
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire79ce"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire79ce"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1P95i", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $154199d8369e1ba7$export$ffb0004e005737fa; }, function (v) { return $154199d8369e1ba7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $154199d8369e1ba7$export$34b9dba7ce09269b; }, function (v) { return $154199d8369e1ba7$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $154199d8369e1ba7$export$25062201e9e25d76; }, function (v) { return $154199d8369e1ba7$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $154199d8369e1ba7$export$ffb0004e005737fa;
var $154199d8369e1ba7$export$34b9dba7ce09269b;
var $154199d8369e1ba7$export$25062201e9e25d76;
'use strict';

var $h4Bez = parcelRequire("h4Bez");
var $154199d8369e1ba7$var$k = Symbol.for("react.element"), $154199d8369e1ba7$var$l = Symbol.for("react.fragment"), $154199d8369e1ba7$var$m = Object.prototype.hasOwnProperty, $154199d8369e1ba7$var$n = $h4Bez.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $154199d8369e1ba7$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $154199d8369e1ba7$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$154199d8369e1ba7$var$m.call(a, b) && !$154199d8369e1ba7$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $154199d8369e1ba7$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $154199d8369e1ba7$var$n.current
    };
}
$154199d8369e1ba7$export$ffb0004e005737fa = $154199d8369e1ba7$var$l;
$154199d8369e1ba7$export$34b9dba7ce09269b = $154199d8369e1ba7$var$q;
$154199d8369e1ba7$export$25062201e9e25d76 = $154199d8369e1ba7$var$q;

});
parcelRegister("h4Bez", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lT02x"));

});
parcelRegister("lT02x", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $feeec3f4f5b2f221$export$dca3b0875bd9a954; }, function (v) { return $feeec3f4f5b2f221$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $feeec3f4f5b2f221$export$16fa2f45be04daa8; }, function (v) { return $feeec3f4f5b2f221$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $feeec3f4f5b2f221$export$ffb0004e005737fa; }, function (v) { return $feeec3f4f5b2f221$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $feeec3f4f5b2f221$export$e2c29f18771995cb; }, function (v) { return $feeec3f4f5b2f221$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $feeec3f4f5b2f221$export$221d75b3f55bb0bd; }, function (v) { return $feeec3f4f5b2f221$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $feeec3f4f5b2f221$export$5f8d39834fd61797; }, function (v) { return $feeec3f4f5b2f221$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $feeec3f4f5b2f221$export$74bf444e3cd11ea5; }, function (v) { return $feeec3f4f5b2f221$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $feeec3f4f5b2f221$export$ae55be85d98224ed; }, function (v) { return $feeec3f4f5b2f221$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $feeec3f4f5b2f221$export$e530037191fcd5d7; }, function (v) { return $feeec3f4f5b2f221$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $feeec3f4f5b2f221$export$fd42f52fd3ae1109; }, function (v) { return $feeec3f4f5b2f221$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $feeec3f4f5b2f221$export$c8a8987d4410bf2d; }, function (v) { return $feeec3f4f5b2f221$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $feeec3f4f5b2f221$export$d38cd72104c1f0e9; }, function (v) { return $feeec3f4f5b2f221$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $feeec3f4f5b2f221$export$7d1e3a5e95ceca43; }, function (v) { return $feeec3f4f5b2f221$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $feeec3f4f5b2f221$export$257a8862b851cb5b; }, function (v) { return $feeec3f4f5b2f221$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $feeec3f4f5b2f221$export$a8257692ac88316c; }, function (v) { return $feeec3f4f5b2f221$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $feeec3f4f5b2f221$export$488013bae63b21da; }, function (v) { return $feeec3f4f5b2f221$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $feeec3f4f5b2f221$export$7c73462e0d25e514; }, function (v) { return $feeec3f4f5b2f221$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $feeec3f4f5b2f221$export$7568632d0d33d16d; }, function (v) { return $feeec3f4f5b2f221$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $feeec3f4f5b2f221$export$88948ce120ea2619; }, function (v) { return $feeec3f4f5b2f221$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $feeec3f4f5b2f221$export$35808ee640e87ca7; }, function (v) { return $feeec3f4f5b2f221$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $feeec3f4f5b2f221$export$fae74005e78b1a27; }, function (v) { return $feeec3f4f5b2f221$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $feeec3f4f5b2f221$export$dc8fbce3eb94dc1e; }, function (v) { return $feeec3f4f5b2f221$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $feeec3f4f5b2f221$export$6a7bc4e911dc01cf; }, function (v) { return $feeec3f4f5b2f221$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $feeec3f4f5b2f221$export$6d9c69b0de29b591; }, function (v) { return $feeec3f4f5b2f221$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $feeec3f4f5b2f221$export$f680877a34711e37; }, function (v) { return $feeec3f4f5b2f221$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $feeec3f4f5b2f221$export$d5a552a76deda3c2; }, function (v) { return $feeec3f4f5b2f221$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $feeec3f4f5b2f221$export$aaabe4eda9ed9969; }, function (v) { return $feeec3f4f5b2f221$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $feeec3f4f5b2f221$export$e5c5a5f917a5871c; }, function (v) { return $feeec3f4f5b2f221$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $feeec3f4f5b2f221$export$1538c33de8887b59; }, function (v) { return $feeec3f4f5b2f221$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $feeec3f4f5b2f221$export$13e3392192263954; }, function (v) { return $feeec3f4f5b2f221$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $feeec3f4f5b2f221$export$b8f5890fc79d6aca; }, function (v) { return $feeec3f4f5b2f221$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $feeec3f4f5b2f221$export$60241385465d0a34; }, function (v) { return $feeec3f4f5b2f221$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $feeec3f4f5b2f221$export$306c0aa65ff9ec16; }, function (v) { return $feeec3f4f5b2f221$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $feeec3f4f5b2f221$export$7b286972b8d8ccbf; }, function (v) { return $feeec3f4f5b2f221$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $feeec3f4f5b2f221$export$83d89fbfd8236492; }, function (v) { return $feeec3f4f5b2f221$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $feeec3f4f5b2f221$export$dca3b0875bd9a954;
var $feeec3f4f5b2f221$export$16fa2f45be04daa8;
var $feeec3f4f5b2f221$export$ffb0004e005737fa;
var $feeec3f4f5b2f221$export$e2c29f18771995cb;
var $feeec3f4f5b2f221$export$221d75b3f55bb0bd;
var $feeec3f4f5b2f221$export$5f8d39834fd61797;
var $feeec3f4f5b2f221$export$74bf444e3cd11ea5;
var $feeec3f4f5b2f221$export$ae55be85d98224ed;
var $feeec3f4f5b2f221$export$e530037191fcd5d7;
var $feeec3f4f5b2f221$export$fd42f52fd3ae1109;
var $feeec3f4f5b2f221$export$c8a8987d4410bf2d;
var $feeec3f4f5b2f221$export$d38cd72104c1f0e9;
var $feeec3f4f5b2f221$export$7d1e3a5e95ceca43;
var $feeec3f4f5b2f221$export$257a8862b851cb5b;
var $feeec3f4f5b2f221$export$a8257692ac88316c;
var $feeec3f4f5b2f221$export$488013bae63b21da;
var $feeec3f4f5b2f221$export$7c73462e0d25e514;
var $feeec3f4f5b2f221$export$7568632d0d33d16d;
var $feeec3f4f5b2f221$export$88948ce120ea2619;
var $feeec3f4f5b2f221$export$35808ee640e87ca7;
var $feeec3f4f5b2f221$export$fae74005e78b1a27;
var $feeec3f4f5b2f221$export$dc8fbce3eb94dc1e;
var $feeec3f4f5b2f221$export$6a7bc4e911dc01cf;
var $feeec3f4f5b2f221$export$6d9c69b0de29b591;
var $feeec3f4f5b2f221$export$f680877a34711e37;
var $feeec3f4f5b2f221$export$d5a552a76deda3c2;
var $feeec3f4f5b2f221$export$aaabe4eda9ed9969;
var $feeec3f4f5b2f221$export$e5c5a5f917a5871c;
var $feeec3f4f5b2f221$export$1538c33de8887b59;
var $feeec3f4f5b2f221$export$13e3392192263954;
var $feeec3f4f5b2f221$export$b8f5890fc79d6aca;
var $feeec3f4f5b2f221$export$60241385465d0a34;
var $feeec3f4f5b2f221$export$306c0aa65ff9ec16;
var $feeec3f4f5b2f221$export$7b286972b8d8ccbf;
var $feeec3f4f5b2f221$export$83d89fbfd8236492;
'use strict';
var $feeec3f4f5b2f221$var$l = Symbol.for("react.element"), $feeec3f4f5b2f221$var$n = Symbol.for("react.portal"), $feeec3f4f5b2f221$var$p = Symbol.for("react.fragment"), $feeec3f4f5b2f221$var$q = Symbol.for("react.strict_mode"), $feeec3f4f5b2f221$var$r = Symbol.for("react.profiler"), $feeec3f4f5b2f221$var$t = Symbol.for("react.provider"), $feeec3f4f5b2f221$var$u = Symbol.for("react.context"), $feeec3f4f5b2f221$var$v = Symbol.for("react.forward_ref"), $feeec3f4f5b2f221$var$w = Symbol.for("react.suspense"), $feeec3f4f5b2f221$var$x = Symbol.for("react.memo"), $feeec3f4f5b2f221$var$y = Symbol.for("react.lazy"), $feeec3f4f5b2f221$var$z = Symbol.iterator;
function $feeec3f4f5b2f221$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $feeec3f4f5b2f221$var$z && a[$feeec3f4f5b2f221$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $feeec3f4f5b2f221$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $feeec3f4f5b2f221$var$C = Object.assign, $feeec3f4f5b2f221$var$D = {};
function $feeec3f4f5b2f221$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $feeec3f4f5b2f221$var$D;
    this.updater = e || $feeec3f4f5b2f221$var$B;
}
$feeec3f4f5b2f221$var$E.prototype.isReactComponent = {};
$feeec3f4f5b2f221$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$feeec3f4f5b2f221$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $feeec3f4f5b2f221$var$F() {}
$feeec3f4f5b2f221$var$F.prototype = $feeec3f4f5b2f221$var$E.prototype;
function $feeec3f4f5b2f221$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $feeec3f4f5b2f221$var$D;
    this.updater = e || $feeec3f4f5b2f221$var$B;
}
var $feeec3f4f5b2f221$var$H = $feeec3f4f5b2f221$var$G.prototype = new $feeec3f4f5b2f221$var$F;
$feeec3f4f5b2f221$var$H.constructor = $feeec3f4f5b2f221$var$G;
$feeec3f4f5b2f221$var$C($feeec3f4f5b2f221$var$H, $feeec3f4f5b2f221$var$E.prototype);
$feeec3f4f5b2f221$var$H.isPureReactComponent = !0;
var $feeec3f4f5b2f221$var$I = Array.isArray, $feeec3f4f5b2f221$var$J = Object.prototype.hasOwnProperty, $feeec3f4f5b2f221$var$K = {
    current: null
}, $feeec3f4f5b2f221$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $feeec3f4f5b2f221$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$feeec3f4f5b2f221$var$J.call(b, d) && !$feeec3f4f5b2f221$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $feeec3f4f5b2f221$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $feeec3f4f5b2f221$var$K.current
    };
}
function $feeec3f4f5b2f221$var$N(a, b) {
    return {
        $$typeof: $feeec3f4f5b2f221$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $feeec3f4f5b2f221$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $feeec3f4f5b2f221$var$l;
}
function $feeec3f4f5b2f221$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $feeec3f4f5b2f221$var$P = /\/+/g;
function $feeec3f4f5b2f221$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $feeec3f4f5b2f221$var$escape("" + a.key) : b.toString(36);
}
function $feeec3f4f5b2f221$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $feeec3f4f5b2f221$var$l:
                case $feeec3f4f5b2f221$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $feeec3f4f5b2f221$var$Q(h, 0) : d, $feeec3f4f5b2f221$var$I(c) ? (e = "", null != a && (e = a.replace($feeec3f4f5b2f221$var$P, "$&/") + "/"), $feeec3f4f5b2f221$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($feeec3f4f5b2f221$var$O(c) && (c = $feeec3f4f5b2f221$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($feeec3f4f5b2f221$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($feeec3f4f5b2f221$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $feeec3f4f5b2f221$var$Q(k, g);
        h += $feeec3f4f5b2f221$var$R(k, b, e, f, c);
    }
    else if (f = $feeec3f4f5b2f221$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $feeec3f4f5b2f221$var$Q(k, g++), h += $feeec3f4f5b2f221$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $feeec3f4f5b2f221$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $feeec3f4f5b2f221$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $feeec3f4f5b2f221$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $feeec3f4f5b2f221$var$U = {
    current: null
}, $feeec3f4f5b2f221$var$V = {
    transition: null
}, $feeec3f4f5b2f221$var$W = {
    ReactCurrentDispatcher: $feeec3f4f5b2f221$var$U,
    ReactCurrentBatchConfig: $feeec3f4f5b2f221$var$V,
    ReactCurrentOwner: $feeec3f4f5b2f221$var$K
};
$feeec3f4f5b2f221$export$dca3b0875bd9a954 = {
    map: $feeec3f4f5b2f221$var$S,
    forEach: function(a, b, e) {
        $feeec3f4f5b2f221$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $feeec3f4f5b2f221$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $feeec3f4f5b2f221$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$feeec3f4f5b2f221$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$feeec3f4f5b2f221$export$16fa2f45be04daa8 = $feeec3f4f5b2f221$var$E;
$feeec3f4f5b2f221$export$ffb0004e005737fa = $feeec3f4f5b2f221$var$p;
$feeec3f4f5b2f221$export$e2c29f18771995cb = $feeec3f4f5b2f221$var$r;
$feeec3f4f5b2f221$export$221d75b3f55bb0bd = $feeec3f4f5b2f221$var$G;
$feeec3f4f5b2f221$export$5f8d39834fd61797 = $feeec3f4f5b2f221$var$q;
$feeec3f4f5b2f221$export$74bf444e3cd11ea5 = $feeec3f4f5b2f221$var$w;
$feeec3f4f5b2f221$export$ae55be85d98224ed = $feeec3f4f5b2f221$var$W;
$feeec3f4f5b2f221$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $feeec3f4f5b2f221$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $feeec3f4f5b2f221$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$feeec3f4f5b2f221$var$J.call(b, f) && !$feeec3f4f5b2f221$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $feeec3f4f5b2f221$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$feeec3f4f5b2f221$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $feeec3f4f5b2f221$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $feeec3f4f5b2f221$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$feeec3f4f5b2f221$export$c8a8987d4410bf2d = $feeec3f4f5b2f221$var$M;
$feeec3f4f5b2f221$export$d38cd72104c1f0e9 = function(a) {
    var b = $feeec3f4f5b2f221$var$M.bind(null, a);
    b.type = a;
    return b;
};
$feeec3f4f5b2f221$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$feeec3f4f5b2f221$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $feeec3f4f5b2f221$var$v,
        render: a
    };
};
$feeec3f4f5b2f221$export$a8257692ac88316c = $feeec3f4f5b2f221$var$O;
$feeec3f4f5b2f221$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $feeec3f4f5b2f221$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $feeec3f4f5b2f221$var$T
    };
};
$feeec3f4f5b2f221$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $feeec3f4f5b2f221$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$feeec3f4f5b2f221$export$7568632d0d33d16d = function(a) {
    var b = $feeec3f4f5b2f221$var$V.transition;
    $feeec3f4f5b2f221$var$V.transition = {};
    try {
        a();
    } finally{
        $feeec3f4f5b2f221$var$V.transition = b;
    }
};
$feeec3f4f5b2f221$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$feeec3f4f5b2f221$export$35808ee640e87ca7 = function(a, b) {
    return $feeec3f4f5b2f221$var$U.current.useCallback(a, b);
};
$feeec3f4f5b2f221$export$fae74005e78b1a27 = function(a) {
    return $feeec3f4f5b2f221$var$U.current.useContext(a);
};
$feeec3f4f5b2f221$export$dc8fbce3eb94dc1e = function() {};
$feeec3f4f5b2f221$export$6a7bc4e911dc01cf = function(a) {
    return $feeec3f4f5b2f221$var$U.current.useDeferredValue(a);
};
$feeec3f4f5b2f221$export$6d9c69b0de29b591 = function(a, b) {
    return $feeec3f4f5b2f221$var$U.current.useEffect(a, b);
};
$feeec3f4f5b2f221$export$f680877a34711e37 = function() {
    return $feeec3f4f5b2f221$var$U.current.useId();
};
$feeec3f4f5b2f221$export$d5a552a76deda3c2 = function(a, b, e) {
    return $feeec3f4f5b2f221$var$U.current.useImperativeHandle(a, b, e);
};
$feeec3f4f5b2f221$export$aaabe4eda9ed9969 = function(a, b) {
    return $feeec3f4f5b2f221$var$U.current.useInsertionEffect(a, b);
};
$feeec3f4f5b2f221$export$e5c5a5f917a5871c = function(a, b) {
    return $feeec3f4f5b2f221$var$U.current.useLayoutEffect(a, b);
};
$feeec3f4f5b2f221$export$1538c33de8887b59 = function(a, b) {
    return $feeec3f4f5b2f221$var$U.current.useMemo(a, b);
};
$feeec3f4f5b2f221$export$13e3392192263954 = function(a, b, e) {
    return $feeec3f4f5b2f221$var$U.current.useReducer(a, b, e);
};
$feeec3f4f5b2f221$export$b8f5890fc79d6aca = function(a) {
    return $feeec3f4f5b2f221$var$U.current.useRef(a);
};
$feeec3f4f5b2f221$export$60241385465d0a34 = function(a) {
    return $feeec3f4f5b2f221$var$U.current.useState(a);
};
$feeec3f4f5b2f221$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $feeec3f4f5b2f221$var$U.current.useSyncExternalStore(a, b, e);
};
$feeec3f4f5b2f221$export$7b286972b8d8ccbf = function() {
    return $feeec3f4f5b2f221$var$U.current.useTransition();
};
$feeec3f4f5b2f221$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("8HUvy", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $656e2c29cdd25871$export$ae55be85d98224ed; }, function (v) { return $656e2c29cdd25871$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $656e2c29cdd25871$export$d39a5bbd09211389; }, function (v) { return $656e2c29cdd25871$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $656e2c29cdd25871$export$882461b6382ed46c; }, function (v) { return $656e2c29cdd25871$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $656e2c29cdd25871$export$466bfc07425424d5; }, function (v) { return $656e2c29cdd25871$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $656e2c29cdd25871$export$cd75ccfd720a3cd4; }, function (v) { return $656e2c29cdd25871$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $656e2c29cdd25871$export$fa8d919ba61d84db; }, function (v) { return $656e2c29cdd25871$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $656e2c29cdd25871$export$757ceba2d55c277e; }, function (v) { return $656e2c29cdd25871$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $656e2c29cdd25871$export$b3890eb0ae9dca99; }, function (v) { return $656e2c29cdd25871$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $656e2c29cdd25871$export$502457920280e6be; }, function (v) { return $656e2c29cdd25871$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $656e2c29cdd25871$export$c78a37762a8d58e1; }, function (v) { return $656e2c29cdd25871$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $656e2c29cdd25871$export$dc54d992c10e8a18; }, function (v) { return $656e2c29cdd25871$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $656e2c29cdd25871$export$83d89fbfd8236492; }, function (v) { return $656e2c29cdd25871$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $656e2c29cdd25871$export$ae55be85d98224ed;
var $656e2c29cdd25871$export$d39a5bbd09211389;
var $656e2c29cdd25871$export$882461b6382ed46c;
var $656e2c29cdd25871$export$466bfc07425424d5;
var $656e2c29cdd25871$export$cd75ccfd720a3cd4;
var $656e2c29cdd25871$export$fa8d919ba61d84db;
var $656e2c29cdd25871$export$757ceba2d55c277e;
var $656e2c29cdd25871$export$b3890eb0ae9dca99;
var $656e2c29cdd25871$export$502457920280e6be;
var $656e2c29cdd25871$export$c78a37762a8d58e1;
var $656e2c29cdd25871$export$dc54d992c10e8a18;
var $656e2c29cdd25871$export$83d89fbfd8236492;
'use strict';

var $h4Bez = parcelRequire("h4Bez");

var $FWXjv = parcelRequire("FWXjv");
function $656e2c29cdd25871$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $656e2c29cdd25871$var$da = new Set, $656e2c29cdd25871$var$ea = {};
function $656e2c29cdd25871$var$fa(a, b) {
    $656e2c29cdd25871$var$ha(a, b);
    $656e2c29cdd25871$var$ha(a + "Capture", b);
}
function $656e2c29cdd25871$var$ha(a, b) {
    $656e2c29cdd25871$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$656e2c29cdd25871$var$da.add(b[a]);
}
var $656e2c29cdd25871$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $656e2c29cdd25871$var$ja = Object.prototype.hasOwnProperty, $656e2c29cdd25871$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $656e2c29cdd25871$var$la = {}, $656e2c29cdd25871$var$ma = {};
function $656e2c29cdd25871$var$oa(a) {
    if ($656e2c29cdd25871$var$ja.call($656e2c29cdd25871$var$ma, a)) return !0;
    if ($656e2c29cdd25871$var$ja.call($656e2c29cdd25871$var$la, a)) return !1;
    if ($656e2c29cdd25871$var$ka.test(a)) return $656e2c29cdd25871$var$ma[a] = !0;
    $656e2c29cdd25871$var$la[a] = !0;
    return !1;
}
function $656e2c29cdd25871$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $656e2c29cdd25871$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $656e2c29cdd25871$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $656e2c29cdd25871$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $656e2c29cdd25871$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $656e2c29cdd25871$var$z[a] = new $656e2c29cdd25871$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $656e2c29cdd25871$var$z[b] = new $656e2c29cdd25871$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $656e2c29cdd25871$var$z[a] = new $656e2c29cdd25871$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $656e2c29cdd25871$var$z[a] = new $656e2c29cdd25871$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $656e2c29cdd25871$var$z[a] = new $656e2c29cdd25871$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $656e2c29cdd25871$var$z[a] = new $656e2c29cdd25871$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $656e2c29cdd25871$var$z[a] = new $656e2c29cdd25871$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $656e2c29cdd25871$var$z[a] = new $656e2c29cdd25871$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $656e2c29cdd25871$var$z[a] = new $656e2c29cdd25871$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $656e2c29cdd25871$var$ra = /[\-:]([a-z])/g;
function $656e2c29cdd25871$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($656e2c29cdd25871$var$ra, $656e2c29cdd25871$var$sa);
    $656e2c29cdd25871$var$z[b] = new $656e2c29cdd25871$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($656e2c29cdd25871$var$ra, $656e2c29cdd25871$var$sa);
    $656e2c29cdd25871$var$z[b] = new $656e2c29cdd25871$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($656e2c29cdd25871$var$ra, $656e2c29cdd25871$var$sa);
    $656e2c29cdd25871$var$z[b] = new $656e2c29cdd25871$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $656e2c29cdd25871$var$z[a] = new $656e2c29cdd25871$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$656e2c29cdd25871$var$z.xlinkHref = new $656e2c29cdd25871$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $656e2c29cdd25871$var$z[a] = new $656e2c29cdd25871$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $656e2c29cdd25871$var$ta(a, b, c, d) {
    var e = $656e2c29cdd25871$var$z.hasOwnProperty(b) ? $656e2c29cdd25871$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $656e2c29cdd25871$var$qa(b, c, e, d) && (c = null), d || null === e ? $656e2c29cdd25871$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $656e2c29cdd25871$var$ua = $h4Bez.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $656e2c29cdd25871$var$va = Symbol.for("react.element"), $656e2c29cdd25871$var$wa = Symbol.for("react.portal"), $656e2c29cdd25871$var$ya = Symbol.for("react.fragment"), $656e2c29cdd25871$var$za = Symbol.for("react.strict_mode"), $656e2c29cdd25871$var$Aa = Symbol.for("react.profiler"), $656e2c29cdd25871$var$Ba = Symbol.for("react.provider"), $656e2c29cdd25871$var$Ca = Symbol.for("react.context"), $656e2c29cdd25871$var$Da = Symbol.for("react.forward_ref"), $656e2c29cdd25871$var$Ea = Symbol.for("react.suspense"), $656e2c29cdd25871$var$Fa = Symbol.for("react.suspense_list"), $656e2c29cdd25871$var$Ga = Symbol.for("react.memo"), $656e2c29cdd25871$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $656e2c29cdd25871$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $656e2c29cdd25871$var$Ja = Symbol.iterator;
function $656e2c29cdd25871$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $656e2c29cdd25871$var$Ja && a[$656e2c29cdd25871$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $656e2c29cdd25871$var$A = Object.assign, $656e2c29cdd25871$var$La;
function $656e2c29cdd25871$var$Ma(a) {
    if (void 0 === $656e2c29cdd25871$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $656e2c29cdd25871$var$La = b && b[1] || "";
    }
    return "\n" + $656e2c29cdd25871$var$La + a;
}
var $656e2c29cdd25871$var$Na = !1;
function $656e2c29cdd25871$var$Oa(a, b) {
    if (!a || $656e2c29cdd25871$var$Na) return "";
    $656e2c29cdd25871$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $656e2c29cdd25871$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $656e2c29cdd25871$var$Ma(a) : "";
}
function $656e2c29cdd25871$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $656e2c29cdd25871$var$Ma(a.type);
        case 16:
            return $656e2c29cdd25871$var$Ma("Lazy");
        case 13:
            return $656e2c29cdd25871$var$Ma("Suspense");
        case 19:
            return $656e2c29cdd25871$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $656e2c29cdd25871$var$Oa(a.type, !1), a;
        case 11:
            return a = $656e2c29cdd25871$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $656e2c29cdd25871$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $656e2c29cdd25871$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $656e2c29cdd25871$var$ya:
            return "Fragment";
        case $656e2c29cdd25871$var$wa:
            return "Portal";
        case $656e2c29cdd25871$var$Aa:
            return "Profiler";
        case $656e2c29cdd25871$var$za:
            return "StrictMode";
        case $656e2c29cdd25871$var$Ea:
            return "Suspense";
        case $656e2c29cdd25871$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $656e2c29cdd25871$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $656e2c29cdd25871$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $656e2c29cdd25871$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $656e2c29cdd25871$var$Ga:
            return b = a.displayName || null, null !== b ? b : $656e2c29cdd25871$var$Qa(a.type) || "Memo";
        case $656e2c29cdd25871$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $656e2c29cdd25871$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $656e2c29cdd25871$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $656e2c29cdd25871$var$Qa(b);
        case 8:
            return b === $656e2c29cdd25871$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $656e2c29cdd25871$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $656e2c29cdd25871$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $656e2c29cdd25871$var$Ua(a) {
    var b = $656e2c29cdd25871$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $656e2c29cdd25871$var$Va(a) {
    a._valueTracker || (a._valueTracker = $656e2c29cdd25871$var$Ua(a));
}
function $656e2c29cdd25871$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $656e2c29cdd25871$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $656e2c29cdd25871$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $656e2c29cdd25871$var$Ya(a, b) {
    var c = b.checked;
    return $656e2c29cdd25871$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $656e2c29cdd25871$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $656e2c29cdd25871$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $656e2c29cdd25871$var$ab(a, b) {
    b = b.checked;
    null != b && $656e2c29cdd25871$var$ta(a, "checked", b, !1);
}
function $656e2c29cdd25871$var$bb(a, b) {
    $656e2c29cdd25871$var$ab(a, b);
    var c = $656e2c29cdd25871$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $656e2c29cdd25871$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $656e2c29cdd25871$var$cb(a, b.type, $656e2c29cdd25871$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $656e2c29cdd25871$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $656e2c29cdd25871$var$cb(a, b, c) {
    if ("number" !== b || $656e2c29cdd25871$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $656e2c29cdd25871$var$eb = Array.isArray;
function $656e2c29cdd25871$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $656e2c29cdd25871$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $656e2c29cdd25871$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($656e2c29cdd25871$var$p(91));
    return $656e2c29cdd25871$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $656e2c29cdd25871$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($656e2c29cdd25871$var$p(92));
            if ($656e2c29cdd25871$var$eb(c)) {
                if (1 < c.length) throw Error($656e2c29cdd25871$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $656e2c29cdd25871$var$Sa(c)
    };
}
function $656e2c29cdd25871$var$ib(a, b) {
    var c = $656e2c29cdd25871$var$Sa(b.value), d = $656e2c29cdd25871$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $656e2c29cdd25871$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $656e2c29cdd25871$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $656e2c29cdd25871$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $656e2c29cdd25871$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $656e2c29cdd25871$var$mb, $656e2c29cdd25871$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $656e2c29cdd25871$var$mb = $656e2c29cdd25871$var$mb || document.createElement("div");
        $656e2c29cdd25871$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $656e2c29cdd25871$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $656e2c29cdd25871$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $656e2c29cdd25871$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $656e2c29cdd25871$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($656e2c29cdd25871$var$pb).forEach(function(a) {
    $656e2c29cdd25871$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $656e2c29cdd25871$var$pb[b] = $656e2c29cdd25871$var$pb[a];
    });
});
function $656e2c29cdd25871$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $656e2c29cdd25871$var$pb.hasOwnProperty(a) && $656e2c29cdd25871$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $656e2c29cdd25871$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $656e2c29cdd25871$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $656e2c29cdd25871$var$tb = $656e2c29cdd25871$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $656e2c29cdd25871$var$ub(a, b) {
    if (b) {
        if ($656e2c29cdd25871$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($656e2c29cdd25871$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($656e2c29cdd25871$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($656e2c29cdd25871$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($656e2c29cdd25871$var$p(62));
    }
}
function $656e2c29cdd25871$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $656e2c29cdd25871$var$wb = null;
function $656e2c29cdd25871$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $656e2c29cdd25871$var$yb = null, $656e2c29cdd25871$var$zb = null, $656e2c29cdd25871$var$Ab = null;
function $656e2c29cdd25871$var$Bb(a) {
    if (a = $656e2c29cdd25871$var$Cb(a)) {
        if ("function" !== typeof $656e2c29cdd25871$var$yb) throw Error($656e2c29cdd25871$var$p(280));
        var b = a.stateNode;
        b && (b = $656e2c29cdd25871$var$Db(b), $656e2c29cdd25871$var$yb(a.stateNode, a.type, b));
    }
}
function $656e2c29cdd25871$var$Eb(a) {
    $656e2c29cdd25871$var$zb ? $656e2c29cdd25871$var$Ab ? $656e2c29cdd25871$var$Ab.push(a) : $656e2c29cdd25871$var$Ab = [
        a
    ] : $656e2c29cdd25871$var$zb = a;
}
function $656e2c29cdd25871$var$Fb() {
    if ($656e2c29cdd25871$var$zb) {
        var a = $656e2c29cdd25871$var$zb, b = $656e2c29cdd25871$var$Ab;
        $656e2c29cdd25871$var$Ab = $656e2c29cdd25871$var$zb = null;
        $656e2c29cdd25871$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$656e2c29cdd25871$var$Bb(b[a]);
    }
}
function $656e2c29cdd25871$var$Gb(a, b) {
    return a(b);
}
function $656e2c29cdd25871$var$Hb() {}
var $656e2c29cdd25871$var$Ib = !1;
function $656e2c29cdd25871$var$Jb(a, b, c) {
    if ($656e2c29cdd25871$var$Ib) return a(b, c);
    $656e2c29cdd25871$var$Ib = !0;
    try {
        return $656e2c29cdd25871$var$Gb(a, b, c);
    } finally{
        if ($656e2c29cdd25871$var$Ib = !1, null !== $656e2c29cdd25871$var$zb || null !== $656e2c29cdd25871$var$Ab) $656e2c29cdd25871$var$Hb(), $656e2c29cdd25871$var$Fb();
    }
}
function $656e2c29cdd25871$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $656e2c29cdd25871$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($656e2c29cdd25871$var$p(231, b, typeof c));
    return c;
}
var $656e2c29cdd25871$var$Lb = !1;
if ($656e2c29cdd25871$var$ia) try {
    var $656e2c29cdd25871$var$Mb = {};
    Object.defineProperty($656e2c29cdd25871$var$Mb, "passive", {
        get: function() {
            $656e2c29cdd25871$var$Lb = !0;
        }
    });
    window.addEventListener("test", $656e2c29cdd25871$var$Mb, $656e2c29cdd25871$var$Mb);
    window.removeEventListener("test", $656e2c29cdd25871$var$Mb, $656e2c29cdd25871$var$Mb);
} catch (a) {
    $656e2c29cdd25871$var$Lb = !1;
}
function $656e2c29cdd25871$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $656e2c29cdd25871$var$Ob = !1, $656e2c29cdd25871$var$Pb = null, $656e2c29cdd25871$var$Qb = !1, $656e2c29cdd25871$var$Rb = null, $656e2c29cdd25871$var$Sb = {
    onError: function(a) {
        $656e2c29cdd25871$var$Ob = !0;
        $656e2c29cdd25871$var$Pb = a;
    }
};
function $656e2c29cdd25871$var$Tb(a, b, c, d, e, f, g, h, k) {
    $656e2c29cdd25871$var$Ob = !1;
    $656e2c29cdd25871$var$Pb = null;
    $656e2c29cdd25871$var$Nb.apply($656e2c29cdd25871$var$Sb, arguments);
}
function $656e2c29cdd25871$var$Ub(a, b, c, d, e, f, g, h, k) {
    $656e2c29cdd25871$var$Tb.apply(this, arguments);
    if ($656e2c29cdd25871$var$Ob) {
        if ($656e2c29cdd25871$var$Ob) {
            var l = $656e2c29cdd25871$var$Pb;
            $656e2c29cdd25871$var$Ob = !1;
            $656e2c29cdd25871$var$Pb = null;
        } else throw Error($656e2c29cdd25871$var$p(198));
        $656e2c29cdd25871$var$Qb || ($656e2c29cdd25871$var$Qb = !0, $656e2c29cdd25871$var$Rb = l);
    }
}
function $656e2c29cdd25871$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $656e2c29cdd25871$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $656e2c29cdd25871$var$Xb(a) {
    if ($656e2c29cdd25871$var$Vb(a) !== a) throw Error($656e2c29cdd25871$var$p(188));
}
function $656e2c29cdd25871$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $656e2c29cdd25871$var$Vb(a);
        if (null === b) throw Error($656e2c29cdd25871$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $656e2c29cdd25871$var$Xb(e), a;
                if (f === d) return $656e2c29cdd25871$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($656e2c29cdd25871$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($656e2c29cdd25871$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($656e2c29cdd25871$var$p(190));
    }
    if (3 !== c.tag) throw Error($656e2c29cdd25871$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $656e2c29cdd25871$var$Zb(a) {
    a = $656e2c29cdd25871$var$Yb(a);
    return null !== a ? $656e2c29cdd25871$var$$b(a) : null;
}
function $656e2c29cdd25871$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $656e2c29cdd25871$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $656e2c29cdd25871$var$ac = $FWXjv.unstable_scheduleCallback, $656e2c29cdd25871$var$bc = $FWXjv.unstable_cancelCallback, $656e2c29cdd25871$var$cc = $FWXjv.unstable_shouldYield, $656e2c29cdd25871$var$dc = $FWXjv.unstable_requestPaint, $656e2c29cdd25871$var$B = $FWXjv.unstable_now, $656e2c29cdd25871$var$ec = $FWXjv.unstable_getCurrentPriorityLevel, $656e2c29cdd25871$var$fc = $FWXjv.unstable_ImmediatePriority, $656e2c29cdd25871$var$gc = $FWXjv.unstable_UserBlockingPriority, $656e2c29cdd25871$var$hc = $FWXjv.unstable_NormalPriority, $656e2c29cdd25871$var$ic = $FWXjv.unstable_LowPriority, $656e2c29cdd25871$var$jc = $FWXjv.unstable_IdlePriority, $656e2c29cdd25871$var$kc = null, $656e2c29cdd25871$var$lc = null;
function $656e2c29cdd25871$var$mc(a) {
    if ($656e2c29cdd25871$var$lc && "function" === typeof $656e2c29cdd25871$var$lc.onCommitFiberRoot) try {
        $656e2c29cdd25871$var$lc.onCommitFiberRoot($656e2c29cdd25871$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $656e2c29cdd25871$var$oc = Math.clz32 ? Math.clz32 : $656e2c29cdd25871$var$nc, $656e2c29cdd25871$var$pc = Math.log, $656e2c29cdd25871$var$qc = Math.LN2;
function $656e2c29cdd25871$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($656e2c29cdd25871$var$pc(a) / $656e2c29cdd25871$var$qc | 0) | 0;
}
var $656e2c29cdd25871$var$rc = 64, $656e2c29cdd25871$var$sc = 4194304;
function $656e2c29cdd25871$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $656e2c29cdd25871$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $656e2c29cdd25871$var$tc(h) : (f &= g, 0 !== f && (d = $656e2c29cdd25871$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $656e2c29cdd25871$var$tc(g) : 0 !== f && (d = $656e2c29cdd25871$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $656e2c29cdd25871$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $656e2c29cdd25871$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $656e2c29cdd25871$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $656e2c29cdd25871$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $656e2c29cdd25871$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $656e2c29cdd25871$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $656e2c29cdd25871$var$yc() {
    var a = $656e2c29cdd25871$var$rc;
    $656e2c29cdd25871$var$rc <<= 1;
    0 === ($656e2c29cdd25871$var$rc & 4194240) && ($656e2c29cdd25871$var$rc = 64);
    return a;
}
function $656e2c29cdd25871$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $656e2c29cdd25871$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $656e2c29cdd25871$var$oc(b);
    a[b] = c;
}
function $656e2c29cdd25871$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $656e2c29cdd25871$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $656e2c29cdd25871$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $656e2c29cdd25871$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $656e2c29cdd25871$var$C = 0;
function $656e2c29cdd25871$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $656e2c29cdd25871$var$Ec, $656e2c29cdd25871$var$Fc, $656e2c29cdd25871$var$Gc, $656e2c29cdd25871$var$Hc, $656e2c29cdd25871$var$Ic, $656e2c29cdd25871$var$Jc = !1, $656e2c29cdd25871$var$Kc = [], $656e2c29cdd25871$var$Lc = null, $656e2c29cdd25871$var$Mc = null, $656e2c29cdd25871$var$Nc = null, $656e2c29cdd25871$var$Oc = new Map, $656e2c29cdd25871$var$Pc = new Map, $656e2c29cdd25871$var$Qc = [], $656e2c29cdd25871$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $656e2c29cdd25871$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $656e2c29cdd25871$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $656e2c29cdd25871$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $656e2c29cdd25871$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $656e2c29cdd25871$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $656e2c29cdd25871$var$Pc.delete(b.pointerId);
    }
}
function $656e2c29cdd25871$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $656e2c29cdd25871$var$Cb(b), null !== b && $656e2c29cdd25871$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $656e2c29cdd25871$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $656e2c29cdd25871$var$Lc = $656e2c29cdd25871$var$Tc($656e2c29cdd25871$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $656e2c29cdd25871$var$Mc = $656e2c29cdd25871$var$Tc($656e2c29cdd25871$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $656e2c29cdd25871$var$Nc = $656e2c29cdd25871$var$Tc($656e2c29cdd25871$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $656e2c29cdd25871$var$Oc.set(f, $656e2c29cdd25871$var$Tc($656e2c29cdd25871$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $656e2c29cdd25871$var$Pc.set(f, $656e2c29cdd25871$var$Tc($656e2c29cdd25871$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $656e2c29cdd25871$var$Vc(a) {
    var b = $656e2c29cdd25871$var$Wc(a.target);
    if (null !== b) {
        var c = $656e2c29cdd25871$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $656e2c29cdd25871$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $656e2c29cdd25871$var$Ic(a.priority, function() {
                        $656e2c29cdd25871$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $656e2c29cdd25871$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $656e2c29cdd25871$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $656e2c29cdd25871$var$wb = d;
            c.target.dispatchEvent(d);
            $656e2c29cdd25871$var$wb = null;
        } else return b = $656e2c29cdd25871$var$Cb(c), null !== b && $656e2c29cdd25871$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $656e2c29cdd25871$var$Zc(a, b, c) {
    $656e2c29cdd25871$var$Xc(a) && c.delete(b);
}
function $656e2c29cdd25871$var$$c() {
    $656e2c29cdd25871$var$Jc = !1;
    null !== $656e2c29cdd25871$var$Lc && $656e2c29cdd25871$var$Xc($656e2c29cdd25871$var$Lc) && ($656e2c29cdd25871$var$Lc = null);
    null !== $656e2c29cdd25871$var$Mc && $656e2c29cdd25871$var$Xc($656e2c29cdd25871$var$Mc) && ($656e2c29cdd25871$var$Mc = null);
    null !== $656e2c29cdd25871$var$Nc && $656e2c29cdd25871$var$Xc($656e2c29cdd25871$var$Nc) && ($656e2c29cdd25871$var$Nc = null);
    $656e2c29cdd25871$var$Oc.forEach($656e2c29cdd25871$var$Zc);
    $656e2c29cdd25871$var$Pc.forEach($656e2c29cdd25871$var$Zc);
}
function $656e2c29cdd25871$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $656e2c29cdd25871$var$Jc || ($656e2c29cdd25871$var$Jc = !0, $FWXjv.unstable_scheduleCallback($FWXjv.unstable_NormalPriority, $656e2c29cdd25871$var$$c)));
}
function $656e2c29cdd25871$var$bd(a) {
    function b(b) {
        return $656e2c29cdd25871$var$ad(b, a);
    }
    if (0 < $656e2c29cdd25871$var$Kc.length) {
        $656e2c29cdd25871$var$ad($656e2c29cdd25871$var$Kc[0], a);
        for(var c = 1; c < $656e2c29cdd25871$var$Kc.length; c++){
            var d = $656e2c29cdd25871$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $656e2c29cdd25871$var$Lc && $656e2c29cdd25871$var$ad($656e2c29cdd25871$var$Lc, a);
    null !== $656e2c29cdd25871$var$Mc && $656e2c29cdd25871$var$ad($656e2c29cdd25871$var$Mc, a);
    null !== $656e2c29cdd25871$var$Nc && $656e2c29cdd25871$var$ad($656e2c29cdd25871$var$Nc, a);
    $656e2c29cdd25871$var$Oc.forEach(b);
    $656e2c29cdd25871$var$Pc.forEach(b);
    for(c = 0; c < $656e2c29cdd25871$var$Qc.length; c++)d = $656e2c29cdd25871$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $656e2c29cdd25871$var$Qc.length && (c = $656e2c29cdd25871$var$Qc[0], null === c.blockedOn);)$656e2c29cdd25871$var$Vc(c), null === c.blockedOn && $656e2c29cdd25871$var$Qc.shift();
}
var $656e2c29cdd25871$var$cd = $656e2c29cdd25871$var$ua.ReactCurrentBatchConfig, $656e2c29cdd25871$var$dd = !0;
function $656e2c29cdd25871$var$ed(a, b, c, d) {
    var e = $656e2c29cdd25871$var$C, f = $656e2c29cdd25871$var$cd.transition;
    $656e2c29cdd25871$var$cd.transition = null;
    try {
        $656e2c29cdd25871$var$C = 1, $656e2c29cdd25871$var$fd(a, b, c, d);
    } finally{
        $656e2c29cdd25871$var$C = e, $656e2c29cdd25871$var$cd.transition = f;
    }
}
function $656e2c29cdd25871$var$gd(a, b, c, d) {
    var e = $656e2c29cdd25871$var$C, f = $656e2c29cdd25871$var$cd.transition;
    $656e2c29cdd25871$var$cd.transition = null;
    try {
        $656e2c29cdd25871$var$C = 4, $656e2c29cdd25871$var$fd(a, b, c, d);
    } finally{
        $656e2c29cdd25871$var$C = e, $656e2c29cdd25871$var$cd.transition = f;
    }
}
function $656e2c29cdd25871$var$fd(a, b, c, d) {
    if ($656e2c29cdd25871$var$dd) {
        var e = $656e2c29cdd25871$var$Yc(a, b, c, d);
        if (null === e) $656e2c29cdd25871$var$hd(a, b, d, $656e2c29cdd25871$var$id, c), $656e2c29cdd25871$var$Sc(a, d);
        else if ($656e2c29cdd25871$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($656e2c29cdd25871$var$Sc(a, d), b & 4 && -1 < $656e2c29cdd25871$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $656e2c29cdd25871$var$Cb(e);
                null !== f && $656e2c29cdd25871$var$Ec(f);
                f = $656e2c29cdd25871$var$Yc(a, b, c, d);
                null === f && $656e2c29cdd25871$var$hd(a, b, d, $656e2c29cdd25871$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $656e2c29cdd25871$var$hd(a, b, d, null, c);
    }
}
var $656e2c29cdd25871$var$id = null;
function $656e2c29cdd25871$var$Yc(a, b, c, d) {
    $656e2c29cdd25871$var$id = null;
    a = $656e2c29cdd25871$var$xb(d);
    a = $656e2c29cdd25871$var$Wc(a);
    if (null !== a) {
        if (b = $656e2c29cdd25871$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $656e2c29cdd25871$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $656e2c29cdd25871$var$id = a;
    return null;
}
function $656e2c29cdd25871$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($656e2c29cdd25871$var$ec()){
                case $656e2c29cdd25871$var$fc:
                    return 1;
                case $656e2c29cdd25871$var$gc:
                    return 4;
                case $656e2c29cdd25871$var$hc:
                case $656e2c29cdd25871$var$ic:
                    return 16;
                case $656e2c29cdd25871$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $656e2c29cdd25871$var$kd = null, $656e2c29cdd25871$var$ld = null, $656e2c29cdd25871$var$md = null;
function $656e2c29cdd25871$var$nd() {
    if ($656e2c29cdd25871$var$md) return $656e2c29cdd25871$var$md;
    var a, b = $656e2c29cdd25871$var$ld, c = b.length, d, e = "value" in $656e2c29cdd25871$var$kd ? $656e2c29cdd25871$var$kd.value : $656e2c29cdd25871$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $656e2c29cdd25871$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $656e2c29cdd25871$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $656e2c29cdd25871$var$pd() {
    return !0;
}
function $656e2c29cdd25871$var$qd() {
    return !1;
}
function $656e2c29cdd25871$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $656e2c29cdd25871$var$pd : $656e2c29cdd25871$var$qd;
        this.isPropagationStopped = $656e2c29cdd25871$var$qd;
        return this;
    }
    $656e2c29cdd25871$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $656e2c29cdd25871$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $656e2c29cdd25871$var$pd);
        },
        persist: function() {},
        isPersistent: $656e2c29cdd25871$var$pd
    });
    return b;
}
var $656e2c29cdd25871$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $656e2c29cdd25871$var$td = $656e2c29cdd25871$var$rd($656e2c29cdd25871$var$sd), $656e2c29cdd25871$var$ud = $656e2c29cdd25871$var$A({}, $656e2c29cdd25871$var$sd, {
    view: 0,
    detail: 0
}), $656e2c29cdd25871$var$vd = $656e2c29cdd25871$var$rd($656e2c29cdd25871$var$ud), $656e2c29cdd25871$var$wd, $656e2c29cdd25871$var$xd, $656e2c29cdd25871$var$yd, $656e2c29cdd25871$var$Ad = $656e2c29cdd25871$var$A({}, $656e2c29cdd25871$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $656e2c29cdd25871$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $656e2c29cdd25871$var$yd && ($656e2c29cdd25871$var$yd && "mousemove" === a.type ? ($656e2c29cdd25871$var$wd = a.screenX - $656e2c29cdd25871$var$yd.screenX, $656e2c29cdd25871$var$xd = a.screenY - $656e2c29cdd25871$var$yd.screenY) : $656e2c29cdd25871$var$xd = $656e2c29cdd25871$var$wd = 0, $656e2c29cdd25871$var$yd = a);
        return $656e2c29cdd25871$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $656e2c29cdd25871$var$xd;
    }
}), $656e2c29cdd25871$var$Bd = $656e2c29cdd25871$var$rd($656e2c29cdd25871$var$Ad), $656e2c29cdd25871$var$Cd = $656e2c29cdd25871$var$A({}, $656e2c29cdd25871$var$Ad, {
    dataTransfer: 0
}), $656e2c29cdd25871$var$Dd = $656e2c29cdd25871$var$rd($656e2c29cdd25871$var$Cd), $656e2c29cdd25871$var$Ed = $656e2c29cdd25871$var$A({}, $656e2c29cdd25871$var$ud, {
    relatedTarget: 0
}), $656e2c29cdd25871$var$Fd = $656e2c29cdd25871$var$rd($656e2c29cdd25871$var$Ed), $656e2c29cdd25871$var$Gd = $656e2c29cdd25871$var$A({}, $656e2c29cdd25871$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $656e2c29cdd25871$var$Hd = $656e2c29cdd25871$var$rd($656e2c29cdd25871$var$Gd), $656e2c29cdd25871$var$Id = $656e2c29cdd25871$var$A({}, $656e2c29cdd25871$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $656e2c29cdd25871$var$Jd = $656e2c29cdd25871$var$rd($656e2c29cdd25871$var$Id), $656e2c29cdd25871$var$Kd = $656e2c29cdd25871$var$A({}, $656e2c29cdd25871$var$sd, {
    data: 0
}), $656e2c29cdd25871$var$Ld = $656e2c29cdd25871$var$rd($656e2c29cdd25871$var$Kd), $656e2c29cdd25871$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $656e2c29cdd25871$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $656e2c29cdd25871$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $656e2c29cdd25871$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $656e2c29cdd25871$var$Od[a]) ? !!b[a] : !1;
}
function $656e2c29cdd25871$var$zd() {
    return $656e2c29cdd25871$var$Pd;
}
var $656e2c29cdd25871$var$Qd = $656e2c29cdd25871$var$A({}, $656e2c29cdd25871$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $656e2c29cdd25871$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $656e2c29cdd25871$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $656e2c29cdd25871$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $656e2c29cdd25871$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $656e2c29cdd25871$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $656e2c29cdd25871$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $656e2c29cdd25871$var$Rd = $656e2c29cdd25871$var$rd($656e2c29cdd25871$var$Qd), $656e2c29cdd25871$var$Sd = $656e2c29cdd25871$var$A({}, $656e2c29cdd25871$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $656e2c29cdd25871$var$Td = $656e2c29cdd25871$var$rd($656e2c29cdd25871$var$Sd), $656e2c29cdd25871$var$Ud = $656e2c29cdd25871$var$A({}, $656e2c29cdd25871$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $656e2c29cdd25871$var$zd
}), $656e2c29cdd25871$var$Vd = $656e2c29cdd25871$var$rd($656e2c29cdd25871$var$Ud), $656e2c29cdd25871$var$Wd = $656e2c29cdd25871$var$A({}, $656e2c29cdd25871$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $656e2c29cdd25871$var$Xd = $656e2c29cdd25871$var$rd($656e2c29cdd25871$var$Wd), $656e2c29cdd25871$var$Yd = $656e2c29cdd25871$var$A({}, $656e2c29cdd25871$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $656e2c29cdd25871$var$Zd = $656e2c29cdd25871$var$rd($656e2c29cdd25871$var$Yd), $656e2c29cdd25871$var$$d = [
    9,
    13,
    27,
    32
], $656e2c29cdd25871$var$ae = $656e2c29cdd25871$var$ia && "CompositionEvent" in window, $656e2c29cdd25871$var$be = null;
$656e2c29cdd25871$var$ia && "documentMode" in document && ($656e2c29cdd25871$var$be = document.documentMode);
var $656e2c29cdd25871$var$ce = $656e2c29cdd25871$var$ia && "TextEvent" in window && !$656e2c29cdd25871$var$be, $656e2c29cdd25871$var$de = $656e2c29cdd25871$var$ia && (!$656e2c29cdd25871$var$ae || $656e2c29cdd25871$var$be && 8 < $656e2c29cdd25871$var$be && 11 >= $656e2c29cdd25871$var$be), $656e2c29cdd25871$var$ee = String.fromCharCode(32), $656e2c29cdd25871$var$fe = !1;
function $656e2c29cdd25871$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $656e2c29cdd25871$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $656e2c29cdd25871$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $656e2c29cdd25871$var$ie = !1;
function $656e2c29cdd25871$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $656e2c29cdd25871$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $656e2c29cdd25871$var$fe = !0;
            return $656e2c29cdd25871$var$ee;
        case "textInput":
            return a = b.data, a === $656e2c29cdd25871$var$ee && $656e2c29cdd25871$var$fe ? null : a;
        default:
            return null;
    }
}
function $656e2c29cdd25871$var$ke(a, b) {
    if ($656e2c29cdd25871$var$ie) return "compositionend" === a || !$656e2c29cdd25871$var$ae && $656e2c29cdd25871$var$ge(a, b) ? (a = $656e2c29cdd25871$var$nd(), $656e2c29cdd25871$var$md = $656e2c29cdd25871$var$ld = $656e2c29cdd25871$var$kd = null, $656e2c29cdd25871$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $656e2c29cdd25871$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $656e2c29cdd25871$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $656e2c29cdd25871$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$656e2c29cdd25871$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $656e2c29cdd25871$var$ne(a, b, c, d) {
    $656e2c29cdd25871$var$Eb(d);
    b = $656e2c29cdd25871$var$oe(b, "onChange");
    0 < b.length && (c = new $656e2c29cdd25871$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $656e2c29cdd25871$var$pe = null, $656e2c29cdd25871$var$qe = null;
function $656e2c29cdd25871$var$re(a) {
    $656e2c29cdd25871$var$se(a, 0);
}
function $656e2c29cdd25871$var$te(a) {
    var b = $656e2c29cdd25871$var$ue(a);
    if ($656e2c29cdd25871$var$Wa(b)) return a;
}
function $656e2c29cdd25871$var$ve(a, b) {
    if ("change" === a) return b;
}
var $656e2c29cdd25871$var$we = !1;
if ($656e2c29cdd25871$var$ia) {
    var $656e2c29cdd25871$var$xe;
    if ($656e2c29cdd25871$var$ia) {
        var $656e2c29cdd25871$var$ye = "oninput" in document;
        if (!$656e2c29cdd25871$var$ye) {
            var $656e2c29cdd25871$var$ze = document.createElement("div");
            $656e2c29cdd25871$var$ze.setAttribute("oninput", "return;");
            $656e2c29cdd25871$var$ye = "function" === typeof $656e2c29cdd25871$var$ze.oninput;
        }
        $656e2c29cdd25871$var$xe = $656e2c29cdd25871$var$ye;
    } else $656e2c29cdd25871$var$xe = !1;
    $656e2c29cdd25871$var$we = $656e2c29cdd25871$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $656e2c29cdd25871$var$Ae() {
    $656e2c29cdd25871$var$pe && ($656e2c29cdd25871$var$pe.detachEvent("onpropertychange", $656e2c29cdd25871$var$Be), $656e2c29cdd25871$var$qe = $656e2c29cdd25871$var$pe = null);
}
function $656e2c29cdd25871$var$Be(a) {
    if ("value" === a.propertyName && $656e2c29cdd25871$var$te($656e2c29cdd25871$var$qe)) {
        var b = [];
        $656e2c29cdd25871$var$ne(b, $656e2c29cdd25871$var$qe, a, $656e2c29cdd25871$var$xb(a));
        $656e2c29cdd25871$var$Jb($656e2c29cdd25871$var$re, b);
    }
}
function $656e2c29cdd25871$var$Ce(a, b, c) {
    "focusin" === a ? ($656e2c29cdd25871$var$Ae(), $656e2c29cdd25871$var$pe = b, $656e2c29cdd25871$var$qe = c, $656e2c29cdd25871$var$pe.attachEvent("onpropertychange", $656e2c29cdd25871$var$Be)) : "focusout" === a && $656e2c29cdd25871$var$Ae();
}
function $656e2c29cdd25871$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $656e2c29cdd25871$var$te($656e2c29cdd25871$var$qe);
}
function $656e2c29cdd25871$var$Ee(a, b) {
    if ("click" === a) return $656e2c29cdd25871$var$te(b);
}
function $656e2c29cdd25871$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $656e2c29cdd25871$var$te(b);
}
function $656e2c29cdd25871$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $656e2c29cdd25871$var$He = "function" === typeof Object.is ? Object.is : $656e2c29cdd25871$var$Ge;
function $656e2c29cdd25871$var$Ie(a, b) {
    if ($656e2c29cdd25871$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$656e2c29cdd25871$var$ja.call(b, e) || !$656e2c29cdd25871$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $656e2c29cdd25871$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $656e2c29cdd25871$var$Ke(a, b) {
    var c = $656e2c29cdd25871$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $656e2c29cdd25871$var$Je(c);
    }
}
function $656e2c29cdd25871$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $656e2c29cdd25871$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $656e2c29cdd25871$var$Me() {
    for(var a = window, b = $656e2c29cdd25871$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $656e2c29cdd25871$var$Xa(a.document);
    }
    return b;
}
function $656e2c29cdd25871$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $656e2c29cdd25871$var$Oe(a) {
    var b = $656e2c29cdd25871$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $656e2c29cdd25871$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $656e2c29cdd25871$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $656e2c29cdd25871$var$Ke(c, f);
                var g = $656e2c29cdd25871$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $656e2c29cdd25871$var$Pe = $656e2c29cdd25871$var$ia && "documentMode" in document && 11 >= document.documentMode, $656e2c29cdd25871$var$Qe = null, $656e2c29cdd25871$var$Re = null, $656e2c29cdd25871$var$Se = null, $656e2c29cdd25871$var$Te = !1;
function $656e2c29cdd25871$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $656e2c29cdd25871$var$Te || null == $656e2c29cdd25871$var$Qe || $656e2c29cdd25871$var$Qe !== $656e2c29cdd25871$var$Xa(d) || (d = $656e2c29cdd25871$var$Qe, "selectionStart" in d && $656e2c29cdd25871$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $656e2c29cdd25871$var$Se && $656e2c29cdd25871$var$Ie($656e2c29cdd25871$var$Se, d) || ($656e2c29cdd25871$var$Se = d, d = $656e2c29cdd25871$var$oe($656e2c29cdd25871$var$Re, "onSelect"), 0 < d.length && (b = new $656e2c29cdd25871$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $656e2c29cdd25871$var$Qe)));
}
function $656e2c29cdd25871$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $656e2c29cdd25871$var$We = {
    animationend: $656e2c29cdd25871$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $656e2c29cdd25871$var$Ve("Animation", "AnimationIteration"),
    animationstart: $656e2c29cdd25871$var$Ve("Animation", "AnimationStart"),
    transitionend: $656e2c29cdd25871$var$Ve("Transition", "TransitionEnd")
}, $656e2c29cdd25871$var$Xe = {}, $656e2c29cdd25871$var$Ye = {};
$656e2c29cdd25871$var$ia && ($656e2c29cdd25871$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $656e2c29cdd25871$var$We.animationend.animation, delete $656e2c29cdd25871$var$We.animationiteration.animation, delete $656e2c29cdd25871$var$We.animationstart.animation), "TransitionEvent" in window || delete $656e2c29cdd25871$var$We.transitionend.transition);
function $656e2c29cdd25871$var$Ze(a) {
    if ($656e2c29cdd25871$var$Xe[a]) return $656e2c29cdd25871$var$Xe[a];
    if (!$656e2c29cdd25871$var$We[a]) return a;
    var b = $656e2c29cdd25871$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $656e2c29cdd25871$var$Ye) return $656e2c29cdd25871$var$Xe[a] = b[c];
    return a;
}
var $656e2c29cdd25871$var$$e = $656e2c29cdd25871$var$Ze("animationend"), $656e2c29cdd25871$var$af = $656e2c29cdd25871$var$Ze("animationiteration"), $656e2c29cdd25871$var$bf = $656e2c29cdd25871$var$Ze("animationstart"), $656e2c29cdd25871$var$cf = $656e2c29cdd25871$var$Ze("transitionend"), $656e2c29cdd25871$var$df = new Map, $656e2c29cdd25871$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $656e2c29cdd25871$var$ff(a, b) {
    $656e2c29cdd25871$var$df.set(a, b);
    $656e2c29cdd25871$var$fa(b, [
        a
    ]);
}
for(var $656e2c29cdd25871$var$gf = 0; $656e2c29cdd25871$var$gf < $656e2c29cdd25871$var$ef.length; $656e2c29cdd25871$var$gf++){
    var $656e2c29cdd25871$var$hf = $656e2c29cdd25871$var$ef[$656e2c29cdd25871$var$gf], $656e2c29cdd25871$var$jf = $656e2c29cdd25871$var$hf.toLowerCase(), $656e2c29cdd25871$var$kf = $656e2c29cdd25871$var$hf[0].toUpperCase() + $656e2c29cdd25871$var$hf.slice(1);
    $656e2c29cdd25871$var$ff($656e2c29cdd25871$var$jf, "on" + $656e2c29cdd25871$var$kf);
}
$656e2c29cdd25871$var$ff($656e2c29cdd25871$var$$e, "onAnimationEnd");
$656e2c29cdd25871$var$ff($656e2c29cdd25871$var$af, "onAnimationIteration");
$656e2c29cdd25871$var$ff($656e2c29cdd25871$var$bf, "onAnimationStart");
$656e2c29cdd25871$var$ff("dblclick", "onDoubleClick");
$656e2c29cdd25871$var$ff("focusin", "onFocus");
$656e2c29cdd25871$var$ff("focusout", "onBlur");
$656e2c29cdd25871$var$ff($656e2c29cdd25871$var$cf, "onTransitionEnd");
$656e2c29cdd25871$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$656e2c29cdd25871$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$656e2c29cdd25871$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$656e2c29cdd25871$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$656e2c29cdd25871$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$656e2c29cdd25871$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$656e2c29cdd25871$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$656e2c29cdd25871$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$656e2c29cdd25871$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$656e2c29cdd25871$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $656e2c29cdd25871$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $656e2c29cdd25871$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($656e2c29cdd25871$var$lf));
function $656e2c29cdd25871$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $656e2c29cdd25871$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $656e2c29cdd25871$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $656e2c29cdd25871$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $656e2c29cdd25871$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($656e2c29cdd25871$var$Qb) throw a = $656e2c29cdd25871$var$Rb, $656e2c29cdd25871$var$Qb = !1, $656e2c29cdd25871$var$Rb = null, a;
}
function $656e2c29cdd25871$var$D(a, b) {
    var c = b[$656e2c29cdd25871$var$of];
    void 0 === c && (c = b[$656e2c29cdd25871$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($656e2c29cdd25871$var$pf(b, a, 2, !1), c.add(d));
}
function $656e2c29cdd25871$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $656e2c29cdd25871$var$pf(c, a, d, b);
}
var $656e2c29cdd25871$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $656e2c29cdd25871$var$sf(a) {
    if (!a[$656e2c29cdd25871$var$rf]) {
        a[$656e2c29cdd25871$var$rf] = !0;
        $656e2c29cdd25871$var$da.forEach(function(b) {
            "selectionchange" !== b && ($656e2c29cdd25871$var$mf.has(b) || $656e2c29cdd25871$var$qf(b, !1, a), $656e2c29cdd25871$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$656e2c29cdd25871$var$rf] || (b[$656e2c29cdd25871$var$rf] = !0, $656e2c29cdd25871$var$qf("selectionchange", !1, b));
    }
}
function $656e2c29cdd25871$var$pf(a, b, c, d) {
    switch($656e2c29cdd25871$var$jd(b)){
        case 1:
            var e = $656e2c29cdd25871$var$ed;
            break;
        case 4:
            e = $656e2c29cdd25871$var$gd;
            break;
        default:
            e = $656e2c29cdd25871$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$656e2c29cdd25871$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $656e2c29cdd25871$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $656e2c29cdd25871$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $656e2c29cdd25871$var$Jb(function() {
        var d = f, e = $656e2c29cdd25871$var$xb(c), g = [];
        a: {
            var h = $656e2c29cdd25871$var$df.get(a);
            if (void 0 !== h) {
                var k = $656e2c29cdd25871$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $656e2c29cdd25871$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $656e2c29cdd25871$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $656e2c29cdd25871$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $656e2c29cdd25871$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $656e2c29cdd25871$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $656e2c29cdd25871$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $656e2c29cdd25871$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $656e2c29cdd25871$var$Vd;
                        break;
                    case $656e2c29cdd25871$var$$e:
                    case $656e2c29cdd25871$var$af:
                    case $656e2c29cdd25871$var$bf:
                        k = $656e2c29cdd25871$var$Hd;
                        break;
                    case $656e2c29cdd25871$var$cf:
                        k = $656e2c29cdd25871$var$Xd;
                        break;
                    case "scroll":
                        k = $656e2c29cdd25871$var$vd;
                        break;
                    case "wheel":
                        k = $656e2c29cdd25871$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $656e2c29cdd25871$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $656e2c29cdd25871$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $656e2c29cdd25871$var$Kb(w, x), null != F && t.push($656e2c29cdd25871$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $656e2c29cdd25871$var$wb && (n = c.relatedTarget || c.fromElement) && ($656e2c29cdd25871$var$Wc(n) || n[$656e2c29cdd25871$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $656e2c29cdd25871$var$Wc(n) : null, null !== n && (J = $656e2c29cdd25871$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $656e2c29cdd25871$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $656e2c29cdd25871$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $656e2c29cdd25871$var$ue(k);
                        u = null == n ? h : $656e2c29cdd25871$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $656e2c29cdd25871$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $656e2c29cdd25871$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $656e2c29cdd25871$var$vf(F))u++;
                            for(; 0 < w - u;)t = $656e2c29cdd25871$var$vf(t), w--;
                            for(; 0 < u - w;)x = $656e2c29cdd25871$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $656e2c29cdd25871$var$vf(t);
                                x = $656e2c29cdd25871$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $656e2c29cdd25871$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $656e2c29cdd25871$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $656e2c29cdd25871$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $656e2c29cdd25871$var$ve;
                else if ($656e2c29cdd25871$var$me(h)) {
                    if ($656e2c29cdd25871$var$we) na = $656e2c29cdd25871$var$Fe;
                    else {
                        na = $656e2c29cdd25871$var$De;
                        var xa = $656e2c29cdd25871$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $656e2c29cdd25871$var$Ee);
                if (na && (na = na(a, d))) {
                    $656e2c29cdd25871$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $656e2c29cdd25871$var$cb(h, "number", h.value);
            }
            xa = d ? $656e2c29cdd25871$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($656e2c29cdd25871$var$me(xa) || "true" === xa.contentEditable) $656e2c29cdd25871$var$Qe = xa, $656e2c29cdd25871$var$Re = d, $656e2c29cdd25871$var$Se = null;
                    break;
                case "focusout":
                    $656e2c29cdd25871$var$Se = $656e2c29cdd25871$var$Re = $656e2c29cdd25871$var$Qe = null;
                    break;
                case "mousedown":
                    $656e2c29cdd25871$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $656e2c29cdd25871$var$Te = !1;
                    $656e2c29cdd25871$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($656e2c29cdd25871$var$Pe) break;
                case "keydown":
                case "keyup":
                    $656e2c29cdd25871$var$Ue(g, c, e);
            }
            var $a;
            if ($656e2c29cdd25871$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $656e2c29cdd25871$var$ie ? $656e2c29cdd25871$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($656e2c29cdd25871$var$de && "ko" !== c.locale && ($656e2c29cdd25871$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $656e2c29cdd25871$var$ie && ($a = $656e2c29cdd25871$var$nd()) : ($656e2c29cdd25871$var$kd = e, $656e2c29cdd25871$var$ld = "value" in $656e2c29cdd25871$var$kd ? $656e2c29cdd25871$var$kd.value : $656e2c29cdd25871$var$kd.textContent, $656e2c29cdd25871$var$ie = !0)), xa = $656e2c29cdd25871$var$oe(d, ba), 0 < xa.length && (ba = new $656e2c29cdd25871$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $656e2c29cdd25871$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $656e2c29cdd25871$var$ce ? $656e2c29cdd25871$var$je(a, c) : $656e2c29cdd25871$var$ke(a, c)) d = $656e2c29cdd25871$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $656e2c29cdd25871$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $656e2c29cdd25871$var$se(g, b);
    });
}
function $656e2c29cdd25871$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $656e2c29cdd25871$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $656e2c29cdd25871$var$Kb(a, c), null != f && d.unshift($656e2c29cdd25871$var$tf(a, f, e)), f = $656e2c29cdd25871$var$Kb(a, b), null != f && d.push($656e2c29cdd25871$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $656e2c29cdd25871$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $656e2c29cdd25871$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $656e2c29cdd25871$var$Kb(c, f), null != k && g.unshift($656e2c29cdd25871$var$tf(c, k, h))) : e || (k = $656e2c29cdd25871$var$Kb(c, f), null != k && g.push($656e2c29cdd25871$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $656e2c29cdd25871$var$xf = /\r\n?/g, $656e2c29cdd25871$var$yf = /\u0000|\uFFFD/g;
function $656e2c29cdd25871$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($656e2c29cdd25871$var$xf, "\n").replace($656e2c29cdd25871$var$yf, "");
}
function $656e2c29cdd25871$var$Af(a, b, c) {
    b = $656e2c29cdd25871$var$zf(b);
    if ($656e2c29cdd25871$var$zf(a) !== b && c) throw Error($656e2c29cdd25871$var$p(425));
}
function $656e2c29cdd25871$var$Bf() {}
var $656e2c29cdd25871$var$Cf = null, $656e2c29cdd25871$var$Df = null;
function $656e2c29cdd25871$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $656e2c29cdd25871$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $656e2c29cdd25871$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $656e2c29cdd25871$var$Hf = "function" === typeof Promise ? Promise : void 0, $656e2c29cdd25871$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $656e2c29cdd25871$var$Hf ? function(a) {
    return $656e2c29cdd25871$var$Hf.resolve(null).then(a).catch($656e2c29cdd25871$var$If);
} : $656e2c29cdd25871$var$Ff;
function $656e2c29cdd25871$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $656e2c29cdd25871$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $656e2c29cdd25871$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $656e2c29cdd25871$var$bd(b);
}
function $656e2c29cdd25871$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $656e2c29cdd25871$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $656e2c29cdd25871$var$Nf = Math.random().toString(36).slice(2), $656e2c29cdd25871$var$Of = "__reactFiber$" + $656e2c29cdd25871$var$Nf, $656e2c29cdd25871$var$Pf = "__reactProps$" + $656e2c29cdd25871$var$Nf, $656e2c29cdd25871$var$uf = "__reactContainer$" + $656e2c29cdd25871$var$Nf, $656e2c29cdd25871$var$of = "__reactEvents$" + $656e2c29cdd25871$var$Nf, $656e2c29cdd25871$var$Qf = "__reactListeners$" + $656e2c29cdd25871$var$Nf, $656e2c29cdd25871$var$Rf = "__reactHandles$" + $656e2c29cdd25871$var$Nf;
function $656e2c29cdd25871$var$Wc(a) {
    var b = a[$656e2c29cdd25871$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$656e2c29cdd25871$var$uf] || c[$656e2c29cdd25871$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $656e2c29cdd25871$var$Mf(a); null !== a;){
                if (c = a[$656e2c29cdd25871$var$Of]) return c;
                a = $656e2c29cdd25871$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $656e2c29cdd25871$var$Cb(a) {
    a = a[$656e2c29cdd25871$var$Of] || a[$656e2c29cdd25871$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $656e2c29cdd25871$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($656e2c29cdd25871$var$p(33));
}
function $656e2c29cdd25871$var$Db(a) {
    return a[$656e2c29cdd25871$var$Pf] || null;
}
var $656e2c29cdd25871$var$Sf = [], $656e2c29cdd25871$var$Tf = -1;
function $656e2c29cdd25871$var$Uf(a) {
    return {
        current: a
    };
}
function $656e2c29cdd25871$var$E(a) {
    0 > $656e2c29cdd25871$var$Tf || (a.current = $656e2c29cdd25871$var$Sf[$656e2c29cdd25871$var$Tf], $656e2c29cdd25871$var$Sf[$656e2c29cdd25871$var$Tf] = null, $656e2c29cdd25871$var$Tf--);
}
function $656e2c29cdd25871$var$G(a, b) {
    $656e2c29cdd25871$var$Tf++;
    $656e2c29cdd25871$var$Sf[$656e2c29cdd25871$var$Tf] = a.current;
    a.current = b;
}
var $656e2c29cdd25871$var$Vf = {}, $656e2c29cdd25871$var$H = $656e2c29cdd25871$var$Uf($656e2c29cdd25871$var$Vf), $656e2c29cdd25871$var$Wf = $656e2c29cdd25871$var$Uf(!1), $656e2c29cdd25871$var$Xf = $656e2c29cdd25871$var$Vf;
function $656e2c29cdd25871$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $656e2c29cdd25871$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $656e2c29cdd25871$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $656e2c29cdd25871$var$$f() {
    $656e2c29cdd25871$var$E($656e2c29cdd25871$var$Wf);
    $656e2c29cdd25871$var$E($656e2c29cdd25871$var$H);
}
function $656e2c29cdd25871$var$ag(a, b, c) {
    if ($656e2c29cdd25871$var$H.current !== $656e2c29cdd25871$var$Vf) throw Error($656e2c29cdd25871$var$p(168));
    $656e2c29cdd25871$var$G($656e2c29cdd25871$var$H, b);
    $656e2c29cdd25871$var$G($656e2c29cdd25871$var$Wf, c);
}
function $656e2c29cdd25871$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($656e2c29cdd25871$var$p(108, $656e2c29cdd25871$var$Ra(a) || "Unknown", e));
    return $656e2c29cdd25871$var$A({}, c, d);
}
function $656e2c29cdd25871$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $656e2c29cdd25871$var$Vf;
    $656e2c29cdd25871$var$Xf = $656e2c29cdd25871$var$H.current;
    $656e2c29cdd25871$var$G($656e2c29cdd25871$var$H, a);
    $656e2c29cdd25871$var$G($656e2c29cdd25871$var$Wf, $656e2c29cdd25871$var$Wf.current);
    return !0;
}
function $656e2c29cdd25871$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($656e2c29cdd25871$var$p(169));
    c ? (a = $656e2c29cdd25871$var$bg(a, b, $656e2c29cdd25871$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $656e2c29cdd25871$var$E($656e2c29cdd25871$var$Wf), $656e2c29cdd25871$var$E($656e2c29cdd25871$var$H), $656e2c29cdd25871$var$G($656e2c29cdd25871$var$H, a)) : $656e2c29cdd25871$var$E($656e2c29cdd25871$var$Wf);
    $656e2c29cdd25871$var$G($656e2c29cdd25871$var$Wf, c);
}
var $656e2c29cdd25871$var$eg = null, $656e2c29cdd25871$var$fg = !1, $656e2c29cdd25871$var$gg = !1;
function $656e2c29cdd25871$var$hg(a) {
    null === $656e2c29cdd25871$var$eg ? $656e2c29cdd25871$var$eg = [
        a
    ] : $656e2c29cdd25871$var$eg.push(a);
}
function $656e2c29cdd25871$var$ig(a) {
    $656e2c29cdd25871$var$fg = !0;
    $656e2c29cdd25871$var$hg(a);
}
function $656e2c29cdd25871$var$jg() {
    if (!$656e2c29cdd25871$var$gg && null !== $656e2c29cdd25871$var$eg) {
        $656e2c29cdd25871$var$gg = !0;
        var a = 0, b = $656e2c29cdd25871$var$C;
        try {
            var c = $656e2c29cdd25871$var$eg;
            for($656e2c29cdd25871$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $656e2c29cdd25871$var$eg = null;
            $656e2c29cdd25871$var$fg = !1;
        } catch (e) {
            throw null !== $656e2c29cdd25871$var$eg && ($656e2c29cdd25871$var$eg = $656e2c29cdd25871$var$eg.slice(a + 1)), $656e2c29cdd25871$var$ac($656e2c29cdd25871$var$fc, $656e2c29cdd25871$var$jg), e;
        } finally{
            $656e2c29cdd25871$var$C = b, $656e2c29cdd25871$var$gg = !1;
        }
    }
    return null;
}
var $656e2c29cdd25871$var$kg = [], $656e2c29cdd25871$var$lg = 0, $656e2c29cdd25871$var$mg = null, $656e2c29cdd25871$var$ng = 0, $656e2c29cdd25871$var$og = [], $656e2c29cdd25871$var$pg = 0, $656e2c29cdd25871$var$qg = null, $656e2c29cdd25871$var$rg = 1, $656e2c29cdd25871$var$sg = "";
function $656e2c29cdd25871$var$tg(a, b) {
    $656e2c29cdd25871$var$kg[$656e2c29cdd25871$var$lg++] = $656e2c29cdd25871$var$ng;
    $656e2c29cdd25871$var$kg[$656e2c29cdd25871$var$lg++] = $656e2c29cdd25871$var$mg;
    $656e2c29cdd25871$var$mg = a;
    $656e2c29cdd25871$var$ng = b;
}
function $656e2c29cdd25871$var$ug(a, b, c) {
    $656e2c29cdd25871$var$og[$656e2c29cdd25871$var$pg++] = $656e2c29cdd25871$var$rg;
    $656e2c29cdd25871$var$og[$656e2c29cdd25871$var$pg++] = $656e2c29cdd25871$var$sg;
    $656e2c29cdd25871$var$og[$656e2c29cdd25871$var$pg++] = $656e2c29cdd25871$var$qg;
    $656e2c29cdd25871$var$qg = a;
    var d = $656e2c29cdd25871$var$rg;
    a = $656e2c29cdd25871$var$sg;
    var e = 32 - $656e2c29cdd25871$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $656e2c29cdd25871$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $656e2c29cdd25871$var$rg = 1 << 32 - $656e2c29cdd25871$var$oc(b) + e | c << e | d;
        $656e2c29cdd25871$var$sg = f + a;
    } else $656e2c29cdd25871$var$rg = 1 << f | c << e | d, $656e2c29cdd25871$var$sg = a;
}
function $656e2c29cdd25871$var$vg(a) {
    null !== a.return && ($656e2c29cdd25871$var$tg(a, 1), $656e2c29cdd25871$var$ug(a, 1, 0));
}
function $656e2c29cdd25871$var$wg(a) {
    for(; a === $656e2c29cdd25871$var$mg;)$656e2c29cdd25871$var$mg = $656e2c29cdd25871$var$kg[--$656e2c29cdd25871$var$lg], $656e2c29cdd25871$var$kg[$656e2c29cdd25871$var$lg] = null, $656e2c29cdd25871$var$ng = $656e2c29cdd25871$var$kg[--$656e2c29cdd25871$var$lg], $656e2c29cdd25871$var$kg[$656e2c29cdd25871$var$lg] = null;
    for(; a === $656e2c29cdd25871$var$qg;)$656e2c29cdd25871$var$qg = $656e2c29cdd25871$var$og[--$656e2c29cdd25871$var$pg], $656e2c29cdd25871$var$og[$656e2c29cdd25871$var$pg] = null, $656e2c29cdd25871$var$sg = $656e2c29cdd25871$var$og[--$656e2c29cdd25871$var$pg], $656e2c29cdd25871$var$og[$656e2c29cdd25871$var$pg] = null, $656e2c29cdd25871$var$rg = $656e2c29cdd25871$var$og[--$656e2c29cdd25871$var$pg], $656e2c29cdd25871$var$og[$656e2c29cdd25871$var$pg] = null;
}
var $656e2c29cdd25871$var$xg = null, $656e2c29cdd25871$var$yg = null, $656e2c29cdd25871$var$I = !1, $656e2c29cdd25871$var$zg = null;
function $656e2c29cdd25871$var$Ag(a, b) {
    var c = $656e2c29cdd25871$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $656e2c29cdd25871$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $656e2c29cdd25871$var$xg = a, $656e2c29cdd25871$var$yg = $656e2c29cdd25871$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $656e2c29cdd25871$var$xg = a, $656e2c29cdd25871$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $656e2c29cdd25871$var$qg ? {
                id: $656e2c29cdd25871$var$rg,
                overflow: $656e2c29cdd25871$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $656e2c29cdd25871$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $656e2c29cdd25871$var$xg = a, $656e2c29cdd25871$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $656e2c29cdd25871$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $656e2c29cdd25871$var$Eg(a) {
    if ($656e2c29cdd25871$var$I) {
        var b = $656e2c29cdd25871$var$yg;
        if (b) {
            var c = b;
            if (!$656e2c29cdd25871$var$Cg(a, b)) {
                if ($656e2c29cdd25871$var$Dg(a)) throw Error($656e2c29cdd25871$var$p(418));
                b = $656e2c29cdd25871$var$Lf(c.nextSibling);
                var d = $656e2c29cdd25871$var$xg;
                b && $656e2c29cdd25871$var$Cg(a, b) ? $656e2c29cdd25871$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $656e2c29cdd25871$var$I = !1, $656e2c29cdd25871$var$xg = a);
            }
        } else {
            if ($656e2c29cdd25871$var$Dg(a)) throw Error($656e2c29cdd25871$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $656e2c29cdd25871$var$I = !1;
            $656e2c29cdd25871$var$xg = a;
        }
    }
}
function $656e2c29cdd25871$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $656e2c29cdd25871$var$xg = a;
}
function $656e2c29cdd25871$var$Gg(a) {
    if (a !== $656e2c29cdd25871$var$xg) return !1;
    if (!$656e2c29cdd25871$var$I) return $656e2c29cdd25871$var$Fg(a), $656e2c29cdd25871$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$656e2c29cdd25871$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $656e2c29cdd25871$var$yg)) {
        if ($656e2c29cdd25871$var$Dg(a)) throw $656e2c29cdd25871$var$Hg(), Error($656e2c29cdd25871$var$p(418));
        for(; b;)$656e2c29cdd25871$var$Ag(a, b), b = $656e2c29cdd25871$var$Lf(b.nextSibling);
    }
    $656e2c29cdd25871$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($656e2c29cdd25871$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $656e2c29cdd25871$var$yg = $656e2c29cdd25871$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $656e2c29cdd25871$var$yg = null;
        }
    } else $656e2c29cdd25871$var$yg = $656e2c29cdd25871$var$xg ? $656e2c29cdd25871$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $656e2c29cdd25871$var$Hg() {
    for(var a = $656e2c29cdd25871$var$yg; a;)a = $656e2c29cdd25871$var$Lf(a.nextSibling);
}
function $656e2c29cdd25871$var$Ig() {
    $656e2c29cdd25871$var$yg = $656e2c29cdd25871$var$xg = null;
    $656e2c29cdd25871$var$I = !1;
}
function $656e2c29cdd25871$var$Jg(a) {
    null === $656e2c29cdd25871$var$zg ? $656e2c29cdd25871$var$zg = [
        a
    ] : $656e2c29cdd25871$var$zg.push(a);
}
var $656e2c29cdd25871$var$Kg = $656e2c29cdd25871$var$ua.ReactCurrentBatchConfig;
function $656e2c29cdd25871$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $656e2c29cdd25871$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $656e2c29cdd25871$var$Mg = $656e2c29cdd25871$var$Uf(null), $656e2c29cdd25871$var$Ng = null, $656e2c29cdd25871$var$Og = null, $656e2c29cdd25871$var$Pg = null;
function $656e2c29cdd25871$var$Qg() {
    $656e2c29cdd25871$var$Pg = $656e2c29cdd25871$var$Og = $656e2c29cdd25871$var$Ng = null;
}
function $656e2c29cdd25871$var$Rg(a) {
    var b = $656e2c29cdd25871$var$Mg.current;
    $656e2c29cdd25871$var$E($656e2c29cdd25871$var$Mg);
    a._currentValue = b;
}
function $656e2c29cdd25871$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $656e2c29cdd25871$var$Tg(a, b) {
    $656e2c29cdd25871$var$Ng = a;
    $656e2c29cdd25871$var$Pg = $656e2c29cdd25871$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($656e2c29cdd25871$var$Ug = !0), a.firstContext = null);
}
function $656e2c29cdd25871$var$Vg(a) {
    var b = a._currentValue;
    if ($656e2c29cdd25871$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $656e2c29cdd25871$var$Og) {
            if (null === $656e2c29cdd25871$var$Ng) throw Error($656e2c29cdd25871$var$p(308));
            $656e2c29cdd25871$var$Og = a;
            $656e2c29cdd25871$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $656e2c29cdd25871$var$Og = $656e2c29cdd25871$var$Og.next = a;
    }
    return b;
}
var $656e2c29cdd25871$var$Wg = null;
function $656e2c29cdd25871$var$Xg(a) {
    null === $656e2c29cdd25871$var$Wg ? $656e2c29cdd25871$var$Wg = [
        a
    ] : $656e2c29cdd25871$var$Wg.push(a);
}
function $656e2c29cdd25871$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $656e2c29cdd25871$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $656e2c29cdd25871$var$Zg(a, d);
}
function $656e2c29cdd25871$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $656e2c29cdd25871$var$$g = !1;
function $656e2c29cdd25871$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $656e2c29cdd25871$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $656e2c29cdd25871$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $656e2c29cdd25871$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($656e2c29cdd25871$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $656e2c29cdd25871$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $656e2c29cdd25871$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $656e2c29cdd25871$var$Zg(a, c);
}
function $656e2c29cdd25871$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $656e2c29cdd25871$var$Cc(a, c);
    }
}
function $656e2c29cdd25871$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $656e2c29cdd25871$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $656e2c29cdd25871$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $656e2c29cdd25871$var$A({}, q, r);
                            break a;
                        case 2:
                            $656e2c29cdd25871$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $656e2c29cdd25871$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $656e2c29cdd25871$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($656e2c29cdd25871$var$p(191, e));
            e.call(d);
        }
    }
}
var $656e2c29cdd25871$var$jh = (new $h4Bez.Component).refs;
function $656e2c29cdd25871$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $656e2c29cdd25871$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $656e2c29cdd25871$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $656e2c29cdd25871$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $656e2c29cdd25871$var$L(), e = $656e2c29cdd25871$var$lh(a), f = $656e2c29cdd25871$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $656e2c29cdd25871$var$dh(a, f, e);
        null !== b && ($656e2c29cdd25871$var$mh(b, a, e, d), $656e2c29cdd25871$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $656e2c29cdd25871$var$L(), e = $656e2c29cdd25871$var$lh(a), f = $656e2c29cdd25871$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $656e2c29cdd25871$var$dh(a, f, e);
        null !== b && ($656e2c29cdd25871$var$mh(b, a, e, d), $656e2c29cdd25871$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $656e2c29cdd25871$var$L(), d = $656e2c29cdd25871$var$lh(a), e = $656e2c29cdd25871$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $656e2c29cdd25871$var$dh(a, e, d);
        null !== b && ($656e2c29cdd25871$var$mh(b, a, d, c), $656e2c29cdd25871$var$eh(b, a, d));
    }
};
function $656e2c29cdd25871$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$656e2c29cdd25871$var$Ie(c, d) || !$656e2c29cdd25871$var$Ie(e, f) : !0;
}
function $656e2c29cdd25871$var$ph(a, b, c) {
    var d = !1, e = $656e2c29cdd25871$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $656e2c29cdd25871$var$Vg(f) : (e = $656e2c29cdd25871$var$Zf(b) ? $656e2c29cdd25871$var$Xf : $656e2c29cdd25871$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $656e2c29cdd25871$var$Yf(a, e) : $656e2c29cdd25871$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $656e2c29cdd25871$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $656e2c29cdd25871$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $656e2c29cdd25871$var$nh.enqueueReplaceState(b, b.state, null);
}
function $656e2c29cdd25871$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $656e2c29cdd25871$var$jh;
    $656e2c29cdd25871$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $656e2c29cdd25871$var$Vg(f) : (f = $656e2c29cdd25871$var$Zf(b) ? $656e2c29cdd25871$var$Xf : $656e2c29cdd25871$var$H.current, e.context = $656e2c29cdd25871$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($656e2c29cdd25871$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $656e2c29cdd25871$var$nh.enqueueReplaceState(e, e.state, null), $656e2c29cdd25871$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $656e2c29cdd25871$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($656e2c29cdd25871$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($656e2c29cdd25871$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $656e2c29cdd25871$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($656e2c29cdd25871$var$p(284));
        if (!c._owner) throw Error($656e2c29cdd25871$var$p(290, a));
    }
    return a;
}
function $656e2c29cdd25871$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($656e2c29cdd25871$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $656e2c29cdd25871$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $656e2c29cdd25871$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $656e2c29cdd25871$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $656e2c29cdd25871$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $656e2c29cdd25871$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $656e2c29cdd25871$var$Ha && $656e2c29cdd25871$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $656e2c29cdd25871$var$sh(a, b, c), d.return = a, d;
        d = $656e2c29cdd25871$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $656e2c29cdd25871$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $656e2c29cdd25871$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $656e2c29cdd25871$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $656e2c29cdd25871$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $656e2c29cdd25871$var$va:
                    return c = $656e2c29cdd25871$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $656e2c29cdd25871$var$sh(a, null, b), c.return = a, c;
                case $656e2c29cdd25871$var$wa:
                    return b = $656e2c29cdd25871$var$zh(b, a.mode, c), b.return = a, b;
                case $656e2c29cdd25871$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($656e2c29cdd25871$var$eb(b) || $656e2c29cdd25871$var$Ka(b)) return b = $656e2c29cdd25871$var$Ah(b, a.mode, c, null), b.return = a, b;
            $656e2c29cdd25871$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $656e2c29cdd25871$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $656e2c29cdd25871$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $656e2c29cdd25871$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($656e2c29cdd25871$var$eb(c) || $656e2c29cdd25871$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $656e2c29cdd25871$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $656e2c29cdd25871$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $656e2c29cdd25871$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $656e2c29cdd25871$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($656e2c29cdd25871$var$eb(d) || $656e2c29cdd25871$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $656e2c29cdd25871$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $656e2c29cdd25871$var$I && $656e2c29cdd25871$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $656e2c29cdd25871$var$I && $656e2c29cdd25871$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $656e2c29cdd25871$var$I && $656e2c29cdd25871$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $656e2c29cdd25871$var$Ka(h);
        if ("function" !== typeof l) throw Error($656e2c29cdd25871$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($656e2c29cdd25871$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $656e2c29cdd25871$var$I && $656e2c29cdd25871$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $656e2c29cdd25871$var$I && $656e2c29cdd25871$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $656e2c29cdd25871$var$I && $656e2c29cdd25871$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $656e2c29cdd25871$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $656e2c29cdd25871$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $656e2c29cdd25871$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $656e2c29cdd25871$var$Ha && $656e2c29cdd25871$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $656e2c29cdd25871$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $656e2c29cdd25871$var$ya ? (d = $656e2c29cdd25871$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $656e2c29cdd25871$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $656e2c29cdd25871$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $656e2c29cdd25871$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $656e2c29cdd25871$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $656e2c29cdd25871$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($656e2c29cdd25871$var$eb(f)) return n(a, d, f, h);
            if ($656e2c29cdd25871$var$Ka(f)) return t(a, d, f, h);
            $656e2c29cdd25871$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $656e2c29cdd25871$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $656e2c29cdd25871$var$Bh = $656e2c29cdd25871$var$vh(!0), $656e2c29cdd25871$var$Ch = $656e2c29cdd25871$var$vh(!1), $656e2c29cdd25871$var$Dh = {}, $656e2c29cdd25871$var$Eh = $656e2c29cdd25871$var$Uf($656e2c29cdd25871$var$Dh), $656e2c29cdd25871$var$Fh = $656e2c29cdd25871$var$Uf($656e2c29cdd25871$var$Dh), $656e2c29cdd25871$var$Gh = $656e2c29cdd25871$var$Uf($656e2c29cdd25871$var$Dh);
function $656e2c29cdd25871$var$Hh(a) {
    if (a === $656e2c29cdd25871$var$Dh) throw Error($656e2c29cdd25871$var$p(174));
    return a;
}
function $656e2c29cdd25871$var$Ih(a, b) {
    $656e2c29cdd25871$var$G($656e2c29cdd25871$var$Gh, b);
    $656e2c29cdd25871$var$G($656e2c29cdd25871$var$Fh, a);
    $656e2c29cdd25871$var$G($656e2c29cdd25871$var$Eh, $656e2c29cdd25871$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $656e2c29cdd25871$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $656e2c29cdd25871$var$lb(b, a);
    }
    $656e2c29cdd25871$var$E($656e2c29cdd25871$var$Eh);
    $656e2c29cdd25871$var$G($656e2c29cdd25871$var$Eh, b);
}
function $656e2c29cdd25871$var$Jh() {
    $656e2c29cdd25871$var$E($656e2c29cdd25871$var$Eh);
    $656e2c29cdd25871$var$E($656e2c29cdd25871$var$Fh);
    $656e2c29cdd25871$var$E($656e2c29cdd25871$var$Gh);
}
function $656e2c29cdd25871$var$Kh(a) {
    $656e2c29cdd25871$var$Hh($656e2c29cdd25871$var$Gh.current);
    var b = $656e2c29cdd25871$var$Hh($656e2c29cdd25871$var$Eh.current);
    var c = $656e2c29cdd25871$var$lb(b, a.type);
    b !== c && ($656e2c29cdd25871$var$G($656e2c29cdd25871$var$Fh, a), $656e2c29cdd25871$var$G($656e2c29cdd25871$var$Eh, c));
}
function $656e2c29cdd25871$var$Lh(a) {
    $656e2c29cdd25871$var$Fh.current === a && ($656e2c29cdd25871$var$E($656e2c29cdd25871$var$Eh), $656e2c29cdd25871$var$E($656e2c29cdd25871$var$Fh));
}
var $656e2c29cdd25871$var$M = $656e2c29cdd25871$var$Uf(0);
function $656e2c29cdd25871$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $656e2c29cdd25871$var$Nh = [];
function $656e2c29cdd25871$var$Oh() {
    for(var a = 0; a < $656e2c29cdd25871$var$Nh.length; a++)$656e2c29cdd25871$var$Nh[a]._workInProgressVersionPrimary = null;
    $656e2c29cdd25871$var$Nh.length = 0;
}
var $656e2c29cdd25871$var$Ph = $656e2c29cdd25871$var$ua.ReactCurrentDispatcher, $656e2c29cdd25871$var$Qh = $656e2c29cdd25871$var$ua.ReactCurrentBatchConfig, $656e2c29cdd25871$var$Rh = 0, $656e2c29cdd25871$var$N = null, $656e2c29cdd25871$var$O = null, $656e2c29cdd25871$var$P = null, $656e2c29cdd25871$var$Sh = !1, $656e2c29cdd25871$var$Th = !1, $656e2c29cdd25871$var$Uh = 0, $656e2c29cdd25871$var$Vh = 0;
function $656e2c29cdd25871$var$Q() {
    throw Error($656e2c29cdd25871$var$p(321));
}
function $656e2c29cdd25871$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$656e2c29cdd25871$var$He(a[c], b[c])) return !1;
    return !0;
}
function $656e2c29cdd25871$var$Xh(a, b, c, d, e, f) {
    $656e2c29cdd25871$var$Rh = f;
    $656e2c29cdd25871$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $656e2c29cdd25871$var$Ph.current = null === a || null === a.memoizedState ? $656e2c29cdd25871$var$Yh : $656e2c29cdd25871$var$Zh;
    a = c(d, e);
    if ($656e2c29cdd25871$var$Th) {
        f = 0;
        do {
            $656e2c29cdd25871$var$Th = !1;
            $656e2c29cdd25871$var$Uh = 0;
            if (25 <= f) throw Error($656e2c29cdd25871$var$p(301));
            f += 1;
            $656e2c29cdd25871$var$P = $656e2c29cdd25871$var$O = null;
            b.updateQueue = null;
            $656e2c29cdd25871$var$Ph.current = $656e2c29cdd25871$var$$h;
            a = c(d, e);
        }while ($656e2c29cdd25871$var$Th);
    }
    $656e2c29cdd25871$var$Ph.current = $656e2c29cdd25871$var$ai;
    b = null !== $656e2c29cdd25871$var$O && null !== $656e2c29cdd25871$var$O.next;
    $656e2c29cdd25871$var$Rh = 0;
    $656e2c29cdd25871$var$P = $656e2c29cdd25871$var$O = $656e2c29cdd25871$var$N = null;
    $656e2c29cdd25871$var$Sh = !1;
    if (b) throw Error($656e2c29cdd25871$var$p(300));
    return a;
}
function $656e2c29cdd25871$var$bi() {
    var a = 0 !== $656e2c29cdd25871$var$Uh;
    $656e2c29cdd25871$var$Uh = 0;
    return a;
}
function $656e2c29cdd25871$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $656e2c29cdd25871$var$P ? $656e2c29cdd25871$var$N.memoizedState = $656e2c29cdd25871$var$P = a : $656e2c29cdd25871$var$P = $656e2c29cdd25871$var$P.next = a;
    return $656e2c29cdd25871$var$P;
}
function $656e2c29cdd25871$var$di() {
    if (null === $656e2c29cdd25871$var$O) {
        var a = $656e2c29cdd25871$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $656e2c29cdd25871$var$O.next;
    var b = null === $656e2c29cdd25871$var$P ? $656e2c29cdd25871$var$N.memoizedState : $656e2c29cdd25871$var$P.next;
    if (null !== b) $656e2c29cdd25871$var$P = b, $656e2c29cdd25871$var$O = a;
    else {
        if (null === a) throw Error($656e2c29cdd25871$var$p(310));
        $656e2c29cdd25871$var$O = a;
        a = {
            memoizedState: $656e2c29cdd25871$var$O.memoizedState,
            baseState: $656e2c29cdd25871$var$O.baseState,
            baseQueue: $656e2c29cdd25871$var$O.baseQueue,
            queue: $656e2c29cdd25871$var$O.queue,
            next: null
        };
        null === $656e2c29cdd25871$var$P ? $656e2c29cdd25871$var$N.memoizedState = $656e2c29cdd25871$var$P = a : $656e2c29cdd25871$var$P = $656e2c29cdd25871$var$P.next = a;
    }
    return $656e2c29cdd25871$var$P;
}
function $656e2c29cdd25871$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $656e2c29cdd25871$var$fi(a) {
    var b = $656e2c29cdd25871$var$di(), c = b.queue;
    if (null === c) throw Error($656e2c29cdd25871$var$p(311));
    c.lastRenderedReducer = a;
    var d = $656e2c29cdd25871$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($656e2c29cdd25871$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $656e2c29cdd25871$var$N.lanes |= m;
                $656e2c29cdd25871$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $656e2c29cdd25871$var$He(d, b.memoizedState) || ($656e2c29cdd25871$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $656e2c29cdd25871$var$N.lanes |= f, $656e2c29cdd25871$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $656e2c29cdd25871$var$gi(a) {
    var b = $656e2c29cdd25871$var$di(), c = b.queue;
    if (null === c) throw Error($656e2c29cdd25871$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $656e2c29cdd25871$var$He(f, b.memoizedState) || ($656e2c29cdd25871$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $656e2c29cdd25871$var$hi() {}
function $656e2c29cdd25871$var$ii(a, b) {
    var c = $656e2c29cdd25871$var$N, d = $656e2c29cdd25871$var$di(), e = b(), f = !$656e2c29cdd25871$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $656e2c29cdd25871$var$Ug = !0);
    d = d.queue;
    $656e2c29cdd25871$var$ji($656e2c29cdd25871$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $656e2c29cdd25871$var$P && $656e2c29cdd25871$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $656e2c29cdd25871$var$li(9, $656e2c29cdd25871$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $656e2c29cdd25871$var$R) throw Error($656e2c29cdd25871$var$p(349));
        0 !== ($656e2c29cdd25871$var$Rh & 30) || $656e2c29cdd25871$var$ni(c, b, e);
    }
    return e;
}
function $656e2c29cdd25871$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $656e2c29cdd25871$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $656e2c29cdd25871$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $656e2c29cdd25871$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $656e2c29cdd25871$var$oi(b) && $656e2c29cdd25871$var$pi(a);
}
function $656e2c29cdd25871$var$ki(a, b, c) {
    return c(function() {
        $656e2c29cdd25871$var$oi(b) && $656e2c29cdd25871$var$pi(a);
    });
}
function $656e2c29cdd25871$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$656e2c29cdd25871$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $656e2c29cdd25871$var$pi(a) {
    var b = $656e2c29cdd25871$var$Zg(a, 1);
    null !== b && $656e2c29cdd25871$var$mh(b, a, 1, -1);
}
function $656e2c29cdd25871$var$qi(a) {
    var b = $656e2c29cdd25871$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $656e2c29cdd25871$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $656e2c29cdd25871$var$ri.bind(null, $656e2c29cdd25871$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $656e2c29cdd25871$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $656e2c29cdd25871$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $656e2c29cdd25871$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $656e2c29cdd25871$var$si() {
    return $656e2c29cdd25871$var$di().memoizedState;
}
function $656e2c29cdd25871$var$ti(a, b, c, d) {
    var e = $656e2c29cdd25871$var$ci();
    $656e2c29cdd25871$var$N.flags |= a;
    e.memoizedState = $656e2c29cdd25871$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $656e2c29cdd25871$var$ui(a, b, c, d) {
    var e = $656e2c29cdd25871$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $656e2c29cdd25871$var$O) {
        var g = $656e2c29cdd25871$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $656e2c29cdd25871$var$Wh(d, g.deps)) {
            e.memoizedState = $656e2c29cdd25871$var$li(b, c, f, d);
            return;
        }
    }
    $656e2c29cdd25871$var$N.flags |= a;
    e.memoizedState = $656e2c29cdd25871$var$li(1 | b, c, f, d);
}
function $656e2c29cdd25871$var$vi(a, b) {
    return $656e2c29cdd25871$var$ti(8390656, 8, a, b);
}
function $656e2c29cdd25871$var$ji(a, b) {
    return $656e2c29cdd25871$var$ui(2048, 8, a, b);
}
function $656e2c29cdd25871$var$wi(a, b) {
    return $656e2c29cdd25871$var$ui(4, 2, a, b);
}
function $656e2c29cdd25871$var$xi(a, b) {
    return $656e2c29cdd25871$var$ui(4, 4, a, b);
}
function $656e2c29cdd25871$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $656e2c29cdd25871$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $656e2c29cdd25871$var$ui(4, 4, $656e2c29cdd25871$var$yi.bind(null, b, a), c);
}
function $656e2c29cdd25871$var$Ai() {}
function $656e2c29cdd25871$var$Bi(a, b) {
    var c = $656e2c29cdd25871$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $656e2c29cdd25871$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $656e2c29cdd25871$var$Ci(a, b) {
    var c = $656e2c29cdd25871$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $656e2c29cdd25871$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $656e2c29cdd25871$var$Di(a, b, c) {
    if (0 === ($656e2c29cdd25871$var$Rh & 21)) return a.baseState && (a.baseState = !1, $656e2c29cdd25871$var$Ug = !0), a.memoizedState = c;
    $656e2c29cdd25871$var$He(c, b) || (c = $656e2c29cdd25871$var$yc(), $656e2c29cdd25871$var$N.lanes |= c, $656e2c29cdd25871$var$hh |= c, a.baseState = !0);
    return b;
}
function $656e2c29cdd25871$var$Ei(a, b) {
    var c = $656e2c29cdd25871$var$C;
    $656e2c29cdd25871$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $656e2c29cdd25871$var$Qh.transition;
    $656e2c29cdd25871$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $656e2c29cdd25871$var$C = c, $656e2c29cdd25871$var$Qh.transition = d;
    }
}
function $656e2c29cdd25871$var$Fi() {
    return $656e2c29cdd25871$var$di().memoizedState;
}
function $656e2c29cdd25871$var$Gi(a, b, c) {
    var d = $656e2c29cdd25871$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($656e2c29cdd25871$var$Hi(a)) $656e2c29cdd25871$var$Ii(b, c);
    else if (c = $656e2c29cdd25871$var$Yg(a, b, c, d), null !== c) {
        var e = $656e2c29cdd25871$var$L();
        $656e2c29cdd25871$var$mh(c, a, d, e);
        $656e2c29cdd25871$var$Ji(c, b, d);
    }
}
function $656e2c29cdd25871$var$ri(a, b, c) {
    var d = $656e2c29cdd25871$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($656e2c29cdd25871$var$Hi(a)) $656e2c29cdd25871$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($656e2c29cdd25871$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $656e2c29cdd25871$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $656e2c29cdd25871$var$Yg(a, b, e, d);
        null !== c && (e = $656e2c29cdd25871$var$L(), $656e2c29cdd25871$var$mh(c, a, d, e), $656e2c29cdd25871$var$Ji(c, b, d));
    }
}
function $656e2c29cdd25871$var$Hi(a) {
    var b = a.alternate;
    return a === $656e2c29cdd25871$var$N || null !== b && b === $656e2c29cdd25871$var$N;
}
function $656e2c29cdd25871$var$Ii(a, b) {
    $656e2c29cdd25871$var$Th = $656e2c29cdd25871$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $656e2c29cdd25871$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $656e2c29cdd25871$var$Cc(a, c);
    }
}
var $656e2c29cdd25871$var$ai = {
    readContext: $656e2c29cdd25871$var$Vg,
    useCallback: $656e2c29cdd25871$var$Q,
    useContext: $656e2c29cdd25871$var$Q,
    useEffect: $656e2c29cdd25871$var$Q,
    useImperativeHandle: $656e2c29cdd25871$var$Q,
    useInsertionEffect: $656e2c29cdd25871$var$Q,
    useLayoutEffect: $656e2c29cdd25871$var$Q,
    useMemo: $656e2c29cdd25871$var$Q,
    useReducer: $656e2c29cdd25871$var$Q,
    useRef: $656e2c29cdd25871$var$Q,
    useState: $656e2c29cdd25871$var$Q,
    useDebugValue: $656e2c29cdd25871$var$Q,
    useDeferredValue: $656e2c29cdd25871$var$Q,
    useTransition: $656e2c29cdd25871$var$Q,
    useMutableSource: $656e2c29cdd25871$var$Q,
    useSyncExternalStore: $656e2c29cdd25871$var$Q,
    useId: $656e2c29cdd25871$var$Q,
    unstable_isNewReconciler: !1
}, $656e2c29cdd25871$var$Yh = {
    readContext: $656e2c29cdd25871$var$Vg,
    useCallback: function(a, b) {
        $656e2c29cdd25871$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $656e2c29cdd25871$var$Vg,
    useEffect: $656e2c29cdd25871$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $656e2c29cdd25871$var$ti(4194308, 4, $656e2c29cdd25871$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $656e2c29cdd25871$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $656e2c29cdd25871$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $656e2c29cdd25871$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $656e2c29cdd25871$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $656e2c29cdd25871$var$Gi.bind(null, $656e2c29cdd25871$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $656e2c29cdd25871$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $656e2c29cdd25871$var$qi,
    useDebugValue: $656e2c29cdd25871$var$Ai,
    useDeferredValue: function(a) {
        return $656e2c29cdd25871$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $656e2c29cdd25871$var$qi(!1), b = a[0];
        a = $656e2c29cdd25871$var$Ei.bind(null, a[1]);
        $656e2c29cdd25871$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $656e2c29cdd25871$var$N, e = $656e2c29cdd25871$var$ci();
        if ($656e2c29cdd25871$var$I) {
            if (void 0 === c) throw Error($656e2c29cdd25871$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $656e2c29cdd25871$var$R) throw Error($656e2c29cdd25871$var$p(349));
            0 !== ($656e2c29cdd25871$var$Rh & 30) || $656e2c29cdd25871$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $656e2c29cdd25871$var$vi($656e2c29cdd25871$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $656e2c29cdd25871$var$li(9, $656e2c29cdd25871$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $656e2c29cdd25871$var$ci(), b = $656e2c29cdd25871$var$R.identifierPrefix;
        if ($656e2c29cdd25871$var$I) {
            var c = $656e2c29cdd25871$var$sg;
            var d = $656e2c29cdd25871$var$rg;
            c = (d & ~(1 << 32 - $656e2c29cdd25871$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $656e2c29cdd25871$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $656e2c29cdd25871$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $656e2c29cdd25871$var$Zh = {
    readContext: $656e2c29cdd25871$var$Vg,
    useCallback: $656e2c29cdd25871$var$Bi,
    useContext: $656e2c29cdd25871$var$Vg,
    useEffect: $656e2c29cdd25871$var$ji,
    useImperativeHandle: $656e2c29cdd25871$var$zi,
    useInsertionEffect: $656e2c29cdd25871$var$wi,
    useLayoutEffect: $656e2c29cdd25871$var$xi,
    useMemo: $656e2c29cdd25871$var$Ci,
    useReducer: $656e2c29cdd25871$var$fi,
    useRef: $656e2c29cdd25871$var$si,
    useState: function() {
        return $656e2c29cdd25871$var$fi($656e2c29cdd25871$var$ei);
    },
    useDebugValue: $656e2c29cdd25871$var$Ai,
    useDeferredValue: function(a) {
        var b = $656e2c29cdd25871$var$di();
        return $656e2c29cdd25871$var$Di(b, $656e2c29cdd25871$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $656e2c29cdd25871$var$fi($656e2c29cdd25871$var$ei)[0], b = $656e2c29cdd25871$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $656e2c29cdd25871$var$hi,
    useSyncExternalStore: $656e2c29cdd25871$var$ii,
    useId: $656e2c29cdd25871$var$Fi,
    unstable_isNewReconciler: !1
}, $656e2c29cdd25871$var$$h = {
    readContext: $656e2c29cdd25871$var$Vg,
    useCallback: $656e2c29cdd25871$var$Bi,
    useContext: $656e2c29cdd25871$var$Vg,
    useEffect: $656e2c29cdd25871$var$ji,
    useImperativeHandle: $656e2c29cdd25871$var$zi,
    useInsertionEffect: $656e2c29cdd25871$var$wi,
    useLayoutEffect: $656e2c29cdd25871$var$xi,
    useMemo: $656e2c29cdd25871$var$Ci,
    useReducer: $656e2c29cdd25871$var$gi,
    useRef: $656e2c29cdd25871$var$si,
    useState: function() {
        return $656e2c29cdd25871$var$gi($656e2c29cdd25871$var$ei);
    },
    useDebugValue: $656e2c29cdd25871$var$Ai,
    useDeferredValue: function(a) {
        var b = $656e2c29cdd25871$var$di();
        return null === $656e2c29cdd25871$var$O ? b.memoizedState = a : $656e2c29cdd25871$var$Di(b, $656e2c29cdd25871$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $656e2c29cdd25871$var$gi($656e2c29cdd25871$var$ei)[0], b = $656e2c29cdd25871$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $656e2c29cdd25871$var$hi,
    useSyncExternalStore: $656e2c29cdd25871$var$ii,
    useId: $656e2c29cdd25871$var$Fi,
    unstable_isNewReconciler: !1
};
function $656e2c29cdd25871$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $656e2c29cdd25871$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $656e2c29cdd25871$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $656e2c29cdd25871$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $656e2c29cdd25871$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $656e2c29cdd25871$var$Oi(a, b, c) {
    c = $656e2c29cdd25871$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $656e2c29cdd25871$var$Pi || ($656e2c29cdd25871$var$Pi = !0, $656e2c29cdd25871$var$Qi = d);
        $656e2c29cdd25871$var$Mi(a, b);
    };
    return c;
}
function $656e2c29cdd25871$var$Ri(a, b, c) {
    c = $656e2c29cdd25871$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $656e2c29cdd25871$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $656e2c29cdd25871$var$Mi(a, b);
        "function" !== typeof d && (null === $656e2c29cdd25871$var$Si ? $656e2c29cdd25871$var$Si = new Set([
            this
        ]) : $656e2c29cdd25871$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $656e2c29cdd25871$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $656e2c29cdd25871$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $656e2c29cdd25871$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $656e2c29cdd25871$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $656e2c29cdd25871$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $656e2c29cdd25871$var$ch(-1, 1), b.tag = 2, $656e2c29cdd25871$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $656e2c29cdd25871$var$Xi = $656e2c29cdd25871$var$ua.ReactCurrentOwner, $656e2c29cdd25871$var$Ug = !1;
function $656e2c29cdd25871$var$Yi(a, b, c, d) {
    b.child = null === a ? $656e2c29cdd25871$var$Ch(b, null, c, d) : $656e2c29cdd25871$var$Bh(b, a.child, c, d);
}
function $656e2c29cdd25871$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $656e2c29cdd25871$var$Tg(b, e);
    d = $656e2c29cdd25871$var$Xh(a, b, c, d, f, e);
    c = $656e2c29cdd25871$var$bi();
    if (null !== a && !$656e2c29cdd25871$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $656e2c29cdd25871$var$$i(a, b, e);
    $656e2c29cdd25871$var$I && c && $656e2c29cdd25871$var$vg(b);
    b.flags |= 1;
    $656e2c29cdd25871$var$Yi(a, b, d, e);
    return b.child;
}
function $656e2c29cdd25871$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$656e2c29cdd25871$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $656e2c29cdd25871$var$cj(a, b, f, d, e);
        a = $656e2c29cdd25871$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $656e2c29cdd25871$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $656e2c29cdd25871$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $656e2c29cdd25871$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $656e2c29cdd25871$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($656e2c29cdd25871$var$Ie(f, d) && a.ref === b.ref) {
            if ($656e2c29cdd25871$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($656e2c29cdd25871$var$Ug = !0);
            else return b.lanes = a.lanes, $656e2c29cdd25871$var$$i(a, b, e);
        }
    }
    return $656e2c29cdd25871$var$dj(a, b, c, d, e);
}
function $656e2c29cdd25871$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $656e2c29cdd25871$var$G($656e2c29cdd25871$var$fj, $656e2c29cdd25871$var$gj), $656e2c29cdd25871$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $656e2c29cdd25871$var$G($656e2c29cdd25871$var$fj, $656e2c29cdd25871$var$gj), $656e2c29cdd25871$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $656e2c29cdd25871$var$G($656e2c29cdd25871$var$fj, $656e2c29cdd25871$var$gj);
            $656e2c29cdd25871$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $656e2c29cdd25871$var$G($656e2c29cdd25871$var$fj, $656e2c29cdd25871$var$gj), $656e2c29cdd25871$var$gj |= d;
    $656e2c29cdd25871$var$Yi(a, b, e, c);
    return b.child;
}
function $656e2c29cdd25871$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $656e2c29cdd25871$var$dj(a, b, c, d, e) {
    var f = $656e2c29cdd25871$var$Zf(c) ? $656e2c29cdd25871$var$Xf : $656e2c29cdd25871$var$H.current;
    f = $656e2c29cdd25871$var$Yf(b, f);
    $656e2c29cdd25871$var$Tg(b, e);
    c = $656e2c29cdd25871$var$Xh(a, b, c, d, f, e);
    d = $656e2c29cdd25871$var$bi();
    if (null !== a && !$656e2c29cdd25871$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $656e2c29cdd25871$var$$i(a, b, e);
    $656e2c29cdd25871$var$I && d && $656e2c29cdd25871$var$vg(b);
    b.flags |= 1;
    $656e2c29cdd25871$var$Yi(a, b, c, e);
    return b.child;
}
function $656e2c29cdd25871$var$ij(a, b, c, d, e) {
    if ($656e2c29cdd25871$var$Zf(c)) {
        var f = !0;
        $656e2c29cdd25871$var$cg(b);
    } else f = !1;
    $656e2c29cdd25871$var$Tg(b, e);
    if (null === b.stateNode) $656e2c29cdd25871$var$jj(a, b), $656e2c29cdd25871$var$ph(b, c, d), $656e2c29cdd25871$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $656e2c29cdd25871$var$Vg(l) : (l = $656e2c29cdd25871$var$Zf(c) ? $656e2c29cdd25871$var$Xf : $656e2c29cdd25871$var$H.current, l = $656e2c29cdd25871$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $656e2c29cdd25871$var$qh(b, g, d, l);
        $656e2c29cdd25871$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $656e2c29cdd25871$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $656e2c29cdd25871$var$Wf.current || $656e2c29cdd25871$var$$g ? ("function" === typeof m && ($656e2c29cdd25871$var$kh(b, c, m, d), k = b.memoizedState), (h = $656e2c29cdd25871$var$$g || $656e2c29cdd25871$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $656e2c29cdd25871$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $656e2c29cdd25871$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $656e2c29cdd25871$var$Vg(k) : (k = $656e2c29cdd25871$var$Zf(c) ? $656e2c29cdd25871$var$Xf : $656e2c29cdd25871$var$H.current, k = $656e2c29cdd25871$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $656e2c29cdd25871$var$qh(b, g, d, k);
        $656e2c29cdd25871$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $656e2c29cdd25871$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $656e2c29cdd25871$var$Wf.current || $656e2c29cdd25871$var$$g ? ("function" === typeof y && ($656e2c29cdd25871$var$kh(b, c, y, d), n = b.memoizedState), (l = $656e2c29cdd25871$var$$g || $656e2c29cdd25871$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $656e2c29cdd25871$var$kj(a, b, c, d, f, e);
}
function $656e2c29cdd25871$var$kj(a, b, c, d, e, f) {
    $656e2c29cdd25871$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $656e2c29cdd25871$var$dg(b, c, !1), $656e2c29cdd25871$var$$i(a, b, f);
    d = b.stateNode;
    $656e2c29cdd25871$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $656e2c29cdd25871$var$Bh(b, a.child, null, f), b.child = $656e2c29cdd25871$var$Bh(b, null, h, f)) : $656e2c29cdd25871$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $656e2c29cdd25871$var$dg(b, c, !0);
    return b.child;
}
function $656e2c29cdd25871$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $656e2c29cdd25871$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $656e2c29cdd25871$var$ag(a, b.context, !1);
    $656e2c29cdd25871$var$Ih(a, b.containerInfo);
}
function $656e2c29cdd25871$var$mj(a, b, c, d, e) {
    $656e2c29cdd25871$var$Ig();
    $656e2c29cdd25871$var$Jg(e);
    b.flags |= 256;
    $656e2c29cdd25871$var$Yi(a, b, c, d);
    return b.child;
}
var $656e2c29cdd25871$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $656e2c29cdd25871$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $656e2c29cdd25871$var$pj(a, b, c) {
    var d = b.pendingProps, e = $656e2c29cdd25871$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $656e2c29cdd25871$var$G($656e2c29cdd25871$var$M, e & 1);
    if (null === a) {
        $656e2c29cdd25871$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $656e2c29cdd25871$var$qj(g, d, 0, null), a = $656e2c29cdd25871$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $656e2c29cdd25871$var$oj(c), b.memoizedState = $656e2c29cdd25871$var$nj, a) : $656e2c29cdd25871$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $656e2c29cdd25871$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $656e2c29cdd25871$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $656e2c29cdd25871$var$wh(h, f) : (f = $656e2c29cdd25871$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $656e2c29cdd25871$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $656e2c29cdd25871$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $656e2c29cdd25871$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $656e2c29cdd25871$var$rj(a, b) {
    b = $656e2c29cdd25871$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $656e2c29cdd25871$var$tj(a, b, c, d) {
    null !== d && $656e2c29cdd25871$var$Jg(d);
    $656e2c29cdd25871$var$Bh(b, a.child, null, c);
    a = $656e2c29cdd25871$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $656e2c29cdd25871$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $656e2c29cdd25871$var$Li(Error($656e2c29cdd25871$var$p(422))), $656e2c29cdd25871$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $656e2c29cdd25871$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $656e2c29cdd25871$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $656e2c29cdd25871$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $656e2c29cdd25871$var$oj(g);
        b.memoizedState = $656e2c29cdd25871$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $656e2c29cdd25871$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($656e2c29cdd25871$var$p(419));
        d = $656e2c29cdd25871$var$Li(f, d, void 0);
        return $656e2c29cdd25871$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($656e2c29cdd25871$var$Ug || h) {
        d = $656e2c29cdd25871$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $656e2c29cdd25871$var$Zg(a, e), $656e2c29cdd25871$var$mh(d, a, e, -1));
        }
        $656e2c29cdd25871$var$uj();
        d = $656e2c29cdd25871$var$Li(Error($656e2c29cdd25871$var$p(421)));
        return $656e2c29cdd25871$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $656e2c29cdd25871$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $656e2c29cdd25871$var$yg = $656e2c29cdd25871$var$Lf(e.nextSibling);
    $656e2c29cdd25871$var$xg = b;
    $656e2c29cdd25871$var$I = !0;
    $656e2c29cdd25871$var$zg = null;
    null !== a && ($656e2c29cdd25871$var$og[$656e2c29cdd25871$var$pg++] = $656e2c29cdd25871$var$rg, $656e2c29cdd25871$var$og[$656e2c29cdd25871$var$pg++] = $656e2c29cdd25871$var$sg, $656e2c29cdd25871$var$og[$656e2c29cdd25871$var$pg++] = $656e2c29cdd25871$var$qg, $656e2c29cdd25871$var$rg = a.id, $656e2c29cdd25871$var$sg = a.overflow, $656e2c29cdd25871$var$qg = b);
    b = $656e2c29cdd25871$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $656e2c29cdd25871$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $656e2c29cdd25871$var$Sg(a.return, b, c);
}
function $656e2c29cdd25871$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $656e2c29cdd25871$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $656e2c29cdd25871$var$Yi(a, b, d.children, c);
    d = $656e2c29cdd25871$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $656e2c29cdd25871$var$wj(a, c, b);
            else if (19 === a.tag) $656e2c29cdd25871$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $656e2c29cdd25871$var$G($656e2c29cdd25871$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $656e2c29cdd25871$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $656e2c29cdd25871$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $656e2c29cdd25871$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $656e2c29cdd25871$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $656e2c29cdd25871$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $656e2c29cdd25871$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $656e2c29cdd25871$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $656e2c29cdd25871$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($656e2c29cdd25871$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $656e2c29cdd25871$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $656e2c29cdd25871$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $656e2c29cdd25871$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $656e2c29cdd25871$var$lj(b);
            $656e2c29cdd25871$var$Ig();
            break;
        case 5:
            $656e2c29cdd25871$var$Kh(b);
            break;
        case 1:
            $656e2c29cdd25871$var$Zf(b.type) && $656e2c29cdd25871$var$cg(b);
            break;
        case 4:
            $656e2c29cdd25871$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $656e2c29cdd25871$var$G($656e2c29cdd25871$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $656e2c29cdd25871$var$G($656e2c29cdd25871$var$M, $656e2c29cdd25871$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $656e2c29cdd25871$var$pj(a, b, c);
                $656e2c29cdd25871$var$G($656e2c29cdd25871$var$M, $656e2c29cdd25871$var$M.current & 1);
                a = $656e2c29cdd25871$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $656e2c29cdd25871$var$G($656e2c29cdd25871$var$M, $656e2c29cdd25871$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $656e2c29cdd25871$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $656e2c29cdd25871$var$G($656e2c29cdd25871$var$M, $656e2c29cdd25871$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $656e2c29cdd25871$var$ej(a, b, c);
    }
    return $656e2c29cdd25871$var$$i(a, b, c);
}
var $656e2c29cdd25871$var$Aj, $656e2c29cdd25871$var$Bj, $656e2c29cdd25871$var$Cj, $656e2c29cdd25871$var$Dj;
$656e2c29cdd25871$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$656e2c29cdd25871$var$Bj = function() {};
$656e2c29cdd25871$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $656e2c29cdd25871$var$Hh($656e2c29cdd25871$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $656e2c29cdd25871$var$Ya(a, e);
                d = $656e2c29cdd25871$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $656e2c29cdd25871$var$A({}, e, {
                    value: void 0
                });
                d = $656e2c29cdd25871$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $656e2c29cdd25871$var$gb(a, e);
                d = $656e2c29cdd25871$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $656e2c29cdd25871$var$Bf);
        }
        $656e2c29cdd25871$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($656e2c29cdd25871$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($656e2c29cdd25871$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $656e2c29cdd25871$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$656e2c29cdd25871$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $656e2c29cdd25871$var$Ej(a, b) {
    if (!$656e2c29cdd25871$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $656e2c29cdd25871$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $656e2c29cdd25871$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $656e2c29cdd25871$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $656e2c29cdd25871$var$S(b), null;
        case 1:
            return $656e2c29cdd25871$var$Zf(b.type) && $656e2c29cdd25871$var$$f(), $656e2c29cdd25871$var$S(b), null;
        case 3:
            d = b.stateNode;
            $656e2c29cdd25871$var$Jh();
            $656e2c29cdd25871$var$E($656e2c29cdd25871$var$Wf);
            $656e2c29cdd25871$var$E($656e2c29cdd25871$var$H);
            $656e2c29cdd25871$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $656e2c29cdd25871$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $656e2c29cdd25871$var$zg && ($656e2c29cdd25871$var$Gj($656e2c29cdd25871$var$zg), $656e2c29cdd25871$var$zg = null));
            $656e2c29cdd25871$var$Bj(a, b);
            $656e2c29cdd25871$var$S(b);
            return null;
        case 5:
            $656e2c29cdd25871$var$Lh(b);
            var e = $656e2c29cdd25871$var$Hh($656e2c29cdd25871$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $656e2c29cdd25871$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($656e2c29cdd25871$var$p(166));
                    $656e2c29cdd25871$var$S(b);
                    return null;
                }
                a = $656e2c29cdd25871$var$Hh($656e2c29cdd25871$var$Eh.current);
                if ($656e2c29cdd25871$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$656e2c29cdd25871$var$Of] = b;
                    d[$656e2c29cdd25871$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $656e2c29cdd25871$var$D("cancel", d);
                            $656e2c29cdd25871$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $656e2c29cdd25871$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $656e2c29cdd25871$var$lf.length; e++)$656e2c29cdd25871$var$D($656e2c29cdd25871$var$lf[e], d);
                            break;
                        case "source":
                            $656e2c29cdd25871$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $656e2c29cdd25871$var$D("error", d);
                            $656e2c29cdd25871$var$D("load", d);
                            break;
                        case "details":
                            $656e2c29cdd25871$var$D("toggle", d);
                            break;
                        case "input":
                            $656e2c29cdd25871$var$Za(d, f);
                            $656e2c29cdd25871$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $656e2c29cdd25871$var$D("invalid", d);
                            break;
                        case "textarea":
                            $656e2c29cdd25871$var$hb(d, f), $656e2c29cdd25871$var$D("invalid", d);
                    }
                    $656e2c29cdd25871$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $656e2c29cdd25871$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $656e2c29cdd25871$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $656e2c29cdd25871$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $656e2c29cdd25871$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $656e2c29cdd25871$var$Va(d);
                            $656e2c29cdd25871$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $656e2c29cdd25871$var$Va(d);
                            $656e2c29cdd25871$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $656e2c29cdd25871$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $656e2c29cdd25871$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$656e2c29cdd25871$var$Of] = b;
                    a[$656e2c29cdd25871$var$Pf] = d;
                    $656e2c29cdd25871$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $656e2c29cdd25871$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $656e2c29cdd25871$var$D("cancel", a);
                                $656e2c29cdd25871$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $656e2c29cdd25871$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $656e2c29cdd25871$var$lf.length; e++)$656e2c29cdd25871$var$D($656e2c29cdd25871$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $656e2c29cdd25871$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $656e2c29cdd25871$var$D("error", a);
                                $656e2c29cdd25871$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $656e2c29cdd25871$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $656e2c29cdd25871$var$Za(a, d);
                                e = $656e2c29cdd25871$var$Ya(a, d);
                                $656e2c29cdd25871$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $656e2c29cdd25871$var$A({}, d, {
                                    value: void 0
                                });
                                $656e2c29cdd25871$var$D("invalid", a);
                                break;
                            case "textarea":
                                $656e2c29cdd25871$var$hb(a, d);
                                e = $656e2c29cdd25871$var$gb(a, d);
                                $656e2c29cdd25871$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $656e2c29cdd25871$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $656e2c29cdd25871$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $656e2c29cdd25871$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $656e2c29cdd25871$var$ob(a, k) : "number" === typeof k && $656e2c29cdd25871$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($656e2c29cdd25871$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $656e2c29cdd25871$var$D("scroll", a) : null != k && $656e2c29cdd25871$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $656e2c29cdd25871$var$Va(a);
                                $656e2c29cdd25871$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $656e2c29cdd25871$var$Va(a);
                                $656e2c29cdd25871$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $656e2c29cdd25871$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $656e2c29cdd25871$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $656e2c29cdd25871$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $656e2c29cdd25871$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $656e2c29cdd25871$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $656e2c29cdd25871$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($656e2c29cdd25871$var$p(166));
                c = $656e2c29cdd25871$var$Hh($656e2c29cdd25871$var$Gh.current);
                $656e2c29cdd25871$var$Hh($656e2c29cdd25871$var$Eh.current);
                if ($656e2c29cdd25871$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$656e2c29cdd25871$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $656e2c29cdd25871$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $656e2c29cdd25871$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $656e2c29cdd25871$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$656e2c29cdd25871$var$Of] = b, b.stateNode = d;
            }
            $656e2c29cdd25871$var$S(b);
            return null;
        case 13:
            $656e2c29cdd25871$var$E($656e2c29cdd25871$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($656e2c29cdd25871$var$I && null !== $656e2c29cdd25871$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $656e2c29cdd25871$var$Hg(), $656e2c29cdd25871$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $656e2c29cdd25871$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($656e2c29cdd25871$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($656e2c29cdd25871$var$p(317));
                        f[$656e2c29cdd25871$var$Of] = b;
                    } else $656e2c29cdd25871$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $656e2c29cdd25871$var$S(b);
                    f = !1;
                } else null !== $656e2c29cdd25871$var$zg && ($656e2c29cdd25871$var$Gj($656e2c29cdd25871$var$zg), $656e2c29cdd25871$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($656e2c29cdd25871$var$M.current & 1) ? 0 === $656e2c29cdd25871$var$T && ($656e2c29cdd25871$var$T = 3) : $656e2c29cdd25871$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $656e2c29cdd25871$var$S(b);
            return null;
        case 4:
            return $656e2c29cdd25871$var$Jh(), $656e2c29cdd25871$var$Bj(a, b), null === a && $656e2c29cdd25871$var$sf(b.stateNode.containerInfo), $656e2c29cdd25871$var$S(b), null;
        case 10:
            return $656e2c29cdd25871$var$Rg(b.type._context), $656e2c29cdd25871$var$S(b), null;
        case 17:
            return $656e2c29cdd25871$var$Zf(b.type) && $656e2c29cdd25871$var$$f(), $656e2c29cdd25871$var$S(b), null;
        case 19:
            $656e2c29cdd25871$var$E($656e2c29cdd25871$var$M);
            f = b.memoizedState;
            if (null === f) return $656e2c29cdd25871$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $656e2c29cdd25871$var$Ej(f, !1);
                else {
                    if (0 !== $656e2c29cdd25871$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $656e2c29cdd25871$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $656e2c29cdd25871$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $656e2c29cdd25871$var$G($656e2c29cdd25871$var$M, $656e2c29cdd25871$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $656e2c29cdd25871$var$B() > $656e2c29cdd25871$var$Hj && (b.flags |= 128, d = !0, $656e2c29cdd25871$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $656e2c29cdd25871$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $656e2c29cdd25871$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$656e2c29cdd25871$var$I) return $656e2c29cdd25871$var$S(b), null;
                    } else 2 * $656e2c29cdd25871$var$B() - f.renderingStartTime > $656e2c29cdd25871$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $656e2c29cdd25871$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $656e2c29cdd25871$var$B(), b.sibling = null, c = $656e2c29cdd25871$var$M.current, $656e2c29cdd25871$var$G($656e2c29cdd25871$var$M, d ? c & 1 | 2 : c & 1), b;
            $656e2c29cdd25871$var$S(b);
            return null;
        case 22:
        case 23:
            return $656e2c29cdd25871$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($656e2c29cdd25871$var$gj & 1073741824) && ($656e2c29cdd25871$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $656e2c29cdd25871$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($656e2c29cdd25871$var$p(156, b.tag));
}
function $656e2c29cdd25871$var$Jj(a, b) {
    $656e2c29cdd25871$var$wg(b);
    switch(b.tag){
        case 1:
            return $656e2c29cdd25871$var$Zf(b.type) && $656e2c29cdd25871$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $656e2c29cdd25871$var$Jh(), $656e2c29cdd25871$var$E($656e2c29cdd25871$var$Wf), $656e2c29cdd25871$var$E($656e2c29cdd25871$var$H), $656e2c29cdd25871$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $656e2c29cdd25871$var$Lh(b), null;
        case 13:
            $656e2c29cdd25871$var$E($656e2c29cdd25871$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($656e2c29cdd25871$var$p(340));
                $656e2c29cdd25871$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $656e2c29cdd25871$var$E($656e2c29cdd25871$var$M), null;
        case 4:
            return $656e2c29cdd25871$var$Jh(), null;
        case 10:
            return $656e2c29cdd25871$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $656e2c29cdd25871$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $656e2c29cdd25871$var$Kj = !1, $656e2c29cdd25871$var$U = !1, $656e2c29cdd25871$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $656e2c29cdd25871$var$V = null;
function $656e2c29cdd25871$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $656e2c29cdd25871$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $656e2c29cdd25871$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $656e2c29cdd25871$var$W(a, b, d);
    }
}
var $656e2c29cdd25871$var$Oj = !1;
function $656e2c29cdd25871$var$Pj(a, b) {
    $656e2c29cdd25871$var$Cf = $656e2c29cdd25871$var$dd;
    a = $656e2c29cdd25871$var$Me();
    if ($656e2c29cdd25871$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $656e2c29cdd25871$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $656e2c29cdd25871$var$dd = !1;
    for($656e2c29cdd25871$var$V = b; null !== $656e2c29cdd25871$var$V;)if (b = $656e2c29cdd25871$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $656e2c29cdd25871$var$V = a;
    else for(; null !== $656e2c29cdd25871$var$V;){
        b = $656e2c29cdd25871$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $656e2c29cdd25871$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($656e2c29cdd25871$var$p(163));
            }
        } catch (F) {
            $656e2c29cdd25871$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $656e2c29cdd25871$var$V = a;
            break;
        }
        $656e2c29cdd25871$var$V = b.return;
    }
    n = $656e2c29cdd25871$var$Oj;
    $656e2c29cdd25871$var$Oj = !1;
    return n;
}
function $656e2c29cdd25871$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $656e2c29cdd25871$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $656e2c29cdd25871$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $656e2c29cdd25871$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $656e2c29cdd25871$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $656e2c29cdd25871$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$656e2c29cdd25871$var$Of], delete b[$656e2c29cdd25871$var$Pf], delete b[$656e2c29cdd25871$var$of], delete b[$656e2c29cdd25871$var$Qf], delete b[$656e2c29cdd25871$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $656e2c29cdd25871$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $656e2c29cdd25871$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $656e2c29cdd25871$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $656e2c29cdd25871$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $656e2c29cdd25871$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($656e2c29cdd25871$var$Wj(a, b, c), a = a.sibling; null !== a;)$656e2c29cdd25871$var$Wj(a, b, c), a = a.sibling;
}
function $656e2c29cdd25871$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($656e2c29cdd25871$var$Xj(a, b, c), a = a.sibling; null !== a;)$656e2c29cdd25871$var$Xj(a, b, c), a = a.sibling;
}
var $656e2c29cdd25871$var$X = null, $656e2c29cdd25871$var$Yj = !1;
function $656e2c29cdd25871$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$656e2c29cdd25871$var$ak(a, b, c), c = c.sibling;
}
function $656e2c29cdd25871$var$ak(a, b, c) {
    if ($656e2c29cdd25871$var$lc && "function" === typeof $656e2c29cdd25871$var$lc.onCommitFiberUnmount) try {
        $656e2c29cdd25871$var$lc.onCommitFiberUnmount($656e2c29cdd25871$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $656e2c29cdd25871$var$U || $656e2c29cdd25871$var$Mj(c, b);
        case 6:
            var d = $656e2c29cdd25871$var$X, e = $656e2c29cdd25871$var$Yj;
            $656e2c29cdd25871$var$X = null;
            $656e2c29cdd25871$var$Zj(a, b, c);
            $656e2c29cdd25871$var$X = d;
            $656e2c29cdd25871$var$Yj = e;
            null !== $656e2c29cdd25871$var$X && ($656e2c29cdd25871$var$Yj ? (a = $656e2c29cdd25871$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $656e2c29cdd25871$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $656e2c29cdd25871$var$X && ($656e2c29cdd25871$var$Yj ? (a = $656e2c29cdd25871$var$X, c = c.stateNode, 8 === a.nodeType ? $656e2c29cdd25871$var$Kf(a.parentNode, c) : 1 === a.nodeType && $656e2c29cdd25871$var$Kf(a, c), $656e2c29cdd25871$var$bd(a)) : $656e2c29cdd25871$var$Kf($656e2c29cdd25871$var$X, c.stateNode));
            break;
        case 4:
            d = $656e2c29cdd25871$var$X;
            e = $656e2c29cdd25871$var$Yj;
            $656e2c29cdd25871$var$X = c.stateNode.containerInfo;
            $656e2c29cdd25871$var$Yj = !0;
            $656e2c29cdd25871$var$Zj(a, b, c);
            $656e2c29cdd25871$var$X = d;
            $656e2c29cdd25871$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$656e2c29cdd25871$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $656e2c29cdd25871$var$Nj(c, b, g) : 0 !== (f & 4) && $656e2c29cdd25871$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $656e2c29cdd25871$var$Zj(a, b, c);
            break;
        case 1:
            if (!$656e2c29cdd25871$var$U && ($656e2c29cdd25871$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $656e2c29cdd25871$var$W(c, b, h);
            }
            $656e2c29cdd25871$var$Zj(a, b, c);
            break;
        case 21:
            $656e2c29cdd25871$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($656e2c29cdd25871$var$U = (d = $656e2c29cdd25871$var$U) || null !== c.memoizedState, $656e2c29cdd25871$var$Zj(a, b, c), $656e2c29cdd25871$var$U = d) : $656e2c29cdd25871$var$Zj(a, b, c);
            break;
        default:
            $656e2c29cdd25871$var$Zj(a, b, c);
    }
}
function $656e2c29cdd25871$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $656e2c29cdd25871$var$Lj);
        b.forEach(function(b) {
            var d = $656e2c29cdd25871$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $656e2c29cdd25871$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $656e2c29cdd25871$var$X = h.stateNode;
                        $656e2c29cdd25871$var$Yj = !1;
                        break a;
                    case 3:
                        $656e2c29cdd25871$var$X = h.stateNode.containerInfo;
                        $656e2c29cdd25871$var$Yj = !0;
                        break a;
                    case 4:
                        $656e2c29cdd25871$var$X = h.stateNode.containerInfo;
                        $656e2c29cdd25871$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $656e2c29cdd25871$var$X) throw Error($656e2c29cdd25871$var$p(160));
            $656e2c29cdd25871$var$ak(f, g, e);
            $656e2c29cdd25871$var$X = null;
            $656e2c29cdd25871$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $656e2c29cdd25871$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$656e2c29cdd25871$var$ek(b, a), b = b.sibling;
}
function $656e2c29cdd25871$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $656e2c29cdd25871$var$dk(b, a);
            $656e2c29cdd25871$var$fk(a);
            if (d & 4) {
                try {
                    $656e2c29cdd25871$var$Qj(3, a, a.return), $656e2c29cdd25871$var$Rj(3, a);
                } catch (t) {
                    $656e2c29cdd25871$var$W(a, a.return, t);
                }
                try {
                    $656e2c29cdd25871$var$Qj(5, a, a.return);
                } catch (t) {
                    $656e2c29cdd25871$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $656e2c29cdd25871$var$dk(b, a);
            $656e2c29cdd25871$var$fk(a);
            d & 512 && null !== c && $656e2c29cdd25871$var$Mj(c, c.return);
            break;
        case 5:
            $656e2c29cdd25871$var$dk(b, a);
            $656e2c29cdd25871$var$fk(a);
            d & 512 && null !== c && $656e2c29cdd25871$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $656e2c29cdd25871$var$ob(e, "");
                } catch (t) {
                    $656e2c29cdd25871$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $656e2c29cdd25871$var$ab(e, f);
                    $656e2c29cdd25871$var$vb(h, g);
                    var l = $656e2c29cdd25871$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $656e2c29cdd25871$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $656e2c29cdd25871$var$nb(e, q) : "children" === m ? $656e2c29cdd25871$var$ob(e, q) : $656e2c29cdd25871$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $656e2c29cdd25871$var$bb(e, f);
                            break;
                        case "textarea":
                            $656e2c29cdd25871$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $656e2c29cdd25871$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $656e2c29cdd25871$var$fb(e, !!f.multiple, f.defaultValue, !0) : $656e2c29cdd25871$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$656e2c29cdd25871$var$Pf] = f;
                } catch (t) {
                    $656e2c29cdd25871$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $656e2c29cdd25871$var$dk(b, a);
            $656e2c29cdd25871$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($656e2c29cdd25871$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $656e2c29cdd25871$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $656e2c29cdd25871$var$dk(b, a);
            $656e2c29cdd25871$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $656e2c29cdd25871$var$bd(b.containerInfo);
            } catch (t) {
                $656e2c29cdd25871$var$W(a, a.return, t);
            }
            break;
        case 4:
            $656e2c29cdd25871$var$dk(b, a);
            $656e2c29cdd25871$var$fk(a);
            break;
        case 13:
            $656e2c29cdd25871$var$dk(b, a);
            $656e2c29cdd25871$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($656e2c29cdd25871$var$gk = $656e2c29cdd25871$var$B()));
            d & 4 && $656e2c29cdd25871$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($656e2c29cdd25871$var$U = (l = $656e2c29cdd25871$var$U) || m, $656e2c29cdd25871$var$dk(b, a), $656e2c29cdd25871$var$U = l) : $656e2c29cdd25871$var$dk(b, a);
            $656e2c29cdd25871$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($656e2c29cdd25871$var$V = a, m = a.child; null !== m;){
                    for(q = $656e2c29cdd25871$var$V = m; null !== $656e2c29cdd25871$var$V;){
                        r = $656e2c29cdd25871$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $656e2c29cdd25871$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $656e2c29cdd25871$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $656e2c29cdd25871$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $656e2c29cdd25871$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $656e2c29cdd25871$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $656e2c29cdd25871$var$V = y) : $656e2c29cdd25871$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $656e2c29cdd25871$var$rb("display", g));
                            } catch (t) {
                                $656e2c29cdd25871$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $656e2c29cdd25871$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $656e2c29cdd25871$var$dk(b, a);
            $656e2c29cdd25871$var$fk(a);
            d & 4 && $656e2c29cdd25871$var$bk(a);
            break;
        case 21:
            break;
        default:
            $656e2c29cdd25871$var$dk(b, a), $656e2c29cdd25871$var$fk(a);
    }
}
function $656e2c29cdd25871$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($656e2c29cdd25871$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($656e2c29cdd25871$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($656e2c29cdd25871$var$ob(e, ""), d.flags &= -33);
                    var f = $656e2c29cdd25871$var$Vj(a);
                    $656e2c29cdd25871$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $656e2c29cdd25871$var$Vj(a);
                    $656e2c29cdd25871$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($656e2c29cdd25871$var$p(161));
            }
        } catch (k) {
            $656e2c29cdd25871$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $656e2c29cdd25871$var$ik(a, b, c) {
    $656e2c29cdd25871$var$V = a;
    $656e2c29cdd25871$var$jk(a, b, c);
}
function $656e2c29cdd25871$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $656e2c29cdd25871$var$V;){
        var e = $656e2c29cdd25871$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $656e2c29cdd25871$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $656e2c29cdd25871$var$U;
                h = $656e2c29cdd25871$var$Kj;
                var l = $656e2c29cdd25871$var$U;
                $656e2c29cdd25871$var$Kj = g;
                if (($656e2c29cdd25871$var$U = k) && !l) for($656e2c29cdd25871$var$V = e; null !== $656e2c29cdd25871$var$V;)g = $656e2c29cdd25871$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $656e2c29cdd25871$var$kk(e) : null !== k ? (k.return = g, $656e2c29cdd25871$var$V = k) : $656e2c29cdd25871$var$kk(e);
                for(; null !== f;)$656e2c29cdd25871$var$V = f, $656e2c29cdd25871$var$jk(f, b, c), f = f.sibling;
                $656e2c29cdd25871$var$V = e;
                $656e2c29cdd25871$var$Kj = h;
                $656e2c29cdd25871$var$U = l;
            }
            $656e2c29cdd25871$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $656e2c29cdd25871$var$V = f) : $656e2c29cdd25871$var$lk(a, b, c);
    }
}
function $656e2c29cdd25871$var$lk(a) {
    for(; null !== $656e2c29cdd25871$var$V;){
        var b = $656e2c29cdd25871$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $656e2c29cdd25871$var$U || $656e2c29cdd25871$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$656e2c29cdd25871$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $656e2c29cdd25871$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $656e2c29cdd25871$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $656e2c29cdd25871$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $656e2c29cdd25871$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($656e2c29cdd25871$var$p(163));
                }
                $656e2c29cdd25871$var$U || b.flags & 512 && $656e2c29cdd25871$var$Sj(b);
            } catch (r) {
                $656e2c29cdd25871$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $656e2c29cdd25871$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $656e2c29cdd25871$var$V = c;
            break;
        }
        $656e2c29cdd25871$var$V = b.return;
    }
}
function $656e2c29cdd25871$var$hk(a) {
    for(; null !== $656e2c29cdd25871$var$V;){
        var b = $656e2c29cdd25871$var$V;
        if (b === a) {
            $656e2c29cdd25871$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $656e2c29cdd25871$var$V = c;
            break;
        }
        $656e2c29cdd25871$var$V = b.return;
    }
}
function $656e2c29cdd25871$var$kk(a) {
    for(; null !== $656e2c29cdd25871$var$V;){
        var b = $656e2c29cdd25871$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $656e2c29cdd25871$var$Rj(4, b);
                    } catch (k) {
                        $656e2c29cdd25871$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $656e2c29cdd25871$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $656e2c29cdd25871$var$Sj(b);
                    } catch (k) {
                        $656e2c29cdd25871$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $656e2c29cdd25871$var$Sj(b);
                    } catch (k) {
                        $656e2c29cdd25871$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $656e2c29cdd25871$var$W(b, b.return, k);
        }
        if (b === a) {
            $656e2c29cdd25871$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $656e2c29cdd25871$var$V = h;
            break;
        }
        $656e2c29cdd25871$var$V = b.return;
    }
}
var $656e2c29cdd25871$var$mk = Math.ceil, $656e2c29cdd25871$var$nk = $656e2c29cdd25871$var$ua.ReactCurrentDispatcher, $656e2c29cdd25871$var$ok = $656e2c29cdd25871$var$ua.ReactCurrentOwner, $656e2c29cdd25871$var$pk = $656e2c29cdd25871$var$ua.ReactCurrentBatchConfig, $656e2c29cdd25871$var$K = 0, $656e2c29cdd25871$var$R = null, $656e2c29cdd25871$var$Y = null, $656e2c29cdd25871$var$Z = 0, $656e2c29cdd25871$var$gj = 0, $656e2c29cdd25871$var$fj = $656e2c29cdd25871$var$Uf(0), $656e2c29cdd25871$var$T = 0, $656e2c29cdd25871$var$qk = null, $656e2c29cdd25871$var$hh = 0, $656e2c29cdd25871$var$rk = 0, $656e2c29cdd25871$var$sk = 0, $656e2c29cdd25871$var$tk = null, $656e2c29cdd25871$var$uk = null, $656e2c29cdd25871$var$gk = 0, $656e2c29cdd25871$var$Hj = Infinity, $656e2c29cdd25871$var$vk = null, $656e2c29cdd25871$var$Pi = !1, $656e2c29cdd25871$var$Qi = null, $656e2c29cdd25871$var$Si = null, $656e2c29cdd25871$var$wk = !1, $656e2c29cdd25871$var$xk = null, $656e2c29cdd25871$var$yk = 0, $656e2c29cdd25871$var$zk = 0, $656e2c29cdd25871$var$Ak = null, $656e2c29cdd25871$var$Bk = -1, $656e2c29cdd25871$var$Ck = 0;
function $656e2c29cdd25871$var$L() {
    return 0 !== ($656e2c29cdd25871$var$K & 6) ? $656e2c29cdd25871$var$B() : -1 !== $656e2c29cdd25871$var$Bk ? $656e2c29cdd25871$var$Bk : $656e2c29cdd25871$var$Bk = $656e2c29cdd25871$var$B();
}
function $656e2c29cdd25871$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($656e2c29cdd25871$var$K & 2) && 0 !== $656e2c29cdd25871$var$Z) return $656e2c29cdd25871$var$Z & -$656e2c29cdd25871$var$Z;
    if (null !== $656e2c29cdd25871$var$Kg.transition) return 0 === $656e2c29cdd25871$var$Ck && ($656e2c29cdd25871$var$Ck = $656e2c29cdd25871$var$yc()), $656e2c29cdd25871$var$Ck;
    a = $656e2c29cdd25871$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $656e2c29cdd25871$var$jd(a.type);
    return a;
}
function $656e2c29cdd25871$var$mh(a, b, c, d) {
    if (50 < $656e2c29cdd25871$var$zk) throw $656e2c29cdd25871$var$zk = 0, $656e2c29cdd25871$var$Ak = null, Error($656e2c29cdd25871$var$p(185));
    $656e2c29cdd25871$var$Ac(a, c, d);
    if (0 === ($656e2c29cdd25871$var$K & 2) || a !== $656e2c29cdd25871$var$R) a === $656e2c29cdd25871$var$R && (0 === ($656e2c29cdd25871$var$K & 2) && ($656e2c29cdd25871$var$rk |= c), 4 === $656e2c29cdd25871$var$T && $656e2c29cdd25871$var$Dk(a, $656e2c29cdd25871$var$Z)), $656e2c29cdd25871$var$Ek(a, d), 1 === c && 0 === $656e2c29cdd25871$var$K && 0 === (b.mode & 1) && ($656e2c29cdd25871$var$Hj = $656e2c29cdd25871$var$B() + 500, $656e2c29cdd25871$var$fg && $656e2c29cdd25871$var$jg());
}
function $656e2c29cdd25871$var$Ek(a, b) {
    var c = a.callbackNode;
    $656e2c29cdd25871$var$wc(a, b);
    var d = $656e2c29cdd25871$var$uc(a, a === $656e2c29cdd25871$var$R ? $656e2c29cdd25871$var$Z : 0);
    if (0 === d) null !== c && $656e2c29cdd25871$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $656e2c29cdd25871$var$bc(c);
        if (1 === b) 0 === a.tag ? $656e2c29cdd25871$var$ig($656e2c29cdd25871$var$Fk.bind(null, a)) : $656e2c29cdd25871$var$hg($656e2c29cdd25871$var$Fk.bind(null, a)), $656e2c29cdd25871$var$Jf(function() {
            0 === ($656e2c29cdd25871$var$K & 6) && $656e2c29cdd25871$var$jg();
        }), c = null;
        else {
            switch($656e2c29cdd25871$var$Dc(d)){
                case 1:
                    c = $656e2c29cdd25871$var$fc;
                    break;
                case 4:
                    c = $656e2c29cdd25871$var$gc;
                    break;
                case 16:
                    c = $656e2c29cdd25871$var$hc;
                    break;
                case 536870912:
                    c = $656e2c29cdd25871$var$jc;
                    break;
                default:
                    c = $656e2c29cdd25871$var$hc;
            }
            c = $656e2c29cdd25871$var$Gk(c, $656e2c29cdd25871$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $656e2c29cdd25871$var$Hk(a, b) {
    $656e2c29cdd25871$var$Bk = -1;
    $656e2c29cdd25871$var$Ck = 0;
    if (0 !== ($656e2c29cdd25871$var$K & 6)) throw Error($656e2c29cdd25871$var$p(327));
    var c = a.callbackNode;
    if ($656e2c29cdd25871$var$Ik() && a.callbackNode !== c) return null;
    var d = $656e2c29cdd25871$var$uc(a, a === $656e2c29cdd25871$var$R ? $656e2c29cdd25871$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $656e2c29cdd25871$var$Jk(a, d);
    else {
        b = d;
        var e = $656e2c29cdd25871$var$K;
        $656e2c29cdd25871$var$K |= 2;
        var f = $656e2c29cdd25871$var$Kk();
        if ($656e2c29cdd25871$var$R !== a || $656e2c29cdd25871$var$Z !== b) $656e2c29cdd25871$var$vk = null, $656e2c29cdd25871$var$Hj = $656e2c29cdd25871$var$B() + 500, $656e2c29cdd25871$var$Lk(a, b);
        for(;;)try {
            $656e2c29cdd25871$var$Mk();
            break;
        } catch (h) {
            $656e2c29cdd25871$var$Nk(a, h);
        }
        $656e2c29cdd25871$var$Qg();
        $656e2c29cdd25871$var$nk.current = f;
        $656e2c29cdd25871$var$K = e;
        null !== $656e2c29cdd25871$var$Y ? b = 0 : ($656e2c29cdd25871$var$R = null, $656e2c29cdd25871$var$Z = 0, b = $656e2c29cdd25871$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $656e2c29cdd25871$var$xc(a), 0 !== e && (d = e, b = $656e2c29cdd25871$var$Ok(a, e)));
        if (1 === b) throw c = $656e2c29cdd25871$var$qk, $656e2c29cdd25871$var$Lk(a, 0), $656e2c29cdd25871$var$Dk(a, d), $656e2c29cdd25871$var$Ek(a, $656e2c29cdd25871$var$B()), c;
        if (6 === b) $656e2c29cdd25871$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$656e2c29cdd25871$var$Pk(e) && (b = $656e2c29cdd25871$var$Jk(a, d), 2 === b && (f = $656e2c29cdd25871$var$xc(a), 0 !== f && (d = f, b = $656e2c29cdd25871$var$Ok(a, f))), 1 === b)) throw c = $656e2c29cdd25871$var$qk, $656e2c29cdd25871$var$Lk(a, 0), $656e2c29cdd25871$var$Dk(a, d), $656e2c29cdd25871$var$Ek(a, $656e2c29cdd25871$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($656e2c29cdd25871$var$p(345));
                case 2:
                    $656e2c29cdd25871$var$Qk(a, $656e2c29cdd25871$var$uk, $656e2c29cdd25871$var$vk);
                    break;
                case 3:
                    $656e2c29cdd25871$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $656e2c29cdd25871$var$gk + 500 - $656e2c29cdd25871$var$B(), 10 < b)) {
                        if (0 !== $656e2c29cdd25871$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $656e2c29cdd25871$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $656e2c29cdd25871$var$Ff($656e2c29cdd25871$var$Qk.bind(null, a, $656e2c29cdd25871$var$uk, $656e2c29cdd25871$var$vk), b);
                        break;
                    }
                    $656e2c29cdd25871$var$Qk(a, $656e2c29cdd25871$var$uk, $656e2c29cdd25871$var$vk);
                    break;
                case 4:
                    $656e2c29cdd25871$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $656e2c29cdd25871$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $656e2c29cdd25871$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $656e2c29cdd25871$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $656e2c29cdd25871$var$Ff($656e2c29cdd25871$var$Qk.bind(null, a, $656e2c29cdd25871$var$uk, $656e2c29cdd25871$var$vk), d);
                        break;
                    }
                    $656e2c29cdd25871$var$Qk(a, $656e2c29cdd25871$var$uk, $656e2c29cdd25871$var$vk);
                    break;
                case 5:
                    $656e2c29cdd25871$var$Qk(a, $656e2c29cdd25871$var$uk, $656e2c29cdd25871$var$vk);
                    break;
                default:
                    throw Error($656e2c29cdd25871$var$p(329));
            }
        }
    }
    $656e2c29cdd25871$var$Ek(a, $656e2c29cdd25871$var$B());
    return a.callbackNode === c ? $656e2c29cdd25871$var$Hk.bind(null, a) : null;
}
function $656e2c29cdd25871$var$Ok(a, b) {
    var c = $656e2c29cdd25871$var$tk;
    a.current.memoizedState.isDehydrated && ($656e2c29cdd25871$var$Lk(a, b).flags |= 256);
    a = $656e2c29cdd25871$var$Jk(a, b);
    2 !== a && (b = $656e2c29cdd25871$var$uk, $656e2c29cdd25871$var$uk = c, null !== b && $656e2c29cdd25871$var$Gj(b));
    return a;
}
function $656e2c29cdd25871$var$Gj(a) {
    null === $656e2c29cdd25871$var$uk ? $656e2c29cdd25871$var$uk = a : $656e2c29cdd25871$var$uk.push.apply($656e2c29cdd25871$var$uk, a);
}
function $656e2c29cdd25871$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$656e2c29cdd25871$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $656e2c29cdd25871$var$Dk(a, b) {
    b &= ~$656e2c29cdd25871$var$sk;
    b &= ~$656e2c29cdd25871$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $656e2c29cdd25871$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $656e2c29cdd25871$var$Fk(a) {
    if (0 !== ($656e2c29cdd25871$var$K & 6)) throw Error($656e2c29cdd25871$var$p(327));
    $656e2c29cdd25871$var$Ik();
    var b = $656e2c29cdd25871$var$uc(a, 0);
    if (0 === (b & 1)) return $656e2c29cdd25871$var$Ek(a, $656e2c29cdd25871$var$B()), null;
    var c = $656e2c29cdd25871$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $656e2c29cdd25871$var$xc(a);
        0 !== d && (b = d, c = $656e2c29cdd25871$var$Ok(a, d));
    }
    if (1 === c) throw c = $656e2c29cdd25871$var$qk, $656e2c29cdd25871$var$Lk(a, 0), $656e2c29cdd25871$var$Dk(a, b), $656e2c29cdd25871$var$Ek(a, $656e2c29cdd25871$var$B()), c;
    if (6 === c) throw Error($656e2c29cdd25871$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $656e2c29cdd25871$var$Qk(a, $656e2c29cdd25871$var$uk, $656e2c29cdd25871$var$vk);
    $656e2c29cdd25871$var$Ek(a, $656e2c29cdd25871$var$B());
    return null;
}
function $656e2c29cdd25871$var$Rk(a, b) {
    var c = $656e2c29cdd25871$var$K;
    $656e2c29cdd25871$var$K |= 1;
    try {
        return a(b);
    } finally{
        $656e2c29cdd25871$var$K = c, 0 === $656e2c29cdd25871$var$K && ($656e2c29cdd25871$var$Hj = $656e2c29cdd25871$var$B() + 500, $656e2c29cdd25871$var$fg && $656e2c29cdd25871$var$jg());
    }
}
function $656e2c29cdd25871$var$Sk(a) {
    null !== $656e2c29cdd25871$var$xk && 0 === $656e2c29cdd25871$var$xk.tag && 0 === ($656e2c29cdd25871$var$K & 6) && $656e2c29cdd25871$var$Ik();
    var b = $656e2c29cdd25871$var$K;
    $656e2c29cdd25871$var$K |= 1;
    var c = $656e2c29cdd25871$var$pk.transition, d = $656e2c29cdd25871$var$C;
    try {
        if ($656e2c29cdd25871$var$pk.transition = null, $656e2c29cdd25871$var$C = 1, a) return a();
    } finally{
        $656e2c29cdd25871$var$C = d, $656e2c29cdd25871$var$pk.transition = c, $656e2c29cdd25871$var$K = b, 0 === ($656e2c29cdd25871$var$K & 6) && $656e2c29cdd25871$var$jg();
    }
}
function $656e2c29cdd25871$var$Ij() {
    $656e2c29cdd25871$var$gj = $656e2c29cdd25871$var$fj.current;
    $656e2c29cdd25871$var$E($656e2c29cdd25871$var$fj);
}
function $656e2c29cdd25871$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $656e2c29cdd25871$var$Gf(c));
    if (null !== $656e2c29cdd25871$var$Y) for(c = $656e2c29cdd25871$var$Y.return; null !== c;){
        var d = c;
        $656e2c29cdd25871$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $656e2c29cdd25871$var$$f();
                break;
            case 3:
                $656e2c29cdd25871$var$Jh();
                $656e2c29cdd25871$var$E($656e2c29cdd25871$var$Wf);
                $656e2c29cdd25871$var$E($656e2c29cdd25871$var$H);
                $656e2c29cdd25871$var$Oh();
                break;
            case 5:
                $656e2c29cdd25871$var$Lh(d);
                break;
            case 4:
                $656e2c29cdd25871$var$Jh();
                break;
            case 13:
                $656e2c29cdd25871$var$E($656e2c29cdd25871$var$M);
                break;
            case 19:
                $656e2c29cdd25871$var$E($656e2c29cdd25871$var$M);
                break;
            case 10:
                $656e2c29cdd25871$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $656e2c29cdd25871$var$Ij();
        }
        c = c.return;
    }
    $656e2c29cdd25871$var$R = a;
    $656e2c29cdd25871$var$Y = a = $656e2c29cdd25871$var$wh(a.current, null);
    $656e2c29cdd25871$var$Z = $656e2c29cdd25871$var$gj = b;
    $656e2c29cdd25871$var$T = 0;
    $656e2c29cdd25871$var$qk = null;
    $656e2c29cdd25871$var$sk = $656e2c29cdd25871$var$rk = $656e2c29cdd25871$var$hh = 0;
    $656e2c29cdd25871$var$uk = $656e2c29cdd25871$var$tk = null;
    if (null !== $656e2c29cdd25871$var$Wg) {
        for(b = 0; b < $656e2c29cdd25871$var$Wg.length; b++)if (c = $656e2c29cdd25871$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $656e2c29cdd25871$var$Wg = null;
    }
    return a;
}
function $656e2c29cdd25871$var$Nk(a, b) {
    do {
        var c = $656e2c29cdd25871$var$Y;
        try {
            $656e2c29cdd25871$var$Qg();
            $656e2c29cdd25871$var$Ph.current = $656e2c29cdd25871$var$ai;
            if ($656e2c29cdd25871$var$Sh) {
                for(var d = $656e2c29cdd25871$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $656e2c29cdd25871$var$Sh = !1;
            }
            $656e2c29cdd25871$var$Rh = 0;
            $656e2c29cdd25871$var$P = $656e2c29cdd25871$var$O = $656e2c29cdd25871$var$N = null;
            $656e2c29cdd25871$var$Th = !1;
            $656e2c29cdd25871$var$Uh = 0;
            $656e2c29cdd25871$var$ok.current = null;
            if (null === c || null === c.return) {
                $656e2c29cdd25871$var$T = 1;
                $656e2c29cdd25871$var$qk = b;
                $656e2c29cdd25871$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $656e2c29cdd25871$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $656e2c29cdd25871$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $656e2c29cdd25871$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $656e2c29cdd25871$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $656e2c29cdd25871$var$Ti(f, l, b);
                            $656e2c29cdd25871$var$uj();
                            break a;
                        }
                        k = Error($656e2c29cdd25871$var$p(426));
                    }
                } else if ($656e2c29cdd25871$var$I && h.mode & 1) {
                    var J = $656e2c29cdd25871$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $656e2c29cdd25871$var$Wi(J, g, h, f, b);
                        $656e2c29cdd25871$var$Jg($656e2c29cdd25871$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $656e2c29cdd25871$var$Ki(k, h);
                4 !== $656e2c29cdd25871$var$T && ($656e2c29cdd25871$var$T = 2);
                null === $656e2c29cdd25871$var$tk ? $656e2c29cdd25871$var$tk = [
                    f
                ] : $656e2c29cdd25871$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $656e2c29cdd25871$var$Oi(f, k, b);
                            $656e2c29cdd25871$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $656e2c29cdd25871$var$Si || !$656e2c29cdd25871$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $656e2c29cdd25871$var$Ri(f, h, b);
                                $656e2c29cdd25871$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $656e2c29cdd25871$var$Tk(c);
        } catch (na) {
            b = na;
            $656e2c29cdd25871$var$Y === c && null !== c && ($656e2c29cdd25871$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $656e2c29cdd25871$var$Kk() {
    var a = $656e2c29cdd25871$var$nk.current;
    $656e2c29cdd25871$var$nk.current = $656e2c29cdd25871$var$ai;
    return null === a ? $656e2c29cdd25871$var$ai : a;
}
function $656e2c29cdd25871$var$uj() {
    if (0 === $656e2c29cdd25871$var$T || 3 === $656e2c29cdd25871$var$T || 2 === $656e2c29cdd25871$var$T) $656e2c29cdd25871$var$T = 4;
    null === $656e2c29cdd25871$var$R || 0 === ($656e2c29cdd25871$var$hh & 268435455) && 0 === ($656e2c29cdd25871$var$rk & 268435455) || $656e2c29cdd25871$var$Dk($656e2c29cdd25871$var$R, $656e2c29cdd25871$var$Z);
}
function $656e2c29cdd25871$var$Jk(a, b) {
    var c = $656e2c29cdd25871$var$K;
    $656e2c29cdd25871$var$K |= 2;
    var d = $656e2c29cdd25871$var$Kk();
    if ($656e2c29cdd25871$var$R !== a || $656e2c29cdd25871$var$Z !== b) $656e2c29cdd25871$var$vk = null, $656e2c29cdd25871$var$Lk(a, b);
    for(;;)try {
        $656e2c29cdd25871$var$Uk();
        break;
    } catch (e) {
        $656e2c29cdd25871$var$Nk(a, e);
    }
    $656e2c29cdd25871$var$Qg();
    $656e2c29cdd25871$var$K = c;
    $656e2c29cdd25871$var$nk.current = d;
    if (null !== $656e2c29cdd25871$var$Y) throw Error($656e2c29cdd25871$var$p(261));
    $656e2c29cdd25871$var$R = null;
    $656e2c29cdd25871$var$Z = 0;
    return $656e2c29cdd25871$var$T;
}
function $656e2c29cdd25871$var$Uk() {
    for(; null !== $656e2c29cdd25871$var$Y;)$656e2c29cdd25871$var$Vk($656e2c29cdd25871$var$Y);
}
function $656e2c29cdd25871$var$Mk() {
    for(; null !== $656e2c29cdd25871$var$Y && !$656e2c29cdd25871$var$cc();)$656e2c29cdd25871$var$Vk($656e2c29cdd25871$var$Y);
}
function $656e2c29cdd25871$var$Vk(a) {
    var b = $656e2c29cdd25871$var$Wk(a.alternate, a, $656e2c29cdd25871$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $656e2c29cdd25871$var$Tk(a) : $656e2c29cdd25871$var$Y = b;
    $656e2c29cdd25871$var$ok.current = null;
}
function $656e2c29cdd25871$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $656e2c29cdd25871$var$Fj(c, b, $656e2c29cdd25871$var$gj), null !== c) {
                $656e2c29cdd25871$var$Y = c;
                return;
            }
        } else {
            c = $656e2c29cdd25871$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $656e2c29cdd25871$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $656e2c29cdd25871$var$T = 6;
                $656e2c29cdd25871$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $656e2c29cdd25871$var$Y = b;
            return;
        }
        $656e2c29cdd25871$var$Y = b = a;
    }while (null !== b);
    0 === $656e2c29cdd25871$var$T && ($656e2c29cdd25871$var$T = 5);
}
function $656e2c29cdd25871$var$Qk(a, b, c) {
    var d = $656e2c29cdd25871$var$C, e = $656e2c29cdd25871$var$pk.transition;
    try {
        $656e2c29cdd25871$var$pk.transition = null, $656e2c29cdd25871$var$C = 1, $656e2c29cdd25871$var$Xk(a, b, c, d);
    } finally{
        $656e2c29cdd25871$var$pk.transition = e, $656e2c29cdd25871$var$C = d;
    }
    return null;
}
function $656e2c29cdd25871$var$Xk(a, b, c, d) {
    do $656e2c29cdd25871$var$Ik();
    while (null !== $656e2c29cdd25871$var$xk);
    if (0 !== ($656e2c29cdd25871$var$K & 6)) throw Error($656e2c29cdd25871$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($656e2c29cdd25871$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $656e2c29cdd25871$var$Bc(a, f);
    a === $656e2c29cdd25871$var$R && ($656e2c29cdd25871$var$Y = $656e2c29cdd25871$var$R = null, $656e2c29cdd25871$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $656e2c29cdd25871$var$wk || ($656e2c29cdd25871$var$wk = !0, $656e2c29cdd25871$var$Gk($656e2c29cdd25871$var$hc, function() {
        $656e2c29cdd25871$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $656e2c29cdd25871$var$pk.transition;
        $656e2c29cdd25871$var$pk.transition = null;
        var g = $656e2c29cdd25871$var$C;
        $656e2c29cdd25871$var$C = 1;
        var h = $656e2c29cdd25871$var$K;
        $656e2c29cdd25871$var$K |= 4;
        $656e2c29cdd25871$var$ok.current = null;
        $656e2c29cdd25871$var$Pj(a, c);
        $656e2c29cdd25871$var$ek(c, a);
        $656e2c29cdd25871$var$Oe($656e2c29cdd25871$var$Df);
        $656e2c29cdd25871$var$dd = !!$656e2c29cdd25871$var$Cf;
        $656e2c29cdd25871$var$Df = $656e2c29cdd25871$var$Cf = null;
        a.current = c;
        $656e2c29cdd25871$var$ik(c, a, e);
        $656e2c29cdd25871$var$dc();
        $656e2c29cdd25871$var$K = h;
        $656e2c29cdd25871$var$C = g;
        $656e2c29cdd25871$var$pk.transition = f;
    } else a.current = c;
    $656e2c29cdd25871$var$wk && ($656e2c29cdd25871$var$wk = !1, $656e2c29cdd25871$var$xk = a, $656e2c29cdd25871$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($656e2c29cdd25871$var$Si = null);
    $656e2c29cdd25871$var$mc(c.stateNode, d);
    $656e2c29cdd25871$var$Ek(a, $656e2c29cdd25871$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($656e2c29cdd25871$var$Pi) throw $656e2c29cdd25871$var$Pi = !1, a = $656e2c29cdd25871$var$Qi, $656e2c29cdd25871$var$Qi = null, a;
    0 !== ($656e2c29cdd25871$var$yk & 1) && 0 !== a.tag && $656e2c29cdd25871$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $656e2c29cdd25871$var$Ak ? $656e2c29cdd25871$var$zk++ : ($656e2c29cdd25871$var$zk = 0, $656e2c29cdd25871$var$Ak = a) : $656e2c29cdd25871$var$zk = 0;
    $656e2c29cdd25871$var$jg();
    return null;
}
function $656e2c29cdd25871$var$Ik() {
    if (null !== $656e2c29cdd25871$var$xk) {
        var a = $656e2c29cdd25871$var$Dc($656e2c29cdd25871$var$yk), b = $656e2c29cdd25871$var$pk.transition, c = $656e2c29cdd25871$var$C;
        try {
            $656e2c29cdd25871$var$pk.transition = null;
            $656e2c29cdd25871$var$C = 16 > a ? 16 : a;
            if (null === $656e2c29cdd25871$var$xk) var d = !1;
            else {
                a = $656e2c29cdd25871$var$xk;
                $656e2c29cdd25871$var$xk = null;
                $656e2c29cdd25871$var$yk = 0;
                if (0 !== ($656e2c29cdd25871$var$K & 6)) throw Error($656e2c29cdd25871$var$p(331));
                var e = $656e2c29cdd25871$var$K;
                $656e2c29cdd25871$var$K |= 4;
                for($656e2c29cdd25871$var$V = a.current; null !== $656e2c29cdd25871$var$V;){
                    var f = $656e2c29cdd25871$var$V, g = f.child;
                    if (0 !== ($656e2c29cdd25871$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($656e2c29cdd25871$var$V = l; null !== $656e2c29cdd25871$var$V;){
                                    var m = $656e2c29cdd25871$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $656e2c29cdd25871$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $656e2c29cdd25871$var$V = q;
                                    else for(; null !== $656e2c29cdd25871$var$V;){
                                        m = $656e2c29cdd25871$var$V;
                                        var r = m.sibling, y = m.return;
                                        $656e2c29cdd25871$var$Tj(m);
                                        if (m === l) {
                                            $656e2c29cdd25871$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $656e2c29cdd25871$var$V = r;
                                            break;
                                        }
                                        $656e2c29cdd25871$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $656e2c29cdd25871$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $656e2c29cdd25871$var$V = g;
                    else b: for(; null !== $656e2c29cdd25871$var$V;){
                        f = $656e2c29cdd25871$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $656e2c29cdd25871$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $656e2c29cdd25871$var$V = x;
                            break b;
                        }
                        $656e2c29cdd25871$var$V = f.return;
                    }
                }
                var w = a.current;
                for($656e2c29cdd25871$var$V = w; null !== $656e2c29cdd25871$var$V;){
                    g = $656e2c29cdd25871$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $656e2c29cdd25871$var$V = u;
                    else b: for(g = w; null !== $656e2c29cdd25871$var$V;){
                        h = $656e2c29cdd25871$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $656e2c29cdd25871$var$Rj(9, h);
                            }
                        } catch (na) {
                            $656e2c29cdd25871$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $656e2c29cdd25871$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $656e2c29cdd25871$var$V = F;
                            break b;
                        }
                        $656e2c29cdd25871$var$V = h.return;
                    }
                }
                $656e2c29cdd25871$var$K = e;
                $656e2c29cdd25871$var$jg();
                if ($656e2c29cdd25871$var$lc && "function" === typeof $656e2c29cdd25871$var$lc.onPostCommitFiberRoot) try {
                    $656e2c29cdd25871$var$lc.onPostCommitFiberRoot($656e2c29cdd25871$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $656e2c29cdd25871$var$C = c, $656e2c29cdd25871$var$pk.transition = b;
        }
    }
    return !1;
}
function $656e2c29cdd25871$var$Yk(a, b, c) {
    b = $656e2c29cdd25871$var$Ki(c, b);
    b = $656e2c29cdd25871$var$Oi(a, b, 1);
    a = $656e2c29cdd25871$var$dh(a, b, 1);
    b = $656e2c29cdd25871$var$L();
    null !== a && ($656e2c29cdd25871$var$Ac(a, 1, b), $656e2c29cdd25871$var$Ek(a, b));
}
function $656e2c29cdd25871$var$W(a, b, c) {
    if (3 === a.tag) $656e2c29cdd25871$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $656e2c29cdd25871$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $656e2c29cdd25871$var$Si || !$656e2c29cdd25871$var$Si.has(d))) {
                a = $656e2c29cdd25871$var$Ki(c, a);
                a = $656e2c29cdd25871$var$Ri(b, a, 1);
                b = $656e2c29cdd25871$var$dh(b, a, 1);
                a = $656e2c29cdd25871$var$L();
                null !== b && ($656e2c29cdd25871$var$Ac(b, 1, a), $656e2c29cdd25871$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $656e2c29cdd25871$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $656e2c29cdd25871$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $656e2c29cdd25871$var$R === a && ($656e2c29cdd25871$var$Z & c) === c && (4 === $656e2c29cdd25871$var$T || 3 === $656e2c29cdd25871$var$T && ($656e2c29cdd25871$var$Z & 130023424) === $656e2c29cdd25871$var$Z && 500 > $656e2c29cdd25871$var$B() - $656e2c29cdd25871$var$gk ? $656e2c29cdd25871$var$Lk(a, 0) : $656e2c29cdd25871$var$sk |= c);
    $656e2c29cdd25871$var$Ek(a, b);
}
function $656e2c29cdd25871$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $656e2c29cdd25871$var$sc, $656e2c29cdd25871$var$sc <<= 1, 0 === ($656e2c29cdd25871$var$sc & 130023424) && ($656e2c29cdd25871$var$sc = 4194304)));
    var c = $656e2c29cdd25871$var$L();
    a = $656e2c29cdd25871$var$Zg(a, b);
    null !== a && ($656e2c29cdd25871$var$Ac(a, b, c), $656e2c29cdd25871$var$Ek(a, c));
}
function $656e2c29cdd25871$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $656e2c29cdd25871$var$Zk(a, c);
}
function $656e2c29cdd25871$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($656e2c29cdd25871$var$p(314));
    }
    null !== d && d.delete(b);
    $656e2c29cdd25871$var$Zk(a, c);
}
var $656e2c29cdd25871$var$Wk;
$656e2c29cdd25871$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $656e2c29cdd25871$var$Wf.current) $656e2c29cdd25871$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $656e2c29cdd25871$var$Ug = !1, $656e2c29cdd25871$var$zj(a, b, c);
            $656e2c29cdd25871$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $656e2c29cdd25871$var$Ug = !1, $656e2c29cdd25871$var$I && 0 !== (b.flags & 1048576) && $656e2c29cdd25871$var$ug(b, $656e2c29cdd25871$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $656e2c29cdd25871$var$jj(a, b);
            a = b.pendingProps;
            var e = $656e2c29cdd25871$var$Yf(b, $656e2c29cdd25871$var$H.current);
            $656e2c29cdd25871$var$Tg(b, c);
            e = $656e2c29cdd25871$var$Xh(null, b, d, a, e, c);
            var f = $656e2c29cdd25871$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $656e2c29cdd25871$var$Zf(d) ? (f = !0, $656e2c29cdd25871$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $656e2c29cdd25871$var$ah(b), e.updater = $656e2c29cdd25871$var$nh, b.stateNode = e, e._reactInternals = b, $656e2c29cdd25871$var$rh(b, d, a, c), b = $656e2c29cdd25871$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $656e2c29cdd25871$var$I && f && $656e2c29cdd25871$var$vg(b), $656e2c29cdd25871$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $656e2c29cdd25871$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $656e2c29cdd25871$var$$k(d);
                a = $656e2c29cdd25871$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $656e2c29cdd25871$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $656e2c29cdd25871$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $656e2c29cdd25871$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $656e2c29cdd25871$var$aj(null, b, d, $656e2c29cdd25871$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($656e2c29cdd25871$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $656e2c29cdd25871$var$Lg(d, e), $656e2c29cdd25871$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $656e2c29cdd25871$var$Lg(d, e), $656e2c29cdd25871$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $656e2c29cdd25871$var$lj(b);
                if (null === a) throw Error($656e2c29cdd25871$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $656e2c29cdd25871$var$bh(a, b);
                $656e2c29cdd25871$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $656e2c29cdd25871$var$Ki(Error($656e2c29cdd25871$var$p(423)), b);
                        b = $656e2c29cdd25871$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $656e2c29cdd25871$var$Ki(Error($656e2c29cdd25871$var$p(424)), b);
                        b = $656e2c29cdd25871$var$mj(a, b, d, c, e);
                        break a;
                    } else for($656e2c29cdd25871$var$yg = $656e2c29cdd25871$var$Lf(b.stateNode.containerInfo.firstChild), $656e2c29cdd25871$var$xg = b, $656e2c29cdd25871$var$I = !0, $656e2c29cdd25871$var$zg = null, c = $656e2c29cdd25871$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $656e2c29cdd25871$var$Ig();
                    if (d === e) {
                        b = $656e2c29cdd25871$var$$i(a, b, c);
                        break a;
                    }
                    $656e2c29cdd25871$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $656e2c29cdd25871$var$Kh(b), null === a && $656e2c29cdd25871$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $656e2c29cdd25871$var$Ef(d, e) ? g = null : null !== f && $656e2c29cdd25871$var$Ef(d, f) && (b.flags |= 32), $656e2c29cdd25871$var$hj(a, b), $656e2c29cdd25871$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $656e2c29cdd25871$var$Eg(b), null;
        case 13:
            return $656e2c29cdd25871$var$pj(a, b, c);
        case 4:
            return $656e2c29cdd25871$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $656e2c29cdd25871$var$Bh(b, null, d, c) : $656e2c29cdd25871$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $656e2c29cdd25871$var$Lg(d, e), $656e2c29cdd25871$var$Zi(a, b, d, e, c);
        case 7:
            return $656e2c29cdd25871$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $656e2c29cdd25871$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $656e2c29cdd25871$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $656e2c29cdd25871$var$G($656e2c29cdd25871$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($656e2c29cdd25871$var$He(f.value, g)) {
                        if (f.children === e.children && !$656e2c29cdd25871$var$Wf.current) {
                            b = $656e2c29cdd25871$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $656e2c29cdd25871$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $656e2c29cdd25871$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($656e2c29cdd25871$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $656e2c29cdd25871$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $656e2c29cdd25871$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $656e2c29cdd25871$var$Tg(b, c), e = $656e2c29cdd25871$var$Vg(e), d = d(e), b.flags |= 1, $656e2c29cdd25871$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $656e2c29cdd25871$var$Lg(d, b.pendingProps), e = $656e2c29cdd25871$var$Lg(d.type, e), $656e2c29cdd25871$var$aj(a, b, d, e, c);
        case 15:
            return $656e2c29cdd25871$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $656e2c29cdd25871$var$Lg(d, e), $656e2c29cdd25871$var$jj(a, b), b.tag = 1, $656e2c29cdd25871$var$Zf(d) ? (a = !0, $656e2c29cdd25871$var$cg(b)) : a = !1, $656e2c29cdd25871$var$Tg(b, c), $656e2c29cdd25871$var$ph(b, d, e), $656e2c29cdd25871$var$rh(b, d, e, c), $656e2c29cdd25871$var$kj(null, b, d, !0, a, c);
        case 19:
            return $656e2c29cdd25871$var$yj(a, b, c);
        case 22:
            return $656e2c29cdd25871$var$ej(a, b, c);
    }
    throw Error($656e2c29cdd25871$var$p(156, b.tag));
};
function $656e2c29cdd25871$var$Gk(a, b) {
    return $656e2c29cdd25871$var$ac(a, b);
}
function $656e2c29cdd25871$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $656e2c29cdd25871$var$Bg(a, b, c, d) {
    return new $656e2c29cdd25871$var$al(a, b, c, d);
}
function $656e2c29cdd25871$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $656e2c29cdd25871$var$$k(a) {
    if ("function" === typeof a) return $656e2c29cdd25871$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $656e2c29cdd25871$var$Da) return 11;
        if (a === $656e2c29cdd25871$var$Ga) return 14;
    }
    return 2;
}
function $656e2c29cdd25871$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $656e2c29cdd25871$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $656e2c29cdd25871$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $656e2c29cdd25871$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $656e2c29cdd25871$var$ya:
            return $656e2c29cdd25871$var$Ah(c.children, e, f, b);
        case $656e2c29cdd25871$var$za:
            g = 8;
            e |= 8;
            break;
        case $656e2c29cdd25871$var$Aa:
            return a = $656e2c29cdd25871$var$Bg(12, c, b, e | 2), a.elementType = $656e2c29cdd25871$var$Aa, a.lanes = f, a;
        case $656e2c29cdd25871$var$Ea:
            return a = $656e2c29cdd25871$var$Bg(13, c, b, e), a.elementType = $656e2c29cdd25871$var$Ea, a.lanes = f, a;
        case $656e2c29cdd25871$var$Fa:
            return a = $656e2c29cdd25871$var$Bg(19, c, b, e), a.elementType = $656e2c29cdd25871$var$Fa, a.lanes = f, a;
        case $656e2c29cdd25871$var$Ia:
            return $656e2c29cdd25871$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $656e2c29cdd25871$var$Ba:
                    g = 10;
                    break a;
                case $656e2c29cdd25871$var$Ca:
                    g = 9;
                    break a;
                case $656e2c29cdd25871$var$Da:
                    g = 11;
                    break a;
                case $656e2c29cdd25871$var$Ga:
                    g = 14;
                    break a;
                case $656e2c29cdd25871$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($656e2c29cdd25871$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $656e2c29cdd25871$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $656e2c29cdd25871$var$Ah(a, b, c, d) {
    a = $656e2c29cdd25871$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $656e2c29cdd25871$var$qj(a, b, c, d) {
    a = $656e2c29cdd25871$var$Bg(22, a, d, b);
    a.elementType = $656e2c29cdd25871$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $656e2c29cdd25871$var$xh(a, b, c) {
    a = $656e2c29cdd25871$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $656e2c29cdd25871$var$zh(a, b, c) {
    b = $656e2c29cdd25871$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $656e2c29cdd25871$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $656e2c29cdd25871$var$zc(0);
    this.expirationTimes = $656e2c29cdd25871$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $656e2c29cdd25871$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $656e2c29cdd25871$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $656e2c29cdd25871$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $656e2c29cdd25871$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $656e2c29cdd25871$var$ah(f);
    return a;
}
function $656e2c29cdd25871$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $656e2c29cdd25871$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $656e2c29cdd25871$var$el(a) {
    if (!a) return $656e2c29cdd25871$var$Vf;
    a = a._reactInternals;
    a: {
        if ($656e2c29cdd25871$var$Vb(a) !== a || 1 !== a.tag) throw Error($656e2c29cdd25871$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($656e2c29cdd25871$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($656e2c29cdd25871$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($656e2c29cdd25871$var$Zf(c)) return $656e2c29cdd25871$var$bg(a, c, b);
    }
    return b;
}
function $656e2c29cdd25871$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $656e2c29cdd25871$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $656e2c29cdd25871$var$el(null);
    c = a.current;
    d = $656e2c29cdd25871$var$L();
    e = $656e2c29cdd25871$var$lh(c);
    f = $656e2c29cdd25871$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $656e2c29cdd25871$var$dh(c, f, e);
    a.current.lanes = e;
    $656e2c29cdd25871$var$Ac(a, e, d);
    $656e2c29cdd25871$var$Ek(a, d);
    return a;
}
function $656e2c29cdd25871$var$gl(a, b, c, d) {
    var e = b.current, f = $656e2c29cdd25871$var$L(), g = $656e2c29cdd25871$var$lh(e);
    c = $656e2c29cdd25871$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $656e2c29cdd25871$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $656e2c29cdd25871$var$dh(e, b, g);
    null !== a && ($656e2c29cdd25871$var$mh(a, e, g, f), $656e2c29cdd25871$var$eh(a, e, g));
    return g;
}
function $656e2c29cdd25871$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $656e2c29cdd25871$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $656e2c29cdd25871$var$jl(a, b) {
    $656e2c29cdd25871$var$il(a, b);
    (a = a.alternate) && $656e2c29cdd25871$var$il(a, b);
}
function $656e2c29cdd25871$var$kl() {
    return null;
}
var $656e2c29cdd25871$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $656e2c29cdd25871$var$ml(a) {
    this._internalRoot = a;
}
$656e2c29cdd25871$var$nl.prototype.render = $656e2c29cdd25871$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($656e2c29cdd25871$var$p(409));
    $656e2c29cdd25871$var$gl(a, b, null, null);
};
$656e2c29cdd25871$var$nl.prototype.unmount = $656e2c29cdd25871$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $656e2c29cdd25871$var$Sk(function() {
            $656e2c29cdd25871$var$gl(null, a, null, null);
        });
        b[$656e2c29cdd25871$var$uf] = null;
    }
};
function $656e2c29cdd25871$var$nl(a) {
    this._internalRoot = a;
}
$656e2c29cdd25871$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $656e2c29cdd25871$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $656e2c29cdd25871$var$Qc.length && 0 !== b && b < $656e2c29cdd25871$var$Qc[c].priority; c++);
        $656e2c29cdd25871$var$Qc.splice(c, 0, a);
        0 === c && $656e2c29cdd25871$var$Vc(a);
    }
};
function $656e2c29cdd25871$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $656e2c29cdd25871$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $656e2c29cdd25871$var$ql() {}
function $656e2c29cdd25871$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $656e2c29cdd25871$var$hl(g);
                f.call(a);
            };
        }
        var g = $656e2c29cdd25871$var$fl(b, d, a, 0, null, !1, !1, "", $656e2c29cdd25871$var$ql);
        a._reactRootContainer = g;
        a[$656e2c29cdd25871$var$uf] = g.current;
        $656e2c29cdd25871$var$sf(8 === a.nodeType ? a.parentNode : a);
        $656e2c29cdd25871$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $656e2c29cdd25871$var$hl(k);
            h.call(a);
        };
    }
    var k = $656e2c29cdd25871$var$cl(a, 0, !1, null, null, !1, !1, "", $656e2c29cdd25871$var$ql);
    a._reactRootContainer = k;
    a[$656e2c29cdd25871$var$uf] = k.current;
    $656e2c29cdd25871$var$sf(8 === a.nodeType ? a.parentNode : a);
    $656e2c29cdd25871$var$Sk(function() {
        $656e2c29cdd25871$var$gl(b, k, c, d);
    });
    return k;
}
function $656e2c29cdd25871$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $656e2c29cdd25871$var$hl(g);
                h.call(a);
            };
        }
        $656e2c29cdd25871$var$gl(b, g, a, e);
    } else g = $656e2c29cdd25871$var$rl(c, b, a, e, d);
    return $656e2c29cdd25871$var$hl(g);
}
$656e2c29cdd25871$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $656e2c29cdd25871$var$tc(b.pendingLanes);
                0 !== c && ($656e2c29cdd25871$var$Cc(b, c | 1), $656e2c29cdd25871$var$Ek(b, $656e2c29cdd25871$var$B()), 0 === ($656e2c29cdd25871$var$K & 6) && ($656e2c29cdd25871$var$Hj = $656e2c29cdd25871$var$B() + 500, $656e2c29cdd25871$var$jg()));
            }
            break;
        case 13:
            $656e2c29cdd25871$var$Sk(function() {
                var b = $656e2c29cdd25871$var$Zg(a, 1);
                if (null !== b) {
                    var c = $656e2c29cdd25871$var$L();
                    $656e2c29cdd25871$var$mh(b, a, 1, c);
                }
            }), $656e2c29cdd25871$var$jl(a, 1);
    }
};
$656e2c29cdd25871$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $656e2c29cdd25871$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $656e2c29cdd25871$var$L();
            $656e2c29cdd25871$var$mh(b, a, 134217728, c);
        }
        $656e2c29cdd25871$var$jl(a, 134217728);
    }
};
$656e2c29cdd25871$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $656e2c29cdd25871$var$lh(a), c = $656e2c29cdd25871$var$Zg(a, b);
        if (null !== c) {
            var d = $656e2c29cdd25871$var$L();
            $656e2c29cdd25871$var$mh(c, a, b, d);
        }
        $656e2c29cdd25871$var$jl(a, b);
    }
};
$656e2c29cdd25871$var$Hc = function() {
    return $656e2c29cdd25871$var$C;
};
$656e2c29cdd25871$var$Ic = function(a, b) {
    var c = $656e2c29cdd25871$var$C;
    try {
        return $656e2c29cdd25871$var$C = a, b();
    } finally{
        $656e2c29cdd25871$var$C = c;
    }
};
$656e2c29cdd25871$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $656e2c29cdd25871$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $656e2c29cdd25871$var$Db(d);
                        if (!e) throw Error($656e2c29cdd25871$var$p(90));
                        $656e2c29cdd25871$var$Wa(d);
                        $656e2c29cdd25871$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $656e2c29cdd25871$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $656e2c29cdd25871$var$fb(a, !!c.multiple, b, !1);
    }
};
$656e2c29cdd25871$var$Gb = $656e2c29cdd25871$var$Rk;
$656e2c29cdd25871$var$Hb = $656e2c29cdd25871$var$Sk;
var $656e2c29cdd25871$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $656e2c29cdd25871$var$Cb,
        $656e2c29cdd25871$var$ue,
        $656e2c29cdd25871$var$Db,
        $656e2c29cdd25871$var$Eb,
        $656e2c29cdd25871$var$Fb,
        $656e2c29cdd25871$var$Rk
    ]
}, $656e2c29cdd25871$var$ul = {
    findFiberByHostInstance: $656e2c29cdd25871$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $656e2c29cdd25871$var$vl = {
    bundleType: $656e2c29cdd25871$var$ul.bundleType,
    version: $656e2c29cdd25871$var$ul.version,
    rendererPackageName: $656e2c29cdd25871$var$ul.rendererPackageName,
    rendererConfig: $656e2c29cdd25871$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $656e2c29cdd25871$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $656e2c29cdd25871$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $656e2c29cdd25871$var$ul.findFiberByHostInstance || $656e2c29cdd25871$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $656e2c29cdd25871$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$656e2c29cdd25871$var$wl.isDisabled && $656e2c29cdd25871$var$wl.supportsFiber) try {
        $656e2c29cdd25871$var$kc = $656e2c29cdd25871$var$wl.inject($656e2c29cdd25871$var$vl), $656e2c29cdd25871$var$lc = $656e2c29cdd25871$var$wl;
    } catch (a) {}
}
$656e2c29cdd25871$export$ae55be85d98224ed = $656e2c29cdd25871$var$tl;
$656e2c29cdd25871$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$656e2c29cdd25871$var$ol(b)) throw Error($656e2c29cdd25871$var$p(200));
    return $656e2c29cdd25871$var$dl(a, b, null, c);
};
$656e2c29cdd25871$export$882461b6382ed46c = function(a, b) {
    if (!$656e2c29cdd25871$var$ol(a)) throw Error($656e2c29cdd25871$var$p(299));
    var c = !1, d = "", e = $656e2c29cdd25871$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $656e2c29cdd25871$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$656e2c29cdd25871$var$uf] = b.current;
    $656e2c29cdd25871$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $656e2c29cdd25871$var$ml(b);
};
$656e2c29cdd25871$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($656e2c29cdd25871$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($656e2c29cdd25871$var$p(268, a));
    }
    a = $656e2c29cdd25871$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$656e2c29cdd25871$export$cd75ccfd720a3cd4 = function(a) {
    return $656e2c29cdd25871$var$Sk(a);
};
$656e2c29cdd25871$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$656e2c29cdd25871$var$pl(b)) throw Error($656e2c29cdd25871$var$p(200));
    return $656e2c29cdd25871$var$sl(null, a, b, !0, c);
};
$656e2c29cdd25871$export$757ceba2d55c277e = function(a, b, c) {
    if (!$656e2c29cdd25871$var$ol(a)) throw Error($656e2c29cdd25871$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $656e2c29cdd25871$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $656e2c29cdd25871$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$656e2c29cdd25871$var$uf] = b.current;
    $656e2c29cdd25871$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $656e2c29cdd25871$var$nl(b);
};
$656e2c29cdd25871$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$656e2c29cdd25871$var$pl(b)) throw Error($656e2c29cdd25871$var$p(200));
    return $656e2c29cdd25871$var$sl(null, a, b, !1, c);
};
$656e2c29cdd25871$export$502457920280e6be = function(a) {
    if (!$656e2c29cdd25871$var$pl(a)) throw Error($656e2c29cdd25871$var$p(40));
    return a._reactRootContainer ? ($656e2c29cdd25871$var$Sk(function() {
        $656e2c29cdd25871$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$656e2c29cdd25871$var$uf] = null;
        });
    }), !0) : !1;
};
$656e2c29cdd25871$export$c78a37762a8d58e1 = $656e2c29cdd25871$var$Rk;
$656e2c29cdd25871$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$656e2c29cdd25871$var$pl(c)) throw Error($656e2c29cdd25871$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($656e2c29cdd25871$var$p(38));
    return $656e2c29cdd25871$var$sl(a, b, c, !1, d);
};
$656e2c29cdd25871$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("FWXjv", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9wDkN"));

});
parcelRegister("9wDkN", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6ef59d35bbb8641f$export$c4744153514ff05d; }, function (v) { return $6ef59d35bbb8641f$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6ef59d35bbb8641f$export$3e506c1ccc9cc1a7; }, function (v) { return $6ef59d35bbb8641f$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6ef59d35bbb8641f$export$e26fe2ed2fa76875; }, function (v) { return $6ef59d35bbb8641f$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6ef59d35bbb8641f$export$502329bbf4b505b1; }, function (v) { return $6ef59d35bbb8641f$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6ef59d35bbb8641f$export$6e3807111c4874c4; }, function (v) { return $6ef59d35bbb8641f$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6ef59d35bbb8641f$export$c27134553091fb3a; }, function (v) { return $6ef59d35bbb8641f$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6ef59d35bbb8641f$export$33ee1acdc04fd2a2; }, function (v) { return $6ef59d35bbb8641f$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6ef59d35bbb8641f$export$b00a404bbd5edef2; }, function (v) { return $6ef59d35bbb8641f$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6ef59d35bbb8641f$export$8352ce38b91d0c62; }, function (v) { return $6ef59d35bbb8641f$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6ef59d35bbb8641f$export$d66a1c1c77bd778b; }, function (v) { return $6ef59d35bbb8641f$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6ef59d35bbb8641f$export$d3dfb8e4810cb555; }, function (v) { return $6ef59d35bbb8641f$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6ef59d35bbb8641f$export$839f9183b0465a69; }, function (v) { return $6ef59d35bbb8641f$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6ef59d35bbb8641f$export$72fdf0e06517287b; }, function (v) { return $6ef59d35bbb8641f$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6ef59d35bbb8641f$export$4b844e58a3e414b4; }, function (v) { return $6ef59d35bbb8641f$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6ef59d35bbb8641f$export$816d2913ae6b83b1; }, function (v) { return $6ef59d35bbb8641f$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6ef59d35bbb8641f$export$61bcfe829111a1d0; }, function (v) { return $6ef59d35bbb8641f$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6ef59d35bbb8641f$export$7ee8c9beb337bc3f; }, function (v) { return $6ef59d35bbb8641f$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6ef59d35bbb8641f$export$b5836b71941fa3ed; }, function (v) { return $6ef59d35bbb8641f$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6ef59d35bbb8641f$export$cf845f2c119da08a; }, function (v) { return $6ef59d35bbb8641f$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6ef59d35bbb8641f$export$c4744153514ff05d;
var $6ef59d35bbb8641f$export$3e506c1ccc9cc1a7;
var $6ef59d35bbb8641f$export$e26fe2ed2fa76875;
var $6ef59d35bbb8641f$export$502329bbf4b505b1;
var $6ef59d35bbb8641f$export$6e3807111c4874c4;
var $6ef59d35bbb8641f$export$c27134553091fb3a;
var $6ef59d35bbb8641f$export$33ee1acdc04fd2a2;
var $6ef59d35bbb8641f$export$b00a404bbd5edef2;
var $6ef59d35bbb8641f$export$8352ce38b91d0c62;
var $6ef59d35bbb8641f$export$d66a1c1c77bd778b;
var $6ef59d35bbb8641f$export$d3dfb8e4810cb555;
var $6ef59d35bbb8641f$export$839f9183b0465a69;
var $6ef59d35bbb8641f$export$72fdf0e06517287b;
var $6ef59d35bbb8641f$export$4b844e58a3e414b4;
var $6ef59d35bbb8641f$export$816d2913ae6b83b1;
var $6ef59d35bbb8641f$export$61bcfe829111a1d0;
var $6ef59d35bbb8641f$export$7ee8c9beb337bc3f;
var $6ef59d35bbb8641f$export$b5836b71941fa3ed;
var $6ef59d35bbb8641f$export$cf845f2c119da08a;
'use strict';
function $6ef59d35bbb8641f$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6ef59d35bbb8641f$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6ef59d35bbb8641f$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6ef59d35bbb8641f$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6ef59d35bbb8641f$var$g(C, c)) n < e && 0 > $6ef59d35bbb8641f$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6ef59d35bbb8641f$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6ef59d35bbb8641f$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6ef59d35bbb8641f$var$l = performance;
    $6ef59d35bbb8641f$export$c4744153514ff05d = function() {
        return $6ef59d35bbb8641f$var$l.now();
    };
} else {
    var $6ef59d35bbb8641f$var$p = Date, $6ef59d35bbb8641f$var$q = $6ef59d35bbb8641f$var$p.now();
    $6ef59d35bbb8641f$export$c4744153514ff05d = function() {
        return $6ef59d35bbb8641f$var$p.now() - $6ef59d35bbb8641f$var$q;
    };
}
var $6ef59d35bbb8641f$var$r = [], $6ef59d35bbb8641f$var$t = [], $6ef59d35bbb8641f$var$u = 1, $6ef59d35bbb8641f$var$v = null, $6ef59d35bbb8641f$var$y = 3, $6ef59d35bbb8641f$var$z = !1, $6ef59d35bbb8641f$var$A = !1, $6ef59d35bbb8641f$var$B = !1, $6ef59d35bbb8641f$var$D = "function" === typeof setTimeout ? setTimeout : null, $6ef59d35bbb8641f$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6ef59d35bbb8641f$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6ef59d35bbb8641f$var$G(a) {
    for(var b = $6ef59d35bbb8641f$var$h($6ef59d35bbb8641f$var$t); null !== b;){
        if (null === b.callback) $6ef59d35bbb8641f$var$k($6ef59d35bbb8641f$var$t);
        else if (b.startTime <= a) $6ef59d35bbb8641f$var$k($6ef59d35bbb8641f$var$t), b.sortIndex = b.expirationTime, $6ef59d35bbb8641f$var$f($6ef59d35bbb8641f$var$r, b);
        else break;
        b = $6ef59d35bbb8641f$var$h($6ef59d35bbb8641f$var$t);
    }
}
function $6ef59d35bbb8641f$var$H(a) {
    $6ef59d35bbb8641f$var$B = !1;
    $6ef59d35bbb8641f$var$G(a);
    if (!$6ef59d35bbb8641f$var$A) {
        if (null !== $6ef59d35bbb8641f$var$h($6ef59d35bbb8641f$var$r)) $6ef59d35bbb8641f$var$A = !0, $6ef59d35bbb8641f$var$I($6ef59d35bbb8641f$var$J);
        else {
            var b = $6ef59d35bbb8641f$var$h($6ef59d35bbb8641f$var$t);
            null !== b && $6ef59d35bbb8641f$var$K($6ef59d35bbb8641f$var$H, b.startTime - a);
        }
    }
}
function $6ef59d35bbb8641f$var$J(a, b) {
    $6ef59d35bbb8641f$var$A = !1;
    $6ef59d35bbb8641f$var$B && ($6ef59d35bbb8641f$var$B = !1, $6ef59d35bbb8641f$var$E($6ef59d35bbb8641f$var$L), $6ef59d35bbb8641f$var$L = -1);
    $6ef59d35bbb8641f$var$z = !0;
    var c = $6ef59d35bbb8641f$var$y;
    try {
        $6ef59d35bbb8641f$var$G(b);
        for($6ef59d35bbb8641f$var$v = $6ef59d35bbb8641f$var$h($6ef59d35bbb8641f$var$r); null !== $6ef59d35bbb8641f$var$v && (!($6ef59d35bbb8641f$var$v.expirationTime > b) || a && !$6ef59d35bbb8641f$var$M());){
            var d = $6ef59d35bbb8641f$var$v.callback;
            if ("function" === typeof d) {
                $6ef59d35bbb8641f$var$v.callback = null;
                $6ef59d35bbb8641f$var$y = $6ef59d35bbb8641f$var$v.priorityLevel;
                var e = d($6ef59d35bbb8641f$var$v.expirationTime <= b);
                b = $6ef59d35bbb8641f$export$c4744153514ff05d();
                "function" === typeof e ? $6ef59d35bbb8641f$var$v.callback = e : $6ef59d35bbb8641f$var$v === $6ef59d35bbb8641f$var$h($6ef59d35bbb8641f$var$r) && $6ef59d35bbb8641f$var$k($6ef59d35bbb8641f$var$r);
                $6ef59d35bbb8641f$var$G(b);
            } else $6ef59d35bbb8641f$var$k($6ef59d35bbb8641f$var$r);
            $6ef59d35bbb8641f$var$v = $6ef59d35bbb8641f$var$h($6ef59d35bbb8641f$var$r);
        }
        if (null !== $6ef59d35bbb8641f$var$v) var w = !0;
        else {
            var m = $6ef59d35bbb8641f$var$h($6ef59d35bbb8641f$var$t);
            null !== m && $6ef59d35bbb8641f$var$K($6ef59d35bbb8641f$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6ef59d35bbb8641f$var$v = null, $6ef59d35bbb8641f$var$y = c, $6ef59d35bbb8641f$var$z = !1;
    }
}
var $6ef59d35bbb8641f$var$N = !1, $6ef59d35bbb8641f$var$O = null, $6ef59d35bbb8641f$var$L = -1, $6ef59d35bbb8641f$var$P = 5, $6ef59d35bbb8641f$var$Q = -1;
function $6ef59d35bbb8641f$var$M() {
    return $6ef59d35bbb8641f$export$c4744153514ff05d() - $6ef59d35bbb8641f$var$Q < $6ef59d35bbb8641f$var$P ? !1 : !0;
}
function $6ef59d35bbb8641f$var$R() {
    if (null !== $6ef59d35bbb8641f$var$O) {
        var a = $6ef59d35bbb8641f$export$c4744153514ff05d();
        $6ef59d35bbb8641f$var$Q = a;
        var b = !0;
        try {
            b = $6ef59d35bbb8641f$var$O(!0, a);
        } finally{
            b ? $6ef59d35bbb8641f$var$S() : ($6ef59d35bbb8641f$var$N = !1, $6ef59d35bbb8641f$var$O = null);
        }
    } else $6ef59d35bbb8641f$var$N = !1;
}
var $6ef59d35bbb8641f$var$S;
if ("function" === typeof $6ef59d35bbb8641f$var$F) $6ef59d35bbb8641f$var$S = function() {
    $6ef59d35bbb8641f$var$F($6ef59d35bbb8641f$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6ef59d35bbb8641f$var$T = new MessageChannel, $6ef59d35bbb8641f$var$U = $6ef59d35bbb8641f$var$T.port2;
    $6ef59d35bbb8641f$var$T.port1.onmessage = $6ef59d35bbb8641f$var$R;
    $6ef59d35bbb8641f$var$S = function() {
        $6ef59d35bbb8641f$var$U.postMessage(null);
    };
} else $6ef59d35bbb8641f$var$S = function() {
    $6ef59d35bbb8641f$var$D($6ef59d35bbb8641f$var$R, 0);
};
function $6ef59d35bbb8641f$var$I(a) {
    $6ef59d35bbb8641f$var$O = a;
    $6ef59d35bbb8641f$var$N || ($6ef59d35bbb8641f$var$N = !0, $6ef59d35bbb8641f$var$S());
}
function $6ef59d35bbb8641f$var$K(a, b) {
    $6ef59d35bbb8641f$var$L = $6ef59d35bbb8641f$var$D(function() {
        a($6ef59d35bbb8641f$export$c4744153514ff05d());
    }, b);
}
$6ef59d35bbb8641f$export$3e506c1ccc9cc1a7 = 5;
$6ef59d35bbb8641f$export$e26fe2ed2fa76875 = 1;
$6ef59d35bbb8641f$export$502329bbf4b505b1 = 4;
$6ef59d35bbb8641f$export$6e3807111c4874c4 = 3;
$6ef59d35bbb8641f$export$c27134553091fb3a = null;
$6ef59d35bbb8641f$export$33ee1acdc04fd2a2 = 2;
$6ef59d35bbb8641f$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6ef59d35bbb8641f$export$8352ce38b91d0c62 = function() {
    $6ef59d35bbb8641f$var$A || $6ef59d35bbb8641f$var$z || ($6ef59d35bbb8641f$var$A = !0, $6ef59d35bbb8641f$var$I($6ef59d35bbb8641f$var$J));
};
$6ef59d35bbb8641f$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6ef59d35bbb8641f$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6ef59d35bbb8641f$export$d3dfb8e4810cb555 = function() {
    return $6ef59d35bbb8641f$var$y;
};
$6ef59d35bbb8641f$export$839f9183b0465a69 = function() {
    return $6ef59d35bbb8641f$var$h($6ef59d35bbb8641f$var$r);
};
$6ef59d35bbb8641f$export$72fdf0e06517287b = function(a) {
    switch($6ef59d35bbb8641f$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6ef59d35bbb8641f$var$y;
    }
    var c = $6ef59d35bbb8641f$var$y;
    $6ef59d35bbb8641f$var$y = b;
    try {
        return a();
    } finally{
        $6ef59d35bbb8641f$var$y = c;
    }
};
$6ef59d35bbb8641f$export$4b844e58a3e414b4 = function() {};
$6ef59d35bbb8641f$export$816d2913ae6b83b1 = function() {};
$6ef59d35bbb8641f$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6ef59d35bbb8641f$var$y;
    $6ef59d35bbb8641f$var$y = a;
    try {
        return b();
    } finally{
        $6ef59d35bbb8641f$var$y = c;
    }
};
$6ef59d35bbb8641f$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6ef59d35bbb8641f$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6ef59d35bbb8641f$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6ef59d35bbb8641f$var$f($6ef59d35bbb8641f$var$t, a), null === $6ef59d35bbb8641f$var$h($6ef59d35bbb8641f$var$r) && a === $6ef59d35bbb8641f$var$h($6ef59d35bbb8641f$var$t) && ($6ef59d35bbb8641f$var$B ? ($6ef59d35bbb8641f$var$E($6ef59d35bbb8641f$var$L), $6ef59d35bbb8641f$var$L = -1) : $6ef59d35bbb8641f$var$B = !0, $6ef59d35bbb8641f$var$K($6ef59d35bbb8641f$var$H, c - d))) : (a.sortIndex = e, $6ef59d35bbb8641f$var$f($6ef59d35bbb8641f$var$r, a), $6ef59d35bbb8641f$var$A || $6ef59d35bbb8641f$var$z || ($6ef59d35bbb8641f$var$A = !0, $6ef59d35bbb8641f$var$I($6ef59d35bbb8641f$var$J)));
    return a;
};
$6ef59d35bbb8641f$export$b5836b71941fa3ed = $6ef59d35bbb8641f$var$M;
$6ef59d35bbb8641f$export$cf845f2c119da08a = function(a) {
    var b = $6ef59d35bbb8641f$var$y;
    return function() {
        var c = $6ef59d35bbb8641f$var$y;
        $6ef59d35bbb8641f$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6ef59d35bbb8641f$var$y = c;
        }
    };
};

});



parcelRegister("US4vK", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $0aaf2c9a201e21da$export$bf730a2d8bf68b42; }, function (v) { return $0aaf2c9a201e21da$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0aaf2c9a201e21da$export$bf730a2d8bf68b42;
"use strict";

var $h4Bez = parcelRequire("h4Bez");

var $86zyE = parcelRequire("86zyE");
function $0aaf2c9a201e21da$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $0aaf2c9a201e21da$var$objectIs = "function" === typeof Object.is ? Object.is : $0aaf2c9a201e21da$var$is, $0aaf2c9a201e21da$var$useSyncExternalStore = $86zyE.useSyncExternalStore, $0aaf2c9a201e21da$var$useRef = $h4Bez.useRef, $0aaf2c9a201e21da$var$useEffect = $h4Bez.useEffect, $0aaf2c9a201e21da$var$useMemo = $h4Bez.useMemo, $0aaf2c9a201e21da$var$useDebugValue = $h4Bez.useDebugValue;
$0aaf2c9a201e21da$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $0aaf2c9a201e21da$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $0aaf2c9a201e21da$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($0aaf2c9a201e21da$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $0aaf2c9a201e21da$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $0aaf2c9a201e21da$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $0aaf2c9a201e21da$var$useDebugValue(value);
    return value;
};

});
parcelRegister("86zyE", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3S4Ul"));

});
parcelRegister("3S4Ul", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $2d1a38d4970eef8c$export$306c0aa65ff9ec16; }, function (v) { return $2d1a38d4970eef8c$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2d1a38d4970eef8c$export$306c0aa65ff9ec16;
"use strict";

var $h4Bez = parcelRequire("h4Bez");
function $2d1a38d4970eef8c$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $2d1a38d4970eef8c$var$objectIs = "function" === typeof Object.is ? Object.is : $2d1a38d4970eef8c$var$is, $2d1a38d4970eef8c$var$useState = $h4Bez.useState, $2d1a38d4970eef8c$var$useEffect = $h4Bez.useEffect, $2d1a38d4970eef8c$var$useLayoutEffect = $h4Bez.useLayoutEffect, $2d1a38d4970eef8c$var$useDebugValue = $h4Bez.useDebugValue;
function $2d1a38d4970eef8c$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $2d1a38d4970eef8c$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $2d1a38d4970eef8c$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $2d1a38d4970eef8c$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $2d1a38d4970eef8c$var$useEffect(function() {
        $2d1a38d4970eef8c$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $2d1a38d4970eef8c$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $2d1a38d4970eef8c$var$useDebugValue(value);
    return value;
}
function $2d1a38d4970eef8c$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$2d1a38d4970eef8c$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $2d1a38d4970eef8c$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $2d1a38d4970eef8c$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2d1a38d4970eef8c$var$useSyncExternalStore$1 : $2d1a38d4970eef8c$var$useSyncExternalStore$2;
$2d1a38d4970eef8c$export$306c0aa65ff9ec16 = void 0 !== $h4Bez.useSyncExternalStore ? $h4Bez.useSyncExternalStore : $2d1a38d4970eef8c$var$shim;

});



parcelRegister("2bPoT", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $1kImh = parcelRequire("1kImh");
function $19847af15529e713$var$emptyFunction() {}
function $19847af15529e713$var$emptyFunctionWithReset() {}
$19847af15529e713$var$emptyFunctionWithReset.resetWarningCache = $19847af15529e713$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $1kImh) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $19847af15529e713$var$emptyFunctionWithReset,
        resetWarningCache: $19847af15529e713$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("1kImh", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $0f8a115ef819d18d$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $0f8a115ef819d18d$var$ReactPropTypesSecret;

});


parcelRegister("5CHok", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $418228f6d04a7eea$export$a7c73072b1a182ae; }, function (v) { return $418228f6d04a7eea$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $418228f6d04a7eea$export$9f27bc3417b4524d; }, function (v) { return $418228f6d04a7eea$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $418228f6d04a7eea$export$db77ccec0bb4ccac; }, function (v) { return $418228f6d04a7eea$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $418228f6d04a7eea$export$8392c0c9d3dcbd35; }, function (v) { return $418228f6d04a7eea$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $418228f6d04a7eea$export$ffb0004e005737fa; }, function (v) { return $418228f6d04a7eea$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $418228f6d04a7eea$export$b624eff549462981; }, function (v) { return $418228f6d04a7eea$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $418228f6d04a7eea$export$7897aa7841a5380c; }, function (v) { return $418228f6d04a7eea$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $418228f6d04a7eea$export$602eac185826482c; }, function (v) { return $418228f6d04a7eea$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $418228f6d04a7eea$export$e2c29f18771995cb; }, function (v) { return $418228f6d04a7eea$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $418228f6d04a7eea$export$5f8d39834fd61797; }, function (v) { return $418228f6d04a7eea$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $418228f6d04a7eea$export$74bf444e3cd11ea5; }, function (v) { return $418228f6d04a7eea$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $418228f6d04a7eea$export$998bcd577473dd93; }, function (v) { return $418228f6d04a7eea$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $418228f6d04a7eea$export$92387174baf9b227; }, function (v) { return $418228f6d04a7eea$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $418228f6d04a7eea$export$ec112efeb987d9c6; }, function (v) { return $418228f6d04a7eea$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $418228f6d04a7eea$export$b706b080d889d2c9; }, function (v) { return $418228f6d04a7eea$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $418228f6d04a7eea$export$5be5a87408f70ddc; }, function (v) { return $418228f6d04a7eea$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $418228f6d04a7eea$export$45a5e7f76e0caa8d; }, function (v) { return $418228f6d04a7eea$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $418228f6d04a7eea$export$455c2e768291efa6; }, function (v) { return $418228f6d04a7eea$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $418228f6d04a7eea$export$9522e17588c12572; }, function (v) { return $418228f6d04a7eea$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $418228f6d04a7eea$export$2110ac352bb060b9; }, function (v) { return $418228f6d04a7eea$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $418228f6d04a7eea$export$56885ab8b9c456ab; }, function (v) { return $418228f6d04a7eea$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $418228f6d04a7eea$export$d927fcb6adf8f9de; }, function (v) { return $418228f6d04a7eea$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $418228f6d04a7eea$export$b82d16f27459e05a; }, function (v) { return $418228f6d04a7eea$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $418228f6d04a7eea$export$522c17b4f5e123e8; }, function (v) { return $418228f6d04a7eea$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $418228f6d04a7eea$export$1aabd8a0274ecfd6; }, function (v) { return $418228f6d04a7eea$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $418228f6d04a7eea$export$3d6c20d97e46b957; }, function (v) { return $418228f6d04a7eea$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $418228f6d04a7eea$export$9b621391a187a31a; }, function (v) { return $418228f6d04a7eea$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $418228f6d04a7eea$export$f5bbd400c2f4426f; }, function (v) { return $418228f6d04a7eea$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $418228f6d04a7eea$export$a7c73072b1a182ae;
var $418228f6d04a7eea$export$9f27bc3417b4524d;
var $418228f6d04a7eea$export$db77ccec0bb4ccac;
var $418228f6d04a7eea$export$8392c0c9d3dcbd35;
var $418228f6d04a7eea$export$ffb0004e005737fa;
var $418228f6d04a7eea$export$b624eff549462981;
var $418228f6d04a7eea$export$7897aa7841a5380c;
var $418228f6d04a7eea$export$602eac185826482c;
var $418228f6d04a7eea$export$e2c29f18771995cb;
var $418228f6d04a7eea$export$5f8d39834fd61797;
var $418228f6d04a7eea$export$74bf444e3cd11ea5;
var $418228f6d04a7eea$export$998bcd577473dd93;
var $418228f6d04a7eea$export$92387174baf9b227;
var $418228f6d04a7eea$export$ec112efeb987d9c6;
var $418228f6d04a7eea$export$b706b080d889d2c9;
var $418228f6d04a7eea$export$5be5a87408f70ddc;
var $418228f6d04a7eea$export$45a5e7f76e0caa8d;
var $418228f6d04a7eea$export$455c2e768291efa6;
var $418228f6d04a7eea$export$9522e17588c12572;
var $418228f6d04a7eea$export$2110ac352bb060b9;
var $418228f6d04a7eea$export$56885ab8b9c456ab;
var $418228f6d04a7eea$export$d927fcb6adf8f9de;
var $418228f6d04a7eea$export$b82d16f27459e05a;
var $418228f6d04a7eea$export$522c17b4f5e123e8;
var $418228f6d04a7eea$export$1aabd8a0274ecfd6;
var $418228f6d04a7eea$export$3d6c20d97e46b957;
var $418228f6d04a7eea$export$9b621391a187a31a;
var $418228f6d04a7eea$export$f5bbd400c2f4426f;
'use strict';
var $418228f6d04a7eea$var$b = Symbol.for("react.element"), $418228f6d04a7eea$var$c = Symbol.for("react.portal"), $418228f6d04a7eea$var$d = Symbol.for("react.fragment"), $418228f6d04a7eea$var$e = Symbol.for("react.strict_mode"), $418228f6d04a7eea$var$f = Symbol.for("react.profiler"), $418228f6d04a7eea$var$g = Symbol.for("react.provider"), $418228f6d04a7eea$var$h = Symbol.for("react.context"), $418228f6d04a7eea$var$k = Symbol.for("react.server_context"), $418228f6d04a7eea$var$l = Symbol.for("react.forward_ref"), $418228f6d04a7eea$var$m = Symbol.for("react.suspense"), $418228f6d04a7eea$var$n = Symbol.for("react.suspense_list"), $418228f6d04a7eea$var$p = Symbol.for("react.memo"), $418228f6d04a7eea$var$q = Symbol.for("react.lazy"), $418228f6d04a7eea$var$t = Symbol.for("react.offscreen"), $418228f6d04a7eea$var$u;
$418228f6d04a7eea$var$u = Symbol.for("react.module.reference");
function $418228f6d04a7eea$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $418228f6d04a7eea$var$b:
                switch(a = a.type, a){
                    case $418228f6d04a7eea$var$d:
                    case $418228f6d04a7eea$var$f:
                    case $418228f6d04a7eea$var$e:
                    case $418228f6d04a7eea$var$m:
                    case $418228f6d04a7eea$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $418228f6d04a7eea$var$k:
                            case $418228f6d04a7eea$var$h:
                            case $418228f6d04a7eea$var$l:
                            case $418228f6d04a7eea$var$q:
                            case $418228f6d04a7eea$var$p:
                            case $418228f6d04a7eea$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $418228f6d04a7eea$var$c:
                return r;
        }
    }
}
$418228f6d04a7eea$export$a7c73072b1a182ae = $418228f6d04a7eea$var$h;
$418228f6d04a7eea$export$9f27bc3417b4524d = $418228f6d04a7eea$var$g;
$418228f6d04a7eea$export$db77ccec0bb4ccac = $418228f6d04a7eea$var$b;
$418228f6d04a7eea$export$8392c0c9d3dcbd35 = $418228f6d04a7eea$var$l;
$418228f6d04a7eea$export$ffb0004e005737fa = $418228f6d04a7eea$var$d;
$418228f6d04a7eea$export$b624eff549462981 = $418228f6d04a7eea$var$q;
$418228f6d04a7eea$export$7897aa7841a5380c = $418228f6d04a7eea$var$p;
$418228f6d04a7eea$export$602eac185826482c = $418228f6d04a7eea$var$c;
$418228f6d04a7eea$export$e2c29f18771995cb = $418228f6d04a7eea$var$f;
$418228f6d04a7eea$export$5f8d39834fd61797 = $418228f6d04a7eea$var$e;
$418228f6d04a7eea$export$74bf444e3cd11ea5 = $418228f6d04a7eea$var$m;
$418228f6d04a7eea$export$998bcd577473dd93 = $418228f6d04a7eea$var$n;
$418228f6d04a7eea$export$92387174baf9b227 = function() {
    return !1;
};
$418228f6d04a7eea$export$ec112efeb987d9c6 = function() {
    return !1;
};
$418228f6d04a7eea$export$b706b080d889d2c9 = function(a) {
    return $418228f6d04a7eea$var$v(a) === $418228f6d04a7eea$var$h;
};
$418228f6d04a7eea$export$5be5a87408f70ddc = function(a) {
    return $418228f6d04a7eea$var$v(a) === $418228f6d04a7eea$var$g;
};
$418228f6d04a7eea$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $418228f6d04a7eea$var$b;
};
$418228f6d04a7eea$export$455c2e768291efa6 = function(a) {
    return $418228f6d04a7eea$var$v(a) === $418228f6d04a7eea$var$l;
};
$418228f6d04a7eea$export$9522e17588c12572 = function(a) {
    return $418228f6d04a7eea$var$v(a) === $418228f6d04a7eea$var$d;
};
$418228f6d04a7eea$export$2110ac352bb060b9 = function(a) {
    return $418228f6d04a7eea$var$v(a) === $418228f6d04a7eea$var$q;
};
$418228f6d04a7eea$export$56885ab8b9c456ab = function(a) {
    return $418228f6d04a7eea$var$v(a) === $418228f6d04a7eea$var$p;
};
$418228f6d04a7eea$export$d927fcb6adf8f9de = function(a) {
    return $418228f6d04a7eea$var$v(a) === $418228f6d04a7eea$var$c;
};
$418228f6d04a7eea$export$b82d16f27459e05a = function(a) {
    return $418228f6d04a7eea$var$v(a) === $418228f6d04a7eea$var$f;
};
$418228f6d04a7eea$export$522c17b4f5e123e8 = function(a) {
    return $418228f6d04a7eea$var$v(a) === $418228f6d04a7eea$var$e;
};
$418228f6d04a7eea$export$1aabd8a0274ecfd6 = function(a) {
    return $418228f6d04a7eea$var$v(a) === $418228f6d04a7eea$var$m;
};
$418228f6d04a7eea$export$3d6c20d97e46b957 = function(a) {
    return $418228f6d04a7eea$var$v(a) === $418228f6d04a7eea$var$n;
};
$418228f6d04a7eea$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $418228f6d04a7eea$var$d || a === $418228f6d04a7eea$var$f || a === $418228f6d04a7eea$var$e || a === $418228f6d04a7eea$var$m || a === $418228f6d04a7eea$var$n || a === $418228f6d04a7eea$var$t || "object" === typeof a && null !== a && (a.$$typeof === $418228f6d04a7eea$var$q || a.$$typeof === $418228f6d04a7eea$var$p || a.$$typeof === $418228f6d04a7eea$var$g || a.$$typeof === $418228f6d04a7eea$var$h || a.$$typeof === $418228f6d04a7eea$var$l || a.$$typeof === $418228f6d04a7eea$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$418228f6d04a7eea$export$f5bbd400c2f4426f = $418228f6d04a7eea$var$v;

});

parcelRegister("cQev2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SyncPromiseState = void 0;
var $959596b461df1128$var$SyncPromiseState;
(function(SyncPromiseState) {
    SyncPromiseState["PENDING"] = "PENDING";
    SyncPromiseState["RESOLVED"] = "RESOLVED";
    SyncPromiseState["REJECTED"] = "REJECTED";
})($959596b461df1128$var$SyncPromiseState = module.exports.SyncPromiseState || (module.exports.SyncPromiseState = {}));

});

parcelRegister("HY3KZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ifNotRejected = module.exports.ifUnresolved = module.exports.isRejected = module.exports.isResolved = module.exports.isPending = void 0;

var $fF3mG = parcelRequire("fF3mG");
/** @example isPending(usePromise(new Promise(() => void 0))) */ var $08429ada0b0d6638$var$isPending = function(promise) {
    return promise.state === $fF3mG.SyncPromiseState.PENDING;
};
module.exports.isPending = $08429ada0b0d6638$var$isPending;
/** @example isResolved(usePromise(Promise.resolve('I have resolve'))) */ var $08429ada0b0d6638$var$isResolved = function(promise) {
    return promise.state === $fF3mG.SyncPromiseState.RESOLVED;
};
module.exports.isResolved = $08429ada0b0d6638$var$isResolved;
/** @example isRejected(usePromise(Promise.reject('I have no resolve'))) */ var $08429ada0b0d6638$var$isRejected = function(promise) {
    return promise.state === $fF3mG.SyncPromiseState.REJECTED;
};
module.exports.isRejected = $08429ada0b0d6638$var$isRejected;
/** @example ifUnresolved(usePromise(Promise.reject('I have no resolve')), 'I am unresolved') */ var $08429ada0b0d6638$var$ifUnresolved = function(promise, otherwise) {
    return (0, module.exports.isResolved)(promise) ? promise.value : otherwise;
};
module.exports.ifUnresolved = $08429ada0b0d6638$var$ifUnresolved;
/** @example ifNotRejected(usePromise(Promise.reject('I have no resolve')), 'I am not rejected') */ var $08429ada0b0d6638$var$ifNotRejected = function(promise, otherwise) {
    return (0, module.exports.isRejected)(promise) ? promise.value : otherwise;
};
module.exports.ifNotRejected = $08429ada0b0d6638$var$ifNotRejected;

});
parcelRegister("fF3mG", function(module, exports) {
"use strict";
var $b66d4b8ab8cf8684$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b66d4b8ab8cf8684$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b66d4b8ab8cf8684$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b66d4b8ab8cf8684$var$__exportStar((parcelRequire("cQev2")), module.exports);

$b66d4b8ab8cf8684$var$__exportStar((parcelRequire("HY3KZ")), module.exports);

$b66d4b8ab8cf8684$var$__exportStar((parcelRequire("j5fs2")), module.exports);

});
parcelRegister("j5fs2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePromise = module.exports.usePromiseState = void 0;

var $h4Bez = parcelRequire("h4Bez");

var $fF3mG = parcelRequire("fF3mG");

var $2Se7T = parcelRequire("2Se7T");
/**
 * Loads given promise with built-in semaphor for later updates
 */ var $de4a78415ac95ba0$var$loadPromise = function(newSource, ref, setSyncPromise) {
    Promise.resolve(newSource).then(function(value) {
        return {
            state: $fF3mG.SyncPromiseState.RESOLVED,
            value: value
        };
    }).catch(function(value) {
        return {
            state: $fF3mG.SyncPromiseState.REJECTED,
            value: value
        };
    })/**
         * Update state with result if the response came from
         * the same source as the one that is currently loaded
         */ .then(function(newDerived) {
        if (ref.current === newSource) setSyncPromise(newDerived);
    });
};
/** All promises that are loading will point to this single object, which causes less re-renders */ var $de4a78415ac95ba0$var$defaultSync = {
    state: $fF3mG.SyncPromiseState.PENDING
};
/**
 * Handle promises synchronously in react!
 *
 * @example
 * const [promise, setPromise] = usePromiseState(Promise.resolve('Execute order 66'));
 * setPromise(Promise.resolve('Do, do not, there is no try'));
 * @example
 * const [promise, setPromise] = usePromiseState(Promise.resolve('There are decades when nothing happens'));
 * setPromise<string, Error>(Promise.resolve('there are weeks, where decades happen'));
 *
 * @param asyncPromise the promise you want to handle synchronously, don't forget to memoize it :)
 *
 * @returns a tupple capable of updating itself based on Promises on the react life-cycle generating react hooked objects
 */ var $de4a78415ac95ba0$var$usePromiseState = function(asyncPromise) {
    /** A reference to the original promise, that will never be updated */ var originalPromiseRef = (0, $h4Bez.useRef)(asyncPromise);
    /** The derived sync promise */ var _a = (0, $2Se7T.useHookedState)(null), syncPromise = _a[0], setSyncPromise = _a[1];
    var callback = (0, $h4Bez.useCallback)(function(action) {
        var newSource = action instanceof Function ? action(originalPromiseRef.current) : action;
        if (newSource === originalPromiseRef.current) /** Source is already loaded, do nothing */ return;
        /** Point the ref to the new source */ originalPromiseRef.current = newSource;
        /** Mark it as loading again */ setSyncPromise(null);
        /** Schedule promise to load */ $de4a78415ac95ba0$var$loadPromise(newSource, originalPromiseRef, setSyncPromise);
    }, [
        originalPromiseRef
    ]);
    /** Force initial load */ (0, $h4Bez.useEffect)(function() {
        return $de4a78415ac95ba0$var$loadPromise(originalPromiseRef.current, originalPromiseRef, setSyncPromise);
    }, [
        originalPromiseRef
    ]);
    return [
        syncPromise || $de4a78415ac95ba0$var$defaultSync,
        callback
    ];
};
module.exports.usePromiseState = $de4a78415ac95ba0$var$usePromiseState;
/**
 * Handle promises synchronously in react!
 *
 * @example usePromise(Promise.resolve('Execute order 66'))
 * @example usePromise<string, Error>(Promise.resolve('Execute order 66'))
 *
 * @param asyncPromise the promise you want to handle synchronously, don't forget to memoize it :)
 */ var $de4a78415ac95ba0$var$usePromise = function(asyncPromise) {
    var _a = (0, module.exports.usePromiseState)(asyncPromise), promise = _a[0], updateSourcePromise = _a[1];
    /** If the promise changes, then update it accordingly */ (0, $h4Bez.useEffect)(function() {
        return updateSourcePromise(asyncPromise);
    }, [
        asyncPromise,
        updateSourcePromise
    ]);
    return promise;
};
module.exports.usePromise = $de4a78415ac95ba0$var$usePromise;

});
parcelRegister("2Se7T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useHookedState = void 0;

var $h4Bez = parcelRequire("h4Bez");
/**
 * @description same behaviour as `useSate` but stops updates when unhooked
 * @see {useSate}
 */ var $217b9515e89232df$var$useHookedState = function(initialState) {
    var ref = (0, $h4Bez.useRef)(true);
    var _a = (0, $h4Bez.useState)(initialState), state = _a[0], dispatcher = _a[1];
    /**
     * Update when unhooked
     */ (0, $h4Bez.useEffect)(function() {
        return function() {
            ref.current = false;
        };
    }, []);
    var hookedDispatcher = (0, $h4Bez.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (ref.current) dispatcher.apply(void 0, args);
    }, [
        dispatcher,
        ref
    ]);
    return [
        state,
        hookedDispatcher
    ];
};
module.exports.useHookedState = $217b9515e89232df$var$useHookedState;

});




parcelRegister("5Ckcr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41702b92efa69396$export$2e2bcd8739ae039; });

var $h5jK2 = parcelRequire("h5jK2");

var $cUfuk = parcelRequire("cUfuk");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $h5jK2.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $cUfuk.default);
var $41702b92efa69396$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("h5jK2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c70237944894ab64$export$2e2bcd8739ae039; });

var $4tpBP = parcelRequire("4tpBP");
/** Detect free variable `self`. */ var $c70237944894ab64$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $c70237944894ab64$var$root = (0, $4tpBP.default) || $c70237944894ab64$var$freeSelf || Function('return this')();
var $c70237944894ab64$export$2e2bcd8739ae039 = $c70237944894ab64$var$root;

});
parcelRegister("4tpBP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $341dbc52d4bacf50$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $341dbc52d4bacf50$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $341dbc52d4bacf50$export$2e2bcd8739ae039 = $341dbc52d4bacf50$var$freeGlobal;

});


parcelRegister("cUfuk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9656ba9ea4cedd13$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $9656ba9ea4cedd13$var$stubFalse() {
    return false;
}
var $9656ba9ea4cedd13$export$2e2bcd8739ae039 = $9656ba9ea4cedd13$var$stubFalse;

});


parcelRegister("lGG4h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc9e270dacc48008$export$2e2bcd8739ae039; });

var $4tpBP = parcelRequire("4tpBP");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $4tpBP.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $fc9e270dacc48008$export$2e2bcd8739ae039 = nodeUtil;

});

parcelRegister("jxwfQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e39a1e7ce1516990$export$2e2bcd8739ae039; });

var $h5jK2 = parcelRequire("h5jK2");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $h5jK2.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $e39a1e7ce1516990$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("kKLhX", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MissingRefError = exports.ValidationError = exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = exports.Ajv = void 0;

var $1jcC6 = parcelRequire("1jcC6");

var $lpcE1 = parcelRequire("lpcE1");

var $3wRO9 = parcelRequire("3wRO9");

var $fBoo7 = parcelRequire("fBoo7");
const META_SUPPORT_DATA = [
    "/properties"
];
const META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
class Ajv extends $1jcC6.default {
    _addVocabularies() {
        super._addVocabularies();
        $lpcE1.default.forEach((v)=>this.addVocabulary(v));
        if (this.opts.discriminator) this.addKeyword($3wRO9.default);
    }
    _addDefaultMetaSchema() {
        super._addDefaultMetaSchema();
        if (!this.opts.meta) return;
        const metaSchema = this.opts.$data ? this.$dataMetaSchema($fBoo7, META_SUPPORT_DATA) : $fBoo7;
        this.addMetaSchema(metaSchema, META_SCHEMA_ID, false);
        this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
    }
    defaultMeta() {
        return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined);
    }
}
exports.Ajv = Ajv;
module.exports = exports = Ajv;
module.exports.Ajv = Ajv;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Ajv;

var $6qXjM = parcelRequire("6qXjM");
Object.defineProperty(exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $6qXjM.KeywordCxt;
    }
});

var $gQlP2 = parcelRequire("gQlP2");
Object.defineProperty(exports, "_", {
    enumerable: true,
    get: function() {
        return $gQlP2._;
    }
});
Object.defineProperty(exports, "str", {
    enumerable: true,
    get: function() {
        return $gQlP2.str;
    }
});
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function() {
        return $gQlP2.stringify;
    }
});
Object.defineProperty(exports, "nil", {
    enumerable: true,
    get: function() {
        return $gQlP2.nil;
    }
});
Object.defineProperty(exports, "Name", {
    enumerable: true,
    get: function() {
        return $gQlP2.Name;
    }
});
Object.defineProperty(exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $gQlP2.CodeGen;
    }
});

var $7aOSD = parcelRequire("7aOSD");
Object.defineProperty(exports, "ValidationError", {
    enumerable: true,
    get: function() {
        return $7aOSD.default;
    }
});

var $kgLTL = parcelRequire("kgLTL");
Object.defineProperty(exports, "MissingRefError", {
    enumerable: true,
    get: function() {
        return $kgLTL.default;
    }
});

});
parcelRegister("1jcC6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodeGen = module.exports.Name = module.exports.nil = module.exports.stringify = module.exports.str = module.exports._ = module.exports.KeywordCxt = void 0;

var $6qXjM = parcelRequire("6qXjM");
Object.defineProperty(module.exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $6qXjM.KeywordCxt;
    }
});

var $gQlP2 = parcelRequire("gQlP2");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $gQlP2._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $gQlP2.str;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $gQlP2.stringify;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $gQlP2.nil;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $gQlP2.Name;
    }
});
Object.defineProperty(module.exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $gQlP2.CodeGen;
    }
});

var $7aOSD = parcelRequire("7aOSD");

var $kgLTL = parcelRequire("kgLTL");

var $3OQ8t = parcelRequire("3OQ8t");

var $5G1Th = parcelRequire("5G1Th");

var $gQlP2 = parcelRequire("gQlP2");

var $8TcHq = parcelRequire("8TcHq");

var $1fcu2 = parcelRequire("1fcu2");

var $1XGcl = parcelRequire("1XGcl");

var $eNmVS = parcelRequire("eNmVS");

var $8bR6S = parcelRequire("8bR6S");
const $0f41598f99b4f506$var$defaultRegExp = (str, flags)=>new RegExp(str, flags);
$0f41598f99b4f506$var$defaultRegExp.code = "new RegExp";
const $0f41598f99b4f506$var$META_IGNORE_OPTIONS = [
    "removeAdditional",
    "useDefaults",
    "coerceTypes"
];
const $0f41598f99b4f506$var$EXT_SCOPE_NAMES = new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error"
]);
const $0f41598f99b4f506$var$removedOptions = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now."
};
const $0f41598f99b4f506$var$deprecatedOptions = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.'
};
const $0f41598f99b4f506$var$MAX_EXPRESSION = 200;
// eslint-disable-next-line complexity
function $0f41598f99b4f506$var$requiredOptions(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    const s = o.strict;
    const _optz = (_a = o.code) === null || _a === void 0 ? void 0 : _a.optimize;
    const optimize = _optz === true || _optz === undefined ? 1 : _optz || 0;
    const regExp = (_c = (_b = o.code) === null || _b === void 0 ? void 0 : _b.regExp) !== null && _c !== void 0 ? _c : $0f41598f99b4f506$var$defaultRegExp;
    const uriResolver = (_d = o.uriResolver) !== null && _d !== void 0 ? _d : $8bR6S.default;
    return {
        strictSchema: (_f = (_e = o.strictSchema) !== null && _e !== void 0 ? _e : s) !== null && _f !== void 0 ? _f : true,
        strictNumbers: (_h = (_g = o.strictNumbers) !== null && _g !== void 0 ? _g : s) !== null && _h !== void 0 ? _h : true,
        strictTypes: (_k = (_j = o.strictTypes) !== null && _j !== void 0 ? _j : s) !== null && _k !== void 0 ? _k : "log",
        strictTuples: (_m = (_l = o.strictTuples) !== null && _l !== void 0 ? _l : s) !== null && _m !== void 0 ? _m : "log",
        strictRequired: (_p = (_o = o.strictRequired) !== null && _o !== void 0 ? _o : s) !== null && _p !== void 0 ? _p : false,
        code: o.code ? {
            ...o.code,
            optimize: optimize,
            regExp: regExp
        } : {
            optimize: optimize,
            regExp: regExp
        },
        loopRequired: (_q = o.loopRequired) !== null && _q !== void 0 ? _q : $0f41598f99b4f506$var$MAX_EXPRESSION,
        loopEnum: (_r = o.loopEnum) !== null && _r !== void 0 ? _r : $0f41598f99b4f506$var$MAX_EXPRESSION,
        meta: (_s = o.meta) !== null && _s !== void 0 ? _s : true,
        messages: (_t = o.messages) !== null && _t !== void 0 ? _t : true,
        inlineRefs: (_u = o.inlineRefs) !== null && _u !== void 0 ? _u : true,
        schemaId: (_v = o.schemaId) !== null && _v !== void 0 ? _v : "$id",
        addUsedSchema: (_w = o.addUsedSchema) !== null && _w !== void 0 ? _w : true,
        validateSchema: (_x = o.validateSchema) !== null && _x !== void 0 ? _x : true,
        validateFormats: (_y = o.validateFormats) !== null && _y !== void 0 ? _y : true,
        unicodeRegExp: (_z = o.unicodeRegExp) !== null && _z !== void 0 ? _z : true,
        int32range: (_0 = o.int32range) !== null && _0 !== void 0 ? _0 : true,
        uriResolver: uriResolver
    };
}
class $0f41598f99b4f506$var$Ajv {
    constructor(opts = {}){
        this.schemas = {};
        this.refs = {};
        this.formats = Object.create(null);
        this._compilations = new Set();
        this._loading = {};
        this._cache = new Map();
        opts = this.opts = {
            ...opts,
            ...$0f41598f99b4f506$var$requiredOptions(opts)
        };
        const { es5: es5, lines: lines } = this.opts.code;
        this.scope = new $gQlP2.ValueScope({
            scope: {},
            prefixes: $0f41598f99b4f506$var$EXT_SCOPE_NAMES,
            es5: es5,
            lines: lines
        });
        this.logger = $0f41598f99b4f506$var$getLogger(opts.logger);
        const formatOpt = opts.validateFormats;
        opts.validateFormats = false;
        this.RULES = (0, $3OQ8t.getRules)();
        $0f41598f99b4f506$var$checkOptions.call(this, $0f41598f99b4f506$var$removedOptions, opts, "NOT SUPPORTED");
        $0f41598f99b4f506$var$checkOptions.call(this, $0f41598f99b4f506$var$deprecatedOptions, opts, "DEPRECATED", "warn");
        this._metaOpts = $0f41598f99b4f506$var$getMetaSchemaOptions.call(this);
        if (opts.formats) $0f41598f99b4f506$var$addInitialFormats.call(this);
        this._addVocabularies();
        this._addDefaultMetaSchema();
        if (opts.keywords) $0f41598f99b4f506$var$addInitialKeywords.call(this, opts.keywords);
        if (typeof opts.meta == "object") this.addMetaSchema(opts.meta);
        $0f41598f99b4f506$var$addInitialSchemas.call(this);
        opts.validateFormats = formatOpt;
    }
    _addVocabularies() {
        this.addKeyword("$async");
    }
    _addDefaultMetaSchema() {
        const { $data: $data, meta: meta, schemaId: schemaId } = this.opts;
        let _dataRefSchema = $eNmVS;
        if (schemaId === "id") {
            _dataRefSchema = {
                ...$eNmVS
            };
            _dataRefSchema.id = _dataRefSchema.$id;
            delete _dataRefSchema.$id;
        }
        if (meta && $data) this.addMetaSchema(_dataRefSchema, _dataRefSchema[schemaId], false);
    }
    defaultMeta() {
        const { meta: meta, schemaId: schemaId } = this.opts;
        return this.opts.defaultMeta = typeof meta == "object" ? meta[schemaId] || meta : undefined;
    }
    validate(schemaKeyRef, // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    data // to be validated
    ) {
        let v;
        if (typeof schemaKeyRef == "string") {
            v = this.getSchema(schemaKeyRef);
            if (!v) throw new Error(`no schema with key or ref "${schemaKeyRef}"`);
        } else v = this.compile(schemaKeyRef);
        const valid = v(data);
        if (!("$async" in v)) this.errors = v.errors;
        return valid;
    }
    compile(schema, _meta) {
        const sch = this._addSchema(schema, _meta);
        return sch.validate || this._compileSchemaEnv(sch);
    }
    compileAsync(schema, meta) {
        if (typeof this.opts.loadSchema != "function") throw new Error("options.loadSchema should be a function");
        const { loadSchema: loadSchema } = this.opts;
        return runCompileAsync.call(this, schema, meta);
        async function runCompileAsync(_schema, _meta) {
            await loadMetaSchema.call(this, _schema.$schema);
            const sch = this._addSchema(_schema, _meta);
            return sch.validate || _compileAsync.call(this, sch);
        }
        async function loadMetaSchema($ref) {
            if ($ref && !this.getSchema($ref)) await runCompileAsync.call(this, {
                $ref: $ref
            }, true);
        }
        async function _compileAsync(sch) {
            try {
                return this._compileSchemaEnv(sch);
            } catch (e) {
                if (!(e instanceof $kgLTL.default)) throw e;
                checkLoaded.call(this, e);
                await loadMissingSchema.call(this, e.missingSchema);
                return _compileAsync.call(this, sch);
            }
        }
        function checkLoaded({ missingSchema: ref, missingRef: missingRef }) {
            if (this.refs[ref]) throw new Error(`AnySchema ${ref} is loaded but ${missingRef} cannot be resolved`);
        }
        async function loadMissingSchema(ref) {
            const _schema = await _loadSchema.call(this, ref);
            if (!this.refs[ref]) await loadMetaSchema.call(this, _schema.$schema);
            if (!this.refs[ref]) this.addSchema(_schema, ref, meta);
        }
        async function _loadSchema(ref) {
            const p = this._loading[ref];
            if (p) return p;
            try {
                return await (this._loading[ref] = loadSchema(ref));
            } finally{
                delete this._loading[ref];
            }
        }
    }
    // Adds schema to the instance
    addSchema(schema, key, _meta, _validateSchema = this.opts.validateSchema // false to skip schema validation. Used internally, option validateSchema should be used instead.
    ) {
        if (Array.isArray(schema)) {
            for (const sch of schema)this.addSchema(sch, undefined, _meta, _validateSchema);
            return this;
        }
        let id;
        if (typeof schema === "object") {
            const { schemaId: schemaId } = this.opts;
            id = schema[schemaId];
            if (id !== undefined && typeof id != "string") throw new Error(`schema ${schemaId} must be string`);
        }
        key = (0, $8TcHq.normalizeId)(key || id);
        this._checkUnique(key);
        this.schemas[key] = this._addSchema(schema, _meta, key, _validateSchema, true);
        return this;
    }
    // Add schema that will be used to validate other schemas
    // options in META_IGNORE_OPTIONS are alway set to false
    addMetaSchema(schema, key, _validateSchema = this.opts.validateSchema // false to skip schema validation, can be used to override validateSchema option for meta-schema
    ) {
        this.addSchema(schema, key, true, _validateSchema);
        return this;
    }
    //  Validate schema against its meta-schema
    validateSchema(schema, throwOrLogError) {
        if (typeof schema == "boolean") return true;
        let $schema;
        $schema = schema.$schema;
        if ($schema !== undefined && typeof $schema != "string") throw new Error("$schema must be a string");
        $schema = $schema || this.opts.defaultMeta || this.defaultMeta();
        if (!$schema) {
            this.logger.warn("meta-schema not available");
            this.errors = null;
            return true;
        }
        const valid = this.validate($schema, schema);
        if (!valid && throwOrLogError) {
            const message = "schema is invalid: " + this.errorsText();
            if (this.opts.validateSchema === "log") this.logger.error(message);
            else throw new Error(message);
        }
        return valid;
    }
    // Get compiled schema by `key` or `ref`.
    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
    getSchema(keyRef) {
        let sch;
        while(typeof (sch = $0f41598f99b4f506$var$getSchEnv.call(this, keyRef)) == "string")keyRef = sch;
        if (sch === undefined) {
            const { schemaId: schemaId } = this.opts;
            const root = new $5G1Th.SchemaEnv({
                schema: {},
                schemaId: schemaId
            });
            sch = $5G1Th.resolveSchema.call(this, root, keyRef);
            if (!sch) return;
            this.refs[keyRef] = sch;
        }
        return sch.validate || this._compileSchemaEnv(sch);
    }
    // Remove cached schema(s).
    // If no parameter is passed all schemas but meta-schemas are removed.
    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
    removeSchema(schemaKeyRef) {
        if (schemaKeyRef instanceof RegExp) {
            this._removeAllSchemas(this.schemas, schemaKeyRef);
            this._removeAllSchemas(this.refs, schemaKeyRef);
            return this;
        }
        switch(typeof schemaKeyRef){
            case "undefined":
                this._removeAllSchemas(this.schemas);
                this._removeAllSchemas(this.refs);
                this._cache.clear();
                return this;
            case "string":
                {
                    const sch = $0f41598f99b4f506$var$getSchEnv.call(this, schemaKeyRef);
                    if (typeof sch == "object") this._cache.delete(sch.schema);
                    delete this.schemas[schemaKeyRef];
                    delete this.refs[schemaKeyRef];
                    return this;
                }
            case "object":
                {
                    const cacheKey = schemaKeyRef;
                    this._cache.delete(cacheKey);
                    let id = schemaKeyRef[this.opts.schemaId];
                    if (id) {
                        id = (0, $8TcHq.normalizeId)(id);
                        delete this.schemas[id];
                        delete this.refs[id];
                    }
                    return this;
                }
            default:
                throw new Error("ajv.removeSchema: invalid parameter");
        }
    }
    // add "vocabulary" - a collection of keywords
    addVocabulary(definitions) {
        for (const def of definitions)this.addKeyword(def);
        return this;
    }
    addKeyword(kwdOrDef, def // deprecated
    ) {
        let keyword;
        if (typeof kwdOrDef == "string") {
            keyword = kwdOrDef;
            if (typeof def == "object") {
                this.logger.warn("these parameters are deprecated, see docs for addKeyword");
                def.keyword = keyword;
            }
        } else if (typeof kwdOrDef == "object" && def === undefined) {
            def = kwdOrDef;
            keyword = def.keyword;
            if (Array.isArray(keyword) && !keyword.length) throw new Error("addKeywords: keyword must be string or non-empty array");
        } else throw new Error("invalid addKeywords parameters");
        $0f41598f99b4f506$var$checkKeyword.call(this, keyword, def);
        if (!def) {
            (0, $1XGcl.eachItem)(keyword, (kwd)=>$0f41598f99b4f506$var$addRule.call(this, kwd));
            return this;
        }
        $0f41598f99b4f506$var$keywordMetaschema.call(this, def);
        const definition = {
            ...def,
            type: (0, $1fcu2.getJSONTypes)(def.type),
            schemaType: (0, $1fcu2.getJSONTypes)(def.schemaType)
        };
        (0, $1XGcl.eachItem)(keyword, definition.type.length === 0 ? (k)=>$0f41598f99b4f506$var$addRule.call(this, k, definition) : (k)=>definition.type.forEach((t)=>$0f41598f99b4f506$var$addRule.call(this, k, definition, t)));
        return this;
    }
    getKeyword(keyword) {
        const rule = this.RULES.all[keyword];
        return typeof rule == "object" ? rule.definition : !!rule;
    }
    // Remove keyword
    removeKeyword(keyword) {
        // TODO return type should be Ajv
        const { RULES: RULES } = this;
        delete RULES.keywords[keyword];
        delete RULES.all[keyword];
        for (const group of RULES.rules){
            const i = group.rules.findIndex((rule)=>rule.keyword === keyword);
            if (i >= 0) group.rules.splice(i, 1);
        }
        return this;
    }
    // Add format
    addFormat(name, format) {
        if (typeof format == "string") format = new RegExp(format);
        this.formats[name] = format;
        return this;
    }
    errorsText(errors = this.errors, { separator: separator = ", ", dataVar: dataVar = "data" } = {} // optional options with properties `separator` and `dataVar`
    ) {
        if (!errors || errors.length === 0) return "No errors";
        return errors.map((e)=>`${dataVar}${e.instancePath} ${e.message}`).reduce((text, msg)=>text + separator + msg);
    }
    $dataMetaSchema(metaSchema, keywordsJsonPointers) {
        const rules = this.RULES.all;
        metaSchema = JSON.parse(JSON.stringify(metaSchema));
        for (const jsonPointer of keywordsJsonPointers){
            const segments = jsonPointer.split("/").slice(1); // first segment is an empty string
            let keywords = metaSchema;
            for (const seg of segments)keywords = keywords[seg];
            for(const key in rules){
                const rule = rules[key];
                if (typeof rule != "object") continue;
                const { $data: $data } = rule.definition;
                const schema = keywords[key];
                if ($data && schema) keywords[key] = $0f41598f99b4f506$var$schemaOrData(schema);
            }
        }
        return metaSchema;
    }
    _removeAllSchemas(schemas, regex) {
        for(const keyRef in schemas){
            const sch = schemas[keyRef];
            if (!regex || regex.test(keyRef)) {
                if (typeof sch == "string") delete schemas[keyRef];
                else if (sch && !sch.meta) {
                    this._cache.delete(sch.schema);
                    delete schemas[keyRef];
                }
            }
        }
    }
    _addSchema(schema, meta, baseId, validateSchema = this.opts.validateSchema, addSchema = this.opts.addUsedSchema) {
        let id;
        const { schemaId: schemaId } = this.opts;
        if (typeof schema == "object") id = schema[schemaId];
        else {
            if (this.opts.jtd) throw new Error("schema must be object");
            else if (typeof schema != "boolean") throw new Error("schema must be object or boolean");
        }
        let sch = this._cache.get(schema);
        if (sch !== undefined) return sch;
        baseId = (0, $8TcHq.normalizeId)(id || baseId);
        const localRefs = $8TcHq.getSchemaRefs.call(this, schema, baseId);
        sch = new $5G1Th.SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            meta: meta,
            baseId: baseId,
            localRefs: localRefs
        });
        this._cache.set(sch.schema, sch);
        if (addSchema && !baseId.startsWith("#")) {
            // TODO atm it is allowed to overwrite schemas without id (instead of not adding them)
            if (baseId) this._checkUnique(baseId);
            this.refs[baseId] = sch;
        }
        if (validateSchema) this.validateSchema(schema, true);
        return sch;
    }
    _checkUnique(id) {
        if (this.schemas[id] || this.refs[id]) throw new Error(`schema with key or id "${id}" already exists`);
    }
    _compileSchemaEnv(sch) {
        if (sch.meta) this._compileMetaSchema(sch);
        else $5G1Th.compileSchema.call(this, sch);
        /* istanbul ignore if */ if (!sch.validate) throw new Error("ajv implementation error");
        return sch.validate;
    }
    _compileMetaSchema(sch) {
        const currentOpts = this.opts;
        this.opts = this._metaOpts;
        try {
            $5G1Th.compileSchema.call(this, sch);
        } finally{
            this.opts = currentOpts;
        }
    }
}
$0f41598f99b4f506$var$Ajv.ValidationError = $7aOSD.default;
$0f41598f99b4f506$var$Ajv.MissingRefError = $kgLTL.default;
module.exports.default = $0f41598f99b4f506$var$Ajv;
function $0f41598f99b4f506$var$checkOptions(checkOpts, options, msg, log = "error") {
    for(const key in checkOpts){
        const opt = key;
        if (opt in options) this.logger[log](`${msg}: option ${key}. ${checkOpts[opt]}`);
    }
}
function $0f41598f99b4f506$var$getSchEnv(keyRef) {
    keyRef = (0, $8TcHq.normalizeId)(keyRef); // TODO tests fail without this line
    return this.schemas[keyRef] || this.refs[keyRef];
}
function $0f41598f99b4f506$var$addInitialSchemas() {
    const optsSchemas = this.opts.schemas;
    if (!optsSchemas) return;
    if (Array.isArray(optsSchemas)) this.addSchema(optsSchemas);
    else for(const key in optsSchemas)this.addSchema(optsSchemas[key], key);
}
function $0f41598f99b4f506$var$addInitialFormats() {
    for(const name in this.opts.formats){
        const format = this.opts.formats[name];
        if (format) this.addFormat(name, format);
    }
}
function $0f41598f99b4f506$var$addInitialKeywords(defs) {
    if (Array.isArray(defs)) {
        this.addVocabulary(defs);
        return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for(const keyword in defs){
        const def = defs[keyword];
        if (!def.keyword) def.keyword = keyword;
        this.addKeyword(def);
    }
}
function $0f41598f99b4f506$var$getMetaSchemaOptions() {
    const metaOpts = {
        ...this.opts
    };
    for (const opt of $0f41598f99b4f506$var$META_IGNORE_OPTIONS)delete metaOpts[opt];
    return metaOpts;
}
const $0f41598f99b4f506$var$noLogs = {
    log () {},
    warn () {},
    error () {}
};
function $0f41598f99b4f506$var$getLogger(logger) {
    if (logger === false) return $0f41598f99b4f506$var$noLogs;
    if (logger === undefined) return console;
    if (logger.log && logger.warn && logger.error) return logger;
    throw new Error("logger must implement log, warn and error methods");
}
const $0f41598f99b4f506$var$KEYWORD_NAME = /^[a-z_$][a-z0-9_$:-]*$/i;
function $0f41598f99b4f506$var$checkKeyword(keyword, def) {
    const { RULES: RULES } = this;
    (0, $1XGcl.eachItem)(keyword, (kwd)=>{
        if (RULES.keywords[kwd]) throw new Error(`Keyword ${kwd} is already defined`);
        if (!$0f41598f99b4f506$var$KEYWORD_NAME.test(kwd)) throw new Error(`Keyword ${kwd} has invalid name`);
    });
    if (!def) return;
    if (def.$data && !("code" in def || "validate" in def)) throw new Error('$data keyword must have "code" or "validate" function');
}
function $0f41598f99b4f506$var$addRule(keyword, definition, dataType) {
    var _a;
    const post = definition === null || definition === void 0 ? void 0 : definition.post;
    if (dataType && post) throw new Error('keyword with "post" flag cannot have "type"');
    const { RULES: RULES } = this;
    let ruleGroup = post ? RULES.post : RULES.rules.find(({ type: t })=>t === dataType);
    if (!ruleGroup) {
        ruleGroup = {
            type: dataType,
            rules: []
        };
        RULES.rules.push(ruleGroup);
    }
    RULES.keywords[keyword] = true;
    if (!definition) return;
    const rule = {
        keyword: keyword,
        definition: {
            ...definition,
            type: (0, $1fcu2.getJSONTypes)(definition.type),
            schemaType: (0, $1fcu2.getJSONTypes)(definition.schemaType)
        }
    };
    if (definition.before) $0f41598f99b4f506$var$addBeforeRule.call(this, ruleGroup, rule, definition.before);
    else ruleGroup.rules.push(rule);
    RULES.all[keyword] = rule;
    (_a = definition.implements) === null || _a === void 0 || _a.forEach((kwd)=>this.addKeyword(kwd));
}
function $0f41598f99b4f506$var$addBeforeRule(ruleGroup, rule, before) {
    const i = ruleGroup.rules.findIndex((_rule)=>_rule.keyword === before);
    if (i >= 0) ruleGroup.rules.splice(i, 0, rule);
    else {
        ruleGroup.rules.push(rule);
        this.logger.warn(`rule ${before} is not defined`);
    }
}
function $0f41598f99b4f506$var$keywordMetaschema(def) {
    let { metaSchema: metaSchema } = def;
    if (metaSchema === undefined) return;
    if (def.$data && this.opts.$data) metaSchema = $0f41598f99b4f506$var$schemaOrData(metaSchema);
    def.validateSchema = this.compile(metaSchema, true);
}
const $0f41598f99b4f506$var$$dataRef = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
};
function $0f41598f99b4f506$var$schemaOrData(schema) {
    return {
        anyOf: [
            schema,
            $0f41598f99b4f506$var$$dataRef
        ]
    };
}

});
parcelRegister("6qXjM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getData = module.exports.KeywordCxt = module.exports.validateFunctionCode = void 0;

var $6Ljew = parcelRequire("6Ljew");

var $1fcu2 = parcelRequire("1fcu2");

var $7PRwo = parcelRequire("7PRwo");

var $1fcu2 = parcelRequire("1fcu2");

var $7r2tH = parcelRequire("7r2tH");

var $fy2SA = parcelRequire("fy2SA");

var $jvI7z = parcelRequire("jvI7z");

var $gQlP2 = parcelRequire("gQlP2");

var $jfMv8 = parcelRequire("jfMv8");

var $8TcHq = parcelRequire("8TcHq");

var $1XGcl = parcelRequire("1XGcl");

var $fg3x0 = parcelRequire("fg3x0");
// schema compilation - generates validation function, subschemaCode (below) is used for subschemas
function $4af32f1de7534d44$var$validateFunctionCode(it) {
    if ($4af32f1de7534d44$var$isSchemaObj(it)) {
        $4af32f1de7534d44$var$checkKeywords(it);
        if ($4af32f1de7534d44$var$schemaCxtHasRules(it)) {
            $4af32f1de7534d44$var$topSchemaObjCode(it);
            return;
        }
    }
    $4af32f1de7534d44$var$validateFunction(it, ()=>(0, $6Ljew.topBoolOrEmptySchema)(it));
}
module.exports.validateFunctionCode = $4af32f1de7534d44$var$validateFunctionCode;
function $4af32f1de7534d44$var$validateFunction({ gen: gen, validateName: validateName, schema: schema, schemaEnv: schemaEnv, opts: opts }, body) {
    if (opts.code.es5) gen.func(validateName, (0, $gQlP2._)`${$jfMv8.default.data}, ${$jfMv8.default.valCxt}`, schemaEnv.$async, ()=>{
        gen.code((0, $gQlP2._)`"use strict"; ${$4af32f1de7534d44$var$funcSourceUrl(schema, opts)}`);
        $4af32f1de7534d44$var$destructureValCxtES5(gen, opts);
        gen.code(body);
    });
    else gen.func(validateName, (0, $gQlP2._)`${$jfMv8.default.data}, ${$4af32f1de7534d44$var$destructureValCxt(opts)}`, schemaEnv.$async, ()=>gen.code($4af32f1de7534d44$var$funcSourceUrl(schema, opts)).code(body));
}
function $4af32f1de7534d44$var$destructureValCxt(opts) {
    return (0, $gQlP2._)`{${$jfMv8.default.instancePath}="", ${$jfMv8.default.parentData}, ${$jfMv8.default.parentDataProperty}, ${$jfMv8.default.rootData}=${$jfMv8.default.data}${opts.dynamicRef ? (0, $gQlP2._)`, ${$jfMv8.default.dynamicAnchors}={}` : $gQlP2.nil}}={}`;
}
function $4af32f1de7534d44$var$destructureValCxtES5(gen, opts) {
    gen.if($jfMv8.default.valCxt, ()=>{
        gen.var($jfMv8.default.instancePath, (0, $gQlP2._)`${$jfMv8.default.valCxt}.${$jfMv8.default.instancePath}`);
        gen.var($jfMv8.default.parentData, (0, $gQlP2._)`${$jfMv8.default.valCxt}.${$jfMv8.default.parentData}`);
        gen.var($jfMv8.default.parentDataProperty, (0, $gQlP2._)`${$jfMv8.default.valCxt}.${$jfMv8.default.parentDataProperty}`);
        gen.var($jfMv8.default.rootData, (0, $gQlP2._)`${$jfMv8.default.valCxt}.${$jfMv8.default.rootData}`);
        if (opts.dynamicRef) gen.var($jfMv8.default.dynamicAnchors, (0, $gQlP2._)`${$jfMv8.default.valCxt}.${$jfMv8.default.dynamicAnchors}`);
    }, ()=>{
        gen.var($jfMv8.default.instancePath, (0, $gQlP2._)`""`);
        gen.var($jfMv8.default.parentData, (0, $gQlP2._)`undefined`);
        gen.var($jfMv8.default.parentDataProperty, (0, $gQlP2._)`undefined`);
        gen.var($jfMv8.default.rootData, $jfMv8.default.data);
        if (opts.dynamicRef) gen.var($jfMv8.default.dynamicAnchors, (0, $gQlP2._)`{}`);
    });
}
function $4af32f1de7534d44$var$topSchemaObjCode(it) {
    const { schema: schema, opts: opts, gen: gen } = it;
    $4af32f1de7534d44$var$validateFunction(it, ()=>{
        if (opts.$comment && schema.$comment) $4af32f1de7534d44$var$commentKeyword(it);
        $4af32f1de7534d44$var$checkNoDefault(it);
        gen.let($jfMv8.default.vErrors, null);
        gen.let($jfMv8.default.errors, 0);
        if (opts.unevaluated) $4af32f1de7534d44$var$resetEvaluated(it);
        $4af32f1de7534d44$var$typeAndKeywords(it);
        $4af32f1de7534d44$var$returnResults(it);
    });
    return;
}
function $4af32f1de7534d44$var$resetEvaluated(it) {
    // TODO maybe some hook to execute it in the end to check whether props/items are Name, as in assignEvaluated
    const { gen: gen, validateName: validateName } = it;
    it.evaluated = gen.const("evaluated", (0, $gQlP2._)`${validateName}.evaluated`);
    gen.if((0, $gQlP2._)`${it.evaluated}.dynamicProps`, ()=>gen.assign((0, $gQlP2._)`${it.evaluated}.props`, (0, $gQlP2._)`undefined`));
    gen.if((0, $gQlP2._)`${it.evaluated}.dynamicItems`, ()=>gen.assign((0, $gQlP2._)`${it.evaluated}.items`, (0, $gQlP2._)`undefined`));
}
function $4af32f1de7534d44$var$funcSourceUrl(schema, opts) {
    const schId = typeof schema == "object" && schema[opts.schemaId];
    return schId && (opts.code.source || opts.code.process) ? (0, $gQlP2._)`/*# sourceURL=${schId} */` : $gQlP2.nil;
}
// schema compilation - this function is used recursively to generate code for sub-schemas
function $4af32f1de7534d44$var$subschemaCode(it, valid) {
    if ($4af32f1de7534d44$var$isSchemaObj(it)) {
        $4af32f1de7534d44$var$checkKeywords(it);
        if ($4af32f1de7534d44$var$schemaCxtHasRules(it)) {
            $4af32f1de7534d44$var$subSchemaObjCode(it, valid);
            return;
        }
    }
    (0, $6Ljew.boolOrEmptySchema)(it, valid);
}
function $4af32f1de7534d44$var$schemaCxtHasRules({ schema: schema, self: self }) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (self.RULES.all[key]) return true;
    return false;
}
function $4af32f1de7534d44$var$isSchemaObj(it) {
    return typeof it.schema != "boolean";
}
function $4af32f1de7534d44$var$subSchemaObjCode(it, valid) {
    const { schema: schema, gen: gen, opts: opts } = it;
    if (opts.$comment && schema.$comment) $4af32f1de7534d44$var$commentKeyword(it);
    $4af32f1de7534d44$var$updateContext(it);
    $4af32f1de7534d44$var$checkAsyncSchema(it);
    const errsCount = gen.const("_errs", $jfMv8.default.errors);
    $4af32f1de7534d44$var$typeAndKeywords(it, errsCount);
    // TODO var
    gen.var(valid, (0, $gQlP2._)`${errsCount} === ${$jfMv8.default.errors}`);
}
function $4af32f1de7534d44$var$checkKeywords(it) {
    (0, $1XGcl.checkUnknownRules)(it);
    $4af32f1de7534d44$var$checkRefsAndKeywords(it);
}
function $4af32f1de7534d44$var$typeAndKeywords(it, errsCount) {
    if (it.opts.jtd) return $4af32f1de7534d44$var$schemaKeywords(it, [], false, errsCount);
    const types = (0, $1fcu2.getSchemaTypes)(it.schema);
    const checkedTypes = (0, $1fcu2.coerceAndCheckDataType)(it, types);
    $4af32f1de7534d44$var$schemaKeywords(it, types, !checkedTypes, errsCount);
}
function $4af32f1de7534d44$var$checkRefsAndKeywords(it) {
    const { schema: schema, errSchemaPath: errSchemaPath, opts: opts, self: self } = it;
    if (schema.$ref && opts.ignoreKeywordsWithRef && (0, $1XGcl.schemaHasRulesButRef)(schema, self.RULES)) self.logger.warn(`$ref: keywords ignored in schema at path "${errSchemaPath}"`);
}
function $4af32f1de7534d44$var$checkNoDefault(it) {
    const { schema: schema, opts: opts } = it;
    if (schema.default !== undefined && opts.useDefaults && opts.strictSchema) (0, $1XGcl.checkStrictMode)(it, "default is ignored in the schema root");
}
function $4af32f1de7534d44$var$updateContext(it) {
    const schId = it.schema[it.opts.schemaId];
    if (schId) it.baseId = (0, $8TcHq.resolveUrl)(it.opts.uriResolver, it.baseId, schId);
}
function $4af32f1de7534d44$var$checkAsyncSchema(it) {
    if (it.schema.$async && !it.schemaEnv.$async) throw new Error("async schema in sync schema");
}
function $4af32f1de7534d44$var$commentKeyword({ gen: gen, schemaEnv: schemaEnv, schema: schema, errSchemaPath: errSchemaPath, opts: opts }) {
    const msg = schema.$comment;
    if (opts.$comment === true) gen.code((0, $gQlP2._)`${$jfMv8.default.self}.logger.log(${msg})`);
    else if (typeof opts.$comment == "function") {
        const schemaPath = (0, $gQlP2.str)`${errSchemaPath}/$comment`;
        const rootName = gen.scopeValue("root", {
            ref: schemaEnv.root
        });
        gen.code((0, $gQlP2._)`${$jfMv8.default.self}.opts.$comment(${msg}, ${schemaPath}, ${rootName}.schema)`);
    }
}
function $4af32f1de7534d44$var$returnResults(it) {
    const { gen: gen, schemaEnv: schemaEnv, validateName: validateName, ValidationError: ValidationError, opts: opts } = it;
    if (schemaEnv.$async) // TODO assign unevaluated
    gen.if((0, $gQlP2._)`${$jfMv8.default.errors} === 0`, ()=>gen.return($jfMv8.default.data), ()=>gen.throw((0, $gQlP2._)`new ${ValidationError}(${$jfMv8.default.vErrors})`));
    else {
        gen.assign((0, $gQlP2._)`${validateName}.errors`, $jfMv8.default.vErrors);
        if (opts.unevaluated) $4af32f1de7534d44$var$assignEvaluated(it);
        gen.return((0, $gQlP2._)`${$jfMv8.default.errors} === 0`);
    }
}
function $4af32f1de7534d44$var$assignEvaluated({ gen: gen, evaluated: evaluated, props: props, items: items }) {
    if (props instanceof $gQlP2.Name) gen.assign((0, $gQlP2._)`${evaluated}.props`, props);
    if (items instanceof $gQlP2.Name) gen.assign((0, $gQlP2._)`${evaluated}.items`, items);
}
function $4af32f1de7534d44$var$schemaKeywords(it, types, typeErrors, errsCount) {
    const { gen: gen, schema: schema, data: data, allErrors: allErrors, opts: opts, self: self } = it;
    const { RULES: RULES } = self;
    if (schema.$ref && (opts.ignoreKeywordsWithRef || !(0, $1XGcl.schemaHasRulesButRef)(schema, RULES))) {
        gen.block(()=>$4af32f1de7534d44$var$keywordCode(it, "$ref", RULES.all.$ref.definition)); // TODO typecast
        return;
    }
    if (!opts.jtd) $4af32f1de7534d44$var$checkStrictTypes(it, types);
    gen.block(()=>{
        for (const group of RULES.rules)groupKeywords(group);
        groupKeywords(RULES.post);
    });
    function groupKeywords(group) {
        if (!(0, $7PRwo.shouldUseGroup)(schema, group)) return;
        if (group.type) {
            gen.if((0, $1fcu2.checkDataType)(group.type, data, opts.strictNumbers));
            $4af32f1de7534d44$var$iterateKeywords(it, group);
            if (types.length === 1 && types[0] === group.type && typeErrors) {
                gen.else();
                (0, $1fcu2.reportTypeError)(it);
            }
            gen.endIf();
        } else $4af32f1de7534d44$var$iterateKeywords(it, group);
        // TODO make it "ok" call?
        if (!allErrors) gen.if((0, $gQlP2._)`${$jfMv8.default.errors} === ${errsCount || 0}`);
    }
}
function $4af32f1de7534d44$var$iterateKeywords(it, group) {
    const { gen: gen, schema: schema, opts: { useDefaults: useDefaults } } = it;
    if (useDefaults) (0, $7r2tH.assignDefaults)(it, group.type);
    gen.block(()=>{
        for (const rule of group.rules)if ((0, $7PRwo.shouldUseRule)(schema, rule)) $4af32f1de7534d44$var$keywordCode(it, rule.keyword, rule.definition, group.type);
    });
}
function $4af32f1de7534d44$var$checkStrictTypes(it, types) {
    if (it.schemaEnv.meta || !it.opts.strictTypes) return;
    $4af32f1de7534d44$var$checkContextTypes(it, types);
    if (!it.opts.allowUnionTypes) $4af32f1de7534d44$var$checkMultipleTypes(it, types);
    $4af32f1de7534d44$var$checkKeywordTypes(it, it.dataTypes);
}
function $4af32f1de7534d44$var$checkContextTypes(it, types) {
    if (!types.length) return;
    if (!it.dataTypes.length) {
        it.dataTypes = types;
        return;
    }
    types.forEach((t)=>{
        if (!$4af32f1de7534d44$var$includesType(it.dataTypes, t)) $4af32f1de7534d44$var$strictTypesError(it, `type "${t}" not allowed by context "${it.dataTypes.join(",")}"`);
    });
    $4af32f1de7534d44$var$narrowSchemaTypes(it, types);
}
function $4af32f1de7534d44$var$checkMultipleTypes(it, ts) {
    if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) $4af32f1de7534d44$var$strictTypesError(it, "use allowUnionTypes to allow union type keyword");
}
function $4af32f1de7534d44$var$checkKeywordTypes(it, ts) {
    const rules = it.self.RULES.all;
    for(const keyword in rules){
        const rule = rules[keyword];
        if (typeof rule == "object" && (0, $7PRwo.shouldUseRule)(it.schema, rule)) {
            const { type: type } = rule.definition;
            if (type.length && !type.some((t)=>$4af32f1de7534d44$var$hasApplicableType(ts, t))) $4af32f1de7534d44$var$strictTypesError(it, `missing type "${type.join(",")}" for keyword "${keyword}"`);
        }
    }
}
function $4af32f1de7534d44$var$hasApplicableType(schTs, kwdT) {
    return schTs.includes(kwdT) || kwdT === "number" && schTs.includes("integer");
}
function $4af32f1de7534d44$var$includesType(ts, t) {
    return ts.includes(t) || t === "integer" && ts.includes("number");
}
function $4af32f1de7534d44$var$narrowSchemaTypes(it, withTypes) {
    const ts = [];
    for (const t of it.dataTypes){
        if ($4af32f1de7534d44$var$includesType(withTypes, t)) ts.push(t);
        else if (withTypes.includes("integer") && t === "number") ts.push("integer");
    }
    it.dataTypes = ts;
}
function $4af32f1de7534d44$var$strictTypesError(it, msg) {
    const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
    msg += ` at "${schemaPath}" (strictTypes)`;
    (0, $1XGcl.checkStrictMode)(it, msg, it.opts.strictTypes);
}
class $4af32f1de7534d44$var$KeywordCxt {
    constructor(it, def, keyword){
        (0, $fy2SA.validateKeywordUsage)(it, def, keyword);
        this.gen = it.gen;
        this.allErrors = it.allErrors;
        this.keyword = keyword;
        this.data = it.data;
        this.schema = it.schema[keyword];
        this.$data = def.$data && it.opts.$data && this.schema && this.schema.$data;
        this.schemaValue = (0, $1XGcl.schemaRefOrVal)(it, this.schema, keyword, this.$data);
        this.schemaType = def.schemaType;
        this.parentSchema = it.schema;
        this.params = {};
        this.it = it;
        this.def = def;
        if (this.$data) this.schemaCode = it.gen.const("vSchema", $4af32f1de7534d44$var$getData(this.$data, it));
        else {
            this.schemaCode = this.schemaValue;
            if (!(0, $fy2SA.validSchemaType)(this.schema, def.schemaType, def.allowUndefined)) throw new Error(`${keyword} value must be ${JSON.stringify(def.schemaType)}`);
        }
        if ("code" in def ? def.trackErrors : def.errors !== false) this.errsCount = it.gen.const("_errs", $jfMv8.default.errors);
    }
    result(condition, successAction, failAction) {
        this.failResult((0, $gQlP2.not)(condition), successAction, failAction);
    }
    failResult(condition, successAction, failAction) {
        this.gen.if(condition);
        if (failAction) failAction();
        else this.error();
        if (successAction) {
            this.gen.else();
            successAction();
            if (this.allErrors) this.gen.endIf();
        } else if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    pass(condition, failAction) {
        this.failResult((0, $gQlP2.not)(condition), undefined, failAction);
    }
    fail(condition) {
        if (condition === undefined) {
            this.error();
            if (!this.allErrors) this.gen.if(false); // this branch will be removed by gen.optimize
            return;
        }
        this.gen.if(condition);
        this.error();
        if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    fail$data(condition) {
        if (!this.$data) return this.fail(condition);
        const { schemaCode: schemaCode } = this;
        this.fail((0, $gQlP2._)`${schemaCode} !== undefined && (${(0, $gQlP2.or)(this.invalid$data(), condition)})`);
    }
    error(append, errorParams, errorPaths) {
        if (errorParams) {
            this.setParams(errorParams);
            this._error(append, errorPaths);
            this.setParams({});
            return;
        }
        this._error(append, errorPaths);
    }
    _error(append, errorPaths) {
        (append ? $fg3x0.reportExtraError : $fg3x0.reportError)(this, this.def.error, errorPaths);
    }
    $dataError() {
        (0, $fg3x0.reportError)(this, this.def.$dataError || $fg3x0.keyword$DataError);
    }
    reset() {
        if (this.errsCount === undefined) throw new Error('add "trackErrors" to keyword definition');
        (0, $fg3x0.resetErrorsCount)(this.gen, this.errsCount);
    }
    ok(cond) {
        if (!this.allErrors) this.gen.if(cond);
    }
    setParams(obj, assign) {
        if (assign) Object.assign(this.params, obj);
        else this.params = obj;
    }
    block$data(valid, codeBlock, $dataValid = $gQlP2.nil) {
        this.gen.block(()=>{
            this.check$data(valid, $dataValid);
            codeBlock();
        });
    }
    check$data(valid = $gQlP2.nil, $dataValid = $gQlP2.nil) {
        if (!this.$data) return;
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def } = this;
        gen.if((0, $gQlP2.or)((0, $gQlP2._)`${schemaCode} === undefined`, $dataValid));
        if (valid !== $gQlP2.nil) gen.assign(valid, true);
        if (schemaType.length || def.validateSchema) {
            gen.elseIf(this.invalid$data());
            this.$dataError();
            if (valid !== $gQlP2.nil) gen.assign(valid, false);
        }
        gen.else();
    }
    invalid$data() {
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def, it: it } = this;
        return (0, $gQlP2.or)(wrong$DataType(), invalid$DataSchema());
        function wrong$DataType() {
            if (schemaType.length) {
                /* istanbul ignore if */ if (!(schemaCode instanceof $gQlP2.Name)) throw new Error("ajv implementation error");
                const st = Array.isArray(schemaType) ? schemaType : [
                    schemaType
                ];
                return (0, $gQlP2._)`${(0, $1fcu2.checkDataTypes)(st, schemaCode, it.opts.strictNumbers, $1fcu2.DataType.Wrong)}`;
            }
            return $gQlP2.nil;
        }
        function invalid$DataSchema() {
            if (def.validateSchema) {
                const validateSchemaRef = gen.scopeValue("validate$data", {
                    ref: def.validateSchema
                }); // TODO value.code for standalone
                return (0, $gQlP2._)`!${validateSchemaRef}(${schemaCode})`;
            }
            return $gQlP2.nil;
        }
    }
    subschema(appl, valid) {
        const subschema = (0, $jvI7z.getSubschema)(this.it, appl);
        (0, $jvI7z.extendSubschemaData)(subschema, this.it, appl);
        (0, $jvI7z.extendSubschemaMode)(subschema, appl);
        const nextContext = {
            ...this.it,
            ...subschema,
            items: undefined,
            props: undefined
        };
        $4af32f1de7534d44$var$subschemaCode(nextContext, valid);
        return nextContext;
    }
    mergeEvaluated(schemaCxt, toName) {
        const { it: it, gen: gen } = this;
        if (!it.opts.unevaluated) return;
        if (it.props !== true && schemaCxt.props !== undefined) it.props = $1XGcl.mergeEvaluated.props(gen, schemaCxt.props, it.props, toName);
        if (it.items !== true && schemaCxt.items !== undefined) it.items = $1XGcl.mergeEvaluated.items(gen, schemaCxt.items, it.items, toName);
    }
    mergeValidEvaluated(schemaCxt, valid) {
        const { it: it, gen: gen } = this;
        if (it.opts.unevaluated && (it.props !== true || it.items !== true)) {
            gen.if(valid, ()=>this.mergeEvaluated(schemaCxt, $gQlP2.Name));
            return true;
        }
    }
}
module.exports.KeywordCxt = $4af32f1de7534d44$var$KeywordCxt;
function $4af32f1de7534d44$var$keywordCode(it, keyword, def, ruleType) {
    const cxt = new $4af32f1de7534d44$var$KeywordCxt(it, def, keyword);
    if ("code" in def) def.code(cxt, ruleType);
    else if (cxt.$data && def.validate) (0, $fy2SA.funcKeywordCode)(cxt, def);
    else if ("macro" in def) (0, $fy2SA.macroKeywordCode)(cxt, def);
    else if (def.compile || def.validate) (0, $fy2SA.funcKeywordCode)(cxt, def);
}
const $4af32f1de7534d44$var$JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
const $4af32f1de7534d44$var$RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function $4af32f1de7534d44$var$getData($data, { dataLevel: dataLevel, dataNames: dataNames, dataPathArr: dataPathArr }) {
    let jsonPointer;
    let data;
    if ($data === "") return $jfMv8.default.rootData;
    if ($data[0] === "/") {
        if (!$4af32f1de7534d44$var$JSON_POINTER.test($data)) throw new Error(`Invalid JSON-pointer: ${$data}`);
        jsonPointer = $data;
        data = $jfMv8.default.rootData;
    } else {
        const matches = $4af32f1de7534d44$var$RELATIVE_JSON_POINTER.exec($data);
        if (!matches) throw new Error(`Invalid JSON-pointer: ${$data}`);
        const up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer === "#") {
            if (up >= dataLevel) throw new Error(errorMsg("property/index", up));
            return dataPathArr[dataLevel - up];
        }
        if (up > dataLevel) throw new Error(errorMsg("data", up));
        data = dataNames[dataLevel - up];
        if (!jsonPointer) return data;
    }
    let expr = data;
    const segments = jsonPointer.split("/");
    for (const segment of segments)if (segment) {
        data = (0, $gQlP2._)`${data}${(0, $gQlP2.getProperty)((0, $1XGcl.unescapeJsonPointer)(segment))}`;
        expr = (0, $gQlP2._)`${expr} && ${data}`;
    }
    return expr;
    function errorMsg(pointerType, up) {
        return `Cannot access ${pointerType} ${up} levels up, current level is ${dataLevel}`;
    }
}
module.exports.getData = $4af32f1de7534d44$var$getData;

});
parcelRegister("6Ljew", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.boolOrEmptySchema = module.exports.topBoolOrEmptySchema = void 0;

var $fg3x0 = parcelRequire("fg3x0");

var $gQlP2 = parcelRequire("gQlP2");

var $jfMv8 = parcelRequire("jfMv8");
const $4ec60d29f5c57869$var$boolError = {
    message: "boolean schema is false"
};
function $4ec60d29f5c57869$var$topBoolOrEmptySchema(it) {
    const { gen: gen, schema: schema, validateName: validateName } = it;
    if (schema === false) $4ec60d29f5c57869$var$falseSchemaError(it, false);
    else if (typeof schema == "object" && schema.$async === true) gen.return($jfMv8.default.data);
    else {
        gen.assign((0, $gQlP2._)`${validateName}.errors`, null);
        gen.return(true);
    }
}
module.exports.topBoolOrEmptySchema = $4ec60d29f5c57869$var$topBoolOrEmptySchema;
function $4ec60d29f5c57869$var$boolOrEmptySchema(it, valid) {
    const { gen: gen, schema: schema } = it;
    if (schema === false) {
        gen.var(valid, false); // TODO var
        $4ec60d29f5c57869$var$falseSchemaError(it);
    } else gen.var(valid, true); // TODO var
}
module.exports.boolOrEmptySchema = $4ec60d29f5c57869$var$boolOrEmptySchema;
function $4ec60d29f5c57869$var$falseSchemaError(it, overrideAllErrors) {
    const { gen: gen, data: data } = it;
    // TODO maybe some other interface should be used for non-keyword validation errors...
    const cxt = {
        gen: gen,
        keyword: "false schema",
        data: data,
        schema: false,
        schemaCode: false,
        schemaValue: false,
        params: {},
        it: it
    };
    (0, $fg3x0.reportError)(cxt, $4ec60d29f5c57869$var$boolError, undefined, overrideAllErrors);
}

});
parcelRegister("fg3x0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendErrors = module.exports.resetErrorsCount = module.exports.reportExtraError = module.exports.reportError = module.exports.keyword$DataError = module.exports.keywordError = void 0;

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");

var $jfMv8 = parcelRequire("jfMv8");
module.exports.keywordError = {
    message: ({ keyword: keyword })=>(0, $gQlP2.str)`must pass "${keyword}" keyword validation`
};
module.exports.keyword$DataError = {
    message: ({ keyword: keyword, schemaType: schemaType })=>schemaType ? (0, $gQlP2.str)`"${keyword}" keyword must be ${schemaType} ($data)` : (0, $gQlP2.str)`"${keyword}" keyword is invalid ($data)`
};
function $b1bb16e58d2bea78$var$reportError(cxt, error = module.exports.keywordError, errorPaths, overrideAllErrors) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $b1bb16e58d2bea78$var$errorObjectCode(cxt, error, errorPaths);
    if (overrideAllErrors !== null && overrideAllErrors !== void 0 ? overrideAllErrors : compositeRule || allErrors) $b1bb16e58d2bea78$var$addError(gen, errObj);
    else $b1bb16e58d2bea78$var$returnErrors(it, (0, $gQlP2._)`[${errObj}]`);
}
module.exports.reportError = $b1bb16e58d2bea78$var$reportError;
function $b1bb16e58d2bea78$var$reportExtraError(cxt, error = module.exports.keywordError, errorPaths) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $b1bb16e58d2bea78$var$errorObjectCode(cxt, error, errorPaths);
    $b1bb16e58d2bea78$var$addError(gen, errObj);
    if (!(compositeRule || allErrors)) $b1bb16e58d2bea78$var$returnErrors(it, $jfMv8.default.vErrors);
}
module.exports.reportExtraError = $b1bb16e58d2bea78$var$reportExtraError;
function $b1bb16e58d2bea78$var$resetErrorsCount(gen, errsCount) {
    gen.assign($jfMv8.default.errors, errsCount);
    gen.if((0, $gQlP2._)`${$jfMv8.default.vErrors} !== null`, ()=>gen.if(errsCount, ()=>gen.assign((0, $gQlP2._)`${$jfMv8.default.vErrors}.length`, errsCount), ()=>gen.assign($jfMv8.default.vErrors, null)));
}
module.exports.resetErrorsCount = $b1bb16e58d2bea78$var$resetErrorsCount;
function $b1bb16e58d2bea78$var$extendErrors({ gen: gen, keyword: keyword, schemaValue: schemaValue, data: data, errsCount: errsCount, it: it }) {
    /* istanbul ignore if */ if (errsCount === undefined) throw new Error("ajv implementation error");
    const err = gen.name("err");
    gen.forRange("i", errsCount, $jfMv8.default.errors, (i)=>{
        gen.const(err, (0, $gQlP2._)`${$jfMv8.default.vErrors}[${i}]`);
        gen.if((0, $gQlP2._)`${err}.instancePath === undefined`, ()=>gen.assign((0, $gQlP2._)`${err}.instancePath`, (0, $gQlP2.strConcat)($jfMv8.default.instancePath, it.errorPath)));
        gen.assign((0, $gQlP2._)`${err}.schemaPath`, (0, $gQlP2.str)`${it.errSchemaPath}/${keyword}`);
        if (it.opts.verbose) {
            gen.assign((0, $gQlP2._)`${err}.schema`, schemaValue);
            gen.assign((0, $gQlP2._)`${err}.data`, data);
        }
    });
}
module.exports.extendErrors = $b1bb16e58d2bea78$var$extendErrors;
function $b1bb16e58d2bea78$var$addError(gen, errObj) {
    const err = gen.const("err", errObj);
    gen.if((0, $gQlP2._)`${$jfMv8.default.vErrors} === null`, ()=>gen.assign($jfMv8.default.vErrors, (0, $gQlP2._)`[${err}]`), (0, $gQlP2._)`${$jfMv8.default.vErrors}.push(${err})`);
    gen.code((0, $gQlP2._)`${$jfMv8.default.errors}++`);
}
function $b1bb16e58d2bea78$var$returnErrors(it, errs) {
    const { gen: gen, validateName: validateName, schemaEnv: schemaEnv } = it;
    if (schemaEnv.$async) gen.throw((0, $gQlP2._)`new ${it.ValidationError}(${errs})`);
    else {
        gen.assign((0, $gQlP2._)`${validateName}.errors`, errs);
        gen.return(false);
    }
}
const $b1bb16e58d2bea78$var$E = {
    keyword: new $gQlP2.Name("keyword"),
    schemaPath: new $gQlP2.Name("schemaPath"),
    params: new $gQlP2.Name("params"),
    propertyName: new $gQlP2.Name("propertyName"),
    message: new $gQlP2.Name("message"),
    schema: new $gQlP2.Name("schema"),
    parentSchema: new $gQlP2.Name("parentSchema")
};
function $b1bb16e58d2bea78$var$errorObjectCode(cxt, error, errorPaths) {
    const { createErrors: createErrors } = cxt.it;
    if (createErrors === false) return (0, $gQlP2._)`{}`;
    return $b1bb16e58d2bea78$var$errorObject(cxt, error, errorPaths);
}
function $b1bb16e58d2bea78$var$errorObject(cxt, error, errorPaths = {}) {
    const { gen: gen, it: it } = cxt;
    const keyValues = [
        $b1bb16e58d2bea78$var$errorInstancePath(it, errorPaths),
        $b1bb16e58d2bea78$var$errorSchemaPath(cxt, errorPaths)
    ];
    $b1bb16e58d2bea78$var$extraErrorProps(cxt, error, keyValues);
    return gen.object(...keyValues);
}
function $b1bb16e58d2bea78$var$errorInstancePath({ errorPath: errorPath }, { instancePath: instancePath }) {
    const instPath = instancePath ? (0, $gQlP2.str)`${errorPath}${(0, $1XGcl.getErrorPath)(instancePath, $1XGcl.Type.Str)}` : errorPath;
    return [
        $jfMv8.default.instancePath,
        (0, $gQlP2.strConcat)($jfMv8.default.instancePath, instPath)
    ];
}
function $b1bb16e58d2bea78$var$errorSchemaPath({ keyword: keyword, it: { errSchemaPath: errSchemaPath } }, { schemaPath: schemaPath, parentSchema: parentSchema }) {
    let schPath = parentSchema ? errSchemaPath : (0, $gQlP2.str)`${errSchemaPath}/${keyword}`;
    if (schemaPath) schPath = (0, $gQlP2.str)`${schPath}${(0, $1XGcl.getErrorPath)(schemaPath, $1XGcl.Type.Str)}`;
    return [
        $b1bb16e58d2bea78$var$E.schemaPath,
        schPath
    ];
}
function $b1bb16e58d2bea78$var$extraErrorProps(cxt, { params: params, message: message }, keyValues) {
    const { keyword: keyword, data: data, schemaValue: schemaValue, it: it } = cxt;
    const { opts: opts, propertyName: propertyName, topSchemaRef: topSchemaRef, schemaPath: schemaPath } = it;
    keyValues.push([
        $b1bb16e58d2bea78$var$E.keyword,
        keyword
    ], [
        $b1bb16e58d2bea78$var$E.params,
        typeof params == "function" ? params(cxt) : params || (0, $gQlP2._)`{}`
    ]);
    if (opts.messages) keyValues.push([
        $b1bb16e58d2bea78$var$E.message,
        typeof message == "function" ? message(cxt) : message
    ]);
    if (opts.verbose) keyValues.push([
        $b1bb16e58d2bea78$var$E.schema,
        schemaValue
    ], [
        $b1bb16e58d2bea78$var$E.parentSchema,
        (0, $gQlP2._)`${topSchemaRef}${schemaPath}`
    ], [
        $jfMv8.default.data,
        data
    ]);
    if (propertyName) keyValues.push([
        $b1bb16e58d2bea78$var$E.propertyName,
        propertyName
    ]);
}

});
parcelRegister("gQlP2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.or = module.exports.and = module.exports.not = module.exports.CodeGen = module.exports.operators = module.exports.varKinds = module.exports.ValueScopeName = module.exports.ValueScope = module.exports.Scope = module.exports.Name = module.exports.regexpCode = module.exports.stringify = module.exports.getProperty = module.exports.nil = module.exports.strConcat = module.exports.str = module.exports._ = void 0;

var $2YoV8 = parcelRequire("2YoV8");

var $avZLO = parcelRequire("avZLO");

var $2YoV8 = parcelRequire("2YoV8");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $2YoV8._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $2YoV8.str;
    }
});
Object.defineProperty(module.exports, "strConcat", {
    enumerable: true,
    get: function() {
        return $2YoV8.strConcat;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $2YoV8.nil;
    }
});
Object.defineProperty(module.exports, "getProperty", {
    enumerable: true,
    get: function() {
        return $2YoV8.getProperty;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $2YoV8.stringify;
    }
});
Object.defineProperty(module.exports, "regexpCode", {
    enumerable: true,
    get: function() {
        return $2YoV8.regexpCode;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $2YoV8.Name;
    }
});

var $avZLO = parcelRequire("avZLO");
Object.defineProperty(module.exports, "Scope", {
    enumerable: true,
    get: function() {
        return $avZLO.Scope;
    }
});
Object.defineProperty(module.exports, "ValueScope", {
    enumerable: true,
    get: function() {
        return $avZLO.ValueScope;
    }
});
Object.defineProperty(module.exports, "ValueScopeName", {
    enumerable: true,
    get: function() {
        return $avZLO.ValueScopeName;
    }
});
Object.defineProperty(module.exports, "varKinds", {
    enumerable: true,
    get: function() {
        return $avZLO.varKinds;
    }
});
module.exports.operators = {
    GT: new $2YoV8._Code(">"),
    GTE: new $2YoV8._Code(">="),
    LT: new $2YoV8._Code("<"),
    LTE: new $2YoV8._Code("<="),
    EQ: new $2YoV8._Code("==="),
    NEQ: new $2YoV8._Code("!=="),
    NOT: new $2YoV8._Code("!"),
    OR: new $2YoV8._Code("||"),
    AND: new $2YoV8._Code("&&"),
    ADD: new $2YoV8._Code("+")
};
class $c4326e16af5ff5a3$var$Node {
    optimizeNodes() {
        return this;
    }
    optimizeNames(_names, _constants) {
        return this;
    }
}
class $c4326e16af5ff5a3$var$Def extends $c4326e16af5ff5a3$var$Node {
    constructor(varKind, name, rhs){
        super();
        this.varKind = varKind;
        this.name = name;
        this.rhs = rhs;
    }
    render({ es5: es5, _n: _n }) {
        const varKind = es5 ? $avZLO.varKinds.var : this.varKind;
        const rhs = this.rhs === undefined ? "" : ` = ${this.rhs}`;
        return `${varKind} ${this.name}${rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (!names[this.name.str]) return;
        if (this.rhs) this.rhs = $c4326e16af5ff5a3$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        return this.rhs instanceof $2YoV8._CodeOrName ? this.rhs.names : {};
    }
}
class $c4326e16af5ff5a3$var$Assign extends $c4326e16af5ff5a3$var$Node {
    constructor(lhs, rhs, sideEffects){
        super();
        this.lhs = lhs;
        this.rhs = rhs;
        this.sideEffects = sideEffects;
    }
    render({ _n: _n }) {
        return `${this.lhs} = ${this.rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (this.lhs instanceof $2YoV8.Name && !names[this.lhs.str] && !this.sideEffects) return;
        this.rhs = $c4326e16af5ff5a3$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        const names = this.lhs instanceof $2YoV8.Name ? {} : {
            ...this.lhs.names
        };
        return $c4326e16af5ff5a3$var$addExprNames(names, this.rhs);
    }
}
class $c4326e16af5ff5a3$var$AssignOp extends $c4326e16af5ff5a3$var$Assign {
    constructor(lhs, op, rhs, sideEffects){
        super(lhs, rhs, sideEffects);
        this.op = op;
    }
    render({ _n: _n }) {
        return `${this.lhs} ${this.op}= ${this.rhs};` + _n;
    }
}
class $c4326e16af5ff5a3$var$Label extends $c4326e16af5ff5a3$var$Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n: _n }) {
        return `${this.label}:` + _n;
    }
}
class $c4326e16af5ff5a3$var$Break extends $c4326e16af5ff5a3$var$Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n: _n }) {
        const label = this.label ? ` ${this.label}` : "";
        return `break${label};` + _n;
    }
}
class $c4326e16af5ff5a3$var$Throw extends $c4326e16af5ff5a3$var$Node {
    constructor(error){
        super();
        this.error = error;
    }
    render({ _n: _n }) {
        return `throw ${this.error};` + _n;
    }
    get names() {
        return this.error.names;
    }
}
class $c4326e16af5ff5a3$var$AnyCode extends $c4326e16af5ff5a3$var$Node {
    constructor(code){
        super();
        this.code = code;
    }
    render({ _n: _n }) {
        return `${this.code};` + _n;
    }
    optimizeNodes() {
        return `${this.code}` ? this : undefined;
    }
    optimizeNames(names, constants) {
        this.code = $c4326e16af5ff5a3$var$optimizeExpr(this.code, names, constants);
        return this;
    }
    get names() {
        return this.code instanceof $2YoV8._CodeOrName ? this.code.names : {};
    }
}
class $c4326e16af5ff5a3$var$ParentNode extends $c4326e16af5ff5a3$var$Node {
    constructor(nodes = []){
        super();
        this.nodes = nodes;
    }
    render(opts) {
        return this.nodes.reduce((code, n)=>code + n.render(opts), "");
    }
    optimizeNodes() {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            const n = nodes[i].optimizeNodes();
            if (Array.isArray(n)) nodes.splice(i, 1, ...n);
            else if (n) nodes[i] = n;
            else nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    optimizeNames(names, constants) {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            // iterating backwards improves 1-pass optimization
            const n = nodes[i];
            if (n.optimizeNames(names, constants)) continue;
            $c4326e16af5ff5a3$var$subtractNames(names, n.names);
            nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    get names() {
        return this.nodes.reduce((names, n)=>$c4326e16af5ff5a3$var$addNames(names, n.names), {});
    }
}
class $c4326e16af5ff5a3$var$BlockNode extends $c4326e16af5ff5a3$var$ParentNode {
    render(opts) {
        return "{" + opts._n + super.render(opts) + "}" + opts._n;
    }
}
class $c4326e16af5ff5a3$var$Root extends $c4326e16af5ff5a3$var$ParentNode {
}
class $c4326e16af5ff5a3$var$Else extends $c4326e16af5ff5a3$var$BlockNode {
}
$c4326e16af5ff5a3$var$Else.kind = "else";
class $c4326e16af5ff5a3$var$If extends $c4326e16af5ff5a3$var$BlockNode {
    constructor(condition, nodes){
        super(nodes);
        this.condition = condition;
    }
    render(opts) {
        let code = `if(${this.condition})` + super.render(opts);
        if (this.else) code += "else " + this.else.render(opts);
        return code;
    }
    optimizeNodes() {
        super.optimizeNodes();
        const cond = this.condition;
        if (cond === true) return this.nodes; // else is ignored here
        let e = this.else;
        if (e) {
            const ns = e.optimizeNodes();
            e = this.else = Array.isArray(ns) ? new $c4326e16af5ff5a3$var$Else(ns) : ns;
        }
        if (e) {
            if (cond === false) return e instanceof $c4326e16af5ff5a3$var$If ? e : e.nodes;
            if (this.nodes.length) return this;
            return new $c4326e16af5ff5a3$var$If($c4326e16af5ff5a3$var$not(cond), e instanceof $c4326e16af5ff5a3$var$If ? [
                e
            ] : e.nodes);
        }
        if (cond === false || !this.nodes.length) return undefined;
        return this;
    }
    optimizeNames(names, constants) {
        var _a;
        this.else = (_a = this.else) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
        if (!(super.optimizeNames(names, constants) || this.else)) return;
        this.condition = $c4326e16af5ff5a3$var$optimizeExpr(this.condition, names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        $c4326e16af5ff5a3$var$addExprNames(names, this.condition);
        if (this.else) $c4326e16af5ff5a3$var$addNames(names, this.else.names);
        return names;
    }
}
$c4326e16af5ff5a3$var$If.kind = "if";
class $c4326e16af5ff5a3$var$For extends $c4326e16af5ff5a3$var$BlockNode {
}
$c4326e16af5ff5a3$var$For.kind = "for";
class $c4326e16af5ff5a3$var$ForLoop extends $c4326e16af5ff5a3$var$For {
    constructor(iteration){
        super();
        this.iteration = iteration;
    }
    render(opts) {
        return `for(${this.iteration})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iteration = $c4326e16af5ff5a3$var$optimizeExpr(this.iteration, names, constants);
        return this;
    }
    get names() {
        return $c4326e16af5ff5a3$var$addNames(super.names, this.iteration.names);
    }
}
class $c4326e16af5ff5a3$var$ForRange extends $c4326e16af5ff5a3$var$For {
    constructor(varKind, name, from, to){
        super();
        this.varKind = varKind;
        this.name = name;
        this.from = from;
        this.to = to;
    }
    render(opts) {
        const varKind = opts.es5 ? $avZLO.varKinds.var : this.varKind;
        const { name: name, from: from, to: to } = this;
        return `for(${varKind} ${name}=${from}; ${name}<${to}; ${name}++)` + super.render(opts);
    }
    get names() {
        const names = $c4326e16af5ff5a3$var$addExprNames(super.names, this.from);
        return $c4326e16af5ff5a3$var$addExprNames(names, this.to);
    }
}
class $c4326e16af5ff5a3$var$ForIter extends $c4326e16af5ff5a3$var$For {
    constructor(loop, varKind, name, iterable){
        super();
        this.loop = loop;
        this.varKind = varKind;
        this.name = name;
        this.iterable = iterable;
    }
    render(opts) {
        return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iterable = $c4326e16af5ff5a3$var$optimizeExpr(this.iterable, names, constants);
        return this;
    }
    get names() {
        return $c4326e16af5ff5a3$var$addNames(super.names, this.iterable.names);
    }
}
class $c4326e16af5ff5a3$var$Func extends $c4326e16af5ff5a3$var$BlockNode {
    constructor(name, args, async){
        super();
        this.name = name;
        this.args = args;
        this.async = async;
    }
    render(opts) {
        const _async = this.async ? "async " : "";
        return `${_async}function ${this.name}(${this.args})` + super.render(opts);
    }
}
$c4326e16af5ff5a3$var$Func.kind = "func";
class $c4326e16af5ff5a3$var$Return extends $c4326e16af5ff5a3$var$ParentNode {
    render(opts) {
        return "return " + super.render(opts);
    }
}
$c4326e16af5ff5a3$var$Return.kind = "return";
class $c4326e16af5ff5a3$var$Try extends $c4326e16af5ff5a3$var$BlockNode {
    render(opts) {
        let code = "try" + super.render(opts);
        if (this.catch) code += this.catch.render(opts);
        if (this.finally) code += this.finally.render(opts);
        return code;
    }
    optimizeNodes() {
        var _a, _b;
        super.optimizeNodes();
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNodes();
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNodes();
        return this;
    }
    optimizeNames(names, constants) {
        var _a, _b;
        super.optimizeNames(names, constants);
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNames(names, constants);
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNames(names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        if (this.catch) $c4326e16af5ff5a3$var$addNames(names, this.catch.names);
        if (this.finally) $c4326e16af5ff5a3$var$addNames(names, this.finally.names);
        return names;
    }
}
class $c4326e16af5ff5a3$var$Catch extends $c4326e16af5ff5a3$var$BlockNode {
    constructor(error){
        super();
        this.error = error;
    }
    render(opts) {
        return `catch(${this.error})` + super.render(opts);
    }
}
$c4326e16af5ff5a3$var$Catch.kind = "catch";
class $c4326e16af5ff5a3$var$Finally extends $c4326e16af5ff5a3$var$BlockNode {
    render(opts) {
        return "finally" + super.render(opts);
    }
}
$c4326e16af5ff5a3$var$Finally.kind = "finally";
class $c4326e16af5ff5a3$var$CodeGen {
    constructor(extScope, opts = {}){
        this._values = {};
        this._blockStarts = [];
        this._constants = {};
        this.opts = {
            ...opts,
            _n: opts.lines ? "\n" : ""
        };
        this._extScope = extScope;
        this._scope = new $avZLO.Scope({
            parent: extScope
        });
        this._nodes = [
            new $c4326e16af5ff5a3$var$Root()
        ];
    }
    toString() {
        return this._root.render(this.opts);
    }
    // returns unique name in the internal scope
    name(prefix) {
        return this._scope.name(prefix);
    }
    // reserves unique name in the external scope
    scopeName(prefix) {
        return this._extScope.name(prefix);
    }
    // reserves unique name in the external scope and assigns value to it
    scopeValue(prefixOrName, value) {
        const name = this._extScope.value(prefixOrName, value);
        const vs = this._values[name.prefix] || (this._values[name.prefix] = new Set());
        vs.add(name);
        return name;
    }
    getScopeValue(prefix, keyOrRef) {
        return this._extScope.getValue(prefix, keyOrRef);
    }
    // return code that assigns values in the external scope to the names that are used internally
    // (same names that were returned by gen.scopeName or gen.scopeValue)
    scopeRefs(scopeName) {
        return this._extScope.scopeRefs(scopeName, this._values);
    }
    scopeCode() {
        return this._extScope.scopeCode(this._values);
    }
    _def(varKind, nameOrPrefix, rhs, constant) {
        const name = this._scope.toName(nameOrPrefix);
        if (rhs !== undefined && constant) this._constants[name.str] = rhs;
        this._leafNode(new $c4326e16af5ff5a3$var$Def(varKind, name, rhs));
        return name;
    }
    // `const` declaration (`var` in es5 mode)
    const(nameOrPrefix, rhs, _constant) {
        return this._def($avZLO.varKinds.const, nameOrPrefix, rhs, _constant);
    }
    // `let` declaration with optional assignment (`var` in es5 mode)
    let(nameOrPrefix, rhs, _constant) {
        return this._def($avZLO.varKinds.let, nameOrPrefix, rhs, _constant);
    }
    // `var` declaration with optional assignment
    var(nameOrPrefix, rhs, _constant) {
        return this._def($avZLO.varKinds.var, nameOrPrefix, rhs, _constant);
    }
    // assignment code
    assign(lhs, rhs, sideEffects) {
        return this._leafNode(new $c4326e16af5ff5a3$var$Assign(lhs, rhs, sideEffects));
    }
    // `+=` code
    add(lhs, rhs) {
        return this._leafNode(new $c4326e16af5ff5a3$var$AssignOp(lhs, module.exports.operators.ADD, rhs));
    }
    // appends passed SafeExpr to code or executes Block
    code(c) {
        if (typeof c == "function") c();
        else if (c !== $2YoV8.nil) this._leafNode(new $c4326e16af5ff5a3$var$AnyCode(c));
        return this;
    }
    // returns code for object literal for the passed argument list of key-value pairs
    object(...keyValues) {
        const code = [
            "{"
        ];
        for (const [key, value] of keyValues){
            if (code.length > 1) code.push(",");
            code.push(key);
            if (key !== value || this.opts.es5) {
                code.push(":");
                (0, $2YoV8.addCodeArg)(code, value);
            }
        }
        code.push("}");
        return new $2YoV8._Code(code);
    }
    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
    if(condition, thenBody, elseBody) {
        this._blockNode(new $c4326e16af5ff5a3$var$If(condition));
        if (thenBody && elseBody) this.code(thenBody).else().code(elseBody).endIf();
        else if (thenBody) this.code(thenBody).endIf();
        else if (elseBody) throw new Error('CodeGen: "else" body without "then" body');
        return this;
    }
    // `else if` clause - invalid without `if` or after `else` clauses
    elseIf(condition) {
        return this._elseNode(new $c4326e16af5ff5a3$var$If(condition));
    }
    // `else` clause - only valid after `if` or `else if` clauses
    else() {
        return this._elseNode(new $c4326e16af5ff5a3$var$Else());
    }
    // end `if` statement (needed if gen.if was used only with condition)
    endIf() {
        return this._endBlockNode($c4326e16af5ff5a3$var$If, $c4326e16af5ff5a3$var$Else);
    }
    _for(node, forBody) {
        this._blockNode(node);
        if (forBody) this.code(forBody).endFor();
        return this;
    }
    // a generic `for` clause (or statement if `forBody` is passed)
    for(iteration, forBody) {
        return this._for(new $c4326e16af5ff5a3$var$ForLoop(iteration), forBody);
    }
    // `for` statement for a range of values
    forRange(nameOrPrefix, from, to, forBody, varKind = this.opts.es5 ? $avZLO.varKinds.var : $avZLO.varKinds.let) {
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $c4326e16af5ff5a3$var$ForRange(varKind, name, from, to), ()=>forBody(name));
    }
    // `for-of` statement (in es5 mode replace with a normal for loop)
    forOf(nameOrPrefix, iterable, forBody, varKind = $avZLO.varKinds.const) {
        const name = this._scope.toName(nameOrPrefix);
        if (this.opts.es5) {
            const arr = iterable instanceof $2YoV8.Name ? iterable : this.var("_arr", iterable);
            return this.forRange("_i", 0, (0, $2YoV8._)`${arr}.length`, (i)=>{
                this.var(name, (0, $2YoV8._)`${arr}[${i}]`);
                forBody(name);
            });
        }
        return this._for(new $c4326e16af5ff5a3$var$ForIter("of", varKind, name, iterable), ()=>forBody(name));
    }
    // `for-in` statement.
    // With option `ownProperties` replaced with a `for-of` loop for object keys
    forIn(nameOrPrefix, obj, forBody, varKind = this.opts.es5 ? $avZLO.varKinds.var : $avZLO.varKinds.const) {
        if (this.opts.ownProperties) return this.forOf(nameOrPrefix, (0, $2YoV8._)`Object.keys(${obj})`, forBody);
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $c4326e16af5ff5a3$var$ForIter("in", varKind, name, obj), ()=>forBody(name));
    }
    // end `for` loop
    endFor() {
        return this._endBlockNode($c4326e16af5ff5a3$var$For);
    }
    // `label` statement
    label(label) {
        return this._leafNode(new $c4326e16af5ff5a3$var$Label(label));
    }
    // `break` statement
    break(label) {
        return this._leafNode(new $c4326e16af5ff5a3$var$Break(label));
    }
    // `return` statement
    return(value) {
        const node = new $c4326e16af5ff5a3$var$Return();
        this._blockNode(node);
        this.code(value);
        if (node.nodes.length !== 1) throw new Error('CodeGen: "return" should have one node');
        return this._endBlockNode($c4326e16af5ff5a3$var$Return);
    }
    // `try` statement
    try(tryBody, catchCode, finallyCode) {
        if (!catchCode && !finallyCode) throw new Error('CodeGen: "try" without "catch" and "finally"');
        const node = new $c4326e16af5ff5a3$var$Try();
        this._blockNode(node);
        this.code(tryBody);
        if (catchCode) {
            const error = this.name("e");
            this._currNode = node.catch = new $c4326e16af5ff5a3$var$Catch(error);
            catchCode(error);
        }
        if (finallyCode) {
            this._currNode = node.finally = new $c4326e16af5ff5a3$var$Finally();
            this.code(finallyCode);
        }
        return this._endBlockNode($c4326e16af5ff5a3$var$Catch, $c4326e16af5ff5a3$var$Finally);
    }
    // `throw` statement
    throw(error) {
        return this._leafNode(new $c4326e16af5ff5a3$var$Throw(error));
    }
    // start self-balancing block
    block(body, nodeCount) {
        this._blockStarts.push(this._nodes.length);
        if (body) this.code(body).endBlock(nodeCount);
        return this;
    }
    // end the current self-balancing block
    endBlock(nodeCount) {
        const len = this._blockStarts.pop();
        if (len === undefined) throw new Error("CodeGen: not in self-balancing block");
        const toClose = this._nodes.length - len;
        if (toClose < 0 || nodeCount !== undefined && toClose !== nodeCount) throw new Error(`CodeGen: wrong number of nodes: ${toClose} vs ${nodeCount} expected`);
        this._nodes.length = len;
        return this;
    }
    // `function` heading (or definition if funcBody is passed)
    func(name, args = $2YoV8.nil, async, funcBody) {
        this._blockNode(new $c4326e16af5ff5a3$var$Func(name, args, async));
        if (funcBody) this.code(funcBody).endFunc();
        return this;
    }
    // end function definition
    endFunc() {
        return this._endBlockNode($c4326e16af5ff5a3$var$Func);
    }
    optimize(n = 1) {
        while(n-- > 0){
            this._root.optimizeNodes();
            this._root.optimizeNames(this._root.names, this._constants);
        }
    }
    _leafNode(node) {
        this._currNode.nodes.push(node);
        return this;
    }
    _blockNode(node) {
        this._currNode.nodes.push(node);
        this._nodes.push(node);
    }
    _endBlockNode(N1, N2) {
        const n = this._currNode;
        if (n instanceof N1 || N2 && n instanceof N2) {
            this._nodes.pop();
            return this;
        }
        throw new Error(`CodeGen: not in block "${N2 ? `${N1.kind}/${N2.kind}` : N1.kind}"`);
    }
    _elseNode(node) {
        const n = this._currNode;
        if (!(n instanceof $c4326e16af5ff5a3$var$If)) throw new Error('CodeGen: "else" without "if"');
        this._currNode = n.else = node;
        return this;
    }
    get _root() {
        return this._nodes[0];
    }
    get _currNode() {
        const ns = this._nodes;
        return ns[ns.length - 1];
    }
    set _currNode(node) {
        const ns = this._nodes;
        ns[ns.length - 1] = node;
    }
}
module.exports.CodeGen = $c4326e16af5ff5a3$var$CodeGen;
function $c4326e16af5ff5a3$var$addNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) + (from[n] || 0);
    return names;
}
function $c4326e16af5ff5a3$var$addExprNames(names, from) {
    return from instanceof $2YoV8._CodeOrName ? $c4326e16af5ff5a3$var$addNames(names, from.names) : names;
}
function $c4326e16af5ff5a3$var$optimizeExpr(expr, names, constants) {
    if (expr instanceof $2YoV8.Name) return replaceName(expr);
    if (!canOptimize(expr)) return expr;
    return new $2YoV8._Code(expr._items.reduce((items, c)=>{
        if (c instanceof $2YoV8.Name) c = replaceName(c);
        if (c instanceof $2YoV8._Code) items.push(...c._items);
        else items.push(c);
        return items;
    }, []));
    function replaceName(n) {
        const c = constants[n.str];
        if (c === undefined || names[n.str] !== 1) return n;
        delete names[n.str];
        return c;
    }
    function canOptimize(e) {
        return e instanceof $2YoV8._Code && e._items.some((c)=>c instanceof $2YoV8.Name && names[c.str] === 1 && constants[c.str] !== undefined);
    }
}
function $c4326e16af5ff5a3$var$subtractNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) - (from[n] || 0);
}
function $c4326e16af5ff5a3$var$not(x) {
    return typeof x == "boolean" || typeof x == "number" || x === null ? !x : (0, $2YoV8._)`!${$c4326e16af5ff5a3$var$par(x)}`;
}
module.exports.not = $c4326e16af5ff5a3$var$not;
const $c4326e16af5ff5a3$var$andCode = $c4326e16af5ff5a3$var$mappend(module.exports.operators.AND);
// boolean AND (&&) expression with the passed arguments
function $c4326e16af5ff5a3$var$and(...args) {
    return args.reduce($c4326e16af5ff5a3$var$andCode);
}
module.exports.and = $c4326e16af5ff5a3$var$and;
const $c4326e16af5ff5a3$var$orCode = $c4326e16af5ff5a3$var$mappend(module.exports.operators.OR);
// boolean OR (||) expression with the passed arguments
function $c4326e16af5ff5a3$var$or(...args) {
    return args.reduce($c4326e16af5ff5a3$var$orCode);
}
module.exports.or = $c4326e16af5ff5a3$var$or;
function $c4326e16af5ff5a3$var$mappend(op) {
    return (x, y)=>x === $2YoV8.nil ? y : y === $2YoV8.nil ? x : (0, $2YoV8._)`${$c4326e16af5ff5a3$var$par(x)} ${op} ${$c4326e16af5ff5a3$var$par(y)}`;
}
function $c4326e16af5ff5a3$var$par(x) {
    return x instanceof $2YoV8.Name ? x : (0, $2YoV8._)`(${x})`;
}

});
parcelRegister("2YoV8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.regexpCode = module.exports.getEsmExportName = module.exports.getProperty = module.exports.safeStringify = module.exports.stringify = module.exports.strConcat = module.exports.addCodeArg = module.exports.str = module.exports._ = module.exports.nil = module.exports._Code = module.exports.Name = module.exports.IDENTIFIER = module.exports._CodeOrName = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class $22a4840de0852fd4$var$_CodeOrName {
}
module.exports._CodeOrName = $22a4840de0852fd4$var$_CodeOrName;
module.exports.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
class $22a4840de0852fd4$var$Name extends $22a4840de0852fd4$var$_CodeOrName {
    constructor(s){
        super();
        if (!module.exports.IDENTIFIER.test(s)) throw new Error("CodeGen: name must be a valid identifier");
        this.str = s;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        return false;
    }
    get names() {
        return {
            [this.str]: 1
        };
    }
}
module.exports.Name = $22a4840de0852fd4$var$Name;
class $22a4840de0852fd4$var$_Code extends $22a4840de0852fd4$var$_CodeOrName {
    constructor(code){
        super();
        this._items = typeof code === "string" ? [
            code
        ] : code;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        if (this._items.length > 1) return false;
        const item = this._items[0];
        return item === "" || item === '""';
    }
    get str() {
        var _a;
        return (_a = this._str) !== null && _a !== void 0 ? _a : this._str = this._items.reduce((s, c)=>`${s}${c}`, "");
    }
    get names() {
        var _a;
        return (_a = this._names) !== null && _a !== void 0 ? _a : this._names = this._items.reduce((names, c)=>{
            if (c instanceof $22a4840de0852fd4$var$Name) names[c.str] = (names[c.str] || 0) + 1;
            return names;
        }, {});
    }
}
module.exports._Code = $22a4840de0852fd4$var$_Code;
module.exports.nil = new $22a4840de0852fd4$var$_Code("");
function $22a4840de0852fd4$var$_(strs, ...args) {
    const code = [
        strs[0]
    ];
    let i = 0;
    while(i < args.length){
        $22a4840de0852fd4$var$addCodeArg(code, args[i]);
        code.push(strs[++i]);
    }
    return new $22a4840de0852fd4$var$_Code(code);
}
module.exports._ = $22a4840de0852fd4$var$_;
const $22a4840de0852fd4$var$plus = new $22a4840de0852fd4$var$_Code("+");
function $22a4840de0852fd4$var$str(strs, ...args) {
    const expr = [
        $22a4840de0852fd4$var$safeStringify(strs[0])
    ];
    let i = 0;
    while(i < args.length){
        expr.push($22a4840de0852fd4$var$plus);
        $22a4840de0852fd4$var$addCodeArg(expr, args[i]);
        expr.push($22a4840de0852fd4$var$plus, $22a4840de0852fd4$var$safeStringify(strs[++i]));
    }
    $22a4840de0852fd4$var$optimize(expr);
    return new $22a4840de0852fd4$var$_Code(expr);
}
module.exports.str = $22a4840de0852fd4$var$str;
function $22a4840de0852fd4$var$addCodeArg(code, arg) {
    if (arg instanceof $22a4840de0852fd4$var$_Code) code.push(...arg._items);
    else if (arg instanceof $22a4840de0852fd4$var$Name) code.push(arg);
    else code.push($22a4840de0852fd4$var$interpolate(arg));
}
module.exports.addCodeArg = $22a4840de0852fd4$var$addCodeArg;
function $22a4840de0852fd4$var$optimize(expr) {
    let i = 1;
    while(i < expr.length - 1){
        if (expr[i] === $22a4840de0852fd4$var$plus) {
            const res = $22a4840de0852fd4$var$mergeExprItems(expr[i - 1], expr[i + 1]);
            if (res !== undefined) {
                expr.splice(i - 1, 3, res);
                continue;
            }
            expr[i++] = "+";
        }
        i++;
    }
}
function $22a4840de0852fd4$var$mergeExprItems(a, b) {
    if (b === '""') return a;
    if (a === '""') return b;
    if (typeof a == "string") {
        if (b instanceof $22a4840de0852fd4$var$Name || a[a.length - 1] !== '"') return;
        if (typeof b != "string") return `${a.slice(0, -1)}${b}"`;
        if (b[0] === '"') return a.slice(0, -1) + b.slice(1);
        return;
    }
    if (typeof b == "string" && b[0] === '"' && !(a instanceof $22a4840de0852fd4$var$Name)) return `"${a}${b.slice(1)}`;
    return;
}
function $22a4840de0852fd4$var$strConcat(c1, c2) {
    return c2.emptyStr() ? c1 : c1.emptyStr() ? c2 : $22a4840de0852fd4$var$str`${c1}${c2}`;
}
module.exports.strConcat = $22a4840de0852fd4$var$strConcat;
// TODO do not allow arrays here
function $22a4840de0852fd4$var$interpolate(x) {
    return typeof x == "number" || typeof x == "boolean" || x === null ? x : $22a4840de0852fd4$var$safeStringify(Array.isArray(x) ? x.join(",") : x);
}
function $22a4840de0852fd4$var$stringify(x) {
    return new $22a4840de0852fd4$var$_Code($22a4840de0852fd4$var$safeStringify(x));
}
module.exports.stringify = $22a4840de0852fd4$var$stringify;
function $22a4840de0852fd4$var$safeStringify(x) {
    return JSON.stringify(x).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
}
module.exports.safeStringify = $22a4840de0852fd4$var$safeStringify;
function $22a4840de0852fd4$var$getProperty(key) {
    return typeof key == "string" && module.exports.IDENTIFIER.test(key) ? new $22a4840de0852fd4$var$_Code(`.${key}`) : $22a4840de0852fd4$var$_`[${key}]`;
}
module.exports.getProperty = $22a4840de0852fd4$var$getProperty;
//Does best effort to format the name properly
function $22a4840de0852fd4$var$getEsmExportName(key) {
    if (typeof key == "string" && module.exports.IDENTIFIER.test(key)) return new $22a4840de0852fd4$var$_Code(`${key}`);
    throw new Error(`CodeGen: invalid export name: ${key}, use explicit $id name mapping`);
}
module.exports.getEsmExportName = $22a4840de0852fd4$var$getEsmExportName;
function $22a4840de0852fd4$var$regexpCode(rx) {
    return new $22a4840de0852fd4$var$_Code(rx.toString());
}
module.exports.regexpCode = $22a4840de0852fd4$var$regexpCode;

});

parcelRegister("avZLO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueScope = module.exports.ValueScopeName = module.exports.Scope = module.exports.varKinds = module.exports.UsedValueState = void 0;

var $2YoV8 = parcelRequire("2YoV8");
class $7a7cb6e68103f4d7$var$ValueError extends Error {
    constructor(name){
        super(`CodeGen: "code" for ${name} not defined`);
        this.value = name.value;
    }
}
var $7a7cb6e68103f4d7$var$UsedValueState;
(function(UsedValueState) {
    UsedValueState[UsedValueState["Started"] = 0] = "Started";
    UsedValueState[UsedValueState["Completed"] = 1] = "Completed";
})($7a7cb6e68103f4d7$var$UsedValueState || (module.exports.UsedValueState = $7a7cb6e68103f4d7$var$UsedValueState = {}));
module.exports.varKinds = {
    const: new $2YoV8.Name("const"),
    let: new $2YoV8.Name("let"),
    var: new $2YoV8.Name("var")
};
class $7a7cb6e68103f4d7$var$Scope {
    constructor({ prefixes: prefixes, parent: parent } = {}){
        this._names = {};
        this._prefixes = prefixes;
        this._parent = parent;
    }
    toName(nameOrPrefix) {
        return nameOrPrefix instanceof $2YoV8.Name ? nameOrPrefix : this.name(nameOrPrefix);
    }
    name(prefix) {
        return new $2YoV8.Name(this._newName(prefix));
    }
    _newName(prefix) {
        const ng = this._names[prefix] || this._nameGroup(prefix);
        return `${prefix}${ng.index++}`;
    }
    _nameGroup(prefix) {
        var _a, _b;
        if (((_b = (_a = this._parent) === null || _a === void 0 ? void 0 : _a._prefixes) === null || _b === void 0 ? void 0 : _b.has(prefix)) || this._prefixes && !this._prefixes.has(prefix)) throw new Error(`CodeGen: prefix "${prefix}" is not allowed in this scope`);
        return this._names[prefix] = {
            prefix: prefix,
            index: 0
        };
    }
}
module.exports.Scope = $7a7cb6e68103f4d7$var$Scope;
class $7a7cb6e68103f4d7$var$ValueScopeName extends $2YoV8.Name {
    constructor(prefix, nameStr){
        super(nameStr);
        this.prefix = prefix;
    }
    setValue(value, { property: property, itemIndex: itemIndex }) {
        this.value = value;
        this.scopePath = (0, $2YoV8._)`.${new $2YoV8.Name(property)}[${itemIndex}]`;
    }
}
module.exports.ValueScopeName = $7a7cb6e68103f4d7$var$ValueScopeName;
const $7a7cb6e68103f4d7$var$line = (0, $2YoV8._)`\n`;
class $7a7cb6e68103f4d7$var$ValueScope extends $7a7cb6e68103f4d7$var$Scope {
    constructor(opts){
        super(opts);
        this._values = {};
        this._scope = opts.scope;
        this.opts = {
            ...opts,
            _n: opts.lines ? $7a7cb6e68103f4d7$var$line : $2YoV8.nil
        };
    }
    get() {
        return this._scope;
    }
    name(prefix) {
        return new $7a7cb6e68103f4d7$var$ValueScopeName(prefix, this._newName(prefix));
    }
    value(nameOrPrefix, value) {
        var _a;
        if (value.ref === undefined) throw new Error("CodeGen: ref must be passed in value");
        const name = this.toName(nameOrPrefix);
        const { prefix: prefix } = name;
        const valueKey = (_a = value.key) !== null && _a !== void 0 ? _a : value.ref;
        let vs = this._values[prefix];
        if (vs) {
            const _name = vs.get(valueKey);
            if (_name) return _name;
        } else vs = this._values[prefix] = new Map();
        vs.set(valueKey, name);
        const s = this._scope[prefix] || (this._scope[prefix] = []);
        const itemIndex = s.length;
        s[itemIndex] = value.ref;
        name.setValue(value, {
            property: prefix,
            itemIndex: itemIndex
        });
        return name;
    }
    getValue(prefix, keyOrRef) {
        const vs = this._values[prefix];
        if (!vs) return;
        return vs.get(keyOrRef);
    }
    scopeRefs(scopeName, values = this._values) {
        return this._reduceValues(values, (name)=>{
            if (name.scopePath === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return (0, $2YoV8._)`${scopeName}${name.scopePath}`;
        });
    }
    scopeCode(values = this._values, usedValues, getCode) {
        return this._reduceValues(values, (name)=>{
            if (name.value === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return name.value.code;
        }, usedValues, getCode);
    }
    _reduceValues(values, valueCode, usedValues = {}, getCode) {
        let code = $2YoV8.nil;
        for(const prefix in values){
            const vs = values[prefix];
            if (!vs) continue;
            const nameSet = usedValues[prefix] = usedValues[prefix] || new Map();
            vs.forEach((name)=>{
                if (nameSet.has(name)) return;
                nameSet.set(name, $7a7cb6e68103f4d7$var$UsedValueState.Started);
                let c = valueCode(name);
                if (c) {
                    const def = this.opts.es5 ? module.exports.varKinds.var : module.exports.varKinds.const;
                    code = (0, $2YoV8._)`${code}${def} ${name} = ${c};${this.opts._n}`;
                } else if (c = getCode === null || getCode === void 0 ? void 0 : getCode(name)) code = (0, $2YoV8._)`${code}${c}${this.opts._n}`;
                else throw new $7a7cb6e68103f4d7$var$ValueError(name);
                nameSet.set(name, $7a7cb6e68103f4d7$var$UsedValueState.Completed);
            });
        }
        return code;
    }
}
module.exports.ValueScope = $7a7cb6e68103f4d7$var$ValueScope;

});


parcelRegister("1XGcl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkStrictMode = module.exports.getErrorPath = module.exports.Type = module.exports.useFunc = module.exports.setEvaluated = module.exports.evaluatedPropsToName = module.exports.mergeEvaluated = module.exports.eachItem = module.exports.unescapeJsonPointer = module.exports.escapeJsonPointer = module.exports.escapeFragment = module.exports.unescapeFragment = module.exports.schemaRefOrVal = module.exports.schemaHasRulesButRef = module.exports.schemaHasRules = module.exports.checkUnknownRules = module.exports.alwaysValidSchema = module.exports.toHash = void 0;

var $gQlP2 = parcelRequire("gQlP2");

var $2YoV8 = parcelRequire("2YoV8");
// TODO refactor to use Set
function $16dc08ce8daa6dee$var$toHash(arr) {
    const hash = {};
    for (const item of arr)hash[item] = true;
    return hash;
}
module.exports.toHash = $16dc08ce8daa6dee$var$toHash;
function $16dc08ce8daa6dee$var$alwaysValidSchema(it, schema) {
    if (typeof schema == "boolean") return schema;
    if (Object.keys(schema).length === 0) return true;
    $16dc08ce8daa6dee$var$checkUnknownRules(it, schema);
    return !$16dc08ce8daa6dee$var$schemaHasRules(schema, it.self.RULES.all);
}
module.exports.alwaysValidSchema = $16dc08ce8daa6dee$var$alwaysValidSchema;
function $16dc08ce8daa6dee$var$checkUnknownRules(it, schema = it.schema) {
    const { opts: opts, self: self } = it;
    if (!opts.strictSchema) return;
    if (typeof schema === "boolean") return;
    const rules = self.RULES.keywords;
    for(const key in schema)if (!rules[key]) $16dc08ce8daa6dee$var$checkStrictMode(it, `unknown keyword: "${key}"`);
}
module.exports.checkUnknownRules = $16dc08ce8daa6dee$var$checkUnknownRules;
function $16dc08ce8daa6dee$var$schemaHasRules(schema, rules) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (rules[key]) return true;
    return false;
}
module.exports.schemaHasRules = $16dc08ce8daa6dee$var$schemaHasRules;
function $16dc08ce8daa6dee$var$schemaHasRulesButRef(schema, RULES) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (key !== "$ref" && RULES.all[key]) return true;
    return false;
}
module.exports.schemaHasRulesButRef = $16dc08ce8daa6dee$var$schemaHasRulesButRef;
function $16dc08ce8daa6dee$var$schemaRefOrVal({ topSchemaRef: topSchemaRef, schemaPath: schemaPath }, schema, keyword, $data) {
    if (!$data) {
        if (typeof schema == "number" || typeof schema == "boolean") return schema;
        if (typeof schema == "string") return (0, $gQlP2._)`${schema}`;
    }
    return (0, $gQlP2._)`${topSchemaRef}${schemaPath}${(0, $gQlP2.getProperty)(keyword)}`;
}
module.exports.schemaRefOrVal = $16dc08ce8daa6dee$var$schemaRefOrVal;
function $16dc08ce8daa6dee$var$unescapeFragment(str) {
    return $16dc08ce8daa6dee$var$unescapeJsonPointer(decodeURIComponent(str));
}
module.exports.unescapeFragment = $16dc08ce8daa6dee$var$unescapeFragment;
function $16dc08ce8daa6dee$var$escapeFragment(str) {
    return encodeURIComponent($16dc08ce8daa6dee$var$escapeJsonPointer(str));
}
module.exports.escapeFragment = $16dc08ce8daa6dee$var$escapeFragment;
function $16dc08ce8daa6dee$var$escapeJsonPointer(str) {
    if (typeof str == "number") return `${str}`;
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
module.exports.escapeJsonPointer = $16dc08ce8daa6dee$var$escapeJsonPointer;
function $16dc08ce8daa6dee$var$unescapeJsonPointer(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
}
module.exports.unescapeJsonPointer = $16dc08ce8daa6dee$var$unescapeJsonPointer;
function $16dc08ce8daa6dee$var$eachItem(xs, f) {
    if (Array.isArray(xs)) for (const x of xs)f(x);
    else f(xs);
}
module.exports.eachItem = $16dc08ce8daa6dee$var$eachItem;
function $16dc08ce8daa6dee$var$makeMergeEvaluated({ mergeNames: mergeNames, mergeToName: mergeToName, mergeValues: mergeValues, resultToName: resultToName }) {
    return (gen, from, to, toName)=>{
        const res = to === undefined ? from : to instanceof $gQlP2.Name ? (from instanceof $gQlP2.Name ? mergeNames(gen, from, to) : mergeToName(gen, from, to), to) : from instanceof $gQlP2.Name ? (mergeToName(gen, to, from), from) : mergeValues(from, to);
        return toName === $gQlP2.Name && !(res instanceof $gQlP2.Name) ? resultToName(gen, res) : res;
    };
}
module.exports.mergeEvaluated = {
    props: $16dc08ce8daa6dee$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $gQlP2._)`${to} !== true && ${from} !== undefined`, ()=>{
                gen.if((0, $gQlP2._)`${from} === true`, ()=>gen.assign(to, true), ()=>gen.assign(to, (0, $gQlP2._)`${to} || {}`).code((0, $gQlP2._)`Object.assign(${to}, ${from})`));
            }),
        mergeToName: (gen, from, to)=>gen.if((0, $gQlP2._)`${to} !== true`, ()=>{
                if (from === true) gen.assign(to, true);
                else {
                    gen.assign(to, (0, $gQlP2._)`${to} || {}`);
                    $16dc08ce8daa6dee$var$setEvaluated(gen, to, from);
                }
            }),
        mergeValues: (from, to)=>from === true ? true : {
                ...from,
                ...to
            },
        resultToName: $16dc08ce8daa6dee$var$evaluatedPropsToName
    }),
    items: $16dc08ce8daa6dee$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $gQlP2._)`${to} !== true && ${from} !== undefined`, ()=>gen.assign(to, (0, $gQlP2._)`${from} === true ? true : ${to} > ${from} ? ${to} : ${from}`)),
        mergeToName: (gen, from, to)=>gen.if((0, $gQlP2._)`${to} !== true`, ()=>gen.assign(to, from === true ? true : (0, $gQlP2._)`${to} > ${from} ? ${to} : ${from}`)),
        mergeValues: (from, to)=>from === true ? true : Math.max(from, to),
        resultToName: (gen, items)=>gen.var("items", items)
    })
};
function $16dc08ce8daa6dee$var$evaluatedPropsToName(gen, ps) {
    if (ps === true) return gen.var("props", true);
    const props = gen.var("props", (0, $gQlP2._)`{}`);
    if (ps !== undefined) $16dc08ce8daa6dee$var$setEvaluated(gen, props, ps);
    return props;
}
module.exports.evaluatedPropsToName = $16dc08ce8daa6dee$var$evaluatedPropsToName;
function $16dc08ce8daa6dee$var$setEvaluated(gen, props, ps) {
    Object.keys(ps).forEach((p)=>gen.assign((0, $gQlP2._)`${props}${(0, $gQlP2.getProperty)(p)}`, true));
}
module.exports.setEvaluated = $16dc08ce8daa6dee$var$setEvaluated;
const $16dc08ce8daa6dee$var$snippets = {};
function $16dc08ce8daa6dee$var$useFunc(gen, f) {
    return gen.scopeValue("func", {
        ref: f,
        code: $16dc08ce8daa6dee$var$snippets[f.code] || ($16dc08ce8daa6dee$var$snippets[f.code] = new $2YoV8._Code(f.code))
    });
}
module.exports.useFunc = $16dc08ce8daa6dee$var$useFunc;
var $16dc08ce8daa6dee$var$Type;
(function(Type) {
    Type[Type["Num"] = 0] = "Num";
    Type[Type["Str"] = 1] = "Str";
})($16dc08ce8daa6dee$var$Type || (module.exports.Type = $16dc08ce8daa6dee$var$Type = {}));
function $16dc08ce8daa6dee$var$getErrorPath(dataProp, dataPropType, jsPropertySyntax) {
    // let path
    if (dataProp instanceof $gQlP2.Name) {
        const isNumber = dataPropType === $16dc08ce8daa6dee$var$Type.Num;
        return jsPropertySyntax ? isNumber ? (0, $gQlP2._)`"[" + ${dataProp} + "]"` : (0, $gQlP2._)`"['" + ${dataProp} + "']"` : isNumber ? (0, $gQlP2._)`"/" + ${dataProp}` : (0, $gQlP2._)`"/" + ${dataProp}.replace(/~/g, "~0").replace(/\\//g, "~1")`; // TODO maybe use global escapePointer
    }
    return jsPropertySyntax ? (0, $gQlP2.getProperty)(dataProp).toString() : "/" + $16dc08ce8daa6dee$var$escapeJsonPointer(dataProp);
}
module.exports.getErrorPath = $16dc08ce8daa6dee$var$getErrorPath;
function $16dc08ce8daa6dee$var$checkStrictMode(it, msg, mode = it.opts.strictSchema) {
    if (!mode) return;
    msg = `strict mode: ${msg}`;
    if (mode === true) throw new Error(msg);
    it.self.logger.warn(msg);
}
module.exports.checkStrictMode = $16dc08ce8daa6dee$var$checkStrictMode;

});

parcelRegister("jfMv8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gQlP2 = parcelRequire("gQlP2");
const $e0450a5e20f5d6a7$var$names = {
    // validation function arguments
    data: new $gQlP2.Name("data"),
    // args passed from referencing schema
    valCxt: new $gQlP2.Name("valCxt"),
    instancePath: new $gQlP2.Name("instancePath"),
    parentData: new $gQlP2.Name("parentData"),
    parentDataProperty: new $gQlP2.Name("parentDataProperty"),
    rootData: new $gQlP2.Name("rootData"),
    dynamicAnchors: new $gQlP2.Name("dynamicAnchors"),
    // function scoped variables
    vErrors: new $gQlP2.Name("vErrors"),
    errors: new $gQlP2.Name("errors"),
    this: new $gQlP2.Name("this"),
    // "globals"
    self: new $gQlP2.Name("self"),
    scope: new $gQlP2.Name("scope"),
    // JTD serialize/parse name for JSON string and position
    json: new $gQlP2.Name("json"),
    jsonPos: new $gQlP2.Name("jsonPos"),
    jsonLen: new $gQlP2.Name("jsonLen"),
    jsonPart: new $gQlP2.Name("jsonPart")
};
module.exports.default = $e0450a5e20f5d6a7$var$names;

});



parcelRegister("1fcu2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.reportTypeError = module.exports.checkDataTypes = module.exports.checkDataType = module.exports.coerceAndCheckDataType = module.exports.getJSONTypes = module.exports.getSchemaTypes = module.exports.DataType = void 0;

var $3OQ8t = parcelRequire("3OQ8t");

var $7PRwo = parcelRequire("7PRwo");

var $fg3x0 = parcelRequire("fg3x0");

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");
var $0e80e01b27b24df8$var$DataType;
(function(DataType) {
    DataType[DataType["Correct"] = 0] = "Correct";
    DataType[DataType["Wrong"] = 1] = "Wrong";
})($0e80e01b27b24df8$var$DataType || (module.exports.DataType = $0e80e01b27b24df8$var$DataType = {}));
function $0e80e01b27b24df8$var$getSchemaTypes(schema) {
    const types = $0e80e01b27b24df8$var$getJSONTypes(schema.type);
    const hasNull = types.includes("null");
    if (hasNull) {
        if (schema.nullable === false) throw new Error("type: null contradicts nullable: false");
    } else {
        if (!types.length && schema.nullable !== undefined) throw new Error('"nullable" cannot be used without "type"');
        if (schema.nullable === true) types.push("null");
    }
    return types;
}
module.exports.getSchemaTypes = $0e80e01b27b24df8$var$getSchemaTypes;
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
function $0e80e01b27b24df8$var$getJSONTypes(ts) {
    const types = Array.isArray(ts) ? ts : ts ? [
        ts
    ] : [];
    if (types.every($3OQ8t.isJSONType)) return types;
    throw new Error("type must be JSONType or JSONType[]: " + types.join(","));
}
module.exports.getJSONTypes = $0e80e01b27b24df8$var$getJSONTypes;
function $0e80e01b27b24df8$var$coerceAndCheckDataType(it, types) {
    const { gen: gen, data: data, opts: opts } = it;
    const coerceTo = $0e80e01b27b24df8$var$coerceToTypes(types, opts.coerceTypes);
    const checkTypes = types.length > 0 && !(coerceTo.length === 0 && types.length === 1 && (0, $7PRwo.schemaHasRulesForType)(it, types[0]));
    if (checkTypes) {
        const wrongType = $0e80e01b27b24df8$var$checkDataTypes(types, data, opts.strictNumbers, $0e80e01b27b24df8$var$DataType.Wrong);
        gen.if(wrongType, ()=>{
            if (coerceTo.length) $0e80e01b27b24df8$var$coerceData(it, types, coerceTo);
            else $0e80e01b27b24df8$var$reportTypeError(it);
        });
    }
    return checkTypes;
}
module.exports.coerceAndCheckDataType = $0e80e01b27b24df8$var$coerceAndCheckDataType;
const $0e80e01b27b24df8$var$COERCIBLE = new Set([
    "string",
    "number",
    "integer",
    "boolean",
    "null"
]);
function $0e80e01b27b24df8$var$coerceToTypes(types, coerceTypes) {
    return coerceTypes ? types.filter((t)=>$0e80e01b27b24df8$var$COERCIBLE.has(t) || coerceTypes === "array" && t === "array") : [];
}
function $0e80e01b27b24df8$var$coerceData(it, types, coerceTo) {
    const { gen: gen, data: data, opts: opts } = it;
    const dataType = gen.let("dataType", (0, $gQlP2._)`typeof ${data}`);
    const coerced = gen.let("coerced", (0, $gQlP2._)`undefined`);
    if (opts.coerceTypes === "array") gen.if((0, $gQlP2._)`${dataType} == 'object' && Array.isArray(${data}) && ${data}.length == 1`, ()=>gen.assign(data, (0, $gQlP2._)`${data}[0]`).assign(dataType, (0, $gQlP2._)`typeof ${data}`).if($0e80e01b27b24df8$var$checkDataTypes(types, data, opts.strictNumbers), ()=>gen.assign(coerced, data)));
    gen.if((0, $gQlP2._)`${coerced} !== undefined`);
    for (const t of coerceTo)if ($0e80e01b27b24df8$var$COERCIBLE.has(t) || t === "array" && opts.coerceTypes === "array") coerceSpecificType(t);
    gen.else();
    $0e80e01b27b24df8$var$reportTypeError(it);
    gen.endIf();
    gen.if((0, $gQlP2._)`${coerced} !== undefined`, ()=>{
        gen.assign(data, coerced);
        $0e80e01b27b24df8$var$assignParentData(it, coerced);
    });
    function coerceSpecificType(t) {
        switch(t){
            case "string":
                gen.elseIf((0, $gQlP2._)`${dataType} == "number" || ${dataType} == "boolean"`).assign(coerced, (0, $gQlP2._)`"" + ${data}`).elseIf((0, $gQlP2._)`${data} === null`).assign(coerced, (0, $gQlP2._)`""`);
                return;
            case "number":
                gen.elseIf((0, $gQlP2._)`${dataType} == "boolean" || ${data} === null
              || (${dataType} == "string" && ${data} && ${data} == +${data})`).assign(coerced, (0, $gQlP2._)`+${data}`);
                return;
            case "integer":
                gen.elseIf((0, $gQlP2._)`${dataType} === "boolean" || ${data} === null
              || (${dataType} === "string" && ${data} && ${data} == +${data} && !(${data} % 1))`).assign(coerced, (0, $gQlP2._)`+${data}`);
                return;
            case "boolean":
                gen.elseIf((0, $gQlP2._)`${data} === "false" || ${data} === 0 || ${data} === null`).assign(coerced, false).elseIf((0, $gQlP2._)`${data} === "true" || ${data} === 1`).assign(coerced, true);
                return;
            case "null":
                gen.elseIf((0, $gQlP2._)`${data} === "" || ${data} === 0 || ${data} === false`);
                gen.assign(coerced, null);
                return;
            case "array":
                gen.elseIf((0, $gQlP2._)`${dataType} === "string" || ${dataType} === "number"
              || ${dataType} === "boolean" || ${data} === null`).assign(coerced, (0, $gQlP2._)`[${data}]`);
        }
    }
}
function $0e80e01b27b24df8$var$assignParentData({ gen: gen, parentData: parentData, parentDataProperty: parentDataProperty }, expr) {
    // TODO use gen.property
    gen.if((0, $gQlP2._)`${parentData} !== undefined`, ()=>gen.assign((0, $gQlP2._)`${parentData}[${parentDataProperty}]`, expr));
}
function $0e80e01b27b24df8$var$checkDataType(dataType, data, strictNums, correct = $0e80e01b27b24df8$var$DataType.Correct) {
    const EQ = correct === $0e80e01b27b24df8$var$DataType.Correct ? $gQlP2.operators.EQ : $gQlP2.operators.NEQ;
    let cond;
    switch(dataType){
        case "null":
            return (0, $gQlP2._)`${data} ${EQ} null`;
        case "array":
            cond = (0, $gQlP2._)`Array.isArray(${data})`;
            break;
        case "object":
            cond = (0, $gQlP2._)`${data} && typeof ${data} == "object" && !Array.isArray(${data})`;
            break;
        case "integer":
            cond = numCond((0, $gQlP2._)`!(${data} % 1) && !isNaN(${data})`);
            break;
        case "number":
            cond = numCond();
            break;
        default:
            return (0, $gQlP2._)`typeof ${data} ${EQ} ${dataType}`;
    }
    return correct === $0e80e01b27b24df8$var$DataType.Correct ? cond : (0, $gQlP2.not)(cond);
    function numCond(_cond = $gQlP2.nil) {
        return (0, $gQlP2.and)((0, $gQlP2._)`typeof ${data} == "number"`, _cond, strictNums ? (0, $gQlP2._)`isFinite(${data})` : $gQlP2.nil);
    }
}
module.exports.checkDataType = $0e80e01b27b24df8$var$checkDataType;
function $0e80e01b27b24df8$var$checkDataTypes(dataTypes, data, strictNums, correct) {
    if (dataTypes.length === 1) return $0e80e01b27b24df8$var$checkDataType(dataTypes[0], data, strictNums, correct);
    let cond;
    const types = (0, $1XGcl.toHash)(dataTypes);
    if (types.array && types.object) {
        const notObj = (0, $gQlP2._)`typeof ${data} != "object"`;
        cond = types.null ? notObj : (0, $gQlP2._)`!${data} || ${notObj}`;
        delete types.null;
        delete types.array;
        delete types.object;
    } else cond = $gQlP2.nil;
    if (types.number) delete types.integer;
    for(const t in types)cond = (0, $gQlP2.and)(cond, $0e80e01b27b24df8$var$checkDataType(t, data, strictNums, correct));
    return cond;
}
module.exports.checkDataTypes = $0e80e01b27b24df8$var$checkDataTypes;
const $0e80e01b27b24df8$var$typeError = {
    message: ({ schema: schema })=>`must be ${schema}`,
    params: ({ schema: schema, schemaValue: schemaValue })=>typeof schema == "string" ? (0, $gQlP2._)`{type: ${schema}}` : (0, $gQlP2._)`{type: ${schemaValue}}`
};
function $0e80e01b27b24df8$var$reportTypeError(it) {
    const cxt = $0e80e01b27b24df8$var$getTypeErrorContext(it);
    (0, $fg3x0.reportError)(cxt, $0e80e01b27b24df8$var$typeError);
}
module.exports.reportTypeError = $0e80e01b27b24df8$var$reportTypeError;
function $0e80e01b27b24df8$var$getTypeErrorContext(it) {
    const { gen: gen, data: data, schema: schema } = it;
    const schemaCode = (0, $1XGcl.schemaRefOrVal)(it, schema, "type");
    return {
        gen: gen,
        keyword: "type",
        data: data,
        schema: schema.type,
        schemaCode: schemaCode,
        schemaValue: schemaCode,
        parentSchema: schema,
        params: {},
        it: it
    };
}

});
parcelRegister("3OQ8t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRules = module.exports.isJSONType = void 0;
const $2c7e7bb0dafa32df$var$_jsonTypes = [
    "string",
    "number",
    "integer",
    "boolean",
    "null",
    "object",
    "array"
];
const $2c7e7bb0dafa32df$var$jsonTypes = new Set($2c7e7bb0dafa32df$var$_jsonTypes);
function $2c7e7bb0dafa32df$var$isJSONType(x) {
    return typeof x == "string" && $2c7e7bb0dafa32df$var$jsonTypes.has(x);
}
module.exports.isJSONType = $2c7e7bb0dafa32df$var$isJSONType;
function $2c7e7bb0dafa32df$var$getRules() {
    const groups = {
        number: {
            type: "number",
            rules: []
        },
        string: {
            type: "string",
            rules: []
        },
        array: {
            type: "array",
            rules: []
        },
        object: {
            type: "object",
            rules: []
        }
    };
    return {
        types: {
            ...groups,
            integer: true,
            boolean: true,
            null: true
        },
        rules: [
            {
                rules: []
            },
            groups.number,
            groups.string,
            groups.array,
            groups.object
        ],
        post: {
            rules: []
        },
        all: {},
        keywords: {}
    };
}
module.exports.getRules = $2c7e7bb0dafa32df$var$getRules;

});

parcelRegister("7PRwo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shouldUseRule = module.exports.shouldUseGroup = module.exports.schemaHasRulesForType = void 0;
function $5b46d00cf7cbd33f$var$schemaHasRulesForType({ schema: schema, self: self }, type) {
    const group = self.RULES.types[type];
    return group && group !== true && $5b46d00cf7cbd33f$var$shouldUseGroup(schema, group);
}
module.exports.schemaHasRulesForType = $5b46d00cf7cbd33f$var$schemaHasRulesForType;
function $5b46d00cf7cbd33f$var$shouldUseGroup(schema, group) {
    return group.rules.some((rule)=>$5b46d00cf7cbd33f$var$shouldUseRule(schema, rule));
}
module.exports.shouldUseGroup = $5b46d00cf7cbd33f$var$shouldUseGroup;
function $5b46d00cf7cbd33f$var$shouldUseRule(schema, rule) {
    var _a;
    return schema[rule.keyword] !== undefined || ((_a = rule.definition.implements) === null || _a === void 0 ? void 0 : _a.some((kwd)=>schema[kwd] !== undefined));
}
module.exports.shouldUseRule = $5b46d00cf7cbd33f$var$shouldUseRule;

});


parcelRegister("7r2tH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignDefaults = void 0;

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");
function $569cfa1f3e86b798$var$assignDefaults(it, ty) {
    const { properties: properties, items: items } = it.schema;
    if (ty === "object" && properties) for(const key in properties)$569cfa1f3e86b798$var$assignDefault(it, key, properties[key].default);
    else if (ty === "array" && Array.isArray(items)) items.forEach((sch, i)=>$569cfa1f3e86b798$var$assignDefault(it, i, sch.default));
}
module.exports.assignDefaults = $569cfa1f3e86b798$var$assignDefaults;
function $569cfa1f3e86b798$var$assignDefault(it, prop, defaultValue) {
    const { gen: gen, compositeRule: compositeRule, data: data, opts: opts } = it;
    if (defaultValue === undefined) return;
    const childData = (0, $gQlP2._)`${data}${(0, $gQlP2.getProperty)(prop)}`;
    if (compositeRule) {
        (0, $1XGcl.checkStrictMode)(it, `default is ignored for: ${childData}`);
        return;
    }
    let condition = (0, $gQlP2._)`${childData} === undefined`;
    if (opts.useDefaults === "empty") condition = (0, $gQlP2._)`${condition} || ${childData} === null || ${childData} === ""`;
    // `${childData} === undefined` +
    // (opts.useDefaults === "empty" ? ` || ${childData} === null || ${childData} === ""` : "")
    gen.if(condition, (0, $gQlP2._)`${childData} = ${(0, $gQlP2.stringify)(defaultValue)}`);
}

});

parcelRegister("fy2SA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateKeywordUsage = module.exports.validSchemaType = module.exports.funcKeywordCode = module.exports.macroKeywordCode = void 0;

var $gQlP2 = parcelRequire("gQlP2");

var $jfMv8 = parcelRequire("jfMv8");

var $f7S6Z = parcelRequire("f7S6Z");

var $fg3x0 = parcelRequire("fg3x0");
function $b51c43c3e3b91b5a$var$macroKeywordCode(cxt, def) {
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, it: it } = cxt;
    const macroSchema = def.macro.call(it.self, schema, parentSchema, it);
    const schemaRef = $b51c43c3e3b91b5a$var$useKeyword(gen, keyword, macroSchema);
    if (it.opts.validateSchema !== false) it.self.validateSchema(macroSchema, true);
    const valid = gen.name("valid");
    cxt.subschema({
        schema: macroSchema,
        schemaPath: $gQlP2.nil,
        errSchemaPath: `${it.errSchemaPath}/${keyword}`,
        topSchemaRef: schemaRef,
        compositeRule: true
    }, valid);
    cxt.pass(valid, ()=>cxt.error(true));
}
module.exports.macroKeywordCode = $b51c43c3e3b91b5a$var$macroKeywordCode;
function $b51c43c3e3b91b5a$var$funcKeywordCode(cxt, def) {
    var _a;
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, $data: $data, it: it } = cxt;
    $b51c43c3e3b91b5a$var$checkAsyncKeyword(it, def);
    const validate = !$data && def.compile ? def.compile.call(it.self, schema, parentSchema, it) : def.validate;
    const validateRef = $b51c43c3e3b91b5a$var$useKeyword(gen, keyword, validate);
    const valid = gen.let("valid");
    cxt.block$data(valid, validateKeyword);
    cxt.ok((_a = def.valid) !== null && _a !== void 0 ? _a : valid);
    function validateKeyword() {
        if (def.errors === false) {
            assignValid();
            if (def.modifying) $b51c43c3e3b91b5a$var$modifyData(cxt);
            reportErrs(()=>cxt.error());
        } else {
            const ruleErrs = def.async ? validateAsync() : validateSync();
            if (def.modifying) $b51c43c3e3b91b5a$var$modifyData(cxt);
            reportErrs(()=>$b51c43c3e3b91b5a$var$addErrs(cxt, ruleErrs));
        }
    }
    function validateAsync() {
        const ruleErrs = gen.let("ruleErrs", null);
        gen.try(()=>assignValid((0, $gQlP2._)`await `), (e)=>gen.assign(valid, false).if((0, $gQlP2._)`${e} instanceof ${it.ValidationError}`, ()=>gen.assign(ruleErrs, (0, $gQlP2._)`${e}.errors`), ()=>gen.throw(e)));
        return ruleErrs;
    }
    function validateSync() {
        const validateErrs = (0, $gQlP2._)`${validateRef}.errors`;
        gen.assign(validateErrs, null);
        assignValid($gQlP2.nil);
        return validateErrs;
    }
    function assignValid(_await = def.async ? (0, $gQlP2._)`await ` : $gQlP2.nil) {
        const passCxt = it.opts.passContext ? $jfMv8.default.this : $jfMv8.default.self;
        const passSchema = !("compile" in def && !$data || def.schema === false);
        gen.assign(valid, (0, $gQlP2._)`${_await}${(0, $f7S6Z.callValidateCode)(cxt, validateRef, passCxt, passSchema)}`, def.modifying);
    }
    function reportErrs(errors) {
        var _a;
        gen.if((0, $gQlP2.not)((_a = def.valid) !== null && _a !== void 0 ? _a : valid), errors);
    }
}
module.exports.funcKeywordCode = $b51c43c3e3b91b5a$var$funcKeywordCode;
function $b51c43c3e3b91b5a$var$modifyData(cxt) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if(it.parentData, ()=>gen.assign(data, (0, $gQlP2._)`${it.parentData}[${it.parentDataProperty}]`));
}
function $b51c43c3e3b91b5a$var$addErrs(cxt, errs) {
    const { gen: gen } = cxt;
    gen.if((0, $gQlP2._)`Array.isArray(${errs})`, ()=>{
        gen.assign($jfMv8.default.vErrors, (0, $gQlP2._)`${$jfMv8.default.vErrors} === null ? ${errs} : ${$jfMv8.default.vErrors}.concat(${errs})`).assign($jfMv8.default.errors, (0, $gQlP2._)`${$jfMv8.default.vErrors}.length`);
        (0, $fg3x0.extendErrors)(cxt);
    }, ()=>cxt.error());
}
function $b51c43c3e3b91b5a$var$checkAsyncKeyword({ schemaEnv: schemaEnv }, def) {
    if (def.async && !schemaEnv.$async) throw new Error("async keyword in sync schema");
}
function $b51c43c3e3b91b5a$var$useKeyword(gen, keyword, result) {
    if (result === undefined) throw new Error(`keyword "${keyword}" failed to compile`);
    return gen.scopeValue("keyword", typeof result == "function" ? {
        ref: result
    } : {
        ref: result,
        code: (0, $gQlP2.stringify)(result)
    });
}
function $b51c43c3e3b91b5a$var$validSchemaType(schema, schemaType, allowUndefined = false) {
    // TODO add tests
    return !schemaType.length || schemaType.some((st)=>st === "array" ? Array.isArray(schema) : st === "object" ? schema && typeof schema == "object" && !Array.isArray(schema) : typeof schema == st || allowUndefined && typeof schema == "undefined");
}
module.exports.validSchemaType = $b51c43c3e3b91b5a$var$validSchemaType;
function $b51c43c3e3b91b5a$var$validateKeywordUsage({ schema: schema, opts: opts, self: self, errSchemaPath: errSchemaPath }, def, keyword) {
    /* istanbul ignore if */ if (Array.isArray(def.keyword) ? !def.keyword.includes(keyword) : def.keyword !== keyword) throw new Error("ajv implementation error");
    const deps = def.dependencies;
    if (deps === null || deps === void 0 ? void 0 : deps.some((kwd)=>!Object.prototype.hasOwnProperty.call(schema, kwd))) throw new Error(`parent schema must have dependencies of ${keyword}: ${deps.join(",")}`);
    if (def.validateSchema) {
        const valid = def.validateSchema(schema[keyword]);
        if (!valid) {
            const msg = `keyword "${keyword}" value is invalid at path "${errSchemaPath}": ` + self.errorsText(def.validateSchema.errors);
            if (opts.validateSchema === "log") self.logger.error(msg);
            else throw new Error(msg);
        }
    }
}
module.exports.validateKeywordUsage = $b51c43c3e3b91b5a$var$validateKeywordUsage;

});
parcelRegister("f7S6Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateUnion = module.exports.validateArray = module.exports.usePattern = module.exports.callValidateCode = module.exports.schemaProperties = module.exports.allSchemaProperties = module.exports.noPropertyInData = module.exports.propertyInData = module.exports.isOwnProperty = module.exports.hasPropFunc = module.exports.reportMissingProp = module.exports.checkMissingProp = module.exports.checkReportMissingProp = void 0;

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");

var $jfMv8 = parcelRequire("jfMv8");

var $1XGcl = parcelRequire("1XGcl");
function $b0317bed6a7c8caa$var$checkReportMissingProp(cxt, prop) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if($b0317bed6a7c8caa$var$noPropertyInData(gen, data, prop, it.opts.ownProperties), ()=>{
        cxt.setParams({
            missingProperty: (0, $gQlP2._)`${prop}`
        }, true);
        cxt.error();
    });
}
module.exports.checkReportMissingProp = $b0317bed6a7c8caa$var$checkReportMissingProp;
function $b0317bed6a7c8caa$var$checkMissingProp({ gen: gen, data: data, it: { opts: opts } }, properties, missing) {
    return (0, $gQlP2.or)(...properties.map((prop)=>(0, $gQlP2.and)($b0317bed6a7c8caa$var$noPropertyInData(gen, data, prop, opts.ownProperties), (0, $gQlP2._)`${missing} = ${prop}`)));
}
module.exports.checkMissingProp = $b0317bed6a7c8caa$var$checkMissingProp;
function $b0317bed6a7c8caa$var$reportMissingProp(cxt, missing) {
    cxt.setParams({
        missingProperty: missing
    }, true);
    cxt.error();
}
module.exports.reportMissingProp = $b0317bed6a7c8caa$var$reportMissingProp;
function $b0317bed6a7c8caa$var$hasPropFunc(gen) {
    return gen.scopeValue("func", {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        ref: Object.prototype.hasOwnProperty,
        code: (0, $gQlP2._)`Object.prototype.hasOwnProperty`
    });
}
module.exports.hasPropFunc = $b0317bed6a7c8caa$var$hasPropFunc;
function $b0317bed6a7c8caa$var$isOwnProperty(gen, data, property) {
    return (0, $gQlP2._)`${$b0317bed6a7c8caa$var$hasPropFunc(gen)}.call(${data}, ${property})`;
}
module.exports.isOwnProperty = $b0317bed6a7c8caa$var$isOwnProperty;
function $b0317bed6a7c8caa$var$propertyInData(gen, data, property, ownProperties) {
    const cond = (0, $gQlP2._)`${data}${(0, $gQlP2.getProperty)(property)} !== undefined`;
    return ownProperties ? (0, $gQlP2._)`${cond} && ${$b0317bed6a7c8caa$var$isOwnProperty(gen, data, property)}` : cond;
}
module.exports.propertyInData = $b0317bed6a7c8caa$var$propertyInData;
function $b0317bed6a7c8caa$var$noPropertyInData(gen, data, property, ownProperties) {
    const cond = (0, $gQlP2._)`${data}${(0, $gQlP2.getProperty)(property)} === undefined`;
    return ownProperties ? (0, $gQlP2.or)(cond, (0, $gQlP2.not)($b0317bed6a7c8caa$var$isOwnProperty(gen, data, property))) : cond;
}
module.exports.noPropertyInData = $b0317bed6a7c8caa$var$noPropertyInData;
function $b0317bed6a7c8caa$var$allSchemaProperties(schemaMap) {
    return schemaMap ? Object.keys(schemaMap).filter((p)=>p !== "__proto__") : [];
}
module.exports.allSchemaProperties = $b0317bed6a7c8caa$var$allSchemaProperties;
function $b0317bed6a7c8caa$var$schemaProperties(it, schemaMap) {
    return $b0317bed6a7c8caa$var$allSchemaProperties(schemaMap).filter((p)=>!(0, $1XGcl.alwaysValidSchema)(it, schemaMap[p]));
}
module.exports.schemaProperties = $b0317bed6a7c8caa$var$schemaProperties;
function $b0317bed6a7c8caa$var$callValidateCode({ schemaCode: schemaCode, data: data, it: { gen: gen, topSchemaRef: topSchemaRef, schemaPath: schemaPath, errorPath: errorPath }, it: it }, func, context, passSchema) {
    const dataAndSchema = passSchema ? (0, $gQlP2._)`${schemaCode}, ${data}, ${topSchemaRef}${schemaPath}` : data;
    const valCxt = [
        [
            $jfMv8.default.instancePath,
            (0, $gQlP2.strConcat)($jfMv8.default.instancePath, errorPath)
        ],
        [
            $jfMv8.default.parentData,
            it.parentData
        ],
        [
            $jfMv8.default.parentDataProperty,
            it.parentDataProperty
        ],
        [
            $jfMv8.default.rootData,
            $jfMv8.default.rootData
        ]
    ];
    if (it.opts.dynamicRef) valCxt.push([
        $jfMv8.default.dynamicAnchors,
        $jfMv8.default.dynamicAnchors
    ]);
    const args = (0, $gQlP2._)`${dataAndSchema}, ${gen.object(...valCxt)}`;
    return context !== $gQlP2.nil ? (0, $gQlP2._)`${func}.call(${context}, ${args})` : (0, $gQlP2._)`${func}(${args})`;
}
module.exports.callValidateCode = $b0317bed6a7c8caa$var$callValidateCode;
const $b0317bed6a7c8caa$var$newRegExp = (0, $gQlP2._)`new RegExp`;
function $b0317bed6a7c8caa$var$usePattern({ gen: gen, it: { opts: opts } }, pattern) {
    const u = opts.unicodeRegExp ? "u" : "";
    const { regExp: regExp } = opts.code;
    const rx = regExp(pattern, u);
    return gen.scopeValue("pattern", {
        key: rx.toString(),
        ref: rx,
        code: (0, $gQlP2._)`${regExp.code === "new RegExp" ? $b0317bed6a7c8caa$var$newRegExp : (0, $1XGcl.useFunc)(gen, regExp)}(${pattern}, ${u})`
    });
}
module.exports.usePattern = $b0317bed6a7c8caa$var$usePattern;
function $b0317bed6a7c8caa$var$validateArray(cxt) {
    const { gen: gen, data: data, keyword: keyword, it: it } = cxt;
    const valid = gen.name("valid");
    if (it.allErrors) {
        const validArr = gen.let("valid", true);
        validateItems(()=>gen.assign(validArr, false));
        return validArr;
    }
    gen.var(valid, true);
    validateItems(()=>gen.break());
    return valid;
    function validateItems(notValid) {
        const len = gen.const("len", (0, $gQlP2._)`${data}.length`);
        gen.forRange("i", 0, len, (i)=>{
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $1XGcl.Type.Num
            }, valid);
            gen.if((0, $gQlP2.not)(valid), notValid);
        });
    }
}
module.exports.validateArray = $b0317bed6a7c8caa$var$validateArray;
function $b0317bed6a7c8caa$var$validateUnion(cxt) {
    const { gen: gen, schema: schema, keyword: keyword, it: it } = cxt;
    /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
    const alwaysValid = schema.some((sch)=>(0, $1XGcl.alwaysValidSchema)(it, sch));
    if (alwaysValid && !it.opts.unevaluated) return;
    const valid = gen.let("valid", false);
    const schValid = gen.name("_valid");
    gen.block(()=>schema.forEach((_sch, i)=>{
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                compositeRule: true
            }, schValid);
            gen.assign(valid, (0, $gQlP2._)`${valid} || ${schValid}`);
            const merged = cxt.mergeValidEvaluated(schCxt, schValid);
            // can short-circuit if `unevaluatedProperties/Items` not supported (opts.unevaluated !== true)
            // or if all properties and items were evaluated (it.props === true && it.items === true)
            if (!merged) gen.if((0, $gQlP2.not)(valid));
        }));
    cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
}
module.exports.validateUnion = $b0317bed6a7c8caa$var$validateUnion;

});


parcelRegister("jvI7z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendSubschemaMode = module.exports.extendSubschemaData = module.exports.getSubschema = void 0;

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");
function $e343231c5c944ccf$var$getSubschema(it, { keyword: keyword, schemaProp: schemaProp, schema: schema, schemaPath: schemaPath, errSchemaPath: errSchemaPath, topSchemaRef: topSchemaRef }) {
    if (keyword !== undefined && schema !== undefined) throw new Error('both "keyword" and "schema" passed, only one allowed');
    if (keyword !== undefined) {
        const sch = it.schema[keyword];
        return schemaProp === undefined ? {
            schema: sch,
            schemaPath: (0, $gQlP2._)`${it.schemaPath}${(0, $gQlP2.getProperty)(keyword)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}`
        } : {
            schema: sch[schemaProp],
            schemaPath: (0, $gQlP2._)`${it.schemaPath}${(0, $gQlP2.getProperty)(keyword)}${(0, $gQlP2.getProperty)(schemaProp)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}/${(0, $1XGcl.escapeFragment)(schemaProp)}`
        };
    }
    if (schema !== undefined) {
        if (schemaPath === undefined || errSchemaPath === undefined || topSchemaRef === undefined) throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
        return {
            schema: schema,
            schemaPath: schemaPath,
            topSchemaRef: topSchemaRef,
            errSchemaPath: errSchemaPath
        };
    }
    throw new Error('either "keyword" or "schema" must be passed');
}
module.exports.getSubschema = $e343231c5c944ccf$var$getSubschema;
function $e343231c5c944ccf$var$extendSubschemaData(subschema, it, { dataProp: dataProp, dataPropType: dpType, data: data, dataTypes: dataTypes, propertyName: propertyName }) {
    if (data !== undefined && dataProp !== undefined) throw new Error('both "data" and "dataProp" passed, only one allowed');
    const { gen: gen } = it;
    if (dataProp !== undefined) {
        const { errorPath: errorPath, dataPathArr: dataPathArr, opts: opts } = it;
        const nextData = gen.let("data", (0, $gQlP2._)`${it.data}${(0, $gQlP2.getProperty)(dataProp)}`, true);
        dataContextProps(nextData);
        subschema.errorPath = (0, $gQlP2.str)`${errorPath}${(0, $1XGcl.getErrorPath)(dataProp, dpType, opts.jsPropertySyntax)}`;
        subschema.parentDataProperty = (0, $gQlP2._)`${dataProp}`;
        subschema.dataPathArr = [
            ...dataPathArr,
            subschema.parentDataProperty
        ];
    }
    if (data !== undefined) {
        const nextData = data instanceof $gQlP2.Name ? data : gen.let("data", data, true); // replaceable if used once?
        dataContextProps(nextData);
        if (propertyName !== undefined) subschema.propertyName = propertyName;
    // TODO something is possibly wrong here with not changing parentDataProperty and not appending dataPathArr
    }
    if (dataTypes) subschema.dataTypes = dataTypes;
    function dataContextProps(_nextData) {
        subschema.data = _nextData;
        subschema.dataLevel = it.dataLevel + 1;
        subschema.dataTypes = [];
        it.definedProperties = new Set();
        subschema.parentData = it.data;
        subschema.dataNames = [
            ...it.dataNames,
            _nextData
        ];
    }
}
module.exports.extendSubschemaData = $e343231c5c944ccf$var$extendSubschemaData;
function $e343231c5c944ccf$var$extendSubschemaMode(subschema, { jtdDiscriminator: jtdDiscriminator, jtdMetadata: jtdMetadata, compositeRule: compositeRule, createErrors: createErrors, allErrors: allErrors }) {
    if (compositeRule !== undefined) subschema.compositeRule = compositeRule;
    if (createErrors !== undefined) subschema.createErrors = createErrors;
    if (allErrors !== undefined) subschema.allErrors = allErrors;
    subschema.jtdDiscriminator = jtdDiscriminator; // not inherited
    subschema.jtdMetadata = jtdMetadata; // not inherited
}
module.exports.extendSubschemaMode = $e343231c5c944ccf$var$extendSubschemaMode;

});

parcelRegister("8TcHq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSchemaRefs = module.exports.resolveUrl = module.exports.normalizeId = module.exports._getFullPath = module.exports.getFullPath = module.exports.inlineRef = void 0;

var $1XGcl = parcelRequire("1XGcl");

var $5jHra = parcelRequire("5jHra");

var $2re4I = parcelRequire("2re4I");
// TODO refactor to use keyword definitions
const $678d4f9a704839c2$var$SIMPLE_INLINED = new Set([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum",
    "const"
]);
function $678d4f9a704839c2$var$inlineRef(schema, limit = true) {
    if (typeof schema == "boolean") return true;
    if (limit === true) return !$678d4f9a704839c2$var$hasRef(schema);
    if (!limit) return false;
    return $678d4f9a704839c2$var$countKeys(schema) <= limit;
}
module.exports.inlineRef = $678d4f9a704839c2$var$inlineRef;
const $678d4f9a704839c2$var$REF_KEYWORDS = new Set([
    "$ref",
    "$recursiveRef",
    "$recursiveAnchor",
    "$dynamicRef",
    "$dynamicAnchor"
]);
function $678d4f9a704839c2$var$hasRef(schema) {
    for(const key in schema){
        if ($678d4f9a704839c2$var$REF_KEYWORDS.has(key)) return true;
        const sch = schema[key];
        if (Array.isArray(sch) && sch.some($678d4f9a704839c2$var$hasRef)) return true;
        if (typeof sch == "object" && $678d4f9a704839c2$var$hasRef(sch)) return true;
    }
    return false;
}
function $678d4f9a704839c2$var$countKeys(schema) {
    let count = 0;
    for(const key in schema){
        if (key === "$ref") return Infinity;
        count++;
        if ($678d4f9a704839c2$var$SIMPLE_INLINED.has(key)) continue;
        if (typeof schema[key] == "object") (0, $1XGcl.eachItem)(schema[key], (sch)=>count += $678d4f9a704839c2$var$countKeys(sch));
        if (count === Infinity) return Infinity;
    }
    return count;
}
function $678d4f9a704839c2$var$getFullPath(resolver, id = "", normalize) {
    if (normalize !== false) id = $678d4f9a704839c2$var$normalizeId(id);
    const p = resolver.parse(id);
    return $678d4f9a704839c2$var$_getFullPath(resolver, p);
}
module.exports.getFullPath = $678d4f9a704839c2$var$getFullPath;
function $678d4f9a704839c2$var$_getFullPath(resolver, p) {
    const serialized = resolver.serialize(p);
    return serialized.split("#")[0] + "#";
}
module.exports._getFullPath = $678d4f9a704839c2$var$_getFullPath;
const $678d4f9a704839c2$var$TRAILING_SLASH_HASH = /#\/?$/;
function $678d4f9a704839c2$var$normalizeId(id) {
    return id ? id.replace($678d4f9a704839c2$var$TRAILING_SLASH_HASH, "") : "";
}
module.exports.normalizeId = $678d4f9a704839c2$var$normalizeId;
function $678d4f9a704839c2$var$resolveUrl(resolver, baseId, id) {
    id = $678d4f9a704839c2$var$normalizeId(id);
    return resolver.resolve(baseId, id);
}
module.exports.resolveUrl = $678d4f9a704839c2$var$resolveUrl;
const $678d4f9a704839c2$var$ANCHOR = /^[a-z_][-a-z0-9._]*$/i;
function $678d4f9a704839c2$var$getSchemaRefs(schema, baseId) {
    if (typeof schema == "boolean") return {};
    const { schemaId: schemaId, uriResolver: uriResolver } = this.opts;
    const schId = $678d4f9a704839c2$var$normalizeId(schema[schemaId] || baseId);
    const baseIds = {
        "": schId
    };
    const pathPrefix = $678d4f9a704839c2$var$getFullPath(uriResolver, schId, false);
    const localRefs = {};
    const schemaRefs = new Set();
    $2re4I(schema, {
        allKeys: true
    }, (sch, jsonPtr, _, parentJsonPtr)=>{
        if (parentJsonPtr === undefined) return;
        const fullPath = pathPrefix + jsonPtr;
        let innerBaseId = baseIds[parentJsonPtr];
        if (typeof sch[schemaId] == "string") innerBaseId = addRef.call(this, sch[schemaId]);
        addAnchor.call(this, sch.$anchor);
        addAnchor.call(this, sch.$dynamicAnchor);
        baseIds[jsonPtr] = innerBaseId;
        function addRef(ref) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const _resolve = this.opts.uriResolver.resolve;
            ref = $678d4f9a704839c2$var$normalizeId(innerBaseId ? _resolve(innerBaseId, ref) : ref);
            if (schemaRefs.has(ref)) throw ambiguos(ref);
            schemaRefs.add(ref);
            let schOrRef = this.refs[ref];
            if (typeof schOrRef == "string") schOrRef = this.refs[schOrRef];
            if (typeof schOrRef == "object") checkAmbiguosRef(sch, schOrRef.schema, ref);
            else if (ref !== $678d4f9a704839c2$var$normalizeId(fullPath)) {
                if (ref[0] === "#") {
                    checkAmbiguosRef(sch, localRefs[ref], ref);
                    localRefs[ref] = sch;
                } else this.refs[ref] = fullPath;
            }
            return ref;
        }
        function addAnchor(anchor) {
            if (typeof anchor == "string") {
                if (!$678d4f9a704839c2$var$ANCHOR.test(anchor)) throw new Error(`invalid anchor "${anchor}"`);
                addRef.call(this, `#${anchor}`);
            }
        }
    });
    return localRefs;
    function checkAmbiguosRef(sch1, sch2, ref) {
        if (sch2 !== undefined && !$5jHra(sch1, sch2)) throw ambiguos(ref);
    }
    function ambiguos(ref) {
        return new Error(`reference "${ref}" resolves to more than one schema`);
    }
}
module.exports.getSchemaRefs = $678d4f9a704839c2$var$getSchemaRefs;

});
parcelRegister("5jHra", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("2re4I", function(module, exports) {
'use strict';
var $1c6905674312bc17$var$traverse = module.exports = function(schema, opts, cb) {
    // Legacy support for v0.3.1 and earlier.
    if (typeof opts == 'function') {
        cb = opts;
        opts = {};
    }
    cb = opts.cb || cb;
    var pre = typeof cb == 'function' ? cb : cb.pre || function() {};
    var post = cb.post || function() {};
    $1c6905674312bc17$var$_traverse(opts, pre, post, schema, '', schema);
};
$1c6905674312bc17$var$traverse.keywords = {
    additionalItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    propertyNames: true,
    not: true,
    if: true,
    then: true,
    else: true
};
$1c6905674312bc17$var$traverse.arrayKeywords = {
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
$1c6905674312bc17$var$traverse.propsKeywords = {
    $defs: true,
    definitions: true,
    properties: true,
    patternProperties: true,
    dependencies: true
};
$1c6905674312bc17$var$traverse.skipKeywords = {
    default: true,
    enum: true,
    const: true,
    required: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
function $1c6905674312bc17$var$_traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (schema && typeof schema == 'object' && !Array.isArray(schema)) {
        pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
        for(var key in schema){
            var sch = schema[key];
            if (Array.isArray(sch)) {
                if (key in $1c6905674312bc17$var$traverse.arrayKeywords) for(var i = 0; i < sch.length; i++)$1c6905674312bc17$var$_traverse(opts, pre, post, sch[i], jsonPtr + '/' + key + '/' + i, rootSchema, jsonPtr, key, schema, i);
            } else if (key in $1c6905674312bc17$var$traverse.propsKeywords) {
                if (sch && typeof sch == 'object') for(var prop in sch)$1c6905674312bc17$var$_traverse(opts, pre, post, sch[prop], jsonPtr + '/' + key + '/' + $1c6905674312bc17$var$escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
            } else if (key in $1c6905674312bc17$var$traverse.keywords || opts.allKeys && !(key in $1c6905674312bc17$var$traverse.skipKeywords)) $1c6905674312bc17$var$_traverse(opts, pre, post, sch, jsonPtr + '/' + key, rootSchema, jsonPtr, key, schema);
        }
        post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    }
}
function $1c6905674312bc17$var$escapeJsonPtr(str) {
    return str.replace(/~/g, '~0').replace(/\//g, '~1');
}

});



parcelRegister("7aOSD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $5390ef546af7dc0c$var$ValidationError extends Error {
    constructor(errors){
        super("validation failed");
        this.errors = errors;
        this.ajv = this.validation = true;
    }
}
module.exports.default = $5390ef546af7dc0c$var$ValidationError;

});

parcelRegister("kgLTL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8TcHq = parcelRequire("8TcHq");
class $ec1a74ead996e721$var$MissingRefError extends Error {
    constructor(resolver, baseId, ref, msg){
        super(msg || `can't resolve reference ${ref} from id ${baseId}`);
        this.missingRef = (0, $8TcHq.resolveUrl)(resolver, baseId, ref);
        this.missingSchema = (0, $8TcHq.normalizeId)((0, $8TcHq.getFullPath)(resolver, this.missingRef));
    }
}
module.exports.default = $ec1a74ead996e721$var$MissingRefError;

});

parcelRegister("5G1Th", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveSchema = module.exports.getCompilingSchema = module.exports.resolveRef = module.exports.compileSchema = module.exports.SchemaEnv = void 0;

var $gQlP2 = parcelRequire("gQlP2");

var $7aOSD = parcelRequire("7aOSD");

var $jfMv8 = parcelRequire("jfMv8");

var $8TcHq = parcelRequire("8TcHq");

var $1XGcl = parcelRequire("1XGcl");

var $6qXjM = parcelRequire("6qXjM");
class $4222576d575c6859$var$SchemaEnv {
    constructor(env){
        var _a;
        this.refs = {};
        this.dynamicAnchors = {};
        let schema;
        if (typeof env.schema == "object") schema = env.schema;
        this.schema = env.schema;
        this.schemaId = env.schemaId;
        this.root = env.root || this;
        this.baseId = (_a = env.baseId) !== null && _a !== void 0 ? _a : (0, $8TcHq.normalizeId)(schema === null || schema === void 0 ? void 0 : schema[env.schemaId || "$id"]);
        this.schemaPath = env.schemaPath;
        this.localRefs = env.localRefs;
        this.meta = env.meta;
        this.$async = schema === null || schema === void 0 ? void 0 : schema.$async;
        this.refs = {};
    }
}
module.exports.SchemaEnv = $4222576d575c6859$var$SchemaEnv;
// let codeSize = 0
// let nodeCount = 0
// Compiles schema in SchemaEnv
function $4222576d575c6859$var$compileSchema(sch) {
    // TODO refactor - remove compilations
    const _sch = $4222576d575c6859$var$getCompilingSchema.call(this, sch);
    if (_sch) return _sch;
    const rootId = (0, $8TcHq.getFullPath)(this.opts.uriResolver, sch.root.baseId); // TODO if getFullPath removed 1 tests fails
    const { es5: es5, lines: lines } = this.opts.code;
    const { ownProperties: ownProperties } = this.opts;
    const gen = new $gQlP2.CodeGen(this.scope, {
        es5: es5,
        lines: lines,
        ownProperties: ownProperties
    });
    let _ValidationError;
    if (sch.$async) _ValidationError = gen.scopeValue("Error", {
        ref: $7aOSD.default,
        code: (0, $gQlP2._)`require("ajv/dist/runtime/validation_error").default`
    });
    const validateName = gen.scopeName("validate");
    sch.validateName = validateName;
    const schemaCxt = {
        gen: gen,
        allErrors: this.opts.allErrors,
        data: $jfMv8.default.data,
        parentData: $jfMv8.default.parentData,
        parentDataProperty: $jfMv8.default.parentDataProperty,
        dataNames: [
            $jfMv8.default.data
        ],
        dataPathArr: [
            $gQlP2.nil
        ],
        dataLevel: 0,
        dataTypes: [],
        definedProperties: new Set(),
        topSchemaRef: gen.scopeValue("schema", this.opts.code.source === true ? {
            ref: sch.schema,
            code: (0, $gQlP2.stringify)(sch.schema)
        } : {
            ref: sch.schema
        }),
        validateName: validateName,
        ValidationError: _ValidationError,
        schema: sch.schema,
        schemaEnv: sch,
        rootId: rootId,
        baseId: sch.baseId || rootId,
        schemaPath: $gQlP2.nil,
        errSchemaPath: sch.schemaPath || (this.opts.jtd ? "" : "#"),
        errorPath: (0, $gQlP2._)`""`,
        opts: this.opts,
        self: this
    };
    let sourceCode;
    try {
        this._compilations.add(sch);
        (0, $6qXjM.validateFunctionCode)(schemaCxt);
        gen.optimize(this.opts.code.optimize);
        // gen.optimize(1)
        const validateCode = gen.toString();
        sourceCode = `${gen.scopeRefs($jfMv8.default.scope)}return ${validateCode}`;
        // console.log((codeSize += sourceCode.length), (nodeCount += gen.nodeCount))
        if (this.opts.code.process) sourceCode = this.opts.code.process(sourceCode, sch);
        // console.log("\n\n\n *** \n", sourceCode)
        const makeValidate = new Function(`${$jfMv8.default.self}`, `${$jfMv8.default.scope}`, sourceCode);
        const validate = makeValidate(this, this.scope.get());
        this.scope.value(validateName, {
            ref: validate
        });
        validate.errors = null;
        validate.schema = sch.schema;
        validate.schemaEnv = sch;
        if (sch.$async) validate.$async = true;
        if (this.opts.code.source === true) validate.source = {
            validateName: validateName,
            validateCode: validateCode,
            scopeValues: gen._values
        };
        if (this.opts.unevaluated) {
            const { props: props, items: items } = schemaCxt;
            validate.evaluated = {
                props: props instanceof $gQlP2.Name ? undefined : props,
                items: items instanceof $gQlP2.Name ? undefined : items,
                dynamicProps: props instanceof $gQlP2.Name,
                dynamicItems: items instanceof $gQlP2.Name
            };
            if (validate.source) validate.source.evaluated = (0, $gQlP2.stringify)(validate.evaluated);
        }
        sch.validate = validate;
        return sch;
    } catch (e) {
        delete sch.validate;
        delete sch.validateName;
        if (sourceCode) this.logger.error("Error compiling schema, function code:", sourceCode);
        // console.log("\n\n\n *** \n", sourceCode, this.opts)
        throw e;
    } finally{
        this._compilations.delete(sch);
    }
}
module.exports.compileSchema = $4222576d575c6859$var$compileSchema;
function $4222576d575c6859$var$resolveRef(root, baseId, ref) {
    var _a;
    ref = (0, $8TcHq.resolveUrl)(this.opts.uriResolver, baseId, ref);
    const schOrFunc = root.refs[ref];
    if (schOrFunc) return schOrFunc;
    let _sch = $4222576d575c6859$var$resolve.call(this, root, ref);
    if (_sch === undefined) {
        const schema = (_a = root.localRefs) === null || _a === void 0 ? void 0 : _a[ref]; // TODO maybe localRefs should hold SchemaEnv
        const { schemaId: schemaId } = this.opts;
        if (schema) _sch = new $4222576d575c6859$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    if (_sch === undefined) return;
    return root.refs[ref] = $4222576d575c6859$var$inlineOrCompile.call(this, _sch);
}
module.exports.resolveRef = $4222576d575c6859$var$resolveRef;
function $4222576d575c6859$var$inlineOrCompile(sch) {
    if ((0, $8TcHq.inlineRef)(sch.schema, this.opts.inlineRefs)) return sch.schema;
    return sch.validate ? sch : $4222576d575c6859$var$compileSchema.call(this, sch);
}
// Index of schema compilation in the currently compiled list
function $4222576d575c6859$var$getCompilingSchema(schEnv) {
    for (const sch of this._compilations){
        if ($4222576d575c6859$var$sameSchemaEnv(sch, schEnv)) return sch;
    }
}
module.exports.getCompilingSchema = $4222576d575c6859$var$getCompilingSchema;
function $4222576d575c6859$var$sameSchemaEnv(s1, s2) {
    return s1.schema === s2.schema && s1.root === s2.root && s1.baseId === s2.baseId;
}
// resolve and compile the references ($ref)
// TODO returns AnySchemaObject (if the schema can be inlined) or validation function
function $4222576d575c6859$var$resolve(root, ref // reference to resolve
) {
    let sch;
    while(typeof (sch = this.refs[ref]) == "string")ref = sch;
    return sch || this.schemas[ref] || $4222576d575c6859$var$resolveSchema.call(this, root, ref);
}
// Resolve schema, its root and baseId
function $4222576d575c6859$var$resolveSchema(root, ref // reference to resolve
) {
    const p = this.opts.uriResolver.parse(ref);
    const refPath = (0, $8TcHq._getFullPath)(this.opts.uriResolver, p);
    let baseId = (0, $8TcHq.getFullPath)(this.opts.uriResolver, root.baseId, undefined);
    // TODO `Object.keys(root.schema).length > 0` should not be needed - but removing breaks 2 tests
    if (Object.keys(root.schema).length > 0 && refPath === baseId) return $4222576d575c6859$var$getJsonPointer.call(this, p, root);
    const id = (0, $8TcHq.normalizeId)(refPath);
    const schOrRef = this.refs[id] || this.schemas[id];
    if (typeof schOrRef == "string") {
        const sch = $4222576d575c6859$var$resolveSchema.call(this, root, schOrRef);
        if (typeof (sch === null || sch === void 0 ? void 0 : sch.schema) !== "object") return;
        return $4222576d575c6859$var$getJsonPointer.call(this, p, sch);
    }
    if (typeof (schOrRef === null || schOrRef === void 0 ? void 0 : schOrRef.schema) !== "object") return;
    if (!schOrRef.validate) $4222576d575c6859$var$compileSchema.call(this, schOrRef);
    if (id === (0, $8TcHq.normalizeId)(ref)) {
        const { schema: schema } = schOrRef;
        const { schemaId: schemaId } = this.opts;
        const schId = schema[schemaId];
        if (schId) baseId = (0, $8TcHq.resolveUrl)(this.opts.uriResolver, baseId, schId);
        return new $4222576d575c6859$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    return $4222576d575c6859$var$getJsonPointer.call(this, p, schOrRef);
}
module.exports.resolveSchema = $4222576d575c6859$var$resolveSchema;
const $4222576d575c6859$var$PREVENT_SCOPE_CHANGE = new Set([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions"
]);
function $4222576d575c6859$var$getJsonPointer(parsedRef, { baseId: baseId, schema: schema, root: root }) {
    var _a;
    if (((_a = parsedRef.fragment) === null || _a === void 0 ? void 0 : _a[0]) !== "/") return;
    for (const part of parsedRef.fragment.slice(1).split("/")){
        if (typeof schema === "boolean") return;
        const partSchema = schema[(0, $1XGcl.unescapeFragment)(part)];
        if (partSchema === undefined) return;
        schema = partSchema;
        // TODO PREVENT_SCOPE_CHANGE could be defined in keyword def?
        const schId = typeof schema === "object" && schema[this.opts.schemaId];
        if (!$4222576d575c6859$var$PREVENT_SCOPE_CHANGE.has(part) && schId) baseId = (0, $8TcHq.resolveUrl)(this.opts.uriResolver, baseId, schId);
    }
    let env;
    if (typeof schema != "boolean" && schema.$ref && !(0, $1XGcl.schemaHasRulesButRef)(schema, this.RULES)) {
        const $ref = (0, $8TcHq.resolveUrl)(this.opts.uriResolver, baseId, schema.$ref);
        env = $4222576d575c6859$var$resolveSchema.call(this, root, $ref);
    }
    // even though resolution failed we need to return SchemaEnv to throw exception
    // so that compileAsync loads missing schema.
    const { schemaId: schemaId } = this.opts;
    env = env || new $4222576d575c6859$var$SchemaEnv({
        schema: schema,
        schemaId: schemaId,
        root: root,
        baseId: baseId
    });
    if (env.schema !== env.root.schema) return env;
    return undefined;
}

});

parcelRegister("eNmVS", function(module, exports) {
module.exports = JSON.parse("{\"$id\":\"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#\",\"description\":\"Meta-schema for $data reference (JSON AnySchema extension proposal)\",\"type\":\"object\",\"required\":[\"$data\"],\"properties\":{\"$data\":{\"type\":\"string\",\"anyOf\":[{\"format\":\"relative-json-pointer\"},{\"format\":\"json-pointer\"}]}},\"additionalProperties\":false}");

});

parcelRegister("8bR6S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9C0cr = parcelRequire("9C0cr");
$9C0cr.code = 'require("ajv/dist/runtime/uri").default';
module.exports.default = $9C0cr;

});
parcelRegister("9C0cr", function(module, exports) {
'use strict';

var $aXupK = parcelRequire("aXupK");
var $6ff7d1529c72e867$require$normalizeIPv6 = $aXupK.normalizeIPv6;
var $6ff7d1529c72e867$require$removeDotSegments = $aXupK.removeDotSegments;
var $6ff7d1529c72e867$require$recomposeAuthority = $aXupK.recomposeAuthority;
var $6ff7d1529c72e867$require$normalizePercentEncoding = $aXupK.normalizePercentEncoding;
var $6ff7d1529c72e867$require$normalizePathEncoding = $aXupK.normalizePathEncoding;
var $6ff7d1529c72e867$require$escapePreservingEscapes = $aXupK.escapePreservingEscapes;
var $6ff7d1529c72e867$require$reescapeHostDelimiters = $aXupK.reescapeHostDelimiters;
var $6ff7d1529c72e867$require$isIPv4 = $aXupK.isIPv4;
var $6ff7d1529c72e867$require$nonSimpleDomain = $aXupK.nonSimpleDomain;

var $cGtb6 = parcelRequire("cGtb6");
var $6ff7d1529c72e867$require$SCHEMES = $cGtb6.SCHEMES;
var $6ff7d1529c72e867$require$getSchemeHandler = $cGtb6.getSchemeHandler;
/**
 * @template {import('./types/index').URIComponent|string} T
 * @param {T} uri
 * @param {import('./types/index').Options} [options]
 * @returns {T}
 */ function $6ff7d1529c72e867$var$normalize(uri, options) {
    if (typeof uri === 'string') uri = /** @type {T} */ $6ff7d1529c72e867$var$normalizeString(uri, options);
    else if (typeof uri === 'object') uri = /** @type {T} */ $6ff7d1529c72e867$var$parse($6ff7d1529c72e867$var$serialize(uri, options), options);
    return uri;
}
/**
 * @param {string} baseURI
 * @param {string} relativeURI
 * @param {import('./types/index').Options} [options]
 * @returns {string}
 */ function $6ff7d1529c72e867$var$resolve(baseURI, relativeURI, options) {
    const schemelessOptions = options ? Object.assign({
        scheme: 'null'
    }, options) : {
        scheme: 'null'
    };
    const { parsed: baseParsed, malformedAuthorityOrPort: baseMalformed } = $6ff7d1529c72e867$var$parseWithStatus(baseURI, schemelessOptions);
    const { parsed: relativeParsed, malformedAuthorityOrPort: relativeMalformed } = $6ff7d1529c72e867$var$parseWithStatus(relativeURI, schemelessOptions);
    if (baseMalformed || relativeMalformed) throw new Error(baseParsed.error || relativeParsed.error || 'URI is malformed.');
    const resolved = $6ff7d1529c72e867$var$resolveComponent(baseParsed, relativeParsed, schemelessOptions, true);
    schemelessOptions.skipEscape = true;
    return $6ff7d1529c72e867$var$serialize(resolved, schemelessOptions);
}
/**
 * @param {import ('./types/index').URIComponent} base
 * @param {import ('./types/index').URIComponent} relative
 * @param {import('./types/index').Options} [options]
 * @param {boolean} [skipNormalization=false]
 * @returns {import ('./types/index').URIComponent}
 */ function $6ff7d1529c72e867$var$resolveComponent(base, relative, options, skipNormalization) {
    /** @type {import('./types/index').URIComponent} */ const target = {};
    if (!skipNormalization) {
        base = $6ff7d1529c72e867$var$parse($6ff7d1529c72e867$var$serialize(base, options), options) // normalize base component
        ;
        relative = $6ff7d1529c72e867$var$parse($6ff7d1529c72e867$var$serialize(relative, options), options) // normalize relative component
        ;
    }
    options = options || {};
    if (!options.tolerant && relative.scheme) {
        target.scheme = relative.scheme;
        // target.authority = relative.authority;
        target.userinfo = relative.userinfo;
        target.host = relative.host;
        target.port = relative.port;
        target.path = $6ff7d1529c72e867$require$removeDotSegments(relative.path || '');
        target.query = relative.query;
    } else {
        if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
            // target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = $6ff7d1529c72e867$require$removeDotSegments(relative.path || '');
            target.query = relative.query;
        } else {
            if (!relative.path) {
                target.path = base.path;
                if (relative.query !== undefined) target.query = relative.query;
                else target.query = base.query;
            } else {
                if (relative.path[0] === '/') target.path = $6ff7d1529c72e867$require$removeDotSegments(relative.path);
                else {
                    if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = '/' + relative.path;
                    else if (!base.path) target.path = relative.path;
                    else target.path = base.path.slice(0, base.path.lastIndexOf('/') + 1) + relative.path;
                    target.path = $6ff7d1529c72e867$require$removeDotSegments(target.path);
                }
                target.query = relative.query;
            }
            // target.authority = base.authority;
            target.userinfo = base.userinfo;
            target.host = base.host;
            target.port = base.port;
        }
        target.scheme = base.scheme;
    }
    target.fragment = relative.fragment;
    return target;
}
/**
 * @param {import ('./types/index').URIComponent|string} uriA
 * @param {import ('./types/index').URIComponent|string} uriB
 * @param {import ('./types/index').Options} options
 * @returns {boolean}
 */ function $6ff7d1529c72e867$var$equal(uriA, uriB, options) {
    const normalizedA = $6ff7d1529c72e867$var$normalizeComparableURI(uriA, options);
    const normalizedB = $6ff7d1529c72e867$var$normalizeComparableURI(uriB, options);
    return normalizedA !== undefined && normalizedB !== undefined && normalizedA.toLowerCase() === normalizedB.toLowerCase();
}
/**
 * @param {Readonly<import('./types/index').URIComponent>} cmpts
 * @param {import('./types/index').Options} [opts]
 * @returns {string}
 */ function $6ff7d1529c72e867$var$serialize(cmpts, opts) {
    const component = {
        host: cmpts.host,
        scheme: cmpts.scheme,
        userinfo: cmpts.userinfo,
        port: cmpts.port,
        path: cmpts.path,
        query: cmpts.query,
        nid: cmpts.nid,
        nss: cmpts.nss,
        uuid: cmpts.uuid,
        fragment: cmpts.fragment,
        reference: cmpts.reference,
        resourceName: cmpts.resourceName,
        secure: cmpts.secure,
        error: ''
    };
    const options = Object.assign({}, opts);
    const uriTokens = [];
    // find scheme handler
    const schemeHandler = $6ff7d1529c72e867$require$getSchemeHandler(options.scheme || component.scheme);
    // perform scheme specific serialization
    if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(component, options);
    if (component.path !== undefined) {
        if (!options.skipEscape) {
            component.path = $6ff7d1529c72e867$require$escapePreservingEscapes(component.path);
            if (component.scheme !== undefined) component.path = component.path.split('%3A').join(':');
        } else component.path = $6ff7d1529c72e867$require$normalizePercentEncoding(component.path);
    }
    if (options.reference !== 'suffix' && component.scheme) uriTokens.push(component.scheme, ':');
    const authority = $6ff7d1529c72e867$require$recomposeAuthority(component);
    if (authority !== undefined) {
        if (options.reference !== 'suffix') uriTokens.push('//');
        uriTokens.push(authority);
        if (component.path && component.path[0] !== '/') uriTokens.push('/');
    }
    if (component.path !== undefined) {
        let s = component.path;
        if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) s = $6ff7d1529c72e867$require$removeDotSegments(s);
        if (authority === undefined && s[0] === '/' && s[1] === '/') // don't allow the path to start with "//"
        s = '/%2F' + s.slice(2);
        uriTokens.push(s);
    }
    if (component.query !== undefined) uriTokens.push('?', component.query);
    if (component.fragment !== undefined) uriTokens.push('#', component.fragment);
    return uriTokens.join('');
}
const $6ff7d1529c72e867$var$URI_PARSE = /^(?:([^#/:?]+):)?(?:\/\/((?:([^#/?@]*)@)?(\[[^#/?\]]+\]|[^#/:?]*)(?::(\d*))?))?([^#?]*)(?:\?([^#]*))?(?:#((?:.|[\n\r])*))?/u;
// Captures the authority component (between "//" and the next "/", "?" or "#"),
// with or without a scheme prefix, for the literal-backslash rejection below.
const $6ff7d1529c72e867$var$AUTHORITY_PREFIX = /^(?:[^#/:?]+:)?\/\/([^/?#]*)/;
// Captures the leading authority-introducer region after an optional scheme: a
// run of forward slashes, backslashes, and the characters the WHATWG URL parser
// removes before parsing (TAB U+0009, LF U+000A, CR U+000D). A valid introducer
// is exactly "//". Node treats "\" as "/" on special schemes and strips those
// characters first, so forms like "\\", "/\", "\/", "/<TAB>/", or a leading
// "<TAB>//" reach an authority in Node while fast-uri's URI_PARSE folds them into
// the path group (host confusion / SSRF / redirect bypass).
const $6ff7d1529c72e867$var$AUTHORITY_INTRODUCER_REGION = /^(?:[^#/:?]+:)?([/\\\t\n\r]*)/;
/**
 * @param {import('./types/index').URIComponent} parsed
 * @param {RegExpMatchArray} matches
 * @returns {string|undefined}
 */ function $6ff7d1529c72e867$var$getParseError(parsed, matches) {
    if (matches[2] !== undefined && parsed.path && parsed.path[0] !== '/') return 'URI path must start with "/" when authority is present.';
    if (typeof parsed.port === 'number' && (parsed.port < 0 || parsed.port > 65535)) return 'URI port is malformed.';
    return undefined;
}
/**
 * @param {string} uri
 * @param {import('./types/index').Options} [opts]
 * @returns {{ parsed: import('./types/index').URIComponent, malformedAuthorityOrPort: boolean }}
 */ function $6ff7d1529c72e867$var$parseWithStatus(uri, opts) {
    const options = Object.assign({}, opts);
    /** @type {import('./types/index').URIComponent} */ const parsed = {
        scheme: undefined,
        userinfo: undefined,
        host: '',
        port: undefined,
        path: '',
        query: undefined,
        fragment: undefined
    };
    let malformedAuthorityOrPort = false;
    let isIP = false;
    if (options.reference === 'suffix') {
        if (options.scheme) uri = options.scheme + ':' + uri;
        else uri = '//' + uri;
    }
    // A literal backslash (U+005C) is not a valid RFC 3986 URI character and is
    // not an authority delimiter. Reject it in the authority rather than
    // rewriting it: normalizing "\" -> "/" (WHATWG error recovery) could silently
    // change the resource identified by an otherwise-invalid input, and lets "\"
    // act as a host delimiter here while Node's native URL parses a different
    // host (SSRF / redirect / origin-allowlist bypass). Percent-encoded %5C is
    // untouched and remains valid encoded data.
    const authorityMatch = uri.match($6ff7d1529c72e867$var$AUTHORITY_PREFIX);
    if (authorityMatch !== null && authorityMatch[1].indexOf('\\') !== -1) {
        parsed.error = 'URI authority must not contain a literal backslash.';
        malformedAuthorityOrPort = true;
    }
    // Reject a malformed or whitespace-smuggled authority introducer. fast-uri
    // only recognizes a literal "//"; anything else in the leading separator run
    // (a backslash, or a "//" that appears only after removing the TAB/LF/CR that
    // Node strips) means the authority fast-uri parses differs from the one Node's
    // URL resolves. Reject rather than rewrite, mirroring the literal-backslash
    // guard above. Percent-encoded forms (%5C, %09) are untouched, valid data.
    const introducerMatch = uri.match($6ff7d1529c72e867$var$AUTHORITY_INTRODUCER_REGION);
    if (introducerMatch !== null) {
        const region = introducerMatch[1];
        const normalizedRegion = region.replace(/[\t\n\r]/g, '');
        // Two or more leading separators introduce an authority.
        if (normalizedRegion.length >= 2) {
            if (normalizedRegion.slice(0, 2) !== '//') {
                parsed.error = parsed.error || 'URI authority must not contain a literal backslash.';
                malformedAuthorityOrPort = true;
            } else if (region.length !== normalizedRegion.length) {
                parsed.error = parsed.error || 'URI authority introducer must not contain whitespace.';
                malformedAuthorityOrPort = true;
            }
        }
    }
    const matches = uri.match($6ff7d1529c72e867$var$URI_PARSE);
    if (matches) {
        // store each component
        parsed.scheme = matches[1];
        parsed.userinfo = matches[3];
        parsed.host = matches[4];
        parsed.port = parseInt(matches[5], 10);
        parsed.path = matches[6] || '';
        parsed.query = matches[7];
        parsed.fragment = matches[8];
        // fix port number
        if (isNaN(parsed.port)) parsed.port = matches[5];
        const parseError = $6ff7d1529c72e867$var$getParseError(parsed, matches);
        if (parseError !== undefined) {
            parsed.error = parsed.error || parseError;
            malformedAuthorityOrPort = true;
        }
        if (parsed.host) {
            const ipv4result = $6ff7d1529c72e867$require$isIPv4(parsed.host);
            if (ipv4result === false) {
                const ipv6result = $6ff7d1529c72e867$require$normalizeIPv6(parsed.host);
                parsed.host = ipv6result.host.toLowerCase();
                isIP = ipv6result.isIPV6;
            } else isIP = true;
        }
        if (parsed.scheme === undefined && parsed.userinfo === undefined && parsed.host === undefined && parsed.port === undefined && parsed.query === undefined && !parsed.path) parsed.reference = 'same-document';
        else if (parsed.scheme === undefined) parsed.reference = 'relative';
        else if (parsed.fragment === undefined) parsed.reference = 'absolute';
        else parsed.reference = 'uri';
        // check for reference errors
        if (options.reference && options.reference !== 'suffix' && options.reference !== parsed.reference) parsed.error = parsed.error || 'URI is not a ' + options.reference + ' reference.';
        // find scheme handler
        const schemeHandler = $6ff7d1529c72e867$require$getSchemeHandler(options.scheme || parsed.scheme);
        // check if scheme can't handle IRIs
        if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
            // if host component is a domain name
            if (parsed.host && (options.domainHost || schemeHandler && schemeHandler.domainHost) && isIP === false && $6ff7d1529c72e867$require$nonSimpleDomain(parsed.host)) // convert Unicode IDN -> ASCII IDN
            try {
                parsed.host = new URL('http://' + parsed.host).hostname;
            } catch (e) {
                parsed.error = parsed.error || "Host's domain name can not be converted to ASCII: " + e;
            }
        // convert IRI -> URI
        }
        if (!schemeHandler || schemeHandler && !schemeHandler.skipNormalize) {
            if (uri.indexOf('%') !== -1) {
                if (parsed.scheme !== undefined) parsed.scheme = unescape(parsed.scheme);
                if (parsed.host !== undefined) parsed.host = $6ff7d1529c72e867$require$reescapeHostDelimiters(unescape(parsed.host), isIP);
            }
            if (parsed.path) parsed.path = $6ff7d1529c72e867$require$normalizePathEncoding(parsed.path);
            if (parsed.fragment) try {
                parsed.fragment = encodeURI(decodeURIComponent(parsed.fragment));
            } catch  {
                parsed.error = parsed.error || 'URI malformed';
            }
        }
        // perform scheme specific parsing
        if (schemeHandler && schemeHandler.parse) schemeHandler.parse(parsed, options);
    } else parsed.error = parsed.error || 'URI can not be parsed.';
    return {
        parsed: parsed,
        malformedAuthorityOrPort: malformedAuthorityOrPort
    };
}
/**
 * @param {string} uri
 * @param {import('./types/index').Options} [opts]
 * @returns
 */ function $6ff7d1529c72e867$var$parse(uri, opts) {
    return $6ff7d1529c72e867$var$parseWithStatus(uri, opts).parsed;
}
/**
 * @param {string} uri
 * @param {import('./types/index').Options} [opts]
 * @returns {string}
 */ function $6ff7d1529c72e867$var$normalizeString(uri, opts) {
    return $6ff7d1529c72e867$var$normalizeStringWithStatus(uri, opts).normalized;
}
/**
 * @param {string} uri
 * @param {import('./types/index').Options} [opts]
 * @returns {{ normalized: string, malformedAuthorityOrPort: boolean }}
 */ function $6ff7d1529c72e867$var$normalizeStringWithStatus(uri, opts) {
    const { parsed: parsed, malformedAuthorityOrPort: malformedAuthorityOrPort } = $6ff7d1529c72e867$var$parseWithStatus(uri, opts);
    return {
        normalized: malformedAuthorityOrPort ? uri : $6ff7d1529c72e867$var$serialize(parsed, opts),
        malformedAuthorityOrPort: malformedAuthorityOrPort
    };
}
/**
 * @param {import ('./types/index').URIComponent|string} uri
 * @param {import('./types/index').Options} [opts]
 * @returns {string|undefined}
 */ function $6ff7d1529c72e867$var$normalizeComparableURI(uri, opts) {
    if (typeof uri === 'string') {
        const { normalized: normalized, malformedAuthorityOrPort: malformedAuthorityOrPort } = $6ff7d1529c72e867$var$normalizeStringWithStatus(uri, opts);
        return malformedAuthorityOrPort ? undefined : normalized;
    }
    if (typeof uri === 'object') return $6ff7d1529c72e867$var$serialize(uri, opts);
}
const $6ff7d1529c72e867$var$fastUri = {
    SCHEMES: $6ff7d1529c72e867$require$SCHEMES,
    normalize: $6ff7d1529c72e867$var$normalize,
    resolve: $6ff7d1529c72e867$var$resolve,
    resolveComponent: $6ff7d1529c72e867$var$resolveComponent,
    equal: $6ff7d1529c72e867$var$equal,
    serialize: $6ff7d1529c72e867$var$serialize,
    parse: $6ff7d1529c72e867$var$parse
};
module.exports = $6ff7d1529c72e867$var$fastUri;
module.exports.default = $6ff7d1529c72e867$var$fastUri;
module.exports.fastUri = $6ff7d1529c72e867$var$fastUri;

});
parcelRegister("aXupK", function(module, exports) {
'use strict';
/** @type {(value: string) => boolean} */ const $7fa701b8f53b925a$var$isUUID = RegExp.prototype.test.bind(/^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/iu);
/** @type {(value: string) => boolean} */ const $7fa701b8f53b925a$var$isIPv4 = RegExp.prototype.test.bind(/^(?:(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]\d|\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]\d|\d)$/u);
/** @type {(value: string) => boolean} */ const $7fa701b8f53b925a$var$isHexPair = RegExp.prototype.test.bind(/^[\da-f]{2}$/iu);
/** @type {(value: string) => boolean} */ const $7fa701b8f53b925a$var$isUnreserved = RegExp.prototype.test.bind(/^[\da-z\-._~]$/iu);
/** @type {(value: string) => boolean} */ const $7fa701b8f53b925a$var$isPathCharacter = RegExp.prototype.test.bind(/^[\da-z\-._~!$&'()*+,;=:@/]$/iu);
/**
 * @param {Array<string>} input
 * @returns {string}
 */ function $7fa701b8f53b925a$var$stringArrayToHexStripped(input) {
    let acc = '';
    let code = 0;
    let i = 0;
    for(i = 0; i < input.length; i++){
        code = input[i].charCodeAt(0);
        if (code === 48) continue;
        if (!(code >= 48 && code <= 57 || code >= 65 && code <= 70 || code >= 97 && code <= 102)) return '';
        acc += input[i];
        break;
    }
    for(i += 1; i < input.length; i++){
        code = input[i].charCodeAt(0);
        if (!(code >= 48 && code <= 57 || code >= 65 && code <= 70 || code >= 97 && code <= 102)) return '';
        acc += input[i];
    }
    return acc;
}
/**
 * @typedef {Object} GetIPV6Result
 * @property {boolean} error - Indicates if there was an error parsing the IPv6 address.
 * @property {string} address - The parsed IPv6 address.
 * @property {string} [zone] - The zone identifier, if present.
 */ /**
 * @param {string} value
 * @returns {boolean}
 */ const $7fa701b8f53b925a$var$nonSimpleDomain = RegExp.prototype.test.bind(/[^!"$&'()*+,\-.;=_`a-z{}~]/u);
/**
 * @param {Array<string>} buffer
 * @returns {boolean}
 */ function $7fa701b8f53b925a$var$consumeIsZone(buffer) {
    buffer.length = 0;
    return true;
}
/**
 * @param {Array<string>} buffer
 * @param {Array<string>} address
 * @param {GetIPV6Result} output
 * @returns {boolean}
 */ function $7fa701b8f53b925a$var$consumeHextets(buffer, address, output) {
    if (buffer.length) {
        const hex = $7fa701b8f53b925a$var$stringArrayToHexStripped(buffer);
        if (hex !== '') address.push(hex);
        else {
            output.error = true;
            return false;
        }
        buffer.length = 0;
    }
    return true;
}
/**
 * @param {string} input
 * @returns {GetIPV6Result}
 */ function $7fa701b8f53b925a$var$getIPV6(input) {
    let tokenCount = 0;
    const output = {
        error: false,
        address: '',
        zone: ''
    };
    /** @type {Array<string>} */ const address = [];
    /** @type {Array<string>} */ const buffer = [];
    let endipv6Encountered = false;
    let endIpv6 = false;
    let consume = $7fa701b8f53b925a$var$consumeHextets;
    for(let i = 0; i < input.length; i++){
        const cursor = input[i];
        if (cursor === '[' || cursor === ']') continue;
        if (cursor === ':') {
            if (endipv6Encountered === true) endIpv6 = true;
            if (!consume(buffer, address, output)) break;
            if (++tokenCount > 7) {
                // not valid
                output.error = true;
                break;
            }
            if (i > 0 && input[i - 1] === ':') endipv6Encountered = true;
            address.push(':');
            continue;
        } else if (cursor === '%') {
            if (!consume(buffer, address, output)) break;
            // switch to zone detection
            consume = $7fa701b8f53b925a$var$consumeIsZone;
        } else {
            buffer.push(cursor);
            continue;
        }
    }
    if (buffer.length) {
        if (consume === $7fa701b8f53b925a$var$consumeIsZone) output.zone = buffer.join('');
        else if (endIpv6) address.push(buffer.join(''));
        else address.push($7fa701b8f53b925a$var$stringArrayToHexStripped(buffer));
    }
    output.address = address.join('');
    return output;
}
/**
 * @typedef {Object} NormalizeIPv6Result
 * @property {string} host - The normalized host.
 * @property {string} [escapedHost] - The escaped host.
 * @property {boolean} isIPV6 - Indicates if the host is an IPv6 address.
 */ /**
 * @param {string} host
 * @returns {NormalizeIPv6Result}
 */ function $7fa701b8f53b925a$var$normalizeIPv6(host) {
    if ($7fa701b8f53b925a$var$findToken(host, ':') < 2) return {
        host: host,
        isIPV6: false
    };
    const ipv6 = $7fa701b8f53b925a$var$getIPV6(host);
    if (!ipv6.error) {
        let newHost = ipv6.address;
        let escapedHost = ipv6.address;
        if (ipv6.zone) {
            newHost += '%' + ipv6.zone;
            escapedHost += '%25' + ipv6.zone;
        }
        return {
            host: newHost,
            isIPV6: true,
            escapedHost: escapedHost
        };
    } else return {
        host: host,
        isIPV6: false
    };
}
/**
 * @param {string} str
 * @param {string} token
 * @returns {number}
 */ function $7fa701b8f53b925a$var$findToken(str, token) {
    let ind = 0;
    for(let i = 0; i < str.length; i++)if (str[i] === token) ind++;
    return ind;
}
/**
 * @param {string} path
 * @returns {string}
 *
 * @see https://datatracker.ietf.org/doc/html/rfc3986#section-5.2.4
 */ function $7fa701b8f53b925a$var$removeDotSegments(path) {
    let input = path;
    const output = [];
    let nextSlash = -1;
    let len = 0;
    // eslint-disable-next-line no-cond-assign
    while(len = input.length){
        if (len === 1) {
            if (input === '.') break;
            else if (input === '/') {
                output.push('/');
                break;
            } else {
                output.push(input);
                break;
            }
        } else if (len === 2) {
            if (input[0] === '.') {
                if (input[1] === '.') break;
                else if (input[1] === '/') {
                    input = input.slice(2);
                    continue;
                }
            } else if (input[0] === '/') {
                if (input[1] === '.' || input[1] === '/') {
                    output.push('/');
                    break;
                }
            }
        } else if (len === 3) {
            if (input === '/..') {
                if (output.length !== 0) output.pop();
                output.push('/');
                break;
            }
        }
        if (input[0] === '.') {
            if (input[1] === '.') {
                if (input[2] === '/') {
                    input = input.slice(3);
                    continue;
                }
            } else if (input[1] === '/') {
                input = input.slice(2);
                continue;
            }
        } else if (input[0] === '/') {
            if (input[1] === '.') {
                if (input[2] === '/') {
                    input = input.slice(2);
                    continue;
                } else if (input[2] === '.') {
                    if (input[3] === '/') {
                        input = input.slice(3);
                        if (output.length !== 0) output.pop();
                        continue;
                    }
                }
            }
        }
        // Rule 2E: Move normal path segment to output
        if ((nextSlash = input.indexOf('/', 1)) === -1) {
            output.push(input);
            break;
        } else {
            output.push(input.slice(0, nextSlash));
            input = input.slice(nextSlash);
        }
    }
    return output.join('');
}
/**
 * Re-escape RFC 3986 gen-delims that must not appear literally in the host.
 * After the URI regex parses, these characters cannot be literal in the host
 * field, so any that appear after decoding came from percent-encoding and
 * must be restored to prevent authority structure changes.
 *
 * @param {string} host
 * @param {boolean} isIP - true for IPv4/IPv6 hosts (skip colon re-escaping)
 * @returns {string}
 */ const $7fa701b8f53b925a$var$HOST_DELIMS = {
    '@': '%40',
    '/': '%2F',
    '?': '%3F',
    '#': '%23',
    ':': '%3A'
};
const $7fa701b8f53b925a$var$HOST_DELIM_RE = /[@/?#:]/g;
const $7fa701b8f53b925a$var$HOST_DELIM_NO_COLON_RE = /[@/?#]/g;
function $7fa701b8f53b925a$var$reescapeHostDelimiters(host, isIP) {
    const re = isIP ? $7fa701b8f53b925a$var$HOST_DELIM_NO_COLON_RE : $7fa701b8f53b925a$var$HOST_DELIM_RE;
    re.lastIndex = 0;
    return host.replace(re, (ch)=>$7fa701b8f53b925a$var$HOST_DELIMS[ch]);
}
/**
 * Normalizes percent escapes and optionally decodes only unreserved ASCII bytes.
 * Reserved delimiters such as `%2F` and `%2E` stay escaped.
 *
 * @param {string} input
 * @param {boolean} [decodeUnreserved=false]
 * @returns {string}
 */ function $7fa701b8f53b925a$var$normalizePercentEncoding(input, decodeUnreserved = false) {
    if (input.indexOf('%') === -1) return input;
    let output = '';
    for(let i = 0; i < input.length; i++){
        if (input[i] === '%' && i + 2 < input.length) {
            const hex = input.slice(i + 1, i + 3);
            if ($7fa701b8f53b925a$var$isHexPair(hex)) {
                const normalizedHex = hex.toUpperCase();
                const decoded = String.fromCharCode(parseInt(normalizedHex, 16));
                if (decodeUnreserved && $7fa701b8f53b925a$var$isUnreserved(decoded)) output += decoded;
                else output += '%' + normalizedHex;
                i += 2;
                continue;
            }
        }
        output += input[i];
    }
    return output;
}
/**
 * Normalizes path data without turning reserved escapes into live path syntax.
 * Valid escapes are uppercased, raw unsafe characters are escaped, and only
 * unreserved bytes that are not `.` are decoded.
 *
 * @param {string} input
 * @returns {string}
 */ function $7fa701b8f53b925a$var$normalizePathEncoding(input) {
    let output = '';
    for(let i = 0; i < input.length; i++){
        if (input[i] === '%' && i + 2 < input.length) {
            const hex = input.slice(i + 1, i + 3);
            if ($7fa701b8f53b925a$var$isHexPair(hex)) {
                const normalizedHex = hex.toUpperCase();
                const decoded = String.fromCharCode(parseInt(normalizedHex, 16));
                if (decoded !== '.' && $7fa701b8f53b925a$var$isUnreserved(decoded)) output += decoded;
                else output += '%' + normalizedHex;
                i += 2;
                continue;
            }
        }
        if ($7fa701b8f53b925a$var$isPathCharacter(input[i])) output += input[i];
        else output += escape(input[i]);
    }
    return output;
}
/**
 * Escapes a component while preserving existing valid percent escapes.
 *
 * @param {string} input
 * @returns {string}
 */ function $7fa701b8f53b925a$var$escapePreservingEscapes(input) {
    let output = '';
    for(let i = 0; i < input.length; i++){
        if (input[i] === '%' && i + 2 < input.length) {
            const hex = input.slice(i + 1, i + 3);
            if ($7fa701b8f53b925a$var$isHexPair(hex)) {
                output += '%' + hex.toUpperCase();
                i += 2;
                continue;
            }
        }
        output += escape(input[i]);
    }
    return output;
}
/**
 * @param {import('../types/index').URIComponent} component
 * @returns {string|undefined}
 */ function $7fa701b8f53b925a$var$recomposeAuthority(component) {
    const uriTokens = [];
    if (component.userinfo !== undefined) {
        uriTokens.push(component.userinfo);
        uriTokens.push('@');
    }
    if (component.host !== undefined) {
        let host = unescape(component.host);
        if (!$7fa701b8f53b925a$var$isIPv4(host)) {
            const ipV6res = $7fa701b8f53b925a$var$normalizeIPv6(host);
            if (ipV6res.isIPV6 === true) host = `[${ipV6res.escapedHost}]`;
            else host = $7fa701b8f53b925a$var$reescapeHostDelimiters(host, false);
        }
        uriTokens.push(host);
    }
    if (typeof component.port === 'number' || typeof component.port === 'string') {
        uriTokens.push(':');
        uriTokens.push(String(component.port));
    }
    return uriTokens.length ? uriTokens.join('') : undefined;
}
module.exports = {
    nonSimpleDomain: $7fa701b8f53b925a$var$nonSimpleDomain,
    recomposeAuthority: $7fa701b8f53b925a$var$recomposeAuthority,
    reescapeHostDelimiters: $7fa701b8f53b925a$var$reescapeHostDelimiters,
    normalizePercentEncoding: $7fa701b8f53b925a$var$normalizePercentEncoding,
    normalizePathEncoding: $7fa701b8f53b925a$var$normalizePathEncoding,
    escapePreservingEscapes: $7fa701b8f53b925a$var$escapePreservingEscapes,
    removeDotSegments: $7fa701b8f53b925a$var$removeDotSegments,
    isIPv4: $7fa701b8f53b925a$var$isIPv4,
    isUUID: $7fa701b8f53b925a$var$isUUID,
    normalizeIPv6: $7fa701b8f53b925a$var$normalizeIPv6,
    stringArrayToHexStripped: $7fa701b8f53b925a$var$stringArrayToHexStripped
};

});

parcelRegister("cGtb6", function(module, exports) {
'use strict';

var $aXupK = parcelRequire("aXupK");
var $93c00a69cfc35c35$require$isUUID = $aXupK.isUUID;
const $93c00a69cfc35c35$var$URN_REG = /([\da-z][\d\-a-z]{0,31}):((?:[\w!$'()*+,\-.:;=@]|%[\da-f]{2})+)/iu;
const $93c00a69cfc35c35$var$supportedSchemeNames = /** @type {const} */ [
    'http',
    'https',
    'ws',
    'wss',
    'urn',
    'urn:uuid'
];
/** @typedef {supportedSchemeNames[number]} SchemeName */ /**
 * @param {string} name
 * @returns {name is SchemeName}
 */ function $93c00a69cfc35c35$var$isValidSchemeName(name) {
    return $93c00a69cfc35c35$var$supportedSchemeNames.indexOf(/** @type {*} */ name) !== -1;
}
/**
 * @callback SchemeFn
 * @param {import('../types/index').URIComponent} component
 * @param {import('../types/index').Options} options
 * @returns {import('../types/index').URIComponent}
 */ /**
 * @typedef {Object} SchemeHandler
 * @property {SchemeName} scheme - The scheme name.
 * @property {boolean} [domainHost] - Indicates if the scheme supports domain hosts.
 * @property {SchemeFn} parse - Function to parse the URI component for this scheme.
 * @property {SchemeFn} serialize - Function to serialize the URI component for this scheme.
 * @property {boolean} [skipNormalize] - Indicates if normalization should be skipped for this scheme.
 * @property {boolean} [absolutePath] - Indicates if the scheme uses absolute paths.
 * @property {boolean} [unicodeSupport] - Indicates if the scheme supports Unicode.
 */ /**
 * @param {import('../types/index').URIComponent} wsComponent
 * @returns {boolean}
 */ function $93c00a69cfc35c35$var$wsIsSecure(wsComponent) {
    if (wsComponent.secure === true) return true;
    else if (wsComponent.secure === false) return false;
    else if (wsComponent.scheme) return wsComponent.scheme.length === 3 && (wsComponent.scheme[0] === 'w' || wsComponent.scheme[0] === 'W') && (wsComponent.scheme[1] === 's' || wsComponent.scheme[1] === 'S') && (wsComponent.scheme[2] === 's' || wsComponent.scheme[2] === 'S');
    else return false;
}
/** @type {SchemeFn} */ function $93c00a69cfc35c35$var$httpParse(component) {
    if (!component.host) component.error = component.error || 'HTTP URIs must have a host.';
    return component;
}
/** @type {SchemeFn} */ function $93c00a69cfc35c35$var$httpSerialize(component) {
    const secure = String(component.scheme).toLowerCase() === 'https';
    // normalize the default port
    if (component.port === (secure ? 443 : 80) || component.port === '') component.port = undefined;
    // normalize the empty path
    if (!component.path) component.path = '/';
    // NOTE: We do not parse query strings for HTTP URIs
    // as WWW Form Url Encoded query strings are part of the HTML4+ spec,
    // and not the HTTP spec.
    return component;
}
/** @type {SchemeFn} */ function $93c00a69cfc35c35$var$wsParse(wsComponent) {
    // indicate if the secure flag is set
    wsComponent.secure = $93c00a69cfc35c35$var$wsIsSecure(wsComponent);
    // construct resouce name
    wsComponent.resourceName = (wsComponent.path || '/') + (wsComponent.query ? '?' + wsComponent.query : '');
    wsComponent.path = undefined;
    wsComponent.query = undefined;
    return wsComponent;
}
/** @type {SchemeFn} */ function $93c00a69cfc35c35$var$wsSerialize(wsComponent) {
    // normalize the default port
    if (wsComponent.port === ($93c00a69cfc35c35$var$wsIsSecure(wsComponent) ? 443 : 80) || wsComponent.port === '') wsComponent.port = undefined;
    // ensure scheme matches secure flag
    if (typeof wsComponent.secure === 'boolean') {
        wsComponent.scheme = wsComponent.secure ? 'wss' : 'ws';
        wsComponent.secure = undefined;
    }
    // reconstruct path from resource name
    if (wsComponent.resourceName) {
        const [path, query] = wsComponent.resourceName.split('?');
        wsComponent.path = path && path !== '/' ? path : undefined;
        wsComponent.query = query;
        wsComponent.resourceName = undefined;
    }
    // forbid fragment component
    wsComponent.fragment = undefined;
    return wsComponent;
}
/** @type {SchemeFn} */ function $93c00a69cfc35c35$var$urnParse(urnComponent, options) {
    if (!urnComponent.path) {
        urnComponent.error = 'URN can not be parsed';
        return urnComponent;
    }
    const matches = urnComponent.path.match($93c00a69cfc35c35$var$URN_REG);
    if (matches) {
        const scheme = options.scheme || urnComponent.scheme || 'urn';
        urnComponent.nid = matches[1].toLowerCase();
        urnComponent.nss = matches[2];
        const urnScheme = `${scheme}:${options.nid || urnComponent.nid}`;
        const schemeHandler = $93c00a69cfc35c35$var$getSchemeHandler(urnScheme);
        urnComponent.path = undefined;
        if (schemeHandler) urnComponent = schemeHandler.parse(urnComponent, options);
    } else urnComponent.error = urnComponent.error || 'URN can not be parsed.';
    return urnComponent;
}
/** @type {SchemeFn} */ function $93c00a69cfc35c35$var$urnSerialize(urnComponent, options) {
    if (urnComponent.nid === undefined) throw new Error('URN without nid cannot be serialized');
    const scheme = options.scheme || urnComponent.scheme || 'urn';
    const nid = urnComponent.nid.toLowerCase();
    const urnScheme = `${scheme}:${options.nid || nid}`;
    const schemeHandler = $93c00a69cfc35c35$var$getSchemeHandler(urnScheme);
    if (schemeHandler) urnComponent = schemeHandler.serialize(urnComponent, options);
    const uriComponent = urnComponent;
    const nss = urnComponent.nss;
    uriComponent.path = `${nid || options.nid}:${nss}`;
    options.skipEscape = true;
    return uriComponent;
}
/** @type {SchemeFn} */ function $93c00a69cfc35c35$var$urnuuidParse(urnComponent, options) {
    const uuidComponent = urnComponent;
    uuidComponent.uuid = uuidComponent.nss;
    uuidComponent.nss = undefined;
    if (!options.tolerant && (!uuidComponent.uuid || !$93c00a69cfc35c35$require$isUUID(uuidComponent.uuid))) uuidComponent.error = uuidComponent.error || 'UUID is not valid.';
    return uuidComponent;
}
/** @type {SchemeFn} */ function $93c00a69cfc35c35$var$urnuuidSerialize(uuidComponent) {
    const urnComponent = uuidComponent;
    // normalize UUID
    urnComponent.nss = (uuidComponent.uuid || '').toLowerCase();
    return urnComponent;
}
const $93c00a69cfc35c35$var$http = /** @type {SchemeHandler} */ {
    scheme: 'http',
    domainHost: true,
    parse: $93c00a69cfc35c35$var$httpParse,
    serialize: $93c00a69cfc35c35$var$httpSerialize
};
const $93c00a69cfc35c35$var$https = /** @type {SchemeHandler} */ {
    scheme: 'https',
    domainHost: $93c00a69cfc35c35$var$http.domainHost,
    parse: $93c00a69cfc35c35$var$httpParse,
    serialize: $93c00a69cfc35c35$var$httpSerialize
};
const $93c00a69cfc35c35$var$ws = /** @type {SchemeHandler} */ {
    scheme: 'ws',
    domainHost: true,
    parse: $93c00a69cfc35c35$var$wsParse,
    serialize: $93c00a69cfc35c35$var$wsSerialize
};
const $93c00a69cfc35c35$var$wss = /** @type {SchemeHandler} */ {
    scheme: 'wss',
    domainHost: $93c00a69cfc35c35$var$ws.domainHost,
    parse: $93c00a69cfc35c35$var$ws.parse,
    serialize: $93c00a69cfc35c35$var$ws.serialize
};
const $93c00a69cfc35c35$var$urn = /** @type {SchemeHandler} */ {
    scheme: 'urn',
    parse: $93c00a69cfc35c35$var$urnParse,
    serialize: $93c00a69cfc35c35$var$urnSerialize,
    skipNormalize: true
};
const $93c00a69cfc35c35$var$urnuuid = /** @type {SchemeHandler} */ {
    scheme: 'urn:uuid',
    parse: $93c00a69cfc35c35$var$urnuuidParse,
    serialize: $93c00a69cfc35c35$var$urnuuidSerialize,
    skipNormalize: true
};
const $93c00a69cfc35c35$var$SCHEMES = /** @type {Record<SchemeName, SchemeHandler>} */ {
    http: $93c00a69cfc35c35$var$http,
    https: $93c00a69cfc35c35$var$https,
    ws: $93c00a69cfc35c35$var$ws,
    wss: $93c00a69cfc35c35$var$wss,
    urn: $93c00a69cfc35c35$var$urn,
    'urn:uuid': $93c00a69cfc35c35$var$urnuuid
};
Object.setPrototypeOf($93c00a69cfc35c35$var$SCHEMES, null);
/**
 * @param {string|undefined} scheme
 * @returns {SchemeHandler|undefined}
 */ function $93c00a69cfc35c35$var$getSchemeHandler(scheme) {
    return scheme && ($93c00a69cfc35c35$var$SCHEMES[/** @type {SchemeName} */ scheme] || $93c00a69cfc35c35$var$SCHEMES[/** @type {SchemeName} */ scheme.toLowerCase()]) || undefined;
}
module.exports = {
    wsIsSecure: $93c00a69cfc35c35$var$wsIsSecure,
    SCHEMES: $93c00a69cfc35c35$var$SCHEMES,
    isValidSchemeName: $93c00a69cfc35c35$var$isValidSchemeName,
    getSchemeHandler: $93c00a69cfc35c35$var$getSchemeHandler
};

});




parcelRegister("lpcE1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aUotk = parcelRequire("aUotk");

var $1QKl4 = parcelRequire("1QKl4");

var $c1K03 = parcelRequire("c1K03");

var $4lTjT = parcelRequire("4lTjT");

var $bd6q3 = parcelRequire("bd6q3");
const $f955bdb24c6e2251$var$draft7Vocabularies = [
    $aUotk.default,
    $1QKl4.default,
    (0, $c1K03.default)(),
    $4lTjT.default,
    $bd6q3.metadataVocabulary,
    $bd6q3.contentVocabulary
];
module.exports.default = $f955bdb24c6e2251$var$draft7Vocabularies;

});
parcelRegister("aUotk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2xUhH = parcelRequire("2xUhH");

var $kcURM = parcelRequire("kcURM");
const $7f121df8031f7431$var$core = [
    "$schema",
    "$id",
    "$defs",
    "$vocabulary",
    {
        keyword: "$comment"
    },
    "definitions",
    $2xUhH.default,
    $kcURM.default
];
module.exports.default = $7f121df8031f7431$var$core;

});
parcelRegister("2xUhH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $1daa52c2453e0beb$var$def = {
    keyword: "id",
    code () {
        throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
    }
};
module.exports.default = $1daa52c2453e0beb$var$def;

});

parcelRegister("kcURM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.callRef = module.exports.getValidate = void 0;

var $kgLTL = parcelRequire("kgLTL");

var $f7S6Z = parcelRequire("f7S6Z");

var $gQlP2 = parcelRequire("gQlP2");

var $jfMv8 = parcelRequire("jfMv8");

var $5G1Th = parcelRequire("5G1Th");

var $1XGcl = parcelRequire("1XGcl");
const $eb610a1b7c7f39bc$var$def = {
    keyword: "$ref",
    schemaType: "string",
    code (cxt) {
        const { gen: gen, schema: $ref, it: it } = cxt;
        const { baseId: baseId, schemaEnv: env, validateName: validateName, opts: opts, self: self } = it;
        const { root: root } = env;
        if (($ref === "#" || $ref === "#/") && baseId === root.baseId) return callRootRef();
        const schOrEnv = $5G1Th.resolveRef.call(self, root, baseId, $ref);
        if (schOrEnv === undefined) throw new $kgLTL.default(it.opts.uriResolver, baseId, $ref);
        if (schOrEnv instanceof $5G1Th.SchemaEnv) return callValidate(schOrEnv);
        return inlineRefSchema(schOrEnv);
        function callRootRef() {
            if (env === root) return $eb610a1b7c7f39bc$var$callRef(cxt, validateName, env, env.$async);
            const rootName = gen.scopeValue("root", {
                ref: root
            });
            return $eb610a1b7c7f39bc$var$callRef(cxt, (0, $gQlP2._)`${rootName}.validate`, root, root.$async);
        }
        function callValidate(sch) {
            const v = $eb610a1b7c7f39bc$var$getValidate(cxt, sch);
            $eb610a1b7c7f39bc$var$callRef(cxt, v, sch, sch.$async);
        }
        function inlineRefSchema(sch) {
            const schName = gen.scopeValue("schema", opts.code.source === true ? {
                ref: sch,
                code: (0, $gQlP2.stringify)(sch)
            } : {
                ref: sch
            });
            const valid = gen.name("valid");
            const schCxt = cxt.subschema({
                schema: sch,
                dataTypes: [],
                schemaPath: $gQlP2.nil,
                topSchemaRef: schName,
                errSchemaPath: $ref
            }, valid);
            cxt.mergeEvaluated(schCxt);
            cxt.ok(valid);
        }
    }
};
function $eb610a1b7c7f39bc$var$getValidate(cxt, sch) {
    const { gen: gen } = cxt;
    return sch.validate ? gen.scopeValue("validate", {
        ref: sch.validate
    }) : (0, $gQlP2._)`${gen.scopeValue("wrapper", {
        ref: sch
    })}.validate`;
}
module.exports.getValidate = $eb610a1b7c7f39bc$var$getValidate;
function $eb610a1b7c7f39bc$var$callRef(cxt, v, sch, $async) {
    const { gen: gen, it: it } = cxt;
    const { allErrors: allErrors, schemaEnv: env, opts: opts } = it;
    const passCxt = opts.passContext ? $jfMv8.default.this : $gQlP2.nil;
    if ($async) callAsyncRef();
    else callSyncRef();
    function callAsyncRef() {
        if (!env.$async) throw new Error("async schema referenced by sync schema");
        const valid = gen.let("valid");
        gen.try(()=>{
            gen.code((0, $gQlP2._)`await ${(0, $f7S6Z.callValidateCode)(cxt, v, passCxt)}`);
            addEvaluatedFrom(v); // TODO will not work with async, it has to be returned with the result
            if (!allErrors) gen.assign(valid, true);
        }, (e)=>{
            gen.if((0, $gQlP2._)`!(${e} instanceof ${it.ValidationError})`, ()=>gen.throw(e));
            addErrorsFrom(e);
            if (!allErrors) gen.assign(valid, false);
        });
        cxt.ok(valid);
    }
    function callSyncRef() {
        cxt.result((0, $f7S6Z.callValidateCode)(cxt, v, passCxt), ()=>addEvaluatedFrom(v), ()=>addErrorsFrom(v));
    }
    function addErrorsFrom(source) {
        const errs = (0, $gQlP2._)`${source}.errors`;
        gen.assign($jfMv8.default.vErrors, (0, $gQlP2._)`${$jfMv8.default.vErrors} === null ? ${errs} : ${$jfMv8.default.vErrors}.concat(${errs})`); // TODO tagged
        gen.assign($jfMv8.default.errors, (0, $gQlP2._)`${$jfMv8.default.vErrors}.length`);
    }
    function addEvaluatedFrom(source) {
        var _a;
        if (!it.opts.unevaluated) return;
        const schEvaluated = (_a = sch === null || sch === void 0 ? void 0 : sch.validate) === null || _a === void 0 ? void 0 : _a.evaluated;
        // TODO refactor
        if (it.props !== true) {
            if (schEvaluated && !schEvaluated.dynamicProps) {
                if (schEvaluated.props !== undefined) it.props = $1XGcl.mergeEvaluated.props(gen, schEvaluated.props, it.props);
            } else {
                const props = gen.var("props", (0, $gQlP2._)`${source}.evaluated.props`);
                it.props = $1XGcl.mergeEvaluated.props(gen, props, it.props, $gQlP2.Name);
            }
        }
        if (it.items !== true) {
            if (schEvaluated && !schEvaluated.dynamicItems) {
                if (schEvaluated.items !== undefined) it.items = $1XGcl.mergeEvaluated.items(gen, schEvaluated.items, it.items);
            } else {
                const items = gen.var("items", (0, $gQlP2._)`${source}.evaluated.items`);
                it.items = $1XGcl.mergeEvaluated.items(gen, items, it.items, $gQlP2.Name);
            }
        }
    }
}
module.exports.callRef = $eb610a1b7c7f39bc$var$callRef;
module.exports.default = $eb610a1b7c7f39bc$var$def;

});


parcelRegister("1QKl4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $60O3P = parcelRequire("60O3P");

var $bDhQ4 = parcelRequire("bDhQ4");

var $9OLhz = parcelRequire("9OLhz");

var $h0gHo = parcelRequire("h0gHo");

var $fpuih = parcelRequire("fpuih");

var $2s9We = parcelRequire("2s9We");

var $fORUP = parcelRequire("fORUP");

var $5dv3J = parcelRequire("5dv3J");

var $6Psvn = parcelRequire("6Psvn");

var $lySyr = parcelRequire("lySyr");
const $158e97b594386285$var$validation = [
    // number
    $60O3P.default,
    $bDhQ4.default,
    // string
    $9OLhz.default,
    $h0gHo.default,
    // object
    $fpuih.default,
    $2s9We.default,
    // array
    $fORUP.default,
    $5dv3J.default,
    // any
    {
        keyword: "type",
        schemaType: [
            "string",
            "array"
        ]
    },
    {
        keyword: "nullable",
        schemaType: "boolean"
    },
    $6Psvn.default,
    $lySyr.default
];
module.exports.default = $158e97b594386285$var$validation;

});
parcelRegister("60O3P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gQlP2 = parcelRequire("gQlP2");
const $46099330d9e2fd86$var$ops = $gQlP2.operators;
const $46099330d9e2fd86$var$KWDs = {
    maximum: {
        okStr: "<=",
        ok: $46099330d9e2fd86$var$ops.LTE,
        fail: $46099330d9e2fd86$var$ops.GT
    },
    minimum: {
        okStr: ">=",
        ok: $46099330d9e2fd86$var$ops.GTE,
        fail: $46099330d9e2fd86$var$ops.LT
    },
    exclusiveMaximum: {
        okStr: "<",
        ok: $46099330d9e2fd86$var$ops.LT,
        fail: $46099330d9e2fd86$var$ops.GTE
    },
    exclusiveMinimum: {
        okStr: ">",
        ok: $46099330d9e2fd86$var$ops.GT,
        fail: $46099330d9e2fd86$var$ops.LTE
    }
};
const $46099330d9e2fd86$var$error = {
    message: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $gQlP2.str)`must be ${$46099330d9e2fd86$var$KWDs[keyword].okStr} ${schemaCode}`,
    params: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $gQlP2._)`{comparison: ${$46099330d9e2fd86$var$KWDs[keyword].okStr}, limit: ${schemaCode}}`
};
const $46099330d9e2fd86$var$def = {
    keyword: Object.keys($46099330d9e2fd86$var$KWDs),
    type: "number",
    schemaType: "number",
    $data: true,
    error: $46099330d9e2fd86$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        cxt.fail$data((0, $gQlP2._)`${data} ${$46099330d9e2fd86$var$KWDs[keyword].fail} ${schemaCode} || isNaN(${data})`);
    }
};
module.exports.default = $46099330d9e2fd86$var$def;

});

parcelRegister("bDhQ4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gQlP2 = parcelRequire("gQlP2");
const $87812ca099089787$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $gQlP2.str)`must be multiple of ${schemaCode}`,
    params: ({ schemaCode: schemaCode })=>(0, $gQlP2._)`{multipleOf: ${schemaCode}}`
};
const $87812ca099089787$var$def = {
    keyword: "multipleOf",
    type: "number",
    schemaType: "number",
    $data: true,
    error: $87812ca099089787$var$error,
    code (cxt) {
        const { gen: gen, data: data, schemaCode: schemaCode, it: it } = cxt;
        // const bdt = bad$DataType(schemaCode, <string>def.schemaType, $data)
        const prec = it.opts.multipleOfPrecision;
        const res = gen.let("res");
        const invalid = prec ? (0, $gQlP2._)`Math.abs(Math.round(${res}) - ${res}) > 1e-${prec}` : (0, $gQlP2._)`${res} !== parseInt(${res})`;
        cxt.fail$data((0, $gQlP2._)`(${schemaCode} === 0 || (${res} = ${data}/${schemaCode}, ${invalid}))`);
    }
};
module.exports.default = $87812ca099089787$var$def;

});

parcelRegister("9OLhz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");

var $3ujrb = parcelRequire("3ujrb");
const $725d75d8f0e79b1d$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxLength" ? "more" : "fewer";
        return (0, $gQlP2.str)`must NOT have ${comp} than ${schemaCode} characters`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $gQlP2._)`{limit: ${schemaCode}}`
};
const $725d75d8f0e79b1d$var$def = {
    keyword: [
        "maxLength",
        "minLength"
    ],
    type: "string",
    schemaType: "number",
    $data: true,
    error: $725d75d8f0e79b1d$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode, it: it } = cxt;
        const op = keyword === "maxLength" ? $gQlP2.operators.GT : $gQlP2.operators.LT;
        const len = it.opts.unicode === false ? (0, $gQlP2._)`${data}.length` : (0, $gQlP2._)`${(0, $1XGcl.useFunc)(cxt.gen, $3ujrb.default)}(${data})`;
        cxt.fail$data((0, $gQlP2._)`${len} ${op} ${schemaCode}`);
    }
};
module.exports.default = $725d75d8f0e79b1d$var$def;

});
parcelRegister("3ujrb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
function $28a34056030a7a51$var$ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while(pos < len){
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            // high surrogate, and there is a next character
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00) pos++; // low surrogate
        }
    }
    return length;
}
module.exports.default = $28a34056030a7a51$var$ucs2length;
$28a34056030a7a51$var$ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';

});


parcelRegister("h0gHo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f7S6Z = parcelRequire("f7S6Z");

var $1XGcl = parcelRequire("1XGcl");

var $gQlP2 = parcelRequire("gQlP2");
const $c60f63d4fc6272e2$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $gQlP2.str)`must match pattern "${schemaCode}"`,
    params: ({ schemaCode: schemaCode })=>(0, $gQlP2._)`{pattern: ${schemaCode}}`
};
const $c60f63d4fc6272e2$var$def = {
    keyword: "pattern",
    type: "string",
    schemaType: "string",
    $data: true,
    error: $c60f63d4fc6272e2$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        const u = it.opts.unicodeRegExp ? "u" : "";
        if ($data) {
            const { regExp: regExp } = it.opts.code;
            const regExpCode = regExp.code === "new RegExp" ? (0, $gQlP2._)`new RegExp` : (0, $1XGcl.useFunc)(gen, regExp);
            const valid = gen.let("valid");
            gen.try(()=>gen.assign(valid, (0, $gQlP2._)`${regExpCode}(${schemaCode}, ${u}).test(${data})`), ()=>gen.assign(valid, false));
            cxt.fail$data((0, $gQlP2._)`!${valid}`);
        } else {
            const regExp = (0, $f7S6Z.usePattern)(cxt, schema);
            cxt.fail$data((0, $gQlP2._)`!${regExp}.test(${data})`);
        }
    }
};
module.exports.default = $c60f63d4fc6272e2$var$def;

});

parcelRegister("fpuih", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gQlP2 = parcelRequire("gQlP2");
const $b380b0891a2ba75c$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxProperties" ? "more" : "fewer";
        return (0, $gQlP2.str)`must NOT have ${comp} than ${schemaCode} properties`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $gQlP2._)`{limit: ${schemaCode}}`
};
const $b380b0891a2ba75c$var$def = {
    keyword: [
        "maxProperties",
        "minProperties"
    ],
    type: "object",
    schemaType: "number",
    $data: true,
    error: $b380b0891a2ba75c$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        const op = keyword === "maxProperties" ? $gQlP2.operators.GT : $gQlP2.operators.LT;
        cxt.fail$data((0, $gQlP2._)`Object.keys(${data}).length ${op} ${schemaCode}`);
    }
};
module.exports.default = $b380b0891a2ba75c$var$def;

});

parcelRegister("2s9We", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f7S6Z = parcelRequire("f7S6Z");

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");
const $1c95e7d5d50fc7d9$var$error = {
    message: ({ params: { missingProperty: missingProperty } })=>(0, $gQlP2.str)`must have required property '${missingProperty}'`,
    params: ({ params: { missingProperty: missingProperty } })=>(0, $gQlP2._)`{missingProperty: ${missingProperty}}`
};
const $1c95e7d5d50fc7d9$var$def = {
    keyword: "required",
    type: "object",
    schemaType: "array",
    $data: true,
    error: $1c95e7d5d50fc7d9$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, schemaCode: schemaCode, data: data, $data: $data, it: it } = cxt;
        const { opts: opts } = it;
        if (!$data && schema.length === 0) return;
        const useLoop = schema.length >= opts.loopRequired;
        if (it.allErrors) allErrorsMode();
        else exitOnErrorMode();
        if (opts.strictRequired) {
            const props = cxt.parentSchema.properties;
            const { definedProperties: definedProperties } = cxt.it;
            for (const requiredKey of schema)if ((props === null || props === void 0 ? void 0 : props[requiredKey]) === undefined && !definedProperties.has(requiredKey)) {
                const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
                const msg = `required property "${requiredKey}" is not defined at "${schemaPath}" (strictRequired)`;
                (0, $1XGcl.checkStrictMode)(it, msg, it.opts.strictRequired);
            }
        }
        function allErrorsMode() {
            if (useLoop || $data) cxt.block$data($gQlP2.nil, loopAllRequired);
            else for (const prop of schema)(0, $f7S6Z.checkReportMissingProp)(cxt, prop);
        }
        function exitOnErrorMode() {
            const missing = gen.let("missing");
            if (useLoop || $data) {
                const valid = gen.let("valid", true);
                cxt.block$data(valid, ()=>loopUntilMissing(missing, valid));
                cxt.ok(valid);
            } else {
                gen.if((0, $f7S6Z.checkMissingProp)(cxt, schema, missing));
                (0, $f7S6Z.reportMissingProp)(cxt, missing);
                gen.else();
            }
        }
        function loopAllRequired() {
            gen.forOf("prop", schemaCode, (prop)=>{
                cxt.setParams({
                    missingProperty: prop
                });
                gen.if((0, $f7S6Z.noPropertyInData)(gen, data, prop, opts.ownProperties), ()=>cxt.error());
            });
        }
        function loopUntilMissing(missing, valid) {
            cxt.setParams({
                missingProperty: missing
            });
            gen.forOf(missing, schemaCode, ()=>{
                gen.assign(valid, (0, $f7S6Z.propertyInData)(gen, data, missing, opts.ownProperties));
                gen.if((0, $gQlP2.not)(valid), ()=>{
                    cxt.error();
                    gen.break();
                });
            }, $gQlP2.nil);
        }
    }
};
module.exports.default = $1c95e7d5d50fc7d9$var$def;

});

parcelRegister("fORUP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gQlP2 = parcelRequire("gQlP2");
const $b845590cecda42d2$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxItems" ? "more" : "fewer";
        return (0, $gQlP2.str)`must NOT have ${comp} than ${schemaCode} items`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $gQlP2._)`{limit: ${schemaCode}}`
};
const $b845590cecda42d2$var$def = {
    keyword: [
        "maxItems",
        "minItems"
    ],
    type: "array",
    schemaType: "number",
    $data: true,
    error: $b845590cecda42d2$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        const op = keyword === "maxItems" ? $gQlP2.operators.GT : $gQlP2.operators.LT;
        cxt.fail$data((0, $gQlP2._)`${data}.length ${op} ${schemaCode}`);
    }
};
module.exports.default = $b845590cecda42d2$var$def;

});

parcelRegister("5dv3J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1fcu2 = parcelRequire("1fcu2");

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");

var $foXrw = parcelRequire("foXrw");
const $3cc64257d9f2b723$var$error = {
    message: ({ params: { i: i, j: j } })=>(0, $gQlP2.str)`must NOT have duplicate items (items ## ${j} and ${i} are identical)`,
    params: ({ params: { i: i, j: j } })=>(0, $gQlP2._)`{i: ${i}, j: ${j}}`
};
const $3cc64257d9f2b723$var$def = {
    keyword: "uniqueItems",
    type: "array",
    schemaType: "boolean",
    $data: true,
    error: $3cc64257d9f2b723$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, parentSchema: parentSchema, schemaCode: schemaCode, it: it } = cxt;
        if (!$data && !schema) return;
        const valid = gen.let("valid");
        const itemTypes = parentSchema.items ? (0, $1fcu2.getSchemaTypes)(parentSchema.items) : [];
        cxt.block$data(valid, validateUniqueItems, (0, $gQlP2._)`${schemaCode} === false`);
        cxt.ok(valid);
        function validateUniqueItems() {
            const i = gen.let("i", (0, $gQlP2._)`${data}.length`);
            const j = gen.let("j");
            cxt.setParams({
                i: i,
                j: j
            });
            gen.assign(valid, true);
            gen.if((0, $gQlP2._)`${i} > 1`, ()=>(canOptimize() ? loopN : loopN2)(i, j));
        }
        function canOptimize() {
            return itemTypes.length > 0 && !itemTypes.some((t)=>t === "object" || t === "array");
        }
        function loopN(i, j) {
            const item = gen.name("item");
            const wrongType = (0, $1fcu2.checkDataTypes)(itemTypes, item, it.opts.strictNumbers, $1fcu2.DataType.Wrong);
            const indices = gen.const("indices", (0, $gQlP2._)`{}`);
            gen.for((0, $gQlP2._)`;${i}--;`, ()=>{
                gen.let(item, (0, $gQlP2._)`${data}[${i}]`);
                gen.if(wrongType, (0, $gQlP2._)`continue`);
                if (itemTypes.length > 1) gen.if((0, $gQlP2._)`typeof ${item} == "string"`, (0, $gQlP2._)`${item} += "_"`);
                gen.if((0, $gQlP2._)`typeof ${indices}[${item}] == "number"`, ()=>{
                    gen.assign(j, (0, $gQlP2._)`${indices}[${item}]`);
                    cxt.error();
                    gen.assign(valid, false).break();
                }).code((0, $gQlP2._)`${indices}[${item}] = ${i}`);
            });
        }
        function loopN2(i, j) {
            const eql = (0, $1XGcl.useFunc)(gen, $foXrw.default);
            const outer = gen.name("outer");
            gen.label(outer).for((0, $gQlP2._)`;${i}--;`, ()=>gen.for((0, $gQlP2._)`${j} = ${i}; ${j}--;`, ()=>gen.if((0, $gQlP2._)`${eql}(${data}[${i}], ${data}[${j}])`, ()=>{
                        cxt.error();
                        gen.assign(valid, false).break(outer);
                    })));
        }
    }
};
module.exports.default = $3cc64257d9f2b723$var$def;

});
parcelRegister("foXrw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5jHra = parcelRequire("5jHra");
$5jHra.code = 'require("ajv/dist/runtime/equal").default';
module.exports.default = $5jHra;

});


parcelRegister("6Psvn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");

var $foXrw = parcelRequire("foXrw");
const $4f8d9e0512ba246f$var$error = {
    message: "must be equal to constant",
    params: ({ schemaCode: schemaCode })=>(0, $gQlP2._)`{allowedValue: ${schemaCode}}`
};
const $4f8d9e0512ba246f$var$def = {
    keyword: "const",
    $data: true,
    error: $4f8d9e0512ba246f$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schemaCode: schemaCode, schema: schema } = cxt;
        if ($data || schema && typeof schema == "object") cxt.fail$data((0, $gQlP2._)`!${(0, $1XGcl.useFunc)(gen, $foXrw.default)}(${data}, ${schemaCode})`);
        else cxt.fail((0, $gQlP2._)`${schema} !== ${data}`);
    }
};
module.exports.default = $4f8d9e0512ba246f$var$def;

});

parcelRegister("lySyr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");

var $foXrw = parcelRequire("foXrw");
const $fb27175ba87b1c6f$var$error = {
    message: "must be equal to one of the allowed values",
    params: ({ schemaCode: schemaCode })=>(0, $gQlP2._)`{allowedValues: ${schemaCode}}`
};
const $fb27175ba87b1c6f$var$def = {
    keyword: "enum",
    schemaType: "array",
    $data: true,
    error: $fb27175ba87b1c6f$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        if (!$data && schema.length === 0) throw new Error("enum must have non-empty array");
        const useLoop = schema.length >= it.opts.loopEnum;
        let eql;
        const getEql = ()=>eql !== null && eql !== void 0 ? eql : eql = (0, $1XGcl.useFunc)(gen, $foXrw.default);
        let valid;
        if (useLoop || $data) {
            valid = gen.let("valid");
            cxt.block$data(valid, loopEnum);
        } else {
            /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
            const vSchema = gen.const("vSchema", schemaCode);
            valid = (0, $gQlP2.or)(...schema.map((_x, i)=>equalCode(vSchema, i)));
        }
        cxt.pass(valid);
        function loopEnum() {
            gen.assign(valid, false);
            gen.forOf("v", schemaCode, (v)=>gen.if((0, $gQlP2._)`${getEql()}(${data}, ${v})`, ()=>gen.assign(valid, true).break()));
        }
        function equalCode(vSchema, i) {
            const sch = schema[i];
            return typeof sch === "object" && sch !== null ? (0, $gQlP2._)`${getEql()}(${data}, ${vSchema}[${i}])` : (0, $gQlP2._)`${data} === ${sch}`;
        }
    }
};
module.exports.default = $fb27175ba87b1c6f$var$def;

});


parcelRegister("c1K03", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l3DCj = parcelRequire("l3DCj");

var $bjqoa = parcelRequire("bjqoa");

var $2OSPS = parcelRequire("2OSPS");

var $5i2E7 = parcelRequire("5i2E7");

var $aayAX = parcelRequire("aayAX");

var $lT7Qw = parcelRequire("lT7Qw");

var $jjKat = parcelRequire("jjKat");

var $gKOdq = parcelRequire("gKOdq");

var $2c9Hm = parcelRequire("2c9Hm");

var $cBEeE = parcelRequire("cBEeE");

var $8Ril5 = parcelRequire("8Ril5");

var $4go77 = parcelRequire("4go77");

var $fY3vN = parcelRequire("fY3vN");

var $a3wE7 = parcelRequire("a3wE7");

var $hnKEy = parcelRequire("hnKEy");

var $XSL5t = parcelRequire("XSL5t");
function $8c1942a9a1380677$var$getApplicator(draft2020 = false) {
    const applicator = [
        // any
        $8Ril5.default,
        $4go77.default,
        $fY3vN.default,
        $a3wE7.default,
        $hnKEy.default,
        $XSL5t.default,
        // object
        $jjKat.default,
        $gKOdq.default,
        $lT7Qw.default,
        $2c9Hm.default,
        $cBEeE.default
    ];
    // array
    if (draft2020) applicator.push($bjqoa.default, $5i2E7.default);
    else applicator.push($l3DCj.default, $2OSPS.default);
    applicator.push($aayAX.default);
    return applicator;
}
module.exports.default = $8c1942a9a1380677$var$getApplicator;

});
parcelRegister("l3DCj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAdditionalItems = void 0;

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");
const $f5489be47b59a641$var$error = {
    message: ({ params: { len: len } })=>(0, $gQlP2.str)`must NOT have more than ${len} items`,
    params: ({ params: { len: len } })=>(0, $gQlP2._)`{limit: ${len}}`
};
const $f5489be47b59a641$var$def = {
    keyword: "additionalItems",
    type: "array",
    schemaType: [
        "boolean",
        "object"
    ],
    before: "uniqueItems",
    error: $f5489be47b59a641$var$error,
    code (cxt) {
        const { parentSchema: parentSchema, it: it } = cxt;
        const { items: items } = parentSchema;
        if (!Array.isArray(items)) {
            (0, $1XGcl.checkStrictMode)(it, '"additionalItems" is ignored when "items" is not an array of schemas');
            return;
        }
        $f5489be47b59a641$var$validateAdditionalItems(cxt, items);
    }
};
function $f5489be47b59a641$var$validateAdditionalItems(cxt, items) {
    const { gen: gen, schema: schema, data: data, keyword: keyword, it: it } = cxt;
    it.items = true;
    const len = gen.const("len", (0, $gQlP2._)`${data}.length`);
    if (schema === false) {
        cxt.setParams({
            len: items.length
        });
        cxt.pass((0, $gQlP2._)`${len} <= ${items.length}`);
    } else if (typeof schema == "object" && !(0, $1XGcl.alwaysValidSchema)(it, schema)) {
        const valid = gen.var("valid", (0, $gQlP2._)`${len} <= ${items.length}`); // TODO var
        gen.if((0, $gQlP2.not)(valid), ()=>validateItems(valid));
        cxt.ok(valid);
    }
    function validateItems(valid) {
        gen.forRange("i", items.length, len, (i)=>{
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $1XGcl.Type.Num
            }, valid);
            if (!it.allErrors) gen.if((0, $gQlP2.not)(valid), ()=>gen.break());
        });
    }
}
module.exports.validateAdditionalItems = $f5489be47b59a641$var$validateAdditionalItems;
module.exports.default = $f5489be47b59a641$var$def;

});

parcelRegister("bjqoa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2OSPS = parcelRequire("2OSPS");
const $83c5f0556885e36a$var$def = {
    keyword: "prefixItems",
    type: "array",
    schemaType: [
        "array"
    ],
    before: "uniqueItems",
    code: (cxt)=>(0, $2OSPS.validateTuple)(cxt, "items")
};
module.exports.default = $83c5f0556885e36a$var$def;

});
parcelRegister("2OSPS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateTuple = void 0;

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");

var $f7S6Z = parcelRequire("f7S6Z");
const $20dac97daad0bff1$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "array",
        "boolean"
    ],
    before: "uniqueItems",
    code (cxt) {
        const { schema: schema, it: it } = cxt;
        if (Array.isArray(schema)) return $20dac97daad0bff1$var$validateTuple(cxt, "additionalItems", schema);
        it.items = true;
        if ((0, $1XGcl.alwaysValidSchema)(it, schema)) return;
        cxt.ok((0, $f7S6Z.validateArray)(cxt));
    }
};
function $20dac97daad0bff1$var$validateTuple(cxt, extraItems, schArr = cxt.schema) {
    const { gen: gen, parentSchema: parentSchema, data: data, keyword: keyword, it: it } = cxt;
    checkStrictTuple(parentSchema);
    if (it.opts.unevaluated && schArr.length && it.items !== true) it.items = $1XGcl.mergeEvaluated.items(gen, schArr.length, it.items);
    const valid = gen.name("valid");
    const len = gen.const("len", (0, $gQlP2._)`${data}.length`);
    schArr.forEach((sch, i)=>{
        if ((0, $1XGcl.alwaysValidSchema)(it, sch)) return;
        gen.if((0, $gQlP2._)`${len} > ${i}`, ()=>cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                dataProp: i
            }, valid));
        cxt.ok(valid);
    });
    function checkStrictTuple(sch) {
        const { opts: opts, errSchemaPath: errSchemaPath } = it;
        const l = schArr.length;
        const fullTuple = l === sch.minItems && (l === sch.maxItems || sch[extraItems] === false);
        if (opts.strictTuples && !fullTuple) {
            const msg = `"${keyword}" is ${l}-tuple, but minItems or maxItems/${extraItems} are not specified or different at path "${errSchemaPath}"`;
            (0, $1XGcl.checkStrictMode)(it, msg, opts.strictTuples);
        }
    }
}
module.exports.validateTuple = $20dac97daad0bff1$var$validateTuple;
module.exports.default = $20dac97daad0bff1$var$def;

});


parcelRegister("5i2E7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");

var $f7S6Z = parcelRequire("f7S6Z");

var $l3DCj = parcelRequire("l3DCj");
const $3da0afaad5b835c8$var$error = {
    message: ({ params: { len: len } })=>(0, $gQlP2.str)`must NOT have more than ${len} items`,
    params: ({ params: { len: len } })=>(0, $gQlP2._)`{limit: ${len}}`
};
const $3da0afaad5b835c8$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    error: $3da0afaad5b835c8$var$error,
    code (cxt) {
        const { schema: schema, parentSchema: parentSchema, it: it } = cxt;
        const { prefixItems: prefixItems } = parentSchema;
        it.items = true;
        if ((0, $1XGcl.alwaysValidSchema)(it, schema)) return;
        if (prefixItems) (0, $l3DCj.validateAdditionalItems)(cxt, prefixItems);
        else cxt.ok((0, $f7S6Z.validateArray)(cxt));
    }
};
module.exports.default = $3da0afaad5b835c8$var$def;

});

parcelRegister("aayAX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");
const $7675ac6a5fc9ed6d$var$error = {
    message: ({ params: { min: min, max: max } })=>max === undefined ? (0, $gQlP2.str)`must contain at least ${min} valid item(s)` : (0, $gQlP2.str)`must contain at least ${min} and no more than ${max} valid item(s)`,
    params: ({ params: { min: min, max: max } })=>max === undefined ? (0, $gQlP2._)`{minContains: ${min}}` : (0, $gQlP2._)`{minContains: ${min}, maxContains: ${max}}`
};
const $7675ac6a5fc9ed6d$var$def = {
    keyword: "contains",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    trackErrors: true,
    error: $7675ac6a5fc9ed6d$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, it: it } = cxt;
        let min;
        let max;
        const { minContains: minContains, maxContains: maxContains } = parentSchema;
        if (it.opts.next) {
            min = minContains === undefined ? 1 : minContains;
            max = maxContains;
        } else min = 1;
        const len = gen.const("len", (0, $gQlP2._)`${data}.length`);
        cxt.setParams({
            min: min,
            max: max
        });
        if (max === undefined && min === 0) {
            (0, $1XGcl.checkStrictMode)(it, `"minContains" == 0 without "maxContains": "contains" keyword ignored`);
            return;
        }
        if (max !== undefined && min > max) {
            (0, $1XGcl.checkStrictMode)(it, `"minContains" > "maxContains" is always invalid`);
            cxt.fail();
            return;
        }
        if ((0, $1XGcl.alwaysValidSchema)(it, schema)) {
            let cond = (0, $gQlP2._)`${len} >= ${min}`;
            if (max !== undefined) cond = (0, $gQlP2._)`${cond} && ${len} <= ${max}`;
            cxt.pass(cond);
            return;
        }
        it.items = true;
        const valid = gen.name("valid");
        if (max === undefined && min === 1) validateItems(valid, ()=>gen.if(valid, ()=>gen.break()));
        else if (min === 0) {
            gen.let(valid, true);
            if (max !== undefined) gen.if((0, $gQlP2._)`${data}.length > 0`, validateItemsWithCount);
        } else {
            gen.let(valid, false);
            validateItemsWithCount();
        }
        cxt.result(valid, ()=>cxt.reset());
        function validateItemsWithCount() {
            const schValid = gen.name("_valid");
            const count = gen.let("count", 0);
            validateItems(schValid, ()=>gen.if(schValid, ()=>checkLimits(count)));
        }
        function validateItems(_valid, block) {
            gen.forRange("i", 0, len, (i)=>{
                cxt.subschema({
                    keyword: "contains",
                    dataProp: i,
                    dataPropType: $1XGcl.Type.Num,
                    compositeRule: true
                }, _valid);
                block();
            });
        }
        function checkLimits(count) {
            gen.code((0, $gQlP2._)`${count}++`);
            if (max === undefined) gen.if((0, $gQlP2._)`${count} >= ${min}`, ()=>gen.assign(valid, true).break());
            else {
                gen.if((0, $gQlP2._)`${count} > ${max}`, ()=>gen.assign(valid, false).break());
                if (min === 1) gen.assign(valid, true);
                else gen.if((0, $gQlP2._)`${count} >= ${min}`, ()=>gen.assign(valid, true));
            }
        }
    }
};
module.exports.default = $7675ac6a5fc9ed6d$var$def;

});

parcelRegister("lT7Qw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateSchemaDeps = module.exports.validatePropertyDeps = module.exports.error = void 0;

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");

var $f7S6Z = parcelRequire("f7S6Z");
module.exports.error = {
    message: ({ params: { property: property, depsCount: depsCount, deps: deps } })=>{
        const property_ies = depsCount === 1 ? "property" : "properties";
        return (0, $gQlP2.str)`must have ${property_ies} ${deps} when property ${property} is present`;
    },
    params: ({ params: { property: property, depsCount: depsCount, deps: deps, missingProperty: missingProperty } })=>(0, $gQlP2._)`{property: ${property},
    missingProperty: ${missingProperty},
    depsCount: ${depsCount},
    deps: ${deps}}`
};
const $fef4d21c20079d27$var$def = {
    keyword: "dependencies",
    type: "object",
    schemaType: "object",
    error: module.exports.error,
    code (cxt) {
        const [propDeps, schDeps] = $fef4d21c20079d27$var$splitDependencies(cxt);
        $fef4d21c20079d27$var$validatePropertyDeps(cxt, propDeps);
        $fef4d21c20079d27$var$validateSchemaDeps(cxt, schDeps);
    }
};
function $fef4d21c20079d27$var$splitDependencies({ schema: schema }) {
    const propertyDeps = {};
    const schemaDeps = {};
    for(const key in schema){
        if (key === "__proto__") continue;
        const deps = Array.isArray(schema[key]) ? propertyDeps : schemaDeps;
        deps[key] = schema[key];
    }
    return [
        propertyDeps,
        schemaDeps
    ];
}
function $fef4d21c20079d27$var$validatePropertyDeps(cxt, propertyDeps = cxt.schema) {
    const { gen: gen, data: data, it: it } = cxt;
    if (Object.keys(propertyDeps).length === 0) return;
    const missing = gen.let("missing");
    for(const prop in propertyDeps){
        const deps = propertyDeps[prop];
        if (deps.length === 0) continue;
        const hasProperty = (0, $f7S6Z.propertyInData)(gen, data, prop, it.opts.ownProperties);
        cxt.setParams({
            property: prop,
            depsCount: deps.length,
            deps: deps.join(", ")
        });
        if (it.allErrors) gen.if(hasProperty, ()=>{
            for (const depProp of deps)(0, $f7S6Z.checkReportMissingProp)(cxt, depProp);
        });
        else {
            gen.if((0, $gQlP2._)`${hasProperty} && (${(0, $f7S6Z.checkMissingProp)(cxt, deps, missing)})`);
            (0, $f7S6Z.reportMissingProp)(cxt, missing);
            gen.else();
        }
    }
}
module.exports.validatePropertyDeps = $fef4d21c20079d27$var$validatePropertyDeps;
function $fef4d21c20079d27$var$validateSchemaDeps(cxt, schemaDeps = cxt.schema) {
    const { gen: gen, data: data, keyword: keyword, it: it } = cxt;
    const valid = gen.name("valid");
    for(const prop in schemaDeps){
        if ((0, $1XGcl.alwaysValidSchema)(it, schemaDeps[prop])) continue;
        gen.if((0, $f7S6Z.propertyInData)(gen, data, prop, it.opts.ownProperties), ()=>{
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: prop
            }, valid);
            cxt.mergeValidEvaluated(schCxt, valid);
        }, ()=>gen.var(valid, true) // TODO var
        );
        cxt.ok(valid);
    }
}
module.exports.validateSchemaDeps = $fef4d21c20079d27$var$validateSchemaDeps;
module.exports.default = $fef4d21c20079d27$var$def;

});

parcelRegister("jjKat", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");
const $e1039aaf2f1f8fb1$var$error = {
    message: "property name must be valid",
    params: ({ params: params })=>(0, $gQlP2._)`{propertyName: ${params.propertyName}}`
};
const $e1039aaf2f1f8fb1$var$def = {
    keyword: "propertyNames",
    type: "object",
    schemaType: [
        "object",
        "boolean"
    ],
    error: $e1039aaf2f1f8fb1$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, data: data, it: it } = cxt;
        if ((0, $1XGcl.alwaysValidSchema)(it, schema)) return;
        const valid = gen.name("valid");
        gen.forIn("key", data, (key)=>{
            cxt.setParams({
                propertyName: key
            });
            cxt.subschema({
                keyword: "propertyNames",
                data: key,
                dataTypes: [
                    "string"
                ],
                propertyName: key,
                compositeRule: true
            }, valid);
            gen.if((0, $gQlP2.not)(valid), ()=>{
                cxt.error(true);
                if (!it.allErrors) gen.break();
            });
        });
        cxt.ok(valid);
    }
};
module.exports.default = $e1039aaf2f1f8fb1$var$def;

});

parcelRegister("gKOdq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f7S6Z = parcelRequire("f7S6Z");

var $gQlP2 = parcelRequire("gQlP2");

var $jfMv8 = parcelRequire("jfMv8");

var $1XGcl = parcelRequire("1XGcl");
const $c327e4fd09439ba6$var$error = {
    message: "must NOT have additional properties",
    params: ({ params: params })=>(0, $gQlP2._)`{additionalProperty: ${params.additionalProperty}}`
};
const $c327e4fd09439ba6$var$def = {
    keyword: "additionalProperties",
    type: [
        "object"
    ],
    schemaType: [
        "boolean",
        "object"
    ],
    allowUndefined: true,
    trackErrors: true,
    error: $c327e4fd09439ba6$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, errsCount: errsCount, it: it } = cxt;
        /* istanbul ignore if */ if (!errsCount) throw new Error("ajv implementation error");
        const { allErrors: allErrors, opts: opts } = it;
        it.props = true;
        if (opts.removeAdditional !== "all" && (0, $1XGcl.alwaysValidSchema)(it, schema)) return;
        const props = (0, $f7S6Z.allSchemaProperties)(parentSchema.properties);
        const patProps = (0, $f7S6Z.allSchemaProperties)(parentSchema.patternProperties);
        checkAdditionalProperties();
        cxt.ok((0, $gQlP2._)`${errsCount} === ${$jfMv8.default.errors}`);
        function checkAdditionalProperties() {
            gen.forIn("key", data, (key)=>{
                if (!props.length && !patProps.length) additionalPropertyCode(key);
                else gen.if(isAdditional(key), ()=>additionalPropertyCode(key));
            });
        }
        function isAdditional(key) {
            let definedProp;
            if (props.length > 8) {
                // TODO maybe an option instead of hard-coded 8?
                const propsSchema = (0, $1XGcl.schemaRefOrVal)(it, parentSchema.properties, "properties");
                definedProp = (0, $f7S6Z.isOwnProperty)(gen, propsSchema, key);
            } else if (props.length) definedProp = (0, $gQlP2.or)(...props.map((p)=>(0, $gQlP2._)`${key} === ${p}`));
            else definedProp = $gQlP2.nil;
            if (patProps.length) definedProp = (0, $gQlP2.or)(definedProp, ...patProps.map((p)=>(0, $gQlP2._)`${(0, $f7S6Z.usePattern)(cxt, p)}.test(${key})`));
            return (0, $gQlP2.not)(definedProp);
        }
        function deleteAdditional(key) {
            gen.code((0, $gQlP2._)`delete ${data}[${key}]`);
        }
        function additionalPropertyCode(key) {
            if (opts.removeAdditional === "all" || opts.removeAdditional && schema === false) {
                deleteAdditional(key);
                return;
            }
            if (schema === false) {
                cxt.setParams({
                    additionalProperty: key
                });
                cxt.error();
                if (!allErrors) gen.break();
                return;
            }
            if (typeof schema == "object" && !(0, $1XGcl.alwaysValidSchema)(it, schema)) {
                const valid = gen.name("valid");
                if (opts.removeAdditional === "failing") {
                    applyAdditionalSchema(key, valid, false);
                    gen.if((0, $gQlP2.not)(valid), ()=>{
                        cxt.reset();
                        deleteAdditional(key);
                    });
                } else {
                    applyAdditionalSchema(key, valid);
                    if (!allErrors) gen.if((0, $gQlP2.not)(valid), ()=>gen.break());
                }
            }
        }
        function applyAdditionalSchema(key, valid, errors) {
            const subschema = {
                keyword: "additionalProperties",
                dataProp: key,
                dataPropType: $1XGcl.Type.Str
            };
            if (errors === false) Object.assign(subschema, {
                compositeRule: true,
                createErrors: false,
                allErrors: false
            });
            cxt.subschema(subschema, valid);
        }
    }
};
module.exports.default = $c327e4fd09439ba6$var$def;

});

parcelRegister("2c9Hm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6qXjM = parcelRequire("6qXjM");

var $f7S6Z = parcelRequire("f7S6Z");

var $1XGcl = parcelRequire("1XGcl");

var $gKOdq = parcelRequire("gKOdq");
const $199439a3ea61e080$var$def = {
    keyword: "properties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, it: it } = cxt;
        if (it.opts.removeAdditional === "all" && parentSchema.additionalProperties === undefined) $gKOdq.default.code(new $6qXjM.KeywordCxt(it, $gKOdq.default, "additionalProperties"));
        const allProps = (0, $f7S6Z.allSchemaProperties)(schema);
        for (const prop of allProps)it.definedProperties.add(prop);
        if (it.opts.unevaluated && allProps.length && it.props !== true) it.props = $1XGcl.mergeEvaluated.props(gen, (0, $1XGcl.toHash)(allProps), it.props);
        const properties = allProps.filter((p)=>!(0, $1XGcl.alwaysValidSchema)(it, schema[p]));
        if (properties.length === 0) return;
        const valid = gen.name("valid");
        for (const prop of properties){
            if (hasDefault(prop)) applyPropertySchema(prop);
            else {
                gen.if((0, $f7S6Z.propertyInData)(gen, data, prop, it.opts.ownProperties));
                applyPropertySchema(prop);
                if (!it.allErrors) gen.else().var(valid, true);
                gen.endIf();
            }
            cxt.it.definedProperties.add(prop);
            cxt.ok(valid);
        }
        function hasDefault(prop) {
            return it.opts.useDefaults && !it.compositeRule && schema[prop].default !== undefined;
        }
        function applyPropertySchema(prop) {
            cxt.subschema({
                keyword: "properties",
                schemaProp: prop,
                dataProp: prop
            }, valid);
        }
    }
};
module.exports.default = $199439a3ea61e080$var$def;

});

parcelRegister("cBEeE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f7S6Z = parcelRequire("f7S6Z");

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");

var $1XGcl = parcelRequire("1XGcl");
const $92d8269ec356a8f2$var$def = {
    keyword: "patternProperties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen: gen, schema: schema, data: data, parentSchema: parentSchema, it: it } = cxt;
        const { opts: opts } = it;
        const patterns = (0, $f7S6Z.allSchemaProperties)(schema);
        const alwaysValidPatterns = patterns.filter((p)=>(0, $1XGcl.alwaysValidSchema)(it, schema[p]));
        if (patterns.length === 0 || alwaysValidPatterns.length === patterns.length && (!it.opts.unevaluated || it.props === true)) return;
        const checkProperties = opts.strictSchema && !opts.allowMatchingProperties && parentSchema.properties;
        const valid = gen.name("valid");
        if (it.props !== true && !(it.props instanceof $gQlP2.Name)) it.props = (0, $1XGcl.evaluatedPropsToName)(gen, it.props);
        const { props: props } = it;
        validatePatternProperties();
        function validatePatternProperties() {
            for (const pat of patterns){
                if (checkProperties) checkMatchingProperties(pat);
                if (it.allErrors) validateProperties(pat);
                else {
                    gen.var(valid, true); // TODO var
                    validateProperties(pat);
                    gen.if(valid);
                }
            }
        }
        function checkMatchingProperties(pat) {
            for(const prop in checkProperties)if (new RegExp(pat).test(prop)) (0, $1XGcl.checkStrictMode)(it, `property ${prop} matches pattern ${pat} (use allowMatchingProperties)`);
        }
        function validateProperties(pat) {
            gen.forIn("key", data, (key)=>{
                gen.if((0, $gQlP2._)`${(0, $f7S6Z.usePattern)(cxt, pat)}.test(${key})`, ()=>{
                    const alwaysValid = alwaysValidPatterns.includes(pat);
                    if (!alwaysValid) cxt.subschema({
                        keyword: "patternProperties",
                        schemaProp: pat,
                        dataProp: key,
                        dataPropType: $1XGcl.Type.Str
                    }, valid);
                    if (it.opts.unevaluated && props !== true) gen.assign((0, $gQlP2._)`${props}[${key}]`, true);
                    else if (!alwaysValid && !it.allErrors) // can short-circuit if `unevaluatedProperties` is not supported (opts.next === false)
                    // or if all properties were evaluated (props === true)
                    gen.if((0, $gQlP2.not)(valid), ()=>gen.break());
                });
            });
        }
    }
};
module.exports.default = $92d8269ec356a8f2$var$def;

});

parcelRegister("8Ril5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1XGcl = parcelRequire("1XGcl");
const $67317fb70f992de8$var$def = {
    keyword: "not",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    code (cxt) {
        const { gen: gen, schema: schema, it: it } = cxt;
        if ((0, $1XGcl.alwaysValidSchema)(it, schema)) {
            cxt.fail();
            return;
        }
        const valid = gen.name("valid");
        cxt.subschema({
            keyword: "not",
            compositeRule: true,
            createErrors: false,
            allErrors: false
        }, valid);
        cxt.failResult(valid, ()=>cxt.reset(), ()=>cxt.error());
    },
    error: {
        message: "must NOT be valid"
    }
};
module.exports.default = $67317fb70f992de8$var$def;

});

parcelRegister("4go77", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f7S6Z = parcelRequire("f7S6Z");
const $31ab5c8e4595d2f5$var$def = {
    keyword: "anyOf",
    schemaType: "array",
    trackErrors: true,
    code: $f7S6Z.validateUnion,
    error: {
        message: "must match a schema in anyOf"
    }
};
module.exports.default = $31ab5c8e4595d2f5$var$def;

});

parcelRegister("fY3vN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");
const $b9ff2eff8825aaa7$var$error = {
    message: "must match exactly one schema in oneOf",
    params: ({ params: params })=>(0, $gQlP2._)`{passingSchemas: ${params.passing}}`
};
const $b9ff2eff8825aaa7$var$def = {
    keyword: "oneOf",
    schemaType: "array",
    trackErrors: true,
    error: $b9ff2eff8825aaa7$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, it: it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        if (it.opts.discriminator && parentSchema.discriminator) return;
        const schArr = schema;
        const valid = gen.let("valid", false);
        const passing = gen.let("passing", null);
        const schValid = gen.name("_valid");
        cxt.setParams({
            passing: passing
        });
        // TODO possibly fail straight away (with warning or exception) if there are two empty always valid schemas
        gen.block(validateOneOf);
        cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
        function validateOneOf() {
            schArr.forEach((sch, i)=>{
                let schCxt;
                if ((0, $1XGcl.alwaysValidSchema)(it, sch)) gen.var(schValid, true);
                else schCxt = cxt.subschema({
                    keyword: "oneOf",
                    schemaProp: i,
                    compositeRule: true
                }, schValid);
                if (i > 0) gen.if((0, $gQlP2._)`${schValid} && ${valid}`).assign(valid, false).assign(passing, (0, $gQlP2._)`[${passing}, ${i}]`).else();
                gen.if(schValid, ()=>{
                    gen.assign(valid, true);
                    gen.assign(passing, i);
                    if (schCxt) cxt.mergeEvaluated(schCxt, $gQlP2.Name);
                });
            });
        }
    }
};
module.exports.default = $b9ff2eff8825aaa7$var$def;

});

parcelRegister("a3wE7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1XGcl = parcelRequire("1XGcl");
const $7523820844e01cd9$var$def = {
    keyword: "allOf",
    schemaType: "array",
    code (cxt) {
        const { gen: gen, schema: schema, it: it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        const valid = gen.name("valid");
        schema.forEach((sch, i)=>{
            if ((0, $1XGcl.alwaysValidSchema)(it, sch)) return;
            const schCxt = cxt.subschema({
                keyword: "allOf",
                schemaProp: i
            }, valid);
            cxt.ok(valid);
            cxt.mergeEvaluated(schCxt);
        });
    }
};
module.exports.default = $7523820844e01cd9$var$def;

});

parcelRegister("hnKEy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gQlP2 = parcelRequire("gQlP2");

var $1XGcl = parcelRequire("1XGcl");
const $ca78c5fa2ce456d5$var$error = {
    message: ({ params: params })=>(0, $gQlP2.str)`must match "${params.ifClause}" schema`,
    params: ({ params: params })=>(0, $gQlP2._)`{failingKeyword: ${params.ifClause}}`
};
const $ca78c5fa2ce456d5$var$def = {
    keyword: "if",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    error: $ca78c5fa2ce456d5$var$error,
    code (cxt) {
        const { gen: gen, parentSchema: parentSchema, it: it } = cxt;
        if (parentSchema.then === undefined && parentSchema.else === undefined) (0, $1XGcl.checkStrictMode)(it, '"if" without "then" and "else" is ignored');
        const hasThen = $ca78c5fa2ce456d5$var$hasSchema(it, "then");
        const hasElse = $ca78c5fa2ce456d5$var$hasSchema(it, "else");
        if (!hasThen && !hasElse) return;
        const valid = gen.let("valid", true);
        const schValid = gen.name("_valid");
        validateIf();
        cxt.reset();
        if (hasThen && hasElse) {
            const ifClause = gen.let("ifClause");
            cxt.setParams({
                ifClause: ifClause
            });
            gen.if(schValid, validateClause("then", ifClause), validateClause("else", ifClause));
        } else if (hasThen) gen.if(schValid, validateClause("then"));
        else gen.if((0, $gQlP2.not)(schValid), validateClause("else"));
        cxt.pass(valid, ()=>cxt.error(true));
        function validateIf() {
            const schCxt = cxt.subschema({
                keyword: "if",
                compositeRule: true,
                createErrors: false,
                allErrors: false
            }, schValid);
            cxt.mergeEvaluated(schCxt);
        }
        function validateClause(keyword, ifClause) {
            return ()=>{
                const schCxt = cxt.subschema({
                    keyword: keyword
                }, schValid);
                gen.assign(valid, schValid);
                cxt.mergeValidEvaluated(schCxt, valid);
                if (ifClause) gen.assign(ifClause, (0, $gQlP2._)`${keyword}`);
                else cxt.setParams({
                    ifClause: keyword
                });
            };
        }
    }
};
function $ca78c5fa2ce456d5$var$hasSchema(it, keyword) {
    const schema = it.schema[keyword];
    return schema !== undefined && !(0, $1XGcl.alwaysValidSchema)(it, schema);
}
module.exports.default = $ca78c5fa2ce456d5$var$def;

});

parcelRegister("XSL5t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1XGcl = parcelRequire("1XGcl");
const $0b3ffcb1cd10b13d$var$def = {
    keyword: [
        "then",
        "else"
    ],
    schemaType: [
        "object",
        "boolean"
    ],
    code ({ keyword: keyword, parentSchema: parentSchema, it: it }) {
        if (parentSchema.if === undefined) (0, $1XGcl.checkStrictMode)(it, `"${keyword}" without "if" is ignored`);
    }
};
module.exports.default = $0b3ffcb1cd10b13d$var$def;

});


parcelRegister("4lTjT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $igHHZ = parcelRequire("igHHZ");
const $32b408f59d0fb95e$var$format = [
    $igHHZ.default
];
module.exports.default = $32b408f59d0fb95e$var$format;

});
parcelRegister("igHHZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gQlP2 = parcelRequire("gQlP2");
const $d4cba03609acde19$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $gQlP2.str)`must match format "${schemaCode}"`,
    params: ({ schemaCode: schemaCode })=>(0, $gQlP2._)`{format: ${schemaCode}}`
};
const $d4cba03609acde19$var$def = {
    keyword: "format",
    type: [
        "number",
        "string"
    ],
    schemaType: "string",
    $data: true,
    error: $d4cba03609acde19$var$error,
    code (cxt, ruleType) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        const { opts: opts, errSchemaPath: errSchemaPath, schemaEnv: schemaEnv, self: self } = it;
        if (!opts.validateFormats) return;
        if ($data) validate$DataFormat();
        else validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            const fDef = gen.const("fDef", (0, $gQlP2._)`${fmts}[${schemaCode}]`);
            const fType = gen.let("fType");
            const format = gen.let("format");
            // TODO simplify
            gen.if((0, $gQlP2._)`typeof ${fDef} == "object" && !(${fDef} instanceof RegExp)`, ()=>gen.assign(fType, (0, $gQlP2._)`${fDef}.type || "string"`).assign(format, (0, $gQlP2._)`${fDef}.validate`), ()=>gen.assign(fType, (0, $gQlP2._)`"string"`).assign(format, fDef));
            cxt.fail$data((0, $gQlP2.or)(unknownFmt(), invalidFmt()));
            function unknownFmt() {
                if (opts.strictSchema === false) return $gQlP2.nil;
                return (0, $gQlP2._)`${schemaCode} && !${format}`;
            }
            function invalidFmt() {
                const callFormat = schemaEnv.$async ? (0, $gQlP2._)`(${fDef}.async ? await ${format}(${data}) : ${format}(${data}))` : (0, $gQlP2._)`${format}(${data})`;
                const validData = (0, $gQlP2._)`(typeof ${format} == "function" ? ${callFormat} : ${format}.test(${data}))`;
                return (0, $gQlP2._)`${format} && ${format} !== true && ${fType} === ${ruleType} && !${validData}`;
            }
        }
        function validateFormat() {
            const formatDef = self.formats[schema];
            if (!formatDef) {
                unknownFormat();
                return;
            }
            if (formatDef === true) return;
            const [fmtType, format, fmtRef] = getFormat(formatDef);
            if (fmtType === ruleType) cxt.pass(validCondition());
            function unknownFormat() {
                if (opts.strictSchema === false) {
                    self.logger.warn(unknownMsg());
                    return;
                }
                throw new Error(unknownMsg());
                function unknownMsg() {
                    return `unknown format "${schema}" ignored in schema at path "${errSchemaPath}"`;
                }
            }
            function getFormat(fmtDef) {
                const code = fmtDef instanceof RegExp ? (0, $gQlP2.regexpCode)(fmtDef) : opts.code.formats ? (0, $gQlP2._)`${opts.code.formats}${(0, $gQlP2.getProperty)(schema)}` : undefined;
                const fmt = gen.scopeValue("formats", {
                    key: schema,
                    ref: fmtDef,
                    code: code
                });
                if (typeof fmtDef == "object" && !(fmtDef instanceof RegExp)) return [
                    fmtDef.type || "string",
                    fmtDef.validate,
                    (0, $gQlP2._)`${fmt}.validate`
                ];
                return [
                    "string",
                    fmtDef,
                    fmt
                ];
            }
            function validCondition() {
                if (typeof formatDef == "object" && !(formatDef instanceof RegExp) && formatDef.async) {
                    if (!schemaEnv.$async) throw new Error("async format in sync schema");
                    return (0, $gQlP2._)`await ${fmtRef}(${data})`;
                }
                return typeof format == "function" ? (0, $gQlP2._)`${fmtRef}(${data})` : (0, $gQlP2._)`${fmtRef}.test(${data})`;
            }
        }
    }
};
module.exports.default = $d4cba03609acde19$var$def;

});


parcelRegister("bd6q3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.contentVocabulary = module.exports.metadataVocabulary = void 0;
module.exports.metadataVocabulary = [
    "title",
    "description",
    "default",
    "deprecated",
    "readOnly",
    "writeOnly",
    "examples"
];
module.exports.contentVocabulary = [
    "contentMediaType",
    "contentEncoding",
    "contentSchema"
];

});


parcelRegister("3wRO9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gQlP2 = parcelRequire("gQlP2");

var $fQd50 = parcelRequire("fQd50");

var $5G1Th = parcelRequire("5G1Th");

var $kgLTL = parcelRequire("kgLTL");

var $1XGcl = parcelRequire("1XGcl");
const $291e196325907af7$var$error = {
    message: ({ params: { discrError: discrError, tagName: tagName } })=>discrError === $fQd50.DiscrError.Tag ? `tag "${tagName}" must be string` : `value of tag "${tagName}" must be in oneOf`,
    params: ({ params: { discrError: discrError, tag: tag, tagName: tagName } })=>(0, $gQlP2._)`{error: ${discrError}, tag: ${tagName}, tagValue: ${tag}}`
};
const $291e196325907af7$var$def = {
    keyword: "discriminator",
    type: "object",
    schemaType: "object",
    error: $291e196325907af7$var$error,
    code (cxt) {
        const { gen: gen, data: data, schema: schema, parentSchema: parentSchema, it: it } = cxt;
        const { oneOf: oneOf } = parentSchema;
        if (!it.opts.discriminator) throw new Error("discriminator: requires discriminator option");
        const tagName = schema.propertyName;
        if (typeof tagName != "string") throw new Error("discriminator: requires propertyName");
        if (schema.mapping) throw new Error("discriminator: mapping is not supported");
        if (!oneOf) throw new Error("discriminator: requires oneOf keyword");
        const valid = gen.let("valid", false);
        const tag = gen.const("tag", (0, $gQlP2._)`${data}${(0, $gQlP2.getProperty)(tagName)}`);
        gen.if((0, $gQlP2._)`typeof ${tag} == "string"`, ()=>validateMapping(), ()=>cxt.error(false, {
                discrError: $fQd50.DiscrError.Tag,
                tag: tag,
                tagName: tagName
            }));
        cxt.ok(valid);
        function validateMapping() {
            const mapping = getMapping();
            gen.if(false);
            for(const tagValue in mapping){
                gen.elseIf((0, $gQlP2._)`${tag} === ${tagValue}`);
                gen.assign(valid, applyTagSchema(mapping[tagValue]));
            }
            gen.else();
            cxt.error(false, {
                discrError: $fQd50.DiscrError.Mapping,
                tag: tag,
                tagName: tagName
            });
            gen.endIf();
        }
        function applyTagSchema(schemaProp) {
            const _valid = gen.name("valid");
            const schCxt = cxt.subschema({
                keyword: "oneOf",
                schemaProp: schemaProp
            }, _valid);
            cxt.mergeEvaluated(schCxt, $gQlP2.Name);
            return _valid;
        }
        function getMapping() {
            var _a;
            const oneOfMapping = {};
            const topRequired = hasRequired(parentSchema);
            let tagRequired = true;
            for(let i = 0; i < oneOf.length; i++){
                let sch = oneOf[i];
                if ((sch === null || sch === void 0 ? void 0 : sch.$ref) && !(0, $1XGcl.schemaHasRulesButRef)(sch, it.self.RULES)) {
                    const ref = sch.$ref;
                    sch = $5G1Th.resolveRef.call(it.self, it.schemaEnv.root, it.baseId, ref);
                    if (sch instanceof $5G1Th.SchemaEnv) sch = sch.schema;
                    if (sch === undefined) throw new $kgLTL.default(it.opts.uriResolver, it.baseId, ref);
                }
                const propSch = (_a = sch === null || sch === void 0 ? void 0 : sch.properties) === null || _a === void 0 ? void 0 : _a[tagName];
                if (typeof propSch != "object") throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${tagName}"`);
                tagRequired = tagRequired && (topRequired || hasRequired(sch));
                addMappings(propSch, i);
            }
            if (!tagRequired) throw new Error(`discriminator: "${tagName}" must be required`);
            return oneOfMapping;
            function hasRequired({ required: required }) {
                return Array.isArray(required) && required.includes(tagName);
            }
            function addMappings(sch, i) {
                if (sch.const) addMapping(sch.const, i);
                else if (sch.enum) for (const tagValue of sch.enum)addMapping(tagValue, i);
                else throw new Error(`discriminator: "properties/${tagName}" must have "const" or "enum"`);
            }
            function addMapping(tagValue, i) {
                if (typeof tagValue != "string" || tagValue in oneOfMapping) throw new Error(`discriminator: "${tagName}" values must be unique strings`);
                oneOfMapping[tagValue] = i;
            }
        }
    }
};
module.exports.default = $291e196325907af7$var$def;

});
parcelRegister("fQd50", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiscrError = void 0;
var $b885dbbbcfcd4b36$var$DiscrError;
(function(DiscrError) {
    DiscrError["Tag"] = "tag";
    DiscrError["Mapping"] = "mapping";
})($b885dbbbcfcd4b36$var$DiscrError || (module.exports.DiscrError = $b885dbbbcfcd4b36$var$DiscrError = {}));

});


parcelRegister("fBoo7", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"$id\":\"http://json-schema.org/draft-07/schema#\",\"title\":\"Core schema meta-schema\",\"definitions\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#\"}},\"nonNegativeInteger\":{\"type\":\"integer\",\"minimum\":0},\"nonNegativeIntegerDefault0\":{\"allOf\":[{\"$ref\":\"#/definitions/nonNegativeInteger\"},{\"default\":0}]},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true,\"default\":[]}},\"type\":[\"object\",\"boolean\"],\"properties\":{\"$id\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$schema\":{\"type\":\"string\",\"format\":\"uri\"},\"$ref\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$comment\":{\"type\":\"string\"},\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":true,\"readOnly\":{\"type\":\"boolean\",\"default\":false},\"examples\":{\"type\":\"array\",\"items\":true},\"multipleOf\":{\"type\":\"number\",\"exclusiveMinimum\":0},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"number\"},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"number\"},\"maxLength\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minLength\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"additionalItems\":{\"$ref\":\"#\"},\"items\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/schemaArray\"}],\"default\":true},\"maxItems\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minItems\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"contains\":{\"$ref\":\"#\"},\"maxProperties\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minProperties\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"required\":{\"$ref\":\"#/definitions/stringArray\"},\"additionalProperties\":{\"$ref\":\"#\"},\"definitions\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"propertyNames\":{\"format\":\"regex\"},\"default\":{}},\"dependencies\":{\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/stringArray\"}]}},\"propertyNames\":{\"$ref\":\"#\"},\"const\":true,\"enum\":{\"type\":\"array\",\"items\":true,\"minItems\":1,\"uniqueItems\":true},\"type\":{\"anyOf\":[{\"$ref\":\"#/definitions/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"format\":{\"type\":\"string\"},\"contentMediaType\":{\"type\":\"string\"},\"contentEncoding\":{\"type\":\"string\"},\"if\":{\"$ref\":\"#\"},\"then\":{\"$ref\":\"#\"},\"else\":{\"$ref\":\"#\"},\"allOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"anyOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"oneOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"not\":{\"$ref\":\"#\"}},\"default\":true}");

});


parcelRegister("5G0y8", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

var $bCxOq = parcelRequire("bCxOq");

var $hGoVI = parcelRequire("hGoVI");

var $dUnzg = parcelRequire("dUnzg");
const fullName = new $dUnzg.Name("fullFormats");
const fastName = new $dUnzg.Name("fastFormats");
const formatsPlugin = (ajv, opts = {
    keywords: true
})=>{
    if (Array.isArray(opts)) {
        addFormats(ajv, opts, $bCxOq.fullFormats, fullName);
        return ajv;
    }
    const [formats, exportName] = opts.mode === "fast" ? [
        $bCxOq.fastFormats,
        fastName
    ] : [
        $bCxOq.fullFormats,
        fullName
    ];
    const list = opts.formats || $bCxOq.formatNames;
    addFormats(ajv, list, formats, exportName);
    if (opts.keywords) $hGoVI.default(ajv);
    return ajv;
};
formatsPlugin.get = (name, mode = "full")=>{
    const formats = mode === "fast" ? $bCxOq.fastFormats : $bCxOq.fullFormats;
    const f = formats[name];
    if (!f) throw new Error(`Unknown format "${name}"`);
    return f;
};
function addFormats(ajv, list, fs, exportName) {
    var _a;
    var _b;
    (_a = (_b = ajv.opts.code).formats) !== null && _a !== void 0 ? _a : _b.formats = $dUnzg._`require("ajv-formats/dist/formats").${exportName}`;
    for (const f of list)ajv.addFormat(f, fs[f]);
}
module.exports = exports = formatsPlugin;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatsPlugin;

});
parcelRegister("bCxOq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatNames = module.exports.fastFormats = module.exports.fullFormats = void 0;
function $875d78bb35aa8d8e$var$fmtDef(validate, compare) {
    return {
        validate: validate,
        compare: compare
    };
}
module.exports.fullFormats = {
    // date: http://tools.ietf.org/html/rfc3339#section-5.6
    date: $875d78bb35aa8d8e$var$fmtDef($875d78bb35aa8d8e$var$date, $875d78bb35aa8d8e$var$compareDate),
    // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
    time: $875d78bb35aa8d8e$var$fmtDef($875d78bb35aa8d8e$var$time, $875d78bb35aa8d8e$var$compareTime),
    "date-time": $875d78bb35aa8d8e$var$fmtDef($875d78bb35aa8d8e$var$date_time, $875d78bb35aa8d8e$var$compareDateTime),
    // duration: https://tools.ietf.org/html/rfc3339#appendix-A
    duration: /^P(?!$)((\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?|(\d+W)?)$/,
    uri: $875d78bb35aa8d8e$var$uri,
    "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
    // uri-template: https://tools.ietf.org/html/rfc6570
    "uri-template": /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
    // For the source: https://gist.github.com/dperini/729294
    // For test cases: https://mathiasbynens.be/demo/url-regex
    url: /^(?:https?|ftp):\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)(?:\.(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu,
    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    hostname: /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
    // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    ipv6: /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i,
    regex: $875d78bb35aa8d8e$var$regex,
    // uuid: http://tools.ietf.org/html/rfc4122
    uuid: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
    // JSON-pointer: https://tools.ietf.org/html/rfc6901
    // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
    "json-pointer": /^(?:\/(?:[^~/]|~0|~1)*)*$/,
    "json-pointer-uri-fragment": /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
    // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
    "relative-json-pointer": /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
    byte: // the following formats are used by the openapi specification: https://spec.openapis.org/oas/v3.0.0#data-types
    // byte: https://github.com/miguelmota/is-base64
    $875d78bb35aa8d8e$var$byte,
    // signed 32 bit integer
    int32: {
        type: "number",
        validate: $875d78bb35aa8d8e$var$validateInt32
    },
    // signed 64 bit integer
    int64: {
        type: "number",
        validate: $875d78bb35aa8d8e$var$validateInt64
    },
    // C-type float
    float: {
        type: "number",
        validate: $875d78bb35aa8d8e$var$validateNumber
    },
    // C-type double
    double: {
        type: "number",
        validate: $875d78bb35aa8d8e$var$validateNumber
    },
    // hint to the UI to hide input strings
    password: true,
    // unchecked string payload
    binary: true
};
module.exports.fastFormats = {
    ...module.exports.fullFormats,
    date: $875d78bb35aa8d8e$var$fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d$/, $875d78bb35aa8d8e$var$compareDate),
    time: $875d78bb35aa8d8e$var$fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, $875d78bb35aa8d8e$var$compareTime),
    "date-time": $875d78bb35aa8d8e$var$fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, $875d78bb35aa8d8e$var$compareDateTime),
    // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
    uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
    "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
    // email (sources from jsen validator):
    // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
    // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'wilful violation')
    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i
};
module.exports.formatNames = Object.keys(module.exports.fullFormats);
function $875d78bb35aa8d8e$var$isLeapYear(year) {
    // https://tools.ietf.org/html/rfc3339#appendix-C
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
const $875d78bb35aa8d8e$var$DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
const $875d78bb35aa8d8e$var$DAYS = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $875d78bb35aa8d8e$var$date(str) {
    // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
    const matches = $875d78bb35aa8d8e$var$DATE.exec(str);
    if (!matches) return false;
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    return month >= 1 && month <= 12 && day >= 1 && day <= (month === 2 && $875d78bb35aa8d8e$var$isLeapYear(year) ? 29 : $875d78bb35aa8d8e$var$DAYS[month]);
}
function $875d78bb35aa8d8e$var$compareDate(d1, d2) {
    if (!(d1 && d2)) return undefined;
    if (d1 > d2) return 1;
    if (d1 < d2) return -1;
    return 0;
}
const $875d78bb35aa8d8e$var$TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
function $875d78bb35aa8d8e$var$time(str, withTimeZone) {
    const matches = $875d78bb35aa8d8e$var$TIME.exec(str);
    if (!matches) return false;
    const hour = +matches[1];
    const minute = +matches[2];
    const second = +matches[3];
    const timeZone = matches[5];
    return (hour <= 23 && minute <= 59 && second <= 59 || hour === 23 && minute === 59 && second === 60) && (!withTimeZone || timeZone !== "");
}
function $875d78bb35aa8d8e$var$compareTime(t1, t2) {
    if (!(t1 && t2)) return undefined;
    const a1 = $875d78bb35aa8d8e$var$TIME.exec(t1);
    const a2 = $875d78bb35aa8d8e$var$TIME.exec(t2);
    if (!(a1 && a2)) return undefined;
    t1 = a1[1] + a1[2] + a1[3] + (a1[4] || "");
    t2 = a2[1] + a2[2] + a2[3] + (a2[4] || "");
    if (t1 > t2) return 1;
    if (t1 < t2) return -1;
    return 0;
}
const $875d78bb35aa8d8e$var$DATE_TIME_SEPARATOR = /t|\s/i;
function $875d78bb35aa8d8e$var$date_time(str) {
    // http://tools.ietf.org/html/rfc3339#section-5.6
    const dateTime = str.split($875d78bb35aa8d8e$var$DATE_TIME_SEPARATOR);
    return dateTime.length === 2 && $875d78bb35aa8d8e$var$date(dateTime[0]) && $875d78bb35aa8d8e$var$time(dateTime[1], true);
}
function $875d78bb35aa8d8e$var$compareDateTime(dt1, dt2) {
    if (!(dt1 && dt2)) return undefined;
    const [d1, t1] = dt1.split($875d78bb35aa8d8e$var$DATE_TIME_SEPARATOR);
    const [d2, t2] = dt2.split($875d78bb35aa8d8e$var$DATE_TIME_SEPARATOR);
    const res = $875d78bb35aa8d8e$var$compareDate(d1, d2);
    if (res === undefined) return undefined;
    return res || $875d78bb35aa8d8e$var$compareTime(t1, t2);
}
const $875d78bb35aa8d8e$var$NOT_URI_FRAGMENT = /\/|:/;
const $875d78bb35aa8d8e$var$URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
function $875d78bb35aa8d8e$var$uri(str) {
    // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
    return $875d78bb35aa8d8e$var$NOT_URI_FRAGMENT.test(str) && $875d78bb35aa8d8e$var$URI.test(str);
}
const $875d78bb35aa8d8e$var$BYTE = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/gm;
function $875d78bb35aa8d8e$var$byte(str) {
    $875d78bb35aa8d8e$var$BYTE.lastIndex = 0;
    return $875d78bb35aa8d8e$var$BYTE.test(str);
}
const $875d78bb35aa8d8e$var$MIN_INT32 = -(2 ** 31);
const $875d78bb35aa8d8e$var$MAX_INT32 = 2 ** 31 - 1;
function $875d78bb35aa8d8e$var$validateInt32(value) {
    return Number.isInteger(value) && value <= $875d78bb35aa8d8e$var$MAX_INT32 && value >= $875d78bb35aa8d8e$var$MIN_INT32;
}
function $875d78bb35aa8d8e$var$validateInt64(value) {
    // JSON and javascript max Int is 2**53, so any int that passes isInteger is valid for Int64
    return Number.isInteger(value);
}
function $875d78bb35aa8d8e$var$validateNumber() {
    return true;
}
const $875d78bb35aa8d8e$var$Z_ANCHOR = /[^\\]\\Z/;
function $875d78bb35aa8d8e$var$regex(str) {
    if ($875d78bb35aa8d8e$var$Z_ANCHOR.test(str)) return false;
    try {
        new RegExp(str);
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("hGoVI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatLimitDefinition = void 0;

var $bi3bp = parcelRequire("bi3bp");

var $dUnzg = parcelRequire("dUnzg");
const $cdf9b27a4de526fa$var$ops = $dUnzg.operators;
const $cdf9b27a4de526fa$var$KWDs = {
    formatMaximum: {
        okStr: "<=",
        ok: $cdf9b27a4de526fa$var$ops.LTE,
        fail: $cdf9b27a4de526fa$var$ops.GT
    },
    formatMinimum: {
        okStr: ">=",
        ok: $cdf9b27a4de526fa$var$ops.GTE,
        fail: $cdf9b27a4de526fa$var$ops.LT
    },
    formatExclusiveMaximum: {
        okStr: "<",
        ok: $cdf9b27a4de526fa$var$ops.LT,
        fail: $cdf9b27a4de526fa$var$ops.GTE
    },
    formatExclusiveMinimum: {
        okStr: ">",
        ok: $cdf9b27a4de526fa$var$ops.GT,
        fail: $cdf9b27a4de526fa$var$ops.LTE
    }
};
const $cdf9b27a4de526fa$var$error = {
    message: ({ keyword: keyword, schemaCode: schemaCode })=>$dUnzg.str`should be ${$cdf9b27a4de526fa$var$KWDs[keyword].okStr} ${schemaCode}`,
    params: ({ keyword: keyword, schemaCode: schemaCode })=>$dUnzg._`{comparison: ${$cdf9b27a4de526fa$var$KWDs[keyword].okStr}, limit: ${schemaCode}}`
};
module.exports.formatLimitDefinition = {
    keyword: Object.keys($cdf9b27a4de526fa$var$KWDs),
    type: "string",
    schemaType: "string",
    $data: true,
    error: $cdf9b27a4de526fa$var$error,
    code (cxt) {
        const { gen: gen, data: data, schemaCode: schemaCode, keyword: keyword, it: it } = cxt;
        const { opts: opts, self: self } = it;
        if (!opts.validateFormats) return;
        const fCxt = new $bi3bp.KeywordCxt(it, self.RULES.all.format.definition, "format");
        if (fCxt.$data) validate$DataFormat();
        else validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            const fmt = gen.const("fmt", $dUnzg._`${fmts}[${fCxt.schemaCode}]`);
            cxt.fail$data($dUnzg.or($dUnzg._`typeof ${fmt} != "object"`, $dUnzg._`${fmt} instanceof RegExp`, $dUnzg._`typeof ${fmt}.compare != "function"`, compareCode(fmt)));
        }
        function validateFormat() {
            const format = fCxt.schema;
            const fmtDef = self.formats[format];
            if (!fmtDef || fmtDef === true) return;
            if (typeof fmtDef != "object" || fmtDef instanceof RegExp || typeof fmtDef.compare != "function") throw new Error(`"${keyword}": format "${format}" does not define "compare" function`);
            const fmt = gen.scopeValue("formats", {
                key: format,
                ref: fmtDef,
                code: opts.code.formats ? $dUnzg._`${opts.code.formats}${$dUnzg.getProperty(format)}` : undefined
            });
            cxt.fail$data(compareCode(fmt));
        }
        function compareCode(fmt) {
            return $dUnzg._`${fmt}.compare(${data}, ${schemaCode}) ${$cdf9b27a4de526fa$var$KWDs[keyword].fail} 0`;
        }
    },
    dependencies: [
        "format"
    ]
};
const $cdf9b27a4de526fa$var$formatLimitPlugin = (ajv)=>{
    ajv.addKeyword(module.exports.formatLimitDefinition);
    return ajv;
};
module.exports.default = $cdf9b27a4de526fa$var$formatLimitPlugin;

});
parcelRegister("bi3bp", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MissingRefError = exports.ValidationError = exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = exports.Ajv = void 0;

var $lQ8xr = parcelRequire("lQ8xr");

var $5CtCa = parcelRequire("5CtCa");

var $iwX0L = parcelRequire("iwX0L");

var $lgGkq = parcelRequire("lgGkq");
const META_SUPPORT_DATA = [
    "/properties"
];
const META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
class Ajv extends $lQ8xr.default {
    _addVocabularies() {
        super._addVocabularies();
        $5CtCa.default.forEach((v)=>this.addVocabulary(v));
        if (this.opts.discriminator) this.addKeyword($iwX0L.default);
    }
    _addDefaultMetaSchema() {
        super._addDefaultMetaSchema();
        if (!this.opts.meta) return;
        const metaSchema = this.opts.$data ? this.$dataMetaSchema($lgGkq, META_SUPPORT_DATA) : $lgGkq;
        this.addMetaSchema(metaSchema, META_SCHEMA_ID, false);
        this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
    }
    defaultMeta() {
        return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined);
    }
}
exports.Ajv = Ajv;
module.exports = exports = Ajv;
module.exports.Ajv = Ajv;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Ajv;

var $1VPfM = parcelRequire("1VPfM");
Object.defineProperty(exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $1VPfM.KeywordCxt;
    }
});

var $dUnzg = parcelRequire("dUnzg");
Object.defineProperty(exports, "_", {
    enumerable: true,
    get: function() {
        return $dUnzg._;
    }
});
Object.defineProperty(exports, "str", {
    enumerable: true,
    get: function() {
        return $dUnzg.str;
    }
});
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function() {
        return $dUnzg.stringify;
    }
});
Object.defineProperty(exports, "nil", {
    enumerable: true,
    get: function() {
        return $dUnzg.nil;
    }
});
Object.defineProperty(exports, "Name", {
    enumerable: true,
    get: function() {
        return $dUnzg.Name;
    }
});
Object.defineProperty(exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $dUnzg.CodeGen;
    }
});

var $8oSUW = parcelRequire("8oSUW");
Object.defineProperty(exports, "ValidationError", {
    enumerable: true,
    get: function() {
        return $8oSUW.default;
    }
});

var $fAM6G = parcelRequire("fAM6G");
Object.defineProperty(exports, "MissingRefError", {
    enumerable: true,
    get: function() {
        return $fAM6G.default;
    }
});

});
parcelRegister("lQ8xr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodeGen = module.exports.Name = module.exports.nil = module.exports.stringify = module.exports.str = module.exports._ = module.exports.KeywordCxt = void 0;

var $1VPfM = parcelRequire("1VPfM");
Object.defineProperty(module.exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $1VPfM.KeywordCxt;
    }
});

var $dUnzg = parcelRequire("dUnzg");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $dUnzg._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $dUnzg.str;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $dUnzg.stringify;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $dUnzg.nil;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $dUnzg.Name;
    }
});
Object.defineProperty(module.exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $dUnzg.CodeGen;
    }
});

var $8oSUW = parcelRequire("8oSUW");

var $fAM6G = parcelRequire("fAM6G");

var $2eQNP = parcelRequire("2eQNP");

var $3F0fZ = parcelRequire("3F0fZ");

var $dUnzg = parcelRequire("dUnzg");

var $fYjY5 = parcelRequire("fYjY5");

var $imYL4 = parcelRequire("imYL4");

var $1YrfU = parcelRequire("1YrfU");

var $qniTE = parcelRequire("qniTE");

var $7f6py = parcelRequire("7f6py");
const $fe6513d7560e94a8$var$defaultRegExp = (str, flags)=>new RegExp(str, flags);
$fe6513d7560e94a8$var$defaultRegExp.code = "new RegExp";
const $fe6513d7560e94a8$var$META_IGNORE_OPTIONS = [
    "removeAdditional",
    "useDefaults",
    "coerceTypes"
];
const $fe6513d7560e94a8$var$EXT_SCOPE_NAMES = new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error"
]);
const $fe6513d7560e94a8$var$removedOptions = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now."
};
const $fe6513d7560e94a8$var$deprecatedOptions = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.'
};
const $fe6513d7560e94a8$var$MAX_EXPRESSION = 200;
// eslint-disable-next-line complexity
function $fe6513d7560e94a8$var$requiredOptions(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    const s = o.strict;
    const _optz = (_a = o.code) === null || _a === void 0 ? void 0 : _a.optimize;
    const optimize = _optz === true || _optz === undefined ? 1 : _optz || 0;
    const regExp = (_c = (_b = o.code) === null || _b === void 0 ? void 0 : _b.regExp) !== null && _c !== void 0 ? _c : $fe6513d7560e94a8$var$defaultRegExp;
    const uriResolver = (_d = o.uriResolver) !== null && _d !== void 0 ? _d : $7f6py.default;
    return {
        strictSchema: (_f = (_e = o.strictSchema) !== null && _e !== void 0 ? _e : s) !== null && _f !== void 0 ? _f : true,
        strictNumbers: (_h = (_g = o.strictNumbers) !== null && _g !== void 0 ? _g : s) !== null && _h !== void 0 ? _h : true,
        strictTypes: (_k = (_j = o.strictTypes) !== null && _j !== void 0 ? _j : s) !== null && _k !== void 0 ? _k : "log",
        strictTuples: (_m = (_l = o.strictTuples) !== null && _l !== void 0 ? _l : s) !== null && _m !== void 0 ? _m : "log",
        strictRequired: (_p = (_o = o.strictRequired) !== null && _o !== void 0 ? _o : s) !== null && _p !== void 0 ? _p : false,
        code: o.code ? {
            ...o.code,
            optimize: optimize,
            regExp: regExp
        } : {
            optimize: optimize,
            regExp: regExp
        },
        loopRequired: (_q = o.loopRequired) !== null && _q !== void 0 ? _q : $fe6513d7560e94a8$var$MAX_EXPRESSION,
        loopEnum: (_r = o.loopEnum) !== null && _r !== void 0 ? _r : $fe6513d7560e94a8$var$MAX_EXPRESSION,
        meta: (_s = o.meta) !== null && _s !== void 0 ? _s : true,
        messages: (_t = o.messages) !== null && _t !== void 0 ? _t : true,
        inlineRefs: (_u = o.inlineRefs) !== null && _u !== void 0 ? _u : true,
        schemaId: (_v = o.schemaId) !== null && _v !== void 0 ? _v : "$id",
        addUsedSchema: (_w = o.addUsedSchema) !== null && _w !== void 0 ? _w : true,
        validateSchema: (_x = o.validateSchema) !== null && _x !== void 0 ? _x : true,
        validateFormats: (_y = o.validateFormats) !== null && _y !== void 0 ? _y : true,
        unicodeRegExp: (_z = o.unicodeRegExp) !== null && _z !== void 0 ? _z : true,
        int32range: (_0 = o.int32range) !== null && _0 !== void 0 ? _0 : true,
        uriResolver: uriResolver
    };
}
class $fe6513d7560e94a8$var$Ajv {
    constructor(opts = {}){
        this.schemas = {};
        this.refs = {};
        this.formats = Object.create(null);
        this._compilations = new Set();
        this._loading = {};
        this._cache = new Map();
        opts = this.opts = {
            ...opts,
            ...$fe6513d7560e94a8$var$requiredOptions(opts)
        };
        const { es5: es5, lines: lines } = this.opts.code;
        this.scope = new $dUnzg.ValueScope({
            scope: {},
            prefixes: $fe6513d7560e94a8$var$EXT_SCOPE_NAMES,
            es5: es5,
            lines: lines
        });
        this.logger = $fe6513d7560e94a8$var$getLogger(opts.logger);
        const formatOpt = opts.validateFormats;
        opts.validateFormats = false;
        this.RULES = (0, $2eQNP.getRules)();
        $fe6513d7560e94a8$var$checkOptions.call(this, $fe6513d7560e94a8$var$removedOptions, opts, "NOT SUPPORTED");
        $fe6513d7560e94a8$var$checkOptions.call(this, $fe6513d7560e94a8$var$deprecatedOptions, opts, "DEPRECATED", "warn");
        this._metaOpts = $fe6513d7560e94a8$var$getMetaSchemaOptions.call(this);
        if (opts.formats) $fe6513d7560e94a8$var$addInitialFormats.call(this);
        this._addVocabularies();
        this._addDefaultMetaSchema();
        if (opts.keywords) $fe6513d7560e94a8$var$addInitialKeywords.call(this, opts.keywords);
        if (typeof opts.meta == "object") this.addMetaSchema(opts.meta);
        $fe6513d7560e94a8$var$addInitialSchemas.call(this);
        opts.validateFormats = formatOpt;
    }
    _addVocabularies() {
        this.addKeyword("$async");
    }
    _addDefaultMetaSchema() {
        const { $data: $data, meta: meta, schemaId: schemaId } = this.opts;
        let _dataRefSchema = $qniTE;
        if (schemaId === "id") {
            _dataRefSchema = {
                ...$qniTE
            };
            _dataRefSchema.id = _dataRefSchema.$id;
            delete _dataRefSchema.$id;
        }
        if (meta && $data) this.addMetaSchema(_dataRefSchema, _dataRefSchema[schemaId], false);
    }
    defaultMeta() {
        const { meta: meta, schemaId: schemaId } = this.opts;
        return this.opts.defaultMeta = typeof meta == "object" ? meta[schemaId] || meta : undefined;
    }
    validate(schemaKeyRef, // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    data // to be validated
    ) {
        let v;
        if (typeof schemaKeyRef == "string") {
            v = this.getSchema(schemaKeyRef);
            if (!v) throw new Error(`no schema with key or ref "${schemaKeyRef}"`);
        } else v = this.compile(schemaKeyRef);
        const valid = v(data);
        if (!("$async" in v)) this.errors = v.errors;
        return valid;
    }
    compile(schema, _meta) {
        const sch = this._addSchema(schema, _meta);
        return sch.validate || this._compileSchemaEnv(sch);
    }
    compileAsync(schema, meta) {
        if (typeof this.opts.loadSchema != "function") throw new Error("options.loadSchema should be a function");
        const { loadSchema: loadSchema } = this.opts;
        return runCompileAsync.call(this, schema, meta);
        async function runCompileAsync(_schema, _meta) {
            await loadMetaSchema.call(this, _schema.$schema);
            const sch = this._addSchema(_schema, _meta);
            return sch.validate || _compileAsync.call(this, sch);
        }
        async function loadMetaSchema($ref) {
            if ($ref && !this.getSchema($ref)) await runCompileAsync.call(this, {
                $ref: $ref
            }, true);
        }
        async function _compileAsync(sch) {
            try {
                return this._compileSchemaEnv(sch);
            } catch (e) {
                if (!(e instanceof $fAM6G.default)) throw e;
                checkLoaded.call(this, e);
                await loadMissingSchema.call(this, e.missingSchema);
                return _compileAsync.call(this, sch);
            }
        }
        function checkLoaded({ missingSchema: ref, missingRef: missingRef }) {
            if (this.refs[ref]) throw new Error(`AnySchema ${ref} is loaded but ${missingRef} cannot be resolved`);
        }
        async function loadMissingSchema(ref) {
            const _schema = await _loadSchema.call(this, ref);
            if (!this.refs[ref]) await loadMetaSchema.call(this, _schema.$schema);
            if (!this.refs[ref]) this.addSchema(_schema, ref, meta);
        }
        async function _loadSchema(ref) {
            const p = this._loading[ref];
            if (p) return p;
            try {
                return await (this._loading[ref] = loadSchema(ref));
            } finally{
                delete this._loading[ref];
            }
        }
    }
    // Adds schema to the instance
    addSchema(schema, key, _meta, _validateSchema = this.opts.validateSchema // false to skip schema validation. Used internally, option validateSchema should be used instead.
    ) {
        if (Array.isArray(schema)) {
            for (const sch of schema)this.addSchema(sch, undefined, _meta, _validateSchema);
            return this;
        }
        let id;
        if (typeof schema === "object") {
            const { schemaId: schemaId } = this.opts;
            id = schema[schemaId];
            if (id !== undefined && typeof id != "string") throw new Error(`schema ${schemaId} must be string`);
        }
        key = (0, $fYjY5.normalizeId)(key || id);
        this._checkUnique(key);
        this.schemas[key] = this._addSchema(schema, _meta, key, _validateSchema, true);
        return this;
    }
    // Add schema that will be used to validate other schemas
    // options in META_IGNORE_OPTIONS are alway set to false
    addMetaSchema(schema, key, _validateSchema = this.opts.validateSchema // false to skip schema validation, can be used to override validateSchema option for meta-schema
    ) {
        this.addSchema(schema, key, true, _validateSchema);
        return this;
    }
    //  Validate schema against its meta-schema
    validateSchema(schema, throwOrLogError) {
        if (typeof schema == "boolean") return true;
        let $schema;
        $schema = schema.$schema;
        if ($schema !== undefined && typeof $schema != "string") throw new Error("$schema must be a string");
        $schema = $schema || this.opts.defaultMeta || this.defaultMeta();
        if (!$schema) {
            this.logger.warn("meta-schema not available");
            this.errors = null;
            return true;
        }
        const valid = this.validate($schema, schema);
        if (!valid && throwOrLogError) {
            const message = "schema is invalid: " + this.errorsText();
            if (this.opts.validateSchema === "log") this.logger.error(message);
            else throw new Error(message);
        }
        return valid;
    }
    // Get compiled schema by `key` or `ref`.
    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
    getSchema(keyRef) {
        let sch;
        while(typeof (sch = $fe6513d7560e94a8$var$getSchEnv.call(this, keyRef)) == "string")keyRef = sch;
        if (sch === undefined) {
            const { schemaId: schemaId } = this.opts;
            const root = new $3F0fZ.SchemaEnv({
                schema: {},
                schemaId: schemaId
            });
            sch = $3F0fZ.resolveSchema.call(this, root, keyRef);
            if (!sch) return;
            this.refs[keyRef] = sch;
        }
        return sch.validate || this._compileSchemaEnv(sch);
    }
    // Remove cached schema(s).
    // If no parameter is passed all schemas but meta-schemas are removed.
    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
    removeSchema(schemaKeyRef) {
        if (schemaKeyRef instanceof RegExp) {
            this._removeAllSchemas(this.schemas, schemaKeyRef);
            this._removeAllSchemas(this.refs, schemaKeyRef);
            return this;
        }
        switch(typeof schemaKeyRef){
            case "undefined":
                this._removeAllSchemas(this.schemas);
                this._removeAllSchemas(this.refs);
                this._cache.clear();
                return this;
            case "string":
                {
                    const sch = $fe6513d7560e94a8$var$getSchEnv.call(this, schemaKeyRef);
                    if (typeof sch == "object") this._cache.delete(sch.schema);
                    delete this.schemas[schemaKeyRef];
                    delete this.refs[schemaKeyRef];
                    return this;
                }
            case "object":
                {
                    const cacheKey = schemaKeyRef;
                    this._cache.delete(cacheKey);
                    let id = schemaKeyRef[this.opts.schemaId];
                    if (id) {
                        id = (0, $fYjY5.normalizeId)(id);
                        delete this.schemas[id];
                        delete this.refs[id];
                    }
                    return this;
                }
            default:
                throw new Error("ajv.removeSchema: invalid parameter");
        }
    }
    // add "vocabulary" - a collection of keywords
    addVocabulary(definitions) {
        for (const def of definitions)this.addKeyword(def);
        return this;
    }
    addKeyword(kwdOrDef, def // deprecated
    ) {
        let keyword;
        if (typeof kwdOrDef == "string") {
            keyword = kwdOrDef;
            if (typeof def == "object") {
                this.logger.warn("these parameters are deprecated, see docs for addKeyword");
                def.keyword = keyword;
            }
        } else if (typeof kwdOrDef == "object" && def === undefined) {
            def = kwdOrDef;
            keyword = def.keyword;
            if (Array.isArray(keyword) && !keyword.length) throw new Error("addKeywords: keyword must be string or non-empty array");
        } else throw new Error("invalid addKeywords parameters");
        $fe6513d7560e94a8$var$checkKeyword.call(this, keyword, def);
        if (!def) {
            (0, $1YrfU.eachItem)(keyword, (kwd)=>$fe6513d7560e94a8$var$addRule.call(this, kwd));
            return this;
        }
        $fe6513d7560e94a8$var$keywordMetaschema.call(this, def);
        const definition = {
            ...def,
            type: (0, $imYL4.getJSONTypes)(def.type),
            schemaType: (0, $imYL4.getJSONTypes)(def.schemaType)
        };
        (0, $1YrfU.eachItem)(keyword, definition.type.length === 0 ? (k)=>$fe6513d7560e94a8$var$addRule.call(this, k, definition) : (k)=>definition.type.forEach((t)=>$fe6513d7560e94a8$var$addRule.call(this, k, definition, t)));
        return this;
    }
    getKeyword(keyword) {
        const rule = this.RULES.all[keyword];
        return typeof rule == "object" ? rule.definition : !!rule;
    }
    // Remove keyword
    removeKeyword(keyword) {
        // TODO return type should be Ajv
        const { RULES: RULES } = this;
        delete RULES.keywords[keyword];
        delete RULES.all[keyword];
        for (const group of RULES.rules){
            const i = group.rules.findIndex((rule)=>rule.keyword === keyword);
            if (i >= 0) group.rules.splice(i, 1);
        }
        return this;
    }
    // Add format
    addFormat(name, format) {
        if (typeof format == "string") format = new RegExp(format);
        this.formats[name] = format;
        return this;
    }
    errorsText(errors = this.errors, { separator: separator = ", ", dataVar: dataVar = "data" } = {} // optional options with properties `separator` and `dataVar`
    ) {
        if (!errors || errors.length === 0) return "No errors";
        return errors.map((e)=>`${dataVar}${e.instancePath} ${e.message}`).reduce((text, msg)=>text + separator + msg);
    }
    $dataMetaSchema(metaSchema, keywordsJsonPointers) {
        const rules = this.RULES.all;
        metaSchema = JSON.parse(JSON.stringify(metaSchema));
        for (const jsonPointer of keywordsJsonPointers){
            const segments = jsonPointer.split("/").slice(1); // first segment is an empty string
            let keywords = metaSchema;
            for (const seg of segments)keywords = keywords[seg];
            for(const key in rules){
                const rule = rules[key];
                if (typeof rule != "object") continue;
                const { $data: $data } = rule.definition;
                const schema = keywords[key];
                if ($data && schema) keywords[key] = $fe6513d7560e94a8$var$schemaOrData(schema);
            }
        }
        return metaSchema;
    }
    _removeAllSchemas(schemas, regex) {
        for(const keyRef in schemas){
            const sch = schemas[keyRef];
            if (!regex || regex.test(keyRef)) {
                if (typeof sch == "string") delete schemas[keyRef];
                else if (sch && !sch.meta) {
                    this._cache.delete(sch.schema);
                    delete schemas[keyRef];
                }
            }
        }
    }
    _addSchema(schema, meta, baseId, validateSchema = this.opts.validateSchema, addSchema = this.opts.addUsedSchema) {
        let id;
        const { schemaId: schemaId } = this.opts;
        if (typeof schema == "object") id = schema[schemaId];
        else {
            if (this.opts.jtd) throw new Error("schema must be object");
            else if (typeof schema != "boolean") throw new Error("schema must be object or boolean");
        }
        let sch = this._cache.get(schema);
        if (sch !== undefined) return sch;
        baseId = (0, $fYjY5.normalizeId)(id || baseId);
        const localRefs = $fYjY5.getSchemaRefs.call(this, schema, baseId);
        sch = new $3F0fZ.SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            meta: meta,
            baseId: baseId,
            localRefs: localRefs
        });
        this._cache.set(sch.schema, sch);
        if (addSchema && !baseId.startsWith("#")) {
            // TODO atm it is allowed to overwrite schemas without id (instead of not adding them)
            if (baseId) this._checkUnique(baseId);
            this.refs[baseId] = sch;
        }
        if (validateSchema) this.validateSchema(schema, true);
        return sch;
    }
    _checkUnique(id) {
        if (this.schemas[id] || this.refs[id]) throw new Error(`schema with key or id "${id}" already exists`);
    }
    _compileSchemaEnv(sch) {
        if (sch.meta) this._compileMetaSchema(sch);
        else $3F0fZ.compileSchema.call(this, sch);
        /* istanbul ignore if */ if (!sch.validate) throw new Error("ajv implementation error");
        return sch.validate;
    }
    _compileMetaSchema(sch) {
        const currentOpts = this.opts;
        this.opts = this._metaOpts;
        try {
            $3F0fZ.compileSchema.call(this, sch);
        } finally{
            this.opts = currentOpts;
        }
    }
}
$fe6513d7560e94a8$var$Ajv.ValidationError = $8oSUW.default;
$fe6513d7560e94a8$var$Ajv.MissingRefError = $fAM6G.default;
module.exports.default = $fe6513d7560e94a8$var$Ajv;
function $fe6513d7560e94a8$var$checkOptions(checkOpts, options, msg, log = "error") {
    for(const key in checkOpts){
        const opt = key;
        if (opt in options) this.logger[log](`${msg}: option ${key}. ${checkOpts[opt]}`);
    }
}
function $fe6513d7560e94a8$var$getSchEnv(keyRef) {
    keyRef = (0, $fYjY5.normalizeId)(keyRef); // TODO tests fail without this line
    return this.schemas[keyRef] || this.refs[keyRef];
}
function $fe6513d7560e94a8$var$addInitialSchemas() {
    const optsSchemas = this.opts.schemas;
    if (!optsSchemas) return;
    if (Array.isArray(optsSchemas)) this.addSchema(optsSchemas);
    else for(const key in optsSchemas)this.addSchema(optsSchemas[key], key);
}
function $fe6513d7560e94a8$var$addInitialFormats() {
    for(const name in this.opts.formats){
        const format = this.opts.formats[name];
        if (format) this.addFormat(name, format);
    }
}
function $fe6513d7560e94a8$var$addInitialKeywords(defs) {
    if (Array.isArray(defs)) {
        this.addVocabulary(defs);
        return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for(const keyword in defs){
        const def = defs[keyword];
        if (!def.keyword) def.keyword = keyword;
        this.addKeyword(def);
    }
}
function $fe6513d7560e94a8$var$getMetaSchemaOptions() {
    const metaOpts = {
        ...this.opts
    };
    for (const opt of $fe6513d7560e94a8$var$META_IGNORE_OPTIONS)delete metaOpts[opt];
    return metaOpts;
}
const $fe6513d7560e94a8$var$noLogs = {
    log () {},
    warn () {},
    error () {}
};
function $fe6513d7560e94a8$var$getLogger(logger) {
    if (logger === false) return $fe6513d7560e94a8$var$noLogs;
    if (logger === undefined) return console;
    if (logger.log && logger.warn && logger.error) return logger;
    throw new Error("logger must implement log, warn and error methods");
}
const $fe6513d7560e94a8$var$KEYWORD_NAME = /^[a-z_$][a-z0-9_$:-]*$/i;
function $fe6513d7560e94a8$var$checkKeyword(keyword, def) {
    const { RULES: RULES } = this;
    (0, $1YrfU.eachItem)(keyword, (kwd)=>{
        if (RULES.keywords[kwd]) throw new Error(`Keyword ${kwd} is already defined`);
        if (!$fe6513d7560e94a8$var$KEYWORD_NAME.test(kwd)) throw new Error(`Keyword ${kwd} has invalid name`);
    });
    if (!def) return;
    if (def.$data && !("code" in def || "validate" in def)) throw new Error('$data keyword must have "code" or "validate" function');
}
function $fe6513d7560e94a8$var$addRule(keyword, definition, dataType) {
    var _a;
    const post = definition === null || definition === void 0 ? void 0 : definition.post;
    if (dataType && post) throw new Error('keyword with "post" flag cannot have "type"');
    const { RULES: RULES } = this;
    let ruleGroup = post ? RULES.post : RULES.rules.find(({ type: t })=>t === dataType);
    if (!ruleGroup) {
        ruleGroup = {
            type: dataType,
            rules: []
        };
        RULES.rules.push(ruleGroup);
    }
    RULES.keywords[keyword] = true;
    if (!definition) return;
    const rule = {
        keyword: keyword,
        definition: {
            ...definition,
            type: (0, $imYL4.getJSONTypes)(definition.type),
            schemaType: (0, $imYL4.getJSONTypes)(definition.schemaType)
        }
    };
    if (definition.before) $fe6513d7560e94a8$var$addBeforeRule.call(this, ruleGroup, rule, definition.before);
    else ruleGroup.rules.push(rule);
    RULES.all[keyword] = rule;
    (_a = definition.implements) === null || _a === void 0 || _a.forEach((kwd)=>this.addKeyword(kwd));
}
function $fe6513d7560e94a8$var$addBeforeRule(ruleGroup, rule, before) {
    const i = ruleGroup.rules.findIndex((_rule)=>_rule.keyword === before);
    if (i >= 0) ruleGroup.rules.splice(i, 0, rule);
    else {
        ruleGroup.rules.push(rule);
        this.logger.warn(`rule ${before} is not defined`);
    }
}
function $fe6513d7560e94a8$var$keywordMetaschema(def) {
    let { metaSchema: metaSchema } = def;
    if (metaSchema === undefined) return;
    if (def.$data && this.opts.$data) metaSchema = $fe6513d7560e94a8$var$schemaOrData(metaSchema);
    def.validateSchema = this.compile(metaSchema, true);
}
const $fe6513d7560e94a8$var$$dataRef = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
};
function $fe6513d7560e94a8$var$schemaOrData(schema) {
    return {
        anyOf: [
            schema,
            $fe6513d7560e94a8$var$$dataRef
        ]
    };
}

});
parcelRegister("1VPfM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getData = module.exports.KeywordCxt = module.exports.validateFunctionCode = void 0;

var $jn16r = parcelRequire("jn16r");

var $imYL4 = parcelRequire("imYL4");

var $6kVqZ = parcelRequire("6kVqZ");

var $imYL4 = parcelRequire("imYL4");

var $d8uCT = parcelRequire("d8uCT");

var $5rEy3 = parcelRequire("5rEy3");

var $8iLRP = parcelRequire("8iLRP");

var $dUnzg = parcelRequire("dUnzg");

var $3tbeu = parcelRequire("3tbeu");

var $fYjY5 = parcelRequire("fYjY5");

var $1YrfU = parcelRequire("1YrfU");

var $kxrkH = parcelRequire("kxrkH");
// schema compilation - generates validation function, subschemaCode (below) is used for subschemas
function $1682df3471a91e92$var$validateFunctionCode(it) {
    if ($1682df3471a91e92$var$isSchemaObj(it)) {
        $1682df3471a91e92$var$checkKeywords(it);
        if ($1682df3471a91e92$var$schemaCxtHasRules(it)) {
            $1682df3471a91e92$var$topSchemaObjCode(it);
            return;
        }
    }
    $1682df3471a91e92$var$validateFunction(it, ()=>(0, $jn16r.topBoolOrEmptySchema)(it));
}
module.exports.validateFunctionCode = $1682df3471a91e92$var$validateFunctionCode;
function $1682df3471a91e92$var$validateFunction({ gen: gen, validateName: validateName, schema: schema, schemaEnv: schemaEnv, opts: opts }, body) {
    if (opts.code.es5) gen.func(validateName, (0, $dUnzg._)`${$3tbeu.default.data}, ${$3tbeu.default.valCxt}`, schemaEnv.$async, ()=>{
        gen.code((0, $dUnzg._)`"use strict"; ${$1682df3471a91e92$var$funcSourceUrl(schema, opts)}`);
        $1682df3471a91e92$var$destructureValCxtES5(gen, opts);
        gen.code(body);
    });
    else gen.func(validateName, (0, $dUnzg._)`${$3tbeu.default.data}, ${$1682df3471a91e92$var$destructureValCxt(opts)}`, schemaEnv.$async, ()=>gen.code($1682df3471a91e92$var$funcSourceUrl(schema, opts)).code(body));
}
function $1682df3471a91e92$var$destructureValCxt(opts) {
    return (0, $dUnzg._)`{${$3tbeu.default.instancePath}="", ${$3tbeu.default.parentData}, ${$3tbeu.default.parentDataProperty}, ${$3tbeu.default.rootData}=${$3tbeu.default.data}${opts.dynamicRef ? (0, $dUnzg._)`, ${$3tbeu.default.dynamicAnchors}={}` : $dUnzg.nil}}={}`;
}
function $1682df3471a91e92$var$destructureValCxtES5(gen, opts) {
    gen.if($3tbeu.default.valCxt, ()=>{
        gen.var($3tbeu.default.instancePath, (0, $dUnzg._)`${$3tbeu.default.valCxt}.${$3tbeu.default.instancePath}`);
        gen.var($3tbeu.default.parentData, (0, $dUnzg._)`${$3tbeu.default.valCxt}.${$3tbeu.default.parentData}`);
        gen.var($3tbeu.default.parentDataProperty, (0, $dUnzg._)`${$3tbeu.default.valCxt}.${$3tbeu.default.parentDataProperty}`);
        gen.var($3tbeu.default.rootData, (0, $dUnzg._)`${$3tbeu.default.valCxt}.${$3tbeu.default.rootData}`);
        if (opts.dynamicRef) gen.var($3tbeu.default.dynamicAnchors, (0, $dUnzg._)`${$3tbeu.default.valCxt}.${$3tbeu.default.dynamicAnchors}`);
    }, ()=>{
        gen.var($3tbeu.default.instancePath, (0, $dUnzg._)`""`);
        gen.var($3tbeu.default.parentData, (0, $dUnzg._)`undefined`);
        gen.var($3tbeu.default.parentDataProperty, (0, $dUnzg._)`undefined`);
        gen.var($3tbeu.default.rootData, $3tbeu.default.data);
        if (opts.dynamicRef) gen.var($3tbeu.default.dynamicAnchors, (0, $dUnzg._)`{}`);
    });
}
function $1682df3471a91e92$var$topSchemaObjCode(it) {
    const { schema: schema, opts: opts, gen: gen } = it;
    $1682df3471a91e92$var$validateFunction(it, ()=>{
        if (opts.$comment && schema.$comment) $1682df3471a91e92$var$commentKeyword(it);
        $1682df3471a91e92$var$checkNoDefault(it);
        gen.let($3tbeu.default.vErrors, null);
        gen.let($3tbeu.default.errors, 0);
        if (opts.unevaluated) $1682df3471a91e92$var$resetEvaluated(it);
        $1682df3471a91e92$var$typeAndKeywords(it);
        $1682df3471a91e92$var$returnResults(it);
    });
    return;
}
function $1682df3471a91e92$var$resetEvaluated(it) {
    // TODO maybe some hook to execute it in the end to check whether props/items are Name, as in assignEvaluated
    const { gen: gen, validateName: validateName } = it;
    it.evaluated = gen.const("evaluated", (0, $dUnzg._)`${validateName}.evaluated`);
    gen.if((0, $dUnzg._)`${it.evaluated}.dynamicProps`, ()=>gen.assign((0, $dUnzg._)`${it.evaluated}.props`, (0, $dUnzg._)`undefined`));
    gen.if((0, $dUnzg._)`${it.evaluated}.dynamicItems`, ()=>gen.assign((0, $dUnzg._)`${it.evaluated}.items`, (0, $dUnzg._)`undefined`));
}
function $1682df3471a91e92$var$funcSourceUrl(schema, opts) {
    const schId = typeof schema == "object" && schema[opts.schemaId];
    return schId && (opts.code.source || opts.code.process) ? (0, $dUnzg._)`/*# sourceURL=${schId} */` : $dUnzg.nil;
}
// schema compilation - this function is used recursively to generate code for sub-schemas
function $1682df3471a91e92$var$subschemaCode(it, valid) {
    if ($1682df3471a91e92$var$isSchemaObj(it)) {
        $1682df3471a91e92$var$checkKeywords(it);
        if ($1682df3471a91e92$var$schemaCxtHasRules(it)) {
            $1682df3471a91e92$var$subSchemaObjCode(it, valid);
            return;
        }
    }
    (0, $jn16r.boolOrEmptySchema)(it, valid);
}
function $1682df3471a91e92$var$schemaCxtHasRules({ schema: schema, self: self }) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (self.RULES.all[key]) return true;
    return false;
}
function $1682df3471a91e92$var$isSchemaObj(it) {
    return typeof it.schema != "boolean";
}
function $1682df3471a91e92$var$subSchemaObjCode(it, valid) {
    const { schema: schema, gen: gen, opts: opts } = it;
    if (opts.$comment && schema.$comment) $1682df3471a91e92$var$commentKeyword(it);
    $1682df3471a91e92$var$updateContext(it);
    $1682df3471a91e92$var$checkAsyncSchema(it);
    const errsCount = gen.const("_errs", $3tbeu.default.errors);
    $1682df3471a91e92$var$typeAndKeywords(it, errsCount);
    // TODO var
    gen.var(valid, (0, $dUnzg._)`${errsCount} === ${$3tbeu.default.errors}`);
}
function $1682df3471a91e92$var$checkKeywords(it) {
    (0, $1YrfU.checkUnknownRules)(it);
    $1682df3471a91e92$var$checkRefsAndKeywords(it);
}
function $1682df3471a91e92$var$typeAndKeywords(it, errsCount) {
    if (it.opts.jtd) return $1682df3471a91e92$var$schemaKeywords(it, [], false, errsCount);
    const types = (0, $imYL4.getSchemaTypes)(it.schema);
    const checkedTypes = (0, $imYL4.coerceAndCheckDataType)(it, types);
    $1682df3471a91e92$var$schemaKeywords(it, types, !checkedTypes, errsCount);
}
function $1682df3471a91e92$var$checkRefsAndKeywords(it) {
    const { schema: schema, errSchemaPath: errSchemaPath, opts: opts, self: self } = it;
    if (schema.$ref && opts.ignoreKeywordsWithRef && (0, $1YrfU.schemaHasRulesButRef)(schema, self.RULES)) self.logger.warn(`$ref: keywords ignored in schema at path "${errSchemaPath}"`);
}
function $1682df3471a91e92$var$checkNoDefault(it) {
    const { schema: schema, opts: opts } = it;
    if (schema.default !== undefined && opts.useDefaults && opts.strictSchema) (0, $1YrfU.checkStrictMode)(it, "default is ignored in the schema root");
}
function $1682df3471a91e92$var$updateContext(it) {
    const schId = it.schema[it.opts.schemaId];
    if (schId) it.baseId = (0, $fYjY5.resolveUrl)(it.opts.uriResolver, it.baseId, schId);
}
function $1682df3471a91e92$var$checkAsyncSchema(it) {
    if (it.schema.$async && !it.schemaEnv.$async) throw new Error("async schema in sync schema");
}
function $1682df3471a91e92$var$commentKeyword({ gen: gen, schemaEnv: schemaEnv, schema: schema, errSchemaPath: errSchemaPath, opts: opts }) {
    const msg = schema.$comment;
    if (opts.$comment === true) gen.code((0, $dUnzg._)`${$3tbeu.default.self}.logger.log(${msg})`);
    else if (typeof opts.$comment == "function") {
        const schemaPath = (0, $dUnzg.str)`${errSchemaPath}/$comment`;
        const rootName = gen.scopeValue("root", {
            ref: schemaEnv.root
        });
        gen.code((0, $dUnzg._)`${$3tbeu.default.self}.opts.$comment(${msg}, ${schemaPath}, ${rootName}.schema)`);
    }
}
function $1682df3471a91e92$var$returnResults(it) {
    const { gen: gen, schemaEnv: schemaEnv, validateName: validateName, ValidationError: ValidationError, opts: opts } = it;
    if (schemaEnv.$async) // TODO assign unevaluated
    gen.if((0, $dUnzg._)`${$3tbeu.default.errors} === 0`, ()=>gen.return($3tbeu.default.data), ()=>gen.throw((0, $dUnzg._)`new ${ValidationError}(${$3tbeu.default.vErrors})`));
    else {
        gen.assign((0, $dUnzg._)`${validateName}.errors`, $3tbeu.default.vErrors);
        if (opts.unevaluated) $1682df3471a91e92$var$assignEvaluated(it);
        gen.return((0, $dUnzg._)`${$3tbeu.default.errors} === 0`);
    }
}
function $1682df3471a91e92$var$assignEvaluated({ gen: gen, evaluated: evaluated, props: props, items: items }) {
    if (props instanceof $dUnzg.Name) gen.assign((0, $dUnzg._)`${evaluated}.props`, props);
    if (items instanceof $dUnzg.Name) gen.assign((0, $dUnzg._)`${evaluated}.items`, items);
}
function $1682df3471a91e92$var$schemaKeywords(it, types, typeErrors, errsCount) {
    const { gen: gen, schema: schema, data: data, allErrors: allErrors, opts: opts, self: self } = it;
    const { RULES: RULES } = self;
    if (schema.$ref && (opts.ignoreKeywordsWithRef || !(0, $1YrfU.schemaHasRulesButRef)(schema, RULES))) {
        gen.block(()=>$1682df3471a91e92$var$keywordCode(it, "$ref", RULES.all.$ref.definition)); // TODO typecast
        return;
    }
    if (!opts.jtd) $1682df3471a91e92$var$checkStrictTypes(it, types);
    gen.block(()=>{
        for (const group of RULES.rules)groupKeywords(group);
        groupKeywords(RULES.post);
    });
    function groupKeywords(group) {
        if (!(0, $6kVqZ.shouldUseGroup)(schema, group)) return;
        if (group.type) {
            gen.if((0, $imYL4.checkDataType)(group.type, data, opts.strictNumbers));
            $1682df3471a91e92$var$iterateKeywords(it, group);
            if (types.length === 1 && types[0] === group.type && typeErrors) {
                gen.else();
                (0, $imYL4.reportTypeError)(it);
            }
            gen.endIf();
        } else $1682df3471a91e92$var$iterateKeywords(it, group);
        // TODO make it "ok" call?
        if (!allErrors) gen.if((0, $dUnzg._)`${$3tbeu.default.errors} === ${errsCount || 0}`);
    }
}
function $1682df3471a91e92$var$iterateKeywords(it, group) {
    const { gen: gen, schema: schema, opts: { useDefaults: useDefaults } } = it;
    if (useDefaults) (0, $d8uCT.assignDefaults)(it, group.type);
    gen.block(()=>{
        for (const rule of group.rules)if ((0, $6kVqZ.shouldUseRule)(schema, rule)) $1682df3471a91e92$var$keywordCode(it, rule.keyword, rule.definition, group.type);
    });
}
function $1682df3471a91e92$var$checkStrictTypes(it, types) {
    if (it.schemaEnv.meta || !it.opts.strictTypes) return;
    $1682df3471a91e92$var$checkContextTypes(it, types);
    if (!it.opts.allowUnionTypes) $1682df3471a91e92$var$checkMultipleTypes(it, types);
    $1682df3471a91e92$var$checkKeywordTypes(it, it.dataTypes);
}
function $1682df3471a91e92$var$checkContextTypes(it, types) {
    if (!types.length) return;
    if (!it.dataTypes.length) {
        it.dataTypes = types;
        return;
    }
    types.forEach((t)=>{
        if (!$1682df3471a91e92$var$includesType(it.dataTypes, t)) $1682df3471a91e92$var$strictTypesError(it, `type "${t}" not allowed by context "${it.dataTypes.join(",")}"`);
    });
    $1682df3471a91e92$var$narrowSchemaTypes(it, types);
}
function $1682df3471a91e92$var$checkMultipleTypes(it, ts) {
    if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) $1682df3471a91e92$var$strictTypesError(it, "use allowUnionTypes to allow union type keyword");
}
function $1682df3471a91e92$var$checkKeywordTypes(it, ts) {
    const rules = it.self.RULES.all;
    for(const keyword in rules){
        const rule = rules[keyword];
        if (typeof rule == "object" && (0, $6kVqZ.shouldUseRule)(it.schema, rule)) {
            const { type: type } = rule.definition;
            if (type.length && !type.some((t)=>$1682df3471a91e92$var$hasApplicableType(ts, t))) $1682df3471a91e92$var$strictTypesError(it, `missing type "${type.join(",")}" for keyword "${keyword}"`);
        }
    }
}
function $1682df3471a91e92$var$hasApplicableType(schTs, kwdT) {
    return schTs.includes(kwdT) || kwdT === "number" && schTs.includes("integer");
}
function $1682df3471a91e92$var$includesType(ts, t) {
    return ts.includes(t) || t === "integer" && ts.includes("number");
}
function $1682df3471a91e92$var$narrowSchemaTypes(it, withTypes) {
    const ts = [];
    for (const t of it.dataTypes){
        if ($1682df3471a91e92$var$includesType(withTypes, t)) ts.push(t);
        else if (withTypes.includes("integer") && t === "number") ts.push("integer");
    }
    it.dataTypes = ts;
}
function $1682df3471a91e92$var$strictTypesError(it, msg) {
    const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
    msg += ` at "${schemaPath}" (strictTypes)`;
    (0, $1YrfU.checkStrictMode)(it, msg, it.opts.strictTypes);
}
class $1682df3471a91e92$var$KeywordCxt {
    constructor(it, def, keyword){
        (0, $5rEy3.validateKeywordUsage)(it, def, keyword);
        this.gen = it.gen;
        this.allErrors = it.allErrors;
        this.keyword = keyword;
        this.data = it.data;
        this.schema = it.schema[keyword];
        this.$data = def.$data && it.opts.$data && this.schema && this.schema.$data;
        this.schemaValue = (0, $1YrfU.schemaRefOrVal)(it, this.schema, keyword, this.$data);
        this.schemaType = def.schemaType;
        this.parentSchema = it.schema;
        this.params = {};
        this.it = it;
        this.def = def;
        if (this.$data) this.schemaCode = it.gen.const("vSchema", $1682df3471a91e92$var$getData(this.$data, it));
        else {
            this.schemaCode = this.schemaValue;
            if (!(0, $5rEy3.validSchemaType)(this.schema, def.schemaType, def.allowUndefined)) throw new Error(`${keyword} value must be ${JSON.stringify(def.schemaType)}`);
        }
        if ("code" in def ? def.trackErrors : def.errors !== false) this.errsCount = it.gen.const("_errs", $3tbeu.default.errors);
    }
    result(condition, successAction, failAction) {
        this.failResult((0, $dUnzg.not)(condition), successAction, failAction);
    }
    failResult(condition, successAction, failAction) {
        this.gen.if(condition);
        if (failAction) failAction();
        else this.error();
        if (successAction) {
            this.gen.else();
            successAction();
            if (this.allErrors) this.gen.endIf();
        } else if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    pass(condition, failAction) {
        this.failResult((0, $dUnzg.not)(condition), undefined, failAction);
    }
    fail(condition) {
        if (condition === undefined) {
            this.error();
            if (!this.allErrors) this.gen.if(false); // this branch will be removed by gen.optimize
            return;
        }
        this.gen.if(condition);
        this.error();
        if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    fail$data(condition) {
        if (!this.$data) return this.fail(condition);
        const { schemaCode: schemaCode } = this;
        this.fail((0, $dUnzg._)`${schemaCode} !== undefined && (${(0, $dUnzg.or)(this.invalid$data(), condition)})`);
    }
    error(append, errorParams, errorPaths) {
        if (errorParams) {
            this.setParams(errorParams);
            this._error(append, errorPaths);
            this.setParams({});
            return;
        }
        this._error(append, errorPaths);
    }
    _error(append, errorPaths) {
        (append ? $kxrkH.reportExtraError : $kxrkH.reportError)(this, this.def.error, errorPaths);
    }
    $dataError() {
        (0, $kxrkH.reportError)(this, this.def.$dataError || $kxrkH.keyword$DataError);
    }
    reset() {
        if (this.errsCount === undefined) throw new Error('add "trackErrors" to keyword definition');
        (0, $kxrkH.resetErrorsCount)(this.gen, this.errsCount);
    }
    ok(cond) {
        if (!this.allErrors) this.gen.if(cond);
    }
    setParams(obj, assign) {
        if (assign) Object.assign(this.params, obj);
        else this.params = obj;
    }
    block$data(valid, codeBlock, $dataValid = $dUnzg.nil) {
        this.gen.block(()=>{
            this.check$data(valid, $dataValid);
            codeBlock();
        });
    }
    check$data(valid = $dUnzg.nil, $dataValid = $dUnzg.nil) {
        if (!this.$data) return;
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def } = this;
        gen.if((0, $dUnzg.or)((0, $dUnzg._)`${schemaCode} === undefined`, $dataValid));
        if (valid !== $dUnzg.nil) gen.assign(valid, true);
        if (schemaType.length || def.validateSchema) {
            gen.elseIf(this.invalid$data());
            this.$dataError();
            if (valid !== $dUnzg.nil) gen.assign(valid, false);
        }
        gen.else();
    }
    invalid$data() {
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def, it: it } = this;
        return (0, $dUnzg.or)(wrong$DataType(), invalid$DataSchema());
        function wrong$DataType() {
            if (schemaType.length) {
                /* istanbul ignore if */ if (!(schemaCode instanceof $dUnzg.Name)) throw new Error("ajv implementation error");
                const st = Array.isArray(schemaType) ? schemaType : [
                    schemaType
                ];
                return (0, $dUnzg._)`${(0, $imYL4.checkDataTypes)(st, schemaCode, it.opts.strictNumbers, $imYL4.DataType.Wrong)}`;
            }
            return $dUnzg.nil;
        }
        function invalid$DataSchema() {
            if (def.validateSchema) {
                const validateSchemaRef = gen.scopeValue("validate$data", {
                    ref: def.validateSchema
                }); // TODO value.code for standalone
                return (0, $dUnzg._)`!${validateSchemaRef}(${schemaCode})`;
            }
            return $dUnzg.nil;
        }
    }
    subschema(appl, valid) {
        const subschema = (0, $8iLRP.getSubschema)(this.it, appl);
        (0, $8iLRP.extendSubschemaData)(subschema, this.it, appl);
        (0, $8iLRP.extendSubschemaMode)(subschema, appl);
        const nextContext = {
            ...this.it,
            ...subschema,
            items: undefined,
            props: undefined
        };
        $1682df3471a91e92$var$subschemaCode(nextContext, valid);
        return nextContext;
    }
    mergeEvaluated(schemaCxt, toName) {
        const { it: it, gen: gen } = this;
        if (!it.opts.unevaluated) return;
        if (it.props !== true && schemaCxt.props !== undefined) it.props = $1YrfU.mergeEvaluated.props(gen, schemaCxt.props, it.props, toName);
        if (it.items !== true && schemaCxt.items !== undefined) it.items = $1YrfU.mergeEvaluated.items(gen, schemaCxt.items, it.items, toName);
    }
    mergeValidEvaluated(schemaCxt, valid) {
        const { it: it, gen: gen } = this;
        if (it.opts.unevaluated && (it.props !== true || it.items !== true)) {
            gen.if(valid, ()=>this.mergeEvaluated(schemaCxt, $dUnzg.Name));
            return true;
        }
    }
}
module.exports.KeywordCxt = $1682df3471a91e92$var$KeywordCxt;
function $1682df3471a91e92$var$keywordCode(it, keyword, def, ruleType) {
    const cxt = new $1682df3471a91e92$var$KeywordCxt(it, def, keyword);
    if ("code" in def) def.code(cxt, ruleType);
    else if (cxt.$data && def.validate) (0, $5rEy3.funcKeywordCode)(cxt, def);
    else if ("macro" in def) (0, $5rEy3.macroKeywordCode)(cxt, def);
    else if (def.compile || def.validate) (0, $5rEy3.funcKeywordCode)(cxt, def);
}
const $1682df3471a91e92$var$JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
const $1682df3471a91e92$var$RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function $1682df3471a91e92$var$getData($data, { dataLevel: dataLevel, dataNames: dataNames, dataPathArr: dataPathArr }) {
    let jsonPointer;
    let data;
    if ($data === "") return $3tbeu.default.rootData;
    if ($data[0] === "/") {
        if (!$1682df3471a91e92$var$JSON_POINTER.test($data)) throw new Error(`Invalid JSON-pointer: ${$data}`);
        jsonPointer = $data;
        data = $3tbeu.default.rootData;
    } else {
        const matches = $1682df3471a91e92$var$RELATIVE_JSON_POINTER.exec($data);
        if (!matches) throw new Error(`Invalid JSON-pointer: ${$data}`);
        const up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer === "#") {
            if (up >= dataLevel) throw new Error(errorMsg("property/index", up));
            return dataPathArr[dataLevel - up];
        }
        if (up > dataLevel) throw new Error(errorMsg("data", up));
        data = dataNames[dataLevel - up];
        if (!jsonPointer) return data;
    }
    let expr = data;
    const segments = jsonPointer.split("/");
    for (const segment of segments)if (segment) {
        data = (0, $dUnzg._)`${data}${(0, $dUnzg.getProperty)((0, $1YrfU.unescapeJsonPointer)(segment))}`;
        expr = (0, $dUnzg._)`${expr} && ${data}`;
    }
    return expr;
    function errorMsg(pointerType, up) {
        return `Cannot access ${pointerType} ${up} levels up, current level is ${dataLevel}`;
    }
}
module.exports.getData = $1682df3471a91e92$var$getData;

});
parcelRegister("jn16r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.boolOrEmptySchema = module.exports.topBoolOrEmptySchema = void 0;

var $kxrkH = parcelRequire("kxrkH");

var $dUnzg = parcelRequire("dUnzg");

var $3tbeu = parcelRequire("3tbeu");
const $e1a105508ad34716$var$boolError = {
    message: "boolean schema is false"
};
function $e1a105508ad34716$var$topBoolOrEmptySchema(it) {
    const { gen: gen, schema: schema, validateName: validateName } = it;
    if (schema === false) $e1a105508ad34716$var$falseSchemaError(it, false);
    else if (typeof schema == "object" && schema.$async === true) gen.return($3tbeu.default.data);
    else {
        gen.assign((0, $dUnzg._)`${validateName}.errors`, null);
        gen.return(true);
    }
}
module.exports.topBoolOrEmptySchema = $e1a105508ad34716$var$topBoolOrEmptySchema;
function $e1a105508ad34716$var$boolOrEmptySchema(it, valid) {
    const { gen: gen, schema: schema } = it;
    if (schema === false) {
        gen.var(valid, false); // TODO var
        $e1a105508ad34716$var$falseSchemaError(it);
    } else gen.var(valid, true); // TODO var
}
module.exports.boolOrEmptySchema = $e1a105508ad34716$var$boolOrEmptySchema;
function $e1a105508ad34716$var$falseSchemaError(it, overrideAllErrors) {
    const { gen: gen, data: data } = it;
    // TODO maybe some other interface should be used for non-keyword validation errors...
    const cxt = {
        gen: gen,
        keyword: "false schema",
        data: data,
        schema: false,
        schemaCode: false,
        schemaValue: false,
        params: {},
        it: it
    };
    (0, $kxrkH.reportError)(cxt, $e1a105508ad34716$var$boolError, undefined, overrideAllErrors);
}

});
parcelRegister("kxrkH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendErrors = module.exports.resetErrorsCount = module.exports.reportExtraError = module.exports.reportError = module.exports.keyword$DataError = module.exports.keywordError = void 0;

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");

var $3tbeu = parcelRequire("3tbeu");
module.exports.keywordError = {
    message: ({ keyword: keyword })=>(0, $dUnzg.str)`must pass "${keyword}" keyword validation`
};
module.exports.keyword$DataError = {
    message: ({ keyword: keyword, schemaType: schemaType })=>schemaType ? (0, $dUnzg.str)`"${keyword}" keyword must be ${schemaType} ($data)` : (0, $dUnzg.str)`"${keyword}" keyword is invalid ($data)`
};
function $ef3c177322a9a71c$var$reportError(cxt, error = module.exports.keywordError, errorPaths, overrideAllErrors) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $ef3c177322a9a71c$var$errorObjectCode(cxt, error, errorPaths);
    if (overrideAllErrors !== null && overrideAllErrors !== void 0 ? overrideAllErrors : compositeRule || allErrors) $ef3c177322a9a71c$var$addError(gen, errObj);
    else $ef3c177322a9a71c$var$returnErrors(it, (0, $dUnzg._)`[${errObj}]`);
}
module.exports.reportError = $ef3c177322a9a71c$var$reportError;
function $ef3c177322a9a71c$var$reportExtraError(cxt, error = module.exports.keywordError, errorPaths) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $ef3c177322a9a71c$var$errorObjectCode(cxt, error, errorPaths);
    $ef3c177322a9a71c$var$addError(gen, errObj);
    if (!(compositeRule || allErrors)) $ef3c177322a9a71c$var$returnErrors(it, $3tbeu.default.vErrors);
}
module.exports.reportExtraError = $ef3c177322a9a71c$var$reportExtraError;
function $ef3c177322a9a71c$var$resetErrorsCount(gen, errsCount) {
    gen.assign($3tbeu.default.errors, errsCount);
    gen.if((0, $dUnzg._)`${$3tbeu.default.vErrors} !== null`, ()=>gen.if(errsCount, ()=>gen.assign((0, $dUnzg._)`${$3tbeu.default.vErrors}.length`, errsCount), ()=>gen.assign($3tbeu.default.vErrors, null)));
}
module.exports.resetErrorsCount = $ef3c177322a9a71c$var$resetErrorsCount;
function $ef3c177322a9a71c$var$extendErrors({ gen: gen, keyword: keyword, schemaValue: schemaValue, data: data, errsCount: errsCount, it: it }) {
    /* istanbul ignore if */ if (errsCount === undefined) throw new Error("ajv implementation error");
    const err = gen.name("err");
    gen.forRange("i", errsCount, $3tbeu.default.errors, (i)=>{
        gen.const(err, (0, $dUnzg._)`${$3tbeu.default.vErrors}[${i}]`);
        gen.if((0, $dUnzg._)`${err}.instancePath === undefined`, ()=>gen.assign((0, $dUnzg._)`${err}.instancePath`, (0, $dUnzg.strConcat)($3tbeu.default.instancePath, it.errorPath)));
        gen.assign((0, $dUnzg._)`${err}.schemaPath`, (0, $dUnzg.str)`${it.errSchemaPath}/${keyword}`);
        if (it.opts.verbose) {
            gen.assign((0, $dUnzg._)`${err}.schema`, schemaValue);
            gen.assign((0, $dUnzg._)`${err}.data`, data);
        }
    });
}
module.exports.extendErrors = $ef3c177322a9a71c$var$extendErrors;
function $ef3c177322a9a71c$var$addError(gen, errObj) {
    const err = gen.const("err", errObj);
    gen.if((0, $dUnzg._)`${$3tbeu.default.vErrors} === null`, ()=>gen.assign($3tbeu.default.vErrors, (0, $dUnzg._)`[${err}]`), (0, $dUnzg._)`${$3tbeu.default.vErrors}.push(${err})`);
    gen.code((0, $dUnzg._)`${$3tbeu.default.errors}++`);
}
function $ef3c177322a9a71c$var$returnErrors(it, errs) {
    const { gen: gen, validateName: validateName, schemaEnv: schemaEnv } = it;
    if (schemaEnv.$async) gen.throw((0, $dUnzg._)`new ${it.ValidationError}(${errs})`);
    else {
        gen.assign((0, $dUnzg._)`${validateName}.errors`, errs);
        gen.return(false);
    }
}
const $ef3c177322a9a71c$var$E = {
    keyword: new $dUnzg.Name("keyword"),
    schemaPath: new $dUnzg.Name("schemaPath"),
    params: new $dUnzg.Name("params"),
    propertyName: new $dUnzg.Name("propertyName"),
    message: new $dUnzg.Name("message"),
    schema: new $dUnzg.Name("schema"),
    parentSchema: new $dUnzg.Name("parentSchema")
};
function $ef3c177322a9a71c$var$errorObjectCode(cxt, error, errorPaths) {
    const { createErrors: createErrors } = cxt.it;
    if (createErrors === false) return (0, $dUnzg._)`{}`;
    return $ef3c177322a9a71c$var$errorObject(cxt, error, errorPaths);
}
function $ef3c177322a9a71c$var$errorObject(cxt, error, errorPaths = {}) {
    const { gen: gen, it: it } = cxt;
    const keyValues = [
        $ef3c177322a9a71c$var$errorInstancePath(it, errorPaths),
        $ef3c177322a9a71c$var$errorSchemaPath(cxt, errorPaths)
    ];
    $ef3c177322a9a71c$var$extraErrorProps(cxt, error, keyValues);
    return gen.object(...keyValues);
}
function $ef3c177322a9a71c$var$errorInstancePath({ errorPath: errorPath }, { instancePath: instancePath }) {
    const instPath = instancePath ? (0, $dUnzg.str)`${errorPath}${(0, $1YrfU.getErrorPath)(instancePath, $1YrfU.Type.Str)}` : errorPath;
    return [
        $3tbeu.default.instancePath,
        (0, $dUnzg.strConcat)($3tbeu.default.instancePath, instPath)
    ];
}
function $ef3c177322a9a71c$var$errorSchemaPath({ keyword: keyword, it: { errSchemaPath: errSchemaPath } }, { schemaPath: schemaPath, parentSchema: parentSchema }) {
    let schPath = parentSchema ? errSchemaPath : (0, $dUnzg.str)`${errSchemaPath}/${keyword}`;
    if (schemaPath) schPath = (0, $dUnzg.str)`${schPath}${(0, $1YrfU.getErrorPath)(schemaPath, $1YrfU.Type.Str)}`;
    return [
        $ef3c177322a9a71c$var$E.schemaPath,
        schPath
    ];
}
function $ef3c177322a9a71c$var$extraErrorProps(cxt, { params: params, message: message }, keyValues) {
    const { keyword: keyword, data: data, schemaValue: schemaValue, it: it } = cxt;
    const { opts: opts, propertyName: propertyName, topSchemaRef: topSchemaRef, schemaPath: schemaPath } = it;
    keyValues.push([
        $ef3c177322a9a71c$var$E.keyword,
        keyword
    ], [
        $ef3c177322a9a71c$var$E.params,
        typeof params == "function" ? params(cxt) : params || (0, $dUnzg._)`{}`
    ]);
    if (opts.messages) keyValues.push([
        $ef3c177322a9a71c$var$E.message,
        typeof message == "function" ? message(cxt) : message
    ]);
    if (opts.verbose) keyValues.push([
        $ef3c177322a9a71c$var$E.schema,
        schemaValue
    ], [
        $ef3c177322a9a71c$var$E.parentSchema,
        (0, $dUnzg._)`${topSchemaRef}${schemaPath}`
    ], [
        $3tbeu.default.data,
        data
    ]);
    if (propertyName) keyValues.push([
        $ef3c177322a9a71c$var$E.propertyName,
        propertyName
    ]);
}

});
parcelRegister("dUnzg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.or = module.exports.and = module.exports.not = module.exports.CodeGen = module.exports.operators = module.exports.varKinds = module.exports.ValueScopeName = module.exports.ValueScope = module.exports.Scope = module.exports.Name = module.exports.regexpCode = module.exports.stringify = module.exports.getProperty = module.exports.nil = module.exports.strConcat = module.exports.str = module.exports._ = void 0;

var $9CNzp = parcelRequire("9CNzp");

var $94p1J = parcelRequire("94p1J");

var $9CNzp = parcelRequire("9CNzp");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $9CNzp._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $9CNzp.str;
    }
});
Object.defineProperty(module.exports, "strConcat", {
    enumerable: true,
    get: function() {
        return $9CNzp.strConcat;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $9CNzp.nil;
    }
});
Object.defineProperty(module.exports, "getProperty", {
    enumerable: true,
    get: function() {
        return $9CNzp.getProperty;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $9CNzp.stringify;
    }
});
Object.defineProperty(module.exports, "regexpCode", {
    enumerable: true,
    get: function() {
        return $9CNzp.regexpCode;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $9CNzp.Name;
    }
});

var $94p1J = parcelRequire("94p1J");
Object.defineProperty(module.exports, "Scope", {
    enumerable: true,
    get: function() {
        return $94p1J.Scope;
    }
});
Object.defineProperty(module.exports, "ValueScope", {
    enumerable: true,
    get: function() {
        return $94p1J.ValueScope;
    }
});
Object.defineProperty(module.exports, "ValueScopeName", {
    enumerable: true,
    get: function() {
        return $94p1J.ValueScopeName;
    }
});
Object.defineProperty(module.exports, "varKinds", {
    enumerable: true,
    get: function() {
        return $94p1J.varKinds;
    }
});
module.exports.operators = {
    GT: new $9CNzp._Code(">"),
    GTE: new $9CNzp._Code(">="),
    LT: new $9CNzp._Code("<"),
    LTE: new $9CNzp._Code("<="),
    EQ: new $9CNzp._Code("==="),
    NEQ: new $9CNzp._Code("!=="),
    NOT: new $9CNzp._Code("!"),
    OR: new $9CNzp._Code("||"),
    AND: new $9CNzp._Code("&&"),
    ADD: new $9CNzp._Code("+")
};
class $a202c96593b3bd78$var$Node {
    optimizeNodes() {
        return this;
    }
    optimizeNames(_names, _constants) {
        return this;
    }
}
class $a202c96593b3bd78$var$Def extends $a202c96593b3bd78$var$Node {
    constructor(varKind, name, rhs){
        super();
        this.varKind = varKind;
        this.name = name;
        this.rhs = rhs;
    }
    render({ es5: es5, _n: _n }) {
        const varKind = es5 ? $94p1J.varKinds.var : this.varKind;
        const rhs = this.rhs === undefined ? "" : ` = ${this.rhs}`;
        return `${varKind} ${this.name}${rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (!names[this.name.str]) return;
        if (this.rhs) this.rhs = $a202c96593b3bd78$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        return this.rhs instanceof $9CNzp._CodeOrName ? this.rhs.names : {};
    }
}
class $a202c96593b3bd78$var$Assign extends $a202c96593b3bd78$var$Node {
    constructor(lhs, rhs, sideEffects){
        super();
        this.lhs = lhs;
        this.rhs = rhs;
        this.sideEffects = sideEffects;
    }
    render({ _n: _n }) {
        return `${this.lhs} = ${this.rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (this.lhs instanceof $9CNzp.Name && !names[this.lhs.str] && !this.sideEffects) return;
        this.rhs = $a202c96593b3bd78$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        const names = this.lhs instanceof $9CNzp.Name ? {} : {
            ...this.lhs.names
        };
        return $a202c96593b3bd78$var$addExprNames(names, this.rhs);
    }
}
class $a202c96593b3bd78$var$AssignOp extends $a202c96593b3bd78$var$Assign {
    constructor(lhs, op, rhs, sideEffects){
        super(lhs, rhs, sideEffects);
        this.op = op;
    }
    render({ _n: _n }) {
        return `${this.lhs} ${this.op}= ${this.rhs};` + _n;
    }
}
class $a202c96593b3bd78$var$Label extends $a202c96593b3bd78$var$Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n: _n }) {
        return `${this.label}:` + _n;
    }
}
class $a202c96593b3bd78$var$Break extends $a202c96593b3bd78$var$Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n: _n }) {
        const label = this.label ? ` ${this.label}` : "";
        return `break${label};` + _n;
    }
}
class $a202c96593b3bd78$var$Throw extends $a202c96593b3bd78$var$Node {
    constructor(error){
        super();
        this.error = error;
    }
    render({ _n: _n }) {
        return `throw ${this.error};` + _n;
    }
    get names() {
        return this.error.names;
    }
}
class $a202c96593b3bd78$var$AnyCode extends $a202c96593b3bd78$var$Node {
    constructor(code){
        super();
        this.code = code;
    }
    render({ _n: _n }) {
        return `${this.code};` + _n;
    }
    optimizeNodes() {
        return `${this.code}` ? this : undefined;
    }
    optimizeNames(names, constants) {
        this.code = $a202c96593b3bd78$var$optimizeExpr(this.code, names, constants);
        return this;
    }
    get names() {
        return this.code instanceof $9CNzp._CodeOrName ? this.code.names : {};
    }
}
class $a202c96593b3bd78$var$ParentNode extends $a202c96593b3bd78$var$Node {
    constructor(nodes = []){
        super();
        this.nodes = nodes;
    }
    render(opts) {
        return this.nodes.reduce((code, n)=>code + n.render(opts), "");
    }
    optimizeNodes() {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            const n = nodes[i].optimizeNodes();
            if (Array.isArray(n)) nodes.splice(i, 1, ...n);
            else if (n) nodes[i] = n;
            else nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    optimizeNames(names, constants) {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            // iterating backwards improves 1-pass optimization
            const n = nodes[i];
            if (n.optimizeNames(names, constants)) continue;
            $a202c96593b3bd78$var$subtractNames(names, n.names);
            nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    get names() {
        return this.nodes.reduce((names, n)=>$a202c96593b3bd78$var$addNames(names, n.names), {});
    }
}
class $a202c96593b3bd78$var$BlockNode extends $a202c96593b3bd78$var$ParentNode {
    render(opts) {
        return "{" + opts._n + super.render(opts) + "}" + opts._n;
    }
}
class $a202c96593b3bd78$var$Root extends $a202c96593b3bd78$var$ParentNode {
}
class $a202c96593b3bd78$var$Else extends $a202c96593b3bd78$var$BlockNode {
}
$a202c96593b3bd78$var$Else.kind = "else";
class $a202c96593b3bd78$var$If extends $a202c96593b3bd78$var$BlockNode {
    constructor(condition, nodes){
        super(nodes);
        this.condition = condition;
    }
    render(opts) {
        let code = `if(${this.condition})` + super.render(opts);
        if (this.else) code += "else " + this.else.render(opts);
        return code;
    }
    optimizeNodes() {
        super.optimizeNodes();
        const cond = this.condition;
        if (cond === true) return this.nodes; // else is ignored here
        let e = this.else;
        if (e) {
            const ns = e.optimizeNodes();
            e = this.else = Array.isArray(ns) ? new $a202c96593b3bd78$var$Else(ns) : ns;
        }
        if (e) {
            if (cond === false) return e instanceof $a202c96593b3bd78$var$If ? e : e.nodes;
            if (this.nodes.length) return this;
            return new $a202c96593b3bd78$var$If($a202c96593b3bd78$var$not(cond), e instanceof $a202c96593b3bd78$var$If ? [
                e
            ] : e.nodes);
        }
        if (cond === false || !this.nodes.length) return undefined;
        return this;
    }
    optimizeNames(names, constants) {
        var _a;
        this.else = (_a = this.else) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
        if (!(super.optimizeNames(names, constants) || this.else)) return;
        this.condition = $a202c96593b3bd78$var$optimizeExpr(this.condition, names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        $a202c96593b3bd78$var$addExprNames(names, this.condition);
        if (this.else) $a202c96593b3bd78$var$addNames(names, this.else.names);
        return names;
    }
}
$a202c96593b3bd78$var$If.kind = "if";
class $a202c96593b3bd78$var$For extends $a202c96593b3bd78$var$BlockNode {
}
$a202c96593b3bd78$var$For.kind = "for";
class $a202c96593b3bd78$var$ForLoop extends $a202c96593b3bd78$var$For {
    constructor(iteration){
        super();
        this.iteration = iteration;
    }
    render(opts) {
        return `for(${this.iteration})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iteration = $a202c96593b3bd78$var$optimizeExpr(this.iteration, names, constants);
        return this;
    }
    get names() {
        return $a202c96593b3bd78$var$addNames(super.names, this.iteration.names);
    }
}
class $a202c96593b3bd78$var$ForRange extends $a202c96593b3bd78$var$For {
    constructor(varKind, name, from, to){
        super();
        this.varKind = varKind;
        this.name = name;
        this.from = from;
        this.to = to;
    }
    render(opts) {
        const varKind = opts.es5 ? $94p1J.varKinds.var : this.varKind;
        const { name: name, from: from, to: to } = this;
        return `for(${varKind} ${name}=${from}; ${name}<${to}; ${name}++)` + super.render(opts);
    }
    get names() {
        const names = $a202c96593b3bd78$var$addExprNames(super.names, this.from);
        return $a202c96593b3bd78$var$addExprNames(names, this.to);
    }
}
class $a202c96593b3bd78$var$ForIter extends $a202c96593b3bd78$var$For {
    constructor(loop, varKind, name, iterable){
        super();
        this.loop = loop;
        this.varKind = varKind;
        this.name = name;
        this.iterable = iterable;
    }
    render(opts) {
        return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iterable = $a202c96593b3bd78$var$optimizeExpr(this.iterable, names, constants);
        return this;
    }
    get names() {
        return $a202c96593b3bd78$var$addNames(super.names, this.iterable.names);
    }
}
class $a202c96593b3bd78$var$Func extends $a202c96593b3bd78$var$BlockNode {
    constructor(name, args, async){
        super();
        this.name = name;
        this.args = args;
        this.async = async;
    }
    render(opts) {
        const _async = this.async ? "async " : "";
        return `${_async}function ${this.name}(${this.args})` + super.render(opts);
    }
}
$a202c96593b3bd78$var$Func.kind = "func";
class $a202c96593b3bd78$var$Return extends $a202c96593b3bd78$var$ParentNode {
    render(opts) {
        return "return " + super.render(opts);
    }
}
$a202c96593b3bd78$var$Return.kind = "return";
class $a202c96593b3bd78$var$Try extends $a202c96593b3bd78$var$BlockNode {
    render(opts) {
        let code = "try" + super.render(opts);
        if (this.catch) code += this.catch.render(opts);
        if (this.finally) code += this.finally.render(opts);
        return code;
    }
    optimizeNodes() {
        var _a, _b;
        super.optimizeNodes();
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNodes();
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNodes();
        return this;
    }
    optimizeNames(names, constants) {
        var _a, _b;
        super.optimizeNames(names, constants);
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNames(names, constants);
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNames(names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        if (this.catch) $a202c96593b3bd78$var$addNames(names, this.catch.names);
        if (this.finally) $a202c96593b3bd78$var$addNames(names, this.finally.names);
        return names;
    }
}
class $a202c96593b3bd78$var$Catch extends $a202c96593b3bd78$var$BlockNode {
    constructor(error){
        super();
        this.error = error;
    }
    render(opts) {
        return `catch(${this.error})` + super.render(opts);
    }
}
$a202c96593b3bd78$var$Catch.kind = "catch";
class $a202c96593b3bd78$var$Finally extends $a202c96593b3bd78$var$BlockNode {
    render(opts) {
        return "finally" + super.render(opts);
    }
}
$a202c96593b3bd78$var$Finally.kind = "finally";
class $a202c96593b3bd78$var$CodeGen {
    constructor(extScope, opts = {}){
        this._values = {};
        this._blockStarts = [];
        this._constants = {};
        this.opts = {
            ...opts,
            _n: opts.lines ? "\n" : ""
        };
        this._extScope = extScope;
        this._scope = new $94p1J.Scope({
            parent: extScope
        });
        this._nodes = [
            new $a202c96593b3bd78$var$Root()
        ];
    }
    toString() {
        return this._root.render(this.opts);
    }
    // returns unique name in the internal scope
    name(prefix) {
        return this._scope.name(prefix);
    }
    // reserves unique name in the external scope
    scopeName(prefix) {
        return this._extScope.name(prefix);
    }
    // reserves unique name in the external scope and assigns value to it
    scopeValue(prefixOrName, value) {
        const name = this._extScope.value(prefixOrName, value);
        const vs = this._values[name.prefix] || (this._values[name.prefix] = new Set());
        vs.add(name);
        return name;
    }
    getScopeValue(prefix, keyOrRef) {
        return this._extScope.getValue(prefix, keyOrRef);
    }
    // return code that assigns values in the external scope to the names that are used internally
    // (same names that were returned by gen.scopeName or gen.scopeValue)
    scopeRefs(scopeName) {
        return this._extScope.scopeRefs(scopeName, this._values);
    }
    scopeCode() {
        return this._extScope.scopeCode(this._values);
    }
    _def(varKind, nameOrPrefix, rhs, constant) {
        const name = this._scope.toName(nameOrPrefix);
        if (rhs !== undefined && constant) this._constants[name.str] = rhs;
        this._leafNode(new $a202c96593b3bd78$var$Def(varKind, name, rhs));
        return name;
    }
    // `const` declaration (`var` in es5 mode)
    const(nameOrPrefix, rhs, _constant) {
        return this._def($94p1J.varKinds.const, nameOrPrefix, rhs, _constant);
    }
    // `let` declaration with optional assignment (`var` in es5 mode)
    let(nameOrPrefix, rhs, _constant) {
        return this._def($94p1J.varKinds.let, nameOrPrefix, rhs, _constant);
    }
    // `var` declaration with optional assignment
    var(nameOrPrefix, rhs, _constant) {
        return this._def($94p1J.varKinds.var, nameOrPrefix, rhs, _constant);
    }
    // assignment code
    assign(lhs, rhs, sideEffects) {
        return this._leafNode(new $a202c96593b3bd78$var$Assign(lhs, rhs, sideEffects));
    }
    // `+=` code
    add(lhs, rhs) {
        return this._leafNode(new $a202c96593b3bd78$var$AssignOp(lhs, module.exports.operators.ADD, rhs));
    }
    // appends passed SafeExpr to code or executes Block
    code(c) {
        if (typeof c == "function") c();
        else if (c !== $9CNzp.nil) this._leafNode(new $a202c96593b3bd78$var$AnyCode(c));
        return this;
    }
    // returns code for object literal for the passed argument list of key-value pairs
    object(...keyValues) {
        const code = [
            "{"
        ];
        for (const [key, value] of keyValues){
            if (code.length > 1) code.push(",");
            code.push(key);
            if (key !== value || this.opts.es5) {
                code.push(":");
                (0, $9CNzp.addCodeArg)(code, value);
            }
        }
        code.push("}");
        return new $9CNzp._Code(code);
    }
    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
    if(condition, thenBody, elseBody) {
        this._blockNode(new $a202c96593b3bd78$var$If(condition));
        if (thenBody && elseBody) this.code(thenBody).else().code(elseBody).endIf();
        else if (thenBody) this.code(thenBody).endIf();
        else if (elseBody) throw new Error('CodeGen: "else" body without "then" body');
        return this;
    }
    // `else if` clause - invalid without `if` or after `else` clauses
    elseIf(condition) {
        return this._elseNode(new $a202c96593b3bd78$var$If(condition));
    }
    // `else` clause - only valid after `if` or `else if` clauses
    else() {
        return this._elseNode(new $a202c96593b3bd78$var$Else());
    }
    // end `if` statement (needed if gen.if was used only with condition)
    endIf() {
        return this._endBlockNode($a202c96593b3bd78$var$If, $a202c96593b3bd78$var$Else);
    }
    _for(node, forBody) {
        this._blockNode(node);
        if (forBody) this.code(forBody).endFor();
        return this;
    }
    // a generic `for` clause (or statement if `forBody` is passed)
    for(iteration, forBody) {
        return this._for(new $a202c96593b3bd78$var$ForLoop(iteration), forBody);
    }
    // `for` statement for a range of values
    forRange(nameOrPrefix, from, to, forBody, varKind = this.opts.es5 ? $94p1J.varKinds.var : $94p1J.varKinds.let) {
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $a202c96593b3bd78$var$ForRange(varKind, name, from, to), ()=>forBody(name));
    }
    // `for-of` statement (in es5 mode replace with a normal for loop)
    forOf(nameOrPrefix, iterable, forBody, varKind = $94p1J.varKinds.const) {
        const name = this._scope.toName(nameOrPrefix);
        if (this.opts.es5) {
            const arr = iterable instanceof $9CNzp.Name ? iterable : this.var("_arr", iterable);
            return this.forRange("_i", 0, (0, $9CNzp._)`${arr}.length`, (i)=>{
                this.var(name, (0, $9CNzp._)`${arr}[${i}]`);
                forBody(name);
            });
        }
        return this._for(new $a202c96593b3bd78$var$ForIter("of", varKind, name, iterable), ()=>forBody(name));
    }
    // `for-in` statement.
    // With option `ownProperties` replaced with a `for-of` loop for object keys
    forIn(nameOrPrefix, obj, forBody, varKind = this.opts.es5 ? $94p1J.varKinds.var : $94p1J.varKinds.const) {
        if (this.opts.ownProperties) return this.forOf(nameOrPrefix, (0, $9CNzp._)`Object.keys(${obj})`, forBody);
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $a202c96593b3bd78$var$ForIter("in", varKind, name, obj), ()=>forBody(name));
    }
    // end `for` loop
    endFor() {
        return this._endBlockNode($a202c96593b3bd78$var$For);
    }
    // `label` statement
    label(label) {
        return this._leafNode(new $a202c96593b3bd78$var$Label(label));
    }
    // `break` statement
    break(label) {
        return this._leafNode(new $a202c96593b3bd78$var$Break(label));
    }
    // `return` statement
    return(value) {
        const node = new $a202c96593b3bd78$var$Return();
        this._blockNode(node);
        this.code(value);
        if (node.nodes.length !== 1) throw new Error('CodeGen: "return" should have one node');
        return this._endBlockNode($a202c96593b3bd78$var$Return);
    }
    // `try` statement
    try(tryBody, catchCode, finallyCode) {
        if (!catchCode && !finallyCode) throw new Error('CodeGen: "try" without "catch" and "finally"');
        const node = new $a202c96593b3bd78$var$Try();
        this._blockNode(node);
        this.code(tryBody);
        if (catchCode) {
            const error = this.name("e");
            this._currNode = node.catch = new $a202c96593b3bd78$var$Catch(error);
            catchCode(error);
        }
        if (finallyCode) {
            this._currNode = node.finally = new $a202c96593b3bd78$var$Finally();
            this.code(finallyCode);
        }
        return this._endBlockNode($a202c96593b3bd78$var$Catch, $a202c96593b3bd78$var$Finally);
    }
    // `throw` statement
    throw(error) {
        return this._leafNode(new $a202c96593b3bd78$var$Throw(error));
    }
    // start self-balancing block
    block(body, nodeCount) {
        this._blockStarts.push(this._nodes.length);
        if (body) this.code(body).endBlock(nodeCount);
        return this;
    }
    // end the current self-balancing block
    endBlock(nodeCount) {
        const len = this._blockStarts.pop();
        if (len === undefined) throw new Error("CodeGen: not in self-balancing block");
        const toClose = this._nodes.length - len;
        if (toClose < 0 || nodeCount !== undefined && toClose !== nodeCount) throw new Error(`CodeGen: wrong number of nodes: ${toClose} vs ${nodeCount} expected`);
        this._nodes.length = len;
        return this;
    }
    // `function` heading (or definition if funcBody is passed)
    func(name, args = $9CNzp.nil, async, funcBody) {
        this._blockNode(new $a202c96593b3bd78$var$Func(name, args, async));
        if (funcBody) this.code(funcBody).endFunc();
        return this;
    }
    // end function definition
    endFunc() {
        return this._endBlockNode($a202c96593b3bd78$var$Func);
    }
    optimize(n = 1) {
        while(n-- > 0){
            this._root.optimizeNodes();
            this._root.optimizeNames(this._root.names, this._constants);
        }
    }
    _leafNode(node) {
        this._currNode.nodes.push(node);
        return this;
    }
    _blockNode(node) {
        this._currNode.nodes.push(node);
        this._nodes.push(node);
    }
    _endBlockNode(N1, N2) {
        const n = this._currNode;
        if (n instanceof N1 || N2 && n instanceof N2) {
            this._nodes.pop();
            return this;
        }
        throw new Error(`CodeGen: not in block "${N2 ? `${N1.kind}/${N2.kind}` : N1.kind}"`);
    }
    _elseNode(node) {
        const n = this._currNode;
        if (!(n instanceof $a202c96593b3bd78$var$If)) throw new Error('CodeGen: "else" without "if"');
        this._currNode = n.else = node;
        return this;
    }
    get _root() {
        return this._nodes[0];
    }
    get _currNode() {
        const ns = this._nodes;
        return ns[ns.length - 1];
    }
    set _currNode(node) {
        const ns = this._nodes;
        ns[ns.length - 1] = node;
    }
}
module.exports.CodeGen = $a202c96593b3bd78$var$CodeGen;
function $a202c96593b3bd78$var$addNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) + (from[n] || 0);
    return names;
}
function $a202c96593b3bd78$var$addExprNames(names, from) {
    return from instanceof $9CNzp._CodeOrName ? $a202c96593b3bd78$var$addNames(names, from.names) : names;
}
function $a202c96593b3bd78$var$optimizeExpr(expr, names, constants) {
    if (expr instanceof $9CNzp.Name) return replaceName(expr);
    if (!canOptimize(expr)) return expr;
    return new $9CNzp._Code(expr._items.reduce((items, c)=>{
        if (c instanceof $9CNzp.Name) c = replaceName(c);
        if (c instanceof $9CNzp._Code) items.push(...c._items);
        else items.push(c);
        return items;
    }, []));
    function replaceName(n) {
        const c = constants[n.str];
        if (c === undefined || names[n.str] !== 1) return n;
        delete names[n.str];
        return c;
    }
    function canOptimize(e) {
        return e instanceof $9CNzp._Code && e._items.some((c)=>c instanceof $9CNzp.Name && names[c.str] === 1 && constants[c.str] !== undefined);
    }
}
function $a202c96593b3bd78$var$subtractNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) - (from[n] || 0);
}
function $a202c96593b3bd78$var$not(x) {
    return typeof x == "boolean" || typeof x == "number" || x === null ? !x : (0, $9CNzp._)`!${$a202c96593b3bd78$var$par(x)}`;
}
module.exports.not = $a202c96593b3bd78$var$not;
const $a202c96593b3bd78$var$andCode = $a202c96593b3bd78$var$mappend(module.exports.operators.AND);
// boolean AND (&&) expression with the passed arguments
function $a202c96593b3bd78$var$and(...args) {
    return args.reduce($a202c96593b3bd78$var$andCode);
}
module.exports.and = $a202c96593b3bd78$var$and;
const $a202c96593b3bd78$var$orCode = $a202c96593b3bd78$var$mappend(module.exports.operators.OR);
// boolean OR (||) expression with the passed arguments
function $a202c96593b3bd78$var$or(...args) {
    return args.reduce($a202c96593b3bd78$var$orCode);
}
module.exports.or = $a202c96593b3bd78$var$or;
function $a202c96593b3bd78$var$mappend(op) {
    return (x, y)=>x === $9CNzp.nil ? y : y === $9CNzp.nil ? x : (0, $9CNzp._)`${$a202c96593b3bd78$var$par(x)} ${op} ${$a202c96593b3bd78$var$par(y)}`;
}
function $a202c96593b3bd78$var$par(x) {
    return x instanceof $9CNzp.Name ? x : (0, $9CNzp._)`(${x})`;
}

});
parcelRegister("9CNzp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.regexpCode = module.exports.getEsmExportName = module.exports.getProperty = module.exports.safeStringify = module.exports.stringify = module.exports.strConcat = module.exports.addCodeArg = module.exports.str = module.exports._ = module.exports.nil = module.exports._Code = module.exports.Name = module.exports.IDENTIFIER = module.exports._CodeOrName = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class $701e1d3ba6966db6$var$_CodeOrName {
}
module.exports._CodeOrName = $701e1d3ba6966db6$var$_CodeOrName;
module.exports.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
class $701e1d3ba6966db6$var$Name extends $701e1d3ba6966db6$var$_CodeOrName {
    constructor(s){
        super();
        if (!module.exports.IDENTIFIER.test(s)) throw new Error("CodeGen: name must be a valid identifier");
        this.str = s;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        return false;
    }
    get names() {
        return {
            [this.str]: 1
        };
    }
}
module.exports.Name = $701e1d3ba6966db6$var$Name;
class $701e1d3ba6966db6$var$_Code extends $701e1d3ba6966db6$var$_CodeOrName {
    constructor(code){
        super();
        this._items = typeof code === "string" ? [
            code
        ] : code;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        if (this._items.length > 1) return false;
        const item = this._items[0];
        return item === "" || item === '""';
    }
    get str() {
        var _a;
        return (_a = this._str) !== null && _a !== void 0 ? _a : this._str = this._items.reduce((s, c)=>`${s}${c}`, "");
    }
    get names() {
        var _a;
        return (_a = this._names) !== null && _a !== void 0 ? _a : this._names = this._items.reduce((names, c)=>{
            if (c instanceof $701e1d3ba6966db6$var$Name) names[c.str] = (names[c.str] || 0) + 1;
            return names;
        }, {});
    }
}
module.exports._Code = $701e1d3ba6966db6$var$_Code;
module.exports.nil = new $701e1d3ba6966db6$var$_Code("");
function $701e1d3ba6966db6$var$_(strs, ...args) {
    const code = [
        strs[0]
    ];
    let i = 0;
    while(i < args.length){
        $701e1d3ba6966db6$var$addCodeArg(code, args[i]);
        code.push(strs[++i]);
    }
    return new $701e1d3ba6966db6$var$_Code(code);
}
module.exports._ = $701e1d3ba6966db6$var$_;
const $701e1d3ba6966db6$var$plus = new $701e1d3ba6966db6$var$_Code("+");
function $701e1d3ba6966db6$var$str(strs, ...args) {
    const expr = [
        $701e1d3ba6966db6$var$safeStringify(strs[0])
    ];
    let i = 0;
    while(i < args.length){
        expr.push($701e1d3ba6966db6$var$plus);
        $701e1d3ba6966db6$var$addCodeArg(expr, args[i]);
        expr.push($701e1d3ba6966db6$var$plus, $701e1d3ba6966db6$var$safeStringify(strs[++i]));
    }
    $701e1d3ba6966db6$var$optimize(expr);
    return new $701e1d3ba6966db6$var$_Code(expr);
}
module.exports.str = $701e1d3ba6966db6$var$str;
function $701e1d3ba6966db6$var$addCodeArg(code, arg) {
    if (arg instanceof $701e1d3ba6966db6$var$_Code) code.push(...arg._items);
    else if (arg instanceof $701e1d3ba6966db6$var$Name) code.push(arg);
    else code.push($701e1d3ba6966db6$var$interpolate(arg));
}
module.exports.addCodeArg = $701e1d3ba6966db6$var$addCodeArg;
function $701e1d3ba6966db6$var$optimize(expr) {
    let i = 1;
    while(i < expr.length - 1){
        if (expr[i] === $701e1d3ba6966db6$var$plus) {
            const res = $701e1d3ba6966db6$var$mergeExprItems(expr[i - 1], expr[i + 1]);
            if (res !== undefined) {
                expr.splice(i - 1, 3, res);
                continue;
            }
            expr[i++] = "+";
        }
        i++;
    }
}
function $701e1d3ba6966db6$var$mergeExprItems(a, b) {
    if (b === '""') return a;
    if (a === '""') return b;
    if (typeof a == "string") {
        if (b instanceof $701e1d3ba6966db6$var$Name || a[a.length - 1] !== '"') return;
        if (typeof b != "string") return `${a.slice(0, -1)}${b}"`;
        if (b[0] === '"') return a.slice(0, -1) + b.slice(1);
        return;
    }
    if (typeof b == "string" && b[0] === '"' && !(a instanceof $701e1d3ba6966db6$var$Name)) return `"${a}${b.slice(1)}`;
    return;
}
function $701e1d3ba6966db6$var$strConcat(c1, c2) {
    return c2.emptyStr() ? c1 : c1.emptyStr() ? c2 : $701e1d3ba6966db6$var$str`${c1}${c2}`;
}
module.exports.strConcat = $701e1d3ba6966db6$var$strConcat;
// TODO do not allow arrays here
function $701e1d3ba6966db6$var$interpolate(x) {
    return typeof x == "number" || typeof x == "boolean" || x === null ? x : $701e1d3ba6966db6$var$safeStringify(Array.isArray(x) ? x.join(",") : x);
}
function $701e1d3ba6966db6$var$stringify(x) {
    return new $701e1d3ba6966db6$var$_Code($701e1d3ba6966db6$var$safeStringify(x));
}
module.exports.stringify = $701e1d3ba6966db6$var$stringify;
function $701e1d3ba6966db6$var$safeStringify(x) {
    return JSON.stringify(x).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
}
module.exports.safeStringify = $701e1d3ba6966db6$var$safeStringify;
function $701e1d3ba6966db6$var$getProperty(key) {
    return typeof key == "string" && module.exports.IDENTIFIER.test(key) ? new $701e1d3ba6966db6$var$_Code(`.${key}`) : $701e1d3ba6966db6$var$_`[${key}]`;
}
module.exports.getProperty = $701e1d3ba6966db6$var$getProperty;
//Does best effort to format the name properly
function $701e1d3ba6966db6$var$getEsmExportName(key) {
    if (typeof key == "string" && module.exports.IDENTIFIER.test(key)) return new $701e1d3ba6966db6$var$_Code(`${key}`);
    throw new Error(`CodeGen: invalid export name: ${key}, use explicit $id name mapping`);
}
module.exports.getEsmExportName = $701e1d3ba6966db6$var$getEsmExportName;
function $701e1d3ba6966db6$var$regexpCode(rx) {
    return new $701e1d3ba6966db6$var$_Code(rx.toString());
}
module.exports.regexpCode = $701e1d3ba6966db6$var$regexpCode;

});

parcelRegister("94p1J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueScope = module.exports.ValueScopeName = module.exports.Scope = module.exports.varKinds = module.exports.UsedValueState = void 0;

var $9CNzp = parcelRequire("9CNzp");
class $69a7e69bf15f1276$var$ValueError extends Error {
    constructor(name){
        super(`CodeGen: "code" for ${name} not defined`);
        this.value = name.value;
    }
}
var $69a7e69bf15f1276$var$UsedValueState;
(function(UsedValueState) {
    UsedValueState[UsedValueState["Started"] = 0] = "Started";
    UsedValueState[UsedValueState["Completed"] = 1] = "Completed";
})($69a7e69bf15f1276$var$UsedValueState || (module.exports.UsedValueState = $69a7e69bf15f1276$var$UsedValueState = {}));
module.exports.varKinds = {
    const: new $9CNzp.Name("const"),
    let: new $9CNzp.Name("let"),
    var: new $9CNzp.Name("var")
};
class $69a7e69bf15f1276$var$Scope {
    constructor({ prefixes: prefixes, parent: parent } = {}){
        this._names = {};
        this._prefixes = prefixes;
        this._parent = parent;
    }
    toName(nameOrPrefix) {
        return nameOrPrefix instanceof $9CNzp.Name ? nameOrPrefix : this.name(nameOrPrefix);
    }
    name(prefix) {
        return new $9CNzp.Name(this._newName(prefix));
    }
    _newName(prefix) {
        const ng = this._names[prefix] || this._nameGroup(prefix);
        return `${prefix}${ng.index++}`;
    }
    _nameGroup(prefix) {
        var _a, _b;
        if (((_b = (_a = this._parent) === null || _a === void 0 ? void 0 : _a._prefixes) === null || _b === void 0 ? void 0 : _b.has(prefix)) || this._prefixes && !this._prefixes.has(prefix)) throw new Error(`CodeGen: prefix "${prefix}" is not allowed in this scope`);
        return this._names[prefix] = {
            prefix: prefix,
            index: 0
        };
    }
}
module.exports.Scope = $69a7e69bf15f1276$var$Scope;
class $69a7e69bf15f1276$var$ValueScopeName extends $9CNzp.Name {
    constructor(prefix, nameStr){
        super(nameStr);
        this.prefix = prefix;
    }
    setValue(value, { property: property, itemIndex: itemIndex }) {
        this.value = value;
        this.scopePath = (0, $9CNzp._)`.${new $9CNzp.Name(property)}[${itemIndex}]`;
    }
}
module.exports.ValueScopeName = $69a7e69bf15f1276$var$ValueScopeName;
const $69a7e69bf15f1276$var$line = (0, $9CNzp._)`\n`;
class $69a7e69bf15f1276$var$ValueScope extends $69a7e69bf15f1276$var$Scope {
    constructor(opts){
        super(opts);
        this._values = {};
        this._scope = opts.scope;
        this.opts = {
            ...opts,
            _n: opts.lines ? $69a7e69bf15f1276$var$line : $9CNzp.nil
        };
    }
    get() {
        return this._scope;
    }
    name(prefix) {
        return new $69a7e69bf15f1276$var$ValueScopeName(prefix, this._newName(prefix));
    }
    value(nameOrPrefix, value) {
        var _a;
        if (value.ref === undefined) throw new Error("CodeGen: ref must be passed in value");
        const name = this.toName(nameOrPrefix);
        const { prefix: prefix } = name;
        const valueKey = (_a = value.key) !== null && _a !== void 0 ? _a : value.ref;
        let vs = this._values[prefix];
        if (vs) {
            const _name = vs.get(valueKey);
            if (_name) return _name;
        } else vs = this._values[prefix] = new Map();
        vs.set(valueKey, name);
        const s = this._scope[prefix] || (this._scope[prefix] = []);
        const itemIndex = s.length;
        s[itemIndex] = value.ref;
        name.setValue(value, {
            property: prefix,
            itemIndex: itemIndex
        });
        return name;
    }
    getValue(prefix, keyOrRef) {
        const vs = this._values[prefix];
        if (!vs) return;
        return vs.get(keyOrRef);
    }
    scopeRefs(scopeName, values = this._values) {
        return this._reduceValues(values, (name)=>{
            if (name.scopePath === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return (0, $9CNzp._)`${scopeName}${name.scopePath}`;
        });
    }
    scopeCode(values = this._values, usedValues, getCode) {
        return this._reduceValues(values, (name)=>{
            if (name.value === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return name.value.code;
        }, usedValues, getCode);
    }
    _reduceValues(values, valueCode, usedValues = {}, getCode) {
        let code = $9CNzp.nil;
        for(const prefix in values){
            const vs = values[prefix];
            if (!vs) continue;
            const nameSet = usedValues[prefix] = usedValues[prefix] || new Map();
            vs.forEach((name)=>{
                if (nameSet.has(name)) return;
                nameSet.set(name, $69a7e69bf15f1276$var$UsedValueState.Started);
                let c = valueCode(name);
                if (c) {
                    const def = this.opts.es5 ? module.exports.varKinds.var : module.exports.varKinds.const;
                    code = (0, $9CNzp._)`${code}${def} ${name} = ${c};${this.opts._n}`;
                } else if (c = getCode === null || getCode === void 0 ? void 0 : getCode(name)) code = (0, $9CNzp._)`${code}${c}${this.opts._n}`;
                else throw new $69a7e69bf15f1276$var$ValueError(name);
                nameSet.set(name, $69a7e69bf15f1276$var$UsedValueState.Completed);
            });
        }
        return code;
    }
}
module.exports.ValueScope = $69a7e69bf15f1276$var$ValueScope;

});


parcelRegister("1YrfU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkStrictMode = module.exports.getErrorPath = module.exports.Type = module.exports.useFunc = module.exports.setEvaluated = module.exports.evaluatedPropsToName = module.exports.mergeEvaluated = module.exports.eachItem = module.exports.unescapeJsonPointer = module.exports.escapeJsonPointer = module.exports.escapeFragment = module.exports.unescapeFragment = module.exports.schemaRefOrVal = module.exports.schemaHasRulesButRef = module.exports.schemaHasRules = module.exports.checkUnknownRules = module.exports.alwaysValidSchema = module.exports.toHash = void 0;

var $dUnzg = parcelRequire("dUnzg");

var $9CNzp = parcelRequire("9CNzp");
// TODO refactor to use Set
function $17008971049c9f76$var$toHash(arr) {
    const hash = {};
    for (const item of arr)hash[item] = true;
    return hash;
}
module.exports.toHash = $17008971049c9f76$var$toHash;
function $17008971049c9f76$var$alwaysValidSchema(it, schema) {
    if (typeof schema == "boolean") return schema;
    if (Object.keys(schema).length === 0) return true;
    $17008971049c9f76$var$checkUnknownRules(it, schema);
    return !$17008971049c9f76$var$schemaHasRules(schema, it.self.RULES.all);
}
module.exports.alwaysValidSchema = $17008971049c9f76$var$alwaysValidSchema;
function $17008971049c9f76$var$checkUnknownRules(it, schema = it.schema) {
    const { opts: opts, self: self } = it;
    if (!opts.strictSchema) return;
    if (typeof schema === "boolean") return;
    const rules = self.RULES.keywords;
    for(const key in schema)if (!rules[key]) $17008971049c9f76$var$checkStrictMode(it, `unknown keyword: "${key}"`);
}
module.exports.checkUnknownRules = $17008971049c9f76$var$checkUnknownRules;
function $17008971049c9f76$var$schemaHasRules(schema, rules) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (rules[key]) return true;
    return false;
}
module.exports.schemaHasRules = $17008971049c9f76$var$schemaHasRules;
function $17008971049c9f76$var$schemaHasRulesButRef(schema, RULES) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (key !== "$ref" && RULES.all[key]) return true;
    return false;
}
module.exports.schemaHasRulesButRef = $17008971049c9f76$var$schemaHasRulesButRef;
function $17008971049c9f76$var$schemaRefOrVal({ topSchemaRef: topSchemaRef, schemaPath: schemaPath }, schema, keyword, $data) {
    if (!$data) {
        if (typeof schema == "number" || typeof schema == "boolean") return schema;
        if (typeof schema == "string") return (0, $dUnzg._)`${schema}`;
    }
    return (0, $dUnzg._)`${topSchemaRef}${schemaPath}${(0, $dUnzg.getProperty)(keyword)}`;
}
module.exports.schemaRefOrVal = $17008971049c9f76$var$schemaRefOrVal;
function $17008971049c9f76$var$unescapeFragment(str) {
    return $17008971049c9f76$var$unescapeJsonPointer(decodeURIComponent(str));
}
module.exports.unescapeFragment = $17008971049c9f76$var$unescapeFragment;
function $17008971049c9f76$var$escapeFragment(str) {
    return encodeURIComponent($17008971049c9f76$var$escapeJsonPointer(str));
}
module.exports.escapeFragment = $17008971049c9f76$var$escapeFragment;
function $17008971049c9f76$var$escapeJsonPointer(str) {
    if (typeof str == "number") return `${str}`;
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
module.exports.escapeJsonPointer = $17008971049c9f76$var$escapeJsonPointer;
function $17008971049c9f76$var$unescapeJsonPointer(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
}
module.exports.unescapeJsonPointer = $17008971049c9f76$var$unescapeJsonPointer;
function $17008971049c9f76$var$eachItem(xs, f) {
    if (Array.isArray(xs)) for (const x of xs)f(x);
    else f(xs);
}
module.exports.eachItem = $17008971049c9f76$var$eachItem;
function $17008971049c9f76$var$makeMergeEvaluated({ mergeNames: mergeNames, mergeToName: mergeToName, mergeValues: mergeValues, resultToName: resultToName }) {
    return (gen, from, to, toName)=>{
        const res = to === undefined ? from : to instanceof $dUnzg.Name ? (from instanceof $dUnzg.Name ? mergeNames(gen, from, to) : mergeToName(gen, from, to), to) : from instanceof $dUnzg.Name ? (mergeToName(gen, to, from), from) : mergeValues(from, to);
        return toName === $dUnzg.Name && !(res instanceof $dUnzg.Name) ? resultToName(gen, res) : res;
    };
}
module.exports.mergeEvaluated = {
    props: $17008971049c9f76$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $dUnzg._)`${to} !== true && ${from} !== undefined`, ()=>{
                gen.if((0, $dUnzg._)`${from} === true`, ()=>gen.assign(to, true), ()=>gen.assign(to, (0, $dUnzg._)`${to} || {}`).code((0, $dUnzg._)`Object.assign(${to}, ${from})`));
            }),
        mergeToName: (gen, from, to)=>gen.if((0, $dUnzg._)`${to} !== true`, ()=>{
                if (from === true) gen.assign(to, true);
                else {
                    gen.assign(to, (0, $dUnzg._)`${to} || {}`);
                    $17008971049c9f76$var$setEvaluated(gen, to, from);
                }
            }),
        mergeValues: (from, to)=>from === true ? true : {
                ...from,
                ...to
            },
        resultToName: $17008971049c9f76$var$evaluatedPropsToName
    }),
    items: $17008971049c9f76$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $dUnzg._)`${to} !== true && ${from} !== undefined`, ()=>gen.assign(to, (0, $dUnzg._)`${from} === true ? true : ${to} > ${from} ? ${to} : ${from}`)),
        mergeToName: (gen, from, to)=>gen.if((0, $dUnzg._)`${to} !== true`, ()=>gen.assign(to, from === true ? true : (0, $dUnzg._)`${to} > ${from} ? ${to} : ${from}`)),
        mergeValues: (from, to)=>from === true ? true : Math.max(from, to),
        resultToName: (gen, items)=>gen.var("items", items)
    })
};
function $17008971049c9f76$var$evaluatedPropsToName(gen, ps) {
    if (ps === true) return gen.var("props", true);
    const props = gen.var("props", (0, $dUnzg._)`{}`);
    if (ps !== undefined) $17008971049c9f76$var$setEvaluated(gen, props, ps);
    return props;
}
module.exports.evaluatedPropsToName = $17008971049c9f76$var$evaluatedPropsToName;
function $17008971049c9f76$var$setEvaluated(gen, props, ps) {
    Object.keys(ps).forEach((p)=>gen.assign((0, $dUnzg._)`${props}${(0, $dUnzg.getProperty)(p)}`, true));
}
module.exports.setEvaluated = $17008971049c9f76$var$setEvaluated;
const $17008971049c9f76$var$snippets = {};
function $17008971049c9f76$var$useFunc(gen, f) {
    return gen.scopeValue("func", {
        ref: f,
        code: $17008971049c9f76$var$snippets[f.code] || ($17008971049c9f76$var$snippets[f.code] = new $9CNzp._Code(f.code))
    });
}
module.exports.useFunc = $17008971049c9f76$var$useFunc;
var $17008971049c9f76$var$Type;
(function(Type) {
    Type[Type["Num"] = 0] = "Num";
    Type[Type["Str"] = 1] = "Str";
})($17008971049c9f76$var$Type || (module.exports.Type = $17008971049c9f76$var$Type = {}));
function $17008971049c9f76$var$getErrorPath(dataProp, dataPropType, jsPropertySyntax) {
    // let path
    if (dataProp instanceof $dUnzg.Name) {
        const isNumber = dataPropType === $17008971049c9f76$var$Type.Num;
        return jsPropertySyntax ? isNumber ? (0, $dUnzg._)`"[" + ${dataProp} + "]"` : (0, $dUnzg._)`"['" + ${dataProp} + "']"` : isNumber ? (0, $dUnzg._)`"/" + ${dataProp}` : (0, $dUnzg._)`"/" + ${dataProp}.replace(/~/g, "~0").replace(/\\//g, "~1")`; // TODO maybe use global escapePointer
    }
    return jsPropertySyntax ? (0, $dUnzg.getProperty)(dataProp).toString() : "/" + $17008971049c9f76$var$escapeJsonPointer(dataProp);
}
module.exports.getErrorPath = $17008971049c9f76$var$getErrorPath;
function $17008971049c9f76$var$checkStrictMode(it, msg, mode = it.opts.strictSchema) {
    if (!mode) return;
    msg = `strict mode: ${msg}`;
    if (mode === true) throw new Error(msg);
    it.self.logger.warn(msg);
}
module.exports.checkStrictMode = $17008971049c9f76$var$checkStrictMode;

});

parcelRegister("3tbeu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dUnzg = parcelRequire("dUnzg");
const $286ccb1dfd0b38a3$var$names = {
    // validation function arguments
    data: new $dUnzg.Name("data"),
    // args passed from referencing schema
    valCxt: new $dUnzg.Name("valCxt"),
    instancePath: new $dUnzg.Name("instancePath"),
    parentData: new $dUnzg.Name("parentData"),
    parentDataProperty: new $dUnzg.Name("parentDataProperty"),
    rootData: new $dUnzg.Name("rootData"),
    dynamicAnchors: new $dUnzg.Name("dynamicAnchors"),
    // function scoped variables
    vErrors: new $dUnzg.Name("vErrors"),
    errors: new $dUnzg.Name("errors"),
    this: new $dUnzg.Name("this"),
    // "globals"
    self: new $dUnzg.Name("self"),
    scope: new $dUnzg.Name("scope"),
    // JTD serialize/parse name for JSON string and position
    json: new $dUnzg.Name("json"),
    jsonPos: new $dUnzg.Name("jsonPos"),
    jsonLen: new $dUnzg.Name("jsonLen"),
    jsonPart: new $dUnzg.Name("jsonPart")
};
module.exports.default = $286ccb1dfd0b38a3$var$names;

});



parcelRegister("imYL4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.reportTypeError = module.exports.checkDataTypes = module.exports.checkDataType = module.exports.coerceAndCheckDataType = module.exports.getJSONTypes = module.exports.getSchemaTypes = module.exports.DataType = void 0;

var $2eQNP = parcelRequire("2eQNP");

var $6kVqZ = parcelRequire("6kVqZ");

var $kxrkH = parcelRequire("kxrkH");

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");
var $d5f9696027d52251$var$DataType;
(function(DataType) {
    DataType[DataType["Correct"] = 0] = "Correct";
    DataType[DataType["Wrong"] = 1] = "Wrong";
})($d5f9696027d52251$var$DataType || (module.exports.DataType = $d5f9696027d52251$var$DataType = {}));
function $d5f9696027d52251$var$getSchemaTypes(schema) {
    const types = $d5f9696027d52251$var$getJSONTypes(schema.type);
    const hasNull = types.includes("null");
    if (hasNull) {
        if (schema.nullable === false) throw new Error("type: null contradicts nullable: false");
    } else {
        if (!types.length && schema.nullable !== undefined) throw new Error('"nullable" cannot be used without "type"');
        if (schema.nullable === true) types.push("null");
    }
    return types;
}
module.exports.getSchemaTypes = $d5f9696027d52251$var$getSchemaTypes;
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
function $d5f9696027d52251$var$getJSONTypes(ts) {
    const types = Array.isArray(ts) ? ts : ts ? [
        ts
    ] : [];
    if (types.every($2eQNP.isJSONType)) return types;
    throw new Error("type must be JSONType or JSONType[]: " + types.join(","));
}
module.exports.getJSONTypes = $d5f9696027d52251$var$getJSONTypes;
function $d5f9696027d52251$var$coerceAndCheckDataType(it, types) {
    const { gen: gen, data: data, opts: opts } = it;
    const coerceTo = $d5f9696027d52251$var$coerceToTypes(types, opts.coerceTypes);
    const checkTypes = types.length > 0 && !(coerceTo.length === 0 && types.length === 1 && (0, $6kVqZ.schemaHasRulesForType)(it, types[0]));
    if (checkTypes) {
        const wrongType = $d5f9696027d52251$var$checkDataTypes(types, data, opts.strictNumbers, $d5f9696027d52251$var$DataType.Wrong);
        gen.if(wrongType, ()=>{
            if (coerceTo.length) $d5f9696027d52251$var$coerceData(it, types, coerceTo);
            else $d5f9696027d52251$var$reportTypeError(it);
        });
    }
    return checkTypes;
}
module.exports.coerceAndCheckDataType = $d5f9696027d52251$var$coerceAndCheckDataType;
const $d5f9696027d52251$var$COERCIBLE = new Set([
    "string",
    "number",
    "integer",
    "boolean",
    "null"
]);
function $d5f9696027d52251$var$coerceToTypes(types, coerceTypes) {
    return coerceTypes ? types.filter((t)=>$d5f9696027d52251$var$COERCIBLE.has(t) || coerceTypes === "array" && t === "array") : [];
}
function $d5f9696027d52251$var$coerceData(it, types, coerceTo) {
    const { gen: gen, data: data, opts: opts } = it;
    const dataType = gen.let("dataType", (0, $dUnzg._)`typeof ${data}`);
    const coerced = gen.let("coerced", (0, $dUnzg._)`undefined`);
    if (opts.coerceTypes === "array") gen.if((0, $dUnzg._)`${dataType} == 'object' && Array.isArray(${data}) && ${data}.length == 1`, ()=>gen.assign(data, (0, $dUnzg._)`${data}[0]`).assign(dataType, (0, $dUnzg._)`typeof ${data}`).if($d5f9696027d52251$var$checkDataTypes(types, data, opts.strictNumbers), ()=>gen.assign(coerced, data)));
    gen.if((0, $dUnzg._)`${coerced} !== undefined`);
    for (const t of coerceTo)if ($d5f9696027d52251$var$COERCIBLE.has(t) || t === "array" && opts.coerceTypes === "array") coerceSpecificType(t);
    gen.else();
    $d5f9696027d52251$var$reportTypeError(it);
    gen.endIf();
    gen.if((0, $dUnzg._)`${coerced} !== undefined`, ()=>{
        gen.assign(data, coerced);
        $d5f9696027d52251$var$assignParentData(it, coerced);
    });
    function coerceSpecificType(t) {
        switch(t){
            case "string":
                gen.elseIf((0, $dUnzg._)`${dataType} == "number" || ${dataType} == "boolean"`).assign(coerced, (0, $dUnzg._)`"" + ${data}`).elseIf((0, $dUnzg._)`${data} === null`).assign(coerced, (0, $dUnzg._)`""`);
                return;
            case "number":
                gen.elseIf((0, $dUnzg._)`${dataType} == "boolean" || ${data} === null
              || (${dataType} == "string" && ${data} && ${data} == +${data})`).assign(coerced, (0, $dUnzg._)`+${data}`);
                return;
            case "integer":
                gen.elseIf((0, $dUnzg._)`${dataType} === "boolean" || ${data} === null
              || (${dataType} === "string" && ${data} && ${data} == +${data} && !(${data} % 1))`).assign(coerced, (0, $dUnzg._)`+${data}`);
                return;
            case "boolean":
                gen.elseIf((0, $dUnzg._)`${data} === "false" || ${data} === 0 || ${data} === null`).assign(coerced, false).elseIf((0, $dUnzg._)`${data} === "true" || ${data} === 1`).assign(coerced, true);
                return;
            case "null":
                gen.elseIf((0, $dUnzg._)`${data} === "" || ${data} === 0 || ${data} === false`);
                gen.assign(coerced, null);
                return;
            case "array":
                gen.elseIf((0, $dUnzg._)`${dataType} === "string" || ${dataType} === "number"
              || ${dataType} === "boolean" || ${data} === null`).assign(coerced, (0, $dUnzg._)`[${data}]`);
        }
    }
}
function $d5f9696027d52251$var$assignParentData({ gen: gen, parentData: parentData, parentDataProperty: parentDataProperty }, expr) {
    // TODO use gen.property
    gen.if((0, $dUnzg._)`${parentData} !== undefined`, ()=>gen.assign((0, $dUnzg._)`${parentData}[${parentDataProperty}]`, expr));
}
function $d5f9696027d52251$var$checkDataType(dataType, data, strictNums, correct = $d5f9696027d52251$var$DataType.Correct) {
    const EQ = correct === $d5f9696027d52251$var$DataType.Correct ? $dUnzg.operators.EQ : $dUnzg.operators.NEQ;
    let cond;
    switch(dataType){
        case "null":
            return (0, $dUnzg._)`${data} ${EQ} null`;
        case "array":
            cond = (0, $dUnzg._)`Array.isArray(${data})`;
            break;
        case "object":
            cond = (0, $dUnzg._)`${data} && typeof ${data} == "object" && !Array.isArray(${data})`;
            break;
        case "integer":
            cond = numCond((0, $dUnzg._)`!(${data} % 1) && !isNaN(${data})`);
            break;
        case "number":
            cond = numCond();
            break;
        default:
            return (0, $dUnzg._)`typeof ${data} ${EQ} ${dataType}`;
    }
    return correct === $d5f9696027d52251$var$DataType.Correct ? cond : (0, $dUnzg.not)(cond);
    function numCond(_cond = $dUnzg.nil) {
        return (0, $dUnzg.and)((0, $dUnzg._)`typeof ${data} == "number"`, _cond, strictNums ? (0, $dUnzg._)`isFinite(${data})` : $dUnzg.nil);
    }
}
module.exports.checkDataType = $d5f9696027d52251$var$checkDataType;
function $d5f9696027d52251$var$checkDataTypes(dataTypes, data, strictNums, correct) {
    if (dataTypes.length === 1) return $d5f9696027d52251$var$checkDataType(dataTypes[0], data, strictNums, correct);
    let cond;
    const types = (0, $1YrfU.toHash)(dataTypes);
    if (types.array && types.object) {
        const notObj = (0, $dUnzg._)`typeof ${data} != "object"`;
        cond = types.null ? notObj : (0, $dUnzg._)`!${data} || ${notObj}`;
        delete types.null;
        delete types.array;
        delete types.object;
    } else cond = $dUnzg.nil;
    if (types.number) delete types.integer;
    for(const t in types)cond = (0, $dUnzg.and)(cond, $d5f9696027d52251$var$checkDataType(t, data, strictNums, correct));
    return cond;
}
module.exports.checkDataTypes = $d5f9696027d52251$var$checkDataTypes;
const $d5f9696027d52251$var$typeError = {
    message: ({ schema: schema })=>`must be ${schema}`,
    params: ({ schema: schema, schemaValue: schemaValue })=>typeof schema == "string" ? (0, $dUnzg._)`{type: ${schema}}` : (0, $dUnzg._)`{type: ${schemaValue}}`
};
function $d5f9696027d52251$var$reportTypeError(it) {
    const cxt = $d5f9696027d52251$var$getTypeErrorContext(it);
    (0, $kxrkH.reportError)(cxt, $d5f9696027d52251$var$typeError);
}
module.exports.reportTypeError = $d5f9696027d52251$var$reportTypeError;
function $d5f9696027d52251$var$getTypeErrorContext(it) {
    const { gen: gen, data: data, schema: schema } = it;
    const schemaCode = (0, $1YrfU.schemaRefOrVal)(it, schema, "type");
    return {
        gen: gen,
        keyword: "type",
        data: data,
        schema: schema.type,
        schemaCode: schemaCode,
        schemaValue: schemaCode,
        parentSchema: schema,
        params: {},
        it: it
    };
}

});
parcelRegister("2eQNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRules = module.exports.isJSONType = void 0;
const $1a15d91b6325262f$var$_jsonTypes = [
    "string",
    "number",
    "integer",
    "boolean",
    "null",
    "object",
    "array"
];
const $1a15d91b6325262f$var$jsonTypes = new Set($1a15d91b6325262f$var$_jsonTypes);
function $1a15d91b6325262f$var$isJSONType(x) {
    return typeof x == "string" && $1a15d91b6325262f$var$jsonTypes.has(x);
}
module.exports.isJSONType = $1a15d91b6325262f$var$isJSONType;
function $1a15d91b6325262f$var$getRules() {
    const groups = {
        number: {
            type: "number",
            rules: []
        },
        string: {
            type: "string",
            rules: []
        },
        array: {
            type: "array",
            rules: []
        },
        object: {
            type: "object",
            rules: []
        }
    };
    return {
        types: {
            ...groups,
            integer: true,
            boolean: true,
            null: true
        },
        rules: [
            {
                rules: []
            },
            groups.number,
            groups.string,
            groups.array,
            groups.object
        ],
        post: {
            rules: []
        },
        all: {},
        keywords: {}
    };
}
module.exports.getRules = $1a15d91b6325262f$var$getRules;

});

parcelRegister("6kVqZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shouldUseRule = module.exports.shouldUseGroup = module.exports.schemaHasRulesForType = void 0;
function $49d12996733b7e67$var$schemaHasRulesForType({ schema: schema, self: self }, type) {
    const group = self.RULES.types[type];
    return group && group !== true && $49d12996733b7e67$var$shouldUseGroup(schema, group);
}
module.exports.schemaHasRulesForType = $49d12996733b7e67$var$schemaHasRulesForType;
function $49d12996733b7e67$var$shouldUseGroup(schema, group) {
    return group.rules.some((rule)=>$49d12996733b7e67$var$shouldUseRule(schema, rule));
}
module.exports.shouldUseGroup = $49d12996733b7e67$var$shouldUseGroup;
function $49d12996733b7e67$var$shouldUseRule(schema, rule) {
    var _a;
    return schema[rule.keyword] !== undefined || ((_a = rule.definition.implements) === null || _a === void 0 ? void 0 : _a.some((kwd)=>schema[kwd] !== undefined));
}
module.exports.shouldUseRule = $49d12996733b7e67$var$shouldUseRule;

});


parcelRegister("d8uCT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignDefaults = void 0;

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");
function $9903c7736082f33d$var$assignDefaults(it, ty) {
    const { properties: properties, items: items } = it.schema;
    if (ty === "object" && properties) for(const key in properties)$9903c7736082f33d$var$assignDefault(it, key, properties[key].default);
    else if (ty === "array" && Array.isArray(items)) items.forEach((sch, i)=>$9903c7736082f33d$var$assignDefault(it, i, sch.default));
}
module.exports.assignDefaults = $9903c7736082f33d$var$assignDefaults;
function $9903c7736082f33d$var$assignDefault(it, prop, defaultValue) {
    const { gen: gen, compositeRule: compositeRule, data: data, opts: opts } = it;
    if (defaultValue === undefined) return;
    const childData = (0, $dUnzg._)`${data}${(0, $dUnzg.getProperty)(prop)}`;
    if (compositeRule) {
        (0, $1YrfU.checkStrictMode)(it, `default is ignored for: ${childData}`);
        return;
    }
    let condition = (0, $dUnzg._)`${childData} === undefined`;
    if (opts.useDefaults === "empty") condition = (0, $dUnzg._)`${condition} || ${childData} === null || ${childData} === ""`;
    // `${childData} === undefined` +
    // (opts.useDefaults === "empty" ? ` || ${childData} === null || ${childData} === ""` : "")
    gen.if(condition, (0, $dUnzg._)`${childData} = ${(0, $dUnzg.stringify)(defaultValue)}`);
}

});

parcelRegister("5rEy3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateKeywordUsage = module.exports.validSchemaType = module.exports.funcKeywordCode = module.exports.macroKeywordCode = void 0;

var $dUnzg = parcelRequire("dUnzg");

var $3tbeu = parcelRequire("3tbeu");

var $fKxAw = parcelRequire("fKxAw");

var $kxrkH = parcelRequire("kxrkH");
function $3f6eed6e80b1faa7$var$macroKeywordCode(cxt, def) {
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, it: it } = cxt;
    const macroSchema = def.macro.call(it.self, schema, parentSchema, it);
    const schemaRef = $3f6eed6e80b1faa7$var$useKeyword(gen, keyword, macroSchema);
    if (it.opts.validateSchema !== false) it.self.validateSchema(macroSchema, true);
    const valid = gen.name("valid");
    cxt.subschema({
        schema: macroSchema,
        schemaPath: $dUnzg.nil,
        errSchemaPath: `${it.errSchemaPath}/${keyword}`,
        topSchemaRef: schemaRef,
        compositeRule: true
    }, valid);
    cxt.pass(valid, ()=>cxt.error(true));
}
module.exports.macroKeywordCode = $3f6eed6e80b1faa7$var$macroKeywordCode;
function $3f6eed6e80b1faa7$var$funcKeywordCode(cxt, def) {
    var _a;
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, $data: $data, it: it } = cxt;
    $3f6eed6e80b1faa7$var$checkAsyncKeyword(it, def);
    const validate = !$data && def.compile ? def.compile.call(it.self, schema, parentSchema, it) : def.validate;
    const validateRef = $3f6eed6e80b1faa7$var$useKeyword(gen, keyword, validate);
    const valid = gen.let("valid");
    cxt.block$data(valid, validateKeyword);
    cxt.ok((_a = def.valid) !== null && _a !== void 0 ? _a : valid);
    function validateKeyword() {
        if (def.errors === false) {
            assignValid();
            if (def.modifying) $3f6eed6e80b1faa7$var$modifyData(cxt);
            reportErrs(()=>cxt.error());
        } else {
            const ruleErrs = def.async ? validateAsync() : validateSync();
            if (def.modifying) $3f6eed6e80b1faa7$var$modifyData(cxt);
            reportErrs(()=>$3f6eed6e80b1faa7$var$addErrs(cxt, ruleErrs));
        }
    }
    function validateAsync() {
        const ruleErrs = gen.let("ruleErrs", null);
        gen.try(()=>assignValid((0, $dUnzg._)`await `), (e)=>gen.assign(valid, false).if((0, $dUnzg._)`${e} instanceof ${it.ValidationError}`, ()=>gen.assign(ruleErrs, (0, $dUnzg._)`${e}.errors`), ()=>gen.throw(e)));
        return ruleErrs;
    }
    function validateSync() {
        const validateErrs = (0, $dUnzg._)`${validateRef}.errors`;
        gen.assign(validateErrs, null);
        assignValid($dUnzg.nil);
        return validateErrs;
    }
    function assignValid(_await = def.async ? (0, $dUnzg._)`await ` : $dUnzg.nil) {
        const passCxt = it.opts.passContext ? $3tbeu.default.this : $3tbeu.default.self;
        const passSchema = !("compile" in def && !$data || def.schema === false);
        gen.assign(valid, (0, $dUnzg._)`${_await}${(0, $fKxAw.callValidateCode)(cxt, validateRef, passCxt, passSchema)}`, def.modifying);
    }
    function reportErrs(errors) {
        var _a;
        gen.if((0, $dUnzg.not)((_a = def.valid) !== null && _a !== void 0 ? _a : valid), errors);
    }
}
module.exports.funcKeywordCode = $3f6eed6e80b1faa7$var$funcKeywordCode;
function $3f6eed6e80b1faa7$var$modifyData(cxt) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if(it.parentData, ()=>gen.assign(data, (0, $dUnzg._)`${it.parentData}[${it.parentDataProperty}]`));
}
function $3f6eed6e80b1faa7$var$addErrs(cxt, errs) {
    const { gen: gen } = cxt;
    gen.if((0, $dUnzg._)`Array.isArray(${errs})`, ()=>{
        gen.assign($3tbeu.default.vErrors, (0, $dUnzg._)`${$3tbeu.default.vErrors} === null ? ${errs} : ${$3tbeu.default.vErrors}.concat(${errs})`).assign($3tbeu.default.errors, (0, $dUnzg._)`${$3tbeu.default.vErrors}.length`);
        (0, $kxrkH.extendErrors)(cxt);
    }, ()=>cxt.error());
}
function $3f6eed6e80b1faa7$var$checkAsyncKeyword({ schemaEnv: schemaEnv }, def) {
    if (def.async && !schemaEnv.$async) throw new Error("async keyword in sync schema");
}
function $3f6eed6e80b1faa7$var$useKeyword(gen, keyword, result) {
    if (result === undefined) throw new Error(`keyword "${keyword}" failed to compile`);
    return gen.scopeValue("keyword", typeof result == "function" ? {
        ref: result
    } : {
        ref: result,
        code: (0, $dUnzg.stringify)(result)
    });
}
function $3f6eed6e80b1faa7$var$validSchemaType(schema, schemaType, allowUndefined = false) {
    // TODO add tests
    return !schemaType.length || schemaType.some((st)=>st === "array" ? Array.isArray(schema) : st === "object" ? schema && typeof schema == "object" && !Array.isArray(schema) : typeof schema == st || allowUndefined && typeof schema == "undefined");
}
module.exports.validSchemaType = $3f6eed6e80b1faa7$var$validSchemaType;
function $3f6eed6e80b1faa7$var$validateKeywordUsage({ schema: schema, opts: opts, self: self, errSchemaPath: errSchemaPath }, def, keyword) {
    /* istanbul ignore if */ if (Array.isArray(def.keyword) ? !def.keyword.includes(keyword) : def.keyword !== keyword) throw new Error("ajv implementation error");
    const deps = def.dependencies;
    if (deps === null || deps === void 0 ? void 0 : deps.some((kwd)=>!Object.prototype.hasOwnProperty.call(schema, kwd))) throw new Error(`parent schema must have dependencies of ${keyword}: ${deps.join(",")}`);
    if (def.validateSchema) {
        const valid = def.validateSchema(schema[keyword]);
        if (!valid) {
            const msg = `keyword "${keyword}" value is invalid at path "${errSchemaPath}": ` + self.errorsText(def.validateSchema.errors);
            if (opts.validateSchema === "log") self.logger.error(msg);
            else throw new Error(msg);
        }
    }
}
module.exports.validateKeywordUsage = $3f6eed6e80b1faa7$var$validateKeywordUsage;

});
parcelRegister("fKxAw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateUnion = module.exports.validateArray = module.exports.usePattern = module.exports.callValidateCode = module.exports.schemaProperties = module.exports.allSchemaProperties = module.exports.noPropertyInData = module.exports.propertyInData = module.exports.isOwnProperty = module.exports.hasPropFunc = module.exports.reportMissingProp = module.exports.checkMissingProp = module.exports.checkReportMissingProp = void 0;

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");

var $3tbeu = parcelRequire("3tbeu");

var $1YrfU = parcelRequire("1YrfU");
function $b77534cdeb488907$var$checkReportMissingProp(cxt, prop) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if($b77534cdeb488907$var$noPropertyInData(gen, data, prop, it.opts.ownProperties), ()=>{
        cxt.setParams({
            missingProperty: (0, $dUnzg._)`${prop}`
        }, true);
        cxt.error();
    });
}
module.exports.checkReportMissingProp = $b77534cdeb488907$var$checkReportMissingProp;
function $b77534cdeb488907$var$checkMissingProp({ gen: gen, data: data, it: { opts: opts } }, properties, missing) {
    return (0, $dUnzg.or)(...properties.map((prop)=>(0, $dUnzg.and)($b77534cdeb488907$var$noPropertyInData(gen, data, prop, opts.ownProperties), (0, $dUnzg._)`${missing} = ${prop}`)));
}
module.exports.checkMissingProp = $b77534cdeb488907$var$checkMissingProp;
function $b77534cdeb488907$var$reportMissingProp(cxt, missing) {
    cxt.setParams({
        missingProperty: missing
    }, true);
    cxt.error();
}
module.exports.reportMissingProp = $b77534cdeb488907$var$reportMissingProp;
function $b77534cdeb488907$var$hasPropFunc(gen) {
    return gen.scopeValue("func", {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        ref: Object.prototype.hasOwnProperty,
        code: (0, $dUnzg._)`Object.prototype.hasOwnProperty`
    });
}
module.exports.hasPropFunc = $b77534cdeb488907$var$hasPropFunc;
function $b77534cdeb488907$var$isOwnProperty(gen, data, property) {
    return (0, $dUnzg._)`${$b77534cdeb488907$var$hasPropFunc(gen)}.call(${data}, ${property})`;
}
module.exports.isOwnProperty = $b77534cdeb488907$var$isOwnProperty;
function $b77534cdeb488907$var$propertyInData(gen, data, property, ownProperties) {
    const cond = (0, $dUnzg._)`${data}${(0, $dUnzg.getProperty)(property)} !== undefined`;
    return ownProperties ? (0, $dUnzg._)`${cond} && ${$b77534cdeb488907$var$isOwnProperty(gen, data, property)}` : cond;
}
module.exports.propertyInData = $b77534cdeb488907$var$propertyInData;
function $b77534cdeb488907$var$noPropertyInData(gen, data, property, ownProperties) {
    const cond = (0, $dUnzg._)`${data}${(0, $dUnzg.getProperty)(property)} === undefined`;
    return ownProperties ? (0, $dUnzg.or)(cond, (0, $dUnzg.not)($b77534cdeb488907$var$isOwnProperty(gen, data, property))) : cond;
}
module.exports.noPropertyInData = $b77534cdeb488907$var$noPropertyInData;
function $b77534cdeb488907$var$allSchemaProperties(schemaMap) {
    return schemaMap ? Object.keys(schemaMap).filter((p)=>p !== "__proto__") : [];
}
module.exports.allSchemaProperties = $b77534cdeb488907$var$allSchemaProperties;
function $b77534cdeb488907$var$schemaProperties(it, schemaMap) {
    return $b77534cdeb488907$var$allSchemaProperties(schemaMap).filter((p)=>!(0, $1YrfU.alwaysValidSchema)(it, schemaMap[p]));
}
module.exports.schemaProperties = $b77534cdeb488907$var$schemaProperties;
function $b77534cdeb488907$var$callValidateCode({ schemaCode: schemaCode, data: data, it: { gen: gen, topSchemaRef: topSchemaRef, schemaPath: schemaPath, errorPath: errorPath }, it: it }, func, context, passSchema) {
    const dataAndSchema = passSchema ? (0, $dUnzg._)`${schemaCode}, ${data}, ${topSchemaRef}${schemaPath}` : data;
    const valCxt = [
        [
            $3tbeu.default.instancePath,
            (0, $dUnzg.strConcat)($3tbeu.default.instancePath, errorPath)
        ],
        [
            $3tbeu.default.parentData,
            it.parentData
        ],
        [
            $3tbeu.default.parentDataProperty,
            it.parentDataProperty
        ],
        [
            $3tbeu.default.rootData,
            $3tbeu.default.rootData
        ]
    ];
    if (it.opts.dynamicRef) valCxt.push([
        $3tbeu.default.dynamicAnchors,
        $3tbeu.default.dynamicAnchors
    ]);
    const args = (0, $dUnzg._)`${dataAndSchema}, ${gen.object(...valCxt)}`;
    return context !== $dUnzg.nil ? (0, $dUnzg._)`${func}.call(${context}, ${args})` : (0, $dUnzg._)`${func}(${args})`;
}
module.exports.callValidateCode = $b77534cdeb488907$var$callValidateCode;
const $b77534cdeb488907$var$newRegExp = (0, $dUnzg._)`new RegExp`;
function $b77534cdeb488907$var$usePattern({ gen: gen, it: { opts: opts } }, pattern) {
    const u = opts.unicodeRegExp ? "u" : "";
    const { regExp: regExp } = opts.code;
    const rx = regExp(pattern, u);
    return gen.scopeValue("pattern", {
        key: rx.toString(),
        ref: rx,
        code: (0, $dUnzg._)`${regExp.code === "new RegExp" ? $b77534cdeb488907$var$newRegExp : (0, $1YrfU.useFunc)(gen, regExp)}(${pattern}, ${u})`
    });
}
module.exports.usePattern = $b77534cdeb488907$var$usePattern;
function $b77534cdeb488907$var$validateArray(cxt) {
    const { gen: gen, data: data, keyword: keyword, it: it } = cxt;
    const valid = gen.name("valid");
    if (it.allErrors) {
        const validArr = gen.let("valid", true);
        validateItems(()=>gen.assign(validArr, false));
        return validArr;
    }
    gen.var(valid, true);
    validateItems(()=>gen.break());
    return valid;
    function validateItems(notValid) {
        const len = gen.const("len", (0, $dUnzg._)`${data}.length`);
        gen.forRange("i", 0, len, (i)=>{
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $1YrfU.Type.Num
            }, valid);
            gen.if((0, $dUnzg.not)(valid), notValid);
        });
    }
}
module.exports.validateArray = $b77534cdeb488907$var$validateArray;
function $b77534cdeb488907$var$validateUnion(cxt) {
    const { gen: gen, schema: schema, keyword: keyword, it: it } = cxt;
    /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
    const alwaysValid = schema.some((sch)=>(0, $1YrfU.alwaysValidSchema)(it, sch));
    if (alwaysValid && !it.opts.unevaluated) return;
    const valid = gen.let("valid", false);
    const schValid = gen.name("_valid");
    gen.block(()=>schema.forEach((_sch, i)=>{
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                compositeRule: true
            }, schValid);
            gen.assign(valid, (0, $dUnzg._)`${valid} || ${schValid}`);
            const merged = cxt.mergeValidEvaluated(schCxt, schValid);
            // can short-circuit if `unevaluatedProperties/Items` not supported (opts.unevaluated !== true)
            // or if all properties and items were evaluated (it.props === true && it.items === true)
            if (!merged) gen.if((0, $dUnzg.not)(valid));
        }));
    cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
}
module.exports.validateUnion = $b77534cdeb488907$var$validateUnion;

});


parcelRegister("8iLRP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendSubschemaMode = module.exports.extendSubschemaData = module.exports.getSubschema = void 0;

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");
function $60b52294d66e7175$var$getSubschema(it, { keyword: keyword, schemaProp: schemaProp, schema: schema, schemaPath: schemaPath, errSchemaPath: errSchemaPath, topSchemaRef: topSchemaRef }) {
    if (keyword !== undefined && schema !== undefined) throw new Error('both "keyword" and "schema" passed, only one allowed');
    if (keyword !== undefined) {
        const sch = it.schema[keyword];
        return schemaProp === undefined ? {
            schema: sch,
            schemaPath: (0, $dUnzg._)`${it.schemaPath}${(0, $dUnzg.getProperty)(keyword)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}`
        } : {
            schema: sch[schemaProp],
            schemaPath: (0, $dUnzg._)`${it.schemaPath}${(0, $dUnzg.getProperty)(keyword)}${(0, $dUnzg.getProperty)(schemaProp)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}/${(0, $1YrfU.escapeFragment)(schemaProp)}`
        };
    }
    if (schema !== undefined) {
        if (schemaPath === undefined || errSchemaPath === undefined || topSchemaRef === undefined) throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
        return {
            schema: schema,
            schemaPath: schemaPath,
            topSchemaRef: topSchemaRef,
            errSchemaPath: errSchemaPath
        };
    }
    throw new Error('either "keyword" or "schema" must be passed');
}
module.exports.getSubschema = $60b52294d66e7175$var$getSubschema;
function $60b52294d66e7175$var$extendSubschemaData(subschema, it, { dataProp: dataProp, dataPropType: dpType, data: data, dataTypes: dataTypes, propertyName: propertyName }) {
    if (data !== undefined && dataProp !== undefined) throw new Error('both "data" and "dataProp" passed, only one allowed');
    const { gen: gen } = it;
    if (dataProp !== undefined) {
        const { errorPath: errorPath, dataPathArr: dataPathArr, opts: opts } = it;
        const nextData = gen.let("data", (0, $dUnzg._)`${it.data}${(0, $dUnzg.getProperty)(dataProp)}`, true);
        dataContextProps(nextData);
        subschema.errorPath = (0, $dUnzg.str)`${errorPath}${(0, $1YrfU.getErrorPath)(dataProp, dpType, opts.jsPropertySyntax)}`;
        subschema.parentDataProperty = (0, $dUnzg._)`${dataProp}`;
        subschema.dataPathArr = [
            ...dataPathArr,
            subschema.parentDataProperty
        ];
    }
    if (data !== undefined) {
        const nextData = data instanceof $dUnzg.Name ? data : gen.let("data", data, true); // replaceable if used once?
        dataContextProps(nextData);
        if (propertyName !== undefined) subschema.propertyName = propertyName;
    // TODO something is possibly wrong here with not changing parentDataProperty and not appending dataPathArr
    }
    if (dataTypes) subschema.dataTypes = dataTypes;
    function dataContextProps(_nextData) {
        subschema.data = _nextData;
        subschema.dataLevel = it.dataLevel + 1;
        subschema.dataTypes = [];
        it.definedProperties = new Set();
        subschema.parentData = it.data;
        subschema.dataNames = [
            ...it.dataNames,
            _nextData
        ];
    }
}
module.exports.extendSubschemaData = $60b52294d66e7175$var$extendSubschemaData;
function $60b52294d66e7175$var$extendSubschemaMode(subschema, { jtdDiscriminator: jtdDiscriminator, jtdMetadata: jtdMetadata, compositeRule: compositeRule, createErrors: createErrors, allErrors: allErrors }) {
    if (compositeRule !== undefined) subschema.compositeRule = compositeRule;
    if (createErrors !== undefined) subschema.createErrors = createErrors;
    if (allErrors !== undefined) subschema.allErrors = allErrors;
    subschema.jtdDiscriminator = jtdDiscriminator; // not inherited
    subschema.jtdMetadata = jtdMetadata; // not inherited
}
module.exports.extendSubschemaMode = $60b52294d66e7175$var$extendSubschemaMode;

});

parcelRegister("fYjY5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSchemaRefs = module.exports.resolveUrl = module.exports.normalizeId = module.exports._getFullPath = module.exports.getFullPath = module.exports.inlineRef = void 0;

var $1YrfU = parcelRequire("1YrfU");

var $5jHra = parcelRequire("5jHra");

var $diVB9 = parcelRequire("diVB9");
// TODO refactor to use keyword definitions
const $ba0bf2e08db7aaf9$var$SIMPLE_INLINED = new Set([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum",
    "const"
]);
function $ba0bf2e08db7aaf9$var$inlineRef(schema, limit = true) {
    if (typeof schema == "boolean") return true;
    if (limit === true) return !$ba0bf2e08db7aaf9$var$hasRef(schema);
    if (!limit) return false;
    return $ba0bf2e08db7aaf9$var$countKeys(schema) <= limit;
}
module.exports.inlineRef = $ba0bf2e08db7aaf9$var$inlineRef;
const $ba0bf2e08db7aaf9$var$REF_KEYWORDS = new Set([
    "$ref",
    "$recursiveRef",
    "$recursiveAnchor",
    "$dynamicRef",
    "$dynamicAnchor"
]);
function $ba0bf2e08db7aaf9$var$hasRef(schema) {
    for(const key in schema){
        if ($ba0bf2e08db7aaf9$var$REF_KEYWORDS.has(key)) return true;
        const sch = schema[key];
        if (Array.isArray(sch) && sch.some($ba0bf2e08db7aaf9$var$hasRef)) return true;
        if (typeof sch == "object" && $ba0bf2e08db7aaf9$var$hasRef(sch)) return true;
    }
    return false;
}
function $ba0bf2e08db7aaf9$var$countKeys(schema) {
    let count = 0;
    for(const key in schema){
        if (key === "$ref") return Infinity;
        count++;
        if ($ba0bf2e08db7aaf9$var$SIMPLE_INLINED.has(key)) continue;
        if (typeof schema[key] == "object") (0, $1YrfU.eachItem)(schema[key], (sch)=>count += $ba0bf2e08db7aaf9$var$countKeys(sch));
        if (count === Infinity) return Infinity;
    }
    return count;
}
function $ba0bf2e08db7aaf9$var$getFullPath(resolver, id = "", normalize) {
    if (normalize !== false) id = $ba0bf2e08db7aaf9$var$normalizeId(id);
    const p = resolver.parse(id);
    return $ba0bf2e08db7aaf9$var$_getFullPath(resolver, p);
}
module.exports.getFullPath = $ba0bf2e08db7aaf9$var$getFullPath;
function $ba0bf2e08db7aaf9$var$_getFullPath(resolver, p) {
    const serialized = resolver.serialize(p);
    return serialized.split("#")[0] + "#";
}
module.exports._getFullPath = $ba0bf2e08db7aaf9$var$_getFullPath;
const $ba0bf2e08db7aaf9$var$TRAILING_SLASH_HASH = /#\/?$/;
function $ba0bf2e08db7aaf9$var$normalizeId(id) {
    return id ? id.replace($ba0bf2e08db7aaf9$var$TRAILING_SLASH_HASH, "") : "";
}
module.exports.normalizeId = $ba0bf2e08db7aaf9$var$normalizeId;
function $ba0bf2e08db7aaf9$var$resolveUrl(resolver, baseId, id) {
    id = $ba0bf2e08db7aaf9$var$normalizeId(id);
    return resolver.resolve(baseId, id);
}
module.exports.resolveUrl = $ba0bf2e08db7aaf9$var$resolveUrl;
const $ba0bf2e08db7aaf9$var$ANCHOR = /^[a-z_][-a-z0-9._]*$/i;
function $ba0bf2e08db7aaf9$var$getSchemaRefs(schema, baseId) {
    if (typeof schema == "boolean") return {};
    const { schemaId: schemaId, uriResolver: uriResolver } = this.opts;
    const schId = $ba0bf2e08db7aaf9$var$normalizeId(schema[schemaId] || baseId);
    const baseIds = {
        "": schId
    };
    const pathPrefix = $ba0bf2e08db7aaf9$var$getFullPath(uriResolver, schId, false);
    const localRefs = {};
    const schemaRefs = new Set();
    $diVB9(schema, {
        allKeys: true
    }, (sch, jsonPtr, _, parentJsonPtr)=>{
        if (parentJsonPtr === undefined) return;
        const fullPath = pathPrefix + jsonPtr;
        let innerBaseId = baseIds[parentJsonPtr];
        if (typeof sch[schemaId] == "string") innerBaseId = addRef.call(this, sch[schemaId]);
        addAnchor.call(this, sch.$anchor);
        addAnchor.call(this, sch.$dynamicAnchor);
        baseIds[jsonPtr] = innerBaseId;
        function addRef(ref) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const _resolve = this.opts.uriResolver.resolve;
            ref = $ba0bf2e08db7aaf9$var$normalizeId(innerBaseId ? _resolve(innerBaseId, ref) : ref);
            if (schemaRefs.has(ref)) throw ambiguos(ref);
            schemaRefs.add(ref);
            let schOrRef = this.refs[ref];
            if (typeof schOrRef == "string") schOrRef = this.refs[schOrRef];
            if (typeof schOrRef == "object") checkAmbiguosRef(sch, schOrRef.schema, ref);
            else if (ref !== $ba0bf2e08db7aaf9$var$normalizeId(fullPath)) {
                if (ref[0] === "#") {
                    checkAmbiguosRef(sch, localRefs[ref], ref);
                    localRefs[ref] = sch;
                } else this.refs[ref] = fullPath;
            }
            return ref;
        }
        function addAnchor(anchor) {
            if (typeof anchor == "string") {
                if (!$ba0bf2e08db7aaf9$var$ANCHOR.test(anchor)) throw new Error(`invalid anchor "${anchor}"`);
                addRef.call(this, `#${anchor}`);
            }
        }
    });
    return localRefs;
    function checkAmbiguosRef(sch1, sch2, ref) {
        if (sch2 !== undefined && !$5jHra(sch1, sch2)) throw ambiguos(ref);
    }
    function ambiguos(ref) {
        return new Error(`reference "${ref}" resolves to more than one schema`);
    }
}
module.exports.getSchemaRefs = $ba0bf2e08db7aaf9$var$getSchemaRefs;

});
parcelRegister("diVB9", function(module, exports) {
'use strict';
var $9af9a29cedfe1c43$var$traverse = module.exports = function(schema, opts, cb) {
    // Legacy support for v0.3.1 and earlier.
    if (typeof opts == 'function') {
        cb = opts;
        opts = {};
    }
    cb = opts.cb || cb;
    var pre = typeof cb == 'function' ? cb : cb.pre || function() {};
    var post = cb.post || function() {};
    $9af9a29cedfe1c43$var$_traverse(opts, pre, post, schema, '', schema);
};
$9af9a29cedfe1c43$var$traverse.keywords = {
    additionalItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    propertyNames: true,
    not: true,
    if: true,
    then: true,
    else: true
};
$9af9a29cedfe1c43$var$traverse.arrayKeywords = {
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
$9af9a29cedfe1c43$var$traverse.propsKeywords = {
    $defs: true,
    definitions: true,
    properties: true,
    patternProperties: true,
    dependencies: true
};
$9af9a29cedfe1c43$var$traverse.skipKeywords = {
    default: true,
    enum: true,
    const: true,
    required: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
function $9af9a29cedfe1c43$var$_traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (schema && typeof schema == 'object' && !Array.isArray(schema)) {
        pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
        for(var key in schema){
            var sch = schema[key];
            if (Array.isArray(sch)) {
                if (key in $9af9a29cedfe1c43$var$traverse.arrayKeywords) for(var i = 0; i < sch.length; i++)$9af9a29cedfe1c43$var$_traverse(opts, pre, post, sch[i], jsonPtr + '/' + key + '/' + i, rootSchema, jsonPtr, key, schema, i);
            } else if (key in $9af9a29cedfe1c43$var$traverse.propsKeywords) {
                if (sch && typeof sch == 'object') for(var prop in sch)$9af9a29cedfe1c43$var$_traverse(opts, pre, post, sch[prop], jsonPtr + '/' + key + '/' + $9af9a29cedfe1c43$var$escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
            } else if (key in $9af9a29cedfe1c43$var$traverse.keywords || opts.allKeys && !(key in $9af9a29cedfe1c43$var$traverse.skipKeywords)) $9af9a29cedfe1c43$var$_traverse(opts, pre, post, sch, jsonPtr + '/' + key, rootSchema, jsonPtr, key, schema);
        }
        post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    }
}
function $9af9a29cedfe1c43$var$escapeJsonPtr(str) {
    return str.replace(/~/g, '~0').replace(/\//g, '~1');
}

});



parcelRegister("8oSUW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $61db2a138eb7e3c4$var$ValidationError extends Error {
    constructor(errors){
        super("validation failed");
        this.errors = errors;
        this.ajv = this.validation = true;
    }
}
module.exports.default = $61db2a138eb7e3c4$var$ValidationError;

});

parcelRegister("fAM6G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fYjY5 = parcelRequire("fYjY5");
class $b59f88cfebca352b$var$MissingRefError extends Error {
    constructor(resolver, baseId, ref, msg){
        super(msg || `can't resolve reference ${ref} from id ${baseId}`);
        this.missingRef = (0, $fYjY5.resolveUrl)(resolver, baseId, ref);
        this.missingSchema = (0, $fYjY5.normalizeId)((0, $fYjY5.getFullPath)(resolver, this.missingRef));
    }
}
module.exports.default = $b59f88cfebca352b$var$MissingRefError;

});

parcelRegister("3F0fZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveSchema = module.exports.getCompilingSchema = module.exports.resolveRef = module.exports.compileSchema = module.exports.SchemaEnv = void 0;

var $dUnzg = parcelRequire("dUnzg");

var $8oSUW = parcelRequire("8oSUW");

var $3tbeu = parcelRequire("3tbeu");

var $fYjY5 = parcelRequire("fYjY5");

var $1YrfU = parcelRequire("1YrfU");

var $1VPfM = parcelRequire("1VPfM");
class $2aa5667128142e8e$var$SchemaEnv {
    constructor(env){
        var _a;
        this.refs = {};
        this.dynamicAnchors = {};
        let schema;
        if (typeof env.schema == "object") schema = env.schema;
        this.schema = env.schema;
        this.schemaId = env.schemaId;
        this.root = env.root || this;
        this.baseId = (_a = env.baseId) !== null && _a !== void 0 ? _a : (0, $fYjY5.normalizeId)(schema === null || schema === void 0 ? void 0 : schema[env.schemaId || "$id"]);
        this.schemaPath = env.schemaPath;
        this.localRefs = env.localRefs;
        this.meta = env.meta;
        this.$async = schema === null || schema === void 0 ? void 0 : schema.$async;
        this.refs = {};
    }
}
module.exports.SchemaEnv = $2aa5667128142e8e$var$SchemaEnv;
// let codeSize = 0
// let nodeCount = 0
// Compiles schema in SchemaEnv
function $2aa5667128142e8e$var$compileSchema(sch) {
    // TODO refactor - remove compilations
    const _sch = $2aa5667128142e8e$var$getCompilingSchema.call(this, sch);
    if (_sch) return _sch;
    const rootId = (0, $fYjY5.getFullPath)(this.opts.uriResolver, sch.root.baseId); // TODO if getFullPath removed 1 tests fails
    const { es5: es5, lines: lines } = this.opts.code;
    const { ownProperties: ownProperties } = this.opts;
    const gen = new $dUnzg.CodeGen(this.scope, {
        es5: es5,
        lines: lines,
        ownProperties: ownProperties
    });
    let _ValidationError;
    if (sch.$async) _ValidationError = gen.scopeValue("Error", {
        ref: $8oSUW.default,
        code: (0, $dUnzg._)`require("ajv/dist/runtime/validation_error").default`
    });
    const validateName = gen.scopeName("validate");
    sch.validateName = validateName;
    const schemaCxt = {
        gen: gen,
        allErrors: this.opts.allErrors,
        data: $3tbeu.default.data,
        parentData: $3tbeu.default.parentData,
        parentDataProperty: $3tbeu.default.parentDataProperty,
        dataNames: [
            $3tbeu.default.data
        ],
        dataPathArr: [
            $dUnzg.nil
        ],
        dataLevel: 0,
        dataTypes: [],
        definedProperties: new Set(),
        topSchemaRef: gen.scopeValue("schema", this.opts.code.source === true ? {
            ref: sch.schema,
            code: (0, $dUnzg.stringify)(sch.schema)
        } : {
            ref: sch.schema
        }),
        validateName: validateName,
        ValidationError: _ValidationError,
        schema: sch.schema,
        schemaEnv: sch,
        rootId: rootId,
        baseId: sch.baseId || rootId,
        schemaPath: $dUnzg.nil,
        errSchemaPath: sch.schemaPath || (this.opts.jtd ? "" : "#"),
        errorPath: (0, $dUnzg._)`""`,
        opts: this.opts,
        self: this
    };
    let sourceCode;
    try {
        this._compilations.add(sch);
        (0, $1VPfM.validateFunctionCode)(schemaCxt);
        gen.optimize(this.opts.code.optimize);
        // gen.optimize(1)
        const validateCode = gen.toString();
        sourceCode = `${gen.scopeRefs($3tbeu.default.scope)}return ${validateCode}`;
        // console.log((codeSize += sourceCode.length), (nodeCount += gen.nodeCount))
        if (this.opts.code.process) sourceCode = this.opts.code.process(sourceCode, sch);
        // console.log("\n\n\n *** \n", sourceCode)
        const makeValidate = new Function(`${$3tbeu.default.self}`, `${$3tbeu.default.scope}`, sourceCode);
        const validate = makeValidate(this, this.scope.get());
        this.scope.value(validateName, {
            ref: validate
        });
        validate.errors = null;
        validate.schema = sch.schema;
        validate.schemaEnv = sch;
        if (sch.$async) validate.$async = true;
        if (this.opts.code.source === true) validate.source = {
            validateName: validateName,
            validateCode: validateCode,
            scopeValues: gen._values
        };
        if (this.opts.unevaluated) {
            const { props: props, items: items } = schemaCxt;
            validate.evaluated = {
                props: props instanceof $dUnzg.Name ? undefined : props,
                items: items instanceof $dUnzg.Name ? undefined : items,
                dynamicProps: props instanceof $dUnzg.Name,
                dynamicItems: items instanceof $dUnzg.Name
            };
            if (validate.source) validate.source.evaluated = (0, $dUnzg.stringify)(validate.evaluated);
        }
        sch.validate = validate;
        return sch;
    } catch (e) {
        delete sch.validate;
        delete sch.validateName;
        if (sourceCode) this.logger.error("Error compiling schema, function code:", sourceCode);
        // console.log("\n\n\n *** \n", sourceCode, this.opts)
        throw e;
    } finally{
        this._compilations.delete(sch);
    }
}
module.exports.compileSchema = $2aa5667128142e8e$var$compileSchema;
function $2aa5667128142e8e$var$resolveRef(root, baseId, ref) {
    var _a;
    ref = (0, $fYjY5.resolveUrl)(this.opts.uriResolver, baseId, ref);
    const schOrFunc = root.refs[ref];
    if (schOrFunc) return schOrFunc;
    let _sch = $2aa5667128142e8e$var$resolve.call(this, root, ref);
    if (_sch === undefined) {
        const schema = (_a = root.localRefs) === null || _a === void 0 ? void 0 : _a[ref]; // TODO maybe localRefs should hold SchemaEnv
        const { schemaId: schemaId } = this.opts;
        if (schema) _sch = new $2aa5667128142e8e$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    if (_sch === undefined) return;
    return root.refs[ref] = $2aa5667128142e8e$var$inlineOrCompile.call(this, _sch);
}
module.exports.resolveRef = $2aa5667128142e8e$var$resolveRef;
function $2aa5667128142e8e$var$inlineOrCompile(sch) {
    if ((0, $fYjY5.inlineRef)(sch.schema, this.opts.inlineRefs)) return sch.schema;
    return sch.validate ? sch : $2aa5667128142e8e$var$compileSchema.call(this, sch);
}
// Index of schema compilation in the currently compiled list
function $2aa5667128142e8e$var$getCompilingSchema(schEnv) {
    for (const sch of this._compilations){
        if ($2aa5667128142e8e$var$sameSchemaEnv(sch, schEnv)) return sch;
    }
}
module.exports.getCompilingSchema = $2aa5667128142e8e$var$getCompilingSchema;
function $2aa5667128142e8e$var$sameSchemaEnv(s1, s2) {
    return s1.schema === s2.schema && s1.root === s2.root && s1.baseId === s2.baseId;
}
// resolve and compile the references ($ref)
// TODO returns AnySchemaObject (if the schema can be inlined) or validation function
function $2aa5667128142e8e$var$resolve(root, ref // reference to resolve
) {
    let sch;
    while(typeof (sch = this.refs[ref]) == "string")ref = sch;
    return sch || this.schemas[ref] || $2aa5667128142e8e$var$resolveSchema.call(this, root, ref);
}
// Resolve schema, its root and baseId
function $2aa5667128142e8e$var$resolveSchema(root, ref // reference to resolve
) {
    const p = this.opts.uriResolver.parse(ref);
    const refPath = (0, $fYjY5._getFullPath)(this.opts.uriResolver, p);
    let baseId = (0, $fYjY5.getFullPath)(this.opts.uriResolver, root.baseId, undefined);
    // TODO `Object.keys(root.schema).length > 0` should not be needed - but removing breaks 2 tests
    if (Object.keys(root.schema).length > 0 && refPath === baseId) return $2aa5667128142e8e$var$getJsonPointer.call(this, p, root);
    const id = (0, $fYjY5.normalizeId)(refPath);
    const schOrRef = this.refs[id] || this.schemas[id];
    if (typeof schOrRef == "string") {
        const sch = $2aa5667128142e8e$var$resolveSchema.call(this, root, schOrRef);
        if (typeof (sch === null || sch === void 0 ? void 0 : sch.schema) !== "object") return;
        return $2aa5667128142e8e$var$getJsonPointer.call(this, p, sch);
    }
    if (typeof (schOrRef === null || schOrRef === void 0 ? void 0 : schOrRef.schema) !== "object") return;
    if (!schOrRef.validate) $2aa5667128142e8e$var$compileSchema.call(this, schOrRef);
    if (id === (0, $fYjY5.normalizeId)(ref)) {
        const { schema: schema } = schOrRef;
        const { schemaId: schemaId } = this.opts;
        const schId = schema[schemaId];
        if (schId) baseId = (0, $fYjY5.resolveUrl)(this.opts.uriResolver, baseId, schId);
        return new $2aa5667128142e8e$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    return $2aa5667128142e8e$var$getJsonPointer.call(this, p, schOrRef);
}
module.exports.resolveSchema = $2aa5667128142e8e$var$resolveSchema;
const $2aa5667128142e8e$var$PREVENT_SCOPE_CHANGE = new Set([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions"
]);
function $2aa5667128142e8e$var$getJsonPointer(parsedRef, { baseId: baseId, schema: schema, root: root }) {
    var _a;
    if (((_a = parsedRef.fragment) === null || _a === void 0 ? void 0 : _a[0]) !== "/") return;
    for (const part of parsedRef.fragment.slice(1).split("/")){
        if (typeof schema === "boolean") return;
        const partSchema = schema[(0, $1YrfU.unescapeFragment)(part)];
        if (partSchema === undefined) return;
        schema = partSchema;
        // TODO PREVENT_SCOPE_CHANGE could be defined in keyword def?
        const schId = typeof schema === "object" && schema[this.opts.schemaId];
        if (!$2aa5667128142e8e$var$PREVENT_SCOPE_CHANGE.has(part) && schId) baseId = (0, $fYjY5.resolveUrl)(this.opts.uriResolver, baseId, schId);
    }
    let env;
    if (typeof schema != "boolean" && schema.$ref && !(0, $1YrfU.schemaHasRulesButRef)(schema, this.RULES)) {
        const $ref = (0, $fYjY5.resolveUrl)(this.opts.uriResolver, baseId, schema.$ref);
        env = $2aa5667128142e8e$var$resolveSchema.call(this, root, $ref);
    }
    // even though resolution failed we need to return SchemaEnv to throw exception
    // so that compileAsync loads missing schema.
    const { schemaId: schemaId } = this.opts;
    env = env || new $2aa5667128142e8e$var$SchemaEnv({
        schema: schema,
        schemaId: schemaId,
        root: root,
        baseId: baseId
    });
    if (env.schema !== env.root.schema) return env;
    return undefined;
}

});

parcelRegister("qniTE", function(module, exports) {
module.exports = JSON.parse("{\"$id\":\"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#\",\"description\":\"Meta-schema for $data reference (JSON AnySchema extension proposal)\",\"type\":\"object\",\"required\":[\"$data\"],\"properties\":{\"$data\":{\"type\":\"string\",\"anyOf\":[{\"format\":\"relative-json-pointer\"},{\"format\":\"json-pointer\"}]}},\"additionalProperties\":false}");

});

parcelRegister("7f6py", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9C0cr = parcelRequire("9C0cr");
$9C0cr.code = 'require("ajv/dist/runtime/uri").default';
module.exports.default = $9C0cr;

});


parcelRegister("5CtCa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jvMSz = parcelRequire("jvMSz");

var $iTl2l = parcelRequire("iTl2l");

var $6f1fx = parcelRequire("6f1fx");

var $bdvVd = parcelRequire("bdvVd");

var $cr0zX = parcelRequire("cr0zX");
const $4177792f4a045cba$var$draft7Vocabularies = [
    $jvMSz.default,
    $iTl2l.default,
    (0, $6f1fx.default)(),
    $bdvVd.default,
    $cr0zX.metadataVocabulary,
    $cr0zX.contentVocabulary
];
module.exports.default = $4177792f4a045cba$var$draft7Vocabularies;

});
parcelRegister("jvMSz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $i3jsW = parcelRequire("i3jsW");

var $19v7K = parcelRequire("19v7K");
const $e346d3f6507fca53$var$core = [
    "$schema",
    "$id",
    "$defs",
    "$vocabulary",
    {
        keyword: "$comment"
    },
    "definitions",
    $i3jsW.default,
    $19v7K.default
];
module.exports.default = $e346d3f6507fca53$var$core;

});
parcelRegister("i3jsW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $d2479b4fcf44bcb4$var$def = {
    keyword: "id",
    code () {
        throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
    }
};
module.exports.default = $d2479b4fcf44bcb4$var$def;

});

parcelRegister("19v7K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.callRef = module.exports.getValidate = void 0;

var $fAM6G = parcelRequire("fAM6G");

var $fKxAw = parcelRequire("fKxAw");

var $dUnzg = parcelRequire("dUnzg");

var $3tbeu = parcelRequire("3tbeu");

var $3F0fZ = parcelRequire("3F0fZ");

var $1YrfU = parcelRequire("1YrfU");
const $0d6ec64d64879bc8$var$def = {
    keyword: "$ref",
    schemaType: "string",
    code (cxt) {
        const { gen: gen, schema: $ref, it: it } = cxt;
        const { baseId: baseId, schemaEnv: env, validateName: validateName, opts: opts, self: self } = it;
        const { root: root } = env;
        if (($ref === "#" || $ref === "#/") && baseId === root.baseId) return callRootRef();
        const schOrEnv = $3F0fZ.resolveRef.call(self, root, baseId, $ref);
        if (schOrEnv === undefined) throw new $fAM6G.default(it.opts.uriResolver, baseId, $ref);
        if (schOrEnv instanceof $3F0fZ.SchemaEnv) return callValidate(schOrEnv);
        return inlineRefSchema(schOrEnv);
        function callRootRef() {
            if (env === root) return $0d6ec64d64879bc8$var$callRef(cxt, validateName, env, env.$async);
            const rootName = gen.scopeValue("root", {
                ref: root
            });
            return $0d6ec64d64879bc8$var$callRef(cxt, (0, $dUnzg._)`${rootName}.validate`, root, root.$async);
        }
        function callValidate(sch) {
            const v = $0d6ec64d64879bc8$var$getValidate(cxt, sch);
            $0d6ec64d64879bc8$var$callRef(cxt, v, sch, sch.$async);
        }
        function inlineRefSchema(sch) {
            const schName = gen.scopeValue("schema", opts.code.source === true ? {
                ref: sch,
                code: (0, $dUnzg.stringify)(sch)
            } : {
                ref: sch
            });
            const valid = gen.name("valid");
            const schCxt = cxt.subschema({
                schema: sch,
                dataTypes: [],
                schemaPath: $dUnzg.nil,
                topSchemaRef: schName,
                errSchemaPath: $ref
            }, valid);
            cxt.mergeEvaluated(schCxt);
            cxt.ok(valid);
        }
    }
};
function $0d6ec64d64879bc8$var$getValidate(cxt, sch) {
    const { gen: gen } = cxt;
    return sch.validate ? gen.scopeValue("validate", {
        ref: sch.validate
    }) : (0, $dUnzg._)`${gen.scopeValue("wrapper", {
        ref: sch
    })}.validate`;
}
module.exports.getValidate = $0d6ec64d64879bc8$var$getValidate;
function $0d6ec64d64879bc8$var$callRef(cxt, v, sch, $async) {
    const { gen: gen, it: it } = cxt;
    const { allErrors: allErrors, schemaEnv: env, opts: opts } = it;
    const passCxt = opts.passContext ? $3tbeu.default.this : $dUnzg.nil;
    if ($async) callAsyncRef();
    else callSyncRef();
    function callAsyncRef() {
        if (!env.$async) throw new Error("async schema referenced by sync schema");
        const valid = gen.let("valid");
        gen.try(()=>{
            gen.code((0, $dUnzg._)`await ${(0, $fKxAw.callValidateCode)(cxt, v, passCxt)}`);
            addEvaluatedFrom(v); // TODO will not work with async, it has to be returned with the result
            if (!allErrors) gen.assign(valid, true);
        }, (e)=>{
            gen.if((0, $dUnzg._)`!(${e} instanceof ${it.ValidationError})`, ()=>gen.throw(e));
            addErrorsFrom(e);
            if (!allErrors) gen.assign(valid, false);
        });
        cxt.ok(valid);
    }
    function callSyncRef() {
        cxt.result((0, $fKxAw.callValidateCode)(cxt, v, passCxt), ()=>addEvaluatedFrom(v), ()=>addErrorsFrom(v));
    }
    function addErrorsFrom(source) {
        const errs = (0, $dUnzg._)`${source}.errors`;
        gen.assign($3tbeu.default.vErrors, (0, $dUnzg._)`${$3tbeu.default.vErrors} === null ? ${errs} : ${$3tbeu.default.vErrors}.concat(${errs})`); // TODO tagged
        gen.assign($3tbeu.default.errors, (0, $dUnzg._)`${$3tbeu.default.vErrors}.length`);
    }
    function addEvaluatedFrom(source) {
        var _a;
        if (!it.opts.unevaluated) return;
        const schEvaluated = (_a = sch === null || sch === void 0 ? void 0 : sch.validate) === null || _a === void 0 ? void 0 : _a.evaluated;
        // TODO refactor
        if (it.props !== true) {
            if (schEvaluated && !schEvaluated.dynamicProps) {
                if (schEvaluated.props !== undefined) it.props = $1YrfU.mergeEvaluated.props(gen, schEvaluated.props, it.props);
            } else {
                const props = gen.var("props", (0, $dUnzg._)`${source}.evaluated.props`);
                it.props = $1YrfU.mergeEvaluated.props(gen, props, it.props, $dUnzg.Name);
            }
        }
        if (it.items !== true) {
            if (schEvaluated && !schEvaluated.dynamicItems) {
                if (schEvaluated.items !== undefined) it.items = $1YrfU.mergeEvaluated.items(gen, schEvaluated.items, it.items);
            } else {
                const items = gen.var("items", (0, $dUnzg._)`${source}.evaluated.items`);
                it.items = $1YrfU.mergeEvaluated.items(gen, items, it.items, $dUnzg.Name);
            }
        }
    }
}
module.exports.callRef = $0d6ec64d64879bc8$var$callRef;
module.exports.default = $0d6ec64d64879bc8$var$def;

});


parcelRegister("iTl2l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bTBZk = parcelRequire("bTBZk");

var $4k03q = parcelRequire("4k03q");

var $4FqTS = parcelRequire("4FqTS");

var $7Sa8B = parcelRequire("7Sa8B");

var $c7r7c = parcelRequire("c7r7c");

var $78yPo = parcelRequire("78yPo");

var $gCCB3 = parcelRequire("gCCB3");

var $h2flJ = parcelRequire("h2flJ");

var $1dk1t = parcelRequire("1dk1t");

var $j8twU = parcelRequire("j8twU");
const $038c9b96d57311f1$var$validation = [
    // number
    $bTBZk.default,
    $4k03q.default,
    // string
    $4FqTS.default,
    $7Sa8B.default,
    // object
    $c7r7c.default,
    $78yPo.default,
    // array
    $gCCB3.default,
    $h2flJ.default,
    // any
    {
        keyword: "type",
        schemaType: [
            "string",
            "array"
        ]
    },
    {
        keyword: "nullable",
        schemaType: "boolean"
    },
    $1dk1t.default,
    $j8twU.default
];
module.exports.default = $038c9b96d57311f1$var$validation;

});
parcelRegister("bTBZk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dUnzg = parcelRequire("dUnzg");
const $8a924c6999297a43$var$ops = $dUnzg.operators;
const $8a924c6999297a43$var$KWDs = {
    maximum: {
        okStr: "<=",
        ok: $8a924c6999297a43$var$ops.LTE,
        fail: $8a924c6999297a43$var$ops.GT
    },
    minimum: {
        okStr: ">=",
        ok: $8a924c6999297a43$var$ops.GTE,
        fail: $8a924c6999297a43$var$ops.LT
    },
    exclusiveMaximum: {
        okStr: "<",
        ok: $8a924c6999297a43$var$ops.LT,
        fail: $8a924c6999297a43$var$ops.GTE
    },
    exclusiveMinimum: {
        okStr: ">",
        ok: $8a924c6999297a43$var$ops.GT,
        fail: $8a924c6999297a43$var$ops.LTE
    }
};
const $8a924c6999297a43$var$error = {
    message: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $dUnzg.str)`must be ${$8a924c6999297a43$var$KWDs[keyword].okStr} ${schemaCode}`,
    params: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $dUnzg._)`{comparison: ${$8a924c6999297a43$var$KWDs[keyword].okStr}, limit: ${schemaCode}}`
};
const $8a924c6999297a43$var$def = {
    keyword: Object.keys($8a924c6999297a43$var$KWDs),
    type: "number",
    schemaType: "number",
    $data: true,
    error: $8a924c6999297a43$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        cxt.fail$data((0, $dUnzg._)`${data} ${$8a924c6999297a43$var$KWDs[keyword].fail} ${schemaCode} || isNaN(${data})`);
    }
};
module.exports.default = $8a924c6999297a43$var$def;

});

parcelRegister("4k03q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dUnzg = parcelRequire("dUnzg");
const $325912706e0c9c35$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $dUnzg.str)`must be multiple of ${schemaCode}`,
    params: ({ schemaCode: schemaCode })=>(0, $dUnzg._)`{multipleOf: ${schemaCode}}`
};
const $325912706e0c9c35$var$def = {
    keyword: "multipleOf",
    type: "number",
    schemaType: "number",
    $data: true,
    error: $325912706e0c9c35$var$error,
    code (cxt) {
        const { gen: gen, data: data, schemaCode: schemaCode, it: it } = cxt;
        // const bdt = bad$DataType(schemaCode, <string>def.schemaType, $data)
        const prec = it.opts.multipleOfPrecision;
        const res = gen.let("res");
        const invalid = prec ? (0, $dUnzg._)`Math.abs(Math.round(${res}) - ${res}) > 1e-${prec}` : (0, $dUnzg._)`${res} !== parseInt(${res})`;
        cxt.fail$data((0, $dUnzg._)`(${schemaCode} === 0 || (${res} = ${data}/${schemaCode}, ${invalid}))`);
    }
};
module.exports.default = $325912706e0c9c35$var$def;

});

parcelRegister("4FqTS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");

var $ez8v2 = parcelRequire("ez8v2");
const $365fdb91650c81b3$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxLength" ? "more" : "fewer";
        return (0, $dUnzg.str)`must NOT have ${comp} than ${schemaCode} characters`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $dUnzg._)`{limit: ${schemaCode}}`
};
const $365fdb91650c81b3$var$def = {
    keyword: [
        "maxLength",
        "minLength"
    ],
    type: "string",
    schemaType: "number",
    $data: true,
    error: $365fdb91650c81b3$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode, it: it } = cxt;
        const op = keyword === "maxLength" ? $dUnzg.operators.GT : $dUnzg.operators.LT;
        const len = it.opts.unicode === false ? (0, $dUnzg._)`${data}.length` : (0, $dUnzg._)`${(0, $1YrfU.useFunc)(cxt.gen, $ez8v2.default)}(${data})`;
        cxt.fail$data((0, $dUnzg._)`${len} ${op} ${schemaCode}`);
    }
};
module.exports.default = $365fdb91650c81b3$var$def;

});
parcelRegister("ez8v2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
function $a9aaed6de9f0e793$var$ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while(pos < len){
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            // high surrogate, and there is a next character
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00) pos++; // low surrogate
        }
    }
    return length;
}
module.exports.default = $a9aaed6de9f0e793$var$ucs2length;
$a9aaed6de9f0e793$var$ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';

});


parcelRegister("7Sa8B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKxAw = parcelRequire("fKxAw");

var $1YrfU = parcelRequire("1YrfU");

var $dUnzg = parcelRequire("dUnzg");
const $5bb570af6fb7f2c2$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $dUnzg.str)`must match pattern "${schemaCode}"`,
    params: ({ schemaCode: schemaCode })=>(0, $dUnzg._)`{pattern: ${schemaCode}}`
};
const $5bb570af6fb7f2c2$var$def = {
    keyword: "pattern",
    type: "string",
    schemaType: "string",
    $data: true,
    error: $5bb570af6fb7f2c2$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        const u = it.opts.unicodeRegExp ? "u" : "";
        if ($data) {
            const { regExp: regExp } = it.opts.code;
            const regExpCode = regExp.code === "new RegExp" ? (0, $dUnzg._)`new RegExp` : (0, $1YrfU.useFunc)(gen, regExp);
            const valid = gen.let("valid");
            gen.try(()=>gen.assign(valid, (0, $dUnzg._)`${regExpCode}(${schemaCode}, ${u}).test(${data})`), ()=>gen.assign(valid, false));
            cxt.fail$data((0, $dUnzg._)`!${valid}`);
        } else {
            const regExp = (0, $fKxAw.usePattern)(cxt, schema);
            cxt.fail$data((0, $dUnzg._)`!${regExp}.test(${data})`);
        }
    }
};
module.exports.default = $5bb570af6fb7f2c2$var$def;

});

parcelRegister("c7r7c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dUnzg = parcelRequire("dUnzg");
const $8d2b2bf5803a82c1$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxProperties" ? "more" : "fewer";
        return (0, $dUnzg.str)`must NOT have ${comp} than ${schemaCode} properties`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $dUnzg._)`{limit: ${schemaCode}}`
};
const $8d2b2bf5803a82c1$var$def = {
    keyword: [
        "maxProperties",
        "minProperties"
    ],
    type: "object",
    schemaType: "number",
    $data: true,
    error: $8d2b2bf5803a82c1$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        const op = keyword === "maxProperties" ? $dUnzg.operators.GT : $dUnzg.operators.LT;
        cxt.fail$data((0, $dUnzg._)`Object.keys(${data}).length ${op} ${schemaCode}`);
    }
};
module.exports.default = $8d2b2bf5803a82c1$var$def;

});

parcelRegister("78yPo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKxAw = parcelRequire("fKxAw");

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");
const $53244bdbd86edce7$var$error = {
    message: ({ params: { missingProperty: missingProperty } })=>(0, $dUnzg.str)`must have required property '${missingProperty}'`,
    params: ({ params: { missingProperty: missingProperty } })=>(0, $dUnzg._)`{missingProperty: ${missingProperty}}`
};
const $53244bdbd86edce7$var$def = {
    keyword: "required",
    type: "object",
    schemaType: "array",
    $data: true,
    error: $53244bdbd86edce7$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, schemaCode: schemaCode, data: data, $data: $data, it: it } = cxt;
        const { opts: opts } = it;
        if (!$data && schema.length === 0) return;
        const useLoop = schema.length >= opts.loopRequired;
        if (it.allErrors) allErrorsMode();
        else exitOnErrorMode();
        if (opts.strictRequired) {
            const props = cxt.parentSchema.properties;
            const { definedProperties: definedProperties } = cxt.it;
            for (const requiredKey of schema)if ((props === null || props === void 0 ? void 0 : props[requiredKey]) === undefined && !definedProperties.has(requiredKey)) {
                const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
                const msg = `required property "${requiredKey}" is not defined at "${schemaPath}" (strictRequired)`;
                (0, $1YrfU.checkStrictMode)(it, msg, it.opts.strictRequired);
            }
        }
        function allErrorsMode() {
            if (useLoop || $data) cxt.block$data($dUnzg.nil, loopAllRequired);
            else for (const prop of schema)(0, $fKxAw.checkReportMissingProp)(cxt, prop);
        }
        function exitOnErrorMode() {
            const missing = gen.let("missing");
            if (useLoop || $data) {
                const valid = gen.let("valid", true);
                cxt.block$data(valid, ()=>loopUntilMissing(missing, valid));
                cxt.ok(valid);
            } else {
                gen.if((0, $fKxAw.checkMissingProp)(cxt, schema, missing));
                (0, $fKxAw.reportMissingProp)(cxt, missing);
                gen.else();
            }
        }
        function loopAllRequired() {
            gen.forOf("prop", schemaCode, (prop)=>{
                cxt.setParams({
                    missingProperty: prop
                });
                gen.if((0, $fKxAw.noPropertyInData)(gen, data, prop, opts.ownProperties), ()=>cxt.error());
            });
        }
        function loopUntilMissing(missing, valid) {
            cxt.setParams({
                missingProperty: missing
            });
            gen.forOf(missing, schemaCode, ()=>{
                gen.assign(valid, (0, $fKxAw.propertyInData)(gen, data, missing, opts.ownProperties));
                gen.if((0, $dUnzg.not)(valid), ()=>{
                    cxt.error();
                    gen.break();
                });
            }, $dUnzg.nil);
        }
    }
};
module.exports.default = $53244bdbd86edce7$var$def;

});

parcelRegister("gCCB3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dUnzg = parcelRequire("dUnzg");
const $c19e227448cdffe1$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxItems" ? "more" : "fewer";
        return (0, $dUnzg.str)`must NOT have ${comp} than ${schemaCode} items`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $dUnzg._)`{limit: ${schemaCode}}`
};
const $c19e227448cdffe1$var$def = {
    keyword: [
        "maxItems",
        "minItems"
    ],
    type: "array",
    schemaType: "number",
    $data: true,
    error: $c19e227448cdffe1$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        const op = keyword === "maxItems" ? $dUnzg.operators.GT : $dUnzg.operators.LT;
        cxt.fail$data((0, $dUnzg._)`${data}.length ${op} ${schemaCode}`);
    }
};
module.exports.default = $c19e227448cdffe1$var$def;

});

parcelRegister("h2flJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $imYL4 = parcelRequire("imYL4");

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");

var $aj97E = parcelRequire("aj97E");
const $c66e87a99fbf912d$var$error = {
    message: ({ params: { i: i, j: j } })=>(0, $dUnzg.str)`must NOT have duplicate items (items ## ${j} and ${i} are identical)`,
    params: ({ params: { i: i, j: j } })=>(0, $dUnzg._)`{i: ${i}, j: ${j}}`
};
const $c66e87a99fbf912d$var$def = {
    keyword: "uniqueItems",
    type: "array",
    schemaType: "boolean",
    $data: true,
    error: $c66e87a99fbf912d$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, parentSchema: parentSchema, schemaCode: schemaCode, it: it } = cxt;
        if (!$data && !schema) return;
        const valid = gen.let("valid");
        const itemTypes = parentSchema.items ? (0, $imYL4.getSchemaTypes)(parentSchema.items) : [];
        cxt.block$data(valid, validateUniqueItems, (0, $dUnzg._)`${schemaCode} === false`);
        cxt.ok(valid);
        function validateUniqueItems() {
            const i = gen.let("i", (0, $dUnzg._)`${data}.length`);
            const j = gen.let("j");
            cxt.setParams({
                i: i,
                j: j
            });
            gen.assign(valid, true);
            gen.if((0, $dUnzg._)`${i} > 1`, ()=>(canOptimize() ? loopN : loopN2)(i, j));
        }
        function canOptimize() {
            return itemTypes.length > 0 && !itemTypes.some((t)=>t === "object" || t === "array");
        }
        function loopN(i, j) {
            const item = gen.name("item");
            const wrongType = (0, $imYL4.checkDataTypes)(itemTypes, item, it.opts.strictNumbers, $imYL4.DataType.Wrong);
            const indices = gen.const("indices", (0, $dUnzg._)`{}`);
            gen.for((0, $dUnzg._)`;${i}--;`, ()=>{
                gen.let(item, (0, $dUnzg._)`${data}[${i}]`);
                gen.if(wrongType, (0, $dUnzg._)`continue`);
                if (itemTypes.length > 1) gen.if((0, $dUnzg._)`typeof ${item} == "string"`, (0, $dUnzg._)`${item} += "_"`);
                gen.if((0, $dUnzg._)`typeof ${indices}[${item}] == "number"`, ()=>{
                    gen.assign(j, (0, $dUnzg._)`${indices}[${item}]`);
                    cxt.error();
                    gen.assign(valid, false).break();
                }).code((0, $dUnzg._)`${indices}[${item}] = ${i}`);
            });
        }
        function loopN2(i, j) {
            const eql = (0, $1YrfU.useFunc)(gen, $aj97E.default);
            const outer = gen.name("outer");
            gen.label(outer).for((0, $dUnzg._)`;${i}--;`, ()=>gen.for((0, $dUnzg._)`${j} = ${i}; ${j}--;`, ()=>gen.if((0, $dUnzg._)`${eql}(${data}[${i}], ${data}[${j}])`, ()=>{
                        cxt.error();
                        gen.assign(valid, false).break(outer);
                    })));
        }
    }
};
module.exports.default = $c66e87a99fbf912d$var$def;

});
parcelRegister("aj97E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5jHra = parcelRequire("5jHra");
$5jHra.code = 'require("ajv/dist/runtime/equal").default';
module.exports.default = $5jHra;

});


parcelRegister("1dk1t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");

var $aj97E = parcelRequire("aj97E");
const $0e268974669706ed$var$error = {
    message: "must be equal to constant",
    params: ({ schemaCode: schemaCode })=>(0, $dUnzg._)`{allowedValue: ${schemaCode}}`
};
const $0e268974669706ed$var$def = {
    keyword: "const",
    $data: true,
    error: $0e268974669706ed$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schemaCode: schemaCode, schema: schema } = cxt;
        if ($data || schema && typeof schema == "object") cxt.fail$data((0, $dUnzg._)`!${(0, $1YrfU.useFunc)(gen, $aj97E.default)}(${data}, ${schemaCode})`);
        else cxt.fail((0, $dUnzg._)`${schema} !== ${data}`);
    }
};
module.exports.default = $0e268974669706ed$var$def;

});

parcelRegister("j8twU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");

var $aj97E = parcelRequire("aj97E");
const $dee5abaa6f7d1bae$var$error = {
    message: "must be equal to one of the allowed values",
    params: ({ schemaCode: schemaCode })=>(0, $dUnzg._)`{allowedValues: ${schemaCode}}`
};
const $dee5abaa6f7d1bae$var$def = {
    keyword: "enum",
    schemaType: "array",
    $data: true,
    error: $dee5abaa6f7d1bae$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        if (!$data && schema.length === 0) throw new Error("enum must have non-empty array");
        const useLoop = schema.length >= it.opts.loopEnum;
        let eql;
        const getEql = ()=>eql !== null && eql !== void 0 ? eql : eql = (0, $1YrfU.useFunc)(gen, $aj97E.default);
        let valid;
        if (useLoop || $data) {
            valid = gen.let("valid");
            cxt.block$data(valid, loopEnum);
        } else {
            /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
            const vSchema = gen.const("vSchema", schemaCode);
            valid = (0, $dUnzg.or)(...schema.map((_x, i)=>equalCode(vSchema, i)));
        }
        cxt.pass(valid);
        function loopEnum() {
            gen.assign(valid, false);
            gen.forOf("v", schemaCode, (v)=>gen.if((0, $dUnzg._)`${getEql()}(${data}, ${v})`, ()=>gen.assign(valid, true).break()));
        }
        function equalCode(vSchema, i) {
            const sch = schema[i];
            return typeof sch === "object" && sch !== null ? (0, $dUnzg._)`${getEql()}(${data}, ${vSchema}[${i}])` : (0, $dUnzg._)`${data} === ${sch}`;
        }
    }
};
module.exports.default = $dee5abaa6f7d1bae$var$def;

});


parcelRegister("6f1fx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fltzY = parcelRequire("fltzY");

var $1K0uN = parcelRequire("1K0uN");

var $3zfVh = parcelRequire("3zfVh");

var $lM2bS = parcelRequire("lM2bS");

var $jOQgf = parcelRequire("jOQgf");

var $3FDUC = parcelRequire("3FDUC");

var $efRac = parcelRequire("efRac");

var $33ugh = parcelRequire("33ugh");

var $cMgUK = parcelRequire("cMgUK");

var $Hacxi = parcelRequire("Hacxi");

var $dp1Oo = parcelRequire("dp1Oo");

var $3ZudS = parcelRequire("3ZudS");

var $8svXU = parcelRequire("8svXU");

var $dNZSG = parcelRequire("dNZSG");

var $cYGZj = parcelRequire("cYGZj");

var $3FEB1 = parcelRequire("3FEB1");
function $48b51cf2ceea2bce$var$getApplicator(draft2020 = false) {
    const applicator = [
        // any
        $dp1Oo.default,
        $3ZudS.default,
        $8svXU.default,
        $dNZSG.default,
        $cYGZj.default,
        $3FEB1.default,
        // object
        $efRac.default,
        $33ugh.default,
        $3FDUC.default,
        $cMgUK.default,
        $Hacxi.default
    ];
    // array
    if (draft2020) applicator.push($1K0uN.default, $lM2bS.default);
    else applicator.push($fltzY.default, $3zfVh.default);
    applicator.push($jOQgf.default);
    return applicator;
}
module.exports.default = $48b51cf2ceea2bce$var$getApplicator;

});
parcelRegister("fltzY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAdditionalItems = void 0;

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");
const $b2bfc300f5b4e90d$var$error = {
    message: ({ params: { len: len } })=>(0, $dUnzg.str)`must NOT have more than ${len} items`,
    params: ({ params: { len: len } })=>(0, $dUnzg._)`{limit: ${len}}`
};
const $b2bfc300f5b4e90d$var$def = {
    keyword: "additionalItems",
    type: "array",
    schemaType: [
        "boolean",
        "object"
    ],
    before: "uniqueItems",
    error: $b2bfc300f5b4e90d$var$error,
    code (cxt) {
        const { parentSchema: parentSchema, it: it } = cxt;
        const { items: items } = parentSchema;
        if (!Array.isArray(items)) {
            (0, $1YrfU.checkStrictMode)(it, '"additionalItems" is ignored when "items" is not an array of schemas');
            return;
        }
        $b2bfc300f5b4e90d$var$validateAdditionalItems(cxt, items);
    }
};
function $b2bfc300f5b4e90d$var$validateAdditionalItems(cxt, items) {
    const { gen: gen, schema: schema, data: data, keyword: keyword, it: it } = cxt;
    it.items = true;
    const len = gen.const("len", (0, $dUnzg._)`${data}.length`);
    if (schema === false) {
        cxt.setParams({
            len: items.length
        });
        cxt.pass((0, $dUnzg._)`${len} <= ${items.length}`);
    } else if (typeof schema == "object" && !(0, $1YrfU.alwaysValidSchema)(it, schema)) {
        const valid = gen.var("valid", (0, $dUnzg._)`${len} <= ${items.length}`); // TODO var
        gen.if((0, $dUnzg.not)(valid), ()=>validateItems(valid));
        cxt.ok(valid);
    }
    function validateItems(valid) {
        gen.forRange("i", items.length, len, (i)=>{
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $1YrfU.Type.Num
            }, valid);
            if (!it.allErrors) gen.if((0, $dUnzg.not)(valid), ()=>gen.break());
        });
    }
}
module.exports.validateAdditionalItems = $b2bfc300f5b4e90d$var$validateAdditionalItems;
module.exports.default = $b2bfc300f5b4e90d$var$def;

});

parcelRegister("1K0uN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3zfVh = parcelRequire("3zfVh");
const $144a78c7e78c398d$var$def = {
    keyword: "prefixItems",
    type: "array",
    schemaType: [
        "array"
    ],
    before: "uniqueItems",
    code: (cxt)=>(0, $3zfVh.validateTuple)(cxt, "items")
};
module.exports.default = $144a78c7e78c398d$var$def;

});
parcelRegister("3zfVh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateTuple = void 0;

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");

var $fKxAw = parcelRequire("fKxAw");
const $2990fded0b2715bc$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "array",
        "boolean"
    ],
    before: "uniqueItems",
    code (cxt) {
        const { schema: schema, it: it } = cxt;
        if (Array.isArray(schema)) return $2990fded0b2715bc$var$validateTuple(cxt, "additionalItems", schema);
        it.items = true;
        if ((0, $1YrfU.alwaysValidSchema)(it, schema)) return;
        cxt.ok((0, $fKxAw.validateArray)(cxt));
    }
};
function $2990fded0b2715bc$var$validateTuple(cxt, extraItems, schArr = cxt.schema) {
    const { gen: gen, parentSchema: parentSchema, data: data, keyword: keyword, it: it } = cxt;
    checkStrictTuple(parentSchema);
    if (it.opts.unevaluated && schArr.length && it.items !== true) it.items = $1YrfU.mergeEvaluated.items(gen, schArr.length, it.items);
    const valid = gen.name("valid");
    const len = gen.const("len", (0, $dUnzg._)`${data}.length`);
    schArr.forEach((sch, i)=>{
        if ((0, $1YrfU.alwaysValidSchema)(it, sch)) return;
        gen.if((0, $dUnzg._)`${len} > ${i}`, ()=>cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                dataProp: i
            }, valid));
        cxt.ok(valid);
    });
    function checkStrictTuple(sch) {
        const { opts: opts, errSchemaPath: errSchemaPath } = it;
        const l = schArr.length;
        const fullTuple = l === sch.minItems && (l === sch.maxItems || sch[extraItems] === false);
        if (opts.strictTuples && !fullTuple) {
            const msg = `"${keyword}" is ${l}-tuple, but minItems or maxItems/${extraItems} are not specified or different at path "${errSchemaPath}"`;
            (0, $1YrfU.checkStrictMode)(it, msg, opts.strictTuples);
        }
    }
}
module.exports.validateTuple = $2990fded0b2715bc$var$validateTuple;
module.exports.default = $2990fded0b2715bc$var$def;

});


parcelRegister("lM2bS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");

var $fKxAw = parcelRequire("fKxAw");

var $fltzY = parcelRequire("fltzY");
const $fd9fc7b0798ef064$var$error = {
    message: ({ params: { len: len } })=>(0, $dUnzg.str)`must NOT have more than ${len} items`,
    params: ({ params: { len: len } })=>(0, $dUnzg._)`{limit: ${len}}`
};
const $fd9fc7b0798ef064$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    error: $fd9fc7b0798ef064$var$error,
    code (cxt) {
        const { schema: schema, parentSchema: parentSchema, it: it } = cxt;
        const { prefixItems: prefixItems } = parentSchema;
        it.items = true;
        if ((0, $1YrfU.alwaysValidSchema)(it, schema)) return;
        if (prefixItems) (0, $fltzY.validateAdditionalItems)(cxt, prefixItems);
        else cxt.ok((0, $fKxAw.validateArray)(cxt));
    }
};
module.exports.default = $fd9fc7b0798ef064$var$def;

});

parcelRegister("jOQgf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");
const $e6db39c7e98338dd$var$error = {
    message: ({ params: { min: min, max: max } })=>max === undefined ? (0, $dUnzg.str)`must contain at least ${min} valid item(s)` : (0, $dUnzg.str)`must contain at least ${min} and no more than ${max} valid item(s)`,
    params: ({ params: { min: min, max: max } })=>max === undefined ? (0, $dUnzg._)`{minContains: ${min}}` : (0, $dUnzg._)`{minContains: ${min}, maxContains: ${max}}`
};
const $e6db39c7e98338dd$var$def = {
    keyword: "contains",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    trackErrors: true,
    error: $e6db39c7e98338dd$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, it: it } = cxt;
        let min;
        let max;
        const { minContains: minContains, maxContains: maxContains } = parentSchema;
        if (it.opts.next) {
            min = minContains === undefined ? 1 : minContains;
            max = maxContains;
        } else min = 1;
        const len = gen.const("len", (0, $dUnzg._)`${data}.length`);
        cxt.setParams({
            min: min,
            max: max
        });
        if (max === undefined && min === 0) {
            (0, $1YrfU.checkStrictMode)(it, `"minContains" == 0 without "maxContains": "contains" keyword ignored`);
            return;
        }
        if (max !== undefined && min > max) {
            (0, $1YrfU.checkStrictMode)(it, `"minContains" > "maxContains" is always invalid`);
            cxt.fail();
            return;
        }
        if ((0, $1YrfU.alwaysValidSchema)(it, schema)) {
            let cond = (0, $dUnzg._)`${len} >= ${min}`;
            if (max !== undefined) cond = (0, $dUnzg._)`${cond} && ${len} <= ${max}`;
            cxt.pass(cond);
            return;
        }
        it.items = true;
        const valid = gen.name("valid");
        if (max === undefined && min === 1) validateItems(valid, ()=>gen.if(valid, ()=>gen.break()));
        else if (min === 0) {
            gen.let(valid, true);
            if (max !== undefined) gen.if((0, $dUnzg._)`${data}.length > 0`, validateItemsWithCount);
        } else {
            gen.let(valid, false);
            validateItemsWithCount();
        }
        cxt.result(valid, ()=>cxt.reset());
        function validateItemsWithCount() {
            const schValid = gen.name("_valid");
            const count = gen.let("count", 0);
            validateItems(schValid, ()=>gen.if(schValid, ()=>checkLimits(count)));
        }
        function validateItems(_valid, block) {
            gen.forRange("i", 0, len, (i)=>{
                cxt.subschema({
                    keyword: "contains",
                    dataProp: i,
                    dataPropType: $1YrfU.Type.Num,
                    compositeRule: true
                }, _valid);
                block();
            });
        }
        function checkLimits(count) {
            gen.code((0, $dUnzg._)`${count}++`);
            if (max === undefined) gen.if((0, $dUnzg._)`${count} >= ${min}`, ()=>gen.assign(valid, true).break());
            else {
                gen.if((0, $dUnzg._)`${count} > ${max}`, ()=>gen.assign(valid, false).break());
                if (min === 1) gen.assign(valid, true);
                else gen.if((0, $dUnzg._)`${count} >= ${min}`, ()=>gen.assign(valid, true));
            }
        }
    }
};
module.exports.default = $e6db39c7e98338dd$var$def;

});

parcelRegister("3FDUC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateSchemaDeps = module.exports.validatePropertyDeps = module.exports.error = void 0;

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");

var $fKxAw = parcelRequire("fKxAw");
module.exports.error = {
    message: ({ params: { property: property, depsCount: depsCount, deps: deps } })=>{
        const property_ies = depsCount === 1 ? "property" : "properties";
        return (0, $dUnzg.str)`must have ${property_ies} ${deps} when property ${property} is present`;
    },
    params: ({ params: { property: property, depsCount: depsCount, deps: deps, missingProperty: missingProperty } })=>(0, $dUnzg._)`{property: ${property},
    missingProperty: ${missingProperty},
    depsCount: ${depsCount},
    deps: ${deps}}`
};
const $2ac42925b0498af9$var$def = {
    keyword: "dependencies",
    type: "object",
    schemaType: "object",
    error: module.exports.error,
    code (cxt) {
        const [propDeps, schDeps] = $2ac42925b0498af9$var$splitDependencies(cxt);
        $2ac42925b0498af9$var$validatePropertyDeps(cxt, propDeps);
        $2ac42925b0498af9$var$validateSchemaDeps(cxt, schDeps);
    }
};
function $2ac42925b0498af9$var$splitDependencies({ schema: schema }) {
    const propertyDeps = {};
    const schemaDeps = {};
    for(const key in schema){
        if (key === "__proto__") continue;
        const deps = Array.isArray(schema[key]) ? propertyDeps : schemaDeps;
        deps[key] = schema[key];
    }
    return [
        propertyDeps,
        schemaDeps
    ];
}
function $2ac42925b0498af9$var$validatePropertyDeps(cxt, propertyDeps = cxt.schema) {
    const { gen: gen, data: data, it: it } = cxt;
    if (Object.keys(propertyDeps).length === 0) return;
    const missing = gen.let("missing");
    for(const prop in propertyDeps){
        const deps = propertyDeps[prop];
        if (deps.length === 0) continue;
        const hasProperty = (0, $fKxAw.propertyInData)(gen, data, prop, it.opts.ownProperties);
        cxt.setParams({
            property: prop,
            depsCount: deps.length,
            deps: deps.join(", ")
        });
        if (it.allErrors) gen.if(hasProperty, ()=>{
            for (const depProp of deps)(0, $fKxAw.checkReportMissingProp)(cxt, depProp);
        });
        else {
            gen.if((0, $dUnzg._)`${hasProperty} && (${(0, $fKxAw.checkMissingProp)(cxt, deps, missing)})`);
            (0, $fKxAw.reportMissingProp)(cxt, missing);
            gen.else();
        }
    }
}
module.exports.validatePropertyDeps = $2ac42925b0498af9$var$validatePropertyDeps;
function $2ac42925b0498af9$var$validateSchemaDeps(cxt, schemaDeps = cxt.schema) {
    const { gen: gen, data: data, keyword: keyword, it: it } = cxt;
    const valid = gen.name("valid");
    for(const prop in schemaDeps){
        if ((0, $1YrfU.alwaysValidSchema)(it, schemaDeps[prop])) continue;
        gen.if((0, $fKxAw.propertyInData)(gen, data, prop, it.opts.ownProperties), ()=>{
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: prop
            }, valid);
            cxt.mergeValidEvaluated(schCxt, valid);
        }, ()=>gen.var(valid, true) // TODO var
        );
        cxt.ok(valid);
    }
}
module.exports.validateSchemaDeps = $2ac42925b0498af9$var$validateSchemaDeps;
module.exports.default = $2ac42925b0498af9$var$def;

});

parcelRegister("efRac", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");
const $a60bb48edb4f4085$var$error = {
    message: "property name must be valid",
    params: ({ params: params })=>(0, $dUnzg._)`{propertyName: ${params.propertyName}}`
};
const $a60bb48edb4f4085$var$def = {
    keyword: "propertyNames",
    type: "object",
    schemaType: [
        "object",
        "boolean"
    ],
    error: $a60bb48edb4f4085$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, data: data, it: it } = cxt;
        if ((0, $1YrfU.alwaysValidSchema)(it, schema)) return;
        const valid = gen.name("valid");
        gen.forIn("key", data, (key)=>{
            cxt.setParams({
                propertyName: key
            });
            cxt.subschema({
                keyword: "propertyNames",
                data: key,
                dataTypes: [
                    "string"
                ],
                propertyName: key,
                compositeRule: true
            }, valid);
            gen.if((0, $dUnzg.not)(valid), ()=>{
                cxt.error(true);
                if (!it.allErrors) gen.break();
            });
        });
        cxt.ok(valid);
    }
};
module.exports.default = $a60bb48edb4f4085$var$def;

});

parcelRegister("33ugh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKxAw = parcelRequire("fKxAw");

var $dUnzg = parcelRequire("dUnzg");

var $3tbeu = parcelRequire("3tbeu");

var $1YrfU = parcelRequire("1YrfU");
const $2399203de0d029e2$var$error = {
    message: "must NOT have additional properties",
    params: ({ params: params })=>(0, $dUnzg._)`{additionalProperty: ${params.additionalProperty}}`
};
const $2399203de0d029e2$var$def = {
    keyword: "additionalProperties",
    type: [
        "object"
    ],
    schemaType: [
        "boolean",
        "object"
    ],
    allowUndefined: true,
    trackErrors: true,
    error: $2399203de0d029e2$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, errsCount: errsCount, it: it } = cxt;
        /* istanbul ignore if */ if (!errsCount) throw new Error("ajv implementation error");
        const { allErrors: allErrors, opts: opts } = it;
        it.props = true;
        if (opts.removeAdditional !== "all" && (0, $1YrfU.alwaysValidSchema)(it, schema)) return;
        const props = (0, $fKxAw.allSchemaProperties)(parentSchema.properties);
        const patProps = (0, $fKxAw.allSchemaProperties)(parentSchema.patternProperties);
        checkAdditionalProperties();
        cxt.ok((0, $dUnzg._)`${errsCount} === ${$3tbeu.default.errors}`);
        function checkAdditionalProperties() {
            gen.forIn("key", data, (key)=>{
                if (!props.length && !patProps.length) additionalPropertyCode(key);
                else gen.if(isAdditional(key), ()=>additionalPropertyCode(key));
            });
        }
        function isAdditional(key) {
            let definedProp;
            if (props.length > 8) {
                // TODO maybe an option instead of hard-coded 8?
                const propsSchema = (0, $1YrfU.schemaRefOrVal)(it, parentSchema.properties, "properties");
                definedProp = (0, $fKxAw.isOwnProperty)(gen, propsSchema, key);
            } else if (props.length) definedProp = (0, $dUnzg.or)(...props.map((p)=>(0, $dUnzg._)`${key} === ${p}`));
            else definedProp = $dUnzg.nil;
            if (patProps.length) definedProp = (0, $dUnzg.or)(definedProp, ...patProps.map((p)=>(0, $dUnzg._)`${(0, $fKxAw.usePattern)(cxt, p)}.test(${key})`));
            return (0, $dUnzg.not)(definedProp);
        }
        function deleteAdditional(key) {
            gen.code((0, $dUnzg._)`delete ${data}[${key}]`);
        }
        function additionalPropertyCode(key) {
            if (opts.removeAdditional === "all" || opts.removeAdditional && schema === false) {
                deleteAdditional(key);
                return;
            }
            if (schema === false) {
                cxt.setParams({
                    additionalProperty: key
                });
                cxt.error();
                if (!allErrors) gen.break();
                return;
            }
            if (typeof schema == "object" && !(0, $1YrfU.alwaysValidSchema)(it, schema)) {
                const valid = gen.name("valid");
                if (opts.removeAdditional === "failing") {
                    applyAdditionalSchema(key, valid, false);
                    gen.if((0, $dUnzg.not)(valid), ()=>{
                        cxt.reset();
                        deleteAdditional(key);
                    });
                } else {
                    applyAdditionalSchema(key, valid);
                    if (!allErrors) gen.if((0, $dUnzg.not)(valid), ()=>gen.break());
                }
            }
        }
        function applyAdditionalSchema(key, valid, errors) {
            const subschema = {
                keyword: "additionalProperties",
                dataProp: key,
                dataPropType: $1YrfU.Type.Str
            };
            if (errors === false) Object.assign(subschema, {
                compositeRule: true,
                createErrors: false,
                allErrors: false
            });
            cxt.subschema(subschema, valid);
        }
    }
};
module.exports.default = $2399203de0d029e2$var$def;

});

parcelRegister("cMgUK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1VPfM = parcelRequire("1VPfM");

var $fKxAw = parcelRequire("fKxAw");

var $1YrfU = parcelRequire("1YrfU");

var $33ugh = parcelRequire("33ugh");
const $94d71691a64fb546$var$def = {
    keyword: "properties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, it: it } = cxt;
        if (it.opts.removeAdditional === "all" && parentSchema.additionalProperties === undefined) $33ugh.default.code(new $1VPfM.KeywordCxt(it, $33ugh.default, "additionalProperties"));
        const allProps = (0, $fKxAw.allSchemaProperties)(schema);
        for (const prop of allProps)it.definedProperties.add(prop);
        if (it.opts.unevaluated && allProps.length && it.props !== true) it.props = $1YrfU.mergeEvaluated.props(gen, (0, $1YrfU.toHash)(allProps), it.props);
        const properties = allProps.filter((p)=>!(0, $1YrfU.alwaysValidSchema)(it, schema[p]));
        if (properties.length === 0) return;
        const valid = gen.name("valid");
        for (const prop of properties){
            if (hasDefault(prop)) applyPropertySchema(prop);
            else {
                gen.if((0, $fKxAw.propertyInData)(gen, data, prop, it.opts.ownProperties));
                applyPropertySchema(prop);
                if (!it.allErrors) gen.else().var(valid, true);
                gen.endIf();
            }
            cxt.it.definedProperties.add(prop);
            cxt.ok(valid);
        }
        function hasDefault(prop) {
            return it.opts.useDefaults && !it.compositeRule && schema[prop].default !== undefined;
        }
        function applyPropertySchema(prop) {
            cxt.subschema({
                keyword: "properties",
                schemaProp: prop,
                dataProp: prop
            }, valid);
        }
    }
};
module.exports.default = $94d71691a64fb546$var$def;

});

parcelRegister("Hacxi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKxAw = parcelRequire("fKxAw");

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");

var $1YrfU = parcelRequire("1YrfU");
const $081bee02eeda5d88$var$def = {
    keyword: "patternProperties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen: gen, schema: schema, data: data, parentSchema: parentSchema, it: it } = cxt;
        const { opts: opts } = it;
        const patterns = (0, $fKxAw.allSchemaProperties)(schema);
        const alwaysValidPatterns = patterns.filter((p)=>(0, $1YrfU.alwaysValidSchema)(it, schema[p]));
        if (patterns.length === 0 || alwaysValidPatterns.length === patterns.length && (!it.opts.unevaluated || it.props === true)) return;
        const checkProperties = opts.strictSchema && !opts.allowMatchingProperties && parentSchema.properties;
        const valid = gen.name("valid");
        if (it.props !== true && !(it.props instanceof $dUnzg.Name)) it.props = (0, $1YrfU.evaluatedPropsToName)(gen, it.props);
        const { props: props } = it;
        validatePatternProperties();
        function validatePatternProperties() {
            for (const pat of patterns){
                if (checkProperties) checkMatchingProperties(pat);
                if (it.allErrors) validateProperties(pat);
                else {
                    gen.var(valid, true); // TODO var
                    validateProperties(pat);
                    gen.if(valid);
                }
            }
        }
        function checkMatchingProperties(pat) {
            for(const prop in checkProperties)if (new RegExp(pat).test(prop)) (0, $1YrfU.checkStrictMode)(it, `property ${prop} matches pattern ${pat} (use allowMatchingProperties)`);
        }
        function validateProperties(pat) {
            gen.forIn("key", data, (key)=>{
                gen.if((0, $dUnzg._)`${(0, $fKxAw.usePattern)(cxt, pat)}.test(${key})`, ()=>{
                    const alwaysValid = alwaysValidPatterns.includes(pat);
                    if (!alwaysValid) cxt.subschema({
                        keyword: "patternProperties",
                        schemaProp: pat,
                        dataProp: key,
                        dataPropType: $1YrfU.Type.Str
                    }, valid);
                    if (it.opts.unevaluated && props !== true) gen.assign((0, $dUnzg._)`${props}[${key}]`, true);
                    else if (!alwaysValid && !it.allErrors) // can short-circuit if `unevaluatedProperties` is not supported (opts.next === false)
                    // or if all properties were evaluated (props === true)
                    gen.if((0, $dUnzg.not)(valid), ()=>gen.break());
                });
            });
        }
    }
};
module.exports.default = $081bee02eeda5d88$var$def;

});

parcelRegister("dp1Oo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1YrfU = parcelRequire("1YrfU");
const $9c1f03ed3aff8db6$var$def = {
    keyword: "not",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    code (cxt) {
        const { gen: gen, schema: schema, it: it } = cxt;
        if ((0, $1YrfU.alwaysValidSchema)(it, schema)) {
            cxt.fail();
            return;
        }
        const valid = gen.name("valid");
        cxt.subschema({
            keyword: "not",
            compositeRule: true,
            createErrors: false,
            allErrors: false
        }, valid);
        cxt.failResult(valid, ()=>cxt.reset(), ()=>cxt.error());
    },
    error: {
        message: "must NOT be valid"
    }
};
module.exports.default = $9c1f03ed3aff8db6$var$def;

});

parcelRegister("3ZudS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKxAw = parcelRequire("fKxAw");
const $2e7e8338ce7f2ce7$var$def = {
    keyword: "anyOf",
    schemaType: "array",
    trackErrors: true,
    code: $fKxAw.validateUnion,
    error: {
        message: "must match a schema in anyOf"
    }
};
module.exports.default = $2e7e8338ce7f2ce7$var$def;

});

parcelRegister("8svXU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");
const $6289bbeafb2562d9$var$error = {
    message: "must match exactly one schema in oneOf",
    params: ({ params: params })=>(0, $dUnzg._)`{passingSchemas: ${params.passing}}`
};
const $6289bbeafb2562d9$var$def = {
    keyword: "oneOf",
    schemaType: "array",
    trackErrors: true,
    error: $6289bbeafb2562d9$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, it: it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        if (it.opts.discriminator && parentSchema.discriminator) return;
        const schArr = schema;
        const valid = gen.let("valid", false);
        const passing = gen.let("passing", null);
        const schValid = gen.name("_valid");
        cxt.setParams({
            passing: passing
        });
        // TODO possibly fail straight away (with warning or exception) if there are two empty always valid schemas
        gen.block(validateOneOf);
        cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
        function validateOneOf() {
            schArr.forEach((sch, i)=>{
                let schCxt;
                if ((0, $1YrfU.alwaysValidSchema)(it, sch)) gen.var(schValid, true);
                else schCxt = cxt.subschema({
                    keyword: "oneOf",
                    schemaProp: i,
                    compositeRule: true
                }, schValid);
                if (i > 0) gen.if((0, $dUnzg._)`${schValid} && ${valid}`).assign(valid, false).assign(passing, (0, $dUnzg._)`[${passing}, ${i}]`).else();
                gen.if(schValid, ()=>{
                    gen.assign(valid, true);
                    gen.assign(passing, i);
                    if (schCxt) cxt.mergeEvaluated(schCxt, $dUnzg.Name);
                });
            });
        }
    }
};
module.exports.default = $6289bbeafb2562d9$var$def;

});

parcelRegister("dNZSG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1YrfU = parcelRequire("1YrfU");
const $a0cfda41e7695c8d$var$def = {
    keyword: "allOf",
    schemaType: "array",
    code (cxt) {
        const { gen: gen, schema: schema, it: it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        const valid = gen.name("valid");
        schema.forEach((sch, i)=>{
            if ((0, $1YrfU.alwaysValidSchema)(it, sch)) return;
            const schCxt = cxt.subschema({
                keyword: "allOf",
                schemaProp: i
            }, valid);
            cxt.ok(valid);
            cxt.mergeEvaluated(schCxt);
        });
    }
};
module.exports.default = $a0cfda41e7695c8d$var$def;

});

parcelRegister("cYGZj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dUnzg = parcelRequire("dUnzg");

var $1YrfU = parcelRequire("1YrfU");
const $972c6f216ab61e35$var$error = {
    message: ({ params: params })=>(0, $dUnzg.str)`must match "${params.ifClause}" schema`,
    params: ({ params: params })=>(0, $dUnzg._)`{failingKeyword: ${params.ifClause}}`
};
const $972c6f216ab61e35$var$def = {
    keyword: "if",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    error: $972c6f216ab61e35$var$error,
    code (cxt) {
        const { gen: gen, parentSchema: parentSchema, it: it } = cxt;
        if (parentSchema.then === undefined && parentSchema.else === undefined) (0, $1YrfU.checkStrictMode)(it, '"if" without "then" and "else" is ignored');
        const hasThen = $972c6f216ab61e35$var$hasSchema(it, "then");
        const hasElse = $972c6f216ab61e35$var$hasSchema(it, "else");
        if (!hasThen && !hasElse) return;
        const valid = gen.let("valid", true);
        const schValid = gen.name("_valid");
        validateIf();
        cxt.reset();
        if (hasThen && hasElse) {
            const ifClause = gen.let("ifClause");
            cxt.setParams({
                ifClause: ifClause
            });
            gen.if(schValid, validateClause("then", ifClause), validateClause("else", ifClause));
        } else if (hasThen) gen.if(schValid, validateClause("then"));
        else gen.if((0, $dUnzg.not)(schValid), validateClause("else"));
        cxt.pass(valid, ()=>cxt.error(true));
        function validateIf() {
            const schCxt = cxt.subschema({
                keyword: "if",
                compositeRule: true,
                createErrors: false,
                allErrors: false
            }, schValid);
            cxt.mergeEvaluated(schCxt);
        }
        function validateClause(keyword, ifClause) {
            return ()=>{
                const schCxt = cxt.subschema({
                    keyword: keyword
                }, schValid);
                gen.assign(valid, schValid);
                cxt.mergeValidEvaluated(schCxt, valid);
                if (ifClause) gen.assign(ifClause, (0, $dUnzg._)`${keyword}`);
                else cxt.setParams({
                    ifClause: keyword
                });
            };
        }
    }
};
function $972c6f216ab61e35$var$hasSchema(it, keyword) {
    const schema = it.schema[keyword];
    return schema !== undefined && !(0, $1YrfU.alwaysValidSchema)(it, schema);
}
module.exports.default = $972c6f216ab61e35$var$def;

});

parcelRegister("3FEB1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1YrfU = parcelRequire("1YrfU");
const $2ac4b0f55682933f$var$def = {
    keyword: [
        "then",
        "else"
    ],
    schemaType: [
        "object",
        "boolean"
    ],
    code ({ keyword: keyword, parentSchema: parentSchema, it: it }) {
        if (parentSchema.if === undefined) (0, $1YrfU.checkStrictMode)(it, `"${keyword}" without "if" is ignored`);
    }
};
module.exports.default = $2ac4b0f55682933f$var$def;

});


parcelRegister("bdvVd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6b0LS = parcelRequire("6b0LS");
const $82a9aba3f4942385$var$format = [
    $6b0LS.default
];
module.exports.default = $82a9aba3f4942385$var$format;

});
parcelRegister("6b0LS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dUnzg = parcelRequire("dUnzg");
const $47f45e5258697754$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $dUnzg.str)`must match format "${schemaCode}"`,
    params: ({ schemaCode: schemaCode })=>(0, $dUnzg._)`{format: ${schemaCode}}`
};
const $47f45e5258697754$var$def = {
    keyword: "format",
    type: [
        "number",
        "string"
    ],
    schemaType: "string",
    $data: true,
    error: $47f45e5258697754$var$error,
    code (cxt, ruleType) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        const { opts: opts, errSchemaPath: errSchemaPath, schemaEnv: schemaEnv, self: self } = it;
        if (!opts.validateFormats) return;
        if ($data) validate$DataFormat();
        else validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            const fDef = gen.const("fDef", (0, $dUnzg._)`${fmts}[${schemaCode}]`);
            const fType = gen.let("fType");
            const format = gen.let("format");
            // TODO simplify
            gen.if((0, $dUnzg._)`typeof ${fDef} == "object" && !(${fDef} instanceof RegExp)`, ()=>gen.assign(fType, (0, $dUnzg._)`${fDef}.type || "string"`).assign(format, (0, $dUnzg._)`${fDef}.validate`), ()=>gen.assign(fType, (0, $dUnzg._)`"string"`).assign(format, fDef));
            cxt.fail$data((0, $dUnzg.or)(unknownFmt(), invalidFmt()));
            function unknownFmt() {
                if (opts.strictSchema === false) return $dUnzg.nil;
                return (0, $dUnzg._)`${schemaCode} && !${format}`;
            }
            function invalidFmt() {
                const callFormat = schemaEnv.$async ? (0, $dUnzg._)`(${fDef}.async ? await ${format}(${data}) : ${format}(${data}))` : (0, $dUnzg._)`${format}(${data})`;
                const validData = (0, $dUnzg._)`(typeof ${format} == "function" ? ${callFormat} : ${format}.test(${data}))`;
                return (0, $dUnzg._)`${format} && ${format} !== true && ${fType} === ${ruleType} && !${validData}`;
            }
        }
        function validateFormat() {
            const formatDef = self.formats[schema];
            if (!formatDef) {
                unknownFormat();
                return;
            }
            if (formatDef === true) return;
            const [fmtType, format, fmtRef] = getFormat(formatDef);
            if (fmtType === ruleType) cxt.pass(validCondition());
            function unknownFormat() {
                if (opts.strictSchema === false) {
                    self.logger.warn(unknownMsg());
                    return;
                }
                throw new Error(unknownMsg());
                function unknownMsg() {
                    return `unknown format "${schema}" ignored in schema at path "${errSchemaPath}"`;
                }
            }
            function getFormat(fmtDef) {
                const code = fmtDef instanceof RegExp ? (0, $dUnzg.regexpCode)(fmtDef) : opts.code.formats ? (0, $dUnzg._)`${opts.code.formats}${(0, $dUnzg.getProperty)(schema)}` : undefined;
                const fmt = gen.scopeValue("formats", {
                    key: schema,
                    ref: fmtDef,
                    code: code
                });
                if (typeof fmtDef == "object" && !(fmtDef instanceof RegExp)) return [
                    fmtDef.type || "string",
                    fmtDef.validate,
                    (0, $dUnzg._)`${fmt}.validate`
                ];
                return [
                    "string",
                    fmtDef,
                    fmt
                ];
            }
            function validCondition() {
                if (typeof formatDef == "object" && !(formatDef instanceof RegExp) && formatDef.async) {
                    if (!schemaEnv.$async) throw new Error("async format in sync schema");
                    return (0, $dUnzg._)`await ${fmtRef}(${data})`;
                }
                return typeof format == "function" ? (0, $dUnzg._)`${fmtRef}(${data})` : (0, $dUnzg._)`${fmtRef}.test(${data})`;
            }
        }
    }
};
module.exports.default = $47f45e5258697754$var$def;

});


parcelRegister("cr0zX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.contentVocabulary = module.exports.metadataVocabulary = void 0;
module.exports.metadataVocabulary = [
    "title",
    "description",
    "default",
    "deprecated",
    "readOnly",
    "writeOnly",
    "examples"
];
module.exports.contentVocabulary = [
    "contentMediaType",
    "contentEncoding",
    "contentSchema"
];

});


parcelRegister("iwX0L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dUnzg = parcelRequire("dUnzg");

var $gARSs = parcelRequire("gARSs");

var $3F0fZ = parcelRequire("3F0fZ");

var $fAM6G = parcelRequire("fAM6G");

var $1YrfU = parcelRequire("1YrfU");
const $d7d8fd8eb12387be$var$error = {
    message: ({ params: { discrError: discrError, tagName: tagName } })=>discrError === $gARSs.DiscrError.Tag ? `tag "${tagName}" must be string` : `value of tag "${tagName}" must be in oneOf`,
    params: ({ params: { discrError: discrError, tag: tag, tagName: tagName } })=>(0, $dUnzg._)`{error: ${discrError}, tag: ${tagName}, tagValue: ${tag}}`
};
const $d7d8fd8eb12387be$var$def = {
    keyword: "discriminator",
    type: "object",
    schemaType: "object",
    error: $d7d8fd8eb12387be$var$error,
    code (cxt) {
        const { gen: gen, data: data, schema: schema, parentSchema: parentSchema, it: it } = cxt;
        const { oneOf: oneOf } = parentSchema;
        if (!it.opts.discriminator) throw new Error("discriminator: requires discriminator option");
        const tagName = schema.propertyName;
        if (typeof tagName != "string") throw new Error("discriminator: requires propertyName");
        if (schema.mapping) throw new Error("discriminator: mapping is not supported");
        if (!oneOf) throw new Error("discriminator: requires oneOf keyword");
        const valid = gen.let("valid", false);
        const tag = gen.const("tag", (0, $dUnzg._)`${data}${(0, $dUnzg.getProperty)(tagName)}`);
        gen.if((0, $dUnzg._)`typeof ${tag} == "string"`, ()=>validateMapping(), ()=>cxt.error(false, {
                discrError: $gARSs.DiscrError.Tag,
                tag: tag,
                tagName: tagName
            }));
        cxt.ok(valid);
        function validateMapping() {
            const mapping = getMapping();
            gen.if(false);
            for(const tagValue in mapping){
                gen.elseIf((0, $dUnzg._)`${tag} === ${tagValue}`);
                gen.assign(valid, applyTagSchema(mapping[tagValue]));
            }
            gen.else();
            cxt.error(false, {
                discrError: $gARSs.DiscrError.Mapping,
                tag: tag,
                tagName: tagName
            });
            gen.endIf();
        }
        function applyTagSchema(schemaProp) {
            const _valid = gen.name("valid");
            const schCxt = cxt.subschema({
                keyword: "oneOf",
                schemaProp: schemaProp
            }, _valid);
            cxt.mergeEvaluated(schCxt, $dUnzg.Name);
            return _valid;
        }
        function getMapping() {
            var _a;
            const oneOfMapping = {};
            const topRequired = hasRequired(parentSchema);
            let tagRequired = true;
            for(let i = 0; i < oneOf.length; i++){
                let sch = oneOf[i];
                if ((sch === null || sch === void 0 ? void 0 : sch.$ref) && !(0, $1YrfU.schemaHasRulesButRef)(sch, it.self.RULES)) {
                    const ref = sch.$ref;
                    sch = $3F0fZ.resolveRef.call(it.self, it.schemaEnv.root, it.baseId, ref);
                    if (sch instanceof $3F0fZ.SchemaEnv) sch = sch.schema;
                    if (sch === undefined) throw new $fAM6G.default(it.opts.uriResolver, it.baseId, ref);
                }
                const propSch = (_a = sch === null || sch === void 0 ? void 0 : sch.properties) === null || _a === void 0 ? void 0 : _a[tagName];
                if (typeof propSch != "object") throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${tagName}"`);
                tagRequired = tagRequired && (topRequired || hasRequired(sch));
                addMappings(propSch, i);
            }
            if (!tagRequired) throw new Error(`discriminator: "${tagName}" must be required`);
            return oneOfMapping;
            function hasRequired({ required: required }) {
                return Array.isArray(required) && required.includes(tagName);
            }
            function addMappings(sch, i) {
                if (sch.const) addMapping(sch.const, i);
                else if (sch.enum) for (const tagValue of sch.enum)addMapping(tagValue, i);
                else throw new Error(`discriminator: "properties/${tagName}" must have "const" or "enum"`);
            }
            function addMapping(tagValue, i) {
                if (typeof tagValue != "string" || tagValue in oneOfMapping) throw new Error(`discriminator: "${tagName}" values must be unique strings`);
                oneOfMapping[tagValue] = i;
            }
        }
    }
};
module.exports.default = $d7d8fd8eb12387be$var$def;

});
parcelRegister("gARSs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiscrError = void 0;
var $c149cd0b527f9d63$var$DiscrError;
(function(DiscrError) {
    DiscrError["Tag"] = "tag";
    DiscrError["Mapping"] = "mapping";
})($c149cd0b527f9d63$var$DiscrError || (module.exports.DiscrError = $c149cd0b527f9d63$var$DiscrError = {}));

});


parcelRegister("lgGkq", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"$id\":\"http://json-schema.org/draft-07/schema#\",\"title\":\"Core schema meta-schema\",\"definitions\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#\"}},\"nonNegativeInteger\":{\"type\":\"integer\",\"minimum\":0},\"nonNegativeIntegerDefault0\":{\"allOf\":[{\"$ref\":\"#/definitions/nonNegativeInteger\"},{\"default\":0}]},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true,\"default\":[]}},\"type\":[\"object\",\"boolean\"],\"properties\":{\"$id\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$schema\":{\"type\":\"string\",\"format\":\"uri\"},\"$ref\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$comment\":{\"type\":\"string\"},\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":true,\"readOnly\":{\"type\":\"boolean\",\"default\":false},\"examples\":{\"type\":\"array\",\"items\":true},\"multipleOf\":{\"type\":\"number\",\"exclusiveMinimum\":0},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"number\"},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"number\"},\"maxLength\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minLength\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"additionalItems\":{\"$ref\":\"#\"},\"items\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/schemaArray\"}],\"default\":true},\"maxItems\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minItems\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"contains\":{\"$ref\":\"#\"},\"maxProperties\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minProperties\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"required\":{\"$ref\":\"#/definitions/stringArray\"},\"additionalProperties\":{\"$ref\":\"#\"},\"definitions\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"propertyNames\":{\"format\":\"regex\"},\"default\":{}},\"dependencies\":{\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/stringArray\"}]}},\"propertyNames\":{\"$ref\":\"#\"},\"const\":true,\"enum\":{\"type\":\"array\",\"items\":true,\"minItems\":1,\"uniqueItems\":true},\"type\":{\"anyOf\":[{\"$ref\":\"#/definitions/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"format\":{\"type\":\"string\"},\"contentMediaType\":{\"type\":\"string\"},\"contentEncoding\":{\"type\":\"string\"},\"if\":{\"$ref\":\"#\"},\"then\":{\"$ref\":\"#\"},\"else\":{\"$ref\":\"#\"},\"allOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"anyOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"oneOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"not\":{\"$ref\":\"#\"}},\"default\":true}");

});




parcelRegister("gV9qD", function(module, exports) {
ace.define("ace/theme/dawn.css", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    module1.exports = ".ace-dawn .ace_gutter {\n  background: #ebebeb;\n  color: #333\n}\n\n.ace-dawn .ace_print-margin {\n  width: 1px;\n  background: #e8e8e8\n}\n\n.ace-dawn {\n  background-color: #F9F9F9;\n  color: #080808\n}\n\n.ace-dawn .ace_cursor {\n  color: #000000\n}\n\n.ace-dawn .ace_marker-layer .ace_selection {\n  background: rgba(39, 95, 255, 0.30)\n}\n\n.ace-dawn.ace_multiselect .ace_selection.ace_start {\n  box-shadow: 0 0 3px 0px #F9F9F9;\n}\n\n.ace-dawn .ace_marker-layer .ace_step {\n  background: rgb(255, 255, 0)\n}\n\n.ace-dawn .ace_marker-layer .ace_bracket {\n  margin: -1px 0 0 -1px;\n  border: 1px solid rgba(75, 75, 126, 0.50)\n}\n\n.ace-dawn .ace_marker-layer .ace_active-line {\n  background: rgba(36, 99, 180, 0.12)\n}\n\n.ace-dawn .ace_gutter-active-line {\n  background-color : #dcdcdc\n}\n\n.ace-dawn .ace_marker-layer .ace_selected-word {\n  border: 1px solid rgba(39, 95, 255, 0.30)\n}\n\n.ace-dawn .ace_invisible {\n  color: rgba(75, 75, 126, 0.50)\n}\n\n.ace-dawn .ace_keyword,\n.ace-dawn .ace_meta {\n  color: #794938\n}\n\n.ace-dawn .ace_constant,\n.ace-dawn .ace_constant.ace_character,\n.ace-dawn .ace_constant.ace_character.ace_escape,\n.ace-dawn .ace_constant.ace_other {\n  color: #811F24\n}\n\n.ace-dawn .ace_invalid.ace_illegal {\n  text-decoration: underline;\n  font-style: italic;\n  color: #F8F8F8;\n  background-color: #B52A1D\n}\n\n.ace-dawn .ace_invalid.ace_deprecated {\n  text-decoration: underline;\n  font-style: italic;\n  color: #B52A1D\n}\n\n.ace-dawn .ace_support {\n  color: #691C97\n}\n\n.ace-dawn .ace_support.ace_constant {\n  color: #B4371F\n}\n\n.ace-dawn .ace_fold {\n  background-color: #794938;\n  border-color: #080808\n}\n\n.ace-dawn .ace_list,\n.ace-dawn .ace_markup.ace_list,\n.ace-dawn .ace_support.ace_function {\n  color: #693A17\n}\n\n.ace-dawn .ace_storage {\n  font-style: italic;\n  color: #A71D5D\n}\n\n.ace-dawn .ace_string {\n  color: #0B6125\n}\n\n.ace-dawn .ace_string.ace_regexp {\n  color: #CF5628\n}\n\n.ace-dawn .ace_comment {\n  font-style: italic;\n  color: #5A525F\n}\n\n.ace-dawn .ace_heading,\n.ace-dawn .ace_markup.ace_heading {\n  color: #19356D\n}\n\n.ace-dawn .ace_variable {\n  color: #234A97\n}\n\n.ace-dawn .ace_indent-guide {\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAEklEQVQImWNgYGBgYLh/5+x/AAizA4hxNNsZAAAAAElFTkSuQmCC) right repeat-y\n}\n\n.ace-dawn .ace_indent-guide-active {\n  background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAZSURBVHjaYvj///9/hivKyv8BAAAA//8DACLqBhbvk+/eAAAAAElFTkSuQmCC\") right repeat-y;\n} \n";
});
ace.define("ace/theme/dawn", [
    "require",
    "exports",
    "module",
    "ace/theme/dawn.css",
    "ace/lib/dom"
], function(require, exports, module1) {
    exports.isDark = false;
    exports.cssClass = "ace-dawn";
    exports.cssText = require("./dawn.css");
    var dom = require("../lib/dom");
    dom.importCssString(exports.cssText, exports.cssClass, false);
});
(function() {
    ace.require([
        "ace/theme/dawn"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRegister("cr2NE", function(module, exports) {
'use strict';
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
module.exports = function ucs2length(str) {
    var length = 0, len = str.length, pos = 0, value;
    while(pos < len){
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xD800 && value <= 0xDBFF && pos < len) {
            // high surrogate, and there is a next character
            value = str.charCodeAt(pos);
            if ((value & 0xFC00) == 0xDC00) pos++; // low surrogate
        }
    }
    return length;
};

});

parcelRegister("amAeJ", function(module, exports) {
'use strict';
module.exports = function generate_validate(it, $keyword, $ruleType) {
    var out = '';
    var $async = it.schema.$async === true, $refKeywords = it.util.schemaHasRulesExcept(it.schema, it.RULES.all, '$ref'), $id = it.self._getId(it.schema);
    if (it.opts.strictKeywords) {
        var $unknownKwd = it.util.schemaUnknownRules(it.schema, it.RULES.keywords);
        if ($unknownKwd) {
            var $keywordsMsg = 'unknown keyword: ' + $unknownKwd;
            if (it.opts.strictKeywords === 'log') it.logger.warn($keywordsMsg);
            else throw new Error($keywordsMsg);
        }
    }
    if (it.isTop) {
        out += ' var validate = ';
        if ($async) {
            it.async = true;
            out += 'async ';
        }
        out += 'function(data, dataPath, parentData, parentDataProperty, rootData) { \'use strict\'; ';
        if ($id && (it.opts.sourceCode || it.opts.processCode)) out += ' ' + ('/\*# sourceURL=' + $id + ' */') + ' ';
    }
    if (typeof it.schema == 'boolean' || !($refKeywords || it.schema.$ref)) {
        var $keyword = 'false schema';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $errorKeyword;
        var $data = 'data' + ($dataLvl || '');
        var $valid = 'valid' + $lvl;
        if (it.schema === false) {
            if (it.isTop) $breakOnError = true;
            else out += ' var ' + $valid + ' = false; ';
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = ''; /* istanbul ignore else */ 
            if (it.createErrors !== false) {
                out += ' { keyword: \'' + ($errorKeyword || 'false schema') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
                if (it.opts.messages !== false) out += ' , message: \'boolean schema is false\' ';
                if (it.opts.verbose) out += ' , schema: false , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                out += ' } ';
            } else out += ' {} ';
            var __err = out;
            out = $$outStack.pop();
            if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                else out += ' validate.errors = [' + __err + ']; return false; ';
            } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        } else if (it.isTop) {
            if ($async) out += ' return data; ';
            else out += ' validate.errors = null; return true; ';
        } else out += ' var ' + $valid + ' = true; ';
        if (it.isTop) out += ' }; return validate; ';
        return out;
    }
    if (it.isTop) {
        var $top = it.isTop, $lvl = it.level = 0, $dataLvl = it.dataLevel = 0, $data = 'data';
        it.rootId = it.resolve.fullPath(it.self._getId(it.root.schema));
        it.baseId = it.baseId || it.rootId;
        delete it.isTop;
        it.dataPathArr = [
            ""
        ];
        if (it.schema.default !== undefined && it.opts.useDefaults && it.opts.strictDefaults) {
            var $defaultMsg = 'default is ignored in the schema root';
            if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
            else throw new Error($defaultMsg);
        }
        out += ' var vErrors = null; ';
        out += ' var errors = 0;     ';
        out += ' if (rootData === undefined) rootData = data; ';
    } else {
        var $lvl = it.level, $dataLvl = it.dataLevel, $data = 'data' + ($dataLvl || '');
        if ($id) it.baseId = it.resolve.url(it.baseId, $id);
        if ($async && !it.async) throw new Error('async schema in sync schema');
        out += ' var errs_' + $lvl + ' = errors;';
    }
    var $valid = 'valid' + $lvl, $breakOnError = !it.opts.allErrors, $closingBraces1 = '', $closingBraces2 = '';
    var $errorKeyword;
    var $typeSchema = it.schema.type, $typeIsArray = Array.isArray($typeSchema);
    if ($typeSchema && it.opts.nullable && it.schema.nullable === true) {
        if ($typeIsArray) {
            if ($typeSchema.indexOf('null') == -1) $typeSchema = $typeSchema.concat('null');
        } else if ($typeSchema != 'null') {
            $typeSchema = [
                $typeSchema,
                'null'
            ];
            $typeIsArray = true;
        }
    }
    if ($typeIsArray && $typeSchema.length == 1) {
        $typeSchema = $typeSchema[0];
        $typeIsArray = false;
    }
    if (it.schema.$ref && $refKeywords) {
        if (it.opts.extendRefs == 'fail') throw new Error('$ref: validation keywords used in schema at path "' + it.errSchemaPath + '" (see option extendRefs)');
        else if (it.opts.extendRefs !== true) {
            $refKeywords = false;
            it.logger.warn('$ref: keywords ignored in schema at path "' + it.errSchemaPath + '"');
        }
    }
    if (it.schema.$comment && it.opts.$comment) out += ' ' + it.RULES.all.$comment.code(it, '$comment');
    if ($typeSchema) {
        if (it.opts.coerceTypes) var $coerceToTypes = it.util.coerceToTypes(it.opts.coerceTypes, $typeSchema);
        var $rulesGroup = it.RULES.types[$typeSchema];
        if ($coerceToTypes || $typeIsArray || $rulesGroup === true || $rulesGroup && !$shouldUseGroup($rulesGroup)) {
            var $schemaPath = it.schemaPath + '.type', $errSchemaPath = it.errSchemaPath + '/type';
            var $schemaPath = it.schemaPath + '.type', $errSchemaPath = it.errSchemaPath + '/type', $method = $typeIsArray ? 'checkDataTypes' : 'checkDataType';
            out += ' if (' + it.util[$method]($typeSchema, $data, it.opts.strictNumbers, true) + ') { ';
            if ($coerceToTypes) {
                var $dataType = 'dataType' + $lvl, $coerced = 'coerced' + $lvl;
                out += ' var ' + $dataType + ' = typeof ' + $data + '; var ' + $coerced + ' = undefined; ';
                if (it.opts.coerceTypes == 'array') out += ' if (' + $dataType + ' == \'object\' && Array.isArray(' + $data + ') && ' + $data + '.length == 1) { ' + $data + ' = ' + $data + '[0]; ' + $dataType + ' = typeof ' + $data + '; if (' + it.util.checkDataType(it.schema.type, $data, it.opts.strictNumbers) + ') ' + $coerced + ' = ' + $data + '; } ';
                out += ' if (' + $coerced + ' !== undefined) ; ';
                var arr1 = $coerceToTypes;
                if (arr1) {
                    var $type, $i = -1, l1 = arr1.length - 1;
                    while($i < l1){
                        $type = arr1[$i += 1];
                        if ($type == 'string') out += ' else if (' + $dataType + ' == \'number\' || ' + $dataType + ' == \'boolean\') ' + $coerced + ' = \'\' + ' + $data + '; else if (' + $data + ' === null) ' + $coerced + ' = \'\'; ';
                        else if ($type == 'number' || $type == 'integer') {
                            out += ' else if (' + $dataType + ' == \'boolean\' || ' + $data + ' === null || (' + $dataType + ' == \'string\' && ' + $data + ' && ' + $data + ' == +' + $data + ' ';
                            if ($type == 'integer') out += ' && !(' + $data + ' % 1)';
                            out += ')) ' + $coerced + ' = +' + $data + '; ';
                        } else if ($type == 'boolean') out += ' else if (' + $data + ' === \'false\' || ' + $data + ' === 0 || ' + $data + ' === null) ' + $coerced + ' = false; else if (' + $data + ' === \'true\' || ' + $data + ' === 1) ' + $coerced + ' = true; ';
                        else if ($type == 'null') out += ' else if (' + $data + ' === \'\' || ' + $data + ' === 0 || ' + $data + ' === false) ' + $coerced + ' = null; ';
                        else if (it.opts.coerceTypes == 'array' && $type == 'array') out += ' else if (' + $dataType + ' == \'string\' || ' + $dataType + ' == \'number\' || ' + $dataType + ' == \'boolean\' || ' + $data + ' == null) ' + $coerced + ' = [' + $data + ']; ';
                    }
                }
                out += ' else {   ';
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ''; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { type: \'';
                    if ($typeIsArray) out += '' + $typeSchema.join(",");
                    else out += '' + $typeSchema;
                    out += '\' } ';
                    if (it.opts.messages !== false) {
                        out += ' , message: \'should be ';
                        if ($typeIsArray) out += '' + $typeSchema.join(",");
                        else out += '' + $typeSchema;
                        out += '\' ';
                    }
                    if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                    else out += ' validate.errors = [' + __err + ']; return false; ';
                } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                out += ' } if (' + $coerced + ' !== undefined) {  ';
                var $parentData = $dataLvl ? 'data' + ($dataLvl - 1 || '') : 'parentData', $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
                out += ' ' + $data + ' = ' + $coerced + '; ';
                if (!$dataLvl) out += 'if (' + $parentData + ' !== undefined)';
                out += ' ' + $parentData + '[' + $parentDataProperty + '] = ' + $coerced + '; } ';
            } else {
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ''; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { type: \'';
                    if ($typeIsArray) out += '' + $typeSchema.join(",");
                    else out += '' + $typeSchema;
                    out += '\' } ';
                    if (it.opts.messages !== false) {
                        out += ' , message: \'should be ';
                        if ($typeIsArray) out += '' + $typeSchema.join(",");
                        else out += '' + $typeSchema;
                        out += '\' ';
                    }
                    if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                    else out += ' validate.errors = [' + __err + ']; return false; ';
                } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            }
            out += ' } ';
        }
    }
    if (it.schema.$ref && !$refKeywords) {
        out += ' ' + it.RULES.all.$ref.code(it, '$ref') + ' ';
        if ($breakOnError) {
            out += ' } if (errors === ';
            if ($top) out += '0';
            else out += 'errs_' + $lvl;
            out += ') { ';
            $closingBraces2 += '}';
        }
    } else {
        var arr2 = it.RULES;
        if (arr2) {
            var $rulesGroup, i2 = -1, l2 = arr2.length - 1;
            while(i2 < l2){
                $rulesGroup = arr2[i2 += 1];
                if ($shouldUseGroup($rulesGroup)) {
                    if ($rulesGroup.type) out += ' if (' + it.util.checkDataType($rulesGroup.type, $data, it.opts.strictNumbers) + ') { ';
                    if (it.opts.useDefaults) {
                        if ($rulesGroup.type == 'object' && it.schema.properties) {
                            var $schema = it.schema.properties, $schemaKeys = Object.keys($schema);
                            var arr3 = $schemaKeys;
                            if (arr3) {
                                var $propertyKey, i3 = -1, l3 = arr3.length - 1;
                                while(i3 < l3){
                                    $propertyKey = arr3[i3 += 1];
                                    var $sch = $schema[$propertyKey];
                                    if ($sch.default !== undefined) {
                                        var $passData = $data + it.util.getProperty($propertyKey);
                                        if (it.compositeRule) {
                                            if (it.opts.strictDefaults) {
                                                var $defaultMsg = 'default is ignored for: ' + $passData;
                                                if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
                                                else throw new Error($defaultMsg);
                                            }
                                        } else {
                                            out += ' if (' + $passData + ' === undefined ';
                                            if (it.opts.useDefaults == 'empty') out += ' || ' + $passData + ' === null || ' + $passData + ' === \'\' ';
                                            out += ' ) ' + $passData + ' = ';
                                            if (it.opts.useDefaults == 'shared') out += ' ' + it.useDefault($sch.default) + ' ';
                                            else out += ' ' + JSON.stringify($sch.default) + ' ';
                                            out += '; ';
                                        }
                                    }
                                }
                            }
                        } else if ($rulesGroup.type == 'array' && Array.isArray(it.schema.items)) {
                            var arr4 = it.schema.items;
                            if (arr4) {
                                var $sch, $i = -1, l4 = arr4.length - 1;
                                while($i < l4){
                                    $sch = arr4[$i += 1];
                                    if ($sch.default !== undefined) {
                                        var $passData = $data + '[' + $i + ']';
                                        if (it.compositeRule) {
                                            if (it.opts.strictDefaults) {
                                                var $defaultMsg = 'default is ignored for: ' + $passData;
                                                if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
                                                else throw new Error($defaultMsg);
                                            }
                                        } else {
                                            out += ' if (' + $passData + ' === undefined ';
                                            if (it.opts.useDefaults == 'empty') out += ' || ' + $passData + ' === null || ' + $passData + ' === \'\' ';
                                            out += ' ) ' + $passData + ' = ';
                                            if (it.opts.useDefaults == 'shared') out += ' ' + it.useDefault($sch.default) + ' ';
                                            else out += ' ' + JSON.stringify($sch.default) + ' ';
                                            out += '; ';
                                        }
                                    }
                                }
                            }
                        }
                    }
                    var arr5 = $rulesGroup.rules;
                    if (arr5) {
                        var $rule, i5 = -1, l5 = arr5.length - 1;
                        while(i5 < l5){
                            $rule = arr5[i5 += 1];
                            if ($shouldUseRule($rule)) {
                                var $code = $rule.code(it, $rule.keyword, $rulesGroup.type);
                                if ($code) {
                                    out += ' ' + $code + ' ';
                                    if ($breakOnError) $closingBraces1 += '}';
                                }
                            }
                        }
                    }
                    if ($breakOnError) {
                        out += ' ' + $closingBraces1 + ' ';
                        $closingBraces1 = '';
                    }
                    if ($rulesGroup.type) {
                        out += ' } ';
                        if ($typeSchema && $typeSchema === $rulesGroup.type && !$coerceToTypes) {
                            out += ' else { ';
                            var $schemaPath = it.schemaPath + '.type', $errSchemaPath = it.errSchemaPath + '/type';
                            var $$outStack = $$outStack || [];
                            $$outStack.push(out);
                            out = ''; /* istanbul ignore else */ 
                            if (it.createErrors !== false) {
                                out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { type: \'';
                                if ($typeIsArray) out += '' + $typeSchema.join(",");
                                else out += '' + $typeSchema;
                                out += '\' } ';
                                if (it.opts.messages !== false) {
                                    out += ' , message: \'should be ';
                                    if ($typeIsArray) out += '' + $typeSchema.join(",");
                                    else out += '' + $typeSchema;
                                    out += '\' ';
                                }
                                if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                                out += ' } ';
                            } else out += ' {} ';
                            var __err = out;
                            out = $$outStack.pop();
                            if (!it.compositeRule && $breakOnError) {
                                /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                                else out += ' validate.errors = [' + __err + ']; return false; ';
                            } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                            out += ' } ';
                        }
                    }
                    if ($breakOnError) {
                        out += ' if (errors === ';
                        if ($top) out += '0';
                        else out += 'errs_' + $lvl;
                        out += ') { ';
                        $closingBraces2 += '}';
                    }
                }
            }
        }
    }
    if ($breakOnError) out += ' ' + $closingBraces2 + ' ';
    if ($top) {
        if ($async) {
            out += ' if (errors === 0) return data;           ';
            out += ' else throw new ValidationError(vErrors); ';
        } else {
            out += ' validate.errors = vErrors; ';
            out += ' return errors === 0;       ';
        }
        out += ' }; return validate;';
    } else out += ' var ' + $valid + ' = errors === errs_' + $lvl + ';';
    function $shouldUseGroup($rulesGroup) {
        var rules = $rulesGroup.rules;
        for(var i = 0; i < rules.length; i++)if ($shouldUseRule(rules[i])) return true;
    }
    function $shouldUseRule($rule) {
        return it.schema[$rule.keyword] !== undefined || $rule.implements && $ruleImplementsSomeKeyword($rule);
    }
    function $ruleImplementsSomeKeyword($rule) {
        var impl = $rule.implements;
        for(var i = 0; i < impl.length; i++)if (it.schema[impl[i]] !== undefined) return true;
    }
    return out;
};

});

parcelRegister("0f208", function(module, exports) {
'use strict';
module.exports = function generate_ref(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $async, $refCode;
    if ($schema == '#' || $schema == '#/') {
        if (it.isRoot) {
            $async = it.async;
            $refCode = 'validate';
        } else {
            $async = it.root.schema.$async === true;
            $refCode = 'root.refVal[0]';
        }
    } else {
        var $refVal = it.resolveRef(it.baseId, $schema, it.isRoot);
        if ($refVal === undefined) {
            var $message = it.MissingRefError.message(it.baseId, $schema);
            if (it.opts.missingRefs == 'fail') {
                it.logger.error($message);
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ''; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: '$ref' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { ref: \'' + it.util.escapeQuotes($schema) + '\' } ';
                    if (it.opts.messages !== false) out += ' , message: \'can\\\'t resolve reference ' + it.util.escapeQuotes($schema) + '\' ';
                    if (it.opts.verbose) out += ' , schema: ' + it.util.toQuotedString($schema) + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                    else out += ' validate.errors = [' + __err + ']; return false; ';
                } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                if ($breakOnError) out += ' if (false) { ';
            } else if (it.opts.missingRefs == 'ignore') {
                it.logger.warn($message);
                if ($breakOnError) out += ' if (true) { ';
            } else throw new it.MissingRefError(it.baseId, $schema, $message);
        } else if ($refVal.inline) {
            var $it = it.util.copy(it);
            $it.level++;
            var $nextValid = 'valid' + $it.level;
            $it.schema = $refVal.schema;
            $it.schemaPath = '';
            $it.errSchemaPath = $schema;
            var $code = it.validate($it).replace(/validate\.schema/g, $refVal.code);
            out += ' ' + $code + ' ';
            if ($breakOnError) out += ' if (' + $nextValid + ') { ';
        } else {
            $async = $refVal.$async === true || it.async && $refVal.$async !== false;
            $refCode = $refVal.code;
        }
    }
    if ($refCode) {
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = '';
        if (it.opts.passContext) out += ' ' + $refCode + '.call(this, ';
        else out += ' ' + $refCode + '( ';
        out += ' ' + $data + ', (dataPath || \'\')';
        if (it.errorPath != '""') out += ' + ' + it.errorPath;
        var $parentData = $dataLvl ? 'data' + ($dataLvl - 1 || '') : 'parentData', $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
        out += ' , ' + $parentData + ' , ' + $parentDataProperty + ', rootData)  ';
        var __callValidate = out;
        out = $$outStack.pop();
        if ($async) {
            if (!it.async) throw new Error('async schema referenced by sync schema');
            if ($breakOnError) out += ' var ' + $valid + '; ';
            out += ' try { await ' + __callValidate + '; ';
            if ($breakOnError) out += ' ' + $valid + ' = true; ';
            out += ' } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ';
            if ($breakOnError) out += ' ' + $valid + ' = false; ';
            out += ' } ';
            if ($breakOnError) out += ' if (' + $valid + ') { ';
        } else {
            out += ' if (!' + __callValidate + ') { if (vErrors === null) vErrors = ' + $refCode + '.errors; else vErrors = vErrors.concat(' + $refCode + '.errors); errors = vErrors.length; } ';
            if ($breakOnError) out += ' else { ';
        }
    }
    return out;
};

});

parcelRegister("2aXQw", function(module, exports) {
'use strict';
module.exports = function generate_allOf(it, $keyword, $ruleType) {
    var out = ' ';
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    var $currentBaseId = $it.baseId, $allSchemasEmpty = true;
    var arr1 = $schema;
    if (arr1) {
        var $sch, $i = -1, l1 = arr1.length - 1;
        while($i < l1){
            $sch = arr1[$i += 1];
            if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                $allSchemasEmpty = false;
                $it.schema = $sch;
                $it.schemaPath = $schemaPath + '[' + $i + ']';
                $it.errSchemaPath = $errSchemaPath + '/' + $i;
                out += '  ' + it.validate($it) + ' ';
                $it.baseId = $currentBaseId;
                if ($breakOnError) {
                    out += ' if (' + $nextValid + ') { ';
                    $closingBraces += '}';
                }
            }
        }
    }
    if ($breakOnError) {
        if ($allSchemasEmpty) out += ' if (true) { ';
        else out += ' ' + $closingBraces.slice(0, -1) + ' ';
    }
    return out;
};

});

parcelRegister("ka2ZD", function(module, exports) {
'use strict';
module.exports = function generate_anyOf(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    var $noEmptySchema = $schema.every(function($sch) {
        return it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all);
    });
    if ($noEmptySchema) {
        var $currentBaseId = $it.baseId;
        out += ' var ' + $errs + ' = errors; var ' + $valid + ' = false;  ';
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        var arr1 = $schema;
        if (arr1) {
            var $sch, $i = -1, l1 = arr1.length - 1;
            while($i < l1){
                $sch = arr1[$i += 1];
                $it.schema = $sch;
                $it.schemaPath = $schemaPath + '[' + $i + ']';
                $it.errSchemaPath = $errSchemaPath + '/' + $i;
                out += '  ' + it.validate($it) + ' ';
                $it.baseId = $currentBaseId;
                out += ' ' + $valid + ' = ' + $valid + ' || ' + $nextValid + '; if (!' + $valid + ') { ';
                $closingBraces += '}';
            }
        }
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += ' ' + $closingBraces + ' if (!' + $valid + ') {   var err =   '; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
            if (it.opts.messages !== false) out += ' , message: \'should match some schema in anyOf\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError(vErrors); ';
            else out += ' validate.errors = vErrors; return false; ';
        }
        out += ' } else {  errors = ' + $errs + '; if (vErrors !== null) { if (' + $errs + ') vErrors.length = ' + $errs + '; else vErrors = null; } ';
        if (it.opts.allErrors) out += ' } ';
    } else if ($breakOnError) out += ' if (true) { ';
    return out;
};

});

parcelRegister("dxVE0", function(module, exports) {
'use strict';
module.exports = function generate_comment(it, $keyword, $ruleType) {
    var out = ' ';
    var $schema = it.schema[$keyword];
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $comment = it.util.toQuotedString($schema);
    if (it.opts.$comment === true) out += ' console.log(' + $comment + ');';
    else if (typeof it.opts.$comment == 'function') out += ' self._opts.$comment(' + $comment + ', ' + it.util.toQuotedString($errSchemaPath) + ', validate.root.schema);';
    return out;
};

});

parcelRegister("61YI5", function(module, exports) {
'use strict';
module.exports = function generate_const(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    if (!$isData) out += ' var schema' + $lvl + ' = validate.schema' + $schemaPath + ';';
    out += 'var ' + $valid + ' = equal(' + $data + ', schema' + $lvl + '); if (!' + $valid + ') {   ';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'const' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { allowedValue: schema' + $lvl + ' } ';
        if (it.opts.messages !== false) out += ' , message: \'should be equal to constant\' ';
        if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += ' }';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("daBSX", function(module, exports) {
'use strict';
module.exports = function generate_contains(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    var $idx = 'i' + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = 'data' + $dataNxt, $currentBaseId = it.baseId, $nonEmptySchema = it.opts.strictKeywords ? typeof $schema == 'object' && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all);
    out += 'var ' + $errs + ' = errors;var ' + $valid + ';';
    if ($nonEmptySchema) {
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        out += ' var ' + $nextValid + ' = false; for (var ' + $idx + ' = 0; ' + $idx + ' < ' + $data + '.length; ' + $idx + '++) { ';
        $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
        var $passData = $data + '[' + $idx + ']';
        $it.dataPathArr[$dataNxt] = $idx;
        var $code = it.validate($it);
        $it.baseId = $currentBaseId;
        if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
        else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
        out += ' if (' + $nextValid + ') break; }  ';
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += ' ' + $closingBraces + ' if (!' + $nextValid + ') {';
    } else out += ' if (' + $data + '.length == 0) {';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'contains' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
        if (it.opts.messages !== false) out += ' , message: \'should contain a valid item\' ';
        if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += ' } else { ';
    if ($nonEmptySchema) out += '  errors = ' + $errs + '; if (vErrors !== null) { if (' + $errs + ') vErrors.length = ' + $errs + '; else vErrors = null; } ';
    if (it.opts.allErrors) out += ' } ';
    return out;
};

});

parcelRegister("bOv4z", function(module, exports) {
'use strict';
module.exports = function generate_dependencies(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    var $schemaDeps = {}, $propertyDeps = {}, $ownProperties = it.opts.ownProperties;
    for($property in $schema){
        if ($property == '__proto__') continue;
        var $sch = $schema[$property];
        var $deps = Array.isArray($sch) ? $propertyDeps : $schemaDeps;
        $deps[$property] = $sch;
    }
    out += 'var ' + $errs + ' = errors;';
    var $currentErrorPath = it.errorPath;
    out += 'var missing' + $lvl + ';';
    for(var $property in $propertyDeps){
        $deps = $propertyDeps[$property];
        if ($deps.length) {
            out += ' if ( ' + $data + it.util.getProperty($property) + ' !== undefined ';
            if ($ownProperties) out += ' && Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($property) + '\') ';
            if ($breakOnError) {
                out += ' && ( ';
                var arr1 = $deps;
                if (arr1) {
                    var $propertyKey, $i = -1, l1 = arr1.length - 1;
                    while($i < l1){
                        $propertyKey = arr1[$i += 1];
                        if ($i) out += ' || ';
                        var $prop = it.util.getProperty($propertyKey), $useData = $data + $prop;
                        out += ' ( ( ' + $useData + ' === undefined ';
                        if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                        out += ') && (missing' + $lvl + ' = ' + it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop) + ') ) ';
                    }
                }
                out += ')) {  ';
                var $propertyPath = 'missing' + $lvl, $missingProperty = '\' + ' + $propertyPath + ' + \'';
                if (it.opts._errorDataPathProperty) it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + ' + ' + $propertyPath;
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ''; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { property: \'' + it.util.escapeQuotes($property) + '\', missingProperty: \'' + $missingProperty + '\', depsCount: ' + $deps.length + ', deps: \'' + it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", ")) + '\' } ';
                    if (it.opts.messages !== false) {
                        out += ' , message: \'should have ';
                        if ($deps.length == 1) out += 'property ' + it.util.escapeQuotes($deps[0]);
                        else out += 'properties ' + it.util.escapeQuotes($deps.join(", "));
                        out += ' when property ' + it.util.escapeQuotes($property) + ' is present\' ';
                    }
                    if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                    else out += ' validate.errors = [' + __err + ']; return false; ';
                } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            } else {
                out += ' ) { ';
                var arr2 = $deps;
                if (arr2) {
                    var $propertyKey, i2 = -1, l2 = arr2.length - 1;
                    while(i2 < l2){
                        $propertyKey = arr2[i2 += 1];
                        var $prop = it.util.getProperty($propertyKey), $missingProperty = it.util.escapeQuotes($propertyKey), $useData = $data + $prop;
                        if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
                        out += ' if ( ' + $useData + ' === undefined ';
                        if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                        out += ') {  var err =   '; /* istanbul ignore else */ 
                        if (it.createErrors !== false) {
                            out += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { property: \'' + it.util.escapeQuotes($property) + '\', missingProperty: \'' + $missingProperty + '\', depsCount: ' + $deps.length + ', deps: \'' + it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", ")) + '\' } ';
                            if (it.opts.messages !== false) {
                                out += ' , message: \'should have ';
                                if ($deps.length == 1) out += 'property ' + it.util.escapeQuotes($deps[0]);
                                else out += 'properties ' + it.util.escapeQuotes($deps.join(", "));
                                out += ' when property ' + it.util.escapeQuotes($property) + ' is present\' ';
                            }
                            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                            out += ' } ';
                        } else out += ' {} ';
                        out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ';
                    }
                }
            }
            out += ' }   ';
            if ($breakOnError) {
                $closingBraces += '}';
                out += ' else { ';
            }
        }
    }
    it.errorPath = $currentErrorPath;
    var $currentBaseId = $it.baseId;
    for(var $property in $schemaDeps){
        var $sch = $schemaDeps[$property];
        if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
            out += ' ' + $nextValid + ' = true; if ( ' + $data + it.util.getProperty($property) + ' !== undefined ';
            if ($ownProperties) out += ' && Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($property) + '\') ';
            out += ') { ';
            $it.schema = $sch;
            $it.schemaPath = $schemaPath + it.util.getProperty($property);
            $it.errSchemaPath = $errSchemaPath + '/' + it.util.escapeFragment($property);
            out += '  ' + it.validate($it) + ' ';
            $it.baseId = $currentBaseId;
            out += ' }  ';
            if ($breakOnError) {
                out += ' if (' + $nextValid + ') { ';
                $closingBraces += '}';
            }
        }
    }
    if ($breakOnError) out += '   ' + $closingBraces + ' if (' + $errs + ' == errors) {';
    return out;
};

});

parcelRegister("cWg6Q", function(module, exports) {
'use strict';
module.exports = function generate_enum(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    var $i = 'i' + $lvl, $vSchema = 'schema' + $lvl;
    if (!$isData) out += ' var ' + $vSchema + ' = validate.schema' + $schemaPath + ';';
    out += 'var ' + $valid + ';';
    if ($isData) out += ' if (schema' + $lvl + ' === undefined) ' + $valid + ' = true; else if (!Array.isArray(schema' + $lvl + ')) ' + $valid + ' = false; else {';
    out += '' + $valid + ' = false;for (var ' + $i + '=0; ' + $i + '<' + $vSchema + '.length; ' + $i + '++) if (equal(' + $data + ', ' + $vSchema + '[' + $i + '])) { ' + $valid + ' = true; break; }';
    if ($isData) out += '  }  ';
    out += ' if (!' + $valid + ') {   ';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'enum' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { allowedValues: schema' + $lvl + ' } ';
        if (it.opts.messages !== false) out += ' , message: \'should be equal to one of the allowed values\' ';
        if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += ' }';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("bP8w5", function(module, exports) {
'use strict';
module.exports = function generate_format(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    if (it.opts.format === false) {
        if ($breakOnError) out += ' if (true) { ';
        return out;
    }
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    var $unknownFormats = it.opts.unknownFormats, $allowUnknown = Array.isArray($unknownFormats);
    if ($isData) {
        var $format = 'format' + $lvl, $isObject = 'isObject' + $lvl, $formatType = 'formatType' + $lvl;
        out += ' var ' + $format + ' = formats[' + $schemaValue + ']; var ' + $isObject + ' = typeof ' + $format + ' == \'object\' && !(' + $format + ' instanceof RegExp) && ' + $format + '.validate; var ' + $formatType + ' = ' + $isObject + ' && ' + $format + '.type || \'string\'; if (' + $isObject + ') { ';
        if (it.async) out += ' var async' + $lvl + ' = ' + $format + '.async; ';
        out += ' ' + $format + ' = ' + $format + '.validate; } if (  ';
        if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'string\') || ';
        out += ' (';
        if ($unknownFormats != 'ignore') {
            out += ' (' + $schemaValue + ' && !' + $format + ' ';
            if ($allowUnknown) out += ' && self._opts.unknownFormats.indexOf(' + $schemaValue + ') == -1 ';
            out += ') || ';
        }
        out += ' (' + $format + ' && ' + $formatType + ' == \'' + $ruleType + '\' && !(typeof ' + $format + ' == \'function\' ? ';
        if (it.async) out += ' (async' + $lvl + ' ? await ' + $format + '(' + $data + ') : ' + $format + '(' + $data + ')) ';
        else out += ' ' + $format + '(' + $data + ') ';
        out += ' : ' + $format + '.test(' + $data + '))))) {';
    } else {
        var $format = it.formats[$schema];
        if (!$format) {
            if ($unknownFormats == 'ignore') {
                it.logger.warn('unknown format "' + $schema + '" ignored in schema at path "' + it.errSchemaPath + '"');
                if ($breakOnError) out += ' if (true) { ';
                return out;
            } else if ($allowUnknown && $unknownFormats.indexOf($schema) >= 0) {
                if ($breakOnError) out += ' if (true) { ';
                return out;
            } else throw new Error('unknown format "' + $schema + '" is used in schema at path "' + it.errSchemaPath + '"');
        }
        var $isObject = typeof $format == 'object' && !($format instanceof RegExp) && $format.validate;
        var $formatType = $isObject && $format.type || 'string';
        if ($isObject) {
            var $async = $format.async === true;
            $format = $format.validate;
        }
        if ($formatType != $ruleType) {
            if ($breakOnError) out += ' if (true) { ';
            return out;
        }
        if ($async) {
            if (!it.async) throw new Error('async format in sync schema');
            var $formatRef = 'formats' + it.util.getProperty($schema) + '.validate';
            out += ' if (!(await ' + $formatRef + '(' + $data + '))) { ';
        } else {
            out += ' if (! ';
            var $formatRef = 'formats' + it.util.getProperty($schema);
            if ($isObject) $formatRef += '.validate';
            if (typeof $format == 'function') out += ' ' + $formatRef + '(' + $data + ') ';
            else out += ' ' + $formatRef + '.test(' + $data + ') ';
            out += ') { ';
        }
    }
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'format' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { format:  ';
        if ($isData) out += '' + $schemaValue;
        else out += '' + it.util.toQuotedString($schema);
        out += '  } ';
        if (it.opts.messages !== false) {
            out += ' , message: \'should match format "';
            if ($isData) out += '\' + ' + $schemaValue + ' + \'';
            else out += '' + it.util.escapeQuotes($schema);
            out += '"\' ';
        }
        if (it.opts.verbose) {
            out += ' , schema:  ';
            if ($isData) out += 'validate.schema' + $schemaPath;
            else out += '' + it.util.toQuotedString($schema);
            out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        }
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += ' } ';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("3TaSd", function(module, exports) {
'use strict';
module.exports = function generate_if(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    var $thenSch = it.schema['then'], $elseSch = it.schema['else'], $thenPresent = $thenSch !== undefined && (it.opts.strictKeywords ? typeof $thenSch == 'object' && Object.keys($thenSch).length > 0 || $thenSch === false : it.util.schemaHasRules($thenSch, it.RULES.all)), $elsePresent = $elseSch !== undefined && (it.opts.strictKeywords ? typeof $elseSch == 'object' && Object.keys($elseSch).length > 0 || $elseSch === false : it.util.schemaHasRules($elseSch, it.RULES.all)), $currentBaseId = $it.baseId;
    if ($thenPresent || $elsePresent) {
        var $ifClause;
        $it.createErrors = false;
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        out += ' var ' + $errs + ' = errors; var ' + $valid + ' = true;  ';
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        out += '  ' + it.validate($it) + ' ';
        $it.baseId = $currentBaseId;
        $it.createErrors = true;
        out += '  errors = ' + $errs + '; if (vErrors !== null) { if (' + $errs + ') vErrors.length = ' + $errs + '; else vErrors = null; }  ';
        it.compositeRule = $it.compositeRule = $wasComposite;
        if ($thenPresent) {
            out += ' if (' + $nextValid + ') {  ';
            $it.schema = it.schema['then'];
            $it.schemaPath = it.schemaPath + '.then';
            $it.errSchemaPath = it.errSchemaPath + '/then';
            out += '  ' + it.validate($it) + ' ';
            $it.baseId = $currentBaseId;
            out += ' ' + $valid + ' = ' + $nextValid + '; ';
            if ($thenPresent && $elsePresent) {
                $ifClause = 'ifClause' + $lvl;
                out += ' var ' + $ifClause + ' = \'then\'; ';
            } else $ifClause = '\'then\'';
            out += ' } ';
            if ($elsePresent) out += ' else { ';
        } else out += ' if (!' + $nextValid + ') { ';
        if ($elsePresent) {
            $it.schema = it.schema['else'];
            $it.schemaPath = it.schemaPath + '.else';
            $it.errSchemaPath = it.errSchemaPath + '/else';
            out += '  ' + it.validate($it) + ' ';
            $it.baseId = $currentBaseId;
            out += ' ' + $valid + ' = ' + $nextValid + '; ';
            if ($thenPresent && $elsePresent) {
                $ifClause = 'ifClause' + $lvl;
                out += ' var ' + $ifClause + ' = \'else\'; ';
            } else $ifClause = '\'else\'';
            out += ' } ';
        }
        out += ' if (!' + $valid + ') {   var err =   '; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'if' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { failingKeyword: ' + $ifClause + ' } ';
            if (it.opts.messages !== false) out += ' , message: \'should match "\' + ' + $ifClause + ' + \'" schema\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError(vErrors); ';
            else out += ' validate.errors = vErrors; return false; ';
        }
        out += ' }   ';
        if ($breakOnError) out += ' else { ';
    } else if ($breakOnError) out += ' if (true) { ';
    return out;
};

});

parcelRegister("ejmK1", function(module, exports) {
'use strict';
module.exports = function generate_items(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    var $idx = 'i' + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = 'data' + $dataNxt, $currentBaseId = it.baseId;
    out += 'var ' + $errs + ' = errors;var ' + $valid + ';';
    if (Array.isArray($schema)) {
        var $additionalItems = it.schema.additionalItems;
        if ($additionalItems === false) {
            out += ' ' + $valid + ' = ' + $data + '.length <= ' + $schema.length + '; ';
            var $currErrSchemaPath = $errSchemaPath;
            $errSchemaPath = it.errSchemaPath + '/additionalItems';
            out += '  if (!' + $valid + ') {   ';
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = ''; /* istanbul ignore else */ 
            if (it.createErrors !== false) {
                out += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { limit: ' + $schema.length + ' } ';
                if (it.opts.messages !== false) out += ' , message: \'should NOT have more than ' + $schema.length + ' items\' ';
                if (it.opts.verbose) out += ' , schema: false , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                out += ' } ';
            } else out += ' {} ';
            var __err = out;
            out = $$outStack.pop();
            if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                else out += ' validate.errors = [' + __err + ']; return false; ';
            } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            out += ' } ';
            $errSchemaPath = $currErrSchemaPath;
            if ($breakOnError) {
                $closingBraces += '}';
                out += ' else { ';
            }
        }
        var arr1 = $schema;
        if (arr1) {
            var $sch, $i = -1, l1 = arr1.length - 1;
            while($i < l1){
                $sch = arr1[$i += 1];
                if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                    out += ' ' + $nextValid + ' = true; if (' + $data + '.length > ' + $i + ') { ';
                    var $passData = $data + '[' + $i + ']';
                    $it.schema = $sch;
                    $it.schemaPath = $schemaPath + '[' + $i + ']';
                    $it.errSchemaPath = $errSchemaPath + '/' + $i;
                    $it.errorPath = it.util.getPathExpr(it.errorPath, $i, it.opts.jsonPointers, true);
                    $it.dataPathArr[$dataNxt] = $i;
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
                    else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
                    out += ' }  ';
                    if ($breakOnError) {
                        out += ' if (' + $nextValid + ') { ';
                        $closingBraces += '}';
                    }
                }
            }
        }
        if (typeof $additionalItems == 'object' && (it.opts.strictKeywords ? typeof $additionalItems == 'object' && Object.keys($additionalItems).length > 0 || $additionalItems === false : it.util.schemaHasRules($additionalItems, it.RULES.all))) {
            $it.schema = $additionalItems;
            $it.schemaPath = it.schemaPath + '.additionalItems';
            $it.errSchemaPath = it.errSchemaPath + '/additionalItems';
            out += ' ' + $nextValid + ' = true; if (' + $data + '.length > ' + $schema.length + ') {  for (var ' + $idx + ' = ' + $schema.length + '; ' + $idx + ' < ' + $data + '.length; ' + $idx + '++) { ';
            $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
            var $passData = $data + '[' + $idx + ']';
            $it.dataPathArr[$dataNxt] = $idx;
            var $code = it.validate($it);
            $it.baseId = $currentBaseId;
            if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
            else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
            if ($breakOnError) out += ' if (!' + $nextValid + ') break; ';
            out += ' } }  ';
            if ($breakOnError) {
                out += ' if (' + $nextValid + ') { ';
                $closingBraces += '}';
            }
        }
    } else if (it.opts.strictKeywords ? typeof $schema == 'object' && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all)) {
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        out += '  for (var ' + $idx + ' = ' + 0 + '; ' + $idx + ' < ' + $data + '.length; ' + $idx + '++) { ';
        $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
        var $passData = $data + '[' + $idx + ']';
        $it.dataPathArr[$dataNxt] = $idx;
        var $code = it.validate($it);
        $it.baseId = $currentBaseId;
        if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
        else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
        if ($breakOnError) out += ' if (!' + $nextValid + ') break; ';
        out += ' }';
    }
    if ($breakOnError) out += ' ' + $closingBraces + ' if (' + $errs + ' == errors) {';
    return out;
};

});

parcelRegister("ci4jj", function(module, exports) {
'use strict';
module.exports = function generate__limit(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = 'data' + ($dataLvl || '');
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    var $isMax = $keyword == 'maximum', $exclusiveKeyword = $isMax ? 'exclusiveMaximum' : 'exclusiveMinimum', $schemaExcl = it.schema[$exclusiveKeyword], $isDataExcl = it.opts.$data && $schemaExcl && $schemaExcl.$data, $op = $isMax ? '<' : '>', $notOp = $isMax ? '>' : '<', $errorKeyword = undefined;
    if (!($isData || typeof $schema == 'number' || $schema === undefined)) throw new Error($keyword + ' must be number');
    if (!($isDataExcl || $schemaExcl === undefined || typeof $schemaExcl == 'number' || typeof $schemaExcl == 'boolean')) throw new Error($exclusiveKeyword + ' must be number or boolean');
    if ($isDataExcl) {
        var $schemaValueExcl = it.util.getData($schemaExcl.$data, $dataLvl, it.dataPathArr), $exclusive = 'exclusive' + $lvl, $exclType = 'exclType' + $lvl, $exclIsNumber = 'exclIsNumber' + $lvl, $opExpr = 'op' + $lvl, $opStr = '\' + ' + $opExpr + ' + \'';
        out += ' var schemaExcl' + $lvl + ' = ' + $schemaValueExcl + '; ';
        $schemaValueExcl = 'schemaExcl' + $lvl;
        out += ' var ' + $exclusive + '; var ' + $exclType + ' = typeof ' + $schemaValueExcl + '; if (' + $exclType + ' != \'boolean\' && ' + $exclType + ' != \'undefined\' && ' + $exclType + ' != \'number\') { ';
        var $errorKeyword = $exclusiveKeyword;
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += ' { keyword: \'' + ($errorKeyword || '_exclusiveLimit') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
            if (it.opts.messages !== false) out += ' , message: \'' + $exclusiveKeyword + ' should be boolean\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        out += ' } else if ( ';
        if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
        out += ' ' + $exclType + ' == \'number\' ? ( (' + $exclusive + ' = ' + $schemaValue + ' === undefined || ' + $schemaValueExcl + ' ' + $op + '= ' + $schemaValue + ') ? ' + $data + ' ' + $notOp + '= ' + $schemaValueExcl + ' : ' + $data + ' ' + $notOp + ' ' + $schemaValue + ' ) : ( (' + $exclusive + ' = ' + $schemaValueExcl + ' === true) ? ' + $data + ' ' + $notOp + '= ' + $schemaValue + ' : ' + $data + ' ' + $notOp + ' ' + $schemaValue + ' ) || ' + $data + ' !== ' + $data + ') { var op' + $lvl + ' = ' + $exclusive + ' ? \'' + $op + '\' : \'' + $op + '=\'; ';
        if ($schema === undefined) {
            $errorKeyword = $exclusiveKeyword;
            $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
            $schemaValue = $schemaValueExcl;
            $isData = $isDataExcl;
        }
    } else {
        var $exclIsNumber = typeof $schemaExcl == 'number', $opStr = $op;
        if ($exclIsNumber && $isData) {
            var $opExpr = '\'' + $opStr + '\'';
            out += ' if ( ';
            if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
            out += ' ( ' + $schemaValue + ' === undefined || ' + $schemaExcl + ' ' + $op + '= ' + $schemaValue + ' ? ' + $data + ' ' + $notOp + '= ' + $schemaExcl + ' : ' + $data + ' ' + $notOp + ' ' + $schemaValue + ' ) || ' + $data + ' !== ' + $data + ') { ';
        } else {
            if ($exclIsNumber && $schema === undefined) {
                $exclusive = true;
                $errorKeyword = $exclusiveKeyword;
                $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
                $schemaValue = $schemaExcl;
                $notOp += '=';
            } else {
                if ($exclIsNumber) $schemaValue = Math[$isMax ? 'min' : 'max']($schemaExcl, $schema);
                if ($schemaExcl === ($exclIsNumber ? $schemaValue : true)) {
                    $exclusive = true;
                    $errorKeyword = $exclusiveKeyword;
                    $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
                    $notOp += '=';
                } else {
                    $exclusive = false;
                    $opStr += '=';
                }
            }
            var $opExpr = '\'' + $opStr + '\'';
            out += ' if ( ';
            if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
            out += ' ' + $data + ' ' + $notOp + ' ' + $schemaValue + ' || ' + $data + ' !== ' + $data + ') { ';
        }
    }
    $errorKeyword = $errorKeyword || $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += ' { keyword: \'' + ($errorKeyword || '_limit') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { comparison: ' + $opExpr + ', limit: ' + $schemaValue + ', exclusive: ' + $exclusive + ' } ';
        if (it.opts.messages !== false) {
            out += ' , message: \'should be ' + $opStr + ' ';
            if ($isData) out += '\' + ' + $schemaValue;
            else out += '' + $schemaValue + '\'';
        }
        if (it.opts.verbose) {
            out += ' , schema:  ';
            if ($isData) out += 'validate.schema' + $schemaPath;
            else out += '' + $schema;
            out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        }
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += ' } ';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("6Z7ie", function(module, exports) {
'use strict';
module.exports = function generate__limitItems(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = 'data' + ($dataLvl || '');
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    if (!($isData || typeof $schema == 'number')) throw new Error($keyword + ' must be number');
    var $op = $keyword == 'maxItems' ? '>' : '<';
    out += 'if ( ';
    if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
    out += ' ' + $data + '.length ' + $op + ' ' + $schemaValue + ') { ';
    var $errorKeyword = $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += ' { keyword: \'' + ($errorKeyword || '_limitItems') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { limit: ' + $schemaValue + ' } ';
        if (it.opts.messages !== false) {
            out += ' , message: \'should NOT have ';
            if ($keyword == 'maxItems') out += 'more';
            else out += 'fewer';
            out += ' than ';
            if ($isData) out += '\' + ' + $schemaValue + ' + \'';
            else out += '' + $schema;
            out += ' items\' ';
        }
        if (it.opts.verbose) {
            out += ' , schema:  ';
            if ($isData) out += 'validate.schema' + $schemaPath;
            else out += '' + $schema;
            out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        }
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += '} ';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("hy8Bk", function(module, exports) {
'use strict';
module.exports = function generate__limitLength(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = 'data' + ($dataLvl || '');
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    if (!($isData || typeof $schema == 'number')) throw new Error($keyword + ' must be number');
    var $op = $keyword == 'maxLength' ? '>' : '<';
    out += 'if ( ';
    if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
    if (it.opts.unicode === false) out += ' ' + $data + '.length ';
    else out += ' ucs2length(' + $data + ') ';
    out += ' ' + $op + ' ' + $schemaValue + ') { ';
    var $errorKeyword = $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += ' { keyword: \'' + ($errorKeyword || '_limitLength') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { limit: ' + $schemaValue + ' } ';
        if (it.opts.messages !== false) {
            out += ' , message: \'should NOT be ';
            if ($keyword == 'maxLength') out += 'longer';
            else out += 'shorter';
            out += ' than ';
            if ($isData) out += '\' + ' + $schemaValue + ' + \'';
            else out += '' + $schema;
            out += ' characters\' ';
        }
        if (it.opts.verbose) {
            out += ' , schema:  ';
            if ($isData) out += 'validate.schema' + $schemaPath;
            else out += '' + $schema;
            out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        }
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += '} ';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("fa2pn", function(module, exports) {
'use strict';
module.exports = function generate__limitProperties(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = 'data' + ($dataLvl || '');
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    if (!($isData || typeof $schema == 'number')) throw new Error($keyword + ' must be number');
    var $op = $keyword == 'maxProperties' ? '>' : '<';
    out += 'if ( ';
    if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
    out += ' Object.keys(' + $data + ').length ' + $op + ' ' + $schemaValue + ') { ';
    var $errorKeyword = $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += ' { keyword: \'' + ($errorKeyword || '_limitProperties') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { limit: ' + $schemaValue + ' } ';
        if (it.opts.messages !== false) {
            out += ' , message: \'should NOT have ';
            if ($keyword == 'maxProperties') out += 'more';
            else out += 'fewer';
            out += ' than ';
            if ($isData) out += '\' + ' + $schemaValue + ' + \'';
            else out += '' + $schema;
            out += ' properties\' ';
        }
        if (it.opts.verbose) {
            out += ' , schema:  ';
            if ($isData) out += 'validate.schema' + $schemaPath;
            else out += '' + $schema;
            out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        }
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += '} ';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("cNhcR", function(module, exports) {
'use strict';
module.exports = function generate_multipleOf(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    if (!($isData || typeof $schema == 'number')) throw new Error($keyword + ' must be number');
    out += 'var division' + $lvl + ';if (';
    if ($isData) out += ' ' + $schemaValue + ' !== undefined && ( typeof ' + $schemaValue + ' != \'number\' || ';
    out += ' (division' + $lvl + ' = ' + $data + ' / ' + $schemaValue + ', ';
    if (it.opts.multipleOfPrecision) out += ' Math.abs(Math.round(division' + $lvl + ') - division' + $lvl + ') > 1e-' + it.opts.multipleOfPrecision + ' ';
    else out += ' division' + $lvl + ' !== parseInt(division' + $lvl + ') ';
    out += ' ) ';
    if ($isData) out += '  )  ';
    out += ' ) {   ';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { multipleOf: ' + $schemaValue + ' } ';
        if (it.opts.messages !== false) {
            out += ' , message: \'should be multiple of ';
            if ($isData) out += '\' + ' + $schemaValue;
            else out += '' + $schemaValue + '\'';
        }
        if (it.opts.verbose) {
            out += ' , schema:  ';
            if ($isData) out += 'validate.schema' + $schemaPath;
            else out += '' + $schema;
            out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        }
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += '} ';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("2XE4Y", function(module, exports) {
'use strict';
module.exports = function generate_not(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    if (it.opts.strictKeywords ? typeof $schema == 'object' && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all)) {
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        out += ' var ' + $errs + ' = errors;  ';
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        $it.createErrors = false;
        var $allErrorsOption;
        if ($it.opts.allErrors) {
            $allErrorsOption = $it.opts.allErrors;
            $it.opts.allErrors = false;
        }
        out += ' ' + it.validate($it) + ' ';
        $it.createErrors = true;
        if ($allErrorsOption) $it.opts.allErrors = $allErrorsOption;
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += ' if (' + $nextValid + ') {   ';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'not' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
            if (it.opts.messages !== false) out += ' , message: \'should NOT be valid\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        out += ' } else {  errors = ' + $errs + '; if (vErrors !== null) { if (' + $errs + ') vErrors.length = ' + $errs + '; else vErrors = null; } ';
        if (it.opts.allErrors) out += ' } ';
    } else {
        out += '  var err =   '; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'not' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
            if (it.opts.messages !== false) out += ' , message: \'should NOT be valid\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        if ($breakOnError) out += ' if (false) { ';
    }
    return out;
};

});

parcelRegister("dBpqw", function(module, exports) {
'use strict';
module.exports = function generate_oneOf(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    var $currentBaseId = $it.baseId, $prevValid = 'prevValid' + $lvl, $passingSchemas = 'passingSchemas' + $lvl;
    out += 'var ' + $errs + ' = errors , ' + $prevValid + ' = false , ' + $valid + ' = false , ' + $passingSchemas + ' = null; ';
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var arr1 = $schema;
    if (arr1) {
        var $sch, $i = -1, l1 = arr1.length - 1;
        while($i < l1){
            $sch = arr1[$i += 1];
            if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                $it.schema = $sch;
                $it.schemaPath = $schemaPath + '[' + $i + ']';
                $it.errSchemaPath = $errSchemaPath + '/' + $i;
                out += '  ' + it.validate($it) + ' ';
                $it.baseId = $currentBaseId;
            } else out += ' var ' + $nextValid + ' = true; ';
            if ($i) {
                out += ' if (' + $nextValid + ' && ' + $prevValid + ') { ' + $valid + ' = false; ' + $passingSchemas + ' = [' + $passingSchemas + ', ' + $i + ']; } else { ';
                $closingBraces += '}';
            }
            out += ' if (' + $nextValid + ') { ' + $valid + ' = ' + $prevValid + ' = true; ' + $passingSchemas + ' = ' + $i + '; }';
        }
    }
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += '' + $closingBraces + 'if (!' + $valid + ') {   var err =   '; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { passingSchemas: ' + $passingSchemas + ' } ';
        if (it.opts.messages !== false) out += ' , message: \'should match exactly one schema in oneOf\' ';
        if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        out += ' } ';
    } else out += ' {} ';
    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError(vErrors); ';
        else out += ' validate.errors = vErrors; return false; ';
    }
    out += '} else {  errors = ' + $errs + '; if (vErrors !== null) { if (' + $errs + ') vErrors.length = ' + $errs + '; else vErrors = null; }';
    if (it.opts.allErrors) out += ' } ';
    return out;
};

});

parcelRegister("Og1VF", function(module, exports) {
'use strict';
module.exports = function generate_pattern(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    var $regexp = $isData ? '(new RegExp(' + $schemaValue + '))' : it.usePattern($schema);
    out += 'if ( ';
    if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'string\') || ';
    out += ' !' + $regexp + '.test(' + $data + ') ) {   ';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { pattern:  ';
        if ($isData) out += '' + $schemaValue;
        else out += '' + it.util.toQuotedString($schema);
        out += '  } ';
        if (it.opts.messages !== false) {
            out += ' , message: \'should match pattern "';
            if ($isData) out += '\' + ' + $schemaValue + ' + \'';
            else out += '' + it.util.escapeQuotes($schema);
            out += '"\' ';
        }
        if (it.opts.verbose) {
            out += ' , schema:  ';
            if ($isData) out += 'validate.schema' + $schemaPath;
            else out += '' + it.util.toQuotedString($schema);
            out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        }
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += '} ';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("jMG7B", function(module, exports) {
'use strict';
module.exports = function generate_properties(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    var $key = 'key' + $lvl, $idx = 'idx' + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = 'data' + $dataNxt, $dataProperties = 'dataProperties' + $lvl;
    var $schemaKeys = Object.keys($schema || {}).filter(notProto), $pProperties = it.schema.patternProperties || {}, $pPropertyKeys = Object.keys($pProperties).filter(notProto), $aProperties = it.schema.additionalProperties, $someProperties = $schemaKeys.length || $pPropertyKeys.length, $noAdditional = $aProperties === false, $additionalIsSchema = typeof $aProperties == 'object' && Object.keys($aProperties).length, $removeAdditional = it.opts.removeAdditional, $checkAdditional = $noAdditional || $additionalIsSchema || $removeAdditional, $ownProperties = it.opts.ownProperties, $currentBaseId = it.baseId;
    var $required = it.schema.required;
    if ($required && !(it.opts.$data && $required.$data) && $required.length < it.opts.loopRequired) var $requiredHash = it.util.toHash($required);
    function notProto(p) {
        return p !== '__proto__';
    }
    out += 'var ' + $errs + ' = errors;var ' + $nextValid + ' = true;';
    if ($ownProperties) out += ' var ' + $dataProperties + ' = undefined;';
    if ($checkAdditional) {
        if ($ownProperties) out += ' ' + $dataProperties + ' = ' + $dataProperties + ' || Object.keys(' + $data + '); for (var ' + $idx + '=0; ' + $idx + '<' + $dataProperties + '.length; ' + $idx + '++) { var ' + $key + ' = ' + $dataProperties + '[' + $idx + ']; ';
        else out += ' for (var ' + $key + ' in ' + $data + ') { ';
        if ($someProperties) {
            out += ' var isAdditional' + $lvl + ' = !(false ';
            if ($schemaKeys.length) {
                if ($schemaKeys.length > 8) out += ' || validate.schema' + $schemaPath + '.hasOwnProperty(' + $key + ') ';
                else {
                    var arr1 = $schemaKeys;
                    if (arr1) {
                        var $propertyKey, i1 = -1, l1 = arr1.length - 1;
                        while(i1 < l1){
                            $propertyKey = arr1[i1 += 1];
                            out += ' || ' + $key + ' == ' + it.util.toQuotedString($propertyKey) + ' ';
                        }
                    }
                }
            }
            if ($pPropertyKeys.length) {
                var arr2 = $pPropertyKeys;
                if (arr2) {
                    var $pProperty, $i = -1, l2 = arr2.length - 1;
                    while($i < l2){
                        $pProperty = arr2[$i += 1];
                        out += ' || ' + it.usePattern($pProperty) + '.test(' + $key + ') ';
                    }
                }
            }
            out += ' ); if (isAdditional' + $lvl + ') { ';
        }
        if ($removeAdditional == 'all') out += ' delete ' + $data + '[' + $key + ']; ';
        else {
            var $currentErrorPath = it.errorPath;
            var $additionalProperty = '\' + ' + $key + ' + \'';
            if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
            if ($noAdditional) {
                if ($removeAdditional) out += ' delete ' + $data + '[' + $key + ']; ';
                else {
                    out += ' ' + $nextValid + ' = false; ';
                    var $currErrSchemaPath = $errSchemaPath;
                    $errSchemaPath = it.errSchemaPath + '/additionalProperties';
                    var $$outStack = $$outStack || [];
                    $$outStack.push(out);
                    out = ''; /* istanbul ignore else */ 
                    if (it.createErrors !== false) {
                        out += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { additionalProperty: \'' + $additionalProperty + '\' } ';
                        if (it.opts.messages !== false) {
                            out += ' , message: \'';
                            if (it.opts._errorDataPathProperty) out += 'is an invalid additional property';
                            else out += 'should NOT have additional properties';
                            out += '\' ';
                        }
                        if (it.opts.verbose) out += ' , schema: false , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                        out += ' } ';
                    } else out += ' {} ';
                    var __err = out;
                    out = $$outStack.pop();
                    if (!it.compositeRule && $breakOnError) {
                        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                        else out += ' validate.errors = [' + __err + ']; return false; ';
                    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                    $errSchemaPath = $currErrSchemaPath;
                    if ($breakOnError) out += ' break; ';
                }
            } else if ($additionalIsSchema) {
                if ($removeAdditional == 'failing') {
                    out += ' var ' + $errs + ' = errors;  ';
                    var $wasComposite = it.compositeRule;
                    it.compositeRule = $it.compositeRule = true;
                    $it.schema = $aProperties;
                    $it.schemaPath = it.schemaPath + '.additionalProperties';
                    $it.errSchemaPath = it.errSchemaPath + '/additionalProperties';
                    $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
                    var $passData = $data + '[' + $key + ']';
                    $it.dataPathArr[$dataNxt] = $key;
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
                    else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
                    out += ' if (!' + $nextValid + ') { errors = ' + $errs + '; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete ' + $data + '[' + $key + ']; }  ';
                    it.compositeRule = $it.compositeRule = $wasComposite;
                } else {
                    $it.schema = $aProperties;
                    $it.schemaPath = it.schemaPath + '.additionalProperties';
                    $it.errSchemaPath = it.errSchemaPath + '/additionalProperties';
                    $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
                    var $passData = $data + '[' + $key + ']';
                    $it.dataPathArr[$dataNxt] = $key;
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
                    else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
                    if ($breakOnError) out += ' if (!' + $nextValid + ') break; ';
                }
            }
            it.errorPath = $currentErrorPath;
        }
        if ($someProperties) out += ' } ';
        out += ' }  ';
        if ($breakOnError) {
            out += ' if (' + $nextValid + ') { ';
            $closingBraces += '}';
        }
    }
    var $useDefaults = it.opts.useDefaults && !it.compositeRule;
    if ($schemaKeys.length) {
        var arr3 = $schemaKeys;
        if (arr3) {
            var $propertyKey, i3 = -1, l3 = arr3.length - 1;
            while(i3 < l3){
                $propertyKey = arr3[i3 += 1];
                var $sch = $schema[$propertyKey];
                if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                    var $prop = it.util.getProperty($propertyKey), $passData = $data + $prop, $hasDefault = $useDefaults && $sch.default !== undefined;
                    $it.schema = $sch;
                    $it.schemaPath = $schemaPath + $prop;
                    $it.errSchemaPath = $errSchemaPath + '/' + it.util.escapeFragment($propertyKey);
                    $it.errorPath = it.util.getPath(it.errorPath, $propertyKey, it.opts.jsonPointers);
                    $it.dataPathArr[$dataNxt] = it.util.toQuotedString($propertyKey);
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) {
                        $code = it.util.varReplace($code, $nextData, $passData);
                        var $useData = $passData;
                    } else {
                        var $useData = $nextData;
                        out += ' var ' + $nextData + ' = ' + $passData + '; ';
                    }
                    if ($hasDefault) out += ' ' + $code + ' ';
                    else {
                        if ($requiredHash && $requiredHash[$propertyKey]) {
                            out += ' if ( ' + $useData + ' === undefined ';
                            if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                            out += ') { ' + $nextValid + ' = false; ';
                            var $currentErrorPath = it.errorPath, $currErrSchemaPath = $errSchemaPath, $missingProperty = it.util.escapeQuotes($propertyKey);
                            if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
                            $errSchemaPath = it.errSchemaPath + '/required';
                            var $$outStack = $$outStack || [];
                            $$outStack.push(out);
                            out = ''; /* istanbul ignore else */ 
                            if (it.createErrors !== false) {
                                out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                                if (it.opts.messages !== false) {
                                    out += ' , message: \'';
                                    if (it.opts._errorDataPathProperty) out += 'is a required property';
                                    else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                                    out += '\' ';
                                }
                                if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                                out += ' } ';
                            } else out += ' {} ';
                            var __err = out;
                            out = $$outStack.pop();
                            if (!it.compositeRule && $breakOnError) {
                                /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                                else out += ' validate.errors = [' + __err + ']; return false; ';
                            } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                            $errSchemaPath = $currErrSchemaPath;
                            it.errorPath = $currentErrorPath;
                            out += ' } else { ';
                        } else if ($breakOnError) {
                            out += ' if ( ' + $useData + ' === undefined ';
                            if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                            out += ') { ' + $nextValid + ' = true; } else { ';
                        } else {
                            out += ' if (' + $useData + ' !== undefined ';
                            if ($ownProperties) out += ' &&   Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                            out += ' ) { ';
                        }
                        out += ' ' + $code + ' } ';
                    }
                }
                if ($breakOnError) {
                    out += ' if (' + $nextValid + ') { ';
                    $closingBraces += '}';
                }
            }
        }
    }
    if ($pPropertyKeys.length) {
        var arr4 = $pPropertyKeys;
        if (arr4) {
            var $pProperty, i4 = -1, l4 = arr4.length - 1;
            while(i4 < l4){
                $pProperty = arr4[i4 += 1];
                var $sch = $pProperties[$pProperty];
                if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                    $it.schema = $sch;
                    $it.schemaPath = it.schemaPath + '.patternProperties' + it.util.getProperty($pProperty);
                    $it.errSchemaPath = it.errSchemaPath + '/patternProperties/' + it.util.escapeFragment($pProperty);
                    if ($ownProperties) out += ' ' + $dataProperties + ' = ' + $dataProperties + ' || Object.keys(' + $data + '); for (var ' + $idx + '=0; ' + $idx + '<' + $dataProperties + '.length; ' + $idx + '++) { var ' + $key + ' = ' + $dataProperties + '[' + $idx + ']; ';
                    else out += ' for (var ' + $key + ' in ' + $data + ') { ';
                    out += ' if (' + it.usePattern($pProperty) + '.test(' + $key + ')) { ';
                    $it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
                    var $passData = $data + '[' + $key + ']';
                    $it.dataPathArr[$dataNxt] = $key;
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
                    else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
                    if ($breakOnError) out += ' if (!' + $nextValid + ') break; ';
                    out += ' } ';
                    if ($breakOnError) out += ' else ' + $nextValid + ' = true; ';
                    out += ' }  ';
                    if ($breakOnError) {
                        out += ' if (' + $nextValid + ') { ';
                        $closingBraces += '}';
                    }
                }
            }
        }
    }
    if ($breakOnError) out += ' ' + $closingBraces + ' if (' + $errs + ' == errors) {';
    return out;
};

});

parcelRegister("5XltN", function(module, exports) {
'use strict';
module.exports = function generate_propertyNames(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    out += 'var ' + $errs + ' = errors;';
    if (it.opts.strictKeywords ? typeof $schema == 'object' && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all)) {
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        var $key = 'key' + $lvl, $idx = 'idx' + $lvl, $i = 'i' + $lvl, $invalidName = '\' + ' + $key + ' + \'', $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = 'data' + $dataNxt, $dataProperties = 'dataProperties' + $lvl, $ownProperties = it.opts.ownProperties, $currentBaseId = it.baseId;
        if ($ownProperties) out += ' var ' + $dataProperties + ' = undefined; ';
        if ($ownProperties) out += ' ' + $dataProperties + ' = ' + $dataProperties + ' || Object.keys(' + $data + '); for (var ' + $idx + '=0; ' + $idx + '<' + $dataProperties + '.length; ' + $idx + '++) { var ' + $key + ' = ' + $dataProperties + '[' + $idx + ']; ';
        else out += ' for (var ' + $key + ' in ' + $data + ') { ';
        out += ' var startErrs' + $lvl + ' = errors; ';
        var $passData = $key;
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        var $code = it.validate($it);
        $it.baseId = $currentBaseId;
        if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
        else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += ' if (!' + $nextValid + ') { for (var ' + $i + '=startErrs' + $lvl + '; ' + $i + '<errors; ' + $i + '++) { vErrors[' + $i + '].propertyName = ' + $key + '; }   var err =   '; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { propertyName: \'' + $invalidName + '\' } ';
            if (it.opts.messages !== false) out += ' , message: \'property name \\\'' + $invalidName + '\\\' is invalid\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError(vErrors); ';
            else out += ' validate.errors = vErrors; return false; ';
        }
        if ($breakOnError) out += ' break; ';
        out += ' } }';
    }
    if ($breakOnError) out += ' ' + $closingBraces + ' if (' + $errs + ' == errors) {';
    return out;
};

});

parcelRegister("ghbYr", function(module, exports) {
'use strict';
module.exports = function generate_required(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    var $vSchema = 'schema' + $lvl;
    if (!$isData) {
        if ($schema.length < it.opts.loopRequired && it.schema.properties && Object.keys(it.schema.properties).length) {
            var $required = [];
            var arr1 = $schema;
            if (arr1) {
                var $property, i1 = -1, l1 = arr1.length - 1;
                while(i1 < l1){
                    $property = arr1[i1 += 1];
                    var $propertySch = it.schema.properties[$property];
                    if (!($propertySch && (it.opts.strictKeywords ? typeof $propertySch == 'object' && Object.keys($propertySch).length > 0 || $propertySch === false : it.util.schemaHasRules($propertySch, it.RULES.all)))) $required[$required.length] = $property;
                }
            }
        } else var $required = $schema;
    }
    if ($isData || $required.length) {
        var $currentErrorPath = it.errorPath, $loopRequired = $isData || $required.length >= it.opts.loopRequired, $ownProperties = it.opts.ownProperties;
        if ($breakOnError) {
            out += ' var missing' + $lvl + '; ';
            if ($loopRequired) {
                if (!$isData) out += ' var ' + $vSchema + ' = validate.schema' + $schemaPath + '; ';
                var $i = 'i' + $lvl, $propertyPath = 'schema' + $lvl + '[' + $i + ']', $missingProperty = '\' + ' + $propertyPath + ' + \'';
                if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
                out += ' var ' + $valid + ' = true; ';
                if ($isData) out += ' if (schema' + $lvl + ' === undefined) ' + $valid + ' = true; else if (!Array.isArray(schema' + $lvl + ')) ' + $valid + ' = false; else {';
                out += ' for (var ' + $i + ' = 0; ' + $i + ' < ' + $vSchema + '.length; ' + $i + '++) { ' + $valid + ' = ' + $data + '[' + $vSchema + '[' + $i + ']] !== undefined ';
                if ($ownProperties) out += ' &&   Object.prototype.hasOwnProperty.call(' + $data + ', ' + $vSchema + '[' + $i + ']) ';
                out += '; if (!' + $valid + ') break; } ';
                if ($isData) out += '  }  ';
                out += '  if (!' + $valid + ') {   ';
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ''; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                    if (it.opts.messages !== false) {
                        out += ' , message: \'';
                        if (it.opts._errorDataPathProperty) out += 'is a required property';
                        else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                        out += '\' ';
                    }
                    if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                    else out += ' validate.errors = [' + __err + ']; return false; ';
                } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                out += ' } else { ';
            } else {
                out += ' if ( ';
                var arr2 = $required;
                if (arr2) {
                    var $propertyKey, $i = -1, l2 = arr2.length - 1;
                    while($i < l2){
                        $propertyKey = arr2[$i += 1];
                        if ($i) out += ' || ';
                        var $prop = it.util.getProperty($propertyKey), $useData = $data + $prop;
                        out += ' ( ( ' + $useData + ' === undefined ';
                        if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                        out += ') && (missing' + $lvl + ' = ' + it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop) + ') ) ';
                    }
                }
                out += ') {  ';
                var $propertyPath = 'missing' + $lvl, $missingProperty = '\' + ' + $propertyPath + ' + \'';
                if (it.opts._errorDataPathProperty) it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + ' + ' + $propertyPath;
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ''; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                    if (it.opts.messages !== false) {
                        out += ' , message: \'';
                        if (it.opts._errorDataPathProperty) out += 'is a required property';
                        else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                        out += '\' ';
                    }
                    if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                    else out += ' validate.errors = [' + __err + ']; return false; ';
                } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                out += ' } else { ';
            }
        } else if ($loopRequired) {
            if (!$isData) out += ' var ' + $vSchema + ' = validate.schema' + $schemaPath + '; ';
            var $i = 'i' + $lvl, $propertyPath = 'schema' + $lvl + '[' + $i + ']', $missingProperty = '\' + ' + $propertyPath + ' + \'';
            if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
            if ($isData) {
                out += ' if (' + $vSchema + ' && !Array.isArray(' + $vSchema + ')) {  var err =   '; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                    if (it.opts.messages !== false) {
                        out += ' , message: \'';
                        if (it.opts._errorDataPathProperty) out += 'is a required property';
                        else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                        out += '\' ';
                    }
                    if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (' + $vSchema + ' !== undefined) { ';
            }
            out += ' for (var ' + $i + ' = 0; ' + $i + ' < ' + $vSchema + '.length; ' + $i + '++) { if (' + $data + '[' + $vSchema + '[' + $i + ']] === undefined ';
            if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', ' + $vSchema + '[' + $i + ']) ';
            out += ') {  var err =   '; /* istanbul ignore else */ 
            if (it.createErrors !== false) {
                out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                if (it.opts.messages !== false) {
                    out += ' , message: \'';
                    if (it.opts._errorDataPathProperty) out += 'is a required property';
                    else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                    out += '\' ';
                }
                if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                out += ' } ';
            } else out += ' {} ';
            out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ';
            if ($isData) out += '  }  ';
        } else {
            var arr3 = $required;
            if (arr3) {
                var $propertyKey, i3 = -1, l3 = arr3.length - 1;
                while(i3 < l3){
                    $propertyKey = arr3[i3 += 1];
                    var $prop = it.util.getProperty($propertyKey), $missingProperty = it.util.escapeQuotes($propertyKey), $useData = $data + $prop;
                    if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
                    out += ' if ( ' + $useData + ' === undefined ';
                    if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                    out += ') {  var err =   '; /* istanbul ignore else */ 
                    if (it.createErrors !== false) {
                        out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                        if (it.opts.messages !== false) {
                            out += ' , message: \'';
                            if (it.opts._errorDataPathProperty) out += 'is a required property';
                            else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                            out += '\' ';
                        }
                        if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                        out += ' } ';
                    } else out += ' {} ';
                    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ';
                }
            }
        }
        it.errorPath = $currentErrorPath;
    } else if ($breakOnError) out += ' if (true) {';
    return out;
};

});

parcelRegister("92UPI", function(module, exports) {
'use strict';
module.exports = function generate_uniqueItems(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    if (($schema || $isData) && it.opts.uniqueItems !== false) {
        if ($isData) out += ' var ' + $valid + '; if (' + $schemaValue + ' === false || ' + $schemaValue + ' === undefined) ' + $valid + ' = true; else if (typeof ' + $schemaValue + ' != \'boolean\') ' + $valid + ' = false; else { ';
        out += ' var i = ' + $data + '.length , ' + $valid + ' = true , j; if (i > 1) { ';
        var $itemType = it.schema.items && it.schema.items.type, $typeIsArray = Array.isArray($itemType);
        if (!$itemType || $itemType == 'object' || $itemType == 'array' || $typeIsArray && ($itemType.indexOf('object') >= 0 || $itemType.indexOf('array') >= 0)) out += ' outer: for (;i--;) { for (j = i; j--;) { if (equal(' + $data + '[i], ' + $data + '[j])) { ' + $valid + ' = false; break outer; } } } ';
        else {
            out += ' var itemIndices = {}, item; for (;i--;) { var item = ' + $data + '[i]; ';
            var $method = 'checkDataType' + ($typeIsArray ? 's' : '');
            out += ' if (' + it.util[$method]($itemType, 'item', it.opts.strictNumbers, true) + ') continue; ';
            if ($typeIsArray) out += ' if (typeof item == \'string\') item = \'"\' + item; ';
            out += ' if (typeof itemIndices[item] == \'number\') { ' + $valid + ' = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ';
        }
        out += ' } ';
        if ($isData) out += '  }  ';
        out += ' if (!' + $valid + ') {   ';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { i: i, j: j } ';
            if (it.opts.messages !== false) out += ' , message: \'should NOT have duplicate items (items ## \' + j + \' and \' + i + \' are identical)\' ';
            if (it.opts.verbose) {
                out += ' , schema:  ';
                if ($isData) out += 'validate.schema' + $schemaPath;
                else out += '' + $schema;
                out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            }
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        out += ' } ';
        if ($breakOnError) out += ' else { ';
    } else if ($breakOnError) out += ' if (true) { ';
    return out;
};

});

parcelRegister("3reCO", function(module, exports) {
'use strict';

var $fhgGC = parcelRequire("fhgGC");
var $280f3cf61a9b1642$require$MissingRefError = $fhgGC.MissingRef;
module.exports = $280f3cf61a9b1642$var$compileAsync;
/**
 * Creates validating function for passed schema with asynchronous loading of missing schemas.
 * `loadSchema` option should be a function that accepts schema uri and returns promise that resolves with the schema.
 * @this  Ajv
 * @param {Object}   schema schema object
 * @param {Boolean}  meta optional true to compile meta-schema; this parameter can be skipped
 * @param {Function} callback an optional node-style callback, it is called with 2 parameters: error (or null) and validating function.
 * @return {Promise} promise that resolves with a validating function.
 */ function $280f3cf61a9b1642$var$compileAsync(schema, meta, callback) {
    /* eslint no-shadow: 0 */ /* global Promise */ /* jshint validthis: true */ var self = this;
    if (typeof this._opts.loadSchema != 'function') throw new Error('options.loadSchema should be a function');
    if (typeof meta == 'function') {
        callback = meta;
        meta = undefined;
    }
    var p = loadMetaSchemaOf(schema).then(function() {
        var schemaObj = self._addSchema(schema, undefined, meta);
        return schemaObj.validate || _compileAsync(schemaObj);
    });
    if (callback) p.then(function(v) {
        callback(null, v);
    }, callback);
    return p;
    function loadMetaSchemaOf(sch) {
        var $schema = sch.$schema;
        return $schema && !self.getSchema($schema) ? $280f3cf61a9b1642$var$compileAsync.call(self, {
            $ref: $schema
        }, true) : Promise.resolve();
    }
    function _compileAsync(schemaObj) {
        try {
            return self._compile(schemaObj);
        } catch (e) {
            if (e instanceof $280f3cf61a9b1642$require$MissingRefError) return loadMissingSchema(e);
            throw e;
        }
        function loadMissingSchema(e) {
            var ref = e.missingSchema;
            if (added(ref)) throw new Error('Schema ' + ref + ' is loaded but ' + e.missingRef + ' cannot be resolved');
            var schemaPromise = self._loadingSchemas[ref];
            if (!schemaPromise) {
                schemaPromise = self._loadingSchemas[ref] = self._opts.loadSchema(ref);
                schemaPromise.then(removePromise, removePromise);
            }
            return schemaPromise.then(function(sch) {
                if (!added(ref)) return loadMetaSchemaOf(sch).then(function() {
                    if (!added(ref)) self.addSchema(sch, ref, undefined, meta);
                });
            }).then(function() {
                return _compileAsync(schemaObj);
            });
            function removePromise() {
                delete self._loadingSchemas[ref];
            }
            function added(ref) {
                return self._refs[ref] || self._schemas[ref];
            }
        }
    }
}

});
parcelRegister("fhgGC", function(module, exports) {
'use strict';

var $edhTp = parcelRequire("edhTp");
module.exports = {
    Validation: $b1f56317cb750297$var$errorSubclass($b1f56317cb750297$var$ValidationError),
    MissingRef: $b1f56317cb750297$var$errorSubclass($b1f56317cb750297$var$MissingRefError)
};
function $b1f56317cb750297$var$ValidationError(errors) {
    this.message = 'validation failed';
    this.errors = errors;
    this.ajv = this.validation = true;
}
$b1f56317cb750297$var$MissingRefError.message = function(baseId, ref) {
    return 'can\'t resolve reference ' + ref + ' from id ' + baseId;
};
function $b1f56317cb750297$var$MissingRefError(baseId, ref, message) {
    this.message = message || $b1f56317cb750297$var$MissingRefError.message(baseId, ref);
    this.missingRef = $edhTp.url(baseId, ref);
    this.missingSchema = $edhTp.normalizeId($edhTp.fullPath(this.missingRef));
}
function $b1f56317cb750297$var$errorSubclass(Subclass) {
    Subclass.prototype = Object.create(Error.prototype);
    Subclass.prototype.constructor = Subclass;
    return Subclass;
}

});
parcelRegister("edhTp", function(module, exports) {
'use strict';

var $87g74 = parcelRequire("87g74");

var $5jHra = parcelRequire("5jHra");

var $4tGD1 = parcelRequire("4tGD1");

var $8D9VW = parcelRequire("8D9VW");

var $9fT4x = parcelRequire("9fT4x");
module.exports = $a59028b6755362d5$var$resolve;
$a59028b6755362d5$var$resolve.normalizeId = $a59028b6755362d5$var$normalizeId;
$a59028b6755362d5$var$resolve.fullPath = $a59028b6755362d5$var$getFullPath;
$a59028b6755362d5$var$resolve.url = $a59028b6755362d5$var$resolveUrl;
$a59028b6755362d5$var$resolve.ids = $a59028b6755362d5$var$resolveIds;
$a59028b6755362d5$var$resolve.inlineRef = $a59028b6755362d5$var$inlineRef;
$a59028b6755362d5$var$resolve.schema = $a59028b6755362d5$var$resolveSchema;
/**
 * [resolve and compile the references ($ref)]
 * @this   Ajv
 * @param  {Function} compile reference to schema compilation funciton (localCompile)
 * @param  {Object} root object with information about the root schema for the current schema
 * @param  {String} ref reference to resolve
 * @return {Object|Function} schema object (if the schema can be inlined) or validation function
 */ function $a59028b6755362d5$var$resolve(compile, root, ref) {
    /* jshint validthis: true */ var refVal = this._refs[ref];
    if (typeof refVal == 'string') {
        if (this._refs[refVal]) refVal = this._refs[refVal];
        else return $a59028b6755362d5$var$resolve.call(this, compile, root, refVal);
    }
    refVal = refVal || this._schemas[ref];
    if (refVal instanceof $8D9VW) return $a59028b6755362d5$var$inlineRef(refVal.schema, this._opts.inlineRefs) ? refVal.schema : refVal.validate || this._compile(refVal);
    var res = $a59028b6755362d5$var$resolveSchema.call(this, root, ref);
    var schema, v, baseId;
    if (res) {
        schema = res.schema;
        root = res.root;
        baseId = res.baseId;
    }
    if (schema instanceof $8D9VW) v = schema.validate || compile.call(this, schema.schema, root, undefined, baseId);
    else if (schema !== undefined) v = $a59028b6755362d5$var$inlineRef(schema, this._opts.inlineRefs) ? schema : compile.call(this, schema, root, undefined, baseId);
    return v;
}
/**
 * Resolve schema, its root and baseId
 * @this Ajv
 * @param  {Object} root root object with properties schema, refVal, refs
 * @param  {String} ref  reference to resolve
 * @return {Object} object with properties schema, root, baseId
 */ function $a59028b6755362d5$var$resolveSchema(root, ref) {
    /* jshint validthis: true */ var p = $87g74.parse(ref), refPath = $a59028b6755362d5$var$_getFullPath(p), baseId = $a59028b6755362d5$var$getFullPath(this._getId(root.schema));
    if (Object.keys(root.schema).length === 0 || refPath !== baseId) {
        var id = $a59028b6755362d5$var$normalizeId(refPath);
        var refVal = this._refs[id];
        if (typeof refVal == 'string') return $a59028b6755362d5$var$resolveRecursive.call(this, root, refVal, p);
        else if (refVal instanceof $8D9VW) {
            if (!refVal.validate) this._compile(refVal);
            root = refVal;
        } else {
            refVal = this._schemas[id];
            if (refVal instanceof $8D9VW) {
                if (!refVal.validate) this._compile(refVal);
                if (id == $a59028b6755362d5$var$normalizeId(ref)) return {
                    schema: refVal,
                    root: root,
                    baseId: baseId
                };
                root = refVal;
            } else return;
        }
        if (!root.schema) return;
        baseId = $a59028b6755362d5$var$getFullPath(this._getId(root.schema));
    }
    return $a59028b6755362d5$var$getJsonPointer.call(this, p, baseId, root.schema, root);
}
/* @this Ajv */ function $a59028b6755362d5$var$resolveRecursive(root, ref, parsedRef) {
    /* jshint validthis: true */ var res = $a59028b6755362d5$var$resolveSchema.call(this, root, ref);
    if (res) {
        var schema = res.schema;
        var baseId = res.baseId;
        root = res.root;
        var id = this._getId(schema);
        if (id) baseId = $a59028b6755362d5$var$resolveUrl(baseId, id);
        return $a59028b6755362d5$var$getJsonPointer.call(this, parsedRef, baseId, schema, root);
    }
}
var $a59028b6755362d5$var$PREVENT_SCOPE_CHANGE = $4tGD1.toHash([
    'properties',
    'patternProperties',
    'enum',
    'dependencies',
    'definitions'
]);
/* @this Ajv */ function $a59028b6755362d5$var$getJsonPointer(parsedRef, baseId, schema, root) {
    /* jshint validthis: true */ parsedRef.fragment = parsedRef.fragment || '';
    if (parsedRef.fragment.slice(0, 1) != '/') return;
    var parts = parsedRef.fragment.split('/');
    for(var i = 1; i < parts.length; i++){
        var part = parts[i];
        if (part) {
            part = $4tGD1.unescapeFragment(part);
            schema = schema[part];
            if (schema === undefined) break;
            var id;
            if (!$a59028b6755362d5$var$PREVENT_SCOPE_CHANGE[part]) {
                id = this._getId(schema);
                if (id) baseId = $a59028b6755362d5$var$resolveUrl(baseId, id);
                if (schema.$ref) {
                    var $ref = $a59028b6755362d5$var$resolveUrl(baseId, schema.$ref);
                    var res = $a59028b6755362d5$var$resolveSchema.call(this, root, $ref);
                    if (res) {
                        schema = res.schema;
                        root = res.root;
                        baseId = res.baseId;
                    }
                }
            }
        }
    }
    if (schema !== undefined && schema !== root.schema) return {
        schema: schema,
        root: root,
        baseId: baseId
    };
}
var $a59028b6755362d5$var$SIMPLE_INLINED = $4tGD1.toHash([
    'type',
    'format',
    'pattern',
    'maxLength',
    'minLength',
    'maxProperties',
    'minProperties',
    'maxItems',
    'minItems',
    'maximum',
    'minimum',
    'uniqueItems',
    'multipleOf',
    'required',
    'enum'
]);
function $a59028b6755362d5$var$inlineRef(schema, limit) {
    if (limit === false) return false;
    if (limit === undefined || limit === true) return $a59028b6755362d5$var$checkNoRef(schema);
    else if (limit) return $a59028b6755362d5$var$countKeys(schema) <= limit;
}
function $a59028b6755362d5$var$checkNoRef(schema) {
    var item;
    if (Array.isArray(schema)) for(var i = 0; i < schema.length; i++){
        item = schema[i];
        if (typeof item == 'object' && !$a59028b6755362d5$var$checkNoRef(item)) return false;
    }
    else for(var key in schema){
        if (key == '$ref') return false;
        item = schema[key];
        if (typeof item == 'object' && !$a59028b6755362d5$var$checkNoRef(item)) return false;
    }
    return true;
}
function $a59028b6755362d5$var$countKeys(schema) {
    var count = 0, item;
    if (Array.isArray(schema)) for(var i = 0; i < schema.length; i++){
        item = schema[i];
        if (typeof item == 'object') count += $a59028b6755362d5$var$countKeys(item);
        if (count == Infinity) return Infinity;
    }
    else for(var key in schema){
        if (key == '$ref') return Infinity;
        if ($a59028b6755362d5$var$SIMPLE_INLINED[key]) count++;
        else {
            item = schema[key];
            if (typeof item == 'object') count += $a59028b6755362d5$var$countKeys(item) + 1;
            if (count == Infinity) return Infinity;
        }
    }
    return count;
}
function $a59028b6755362d5$var$getFullPath(id, normalize) {
    if (normalize !== false) id = $a59028b6755362d5$var$normalizeId(id);
    var p = $87g74.parse(id);
    return $a59028b6755362d5$var$_getFullPath(p);
}
function $a59028b6755362d5$var$_getFullPath(p) {
    return $87g74.serialize(p).split('#')[0] + '#';
}
var $a59028b6755362d5$var$TRAILING_SLASH_HASH = /#\/?$/;
function $a59028b6755362d5$var$normalizeId(id) {
    return id ? id.replace($a59028b6755362d5$var$TRAILING_SLASH_HASH, '') : '';
}
function $a59028b6755362d5$var$resolveUrl(baseId, id) {
    id = $a59028b6755362d5$var$normalizeId(id);
    return $87g74.resolve(baseId, id);
}
/* @this Ajv */ function $a59028b6755362d5$var$resolveIds(schema) {
    var schemaId = $a59028b6755362d5$var$normalizeId(this._getId(schema));
    var baseIds = {
        '': schemaId
    };
    var fullPaths = {
        '': $a59028b6755362d5$var$getFullPath(schemaId, false)
    };
    var localRefs = {};
    var self = this;
    $9fT4x(schema, {
        allKeys: true
    }, function(sch, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
        if (jsonPtr === '') return;
        var id = self._getId(sch);
        var baseId = baseIds[parentJsonPtr];
        var fullPath = fullPaths[parentJsonPtr] + '/' + parentKeyword;
        if (keyIndex !== undefined) fullPath += '/' + (typeof keyIndex == 'number' ? keyIndex : $4tGD1.escapeFragment(keyIndex));
        if (typeof id == 'string') {
            id = baseId = $a59028b6755362d5$var$normalizeId(baseId ? $87g74.resolve(baseId, id) : id);
            var refVal = self._refs[id];
            if (typeof refVal == 'string') refVal = self._refs[refVal];
            if (refVal && refVal.schema) {
                if (!$5jHra(sch, refVal.schema)) throw new Error('id "' + id + '" resolves to more than one schema');
            } else if (id != $a59028b6755362d5$var$normalizeId(fullPath)) {
                if (id[0] == '#') {
                    if (localRefs[id] && !$5jHra(sch, localRefs[id])) throw new Error('id "' + id + '" resolves to more than one schema');
                    localRefs[id] = sch;
                } else self._refs[id] = fullPath;
            }
        }
        baseIds[jsonPtr] = baseId;
        fullPaths[jsonPtr] = fullPath;
    });
    return localRefs;
}

});
parcelRegister("87g74", function(module, exports) {
/** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    function merge() {
        for(var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++)sets[_key] = arguments[_key];
        if (sets.length > 1) {
            sets[0] = sets[0].slice(0, -1);
            var xl = sets.length - 1;
            for(var x = 1; x < xl; ++x)sets[x] = sets[x].slice(1, -1);
            sets[xl] = sets[xl].slice(1);
            return sets.join('');
        } else return sets[0];
    }
    function subexp(str) {
        return "(?:" + str + ")";
    }
    function typeOf(o) {
        return o === undefined ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
    }
    function toUpperCase(str) {
        return str.toUpperCase();
    }
    function toArray(obj) {
        return obj !== undefined && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [
            obj
        ] : Array.prototype.slice.call(obj) : [];
    }
    function assign(target, source) {
        var obj = target;
        if (source) for(var key in source)obj[key] = source[key];
        return obj;
    }
    function buildExps(isIRI) {
        var ALPHA$$ = "[A-Za-z]", CR$ = "[\\x0D]", DIGIT$$ = "[0-9]", DQUOTE$$ = "[\\x22]", HEXDIG$$ = merge(DIGIT$$, "[A-Fa-f]"), //case-insensitive
        LF$$ = "[\\x0A]", SP$$ = "[\\x20]", PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)), //expanded
        GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]", SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", RESERVED$$ = merge(GEN_DELIMS$$, SUB_DELIMS$$), UCSCHAR$$ = isIRI ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", //subset, excludes bidi control characters
        IPRIVATE$$ = isIRI ? "[\\uE000-\\uF8FF]" : "[]", //subset
        UNRESERVED$$ = merge(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$), SCHEME$ = subexp(ALPHA$$ + merge(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*"), USERINFO$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]")) + "*"), DEC_OCTET$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("[1-9]" + DIGIT$$) + "|" + DIGIT$$), DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$), //relaxed parsing rules
        IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$), H16$ = subexp(HEXDIG$$ + "{1,4}"), LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$), IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$), //                           6( h16 ":" ) ls32
        IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$), //                      "::" 5( h16 ":" ) ls32
        IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$), //[               h16 ] "::" 4( h16 ":" ) ls32
        IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$), //[ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
        IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$), //[ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
        IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$), //[ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
        IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$), //[ *4( h16 ":" ) h16 ] "::"              ls32
        IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$), //[ *5( h16 ":" ) h16 ] "::"              h16
        IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"), //[ *6( h16 ":" ) h16 ] "::"
        IPV6ADDRESS$ = subexp([
            IPV6ADDRESS1$,
            IPV6ADDRESS2$,
            IPV6ADDRESS3$,
            IPV6ADDRESS4$,
            IPV6ADDRESS5$,
            IPV6ADDRESS6$,
            IPV6ADDRESS7$,
            IPV6ADDRESS8$,
            IPV6ADDRESS9$
        ].join("|")), ZONEID$ = subexp(subexp(UNRESERVED$$ + "|" + PCT_ENCODED$) + "+"), //RFC 6874
        IPV6ADDRZ$ = subexp(IPV6ADDRESS$ + "\\%25" + ZONEID$), //RFC 6874
        IPV6ADDRZ_RELAXED$ = subexp(IPV6ADDRESS$ + subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + ZONEID$), //RFC 6874, with relaxed parsing rules
        IPVFUTURE$ = subexp("[vV]" + HEXDIG$$ + "+\\." + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]") + "+"), IP_LITERAL$ = subexp("\\[" + subexp(IPV6ADDRZ_RELAXED$ + "|" + IPV6ADDRESS$ + "|" + IPVFUTURE$) + "\\]"), //RFC 6874
        REG_NAME$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$)) + "*"), HOST$ = subexp(IP_LITERAL$ + "|" + IPV4ADDRESS$ + "(?!" + REG_NAME$ + ")" + "|" + REG_NAME$), PORT$ = subexp(DIGIT$$ + "*"), AUTHORITY$ = subexp(subexp(USERINFO$ + "@") + "?" + HOST$ + subexp("\\:" + PORT$) + "?"), PCHAR$ = subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@]")), SEGMENT$ = subexp(PCHAR$ + "*"), SEGMENT_NZ$ = subexp(PCHAR$ + "+"), SEGMENT_NZ_NC$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\@]")) + "+"), PATH_ABEMPTY$ = subexp(subexp("\\/" + SEGMENT$) + "*"), PATH_ABSOLUTE$ = subexp("\\/" + subexp(SEGMENT_NZ$ + PATH_ABEMPTY$) + "?"), //simplified
        PATH_NOSCHEME$ = subexp(SEGMENT_NZ_NC$ + PATH_ABEMPTY$), //simplified
        PATH_ROOTLESS$ = subexp(SEGMENT_NZ$ + PATH_ABEMPTY$), //simplified
        PATH_EMPTY$ = "(?!" + PCHAR$ + ")", PATH$ = subexp(PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), QUERY$ = subexp(subexp(PCHAR$ + "|" + merge("[\\/\\?]", IPRIVATE$$)) + "*"), FRAGMENT$ = subexp(subexp(PCHAR$ + "|[\\/\\?]") + "*"), HIER_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), RELATIVE_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$), RELATIVE$ = subexp(RELATIVE_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), URI_REFERENCE$ = subexp(URI$ + "|" + RELATIVE$), ABSOLUTE_URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?"), GENERIC_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", RELATIVE_REF$ = "^(){0}" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", ABSOLUTE_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?$", SAMEDOC_REF$ = "^" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", AUTHORITY_REF$ = "^" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?$";
        return {
            NOT_SCHEME: new RegExp(merge("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
            NOT_USERINFO: new RegExp(merge("[^\\%\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_HOST: new RegExp(merge("[^\\%\\[\\]\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH: new RegExp(merge("[^\\%\\/\\:\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH_NOSCHEME: new RegExp(merge("[^\\%\\/\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_QUERY: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
            NOT_FRAGMENT: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
            ESCAPE: new RegExp(merge("[^]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            UNRESERVED: new RegExp(UNRESERVED$$, "g"),
            OTHER_CHARS: new RegExp(merge("[^\\%]", UNRESERVED$$, RESERVED$$), "g"),
            PCT_ENCODED: new RegExp(PCT_ENCODED$, "g"),
            IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
            IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$") //RFC 6874, with relaxed parsing rules
        };
    }
    var URI_PROTOCOL = buildExps(false);
    var IRI_PROTOCOL = buildExps(true);
    var slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally{
                try {
                    if (!_n && _i["return"]) _i["return"]();
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            else throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
    var toConsumableArray = function(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        } else return Array.from(arr);
    };
    /** Highest positive signed 32-bit float value */ var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
    /** Bootstring parameters */ var base = 36;
    var tMin = 1;
    var tMax = 26;
    var skew = 38;
    var damp = 700;
    var initialBias = 72;
    var initialN = 128; // 0x80
    var delimiter = '-'; // '\x2D'
    /** Regular expressions */ var regexPunycode = /^xn--/;
    var regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
    var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
    /** Error messages */ var errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    };
    /** Convenience shortcuts */ var baseMinusTMin = base - tMin;
    var floor = Math.floor;
    var stringFromCharCode = String.fromCharCode;
    /*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function error$1(type) {
        throw new RangeError(errors[type]);
    }
    /**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function map(array, fn) {
        var result = [];
        var length = array.length;
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function ucs2decode(string) {
        var output = [];
        var counter = 0;
        var length = string.length;
        while(counter < length){
            var value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // It's a high surrogate, and there is a next character.
                var extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) // Low surrogate.
                output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // It's an unmatched surrogate; only append this code unit, in case the
                    // next code unit is the high surrogate of a surrogate pair.
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ var ucs2encode = function ucs2encode(array) {
        return String.fromCodePoint.apply(String, toConsumableArray(array));
    };
    /**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ var basicToDigit = function basicToDigit(codePoint) {
        if (codePoint - 0x30 < 0x0A) return codePoint - 0x16;
        if (codePoint - 0x41 < 0x1A) return codePoint - 0x41;
        if (codePoint - 0x61 < 0x1A) return codePoint - 0x61;
        return base;
    };
    /**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ var digitToBasic = function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    };
    /**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ var adapt = function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    };
    /**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ var decode = function decode(input) {
        // Don't use UCS-2.
        var output = [];
        var inputLength = input.length;
        var i = 0;
        var n = initialN;
        var bias = initialBias;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        var basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(var j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error$1('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(var index = basic > 0 ? basic + 1 : 0; index < inputLength;)/* no final expression */ {
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            var oldi = i;
            for(var w = 1, k = base;; k += base){
                if (index >= inputLength) error$1('invalid-input');
                var digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error$1('overflow');
                i += digit * w;
                var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                var baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error$1('overflow');
                w *= baseMinusT;
            }
            var out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error$1('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output.
            output.splice(i++, 0, n);
        }
        return String.fromCodePoint.apply(String, output);
    };
    /**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ var encode = function encode(input) {
        var output = [];
        // Convert the input in UCS-2 to an array of Unicode code points.
        input = ucs2decode(input);
        // Cache the length.
        var inputLength = input.length;
        // Initialize the state.
        var n = initialN;
        var delta = 0;
        var bias = initialBias;
        // Handle the basic code points.
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _currentValue2 = _step.value;
                if (_currentValue2 < 0x80) output.push(stringFromCharCode(_currentValue2));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        var basicLength = output.length;
        var handledCPCount = basicLength;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string with a delimiter unless it's empty.
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            var m = maxInt;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;
            try {
                for(var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var currentValue = _step2.value;
                    if (currentValue >= n && currentValue < m) m = currentValue;
                }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow.
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                } finally{
                    if (_didIteratorError2) throw _iteratorError2;
                }
            }
            var handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error$1('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;
            try {
                for(var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var _currentValue = _step3.value;
                    if (_currentValue < n && ++delta > maxInt) error$1('overflow');
                    if (_currentValue == n) {
                        // Represent delta as a generalized variable-length integer.
                        var q = delta;
                        for(var k = base;; k += base){
                            var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                            if (q < t) break;
                            var qMinusT = q - t;
                            var baseMinusT = base - t;
                            output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                            q = floor(qMinusT / baseMinusT);
                        }
                        output.push(stringFromCharCode(digitToBasic(q, 0)));
                        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                        delta = 0;
                        ++handledCPCount;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) _iterator3.return();
                } finally{
                    if (_didIteratorError3) throw _iteratorError3;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    };
    /**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ var toUnicode = function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    };
    /**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ var toASCII = function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    };
    /*--------------------------------------------------------------------------*/ /** Define the public API */ var punycode = {
        /**
  * A string representing the current Punycode.js version number.
  * @memberOf punycode
  * @type String
  */ 'version': '2.1.0',
        /**
  * An object of methods to convert from JavaScript's internal character
  * representation (UCS-2) to Unicode code points, and back.
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode
  * @type Object
  */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /**
 * URI.js
 *
 * @fileoverview An RFC 3986 compliant, scheme extendable URI parsing/validating/resolving library for JavaScript.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/uri-js
 */ /**
 * Copyright 2011 Gary Court. All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court.
 */ var SCHEMES = {};
    function pctEncChar(chr) {
        var c = chr.charCodeAt(0);
        var e = void 0;
        if (c < 16) e = "%0" + c.toString(16).toUpperCase();
        else if (c < 128) e = "%" + c.toString(16).toUpperCase();
        else if (c < 2048) e = "%" + (c >> 6 | 192).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        else e = "%" + (c >> 12 | 224).toString(16).toUpperCase() + "%" + (c >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        return e;
    }
    function pctDecChars(str) {
        var newStr = "";
        var i = 0;
        var il = str.length;
        while(i < il){
            var c = parseInt(str.substr(i + 1, 2), 16);
            if (c < 128) {
                newStr += String.fromCharCode(c);
                i += 3;
            } else if (c >= 194 && c < 224) {
                if (il - i >= 6) {
                    var c2 = parseInt(str.substr(i + 4, 2), 16);
                    newStr += String.fromCharCode((c & 31) << 6 | c2 & 63);
                } else newStr += str.substr(i, 6);
                i += 6;
            } else if (c >= 224) {
                if (il - i >= 9) {
                    var _c = parseInt(str.substr(i + 4, 2), 16);
                    var c3 = parseInt(str.substr(i + 7, 2), 16);
                    newStr += String.fromCharCode((c & 15) << 12 | (_c & 63) << 6 | c3 & 63);
                } else newStr += str.substr(i, 9);
                i += 9;
            } else {
                newStr += str.substr(i, 3);
                i += 3;
            }
        }
        return newStr;
    }
    function _normalizeComponentEncoding(components, protocol) {
        function decodeUnreserved(str) {
            var decStr = pctDecChars(str);
            return !decStr.match(protocol.UNRESERVED) ? str : decStr;
        }
        if (components.scheme) components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_SCHEME, "");
        if (components.userinfo !== undefined) components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.host !== undefined) components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.path !== undefined) components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.query !== undefined) components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.fragment !== undefined) components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        return components;
    }
    function _stripLeadingZeros(str) {
        return str.replace(/^0*(.*)/, "$1") || "0";
    }
    function _normalizeIPv4(host, protocol) {
        var matches = host.match(protocol.IPV4ADDRESS) || [];
        var _matches = slicedToArray(matches, 2), address = _matches[1];
        if (address) return address.split(".").map(_stripLeadingZeros).join(".");
        else return host;
    }
    function _normalizeIPv6(host, protocol) {
        var matches = host.match(protocol.IPV6ADDRESS) || [];
        var _matches2 = slicedToArray(matches, 3), address = _matches2[1], zone = _matches2[2];
        if (address) {
            var _address$toLowerCase$ = address.toLowerCase().split('::').reverse(), _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2), last = _address$toLowerCase$2[0], first = _address$toLowerCase$2[1];
            var firstFields = first ? first.split(":").map(_stripLeadingZeros) : [];
            var lastFields = last.split(":").map(_stripLeadingZeros);
            var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
            var fieldCount = isLastFieldIPv4Address ? 7 : 8;
            var lastFieldsStart = lastFields.length - fieldCount;
            var fields = Array(fieldCount);
            for(var x = 0; x < fieldCount; ++x)fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || '';
            if (isLastFieldIPv4Address) fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
            var allZeroFields = fields.reduce(function(acc, field, index) {
                if (!field || field === "0") {
                    var lastLongest = acc[acc.length - 1];
                    if (lastLongest && lastLongest.index + lastLongest.length === index) lastLongest.length++;
                    else acc.push({
                        index: index,
                        length: 1
                    });
                }
                return acc;
            }, []);
            var longestZeroFields = allZeroFields.sort(function(a, b) {
                return b.length - a.length;
            })[0];
            var newHost = void 0;
            if (longestZeroFields && longestZeroFields.length > 1) {
                var newFirst = fields.slice(0, longestZeroFields.index);
                var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
                newHost = newFirst.join(":") + "::" + newLast.join(":");
            } else newHost = fields.join(":");
            if (zone) newHost += "%" + zone;
            return newHost;
        } else return host;
    }
    var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
    var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === undefined;
    function parse(uriString) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var components = {};
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        if (options.reference === "suffix") uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
        var matches = uriString.match(URI_PARSE);
        if (matches) {
            if (NO_MATCH_IS_UNDEFINED) {
                //store each component
                components.scheme = matches[1];
                components.userinfo = matches[3];
                components.host = matches[4];
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = matches[7];
                components.fragment = matches[8];
                //fix port number
                if (isNaN(components.port)) components.port = matches[5];
            } else {
                //IE FIX for improper RegExp matching
                //store each component
                components.scheme = matches[1] || undefined;
                components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : undefined;
                components.host = uriString.indexOf("//") !== -1 ? matches[4] : undefined;
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = uriString.indexOf("?") !== -1 ? matches[7] : undefined;
                components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : undefined;
                //fix port number
                if (isNaN(components.port)) components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : undefined;
            }
            if (components.host) //normalize IP hosts
            components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
            //determine reference type
            if (components.scheme === undefined && components.userinfo === undefined && components.host === undefined && components.port === undefined && !components.path && components.query === undefined) components.reference = "same-document";
            else if (components.scheme === undefined) components.reference = "relative";
            else if (components.fragment === undefined) components.reference = "absolute";
            else components.reference = "uri";
            //check for reference errors
            if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) components.error = components.error || "URI is not a " + options.reference + " reference.";
            //find scheme handler
            var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
            //check if scheme can't handle IRIs
            if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
                //if host component is a domain name
                if (components.host && (options.domainHost || schemeHandler && schemeHandler.domainHost)) //convert Unicode IDN -> ASCII IDN
                try {
                    components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                }
                //convert IRI -> URI
                _normalizeComponentEncoding(components, URI_PROTOCOL);
            } else //normalize encodings
            _normalizeComponentEncoding(components, protocol);
            //perform scheme specific parsing
            if (schemeHandler && schemeHandler.parse) schemeHandler.parse(components, options);
        } else components.error = components.error || "URI can not be parsed.";
        return components;
    }
    function _recomposeAuthority(components, options) {
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        if (components.userinfo !== undefined) {
            uriTokens.push(components.userinfo);
            uriTokens.push("@");
        }
        if (components.host !== undefined) //normalize IP hosts, add brackets and escape zone separator for IPv6
        uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function(_, $1, $2) {
            return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
        }));
        if (typeof components.port === "number" || typeof components.port === "string") {
            uriTokens.push(":");
            uriTokens.push(String(components.port));
        }
        return uriTokens.length ? uriTokens.join("") : undefined;
    }
    var RDS1 = /^\.\.?\//;
    var RDS2 = /^\/\.(\/|$)/;
    var RDS3 = /^\/\.\.(\/|$)/;
    var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
    function removeDotSegments(input) {
        var output = [];
        while(input.length){
            if (input.match(RDS1)) input = input.replace(RDS1, "");
            else if (input.match(RDS2)) input = input.replace(RDS2, "/");
            else if (input.match(RDS3)) {
                input = input.replace(RDS3, "/");
                output.pop();
            } else if (input === "." || input === "..") input = "";
            else {
                var im = input.match(RDS5);
                if (im) {
                    var s = im[0];
                    input = input.slice(s.length);
                    output.push(s);
                } else throw new Error("Unexpected dot segment condition");
            }
        }
        return output.join("");
    }
    function serialize(components) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var protocol = options.iri ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        //find scheme handler
        var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
        //perform scheme specific serialization
        if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
        if (components.host) {
            //if host component is an IPv6 address
            if (protocol.IPV6ADDRESS.test(components.host)) ;
            else if (options.domainHost || schemeHandler && schemeHandler.domainHost) //convert IDN via punycode
            try {
                components.host = !options.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
            } catch (e) {
                components.error = components.error || "Host's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
            }
        }
        //normalize encoding
        _normalizeComponentEncoding(components, protocol);
        if (options.reference !== "suffix" && components.scheme) {
            uriTokens.push(components.scheme);
            uriTokens.push(":");
        }
        var authority = _recomposeAuthority(components, options);
        if (authority !== undefined) {
            if (options.reference !== "suffix") uriTokens.push("//");
            uriTokens.push(authority);
            if (components.path && components.path.charAt(0) !== "/") uriTokens.push("/");
        }
        if (components.path !== undefined) {
            var s = components.path;
            if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) s = removeDotSegments(s);
            if (authority === undefined) s = s.replace(/^\/\//, "/%2F"); //don't allow the path to start with "//"
            uriTokens.push(s);
        }
        if (components.query !== undefined) {
            uriTokens.push("?");
            uriTokens.push(components.query);
        }
        if (components.fragment !== undefined) {
            uriTokens.push("#");
            uriTokens.push(components.fragment);
        }
        return uriTokens.join(""); //merge tokens into a string
    }
    function resolveComponents(base, relative) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var skipNormalization = arguments[3];
        var target = {};
        if (!skipNormalization) {
            base = parse(serialize(base, options), options); //normalize base components
            relative = parse(serialize(relative, options), options); //normalize relative components
        }
        options = options || {};
        if (!options.tolerant && relative.scheme) {
            target.scheme = relative.scheme;
            //target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = removeDotSegments(relative.path || "");
            target.query = relative.query;
        } else {
            if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
                //target.authority = relative.authority;
                target.userinfo = relative.userinfo;
                target.host = relative.host;
                target.port = relative.port;
                target.path = removeDotSegments(relative.path || "");
                target.query = relative.query;
            } else {
                if (!relative.path) {
                    target.path = base.path;
                    if (relative.query !== undefined) target.query = relative.query;
                    else target.query = base.query;
                } else {
                    if (relative.path.charAt(0) === "/") target.path = removeDotSegments(relative.path);
                    else {
                        if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = "/" + relative.path;
                        else if (!base.path) target.path = relative.path;
                        else target.path = base.path.slice(0, base.path.lastIndexOf("/") + 1) + relative.path;
                        target.path = removeDotSegments(target.path);
                    }
                    target.query = relative.query;
                }
                //target.authority = base.authority;
                target.userinfo = base.userinfo;
                target.host = base.host;
                target.port = base.port;
            }
            target.scheme = base.scheme;
        }
        target.fragment = relative.fragment;
        return target;
    }
    function resolve(baseURI, relativeURI, options) {
        var schemelessOptions = assign({
            scheme: 'null'
        }, options);
        return serialize(resolveComponents(parse(baseURI, schemelessOptions), parse(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
    }
    function normalize(uri, options) {
        if (typeof uri === "string") uri = serialize(parse(uri, options), options);
        else if (typeOf(uri) === "object") uri = parse(serialize(uri, options), options);
        return uri;
    }
    function equal(uriA, uriB, options) {
        if (typeof uriA === "string") uriA = serialize(parse(uriA, options), options);
        else if (typeOf(uriA) === "object") uriA = serialize(uriA, options);
        if (typeof uriB === "string") uriB = serialize(parse(uriB, options), options);
        else if (typeOf(uriB) === "object") uriB = serialize(uriB, options);
        return uriA === uriB;
    }
    function escapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
    }
    function unescapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
    }
    var handler = {
        scheme: "http",
        domainHost: true,
        parse: function parse(components, options) {
            //report missing host
            if (!components.host) components.error = components.error || "HTTP URIs must have a host.";
            return components;
        },
        serialize: function serialize(components, options) {
            var secure = String(components.scheme).toLowerCase() === "https";
            //normalize the default port
            if (components.port === (secure ? 443 : 80) || components.port === "") components.port = undefined;
            //normalize the empty path
            if (!components.path) components.path = "/";
            //NOTE: We do not parse query strings for HTTP URIs
            //as WWW Form Url Encoded query strings are part of the HTML4+ spec,
            //and not the HTTP spec.
            return components;
        }
    };
    var handler$1 = {
        scheme: "https",
        domainHost: handler.domainHost,
        parse: handler.parse,
        serialize: handler.serialize
    };
    function isSecure(wsComponents) {
        return typeof wsComponents.secure === 'boolean' ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
    }
    //RFC 6455
    var handler$2 = {
        scheme: "ws",
        domainHost: true,
        parse: function parse(components, options) {
            var wsComponents = components;
            //indicate if the secure flag is set
            wsComponents.secure = isSecure(wsComponents);
            //construct resouce name
            wsComponents.resourceName = (wsComponents.path || '/') + (wsComponents.query ? '?' + wsComponents.query : '');
            wsComponents.path = undefined;
            wsComponents.query = undefined;
            return wsComponents;
        },
        serialize: function serialize(wsComponents, options) {
            //normalize the default port
            if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") wsComponents.port = undefined;
            //ensure scheme matches secure flag
            if (typeof wsComponents.secure === 'boolean') {
                wsComponents.scheme = wsComponents.secure ? 'wss' : 'ws';
                wsComponents.secure = undefined;
            }
            //reconstruct path from resource name
            if (wsComponents.resourceName) {
                var _wsComponents$resourc = wsComponents.resourceName.split('?'), _wsComponents$resourc2 = slicedToArray(_wsComponents$resourc, 2), path = _wsComponents$resourc2[0], query = _wsComponents$resourc2[1];
                wsComponents.path = path && path !== '/' ? path : undefined;
                wsComponents.query = query;
                wsComponents.resourceName = undefined;
            }
            //forbid fragment component
            wsComponents.fragment = undefined;
            return wsComponents;
        }
    };
    var handler$3 = {
        scheme: "wss",
        domainHost: handler$2.domainHost,
        parse: handler$2.parse,
        serialize: handler$2.serialize
    };
    var O = {};
    var isIRI = true;
    //RFC 3986
    var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~" + (isIRI ? "\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" : "") + "]";
    var HEXDIG$$ = "[0-9A-Fa-f]"; //case-insensitive
    var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)); //expanded
    //RFC 5322, except these symbols as per RFC 6068: @ : / ? # [ ] & ; =
    //const ATEXT$$ = "[A-Za-z0-9\\!\\#\\$\\%\\&\\'\\*\\+\\-\\/\\=\\?\\^\\_\\`\\{\\|\\}\\~]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QTEXT$$ = "[\\x01-\\x08\\x0B\\x0C\\x0E-\\x1F\\x7F]";  //(%d1-8 / %d11-12 / %d14-31 / %d127)
    //const QTEXT$$ = merge("[\\x21\\x23-\\x5B\\x5D-\\x7E]", OBS_QTEXT$$);  //%d33 / %d35-91 / %d93-126 / obs-qtext
    //const VCHAR$$ = "[\\x21-\\x7E]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QP$ = subexp("\\\\" + merge("[\\x00\\x0D\\x0A]", OBS_QTEXT$$));  //%d0 / CR / LF / obs-qtext
    //const FWS$ = subexp(subexp(WSP$$ + "*" + "\\x0D\\x0A") + "?" + WSP$$ + "+");
    //const QUOTED_PAIR$ = subexp(subexp("\\\\" + subexp(VCHAR$$ + "|" + WSP$$)) + "|" + OBS_QP$);
    //const QUOTED_STRING$ = subexp('\\"' + subexp(FWS$ + "?" + QCONTENT$) + "*" + FWS$ + "?" + '\\"');
    var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
    var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
    var VCHAR$$ = merge(QTEXT$$, "[\\\"\\\\]");
    var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
    var UNRESERVED = new RegExp(UNRESERVED$$, "g");
    var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
    var NOT_LOCAL_PART = new RegExp(merge("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
    var NOT_HFNAME = new RegExp(merge("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
    var NOT_HFVALUE = NOT_HFNAME;
    function decodeUnreserved(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(UNRESERVED) ? str : decStr;
    }
    var handler$4 = {
        scheme: "mailto",
        parse: function parse$$1(components, options) {
            var mailtoComponents = components;
            var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
            mailtoComponents.path = undefined;
            if (mailtoComponents.query) {
                var unknownHeaders = false;
                var headers = {};
                var hfields = mailtoComponents.query.split("&");
                for(var x = 0, xl = hfields.length; x < xl; ++x){
                    var hfield = hfields[x].split("=");
                    switch(hfield[0]){
                        case "to":
                            var toAddrs = hfield[1].split(",");
                            for(var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x)to.push(toAddrs[_x]);
                            break;
                        case "subject":
                            mailtoComponents.subject = unescapeComponent(hfield[1], options);
                            break;
                        case "body":
                            mailtoComponents.body = unescapeComponent(hfield[1], options);
                            break;
                        default:
                            unknownHeaders = true;
                            headers[unescapeComponent(hfield[0], options)] = unescapeComponent(hfield[1], options);
                            break;
                    }
                }
                if (unknownHeaders) mailtoComponents.headers = headers;
            }
            mailtoComponents.query = undefined;
            for(var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2){
                var addr = to[_x2].split("@");
                addr[0] = unescapeComponent(addr[0]);
                if (!options.unicodeSupport) //convert Unicode IDN -> ASCII IDN
                try {
                    addr[1] = punycode.toASCII(unescapeComponent(addr[1], options).toLowerCase());
                } catch (e) {
                    mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                }
                else addr[1] = unescapeComponent(addr[1], options).toLowerCase();
                to[_x2] = addr.join("@");
            }
            return mailtoComponents;
        },
        serialize: function serialize$$1(mailtoComponents, options) {
            var components = mailtoComponents;
            var to = toArray(mailtoComponents.to);
            if (to) {
                for(var x = 0, xl = to.length; x < xl; ++x){
                    var toAddr = String(to[x]);
                    var atIdx = toAddr.lastIndexOf("@");
                    var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
                    var domain = toAddr.slice(atIdx + 1);
                    //convert IDN via punycode
                    try {
                        domain = !options.iri ? punycode.toASCII(unescapeComponent(domain, options).toLowerCase()) : punycode.toUnicode(domain);
                    } catch (e) {
                        components.error = components.error || "Email address's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                    }
                    to[x] = localPart + "@" + domain;
                }
                components.path = to.join(",");
            }
            var headers = mailtoComponents.headers = mailtoComponents.headers || {};
            if (mailtoComponents.subject) headers["subject"] = mailtoComponents.subject;
            if (mailtoComponents.body) headers["body"] = mailtoComponents.body;
            var fields = [];
            for(var name in headers)if (headers[name] !== O[name]) fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
            if (fields.length) components.query = fields.join("&");
            return components;
        }
    };
    var URN_PARSE = /^([^\:]+)\:(.*)/;
    //RFC 2141
    var handler$5 = {
        scheme: "urn",
        parse: function parse$$1(components, options) {
            var matches = components.path && components.path.match(URN_PARSE);
            var urnComponents = components;
            if (matches) {
                var scheme = options.scheme || urnComponents.scheme || "urn";
                var nid = matches[1].toLowerCase();
                var nss = matches[2];
                var urnScheme = scheme + ":" + (options.nid || nid);
                var schemeHandler = SCHEMES[urnScheme];
                urnComponents.nid = nid;
                urnComponents.nss = nss;
                urnComponents.path = undefined;
                if (schemeHandler) urnComponents = schemeHandler.parse(urnComponents, options);
            } else urnComponents.error = urnComponents.error || "URN can not be parsed.";
            return urnComponents;
        },
        serialize: function serialize$$1(urnComponents, options) {
            var scheme = options.scheme || urnComponents.scheme || "urn";
            var nid = urnComponents.nid;
            var urnScheme = scheme + ":" + (options.nid || nid);
            var schemeHandler = SCHEMES[urnScheme];
            if (schemeHandler) urnComponents = schemeHandler.serialize(urnComponents, options);
            var uriComponents = urnComponents;
            var nss = urnComponents.nss;
            uriComponents.path = (nid || options.nid) + ":" + nss;
            return uriComponents;
        }
    };
    var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
    //RFC 4122
    var handler$6 = {
        scheme: "urn:uuid",
        parse: function parse(urnComponents, options) {
            var uuidComponents = urnComponents;
            uuidComponents.uuid = uuidComponents.nss;
            uuidComponents.nss = undefined;
            if (!options.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) uuidComponents.error = uuidComponents.error || "UUID is not valid.";
            return uuidComponents;
        },
        serialize: function serialize(uuidComponents, options) {
            var urnComponents = uuidComponents;
            //normalize UUID
            urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
            return urnComponents;
        }
    };
    SCHEMES[handler.scheme] = handler;
    SCHEMES[handler$1.scheme] = handler$1;
    SCHEMES[handler$2.scheme] = handler$2;
    SCHEMES[handler$3.scheme] = handler$3;
    SCHEMES[handler$4.scheme] = handler$4;
    SCHEMES[handler$5.scheme] = handler$5;
    SCHEMES[handler$6.scheme] = handler$6;
    exports1.SCHEMES = SCHEMES;
    exports1.pctEncChar = pctEncChar;
    exports1.pctDecChars = pctDecChars;
    exports1.parse = parse;
    exports1.removeDotSegments = removeDotSegments;
    exports1.serialize = serialize;
    exports1.resolveComponents = resolveComponents;
    exports1.resolve = resolve;
    exports1.normalize = normalize;
    exports1.equal = equal;
    exports1.escapeComponent = escapeComponent;
    exports1.unescapeComponent = unescapeComponent;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("4tGD1", function(module, exports) {
'use strict';


module.exports = {
    copy: $342aeff8b3235310$var$copy,
    checkDataType: $342aeff8b3235310$var$checkDataType,
    checkDataTypes: $342aeff8b3235310$var$checkDataTypes,
    coerceToTypes: $342aeff8b3235310$var$coerceToTypes,
    toHash: $342aeff8b3235310$var$toHash,
    getProperty: $342aeff8b3235310$var$getProperty,
    escapeQuotes: $342aeff8b3235310$var$escapeQuotes,
    equal: (parcelRequire("5jHra")),
    ucs2length: (parcelRequire("cr2NE")),
    varOccurences: $342aeff8b3235310$var$varOccurences,
    varReplace: $342aeff8b3235310$var$varReplace,
    schemaHasRules: $342aeff8b3235310$var$schemaHasRules,
    schemaHasRulesExcept: $342aeff8b3235310$var$schemaHasRulesExcept,
    schemaUnknownRules: $342aeff8b3235310$var$schemaUnknownRules,
    toQuotedString: $342aeff8b3235310$var$toQuotedString,
    getPathExpr: $342aeff8b3235310$var$getPathExpr,
    getPath: $342aeff8b3235310$var$getPath,
    getData: $342aeff8b3235310$var$getData,
    unescapeFragment: $342aeff8b3235310$var$unescapeFragment,
    unescapeJsonPointer: $342aeff8b3235310$var$unescapeJsonPointer,
    escapeFragment: $342aeff8b3235310$var$escapeFragment,
    escapeJsonPointer: $342aeff8b3235310$var$escapeJsonPointer
};
function $342aeff8b3235310$var$copy(o, to) {
    to = to || {};
    for(var key in o)to[key] = o[key];
    return to;
}
function $342aeff8b3235310$var$checkDataType(dataType, data, strictNumbers, negate) {
    var EQUAL = negate ? ' !== ' : ' === ', AND = negate ? ' || ' : ' && ', OK = negate ? '!' : '', NOT = negate ? '' : '!';
    switch(dataType){
        case 'null':
            return data + EQUAL + 'null';
        case 'array':
            return OK + 'Array.isArray(' + data + ')';
        case 'object':
            return '(' + OK + data + AND + 'typeof ' + data + EQUAL + '"object"' + AND + NOT + 'Array.isArray(' + data + '))';
        case 'integer':
            return '(typeof ' + data + EQUAL + '"number"' + AND + NOT + '(' + data + ' % 1)' + AND + data + EQUAL + data + (strictNumbers ? AND + OK + 'isFinite(' + data + ')' : '') + ')';
        case 'number':
            return '(typeof ' + data + EQUAL + '"' + dataType + '"' + (strictNumbers ? AND + OK + 'isFinite(' + data + ')' : '') + ')';
        default:
            return 'typeof ' + data + EQUAL + '"' + dataType + '"';
    }
}
function $342aeff8b3235310$var$checkDataTypes(dataTypes, data, strictNumbers) {
    switch(dataTypes.length){
        case 1:
            return $342aeff8b3235310$var$checkDataType(dataTypes[0], data, strictNumbers, true);
        default:
            var code = '';
            var types = $342aeff8b3235310$var$toHash(dataTypes);
            if (types.array && types.object) {
                code = types.null ? '(' : '(!' + data + ' || ';
                code += 'typeof ' + data + ' !== "object")';
                delete types.null;
                delete types.array;
                delete types.object;
            }
            if (types.number) delete types.integer;
            for(var t in types)code += (code ? ' && ' : '') + $342aeff8b3235310$var$checkDataType(t, data, strictNumbers, true);
            return code;
    }
}
var $342aeff8b3235310$var$COERCE_TO_TYPES = $342aeff8b3235310$var$toHash([
    'string',
    'number',
    'integer',
    'boolean',
    'null'
]);
function $342aeff8b3235310$var$coerceToTypes(optionCoerceTypes, dataTypes) {
    if (Array.isArray(dataTypes)) {
        var types = [];
        for(var i = 0; i < dataTypes.length; i++){
            var t = dataTypes[i];
            if ($342aeff8b3235310$var$COERCE_TO_TYPES[t]) types[types.length] = t;
            else if (optionCoerceTypes === 'array' && t === 'array') types[types.length] = t;
        }
        if (types.length) return types;
    } else if ($342aeff8b3235310$var$COERCE_TO_TYPES[dataTypes]) return [
        dataTypes
    ];
    else if (optionCoerceTypes === 'array' && dataTypes === 'array') return [
        'array'
    ];
}
function $342aeff8b3235310$var$toHash(arr) {
    var hash = {};
    for(var i = 0; i < arr.length; i++)hash[arr[i]] = true;
    return hash;
}
var $342aeff8b3235310$var$IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
var $342aeff8b3235310$var$SINGLE_QUOTE = /'|\\/g;
function $342aeff8b3235310$var$getProperty(key) {
    return typeof key == 'number' ? '[' + key + ']' : $342aeff8b3235310$var$IDENTIFIER.test(key) ? '.' + key : "['" + $342aeff8b3235310$var$escapeQuotes(key) + "']";
}
function $342aeff8b3235310$var$escapeQuotes(str) {
    return str.replace($342aeff8b3235310$var$SINGLE_QUOTE, '\\$&').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\f/g, '\\f').replace(/\t/g, '\\t');
}
function $342aeff8b3235310$var$varOccurences(str, dataVar) {
    dataVar += '[^0-9]';
    var matches = str.match(new RegExp(dataVar, 'g'));
    return matches ? matches.length : 0;
}
function $342aeff8b3235310$var$varReplace(str, dataVar, expr) {
    dataVar += '([^0-9])';
    expr = expr.replace(/\$/g, '$$$$');
    return str.replace(new RegExp(dataVar, 'g'), expr + '$1');
}
function $342aeff8b3235310$var$schemaHasRules(schema, rules) {
    if (typeof schema == 'boolean') return !schema;
    for(var key in schema)if (rules[key]) return true;
}
function $342aeff8b3235310$var$schemaHasRulesExcept(schema, rules, exceptKeyword) {
    if (typeof schema == 'boolean') return !schema && exceptKeyword != 'not';
    for(var key in schema)if (key != exceptKeyword && rules[key]) return true;
}
function $342aeff8b3235310$var$schemaUnknownRules(schema, rules) {
    if (typeof schema == 'boolean') return;
    for(var key in schema)if (!rules[key]) return key;
}
function $342aeff8b3235310$var$toQuotedString(str) {
    return '\'' + $342aeff8b3235310$var$escapeQuotes(str) + '\'';
}
function $342aeff8b3235310$var$getPathExpr(currentPath, expr, jsonPointers, isNumber) {
    var path = jsonPointers // false by default
     ? '\'/\' + ' + expr + (isNumber ? '' : '.replace(/~/g, \'~0\').replace(/\\//g, \'~1\')') : isNumber ? '\'[\' + ' + expr + ' + \']\'' : '\'[\\\'\' + ' + expr + ' + \'\\\']\'';
    return $342aeff8b3235310$var$joinPaths(currentPath, path);
}
function $342aeff8b3235310$var$getPath(currentPath, prop, jsonPointers) {
    var path = jsonPointers // false by default
     ? $342aeff8b3235310$var$toQuotedString('/' + $342aeff8b3235310$var$escapeJsonPointer(prop)) : $342aeff8b3235310$var$toQuotedString($342aeff8b3235310$var$getProperty(prop));
    return $342aeff8b3235310$var$joinPaths(currentPath, path);
}
var $342aeff8b3235310$var$JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
var $342aeff8b3235310$var$RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function $342aeff8b3235310$var$getData($data, lvl, paths) {
    var up, jsonPointer, data, matches;
    if ($data === '') return 'rootData';
    if ($data[0] == '/') {
        if (!$342aeff8b3235310$var$JSON_POINTER.test($data)) throw new Error('Invalid JSON-pointer: ' + $data);
        jsonPointer = $data;
        data = 'rootData';
    } else {
        matches = $data.match($342aeff8b3235310$var$RELATIVE_JSON_POINTER);
        if (!matches) throw new Error('Invalid JSON-pointer: ' + $data);
        up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer == '#') {
            if (up >= lvl) throw new Error('Cannot access property/index ' + up + ' levels up, current level is ' + lvl);
            return paths[lvl - up];
        }
        if (up > lvl) throw new Error('Cannot access data ' + up + ' levels up, current level is ' + lvl);
        data = 'data' + (lvl - up || '');
        if (!jsonPointer) return data;
    }
    var expr = data;
    var segments = jsonPointer.split('/');
    for(var i = 0; i < segments.length; i++){
        var segment = segments[i];
        if (segment) {
            data += $342aeff8b3235310$var$getProperty($342aeff8b3235310$var$unescapeJsonPointer(segment));
            expr += ' && ' + data;
        }
    }
    return expr;
}
function $342aeff8b3235310$var$joinPaths(a, b) {
    if (a == '""') return b;
    return (a + ' + ' + b).replace(/([^\\])' \+ '/g, '$1');
}
function $342aeff8b3235310$var$unescapeFragment(str) {
    return $342aeff8b3235310$var$unescapeJsonPointer(decodeURIComponent(str));
}
function $342aeff8b3235310$var$escapeFragment(str) {
    return encodeURIComponent($342aeff8b3235310$var$escapeJsonPointer(str));
}
function $342aeff8b3235310$var$escapeJsonPointer(str) {
    return str.replace(/~/g, '~0').replace(/\//g, '~1');
}
function $342aeff8b3235310$var$unescapeJsonPointer(str) {
    return str.replace(/~1/g, '/').replace(/~0/g, '~');
}

});

parcelRegister("8D9VW", function(module, exports) {
'use strict';

var $4tGD1 = parcelRequire("4tGD1");
module.exports = $6489abda9a3ce28e$var$SchemaObject;
function $6489abda9a3ce28e$var$SchemaObject(obj) {
    $4tGD1.copy(obj, this);
}

});

parcelRegister("9fT4x", function(module, exports) {
'use strict';
var $6bd03bf0f7c7ade8$var$traverse = module.exports = function(schema, opts, cb) {
    // Legacy support for v0.3.1 and earlier.
    if (typeof opts == 'function') {
        cb = opts;
        opts = {};
    }
    cb = opts.cb || cb;
    var pre = typeof cb == 'function' ? cb : cb.pre || function() {};
    var post = cb.post || function() {};
    $6bd03bf0f7c7ade8$var$_traverse(opts, pre, post, schema, '', schema);
};
$6bd03bf0f7c7ade8$var$traverse.keywords = {
    additionalItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    propertyNames: true,
    not: true
};
$6bd03bf0f7c7ade8$var$traverse.arrayKeywords = {
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
$6bd03bf0f7c7ade8$var$traverse.propsKeywords = {
    definitions: true,
    properties: true,
    patternProperties: true,
    dependencies: true
};
$6bd03bf0f7c7ade8$var$traverse.skipKeywords = {
    default: true,
    enum: true,
    const: true,
    required: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
function $6bd03bf0f7c7ade8$var$_traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (schema && typeof schema == 'object' && !Array.isArray(schema)) {
        pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
        for(var key in schema){
            var sch = schema[key];
            if (Array.isArray(sch)) {
                if (key in $6bd03bf0f7c7ade8$var$traverse.arrayKeywords) for(var i = 0; i < sch.length; i++)$6bd03bf0f7c7ade8$var$_traverse(opts, pre, post, sch[i], jsonPtr + '/' + key + '/' + i, rootSchema, jsonPtr, key, schema, i);
            } else if (key in $6bd03bf0f7c7ade8$var$traverse.propsKeywords) {
                if (sch && typeof sch == 'object') for(var prop in sch)$6bd03bf0f7c7ade8$var$_traverse(opts, pre, post, sch[prop], jsonPtr + '/' + key + '/' + $6bd03bf0f7c7ade8$var$escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
            } else if (key in $6bd03bf0f7c7ade8$var$traverse.keywords || opts.allKeys && !(key in $6bd03bf0f7c7ade8$var$traverse.skipKeywords)) $6bd03bf0f7c7ade8$var$_traverse(opts, pre, post, sch, jsonPtr + '/' + key, rootSchema, jsonPtr, key, schema);
        }
        post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    }
}
function $6bd03bf0f7c7ade8$var$escapeJsonPtr(str) {
    return str.replace(/~/g, '~0').replace(/\//g, '~1');
}

});




parcelRegister("jQknV", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"$id\":\"http://json-schema.org/draft-07/schema#\",\"title\":\"Core schema meta-schema\",\"definitions\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#\"}},\"nonNegativeInteger\":{\"type\":\"integer\",\"minimum\":0},\"nonNegativeIntegerDefault0\":{\"allOf\":[{\"$ref\":\"#/definitions/nonNegativeInteger\"},{\"default\":0}]},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true,\"default\":[]}},\"type\":[\"object\",\"boolean\"],\"properties\":{\"$id\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$schema\":{\"type\":\"string\",\"format\":\"uri\"},\"$ref\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$comment\":{\"type\":\"string\"},\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":true,\"readOnly\":{\"type\":\"boolean\",\"default\":false},\"examples\":{\"type\":\"array\",\"items\":true},\"multipleOf\":{\"type\":\"number\",\"exclusiveMinimum\":0},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"number\"},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"number\"},\"maxLength\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minLength\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"additionalItems\":{\"$ref\":\"#\"},\"items\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/schemaArray\"}],\"default\":true},\"maxItems\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minItems\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"contains\":{\"$ref\":\"#\"},\"maxProperties\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minProperties\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"required\":{\"$ref\":\"#/definitions/stringArray\"},\"additionalProperties\":{\"$ref\":\"#\"},\"definitions\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"propertyNames\":{\"format\":\"regex\"},\"default\":{}},\"dependencies\":{\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/stringArray\"}]}},\"propertyNames\":{\"$ref\":\"#\"},\"const\":true,\"enum\":{\"type\":\"array\",\"items\":true,\"minItems\":1,\"uniqueItems\":true},\"type\":{\"anyOf\":[{\"$ref\":\"#/definitions/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"format\":{\"type\":\"string\"},\"contentMediaType\":{\"type\":\"string\"},\"contentEncoding\":{\"type\":\"string\"},\"if\":{\"$ref\":\"#\"},\"then\":{\"$ref\":\"#\"},\"else\":{\"$ref\":\"#\"},\"allOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"anyOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"oneOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"not\":{\"$ref\":\"#\"}},\"default\":true}");

});

parcelRegister("2d1Zg", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"$id\":\"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#\",\"description\":\"Meta-schema for $data reference (JSON Schema extension proposal)\",\"type\":\"object\",\"required\":[\"$data\"],\"properties\":{\"$data\":{\"type\":\"string\",\"anyOf\":[{\"format\":\"relative-json-pointer\"},{\"format\":\"json-pointer\"}]}},\"additionalProperties\":false}");

});

parcelRegister("7FL16", function(module, exports) {
'use strict';

var $hM5r1 = parcelRequire("hM5r1");

var $8cRmA = parcelRequire("8cRmA");

var $frSVn = parcelRequire("frSVn");

var $gUSYn = parcelRequire("gUSYn");
var $5960d550269863d6$require$scanSchema = $gUSYn.scan;
var $5960d550269863d6$var$ValidatorResult = $frSVn.ValidatorResult;
var $5960d550269863d6$var$ValidatorResultError = $frSVn.ValidatorResultError;
var $5960d550269863d6$var$SchemaError = $frSVn.SchemaError;
var $5960d550269863d6$var$SchemaContext = $frSVn.SchemaContext;
//var anonymousBase = 'vnd.jsonschema:///';
var $5960d550269863d6$var$anonymousBase = '/';
/**
 * Creates a new Validator object
 * @name Validator
 * @constructor
 */ var $5960d550269863d6$var$Validator = function Validator() {
    // Allow a validator instance to override global custom formats or to have their
    // own custom formats.
    this.customFormats = Object.create(Validator.prototype.customFormats);
    this.schemas = {};
    this.unresolvedRefs = [];
    // Use Object.create to make this extensible without Validator instances stepping on each other's toes.
    this.types = Object.create($5960d550269863d6$var$types);
    this.attributes = Object.create($8cRmA.validators);
};
// Allow formats to be registered globally.
$5960d550269863d6$var$Validator.prototype.customFormats = {};
// Hint at the presence of a property
$5960d550269863d6$var$Validator.prototype.schemas = null;
$5960d550269863d6$var$Validator.prototype.types = null;
$5960d550269863d6$var$Validator.prototype.attributes = null;
$5960d550269863d6$var$Validator.prototype.unresolvedRefs = null;
/**
 * Adds a schema with a certain urn to the Validator instance.
 * @param schema
 * @param urn
 * @return {Object}
 */ $5960d550269863d6$var$Validator.prototype.addSchema = function addSchema(schema, base) {
    var self = this;
    if (!schema) return null;
    var scan = $5960d550269863d6$require$scanSchema(base || $5960d550269863d6$var$anonymousBase, schema);
    var ourUri = base || schema.$id || schema.id;
    for(var uri in scan.id)this.schemas[uri] = scan.id[uri];
    for(var uri in scan.ref)// If this schema is already defined, it will be filtered out by the next step
    this.unresolvedRefs.push(uri);
    // Remove newly defined schemas from unresolvedRefs
    this.unresolvedRefs = this.unresolvedRefs.filter(function(uri) {
        return typeof self.schemas[uri] === 'undefined';
    });
    return this.schemas[ourUri];
};
$5960d550269863d6$var$Validator.prototype.addSubSchemaArray = function addSubSchemaArray(baseuri, schemas) {
    if (!Array.isArray(schemas)) return;
    for(var i = 0; i < schemas.length; i++)this.addSubSchema(baseuri, schemas[i]);
};
$5960d550269863d6$var$Validator.prototype.addSubSchemaObject = function addSubSchemaArray(baseuri, schemas) {
    if (!schemas || typeof schemas != 'object') return;
    for(var p in schemas)this.addSubSchema(baseuri, schemas[p]);
};
/**
 * Sets all the schemas of the Validator instance.
 * @param schemas
 */ $5960d550269863d6$var$Validator.prototype.setSchemas = function setSchemas(schemas) {
    this.schemas = schemas;
};
/**
 * Returns the schema of a certain urn
 * @param urn
 */ $5960d550269863d6$var$Validator.prototype.getSchema = function getSchema(urn) {
    return this.schemas[urn];
};
/**
 * Validates instance against the provided schema
 * @param instance
 * @param schema
 * @param [options]
 * @param [ctx]
 * @return {Array}
 */ $5960d550269863d6$var$Validator.prototype.validate = function validate(instance, schema, options, ctx) {
    if (typeof schema !== 'boolean' && typeof schema !== 'object' || schema === null) throw new $5960d550269863d6$var$SchemaError('Expected `schema` to be an object or boolean');
    if (!options) options = {};
    // This section indexes subschemas in the provided schema, so they don't need to be added with Validator#addSchema
    // This will work so long as the function at uri.resolve() will resolve a relative URI to a relative URI
    var id = schema.$id || schema.id;
    var base = $hM5r1.resolve(options.base || $5960d550269863d6$var$anonymousBase, id || '');
    if (!ctx) {
        ctx = new $5960d550269863d6$var$SchemaContext(schema, options, [], base, Object.create(this.schemas));
        if (!ctx.schemas[base]) ctx.schemas[base] = schema;
        var found = $5960d550269863d6$require$scanSchema(base, schema);
        for(var n in found.id){
            var sch = found.id[n];
            ctx.schemas[n] = sch;
        }
    }
    if (options.required && instance === undefined) {
        var result = new $5960d550269863d6$var$ValidatorResult(instance, schema, options, ctx);
        result.addError('is required, but is undefined');
        return result;
    }
    var result = this.validateSchema(instance, schema, options, ctx);
    if (!result) throw new Error('Result undefined');
    else if (options.throwAll && result.errors.length) throw new $5960d550269863d6$var$ValidatorResultError(result);
    return result;
};
/**
* @param Object schema
* @return mixed schema uri or false
*/ function $5960d550269863d6$var$shouldResolve(schema) {
    var ref = typeof schema === 'string' ? schema : schema.$ref;
    if (typeof ref == 'string') return ref;
    return false;
}
/**
 * Validates an instance against the schema (the actual work horse)
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @private
 * @return {ValidatorResult}
 */ $5960d550269863d6$var$Validator.prototype.validateSchema = function validateSchema(instance, schema, options, ctx) {
    var result = new $5960d550269863d6$var$ValidatorResult(instance, schema, options, ctx);
    // Support for the true/false schemas
    if (typeof schema === 'boolean') {
        if (schema === true) // `true` is always valid
        schema = {};
        else if (schema === false) // `false` is always invalid
        schema = {
            type: []
        };
    } else if (!schema) // This might be a string
    throw new Error("schema is undefined");
    if (schema['extends']) {
        if (Array.isArray(schema['extends'])) {
            var schemaobj = {
                schema: schema,
                ctx: ctx
            };
            schema['extends'].forEach(this.schemaTraverser.bind(this, schemaobj));
            schema = schemaobj.schema;
            schemaobj.schema = null;
            schemaobj.ctx = null;
            schemaobj = null;
        } else schema = $frSVn.deepMerge(schema, this.superResolve(schema['extends'], ctx));
    }
    // If passed a string argument, load that schema URI
    var switchSchema = $5960d550269863d6$var$shouldResolve(schema);
    if (switchSchema) {
        var resolved = this.resolve(schema, switchSchema, ctx);
        var subctx = new $5960d550269863d6$var$SchemaContext(resolved.subschema, options, ctx.path, resolved.switchSchema, ctx.schemas);
        return this.validateSchema(instance, resolved.subschema, options, subctx);
    }
    var skipAttributes = options && options.skipAttributes || [];
    // Validate each schema attribute against the instance
    for(var key in schema)if (!$8cRmA.ignoreProperties[key] && skipAttributes.indexOf(key) < 0) {
        var validatorErr = null;
        var validator = this.attributes[key];
        if (validator) validatorErr = validator.call(this, instance, schema, options, ctx);
        else if (options.allowUnknownAttributes === false) // This represents an error with the schema itself, not an invalid instance
        throw new $5960d550269863d6$var$SchemaError("Unsupported attribute: " + key, schema);
        if (validatorErr) result.importErrors(validatorErr);
    }
    if (typeof options.rewrite == 'function') {
        var value = options.rewrite.call(this, instance, schema, options, ctx);
        result.instance = value;
    }
    return result;
};
/**
* @private
* @param Object schema
* @param SchemaContext ctx
* @returns Object schema or resolved schema
*/ $5960d550269863d6$var$Validator.prototype.schemaTraverser = function schemaTraverser(schemaobj, s) {
    schemaobj.schema = $frSVn.deepMerge(schemaobj.schema, this.superResolve(s, schemaobj.ctx));
};
/**
* @private
* @param Object schema
* @param SchemaContext ctx
* @returns Object schema or resolved schema
*/ $5960d550269863d6$var$Validator.prototype.superResolve = function superResolve(schema, ctx) {
    var ref = $5960d550269863d6$var$shouldResolve(schema);
    if (ref) return this.resolve(schema, ref, ctx).subschema;
    return schema;
};
/**
* @private
* @param Object schema
* @param Object switchSchema
* @param SchemaContext ctx
* @return Object resolved schemas {subschema:String, switchSchema: String}
* @throws SchemaError
*/ $5960d550269863d6$var$Validator.prototype.resolve = function resolve(schema, switchSchema, ctx) {
    switchSchema = ctx.resolve(switchSchema);
    // First see if the schema exists under the provided URI
    if (ctx.schemas[switchSchema]) return {
        subschema: ctx.schemas[switchSchema],
        switchSchema: switchSchema
    };
    // Else try walking the property pointer
    var parsed = $hM5r1.parse(switchSchema);
    var fragment = parsed && parsed.hash;
    var document = fragment && fragment.length && switchSchema.substr(0, switchSchema.length - fragment.length);
    if (!document || !ctx.schemas[document]) throw new $5960d550269863d6$var$SchemaError("no such schema <" + switchSchema + ">", schema);
    var subschema = $frSVn.objectGetPath(ctx.schemas[document], fragment.substr(1));
    if (subschema === undefined) throw new $5960d550269863d6$var$SchemaError("no such schema " + fragment + " located in <" + document + ">", schema);
    return {
        subschema: subschema,
        switchSchema: switchSchema
    };
};
/**
 * Tests whether the instance if of a certain type.
 * @private
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @param type
 * @return {boolean}
 */ $5960d550269863d6$var$Validator.prototype.testType = function validateType(instance, schema, options, ctx, type) {
    if (type === undefined) return;
    else if (type === null) throw new $5960d550269863d6$var$SchemaError('Unexpected null in "type" keyword');
    if (typeof this.types[type] == 'function') return this.types[type].call(this, instance);
    if (type && typeof type == 'object') {
        var res = this.validateSchema(instance, type, options, ctx);
        return res === undefined || !(res && res.errors.length);
    }
    // Undefined or properties not on the list are acceptable, same as not being defined
    return true;
};
var $5960d550269863d6$var$types = $5960d550269863d6$var$Validator.prototype.types = {};
$5960d550269863d6$var$types.string = function testString(instance) {
    return typeof instance == 'string';
};
$5960d550269863d6$var$types.number = function testNumber(instance) {
    // isFinite returns false for NaN, Infinity, and -Infinity
    return typeof instance == 'number' && isFinite(instance);
};
$5960d550269863d6$var$types.integer = function testInteger(instance) {
    return typeof instance == 'number' && instance % 1 === 0;
};
$5960d550269863d6$var$types.boolean = function testBoolean(instance) {
    return typeof instance == 'boolean';
};
$5960d550269863d6$var$types.array = function testArray(instance) {
    return Array.isArray(instance);
};
$5960d550269863d6$var$types['null'] = function testNull(instance) {
    return instance === null;
};
$5960d550269863d6$var$types.date = function testDate(instance) {
    return instance instanceof Date;
};
$5960d550269863d6$var$types.any = function testAny(instance) {
    return true;
};
$5960d550269863d6$var$types.object = function testObject(instance) {
    // TODO: fix this - see #15
    return instance && typeof instance === 'object' && !Array.isArray(instance) && !(instance instanceof Date);
};
module.exports = $5960d550269863d6$var$Validator;

});
parcelRegister("hM5r1", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $bAZSJ = parcelRequire("bAZSJ");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $kIO7d = parcelRequire("kIO7d");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $kIO7d.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $bAZSJ.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $kIO7d.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $kIO7d.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("bAZSJ", function(module, exports) {
/*! https://mths.be/punycode v1.4.1 by @mathias */ (function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("kIO7d", function(module, exports) {
'use strict';

var $4CQPM = parcelRequire("4CQPM");

var $aim1F = parcelRequire("aim1F");

var $8xQUM = parcelRequire("8xQUM");
module.exports = {
    formats: $8xQUM,
    parse: $aim1F,
    stringify: $4CQPM
};

});
parcelRegister("4CQPM", function(module, exports) {
'use strict';

var $ckP7Q = parcelRequire("ckP7Q");

var $91NrL = parcelRequire("91NrL");

var $8xQUM = parcelRequire("8xQUM");
var $35e3b1d1a59ade50$var$has = Object.prototype.hasOwnProperty;
var $35e3b1d1a59ade50$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $35e3b1d1a59ade50$var$isArray = Array.isArray;
var $35e3b1d1a59ade50$var$push = Array.prototype.push;
var $35e3b1d1a59ade50$var$pushToArray = function(arr, valueOrArray) {
    $35e3b1d1a59ade50$var$push.apply(arr, $35e3b1d1a59ade50$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $35e3b1d1a59ade50$var$toISO = Date.prototype.toISOString;
var $35e3b1d1a59ade50$var$defaultFormat = $8xQUM.default;
var $35e3b1d1a59ade50$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $91NrL.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $35e3b1d1a59ade50$var$defaultFormat,
    formatter: $8xQUM.formatters[$35e3b1d1a59ade50$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $35e3b1d1a59ade50$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $35e3b1d1a59ade50$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $35e3b1d1a59ade50$var$sentinel = {};
var $35e3b1d1a59ade50$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($35e3b1d1a59ade50$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($35e3b1d1a59ade50$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $35e3b1d1a59ade50$var$isArray(obj)) obj = $91NrL.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $35e3b1d1a59ade50$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($35e3b1d1a59ade50$var$isNonNullishPrimitive(obj) || $91NrL.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $35e3b1d1a59ade50$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $35e3b1d1a59ade50$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $35e3b1d1a59ade50$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $91NrL.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($35e3b1d1a59ade50$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $35e3b1d1a59ade50$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $35e3b1d1a59ade50$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $35e3b1d1a59ade50$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $ckP7Q();
        valueSideChannel.set($35e3b1d1a59ade50$var$sentinel, sideChannel);
        $35e3b1d1a59ade50$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $35e3b1d1a59ade50$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $35e3b1d1a59ade50$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $35e3b1d1a59ade50$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $35e3b1d1a59ade50$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $8xQUM.default;
    if (typeof opts.format !== 'undefined') {
        if (!$35e3b1d1a59ade50$var$has.call($8xQUM.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $8xQUM.formatters[format];
    var filter = $35e3b1d1a59ade50$var$defaults.filter;
    if (typeof opts.filter === 'function' || $35e3b1d1a59ade50$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $35e3b1d1a59ade50$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $35e3b1d1a59ade50$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $35e3b1d1a59ade50$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $35e3b1d1a59ade50$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $35e3b1d1a59ade50$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $35e3b1d1a59ade50$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $35e3b1d1a59ade50$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $35e3b1d1a59ade50$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $35e3b1d1a59ade50$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $35e3b1d1a59ade50$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $35e3b1d1a59ade50$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $35e3b1d1a59ade50$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $35e3b1d1a59ade50$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $35e3b1d1a59ade50$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $35e3b1d1a59ade50$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($35e3b1d1a59ade50$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $35e3b1d1a59ade50$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $ckP7Q();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $35e3b1d1a59ade50$var$pushToArray(keys, $35e3b1d1a59ade50$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("ckP7Q", function(module, exports) {
'use strict';

var $4jDfL = parcelRequire("4jDfL");

var $9MXmW = parcelRequire("9MXmW");

var $7gNss = parcelRequire("7gNss");

var $jAg4Y = parcelRequire("jAg4Y");

var $kXG7e = parcelRequire("kXG7e");
var $8faf02bc209a5857$var$makeChannel = $kXG7e || $jAg4Y || $7gNss;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $4jDfL('Side channel does not contain ' + $9MXmW(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $8faf02bc209a5857$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});
parcelRegister("4jDfL", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("9MXmW", function(module, exports) {
var $7206a639b7157287$var$hasMap = typeof Map === 'function' && Map.prototype;
var $7206a639b7157287$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $7206a639b7157287$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $7206a639b7157287$var$mapSize = $7206a639b7157287$var$hasMap && $7206a639b7157287$var$mapSizeDescriptor && typeof $7206a639b7157287$var$mapSizeDescriptor.get === 'function' ? $7206a639b7157287$var$mapSizeDescriptor.get : null;
var $7206a639b7157287$var$mapForEach = $7206a639b7157287$var$hasMap && Map.prototype.forEach;
var $7206a639b7157287$var$hasSet = typeof Set === 'function' && Set.prototype;
var $7206a639b7157287$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $7206a639b7157287$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $7206a639b7157287$var$setSize = $7206a639b7157287$var$hasSet && $7206a639b7157287$var$setSizeDescriptor && typeof $7206a639b7157287$var$setSizeDescriptor.get === 'function' ? $7206a639b7157287$var$setSizeDescriptor.get : null;
var $7206a639b7157287$var$setForEach = $7206a639b7157287$var$hasSet && Set.prototype.forEach;
var $7206a639b7157287$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $7206a639b7157287$var$weakMapHas = $7206a639b7157287$var$hasWeakMap ? WeakMap.prototype.has : null;
var $7206a639b7157287$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $7206a639b7157287$var$weakSetHas = $7206a639b7157287$var$hasWeakSet ? WeakSet.prototype.has : null;
var $7206a639b7157287$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $7206a639b7157287$var$weakRefDeref = $7206a639b7157287$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $7206a639b7157287$var$booleanValueOf = Boolean.prototype.valueOf;
var $7206a639b7157287$var$objectToString = Object.prototype.toString;
var $7206a639b7157287$var$functionToString = Function.prototype.toString;
var $7206a639b7157287$var$$match = String.prototype.match;
var $7206a639b7157287$var$$slice = String.prototype.slice;
var $7206a639b7157287$var$$replace = String.prototype.replace;
var $7206a639b7157287$var$$toUpperCase = String.prototype.toUpperCase;
var $7206a639b7157287$var$$toLowerCase = String.prototype.toLowerCase;
var $7206a639b7157287$var$$test = RegExp.prototype.test;
var $7206a639b7157287$var$$concat = Array.prototype.concat;
var $7206a639b7157287$var$$join = Array.prototype.join;
var $7206a639b7157287$var$$arrSlice = Array.prototype.slice;
var $7206a639b7157287$var$$floor = Math.floor;
var $7206a639b7157287$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $7206a639b7157287$var$gOPS = Object.getOwnPropertySymbols;
var $7206a639b7157287$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $7206a639b7157287$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $7206a639b7157287$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $7206a639b7157287$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $7206a639b7157287$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $7206a639b7157287$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $7206a639b7157287$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $7206a639b7157287$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$7206a639b7157287$var$$floor(-num) : $7206a639b7157287$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $7206a639b7157287$var$$slice.call(str, intStr.length + 1);
            return $7206a639b7157287$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $7206a639b7157287$var$$replace.call($7206a639b7157287$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $7206a639b7157287$var$$replace.call(str, sepRegex, '$&_');
}

var $9g24W = parcelRequire("9g24W");
var $7206a639b7157287$var$inspectCustom = $9g24W.custom;
var $7206a639b7157287$var$inspectSymbol = $7206a639b7157287$var$isSymbol($7206a639b7157287$var$inspectCustom) ? $7206a639b7157287$var$inspectCustom : null;
var $7206a639b7157287$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $7206a639b7157287$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($7206a639b7157287$var$has(opts, 'quoteStyle') && !$7206a639b7157287$var$has($7206a639b7157287$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($7206a639b7157287$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $7206a639b7157287$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($7206a639b7157287$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($7206a639b7157287$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $7206a639b7157287$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $7206a639b7157287$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $7206a639b7157287$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $7206a639b7157287$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $7206a639b7157287$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($7206a639b7157287$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $7206a639b7157287$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($7206a639b7157287$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$7206a639b7157287$var$isRegExp(obj)) {
        var name = $7206a639b7157287$var$nameOf(obj);
        var keys = $7206a639b7157287$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $7206a639b7157287$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($7206a639b7157287$var$isSymbol(obj)) {
        var symString = $7206a639b7157287$var$hasShammedSymbols ? $7206a639b7157287$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $7206a639b7157287$var$symToString.call(obj);
        return typeof obj === 'object' && !$7206a639b7157287$var$hasShammedSymbols ? $7206a639b7157287$var$markBoxed(symString) : symString;
    }
    if ($7206a639b7157287$var$isElement(obj)) {
        var s = '<' + $7206a639b7157287$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $7206a639b7157287$var$wrapQuotes($7206a639b7157287$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $7206a639b7157287$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($7206a639b7157287$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $7206a639b7157287$var$arrObjKeys(obj, inspect);
        if (indent && !$7206a639b7157287$var$singleLineValues(xs)) return '[' + $7206a639b7157287$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $7206a639b7157287$var$$join.call(xs, ', ') + ' ]';
    }
    if ($7206a639b7157287$var$isError(obj)) {
        var parts = $7206a639b7157287$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$7206a639b7157287$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $7206a639b7157287$var$$join.call($7206a639b7157287$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $7206a639b7157287$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($7206a639b7157287$var$inspectSymbol && typeof obj[$7206a639b7157287$var$inspectSymbol] === 'function' && $9g24W) return $9g24W(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($7206a639b7157287$var$isMap(obj)) {
        var mapParts = [];
        if ($7206a639b7157287$var$mapForEach) $7206a639b7157287$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $7206a639b7157287$var$collectionOf('Map', $7206a639b7157287$var$mapSize.call(obj), mapParts, indent);
    }
    if ($7206a639b7157287$var$isSet(obj)) {
        var setParts = [];
        if ($7206a639b7157287$var$setForEach) $7206a639b7157287$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $7206a639b7157287$var$collectionOf('Set', $7206a639b7157287$var$setSize.call(obj), setParts, indent);
    }
    if ($7206a639b7157287$var$isWeakMap(obj)) return $7206a639b7157287$var$weakCollectionOf('WeakMap');
    if ($7206a639b7157287$var$isWeakSet(obj)) return $7206a639b7157287$var$weakCollectionOf('WeakSet');
    if ($7206a639b7157287$var$isWeakRef(obj)) return $7206a639b7157287$var$weakCollectionOf('WeakRef');
    if ($7206a639b7157287$var$isNumber(obj)) return $7206a639b7157287$var$markBoxed(inspect(Number(obj)));
    if ($7206a639b7157287$var$isBigInt(obj)) return $7206a639b7157287$var$markBoxed(inspect($7206a639b7157287$var$bigIntValueOf.call(obj)));
    if ($7206a639b7157287$var$isBoolean(obj)) return $7206a639b7157287$var$markBoxed($7206a639b7157287$var$booleanValueOf.call(obj));
    if ($7206a639b7157287$var$isString(obj)) return $7206a639b7157287$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$7206a639b7157287$var$isDate(obj) && !$7206a639b7157287$var$isRegExp(obj)) {
        var ys = $7206a639b7157287$var$arrObjKeys(obj, inspect);
        var isPlainObject = $7206a639b7157287$var$gPO ? $7206a639b7157287$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $7206a639b7157287$var$toStringTag && Object(obj) === obj && $7206a639b7157287$var$toStringTag in obj ? $7206a639b7157287$var$$slice.call($7206a639b7157287$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $7206a639b7157287$var$$join.call($7206a639b7157287$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $7206a639b7157287$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $7206a639b7157287$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $7206a639b7157287$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $7206a639b7157287$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $7206a639b7157287$var$quote(s) {
    return $7206a639b7157287$var$$replace.call(String(s), /"/g, '&quot;');
}
function $7206a639b7157287$var$canTrustToString(obj) {
    return !$7206a639b7157287$var$toStringTag || !(typeof obj === 'object' && ($7206a639b7157287$var$toStringTag in obj || typeof obj[$7206a639b7157287$var$toStringTag] !== 'undefined'));
}
function $7206a639b7157287$var$isArray(obj) {
    return $7206a639b7157287$var$toStr(obj) === '[object Array]' && $7206a639b7157287$var$canTrustToString(obj);
}
function $7206a639b7157287$var$isDate(obj) {
    return $7206a639b7157287$var$toStr(obj) === '[object Date]' && $7206a639b7157287$var$canTrustToString(obj);
}
function $7206a639b7157287$var$isRegExp(obj) {
    return $7206a639b7157287$var$toStr(obj) === '[object RegExp]' && $7206a639b7157287$var$canTrustToString(obj);
}
function $7206a639b7157287$var$isError(obj) {
    return $7206a639b7157287$var$toStr(obj) === '[object Error]' && $7206a639b7157287$var$canTrustToString(obj);
}
function $7206a639b7157287$var$isString(obj) {
    return $7206a639b7157287$var$toStr(obj) === '[object String]' && $7206a639b7157287$var$canTrustToString(obj);
}
function $7206a639b7157287$var$isNumber(obj) {
    return $7206a639b7157287$var$toStr(obj) === '[object Number]' && $7206a639b7157287$var$canTrustToString(obj);
}
function $7206a639b7157287$var$isBoolean(obj) {
    return $7206a639b7157287$var$toStr(obj) === '[object Boolean]' && $7206a639b7157287$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $7206a639b7157287$var$isSymbol(obj) {
    if ($7206a639b7157287$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$7206a639b7157287$var$symToString) return false;
    try {
        $7206a639b7157287$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $7206a639b7157287$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$7206a639b7157287$var$bigIntValueOf) return false;
    try {
        $7206a639b7157287$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $7206a639b7157287$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $7206a639b7157287$var$has(obj, key) {
    return $7206a639b7157287$var$hasOwn.call(obj, key);
}
function $7206a639b7157287$var$toStr(obj) {
    return $7206a639b7157287$var$objectToString.call(obj);
}
function $7206a639b7157287$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $7206a639b7157287$var$$match.call($7206a639b7157287$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $7206a639b7157287$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $7206a639b7157287$var$isMap(x) {
    if (!$7206a639b7157287$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $7206a639b7157287$var$mapSize.call(x);
        try {
            $7206a639b7157287$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $7206a639b7157287$var$isWeakMap(x) {
    if (!$7206a639b7157287$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $7206a639b7157287$var$weakMapHas.call(x, $7206a639b7157287$var$weakMapHas);
        try {
            $7206a639b7157287$var$weakSetHas.call(x, $7206a639b7157287$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $7206a639b7157287$var$isWeakRef(x) {
    if (!$7206a639b7157287$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $7206a639b7157287$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $7206a639b7157287$var$isSet(x) {
    if (!$7206a639b7157287$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $7206a639b7157287$var$setSize.call(x);
        try {
            $7206a639b7157287$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $7206a639b7157287$var$isWeakSet(x) {
    if (!$7206a639b7157287$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $7206a639b7157287$var$weakSetHas.call(x, $7206a639b7157287$var$weakSetHas);
        try {
            $7206a639b7157287$var$weakMapHas.call(x, $7206a639b7157287$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $7206a639b7157287$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $7206a639b7157287$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $7206a639b7157287$var$inspectString($7206a639b7157287$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $7206a639b7157287$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $7206a639b7157287$var$$replace.call($7206a639b7157287$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $7206a639b7157287$var$lowbyte);
    return $7206a639b7157287$var$wrapQuotes(s, 'single', opts);
}
function $7206a639b7157287$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $7206a639b7157287$var$$toUpperCase.call(n.toString(16));
}
function $7206a639b7157287$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $7206a639b7157287$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $7206a639b7157287$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $7206a639b7157287$var$indentedJoin(entries, indent) : $7206a639b7157287$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $7206a639b7157287$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($7206a639b7157287$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $7206a639b7157287$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $7206a639b7157287$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $7206a639b7157287$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $7206a639b7157287$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $7206a639b7157287$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $7206a639b7157287$var$arrObjKeys(obj, inspect) {
    var isArr = $7206a639b7157287$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $7206a639b7157287$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $7206a639b7157287$var$gOPS === 'function' ? $7206a639b7157287$var$gOPS(obj) : [];
    var symMap;
    if ($7206a639b7157287$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$7206a639b7157287$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($7206a639b7157287$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($7206a639b7157287$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $7206a639b7157287$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($7206a639b7157287$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("9g24W", function(module, exports) {
"use strict";

});


parcelRegister("7gNss", function(module, exports) {
'use strict';

var $9MXmW = parcelRequire("9MXmW");

var $4jDfL = parcelRequire("4jDfL");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $54b0645a94d5f437$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $54b0645a94d5f437$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $54b0645a94d5f437$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $54b0645a94d5f437$var$listSet = function(objects, key, value) {
    var node = $54b0645a94d5f437$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $54b0645a94d5f437$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$54b0645a94d5f437$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $54b0645a94d5f437$var$listDelete = function(objects, key) {
    if (objects) return $54b0645a94d5f437$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $4jDfL('Side channel does not contain ' + $9MXmW(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $54b0645a94d5f437$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $54b0645a94d5f437$var$listGet($o, key);
        },
        has: function(key) {
            return $54b0645a94d5f437$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $54b0645a94d5f437$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});

parcelRegister("jAg4Y", function(module, exports) {
'use strict';

var $2Okay = parcelRequire("2Okay");

var $4XrrU = parcelRequire("4XrrU");

var $9MXmW = parcelRequire("9MXmW");

var $4jDfL = parcelRequire("4jDfL");
var $e41dda1e775e1e81$var$$Map = $2Okay('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $e41dda1e775e1e81$var$$mapGet = $4XrrU('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $e41dda1e775e1e81$var$$mapSet = $4XrrU('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $e41dda1e775e1e81$var$$mapHas = $4XrrU('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $e41dda1e775e1e81$var$$mapDelete = $4XrrU('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $e41dda1e775e1e81$var$$mapSize = $4XrrU('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$e41dda1e775e1e81$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $4jDfL('Side channel does not contain ' + $9MXmW(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $e41dda1e775e1e81$var$$mapDelete($m, key);
                if ($e41dda1e775e1e81$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $e41dda1e775e1e81$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $e41dda1e775e1e81$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $e41dda1e775e1e81$var$$Map();
            $e41dda1e775e1e81$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("2Okay", function(module, exports) {
'use strict';
var $20bfe57777138719$var$undefined1;

var $gDafl = parcelRequire("gDafl");

var $hzZFL = parcelRequire("hzZFL");

var $hbYsn = parcelRequire("hbYsn");

var $0rATh = parcelRequire("0rATh");

var $9cPGv = parcelRequire("9cPGv");

var $dNB2P = parcelRequire("dNB2P");

var $4jDfL = parcelRequire("4jDfL");

var $k2mz1 = parcelRequire("k2mz1");

var $LXqVr = parcelRequire("LXqVr");

var $2B9aS = parcelRequire("2B9aS");

var $dsVgb = parcelRequire("dsVgb");

var $1Aiq5 = parcelRequire("1Aiq5");

var $bangn = parcelRequire("bangn");

var $aOBhR = parcelRequire("aOBhR");

var $2dnuB = parcelRequire("2dnuB");
var $20bfe57777138719$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $20bfe57777138719$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $20bfe57777138719$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $3iCJh = parcelRequire("3iCJh");

var $35BII = parcelRequire("35BII");
var $20bfe57777138719$var$throwTypeError = function() {
    throw new $4jDfL();
};
var $20bfe57777138719$var$ThrowTypeError = $3iCJh ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $20bfe57777138719$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $3iCJh(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $20bfe57777138719$var$throwTypeError;
        }
    }
}() : $20bfe57777138719$var$throwTypeError;

var $20bfe57777138719$var$hasSymbols = (parcelRequire("7psNr"))();

var $5P2nR = parcelRequire("5P2nR");

var $eYorT = parcelRequire("eYorT");

var $di5qO = parcelRequire("di5qO");

var $i8boE = parcelRequire("i8boE");

var $cQyfH = parcelRequire("cQyfH");
var $20bfe57777138719$var$needsEval = {};
var $20bfe57777138719$var$TypedArray = typeof Uint8Array === 'undefined' || !$5P2nR ? undefined : $5P2nR(Uint8Array);
var $20bfe57777138719$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $20bfe57777138719$var$hasSymbols && $5P2nR ? $5P2nR([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $20bfe57777138719$var$needsEval,
    '%AsyncGenerator%': $20bfe57777138719$var$needsEval,
    '%AsyncGeneratorFunction%': $20bfe57777138719$var$needsEval,
    '%AsyncIteratorPrototype%': $20bfe57777138719$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $hzZFL,
    '%eval%': eval,
    '%EvalError%': $hbYsn,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $20bfe57777138719$var$$Function,
    '%GeneratorFunction%': $20bfe57777138719$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $20bfe57777138719$var$hasSymbols && $5P2nR ? $5P2nR($5P2nR([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$20bfe57777138719$var$hasSymbols || !$5P2nR ? undefined : $5P2nR(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $gDafl,
    '%Object.getOwnPropertyDescriptor%': $3iCJh,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $0rATh,
    '%ReferenceError%': $9cPGv,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$20bfe57777138719$var$hasSymbols || !$5P2nR ? undefined : $5P2nR(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $20bfe57777138719$var$hasSymbols && $5P2nR ? $5P2nR(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $20bfe57777138719$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $dNB2P,
    '%ThrowTypeError%': $20bfe57777138719$var$ThrowTypeError,
    '%TypedArray%': $20bfe57777138719$var$TypedArray,
    '%TypeError%': $4jDfL,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $k2mz1,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $cQyfH,
    '%Function.prototype.apply%': $i8boE,
    '%Object.defineProperty%': $35BII,
    '%Object.getPrototypeOf%': $eYorT,
    '%Math.abs%': $LXqVr,
    '%Math.floor%': $2B9aS,
    '%Math.max%': $dsVgb,
    '%Math.min%': $1Aiq5,
    '%Math.pow%': $bangn,
    '%Math.round%': $aOBhR,
    '%Math.sign%': $2dnuB,
    '%Reflect.getPrototypeOf%': $di5qO
};
if ($5P2nR) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $20bfe57777138719$var$errorProto = $5P2nR($5P2nR(e));
    $20bfe57777138719$var$INTRINSICS['%Error.prototype%'] = $20bfe57777138719$var$errorProto;
}
var $20bfe57777138719$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $20bfe57777138719$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $20bfe57777138719$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $20bfe57777138719$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $5P2nR) value = $5P2nR(gen.prototype);
    }
    $20bfe57777138719$var$INTRINSICS[name] = value;
    return value;
};
var $20bfe57777138719$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $5bWhi = parcelRequire("5bWhi");

var $9sOn7 = parcelRequire("9sOn7");
var $20bfe57777138719$var$$concat = $5bWhi.call($cQyfH, Array.prototype.concat);
var $20bfe57777138719$var$$spliceApply = $5bWhi.call($i8boE, Array.prototype.splice);
var $20bfe57777138719$var$$replace = $5bWhi.call($cQyfH, String.prototype.replace);
var $20bfe57777138719$var$$strSlice = $5bWhi.call($cQyfH, String.prototype.slice);
var $20bfe57777138719$var$$exec = $5bWhi.call($cQyfH, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $20bfe57777138719$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $20bfe57777138719$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $20bfe57777138719$var$stringToPath = function stringToPath(string) {
    var first = $20bfe57777138719$var$$strSlice(string, 0, 1);
    var last = $20bfe57777138719$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $dNB2P('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $dNB2P('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $20bfe57777138719$var$$replace(string, $20bfe57777138719$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $20bfe57777138719$var$$replace(subString, $20bfe57777138719$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $20bfe57777138719$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($9sOn7($20bfe57777138719$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $20bfe57777138719$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($9sOn7($20bfe57777138719$var$INTRINSICS, intrinsicName)) {
        var value = $20bfe57777138719$var$INTRINSICS[intrinsicName];
        if (value === $20bfe57777138719$var$needsEval) value = $20bfe57777138719$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $4jDfL('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $dNB2P('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $4jDfL('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $4jDfL('"allowMissing" argument must be a boolean');
    if ($20bfe57777138719$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $dNB2P('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $20bfe57777138719$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $20bfe57777138719$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $20bfe57777138719$var$$spliceApply(parts, $20bfe57777138719$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $20bfe57777138719$var$$strSlice(part, 0, 1);
        var last = $20bfe57777138719$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $dNB2P('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($9sOn7($20bfe57777138719$var$INTRINSICS, intrinsicRealName)) value = $20bfe57777138719$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $4jDfL('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($3iCJh && i + 1 >= parts.length) {
                var desc = $3iCJh(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $9sOn7(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $20bfe57777138719$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("gDafl", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("hzZFL", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hbYsn", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("0rATh", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("9cPGv", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("dNB2P", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("k2mz1", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("LXqVr", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("2B9aS", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("dsVgb", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("1Aiq5", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("bangn", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("aOBhR", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("2dnuB", function(module, exports) {
'use strict';

var $l58jB = parcelRequire("l58jB");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($l58jB(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("l58jB", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("3iCJh", function(module, exports) {
'use strict';

var $6wp5I = parcelRequire("6wp5I");
var $2671185be0e30ea3$require$$gOPD = $6wp5I;
if ($2671185be0e30ea3$require$$gOPD) try {
    $2671185be0e30ea3$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $2671185be0e30ea3$require$$gOPD = null;
}
module.exports = $2671185be0e30ea3$require$$gOPD;

});
parcelRegister("6wp5I", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("35BII", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $23ff192bdffb2322$var$$defineProperty = Object.defineProperty || false;
if ($23ff192bdffb2322$var$$defineProperty) try {
    $23ff192bdffb2322$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $23ff192bdffb2322$var$$defineProperty = false;
}
module.exports = $23ff192bdffb2322$var$$defineProperty;

});

parcelRegister("7psNr", function(module, exports) {
'use strict';
var $56513496a49c9e7c$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $61RRI = parcelRequire("61RRI");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $56513496a49c9e7c$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $56513496a49c9e7c$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $61RRI();
};

});
parcelRegister("61RRI", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("5P2nR", function(module, exports) {
'use strict';

var $di5qO = parcelRequire("di5qO");

var $eYorT = parcelRequire("eYorT");

var $doRDz = parcelRequire("doRDz");
/** @type {import('.')} */ module.exports = $di5qO ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $di5qO(O);
} : $eYorT ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $eYorT(O);
} : $doRDz ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $doRDz(O);
} : null;

});
parcelRegister("di5qO", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("eYorT", function(module, exports) {
'use strict';

var $gDafl = parcelRequire("gDafl");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $gDafl.getPrototypeOf || null;

});

parcelRegister("doRDz", function(module, exports) {
'use strict';

var $iTslY = parcelRequire("iTslY");

var $3iCJh = parcelRequire("3iCJh");
var $9c171f7987f96a4e$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $9c171f7987f96a4e$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $9c171f7987f96a4e$var$desc = !!$9c171f7987f96a4e$var$hasProtoAccessor && $3iCJh && $3iCJh(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $9c171f7987f96a4e$var$$Object = Object;
var $9c171f7987f96a4e$var$$getPrototypeOf = $9c171f7987f96a4e$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $9c171f7987f96a4e$var$desc && typeof $9c171f7987f96a4e$var$desc.get === 'function' ? $iTslY([
    $9c171f7987f96a4e$var$desc.get
]) : typeof $9c171f7987f96a4e$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $9c171f7987f96a4e$var$$getPrototypeOf(value == null ? value : $9c171f7987f96a4e$var$$Object(value));
} : false;

});
parcelRegister("iTslY", function(module, exports) {
'use strict';

var $5bWhi = parcelRequire("5bWhi");

var $4jDfL = parcelRequire("4jDfL");

var $cQyfH = parcelRequire("cQyfH");

var $fKreL = parcelRequire("fKreL");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $4jDfL('a function is required');
    return $fKreL($5bWhi, $cQyfH, args);
};

});
parcelRegister("5bWhi", function(module, exports) {
'use strict';

var $14aTC = parcelRequire("14aTC");
module.exports = Function.prototype.bind || $14aTC;

});
parcelRegister("14aTC", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $0c6e9de099385de3$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $0c6e9de099385de3$var$toStr = Object.prototype.toString;
var $0c6e9de099385de3$var$max = Math.max;
var $0c6e9de099385de3$var$funcType = '[object Function]';
var $0c6e9de099385de3$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $0c6e9de099385de3$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $0c6e9de099385de3$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $0c6e9de099385de3$var$toStr.apply(target) !== $0c6e9de099385de3$var$funcType) throw new TypeError($0c6e9de099385de3$var$ERROR_MESSAGE + target);
    var args = $0c6e9de099385de3$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $0c6e9de099385de3$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $0c6e9de099385de3$var$concatty(args, arguments));
    };
    var boundLength = $0c6e9de099385de3$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $0c6e9de099385de3$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("cQyfH", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("fKreL", function(module, exports) {
'use strict';

var $5bWhi = parcelRequire("5bWhi");

var $i8boE = parcelRequire("i8boE");

var $cQyfH = parcelRequire("cQyfH");

var $5rQB6 = parcelRequire("5rQB6");
/** @type {import('./actualApply')} */ module.exports = $5rQB6 || $5bWhi.call($cQyfH, $i8boE);

});
parcelRegister("i8boE", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("5rQB6", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("9sOn7", function(module, exports) {
'use strict';
var $6e3dcd65467b958e$var$call = Function.prototype.call;
var $6e3dcd65467b958e$var$$hasOwn = Object.prototype.hasOwnProperty;

var $5bWhi = parcelRequire("5bWhi");
/** @type {import('.')} */ module.exports = $5bWhi.call($6e3dcd65467b958e$var$call, $6e3dcd65467b958e$var$$hasOwn);

});


parcelRegister("4XrrU", function(module, exports) {
'use strict';

var $2Okay = parcelRequire("2Okay");

var $iTslY = parcelRequire("iTslY");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $39c1f6ece7433cab$var$$indexOf = $iTslY([
    $2Okay('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $2Okay(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $39c1f6ece7433cab$var$$indexOf(name, '.prototype.') > -1) return $iTslY(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("kXG7e", function(module, exports) {
'use strict';

var $2Okay = parcelRequire("2Okay");

var $4XrrU = parcelRequire("4XrrU");

var $9MXmW = parcelRequire("9MXmW");

var $jAg4Y = parcelRequire("jAg4Y");

var $4jDfL = parcelRequire("4jDfL");
var $f429fc9c1889a9c0$var$$WeakMap = $2Okay('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $f429fc9c1889a9c0$var$$weakMapGet = $4XrrU('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $f429fc9c1889a9c0$var$$weakMapSet = $4XrrU('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $f429fc9c1889a9c0$var$$weakMapHas = $4XrrU('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $f429fc9c1889a9c0$var$$weakMapDelete = $4XrrU('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $f429fc9c1889a9c0$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $4jDfL('Side channel does not contain ' + $9MXmW(key));
        },
        'delete': function(key) {
            if ($f429fc9c1889a9c0$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $f429fc9c1889a9c0$var$$weakMapDelete($wm, key);
            } else if ($jAg4Y) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($f429fc9c1889a9c0$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $f429fc9c1889a9c0$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($f429fc9c1889a9c0$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $f429fc9c1889a9c0$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($f429fc9c1889a9c0$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $f429fc9c1889a9c0$var$$WeakMap();
                $f429fc9c1889a9c0$var$$weakMapSet($wm, key, value);
            } else if ($jAg4Y) {
                if (!$m) $m = $jAg4Y();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $jAg4Y;

});


parcelRegister("91NrL", function(module, exports) {
'use strict';

var $8xQUM = parcelRequire("8xQUM");

var $ckP7Q = parcelRequire("ckP7Q");
var $692a9027b13bb397$var$has = Object.prototype.hasOwnProperty;
var $692a9027b13bb397$var$isArray = Array.isArray;
// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var $692a9027b13bb397$var$overflowChannel = $ckP7Q();
var $692a9027b13bb397$var$markOverflow = function markOverflow(obj, maxIndex) {
    $692a9027b13bb397$var$overflowChannel.set(obj, maxIndex);
    return obj;
};
var $692a9027b13bb397$var$isOverflow = function isOverflow(obj) {
    return $692a9027b13bb397$var$overflowChannel.has(obj);
};
var $692a9027b13bb397$var$getMaxIndex = function getMaxIndex(obj) {
    return $692a9027b13bb397$var$overflowChannel.get(obj);
};
var $692a9027b13bb397$var$setMaxIndex = function setMaxIndex(obj, maxIndex) {
    $692a9027b13bb397$var$overflowChannel.set(obj, maxIndex);
};
var $692a9027b13bb397$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    return array;
}();
var $692a9027b13bb397$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($692a9027b13bb397$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted[compacted.length] = obj[j];
            item.obj[item.prop] = compacted;
        }
    }
};
var $692a9027b13bb397$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $692a9027b13bb397$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($692a9027b13bb397$var$isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex > options.arrayLimit) return $692a9027b13bb397$var$markOverflow($692a9027b13bb397$var$arrayToObject(target.concat(source), options), nextIndex);
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if ($692a9027b13bb397$var$isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = $692a9027b13bb397$var$getMaxIndex(target) + 1;
                target[newIndex] = source;
                $692a9027b13bb397$var$setMaxIndex(target, newIndex);
            } else if (options && (options.plainObjects || options.allowPrototypes) || !$692a9027b13bb397$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') {
        if ($692a9027b13bb397$var$isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects ? {
                __proto__: null,
                0: target
            } : {
                0: target
            };
            for(var m = 0; m < sourceKeys.length; m++){
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return $692a9027b13bb397$var$markOverflow(result, $692a9027b13bb397$var$getMaxIndex(source) + 1);
        }
        var combined = [
            target
        ].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) return $692a9027b13bb397$var$markOverflow($692a9027b13bb397$var$arrayToObject(combined, options), combined.length - 1);
        return combined;
    }
    var mergeTarget = target;
    if ($692a9027b13bb397$var$isArray(target) && !$692a9027b13bb397$var$isArray(source)) mergeTarget = $692a9027b13bb397$var$arrayToObject(target, options);
    if ($692a9027b13bb397$var$isArray(target) && $692a9027b13bb397$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($692a9027b13bb397$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target[target.length] = item;
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($692a9027b13bb397$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        if ($692a9027b13bb397$var$isOverflow(source) && !$692a9027b13bb397$var$isOverflow(acc)) $692a9027b13bb397$var$markOverflow(acc, $692a9027b13bb397$var$getMaxIndex(source));
        if ($692a9027b13bb397$var$isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > $692a9027b13bb397$var$getMaxIndex(acc)) $692a9027b13bb397$var$setMaxIndex(acc, keyNum);
        }
        return acc;
    }, mergeTarget);
};
var $692a9027b13bb397$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $692a9027b13bb397$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $692a9027b13bb397$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $692a9027b13bb397$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $692a9027b13bb397$var$limit){
        var segment = string.length >= $692a9027b13bb397$var$limit ? string.slice(j, j + $692a9027b13bb397$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $8xQUM.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $692a9027b13bb397$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $692a9027b13bb397$var$hexTable[0xC0 | c >> 6] + $692a9027b13bb397$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $692a9027b13bb397$var$hexTable[0xE0 | c >> 12] + $692a9027b13bb397$var$hexTable[0x80 | c >> 6 & 0x3F] + $692a9027b13bb397$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $692a9027b13bb397$var$hexTable[0xF0 | c >> 18] + $692a9027b13bb397$var$hexTable[0x80 | c >> 12 & 0x3F] + $692a9027b13bb397$var$hexTable[0x80 | c >> 6 & 0x3F] + $692a9027b13bb397$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $692a9027b13bb397$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue[queue.length] = {
                    obj: obj,
                    prop: key
                };
                refs[refs.length] = val;
            }
        }
    }
    $692a9027b13bb397$var$compactQueue(queue);
    return value;
};
var $692a9027b13bb397$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $692a9027b13bb397$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $692a9027b13bb397$var$combine = function combine(a, b, arrayLimit, plainObjects) {
    // If 'a' is already an overflow object, add to it
    if ($692a9027b13bb397$var$isOverflow(a)) {
        var newIndex = $692a9027b13bb397$var$getMaxIndex(a) + 1;
        a[newIndex] = b;
        $692a9027b13bb397$var$setMaxIndex(a, newIndex);
        return a;
    }
    var result = [].concat(a, b);
    if (result.length > arrayLimit) return $692a9027b13bb397$var$markOverflow($692a9027b13bb397$var$arrayToObject(result, {
        plainObjects: plainObjects
    }), result.length - 1);
    return result;
};
var $692a9027b13bb397$var$maybeMap = function maybeMap(val, fn) {
    if ($692a9027b13bb397$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped[mapped.length] = fn(val[i]);
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $692a9027b13bb397$var$arrayToObject,
    assign: $692a9027b13bb397$var$assign,
    combine: $692a9027b13bb397$var$combine,
    compact: $692a9027b13bb397$var$compact,
    decode: $692a9027b13bb397$var$decode,
    encode: $692a9027b13bb397$var$encode,
    isBuffer: $692a9027b13bb397$var$isBuffer,
    isOverflow: $692a9027b13bb397$var$isOverflow,
    isRegExp: $692a9027b13bb397$var$isRegExp,
    markOverflow: $692a9027b13bb397$var$markOverflow,
    maybeMap: $692a9027b13bb397$var$maybeMap,
    merge: $692a9027b13bb397$var$merge
};

});
parcelRegister("8xQUM", function(module, exports) {
'use strict';
var $638a739431440329$var$replace = String.prototype.replace;
var $638a739431440329$var$percentTwenties = /%20/g;
var $638a739431440329$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $638a739431440329$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $638a739431440329$var$replace.call(value, $638a739431440329$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $638a739431440329$var$Format.RFC1738,
    RFC3986: $638a739431440329$var$Format.RFC3986
};

});



parcelRegister("aim1F", function(module, exports) {
'use strict';

var $91NrL = parcelRequire("91NrL");
var $77ecabae9a966568$var$has = Object.prototype.hasOwnProperty;
var $77ecabae9a966568$var$isArray = Array.isArray;
var $77ecabae9a966568$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $91NrL.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $77ecabae9a966568$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $77ecabae9a966568$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $77ecabae9a966568$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $77ecabae9a966568$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $77ecabae9a966568$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $77ecabae9a966568$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $77ecabae9a966568$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $77ecabae9a966568$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $77ecabae9a966568$var$defaults.decoder, charset, 'key');
            if (key !== null) val = $91NrL.maybeMap($77ecabae9a966568$var$parseArrayValue(part.slice(pos + 1), options, $77ecabae9a966568$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $77ecabae9a966568$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $77ecabae9a966568$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $77ecabae9a966568$var$isArray(val) ? [
            val
        ] : val;
        if (options.comma && $77ecabae9a966568$var$isArray(val) && val.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            val = $91NrL.combine([], val, options.arrayLimit, options.plainObjects);
        }
        if (key !== null) {
            var existing = $77ecabae9a966568$var$has.call(obj, key);
            if (existing && options.duplicates === 'combine') obj[key] = $91NrL.combine(obj[key], val, options.arrayLimit, options.plainObjects);
            else if (!existing || options.duplicates === 'last') obj[key] = val;
        }
    }
    return obj;
};
var $77ecabae9a966568$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $77ecabae9a966568$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) {
            if ($91NrL.isOverflow(leaf)) // leaf is already an overflow object, preserve it
            obj = leaf;
            else obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $91NrL.combine([], leaf, options.arrayLimit, options.plainObjects);
        } else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            else if (isValidArrayIndex) {
                obj[index] = leaf;
                $91NrL.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $77ecabae9a966568$var$splitKeyIntoSegments = function splitKeyIntoSegments(givenKey, options) {
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    if (options.depth <= 0) {
        if (!options.plainObjects && $77ecabae9a966568$var$has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) return;
        }
        return [
            key
        ];
    }
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    var keys = [];
    if (parent) {
        if (!options.plainObjects && $77ecabae9a966568$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys[keys.length] = parent;
    }
    var i = 0;
    while((segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        var segmentContent = segment[1].slice(1, -1);
        if (!options.plainObjects && $77ecabae9a966568$var$has.call(Object.prototype, segmentContent)) {
            if (!options.allowPrototypes) return;
        }
        keys[keys.length] = segment[1];
    }
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys[keys.length] = '[' + key.slice(segment.index) + ']';
    }
    return keys;
};
var $77ecabae9a966568$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    var keys = $77ecabae9a966568$var$splitKeyIntoSegments(givenKey, options);
    if (!keys) return;
    return $77ecabae9a966568$var$parseObject(keys, val, options, valuesParsed);
};
var $77ecabae9a966568$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $77ecabae9a966568$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $77ecabae9a966568$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $77ecabae9a966568$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $77ecabae9a966568$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $77ecabae9a966568$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $77ecabae9a966568$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $77ecabae9a966568$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $77ecabae9a966568$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $77ecabae9a966568$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $77ecabae9a966568$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $77ecabae9a966568$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $77ecabae9a966568$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $91NrL.isRegExp(opts.delimiter) ? opts.delimiter : $77ecabae9a966568$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $77ecabae9a966568$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $77ecabae9a966568$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $77ecabae9a966568$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $77ecabae9a966568$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $77ecabae9a966568$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $77ecabae9a966568$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $77ecabae9a966568$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $77ecabae9a966568$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $77ecabae9a966568$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $91NrL.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $91NrL.compact(obj);
};

});



parcelRegister("8cRmA", function(module, exports) {
'use strict';

var $frSVn = parcelRequire("frSVn");
/** @type ValidatorResult */ var $5f98d69425afd070$var$ValidatorResult = $frSVn.ValidatorResult;
/** @type SchemaError */ var $5f98d69425afd070$var$SchemaError = $frSVn.SchemaError;
var $5f98d69425afd070$var$attribute = {};
$5f98d69425afd070$var$attribute.ignoreProperties = {
    // informative properties
    'id': true,
    'default': true,
    'description': true,
    'title': true,
    // arguments to other properties
    'additionalItems': true,
    'then': true,
    'else': true,
    // special-handled properties
    '$schema': true,
    '$ref': true,
    'extends': true
};
/**
 * @name validators
 */ var $5f98d69425afd070$var$validators = $5f98d69425afd070$var$attribute.validators = {};
/**
 * Validates whether the instance if of a certain type
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {ValidatorResult|null}
 */ $5f98d69425afd070$var$validators.type = function validateType(instance, schema, options, ctx) {
    // Ignore undefined instances
    if (instance === undefined) return null;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var types = Array.isArray(schema.type) ? schema.type : [
        schema.type
    ];
    if (!types.some(this.testType.bind(this, instance, schema, options, ctx))) {
        var list = types.map(function(v) {
            if (!v) return;
            var id = v.$id || v.id;
            return id ? '<' + id + '>' : v + '';
        });
        result.addError({
            name: 'type',
            argument: list,
            message: "is not of a type(s) " + list
        });
    }
    return result;
};
function $5f98d69425afd070$var$testSchemaNoThrow(instance, options, ctx, callback, schema) {
    var throwError = options.throwError;
    var throwAll = options.throwAll;
    options.throwError = false;
    options.throwAll = false;
    var res = this.validateSchema(instance, schema, options, ctx);
    options.throwError = throwError;
    options.throwAll = throwAll;
    if (!res.valid && callback instanceof Function) callback(res);
    return res.valid;
}
/**
 * Validates whether the instance matches some of the given schemas
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {ValidatorResult|null}
 */ $5f98d69425afd070$var$validators.anyOf = function validateAnyOf(instance, schema, options, ctx) {
    // Ignore undefined instances
    if (instance === undefined) return null;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var inner = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    if (!Array.isArray(schema.anyOf)) throw new $5f98d69425afd070$var$SchemaError("anyOf must be an array");
    if (!schema.anyOf.some($5f98d69425afd070$var$testSchemaNoThrow.bind(this, instance, options, ctx, function(res) {
        inner.importErrors(res);
    }))) {
        var list = schema.anyOf.map(function(v, i) {
            var id = v.$id || v.id;
            if (id) return '<' + id + '>';
            return v.title && JSON.stringify(v.title) || v['$ref'] && '<' + v['$ref'] + '>' || '[subschema ' + i + ']';
        });
        if (options.nestedErrors) result.importErrors(inner);
        result.addError({
            name: 'anyOf',
            argument: list,
            message: "is not any of " + list.join(',')
        });
    }
    return result;
};
/**
 * Validates whether the instance matches every given schema
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.allOf = function validateAllOf(instance, schema, options, ctx) {
    // Ignore undefined instances
    if (instance === undefined) return null;
    if (!Array.isArray(schema.allOf)) throw new $5f98d69425afd070$var$SchemaError("allOf must be an array");
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var self = this;
    schema.allOf.forEach(function(v, i) {
        var valid = self.validateSchema(instance, v, options, ctx);
        if (!valid.valid) {
            var id = v.$id || v.id;
            var msg = id || v.title && JSON.stringify(v.title) || v['$ref'] && '<' + v['$ref'] + '>' || '[subschema ' + i + ']';
            result.addError({
                name: 'allOf',
                argument: {
                    id: msg,
                    length: valid.errors.length,
                    valid: valid
                },
                message: 'does not match allOf schema ' + msg + ' with ' + valid.errors.length + ' error[s]:'
            });
            result.importErrors(valid);
        }
    });
    return result;
};
/**
 * Validates whether the instance matches exactly one of the given schemas
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.oneOf = function validateOneOf(instance, schema, options, ctx) {
    // Ignore undefined instances
    if (instance === undefined) return null;
    if (!Array.isArray(schema.oneOf)) throw new $5f98d69425afd070$var$SchemaError("oneOf must be an array");
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var inner = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var count = schema.oneOf.filter($5f98d69425afd070$var$testSchemaNoThrow.bind(this, instance, options, ctx, function(res) {
        inner.importErrors(res);
    })).length;
    var list = schema.oneOf.map(function(v, i) {
        var id = v.$id || v.id;
        return id || v.title && JSON.stringify(v.title) || v['$ref'] && '<' + v['$ref'] + '>' || '[subschema ' + i + ']';
    });
    if (count !== 1) {
        if (options.nestedErrors) result.importErrors(inner);
        result.addError({
            name: 'oneOf',
            argument: list,
            message: "is not exactly one from " + list.join(',')
        });
    }
    return result;
};
/**
 * Validates "then" or "else" depending on the result of validating "if"
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.if = function validateIf(instance, schema, options, ctx) {
    // Ignore undefined instances
    if (instance === undefined) return null;
    if (!$frSVn.isSchema(schema.if)) throw new Error('Expected "if" keyword to be a schema');
    var ifValid = $5f98d69425afd070$var$testSchemaNoThrow.call(this, instance, options, ctx, null, schema.if);
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var res;
    if (ifValid) {
        if (schema.then === undefined) return;
        if (!$frSVn.isSchema(schema.then)) throw new Error('Expected "then" keyword to be a schema');
        res = this.validateSchema(instance, schema.then, options, ctx.makeChild(schema.then));
        result.importErrors(res);
    } else {
        if (schema.else === undefined) return;
        if (!$frSVn.isSchema(schema.else)) throw new Error('Expected "else" keyword to be a schema');
        res = this.validateSchema(instance, schema.else, options, ctx.makeChild(schema.else));
        result.importErrors(res);
    }
    return result;
};
function $5f98d69425afd070$var$getEnumerableProperty(object, key) {
    // Determine if `key` shows up in `for(var key in object)`
    // First test Object.hasOwnProperty.call as an optimization: that guarantees it does
    if (Object.hasOwnProperty.call(object, key)) return object[key];
    // Test `key in object` as an optimization; false means it won't
    if (!(key in object)) return;
    while(object = Object.getPrototypeOf(object)){
        if (Object.propertyIsEnumerable.call(object, key)) return object[key];
    }
}
/**
 * Validates propertyNames
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */ $5f98d69425afd070$var$validators.propertyNames = function validatePropertyNames(instance, schema, options, ctx) {
    if (!this.types.object(instance)) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var subschema = schema.propertyNames !== undefined ? schema.propertyNames : {};
    if (!$frSVn.isSchema(subschema)) throw new $5f98d69425afd070$var$SchemaError('Expected "propertyNames" to be a schema (object or boolean)');
    for(var property in instance)if ($5f98d69425afd070$var$getEnumerableProperty(instance, property) !== undefined) {
        var res = this.validateSchema(property, subschema, options, ctx.makeChild(subschema));
        result.importErrors(res);
    }
    return result;
};
/**
 * Validates properties
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */ $5f98d69425afd070$var$validators.properties = function validateProperties(instance, schema, options, ctx) {
    if (!this.types.object(instance)) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var properties = schema.properties || {};
    for(var property in properties){
        var subschema = properties[property];
        if (subschema === undefined) continue;
        else if (subschema === null) throw new $5f98d69425afd070$var$SchemaError('Unexpected null, expected schema in "properties"');
        if (typeof options.preValidateProperty == 'function') options.preValidateProperty(instance, property, subschema, options, ctx);
        var prop = $5f98d69425afd070$var$getEnumerableProperty(instance, property);
        var res = this.validateSchema(prop, subschema, options, ctx.makeChild(subschema, property));
        if (res.instance !== result.instance[property]) result.instance[property] = res.instance;
        result.importErrors(res);
    }
    return result;
};
/**
 * Test a specific property within in instance against the additionalProperties schema attribute
 * This ignores properties with definitions in the properties schema attribute, but no other attributes.
 * If too many more types of property-existence tests pop up they may need their own class of tests (like `type` has)
 * @private
 * @return {boolean}
 */ function $5f98d69425afd070$var$testAdditionalProperty(instance, schema, options, ctx, property, result) {
    if (!this.types.object(instance)) return;
    if (schema.properties && schema.properties[property] !== undefined) return;
    if (schema.additionalProperties === false) result.addError({
        name: 'additionalProperties',
        argument: property,
        message: "is not allowed to have the additional property " + JSON.stringify(property)
    });
    else {
        var additionalProperties = schema.additionalProperties || {};
        if (typeof options.preValidateProperty == 'function') options.preValidateProperty(instance, property, additionalProperties, options, ctx);
        var res = this.validateSchema(instance[property], additionalProperties, options, ctx.makeChild(additionalProperties, property));
        if (res.instance !== result.instance[property]) result.instance[property] = res.instance;
        result.importErrors(res);
    }
}
/**
 * Validates patternProperties
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */ $5f98d69425afd070$var$validators.patternProperties = function validatePatternProperties(instance, schema, options, ctx) {
    if (!this.types.object(instance)) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var patternProperties = schema.patternProperties || {};
    for(var property in instance){
        var test = true;
        for(var pattern in patternProperties){
            var subschema = patternProperties[pattern];
            if (subschema === undefined) continue;
            else if (subschema === null) throw new $5f98d69425afd070$var$SchemaError('Unexpected null, expected schema in "patternProperties"');
            try {
                var regexp = new RegExp(pattern, 'u');
            } catch (_e) {
                // In the event the stricter handling causes an error, fall back on the forgiving handling
                // DEPRECATED
                regexp = new RegExp(pattern);
            }
            if (!regexp.test(property)) continue;
            test = false;
            if (typeof options.preValidateProperty == 'function') options.preValidateProperty(instance, property, subschema, options, ctx);
            var res = this.validateSchema(instance[property], subschema, options, ctx.makeChild(subschema, property));
            if (res.instance !== result.instance[property]) result.instance[property] = res.instance;
            result.importErrors(res);
        }
        if (test) $5f98d69425afd070$var$testAdditionalProperty.call(this, instance, schema, options, ctx, property, result);
    }
    return result;
};
/**
 * Validates additionalProperties
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */ $5f98d69425afd070$var$validators.additionalProperties = function validateAdditionalProperties(instance, schema, options, ctx) {
    if (!this.types.object(instance)) return;
    // if patternProperties is defined then we'll test when that one is called instead
    if (schema.patternProperties) return null;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    for(var property in instance)$5f98d69425afd070$var$testAdditionalProperty.call(this, instance, schema, options, ctx, property, result);
    return result;
};
/**
 * Validates whether the instance value is at least of a certain length, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.minProperties = function validateMinProperties(instance, schema, options, ctx) {
    if (!this.types.object(instance)) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var keys = Object.keys(instance);
    if (!(keys.length >= schema.minProperties)) result.addError({
        name: 'minProperties',
        argument: schema.minProperties,
        message: "does not meet minimum property length of " + schema.minProperties
    });
    return result;
};
/**
 * Validates whether the instance value is at most of a certain length, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.maxProperties = function validateMaxProperties(instance, schema, options, ctx) {
    if (!this.types.object(instance)) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var keys = Object.keys(instance);
    if (!(keys.length <= schema.maxProperties)) result.addError({
        name: 'maxProperties',
        argument: schema.maxProperties,
        message: "does not meet maximum property length of " + schema.maxProperties
    });
    return result;
};
/**
 * Validates items when instance is an array
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */ $5f98d69425afd070$var$validators.items = function validateItems(instance, schema, options, ctx) {
    var self = this;
    if (!this.types.array(instance)) return;
    if (schema.items === undefined) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    instance.every(function(value, i) {
        if (Array.isArray(schema.items)) var items = schema.items[i] === undefined ? schema.additionalItems : schema.items[i];
        else var items = schema.items;
        if (items === undefined) return true;
        if (items === false) {
            result.addError({
                name: 'items',
                message: "additionalItems not permitted"
            });
            return false;
        }
        var res = self.validateSchema(value, items, options, ctx.makeChild(items, i));
        if (res.instance !== result.instance[i]) result.instance[i] = res.instance;
        result.importErrors(res);
        return true;
    });
    return result;
};
/**
 * Validates the "contains" keyword
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */ $5f98d69425afd070$var$validators.contains = function validateContains(instance, schema, options, ctx) {
    var self = this;
    if (!this.types.array(instance)) return;
    if (schema.contains === undefined) return;
    if (!$frSVn.isSchema(schema.contains)) throw new Error('Expected "contains" keyword to be a schema');
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var count = instance.some(function(value, i) {
        var res = self.validateSchema(value, schema.contains, options, ctx.makeChild(schema.contains, i));
        return res.errors.length === 0;
    });
    if (count === false) result.addError({
        name: 'contains',
        argument: schema.contains,
        message: "must contain an item matching given schema"
    });
    return result;
};
/**
 * Validates minimum and exclusiveMinimum when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.minimum = function validateMinimum(instance, schema, options, ctx) {
    if (!this.types.number(instance)) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    if (schema.exclusiveMinimum && schema.exclusiveMinimum === true) {
        if (!(instance > schema.minimum)) result.addError({
            name: 'minimum',
            argument: schema.minimum,
            message: "must be greater than " + schema.minimum
        });
    } else if (!(instance >= schema.minimum)) result.addError({
        name: 'minimum',
        argument: schema.minimum,
        message: "must be greater than or equal to " + schema.minimum
    });
    return result;
};
/**
 * Validates maximum and exclusiveMaximum when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.maximum = function validateMaximum(instance, schema, options, ctx) {
    if (!this.types.number(instance)) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    if (schema.exclusiveMaximum && schema.exclusiveMaximum === true) {
        if (!(instance < schema.maximum)) result.addError({
            name: 'maximum',
            argument: schema.maximum,
            message: "must be less than " + schema.maximum
        });
    } else if (!(instance <= schema.maximum)) result.addError({
        name: 'maximum',
        argument: schema.maximum,
        message: "must be less than or equal to " + schema.maximum
    });
    return result;
};
/**
 * Validates the number form of exclusiveMinimum when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.exclusiveMinimum = function validateExclusiveMinimum(instance, schema, options, ctx) {
    // Support the boolean form of exclusiveMinimum, which is handled by the "minimum" keyword.
    if (typeof schema.exclusiveMinimum === 'boolean') return;
    if (!this.types.number(instance)) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var valid = instance > schema.exclusiveMinimum;
    if (!valid) result.addError({
        name: 'exclusiveMinimum',
        argument: schema.exclusiveMinimum,
        message: "must be strictly greater than " + schema.exclusiveMinimum
    });
    return result;
};
/**
 * Validates the number form of exclusiveMaximum when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.exclusiveMaximum = function validateExclusiveMaximum(instance, schema, options, ctx) {
    // Support the boolean form of exclusiveMaximum, which is handled by the "maximum" keyword.
    if (typeof schema.exclusiveMaximum === 'boolean') return;
    if (!this.types.number(instance)) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var valid = instance < schema.exclusiveMaximum;
    if (!valid) result.addError({
        name: 'exclusiveMaximum',
        argument: schema.exclusiveMaximum,
        message: "must be strictly less than " + schema.exclusiveMaximum
    });
    return result;
};
/**
 * Perform validation for multipleOf and divisibleBy, which are essentially the same.
 * @param instance
 * @param schema
 * @param validationType
 * @param errorMessage
 * @returns {String|null}
 */ var $5f98d69425afd070$var$validateMultipleOfOrDivisbleBy = function validateMultipleOfOrDivisbleBy(instance, schema, options, ctx, validationType, errorMessage) {
    if (!this.types.number(instance)) return;
    var validationArgument = schema[validationType];
    if (validationArgument == 0) throw new $5f98d69425afd070$var$SchemaError(validationType + " cannot be zero");
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var instanceDecimals = $frSVn.getDecimalPlaces(instance);
    var divisorDecimals = $frSVn.getDecimalPlaces(validationArgument);
    var maxDecimals = Math.max(instanceDecimals, divisorDecimals);
    var multiplier = Math.pow(10, maxDecimals);
    if (Math.round(instance * multiplier) % Math.round(validationArgument * multiplier) !== 0) result.addError({
        name: validationType,
        argument: validationArgument,
        message: errorMessage + JSON.stringify(validationArgument)
    });
    return result;
};
/**
 * Validates divisibleBy when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.multipleOf = function validateMultipleOf(instance, schema, options, ctx) {
    return $5f98d69425afd070$var$validateMultipleOfOrDivisbleBy.call(this, instance, schema, options, ctx, "multipleOf", "is not a multiple of (divisible by) ");
};
/**
 * Validates multipleOf when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.divisibleBy = function validateDivisibleBy(instance, schema, options, ctx) {
    return $5f98d69425afd070$var$validateMultipleOfOrDivisbleBy.call(this, instance, schema, options, ctx, "divisibleBy", "is not divisible by (multiple of) ");
};
/**
 * Validates whether the instance value is present.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.required = function validateRequired(instance, schema, options, ctx) {
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    if (instance === undefined && schema.required === true) // A boolean form is implemented for reverse-compatibility with schemas written against older drafts
    result.addError({
        name: 'required',
        message: "is required"
    });
    else if (this.types.object(instance) && Array.isArray(schema.required)) schema.required.forEach(function(n) {
        if ($5f98d69425afd070$var$getEnumerableProperty(instance, n) === undefined) result.addError({
            name: 'required',
            argument: n,
            message: "requires property " + JSON.stringify(n)
        });
    });
    return result;
};
/**
 * Validates whether the instance value matches the regular expression, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.pattern = function validatePattern(instance, schema, options, ctx) {
    if (!this.types.string(instance)) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var pattern = schema.pattern;
    try {
        var regexp = new RegExp(pattern, 'u');
    } catch (_e) {
        // In the event the stricter handling causes an error, fall back on the forgiving handling
        // DEPRECATED
        regexp = new RegExp(pattern);
    }
    if (!instance.match(regexp)) result.addError({
        name: 'pattern',
        argument: schema.pattern,
        message: "does not match pattern " + JSON.stringify(schema.pattern.toString())
    });
    return result;
};
/**
 * Validates whether the instance value is of a certain defined format or a custom
 * format.
 * The following formats are supported for string types:
 *   - date-time
 *   - date
 *   - time
 *   - ip-address
 *   - ipv6
 *   - uri
 *   - color
 *   - host-name
 *   - alpha
 *   - alpha-numeric
 *   - utc-millisec
 * @param instance
 * @param schema
 * @param [options]
 * @param [ctx]
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.format = function validateFormat(instance, schema, options, ctx) {
    if (instance === undefined) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    if (!result.disableFormat && !$frSVn.isFormat(instance, schema.format, this)) result.addError({
        name: 'format',
        argument: schema.format,
        message: "does not conform to the " + JSON.stringify(schema.format) + " format"
    });
    return result;
};
/**
 * Validates whether the instance value is at least of a certain length, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.minLength = function validateMinLength(instance, schema, options, ctx) {
    if (!this.types.string(instance)) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var hsp = instance.match(/[\uDC00-\uDFFF]/g);
    var length = instance.length - (hsp ? hsp.length : 0);
    if (!(length >= schema.minLength)) result.addError({
        name: 'minLength',
        argument: schema.minLength,
        message: "does not meet minimum length of " + schema.minLength
    });
    return result;
};
/**
 * Validates whether the instance value is at most of a certain length, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.maxLength = function validateMaxLength(instance, schema, options, ctx) {
    if (!this.types.string(instance)) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    // TODO if this was already computed in "minLength", use that value instead of re-computing
    var hsp = instance.match(/[\uDC00-\uDFFF]/g);
    var length = instance.length - (hsp ? hsp.length : 0);
    if (!(length <= schema.maxLength)) result.addError({
        name: 'maxLength',
        argument: schema.maxLength,
        message: "does not meet maximum length of " + schema.maxLength
    });
    return result;
};
/**
 * Validates whether instance contains at least a minimum number of items, when the instance is an Array.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.minItems = function validateMinItems(instance, schema, options, ctx) {
    if (!this.types.array(instance)) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    if (!(instance.length >= schema.minItems)) result.addError({
        name: 'minItems',
        argument: schema.minItems,
        message: "does not meet minimum length of " + schema.minItems
    });
    return result;
};
/**
 * Validates whether instance contains no more than a maximum number of items, when the instance is an Array.
 * @param instance
 * @param schema
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.maxItems = function validateMaxItems(instance, schema, options, ctx) {
    if (!this.types.array(instance)) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    if (!(instance.length <= schema.maxItems)) result.addError({
        name: 'maxItems',
        argument: schema.maxItems,
        message: "does not meet maximum length of " + schema.maxItems
    });
    return result;
};
/**
 * Deep compares arrays for duplicates
 * @param v
 * @param i
 * @param a
 * @private
 * @return {boolean}
 */ function $5f98d69425afd070$var$testArrays(v, i, a) {
    var j, len = a.length;
    for(j = i + 1, len; j < len; j++){
        if ($frSVn.deepCompareStrict(v, a[j])) return false;
    }
    return true;
}
/**
 * Validates whether there are no duplicates, when the instance is an Array.
 * @param instance
 * @return {String|null}
 */ $5f98d69425afd070$var$validators.uniqueItems = function validateUniqueItems(instance, schema, options, ctx) {
    if (schema.uniqueItems !== true) return;
    if (!this.types.array(instance)) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    if (!instance.every($5f98d69425afd070$var$testArrays)) result.addError({
        name: 'uniqueItems',
        message: "contains duplicate item"
    });
    return result;
};
/**
 * Validate for the presence of dependency properties, if the instance is an object.
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {null|ValidatorResult}
 */ $5f98d69425afd070$var$validators.dependencies = function validateDependencies(instance, schema, options, ctx) {
    if (!this.types.object(instance)) return;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    for(var property in schema.dependencies){
        if (instance[property] === undefined) continue;
        var dep = schema.dependencies[property];
        var childContext = ctx.makeChild(dep, property);
        if (typeof dep == 'string') dep = [
            dep
        ];
        if (Array.isArray(dep)) dep.forEach(function(prop) {
            if (instance[prop] === undefined) result.addError({
                // FIXME there's two different "dependencies" errors here with slightly different outputs
                // Can we make these the same? Or should we create different error types?
                name: 'dependencies',
                argument: childContext.propertyPath,
                message: "property " + prop + " not found, required by " + childContext.propertyPath
            });
        });
        else {
            var res = this.validateSchema(instance, dep, options, childContext);
            if (result.instance !== res.instance) result.instance = res.instance;
            if (res && res.errors.length) {
                result.addError({
                    name: 'dependencies',
                    argument: childContext.propertyPath,
                    message: "does not meet dependency required by " + childContext.propertyPath
                });
                result.importErrors(res);
            }
        }
    }
    return result;
};
/**
 * Validates whether the instance value is one of the enumerated values.
 *
 * @param instance
 * @param schema
 * @return {ValidatorResult|null}
 */ $5f98d69425afd070$var$validators['enum'] = function validateEnum(instance, schema, options, ctx) {
    if (instance === undefined) return null;
    if (!Array.isArray(schema['enum'])) throw new $5f98d69425afd070$var$SchemaError("enum expects an array", schema);
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    if (!schema['enum'].some($frSVn.deepCompareStrict.bind(null, instance))) result.addError({
        name: 'enum',
        argument: schema['enum'],
        message: "is not one of enum values: " + schema['enum'].map(String).join(',')
    });
    return result;
};
/**
 * Validates whether the instance exactly matches a given value
 *
 * @param instance
 * @param schema
 * @return {ValidatorResult|null}
 */ $5f98d69425afd070$var$validators['const'] = function validateEnum(instance, schema, options, ctx) {
    if (instance === undefined) return null;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    if (!$frSVn.deepCompareStrict(schema['const'], instance)) result.addError({
        name: 'const',
        argument: schema['const'],
        message: "does not exactly match expected constant: " + schema['const']
    });
    return result;
};
/**
 * Validates whether the instance if of a prohibited type.
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {null|ValidatorResult}
 */ $5f98d69425afd070$var$validators.not = $5f98d69425afd070$var$validators.disallow = function validateNot(instance, schema, options, ctx) {
    var self = this;
    if (instance === undefined) return null;
    var result = new $5f98d69425afd070$var$ValidatorResult(instance, schema, options, ctx);
    var notTypes = schema.not || schema.disallow;
    if (!notTypes) return null;
    if (!Array.isArray(notTypes)) notTypes = [
        notTypes
    ];
    notTypes.forEach(function(type) {
        if (self.testType(instance, schema, options, ctx, type)) {
            var id = type && (type.$id || type.id);
            var schemaId = id || type;
            result.addError({
                name: 'not',
                argument: schemaId,
                message: "is of prohibited type " + schemaId
            });
        }
    });
    return result;
};
module.exports = $5f98d69425afd070$var$attribute;

});
parcelRegister("frSVn", function(module, exports) {

$parcel$export(module.exports, "ValidationError", function () { return $b3f3fb7a542e828d$export$2191b9da168c6cf0; }, function (v) { return $b3f3fb7a542e828d$export$2191b9da168c6cf0 = v; });
$parcel$export(module.exports, "ValidatorResult", function () { return $b3f3fb7a542e828d$export$b0184c04dbb75cbd; }, function (v) { return $b3f3fb7a542e828d$export$b0184c04dbb75cbd = v; });
$parcel$export(module.exports, "ValidatorResultError", function () { return $b3f3fb7a542e828d$export$93b9911b232b246c; }, function (v) { return $b3f3fb7a542e828d$export$93b9911b232b246c = v; });
$parcel$export(module.exports, "SchemaError", function () { return $b3f3fb7a542e828d$export$44dde8d2b17fc96a; }, function (v) { return $b3f3fb7a542e828d$export$44dde8d2b17fc96a = v; });
$parcel$export(module.exports, "SchemaContext", function () { return $b3f3fb7a542e828d$export$77f26f02a668a7e2; }, function (v) { return $b3f3fb7a542e828d$export$77f26f02a668a7e2 = v; });
$parcel$export(module.exports, "isFormat", function () { return $b3f3fb7a542e828d$export$674374997fba8879; }, function (v) { return $b3f3fb7a542e828d$export$674374997fba8879 = v; });
$parcel$export(module.exports, "deepCompareStrict", function () { return $b3f3fb7a542e828d$export$f99d9bd271f9a30e; }, function (v) { return $b3f3fb7a542e828d$export$f99d9bd271f9a30e = v; });
$parcel$export(module.exports, "deepMerge", function () { return $b3f3fb7a542e828d$export$6969335ea1e4e77c; }, function (v) { return $b3f3fb7a542e828d$export$6969335ea1e4e77c = v; });
$parcel$export(module.exports, "objectGetPath", function () { return $b3f3fb7a542e828d$export$d03ab7c46c3a0e16; }, function (v) { return $b3f3fb7a542e828d$export$d03ab7c46c3a0e16 = v; });
$parcel$export(module.exports, "getDecimalPlaces", function () { return $b3f3fb7a542e828d$export$4c5662d18be49e92; }, function (v) { return $b3f3fb7a542e828d$export$4c5662d18be49e92 = v; });
$parcel$export(module.exports, "isSchema", function () { return $b3f3fb7a542e828d$export$213e2a3e7c4f326e; }, function (v) { return $b3f3fb7a542e828d$export$213e2a3e7c4f326e = v; });
var $b3f3fb7a542e828d$export$2191b9da168c6cf0;
var $b3f3fb7a542e828d$export$b0184c04dbb75cbd;
var $b3f3fb7a542e828d$export$93b9911b232b246c;
var $b3f3fb7a542e828d$export$44dde8d2b17fc96a;
var $b3f3fb7a542e828d$export$77f26f02a668a7e2;
var $b3f3fb7a542e828d$export$1d8c0144df69cb55;
var $b3f3fb7a542e828d$export$674374997fba8879;
var $b3f3fb7a542e828d$export$61f60bce4af13a93;
var $b3f3fb7a542e828d$export$f99d9bd271f9a30e;
var $b3f3fb7a542e828d$export$6969335ea1e4e77c;
/**
 * Validates instance against the provided schema
 * Implements URI+JSON Pointer encoding, e.g. "%7e"="~0"=>"~", "~1"="%2f"=>"/"
 * @param o
 * @param s The path to walk o along
 * @return any
 */ var $b3f3fb7a542e828d$export$d03ab7c46c3a0e16;
/**
 * Accept an Array of property names and return a JSON Pointer URI fragment
 * @param Array a
 * @return {String}
 */ var $b3f3fb7a542e828d$export$20c03ce31e68a433;
/**
 * Calculate the number of decimal places a number uses
 * We need this to get correct results out of multipleOf and divisibleBy
 * when either figure is has decimal places, due to IEEE-754 float issues.
 * @param number
 * @returns {number}
 */ var $b3f3fb7a542e828d$export$4c5662d18be49e92;
var $b3f3fb7a542e828d$export$213e2a3e7c4f326e;
'use strict';

var $hM5r1 = parcelRequire("hM5r1");
var $b3f3fb7a542e828d$var$ValidationError = $b3f3fb7a542e828d$export$2191b9da168c6cf0 = function ValidationError(message, instance, schema, path, name, argument) {
    if (Array.isArray(path)) {
        this.path = path;
        this.property = path.reduce(function(sum, item) {
            return sum + $b3f3fb7a542e828d$var$makeSuffix(item);
        }, 'instance');
    } else if (path !== undefined) this.property = path;
    if (message) this.message = message;
    if (schema) {
        var id = schema.$id || schema.id;
        this.schema = id || schema;
    }
    if (instance !== undefined) this.instance = instance;
    this.name = name;
    this.argument = argument;
    this.stack = this.toString();
};
$b3f3fb7a542e828d$var$ValidationError.prototype.toString = function toString() {
    return this.property + ' ' + this.message;
};
var $b3f3fb7a542e828d$var$ValidatorResult = $b3f3fb7a542e828d$export$b0184c04dbb75cbd = function ValidatorResult(instance, schema, options, ctx) {
    this.instance = instance;
    this.schema = schema;
    this.options = options;
    this.path = ctx.path;
    this.propertyPath = ctx.propertyPath;
    this.errors = [];
    this.throwError = options && options.throwError;
    this.throwFirst = options && options.throwFirst;
    this.throwAll = options && options.throwAll;
    this.disableFormat = options && options.disableFormat === true;
};
$b3f3fb7a542e828d$var$ValidatorResult.prototype.addError = function addError(detail) {
    var err;
    if (typeof detail == 'string') err = new $b3f3fb7a542e828d$var$ValidationError(detail, this.instance, this.schema, this.path);
    else {
        if (!detail) throw new Error('Missing error detail');
        if (!detail.message) throw new Error('Missing error message');
        if (!detail.name) throw new Error('Missing validator type');
        err = new $b3f3fb7a542e828d$var$ValidationError(detail.message, this.instance, this.schema, this.path, detail.name, detail.argument);
    }
    this.errors.push(err);
    if (this.throwFirst) throw new $b3f3fb7a542e828d$var$ValidatorResultError(this);
    else if (this.throwError) throw err;
    return err;
};
$b3f3fb7a542e828d$var$ValidatorResult.prototype.importErrors = function importErrors(res) {
    if (typeof res == 'string' || res && res.validatorType) this.addError(res);
    else if (res && res.errors) this.errors = this.errors.concat(res.errors);
};
function $b3f3fb7a542e828d$var$stringizer(v, i) {
    return i + ': ' + v.toString() + '\n';
}
$b3f3fb7a542e828d$var$ValidatorResult.prototype.toString = function toString(res) {
    return this.errors.map($b3f3fb7a542e828d$var$stringizer).join('');
};
Object.defineProperty($b3f3fb7a542e828d$var$ValidatorResult.prototype, "valid", {
    get: function() {
        return !this.errors.length;
    }
});
$b3f3fb7a542e828d$export$93b9911b232b246c = $b3f3fb7a542e828d$var$ValidatorResultError;
function $b3f3fb7a542e828d$var$ValidatorResultError(result) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, $b3f3fb7a542e828d$var$ValidatorResultError);
    this.instance = result.instance;
    this.schema = result.schema;
    this.options = result.options;
    this.errors = result.errors;
}
$b3f3fb7a542e828d$var$ValidatorResultError.prototype = new Error();
$b3f3fb7a542e828d$var$ValidatorResultError.prototype.constructor = $b3f3fb7a542e828d$var$ValidatorResultError;
$b3f3fb7a542e828d$var$ValidatorResultError.prototype.name = "Validation Error";
/**
 * Describes a problem with a Schema which prevents validation of an instance
 * @name SchemaError
 * @constructor
 */ var $b3f3fb7a542e828d$var$SchemaError = $b3f3fb7a542e828d$export$44dde8d2b17fc96a = function SchemaError(msg, schema) {
    this.message = msg;
    this.schema = schema;
    Error.call(this, msg);
    Error.captureStackTrace(this, SchemaError);
};
$b3f3fb7a542e828d$var$SchemaError.prototype = Object.create(Error.prototype, {
    constructor: {
        value: $b3f3fb7a542e828d$var$SchemaError,
        enumerable: false
    },
    name: {
        value: 'SchemaError',
        enumerable: false
    }
});
var $b3f3fb7a542e828d$var$SchemaContext = $b3f3fb7a542e828d$export$77f26f02a668a7e2 = function SchemaContext(schema, options, path, base, schemas) {
    this.schema = schema;
    this.options = options;
    if (Array.isArray(path)) {
        this.path = path;
        this.propertyPath = path.reduce(function(sum, item) {
            return sum + $b3f3fb7a542e828d$var$makeSuffix(item);
        }, 'instance');
    } else this.propertyPath = path;
    this.base = base;
    this.schemas = schemas;
};
$b3f3fb7a542e828d$var$SchemaContext.prototype.resolve = function resolve(target) {
    return $hM5r1.resolve(this.base, target);
};
$b3f3fb7a542e828d$var$SchemaContext.prototype.makeChild = function makeChild(schema, propertyName) {
    var path = propertyName === undefined ? this.path : this.path.concat([
        propertyName
    ]);
    var id = schema.$id || schema.id;
    var base = $hM5r1.resolve(this.base, id || '');
    var ctx = new $b3f3fb7a542e828d$var$SchemaContext(schema, this.options, path, base, Object.create(this.schemas));
    if (id && !ctx.schemas[base]) ctx.schemas[base] = schema;
    return ctx;
};
var $b3f3fb7a542e828d$var$FORMAT_REGEXPS = $b3f3fb7a542e828d$export$1d8c0144df69cb55 = {
    // 7.3.1. Dates, Times, and Duration
    'date-time': /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])[tT ](2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])(\.\d+)?([zZ]|[+-]([0-5][0-9]):(60|[0-5][0-9]))$/,
    'date': /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])$/,
    'time': /^(2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])$/,
    'duration': /P(T\d+(H(\d+M(\d+S)?)?|M(\d+S)?|S)|\d+(D|M(\d+D)?|Y(\d+M(\d+D)?)?)(T\d+(H(\d+M(\d+S)?)?|M(\d+S)?|S))?|\d+W)/i,
    // 7.3.2. Email Addresses
    // TODO: fix the email production
    'email': /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/,
    'idn-email': /^("(?:[!#-\[\]-\u{10FFFF}]|\\[\t -\u{10FFFF}])*"|[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}](?:\.?[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}])*)@([!#-'*+\-/-9=?A-Z\^-\u{10FFFF}](?:\.?[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}])*|\[[!-Z\^-\u{10FFFF}]*\])$/u,
    // 7.3.3. Hostnames
    // 7.3.4. IP Addresses
    'ip-address': /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
    // FIXME whitespace is invalid
    'ipv6': /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/,
    // 7.3.5. Resource Identifiers
    // TODO: A more accurate regular expression for "uri" goes:
    // [A-Za-z][+\-.0-9A-Za-z]*:((/(/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?)?)?#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(/(/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])|/?%[0-9A-Fa-f]{2}|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*(#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?|/(/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+(:\d*)?|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?:\d*|\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)?)?
    'uri': /^[a-zA-Z][a-zA-Z0-9+.-]*:[^\s]*$/,
    'uri-reference': /^(((([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|([A-Za-z][+\-.0-9A-Za-z]*:?)?)|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?)?))#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(([A-Za-z][+\-.0-9A-Za-z]*)?%[0-9A-Fa-f]{2}|[!$&-.0-9;=@_~]|[A-Za-z][+\-.0-9A-Za-z]*[!$&-*,;=@_~])(%[0-9A-Fa-f]{2}|[!$&-.0-9;=@-Z_a-z~])*((([/?](%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?#|[/?])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?|([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+(:\d*)?|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?:\d*|\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)?|[A-Za-z][+\-.0-9A-Za-z]*:?)?$/,
    'iri': /^[a-zA-Z][a-zA-Z0-9+.-]*:[^\s]*$/,
    'iri-reference': /^(((([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~-\u{10FFFF}]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|([A-Za-z][+\-.0-9A-Za-z]*:?)?)|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|(\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?)?))#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|(([A-Za-z][+\-.0-9A-Za-z]*)?%[0-9A-Fa-f]{2}|[!$&-.0-9;=@_~-\u{10FFFF}]|[A-Za-z][+\-.0-9A-Za-z]*[!$&-*,;=@_~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-.0-9;=@-Z_a-z~-\u{10FFFF}])*((([/?](%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*)?#|[/?])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*)?|([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~-\u{10FFFF}]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+(:\d*)?|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?:\d*|\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)?|[A-Za-z][+\-.0-9A-Za-z]*:?)?$/u,
    'uuid': /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    // 7.3.6. uri-template
    'uri-template': /(%[0-9a-f]{2}|[!#$&(-;=?@\[\]_a-z~]|\{[!#&+,./;=?@|]?(%[0-9a-f]{2}|[0-9_a-z])(\.?(%[0-9a-f]{2}|[0-9_a-z]))*(:[1-9]\d{0,3}|\*)?(,(%[0-9a-f]{2}|[0-9_a-z])(\.?(%[0-9a-f]{2}|[0-9_a-z]))*(:[1-9]\d{0,3}|\*)?)*\})*/iu,
    // 7.3.7. JSON Pointers
    'json-pointer': /^(\/([\x00-\x2e0-@\[-}\x7f]|~[01])*)*$/iu,
    'relative-json-pointer': /^\d+(#|(\/([\x00-\x2e0-@\[-}\x7f]|~[01])*)*)$/iu,
    // hostname regex from: http://stackoverflow.com/a/1420225/5628
    'hostname': /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/,
    'host-name': /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/,
    'utc-millisec': function(input) {
        return typeof input === 'string' && parseFloat(input) === parseInt(input, 10) && !isNaN(input);
    },
    // 7.3.8. regex
    'regex': function(input) {
        var result = true;
        try {
            new RegExp(input);
        } catch (e) {
            result = false;
        }
        return result;
    },
    // Other definitions
    // "style" was removed from JSON Schema in draft-4 and is deprecated
    'style': /[\r\n\t ]*[^\r\n\t ][^:]*:[\r\n\t ]*[^\r\n\t ;]*[\r\n\t ]*;?/,
    // "color" was removed from JSON Schema in draft-4 and is deprecated
    'color': /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/,
    'phone': /^\+(?:[0-9] ?){6,14}[0-9]$/,
    'alpha': /^[a-zA-Z]+$/,
    'alphanumeric': /^[a-zA-Z0-9]+$/
};
$b3f3fb7a542e828d$var$FORMAT_REGEXPS.regexp = $b3f3fb7a542e828d$var$FORMAT_REGEXPS.regex;
$b3f3fb7a542e828d$var$FORMAT_REGEXPS.pattern = $b3f3fb7a542e828d$var$FORMAT_REGEXPS.regex;
$b3f3fb7a542e828d$var$FORMAT_REGEXPS.ipv4 = $b3f3fb7a542e828d$var$FORMAT_REGEXPS['ip-address'];
$b3f3fb7a542e828d$export$674374997fba8879 = function isFormat(input, format, validator) {
    if (typeof input === 'string' && $b3f3fb7a542e828d$var$FORMAT_REGEXPS[format] !== undefined) {
        if ($b3f3fb7a542e828d$var$FORMAT_REGEXPS[format] instanceof RegExp) return $b3f3fb7a542e828d$var$FORMAT_REGEXPS[format].test(input);
        if (typeof $b3f3fb7a542e828d$var$FORMAT_REGEXPS[format] === 'function') return $b3f3fb7a542e828d$var$FORMAT_REGEXPS[format](input);
    } else if (validator && validator.customFormats && typeof validator.customFormats[format] === 'function') return validator.customFormats[format](input);
    return true;
};
var $b3f3fb7a542e828d$var$makeSuffix = $b3f3fb7a542e828d$export$61f60bce4af13a93 = function makeSuffix(key) {
    key = key.toString();
    // This function could be capable of outputting valid a ECMAScript string, but the
    // resulting code for testing which form to use would be tens of thousands of characters long
    // That means this will use the name form for some illegal forms
    if (!key.match(/[.\s\[\]]/) && !key.match(/^[\d]/)) return '.' + key;
    if (key.match(/^\d+$/)) return '[' + key + ']';
    return '[' + JSON.stringify(key) + ']';
};
$b3f3fb7a542e828d$export$f99d9bd271f9a30e = function deepCompareStrict(a, b) {
    if (typeof a !== typeof b) return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b)) return false;
        if (a.length !== b.length) return false;
        return a.every(function(v, i) {
            return deepCompareStrict(a[i], b[i]);
        });
    }
    if (typeof a === 'object') {
        if (!a || !b) return a === b;
        var aKeys = Object.keys(a);
        var bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        return aKeys.every(function(v) {
            return deepCompareStrict(a[v], b[v]);
        });
    }
    return a === b;
};
function $b3f3fb7a542e828d$var$deepMerger(target, dst, e, i) {
    if (typeof e === 'object') dst[i] = $b3f3fb7a542e828d$var$deepMerge(target[i], e);
    else if (target.indexOf(e) === -1) dst.push(e);
}
function $b3f3fb7a542e828d$var$copyist(src, dst, key) {
    dst[key] = src[key];
}
function $b3f3fb7a542e828d$var$copyistWithDeepMerge(target, src, dst, key) {
    if (typeof src[key] !== 'object' || !src[key]) dst[key] = src[key];
    else if (!target[key]) dst[key] = src[key];
    else dst[key] = $b3f3fb7a542e828d$var$deepMerge(target[key], src[key]);
}
function $b3f3fb7a542e828d$var$deepMerge(target, src) {
    var array = Array.isArray(src);
    var dst = array && [] || {};
    if (array) {
        target = target || [];
        dst = dst.concat(target);
        src.forEach($b3f3fb7a542e828d$var$deepMerger.bind(null, target, dst));
    } else {
        if (target && typeof target === 'object') Object.keys(target).forEach($b3f3fb7a542e828d$var$copyist.bind(null, target, dst));
        Object.keys(src).forEach($b3f3fb7a542e828d$var$copyistWithDeepMerge.bind(null, target, src, dst));
    }
    return dst;
}
$b3f3fb7a542e828d$export$6969335ea1e4e77c = $b3f3fb7a542e828d$var$deepMerge;
$b3f3fb7a542e828d$export$d03ab7c46c3a0e16 = function objectGetPath(o, s) {
    var parts = s.split('/').slice(1);
    var k;
    while(typeof (k = parts.shift()) == 'string'){
        var n = decodeURIComponent(k.replace(/~0/, '~').replace(/~1/g, '/'));
        if (!(n in o)) return;
        o = o[n];
    }
    return o;
};
function $b3f3fb7a542e828d$var$pathEncoder(v) {
    return '/' + encodeURIComponent(v).replace(/~/g, '%7E');
}
$b3f3fb7a542e828d$export$20c03ce31e68a433 = function encodePointer(a) {
    // ~ must be encoded explicitly because hacks
    // the slash is encoded by encodeURIComponent
    return a.map($b3f3fb7a542e828d$var$pathEncoder).join('');
};
$b3f3fb7a542e828d$export$4c5662d18be49e92 = function getDecimalPlaces(number) {
    var decimalPlaces = 0;
    if (isNaN(number)) return decimalPlaces;
    if (typeof number !== 'number') number = Number(number);
    var parts = number.toString().split('e');
    if (parts.length === 2) {
        if (parts[1][0] !== '-') return decimalPlaces;
        else decimalPlaces = Number(parts[1].slice(1));
    }
    var decimalParts = parts[0].split('.');
    if (decimalParts.length === 2) decimalPlaces += decimalParts[1].length;
    return decimalPlaces;
};
$b3f3fb7a542e828d$export$213e2a3e7c4f326e = function isSchema(val) {
    return typeof val === 'object' && val || typeof val === 'boolean';
};

});


parcelRegister("gUSYn", function(module, exports) {

$parcel$export(module.exports, "SchemaScanResult", function () { return $c50c84c1cfefabbe$export$fa2f6d6458e494ac; }, function (v) { return $c50c84c1cfefabbe$export$fa2f6d6458e494ac = v; });
$parcel$export(module.exports, "scan", function () { return $c50c84c1cfefabbe$export$c87d910e63d22ed6; }, function (v) { return $c50c84c1cfefabbe$export$c87d910e63d22ed6 = v; });
var $c50c84c1cfefabbe$export$fa2f6d6458e494ac;
/**
 * Adds a schema with a certain urn to the Validator instance.
 * @param string uri
 * @param object schema
 * @return {Object}
 */ var $c50c84c1cfefabbe$export$c87d910e63d22ed6;
"use strict";

var $hM5r1 = parcelRequire("hM5r1");

var $frSVn = parcelRequire("frSVn");
$c50c84c1cfefabbe$export$fa2f6d6458e494ac = $c50c84c1cfefabbe$var$SchemaScanResult;
function $c50c84c1cfefabbe$var$SchemaScanResult(found, ref) {
    this.id = found;
    this.ref = ref;
}
$c50c84c1cfefabbe$export$c87d910e63d22ed6 = function scan(base, schema) {
    function scanSchema(baseuri, schema) {
        if (!schema || typeof schema != 'object') return;
        // Mark all referenced schemas so we can tell later which schemas are referred to, but never defined
        if (schema.$ref) {
            var resolvedUri = $hM5r1.resolve(baseuri, schema.$ref);
            ref[resolvedUri] = ref[resolvedUri] ? ref[resolvedUri] + 1 : 0;
            return;
        }
        var id = schema.$id || schema.id;
        var ourBase = id ? $hM5r1.resolve(baseuri, id) : baseuri;
        if (ourBase) {
            // If there's no fragment, append an empty one
            if (ourBase.indexOf('#') < 0) ourBase += '#';
            if (found[ourBase]) {
                if (!$frSVn.deepCompareStrict(found[ourBase], schema)) throw new Error('Schema <' + ourBase + '> already exists with different definition');
                return found[ourBase];
            }
            found[ourBase] = schema;
            // strip trailing fragment
            if (ourBase[ourBase.length - 1] == '#') found[ourBase.substring(0, ourBase.length - 1)] = schema;
        }
        scanArray(ourBase + '/items', Array.isArray(schema.items) ? schema.items : [
            schema.items
        ]);
        scanArray(ourBase + '/extends', Array.isArray(schema.extends) ? schema.extends : [
            schema.extends
        ]);
        scanSchema(ourBase + '/additionalItems', schema.additionalItems);
        scanObject(ourBase + '/properties', schema.properties);
        scanSchema(ourBase + '/additionalProperties', schema.additionalProperties);
        scanObject(ourBase + '/definitions', schema.definitions);
        scanObject(ourBase + '/patternProperties', schema.patternProperties);
        scanObject(ourBase + '/dependencies', schema.dependencies);
        scanArray(ourBase + '/disallow', schema.disallow);
        scanArray(ourBase + '/allOf', schema.allOf);
        scanArray(ourBase + '/anyOf', schema.anyOf);
        scanArray(ourBase + '/oneOf', schema.oneOf);
        scanSchema(ourBase + '/not', schema.not);
    }
    function scanArray(baseuri, schemas) {
        if (!Array.isArray(schemas)) return;
        for(var i = 0; i < schemas.length; i++)scanSchema(baseuri + '/' + i, schemas[i]);
    }
    function scanObject(baseuri, schemas) {
        if (!schemas || typeof schemas != 'object') return;
        for(var p in schemas)scanSchema(baseuri + '/' + p, schemas[p]);
    }
    var found = {};
    var ref = {};
    scanSchema(base, schema);
    return new $c50c84c1cfefabbe$var$SchemaScanResult(found, ref);
};

});


parcelRegister("GCbjB", function(module, exports) {

var $8fJ0j = parcelRequire("8fJ0j");
var $08018a68c763ab26$require$Buffer = $8fJ0j.Buffer;








const $08018a68c763ab26$var$rules = {
    burst: (parcelRequire("aQG7H")),
    cov: (parcelRequire("lTSJg")),
    filter: (parcelRequire("iSfo1")),
    parse: (parcelRequire("lv0BB")),
    stash: (parcelRequire("h92xw")),
    transform: (parcelRequire("jF4KS")),
    setContextVars: (parcelRequire("6ouYf")),
    collect: (parcelRequire("9k4as"))
};

var $fFht9 = parcelRequire("fFht9");
var $08018a68c763ab26$require$couldBeJsonParsable = $fFht9.couldBeJsonParsable;
class $08018a68c763ab26$var$RuleEngine {
    /**
     * @param {object} args
     * @param {Partial<Record<keyof typeof rules, unknown>>[]} args.configuration
     * @param {Pick<Console, 'warn'>} args.log the logger
     * @param {string} args.id internal id used for logging
     * @param {(args: { error: [string | null, string], ruleName: keyof typeof rules, rule: Record<keyof typeof rules, unknown>, message: unknown }) => void=} args.onExecutionError Called where there are execution errors
     */ constructor({ configuration: configuration, log: log, id: id, onExecutionError: onExecutionError }){
        this._configuration = configuration;
        this._log = log;
        this._id = id;
        this._onExecutionError = onExecutionError;
        /**
         * @type {Partial<Record<'input' | 'last' | 'lastOutput' | 'lastInput', unknown>>}
         * @private
         */ this._store = {};
    }
    /**
     * @param {unknown} data
     * @param {unknown=} context
     * @returns {Promise<unknown> | Promise<void>} In case of failure it will yield an undefined
     */ async run(data, context) {
        // We have to find out if the data is parsable JSON and eventually parse
        if ($08018a68c763ab26$require$couldBeJsonParsable(data)) try {
            data = JSON.parse(data);
        } catch (e) {
            this._log.debug(`${this._id}: The data does not appear to be in JSON format`);
        }
        // Create duplicate of the input data, but duplication must be handled
        // differently per type, especially for Buffer
        let modified;
        if (data instanceof $08018a68c763ab26$require$Buffer) modified = $08018a68c763ab26$require$Buffer.from(data);
        else if (typeof data === 'object') // no other Object prototypes get special cases here!
        modified = JSON.parse(JSON.stringify(data));
        else // primitive types => direct copy
        modified = data;
        this._store.input = data;
        for(const index in this._configuration){
            const item = this._configuration[index];
            const name = Object.keys(item)[0];
            if (!$08018a68c763ab26$var$rules[name]) {
                this._log.warn(`${this._id}: ${name} is not a valid rule name, skipping this entry`);
                continue;
            }
            try {
                modified = await $08018a68c763ab26$var$rules[name].execute({
                    ...item[name],
                    context: context,
                    message: modified,
                    store: this._store,
                    index: index
                });
            } catch (err) {
                if (err?.extras?.details?.startsWith('Unexpected token ')) {
                    // Some more detailed message for a common usage error
                    err.extras.details = `Cannot parse input message as JSON. Maybe the "parse" rule should be applied beforehand? ${err.extras.details}`;
                    err.message = `${err.extras.prefix}: ${err.extras.details}`;
                }
                this._log.warn({
                    params: this._configuration[name]
                }, `${this._id}: Failed processing ${name}, because: ${err.message}`);
                if (this._onExecutionError) {
                    const prefix = err.extras && err.extras.prefix || null;
                    const details = err.extras && err.extras.details || null;
                    this._onExecutionError({
                        error: prefix && details ? [
                            prefix,
                            details
                        ] : [
                            null,
                            err.message
                        ],
                        rule: item,
                        ruleName: name,
                        message: modified
                    });
                }
                // Shuts down the execution
                modified = undefined;
            }
            // Exit the chain whenever an empty payload is received (but a literal
            // 'false' might be a valid return value)
            if (modified === undefined) return;
        }
        // Save the last (modified) message
        this._store.last = modified // keep for backwards compatibility of older mappings
        ;
        this._store.lastOutput = modified;
        this._store.lastInput = data;
        return modified;
    }
}
module.exports = $08018a68c763ab26$var$RuleEngine;

});
parcelRegister("8fJ0j", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $6022a24cde8ced95$export$a143d493d941bafc; }, function (v) { return $6022a24cde8ced95$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $6022a24cde8ced95$export$f99ded8fe4b79145; }, function (v) { return $6022a24cde8ced95$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $6022a24cde8ced95$export$a143d493d941bafc;
var $6022a24cde8ced95$export$e4cf37d7f6fb9e0a;
var $6022a24cde8ced95$export$f99ded8fe4b79145;
var $6022a24cde8ced95$export$599f31c3813fae4d;
'use strict';

var $a0Aex = parcelRequire("a0Aex");

var $hxJph = parcelRequire("hxJph");
var $6022a24cde8ced95$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$6022a24cde8ced95$export$a143d493d941bafc = $6022a24cde8ced95$var$Buffer;
$6022a24cde8ced95$export$e4cf37d7f6fb9e0a = $6022a24cde8ced95$var$SlowBuffer;
$6022a24cde8ced95$export$f99ded8fe4b79145 = 50;
var $6022a24cde8ced95$var$K_MAX_LENGTH = 0x7fffffff;
$6022a24cde8ced95$export$599f31c3813fae4d = $6022a24cde8ced95$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $6022a24cde8ced95$var$Buffer.TYPED_ARRAY_SUPPORT = $6022a24cde8ced95$var$typedArraySupport();
if (!$6022a24cde8ced95$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $6022a24cde8ced95$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($6022a24cde8ced95$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$6022a24cde8ced95$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($6022a24cde8ced95$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$6022a24cde8ced95$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $6022a24cde8ced95$var$createBuffer(length) {
    if (length > $6022a24cde8ced95$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $6022a24cde8ced95$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $6022a24cde8ced95$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $6022a24cde8ced95$var$allocUnsafe(arg);
    }
    return $6022a24cde8ced95$var$from(arg, encodingOrOffset, length);
}
$6022a24cde8ced95$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $6022a24cde8ced95$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $6022a24cde8ced95$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $6022a24cde8ced95$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($6022a24cde8ced95$var$isInstance(value, ArrayBuffer) || value && $6022a24cde8ced95$var$isInstance(value.buffer, ArrayBuffer)) return $6022a24cde8ced95$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($6022a24cde8ced95$var$isInstance(value, SharedArrayBuffer) || value && $6022a24cde8ced95$var$isInstance(value.buffer, SharedArrayBuffer))) return $6022a24cde8ced95$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $6022a24cde8ced95$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $6022a24cde8ced95$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $6022a24cde8ced95$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $6022a24cde8ced95$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $6022a24cde8ced95$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($6022a24cde8ced95$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($6022a24cde8ced95$var$Buffer, Uint8Array);
function $6022a24cde8ced95$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $6022a24cde8ced95$var$alloc(size, fill, encoding) {
    $6022a24cde8ced95$var$assertSize(size);
    if (size <= 0) return $6022a24cde8ced95$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $6022a24cde8ced95$var$createBuffer(size).fill(fill, encoding) : $6022a24cde8ced95$var$createBuffer(size).fill(fill);
    return $6022a24cde8ced95$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $6022a24cde8ced95$var$Buffer.alloc = function(size, fill, encoding) {
    return $6022a24cde8ced95$var$alloc(size, fill, encoding);
};
function $6022a24cde8ced95$var$allocUnsafe(size) {
    $6022a24cde8ced95$var$assertSize(size);
    return $6022a24cde8ced95$var$createBuffer(size < 0 ? 0 : $6022a24cde8ced95$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $6022a24cde8ced95$var$Buffer.allocUnsafe = function(size) {
    return $6022a24cde8ced95$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $6022a24cde8ced95$var$Buffer.allocUnsafeSlow = function(size) {
    return $6022a24cde8ced95$var$allocUnsafe(size);
};
function $6022a24cde8ced95$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$6022a24cde8ced95$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $6022a24cde8ced95$var$byteLength(string, encoding) | 0;
    var buf = $6022a24cde8ced95$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $6022a24cde8ced95$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $6022a24cde8ced95$var$checked(array.length) | 0;
    var buf = $6022a24cde8ced95$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $6022a24cde8ced95$var$fromArrayView(arrayView) {
    if ($6022a24cde8ced95$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $6022a24cde8ced95$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $6022a24cde8ced95$var$fromArrayLike(arrayView);
}
function $6022a24cde8ced95$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $6022a24cde8ced95$var$Buffer.prototype);
    return buf;
}
function $6022a24cde8ced95$var$fromObject(obj) {
    if ($6022a24cde8ced95$var$Buffer.isBuffer(obj)) {
        var len = $6022a24cde8ced95$var$checked(obj.length) | 0;
        var buf = $6022a24cde8ced95$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $6022a24cde8ced95$var$numberIsNaN(obj.length)) return $6022a24cde8ced95$var$createBuffer(0);
        return $6022a24cde8ced95$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $6022a24cde8ced95$var$fromArrayLike(obj.data);
}
function $6022a24cde8ced95$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $6022a24cde8ced95$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $6022a24cde8ced95$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $6022a24cde8ced95$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $6022a24cde8ced95$var$Buffer.alloc(+length);
}
$6022a24cde8ced95$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $6022a24cde8ced95$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$6022a24cde8ced95$var$Buffer.compare = function compare(a, b) {
    if ($6022a24cde8ced95$var$isInstance(a, Uint8Array)) a = $6022a24cde8ced95$var$Buffer.from(a, a.offset, a.byteLength);
    if ($6022a24cde8ced95$var$isInstance(b, Uint8Array)) b = $6022a24cde8ced95$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$6022a24cde8ced95$var$Buffer.isBuffer(a) || !$6022a24cde8ced95$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$6022a24cde8ced95$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$6022a24cde8ced95$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $6022a24cde8ced95$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $6022a24cde8ced95$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($6022a24cde8ced95$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $6022a24cde8ced95$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$6022a24cde8ced95$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $6022a24cde8ced95$var$byteLength(string, encoding) {
    if ($6022a24cde8ced95$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $6022a24cde8ced95$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $6022a24cde8ced95$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $6022a24cde8ced95$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $6022a24cde8ced95$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$6022a24cde8ced95$var$Buffer.byteLength = $6022a24cde8ced95$var$byteLength;
function $6022a24cde8ced95$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $6022a24cde8ced95$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $6022a24cde8ced95$var$utf8Slice(this, start, end);
        case 'ascii':
            return $6022a24cde8ced95$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $6022a24cde8ced95$var$latin1Slice(this, start, end);
        case 'base64':
            return $6022a24cde8ced95$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6022a24cde8ced95$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$6022a24cde8ced95$var$Buffer.prototype._isBuffer = true;
function $6022a24cde8ced95$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$6022a24cde8ced95$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$6022a24cde8ced95$var$swap(this, i, i + 1);
    return this;
};
$6022a24cde8ced95$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $6022a24cde8ced95$var$swap(this, i, i + 3);
        $6022a24cde8ced95$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$6022a24cde8ced95$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $6022a24cde8ced95$var$swap(this, i, i + 7);
        $6022a24cde8ced95$var$swap(this, i + 1, i + 6);
        $6022a24cde8ced95$var$swap(this, i + 2, i + 5);
        $6022a24cde8ced95$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$6022a24cde8ced95$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $6022a24cde8ced95$var$utf8Slice(this, 0, length);
    return $6022a24cde8ced95$var$slowToString.apply(this, arguments);
};
$6022a24cde8ced95$var$Buffer.prototype.toLocaleString = $6022a24cde8ced95$var$Buffer.prototype.toString;
$6022a24cde8ced95$var$Buffer.prototype.equals = function equals(b) {
    if (!$6022a24cde8ced95$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $6022a24cde8ced95$var$Buffer.compare(this, b) === 0;
};
$6022a24cde8ced95$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $6022a24cde8ced95$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($6022a24cde8ced95$var$customInspectSymbol) $6022a24cde8ced95$var$Buffer.prototype[$6022a24cde8ced95$var$customInspectSymbol] = $6022a24cde8ced95$var$Buffer.prototype.inspect;
$6022a24cde8ced95$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($6022a24cde8ced95$var$isInstance(target, Uint8Array)) target = $6022a24cde8ced95$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$6022a24cde8ced95$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $6022a24cde8ced95$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($6022a24cde8ced95$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $6022a24cde8ced95$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($6022a24cde8ced95$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $6022a24cde8ced95$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $6022a24cde8ced95$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $6022a24cde8ced95$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$6022a24cde8ced95$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$6022a24cde8ced95$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $6022a24cde8ced95$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$6022a24cde8ced95$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $6022a24cde8ced95$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $6022a24cde8ced95$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($6022a24cde8ced95$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $6022a24cde8ced95$var$utf8Write(buf, string, offset, length) {
    return $6022a24cde8ced95$var$blitBuffer($6022a24cde8ced95$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $6022a24cde8ced95$var$asciiWrite(buf, string, offset, length) {
    return $6022a24cde8ced95$var$blitBuffer($6022a24cde8ced95$var$asciiToBytes(string), buf, offset, length);
}
function $6022a24cde8ced95$var$base64Write(buf, string, offset, length) {
    return $6022a24cde8ced95$var$blitBuffer($6022a24cde8ced95$var$base64ToBytes(string), buf, offset, length);
}
function $6022a24cde8ced95$var$ucs2Write(buf, string, offset, length) {
    return $6022a24cde8ced95$var$blitBuffer($6022a24cde8ced95$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$6022a24cde8ced95$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $6022a24cde8ced95$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $6022a24cde8ced95$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $6022a24cde8ced95$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $6022a24cde8ced95$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6022a24cde8ced95$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$6022a24cde8ced95$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $6022a24cde8ced95$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $a0Aex.fromByteArray(buf);
    else return $a0Aex.fromByteArray(buf.slice(start, end));
}
function $6022a24cde8ced95$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $6022a24cde8ced95$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $6022a24cde8ced95$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $6022a24cde8ced95$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $6022a24cde8ced95$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $6022a24cde8ced95$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $6022a24cde8ced95$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $6022a24cde8ced95$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $6022a24cde8ced95$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $6022a24cde8ced95$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $6022a24cde8ced95$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$6022a24cde8ced95$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $6022a24cde8ced95$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $6022a24cde8ced95$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$6022a24cde8ced95$var$Buffer.prototype.readUintLE = $6022a24cde8ced95$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$6022a24cde8ced95$var$Buffer.prototype.readUintBE = $6022a24cde8ced95$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$6022a24cde8ced95$var$Buffer.prototype.readUint8 = $6022a24cde8ced95$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$6022a24cde8ced95$var$Buffer.prototype.readUint16LE = $6022a24cde8ced95$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$6022a24cde8ced95$var$Buffer.prototype.readUint16BE = $6022a24cde8ced95$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$6022a24cde8ced95$var$Buffer.prototype.readUint32LE = $6022a24cde8ced95$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$6022a24cde8ced95$var$Buffer.prototype.readUint32BE = $6022a24cde8ced95$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$6022a24cde8ced95$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6022a24cde8ced95$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6022a24cde8ced95$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$6022a24cde8ced95$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6022a24cde8ced95$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6022a24cde8ced95$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$6022a24cde8ced95$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$6022a24cde8ced95$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, 4, this.length);
    return $hxJph.read(this, offset, true, 23, 4);
};
$6022a24cde8ced95$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, 4, this.length);
    return $hxJph.read(this, offset, false, 23, 4);
};
$6022a24cde8ced95$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, 8, this.length);
    return $hxJph.read(this, offset, true, 52, 8);
};
$6022a24cde8ced95$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkOffset(offset, 8, this.length);
    return $hxJph.read(this, offset, false, 52, 8);
};
function $6022a24cde8ced95$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$6022a24cde8ced95$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$6022a24cde8ced95$var$Buffer.prototype.writeUintLE = $6022a24cde8ced95$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6022a24cde8ced95$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6022a24cde8ced95$var$Buffer.prototype.writeUintBE = $6022a24cde8ced95$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6022a24cde8ced95$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6022a24cde8ced95$var$Buffer.prototype.writeUint8 = $6022a24cde8ced95$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$6022a24cde8ced95$var$Buffer.prototype.writeUint16LE = $6022a24cde8ced95$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6022a24cde8ced95$var$Buffer.prototype.writeUint16BE = $6022a24cde8ced95$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6022a24cde8ced95$var$Buffer.prototype.writeUint32LE = $6022a24cde8ced95$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$6022a24cde8ced95$var$Buffer.prototype.writeUint32BE = $6022a24cde8ced95$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$6022a24cde8ced95$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $6022a24cde8ced95$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6022a24cde8ced95$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $6022a24cde8ced95$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6022a24cde8ced95$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$6022a24cde8ced95$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6022a24cde8ced95$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6022a24cde8ced95$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$6022a24cde8ced95$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $6022a24cde8ced95$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $6022a24cde8ced95$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $hxJph.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$6022a24cde8ced95$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $6022a24cde8ced95$var$writeFloat(this, value, offset, true, noAssert);
};
$6022a24cde8ced95$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $6022a24cde8ced95$var$writeFloat(this, value, offset, false, noAssert);
};
function $6022a24cde8ced95$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6022a24cde8ced95$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $hxJph.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$6022a24cde8ced95$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $6022a24cde8ced95$var$writeDouble(this, value, offset, true, noAssert);
};
$6022a24cde8ced95$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $6022a24cde8ced95$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$6022a24cde8ced95$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$6022a24cde8ced95$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$6022a24cde8ced95$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$6022a24cde8ced95$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $6022a24cde8ced95$var$Buffer.isBuffer(val) ? val : $6022a24cde8ced95$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $6022a24cde8ced95$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $6022a24cde8ced95$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($6022a24cde8ced95$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $6022a24cde8ced95$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $6022a24cde8ced95$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $6022a24cde8ced95$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $6022a24cde8ced95$var$base64ToBytes(str) {
    return $a0Aex.toByteArray($6022a24cde8ced95$var$base64clean(str));
}
function $6022a24cde8ced95$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $6022a24cde8ced95$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $6022a24cde8ced95$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $6022a24cde8ced95$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("a0Aex", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $749602aeb1f69fe5$export$d622b2ad8d90c771; }, function (v) { return $749602aeb1f69fe5$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $749602aeb1f69fe5$export$6100ba28696e12de; }, function (v) { return $749602aeb1f69fe5$export$6100ba28696e12de = v; });
var $749602aeb1f69fe5$export$a48f0734ac7c2329;
var $749602aeb1f69fe5$export$d622b2ad8d90c771;
var $749602aeb1f69fe5$export$6100ba28696e12de;
'use strict';
$749602aeb1f69fe5$export$a48f0734ac7c2329 = $749602aeb1f69fe5$var$byteLength;
$749602aeb1f69fe5$export$d622b2ad8d90c771 = $749602aeb1f69fe5$var$toByteArray;
$749602aeb1f69fe5$export$6100ba28696e12de = $749602aeb1f69fe5$var$fromByteArray;
var $749602aeb1f69fe5$var$lookup = [];
var $749602aeb1f69fe5$var$revLookup = [];
var $749602aeb1f69fe5$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $749602aeb1f69fe5$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $749602aeb1f69fe5$var$i = 0, $749602aeb1f69fe5$var$len = $749602aeb1f69fe5$var$code.length; $749602aeb1f69fe5$var$i < $749602aeb1f69fe5$var$len; ++$749602aeb1f69fe5$var$i){
    $749602aeb1f69fe5$var$lookup[$749602aeb1f69fe5$var$i] = $749602aeb1f69fe5$var$code[$749602aeb1f69fe5$var$i];
    $749602aeb1f69fe5$var$revLookup[$749602aeb1f69fe5$var$code.charCodeAt($749602aeb1f69fe5$var$i)] = $749602aeb1f69fe5$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$749602aeb1f69fe5$var$revLookup['-'.charCodeAt(0)] = 62;
$749602aeb1f69fe5$var$revLookup['_'.charCodeAt(0)] = 63;
function $749602aeb1f69fe5$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $749602aeb1f69fe5$var$byteLength(b64) {
    var lens = $749602aeb1f69fe5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $749602aeb1f69fe5$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $749602aeb1f69fe5$var$toByteArray(b64) {
    var tmp;
    var lens = $749602aeb1f69fe5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $749602aeb1f69fe5$var$Arr($749602aeb1f69fe5$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $749602aeb1f69fe5$var$revLookup[b64.charCodeAt(i)] << 18 | $749602aeb1f69fe5$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $749602aeb1f69fe5$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $749602aeb1f69fe5$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $749602aeb1f69fe5$var$revLookup[b64.charCodeAt(i)] << 2 | $749602aeb1f69fe5$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $749602aeb1f69fe5$var$revLookup[b64.charCodeAt(i)] << 10 | $749602aeb1f69fe5$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $749602aeb1f69fe5$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $749602aeb1f69fe5$var$tripletToBase64(num) {
    return $749602aeb1f69fe5$var$lookup[num >> 18 & 0x3F] + $749602aeb1f69fe5$var$lookup[num >> 12 & 0x3F] + $749602aeb1f69fe5$var$lookup[num >> 6 & 0x3F] + $749602aeb1f69fe5$var$lookup[num & 0x3F];
}
function $749602aeb1f69fe5$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($749602aeb1f69fe5$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $749602aeb1f69fe5$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($749602aeb1f69fe5$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($749602aeb1f69fe5$var$lookup[tmp >> 2] + $749602aeb1f69fe5$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($749602aeb1f69fe5$var$lookup[tmp >> 10] + $749602aeb1f69fe5$var$lookup[tmp >> 4 & 0x3F] + $749602aeb1f69fe5$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("hxJph", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $cc58bd928e02b774$export$aafa59e2e03f2942; }, function (v) { return $cc58bd928e02b774$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $cc58bd928e02b774$export$68d8715fc104d294; }, function (v) { return $cc58bd928e02b774$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $cc58bd928e02b774$export$aafa59e2e03f2942;
var $cc58bd928e02b774$export$68d8715fc104d294;
$cc58bd928e02b774$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$cc58bd928e02b774$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("aQG7H", function(module, exports) {
class $7e5f6f837fa6345a$var$Burst {
    static async execute({ message: message, store: store, label: label = 'burst', interval: interval, maxSize: maxSize }) {
        if (store[label]) {
            const burst = store[label];
            burst.push(message);
            if (maxSize && burst.length >= maxSize) {
                delete store[label];
                return burst;
            }
        } else {
            if (maxSize && maxSize <= 1) return [
                message
            ];
            store[label] = [
                message
            ];
            if (interval) return new Promise((resolve)=>{
                setTimeout(()=>{
                    const burst = store[label];
                    delete store[label];
                    resolve(burst);
                }, interval);
            });
        }
    }
}
module.exports = $7e5f6f837fa6345a$var$Burst;

});

parcelRegister("lTSJg", function(module, exports) {
// Implements a "Change of Value" Rule
//
// Provides the following options:
//
// - key: JSON property to apply the filter to. If omitted, object matching is
//        active
// - label: optional label that is used to look up the cached value
// - deadband: number. Defines the threshold a change must exceed before
//             triggering an update
// - deadbandMode: one of: [ relative, absolute ] defaults to "absolute".
//                 if relative: treated a a percentage (e.g. 10 => 10%)
//                 if absolute: treated as an absolut value
//
class $ff193015f76ab4e6$var$Cov {
    static execute({ message: message, store: store, label: label, index: index, key: key, deadband: deadband = 0, deadbandMode: deadbandMode = 'absolute' }) {
        let storeResult = true;
        let forwardMessage = false;
        if (label) storeResult = false;
        else label = `__cyb_cov_${index}`;
        if (!store[label]) forwardMessage = true;
        else {
            const cached = store[label];
            const previous = key ? _resolve(key, cached) : cached;
            const current = key ? _resolve(key, message) : message;
            if (deadband === 0) forwardMessage = _hasChanged(previous, current);
            else forwardMessage = deadbandMode === 'relative' ? _hasChangedRelativeDeadband(previous, current, deadband) : _hasChangedAbsoluteDeadband(previous, current, deadband);
        }
        if (forwardMessage) {
            if (storeResult) store[label] = message;
            return message;
        }
        function _hasChanged(previous, current) {
            if (typeof previous === 'object' && previous !== null) return JSON.stringify(previous) !== JSON.stringify(current);
            else return previous !== current;
        }
        function _hasChangedRelativeDeadband(previous, current, deadband) {
            return previous * (1 + deadband / 100) <= current || previous * (1 - deadband / 100) >= current;
        }
        function _hasChangedAbsoluteDeadband(previous, current, deadband) {
            return previous + deadband <= current || previous - deadband >= current;
        }
        function _resolve(path, object) {
            return path instanceof Array ? path.reduce((subObject, subPath)=>subObject && subObject[subPath] ? subObject[subPath] : null, object) : object[path];
        }
    }
}
module.exports = $ff193015f76ab4e6$var$Cov;

});

parcelRegister("iSfo1", function(module, exports) {

var $cNx6R = parcelRequire("cNx6R");
class $dbd93496cabe743f$var$Filter extends $cNx6R {
    static execute(options) {
        const result = $cNx6R.execute(options);
        if (result) return options.message;
    }
}
module.exports = $dbd93496cabe743f$var$Filter;

});
parcelRegister("cNx6R", function(module, exports) {

var $8fJ0j = parcelRequire("8fJ0j");
var $9513be817d964fc9$require$Buffer = $8fJ0j.Buffer;

var $htFsi = parcelRequire("htFsi");

var $3osrl = parcelRequire("3osrl");
/**
 * @type {Map<string, import('jsonata').Expression>}
 */ const $9513be817d964fc9$var$expressions = new Map();
class $9513be817d964fc9$var$JsonataRuleEngine {
    /**
     * @param {{ message: string | import('buffer').Buffer, store?: unknown, context?: unknown, expression: string }} param
     * @returns
     */ static execute({ message: message, store: store, context: context, expression: expression }) {
        try {
            const jsonMessage = message instanceof $9513be817d964fc9$require$Buffer ? JSON.parse(message) : message;
            if (!$9513be817d964fc9$var$expressions.has(expression)) $9513be817d964fc9$var$expressions.set(expression, $htFsi(expression));
            const result = $9513be817d964fc9$var$expressions.get(expression).evaluate(jsonMessage, {
                context: context,
                last: (label = 'last')=>store[label],
                ...$3osrl
            });
            return result;
        } catch (err) {
            const newError = new Error(`Jsonata rule engine raised an error: ${err.message}`);
            newError.extras = {
                prefix: 'Jsonata rule engine raised an error',
                details: err.message
            };
            throw newError;
        }
    }
}
module.exports = $9513be817d964fc9$var$JsonataRuleEngine;

});
parcelRegister("htFsi", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function() {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = undefined;
                        if (!f && c) return c(i, !0);
                        if (u) return u(i, !0);
                        var a = new Error("Cannot find module '" + i + "'");
                        throw a.code = "MODULE_NOT_FOUND", a;
                    }
                    var p = n[i] = {
                        exports: {}
                    };
                    e[i][0].call(p.exports, function(r) {
                        var n = e[i][1][r];
                        return o(n || r);
                    }, p, p.exports, r, e, n, t);
                }
                return n[i].exports;
            }
            for(var u = undefined, i = 0; i < t.length; i++)o(t[i]);
            return o;
        }
        return r;
    })()({
        1: [
            function(require1, module1, exports) {
                /**
 * © Copyright IBM Corp. 2018 All Rights Reserved
 *   Project name: JSONata
 *   This project is licensed under the MIT License, see LICENSE
 */ const utils = require1('./utils');
                /**
 * DateTime formatting and parsing functions
 * Implements the xpath-functions format-date-time specification
 * @type {{formatInteger, formatDateTime, parseInteger, parseDateTime}}
 */ const dateTime = function() {
                    'use strict';
                    const stringToArray = utils.stringToArray;
                    const few = [
                        'Zero',
                        'One',
                        'Two',
                        'Three',
                        'Four',
                        'Five',
                        'Six',
                        'Seven',
                        'Eight',
                        'Nine',
                        'Ten',
                        'Eleven',
                        'Twelve',
                        'Thirteen',
                        'Fourteen',
                        'Fifteen',
                        'Sixteen',
                        'Seventeen',
                        'Eighteen',
                        'Nineteen'
                    ];
                    const ordinals = [
                        'Zeroth',
                        'First',
                        'Second',
                        'Third',
                        'Fourth',
                        'Fifth',
                        'Sixth',
                        'Seventh',
                        'Eighth',
                        'Ninth',
                        'Tenth',
                        'Eleventh',
                        'Twelfth',
                        'Thirteenth',
                        'Fourteenth',
                        'Fifteenth',
                        'Sixteenth',
                        'Seventeenth',
                        'Eighteenth',
                        'Nineteenth'
                    ];
                    const decades = [
                        'Twenty',
                        'Thirty',
                        'Forty',
                        'Fifty',
                        'Sixty',
                        'Seventy',
                        'Eighty',
                        'Ninety',
                        'Hundred'
                    ];
                    const magnitudes = [
                        'Thousand',
                        'Million',
                        'Billion',
                        'Trillion'
                    ];
                    /**
     * converts a number into english words
     * @param {string} value - the value to format
     * @param {boolean} ordinal - ordinal or cardinal form
     * @returns {string} - representation in words
     */ function numberToWords(value, ordinal) {
                        var lookup = function(num, prev, ord) {
                            var words = '';
                            if (num <= 19) words = (prev ? ' and ' : '') + (ord ? ordinals[num] : few[num]);
                            else if (num < 100) {
                                const tens = Math.floor(num / 10);
                                const remainder = num % 10;
                                words = (prev ? ' and ' : '') + decades[tens - 2];
                                if (remainder > 0) words += '-' + lookup(remainder, false, ord);
                                else if (ord) words = words.substring(0, words.length - 1) + 'ieth';
                            } else if (num < 1000) {
                                const hundreds = Math.floor(num / 100);
                                const remainder = num % 100;
                                words = (prev ? ', ' : '') + few[hundreds] + ' Hundred';
                                if (remainder > 0) words += lookup(remainder, true, ord);
                                else if (ord) words += 'th';
                            } else {
                                var mag = Math.floor(Math.log10(num) / 3);
                                if (mag > magnitudes.length) mag = magnitudes.length; // the largest word
                                const factor = Math.pow(10, mag * 3);
                                const mant = Math.floor(num / factor);
                                const remainder = num - mant * factor;
                                words = (prev ? ', ' : '') + lookup(mant, false, false) + ' ' + magnitudes[mag - 1];
                                if (remainder > 0) words += lookup(remainder, true, ord);
                                else if (ord) words += 'th';
                            }
                            return words;
                        };
                        var words = lookup(value, false, ordinal);
                        return words;
                    }
                    const wordValues = Object.create(null);
                    few.forEach(function(word, index) {
                        wordValues[word.toLowerCase()] = index;
                    });
                    ordinals.forEach(function(word, index) {
                        wordValues[word.toLowerCase()] = index;
                    });
                    decades.forEach(function(word, index) {
                        const lword = word.toLowerCase();
                        wordValues[lword] = (index + 2) * 10;
                        wordValues[lword.substring(0, word.length - 1) + 'ieth'] = wordValues[lword];
                    });
                    wordValues.hundredth = 100;
                    magnitudes.forEach(function(word, index) {
                        const lword = word.toLowerCase();
                        const val = Math.pow(10, (index + 1) * 3);
                        wordValues[lword] = val;
                        wordValues[lword + 'th'] = val;
                    });
                    /**
     * Converts a number in english words to numeric value
     * @param {string} text - the number in words
     * @returns {number} - the numeric value
     */ function wordsToNumber(text) {
                        const parts = text.split(/,\s|\sand\s|[\s\\-]/);
                        const values = parts.map((part)=>wordValues[part]);
                        let segs = [
                            0
                        ];
                        values.forEach((value)=>{
                            if (value < 100) {
                                let top = segs.pop();
                                if (top >= 1000) {
                                    segs.push(top);
                                    top = 0;
                                }
                                segs.push(top + value);
                            } else segs.push(segs.pop() * value);
                        });
                        const result = segs.reduce((a, b)=>a + b, 0);
                        return result;
                    }
                    const romanNumerals = [
                        [
                            1000,
                            'm'
                        ],
                        [
                            900,
                            'cm'
                        ],
                        [
                            500,
                            'd'
                        ],
                        [
                            400,
                            'cd'
                        ],
                        [
                            100,
                            'c'
                        ],
                        [
                            90,
                            'xc'
                        ],
                        [
                            50,
                            'l'
                        ],
                        [
                            40,
                            'xl'
                        ],
                        [
                            10,
                            'x'
                        ],
                        [
                            9,
                            'ix'
                        ],
                        [
                            5,
                            'v'
                        ],
                        [
                            4,
                            'iv'
                        ],
                        [
                            1,
                            'i'
                        ]
                    ];
                    const romanValues = {
                        'M': 1000,
                        'D': 500,
                        'C': 100,
                        'L': 50,
                        'X': 10,
                        'V': 5,
                        'I': 1
                    };
                    /**
     * converts a number to roman numerals
     * @param {number} value - the number
     * @returns {string} - the number in roman numerals
     */ function decimalToRoman(value) {
                        for(var index = 0; index < romanNumerals.length; index++){
                            const numeral = romanNumerals[index];
                            if (value >= numeral[0]) return numeral[1] + decimalToRoman(value - numeral[0]);
                        }
                        return '';
                    }
                    /**
     * converts roman numerals to a number
     * @param {string} roman - roman number
     * @returns {number} - the numeric value
     */ function romanToDecimal(roman) {
                        var decimal = 0;
                        var max = 1;
                        for(var i = roman.length - 1; i >= 0; i--){
                            const digit = roman[i];
                            const value = romanValues[digit];
                            if (value < max) decimal -= value;
                            else {
                                max = value;
                                decimal += value;
                            }
                        }
                        return decimal;
                    }
                    /**
     * converts a number to spreadsheet style letters
     * @param {number} value - the number
     * @param {string} aChar - the character representing the start of the sequence, e.g. 'A'
     * @returns {string} - the letters
     */ function decimalToLetters(value, aChar) {
                        var letters = [];
                        var aCode = aChar.charCodeAt(0);
                        while(value > 0){
                            letters.unshift(String.fromCharCode((value - 1) % 26 + aCode));
                            value = Math.floor((value - 1) / 26);
                        }
                        return letters.join('');
                    }
                    /**
     * converts spreadsheet style letters to a number
     * @param {string} letters - the letters
     * @param {string} aChar - the character representing the start of the sequence, e.g. 'A'
     * @returns {number} - the numeric value
     */ function lettersToDecimal(letters, aChar) {
                        var aCode = aChar.charCodeAt(0);
                        var decimal = 0;
                        for(var i = 0; i < letters.length; i++)decimal += (letters.charCodeAt(letters.length - i - 1) - aCode + 1) * Math.pow(26, i);
                        return decimal;
                    }
                    /**
     * Formats an integer as specified by the XPath fn:format-integer function
     * See https://www.w3.org/TR/xpath-functions-31/#func-format-integer
     * @param {number} value - the number to be formatted
     * @param {string} picture - the picture string that specifies the format
     * @returns {string} - the formatted number
     */ function formatInteger(value, picture) {
                        if (typeof value === 'undefined') return undefined;
                        value = Math.floor(value);
                        const format = analyseIntegerPicture(picture);
                        return _formatInteger(value, format);
                    }
                    const formats = {
                        DECIMAL: 'decimal',
                        LETTERS: 'letters',
                        ROMAN: 'roman',
                        WORDS: 'words',
                        SEQUENCE: 'sequence'
                    };
                    const tcase = {
                        UPPER: 'upper',
                        LOWER: 'lower',
                        TITLE: 'title'
                    };
                    /**
     * formats an integer using a preprocessed representation of the picture string
     * @param {number} value - the number to be formatted
     * @param {object} format - the preprocessed representation of the pucture string
     * @returns {string} - the formatted number
     * @private
     */ function _formatInteger(value, format) {
                        let formattedInteger;
                        const negative = value < 0;
                        value = Math.abs(value);
                        switch(format.primary){
                            case formats.LETTERS:
                                formattedInteger = decimalToLetters(value, format.case === tcase.UPPER ? 'A' : 'a');
                                break;
                            case formats.ROMAN:
                                formattedInteger = decimalToRoman(value);
                                if (format.case === tcase.UPPER) formattedInteger = formattedInteger.toUpperCase();
                                break;
                            case formats.WORDS:
                                formattedInteger = numberToWords(value, format.ordinal);
                                if (format.case === tcase.UPPER) formattedInteger = formattedInteger.toUpperCase();
                                else if (format.case === tcase.LOWER) formattedInteger = formattedInteger.toLowerCase();
                                break;
                            case formats.DECIMAL:
                                formattedInteger = '' + value;
                                // TODO use functionPad
                                var padLength = format.mandatoryDigits - formattedInteger.length;
                                if (padLength > 0) {
                                    var padding = new Array(padLength + 1).join('0');
                                    formattedInteger = padding + formattedInteger;
                                }
                                if (format.zeroCode !== 0x30) formattedInteger = stringToArray(formattedInteger).map((code)=>{
                                    return String.fromCodePoint(code.codePointAt(0) + format.zeroCode - 0x30);
                                }).join('');
                                // insert the grouping-separator-signs, if any
                                if (format.regular) {
                                    const n = Math.floor((formattedInteger.length - 1) / format.groupingSeparators.position);
                                    for(let ii = n; ii > 0; ii--){
                                        const pos = formattedInteger.length - ii * format.groupingSeparators.position;
                                        formattedInteger = formattedInteger.substr(0, pos) + format.groupingSeparators.character + formattedInteger.substr(pos);
                                    }
                                } else format.groupingSeparators.reverse().forEach((separator)=>{
                                    const pos = formattedInteger.length - separator.position;
                                    formattedInteger = formattedInteger.substr(0, pos) + separator.character + formattedInteger.substr(pos);
                                });
                                if (format.ordinal) {
                                    var suffix123 = {
                                        '1': 'st',
                                        '2': 'nd',
                                        '3': 'rd'
                                    };
                                    var lastDigit = formattedInteger[formattedInteger.length - 1];
                                    var suffix = suffix123[lastDigit];
                                    if (!suffix || formattedInteger.length > 1 && formattedInteger[formattedInteger.length - 2] === '1') suffix = 'th';
                                    formattedInteger = formattedInteger + suffix;
                                }
                                break;
                            case formats.SEQUENCE:
                                throw {
                                    code: 'D3130',
                                    value: format.token
                                };
                        }
                        if (negative) formattedInteger = '-' + formattedInteger;
                        return formattedInteger;
                    }
                    //TODO what about decimal groups in the unicode supplementary planes (surrogate pairs) ???
                    const decimalGroups = [
                        0x30,
                        0x0660,
                        0x06F0,
                        0x07C0,
                        0x0966,
                        0x09E6,
                        0x0A66,
                        0x0AE6,
                        0x0B66,
                        0x0BE6,
                        0x0C66,
                        0x0CE6,
                        0x0D66,
                        0x0DE6,
                        0x0E50,
                        0x0ED0,
                        0x0F20,
                        0x1040,
                        0x1090,
                        0x17E0,
                        0x1810,
                        0x1946,
                        0x19D0,
                        0x1A80,
                        0x1A90,
                        0x1B50,
                        0x1BB0,
                        0x1C40,
                        0x1C50,
                        0xA620,
                        0xA8D0,
                        0xA900,
                        0xA9D0,
                        0xA9F0,
                        0xAA50,
                        0xABF0,
                        0xFF10
                    ];
                    /**
     * preprocesses the picture string
     * @param {string} picture - picture string
     * @returns {{type: string, primary: string, case: string, ordinal: boolean}} - analysed picture
     */ function analyseIntegerPicture(picture) {
                        const format = {
                            type: 'integer',
                            primary: formats.DECIMAL,
                            case: tcase.LOWER,
                            ordinal: false
                        };
                        let primaryFormat, formatModifier;
                        const semicolon = picture.lastIndexOf(';');
                        if (semicolon === -1) primaryFormat = picture;
                        else {
                            primaryFormat = picture.substring(0, semicolon);
                            formatModifier = picture.substring(semicolon + 1);
                            if (formatModifier[0] === 'o') format.ordinal = true;
                        }
                        /* eslnt-disable-next no-fallthrough */ switch(primaryFormat){
                            case 'A':
                                format.case = tcase.UPPER;
                            /* eslnt-disable-next-line no-fallthrough */ case 'a':
                                format.primary = formats.LETTERS;
                                break;
                            case 'I':
                                format.case = tcase.UPPER;
                            /* eslnt-disable-next-line no-fallthrough */ case 'i':
                                format.primary = formats.ROMAN;
                                break;
                            case 'W':
                                format.case = tcase.UPPER;
                                format.primary = formats.WORDS;
                                break;
                            case 'Ww':
                                format.case = tcase.TITLE;
                                format.primary = formats.WORDS;
                                break;
                            case 'w':
                                format.primary = formats.WORDS;
                                break;
                            default:
                                {
                                    // this is a decimal-digit-pattern if it contains a decimal digit (from any unicode decimal digit group)
                                    let zeroCode = null;
                                    let mandatoryDigits = 0;
                                    let optionalDigits = 0;
                                    let groupingSeparators = [];
                                    let separatorPosition = 0;
                                    const formatCodepoints = stringToArray(primaryFormat).map((c)=>c.codePointAt(0)).reverse(); // reverse the array to determine positions of grouping-separator-signs
                                    formatCodepoints.forEach((codePoint)=>{
                                        // step though each char in the picture to determine the digit group
                                        let digit = false;
                                        for(let ii = 0; ii < decimalGroups.length; ii++){
                                            const group = decimalGroups[ii];
                                            if (codePoint >= group && codePoint <= group + 9) {
                                                // codepoint is part of this decimal group
                                                digit = true;
                                                mandatoryDigits++;
                                                separatorPosition++;
                                                if (zeroCode === null) zeroCode = group;
                                                else if (group !== zeroCode) // error! different decimal groups in the same pattern
                                                throw {
                                                    code: 'D3131'
                                                };
                                                break;
                                            }
                                        }
                                        if (!digit) {
                                            if (codePoint === 0x23) {
                                                separatorPosition++;
                                                optionalDigits++;
                                            } else // neither a decimal-digit-sign ot optional-digit-sign, assume it is a grouping-separator-sign
                                            groupingSeparators.push({
                                                position: separatorPosition,
                                                character: String.fromCodePoint(codePoint)
                                            });
                                        }
                                    });
                                    if (mandatoryDigits > 0) {
                                        format.primary = formats.DECIMAL;
                                        // TODO validate decimal-digit-pattern
                                        // the decimal digit family (codepoint offset)
                                        format.zeroCode = zeroCode;
                                        // the number of mandatory digits
                                        format.mandatoryDigits = mandatoryDigits;
                                        // the number of optional digits
                                        format.optionalDigits = optionalDigits;
                                        // grouping separator template
                                        // are the grouping-separator-signs 'regular'?
                                        const regularRepeat = function(separators) {
                                            // are the grouping positions regular? i.e. same interval between each of them
                                            // is there at least one separator?
                                            if (separators.length === 0) return 0;
                                            // are all the characters the same?
                                            const sepChar = separators[0].character;
                                            for(let ii = 1; ii < separators.length; ii++){
                                                if (separators[ii].character !== sepChar) return 0;
                                            }
                                            // are they equally spaced?
                                            const indexes = separators.map((separator)=>separator.position);
                                            const gcd = function(a, b) {
                                                return b === 0 ? a : gcd(b, a % b);
                                            };
                                            // find the greatest common divisor of all the positions
                                            const factor = indexes.reduce(gcd);
                                            // is every position separated by this divisor? If so, it's regular
                                            for(let index = 1; index <= indexes.length; index++){
                                                if (indexes.indexOf(index * factor) === -1) return 0;
                                            }
                                            return factor;
                                        };
                                        const regular = regularRepeat(groupingSeparators);
                                        if (regular > 0) {
                                            format.regular = true;
                                            format.groupingSeparators = {
                                                position: regular,
                                                character: groupingSeparators[0].character
                                            };
                                        } else {
                                            format.regular = false;
                                            format.groupingSeparators = groupingSeparators;
                                        }
                                    } else {
                                        // this is a 'numbering sequence' which the spec says is implementation-defined
                                        // this implementation doesn't support any numbering sequences at the moment.
                                        format.primary = formats.SEQUENCE;
                                        format.token = primaryFormat;
                                    }
                                }
                        }
                        return format;
                    }
                    const defaultPresentationModifiers = {
                        Y: '1',
                        M: '1',
                        D: '1',
                        d: '1',
                        F: 'n',
                        W: '1',
                        w: '1',
                        X: '1',
                        x: '1',
                        H: '1',
                        h: '1',
                        P: 'n',
                        m: '01',
                        s: '01',
                        f: '1',
                        Z: '01:01',
                        z: '01:01',
                        C: 'n',
                        E: 'n'
                    };
                    // §9.8.4.1 the format specifier is an array of string literals and variable markers
                    /**
     * analyse the date-time picture string
     * @param {string} picture - picture string
     * @returns {{type: string, parts: Array}} - the analysed string
     */ function analyseDateTimePicture(picture) {
                        var spec = [];
                        const format = {
                            type: 'datetime',
                            parts: spec
                        };
                        const addLiteral = function(start, end) {
                            if (end > start) {
                                let literal = picture.substring(start, end);
                                // replace any doubled ]] with single ]
                                // what if there are instances of single ']' ? - the spec doesn't say
                                literal = literal.split(']]').join(']');
                                spec.push({
                                    type: 'literal',
                                    value: literal
                                });
                            }
                        };
                        var start = 0, pos = 0;
                        while(pos < picture.length){
                            if (picture.charAt(pos) === '[') {
                                // check it's not a doubled [[
                                if (picture.charAt(pos + 1) === '[') {
                                    // literal [
                                    addLiteral(start, pos);
                                    spec.push({
                                        type: 'literal',
                                        value: '['
                                    });
                                    pos += 2;
                                    start = pos;
                                    continue;
                                }
                                // start of variable marker
                                // push the string literal (if there is one) onto the array
                                addLiteral(start, pos);
                                start = pos;
                                // search forward to closing ]
                                pos = picture.indexOf(']', start);
                                // TODO handle error case if pos === -1
                                if (pos === -1) // error - no closing bracket
                                throw {
                                    code: 'D3135'
                                };
                                let marker = picture.substring(start + 1, pos);
                                // whitespace within a variable marker is ignored (i.e. remove it)
                                marker = marker.split(/\s+/).join('');
                                var def = {
                                    type: 'marker',
                                    component: marker.charAt(0) // 1. The component specifier is always present and is always a single letter.
                                };
                                var comma = marker.lastIndexOf(','); // 2. The width modifier may be recognized by the presence of a comma
                                var presMod; // the presentation modifiers
                                if (comma !== -1) {
                                    // §9.8.4.2 The Width Modifier
                                    const widthMod = marker.substring(comma + 1);
                                    const dash = widthMod.indexOf('-');
                                    let min, max;
                                    const parseWidth = function(wm) {
                                        if (typeof wm === 'undefined' || wm === '*') return undefined;
                                        else // TODO validate wm is an unsigned int
                                        return parseInt(wm);
                                    };
                                    if (dash === -1) min = widthMod;
                                    else {
                                        min = widthMod.substring(0, dash);
                                        max = widthMod.substring(dash + 1);
                                    }
                                    const widthDef = {
                                        min: parseWidth(min),
                                        max: parseWidth(max)
                                    };
                                    def.width = widthDef;
                                    presMod = marker.substring(1, comma);
                                } else presMod = marker.substring(1);
                                if (presMod.length === 1) def.presentation1 = presMod; // first presentation modifier
                                else if (presMod.length > 1) {
                                    var lastChar = presMod.charAt(presMod.length - 1);
                                    if ('atco'.indexOf(lastChar) !== -1) {
                                        def.presentation2 = lastChar;
                                        if (lastChar === 'o') def.ordinal = true;
                                        // 'c' means 'cardinal' and is the default (i.e. not 'ordinal')
                                        // 'a' & 't' are ignored (not sure of their relevance to English numbering)
                                        def.presentation1 = presMod.substring(0, presMod.length - 1);
                                    } else def.presentation1 = presMod;
                                } else // no presentation modifier specified - apply the default;
                                def.presentation1 = defaultPresentationModifiers[def.component];
                                if (typeof def.presentation1 === 'undefined') // unknown component specifier
                                throw {
                                    code: 'D3132',
                                    value: def.component
                                };
                                if (def.presentation1[0] === 'n') def.names = tcase.LOWER;
                                else if (def.presentation1[0] === 'N') {
                                    if (def.presentation1[1] === 'n') def.names = tcase.TITLE;
                                    else def.names = tcase.UPPER;
                                } else if ('YMDdFWwXxHhmsf'.indexOf(def.component) !== -1) {
                                    var integerPattern = def.presentation1;
                                    if (def.presentation2) integerPattern += ';' + def.presentation2;
                                    def.integerFormat = analyseIntegerPicture(integerPattern);
                                    if (def.width && def.width.min !== undefined) {
                                        if (def.integerFormat.mandatoryDigits < def.width.min) def.integerFormat.mandatoryDigits = def.width.min;
                                    }
                                    if ('YMD'.indexOf(def.component) !== -1) {
                                        // §9.8.4.4
                                        def.n = -1;
                                        if (def.width && def.width.max !== undefined) {
                                            def.n = def.width.max;
                                            def.integerFormat.mandatoryDigits = def.n;
                                        } else {
                                            var w = def.integerFormat.mandatoryDigits + def.integerFormat.optionalDigits;
                                            if (w >= 2) def.n = w;
                                        }
                                    }
                                }
                                if (def.component === 'Z' || def.component === 'z') def.integerFormat = analyseIntegerPicture(def.presentation1);
                                spec.push(def);
                                start = pos + 1;
                            }
                            pos++;
                        }
                        addLiteral(start, pos);
                        return format;
                    }
                    const days = [
                        '',
                        'Monday',
                        'Tuesday',
                        'Wednesday',
                        'Thursday',
                        'Friday',
                        'Saturday',
                        'Sunday'
                    ];
                    const months = [
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December'
                    ];
                    const millisInADay = 86400000;
                    const startOfFirstWeek = function(ym) {
                        // ISO 8601 defines the first week of the year to be the week that contains the first Thursday
                        // XPath F&O extends this same definition for the first week of a month
                        // the week starts on a Monday - calculate the millis for the start of the first week
                        // millis for given 1st Jan of that year (at 00:00 UTC)
                        const jan1 = Date.UTC(ym.year, ym.month);
                        var dayOfJan1 = new Date(jan1).getUTCDay();
                        if (dayOfJan1 === 0) dayOfJan1 = 7;
                        // if Jan 1 is Fri, Sat or Sun, then add the number of days (in millis) to jan1 to get the start of week 1
                        return dayOfJan1 > 4 ? jan1 + (8 - dayOfJan1) * millisInADay : jan1 - (dayOfJan1 - 1) * millisInADay;
                    };
                    const yearMonth = function(year, month) {
                        return {
                            year: year,
                            month: month,
                            nextMonth: function() {
                                return month === 11 ? yearMonth(year + 1, 0) : yearMonth(year, month + 1);
                            },
                            previousMonth: function() {
                                return month === 0 ? yearMonth(year - 1, 11) : yearMonth(year, month - 1);
                            },
                            nextYear: function() {
                                return yearMonth(year + 1, month);
                            },
                            previousYear: function() {
                                return yearMonth(year - 1, month);
                            }
                        };
                    };
                    const deltaWeeks = function(start, end) {
                        return (end - start) / (millisInADay * 7) + 1;
                    };
                    const getDateTimeFragment = (date, component)=>{
                        let componentValue;
                        switch(component){
                            case 'Y':
                                componentValue = date.getUTCFullYear();
                                break;
                            case 'M':
                                componentValue = date.getUTCMonth() + 1;
                                break;
                            case 'D':
                                componentValue = date.getUTCDate();
                                break;
                            case 'd':
                                {
                                    // millis for given date (at 00:00 UTC)
                                    const today = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                                    // millis for given 1st Jan of that year (at 00:00 UTC)
                                    const firstJan = Date.UTC(date.getUTCFullYear(), 0);
                                    componentValue = (today - firstJan) / millisInADay + 1;
                                    break;
                                }
                            case 'F':
                                componentValue = date.getUTCDay();
                                if (componentValue === 0) // ISO 8601 defines days 1-7: Mon-Sun
                                componentValue = 7;
                                break;
                            case 'W':
                                {
                                    const thisYear = yearMonth(date.getUTCFullYear(), 0);
                                    const startOfWeek1 = startOfFirstWeek(thisYear);
                                    const today = Date.UTC(thisYear.year, date.getUTCMonth(), date.getUTCDate());
                                    let week = deltaWeeks(startOfWeek1, today);
                                    if (week > 52) {
                                        // might be first week of the following year
                                        const startOfFollowingYear = startOfFirstWeek(thisYear.nextYear());
                                        if (today >= startOfFollowingYear) week = 1;
                                    } else if (week < 1) {
                                        // must be end of the previous year
                                        const startOfPreviousYear = startOfFirstWeek(thisYear.previousYear());
                                        week = deltaWeeks(startOfPreviousYear, today);
                                    }
                                    componentValue = Math.floor(week);
                                    break;
                                }
                            case 'w':
                                {
                                    const thisMonth = yearMonth(date.getUTCFullYear(), date.getUTCMonth());
                                    const startOfWeek1 = startOfFirstWeek(thisMonth);
                                    const today = Date.UTC(thisMonth.year, thisMonth.month, date.getUTCDate());
                                    let week = deltaWeeks(startOfWeek1, today);
                                    if (week > 4) {
                                        // might be first week of the following month
                                        const startOfFollowingMonth = startOfFirstWeek(thisMonth.nextMonth());
                                        if (today >= startOfFollowingMonth) week = 1;
                                    } else if (week < 1) {
                                        // must be end of the previous month
                                        const startOfPreviousMonth = startOfFirstWeek(thisMonth.previousMonth());
                                        week = deltaWeeks(startOfPreviousMonth, today);
                                    }
                                    componentValue = Math.floor(week);
                                    break;
                                }
                            case 'X':
                                {
                                    // Extension: The F&O spec says nothing about how to access the year associated with the week-of-the-year
                                    // e.g. Sat 1 Jan 2005 is in the 53rd week of 2004.
                                    // The 'W' component specifier gives 53, but 'Y' will give 2005.
                                    // I propose to add 'X' as the component specifier to give the ISO week-numbering year (2004 in this example)
                                    const thisYear = yearMonth(date.getUTCFullYear(), 0);
                                    const startOfISOYear = startOfFirstWeek(thisYear);
                                    const endOfISOYear = startOfFirstWeek(thisYear.nextYear());
                                    const now = date.getTime();
                                    if (now < startOfISOYear) componentValue = thisYear.year - 1;
                                    else if (now >= endOfISOYear) componentValue = thisYear.year + 1;
                                    else componentValue = thisYear.year;
                                    break;
                                }
                            case 'x':
                                {
                                    // Extension: The F&O spec says nothing about how to access the month associated with the week-of-the-month
                                    // e.g. Sat 1 Jan 2005 is in the 5th week of December 2004.
                                    // The 'w' component specifier gives 5, but 'W' will give January and 'Y' will give 2005.
                                    // I propose to add 'x' as the component specifier to give the 'week-numbering' month (December in this example)
                                    const thisMonth = yearMonth(date.getUTCFullYear(), date.getUTCMonth());
                                    const startOfISOMonth = startOfFirstWeek(thisMonth);
                                    const nextMonth = thisMonth.nextMonth();
                                    const endOfISOMonth = startOfFirstWeek(nextMonth);
                                    const now = date.getTime();
                                    if (now < startOfISOMonth) componentValue = thisMonth.previousMonth().month + 1;
                                    else if (now >= endOfISOMonth) componentValue = nextMonth.month + 1;
                                    else componentValue = thisMonth.month + 1;
                                    break;
                                }
                            case 'H':
                                componentValue = date.getUTCHours();
                                break;
                            case 'h':
                                componentValue = date.getUTCHours();
                                componentValue = componentValue % 12;
                                if (componentValue === 0) componentValue = 12;
                                break;
                            case 'P':
                                componentValue = date.getUTCHours() >= 12 ? 'pm' : 'am';
                                break;
                            case 'm':
                                componentValue = date.getUTCMinutes();
                                break;
                            case 's':
                                componentValue = date.getUTCSeconds();
                                break;
                            case 'f':
                                componentValue = date.getUTCMilliseconds();
                                break;
                            case 'Z':
                            case 'z':
                                break;
                            case 'C':
                                componentValue = 'ISO';
                                break;
                            case 'E':
                                componentValue = 'ISO';
                                break;
                        }
                        return componentValue;
                    };
                    let iso8601Spec = null;
                    /**
     * formats the date/time as specified by the XPath fn:format-dateTime function
     * @param {number} millis - the timestamp to be formatted, in millis since the epoch
     * @param {string} picture - the picture string that specifies the format
     * @param {string} timezone - the timezone to use
     * @returns {string} - the formatted timestamp
     */ function formatDateTime(millis, picture, timezone) {
                        var offsetHours = 0;
                        var offsetMinutes = 0;
                        if (typeof timezone !== 'undefined') {
                            // parse the hour and minute offsets
                            // assume for now the format supplied is +hhmm
                            const offset = parseInt(timezone);
                            offsetHours = Math.floor(offset / 100);
                            offsetMinutes = offset % 100;
                        }
                        var formatComponent = function(date, markerSpec) {
                            var componentValue = getDateTimeFragment(date, markerSpec.component);
                            // §9.8.4.3 Formatting Integer-Valued Date/Time Components
                            if ('YMDdFWwXxHhms'.indexOf(markerSpec.component) !== -1) {
                                if (markerSpec.component === 'Y') // §9.8.4.4 Formatting the Year Component
                                {
                                    if (markerSpec.n !== -1) componentValue = componentValue % Math.pow(10, markerSpec.n);
                                }
                                if (markerSpec.names) {
                                    if (markerSpec.component === 'M' || markerSpec.component === 'x') componentValue = months[componentValue - 1];
                                    else if (markerSpec.component === 'F') componentValue = days[componentValue];
                                    else throw {
                                        code: 'D3133',
                                        value: markerSpec.component
                                    };
                                    if (markerSpec.names === tcase.UPPER) componentValue = componentValue.toUpperCase();
                                    else if (markerSpec.names === tcase.LOWER) componentValue = componentValue.toLowerCase();
                                    if (markerSpec.width && componentValue.length > markerSpec.width.max) componentValue = componentValue.substring(0, markerSpec.width.max);
                                } else componentValue = _formatInteger(componentValue, markerSpec.integerFormat);
                            } else if (markerSpec.component === 'f') // TODO §9.8.4.5 Formatting Fractional Seconds
                            componentValue = _formatInteger(componentValue, markerSpec.integerFormat);
                            else if (markerSpec.component === 'Z' || markerSpec.component === 'z') {
                                // §9.8.4.6 Formatting timezones
                                const offset = offsetHours * 100 + offsetMinutes;
                                if (markerSpec.integerFormat.regular) componentValue = _formatInteger(offset, markerSpec.integerFormat);
                                else {
                                    const numDigits = markerSpec.integerFormat.mandatoryDigits;
                                    if (numDigits === 1 || numDigits === 2) {
                                        componentValue = _formatInteger(offsetHours, markerSpec.integerFormat);
                                        if (offsetMinutes !== 0) componentValue += ':' + formatInteger(offsetMinutes, '00');
                                    } else if (numDigits === 3 || numDigits === 4) componentValue = _formatInteger(offset, markerSpec.integerFormat);
                                    else throw {
                                        code: 'D3134',
                                        value: numDigits
                                    };
                                }
                                if (offset >= 0) componentValue = '+' + componentValue;
                                if (markerSpec.component === 'z') componentValue = 'GMT' + componentValue;
                                if (offset === 0 && markerSpec.presentation2 === 't') componentValue = 'Z';
                            }
                            return componentValue;
                        };
                        let formatSpec;
                        if (typeof picture === 'undefined') {
                            // default to ISO 8601 format
                            if (iso8601Spec === null) iso8601Spec = analyseDateTimePicture('[Y0001]-[M01]-[D01]T[H01]:[m01]:[s01].[f001][Z01:01t]');
                            formatSpec = iso8601Spec;
                        } else formatSpec = analyseDateTimePicture(picture);
                        const offsetMillis = (60 * offsetHours + offsetMinutes) * 60000;
                        const dateTime = new Date(millis + offsetMillis);
                        let result = '';
                        formatSpec.parts.forEach(function(part) {
                            if (part.type === 'literal') result += part.value;
                            else result += formatComponent(dateTime, part);
                        });
                        return result;
                    }
                    /**
     * Generate a regex to parse integers or timestamps
     * @param {object} formatSpec - object representing the format
     * @returns {object} - regex
     */ function generateRegex(formatSpec) {
                        var matcher = Object.create(null);
                        if (formatSpec.type === 'datetime') {
                            matcher.type = 'datetime';
                            matcher.parts = formatSpec.parts.map(function(part) {
                                var res = Object.create(null);
                                if (part.type === 'literal') res.regex = part.value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                                else if (part.component === 'Z' || part.component === 'z') {
                                    // timezone
                                    let separator;
                                    if (!Array.isArray(part.integerFormat.groupingSeparators)) separator = part.integerFormat.groupingSeparators;
                                    res.regex = '';
                                    if (part.component === 'z') res.regex = 'GMT';
                                    res.regex += '[-+][0-9]+';
                                    if (separator) res.regex += separator.character + '[0-9]+';
                                    res.parse = function(value) {
                                        if (part.component === 'z') value = value.substring(3); // remove the leading GMT
                                        let offsetHours = 0, offsetMinutes = 0;
                                        if (separator) {
                                            offsetHours = Number.parseInt(value.substring(0, value.indexOf(separator.character)));
                                            offsetMinutes = Number.parseInt(value.substring(value.indexOf(separator.character) + 1));
                                        } else {
                                            // depends on number of digits
                                            const numdigits = value.length - 1;
                                            if (numdigits <= 2) // just hour offset
                                            offsetHours = Number.parseInt(value);
                                            else {
                                                offsetHours = Number.parseInt(value.substring(0, 3));
                                                offsetMinutes = Number.parseInt(value.substring(3));
                                            }
                                        }
                                        return offsetHours * 60 + offsetMinutes;
                                    };
                                } else if (part.component === 'f') {
                                    res.regex = '[0-9]+';
                                    res.parse = function(value) {
                                        return parseFloat('0.' + value.substring(0, 3)) * 1000;
                                    };
                                } else if (part.integerFormat) {
                                    part.integerFormat.n = part.n;
                                    res = generateRegex(part.integerFormat);
                                } else {
                                    // must be a month or day name
                                    res.regex = '[a-zA-Z]+';
                                    var lookup = Object.create(null);
                                    if (part.component === 'M' || part.component === 'x') // months
                                    months.forEach(function(name, index) {
                                        if (part.width && part.width.max) lookup[name.substring(0, part.width.max)] = index + 1;
                                        else lookup[name] = index + 1;
                                    });
                                    else if (part.component === 'F') // days
                                    days.forEach(function(name, index) {
                                        if (index > 0) {
                                            if (part.width && part.width.max) lookup[name.substring(0, part.width.max)] = index;
                                            else lookup[name] = index;
                                        }
                                    });
                                    else if (part.component === 'P') lookup = {
                                        'am': 0,
                                        'AM': 0,
                                        'pm': 1,
                                        'PM': 1
                                    };
                                    else // unsupported 'name' option for this component
                                    throw {
                                        code: 'D3133',
                                        value: part.component
                                    };
                                    res.parse = function(value) {
                                        return lookup[value];
                                    };
                                }
                                res.component = part.component;
                                return res;
                            });
                        } else {
                            matcher.type = 'integer';
                            const isUpper = formatSpec.case === tcase.UPPER;
                            let occurrences;
                            if (formatSpec.n && formatSpec.n > 0) {
                                if (formatSpec.optionalDigits === 0) occurrences = `{${formatSpec.n}}`;
                                else occurrences = `{${formatSpec.n - formatSpec.optionalDigits},${formatSpec.n}}`;
                            } else occurrences = '+';
                            switch(formatSpec.primary){
                                case formats.LETTERS:
                                    matcher.regex = isUpper ? '[A-Z]+' : '[a-z]+';
                                    matcher.parse = function(value) {
                                        return lettersToDecimal(value, isUpper ? 'A' : 'a');
                                    };
                                    break;
                                case formats.ROMAN:
                                    matcher.regex = isUpper ? '[MDCLXVI]+' : '[mdclxvi]+';
                                    matcher.parse = function(value) {
                                        return romanToDecimal(isUpper ? value : value.toUpperCase());
                                    };
                                    break;
                                case formats.WORDS:
                                    matcher.regex = '(?:' + utils.keys(wordValues).concat('and', '[\\-, ]').join('|') + ')+';
                                    matcher.parse = function(value) {
                                        return wordsToNumber(value.toLowerCase());
                                    };
                                    break;
                                case formats.DECIMAL:
                                    matcher.regex = `[0-9]${occurrences}`;
                                    if (formatSpec.ordinal) // ordinals
                                    matcher.regex += '(?:th|st|nd|rd)';
                                    matcher.parse = function(value) {
                                        let digits = value;
                                        if (formatSpec.ordinal) // strip off the suffix
                                        digits = value.substring(0, value.length - 2);
                                        // strip out the separators
                                        if (formatSpec.regular) digits = digits.split(',').join('');
                                        else formatSpec.groupingSeparators.forEach((sep)=>{
                                            digits = digits.split(sep.character).join('');
                                        });
                                        if (formatSpec.zeroCode !== 0x30) // apply offset
                                        digits = digits.split('').map((char)=>String.fromCodePoint(char.codePointAt(0) - formatSpec.zeroCode + 0x30)).join('');
                                        return parseInt(digits);
                                    };
                                    break;
                                case formats.SEQUENCE:
                                    throw {
                                        code: 'D3130',
                                        value: formatSpec.token
                                    };
                            }
                        }
                        return matcher;
                    }
                    /**
     * parse a string containing an integer as specified by the picture string
     * @param {string} value - the string to parse
     * @param {string} picture - the picture string
     * @returns {number} - the parsed number
     */ function parseInteger(value, picture) {
                        if (typeof value === 'undefined') return undefined;
                        const formatSpec = analyseIntegerPicture(picture);
                        const matchSpec = generateRegex(formatSpec);
                        //const fullRegex = '^' + matchSpec.regex + '$';
                        //const matcher = new RegExp(fullRegex);
                        // TODO validate input based on the matcher regex
                        const result = matchSpec.parse(value);
                        return result;
                    }
                    /**
     * parse a string containing a timestamp as specified by the picture string
     * @param {string} timestamp - the string to parse
     * @param {string} picture - the picture string
     * @returns {number} - the parsed timestamp in millis since the epoch
     */ function parseDateTime(timestamp, picture) {
                        const formatSpec = analyseDateTimePicture(picture);
                        const matchSpec = generateRegex(formatSpec);
                        const fullRegex = '^' + matchSpec.parts.map((part)=>'(' + part.regex + ')').join('') + '$';
                        const matcher = new RegExp(fullRegex, 'i'); // TODO can cache this against the picture
                        var info = matcher.exec(timestamp);
                        if (info !== null) {
                            // validate what we've just parsed - do we have enough information to create a timestamp?
                            // rules:
                            // The date is specified by one of:
                            //    {Y, M, D}    (dateA)
                            // or {Y, d}       (dateB)
                            // or {Y, x, w, F} (dateC)
                            // or {X, W, F}    (dateD)
                            // The time is specified by one of:
                            //    {H, m, s, f}    (timeA)
                            // or {P, h, m, s, f} (timeB)
                            // All sets can have an optional Z
                            // To create a timestamp (epoch millis) we need both date and time, but we can default missing
                            // information according to the following rules:
                            // - line up one combination of the above from date, and one from time, most significant value (MSV) to least significant (LSV
                            // - for the values that have been captured, if there are any gaps between MSV and LSV, then throw an error
                            //     (e.g.) if hour and seconds, but not minutes is given - throw
                            //     (e.g.) if month, hour and minutes, but not day-of-month is given - throw
                            // - anything right of the LSV should be defaulted to zero
                            //     (e.g.) if hour and minutes given, default seconds and fractional seconds to zero
                            //     (e.g.) if date only given, default the time to 0:00:00.000 (midnight)
                            // - anything left of the MSV should be defaulted to the value of that component returned by $now()
                            //     (e.g.) if time only given, default the date to today
                            //     (e.g.) if month and date given, default to this year (and midnight, by previous rule)
                            //   -- default values for X, x, W, w, F will be derived from the values returned by $now()
                            // implement the above rules
                            // determine which of the above date/time combinations we have by using bit masks
                            //        Y X M x W w d D F P H h m s f Z
                            // dateA  1 0 1 0 0 0 0 1 ?                     0 - must not appear
                            // dateB  1 0 0 0 0 0 1 0 ?                     1 - can appear - relevant
                            // dateC  0 1 0 1 0 1 0 0 1                     ? - can appear - ignored
                            // dateD  0 1 0 0 1 0 0 0 1
                            // timeA                    0 1 0 1 1 1
                            // timeB                    1 0 1 1 1 1
                            // create bitmasks based on the above
                            //    date mask             YXMxWwdD
                            const dmA = 161; // binary 10100001
                            const dmB = 130; // binary 10000010
                            const dmC = 84; // binary 01010100
                            const dmD = 72; // binary 01001000
                            //    time mask             PHhmsf
                            const tmA = 23; // binary 010111
                            const tmB = 47; // binary 101111
                            const components = Object.create(null);
                            for(let i = 1; i < info.length; i++){
                                const mpart = matchSpec.parts[i - 1];
                                if (mpart.parse) components[mpart.component] = mpart.parse(info[i]);
                            }
                            if (Object.getOwnPropertyNames(components).length === 0) // nothing specified
                            return undefined;
                            let mask = 0;
                            const shift = (bit)=>{
                                mask <<= 1;
                                mask += bit ? 1 : 0;
                            };
                            const isType = (type)=>{
                                // shouldn't match any 0's, must match at least one 1
                                return !(~type & mask) && !!(type & mask);
                            };
                            'YXMxWwdD'.split('').forEach((part)=>shift(components[part]));
                            const dateA = isType(dmA);
                            const dateB = !dateA && isType(dmB);
                            const dateC = isType(dmC);
                            const dateD = !dateC && isType(dmD);
                            mask = 0;
                            'PHhmsf'.split('').forEach((part)=>shift(components[part]));
                            const timeA = isType(tmA);
                            const timeB = !timeA && isType(tmB);
                            // should only be zero or one date type and zero or one time type
                            const dateComps = dateB ? 'YD' : dateC ? 'XxwF' : dateD ? 'XWF' : 'YMD';
                            const timeComps = timeB ? 'Phmsf' : 'Hmsf';
                            const comps = dateComps + timeComps;
                            // step through the candidate parts from most significant to least significant
                            // default the most significant unspecified parts to current timestamp component
                            // default the least significant unspecified parts to zero
                            // if any gaps in between the specified parts, throw an error
                            const now = this.environment.timestamp; // must get the fixed timestamp from jsonata
                            let startSpecified = false;
                            let endSpecified = false;
                            comps.split('').forEach((part)=>{
                                if (typeof components[part] === 'undefined') {
                                    if (startSpecified) {
                                        // past the specified block - default to zero
                                        components[part] = 'MDd'.indexOf(part) !== -1 ? 1 : 0;
                                        endSpecified = true;
                                    } else // haven't hit the specified block yet, default to current timestamp
                                    components[part] = getDateTimeFragment(now, part);
                                } else {
                                    startSpecified = true;
                                    if (endSpecified) throw {
                                        code: 'D3136'
                                    };
                                }
                            });
                            // validate and fill in components
                            if (components.M > 0) components.M -= 1; // Date.UTC requires a zero-indexed month
                            else components.M = 0; // default to January
                            if (dateB) {
                                // millis for given 1st Jan of that year (at 00:00 UTC)
                                const firstJan = Date.UTC(components.Y, 0);
                                const offsetMillis = (components.d - 1) * 86400000;
                                const derivedDate = new Date(firstJan + offsetMillis);
                                components.M = derivedDate.getUTCMonth();
                                components.D = derivedDate.getUTCDate();
                            }
                            if (dateC) // TODO implement this
                            // parsing this format not currently supported
                            throw {
                                code: 'D3136'
                            };
                            if (dateD) // TODO implement this
                            // parsing this format (ISO week date) not currently supported
                            throw {
                                code: 'D3136'
                            };
                            if (timeB) {
                                // 12hr to 24hr
                                components.H = components.h === 12 ? 0 : components.h;
                                if (components.P === 1) components.H += 12;
                            }
                            var millis = Date.UTC(components.Y, components.M, components.D, components.H, components.m, components.s, components.f);
                            if (components.Z || components.z) // adjust for timezone
                            millis -= (components.Z || components.z) * 60000;
                            return millis;
                        }
                    }
                    // Regular expression to match an ISO 8601 formatted timestamp
                    var iso8601regex = new RegExp('^\\d{4}(-[01]\\d)?(-[0-3]\\d)?(T[0-2]\\d:[0-5]\\d:[0-5]\\d)?(\\.\\d+)?([+-][0-2]\\d:?[0-5]\\d|Z)?$');
                    /**
     * Converts an ISO 8601 timestamp to milliseconds since the epoch
     *
     * @param {string} timestamp - the timestamp to be converted
     * @param {string} [picture] - the picture string defining the format of the timestamp (defaults to ISO 8601)
     * @returns {Number} - milliseconds since the epoch
     */ function toMillis(timestamp, picture) {
                        // undefined inputs always return undefined
                        if (typeof timestamp === 'undefined') return undefined;
                        if (typeof picture === 'undefined') {
                            if (!iso8601regex.test(timestamp)) throw {
                                stack: new Error().stack,
                                code: "D3110",
                                value: timestamp
                            };
                            return Date.parse(timestamp);
                        } else return parseDateTime.call(this, timestamp, picture);
                    }
                    /**
     * Converts milliseconds since the epoch to an ISO 8601 timestamp
     * @param {Number} millis - milliseconds since the epoch to be converted
     * @param {string} [picture] - the picture string defining the format of the timestamp (defaults to ISO 8601)
     * @param {string} [timezone] - the timezone to format the timestamp in (defaults to UTC)
     * @returns {String} - the formatted timestamp
     */ function fromMillis(millis, picture, timezone) {
                        // undefined inputs always return undefined
                        if (typeof millis === 'undefined') return undefined;
                        return formatDateTime.call(this, millis, picture, timezone);
                    }
                    return {
                        formatInteger: formatInteger,
                        parseInteger: parseInteger,
                        fromMillis: fromMillis,
                        toMillis: toMillis
                    };
                }();
                module1.exports = dateTime;
            },
            {
                "./utils": 6
            }
        ],
        2: [
            function(require1, module1, exports) {
                (function(global1) {
                    (function() {
                        /**
 * © Copyright IBM Corp. 2016, 2018 All Rights Reserved
 *   Project name: JSONata
 *   This project is licensed under the MIT License, see LICENSE
 */ var utils = require1('./utils');
                        const functions = (()=>{
                            'use strict';
                            var isNumeric = utils.isNumeric;
                            var isArrayOfStrings = utils.isArrayOfStrings;
                            var isArrayOfNumbers = utils.isArrayOfNumbers;
                            var createSequence = utils.createSequence;
                            var isSequence = utils.isSequence;
                            var isFunction = utils.isFunction;
                            var isLambda = utils.isLambda;
                            var isIterable = utils.isIterable;
                            var getFunctionArity = utils.getFunctionArity;
                            var deepEquals = utils.isDeepEqual;
                            var stringToArray = utils.stringToArray;
                            /**
     * Sum function
     * @param {Object} args - Arguments
     * @returns {number} Total value of arguments
     */ function sum(args) {
                                // undefined inputs always return undefined
                                if (typeof args === 'undefined') return undefined;
                                var total = 0;
                                args.forEach(function(num) {
                                    total += num;
                                });
                                return total;
                            }
                            /**
     * Count function
     * @param {Object} args - Arguments
     * @returns {number} Number of elements in the array
     */ function count(args) {
                                // undefined inputs always return undefined
                                if (typeof args === 'undefined') return 0;
                                return args.length;
                            }
                            /**
     * Max function
     * @param {Object} args - Arguments
     * @returns {number} Max element in the array
     */ function max(args) {
                                // undefined inputs always return undefined
                                if (typeof args === 'undefined' || args.length === 0) return undefined;
                                return Math.max.apply(Math, args);
                            }
                            /**
     * Min function
     * @param {Object} args - Arguments
     * @returns {number} Min element in the array
     */ function min(args) {
                                // undefined inputs always return undefined
                                if (typeof args === 'undefined' || args.length === 0) return undefined;
                                return Math.min.apply(Math, args);
                            }
                            /**
     * Average function
     * @param {Object} args - Arguments
     * @returns {number} Average element in the array
     */ function average(args) {
                                // undefined inputs always return undefined
                                if (typeof args === 'undefined' || args.length === 0) return undefined;
                                var total = 0;
                                args.forEach(function(num) {
                                    total += num;
                                });
                                return total / args.length;
                            }
                            /**
     * Stringify arguments
     * @param {Object} arg - Arguments
     * @param {boolean} [prettify] - Pretty print the result
     * @returns {String} String from arguments
     */ function string(arg, prettify = false) {
                                // undefined inputs always return undefined
                                if (typeof arg === 'undefined') return undefined;
                                var str;
                                if (typeof arg === 'string') // already a string
                                str = arg;
                                else if (isFunction(arg)) // functions (built-in and lambda convert to empty string
                                str = '';
                                else if (typeof arg === 'number' && !isFinite(arg)) throw {
                                    code: "D3001",
                                    value: arg,
                                    stack: new Error().stack
                                };
                                else {
                                    var space = prettify ? 2 : 0;
                                    if (Array.isArray(arg) && arg.outerWrapper) arg = arg[0];
                                    str = JSON.stringify(arg, function(key, val) {
                                        return typeof val !== 'undefined' && val !== null && val.toPrecision && isNumeric(val) ? Number(val.toPrecision(15)) : val && isFunction(val) ? '' : val;
                                    }, space);
                                }
                                return str;
                            }
                            /**
     * Create substring based on character number and length
     * @param {String} str - String to evaluate
     * @param {Integer} start - Character number to start substring
     * @param {Integer} [length] - Number of characters in substring
     * @returns {string|*} Substring
     */ function substring(str, start, length) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                var strArray = stringToArray(str);
                                var strLength = strArray.length;
                                if (strLength + start < 0) start = 0;
                                if (typeof length !== 'undefined') {
                                    if (length <= 0) return '';
                                    var end = start >= 0 ? start + length : strLength + start + length;
                                    return strArray.slice(start, end).join('');
                                }
                                return strArray.slice(start).join('');
                            }
                            /**
     * Create substring up until a character
     * @param {String} str - String to evaluate
     * @param {String} chars - Character to define substring boundary
     * @returns {*} Substring
     */ function substringBefore(str, chars) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                var pos = str.indexOf(chars);
                                if (pos > -1) return str.substr(0, pos);
                                else return str;
                            }
                            /**
     * Create substring after a character
     * @param {String} str - String to evaluate
     * @param {String} chars - Character to define substring boundary
     * @returns {*} Substring
     */ function substringAfter(str, chars) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                var pos = str.indexOf(chars);
                                if (pos > -1) return str.substr(pos + chars.length);
                                else return str;
                            }
                            /**
     * Lowercase a string
     * @param {String} str - String to evaluate
     * @returns {string} Lowercase string
     */ function lowercase(str) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                return str.toLowerCase();
                            }
                            /**
     * Uppercase a string
     * @param {String} str - String to evaluate
     * @returns {string} Uppercase string
     */ function uppercase(str) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                return str.toUpperCase();
                            }
                            /**
     * length of a string
     * @param {String} str - string
     * @returns {Number} The number of characters in the string
     */ function length(str) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                return stringToArray(str).length;
                            }
                            /**
     * Normalize and trim whitespace within a string
     * @param {string} str - string to be trimmed
     * @returns {string} - trimmed string
     */ function trim(str) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                // normalize whitespace
                                var result = str.replace(/[ \t\n\r]+/gm, ' ');
                                if (result.charAt(0) === ' ') // strip leading space
                                result = result.substring(1);
                                if (result.charAt(result.length - 1) === ' ') // strip trailing space
                                result = result.substring(0, result.length - 1);
                                return result;
                            }
                            /**
     * Pad a string to a minimum width by adding characters to the start or end
     * @param {string} str - string to be padded
     * @param {number} width - the minimum width; +ve pads to the right, -ve pads to the left
     * @param {string} [char] - the pad character(s); defaults to ' '
     * @returns {string} - padded string
     */ function pad(str, width, char) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                if (typeof char === 'undefined' || char.length === 0) char = ' ';
                                var result;
                                var padLength = Math.abs(width) - length(str);
                                if (padLength > 0) {
                                    var padding = new Array(padLength + 1).join(char);
                                    if (char.length > 1) padding = substring(padding, 0, padLength);
                                    if (width > 0) result = str + padding;
                                    else result = padding + str;
                                } else result = str;
                                return result;
                            }
                            /**
     * Evaluate the matcher function against the str arg
     *
     * @param {*} matcher - matching function (native or lambda)
     * @param {string} str - the string to match against
     * @returns {object} - structure that represents the match(es)
     */ function* evaluateMatcher(matcher, str) {
                                var result = matcher.apply(this, [
                                    str
                                ]); // eslint-disable-line no-useless-call
                                if (isIterable(result)) result = yield* result;
                                if (result && !(typeof result.start === 'number' || result.end === 'number' || Array.isArray(result.groups) || isFunction(result.next))) // the matcher function didn't return the correct structure
                                throw {
                                    code: "T1010",
                                    stack: new Error().stack
                                };
                                return result;
                            }
                            /**
     * Tests if the str contains the token
     * @param {String} str - string to test
     * @param {String} token - substring or regex to find
     * @returns {Boolean} - true if str contains token
     */ function* contains(str, token) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                var result;
                                if (typeof token === 'string') result = str.indexOf(token) !== -1;
                                else {
                                    var matches = yield* evaluateMatcher(token, str);
                                    result = typeof matches !== 'undefined';
                                }
                                return result;
                            }
                            /**
     * Match a string with a regex returning an array of object containing details of each match
     * @param {String} str - string
     * @param {String} regex - the regex applied to the string
     * @param {Integer} [limit] - max number of matches to return
     * @returns {Array} The array of match objects
     */ function* match(str, regex, limit) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                // limit, if specified, must be a non-negative number
                                if (limit < 0) throw {
                                    stack: new Error().stack,
                                    value: limit,
                                    code: 'D3040',
                                    index: 3
                                };
                                var result = createSequence();
                                if (typeof limit === 'undefined' || limit > 0) {
                                    var count = 0;
                                    var matches = yield* evaluateMatcher(regex, str);
                                    if (typeof matches !== 'undefined') while(typeof matches !== 'undefined' && (typeof limit === 'undefined' || count < limit)){
                                        result.push({
                                            match: matches.match,
                                            index: matches.start,
                                            groups: matches.groups
                                        });
                                        matches = yield* evaluateMatcher(matches.next);
                                        count++;
                                    }
                                }
                                return result;
                            }
                            /**
     * Match a string with a regex returning an array of object containing details of each match
     * @param {String} str - string
     * @param {String} pattern - the substring/regex applied to the string
     * @param {String} replacement - text to replace the matched substrings
     * @param {Integer} [limit] - max number of matches to return
     * @returns {Array} The array of match objects
     */ function* replace(str, pattern, replacement, limit) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                var self1 = this;
                                // pattern cannot be an empty string
                                if (pattern === '') throw {
                                    code: "D3010",
                                    stack: new Error().stack,
                                    value: pattern,
                                    index: 2
                                };
                                // limit, if specified, must be a non-negative number
                                if (limit < 0) throw {
                                    code: "D3011",
                                    stack: new Error().stack,
                                    value: limit,
                                    index: 4
                                };
                                var replacer;
                                if (typeof replacement === 'string') replacer = function(regexMatch) {
                                    var substitute = '';
                                    // scan forward, copying the replacement text into the substitute string
                                    // and replace any occurrence of $n with the values matched by the regex
                                    var position = 0;
                                    var index = replacement.indexOf('$', position);
                                    while(index !== -1 && position < replacement.length){
                                        substitute += replacement.substring(position, index);
                                        position = index + 1;
                                        var dollarVal = replacement.charAt(position);
                                        if (dollarVal === '$') {
                                            // literal $
                                            substitute += '$';
                                            position++;
                                        } else if (dollarVal === '0') {
                                            substitute += regexMatch.match;
                                            position++;
                                        } else {
                                            var maxDigits;
                                            if (regexMatch.groups.length === 0) // no sub-matches; any $ followed by a digit will be replaced by an empty string
                                            maxDigits = 1;
                                            else // max number of digits to parse following the $
                                            maxDigits = Math.floor(Math.log(regexMatch.groups.length) * Math.LOG10E) + 1;
                                            index = parseInt(replacement.substring(position, position + maxDigits), 10);
                                            if (maxDigits > 1 && index > regexMatch.groups.length) index = parseInt(replacement.substring(position, position + maxDigits - 1), 10);
                                            if (!isNaN(index)) {
                                                if (regexMatch.groups.length > 0) {
                                                    var submatch = regexMatch.groups[index - 1];
                                                    if (typeof submatch !== 'undefined') substitute += submatch;
                                                }
                                                position += index.toString().length;
                                            } else // not a capture group, treat the $ as literal
                                            substitute += '$';
                                        }
                                        index = replacement.indexOf('$', position);
                                    }
                                    substitute += replacement.substring(position);
                                    return substitute;
                                };
                                else replacer = replacement;
                                var result = '';
                                var position = 0;
                                if (typeof limit === 'undefined' || limit > 0) {
                                    var count = 0;
                                    if (typeof pattern === 'string') {
                                        var index = str.indexOf(pattern, position);
                                        while(index !== -1 && (typeof limit === 'undefined' || count < limit)){
                                            result += str.substring(position, index);
                                            result += replacement;
                                            position = index + pattern.length;
                                            count++;
                                            index = str.indexOf(pattern, position);
                                        }
                                        result += str.substring(position);
                                    } else {
                                        var matches = yield* evaluateMatcher(pattern, str);
                                        if (typeof matches !== 'undefined') {
                                            while(typeof matches !== 'undefined' && (typeof limit === 'undefined' || count < limit)){
                                                result += str.substring(position, matches.start);
                                                var replacedWith = replacer.apply(self1, [
                                                    matches
                                                ]);
                                                if (isIterable(replacedWith)) replacedWith = yield* replacedWith;
                                                // check replacedWith is a string
                                                if (typeof replacedWith === 'string') result += replacedWith;
                                                else // not a string - throw error
                                                throw {
                                                    code: "D3012",
                                                    stack: new Error().stack,
                                                    value: replacedWith
                                                };
                                                position = matches.start + matches.match.length;
                                                count++;
                                                matches = yield* evaluateMatcher(matches.next);
                                            }
                                            result += str.substring(position);
                                        } else result = str;
                                    }
                                } else result = str;
                                return result;
                            }
                            /**
     * Base64 encode a string
     * @param {String} str - string
     * @returns {String} Base 64 encoding of the binary data
     */ function base64encode(str) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                // Use btoa in a browser, or Buffer in Node.js
                                var btoa = typeof window !== 'undefined' ? /* istanbul ignore next */ window.btoa : function(str) {
                                    // Simply doing `new Buffer` at this point causes Browserify to pull
                                    // in the entire Buffer browser library, which is large and unnecessary.
                                    // Using `global.Buffer` defeats this.
                                    return new global1.Buffer.from(str, 'binary').toString('base64'); // eslint-disable-line new-cap
                                };
                                return btoa(str);
                            }
                            /**
     * Base64 decode a string
     * @param {String} str - string
     * @returns {String} Base 64 encoding of the binary data
     */ function base64decode(str) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                // Use btoa in a browser, or Buffer in Node.js
                                var atob = typeof window !== 'undefined' ? /* istanbul ignore next */ window.atob : function(str) {
                                    // Simply doing `new Buffer` at this point causes Browserify to pull
                                    // in the entire Buffer browser library, which is large and unnecessary.
                                    // Using `global.Buffer` defeats this.
                                    return new global1.Buffer.from(str, 'base64').toString('binary'); // eslint-disable-line new-cap
                                };
                                return atob(str);
                            }
                            /**
     * Encode a string into a component for a url
     * @param {String} str - String to encode
     * @returns {string} Encoded string
     */ function encodeUrlComponent(str) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                // Catch URIErrors when URI sequence is malformed
                                var returnVal;
                                try {
                                    returnVal = encodeURIComponent(str);
                                } catch (e) {
                                    throw {
                                        code: "D3140",
                                        stack: new Error().stack,
                                        value: str,
                                        functionName: "encodeUrlComponent"
                                    };
                                }
                                return returnVal;
                            }
                            /**
     * Encode a string into a url
     * @param {String} str - String to encode
     * @returns {string} Encoded string
     */ function encodeUrl(str) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                // Catch URIErrors when URI sequence is malformed
                                var returnVal;
                                try {
                                    returnVal = encodeURI(str);
                                } catch (e) {
                                    throw {
                                        code: "D3140",
                                        stack: new Error().stack,
                                        value: str,
                                        functionName: "encodeUrl"
                                    };
                                }
                                return returnVal;
                            }
                            /**
     * Decode a string from a component for a url
     * @param {String} str - String to decode
     * @returns {string} Decoded string
     */ function decodeUrlComponent(str) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                // Catch URIErrors when URI sequence is malformed
                                var returnVal;
                                try {
                                    returnVal = decodeURIComponent(str);
                                } catch (e) {
                                    throw {
                                        code: "D3140",
                                        stack: new Error().stack,
                                        value: str,
                                        functionName: "decodeUrlComponent"
                                    };
                                }
                                return returnVal;
                            }
                            /**
     * Decode a string from a url
     * @param {String} str - String to decode
     * @returns {string} Decoded string
     */ function decodeUrl(str) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                // Catch URIErrors when URI sequence is malformed
                                var returnVal;
                                try {
                                    returnVal = decodeURI(str);
                                } catch (e) {
                                    throw {
                                        code: "D3140",
                                        stack: new Error().stack,
                                        value: str,
                                        functionName: "decodeUrl"
                                    };
                                }
                                return returnVal;
                            }
                            /**
     * Split a string into an array of substrings
     * @param {String} str - string
     * @param {String} separator - the token or regex that splits the string
     * @param {Integer} [limit] - max number of substrings
     * @returns {Array} The array of string
     */ function* split(str, separator, limit) {
                                // undefined inputs always return undefined
                                if (typeof str === 'undefined') return undefined;
                                // limit, if specified, must be a non-negative number
                                if (limit < 0) throw {
                                    code: "D3020",
                                    stack: new Error().stack,
                                    value: limit,
                                    index: 3
                                };
                                var result = [];
                                if (typeof limit === 'undefined' || limit > 0) {
                                    if (typeof separator === 'string') result = str.split(separator, limit);
                                    else {
                                        var count = 0;
                                        var matches = yield* evaluateMatcher(separator, str);
                                        if (typeof matches !== 'undefined') {
                                            var start = 0;
                                            while(typeof matches !== 'undefined' && (typeof limit === 'undefined' || count < limit)){
                                                result.push(str.substring(start, matches.start));
                                                start = matches.end;
                                                matches = yield* evaluateMatcher(matches.next);
                                                count++;
                                            }
                                            if (typeof limit === 'undefined' || count < limit) result.push(str.substring(start));
                                        } else result.push(str);
                                    }
                                }
                                return result;
                            }
                            /**
     * Join an array of strings
     * @param {Array} strs - array of string
     * @param {String} [separator] - the token that splits the string
     * @returns {String} The concatenated string
     */ function join(strs, separator) {
                                // undefined inputs always return undefined
                                if (typeof strs === 'undefined') return undefined;
                                // if separator is not specified, default to empty string
                                if (typeof separator === 'undefined') separator = "";
                                return strs.join(separator);
                            }
                            /**
     * Formats a number into a decimal string representation using XPath 3.1 F&O fn:format-number spec
     * @param {number} value - number to format
     * @param {String} picture - picture string definition
     * @param {Object} [options] - override locale defaults
     * @returns {String} The formatted string
     */ function formatNumber(value, picture, options) {
                                // undefined inputs always return undefined
                                if (typeof value === 'undefined') return undefined;
                                var defaults = {
                                    "decimal-separator": ".",
                                    "grouping-separator": ",",
                                    "exponent-separator": "e",
                                    "infinity": "Infinity",
                                    "minus-sign": "-",
                                    "NaN": "NaN",
                                    "percent": "%",
                                    "per-mille": "\u2030",
                                    "zero-digit": "0",
                                    "digit": "#",
                                    "pattern-separator": ";"
                                };
                                // if `options` is specified, then its entries override defaults
                                var properties = defaults;
                                if (typeof options !== 'undefined') utils.keys(options).forEach(function(key) {
                                    properties[key] = options[key];
                                });
                                var decimalDigitFamily = [];
                                var zeroCharCode = properties['zero-digit'].charCodeAt(0);
                                for(var ii = zeroCharCode; ii < zeroCharCode + 10; ii++)decimalDigitFamily.push(String.fromCharCode(ii));
                                var activeChars = decimalDigitFamily.concat([
                                    properties['decimal-separator'],
                                    properties['exponent-separator'],
                                    properties['grouping-separator'],
                                    properties.digit,
                                    properties['pattern-separator']
                                ]);
                                var subPictures = picture.split(properties['pattern-separator']);
                                if (subPictures.length > 2) throw {
                                    code: 'D3080',
                                    stack: new Error().stack
                                };
                                var splitParts = function(subpicture) {
                                    var prefix = function() {
                                        var ch;
                                        for(var ii = 0; ii < subpicture.length; ii++){
                                            ch = subpicture.charAt(ii);
                                            if (activeChars.indexOf(ch) !== -1 && ch !== properties['exponent-separator']) return subpicture.substring(0, ii);
                                        }
                                    }();
                                    var suffix = function() {
                                        var ch;
                                        for(var ii = subpicture.length - 1; ii >= 0; ii--){
                                            ch = subpicture.charAt(ii);
                                            if (activeChars.indexOf(ch) !== -1 && ch !== properties['exponent-separator']) return subpicture.substring(ii + 1);
                                        }
                                    }();
                                    var activePart = subpicture.substring(prefix.length, subpicture.length - suffix.length);
                                    var mantissaPart, exponentPart, integerPart, fractionalPart;
                                    var exponentPosition = subpicture.indexOf(properties['exponent-separator'], prefix.length);
                                    if (exponentPosition === -1 || exponentPosition > subpicture.length - suffix.length) {
                                        mantissaPart = activePart;
                                        exponentPart = undefined;
                                    } else {
                                        mantissaPart = activePart.substring(0, exponentPosition);
                                        exponentPart = activePart.substring(exponentPosition + 1);
                                    }
                                    var decimalPosition = mantissaPart.indexOf(properties['decimal-separator']);
                                    if (decimalPosition === -1) {
                                        integerPart = mantissaPart;
                                        fractionalPart = suffix;
                                    } else {
                                        integerPart = mantissaPart.substring(0, decimalPosition);
                                        fractionalPart = mantissaPart.substring(decimalPosition + 1);
                                    }
                                    return {
                                        prefix: prefix,
                                        suffix: suffix,
                                        activePart: activePart,
                                        mantissaPart: mantissaPart,
                                        exponentPart: exponentPart,
                                        integerPart: integerPart,
                                        fractionalPart: fractionalPart,
                                        subpicture: subpicture
                                    };
                                };
                                // validate the picture string, F&O 4.7.3
                                var validate = function(parts) {
                                    var error;
                                    var ii;
                                    var subpicture = parts.subpicture;
                                    var decimalPos = subpicture.indexOf(properties['decimal-separator']);
                                    if (decimalPos !== subpicture.lastIndexOf(properties['decimal-separator'])) error = 'D3081';
                                    if (subpicture.indexOf(properties.percent) !== subpicture.lastIndexOf(properties.percent)) error = 'D3082';
                                    if (subpicture.indexOf(properties['per-mille']) !== subpicture.lastIndexOf(properties['per-mille'])) error = 'D3083';
                                    if (subpicture.indexOf(properties.percent) !== -1 && subpicture.indexOf(properties['per-mille']) !== -1) error = 'D3084';
                                    var valid = false;
                                    for(ii = 0; ii < parts.mantissaPart.length; ii++){
                                        var ch = parts.mantissaPart.charAt(ii);
                                        if (decimalDigitFamily.indexOf(ch) !== -1 || ch === properties.digit) {
                                            valid = true;
                                            break;
                                        }
                                    }
                                    if (!valid) error = 'D3085';
                                    var charTypes = parts.activePart.split('').map(function(char) {
                                        return activeChars.indexOf(char) === -1 ? 'p' : 'a';
                                    }).join('');
                                    if (charTypes.indexOf('p') !== -1) error = 'D3086';
                                    if (decimalPos !== -1) {
                                        if (subpicture.charAt(decimalPos - 1) === properties['grouping-separator'] || subpicture.charAt(decimalPos + 1) === properties['grouping-separator']) error = 'D3087';
                                    } else if (parts.integerPart.charAt(parts.integerPart.length - 1) === properties['grouping-separator']) error = 'D3088';
                                    if (subpicture.indexOf(properties['grouping-separator'] + properties['grouping-separator']) !== -1) error = 'D3089';
                                    var optionalDigitPos = parts.integerPart.indexOf(properties.digit);
                                    if (optionalDigitPos !== -1 && parts.integerPart.substring(0, optionalDigitPos).split('').filter(function(char) {
                                        return decimalDigitFamily.indexOf(char) > -1;
                                    }).length > 0) error = 'D3090';
                                    optionalDigitPos = parts.fractionalPart.lastIndexOf(properties.digit);
                                    if (optionalDigitPos !== -1 && parts.fractionalPart.substring(optionalDigitPos).split('').filter(function(char) {
                                        return decimalDigitFamily.indexOf(char) > -1;
                                    }).length > 0) error = 'D3091';
                                    var exponentExists = typeof parts.exponentPart === 'string';
                                    if (exponentExists && parts.exponentPart.length > 0 && (subpicture.indexOf(properties.percent) !== -1 || subpicture.indexOf(properties['per-mille']) !== -1)) error = 'D3092';
                                    if (exponentExists && (parts.exponentPart.length === 0 || parts.exponentPart.split('').filter(function(char) {
                                        return decimalDigitFamily.indexOf(char) === -1;
                                    }).length > 0)) error = 'D3093';
                                    if (error) throw {
                                        code: error,
                                        stack: new Error().stack
                                    };
                                };
                                // analyse the picture string, F&O 4.7.4
                                var analyse = function(parts) {
                                    var getGroupingPositions = function(part, toLeft) {
                                        var positions = [];
                                        var groupingPosition = part.indexOf(properties['grouping-separator']);
                                        while(groupingPosition !== -1){
                                            var charsToTheRight = (toLeft ? part.substring(0, groupingPosition) : part.substring(groupingPosition)).split('').filter(function(char) {
                                                return decimalDigitFamily.indexOf(char) !== -1 || char === properties.digit;
                                            }).length;
                                            positions.push(charsToTheRight);
                                            groupingPosition = parts.integerPart.indexOf(properties['grouping-separator'], groupingPosition + 1);
                                        }
                                        return positions;
                                    };
                                    var integerPartGroupingPositions = getGroupingPositions(parts.integerPart);
                                    var regular = function(indexes) {
                                        // are the grouping positions regular? i.e. same interval between each of them
                                        if (indexes.length === 0) return 0;
                                        var gcd = function(a, b) {
                                            return b === 0 ? a : gcd(b, a % b);
                                        };
                                        // find the greatest common divisor of all the positions
                                        var factor = indexes.reduce(gcd);
                                        // is every position separated by this divisor? If so, it's regular
                                        for(var index = 1; index <= indexes.length; index++){
                                            if (indexes.indexOf(index * factor) === -1) return 0;
                                        }
                                        return factor;
                                    };
                                    var regularGrouping = regular(integerPartGroupingPositions);
                                    var fractionalPartGroupingPositions = getGroupingPositions(parts.fractionalPart, true);
                                    var minimumIntegerPartSize = parts.integerPart.split('').filter(function(char) {
                                        return decimalDigitFamily.indexOf(char) !== -1;
                                    }).length;
                                    var scalingFactor = minimumIntegerPartSize;
                                    var fractionalPartArray = parts.fractionalPart.split('');
                                    var minimumFactionalPartSize = fractionalPartArray.filter(function(char) {
                                        return decimalDigitFamily.indexOf(char) !== -1;
                                    }).length;
                                    var maximumFactionalPartSize = fractionalPartArray.filter(function(char) {
                                        return decimalDigitFamily.indexOf(char) !== -1 || char === properties.digit;
                                    }).length;
                                    var exponentPresent = typeof parts.exponentPart === 'string';
                                    if (minimumIntegerPartSize === 0 && maximumFactionalPartSize === 0) {
                                        if (exponentPresent) {
                                            minimumFactionalPartSize = 1;
                                            maximumFactionalPartSize = 1;
                                        } else minimumIntegerPartSize = 1;
                                    }
                                    if (exponentPresent && minimumIntegerPartSize === 0 && parts.integerPart.indexOf(properties.digit) !== -1) minimumIntegerPartSize = 1;
                                    if (minimumIntegerPartSize === 0 && minimumFactionalPartSize === 0) minimumFactionalPartSize = 1;
                                    var minimumExponentSize = 0;
                                    if (exponentPresent) minimumExponentSize = parts.exponentPart.split('').filter(function(char) {
                                        return decimalDigitFamily.indexOf(char) !== -1;
                                    }).length;
                                    return {
                                        integerPartGroupingPositions: integerPartGroupingPositions,
                                        regularGrouping: regularGrouping,
                                        minimumIntegerPartSize: minimumIntegerPartSize,
                                        scalingFactor: scalingFactor,
                                        prefix: parts.prefix,
                                        fractionalPartGroupingPositions: fractionalPartGroupingPositions,
                                        minimumFactionalPartSize: minimumFactionalPartSize,
                                        maximumFactionalPartSize: maximumFactionalPartSize,
                                        minimumExponentSize: minimumExponentSize,
                                        suffix: parts.suffix,
                                        picture: parts.subpicture
                                    };
                                };
                                var parts = subPictures.map(splitParts);
                                parts.forEach(validate);
                                var variables = parts.map(analyse);
                                var minus_sign = properties['minus-sign'];
                                var zero_digit = properties['zero-digit'];
                                var decimal_separator = properties['decimal-separator'];
                                var grouping_separator = properties['grouping-separator'];
                                if (variables.length === 1) {
                                    variables.push(JSON.parse(JSON.stringify(variables[0])));
                                    variables[1].prefix = minus_sign + variables[1].prefix;
                                }
                                // TODO cache the result of the analysis
                                // format the number
                                // bullet 1: TODO: NaN - not sure we'd ever get this in JSON
                                var pic;
                                // bullet 2:
                                if (value >= 0) pic = variables[0];
                                else pic = variables[1];
                                var adjustedNumber;
                                // bullet 3:
                                if (pic.picture.indexOf(properties.percent) !== -1) adjustedNumber = value * 100;
                                else if (pic.picture.indexOf(properties['per-mille']) !== -1) adjustedNumber = value * 1000;
                                else adjustedNumber = value;
                                // bullet 4:
                                // TODO: infinity - not sure we'd ever get this in JSON
                                // bullet 5:
                                var mantissa, exponent;
                                if (pic.minimumExponentSize === 0) mantissa = adjustedNumber;
                                else {
                                    // mantissa * 10^exponent = adjustedNumber
                                    var maxMantissa = Math.pow(10, pic.scalingFactor);
                                    var minMantissa = Math.pow(10, pic.scalingFactor - 1);
                                    mantissa = adjustedNumber;
                                    exponent = 0;
                                    while(mantissa < minMantissa){
                                        mantissa *= 10;
                                        exponent -= 1;
                                    }
                                    while(mantissa > maxMantissa){
                                        mantissa /= 10;
                                        exponent += 1;
                                    }
                                }
                                // bullet 6:
                                var roundedNumber = round(mantissa, pic.maximumFactionalPartSize);
                                // bullet 7:
                                var makeString = function(value, dp) {
                                    var str = Math.abs(value).toFixed(dp);
                                    if (zero_digit !== '0') str = str.split('').map(function(digit) {
                                        if (digit >= '0' && digit <= '9') return decimalDigitFamily[digit.charCodeAt(0) - 48];
                                        else return digit;
                                    }).join('');
                                    return str;
                                };
                                var stringValue = makeString(roundedNumber, pic.maximumFactionalPartSize);
                                var decimalPos = stringValue.indexOf('.');
                                if (decimalPos === -1) stringValue = stringValue + decimal_separator;
                                else stringValue = stringValue.replace('.', decimal_separator);
                                while(stringValue.charAt(0) === zero_digit)stringValue = stringValue.substring(1);
                                while(stringValue.charAt(stringValue.length - 1) === zero_digit)stringValue = stringValue.substring(0, stringValue.length - 1);
                                // bullets 8 & 9:
                                decimalPos = stringValue.indexOf(decimal_separator);
                                var padLeft = pic.minimumIntegerPartSize - decimalPos;
                                var padRight = pic.minimumFactionalPartSize - (stringValue.length - decimalPos - 1);
                                stringValue = (padLeft > 0 ? new Array(padLeft + 1).join(zero_digit) : '') + stringValue;
                                stringValue = stringValue + (padRight > 0 ? new Array(padRight + 1).join(zero_digit) : '');
                                decimalPos = stringValue.indexOf(decimal_separator);
                                // bullet 10:
                                if (pic.regularGrouping > 0) {
                                    var groupCount = Math.floor((decimalPos - 1) / pic.regularGrouping);
                                    for(var group = 1; group <= groupCount; group++)stringValue = [
                                        stringValue.slice(0, decimalPos - group * pic.regularGrouping),
                                        grouping_separator,
                                        stringValue.slice(decimalPos - group * pic.regularGrouping)
                                    ].join('');
                                } else pic.integerPartGroupingPositions.forEach(function(pos) {
                                    stringValue = [
                                        stringValue.slice(0, decimalPos - pos),
                                        grouping_separator,
                                        stringValue.slice(decimalPos - pos)
                                    ].join('');
                                    decimalPos++;
                                });
                                // bullet 11:
                                decimalPos = stringValue.indexOf(decimal_separator);
                                pic.fractionalPartGroupingPositions.forEach(function(pos) {
                                    stringValue = [
                                        stringValue.slice(0, pos + decimalPos + 1),
                                        grouping_separator,
                                        stringValue.slice(pos + decimalPos + 1)
                                    ].join('');
                                });
                                // bullet 12:
                                decimalPos = stringValue.indexOf(decimal_separator);
                                if (pic.picture.indexOf(decimal_separator) === -1 || decimalPos === stringValue.length - 1) stringValue = stringValue.substring(0, stringValue.length - 1);
                                // bullet 13:
                                if (typeof exponent !== 'undefined') {
                                    var stringExponent = makeString(exponent, 0);
                                    padLeft = pic.minimumExponentSize - stringExponent.length;
                                    if (padLeft > 0) stringExponent = new Array(padLeft + 1).join(zero_digit) + stringExponent;
                                    stringValue = stringValue + properties['exponent-separator'] + (exponent < 0 ? minus_sign : '') + stringExponent;
                                }
                                // bullet 14:
                                stringValue = pic.prefix + stringValue + pic.suffix;
                                return stringValue;
                            }
                            /**
     * Converts a number to a string using a specified number base
     * @param {number} value - the number to convert
     * @param {number} [radix] - the number base; must be between 2 and 36. Defaults to 10
     * @returns {string} - the converted string
     */ function formatBase(value, radix) {
                                // undefined inputs always return undefined
                                if (typeof value === 'undefined') return undefined;
                                value = round(value);
                                if (typeof radix === 'undefined') radix = 10;
                                else radix = round(radix);
                                if (radix < 2 || radix > 36) throw {
                                    code: 'D3100',
                                    stack: new Error().stack,
                                    value: radix
                                };
                                var result = value.toString(radix);
                                return result;
                            }
                            /**
     * Cast argument to number
     * @param {Object} arg - Argument
     * @returns {Number} numeric value of argument
     */ function number(arg) {
                                var result;
                                // undefined inputs always return undefined
                                if (typeof arg === 'undefined') return undefined;
                                if (typeof arg === 'number') // already a number
                                result = arg;
                                else if (typeof arg === 'string' && /^-?[0-9]+(\.[0-9]+)?([Ee][-+]?[0-9]+)?$/.test(arg) && !isNaN(parseFloat(arg)) && isFinite(arg)) result = parseFloat(arg);
                                else if (arg === true) // boolean true casts to 1
                                result = 1;
                                else if (arg === false) // boolean false casts to 0
                                result = 0;
                                else throw {
                                    code: "D3030",
                                    value: arg,
                                    stack: new Error().stack,
                                    index: 1
                                };
                                return result;
                            }
                            /**
     * Absolute value of a number
     * @param {Number} arg - Argument
     * @returns {Number} absolute value of argument
     */ function abs(arg) {
                                var result;
                                // undefined inputs always return undefined
                                if (typeof arg === 'undefined') return undefined;
                                result = Math.abs(arg);
                                return result;
                            }
                            /**
     * Rounds a number down to integer
     * @param {Number} arg - Argument
     * @returns {Number} rounded integer
     */ function floor(arg) {
                                var result;
                                // undefined inputs always return undefined
                                if (typeof arg === 'undefined') return undefined;
                                result = Math.floor(arg);
                                return result;
                            }
                            /**
     * Rounds a number up to integer
     * @param {Number} arg - Argument
     * @returns {Number} rounded integer
     */ function ceil(arg) {
                                var result;
                                // undefined inputs always return undefined
                                if (typeof arg === 'undefined') return undefined;
                                result = Math.ceil(arg);
                                return result;
                            }
                            /**
     * Round to half even
     * @param {Number} arg - Argument
     * @param {Number} [precision] - number of decimal places
     * @returns {Number} rounded integer
     */ function round(arg, precision) {
                                var result;
                                // undefined inputs always return undefined
                                if (typeof arg === 'undefined') return undefined;
                                if (precision) {
                                    // shift the decimal place - this needs to be done in a string since multiplying
                                    // by a power of ten can introduce floating point precision errors which mess up
                                    // this rounding algorithm - See 'Decimal rounding' in
                                    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
                                    // Shift
                                    var value = arg.toString().split('e');
                                    arg = +(value[0] + 'e' + (value[1] ? +value[1] + precision : precision));
                                }
                                // round up to nearest int
                                result = Math.round(arg);
                                var diff = result - arg;
                                if (Math.abs(diff) === 0.5 && Math.abs(result % 2) === 1) // rounded the wrong way - adjust to nearest even number
                                result = result - 1;
                                if (precision) {
                                    // Shift back
                                    value = result.toString().split('e');
                                    /* istanbul ignore next */ result = +(value[0] + 'e' + (value[1] ? +value[1] - precision : -precision));
                                }
                                if (Object.is(result, -0)) // JSON doesn't do -0
                                result = 0;
                                return result;
                            }
                            /**
     * Square root of number
     * @param {Number} arg - Argument
     * @returns {Number} square root
     */ function sqrt(arg) {
                                var result;
                                // undefined inputs always return undefined
                                if (typeof arg === 'undefined') return undefined;
                                if (arg < 0) throw {
                                    stack: new Error().stack,
                                    code: "D3060",
                                    index: 1,
                                    value: arg
                                };
                                result = Math.sqrt(arg);
                                return result;
                            }
                            /**
     * Raises number to the power of the second number
     * @param {Number} arg - the base
     * @param {Number} exp - the exponent
     * @returns {Number} rounded integer
     */ function power(arg, exp) {
                                var result;
                                // undefined inputs always return undefined
                                if (typeof arg === 'undefined') return undefined;
                                result = Math.pow(arg, exp);
                                if (!isFinite(result)) throw {
                                    stack: new Error().stack,
                                    code: "D3061",
                                    index: 1,
                                    value: arg,
                                    exp: exp
                                };
                                return result;
                            }
                            /**
     * Returns a random number 0 <= n < 1
     * @returns {number} random number
     */ function random() {
                                return Math.random();
                            }
                            /**
     * Evaluate an input and return a boolean
     * @param {*} arg - Arguments
     * @returns {boolean} Boolean
     */ function boolean(arg) {
                                // cast arg to its effective boolean value
                                // boolean: unchanged
                                // string: zero-length -> false; otherwise -> true
                                // number: 0 -> false; otherwise -> true
                                // null -> false
                                // array: empty -> false; length > 1 -> true
                                // object: empty -> false; non-empty -> true
                                // function -> false
                                // undefined inputs always return undefined
                                if (typeof arg === 'undefined') return undefined;
                                var result = false;
                                if (Array.isArray(arg)) {
                                    if (arg.length === 1) result = boolean(arg[0]);
                                    else if (arg.length > 1) {
                                        var trues = arg.filter(function(val) {
                                            return boolean(val);
                                        });
                                        result = trues.length > 0;
                                    }
                                } else if (typeof arg === 'string') {
                                    if (arg.length > 0) result = true;
                                } else if (isNumeric(arg)) {
                                    if (arg !== 0) result = true;
                                } else if (arg !== null && typeof arg === 'object') {
                                    if (utils.keys(arg).length > 0) result = true;
                                } else if (typeof arg === 'boolean' && arg === true) result = true;
                                return result;
                            }
                            /**
     * returns the Boolean NOT of the arg
     * @param {*} arg - argument
     * @returns {boolean} - NOT arg
     */ function not(arg) {
                                // undefined inputs always return undefined
                                if (typeof arg === 'undefined') return undefined;
                                return !boolean(arg);
                            }
                            /**
     * Helper function to build the arguments to be supplied to the function arg of the
     * HOFs map, filter, each, sift and single
     * @param {function} func - the function to be invoked
     * @param {*} arg1 - the first (required) arg - the value
     * @param {*} arg2 - the second (optional) arg - the position (index or key)
     * @param {*} arg3 - the third (optional) arg - the whole structure (array or object)
     * @returns {*[]} the argument list
     */ function hofFuncArgs(func, arg1, arg2, arg3) {
                                var func_args = [
                                    arg1
                                ]; // the first arg (the value) is required
                                // the other two are optional - only supply it if the function can take it
                                var length = getFunctionArity(func);
                                if (length >= 2) func_args.push(arg2);
                                if (length >= 3) func_args.push(arg3);
                                return func_args;
                            }
                            /**
     * Create a map from an array of arguments
     * @param {Array} [arr] - array to map over
     * @param {Function} func - function to apply
     * @returns {Array} Map array
     */ function* map(arr, func) {
                                // undefined inputs always return undefined
                                if (typeof arr === 'undefined') return undefined;
                                var result = createSequence();
                                // do the map - iterate over the arrays, and invoke func
                                for(var i = 0; i < arr.length; i++){
                                    var func_args = hofFuncArgs(func, arr[i], i, arr);
                                    // invoke func
                                    var res = yield* func.apply(this, func_args);
                                    if (typeof res !== 'undefined') result.push(res);
                                }
                                return result;
                            }
                            /**
     * Create a map from an array of arguments
     * @param {Array} [arr] - array to filter
     * @param {Function} func - predicate function
     * @returns {Array} Map array
     */ function* filter(arr, func) {
                                // undefined inputs always return undefined
                                if (typeof arr === 'undefined') return undefined;
                                var result = createSequence();
                                for(var i = 0; i < arr.length; i++){
                                    var entry = arr[i];
                                    var func_args = hofFuncArgs(func, entry, i, arr);
                                    // invoke func
                                    var res = yield* func.apply(this, func_args);
                                    if (boolean(res)) result.push(entry);
                                }
                                return result;
                            }
                            /**
     * Given an array, find the single element matching a specified condition
     * Throws an exception if the number of matching elements is not exactly one
     * @param {Array} [arr] - array to filter
     * @param {Function} [func] - predicate function
     * @returns {*} Matching element
     */ function* single(arr, func) {
                                // undefined inputs always return undefined
                                if (typeof arr === 'undefined') return undefined;
                                var hasFoundMatch = false;
                                var result;
                                for(var i = 0; i < arr.length; i++){
                                    var entry = arr[i];
                                    var positiveResult = true;
                                    if (typeof func !== 'undefined') {
                                        var func_args = hofFuncArgs(func, entry, i, arr);
                                        // invoke func
                                        var res = yield* func.apply(this, func_args);
                                        positiveResult = boolean(res);
                                    }
                                    if (positiveResult) {
                                        if (!hasFoundMatch) {
                                            result = entry;
                                            hasFoundMatch = true;
                                        } else throw {
                                            stack: new Error().stack,
                                            code: "D3138",
                                            index: i
                                        };
                                    }
                                }
                                if (!hasFoundMatch) throw {
                                    stack: new Error().stack,
                                    code: "D3139"
                                };
                                return result;
                            }
                            /**
     * Convolves (zips) each value from a set of arrays
     * @param {Array} [args] - arrays to zip
     * @returns {Array} Zipped array
     */ function zip() {
                                // this can take a variable number of arguments
                                var result = [];
                                var args = Array.prototype.slice.call(arguments);
                                // length of the shortest array
                                var length = Math.min.apply(Math, args.map(function(arg) {
                                    if (Array.isArray(arg)) return arg.length;
                                    return 0;
                                }));
                                for(var i = 0; i < length; i++){
                                    var tuple = args.map((arg)=>{
                                        return arg[i];
                                    });
                                    result.push(tuple);
                                }
                                return result;
                            }
                            /**
     * Fold left function
     * @param {Array} sequence - Sequence
     * @param {Function} func - Function
     * @param {Object} init - Initial value
     * @returns {*} Result
     */ function* foldLeft(sequence, func, init) {
                                // undefined inputs always return undefined
                                if (typeof sequence === 'undefined') return undefined;
                                var result;
                                var arity = getFunctionArity(func);
                                if (arity < 2) throw {
                                    stack: new Error().stack,
                                    code: "D3050",
                                    index: 1
                                };
                                var index;
                                if (typeof init === 'undefined' && sequence.length > 0) {
                                    result = sequence[0];
                                    index = 1;
                                } else {
                                    result = init;
                                    index = 0;
                                }
                                while(index < sequence.length){
                                    var args = [
                                        result,
                                        sequence[index]
                                    ];
                                    if (arity >= 3) args.push(index);
                                    if (arity >= 4) args.push(sequence);
                                    result = yield* func.apply(this, args);
                                    index++;
                                }
                                return result;
                            }
                            /**
     * Return keys for an object
     * @param {Object} arg - Object
     * @returns {Array} Array of keys
     */ function keys(arg) {
                                var result = createSequence();
                                if (Array.isArray(arg)) {
                                    // merge the keys of all of the items in the array
                                    var merge = Object.create(null);
                                    arg.forEach(function(item) {
                                        var allkeys = keys(item);
                                        allkeys.forEach(function(key) {
                                            merge[key] = true;
                                        });
                                    });
                                    result = keys(merge);
                                } else if (arg !== null && typeof arg === 'object' && !isLambda(arg)) utils.keys(arg).forEach((key)=>result.push(key));
                                return result;
                            }
                            /**
     * Return value from an object for a given key
     * @param {Object} input - Object/Array
     * @param {String} key - Key in object
     * @returns {*} Value of key in object
     */ function lookup(input, key) {
                                // lookup the 'name' item in the input
                                var result;
                                if (Array.isArray(input)) {
                                    result = createSequence();
                                    for(var ii = 0; ii < input.length; ii++){
                                        var res = lookup(input[ii], key);
                                        if (typeof res !== 'undefined') {
                                            if (Array.isArray(res)) res.forEach((val)=>result.push(val));
                                            else result.push(res);
                                        }
                                    }
                                } else if (input !== null && typeof input === 'object' && Object.prototype.hasOwnProperty.call(input, key) && !isFunction(input)) result = input[key];
                                return result;
                            }
                            /**
     * Append second argument to first
     * @param {Array|Object} arg1 - First argument
     * @param {Array|Object} arg2 - Second argument
     * @returns {*} Appended arguments
     */ function append(arg1, arg2) {
                                // disregard undefined args
                                if (typeof arg1 === 'undefined') return arg2;
                                if (typeof arg2 === 'undefined') return arg1;
                                // if either argument is not an array, make it so
                                if (!Array.isArray(arg1)) arg1 = createSequence(arg1);
                                if (!Array.isArray(arg2)) arg2 = [
                                    arg2
                                ];
                                return arg1.concat(arg2);
                            }
                            /**
     * Determines if the argument is undefined
     * @param {*} arg - argument
     * @returns {boolean} False if argument undefined, otherwise true
     */ function exists(arg) {
                                if (typeof arg === 'undefined') return false;
                                else return true;
                            }
                            /**
     * Splits an object into an array of object with one property each
     * @param {*} arg - the object to split
     * @returns {*} - the array
     */ function spread(arg) {
                                var result = createSequence();
                                if (Array.isArray(arg)) // spread all of the items in the array
                                arg.forEach(function(item) {
                                    result = append(result, spread(item));
                                });
                                else if (arg !== null && typeof arg === 'object' && !isLambda(arg)) for (const key of utils.keys(arg)){
                                    var obj = Object.create(null);
                                    obj[key] = arg[key];
                                    result.push(obj);
                                }
                                else result = arg;
                                return result;
                            }
                            /**
     * Merges an array of objects into a single object.  Duplicate properties are
     * overridden by entries later in the array
     * @param {*} arg - the objects to merge
     * @returns {*} - the object
     */ function merge(arg) {
                                // undefined inputs always return undefined
                                if (typeof arg === 'undefined') return undefined;
                                var result = Object.create(null);
                                arg.forEach(function(obj) {
                                    for (const prop of utils.keys(obj))result[prop] = obj[prop];
                                });
                                return result;
                            }
                            /**
     * Reverses the order of items in an array
     * @param {Array} arr - the array to reverse
     * @returns {Array} - the reversed array
     */ function reverse(arr) {
                                // undefined inputs always return undefined
                                if (typeof arr === 'undefined') return undefined;
                                if (arr.length <= 1) return arr;
                                var length = arr.length;
                                var result = new Array(length);
                                for(var i = 0; i < length; i++)result[length - i - 1] = arr[i];
                                return result;
                            }
                            /**
     *
     * @param {*} obj - the input object to iterate over
     * @param {*} func - the function to apply to each key/value pair
     * @returns {Array} - the resultant array
     */ function* each(obj, func) {
                                var result = createSequence();
                                for (const key of utils.keys(obj)){
                                    var func_args = hofFuncArgs(func, obj[key], key, obj);
                                    // invoke func
                                    var val = yield* func.apply(this, func_args);
                                    if (typeof val !== 'undefined') result.push(val);
                                }
                                return result;
                            }
                            /**
     *
     * @param {string} [message] - the message to attach to the error
     * @throws custom error with code 'D3137'
     */ function error(message) {
                                throw {
                                    code: "D3137",
                                    stack: new Error().stack,
                                    message: message || "$error() function evaluated"
                                };
                            }
                            /**
     *
     * @param {boolean} condition - the condition to evaluate
     * @param {string} [message] - the message to attach to the error
     * @throws custom error with code 'D3137'
     * @returns {undefined}
     */ function assert(condition, message) {
                                if (!condition) throw {
                                    code: "D3141",
                                    stack: new Error().stack,
                                    message: message || "$assert() statement failed"
                                };
                                return undefined;
                            }
                            /**
     *
     * @param {*} [value] - the input to which the type will be checked
     * @returns {string} - the type of the input
     */ function type(value) {
                                if (value === undefined) return undefined;
                                if (value === null) return 'null';
                                if (isNumeric(value)) return 'number';
                                if (typeof value === 'string') return 'string';
                                if (typeof value === 'boolean') return 'boolean';
                                if (Array.isArray(value)) return 'array';
                                if (isFunction(value)) return 'function';
                                return 'object';
                            }
                            /**
     * Implements the merge sort (stable) with optional comparator function
     *
     * @param {Array} arr - the array to sort
     * @param {*} comparator - comparator function
     * @returns {Array} - sorted array
     */ function* sort(arr, comparator) {
                                // undefined inputs always return undefined
                                if (typeof arr === 'undefined') return undefined;
                                if (arr.length <= 1) return arr;
                                var comp;
                                if (typeof comparator === 'undefined') {
                                    // inject a default comparator - only works for numeric or string arrays
                                    if (!isArrayOfNumbers(arr) && !isArrayOfStrings(arr)) throw {
                                        stack: new Error().stack,
                                        code: "D3070",
                                        index: 1
                                    };
                                    comp = function*(a, b) {
                                        return a > b;
                                    };
                                } else // for internal usage of functionSort (i.e. order-by syntax)
                                comp = comparator;
                                var merge = function*(l, r) {
                                    var merge_iter = function*(result, left, right) {
                                        if (left.length === 0) Array.prototype.push.apply(result, right);
                                        else if (right.length === 0) Array.prototype.push.apply(result, left);
                                        else if (yield* comp(left[0], right[0])) {
                                            // if it returns true - swap left and right
                                            result.push(right[0]);
                                            yield* merge_iter(result, left, right.slice(1));
                                        } else {
                                            // otherwise keep the same order
                                            result.push(left[0]);
                                            yield* merge_iter(result, left.slice(1), right);
                                        }
                                    };
                                    var merged = [];
                                    yield* merge_iter(merged, l, r);
                                    return merged;
                                };
                                var msort = function*(array) {
                                    if (!Array.isArray(array) || array.length <= 1) return array;
                                    else {
                                        var middle = Math.floor(array.length / 2);
                                        var left = array.slice(0, middle);
                                        var right = array.slice(middle);
                                        left = yield* msort(left);
                                        right = yield* msort(right);
                                        return yield* merge(left, right);
                                    }
                                };
                                var result = yield* msort(arr);
                                return result;
                            }
                            /**
     * Randomly shuffles the contents of an array
     * @param {Array} arr - the input array
     * @returns {Array} the shuffled array
     */ function shuffle(arr) {
                                // undefined inputs always return undefined
                                if (typeof arr === 'undefined') return undefined;
                                if (arr.length <= 1) return arr;
                                // shuffle using the 'inside-out' variant of the Fisher-Yates algorithm
                                var result = new Array(arr.length);
                                for(var i = 0; i < arr.length; i++){
                                    var j = Math.floor(Math.random() * (i + 1)); // random integer such that 0 ≤ j ≤ i
                                    if (i !== j) result[i] = result[j];
                                    result[j] = arr[i];
                                }
                                return result;
                            }
                            /**
     * Returns the values that appear in a sequence, with duplicates eliminated.
     * @param {Array} arr - An array or sequence of values
     * @returns {Array} - sequence of distinct values
     */ function distinct(arr) {
                                // undefined inputs always return undefined
                                if (typeof arr === 'undefined') return undefined;
                                if (!Array.isArray(arr) || arr.length <= 1) return arr;
                                var results = isSequence(arr) ? createSequence() : [];
                                for(var ii = 0; ii < arr.length; ii++){
                                    var value = arr[ii];
                                    // is this value already in the result sequence?
                                    var includes = false;
                                    for(var jj = 0; jj < results.length; jj++)if (deepEquals(value, results[jj])) {
                                        includes = true;
                                        break;
                                    }
                                    if (!includes) results.push(value);
                                }
                                return results;
                            }
                            /**
     * Applies a predicate function to each key/value pair in an object, and returns an object containing
     * only the key/value pairs that passed the predicate
     *
     * @param {object} arg - the object to be sifted
     * @param {object} func - the predicate function (lambda or native)
     * @returns {object} - sifted object
     */ function* sift(arg, func) {
                                var result = Object.create(null);
                                for (const item of utils.keys(arg)){
                                    var entry = arg[item];
                                    var func_args = hofFuncArgs(func, entry, item, arg);
                                    // invoke func
                                    var res = yield* func.apply(this, func_args);
                                    if (boolean(res)) result[item] = entry;
                                }
                                // empty objects should be changed to undefined
                                if (utils.keys(result).length === 0) result = undefined;
                                return result;
                            }
                            return {
                                sum: sum,
                                count: count,
                                max: max,
                                min: min,
                                average: average,
                                string: string,
                                substring: substring,
                                substringBefore: substringBefore,
                                substringAfter: substringAfter,
                                lowercase: lowercase,
                                uppercase: uppercase,
                                length: length,
                                trim: trim,
                                pad: pad,
                                match: match,
                                contains: contains,
                                replace: replace,
                                split: split,
                                join: join,
                                formatNumber: formatNumber,
                                formatBase: formatBase,
                                number: number,
                                floor: floor,
                                ceil: ceil,
                                round: round,
                                abs: abs,
                                sqrt: sqrt,
                                power: power,
                                random: random,
                                boolean: boolean,
                                not: not,
                                map: map,
                                zip: zip,
                                filter: filter,
                                single: single,
                                foldLeft: foldLeft,
                                sift: sift,
                                keys: keys,
                                lookup: lookup,
                                append: append,
                                exists: exists,
                                spread: spread,
                                merge: merge,
                                reverse: reverse,
                                each: each,
                                error: error,
                                assert: assert,
                                type: type,
                                sort: sort,
                                shuffle: shuffle,
                                distinct: distinct,
                                base64encode: base64encode,
                                base64decode: base64decode,
                                encodeUrlComponent: encodeUrlComponent,
                                encodeUrl: encodeUrl,
                                decodeUrlComponent: decodeUrlComponent,
                                decodeUrl: decodeUrl
                            };
                        })();
                        module1.exports = functions;
                    }).call(this);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "./utils": 6
            }
        ],
        3: [
            function(require1, module1, exports) {
                /**
 * © Copyright IBM Corp. 2016, 2017 All Rights Reserved
 *   Project name: JSONata
 *   This project is licensed under the MIT License, see LICENSE
 */ /**
 * @module JSONata
 * @description JSON query and transformation language
 */ var datetime = require1('./datetime');
                var fn = require1('./functions');
                var utils = require1('./utils');
                var parser = require1('./parser');
                var parseSignature = require1('./signature');
                /**
 * jsonata
 * @function
 * @param {Object} expr - JSONata expression
 * @returns {{evaluate: evaluate, assign: assign}} Evaluated expression
 */ var jsonata = function() {
                    'use strict';
                    var isNumeric = utils.isNumeric;
                    var isArrayOfStrings = utils.isArrayOfStrings;
                    var isArrayOfNumbers = utils.isArrayOfNumbers;
                    var createSequence = utils.createSequence;
                    var isSequence = utils.isSequence;
                    var isFunction = utils.isFunction;
                    var isLambda = utils.isLambda;
                    var isIterable = utils.isIterable;
                    var getFunctionArity = utils.getFunctionArity;
                    var isDeepEqual = utils.isDeepEqual;
                    // Start of Evaluator code
                    var staticFrame = createFrame(null);
                    /**
     * Evaluate expression against input data
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @param {Object} environment - Environment
     * @returns {*} Evaluated input data
     */ function* evaluate(expr, input, environment) {
                        var result;
                        var entryCallback = environment.lookup('__evaluate_entry');
                        if (entryCallback) entryCallback(expr, input, environment);
                        switch(expr.type){
                            case 'path':
                                result = yield* evaluatePath(expr, input, environment);
                                break;
                            case 'binary':
                                result = yield* evaluateBinary(expr, input, environment);
                                break;
                            case 'unary':
                                result = yield* evaluateUnary(expr, input, environment);
                                break;
                            case 'name':
                                result = evaluateName(expr, input, environment);
                                break;
                            case 'string':
                            case 'number':
                            case 'value':
                                result = evaluateLiteral(expr, input, environment);
                                break;
                            case 'wildcard':
                                result = evaluateWildcard(expr, input, environment);
                                break;
                            case 'descendant':
                                result = evaluateDescendants(expr, input, environment);
                                break;
                            case 'parent':
                                result = environment.lookup(expr.slot.label);
                                break;
                            case 'condition':
                                result = yield* evaluateCondition(expr, input, environment);
                                break;
                            case 'block':
                                result = yield* evaluateBlock(expr, input, environment);
                                break;
                            case 'bind':
                                result = yield* evaluateBindExpression(expr, input, environment);
                                break;
                            case 'regex':
                                result = evaluateRegex(expr, input, environment);
                                break;
                            case 'function':
                                result = yield* evaluateFunction(expr, input, environment);
                                break;
                            case 'variable':
                                result = evaluateVariable(expr, input, environment);
                                break;
                            case 'lambda':
                                result = evaluateLambda(expr, input, environment);
                                break;
                            case 'partial':
                                result = yield* evaluatePartialApplication(expr, input, environment);
                                break;
                            case 'apply':
                                result = yield* evaluateApplyExpression(expr, input, environment);
                                break;
                            case 'transform':
                                result = evaluateTransformExpression(expr, input, environment);
                                break;
                        }
                        if (environment.async && (typeof result === 'undefined' || result === null || typeof result.then !== 'function')) result = Promise.resolve(result);
                        if (environment.async && typeof result.then === 'function' && expr.nextFunction && typeof result[expr.nextFunction] === 'function') ;
                        else result = yield result;
                        if (Object.prototype.hasOwnProperty.call(expr, 'predicate')) for(var ii = 0; ii < expr.predicate.length; ii++)result = yield* evaluateFilter(expr.predicate[ii].expr, result, environment);
                        if (expr.type !== 'path' && Object.prototype.hasOwnProperty.call(expr, 'group')) result = yield* evaluateGroupExpression(expr.group, result, environment);
                        var exitCallback = environment.lookup('__evaluate_exit');
                        if (exitCallback) exitCallback(expr, input, environment, result);
                        if (result && isSequence(result) && !result.tupleStream) {
                            if (expr.keepArray) result.keepSingleton = true;
                            if (result.length === 0) result = undefined;
                            else if (result.length === 1) result = result.keepSingleton ? result : result[0];
                        }
                        return result;
                    }
                    /**
     * Evaluate path expression against input data
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @param {Object} environment - Environment
     * @returns {*} Evaluated input data
     */ function* evaluatePath(expr, input, environment) {
                        var inputSequence;
                        // expr is an array of steps
                        // if the first step is a variable reference ($...), including root reference ($$),
                        //   then the path is absolute rather than relative
                        if (Array.isArray(input) && expr.steps[0].type !== 'variable') inputSequence = input;
                        else // if input is not an array, make it so
                        inputSequence = createSequence(input);
                        var resultSequence;
                        var isTupleStream = false;
                        var tupleBindings = undefined;
                        // evaluate each step in turn
                        for(var ii = 0; ii < expr.steps.length; ii++){
                            var step = expr.steps[ii];
                            if (step.tuple) isTupleStream = true;
                            // if the first step is an explicit array constructor, then just evaluate that (i.e. don't iterate over a context array)
                            if (ii === 0 && step.consarray) resultSequence = yield* evaluate(step, inputSequence, environment);
                            else if (isTupleStream) tupleBindings = yield* evaluateTupleStep(step, inputSequence, tupleBindings, environment);
                            else resultSequence = yield* evaluateStep(step, inputSequence, environment, ii === expr.steps.length - 1);
                            if (!isTupleStream && (typeof resultSequence === 'undefined' || resultSequence.length === 0)) break;
                            if (typeof step.focus === 'undefined') inputSequence = resultSequence;
                        }
                        if (isTupleStream) {
                            if (expr.tuple) // tuple stream is carrying ancestry information - keep this
                            resultSequence = tupleBindings;
                            else {
                                resultSequence = createSequence();
                                for(ii = 0; ii < tupleBindings.length; ii++)resultSequence.push(tupleBindings[ii]['@']);
                            }
                        }
                        if (expr.keepSingletonArray) {
                            // if the array is explicitly constructed in the expression and marked to promote singleton sequences to array
                            if (Array.isArray(resultSequence) && resultSequence.cons && !resultSequence.sequence) resultSequence = createSequence(resultSequence);
                            resultSequence.keepSingleton = true;
                        }
                        if (Object.prototype.hasOwnProperty.call(expr, 'group')) resultSequence = yield* evaluateGroupExpression(expr.group, isTupleStream ? tupleBindings : resultSequence, environment);
                        return resultSequence;
                    }
                    function createFrameFromTuple(environment, tuple) {
                        var frame = createFrame(environment);
                        for (const prop of utils.keys(tuple))frame.bind(prop, tuple[prop]);
                        return frame;
                    }
                    /**
     * Evaluate a step within a path
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @param {Object} environment - Environment
     * @param {boolean} lastStep - flag the last step in a path
     * @returns {*} Evaluated input data
     */ function* evaluateStep(expr, input, environment, lastStep) {
                        var result;
                        if (expr.type === 'sort') {
                            result = yield* evaluateSortExpression(expr, input, environment);
                            if (expr.stages) result = yield* evaluateStages(expr.stages, result, environment);
                            return result;
                        }
                        result = createSequence();
                        for(var ii = 0; ii < input.length; ii++){
                            var res = yield* evaluate(expr, input[ii], environment);
                            if (expr.stages) for(var ss = 0; ss < expr.stages.length; ss++)res = yield* evaluateFilter(expr.stages[ss].expr, res, environment);
                            if (typeof res !== 'undefined') result.push(res);
                        }
                        var resultSequence = createSequence();
                        if (lastStep && result.length === 1 && Array.isArray(result[0]) && !isSequence(result[0])) resultSequence = result[0];
                        else // flatten the sequence
                        Array.prototype.forEach.call(result, function(res) {
                            if (!Array.isArray(res) || res.cons) // it's not an array - just push into the result sequence
                            resultSequence.push(res);
                            else // res is a sequence - flatten it into the parent sequence
                            Array.prototype.forEach.call(res, (val)=>resultSequence.push(val));
                        });
                        return resultSequence;
                    }
                    function* evaluateStages(stages, input, environment) {
                        var result = input;
                        for(var ss = 0; ss < stages.length; ss++){
                            var stage = stages[ss];
                            switch(stage.type){
                                case 'filter':
                                    result = yield* evaluateFilter(stage.expr, result, environment);
                                    break;
                                case 'index':
                                    for(var ee = 0; ee < result.length; ee++){
                                        var tuple = result[ee];
                                        tuple[stage.value] = ee;
                                    }
                                    break;
                            }
                        }
                        return result;
                    }
                    /**
     * Evaluate a step within a path
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @param {Object} tupleBindings - The tuple stream
     * @param {Object} environment - Environment
     * @returns {*} Evaluated input data
     */ function* evaluateTupleStep(expr, input, tupleBindings, environment) {
                        var result;
                        if (expr.type === 'sort') {
                            if (tupleBindings) result = yield* evaluateSortExpression(expr, tupleBindings, environment);
                            else {
                                var sorted = yield* evaluateSortExpression(expr, input, environment);
                                result = createSequence();
                                result.tupleStream = true;
                                for(var ss = 0; ss < sorted.length; ss++){
                                    var tuple = {
                                        '@': sorted[ss]
                                    };
                                    tuple[expr.index] = ss;
                                    result.push(tuple);
                                }
                            }
                            if (expr.stages) result = yield* evaluateStages(expr.stages, result, environment);
                            return result;
                        }
                        result = createSequence();
                        result.tupleStream = true;
                        var stepEnv = environment;
                        if (tupleBindings === undefined) tupleBindings = input.map((item)=>{
                            return {
                                '@': item
                            };
                        });
                        for(var ee = 0; ee < tupleBindings.length; ee++){
                            stepEnv = createFrameFromTuple(environment, tupleBindings[ee]);
                            var res = yield* evaluate(expr, tupleBindings[ee]['@'], stepEnv);
                            // res is the binding sequence for the output tuple stream
                            if (typeof res !== 'undefined') {
                                if (!Array.isArray(res)) res = [
                                    res
                                ];
                                for(var bb = 0; bb < res.length; bb++){
                                    tuple = Object.create(null);
                                    Object.assign(tuple, tupleBindings[ee]);
                                    if (res.tupleStream) Object.assign(tuple, res[bb]);
                                    else {
                                        if (expr.focus) {
                                            tuple[expr.focus] = res[bb];
                                            tuple['@'] = tupleBindings[ee]['@'];
                                        } else tuple['@'] = res[bb];
                                        if (expr.index) tuple[expr.index] = bb;
                                        if (expr.ancestor) tuple[expr.ancestor.label] = tupleBindings[ee]['@'];
                                    }
                                    result.push(tuple);
                                }
                            }
                        }
                        if (expr.stages) result = yield* evaluateStages(expr.stages, result, environment);
                        return result;
                    }
                    /**
     * Apply filter predicate to input data
     * @param {Object} predicate - filter expression
     * @param {Object} input - Input data to apply predicates against
     * @param {Object} environment - Environment
     * @returns {*} Result after applying predicates
     */ function* evaluateFilter(predicate, input, environment) {
                        var results = createSequence();
                        if (input && input.tupleStream) results.tupleStream = true;
                        if (!Array.isArray(input)) input = createSequence(input);
                        if (predicate.type === 'number') {
                            var index = Math.floor(predicate.value); // round it down
                            if (index < 0) // count in from end of array
                            index = input.length + index;
                            var item = input[index];
                            if (typeof item !== 'undefined') {
                                if (Array.isArray(item)) results = item;
                                else results.push(item);
                            }
                        } else for(index = 0; index < input.length; index++){
                            var item = input[index];
                            var context = item;
                            var env = environment;
                            if (input.tupleStream) {
                                context = item['@'];
                                env = createFrameFromTuple(environment, item);
                            }
                            var res = yield* evaluate(predicate, context, env);
                            if (isNumeric(res)) res = [
                                res
                            ];
                            if (isArrayOfNumbers(res)) Array.prototype.forEach.call(res, function(ires) {
                                // round it down
                                var ii = Math.floor(ires);
                                if (ii < 0) // count in from end of array
                                ii = input.length + ii;
                                if (ii === index) results.push(item);
                            });
                            else if (fn.boolean(res)) results.push(item);
                        }
                        return results;
                    }
                    /**
     * Evaluate binary expression against input data
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @param {Object} environment - Environment
     * @returns {*} Evaluated input data
     */ function* evaluateBinary(expr, input, environment) {
                        var result;
                        var lhs = yield* evaluate(expr.lhs, input, environment);
                        var op = expr.value;
                        //defer evaluation of RHS to allow short-circuiting
                        var evalrhs = function*() {
                            return yield* evaluate(expr.rhs, input, environment);
                        };
                        if (op === "and" || op === "or") try {
                            return yield* evaluateBooleanExpression(lhs, evalrhs, op);
                        } catch (err) {
                            err.position = expr.position;
                            err.token = op;
                            throw err;
                        }
                        var rhs = yield* evalrhs();
                        try {
                            switch(op){
                                case '+':
                                case '-':
                                case '*':
                                case '/':
                                case '%':
                                    result = evaluateNumericExpression(lhs, rhs, op);
                                    break;
                                case '=':
                                case '!=':
                                    result = evaluateEqualityExpression(lhs, rhs, op);
                                    break;
                                case '<':
                                case '<=':
                                case '>':
                                case '>=':
                                    result = evaluateComparisonExpression(lhs, rhs, op);
                                    break;
                                case '&':
                                    result = evaluateStringConcat(lhs, rhs);
                                    break;
                                case '..':
                                    result = evaluateRangeExpression(lhs, rhs);
                                    break;
                                case 'in':
                                    result = evaluateIncludesExpression(lhs, rhs);
                                    break;
                            }
                        } catch (err) {
                            err.position = expr.position;
                            err.token = op;
                            throw err;
                        }
                        return result;
                    }
                    /**
     * Evaluate unary expression against input data
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @param {Object} environment - Environment
     * @returns {*} Evaluated input data
     */ function* evaluateUnary(expr, input, environment) {
                        var result;
                        switch(expr.value){
                            case '-':
                                result = yield* evaluate(expr.expression, input, environment);
                                if (typeof result === 'undefined') result = undefined;
                                else if (isNumeric(result)) result = -result;
                                else throw {
                                    code: "D1002",
                                    stack: new Error().stack,
                                    position: expr.position,
                                    token: expr.value,
                                    value: result
                                };
                                break;
                            case '[':
                                // array constructor - evaluate each item
                                result = [];
                                for(var ii = 0; ii < expr.expressions.length; ii++){
                                    var item = expr.expressions[ii];
                                    var value = yield* evaluate(item, input, environment);
                                    if (typeof value !== 'undefined') {
                                        if (item.value === '[') result.push(value);
                                        else result = fn.append(result, value);
                                    }
                                }
                                if (expr.consarray) Object.defineProperty(result, 'cons', {
                                    enumerable: false,
                                    configurable: false,
                                    value: true
                                });
                                break;
                            case '{':
                                // object constructor - apply grouping
                                result = yield* evaluateGroupExpression(expr, input, environment);
                                break;
                        }
                        return result;
                    }
                    /**
     * Evaluate name object against input data
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @param {Object} environment - Environment
     * @returns {*} Evaluated input data
     */ function evaluateName(expr, input, environment) {
                        // lookup the 'name' item in the input
                        return fn.lookup(input, expr.value);
                    }
                    /**
     * Evaluate literal against input data
     * @param {Object} expr - JSONata expression
     * @returns {*} Evaluated input data
     */ function evaluateLiteral(expr) {
                        return expr.value;
                    }
                    /**
     * Evaluate wildcard against input data
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @returns {*} Evaluated input data
     */ function evaluateWildcard(expr, input) {
                        var results = createSequence();
                        if (Array.isArray(input) && input.outerWrapper && input.length > 0) input = input[0];
                        if (input !== null && typeof input === 'object' && !isFunction(input)) utils.keys(input).forEach(function(key) {
                            var value = input[key];
                            if (Array.isArray(value)) {
                                value = flatten(value);
                                results = fn.append(results, value);
                            } else results.push(value);
                        });
                        //        result = normalizeSequence(results);
                        return results;
                    }
                    /**
     * Returns a flattened array
     * @param {Array} arg - the array to be flatten
     * @param {Array} flattened - carries the flattened array - if not defined, will initialize to []
     * @returns {Array} - the flattened array
     */ function flatten(arg, flattened) {
                        if (typeof flattened === 'undefined') flattened = [];
                        if (Array.isArray(arg)) Array.prototype.forEach.call(arg, function(item) {
                            flatten(item, flattened);
                        });
                        else flattened.push(arg);
                        return flattened;
                    }
                    /**
     * Evaluate descendants against input data
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @returns {*} Evaluated input data
     */ function evaluateDescendants(expr, input) {
                        var result;
                        var resultSequence = createSequence();
                        if (typeof input !== 'undefined') {
                            // traverse all descendants of this object/array
                            recurseDescendants(input, resultSequence);
                            if (resultSequence.length === 1) result = resultSequence[0];
                            else result = resultSequence;
                        }
                        return result;
                    }
                    /**
     * Recurse through descendants
     * @param {Object} input - Input data
     * @param {Object} results - Results
     */ function recurseDescendants(input, results) {
                        // this is the equivalent of //* in XPath
                        if (!Array.isArray(input)) results.push(input);
                        if (Array.isArray(input)) Array.prototype.forEach.call(input, function(member) {
                            recurseDescendants(member, results);
                        });
                        else if (input !== null && typeof input === 'object' && !isFunction(input)) utils.keys(input).forEach(function(key) {
                            recurseDescendants(input[key], results);
                        });
                    }
                    /**
     * Evaluate numeric expression against input data
     * @param {Object} lhs - LHS value
     * @param {Object} rhs - RHS value
     * @param {Object} op - opcode
     * @returns {*} Result
     */ function evaluateNumericExpression(lhs, rhs, op) {
                        var result;
                        if (typeof lhs !== 'undefined' && !isNumeric(lhs)) throw {
                            code: "T2001",
                            stack: new Error().stack,
                            value: lhs
                        };
                        if (typeof rhs !== 'undefined' && !isNumeric(rhs)) throw {
                            code: "T2002",
                            stack: new Error().stack,
                            value: rhs
                        };
                        if (typeof lhs === 'undefined' || typeof rhs === 'undefined') // if either side is undefined, the result is undefined
                        return result;
                        switch(op){
                            case '+':
                                result = lhs + rhs;
                                break;
                            case '-':
                                result = lhs - rhs;
                                break;
                            case '*':
                                result = lhs * rhs;
                                break;
                            case '/':
                                result = lhs / rhs;
                                break;
                            case '%':
                                result = lhs % rhs;
                                break;
                        }
                        return result;
                    }
                    /**
     * Evaluate equality expression against input data
     * @param {Object} lhs - LHS value
     * @param {Object} rhs - RHS value
     * @param {Object} op - opcode
     * @returns {*} Result
     */ function evaluateEqualityExpression(lhs, rhs, op) {
                        var result;
                        // type checks
                        var ltype = typeof lhs;
                        var rtype = typeof rhs;
                        if (ltype === 'undefined' || rtype === 'undefined') // if either side is undefined, the result is false
                        return false;
                        switch(op){
                            case '=':
                                result = isDeepEqual(lhs, rhs);
                                break;
                            case '!=':
                                result = !isDeepEqual(lhs, rhs);
                                break;
                        }
                        return result;
                    }
                    /**
     * Evaluate comparison expression against input data
     * @param {Object} lhs - LHS value
     * @param {Object} rhs - RHS value
     * @param {Object} op - opcode
     * @returns {*} Result
     */ function evaluateComparisonExpression(lhs, rhs, op) {
                        var result;
                        // type checks
                        var ltype = typeof lhs;
                        var rtype = typeof rhs;
                        var lcomparable = ltype === 'undefined' || ltype === 'string' || ltype === 'number';
                        var rcomparable = rtype === 'undefined' || rtype === 'string' || rtype === 'number';
                        // if either aa or bb are not comparable (string or numeric) values, then throw an error
                        if (!lcomparable || !rcomparable) throw {
                            code: "T2010",
                            stack: new Error().stack,
                            value: !(ltype === 'string' || ltype === 'number') ? lhs : rhs
                        };
                        // if either side is undefined, the result is undefined
                        if (ltype === 'undefined' || rtype === 'undefined') return undefined;
                        //if aa and bb are not of the same type
                        if (ltype !== rtype) throw {
                            code: "T2009",
                            stack: new Error().stack,
                            value: lhs,
                            value2: rhs
                        };
                        switch(op){
                            case '<':
                                result = lhs < rhs;
                                break;
                            case '<=':
                                result = lhs <= rhs;
                                break;
                            case '>':
                                result = lhs > rhs;
                                break;
                            case '>=':
                                result = lhs >= rhs;
                                break;
                        }
                        return result;
                    }
                    /**
     * Inclusion operator - in
     *
     * @param {Object} lhs - LHS value
     * @param {Object} rhs - RHS value
     * @returns {boolean} - true if lhs is a member of rhs
     */ function evaluateIncludesExpression(lhs, rhs) {
                        var result = false;
                        if (typeof lhs === 'undefined' || typeof rhs === 'undefined') // if either side is undefined, the result is false
                        return false;
                        if (!Array.isArray(rhs)) rhs = [
                            rhs
                        ];
                        for(var i = 0; i < rhs.length; i++)if (rhs[i] === lhs) {
                            result = true;
                            break;
                        }
                        return result;
                    }
                    /**
     * Evaluate boolean expression against input data
     * @param {Object} lhs - LHS value
     * @param {Function} evalrhs - function to evaluate RHS value
     * @param {Object} op - opcode
     * @returns {*} Result
     */ function* evaluateBooleanExpression(lhs, evalrhs, op) {
                        var result;
                        var lBool = boolize(lhs);
                        switch(op){
                            case 'and':
                                result = lBool && boolize((yield* evalrhs()));
                                break;
                            case 'or':
                                result = lBool || boolize((yield* evalrhs()));
                                break;
                        }
                        return result;
                    }
                    function boolize(value) {
                        var booledValue = fn.boolean(value);
                        return typeof booledValue === 'undefined' ? false : booledValue;
                    }
                    /**
     * Evaluate string concatenation against input data
     * @param {Object} lhs - LHS value
     * @param {Object} rhs - RHS value
     * @returns {string|*} Concatenated string
     */ function evaluateStringConcat(lhs, rhs) {
                        var result;
                        var lstr = '';
                        var rstr = '';
                        if (typeof lhs !== 'undefined') lstr = fn.string(lhs);
                        if (typeof rhs !== 'undefined') rstr = fn.string(rhs);
                        result = lstr.concat(rstr);
                        return result;
                    }
                    /**
     * Evaluate group expression against input data
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @param {Object} environment - Environment
     * @returns {{}} Evaluated input data
     */ function* evaluateGroupExpression(expr, input, environment) {
                        var result = Object.create(null);
                        var groups = Object.create(null);
                        var reduce = input && input.tupleStream ? true : false;
                        // group the input sequence by 'key' expression
                        if (!Array.isArray(input)) input = createSequence(input);
                        // if the array is empty, add an undefined entry to enable literal JSON object to be generated
                        if (input.length === 0) input.push(undefined);
                        for(var itemIndex = 0; itemIndex < input.length; itemIndex++){
                            var item = input[itemIndex];
                            var env = reduce ? createFrameFromTuple(environment, item) : environment;
                            for(var pairIndex = 0; pairIndex < expr.lhs.length; pairIndex++){
                                var pair = expr.lhs[pairIndex];
                                var key = yield* evaluate(pair[0], reduce ? item['@'] : item, env);
                                // key has to be a string
                                if (typeof key !== 'string' && key !== undefined) throw {
                                    code: "T1003",
                                    stack: new Error().stack,
                                    position: expr.position,
                                    value: key
                                };
                                if (key !== undefined) {
                                    // reject any attempts to set the internal JSONata flags
                                    if (key === '_jsonata_lambda' || key === '_jsonata_function') // this is a restriction of this implementation rather than JSONata itself
                                    throw {
                                        code: "D1013",
                                        stack: new Error().stack,
                                        position: expr.position,
                                        value: key
                                    };
                                    var entry = {
                                        data: item,
                                        exprIndex: pairIndex
                                    };
                                    if (Object.prototype.hasOwnProperty.call(groups, key)) {
                                        // a value already exists in this slot
                                        if (groups[key].exprIndex !== pairIndex) // this key has been generated by another expression in this group
                                        // when multiple key expressions evaluate to the same key, then error D1009 must be thrown
                                        throw {
                                            code: "D1009",
                                            stack: new Error().stack,
                                            position: expr.position,
                                            value: key
                                        };
                                        // append it as an array
                                        groups[key].data = fn.append(groups[key].data, item);
                                    } else groups[key] = entry;
                                }
                            }
                        }
                        // iterate over the groups to evaluate the 'value' expression
                        for(key in groups){
                            entry = groups[key];
                            var context = entry.data;
                            var env = environment;
                            if (reduce) {
                                var tuple = reduceTupleStream(entry.data);
                                context = tuple['@'];
                                delete tuple['@'];
                                env = createFrameFromTuple(environment, tuple);
                            }
                            var value = yield* evaluate(expr.lhs[entry.exprIndex][1], context, env);
                            if (typeof value !== 'undefined') result[key] = value;
                        }
                        return result;
                    }
                    function reduceTupleStream(tupleStream) {
                        if (!Array.isArray(tupleStream)) return tupleStream;
                        var result = Object.create(null);
                        Object.assign(result, tupleStream[0]);
                        for(var ii = 1; ii < tupleStream.length; ii++)for (const prop of utils.keys(tupleStream[ii]))result[prop] = fn.append(result[prop], tupleStream[ii][prop]);
                        return result;
                    }
                    /**
     * Evaluate range expression against input data
     * @param {Object} lhs - LHS value
     * @param {Object} rhs - RHS value
     * @returns {Array} Resultant array
     */ function evaluateRangeExpression(lhs, rhs) {
                        var result;
                        if (typeof lhs !== 'undefined' && !Number.isInteger(lhs)) throw {
                            code: "T2003",
                            stack: new Error().stack,
                            value: lhs
                        };
                        if (typeof rhs !== 'undefined' && !Number.isInteger(rhs)) throw {
                            code: "T2004",
                            stack: new Error().stack,
                            value: rhs
                        };
                        if (typeof lhs === 'undefined' || typeof rhs === 'undefined') // if either side is undefined, the result is undefined
                        return result;
                        if (lhs > rhs) // if the lhs is greater than the rhs, return undefined
                        return result;
                        // limit the size of the array to ten million entries (1e7)
                        // this is an implementation defined limit to protect against
                        // memory and performance issues.  This value may increase in the future.
                        var size = rhs - lhs + 1;
                        if (size > 1e7) throw {
                            code: "D2014",
                            stack: new Error().stack,
                            value: size
                        };
                        result = new Array(size);
                        for(var item = lhs, index = 0; item <= rhs; item++, index++)result[index] = item;
                        result.sequence = true;
                        return result;
                    }
                    /**
     * Evaluate bind expression against input data
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @param {Object} environment - Environment
     * @returns {*} Evaluated input data
     */ function* evaluateBindExpression(expr, input, environment) {
                        // The RHS is the expression to evaluate
                        // The LHS is the name of the variable to bind to - should be a VARIABLE token (enforced by parser)
                        var value = yield* evaluate(expr.rhs, input, environment);
                        environment.bind(expr.lhs.value, value);
                        return value;
                    }
                    /**
     * Evaluate condition against input data
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @param {Object} environment - Environment
     * @returns {*} Evaluated input data
     */ function* evaluateCondition(expr, input, environment) {
                        var result;
                        var condition = yield* evaluate(expr.condition, input, environment);
                        if (fn.boolean(condition)) result = yield* evaluate(expr.then, input, environment);
                        else if (typeof expr.else !== 'undefined') result = yield* evaluate(expr.else, input, environment);
                        return result;
                    }
                    /**
     * Evaluate block against input data
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @param {Object} environment - Environment
     * @returns {*} Evaluated input data
     */ function* evaluateBlock(expr, input, environment) {
                        var result;
                        // create a new frame to limit the scope of variable assignments
                        // TODO, only do this if the post-parse stage has flagged this as required
                        var frame = createFrame(environment);
                        // invoke each expression in turn
                        // only return the result of the last one
                        for(var ii = 0; ii < expr.expressions.length; ii++)result = yield* evaluate(expr.expressions[ii], input, frame);
                        return result;
                    }
                    /**
     * Prepare a regex
     * @param {Object} expr - expression containing regex
     * @returns {Function} Higher order function representing prepared regex
     */ function evaluateRegex(expr) {
                        var re = new jsonata.RegexEngine(expr.value);
                        var closure = function(str, fromIndex) {
                            var result;
                            re.lastIndex = fromIndex || 0;
                            var match = re.exec(str);
                            if (match !== null) {
                                result = {
                                    match: match[0],
                                    start: match.index,
                                    end: match.index + match[0].length,
                                    groups: []
                                };
                                if (match.length > 1) for(var i = 1; i < match.length; i++)result.groups.push(match[i]);
                                result.next = function() {
                                    if (re.lastIndex >= str.length) return undefined;
                                    else {
                                        var next = closure(str, re.lastIndex);
                                        if (next && next.match === '') // matches zero length string; this will never progress
                                        throw {
                                            code: "D1004",
                                            stack: new Error().stack,
                                            position: expr.position,
                                            value: expr.value.source
                                        };
                                        return next;
                                    }
                                };
                            }
                            return result;
                        };
                        return closure;
                    }
                    /**
     * Evaluate variable against input data
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @param {Object} environment - Environment
     * @returns {*} Evaluated input data
     */ function evaluateVariable(expr, input, environment) {
                        // lookup the variable value in the environment
                        var result;
                        // if the variable name is empty string, then it refers to context value
                        if (expr.value === '') result = input && input.outerWrapper ? input[0] : input;
                        else result = environment.lookup(expr.value);
                        return result;
                    }
                    /**
     * sort / order-by operator
     * @param {Object} expr - AST for operator
     * @param {Object} input - Input data to evaluate against
     * @param {Object} environment - Environment
     * @returns {*} Ordered sequence
     */ function* evaluateSortExpression(expr, input, environment) {
                        var result;
                        // evaluate the lhs, then sort the results in order according to rhs expression
                        //var lhs = yield * evaluate(expr.lhs, input, environment);
                        var lhs = input;
                        var isTupleSort = input.tupleStream ? true : false;
                        // sort the lhs array
                        // use comparator function
                        var comparator = function*(a, b) {
                            // expr.terms is an array of order-by in priority order
                            var comp = 0;
                            for(var index = 0; comp === 0 && index < expr.terms.length; index++){
                                var term = expr.terms[index];
                                //evaluate the sort term in the context of a
                                var context = a;
                                var env = environment;
                                if (isTupleSort) {
                                    context = a['@'];
                                    env = createFrameFromTuple(environment, a);
                                }
                                var aa = yield* evaluate(term.expression, context, env);
                                //evaluate the sort term in the context of b
                                context = b;
                                env = environment;
                                if (isTupleSort) {
                                    context = b['@'];
                                    env = createFrameFromTuple(environment, b);
                                }
                                var bb = yield* evaluate(term.expression, context, env);
                                // type checks
                                var atype = typeof aa;
                                var btype = typeof bb;
                                // undefined should be last in sort order
                                if (atype === 'undefined') {
                                    // swap them, unless btype is also undefined
                                    comp = btype === 'undefined' ? 0 : 1;
                                    continue;
                                }
                                if (btype === 'undefined') {
                                    comp = -1;
                                    continue;
                                }
                                // if aa or bb are not string or numeric values, then throw an error
                                if (!(atype === 'string' || atype === 'number') || !(btype === 'string' || btype === 'number')) throw {
                                    code: "T2008",
                                    stack: new Error().stack,
                                    position: expr.position,
                                    value: !(atype === 'string' || atype === 'number') ? aa : bb
                                };
                                //if aa and bb are not of the same type
                                if (atype !== btype) throw {
                                    code: "T2007",
                                    stack: new Error().stack,
                                    position: expr.position,
                                    value: aa,
                                    value2: bb
                                };
                                if (aa === bb) continue;
                                else if (aa < bb) comp = -1;
                                else comp = 1;
                                if (term.descending === true) comp = -comp;
                            }
                            // only swap a & b if comp equals 1
                            return comp === 1;
                        };
                        var focus = {
                            environment: environment,
                            input: input
                        };
                        // the `focus` is passed in as the `this` for the invoked function
                        result = yield* fn.sort.apply(focus, [
                            lhs,
                            comparator
                        ]);
                        return result;
                    }
                    /**
     * create a transformer function
     * @param {Object} expr - AST for operator
     * @param {Object} input - Input data to evaluate against
     * @param {Object} environment - Environment
     * @returns {*} tranformer function
     */ function evaluateTransformExpression(expr, input, environment) {
                        // create a function to implement the transform definition
                        var transformer = function*(obj) {
                            // undefined inputs always return undefined
                            if (typeof obj === 'undefined') return undefined;
                            // this function returns a copy of obj with changes specified by the pattern/operation
                            var cloneFunction = environment.lookup('clone');
                            if (!isFunction(cloneFunction)) // throw type error
                            throw {
                                code: "T2013",
                                stack: new Error().stack,
                                position: expr.position
                            };
                            var result = yield* apply(cloneFunction, [
                                obj
                            ], null, environment);
                            var matches = yield* evaluate(expr.pattern, result, environment);
                            if (typeof matches !== 'undefined') {
                                if (!Array.isArray(matches)) matches = [
                                    matches
                                ];
                                for(var ii = 0; ii < matches.length; ii++){
                                    var match = matches[ii];
                                    // evaluate the update value for each match
                                    var update = yield* evaluate(expr.update, match, environment);
                                    // update must be an object
                                    var updateType = typeof update;
                                    if (updateType !== 'undefined') {
                                        if (updateType !== 'object' || update === null || Array.isArray(update)) // throw type error
                                        throw {
                                            code: "T2011",
                                            stack: new Error().stack,
                                            position: expr.update.position,
                                            value: update
                                        };
                                        // merge the update
                                        for (const prop of utils.keys(update))match[prop] = update[prop];
                                    }
                                    // delete, if specified, must be an array of strings (or single string)
                                    if (typeof expr.delete !== 'undefined') {
                                        var deletions = yield* evaluate(expr.delete, match, environment);
                                        if (typeof deletions !== 'undefined') {
                                            var val = deletions;
                                            if (!Array.isArray(deletions)) deletions = [
                                                deletions
                                            ];
                                            if (!isArrayOfStrings(deletions)) // throw type error
                                            throw {
                                                code: "T2012",
                                                stack: new Error().stack,
                                                position: expr.delete.position,
                                                value: val
                                            };
                                            for(var jj = 0; jj < deletions.length; jj++)if (typeof match === 'object' && match !== null) delete match[deletions[jj]];
                                        }
                                    }
                                }
                            }
                            return result;
                        };
                        return defineFunction(transformer, '<(oa):o>');
                    }
                    var chainAST = parser('function($f, $g) { function($x){ $g($f($x)) } }');
                    /**
     * Apply the function on the RHS using the sequence on the LHS as the first argument
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @param {Object} environment - Environment
     * @returns {*} Evaluated input data
     */ function* evaluateApplyExpression(expr, input, environment) {
                        var result;
                        var lhs = yield* evaluate(expr.lhs, input, environment);
                        if (expr.rhs.type === 'function') // this is a function _invocation_; invoke it with lhs expression as the first argument
                        result = yield* evaluateFunction(expr.rhs, input, environment, {
                            context: lhs
                        });
                        else {
                            var func = yield* evaluate(expr.rhs, input, environment);
                            if (!isFunction(func)) throw {
                                code: "T2006",
                                stack: new Error().stack,
                                position: expr.position,
                                value: func
                            };
                            if (isFunction(lhs)) {
                                // this is function chaining (func1 ~> func2)
                                // λ($f, $g) { λ($x){ $g($f($x)) } }
                                var chain = yield* evaluate(chainAST, null, environment);
                                result = yield* apply(chain, [
                                    lhs,
                                    func
                                ], null, environment);
                            } else result = yield* apply(func, [
                                lhs
                            ], null, environment);
                        }
                        return result;
                    }
                    /**
     * Evaluate function against input data
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @param {Object} environment - Environment
     * @returns {*} Evaluated input data
     */ function* evaluateFunction(expr, input, environment, applyto) {
                        var result;
                        // create the procedure
                        // can't assume that expr.procedure is a lambda type directly
                        // could be an expression that evaluates to a function (e.g. variable reference, parens expr etc.
                        // evaluate it generically first, then check that it is a function.  Throw error if not.
                        var proc = yield* evaluate(expr.procedure, input, environment);
                        if (typeof proc === 'undefined' && expr.procedure.type === 'path' && environment.lookup(expr.procedure.steps[0].value)) // help the user out here if they simply forgot the leading $
                        throw {
                            code: "T1005",
                            stack: new Error().stack,
                            position: expr.position,
                            token: expr.procedure.steps[0].value
                        };
                        var evaluatedArgs = [];
                        if (typeof applyto !== 'undefined') evaluatedArgs.push(applyto.context);
                        // eager evaluation - evaluate the arguments
                        for(var jj = 0; jj < expr.arguments.length; jj++){
                            const arg = yield* evaluate(expr.arguments[jj], input, environment);
                            if (isFunction(arg)) {
                                // wrap this in a closure
                                const closure = function*(...params) {
                                    // invoke func
                                    return yield* apply(arg, params, null, environment);
                                };
                                closure.arity = getFunctionArity(arg);
                                evaluatedArgs.push(closure);
                            } else evaluatedArgs.push(arg);
                        }
                        // apply the procedure
                        var procName = expr.procedure.type === 'path' ? expr.procedure.steps[0].value : expr.procedure.value;
                        try {
                            if (typeof proc === 'object') {
                                proc.token = procName;
                                proc.position = expr.position;
                            }
                            result = yield* apply(proc, evaluatedArgs, input, environment);
                        } catch (err) {
                            if (!err.position) // add the position field to the error
                            err.position = expr.position;
                            if (!err.token) // and the function identifier
                            err.token = procName;
                            throw err;
                        }
                        return result;
                    }
                    /**
     * Apply procedure or function
     * @param {Object} proc - Procedure
     * @param {Array} args - Arguments
     * @param {Object} input - input
     * @param {Object} environment - environment
     * @returns {*} Result of procedure
     */ function* apply(proc, args, input, environment) {
                        var result;
                        result = yield* applyInner(proc, args, input, environment);
                        while(isLambda(result) && result.thunk === true){
                            // trampoline loop - this gets invoked as a result of tail-call optimization
                            // the function returned a tail-call thunk
                            // unpack it, evaluate its arguments, and apply the tail call
                            var next = yield* evaluate(result.body.procedure, result.input, result.environment);
                            if (result.body.procedure.type === 'variable') next.token = result.body.procedure.value;
                            next.position = result.body.procedure.position;
                            var evaluatedArgs = [];
                            for(var ii = 0; ii < result.body.arguments.length; ii++)evaluatedArgs.push((yield* evaluate(result.body.arguments[ii], result.input, result.environment)));
                            result = yield* applyInner(next, evaluatedArgs, input, environment);
                        }
                        return result;
                    }
                    /**
     * Apply procedure or function
     * @param {Object} proc - Procedure
     * @param {Array} args - Arguments
     * @param {Object} input - input
     * @param {Object} environment - environment
     * @returns {*} Result of procedure
     */ function* applyInner(proc, args, input, environment) {
                        var result;
                        try {
                            var validatedArgs = args;
                            if (proc) validatedArgs = validateArguments(proc.signature, args, input);
                            if (isLambda(proc)) result = yield* applyProcedure(proc, validatedArgs);
                            else if (proc && proc._jsonata_function === true) {
                                var focus = {
                                    environment: environment,
                                    input: input
                                };
                                // the `focus` is passed in as the `this` for the invoked function
                                result = proc.implementation.apply(focus, validatedArgs);
                                // `proc.implementation` might be a generator function
                                // and `result` might be a generator - if so, yield
                                if (isIterable(result)) result = yield* result;
                            } else if (typeof proc === 'function') {
                                // typically these are functions that are returned by the invocation of plugin functions
                                // the `input` is being passed in as the `this` for the invoked function
                                // this is so that functions that return objects containing functions can chain
                                // e.g. $func().next().next()
                                result = proc.apply(input, validatedArgs);
                                /* istanbul ignore next */ if (isIterable(result)) result = yield* result;
                            } else throw {
                                code: "T1006",
                                stack: new Error().stack
                            };
                        } catch (err) {
                            if (proc) {
                                if (typeof err.token == 'undefined' && typeof proc.token !== 'undefined') err.token = proc.token;
                                err.position = proc.position || err.position;
                            }
                            throw err;
                        }
                        return result;
                    }
                    /**
     * Evaluate lambda against input data
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @param {Object} environment - Environment
     * @returns {{lambda: boolean, input: *, environment: *, arguments: *, body: *}} Evaluated input data
     */ function evaluateLambda(expr, input, environment) {
                        // make a function (closure)
                        var procedure = {
                            _jsonata_lambda: true,
                            input: input,
                            environment: environment,
                            arguments: expr.arguments,
                            signature: expr.signature,
                            body: expr.body
                        };
                        if (expr.thunk === true) procedure.thunk = true;
                        procedure.apply = function*(self1, args) {
                            return yield* apply(procedure, args, input, self1.environment);
                        };
                        return procedure;
                    }
                    /**
     * Evaluate partial application
     * @param {Object} expr - JSONata expression
     * @param {Object} input - Input data to evaluate against
     * @param {Object} environment - Environment
     * @returns {*} Evaluated input data
     */ function* evaluatePartialApplication(expr, input, environment) {
                        // partially apply a function
                        var result;
                        // evaluate the arguments
                        var evaluatedArgs = [];
                        for(var ii = 0; ii < expr.arguments.length; ii++){
                            var arg = expr.arguments[ii];
                            if (arg.type === 'operator' && arg.value === '?') evaluatedArgs.push(arg);
                            else evaluatedArgs.push((yield* evaluate(arg, input, environment)));
                        }
                        // lookup the procedure
                        var proc = yield* evaluate(expr.procedure, input, environment);
                        if (typeof proc === 'undefined' && expr.procedure.type === 'path' && environment.lookup(expr.procedure.steps[0].value)) // help the user out here if they simply forgot the leading $
                        throw {
                            code: "T1007",
                            stack: new Error().stack,
                            position: expr.position,
                            token: expr.procedure.steps[0].value
                        };
                        if (isLambda(proc)) result = partialApplyProcedure(proc, evaluatedArgs);
                        else if (proc && proc._jsonata_function === true) result = partialApplyNativeFunction(proc.implementation, evaluatedArgs);
                        else if (typeof proc === 'function') result = partialApplyNativeFunction(proc, evaluatedArgs);
                        else throw {
                            code: "T1008",
                            stack: new Error().stack,
                            position: expr.position,
                            token: expr.procedure.type === 'path' ? expr.procedure.steps[0].value : expr.procedure.value
                        };
                        return result;
                    }
                    /**
     * Validate the arguments against the signature validator (if it exists)
     * @param {Function} signature - validator function
     * @param {Array} args - function arguments
     * @param {*} context - context value
     * @returns {Array} - validated arguments
     */ function validateArguments(signature, args, context) {
                        if (typeof signature === 'undefined') // nothing to validate
                        return args;
                        var validatedArgs = signature.validate(args, context);
                        return validatedArgs;
                    }
                    /**
     * Apply procedure
     * @param {Object} proc - Procedure
     * @param {Array} args - Arguments
     * @returns {*} Result of procedure
     */ function* applyProcedure(proc, args) {
                        var result;
                        var env = createFrame(proc.environment);
                        Array.prototype.forEach.call(proc.arguments, function(param, index) {
                            env.bind(param.value, args[index]);
                        });
                        if (typeof proc.body === 'function') // this is a lambda that wraps a native function - generated by partially evaluating a native
                        result = yield* applyNativeFunction(proc.body, env);
                        else result = yield* evaluate(proc.body, proc.input, env);
                        return result;
                    }
                    /**
     * Partially apply procedure
     * @param {Object} proc - Procedure
     * @param {Array} args - Arguments
     * @returns {{lambda: boolean, input: *, environment: {bind, lookup}, arguments: Array, body: *}} Result of partially applied procedure
     */ function partialApplyProcedure(proc, args) {
                        // create a closure, bind the supplied parameters and return a function that takes the remaining (?) parameters
                        var env = createFrame(proc.environment);
                        var unboundArgs = [];
                        Array.prototype.forEach.call(proc.arguments, function(param, index) {
                            var arg = args[index];
                            if (arg && arg.type === 'operator' && arg.value === '?') unboundArgs.push(param);
                            else env.bind(param.value, arg);
                        });
                        var procedure = {
                            _jsonata_lambda: true,
                            input: proc.input,
                            environment: env,
                            arguments: unboundArgs,
                            body: proc.body
                        };
                        return procedure;
                    }
                    /**
     * Partially apply native function
     * @param {Function} native - Native function
     * @param {Array} args - Arguments
     * @returns {{lambda: boolean, input: *, environment: {bind, lookup}, arguments: Array, body: *}} Result of partially applying native function
     */ function partialApplyNativeFunction(native, args) {
                        // create a lambda function that wraps and invokes the native function
                        // get the list of declared arguments from the native function
                        // this has to be picked out from the toString() value
                        var sigArgs = getNativeFunctionArguments(native);
                        sigArgs = sigArgs.map(function(sigArg) {
                            return '$' + sigArg.trim();
                        });
                        var body = 'function(' + sigArgs.join(', ') + '){ _ }';
                        var bodyAST = parser(body);
                        bodyAST.body = native;
                        var partial = partialApplyProcedure(bodyAST, args);
                        return partial;
                    }
                    /**
     * Apply native function
     * @param {Object} proc - Procedure
     * @param {Object} env - Environment
     * @returns {*} Result of applying native function
     */ function* applyNativeFunction(proc, env) {
                        var sigArgs = getNativeFunctionArguments(proc);
                        // generate the array of arguments for invoking the function - look them up in the environment
                        var args = sigArgs.map(function(sigArg) {
                            return env.lookup(sigArg.trim());
                        });
                        var focus = {
                            environment: env
                        };
                        var result = proc.apply(focus, args);
                        if (isIterable(result)) result = yield* result;
                        return result;
                    }
                    /**
     * Get native function arguments
     * @param {Function} func - Function
     * @returns {*|Array} Native function arguments
     */ function getNativeFunctionArguments(func) {
                        var signature = func.toString();
                        var sigParens = /\(([^)]*)\)/.exec(signature)[1]; // the contents of the parens
                        var sigArgs = sigParens.split(',');
                        return sigArgs;
                    }
                    /**
     * Creates a function definition
     * @param {Function} func - function implementation in Javascript
     * @param {string} signature - JSONata function signature definition
     * @returns {{implementation: *, signature: *}} function definition
     */ function defineFunction(func, signature) {
                        var definition = {
                            _jsonata_function: true,
                            implementation: func
                        };
                        if (typeof signature !== 'undefined') definition.signature = parseSignature(signature);
                        return definition;
                    }
                    /**
     * parses and evaluates the supplied expression
     * @param {string} expr - expression to evaluate
     * @returns {*} - result of evaluating the expression
     */ function* functionEval(expr, focus) {
                        // undefined inputs always return undefined
                        if (typeof expr === 'undefined') return undefined;
                        var input = this.input;
                        if (typeof focus !== 'undefined') {
                            input = focus;
                            // if the input is a JSON array, then wrap it in a singleton sequence so it gets treated as a single input
                            if (Array.isArray(input) && !isSequence(input)) {
                                input = createSequence(input);
                                input.outerWrapper = true;
                            }
                        }
                        try {
                            var ast = parser(expr, false);
                        } catch (err) {
                            // error parsing the expression passed to $eval
                            populateMessage(err);
                            throw {
                                stack: new Error().stack,
                                code: "D3120",
                                value: err.message,
                                error: err
                            };
                        }
                        try {
                            var result = yield* evaluate(ast, input, this.environment);
                        } catch (err) {
                            // error evaluating the expression passed to $eval
                            populateMessage(err);
                            throw {
                                stack: new Error().stack,
                                code: "D3121",
                                value: err.message,
                                error: err
                            };
                        }
                        return result;
                    }
                    /**
     * Clones an object
     * @param {Object} arg - object to clone (deep copy)
     * @returns {*} - the cloned object
     */ function functionClone(arg) {
                        // undefined inputs always return undefined
                        if (typeof arg === 'undefined') return undefined;
                        return JSON.parse(fn.string(arg));
                    }
                    /**
     * Create frame
     * @param {Object} enclosingEnvironment - Enclosing environment
     * @returns {{bind: bind, lookup: lookup}} Created frame
     */ function createFrame(enclosingEnvironment) {
                        var bindings = Object.create(null);
                        return {
                            bind: function(name, value) {
                                bindings[name] = value;
                            },
                            lookup: function(name) {
                                var value;
                                if (Object.prototype.hasOwnProperty.call(bindings, name)) value = bindings[name];
                                else if (enclosingEnvironment) value = enclosingEnvironment.lookup(name);
                                return value;
                            },
                            timestamp: enclosingEnvironment ? enclosingEnvironment.timestamp : null,
                            async: enclosingEnvironment ? enclosingEnvironment.async : false,
                            global: enclosingEnvironment ? enclosingEnvironment.global : {
                                ancestry: [
                                    null
                                ]
                            }
                        };
                    }
                    // Function registration
                    staticFrame.bind('sum', defineFunction(fn.sum, '<a<n>:n>'));
                    staticFrame.bind('count', defineFunction(fn.count, '<a:n>'));
                    staticFrame.bind('max', defineFunction(fn.max, '<a<n>:n>'));
                    staticFrame.bind('min', defineFunction(fn.min, '<a<n>:n>'));
                    staticFrame.bind('average', defineFunction(fn.average, '<a<n>:n>'));
                    staticFrame.bind('string', defineFunction(fn.string, '<x-b?:s>'));
                    staticFrame.bind('substring', defineFunction(fn.substring, '<s-nn?:s>'));
                    staticFrame.bind('substringBefore', defineFunction(fn.substringBefore, '<s-s:s>'));
                    staticFrame.bind('substringAfter', defineFunction(fn.substringAfter, '<s-s:s>'));
                    staticFrame.bind('lowercase', defineFunction(fn.lowercase, '<s-:s>'));
                    staticFrame.bind('uppercase', defineFunction(fn.uppercase, '<s-:s>'));
                    staticFrame.bind('length', defineFunction(fn.length, '<s-:n>'));
                    staticFrame.bind('trim', defineFunction(fn.trim, '<s-:s>'));
                    staticFrame.bind('pad', defineFunction(fn.pad, '<s-ns?:s>'));
                    staticFrame.bind('match', defineFunction(fn.match, '<s-f<s:o>n?:a<o>>'));
                    staticFrame.bind('contains', defineFunction(fn.contains, '<s-(sf):b>')); // TODO <s-(sf<s:o>):b>
                    staticFrame.bind('replace', defineFunction(fn.replace, '<s-(sf)(sf)n?:s>')); // TODO <s-(sf<s:o>)(sf<o:s>)n?:s>
                    staticFrame.bind('split', defineFunction(fn.split, '<s-(sf)n?:a<s>>')); // TODO <s-(sf<s:o>)n?:a<s>>
                    staticFrame.bind('join', defineFunction(fn.join, '<a<s>s?:s>'));
                    staticFrame.bind('formatNumber', defineFunction(fn.formatNumber, '<n-so?:s>'));
                    staticFrame.bind('formatBase', defineFunction(fn.formatBase, '<n-n?:s>'));
                    staticFrame.bind('formatInteger', defineFunction(datetime.formatInteger, '<n-s:s>'));
                    staticFrame.bind('parseInteger', defineFunction(datetime.parseInteger, '<s-s:n>'));
                    staticFrame.bind('number', defineFunction(fn.number, '<(nsb)-:n>'));
                    staticFrame.bind('floor', defineFunction(fn.floor, '<n-:n>'));
                    staticFrame.bind('ceil', defineFunction(fn.ceil, '<n-:n>'));
                    staticFrame.bind('round', defineFunction(fn.round, '<n-n?:n>'));
                    staticFrame.bind('abs', defineFunction(fn.abs, '<n-:n>'));
                    staticFrame.bind('sqrt', defineFunction(fn.sqrt, '<n-:n>'));
                    staticFrame.bind('power', defineFunction(fn.power, '<n-n:n>'));
                    staticFrame.bind('random', defineFunction(fn.random, '<:n>'));
                    staticFrame.bind('boolean', defineFunction(fn.boolean, '<x-:b>'));
                    staticFrame.bind('not', defineFunction(fn.not, '<x-:b>'));
                    staticFrame.bind('map', defineFunction(fn.map, '<af>'));
                    staticFrame.bind('zip', defineFunction(fn.zip, '<a+>'));
                    staticFrame.bind('filter', defineFunction(fn.filter, '<af>'));
                    staticFrame.bind('single', defineFunction(fn.single, '<af?>'));
                    staticFrame.bind('reduce', defineFunction(fn.foldLeft, '<afj?:j>')); // TODO <f<jj:j>a<j>j?:j>
                    staticFrame.bind('sift', defineFunction(fn.sift, '<o-f?:o>'));
                    staticFrame.bind('keys', defineFunction(fn.keys, '<x-:a<s>>'));
                    staticFrame.bind('lookup', defineFunction(fn.lookup, '<x-s:x>'));
                    staticFrame.bind('append', defineFunction(fn.append, '<xx:a>'));
                    staticFrame.bind('exists', defineFunction(fn.exists, '<x:b>'));
                    staticFrame.bind('spread', defineFunction(fn.spread, '<x-:a<o>>'));
                    staticFrame.bind('merge', defineFunction(fn.merge, '<a<o>:o>'));
                    staticFrame.bind('reverse', defineFunction(fn.reverse, '<a:a>'));
                    staticFrame.bind('each', defineFunction(fn.each, '<o-f:a>'));
                    staticFrame.bind('error', defineFunction(fn.error, '<s?:x>'));
                    staticFrame.bind('assert', defineFunction(fn.assert, '<bs?:x>'));
                    staticFrame.bind('type', defineFunction(fn.type, '<x:s>'));
                    staticFrame.bind('sort', defineFunction(fn.sort, '<af?:a>'));
                    staticFrame.bind('shuffle', defineFunction(fn.shuffle, '<a:a>'));
                    staticFrame.bind('distinct', defineFunction(fn.distinct, '<x:x>'));
                    staticFrame.bind('base64encode', defineFunction(fn.base64encode, '<s-:s>'));
                    staticFrame.bind('base64decode', defineFunction(fn.base64decode, '<s-:s>'));
                    staticFrame.bind('encodeUrlComponent', defineFunction(fn.encodeUrlComponent, '<s-:s>'));
                    staticFrame.bind('encodeUrl', defineFunction(fn.encodeUrl, '<s-:s>'));
                    staticFrame.bind('decodeUrlComponent', defineFunction(fn.decodeUrlComponent, '<s-:s>'));
                    staticFrame.bind('decodeUrl', defineFunction(fn.decodeUrl, '<s-:s>'));
                    staticFrame.bind('eval', defineFunction(functionEval, '<sx?:x>'));
                    staticFrame.bind('toMillis', defineFunction(datetime.toMillis, '<s-s?:n>'));
                    staticFrame.bind('fromMillis', defineFunction(datetime.fromMillis, '<n-s?s?:s>'));
                    staticFrame.bind('clone', defineFunction(functionClone, '<(oa)-:o>'));
                    /**
     * Error codes
     *
     * Sxxxx    - Static errors (compile time)
     * Txxxx    - Type errors
     * Dxxxx    - Dynamic errors (evaluate time)
     *  01xx    - tokenizer
     *  02xx    - parser
     *  03xx    - regex parser
     *  04xx    - function signature parser/evaluator
     *  10xx    - evaluator
     *  20xx    - operators
     *  3xxx    - functions (blocks of 10 for each function)
     */ var errorCodes = {
                        "S0101": "String literal must be terminated by a matching quote",
                        "S0102": "Number out of range: {{token}}",
                        "S0103": "Unsupported escape sequence: \\{{token}}",
                        "S0104": "The escape sequence \\u must be followed by 4 hex digits",
                        "S0105": "Quoted property name must be terminated with a backquote (`)",
                        "S0106": "Comment has no closing tag",
                        "S0201": "Syntax error: {{token}}",
                        "S0202": "Expected {{value}}, got {{token}}",
                        "S0203": "Expected {{value}} before end of expression",
                        "S0204": "Unknown operator: {{token}}",
                        "S0205": "Unexpected token: {{token}}",
                        "S0206": "Unknown expression type: {{token}}",
                        "S0207": "Unexpected end of expression",
                        "S0208": "Parameter {{value}} of function definition must be a variable name (start with $)",
                        "S0209": "A predicate cannot follow a grouping expression in a step",
                        "S0210": "Each step can only have one grouping expression",
                        "S0211": "The symbol {{token}} cannot be used as a unary operator",
                        "S0212": "The left side of := must be a variable name (start with $)",
                        "S0213": "The literal value {{value}} cannot be used as a step within a path expression",
                        "S0214": "The right side of {{token}} must be a variable name (start with $)",
                        "S0215": "A context variable binding must precede any predicates on a step",
                        "S0216": "A context variable binding must precede the 'order-by' clause on a step",
                        "S0217": "The object representing the 'parent' cannot be derived from this expression",
                        "S0301": "Empty regular expressions are not allowed",
                        "S0302": "No terminating / in regular expression",
                        "S0402": "Choice groups containing parameterized types are not supported",
                        "S0401": "Type parameters can only be applied to functions and arrays",
                        "S0500": "Attempted to evaluate an expression containing syntax error(s)",
                        "T0410": "Argument {{index}} of function {{token}} does not match function signature",
                        "T0411": "Context value is not a compatible type with argument {{index}} of function {{token}}",
                        "T0412": "Argument {{index}} of function {{token}} must be an array of {{type}}",
                        "D1001": "Number out of range: {{value}}",
                        "D1002": "Cannot negate a non-numeric value: {{value}}",
                        "T1003": "Key in object structure must evaluate to a string; got: {{value}}",
                        "D1004": "Regular expression matches zero length string",
                        "T1005": "Attempted to invoke a non-function. Did you mean ${{{token}}}?",
                        "T1006": "Attempted to invoke a non-function",
                        "T1007": "Attempted to partially apply a non-function. Did you mean ${{{token}}}?",
                        "T1008": "Attempted to partially apply a non-function",
                        "D1009": "Multiple key definitions evaluate to same key: {{value}}",
                        "D1013": "Object property names starting with _jsonata_ are reserved for internal use: {{value}}",
                        "T1010": "The matcher function argument passed to function {{token}} does not return the correct object structure",
                        "T2001": "The left side of the {{token}} operator must evaluate to a number",
                        "T2002": "The right side of the {{token}} operator must evaluate to a number",
                        "T2003": "The left side of the range operator (..) must evaluate to an integer",
                        "T2004": "The right side of the range operator (..) must evaluate to an integer",
                        "D2005": "The left side of := must be a variable name (start with $)",
                        "T2006": "The right side of the function application operator ~> must be a function",
                        "T2007": "Type mismatch when comparing values {{value}} and {{value2}} in order-by clause",
                        "T2008": "The expressions within an order-by clause must evaluate to numeric or string values",
                        "T2009": "The values {{value}} and {{value2}} either side of operator {{token}} must be of the same data type",
                        "T2010": "The expressions either side of operator {{token}} must evaluate to numeric or string values",
                        "T2011": "The insert/update clause of the transform expression must evaluate to an object: {{value}}",
                        "T2012": "The delete clause of the transform expression must evaluate to a string or array of strings: {{value}}",
                        "T2013": "The transform expression clones the input object using the $clone() function.  This has been overridden in the current scope by a non-function.",
                        "D2014": "The size of the sequence allocated by the range operator (..) must not exceed 1e6.  Attempted to allocate {{value}}.",
                        "D3001": "Attempting to invoke string function on Infinity or NaN",
                        "D3010": "Second argument of replace function cannot be an empty string",
                        "D3011": "Fourth argument of replace function must evaluate to a positive number",
                        "D3012": "Attempted to replace a matched string with a non-string value",
                        "D3020": "Third argument of split function must evaluate to a positive number",
                        "D3030": "Unable to cast value to a number: {{value}}",
                        "D3040": "Third argument of match function must evaluate to a positive number",
                        "D3050": "The second argument of reduce function must be a function with at least two arguments",
                        "D3060": "The sqrt function cannot be applied to a negative number: {{value}}",
                        "D3061": "The power function has resulted in a value that cannot be represented as a JSON number: base={{value}}, exponent={{exp}}",
                        "D3070": "The single argument form of the sort function can only be applied to an array of strings or an array of numbers.  Use the second argument to specify a comparison function",
                        "D3080": "The picture string must only contain a maximum of two sub-pictures",
                        "D3081": "The sub-picture must not contain more than one instance of the 'decimal-separator' character",
                        "D3082": "The sub-picture must not contain more than one instance of the 'percent' character",
                        "D3083": "The sub-picture must not contain more than one instance of the 'per-mille' character",
                        "D3084": "The sub-picture must not contain both a 'percent' and a 'per-mille' character",
                        "D3085": "The mantissa part of a sub-picture must contain at least one character that is either an 'optional digit character' or a member of the 'decimal digit family'",
                        "D3086": "The sub-picture must not contain a passive character that is preceded by an active character and that is followed by another active character",
                        "D3087": "The sub-picture must not contain a 'grouping-separator' character that appears adjacent to a 'decimal-separator' character",
                        "D3088": "The sub-picture must not contain a 'grouping-separator' at the end of the integer part",
                        "D3089": "The sub-picture must not contain two adjacent instances of the 'grouping-separator' character",
                        "D3090": "The integer part of the sub-picture must not contain a member of the 'decimal digit family' that is followed by an instance of the 'optional digit character'",
                        "D3091": "The fractional part of the sub-picture must not contain an instance of the 'optional digit character' that is followed by a member of the 'decimal digit family'",
                        "D3092": "A sub-picture that contains a 'percent' or 'per-mille' character must not contain a character treated as an 'exponent-separator'",
                        "D3093": "The exponent part of the sub-picture must comprise only of one or more characters that are members of the 'decimal digit family'",
                        "D3100": "The radix of the formatBase function must be between 2 and 36.  It was given {{value}}",
                        "D3110": "The argument of the toMillis function must be an ISO 8601 formatted timestamp. Given {{value}}",
                        "D3120": "Syntax error in expression passed to function eval: {{value}}",
                        "D3121": "Dynamic error evaluating the expression passed to function eval: {{value}}",
                        "D3130": "Formatting or parsing an integer as a sequence starting with {{value}} is not supported by this implementation",
                        "D3131": "In a decimal digit pattern, all digits must be from the same decimal group",
                        "D3132": "Unknown component specifier {{value}} in date/time picture string",
                        "D3133": "The 'name' modifier can only be applied to months and days in the date/time picture string, not {{value}}",
                        "D3134": "The timezone integer format specifier cannot have more than four digits",
                        "D3135": "No matching closing bracket ']' in date/time picture string",
                        "D3136": "The date/time picture string is missing specifiers required to parse the timestamp",
                        "D3137": "{{{message}}}",
                        "D3138": "The $single() function expected exactly 1 matching result.  Instead it matched more.",
                        "D3139": "The $single() function expected exactly 1 matching result.  Instead it matched 0.",
                        "D3140": "Malformed URL passed to ${{{functionName}}}(): {{value}}",
                        "D3141": "{{{message}}}"
                    };
                    /**
     * lookup a message template from the catalog and substitute the inserts.
     * Populates `err.message` with the substituted message. Leaves `err.message`
     * untouched if code lookup fails.
     * @param {string} err - error code to lookup
     * @returns {undefined} - `err` is modified in place
     */ function populateMessage(err) {
                        var template = errorCodes[err.code];
                        if (typeof template !== 'undefined') {
                            // if there are any handlebars, replace them with the field references
                            // triple braces - replace with value
                            // double braces - replace with json stringified value
                            var message = template.replace(/\{\{\{([^}]+)}}}/g, function() {
                                return err[arguments[1]];
                            });
                            message = message.replace(/\{\{([^}]+)}}/g, function() {
                                return JSON.stringify(err[arguments[1]]);
                            });
                            err.message = message;
                        }
                    // Otherwise retain the original `err.message`
                    }
                    /**
     * JSONata
     * @param {Object} expr - JSONata expression
     * @param {Object} options
     * @param {boolean} options.recover: attempt to recover on parse error
     * @param {Function} options.RegexEngine: RegEx class constructor to use
     * @returns {{evaluate: evaluate, assign: assign}} Evaluated expression
     */ function jsonata(expr, options) {
                        var ast;
                        var errors;
                        try {
                            ast = parser(expr, options && options.recover);
                            errors = ast.errors;
                            delete ast.errors;
                        } catch (err) {
                            // insert error message into structure
                            populateMessage(err); // possible side-effects on `err`
                            throw err;
                        }
                        var environment = createFrame(staticFrame);
                        var timestamp = new Date(); // will be overridden on each call to evalute()
                        environment.bind('now', defineFunction(function(picture, timezone) {
                            return datetime.fromMillis(timestamp.getTime(), picture, timezone);
                        }, '<s?s?:s>'));
                        environment.bind('millis', defineFunction(function() {
                            return timestamp.getTime();
                        }, '<:n>'));
                        if (options && options.RegexEngine) jsonata.RegexEngine = options.RegexEngine;
                        else jsonata.RegexEngine = RegExp;
                        return {
                            evaluate: function(input, bindings, callback) {
                                // throw if the expression compiled with syntax errors
                                if (typeof errors !== 'undefined') {
                                    var err = {
                                        code: 'S0500',
                                        position: 0
                                    };
                                    populateMessage(err); // possible side-effects on `err`
                                    throw err;
                                }
                                if (typeof bindings !== 'undefined') {
                                    var exec_env;
                                    // the variable bindings have been passed in - create a frame to hold these
                                    exec_env = createFrame(environment);
                                    for (const v of utils.keys(bindings))exec_env.bind(v, bindings[v]);
                                } else exec_env = environment;
                                // put the input document into the environment as the root object
                                exec_env.bind('$', input);
                                // capture the timestamp and put it in the execution environment
                                // the $now() and $millis() functions will return this value - whenever it is called
                                timestamp = new Date();
                                exec_env.timestamp = timestamp;
                                // if the input is a JSON array, then wrap it in a singleton sequence so it gets treated as a single input
                                if (Array.isArray(input) && !isSequence(input)) {
                                    input = createSequence(input);
                                    input.outerWrapper = true;
                                }
                                var result, it;
                                // if a callback function is supplied, then drive the generator in a promise chain
                                if (typeof callback === 'function') {
                                    exec_env.async = true;
                                    var catchHandler = function(err) {
                                        populateMessage(err); // possible side-effects on `err`
                                        callback(err, null);
                                    };
                                    var thenHandler = function(response) {
                                        result = it.next(response);
                                        if (result.done) callback(null, result.value);
                                        else result.value.then(thenHandler).catch(catchHandler);
                                    };
                                    it = evaluate(ast, input, exec_env);
                                    result = it.next();
                                    result.value.then(thenHandler).catch(catchHandler);
                                } else // no callback function - drive the generator to completion synchronously
                                try {
                                    it = evaluate(ast, input, exec_env);
                                    result = it.next();
                                    while(!result.done)result = it.next(result.value);
                                    return result.value;
                                } catch (err) {
                                    // insert error message into structure
                                    populateMessage(err); // possible side-effects on `err`
                                    throw err;
                                }
                            },
                            assign: function(name, value) {
                                environment.bind(name, value);
                            },
                            registerFunction: function(name, implementation, signature) {
                                var func = defineFunction(implementation, signature);
                                environment.bind(name, func);
                            },
                            ast: function() {
                                return ast;
                            },
                            errors: function() {
                                return errors;
                            }
                        };
                    }
                    jsonata.parser = parser; // TODO remove this in a future release - use ast() instead
                    return jsonata;
                }();
                module1.exports = jsonata;
            },
            {
                "./datetime": 1,
                "./functions": 2,
                "./parser": 4,
                "./signature": 5,
                "./utils": 6
            }
        ],
        4: [
            function(require1, module1, exports) {
                /**
 * © Copyright IBM Corp. 2016, 2018 All Rights Reserved
 *   Project name: JSONata
 *   This project is licensed under the MIT License, see LICENSE
 */ var parseSignature = require1('./signature');
                const parser = (()=>{
                    'use strict';
                    var operators = {
                        '.': 75,
                        '[': 80,
                        ']': 0,
                        '{': 70,
                        '}': 0,
                        '(': 80,
                        ')': 0,
                        ',': 0,
                        '@': 80,
                        '#': 80,
                        ';': 80,
                        ':': 80,
                        '?': 20,
                        '+': 50,
                        '-': 50,
                        '*': 60,
                        '/': 60,
                        '%': 60,
                        '|': 20,
                        '=': 40,
                        '<': 40,
                        '>': 40,
                        '^': 40,
                        '**': 60,
                        '..': 20,
                        ':=': 10,
                        '!=': 40,
                        '<=': 40,
                        '>=': 40,
                        '~>': 40,
                        'and': 30,
                        'or': 25,
                        'in': 40,
                        '&': 50,
                        '!': 0,
                        '~': 0 // not an operator, but needed as a stop character for name tokens
                    };
                    var escapes = {
                        '"': '"',
                        '\\': '\\',
                        '/': '/',
                        'b': '\b',
                        'f': '\f',
                        'n': '\n',
                        'r': '\r',
                        't': '\t'
                    };
                    // Tokenizer (lexer) - invoked by the parser to return one token at a time
                    var tokenizer = function(path) {
                        var position = 0;
                        var length = path.length;
                        var create = function(type, value) {
                            var obj = {
                                type: type,
                                value: value,
                                position: position
                            };
                            return obj;
                        };
                        var scanRegex = function() {
                            // the prefix '/' will have been previously scanned. Find the end of the regex.
                            // search for closing '/' ignoring any that are escaped, or within brackets
                            var start = position;
                            var depth = 0;
                            var pattern;
                            var flags;
                            while(position < length){
                                var currentChar = path.charAt(position);
                                if (currentChar === '/' && path.charAt(position - 1) !== '\\' && depth === 0) {
                                    // end of regex found
                                    pattern = path.substring(start, position);
                                    if (pattern === '') throw {
                                        code: "S0301",
                                        stack: new Error().stack,
                                        position: position
                                    };
                                    position++;
                                    currentChar = path.charAt(position);
                                    // flags
                                    start = position;
                                    while(currentChar === 'i' || currentChar === 'm'){
                                        position++;
                                        currentChar = path.charAt(position);
                                    }
                                    flags = path.substring(start, position) + 'g';
                                    return new RegExp(pattern, flags);
                                }
                                if ((currentChar === '(' || currentChar === '[' || currentChar === '{') && path.charAt(position - 1) !== '\\') depth++;
                                if ((currentChar === ')' || currentChar === ']' || currentChar === '}') && path.charAt(position - 1) !== '\\') depth--;
                                position++;
                            }
                            throw {
                                code: "S0302",
                                stack: new Error().stack,
                                position: position
                            };
                        };
                        var next = function(prefix) {
                            if (position >= length) return null;
                            var currentChar = path.charAt(position);
                            // skip whitespace
                            while(position < length && ' \t\n\r\v'.indexOf(currentChar) > -1){
                                position++;
                                currentChar = path.charAt(position);
                            }
                            // skip comments
                            if (currentChar === '/' && path.charAt(position + 1) === '*') {
                                var commentStart = position;
                                position += 2;
                                currentChar = path.charAt(position);
                                while(!(currentChar === '*' && path.charAt(position + 1) === '/')){
                                    currentChar = path.charAt(++position);
                                    if (position >= length) // no closing tag
                                    throw {
                                        code: "S0106",
                                        stack: new Error().stack,
                                        position: commentStart
                                    };
                                }
                                position += 2;
                                currentChar = path.charAt(position);
                                return next(prefix); // need this to swallow any following whitespace
                            }
                            // test for regex
                            if (prefix !== true && currentChar === '/') {
                                position++;
                                return create('regex', scanRegex());
                            }
                            // handle double-char operators
                            if (currentChar === '.' && path.charAt(position + 1) === '.') {
                                // double-dot .. range operator
                                position += 2;
                                return create('operator', '..');
                            }
                            if (currentChar === ':' && path.charAt(position + 1) === '=') {
                                // := assignment
                                position += 2;
                                return create('operator', ':=');
                            }
                            if (currentChar === '!' && path.charAt(position + 1) === '=') {
                                // !=
                                position += 2;
                                return create('operator', '!=');
                            }
                            if (currentChar === '>' && path.charAt(position + 1) === '=') {
                                // >=
                                position += 2;
                                return create('operator', '>=');
                            }
                            if (currentChar === '<' && path.charAt(position + 1) === '=') {
                                // <=
                                position += 2;
                                return create('operator', '<=');
                            }
                            if (currentChar === '*' && path.charAt(position + 1) === '*') {
                                // **  descendant wildcard
                                position += 2;
                                return create('operator', '**');
                            }
                            if (currentChar === '~' && path.charAt(position + 1) === '>') {
                                // ~>  chain function
                                position += 2;
                                return create('operator', '~>');
                            }
                            // test for single char operators
                            if (Object.prototype.hasOwnProperty.call(operators, currentChar)) {
                                position++;
                                return create('operator', currentChar);
                            }
                            // test for string literals
                            if (currentChar === '"' || currentChar === "'") {
                                var quoteType = currentChar;
                                // double quoted string literal - find end of string
                                position++;
                                var qstr = "";
                                while(position < length){
                                    currentChar = path.charAt(position);
                                    if (currentChar === '\\') {
                                        position++;
                                        currentChar = path.charAt(position);
                                        if (Object.prototype.hasOwnProperty.call(escapes, currentChar)) qstr += escapes[currentChar];
                                        else if (currentChar === 'u') {
                                            // \u should be followed by 4 hex digits
                                            var octets = path.substr(position + 1, 4);
                                            if (/^[0-9a-fA-F]+$/.test(octets)) {
                                                var codepoint = parseInt(octets, 16);
                                                qstr += String.fromCharCode(codepoint);
                                                position += 4;
                                            } else throw {
                                                code: "S0104",
                                                stack: new Error().stack,
                                                position: position
                                            };
                                        } else // illegal escape sequence
                                        throw {
                                            code: "S0103",
                                            stack: new Error().stack,
                                            position: position,
                                            token: currentChar
                                        };
                                    } else if (currentChar === quoteType) {
                                        position++;
                                        return create('string', qstr);
                                    } else qstr += currentChar;
                                    position++;
                                }
                                throw {
                                    code: "S0101",
                                    stack: new Error().stack,
                                    position: position
                                };
                            }
                            // test for numbers
                            var numregex = /^-?(0|([1-9][0-9]*))(\.[0-9]+)?([Ee][-+]?[0-9]+)?/;
                            var match = numregex.exec(path.substring(position));
                            if (match !== null) {
                                var num = parseFloat(match[0]);
                                if (!isNaN(num) && isFinite(num)) {
                                    position += match[0].length;
                                    return create('number', num);
                                } else throw {
                                    code: "S0102",
                                    stack: new Error().stack,
                                    position: position,
                                    token: match[0]
                                };
                            }
                            // test for quoted names (backticks)
                            var name;
                            if (currentChar === '`') {
                                // scan for closing quote
                                position++;
                                var end = path.indexOf('`', position);
                                if (end !== -1) {
                                    name = path.substring(position, end);
                                    position = end + 1;
                                    return create('name', name);
                                }
                                position = length;
                                throw {
                                    code: "S0105",
                                    stack: new Error().stack,
                                    position: position
                                };
                            }
                            // test for names
                            var i = position;
                            var ch;
                            for(;;){
                                ch = path.charAt(i);
                                if (i === length || ' \t\n\r\v'.indexOf(ch) > -1 || Object.prototype.hasOwnProperty.call(operators, ch)) {
                                    if (path.charAt(position) === '$') {
                                        // variable reference
                                        name = path.substring(position + 1, i);
                                        position = i;
                                        return create('variable', name);
                                    } else {
                                        name = path.substring(position, i);
                                        position = i;
                                        switch(name){
                                            case 'or':
                                            case 'in':
                                            case 'and':
                                                return create('operator', name);
                                            case 'true':
                                                return create('value', true);
                                            case 'false':
                                                return create('value', false);
                                            case 'null':
                                                return create('value', null);
                                            default:
                                                if (position === length && name === '') // whitespace at end of input
                                                return null;
                                                return create('name', name);
                                        }
                                    }
                                } else i++;
                            }
                        };
                        return next;
                    };
                    // This parser implements the 'Top down operator precedence' algorithm developed by Vaughan R Pratt; http://dl.acm.org/citation.cfm?id=512931.
                    // and builds on the Javascript framework described by Douglas Crockford at http://javascript.crockford.com/tdop/tdop.html
                    // and in 'Beautiful Code', edited by Andy Oram and Greg Wilson, Copyright 2007 O'Reilly Media, Inc. 798-0-596-51004-6
                    var parser = function(source, recover) {
                        var node;
                        var lexer;
                        var symbol_table = Object.create(null);
                        var errors = [];
                        var remainingTokens = function() {
                            var remaining = [];
                            if (node.id !== '(end)') remaining.push({
                                type: node.type,
                                value: node.value,
                                position: node.position
                            });
                            var nxt = lexer();
                            while(nxt !== null){
                                remaining.push(nxt);
                                nxt = lexer();
                            }
                            return remaining;
                        };
                        var base_symbol = {
                            nud: function() {
                                // error - symbol has been invoked as a unary operator
                                var err = {
                                    code: 'S0211',
                                    token: this.value,
                                    position: this.position
                                };
                                if (recover) {
                                    err.remaining = remainingTokens();
                                    err.type = 'error';
                                    errors.push(err);
                                    return err;
                                } else {
                                    err.stack = new Error().stack;
                                    throw err;
                                }
                            }
                        };
                        var symbol = function(id, bp) {
                            var s = symbol_table[id];
                            bp = bp || 0;
                            if (s) {
                                if (bp >= s.lbp) s.lbp = bp;
                            } else {
                                s = Object.create(base_symbol);
                                s.id = s.value = id;
                                s.lbp = bp;
                                symbol_table[id] = s;
                            }
                            return s;
                        };
                        var handleError = function(err) {
                            if (recover) {
                                // tokenize the rest of the buffer and add it to an error token
                                err.remaining = remainingTokens();
                                errors.push(err);
                                var symbol = symbol_table["(error)"];
                                node = Object.create(symbol);
                                node.error = err;
                                node.type = "(error)";
                                return node;
                            } else {
                                err.stack = new Error().stack;
                                throw err;
                            }
                        };
                        var advance = function(id, infix) {
                            if (id && node.id !== id) {
                                var code;
                                if (node.id === '(end)') // unexpected end of buffer
                                code = "S0203";
                                else code = "S0202";
                                var err = {
                                    code: code,
                                    position: node.position,
                                    token: node.value,
                                    value: id
                                };
                                return handleError(err);
                            }
                            var next_token = lexer(infix);
                            if (next_token === null) {
                                node = symbol_table["(end)"];
                                node.position = source.length;
                                return node;
                            }
                            var value = next_token.value;
                            var type = next_token.type;
                            var symbol;
                            switch(type){
                                case 'name':
                                case 'variable':
                                    symbol = symbol_table["(name)"];
                                    break;
                                case 'operator':
                                    symbol = symbol_table[value];
                                    if (!symbol) return handleError({
                                        code: "S0204",
                                        stack: new Error().stack,
                                        position: next_token.position,
                                        token: value
                                    });
                                    break;
                                case 'string':
                                case 'number':
                                case 'value':
                                    symbol = symbol_table["(literal)"];
                                    break;
                                case 'regex':
                                    type = "regex";
                                    symbol = symbol_table["(regex)"];
                                    break;
                                /* istanbul ignore next */ default:
                                    return handleError({
                                        code: "S0205",
                                        stack: new Error().stack,
                                        position: next_token.position,
                                        token: value
                                    });
                            }
                            node = Object.create(symbol);
                            node.value = value;
                            node.type = type;
                            node.position = next_token.position;
                            return node;
                        };
                        // Pratt's algorithm
                        var expression = function(rbp) {
                            var left;
                            var t = node;
                            advance(null, true);
                            left = t.nud();
                            while(rbp < node.lbp){
                                t = node;
                                advance();
                                left = t.led(left);
                            }
                            return left;
                        };
                        var terminal = function(id) {
                            var s = symbol(id, 0);
                            s.nud = function() {
                                return this;
                            };
                        };
                        // match infix operators
                        // <expression> <operator> <expression>
                        // left associative
                        var infix = function(id, bp, led) {
                            var bindingPower = bp || operators[id];
                            var s = symbol(id, bindingPower);
                            s.led = led || function(left) {
                                this.lhs = left;
                                this.rhs = expression(bindingPower);
                                this.type = "binary";
                                return this;
                            };
                            return s;
                        };
                        // match infix operators
                        // <expression> <operator> <expression>
                        // right associative
                        var infixr = function(id, bp, led) {
                            var s = symbol(id, bp);
                            s.led = led;
                            return s;
                        };
                        // match prefix operators
                        // <operator> <expression>
                        var prefix = function(id, nud) {
                            var s = symbol(id);
                            s.nud = nud || function() {
                                this.expression = expression(70);
                                this.type = "unary";
                                return this;
                            };
                            return s;
                        };
                        terminal("(end)");
                        terminal("(name)");
                        terminal("(literal)");
                        terminal("(regex)");
                        symbol(":");
                        symbol(";");
                        symbol(",");
                        symbol(")");
                        symbol("]");
                        symbol("}");
                        symbol(".."); // range operator
                        infix("."); // map operator
                        infix("+"); // numeric addition
                        infix("-"); // numeric subtraction
                        infix("*"); // numeric multiplication
                        infix("/"); // numeric division
                        infix("%"); // numeric modulus
                        infix("="); // equality
                        infix("<"); // less than
                        infix(">"); // greater than
                        infix("!="); // not equal to
                        infix("<="); // less than or equal
                        infix(">="); // greater than or equal
                        infix("&"); // string concatenation
                        infix("and"); // Boolean AND
                        infix("or"); // Boolean OR
                        infix("in"); // is member of array
                        terminal("and"); // the 'keywords' can also be used as terminals (field names)
                        terminal("or"); //
                        terminal("in"); //
                        prefix("-"); // unary numeric negation
                        infix("~>"); // function application
                        infixr("(error)", 10, function(left) {
                            this.lhs = left;
                            this.error = node.error;
                            this.remaining = remainingTokens();
                            this.type = 'error';
                            return this;
                        });
                        // field wildcard (single level)
                        prefix('*', function() {
                            this.type = "wildcard";
                            return this;
                        });
                        // descendant wildcard (multi-level)
                        prefix('**', function() {
                            this.type = "descendant";
                            return this;
                        });
                        // parent operator
                        prefix('%', function() {
                            this.type = "parent";
                            return this;
                        });
                        // function invocation
                        infix("(", operators['('], function(left) {
                            // left is is what we are trying to invoke
                            this.procedure = left;
                            this.type = 'function';
                            this.arguments = [];
                            if (node.id !== ')') for(;;){
                                if (node.type === 'operator' && node.id === '?') {
                                    // partial function application
                                    this.type = 'partial';
                                    this.arguments.push(node);
                                    advance('?');
                                } else this.arguments.push(expression(0));
                                if (node.id !== ',') break;
                                advance(',');
                            }
                            advance(")", true);
                            // if the name of the function is 'function' or λ, then this is function definition (lambda function)
                            if (left.type === 'name' && (left.value === 'function' || left.value === '\u03BB')) {
                                // all of the args must be VARIABLE tokens
                                this.arguments.forEach(function(arg, index) {
                                    if (arg.type !== 'variable') return handleError({
                                        code: "S0208",
                                        stack: new Error().stack,
                                        position: arg.position,
                                        token: arg.value,
                                        value: index + 1
                                    });
                                });
                                this.type = 'lambda';
                                // is the next token a '<' - if so, parse the function signature
                                if (node.id === '<') {
                                    var sigPos = node.position;
                                    var depth = 1;
                                    var sig = '<';
                                    while(depth > 0 && node.id !== '{' && node.id !== '(end)'){
                                        var tok = advance();
                                        if (tok.id === '>') depth--;
                                        else if (tok.id === '<') depth++;
                                        sig += tok.value;
                                    }
                                    advance('>');
                                    try {
                                        this.signature = parseSignature(sig);
                                    } catch (err) {
                                        // insert the position into this error
                                        err.position = sigPos + err.offset;
                                        return handleError(err);
                                    }
                                }
                                // parse the function body
                                advance('{');
                                this.body = expression(0);
                                advance('}');
                            }
                            return this;
                        });
                        // parenthesis - block expression
                        prefix("(", function() {
                            var expressions = [];
                            while(node.id !== ")"){
                                expressions.push(expression(0));
                                if (node.id !== ";") break;
                                advance(";");
                            }
                            advance(")", true);
                            this.type = 'block';
                            this.expressions = expressions;
                            return this;
                        });
                        // array constructor
                        prefix("[", function() {
                            var a = [];
                            if (node.id !== "]") for(;;){
                                var item = expression(0);
                                if (node.id === "..") {
                                    // range operator
                                    var range = {
                                        type: "binary",
                                        value: "..",
                                        position: node.position,
                                        lhs: item
                                    };
                                    advance("..");
                                    range.rhs = expression(0);
                                    item = range;
                                }
                                a.push(item);
                                if (node.id !== ",") break;
                                advance(",");
                            }
                            advance("]", true);
                            this.expressions = a;
                            this.type = "unary";
                            return this;
                        });
                        // filter - predicate or array index
                        infix("[", operators['['], function(left) {
                            if (node.id === "]") {
                                // empty predicate means maintain singleton arrays in the output
                                var step = left;
                                while(step && step.type === 'binary' && step.value === '[')step = step.lhs;
                                step.keepArray = true;
                                advance("]");
                                return left;
                            } else {
                                this.lhs = left;
                                this.rhs = expression(operators[']']);
                                this.type = 'binary';
                                advance("]", true);
                                return this;
                            }
                        });
                        // order-by
                        infix("^", operators['^'], function(left) {
                            advance("(");
                            var terms = [];
                            for(;;){
                                var term = {
                                    descending: false
                                };
                                if (node.id === "<") // ascending sort
                                advance("<");
                                else if (node.id === ">") {
                                    // descending sort
                                    term.descending = true;
                                    advance(">");
                                }
                                term.expression = expression(0);
                                terms.push(term);
                                if (node.id !== ",") break;
                                advance(",");
                            }
                            advance(")");
                            this.lhs = left;
                            this.rhs = terms;
                            this.type = 'binary';
                            return this;
                        });
                        var objectParser = function(left) {
                            var a = [];
                            if (node.id !== "}") for(;;){
                                var n = expression(0);
                                advance(":");
                                var v = expression(0);
                                a.push([
                                    n,
                                    v
                                ]); // holds an array of name/value expression pairs
                                if (node.id !== ",") break;
                                advance(",");
                            }
                            advance("}", true);
                            if (typeof left === 'undefined') {
                                // NUD - unary prefix form
                                this.lhs = a;
                                this.type = "unary";
                            } else {
                                // LED - binary infix form
                                this.lhs = left;
                                this.rhs = a;
                                this.type = 'binary';
                            }
                            return this;
                        };
                        // object constructor
                        prefix("{", objectParser);
                        // object grouping
                        infix("{", operators['{'], objectParser);
                        // bind variable
                        infixr(":=", operators[':='], function(left) {
                            if (left.type !== 'variable') return handleError({
                                code: "S0212",
                                stack: new Error().stack,
                                position: left.position,
                                token: left.value
                            });
                            this.lhs = left;
                            this.rhs = expression(operators[':='] - 1); // subtract 1 from bindingPower for right associative operators
                            this.type = "binary";
                            return this;
                        });
                        // focus variable bind
                        infix("@", operators['@'], function(left) {
                            this.lhs = left;
                            this.rhs = expression(operators['@']);
                            if (this.rhs.type !== 'variable') return handleError({
                                code: "S0214",
                                stack: new Error().stack,
                                position: this.rhs.position,
                                token: "@"
                            });
                            this.type = "binary";
                            return this;
                        });
                        // index (position) variable bind
                        infix("#", operators['#'], function(left) {
                            this.lhs = left;
                            this.rhs = expression(operators['#']);
                            if (this.rhs.type !== 'variable') return handleError({
                                code: "S0214",
                                stack: new Error().stack,
                                position: this.rhs.position,
                                token: "#"
                            });
                            this.type = "binary";
                            return this;
                        });
                        // if/then/else ternary operator ?:
                        infix("?", operators['?'], function(left) {
                            this.type = 'condition';
                            this.condition = left;
                            this.then = expression(0);
                            if (node.id === ':') {
                                // else condition
                                advance(":");
                                this.else = expression(0);
                            }
                            return this;
                        });
                        // object transformer
                        prefix("|", function() {
                            this.type = 'transform';
                            this.pattern = expression(0);
                            advance('|');
                            this.update = expression(0);
                            if (node.id === ',') {
                                advance(',');
                                this.delete = expression(0);
                            }
                            advance('|');
                            return this;
                        });
                        // tail call optimization
                        // this is invoked by the post parser to analyse lambda functions to see
                        // if they make a tail call.  If so, it is replaced by a thunk which will
                        // be invoked by the trampoline loop during function application.
                        // This enables tail-recursive functions to be written without growing the stack
                        var tailCallOptimize = function(expr) {
                            var result;
                            if (expr.type === 'function' && !expr.predicate) {
                                var thunk = {
                                    type: 'lambda',
                                    thunk: true,
                                    arguments: [],
                                    position: expr.position
                                };
                                thunk.body = expr;
                                result = thunk;
                            } else if (expr.type === 'condition') {
                                // analyse both branches
                                expr.then = tailCallOptimize(expr.then);
                                if (typeof expr.else !== 'undefined') expr.else = tailCallOptimize(expr.else);
                                result = expr;
                            } else if (expr.type === 'block') {
                                // only the last expression in the block
                                var length = expr.expressions.length;
                                if (length > 0) expr.expressions[length - 1] = tailCallOptimize(expr.expressions[length - 1]);
                                result = expr;
                            } else result = expr;
                            return result;
                        };
                        var ancestorLabel = 0;
                        var ancestorIndex = 0;
                        var ancestry = [];
                        var seekParent = function(node, slot) {
                            switch(node.type){
                                case 'name':
                                case 'wildcard':
                                    slot.level--;
                                    if (slot.level === 0) {
                                        if (typeof node.ancestor === 'undefined') node.ancestor = slot;
                                        else {
                                            // reuse the existing label
                                            ancestry[slot.index].slot.label = node.ancestor.label;
                                            node.ancestor = slot;
                                        }
                                        node.tuple = true;
                                    }
                                    break;
                                case 'parent':
                                    slot.level++;
                                    break;
                                case 'block':
                                    // look in last expression in the block
                                    if (node.expressions.length > 0) {
                                        node.tuple = true;
                                        slot = seekParent(node.expressions[node.expressions.length - 1], slot);
                                    }
                                    break;
                                case 'path':
                                    // last step in path
                                    node.tuple = true;
                                    var index = node.steps.length - 1;
                                    slot = seekParent(node.steps[index--], slot);
                                    while(slot.level > 0 && index >= 0)// check previous steps
                                    slot = seekParent(node.steps[index--], slot);
                                    break;
                                default:
                                    // error - can't derive ancestor
                                    throw {
                                        code: "S0217",
                                        token: node.type,
                                        position: node.position
                                    };
                            }
                            return slot;
                        };
                        var pushAncestry = function(result, value) {
                            if (typeof value.seekingParent !== 'undefined' || value.type === 'parent') {
                                var slots = typeof value.seekingParent !== 'undefined' ? value.seekingParent : [];
                                if (value.type === 'parent') slots.push(value.slot);
                                if (typeof result.seekingParent === 'undefined') result.seekingParent = slots;
                                else Array.prototype.push.apply(result.seekingParent, slots);
                            }
                        };
                        var resolveAncestry = function(path) {
                            var index = path.steps.length - 1;
                            var laststep = path.steps[index];
                            var slots = typeof laststep.seekingParent !== 'undefined' ? laststep.seekingParent : [];
                            if (laststep.type === 'parent') slots.push(laststep.slot);
                            for(var is = 0; is < slots.length; is++){
                                var slot = slots[is];
                                index = path.steps.length - 2;
                                while(slot.level > 0){
                                    if (index < 0) {
                                        if (typeof path.seekingParent === 'undefined') path.seekingParent = [
                                            slot
                                        ];
                                        else path.seekingParent.push(slot);
                                        break;
                                    }
                                    // try previous step
                                    var step = path.steps[index--];
                                    // multiple contiguous steps that bind the focus should be skipped
                                    while(index >= 0 && step.focus && path.steps[index].focus)step = path.steps[index--];
                                    slot = seekParent(step, slot);
                                }
                            }
                        };
                        // post-parse stage
                        // the purpose of this is to add as much semantic value to the parse tree as possible
                        // in order to simplify the work of the evaluator.
                        // This includes flattening the parts of the AST representing location paths,
                        // converting them to arrays of steps which in turn may contain arrays of predicates.
                        // following this, nodes containing '.' and '[' should be eliminated from the AST.
                        var processAST = function(expr) {
                            var result;
                            switch(expr.type){
                                case 'binary':
                                    switch(expr.value){
                                        case '.':
                                            var lstep = processAST(expr.lhs);
                                            if (lstep.type === 'path') result = lstep;
                                            else result = {
                                                type: 'path',
                                                steps: [
                                                    lstep
                                                ]
                                            };
                                            if (lstep.type === 'parent') result.seekingParent = [
                                                lstep.slot
                                            ];
                                            var rest = processAST(expr.rhs);
                                            if (rest.type === 'function' && rest.procedure.type === 'path' && rest.procedure.steps.length === 1 && rest.procedure.steps[0].type === 'name' && result.steps[result.steps.length - 1].type === 'function') // next function in chain of functions - will override a thenable
                                            result.steps[result.steps.length - 1].nextFunction = rest.procedure.steps[0].value;
                                            if (rest.type === 'path') Array.prototype.push.apply(result.steps, rest.steps);
                                            else {
                                                if (typeof rest.predicate !== 'undefined') {
                                                    rest.stages = rest.predicate;
                                                    delete rest.predicate;
                                                }
                                                result.steps.push(rest);
                                            }
                                            // any steps within a path that are string literals, should be changed to 'name'
                                            result.steps.filter(function(step) {
                                                if (step.type === 'number' || step.type === 'value') // don't allow steps to be numbers or the values true/false/null
                                                throw {
                                                    code: "S0213",
                                                    stack: new Error().stack,
                                                    position: step.position,
                                                    value: step.value
                                                };
                                                return step.type === 'string';
                                            }).forEach(function(lit) {
                                                lit.type = 'name';
                                            });
                                            // any step that signals keeping a singleton array, should be flagged on the path
                                            if (result.steps.filter(function(step) {
                                                return step.keepArray === true;
                                            }).length > 0) result.keepSingletonArray = true;
                                            // if first step is a path constructor, flag it for special handling
                                            var firststep = result.steps[0];
                                            if (firststep.type === 'unary' && firststep.value === '[') firststep.consarray = true;
                                            // if the last step is an array constructor, flag it so it doesn't flatten
                                            var laststep = result.steps[result.steps.length - 1];
                                            if (laststep.type === 'unary' && laststep.value === '[') laststep.consarray = true;
                                            resolveAncestry(result);
                                            break;
                                        case '[':
                                            // predicated step
                                            // LHS is a step or a predicated step
                                            // RHS is the predicate expr
                                            result = processAST(expr.lhs);
                                            var step = result;
                                            var type = 'predicate';
                                            if (result.type === 'path') {
                                                step = result.steps[result.steps.length - 1];
                                                type = 'stages';
                                            }
                                            if (typeof step.group !== 'undefined') throw {
                                                code: "S0209",
                                                stack: new Error().stack,
                                                position: expr.position
                                            };
                                            if (typeof step[type] === 'undefined') step[type] = [];
                                            var predicate = processAST(expr.rhs);
                                            if (typeof predicate.seekingParent !== 'undefined') {
                                                predicate.seekingParent.forEach((slot)=>{
                                                    if (slot.level === 1) seekParent(step, slot);
                                                    else slot.level--;
                                                });
                                                pushAncestry(step, predicate);
                                            }
                                            step[type].push({
                                                type: 'filter',
                                                expr: predicate,
                                                position: expr.position
                                            });
                                            break;
                                        case '{':
                                            // group-by
                                            // LHS is a step or a predicated step
                                            // RHS is the object constructor expr
                                            result = processAST(expr.lhs);
                                            if (typeof result.group !== 'undefined') throw {
                                                code: "S0210",
                                                stack: new Error().stack,
                                                position: expr.position
                                            };
                                            // object constructor - process each pair
                                            result.group = {
                                                lhs: expr.rhs.map(function(pair) {
                                                    return [
                                                        processAST(pair[0]),
                                                        processAST(pair[1])
                                                    ];
                                                }),
                                                position: expr.position
                                            };
                                            break;
                                        case '^':
                                            // order-by
                                            // LHS is the array to be ordered
                                            // RHS defines the terms
                                            result = processAST(expr.lhs);
                                            if (result.type !== 'path') result = {
                                                type: 'path',
                                                steps: [
                                                    result
                                                ]
                                            };
                                            var sortStep = {
                                                type: 'sort',
                                                position: expr.position
                                            };
                                            sortStep.terms = expr.rhs.map(function(terms) {
                                                var expression = processAST(terms.expression);
                                                pushAncestry(sortStep, expression);
                                                return {
                                                    descending: terms.descending,
                                                    expression: expression
                                                };
                                            });
                                            result.steps.push(sortStep);
                                            resolveAncestry(result);
                                            break;
                                        case ':=':
                                            result = {
                                                type: 'bind',
                                                value: expr.value,
                                                position: expr.position
                                            };
                                            result.lhs = processAST(expr.lhs);
                                            result.rhs = processAST(expr.rhs);
                                            pushAncestry(result, result.rhs);
                                            break;
                                        case '@':
                                            result = processAST(expr.lhs);
                                            step = result;
                                            if (result.type === 'path') step = result.steps[result.steps.length - 1];
                                            // throw error if there are any predicates defined at this point
                                            // at this point the only type of stages can be predicates
                                            if (typeof step.stages !== 'undefined' || typeof step.predicate !== 'undefined') throw {
                                                code: "S0215",
                                                stack: new Error().stack,
                                                position: expr.position
                                            };
                                            // also throw if this is applied after an 'order-by' clause
                                            if (step.type === 'sort') throw {
                                                code: "S0216",
                                                stack: new Error().stack,
                                                position: expr.position
                                            };
                                            if (expr.keepArray) step.keepArray = true;
                                            step.focus = expr.rhs.value;
                                            step.tuple = true;
                                            break;
                                        case '#':
                                            result = processAST(expr.lhs);
                                            step = result;
                                            if (result.type === 'path') step = result.steps[result.steps.length - 1];
                                            else {
                                                result = {
                                                    type: 'path',
                                                    steps: [
                                                        result
                                                    ]
                                                };
                                                if (typeof step.predicate !== 'undefined') {
                                                    step.stages = step.predicate;
                                                    delete step.predicate;
                                                }
                                            }
                                            if (typeof step.stages === 'undefined') step.index = expr.rhs.value;
                                            else step.stages.push({
                                                type: 'index',
                                                value: expr.rhs.value,
                                                position: expr.position
                                            });
                                            step.tuple = true;
                                            break;
                                        case '~>':
                                            result = {
                                                type: 'apply',
                                                value: expr.value,
                                                position: expr.position
                                            };
                                            result.lhs = processAST(expr.lhs);
                                            result.rhs = processAST(expr.rhs);
                                            break;
                                        default:
                                            result = {
                                                type: expr.type,
                                                value: expr.value,
                                                position: expr.position
                                            };
                                            result.lhs = processAST(expr.lhs);
                                            result.rhs = processAST(expr.rhs);
                                            pushAncestry(result, result.lhs);
                                            pushAncestry(result, result.rhs);
                                    }
                                    break;
                                case 'unary':
                                    result = {
                                        type: expr.type,
                                        value: expr.value,
                                        position: expr.position
                                    };
                                    if (expr.value === '[') // array constructor - process each item
                                    result.expressions = expr.expressions.map(function(item) {
                                        var value = processAST(item);
                                        pushAncestry(result, value);
                                        return value;
                                    });
                                    else if (expr.value === '{') // object constructor - process each pair
                                    result.lhs = expr.lhs.map(function(pair) {
                                        var key = processAST(pair[0]);
                                        pushAncestry(result, key);
                                        var value = processAST(pair[1]);
                                        pushAncestry(result, value);
                                        return [
                                            key,
                                            value
                                        ];
                                    });
                                    else {
                                        // all other unary expressions - just process the expression
                                        result.expression = processAST(expr.expression);
                                        // if unary minus on a number, then pre-process
                                        if (expr.value === '-' && result.expression.type === 'number') {
                                            result = result.expression;
                                            result.value = -result.value;
                                        } else pushAncestry(result, result.expression);
                                    }
                                    break;
                                case 'function':
                                case 'partial':
                                    result = {
                                        type: expr.type,
                                        name: expr.name,
                                        value: expr.value,
                                        position: expr.position
                                    };
                                    result.arguments = expr.arguments.map(function(arg) {
                                        var argAST = processAST(arg);
                                        pushAncestry(result, argAST);
                                        return argAST;
                                    });
                                    result.procedure = processAST(expr.procedure);
                                    break;
                                case 'lambda':
                                    result = {
                                        type: expr.type,
                                        arguments: expr.arguments,
                                        signature: expr.signature,
                                        position: expr.position
                                    };
                                    var body = processAST(expr.body);
                                    result.body = tailCallOptimize(body);
                                    break;
                                case 'condition':
                                    result = {
                                        type: expr.type,
                                        position: expr.position
                                    };
                                    result.condition = processAST(expr.condition);
                                    pushAncestry(result, result.condition);
                                    result.then = processAST(expr.then);
                                    pushAncestry(result, result.then);
                                    if (typeof expr.else !== 'undefined') {
                                        result.else = processAST(expr.else);
                                        pushAncestry(result, result.else);
                                    }
                                    break;
                                case 'transform':
                                    result = {
                                        type: expr.type,
                                        position: expr.position
                                    };
                                    result.pattern = processAST(expr.pattern);
                                    result.update = processAST(expr.update);
                                    if (typeof expr.delete !== 'undefined') result.delete = processAST(expr.delete);
                                    break;
                                case 'block':
                                    result = {
                                        type: expr.type,
                                        position: expr.position
                                    };
                                    // array of expressions - process each one
                                    result.expressions = expr.expressions.map(function(item) {
                                        var part = processAST(item);
                                        pushAncestry(result, part);
                                        if (part.consarray || part.type === 'path' && part.steps[0].consarray) result.consarray = true;
                                        return part;
                                    });
                                    break;
                                case 'name':
                                    result = {
                                        type: 'path',
                                        steps: [
                                            expr
                                        ]
                                    };
                                    if (expr.keepArray) result.keepSingletonArray = true;
                                    break;
                                case 'parent':
                                    result = {
                                        type: 'parent',
                                        slot: {
                                            label: '!' + ancestorLabel++,
                                            level: 1,
                                            index: ancestorIndex++
                                        }
                                    };
                                    ancestry.push(result);
                                    break;
                                case 'string':
                                case 'number':
                                case 'value':
                                case 'wildcard':
                                case 'descendant':
                                case 'variable':
                                case 'regex':
                                    result = expr;
                                    break;
                                case 'operator':
                                    // the tokens 'and' and 'or' might have been used as a name rather than an operator
                                    if (expr.value === 'and' || expr.value === 'or' || expr.value === 'in') {
                                        expr.type = 'name';
                                        result = processAST(expr);
                                    } else /* istanbul ignore else */ if (expr.value === '?') // partial application
                                    result = expr;
                                    else throw {
                                        code: "S0201",
                                        stack: new Error().stack,
                                        position: expr.position,
                                        token: expr.value
                                    };
                                    break;
                                case 'error':
                                    result = expr;
                                    if (expr.lhs) result = processAST(expr.lhs);
                                    break;
                                default:
                                    var code = "S0206";
                                    /* istanbul ignore else */ if (expr.id === '(end)') code = "S0207";
                                    var err = {
                                        code: code,
                                        position: expr.position,
                                        token: expr.value
                                    };
                                    if (recover) {
                                        errors.push(err);
                                        return {
                                            type: 'error',
                                            error: err
                                        };
                                    } else {
                                        err.stack = new Error().stack;
                                        throw err;
                                    }
                            }
                            if (expr.keepArray) result.keepArray = true;
                            return result;
                        };
                        // now invoke the tokenizer and the parser and return the syntax tree
                        lexer = tokenizer(source);
                        advance();
                        // parse the tokens
                        var expr = expression(0);
                        if (node.id !== '(end)') {
                            var err = {
                                code: "S0201",
                                position: node.position,
                                token: node.value
                            };
                            handleError(err);
                        }
                        expr = processAST(expr);
                        if (expr.type === 'parent' || typeof expr.seekingParent !== 'undefined') // error - trying to derive ancestor at top level
                        throw {
                            code: "S0217",
                            token: expr.type,
                            position: expr.position
                        };
                        if (errors.length > 0) expr.errors = errors;
                        return expr;
                    };
                    return parser;
                })();
                module1.exports = parser;
            },
            {
                "./signature": 5
            }
        ],
        5: [
            function(require1, module1, exports) {
                /**
 * © Copyright IBM Corp. 2016, 2018 All Rights Reserved
 *   Project name: JSONata
 *   This project is licensed under the MIT License, see LICENSE
 */ var utils = require1('./utils');
                const signature = (()=>{
                    'use strict';
                    // A mapping between the function signature symbols and the full plural of the type
                    // Expected to be used in error messages
                    var arraySignatureMapping = {
                        "a": "arrays",
                        "b": "booleans",
                        "f": "functions",
                        "n": "numbers",
                        "o": "objects",
                        "s": "strings"
                    };
                    /**
     * Parses a function signature definition and returns a validation function
     * @param {string} signature - the signature between the <angle brackets>
     * @returns {Function} validation function
     */ function parseSignature(signature) {
                        // create a Regex that represents this signature and return a function that when invoked,
                        // returns the validated (possibly fixed-up) arguments, or throws a validation error
                        // step through the signature, one symbol at a time
                        var position = 1;
                        var params = [];
                        var param = Object.create(null);
                        var prevParam = param;
                        while(position < signature.length){
                            var symbol = signature.charAt(position);
                            if (symbol === ':') break;
                            var next = function() {
                                params.push(param);
                                prevParam = param;
                                param = Object.create(null);
                            };
                            var findClosingBracket = function(str, start, openSymbol, closeSymbol) {
                                // returns the position of the closing symbol (e.g. bracket) in a string
                                // that balances the opening symbol at position start
                                var depth = 1;
                                var position = start;
                                while(position < str.length){
                                    position++;
                                    symbol = str.charAt(position);
                                    if (symbol === closeSymbol) {
                                        depth--;
                                        if (depth === 0) break; // out of while loop
                                    } else if (symbol === openSymbol) depth++;
                                }
                                return position;
                            };
                            switch(symbol){
                                case 's':
                                case 'n':
                                case 'b':
                                case 'l':
                                case 'o':
                                    param.regex = '[' + symbol + 'm]';
                                    param.type = symbol;
                                    next();
                                    break;
                                case 'a':
                                    //  normally treat any value as singleton array
                                    param.regex = '[asnblfom]';
                                    param.type = symbol;
                                    param.array = true;
                                    next();
                                    break;
                                case 'f':
                                    param.regex = 'f';
                                    param.type = symbol;
                                    next();
                                    break;
                                case 'j':
                                    param.regex = '[asnblom]';
                                    param.type = symbol;
                                    next();
                                    break;
                                case 'x':
                                    param.regex = '[asnblfom]';
                                    param.type = symbol;
                                    next();
                                    break;
                                case '-':
                                    prevParam.context = true;
                                    prevParam.contextRegex = new RegExp(prevParam.regex); // pre-compiled to test the context type at runtime
                                    prevParam.regex += '?';
                                    break;
                                case '?':
                                case '+':
                                    prevParam.regex += symbol;
                                    break;
                                case '(':
                                    // search forward for matching ')'
                                    var endParen = findClosingBracket(signature, position, '(', ')');
                                    var choice = signature.substring(position + 1, endParen);
                                    if (choice.indexOf('<') === -1) // no parameterized types, simple regex
                                    param.regex = '[' + choice + 'm]';
                                    else // TODO harder
                                    throw {
                                        code: "S0402",
                                        stack: new Error().stack,
                                        value: choice,
                                        offset: position
                                    };
                                    param.type = '(' + choice + ')';
                                    position = endParen;
                                    next();
                                    break;
                                case '<':
                                    if (prevParam.type === 'a' || prevParam.type === 'f') {
                                        // search forward for matching '>'
                                        var endPos = findClosingBracket(signature, position, '<', '>');
                                        prevParam.subtype = signature.substring(position + 1, endPos);
                                        position = endPos;
                                    } else throw {
                                        code: "S0401",
                                        stack: new Error().stack,
                                        value: prevParam.type,
                                        offset: position
                                    };
                                    break;
                            }
                            position++;
                        }
                        var regexStr = '^' + params.map(function(param) {
                            return '(' + param.regex + ')';
                        }).join('') + '$';
                        var regex = new RegExp(regexStr);
                        var getSymbol = function(value) {
                            var symbol;
                            if (utils.isFunction(value)) symbol = 'f';
                            else {
                                var type = typeof value;
                                switch(type){
                                    case 'string':
                                        symbol = 's';
                                        break;
                                    case 'number':
                                        symbol = 'n';
                                        break;
                                    case 'boolean':
                                        symbol = 'b';
                                        break;
                                    case 'object':
                                        if (value === null) symbol = 'l';
                                        else if (Array.isArray(value)) symbol = 'a';
                                        else symbol = 'o';
                                        break;
                                    case 'undefined':
                                    default:
                                        // any value can be undefined, but should be allowed to match
                                        symbol = 'm'; // m for missing
                                }
                            }
                            return symbol;
                        };
                        var throwValidationError = function(badArgs, badSig) {
                            // to figure out where this went wrong we need apply each component of the
                            // regex to each argument until we get to the one that fails to match
                            var partialPattern = '^';
                            var goodTo = 0;
                            for(var index = 0; index < params.length; index++){
                                partialPattern += params[index].regex;
                                var match = badSig.match(partialPattern);
                                if (match === null) // failed here
                                throw {
                                    code: "T0410",
                                    stack: new Error().stack,
                                    value: badArgs[goodTo],
                                    index: goodTo + 1
                                };
                                goodTo = match[0].length;
                            }
                            // if it got this far, it's probably because of extraneous arguments (we
                            // haven't added the trailing '$' in the regex yet.
                            throw {
                                code: "T0410",
                                stack: new Error().stack,
                                value: badArgs[goodTo],
                                index: goodTo + 1
                            };
                        };
                        return {
                            definition: signature,
                            validate: function(args, context) {
                                var suppliedSig = '';
                                args.forEach(function(arg) {
                                    suppliedSig += getSymbol(arg);
                                });
                                var isValid = regex.exec(suppliedSig);
                                if (isValid) {
                                    var validatedArgs = [];
                                    var argIndex = 0;
                                    params.forEach(function(param, index) {
                                        var arg = args[argIndex];
                                        var match = isValid[index + 1];
                                        if (match === '') {
                                            if (param.context && param.contextRegex) {
                                                // substitute context value for missing arg
                                                // first check that the context value is the right type
                                                var contextType = getSymbol(context);
                                                // test contextType against the regex for this arg (without the trailing ?)
                                                if (param.contextRegex.test(contextType)) validatedArgs.push(context);
                                                else // context value not compatible with this argument
                                                throw {
                                                    code: "T0411",
                                                    stack: new Error().stack,
                                                    value: context,
                                                    index: argIndex + 1
                                                };
                                            } else {
                                                validatedArgs.push(arg);
                                                argIndex++;
                                            }
                                        } else // may have matched multiple args (if the regex ends with a '+'
                                        // split into single tokens
                                        match.split('').forEach(function(single) {
                                            if (param.type === 'a') {
                                                if (single === 'm') // missing (undefined)
                                                arg = undefined;
                                                else {
                                                    arg = args[argIndex];
                                                    var arrayOK = true;
                                                    // is there type information on the contents of the array?
                                                    if (typeof param.subtype !== 'undefined') {
                                                        if (single !== 'a' && match !== param.subtype) arrayOK = false;
                                                        else if (single === 'a') {
                                                            if (arg.length > 0) {
                                                                var itemType = getSymbol(arg[0]);
                                                                if (itemType !== param.subtype.charAt(0)) arrayOK = false;
                                                                else {
                                                                    // make sure every item in the array is this type
                                                                    var differentItems = arg.filter(function(val) {
                                                                        return getSymbol(val) !== itemType;
                                                                    });
                                                                    arrayOK = differentItems.length === 0;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    if (!arrayOK) throw {
                                                        code: "T0412",
                                                        stack: new Error().stack,
                                                        value: arg,
                                                        index: argIndex + 1,
                                                        type: arraySignatureMapping[param.subtype]
                                                    };
                                                    // the function expects an array. If it's not one, make it so
                                                    if (single !== 'a') arg = [
                                                        arg
                                                    ];
                                                }
                                                validatedArgs.push(arg);
                                                argIndex++;
                                            } else {
                                                validatedArgs.push(arg);
                                                argIndex++;
                                            }
                                        });
                                    });
                                    return validatedArgs;
                                }
                                throwValidationError(args, suppliedSig);
                            }
                        };
                    }
                    return parseSignature;
                })();
                module1.exports = signature;
            },
            {
                "./utils": 6
            }
        ],
        6: [
            function(require1, module1, exports) {
                /**
 * © Copyright IBM Corp. 2016, 2018 All Rights Reserved
 *   Project name: JSONata
 *   This project is licensed under the MIT License, see LICENSE
 */ const utils = (()=>{
                    'use strict';
                    /**
     * Check if value is a finite number
     * @param {float} n - number to evaluate
     * @returns {boolean} True if n is a finite number
     */ function isNumeric(n) {
                        var isNum = false;
                        if (typeof n === 'number') {
                            isNum = !isNaN(n);
                            if (isNum && !isFinite(n)) throw {
                                code: "D1001",
                                value: n,
                                stack: new Error().stack
                            };
                        }
                        return isNum;
                    }
                    /**
     * Returns true if the arg is an array of strings
     * @param {*} arg - the item to test
     * @returns {boolean} True if arg is an array of strings
     */ function isArrayOfStrings(arg) {
                        var result = false;
                        /* istanbul ignore else */ if (Array.isArray(arg)) result = arg.filter(function(item) {
                            return typeof item !== 'string';
                        }).length === 0;
                        return result;
                    }
                    /**
     * Returns true if the arg is an array of numbers
     * @param {*} arg - the item to test
     * @returns {boolean} True if arg is an array of numbers
     */ function isArrayOfNumbers(arg) {
                        var result = false;
                        if (Array.isArray(arg)) result = arg.filter(function(item) {
                            return !isNumeric(item);
                        }).length === 0;
                        return result;
                    }
                    /**
     * Create an empty sequence to contain query results
     * @returns {Array} - empty sequence
     */ function createSequence() {
                        var sequence = [];
                        sequence.sequence = true;
                        if (arguments.length === 1) sequence.push(arguments[0]);
                        return sequence;
                    }
                    /**
     * Tests if a value is a sequence
     * @param {*} value the value to test
     * @returns {boolean} true if it's a sequence
     */ function isSequence(value) {
                        return value.sequence === true && Array.isArray(value);
                    }
                    /**
     *
     * @param {Object} arg - expression to test
     * @returns {boolean} - true if it is a function (lambda or built-in)
     */ function isFunction(arg) {
                        return arg && (arg._jsonata_function === true || arg._jsonata_lambda === true) || typeof arg === 'function';
                    }
                    /**
     * Returns the arity (number of arguments) of the function
     * @param {*} func - the function
     * @returns {*} - the arity
     */ function getFunctionArity(func) {
                        var arity = typeof func.arity === 'number' ? func.arity : typeof func.implementation === 'function' ? func.implementation.length : typeof func.length === 'number' ? func.length : func.arguments.length;
                        return arity;
                    }
                    /**
     * Tests whether arg is a lambda function
     * @param {*} arg - the value to test
     * @returns {boolean} - true if it is a lambda function
     */ function isLambda(arg) {
                        return arg && arg._jsonata_lambda === true;
                    }
                    // istanbul ignore next
                    var $Symbol = typeof Symbol === "function" ? Symbol : {};
                    // istanbul ignore next
                    var iteratorSymbol = $Symbol.iterator || "@@iterator";
                    /**
     * @param {Object} arg - expression to test
     * @returns {boolean} - true if it is iterable
     */ function isIterable(arg) {
                        return typeof arg === 'object' && arg !== null && iteratorSymbol in arg && 'next' in arg && typeof arg.next === 'function';
                    }
                    /**
     * Compares two values for equality
     * @param {*} lhs first value
     * @param {*} rhs second value
     * @returns {boolean} true if they are deep equal
     */ function isDeepEqual(lhs, rhs) {
                        if (lhs === rhs) return true;
                        if (typeof lhs === 'object' && typeof rhs === 'object' && lhs !== null && rhs !== null) {
                            if (Array.isArray(lhs) && Array.isArray(rhs)) {
                                // both arrays (or sequences)
                                // must be the same length
                                if (lhs.length !== rhs.length) return false;
                                // must contain same values in same order
                                for(var ii = 0; ii < lhs.length; ii++){
                                    if (!isDeepEqual(lhs[ii], rhs[ii])) return false;
                                }
                                return true;
                            }
                            // both objects
                            // must have the same set of keys (in any order)
                            var lkeys = Object.getOwnPropertyNames(lhs);
                            var rkeys = Object.getOwnPropertyNames(rhs);
                            if (lkeys.length !== rkeys.length) return false;
                            lkeys = lkeys.sort();
                            rkeys = rkeys.sort();
                            for(ii = 0; ii < lkeys.length; ii++){
                                if (lkeys[ii] !== rkeys[ii]) return false;
                            }
                            // must have the same values
                            for(ii = 0; ii < lkeys.length; ii++){
                                var key = lkeys[ii];
                                if (!isDeepEqual(lhs[key], rhs[key])) return false;
                            }
                            return true;
                        }
                        return false;
                    }
                    /**
     * converts a string to an array of characters
     * @param {string} str - the input string
     * @returns {Array} - the array of characters
     */ function stringToArray(str) {
                        var arr = [];
                        for (let char of str)arr.push(char);
                        return arr;
                    }
                    /**
     *
     * @param {Object} arg - the object to inspect
     * @returns {Array} - the keys (property names) of the object
     */ function keys(arg) {
                        return typeof arg === 'object' && arg !== null ? Object.keys(arg) : [];
                    }
                    return {
                        isNumeric: isNumeric,
                        isArrayOfStrings: isArrayOfStrings,
                        isArrayOfNumbers: isArrayOfNumbers,
                        createSequence: createSequence,
                        isSequence: isSequence,
                        isFunction: isFunction,
                        isLambda: isLambda,
                        isIterable: isIterable,
                        getFunctionArity: getFunctionArity,
                        isDeepEqual: isDeepEqual,
                        stringToArray: stringToArray,
                        keys: keys
                    };
                })();
                module1.exports = utils;
            },
            {}
        ]
    }, {}, [
        3
    ])(3);
});

});

parcelRegister("3osrl", function(module, exports) {
// Sample script to demonstrate extension of JSONATA with simple bitmask
// encoding and decoding functions.
//
// Three functions are added to JSONATA with the following signatures:
//
// ---------------------------------------------------------------------
// $encodeBitmask(array) - takes an array of boolean values and converts
//                         into a bitmask. Returns a number
// Sample:
//        [ true, false, false, true, false ]
//          2^0    2^1    2^2    2^3   2^4    = 9  ( 00001001 )
//
// Attention: first value in the array will be the right-most bit
//
// ---------------------------------------------------------------------
// $decodeBitmask(number, array) - takes a number and an array of strings
//                                 as arguments. Returns an object with keys
//                                 taken from the arrays and values being
//                                 booleans that result from the bitmask of
//                                 the key-position being applied to the number
//
// Sample: $decodeBitmask(9, ["ok", "alarm", "door", "powerOn", "warning"])
//                        ^
//                 00001001 -> 1      0         0        1         0
//
// { "ok": true, "alarm": false, "door": false, "powerOn": true, "warning": false }
//
// ---------------------------------------------------------------------
// $bitmask(number, index) - returns a boolean value depending on the bit at
//                           position <index> in <number> being set
//
// Sample: $bitmask(9, 3) -> true     $bitmask(9, 2) -> false
module.exports = {
    encodeBitmask: (values)=>values.reduce((res, v, i)=>res + Math.pow(2, i) * !!v, 0),
    decodeBitmask: (data, keys)=>keys.reduce((res, key, i)=>key === null ? res : {
                ...res,
                [key]: !!(data & 1 << i)
            }, {}),
    bitmask: (data, index)=>!!(data & 1 << index)
};

});



parcelRegister("lv0BB", function(module, exports) {

var $8fJ0j = parcelRequire("8fJ0j");
var $fa6cf6744b5b9d37$require$Buffer = $8fJ0j.Buffer;
function $fa6cf6744b5b9d37$var$_toBuffer(msg) {
    if ($fa6cf6744b5b9d37$require$Buffer.isBuffer(msg)) return msg;
    else if (typeof msg === 'number') return $fa6cf6744b5b9d37$require$Buffer.from([
        msg
    ]);
    else return $fa6cf6744b5b9d37$require$Buffer.from(msg);
}
class $fa6cf6744b5b9d37$var$Parse {
    static execute({ message: message, format: format = 'json' }) {
        try {
            switch(format){
                case 'json':
                    // safeguard to avoid confusion if message is already an object
                    if (typeof message === 'object' && message !== null) return message;
                    return JSON.parse(message);
                case 'utf8':
                    return message.toString();
                case 'boolean':
                    if ($fa6cf6744b5b9d37$require$Buffer.isBuffer(message)) return message.length > 0 ? !!message.readUInt8() : false;
                    else return !!message;
                case 'ascii':
                    return $fa6cf6744b5b9d37$var$_toBuffer(message).toString('ascii');
                case 'latin1':
                    return $fa6cf6744b5b9d37$var$_toBuffer(message).toString('latin1');
                case 'base64':
                case 'toBase64':
                    return $fa6cf6744b5b9d37$var$_toBuffer(message).toString('base64');
                case 'fromBase64':
                    return $fa6cf6744b5b9d37$require$Buffer.from($fa6cf6744b5b9d37$require$Buffer.isBuffer(message) ? message.toString() : message, 'base64');
                case 'int8':
                    return $fa6cf6744b5b9d37$var$_toBuffer(message).readInt8();
                case 'int16BE':
                    return $fa6cf6744b5b9d37$var$_toBuffer(message).readInt16BE();
                case 'int16LE':
                    return $fa6cf6744b5b9d37$var$_toBuffer(message).readInt16LE();
                case 'int32BE':
                    return $fa6cf6744b5b9d37$var$_toBuffer(message).readInt32BE();
                case 'int32LE':
                    return $fa6cf6744b5b9d37$var$_toBuffer(message).readInt32LE();
                case 'uint8':
                    return $fa6cf6744b5b9d37$var$_toBuffer(message).readUInt8();
                case 'uint16BE':
                    return $fa6cf6744b5b9d37$var$_toBuffer(message).readUInt16BE();
                case 'uint16LE':
                    return $fa6cf6744b5b9d37$var$_toBuffer(message).readUInt16LE();
                case 'uint32BE':
                    return $fa6cf6744b5b9d37$var$_toBuffer(message).readUInt32BE();
                case 'uint32LE':
                    return $fa6cf6744b5b9d37$var$_toBuffer(message).readUInt32LE();
                case 'floatBE':
                    return $fa6cf6744b5b9d37$var$_toBuffer(message).readFloatBE();
                case 'floatLE':
                    return $fa6cf6744b5b9d37$var$_toBuffer(message).readFloatLE();
                case 'doubleBE':
                    return $fa6cf6744b5b9d37$var$_toBuffer(message).readDoubleBE();
                case 'doubleLE':
                    return $fa6cf6744b5b9d37$var$_toBuffer(message).readDoubleLE();
                default:
                    return message;
            }
        } catch (err) {
            const newError = new Error(`Could not parse message of type ${typeof message} because: ${err.message}`);
            newError.extras = {
                prefix: `Could not parse message of type ${typeof message} because`,
                details: err.message
            };
            throw newError;
        }
    }
}
module.exports = $fa6cf6744b5b9d37$var$Parse;

});

parcelRegister("h92xw", function(module, exports) {
class $c7b53f40cf1e4387$var$Stash {
    static execute({ message: message, store: store, label: label = 'stash' }) {
        store[label] = message;
        return message;
    }
}
module.exports = $c7b53f40cf1e4387$var$Stash;

});

parcelRegister("jF4KS", function(module, exports) {

var $cNx6R = parcelRequire("cNx6R");
class $e50588eca3d17519$var$Transform {
    static execute(options) {
        return $cNx6R.execute(options);
    }
}
module.exports = $e50588eca3d17519$var$Transform;

});

parcelRegister("6ouYf", function(module, exports) {

var $cNx6R = parcelRequire("cNx6R");
class $4a7d022160713ae6$var$SetContextVars {
    static execute({ message: message, store: store, context: context, vars: vars, setMissingAsUndefined: setMissingAsUndefined = false }) {
        if (typeof vars !== 'object') {
            const err = new RangeError(`setContextVars rule called without 'vars' object property: ${vars}`);
            err.extras = {
                prefix: null,
                details: err.message
            };
            throw err;
        }
        for (const [key, value] of Object.entries(vars)){
            const result = $cNx6R.execute({
                message: message,
                store: store,
                context: context,
                expression: value
            });
            if (context && context.vars) {
                // Error checking, unless configured otherwise
                if (result === undefined && !setMissingAsUndefined) {
                    const err = new Error(`setContextVars rule should set context variable "${key}" from message property "${value}" but this is missing in the message: ${JSON.stringify(message)}`);
                    err.extras = {
                        prefix: null,
                        details: err.message
                    };
                    throw err;
                }
                // Store the result
                context.vars[key] = result;
            }
        }
        return message;
    }
}
module.exports = $4a7d022160713ae6$var$SetContextVars;

});

parcelRegister("9k4as", function(module, exports) {
class $6c9936ecc52294b6$var$Collect {
    static execute({ message: message, store: store, context: context, index: index }) {
        // Collect rule needs an stable storage so
        // we mutate the shared storage to include
        // that stable storage here.
        // TODO: for supporting multiple usages
        // of the collect rule at different RuleEngine
        // stages we could additionally pass the index
        // of the loop calling the rules to create an
        // additional storage level inside this property
        if (store.collectRule === undefined) store.collectRule = {};
        // We use an additional level to support multiple
        // usages of the collect rule
        if (store.collectRule[index] === undefined) store.collectRule[index] = {};
        // We write or overwrite the value into the last value cached object
        if (context.label) store.collectRule[index][context.label] = message;
        else store.collectRule[index][context.topic] = message;
        // return a copy to avoid additional mutations
        return {
            ...store.collectRule[index]
        };
    }
}
module.exports = $6c9936ecc52294b6$var$Collect;

});

parcelRegister("fFht9", function(module, exports) {
/*
 * Tries to evaluate if the input data could possibly be parsable JSON
 * @param {any} data The data to be processed
 * @returns {Boolean}
 */ 
var $8fJ0j = parcelRequire("8fJ0j");
var $b6783c5b71310ec9$require$Buffer = $8fJ0j.Buffer;
function $b6783c5b71310ec9$var$couldBeJsonParsable(data) {
    // SP(space),",0,1,2,3,4,5,6,7,8,9,t(rue),f(alse),[,{
    const VALID_JSON_STRING_STARTING_CHARS_AS_INT = [
        32,
        34,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        116,
        102,
        91,
        123
    ];
    const VALID_JSON_STARTING_CHARS = [
        ' ',
        '"',
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        't',
        'f',
        '[',
        '{'
    ];
    const isTypeBuffer = $b6783c5b71310ec9$require$Buffer.isBuffer(data);
    const isTypeString = typeof data === 'string';
    if (!isTypeString && !isTypeBuffer) return false;
    if (data.length <= 0) return false;
    if (isTypeBuffer && VALID_JSON_STRING_STARTING_CHARS_AS_INT.includes(data[0])) return true;
    return !!(isTypeString && VALID_JSON_STARTING_CHARS.includes(data[0]));
}
module.exports = {
    couldBeJsonParsable: $b6783c5b71310ec9$var$couldBeJsonParsable
};

});


var $593c1706cd7dc221$exports = {};
$parcel$extendImportMap({
    "gVijF": "Background.a2c91b78.png",
    "jWOtk": "logo.898354d5.png",
    "8Bxrl": "config.27705c16.json",
    "lLlqL": "MqttWorker.935ecec8.js"
});

var $2e41620b030ed79e$exports = {};
'use strict';

$2e41620b030ed79e$exports = (parcelRequire("1P95i"));


parcelRequire("h4Bez");
var $3966d42803f0ec68$exports = {};

$parcel$export($3966d42803f0ec68$exports, "createRoot", function () { return $3966d42803f0ec68$export$882461b6382ed46c; }, function (v) { return $3966d42803f0ec68$export$882461b6382ed46c = v; });
$parcel$export($3966d42803f0ec68$exports, "hydrateRoot", function () { return $3966d42803f0ec68$export$757ceba2d55c277e; }, function (v) { return $3966d42803f0ec68$export$757ceba2d55c277e = v; });
var $3966d42803f0ec68$export$882461b6382ed46c;
var $3966d42803f0ec68$export$757ceba2d55c277e;
'use strict';
var $68fd039c491aa2b2$exports = {};
'use strict';
function $68fd039c491aa2b2$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($68fd039c491aa2b2$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$68fd039c491aa2b2$var$checkDCE();

$68fd039c491aa2b2$exports = (parcelRequire("8HUvy"));


var $3966d42803f0ec68$var$i;
$3966d42803f0ec68$export$882461b6382ed46c = $68fd039c491aa2b2$exports.createRoot;
$3966d42803f0ec68$export$757ceba2d55c277e = $68fd039c491aa2b2$exports.hydrateRoot;


/**
 * Why is this not an arrow function?
 * @see https://github.com/microsoft/TypeScript/issues/34523
 */ function $14eddac5f20c576c$export$a7a9523472993e97(value, error) {
    if (!value) throw error;
}


const $091b76300838ede1$export$e470987fa2f20e6 = (date)=>date instanceof Date;
const $091b76300838ede1$export$3203edd9e5edd663 = (date)=>`${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
const $091b76300838ede1$export$3ae94a2503e890a1 = (date)=>`${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
const $091b76300838ede1$export$1c4ee043487b1d5e = (startDate, endDate)=>startDate !== null && endDate !== null && startDate.getTime() > endDate.getTime();
const $091b76300838ede1$export$3cda43bb863908d4 = (a, b)=>a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
const $091b76300838ede1$var$TIME_PATTERN = /^([01]\d|2[0-3]):([0-5]\d)$/;
const $091b76300838ede1$export$6195456a656da885 = (date, time)=>{
    const match = $091b76300838ede1$var$TIME_PATTERN.exec(time);
    if (!match) return undefined;
    const result = new Date(date.getTime());
    result.setHours(Number(match[1]), Number(match[2]), 0, 0);
    return result;
};
const $091b76300838ede1$export$bfdf65d751e28457 = (date)=>{
    const result = new Date(date.getTime());
    result.setSeconds(59, 999);
    return result;
};


var $3558c5f3ce25aa51$exports = {};
!function(e) {
    var t;
    $3558c5f3ce25aa51$exports = e();
}(function() {
    return (function r(o, i, u) {
        function s(n, e) {
            if (!i[n]) {
                if (!o[n]) {
                    var t = undefined;
                    if (!e && t) return t(n, !0);
                    if (a) return a(n, !0);
                    throw new Error("Cannot find module '" + n + "'");
                }
                e = i[n] = {
                    exports: {}
                };
                o[n][0].call(e.exports, function(e) {
                    var t = o[n][1][e];
                    return s(t || e);
                }, e, e.exports, r, o, i, u);
            }
            return i[n].exports;
        }
        for(var a = undefined, e = 0; e < u.length; e++)s(u[e]);
        return s;
    })({
        1: [
            function(w, b, m) {
                (function(e, n, s, c, d, h, p, g, y) {
                    "use strict";
                    var r = w("crypto");
                    function t(e, t) {
                        t = u(e, t);
                        var n;
                        return void 0 === (n = "passthrough" !== t.algorithm ? r.createHash(t.algorithm) : new l).write && (n.write = n.update, n.end = n.update), f(t, n).dispatch(e), n.update || n.end(""), n.digest ? n.digest("buffer" === t.encoding ? void 0 : t.encoding) : (e = n.read(), "buffer" !== t.encoding ? e.toString(t.encoding) : e);
                    }
                    (m = b.exports = t).sha1 = function(e) {
                        return t(e);
                    }, m.keys = function(e) {
                        return t(e, {
                            excludeValues: !0,
                            algorithm: "sha1",
                            encoding: "hex"
                        });
                    }, m.MD5 = function(e) {
                        return t(e, {
                            algorithm: "md5",
                            encoding: "hex"
                        });
                    }, m.keysMD5 = function(e) {
                        return t(e, {
                            algorithm: "md5",
                            encoding: "hex",
                            excludeValues: !0
                        });
                    };
                    var o = r.getHashes ? r.getHashes().slice() : [
                        "sha1",
                        "md5"
                    ], i = (o.push("passthrough"), [
                        "buffer",
                        "hex",
                        "binary",
                        "base64"
                    ]);
                    function u(e, t) {
                        var n = {};
                        if (n.algorithm = (t = t || {}).algorithm || "sha1", n.encoding = t.encoding || "hex", n.excludeValues = !!t.excludeValues, n.algorithm = n.algorithm.toLowerCase(), n.encoding = n.encoding.toLowerCase(), n.ignoreUnknown = !0 === t.ignoreUnknown, n.respectType = !1 !== t.respectType, n.respectFunctionNames = !1 !== t.respectFunctionNames, n.respectFunctionProperties = !1 !== t.respectFunctionProperties, n.unorderedArrays = !0 === t.unorderedArrays, n.unorderedSets = !1 !== t.unorderedSets, n.unorderedObjects = !1 !== t.unorderedObjects, n.replacer = t.replacer || void 0, n.excludeKeys = t.excludeKeys || void 0, void 0 === e) throw new Error("Object argument required.");
                        for(var r = 0; r < o.length; ++r)o[r].toLowerCase() === n.algorithm.toLowerCase() && (n.algorithm = o[r]);
                        if (-1 === o.indexOf(n.algorithm)) throw new Error('Algorithm "' + n.algorithm + '"  not supported. supported values: ' + o.join(", "));
                        if (-1 === i.indexOf(n.encoding) && "passthrough" !== n.algorithm) throw new Error('Encoding "' + n.encoding + '"  not supported. supported values: ' + i.join(", "));
                        return n;
                    }
                    function a(e) {
                        if ("function" == typeof e) return null != /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(e));
                    }
                    function f(o, t, i) {
                        i = i || [];
                        function u(e) {
                            return t.update ? t.update(e, "utf8") : t.write(e, "utf8");
                        }
                        return {
                            dispatch: function(e) {
                                return this["_" + (null === (e = o.replacer ? o.replacer(e) : e) ? "null" : typeof e)](e);
                            },
                            _object: function(t) {
                                var n, e = Object.prototype.toString.call(t), r = /\[object (.*)\]/i.exec(e);
                                r = (r = r ? r[1] : "unknown:[" + e + "]").toLowerCase();
                                if (0 <= (e = i.indexOf(t))) return this.dispatch("[CIRCULAR:" + e + "]");
                                if (i.push(t), void 0 !== s && s.isBuffer && s.isBuffer(t)) return u("buffer:"), u(t);
                                if ("object" === r || "function" === r || "asyncfunction" === r) return e = Object.keys(t), o.unorderedObjects && (e = e.sort()), !1 === o.respectType || a(t) || e.splice(0, 0, "prototype", "__proto__", "constructor"), o.excludeKeys && (e = e.filter(function(e) {
                                    return !o.excludeKeys(e);
                                })), u("object:" + e.length + ":"), n = this, e.forEach(function(e) {
                                    n.dispatch(e), u(":"), o.excludeValues || n.dispatch(t[e]), u(",");
                                });
                                if (!this["_" + r]) {
                                    if (o.ignoreUnknown) return u("[" + r + "]");
                                    throw new Error('Unknown object type "' + r + '"');
                                }
                                this["_" + r](t);
                            },
                            _array: function(e, t) {
                                t = void 0 !== t ? t : !1 !== o.unorderedArrays;
                                var n = this;
                                if (u("array:" + e.length + ":"), !t || e.length <= 1) return e.forEach(function(e) {
                                    return n.dispatch(e);
                                });
                                var r = [], t = e.map(function(e) {
                                    var t = new l, n = i.slice();
                                    return f(o, t, n).dispatch(e), r = r.concat(n.slice(i.length)), t.read().toString();
                                });
                                return i = i.concat(r), t.sort(), this._array(t, !1);
                            },
                            _date: function(e) {
                                return u("date:" + e.toJSON());
                            },
                            _symbol: function(e) {
                                return u("symbol:" + e.toString());
                            },
                            _error: function(e) {
                                return u("error:" + e.toString());
                            },
                            _boolean: function(e) {
                                return u("bool:" + e.toString());
                            },
                            _string: function(e) {
                                u("string:" + e.length + ":"), u(e.toString());
                            },
                            _function: function(e) {
                                u("fn:"), a(e) ? this.dispatch("[native]") : this.dispatch(e.toString()), !1 !== o.respectFunctionNames && this.dispatch("function-name:" + String(e.name)), o.respectFunctionProperties && this._object(e);
                            },
                            _number: function(e) {
                                return u("number:" + e.toString());
                            },
                            _xml: function(e) {
                                return u("xml:" + e.toString());
                            },
                            _null: function() {
                                return u("Null");
                            },
                            _undefined: function() {
                                return u("Undefined");
                            },
                            _regexp: function(e) {
                                return u("regex:" + e.toString());
                            },
                            _uint8array: function(e) {
                                return u("uint8array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint8clampedarray: function(e) {
                                return u("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int8array: function(e) {
                                return u("int8array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint16array: function(e) {
                                return u("uint16array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int16array: function(e) {
                                return u("int16array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint32array: function(e) {
                                return u("uint32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int32array: function(e) {
                                return u("int32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _float32array: function(e) {
                                return u("float32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _float64array: function(e) {
                                return u("float64array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _arraybuffer: function(e) {
                                return u("arraybuffer:"), this.dispatch(new Uint8Array(e));
                            },
                            _url: function(e) {
                                return u("url:" + e.toString());
                            },
                            _map: function(e) {
                                u("map:");
                                e = Array.from(e);
                                return this._array(e, !1 !== o.unorderedSets);
                            },
                            _set: function(e) {
                                u("set:");
                                e = Array.from(e);
                                return this._array(e, !1 !== o.unorderedSets);
                            },
                            _file: function(e) {
                                return u("file:"), this.dispatch([
                                    e.name,
                                    e.size,
                                    e.type,
                                    e.lastModfied
                                ]);
                            },
                            _blob: function() {
                                if (o.ignoreUnknown) return u("[blob]");
                                throw Error('Hashing Blob objects is currently not supported\n(see https://github.com/puleos/object-hash/issues/26)\nUse "options.replacer" or "options.ignoreUnknown"\n');
                            },
                            _domwindow: function() {
                                return u("domwindow");
                            },
                            _bigint: function(e) {
                                return u("bigint:" + e.toString());
                            },
                            _process: function() {
                                return u("process");
                            },
                            _timer: function() {
                                return u("timer");
                            },
                            _pipe: function() {
                                return u("pipe");
                            },
                            _tcp: function() {
                                return u("tcp");
                            },
                            _udp: function() {
                                return u("udp");
                            },
                            _tty: function() {
                                return u("tty");
                            },
                            _statwatcher: function() {
                                return u("statwatcher");
                            },
                            _securecontext: function() {
                                return u("securecontext");
                            },
                            _connection: function() {
                                return u("connection");
                            },
                            _zlib: function() {
                                return u("zlib");
                            },
                            _context: function() {
                                return u("context");
                            },
                            _nodescript: function() {
                                return u("nodescript");
                            },
                            _httpparser: function() {
                                return u("httpparser");
                            },
                            _dataview: function() {
                                return u("dataview");
                            },
                            _signal: function() {
                                return u("signal");
                            },
                            _fsevent: function() {
                                return u("fsevent");
                            },
                            _tlswrap: function() {
                                return u("tlswrap");
                            }
                        };
                    }
                    function l() {
                        return {
                            buf: "",
                            write: function(e) {
                                this.buf += e;
                            },
                            end: function(e) {
                                this.buf += e;
                            },
                            read: function() {
                                return this.buf;
                            }
                        };
                    }
                    m.writeToStream = function(e, t, n) {
                        return void 0 === n && (n = t, t = {}), f(t = u(e, t), n).dispatch(e);
                    };
                }).call(this, w("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, w("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
            },
            {
                buffer: 3,
                crypto: 5,
                lYpoI2: 11
            }
        ],
        2: [
            function(e, t, f) {
                (function(e, t, n, r, o, i, u, s, a) {
                    !function(e) {
                        "use strict";
                        var a = "undefined" != typeof Uint8Array ? Uint8Array : Array, t = "+".charCodeAt(0), n = "/".charCodeAt(0), r = "0".charCodeAt(0), o = "a".charCodeAt(0), i = "A".charCodeAt(0), u = "-".charCodeAt(0), s = "_".charCodeAt(0);
                        function f(e) {
                            e = e.charCodeAt(0);
                            return e === t || e === u ? 62 : e === n || e === s ? 63 : e < r ? -1 : e < r + 10 ? e - r + 26 + 26 : e < i + 26 ? e - i : e < o + 26 ? e - o + 26 : void 0;
                        }
                        e.toByteArray = function(e) {
                            var t, n;
                            if (0 < e.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
                            var r = e.length, r = "=" === e.charAt(r - 2) ? 2 : "=" === e.charAt(r - 1) ? 1 : 0, o = new a(3 * e.length / 4 - r), i = 0 < r ? e.length - 4 : e.length, u = 0;
                            function s(e) {
                                o[u++] = e;
                            }
                            for(t = 0; t < i; t += 4)s((16711680 & (n = f(e.charAt(t)) << 18 | f(e.charAt(t + 1)) << 12 | f(e.charAt(t + 2)) << 6 | f(e.charAt(t + 3)))) >> 16), s((65280 & n) >> 8), s(255 & n);
                            return 2 == r ? s(255 & (n = f(e.charAt(t)) << 2 | f(e.charAt(t + 1)) >> 4)) : 1 == r && (s((n = f(e.charAt(t)) << 10 | f(e.charAt(t + 1)) << 4 | f(e.charAt(t + 2)) >> 2) >> 8 & 255), s(255 & n)), o;
                        }, e.fromByteArray = function(e) {
                            var t, n, r, o, i = e.length % 3, u = "";
                            function s(e) {
                                return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(e);
                            }
                            for(t = 0, r = e.length - i; t < r; t += 3)n = (e[t] << 16) + (e[t + 1] << 8) + e[t + 2], u += s((o = n) >> 18 & 63) + s(o >> 12 & 63) + s(o >> 6 & 63) + s(63 & o);
                            switch(i){
                                case 1:
                                    u = (u += s((n = e[e.length - 1]) >> 2)) + s(n << 4 & 63) + "==";
                                    break;
                                case 2:
                                    u = (u = (u += s((n = (e[e.length - 2] << 8) + e[e.length - 1]) >> 10)) + s(n >> 4 & 63)) + s(n << 2 & 63) + "=";
                            }
                            return u;
                        };
                    }(void 0 === f ? this.base64js = {} : f);
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        3: [
            function(O, e, H) {
                (function(e, n, f, r, h, p, g, y, w) {
                    var a = O("base64-js"), i = O("ieee754");
                    function f(e, t, n) {
                        if (!(this instanceof f)) return new f(e, t, n);
                        var r, o, i, u, s = typeof e;
                        if ("base64" === t && "string" == s) for(e = (u = e).trim ? u.trim() : u.replace(/^\s+|\s+$/g, ""); e.length % 4 != 0;)e += "=";
                        if ("number" == s) r = j(e);
                        else if ("string" == s) r = f.byteLength(e, t);
                        else {
                            if ("object" != s) throw new Error("First argument needs to be a number, array or string.");
                            r = j(e.length);
                        }
                        if (f._useTypedArrays ? o = f._augment(new Uint8Array(r)) : ((o = this).length = r, o._isBuffer = !0), f._useTypedArrays && "number" == typeof e.byteLength) o._set(e);
                        else if (C(u = e) || f.isBuffer(u) || u && "object" == typeof u && "number" == typeof u.length) for(i = 0; i < r; i++)f.isBuffer(e) ? o[i] = e.readUInt8(i) : o[i] = e[i];
                        else if ("string" == s) o.write(e, 0, t);
                        else if ("number" == s && !f._useTypedArrays && !n) for(i = 0; i < r; i++)o[i] = 0;
                        return o;
                    }
                    function b(e, t, n, r) {
                        return f._charsWritten = c(function(e) {
                            for(var t = [], n = 0; n < e.length; n++)t.push(255 & e.charCodeAt(n));
                            return t;
                        }(t), e, n, r);
                    }
                    function m(e, t, n, r) {
                        return f._charsWritten = c(function(e) {
                            for(var t, n, r = [], o = 0; o < e.length; o++)n = e.charCodeAt(o), t = n >> 8, n = n % 256, r.push(n), r.push(t);
                            return r;
                        }(t), e, n, r);
                    }
                    function v(e, t, n) {
                        var r = "";
                        n = Math.min(e.length, n);
                        for(var o = t; o < n; o++)r += String.fromCharCode(e[o]);
                        return r;
                    }
                    function o(e, t, n, r) {
                        r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 1 < e.length, "Trying to read beyond buffer length"));
                        var o, r = e.length;
                        if (!(r <= t)) return n ? (o = e[t], t + 1 < r && (o |= e[t + 1] << 8)) : (o = e[t] << 8, t + 1 < r && (o |= e[t + 1])), o;
                    }
                    function u(e, t, n, r) {
                        r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 3 < e.length, "Trying to read beyond buffer length"));
                        var o, r = e.length;
                        if (!(r <= t)) return n ? (t + 2 < r && (o = e[t + 2] << 16), t + 1 < r && (o |= e[t + 1] << 8), o |= e[t], t + 3 < r && (o += e[t + 3] << 24 >>> 0)) : (t + 1 < r && (o = e[t + 1] << 16), t + 2 < r && (o |= e[t + 2] << 8), t + 3 < r && (o |= e[t + 3]), o += e[t] << 24 >>> 0), o;
                    }
                    function _(e, t, n, r) {
                        if (r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 1 < e.length, "Trying to read beyond buffer length")), !(e.length <= t)) return r = o(e, t, n, !0), 32768 & r ? -1 * (65535 - r + 1) : r;
                    }
                    function E(e, t, n, r) {
                        if (r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 3 < e.length, "Trying to read beyond buffer length")), !(e.length <= t)) return r = u(e, t, n, !0), 2147483648 & r ? -1 * (4294967295 - r + 1) : r;
                    }
                    function I(e, t, n, r) {
                        return r || (d("boolean" == typeof n, "missing or invalid endian"), d(t + 3 < e.length, "Trying to read beyond buffer length")), i.read(e, t, n, 23, 4);
                    }
                    function A(e, t, n, r) {
                        return r || (d("boolean" == typeof n, "missing or invalid endian"), d(t + 7 < e.length, "Trying to read beyond buffer length")), i.read(e, t, n, 52, 8);
                    }
                    function s(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 1 < e.length, "trying to write beyond buffer length"), Y(t, 65535));
                        o = e.length;
                        if (!(o <= n)) for(var i = 0, u = Math.min(o - n, 2); i < u; i++)e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
                    }
                    function l(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "trying to write beyond buffer length"), Y(t, 4294967295));
                        o = e.length;
                        if (!(o <= n)) for(var i = 0, u = Math.min(o - n, 4); i < u; i++)e[n + i] = t >>> 8 * (r ? i : 3 - i) & 255;
                    }
                    function B(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 1 < e.length, "Trying to write beyond buffer length"), F(t, 32767, -32768)), e.length <= n || s(e, 0 <= t ? t : 65535 + t + 1, n, r, o);
                    }
                    function L(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "Trying to write beyond buffer length"), F(t, 2147483647, -2147483648)), e.length <= n || l(e, 0 <= t ? t : 4294967295 + t + 1, n, r, o);
                    }
                    function U(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "Trying to write beyond buffer length"), D(t, 34028234663852886e22, -340282346638528860000000000000000000000)), e.length <= n || i.write(e, t, n, r, 23, 4);
                    }
                    function x(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 7 < e.length, "Trying to write beyond buffer length"), D(t, 17976931348623157e292, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000)), e.length <= n || i.write(e, t, n, r, 52, 8);
                    }
                    H.Buffer = f, H.SlowBuffer = f, H.INSPECT_MAX_BYTES = 50, f.poolSize = 8192, f._useTypedArrays = function() {
                        try {
                            var e = new ArrayBuffer(0), t = new Uint8Array(e);
                            return t.foo = function() {
                                return 42;
                            }, 42 === t.foo() && "function" == typeof t.subarray;
                        } catch (e) {
                            return !1;
                        }
                    }(), f.isEncoding = function(e) {
                        switch(String(e).toLowerCase()){
                            case "hex":
                            case "utf8":
                            case "utf-8":
                            case "ascii":
                            case "binary":
                            case "base64":
                            case "raw":
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                return !0;
                            default:
                                return !1;
                        }
                    }, f.isBuffer = function(e) {
                        return !(null == e || !e._isBuffer);
                    }, f.byteLength = function(e, t) {
                        var n;
                        switch(e += "", t || "utf8"){
                            case "hex":
                                n = e.length / 2;
                                break;
                            case "utf8":
                            case "utf-8":
                                n = T(e).length;
                                break;
                            case "ascii":
                            case "binary":
                            case "raw":
                                n = e.length;
                                break;
                            case "base64":
                                n = M(e).length;
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                n = 2 * e.length;
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return n;
                    }, f.concat = function(e, t) {
                        if (d(C(e), "Usage: Buffer.concat(list, [totalLength])\nlist should be an Array."), 0 === e.length) return new f(0);
                        if (1 === e.length) return e[0];
                        if ("number" != typeof t) for(o = t = 0; o < e.length; o++)t += e[o].length;
                        for(var n = new f(t), r = 0, o = 0; o < e.length; o++){
                            var i = e[o];
                            i.copy(n, r), r += i.length;
                        }
                        return n;
                    }, f.prototype.write = function(e, t, n, r) {
                        isFinite(t) ? isFinite(n) || (r = n, n = void 0) : (a = r, r = t, t = n, n = a), t = Number(t) || 0;
                        var o, i, u, s, a = this.length - t;
                        switch((!n || a < (n = Number(n))) && (n = a), r = String(r || "utf8").toLowerCase()){
                            case "hex":
                                o = function(e, t, n, r) {
                                    n = Number(n) || 0;
                                    var o = e.length - n;
                                    (!r || o < (r = Number(r))) && (r = o), d((o = t.length) % 2 == 0, "Invalid hex string"), o / 2 < r && (r = o / 2);
                                    for(var i = 0; i < r; i++){
                                        var u = parseInt(t.substr(2 * i, 2), 16);
                                        d(!isNaN(u), "Invalid hex string"), e[n + i] = u;
                                    }
                                    return f._charsWritten = 2 * i, i;
                                }(this, e, t, n);
                                break;
                            case "utf8":
                            case "utf-8":
                                i = this, u = t, s = n, o = f._charsWritten = c(T(e), i, u, s);
                                break;
                            case "ascii":
                            case "binary":
                                o = b(this, e, t, n);
                                break;
                            case "base64":
                                i = this, u = t, s = n, o = f._charsWritten = c(M(e), i, u, s);
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                o = m(this, e, t, n);
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return o;
                    }, f.prototype.toString = function(e, t, n) {
                        var r, o, i, u, s = this;
                        if (e = String(e || "utf8").toLowerCase(), t = Number(t) || 0, (n = void 0 !== n ? Number(n) : s.length) === t) return "";
                        switch(e){
                            case "hex":
                                r = function(e, t, n) {
                                    var r = e.length;
                                    (!t || t < 0) && (t = 0);
                                    (!n || n < 0 || r < n) && (n = r);
                                    for(var o = "", i = t; i < n; i++)o += k(e[i]);
                                    return o;
                                }(s, t, n);
                                break;
                            case "utf8":
                            case "utf-8":
                                r = function(e, t, n) {
                                    var r = "", o = "";
                                    n = Math.min(e.length, n);
                                    for(var i = t; i < n; i++)e[i] <= 127 ? (r += N(o) + String.fromCharCode(e[i]), o = "") : o += "%" + e[i].toString(16);
                                    return r + N(o);
                                }(s, t, n);
                                break;
                            case "ascii":
                            case "binary":
                                r = v(s, t, n);
                                break;
                            case "base64":
                                o = s, u = n, r = 0 === (i = t) && u === o.length ? a.fromByteArray(o) : a.fromByteArray(o.slice(i, u));
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                r = function(e, t, n) {
                                    for(var r = e.slice(t, n), o = "", i = 0; i < r.length; i += 2)o += String.fromCharCode(r[i] + 256 * r[i + 1]);
                                    return o;
                                }(s, t, n);
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return r;
                    }, f.prototype.toJSON = function() {
                        return {
                            type: "Buffer",
                            data: Array.prototype.slice.call(this._arr || this, 0)
                        };
                    }, f.prototype.copy = function(e, t, n, r) {
                        if (t = t || 0, (r = r || 0 === r ? r : this.length) !== (n = n || 0) && 0 !== e.length && 0 !== this.length) {
                            d(n <= r, "sourceEnd < sourceStart"), d(0 <= t && t < e.length, "targetStart out of bounds"), d(0 <= n && n < this.length, "sourceStart out of bounds"), d(0 <= r && r <= this.length, "sourceEnd out of bounds"), r > this.length && (r = this.length);
                            var o = (r = e.length - t < r - n ? e.length - t + n : r) - n;
                            if (o < 100 || !f._useTypedArrays) for(var i = 0; i < o; i++)e[i + t] = this[i + n];
                            else e._set(this.subarray(n, n + o), t);
                        }
                    }, f.prototype.slice = function(e, t) {
                        var n = this.length;
                        if (e = S(e, n, 0), t = S(t, n, n), f._useTypedArrays) return f._augment(this.subarray(e, t));
                        for(var r = t - e, o = new f(r, void 0, !0), i = 0; i < r; i++)o[i] = this[i + e];
                        return o;
                    }, f.prototype.get = function(e) {
                        return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(e);
                    }, f.prototype.set = function(e, t) {
                        return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(e, t);
                    }, f.prototype.readUInt8 = function(e, t) {
                        if (t || (d(null != e, "missing offset"), d(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length)) return this[e];
                    }, f.prototype.readUInt16LE = function(e, t) {
                        return o(this, e, !0, t);
                    }, f.prototype.readUInt16BE = function(e, t) {
                        return o(this, e, !1, t);
                    }, f.prototype.readUInt32LE = function(e, t) {
                        return u(this, e, !0, t);
                    }, f.prototype.readUInt32BE = function(e, t) {
                        return u(this, e, !1, t);
                    }, f.prototype.readInt8 = function(e, t) {
                        if (t || (d(null != e, "missing offset"), d(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length)) return 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                    }, f.prototype.readInt16LE = function(e, t) {
                        return _(this, e, !0, t);
                    }, f.prototype.readInt16BE = function(e, t) {
                        return _(this, e, !1, t);
                    }, f.prototype.readInt32LE = function(e, t) {
                        return E(this, e, !0, t);
                    }, f.prototype.readInt32BE = function(e, t) {
                        return E(this, e, !1, t);
                    }, f.prototype.readFloatLE = function(e, t) {
                        return I(this, e, !0, t);
                    }, f.prototype.readFloatBE = function(e, t) {
                        return I(this, e, !1, t);
                    }, f.prototype.readDoubleLE = function(e, t) {
                        return A(this, e, !0, t);
                    }, f.prototype.readDoubleBE = function(e, t) {
                        return A(this, e, !1, t);
                    }, f.prototype.writeUInt8 = function(e, t, n) {
                        n || (d(null != e, "missing value"), d(null != t, "missing offset"), d(t < this.length, "trying to write beyond buffer length"), Y(e, 255)), t >= this.length || (this[t] = e);
                    }, f.prototype.writeUInt16LE = function(e, t, n) {
                        s(this, e, t, !0, n);
                    }, f.prototype.writeUInt16BE = function(e, t, n) {
                        s(this, e, t, !1, n);
                    }, f.prototype.writeUInt32LE = function(e, t, n) {
                        l(this, e, t, !0, n);
                    }, f.prototype.writeUInt32BE = function(e, t, n) {
                        l(this, e, t, !1, n);
                    }, f.prototype.writeInt8 = function(e, t, n) {
                        n || (d(null != e, "missing value"), d(null != t, "missing offset"), d(t < this.length, "Trying to write beyond buffer length"), F(e, 127, -128)), t >= this.length || (0 <= e ? this.writeUInt8(e, t, n) : this.writeUInt8(255 + e + 1, t, n));
                    }, f.prototype.writeInt16LE = function(e, t, n) {
                        B(this, e, t, !0, n);
                    }, f.prototype.writeInt16BE = function(e, t, n) {
                        B(this, e, t, !1, n);
                    }, f.prototype.writeInt32LE = function(e, t, n) {
                        L(this, e, t, !0, n);
                    }, f.prototype.writeInt32BE = function(e, t, n) {
                        L(this, e, t, !1, n);
                    }, f.prototype.writeFloatLE = function(e, t, n) {
                        U(this, e, t, !0, n);
                    }, f.prototype.writeFloatBE = function(e, t, n) {
                        U(this, e, t, !1, n);
                    }, f.prototype.writeDoubleLE = function(e, t, n) {
                        x(this, e, t, !0, n);
                    }, f.prototype.writeDoubleBE = function(e, t, n) {
                        x(this, e, t, !1, n);
                    }, f.prototype.fill = function(e, t, n) {
                        if (t = t || 0, n = n || this.length, d("number" == typeof (e = "string" == typeof (e = e || 0) ? e.charCodeAt(0) : e) && !isNaN(e), "value is not a number"), d(t <= n, "end < start"), n !== t && 0 !== this.length) {
                            d(0 <= t && t < this.length, "start out of bounds"), d(0 <= n && n <= this.length, "end out of bounds");
                            for(var r = t; r < n; r++)this[r] = e;
                        }
                    }, f.prototype.inspect = function() {
                        for(var e = [], t = this.length, n = 0; n < t; n++)if (e[n] = k(this[n]), n === H.INSPECT_MAX_BYTES) {
                            e[n + 1] = "...";
                            break;
                        }
                        return "<Buffer " + e.join(" ") + ">";
                    }, f.prototype.toArrayBuffer = function() {
                        if ("undefined" == typeof Uint8Array) throw new Error("Buffer.toArrayBuffer not supported in this browser");
                        if (f._useTypedArrays) return new f(this).buffer;
                        for(var e = new Uint8Array(this.length), t = 0, n = e.length; t < n; t += 1)e[t] = this[t];
                        return e.buffer;
                    };
                    var t = f.prototype;
                    function S(e, t, n) {
                        return "number" != typeof e ? n : t <= (e = ~~e) ? t : 0 <= e || 0 <= (e += t) ? e : 0;
                    }
                    function j(e) {
                        return (e = ~~Math.ceil(+e)) < 0 ? 0 : e;
                    }
                    function C(e) {
                        return (Array.isArray || function(e) {
                            return "[object Array]" === Object.prototype.toString.call(e);
                        })(e);
                    }
                    function k(e) {
                        return e < 16 ? "0" + e.toString(16) : e.toString(16);
                    }
                    function T(e) {
                        for(var t = [], n = 0; n < e.length; n++){
                            var r = e.charCodeAt(n);
                            if (r <= 127) t.push(e.charCodeAt(n));
                            else for(var o = n, i = (55296 <= r && r <= 57343 && n++, encodeURIComponent(e.slice(o, n + 1)).substr(1).split("%")), u = 0; u < i.length; u++)t.push(parseInt(i[u], 16));
                        }
                        return t;
                    }
                    function M(e) {
                        return a.toByteArray(e);
                    }
                    function c(e, t, n, r) {
                        for(var o = 0; o < r && !(o + n >= t.length || o >= e.length); o++)t[o + n] = e[o];
                        return o;
                    }
                    function N(e) {
                        try {
                            return decodeURIComponent(e);
                        } catch (e) {
                            return String.fromCharCode(65533);
                        }
                    }
                    function Y(e, t) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(0 <= e, "specified a negative value for writing an unsigned value"), d(e <= t, "value is larger than maximum value for type"), d(Math.floor(e) === e, "value has a fractional component");
                    }
                    function F(e, t, n) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(e <= t, "value larger than maximum allowed value"), d(n <= e, "value smaller than minimum allowed value"), d(Math.floor(e) === e, "value has a fractional component");
                    }
                    function D(e, t, n) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(e <= t, "value larger than maximum allowed value"), d(n <= e, "value smaller than minimum allowed value");
                    }
                    function d(e, t) {
                        if (!e) throw new Error(t || "Failed assertion");
                    }
                    f._augment = function(e) {
                        return e._isBuffer = !0, e._get = e.get, e._set = e.set, e.get = t.get, e.set = t.set, e.write = t.write, e.toString = t.toString, e.toLocaleString = t.toString, e.toJSON = t.toJSON, e.copy = t.copy, e.slice = t.slice, e.readUInt8 = t.readUInt8, e.readUInt16LE = t.readUInt16LE, e.readUInt16BE = t.readUInt16BE, e.readUInt32LE = t.readUInt32LE, e.readUInt32BE = t.readUInt32BE, e.readInt8 = t.readInt8, e.readInt16LE = t.readInt16LE, e.readInt16BE = t.readInt16BE, e.readInt32LE = t.readInt32LE, e.readInt32BE = t.readInt32BE, e.readFloatLE = t.readFloatLE, e.readFloatBE = t.readFloatBE, e.readDoubleLE = t.readDoubleLE, e.readDoubleBE = t.readDoubleBE, e.writeUInt8 = t.writeUInt8, e.writeUInt16LE = t.writeUInt16LE, e.writeUInt16BE = t.writeUInt16BE, e.writeUInt32LE = t.writeUInt32LE, e.writeUInt32BE = t.writeUInt32BE, e.writeInt8 = t.writeInt8, e.writeInt16LE = t.writeInt16LE, e.writeInt16BE = t.writeInt16BE, e.writeInt32LE = t.writeInt32LE, e.writeInt32BE = t.writeInt32BE, e.writeFloatLE = t.writeFloatLE, e.writeFloatBE = t.writeFloatBE, e.writeDoubleLE = t.writeDoubleLE, e.writeDoubleBE = t.writeDoubleBE, e.fill = t.fill, e.inspect = t.inspect, e.toArrayBuffer = t.toArrayBuffer, e;
                    };
                }).call(this, O("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, O("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
            },
            {
                "base64-js": 2,
                buffer: 3,
                ieee754: 10,
                lYpoI2: 11
            }
        ],
        4: [
            function(c, d, e) {
                (function(e, t, a, n, r, o, i, u, s) {
                    var a = c("buffer").Buffer, f = 4, l = new a(f);
                    l.fill(0);
                    d.exports = {
                        hash: function(e, t, n, r) {
                            for(var o = t(function(e, t) {
                                e.length % f != 0 && (n = e.length + (f - e.length % f), e = a.concat([
                                    e,
                                    l
                                ], n));
                                for(var n, r = [], o = t ? e.readInt32BE : e.readInt32LE, i = 0; i < e.length; i += f)r.push(o.call(e, i));
                                return r;
                            }(e = a.isBuffer(e) ? e : new a(e), r), 8 * e.length), t = r, i = new a(n), u = t ? i.writeInt32BE : i.writeInt32LE, s = 0; s < o.length; s++)u.call(i, o[s], 4 * s, !0);
                            return i;
                        }
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        5: [
            function(v, e, _) {
                (function(l, c, u, d, h, p, g, y, w) {
                    var u = v("buffer").Buffer, e = v("./sha"), t = v("./sha256"), n = v("./rng"), b = {
                        sha1: e,
                        sha256: t,
                        md5: v("./md5")
                    }, s = 64, a = new u(s);
                    function r(e, n) {
                        var r = b[e = e || "sha1"], o = [];
                        return r || i("algorithm:", e, "is not yet supported"), {
                            update: function(e) {
                                return u.isBuffer(e) || (e = new u(e)), o.push(e), e.length, this;
                            },
                            digest: function(e) {
                                var t = u.concat(o), t = n ? function(e, t, n) {
                                    u.isBuffer(t) || (t = new u(t)), u.isBuffer(n) || (n = new u(n)), t.length > s ? t = e(t) : t.length < s && (t = u.concat([
                                        t,
                                        a
                                    ], s));
                                    for(var r = new u(s), o = new u(s), i = 0; i < s; i++)r[i] = 54 ^ t[i], o[i] = 92 ^ t[i];
                                    return n = e(u.concat([
                                        r,
                                        n
                                    ])), e(u.concat([
                                        o,
                                        n
                                    ]));
                                }(r, n, t) : r(t);
                                return o = null, e ? t.toString(e) : t;
                            }
                        };
                    }
                    function i() {
                        var e = [].slice.call(arguments).join(" ");
                        throw new Error([
                            e,
                            "we accept pull requests",
                            "http://github.com/dominictarr/crypto-browserify"
                        ].join("\n"));
                    }
                    a.fill(0), _.createHash = function(e) {
                        return r(e);
                    }, _.createHmac = r, _.randomBytes = function(e, t) {
                        if (!t || !t.call) return new u(n(e));
                        try {
                            t.call(this, void 0, new u(n(e)));
                        } catch (e) {
                            t(e);
                        }
                    };
                    var o, f = [
                        "createCredentials",
                        "createCipher",
                        "createCipheriv",
                        "createDecipher",
                        "createDecipheriv",
                        "createSign",
                        "createVerify",
                        "createDiffieHellman",
                        "pbkdf2"
                    ], m = function(e) {
                        _[e] = function() {
                            i("sorry,", e, "is not implemented yet");
                        };
                    };
                    for(o in f)m(f[o], o);
                }).call(this, v("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, v("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./md5": 6,
                "./rng": 7,
                "./sha": 8,
                "./sha256": 9,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        6: [
            function(w, b, e) {
                (function(e, r, o, i, u, a, f, l, y) {
                    var t = w("./helpers");
                    function n(e, t) {
                        e[t >> 5] |= 128 << t % 32, e[14 + (t + 64 >>> 9 << 4)] = t;
                        for(var n = 1732584193, r = -271733879, o = -1732584194, i = 271733878, u = 0; u < e.length; u += 16){
                            var s = n, a = r, f = o, l = i, n = c(n, r, o, i, e[u + 0], 7, -680876936), i = c(i, n, r, o, e[u + 1], 12, -389564586), o = c(o, i, n, r, e[u + 2], 17, 606105819), r = c(r, o, i, n, e[u + 3], 22, -1044525330);
                            n = c(n, r, o, i, e[u + 4], 7, -176418897), i = c(i, n, r, o, e[u + 5], 12, 1200080426), o = c(o, i, n, r, e[u + 6], 17, -1473231341), r = c(r, o, i, n, e[u + 7], 22, -45705983), n = c(n, r, o, i, e[u + 8], 7, 1770035416), i = c(i, n, r, o, e[u + 9], 12, -1958414417), o = c(o, i, n, r, e[u + 10], 17, -42063), r = c(r, o, i, n, e[u + 11], 22, -1990404162), n = c(n, r, o, i, e[u + 12], 7, 1804603682), i = c(i, n, r, o, e[u + 13], 12, -40341101), o = c(o, i, n, r, e[u + 14], 17, -1502002290), n = d(n, r = c(r, o, i, n, e[u + 15], 22, 1236535329), o, i, e[u + 1], 5, -165796510), i = d(i, n, r, o, e[u + 6], 9, -1069501632), o = d(o, i, n, r, e[u + 11], 14, 643717713), r = d(r, o, i, n, e[u + 0], 20, -373897302), n = d(n, r, o, i, e[u + 5], 5, -701558691), i = d(i, n, r, o, e[u + 10], 9, 38016083), o = d(o, i, n, r, e[u + 15], 14, -660478335), r = d(r, o, i, n, e[u + 4], 20, -405537848), n = d(n, r, o, i, e[u + 9], 5, 568446438), i = d(i, n, r, o, e[u + 14], 9, -1019803690), o = d(o, i, n, r, e[u + 3], 14, -187363961), r = d(r, o, i, n, e[u + 8], 20, 1163531501), n = d(n, r, o, i, e[u + 13], 5, -1444681467), i = d(i, n, r, o, e[u + 2], 9, -51403784), o = d(o, i, n, r, e[u + 7], 14, 1735328473), n = h(n, r = d(r, o, i, n, e[u + 12], 20, -1926607734), o, i, e[u + 5], 4, -378558), i = h(i, n, r, o, e[u + 8], 11, -2022574463), o = h(o, i, n, r, e[u + 11], 16, 1839030562), r = h(r, o, i, n, e[u + 14], 23, -35309556), n = h(n, r, o, i, e[u + 1], 4, -1530992060), i = h(i, n, r, o, e[u + 4], 11, 1272893353), o = h(o, i, n, r, e[u + 7], 16, -155497632), r = h(r, o, i, n, e[u + 10], 23, -1094730640), n = h(n, r, o, i, e[u + 13], 4, 681279174), i = h(i, n, r, o, e[u + 0], 11, -358537222), o = h(o, i, n, r, e[u + 3], 16, -722521979), r = h(r, o, i, n, e[u + 6], 23, 76029189), n = h(n, r, o, i, e[u + 9], 4, -640364487), i = h(i, n, r, o, e[u + 12], 11, -421815835), o = h(o, i, n, r, e[u + 15], 16, 530742520), n = p(n, r = h(r, o, i, n, e[u + 2], 23, -995338651), o, i, e[u + 0], 6, -198630844), i = p(i, n, r, o, e[u + 7], 10, 1126891415), o = p(o, i, n, r, e[u + 14], 15, -1416354905), r = p(r, o, i, n, e[u + 5], 21, -57434055), n = p(n, r, o, i, e[u + 12], 6, 1700485571), i = p(i, n, r, o, e[u + 3], 10, -1894986606), o = p(o, i, n, r, e[u + 10], 15, -1051523), r = p(r, o, i, n, e[u + 1], 21, -2054922799), n = p(n, r, o, i, e[u + 8], 6, 1873313359), i = p(i, n, r, o, e[u + 15], 10, -30611744), o = p(o, i, n, r, e[u + 6], 15, -1560198380), r = p(r, o, i, n, e[u + 13], 21, 1309151649), n = p(n, r, o, i, e[u + 4], 6, -145523070), i = p(i, n, r, o, e[u + 11], 10, -1120210379), o = p(o, i, n, r, e[u + 2], 15, 718787259), r = p(r, o, i, n, e[u + 9], 21, -343485551), n = g(n, s), r = g(r, a), o = g(o, f), i = g(i, l);
                        }
                        return Array(n, r, o, i);
                    }
                    function s(e, t, n, r, o, i) {
                        return g((t = g(g(t, e), g(r, i))) << o | t >>> 32 - o, n);
                    }
                    function c(e, t, n, r, o, i, u) {
                        return s(t & n | ~t & r, e, t, o, i, u);
                    }
                    function d(e, t, n, r, o, i, u) {
                        return s(t & r | n & ~r, e, t, o, i, u);
                    }
                    function h(e, t, n, r, o, i, u) {
                        return s(t ^ n ^ r, e, t, o, i, u);
                    }
                    function p(e, t, n, r, o, i, u) {
                        return s(n ^ (t | ~r), e, t, o, i, u);
                    }
                    function g(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    b.exports = function(e) {
                        return t.hash(e, n, 16);
                    };
                }).call(this, w("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, w("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        7: [
            function(e, l, t) {
                (function(e, t, n, r, o, i, u, s, f) {
                    var a;
                    l.exports = a || function(e) {
                        for(var t, n = new Array(e), r = 0; r < e; r++)0 == (3 & r) && (t = 4294967296 * Math.random()), n[r] = t >>> ((3 & r) << 3) & 255;
                        return n;
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        8: [
            function(c, d, e) {
                (function(e, t, n, r, o, s, a, f, l) {
                    var i = c("./helpers");
                    function u(l, c) {
                        l[c >> 5] |= 128 << 24 - c % 32, l[15 + (c + 64 >> 9 << 4)] = c;
                        for(var e, t, n, r = Array(80), o = 1732584193, i = -271733879, u = -1732584194, s = 271733878, d = -1009589776, h = 0; h < l.length; h += 16){
                            for(var p = o, g = i, y = u, w = s, b = d, a = 0; a < 80; a++){
                                r[a] = a < 16 ? l[h + a] : v(r[a - 3] ^ r[a - 8] ^ r[a - 14] ^ r[a - 16], 1);
                                var f = m(m(v(o, 5), (f = i, t = u, n = s, (e = a) < 20 ? f & t | ~f & n : !(e < 40) && e < 60 ? f & t | f & n | t & n : f ^ t ^ n)), m(m(d, r[a]), (e = a) < 20 ? 1518500249 : e < 40 ? 1859775393 : e < 60 ? -1894007588 : -899497514)), d = s, s = u, u = v(i, 30), i = o, o = f;
                            }
                            o = m(o, p), i = m(i, g), u = m(u, y), s = m(s, w), d = m(d, b);
                        }
                        return Array(o, i, u, s, d);
                    }
                    function m(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    function v(e, t) {
                        return e << t | e >>> 32 - t;
                    }
                    d.exports = function(e) {
                        return i.hash(e, u, 20, !0);
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        9: [
            function(c, d, e) {
                (function(e, t, n, r, u, s, a, f, l) {
                    function b(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    function o(e, l) {
                        var c, d = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), t = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), n = new Array(64);
                        e[l >> 5] |= 128 << 24 - l % 32, e[15 + (l + 64 >> 9 << 4)] = l;
                        for(var r, o, h = 0; h < e.length; h += 16){
                            for(var i = t[0], u = t[1], s = t[2], p = t[3], a = t[4], g = t[5], y = t[6], w = t[7], f = 0; f < 64; f++)n[f] = f < 16 ? e[f + h] : b(b(b((o = n[f - 2], m(o, 17) ^ m(o, 19) ^ v(o, 10)), n[f - 7]), (o = n[f - 15], m(o, 7) ^ m(o, 18) ^ v(o, 3))), n[f - 16]), c = b(b(b(b(w, m(o = a, 6) ^ m(o, 11) ^ m(o, 25)), a & g ^ ~a & y), d[f]), n[f]), r = b(m(r = i, 2) ^ m(r, 13) ^ m(r, 22), i & u ^ i & s ^ u & s), w = y, y = g, g = a, a = b(p, c), p = s, s = u, u = i, i = b(c, r);
                            t[0] = b(i, t[0]), t[1] = b(u, t[1]), t[2] = b(s, t[2]), t[3] = b(p, t[3]), t[4] = b(a, t[4]), t[5] = b(g, t[5]), t[6] = b(y, t[6]), t[7] = b(w, t[7]);
                        }
                        return t;
                    }
                    var i = c("./helpers"), m = function(e, t) {
                        return e >>> t | e << 32 - t;
                    }, v = function(e, t) {
                        return e >>> t;
                    };
                    d.exports = function(e) {
                        return i.hash(e, o, 32, !0);
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        10: [
            function(e, t, f) {
                (function(e, t, n, r, o, i, u, s, a) {
                    f.read = function(e, t, n, r, o) {
                        var i, u, l = 8 * o - r - 1, c = (1 << l) - 1, d = c >> 1, s = -7, a = n ? o - 1 : 0, f = n ? -1 : 1, o = e[t + a];
                        for(a += f, i = o & (1 << -s) - 1, o >>= -s, s += l; 0 < s; i = 256 * i + e[t + a], a += f, s -= 8);
                        for(u = i & (1 << -s) - 1, i >>= -s, s += r; 0 < s; u = 256 * u + e[t + a], a += f, s -= 8);
                        if (0 === i) i = 1 - d;
                        else {
                            if (i === c) return u ? NaN : 1 / 0 * (o ? -1 : 1);
                            u += Math.pow(2, r), i -= d;
                        }
                        return (o ? -1 : 1) * u * Math.pow(2, i - r);
                    }, f.write = function(e, t, l, n, r, c) {
                        var o, i, u = 8 * c - r - 1, s = (1 << u) - 1, a = s >> 1, d = 23 === r ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : c - 1, h = n ? 1 : -1, c = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                        for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (i = isNaN(t) ? 1 : 0, o = s) : (o = Math.floor(Math.log(t) / Math.LN2), t * (n = Math.pow(2, -o)) < 1 && (o--, n *= 2), 2 <= (t += 1 <= o + a ? d / n : d * Math.pow(2, 1 - a)) * n && (o++, n /= 2), s <= o + a ? (i = 0, o = s) : 1 <= o + a ? (i = (t * n - 1) * Math.pow(2, r), o += a) : (i = t * Math.pow(2, a - 1) * Math.pow(2, r), o = 0)); 8 <= r; e[l + f] = 255 & i, f += h, i /= 256, r -= 8);
                        for(o = o << r | i, u += r; 0 < u; e[l + f] = 255 & o, f += h, o /= 256, u -= 8);
                        e[l + f - h] |= 128 * c;
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        11: [
            function(e, h, t) {
                (function(e, t, n, r, o, f, l, c, d) {
                    var i, u, s;
                    function a() {}
                    (e = h.exports = {}).nextTick = (u = "undefined" != typeof window && window.setImmediate, s = "undefined" != typeof window && window.postMessage && window.addEventListener, u ? function(e) {
                        return window.setImmediate(e);
                    } : s ? (i = [], window.addEventListener("message", function(e) {
                        var t = e.source;
                        t !== window && null !== t || "process-tick" !== e.data || (e.stopPropagation(), 0 < i.length && i.shift()());
                    }, !0), function(e) {
                        i.push(e), window.postMessage("process-tick", "*");
                    }) : function(e) {
                        setTimeout(e, 0);
                    }), e.title = "browser", e.browser = !0, e.env = {}, e.argv = [], e.on = a, e.addListener = a, e.once = a, e.off = a, e.removeListener = a, e.removeAllListeners = a, e.emit = a, e.binding = function(e) {
                        throw new Error("process.binding is not supported");
                    }, e.cwd = function() {
                        return "/";
                    }, e.chdir = function(e) {
                        throw new Error("process.chdir is not supported");
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ]
    }, {}, [
        1
    ])(1);
});


class $39a8095e56de6b13$export$94affb487e701bf2 {
    constructor(hash = (0, (/*@__PURE__*/$parcel$interopDefault($3558c5f3ce25aa51$exports)))){
        this.hash = hash;
        this.cache = new Map();
    }
    get(fetcher, ...hashable) {
        /** Get hash key */ const hash = this.hash(hashable);
        /** Use pre loaded or fetch */ const cached = this.cache.has(hash) ? this.cache.get(hash) : fetcher();
        /** Store on cache */ this.cache.set(hash, cached);
        return cached;
    }
}


const $ea3ab9f98af64a6e$export$6f6534ba0edb1cf4 = (error, func)=>Error.captureStackTrace && Error.captureStackTrace(error, func);
const $ea3ab9f98af64a6e$export$3a769f39d361ea9a = (error, func)=>{
    $ea3ab9f98af64a6e$export$6f6534ba0edb1cf4(error, func);
    return error;
};
const $ea3ab9f98af64a6e$export$7914be4505ea8cc6 = (error, func)=>{
    $ea3ab9f98af64a6e$export$6f6534ba0edb1cf4(error, func);
    throw error;
};





const $65583c3760a483fc$export$2b5e8179047d3ac4 = (e)=>{
    const getEnumValuesSet = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>new Set(Object.values(e)));
    return (v)=>getEnumValuesSet().has(v);
};




/**
 * Generates a delta between the two given arrays
 *
 * Relies on reference equality for delta creation
 * If the same object is sent twice, it will be referenced only once
 */ const $9bfc602ec92faf4d$export$eabbe41f409ce55b = (before, after)=>{
    const beforeSet = new Set(before);
    const afterSet = new Set(after);
    const eitherSet = new Set([
        ...before,
        ...after
    ]);
    const removed = [];
    const notUpdated = [];
    const added = [];
    eitherSet.forEach((i)=>{
        const beforeHas = beforeSet.has(i);
        const afterHas = afterSet.has(i);
        if (beforeHas === afterHas) // Nothing has changed
        notUpdated.push(i);
        else if (afterHas) // Something has changed and it was added
        added.push(i);
        else // Last alternative
        removed.push(i);
    });
    return [
        removed,
        notUpdated,
        added
    ];
};


const $0b21958d2ab6642d$export$cf8d5bedcfe04f6 = (a, b, config = {})=>{
    if (a === b) return true;
    const { sort: sort, equals: equals = (a, b)=>a === b } = config;
    let aCopy = a;
    let bCopy = b;
    if (sort !== false) {
        // Copy arrays before sorting
        aCopy = [
            ...aCopy
        ];
        bCopy = [
            ...bCopy
        ];
        aCopy.sort(sort);
        bCopy.sort(sort);
    }
    return aCopy.length === bCopy.length && aCopy.every((aElement, k)=>aCopy === bCopy[k] || equals(aElement, bCopy[k]));
};


const $9f70c141ac08ef9a$export$a079a83b07f794bf = (arr)=>arr.length > 0;
const $9f70c141ac08ef9a$export$109d9d261d61ca16 = (arr)=>arr[arr.length - 1];


const $36fb5ff0bd6498d5$export$226b3eccf92c9ed9 = Array.isArray;
const $36fb5ff0bd6498d5$export$2dabafa86f11ed64 = (array, predicate)=>$36fb5ff0bd6498d5$export$226b3eccf92c9ed9(array) && array.every(predicate);


const $e407acf04d9c2f7e$export$6a29ade99f81ec8a = Object.entries;


const $beec4324cbd609ea$export$6b4e15ccdc547ae7 = (func, functionName)=>{
    const aux = {
        [functionName]: (...args)=>func(...args)
    };
    return aux[functionName];
};




const $d7e4c4d4cdf468fc$var$createPropertySorter = (...[toNumber, asc = true])=>(a, b)=>(toNumber(a) - toNumber(b)) * (asc ? 1 : -1);
const $d7e4c4d4cdf468fc$export$fe9afbcb954a8fa = (configuration, name)=>{
    const getEntries = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>(0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(configuration).filter((pair)=>pair[1] !== false));
    return (0, $beec4324cbd609ea$export$6b4e15ccdc547ae7)((a, b)=>{
        let order = 0;
        for (const [prop, sorter] of getEntries()){
            let internalSorter = sorter;
            if ((0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(internalSorter)) /**
                 * Simple config was used
                 */ internalSorter = $d7e4c4d4cdf468fc$var$createPropertySorter(...sorter);
            order = internalSorter(a[prop], b[prop]);
            if (order !== 0) break;
        }
        return order;
    }, name);
};




const $2ae70427bab197d4$export$12b617052eb9d30e = (original, ...keys)=>{
    const copy = {
        ...original
    };
    for (const k of keys)// eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete copy[k];
    return copy;
};
const $2ae70427bab197d4$export$ed97f33186d4b816 = Object.keys;
const $2ae70427bab197d4$export$dd1bc94b04021eeb = (obj)=>!(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)($2ae70427bab197d4$export$ed97f33186d4b816(obj));



const $3b4a6a32782da93b$export$b1fe116b2fdda743 = (generator, retryOnError = false)=>{
    let result = null;
    const handler = (...args)=>{
        if (!result || retryOnError && result[1]) try {
            const value = generator(...args);
            result = [
                value,
                false
            ];
            if (value instanceof Promise) /**
                     * If the yielded value is a promise, flag it as an error once it rejects
                     */ value.catch(()=>{
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                result = [
                    value,
                    true
                ];
            });
        } catch (e) {
            result = [
                e,
                true
            ];
        }
        const [value, isError] = result;
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(!isError, value);
        return value;
    };
    handler.clear = ()=>{
        result = null;
    };
    return handler;
};



const $33cff95ba235ba3b$export$596273409274759 = (a, b, config = {})=>{
    if (a === b) return true;
    const aKeys = (0, $2ae70427bab197d4$export$ed97f33186d4b816)(a);
    const bKeys = (0, $2ae70427bab197d4$export$ed97f33186d4b816)(b);
    if (!(0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(aKeys, bKeys)) return false;
    const { equals: equals } = config;
    for(let i = 0; i < aKeys.length; i++){
        const currKey = aKeys[i];
        const aValue = a[currKey];
        const bValue = b[currKey];
        if (aValue !== bValue && (equals ? !equals(aValue, bValue, currKey) : true)) return false;
    }
    return true;
};
const $33cff95ba235ba3b$export$9701e92d714bc6a7 = (a, b)=>{
    if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) return a === b;
    return $33cff95ba235ba3b$export$596273409274759(a, b, {
        equals: $33cff95ba235ba3b$export$9701e92d714bc6a7
    });
};



const $66f4d76e5f79376d$export$8afc0f4daad61937 = (object)=>object !== null && typeof object === 'object' && !(0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(object);




/**
 * This is a utility class to assist with asynchronous usage of assets
 */ class $092680ba287ef87d$export$423ec2075359570a {
    get isDropped() {
        return this.dropped;
    }
    execute() {
        if (!this.dropped) return;
        /**
         * Make copy of callbacks
         */ const callbacks = Array.from(this.callbacks);
        /**
         * Drop all listed callbacks
         */ this.callbacks.clear();
        /**
         * Execute all callbacks
         */ callbacks.forEach((callback)=>callback());
    }
    drop() {
        this.dropped = true;
        this.execute();
    }
    onDrop(callback) {
        this.callbacks.add(callback);
        this.execute();
    }
    ifNotDropped(callback) {
        if (!this.dropped) return callback();
    }
    constructor(){
        this.callbacks = new Set();
        this.dropped = false;
    }
}





const $d4622374f48a4eef$export$b8b121e6edf70f49 = 500;
const $d4622374f48a4eef$var$calculateTimeLeft = (targetTimestamp)=>targetTimestamp - Date.now();
const $d4622374f48a4eef$var$createSimpleTimeout = (callback, time)=>{
    const id = setTimeout(callback, time);
    return ()=>clearTimeout(id);
};
const $d4622374f48a4eef$export$6eae7cf7a129a986 = (callback, timeOrDate)=>{
    const timestamp = typeof timeOrDate === 'number' ? timeOrDate + Date.now() : timeOrDate.getTime();
    const timerStoppers = [];
    /**
     * Stop all timers and clear them for further execution
     */ const stopAndClear = ()=>{
        for (const stopper of timerStoppers)stopper();
        timerStoppers.splice(0);
    };
    if ($d4622374f48a4eef$var$calculateTimeLeft(timestamp) < $d4622374f48a4eef$export$b8b121e6edf70f49) /**
         * Time given is under threshold, no reason to do anything fancy
         */ timerStoppers.push($d4622374f48a4eef$var$createSimpleTimeout(callback, $d4622374f48a4eef$var$calculateTimeLeft(timestamp)));
    else /**
         * Time given is above threhsold, so setup a timer to re-check it often enough
         * Every cycle then, further check if execution has fallen under the threshold
         * If it has, kill interval, and setup the simple timer
         */ timerStoppers.push((0, $ad06b61c4606f6df$export$5fe74ec28e3a5524)(()=>{
        if ($d4622374f48a4eef$var$calculateTimeLeft(timestamp) > $d4622374f48a4eef$export$b8b121e6edf70f49) return;
        stopAndClear();
        timerStoppers.push($d4622374f48a4eef$var$createSimpleTimeout(callback, $d4622374f48a4eef$var$calculateTimeLeft(timestamp)));
    }, $d4622374f48a4eef$export$b8b121e6edf70f49));
    return stopAndClear;
};



const $48cf5ef53a480c1f$export$1391212d75b2ee65 = (timeOrDate)=>new Promise((resolve)=>(0, $d4622374f48a4eef$export$6eae7cf7a129a986)(resolve, timeOrDate));



const $ad06b61c4606f6df$export$fc72b07294cc9741 = 2147483647;
const $ad06b61c4606f6df$export$5fe74ec28e3a5524 = (callback, time)=>{
    (0, $14eddac5f20c576c$export$a7a9523472993e97)(time <= $ad06b61c4606f6df$export$fc72b07294cc9741, new Error(`Interval ${time} not supported`));
    const id = setInterval(callback, time);
    return ()=>clearInterval(id);
};


class $85a96cf722827591$export$3dc07afe418952bc {
    static async awaitNext(asyncCall, resolve, reject) {
        try {
            resolve(await asyncCall());
        } catch (e) {
            reject(e);
        }
    }
    static async awaitSafely(previous) {
        try {
            await previous;
        } catch  {
        // It is ok to hide errors here, only the code coverage tool is going to judge us
        }
    }
    /**
     * Adds an async callback to the async queue
     * This callback will only be executed after the previous callbacks
     *
     * @returns the promise that you gave to it through its callback, no errors are held
     */ push(asyncCall) {
        const previous = this.lastPromise;
        /**
         * Replace previous with new one
         */ const current = new Promise((resolve, reject)=>{
            /**
             * Await for previous to finish
             */ $85a96cf722827591$export$3dc07afe418952bc.awaitSafely(previous).then(()=>{
                /**
                 * Then execute new one
                 */ $85a96cf722827591$export$3dc07afe418952bc.awaitNext(asyncCall, resolve, reject);
            });
        });
        /**
         * Replace previous with current
         */ this.lastPromise = current;
        return current;
    }
    constructor(){
        this.lastPromise = Promise.resolve();
    }
}



class $2accc4d3fee5c026$var$BaseThrottler {
    /**
     * @param interval in milliseconds
     */ constructor(interval){
        this.interval = interval;
    }
}
class $2accc4d3fee5c026$export$1a6b7111629cfd6e extends $2accc4d3fee5c026$var$BaseThrottler {
    run(callback) {
        if (this.cancel) /**
             * Timer was already set, ignore next ones until is clears
             */ return null;
        this.cancel = true;
        return (0, $d4622374f48a4eef$export$6eae7cf7a129a986)(()=>{
            try {
                callback();
            } finally{
                this.cancel = false;
            }
        }, this.interval);
    }
    constructor(...args){
        super(...args), this.cancel = false;
    }
}
class $2accc4d3fee5c026$export$af12a1bf506c8522 extends $2accc4d3fee5c026$var$BaseThrottler {
    run(callback) {
        this.cancel?.();
        this.cancel = (0, $d4622374f48a4eef$export$6eae7cf7a129a986)(callback, this.interval);
        return this.cancel;
    }
    constructor(...args){
        super(...args), this.cancel = null;
    }
}
class $2accc4d3fee5c026$export$badd29bfd2c3923d extends $2accc4d3fee5c026$var$BaseThrottler {
    execute(callback) {
        this.done = Date.now() + this.interval;
        callback();
    }
    /**
     * @returns if the function was executed
     */ run(callback) {
        /**
         * Either has not been executed
         * Or the threshold has passed
         */ const willExecute = this.done === null || this.done < Date.now();
        if (willExecute) this.execute(callback);
        return willExecute;
    }
    /**
     * @returns if the function was executed, which it is unless another execution happened while waiting
     */ async runAfter(callback) {
        /**
         * Checks that the stored `done` timestamp is unchanged rather than comparing it against `Date.now()`,
         * because the timer can fire before `done` (timers are scheduled from the event loop's cached time)
         * or exactly at it (failing `run()`'s strict `<`), either of which would silently drop this trailing execution
         */ const blockedUntil = this.done;
        await (0, $48cf5ef53a480c1f$export$1391212d75b2ee65)(this.interval);
        const willExecute = this.done === blockedUntil;
        if (willExecute) this.execute(callback);
        return willExecute;
    }
    constructor(...args){
        super(...args), this.done = null;
    }
}


/**
 * This is a simple utility class that helps the codebase create a promise
 * that does not have to be resolved internally, but can solved elsewhere
 */ class $4b4d116d11b9cad5$export$63804c02d20d1c30 {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}




var $07bb6deec3b2f839$export$cd7f480d6b8286c3;
var $07bb6deec3b2f839$export$452fcf31d2a11c49;
var $07bb6deec3b2f839$export$a078a2660a2c4d03;
$07bb6deec3b2f839$export$cd7f480d6b8286c3 = $07bb6deec3b2f839$var$removeDiacritics;
var $07bb6deec3b2f839$var$replacementList = [
    {
        base: ' ',
        chars: "\u00A0"
    },
    {
        base: '0',
        chars: "\u07C0"
    },
    {
        base: 'A',
        chars: "\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        chars: "\uA732"
    },
    {
        base: 'AE',
        chars: "\u00C6\u01FC\u01E2"
    },
    {
        base: 'AO',
        chars: "\uA734"
    },
    {
        base: 'AU',
        chars: "\uA736"
    },
    {
        base: 'AV',
        chars: "\uA738\uA73A"
    },
    {
        base: 'AY',
        chars: "\uA73C"
    },
    {
        base: 'B',
        chars: "\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0181"
    },
    {
        base: 'C',
        chars: "\u24b8\uff23\uA73E\u1E08\u0106\u0043\u0108\u010A\u010C\u00C7\u0187\u023B"
    },
    {
        base: 'D',
        chars: "\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018A\u0189\u1D05\uA779"
    },
    {
        base: 'Dh',
        chars: "\u00D0"
    },
    {
        base: 'DZ',
        chars: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        chars: "\u01F2\u01C5"
    },
    {
        base: 'E',
        chars: "\u025B\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E\u1D07"
    },
    {
        base: 'F',
        chars: "\uA77C\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        chars: "\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E\u0262"
    },
    {
        base: 'H',
        chars: "\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        chars: "\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        chars: "\u24BF\uFF2A\u0134\u0248\u0237"
    },
    {
        base: 'K',
        chars: "\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        chars: "\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        chars: "\u01C7"
    },
    {
        base: 'Lj',
        chars: "\u01C8"
    },
    {
        base: 'M',
        chars: "\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C\u03FB"
    },
    {
        base: 'N',
        chars: "\uA7A4\u0220\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u019D\uA790\u1D0E"
    },
    {
        base: 'NJ',
        chars: "\u01CA"
    },
    {
        base: 'Nj',
        chars: "\u01CB"
    },
    {
        base: 'O',
        chars: "\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OE',
        chars: "\u0152"
    },
    {
        base: 'OI',
        chars: "\u01A2"
    },
    {
        base: 'OO',
        chars: "\uA74E"
    },
    {
        base: 'OU',
        chars: "\u0222"
    },
    {
        base: 'P',
        chars: "\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        chars: "\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        chars: "\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        chars: "\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        chars: "\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'Th',
        chars: "\u00DE"
    },
    {
        base: 'TZ',
        chars: "\uA728"
    },
    {
        base: 'U',
        chars: "\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        chars: "\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        chars: "\uA760"
    },
    {
        base: 'W',
        chars: "\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        chars: "\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        chars: "\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        chars: "\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        chars: "\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251"
    },
    {
        base: 'aa',
        chars: "\uA733"
    },
    {
        base: 'ae',
        chars: "\u00E6\u01FD\u01E3"
    },
    {
        base: 'ao',
        chars: "\uA735"
    },
    {
        base: 'au',
        chars: "\uA737"
    },
    {
        base: 'av',
        chars: "\uA739\uA73B"
    },
    {
        base: 'ay',
        chars: "\uA73D"
    },
    {
        base: 'b',
        chars: "\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253\u0182"
    },
    {
        base: 'c',
        chars: "\uFF43\u24D2\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        chars: "\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\u018B\u13E7\u0501\uA7AA"
    },
    {
        base: 'dh',
        chars: "\u00F0"
    },
    {
        base: 'dz',
        chars: "\u01F3\u01C6"
    },
    {
        base: 'e',
        chars: "\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u01DD"
    },
    {
        base: 'f',
        chars: "\u24D5\uFF46\u1E1F\u0192"
    },
    {
        base: 'ff',
        chars: "\uFB00"
    },
    {
        base: 'fi',
        chars: "\uFB01"
    },
    {
        base: 'fl',
        chars: "\uFB02"
    },
    {
        base: 'ffi',
        chars: "\uFB03"
    },
    {
        base: 'ffl',
        chars: "\uFB04"
    },
    {
        base: 'g',
        chars: "\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\uA77F\u1D79"
    },
    {
        base: 'h',
        chars: "\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        chars: "\u0195"
    },
    {
        base: 'i',
        chars: "\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        chars: "\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        chars: "\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        chars: "\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747\u026D"
    },
    {
        base: 'lj',
        chars: "\u01C9"
    },
    {
        base: 'm',
        chars: "\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        chars: "\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509"
    },
    {
        base: 'nj',
        chars: "\u01CC"
    },
    {
        base: 'o',
        chars: "\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\uA74B\uA74D\u0275\u0254\u1D11"
    },
    {
        base: 'oe',
        chars: "\u0153"
    },
    {
        base: 'oi',
        chars: "\u01A3"
    },
    {
        base: 'oo',
        chars: "\uA74F"
    },
    {
        base: 'ou',
        chars: "\u0223"
    },
    {
        base: 'p',
        chars: "\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755\u03C1"
    },
    {
        base: 'q',
        chars: "\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        chars: "\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        chars: "\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u0282"
    },
    {
        base: 'ss',
        chars: "\xDF"
    },
    {
        base: 't',
        chars: "\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'th',
        chars: "\u00FE"
    },
    {
        base: 'tz',
        chars: "\uA729"
    },
    {
        base: 'u',
        chars: "\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        chars: "\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        chars: "\uA761"
    },
    {
        base: 'w',
        chars: "\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        chars: "\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        chars: "\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        chars: "\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $07bb6deec3b2f839$var$diacriticsMap = {};
for(var $07bb6deec3b2f839$var$i = 0; $07bb6deec3b2f839$var$i < $07bb6deec3b2f839$var$replacementList.length; $07bb6deec3b2f839$var$i += 1){
    var $07bb6deec3b2f839$var$chars = $07bb6deec3b2f839$var$replacementList[$07bb6deec3b2f839$var$i].chars;
    for(var $07bb6deec3b2f839$var$j = 0; $07bb6deec3b2f839$var$j < $07bb6deec3b2f839$var$chars.length; $07bb6deec3b2f839$var$j += 1)$07bb6deec3b2f839$var$diacriticsMap[$07bb6deec3b2f839$var$chars[$07bb6deec3b2f839$var$j]] = $07bb6deec3b2f839$var$replacementList[$07bb6deec3b2f839$var$i].base;
}
function $07bb6deec3b2f839$var$removeDiacritics(str) {
    return str.replace(/[^\u0000-\u007e]/g, function(c) {
        return $07bb6deec3b2f839$var$diacriticsMap[c] || c;
    });
}
$07bb6deec3b2f839$export$452fcf31d2a11c49 = $07bb6deec3b2f839$var$replacementList;
$07bb6deec3b2f839$export$a078a2660a2c4d03 = $07bb6deec3b2f839$var$diacriticsMap;


const $1e2b62fb1507b421$export$a3295358bff77e = (str, mode = 'toLowerCase')=>(0, $07bb6deec3b2f839$export$cd7f480d6b8286c3)(str[mode]());



var $8fJ0j = parcelRequire("8fJ0j");
const $eaf49e34dc778a74$export$373f4c3083978ffd = (str)=>(0, $8fJ0j.Buffer).from(str).toString('base64');
const $eaf49e34dc778a74$export$83edfd8fcc66ec17 = (str)=>(0, $8fJ0j.Buffer).from(str, 'base64').toString();


const $d54af89b52a0b804$var$searchCache = {};
const $d54af89b52a0b804$export$d76128d007d19019 = (content, terms)=>{
    for(let i = 0; i < terms.length; i++){
        const term = terms[i];
        const hit = $d54af89b52a0b804$var$searchCache[term]?.[content];
        const wasHit = hit !== undefined;
        const matches = wasHit ? hit : content.includes(term);
        if (!wasHit) $d54af89b52a0b804$var$searchCache[term] = {
            ...$d54af89b52a0b804$var$searchCache[term],
            [content]: matches
        };
        if (matches) return true;
    }
    return false;
};





class $9fc21cc786388d5a$export$3291343375ee8b92 {
    constructor(shouldTrigger = ()=>true){
        this.shouldTrigger = shouldTrigger;
        this.listeners = new Set();
    }
    get size() {
        return this.listeners.size;
    }
    off(listener) {
        this.listeners.delete(listener);
    }
    trigger(event) {
        if (this.shouldTrigger(event)) this.listeners.forEach((l)=>l(event));
    }
    on(listener) {
        this.listeners.add(listener);
        return ()=>this.off(listener);
    }
}
class $9fc21cc786388d5a$export$668230531b0abb74 {
    constructor(currentValue, changeBefore = false){
        this.currentValue = currentValue;
        this.changeBefore = changeBefore;
        this.listener = new $9fc21cc786388d5a$export$3291343375ee8b92();
    }
    get value() {
        return this.currentValue;
    }
    onChange(listener) {
        return this.listener.on(listener);
    }
    change(value) {
        const currentValue = this.currentValue;
        if (this.changeBefore) this.currentValue = value;
        this.listener.trigger([
            currentValue,
            value
        ]);
        if (!this.changeBefore) this.currentValue = value;
    }
}
class $9fc21cc786388d5a$export$37ef2bcb880cd30 {
    /**
     * @param cycle in milliseconds
     * @see https://developer.mozilla.org/en-US/docs/Web/API/setInterval#sect1
     * @param eager if eager, will trigger the `onCycled` as soon as a value is appended
     */ constructor(cycle, eager = false){
        this.cycle = cycle;
        this.eager = eager;
        this.listeners = new $9fc21cc786388d5a$export$3291343375ee8b92();
        this.triggerEager = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.eager && this.trigger());
        this.cancelInterval = null;
        this.values = [];
        this.refreshCycle();
    }
    trigger() {
        const values = this.values;
        this.values = [];
        this.listeners.trigger(values);
    }
    refreshCycle() {
        /**
         * If there are listeners but no interval yet, set one up
         */ if (this.listeners.size && !this.cancelInterval) this.cancelInterval = (0, $ad06b61c4606f6df$export$5fe74ec28e3a5524)(()=>this.trigger(), this.cycle);
        /**
         * If there are no listeners left but an interval exists, clear it
         */ if (!this.listeners.size && this.cancelInterval) {
            this.cancelInterval();
            this.cancelInterval = null;
        }
    }
    /**
     * The callback will be triggered even when there is nothing in the batch
     */ onCycled(listener) {
        const unsub = this.listeners.on(listener);
        this.refreshCycle();
        return ()=>{
            unsub();
            this.refreshCycle();
        };
    }
    append(value) {
        this.values.push(value);
        this.triggerEager();
    }
}



const $bf45460f43a51d1f$export$25015dbcee3d4fb2 = (set, toggled)=>{
    if (set.has(toggled)) set.delete(toggled);
    else set.add(toggled);
    return set;
};
const $bf45460f43a51d1f$export$54c12c14e9d064 = (set, toggled)=>$bf45460f43a51d1f$export$25015dbcee3d4fb2(new Set(set), toggled);


const $ce8b0bc4475e8e40$export$7a32dd8b629a0529 = (arr, length)=>{
    const split = [];
    for(let i = 0; i < arr.length; i += length)split.push(arr.slice(i, i + length));
    return split;
};


class $f0cbf013be9038ef$export$c3f30dbb97e8bc91 extends Map {
    /**
     * Same as Map.get but with default value functionality
     * @see {Map.get}
     */ getDefault(key, defaultValue) {
        return this.has(key) ? this.get(key) : defaultValue;
    }
    /**
     * Short hand for converting map values to an array
     */ toValuesArray() {
        return Array.from(this.values());
    }
}




const $1f8efbeda4be7f45$export$9c813ac7100b0116 = (customComparator, sort = false)=>(a, b)=>(0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(a, b, {
            sort: sort,
            equals: customComparator
        });
const $1f8efbeda4be7f45$export$99c416949ad3efe4 = (extractor)=>(a, b)=>extractor(a) === extractor(b);
const $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4 = (comparators)=>{
    const getComparators = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>(0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(comparators));
    return (a, b)=>a === b || getComparators().every(([field, comparator])=>{
            const vA = a[field];
            const vB = b[field];
            return vA === vB || (comparator ? comparator(vA, vB) : false);
        });
};
const $1f8efbeda4be7f45$export$7706906eb37331a3 = (comparators, name)=>(0, $beec4324cbd609ea$export$6b4e15ccdc547ae7)($1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4(comparators), name);




const $c9e988a9208a6bbc$var$createSurrogateFunction = (part, methodName)=>{
    return (...args)=>part[methodName](...args);
};
const $c9e988a9208a6bbc$export$755b96d9572a8e9e = (parts)=>(0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(parts).reduce((r, [methodName, part])=>({
            ...r,
            [methodName]: /**
                 * Check if part is a function or a class implementation
                 *
                 * The castings here are fine if and only if the type constraints provided above work as expected
                 * @see {OnlyFunctions}
                 */ part instanceof Function ? part : $c9e988a9208a6bbc$var$createSurrogateFunction(part, methodName)
        }), {});



class $50ef090cac933bbc$export$a79d17dc751af0da {
    traverse(input, parents = []) {
        const children = [];
        for (const [parent, child] of this.mapChildEntries(input))children.push([
            parent,
            this.traverse(child, [
                ...parents,
                parent
            ])
        ]);
        return this.collect({
            input: input,
            parents: parents,
            children: children
        });
    }
}
class $50ef090cac933bbc$export$979fbf2cce3f8587 extends $50ef090cac933bbc$export$a79d17dc751af0da {
    constructor(remap){
        super(), this.remap = remap;
    }
    mapChildEntries(input) {
        if ((0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(input)) return input.map((child, k)=>[
                k,
                child
            ]);
        if (input && typeof input === 'object') return (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(input);
        return [];
    }
    collect({ input: input, parents: parents, children: children }) {
        if (!(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(children)) /** Not an array or object */ return this.remap(input, parents);
        if (typeof children[0][0] === 'number') /** Should always be an array */ return this.remap(children.map(([, c])=>c), parents);
        return this.remap(Object.fromEntries(children), parents);
    }
}





const $ef143c4e3199bc2b$export$e3b2f95055a9733d = (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
    asc: null,
    column: null
});






const $f0717a7650cc5e17$export$281fdbe386b97b06 = (loadable)=>Boolean(loadable && !(0, $c3e1b746ad236797$export$8d524fb6540252df).is(loadable));
const $f0717a7650cc5e17$export$d3e3eeb4af2d1203 = (select, idField, filter)=>(s, ids)=>{
        /** Nothing is selected, load nothing */ if (!(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(ids)) return [];
        const loadable = select(s);
        if (!$f0717a7650cc5e17$export$281fdbe386b97b06(loadable) || filter && !filter(loadable) || !ids.includes(loadable[idField])) return [];
        return [
            loadable
        ];
    };


const $e926476d3d092144$export$8e4ba12aa2056817 = (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
    pageSize: null,
    page: null
});
const $e926476d3d092144$var$arePageDataEquals = (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
    current: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)(),
    totalCount: null
});
const $e926476d3d092144$var$areNonNullablePagesEquals = (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
    pagination: $e926476d3d092144$export$8e4ba12aa2056817,
    data: (a, b)=>Boolean(a && b && !(0, $c3e1b746ad236797$export$8d524fb6540252df).is(a) && !(0, $c3e1b746ad236797$export$8d524fb6540252df).is(b) && $e926476d3d092144$var$arePageDataEquals(a, b)),
    search: null,
    sort: (0, $ef143c4e3199bc2b$export$e3b2f95055a9733d)
});
const $e926476d3d092144$export$befd6eec7b379c32 = (a, b)=>a === null || b === null ? a === b : $e926476d3d092144$var$areNonNullablePagesEquals(a, b);
const $e926476d3d092144$export$8f6106f24823543e = (select, idField, name, filter)=>{
    const emptyArray = [];
    return (0, $beec4324cbd609ea$export$6b4e15ccdc547ae7)((s, ids)=>{
        /** Nothing is selected, load nothing */ if (!(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(ids)) return emptyArray;
        const page = select(s);
        if (page === null || !(0, $f0717a7650cc5e17$export$281fdbe386b97b06)(page.data)) return emptyArray;
        return page.data.current.filter((e)=>/** If there is a filter, make sure it passes */ (filter ? filter(e) : true) && /** Finally, check if the selected ids include the entries */ ids.includes(e[idField]));
    }, name);
};



var $1041b3cad55163d4$export$e35c1996c6f482ad = /*#__PURE__*/ function(StatusType) {
    StatusType["ACTIVE"] = "ACTIVE";
    StatusType["AVAILABLE"] = "AVAILABLE";
    StatusType["CONNECTED"] = "CONNECTED";
    StatusType["CONNECTING"] = "CONNECTING";
    StatusType["CREATED"] = "CREATED";
    StatusType["DEAD"] = "DEAD";
    StatusType["DEVIATED"] = "DEVIATED";
    StatusType["DISABLED"] = "DISABLED";
    StatusType["DISABLING"] = "DISABLING";
    StatusType["DISCONNECTED"] = "DISCONNECTED";
    StatusType["DISCONNECTING"] = "DISCONNECTING";
    StatusType["ENABLED"] = "ENABLED";
    StatusType["ENABLING"] = "ENABLING";
    StatusType["EXITED"] = "EXITED";
    StatusType["INACTIVE"] = "INACTIVE";
    StatusType["INVALID"] = "INVALID";
    StatusType["NO_DEVIATION"] = "NO_DEVIATION";
    StatusType["NOT_ENABLED"] = "NOT_ENABLED";
    StatusType["OFFLINE"] = "OFFLINE";
    StatusType["ONLINE"] = "ONLINE";
    StatusType["PAUSED"] = "PAUSED";
    StatusType["REACHABLE"] = "REACHABLE";
    StatusType["RECONNECTING"] = "RECONNECTING";
    StatusType["REENABLING"] = "REENABLING";
    StatusType["RESTARTING"] = "RESTARTING";
    StatusType["ROLLING_BACK"] = "ROLLING_BACK";
    StatusType["RUNNING"] = "RUNNING";
    StatusType["STARTING"] = "STARTING";
    StatusType["STOPPING"] = "STOPPING";
    StatusType["TERMINATED"] = "TERMINATED";
    StatusType["UNAVAILABLE"] = "UNAVAILABLE";
    StatusType["UNKNOWN"] = "UNKNOWN";
    StatusType["UNREACHABLE"] = "UNREACHABLE";
    StatusType["UPDATING"] = "UPDATING";
    StatusType["VALID"] = "VALID";
    StatusType["WAITING"] = "WAITING";
    /**
     * Used only when the state coming from the backend is not expected/covered in the rest of the enum
     */ // eslint-disable-next-line typescript-sort-keys/string-enum
    StatusType["UNEXPECTED"] = "UNEXPECTED";
    return StatusType;
}({});
const $1041b3cad55163d4$export$a6a94a1c8dcbbdf8 = (0, $65583c3760a483fc$export$2b5e8179047d3ac4)($1041b3cad55163d4$export$e35c1996c6f482ad);




const $9ede1dd6506a21d3$export$bccffce87b0d7a69 = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    containerId: null,
    hostname: null,
    name: null,
    status: null,
    version: null
}, 'areAgentEquals');
const $9ede1dd6506a21d3$export$f543d47ae073f806 = (agent)=>agent.status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).OFFLINE;
const $9ede1dd6506a21d3$export$d4d8ee9ce1c82cec = (s)=>s.agentsPage;
const $9ede1dd6506a21d3$export$1135a0877e5140ce = (0, $e926476d3d092144$export$8f6106f24823543e)($9ede1dd6506a21d3$export$d4d8ee9ce1c82cec, 'name', 'selectDeletableLoadedAgents', $9ede1dd6506a21d3$export$f543d47ae073f806);







const $6bfd545928047d5f$var$createSelector = (k)=>(a)=>a[k];
const $6bfd545928047d5f$export$4762e3eadf2f3a03 = $6bfd545928047d5f$var$createSelector('token');
const $6bfd545928047d5f$export$16d401e5f8a6290f = $6bfd545928047d5f$var$createSelector('username');
const $6bfd545928047d5f$export$fe203747b10f326e = $6bfd545928047d5f$var$createSelector('expiresAt');
const $6bfd545928047d5f$export$6ccadce24844b875 = $6bfd545928047d5f$var$createSelector('expiresSoon');
const $6bfd545928047d5f$export$4c17e06804984df7 = $6bfd545928047d5f$var$createSelector('capabilities');
const $6bfd545928047d5f$export$d38011aa9682808f = $6bfd545928047d5f$var$createSelector('obsolete');
const $6bfd545928047d5f$export$467fea09bf6b8399 = (...[s])=>{
    const getIndexedCapabilities = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>new Set($6bfd545928047d5f$export$4c17e06804984df7(s)));
    return (requiredCapabilities)=>requiredCapabilities.every((p)=>getIndexedCapabilities().has(p));
};


/* eslint-disable typescript-sort-keys/string-enum */ var $78670ebe9381a713$export$790a66df9dc00390 = /*#__PURE__*/ function(Capability) {
    /**
     * Resources
     */ Capability["AGENTS_MANAGE"] = "AGENTS_MANAGE";
    Capability["AGENTS_READ"] = "AGENTS_READ";
    Capability["CONNECTION_READ"] = "CONNECTION_READ";
    Capability["CONNECTIONS_MANAGE"] = "CONNECTIONS_MANAGE";
    Capability["CONNECTIONS_READ"] = "CONNECTIONS_READ";
    Capability["CORE_CONTAINER_READ"] = "CORE_CONTAINER_READ";
    Capability["CORE_CONTAINERS_MANAGE"] = "CORE_CONTAINERS_MANAGE";
    Capability["CORE_CONTAINERS_READ"] = "CORE_CONTAINERS_READ";
    Capability["SERVICE_CONTAINER_READ"] = "SERVICE_CONTAINER_READ";
    Capability["SERVICE_CONTAINERS_MANAGE"] = "SERVICE_CONTAINERS_MANAGE";
    Capability["SERVICE_CONTAINERS_READ"] = "SERVICE_CONTAINERS_READ";
    Capability["ENDPOINT_READ"] = "ENDPOINT_READ";
    Capability["ENDPOINTS_MANAGE"] = "ENDPOINTS_MANAGE";
    Capability["ENDPOINTS_READ"] = "ENDPOINTS_READ";
    Capability["MAPPING_READ"] = "MAPPING_READ";
    Capability["MAPPINGS_MANAGE"] = "MAPPINGS_MANAGE";
    Capability["MAPPINGS_READ"] = "MAPPINGS_READ";
    Capability["NODES_READ"] = "NODES_READ";
    Capability["SERVER_READ"] = "SERVER_READ";
    Capability["SERVERS_MANAGE"] = "SERVERS_MANAGE";
    Capability["SERVERS_READ"] = "SERVERS_READ";
    Capability["SERVICE_READ"] = "SERVICE_READ";
    Capability["SERVICE_COMMISSIONING_FILE_READ"] = "SERVICE_COMMISSIONING_FILE_READ";
    Capability["SERVICES_MANAGE"] = "SERVICES_MANAGE";
    Capability["SERVICES_PARAMETERS_READ"] = "SERVICES_PARAMETERS_READ";
    Capability["SERVICES_CREATE_OR_UPDATE"] = "SERVICES_CREATE_OR_UPDATE";
    Capability["SERVICES_READ"] = "SERVICES_READ";
    Capability["SERVICE_SUBSCRIPTION_METADATA"] = "SERVICE_SUBSCRIPTION_METADATA";
    Capability["DEVIATIONS_READ"] = "DEVIATIONS_READ";
    Capability["VOLUME_READ"] = "VOLUME_READ";
    Capability["VOLUMES_MANAGE"] = "VOLUMES_MANAGE";
    Capability["VOLUMES_READ"] = "VOLUMES_READ";
    /**
     * User management
     */ Capability["MANAGE_USERS"] = "MANAGE_USERS";
    Capability["MANAGE_ROLES"] = "MANAGE_ROLES";
    Capability["MANAGE_PERMISSIONS"] = "MANAGE_PERMISSIONS";
    Capability["CLIENT_REGISTRY_MANAGE"] = "CLIENT_REGISTRY_MANAGE";
    Capability["CERTIFICATES_MANAGE"] = "CERTIFICATES_MANAGE";
    Capability["USER_MANAGEMENT_CONFIGURATION"] = "USER_MANAGEMENT_CONFIGURATION";
    /**
     * Others
     */ Capability["TOPIC_CHUNKS_READ"] = "TOPIC_CHUNKS_READ";
    Capability["RULE_ENGINE_RESOURCES"] = "RULE_ENGINE_RESOURCES";
    Capability["TOPICS_SUBSCRIPTION"] = "TOPICS_SUBSCRIPTION";
    Capability["WORKBENCH"] = "WORKBENCH";
    Capability["LOGS_READ"] = "LOGS_READ";
    Capability["MINIMUM"] = "MINIMUM";
    Capability["USE_MFA"] = "USE_MFA";
    /**
     * System
     */ Capability["SYSTEM_LICENSE_MANAGE"] = "SYSTEM_LICENSE_MANAGE";
    Capability["SYSTEM_METRICS_MANAGE"] = "SYSTEM_METRICS_MANAGE";
    Capability["SYSTEM_METRICS_READ"] = "SYSTEM_METRICS_READ";
    /** Change password */ Capability["MANAGE_OWN_PASSWORD"] = "MANAGE_OWN_PASSWORD";
    /** Policies */ Capability["RETRIEVE_USERNAME_POLICY"] = "RETRIEVE_USERNAME_POLICY";
    Capability["RETRIEVE_PASSWORD_POLICY"] = "RETRIEVE_PASSWORD_POLICY";
    return Capability;
}({});


var $c3e1b746ad236797$export$13cd8ea82c82bf53 = /*#__PURE__*/ function(ConnectwareErrorType) {
    /**
     * Used whenever there are authentication issues on the application
     * @example user was not authenticated to use X or Y resource
     */ ConnectwareErrorType["AUTHENTICATION"] = "AUTHENTICATION";
    /**
     * Used whenever there was a request deemed invalid by an external service
     */ ConnectwareErrorType["BAD_REQUEST"] = "BAD_REQUEST";
    /**
     * Used when there is some configuration error on the application
     * @example license is badly configured or some service is not properly configured to run
     */ ConnectwareErrorType["CONFIGURATION_ERROR"] = "CONFIGURATION_ERROR";
    /**
     * For whenever a business rule does not allow an action
     */ ConnectwareErrorType["GENERAL_BUSINESS_RULE_INFRACTION"] = "GENERAL_BUSINESS_RULE_INFRACTION";
    /**
     * If there was an issue while mapping some external comunication response, this is the type to use
     */ ConnectwareErrorType["MAPPING_ERROR"] = "MAPPING_ERROR";
    /**
     * Used if a resource, that was to be loaded or manipulated, was not found
     */ ConnectwareErrorType["NOT_FOUND"] = "NOT_FOUND";
    /**
     * Generic external server error
     */ ConnectwareErrorType["SERVER_ERROR"] = "SERVER_ERROR";
    /**
     * Error if server being contacted could not be reached
     */ ConnectwareErrorType["SERVER_NOT_AVAILABLE"] = "SERVER_NOT_AVAILABLE";
    /**
     * Error if server runs into any kind of timeout
     */ ConnectwareErrorType["SERVER_TIMEOUT"] = "SERVER_TIMEOUT";
    /**
     * Use when there is an issue creating a service
     */ ConnectwareErrorType["SERVICE_CREATION_ERROR"] = "SERVICE_CREATION_ERROR";
    /**
     * Used when there is an issue manipulating the state of the application
     * and an unexpected state is found
     */ ConnectwareErrorType["STATE"] = "STATE";
    /**
     * For translation related errors
     */ ConnectwareErrorType["TRANSLATIONS"] = "TRANSLATIONS";
    /**
     * For other unexpected scenarios
     */ ConnectwareErrorType["UNEXPECTED"] = "UNEXPECTED";
    return ConnectwareErrorType;
}({});
class $c3e1b746ad236797$export$8d524fb6540252df extends Error {
    static is(e) {
        return e instanceof $c3e1b746ad236797$export$8d524fb6540252df;
    }
    static isOfTypes(e, ...types) {
        return this.is(e) && types.includes(e.type);
    }
    constructor(typeOrError, message, extras){
        /**
         * First use customized message
         * Then inherited message
         * Finally no message
         */ super(message || $c3e1b746ad236797$export$8d524fb6540252df.is(typeOrError) && typeOrError.message || 'No message');
        this.type = $c3e1b746ad236797$export$8d524fb6540252df.is(typeOrError) ? typeOrError.type : typeOrError;
        this.extras = extras ?? ($c3e1b746ad236797$export$8d524fb6540252df.is(typeOrError) ? typeOrError.extras : {});
    }
}


class $ce07554ccb7fdbc8$export$49118b1f444502b4 extends (0, $c3e1b746ad236797$export$8d524fb6540252df) {
    static is(e) {
        return e instanceof $ce07554ccb7fdbc8$export$49118b1f444502b4;
    }
    constructor(){
        super((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, 'Session not found');
    }
}
class $ce07554ccb7fdbc8$export$f4d656254be083ec extends (0, $c3e1b746ad236797$export$8d524fb6540252df) {
    static is(e) {
        return e instanceof $ce07554ccb7fdbc8$export$f4d656254be083ec;
    }
    constructor(){
        super((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, 'MFA token expired');
    }
}
class $ce07554ccb7fdbc8$export$8a25c189a0dc6a1b extends (0, $c3e1b746ad236797$export$8d524fb6540252df) {
    static is(e) {
        return e instanceof $ce07554ccb7fdbc8$export$8a25c189a0dc6a1b;
    }
    constructor(){
        super((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, 'Token expired');
    }
}






const $1c05f13022cf1480$export$d7186caa83d1ebde = (s)=>s.authentication;
const $1c05f13022cf1480$export$83d11f23a23d4a7c = (auth)=>Boolean(auth && !(0, $c3e1b746ad236797$export$8d524fb6540252df).is(auth));
const $1c05f13022cf1480$export$c75d7b8f071929fe = (s)=>$1c05f13022cf1480$export$83d11f23a23d4a7c($1c05f13022cf1480$export$d7186caa83d1ebde(s));
const $1c05f13022cf1480$var$createAuthenticationSelector = (selector, defaultValue)=>(s)=>{
        const auth = $1c05f13022cf1480$export$d7186caa83d1ebde(s);
        return $1c05f13022cf1480$export$83d11f23a23d4a7c(auth) ? selector(auth) : defaultValue;
    };
const $1c05f13022cf1480$export$f145af4743957df7 = $1c05f13022cf1480$var$createAuthenticationSelector((0, $6bfd545928047d5f$export$4762e3eadf2f3a03), null);
const $1c05f13022cf1480$export$f45ac34dd9e56631 = $1c05f13022cf1480$var$createAuthenticationSelector((0, $6bfd545928047d5f$export$16d401e5f8a6290f), null);
const $1c05f13022cf1480$export$7326d92567ef4631 = $1c05f13022cf1480$var$createAuthenticationSelector((0, $6bfd545928047d5f$export$4c17e06804984df7), null);
const $1c05f13022cf1480$export$13066c71c1ef331a = $1c05f13022cf1480$var$createAuthenticationSelector((0, $6bfd545928047d5f$export$4c17e06804984df7), []);
const $1c05f13022cf1480$export$708b617202a3b032 = $1c05f13022cf1480$var$createAuthenticationSelector((0, $6bfd545928047d5f$export$d38011aa9682808f), null);
const $1c05f13022cf1480$export$97c945ddcfd5e726 = $1c05f13022cf1480$var$createAuthenticationSelector((authentication)=>{
    const soon = (0, $6bfd545928047d5f$export$6ccadce24844b875)(authentication);
    return soon ? (0, $6bfd545928047d5f$export$fe203747b10f326e)(authentication) : null;
}, null);
const $1c05f13022cf1480$var$selectAreAllCapabilitiesIncludedChecker = $1c05f13022cf1480$var$createAuthenticationSelector((0, $6bfd545928047d5f$export$467fea09bf6b8399), null);
const $1c05f13022cf1480$export$f57bfb60306fe35f = (s)=>{
    const check = $1c05f13022cf1480$var$selectAreAllCapabilitiesIncludedChecker(s);
    return (requiredCapabilities)=>Boolean(check?.(requiredCapabilities));
};
const $1c05f13022cf1480$export$718d52259ef5bb58 = (...requiredPermissions)=>(s)=>$1c05f13022cf1480$export$f57bfb60306fe35f(s)(requiredPermissions);




var $0b8fac93f85dcb05$export$a9b603917c4d9863 = /*#__PURE__*/ function(BufferType) {
    BufferType["HEX"] = "HEX";
    BufferType["LARGE_BUFFER"] = "LARGE_BUFFER";
    BufferType["NUMBER"] = "NUMBER";
    BufferType["OBJECT"] = "OBJECT";
    BufferType["STRING"] = "STRING";
    return BufferType;
}({});



var $aadfb82b994af9ea$export$ef2ab10c315d4157 = /*#__PURE__*/ function(CertificateKeyUsage) {
    CertificateKeyUsage["CRITICAL"] = "CRITICAL";
    CertificateKeyUsage["CRL_SIGN"] = "CRL_SIGN";
    CertificateKeyUsage["DATA_ENCIPHERMENT"] = "DATA_ENCIPHERMENT";
    CertificateKeyUsage["DECIPHER_ONLY"] = "DECIPHER_ONLY";
    CertificateKeyUsage["DIGITAL_SIGNATURE"] = "DIGITAL_SIGNATURE";
    CertificateKeyUsage["ENCIPHER_ONLY"] = "ENCIPHER_ONLY";
    CertificateKeyUsage["KEY_AGREEMENT"] = "KEY_AGREEMENT";
    CertificateKeyUsage["KEY_CERTSIGN"] = "KEY_CERTSIGN";
    CertificateKeyUsage["KEY_ENCIPHERMENT"] = "KEY_ENCIPHERMENT";
    CertificateKeyUsage["NON_REPUDIATION"] = "NON_REPUDIATION";
    return CertificateKeyUsage;
}({});
var $aadfb82b994af9ea$export$c89c6493e376b766 = /*#__PURE__*/ function(CertificateExtendedKeyUsage) {
    CertificateExtendedKeyUsage["CLIENT_AUTH"] = "CLIENT_AUTH";
    CertificateExtendedKeyUsage["CODE_SIGNING"] = "CODE_SIGNING";
    CertificateExtendedKeyUsage["CRITICAL"] = "CRITICAL";
    CertificateExtendedKeyUsage["EMAIL_PROTECTION"] = "EMAIL_PROTECTION";
    CertificateExtendedKeyUsage["IPSEC_IKE"] = "IPSEC_IKE";
    CertificateExtendedKeyUsage["MS_CODE_COM"] = "MS_CODE_COM";
    CertificateExtendedKeyUsage["MS_CODE_IND"] = "MS_CODE_IND";
    CertificateExtendedKeyUsage["MS_CTL_SIGN"] = "MS_CTL_SIGN";
    CertificateExtendedKeyUsage["MS_EFS"] = "MS_EFS";
    CertificateExtendedKeyUsage["OCSP_SIGNING"] = "OCSP_SIGNING";
    CertificateExtendedKeyUsage["SERVER_AUTH"] = "SERVER_AUTH";
    CertificateExtendedKeyUsage["TIME_STAMPING"] = "TIME_STAMPING";
    return CertificateExtendedKeyUsage;
}({});
const $aadfb82b994af9ea$var$getCertificateIssuedByTitle = (issuedBy)=>issuedBy.commonName || issuedBy.organization;
const $aadfb82b994af9ea$export$5ace278d59015300 = (certificate)=>$aadfb82b994af9ea$var$getCertificateIssuedByTitle(certificate.issuedBy);
const $aadfb82b994af9ea$export$ad6655e6c0becdd9 = (0, $d7e4c4d4cdf468fc$export$fe9afbcb954a8fa)({
    id: false,
    issuedBy: (a, b)=>$aadfb82b994af9ea$var$getCertificateIssuedByTitle(a).localeCompare($aadfb82b994af9ea$var$getCertificateIssuedByTitle(b)),
    issuedTo: false,
    keyUsage: false,
    extendedKeyUsage: false,
    basicConstraints: false,
    issuedOn: false,
    expiresOn: false,
    fingerprints: false,
    removable: false
}, 'certificatesSorter');
const $aadfb82b994af9ea$export$e5be0e9f0af0ab8b = (s)=>s.certificates;




const $b3e7a2ab0fd4d9ed$var$baseConnectionsComparators = {
    id: null,
    name: null,
    service: null,
    status: null,
    host: null,
    port: null,
    deviceAddress: null,
    deviceInstance: null,
    ipAddress: null,
    cncType: null,
    agent: null,
    device: null,
    brokers: (a, b)=>(0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(a) && (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(b) && (0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(a, b, {
            sort: false
        })
};
const $b3e7a2ab0fd4d9ed$export$fcb75d03e736f6ea = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    ...$b3e7a2ab0fd4d9ed$var$baseConnectionsComparators,
    protocol: null
}, 'areCybusConnectionsEquals');
const $b3e7a2ab0fd4d9ed$export$482c904bf2d3b316 = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    ...$b3e7a2ab0fd4d9ed$var$baseConnectionsComparators,
    extraConfiguration: (0, $33cff95ba235ba3b$export$596273409274759)
}, 'areCybusConnectionsEquals');
const $b3e7a2ab0fd4d9ed$export$70bb1060ba23a5e6 = (connection)=>connection.status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISCONNECTED;
const $b3e7a2ab0fd4d9ed$export$ab4361d7a1cbdab3 = (connection)=>connection.status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).CONNECTED;





const $e35c6a737caa74d7$export$83d924e75142d198 = (s)=>s.connection;
const $e35c6a737caa74d7$export$22bff46b5e0f21b8 = (s)=>s.connectionsPage;
const $e35c6a737caa74d7$export$82c7e7af560ff833 = (0, $e926476d3d092144$export$8f6106f24823543e)($e35c6a737caa74d7$export$22bff46b5e0f21b8, 'id', 'selectConnectableLoadedDetailedConnections', (0, $b3e7a2ab0fd4d9ed$export$70bb1060ba23a5e6));
const $e35c6a737caa74d7$export$4c56d54b7a77723d = (0, $e926476d3d092144$export$8f6106f24823543e)($e35c6a737caa74d7$export$22bff46b5e0f21b8, 'id', 'selectDisconnectableLoadedDetailedConnections', (0, $b3e7a2ab0fd4d9ed$export$ab4361d7a1cbdab3));
const $e35c6a737caa74d7$export$33dfe39cb992963d = (0, $e926476d3d092144$export$8f6106f24823543e)($e35c6a737caa74d7$export$22bff46b5e0f21b8, 'id', 'selectLoadedConnections');
const $e35c6a737caa74d7$export$a082b934f7cf7bd6 = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($e35c6a737caa74d7$export$83d924e75142d198, 'id', (0, $b3e7a2ab0fd4d9ed$export$70bb1060ba23a5e6));
const $e35c6a737caa74d7$export$3a6d405424d5e9f2 = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($e35c6a737caa74d7$export$83d924e75142d198, 'id', (0, $b3e7a2ab0fd4d9ed$export$ab4361d7a1cbdab3));
const $e35c6a737caa74d7$export$26b8cd3b3cd99014 = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($e35c6a737caa74d7$export$83d924e75142d198, 'id');






const $dc261e1a4f8deea7$var$nullableDateComparator = (0, $1f8efbeda4be7f45$export$99c416949ad3efe4)((d)=>d?.getTime());
const $dc261e1a4f8deea7$var$baseCybusContainersComparators = {
    id: null,
    name: null,
    status: null,
    created: $dc261e1a4f8deea7$var$nullableDateComparator
};
const $dc261e1a4f8deea7$var$cybusCoreContainersComparators = {
    ...$dc261e1a4f8deea7$var$baseCybusContainersComparators,
    lastUpdate: $dc261e1a4f8deea7$var$nullableDateComparator
};
const $dc261e1a4f8deea7$export$f2958c16b60896ae = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)($dc261e1a4f8deea7$var$cybusCoreContainersComparators, 'areCybusCoreContainersEquals');
const $dc261e1a4f8deea7$var$areCybusContainerConfigsEquals = (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
    image: null,
    workingDir: null,
    author: null,
    vendor: null,
    capAdd: (a, b)=>(0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(a) && (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(b) && (0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(a, b, {
            sort: false
        }),
    exposedPorts: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)(),
    privileged: null
});
const $dc261e1a4f8deea7$export$f62d527a0ab80f09 = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    ...$dc261e1a4f8deea7$var$baseCybusContainersComparators,
    volumes: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)(),
    config: $dc261e1a4f8deea7$var$areCybusContainerConfigsEquals,
    variables: (0, $33cff95ba235ba3b$export$596273409274759)
}, 'areCybusDetailedCoreContainersEquals');
const $dc261e1a4f8deea7$export$ba06f365668c46b9 = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    ...$dc261e1a4f8deea7$var$cybusCoreContainersComparators,
    volumesCount: null,
    service: null
}, 'areCybusServiceContainersEquals');
const $dc261e1a4f8deea7$export$96e6b69c5483e739 = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    ...$dc261e1a4f8deea7$var$baseCybusContainersComparators,
    service: null,
    volumes: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)(),
    config: $dc261e1a4f8deea7$var$areCybusContainerConfigsEquals,
    variables: (0, $33cff95ba235ba3b$export$596273409274759)
}, 'areCybusDetailedServiceContainersEquals');
const $dc261e1a4f8deea7$export$bebb768243e568eb = ({ status: status })=>status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).EXITED;
const $dc261e1a4f8deea7$export$e49c64d84076eb0e = ({ status: status })=>status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).EXITED;
const $dc261e1a4f8deea7$export$7f65084de65d53e5 = ({ status: status })=>status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).RUNNING;
const $dc261e1a4f8deea7$export$9dde073542957add = ({ status: status })=>status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).RUNNING;
const $dc261e1a4f8deea7$export$e97c36b514061cac = (containers)=>containers.length <= 1;





const $b474aaee01cbac2d$export$4526fb399dbb3dc8 = (s)=>s.serviceContainer;
const $b474aaee01cbac2d$export$b585067996a6a19f = (s)=>s.serviceContainersPage;
const $b474aaee01cbac2d$export$679adc1bee7d9e67 = (s)=>s.coreContainer;
const $b474aaee01cbac2d$export$cde74a8c249634b0 = (s)=>s.coreContainersPage;
const $b474aaee01cbac2d$export$41d946e31f4c5aaa = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($b474aaee01cbac2d$export$679adc1bee7d9e67, 'id', (0, $dc261e1a4f8deea7$export$e49c64d84076eb0e));
const $b474aaee01cbac2d$export$6fffc264c584dcbf = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($b474aaee01cbac2d$export$679adc1bee7d9e67, 'id', (0, $dc261e1a4f8deea7$export$7f65084de65d53e5));
const $b474aaee01cbac2d$export$3dfc90c2e7090475 = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($b474aaee01cbac2d$export$679adc1bee7d9e67, 'id', (0, $dc261e1a4f8deea7$export$9dde073542957add));
const $b474aaee01cbac2d$export$88ac17e423771031 = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($b474aaee01cbac2d$export$4526fb399dbb3dc8, 'id', (0, $dc261e1a4f8deea7$export$e49c64d84076eb0e));
const $b474aaee01cbac2d$export$f0efde4c58bb83b3 = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($b474aaee01cbac2d$export$4526fb399dbb3dc8, 'id', (0, $dc261e1a4f8deea7$export$7f65084de65d53e5));
const $b474aaee01cbac2d$export$50271cc70cef846f = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($b474aaee01cbac2d$export$4526fb399dbb3dc8, 'id', (0, $dc261e1a4f8deea7$export$9dde073542957add));
const $b474aaee01cbac2d$export$9424ad235af7a5ae = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($b474aaee01cbac2d$export$4526fb399dbb3dc8, 'id', (0, $dc261e1a4f8deea7$export$bebb768243e568eb));
const $b474aaee01cbac2d$export$d81294bf4becdd38 = (0, $e926476d3d092144$export$8f6106f24823543e)($b474aaee01cbac2d$export$cde74a8c249634b0, 'id', 'selectStartableLoadedCoreContainers', (0, $dc261e1a4f8deea7$export$e49c64d84076eb0e));
const $b474aaee01cbac2d$export$a2000d1471de8a91 = (0, $e926476d3d092144$export$8f6106f24823543e)($b474aaee01cbac2d$export$cde74a8c249634b0, 'id', 'selectRestartableLoadedCoreContainers', (0, $dc261e1a4f8deea7$export$7f65084de65d53e5));
const $b474aaee01cbac2d$export$4490d5230a68c9b7 = (0, $e926476d3d092144$export$8f6106f24823543e)($b474aaee01cbac2d$export$cde74a8c249634b0, 'id', 'selectStoppableLoadedCoreContainers', (0, $dc261e1a4f8deea7$export$9dde073542957add));
const $b474aaee01cbac2d$export$380069ca056ef14d = (0, $e926476d3d092144$export$8f6106f24823543e)($b474aaee01cbac2d$export$b585067996a6a19f, 'id', 'selectStartableLoadedServiceContainers', (0, $dc261e1a4f8deea7$export$e49c64d84076eb0e));
const $b474aaee01cbac2d$export$c615125b5c5f3a39 = (0, $e926476d3d092144$export$8f6106f24823543e)($b474aaee01cbac2d$export$b585067996a6a19f, 'id', 'selectRestartableLoadedServiceContainers', (0, $dc261e1a4f8deea7$export$7f65084de65d53e5));
const $b474aaee01cbac2d$export$7ca4451abe73539c = (0, $e926476d3d092144$export$8f6106f24823543e)($b474aaee01cbac2d$export$b585067996a6a19f, 'id', 'selectStoppableLoadedServiceContainers', (0, $dc261e1a4f8deea7$export$9dde073542957add));
const $b474aaee01cbac2d$export$9c5d17d4eb33bc70 = (0, $e926476d3d092144$export$8f6106f24823543e)($b474aaee01cbac2d$export$b585067996a6a19f, 'id', 'selectDeletableLoadedServiceContainers', (0, $dc261e1a4f8deea7$export$bebb768243e568eb));






const $20a95c68bb34987c$export$f4e830cc86f40e52 = (endpoint)=>endpoint.status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISABLED;
const $20a95c68bb34987c$export$43384fe56d68ed4 = (endpoint)=>endpoint.status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLED;
const $20a95c68bb34987c$var$baseEndpointComparators = {
    id: null,
    name: null,
    service: null,
    protocol: null,
    operation: null,
    agent: null,
    status: null
};
const $20a95c68bb34987c$export$20395fc2f5195912 = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    ...$20a95c68bb34987c$var$baseEndpointComparators,
    connection: null
}, 'areCybusEndpointEquals');
const $20a95c68bb34987c$export$dd7dae8c7d9140f3 = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    ...$20a95c68bb34987c$var$baseEndpointComparators,
    address: (0, $33cff95ba235ba3b$export$596273409274759),
    rules: (a, b)=>(0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(a) && (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(b) && (0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(a, b, {
            sort: false
        }),
    topics: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)()
}, 'areDetailedCybusEndpointEquals');





const $c18490461364b14c$export$15c224e49a280ac2 = (s)=>s.endpoint;
const $c18490461364b14c$export$cda0de9810c33af4 = (s)=>s.endpointsPage;
const $c18490461364b14c$export$6e6903955a758574 = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($c18490461364b14c$export$15c224e49a280ac2, 'id', (0, $20a95c68bb34987c$export$f4e830cc86f40e52));
const $c18490461364b14c$export$6b7af8c484ac5c0b = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($c18490461364b14c$export$15c224e49a280ac2, 'id', (0, $20a95c68bb34987c$export$43384fe56d68ed4));
const $c18490461364b14c$export$e3f71d2a191ab4b6 = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($c18490461364b14c$export$15c224e49a280ac2, 'id');
const $c18490461364b14c$export$622e2693b8599e36 = (0, $e926476d3d092144$export$8f6106f24823543e)($c18490461364b14c$export$cda0de9810c33af4, 'id', 'selectEnabableLoadedEndpoints', (0, $20a95c68bb34987c$export$f4e830cc86f40e52));
const $c18490461364b14c$export$b2220f653c519314 = (0, $e926476d3d092144$export$8f6106f24823543e)($c18490461364b14c$export$cda0de9810c33af4, 'id', 'selectDisabableLoadedEndpoints', (0, $20a95c68bb34987c$export$43384fe56d68ed4));
const $c18490461364b14c$export$70f64a3afebd30c4 = (0, $e926476d3d092144$export$8f6106f24823543e)($c18490461364b14c$export$cda0de9810c33af4, 'id', 'selectLoadedEndpoints');






const $238a83731a48faba$export$8f7496a65239c6d8 = ({ invalid: invalid, noPermissions: noPermissions, unknown: unknown, shared: shared })=>!(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(invalid) && !(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(noPermissions) && !(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(unknown) && !(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(shared);







class $e7e4681c51bba9d2$var$TopicTreeBuilder {
    constructor(topic){
        this.topic = topic;
        this.isSelected = false;
        this.isCustom = false;
        this.loading = false;
        this.canLoadChildren = false;
        this.siblingError = null;
        this.nextSiblingChunkSize = null;
        this.childNodes = {};
    }
    get name() {
        return this.topic.lastLevel;
    }
    get valid() {
        return this.topic.valid;
    }
    get fullPath() {
        return this.topic.fullPath;
    }
    get selected() {
        return this.isSelected;
    }
    get custom() {
        return this.isCustom;
    }
    get isLoadingSibling() {
        return this.loading;
    }
    get loadingSiblingError() {
        return this.siblingError;
    }
    get nextPageSize() {
        return this.nextSiblingChunkSize;
    }
    get children() {
        return [
            ...(0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(this.childNodes)
        ].sort(([a], [b])=>a > b ? 1 : -1).map(([, value])=>value);
    }
    get hasChildrenToLoad() {
        return this.canLoadChildren;
    }
    /**
     * Recursively generates topics from the current builder tree
     * @param childPath the path below the current topic
     *  IE, if you are at "foo", and want to create the path to "foo/bar", then just pass "bar"
     */ ensureTopic(childPath) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let builder = this;
        let pathLeft = childPath;
        /** Until there is nowhere else to go */ while(pathLeft !== null){
            const [directChildTopic, restOfPath] = builder.topic.createChild(pathLeft);
            (0, $14eddac5f20c576c$export$a7a9523472993e97)(directChildTopic.lastLevel !== null, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'All child topic should have a path by definition'));
            /** Ensure the builder is created within the current builder */ const builderChild = builder.childNodes[directChildTopic.lastLevel] ?? new $e7e4681c51bba9d2$var$TopicTreeBuilder(directChildTopic);
            builder.childNodes = {
                ...builder.childNodes,
                [directChildTopic.lastLevel]: builderChild
            };
            builder = builderChild;
            pathLeft = restOfPath;
        }
        return builder;
    }
    addSelectedTopic(topic) {
        const selectedTopic = this.ensureTopic(topic);
        selectedTopic.isSelected = true;
    }
    addCustomTopic(topic) {
        const customTopic = this.ensureTopic(topic);
        customTopic.isCustom = true;
    }
    addChunks(prefix, chunks) {
        const prefixTopic = this.ensureTopic(prefix);
        for (const chunk of chunks){
            if ((0, $f0717a7650cc5e17$export$281fdbe386b97b06)(chunk)) for (const { name: name, hasChildren: hasChildren } of chunk.topics){
                const topic = prefixTopic.ensureTopic(name);
                topic.canLoadChildren = topic.canLoadChildren || hasChildren;
            }
            else if (chunk === null) {
                (0, $14eddac5f20c576c$export$a7a9523472993e97)(!prefixTopic.loading, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'There is already a loading chunk', {
                    prefix: prefix
                }));
                prefixTopic.loading = true;
            } else {
                (0, $14eddac5f20c576c$export$a7a9523472993e97)(!prefixTopic.siblingError, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'There is already a load chunk error', {
                    prefix: prefix
                }));
                prefixTopic.siblingError = chunk;
            }
        }
        const lastChunk = (0, $9f70c141ac08ef9a$export$109d9d261d61ca16)(chunks);
        if ((0, $f0717a7650cc5e17$export$281fdbe386b97b06)(lastChunk) && lastChunk.nextChunk !== null) prefixTopic.nextSiblingChunkSize = lastChunk.nextChunk.pageSize;
    }
}
const $e7e4681c51bba9d2$export$cc23af0783e021c3 = (tree, topic)=>{
    if (tree.fullPath === topic) return tree;
    /**
     * If this is the root, or the topic starts with this node's path, then check its children
     * Otherwise just yield a null
     */ return (tree.fullPath === null || topic.startsWith(tree.fullPath)) && tree.children.find((c)=>$e7e4681c51bba9d2$export$cc23af0783e021c3(c, topic)) || null;
};
const $e7e4681c51bba9d2$export$8f4a36ff79636a0b = (...[rootTopic, selected, custom, allChunks])=>{
    const tree = new $e7e4681c51bba9d2$var$TopicTreeBuilder(rootTopic);
    selected.forEach((t)=>tree.addSelectedTopic(t));
    custom.forEach((t)=>tree.addCustomTopic(t));
    allChunks.forEach((chunks, prefix)=>tree.addChunks(prefix, chunks));
    return tree;
};
const $e7e4681c51bba9d2$export$a3ec7e7a39bb7dca = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    name: null,
    fullPath: null,
    valid: null,
    hasChildrenToLoad: null,
    selected: null,
    custom: null,
    isLoadingSibling: null,
    loadingSiblingError: null,
    nextPageSize: null,
    children: (a, b)=>(0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(a, b, {
            sort: false,
            equals: $e7e4681c51bba9d2$export$a3ec7e7a39bb7dca
        })
}, 'areTopicTreesEquals');







const $070c3c2fc0eda22c$export$723680c405115633 = (s)=>s.explorer;
const $070c3c2fc0eda22c$export$3c69d3efda9669d4 = (s)=>{
    const explorer = $070c3c2fc0eda22c$export$723680c405115633(s);
    (0, $14eddac5f20c576c$export$a7a9523472993e97)(explorer && !(0, $c3e1b746ad236797$export$8d524fb6540252df).is(explorer), new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Can not retrieve explorer'));
    return explorer;
};
const $070c3c2fc0eda22c$export$dc0906d733d23e62 = (s)=>{
    const explorer = $070c3c2fc0eda22c$export$723680c405115633(s);
    return (0, $c3e1b746ad236797$export$8d524fb6540252df).is(explorer) ? explorer : null;
};
const $070c3c2fc0eda22c$var$createInitializedExplorerSelector = (selector, defaultValue)=>(s, ...args)=>{
        const explorer = $070c3c2fc0eda22c$export$723680c405115633(s);
        return !explorer || (0, $c3e1b746ad236797$export$8d524fb6540252df).is(explorer) ? defaultValue : selector(explorer, args, defaultValue);
    };
const $070c3c2fc0eda22c$export$580f92cfd492a3f6 = $070c3c2fc0eda22c$var$createInitializedExplorerSelector((e)=>e.chunks, new Map());
const $070c3c2fc0eda22c$export$18a4d36a25eb0ba4 = $070c3c2fc0eda22c$var$createInitializedExplorerSelector((e)=>Array.from(e.chunks.keys()), []);
const $070c3c2fc0eda22c$export$f470b43d5107165e = $070c3c2fc0eda22c$var$createInitializedExplorerSelector((e)=>e.customTopics, []);
const $070c3c2fc0eda22c$export$9638cf3323a42fde = $070c3c2fc0eda22c$var$createInitializedExplorerSelector((e)=>e.selectedTopics, []);
const $070c3c2fc0eda22c$export$e05723afac562ff0 = (0, $beec4324cbd609ea$export$6b4e15ccdc547ae7)($070c3c2fc0eda22c$var$createInitializedExplorerSelector(({ selectedTopics: selectedTopics, customTopics: customTopics, chunks: chunks })=>(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(selectedTopics) || (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(customTopics) || Array.from(chunks).some(([, prefixChunks])=>prefixChunks.some((chunk)=>!(0, $f0717a7650cc5e17$export$281fdbe386b97b06)(chunk) || (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(chunk.topics))), false), 'selectExplorerAreTopicAvailable');
const $070c3c2fc0eda22c$export$75eb6fe331ae8a1a = $070c3c2fc0eda22c$var$createInitializedExplorerSelector((e, [topic])=>e.customTopics.includes(topic) || e.selectedTopics.includes(topic) || Array.from(e.chunks).some(([, prefixChunks])=>prefixChunks.some((c)=>(0, $f0717a7650cc5e17$export$281fdbe386b97b06)(c) && c.topics.some((t)=>t.fullPath === topic))), false);
const $070c3c2fc0eda22c$export$a944664ab6756ac5 = $070c3c2fc0eda22c$var$createInitializedExplorerSelector(({ subscriptionResponse: subscriptionResponse }, [fullPath], defaultValue)=>subscriptionResponse === null ? defaultValue : (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)((0, $2ae70427bab197d4$export$12b617052eb9d30e)(subscriptionResponse, 'subscribed')).reduce((r, [errorType, topics])=>topics.includes(fullPath) ? [
            ...r,
            errorType
        ] : r, defaultValue), []);
const $070c3c2fc0eda22c$export$84942bb2424aed3 = $070c3c2fc0eda22c$var$createInitializedExplorerSelector(({ latestValues: latestValues })=>(0, $2ae70427bab197d4$export$ed97f33186d4b816)(latestValues).sort(), []);
const $070c3c2fc0eda22c$export$d8794ef1e9f50e36 = $070c3c2fc0eda22c$var$createInitializedExplorerSelector(({ latestValues: latestValues }, [topic], defaultValue)=>latestValues[topic] ?? defaultValue, null);
const $070c3c2fc0eda22c$export$af9234b6c8bd1d81 = $070c3c2fc0eda22c$var$createInitializedExplorerSelector(({ selectedTopics: selectedTopics, latestValues: latestValues }, [topic], defaultValue)=>{
    const selected = new Set(selectedTopics);
    if (selected.has(topic)) return [
        topic
    ];
    const sources = latestValues[topic]?.sources ?? defaultValue;
    /**
         * Ensuring that the given sources are still subscribed to
         */ return sources.filter((t)=>selected.has(t));
}, []);
const $070c3c2fc0eda22c$export$57cd553a5287edd7 = $070c3c2fc0eda22c$var$createInitializedExplorerSelector((e)=>e.latestValues, {});
const $070c3c2fc0eda22c$export$c992ab88b8f649d = $070c3c2fc0eda22c$var$createInitializedExplorerSelector((e)=>e.tailSize, 0);
const $070c3c2fc0eda22c$export$88a8f23a49d6261e = $070c3c2fc0eda22c$var$createInitializedExplorerSelector((e)=>e.isTailing, null);
const $070c3c2fc0eda22c$export$35fea1eb720660ae = $070c3c2fc0eda22c$var$createInitializedExplorerSelector((e)=>e.tail, []);
const $070c3c2fc0eda22c$export$612929a23c7c1e4c = (s, prefix)=>{
    const chunks = $070c3c2fc0eda22c$export$580f92cfd492a3f6(s).get(prefix);
    if (!chunks) return null;
    const result = (0, $9f70c141ac08ef9a$export$109d9d261d61ca16)(chunks);
    (0, $14eddac5f20c576c$export$a7a9523472993e97)((0, $f0717a7650cc5e17$export$281fdbe386b97b06)(result) && result.nextChunk !== null, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Cannot resolve to next chunk offset', {
        prefix: prefix,
        result: result
    }));
    return result.nextChunk.reference;
};
const $070c3c2fc0eda22c$export$a76e1be6cb0a97ca = $070c3c2fc0eda22c$var$createInitializedExplorerSelector(({ chunks: chunks }, [prefix], defaultValue)=>chunks.get(prefix) ?? defaultValue, []);
const $070c3c2fc0eda22c$export$a6c82c1da1c7b055 = (s, prefix, position)=>{
    const chunk = $070c3c2fc0eda22c$export$a76e1be6cb0a97ca(s, prefix);
    (0, $14eddac5f20c576c$export$a7a9523472993e97)((0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(chunk) && chunk[position] === null, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Unexpected chunk state', {
        prefix: prefix,
        position: position
    }));
    return chunk;
};





const $ee9c60e7a5b417f7$export$f118100f1b195a18 = (s)=>s.license;
const $ee9c60e7a5b417f7$var$createLicenseSelector = (prop)=>(s)=>{
        const license = $ee9c60e7a5b417f7$export$f118100f1b195a18(s);
        return (0, $f0717a7650cc5e17$export$281fdbe386b97b06)(license) ? license[prop] : null;
    };
const $ee9c60e7a5b417f7$export$bd5742f31bcdaad7 = $ee9c60e7a5b417f7$var$createLicenseSelector('id');
const $ee9c60e7a5b417f7$export$67c1501951d364c0 = $ee9c60e7a5b417f7$var$createLicenseSelector('valid');


var $0065e6ee17ac2c80$export$4c17dd9bae91ff0d = /*#__PURE__*/ function(CybusLogLevel) {
    CybusLogLevel["DEBUG"] = "DEBUG";
    CybusLogLevel["ERROR"] = "ERROR";
    CybusLogLevel["FATAL"] = "FATAL";
    CybusLogLevel["INFO"] = "INFO";
    CybusLogLevel["TRACE"] = "TRACE";
    CybusLogLevel["WARN"] = "WARN";
    return CybusLogLevel;
}({});
var $0065e6ee17ac2c80$export$b1c5b8150a1a3cec = /*#__PURE__*/ function(CybusLogSource) {
    CybusLogSource["CONNECTION"] = "CONNECTION";
    CybusLogSource["CORE_CONTAINER"] = "CORE_CONTAINER";
    CybusLogSource["ENDPOINT"] = "ENDPOINT";
    CybusLogSource["MAPPING"] = "MAPPING";
    CybusLogSource["SERVER"] = "SERVER";
    CybusLogSource["SERVICE"] = "SERVICE";
    CybusLogSource["SERVICE_CONTAINER"] = "SERVICE_CONTAINER";
    CybusLogSource["VOLUME"] = "VOLUME";
    return CybusLogSource;
}({});


const $da778fcb2b39c6da$export$62d55b06c6965c86 = (s)=>s.loadingCount > 0;






var $bc868e3ec3b72477$export$5c8c128443e404df = /*#__PURE__*/ function(CybusPubSubType) {
    CybusPubSubType["ENDPOINT"] = "ENDPOINT";
    CybusPubSubType["TOPIC"] = "TOPIC";
    return CybusPubSubType;
}({});
const $bc868e3ec3b72477$export$9cfee36c0f112169 = (service)=>service.status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISABLED;
const $bc868e3ec3b72477$export$b88823ef6a552fb1 = (service)=>service.status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISABLED;
const $bc868e3ec3b72477$export$35bdda6c1d986771 = (service)=>service.status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLED;
const $bc868e3ec3b72477$var$areCybusPubSubsEquals = (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
    type: null,
    id: null,
    externalBroker: null,
    topics: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)(),
    subscriptionErrors: (a, b)=>(0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(Array.from(a), Array.from(b), {
            sort: false
        })
});
const $bc868e3ec3b72477$var$areCybusMappingEntriesEquals = (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
    subscribe: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)($bc868e3ec3b72477$var$areCybusPubSubsEquals),
    publish: $bc868e3ec3b72477$var$areCybusPubSubsEquals,
    rules: (a, b)=>(0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(a) && (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(b) && (0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(a, b, {
            sort: false,
            equals: (0, $33cff95ba235ba3b$export$596273409274759)
        }),
    executionError: null
});
const $bc868e3ec3b72477$var$baseCybusMappingComparators = {
    id: null,
    name: null,
    service: null,
    status: null,
    agent: null
};
const $bc868e3ec3b72477$export$67c0d73e73b217bc = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    ...$bc868e3ec3b72477$var$baseCybusMappingComparators,
    entriesCount: null
}, 'areCybusMappingEquals');
const $bc868e3ec3b72477$export$73104380e5218bec = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    ...$bc868e3ec3b72477$var$baseCybusMappingComparators,
    entries: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)($bc868e3ec3b72477$var$areCybusMappingEntriesEquals)
}, 'areDetailedCybusMappingEquals');






const $220733605f0fc2b5$export$3921ef1972aa52e0 = (s)=>s.mapping;
const $220733605f0fc2b5$export$2ff8b4bfb3d2a5df = (s)=>s.mappingEntries;
const $220733605f0fc2b5$export$77c6c28de80b0eef = (s)=>s.mappingsPage;
const $220733605f0fc2b5$var$createLoadedMappingSelector = (key, defaultValue)=>(s)=>{
        const mapping = $220733605f0fc2b5$export$3921ef1972aa52e0(s);
        if (!mapping || (0, $c3e1b746ad236797$export$8d524fb6540252df).is(mapping)) return defaultValue;
        return mapping[key];
    };
const $220733605f0fc2b5$export$7ca19239db6a3ae7 = $220733605f0fc2b5$var$createLoadedMappingSelector('entries', []);
const $220733605f0fc2b5$export$ecd8059f15c93289 = (s)=>{
    const entries = $220733605f0fc2b5$export$7ca19239db6a3ae7(s);
    /** All the entry topics and mapping back to entries need to be mapped */ const allTopics = [];
    const idToTopics = {};
    entries.forEach(({ subscribe: subscribe, publish: publish })=>{
        const pubSub = [
            ...subscribe,
            publish
        ];
        pubSub.forEach(({ id: id, topics: topics, externalBroker: externalBroker })=>{
            if (externalBroker) return;
            idToTopics[id] = idToTopics[id] || topics;
            allTopics.push(...topics);
        });
    });
    return [
        allTopics,
        idToTopics
    ];
};
const $220733605f0fc2b5$export$569747daf24d8c0a = (0, $e926476d3d092144$export$8f6106f24823543e)($220733605f0fc2b5$export$77c6c28de80b0eef, 'id', 'selectDeletableLoadedMappings', (0, $bc868e3ec3b72477$export$9cfee36c0f112169));
const $220733605f0fc2b5$export$4ec0e5692e6f249c = (0, $e926476d3d092144$export$8f6106f24823543e)($220733605f0fc2b5$export$77c6c28de80b0eef, 'id', 'selectEnabableLoadedMappings', (0, $bc868e3ec3b72477$export$b88823ef6a552fb1));
const $220733605f0fc2b5$export$86d2a80573febb6c = (0, $e926476d3d092144$export$8f6106f24823543e)($220733605f0fc2b5$export$77c6c28de80b0eef, 'id', 'selectDisabableLoadedMappings', (0, $bc868e3ec3b72477$export$35bdda6c1d986771));
const $220733605f0fc2b5$export$495c8147ac571b6d = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($220733605f0fc2b5$export$3921ef1972aa52e0, 'id', (0, $bc868e3ec3b72477$export$9cfee36c0f112169));
const $220733605f0fc2b5$export$aa80e2a417628314 = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($220733605f0fc2b5$export$3921ef1972aa52e0, 'id', (0, $bc868e3ec3b72477$export$b88823ef6a552fb1));
const $220733605f0fc2b5$export$5d11f63b60cf4570 = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($220733605f0fc2b5$export$3921ef1972aa52e0, 'id', (0, $bc868e3ec3b72477$export$35bdda6c1d986771));
const $220733605f0fc2b5$export$f555eb9c70b44e48 = (s)=>{
    const entries = $220733605f0fc2b5$export$2ff8b4bfb3d2a5df(s);
    return (0, $c3e1b746ad236797$export$8d524fb6540252df).is(entries) ? entries : null;
};
const $220733605f0fc2b5$export$c89f7c57bbdaad4c = (s, id)=>{
    const entries = $220733605f0fc2b5$export$2ff8b4bfb3d2a5df(s);
    return !(0, $c3e1b746ad236797$export$8d524fb6540252df).is(entries) && entries?.[id] || null;
};






var $5e13938500eec645$export$c6f9da6f70cfc2eb = /*#__PURE__*/ function(ResourceType) {
    ResourceType["AGENT"] = "AGENT";
    ResourceType["CONNECTION"] = "CONNECTION";
    ResourceType["CORE_CONTAINER"] = "CORE_CONTAINER";
    ResourceType["ENDPOINT"] = "ENDPOINT";
    ResourceType["MAPPING"] = "MAPPING";
    ResourceType["SERVER"] = "SERVER";
    ResourceType["SERVICE"] = "SERVICE";
    ResourceType["SERVICE_CONTAINER"] = "SERVICE_CONTAINER";
    ResourceType["VOLUME"] = "VOLUME";
    return ResourceType;
}({});
const $5e13938500eec645$export$c11350030b6e6fa4 = (s)=>s.resources;
const $5e13938500eec645$export$e9290a5ccd17ff37 = (s, dimension, action)=>$5e13938500eec645$export$c11350030b6e6fa4(s)[dimension][action];



class $5491cfd462130f7a$export$79c7d16c94855997 extends (0, $c3e1b746ad236797$export$8d524fb6540252df) {
    static is(e) {
        return e instanceof $5491cfd462130f7a$export$79c7d16c94855997;
    }
    constructor(extras){
        super((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, 'There was an issue with executing the rule engine', extras);
    }
    get messagePrefix() {
        return this.extras.messagePrefix;
    }
    get messageDetails() {
        return this.extras.messageDetails;
    }
    get ruleName() {
        return this.extras.ruleName;
    }
    get rule() {
        return this.extras.rule;
    }
    get payload() {
        return this.extras.payload;
    }
}
var $5491cfd462130f7a$export$605f39a06a79387c = /*#__PURE__*/ function(RuleEngineType) {
    RuleEngineType["ENDPOINT"] = "ENDPOINT";
    RuleEngineType["JSON"] = "JSON";
    RuleEngineType["MQTT_TOPIC"] = "MQTT_TOPIC";
    return RuleEngineType;
}({});
const $5491cfd462130f7a$export$28db646e631a3c7e = ({ ruleEngineSandbox: ruleEngineSandbox })=>ruleEngineSandbox;
const $5491cfd462130f7a$export$26200e6f60f4189a = (prop)=>(s)=>$5491cfd462130f7a$export$28db646e631a3c7e(s)[prop];




const $a79b5916972014a8$export$7dc9519714001331 = (Server)=>Server.status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISABLED;
const $a79b5916972014a8$export$a0630811f022c903 = (Server)=>Server.status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISABLED;
const $a79b5916972014a8$export$a6c412803fd25277 = (Server)=>Server.status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLED;
const $a79b5916972014a8$export$a18a2f875e4f96c4 = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    id: null,
    service: null,
    name: null,
    status: null,
    protocol: null
}, 'areCybusServersEquals');



const $b6a480063e26497c$export$fef17a864338ee23 = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    id: null,
    service: null,
    name: null,
    status: null,
    parent: null,
    protocol: null,
    operation: null
}, 'areCybusNodesEquals');





const $f26ca34712d97a28$export$87e15bc97bbe9a4a = (s)=>s.server;
const $f26ca34712d97a28$export$818b466ecc63d5f1 = (s)=>s.serversPage;
const $f26ca34712d97a28$export$4d8d89a5c8a05d3e = (s)=>s.nodesPage;
const $f26ca34712d97a28$export$bc68d5ab6318d4e8 = (0, $e926476d3d092144$export$8f6106f24823543e)($f26ca34712d97a28$export$818b466ecc63d5f1, 'id', 'selectDisablableLoadedServers', (0, $a79b5916972014a8$export$a6c412803fd25277));
const $f26ca34712d97a28$export$abcdceac2ad6bded = (0, $e926476d3d092144$export$8f6106f24823543e)($f26ca34712d97a28$export$818b466ecc63d5f1, 'id', 'selectEnabableLoadedServers', (0, $a79b5916972014a8$export$7dc9519714001331));
const $f26ca34712d97a28$export$8c41444bcf536591 = (0, $e926476d3d092144$export$8f6106f24823543e)($f26ca34712d97a28$export$818b466ecc63d5f1, 'id', 'selectDeletableLoadedServers', (0, $a79b5916972014a8$export$a0630811f022c903));
const $f26ca34712d97a28$export$469eef6cf7a292fc = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($f26ca34712d97a28$export$87e15bc97bbe9a4a, 'id', (0, $a79b5916972014a8$export$a6c412803fd25277));
const $f26ca34712d97a28$export$817f98e6c3192618 = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($f26ca34712d97a28$export$87e15bc97bbe9a4a, 'id', (0, $a79b5916972014a8$export$7dc9519714001331));
const $f26ca34712d97a28$export$cec3a3062033c610 = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($f26ca34712d97a28$export$87e15bc97bbe9a4a, 'id', (0, $a79b5916972014a8$export$a0630811f022c903));






const $e8356e494d58a419$export$3523073818ab01af = (schema)=>(0, $f0717a7650cc5e17$export$281fdbe386b97b06)(schema);
const $e8356e494d58a419$export$4b8c8489f202ce0c = (file)=>(0, $f0717a7650cc5e17$export$281fdbe386b97b06)(file);
const $e8356e494d58a419$export$596b4af045cf788a = (property)=>(0, $66f4d76e5f79376d$export$8afc0f4daad61937)(property) && property.secret === true;
/**
 * A `secret: true` property declared `type: 'string'` — the only shape the write-only masking
 * widget (`SecretParameterWidget`) can render, and the only shape the ticket's own spec allows a
 * secret parameter definition to have (service-manager's `baseSchema.yml` only lets a string
 * parameter definition declare `secret: true`). A secret property of any other type (e.g. array)
 * still has its value stripped like any other secret (see `getSecretParameterNames`); it just falls
 * through to rjsf's normal, unmasked rendering for its type instead of being assigned the widget.
 */ const $e8356e494d58a419$var$isMaskableSecretProperty = (property)=>(0, $66f4d76e5f79376d$export$8afc0f4daad61937)(property) && property.secret === true && property.type === 'string';
const $e8356e494d58a419$var$getParameterNamesMatching = (schema, matches)=>{
    const { properties: properties } = schema;
    if (!(0, $66f4d76e5f79376d$export$8afc0f4daad61937)(properties)) return [];
    return Object.entries(properties).filter(([, property])=>matches(property)).map(([name])=>name);
};
const $e8356e494d58a419$export$67ede92ee8549a68 = (schema)=>$e8356e494d58a419$var$getParameterNamesMatching(schema, $e8356e494d58a419$export$596b4af045cf788a);
const $e8356e494d58a419$export$5a4a14ee0306f811 = (schema)=>$e8356e494d58a419$var$getParameterNamesMatching(schema, $e8356e494d58a419$var$isMaskableSecretProperty);



class $2918297897f2f622$export$515a7b7930693557 extends (0, $c3e1b746ad236797$export$8d524fb6540252df) {
    static is(e) {
        return e instanceof $2918297897f2f622$export$515a7b7930693557;
    }
    constructor(/**
         * The list of errors obtained while parsing the commissioning file
         *
         * @example Map<"property path" | null, "error message">
         */ parseErrors){
        super((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST, 'Given commissioning file is invalid', {
            errors: Array.from(parseErrors)
        }), this.parseErrors = parseErrors;
    }
}



class $1ad670b228c881bd$export$8d7d121236284350 extends (0, $c3e1b746ad236797$export$8d524fb6540252df) {
    static is(e) {
        return e instanceof $1ad670b228c881bd$export$8d7d121236284350;
    }
    constructor(translation){
        super((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVICE_CREATION_ERROR, 'Could not create service', {
            translation: translation
        });
    }
    get translation() {
        return this.extras.translation;
    }
}



const $093569cca634f702$export$122eb2a8254b9d8 = (0, $33cff95ba235ba3b$export$596273409274759);
const $093569cca634f702$export$dd0c4ae66199f158 = (0, $33cff95ba235ba3b$export$596273409274759);



const $940a6604ef0427ec$export$17ec1c9b9eabc75c = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    actual: null,
    expected: null,
    resourceId: null,
    reason: null
}, 'areCybusResourceDeviationsEqual');
const $940a6604ef0427ec$export$6105be03e969654c = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    id: null
}, 'areCybusServiceDeviationsEquals');



var $d7e1ff559b364dab$export$b459d70d11da43d5 = /*#__PURE__*/ function(CybusServiceDataResourceType) {
    CybusServiceDataResourceType["ENDPOINT"] = "ENDPOINT";
    CybusServiceDataResourceType["MAPPING"] = "MAPPING";
    CybusServiceDataResourceType["NODE"] = "NODE";
    return CybusServiceDataResourceType;
}({});
const $d7e1ff559b364dab$export$a6d965fc5a510a2a = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    id: null,
    type: null,
    topics: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)()
}, 'areCybusServiceDataResourceEquals');





const $c091d3dc2d3f37db$export$29e593b5864265d1 = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    id: null,
    name: null,
    version: null,
    resourceDeviationsCount: null
}, 'areCybusDeviatedServiceEquals');
const $c091d3dc2d3f37db$var$areCybusServiceLinkEquals = (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
    name: null,
    href: null
});
const $c091d3dc2d3f37db$var$cybusServiceComparators = {
    id: null,
    name: null,
    version: null,
    status: null,
    deviation: null,
    links: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)($c091d3dc2d3f37db$var$areCybusServiceLinkEquals)
};
const $c091d3dc2d3f37db$export$23b70a04b71a1733 = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)($c091d3dc2d3f37db$var$cybusServiceComparators, 'areCybusServiceEquals');
const $c091d3dc2d3f37db$export$e5007f342b68b3d = (a, b)=>(0, $33cff95ba235ba3b$export$596273409274759)(a, b, {
        equals: (pA, pB)=>(0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(pA) && (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(pB) ? (0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(pA, pB, {
                sort: false
            }) : pA === pB
    });
const $c091d3dc2d3f37db$export$956c8f416cd2f31a = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    ...$c091d3dc2d3f37db$var$cybusServiceComparators,
    icon: null,
    provider: null,
    description: null,
    parameters: $c091d3dc2d3f37db$export$e5007f342b68b3d,
    configuredResources: (0, $093569cca634f702$export$122eb2a8254b9d8),
    availableResources: (0, $093569cca634f702$export$dd0c4ae66199f158),
    resourceDeviationsCount: null,
    dependencies: (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
        dependsOn: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)(),
        dependent: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)()
    })
}, 'areDetailedCybusServiceEquals');
const $c091d3dc2d3f37db$export$4a083955540172bd = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    id: null,
    name: null,
    links: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)($c091d3dc2d3f37db$var$areCybusServiceLinkEquals)
}, 'areLinkedCybusServiceEquals');
const $c091d3dc2d3f37db$export$8883ec02c9ab9cac = (service)=>service.status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISABLED;
const $c091d3dc2d3f37db$export$278c4671b9ea60a3 = (service)=>service.status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLED;
const $c091d3dc2d3f37db$export$2a4ae1ab14c1da18 = ({ configuredResources: configuredResources })=>Object.values(configuredResources).some((r)=>r > 0);






const $d8a939fc8bdc4e6b$export$b1d3fd5cbfd0565e = (s)=>s.service;
const $d8a939fc8bdc4e6b$export$240c9122a0549c0f = (s)=>s.servicesDataPage;
const $d8a939fc8bdc4e6b$export$3a98fe926d42f6a0 = (s)=>{
    const page = $d8a939fc8bdc4e6b$export$240c9122a0549c0f(s);
    return page && page.data && !(0, $c3e1b746ad236797$export$8d524fb6540252df).is(page.data) && page.data.current ? page.data.current.flatMap((r)=>r.topics) : [];
};
const $d8a939fc8bdc4e6b$export$c73643a1640d8b9e = (s)=>s.serviceTopicsMessages;
const $d8a939fc8bdc4e6b$export$5accc1ee7a9a1dac = (s)=>s.servicesPage;
const $d8a939fc8bdc4e6b$export$8295a43c0a85c66f = (s)=>s.deviatedServicesPage;
const $d8a939fc8bdc4e6b$export$91b6dafec275fd10 = (s)=>s.resourceDeviationPage;
const $d8a939fc8bdc4e6b$export$df592b9413ed56f3 = (s)=>s.servicesLinksPage;
const $d8a939fc8bdc4e6b$export$dc85b0c2a4f8ef64 = (s)=>s.serviceForm;
const $d8a939fc8bdc4e6b$export$db7570957be2f41c = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($d8a939fc8bdc4e6b$export$b1d3fd5cbfd0565e, 'id', (0, $c091d3dc2d3f37db$export$278c4671b9ea60a3));
const $d8a939fc8bdc4e6b$export$cfcd7bbf606e399 = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($d8a939fc8bdc4e6b$export$b1d3fd5cbfd0565e, 'id');
const $d8a939fc8bdc4e6b$export$c8149c820c4d2e01 = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($d8a939fc8bdc4e6b$export$b1d3fd5cbfd0565e, 'id', (0, $c091d3dc2d3f37db$export$8883ec02c9ab9cac));
const $d8a939fc8bdc4e6b$export$365b9a61b3676716 = (0, $e926476d3d092144$export$8f6106f24823543e)($d8a939fc8bdc4e6b$export$5accc1ee7a9a1dac, 'id', 'selectDisablableLoadedServices', (0, $c091d3dc2d3f37db$export$278c4671b9ea60a3));
const $d8a939fc8bdc4e6b$export$f2983dcfc827a39c = (0, $e926476d3d092144$export$8f6106f24823543e)($d8a939fc8bdc4e6b$export$5accc1ee7a9a1dac, 'id', 'selectDeletableLoadedServices');
/**
 *  @param transformData - Function that formats or transform the data into a desired format
 *  @param fallback - Default value returned when the data is missing
 *  @param name - Name of the function
 *
 *  @returns selector function that either returns transformed data or provides a fallback value
 */ const $d8a939fc8bdc4e6b$var$createDeviationsPageSelector = (transformData, fallback, name)=>(0, $beec4324cbd609ea$export$6b4e15ccdc547ae7)(({ serviceDeviationsPage: serviceDeviationsPage })=>{
        if (serviceDeviationsPage === null || serviceDeviationsPage.data === null || (0, $c3e1b746ad236797$export$8d524fb6540252df).is(serviceDeviationsPage.data)) return fallback;
        const { current: current, totalCount: totalCount } = serviceDeviationsPage.data;
        const { page: page, pageSize: pageSize } = serviceDeviationsPage.pagination;
        return transformData({
            current: current,
            page: page,
            pageSize: pageSize,
            totalCount: totalCount
        });
    }, name);
const $d8a939fc8bdc4e6b$export$d2a9b20bfb5db65f = $d8a939fc8bdc4e6b$var$createDeviationsPageSelector((pageData)=>pageData, null, 'selectServiceDeviationPage');





const $d5b2f7653d87e9de$export$236b6ad6452b27f9 = (s)=>s.info;
const $d5b2f7653d87e9de$export$c0f1a70937d72968 = (s)=>s.versions;
const $d5b2f7653d87e9de$export$45f532a7dd683b77 = (s)=>{
    const versions = $d5b2f7653d87e9de$export$c0f1a70937d72968(s);
    return versions && !(0, $c3e1b746ad236797$export$8d524fb6540252df).is(versions) && versions.connectware !== versions.ui ? versions : null;
};




const $2ac73d5fe610e8da$export$638aea850a86a555 = {
    order: [],
    hidden: [],
    pinned: [],
    widths: {}
};
const $2ac73d5fe610e8da$var$onlyColumns = (names, saved)=>names.filter((name)=>saved.includes(name));
/** The columns in the user's order, before pinning: columns the saved order lacks keep their default place */ const $2ac73d5fe610e8da$var$baseOrder = (names, { order: order })=>{
    const ordered = $2ac73d5fe610e8da$var$onlyColumns(names, order).slice().sort((a, b)=>order.indexOf(a) - order.indexOf(b));
    names.forEach((name, defaultIndex)=>{
        if (!order.includes(name)) ordered.splice(Math.min(defaultIndex, ordered.length), 0, name);
    });
    return ordered;
};
const $2ac73d5fe610e8da$var$isSameOrder = (a, b)=>a.length === b.length && a.every((name, index)=>name === b[index]);
const $2ac73d5fe610e8da$var$isValidWidth = (width)=>Number.isFinite(width) && width > 0;
const $2ac73d5fe610e8da$var$onlyColumnWidths = (names, widths)=>names.reduce((r, name)=>{
        const width = widths[name];
        return width !== undefined && $2ac73d5fe610e8da$var$isValidWidth(width) ? {
            ...r,
            [name]: width
        } : r;
    }, {});
/** Drops names that aren't columns, duplicates and invalid widths, and stores no order when it's the default one */ const $2ac73d5fe610e8da$var$prune = (names, view)=>{
    const order = $2ac73d5fe610e8da$var$baseOrder(names, view);
    return {
        order: $2ac73d5fe610e8da$var$isSameOrder(order, names) ? [] : order,
        hidden: $2ac73d5fe610e8da$var$onlyColumns(names, view.hidden),
        pinned: $2ac73d5fe610e8da$var$onlyColumns(names, view.pinned),
        widths: $2ac73d5fe610e8da$var$onlyColumnWidths(names, view.widths)
    };
};
const $2ac73d5fe610e8da$export$e1be355857979d95 = (names, view)=>{
    const { order: order, hidden: hidden, pinned: pinned, widths: widths } = $2ac73d5fe610e8da$var$prune(names, view);
    return order.length === 0 && hidden.length === 0 && pinned.length === 0 && Object.keys(widths).length === 0;
};
const $2ac73d5fe610e8da$export$ac763d2b0470e663 = (names, view)=>{
    const ordered = $2ac73d5fe610e8da$var$baseOrder(names, view);
    return [
        ...ordered.filter((name)=>view.pinned.includes(name)),
        ...ordered.filter((name)=>!view.pinned.includes(name))
    ];
};
const $2ac73d5fe610e8da$export$1b6de485b4f669da = (names, view)=>{
    const ordered = $2ac73d5fe610e8da$export$ac763d2b0470e663(names, view);
    const visible = ordered.filter((name)=>!view.hidden.includes(name));
    const [first] = ordered;
    return visible.length > 0 || first === undefined ? visible : [
        first
    ];
};
const $2ac73d5fe610e8da$export$d643e649b02b904a = (names, view, name)=>{
    if (!names.includes(name)) return $2ac73d5fe610e8da$var$prune(names, view);
    if (view.hidden.includes(name)) return $2ac73d5fe610e8da$var$prune(names, {
        ...view,
        hidden: view.hidden.filter((hidden)=>hidden !== name)
    });
    return $2ac73d5fe610e8da$var$prune(names, $2ac73d5fe610e8da$export$1b6de485b4f669da(names, view).length > 1 ? {
        ...view,
        hidden: [
            ...view.hidden,
            name
        ]
    } : view);
};
const $2ac73d5fe610e8da$export$947f0ad0b9bf6750 = (names, view, name)=>{
    if (!names.includes(name)) return $2ac73d5fe610e8da$var$prune(names, view);
    return $2ac73d5fe610e8da$var$prune(names, {
        ...view,
        pinned: view.pinned.includes(name) ? view.pinned.filter((pinned)=>pinned !== name) : [
            ...view.pinned,
            name
        ]
    });
};
const $2ac73d5fe610e8da$export$d1fbe0eb3fc9219 = (names, view, name, target)=>{
    const ordered = $2ac73d5fe610e8da$var$baseOrder(names, view).slice();
    const from = ordered.indexOf(name);
    const to = ordered.indexOf(target);
    if (from === -1 || to === -1) return $2ac73d5fe610e8da$var$prune(names, view);
    ordered.splice(from, 1);
    ordered.splice(to, 0, name);
    return $2ac73d5fe610e8da$var$prune(names, {
        ...view,
        order: ordered
    });
};
const $2ac73d5fe610e8da$export$2e875294f1e55b35 = (names, view, name, width, minWidth)=>{
    (0, $14eddac5f20c576c$export$a7a9523472993e97)(Number.isFinite(minWidth) && minWidth > 0, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'A column minimum width must be a positive number', {
        minWidth: minWidth
    }));
    if (!names.includes(name) || !Number.isFinite(width)) return $2ac73d5fe610e8da$var$prune(names, view);
    return $2ac73d5fe610e8da$var$prune(names, {
        ...view,
        widths: {
            ...view.widths,
            [name]: Math.max(Math.round(width), Math.ceil(minWidth))
        }
    });
};
const $2ac73d5fe610e8da$export$1184d6eee78c7c79 = (names, view)=>$2ac73d5fe610e8da$var$onlyColumnWidths(names, view.widths);



var $40a99dac858c1d75$export$b63289fbda65eed1 = /*#__PURE__*/ function(Translation) {
    Translation["ACTION"] = "ACTION";
    Translation["ACTIVE_ROLE"] = "ACTIVE_ROLE";
    Translation["ACTIVE_USER"] = "ACTIVE_USER";
    Translation["ACTUAL"] = "ACTUAL";
    Translation["ADD"] = "ADD";
    Translation["ADD_CERTIFICATE"] = "ADD_CERTIFICATE";
    Translation["ADD_CUSTOM_TOPIC"] = "ADD_CUSTOM_TOPIC";
    Translation["ADD_PERMISSION"] = "ADD_PERMISSION";
    Translation["ADDITIONAL_PERMISSION"] = "ADDITIONAL_PERMISSION";
    Translation["ADDRESS"] = "ADDRESS";
    Translation["ADVANCED_MODE"] = "ADVANCED_MODE";
    Translation["AGENT"] = "AGENT";
    Translation["AGENT_DOCUMENTATION_BODY"] = "AGENT_DOCUMENTATION_BODY";
    Translation["AGENT_DOCUMENTATION_TITLE"] = "AGENT_DOCUMENTATION_TITLE";
    Translation["ALL_RAW_LOGS"] = "ALL_RAW_LOGS";
    Translation["ALLOW"] = "ALLOW";
    Translation["ALTERNATIVE_NAME"] = "ALTERNATIVE_NAME";
    Translation["APPLICATION_TITLE"] = "APPLICATION_TITLE";
    Translation["APPLY"] = "APPLY";
    Translation["ASK_YOUR_ADMIN_TO_GAIN_ACCESS"] = "ASK_YOUR_ADMIN_TO_GAIN_ACCESS";
    Translation["AUTHENTICATION_ERROR"] = "AUTHENTICATION_ERROR";
    Translation["AUTHENTICATION_ERROR_TITLE"] = "AUTHENTICATION_ERROR_TITLE";
    Translation["AUTHENTICATION_METHODS"] = "AUTHENTICATION_METHODS";
    Translation["AUTHORIZATION_REQUIRED"] = "AUTHORIZATION_REQUIRED";
    Translation["AUTHORIZATION_REQUIRED_DOCUMENTATION_BODY"] = "AUTHORIZATION_REQUIRED_DOCUMENTATION_BODY";
    Translation["AUTHORIZATION_REQUIRED_DOCUMENTATION_BODY_ITEM"] = "AUTHORIZATION_REQUIRED_DOCUMENTATION_BODY_ITEM";
    Translation["AUTHORIZE_SERVICE_REQUIREMENTS"] = "AUTHORIZE_SERVICE_REQUIREMENTS";
    Translation["AUTO_FIT_COLUMNS"] = "AUTO_FIT_COLUMNS";
    Translation["AVAILABLE_TOPICS"] = "AVAILABLE_TOPICS";
    Translation["BACK_TO_LOGIN"] = "BACK_TO_LOGIN";
    Translation["BASIC_CONSTRAINT"] = "BASIC_CONSTRAINT";
    Translation["BOOLEAN"] = "BOOLEAN";
    Translation["BROKER"] = "BROKER";
    Translation["BUFFER_TOO_LARGE_TO_BE_DISPLAYED"] = "BUFFER_TOO_LARGE_TO_BE_DISPLAYED";
    Translation["BULK_ACTION_CONNECT_CONNECTIONS_ERROR"] = "BULK_ACTION_CONNECT_CONNECTIONS_ERROR";
    Translation["BULK_ACTION_DELETE_AGENTS_ERROR"] = "BULK_ACTION_DELETE_AGENTS_ERROR";
    Translation["BULK_ACTION_DELETE_SERVICES_ERROR"] = "BULK_ACTION_DELETE_SERVICES_ERROR";
    Translation["BULK_ACTION_DISABLE_CONTAINERS_ERROR"] = "BULK_ACTION_DISABLE_CONTAINERS_ERROR";
    Translation["BULK_ACTION_DISABLE_ENDPOINTS_ERROR"] = "BULK_ACTION_DISABLE_ENDPOINTS_ERROR";
    Translation["BULK_ACTION_DISABLE_MAPPINGS_ERROR"] = "BULK_ACTION_DISABLE_MAPPINGS_ERROR";
    Translation["BULK_ACTION_DISABLE_SERVERS_ERROR"] = "BULK_ACTION_DISABLE_SERVERS_ERROR";
    Translation["BULK_ACTION_DISABLE_SERVICES_ERROR"] = "BULK_ACTION_DISABLE_SERVICES_ERROR";
    Translation["BULK_ACTION_DISCONNECT_CONNECTIONS_ERROR"] = "BULK_ACTION_DISCONNECT_CONNECTIONS_ERROR";
    Translation["BULK_ACTION_ENABLE_CONTAINERS_ERROR"] = "BULK_ACTION_ENABLE_CONTAINERS_ERROR";
    Translation["BULK_ACTION_ENABLE_ENDPOINTS_ERROR"] = "BULK_ACTION_ENABLE_ENDPOINTS_ERROR";
    Translation["BULK_ACTION_ENABLE_MAPPINGS_ERROR"] = "BULK_ACTION_ENABLE_MAPPINGS_ERROR";
    Translation["BULK_ACTION_ENABLE_SERVERS_ERROR"] = "BULK_ACTION_ENABLE_SERVERS_ERROR";
    Translation["BULK_ACTION_ENABLE_SERVICES_ERROR"] = "BULK_ACTION_ENABLE_SERVICES_ERROR";
    Translation["BULK_ACTION_RE_ENABLE_CONTAINERS_ERROR"] = "BULK_ACTION_RE_ENABLE_CONTAINERS_ERROR";
    Translation["BULK_DISABLE_SERVICES_CONFIRMATION"] = "BULK_DISABLE_SERVICES_CONFIRMATION";
    Translation["CANCEL"] = "CANCEL";
    Translation["CANNOT_AUTHENTICATE"] = "CANNOT_AUTHENTICATE";
    Translation["CERTIFICATE_AUTHORITY"] = "CERTIFICATE_AUTHORITY";
    Translation["CERTIFICATE_PROPERTY_NOT_PROVIDED"] = "CERTIFICATE_PROPERTY_NOT_PROVIDED";
    Translation["CERTIFICATE_VIEWER_TITLE"] = "CERTIFICATE_VIEWER_TITLE";
    Translation["CERTIFICATES"] = "CERTIFICATES";
    Translation["CERTIFICATES_DETAILS_DOCUMENTATION_BODY"] = "CERTIFICATES_DETAILS_DOCUMENTATION_BODY";
    Translation["CERTIFICATES_DETAILS_DOCUMENTATION_TITLE"] = "CERTIFICATES_DETAILS_DOCUMENTATION_TITLE";
    Translation["CHANGE_PASSWORD"] = "CHANGE_PASSWORD";
    Translation["CHANGE_PASSWORD_DESCRIPTION"] = "CHANGE_PASSWORD_DESCRIPTION";
    Translation["CLASS_NAME"] = "CLASS_NAME";
    Translation["CLEAR"] = "CLEAR";
    Translation["CLIENT_REGISTRATION_FAILED"] = "CLIENT_REGISTRATION_FAILED";
    Translation["CLIENT_REGISTRY"] = "CLIENT_REGISTRY";
    Translation["CLIENT_REGISTRY_DOCUMENTATION_BODY"] = "CLIENT_REGISTRY_DOCUMENTATION_BODY";
    Translation["CLIENT_REGISTRY_DOCUMENTATION_TITLE"] = "CLIENT_REGISTRY_DOCUMENTATION_TITLE";
    Translation["CLIENT_REGISTRY_NO_REQUESTS"] = "CLIENT_REGISTRY_NO_REQUESTS";
    Translation["CLIENT_REGISTRY_SELF_REGISTRATION"] = "CLIENT_REGISTRY_SELF_REGISTRATION";
    Translation["CLOSE"] = "CLOSE";
    Translation["CNC_TYPE"] = "CNC_TYPE";
    Translation["COLLECTED_DAILY_METRICS_TITLE"] = "COLLECTED_DAILY_METRICS_TITLE";
    Translation["COLLECTED_HOURLY_METRICS_TITLE"] = "COLLECTED_HOURLY_METRICS_TITLE";
    Translation["COLUMN_DRAG_CANCEL"] = "COLUMN_DRAG_CANCEL";
    Translation["COLUMN_DRAG_END"] = "COLUMN_DRAG_END";
    Translation["COLUMN_DRAG_INSTRUCTIONS"] = "COLUMN_DRAG_INSTRUCTIONS";
    Translation["COLUMN_DRAG_OVER"] = "COLUMN_DRAG_OVER";
    Translation["COLUMN_DRAG_START"] = "COLUMN_DRAG_START";
    Translation["COLUMNS"] = "COLUMNS";
    Translation["COMMISSIONING_FILE"] = "COMMISSIONING_FILE";
    Translation["COMMISSIONING_FILE_PARSING_ERROR"] = "COMMISSIONING_FILE_PARSING_ERROR";
    Translation["COMMON_NAME"] = "COMMON_NAME";
    Translation["CONFIGURATION"] = "CONFIGURATION";
    Translation["CONFIGURE_COLUMNS"] = "CONFIGURE_COLUMNS";
    Translation["CONFIRM_PASSWORD"] = "CONFIRM_PASSWORD";
    Translation["CONNECT"] = "CONNECT";
    Translation["CONNECT_CONNECTIONS"] = "CONNECT_CONNECTIONS";
    Translation["CONNECT_CONNECTIONS_SUBTITLE"] = "CONNECT_CONNECTIONS_SUBTITLE";
    Translation["CONNECTING"] = "CONNECTING";
    Translation["CONNECTION"] = "CONNECTION";
    Translation["CONNECTION_DETAILS_DOCUMENTATION_BODY"] = "CONNECTION_DETAILS_DOCUMENTATION_BODY";
    Translation["CONNECTION_DETAILS_DOCUMENTATION_TITLE"] = "CONNECTION_DETAILS_DOCUMENTATION_TITLE";
    Translation["CONNECTION_ID"] = "CONNECTION_ID";
    Translation["CONNECTION_LOGS"] = "CONNECTION_LOGS";
    Translation["CONNECTION_NOT_FOUND"] = "CONNECTION_NOT_FOUND";
    Translation["CONNECTIONS_DOCUMENTATION_BODY"] = "CONNECTIONS_DOCUMENTATION_BODY";
    Translation["CONNECTIONS_DOCUMENTATION_TITLE"] = "CONNECTIONS_DOCUMENTATION_TITLE";
    Translation["CONNECTWARE_NEW_SELF_HOSTED_APPLIANCE_VERSION"] = "CONNECTWARE_NEW_SELF_HOSTED_APPLIANCE_VERSION";
    Translation["CONNECTWARE_SLOGAN"] = "CONNECTWARE_SLOGAN";
    Translation["CONNECTWARE_VERSION"] = "CONNECTWARE_VERSION";
    Translation["CONNECTWARE_VERSION_INFORMATION"] = "CONNECTWARE_VERSION_INFORMATION";
    Translation["CONTACT_YOUR_ADMINISTRATOR"] = "CONTACT_YOUR_ADMINISTRATOR";
    Translation["CONTAINER"] = "CONTAINER";
    Translation["CONTAINER_DETAILS_DOCUMENTATION_BODY"] = "CONTAINER_DETAILS_DOCUMENTATION_BODY";
    Translation["CONTAINER_DETAILS_DOCUMENTATION_TITLE"] = "CONTAINER_DETAILS_DOCUMENTATION_TITLE";
    Translation["CONTAINER_ID"] = "CONTAINER_ID";
    Translation["CONTAINER_LOGS"] = "CONTAINER_LOGS";
    Translation["CONTAINER_NOT_FOUND"] = "CONTAINER_NOT_FOUND";
    Translation["CONTAINERS_DOCUMENTATION_BODY"] = "CONTAINERS_DOCUMENTATION_BODY";
    Translation["CONTAINERS_DOCUMENTATION_TITLE"] = "CONTAINERS_DOCUMENTATION_TITLE";
    Translation["CONTEXT"] = "CONTEXT";
    Translation["COPIED_TO_CLIPBOARD"] = "COPIED_TO_CLIPBOARD";
    Translation["COPY_LICENSE_ID"] = "COPY_LICENSE_ID";
    Translation["COPY_PERMISSIONS"] = "COPY_PERMISSIONS";
    Translation["COPY_TO_CLIPBOARD"] = "COPY_TO_CLIPBOARD";
    Translation["CORE_CONTAINER_DETAILS_DOCUMENTATION_BODY"] = "CORE_CONTAINER_DETAILS_DOCUMENTATION_BODY";
    Translation["CORE_CONTAINER_DETAILS_DOCUMENTATION_TITLE"] = "CORE_CONTAINER_DETAILS_DOCUMENTATION_TITLE";
    Translation["CORE_CONTAINERS_DOCUMENTATION_BODY"] = "CORE_CONTAINERS_DOCUMENTATION_BODY";
    Translation["CORE_CONTAINERS_DOCUMENTATION_TITLE"] = "CORE_CONTAINERS_DOCUMENTATION_TITLE";
    Translation["CREATE"] = "CREATE";
    Translation["CREATE_ROLE"] = "CREATE_ROLE";
    Translation["CREATE_USER"] = "CREATE_USER";
    Translation["CREATED_AT"] = "CREATED_AT";
    Translation["CREDENTIALS"] = "CREDENTIALS";
    Translation["CSR_COMMON_NAME_ISSUE"] = "CSR_COMMON_NAME_ISSUE";
    Translation["CURRENT_PASSWORD"] = "CURRENT_PASSWORD";
    Translation["CYBUS_PORTAL"] = "CYBUS_PORTAL";
    Translation["CYBUS_PORTAL_STATUS"] = "CYBUS_PORTAL_STATUS";
    Translation["CYBUS_REGISTRY"] = "CYBUS_REGISTRY";
    Translation["CYBUS_REGISTRY_STATUS"] = "CYBUS_REGISTRY_STATUS";
    Translation["DATA"] = "DATA";
    Translation["DATA_EXPLORER"] = "DATA_EXPLORER";
    Translation["DATA_EXPLORER_DOCUMENTATION_BODY"] = "DATA_EXPLORER_DOCUMENTATION_BODY";
    Translation["DATA_EXPLORER_DOCUMENTATION_TITLE"] = "DATA_EXPLORER_DOCUMENTATION_TITLE";
    Translation["DATE"] = "DATE";
    Translation["DATETIME"] = "DATETIME";
    Translation["DELETE"] = "DELETE";
    Translation["DELETE_AGENTS"] = "DELETE_AGENTS";
    Translation["DELETE_AGENTS_SUBTITLE"] = "DELETE_AGENTS_SUBTITLE";
    Translation["DELETE_CERTIFICATE_CONFIRMATION"] = "DELETE_CERTIFICATE_CONFIRMATION";
    Translation["DELETE_CONNECTIONS"] = "DELETE_CONNECTIONS";
    Translation["DELETE_CONNECTIONS_SUBTITLE"] = "DELETE_CONNECTIONS_SUBTITLE";
    Translation["DELETE_CONTAINERS"] = "DELETE_CONTAINERS";
    Translation["DELETE_CONTAINERS_SUBTITLE"] = "DELETE_CONTAINERS_SUBTITLE";
    Translation["DELETE_ENDPOINTS"] = "DELETE_ENDPOINTS";
    Translation["DELETE_ENDPOINTS_SUBTITLE"] = "DELETE_ENDPOINTS_SUBTITLE";
    Translation["DELETE_MAPPINGS"] = "DELETE_MAPPINGS";
    Translation["DELETE_MAPPINGS_SUBTITLE"] = "DELETE_MAPPINGS_SUBTITLE";
    Translation["DELETE_ROLE_CONFIRMATION"] = "DELETE_ROLE_CONFIRMATION";
    Translation["DELETE_SERVERS"] = "DELETE_SERVERS";
    Translation["DELETE_SERVERS_SUBTITLE"] = "DELETE_SERVERS_SUBTITLE";
    Translation["DELETE_SERVICES"] = "DELETE_SERVICES";
    Translation["DELETE_SERVICES_SUBTITLE"] = "DELETE_SERVICES_SUBTITLE";
    Translation["DELETE_USER_CONFIRMATION"] = "DELETE_USER_CONFIRMATION";
    Translation["DELETE_VOLUMES"] = "DELETE_VOLUMES";
    Translation["DELETE_VOLUMES_SUBTITLE"] = "DELETE_VOLUMES_SUBTITLE";
    Translation["DEPENDS_ON_SERVICES"] = "DEPENDS_ON_SERVICES";
    Translation["DESCRIPTION"] = "DESCRIPTION";
    Translation["DEVIATED_RESOURCES"] = "DEVIATED_RESOURCES";
    Translation["DEVIATED_SERVICES"] = "DEVIATED_SERVICES";
    Translation["DEVIATED_SERVICES_DOCUMENTATION_BODY"] = "DEVIATED_SERVICES_DOCUMENTATION_BODY";
    Translation["DEVIATED_SERVICES_DOCUMENTATION_TITLE"] = "DEVIATED_SERVICES_DOCUMENTATION_TITLE";
    Translation["DEVIATION"] = "DEVIATION";
    Translation["DEVIATION_DETECTED"] = "DEVIATION_DETECTED";
    Translation["DEVIATION_NEW_TOAST"] = "DEVIATION_NEW_TOAST";
    Translation["DEVIATION_POPOVER_MORE"] = "DEVIATION_POPOVER_MORE";
    Translation["DEVIATION_RESOLVED"] = "DEVIATION_RESOLVED";
    Translation["DEVIATION_TAB"] = "DEVIATION_TAB";
    Translation["DEVIATION_TOAST_COUNTER"] = "DEVIATION_TOAST_COUNTER";
    Translation["DEVIATION_VIEW_ALL"] = "DEVIATION_VIEW_ALL";
    Translation["DEVICE"] = "DEVICE";
    Translation["DEVICE_ADDRESS"] = "DEVICE_ADDRESS";
    Translation["DEVICE_INSTANCE"] = "DEVICE_INSTANCE";
    Translation["DISABLE"] = "DISABLE";
    Translation["DISABLE_ENDPOINTS"] = "DISABLE_ENDPOINTS";
    Translation["DISABLE_ENDPOINTS_SUBTITLE"] = "DISABLE_ENDPOINTS_SUBTITLE";
    Translation["DISABLE_MAPPINGS"] = "DISABLE_MAPPINGS";
    Translation["DISABLE_MAPPINGS_SUBTITLE"] = "DISABLE_MAPPINGS_SUBTITLE";
    Translation["DISABLE_SERVERS"] = "DISABLE_SERVERS";
    Translation["DISABLE_SERVERS_SUBTITLE"] = "DISABLE_SERVERS_SUBTITLE";
    Translation["DISABLE_SERVICES"] = "DISABLE_SERVICES";
    Translation["DISABLED"] = "DISABLED";
    Translation["DISCONNECT"] = "DISCONNECT";
    Translation["DISCONNECT_CONNECTIONS"] = "DISCONNECT_CONNECTIONS";
    Translation["DISCONNECT_CONNECTIONS_SUBTITLE"] = "DISCONNECT_CONNECTIONS_SUBTITLE";
    Translation["DISMISS"] = "DISMISS";
    Translation["DN_OF_AD_GROUP"] = "DN_OF_AD_GROUP";
    Translation["DOCKER_HUB"] = "DOCKER_HUB";
    Translation["DOCKER_HUB_STATUS"] = "DOCKER_HUB_STATUS";
    Translation["DOCUMENTATION"] = "DOCUMENTATION";
    Translation["DOWNLOAD"] = "DOWNLOAD";
    Translation["DOWNLOAD_COMMISSIONING_FILE_DESCRIPTION"] = "DOWNLOAD_COMMISSIONING_FILE_DESCRIPTION";
    Translation["DOWNLOAD_COMMISSIONING_FILE_DESCRIPTION_ERROR"] = "DOWNLOAD_COMMISSIONING_FILE_DESCRIPTION_ERROR";
    Translation["DOWNLOAD_CSV"] = "DOWNLOAD_CSV";
    Translation["DOWNLOAD_RAW_LOGS"] = "DOWNLOAD_RAW_LOGS";
    Translation["EDIT_ROLE"] = "EDIT_ROLE";
    Translation["EDIT_USER"] = "EDIT_USER";
    Translation["ENABLE"] = "ENABLE";
    Translation["ENABLE_ENDPOINTS"] = "ENABLE_ENDPOINTS";
    Translation["ENABLE_ENDPOINTS_SUBTITLE"] = "ENABLE_ENDPOINTS_SUBTITLE";
    Translation["ENABLE_MAPPINGS"] = "ENABLE_MAPPINGS";
    Translation["ENABLE_MAPPINGS_SUBTITLE"] = "ENABLE_MAPPINGS_SUBTITLE";
    Translation["ENABLE_SERVERS"] = "ENABLE_SERVERS";
    Translation["ENABLE_SERVERS_SUBTITLE"] = "ENABLE_SERVERS_SUBTITLE";
    Translation["ENABLING"] = "ENABLING";
    Translation["END"] = "END";
    Translation["END_DATE"] = "END_DATE";
    Translation["ENDPOINT"] = "ENDPOINT";
    Translation["ENDPOINT_DETAILS_DOCUMENTATION_BODY"] = "ENDPOINT_DETAILS_DOCUMENTATION_BODY";
    Translation["ENDPOINT_DETAILS_DOCUMENTATION_TITLE"] = "ENDPOINT_DETAILS_DOCUMENTATION_TITLE";
    Translation["ENDPOINT_LOGS"] = "ENDPOINT_LOGS";
    Translation["ENDPOINT_NOT_FOUND"] = "ENDPOINT_NOT_FOUND";
    Translation["ENDPOINTS_DOCUMENTATION_BODY"] = "ENDPOINTS_DOCUMENTATION_BODY";
    Translation["ENDPOINTS_DOCUMENTATION_TITLE"] = "ENDPOINTS_DOCUMENTATION_TITLE";
    Translation["ENFORCE_MFA_USAGE"] = "ENFORCE_MFA_USAGE";
    Translation["ENTRA_OBJECT_ID"] = "ENTRA_OBJECT_ID";
    Translation["ENTRY"] = "ENTRY";
    Translation["ENVIRONMENT_VARIABLE"] = "ENVIRONMENT_VARIABLE";
    Translation["ERROR"] = "ERROR";
    Translation["ERROR_COUNT"] = "ERROR_COUNT";
    Translation["ERROR_DETAILS"] = "ERROR_DETAILS";
    Translation["ERROR_DETAILS_TYPE"] = "ERROR_DETAILS_TYPE";
    Translation["ERROR_EXTRA_INFORMATION"] = "ERROR_EXTRA_INFORMATION";
    Translation["ERROR_TITLE"] = "ERROR_TITLE";
    Translation["EXPECTED"] = "EXPECTED";
    Translation["EXPIRATION_DATE"] = "EXPIRATION_DATE";
    Translation["EXPIRES_ON"] = "EXPIRES_ON";
    Translation["EXTENDED_KEY_USAGE"] = "EXTENDED_KEY_USAGE";
    Translation["EXTENDED_KEY_USAGE_TYPE"] = "EXTENDED_KEY_USAGE_TYPE";
    Translation["EXTENSIONS"] = "EXTENSIONS";
    Translation["EXTERNAL"] = "EXTERNAL";
    Translation["FILE_UPLOAD"] = "FILE_UPLOAD";
    Translation["FILE_UPLOAD_LABEL"] = "FILE_UPLOAD_LABEL";
    Translation["FILTER"] = "FILTER";
    Translation["FINGERPRINT"] = "FINGERPRINT";
    Translation["GO_TO"] = "GO_TO";
    Translation["GRANT_ACCESS"] = "GRANT_ACCESS";
    Translation["HIDE_LICENSE_ID"] = "HIDE_LICENSE_ID";
    Translation["HIDE_PASSWORD"] = "HIDE_PASSWORD";
    Translation["HISTORY"] = "HISTORY";
    Translation["HOST"] = "HOST";
    Translation["HOSTNAME"] = "HOSTNAME";
    Translation["INFO"] = "INFO";
    Translation["INFO_PAGE_DOCUMENTATION_BODY"] = "INFO_PAGE_DOCUMENTATION_BODY";
    Translation["INFO_PAGE_DOCUMENTATION_TITLE"] = "INFO_PAGE_DOCUMENTATION_TITLE";
    Translation["INHERITED_FROM"] = "INHERITED_FROM";
    Translation["INPUT"] = "INPUT";
    Translation["INPUT_MQTT_TOPIC"] = "INPUT_MQTT_TOPIC";
    Translation["INPUT_TRANSFORMATION_RULE"] = "INPUT_TRANSFORMATION_RULE";
    Translation["INSTALL"] = "INSTALL";
    Translation["INSTALLED_SERVICES"] = "INSTALLED_SERVICES";
    Translation["INTERNAL"] = "INTERNAL";
    Translation["INTERNET_CONNECTIVITY"] = "INTERNET_CONNECTIVITY";
    Translation["INTERNET_CONNECTIVITY_DOCUMENTATION_BODY"] = "INTERNET_CONNECTIVITY_DOCUMENTATION_BODY";
    Translation["INTERNET_CONNECTIVITY_DOCUMENTATION_TITLE"] = "INTERNET_CONNECTIVITY_DOCUMENTATION_TITLE";
    Translation["INVALID_CSR"] = "INVALID_CSR";
    Translation["INVALID_OTP"] = "INVALID_OTP";
    Translation["INVALID_SERVICE_ID"] = "INVALID_SERVICE_ID";
    Translation["INVALID_TOPIC"] = "INVALID_TOPIC";
    Translation["IP_ADDRESS"] = "IP_ADDRESS";
    Translation["IS_URL_REACHABLE"] = "IS_URL_REACHABLE";
    Translation["IS_USED_BY"] = "IS_USED_BY";
    Translation["ISSUED_BY"] = "ISSUED_BY";
    Translation["ISSUED_ON"] = "ISSUED_ON";
    Translation["ISSUED_TO"] = "ISSUED_TO";
    Translation["JSON"] = "JSON";
    Translation["JUMP_TO_PAGE"] = "JUMP_TO_PAGE";
    Translation["KEY_USAGE"] = "KEY_USAGE";
    Translation["KEY_USAGE_TYPE"] = "KEY_USAGE_TYPE";
    Translation["LABEL"] = "LABEL";
    Translation["LAST_SEEN"] = "LAST_SEEN";
    Translation["LAST_UPDATED"] = "LAST_UPDATED";
    Translation["LEVEL"] = "LEVEL";
    Translation["LICENSE"] = "LICENSE";
    Translation["LICENSE_ACCOUNT"] = "LICENSE_ACCOUNT";
    Translation["LICENSE_ACTIVATION_NEEDED"] = "LICENSE_ACTIVATION_NEEDED";
    Translation["LICENSE_ACTIVATION_NEEDED_DESCRIPTION"] = "LICENSE_ACTIVATION_NEEDED_DESCRIPTION";
    Translation["LICENSE_ACTIVATION_TITLE"] = "LICENSE_ACTIVATION_TITLE";
    Translation["LICENSE_CLASS"] = "LICENSE_CLASS";
    Translation["LICENSE_ERROR_SUMMARY"] = "LICENSE_ERROR_SUMMARY";
    Translation["LICENSE_EXPIRED_CONTACT_SALES"] = "LICENSE_EXPIRED_CONTACT_SALES";
    Translation["LICENSE_EXPIRED_EXTENSION_NEEDED"] = "LICENSE_EXPIRED_EXTENSION_NEEDED";
    Translation["LICENSE_ID"] = "LICENSE_ID";
    Translation["LICENSE_MODAL_FOOTER"] = "LICENSE_MODAL_FOOTER";
    Translation["LICENSE_MODAL_TITLE"] = "LICENSE_MODAL_TITLE";
    Translation["LICENSE_NAME"] = "LICENSE_NAME";
    Translation["LICENSE_OFFLINE_ACTIVATION"] = "LICENSE_OFFLINE_ACTIVATION";
    Translation["LICENSE_ONLINE_ACTIVATION"] = "LICENSE_ONLINE_ACTIVATION";
    Translation["LICENSE_ONLINE_AVAILABILITY_CHECK"] = "LICENSE_ONLINE_AVAILABILITY_CHECK";
    Translation["LICENSE_REFRESH_REQUIRES_INTERNET"] = "LICENSE_REFRESH_REQUIRES_INTERNET";
    Translation["LICENSE_STATUS"] = "LICENSE_STATUS";
    Translation["LICENSE_STILL_INVALID"] = "LICENSE_STILL_INVALID";
    Translation["LICENSE_VALIDATION_ERROR"] = "LICENSE_VALIDATION_ERROR";
    Translation["LINK"] = "LINK";
    Translation["LIVE_DATA_SUBSCRIPTION_ERROR"] = "LIVE_DATA_SUBSCRIPTION_ERROR";
    Translation["LOCK"] = "LOCK";
    Translation["LOG_DETAILS"] = "LOG_DETAILS";
    Translation["LOG_LEVEL"] = "LOG_LEVEL";
    Translation["LOGICAL_ID"] = "LOGICAL_ID";
    Translation["LOGIN_FORM_BACKUP_CODE"] = "LOGIN_FORM_BACKUP_CODE";
    Translation["LOGIN_FORM_CANCEL_MFA"] = "LOGIN_FORM_CANCEL_MFA";
    Translation["LOGIN_FORM_MFA_EXPLANATION"] = "LOGIN_FORM_MFA_EXPLANATION";
    Translation["LOGIN_FORM_TITLE"] = "LOGIN_FORM_TITLE";
    Translation["LOGIN_SETTINGS"] = "LOGIN_SETTINGS";
    Translation["LOGIN_SETTINGS_DOCUMENTATION_BODY"] = "LOGIN_SETTINGS_DOCUMENTATION_BODY";
    Translation["LOGIN_SETTINGS_DOCUMENTATION_TITLE"] = "LOGIN_SETTINGS_DOCUMENTATION_TITLE";
    Translation["LOGOUT"] = "LOGOUT";
    Translation["MAPPING"] = "MAPPING";
    Translation["MAPPING_DETAILS_DOCUMENTATION_BODY"] = "MAPPING_DETAILS_DOCUMENTATION_BODY";
    Translation["MAPPING_DETAILS_DOCUMENTATION_TITLE"] = "MAPPING_DETAILS_DOCUMENTATION_TITLE";
    Translation["MAPPING_ID"] = "MAPPING_ID";
    Translation["MAPPING_LOGS"] = "MAPPING_LOGS";
    Translation["MAPPING_NOT_FOUND"] = "MAPPING_NOT_FOUND";
    Translation["MAPPINGS_DOCUMENTATION_BODY"] = "MAPPINGS_DOCUMENTATION_BODY";
    Translation["MAPPINGS_DOCUMENTATION_TITLE"] = "MAPPINGS_DOCUMENTATION_TITLE";
    Translation["MENU"] = "MENU";
    Translation["MESSAGE"] = "MESSAGE";
    Translation["MESSAGE_PER_DAY"] = "MESSAGE_PER_DAY";
    Translation["MESSAGE_PER_HOUR"] = "MESSAGE_PER_HOUR";
    Translation["METRICS"] = "METRICS";
    Translation["METRICS_DOCUMENTATION_BODY"] = "METRICS_DOCUMENTATION_BODY";
    Translation["METRICS_DOCUMENTATION_TITLE"] = "METRICS_DOCUMENTATION_TITLE";
    Translation["MFA_ALREADY_ENABLED_ERROR"] = "MFA_ALREADY_ENABLED_ERROR";
    Translation["MFA_BACKUP_CODES_PRESENTATION_SUBTITLE"] = "MFA_BACKUP_CODES_PRESENTATION_SUBTITLE";
    Translation["MFA_BACKUP_CODES_PRESENTATION_TITLE"] = "MFA_BACKUP_CODES_PRESENTATION_TITLE";
    Translation["MFA_ENABLED_ACTION_CONFIRMATION"] = "MFA_ENABLED_ACTION_CONFIRMATION";
    Translation["MFA_ENABLED_ACTION_DESCRIPTION"] = "MFA_ENABLED_ACTION_DESCRIPTION";
    Translation["MFA_ENABLING_STEPS_SUBTITLE"] = "MFA_ENABLING_STEPS_SUBTITLE";
    Translation["MFA_ENABLING_STEPS_TITLE"] = "MFA_ENABLING_STEPS_TITLE";
    Translation["MFA_ENFORCED_NOTIFICATION"] = "MFA_ENFORCED_NOTIFICATION";
    Translation["MFA_MISSING_PERMISSIONS_ERROR"] = "MFA_MISSING_PERMISSIONS_ERROR";
    Translation["MFA_SAVE_CONFIGURATION"] = "MFA_SAVE_CONFIGURATION";
    Translation["MFA_SECRET_KEY_LABEL"] = "MFA_SECRET_KEY_LABEL";
    Translation["MFA_SETTINGS_SUBTITLE"] = "MFA_SETTINGS_SUBTITLE";
    Translation["MFA_TOGGLE"] = "MFA_TOGGLE";
    Translation["MFA_TOKEN_EXPIRED_ERROR"] = "MFA_TOKEN_EXPIRED_ERROR";
    Translation["MISSING_READ_OR_WRITE_PERMISSION"] = "MISSING_READ_OR_WRITE_PERMISSION";
    Translation["MONITORED_TOPICS"] = "MONITORED_TOPICS";
    Translation["MORE_TAGS_COUNT"] = "MORE_TAGS_COUNT";
    Translation["MQTT_COULD_NOT_CONNECT_ERROR"] = "MQTT_COULD_NOT_CONNECT_ERROR";
    Translation["MQTT_GENERIC_ERROR"] = "MQTT_GENERIC_ERROR";
    Translation["MQTT_PUBLISH_PREFIX"] = "MQTT_PUBLISH_PREFIX";
    Translation["MQTT_PUBLISH_PREFIX_DOCUMENTATION"] = "MQTT_PUBLISH_PREFIX_DOCUMENTATION";
    Translation["MQTT_PUBLISH_PREFIX_VALIDATION"] = "MQTT_PUBLISH_PREFIX_VALIDATION";
    Translation["MQTT_PUBLISH_PREFIX_WARNING"] = "MQTT_PUBLISH_PREFIX_WARNING";
    Translation["MQTT_TOPIC"] = "MQTT_TOPIC";
    Translation["MULTI_FACTOR_AUTHENTICATION"] = "MULTI_FACTOR_AUTHENTICATION";
    Translation["MULTI_FACTOR_AUTHENTICATION_ACRONYM"] = "MULTI_FACTOR_AUTHENTICATION_ACRONYM";
    Translation["NAME"] = "NAME";
    Translation["NAVIGATION_BRAND"] = "NAVIGATION_BRAND";
    Translation["NAVIGATION_BRAND_HOME"] = "NAVIGATION_BRAND_HOME";
    Translation["NAVIGATION_CERTIFICATES_DESCRIPTION"] = "NAVIGATION_CERTIFICATES_DESCRIPTION";
    Translation["NAVIGATION_CLIENT_REGISTRY_DESCRIPTION"] = "NAVIGATION_CLIENT_REGISTRY_DESCRIPTION";
    Translation["NAVIGATION_CONNECTIONS_DESCRIPTION"] = "NAVIGATION_CONNECTIONS_DESCRIPTION";
    Translation["NAVIGATION_CONTAINERS_DESCRIPTION"] = "NAVIGATION_CONTAINERS_DESCRIPTION";
    Translation["NAVIGATION_ENDPOINTS_DESCRIPTION"] = "NAVIGATION_ENDPOINTS_DESCRIPTION";
    Translation["NAVIGATION_EXPLORER_DESCRIPTION"] = "NAVIGATION_EXPLORER_DESCRIPTION";
    Translation["NAVIGATION_MAPPINGS_DESCRIPTION"] = "NAVIGATION_MAPPINGS_DESCRIPTION";
    Translation["NAVIGATION_NODES_DESCRIPTION"] = "NAVIGATION_NODES_DESCRIPTION";
    Translation["NAVIGATION_PHONE_MENU_CLOSE"] = "NAVIGATION_PHONE_MENU_CLOSE";
    Translation["NAVIGATION_PHONE_SIGNED_IN_AS"] = "NAVIGATION_PHONE_SIGNED_IN_AS";
    Translation["NAVIGATION_RULE_ENGINE_SANDBOX_DESCRIPTION"] = "NAVIGATION_RULE_ENGINE_SANDBOX_DESCRIPTION";
    Translation["NAVIGATION_SERVERS_DESCRIPTION"] = "NAVIGATION_SERVERS_DESCRIPTION";
    Translation["NAVIGATION_SERVICES_DESCRIPTION"] = "NAVIGATION_SERVICES_DESCRIPTION";
    Translation["NAVIGATION_SERVICES_LINKS_DESCRIPTION"] = "NAVIGATION_SERVICES_LINKS_DESCRIPTION";
    Translation["NAVIGATION_SIDE_COLLAPSE"] = "NAVIGATION_SIDE_COLLAPSE";
    Translation["NAVIGATION_SIDE_EXPAND"] = "NAVIGATION_SIDE_EXPAND";
    Translation["NAVIGATION_SIDE_LABEL"] = "NAVIGATION_SIDE_LABEL";
    Translation["NAVIGATION_SYSTEM_AGENTS_DESCRIPTION"] = "NAVIGATION_SYSTEM_AGENTS_DESCRIPTION";
    Translation["NAVIGATION_SYSTEM_LICENSE_DESCRIPTION"] = "NAVIGATION_SYSTEM_LICENSE_DESCRIPTION";
    Translation["NAVIGATION_SYSTEM_METRICS_DESCRIPTION"] = "NAVIGATION_SYSTEM_METRICS_DESCRIPTION";
    Translation["NAVIGATION_SYSTEM_STATUSES_DESCRIPTION"] = "NAVIGATION_SYSTEM_STATUSES_DESCRIPTION";
    Translation["NAVIGATION_TOP_LABEL"] = "NAVIGATION_TOP_LABEL";
    Translation["NAVIGATION_VOLUMES_DESCRIPTION"] = "NAVIGATION_VOLUMES_DESCRIPTION";
    Translation["NEW_PASSWORD"] = "NEW_PASSWORD";
    Translation["NEW_ROLE"] = "NEW_ROLE";
    Translation["NEW_USER"] = "NEW_USER";
    Translation["NO_AGENTS_AVAILABLE"] = "NO_AGENTS_AVAILABLE";
    Translation["NO_AGENTS_RUNNING"] = "NO_AGENTS_RUNNING";
    Translation["NO_CERTIFICATES"] = "NO_CERTIFICATES";
    Translation["NO_CHANGE_PASSWORD_PERMISSION_DESCRIPTION"] = "NO_CHANGE_PASSWORD_PERMISSION_DESCRIPTION";
    Translation["NO_CONFIGURATION"] = "NO_CONFIGURATION";
    Translation["NO_CONNECTIONS_AVAILABLE"] = "NO_CONNECTIONS_AVAILABLE";
    Translation["NO_CONTAINERS_AVAILABLE"] = "NO_CONTAINERS_AVAILABLE";
    Translation["NO_DEVIATED_SERVICES_AVAILABLE"] = "NO_DEVIATED_SERVICES_AVAILABLE";
    Translation["NO_ENDPOINTS_AVAILABLE"] = "NO_ENDPOINTS_AVAILABLE";
    Translation["NO_ENTRIES_AVAILABLE"] = "NO_ENTRIES_AVAILABLE";
    Translation["NO_LIVE_DATA_RESOURCES"] = "NO_LIVE_DATA_RESOURCES";
    Translation["NO_LIVE_DATA_RESOURCES_FOUND"] = "NO_LIVE_DATA_RESOURCES_FOUND";
    Translation["NO_LOGS_FOUND"] = "NO_LOGS_FOUND";
    Translation["NO_MAPPINGS_AVAILABLE"] = "NO_MAPPINGS_AVAILABLE";
    Translation["NO_MESSAGES"] = "NO_MESSAGES";
    Translation["NO_METRICS"] = "NO_METRICS";
    Translation["NO_NODES_AVAILABLE"] = "NO_NODES_AVAILABLE";
    Translation["NO_PERMISSIONS_FOUND"] = "NO_PERMISSIONS_FOUND";
    Translation["NO_RESULTS_FOUND"] = "NO_RESULTS_FOUND";
    Translation["NO_ROLES"] = "NO_ROLES";
    Translation["NO_ROLES_FOUND"] = "NO_ROLES_FOUND";
    Translation["NO_SERVERS_AVAILABLE"] = "NO_SERVERS_AVAILABLE";
    Translation["NO_SERVICE_LINKS_AVAILABLE"] = "NO_SERVICE_LINKS_AVAILABLE";
    Translation["NO_SERVICES_INSTALLED"] = "NO_SERVICES_INSTALLED";
    Translation["NO_TEMPLATES_AVAILABLE"] = "NO_TEMPLATES_AVAILABLE";
    Translation["NO_TOPICS_AVAILABLE"] = "NO_TOPICS_AVAILABLE";
    Translation["NO_TOPICS_SELECTED"] = "NO_TOPICS_SELECTED";
    Translation["NO_USERS_FOUND"] = "NO_USERS_FOUND";
    Translation["NO_VOLUMES_AVAILABLE"] = "NO_VOLUMES_AVAILABLE";
    Translation["NODE"] = "NODE";
    Translation["NODES_DOCUMENTATION_BODY"] = "NODES_DOCUMENTATION_BODY";
    Translation["NODES_DOCUMENTATION_TITLE"] = "NODES_DOCUMENTATION_TITLE";
    Translation["NONE"] = "NONE";
    Translation["NOT_AVAILABLE"] = "NOT_AVAILABLE";
    Translation["NOT_EDITABLE"] = "NOT_EDITABLE";
    Translation["NOTHING_TO_CONFIGURE"] = "NOTHING_TO_CONFIGURE";
    Translation["NOTIFICATION_TOAST_COUNT"] = "NOTIFICATION_TOAST_COUNT";
    Translation["NUMBER_OF_DATAPOINTS"] = "NUMBER_OF_DATAPOINTS";
    Translation["NUMBER_OF_ENTRIES"] = "NUMBER_OF_ENTRIES";
    Translation["NUMBER_OF_MESSAGES_PER_DAY"] = "NUMBER_OF_MESSAGES_PER_DAY";
    Translation["NUMBER_OF_MESSAGES_PER_HOUR"] = "NUMBER_OF_MESSAGES_PER_HOUR";
    Translation["NUMBER_OF_VOLUMES"] = "NUMBER_OF_VOLUMES";
    Translation["OPEN_DOCUMENTATION"] = "OPEN_DOCUMENTATION";
    Translation["OPERATION"] = "OPERATION";
    Translation["OPERATION_PERMISSION"] = "OPERATION_PERMISSION";
    Translation["OPTIONAL"] = "OPTIONAL";
    Translation["OR_USE_USERNAME"] = "OR_USE_USERNAME";
    Translation["ORGANIZATION"] = "ORGANIZATION";
    Translation["ORGANIZATIONAL_UNIT"] = "ORGANIZATIONAL_UNIT";
    Translation["PARENT"] = "PARENT";
    Translation["PASSWORD"] = "PASSWORD";
    Translation["PASSWORD_SUCCESSFULLY_CHANGED"] = "PASSWORD_SUCCESSFULLY_CHANGED";
    Translation["PASSWORD_VALIDATION"] = "PASSWORD_VALIDATION";
    Translation["PATH_LENGTH"] = "PATH_LENGTH";
    Translation["PERMISSION"] = "PERMISSION";
    Translation["PERMISSION_ALREADY_EXISTS"] = "PERMISSION_ALREADY_EXISTS";
    Translation["PERMISSIONS_CHANGED_NOTIFICATION"] = "PERMISSIONS_CHANGED_NOTIFICATION";
    Translation["PID"] = "PID";
    Translation["PIN_COLUMN"] = "PIN_COLUMN";
    Translation["PINNED"] = "PINNED";
    Translation["PORT"] = "PORT";
    Translation["PROBLEM_CHANGING_PASSWORD"] = "PROBLEM_CHANGING_PASSWORD";
    Translation["PROTOCOL"] = "PROTOCOL";
    Translation["PROVIDER"] = "PROVIDER";
    Translation["PUBLISH"] = "PUBLISH";
    Translation["PUBLISH_BROKER"] = "PUBLISH_BROKER";
    Translation["REASON"] = "REASON";
    Translation["RECORD_PANEL"] = "RECORD_PANEL";
    Translation["RECORD_PANEL_ACTION"] = "RECORD_PANEL_ACTION";
    Translation["RECORD_PANEL_ACTION_TOOLTIP"] = "RECORD_PANEL_ACTION_TOOLTIP";
    Translation["RECORD_PANEL_POSITION"] = "RECORD_PANEL_POSITION";
    Translation["RECORD_PANEL_SNAP"] = "RECORD_PANEL_SNAP";
    Translation["RECORD_PANEL_WIDTH"] = "RECORD_PANEL_WIDTH";
    Translation["RECORD_PANEL_WIDTH_VALUE"] = "RECORD_PANEL_WIDTH_VALUE";
    Translation["REDUCED_PERMISSIONS_TITLE"] = "REDUCED_PERMISSIONS_TITLE";
    Translation["REFRESH_LICENSE"] = "REFRESH_LICENSE";
    Translation["REFRESH_LICENSE_FILE_FROM_PORTAL"] = "REFRESH_LICENSE_FILE_FROM_PORTAL";
    Translation["REFRESH_LOGS"] = "REFRESH_LOGS";
    Translation["RELOAD_SESSION"] = "RELOAD_SESSION";
    Translation["REMOVE"] = "REMOVE";
    Translation["REMOVE_ALL_PERMISSIONS"] = "REMOVE_ALL_PERMISSIONS";
    Translation["REMOVE_CUSTOMIZATION"] = "REMOVE_CUSTOMIZATION";
    Translation["REORDER_COLUMN"] = "REORDER_COLUMN";
    Translation["REQUIRED_BY"] = "REQUIRED_BY";
    Translation["RESET"] = "RESET";
    Translation["RESET_VIEW"] = "RESET_VIEW";
    Translation["RESOURCE"] = "RESOURCE";
    Translation["RESOURCE_ID"] = "RESOURCE_ID";
    Translation["RESOURCE_IS_MISSING"] = "RESOURCE_IS_MISSING";
    Translation["RESOURCE_TYPE"] = "RESOURCE_TYPE";
    Translation["RESOURCES_AND_SERVICE_LINK_DOCUMENTATION_BODY"] = "RESOURCES_AND_SERVICE_LINK_DOCUMENTATION_BODY";
    Translation["RESOURCES_AND_SERVICE_LINK_DOCUMENTATION_TITLE"] = "RESOURCES_AND_SERVICE_LINK_DOCUMENTATION_TITLE";
    Translation["RESTART"] = "RESTART";
    Translation["RESTART_CONTAINERS"] = "RESTART_CONTAINERS";
    Translation["RESTART_CONTAINERS_SUBTITLE"] = "RESTART_CONTAINERS_SUBTITLE";
    Translation["ROLE"] = "ROLE";
    Translation["ROLE_NAME"] = "ROLE_NAME";
    Translation["ROLE_NAME_ALREADY_USED"] = "ROLE_NAME_ALREADY_USED";
    Translation["ROUTE"] = "ROUTE";
    Translation["ROW_ACTIONS"] = "ROW_ACTIONS";
    Translation["ROWS_PER_PAGE"] = "ROWS_PER_PAGE";
    Translation["RULE"] = "RULE";
    Translation["RULE_ENGINE_DOCUMENTATION"] = "RULE_ENGINE_DOCUMENTATION";
    Translation["RULE_ENGINE_SANDBOX"] = "RULE_ENGINE_SANDBOX";
    Translation["RULE_ENGINE_SANDBOX_DOCUMENTATION_BODY"] = "RULE_ENGINE_SANDBOX_DOCUMENTATION_BODY";
    Translation["RULE_ENGINE_SANDBOX_DOCUMENTATION_TITLE"] = "RULE_ENGINE_SANDBOX_DOCUMENTATION_TITLE";
    Translation["RULE_ENGINE_SANDBOX_TRANSFORMATION_PLACEHOLDER"] = "RULE_ENGINE_SANDBOX_TRANSFORMATION_PLACEHOLDER";
    Translation["RULE_ERROR"] = "RULE_ERROR";
    Translation["SANDBOX_SUBSCRIPTION_ISSUE"] = "SANDBOX_SUBSCRIPTION_ISSUE";
    Translation["SAVE_NEW_PASSWORD"] = "SAVE_NEW_PASSWORD";
    Translation["SEARCH_CHARACTERS_LEFT"] = "SEARCH_CHARACTERS_LEFT";
    Translation["SEARCH_PLACEHOLDER"] = "SEARCH_PLACEHOLDER";
    Translation["SEARCH_THRESHOLD_EXPLANATION"] = "SEARCH_THRESHOLD_EXPLANATION";
    Translation["SECRET_PARAMETER_CHANGE"] = "SECRET_PARAMETER_CHANGE";
    Translation["SECRET_PARAMETER_CONCEALED_HELPER"] = "SECRET_PARAMETER_CONCEALED_HELPER";
    Translation["SECRET_PARAMETER_EDIT_HELPER"] = "SECRET_PARAMETER_EDIT_HELPER";
    Translation["SECRET_PARAMETER_HIDE_VALUE"] = "SECRET_PARAMETER_HIDE_VALUE";
    Translation["SECRET_PARAMETER_SHOW_VALUE"] = "SECRET_PARAMETER_SHOW_VALUE";
    Translation["SELECT_ENDPOINT"] = "SELECT_ENDPOINT";
    Translation["SELECT_TRANSFORMATION_SOURCE"] = "SELECT_TRANSFORMATION_SOURCE";
    Translation["SELECTED_COUNT"] = "SELECTED_COUNT";
    Translation["SEND_METRICS_TO_PORTAL"] = "SEND_METRICS_TO_PORTAL";
    Translation["SERVER"] = "SERVER";
    Translation["SERVER_DETAILS_DOCUMENTATION_BODY"] = "SERVER_DETAILS_DOCUMENTATION_BODY";
    Translation["SERVER_DETAILS_DOCUMENTATION_TITLE"] = "SERVER_DETAILS_DOCUMENTATION_TITLE";
    Translation["SERVER_ERROR"] = "SERVER_ERROR";
    Translation["SERVER_LOGS"] = "SERVER_LOGS";
    Translation["SERVER_NOT_AVAILABLE"] = "SERVER_NOT_AVAILABLE";
    Translation["SERVER_NOT_FOUND"] = "SERVER_NOT_FOUND";
    Translation["SERVERS_DOCUMENTATION_BODY"] = "SERVERS_DOCUMENTATION_BODY";
    Translation["SERVERS_DOCUMENTATION_TITLE"] = "SERVERS_DOCUMENTATION_TITLE";
    Translation["SERVICE"] = "SERVICE";
    Translation["SERVICE_COMMISSIONING_FILE_LABEL"] = "SERVICE_COMMISSIONING_FILE_LABEL";
    Translation["SERVICE_CONFIGURATION"] = "SERVICE_CONFIGURATION";
    Translation["SERVICE_CONFIGURE_CURRENT"] = "SERVICE_CONFIGURE_CURRENT";
    Translation["SERVICE_CONFIGURE_HINT"] = "SERVICE_CONFIGURE_HINT";
    Translation["SERVICE_CONFIGURE_NEW"] = "SERVICE_CONFIGURE_NEW";
    Translation["SERVICE_DETAILS"] = "SERVICE_DETAILS";
    Translation["SERVICE_DETAILS_DOCUMENTATION_BODY"] = "SERVICE_DETAILS_DOCUMENTATION_BODY";
    Translation["SERVICE_DETAILS_DOCUMENTATION_TITLE"] = "SERVICE_DETAILS_DOCUMENTATION_TITLE";
    Translation["SERVICE_DOCUMENTATION_LINK"] = "SERVICE_DOCUMENTATION_LINK";
    Translation["SERVICE_ID"] = "SERVICE_ID";
    Translation["SERVICE_ID_ALREADY_USED"] = "SERVICE_ID_ALREADY_USED";
    Translation["SERVICE_INSTALL"] = "SERVICE_INSTALL";
    Translation["SERVICE_INSTALL_OR_UPDATE_ERROR"] = "SERVICE_INSTALL_OR_UPDATE_ERROR";
    Translation["SERVICE_LINK"] = "SERVICE_LINK";
    Translation["SERVICE_LIVE_DATA"] = "SERVICE_LIVE_DATA";
    Translation["SERVICE_LOGS"] = "SERVICE_LOGS";
    Translation["SERVICE_LOGS_DOCUMENTATION_BODY"] = "SERVICE_LOGS_DOCUMENTATION_BODY";
    Translation["SERVICE_LOGS_DOCUMENTATION_TITLE"] = "SERVICE_LOGS_DOCUMENTATION_TITLE";
    Translation["SERVICE_NOT_FOUND"] = "SERVICE_NOT_FOUND";
    Translation["SERVICE_OVERVIEW"] = "SERVICE_OVERVIEW";
    Translation["SERVICE_RESOURCE_TYPE"] = "SERVICE_RESOURCE_TYPE";
    Translation["SERVICE_RESOURCES"] = "SERVICE_RESOURCES";
    Translation["SERVICE_SELECT_COMMISSIONING_FILE"] = "SERVICE_SELECT_COMMISSIONING_FILE";
    Translation["SERVICE_UPDATE_RECONFIGURE"] = "SERVICE_UPDATE_RECONFIGURE";
    Translation["SERVICE_WITH_ID_STILL_BEING_DELETED"] = "SERVICE_WITH_ID_STILL_BEING_DELETED";
    Translation["SERVICES_DETAILS_DOCUMENTATION_BODY"] = "SERVICES_DETAILS_DOCUMENTATION_BODY";
    Translation["SERVICES_DETAILS_DOCUMENTATION_TITLE"] = "SERVICES_DETAILS_DOCUMENTATION_TITLE";
    Translation["SESSION_BANNER"] = "SESSION_BANNER";
    Translation["SESSION_COUNTDOWN"] = "SESSION_COUNTDOWN";
    Translation["SETTINGS"] = "SETTINGS";
    Translation["SHOW_LICENSE_ID"] = "SHOW_LICENSE_ID";
    Translation["SHOW_MORE"] = "SHOW_MORE";
    Translation["SHOW_PASSWORD"] = "SHOW_PASSWORD";
    Translation["SHOW_USER_MANAGEMENT_RESULTS"] = "SHOW_USER_MANAGEMENT_RESULTS";
    Translation["SIGN_IN"] = "SIGN_IN";
    Translation["SIGN_IN_WITH_SSO"] = "SIGN_IN_WITH_SSO";
    Translation["SSO_AUTHENTICATION_ERROR"] = "SSO_AUTHENTICATION_ERROR";
    Translation["SSO_REDIRECTING_ERROR"] = "SSO_REDIRECTING_ERROR";
    Translation["SSO_STATUS_FETCHING_ERROR"] = "SSO_STATUS_FETCHING_ERROR";
    Translation["START"] = "START";
    Translation["START_CONTAINERS"] = "START_CONTAINERS";
    Translation["START_CONTAINERS_SUBTITLE"] = "START_CONTAINERS_SUBTITLE";
    Translation["START_DATE"] = "START_DATE";
    Translation["STATUS"] = "STATUS";
    Translation["STATUS_LABEL"] = "STATUS_LABEL";
    Translation["STOP"] = "STOP";
    Translation["STOP_CONTAINERS"] = "STOP_CONTAINERS";
    Translation["STOP_CONTAINERS_SUBTITLE"] = "STOP_CONTAINERS_SUBTITLE";
    Translation["STORYBOOK"] = "STORYBOOK";
    Translation["STORYBOOK_BUTTONS"] = "STORYBOOK_BUTTONS";
    Translation["STORYBOOK_BUTTONS_DOCUMENTATION_BODY"] = "STORYBOOK_BUTTONS_DOCUMENTATION_BODY";
    Translation["STORYBOOK_BUTTONS_DOCUMENTATION_TITLE"] = "STORYBOOK_BUTTONS_DOCUMENTATION_TITLE";
    Translation["STORYBOOK_CHIPS_AND_STATUSES"] = "STORYBOOK_CHIPS_AND_STATUSES";
    Translation["STORYBOOK_CHIPS_AND_STATUSES_DOCUMENTATION_BODY"] = "STORYBOOK_CHIPS_AND_STATUSES_DOCUMENTATION_BODY";
    Translation["STORYBOOK_CHIPS_AND_STATUSES_DOCUMENTATION_TITLE"] = "STORYBOOK_CHIPS_AND_STATUSES_DOCUMENTATION_TITLE";
    Translation["STORYBOOK_FOUNDATIONS"] = "STORYBOOK_FOUNDATIONS";
    Translation["STORYBOOK_FOUNDATIONS_DOCUMENTATION_BODY"] = "STORYBOOK_FOUNDATIONS_DOCUMENTATION_BODY";
    Translation["STORYBOOK_FOUNDATIONS_DOCUMENTATION_TITLE"] = "STORYBOOK_FOUNDATIONS_DOCUMENTATION_TITLE";
    Translation["STORYBOOK_INPUTS"] = "STORYBOOK_INPUTS";
    Translation["STORYBOOK_INPUTS_DOCUMENTATION_BODY"] = "STORYBOOK_INPUTS_DOCUMENTATION_BODY";
    Translation["STORYBOOK_INPUTS_DOCUMENTATION_TITLE"] = "STORYBOOK_INPUTS_DOCUMENTATION_TITLE";
    Translation["STORYBOOK_NOTIFICATIONS"] = "STORYBOOK_NOTIFICATIONS";
    Translation["STORYBOOK_NOTIFICATIONS_DOCUMENTATION_BODY"] = "STORYBOOK_NOTIFICATIONS_DOCUMENTATION_BODY";
    Translation["STORYBOOK_NOTIFICATIONS_DOCUMENTATION_TITLE"] = "STORYBOOK_NOTIFICATIONS_DOCUMENTATION_TITLE";
    Translation["STORYBOOK_TABLES"] = "STORYBOOK_TABLES";
    Translation["STORYBOOK_TABLES_DOCUMENTATION_BODY"] = "STORYBOOK_TABLES_DOCUMENTATION_BODY";
    Translation["STORYBOOK_TABLES_DOCUMENTATION_TITLE"] = "STORYBOOK_TABLES_DOCUMENTATION_TITLE";
    Translation["SUBJECT"] = "SUBJECT";
    Translation["SUBSCRIBE"] = "SUBSCRIBE";
    Translation["SUBSCRIBE_BROKER"] = "SUBSCRIBE_BROKER";
    Translation["SUCCESSFULLY_SENT_METRICS_TO_PORTAL"] = "SUCCESSFULLY_SENT_METRICS_TO_PORTAL";
    Translation["SYSTEM"] = "SYSTEM";
    Translation["SYSTEM_CONTAINER"] = "SYSTEM_CONTAINER";
    Translation["SYSTEM_INFORMATION"] = "SYSTEM_INFORMATION";
    Translation["SYSTEM_INFORMATION_DOCUMENTATION_BODY"] = "SYSTEM_INFORMATION_DOCUMENTATION_BODY";
    Translation["SYSTEM_INFORMATION_DOCUMENTATION_TITLE"] = "SYSTEM_INFORMATION_DOCUMENTATION_TITLE";
    Translation["SYSTEM_STATUS"] = "SYSTEM_STATUS";
    Translation["TABLE_LOAD_ERROR"] = "TABLE_LOAD_ERROR";
    Translation["TABLE_LOADING"] = "TABLE_LOADING";
    Translation["TABLE_PAGINATION_DISPLAYED_ROWS"] = "TABLE_PAGINATION_DISPLAYED_ROWS";
    Translation["TIME"] = "TIME";
    Translation["TIMEOUT_ERROR"] = "TIMEOUT_ERROR";
    Translation["TIMESTAMP"] = "TIMESTAMP";
    Translation["TOGGLE_AUTHENTICATION_METHOD"] = "TOGGLE_AUTHENTICATION_METHOD";
    Translation["TOKEN_ERROR_DIALOG_CONTENT"] = "TOKEN_ERROR_DIALOG_CONTENT";
    Translation["TOKEN_ERROR_DIALOG_TITLE"] = "TOKEN_ERROR_DIALOG_TITLE";
    Translation["TOKEN_EXPIRED_ERROR"] = "TOKEN_EXPIRED_ERROR";
    Translation["TOKEN_EXPIRING_MODAL_BODY"] = "TOKEN_EXPIRING_MODAL_BODY";
    Translation["TOKEN_EXPIRING_MODAL_TITLE"] = "TOKEN_EXPIRING_MODAL_TITLE";
    Translation["TOPIC"] = "TOPIC";
    Translation["TOPIC_PLACEHOLDER"] = "TOPIC_PLACEHOLDER";
    Translation["TOPIC_SUBSCRIPTION_ERROR"] = "TOPIC_SUBSCRIPTION_ERROR";
    Translation["TOPIC_TYPE"] = "TOPIC_TYPE";
    Translation["TOPICS_METADATA_PERMISSION_MISSING"] = "TOPICS_METADATA_PERMISSION_MISSING";
    Translation["TOTAL_PERMISSIONS"] = "TOTAL_PERMISSIONS";
    Translation["TRANSFORMATION_INPUT"] = "TRANSFORMATION_INPUT";
    Translation["TRANSFORMATION_INPUT_HELPER_TEXT"] = "TRANSFORMATION_INPUT_HELPER_TEXT";
    Translation["TRANSFORMATION_RESULT"] = "TRANSFORMATION_RESULT";
    Translation["TRANSFORMATION_RULE"] = "TRANSFORMATION_RULE";
    Translation["TRY_AGAIN"] = "TRY_AGAIN";
    Translation["TYPE"] = "TYPE";
    Translation["UI_ACCESS_PERMISSIONS_DOCUMENTATION"] = "UI_ACCESS_PERMISSIONS_DOCUMENTATION";
    Translation["UNLOCK"] = "UNLOCK";
    Translation["UNSUBSCRIBE"] = "UNSUBSCRIBE";
    Translation["UPDATE"] = "UPDATE";
    Translation["UPLOAD_LICENSE_FILE"] = "UPLOAD_LICENSE_FILE";
    Translation["UPLOAD_SERVICE"] = "UPLOAD_SERVICE";
    Translation["USER"] = "USER";
    Translation["USER_AUTHENTICATION_METHOD"] = "USER_AUTHENTICATION_METHOD";
    Translation["USER_CERTIFICATES"] = "USER_CERTIFICATES";
    Translation["USER_MANAGEMENT"] = "USER_MANAGEMENT";
    Translation["USER_PROVIDER"] = "USER_PROVIDER";
    Translation["USER_UPDATE_ERROR_PROTECTED_USER"] = "USER_UPDATE_ERROR_PROTECTED_USER";
    Translation["USERNAME"] = "USERNAME";
    Translation["USERNAME_ALREADY_USED"] = "USERNAME_ALREADY_USED";
    Translation["USERNAME_VALIDATION"] = "USERNAME_VALIDATION";
    Translation["USERS_AND_ROLES"] = "USERS_AND_ROLES";
    Translation["USERS_AND_ROLES_DOCUMENTATION_BODY"] = "USERS_AND_ROLES_DOCUMENTATION_BODY";
    Translation["USERS_AND_ROLES_DOCUMENTATION_TITLE"] = "USERS_AND_ROLES_DOCUMENTATION_TITLE";
    Translation["VALIDITY_PERIOD"] = "VALIDITY_PERIOD";
    Translation["VALUE"] = "VALUE";
    Translation["VERSION"] = "VERSION";
    Translation["VERSION_MISMATCH_ACTION"] = "VERSION_MISMATCH_ACTION";
    Translation["VERSION_MISMATCH_BODY"] = "VERSION_MISMATCH_BODY";
    Translation["VERSION_MISMATCH_TITLE"] = "VERSION_MISMATCH_TITLE";
    Translation["VIEW_CONFIGURATION"] = "VIEW_CONFIGURATION";
    Translation["VIEW_SERVICE"] = "VIEW_SERVICE";
    Translation["VOLUME"] = "VOLUME";
    Translation["VOLUME_DETAILS_DOCUMENTATION_BODY"] = "VOLUME_DETAILS_DOCUMENTATION_BODY";
    Translation["VOLUME_DETAILS_DOCUMENTATION_TITLE"] = "VOLUME_DETAILS_DOCUMENTATION_TITLE";
    Translation["VOLUME_LOGS"] = "VOLUME_LOGS";
    Translation["VOLUME_NOT_FOUND"] = "VOLUME_NOT_FOUND";
    Translation["VOLUMES_DOCUMENTATION_BODY"] = "VOLUMES_DOCUMENTATION_BODY";
    Translation["VOLUMES_DOCUMENTATION_TITLE"] = "VOLUMES_DOCUMENTATION_TITLE";
    Translation["WORKBENCH_TITLE"] = "WORKBENCH_TITLE";
    Translation["WRONG_MFA_CREDENTIALS"] = "WRONG_MFA_CREDENTIALS";
    Translation["YOU_NEED_PERMISSION_TO_VIEW_THIS_DATA"] = "YOU_NEED_PERMISSION_TO_VIEW_THIS_DATA";
    return Translation;
}({});
const $40a99dac858c1d75$export$552cd99e43fa1085 = (0, $65583c3760a483fc$export$2b5e8179047d3ac4)($40a99dac858c1d75$export$b63289fbda65eed1);



const $a477639c40078c3a$var$otpValidator = /^\d{1}$/;
const $a477639c40078c3a$export$e3ec818eb1037b73 = (otp)=>otp.every((v)=>$a477639c40078c3a$var$otpValidator.test(v));
class $a477639c40078c3a$export$596874a932ac8047 extends (0, $c3e1b746ad236797$export$8d524fb6540252df) {
    static is(e) {
        return e instanceof $a477639c40078c3a$export$596874a932ac8047;
    }
    constructor(extras){
        super((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, 'Invalid OTP', extras);
    }
}




const $bd157480915e9571$export$19d071bb1d74319 = (s)=>s.loginForm;
const $bd157480915e9571$export$a1f60355a4099a0c = (form)=>typeof form.otpSecret === 'string';
const $bd157480915e9571$export$aa571064e3c5dc86 = (form)=>(0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(form.otp);
const $bd157480915e9571$export$43a70886b2445563 = (form)=>typeof form.backup === 'string';
const $bd157480915e9571$export$cdd8cf848623c2e1 = (s)=>{
    const form = $bd157480915e9571$export$19d071bb1d74319(s);
    const { username: username } = form;
    if (username) {
        if ($bd157480915e9571$export$a1f60355a4099a0c(form) && $bd157480915e9571$export$aa571064e3c5dc86(form) && (0, $a477639c40078c3a$export$e3ec818eb1037b73)(form.otp)) /** User is using otp */ return {
            username: username,
            secret: form.otpSecret,
            otp: form.otp
        };
        if ($bd157480915e9571$export$a1f60355a4099a0c(form) && $bd157480915e9571$export$43a70886b2445563(form) && form.backup) /** User is using backup codes */ return {
            username: username,
            secret: form.otpSecret,
            backupCode: form.backup
        };
        if (!$bd157480915e9571$export$a1f60355a4099a0c(form) && form.password) /** User is using username and password */ return {
            username: username,
            password: form.password
        };
    }
    /** No valid means of login found, giving up */ return null;
};
const $bd157480915e9571$export$8f992d7a4bbc5c24 = (s)=>Boolean($bd157480915e9571$export$cdd8cf848623c2e1(s));



var $10784336063bfb60$export$25544a24f1dbb74 = /*#__PURE__*/ function(CybusPermissionContext) {
    CybusPermissionContext["CONTROL_PLANE"] = "CONTROL_PLANE";
    CybusPermissionContext["HTTP"] = "HTTP";
    CybusPermissionContext["MQTT"] = "MQTT";
    return CybusPermissionContext;
}({});
const $10784336063bfb60$export$1b3b7763317c5b30 = (p)=>(p.write || p.read) && p.resource.length > 0;
const $10784336063bfb60$export$2e83e407cf76af40 = (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)((0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
    context: null,
    id: null,
    resource: null,
    read: null,
    write: null
}));




class $5fd4acf82e6163f5$var$EditableCybusPermissionWithInheritanceImpl {
    static create() {
        return new $5fd4acf82e6163f5$var$EditableCybusPermissionWithInheritanceImpl();
    }
    constructor(internalPermission = null, internalRequirements = null, internalInheritance = {}){
        this.internalPermission = internalPermission;
        this.internalRequirements = internalRequirements;
        this.internalInheritance = internalInheritance;
        this.cache = {
            context: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.map((p)=>p.context)),
            resource: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.map((p)=>p.resource)),
            inheritancesRead: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>Object.values(this.internalInheritance).some((i)=>i.read)),
            inheritancesWrite: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>Object.values(this.internalInheritance).some((i)=>i.write)),
            inheritanceRoles: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>Object.values(this.internalInheritance).map((i)=>i.role)),
            read: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.internalPermission?.read || this.inheritancesRead),
            write: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.internalPermission?.write || this.inheritancesWrite)
        };
    }
    get permission() {
        return this.internalPermission;
    }
    get context() {
        return this.cache.context();
    }
    get resource() {
        return this.cache.resource();
    }
    get inheritancesRead() {
        return this.cache.inheritancesRead();
    }
    get inheritancesWrite() {
        return this.cache.inheritancesWrite();
    }
    get inheritanceRoles() {
        return this.cache.inheritanceRoles();
    }
    get read() {
        return this.cache.read();
    }
    get write() {
        return this.cache.write();
    }
    get required() {
        return this.internalRequirements;
    }
    clearCache(mode) {
        if (mode === 'none') return;
        if (mode === 'all') {
            this.cache.inheritancesRead.clear();
            this.cache.inheritancesWrite.clear();
            this.cache.inheritanceRoles.clear();
        }
        this.cache.context.clear();
        this.cache.resource.clear();
        this.cache.read.clear();
        this.cache.write.clear();
    }
    refresh(mode) {
        this.clearCache(mode);
        return this.internalPermission === null && this.internalRequirements === null && (0, $2ae70427bab197d4$export$dd1bc94b04021eeb)(this.internalInheritance);
    }
    map(mapper) {
        const first = this.internalPermission || Object.values(this.internalInheritance)[0];
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(first, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'First permission not found', {
            permission: this.internalPermission,
            inheritance: this.internalInheritance,
            requirements: this.internalRequirements
        }));
        return mapper(first);
    }
    clone() {
        return new $5fd4acf82e6163f5$var$EditableCybusPermissionWithInheritanceImpl(this.internalPermission, this.internalRequirements, this.internalInheritance);
    }
    updatePermission(addition) {
        this.internalPermission = addition;
        this.clearCache('permission');
        return this;
    }
    updateInheritance(addition) {
        this.internalInheritance[addition.role] = addition;
        this.clearCache('all');
        return this;
    }
    updateRequired(addition) {
        this.internalRequirements = addition;
        this.clearCache('none');
        return this;
    }
    removePermission() {
        this.internalPermission = null;
        return this.refresh('permission');
    }
    removeRequired() {
        this.internalRequirements = null;
        return this.refresh('none');
    }
    removeInheritance(removal) {
        if (this.internalInheritance[removal.role] === removal) delete this.internalInheritance[removal.role];
        return this.refresh('all');
    }
}
class $5fd4acf82e6163f5$export$97499fa49333a4d1 {
    constructor(permissionsInput, requiredInput, inheritedInput){
        this.permissionsInput = permissionsInput;
        this.requiredInput = requiredInput;
        this.inheritedInput = inheritedInput;
        this.indexed = Object.values((0, $10784336063bfb60$export$25544a24f1dbb74)).reduce((r, context)=>({
                ...r,
                [context]: []
            }), {});
        this.permissionsInput.forEach((p)=>this.create(p, (ref)=>ref.updatePermission(p)));
        this.inheritedInput.forEach((i)=>this.create(i, (ref)=>ref.updateInheritance(i)));
        this.requiredInput.forEach((r)=>this.create(r, (ref)=>ref.updateRequired(r)));
    }
    getRefOrDefault(permission) {
        return this.indexed[permission.context][permission.resource] || $5fd4acf82e6163f5$var$EditableCybusPermissionWithInheritanceImpl.create();
    }
    setRef(permission, impl) {
        this.indexed[permission.context][permission.resource] = impl;
    }
    deleteRef(permission) {
        delete this.indexed[permission.context][permission.resource];
    }
    create(addition, add) {
        this.setRef(addition, add(this.getRefOrDefault(addition)));
    }
    update(update, modify) {
        this.setRef(update, modify(this.getRefOrDefault(update).clone()));
    }
    remove(removal, remove) {
        const impl = this.indexed[removal.context][removal.resource];
        if (impl) {
            if (remove(impl)) // Is now empty, so remove it
            this.deleteRef(removal);
            else // Create a copy of what is left
            this.setRef(removal, impl.clone());
        }
    }
    setAll(permissions, required, inherited) {
        const [removedPermissions, , addedPermissions] = (0, $9bfc602ec92faf4d$export$eabbe41f409ce55b)(this.permissionsInput, permissions);
        const [removedInheritance, , addedInheritance] = (0, $9bfc602ec92faf4d$export$eabbe41f409ce55b)(this.inheritedInput, inherited);
        const [removedRequirement, , addedRequirement] = (0, $9bfc602ec92faf4d$export$eabbe41f409ce55b)(this.requiredInput, required);
        removedPermissions.forEach((p)=>this.remove(p, (ref)=>ref.removePermission()));
        removedInheritance.forEach((i)=>this.remove(i, (ref)=>ref.removeInheritance(i)));
        removedRequirement.forEach((r)=>this.remove(r, (ref)=>ref.removeRequired()));
        addedPermissions.forEach((p)=>this.update(p, (ref)=>ref.updatePermission(p)));
        addedInheritance.forEach((i)=>this.update(i, (ref)=>ref.updateInheritance(i)));
        addedRequirement.forEach((r)=>this.update(r, (ref)=>ref.updateRequired(r)));
        this.permissionsInput = permissions;
        this.inheritedInput = inherited;
        this.requiredInput = required;
        return Array.from(new Set([
            ...addedPermissions,
            ...addedInheritance,
            ...addedRequirement
        ].map((p)=>p.context)));
    }
    getPermissions() {
        return Object.values((0, $10784336063bfb60$export$25544a24f1dbb74)).reduce((r, context)=>({
                ...r,
                [context]: Object.values(this.indexed[context])
            }), {});
    }
}




const $a59be490d06a33b2$export$c5d11a104b3691c8 = (validation)=>(0, $36fb5ff0bd6498d5$export$2dabafa86f11ed64)(validation, (v)=>typeof v === 'string');



var $80ed8557cc0425cc$export$d41318922d055bfc = /*#__PURE__*/ function(CybusUserProvider) {
    CybusUserProvider["CONNECTWARE"] = "CONNECTWARE";
    CybusUserProvider["LDAP"] = "LDAP";
    CybusUserProvider["MICROSOFT_ENTRA_ID"] = "MICROSOFT_ENTRA_ID";
    return CybusUserProvider;
}({});
var $80ed8557cc0425cc$export$766a2ded12a6f943 = /*#__PURE__*/ function(CybusUserAuthenticationMethod) {
    CybusUserAuthenticationMethod["CERTIFICATE"] = "CERTIFICATE";
    CybusUserAuthenticationMethod["PASSWORD"] = "PASSWORD";
    CybusUserAuthenticationMethod["TOKEN"] = "TOKEN";
    return CybusUserAuthenticationMethod;
}({});
const $80ed8557cc0425cc$export$9c1a922921014239 = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    username: null,
    mqttPublishPrefix: null,
    password: null,
    passwordConfirmation: null,
    roles: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)(),
    permissions: (0, $10784336063bfb60$export$2e83e407cf76af40),
    authenticationMethods: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)(),
    isMfaEnforced: null
}, 'areUserFormsEqual');
const $80ed8557cc0425cc$export$97e30f316783ac5b = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    username: null,
    mfaStatus: null,
    mqttPublishPrefix: null,
    password: null,
    passwordConfirmation: null,
    roles: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)(),
    permissions: (0, $10784336063bfb60$export$2e83e407cf76af40),
    authenticationMethods: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)(),
    isMfaEnforced: null
}, 'areUserFormsEqual');
/**
 * Checks if username is present and if validation is positive
 */ const $80ed8557cc0425cc$var$isUsernameValid = ({ username: username, usernameValidation: usernameValidation })=>Boolean(username) && (0, $a59be490d06a33b2$export$c5d11a104b3691c8)(usernameValidation);
const $80ed8557cc0425cc$var$arePermissionsValid = ({ permissions: permissions })=>permissions.every((0, $10784336063bfb60$export$1b3b7763317c5b30));
/**
 * Checks if password is relevant or if validation is positive
 */ const $80ed8557cc0425cc$var$isPasswordValid = ({ password: password, passwordValidation: passwordValidation })=>password === null && passwordValidation === null || (0, $a59be490d06a33b2$export$c5d11a104b3691c8)(passwordValidation);
const $80ed8557cc0425cc$export$967824c71a20c40b = (form)=>$80ed8557cc0425cc$var$isUsernameValid(form) && $80ed8557cc0425cc$var$arePermissionsValid(form) && $80ed8557cc0425cc$var$isPasswordValid(form);
const $80ed8557cc0425cc$export$d458ae297c13a3ff = (form)=>(!form.canEditName || $80ed8557cc0425cc$var$isUsernameValid(form)) && $80ed8557cc0425cc$var$arePermissionsValid(form) && $80ed8557cc0425cc$var$isPasswordValid(form);
const $80ed8557cc0425cc$export$8dde6ee29d5a3169 = (u)=>Boolean(u.id) && u.canDelete;




const $beeea5165e6b24a4$var$areMSEntraIdGroupIdsEquals = (a, b)=>a === null || b === null ? a === b : (0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(a, b, {
        sort: false
    });
const $beeea5165e6b24a4$var$areRolesEquals = (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
    name: null,
    id: null,
    ldapGroupDn: null,
    msEntraIdGroupIds: $beeea5165e6b24a4$var$areMSEntraIdGroupIdsEquals,
    users: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)(),
    permissions: (0, $10784336063bfb60$export$2e83e407cf76af40),
    canEditName: null,
    canEditOthers: null,
    canDelete: null
});
const $beeea5165e6b24a4$export$90c517a953a1b4f3 = (a, b)=>(0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(a, b, {
        sort: false,
        equals: $beeea5165e6b24a4$var$areRolesEquals
    });
const $beeea5165e6b24a4$export$188c5a575d2c4e15 = (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
    name: null,
    ldapGroupDn: null,
    msEntraIdGroupIds: $beeea5165e6b24a4$var$areMSEntraIdGroupIdsEquals,
    permissions: (0, $10784336063bfb60$export$2e83e407cf76af40)
});
const $beeea5165e6b24a4$export$5b8009ded575d6f = ({ name: name, permissions: permissions })=>name.length > 0 && permissions.every((0, $10784336063bfb60$export$1b3b7763317c5b30));
const $beeea5165e6b24a4$export$173f0af7fce5fab1 = (form)=>form.canEditOthers && $beeea5165e6b24a4$export$5b8009ded575d6f(form);
const $beeea5165e6b24a4$export$26dd36dca303eb23 = (r)=>Boolean(r.id) && r.canDelete;




const $6d780693ef9ac26e$export$c07d35a8c9093be8 = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    mqttPublishPrefix: null,
    roles: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)(),
    permissions: (0, $10784336063bfb60$export$2e83e407cf76af40),
    authenticationMethods: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)()
}, 'areClientRegistryRequestFormsEqual');
const $6d780693ef9ac26e$export$3018d73bcedee4fa = ({ permissions: permissions, authenticationMethods: authenticationMethods })=>(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(authenticationMethods) && permissions.every((0, $10784336063bfb60$export$1b3b7763317c5b30));
const $6d780693ef9ac26e$var$areClientRegistryRequestEquals = (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
    username: null,
    description: null,
    timestamp: (0, $1f8efbeda4be7f45$export$99c416949ad3efe4)((t)=>t.getTime()),
    authenticationMethod: null,
    roles: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)(),
    permissions: (0, $10784336063bfb60$export$2e83e407cf76af40)
});
const $6d780693ef9ac26e$export$74915331dae2b65b = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    unlockedUntil: (0, $1f8efbeda4be7f45$export$99c416949ad3efe4)((t)=>t?.getTime()),
    requests: (0, $1f8efbeda4be7f45$export$9c813ac7100b0116)($6d780693ef9ac26e$var$areClientRegistryRequestEquals)
}, 'areClientRegistryDataEquals');




const $fbdaead6b0d14feb$export$6f609a3beb4bd7ae = (s)=>s.usersManagement;
const $fbdaead6b0d14feb$var$createUsersManagementSelector = (propName)=>(s)=>$fbdaead6b0d14feb$export$6f609a3beb4bd7ae(s)[propName];
const $fbdaead6b0d14feb$export$bf7fc1d8540b77ce = $fbdaead6b0d14feb$var$createUsersManagementSelector('roleCreation');
const $fbdaead6b0d14feb$export$8c529c986e442e67 = $fbdaead6b0d14feb$var$createUsersManagementSelector('roleUpdating');
const $fbdaead6b0d14feb$export$830f6d06818aa34 = $fbdaead6b0d14feb$var$createUsersManagementSelector('registryRequest');
const $fbdaead6b0d14feb$export$c3255b8cef0af79 = $fbdaead6b0d14feb$var$createUsersManagementSelector('userCreation');
const $fbdaead6b0d14feb$export$cf1548ec5e235d39 = $fbdaead6b0d14feb$var$createUsersManagementSelector('userUpdating');
const $fbdaead6b0d14feb$export$8c76e358ba74451b = $fbdaead6b0d14feb$var$createUsersManagementSelector('viewPermission');
const $fbdaead6b0d14feb$export$ff5eb3337d355fbf = $fbdaead6b0d14feb$var$createUsersManagementSelector('registry');
const $fbdaead6b0d14feb$export$c44b060058cf5112 = ([initial])=>initial;
const $fbdaead6b0d14feb$export$4904853904034fa9 = ([, current])=>current;




const $823726049107e73f$export$9baacaf8bb7b4e87 = (s)=>(0, $fbdaead6b0d14feb$export$ff5eb3337d355fbf)(s).data;
const $823726049107e73f$export$bd49409b92fc83cc = (s)=>$823726049107e73f$export$9baacaf8bb7b4e87(s) === null;
const $823726049107e73f$export$23d7982a2b8920cd = (s)=>{
    const data = $823726049107e73f$export$9baacaf8bb7b4e87(s);
    return (0, $c3e1b746ad236797$export$8d524fb6540252df).is(data) ? data : null;
};
const $823726049107e73f$export$790f9bc128365008 = (s)=>(0, $fbdaead6b0d14feb$export$ff5eb3337d355fbf)(s).locked;
const $823726049107e73f$export$624c20a5b74bddc6 = (s)=>{
    const locked = $823726049107e73f$export$790f9bc128365008(s);
    return locked === null || locked;
};
const $823726049107e73f$var$createLoadedRegistrySelector = (propName, defaultValue)=>(s)=>{
        const data = $823726049107e73f$export$9baacaf8bb7b4e87(s);
        return data === null || (0, $c3e1b746ad236797$export$8d524fb6540252df).is(data) ? defaultValue : data[propName];
    };
const $823726049107e73f$export$404928cf445cfb00 = $823726049107e73f$var$createLoadedRegistrySelector('unlockedUntil', null);
const $823726049107e73f$export$cbf35af70ae0b3a9 = $823726049107e73f$var$createLoadedRegistrySelector('requests', []);




const $55a8cd2d1e96ead3$export$f23f5525e25bce9e = (s, tab)=>(0, $fbdaead6b0d14feb$export$6f609a3beb4bd7ae)(s)[tab];
const $55a8cd2d1e96ead3$export$b5bd176576c7c005 = (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
    page: null,
    showInternal: null,
    search: null
});
const $55a8cd2d1e96ead3$var$createUsersManagementTabInformationSelector = (propName)=>(s, tab)=>$55a8cd2d1e96ead3$export$f23f5525e25bce9e(s, tab)[propName];
const $55a8cd2d1e96ead3$export$4f3303962d683d6e = $55a8cd2d1e96ead3$var$createUsersManagementTabInformationSelector('data');
const $55a8cd2d1e96ead3$export$9c7c2de2b1a0c08a = $55a8cd2d1e96ead3$var$createUsersManagementTabInformationSelector('search');
const $55a8cd2d1e96ead3$export$723849c1426bff71 = $55a8cd2d1e96ead3$var$createUsersManagementTabInformationSelector('page');
const $55a8cd2d1e96ead3$export$3d204d54547967c0 = $55a8cd2d1e96ead3$var$createUsersManagementTabInformationSelector('showInternal');
const $55a8cd2d1e96ead3$export$d3fdc632592facd4 = (tab, a, b)=>$55a8cd2d1e96ead3$export$b5bd176576c7c005($55a8cd2d1e96ead3$export$f23f5525e25bce9e(a, tab), $55a8cd2d1e96ead3$export$f23f5525e25bce9e(b, tab));









const $73c1dcd3ec66dcf5$var$cybusVolumeComparators = {
    id: null,
    name: null,
    service: null,
    created: (0, $1f8efbeda4be7f45$export$99c416949ad3efe4)((c)=>c.getTime()),
    status: null
};
const $73c1dcd3ec66dcf5$export$3b5e9855d93c8fe = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)($73c1dcd3ec66dcf5$var$cybusVolumeComparators, 'areCybusVolumeEquals');
const $73c1dcd3ec66dcf5$export$aa42524e4e8e2e63 = (0, $1f8efbeda4be7f45$export$7706906eb37331a3)({
    ...$73c1dcd3ec66dcf5$var$cybusVolumeComparators,
    labels: (0, $33cff95ba235ba3b$export$596273409274759)
}, 'areDetailedCybusVolumeEquals');




const $00bfc083c82fb6bc$export$7889cfb86da68b4e = (s)=>s.volume;
const $00bfc083c82fb6bc$export$83b9822c5d2e39f1 = (s)=>s.volumesPage;
const $00bfc083c82fb6bc$export$9b6405391d17baaa = (0, $f0717a7650cc5e17$export$d3e3eeb4af2d1203)($00bfc083c82fb6bc$export$7889cfb86da68b4e, 'id');
const $00bfc083c82fb6bc$export$228022853b9a73d5 = (0, $e926476d3d092144$export$8f6106f24823543e)($00bfc083c82fb6bc$export$83b9822c5d2e39f1, 'id', 'selectLoadedVolumes');




const $4220d57e589c900d$export$e41da262128eaf69 = (s)=>s.lastCopyId;





const $65e38d2a650b506d$export$19b083a30e6dacea = (form)=>Boolean(form.password && form.newPassword && form.confirmPassword && (0, $a59be490d06a33b2$export$c5d11a104b3691c8)(form.passwordValidation));
const $65e38d2a650b506d$export$7035a9f02825a4ad = (s)=>s.changePasswordForm;
const $65e38d2a650b506d$export$c0fe502c078e94ef = (s)=>Boolean($65e38d2a650b506d$export$7035a9f02825a4ad(s));


/* eslint-disable typescript-sort-keys/string-enum */ 

var $37c2a8e29603f683$export$da170fbff8c5bb0c = /*#__PURE__*/ function(MfaSettingsState) {
    MfaSettingsState["LOADING"] = "LOADING";
    MfaSettingsState["DISABLED"] = "DISABLED";
    MfaSettingsState["DISABLING"] = "DISABLING";
    MfaSettingsState["ENABLING"] = "ENABLING";
    MfaSettingsState["ENABLED"] = "ENABLED";
    MfaSettingsState["REGENERATING_BACKUP_CODES"] = "REGENERATING_BACKUP_CODES";
    MfaSettingsState["REGENERATED_BACKUP_CODES"] = "REGENERATED_BACKUP_CODES";
    return MfaSettingsState;
}({});
var $37c2a8e29603f683$export$5e93ec1eb1a0effa = /*#__PURE__*/ function(MFAStatus) {
    MFAStatus["ENABLED"] = "ENABLED";
    MFAStatus["DISABLED"] = "DISABLED";
    MFAStatus["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    MFAStatus["NOT_SETUP"] = "NOT_SETUP";
    return MFAStatus;
}({});
class $37c2a8e29603f683$export$c59494f4dae44ada extends (0, $c3e1b746ad236797$export$8d524fb6540252df) {
    static is(e) {
        return e instanceof $37c2a8e29603f683$export$c59494f4dae44ada;
    }
    constructor(secret){
        super((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, 'Multi-factor authentication required', {
            secret: secret
        });
    }
    get secret() {
        return this.extras.secret;
    }
}
class $37c2a8e29603f683$export$a3dab68f7f8fa48c extends (0, $c3e1b746ad236797$export$8d524fb6540252df) {
    static is(e) {
        return e instanceof $37c2a8e29603f683$export$a3dab68f7f8fa48c;
    }
    constructor(authentication){
        super((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, 'Multi-factor authentication setup required', authentication);
    }
}
const $37c2a8e29603f683$var$isMfaSettingsOnState = (settings, ...states)=>states.includes(settings.state);
const $37c2a8e29603f683$export$727c08e3007b47ec = (c)=>(0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(c.otp);
const $37c2a8e29603f683$export$42e8fa7c7a7606af = (s, ...states)=>{
    const settings = $37c2a8e29603f683$export$6d2c79465e542978(s);
    return settings && $37c2a8e29603f683$var$isMfaSettingsOnState(settings, ...states) ? settings : null;
};
const $37c2a8e29603f683$export$91e94d32412bafea = (settings)=>{
    const usingOtp = $37c2a8e29603f683$export$727c08e3007b47ec(settings);
    const input = // Try otp flow
    usingOtp && (0, $a477639c40078c3a$export$e3ec818eb1037b73)(settings.otp) && {
        otp: settings.otp,
        backupCode: null
    } || // Try backup flow
    !usingOtp && settings.backupCode && {
        otp: null,
        backupCode: settings.backupCode
    } || // Give up
    null;
    return input;
};
const $37c2a8e29603f683$export$6d2c79465e542978 = (s)=>s.mfa;
const $37c2a8e29603f683$export$8f0d2b82864c3426 = (s)=>({
        mfa: s
    });
const $37c2a8e29603f683$export$cdf9a2dd3b8433cb = (s)=>s.mfaRequiredAuthentication;
const $37c2a8e29603f683$export$7915da2b209d417d = (s)=>({
        mfaRequiredAuthentication: s
    });
const $37c2a8e29603f683$export$ff9e49793420e555 = (s)=>Boolean($37c2a8e29603f683$export$cdf9a2dd3b8433cb(s));
const $37c2a8e29603f683$var$createMfaRequiredAuthenticationSelector = (selector)=>(s)=>{
        const auth = $37c2a8e29603f683$export$cdf9a2dd3b8433cb(s);
        return auth ? selector(auth) : null;
    };
const $37c2a8e29603f683$export$24620db712c9d7b2 = $37c2a8e29603f683$var$createMfaRequiredAuthenticationSelector((0, $6bfd545928047d5f$export$4762e3eadf2f3a03));
const $37c2a8e29603f683$var$selectChecker = $37c2a8e29603f683$var$createMfaRequiredAuthenticationSelector((0, $6bfd545928047d5f$export$467fea09bf6b8399));
const $37c2a8e29603f683$export$e7d5c70253994566 = (...requiredPermissions)=>(s)=>Boolean($37c2a8e29603f683$var$selectChecker(s)?.(requiredPermissions));



var $eba4f0b13361fb3e$export$a0bf97755470bf0e = /*#__PURE__*/ function(SSOAuthenticationMethod) {
    SSOAuthenticationMethod["MICROSOFT_ENTRA_ID"] = "MICROSOFT_ENTRA_ID";
    return SSOAuthenticationMethod;
}({});
const $eba4f0b13361fb3e$export$88fff0225a6b2db = (s)=>s.supportedSSOs;
class $eba4f0b13361fb3e$export$d86854ef9821cdaf extends (0, $c3e1b746ad236797$export$8d524fb6540252df) {
    static is(e) {
        return e instanceof $eba4f0b13361fb3e$export$d86854ef9821cdaf;
    }
    constructor(extras){
        super((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, 'Could not authenticate with SSO', extras);
    }
}


const $b0991a9a4ef4845f$export$7ee49b75b6d0f0fb = (s)=>s.sideNavCollapsed;


var $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2 = /*#__PURE__*/ function(NotificationSeverity) {
    NotificationSeverity["ERROR"] = "error";
    NotificationSeverity["INFO"] = "info";
    NotificationSeverity["SUCCESS"] = "success";
    NotificationSeverity["WARNING"] = "warning";
    return NotificationSeverity;
}({});


const $83da31ffcebd71d6$export$8f481e8a25f70299 = (s)=>s.toasts;


const $39d33484e8b79466$export$6909fb9b4ba29917 = (s)=>s.activeBanner;


const $326a003cf0269e2b$export$8cce705316c4c043 = (s)=>s.deviationEventToasts;
const $326a003cf0269e2b$export$e4e9003e796cb10 = (s)=>s.deviationCounterToast;





const $95a9c43d1c8832e3$var$initialResourceActionState = {
    ids: null,
    load: false
};
const $95a9c43d1c8832e3$var$initialResourceState = {
    disable: $95a9c43d1c8832e3$var$initialResourceActionState,
    enable: $95a9c43d1c8832e3$var$initialResourceActionState,
    reenable: $95a9c43d1c8832e3$var$initialResourceActionState,
    delete: $95a9c43d1c8832e3$var$initialResourceActionState
};
const $95a9c43d1c8832e3$export$d4c72bab9d6cc13a = {
    changePasswordForm: null,
    loginForm: {
        username: '',
        password: '',
        otpSecret: null,
        otp: null,
        backup: null
    },
    usersManagement: {
        users: {
            search: '',
            data: null,
            page: 1,
            showInternal: false
        },
        roles: {
            search: '',
            data: null,
            page: 1,
            showInternal: false
        },
        permissions: {
            search: '',
            data: null,
            page: 1,
            showInternal: false
        },
        userUpdating: null,
        userCreation: null,
        viewPermission: null,
        roleUpdating: null,
        roleCreation: null,
        registry: {
            locked: null,
            data: null
        },
        registryRequest: null
    },
    authentication: null,
    versions: null,
    info: null,
    license: null,
    serviceForm: null,
    service: null,
    servicesDataPage: null,
    serviceTopicsMessages: {},
    servicesPage: null,
    deviatedServicesPage: null,
    servicesLinksPage: null,
    serviceDeviationResolution: null,
    serviceDeviationsPage: null,
    resourceDeviationPage: null,
    connection: null,
    connectionsPage: null,
    mapping: null,
    mappingEntries: null,
    mappingsPage: null,
    endpoint: null,
    endpointsPage: null,
    volume: null,
    volumesPage: null,
    serviceContainer: null,
    serviceContainersPage: null,
    coreContainer: null,
    coreContainersPage: null,
    server: null,
    serversPage: null,
    nodesPage: null,
    agentsPage: null,
    resources: {
        [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).AGENT]: $95a9c43d1c8832e3$var$initialResourceState,
        [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CONNECTION]: $95a9c43d1c8832e3$var$initialResourceState,
        [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CORE_CONTAINER]: $95a9c43d1c8832e3$var$initialResourceState,
        [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).ENDPOINT]: $95a9c43d1c8832e3$var$initialResourceState,
        [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).MAPPING]: $95a9c43d1c8832e3$var$initialResourceState,
        [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVER]: $95a9c43d1c8832e3$var$initialResourceState,
        [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE_CONTAINER]: $95a9c43d1c8832e3$var$initialResourceState,
        [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE]: $95a9c43d1c8832e3$var$initialResourceState,
        [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).VOLUME]: $95a9c43d1c8832e3$var$initialResourceState
    },
    explorer: null,
    ruleEngineSandbox: {
        type: (0, $5491cfd462130f7a$export$605f39a06a79387c).JSON,
        selectedTopics: null,
        input: {
            loaded: true,
            topic: null,
            value: {}
        },
        endpointsSearch: '',
        endpoints: null,
        selectedEndpoints: null,
        transformation: '',
        output: {
            loaded: false,
            id: 0,
            value: null
        }
    },
    certificates: null,
    lastCopyId: null,
    mfa: null,
    mfaRequiredAuthentication: null,
    loadingCount: 0,
    supportedSSOs: null,
    sideNavCollapsed: false,
    toasts: [],
    activeBanner: null,
    deviationEventToasts: [],
    deviationCounterToast: null
};
const $95a9c43d1c8832e3$export$fe9980998616231 = Array(6).fill('');










var $de76aa5bd91d062d$export$26609300e3bf37cf = /*#__PURE__*/ function(DocumentationType) {
    DocumentationType["CYBUS_DOCS"] = "CYBUS_DOCS";
    DocumentationType["LICENSE_OFFLINE_ACTIVATION"] = "LICENSE_OFFLINE_ACTIVATION";
    DocumentationType["LICENSING"] = "LICENSING";
    DocumentationType["MQTT_PREFIX"] = "MQTT_PREFIX";
    DocumentationType["RULE_ENGINE_PARSE_RULE"] = "RULE_ENGINE_PARSE_RULE";
    DocumentationType["SERVICES"] = "SERVICES";
    DocumentationType["SERVICES_COMMISSIONING_FILE"] = "SERVICES_COMMISSIONING_FILE";
    DocumentationType["UI_ACCESS_PERMISSIONS"] = "UI_ACCESS_PERMISSIONS";
    return DocumentationType;
}({});
var $de76aa5bd91d062d$export$431c833e82f9ca90 = /*#__PURE__*/ function(FileExtensionType) {
    FileExtensionType["CERTIFICATE"] = "CERTIFICATE";
    FileExtensionType["LICENSE"] = "LICENSE";
    FileExtensionType["SERVICE_COMMISSIONING"] = "SERVICE_COMMISSIONING";
    return FileExtensionType;
}({});






var $703a0e0813d6ac75$export$9eafce13aba72038 = /*#__PURE__*/ function(ServiceManagementMode) {
    ServiceManagementMode["CREATION"] = "CREATION";
    ServiceManagementMode["UPDATE"] = "UPDATE";
    return ServiceManagementMode;
}({});


























class $dfd5a49efac3fdb6$export$7f62ee5070458a6d {
    constructor(registry, services){
        this.registry = registry;
        this.services = services;
        this.setUsecase(this.constructor);
    }
    get authenticationPersistenceService() {
        return this.services.authenticationPersistenceService;
    }
    get authenticationService() {
        return this.services.authenticationService;
    }
    get browserService() {
        return this.services.browserService;
    }
    get certificatesService() {
        return this.services.certificatesService;
    }
    get configurationService() {
        return this.services.configurationService;
    }
    get connectwareLogsService() {
        return this.services.connectwareLogsService;
    }
    get connectwareResourcesManagementService() {
        return this.services.connectwareResourcesManagementService;
    }
    get connectwareServicesService() {
        return this.services.connectwareServicesService;
    }
    get fileService() {
        return this.services.fileService;
    }
    get logger() {
        return this.services.logger;
    }
    get ruleEngineService() {
        return this.services.ruleEngineService;
    }
    get subscriptionsService() {
        return this.services.subscriptionsService;
    }
    get systemService() {
        return this.services.systemService;
    }
    get topicsService() {
        return this.services.topicsService;
    }
    get topicsPersistenceService() {
        return this.services.topicsPersistenceService;
    }
    get translationService() {
        return this.services.translationService;
    }
    get userService() {
        return this.services.userService;
    }
    get clientRegistryService() {
        return this.services.clientRegistryService;
    }
    get tablePersistenceService() {
        return this.services.tablePersistenceService;
    }
    get columnViewPersistenceService() {
        return this.services.columnViewPersistenceService;
    }
    get recordPanelWidthPersistenceService() {
        return this.services.recordPanelWidthPersistenceService;
    }
    get mfaService() {
        return this.services.mfaService;
    }
    setUsecase(usecaseConstructor) {
        this.registry.set(usecaseConstructor, this);
    }
    /**
     * To get any other registered usecases
     */ getUsecase(usecaseConstructor) {
        const usecase = this.registry.get(usecaseConstructor);
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(usecase, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Could not find usecase on registry', {
            name: usecaseConstructor.name
        }));
        return usecase;
    }
    setState(state) {
        this.services.applicationState.setState(state);
    }
    getState() {
        return this.services.applicationState.getState();
    }
    subscribeToState(filter, subscriber) {
        return this.services.applicationState.subscribe(filter, subscriber);
    }
}






/**
 * This is a base usecase
 * Describes the manipulation of a prop under AppState['resources']
 *
 * Other usecases can specify the specific use of each dimension
 * And implement service calls to each
 */ class $0e262b77192f27d5$var$BulkResourceUsecase extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    get selected() {
        const { ids: ids } = this.getResources();
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(ids, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, `Can't ${this.dimension} the ${this.type}, state is not properly setup`));
        return ids;
    }
    getResources() {
        return (0, $5e13938500eec645$export$e9290a5ccd17ff37)(this.getState(), this.type, this.dimension);
    }
    setResources(update) {
        const resources = (0, $5e13938500eec645$export$c11350030b6e6fa4)(this.getState());
        this.setState({
            resources: {
                ...resources,
                [this.type]: {
                    ...resources[this.type],
                    [this.dimension]: {
                        ...this.getResources(),
                        ...update
                    }
                }
            }
        });
    }
    select(ids) {
        this.setResources({
            ...(0, $5e13938500eec645$export$e9290a5ccd17ff37)((0, $95a9c43d1c8832e3$export$d4c72bab9d6cc13a), this.type, this.dimension),
            ids: ids
        });
    }
    async execute(method) {
        try {
            this.setResources({
                load: true
            });
            await this.connectwareResourcesManagementService[method](this.type, this.selected);
            this.setResources({
                ids: null,
                load: false
            });
        } catch (e) {
            this.setResources({
                load: e
            });
        }
    }
}
class $0e262b77192f27d5$export$1931d3912bb14259 extends $0e262b77192f27d5$var$BulkResourceUsecase {
    async enable() {
        await this.execute('enable');
    }
    constructor(...args){
        super(...args), this.dimension = 'enable';
    }
}
class $0e262b77192f27d5$export$24c785bfdde217e8 extends $0e262b77192f27d5$var$BulkResourceUsecase {
    async disable() {
        await this.execute('disable');
    }
    constructor(...args){
        super(...args), this.dimension = 'disable';
    }
}
class $0e262b77192f27d5$export$f708ad0ed4e537ba extends $0e262b77192f27d5$var$BulkResourceUsecase {
    async delete() {
        await this.execute('delete');
    }
    constructor(...args){
        super(...args), this.dimension = 'delete';
    }
}
class $0e262b77192f27d5$export$78fa625c015da377 extends $0e262b77192f27d5$var$BulkResourceUsecase {
    async reenable() {
        await this.execute('reenable');
    }
    constructor(...args){
        super(...args), this.dimension = 'reenable';
    }
}




class $7b9515791776b163$export$8dbd5db7aa48881c extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    setSingleState(event) {
        this.setState({
            [this.singleAddress]: event
        });
    }
    /**
     * @returns an unsub function, to be called when the state should stop being updated
     */ subscribe(id) {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        /** Reset state */ this.setSingleState(null);
        /** Schedule state reset when done */ droppable.onDrop(()=>this.setSingleState(null));
        this.subscriptionsService.subscribeToOne(this.singularName, id, (data)=>this.setSingleState(data)).then((off)=>droppable.onDrop(off)).catch((e)=>this.setSingleState(e));
        return ()=>droppable.drop();
    }
}






const $091d28ec500ee607$export$efe56791b10fc931 = ([short, medium, large, max])=>{
    const belowMax = [
        ...new Set([
            short,
            medium,
            large
        ])
    ].filter((size)=>size < max).sort((a, b)=>a - b);
    return [
        ...belowMax,
        max
    ];
};
const $091d28ec500ee607$var$areSubscriptionPageOptionsEquals = (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
    search: null,
    sort: (0, $ef143c4e3199bc2b$export$e3b2f95055a9733d),
    pagination: (0, $e926476d3d092144$export$8e4ba12aa2056817)
});
class $091d28ec500ee607$export$e35eeca9ac01af15 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    generatePersistenceName(short, { server: server = '', service: service = '', connection: connection = '' }) {
        /** Generate a unique id for the tables that are initialized as short or as default alongside their filter parameters */ return [
            this.pageName,
            this.pageAddress,
            String(short),
            (0, $eaf49e34dc778a74$export$373f4c3083978ffd)(server),
            (0, $eaf49e34dc778a74$export$373f4c3083978ffd)(service),
            (0, $eaf49e34dc778a74$export$373f4c3083978ffd)(connection)
        ].join('_');
    }
    setPageState(page) {
        this.setState({
            [this.pageAddress]: page
        });
    }
    selectPageFromState(s) {
        return s[this.pageAddress];
    }
    selectLoadedPageFromState(s) {
        const state = this.selectPageFromState(s);
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(state !== null, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Resource page is not initialized', {
            pageAddress: this.pageAddress
        }));
        return state;
    }
    updatePageState(update) {
        this.setPageState({
            ...this.selectLoadedPageFromState(this.getState()),
            ...update
        });
    }
    /** A search shorter than the threshold isn't run, so it counts as no search */ toEffectiveSearch(search) {
        return search !== null && search.length >= this.getResourcesSearchThreshold() ? search : null;
    }
    /** The options the subscription actually runs with, which differ from the page state only by a too-short search */ selectSubscriptionPageOptions(s) {
        const { search: search, sort: sort, pagination: pagination } = this.selectLoadedPageFromState(s);
        return {
            search: this.toEffectiveSearch(search),
            sort: sort,
            pagination: pagination
        };
    }
    updateStateWithPageEvents(event) {
        let { pagination: pagination, data: data } = this.selectLoadedPageFromState(this.getState());
        if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(event)) data = event;
        else {
            data = {
                current: event.current,
                totalCount: event.totalCount
            };
            if (pagination.page !== event.page) /** Re-map the current page to stay in sync with the BE */ pagination = {
                ...pagination,
                page: event.page
            };
            if (pagination.pageSize !== event.pageSize) /** Re-map the current page size to stay in sync with the BE */ pagination = {
                ...pagination,
                pageSize: event.pageSize
            };
        }
        this.updatePageState({
            pagination: pagination,
            data: data
        });
    }
    initialize(short, filter) {
        const resourcePage = this.selectPageFromState(this.getState());
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(resourcePage === null, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Resource page was already initialized', {
            pageAddress: this.pageAddress
        }));
        let { page: page, pageSize: pageSize, sort: sort, search: search } = this.tablePersistenceService.retrieveTable(this.generatePersistenceName(short, filter));
        /** Either use the customized page, or, if there is nothing customized, use the short or medium sizes */ if (pageSize === undefined) {
            const [shortPage, mediumPage, , maxPage] = this.getPaginationSizes();
            pageSize = Math.min(short ? shortPage : mediumPage, maxPage);
        }
        this.setPageState({
            search: search === undefined ? null : search,
            sort: sort ? {
                asc: sort.asc,
                column: sort.column
            } : {
                asc: true,
                column: this.initialSortColumn
            },
            pagination: {
                pageSize: pageSize,
                page: page === undefined ? 0 : page
            },
            data: null
        });
    }
    subscribe({ short: short, ...filter }) {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        this.initialize(short, filter);
        const updateThrottler = new (0, $2accc4d3fee5c026$export$af12a1bf506c8522)(this.getThrottle());
        /** Start subscriptions finally */ this.subscriptionsService.subscribeToPage(this.pageName, {
            ...this.selectSubscriptionPageOptions(this.getState()),
            ...filter
        }).then((subscription)=>{
            /** Finally set internal listener */ droppable.onDrop(subscription.onData((event)=>droppable.ifNotDropped(()=>this.updateStateWithPageEvents(event))));
            /** Listen to the state for any changes to the pagination setup */ droppable.onDrop(this.subscribeToState((prev, curr)=>$091d28ec500ee607$var$areSubscriptionPageOptionsEquals(this.selectSubscriptionPageOptions(prev), this.selectSubscriptionPageOptions(curr)), ()=>/** Schedule an update */ droppable.onDrop(updateThrottler.run(()=>droppable.ifNotDropped(()=>{
                        const options = this.selectSubscriptionPageOptions(this.getState());
                        this.tablePersistenceService.persistTable(this.generatePersistenceName(short, filter), {
                            page: options.pagination.page,
                            pageSize: options.pagination.pageSize,
                            sort: options.sort,
                            search: options.search
                        });
                        subscription.update(options);
                    })))));
            /** Kill internal subscription when dropped */ droppable.onDrop(()=>subscription.stop());
        })/** Handle any issues that occur while setting up the subscription */ .catch((e)=>droppable.ifNotDropped(()=>this.updateStateWithPageEvents(e)))/** Schedule reset as well */ .finally(()=>droppable.onDrop(()=>this.setPageState(this.selectPageFromState((0, $95a9c43d1c8832e3$export$d4c72bab9d6cc13a)))));
        return ()=>droppable.drop();
    }
    updateParameters({ page: page, pageSize: pageSize, sort: sort, search: search }) {
        const state = this.getState();
        const current = this.selectLoadedPageFromState(state);
        let updated = {
            pagination: {
                ...current.pagination,
                page: page ?? current.pagination.page,
                pageSize: pageSize ?? current.pagination.pageSize
            },
            search: search !== undefined ? search : current.search,
            sort: sort ?? current.sort
        };
        if (updated.sort !== current.sort || this.toEffectiveSearch(updated.search) !== this.toEffectiveSearch(current.search) || updated.pagination.pageSize !== current.pagination.pageSize) /** If updating the sorting, search or page size, reset user to the first page */ updated = {
            ...updated,
            pagination: {
                ...updated.pagination,
                page: 0
            }
        };
        const isReloading = !$091d28ec500ee607$var$areSubscriptionPageOptionsEquals(this.selectSubscriptionPageOptions(state), {
            ...updated,
            search: this.toEffectiveSearch(updated.search)
        });
        /** Without a change the subscription would act on, the loaded data stays, and only the typed search is kept */ this.updatePageState(isReloading ? {
            ...updated,
            data: null
        } : {
            search: updated.search
        });
    }
    constructor(...args){
        super(...args), this.getThrottle = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.configurationService.getInteractionThrottle()), this.getPaginationSizes = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.configurationService.getResourcesPaginationSizes()), this.getResourcesSearchThreshold = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.configurationService.getResourcesSearchThreshold());
    }
}





class $69bdcfe0730f0c80$export$d45a5d6c8b3bcf3a extends (0, $091d28ec500ee607$export$e35eeca9ac01af15) {
    constructor(...args){
        super(...args), this.pageName = 'agents', this.pageAddress = 'agentsPage', this.initialSortColumn = 'name';
    }
}




class $549ff04f846b6ac9$export$3843f9bb6288bf65 extends (0, $0e262b77192f27d5$export$f708ad0ed4e537ba) {
    selectAgents(names) {
        this.select(names);
    }
    delete() {
        return super.delete();
    }
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).AGENT;
    }
}





class $59ededb85d1c8ccc$export$4eebe38be93527e2 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    invoke() {
        return this.configurationService.getApplicationMetadata();
    }
}






var $3f24850e5c974db2$export$55e75bec2b906c5e = /*#__PURE__*/ function(LogoutReason) {
    /**
     * User has manually logged out
     */ LogoutReason["MANUAL_LOGOUT"] = "MANUAL_LOGOUT";
    /**
     * Logout is happening due to token being expired
     */ LogoutReason["TOKEN_EXPIRED"] = "TOKEN_EXPIRED";
    return LogoutReason;
}({});
class $3f24850e5c974db2$export$d524a685bc361813 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    /**
     * This checks if the user should be redirected, and then does it
     */ attemptRedirection() {
        const currentUrl = this.browserService.getRedirectionURL();
        if (!currentUrl) return;
        try {
            this.browserService.redirect(currentUrl);
        } catch (e) {
            this.logger.error(e);
        }
    }
    async setupExpirationTimers() {
        const oldAuthentication = (0, $1c05f13022cf1480$export$d7186caa83d1ebde)(this.getState());
        if (!(0, $1c05f13022cf1480$export$83d11f23a23d4a7c)(oldAuthentication)) /** No need for timer, user is not authenticated */ return;
        const expiresAt = (0, $6bfd545928047d5f$export$fe203747b10f326e)(oldAuthentication);
        for (const { executionTimestamp: executionTimestamp, execute: execute } of [
            /** Set expire soon to true when the warning period starts */ {
                executionTimestamp: new Date(expiresAt.getTime() - this.configurationService.getLogoutWarningPeriod()),
                execute: ()=>this.setState({
                        authentication: {
                            ...oldAuthentication,
                            expiresSoon: true
                        }
                    })
            },
            /** Log out at the expiration */ {
                executionTimestamp: expiresAt,
                execute: ()=>this.logout("TOKEN_EXPIRED")
            }
        ]){
            await (0, $48cf5ef53a480c1f$export$1391212d75b2ee65)(executionTimestamp);
            if ((0, $1c05f13022cf1480$export$f145af4743957df7)(this.getState()) !== oldAuthentication.token) /** Authentication has changed, so stop everything */ return;
            execute();
        }
    }
    persist(info) {
        this.browserService.authenticate(info);
        if (info) this.authenticationPersistenceService.persist(info);
        else {
            this.authenticationPersistenceService.flush();
            this.tablePersistenceService.flush();
            this.columnViewPersistenceService.flush();
        }
    }
    updateAuthentication(authentication) {
        if (!(0, $c3e1b746ad236797$export$8d524fb6540252df).is(authentication)) this.persist(authentication);
        /**
         * Finally, update the state and if the user is authenticated,
         * remove their password so it cannot be reused
         */ const state = {
            authentication: authentication
        };
        if ((0, $1c05f13022cf1480$export$83d11f23a23d4a7c)(authentication)) /** Reset everything but the username */ state.loginForm = {
            ...(0, $bd157480915e9571$export$19d071bb1d74319)((0, $95a9c43d1c8832e3$export$d4c72bab9d6cc13a)),
            username: authentication.username
        };
        this.setState(state);
        this.setupExpirationTimers();
        if ((0, $1c05f13022cf1480$export$83d11f23a23d4a7c)(authentication)) this.attemptRedirection();
    }
    updateAuthenticationFromToken(token) {
        return this.authenticationService.fetchSession(token).then((session)=>this.updateAuthentication({
                ...session,
                token: token,
                obsolete: null,
                expiresSoon: false
            })).catch((error)=>this.updateAuthentication(error));
    }
    logout(logoutReason) {
        const token = (0, $1c05f13022cf1480$export$f145af4743957df7)(this.getState());
        if (token !== null) this.authenticationService.flushAuthentication(token).catch((e)=>this.logger.error(e));
        this.persist(null);
        this.setState({
            authentication: logoutReason === "TOKEN_EXPIRED" ? new (0, $ce07554ccb7fdbc8$export$8a25c189a0dc6a1b)() : null
        });
    }
}



class $d966f49311c5b2c6$export$fa306862f2d2d024 extends (0, $3f24850e5c974db2$export$d524a685bc361813) {
    /**
     * Logs user out and reloads page
     */ logout(logoutReason) {
        super.logout(logoutReason);
    }
}




class $ecac7cf418cabc4a$export$b85e58149769aeec extends (0, $d966f49311c5b2c6$export$fa306862f2d2d024) {
    /**
     * Reads from persistence layer, searching for persisted token that can be re-used
     *
     * @returns if information was there and valid from the perspective of the front-end
     */ loginWithPersistedInformation() {
        let authentication = this.authenticationPersistenceService.retrieve();
        if (authentication && (0, $6bfd545928047d5f$export$fe203747b10f326e)(authentication) < new Date()) /**
             * The token has expired, so drop it
             */ authentication = null;
        this.updateAuthentication(authentication);
        return Boolean(authentication);
    }
}



class $30bf46dab521b87e$export$e6e5d48cb04d8be7 extends (0, $d966f49311c5b2c6$export$fa306862f2d2d024) {
    loginBrowserFromToken() {
        const tokenOrError = this.browserService.extractURLAuthentication();
        if (tokenOrError === null) /** There is no token, give up */ return false;
        if (typeof tokenOrError === 'string') /** Attempt to fetch the session, load it, and then drop the args from the URL */ this.updateAuthenticationFromToken(tokenOrError).then(()=>this.browserService.removeURLAuthentication());
        else this.updateAuthentication(tokenOrError);
        return true;
    }
}



class $60f029876a050e15$export$ee2df158a740437b extends (0, $d966f49311c5b2c6$export$fa306862f2d2d024) {
    async fetchSupported() {
        const supportedSSOs = await this.authenticationService.fetchActiveSSOAuthenticationMethods().catch((error)=>error);
        this.setState({
            supportedSSOs: supportedSSOs
        });
    }
    async redirectToAuthenticationUrl(type) {
        const url = await this.authenticationService.fetchSSOAuthenticationUrl(type);
        this.browserService.redirect(url);
    }
}










class $dec9e019b2a7039b$export$ab3e509014cf413 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    setMfa(mfa) {
        this.setState((0, $37c2a8e29603f683$export$8f0d2b82864c3426)(mfa));
    }
    getMFaSettings(...states) {
        const state = this.getState();
        const mfa = (0, $37c2a8e29603f683$export$42e8fa7c7a7606af)(state, ...states);
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(mfa, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Mfa state is not in the expected state', {
            states: states
        }));
        return mfa;
    }
    updateMfaSettings(update) {
        this.setMfa({
            ...this.getMFaSettings(update.state),
            ...update
        });
    }
}


class $32624675c0ac9ba4$export$a74b0dc6865b503c extends (0, $dec9e019b2a7039b$export$ab3e509014cf413) {
    load() {
        const dropable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        this.setMfa({
            state: (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).LOADING,
            error: null
        });
        this.mfaService.isEnabled().then((enabled)=>dropable.ifNotDropped(()=>this.setMfa(enabled ? {
                    state: (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).ENABLED,
                    backupCodes: null
                } : {
                    state: (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).DISABLED
                }))).catch((error)=>dropable.ifNotDropped(()=>this.updateMfaSettings({
                    state: (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).LOADING,
                    error: error
                })));
        dropable.onDrop(()=>this.setMfa(null));
        return ()=>dropable.drop();
    }
}






class $bca103a784110feb$export$9a92766468cfcb94 extends (0, $dec9e019b2a7039b$export$ab3e509014cf413) {
    /** Does **not** throw errors in expected conditions */ async start() {
        /** Asserting that MFA is currently disabled */ this.getMFaSettings((0, $37c2a8e29603f683$export$da170fbff8c5bb0c).DISABLED);
        /** Start enabling process */ this.setMfa({
            state: (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).ENABLING,
            activation: null,
            otp: (0, $95a9c43d1c8832e3$export$fe9980998616231),
            error: null
        });
        /** Load activation metadata onto the state */ await this.mfaService.enable().catch((e)=>e).then((activation)=>this.updateMfaSettings({
                state: (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).ENABLING,
                activation: activation
            }));
    }
    setOtp(otp) {
        this.updateMfaSettings({
            state: (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).ENABLING,
            otp: otp
        });
    }
    /** Does **not** throw errors in expected conditions */ async confirm() {
        const { otp: otp } = this.getMFaSettings((0, $37c2a8e29603f683$export$da170fbff8c5bb0c).ENABLING);
        try {
            (0, $14eddac5f20c576c$export$a7a9523472993e97)((0, $a477639c40078c3a$export$e3ec818eb1037b73)(otp), new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Invalid OTP', {
                otp: otp
            }));
            /** Reset error */ this.updateMfaSettings({
                state: (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).ENABLING,
                error: null
            });
            this.setMfa({
                state: (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).ENABLED,
                backupCodes: await this.mfaService.confirmEnabling(otp)
            });
        } catch (e) {
            this.updateMfaSettings({
                state: (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).ENABLING,
                error: e
            });
        }
    }
}








/** Stable states in which MFA is already enabled */ const $e3b8041cad98543f$var$stableStates = [
    (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).ENABLED,
    (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).REGENERATED_BACKUP_CODES
];
class $e3b8041cad98543f$export$3a85f18fd18d2481 extends (0, $dec9e019b2a7039b$export$ab3e509014cf413) {
    start() {
        /** Asserting that MFA is currently enabled */ this.getMFaSettings(...$e3b8041cad98543f$var$stableStates);
        /** Start process */ this.setMfa(this.initialSettings);
    }
    cancel() {
        this.setMfa({
            state: (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).ENABLED,
            backupCodes: null
        });
    }
    /**
     * Toggle between using otp or backup codes
     */ toggle() {
        const settings = this.getMFaSettings(this.initialSettings.state);
        this.updateMfaSettings({
            state: this.initialSettings.state,
            ...(0, $37c2a8e29603f683$export$727c08e3007b47ec)(settings) ? {
                otp: null,
                backupCode: ''
            } : {
                otp: (0, $95a9c43d1c8832e3$export$fe9980998616231),
                backupCode: null
            }
        });
    }
    /**
     * Update the current input, whether that's the otp or the backup code
     */ updateInput(update) {
        const settings = this.getMFaSettings(this.initialSettings.state);
        const isUsingOtp = (0, $37c2a8e29603f683$export$727c08e3007b47ec)(settings);
        const arrayness = (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(update);
        const settingsUpdate = isUsingOtp && arrayness && {
            otp: update
        } || !isUsingOtp && !arrayness && {
            backupCode: update
        };
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(settingsUpdate, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Invalid Update input', {
            settings: settings,
            update: update
        }));
        this.updateMfaSettings({
            state: this.initialSettings.state,
            ...settingsUpdate
        });
    }
    /** Does **not** throw errors in expected conditions */ async confirm() {
        const settings = this.getMFaSettings(this.initialSettings.state);
        try {
            const input = (0, $37c2a8e29603f683$export$91e94d32412bafea)(settings);
            (0, $14eddac5f20c576c$export$a7a9523472993e97)(input, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Invalid state for confirmation', settings));
            /** Reset any previous error */ this.updateMfaSettings({
                state: this.initialSettings.state,
                error: null
            });
            /** Either perform action and move user to next state or show error */ this.setMfa(await this.execute(input));
        } catch (e) {
            this.updateMfaSettings({
                state: this.initialSettings.state,
                error: e
            });
        }
    }
}


class $066a0a5a67673b88$export$688f87bf310930a6 extends (0, $e3b8041cad98543f$export$3a85f18fd18d2481) {
    async execute(input) {
        return {
            state: (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).REGENERATED_BACKUP_CODES,
            backupCodes: await this.mfaService.regenerateBackupCodes(input)
        };
    }
    constructor(...args){
        super(...args), this.initialSettings = {
            state: (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).REGENERATING_BACKUP_CODES,
            error: null,
            otp: (0, $95a9c43d1c8832e3$export$fe9980998616231),
            backupCode: null
        };
    }
}





class $e4342e4754a974b7$export$83b462fd81279800 extends (0, $e3b8041cad98543f$export$3a85f18fd18d2481) {
    async execute(input) {
        await this.mfaService.disable(input);
        return {
            state: (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).DISABLED
        };
    }
    constructor(...args){
        super(...args), this.initialSettings = {
            state: (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).DISABLING,
            error: null,
            otp: (0, $95a9c43d1c8832e3$export$fe9980998616231),
            backupCode: null
        };
    }
}






class $29f5a48fd1fa0c87$export$54ddab5945e83186 extends (0, $dec9e019b2a7039b$export$ab3e509014cf413) {
    async load({ extras: extras }) {
        this.setState({
            /** Mark mfa as disabled (as it currently is) */ ...(0, $37c2a8e29603f683$export$8f0d2b82864c3426)({
                state: (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).DISABLED
            }),
            /** Load separate authentication */ ...(0, $37c2a8e29603f683$export$7915da2b209d417d)(extras)
        });
        if ((0, $6bfd545928047d5f$export$4c17e06804984df7)(extras).includes((0, $78670ebe9381a713$export$790a66df9dc00390).USE_MFA)) /** Run first mfa enabling step if user can manage it */ await this.getUsecase((0, $bca103a784110feb$export$9a92766468cfcb94)).start();
        /** If token runs out, it needs to be dealt with */ (0, $48cf5ef53a480c1f$export$1391212d75b2ee65)((0, $6bfd545928047d5f$export$fe203747b10f326e)(extras)).finally(()=>{
            if ((0, $6bfd545928047d5f$export$4762e3eadf2f3a03)(extras) === (0, $37c2a8e29603f683$export$24620db712c9d7b2)(this.getState())) this.reset();
        });
    }
    reset() {
        this.setState({
            ...(0, $37c2a8e29603f683$export$7915da2b209d417d)(null),
            ...(0, $37c2a8e29603f683$export$8f0d2b82864c3426)(null)
        });
    }
}





class $27e30e4f11bba5f5$export$3c74c9e5f718dd43 extends (0, $3f24850e5c974db2$export$d524a685bc361813) {
    /**
     * Updates form to be used for login
     */ updateLoginForm(update) {
        const currentForm = (0, $bd157480915e9571$export$19d071bb1d74319)(this.getState());
        if ('username' in update && (0, $bd157480915e9571$export$a1f60355a4099a0c)(currentForm)) /** User changed their username again, so they are no longer going through MFA */ update = {
            ...(0, $bd157480915e9571$export$19d071bb1d74319)((0, $95a9c43d1c8832e3$export$d4c72bab9d6cc13a)),
            username: update.username,
            password: currentForm.password
        };
        this.setState({
            loginForm: {
                ...currentForm,
                ...update
            },
            authentication: null
        });
    }
    toggleMfaMethod() {
        const { backup: backup, otp: otp } = (0, $bd157480915e9571$export$19d071bb1d74319)(this.getState());
        this.updateLoginForm({
            backup: typeof backup === 'string' ? null : '',
            otp: (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(otp) ? null : (0, $95a9c43d1c8832e3$export$fe9980998616231)
        });
    }
    cancelMfa() {
        const { backup: backup, otp: otp, otpSecret: otpSecret } = (0, $bd157480915e9571$export$19d071bb1d74319)((0, $95a9c43d1c8832e3$export$d4c72bab9d6cc13a));
        this.updateLoginForm({
            backup: backup,
            otp: otp,
            otpSecret: otpSecret
        });
    }
    /**
     * Attempts to login with information on loginForm
     * @returns if the user was able to be logged in or not
     */ async login() {
        const request = (0, $bd157480915e9571$export$cdd8cf848623c2e1)(this.getState());
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(request, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Could not log-in'));
        this.setState({
            authentication: null
        });
        try {
            this.updateAuthentication({
                ...await this.authenticationService.authenticate(request),
                username: request.username,
                obsolete: null,
                expiresSoon: false
            });
            return true;
        } catch (e) {
            if ((0, $37c2a8e29603f683$export$a3dab68f7f8fa48c).is(e)) {
                /** Mfa is required, drop user's password and then load mfa */ const { password: initialPassword } = (0, $bd157480915e9571$export$19d071bb1d74319)((0, $95a9c43d1c8832e3$export$d4c72bab9d6cc13a));
                this.updateLoginForm({
                    password: initialPassword
                });
                await this.getUsecase((0, $29f5a48fd1fa0c87$export$54ddab5945e83186)).load(e);
            } else if ((0, $37c2a8e29603f683$export$c59494f4dae44ada).is(e)) /** User is still not logged in, needs to provide otp */ this.updateLoginForm({
                otpSecret: e.secret,
                otp: (0, $95a9c43d1c8832e3$export$fe9980998616231)
            });
            else this.updateAuthentication(e);
            return false;
        }
    }
}





class $a6227f026526b8f9$export$1c9acd11ed646f2a extends (0, $3f24850e5c974db2$export$d524a685bc361813) {
    getNonObsoleteAuthenticationInfo() {
        const authentication = (0, $1c05f13022cf1480$export$d7186caa83d1ebde)(this.getState());
        if (!(0, $1c05f13022cf1480$export$83d11f23a23d4a7c)(authentication) || (0, $6bfd545928047d5f$export$d38011aa9682808f)(authentication) !== null) /** Already obsolete */ return null;
        return authentication;
    }
    getAuthenticatedToken() {
        const token = (0, $1c05f13022cf1480$export$f145af4743957df7)(this.getState());
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(token !== null, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'User is not authenticated'));
        return token;
    }
    /**
     * Used to detect authentication obsolescence
     */ async updateObsolescence() {
        if (this.getNonObsoleteAuthenticationInfo() === null) return;
        /** Get the obsolescence status */ const status = await this.authenticationService.fetchAuthenticationStatus(this.getAuthenticatedToken()).catch((e)=>e);
        const authentication = this.getNonObsoleteAuthenticationInfo();
        if (authentication === null) return;
        this.updateAuthentication({
            ...authentication,
            obsolete: status
        });
    }
    /**
     * Used to reload authentication from backend using token on application state
     */ async reload() {
        await this.updateAuthenticationFromToken(this.getAuthenticatedToken());
    }
}










class $faef306442fac532$export$e3ad60c87cefb071 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    updateCertificates(remapper) {
        const certificates = (0, $aadfb82b994af9ea$export$e5be0e9f0af0ab8b)(this.getState());
        (0, $14eddac5f20c576c$export$a7a9523472993e97)((0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(certificates), new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Application state is unexpected. Update not possible'));
        this.setState({
            certificates: remapper(certificates)
        });
    }
}


class $28cce69de8681ba2$export$cc7ee9e47b833334 extends (0, $faef306442fac532$export$e3ad60c87cefb071) {
    invoke() {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        this.certificatesService.fetchCertificates().then((certificates)=>droppable.ifNotDropped(()=>this.setState({
                    certificates: certificates
                }))).catch((certificates)=>droppable.ifNotDropped(()=>this.setState({
                    certificates: certificates
                })));
        /** Once dropped, reset */ droppable.onDrop(()=>this.setState({
                certificates: (0, $aadfb82b994af9ea$export$e5be0e9f0af0ab8b)((0, $95a9c43d1c8832e3$export$d4c72bab9d6cc13a))
            }));
        return ()=>droppable.drop();
    }
}



class $e9a16ecf1d738e89$export$f16b64f165132257 extends (0, $faef306442fac532$export$e3ad60c87cefb071) {
    async add(content) {
        const certificate = await this.certificatesService.upload(content);
        this.updateCertificates((certificates)=>[
                ...certificates,
                certificate
            ]);
    }
}



class $ade1129b818a4d6f$export$eebbe27d8fa9c283 extends (0, $faef306442fac532$export$e3ad60c87cefb071) {
    async delete(certificate) {
        /** Delete certificate */ await this.certificatesService.delete(certificate);
        /** Remove certificates from state */ this.updateCertificates((certificates)=>certificates.filter((c)=>c !== certificate));
    }
}





class $1dfb6cd6e9e608fa$export$a5326e373df9bdd2 extends (0, $faef306442fac532$export$e3ad60c87cefb071) {
    async download(certificate) {
        const content = await this.certificatesService.fetchCertificateFileContent(certificate);
        const [extension] = this.configurationService.getSupportedFileExtensions((0, $de76aa5bd91d062d$export$431c833e82f9ca90).CERTIFICATE);
        this.fileService.download(new File([
            content
        ], `${(0, $aadfb82b994af9ea$export$5ace278d59015300)(certificate)}.${extension}`));
    }
}







const $a3c473cf3c5a58ef$var$emptyForm = {
    password: '',
    newPassword: '',
    confirmPassword: '',
    passwordValidation: null
};
class $a3c473cf3c5a58ef$export$7c5910b04f454619 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    setChangePasswordForm(changePasswordForm) {
        this.setState({
            changePasswordForm: changePasswordForm
        });
    }
    getChangePasswordForm() {
        const form = (0, $65e38d2a650b506d$export$7035a9f02825a4ad)(this.getState());
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(form, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Can not get change password form'));
        return form;
    }
    updateChangePasswordForm(form) {
        this.setChangePasswordForm({
            ...this.getChangePasswordForm(),
            ...form
        });
    }
    getPasswordChangeRequest() {
        const form = this.getChangePasswordForm();
        const { password: password, newPassword: newPassword, passwordValidation: passwordValidation } = form;
        if (!password || !newPassword || !(0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(passwordValidation) || passwordValidation.some((validation)=>typeof validation !== 'string')) return null;
        return {
            password: password,
            newPassword: newPassword
        };
    }
    async updatePasswordValidation() {
        const form = this.getChangePasswordForm();
        const passwordValidation = await this.validatePassword(form).catch((e)=>e);
        if (this.getChangePasswordForm() === form) /** There have been no changes */ this.updateChangePasswordForm({
            passwordValidation: passwordValidation
        });
    }
    async validatePassword({ newPassword: newPassword, confirmPassword: confirmPassword }) {
        const validateMethod = this.userService.validatePassword(newPassword);
        return [
            this.createConfirmationValidationMessage({
                newPassword: newPassword,
                confirmPassword: confirmPassword
            }),
            ...await validateMethod
        ].filter((v)=>Boolean(v));
    }
    createConfirmationValidationMessage({ newPassword: newPassword, confirmPassword: confirmPassword }) {
        const matchMessage = this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).PASSWORD_VALIDATION, {
            type: 'match'
        });
        return newPassword === confirmPassword ? matchMessage : new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).GENERAL_BUSINESS_RULE_INFRACTION, matchMessage);
    }
    /**
     * Toggle password changing
     */ toggle() {
        this.setChangePasswordForm((0, $65e38d2a650b506d$export$c0fe502c078e94ef)(this.getState()) ? null : $a3c473cf3c5a58ef$var$emptyForm);
    }
    /**
     * Update the change password form
     * @param form
     */ updateForm(form) {
        this.updateChangePasswordForm(form);
        if (form.newPassword ?? form.confirmPassword) this.updatePasswordValidation();
    }
    /**
     * Update the password
     */ async invoke() {
        const request = this.getPasswordChangeRequest();
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(request, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Can not update password'));
        await this.userService.changePassword(request);
        /** Now clear the form so password does not get remembered */ this.updateForm($a3c473cf3c5a58ef$var$emptyForm);
    }
}





class $786ede0f790131ed$export$725078b289d38018 extends (0, $091d28ec500ee607$export$e35eeca9ac01af15) {
    constructor(...args){
        super(...args), this.pageName = 'connections', this.pageAddress = 'connectionsPage', this.initialSortColumn = 'service';
    }
}
class $786ede0f790131ed$export$d52ef41ed3cfe093 extends (0, $7b9515791776b163$export$8dbd5db7aa48881c) {
    constructor(...args){
        super(...args), this.singularName = 'connection', this.singleAddress = 'connection';
    }
}




class $13bccdb70e276f41$export$77a6c0350e13812d extends (0, $0e262b77192f27d5$export$f708ad0ed4e537ba) {
    selectConnections(ids) {
        this.select(ids);
    }
    delete() {
        return super.delete();
    }
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CONNECTION;
    }
}
class $13bccdb70e276f41$export$137d2798b408ef65 extends (0, $0e262b77192f27d5$export$1931d3912bb14259) {
    selectConnections(ids) {
        this.select(ids);
    }
    connect() {
        return super.enable();
    }
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CONNECTION;
    }
}
class $13bccdb70e276f41$export$7d251909b6893d6d extends (0, $0e262b77192f27d5$export$24c785bfdde217e8) {
    selectConnections(ids) {
        this.select(ids);
    }
    disconnect() {
        return super.disable();
    }
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CONNECTION;
    }
}





class $714093a85438e59a$export$737c0d09687bf83 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    sendEmail(email, subject) {
        this.browserService.sendEmail(email, subject || null);
    }
    sendSalesEmail(subject) {
        this.sendEmail(this.getSalesEmail(), subject);
    }
    sendSupportEmail(subject) {
        this.sendEmail(this.getSupportEmail(), subject);
    }
    getSalesEmail() {
        return this.configurationService.getSalesEmail();
    }
    getSupportEmail() {
        return this.configurationService.getSupportEmail();
    }
}





class $d3733d28ed2b022e$export$c223af5fb83cd500 extends (0, $091d28ec500ee607$export$e35eeca9ac01af15) {
    constructor(...args){
        super(...args), this.pageName = 'serviceContainers', this.pageAddress = 'serviceContainersPage', this.initialSortColumn = 'service';
    }
}
class $d3733d28ed2b022e$export$868018c72176e16d extends (0, $7b9515791776b163$export$8dbd5db7aa48881c) {
    constructor(...args){
        super(...args), this.singularName = 'serviceContainer', this.singleAddress = 'serviceContainer';
    }
}
class $d3733d28ed2b022e$export$bd35bb1fbc92938b extends (0, $7b9515791776b163$export$8dbd5db7aa48881c) {
    constructor(...args){
        super(...args), this.singularName = 'coreContainer', this.singleAddress = 'coreContainer';
    }
}
class $d3733d28ed2b022e$export$287a47aae54878de extends (0, $091d28ec500ee607$export$e35eeca9ac01af15) {
    constructor(...args){
        super(...args), this.pageName = 'coreContainers', this.pageAddress = 'coreContainersPage', this.initialSortColumn = 'name';
    }
}




class $f2c1a77a86e27d7a$var$BulkDeleteContainersUsecase extends (0, $0e262b77192f27d5$export$f708ad0ed4e537ba) {
    selectContainers(ids) {
        this.select(ids);
    }
    delete() {
        return super.delete();
    }
}
class $f2c1a77a86e27d7a$export$8c494260e69be049 extends $f2c1a77a86e27d7a$var$BulkDeleteContainersUsecase {
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE_CONTAINER;
    }
}
class $f2c1a77a86e27d7a$var$BulkStartContainersUsecase extends (0, $0e262b77192f27d5$export$1931d3912bb14259) {
    selectContainers(ids) {
        this.select(ids);
    }
    start() {
        return super.enable();
    }
}
class $f2c1a77a86e27d7a$export$3d8e4c7d5151a1ce extends $f2c1a77a86e27d7a$var$BulkStartContainersUsecase {
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE_CONTAINER;
    }
}
class $f2c1a77a86e27d7a$export$590ca45b01504df4 extends $f2c1a77a86e27d7a$var$BulkStartContainersUsecase {
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CORE_CONTAINER;
    }
}
class $f2c1a77a86e27d7a$var$BulkStopContainersUsecase extends (0, $0e262b77192f27d5$export$24c785bfdde217e8) {
    selectContainers(ids) {
        this.select(ids);
    }
    stop() {
        return super.disable();
    }
}
class $f2c1a77a86e27d7a$export$5986bef2c14dd5ce extends $f2c1a77a86e27d7a$var$BulkStopContainersUsecase {
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE_CONTAINER;
    }
}
class $f2c1a77a86e27d7a$export$d0ae5960553fc4c2 extends $f2c1a77a86e27d7a$var$BulkStopContainersUsecase {
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CORE_CONTAINER;
    }
}
class $f2c1a77a86e27d7a$var$BulkRestartontainersUsecase extends (0, $0e262b77192f27d5$export$78fa625c015da377) {
    selectContainers(ids) {
        this.select(ids);
    }
    restart() {
        return super.reenable();
    }
}
class $f2c1a77a86e27d7a$export$929d4e4c5b8aba68 extends $f2c1a77a86e27d7a$var$BulkRestartontainersUsecase {
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE_CONTAINER;
    }
}
class $f2c1a77a86e27d7a$export$8bb9a9960692ab55 extends $f2c1a77a86e27d7a$var$BulkRestartontainersUsecase {
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CORE_CONTAINER;
    }
}





class $8d2339ea31d240b8$export$4f02a29151aff02e extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    invoke(value) {
        this.setState({
            lastCopyId: this.browserService.copy(value)
        });
    }
}



class $bbb61d36f4d51eb7$export$3604546ce70513ee extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    createURL(doc) {
        return this.configurationService.getDocumentationURL(doc);
    }
}





class $7620686f4015eec2$export$f86de92dc4c171dd extends (0, $091d28ec500ee607$export$e35eeca9ac01af15) {
    constructor(...args){
        super(...args), this.pageName = 'endpoints', this.pageAddress = 'endpointsPage', this.initialSortColumn = 'service';
    }
}
class $7620686f4015eec2$export$f8b467ddc4f01b08 extends (0, $7b9515791776b163$export$8dbd5db7aa48881c) {
    constructor(...args){
        super(...args), this.singularName = 'endpoint', this.singleAddress = 'endpoint';
    }
}




class $194a812251685b25$export$4f5930e2feb65d89 extends (0, $0e262b77192f27d5$export$f708ad0ed4e537ba) {
    selectEndpoints(ids) {
        this.select(ids);
    }
    delete() {
        return super.delete();
    }
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).ENDPOINT;
    }
}
class $194a812251685b25$export$b3c8b51f94117509 extends (0, $0e262b77192f27d5$export$1931d3912bb14259) {
    selectEndpoints(ids) {
        this.select(ids);
    }
    enable() {
        return super.enable();
    }
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).ENDPOINT;
    }
}
class $194a812251685b25$export$14e9645d73dfa711 extends (0, $0e262b77192f27d5$export$24c785bfdde217e8) {
    selectEndpoints(ids) {
        this.select(ids);
    }
    disable() {
        return super.disable();
    }
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).ENDPOINT;
    }
}







class $592bbc806a799909$export$aa6a1792a9d987d extends (0, $c3e1b746ad236797$export$8d524fb6540252df) {
    static is(e) {
        return e instanceof $592bbc806a799909$export$aa6a1792a9d987d;
    }
    constructor(path, env, value){
        super((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).CONFIGURATION_ERROR, 'Could not override configuration because it was found to be invalid', {
            path: path,
            env: env,
            value: value
        });
    }
}
class $592bbc806a799909$export$fe00d82501efb7f extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    handleConfigurationErrors(errors) {
        if (!(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(errors)) return;
        this.logger.warn('There are misconfigured Admin UI customizations that should be looked into');
        for (const error of errors)if ($592bbc806a799909$export$aa6a1792a9d987d.is(error)) /** User error */ this.logger.warn(`${error.extras.env} can NOT be set to '${error.extras.value}'`);
        else /** Unexpected configuration error, means a development bug */ this.logger.error(error);
    }
    activate() {
        if (this.browserService.isInspecting()) this.logger.info('Application is in inspection mode', this);
    }
}







const $c2ca13af6b1b004f$var$canReadSystemInfo = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).MINIMUM);
class $c2ca13af6b1b004f$export$34688633b2d30fd0 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    mapLicenseChangeError(e) {
        (0, $14eddac5f20c576c$export$a7a9523472993e97)((0, $c3e1b746ad236797$export$8d524fb6540252df).isOfTypes(e, (0, $c3e1b746ad236797$export$13cd8ea82c82bf53).CONFIGURATION_ERROR), /**
             * If error is not of configuration type
             * it means some other issue occurred
             * while changing the license
             * so just pass it on
             */ e);
        /**
         * We then check if the license was invalid before
         */ const license = (0, $ee9c60e7a5b417f7$export$f118100f1b195a18)(this.getState());
        if (!(0, $c3e1b746ad236797$export$8d524fb6540252df).is(license) && license?.valid) /**
             * The license was valid and it is now invalid
             * So we let the update (from `reloadLicense`) follow through
             */ return;
        /**
         * The license was invalid before this update
         * So we through another error stating so
         */ throw new (0, $c3e1b746ad236797$export$8d524fb6540252df)(e, this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_STILL_INVALID));
    }
    async reloadLicense() {
        const state = this.getState();
        if (!(0, $1c05f13022cf1480$export$c75d7b8f071929fe)(state)) return;
        if (!$c2ca13af6b1b004f$var$canReadSystemInfo(state)) {
            this.setState({
                license: new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION)
            });
            return;
        }
        try {
            this.setState({
                license: await this.systemService.fetchLicense()
            });
        } catch (e) {
            this.setState({
                license: e
            });
        }
    }
    async changeLicense(action) {
        try {
            await action();
        } catch (e) {
            this.mapLicenseChangeError(e);
        }
        await this.reloadLicense();
    }
}


class $ef665ec08d8118d5$export$1fd058a6ebf61da4 extends (0, $c2ca13af6b1b004f$export$34688633b2d30fd0) {
    loadLicense() {
        this.reloadLicense();
        return ()=>this.setState({
                license: null
            });
    }
}



class $132603bfd94225ab$export$c5c63131585c5dbf extends (0, $c2ca13af6b1b004f$export$34688633b2d30fd0) {
    async refresh() {
        await this.changeLicense(()=>this.systemService.refreshLicense());
    }
}




class $f21a2f90dab85fd1$export$7676a1a67dcc47ac extends (0, $c2ca13af6b1b004f$export$34688633b2d30fd0) {
    async upload(fileContent) {
        await this.changeLicense(()=>this.systemService.uploadLicenseFile(fileContent));
    }
    getSupportedLicenseFileExtensions() {
        return this.configurationService.getSupportedFileExtensions((0, $de76aa5bd91d062d$export$431c833e82f9ca90).LICENSE);
    }
}




const $f2b5b70bb2712bac$var$canManageLicense = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_LICENSE_MANAGE);
class $f2b5b70bb2712bac$export$c03faae1a902cd5 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    async fetchPortalConnectivity() {
        if (!$f2b5b70bb2712bac$var$canManageLicense(this.getState())) /**
             * No need to reach the portal
             * As the user would not care about the results anyhow
             */ return {
            url: null,
            reachable: false
        };
        try {
            const { endpoints: endpoints } = await this.systemService.fetchConnectivity();
            return endpoints.cybusPortal;
        } catch  {
            return {
                url: null,
                reachable: false
            };
        }
    }
}





class $205a20edbb49a521$export$b20d894ccd4f1010 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    setInfo(update = {}) {
        let info = (0, $d5b2f7653d87e9de$export$236b6ad6452b27f9)(this.getState());
        if (!info) info = {
            version: this.systemService.getUIVersion(),
            servicesCount: null,
            connectivity: null
        };
        this.setState({
            info: {
                ...info,
                ...update
            }
        });
    }
    refreshConnectivity() {
        this.systemService.fetchConnectivity().then((connectivity)=>this.setInfo({
                connectivity: connectivity
            })).catch((connectivity)=>this.setInfo({
                connectivity: connectivity
            }));
    }
    /**
     * Loads the connectivity & services count information
     *
     * 2 Different async requests are made internally independent of each other
     */ loadInformation() {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        /**
         * Just initializes the info
         */ this.setInfo();
        const refreshConnectivity = ()=>this.refreshConnectivity();
        /**
         * Fetches initial data
         * and
         * Sets up a subscription of the service count
         */ refreshConnectivity();
        this.subscriptionsService.subscribeToCount('services', (servicesCount)=>this.setInfo({
                servicesCount: servicesCount
            })).then((unsub)=>droppable.onDrop(unsub)).catch((servicesCount)=>this.setInfo({
                servicesCount: servicesCount
            }));
        const refreshRate = this.configurationService.getInfoPageRefreshRate();
        /** Updates data */ droppable.onDrop((0, $ad06b61c4606f6df$export$5fe74ec28e3a5524)(refreshConnectivity, refreshRate));
        return ()=>droppable.drop();
    }
}





class $a6de2e88b5226ac8$export$dd06ffc7864da99f extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    updateLoading(increase) {
        let { loadingCount: loadingCount } = this.getState();
        if (increase) loadingCount++;
        else loadingCount--;
        this.setState({
            loadingCount: Math.max(loadingCount, 0)
        });
    }
    async withLoading(asyncAction) {
        try {
            this.updateLoading(true);
            await asyncAction;
        } finally{
            this.updateLoading(false);
        }
    }
}




const $e2de68e8ae0b3ea0$var$canReadLogs = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ);
class $e2de68e8ae0b3ea0$export$64ef4a449b44fc83 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    areLogsAvailable(type, id) {
        if (!$e2de68e8ae0b3ea0$var$canReadLogs(this.getState())) return Promise.resolve(false);
        return this.connectwareLogsService.doesCollectLogs(type, id);
    }
    fetchLogs(type, options) {
        return this.connectwareLogsService.fetchLogs(type, options);
    }
    async downloadRawlogs(type, resource) {
        this.fileService.download(await this.connectwareLogsService.fetchAllRawLogs(type, {
            resource: resource,
            lines: 'all'
        }));
    }
    downloadCSV(logs, fileName, showServiceId) {
        const head = [
            this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).LEVEL),
            this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).TIME),
            ...showServiceId ? [
                this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE, {
                    count: 1
                })
            ] : [],
            this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).MESSAGE)
        ];
        const file = this.fileService.generateCSV(fileName, head, logs.map((log)=>showServiceId ? [
                log.level,
                log.timestamp,
                log.serviceId,
                log.message
            ] : [
                log.level,
                log.timestamp,
                log.message
            ]));
        this.fileService.download(file);
    }
}





class $8b415a0d347ab5d0$export$1083aa9fdf5829f5 extends (0, $091d28ec500ee607$export$e35eeca9ac01af15) {
    constructor(...args){
        super(...args), this.pageName = 'mappings', this.pageAddress = 'mappingsPage', this.initialSortColumn = 'service';
    }
}
class $8b415a0d347ab5d0$export$92f6df4d2f32ffce extends (0, $7b9515791776b163$export$8dbd5db7aa48881c) {
    constructor(...args){
        super(...args), this.singularName = 'mapping', this.singleAddress = 'mapping';
    }
}




class $c0e2f934224b5999$export$2913a7396a5786f1 extends (0, $0e262b77192f27d5$export$f708ad0ed4e537ba) {
    selectMappings(ids) {
        this.select(ids);
    }
    delete() {
        return super.delete();
    }
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).MAPPING;
    }
}
class $c0e2f934224b5999$export$c851b6c1d1d47051 extends (0, $0e262b77192f27d5$export$1931d3912bb14259) {
    selectMappings(ids) {
        this.select(ids);
    }
    enable() {
        return super.enable();
    }
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).MAPPING;
    }
}
class $c0e2f934224b5999$export$52b82e0d67fb33bc extends (0, $0e262b77192f27d5$export$24c785bfdde217e8) {
    selectMappings(ids) {
        this.select(ids);
    }
    disable() {
        return super.disable();
    }
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).MAPPING;
    }
}






class $f3fe50e4d539b082$export$c8208d39186c007a {
    constructor(response){
        /** Auxiliary flag to detect changes during remapping */ this.hasChanges = false;
        this.errorsByTopic = (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(response).reduce((r, [responseType, topics])=>responseType === 'subscribed' ? r : topics.reduce((r, topic)=>({
                    ...r,
                    [topic]: responseType
                }), r), {});
    }
    remapSubscriptionError(topics, original) {
        const newErrors = topics.reduce((errors, topic)=>{
            const error = this.errorsByTopic[topic];
            if (error) errors.add(error);
            return errors;
        }, new Set());
        this.hasChanges = this.hasChanges || !(0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(Array.from(newErrors), Array.from(original), {
            sort: false
        });
        return newErrors;
    }
    /**
     * @returns null if the mapping has had no changes
     */ remapWithErrors(mapping) {
        /** Reset tracking */ this.hasChanges = false;
        const copy = {
            ...mapping,
            entries: mapping.entries.map((entry)=>({
                    ...entry,
                    subscribe: entry.subscribe.map((subscribe)=>({
                            ...subscribe,
                            subscriptionErrors: this.remapSubscriptionError(subscribe.topics, subscribe.subscriptionErrors)
                        })),
                    publish: {
                        ...entry.publish,
                        subscriptionErrors: this.remapSubscriptionError(entry.publish.topics, entry.publish.subscriptionErrors)
                    }
                }))
        };
        return this.hasChanges ? copy : null;
    }
}


class $748ce78486da5d49$export$bf84beddf0495a4 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    setMappingEntries(mappingEntries) {
        this.setState({
            mappingEntries: mappingEntries
        });
    }
    listenToEntriesStateChanges(subscription, idTopicsMap) {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        /**
         * Even as the entries get updated
         * This function is responsible to keep everything up to date
         * In one move it maps all relevant topics and the entries responsible for them
         * So the state can be reliably updated later on
         */ const refreshEntitiesDerivedValues = ()=>{
            const [allTopics, idToTopics] = (0, $220733605f0fc2b5$export$ecd8059f15c93289)(this.getState());
            const promise = subscription.subscribe(allTopics);
            promise.then((response)=>{
                const mapping = (0, $220733605f0fc2b5$export$3921ef1972aa52e0)(this.getState());
                if ((0, $238a83731a48faba$export$8f7496a65239c6d8)(response) || (0, $c3e1b746ad236797$export$8d524fb6540252df).is(mapping) || !mapping) /**
                     * Either there are no errors, or the mapping entries can't really be edited
                     */ return;
                const mapWithErrors = new (0, $f3fe50e4d539b082$export$c8208d39186c007a)(response).remapWithErrors(mapping);
                if (mapWithErrors) this.setState({
                    mapping: mapWithErrors
                });
            });
            idTopicsMap.change(idToTopics);
        };
        /** Update subscription with initial value */ refreshEntitiesDerivedValues();
        /** Detect further changes to perform further updates */ droppable.onDrop(this.subscribeToState((previous, current)=>(0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)((0, $220733605f0fc2b5$export$7ca19239db6a3ae7)(previous), (0, $220733605f0fc2b5$export$7ca19239db6a3ae7)(current)), refreshEntitiesDerivedValues));
        return ()=>droppable.drop();
    }
    listenToTopicMessages(subscription, entriesMap) {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        /** Wait for messages and errors to arrive */ droppable.onDrop(subscription.onBatch((batch)=>{
            const mappingEntries = (0, $220733605f0fc2b5$export$2ff8b4bfb3d2a5df)(this.getState());
            if (mappingEntries === null || (0, $c3e1b746ad236797$export$8d524fb6540252df).is(mappingEntries)) {
                /** Should not be updated as something else is wrong */ this.setMappingEntries(new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Could not update mapping entries as it is in unexpected state'));
                return;
            }
            const newEntries = {};
            /**
                 * Iterate every entry
                 * And attempt to find, from the published messages, which entry each one is sourced from
                 */ (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(entriesMap.value).forEach(([id, topics])=>batch.forEach((m)=>{
                    if (this.topicsService.createTopic(m.topic).isSourcedFrom(topics)) newEntries[id] = m;
                }));
            if (!(0, $2ae70427bab197d4$export$dd1bc94b04021eeb)(newEntries)) /** Merge values */ this.setMappingEntries({
                ...mappingEntries,
                ...newEntries
            });
        }));
        droppable.onDrop(/** Error implies that the client will be closed */ subscription.onError((error)=>this.setMappingEntries(error)));
        return ()=>droppable.drop();
    }
    /**
     * This function subscribes to the topics on the mapping.entries on the application state
     * And writes to the mappingEntries property whatever is received from those subscribed topics
     */ subscribe() {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        /** Initialize state */ this.setMappingEntries({});
        /** Reset the state once the application is done subscribing */ droppable.onDrop(()=>this.setMappingEntries(null));
        const idTopicsMap = new (0, $9fc21cc786388d5a$export$668230531b0abb74)({});
        const subscription = this.topicsService.createSubscription();
        /** Drop subscription once everything is gone */ droppable.onDrop(()=>subscription.end());
        /** If the mapping entries change, these will keep the auxiliar and subscription variables up to date */ droppable.onDrop(this.listenToEntriesStateChanges(subscription, idTopicsMap));
        /** Listen to the inbound topic messages */ droppable.onDrop(this.listenToTopicMessages(subscription, idTopicsMap));
        return ()=>droppable.drop();
    }
}






class $f42c02287403bd2f$export$f0607a650dd17548 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    open() {
        try {
            this.browserService.open(this.configurationService.getWorkbenchURL(), null);
        } catch (e) {
            this.logger.error(e);
        }
    }
}





class $33fc77a964f7feac$export$770033b3343598b1 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    invoke() {
        this.browserService.reload();
    }
}





class $971242282ea54998$export$35c2b5cb04b22b5a extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    setSandbox(ruleEngine) {
        this.setState({
            ruleEngineSandbox: {
                ...(0, $5491cfd462130f7a$export$28db646e631a3c7e)(this.getState()),
                ...ruleEngine
            }
        });
    }
}


class $cb52a4d79dfa72c0$export$d0e996463cd681f7 extends (0, $971242282ea54998$export$35c2b5cb04b22b5a) {
    selectType(type) {
        const { input: input } = (0, $5491cfd462130f7a$export$28db646e631a3c7e)(this.getState());
        this.setSandbox({
            type: type,
            endpointsSearch: '',
            endpoints: null,
            /** Clear the endpoint selection */ selectedEndpoints: type === (0, $5491cfd462130f7a$export$605f39a06a79387c).ENDPOINT ? [] : null,
            /** De-select all topics */ selectedTopics: null,
            /**
             * Reset input
             * if the new type is json, attempt to migrate from previous value, or set empty object
             * otherwise, just nullify it as unloaded
             */ input: type === (0, $5491cfd462130f7a$export$605f39a06a79387c).JSON ? {
                loaded: true,
                topic: null,
                value: (0, $c3e1b746ad236797$export$8d524fb6540252df).is(input.value) || input.value === null ? {} : input.value
            } : {
                loaded: false,
                topic: null,
                value: null
            }
        });
    }
    setJson(json) {
        this.setSandbox({
            type: (0, $5491cfd462130f7a$export$605f39a06a79387c).JSON,
            selectedEndpoints: null,
            endpointsSearch: '',
            endpoints: null,
            selectedTopics: null,
            input: {
                loaded: true,
                topic: null,
                value: json
            }
        });
    }
    setEndpointsSearch(endpointsSearch) {
        this.setSandbox({
            endpointsSearch: endpointsSearch,
            endpoints: null
        });
    }
    selectEndpoints(selectedEndpoints) {
        const { input: input } = (0, $5491cfd462130f7a$export$28db646e631a3c7e)(this.getState());
        const selectedTopics = new Set(selectedEndpoints.flatMap((e)=>e.topics));
        const isRelevant = input.loaded && input.topic !== null && selectedTopics.has(input.topic);
        this.setSandbox({
            selectedEndpoints: selectedEndpoints,
            selectedTopics: Array.from(selectedTopics),
            input: isRelevant ? input : {
                loaded: false,
                topic: null,
                value: null
            }
        });
    }
    selectTopics(selectedTopics) {
        this.setSandbox({
            selectedTopics: selectedTopics
        });
    }
    setTransformation(transformation) {
        this.setSandbox({
            transformation: transformation
        });
    }
}





class $305d42c991a29d63$export$642511a9467880eb extends (0, $971242282ea54998$export$35c2b5cb04b22b5a) {
    static mapInput(message) {
        if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(message)) /** Error, just pass it on */ return {
            topic: null,
            value: message
        };
        const { possibleTypes: possibleTypes, topic: topic, payload: payload } = message;
        return {
            topic: topic,
            value: possibleTypes.includes((0, $0b8fac93f85dcb05$export$a9b603917c4d9863).OBJECT) ? JSON.parse(payload.toString()) : payload.toString()
        };
    }
    updateInput(message) {
        this.setSandbox({
            input: {
                loaded: true,
                ...$305d42c991a29d63$export$642511a9467880eb.mapInput(message)
            }
        });
    }
    propagateStateChanges(subscription) {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        const updateSubscription = ()=>{
            const { selectedTopics: selectedTopics } = (0, $5491cfd462130f7a$export$28db646e631a3c7e)(this.getState());
            if (selectedTopics) subscription.subscribe(selectedTopics).then((response)=>{
                if ((0, $238a83731a48faba$export$8f7496a65239c6d8)(response)) return;
                const { selectedEndpoints: selectedEndpoints } = (0, $5491cfd462130f7a$export$28db646e631a3c7e)(this.getState());
                /** Topic inputed/endpoints selected by the user causes issues within the client */ this.updateInput(new (0, $c3e1b746ad236797$export$8d524fb6540252df)(selectedEndpoints ? (0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION : (0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST, this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).SANDBOX_SUBSCRIPTION_ISSUE, {
                    endpoints: selectedEndpoints?.length ?? null
                }), response));
            });
        };
        updateSubscription();
        /** Listen to state subscription changes */ droppable.onDrop(this.subscribeToState((previous, current)=>(0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)((0, $5491cfd462130f7a$export$28db646e631a3c7e)(previous).selectedTopics || [], (0, $5491cfd462130f7a$export$28db646e631a3c7e)(current).selectedTopics || []), updateSubscription));
        return ()=>droppable.drop();
    }
    subscribe() {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        const subscription = this.topicsService.createSubscription();
        /** Once dropped subscription goes away */ droppable.onDrop(()=>subscription.end());
        /** Listen to state changes */ droppable.onDrop(this.propagateStateChanges(subscription));
        /** Handle messages */ droppable.onDrop(subscription.onLastMessage((message)=>this.updateInput(message)));
        /** Handle errors */ droppable.onDrop(subscription.onError((error)=>this.updateInput(error)));
        return ()=>droppable.drop();
    }
}




class $86a88cf7ed95e874$export$466279f3cec52b3d extends (0, $971242282ea54998$export$35c2b5cb04b22b5a) {
    setOutputValue(id, value) {
        const { output: output } = (0, $5491cfd462130f7a$export$28db646e631a3c7e)(this.getState());
        if (output.id !== id) return;
        this.setSandbox({
            output: {
                loaded: true,
                id: id,
                value: value
            }
        });
    }
    invoke() {
        const { input: input, transformation: transformation, output: { id: id } } = (0, $5491cfd462130f7a$export$28db646e631a3c7e)(this.getState());
        if (!input.loaded || !transformation) {
            this.setSandbox({
                output: {
                    loaded: false,
                    id: id,
                    value: null
                }
            });
            return;
        }
        const newId = id + 1;
        this.setSandbox({
            output: {
                loaded: false,
                id: newId,
                value: null
            }
        });
        this.ruleEngineService.transform(input.value, transformation).then((payload)=>this.setOutputValue(newId, payload)).catch((e)=>this.setOutputValue(newId, e));
    }
}






const $f36042338fcbfc5a$var$selectType = (0, $5491cfd462130f7a$export$26200e6f60f4189a)('type');
const $f36042338fcbfc5a$var$selectEndpointsSearch = (0, $5491cfd462130f7a$export$26200e6f60f4189a)('endpointsSearch');
const $f36042338fcbfc5a$var$canReadTopicsMetadata = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).RULE_ENGINE_RESOURCES);
class $f36042338fcbfc5a$export$f31d6abbcd8ccb6d extends (0, $971242282ea54998$export$35c2b5cb04b22b5a) {
    async updateEndpoints(droppable) {
        const search = $f36042338fcbfc5a$var$selectEndpointsSearch(this.getState());
        const endpoints = await this.ruleEngineService.fetchEndpoints(search).catch((e)=>e);
        if (droppable.isDropped || $f36042338fcbfc5a$var$selectEndpointsSearch(this.getState()) !== search) return;
        this.setSandbox({
            endpoints: endpoints
        });
    }
    invoke() {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        if ($f36042338fcbfc5a$var$canReadTopicsMetadata(this.getState())) {
            const throttler = new (0, $2accc4d3fee5c026$export$af12a1bf506c8522)(this.getThrottle());
            droppable.onDrop(this.subscribeToState(/**
                     * @returns false (i.e. state is considered changed) if
                     *  - User went to the endpoint mode
                     *  - User changed the search while in endpoint mode
                     */ (previous, current)=>!($f36042338fcbfc5a$var$selectType(previous) !== (0, $5491cfd462130f7a$export$605f39a06a79387c).ENDPOINT && $f36042338fcbfc5a$var$selectType(current) === (0, $5491cfd462130f7a$export$605f39a06a79387c).ENDPOINT || $f36042338fcbfc5a$var$selectType(current) === (0, $5491cfd462130f7a$export$605f39a06a79387c).ENDPOINT && $f36042338fcbfc5a$var$selectEndpointsSearch(previous) !== $f36042338fcbfc5a$var$selectEndpointsSearch(current)), ()=>droppable.onDrop(throttler.run(()=>void this.updateEndpoints(droppable)))));
        }
        /** Reset to init state */ droppable.onDrop(()=>this.setSandbox((0, $5491cfd462130f7a$export$28db646e631a3c7e)((0, $95a9c43d1c8832e3$export$d4c72bab9d6cc13a))));
        return ()=>droppable.drop();
    }
    constructor(...args){
        super(...args), this.getThrottle = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.configurationService.getInteractionThrottle());
    }
}





class $e682fcc2d82bf100$export$950299f2a639da2a extends (0, $091d28ec500ee607$export$e35eeca9ac01af15) {
    constructor(...args){
        super(...args), this.pageName = 'servers', this.pageAddress = 'serversPage', this.initialSortColumn = 'service';
    }
}
class $e682fcc2d82bf100$export$7a8666f771e4c5e2 extends (0, $7b9515791776b163$export$8dbd5db7aa48881c) {
    constructor(...args){
        super(...args), this.singularName = 'server', this.singleAddress = 'server';
    }
}




class $007471c0df8f0447$export$7cf59b3f0a998671 extends (0, $0e262b77192f27d5$export$f708ad0ed4e537ba) {
    selectServers(ids) {
        this.select(ids);
    }
    delete() {
        return super.delete();
    }
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVER;
    }
}
class $007471c0df8f0447$export$a3e78906f2e4947d extends (0, $0e262b77192f27d5$export$1931d3912bb14259) {
    selectServers(ids) {
        this.select(ids);
    }
    enable() {
        return super.enable();
    }
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVER;
    }
}
class $007471c0df8f0447$export$66587697d3b6889e extends (0, $0e262b77192f27d5$export$24c785bfdde217e8) {
    selectServers(ids) {
        this.select(ids);
    }
    disable() {
        return super.disable();
    }
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVER;
    }
}





class $826cebeef3327334$export$ae3399c13a1383bd extends (0, $091d28ec500ee607$export$e35eeca9ac01af15) {
    constructor(...args){
        super(...args), this.pageName = 'nodes', this.pageAddress = 'nodesPage', this.initialSortColumn = 'service';
    }
}





class $e679292292d11002$export$652d47937221c0d3 extends (0, $091d28ec500ee607$export$e35eeca9ac01af15) {
    constructor(...args){
        super(...args), this.pageName = 'services', this.pageAddress = 'servicesPage', this.initialSortColumn = 'id';
    }
}
class $e679292292d11002$export$9e78756881ac13d3 extends (0, $7b9515791776b163$export$8dbd5db7aa48881c) {
    constructor(...args){
        super(...args), this.singularName = 'service', this.singleAddress = 'service';
    }
}






class $9bcefb50f61c7c5d$export$d45b66011487aa66 extends (0, $091d28ec500ee607$export$e35eeca9ac01af15) {
    constructor(...args){
        super(...args), this.pageName = 'serviceResources', this.pageAddress = 'servicesDataPage', this.initialSortColumn = 'id';
    }
}
class $9bcefb50f61c7c5d$export$1965641b4bc55f16 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    static generateInitialMessages(topics, response) {
        const errorEntries = (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)({
            invalid: new Set(response.invalid),
            noPermissions: new Set(response.noPermissions),
            unknown: new Set(response.unknown),
            shared: new Set(response.shared)
        });
        return topics.reduce((r, topic)=>{
            const errorEntry = errorEntries.find(([, topics])=>topics.has(topic));
            if (!errorEntry) return r;
            const [error] = errorEntry;
            return {
                ...r,
                [topic]: new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, 'Had issues subscribing to the topic', {
                    topic: topic,
                    error: error
                })
            };
        }, {});
    }
    generateBatchMessages(batch) {
        const messages = {};
        for (const message of batch)for (const topic of message.sources)messages[topic] = {
            payload: message.payload,
            possibleTypes: message.possibleTypes,
            timestamp: message.timestamp
        };
        return messages;
    }
    setServiceTopicsMessages(update, clear) {
        const previousMessages = clear ? {} : (0, $d8a939fc8bdc4e6b$export$c73643a1640d8b9e)(this.getState());
        this.setState({
            serviceTopicsMessages: {
                ...previousMessages,
                ...update
            }
        });
    }
    invoke() {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        const subscription = this.topicsService.createSubscription();
        /** Listen to changes to the page and if updates occur, then re-subscribe to new topics */ droppable.onDrop(this.subscribeToState((previous, current)=>(0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)((0, $d8a939fc8bdc4e6b$export$3a98fe926d42f6a0)(previous), (0, $d8a939fc8bdc4e6b$export$3a98fe926d42f6a0)(current), {
                sort: false
            }), ()=>{
            const topics = Array.from(new Set((0, $d8a939fc8bdc4e6b$export$3a98fe926d42f6a0)(this.getState())));
            subscription.subscribe(topics).then((response)=>droppable.ifNotDropped(()=>this.setServiceTopicsMessages($9bcefb50f61c7c5d$export$1965641b4bc55f16.generateInitialMessages(topics, response), true)));
        }));
        /** Listen to the topic batches and record the messages into the state */ droppable.onDrop(subscription.onBatch((batch)=>droppable.ifNotDropped(()=>this.setServiceTopicsMessages(this.generateBatchMessages(batch), false))));
        /** When dropping, kill the subscription */ droppable.onDrop(()=>subscription.end());
        /** Set state back to initial */ droppable.onDrop(()=>this.setServiceTopicsMessages((0, $d8a939fc8bdc4e6b$export$c73643a1640d8b9e)((0, $95a9c43d1c8832e3$export$d4c72bab9d6cc13a)), true));
        return ()=>droppable.drop();
    }
}








class $5f336316eb9898c3$export$21106d08c9f5a444 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    constructor(...args){
        super(...args), this.getSupportedServiceCommissioningFileExtensions = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.configurationService.getSupportedFileExtensions((0, $de76aa5bd91d062d$export$431c833e82f9ca90).SERVICE_COMMISSIONING));
    }
}


const $a9691f5263be09de$var$initial = {
    file: null,
    schema: null,
    id: null,
    parameters: null,
    requesting: false,
    initialFormValue: null
};
const $a9691f5263be09de$var$catchPromise = (e)=>e;
/**
 * Copies the entries of `parameters` whose value `keep` accepts, dropping the rest, in one linear
 * pass — as opposed to a `reduce` that spreads into a fresh object on every iteration
 */ const $a9691f5263be09de$var$filterParameterEntries = (parameters, keep)=>Object.fromEntries((0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(parameters).filter((entry)=>keep(entry[1])));
const $a9691f5263be09de$var$isDefinedParameterValue = (value)=>value !== undefined;
const $a9691f5263be09de$var$isNotNullParameterValue = (value)=>value !== null;
/**
 * Drops keys whose value is undefined — @rjsf widgets emit undefined when a
 * field is cleared, and an absent secret parameter means "keep the stored value"
 */ const $a9691f5263be09de$var$dropUndefinedParameters = (parameters)=>$a9691f5263be09de$var$filterParameterEntries(parameters, $a9691f5263be09de$var$isDefinedParameterValue);
class $a9691f5263be09de$var$BaseUsecase extends (0, $5f336316eb9898c3$export$21106d08c9f5a444) {
    getNullableServiceForm() {
        return (0, $d8a939fc8bdc4e6b$export$dc85b0c2a4f8ef64)(this.getState());
    }
    getRequest() {
        const form = this.getNullableServiceForm();
        if (form === null || form.requesting === true || !form.id || !form.parameters || !(0, $e8356e494d58a419$export$4b8c8489f202ce0c)(form.file) || !(0, $e8356e494d58a419$export$3523073818ab01af)(form.schema) || form.initialFormValue && form.id === form.initialFormValue.id && form.file === form.initialFormValue.file && (0, $c091d3dc2d3f37db$export$e5007f342b68b3d)(form.parameters, form.initialFormValue.parameters) || !this.connectwareServicesService.validate({
            schema: form.schema,
            id: form.id,
            parameters: form.parameters
        }, this.getServiceManagementMode())) return null;
        return {
            commissioningFile: form.file,
            id: form.id,
            parameters: form.parameters
        };
    }
    getServiceFormFile() {
        return this.getServiceForm().file;
    }
    isCreating() {
        return this.getServiceManagementMode() === (0, $703a0e0813d6ac75$export$9eafce13aba72038).CREATION;
    }
    initializeServiceForm(serviceForm) {
        this.setState({
            serviceForm: serviceForm
        });
    }
    getServiceForm() {
        const form = this.getNullableServiceForm();
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(form, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Could not update service creation form'));
        return form;
    }
    setServiceForm(form) {
        this.initializeServiceForm({
            ...this.getServiceForm(),
            ...form
        });
    }
    close() {
        this.initializeServiceForm(null);
    }
    createParameters(parameters, initialParameters) {
        const out = parameters || initialParameters;
        return out && $a9691f5263be09de$var$filterParameterEntries(out, $a9691f5263be09de$var$isNotNullParameterValue);
    }
    /**
     * Merges the initial parameters with the parameters of the service
     *
     * @param current the parameters of the service
     * @param initial the initial parameters of the service
     *
     * @returns valid parameters of the service, correct for any changes between a version of a service
     */ mergeParameters(current, initial) {
        return (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(initial).reduce((outParameters, [parameterKey, initialValue])=>{
            const currentValue = current[parameterKey];
            if (initialValue === null) {
                if (currentValue === undefined) /** There is no value there, so just send it as is */ return outParameters;
                /** The value is set already, so use it */ return {
                    ...outParameters,
                    [parameterKey]: currentValue
                };
            }
            if (currentValue !== undefined && typeof currentValue === typeof initialValue) /** The value is set already and the value is of the same type, so use it */ return {
                ...outParameters,
                [parameterKey]: currentValue
            };
            /** Use the initial value */ return {
                ...outParameters,
                [parameterKey]: initialValue
            };
        }, {});
    }
    /**
     * Update the commissioning file for the service that will be created
     * Resets current service schema/parameters in some scenarios
     */ async updateCommissioningFile(newFile) {
        const oldFile = this.getServiceFormFile();
        if (oldFile === newFile) /** If the new file is the same, then do nothing */ return;
        if (!(0, $e8356e494d58a419$export$4b8c8489f202ce0c)(newFile)) {
            this.setServiceForm({
                file: newFile,
                schema: null,
                id: null,
                parameters: null
            });
            return;
        }
        const { parameters: parameters } = this.getServiceForm();
        /** Clear derived information and start loading */ this.setServiceForm({
            file: newFile,
            schema: null,
            parameters: null,
            requesting: true
        });
        /** Commissioning file was read, let's try to parse it */ const schemaResolution = await this.connectwareServicesService.parseCommissioningFile(newFile, this.getServiceManagementMode()).then(([schema, id, parameters])=>({
                schema: schema,
                id: this.isCreating() ? id : this.getServiceForm().id,
                parameters: parameters
            })).catch((e)=>({
                schema: e,
                id: null,
                parameters: null
            }));
        if (this.getServiceFormFile() !== newFile) /** File has changed since parsing started, so stop the presses and let the last process do its thing */ return;
        /** Set state when promise yields */ let newParameters = schemaResolution.parameters === null || parameters === null ? this.createParameters(parameters, schemaResolution.parameters) : this.mergeParameters(parameters, schemaResolution.parameters);
        if (newParameters && (0, $e8356e494d58a419$export$3523073818ab01af)(schemaResolution.schema)) /**
             * Secret (write-only) parameters never carry a value in the form — on update the API
             * omits them (see startUpdate), and on creation a schema `default` is not a value the
             * user actually typed, so it must not be echoed back into the write-only widget either
             */ newParameters = (0, $2ae70427bab197d4$export$12b617052eb9d30e)(newParameters, ...(0, $e8356e494d58a419$export$67ede92ee8549a68)(schemaResolution.schema));
        this.setServiceForm({
            ...schemaResolution,
            file: newFile,
            parameters: newParameters,
            id: this.isCreating() ? schemaResolution.id : this.getServiceForm().id,
            requesting: false
        });
    }
    updateServiceParameters(id, parameters) {
        const { schema: schema, id: previousId } = this.getServiceForm();
        (0, $14eddac5f20c576c$export$a7a9523472993e97)((0, $e8356e494d58a419$export$3523073818ab01af)(schema), new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Could not update service parameters'));
        this.setServiceForm({
            id: this.isCreating() ? id : previousId,
            parameters: parameters && $a9691f5263be09de$var$dropUndefinedParameters(parameters)
        });
    }
    cancel() {
        this.close();
    }
    async confirm() {
        const args = this.getRequest();
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(args, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Cannot create or update the service'));
        const { id: id } = args;
        this.setServiceForm({
            requesting: true
        });
        return this.connectwareServicesService.manage(args, this.getServiceManagementMode()).then(()=>{
            this.close();
            return id;
        })/** Record the error */ .catch((requesting)=>{
            this.setServiceForm({
                requesting: requesting
            });
            return null;
        });
    }
    isConfirmationRequestValid() {
        return Boolean(this.getRequest());
    }
}
class $a9691f5263be09de$export$476bdbc176e45bb7 extends $a9691f5263be09de$var$BaseUsecase {
    getServiceManagementMode() {
        return (0, $703a0e0813d6ac75$export$9eafce13aba72038).CREATION;
    }
    startCreation() {
        this.initializeServiceForm({
            ...$a9691f5263be09de$var$initial,
            creating: true
        });
    }
}
class $a9691f5263be09de$export$930caa99762afdf7 extends $a9691f5263be09de$var$BaseUsecase {
    /**
     * The update form is only ready after an async fetch, by which time a creation form may have been opened, and it must not be replaced
     */ initializeUpdateForm(form) {
        if ((0, $d8a939fc8bdc4e6b$export$dc85b0c2a4f8ef64)(this.getState())?.creating) return;
        this.initializeServiceForm({
            ...form,
            creating: false
        });
    }
    getServiceManagementMode() {
        return (0, $703a0e0813d6ac75$export$9eafce13aba72038).UPDATE;
    }
    async startUpdate({ id: id, parameters: parameters }) {
        const commissioningFile = await this.connectwareServicesService.fetchCommissioningFile(id);
        const parsedResponse = await this.connectwareServicesService.parseCommissioningFile(commissioningFile, (0, $703a0e0813d6ac75$export$9eafce13aba72038).UPDATE).catch($a9691f5263be09de$var$catchPromise);
        if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(parsedResponse)) {
            this.initializeUpdateForm({
                ...$a9691f5263be09de$var$initial,
                schema: parsedResponse
            });
            return;
        }
        const [schema, , initialParameters] = parsedResponse;
        /**
         * Secret (write-only) parameters never carry a value in the update form:
         * the API omits them, and a schema default must not silently overwrite the stored value
         */ const outParameters = (0, $2ae70427bab197d4$export$12b617052eb9d30e)(this.mergeParameters(parameters, initialParameters), ...(0, $e8356e494d58a419$export$67ede92ee8549a68)(schema));
        this.initializeUpdateForm({
            file: commissioningFile,
            schema: schema,
            id: id,
            parameters: outParameters,
            requesting: false,
            initialFormValue: {
                id: id,
                file: commissioningFile,
                parameters: outParameters
            }
        });
    }
}




class $fca0e20a867708b2$export$28177f047669ef54 extends (0, $0e262b77192f27d5$export$1931d3912bb14259) {
    selectServices(ids) {
        this.select(ids);
    }
    enable() {
        return super.enable();
    }
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE;
    }
}
class $fca0e20a867708b2$export$f287c93e6c7814b4 extends (0, $0e262b77192f27d5$export$f708ad0ed4e537ba) {
    selectServices(ids) {
        this.select(ids);
    }
    delete() {
        return super.delete();
    }
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE;
    }
}
class $fca0e20a867708b2$export$cd4b460e847871d0 extends (0, $0e262b77192f27d5$export$24c785bfdde217e8) {
    selectServices(ids) {
        this.select(ids);
    }
    disable() {
        return super.disable();
    }
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE;
    }
}





class $acde661cae8a73e6$export$d1aa369c4019c3fe extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    async invoke({ id: id }) {
        const fileContent = await this.connectwareServicesService.fetchCommissioningFile(id);
        const fileName = `${id}.${this.getExtension()}`;
        const type = this.configurationService.getServiceCommissioningFileDownloadMimeType();
        this.fileService.download(new File([
            fileContent
        ], fileName, {
            type: type
        }));
    }
    constructor(...args){
        super(...args), this.getExtension = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>(0, $9f70c141ac08ef9a$export$109d9d261d61ca16)(this.configurationService.getSupportedFileExtensions((0, $de76aa5bd91d062d$export$431c833e82f9ca90).SERVICE_COMMISSIONING)));
    }
}



class $538dd376b6e87339$export$c4a0d7f2e2f54e38 extends (0, $091d28ec500ee607$export$e35eeca9ac01af15) {
    constructor(...args){
        super(...args), this.pageName = 'servicesLinks', this.pageAddress = 'servicesLinksPage', this.initialSortColumn = 'id';
    }
}





class $c5fc0bc2176d87eb$export$6d028bace09f449e extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    setServiceDeviationResolution(serviceDeviationResolution) {
        this.setState({
            serviceDeviationResolution: serviceDeviationResolution
        });
    }
    subscribe() {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        this.subscriptionsService.subscribeToAll('resolvedServiceDeviations', (event)=>{
            if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(event)) this.logger.error(event);
            else this.setServiceDeviationResolution(event);
        }).then((off)=>{
            droppable.onDrop(off);
            /** Reset state */ droppable.onDrop(()=>this.setServiceDeviationResolution(null));
        }).catch((e)=>{
            this.logger.error(e);
            droppable.drop();
        });
        return ()=>droppable.drop();
    }
}
class $c5fc0bc2176d87eb$export$e4252105eea16419 extends (0, $091d28ec500ee607$export$e35eeca9ac01af15) {
    constructor(...args){
        super(...args), this.pageName = 'serviceDeviations', this.pageAddress = 'serviceDeviationsPage', this.initialSortColumn = 'id';
    }
}
class $c5fc0bc2176d87eb$export$a2f2c11b4ce5a38d extends (0, $091d28ec500ee607$export$e35eeca9ac01af15) {
    constructor(...args){
        super(...args), this.pageName = 'resourceDeviation', this.pageAddress = 'resourceDeviationPage', this.initialSortColumn = 'resourceId';
    }
}
class $c5fc0bc2176d87eb$export$38a5d37aaeaa9d4e extends (0, $091d28ec500ee607$export$e35eeca9ac01af15) {
    constructor(...args){
        super(...args), this.pageName = 'deviatedServices', this.pageAddress = 'deviatedServicesPage', this.initialSortColumn = 'id';
    }
}





class $369f0092d3cd4076$export$abab701c949ec279 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    invoke() {
        return this.configurationService.isStorybookEnabled();
    }
}






class $7ebee1b5ffb99c69$export$e1eac928f4286631 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    fetchMetrics() {
        return this.systemService.fetchMetrics();
    }
    sendMetricsToPortal() {
        return this.systemService.sendMetricsToPortal();
    }
    downloadHourlyMetricCSV(metrics) {
        const head = [
            this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).TIME),
            this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).NUMBER_OF_DATAPOINTS),
            this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).NUMBER_OF_MESSAGES_PER_HOUR)
        ];
        const file = this.fileService.generateCSV(this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).COLLECTED_HOURLY_METRICS_TITLE), head, metrics.map((metric)=>[
                metric.timestamp,
                metric.numberOfConnectedDatapoints,
                metric.numberOfReceivedMessages
            ]));
        this.fileService.download(file);
    }
    downloadDailyMetricCSV(metrics) {
        const head = [
            this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_ID),
            this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).DATE),
            this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).NUMBER_OF_DATAPOINTS),
            this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).NUMBER_OF_MESSAGES_PER_DAY)
        ];
        const licenseId = (0, $ee9c60e7a5b417f7$export$bd5742f31bcdaad7)(this.getState());
        const file = this.fileService.generateCSV(this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).COLLECTED_DAILY_METRICS_TITLE), head, metrics.map((metric)=>[
                licenseId,
                metric.date,
                metric.numberOfConnectedDatapoints,
                metric.numberOfReceivedMessages
            ]));
        this.fileService.download(file);
    }
}





const $dd699a9573945acf$var$isEmptyColumnView = ({ order: order, hidden: hidden, pinned: pinned, widths: widths })=>[
        order,
        hidden,
        pinned
    ].every((names)=>names.length === 0) && Object.keys(widths).length === 0;
class $dd699a9573945acf$export$1a43191552cf8b55 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    get(id) {
        return this.columnViewPersistenceService.retrieve(id);
    }
    /** Table views come without stale names, so an empty view is the default one, which isn't stored */ save(id, view) {
        if ($dd699a9573945acf$var$isEmptyColumnView(view)) this.columnViewPersistenceService.drop(id);
        else this.columnViewPersistenceService.persist(id, view);
    }
}




class $d1487aa97c1342bd$export$f317445fff1075c8 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    logFailure(e, message) {
        this.logger.error((0, $c3e1b746ad236797$export$8d524fb6540252df).is(e) ? e : new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, message, {
            error: e
        }));
    }
    /** In px, `null` for the default width, also when the saved width can't be read */ get() {
        try {
            return this.recordPanelWidthPersistenceService.retrieve();
        } catch (e) {
            this.logFailure(e, 'Could not read the record panel width');
            return null;
        }
    }
    /** `null` goes back to the default width; a width that can't be saved is only kept by the caller */ save(width) {
        try {
            this.recordPanelWidthPersistenceService.persist(width);
        } catch (e) {
            this.logFailure(e, 'Could not save the record panel width');
        }
    }
}





const $c623e2d48144a673$export$d1b579ecf4cf2d3f = {
    chunks: new Map(),
    customTopics: [],
    selectedTopics: [],
    subscriptionResponse: null,
    latestValues: {},
    tailSize: 50,
    isTailing: true,
    tail: []
};
class $c623e2d48144a673$export$46224f5a5af8ee22 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    static createTail({ tail: tail, tailSize: tailSize }) {
        return tail.slice(0, tailSize);
    }
    setExplorer(newExplorer) {
        const explorer = (0, $070c3c2fc0eda22c$export$3c69d3efda9669d4)(this.getState());
        this.setState({
            explorer: {
                ...explorer,
                ...newExplorer
            }
        });
    }
}


class $4fa4a5f54ae63c72$export$963a2d26686e7d38 extends (0, $c623e2d48144a673$export$46224f5a5af8ee22) {
    updateTailSize(tailSize) {
        if (!Number.isInteger(tailSize) || tailSize < 0) return false;
        const state = this.getState();
        if ((0, $070c3c2fc0eda22c$export$c992ab88b8f649d)(state) === tailSize) return false;
        this.setExplorer({
            tailSize: tailSize,
            tail: (0, $c623e2d48144a673$export$46224f5a5af8ee22).createTail((0, $070c3c2fc0eda22c$export$3c69d3efda9669d4)(state))
        });
        return true;
    }
    toggleTailing() {
        const { isTailing: isTailing } = (0, $070c3c2fc0eda22c$export$3c69d3efda9669d4)(this.getState());
        this.setExplorer({
            isTailing: !isTailing
        });
    }
    clearTail() {
        this.setExplorer({
            tail: []
        });
    }
}





class $08e00ffa0eeed96c$export$325f1a7e8fa6b185 extends (0, $c623e2d48144a673$export$46224f5a5af8ee22) {
    selectLatestValueType(topic, selectedType) {
        const { [topic]: latestValue, ...latestValues } = (0, $070c3c2fc0eda22c$export$57cd553a5287edd7)(this.getState());
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(latestValue, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Latest value not found', {
            topic: topic
        }));
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(latestValue.possibleTypes.includes(selectedType), new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Selected type not allowed', {
            topic: topic,
            selectedType: selectedType,
            allowedValues: latestValue.possibleTypes
        }));
        if (selectedType !== latestValue.selectedType) this.setExplorer({
            latestValues: {
                ...latestValues,
                [topic]: {
                    ...latestValue,
                    selectedType: selectedType
                }
            }
        });
    }
}





class $ac00f283016f694b$export$a3fd79364ed8bf15 extends (0, $c623e2d48144a673$export$46224f5a5af8ee22) {
    updateTopics(topics, action, types) {
        const state = this.getState();
        const update = {};
        for (const [type, isActionRequired] of (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(types))for (const topic of topics){
            const currentTopics = update[type] ?? this.topicSelectors[type](state);
            const wasAdded = currentTopics.includes(topic);
            const wantsToAdd = action === 'toggle' ? !wasAdded : action === 'add';
            if (wantsToAdd === wasAdded) {
                (0, $14eddac5f20c576c$export$a7a9523472993e97)(!isActionRequired, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Topic were in an unexpected state', {
                    wasAdded: wasAdded,
                    wantsToAdd: wantsToAdd,
                    type: type,
                    topic: topic
                }));
                continue;
            }
            update[type] = wantsToAdd ? [
                ...currentTopics,
                topic
            ] : currentTopics.filter((t)=>t !== topic);
        }
        this.setExplorer(update);
    }
    /**
     * (Un)subscribe selection of a topics
     */ toggleTopics(topics) {
        this.updateTopics(topics, 'toggle', {
            selectedTopics: true
        });
    }
    retryTopic(fullPath) {
        /** De-select relevant topics, forcing a subscription change */ this.toggleTopics([
            fullPath
        ]);
        /** Re-select relevant topics, forcing re-subscription */ this.toggleTopics([
            fullPath
        ]);
    }
    /**
     * Remove custom topic from application und unselect it if its selected
     *
     * If custom topic cannot be found, error is thrown
     */ removeCustomTopic(topic) {
        this.updateTopics([
            topic
        ], 'remove', {
            customTopics: true,
            selectedTopics: false
        });
    }
    /**
     * Adds custom topic and selects it
     *
     * If topic existed before, error will be thrown
     * If topic is invalid, error will be thrown
     */ addCustomTopic(topic) {
        if (!this.topicsService.createTopic(topic).valid) throw new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).GENERAL_BUSINESS_RULE_INFRACTION, this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).INVALID_TOPIC), {
            topic: topic
        });
        this.updateTopics([
            topic
        ], 'add', {
            customTopics: true,
            selectedTopics: true
        });
    }
    constructor(...args){
        super(...args), this.topicSelectors = {
            customTopics: (0, $070c3c2fc0eda22c$export$f470b43d5107165e),
            selectedTopics: (0, $070c3c2fc0eda22c$export$9638cf3323a42fde)
        };
    }
}




const $684496fd7538c52c$var$canReadTopicsMetadata = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).TOPIC_CHUNKS_READ);
class $684496fd7538c52c$export$798476376223da07 extends (0, $c623e2d48144a673$export$46224f5a5af8ee22) {
    setChunks(prefix, value) {
        const chunks = new Map((0, $070c3c2fc0eda22c$export$580f92cfd492a3f6)(this.getState()));
        chunks.set(prefix, value);
        this.setExplorer({
            chunks: chunks
        });
    }
    initializeChunk(prefix) {
        /** Initalize current chunk and save the position of the chunk that has been just to 'loading' */ const currentChunk = (0, $070c3c2fc0eda22c$export$a76e1be6cb0a97ca)(this.getState(), prefix);
        this.setChunks(prefix, [
            ...currentChunk,
            null
        ]);
        return currentChunk.length;
    }
    load(prefix, droppable) {
        const state = this.getState();
        if (!$684496fd7538c52c$var$canReadTopicsMetadata(state)) /**
             * Drop loading silently if the current state does not have permission
             */ return;
        /**
         * Fetch the needed metadata
         */ const reference = (0, $070c3c2fc0eda22c$export$612929a23c7c1e4c)(state, prefix);
        /**
         * Add a chunk with the loading state
         */ const position = this.initializeChunk(prefix);
        this.topicsService.fetchTopicsChunk(prefix, reference).catch((e)=>e).then((chunkOrerror)=>{
            if (droppable.isDropped) return;
            /**
                 * Update the chunk with the response
                 */ const [...next] = (0, $070c3c2fc0eda22c$export$a6c82c1da1c7b055)(this.getState(), prefix, position);
            next[position] = chunkOrerror;
            this.setChunks(prefix, next);
        });
    }
    createRootTopic() {
        return this.topicsService.createTopic(null);
    }
}






class $d58a394b070f3fda$export$53155f88f59532cd extends (0, $c623e2d48144a673$export$46224f5a5af8ee22) {
    createTopicSelectionRefresher(subscription, droppable) {
        /**
         * The queue ensure each wait for the next
         */ const queue = new (0, $85a96cf722827591$export$3dc07afe418952bc)();
        return ()=>{
            queue.push(async ()=>{
                if (droppable.isDropped) return;
                /** Reset if needed */ if ((0, $070c3c2fc0eda22c$export$3c69d3efda9669d4)(this.getState()).subscriptionResponse !== null) this.setExplorer({
                    subscriptionResponse: null
                });
                const selectedTopics = (0, $070c3c2fc0eda22c$export$9638cf3323a42fde)(this.getState());
                const subscriptionResponse = await subscription.subscribe(selectedTopics);
                /** Check if subscription has been dropped or if another set of topics have been selected */ if (droppable.isDropped || selectedTopics !== (0, $070c3c2fc0eda22c$export$9638cf3323a42fde)(this.getState())) return;
                const getIndexedSelectedTopics = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>new Set(selectedTopics));
                /**
                 * Recreate last values without topics that may be gone
                 */ const latestValues = [];
                /**
                 * Selected topics that are exact get to be pre-added as null entries
                 */ for (const topic of selectedTopics)if (this.topicsService.createTopic(topic).exact) latestValues.push([
                    topic,
                    null
                ]);
                /**
                 * Messages from topics that are still being subscribed to get to still be present
                 */ for (const [topic, message] of (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)((0, $070c3c2fc0eda22c$export$57cd553a5287edd7)(this.getState())))if (message?.sources.some((s)=>getIndexedSelectedTopics().has(s))) latestValues.push([
                    topic,
                    message
                ]);
                this.setExplorer({
                    subscriptionResponse: subscriptionResponse,
                    latestValues: Object.fromEntries(latestValues)
                });
            });
        };
    }
    /**
     * Creates a topic subscription that will wait for topics to be subscribed to
     * @returns a function to drop the subscription
     */ invoke() {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        /** Initialize the state of the explorer */ this.setState({
            explorer: (0, $c623e2d48144a673$export$d1b579ecf4cf2d3f)
        });
        /** Retrive from the persistence layer the topics config and listen to changes */ const { selected: selectedTopics, custom: customTopics } = this.topicsPersistenceService.retrieveTopics();
        if (selectedTopics.length + customTopics.length) this.setExplorer({
            selectedTopics: selectedTopics,
            customTopics: customTopics
        });
        droppable.onDrop(this.subscribeToState((a, b)=>(0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)((0, $070c3c2fc0eda22c$export$9638cf3323a42fde)(a), (0, $070c3c2fc0eda22c$export$9638cf3323a42fde)(b)) && (0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)((0, $070c3c2fc0eda22c$export$f470b43d5107165e)(a), (0, $070c3c2fc0eda22c$export$f470b43d5107165e)(b)), ()=>this.topicsPersistenceService.persistTopics({
                selected: (0, $070c3c2fc0eda22c$export$9638cf3323a42fde)(this.getState()),
                custom: (0, $070c3c2fc0eda22c$export$f470b43d5107165e)(this.getState())
            })));
        /** Already load the root chunk */ this.getUsecase((0, $684496fd7538c52c$export$798476376223da07)).load(null, droppable);
        /** Start listening to topic messages */ const subscription = this.topicsService.createSubscription();
        droppable.onDrop(()=>subscription.end());
        /** Listen for change in selection, and update subscription accordingly */ const topicsSelectionChanged = this.createTopicSelectionRefresher(subscription, droppable);
        droppable.onDrop(this.subscribeToState((a, b)=>(0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)((0, $070c3c2fc0eda22c$export$9638cf3323a42fde)(a), (0, $070c3c2fc0eda22c$export$9638cf3323a42fde)(b)), topicsSelectionChanged));
        topicsSelectionChanged();
        /**
         * If there is general error, just thrown it all over the place,
         * an error implies that the client will be closed
         */ droppable.onDrop(subscription.onError((error)=>this.setState({
                explorer: error
            })));
        droppable.onDrop(subscription.onBatch((batch)=>{
            const explorer = (0, $070c3c2fc0eda22c$export$3c69d3efda9669d4)(this.getState());
            let { latestValues: latestValues, tailSize: tailSize, tail: tail } = explorer;
            batch.forEach(({ timestamp: timestamp, possibleTypes: possibleTypes, topic: topic, payload: payload, sources: sources })=>{
                let [selectedType] = possibleTypes;
                const latestValue = latestValues[topic] ?? null;
                const previousSelectedType = latestValue && 'selectedType' in latestValue && latestValue.selectedType || selectedType;
                selectedType = possibleTypes.includes(previousSelectedType) ? previousSelectedType : selectedType;
                /** Update latest values, without overriding the previously selected value */ latestValues = {
                    ...latestValues,
                    [topic]: {
                        possibleTypes: possibleTypes,
                        payload: payload,
                        selectedType: selectedType,
                        sources: sources
                    }
                };
                /** Updates the tail unless it is stopped */ tail = explorer.isTailing ? (0, $c623e2d48144a673$export$46224f5a5af8ee22).createTail({
                    tail: [
                        {
                            timestamp: timestamp,
                            topic: topic,
                            payload: payload,
                            selectedType: selectedType
                        },
                        ...tail
                    ],
                    tailSize: tailSize
                }) : tail;
            });
            this.setExplorer({
                latestValues: latestValues,
                tail: tail
            });
        }));
        /** If dropped, reset the state */ droppable.onDrop(()=>this.setState({
                explorer: (0, $070c3c2fc0eda22c$export$723680c405115633)((0, $95a9c43d1c8832e3$export$d4c72bab9d6cc13a))
            }));
        return ()=>droppable.drop();
    }
}









class $65a64e7ace4ea65e$export$fc81d9ba8155b1a6 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    setUsersManagement(changes) {
        this.setState({
            usersManagement: {
                ...(0, $fbdaead6b0d14feb$export$6f609a3beb4bd7ae)(this.getState()),
                ...changes
            }
        });
    }
}


class $d8890ef5104ea89c$export$fd0332defd54be86 extends (0, $65a64e7ace4ea65e$export$fc81d9ba8155b1a6) {
    updateTab(tab, update) {
        this.setUsersManagement({
            [tab]: {
                ...(0, $55a8cd2d1e96ead3$export$f23f5525e25bce9e)(this.getState(), tab),
                ...update
            }
        });
    }
    async loadTab(selected, resetTab) {
        const previousTab = (0, $55a8cd2d1e96ead3$export$f23f5525e25bce9e)(this.getState(), selected);
        if (resetTab) /** Set the tab as loading */ this.updateTab(selected, {
            data: null
        });
        /** Finally get the data */ const promise = this.pageFetchers[selected](previousTab.search, previousTab.showInternal, previousTab.page);
        const data = await promise.catch((e)=>e);
        /** Check if filter has been updated */ const currentTab = (0, $55a8cd2d1e96ead3$export$f23f5525e25bce9e)(this.getState(), selected);
        if (!(0, $55a8cd2d1e96ead3$export$b5bd176576c7c005)(previousTab, currentTab)) return;
        const page = data && 'page' in data ? data.page : null;
        if (page !== null && previousTab.page !== page) /** Page does not match what backend says, so update it and let the data be refreshed */ this.updateTab(selected, {
            page: page
        });
        else /** State hasn't been re-fetched, just update the data */ this.updateTab(selected, {
            data: data
        });
    }
    constructor(...args){
        super(...args), this.pageFetchers = {
            users: (...args)=>this.userService.fetchUsersPage(...args),
            roles: (...args)=>this.userService.fetchRolesPage(...args),
            permissions: (...args)=>this.userService.fetchPermissionsPage(...args)
        };
    }
}


class $bfe27f193238fc66$export$db0863e6288a9df5 extends (0, $d8890ef5104ea89c$export$fd0332defd54be86) {
    invoke(tab) {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        /** So the load does not get triggered every time there is a state change */ const throttler = new (0, $2accc4d3fee5c026$export$af12a1bf506c8522)(this.getThrottle());
        /** Listen to state changes, and after the calls are throttled, then load again */ droppable.onDrop(this.subscribeToState((a, b)=>(0, $55a8cd2d1e96ead3$export$d3fdc632592facd4)(tab, a, b), ()=>droppable.onDrop(throttler.run(()=>void this.loadTab(tab, false)))));
        /** Finally load everything */ this.loadTab(tab, false);
        return ()=>droppable.drop();
    }
    /** Loads the tab again, showing it as loading in the meantime */ retry(tab) {
        this.loadTab(tab, true);
    }
    constructor(...args){
        super(...args), this.getThrottle = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.configurationService.getInteractionThrottle());
    }
}





class $41df092f4f0a1f9c$export$ddc038420000b938 extends (0, $d8890ef5104ea89c$export$fd0332defd54be86) {
    search(tab, search) {
        this.updateTab(tab, {
            search: search,
            page: (0, $55a8cd2d1e96ead3$export$723849c1426bff71)((0, $95a9c43d1c8832e3$export$d4c72bab9d6cc13a), tab),
            data: null
        });
    }
    toggleShowInternal(tab) {
        this.updateTab(tab, {
            showInternal: !(0, $55a8cd2d1e96ead3$export$3d204d54547967c0)(this.getState(), tab),
            page: (0, $55a8cd2d1e96ead3$export$723849c1426bff71)((0, $95a9c43d1c8832e3$export$d4c72bab9d6cc13a), tab),
            data: null
        });
    }
    setPage(tab, page) {
        this.updateTab(tab, {
            page: page,
            data: null
        });
    }
}












class $0632cb9aeb130c4d$export$5744a38b399ab25f extends (0, $d8890ef5104ea89c$export$fd0332defd54be86) {
    getHiddenFormsState() {
        const { roleCreation: roleCreation, roleUpdating: roleUpdating, userUpdating: userUpdating, userCreation: userCreation, registryRequest: registryRequest } = (0, $fbdaead6b0d14feb$export$6f609a3beb4bd7ae)((0, $95a9c43d1c8832e3$export$d4c72bab9d6cc13a));
        const hiddenFormsState = {
            roleCreation: roleCreation,
            roleUpdating: roleUpdating,
            userUpdating: userUpdating,
            userCreation: userCreation,
            registryRequest: registryRequest
        };
        return hiddenFormsState;
    }
    setForm(form) {
        this.setUsersManagement({
            ...this.getHiddenFormsState(),
            [this.formName]: form
        });
    }
    getNullableForm() {
        return this.selectForm(this.getState());
    }
    getForm() {
        const form = this.getNullableForm();
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(form, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Can not retrieve form'));
        return form;
    }
    close() {
        this.setUsersManagement(this.getHiddenFormsState());
    }
}


class $8cb94d155ab62188$export$ea3cafb4d9f1b328 extends (0, $0632cb9aeb130c4d$export$5744a38b399ab25f) {
    isFormVisible() {
        return this.getNullableForm() !== null;
    }
    getInitialForm() {
        return (0, $fbdaead6b0d14feb$export$c44b060058cf5112)(this.getForm());
    }
    getCurrentForm() {
        return (0, $fbdaead6b0d14feb$export$4904853904034fa9)(this.getForm());
    }
    setPartialForm(form) {
        this.setForm([
            this.getInitialForm(),
            {
                ...this.getCurrentForm(),
                ...form
            }
        ]);
    }
    initializeForm(form) {
        this.setForm([
            form,
            form
        ]);
    }
    /**
     * Utility function to schedule throttled updates of the form
     */ async updateFormWithDelay(compare, update) {
        const initial = this.getCurrentForm();
        /** Wait for some time to pass before executing any post validation */ await (0, $48cf5ef53a480c1f$export$1391212d75b2ee65)(this.getThrottle());
        if (!this.isFormVisible() || !compare(initial, this.getCurrentForm())) /** The form changed in the meantime, stop */ return;
        const updated = await update(initial);
        if (!this.isFormVisible() || !compare(initial, this.getCurrentForm())) /** The form changed in the meantime, stop */ return;
        this.setPartialForm(updated);
    }
    async reload() {
        /** Close all the forms */ this.close();
        /** Load the page */ await this.loadTab(this.selected, true);
    }
    update(update) {
        this.setPartialForm(update);
    }
    async confirm() {
        await this.request();
        await this.reload();
    }
    constructor(...args){
        super(...args), this.getThrottle = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.configurationService.getInteractionThrottle());
    }
}


class $a0445c333a5cd171$export$db4a433fac0a0733 extends (0, $8cb94d155ab62188$export$ea3cafb4d9f1b328) {
    static #_ = this.derivedTemplateValues = {
        templateInput: null,
        templates: null,
        selectedTemplate: null
    };
    getValidateNewPermissionError(permission) {
        if (!permission.resource) return (0, $40a99dac858c1d75$export$b63289fbda65eed1).RESOURCE_IS_MISSING;
        if (!permission.read && !permission.write) return (0, $40a99dac858c1d75$export$b63289fbda65eed1).MISSING_READ_OR_WRITE_PERMISSION;
        const { permissions: permissions } = this.getCurrentForm();
        if (permissions.some((p)=>p.context === permission.context && p.resource === permission.resource)) return (0, $40a99dac858c1d75$export$b63289fbda65eed1).PERMISSION_ALREADY_EXISTS;
        return null;
    }
    async updateTemplates() {
        await this.updateFormWithDelay((a, b)=>a.templateInput === b.templateInput, ({ templateInput: templateInput })=>templateInput === null ? {} : Promise.all([
                this.userService.fetchRoles(templateInput),
                this.userService.fetchUsers(templateInput)
            ]).then(([roles, users])=>[
                    ...roles,
                    ...users
                ]).catch((e)=>e).then((templates)=>({
                    templates: templates
                })));
    }
    async updateTemplateInput() {
        await this.updateFormWithDelay((a, b)=>a.selectedTemplate === b.selectedTemplate, ()=>({
                templateInput: null
            }));
    }
    initializeForm(form) {
        super.initializeForm(form);
        this.updateTemplates();
        this.updateTemplateInput();
    }
    setPartialForm(form) {
        super.setPartialForm(form);
        if ('templateInput' in form) this.updateTemplates();
        if ('selectedTemplate' in form) this.updateTemplateInput();
    }
    validateNewPermission(permission) {
        const errorTranslation = this.getValidateNewPermissionError(permission);
        if (errorTranslation) throw new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).GENERAL_BUSINESS_RULE_INFRACTION, this.translationService.translate(errorTranslation, permission));
    }
    applyTemplate(userOrRole) {
        const permissions = 'username' in userOrRole ? userOrRole.allPermissions : userOrRole.permissions;
        const { permissions: currentPermissions } = this.getCurrentForm();
        const mergedPermissions = new (0, $f0cbf013be9038ef$export$c3f30dbb97e8bc91)();
        // Add current permissions
        currentPermissions.forEach((p)=>mergedPermissions.set(p.context + p.resource, p));
        // Add new permissions
        permissions.forEach((p)=>{
            const { read: read, write: write, ...merged } = mergedPermissions.getDefault(p.context + p.resource, {
                context: p.context,
                resource: p.resource,
                id: null,
                read: false,
                write: false
            });
            mergedPermissions.set(p.context + p.resource, {
                ...merged,
                read: read || p.read,
                write: write || p.write
            });
        });
        const update = {};
        update.permissions = mergedPermissions.toValuesArray();
        this.setPartialForm({
            ...update,
            ...$a0445c333a5cd171$export$db4a433fac0a0733.derivedTemplateValues
        });
    }
    selectTemplate(selectedTemplate) {
        this.setPartialForm({
            selectedTemplate: selectedTemplate
        });
    }
    searchTemplates(templateInput) {
        this.setPartialForm({
            templateInput: templateInput
        });
    }
}


class $39045d52f9d3c3b0$export$7f0e6111b666129c extends (0, $a0445c333a5cd171$export$db4a433fac0a0733) {
    async request() {
        const { id: id, name: name, permissions: permissions, ldapGroupDn: ldapGroupDn, msEntraIdGroupIds: msEntraIdGroupIds } = this.getCurrentForm();
        await this.userService.updateRole({
            id: id,
            name: name,
            permissions: permissions,
            ldapGroupDn: ldapGroupDn,
            msEntraIdGroupIds: msEntraIdGroupIds
        });
    }
    async delete(id) {
        await this.userService.deleteRole(id);
        await this.reload();
    }
    async start({ id: id, name: name, permissions: permissions, users: users, ldapGroupDn: ldapGroupDn, canDelete: canDelete, canEditOthers: canEditOthers, canEditName: canEditName, msEntraIdGroupIds: msEntraIdGroupIds }) {
        const { isLdapEnabled: isLdapEnabled, isEntraEnabled: isEntraEnabled } = await this.userService.fetchManagementConfiguration();
        this.initializeForm({
            id: id,
            name: name,
            permissions: permissions,
            users: users,
            ldapGroupDn: isLdapEnabled ? ldapGroupDn : null,
            msEntraIdGroupIds: isEntraEnabled ? msEntraIdGroupIds : null,
            canDelete: canDelete,
            canEditOthers: canEditOthers,
            canEditName: canEditName,
            ...$39045d52f9d3c3b0$export$7f0e6111b666129c.derivedTemplateValues
        });
    }
    async load(roleName) {
        const loadindUsecase = this.getUsecase((0, $a6de2e88b5226ac8$export$dd06ffc7864da99f));
        await loadindUsecase.withLoading(this.userService.fetchRole(roleName).then((role)=>this.start(role)));
    }
    constructor(...args){
        super(...args), this.selected = 'roles', this.formName = 'roleUpdating', this.selectForm = (0, $fbdaead6b0d14feb$export$8c529c986e442e67);
    }
}
class $39045d52f9d3c3b0$export$550648d575c2043c extends (0, $a0445c333a5cd171$export$db4a433fac0a0733) {
    async request() {
        const { name: name, permissions: permissions, ldapGroupDn: ldapGroupDn, msEntraIdGroupIds: msEntraIdGroupIds } = this.getCurrentForm();
        await this.userService.createRole({
            name: name,
            permissions: permissions,
            ldapGroupDn: ldapGroupDn,
            msEntraIdGroupIds: msEntraIdGroupIds
        });
    }
    async start() {
        const loadindUsecase = this.getUsecase((0, $a6de2e88b5226ac8$export$dd06ffc7864da99f));
        await loadindUsecase.withLoading(this.userService.fetchManagementConfiguration().then(({ isLdapEnabled: isLdapEnabled, isEntraEnabled: isEntraEnabled })=>{
            this.initializeForm({
                name: '',
                permissions: [],
                ldapGroupDn: isLdapEnabled ? '' : null,
                msEntraIdGroupIds: isEntraEnabled ? [] : null,
                canDelete: true,
                canEditOthers: true,
                canEditName: true,
                ...$39045d52f9d3c3b0$export$550648d575c2043c.derivedTemplateValues
            });
        }));
    }
    constructor(...args){
        super(...args), this.selected = 'roles', this.formName = 'roleCreation', this.selectForm = (0, $fbdaead6b0d14feb$export$bf7fc1d8540b77ce);
    }
}






class $5f34ca3f0e83d4c2$export$88a86cf7ae5dc5c1 extends (0, $a0445c333a5cd171$export$db4a433fac0a0733) {
    static #_ = this.derivedRolesValues = {
        roleInput: null,
        allRoles: null,
        rolesPermissions: [],
        mqttPublishPrefixValidation: null
    };
    async updateMQTTPublishPrefixValidation() {
        await this.updateFormWithDelay((a, b)=>a.mqttPublishPrefix === b.mqttPublishPrefix && a.username === b.username && (0, $10784336063bfb60$export$2e83e407cf76af40)(a.permissions, b.permissions) && (0, $beeea5165e6b24a4$export$90c517a953a1b4f3)(a.roles, b.roles), ({ mqttPublishPrefix: mqttPublishPrefix, permissions: permissions, rolesPermissions: rolesPermissions, username: username })=>{
            if (mqttPublishPrefix && !this.topicsService.createTopic(mqttPublishPrefix).exact) /** Handling scenario with non exact prefix */ return {
                mqttPublishPrefixValidation: new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).GENERAL_BUSINESS_RULE_INFRACTION, this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).MQTT_PUBLISH_PREFIX_VALIDATION, {
                    type: 'NOT_EXACT'
                }))
            };
            const topic = mqttPublishPrefix && this.topicsService.createTopic(mqttPublishPrefix);
            if (topic && !topic.isPrefixedBy([
                ...permissions,
                ...rolesPermissions
            ].flatMap((permission)=>permission.context === (0, $10784336063bfb60$export$25544a24f1dbb74).MQTT && permission.write ? [
                    permission.resource
                ] : []))) /** Handling scenario with prefix without permissions */ return {
                mqttPublishPrefixValidation: new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).GENERAL_BUSINESS_RULE_INFRACTION, this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).MQTT_PUBLISH_PREFIX_VALIDATION, {
                    username: username,
                    prefix: mqttPublishPrefix,
                    type: 'NO_PERMISSIONS'
                }))
            };
            /** Handling scenario with no prefix */ return {
                mqttPublishPrefixValidation: null
            };
        });
    }
    updateRolePermissions() {
        const { roles: roles } = this.getCurrentForm();
        const update = {};
        update.rolesPermissions = roles.flatMap((r)=>r.permissions.map((p)=>({
                    ...p,
                    role: r.name
                })));
        this.setPartialForm(update);
    }
    async updateAllRoles() {
        await this.updateFormWithDelay((a, b)=>a.roleInput === b.roleInput, async ({ roleInput: roleInput })=>{
            const update = {};
            if (roleInput === null) {
                update.allRoles = null;
                return update;
            }
            try {
                const foundRoles = await this.userService.fetchRoles(roleInput);
                const { roles: roles } = this.getCurrentForm();
                update.allRoles = [
                    ...foundRoles,
                    ...roles.filter((r)=>!foundRoles.some((f)=>f.id === r.id))
                ];
            } catch (e) {
                update.allRoles = e;
            }
            return update;
        });
    }
    initializeForm(form) {
        super.initializeForm(form);
        this.updateRolePermissions();
        this.updateAllRoles();
        this.updateMQTTPublishPrefixValidation();
    }
    setPartialForm(form) {
        super.setPartialForm(form);
        if ('mqttPublishPrefix' in form || 'permissions' in form || 'rolesPermissions' in form || 'username' in form) this.updateMQTTPublishPrefixValidation();
        if ('roles' in form) this.updateRolePermissions();
        if ('roleInput' in form) this.updateAllRoles();
    }
    searchRoles(roleInput) {
        this.setPartialForm({
            roleInput: roleInput
        });
    }
    /** Keeps the search and its results: removing a chip with backspace leaves the list open, and nothing would reload it */ selectRoles(roles) {
        this.setPartialForm({
            roles: roles
        });
    }
}
class $5f34ca3f0e83d4c2$var$CredentializedUserFormUsecase extends $5f34ca3f0e83d4c2$export$88a86cf7ae5dc5c1 {
    static #_ = this.derivedUserValues = {
        passwordValidation: null,
        usernameValidation: null
    };
    createConfirmationValidationMessage({ password: password, passwordConfirmation: passwordConfirmation }) {
        if (passwordConfirmation === null) return null;
        const matchMessage = this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).PASSWORD_VALIDATION, {
            type: 'match'
        });
        return password === passwordConfirmation ? matchMessage : new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).GENERAL_BUSINESS_RULE_INFRACTION, matchMessage);
    }
    async validatePassword({ password: password, passwordConfirmation: passwordConfirmation }) {
        if (password === null) // No password is being set, so just don't do anything
        return [];
        return [
            this.createConfirmationValidationMessage({
                password: password,
                passwordConfirmation: passwordConfirmation
            }),
            ...await this.userService.validatePassword(password)
        ].filter((v)=>Boolean(v));
    }
    async updatePasswordValidation() {
        await this.updateFormWithDelay((a, b)=>a.password === b.password && a.passwordConfirmation === b.passwordConfirmation, (form)=>this.validatePassword(form).catch((e)=>e).then((passwordValidation)=>({
                    passwordValidation: passwordValidation
                })));
    }
    async updateUsernameValidation() {
        await this.updateFormWithDelay((a, b)=>a.username === b.username, ({ username: username })=>this.userService.validateUsername(username).then((usernameValidation)=>({
                    usernameValidation: usernameValidation
                })));
    }
    initializeForm(form) {
        super.initializeForm(form);
        this.updatePasswordValidation();
        this.updateUsernameValidation();
    }
    setPartialForm(form) {
        super.setPartialForm(form);
        if ('password' in form || 'passwordConfirmation' in form) this.updatePasswordValidation();
        if ('username' in form) this.updateUsernameValidation();
    }
    togglePasswordMode() {
        const { passwordConfirmation: passwordConfirmation } = this.getCurrentForm();
        this.setPartialForm({
            passwordConfirmation: passwordConfirmation === null ? '' : null
        });
    }
}
class $5f34ca3f0e83d4c2$export$8b40dc8823a18741 extends $5f34ca3f0e83d4c2$var$CredentializedUserFormUsecase {
    static getModifiedFields(origin, compare) {
        const diff = {};
        for(const key in compare)if (!(0, $33cff95ba235ba3b$export$9701e92d714bc6a7)(origin[key], compare[key])) diff[key] = compare[key];
        return diff;
    }
    async request() {
        const initial = this.getInitialForm();
        const current = this.getCurrentForm();
        // only returns changed fields
        const { username: username, permissions: permissions, roles: roles, authenticationMethods: authenticationMethods, mqttPublishPrefix: mqttPublishPrefix, password: password, mfaStatus: mfaStatus, isMfaEnforced: isMfaEnforced } = $5f34ca3f0e83d4c2$export$8b40dc8823a18741.getModifiedFields(initial, current);
        await this.userService.updateUser({
            id: current.id,
            username: username,
            permissions: permissions,
            roles: roles,
            authenticationMethods: authenticationMethods,
            mqttPublishPrefix: mqttPublishPrefix,
            password: password,
            mfaStatus: mfaStatus,
            isMfaEnforced: isMfaEnforced
        });
    }
    async updateUsernameValidation() {
        const { canEditName: canEditName } = this.getCurrentForm();
        if (canEditName) await super.updateUsernameValidation();
    }
    async delete(id) {
        await this.userService.deleteUser(id);
        await this.reload();
    }
    async load(userOrUsername) {
        const userPromise = typeof userOrUsername === 'string' ? this.userService.fetchUser(userOrUsername) : Promise.resolve(userOrUsername);
        const loadindUsecase = this.getUsecase((0, $a6de2e88b5226ac8$export$dd06ffc7864da99f));
        await loadindUsecase.withLoading(userPromise.then((user)=>Promise.all([
                user,
                Promise.all(user.roles.map((roleName)=>this.userService.fetchRole(roleName)))
            ])).then(([user, roles])=>this.initializeForm({
                username: user.username,
                mfaStatus: user.mfaStatus,
                mqttPublishPrefix: user.mqttPublishPrefix,
                id: user.id,
                password: null,
                passwordConfirmation: null,
                roles: roles,
                permissions: user.permissions,
                authenticationMethods: user.authenticationMethods,
                isMfaEnforced: user.isMfaEnforced,
                canDelete: user.canDelete,
                canEditOthers: user.canEditOthers,
                canEditName: user.canEditName,
                canUpdateMFA: user.canUpdateMFA,
                ...$5f34ca3f0e83d4c2$export$8b40dc8823a18741.derivedRolesValues,
                ...$5f34ca3f0e83d4c2$export$8b40dc8823a18741.derivedUserValues,
                ...$5f34ca3f0e83d4c2$export$8b40dc8823a18741.derivedTemplateValues
            })));
    }
    constructor(...args){
        super(...args), this.selected = 'users', this.formName = 'userUpdating', this.selectForm = (0, $fbdaead6b0d14feb$export$cf1548ec5e235d39);
    }
}
class $5f34ca3f0e83d4c2$export$b1f054f60d0c85ca extends $5f34ca3f0e83d4c2$var$CredentializedUserFormUsecase {
    async request() {
        const { username: username, mqttPublishPrefix: mqttPublishPrefix, authenticationMethods: authenticationMethods, roles: roles, permissions: permissions, password: password, isMfaEnforced: isMfaEnforced } = this.getCurrentForm();
        await this.userService.createUser({
            username: username,
            mqttPublishPrefix: mqttPublishPrefix,
            authenticationMethods: authenticationMethods,
            roles: roles,
            permissions: permissions,
            password: password,
            isMfaEnforced: isMfaEnforced
        });
    }
    async start() {
        const loadindUsecase = this.getUsecase((0, $a6de2e88b5226ac8$export$dd06ffc7864da99f));
        await loadindUsecase.withLoading(this.userService.fetchManagementConfiguration().then(({ isMfaEnabled: isMfaEnabled })=>{
            this.initializeForm({
                username: '',
                mqttPublishPrefix: null,
                password: '',
                passwordConfirmation: '',
                roles: [],
                permissions: [],
                authenticationMethods: [
                    (0, $80ed8557cc0425cc$export$766a2ded12a6f943).PASSWORD,
                    (0, $80ed8557cc0425cc$export$766a2ded12a6f943).TOKEN
                ],
                isMfaEnforced: isMfaEnabled ? false : null,
                canDelete: true,
                canEditOthers: true,
                canEditName: true,
                canUpdateMFA: true,
                ...$5f34ca3f0e83d4c2$export$b1f054f60d0c85ca.derivedUserValues,
                ...$5f34ca3f0e83d4c2$export$b1f054f60d0c85ca.derivedRolesValues,
                ...$5f34ca3f0e83d4c2$export$b1f054f60d0c85ca.derivedTemplateValues
            });
        }));
    }
    constructor(...args){
        super(...args), this.selected = 'users', this.formName = 'userCreation', this.selectForm = (0, $fbdaead6b0d14feb$export$c3255b8cef0af79);
    }
}





class $d987ba8160d3c875$export$17d852bed71d3fbc extends (0, $65a64e7ace4ea65e$export$fc81d9ba8155b1a6) {
    show(viewPermission) {
        this.setUsersManagement({
            viewPermission: viewPermission
        });
    }
    close() {
        this.setUsersManagement({
            viewPermission: (0, $fbdaead6b0d14feb$export$8c76e358ba74451b)((0, $95a9c43d1c8832e3$export$d4c72bab9d6cc13a))
        });
    }
}






class $7d54780cec51edb2$export$ee5d620451301784 extends (0, $65a64e7ace4ea65e$export$fc81d9ba8155b1a6) {
    setRegistry(update) {
        this.setUsersManagement({
            registry: {
                ...(0, $fbdaead6b0d14feb$export$ff5eb3337d355fbf)(this.getState()),
                ...update
            }
        });
    }
}


class $acc1a4d6b2b220d2$export$a698fe06a7ad2b37 extends (0, $7d54780cec51edb2$export$ee5d620451301784) {
    mapDataUpdate(response) {
        const data = (0, $823726049107e73f$export$9baacaf8bb7b4e87)(this.getState());
        if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(response) || (0, $c3e1b746ad236797$export$8d524fb6540252df).is(data) || data === null || !(0, $6d780693ef9ac26e$export$74915331dae2b65b)(response, data)) /**
             * Data should be updated if
             *  - there is an error on the response
             *  - previous data was an error
             *  - previous data was not loaded
             *  - is different
             */ return response;
        // Keep same as old one
        return data;
    }
    mapLockedUpdate(response) {
        const locked = (0, $823726049107e73f$export$790f9bc128365008)(this.getState());
        if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(response)) /** There was an error, just use current status */ return locked;
        const isLocked = response.unlockedUntil === null;
        if (locked !== isLocked) /**
             * User hasn't actively locked or unlocked
             * Or data is misaligned with the users selection
             * So use the data
             */ return isLocked;
        return locked;
    }
    async fetchRegistry() {
        const response = await this.clientRegistryService.fetchData().catch((e)=>e);
        return {
            locked: this.mapLockedUpdate(response),
            data: this.mapDataUpdate(response)
        };
    }
    scheduleRelock(droppable) {
        const data = (0, $823726049107e73f$export$9baacaf8bb7b4e87)(this.getState());
        if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(data) || data === null || data.unlockedUntil === null) /** Nothing to be locked */ return;
        const unlockedUntil = data.unlockedUntil;
        droppable.onDrop(()=>(0, $d4622374f48a4eef$export$6eae7cf7a129a986)(()=>{
                const currentRegistry = (0, $fbdaead6b0d14feb$export$ff5eb3337d355fbf)(this.getState());
                if (data === currentRegistry.data) /** Registry window is now closed, time to lock */ this.setRegistry({
                    locked: true,
                    data: {
                        ...data,
                        unlockedUntil: null
                    }
                });
            }, unlockedUntil));
    }
    async load(droppable) {
        const oldRegistry = (0, $fbdaead6b0d14feb$export$ff5eb3337d355fbf)(this.getState());
        const update = await this.fetchRegistry();
        const registry = (0, $fbdaead6b0d14feb$export$ff5eb3337d355fbf)(this.getState());
        if (oldRegistry !== registry || droppable.isDropped || registry.locked === update.locked && registry.data === update.data) /**
             * It was either
             *  - updated in the meantime
             *  - dropped in the meantime
             *  - no actual change in the data
             * Therefore, no need to do anything
             */ return;
        this.setRegistry(update);
        this.scheduleRelock(droppable);
    }
    invoke() {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        const load = ()=>void this.load(droppable);
        // Already update the registry
        load();
        // Schedule regular update
        droppable.onDrop((0, $ad06b61c4606f6df$export$5fe74ec28e3a5524)(load, this.configurationService.getClientRegistryRefreshRate()));
        // Schedule load when state has changed
        droppable.onDrop(this.subscribeToState((a, b)=>(0, $823726049107e73f$export$790f9bc128365008)(a) === (0, $823726049107e73f$export$790f9bc128365008)(b), load));
        return ()=>droppable.drop();
    }
}






class $2bf33eb0bf0fbdea$export$eeebada583410990 extends (0, $5f34ca3f0e83d4c2$export$88a86cf7ae5dc5c1) {
    async request() {
        const { username: username, mqttPublishPrefix: mqttPublishPrefix, authenticationMethods: authenticationMethods, roles: roles, permissions: permissions } = this.getCurrentForm();
        await this.clientRegistryService.authorize({
            username: username,
            mqttPublishPrefix: mqttPublishPrefix,
            authenticationMethods: authenticationMethods,
            roles: roles,
            permissions: permissions
        });
    }
    selectRoles(input) {
        const { request: request, roles: roles, allRoles: allRoles } = this.getCurrentForm();
        /** Retrieve all available roles */ const indexedRoles = [
            ...(0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(allRoles) ? allRoles : [],
            ...roles
        ].reduce((r, role)=>({
                ...r,
                [role.name]: role
            }), {});
        /** The input of the user + required selection */ const selection = input.reduce((r, { name: name })=>r.add(name), new Set(request.roles));
        super.selectRoles(Array.from(selection, (name)=>{
            const role = indexedRoles[name];
            (0, $14eddac5f20c576c$export$a7a9523472993e97)(role, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Could not find role by name', {
                name: name
            }));
            return role;
        }));
    }
    async load(request) {
        const loadindUsecase = this.getUsecase((0, $a6de2e88b5226ac8$export$dd06ffc7864da99f));
        await loadindUsecase.withLoading(Promise.all(request.roles.map((roleName)=>this.userService.fetchRole(roleName))).then((selectedRoles)=>this.initializeForm({
                username: request.username,
                authenticationMethods: [
                    request.authenticationMethod
                ],
                roles: selectedRoles,
                permissions: request.permissions,
                mqttPublishPrefix: null,
                request: request,
                ...$2bf33eb0bf0fbdea$export$eeebada583410990.derivedRolesValues,
                ...$2bf33eb0bf0fbdea$export$eeebada583410990.derivedTemplateValues
            })));
    }
    constructor(...args){
        super(...args), this.selected = 'users', this.formName = 'registryRequest', this.selectForm = (0, $fbdaead6b0d14feb$export$830f6d06818aa34);
    }
}




class $c730816d5606c5af$export$bc4223862310c4b0 extends (0, $7d54780cec51edb2$export$ee5d620451301784) {
    async lock() {
        await this.clientRegistryService.lock();
        this.setRegistry({
            locked: true
        });
    }
    async unlock() {
        await this.clientRegistryService.unlock();
        this.setRegistry({
            locked: false
        });
    }
    async invoke() {
        await ((0, $823726049107e73f$export$790f9bc128365008)(this.getState()) ? this.unlock() : this.lock());
    }
}








const $21b7c86397064168$var$canReadSystemInfo = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).MINIMUM);
class $21b7c86397064168$export$e06008d9aaa2eb61 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    async getVersions() {
        if (!$21b7c86397064168$var$canReadSystemInfo(this.getState())) return null;
        try {
            return await this.systemService.fetchVersions();
        } catch (e) {
            return e;
        }
    }
    async loadVersions() {
        const versions = await this.getVersions();
        const { versions: oldVersions } = this.getState();
        if (oldVersions !== versions) this.setState({
            versions: versions
        });
    }
    getUIVersion() {
        return this.systemService.getUIVersion();
    }
}



class $7632700fddf3b4c2$export$b9a4e54d778faf41 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    /**
     * This function should only be manually called
     */ invoke() {
        this.getUsecase((0, $d966f49311c5b2c6$export$fa306862f2d2d024)).logout((0, $3f24850e5c974db2$export$55e75bec2b906c5e).MANUAL_LOGOUT);
        /**
         * Reloading the page should do it
         */ this.browserService.reload();
    }
}





class $17621bb86b7cb19e$export$efa12ff798aaac14 extends (0, $091d28ec500ee607$export$e35eeca9ac01af15) {
    constructor(...args){
        super(...args), this.pageName = 'volumes', this.pageAddress = 'volumesPage', this.initialSortColumn = 'service';
    }
}
class $17621bb86b7cb19e$export$b0a4e1d7d8e4aad2 extends (0, $7b9515791776b163$export$8dbd5db7aa48881c) {
    constructor(...args){
        super(...args), this.singularName = 'volume', this.singleAddress = 'volume';
    }
}




class $829a2e124375045d$export$813f6e3ddca432a1 extends (0, $0e262b77192f27d5$export$f708ad0ed4e537ba) {
    selectVolumes(ids) {
        this.select(ids);
    }
    delete() {
        return super.delete();
    }
    constructor(...args){
        super(...args), this.type = (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).VOLUME;
    }
}






class $5c96601186f32a60$export$ca496f402ddadc0b extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    toggleSideNavCollapsed() {
        const sideNavCollapsed = (0, $b0991a9a4ef4845f$export$7ee49b75b6d0f0fb)(this.getState());
        this.setState({
            sideNavCollapsed: !sideNavCollapsed
        });
    }
}





const $23355dedb095edf3$var$TOTAL_MAX = 3;
const $23355dedb095edf3$var$SEVERITY_MAX = {
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).INFO]: 1,
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).SUCCESS]: 1,
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).WARNING]: 2,
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).ERROR]: 2
};
/** Lower rank = higher priority = evicted last, higher rank = lower priority = evicted first. */ const $23355dedb095edf3$var$EVICTION_RANK = {
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).ERROR]: 0,
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).WARNING]: 1,
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).INFO]: 2,
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).SUCCESS]: 3
};
class $23355dedb095edf3$export$d0c7efdf5fc0e78d extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    /**
     * Enforces the two caps from the Figma spec that notistack has no equivalent for - its own
     * `maxSnack` is a single severity-blind count that evicts whatever's oldest overall, with no
     * concept of "keep the error, drop the info." This evicts in two independent passes:
     *
     * 1. Per-severity: each severity has its own max (`SEVERITY_MAX` - info/success 1, warning/error
     *    2). A severity over its own max evicts its oldest entry, regardless of what else is queued.
     * 2. Total: the whole queue is capped at `TOTAL_MAX` (3). Over that, the *oldest entry of the
     *    lowest-priority severity currently present* is evicted (`EVICTION_RANK`) - e.g. an info
     *    toast is dropped before a warning or error would be, even if the info arrived more recently.
     *
     * Runs after `show()` has already resolved dedup/aggregation, so `queue` here is the candidate
     * post-aggregation state, not yet guaranteed to respect either cap.
     *
     * A `persist` toast is excluded from both passes entirely - it doesn't count toward either cap's
     * threshold, and is never picked as an eviction candidate. Otherwise unrelated toast traffic could
     * silently evict a toast whose whole contract is "only `dismiss()` removes me".
     */ static applyCaps(queue) {
        let result = queue;
        for (const [severity, max] of (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)($23355dedb095edf3$var$SEVERITY_MAX))while(result.filter((toast)=>toast.severity === severity && !toast.persist).length > max)result = $23355dedb095edf3$export$d0c7efdf5fc0e78d.evictOldestOfSeverity(result, severity);
        while(result.filter((toast)=>!toast.persist).length > $23355dedb095edf3$var$TOTAL_MAX){
            const lowestPresentEntry = (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)($23355dedb095edf3$var$EVICTION_RANK).filter(([severity])=>result.some((toast)=>toast.severity === severity && !toast.persist)).sort(([, rankA], [, rankB])=>rankB - rankA).at(0);
            (0, $14eddac5f20c576c$export$a7a9523472993e97)(lowestPresentEntry, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Toast queue overflowed with no severity to evict', {
                queue: result
            }));
            const [lowestPresentSeverity] = lowestPresentEntry;
            result = $23355dedb095edf3$export$d0c7efdf5fc0e78d.evictOldestOfSeverity(result, lowestPresentSeverity);
        }
        return result;
    }
    /**
     * Never targets a `persist` toast - see `applyCaps` above. Both of `applyCaps`'s call sites
     * already guarantee a matching entry exists before calling this, so a miss here means one of
     * those guards broke, not a normal outcome to fall back from.
     */ static evictOldestOfSeverity(queue, severity) {
        const index = queue.findIndex((toast)=>toast.severity === severity && !toast.persist);
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(index !== -1, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'No non-persistent toast of the given severity to evict', {
            queue: queue,
            severity: severity
        }));
        return [
            ...queue.slice(0, index),
            ...queue.slice(index + 1)
        ];
    }
    /**
     * Enqueues a toast, aggregating into an existing one sharing the same `dedupeKey` (while it's
     * still visible) instead of stacking a duplicate, then applies the per-severity and total caps.
     *
     * Unlike `description`/`action` (intentionally not sticky - each call's own options win outright),
     * `persist` falls back to the existing item's value when the new call omits it. Otherwise a caller
     * that re-fires `show()` for the same `dedupeKey` without repeating `persist: true` would silently
     * un-persist an already-shown toast.
     */ show(options) {
        const id = options.dedupeKey ?? `toast-auto-${this.nextId++}`;
        const queue = (0, $83da31ffcebd71d6$export$8f481e8a25f70299)(this.getState());
        const existing = queue.find((toast)=>toast.id === id);
        const persist = options.persist ?? existing?.persist;
        const item = {
            id: id,
            severity: options.severity,
            title: options.title,
            count: (existing?.count ?? 0) + 1,
            ...options.description !== undefined && {
                description: options.description
            },
            ...options.action !== undefined && {
                action: options.action
            },
            ...persist !== undefined && {
                persist: persist
            }
        };
        const withoutExisting = queue.filter((toast)=>toast.id !== id);
        this.setState({
            toasts: $23355dedb095edf3$export$d0c7efdf5fc0e78d.applyCaps([
                ...withoutExisting,
                item
            ])
        });
    }
    /** Removes a toast, e.g. once the caller-driven auto-dismiss/close affordance fires. */ dismiss(id) {
        this.setState({
            toasts: (0, $83da31ffcebd71d6$export$8f481e8a25f70299)(this.getState()).filter((toast)=>toast.id !== id)
        });
    }
    constructor(...args){
        super(...args), this.nextId = 0;
    }
}




class $d8af8516faa3a51c$export$512d3b631afdca5f extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    /**
     * Shows a banner, unless its `dismissKey` was already dismissed this session and hasn't been
     * `clear`-ed since. At most one banner is ever visible - a new call replaces whatever's
     * currently active. The plan leaves "two simultaneous banner-worthy conditions" unspecified;
     * last-shown-wins is the simplest, most predictable rule absent a spec either way.
     */ show(options) {
        if (this.dismissedKeys.has(options.dismissKey)) return;
        const banner = {
            severity: options.severity,
            title: options.title,
            dismissKey: options.dismissKey,
            ...options.description !== undefined && {
                description: options.description
            },
            ...options.action !== undefined && {
                action: options.action
            }
        };
        this.setState({
            activeBanner: banner
        });
    }
    /**
     * Called by the feature once the underlying condition resolves (e.g. the version mismatch is
     * fixed) - forgets the dismissal for `dismissKey`, so a future recurrence of the condition
     * shows the banner again ("reappears if condition persists"), and hides it now if it's the one
     * currently active (the condition it represents is gone, so it shouldn't still be shown).
     */ clear(dismissKey) {
        this.dismissedKeys.delete(dismissKey);
        if ((0, $39d33484e8b79466$export$6909fb9b4ba29917)(this.getState())?.dismissKey === dismissKey) this.setState({
            activeBanner: null
        });
    }
    /**
     * User-initiated dismiss (the banner's own close button) - suppresses it until `clear` is
     * called for its `dismissKey`. Not in the plan's illustrative `BannerUsecase` sketch (`show`/
     * `clear` only), but necessary: `clear` is the *feature's* signal that a condition resolved,
     * distinct from the *user* asking to stop seeing a still-active one.
     */ dismiss() {
        const banner = (0, $39d33484e8b79466$export$6909fb9b4ba29917)(this.getState());
        if (!banner) return;
        this.dismissedKeys.add(banner.dismissKey);
        this.setState({
            activeBanner: null
        });
    }
    constructor(...args){
        super(...args), /**
     * Not `AppState`: nothing renders off this directly, it's session-scoped bookkeeping local to
     * this usecase instance (which itself lives for the app session), mirroring `ToastUsecase`'s
     * `nextId` counter.
     */ this.dismissedKeys = new Set();
    }
}




const $6c70a06b05004cbe$var$EVENT_TOAST_MAX = 3;
class $6c70a06b05004cbe$export$90c58c964fe09549 extends (0, $dfd5a49efac3fdb6$export$7f62ee5070458a6d) {
    static appendEventToast(queue, item) {
        const appended = [
            ...queue,
            item
        ];
        return appended.length > $6c70a06b05004cbe$var$EVENT_TOAST_MAX ? appended.slice(appended.length - $6c70a06b05004cbe$var$EVENT_TOAST_MAX) : appended;
    }
    /** Only writes when the count actually changed - a redelivered-but-unchanged snapshot shouldn't reset the renderer's dismiss timer, or resurrect a toast the user already dismissed at that same total. */ refreshCounter(totalCount) {
        if (totalCount <= 0) {
            this.lastCounterCount = null;
            if ((0, $326a003cf0269e2b$export$e4e9003e796cb10)(this.getState()) !== null) this.setState({
                deviationCounterToast: null
            });
        } else if (totalCount !== this.lastCounterCount) {
            this.lastCounterCount = totalCount;
            this.setState({
                deviationCounterToast: {
                    count: totalCount
                }
            });
        }
    }
    /**
     * The first call only seeds the "already seen" baseline, so pre-existing deviations at
     * login/mount don't each fire a "new" event toast. Later calls emit one per newly-appeared id.
     */ syncDeviations(current, totalCount) {
        const currentIds = new Set(current.map(({ id: id })=>id));
        const previousIds = this.seenIds;
        this.seenIds = currentIds;
        if (previousIds === undefined) return;
        const newIds = current.filter(({ id: id })=>!previousIds.has(id));
        if (newIds.length > 0) {
            let queue = (0, $326a003cf0269e2b$export$8cce705316c4c043)(this.getState());
            for (const { id: serviceId } of newIds)queue = $6c70a06b05004cbe$export$90c58c964fe09549.appendEventToast(queue, {
                id: `deviation-event-${this.nextEventId++}`,
                kind: 'new',
                serviceId: serviceId
            });
            this.setState({
                deviationEventToasts: queue
            });
        }
        this.refreshCounter(totalCount);
    }
    /** Reacts to a single resolution event (`serviceDeviationResolution`). */ notifyResolved(resolution, totalCount) {
        const queue = $6c70a06b05004cbe$export$90c58c964fe09549.appendEventToast((0, $326a003cf0269e2b$export$8cce705316c4c043)(this.getState()), {
            id: `deviation-event-${this.nextEventId++}`,
            kind: 'resolved',
            serviceId: resolution.id
        });
        this.setState({
            deviationEventToasts: queue
        });
        this.refreshCounter(totalCount);
    }
    dismissEvent(id) {
        this.setState({
            deviationEventToasts: (0, $326a003cf0269e2b$export$8cce705316c4c043)(this.getState()).filter((item)=>item.id !== id)
        });
    }
    dismissCounter() {
        if ((0, $326a003cf0269e2b$export$e4e9003e796cb10)(this.getState()) !== null) this.setState({
            deviationCounterToast: null
        });
    }
    constructor(...args){
        super(...args), this.nextEventId = 0, /**
     * The total the counter toast was last set to show, kept even after `dismissCounter()` clears the
     * live toast - so a later snapshot reporting that same total (a poll redelivery, or the backend
     * simply not having changed yet) doesn't resurrect a toast the user just closed. Only a genuinely
     * different total re-shows it.
     */ this.lastCounterCount = null;
    }
}





const $08f633a474e8a160$export$32fa1abc5072a856 = (services)=>{
    const registry = new Map();
    return {
        workbenchUsecase: new (0, $f42c02287403bd2f$export$f0607a650dd17548)(registry, services),
        versionUsecase: new (0, $21b7c86397064168$export$e06008d9aaa2eb61)(registry, services),
        fixVersionUsecase: new (0, $7632700fddf3b4c2$export$b9a4e54d778faf41)(registry, services),
        contactInformationUsecase: new (0, $714093a85438e59a$export$737c0d09687bf83)(registry, services),
        documentationUsecase: new (0, $bbb61d36f4d51eb7$export$3604546ce70513ee)(registry, services),
        copyValueUsecase: new (0, $8d2339ea31d240b8$export$4f02a29151aff02e)(registry, services),
        getApplicationMetadataUsecase: new (0, $59ededb85d1c8ccc$export$4eebe38be93527e2)(registry, services),
        debugApplicationUsecase: new (0, $592bbc806a799909$export$fe00d82501efb7f)(registry, services),
        fixNetworkIssueUsecase: new (0, $33fc77a964f7feac$export$770033b3343598b1)(registry, services),
        isStorybookEnabledUsecase: new (0, $369f0092d3cd4076$export$abab701c949ec279)(registry, services),
        loginFormUsecase: new (0, $27e30e4f11bba5f5$export$3c74c9e5f718dd43)(registry, services),
        loginFromPersistenceUsecase: new (0, $ecac7cf418cabc4a$export$b85e58149769aeec)(registry, services),
        loginFromTokenUsecase: new (0, $30bf46dab521b87e$export$e6e5d48cb04d8be7)(registry, services),
        logoutUsecase: new (0, $d966f49311c5b2c6$export$fa306862f2d2d024)(registry, services),
        missingPermissionsUsecase: new (0, $a6227f026526b8f9$export$1c9acd11ed646f2a)(registry, services),
        ssoLoginUsecase: new (0, $60f029876a050e15$export$ee2df158a740437b)(registry, services),
        loadUserManagementDataUsecase: new (0, $bfe27f193238fc66$export$db0863e6288a9df5)(registry, services),
        filterUserManagementUsecase: new (0, $41df092f4f0a1f9c$export$ddc038420000b938)(registry, services),
        editUserUsecase: new (0, $5f34ca3f0e83d4c2$export$8b40dc8823a18741)(registry, services),
        createUserUsecase: new (0, $5f34ca3f0e83d4c2$export$b1f054f60d0c85ca)(registry, services),
        editRoleUsecase: new (0, $39045d52f9d3c3b0$export$7f0e6111b666129c)(registry, services),
        createRoleUsecase: new (0, $39045d52f9d3c3b0$export$550648d575c2043c)(registry, services),
        viewPermissionUsecase: new (0, $d987ba8160d3c875$export$17d852bed71d3fbc)(registry, services),
        loadClientRegistryUsecase: new (0, $acc1a4d6b2b220d2$export$a698fe06a7ad2b37)(registry, services),
        toggleLockClientRegistryUsecase: new (0, $c730816d5606c5af$export$bc4223862310c4b0)(registry, services),
        allowClientRegistryRequestUsecase: new (0, $2bf33eb0bf0fbdea$export$eeebada583410990)(registry, services),
        loadLicenseUsecase: new (0, $ef665ec08d8118d5$export$1fd058a6ebf61da4)(registry, services),
        refreshLicenseUsecase: new (0, $132603bfd94225ab$export$c5c63131585c5dbf)(registry, services),
        uploadLicenseFileUsecase: new (0, $f21a2f90dab85fd1$export$7676a1a67dcc47ac)(registry, services),
        licenseViewUsecase: new (0, $f2b5b70bb2712bac$export$c03faae1a902cd5)(registry, services),
        informationUsecase: new (0, $205a20edbb49a521$export$b20d894ccd4f1010)(registry, services),
        manageServiceUsecase: new (0, $e679292292d11002$export$9e78756881ac13d3)(registry, services),
        manageServicesUsecase: new (0, $e679292292d11002$export$652d47937221c0d3)(registry, services),
        manageDeviatedServicesUsecase: new (0, $c5fc0bc2176d87eb$export$38a5d37aaeaa9d4e)(registry, services),
        manageServicesDeviationsUsecase: new (0, $c5fc0bc2176d87eb$export$e4252105eea16419)(registry, services),
        manageResolvedDeviationsUsecase: new (0, $c5fc0bc2176d87eb$export$6d028bace09f449e)(registry, services),
        manageResourcesDeviationsUsecase: new (0, $c5fc0bc2176d87eb$export$a2f2c11b4ce5a38d)(registry, services),
        addServiceUsecase: new (0, $a9691f5263be09de$export$476bdbc176e45bb7)(registry, services),
        updateServiceUsecase: new (0, $a9691f5263be09de$export$930caa99762afdf7)(registry, services),
        downloadServiceUsecase: new (0, $acde661cae8a73e6$export$d1aa369c4019c3fe)(registry, services),
        bulkDeleteServicesUsecase: new (0, $fca0e20a867708b2$export$f287c93e6c7814b4)(registry, services),
        bulkDisableServicesUsecase: new (0, $fca0e20a867708b2$export$cd4b460e847871d0)(registry, services),
        bulkEnableServiceUsecase: new (0, $fca0e20a867708b2$export$28177f047669ef54)(registry, services),
        manageServicesLinksUsecase: new (0, $538dd376b6e87339$export$c4a0d7f2e2f54e38)(registry, services),
        manageServicesTopicsUsecase: new (0, $9bcefb50f61c7c5d$export$d45b66011487aa66)(registry, services),
        loadServiceDataUsecase: new (0, $9bcefb50f61c7c5d$export$1965641b4bc55f16)(registry, services),
        manageConnectionsUsecase: new (0, $786ede0f790131ed$export$725078b289d38018)(registry, services),
        manageConnectionUsecase: new (0, $786ede0f790131ed$export$d52ef41ed3cfe093)(registry, services),
        bulkDeleteConnectionsUsecase: new (0, $13bccdb70e276f41$export$77a6c0350e13812d)(registry, services),
        bulkConnectConnectionsUsecase: new (0, $13bccdb70e276f41$export$137d2798b408ef65)(registry, services),
        bulkDisconnectConnectionsUsecase: new (0, $13bccdb70e276f41$export$7d251909b6893d6d)(registry, services),
        manageMappingUsecase: new (0, $8b415a0d347ab5d0$export$92f6df4d2f32ffce)(registry, services),
        manageMappingsUsecase: new (0, $8b415a0d347ab5d0$export$1083aa9fdf5829f5)(registry, services),
        bulkDeleteMappingsUsecase: new (0, $c0e2f934224b5999$export$2913a7396a5786f1)(registry, services),
        bulkEnableMappingsUsecase: new (0, $c0e2f934224b5999$export$c851b6c1d1d47051)(registry, services),
        bulkDisableMappingsUsecase: new (0, $c0e2f934224b5999$export$52b82e0d67fb33bc)(registry, services),
        subscribeToMappingEntriesUsecase: new (0, $748ce78486da5d49$export$bf84beddf0495a4)(registry, services),
        manageEndpointUsecase: new (0, $7620686f4015eec2$export$f8b467ddc4f01b08)(registry, services),
        manageEndpointsUsecase: new (0, $7620686f4015eec2$export$f86de92dc4c171dd)(registry, services),
        bulkDeleteEndpointsUsecase: new (0, $194a812251685b25$export$4f5930e2feb65d89)(registry, services),
        bulkEnableEndpointsUsecase: new (0, $194a812251685b25$export$b3c8b51f94117509)(registry, services),
        bulkDisableEndpointsUsecase: new (0, $194a812251685b25$export$14e9645d73dfa711)(registry, services),
        manageVolumeUsecase: new (0, $17621bb86b7cb19e$export$b0a4e1d7d8e4aad2)(registry, services),
        manageVolumesUsecase: new (0, $17621bb86b7cb19e$export$efa12ff798aaac14)(registry, services),
        bulkDeleteVolumesUsecase: new (0, $829a2e124375045d$export$813f6e3ddca432a1)(registry, services),
        manageServiceContainerUsecase: new (0, $d3733d28ed2b022e$export$868018c72176e16d)(registry, services),
        manageServiceContainersUsecase: new (0, $d3733d28ed2b022e$export$c223af5fb83cd500)(registry, services),
        bulkDeleteServiceContainersUsecase: new (0, $f2c1a77a86e27d7a$export$8c494260e69be049)(registry, services),
        bulkRestartServiceContainersUsecase: new (0, $f2c1a77a86e27d7a$export$929d4e4c5b8aba68)(registry, services),
        bulkStartServiceContainersUsecase: new (0, $f2c1a77a86e27d7a$export$3d8e4c7d5151a1ce)(registry, services),
        bulkStopServiceContainersUsecase: new (0, $f2c1a77a86e27d7a$export$5986bef2c14dd5ce)(registry, services),
        manageCoreContainerUsecase: new (0, $d3733d28ed2b022e$export$bd35bb1fbc92938b)(registry, services),
        manageCoreContainersUsecase: new (0, $d3733d28ed2b022e$export$287a47aae54878de)(registry, services),
        bulkRestartCoreContainersUsecase: new (0, $f2c1a77a86e27d7a$export$8bb9a9960692ab55)(registry, services),
        bulkStartCoreContainersUsecase: new (0, $f2c1a77a86e27d7a$export$590ca45b01504df4)(registry, services),
        bulkStopCoreContainersUsecase: new (0, $f2c1a77a86e27d7a$export$d0ae5960553fc4c2)(registry, services),
        manageServersUsecase: new (0, $e682fcc2d82bf100$export$950299f2a639da2a)(registry, services),
        manageServerUsecase: new (0, $e682fcc2d82bf100$export$7a8666f771e4c5e2)(registry, services),
        bulkDeleteServersUsecase: new (0, $007471c0df8f0447$export$7cf59b3f0a998671)(registry, services),
        bulkDisableServersUsecase: new (0, $007471c0df8f0447$export$66587697d3b6889e)(registry, services),
        bulkEnableServersUsecase: new (0, $007471c0df8f0447$export$a3e78906f2e4947d)(registry, services),
        manageNodesUsecase: new (0, $826cebeef3327334$export$ae3399c13a1383bd)(registry, services),
        containerLogsUsecase: new (0, $e2de68e8ae0b3ea0$export$64ef4a449b44fc83)(registry, services),
        startExplorerSubscriptionUsecase: new (0, $d58a394b070f3fda$export$53155f88f59532cd)(registry, services),
        explorerChunksUsecase: new (0, $684496fd7538c52c$export$798476376223da07)(registry, services),
        updateExplorerTailUsecase: new (0, $4fa4a5f54ae63c72$export$963a2d26686e7d38)(registry, services),
        explorerTopicsFormattingUsecase: new (0, $08e00ffa0eeed96c$export$325f1a7e8fa6b185)(registry, services),
        explorerTopicManagementUsecase: new (0, $ac00f283016f694b$export$a3fd79364ed8bf15)(registry, services),
        startSandboxUsecase: new (0, $f36042338fcbfc5a$export$f31d6abbcd8ccb6d)(registry, services),
        filterSandboxUsecase: new (0, $cb52a4d79dfa72c0$export$d0e996463cd681f7)(registry, services),
        subscribeToMessagesSandboxUsecase: new (0, $305d42c991a29d63$export$642511a9467880eb)(registry, services),
        transformSandboxUsecase: new (0, $86a88cf7ed95e874$export$466279f3cec52b3d)(registry, services),
        systemMetricsUsecase: new (0, $7ebee1b5ffb99c69$export$e1eac928f4286631)(registry, services),
        manageAgentsUsecase: new (0, $69bdcfe0730f0c80$export$d45a5d6c8b3bcf3a)(registry, services),
        bulkDeleteAgentsUsecase: new (0, $549ff04f846b6ac9$export$3843f9bb6288bf65)(registry, services),
        loadCertificatesUsecase: new (0, $28cce69de8681ba2$export$cc7ee9e47b833334)(registry, services),
        addCertificateUsecase: new (0, $e9a16ecf1d738e89$export$f16b64f165132257)(registry, services),
        downloadCertificateUsecase: new (0, $1dfb6cd6e9e608fa$export$a5326e373df9bdd2)(registry, services),
        deleteCertificateUsecase: new (0, $ade1129b818a4d6f$export$eebbe27d8fa9c283)(registry, services),
        loadingUsecase: new (0, $a6de2e88b5226ac8$export$dd06ffc7864da99f)(registry, services),
        navigationUsecase: new (0, $5c96601186f32a60$export$ca496f402ddadc0b)(registry, services),
        tableColumnViewUsecase: new (0, $dd699a9573945acf$export$1a43191552cf8b55)(registry, services),
        recordPanelWidthUsecase: new (0, $d1487aa97c1342bd$export$f317445fff1075c8)(registry, services),
        toastUsecase: new (0, $23355dedb095edf3$export$d0c7efdf5fc0e78d)(registry, services),
        bannerUsecase: new (0, $d8af8516faa3a51c$export$512d3b631afdca5f)(registry, services),
        deviationToastsUsecase: new (0, $6c70a06b05004cbe$export$90c58c964fe09549)(registry, services),
        changePasswordUsecase: new (0, $a3c473cf3c5a58ef$export$7c5910b04f454619)(registry, services),
        enableMfaUsecase: new (0, $bca103a784110feb$export$9a92766468cfcb94)(registry, services),
        loadMfaSettingsUsecase: new (0, $32624675c0ac9ba4$export$a74b0dc6865b503c)(registry, services),
        regenerateMfaBackupCodesUsecase: new (0, $066a0a5a67673b88$export$688f87bf310930a6)(registry, services),
        disableMfaUsecase: new (0, $e4342e4754a974b7$export$83b462fd81279800)(registry, services),
        enforceMfaUsageUsecase: new (0, $29f5a48fd1fa0c87$export$54ddab5945e83186)(registry, services)
    };
};









var $h4Bez = parcelRequire("h4Bez");
const $a1a6d7d0f76ede8d$export$902abe05969bdd53 = (useDependencies, Class, name)=>{
    const namedFunctions = {
        [name]: ()=>{
            const dependencies = useDependencies();
            /** This memo ensures this hook can be used without causing additional re-renders */ return (0, $h4Bez.useMemo)(()=>new Class(...dependencies), dependencies);
        }
    };
    const namedFunction = namedFunctions[name];
    namedFunction.extendClass = (extender)=>extender(Class);
    namedFunction.extend = (extender, name)=>$a1a6d7d0f76ede8d$export$902abe05969bdd53(useDependencies, namedFunction.extendClass(extender), name);
    return namedFunction;
};


const $3dd52092ec4fc8cb$export$eea0c9f46a8cc3f9 = (props, appendage)=>{
    const testId = 'data-testid' in props && typeof props['data-testid'] === 'string' && props['data-testid'] || null;
    if (testId && appendage) return testId + appendage;
    return testId;
};


const $1fdb53e1bec07519$export$13dc79c32630341b = (e, key)=>e.key === key;
const $1fdb53e1bec07519$export$d9ea00e8a3cf8cca = (callback)=>(e)=>$1fdb53e1bec07519$export$13dc79c32630341b(e, 'Enter') && callback(e);
const $1fdb53e1bec07519$export$5532d7f774835bb3 = (callback)=>(e)=>{
        e.stopPropagation();
        callback?.(e);
    };
const $1fdb53e1bec07519$export$a5a34735bf65cdae = (ref)=>()=>ref.current?.click();


var $3c020485cc581d15$exports = {};
function $3c020485cc581d15$var$readAs(file, as) {
    if (!(file instanceof Blob)) throw new TypeError('Must be a File or Blob');
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function(e) {
            resolve(e.target.result);
        };
        reader.onerror = function(e) {
            reject(new Error('Error reading' + file.name + ': ' + e.target.result));
        };
        reader['readAs' + as](file);
    });
}
function $3c020485cc581d15$var$readAsDataURL(file) {
    return $3c020485cc581d15$var$readAs(file, 'DataURL');
}
function $3c020485cc581d15$var$readAsText(file) {
    return $3c020485cc581d15$var$readAs(file, 'Text');
}
function $3c020485cc581d15$var$readAsArrayBuffer(file) {
    return $3c020485cc581d15$var$readAs(file, 'ArrayBuffer');
}
$3c020485cc581d15$exports = {
    readAsDataURL: $3c020485cc581d15$var$readAsDataURL,
    readAsText: $3c020485cc581d15$var$readAsText,
    readAsArrayBuffer: $3c020485cc581d15$var$readAsArrayBuffer
};



const $ebef08300a7156b3$export$7dc2912951b09f = (file)=>(0, $3c020485cc581d15$exports.readAsText)(file).catch((e)=>Promise.reject(new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, e.message)));




const $2371d85f76b63637$export$925a4c3537ec7ca4 = ([file])=>file ? (0, $ebef08300a7156b3$export$7dc2912951b09f)(file) : Promise.resolve(null);



var $h4Bez = parcelRequire("h4Bez");
const $9dfd779a84325298$export$aa7f9ebe4f644d13 = ()=>(0, $h4Bez.useReducer)((attempt)=>attempt + 1, 0);




var $h4Bez = parcelRequire("h4Bez");
const $fcbbb67d63dcd76b$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $fcbbb67d63dcd76b$export$f51a9068ac82ea43 = (createState)=>createState ? $fcbbb67d63dcd76b$var$createStoreImpl(createState) : $fcbbb67d63dcd76b$var$createStoreImpl;



var $h4Bez = parcelRequire("h4Bez");
var $8f1a4e972523e5c7$exports = {};
'use strict';

$8f1a4e972523e5c7$exports = (parcelRequire("US4vK"));



const { useSyncExternalStoreWithSelector: $88ab338bfce17fad$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($8f1a4e972523e5c7$exports)));
const $88ab338bfce17fad$var$identity = (arg)=>arg;
function $88ab338bfce17fad$export$2951cba41945c0c8(api, selector = $88ab338bfce17fad$var$identity, equalityFn) {
    const slice = $88ab338bfce17fad$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getInitialState, selector, equalityFn);
    (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).useDebugValue(slice);
    return slice;
}
const $88ab338bfce17fad$var$createWithEqualityFnImpl = (createState, defaultEqualityFn)=>{
    const api = (0, $fcbbb67d63dcd76b$export$f51a9068ac82ea43)(createState);
    const useBoundStoreWithEqualityFn = (selector, equalityFn = defaultEqualityFn)=>$88ab338bfce17fad$export$2951cba41945c0c8(api, selector, equalityFn);
    Object.assign(useBoundStoreWithEqualityFn, api);
    return useBoundStoreWithEqualityFn;
};
const $88ab338bfce17fad$export$c883e057baa24e24 = (createState, defaultEqualityFn)=>createState ? $88ab338bfce17fad$var$createWithEqualityFnImpl(createState, defaultEqualityFn) : $88ab338bfce17fad$var$createWithEqualityFnImpl;




const $08b3e6ee09ecfd12$var$areResultsEqual = (previous, current, filter)=>{
    const result = filter(previous, current);
    return typeof result === 'boolean' ? result : result === filter(current, previous);
};
class $08b3e6ee09ecfd12$export$b20e70bc564b1116 {
    constructor(state){
        this.store = (0, $fcbbb67d63dcd76b$export$f51a9068ac82ea43)()(()=>state);
    }
    /**
     * Read-only on purpose: writes go through `setState`, so a subclass can wrap every one of them
     */ get api() {
        return this.store;
    }
    getState() {
        return this.store.getState();
    }
    /**
     * Always notifies, even when `state` is the current state object, which Zustand alone would skip
     */ setState(state) {
        this.store.setState({
            ...state
        });
    }
    subscribe(...args) {
        const [filter, subscriber] = args.length === 1 ? [
            ()=>false,
            args[0]
        ] : args;
        /**
         * Kept per subscriber rather than taken from Zustand's `previous`,
         * so a `setState` nested in a subscriber doesn't hand later subscribers an older pair
         */ let previous = this.store.getState();
        return this.store.subscribe(()=>{
            const current = this.store.getState();
            if (!$08b3e6ee09ecfd12$var$areResultsEqual(previous, current, filter)) subscriber();
            previous = current;
        });
    }
}
const $08b3e6ee09ecfd12$var$selectState = (props)=>'value' in props ? props.value : props.manager.getState();
const $08b3e6ee09ecfd12$export$e50ad042342a539d = ({ ignorePropsChanges: ignorePropsChanges = false } = {})=>{
    const Context = /*#__PURE__*/ (0, $h4Bez.createContext)(null);
    const useManager = (caller)=>{
        const manager = (0, $h4Bez.useContext)(Context);
        if (manager === null) throw (0, $ea3ab9f98af64a6e$export$3a769f39d361ea9a)(new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Extended state must be used within its Provider'), caller);
        return manager;
    };
    const Provider = ({ children: children, ...props })=>{
        const [manager] = (0, $h4Bez.useState)(()=>'value' in props ? new $08b3e6ee09ecfd12$export$b20e70bc564b1116(props.value) : props.manager);
        (0, $h4Bez.useLayoutEffect)(()=>{
            const state = $08b3e6ee09ecfd12$var$selectState(props);
            if (!ignorePropsChanges && state !== manager.getState()) manager.setState(state);
        }, [
            'value' in props ? props.value : props.manager
        ]);
        return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Context.Provider, {
            value: manager,
            children: children
        });
    };
    const useExtendedState = (...[selector, ...rest])=>{
        const manager = useManager(useExtendedState);
        const filter = rest.find((arg)=>typeof arg === 'function') ?? null;
        const dependencies = rest.find((arg)=>Array.isArray(arg)) ?? [];
        const select = (0, $h4Bez.useCallback)(selector, [
            manager,
            ...dependencies
        ]);
        const committedSelect = (0, $h4Bez.useRef)(select);
        (0, $h4Bez.useLayoutEffect)(()=>{
            committedSelect.current = select;
        });
        /**
         * Skips the filter in the render where `select` changed, so the new selection is applied rather than compared with the old one
         */ const isEqual = (0, $h4Bez.useCallback)((previous, current)=>previous === current || filter !== null && committedSelect.current === select && $08b3e6ee09ecfd12$var$areResultsEqual(current, previous, filter), [
            select
        ]);
        return (0, $88ab338bfce17fad$export$2951cba41945c0c8)(manager.api, select, isEqual);
    };
    const useExtendedStateDispatcher = ()=>{
        const manager = useManager(useExtendedStateDispatcher);
        return (0, $h4Bez.useCallback)((newStateOrGenerator)=>manager.setState(typeof newStateOrGenerator === 'function' ? newStateOrGenerator(manager.getState()) : newStateOrGenerator), [
            manager
        ]);
    };
    return {
        Provider: Provider,
        useExtendedState: useExtendedState,
        useExtendedStateDispatcher: useExtendedStateDispatcher
    };
};





parcelRequire("h4Bez");




var $h4Bez = parcelRequire("h4Bez");
var $53ec8e624a52d9bc$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $53ec8e624a52d9bc$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $53ec8e624a52d9bc$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $53ec8e624a52d9bc$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$53ec8e624a52d9bc$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($53ec8e624a52d9bc$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $53ec8e624a52d9bc$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


/**
 * @param {number}
 * @return {number}
 */ var $e1697c988887a76c$export$2335f513bbd82c6d = Math.abs;
var $e1697c988887a76c$export$6788812c4e6611e6 = String.fromCharCode;
var $e1697c988887a76c$export$e6e34fd1f2686227 = Object.assign;
function $e1697c988887a76c$export$d6af199866bfb566(value, length) {
    return $e1697c988887a76c$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $e1697c988887a76c$export$a9db5e087081082d(value, 0)) << 2 ^ $e1697c988887a76c$export$a9db5e087081082d(value, 1)) << 2 ^ $e1697c988887a76c$export$a9db5e087081082d(value, 2)) << 2 ^ $e1697c988887a76c$export$a9db5e087081082d(value, 3) : 0;
}
function $e1697c988887a76c$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $e1697c988887a76c$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $e1697c988887a76c$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $e1697c988887a76c$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $e1697c988887a76c$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $e1697c988887a76c$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $e1697c988887a76c$export$36776f635604f274(value) {
    return value.length;
}
function $e1697c988887a76c$export$f9084667e487ed46(value) {
    return value.length;
}
function $e1697c988887a76c$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $e1697c988887a76c$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}


var $3507b6f740af8b0b$export$53f1d5ea8de3d7c = 1;
var $3507b6f740af8b0b$export$4e0c71f277ca26b3 = 1;
var $3507b6f740af8b0b$export$f24224f1c91d8156 = 0;
var $3507b6f740af8b0b$export$5880b8b5730aff45 = 0;
var $3507b6f740af8b0b$export$c0306caf338ac095 = 0;
var $3507b6f740af8b0b$export$30a86d91af8ff6e6 = '';
function $3507b6f740af8b0b$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $3507b6f740af8b0b$export$53f1d5ea8de3d7c,
        column: $3507b6f740af8b0b$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $3507b6f740af8b0b$export$784d13d8ee351f07(root, props) {
    return (0, $e1697c988887a76c$export$e6e34fd1f2686227)($3507b6f740af8b0b$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $3507b6f740af8b0b$export$eba6f6f03b0a92e7() {
    return $3507b6f740af8b0b$export$c0306caf338ac095;
}
function $3507b6f740af8b0b$export$232faf9add678146() {
    $3507b6f740af8b0b$export$c0306caf338ac095 = $3507b6f740af8b0b$export$5880b8b5730aff45 > 0 ? (0, $e1697c988887a76c$export$a9db5e087081082d)($3507b6f740af8b0b$export$30a86d91af8ff6e6, --$3507b6f740af8b0b$export$5880b8b5730aff45) : 0;
    if ($3507b6f740af8b0b$export$4e0c71f277ca26b3--, $3507b6f740af8b0b$export$c0306caf338ac095 === 10) $3507b6f740af8b0b$export$4e0c71f277ca26b3 = 1, $3507b6f740af8b0b$export$53f1d5ea8de3d7c--;
    return $3507b6f740af8b0b$export$c0306caf338ac095;
}
function $3507b6f740af8b0b$export$48cfd1e771a65c4f() {
    $3507b6f740af8b0b$export$c0306caf338ac095 = $3507b6f740af8b0b$export$5880b8b5730aff45 < $3507b6f740af8b0b$export$f24224f1c91d8156 ? (0, $e1697c988887a76c$export$a9db5e087081082d)($3507b6f740af8b0b$export$30a86d91af8ff6e6, $3507b6f740af8b0b$export$5880b8b5730aff45++) : 0;
    if ($3507b6f740af8b0b$export$4e0c71f277ca26b3++, $3507b6f740af8b0b$export$c0306caf338ac095 === 10) $3507b6f740af8b0b$export$4e0c71f277ca26b3 = 1, $3507b6f740af8b0b$export$53f1d5ea8de3d7c++;
    return $3507b6f740af8b0b$export$c0306caf338ac095;
}
function $3507b6f740af8b0b$export$4d3fb11e950abb9e() {
    return (0, $e1697c988887a76c$export$a9db5e087081082d)($3507b6f740af8b0b$export$30a86d91af8ff6e6, $3507b6f740af8b0b$export$5880b8b5730aff45);
}
function $3507b6f740af8b0b$export$e88cb2efb12ae807() {
    return $3507b6f740af8b0b$export$5880b8b5730aff45;
}
function $3507b6f740af8b0b$export$58adb3bec8346d0f(begin, end) {
    return (0, $e1697c988887a76c$export$2f35ab04d2335697)($3507b6f740af8b0b$export$30a86d91af8ff6e6, begin, end);
}
function $3507b6f740af8b0b$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $3507b6f740af8b0b$export$2de70f21292aac9e(value) {
    return $3507b6f740af8b0b$export$53f1d5ea8de3d7c = $3507b6f740af8b0b$export$4e0c71f277ca26b3 = 1, $3507b6f740af8b0b$export$f24224f1c91d8156 = (0, $e1697c988887a76c$export$36776f635604f274)($3507b6f740af8b0b$export$30a86d91af8ff6e6 = value), $3507b6f740af8b0b$export$5880b8b5730aff45 = 0, [];
}
function $3507b6f740af8b0b$export$45918ac1574455b1(value) {
    return $3507b6f740af8b0b$export$30a86d91af8ff6e6 = '', value;
}
function $3507b6f740af8b0b$export$410ac95b9ec204b8(type) {
    return (0, $e1697c988887a76c$export$87c2784dc9fc4ab)($3507b6f740af8b0b$export$58adb3bec8346d0f($3507b6f740af8b0b$export$5880b8b5730aff45 - 1, $3507b6f740af8b0b$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $3507b6f740af8b0b$export$660b2ee2d4fb4eff(value) {
    return $3507b6f740af8b0b$export$45918ac1574455b1($3507b6f740af8b0b$export$5f8c09e3ae6f64e1($3507b6f740af8b0b$export$2de70f21292aac9e(value)));
}
function $3507b6f740af8b0b$export$7af1228ff777d175(type) {
    while($3507b6f740af8b0b$export$c0306caf338ac095 = $3507b6f740af8b0b$export$4d3fb11e950abb9e())if ($3507b6f740af8b0b$export$c0306caf338ac095 < 33) $3507b6f740af8b0b$export$48cfd1e771a65c4f();
    else break;
    return $3507b6f740af8b0b$export$9e1725a4cfeada27(type) > 2 || $3507b6f740af8b0b$export$9e1725a4cfeada27($3507b6f740af8b0b$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $3507b6f740af8b0b$export$5f8c09e3ae6f64e1(children) {
    while($3507b6f740af8b0b$export$48cfd1e771a65c4f())switch($3507b6f740af8b0b$export$9e1725a4cfeada27($3507b6f740af8b0b$export$c0306caf338ac095)){
        case 0:
            (0, $e1697c988887a76c$export$10d8903dec122b9d)($3507b6f740af8b0b$export$c2ab62c7bf24634($3507b6f740af8b0b$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $e1697c988887a76c$export$10d8903dec122b9d)($3507b6f740af8b0b$export$410ac95b9ec204b8($3507b6f740af8b0b$export$c0306caf338ac095), children);
            break;
        default:
            (0, $e1697c988887a76c$export$10d8903dec122b9d)((0, $e1697c988887a76c$export$6788812c4e6611e6)($3507b6f740af8b0b$export$c0306caf338ac095), children);
    }
    return children;
}
function $3507b6f740af8b0b$export$955ba06d119e085e(index, count) {
    while(--count && $3507b6f740af8b0b$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($3507b6f740af8b0b$export$c0306caf338ac095 < 48 || $3507b6f740af8b0b$export$c0306caf338ac095 > 102 || $3507b6f740af8b0b$export$c0306caf338ac095 > 57 && $3507b6f740af8b0b$export$c0306caf338ac095 < 65 || $3507b6f740af8b0b$export$c0306caf338ac095 > 70 && $3507b6f740af8b0b$export$c0306caf338ac095 < 97) break;
    return $3507b6f740af8b0b$export$58adb3bec8346d0f(index, $3507b6f740af8b0b$export$e88cb2efb12ae807() + (count < 6 && $3507b6f740af8b0b$export$4d3fb11e950abb9e() == 32 && $3507b6f740af8b0b$export$48cfd1e771a65c4f() == 32));
}
function $3507b6f740af8b0b$export$c889f2fcc19dbf12(type) {
    while($3507b6f740af8b0b$export$48cfd1e771a65c4f())switch($3507b6f740af8b0b$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $3507b6f740af8b0b$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $3507b6f740af8b0b$export$c889f2fcc19dbf12($3507b6f740af8b0b$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $3507b6f740af8b0b$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $3507b6f740af8b0b$export$48cfd1e771a65c4f();
            break;
    }
    return $3507b6f740af8b0b$export$5880b8b5730aff45;
}
function $3507b6f740af8b0b$export$4254d4e2b3745c4c(type, index) {
    while($3507b6f740af8b0b$export$48cfd1e771a65c4f())// //
    if (type + $3507b6f740af8b0b$export$c0306caf338ac095 === 57) break;
    else if (type + $3507b6f740af8b0b$export$c0306caf338ac095 === 84 && $3507b6f740af8b0b$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $3507b6f740af8b0b$export$58adb3bec8346d0f(index, $3507b6f740af8b0b$export$5880b8b5730aff45 - 1) + '*' + (0, $e1697c988887a76c$export$6788812c4e6611e6)(type === 47 ? type : $3507b6f740af8b0b$export$48cfd1e771a65c4f());
}
function $3507b6f740af8b0b$export$c2ab62c7bf24634(index) {
    while(!$3507b6f740af8b0b$export$9e1725a4cfeada27($3507b6f740af8b0b$export$4d3fb11e950abb9e()))$3507b6f740af8b0b$export$48cfd1e771a65c4f();
    return $3507b6f740af8b0b$export$58adb3bec8346d0f(index, $3507b6f740af8b0b$export$5880b8b5730aff45);
}

var $83734da6875d6b87$export$71ad59f2e432cfe8 = '-ms-';
var $83734da6875d6b87$export$2c0f367103c8d01c = '-moz-';
var $83734da6875d6b87$export$39dfd62a25e0fe93 = '-webkit-';
var $83734da6875d6b87$export$a29989082612d0d9 = 'comm';
var $83734da6875d6b87$export$aa3a2e812ca8570d = 'rule';
var $83734da6875d6b87$export$527d108ccf083c2b = 'decl';
var $83734da6875d6b87$export$d3d35020fa5b54f0 = '@page';
var $83734da6875d6b87$export$500415a86c544f73 = '@media';
var $83734da6875d6b87$export$a763edbf796b780a = '@import';
var $83734da6875d6b87$export$2790aeb8b4e5c826 = '@charset';
var $83734da6875d6b87$export$1cc683e23b84b133 = '@viewport';
var $83734da6875d6b87$export$9447a5efea57e862 = '@supports';
var $83734da6875d6b87$export$ef011b4e114b1fba = '@document';
var $83734da6875d6b87$export$6aad947bda0f3f46 = '@namespace';
var $83734da6875d6b87$export$b44a8529a35fcb60 = '@keyframes';
var $83734da6875d6b87$export$2c16de31893252e6 = '@font-face';
var $83734da6875d6b87$export$3d846dd52e150c6f = '@counter-style';
var $83734da6875d6b87$export$22314bfbb57653fe = '@font-feature-values';
var $83734da6875d6b87$export$d773506282b3cfe6 = '@layer';




function $6a6ea5c0450acde0$export$ef7acd7185315e22(value) {
    return (0, $3507b6f740af8b0b$export$45918ac1574455b1)($6a6ea5c0450acde0$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $3507b6f740af8b0b$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $6a6ea5c0450acde0$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $3507b6f740af8b0b$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $e1697c988887a76c$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $e1697c988887a76c$export$f8e21b1e77979a08)(characters += (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)((0, $3507b6f740af8b0b$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $3507b6f740af8b0b$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $3507b6f740af8b0b$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $3507b6f740af8b0b$export$955ba06d119e085e)((0, $3507b6f740af8b0b$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $3507b6f740af8b0b$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $e1697c988887a76c$export$10d8903dec122b9d)($6a6ea5c0450acde0$export$4a34f930e789283c((0, $3507b6f740af8b0b$export$4254d4e2b3745c4c)((0, $3507b6f740af8b0b$export$48cfd1e771a65c4f)(), (0, $3507b6f740af8b0b$export$e88cb2efb12ae807)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $e1697c988887a76c$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && (0, $e1697c988887a76c$export$36776f635604f274)(characters) - length) (0, $e1697c988887a76c$export$10d8903dec122b9d)(property > 32 ? $6a6ea5c0450acde0$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $6a6ea5c0450acde0$export$f8483753829ec8f3((0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $e1697c988887a76c$export$10d8903dec122b9d)(reference = $6a6ea5c0450acde0$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $6a6ea5c0450acde0$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $e1697c988887a76c$export$a9db5e087081082d)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $6a6ea5c0450acde0$export$98e6a39c04603d36(value, reference, reference, rule && (0, $e1697c988887a76c$export$10d8903dec122b9d)($6a6ea5c0450acde0$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $6a6ea5c0450acde0$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $e1697c988887a76c$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $3507b6f740af8b0b$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $e1697c988887a76c$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $e1697c988887a76c$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $3507b6f740af8b0b$export$4d3fb11e950abb9e)() === 45) characters += (0, $3507b6f740af8b0b$export$410ac95b9ec204b8)((0, $3507b6f740af8b0b$export$48cfd1e771a65c4f)());
                    atrule = (0, $3507b6f740af8b0b$export$4d3fb11e950abb9e)(), offset = length = (0, $e1697c988887a76c$export$36776f635604f274)(type = characters += (0, $3507b6f740af8b0b$export$c2ab62c7bf24634)((0, $3507b6f740af8b0b$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $e1697c988887a76c$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $6a6ea5c0450acde0$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $e1697c988887a76c$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $e1697c988887a76c$export$2f35ab04d2335697)(value, post + 1, post = (0, $e1697c988887a76c$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $e1697c988887a76c$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $3507b6f740af8b0b$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $83734da6875d6b87$export$aa3a2e812ca8570d) : type, props, children, length);
}
function $6a6ea5c0450acde0$export$4a34f930e789283c(value, root, parent) {
    return (0, $3507b6f740af8b0b$export$35059013cd4a06db)(value, root, parent, (0, $83734da6875d6b87$export$a29989082612d0d9), (0, $e1697c988887a76c$export$6788812c4e6611e6)((0, $3507b6f740af8b0b$export$eba6f6f03b0a92e7)()), (0, $e1697c988887a76c$export$2f35ab04d2335697)(value, 2, -2), 0);
}
function $6a6ea5c0450acde0$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $3507b6f740af8b0b$export$35059013cd4a06db)(value, root, parent, (0, $83734da6875d6b87$export$527d108ccf083c2b), (0, $e1697c988887a76c$export$2f35ab04d2335697)(value, 0, length), (0, $e1697c988887a76c$export$2f35ab04d2335697)(value, length + 1, -1), length);
}






function $307dbaf3d9eac44e$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $e1697c988887a76c$export$f9084667e487ed46)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $307dbaf3d9eac44e$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $83734da6875d6b87$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $83734da6875d6b87$export$a763edbf796b780a:
        case 0, $83734da6875d6b87$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $83734da6875d6b87$export$a29989082612d0d9:
            return '';
        case 0, $83734da6875d6b87$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $307dbaf3d9eac44e$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $83734da6875d6b87$export$aa3a2e812ca8570d:
            element.value = element.props.join(',');
    }
    return (0, $e1697c988887a76c$export$36776f635604f274)(children = $307dbaf3d9eac44e$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $14e3b48315207df6$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $e1697c988887a76c$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + value;
        // tab-size
        case 4789:
            return (0, $83734da6875d6b87$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$2c0f367103c8d01c) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $e1697c988887a76c$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $e1697c988887a76c$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + 'box-' + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)((0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)((0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)((0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $e1697c988887a76c$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $e1697c988887a76c$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $e1697c988887a76c$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $e1697c988887a76c$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span') ? value : (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $e1697c988887a76c$export$f8e21b1e77979a08)(children, 'span') ? (0, $e1697c988887a76c$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $e1697c988887a76c$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $e1697c988887a76c$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $e1697c988887a76c$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)((0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $e1697c988887a76c$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $e1697c988887a76c$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $e1697c988887a76c$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $83734da6875d6b87$export$2c0f367103c8d01c) + ((0, $e1697c988887a76c$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $e1697c988887a76c$export$f8e21b1e77979a08)(value, 'stretch') ? $14e3b48315207df6$export$82e9f45cca5ba907((0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $e1697c988887a76c$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $83734da6875d6b87$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $e1697c988887a76c$export$a9db5e087081082d)(value, (0, $e1697c988887a76c$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + ((0, $e1697c988887a76c$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $83734da6875d6b87$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $db97acbc9227fc9b$export$5a7767152ae0305f(collection) {
    var length = (0, $e1697c988887a76c$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $db97acbc9227fc9b$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $db97acbc9227fc9b$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $83734da6875d6b87$export$527d108ccf083c2b:
                element.return = (0, $14e3b48315207df6$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $83734da6875d6b87$export$b44a8529a35fcb60:
                return (0, $307dbaf3d9eac44e$export$dfdc1655ccc5b9cb)([
                    (0, $3507b6f740af8b0b$export$784d13d8ee351f07)(element, {
                        value: (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $83734da6875d6b87$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $83734da6875d6b87$export$aa3a2e812ca8570d:
                if (element.length) return (0, $e1697c988887a76c$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $e1697c988887a76c$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $307dbaf3d9eac44e$export$dfdc1655ccc5b9cb)([
                                (0, $3507b6f740af8b0b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $83734da6875d6b87$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $307dbaf3d9eac44e$export$dfdc1655ccc5b9cb)([
                                (0, $3507b6f740af8b0b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $3507b6f740af8b0b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $83734da6875d6b87$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $3507b6f740af8b0b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $db97acbc9227fc9b$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $83734da6875d6b87$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $e1697c988887a76c$export$1be1fc439b849fdf)((0, $3507b6f740af8b0b$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $e1697c988887a76c$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $e1697c988887a76c$export$2f35ab04d2335697)(value, 1, (0, $e1697c988887a76c$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $e1697c988887a76c$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $e1697c988887a76c$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $e1697c988887a76c$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}


var $cc3252a8ee73aed0$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $0a9feeed4f7788db$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $93d42a638974aea7$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $3507b6f740af8b0b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $3507b6f740af8b0b$export$9e1725a4cfeada27)(character)) break;
        (0, $3507b6f740af8b0b$export$48cfd1e771a65c4f)();
    }
    return (0, $3507b6f740af8b0b$export$58adb3bec8346d0f)(begin, (0, $3507b6f740af8b0b$export$5880b8b5730aff45));
};
var $93d42a638974aea7$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $3507b6f740af8b0b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $3507b6f740af8b0b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $93d42a638974aea7$var$identifierWithPointTracking((0, $3507b6f740af8b0b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $3507b6f740af8b0b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $3507b6f740af8b0b$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $e1697c988887a76c$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $3507b6f740af8b0b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $93d42a638974aea7$var$getRules = function getRules(value, points) {
    return (0, $3507b6f740af8b0b$export$45918ac1574455b1)($93d42a638974aea7$var$toRules((0, $3507b6f740af8b0b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $93d42a638974aea7$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $93d42a638974aea7$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$93d42a638974aea7$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $93d42a638974aea7$var$fixedElements.set(element, true);
    var points = [];
    var rules = $93d42a638974aea7$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $93d42a638974aea7$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $93d42a638974aea7$var$prefix(value, length) {
    switch((0, $e1697c988887a76c$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$2c0f367103c8d01c) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + 'box-' + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)((0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)((0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)((0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $e1697c988887a76c$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $e1697c988887a76c$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $e1697c988887a76c$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $83734da6875d6b87$export$2c0f367103c8d01c) + ((0, $e1697c988887a76c$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $e1697c988887a76c$export$f8e21b1e77979a08)(value, 'stretch') ? $93d42a638974aea7$var$prefix((0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $e1697c988887a76c$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $e1697c988887a76c$export$a9db5e087081082d)(value, (0, $e1697c988887a76c$export$36776f635604f274)(value) - 3 - (~(0, $e1697c988887a76c$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $83734da6875d6b87$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + ((0, $e1697c988887a76c$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $e1697c988887a76c$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + value + (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $93d42a638974aea7$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $83734da6875d6b87$export$527d108ccf083c2b:
                element["return"] = $93d42a638974aea7$var$prefix(element.value, element.length);
                break;
            case 0, $83734da6875d6b87$export$b44a8529a35fcb60:
                return (0, $307dbaf3d9eac44e$export$dfdc1655ccc5b9cb)([
                    (0, $3507b6f740af8b0b$export$784d13d8ee351f07)(element, {
                        value: (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $83734da6875d6b87$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $83734da6875d6b87$export$aa3a2e812ca8570d:
                if (element.length) return (0, $e1697c988887a76c$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $e1697c988887a76c$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $307dbaf3d9eac44e$export$dfdc1655ccc5b9cb)([
                                (0, $3507b6f740af8b0b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $83734da6875d6b87$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $307dbaf3d9eac44e$export$dfdc1655ccc5b9cb)([
                                (0, $3507b6f740af8b0b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $83734da6875d6b87$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $3507b6f740af8b0b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $83734da6875d6b87$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $3507b6f740af8b0b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e1697c988887a76c$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $83734da6875d6b87$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $93d42a638974aea7$var$defaultStylisPlugins = [
    $93d42a638974aea7$var$prefixer
];
var $93d42a638974aea7$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $93d42a638974aea7$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $93d42a638974aea7$var$compat,
        $93d42a638974aea7$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $307dbaf3d9eac44e$export$fac44ee5b035f737),
        (0, $db97acbc9227fc9b$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $db97acbc9227fc9b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $307dbaf3d9eac44e$export$dfdc1655ccc5b9cb)((0, $6a6ea5c0450acde0$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $53ec8e624a52d9bc$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


function $db9d35cbfb6cf715$export$2e2bcd8739ae039() {
    return $db9d35cbfb6cf715$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $db9d35cbfb6cf715$export$2e2bcd8739ae039.apply(null, arguments);
}


var $da36f7b7bcbe9859$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


var $25cb7246cfccd3af$exports = {};
'use strict';
var $53a81ab81d62cb67$exports = {};
'use strict';

$53a81ab81d62cb67$exports = (parcelRequire("5CHok"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $25cb7246cfccd3af$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $25cb7246cfccd3af$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $25cb7246cfccd3af$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $25cb7246cfccd3af$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $25cb7246cfccd3af$var$TYPE_STATICS = {};
$25cb7246cfccd3af$var$TYPE_STATICS[$53a81ab81d62cb67$exports.ForwardRef] = $25cb7246cfccd3af$var$FORWARD_REF_STATICS;
$25cb7246cfccd3af$var$TYPE_STATICS[$53a81ab81d62cb67$exports.Memo] = $25cb7246cfccd3af$var$MEMO_STATICS;
function $25cb7246cfccd3af$var$getStatics(component) {
    // React v16.11 and below
    if ($53a81ab81d62cb67$exports.isMemo(component)) return $25cb7246cfccd3af$var$MEMO_STATICS;
     // React v16.12 and above
    return $25cb7246cfccd3af$var$TYPE_STATICS[component['$$typeof']] || $25cb7246cfccd3af$var$REACT_STATICS;
}
var $25cb7246cfccd3af$var$defineProperty = Object.defineProperty;
var $25cb7246cfccd3af$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $25cb7246cfccd3af$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $25cb7246cfccd3af$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $25cb7246cfccd3af$var$getPrototypeOf = Object.getPrototypeOf;
var $25cb7246cfccd3af$var$objectPrototype = Object.prototype;
function $25cb7246cfccd3af$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($25cb7246cfccd3af$var$objectPrototype) {
            var inheritedComponent = $25cb7246cfccd3af$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $25cb7246cfccd3af$var$objectPrototype) $25cb7246cfccd3af$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $25cb7246cfccd3af$var$getOwnPropertyNames(sourceComponent);
        if ($25cb7246cfccd3af$var$getOwnPropertySymbols) keys = keys.concat($25cb7246cfccd3af$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $25cb7246cfccd3af$var$getStatics(targetComponent);
        var sourceStatics = $25cb7246cfccd3af$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$25cb7246cfccd3af$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $25cb7246cfccd3af$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $25cb7246cfccd3af$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$25cb7246cfccd3af$exports = $25cb7246cfccd3af$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $65d5bca98c00c879$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($25cb7246cfccd3af$exports)))(targetComponent, sourceComponent);
};


var $7628a585f8fbb799$var$isBrowser = true;
function $7628a585f8fbb799$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $7628a585f8fbb799$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $7628a585f8fbb799$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $7628a585f8fbb799$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $7628a585f8fbb799$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $a6989bdd5e577c83$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $6a43e995b691d257$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


function $0d4a673343ce05f6$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $71f096a7fec5de1b$var$isDevelopment = false;
var $71f096a7fec5de1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $71f096a7fec5de1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $71f096a7fec5de1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $71f096a7fec5de1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $71f096a7fec5de1b$var$processStyleName = /* #__PURE__ */ (0, $0d4a673343ce05f6$export$2e2bcd8739ae039)(function(styleName) {
    return $71f096a7fec5de1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($71f096a7fec5de1b$var$hyphenateRegex, '-$&').toLowerCase();
});
var $71f096a7fec5de1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($71f096a7fec5de1b$var$animationRegex, function(match, p1, p2) {
                $71f096a7fec5de1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $71f096a7fec5de1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $6a43e995b691d257$export$2e2bcd8739ae039)[key] !== 1 && !$71f096a7fec5de1b$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $71f096a7fec5de1b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $71f096a7fec5de1b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $71f096a7fec5de1b$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $71f096a7fec5de1b$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $71f096a7fec5de1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $71f096a7fec5de1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $71f096a7fec5de1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $71f096a7fec5de1b$var$cursor;
                var result = interpolation(mergedProps);
                $71f096a7fec5de1b$var$cursor = previousCursor;
                return $71f096a7fec5de1b$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $71f096a7fec5de1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $71f096a7fec5de1b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($71f096a7fec5de1b$var$isProcessableValue(asString)) string += $71f096a7fec5de1b$var$processStyleName(key) + ":" + $71f096a7fec5de1b$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $71f096a7fec5de1b$var$isDevelopment) throw new Error($71f096a7fec5de1b$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($71f096a7fec5de1b$var$isProcessableValue(value[_i])) string += $71f096a7fec5de1b$var$processStyleName(key) + ":" + $71f096a7fec5de1b$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $71f096a7fec5de1b$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $71f096a7fec5de1b$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $71f096a7fec5de1b$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $71f096a7fec5de1b$var$cursor;
function $71f096a7fec5de1b$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $71f096a7fec5de1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $71f096a7fec5de1b$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $71f096a7fec5de1b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $71f096a7fec5de1b$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $71f096a7fec5de1b$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $a6989bdd5e577c83$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $71f096a7fec5de1b$var$cursor
    };
}



var $h4Bez = parcelRequire("h4Bez");
var $3ecc770cfb7f5541$var$syncFallback = function syncFallback(create) {
    return create();
};
var $3ecc770cfb7f5541$var$useInsertionEffect = $h4Bez.useInsertionEffect ? $h4Bez.useInsertionEffect : false;
var $3ecc770cfb7f5541$export$db21c7ffa21794e7 = $3ecc770cfb7f5541$var$useInsertionEffect || $3ecc770cfb7f5541$var$syncFallback;
var $3ecc770cfb7f5541$export$811a713a7276cb9d = $3ecc770cfb7f5541$var$useInsertionEffect || $h4Bez.useLayoutEffect;


var $216c71ed8edea623$export$23f2a1d2818174ef = true;
var $216c71ed8edea623$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $216c71ed8edea623$var$EmotionCacheContext = /* #__PURE__ */ $h4Bez.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $93d42a638974aea7$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $216c71ed8edea623$export$e7094788287c5e9b = $216c71ed8edea623$var$EmotionCacheContext.Provider;
var $216c71ed8edea623$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $h4Bez.useContext)($216c71ed8edea623$var$EmotionCacheContext);
};
var $216c71ed8edea623$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $h4Bez.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $h4Bez.useContext)($216c71ed8edea623$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$216c71ed8edea623$export$23f2a1d2818174ef) $216c71ed8edea623$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $h4Bez.useContext)($216c71ed8edea623$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $93d42a638974aea7$export$2e2bcd8739ae039)({
                key: 'css'
            });
            return /*#__PURE__*/ $h4Bez.createElement($216c71ed8edea623$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $216c71ed8edea623$export$971d5caa766a69d7 = /* #__PURE__ */ $h4Bez.createContext({});
var $216c71ed8edea623$export$3b14a55fb2447963 = function useTheme() {
    return $h4Bez.useContext($216c71ed8edea623$export$971d5caa766a69d7);
};
var $216c71ed8edea623$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $216c71ed8edea623$var$createCacheWithTheme = /* #__PURE__ */ (0, $da36f7b7bcbe9859$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $da36f7b7bcbe9859$export$2e2bcd8739ae039)(function(theme) {
        return $216c71ed8edea623$var$getTheme(outerTheme, theme);
    });
});
var $216c71ed8edea623$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $h4Bez.useContext($216c71ed8edea623$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $216c71ed8edea623$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $h4Bez.createElement($216c71ed8edea623$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $216c71ed8edea623$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $h4Bez.useContext($216c71ed8edea623$export$971d5caa766a69d7);
        return /*#__PURE__*/ $h4Bez.createElement(Component, (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $h4Bez.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $65d5bca98c00c879$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $216c71ed8edea623$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $216c71ed8edea623$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $216c71ed8edea623$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $216c71ed8edea623$var$getLastPart(match[1]);
    return undefined;
};
var $216c71ed8edea623$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $216c71ed8edea623$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $216c71ed8edea623$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $216c71ed8edea623$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($216c71ed8edea623$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $216c71ed8edea623$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $216c71ed8edea623$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $216c71ed8edea623$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $216c71ed8edea623$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($216c71ed8edea623$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$216c71ed8edea623$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $216c71ed8edea623$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $7628a585f8fbb799$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $3ecc770cfb7f5541$export$db21c7ffa21794e7)(function() {
        return (0, $7628a585f8fbb799$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $216c71ed8edea623$var$Emotion = /* #__PURE__ */ $216c71ed8edea623$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$216c71ed8edea623$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $7628a585f8fbb799$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $71f096a7fec5de1b$export$6321afa313b251b5)(registeredStyles, undefined, $h4Bez.useContext($216c71ed8edea623$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($216c71ed8edea623$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $216c71ed8edea623$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $h4Bez.createElement($h4Bez.Fragment, null, /*#__PURE__*/ $h4Bez.createElement($216c71ed8edea623$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $h4Bez.createElement(WrappedComponent, newProps));
});
var $216c71ed8edea623$export$a9c23c6ac3fc3eca = $216c71ed8edea623$var$Emotion;



var $h4Bez = parcelRequire("h4Bez");








var $2260c64920c0bb2a$var$pkg = {
    name: "@emotion/react",
    version: "11.11.0",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $2260c64920c0bb2a$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $216c71ed8edea623$export$dda1d9f60106f0e9).call(props, 'css')) // $FlowFixMe
    return $h4Bez.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $216c71ed8edea623$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $216c71ed8edea623$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $h4Bez.createElement.apply(null, createElementArgArray);
};
var $2260c64920c0bb2a$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $2260c64920c0bb2a$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $216c71ed8edea623$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $71f096a7fec5de1b$export$6321afa313b251b5)([
        styles
    ], undefined, $h4Bez.useContext((0, $216c71ed8edea623$export$971d5caa766a69d7)));
    if (!(0, $216c71ed8edea623$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $h4Bez.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $h4Bez.useRef();
    (0, $3ecc770cfb7f5541$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $3ecc770cfb7f5541$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $7628a585f8fbb799$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $2260c64920c0bb2a$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $71f096a7fec5de1b$export$6321afa313b251b5)(args);
}
var $2260c64920c0bb2a$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $2260c64920c0bb2a$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $2260c64920c0bb2a$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $2260c64920c0bb2a$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $7628a585f8fbb799$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $2260c64920c0bb2a$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $3ecc770cfb7f5541$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $7628a585f8fbb799$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $2260c64920c0bb2a$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $216c71ed8edea623$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $71f096a7fec5de1b$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $7628a585f8fbb799$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $2260c64920c0bb2a$var$merge(cache.registered, css, $2260c64920c0bb2a$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $h4Bez.useContext((0, $216c71ed8edea623$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $h4Bez.createElement($h4Bez.Fragment, null, /*#__PURE__*/ $h4Bez.createElement($2260c64920c0bb2a$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $2260c64920c0bb2a$var$isBrowser, $2260c64920c0bb2a$var$isTestEnv, $2260c64920c0bb2a$var$globalContext, $2260c64920c0bb2a$var$globalKey;



'use client';
function $cbdad6be451a22e4$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $cbdad6be451a22e4$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($cbdad6be451a22e4$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2260c64920c0bb2a$export$98f03c5d19621d70), {
        styles: globalStyles
    });
}

/**
 * @mui/styled-engine v7.3.7
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 

var $h4Bez = parcelRequire("h4Bez");
function $aec1e9c5611284d4$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $984ecc1623ab52af$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $984ecc1623ab52af$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $aec1e9c5611284d4$export$2e2bcd8739ae039)(function(prop) {
    return $984ecc1623ab52af$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});






var $a98a064084889621$var$testOmitPropsOnStringTag = (0, $984ecc1623ab52af$export$2e2bcd8739ae039);
var $a98a064084889621$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $a98a064084889621$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $a98a064084889621$var$testOmitPropsOnStringTag : $a98a064084889621$var$testOmitPropsOnComponent;
};
var $a98a064084889621$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $a98a064084889621$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $a98a064084889621$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $7628a585f8fbb799$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $3ecc770cfb7f5541$export$db21c7ffa21794e7)(function() {
        return (0, $7628a585f8fbb799$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $a98a064084889621$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $a98a064084889621$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $a98a064084889621$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $216c71ed8edea623$export$efccba1c4a2ef57b)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $h4Bez.useContext((0, $216c71ed8edea623$export$971d5caa766a69d7));
            }
            if (typeof props.className === 'string') className = (0, $7628a585f8fbb799$export$95d99596f328fd52)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $71f096a7fec5de1b$export$6321afa313b251b5)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $a98a064084889621$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $h4Bez.createElement($h4Bez.Fragment, null, /*#__PURE__*/ $h4Bez.createElement($a98a064084889621$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $h4Bez.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, options, nextOptions, {
                shouldForwardProp: $a98a064084889621$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};



parcelRequire("h4Bez");





var $9a00ca9512f4e815$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $9a00ca9512f4e815$export$2e2bcd8739ae039 = (0, $a98a064084889621$export$2e2bcd8739ae039).bind();
$9a00ca9512f4e815$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $9a00ca9512f4e815$export$2e2bcd8739ae039[tagName] = $9a00ca9512f4e815$export$2e2bcd8739ae039(tagName);
});






'use client';
function $f03c30be6721b2ef$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $9a00ca9512f4e815$export$2e2bcd8739ae039)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $f03c30be6721b2ef$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $f03c30be6721b2ef$var$wrapper = [];
function $f03c30be6721b2ef$export$13a2d3ef13012b32(styles) {
    $f03c30be6721b2ef$var$wrapper[0] = styles;
    return (0, $71f096a7fec5de1b$export$6321afa313b251b5)($f03c30be6721b2ef$var$wrapper);
}



var $h4Bez = parcelRequire("h4Bez");

function $a539fc8639d0a7b4$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $a539fc8639d0a7b4$var$deepClone(source) {
    if (/*#__PURE__*/ $h4Bez.isValidElement(source) || (0, $53a81ab81d62cb67$exports.isValidElementType)(source) || !$a539fc8639d0a7b4$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $a539fc8639d0a7b4$var$deepClone(source[key]);
    });
    return output;
}
function $a539fc8639d0a7b4$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($a539fc8639d0a7b4$export$53b83ca8eaab0383(target) && $a539fc8639d0a7b4$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $h4Bez.isValidElement(source[key]) || (0, $53a81ab81d62cb67$exports.isValidElementType)(source[key])) output[key] = source[key];
        else if ($a539fc8639d0a7b4$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $a539fc8639d0a7b4$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $a539fc8639d0a7b4$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $a539fc8639d0a7b4$export$53b83ca8eaab0383(source[key]) ? $a539fc8639d0a7b4$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}


// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $992177b11722e470$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $992177b11722e470$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $992177b11722e470$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $992177b11722e470$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}



function $2678d4493f17a78b$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $2678d4493f17a78b$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $2678d4493f17a78b$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $2678d4493f17a78b$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}


const $58ab088bd2db9361$var$shape = {
    borderRadius: 4
};
var $58ab088bd2db9361$export$2e2bcd8739ae039 = $58ab088bd2db9361$var$shape;






function $df2e53bdf9984305$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $a539fc8639d0a7b4$export$2e2bcd8739ae039)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $df2e53bdf9984305$export$2e2bcd8739ae039 = $df2e53bdf9984305$var$merge;



const $9d0348a6a7057277$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $9d0348a6a7057277$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$9d0348a6a7057277$export$68c286be0e7e55b7[key]}px)`
};
const $9d0348a6a7057277$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $9d0348a6a7057277$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $9d0348a6a7057277$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $9d0348a6a7057277$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $9d0348a6a7057277$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $2678d4493f17a78b$export$77c7c3e357f440e7)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $2678d4493f17a78b$export$10a9745dfa00d15)(theme.containerQueries ? theme : $9d0348a6a7057277$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $9d0348a6a7057277$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $9d0348a6a7057277$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $9d0348a6a7057277$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $df2e53bdf9984305$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $9d0348a6a7057277$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $9d0348a6a7057277$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $9d0348a6a7057277$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $9d0348a6a7057277$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $a539fc8639d0a7b4$export$2e2bcd8739ae039)(prev, next), {});
    return $9d0348a6a7057277$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $9d0348a6a7057277$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $9d0348a6a7057277$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $9d0348a6a7057277$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $9d0348a6a7057277$export$2e2bcd8739ae039 = $9d0348a6a7057277$var$breakpoints;


/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $7052f9417b2e0e56$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}


function $00f59fafbaffc20f$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $7052f9417b2e0e56$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}




function $ca2b3459e44cca5a$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $ca2b3459e44cca5a$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $ca2b3459e44cca5a$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $ca2b3459e44cca5a$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $ca2b3459e44cca5a$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $ca2b3459e44cca5a$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $ca2b3459e44cca5a$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $00f59fafbaffc20f$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $9d0348a6a7057277$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $ca2b3459e44cca5a$export$2e2bcd8739ae039 = $ca2b3459e44cca5a$var$style;



function $852eb04c2fdee4a7$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


const $2cbe39ac70acf613$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $2cbe39ac70acf613$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $2cbe39ac70acf613$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $2cbe39ac70acf613$var$getCssProperties = (0, $852eb04c2fdee4a7$export$2e2bcd8739ae039)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($2cbe39ac70acf613$var$aliases[prop]) prop = $2cbe39ac70acf613$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $2cbe39ac70acf613$var$properties[a];
    const direction = $2cbe39ac70acf613$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $2cbe39ac70acf613$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $2cbe39ac70acf613$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $2cbe39ac70acf613$var$spacingKeys = [
    ...$2cbe39ac70acf613$export$aab52a0dde05ad8a,
    ...$2cbe39ac70acf613$export$f8397d44f03ab6ad
];
function $2cbe39ac70acf613$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $ca2b3459e44cca5a$export$2aa3fd96c49a84a8)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $2cbe39ac70acf613$export$1def6f833384e3d1(theme) {
    return $2cbe39ac70acf613$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $2cbe39ac70acf613$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $2cbe39ac70acf613$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $2cbe39ac70acf613$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $2cbe39ac70acf613$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $2cbe39ac70acf613$var$getCssProperties(prop);
    const styleFromPropValue = $2cbe39ac70acf613$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $9d0348a6a7057277$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
}
function $2cbe39ac70acf613$var$style(props, keys) {
    const transformer = $2cbe39ac70acf613$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$2cbe39ac70acf613$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $df2e53bdf9984305$export$2e2bcd8739ae039), {});
}
function $2cbe39ac70acf613$export$7ede87f9b603dd3c(props) {
    return $2cbe39ac70acf613$var$style(props, $2cbe39ac70acf613$export$aab52a0dde05ad8a);
}
$2cbe39ac70acf613$export$7ede87f9b603dd3c.propTypes = {};
$2cbe39ac70acf613$export$7ede87f9b603dd3c.filterProps = $2cbe39ac70acf613$export$aab52a0dde05ad8a;
function $2cbe39ac70acf613$export$6f98e8eaf0be1996(props) {
    return $2cbe39ac70acf613$var$style(props, $2cbe39ac70acf613$export$f8397d44f03ab6ad);
}
$2cbe39ac70acf613$export$6f98e8eaf0be1996.propTypes = {};
$2cbe39ac70acf613$export$6f98e8eaf0be1996.filterProps = $2cbe39ac70acf613$export$f8397d44f03ab6ad;
function $2cbe39ac70acf613$var$spacing(props) {
    return $2cbe39ac70acf613$var$style(props, $2cbe39ac70acf613$var$spacingKeys);
}
$2cbe39ac70acf613$var$spacing.propTypes = {};
$2cbe39ac70acf613$var$spacing.filterProps = $2cbe39ac70acf613$var$spacingKeys;
var $2cbe39ac70acf613$export$2e2bcd8739ae039 = $2cbe39ac70acf613$var$spacing;


function $824e58567897880e$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $2cbe39ac70acf613$export$1def6f833384e3d1)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}











function $28255eb356595c4c$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $df2e53bdf9984305$export$2e2bcd8739ae039)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $28255eb356595c4c$export$2e2bcd8739ae039 = $28255eb356595c4c$var$compose;




function $562e19a7c4f3a943$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $562e19a7c4f3a943$var$createBorderStyle(prop, transform) {
    return (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $562e19a7c4f3a943$export$1edee58a52776cd9 = $562e19a7c4f3a943$var$createBorderStyle('border', $562e19a7c4f3a943$export$34e2febe53ae29cc);
const $562e19a7c4f3a943$export$f9a7b6bd24892946 = $562e19a7c4f3a943$var$createBorderStyle('borderTop', $562e19a7c4f3a943$export$34e2febe53ae29cc);
const $562e19a7c4f3a943$export$5abca33e6be905d2 = $562e19a7c4f3a943$var$createBorderStyle('borderRight', $562e19a7c4f3a943$export$34e2febe53ae29cc);
const $562e19a7c4f3a943$export$e2ce9f12a980a822 = $562e19a7c4f3a943$var$createBorderStyle('borderBottom', $562e19a7c4f3a943$export$34e2febe53ae29cc);
const $562e19a7c4f3a943$export$47658cca1a909427 = $562e19a7c4f3a943$var$createBorderStyle('borderLeft', $562e19a7c4f3a943$export$34e2febe53ae29cc);
const $562e19a7c4f3a943$export$e7fb0694ba2404fc = $562e19a7c4f3a943$var$createBorderStyle('borderColor');
const $562e19a7c4f3a943$export$126a92c968acdb85 = $562e19a7c4f3a943$var$createBorderStyle('borderTopColor');
const $562e19a7c4f3a943$export$85cc51cb8fbb8c0e = $562e19a7c4f3a943$var$createBorderStyle('borderRightColor');
const $562e19a7c4f3a943$export$340b0327727f6d1a = $562e19a7c4f3a943$var$createBorderStyle('borderBottomColor');
const $562e19a7c4f3a943$export$60beef91a985b4bf = $562e19a7c4f3a943$var$createBorderStyle('borderLeftColor');
const $562e19a7c4f3a943$export$f9258c55612cbed7 = $562e19a7c4f3a943$var$createBorderStyle('outline', $562e19a7c4f3a943$export$34e2febe53ae29cc);
const $562e19a7c4f3a943$export$621fe586efeb64b9 = $562e19a7c4f3a943$var$createBorderStyle('outlineColor');
const $562e19a7c4f3a943$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $2cbe39ac70acf613$export$cb5ee237cce814a2)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $2cbe39ac70acf613$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $9d0348a6a7057277$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$562e19a7c4f3a943$export$7a57f79000377ca2.propTypes = {};
$562e19a7c4f3a943$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $562e19a7c4f3a943$var$borders = (0, $28255eb356595c4c$export$2e2bcd8739ae039)($562e19a7c4f3a943$export$1edee58a52776cd9, $562e19a7c4f3a943$export$f9a7b6bd24892946, $562e19a7c4f3a943$export$5abca33e6be905d2, $562e19a7c4f3a943$export$e2ce9f12a980a822, $562e19a7c4f3a943$export$47658cca1a909427, $562e19a7c4f3a943$export$e7fb0694ba2404fc, $562e19a7c4f3a943$export$126a92c968acdb85, $562e19a7c4f3a943$export$85cc51cb8fbb8c0e, $562e19a7c4f3a943$export$340b0327727f6d1a, $562e19a7c4f3a943$export$60beef91a985b4bf, $562e19a7c4f3a943$export$7a57f79000377ca2, $562e19a7c4f3a943$export$f9258c55612cbed7, $562e19a7c4f3a943$export$621fe586efeb64b9);
var $562e19a7c4f3a943$export$2e2bcd8739ae039 = $562e19a7c4f3a943$var$borders;







const $17037f57ba9ce305$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $2cbe39ac70acf613$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $2cbe39ac70acf613$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $9d0348a6a7057277$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$17037f57ba9ce305$export$5df9adcb0db95e1e.propTypes = {};
$17037f57ba9ce305$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $17037f57ba9ce305$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $2cbe39ac70acf613$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $2cbe39ac70acf613$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $9d0348a6a7057277$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$17037f57ba9ce305$export$ec60d70ff941a580.propTypes = {};
$17037f57ba9ce305$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $17037f57ba9ce305$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $2cbe39ac70acf613$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $2cbe39ac70acf613$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $9d0348a6a7057277$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$17037f57ba9ce305$export$8a833ffa5f5dbeda.propTypes = {};
$17037f57ba9ce305$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $17037f57ba9ce305$export$baf44164ca3a34e8 = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'gridColumn'
});
const $17037f57ba9ce305$export$8f7213a1cd01e832 = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'gridRow'
});
const $17037f57ba9ce305$export$b0e0abbc49ba668 = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'gridAutoFlow'
});
const $17037f57ba9ce305$export$bcd8b929d4b4142 = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'gridAutoColumns'
});
const $17037f57ba9ce305$export$e5039a674e14c828 = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'gridAutoRows'
});
const $17037f57ba9ce305$export$42bd9088661ffb03 = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'gridTemplateColumns'
});
const $17037f57ba9ce305$export$920682ae05b999bc = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'gridTemplateRows'
});
const $17037f57ba9ce305$export$1b88fbdd482fd33a = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'gridTemplateAreas'
});
const $17037f57ba9ce305$export$bdb486e40d52d26f = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'gridArea'
});
const $17037f57ba9ce305$var$grid = (0, $28255eb356595c4c$export$2e2bcd8739ae039)($17037f57ba9ce305$export$5df9adcb0db95e1e, $17037f57ba9ce305$export$ec60d70ff941a580, $17037f57ba9ce305$export$8a833ffa5f5dbeda, $17037f57ba9ce305$export$baf44164ca3a34e8, $17037f57ba9ce305$export$8f7213a1cd01e832, $17037f57ba9ce305$export$b0e0abbc49ba668, $17037f57ba9ce305$export$bcd8b929d4b4142, $17037f57ba9ce305$export$e5039a674e14c828, $17037f57ba9ce305$export$42bd9088661ffb03, $17037f57ba9ce305$export$920682ae05b999bc, $17037f57ba9ce305$export$1b88fbdd482fd33a, $17037f57ba9ce305$export$bdb486e40d52d26f);
var $17037f57ba9ce305$export$2e2bcd8739ae039 = $17037f57ba9ce305$var$grid;




function $87aa76b4de3d5e0e$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $87aa76b4de3d5e0e$export$35e9368ef982300f = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'color',
    themeKey: 'palette',
    transform: $87aa76b4de3d5e0e$export$dbaffd4420ea0ac6
});
const $87aa76b4de3d5e0e$export$2506f56c10355b33 = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $87aa76b4de3d5e0e$export$dbaffd4420ea0ac6
});
const $87aa76b4de3d5e0e$export$8c5a050822fd698c = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $87aa76b4de3d5e0e$export$dbaffd4420ea0ac6
});
const $87aa76b4de3d5e0e$var$palette = (0, $28255eb356595c4c$export$2e2bcd8739ae039)($87aa76b4de3d5e0e$export$35e9368ef982300f, $87aa76b4de3d5e0e$export$2506f56c10355b33, $87aa76b4de3d5e0e$export$8c5a050822fd698c);
var $87aa76b4de3d5e0e$export$2e2bcd8739ae039 = $87aa76b4de3d5e0e$var$palette;





function $dea4d59837cf7ec7$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $dea4d59837cf7ec7$export$7e3df82ee760448c = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'width',
    transform: $dea4d59837cf7ec7$export$8afece71750ec241
});
const $dea4d59837cf7ec7$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $9d0348a6a7057277$export$68c286be0e7e55b7)[propValue];
            if (!breakpoint) return {
                maxWidth: $dea4d59837cf7ec7$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $9d0348a6a7057277$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$dea4d59837cf7ec7$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $dea4d59837cf7ec7$export$ee148fbbe8357dd2 = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'minWidth',
    transform: $dea4d59837cf7ec7$export$8afece71750ec241
});
const $dea4d59837cf7ec7$export$ac607276a8fe9f0a = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'height',
    transform: $dea4d59837cf7ec7$export$8afece71750ec241
});
const $dea4d59837cf7ec7$export$dc0d8bd0b94f8570 = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'maxHeight',
    transform: $dea4d59837cf7ec7$export$8afece71750ec241
});
const $dea4d59837cf7ec7$export$a43cf604e12f3b17 = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'minHeight',
    transform: $dea4d59837cf7ec7$export$8afece71750ec241
});
const $dea4d59837cf7ec7$export$ffed9f14fb65e276 = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'width',
    transform: $dea4d59837cf7ec7$export$8afece71750ec241
});
const $dea4d59837cf7ec7$export$905076ed6620e671 = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'height',
    transform: $dea4d59837cf7ec7$export$8afece71750ec241
});
const $dea4d59837cf7ec7$export$6ccc93f785106a58 = (0, $ca2b3459e44cca5a$export$2e2bcd8739ae039)({
    prop: 'boxSizing'
});
const $dea4d59837cf7ec7$var$sizing = (0, $28255eb356595c4c$export$2e2bcd8739ae039)($dea4d59837cf7ec7$export$7e3df82ee760448c, $dea4d59837cf7ec7$export$488fda99655ff65a, $dea4d59837cf7ec7$export$ee148fbbe8357dd2, $dea4d59837cf7ec7$export$ac607276a8fe9f0a, $dea4d59837cf7ec7$export$dc0d8bd0b94f8570, $dea4d59837cf7ec7$export$a43cf604e12f3b17, $dea4d59837cf7ec7$export$6ccc93f785106a58);
var $dea4d59837cf7ec7$export$2e2bcd8739ae039 = $dea4d59837cf7ec7$var$sizing;


const $1ddc86c69bdbc815$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $562e19a7c4f3a943$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $562e19a7c4f3a943$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $562e19a7c4f3a943$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $562e19a7c4f3a943$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $562e19a7c4f3a943$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $562e19a7c4f3a943$export$34e2febe53ae29cc)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $562e19a7c4f3a943$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $87aa76b4de3d5e0e$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $87aa76b4de3d5e0e$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $87aa76b4de3d5e0e$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $2cbe39ac70acf613$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $2cbe39ac70acf613$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $17037f57ba9ce305$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $17037f57ba9ce305$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $17037f57ba9ce305$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $dea4d59837cf7ec7$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $dea4d59837cf7ec7$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $dea4d59837cf7ec7$export$8afece71750ec241)
    },
    height: {
        transform: (0, $dea4d59837cf7ec7$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $dea4d59837cf7ec7$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $dea4d59837cf7ec7$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $1ddc86c69bdbc815$export$2e2bcd8739ae039 = $1ddc86c69bdbc815$var$defaultSxConfig;


function $bee7cb8e1c4d4571$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $bee7cb8e1c4d4571$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $bee7cb8e1c4d4571$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $ca2b3459e44cca5a$export$2aa3fd96c49a84a8)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $ca2b3459e44cca5a$export$741ad47189a64aa0)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $ca2b3459e44cca5a$export$741ad47189a64aa0)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $00f59fafbaffc20f$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $9d0348a6a7057277$export$88347efdb2e19abd)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $1ddc86c69bdbc815$export$2e2bcd8739ae039);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $9d0348a6a7057277$export$1f2600516e91381f)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $bee7cb8e1c4d4571$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $df2e53bdf9984305$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $9d0348a6a7057277$export$88347efdb2e19abd)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($bee7cb8e1c4d4571$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $df2e53bdf9984305$export$2e2bcd8739ae039)(css, breakpointsValues);
                        }
                    } else css = (0, $df2e53bdf9984305$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $2678d4493f17a78b$export$456f6c1142f990db)(theme, (0, $9d0348a6a7057277$export$8922c90b6e020726)(breakpointsKeys, css))
            };
            return (0, $2678d4493f17a78b$export$456f6c1142f990db)(theme, (0, $9d0348a6a7057277$export$8922c90b6e020726)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $bee7cb8e1c4d4571$var$styleFunctionSx = $bee7cb8e1c4d4571$export$7d53d8bf2911e013();
$bee7cb8e1c4d4571$var$styleFunctionSx.filterProps = [
    'sx'
];
var $bee7cb8e1c4d4571$export$2e2bcd8739ae039 = $bee7cb8e1c4d4571$var$styleFunctionSx;



/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $34e4fb882c858be7$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}


function $32d258d0759a439a$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $992177b11722e470$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $824e58567897880e$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $a539fc8639d0a7b4$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $58ab088bd2db9361$export$2e2bcd8739ae039),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $2678d4493f17a78b$export$2e2bcd8739ae039)(muiTheme);
    muiTheme.applyStyles = (0, $34e4fb882c858be7$export$2e2bcd8739ae039);
    muiTheme = args.reduce((acc, argument)=>(0, $a539fc8639d0a7b4$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $1ddc86c69bdbc815$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $bee7cb8e1c4d4571$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $32d258d0759a439a$export$2e2bcd8739ae039 = $32d258d0759a439a$var$createTheme;



var $h4Bez = parcelRequire("h4Bez");

'use client';
function $4609584b99dbdbe9$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $4609584b99dbdbe9$var$useTheme(defaultTheme = null) {
    const contextTheme = $h4Bez.useContext((0, $216c71ed8edea623$export$971d5caa766a69d7));
    return !contextTheme || $4609584b99dbdbe9$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $4609584b99dbdbe9$export$2e2bcd8739ae039 = $4609584b99dbdbe9$var$useTheme;


'use client';
const $f8416c9663895cb7$export$35e57303dbd8a66 = (0, $32d258d0759a439a$export$2e2bcd8739ae039)();
function $f8416c9663895cb7$var$useTheme(defaultTheme = $f8416c9663895cb7$export$35e57303dbd8a66) {
    return (0, $4609584b99dbdbe9$export$2e2bcd8739ae039)(defaultTheme);
}
var $f8416c9663895cb7$export$2e2bcd8739ae039 = $f8416c9663895cb7$var$useTheme;



'use client';
function $f3135bf3b34b1e0f$var$wrapGlobalLayer(styles) {
    const serialized = (0, $f03c30be6721b2ef$export$13a2d3ef13012b32)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $f3135bf3b34b1e0f$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $f8416c9663895cb7$export$2e2bcd8739ae039)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $f3135bf3b34b1e0f$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $f3135bf3b34b1e0f$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $f3135bf3b34b1e0f$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $cbdad6be451a22e4$export$2e2bcd8739ae039), {
        styles: globalStyles
    });
}
var $f3135bf3b34b1e0f$export$2e2bcd8739ae039 = $f3135bf3b34b1e0f$var$GlobalStyles;





function $8ece3559f62aa728$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $8ece3559f62aa728$export$2e2bcd8739ae039 = $8ece3559f62aa728$var$clamp;


/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $3289d56f59a873c2$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $8ece3559f62aa728$export$2e2bcd8739ae039)(value, min, max);
}
function $3289d56f59a873c2$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $3289d56f59a873c2$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $3289d56f59a873c2$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $3289d56f59a873c2$export$677b39864803984e($3289d56f59a873c2$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $7052f9417b2e0e56$export$2e2bcd8739ae039)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $7052f9417b2e0e56$export$2e2bcd8739ae039)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $3289d56f59a873c2$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $3289d56f59a873c2$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $3289d56f59a873c2$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $3289d56f59a873c2$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $3289d56f59a873c2$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $3289d56f59a873c2$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $3289d56f59a873c2$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$3289d56f59a873c2$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $3289d56f59a873c2$export$29fb7152bd3f781a(color) {
    color = $3289d56f59a873c2$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $3289d56f59a873c2$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $3289d56f59a873c2$export$c852d90bf7403b62(color) {
    color = $3289d56f59a873c2$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $3289d56f59a873c2$export$677b39864803984e($3289d56f59a873c2$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $3289d56f59a873c2$export$d061e26956a60b0a(foreground, background) {
    const lumA = $3289d56f59a873c2$export$c852d90bf7403b62(foreground);
    const lumB = $3289d56f59a873c2$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $3289d56f59a873c2$export$58f0f39f63f3cf42(color, value) {
    color = $3289d56f59a873c2$export$677b39864803984e(color);
    value = $3289d56f59a873c2$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $3289d56f59a873c2$export$211a73f2b8c10ce4(color);
}
function $3289d56f59a873c2$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $3289d56f59a873c2$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $3289d56f59a873c2$export$4b073707ff63303(color, coefficient) {
    color = $3289d56f59a873c2$export$677b39864803984e(color);
    coefficient = $3289d56f59a873c2$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $3289d56f59a873c2$export$211a73f2b8c10ce4(color);
}
function $3289d56f59a873c2$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $3289d56f59a873c2$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $3289d56f59a873c2$export$c0816ed86df316af(color, coefficient) {
    color = $3289d56f59a873c2$export$677b39864803984e(color);
    coefficient = $3289d56f59a873c2$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $3289d56f59a873c2$export$211a73f2b8c10ce4(color);
}
function $3289d56f59a873c2$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $3289d56f59a873c2$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $3289d56f59a873c2$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $3289d56f59a873c2$export$c852d90bf7403b62(color) > 0.5 ? $3289d56f59a873c2$export$4b073707ff63303(color, coefficient) : $3289d56f59a873c2$export$c0816ed86df316af(color, coefficient);
}
function $3289d56f59a873c2$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $3289d56f59a873c2$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $3289d56f59a873c2$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $3289d56f59a873c2$export$677b39864803984e(background);
    const overlayColor = $3289d56f59a873c2$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $3289d56f59a873c2$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}


const $4d4b47eab2d24330$var$common = {
    black: '#000',
    white: '#fff'
};
var $4d4b47eab2d24330$export$2e2bcd8739ae039 = $4d4b47eab2d24330$var$common;


const $fcc7f3d7aad5bcb9$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $fcc7f3d7aad5bcb9$export$2e2bcd8739ae039 = $fcc7f3d7aad5bcb9$var$grey;


const $4cd88d873f6e878d$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $4cd88d873f6e878d$export$2e2bcd8739ae039 = $4cd88d873f6e878d$var$purple;


const $0f104a22d3b52277$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $0f104a22d3b52277$export$2e2bcd8739ae039 = $0f104a22d3b52277$var$red;


const $95195ddba3567eda$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $95195ddba3567eda$export$2e2bcd8739ae039 = $95195ddba3567eda$var$orange;


const $98fa899c63f712d1$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $98fa899c63f712d1$export$2e2bcd8739ae039 = $98fa899c63f712d1$var$blue;


const $2c87fbc8fad6829c$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $2c87fbc8fad6829c$export$2e2bcd8739ae039 = $2c87fbc8fad6829c$var$lightBlue;


const $818d52d57cc7c0de$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $818d52d57cc7c0de$export$2e2bcd8739ae039 = $818d52d57cc7c0de$var$green;


function $86763ab82fa74def$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $4d4b47eab2d24330$export$2e2bcd8739ae039).white,
            default: (0, $4d4b47eab2d24330$export$2e2bcd8739ae039).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $86763ab82fa74def$export$a43af521ac8c3202 = $86763ab82fa74def$var$getLight();
function $86763ab82fa74def$var$getDark() {
    return {
        text: {
            primary: (0, $4d4b47eab2d24330$export$2e2bcd8739ae039).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $4d4b47eab2d24330$export$2e2bcd8739ae039).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $86763ab82fa74def$export$55ce6f3a06c59543 = $86763ab82fa74def$var$getDark();
function $86763ab82fa74def$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $3289d56f59a873c2$export$c0816ed86df316af)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $3289d56f59a873c2$export$4b073707ff63303)(intent.main, tonalOffsetDark);
    }
}
function $86763ab82fa74def$var$mixLightOrDark(colorSpace, intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = `color-mix(in ${colorSpace}, ${intent.main}, #fff ${(tonalOffsetLight * 100).toFixed(0)}%)`;
        else if (direction === 'dark') intent.dark = `color-mix(in ${colorSpace}, ${intent.main}, #000 ${(tonalOffsetDark * 100).toFixed(0)}%)`;
    }
}
function $86763ab82fa74def$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $98fa899c63f712d1$export$2e2bcd8739ae039)[200],
        light: (0, $98fa899c63f712d1$export$2e2bcd8739ae039)[50],
        dark: (0, $98fa899c63f712d1$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $98fa899c63f712d1$export$2e2bcd8739ae039)[700],
        light: (0, $98fa899c63f712d1$export$2e2bcd8739ae039)[400],
        dark: (0, $98fa899c63f712d1$export$2e2bcd8739ae039)[800]
    };
}
function $86763ab82fa74def$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $4cd88d873f6e878d$export$2e2bcd8739ae039)[200],
        light: (0, $4cd88d873f6e878d$export$2e2bcd8739ae039)[50],
        dark: (0, $4cd88d873f6e878d$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $4cd88d873f6e878d$export$2e2bcd8739ae039)[500],
        light: (0, $4cd88d873f6e878d$export$2e2bcd8739ae039)[300],
        dark: (0, $4cd88d873f6e878d$export$2e2bcd8739ae039)[700]
    };
}
function $86763ab82fa74def$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $0f104a22d3b52277$export$2e2bcd8739ae039)[500],
        light: (0, $0f104a22d3b52277$export$2e2bcd8739ae039)[300],
        dark: (0, $0f104a22d3b52277$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $0f104a22d3b52277$export$2e2bcd8739ae039)[700],
        light: (0, $0f104a22d3b52277$export$2e2bcd8739ae039)[400],
        dark: (0, $0f104a22d3b52277$export$2e2bcd8739ae039)[800]
    };
}
function $86763ab82fa74def$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $2c87fbc8fad6829c$export$2e2bcd8739ae039)[400],
        light: (0, $2c87fbc8fad6829c$export$2e2bcd8739ae039)[300],
        dark: (0, $2c87fbc8fad6829c$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $2c87fbc8fad6829c$export$2e2bcd8739ae039)[700],
        light: (0, $2c87fbc8fad6829c$export$2e2bcd8739ae039)[500],
        dark: (0, $2c87fbc8fad6829c$export$2e2bcd8739ae039)[900]
    };
}
function $86763ab82fa74def$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $818d52d57cc7c0de$export$2e2bcd8739ae039)[400],
        light: (0, $818d52d57cc7c0de$export$2e2bcd8739ae039)[300],
        dark: (0, $818d52d57cc7c0de$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $818d52d57cc7c0de$export$2e2bcd8739ae039)[800],
        light: (0, $818d52d57cc7c0de$export$2e2bcd8739ae039)[500],
        dark: (0, $818d52d57cc7c0de$export$2e2bcd8739ae039)[900]
    };
}
function $86763ab82fa74def$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $95195ddba3567eda$export$2e2bcd8739ae039)[400],
        light: (0, $95195ddba3567eda$export$2e2bcd8739ae039)[300],
        dark: (0, $95195ddba3567eda$export$2e2bcd8739ae039)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $95195ddba3567eda$export$2e2bcd8739ae039)[500],
        dark: (0, $95195ddba3567eda$export$2e2bcd8739ae039)[900]
    };
}
function $86763ab82fa74def$export$b6e2ca4581a735cb(background) {
    return `oklch(from ${background} var(--__l) 0 h / var(--__a))`;
}
function $86763ab82fa74def$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, colorSpace: colorSpace, ...other } = palette;
    const primary = palette.primary || $86763ab82fa74def$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $86763ab82fa74def$var$getDefaultSecondary(mode);
    const error = palette.error || $86763ab82fa74def$var$getDefaultError(mode);
    const info = palette.info || $86763ab82fa74def$var$getDefaultInfo(mode);
    const success = palette.success || $86763ab82fa74def$var$getDefaultSuccess(mode);
    const warning = palette.warning || $86763ab82fa74def$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        if (colorSpace) return $86763ab82fa74def$export$b6e2ca4581a735cb(background);
        const contrastText = (0, $3289d56f59a873c2$export$d061e26956a60b0a)(background, $86763ab82fa74def$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $86763ab82fa74def$export$55ce6f3a06c59543.text.primary : $86763ab82fa74def$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $7052f9417b2e0e56$export$2e2bcd8739ae039)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $7052f9417b2e0e56$export$2e2bcd8739ae039)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        if (colorSpace) {
            $86763ab82fa74def$var$mixLightOrDark(colorSpace, color, 'light', lightShade, tonalOffset);
            $86763ab82fa74def$var$mixLightOrDark(colorSpace, color, 'dark', darkShade, tonalOffset);
        } else {
            $86763ab82fa74def$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
            $86763ab82fa74def$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        }
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $86763ab82fa74def$var$getLight();
    else if (mode === 'dark') modeHydrated = $86763ab82fa74def$var$getDark();
    const paletteOutput = (0, $a539fc8639d0a7b4$export$2e2bcd8739ae039)({
        // A collection of common colors.
        common: {
            ...(0, $4d4b47eab2d24330$export$2e2bcd8739ae039)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $fcc7f3d7aad5bcb9$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}




/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $fd4df960d2f1b12e$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}



/* eslint-disable import/prefer-default-export */ function $d437000e6cf02c2f$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}


/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $aa5bc96669276fac$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $aa5bc96669276fac$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $aa5bc96669276fac$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $aa5bc96669276fac$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $aa5bc96669276fac$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $aa5bc96669276fac$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $aa5bc96669276fac$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $aa5bc96669276fac$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}


function $79e903af749851ca$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector, enableContrastVars: enableContrastVars } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $aa5bc96669276fac$export$2e2bcd8739ae039)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $aa5bc96669276fac$export$2e2bcd8739ae039)(scheme, parserConfig);
        themeVars = (0, $a539fc8639d0a7b4$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $aa5bc96669276fac$export$2e2bcd8739ae039)(defaultScheme, parserConfig);
        themeVars = (0, $a539fc8639d0a7b4$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $a539fc8639d0a7b4$export$2e2bcd8739ae039)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        if (enableContrastVars) stylesheets.push({
            ':root': {
                // use double underscore to indicate that these are private variables
                '--__l-threshold': '0.7',
                '--__l': 'clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)',
                '--__a': 'clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)' // 0.87 is the default alpha value for black text.
            }
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $79e903af749851ca$export$2e2bcd8739ae039 = $79e903af749851ca$var$prepareCssVars;

function $05e540a97cb18af4$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}










function $53353c0badc3d9d5$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}




function $3160ea8415b7c6f2$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $3160ea8415b7c6f2$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $3160ea8415b7c6f2$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $3160ea8415b7c6f2$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $3160ea8415b7c6f2$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $3160ea8415b7c6f2$var$defaultFontFamily ? {
                letterSpacing: `${$3160ea8415b7c6f2$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $3160ea8415b7c6f2$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $3160ea8415b7c6f2$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $a539fc8639d0a7b4$export$2e2bcd8739ae039)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}


const $4b0a1e51c82fa5f3$var$shadowKeyUmbraOpacity = 0.2;
const $4b0a1e51c82fa5f3$var$shadowKeyPenumbraOpacity = 0.14;
const $4b0a1e51c82fa5f3$var$shadowAmbientShadowOpacity = 0.12;
function $4b0a1e51c82fa5f3$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$4b0a1e51c82fa5f3$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$4b0a1e51c82fa5f3$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$4b0a1e51c82fa5f3$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $4b0a1e51c82fa5f3$var$shadows = [
    'none',
    $4b0a1e51c82fa5f3$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $4b0a1e51c82fa5f3$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $4b0a1e51c82fa5f3$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $4b0a1e51c82fa5f3$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $4b0a1e51c82fa5f3$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $4b0a1e51c82fa5f3$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $4b0a1e51c82fa5f3$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $4b0a1e51c82fa5f3$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $4b0a1e51c82fa5f3$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $4b0a1e51c82fa5f3$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $4b0a1e51c82fa5f3$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $4b0a1e51c82fa5f3$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $4b0a1e51c82fa5f3$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $4b0a1e51c82fa5f3$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $4b0a1e51c82fa5f3$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $4b0a1e51c82fa5f3$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $4b0a1e51c82fa5f3$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $4b0a1e51c82fa5f3$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $4b0a1e51c82fa5f3$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $4b0a1e51c82fa5f3$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $4b0a1e51c82fa5f3$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $4b0a1e51c82fa5f3$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $4b0a1e51c82fa5f3$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $4b0a1e51c82fa5f3$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $4b0a1e51c82fa5f3$export$2e2bcd8739ae039 = $4b0a1e51c82fa5f3$var$shadows;


// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $9e70812d00b733f4$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $9e70812d00b733f4$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $9e70812d00b733f4$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $9e70812d00b733f4$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $9e70812d00b733f4$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$9e70812d00b733f4$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$9e70812d00b733f4$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $9e70812d00b733f4$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $9e70812d00b733f4$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $9e70812d00b733f4$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $2f2d611f8dba8cd1$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $2f2d611f8dba8cd1$export$2e2bcd8739ae039 = $2f2d611f8dba8cd1$var$zIndex;


/* eslint-disable import/prefer-default-export */ 
function $811e2d139dcc4fe4$var$isSerializable(val) {
    return (0, $a539fc8639d0a7b4$export$53b83ca8eaab0383)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $811e2d139dcc4fe4$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$811e2d139dcc4fe4$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $a539fc8639d0a7b4$export$53b83ca8eaab0383)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}


function $1009a72e9bceb565$var$coefficientToPercentage(coefficient) {
    if (typeof coefficient === 'number') return `${(coefficient * 100).toFixed(0)}%`;
    return `calc((${coefficient}) * 100%)`;
}
// This can be removed when moved to `color-mix()` entirely.
const $1009a72e9bceb565$var$parseAddition = (str)=>{
    if (!Number.isNaN(+str)) return +str;
    const numbers = str.match(/\d*\.?\d+/g);
    if (!numbers) return 0;
    let sum = 0;
    for(let i = 0; i < numbers.length; i += 1)sum += +numbers[i];
    return sum;
};
function $1009a72e9bceb565$var$attachColorManipulators(theme) {
    Object.assign(theme, {
        alpha (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `oklch(from ${color} l c h / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            if (obj.vars) // To preserve the behavior of the CSS theme variables
            // In the future, this could be replaced by `color-mix` (when https://caniuse.com/?search=color-mix reaches 95%).
            return `rgba(${color.replace(/var\(--([^,\s)]+)(?:,[^)]+)?\)+/g, 'var(--$1Channel)')} / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            return (0, $3289d56f59a873c2$export$58f0f39f63f3cf42)(color, $1009a72e9bceb565$var$parseAddition(coefficient));
        },
        lighten (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #fff ${$1009a72e9bceb565$var$coefficientToPercentage(coefficient)})`;
            return (0, $3289d56f59a873c2$export$c0816ed86df316af)(color, coefficient);
        },
        darken (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #000 ${$1009a72e9bceb565$var$coefficientToPercentage(coefficient)})`;
            return (0, $3289d56f59a873c2$export$4b073707ff63303)(color, coefficient);
        }
    });
}
function $1009a72e9bceb565$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, colorSpace: colorSpace, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $7052f9417b2e0e56$export$2e2bcd8739ae039)(20));
    const palette = (0, $86763ab82fa74def$export$2e2bcd8739ae039)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    const systemTheme = (0, $32d258d0759a439a$export$2e2bcd8739ae039)(options);
    let muiTheme = (0, $a539fc8639d0a7b4$export$2e2bcd8739ae039)(systemTheme, {
        mixins: (0, $53353c0badc3d9d5$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $4b0a1e51c82fa5f3$export$2e2bcd8739ae039).slice(),
        typography: (0, $3160ea8415b7c6f2$export$2e2bcd8739ae039)(palette, typographyInput),
        transitions: (0, $9e70812d00b733f4$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: {
            ...(0, $2f2d611f8dba8cd1$export$2e2bcd8739ae039)
        }
    });
    muiTheme = (0, $a539fc8639d0a7b4$export$2e2bcd8739ae039)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $a539fc8639d0a7b4$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $1ddc86c69bdbc815$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $bee7cb8e1c4d4571$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $811e2d139dcc4fe4$export$32c2afa5f91892aa); // for Pigment CSS integration
    $1009a72e9bceb565$var$attachColorManipulators(muiTheme);
    return muiTheme;
}
var $1009a72e9bceb565$export$2e2bcd8739ae039 = $1009a72e9bceb565$var$createThemeNoVars;



// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $61dc2be28a9690a5$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}


const $d460dda651ebe1bf$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $61dc2be28a9690a5$export$2e2bcd8739ae039)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $d460dda651ebe1bf$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $d460dda651ebe1bf$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $d460dda651ebe1bf$var$defaultDarkOverlays : [];
}
function $d460dda651ebe1bf$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, colorSpace: colorSpace, ...other } = options;
    // need to cast because `colorSpace` is considered internal at the moment.
    const palette = (0, $86763ab82fa74def$export$2e2bcd8739ae039)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    return {
        palette: palette,
        opacity: {
            ...$d460dda651ebe1bf$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $d460dda651ebe1bf$export$dd191566510330d3(palette.mode),
        ...other
    };
}


function $f3147a07bb4e3b11$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}


/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $b7b0244bcb11d3aa$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $b7b0244bcb11d3aa$export$2e2bcd8739ae039 = $b7b0244bcb11d3aa$var$excludeVariablesFromRoot;


var $74195e7318100f77$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $b7b0244bcb11d3aa$export$2e2bcd8739ae039)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };




function $84411e9c0e7aa6d7$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $84411e9c0e7aa6d7$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $84411e9c0e7aa6d7$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $3289d56f59a873c2$export$29fb7152bd3f781a)(color);
}
function $84411e9c0e7aa6d7$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $3289d56f59a873c2$export$427365fc3db6fc5e)($84411e9c0e7aa6d7$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $84411e9c0e7aa6d7$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $84411e9c0e7aa6d7$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $84411e9c0e7aa6d7$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $fd4df960d2f1b12e$export$2e2bcd8739ae039)(cssVarPrefix);
function $84411e9c0e7aa6d7$var$attachColorScheme(colorSpace, colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $d460dda651ebe1bf$export$2e2bcd8739ae039)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            },
            colorSpace: colorSpace
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $1009a72e9bceb565$export$2e2bcd8739ae039)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        },
        colorSpace: colorSpace
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $d460dda651ebe1bf$export$c85e0347fceb69ba)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $d460dda651ebe1bf$export$dd191566510330d3)(mode)
    };
    return muiTheme;
}
function $84411e9c0e7aa6d7$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', nativeColor: nativeColor = false, shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $f3147a07bb4e3b11$export$2e2bcd8739ae039), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $84411e9c0e7aa6d7$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $7052f9417b2e0e56$export$2e2bcd8739ae039)(21, defaultColorScheme));
    // The reason to use `oklch` is that it is the most perceptually uniform color space and widely supported.
    let colorSpace;
    if (nativeColor) colorSpace = 'oklch';
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $84411e9c0e7aa6d7$var$attachColorScheme(colorSpace, colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $84411e9c0e7aa6d7$var$attachColorScheme(colorSpace, colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $84411e9c0e7aa6d7$var$attachColorScheme(colorSpace, colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $05e540a97cb18af4$export$2e2bcd8739ae039)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $84411e9c0e7aa6d7$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $84411e9c0e7aa6d7$var$setColor(palette.common, 'background', '#fff');
            $84411e9c0e7aa6d7$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $84411e9c0e7aa6d7$var$setColor(palette.common, 'background', '#000');
            $84411e9c0e7aa6d7$var$setColor(palette.common, 'onBackground', '#fff');
        }
        function colorMix(method, color, coefficient) {
            if (colorSpace) {
                let mixer;
                if (method === (0, $3289d56f59a873c2$export$34109543fc7f43f8)) mixer = `transparent ${((1 - coefficient) * 100).toFixed(0)}%`;
                if (method === (0, $3289d56f59a873c2$export$eaaef2dca3e9e512)) mixer = `#000 ${(coefficient * 100).toFixed(0)}%`;
                if (method === (0, $3289d56f59a873c2$export$aeeda94ef1d01275)) mixer = `#fff ${(coefficient * 100).toFixed(0)}%`;
                return `color-mix(in ${colorSpace}, ${color}, ${mixer})`;
            }
            return method(color, coefficient);
        }
        // assign component variables
        $84411e9c0e7aa6d7$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'errorColor', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.error.light, 0.6));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'infoColor', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.info.light, 0.6));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'successColor', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.success.light, 0.6));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'warningColor', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.warning.light, 0.6));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'errorFilledColor', $84411e9c0e7aa6d7$var$silent(()=>palette.getContrastText(palette.error.main)));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'infoFilledColor', $84411e9c0e7aa6d7$var$silent(()=>palette.getContrastText(palette.info.main)));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'successFilledColor', $84411e9c0e7aa6d7$var$silent(()=>palette.getContrastText(palette.success.main)));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'warningFilledColor', $84411e9c0e7aa6d7$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.error.light, 0.9));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.info.light, 0.9));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.success.light, 0.9));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.warning.light, 0.9));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $84411e9c0e7aa6d7$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $84411e9c0e7aa6d7$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $84411e9c0e7aa6d7$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $84411e9c0e7aa6d7$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $84411e9c0e7aa6d7$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $84411e9c0e7aa6d7$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $84411e9c0e7aa6d7$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $84411e9c0e7aa6d7$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $84411e9c0e7aa6d7$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $84411e9c0e7aa6d7$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $84411e9c0e7aa6d7$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.primary.main, 0.62));
            $84411e9c0e7aa6d7$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.secondary.main, 0.62));
            $84411e9c0e7aa6d7$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.error.main, 0.62));
            $84411e9c0e7aa6d7$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.info.main, 0.62));
            $84411e9c0e7aa6d7$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.success.main, 0.62));
            $84411e9c0e7aa6d7$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.warning.main, 0.62));
            $84411e9c0e7aa6d7$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $3289d56f59a873c2$export$34109543fc7f43f8), palette.text.primary, 0.11) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $84411e9c0e7aa6d7$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.primary.main, 0.62));
            $84411e9c0e7aa6d7$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.secondary.main, 0.62));
            $84411e9c0e7aa6d7$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.error.main, 0.62));
            $84411e9c0e7aa6d7$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.info.main, 0.62));
            $84411e9c0e7aa6d7$var$setColor(palette.Slider, 'successTrack', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.success.main, 0.62));
            $84411e9c0e7aa6d7$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.warning.main, 0.62));
            const snackbarContentBackground = colorSpace ? colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.background.default, 0.6825) // use `0.6825` instead of `0.8` to match the contrast ratio of JS implementation
             : (0, $3289d56f59a873c2$export$11bb74ba10c85505)(palette.background.default, 0.8);
            $84411e9c0e7aa6d7$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $84411e9c0e7aa6d7$var$setColor(palette.SnackbarContent, 'color', $84411e9c0e7aa6d7$var$silent(()=>colorSpace ? (0, $86763ab82fa74def$export$55ce6f3a06c59543).text.primary : palette.getContrastText(snackbarContentBackground)));
            $84411e9c0e7aa6d7$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $3289d56f59a873c2$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $84411e9c0e7aa6d7$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $84411e9c0e7aa6d7$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $84411e9c0e7aa6d7$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $84411e9c0e7aa6d7$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $84411e9c0e7aa6d7$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.primary.main, 0.62));
            $84411e9c0e7aa6d7$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.secondary.main, 0.62));
            $84411e9c0e7aa6d7$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.error.main, 0.62));
            $84411e9c0e7aa6d7$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.info.main, 0.62));
            $84411e9c0e7aa6d7$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.success.main, 0.62));
            $84411e9c0e7aa6d7$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.warning.main, 0.62));
            $84411e9c0e7aa6d7$var$setColor(palette.TableCell, 'border', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), colorMix((0, $3289d56f59a873c2$export$34109543fc7f43f8), palette.divider, 1), 0.88));
            $84411e9c0e7aa6d7$var$setColor(palette.Tooltip, 'bg', colorMix((0, $3289d56f59a873c2$export$34109543fc7f43f8), palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'errorColor', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.error.light, 0.6));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'infoColor', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.info.light, 0.6));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'successColor', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.success.light, 0.6));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'warningColor', colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.warning.light, 0.6));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'errorFilledColor', $84411e9c0e7aa6d7$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'infoFilledColor', $84411e9c0e7aa6d7$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'successFilledColor', $84411e9c0e7aa6d7$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'warningFilledColor', $84411e9c0e7aa6d7$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.error.light, 0.9));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.info.light, 0.9));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.success.light, 0.9));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.warning.light, 0.9));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $84411e9c0e7aa6d7$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $84411e9c0e7aa6d7$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $84411e9c0e7aa6d7$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $84411e9c0e7aa6d7$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $84411e9c0e7aa6d7$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $84411e9c0e7aa6d7$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $84411e9c0e7aa6d7$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $84411e9c0e7aa6d7$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $84411e9c0e7aa6d7$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $84411e9c0e7aa6d7$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $84411e9c0e7aa6d7$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $84411e9c0e7aa6d7$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $84411e9c0e7aa6d7$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $84411e9c0e7aa6d7$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.primary.main, 0.5));
            $84411e9c0e7aa6d7$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.secondary.main, 0.5));
            $84411e9c0e7aa6d7$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.error.main, 0.5));
            $84411e9c0e7aa6d7$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.info.main, 0.5));
            $84411e9c0e7aa6d7$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.success.main, 0.5));
            $84411e9c0e7aa6d7$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.warning.main, 0.5));
            $84411e9c0e7aa6d7$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $3289d56f59a873c2$export$34109543fc7f43f8), palette.text.primary, 0.13) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $84411e9c0e7aa6d7$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.primary.main, 0.5));
            $84411e9c0e7aa6d7$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.secondary.main, 0.5));
            $84411e9c0e7aa6d7$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.error.main, 0.5));
            $84411e9c0e7aa6d7$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.info.main, 0.5));
            $84411e9c0e7aa6d7$var$setColor(palette.Slider, 'successTrack', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.success.main, 0.5));
            $84411e9c0e7aa6d7$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.warning.main, 0.5));
            const snackbarContentBackground = colorSpace ? colorMix((0, $3289d56f59a873c2$export$aeeda94ef1d01275), palette.background.default, 0.985) // use `0.985` instead of `0.98` to match the contrast ratio of JS implementation
             : (0, $3289d56f59a873c2$export$11bb74ba10c85505)(palette.background.default, 0.98);
            $84411e9c0e7aa6d7$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $84411e9c0e7aa6d7$var$setColor(palette.SnackbarContent, 'color', $84411e9c0e7aa6d7$var$silent(()=>colorSpace ? (0, $86763ab82fa74def$export$a43af521ac8c3202).text.primary : palette.getContrastText(snackbarContentBackground)));
            $84411e9c0e7aa6d7$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $3289d56f59a873c2$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $84411e9c0e7aa6d7$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $84411e9c0e7aa6d7$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $84411e9c0e7aa6d7$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $84411e9c0e7aa6d7$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $84411e9c0e7aa6d7$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.primary.main, 0.55));
            $84411e9c0e7aa6d7$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.secondary.main, 0.55));
            $84411e9c0e7aa6d7$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.error.main, 0.55));
            $84411e9c0e7aa6d7$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.info.main, 0.55));
            $84411e9c0e7aa6d7$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.success.main, 0.55));
            $84411e9c0e7aa6d7$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), palette.warning.main, 0.55));
            $84411e9c0e7aa6d7$var$setColor(palette.TableCell, 'border', colorMix((0, $3289d56f59a873c2$export$eaaef2dca3e9e512), colorMix((0, $3289d56f59a873c2$export$34109543fc7f43f8), palette.divider, 1), 0.68));
            $84411e9c0e7aa6d7$var$setColor(palette.Tooltip, 'bg', colorMix((0, $3289d56f59a873c2$export$34109543fc7f43f8), palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $84411e9c0e7aa6d7$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $84411e9c0e7aa6d7$var$setColorChannel(palette.background, 'paper');
        $84411e9c0e7aa6d7$var$setColorChannel(palette.common, 'background');
        $84411e9c0e7aa6d7$var$setColorChannel(palette.common, 'onBackground');
        $84411e9c0e7aa6d7$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $84411e9c0e7aa6d7$var$setColor(palette[color], 'mainChannel', (0, $3289d56f59a873c2$export$427365fc3db6fc5e)($84411e9c0e7aa6d7$var$toRgb(colors.main)));
                if (colors.light) $84411e9c0e7aa6d7$var$setColor(palette[color], 'lightChannel', (0, $3289d56f59a873c2$export$427365fc3db6fc5e)($84411e9c0e7aa6d7$var$toRgb(colors.light)));
                if (colors.dark) $84411e9c0e7aa6d7$var$setColor(palette[color], 'darkChannel', (0, $3289d56f59a873c2$export$427365fc3db6fc5e)($84411e9c0e7aa6d7$var$toRgb(colors.dark)));
                if (colors.contrastText) $84411e9c0e7aa6d7$var$setColor(palette[color], 'contrastTextChannel', (0, $3289d56f59a873c2$export$427365fc3db6fc5e)($84411e9c0e7aa6d7$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $84411e9c0e7aa6d7$var$setColorChannel(palette[color], 'primary');
                    $84411e9c0e7aa6d7$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $84411e9c0e7aa6d7$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $84411e9c0e7aa6d7$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $a539fc8639d0a7b4$export$2e2bcd8739ae039)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $74195e7318100f77$export$2e2bcd8739ae039)(theme),
        enableContrastVars: nativeColor
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $79e903af749851ca$export$2e2bcd8739ae039)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $824e58567897880e$export$2e2bcd8739ae039)(input.spacing, (0, $2cbe39ac70acf613$export$1def6f833384e3d1)(this));
    };
    theme.getColorSchemeSelector = (0, $d437000e6cf02c2f$export$858538ff6c0d421d)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $1ddc86c69bdbc815$export$2e2bcd8739ae039),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $bee7cb8e1c4d4571$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $811e2d139dcc4fe4$export$32c2afa5f91892aa); // for Pigment CSS integration
    return theme;
}



// eslint-disable-next-line consistent-return
function $c6bd6699c9daa002$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $86763ab82fa74def$export$2e2bcd8739ae039)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $c6bd6699c9daa002$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...other } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $1009a72e9bceb565$export$2e2bcd8739ae039)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $1009a72e9bceb565$export$2e2bcd8739ae039)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $c6bd6699c9daa002$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $c6bd6699c9daa002$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $84411e9c0e7aa6d7$export$2e2bcd8739ae039)({
        ...other,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}


'use client';
const $1501f617dbde04aa$var$defaultTheme = (0, $c6bd6699c9daa002$export$2e2bcd8739ae039)();
var $1501f617dbde04aa$export$2e2bcd8739ae039 = $1501f617dbde04aa$var$defaultTheme;


var $3abbb2670cc8edff$export$2e2bcd8739ae039 = '$$material';



'use client';
function $726d3fe46e12654c$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f3135bf3b34b1e0f$export$2e2bcd8739ae039), {
        ...props,
        defaultTheme: (0, $1501f617dbde04aa$export$2e2bcd8739ae039),
        themeId: (0, $3abbb2670cc8edff$export$2e2bcd8739ae039)
    });
}
var $726d3fe46e12654c$export$2e2bcd8739ae039 = $726d3fe46e12654c$var$GlobalStyles;


var $h4Bez = parcelRequire("h4Bez");
parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");


var $h4Bez = parcelRequire("h4Bez");



var $h4Bez = parcelRequire("h4Bez");
'use client';
const $b03fd3a7f20f7ad9$var$ThemeContext = /*#__PURE__*/ $h4Bez.createContext(null);
var $b03fd3a7f20f7ad9$export$2e2bcd8739ae039 = $b03fd3a7f20f7ad9$var$ThemeContext;



var $h4Bez = parcelRequire("h4Bez");

function $336fd3b64d0bd4ab$export$2e2bcd8739ae039() {
    const theme = $h4Bez.useContext((0, $b03fd3a7f20f7ad9$export$2e2bcd8739ae039));
    return theme;
}


const $56174e82908cd1ac$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $56174e82908cd1ac$export$2e2bcd8739ae039 = $56174e82908cd1ac$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



function $ede75a5710549436$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $ede75a5710549436$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $336fd3b64d0bd4ab$export$2e2bcd8739ae039)();
    const theme = $h4Bez.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $ede75a5710549436$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $56174e82908cd1ac$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b03fd3a7f20f7ad9$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $ede75a5710549436$export$2e2bcd8739ae039 = $ede75a5710549436$var$ThemeProvider;






var $h4Bez = parcelRequire("h4Bez");


'use client';
const $c12c19e2bf4d75c0$var$RtlContext = /*#__PURE__*/ $h4Bez.createContext();
function $c12c19e2bf4d75c0$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($c12c19e2bf4d75c0$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $c12c19e2bf4d75c0$export$b2dd014b6c321cb = ()=>{
    const value = $h4Bez.useContext($c12c19e2bf4d75c0$var$RtlContext);
    return value ?? false;
};
var $c12c19e2bf4d75c0$export$2e2bcd8739ae039 = $c12c19e2bf4d75c0$var$RtlProvider;



var $h4Bez = parcelRequire("h4Bez");

function $74096779e8c9e450$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $74096779e8c9e450$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $74096779e8c9e450$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $74096779e8c9e450$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $74096779e8c9e450$export$2e2bcd8739ae039 = $74096779e8c9e450$export$4f5d2d50c9deca37;


function $8a4b1f01109d1a9b$export$2e2bcd8739ae039(defaultProps, props, mergeClassNameAndStyle = false) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $8a4b1f01109d1a9b$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName], mergeClassNameAndStyle);
                }
            }
        } else if (propName === 'className' && mergeClassNameAndStyle && props.className) output.className = (0, $74096779e8c9e450$export$2e2bcd8739ae039)(defaultProps?.className, props?.className);
        else if (propName === 'style' && mergeClassNameAndStyle && props.style) output.style = {
            ...defaultProps?.style,
            ...props?.style
        };
        else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}



'use client';
const $3b37a68f494cca38$var$PropsContext = /*#__PURE__*/ $h4Bez.createContext(undefined);
function $3b37a68f494cca38$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($3b37a68f494cca38$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $3b37a68f494cca38$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $8a4b1f01109d1a9b$export$2e2bcd8739ae039)(config.defaultProps, props, theme.components.mergeClassNameAndStyle);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $8a4b1f01109d1a9b$export$2e2bcd8739ae039)(config, props, theme.components.mergeClassNameAndStyle);
    return props;
}
function $3b37a68f494cca38$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $h4Bez.useContext($3b37a68f494cca38$var$PropsContext);
    return $3b37a68f494cca38$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $3b37a68f494cca38$export$2e2bcd8739ae039 = $3b37a68f494cca38$var$DefaultPropsProvider;



var $h4Bez = parcelRequire("h4Bez");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $01a3a2b63fe8dafe$var$useEnhancedEffect = typeof window !== 'undefined' ? $h4Bez.useLayoutEffect : $h4Bez.useEffect;
var $01a3a2b63fe8dafe$export$2e2bcd8739ae039 = $01a3a2b63fe8dafe$var$useEnhancedEffect;



var $h4Bez = parcelRequire("h4Bez");
'use client';
let $8bcd24cec5c7b3d6$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $8bcd24cec5c7b3d6$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $h4Bez.useState(idOverride);
    const id = idOverride || defaultId;
    $h4Bez.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $8bcd24cec5c7b3d6$var$globalId += 1;
            setDefaultId(`mui-${$8bcd24cec5c7b3d6$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $8bcd24cec5c7b3d6$var$safeReact = {
    ...$h4Bez
};
const $8bcd24cec5c7b3d6$var$maybeReactUseId = $8bcd24cec5c7b3d6$var$safeReact.useId;
function $8bcd24cec5c7b3d6$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($8bcd24cec5c7b3d6$var$maybeReactUseId !== undefined) {
        const reactId = $8bcd24cec5c7b3d6$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $8bcd24cec5c7b3d6$var$useGlobalId(idOverride);
}





function $53b8a1419aa3541f$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $4609584b99dbdbe9$export$2e2bcd8739ae039)();
    const id = (0, $8bcd24cec5c7b3d6$export$2e2bcd8739ae039)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $01a3a2b63fe8dafe$export$2e2bcd8739ae039)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && firstChild.hasAttribute?.('data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else head.querySelector(`style[data-mui-layer-order="${id}"]`)?.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f3135bf3b34b1e0f$export$2e2bcd8739ae039), {
        styles: layerOrder
    });
}



'use client';
const $390819579c6c96e0$var$EMPTY_THEME = {};
function $390819579c6c96e0$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $h4Bez.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $390819579c6c96e0$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $4609584b99dbdbe9$export$2e2bcd8739ae039)($390819579c6c96e0$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $336fd3b64d0bd4ab$export$2e2bcd8739ae039)() || $390819579c6c96e0$var$EMPTY_THEME;
    const engineTheme = $390819579c6c96e0$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $390819579c6c96e0$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, $53b8a1419aa3541f$export$2e2bcd8739ae039)(engineTheme);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ede75a5710549436$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $216c71ed8edea623$export$971d5caa766a69d7).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c12c19e2bf4d75c0$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $3b37a68f494cca38$export$2e2bcd8739ae039), {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $390819579c6c96e0$export$2e2bcd8739ae039 = $390819579c6c96e0$var$ThemeProvider;




'use client';
function $2acf0a20adaae0b2$export$2e2bcd8739ae039({ theme: themeInput, ...props }) {
    const scopedTheme = (0, $3abbb2670cc8edff$export$2e2bcd8739ae039) in themeInput ? themeInput[0, $3abbb2670cc8edff$export$2e2bcd8739ae039] : undefined;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $390819579c6c96e0$export$2e2bcd8739ae039), {
        ...props,
        themeId: scopedTheme ? (0, $3abbb2670cc8edff$export$2e2bcd8739ae039) : undefined,
        theme: scopedTheme || themeInput
    });
}




var $h4Bez = parcelRequire("h4Bez");






const $0c3ba8d2bd072ae5$export$ff0fa3047d11164c = 'mode';
const $0c3ba8d2bd072ae5$export$665054ea9d94dab9 = 'color-scheme';
const $0c3ba8d2bd072ae5$export$14ebe5b26ee7fb38 = 'data-color-scheme';
function $0c3ba8d2bd072ae5$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $0c3ba8d2bd072ae5$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $0c3ba8d2bd072ae5$export$665054ea9d94dab9, attribute: initialAttribute = $0c3ba8d2bd072ae5$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^[\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else if (attribute !== '.%s') setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}



var $h4Bez = parcelRequire("h4Bez");

function $2035f700166d6daf$var$noop() {}
const $2035f700166d6daf$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $2035f700166d6daf$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $2035f700166d6daf$export$2e2bcd8739ae039 = $2035f700166d6daf$var$localStorageManager;


'use client';
function $862899c40b230c4b$var$noop() {}
function $862899c40b230c4b$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $862899c40b230c4b$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $862899c40b230c4b$export$3caa7590cc1987bd(state) {
    return $862899c40b230c4b$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $862899c40b230c4b$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $0c3ba8d2bd072ae5$export$ff0fa3047d11164c), colorSchemeStorageKey: colorSchemeStorageKey = (0, $0c3ba8d2bd072ae5$export$665054ea9d94dab9), storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = (0, $2035f700166d6daf$export$2e2bcd8739ae039), noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $h4Bez.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $h4Bez.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $h4Bez.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $h4Bez.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $862899c40b230c4b$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $h4Bez.useState(noSsr || !isMultiSchemes);
    $h4Bez.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $862899c40b230c4b$export$3caa7590cc1987bd(state);
    const setMode = $h4Bez.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $862899c40b230c4b$export$ab3d447356dfa3e5(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $h4Bez.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $862899c40b230c4b$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $h4Bez.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $h4Bez.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $h4Bez.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $h4Bez.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $862899c40b230c4b$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $862899c40b230c4b$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $862899c40b230c4b$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}



'use client';
const $e85261511b07c72e$export$c09f426c4535c3ec = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $e85261511b07c72e$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, $0c3ba8d2bd072ae5$export$ff0fa3047d11164c), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $0c3ba8d2bd072ae5$export$665054ea9d94dab9), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $h4Bez.createContext(undefined);
    const useColorScheme = ()=>$h4Bez.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $h4Bez.useRef(false);
        const upperTheme = (0, $336fd3b64d0bd4ab$export$2e2bcd8739ae039)();
        const ctx = $h4Bez.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $h4Bez.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $h4Bez.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $862899c40b230c4b$export$2e2bcd8739ae039)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $h4Bez.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $01a3a2b63fe8dafe$export$2e2bcd8739ae039)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $h4Bez.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($e85261511b07c72e$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $h4Bez.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $h4Bez.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($h4Bez.Fragment, {
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $390819579c6c96e0$export$2e2bcd8739ae039), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $cbdad6be451a22e4$export$2e2bcd8739ae039), {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $0c3ba8d2bd072ae5$export$2e2bcd8739ae039)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}








const $44df35cd3d3db2c3$export$f84bd70098573c5c = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
/**
 *
 * Demos:
 *
 * - [InitColorSchemeScript](https://mui.com/material-ui/react-init-color-scheme-script/)
 *
 * API:
 *
 * - [InitColorSchemeScript API](https://mui.com/material-ui/api/init-color-scheme-script/)
 */ function $44df35cd3d3db2c3$var$InitColorSchemeScript(props) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = $44df35cd3d3db2c3$export$f84bd70098573c5c.defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme = $44df35cd3d3db2c3$export$f84bd70098573c5c.defaultDarkColorScheme, modeStorageKey: modeStorageKey = $44df35cd3d3db2c3$export$f84bd70098573c5c.modeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = $44df35cd3d3db2c3$export$f84bd70098573c5c.colorSchemeStorageKey, attribute: initialAttribute = $44df35cd3d3db2c3$export$f84bd70098573c5c.attribute, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = props;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0c3ba8d2bd072ae5$export$2e2bcd8739ae039), {
        defaultMode: defaultMode,
        defaultLightColorScheme: defaultLightColorScheme,
        defaultDarkColorScheme: defaultDarkColorScheme,
        modeStorageKey: modeStorageKey,
        colorSchemeStorageKey: colorSchemeStorageKey,
        attribute: initialAttribute,
        colorSchemeNode: colorSchemeNode,
        nonce: nonce
    });
}
var $44df35cd3d3db2c3$export$2e2bcd8739ae039 = $44df35cd3d3db2c3$var$InitColorSchemeScript;



'use client';
const { CssVarsProvider: $27b78ceaed63fae1$var$InternalCssVarsProvider, useColorScheme: $27b78ceaed63fae1$export$6343629ee1b29116, getInitColorSchemeScript: $27b78ceaed63fae1$var$deprecatedGetInitColorSchemeScript } = (0, $e85261511b07c72e$export$2e2bcd8739ae039)({
    themeId: (0, $3abbb2670cc8edff$export$2e2bcd8739ae039),
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $c6bd6699c9daa002$export$2e2bcd8739ae039)({
            cssVariables: true
        }),
    colorSchemeStorageKey: (0, $44df35cd3d3db2c3$export$f84bd70098573c5c).colorSchemeStorageKey,
    modeStorageKey: (0, $44df35cd3d3db2c3$export$f84bd70098573c5c).modeStorageKey,
    defaultColorScheme: {
        light: (0, $44df35cd3d3db2c3$export$f84bd70098573c5c).defaultLightColorScheme,
        dark: (0, $44df35cd3d3db2c3$export$f84bd70098573c5c).defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $3160ea8415b7c6f2$export$2e2bcd8739ae039)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $bee7cb8e1c4d4571$export$2e2bcd8739ae039)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
let $27b78ceaed63fae1$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $27b78ceaed63fae1$export$99adf6d9ed169a14(props) {
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($27b78ceaed63fae1$var$InternalCssVarsProvider, {
        ...props
    });
}
let $27b78ceaed63fae1$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $27b78ceaed63fae1$export$f9a57b4a2abf8ed = (params)=>{
    if (!$27b78ceaed63fae1$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $27b78ceaed63fae1$var$warnedInitScriptOnce = true;
    }
    return $27b78ceaed63fae1$var$deprecatedGetInitColorSchemeScript(params);
};
const $27b78ceaed63fae1$export$50ec01b133c61652 = $27b78ceaed63fae1$var$InternalCssVarsProvider;




'use client';
function $bed3dc7f03d1e028$export$2e2bcd8739ae039({ theme: theme, ...props }) {
    const noVarsTheme = $h4Bez.useMemo(()=>{
        if (typeof theme === 'function') return theme;
        const muiTheme = (0, $3abbb2670cc8edff$export$2e2bcd8739ae039) in theme ? theme[0, $3abbb2670cc8edff$export$2e2bcd8739ae039] : theme;
        if (!('colorSchemes' in muiTheme)) {
            if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
            // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
            return {
                ...theme,
                vars: null
            };
            return theme;
        }
        return null;
    }, [
        theme
    ]);
    if (noVarsTheme) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2acf0a20adaae0b2$export$2e2bcd8739ae039), {
        theme: noVarsTheme,
        ...props
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $27b78ceaed63fae1$export$50ec01b133c61652), {
        theme: theme,
        ...props
    });
}



var $h4Bez = parcelRequire("h4Bez");

function $47a53d4026e1d774$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $47a53d4026e1d774$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $47a53d4026e1d774$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $47a53d4026e1d774$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $47a53d4026e1d774$export$2e2bcd8739ae039 = $47a53d4026e1d774$export$4f5d2d50c9deca37;


let $6ef99c9a893c902b$var$e = {
    data: ""
}, $6ef99c9a893c902b$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $6ef99c9a893c902b$var$e, $6ef99c9a893c902b$export$54aba348a7896325 = (e)=>{
    let r = $6ef99c9a893c902b$var$t(e), l = r.data;
    return r.data = "", l;
}, $6ef99c9a893c902b$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $6ef99c9a893c902b$var$a = /\/\*[^]*?\*\/|  +/g, $6ef99c9a893c902b$var$n = /\n+/g, $6ef99c9a893c902b$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $6ef99c9a893c902b$var$o(c, n) : n + "{" + $6ef99c9a893c902b$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $6ef99c9a893c902b$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $6ef99c9a893c902b$var$o.p ? $6ef99c9a893c902b$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $6ef99c9a893c902b$var$c = {}, $6ef99c9a893c902b$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $6ef99c9a893c902b$var$s(e[r]);
        return t;
    }
    return e;
}, $6ef99c9a893c902b$var$i = (e, t, r, i, p)=>{
    let u = $6ef99c9a893c902b$var$s(e), d = $6ef99c9a893c902b$var$c[u] || ($6ef99c9a893c902b$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$6ef99c9a893c902b$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $6ef99c9a893c902b$var$l.exec(e.replace($6ef99c9a893c902b$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($6ef99c9a893c902b$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($6ef99c9a893c902b$var$n, " ").trim();
            return o[0];
        })(e);
        $6ef99c9a893c902b$var$c[d] = $6ef99c9a893c902b$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $6ef99c9a893c902b$var$c.g ? $6ef99c9a893c902b$var$c.g : null;
    return r && ($6ef99c9a893c902b$var$c.g = $6ef99c9a893c902b$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($6ef99c9a893c902b$var$c[d], t, i, f), d;
}, $6ef99c9a893c902b$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $6ef99c9a893c902b$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $6ef99c9a893c902b$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $6ef99c9a893c902b$var$i(l.unshift ? l.raw ? $6ef99c9a893c902b$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $6ef99c9a893c902b$var$t(r.target), r.g, r.o, r.k);
}
let $6ef99c9a893c902b$var$d, $6ef99c9a893c902b$var$f, $6ef99c9a893c902b$var$g, $6ef99c9a893c902b$export$442f1a04865e4790 = $6ef99c9a893c902b$export$dbf350e5966cf602.bind({
    g: 1
}), $6ef99c9a893c902b$export$d25ddfdf17c3ad3e = $6ef99c9a893c902b$export$dbf350e5966cf602.bind({
    k: 1
});
function $6ef99c9a893c902b$export$de27182ff8187d6c(e, t, r, l) {
    $6ef99c9a893c902b$var$o.p = t, $6ef99c9a893c902b$var$d = e, $6ef99c9a893c902b$var$f = r, $6ef99c9a893c902b$var$g = l;
}
function $6ef99c9a893c902b$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $6ef99c9a893c902b$var$f && $6ef99c9a893c902b$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $6ef99c9a893c902b$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $6ef99c9a893c902b$var$g && i[0] && $6ef99c9a893c902b$var$g(c), $6ef99c9a893c902b$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}


function $dcf623fd84dea6d4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $dcf623fd84dea6d4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $dcf623fd84dea6d4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $dcf623fd84dea6d4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $dcf623fd84dea6d4$var$_extends() {
    $dcf623fd84dea6d4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dcf623fd84dea6d4$var$_extends.apply(this, arguments);
}
function $dcf623fd84dea6d4$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $dcf623fd84dea6d4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $dcf623fd84dea6d4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $dcf623fd84dea6d4$var$noOp = function noOp() {
    return '';
};
var $dcf623fd84dea6d4$var$SnackbarContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createContext({
    enqueueSnackbar: $dcf623fd84dea6d4$var$noOp,
    closeSnackbar: $dcf623fd84dea6d4$var$noOp
});
var $dcf623fd84dea6d4$var$breakpoints = {
    downXs: '@media (max-width:599.95px)',
    upSm: '@media (min-width:600px)'
};
var $dcf623fd84dea6d4$var$capitalise = function capitalise(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
var $dcf623fd84dea6d4$var$originKeyExtractor = function originKeyExtractor(anchor) {
    return "" + $dcf623fd84dea6d4$var$capitalise(anchor.vertical) + $dcf623fd84dea6d4$var$capitalise(anchor.horizontal);
};
var $dcf623fd84dea6d4$var$isDefined = function isDefined(value) {
    return !!value || value === 0;
};
var $dcf623fd84dea6d4$var$UNMOUNTED = 'unmounted';
var $dcf623fd84dea6d4$var$EXITED = 'exited';
var $dcf623fd84dea6d4$var$ENTERING = 'entering';
var $dcf623fd84dea6d4$var$ENTERED = 'entered';
var $dcf623fd84dea6d4$var$EXITING = 'exiting';
var $dcf623fd84dea6d4$export$be58926105124dd4 = /*#__PURE__*/ function(_React$Component) {
    $dcf623fd84dea6d4$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var appear = props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props["in"]) {
            if (appear) {
                initialStatus = $dcf623fd84dea6d4$var$EXITED;
                _this.appearStatus = $dcf623fd84dea6d4$var$ENTERING;
            } else initialStatus = $dcf623fd84dea6d4$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $dcf623fd84dea6d4$var$UNMOUNTED;
        else initialStatus = $dcf623fd84dea6d4$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref["in"];
        if (nextIn && prevState.status === $dcf623fd84dea6d4$var$UNMOUNTED) return {
            status: $dcf623fd84dea6d4$var$EXITED
        };
        return null;
    };
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props["in"]) {
                if (status !== $dcf623fd84dea6d4$var$ENTERING && status !== $dcf623fd84dea6d4$var$ENTERED) nextStatus = $dcf623fd84dea6d4$var$ENTERING;
            } else if (status === $dcf623fd84dea6d4$var$ENTERING || status === $dcf623fd84dea6d4$var$ENTERED) nextStatus = $dcf623fd84dea6d4$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var enter = timeout;
        var exit = timeout;
        if (timeout != null && typeof timeout !== 'number' && typeof timeout !== 'string') {
            exit = timeout.exit;
            enter = timeout.enter;
        }
        return {
            exit: exit,
            enter: enter
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            this.cancelNextCallback();
            if (nextStatus === $dcf623fd84dea6d4$var$ENTERING) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $dcf623fd84dea6d4$var$EXITED) this.setState({
            status: $dcf623fd84dea6d4$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var isAppearing = mounting;
        var timeouts = this.getTimeouts();
        if (!mounting && !enter) {
            this.safeSetState({
                status: $dcf623fd84dea6d4$var$ENTERED
            }, function() {
                if (_this2.props.onEntered) _this2.props.onEntered(_this2.node, isAppearing);
            });
            return;
        }
        if (this.props.onEnter) this.props.onEnter(this.node, isAppearing);
        this.safeSetState({
            status: $dcf623fd84dea6d4$var$ENTERING
        }, function() {
            if (_this2.props.onEntering) _this2.props.onEntering(_this2.node, isAppearing);
            _this2.onTransitionEnd(timeouts.enter, function() {
                _this2.safeSetState({
                    status: $dcf623fd84dea6d4$var$ENTERED
                }, function() {
                    if (_this2.props.onEntered) _this2.props.onEntered(_this2.node, isAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $dcf623fd84dea6d4$var$EXITED
            }, function() {
                if (_this3.props.onExited) _this3.props.onExited(_this3.node);
            });
            return;
        }
        if (this.props.onExit) this.props.onExit(this.node);
        this.safeSetState({
            status: $dcf623fd84dea6d4$var$EXITING
        }, function() {
            if (_this3.props.onExiting) _this3.props.onExiting(_this3.node);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $dcf623fd84dea6d4$var$EXITED
                }, function() {
                    if (_this3.props.onExited) _this3.props.onExited(_this3.node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null && this.nextCallback.cancel) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function() {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback();
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!this.node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(this.node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $dcf623fd84dea6d4$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $dcf623fd84dea6d4$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return children(status, childProps);
    };
    $dcf623fd84dea6d4$var$_createClass(Transition, [
        {
            key: "node",
            get: function get() {
                var _this$props$nodeRef;
                var node = (_this$props$nodeRef = this.props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current;
                if (!node) throw new Error('notistack - Custom snackbar is not refForwarding');
                return node;
            }
        }
    ]);
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Component);
function $dcf623fd84dea6d4$var$noop() {}
$dcf623fd84dea6d4$export$be58926105124dd4.defaultProps = {
    "in": false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $dcf623fd84dea6d4$var$noop,
    onEntering: $dcf623fd84dea6d4$var$noop,
    onEntered: $dcf623fd84dea6d4$var$noop,
    onExit: $dcf623fd84dea6d4$var$noop,
    onExiting: $dcf623fd84dea6d4$var$noop,
    onExited: $dcf623fd84dea6d4$var$noop
};
/**
 * Credit to MUI team @ https://mui.com
 */ /**
 * passes {value} to {ref}
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $dcf623fd84dea6d4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}
function $dcf623fd84dea6d4$var$useForkRef(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return (0, $h4Bez.useMemo)(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            $dcf623fd84dea6d4$var$setRef(refA, refValue);
            $dcf623fd84dea6d4$var$setRef(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}
function $dcf623fd84dea6d4$var$getTransitionProps(props) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style, mode = props.mode;
    return {
        duration: typeof timeout === 'object' ? timeout[mode] || 0 : timeout,
        easing: style.transitionTimingFunction,
        delay: style.transitionDelay
    };
}
/**
 * Credit to MUI team @ https://mui.com
 */ var $dcf623fd84dea6d4$var$defaultEasing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
/**
 * CSS hack to force a repaint
 */ var $dcf623fd84dea6d4$var$reflow = function reflow(node) {
    // We have to do something with node.scrollTop.
    // Otherwise it's removed from the compiled code by optimisers
    // eslint-disable-next-line no-self-assign
    node.scrollTop = node.scrollTop;
};
var $dcf623fd84dea6d4$var$formatMs = function formatMs(milliseconds) {
    return Math.round(milliseconds) + "ms";
};
function $dcf623fd84dea6d4$var$createTransition(props, options) {
    if (props === void 0) props = [
        'all'
    ];
    var _ref = options || {}, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 300 : _ref$duration, _ref$easing = _ref.easing, easing = _ref$easing === void 0 ? $dcf623fd84dea6d4$var$defaultEasing.easeInOut : _ref$easing, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay;
    var properties = Array.isArray(props) ? props : [
        props
    ];
    return properties.map(function(animatedProp) {
        var formattedDuration = typeof duration === 'string' ? duration : $dcf623fd84dea6d4$var$formatMs(duration);
        var formattedDelay = typeof delay === 'string' ? delay : $dcf623fd84dea6d4$var$formatMs(delay);
        return animatedProp + " " + formattedDuration + " " + easing + " " + formattedDelay;
    }).join(',');
}
function $dcf623fd84dea6d4$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}
function $dcf623fd84dea6d4$var$ownerWindow(node) {
    var doc = $dcf623fd84dea6d4$var$ownerDocument(node);
    return doc.defaultView || window;
}
/**
 * Corresponds to 10 frames at 60 Hz.
 * A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
 */ function $dcf623fd84dea6d4$var$debounce(func, wait) {
    if (wait === void 0) wait = 166;
    var timeout;
    function debounced() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var later = function later() {
            // @ts-ignore
            func.apply(_this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}
/**
 * Translate the node so it can't be seen on the screen.
 * Later, we're going to translate the node back to its original location with `none`.
 */ function $dcf623fd84dea6d4$var$getTranslateValue(direction, node) {
    var rect = node.getBoundingClientRect();
    var containerWindow = $dcf623fd84dea6d4$var$ownerWindow(node);
    var transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        var computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    var offsetX = 0;
    var offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    switch(direction){
        case 'left':
            return "translateX(" + (containerWindow.innerWidth + offsetX - rect.left) + "px)";
        case 'right':
            return "translateX(-" + (rect.left + rect.width - offsetX) + "px)";
        case 'up':
            return "translateY(" + (containerWindow.innerHeight + offsetY - rect.top) + "px)";
        default:
            // down
            return "translateY(-" + (rect.top + rect.height - offsetY) + "px)";
    }
}
function $dcf623fd84dea6d4$var$setTranslateValue(direction, node) {
    if (!node) return;
    var transform = $dcf623fd84dea6d4$var$getTranslateValue(direction, node);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
var $dcf623fd84dea6d4$var$Slide = /*#__PURE__*/ (0, $h4Bez.forwardRef)(function(props, ref) {
    var children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? 'down' : _props$direction, inProp = props["in"], style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? 0 : _props$timeout, onEnter = props.onEnter, onEntered = props.onEntered, onExit = props.onExit, onExited = props.onExited, other = $dcf623fd84dea6d4$var$_objectWithoutPropertiesLoose(props, [
        "children",
        "direction",
        "in",
        "style",
        "timeout",
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ]);
    var nodeRef = (0, $h4Bez.useRef)(null);
    var handleRefIntermediary = $dcf623fd84dea6d4$var$useForkRef(children.ref, nodeRef);
    var handleRef = $dcf623fd84dea6d4$var$useForkRef(handleRefIntermediary, ref);
    var handleEnter = function handleEnter(node, isAppearing) {
        $dcf623fd84dea6d4$var$setTranslateValue(direction, node);
        $dcf623fd84dea6d4$var$reflow(node);
        if (onEnter) onEnter(node, isAppearing);
    };
    var handleEntering = function handleEntering(node) {
        var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || $dcf623fd84dea6d4$var$defaultEasing.easeOut;
        var transitionProps = $dcf623fd84dea6d4$var$getTransitionProps({
            timeout: timeout,
            mode: 'enter',
            style: $dcf623fd84dea6d4$var$_extends({}, style, {
                transitionTimingFunction: easing
            })
        });
        node.style.webkitTransition = $dcf623fd84dea6d4$var$createTransition('-webkit-transform', transitionProps);
        node.style.transition = $dcf623fd84dea6d4$var$createTransition('transform', transitionProps);
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
    };
    var handleExit = function handleExit(node) {
        var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || $dcf623fd84dea6d4$var$defaultEasing.sharp;
        var transitionProps = $dcf623fd84dea6d4$var$getTransitionProps({
            timeout: timeout,
            mode: 'exit',
            style: $dcf623fd84dea6d4$var$_extends({}, style, {
                transitionTimingFunction: easing
            })
        });
        node.style.webkitTransition = $dcf623fd84dea6d4$var$createTransition('-webkit-transform', transitionProps);
        node.style.transition = $dcf623fd84dea6d4$var$createTransition('transform', transitionProps);
        $dcf623fd84dea6d4$var$setTranslateValue(direction, node);
        if (onExit) onExit(node);
    };
    var handleExited = function handleExited(node) {
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    };
    var updatePosition = (0, $h4Bez.useCallback)(function() {
        if (nodeRef.current) $dcf623fd84dea6d4$var$setTranslateValue(direction, nodeRef.current);
    }, [
        direction
    ]);
    (0, $h4Bez.useEffect)(function() {
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        var handleResize = $dcf623fd84dea6d4$var$debounce(function() {
            if (nodeRef.current) $dcf623fd84dea6d4$var$setTranslateValue(direction, nodeRef.current);
        });
        var containerWindow = $dcf623fd84dea6d4$var$ownerWindow(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp
    ]);
    (0, $h4Bez.useEffect)(function() {
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return (0, $h4Bez.createElement)($dcf623fd84dea6d4$export$be58926105124dd4, Object.assign({
        appear: true,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: onEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        "in": inProp,
        timeout: timeout
    }, other), function(state, childProps) {
        return (0, $h4Bez.cloneElement)(children, $dcf623fd84dea6d4$var$_extends({
            ref: handleRef,
            style: $dcf623fd84dea6d4$var$_extends({
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, style, {}, children.props.style)
        }, childProps));
    });
});
$dcf623fd84dea6d4$var$Slide.displayName = 'Slide';
var $dcf623fd84dea6d4$var$SvgIcon = function SvgIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("svg", Object.assign({
        viewBox: "0 0 24 24",
        focusable: "false",
        style: {
            fontSize: 20,
            marginInlineEnd: 8,
            userSelect: 'none',
            width: '1em',
            height: '1em',
            display: 'inline-block',
            fill: 'currentColor',
            flexShrink: 0
        }
    }, props));
};
var $dcf623fd84dea6d4$var$CheckIcon = function CheckIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($dcf623fd84dea6d4$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("path", {
        d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41\n        10.59L10 14.17L17.59 6.58L19 8L10 17Z"
    }));
};
var $dcf623fd84dea6d4$var$WarningIcon = function WarningIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($dcf623fd84dea6d4$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("path", {
        d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
    }));
};
var $dcf623fd84dea6d4$var$ErrorIcon = function ErrorIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($dcf623fd84dea6d4$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("path", {
        d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,\n        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,\n        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
    }));
};
var $dcf623fd84dea6d4$var$InfoIcon = function InfoIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($dcf623fd84dea6d4$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("path", {
        d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,\n        0 22,12A10,10 0 0,0 12,2Z"
    }));
};
var $dcf623fd84dea6d4$var$defaultIconVariants = {
    "default": undefined,
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($dcf623fd84dea6d4$var$CheckIcon, null),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($dcf623fd84dea6d4$var$WarningIcon, null),
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($dcf623fd84dea6d4$var$ErrorIcon, null),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($dcf623fd84dea6d4$var$InfoIcon, null)
};
var $dcf623fd84dea6d4$var$defaults = {
    maxSnack: 3,
    persist: false,
    hideIconVariant: false,
    disableWindowBlurListener: false,
    variant: 'default',
    autoHideDuration: 5000,
    iconVariant: $dcf623fd84dea6d4$var$defaultIconVariants,
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
    },
    TransitionComponent: $dcf623fd84dea6d4$var$Slide,
    transitionDuration: {
        enter: 225,
        exit: 195
    }
};
/**
 * Derives the right autoHideDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */ var $dcf623fd84dea6d4$var$getAutoHideDuration = function getAutoHideDuration(optionsDuration, propsDuration) {
    var isNumberOrNull = function isNumberOrNull(numberish) {
        return typeof numberish === 'number' || numberish === null;
    };
    if (isNumberOrNull(optionsDuration)) return optionsDuration;
    if (isNumberOrNull(propsDuration)) return propsDuration;
    return $dcf623fd84dea6d4$var$defaults.autoHideDuration;
};
/**
 * Derives the right transitionDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */ var $dcf623fd84dea6d4$var$getTransitionDuration = function getTransitionDuration(optionsDuration, propsDuration) {
    var is = function is(item, types) {
        return types.some(function(t) {
            return typeof item === t;
        });
    };
    if (is(optionsDuration, [
        'string',
        'number'
    ])) return optionsDuration;
    if (is(optionsDuration, [
        'object'
    ])) return $dcf623fd84dea6d4$var$_extends({}, $dcf623fd84dea6d4$var$defaults.transitionDuration, {}, is(propsDuration, [
        'object'
    ]) && propsDuration, {}, optionsDuration);
    if (is(propsDuration, [
        'string',
        'number'
    ])) return propsDuration;
    if (is(propsDuration, [
        'object'
    ])) return $dcf623fd84dea6d4$var$_extends({}, $dcf623fd84dea6d4$var$defaults.transitionDuration, {}, propsDuration);
    return $dcf623fd84dea6d4$var$defaults.transitionDuration;
};
var $dcf623fd84dea6d4$var$merge = function merge(options, props) {
    return function(name, shouldObjectMerge) {
        if (shouldObjectMerge === void 0) shouldObjectMerge = false;
        if (shouldObjectMerge) return $dcf623fd84dea6d4$var$_extends({}, $dcf623fd84dea6d4$var$defaults[name], {}, props[name], {}, options[name]);
        if (name === 'autoHideDuration') return $dcf623fd84dea6d4$var$getAutoHideDuration(options.autoHideDuration, props.autoHideDuration);
        if (name === 'transitionDuration') return $dcf623fd84dea6d4$var$getTransitionDuration(options.transitionDuration, props.transitionDuration);
        return options[name] || props[name] || $dcf623fd84dea6d4$var$defaults[name];
    };
};
function $dcf623fd84dea6d4$var$makeStyles(styles) {
    return Object.entries(styles).reduce(function(acc, _ref) {
        var _extends2;
        var key = _ref[0], value = _ref[1];
        return $dcf623fd84dea6d4$var$_extends({}, acc, (_extends2 = {}, _extends2[key] = (0, $6ef99c9a893c902b$export$dbf350e5966cf602)(value), _extends2));
    }, {});
}
var $dcf623fd84dea6d4$var$ComponentClasses = {
    SnackbarContainer: 'notistack-SnackbarContainer',
    Snackbar: 'notistack-Snackbar',
    CollapseWrapper: 'notistack-CollapseWrapper',
    MuiContent: 'notistack-MuiContent',
    MuiContentVariant: function MuiContentVariant(variant) {
        return "notistack-MuiContent-" + variant;
    }
};
var $dcf623fd84dea6d4$var$classes = /*#__PURE__*/ $dcf623fd84dea6d4$var$makeStyles({
    root: {
        height: 0
    },
    entered: {
        height: 'auto'
    }
});
var $dcf623fd84dea6d4$var$collapsedSize = '0px';
var $dcf623fd84dea6d4$var$timeout = 175;
var $dcf623fd84dea6d4$var$Collapse = /*#__PURE__*/ (0, $h4Bez.forwardRef)(function(props, ref) {
    var children = props.children, inProp = props["in"], onExited = props.onExited;
    var wrapperRef = (0, $h4Bez.useRef)(null);
    var nodeRef = (0, $h4Bez.useRef)(null);
    var handleRef = $dcf623fd84dea6d4$var$useForkRef(ref, nodeRef);
    var getWrapperSize = function getWrapperSize() {
        return wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    };
    var handleEnter = function handleEnter(node) {
        node.style.height = $dcf623fd84dea6d4$var$collapsedSize;
    };
    var handleEntering = function handleEntering(node) {
        var wrapperSize = getWrapperSize();
        var _getTransitionProps = $dcf623fd84dea6d4$var$getTransitionProps({
            timeout: $dcf623fd84dea6d4$var$timeout,
            mode: 'enter'
        }), transitionDuration = _getTransitionProps.duration, easing = _getTransitionProps.easing;
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + "ms";
        node.style.height = wrapperSize + "px";
        node.style.transitionTimingFunction = easing || '';
    };
    var handleEntered = function handleEntered(node) {
        node.style.height = 'auto';
    };
    var handleExit = function handleExit(node) {
        node.style.height = getWrapperSize() + "px";
    };
    var handleExiting = function handleExiting(node) {
        $dcf623fd84dea6d4$var$reflow(node);
        var _getTransitionProps2 = $dcf623fd84dea6d4$var$getTransitionProps({
            timeout: $dcf623fd84dea6d4$var$timeout,
            mode: 'exit'
        }), transitionDuration = _getTransitionProps2.duration, easing = _getTransitionProps2.easing;
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + "ms";
        node.style.height = $dcf623fd84dea6d4$var$collapsedSize;
        node.style.transitionTimingFunction = easing || '';
    };
    return (0, $h4Bez.createElement)($dcf623fd84dea6d4$export$be58926105124dd4, {
        "in": inProp,
        unmountOnExit: true,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: onExited,
        onExiting: handleExiting,
        nodeRef: nodeRef,
        timeout: $dcf623fd84dea6d4$var$timeout
    }, function(state, childProps) {
        return (0, $h4Bez.createElement)("div", Object.assign({
            ref: handleRef,
            className: (0, $47a53d4026e1d774$export$2e2bcd8739ae039)($dcf623fd84dea6d4$var$classes.root, state === 'entered' && $dcf623fd84dea6d4$var$classes.entered),
            style: $dcf623fd84dea6d4$var$_extends({
                pointerEvents: 'all',
                overflow: 'hidden',
                minHeight: $dcf623fd84dea6d4$var$collapsedSize,
                transition: $dcf623fd84dea6d4$var$createTransition('height')
            }, state === 'entered' && {
                overflow: 'visible'
            }, {}, state === 'exited' && !inProp && {
                visibility: 'hidden'
            })
        }, childProps), (0, $h4Bez.createElement)("div", {
            ref: wrapperRef,
            className: $dcf623fd84dea6d4$var$ComponentClasses.CollapseWrapper,
            // Hack to get children with a negative margin to not falsify the height computation.
            style: {
                display: 'flex',
                width: '100%'
            }
        }, children));
    });
});
$dcf623fd84dea6d4$var$Collapse.displayName = 'Collapse';
var $dcf623fd84dea6d4$var$direction = {
    right: 'left',
    left: 'right',
    bottom: 'up',
    top: 'down'
};
var $dcf623fd84dea6d4$var$getSlideDirection = function getSlideDirection(anchorOrigin) {
    if (anchorOrigin.horizontal !== 'center') return $dcf623fd84dea6d4$var$direction[anchorOrigin.horizontal];
    return $dcf623fd84dea6d4$var$direction[anchorOrigin.vertical];
};
/** Tranforms classes name */ var $dcf623fd84dea6d4$var$toSnackbarAnchorOrigin = function toSnackbarAnchorOrigin(anchorOrigin) {
    return "anchorOrigin" + $dcf623fd84dea6d4$var$originKeyExtractor(anchorOrigin);
};
/**
 * Omit SnackbarContainer class keys that are not needed for SnackbarItem
 */ var $dcf623fd84dea6d4$var$keepSnackbarClassKeys = function keepSnackbarClassKeys(classes) {
    if (classes === void 0) classes = {};
    var containerClasses = {
        containerRoot: true,
        containerAnchorOriginTopCenter: true,
        containerAnchorOriginBottomCenter: true,
        containerAnchorOriginTopRight: true,
        containerAnchorOriginBottomRight: true,
        containerAnchorOriginTopLeft: true,
        containerAnchorOriginBottomLeft: true
    };
    return Object.keys(classes).filter(function(key) {
        return !containerClasses[key];
    }).reduce(function(obj, key) {
        var _extends2;
        return $dcf623fd84dea6d4$var$_extends({}, obj, (_extends2 = {}, _extends2[key] = classes[key], _extends2));
    }, {});
};
var $dcf623fd84dea6d4$var$noOp$1 = function noOp() {
/* */ };
/**
 * Credit to MUI team @ https://mui.com
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $dcf623fd84dea6d4$var$createChainedFunction(funcs, snackbarId) {
    // @ts-ignore
    return funcs.reduce(function(acc, func) {
        if (func === null || func === undefined) return acc;
        return function chainedFunction() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var argums = [].concat(args);
            if (snackbarId && argums.indexOf(snackbarId) === -1) argums.push(snackbarId);
             // @ts-ignore
            acc.apply(this, argums);
            func.apply(this, argums);
        };
    }, $dcf623fd84dea6d4$var$noOp$1);
}
/**
 * Credit to MUI team @ https://mui.com
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */ var $dcf623fd84dea6d4$var$useEnhancedEffect = typeof window !== 'undefined' ? (0, $h4Bez.useLayoutEffect) : (0, $h4Bez.useEffect);
function $dcf623fd84dea6d4$var$useEventCallback(fn) {
    var ref = (0, $h4Bez.useRef)(fn);
    $dcf623fd84dea6d4$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return (0, $h4Bez.useCallback)(function() {
        return ref.current.apply(void 0, arguments);
    }, []);
}
/**
 * Credit to MUI team @ https://mui.com
 */ var $dcf623fd84dea6d4$var$Snackbar = /*#__PURE__*/ (0, $h4Bez.forwardRef)(function(props, ref) {
    var children = props.children, className = props.className, autoHideDuration = props.autoHideDuration, _props$disableWindowB = props.disableWindowBlurListener, disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB, onClose = props.onClose, id = props.id, open = props.open, _props$SnackbarProps = props.SnackbarProps, SnackbarProps = _props$SnackbarProps === void 0 ? {} : _props$SnackbarProps;
    var timerAutoHide = (0, $h4Bez.useRef)();
    var handleClose = $dcf623fd84dea6d4$var$useEventCallback(function() {
        if (onClose) onClose.apply(void 0, arguments);
    });
    var setAutoHideTimer = $dcf623fd84dea6d4$var$useEventCallback(function(autoHideDurationParam) {
        if (!onClose || autoHideDurationParam == null) return;
        if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(function() {
            handleClose(null, 'timeout', id);
        }, autoHideDurationParam);
    });
    (0, $h4Bez.useEffect)(function() {
        if (open) setAutoHideTimer(autoHideDuration);
        return function() {
            if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]);
    /**
   * Pause the timer when the user is interacting with the Snackbar
   * or when the user hide the window.
   */ var handlePause = function handlePause() {
        if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
    };
    /**
   * Restart the timer when the user is no longer interacting with the Snackbar
   * or when the window is shown back.
   */ var handleResume = (0, $h4Bez.useCallback)(function() {
        if (autoHideDuration != null) setAutoHideTimer(autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        setAutoHideTimer
    ]);
    var handleMouseEnter = function handleMouseEnter(event) {
        if (SnackbarProps.onMouseEnter) SnackbarProps.onMouseEnter(event);
        handlePause();
    };
    var handleMouseLeave = function handleMouseLeave(event) {
        if (SnackbarProps.onMouseLeave) SnackbarProps.onMouseLeave(event);
        handleResume();
    };
    (0, $h4Bez.useEffect)(function() {
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return function() {
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    return (0, $h4Bez.createElement)("div", Object.assign({
        ref: ref
    }, SnackbarProps, {
        className: (0, $47a53d4026e1d774$export$2e2bcd8739ae039)($dcf623fd84dea6d4$var$ComponentClasses.Snackbar, className),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    }), children);
});
$dcf623fd84dea6d4$var$Snackbar.displayName = 'Snackbar';
var $dcf623fd84dea6d4$var$_root;
var $dcf623fd84dea6d4$var$classes$1 = /*#__PURE__*/ $dcf623fd84dea6d4$var$makeStyles({
    root: ($dcf623fd84dea6d4$var$_root = {
        display: 'flex',
        flexWrap: 'wrap',
        flexGrow: 1
    }, $dcf623fd84dea6d4$var$_root[$dcf623fd84dea6d4$var$breakpoints.upSm] = {
        flexGrow: 'initial',
        minWidth: '288px'
    }, $dcf623fd84dea6d4$var$_root)
});
var $dcf623fd84dea6d4$export$860cef82710cac7 = /*#__PURE__*/ (0, $h4Bez.forwardRef)(function(_ref, ref) {
    var className = _ref.className, props = $dcf623fd84dea6d4$var$_objectWithoutPropertiesLoose(_ref, [
        "className"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("div", Object.assign({
        ref: ref,
        className: (0, $47a53d4026e1d774$export$2e2bcd8739ae039)($dcf623fd84dea6d4$var$classes$1.root, className)
    }, props));
});
$dcf623fd84dea6d4$export$860cef82710cac7.displayName = 'SnackbarContent';
var $dcf623fd84dea6d4$var$classes$2 = /*#__PURE__*/ $dcf623fd84dea6d4$var$makeStyles({
    root: {
        backgroundColor: '#313131',
        fontSize: '0.875rem',
        lineHeight: 1.43,
        letterSpacing: '0.01071em',
        color: '#fff',
        alignItems: 'center',
        padding: '6px 16px',
        borderRadius: '4px',
        boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)'
    },
    lessPadding: {
        paddingLeft: "20px"
    },
    "default": {
        backgroundColor: '#313131'
    },
    success: {
        backgroundColor: '#43a047'
    },
    error: {
        backgroundColor: '#d32f2f'
    },
    warning: {
        backgroundColor: '#ff9800'
    },
    info: {
        backgroundColor: '#2196f3'
    },
    message: {
        display: 'flex',
        alignItems: 'center',
        padding: '8px 0'
    },
    action: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
        paddingLeft: '16px',
        marginRight: '-8px'
    }
});
var $dcf623fd84dea6d4$var$ariaDescribedby = 'notistack-snackbar';
var $dcf623fd84dea6d4$var$MaterialDesignContent = /*#__PURE__*/ (0, $h4Bez.forwardRef)(function(props, forwardedRef) {
    var id = props.id, message = props.message, componentOrFunctionAction = props.action, iconVariant = props.iconVariant, variant = props.variant, hideIconVariant = props.hideIconVariant, style = props.style, className = props.className;
    var icon = iconVariant[variant];
    var action = componentOrFunctionAction;
    if (typeof action === 'function') action = action(id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($dcf623fd84dea6d4$export$860cef82710cac7, {
        ref: forwardedRef,
        role: "alert",
        "aria-describedby": $dcf623fd84dea6d4$var$ariaDescribedby,
        style: style,
        className: (0, $47a53d4026e1d774$export$2e2bcd8739ae039)($dcf623fd84dea6d4$var$ComponentClasses.MuiContent, $dcf623fd84dea6d4$var$ComponentClasses.MuiContentVariant(variant), $dcf623fd84dea6d4$var$classes$2.root, $dcf623fd84dea6d4$var$classes$2[variant], className, !hideIconVariant && icon && $dcf623fd84dea6d4$var$classes$2.lessPadding)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("div", {
        id: $dcf623fd84dea6d4$var$ariaDescribedby,
        className: $dcf623fd84dea6d4$var$classes$2.message
    }, !hideIconVariant ? icon : null, message), action && (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("div", {
        className: $dcf623fd84dea6d4$var$classes$2.action
    }, action));
});
$dcf623fd84dea6d4$var$MaterialDesignContent.displayName = 'MaterialDesignContent';
var $dcf623fd84dea6d4$export$407b0b907b65dfeb = /*#__PURE__*/ (0, $h4Bez.memo)($dcf623fd84dea6d4$var$MaterialDesignContent);
var $dcf623fd84dea6d4$var$styles = /*#__PURE__*/ $dcf623fd84dea6d4$var$makeStyles({
    wrappedRoot: {
        width: '100%',
        position: 'relative',
        transform: 'translateX(0)',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        minWidth: '288px'
    }
});
var $dcf623fd84dea6d4$var$SnackbarItem = function SnackbarItem(props) {
    var timeout = (0, $h4Bez.useRef)();
    var _useState = (0, $h4Bez.useState)(true), collapsed = _useState[0], setCollapsed = _useState[1];
    var handleClose = $dcf623fd84dea6d4$var$createChainedFunction([
        props.snack.onClose,
        props.onClose
    ]);
    var handleEntered = function handleEntered() {
        if (props.snack.requestClose) handleClose(null, 'instructed', props.snack.id);
    };
    var handleExitedScreen = (0, $h4Bez.useCallback)(function() {
        timeout.current = setTimeout(function() {
            setCollapsed(function(col) {
                return !col;
            });
        }, 125);
    }, []);
    (0, $h4Bez.useEffect)(function() {
        return function() {
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, []);
    var snack = props.snack, allClasses = props.classes, _props$Component = props.Component, Component = _props$Component === void 0 ? $dcf623fd84dea6d4$export$407b0b907b65dfeb : _props$Component;
    var classes = (0, $h4Bez.useMemo)(function() {
        return $dcf623fd84dea6d4$var$keepSnackbarClassKeys(allClasses);
    }, [
        allClasses
    ]);
    var open = snack.open, SnackbarProps = snack.SnackbarProps, TransitionComponent = snack.TransitionComponent, TransitionProps = snack.TransitionProps, transitionDuration = snack.transitionDuration, disableWindowBlurListener = snack.disableWindowBlurListener, componentOrFunctionContent = snack.content, otherSnack = $dcf623fd84dea6d4$var$_objectWithoutPropertiesLoose(snack, [
        "open",
        "SnackbarProps",
        "TransitionComponent",
        "TransitionProps",
        "transitionDuration",
        "disableWindowBlurListener",
        "content",
        "entered",
        "requestClose",
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ]);
    var transitionProps = $dcf623fd84dea6d4$var$_extends({
        direction: $dcf623fd84dea6d4$var$getSlideDirection(otherSnack.anchorOrigin),
        timeout: transitionDuration
    }, TransitionProps);
    var content = componentOrFunctionContent;
    if (typeof content === 'function') content = content(otherSnack.id, otherSnack.message);
    var callbacks = [
        'onEnter',
        'onEntered',
        'onExit',
        'onExited'
    ].reduce(function(acc, cbName) {
        var _extends2;
        return $dcf623fd84dea6d4$var$_extends({}, acc, (_extends2 = {}, _extends2[cbName] = $dcf623fd84dea6d4$var$createChainedFunction([
            props.snack[cbName],
            props[cbName]
        ], otherSnack.id), _extends2));
    }, {});
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($dcf623fd84dea6d4$var$Collapse, {
        "in": collapsed,
        onExited: callbacks.onExited
    }, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($dcf623fd84dea6d4$var$Snackbar, {
        open: open,
        id: otherSnack.id,
        disableWindowBlurListener: disableWindowBlurListener,
        autoHideDuration: otherSnack.autoHideDuration,
        className: (0, $47a53d4026e1d774$export$2e2bcd8739ae039)($dcf623fd84dea6d4$var$styles.wrappedRoot, classes.root, classes[$dcf623fd84dea6d4$var$toSnackbarAnchorOrigin(otherSnack.anchorOrigin)]),
        SnackbarProps: SnackbarProps,
        onClose: handleClose
    }, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(TransitionComponent, Object.assign({}, transitionProps, {
        appear: true,
        "in": open,
        onExit: callbacks.onExit,
        onExited: handleExitedScreen,
        onEnter: callbacks.onEnter,
        // order matters. first callbacks.onEntered to set entered: true,
        // then handleEntered to check if there's a request for closing
        onEntered: $dcf623fd84dea6d4$var$createChainedFunction([
            callbacks.onEntered,
            handleEntered
        ], otherSnack.id)
    }), content || (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(Component, Object.assign({}, otherSnack)))));
};
var $dcf623fd84dea6d4$var$_root$1, $dcf623fd84dea6d4$var$_rootDense, $dcf623fd84dea6d4$var$_left, $dcf623fd84dea6d4$var$_right, $dcf623fd84dea6d4$var$_center;
var $dcf623fd84dea6d4$var$indents = {
    view: {
        "default": 20,
        dense: 4
    },
    snackbar: {
        "default": 6,
        dense: 2
    }
};
var $dcf623fd84dea6d4$var$collapseWrapper = "." + $dcf623fd84dea6d4$var$ComponentClasses.CollapseWrapper;
var $dcf623fd84dea6d4$var$xsWidthMargin = 16;
var $dcf623fd84dea6d4$var$styles$1 = /*#__PURE__*/ $dcf623fd84dea6d4$var$makeStyles({
    root: ($dcf623fd84dea6d4$var$_root$1 = {
        boxSizing: 'border-box',
        display: 'flex',
        maxHeight: '100%',
        position: 'fixed',
        zIndex: 1400,
        height: 'auto',
        width: 'auto',
        transition: /*#__PURE__*/ $dcf623fd84dea6d4$var$createTransition([
            'top',
            'right',
            'bottom',
            'left',
            'max-width'
        ], {
            duration: 300,
            easing: 'ease'
        }),
        // container itself is invisible and should not block clicks, clicks should be passed to its children
        // a pointerEvents: all is applied in the collapse component
        pointerEvents: 'none'
    }, $dcf623fd84dea6d4$var$_root$1[$dcf623fd84dea6d4$var$collapseWrapper] = {
        padding: $dcf623fd84dea6d4$var$indents.snackbar["default"] + "px 0px",
        transition: 'padding 300ms ease 0ms'
    }, $dcf623fd84dea6d4$var$_root$1.maxWidth = "calc(100% - " + $dcf623fd84dea6d4$var$indents.view["default"] * 2 + "px)", $dcf623fd84dea6d4$var$_root$1[$dcf623fd84dea6d4$var$breakpoints.downXs] = {
        width: '100%',
        maxWidth: "calc(100% - " + $dcf623fd84dea6d4$var$xsWidthMargin * 2 + "px)"
    }, $dcf623fd84dea6d4$var$_root$1),
    rootDense: ($dcf623fd84dea6d4$var$_rootDense = {}, $dcf623fd84dea6d4$var$_rootDense[$dcf623fd84dea6d4$var$collapseWrapper] = {
        padding: $dcf623fd84dea6d4$var$indents.snackbar.dense + "px 0px"
    }, $dcf623fd84dea6d4$var$_rootDense),
    top: {
        top: $dcf623fd84dea6d4$var$indents.view["default"] - $dcf623fd84dea6d4$var$indents.snackbar["default"] + "px",
        flexDirection: 'column'
    },
    bottom: {
        bottom: $dcf623fd84dea6d4$var$indents.view["default"] - $dcf623fd84dea6d4$var$indents.snackbar["default"] + "px",
        flexDirection: 'column-reverse'
    },
    left: ($dcf623fd84dea6d4$var$_left = {
        left: $dcf623fd84dea6d4$var$indents.view["default"] + "px"
    }, $dcf623fd84dea6d4$var$_left[$dcf623fd84dea6d4$var$breakpoints.upSm] = {
        alignItems: 'flex-start'
    }, $dcf623fd84dea6d4$var$_left[$dcf623fd84dea6d4$var$breakpoints.downXs] = {
        left: $dcf623fd84dea6d4$var$xsWidthMargin + "px"
    }, $dcf623fd84dea6d4$var$_left),
    right: ($dcf623fd84dea6d4$var$_right = {
        right: $dcf623fd84dea6d4$var$indents.view["default"] + "px"
    }, $dcf623fd84dea6d4$var$_right[$dcf623fd84dea6d4$var$breakpoints.upSm] = {
        alignItems: 'flex-end'
    }, $dcf623fd84dea6d4$var$_right[$dcf623fd84dea6d4$var$breakpoints.downXs] = {
        right: $dcf623fd84dea6d4$var$xsWidthMargin + "px"
    }, $dcf623fd84dea6d4$var$_right),
    center: ($dcf623fd84dea6d4$var$_center = {
        left: '50%',
        transform: 'translateX(-50%)'
    }, $dcf623fd84dea6d4$var$_center[$dcf623fd84dea6d4$var$breakpoints.upSm] = {
        alignItems: 'center'
    }, $dcf623fd84dea6d4$var$_center)
});
var $dcf623fd84dea6d4$var$SnackbarContainer = function SnackbarContainer(props) {
    var _props$classes = props.classes, classes = _props$classes === void 0 ? {} : _props$classes, anchorOrigin = props.anchorOrigin, dense = props.dense, children = props.children;
    var combinedClassname = (0, $47a53d4026e1d774$export$2e2bcd8739ae039)($dcf623fd84dea6d4$var$ComponentClasses.SnackbarContainer, $dcf623fd84dea6d4$var$styles$1[anchorOrigin.vertical], $dcf623fd84dea6d4$var$styles$1[anchorOrigin.horizontal], $dcf623fd84dea6d4$var$styles$1.root, classes.containerRoot, classes["containerAnchorOrigin" + $dcf623fd84dea6d4$var$originKeyExtractor(anchorOrigin)], dense && $dcf623fd84dea6d4$var$styles$1.rootDense);
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("div", {
        className: combinedClassname
    }, children);
};
var $dcf623fd84dea6d4$var$SnackbarContainer$1 = /*#__PURE__*/ (0, $h4Bez.memo)($dcf623fd84dea6d4$var$SnackbarContainer);
/* eslint-disable */ var $dcf623fd84dea6d4$var$__DEV__ = false;
var $dcf623fd84dea6d4$var$messages = {
    NO_PERSIST_ALL: "Reached maxSnack while all enqueued snackbars have 'persist' flag. Notistack will dismiss the oldest snackbar anyway to allow other ones in the queue to be presented."
};
var $dcf623fd84dea6d4$var$warning = function(messageKey) {
    if (!$dcf623fd84dea6d4$var$__DEV__) return;
    var message = $dcf623fd84dea6d4$var$messages[messageKey];
    if (typeof console !== 'undefined') console.error("WARNING - notistack: " + message);
    try {
        throw new Error(message);
    } catch (x) {}
};
var $dcf623fd84dea6d4$var$isOptions = function isOptions(messageOrOptions) {
    var isMessage = typeof messageOrOptions === 'string' || (0, $h4Bez.isValidElement)(messageOrOptions);
    return !isMessage;
};
var $dcf623fd84dea6d4$export$9d70c354f0150b1b;
var $dcf623fd84dea6d4$export$823cdc5238933767;
var $dcf623fd84dea6d4$export$d1e619fddc3508ce = /*#__PURE__*/ function(_Component) {
    $dcf623fd84dea6d4$var$_inheritsLoose(SnackbarProvider, _Component);
    function SnackbarProvider(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        /**
     * Adds a new snackbar to the queue to be presented.
     * Returns generated or user defined key referencing the new snackbar or null
     */ _this.enqueueSnackbar = function(messageOrOptions, optsOrUndefined) {
            if (optsOrUndefined === void 0) optsOrUndefined = {};
            if (messageOrOptions === undefined || messageOrOptions === null) throw new Error('enqueueSnackbar called with invalid argument');
            var opts = $dcf623fd84dea6d4$var$isOptions(messageOrOptions) ? messageOrOptions : optsOrUndefined;
            var message = $dcf623fd84dea6d4$var$isOptions(messageOrOptions) ? messageOrOptions.message : messageOrOptions;
            var key = opts.key, preventDuplicate = opts.preventDuplicate, options = $dcf623fd84dea6d4$var$_objectWithoutPropertiesLoose(opts, [
                "key",
                "preventDuplicate"
            ]);
            var hasSpecifiedKey = $dcf623fd84dea6d4$var$isDefined(key);
            var id = hasSpecifiedKey ? key : new Date().getTime() + Math.random();
            var merger = $dcf623fd84dea6d4$var$merge(options, _this.props);
            var snack = $dcf623fd84dea6d4$var$_extends({
                id: id
            }, options, {
                message: message,
                open: true,
                entered: false,
                requestClose: false,
                persist: merger('persist'),
                action: merger('action'),
                content: merger('content'),
                variant: merger('variant'),
                anchorOrigin: merger('anchorOrigin'),
                disableWindowBlurListener: merger('disableWindowBlurListener'),
                autoHideDuration: merger('autoHideDuration'),
                hideIconVariant: merger('hideIconVariant'),
                TransitionComponent: merger('TransitionComponent'),
                transitionDuration: merger('transitionDuration'),
                TransitionProps: merger('TransitionProps', true),
                iconVariant: merger('iconVariant', true),
                style: merger('style', true),
                SnackbarProps: merger('SnackbarProps', true),
                className: (0, $47a53d4026e1d774$export$2e2bcd8739ae039)(_this.props.className, options.className)
            });
            if (snack.persist) snack.autoHideDuration = undefined;
            _this.setState(function(state) {
                if (preventDuplicate === undefined && _this.props.preventDuplicate || preventDuplicate) {
                    var compareFunction = function compareFunction(item) {
                        return hasSpecifiedKey ? item.id === id : item.message === message;
                    };
                    var inQueue = state.queue.findIndex(compareFunction) > -1;
                    var inView = state.snacks.findIndex(compareFunction) > -1;
                    if (inQueue || inView) return state;
                }
                return _this.handleDisplaySnack($dcf623fd84dea6d4$var$_extends({}, state, {
                    queue: [].concat(state.queue, [
                        snack
                    ])
                }));
            });
            return id;
        };
        /**
     * Reducer: Display snack if there's space for it. Otherwise, immediately
     * begin dismissing the oldest message to start showing the new one.
     */ _this.handleDisplaySnack = function(state) {
            var snacks = state.snacks;
            if (snacks.length >= _this.maxSnack) return _this.handleDismissOldest(state);
            return _this.processQueue(state);
        };
        /**
     * Reducer: Display items (notifications) in the queue if there's space for them.
     */ _this.processQueue = function(state) {
            var queue = state.queue, snacks = state.snacks;
            if (queue.length > 0) return $dcf623fd84dea6d4$var$_extends({}, state, {
                snacks: [].concat(snacks, [
                    queue[0]
                ]),
                queue: queue.slice(1, queue.length)
            });
            return state;
        };
        /**
     * Reducer: Hide oldest snackbar on the screen because there exists a new one which we have to display.
     * (ignoring the one with 'persist' flag. i.e. explicitly told by user not to get dismissed).
     *
     * Note 1: If there is already a message leaving the screen, no new messages are dismissed.
     * Note 2: If the oldest message has not yet entered the screen, only a request to close the
     *         snackbar is made. Once it entered the screen, it will be immediately dismissed.
     */ _this.handleDismissOldest = function(state) {
            if (state.snacks.some(function(item) {
                return !item.open || item.requestClose;
            })) return state;
            var popped = false;
            var ignore = false;
            var persistentCount = state.snacks.reduce(function(acc, current) {
                return acc + (current.open && current.persist ? 1 : 0);
            }, 0);
            if (persistentCount === _this.maxSnack) ignore = true;
            var snacks = state.snacks.map(function(item) {
                if (!popped && (!item.persist || ignore)) {
                    popped = true;
                    if (!item.entered) return $dcf623fd84dea6d4$var$_extends({}, item, {
                        requestClose: true
                    });
                    if (item.onClose) item.onClose(null, 'maxsnack', item.id);
                    if (_this.props.onClose) _this.props.onClose(null, 'maxsnack', item.id);
                    return $dcf623fd84dea6d4$var$_extends({}, item, {
                        open: false
                    });
                }
                return $dcf623fd84dea6d4$var$_extends({}, item);
            });
            return $dcf623fd84dea6d4$var$_extends({}, state, {
                snacks: snacks
            });
        };
        /**
     * Set the entered state of the snackbar with the given key.
     */ _this.handleEnteredSnack = function(node, isAppearing, key) {
            if (!$dcf623fd84dea6d4$var$isDefined(key)) throw new Error('handleEnteredSnack Cannot be called with undefined key');
            _this.setState(function(_ref) {
                var snacks = _ref.snacks;
                return {
                    snacks: snacks.map(function(item) {
                        return item.id === key ? $dcf623fd84dea6d4$var$_extends({}, item, {
                            entered: true
                        }) : $dcf623fd84dea6d4$var$_extends({}, item);
                    })
                };
            });
        };
        /**
     * Hide a snackbar after its timeout.
     */ _this.handleCloseSnack = function(event, reason, key) {
            // should not use createChainedFunction for onClose.
            // because this.closeSnackbar called this function
            if (_this.props.onClose) _this.props.onClose(event, reason, key);
            var shouldCloseAll = key === undefined;
            _this.setState(function(_ref2) {
                var snacks = _ref2.snacks, queue = _ref2.queue;
                return {
                    snacks: snacks.map(function(item) {
                        if (!shouldCloseAll && item.id !== key) return $dcf623fd84dea6d4$var$_extends({}, item);
                        return item.entered ? $dcf623fd84dea6d4$var$_extends({}, item, {
                            open: false
                        }) : $dcf623fd84dea6d4$var$_extends({}, item, {
                            requestClose: true
                        });
                    }),
                    queue: queue.filter(function(item) {
                        return item.id !== key;
                    })
                };
            });
        };
        /**
     * Close snackbar with the given key
     */ _this.closeSnackbar = function(key) {
            // call individual snackbar onClose callback passed through options parameter
            var toBeClosed = _this.state.snacks.find(function(item) {
                return item.id === key;
            });
            if ($dcf623fd84dea6d4$var$isDefined(key) && toBeClosed && toBeClosed.onClose) toBeClosed.onClose(null, 'instructed', key);
            _this.handleCloseSnack(null, 'instructed', key);
        };
        /**
     * When we set open attribute of a snackbar to false (i.e. after we hide a snackbar),
     * it leaves the screen and immediately after leaving animation is done, this method
     * gets called. We remove the hidden snackbar from state and then display notifications
     * waiting in the queue (if any). If after this process the queue is not empty, the
     * oldest message is dismissed.
     */ _this.handleExitedSnack = function(node, key) {
            if (!$dcf623fd84dea6d4$var$isDefined(key)) throw new Error('handleExitedSnack Cannot be called with undefined key');
            _this.setState(function(state) {
                var newState = _this.processQueue($dcf623fd84dea6d4$var$_extends({}, state, {
                    snacks: state.snacks.filter(function(item) {
                        return item.id !== key;
                    })
                }));
                if (newState.queue.length === 0) return newState;
                return _this.handleDismissOldest(newState);
            });
        };
        $dcf623fd84dea6d4$export$9d70c354f0150b1b = _this.enqueueSnackbar;
        $dcf623fd84dea6d4$export$823cdc5238933767 = _this.closeSnackbar;
        _this.state = {
            snacks: [],
            queue: [],
            contextValue: {
                enqueueSnackbar: _this.enqueueSnackbar.bind($dcf623fd84dea6d4$var$_assertThisInitialized(_this)),
                closeSnackbar: _this.closeSnackbar.bind($dcf623fd84dea6d4$var$_assertThisInitialized(_this))
            }
        };
        return _this;
    }
    var _proto = SnackbarProvider.prototype;
    _proto.render = function render() {
        var _this2 = this;
        var contextValue = this.state.contextValue;
        var _this$props = this.props, domRoot = _this$props.domRoot, children = _this$props.children, _this$props$dense = _this$props.dense, dense = _this$props$dense === void 0 ? false : _this$props$dense, _this$props$Component = _this$props.Components, Components = _this$props$Component === void 0 ? {} : _this$props$Component, classes = _this$props.classes;
        var categ = this.state.snacks.reduce(function(acc, current) {
            var _extends2;
            var category = $dcf623fd84dea6d4$var$originKeyExtractor(current.anchorOrigin);
            var existingOfCategory = acc[category] || [];
            return $dcf623fd84dea6d4$var$_extends({}, acc, (_extends2 = {}, _extends2[category] = [].concat(existingOfCategory, [
                current
            ]), _extends2));
        }, {});
        var snackbars = Object.keys(categ).map(function(origin) {
            var snacks = categ[origin];
            var nomineeSnack = snacks[0];
            return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($dcf623fd84dea6d4$var$SnackbarContainer$1, {
                key: origin,
                dense: dense,
                anchorOrigin: nomineeSnack.anchorOrigin,
                classes: classes
            }, snacks.map(function(snack) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($dcf623fd84dea6d4$var$SnackbarItem, {
                    key: snack.id,
                    snack: snack,
                    classes: classes,
                    Component: Components[snack.variant],
                    onClose: _this2.handleCloseSnack,
                    onEnter: _this2.props.onEnter,
                    onExit: _this2.props.onExit,
                    onExited: $dcf623fd84dea6d4$var$createChainedFunction([
                        _this2.handleExitedSnack,
                        _this2.props.onExited
                    ], snack.id),
                    onEntered: $dcf623fd84dea6d4$var$createChainedFunction([
                        _this2.handleEnteredSnack,
                        _this2.props.onEntered
                    ], snack.id)
                });
            }));
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($dcf623fd84dea6d4$var$SnackbarContext.Provider, {
            value: contextValue
        }, children, domRoot ? (0, $68fd039c491aa2b2$exports.createPortal)(snackbars, domRoot) : snackbars);
    };
    $dcf623fd84dea6d4$var$_createClass(SnackbarProvider, [
        {
            key: "maxSnack",
            get: function get() {
                return this.props.maxSnack || $dcf623fd84dea6d4$var$defaults.maxSnack;
            }
        }
    ]);
    return SnackbarProvider;
}((0, $h4Bez.Component));
var $dcf623fd84dea6d4$export$1c97ac2c9a6e7c09 = function() {
    return (0, $h4Bez.useContext)($dcf623fd84dea6d4$var$SnackbarContext);
};


const $53f61f6e8d02313e$var$defaultGenerator = (componentName)=>componentName;
const $53f61f6e8d02313e$var$createClassNameGenerator = ()=>{
    let generate = $53f61f6e8d02313e$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $53f61f6e8d02313e$var$defaultGenerator;
        }
    };
};
const $53f61f6e8d02313e$var$ClassNameGenerator = $53f61f6e8d02313e$var$createClassNameGenerator();
var $53f61f6e8d02313e$export$2e2bcd8739ae039 = $53f61f6e8d02313e$var$ClassNameGenerator;


const $6b55eb7835363b92$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $6b55eb7835363b92$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $6b55eb7835363b92$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $53f61f6e8d02313e$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $6b55eb7835363b92$export$34c0130b1f3e8ae3(slot) {
    return $6b55eb7835363b92$export$9d6b9120de57c54[slot] !== undefined;
}


function $1980a9eb8f5fa46b$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $6b55eb7835363b92$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}


const $ab72aeb277ab974e$export$a100fd7a4d4ccbc7 = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('CybusErrorMessage', [
    'root',
    'header',
    'popover',
    'popover-button',
    'popover-content',
    'popover-extras',
    'stack',
    'extras',
    'extras-info',
    'extras-info-title',
    'details-button',
    'details-content',
    'details-type'
]);



parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");
function $b4ceee382bf9d5af$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $b4ceee382bf9d5af$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $b4ceee382bf9d5af$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $b4ceee382bf9d5af$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $b4ceee382bf9d5af$export$2e2bcd8739ae039 = $b4ceee382bf9d5af$export$4f5d2d50c9deca37;





const $348688587c50d45e$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $1ddc86c69bdbc815$export$2e2bcd8739ae039);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $348688587c50d45e$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $348688587c50d45e$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $a539fc8639d0a7b4$export$53b83ca8eaab0383)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}




'use client';
function $7f25a133f311d859$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $f03c30be6721b2ef$export$2e2bcd8739ae039)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $bee7cb8e1c4d4571$export$2e2bcd8739ae039));
    const Box = /*#__PURE__*/ $h4Bez.forwardRef(function Box(inProps, ref) {
        const theme = (0, $f8416c9663895cb7$export$2e2bcd8739ae039)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $348688587c50d45e$export$2e2bcd8739ae039)(inProps);
        return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $b4ceee382bf9d5af$export$2e2bcd8739ae039)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}







const $88918bc6885bb608$var$boxClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiBox', [
    'root'
]);
var $88918bc6885bb608$export$2e2bcd8739ae039 = $88918bc6885bb608$var$boxClasses;


'use client';
const $7f71da25a1486af3$var$defaultTheme = (0, $c6bd6699c9daa002$export$2e2bcd8739ae039)();
const $7f71da25a1486af3$var$Box = (0, $7f25a133f311d859$export$2e2bcd8739ae039)({
    themeId: (0, $3abbb2670cc8edff$export$2e2bcd8739ae039),
    defaultTheme: $7f71da25a1486af3$var$defaultTheme,
    defaultClassName: (0, $88918bc6885bb608$export$2e2bcd8739ae039).root,
    generateClassName: (0, $53f61f6e8d02313e$export$2e2bcd8739ae039).generate
});
var $7f71da25a1486af3$export$2e2bcd8739ae039 = $7f71da25a1486af3$var$Box;


var $h4Bez = parcelRequire("h4Bez");

function $234b0b3cb485132a$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $234b0b3cb485132a$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $234b0b3cb485132a$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $234b0b3cb485132a$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $234b0b3cb485132a$export$2e2bcd8739ae039 = $234b0b3cb485132a$export$4f5d2d50c9deca37;



/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $15645634511fd40c$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}


/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $90a9a7d90476ac81$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}



var $48502cfd5e4ee8e9$export$2e2bcd8739ae039 = (0, $00f59fafbaffc20f$export$2e2bcd8739ae039);






function $ff9cde3be95a41e7$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $ff9cde3be95a41e7$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ff9cde3be95a41e7$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $ff9cde3be95a41e7$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $ff9cde3be95a41e7$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $53a81ab81d62cb67$exports.ForwardRef:
            return $ff9cde3be95a41e7$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $53a81ab81d62cb67$exports.Memo:
            return $ff9cde3be95a41e7$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}





function $1fce310c4a363cc4$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $f03c30be6721b2ef$export$13a2d3ef13012b32)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $f03c30be6721b2ef$export$13a2d3ef13012b32)(variant.style);
    });
    return result;
}


const $323d09b5b142c3c9$export$35e57303dbd8a66 = (0, $32d258d0759a439a$export$2e2bcd8739ae039)();
function $323d09b5b142c3c9$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $323d09b5b142c3c9$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $323d09b5b142c3c9$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $323d09b5b142c3c9$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $323d09b5b142c3c9$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $323d09b5b142c3c9$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$323d09b5b142c3c9$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $323d09b5b142c3c9$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $323d09b5b142c3c9$var$shallowLayer((0, $f03c30be6721b2ef$export$13a2d3ef13012b32)(otherStyles), layerName) : otherStyles;
        }
        return $323d09b5b142c3c9$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $323d09b5b142c3c9$var$shallowLayer((0, $f03c30be6721b2ef$export$13a2d3ef13012b32)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $323d09b5b142c3c9$var$shallowLayer((0, $f03c30be6721b2ef$export$13a2d3ef13012b32)(resolvedStyle), layerName) : resolvedStyle;
}
function $323d09b5b142c3c9$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(layerName ? $323d09b5b142c3c9$var$shallowLayer((0, $f03c30be6721b2ef$export$13a2d3ef13012b32)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $323d09b5b142c3c9$var$shallowLayer((0, $f03c30be6721b2ef$export$13a2d3ef13012b32)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $323d09b5b142c3c9$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $323d09b5b142c3c9$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $323d09b5b142c3c9$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $323d09b5b142c3c9$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $323d09b5b142c3c9$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $f03c30be6721b2ef$export$592c7226e4cb0171)(tag, (styles)=>styles.filter((style)=>style !== (0, $bee7cb8e1c4d4571$export$2e2bcd8739ae039)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $323d09b5b142c3c9$var$defaultOverridesResolver($323d09b5b142c3c9$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $323d09b5b142c3c9$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($323d09b5b142c3c9$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $f03c30be6721b2ef$export$2e2bcd8739ae039)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $323d09b5b142c3c9$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $323d09b5b142c3c9$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $a539fc8639d0a7b4$export$53b83ca8eaab0383)(style)) {
                const serialized = (0, $1fce310c4a363cc4$export$2e2bcd8739ae039)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $323d09b5b142c3c9$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $323d09b5b142c3c9$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $323d09b5b142c3c9$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $323d09b5b142c3c9$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push((0, $bee7cb8e1c4d4571$export$2e2bcd8739ae039));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $323d09b5b142c3c9$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $00f59fafbaffc20f$export$2e2bcd8739ae039)(componentSlot || '')}`;
    return `Styled(${(0, $ff9cde3be95a41e7$export$2e2bcd8739ae039)(tag)})`;
}
function $323d09b5b142c3c9$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $323d09b5b142c3c9$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $323d09b5b142c3c9$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $323d09b5b142c3c9$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}




// copied from @mui/system/createStyled
function $43f40a41b3374964$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $43f40a41b3374964$export$2e2bcd8739ae039 = $43f40a41b3374964$var$slotShouldForwardProp;


const $19087586f17e5d57$var$rootShouldForwardProp = (prop)=>(0, $43f40a41b3374964$export$2e2bcd8739ae039)(prop) && prop !== 'classes';
var $19087586f17e5d57$export$2e2bcd8739ae039 = $19087586f17e5d57$var$rootShouldForwardProp;



'use client';
const $0a84fcab91d2b818$var$styled = (0, $323d09b5b142c3c9$export$2e2bcd8739ae039)({
    themeId: (0, $3abbb2670cc8edff$export$2e2bcd8739ae039),
    defaultTheme: $1501f617dbde04aa$export$2e2bcd8739ae039,
    rootShouldForwardProp: $19087586f17e5d57$export$2e2bcd8739ae039
});
var $0a84fcab91d2b818$export$2e2bcd8739ae039 = $0a84fcab91d2b818$var$styled;

parcelRequire("h4Bez");



'use client';
function $cd99783e1cac2d84$export$2e2bcd8739ae039() {
    const theme = (0, $f8416c9663895cb7$export$2e2bcd8739ae039)((0, $1501f617dbde04aa$export$2e2bcd8739ae039));
    return theme[0, $3abbb2670cc8edff$export$2e2bcd8739ae039] || theme;
}



/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $25014e36516d5df1$var$arg = {
    theme: undefined
};
function $25014e36516d5df1$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $25014e36516d5df1$var$arg.theme = props.theme;
            value = (0, $1fce310c4a363cc4$export$2e2bcd8739ae039)(styleFn($25014e36516d5df1$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}


const $6f5ab2b368d2d9fb$var$memoTheme = (0, $25014e36516d5df1$export$2e2bcd8739ae039);
var $6f5ab2b368d2d9fb$export$2e2bcd8739ae039 = $6f5ab2b368d2d9fb$var$memoTheme;


/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $0276aff9d37c91bd$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $0276aff9d37c91bd$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$0276aff9d37c91bd$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $0276aff9d37c91bd$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $0276aff9d37c91bd$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}


parcelRequire("h4Bez");



'use client';
function $16527687018ae2c4$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $3b37a68f494cca38$export$2e2bcd8739ae039), {
        ...props
    });
}
var $16527687018ae2c4$export$2e2bcd8739ae039 = $16527687018ae2c4$var$DefaultPropsProvider;
function $16527687018ae2c4$export$2440da353cedad43(params) {
    return (0, $3b37a68f494cca38$export$2440da353cedad43)(params);
}



var $h4Bez = parcelRequire("h4Bez");









function $9fc46070fdf093c8$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $2e41620b030ed79e$exports.jsx)((0, $726d3fe46e12654c$export$2e2bcd8739ae039), {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $9fc46070fdf093c8$export$7e7f5719ff4debb1() {
    return 0, $348688587c50d45e$export$2e2bcd8739ae039;
}








function $f9ef756b8f6a1b37$export$24c1f8f60cbac79e(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiTypography', slot);
}
const $f9ef756b8f6a1b37$var$typographyClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $f9ef756b8f6a1b37$export$2e2bcd8739ae039 = $f9ef756b8f6a1b37$var$typographyClasses;



'use client';
const $d3cc2294f10b2d1f$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $d3cc2294f10b2d1f$var$extendSxProp = (0, $9fc46070fdf093c8$export$7e7f5719ff4debb1)();
const $d3cc2294f10b2d1f$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $f9ef756b8f6a1b37$export$24c1f8f60cbac79e), classes);
};
const $d3cc2294f10b2d1f$export$140e2f5526d3cad8 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $d3cc2294f10b2d1f$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $d3cc2294f10b2d1f$var$Typography = /*#__PURE__*/ $h4Bez.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$d3cc2294f10b2d1f$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $d3cc2294f10b2d1f$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $d3cc2294f10b2d1f$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $d3cc2294f10b2d1f$var$defaultVariantMapping[variant]) || 'span';
    const classes = $d3cc2294f10b2d1f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($d3cc2294f10b2d1f$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $d3cc2294f10b2d1f$export$2e2bcd8739ae039 = $d3cc2294f10b2d1f$var$Typography;




function $f6879b30beb87aff$export$d6efab9620b78fec(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiLink', slot);
}
const $f6879b30beb87aff$var$linkClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $f6879b30beb87aff$export$2e2bcd8739ae039 = $f6879b30beb87aff$var$linkClasses;




const $e1b49963912b6ccc$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = ownerState.color;
    if ('colorSpace' in theme && theme.colorSpace) {
        const color = (0, $ca2b3459e44cca5a$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}.main`) || (0, $ca2b3459e44cca5a$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}`) || ownerState.color;
        return theme.alpha(color, 0.4);
    }
    // check the `main` color first for a custom palette, then fallback to the color itself
    const color = (0, $ca2b3459e44cca5a$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}.main`, false) || (0, $ca2b3459e44cca5a$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $ca2b3459e44cca5a$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}.mainChannel`) || (0, $ca2b3459e44cca5a$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $3289d56f59a873c2$export$58f0f39f63f3cf42)(color, 0.4);
};
var $e1b49963912b6ccc$export$2e2bcd8739ae039 = $e1b49963912b6ccc$var$getTextDecoration;



'use client';
const $a497eee141ca75b8$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $a497eee141ca75b8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $f6879b30beb87aff$export$d6efab9620b78fec), classes);
};
const $a497eee141ca75b8$var$LinkRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>{
    return {
        variants: [
            {
                props: {
                    underline: 'none'
                },
                style: {
                    textDecoration: 'none'
                }
            },
            {
                props: {
                    underline: 'hover'
                },
                style: {
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline'
                    }
                }
            },
            {
                props: {
                    underline: 'always'
                },
                style: {
                    textDecoration: 'underline',
                    '&:hover': {
                        textDecorationColor: 'inherit'
                    }
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color !== 'inherit',
                style: {
                    textDecorationColor: 'var(--Link-underlineColor)'
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color === 'inherit',
                style: theme.colorSpace ? {
                    textDecorationColor: theme.alpha('currentColor', 0.4)
                } : null
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        underline: 'always',
                        color: color
                    },
                    style: {
                        '--Link-underlineColor': theme.alpha((theme.vars || theme).palette[color].main, 0.4)
                    }
                })),
            {
                props: {
                    underline: 'always',
                    color: 'textPrimary'
                },
                style: {
                    '--Link-underlineColor': theme.alpha((theme.vars || theme).palette.text.primary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textSecondary'
                },
                style: {
                    '--Link-underlineColor': theme.alpha((theme.vars || theme).palette.text.secondary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textDisabled'
                },
                style: {
                    '--Link-underlineColor': (theme.vars || theme).palette.text.disabled
                }
            },
            {
                props: {
                    component: 'button'
                },
                style: {
                    position: 'relative',
                    WebkitTapHighlightColor: 'transparent',
                    backgroundColor: 'transparent',
                    // Reset default value
                    // We disable the focus ring for mouse, touch and keyboard users.
                    outline: 0,
                    border: 0,
                    margin: 0,
                    // Remove the margin in Safari
                    borderRadius: 0,
                    padding: 0,
                    // Remove the padding in Firefox
                    cursor: 'pointer',
                    userSelect: 'none',
                    verticalAlign: 'middle',
                    MozAppearance: 'none',
                    // Reset
                    WebkitAppearance: 'none',
                    // Reset
                    '&::-moz-focus-inner': {
                        borderStyle: 'none' // Remove Firefox dotted outline.
                    },
                    [`&.${(0, $f6879b30beb87aff$export$2e2bcd8739ae039).focusVisible}`]: {
                        outline: 'auto'
                    }
                }
            }
        ]
    };
}));
const $a497eee141ca75b8$var$Link = /*#__PURE__*/ $h4Bez.forwardRef(function Link(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiLink'
    });
    const theme = (0, $cd99783e1cac2d84$export$2e2bcd8739ae039)();
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx, ...other } = props;
    const [focusVisible, setFocusVisible] = $h4Bez.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $90a9a7d90476ac81$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        if ((0, $90a9a7d90476ac81$export$2e2bcd8739ae039)(event.target)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = {
        ...props,
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    };
    const classes = $a497eee141ca75b8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($a497eee141ca75b8$var$LinkRoot, {
        color: color,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: ref,
        ownerState: ownerState,
        variant: variant,
        ...other,
        sx: [
            ...$a497eee141ca75b8$var$v6Colors[color] === undefined ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        style: {
            ...other.style,
            ...underline === 'always' && color !== 'inherit' && !$a497eee141ca75b8$var$v6Colors[color] && {
                '--Link-underlineColor': (0, $e1b49963912b6ccc$export$2e2bcd8739ae039)({
                    theme: theme,
                    ownerState: ownerState
                })
            }
        }
    });
});
var $a497eee141ca75b8$export$2e2bcd8739ae039 = $a497eee141ca75b8$var$Link;


var $deeee9bf4fa3e86f$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($deeee9bf4fa3e86f$exports) {
        classNames.default = classNames;
        $deeee9bf4fa3e86f$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();






parcelRequire("h4Bez");
const $4772774eee62bdcc$export$18fadbe56dfcb1a1 = (Renderer, props)=>(...chunks)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Renderer, {
            ...props,
            children: chunks
        });
const $4772774eee62bdcc$export$582aafb958f7fe50 = $4772774eee62bdcc$export$18fadbe56dfcb1a1((props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("b", {
        ...props
    }), {});




var $h4Bez = parcelRequire("h4Bez");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $15cbcba2c47c7dce$var$extendStatics = function(d, b) {
    $15cbcba2c47c7dce$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $15cbcba2c47c7dce$var$extendStatics(d, b);
};
function $15cbcba2c47c7dce$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $15cbcba2c47c7dce$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $15cbcba2c47c7dce$export$18ce0697a983be9b = function() {
    $15cbcba2c47c7dce$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $15cbcba2c47c7dce$export$18ce0697a983be9b.apply(this, arguments);
};
function $15cbcba2c47c7dce$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $15cbcba2c47c7dce$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $15cbcba2c47c7dce$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $15cbcba2c47c7dce$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $15cbcba2c47c7dce$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $15cbcba2c47c7dce$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $15cbcba2c47c7dce$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $15cbcba2c47c7dce$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $15cbcba2c47c7dce$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $15cbcba2c47c7dce$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $15cbcba2c47c7dce$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $15cbcba2c47c7dce$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $15cbcba2c47c7dce$export$45d3717a4c69092e(o, m, p);
}
function $15cbcba2c47c7dce$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $15cbcba2c47c7dce$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $15cbcba2c47c7dce$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($15cbcba2c47c7dce$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $15cbcba2c47c7dce$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $15cbcba2c47c7dce$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $15cbcba2c47c7dce$export$10c90e4f7922046c(v) {
    return this instanceof $15cbcba2c47c7dce$export$10c90e4f7922046c ? (this.v = v, this) : new $15cbcba2c47c7dce$export$10c90e4f7922046c(v);
}
function $15cbcba2c47c7dce$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $15cbcba2c47c7dce$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $15cbcba2c47c7dce$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $15cbcba2c47c7dce$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $15cbcba2c47c7dce$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $15cbcba2c47c7dce$export$19a8beecd37a4c45 === "function" ? $15cbcba2c47c7dce$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $15cbcba2c47c7dce$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $15cbcba2c47c7dce$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $15cbcba2c47c7dce$var$ownKeys = function(o) {
    $15cbcba2c47c7dce$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $15cbcba2c47c7dce$var$ownKeys(o);
};
function $15cbcba2c47c7dce$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $15cbcba2c47c7dce$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $15cbcba2c47c7dce$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $15cbcba2c47c7dce$var$__setModuleDefault(result, mod);
    return result;
}
function $15cbcba2c47c7dce$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $15cbcba2c47c7dce$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $15cbcba2c47c7dce$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $15cbcba2c47c7dce$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $15cbcba2c47c7dce$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $15cbcba2c47c7dce$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $15cbcba2c47c7dce$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $15cbcba2c47c7dce$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $15cbcba2c47c7dce$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $15cbcba2c47c7dce$export$2e2bcd8739ae039 = {
    __extends: $15cbcba2c47c7dce$export$a8ba968b8961cb8a,
    __assign: $15cbcba2c47c7dce$export$18ce0697a983be9b,
    __rest: $15cbcba2c47c7dce$export$3c9a16f847548506,
    __decorate: $15cbcba2c47c7dce$export$29e00dfd3077644b,
    __param: $15cbcba2c47c7dce$export$d5ad3fd78186038f,
    __esDecorate: $15cbcba2c47c7dce$export$3a84e1ae4e97e9b0,
    __runInitializers: $15cbcba2c47c7dce$export$d831c04e792af3d,
    __propKey: $15cbcba2c47c7dce$export$6a2a36740a146cb8,
    __setFunctionName: $15cbcba2c47c7dce$export$d1a06452d3489bc7,
    __metadata: $15cbcba2c47c7dce$export$f1db080c865becb9,
    __awaiter: $15cbcba2c47c7dce$export$1050f835b63b671e,
    __generator: $15cbcba2c47c7dce$export$67ebef60e6f28a6,
    __createBinding: $15cbcba2c47c7dce$export$45d3717a4c69092e,
    __exportStar: $15cbcba2c47c7dce$export$f33643c0debef087,
    __values: $15cbcba2c47c7dce$export$19a8beecd37a4c45,
    __read: $15cbcba2c47c7dce$export$8d051b38c9118094,
    __spread: $15cbcba2c47c7dce$export$afc72e2116322959,
    __spreadArrays: $15cbcba2c47c7dce$export$6388937ca91ccae8,
    __spreadArray: $15cbcba2c47c7dce$export$1216008129fb82ed,
    __await: $15cbcba2c47c7dce$export$10c90e4f7922046c,
    __asyncGenerator: $15cbcba2c47c7dce$export$e427f37a30a4de9b,
    __asyncDelegator: $15cbcba2c47c7dce$export$bbd80228419bb833,
    __asyncValues: $15cbcba2c47c7dce$export$e3b29a3d6162315f,
    __makeTemplateObject: $15cbcba2c47c7dce$export$4fb47efe1390b86f,
    __importStar: $15cbcba2c47c7dce$export$c21735bcef00d192,
    __importDefault: $15cbcba2c47c7dce$export$da59b14a69baef04,
    __classPrivateFieldGet: $15cbcba2c47c7dce$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $15cbcba2c47c7dce$export$d40a35129aaff81f,
    __classPrivateFieldIn: $15cbcba2c47c7dce$export$81fdc39f203e4e04,
    __addDisposableResource: $15cbcba2c47c7dce$export$88ac25d8e944e405,
    __disposeResources: $15cbcba2c47c7dce$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $15cbcba2c47c7dce$export$889dfb5d17574b0b
};



var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");


var $h4Bez = parcelRequire("h4Bez");



var $h4Bez = parcelRequire("h4Bez");
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $0583a75db3603b3b$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $0583a75db3603b3b$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $0583a75db3603b3b$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $0583a75db3603b3b$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $0583a75db3603b3b$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $0583a75db3603b3b$export$3fae2929ed23c202(map, pl, field) {
    return $0583a75db3603b3b$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $0583a75db3603b3b$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $0583a75db3603b3b$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $0583a75db3603b3b$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $0583a75db3603b3b$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $0583a75db3603b3b$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}



/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 

var $92bcbaa28fe005f8$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($92bcbaa28fe005f8$export$896afd8541959ee5 || ($92bcbaa28fe005f8$export$896afd8541959ee5 = {}));




var $1ab02541e9601e30$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($1ab02541e9601e30$export$b87f371cbc396fcf || ($1ab02541e9601e30$export$b87f371cbc396fcf = {}));
var $1ab02541e9601e30$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($1ab02541e9601e30$export$906452485466fa53 || ($1ab02541e9601e30$export$906452485466fa53 = {}));
function $1ab02541e9601e30$export$cfa10c5697238752(el) {
    return el.type === $1ab02541e9601e30$export$b87f371cbc396fcf.literal;
}
function $1ab02541e9601e30$export$4f55724281bdfaf9(el) {
    return el.type === $1ab02541e9601e30$export$b87f371cbc396fcf.argument;
}
function $1ab02541e9601e30$export$e11187b219e191e1(el) {
    return el.type === $1ab02541e9601e30$export$b87f371cbc396fcf.number;
}
function $1ab02541e9601e30$export$32d811605da75f40(el) {
    return el.type === $1ab02541e9601e30$export$b87f371cbc396fcf.date;
}
function $1ab02541e9601e30$export$34ec46f596b1702f(el) {
    return el.type === $1ab02541e9601e30$export$b87f371cbc396fcf.time;
}
function $1ab02541e9601e30$export$dcfe1c11d168b5a1(el) {
    return el.type === $1ab02541e9601e30$export$b87f371cbc396fcf.select;
}
function $1ab02541e9601e30$export$6c796d116f0a4fbc(el) {
    return el.type === $1ab02541e9601e30$export$b87f371cbc396fcf.plural;
}
function $1ab02541e9601e30$export$c0ece297bdd0c082(el) {
    return el.type === $1ab02541e9601e30$export$b87f371cbc396fcf.pound;
}
function $1ab02541e9601e30$export$5c83de34745812b(el) {
    return el.type === $1ab02541e9601e30$export$b87f371cbc396fcf.tag;
}
function $1ab02541e9601e30$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $1ab02541e9601e30$export$906452485466fa53.number);
}
function $1ab02541e9601e30$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $1ab02541e9601e30$export$906452485466fa53.dateTime);
}
function $1ab02541e9601e30$export$f0ac572c1121c662(value) {
    return {
        type: $1ab02541e9601e30$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $1ab02541e9601e30$export$425e864b0ba114f1(value, style) {
    return {
        type: $1ab02541e9601e30$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


// @generated from regex-gen.ts
var $4443a6865ace3b5d$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $4443a6865ace3b5d$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;


/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $dd64173f5749aa2a$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $dd64173f5749aa2a$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($dd64173f5749aa2a$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}



// @generated from regex-gen.ts
var $bd1832cc1a35479a$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $a444b9d11552ae9e$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $bd1832cc1a35479a$export$2b8db14d8bcaece7)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $a444b9d11552ae9e$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $a444b9d11552ae9e$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $a444b9d11552ae9e$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $a444b9d11552ae9e$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $a444b9d11552ae9e$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $a444b9d11552ae9e$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($a444b9d11552ae9e$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $a444b9d11552ae9e$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $a444b9d11552ae9e$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$a444b9d11552ae9e$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $a444b9d11552ae9e$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $a444b9d11552ae9e$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $a444b9d11552ae9e$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $a444b9d11552ae9e$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, all), $a444b9d11552ae9e$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, all), $a444b9d11552ae9e$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($a444b9d11552ae9e$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($a444b9d11552ae9e$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($a444b9d11552ae9e$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($a444b9d11552ae9e$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, result), $a444b9d11552ae9e$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($a444b9d11552ae9e$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, result), $a444b9d11552ae9e$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $a444b9d11552ae9e$var$parseSign(token.stem);
        if (signOpts) result = (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $a444b9d11552ae9e$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}




// @generated from time-data-gen.ts
// prettier-ignore  
var $7786a5d9ac498fd5$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};


function $0830eabcf0c5a675$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $0830eabcf0c5a675$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $0830eabcf0c5a675$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $7786a5d9ac498fd5$export$a8c9209db4084317)[regionTag || ''] || (0, $7786a5d9ac498fd5$export$a8c9209db4084317)[languageTag || ''] || (0, $7786a5d9ac498fd5$export$a8c9209db4084317)["".concat(languageTag, "-001")] || (0, $7786a5d9ac498fd5$export$a8c9209db4084317)['001'];
    return hourCycles[0];
}


var $2dc02ae5d789e423$var$_a;
var $2dc02ae5d789e423$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $4443a6865ace3b5d$export$523451f94304dd6c).source, "*"));
var $2dc02ae5d789e423$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $4443a6865ace3b5d$export$523451f94304dd6c).source, "*$"));
function $2dc02ae5d789e423$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $2dc02ae5d789e423$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $2dc02ae5d789e423$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $2dc02ae5d789e423$var$hasNativeFromEntries = !!Object.fromEntries;
var $2dc02ae5d789e423$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $2dc02ae5d789e423$var$hasTrimStart = !!String.prototype.trimStart;
var $2dc02ae5d789e423$var$hasTrimEnd = !!String.prototype.trimEnd;
var $2dc02ae5d789e423$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $2dc02ae5d789e423$var$isSafeInteger = $2dc02ae5d789e423$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $2dc02ae5d789e423$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $2dc02ae5d789e423$var$re = $2dc02ae5d789e423$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $2dc02ae5d789e423$var$REGEX_SUPPORTS_U_AND_Y = (($2dc02ae5d789e423$var$_a = $2dc02ae5d789e423$var$re.exec('a')) === null || $2dc02ae5d789e423$var$_a === void 0 ? void 0 : $2dc02ae5d789e423$var$_a[0]) === 'a';
} catch (_) {
    $2dc02ae5d789e423$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $2dc02ae5d789e423$var$startsWith = $2dc02ae5d789e423$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $2dc02ae5d789e423$var$fromCodePoint = $2dc02ae5d789e423$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $2dc02ae5d789e423$var$fromEntries = // native
$2dc02ae5d789e423$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $2dc02ae5d789e423$var$codePointAt = $2dc02ae5d789e423$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $2dc02ae5d789e423$var$trimStart = $2dc02ae5d789e423$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($2dc02ae5d789e423$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $2dc02ae5d789e423$var$trimEnd = $2dc02ae5d789e423$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($2dc02ae5d789e423$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $2dc02ae5d789e423$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $2dc02ae5d789e423$var$matchIdentifierAtIndex;
if ($2dc02ae5d789e423$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $2dc02ae5d789e423$var$IDENTIFIER_PREFIX_RE_1 = $2dc02ae5d789e423$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $2dc02ae5d789e423$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $2dc02ae5d789e423$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $2dc02ae5d789e423$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$2dc02ae5d789e423$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $2dc02ae5d789e423$var$codePointAt(s, index);
        if (c === undefined || $2dc02ae5d789e423$var$_isWhiteSpace(c) || $2dc02ae5d789e423$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $2dc02ae5d789e423$var$fromCodePoint.apply(void 0, match);
};
var $2dc02ae5d789e423$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $1ab02541e9601e30$export$b87f371cbc396fcf).pound,
                    location: $2dc02ae5d789e423$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $2dc02ae5d789e423$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $2dc02ae5d789e423$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $1ab02541e9601e30$export$b87f371cbc396fcf).literal,
                value: "<".concat(tagName, "/>"),
                location: $2dc02ae5d789e423$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$2dc02ae5d789e423$var$_isAlpha(this.char())) return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).INVALID_TAG, $2dc02ae5d789e423$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $2dc02ae5d789e423$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).INVALID_TAG, $2dc02ae5d789e423$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $1ab02541e9601e30$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $2dc02ae5d789e423$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).UNCLOSED_TAG, $2dc02ae5d789e423$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).INVALID_TAG, $2dc02ae5d789e423$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $2dc02ae5d789e423$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $2dc02ae5d789e423$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $1ab02541e9601e30$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$2dc02ae5d789e423$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $2dc02ae5d789e423$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $2dc02ae5d789e423$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $2dc02ae5d789e423$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).EMPTY_ARGUMENT, $2dc02ae5d789e423$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).MALFORMED_ARGUMENT, $2dc02ae5d789e423$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $2dc02ae5d789e423$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $1ab02541e9601e30$export$b87f371cbc396fcf).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $2dc02ae5d789e423$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $2dc02ae5d789e423$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).MALFORMED_ARGUMENT, $2dc02ae5d789e423$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $2dc02ae5d789e423$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $2dc02ae5d789e423$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $2dc02ae5d789e423$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $2dc02ae5d789e423$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $2dc02ae5d789e423$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $2dc02ae5d789e423$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $2dc02ae5d789e423$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $2dc02ae5d789e423$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $2dc02ae5d789e423$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $1ab02541e9601e30$export$b87f371cbc396fcf).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $0830eabcf0c5a675$export$29c5368be8904d27)(skeleton, this.locale);
                        var style = {
                            type: (0, $1ab02541e9601e30$export$906452485466fa53).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $dd64173f5749aa2a$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $1ab02541e9601e30$export$b87f371cbc396fcf).date : (0, $1ab02541e9601e30$export$b87f371cbc396fcf).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $1ab02541e9601e30$export$b87f371cbc396fcf).number : argType === 'date' ? (0, $1ab02541e9601e30$export$b87f371cbc396fcf).date : (0, $1ab02541e9601e30$export$b87f371cbc396fcf).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $2dc02ae5d789e423$var$createLocation(typeEndPosition_1, (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $2dc02ae5d789e423$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $92bcbaa28fe005f8$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $92bcbaa28fe005f8$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $2dc02ae5d789e423$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $1ab02541e9601e30$export$b87f371cbc396fcf).select,
                        value: value,
                        options: $2dc02ae5d789e423$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $1ab02541e9601e30$export$b87f371cbc396fcf).plural,
                        value: value,
                        options: $2dc02ae5d789e423$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $2dc02ae5d789e423$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $2dc02ae5d789e423$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $2dc02ae5d789e423$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $a444b9d11552ae9e$export$71cee2f16fba2480)(skeleton);
        } catch (e) {
            return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $1ab02541e9601e30$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $a444b9d11552ae9e$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $92bcbaa28fe005f8$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $92bcbaa28fe005f8$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $2dc02ae5d789e423$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $92bcbaa28fe005f8$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $92bcbaa28fe005f8$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $92bcbaa28fe005f8$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $92bcbaa28fe005f8$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $2dc02ae5d789e423$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $2dc02ae5d789e423$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $92bcbaa28fe005f8$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $92bcbaa28fe005f8$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $2dc02ae5d789e423$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $92bcbaa28fe005f8$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $2dc02ae5d789e423$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $2dc02ae5d789e423$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$2dc02ae5d789e423$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $2dc02ae5d789e423$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($2dc02ae5d789e423$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $2dc02ae5d789e423$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $2dc02ae5d789e423$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $2dc02ae5d789e423$var$_isAlphaOrSlash(codepoint) {
    return $2dc02ae5d789e423$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $2dc02ae5d789e423$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $2dc02ae5d789e423$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $2dc02ae5d789e423$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}



function $aed8e07e98689583$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $1ab02541e9601e30$export$dcfe1c11d168b5a1)(el) || (0, $1ab02541e9601e30$export$6c796d116f0a4fbc)(el)) for(var k in el.options){
            delete el.options[k].location;
            $aed8e07e98689583$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $1ab02541e9601e30$export$e11187b219e191e1)(el) && (0, $1ab02541e9601e30$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $1ab02541e9601e30$export$32d811605da75f40)(el) || (0, $1ab02541e9601e30$export$34ec46f596b1702f)(el)) && (0, $1ab02541e9601e30$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $1ab02541e9601e30$export$5c83de34745812b)(el)) $aed8e07e98689583$var$pruneLocation(el.children);
    });
}
function $aed8e07e98689583$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $2dc02ae5d789e423$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $92bcbaa28fe005f8$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $aed8e07e98689583$var$pruneLocation(result.val);
    return result.val;
}
var $aed8e07e98689583$export$d3c1bfa0f7d806e9 = (0, $2dc02ae5d789e423$export$7acfa6ed01010e37);


//
// Main
//
function $0f5e85cd23015935$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $0f5e85cd23015935$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $0f5e85cd23015935$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $0f5e85cd23015935$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $0f5e85cd23015935$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $0f5e85cd23015935$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $0f5e85cd23015935$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $0f5e85cd23015935$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $0f5e85cd23015935$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $0f5e85cd23015935$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $0f5e85cd23015935$var$monadic : $0f5e85cd23015935$var$variadic;
    return $0f5e85cd23015935$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $0f5e85cd23015935$var$strategyVariadic(fn, options) {
    return $0f5e85cd23015935$var$assemble(fn, this, $0f5e85cd23015935$var$variadic, options.cache.create(), options.serializer);
}
function $0f5e85cd23015935$var$strategyMonadic(fn, options) {
    return $0f5e85cd23015935$var$assemble(fn, this, $0f5e85cd23015935$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $0f5e85cd23015935$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $0f5e85cd23015935$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$0f5e85cd23015935$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$0f5e85cd23015935$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $0f5e85cd23015935$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $0f5e85cd23015935$var$ObjectWithoutPrototypeCache();
    }
};
var $0f5e85cd23015935$export$c5491a8691a23b9e = {
    variadic: $0f5e85cd23015935$var$strategyVariadic,
    monadic: $0f5e85cd23015935$var$strategyMonadic
};




var $afaffe6c4a6d47d5$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($afaffe6c4a6d47d5$export$d4e71bc0b80dc0fb || ($afaffe6c4a6d47d5$export$d4e71bc0b80dc0fb = {}));
var $afaffe6c4a6d47d5$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $15cbcba2c47c7dce$export$a8ba968b8961cb8a)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $afaffe6c4a6d47d5$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $15cbcba2c47c7dce$export$a8ba968b8961cb8a)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $afaffe6c4a6d47d5$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($afaffe6c4a6d47d5$export$7369836851cc1329);
var $afaffe6c4a6d47d5$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $15cbcba2c47c7dce$export$a8ba968b8961cb8a)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $afaffe6c4a6d47d5$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($afaffe6c4a6d47d5$export$7369836851cc1329);
var $afaffe6c4a6d47d5$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $15cbcba2c47c7dce$export$a8ba968b8961cb8a)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $afaffe6c4a6d47d5$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($afaffe6c4a6d47d5$export$7369836851cc1329);


var $281a6c3f7f4874af$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($281a6c3f7f4874af$export$49694c2877b44c57 || ($281a6c3f7f4874af$export$49694c2877b44c57 = {}));
function $281a6c3f7f4874af$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $281a6c3f7f4874af$export$49694c2877b44c57.literal || part.type !== $281a6c3f7f4874af$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $281a6c3f7f4874af$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $281a6c3f7f4874af$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $1ab02541e9601e30$export$cfa10c5697238752)(els[0])) return [
        {
            type: $281a6c3f7f4874af$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $1ab02541e9601e30$export$cfa10c5697238752)(el)) {
            result.push({
                type: $281a6c3f7f4874af$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $1ab02541e9601e30$export$c0ece297bdd0c082)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $281a6c3f7f4874af$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $afaffe6c4a6d47d5$export$8bfc137e4d23fdf0)(varName, originalMessage);
        var value = values[varName];
        if ((0, $1ab02541e9601e30$export$4f55724281bdfaf9)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $281a6c3f7f4874af$export$49694c2877b44c57.literal : $281a6c3f7f4874af$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $1ab02541e9601e30$export$32d811605da75f40)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $1ab02541e9601e30$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $281a6c3f7f4874af$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $1ab02541e9601e30$export$34ec46f596b1702f)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $1ab02541e9601e30$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $281a6c3f7f4874af$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $1ab02541e9601e30$export$e11187b219e191e1)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $1ab02541e9601e30$export$3f9a19cd4152eda3)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $281a6c3f7f4874af$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $1ab02541e9601e30$export$5c83de34745812b)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$281a6c3f7f4874af$export$df0c12a2d414a163(formatFn)) throw new (0, $afaffe6c4a6d47d5$export$cbc0db47c750f7c9)(value_1, 'function', originalMessage);
            var parts = $281a6c3f7f4874af$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $281a6c3f7f4874af$export$49694c2877b44c57.literal : $281a6c3f7f4874af$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $1ab02541e9601e30$export$dcfe1c11d168b5a1)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $afaffe6c4a6d47d5$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $281a6c3f7f4874af$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $1ab02541e9601e30$export$6c796d116f0a4fbc)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $afaffe6c4a6d47d5$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $afaffe6c4a6d47d5$export$d4e71bc0b80dc0fb).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $afaffe6c4a6d47d5$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $281a6c3f7f4874af$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $281a6c3f7f4874af$var$mergeLiteral(result);
}


// -- MessageFormat --------------------------------------------------------
function $79b9c485b6df91a1$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $79b9c485b6df91a1$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $79b9c485b6df91a1$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, defaultConfig));
}
function $79b9c485b6df91a1$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $79b9c485b6df91a1$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $0f5e85cd23015935$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $15cbcba2c47c7dce$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $79b9c485b6df91a1$var$createFastMemoizeCache(cache.number),
            strategy: (0, $0f5e85cd23015935$export$c5491a8691a23b9e).variadic
        }),
        getDateTimeFormat: (0, $0f5e85cd23015935$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $15cbcba2c47c7dce$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $79b9c485b6df91a1$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $0f5e85cd23015935$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: (0, $0f5e85cd23015935$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $15cbcba2c47c7dce$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $79b9c485b6df91a1$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $0f5e85cd23015935$export$c5491a8691a23b9e).variadic
        })
    };
}
var $79b9c485b6df91a1$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $281a6c3f7f4874af$export$49694c2877b44c57).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $281a6c3f7f4874af$export$275d4a3bb5f66fda)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $15cbcba2c47c7dce$export$3c9a16f847548506)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $79b9c485b6df91a1$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $79b9c485b6df91a1$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $aed8e07e98689583$export$98e6a39c04603d36);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();




var $8b69c1d8b982daeb$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($8b69c1d8b982daeb$export$557d6acb76e8a244 || ($8b69c1d8b982daeb$export$557d6acb76e8a244 = {}));
var $8b69c1d8b982daeb$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $15cbcba2c47c7dce$export$a8ba968b8961cb8a)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $8b69c1d8b982daeb$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $15cbcba2c47c7dce$export$a8ba968b8961cb8a)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $8b69c1d8b982daeb$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($8b69c1d8b982daeb$export$c016d36112f6ddf8);
var $8b69c1d8b982daeb$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $15cbcba2c47c7dce$export$a8ba968b8961cb8a)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $8b69c1d8b982daeb$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($8b69c1d8b982daeb$export$c016d36112f6ddf8);
var $8b69c1d8b982daeb$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $15cbcba2c47c7dce$export$a8ba968b8961cb8a)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $8b69c1d8b982daeb$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($8b69c1d8b982daeb$export$c016d36112f6ddf8);
var $8b69c1d8b982daeb$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $15cbcba2c47c7dce$export$a8ba968b8961cb8a)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $8b69c1d8b982daeb$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($8b69c1d8b982daeb$export$c016d36112f6ddf8);
var $8b69c1d8b982daeb$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $15cbcba2c47c7dce$export$a8ba968b8961cb8a)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($8b69c1d8b982daeb$export$e3b7eee1dbc44895);
var $8b69c1d8b982daeb$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $15cbcba2c47c7dce$export$a8ba968b8961cb8a)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $8b69c1d8b982daeb$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($8b69c1d8b982daeb$export$c016d36112f6ddf8);


function $4e5367d79ffba765$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $4e5367d79ffba765$var$defaultErrorHandler = function(error) {};
var $4e5367d79ffba765$var$defaultWarnHandler = function(warning) {};
var $4e5367d79ffba765$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $4e5367d79ffba765$var$defaultErrorHandler,
    onWarn: $4e5367d79ffba765$var$defaultWarnHandler
};
function $4e5367d79ffba765$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $4e5367d79ffba765$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $4e5367d79ffba765$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $4e5367d79ffba765$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $0f5e85cd23015935$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $15cbcba2c47c7dce$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $4e5367d79ffba765$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $0f5e85cd23015935$export$c5491a8691a23b9e).variadic
    });
    var getNumberFormat = (0, $0f5e85cd23015935$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $15cbcba2c47c7dce$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $4e5367d79ffba765$var$createFastMemoizeCache(cache.number),
        strategy: (0, $0f5e85cd23015935$export$c5491a8691a23b9e).variadic
    });
    var getPluralRules = (0, $0f5e85cd23015935$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $15cbcba2c47c7dce$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $4e5367d79ffba765$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $0f5e85cd23015935$export$c5491a8691a23b9e).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $0f5e85cd23015935$export$fc10aeed3a532e2a)(function(message, locales, overrideFormats, opts) {
            return new (0, $79b9c485b6df91a1$export$d342343268debc40)(message, locales, overrideFormats, (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $4e5367d79ffba765$var$createFastMemoizeCache(cache.message),
            strategy: (0, $0f5e85cd23015935$export$c5491a8691a23b9e).variadic
        }),
        getRelativeTimeFormat: (0, $0f5e85cd23015935$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $15cbcba2c47c7dce$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $4e5367d79ffba765$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $0f5e85cd23015935$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $0f5e85cd23015935$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $15cbcba2c47c7dce$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $4e5367d79ffba765$var$createFastMemoizeCache(cache.list),
            strategy: (0, $0f5e85cd23015935$export$c5491a8691a23b9e).variadic
        }),
        getDisplayNames: (0, $0f5e85cd23015935$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $15cbcba2c47c7dce$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $4e5367d79ffba765$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $0f5e85cd23015935$export$c5491a8691a23b9e).variadic
        })
    };
}
function $4e5367d79ffba765$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $8b69c1d8b982daeb$export$549f97e137a05c90)("No ".concat(type, " format named: ").concat(name)));
}


function $57e517161f4aef2e$export$45c4bbf6e55bba1f(intl) {
    (0, $0583a75db3603b3b$export$f5708dca728d7177)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $57e517161f4aef2e$export$b52f8d6fc0d47415 = (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, (0, $4e5367d79ffba765$export$b52f8d6fc0d47415)), {
    textComponent: $h4Bez.Fragment
});
function $57e517161f4aef2e$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($h4Bez.Children.toArray(parts));
    };
}
function $57e517161f4aef2e$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}


function $f8fc7b8b2b80d34a$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $f8fc7b8b2b80d34a$var$IntlContext = typeof window !== 'undefined' ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $h4Bez.createContext(null)) : $h4Bez.createContext(null);
var $f8fc7b8b2b80d34a$var$IntlConsumer = $f8fc7b8b2b80d34a$var$IntlContext.Consumer, $f8fc7b8b2b80d34a$var$IntlProvider = $f8fc7b8b2b80d34a$var$IntlContext.Provider;
var $f8fc7b8b2b80d34a$export$2881499e37b75b9a = $f8fc7b8b2b80d34a$var$IntlProvider;
var $f8fc7b8b2b80d34a$export$841858b892ce1f4c = $f8fc7b8b2b80d34a$var$IntlContext;
function $f8fc7b8b2b80d34a$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $h4Bez.createElement($f8fc7b8b2b80d34a$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $57e517161f4aef2e$export$45c4bbf6e55bba1f)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $h4Bez.createElement(WrappedComponent, (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($f8fc7b8b2b80d34a$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($25cb7246cfccd3af$exports)))($h4Bez.forwardRef(function(props, ref) {
        return $h4Bez.createElement(WithIntl, (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25cb7246cfccd3af$exports)))(WithIntl, WrappedComponent);
}



function $b4035d36efc112ae$export$2e2bcd8739ae039() {
    var intl = $h4Bez.useContext((0, $f8fc7b8b2b80d34a$export$841858b892ce1f4c));
    (0, $57e517161f4aef2e$export$45c4bbf6e55bba1f)(intl);
    return intl;
}


var $144bcb20ba6c2d9d$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($144bcb20ba6c2d9d$var$DisplayName || ($144bcb20ba6c2d9d$var$DisplayName = {}));
var $144bcb20ba6c2d9d$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($144bcb20ba6c2d9d$var$DisplayNameParts || ($144bcb20ba6c2d9d$var$DisplayNameParts = {}));
var $144bcb20ba6c2d9d$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $b4035d36efc112ae$export$2e2bcd8739ae039)();
    var value = props.value, children = props.children, formatProps = (0, $15cbcba2c47c7dce$export$3c9a16f847548506)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$144bcb20ba6c2d9d$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $144bcb20ba6c2d9d$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $b4035d36efc112ae$export$2e2bcd8739ae039)();
    var value = props.value, children = props.children, formatProps = (0, $15cbcba2c47c7dce$export$3c9a16f847548506)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$144bcb20ba6c2d9d$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $144bcb20ba6c2d9d$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $b4035d36efc112ae$export$2e2bcd8739ae039)();
        var value = props.value, children = props.children, formatProps = (0, $15cbcba2c47c7dce$export$3c9a16f847548506)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $144bcb20ba6c2d9d$var$DisplayNameParts[name];
    return ComponentParts;
}
function $144bcb20ba6c2d9d$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $b4035d36efc112ae$export$2e2bcd8739ae039)();
        var value = props.value, children = props.children, formatProps = (0, $15cbcba2c47c7dce$export$3c9a16f847548506)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $h4Bez.Fragment;
        return $h4Bez.createElement(Text, null, formattedValue);
    };
    Component.displayName = $144bcb20ba6c2d9d$var$DisplayName[name];
    return Component;
}




/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 

var $h4Bez = parcelRequire("h4Bez");







var $3391a165383f9061$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem'
];
function $3391a165383f9061$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $4e5367d79ffba765$export$4ee1db8ce44a209b)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $4e5367d79ffba765$export$d697c39a2985a4c)(options, $3391a165383f9061$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $3391a165383f9061$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $3391a165383f9061$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $8b69c1d8b982daeb$export$e3b7eee1dbc44895)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $3391a165383f9061$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $3391a165383f9061$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $8b69c1d8b982daeb$export$e3b7eee1dbc44895)('Error formatting number.', config.locale, e));
    }
    return [];
}





var $66237cc3ba5442e3$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $66237cc3ba5442e3$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $4e5367d79ffba765$export$4ee1db8ce44a209b)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $4e5367d79ffba765$export$d697c39a2985a4c)(options, $66237cc3ba5442e3$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $66237cc3ba5442e3$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $afaffe6c4a6d47d5$export$7369836851cc1329)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $afaffe6c4a6d47d5$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    try {
        return $66237cc3ba5442e3$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $8b69c1d8b982daeb$export$e3b7eee1dbc44895)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}





var $35d98a4b26b0850f$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $35d98a4b26b0850f$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $4e5367d79ffba765$export$4ee1db8ce44a209b)(formats, type, format, onError));
    var filteredOptions = (0, $4e5367d79ffba765$export$d697c39a2985a4c)(options, $35d98a4b26b0850f$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $35d98a4b26b0850f$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $35d98a4b26b0850f$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $8b69c1d8b982daeb$export$e3b7eee1dbc44895)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $35d98a4b26b0850f$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $35d98a4b26b0850f$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $8b69c1d8b982daeb$export$e3b7eee1dbc44895)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $35d98a4b26b0850f$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $4e5367d79ffba765$export$d697c39a2985a4c)(options, $35d98a4b26b0850f$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $8b69c1d8b982daeb$export$e3b7eee1dbc44895)('Error formatting date time range.', config.locale, e));
    }
    return String(from);
}
function $35d98a4b26b0850f$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $35d98a4b26b0850f$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $8b69c1d8b982daeb$export$e3b7eee1dbc44895)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $35d98a4b26b0850f$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $35d98a4b26b0850f$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $8b69c1d8b982daeb$export$e3b7eee1dbc44895)('Error formatting time.', config.locale, e));
    }
    return [];
}





var $95a07bf261332d25$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $95a07bf261332d25$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $afaffe6c4a6d47d5$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $afaffe6c4a6d47d5$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $4e5367d79ffba765$export$d697c39a2985a4c)(options, $95a07bf261332d25$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $8b69c1d8b982daeb$export$e3b7eee1dbc44895)('Error formatting plural.', locale, e));
    }
    return 'other';
}







function $22e602bdfaf38867$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $22e602bdfaf38867$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $22e602bdfaf38867$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $79b9c485b6df91a1$export$d342343268debc40).formats;
    return (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, mfFormats), f1), {
        date: $22e602bdfaf38867$var$deepMergeOptions($22e602bdfaf38867$var$setTimeZoneInOptions(mfFormats.date, timeZone), $22e602bdfaf38867$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $22e602bdfaf38867$var$deepMergeOptions($22e602bdfaf38867$var$setTimeZoneInOptions(mfFormats.time, timeZone), $22e602bdfaf38867$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $22e602bdfaf38867$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $0583a75db3603b3b$export$f5708dca728d7177)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $1ab02541e9601e30$export$b87f371cbc396fcf).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, defaultRichTextElements), values || {});
    formats = $22e602bdfaf38867$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $22e602bdfaf38867$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $8b69c1d8b982daeb$export$2ddcb436d0aa3688)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $8b69c1d8b982daeb$export$74a601a3d3f31621)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $8b69c1d8b982daeb$export$74a601a3d3f31621)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $8b69c1d8b982daeb$export$74a601a3d3f31621)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};






var $884c2de876d47f81$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $884c2de876d47f81$var$now = Date.now();
function $884c2de876d47f81$var$generateToken(i) {
    return "".concat($884c2de876d47f81$var$now, "_").concat(i, "_").concat($884c2de876d47f81$var$now);
}
function $884c2de876d47f81$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $884c2de876d47f81$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $884c2de876d47f81$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $afaffe6c4a6d47d5$export$7369836851cc1329)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $afaffe6c4a6d47d5$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $4e5367d79ffba765$export$d697c39a2985a4c)(options, $884c2de876d47f81$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $884c2de876d47f81$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $8b69c1d8b982daeb$export$e3b7eee1dbc44895)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}





var $bdc8fe02ddcebec5$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $bdc8fe02ddcebec5$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $afaffe6c4a6d47d5$export$7369836851cc1329)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $afaffe6c4a6d47d5$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $4e5367d79ffba765$export$d697c39a2985a4c)(options, $bdc8fe02ddcebec5$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $8b69c1d8b982daeb$export$e3b7eee1dbc44895)('Error formatting display name.', locale, e));
    }
}


function $e64c92d637c5ac09$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $e64c92d637c5ac09$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $e64c92d637c5ac09$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $e64c92d637c5ac09$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $4e5367d79ffba765$export$c3f4cd5551df13fd)(cache);
    var resolvedConfig = (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, (0, $4e5367d79ffba765$export$b52f8d6fc0d47415)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $8b69c1d8b982daeb$export$3ca04dd7fb305893)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $8b69c1d8b982daeb$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $8b69c1d8b982daeb$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $e64c92d637c5ac09$var$verifyConfigMessages(resolvedConfig);
    return (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $3391a165383f9061$export$f5dd818bff069720).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $3391a165383f9061$export$6871080848f10b2f).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $66237cc3ba5442e3$export$b4ea3b48dcf921f6).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $35d98a4b26b0850f$export$3ae94a2503e890a1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $35d98a4b26b0850f$export$dc1f059bce486b1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $35d98a4b26b0850f$export$3203edd9e5edd663).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $35d98a4b26b0850f$export$a7fc3a91cb2ec376).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $35d98a4b26b0850f$export$af6e5d7a5c73edeb).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $95a07bf261332d25$export$bbbd05c900f3568d).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $22e602bdfaf38867$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $22e602bdfaf38867$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        formatList: (0, $884c2de876d47f81$export$e8b8be48b45905bb).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $884c2de876d47f81$export$6f284aad1934db69).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $bdc8fe02ddcebec5$export$62fe1a4d9e891fa2).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}



function $45d21d591d93aee7$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $45d21d591d93aee7$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $281a6c3f7f4874af$export$df0c12a2d414a163)(v) ? (0, $57e517161f4aef2e$export$cfec03d26465fa63)(v) : v;
        return acc;
    }, {});
}
var $45d21d591d93aee7$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $45d21d591d93aee7$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $22e602bdfaf38867$export$25868d1e8e76735f).apply(void 0, (0, $15cbcba2c47c7dce$export$1216008129fb82ed)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $h4Bez.Children.toArray(chunks);
    return chunks;
};
var $45d21d591d93aee7$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $15cbcba2c47c7dce$export$3c9a16f847548506)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $45d21d591d93aee7$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $e64c92d637c5ac09$export$7e4cbedfdd7b4c0d)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, (0, $57e517161f4aef2e$export$b52f8d6fc0d47415)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)((0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({}, coreIntl), {
        // @ts-expect-error fix this
        formatMessage: $45d21d591d93aee7$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $45d21d591d93aee7$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};
var $45d21d591d93aee7$var$IntlProvider = /** @class */ function(_super) {
    (0, $15cbcba2c47c7dce$export$a8ba968b8961cb8a)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $4e5367d79ffba765$export$51c4f4e973f2dc00)();
        _this.state = {
            cache: _this.cache,
            intl: $45d21d591d93aee7$export$7e4cbedfdd7b4c0d($45d21d591d93aee7$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $45d21d591d93aee7$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $45d21d591d93aee7$var$processIntlConfig(props);
        if (!(0, $57e517161f4aef2e$export$d36bdfa510afb180)(prevConfig, config)) return {
            intl: $45d21d591d93aee7$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $57e517161f4aef2e$export$45c4bbf6e55bba1f)(this.state.intl);
        return $h4Bez.createElement((0, $f8fc7b8b2b80d34a$export$2881499e37b75b9a), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $57e517161f4aef2e$export$b52f8d6fc0d47415);
    return IntlProvider;
}($h4Bez.PureComponent);
var $45d21d591d93aee7$export$2e2bcd8739ae039 = $45d21d591d93aee7$var$IntlProvider;




var $h4Bez = parcelRequire("h4Bez");


var $9f49e6132307eaee$var$MINUTE = 60;
var $9f49e6132307eaee$var$HOUR = 3600;
var $9f49e6132307eaee$var$DAY = 86400;
function $9f49e6132307eaee$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $9f49e6132307eaee$var$MINUTE) return 'second';
    if (absValue < $9f49e6132307eaee$var$HOUR) return 'minute';
    if (absValue < $9f49e6132307eaee$var$DAY) return 'hour';
    return 'day';
}
function $9f49e6132307eaee$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $9f49e6132307eaee$var$MINUTE;
        case 'hour':
            return $9f49e6132307eaee$var$HOUR;
        default:
            return $9f49e6132307eaee$var$DAY;
    }
}
function $9f49e6132307eaee$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $9f49e6132307eaee$var$MINUTE;
        default:
            return value * $9f49e6132307eaee$var$HOUR;
    }
}
var $9f49e6132307eaee$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $9f49e6132307eaee$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $9f49e6132307eaee$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $9f49e6132307eaee$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $b4035d36efc112ae$export$2e2bcd8739ae039)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $15cbcba2c47c7dce$export$3c9a16f847548506)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $h4Bez.createElement(Text, null, formattedRelativeTime);
    return $h4Bez.createElement($h4Bez.Fragment, null, formattedRelativeTime);
};
var $9f49e6132307eaee$var$FormattedRelativeTime = function(_a) {
    var value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $15cbcba2c47c7dce$export$3c9a16f847548506)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $0583a75db3603b3b$export$f5708dca728d7177)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $9f49e6132307eaee$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _b = $h4Bez.useState(), prevUnit = _b[0], setPrevUnit = _b[1];
    var _c = $h4Bez.useState(0), prevValue = _c[0], setPrevValue = _c[1];
    var _d = $h4Bez.useState(0), currentValueInSeconds = _d[0], setCurrentValueInSeconds = _d[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($9f49e6132307eaee$var$canIncrement(unit) ? $9f49e6132307eaee$var$valueToSeconds(value, unit) : 0);
    }
    $h4Bez.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$9f49e6132307eaee$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $9f49e6132307eaee$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $9f49e6132307eaee$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($9f49e6132307eaee$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $9f49e6132307eaee$var$selectUnit(currentValueInSeconds);
        var unitDuration = $9f49e6132307eaee$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $h4Bez.createElement($9f49e6132307eaee$var$SimpleFormattedRelativeTime, (0, $15cbcba2c47c7dce$export$18ce0697a983be9b)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$9f49e6132307eaee$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
$9f49e6132307eaee$var$FormattedRelativeTime.defaultProps = {
    value: 0,
    unit: 'second'
};
var $9f49e6132307eaee$export$2e2bcd8739ae039 = $9f49e6132307eaee$var$FormattedRelativeTime;



/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 

var $h4Bez = parcelRequire("h4Bez");


function $dda0a684f36fcf15$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $15cbcba2c47c7dce$export$3c9a16f847548506)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $15cbcba2c47c7dce$export$3c9a16f847548506)(nextProps, [
        "values"
    ]);
    return (0, $57e517161f4aef2e$export$d36bdfa510afb180)(nextValues, values) && (0, $57e517161f4aef2e$export$d36bdfa510afb180)(otherProps, nextOtherProps);
}
function $dda0a684f36fcf15$var$FormattedMessage(props) {
    var intl = (0, $b4035d36efc112ae$export$2e2bcd8739ae039)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $h4Bez.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $h4Bez.createElement(Component, null, $h4Bez.Children.toArray(nodes));
    return $h4Bez.createElement($h4Bez.Fragment, null, nodes);
}
$dda0a684f36fcf15$var$FormattedMessage.displayName = 'FormattedMessage';
var $dda0a684f36fcf15$var$MemoizedFormattedMessage = $h4Bez.memo($dda0a684f36fcf15$var$FormattedMessage, $dda0a684f36fcf15$var$areEqual);
$dda0a684f36fcf15$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $dda0a684f36fcf15$export$2e2bcd8739ae039 = $dda0a684f36fcf15$var$MemoizedFormattedMessage;




function $dbba8fd6e98bab28$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $dbba8fd6e98bab28$export$747d244ee58120dd(msg) {
    return msg;
}
var $dbba8fd6e98bab28$export$40ae3194919d16b = (0, $144bcb20ba6c2d9d$export$b37e14176d001dec)('formatDate');
var $dbba8fd6e98bab28$export$5b390a54f8a846f7 = (0, $144bcb20ba6c2d9d$export$b37e14176d001dec)('formatTime');
var $dbba8fd6e98bab28$export$db80edc1e6b2f63d = (0, $144bcb20ba6c2d9d$export$b37e14176d001dec)('formatNumber');
var $dbba8fd6e98bab28$export$f52b44e459e6e71d = (0, $144bcb20ba6c2d9d$export$b37e14176d001dec)('formatList');
var $dbba8fd6e98bab28$export$c2336ea5aaab92fa = (0, $144bcb20ba6c2d9d$export$b37e14176d001dec)('formatDisplayName');
var $dbba8fd6e98bab28$export$7fdc7d2c91ce149b = (0, $144bcb20ba6c2d9d$export$7448277f6036d2ab)('formatDate');
var $dbba8fd6e98bab28$export$ec35873761676c2a = (0, $144bcb20ba6c2d9d$export$7448277f6036d2ab)('formatTime');



const $dcd310acfec43287$export$19678796a8dffb7d = ({ internationalization: internationalization, children: children })=>{
    const { locale: locale, messages: messages, onError: onError } = internationalization;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $45d21d591d93aee7$export$2e2bcd8739ae039), {
        locale: locale,
        messages: messages,
        onError: onError,
        children: children
    });
};
const $dcd310acfec43287$var$COUNTDOWN_UNITS = [
    {
        unit: 'second',
        seconds: 1,
        upTo: 60
    },
    {
        unit: 'minute',
        seconds: 60,
        upTo: 60
    },
    {
        unit: 'hour',
        seconds: 3600,
        upTo: 24
    }
];
const $dcd310acfec43287$var$SECONDS_PER_DAY = 86400;
const $dcd310acfec43287$var$toCountdown = (seconds)=>{
    for (const { unit: unit, seconds: unitSeconds, upTo: upTo } of $dcd310acfec43287$var$COUNTDOWN_UNITS){
        const value = Math.ceil(seconds / unitSeconds);
        if (Math.abs(value) <= upTo) return {
            value: value,
            unit: unit
        };
    }
    return {
        value: Math.ceil(seconds / $dcd310acfec43287$var$SECONDS_PER_DAY),
        unit: 'day'
    };
};
const $dcd310acfec43287$export$e6df4a75350b1cee = ()=>{
    const intl = (0, $b4035d36efc112ae$export$2e2bcd8739ae039)();
    return (0, $h4Bez.useMemo)(()=>({
            formatTranslation: (id, values)=>intl.formatMessage({
                    id: id
                }, values),
            formatList: (values, options)=>intl.formatList(values, options),
            formatTimeLeft: (value)=>{
                const { value: relativeValue, unit: unit } = $dcd310acfec43287$var$toCountdown((value.getTime() - Date.now()) / 1000);
                return intl.formatRelativeTime(relativeValue, unit);
            }
        }), [
        intl
    ]);
};
const $dcd310acfec43287$export$5bc2e2836f7b63ab = ({ id: id, values: values })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dda0a684f36fcf15$export$2e2bcd8739ae039), {
        id: id,
        values: values
    });
const $dcd310acfec43287$export$1b17df352e43d1d3 = ({ value: value })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f49e6132307eaee$export$2e2bcd8739ae039), {
        unit: "second",
        value: (value.getTime() - Date.now()) / 1000,
        updateIntervalInSeconds: 1
    });
const $dcd310acfec43287$export$d275c5eeba29af75 = ({ format: format, date: date })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($dcd310acfec43287$export$5bc2e2836f7b63ab, {
        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DATETIME,
        values: {
            type: format,
            date: date
        }
    });





parcelRequire("h4Bez");

const { Provider: $be523f14267dcd17$var$UsecasesProvider, useExtendedState: $be523f14267dcd17$var$useUsecasesExtendedState } = (0, $08b3e6ee09ecfd12$export$e50ad042342a539d)();
const { Provider: $be523f14267dcd17$var$StateProvider, useExtendedState: $be523f14267dcd17$var$useAppExtendedState } = (0, $08b3e6ee09ecfd12$export$e50ad042342a539d)();
const $be523f14267dcd17$export$d56d5432daeb70cb = ({ manager: manager, usecases: usecases, children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($be523f14267dcd17$var$StateProvider, {
        manager: manager,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($be523f14267dcd17$var$UsecasesProvider, {
            value: usecases,
            children: children
        })
    });
const $be523f14267dcd17$export$9973955de2bf96cf = $be523f14267dcd17$var$useAppExtendedState;
const $be523f14267dcd17$export$9c9c809bfed75cbf = ()=>$be523f14267dcd17$var$useUsecasesExtendedState((u)=>u);
const $be523f14267dcd17$export$b5eb5d2a4e80beed = (name)=>$be523f14267dcd17$var$useUsecasesExtendedState((u)=>u[name]);



parcelRequire("h4Bez");




const $cb46b6caf4d08903$var$codeStyle = {
    p: 2,
    borderRadius: 2,
    border: 'solid 1px',
    borderColor: 'error.main',
    typography: 'body2',
    fontFamily: 'monospace',
    color: 'error.dark',
    whiteSpace: 'break-spaces',
    wordBreak: 'break-all'
};
const $cb46b6caf4d08903$var$errorExtraInfoWrapper = {
    display: 'flex',
    mb: 1
};
const $cb46b6caf4d08903$var$Code = ({ className: className, children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        className: className,
        component: "pre",
        sx: $cb46b6caf4d08903$var$codeStyle,
        children: children
    });
const $cb46b6caf4d08903$export$d540ba6c994dd81c = ({ error: error })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($cb46b6caf4d08903$var$Code, {
        className: (0, $ab72aeb277ab974e$export$a100fd7a4d4ccbc7).stack,
        children: error.stack
    });
const $cb46b6caf4d08903$export$5b50ef99c28ea41f = ({ variant: variant, error: error, extrasTitleSuffix: extrasTitleSuffix })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        className: (0, $ab72aeb277ab974e$export$a100fd7a4d4ccbc7).extras,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($cb46b6caf4d08903$var$Code, {
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: $cb46b6caf4d08903$var$errorExtraInfoWrapper,
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                            className: (0, $ab72aeb277ab974e$export$a100fd7a4d4ccbc7)['extras-info-title'],
                            variant: variant,
                            color: "error",
                            children: [
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ERROR_EXTRA_INFORMATION
                                }),
                                ":"
                            ]
                        }),
                        extrasTitleSuffix
                    ]
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    className: (0, $ab72aeb277ab974e$export$a100fd7a4d4ccbc7)['extras-info'],
                    variant: "body2",
                    children: JSON.stringify({
                        type: error.type,
                        extras: error.extras
                    }, null, 2)
                })
            ]
        })
    });



parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");









function $2642ca6f3a461e10$export$c7c50641356bdfa5(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiSvgIcon', slot);
}
const $2642ca6f3a461e10$var$svgIconClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $2642ca6f3a461e10$export$2e2bcd8739ae039 = $2642ca6f3a461e10$var$svgIconClasses;



'use client';
const $09dab4bc1b3aad02$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            `fontSize${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(fontSize)}`
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $2642ca6f3a461e10$export$c7c50641356bdfa5), classes);
};
const $09dab4bc1b3aad02$var$SvgIconRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`fontSize${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.fontSize)}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $09dab4bc1b3aad02$var$SvgIcon = /*#__PURE__*/ $h4Bez.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $h4Bez.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $09dab4bc1b3aad02$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($09dab4bc1b3aad02$var$SvgIconRoot, {
        as: component,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$09dab4bc1b3aad02$var$SvgIcon.muiName = 'SvgIcon';
var $09dab4bc1b3aad02$export$2e2bcd8739ae039 = $09dab4bc1b3aad02$var$SvgIcon;



'use client';
function $88f728827016eaaa$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
            "data-testid": undefined,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $09dab4bc1b3aad02$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ $h4Bez.memo(/*#__PURE__*/ $h4Bez.forwardRef(Component));
}



"use client";
var $63351b87e92a3af6$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'InfoOutlined');





parcelRequire("h4Bez");

parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");








/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $4062a7b1f5a47416$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $4062a7b1f5a47416$export$2e2bcd8739ae039 = $4062a7b1f5a47416$var$isHostComponent;




// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $c5adc846d2f2ee36$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $c5f3fedd75c1d71e$export$2e2bcd8739ae039 = (0, $c5adc846d2f2ee36$export$2e2bcd8739ae039);


function $2e2b971777d65c3c$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


var $4fa343ae2434ad28$export$2e2bcd8739ae039 = (0, $2e2b971777d65c3c$export$2e2bcd8739ae039);



function $328f2d6822f57247$export$2e2bcd8739ae039(node) {
    const doc = (0, $2e2b971777d65c3c$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $eb0aab3eb5dc2a90$export$2e2bcd8739ae039 = (0, $328f2d6822f57247$export$2e2bcd8739ae039);



var $h4Bez = parcelRequire("h4Bez");


var $h4Bez = parcelRequire("h4Bez");
'use client';
const $ebcd91de7f6a0c24$var$UNINITIALIZED = {};
function $ebcd91de7f6a0c24$export$2e2bcd8739ae039(init, initArg) {
    const ref = $h4Bez.useRef($ebcd91de7f6a0c24$var$UNINITIALIZED);
    if (ref.current === $ebcd91de7f6a0c24$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $h4Bez = parcelRequire("h4Bez");
'use client';
const $3a063a92a384560e$var$EMPTY = [];
function $3a063a92a384560e$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $h4Bez.useEffect(fn, $3a063a92a384560e$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $4497065fec36f675$export$786b4da70f00938b {
    static create() {
        return new $4497065fec36f675$export$786b4da70f00938b();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $4497065fec36f675$export$2e2bcd8739ae039() {
    const timeout = (0, $ebcd91de7f6a0c24$export$2e2bcd8739ae039)($4497065fec36f675$export$786b4da70f00938b.create).current;
    (0, $3a063a92a384560e$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}




var $h4Bez = parcelRequire("h4Bez");
function $ba4f9121b652949b$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($h4Bez.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}


function $4b23e67a53a2b954$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $f37024e9582434b0$export$2e2bcd8739ae039(t, e) {
    return $f37024e9582434b0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $f37024e9582434b0$export$2e2bcd8739ae039(t, e);
}


function $d6dc968cc2ff4ccc$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $f37024e9582434b0$export$2e2bcd8739ae039)(t, o);
}




var $h4Bez = parcelRequire("h4Bez");

var $fce1fad9e7b45538$export$2e2bcd8739ae039 = {
    disabled: false
};




var $h4Bez = parcelRequire("h4Bez");
var $e017bc0646804e2f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createContext(null);


var $ccc5f25fb0d57dff$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $fee6626576e0ac90$export$bb38bb9a1161268 = 'unmounted';
var $fee6626576e0ac90$export$84cbff306f539230 = 'exited';
var $fee6626576e0ac90$export$df38205c966be359 = 'entering';
var $fee6626576e0ac90$export$78e9e6e3e014d60a = 'entered';
var $fee6626576e0ac90$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $fee6626576e0ac90$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $d6dc968cc2ff4ccc$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $fee6626576e0ac90$export$84cbff306f539230;
                _this.appearStatus = $fee6626576e0ac90$export$df38205c966be359;
            } else initialStatus = $fee6626576e0ac90$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $fee6626576e0ac90$export$bb38bb9a1161268;
        else initialStatus = $fee6626576e0ac90$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $fee6626576e0ac90$export$bb38bb9a1161268) return {
            status: $fee6626576e0ac90$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $fee6626576e0ac90$export$df38205c966be359 && status !== $fee6626576e0ac90$export$78e9e6e3e014d60a) nextStatus = $fee6626576e0ac90$export$df38205c966be359;
            } else if (status === $fee6626576e0ac90$export$df38205c966be359 || status === $fee6626576e0ac90$export$78e9e6e3e014d60a) nextStatus = $fee6626576e0ac90$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $fee6626576e0ac90$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($68fd039c491aa2b2$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $ccc5f25fb0d57dff$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $fee6626576e0ac90$export$84cbff306f539230) this.setState({
            status: $fee6626576e0ac90$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($68fd039c491aa2b2$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $fce1fad9e7b45538$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $fee6626576e0ac90$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $fee6626576e0ac90$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $fee6626576e0ac90$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($68fd039c491aa2b2$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $fce1fad9e7b45538$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $fee6626576e0ac90$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $fee6626576e0ac90$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $fee6626576e0ac90$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($68fd039c491aa2b2$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $fee6626576e0ac90$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $4b23e67a53a2b954$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement((0, $e017bc0646804e2f$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Component);
$fee6626576e0ac90$var$Transition.contextType = (0, $e017bc0646804e2f$export$2e2bcd8739ae039);
$fee6626576e0ac90$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $fee6626576e0ac90$var$noop() {}
$fee6626576e0ac90$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $fee6626576e0ac90$var$noop,
    onEntering: $fee6626576e0ac90$var$noop,
    onEntered: $fee6626576e0ac90$var$noop,
    onExit: $fee6626576e0ac90$var$noop,
    onExiting: $fee6626576e0ac90$var$noop,
    onExited: $fee6626576e0ac90$var$noop
};
$fee6626576e0ac90$var$Transition.UNMOUNTED = $fee6626576e0ac90$export$bb38bb9a1161268;
$fee6626576e0ac90$var$Transition.EXITED = $fee6626576e0ac90$export$84cbff306f539230;
$fee6626576e0ac90$var$Transition.ENTERING = $fee6626576e0ac90$export$df38205c966be359;
$fee6626576e0ac90$var$Transition.ENTERED = $fee6626576e0ac90$export$78e9e6e3e014d60a;
$fee6626576e0ac90$var$Transition.EXITING = $fee6626576e0ac90$export$4aacc83d4d59139f;
var $fee6626576e0ac90$export$2e2bcd8739ae039 = $fee6626576e0ac90$var$Transition;



const $93e522fc190a5b9f$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $93e522fc190a5b9f$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}



var $h4Bez = parcelRequire("h4Bez");
'use client';
function $4fa58c431bc87919$export$2e2bcd8739ae039(...refs) {
    const cleanupRef = $h4Bez.useRef(undefined);
    const refEffect = $h4Bez.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $h4Bez.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


'use client';
var $6fa00ac7fde563d8$export$2e2bcd8739ae039 = (0, $4fa58c431bc87919$export$2e2bcd8739ae039);



'use client';
function $73da2bbf79b5829f$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $73da2bbf79b5829f$var$styles = {
    entering: {
        opacity: 1,
        transform: $73da2bbf79b5829f$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $73da2bbf79b5829f$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $73da2bbf79b5829f$var$Grow = /*#__PURE__*/ $h4Bez.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $fee6626576e0ac90$export$2e2bcd8739ae039), ...other } = props;
    const timer = (0, $4497065fec36f675$export$2e2bcd8739ae039)();
    const autoTimeout = $h4Bez.useRef();
    const theme = (0, $cd99783e1cac2d84$export$2e2bcd8739ae039)();
    const nodeRef = $h4Bez.useRef(null);
    const handleRef = (0, $6fa00ac7fde563d8$export$2e2bcd8739ae039)(nodeRef, (0, $ba4f9121b652949b$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $93e522fc190a5b9f$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $93e522fc190a5b9f$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $73da2bbf79b5829f$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $93e522fc190a5b9f$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $73da2bbf79b5829f$var$isWebKit154 ? duration : duration * 0.666,
                delay: $73da2bbf79b5829f$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $73da2bbf79b5829f$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $h4Bez.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $73da2bbf79b5829f$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$73da2bbf79b5829f$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if ($73da2bbf79b5829f$var$Grow) $73da2bbf79b5829f$var$Grow.muiSupportAuto = true;
var $73da2bbf79b5829f$export$2e2bcd8739ae039 = $73da2bbf79b5829f$var$Grow;



var $h4Bez = parcelRequire("h4Bez");






var $h4Bez = parcelRequire("h4Bez");






/**
 * Gets the actual active element, traversing through shadow roots if necessary.
 *
 * When an element inside a shadow root has focus, `document.activeElement` returns
 * the shadow host element. This function recursively traverses shadow roots to find
 * the actual focused element.
 *
 * @param root - The document or shadow root to start the search from.
 * @returns The actual focused element, or null if no element has focus.
 *
 * @example
 * // In a shadow DOM context
 * const activeElement = getActiveElement(document);
 * // Returns the actual focused element inside the shadow root
 *
 * @example
 * // Starting from a specific document
 * const activeElement = getActiveElement(ownerDocument(element));
 */ function $cc42e8f19a26da74$export$2e2bcd8739ae039(doc) {
    let element = doc.activeElement;
    while(element?.shadowRoot?.activeElement != null)element = element.shadowRoot.activeElement;
    return element;
}


var $0af2c8a204f06237$export$2e2bcd8739ae039 = (0, $cc42e8f19a26da74$export$2e2bcd8739ae039);



'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $fb0df63f450eb465$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $fb0df63f450eb465$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $fb0df63f450eb465$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $fb0df63f450eb465$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $fb0df63f450eb465$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $fb0df63f450eb465$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($fb0df63f450eb465$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $fb0df63f450eb465$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$fb0df63f450eb465$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $fb0df63f450eb465$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $fb0df63f450eb465$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $fb0df63f450eb465$var$defaultGetTabbable, isEnabled: isEnabled = $fb0df63f450eb465$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $h4Bez.useRef(false);
    const sentinelStart = $h4Bez.useRef(null);
    const sentinelEnd = $h4Bez.useRef(null);
    const nodeToRestore = $h4Bez.useRef(null);
    const reactFocusEventTarget = $h4Bez.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $h4Bez.useRef(false);
    const rootRef = $h4Bez.useRef(null);
    const handleRef = (0, $4fa58c431bc87919$export$2e2bcd8739ae039)((0, $ba4f9121b652949b$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $h4Bez.useRef(null);
    $h4Bez.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $h4Bez.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $2e2b971777d65c3c$export$2e2bcd8739ae039)(rootRef.current);
        const activeElement = (0, $0af2c8a204f06237$export$2e2bcd8739ae039)(doc);
        if (!rootRef.current.contains(activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $h4Bez.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $2e2b971777d65c3c$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            const activeElement = (0, $0af2c8a204f06237$export$2e2bcd8739ae039)(doc);
            // Make sure the next tab starts from the right place.
            // activeElement refers to the origin.
            if (activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            const activeEl = (0, $0af2c8a204f06237$export$2e2bcd8739ae039)(doc);
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(activeEl)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && activeEl !== sentinelStart.current && activeEl !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (activeEl !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (activeEl === sentinelStart.current || activeEl === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            const activeEl = (0, $0af2c8a204f06237$export$2e2bcd8739ae039)(doc);
            if (activeEl && activeEl.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($h4Bez.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $h4Bez.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $fb0df63f450eb465$export$2e2bcd8739ae039 = $fb0df63f450eb465$var$FocusTrap;



var $h4Bez = parcelRequire("h4Bez");




/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $9a781affb256ebc4$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}





'use client';
function $8653e21686aeef13$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $8653e21686aeef13$var$Portal = /*#__PURE__*/ $h4Bez.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $h4Bez.useState(null);
    const handleRef = (0, $4fa58c431bc87919$export$2e2bcd8739ae039)(/*#__PURE__*/ $h4Bez.isValidElement(children) ? (0, $ba4f9121b652949b$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $01a3a2b63fe8dafe$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($8653e21686aeef13$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $01a3a2b63fe8dafe$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $9a781affb256ebc4$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $9a781affb256ebc4$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $h4Bez.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $h4Bez.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $68fd039c491aa2b2$exports.createPortal(children, mountNode) : mountNode;
});
var $8653e21686aeef13$export$2e2bcd8739ae039 = $8653e21686aeef13$var$Portal;






var $h4Bez = parcelRequire("h4Bez");







/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $d66d448a6f54282f$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $4062a7b1f5a47416$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $d66d448a6f54282f$export$2e2bcd8739ae039 = $d66d448a6f54282f$var$appendOwnerState;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $aec1308c8f28d758$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $aec1308c8f28d758$export$2e2bcd8739ae039 = $aec1308c8f28d758$var$resolveComponentProps;



/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $6f1a7dc79a4af46c$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $6f1a7dc79a4af46c$export$2e2bcd8739ae039 = $6f1a7dc79a4af46c$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $f8e95bffabee63b4$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $f8e95bffabee63b4$export$2e2bcd8739ae039 = $f8e95bffabee63b4$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $2552d8bac41e7610$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $74096779e8c9e450$export$2e2bcd8739ae039)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $6f1a7dc79a4af46c$export$2e2bcd8739ae039)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $f8e95bffabee63b4$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $f8e95bffabee63b4$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $74096779e8c9e450$export$2e2bcd8739ae039)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $2552d8bac41e7610$export$2e2bcd8739ae039 = $2552d8bac41e7610$var$mergeSlotProps;


'use client';
function $5f156b258c957bd7$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $aec1308c8f28d758$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $2552d8bac41e7610$export$2e2bcd8739ae039)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $4fa58c431bc87919$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $d66d448a6f54282f$export$2e2bcd8739ae039)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}



var $h4Bez = parcelRequire("h4Bez");








'use client';
const $a5aa955e27ea098e$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $a5aa955e27ea098e$var$Fade = /*#__PURE__*/ $h4Bez.forwardRef(function Fade(props, ref) {
    const theme = (0, $cd99783e1cac2d84$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $fee6626576e0ac90$export$2e2bcd8739ae039), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $h4Bez.useRef(null);
    const handleRef = (0, $6fa00ac7fde563d8$export$2e2bcd8739ae039)(nodeRef, (0, $ba4f9121b652949b$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $93e522fc190a5b9f$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $93e522fc190a5b9f$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $93e522fc190a5b9f$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $h4Bez.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$a5aa955e27ea098e$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $a5aa955e27ea098e$export$2e2bcd8739ae039 = $a5aa955e27ea098e$var$Fade;




function $b7f3349ebb274989$export$9927a91fd93152bd(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiBackdrop', slot);
}
const $b7f3349ebb274989$var$backdropClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $b7f3349ebb274989$export$2e2bcd8739ae039 = $b7f3349ebb274989$var$backdropClasses;



'use client';
const $1e67fed7a77f91a6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $b7f3349ebb274989$export$9927a91fd93152bd), classes);
};
const $1e67fed7a77f91a6$var$BackdropRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $1e67fed7a77f91a6$var$Backdrop = /*#__PURE__*/ $h4Bez.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $1e67fed7a77f91a6$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        component: component,
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('root', {
        elementType: $1e67fed7a77f91a6$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $a5aa955e27ea098e$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            ref: ref,
            children: children
        })
    });
});
var $1e67fed7a77f91a6$export$2e2bcd8739ae039 = $1e67fed7a77f91a6$var$Backdrop;



var $h4Bez = parcelRequire("h4Bez");



var $h4Bez = parcelRequire("h4Bez");

'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $8ff1dc7abf990699$var$useEventCallback(fn) {
    const ref = $h4Bez.useRef(fn);
    (0, $01a3a2b63fe8dafe$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $h4Bez.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $8ff1dc7abf990699$export$2e2bcd8739ae039 = $8ff1dc7abf990699$var$useEventCallback;


/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $f632681c6d4a0a8c$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}





// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $861cc607c015e86b$export$2e2bcd8739ae039(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}


// Is a vertical scrollbar displayed?
function $4fa4abccd0c48c7c$var$isOverflowing(container) {
    const doc = (0, $2e2b971777d65c3c$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $328f2d6822f57247$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $4fa4abccd0c48c7c$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $4fa4abccd0c48c7c$var$getPaddingRight(element) {
    return parseFloat((0, $328f2d6822f57247$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight) || 0;
}
function $4fa4abccd0c48c7c$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $4fa4abccd0c48c7c$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$4fa4abccd0c48c7c$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $4fa4abccd0c48c7c$export$e1bd0c6150f13d96(element, hide);
    });
}
function $4fa4abccd0c48c7c$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $4fa4abccd0c48c7c$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($4fa4abccd0c48c7c$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $861cc607c015e86b$export$2e2bcd8739ae039)((0, $328f2d6822f57247$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$4fa4abccd0c48c7c$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $2e2b971777d65c3c$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$4fa4abccd0c48c7c$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $2e2b971777d65c3c$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $328f2d6822f57247$export$2e2bcd8739ae039)(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $4fa4abccd0c48c7c$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $4fa4abccd0c48c7c$export$ce11c4ecd08cea67 {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $4fa4abccd0c48c7c$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $4fa4abccd0c48c7c$var$getHiddenSiblings(container);
        $4fa4abccd0c48c7c$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $4fa4abccd0c48c7c$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $4fa4abccd0c48c7c$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $4fa4abccd0c48c7c$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $4fa4abccd0c48c7c$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $4fa4abccd0c48c7c$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $4fa4abccd0c48c7c$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $4fa4abccd0c48c7c$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $0906ab16067ffe29$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $0906ab16067ffe29$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $0906ab16067ffe29$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $0906ab16067ffe29$var$manager = new (0, $4fa4abccd0c48c7c$export$ce11c4ecd08cea67)();
function $0906ab16067ffe29$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $h4Bez.useRef({});
    const mountNodeRef = $h4Bez.useRef(null);
    const modalRef = $h4Bez.useRef(null);
    const handleRef = (0, $4fa58c431bc87919$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $h4Bez.useState(!open);
    const hasTransition = $0906ab16067ffe29$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $2e2b971777d65c3c$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $0906ab16067ffe29$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $0906ab16067ffe29$var$getContainer(container) || getDoc().body;
        $0906ab16067ffe29$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$0906ab16067ffe29$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $4fa4abccd0c48c7c$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $h4Bez.useCallback(()=>{
        $0906ab16067ffe29$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $h4Bez.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $h4Bez.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $6f1a7dc79a4af46c$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $f632681c6d4a0a8c$export$2e2bcd8739ae039)(handleEnter, children?.props.onEnter ?? $0906ab16067ffe29$var$noop),
            onExited: (0, $f632681c6d4a0a8c$export$2e2bcd8739ae039)(handleExited, children?.props.onExited ?? $0906ab16067ffe29$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $0906ab16067ffe29$export$2e2bcd8739ae039 = $0906ab16067ffe29$var$useModal;




function $e372142bb6242c60$export$67960e22b12a638d(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiModal', slot);
}
const $e372142bb6242c60$var$modalClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $e372142bb6242c60$export$2e2bcd8739ae039 = $e372142bb6242c60$var$modalClasses;




'use client';
const $22fdbb8607c29afa$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $e372142bb6242c60$export$67960e22b12a638d), classes);
};
const $22fdbb8607c29afa$var$ModalRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $22fdbb8607c29afa$var$ModalBackdrop = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $1e67fed7a77f91a6$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop'
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $22fdbb8607c29afa$var$Modal = /*#__PURE__*/ $h4Bez.forwardRef(function Modal(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $22fdbb8607c29afa$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $0906ab16067ffe29$export$2e2bcd8739ae039)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $22fdbb8607c29afa$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $22fdbb8607c29afa$var$ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8653e21686aeef13$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fb0df63f450eb465$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $h4Bez.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $22fdbb8607c29afa$export$2e2bcd8739ae039 = $22fdbb8607c29afa$var$Modal;



var $h4Bez = parcelRequire("h4Bez");












function $b92c096145ad088a$export$29cdb466b9b6f20b(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiPaper', slot);
}
const $b92c096145ad088a$var$paperClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $b92c096145ad088a$export$2e2bcd8739ae039 = $b92c096145ad088a$var$paperClasses;



'use client';
const $d6020d3fa35703e9$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $b92c096145ad088a$export$29cdb466b9b6f20b), classes);
};
const $d6020d3fa35703e9$var$PaperRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $d6020d3fa35703e9$var$Paper = /*#__PURE__*/ $h4Bez.forwardRef(function Paper(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $cd99783e1cac2d84$export$2e2bcd8739ae039)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $d6020d3fa35703e9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($d6020d3fa35703e9$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $3289d56f59a873c2$export$58f0f39f63f3cf42)('#fff', (0, $61dc2be28a9690a5$export$2e2bcd8739ae039)(elevation))}, ${(0, $3289d56f59a873c2$export$58f0f39f63f3cf42)('#fff', (0, $61dc2be28a9690a5$export$2e2bcd8739ae039)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $d6020d3fa35703e9$export$2e2bcd8739ae039 = $d6020d3fa35703e9$var$Paper;




function $f0c6ec8bfbb7b92e$export$88f455dd56c95edb(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiPopover', slot);
}
const $f0c6ec8bfbb7b92e$var$popoverClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiPopover', [
    'root',
    'paper'
]);
var $f0c6ec8bfbb7b92e$export$2e2bcd8739ae039 = $f0c6ec8bfbb7b92e$var$popoverClasses;




// Brought from [Base UI](https://github.com/mui/base-ui/blob/master/packages/react/src/merge-props/mergeProps.ts#L119)
// Use it directly from Base UI once it's a package dependency.
function $a2e9ce20abe2966a$var$isEventHandler(key, value) {
    // This approach is more efficient than using a regex.
    const thirdCharCode = key.charCodeAt(2);
    return key[0] === 'o' && key[1] === 'n' && thirdCharCode >= 65 /* A */  && thirdCharCode <= 90 /* Z */  && typeof value === 'function';
}
function $a2e9ce20abe2966a$export$2e2bcd8739ae039(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    function extractHandlers(externalSlotPropsValue, defaultSlotPropsValue) {
        const handlers = {};
        Object.keys(defaultSlotPropsValue).forEach((key)=>{
            if ($a2e9ce20abe2966a$var$isEventHandler(key, defaultSlotPropsValue[key]) && typeof externalSlotPropsValue[key] === 'function') // only compose the handlers if both default and external slot props match the event handler
            handlers[key] = (...args)=>{
                externalSlotPropsValue[key](...args);
                defaultSlotPropsValue[key](...args);
            };
        });
        return handlers;
    }
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        const handlers = extractHandlers(externalSlotPropsValue, defaultSlotPropsValue);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...handlers,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const handlers = extractHandlers(externalSlotProps, typedDefaultSlotProps);
    const className = (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...handlers,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}



'use client';
function $63ee27f962173109$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $63ee27f962173109$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $63ee27f962173109$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $63ee27f962173109$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $63ee27f962173109$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $f0c6ec8bfbb7b92e$export$88f455dd56c95edb), classes);
};
const $63ee27f962173109$export$bcce13685275fc99 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $22fdbb8607c29afa$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root'
})({});
const $63ee27f962173109$export$821346c38a2d9390 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper'
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $63ee27f962173109$var$Popover = /*#__PURE__*/ $h4Bez.forwardRef(function Popover(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: // TODO: remove in v7
    slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps = {}, disableScrollLock: // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = $h4Bez.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $63ee27f962173109$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $h4Bez.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $63ee27f962173109$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $4fa343ae2434ad28$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $63ee27f962173109$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $63ee27f962173109$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $h4Bez.useCallback((elemRect)=>{
        return {
            vertical: $63ee27f962173109$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $63ee27f962173109$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $h4Bez.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $63ee27f962173109$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $eb0aab3eb5dc2a90$export$2e2bcd8739ae039)($63ee27f962173109$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $63ee27f962173109$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $h4Bez.useState(open);
    const setPositioningStyles = $h4Bez.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $h4Bez.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $h4Bez.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $h4Bez.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $h4Bez.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $c5f3fedd75c1d71e$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $eb0aab3eb5dc2a90$export$2e2bcd8739ae039)($63ee27f962173109$var$resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $73da2bbf79b5829f$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $4fa343ae2434ad28$export$2e2bcd8739ae039)($63ee27f962173109$var$resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $63ee27f962173109$export$bcce13685275fc99,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $a2e9ce20abe2966a$export$2e2bcd8739ae039)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: $63ee27f962173109$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $4062a7b1f5a47416$export$2e2bcd8739ae039)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var $63ee27f962173109$export$2e2bcd8739ae039 = $63ee27f962173109$var$Popover;



parcelRequire("h4Bez");

const { Provider: $5c50dcf7e155ce8c$var$Provider, useExtendedState: $5c50dcf7e155ce8c$var$useExtendedState, useExtendedStateDispatcher: $5c50dcf7e155ce8c$var$useExtendedStateDispatcher } = (0, $08b3e6ee09ecfd12$export$e50ad042342a539d)({
    ignorePropsChanges: true
});
const $5c50dcf7e155ce8c$var$initialState = {
    anchorEl: null
};
const $5c50dcf7e155ce8c$export$1d7e255c6105d39b = ({ children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($5c50dcf7e155ce8c$var$Provider, {
        value: $5c50dcf7e155ce8c$var$initialState,
        children: children
    });
const $5c50dcf7e155ce8c$export$718dfabee0fc16f8 = ()=>$5c50dcf7e155ce8c$var$useExtendedState((s)=>s.anchorEl);
const $5c50dcf7e155ce8c$export$b13dce3af0135d87 = ()=>{
    const dispatch = $5c50dcf7e155ce8c$var$useExtendedStateDispatcher();
    return (anchorEl)=>dispatch({
            anchorEl: anchorEl
        });
};
const $5c50dcf7e155ce8c$export$89554eb4b4787636 = ()=>{
    const setOrigin = $5c50dcf7e155ce8c$export$b13dce3af0135d87();
    return ()=>setOrigin(null);
};


const $40650a35df6eb212$var$Popover = (props)=>{
    const anchorEl = (0, $5c50dcf7e155ce8c$export$718dfabee0fc16f8)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $63ee27f962173109$export$2e2bcd8739ae039), {
        ...props,
        anchorEl: anchorEl,
        open: Boolean(anchorEl)
    });
};
var $40650a35df6eb212$export$2e2bcd8739ae039 = $40650a35df6eb212$var$Popover;



const $f32134562d667542$var$Content = ({ className: className, trigger: trigger, children: children })=>{
    const open = (0, $5c50dcf7e155ce8c$export$718dfabee0fc16f8)() !== null;
    const setOrigin = (0, $5c50dcf7e155ce8c$export$b13dce3af0135d87)();
    const close = (0, $5c50dcf7e155ce8c$export$89554eb4b4787636)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            trigger({
                open: open,
                onClick: (e)=>setOrigin(e.currentTarget)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $40650a35df6eb212$export$2e2bcd8739ae039), {
                className: className,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                onClose: close,
                children: children
            })
        ]
    });
};
const $f32134562d667542$export$adce78b89d4ae3cc = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5c50dcf7e155ce8c$export$1d7e255c6105d39b), {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($f32134562d667542$var$Content, {
            ...props
        })
    });



const $dfa653ca24cb5d9a$var$errorPopoverStyle = {
    display: 'flex',
    width: '100%'
};
const $dfa653ca24cb5d9a$var$infoIconStyle = {
    m: 'auto'
};
const $dfa653ca24cb5d9a$var$contentWrapperStyle = {
    mt: 1,
    mx: 1
};
const $dfa653ca24cb5d9a$export$8afccc1c0f0dfc45 = ({ error: error, children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        className: (0, $ab72aeb277ab974e$export$a100fd7a4d4ccbc7).popover,
        sx: $dfa653ca24cb5d9a$var$errorPopoverStyle,
        children: [
            children,
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f32134562d667542$export$adce78b89d4ae3cc), {
                className: (0, $ab72aeb277ab974e$export$a100fd7a4d4ccbc7)['popover-content'],
                trigger: ({ onClick: onClick })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $63351b87e92a3af6$export$2e2bcd8739ae039), {
                        className: (0, $ab72aeb277ab974e$export$a100fd7a4d4ccbc7)['popover-button'],
                        sx: $dfa653ca24cb5d9a$var$infoIconStyle,
                        onClick: onClick
                    }),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    className: (0, $ab72aeb277ab974e$export$a100fd7a4d4ccbc7)['popover-extras'],
                    sx: $dfa653ca24cb5d9a$var$contentWrapperStyle,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $cb46b6caf4d08903$export$5b50ef99c28ea41f), {
                        variant: "body2",
                        error: error
                    })
                })
            })
        ]
    });



parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");











function $5cc65fc6482319fc$export$29cad1383b3f235d(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiCircularProgress', slot);
}
const $5cc65fc6482319fc$var$circularProgressClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'track',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $5cc65fc6482319fc$export$2e2bcd8739ae039 = $5cc65fc6482319fc$var$circularProgressClasses;



'use client';
const $95388f9578043f1e$var$SIZE = 44;
const $95388f9578043f1e$var$circularRotateKeyframe = (0, $2260c64920c0bb2a$export$d25ddfdf17c3ad3e)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $95388f9578043f1e$var$circularDashKeyframe = (0, $2260c64920c0bb2a$export$d25ddfdf17c3ad3e)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $95388f9578043f1e$var$rotateAnimation = typeof $95388f9578043f1e$var$circularRotateKeyframe !== 'string' ? (0, $2260c64920c0bb2a$export$dbf350e5966cf602)`
        animation: ${$95388f9578043f1e$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $95388f9578043f1e$var$dashAnimation = typeof $95388f9578043f1e$var$circularDashKeyframe !== 'string' ? (0, $2260c64920c0bb2a$export$dbf350e5966cf602)`
        animation: ${$95388f9578043f1e$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $95388f9578043f1e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`
        ],
        svg: [
            'svg'
        ],
        track: [
            'track'
        ],
        circle: [
            'circle',
            `circle${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $5cc65fc6482319fc$export$29cad1383b3f235d), classes);
};
const $95388f9578043f1e$var$CircularProgressRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $95388f9578043f1e$var$rotateAnimation || {
                    animation: `${$95388f9578043f1e$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $95388f9578043f1e$var$CircularProgressSVG = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg'
})({
    display: 'block' // Keeps the progress centered
});
const $95388f9578043f1e$var$CircularProgressCircle = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $95388f9578043f1e$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$95388f9578043f1e$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
const $95388f9578043f1e$var$CircularProgressTrack = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Track'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        stroke: 'currentColor',
        opacity: (theme.vars || theme).palette.action.activatedOpacity
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $95388f9578043f1e$var$CircularProgress = /*#__PURE__*/ $h4Bez.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, enableTrackSlot: enableTrackSlot = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant,
        enableTrackSlot: enableTrackSlot
    };
    const classes = $95388f9578043f1e$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($95388f9578043f1e$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($95388f9578043f1e$var$CircularProgressRoot, {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($95388f9578043f1e$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$95388f9578043f1e$var$SIZE / 2} ${$95388f9578043f1e$var$SIZE / 2} ${$95388f9578043f1e$var$SIZE} ${$95388f9578043f1e$var$SIZE}`,
            children: [
                enableTrackSlot ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($95388f9578043f1e$var$CircularProgressTrack, {
                    className: classes.track,
                    ownerState: ownerState,
                    cx: $95388f9578043f1e$var$SIZE,
                    cy: $95388f9578043f1e$var$SIZE,
                    r: ($95388f9578043f1e$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness,
                    "aria-hidden": "true"
                }) : null,
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($95388f9578043f1e$var$CircularProgressCircle, {
                    className: classes.circle,
                    style: circleStyle,
                    ownerState: ownerState,
                    cx: $95388f9578043f1e$var$SIZE,
                    cy: $95388f9578043f1e$var$SIZE,
                    r: ($95388f9578043f1e$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness
                })
            ]
        })
    });
});
var $95388f9578043f1e$export$2e2bcd8739ae039 = $95388f9578043f1e$var$CircularProgress;





"use client";
var $e923e15544c95619$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), 'CheckCircle');



"use client";
var $90b68bb2354d9221$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'CheckCircleOutline');



"use client";
var $532c360caa5d9e70$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1m-.01-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8m1-3h-2v-2h2z"
}), 'ErrorOutlineRounded');



"use client";
var $08c9290ca718566e$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 11c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1m1 4h-2v-2h2z"
}), 'ErrorRounded');




const $fb671afc24ce07a1$var$validationsWrapperStyle = {
    textAlign: 'center'
};
const $fb671afc24ce07a1$var$validationsLoaderStyle = {
    mx: 'auto'
};
const $fb671afc24ce07a1$var$validationStyle = {
    display: 'flex',
    width: '100%'
};
const $fb671afc24ce07a1$var$validationIconStyle = {
    my: 'auto',
    mr: 1
};
const $fb671afc24ce07a1$var$validationLabelStyle = {
    my: 'auto'
};
const $fb671afc24ce07a1$export$ac0218a70844ff2 = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('CybusValidations', [
    'root',
    'loader',
    'validation'
]);
const $fb671afc24ce07a1$export$f95a619b04479b7d = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('CybusValidation', [
    'root',
    'icon',
    'label'
]);
const $fb671afc24ce07a1$export$794e892580855985 = ({ className: className, sx: sx, labelVariant: labelVariant = 'body2', error: error = false, outlined: outlined = false, children: children, ...props })=>{
    const [Icon, color] = error ? [
        outlined ? (0, $532c360caa5d9e70$export$2e2bcd8739ae039) : (0, $08c9290ca718566e$export$2e2bcd8739ae039),
        'error.main'
    ] : [
        outlined ? (0, $90b68bb2354d9221$export$2e2bcd8739ae039) : (0, $e923e15544c95619$export$2e2bcd8739ae039),
        'success.main'
    ];
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($deeee9bf4fa3e86f$exports)))(className, $fb671afc24ce07a1$export$f95a619b04479b7d.root),
        sx: {
            ...$fb671afc24ce07a1$var$validationStyle,
            ...sx
        },
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Icon, {
                className: $fb671afc24ce07a1$export$f95a619b04479b7d.icon,
                sx: {
                    color: color,
                    ...$fb671afc24ce07a1$var$validationIconStyle
                }
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                className: $fb671afc24ce07a1$export$f95a619b04479b7d.label,
                sx: {
                    color: color,
                    ...$fb671afc24ce07a1$var$validationLabelStyle
                },
                variant: labelVariant,
                children: children
            })
        ]
    });
};
const $fb671afc24ce07a1$export$d0473d205c8ede55 = ({ className: className, sx: sx, validations: validations, labelVariant: labelVariant, outlined: outlined, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($deeee9bf4fa3e86f$exports)))(className, $fb671afc24ce07a1$export$ac0218a70844ff2.root),
        sx: {
            ...$fb671afc24ce07a1$var$validationsWrapperStyle,
            ...sx
        },
        children: [
            !(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(validations) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $95388f9578043f1e$export$2e2bcd8739ae039), {
                className: $fb671afc24ce07a1$export$ac0218a70844ff2.loader,
                sx: $fb671afc24ce07a1$var$validationsLoaderStyle
            }),
            validations.map((v, k)=>{
                const error = (0, $c3e1b746ad236797$export$8d524fb6540252df).is(v);
                const label = error ? v.message : v;
                return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($fb671afc24ce07a1$export$794e892580855985, {
                    className: $fb671afc24ce07a1$export$ac0218a70844ff2.validation,
                    labelVariant: labelVariant,
                    error: error,
                    outlined: outlined,
                    children: label
                }, k);
            })
        ]
    });


const $b39283bccca0350b$var$timeoutLinkStyle = {
    cursor: 'pointer'
};
const $b39283bccca0350b$var$headerSectionStyle = {
    backgroundColor: 'error.main',
    p: 3.4,
    my: 8,
    borderRadius: 1,
    [`&.${(0, $ab72aeb277ab974e$export$a100fd7a4d4ccbc7).header} > *`]: {
        color: 'white'
    }
};
const $b39283bccca0350b$var$hasExtras = (actual, expected, error)=>actual === expected && !(0, $2ae70427bab197d4$export$dd1bc94b04021eeb)(error.extras);
const $b39283bccca0350b$var$ErrorHeader = ({ customTitle: customTitle, titleVariant: titleVariant, error: error, extras: extras })=>{
    const hasSection = extras === 'section';
    const title = customTitle(error) || /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ERROR_TITLE,
        values: {
            message: error.message
        }
    });
    const validation = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fb671afc24ce07a1$export$794e892580855985), {
        sx: hasSection ? $b39283bccca0350b$var$headerSectionStyle : {},
        outlined: hasSection,
        className: (0, $ab72aeb277ab974e$export$a100fd7a4d4ccbc7).header,
        error: true,
        labelVariant: hasSection ? 'subtitle2' : titleVariant,
        children: title
    });
    return $b39283bccca0350b$var$hasExtras(extras, 'popover', error) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dfa653ca24cb5d9a$export$8afccc1c0f0dfc45), {
        error: error,
        children: validation
    }) : validation;
};
const $b39283bccca0350b$var$ErrorTimeoutHeader = ()=>{
    const network = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('fixNetworkIssueUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
        variant: "body1",
        color: "error",
        "data-testid": "error-timeout-text",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TIMEOUT_ERROR,
            values: {
                link: (0, $4772774eee62bdcc$export$18fadbe56dfcb1a1)((0, $a497eee141ca75b8$export$2e2bcd8739ae039), {
                    onClick: ()=>network.invoke(),
                    sx: $b39283bccca0350b$var$timeoutLinkStyle
                })
            }
        })
    });
};
const $b39283bccca0350b$export$915e9e7bd4f0f96d = ({ stack: stack = false, extras: extras = false, error: error, titleVariant: titleVariant = 'h6', customTitle: customTitle = ()=>null, extrasTitleSuffix: extrasTitleSuffix = null, sx: sx, className: className, ...other })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "error-message",
        ...other,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($deeee9bf4fa3e86f$exports)))(className, (0, $ab72aeb277ab974e$export$a100fd7a4d4ccbc7).root),
        sx: {
            color: 'error.main',
            ...sx
        },
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b39283bccca0350b$var$ErrorHeader, {
                customTitle: customTitle,
                titleVariant: titleVariant,
                error: error,
                extras: extras
            }),
            (0, $c3e1b746ad236797$export$8d524fb6540252df).isOfTypes(error, (0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_TIMEOUT) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b39283bccca0350b$var$ErrorTimeoutHeader, {}),
            stack && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $cb46b6caf4d08903$export$d540ba6c994dd81c), {
                error: error
            }),
            $b39283bccca0350b$var$hasExtras(extras, 'section', error) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $cb46b6caf4d08903$export$5b50ef99c28ea41f), {
                variant: "body2",
                error: error,
                extrasTitleSuffix: extrasTitleSuffix
            })
        ]
    });



parcelRequire("h4Bez");
var $1d0ec4abd3dfbac2$exports = {};

(function(global, factory) {
    factory($1d0ec4abd3dfbac2$exports, (parcelRequire("h4Bez")));
})($1d0ec4abd3dfbac2$exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});





const $863ca392f900a852$var$wrapperStyle = {
    p: 2
};
/** Caught react Errors need to be converted to the ConnectwareError to be displayed */ const $863ca392f900a852$var$mapReactError = (error)=>{
    if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(error)) return error;
    const newError = new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, error.message);
    newError.stack = error.stack;
    return newError;
};
const $863ca392f900a852$export$96827c5c36a77a5a = ({ children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1d0ec4abd3dfbac2$exports.ErrorBoundary), {
        FallbackComponent: ({ error: error })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $863ca392f900a852$var$wrapperStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
                    "data-testid": "boundary-error",
                    error: $863ca392f900a852$var$mapReactError(error),
                    stack: true,
                    extras: "section"
                })
            }),
        children: children
    });



parcelRequire("h4Bez");


var $h4Bez = parcelRequire("h4Bez");






const $93c004e5d2e4907b$var$styled = (0, $323d09b5b142c3c9$export$2e2bcd8739ae039)();
var $93c004e5d2e4907b$export$2e2bcd8739ae039 = $93c004e5d2e4907b$var$styled;



function $ada2059bb7e8f74d$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $8a4b1f01109d1a9b$export$2e2bcd8739ae039)(theme.components[name].defaultProps, props);
}



'use client';
function $613bf551b55aae32$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $f8416c9663895cb7$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $ada2059bb7e8f74d$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
}







'use client';
const $6daf38b4485404fd$var$defaultTheme = (0, $32d258d0759a439a$export$2e2bcd8739ae039)();
// widening Theme to any so that the consumer can own the theme structure.
const $6daf38b4485404fd$var$defaultCreateStyledComponent = (0, $93c004e5d2e4907b$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root'
});
function $6daf38b4485404fd$var$useThemePropsDefault(props) {
    return (0, $613bf551b55aae32$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $6daf38b4485404fd$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $6daf38b4485404fd$var$joinChildren(children, separator) {
    const childrenArray = $h4Bez.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $h4Bez.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $6daf38b4485404fd$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $6daf38b4485404fd$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        display: 'flex',
        flexDirection: 'column',
        ...(0, $9d0348a6a7057277$export$88347efdb2e19abd)({
            theme: theme
        }, (0, $9d0348a6a7057277$export$980e6a259d807490)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, $2cbe39ac70acf613$export$1def6f833384e3d1)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $9d0348a6a7057277$export$980e6a259d807490)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $9d0348a6a7057277$export$980e6a259d807490)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $2cbe39ac70acf613$export$bf7199a9ebcb84a9)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$6daf38b4485404fd$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $2cbe39ac70acf613$export$bf7199a9ebcb84a9)(transformer, propValue)
                }
            };
        };
        styles = (0, $a539fc8639d0a7b4$export$2e2bcd8739ae039)(styles, (0, $9d0348a6a7057277$export$88347efdb2e19abd)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $9d0348a6a7057277$export$b89a003a1e05c0ee)(theme.breakpoints, styles);
    return styles;
};
function $6daf38b4485404fd$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $6daf38b4485404fd$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $6daf38b4485404fd$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (slot)=>(0, $6b55eb7835363b92$export$2e2bcd8739ae039)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($6daf38b4485404fd$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $h4Bez.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $348688587c50d45e$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false, ...other } = props;
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $b4ceee382bf9d5af$export$2e2bcd8739ae039)(classes.root, className),
            ...other,
            children: divider ? $6daf38b4485404fd$var$joinChildren(children, divider) : children
        });
    });
    return Stack;
}




'use client';
const $d06d05d70ecd5bc3$var$Stack = (0, $6daf38b4485404fd$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
        name: 'MuiStack',
        slot: 'Root'
    }),
    useThemeProps: (inProps)=>(0, $16527687018ae2c4$export$2440da353cedad43)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $d06d05d70ecd5bc3$export$2e2bcd8739ae039 = $d06d05d70ecd5bc3$var$Stack;






var $h4Bez = parcelRequire("h4Bez");





'use client';
var $05678a2096742019$export$2e2bcd8739ae039 = (0, $8bcd24cec5c7b3d6$export$2e2bcd8739ae039);







var $h4Bez = parcelRequire("h4Bez");










'use client';
var $ea79b826054a58a6$export$2e2bcd8739ae039 = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039);



var $h4Bez = parcelRequire("h4Bez");

'use client';
class $81e54fced535a489$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $81e54fced535a489$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $ebcd91de7f6a0c24$export$2e2bcd8739ae039)($81e54fced535a489$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $h4Bez.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $h4Bez.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $81e54fced535a489$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $81e54fced535a489$export$2e2bcd8739ae039() {
    return $81e54fced535a489$export$f5de0641c7db4154.use();
}
function $81e54fced535a489$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}



var $h4Bez = parcelRequire("h4Bez");



function $c7cc4ca38fb6ee8a$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}





var $h4Bez = parcelRequire("h4Bez");


var $h4Bez = parcelRequire("h4Bez");
function $88d2f6fddcbb6d0f$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $h4Bez.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $h4Bez.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $88d2f6fddcbb6d0f$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $88d2f6fddcbb6d0f$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $88d2f6fddcbb6d0f$export$fa71e2345c31d7a2(props, onExited) {
    return $88d2f6fddcbb6d0f$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $h4Bez.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $88d2f6fddcbb6d0f$var$getProp(child, 'appear', props),
            enter: $88d2f6fddcbb6d0f$var$getProp(child, 'enter', props),
            exit: $88d2f6fddcbb6d0f$var$getProp(child, 'exit', props)
        });
    });
}
function $88d2f6fddcbb6d0f$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $88d2f6fddcbb6d0f$export$bbc8a025727ea824(nextProps.children);
    var children = $88d2f6fddcbb6d0f$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $h4Bez.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $h4Bez.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $h4Bez.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $88d2f6fddcbb6d0f$var$getProp(child, 'exit', nextProps),
            enter: $88d2f6fddcbb6d0f$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $h4Bez.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $h4Bez.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $h4Bez.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $88d2f6fddcbb6d0f$var$getProp(child, 'exit', nextProps),
            enter: $88d2f6fddcbb6d0f$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $64e39e5df7aa78f9$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $64e39e5df7aa78f9$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $64e39e5df7aa78f9$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $d6dc968cc2ff4ccc$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $c7cc4ca38fb6ee8a$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $88d2f6fddcbb6d0f$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $88d2f6fddcbb6d0f$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $88d2f6fddcbb6d0f$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $4b23e67a53a2b954$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $64e39e5df7aa78f9$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement((0, $e017bc0646804e2f$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement((0, $e017bc0646804e2f$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Component);
$64e39e5df7aa78f9$var$TransitionGroup.propTypes = {};
$64e39e5df7aa78f9$var$TransitionGroup.defaultProps = $64e39e5df7aa78f9$var$defaultProps;
var $64e39e5df7aa78f9$export$2e2bcd8739ae039 = $64e39e5df7aa78f9$var$TransitionGroup;







var $h4Bez = parcelRequire("h4Bez");



'use client';
function $87e2f64c31e2fd3f$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $h4Bez.useState(false);
    const rippleClassName = (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $h4Bez.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
            className: childClassName
        })
    });
}
var $87e2f64c31e2fd3f$export$2e2bcd8739ae039 = $87e2f64c31e2fd3f$var$Ripple;




function $4318ef1c35fdac72$export$b464606f735ab902(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiTouchRipple', slot);
}
const $4318ef1c35fdac72$var$touchRippleClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $4318ef1c35fdac72$export$2e2bcd8739ae039 = $4318ef1c35fdac72$var$touchRippleClasses;



'use client';
const $a0f815a95cd0b6ad$var$DURATION = 550;
const $a0f815a95cd0b6ad$export$95d0c9356b2231a3 = 80;
const $a0f815a95cd0b6ad$var$enterKeyframe = (0, $2260c64920c0bb2a$export$d25ddfdf17c3ad3e)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $a0f815a95cd0b6ad$var$exitKeyframe = (0, $2260c64920c0bb2a$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $a0f815a95cd0b6ad$var$pulsateKeyframe = (0, $2260c64920c0bb2a$export$d25ddfdf17c3ad3e)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $a0f815a95cd0b6ad$export$f6b7418508c72c25 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $a0f815a95cd0b6ad$export$676cfe7b12693c4b = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $87e2f64c31e2fd3f$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $4318ef1c35fdac72$export$2e2bcd8739ae039).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$a0f815a95cd0b6ad$var$enterKeyframe};
    animation-duration: ${$a0f815a95cd0b6ad$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $4318ef1c35fdac72$export$2e2bcd8739ae039).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $4318ef1c35fdac72$export$2e2bcd8739ae039).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $4318ef1c35fdac72$export$2e2bcd8739ae039).childLeaving} {
    opacity: 0;
    animation-name: ${$a0f815a95cd0b6ad$var$exitKeyframe};
    animation-duration: ${$a0f815a95cd0b6ad$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $4318ef1c35fdac72$export$2e2bcd8739ae039).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$a0f815a95cd0b6ad$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $a0f815a95cd0b6ad$var$TouchRipple = /*#__PURE__*/ $h4Bez.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $h4Bez.useState([]);
    const nextKey = $h4Bez.useRef(0);
    const rippleCallback = $h4Bez.useRef(null);
    $h4Bez.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $h4Bez.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $4497065fec36f675$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $h4Bez.useRef(null);
    const container = $h4Bez.useRef(null);
    const startCommit = $h4Bez.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($a0f815a95cd0b6ad$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.ripple, (0, $4318ef1c35fdac72$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.rippleVisible, (0, $4318ef1c35fdac72$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.ripplePulsate, (0, $4318ef1c35fdac72$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.child, (0, $4318ef1c35fdac72$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.childLeaving, (0, $4318ef1c35fdac72$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.childPulsate, (0, $4318ef1c35fdac72$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $a0f815a95cd0b6ad$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $h4Bez.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touch devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($a0f815a95cd0b6ad$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $h4Bez.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $h4Bez.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $h4Bez.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($a0f815a95cd0b6ad$export$f6b7418508c72c25, {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)((0, $4318ef1c35fdac72$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $64e39e5df7aa78f9$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $a0f815a95cd0b6ad$export$2e2bcd8739ae039 = $a0f815a95cd0b6ad$var$TouchRipple;




function $cbad1124ad327257$export$fccb0498dcd99783(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiButtonBase', slot);
}
const $cbad1124ad327257$var$buttonBaseClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $cbad1124ad327257$export$2e2bcd8739ae039 = $cbad1124ad327257$var$buttonBaseClasses;



'use client';
const $d02728b6fe958b24$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $cbad1124ad327257$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $d02728b6fe958b24$export$7ec0dcc5e3cdcd36 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('button', {
    name: 'MuiButtonBase',
    slot: 'Root'
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $cbad1124ad327257$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $d02728b6fe958b24$var$ButtonBase = /*#__PURE__*/ $h4Bez.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $h4Bez.useRef(null);
    const ripple = (0, $81e54fced535a489$export$2e2bcd8739ae039)();
    const handleRippleRef = (0, $6fa00ac7fde563d8$export$2e2bcd8739ae039)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $h4Bez.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $h4Bez.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $h4Bez.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $d02728b6fe958b24$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $d02728b6fe958b24$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $d02728b6fe958b24$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $d02728b6fe958b24$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $d02728b6fe958b24$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $d02728b6fe958b24$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $d02728b6fe958b24$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $d02728b6fe958b24$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $d02728b6fe958b24$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $90a9a7d90476ac81$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $ea79b826054a58a6$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $90a9a7d90476ac81$export$2e2bcd8739ae039)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $ea79b826054a58a6$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $ea79b826054a58a6$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        const hasFormAttributes = !!other.formAction;
        // ButtonBase was defaulting to type="button" when no type prop was provided, which prevented form submission and broke formAction functionality.
        // The fix checks for form-related attributes and skips the default type to allow the browser's natural submit behavior (type="submit").
        buttonProps.type = type === undefined && !hasFormAttributes ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $6fa00ac7fde563d8$export$2e2bcd8739ae039)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $d02728b6fe958b24$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($d02728b6fe958b24$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a0f815a95cd0b6ad$export$2e2bcd8739ae039), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $d02728b6fe958b24$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $ea79b826054a58a6$export$2e2bcd8739ae039)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $d02728b6fe958b24$export$2e2bcd8739ae039 = $d02728b6fe958b24$var$ButtonBase;







function $ef73307de6008871$export$5a6f9035944c8119(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiButton', slot);
}
const $ef73307de6008871$var$buttonClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $ef73307de6008871$export$2e2bcd8739ae039 = $ef73307de6008871$var$buttonClasses;



var $h4Bez = parcelRequire("h4Bez");
'use client';
/**
 * @ignore - internal component.
 */ const $656d3071cfbb944f$var$ButtonGroupContext = /*#__PURE__*/ $h4Bez.createContext({});
var $656d3071cfbb944f$export$2e2bcd8739ae039 = $656d3071cfbb944f$var$ButtonGroupContext;



var $h4Bez = parcelRequire("h4Bez");
'use client';
/**
 * @ignore - internal component.
 */ const $441e40d1ba2980c5$var$ButtonGroupButtonContext = /*#__PURE__*/ $h4Bez.createContext(undefined);
var $441e40d1ba2980c5$export$2e2bcd8739ae039 = $441e40d1ba2980c5$var$ButtonGroupButtonContext;



'use client';
const $1e2141c588472150$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`,
            `${variant}Size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $ef73307de6008871$export$5a6f9035944c8119), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $1e2141c588472150$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $1e2141c588472150$var$ButtonRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d02728b6fe958b24$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $19087586f17e5d57$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $ef73307de6008871$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $ef73307de6008871$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $ef73307de6008871$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $ef73307de6008871$export$2e2bcd8739ae039).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.alpha((theme.vars || theme).palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $ef73307de6008871$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $ef73307de6008871$export$2e2bcd8739ae039).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${(0, $ef73307de6008871$export$2e2bcd8739ae039).loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $1e2141c588472150$var$ButtonStartIcon = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$1e2141c588472150$var$commonIconStyles
        ]
    }));
const $1e2141c588472150$var$ButtonEndIcon = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$1e2141c588472150$var$commonIconStyles
        ]
    }));
const $1e2141c588472150$var$ButtonLoadingIndicator = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $1e2141c588472150$var$ButtonLoadingIconPlaceholder = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder'
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $1e2141c588472150$var$Button = /*#__PURE__*/ $h4Bez.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $h4Bez.useContext((0, $656d3071cfbb944f$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $h4Bez.useContext((0, $441e40d1ba2980c5$export$2e2bcd8739ae039));
    const resolvedProps = (0, $8a4b1f01109d1a9b$export$2e2bcd8739ae039)(contextProps, inProps);
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $05678a2096742019$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $95388f9578043f1e$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $1e2141c588472150$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1e2141c588472150$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1e2141c588472150$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1e2141c588472150$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1e2141c588472150$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $2e41620b030ed79e$exports.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1e2141c588472150$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($1e2141c588472150$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var $1e2141c588472150$export$2e2bcd8739ae039 = $1e2141c588472150$var$Button;


const $ca1ea2b88c04430e$export$353f5b6fc5456de1 = (0, $1e2141c588472150$export$2e2bcd8739ae039);



var $h4Bez = parcelRequire("h4Bez");














function $d11898bbe79f09e3$export$5e8702d71474f093(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiIconButton', slot);
}
const $d11898bbe79f09e3$var$iconButtonClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $d11898bbe79f09e3$export$2e2bcd8739ae039 = $d11898bbe79f09e3$var$iconButtonClasses;



'use client';
const $8ccbf49a69947e95$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            edge && `edge${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $d11898bbe79f09e3$export$5e8702d71474f093), classes);
};
const $8ccbf49a69947e95$var$IconButtonRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d02728b6fe958b24$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $d11898bbe79f09e3$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${(0, $d11898bbe79f09e3$export$2e2bcd8739ae039).loading}`]: {
            color: 'transparent'
        }
    })));
const $8ccbf49a69947e95$var$IconButtonLoadingIndicator = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $8ccbf49a69947e95$var$IconButton = /*#__PURE__*/ $h4Bez.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $05678a2096742019$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $95388f9578043f1e$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $8ccbf49a69947e95$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($8ccbf49a69947e95$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $2e41620b030ed79e$exports.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($8ccbf49a69947e95$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var $8ccbf49a69947e95$export$2e2bcd8739ae039 = $8ccbf49a69947e95$var$IconButton;


const $0128221b0851485d$export$c25acd513dcc8062 = (0, $8ccbf49a69947e95$export$2e2bcd8739ae039);







const $6354af2b130548c7$var$contentStyle = {
    p: 2,
    gap: 1,
    maxWidth: 640
};
const $6354af2b130548c7$export$d053ec805ce391aa = ({ error: error })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f32134562d667542$export$adce78b89d4ae3cc), {
        className: (0, $ab72aeb277ab974e$export$a100fd7a4d4ccbc7)['details-content'],
        trigger: ({ open: open, onClick: onClick })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                "data-testid": "error-details-button",
                className: (0, $ab72aeb277ab974e$export$a100fd7a4d4ccbc7)['details-button'],
                variant: "ghost",
                size: "medium",
                "aria-expanded": open,
                onClick: onClick,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ERROR_DETAILS
                })
            }),
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
            sx: $6354af2b130548c7$var$contentStyle,
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    className: (0, $ab72aeb277ab974e$export$a100fd7a4d4ccbc7)['details-type'],
                    variant: "body2",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ERROR_DETAILS_TYPE,
                        values: {
                            type: error.type
                        }
                    })
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $cb46b6caf4d08903$export$d540ba6c994dd81c), {
                    error: error
                }),
                !(0, $2ae70427bab197d4$export$dd1bc94b04021eeb)(error.extras) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $cb46b6caf4d08903$export$5b50ef99c28ea41f), {
                    variant: "body2",
                    error: error
                })
            ]
        })
    });







var $h4Bez = parcelRequire("h4Bez");






var $h4Bez = parcelRequire("h4Bez");












function $7e4341771c0d156d$export$69aecd24bc2cf7e3(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiAlert', slot);
}
const $7e4341771c0d156d$var$alertClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $7e4341771c0d156d$export$2e2bcd8739ae039 = $7e4341771c0d156d$var$alertClasses;





'use client';
var $03f88ec0325d4b09$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');




'use client';
var $4ba77e8d0bf21b5a$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');




'use client';
var $7de640f98e06a986$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');




'use client';
var $5f05791f56f87ce0$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');




'use client';
var $7fb90e10244d933a$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



'use client';
const $bb140bd70ba0d464$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color || severity)}`,
            `${variant}${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $7e4341771c0d156d$export$69aecd24bc2cf7e3), classes);
};
const $bb140bd70ba0d464$var$AlertRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color || ownerState.severity)}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? theme.darken : theme.lighten;
    const getBackgroundColor = theme.palette.mode === 'light' ? theme.lighten : theme.darken;
    return {
        ...theme.typography.body2,
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $7e4341771c0d156d$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $7e4341771c0d156d$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: {
                        fontWeight: theme.typography.fontWeightMedium,
                        ...theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}FilledColor`],
                            backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                        } : {
                            backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                            color: theme.palette.getContrastText(theme.palette[color].main)
                        }
                    }
                }))
        ]
    };
}));
const $bb140bd70ba0d464$var$AlertIcon = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Icon'
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $bb140bd70ba0d464$var$AlertMessage = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Message'
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $bb140bd70ba0d464$var$AlertAction = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Action'
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $bb140bd70ba0d464$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $03f88ec0325d4b09$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4ba77e8d0bf21b5a$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7de640f98e06a986$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5f05791f56f87ce0$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $bb140bd70ba0d464$var$Alert = /*#__PURE__*/ $h4Bez.forwardRef(function Alert(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $bb140bd70ba0d464$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    };
    const classes = $bb140bd70ba0d464$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $bb140bd70ba0d464$var$AlertRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            role: role,
            elevation: 0
        }
    });
    const [IconSlot, iconSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('icon', {
        className: classes.icon,
        elementType: $bb140bd70ba0d464$var$AlertIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MessageSlot, messageSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('message', {
        className: classes.message,
        elementType: $bb140bd70ba0d464$var$AlertMessage,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('action', {
        className: classes.action,
        elementType: $bb140bd70ba0d464$var$AlertAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseButtonSlot, closeButtonProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('closeButton', {
        elementType: (0, $8ccbf49a69947e95$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('closeIcon', {
        elementType: (0, $7fb90e10244d933a$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            icon !== false ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(IconSlot, {
                ...iconSlotProps,
                children: icon || iconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(MessageSlot, {
                ...messageSlotProps,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(CloseButtonSlot, {
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose,
                    ...closeButtonProps,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(CloseIconSlot, {
                        fontSize: "small",
                        ...closeIconProps
                    })
                })
            }) : null
        ]
    });
});
var $bb140bd70ba0d464$export$2e2bcd8739ae039 = $bb140bd70ba0d464$var$Alert;


var $h4Bez = parcelRequire("h4Bez");









function $119222338d2d45d2$export$5269a5bce2c2f987(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiAlertTitle', slot);
}
const $119222338d2d45d2$var$alertTitleClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiAlertTitle', [
    'root'
]);
var $119222338d2d45d2$export$2e2bcd8739ae039 = $119222338d2d45d2$var$alertTitleClasses;



'use client';
const $9f0ab7fd79b13f26$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $119222338d2d45d2$export$5269a5bce2c2f987), classes);
};
const $9f0ab7fd79b13f26$var$AlertTitleRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
    name: 'MuiAlertTitle',
    slot: 'Root'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
}));
const $9f0ab7fd79b13f26$var$AlertTitle = /*#__PURE__*/ $h4Bez.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAlertTitle'
    });
    const { className: className, ...other } = props;
    const ownerState = props;
    const classes = $9f0ab7fd79b13f26$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($9f0ab7fd79b13f26$var$AlertTitleRoot, {
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ...other
    });
});
var $9f0ab7fd79b13f26$export$2e2bcd8739ae039 = $9f0ab7fd79b13f26$var$AlertTitle;



var $h4Bez = parcelRequire("h4Bez");





const $0456fe2a0c5df307$var$RAMPS = [
    'error',
    'warning',
    'success',
    'info'
];
/** Each severity's styling is defined independently rather than derived from one shared formula. */ const $0456fe2a0c5df307$var$notificationSeverityStyle = {
    info: (theme)=>({
            backgroundColor: theme.palette.info[25],
            color: theme.palette.info[600],
            border: `1px solid ${theme.palette.info[200]}`,
            [`& .${(0, $7e4341771c0d156d$export$2e2bcd8739ae039).icon}`]: {
                color: theme.palette.info[700]
            },
            [`& .${(0, $119222338d2d45d2$export$2e2bcd8739ae039).root}`]: {
                color: theme.palette.info[800]
            }
        }),
    error: (theme)=>({
            backgroundColor: theme.palette.error[25],
            color: theme.palette.error[600],
            border: `1px solid ${theme.palette.error[200]}`,
            [`& .${(0, $7e4341771c0d156d$export$2e2bcd8739ae039).icon}`]: {
                color: theme.palette.error[600]
            },
            [`& .${(0, $119222338d2d45d2$export$2e2bcd8739ae039).root}`]: {
                color: theme.palette.error[800]
            }
        }),
    warning: (theme)=>({
            backgroundColor: theme.palette.warning[25],
            color: theme.palette.warning[600],
            border: `1px solid ${theme.palette.warning[200]}`,
            [`& .${(0, $7e4341771c0d156d$export$2e2bcd8739ae039).icon}`]: {
                color: theme.palette.warning[600]
            },
            [`& .${(0, $119222338d2d45d2$export$2e2bcd8739ae039).root}`]: {
                color: theme.palette.warning[800]
            }
        }),
    success: (theme)=>({
            backgroundColor: theme.palette.success[25],
            color: theme.palette.success[600],
            border: `1px solid ${theme.palette.success[200]}`,
            [`& .${(0, $7e4341771c0d156d$export$2e2bcd8739ae039).icon}`]: {
                color: theme.palette.success[600]
            },
            [`& .${(0, $119222338d2d45d2$export$2e2bcd8739ae039).root}`]: {
                color: theme.palette.success[800]
            }
        })
};
const $0456fe2a0c5df307$export$c22ec15e3373c8f5 = {
    info: (theme)=>theme.palette.info[200],
    error: (theme)=>theme.palette.error[200],
    warning: (theme)=>theme.palette.warning[200],
    success: (theme)=>theme.palette.success[200]
};
const $0456fe2a0c5df307$export$137de82bdbba50d6 = {
    info: (theme)=>theme.palette.info[400],
    error: (theme)=>theme.palette.error[400],
    warning: (theme)=>theme.palette.warning[400],
    success: (theme)=>theme.palette.success[400]
};
const $0456fe2a0c5df307$var$variants = $0456fe2a0c5df307$var$RAMPS.map((severity)=>({
        props: {
            variant: 'notification',
            severity: severity
        },
        style: ({ theme: theme })=>$0456fe2a0c5df307$var$notificationSeverityStyle[severity](theme)
    }));
const $0456fe2a0c5df307$export$752ab86848a89b46 = {
    variants: $0456fe2a0c5df307$var$variants
};


/**
 * Icons for theme overrides live here, not `common/Branding` — some `Branding` icons
 * import `cybusTheme`, so using that barrel here would create a circular import.
 */ 
parcelRequire("h4Bez");

const $b9a3c6876c67d06c$export$cae179f078f4b4a4 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "CloseIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/close",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                d: "M18 6L6 18M6 6L18 18",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $024b35d06a10e12d$export$4857d3f3f5f8319b = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "ChevronDownIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/chevron/down",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                d: "M6 9L12 15L18 9",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });







"use client";
var $ce81745a3cd16b5f$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'ErrorOutline');


parcelRequire("h4Bez");


parcelRequire("h4Bez");

const $ec5894a60f9e2c5f$export$a6b7c34d56975de0 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "AddIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/add",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                id: "Vector",
                d: "M5 12H19M12 5V19",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $b535488bb7f5202c$export$25c6e96bbb971c7c = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "AlertTriangleFilledIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/alert/triangle/filled",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                id: "Vector",
                d: "M13.2281 3.95915C13.1044 3.74364 12.926 3.56459 12.7109 3.44008C12.4959 3.31557 12.2518 3.25 12.0033 3.25C11.7548 3.25 11.5107 3.31557 11.2957 3.44008C11.0806 3.56459 10.9022 3.74364 10.7785 3.95915L2.20877 18.5403C1.63762 19.5126 2.3225 20.7487 3.43355 20.7487H20.5718C21.6828 20.7487 22.369 19.5114 21.7966 18.5403L13.2281 3.95915ZM12.0008 8.25089C12.6694 8.25089 13.1931 8.82828 13.1256 9.49442L12.6882 13.8774C12.6735 14.0496 12.5947 14.21 12.4674 14.3269C12.3401 14.4437 12.1736 14.5086 12.0008 14.5086C11.828 14.5086 11.6615 14.4437 11.5342 14.3269C11.4069 14.21 11.3281 14.0496 11.3134 13.8774L10.876 9.49442C10.8603 9.33724 10.8777 9.17851 10.927 9.02846C10.9764 8.87841 11.0567 8.74036 11.1626 8.62321C11.2686 8.50606 11.3979 8.41241 11.5423 8.34828C11.6866 8.28415 11.8428 8.25098 12.0008 8.25089ZM12.0033 15.7496C12.3348 15.7496 12.6526 15.8812 12.887 16.1156C13.1214 16.35 13.2531 16.6679 13.2531 16.9993C13.2531 17.3308 13.1214 17.6487 12.887 17.8831C12.6526 18.1174 12.3348 18.2491 12.0033 18.2491C11.6718 18.2491 11.3539 18.1174 11.1196 17.8831C10.8852 17.6487 10.7535 17.3308 10.7535 16.9993C10.7535 16.6679 10.8852 16.35 11.1196 16.1156C11.3539 15.8812 11.6718 15.7496 12.0033 15.7496Z",
                fill: "currentColor"
            })
        })
    });



parcelRequire("h4Bez");

const $ed6f3d571c93aafd$export$b7910236d21ed8ef = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "AlertTriangleLineIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/alert-triangle/line",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                d: "M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $4d0c3371e4bf5696$export$794f4e1bebe11db5 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "AlertTriangleOutlineIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/alert/triangle/outline",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("g", {
                id: "Vector",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M12.0022 15.7495C12.1664 15.7495 12.329 15.7819 12.4807 15.8447C12.6322 15.9075 12.7699 15.9997 12.8859 16.1157C13.0019 16.2316 13.094 16.3693 13.1568 16.5209C13.2196 16.6725 13.252 16.8352 13.252 16.9993C13.252 17.3307 13.1202 17.6486 12.8859 17.8829C12.6515 18.1173 12.3337 18.2491 12.0022 18.2491C11.6708 18.2491 11.353 18.1173 11.1186 17.8829C10.8843 17.6486 10.7525 17.3307 10.7525 16.9993C10.7525 16.8352 10.7849 16.6725 10.8477 16.5209C10.9105 16.3694 11.0026 16.2316 11.1186 16.1157C11.2346 15.9997 11.3723 15.9075 11.5238 15.8447C11.6754 15.7819 11.8381 15.7495 12.0022 15.7495Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M11.9998 8.24519C12.1582 8.2452 12.3148 8.2784 12.4595 8.34283C12.6043 8.40733 12.7342 8.50162 12.8403 8.61947C12.9462 8.7372 13.0265 8.87567 13.0755 9.0263C13.1244 9.1771 13.1409 9.33729 13.1243 9.49496L12.6873 13.8773C12.6726 14.0495 12.5933 14.2104 12.466 14.3273C12.3388 14.4439 12.1724 14.5087 11.9998 14.5087C11.827 14.5087 11.66 14.4441 11.5328 14.3273C11.4055 14.2104 11.327 14.0495 11.3123 13.8773L10.8753 9.49496C10.8587 9.33729 10.8752 9.1771 10.9242 9.0263C10.9731 8.87566 11.0533 8.7372 11.1593 8.61947C11.2653 8.50171 11.3946 8.40732 11.5393 8.34283C11.6841 8.27832 11.8413 8.24519 11.9998 8.24519Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12.0006 3.25098C12.249 3.25103 12.4927 3.31693 12.7077 3.44137C12.9227 3.56588 13.1015 3.74498 13.2252 3.96048L21.7938 18.5412C22.3661 19.5122 21.6794 20.7494 20.5684 20.7494H3.43039C2.31946 20.7493 1.63473 19.5134 2.20584 18.5412L10.7753 3.96048C10.899 3.745 11.0777 3.56588 11.2927 3.44137C11.5078 3.31686 11.7521 3.25098 12.0006 3.25098ZM12.0006 4.50238C11.9727 4.50205 11.9446 4.50929 11.9201 4.52272C11.8916 4.53983 11.8681 4.56417 11.8525 4.59351L3.28312 19.175C3.26182 19.2092 3.2502 19.2486 3.24976 19.2889C3.24933 19.3292 3.2601 19.369 3.28068 19.4036C3.30067 19.4411 3.32698 19.466 3.34821 19.4785C3.36692 19.491 3.39056 19.4996 3.43039 19.4997H20.5684C20.5974 19.5007 20.6265 19.4934 20.6514 19.4785C20.6802 19.4598 20.7036 19.4339 20.7197 19.4036C20.7401 19.3689 20.7505 19.3292 20.7498 19.2889C20.7492 19.2487 20.7379 19.2091 20.7165 19.175L12.1479 4.59351C12.1323 4.56416 12.1088 4.53982 12.0804 4.52272C12.056 4.50934 12.0284 4.50211 12.0006 4.50238Z",
                        fill: "currentColor"
                    })
                ]
            })
        })
    });



parcelRequire("h4Bez");

const $8918db21d3652fbb$export$1c939d3c9b6931b = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "ArrowDownIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/arrow/down",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                id: "Vector",
                d: "M12 5V19M12 19L19 12M12 19L5 12",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $1adece5071bb7b44$export$f1a507b991affc46 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "ArrowUpIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/arrow/up",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                id: "Icon",
                d: "M12 19V5M12 5L5 12M12 5L19 12",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

var $df8d60fd247376eb$exports = {};
$df8d60fd247376eb$exports = $parcel$resolve("gVijF");


const $9c5c25b8e801801f$var$style = {
    height: '100%',
    width: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($df8d60fd247376eb$exports)))})`
};
const $9c5c25b8e801801f$export$668799e4797757a8 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "working-background",
        sx: $9c5c25b8e801801f$var$style
    });



parcelRequire("h4Bez");

const $7be2eff253c48d8a$export$69ed718e88f9cee1 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "CertificateOutlineIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/certificate/outline",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                id: "Vector",
                d: "M9 12L11 14L15 9.99996M20 13C20 18 16.5 20.5 12.34 21.95C12.1222 22.0238 11.8855 22.0202 11.67 21.94C7.5 20.5 4 18 4 13V5.99996C4 5.73474 4.10536 5.48039 4.29289 5.29285C4.48043 5.10532 4.73478 4.99996 5 4.99996C7 4.99996 9.5 3.79996 11.24 2.27996C11.4519 2.09896 11.7214 1.99951 12 1.99951C12.2786 1.99951 12.5481 2.09896 12.76 2.27996C14.51 3.80996 17 4.99996 19 4.99996C19.2652 4.99996 19.5196 5.10532 19.7071 5.29285C19.8946 5.48039 20 5.73474 20 5.99996V13Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $5200a8ede5ccc875$export$7f01a6cbee61a0f2 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "ChevronUpIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/chevron/up",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                d: "M18 15L12 9L6 15",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $7611395e1ba5aa98$export$7dd004358974b05d = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "CheckIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/check",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                id: "Vector",
                fill: "none",
                d: "M20 6L9 17L4 12",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $3f17bc125b2f71c3$export$481a7013a5a1a9ef = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "ClientIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/client",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                id: "Vector",
                d: "M11 17L13 19C13.197 19.197 13.4308 19.3533 13.6882 19.4599C13.9456 19.5665 14.2214 19.6213 14.5 19.6213C14.7786 19.6213 15.0544 19.5665 15.3118 19.4599C15.5692 19.3533 15.803 19.197 16 19C16.197 18.803 16.3532 18.5692 16.4598 18.3118C16.5665 18.0544 16.6213 17.7786 16.6213 17.5C16.6213 17.2214 16.5665 16.9456 16.4598 16.6882C16.3532 16.4309 16.197 16.197 16 16M14 14L16.5 16.5C16.8978 16.8978 17.4374 17.1213 18 17.1213C18.5626 17.1213 19.1022 16.8978 19.5 16.5C19.8978 16.1022 20.1213 15.5626 20.1213 15C20.1213 14.4374 19.8978 13.8978 19.5 13.5L15.62 9.62002C15.0575 9.05821 14.295 8.74265 13.5 8.74265C12.705 8.74265 11.9425 9.05821 11.38 9.62002L10.5 10.5C10.1022 10.8978 9.56261 11.1213 9 11.1213C8.43739 11.1213 7.89782 10.8978 7.5 10.5C7.10218 10.1022 6.87868 9.56262 6.87868 9.00002C6.87868 8.43741 7.10218 7.89784 7.5 7.50002L10.31 4.69002C11.2222 3.78016 12.4119 3.20057 13.6906 3.04299C14.9694 2.88541 16.2642 3.15885 17.37 3.82002L17.84 4.10002C18.2658 4.357 18.772 4.44613 19.26 4.35002L21 4.00002M21 3.00002L22 14H20M3 3.00002L2 14L8.5 20.5C8.89782 20.8978 9.43739 21.1213 10 21.1213C10.5626 21.1213 11.1022 20.8978 11.5 20.5C11.8978 20.1022 12.1213 19.5626 12.1213 19C12.1213 18.4374 11.8978 17.8978 11.5 17.5M3 4.00002H11",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $ce5ed6e542502f21$export$8099ab97743c966c = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "ClockIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/clock",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                id: "Vector",
                d: "M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $f64707633c45c401$export$1aa86ab72c4a7023 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "ConfigureOutlineIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
            d: "M7.5752 14.502C7.85123 14.502 8.07508 14.7259 8.0752 15.002V19.002C8.0752 19.2781 7.8513 19.5019 7.5752 19.502H3.5752C3.29905 19.502 3.0752 19.2781 3.0752 19.002V15.002C3.07531 14.7259 3.29913 14.502 3.5752 14.502H7.5752ZM16.4268 17.9951C16.7028 17.9952 16.9268 18.2191 16.9268 18.4951C16.9268 18.7712 16.7028 18.995 16.4268 18.9951H12.4268C12.1506 18.9951 11.9268 18.7713 11.9268 18.4951C11.9268 18.219 12.1506 17.9951 12.4268 17.9951H16.4268ZM4.0752 18.502H7.0752V15.502H4.0752V18.502ZM20.4209 14.9951C20.697 14.9951 20.9208 15.219 20.9209 15.4951C20.9209 15.7713 20.697 15.9951 20.4209 15.9951H12.4209C12.1449 15.995 11.9209 15.7712 11.9209 15.4951C11.921 15.2191 12.1449 14.9953 12.4209 14.9951H20.4209ZM7.5752 4.49805C7.85131 4.49805 8.07514 4.72195 8.0752 4.99805V8.99805C8.0752 9.27419 7.85134 9.49805 7.5752 9.49805H3.5752C3.29924 9.49783 3.0752 9.27405 3.0752 8.99805V4.99805C3.07525 4.72208 3.29927 4.49827 3.5752 4.49805H7.5752ZM16.4258 7.99121C16.7017 7.99142 16.9257 8.21524 16.9258 8.49121C16.9258 8.76722 16.7017 8.991 16.4258 8.99121H12.4258C12.1496 8.99121 11.9258 8.76735 11.9258 8.49121C11.9258 8.21511 12.1497 7.99121 12.4258 7.99121H16.4258ZM4.0752 8.49805H7.0752V5.49805H4.0752V8.49805ZM20.4248 4.98828C20.7008 4.98828 20.9246 5.21231 20.9248 5.48828C20.9248 5.76442 20.7009 5.98828 20.4248 5.98828H12.4248C12.1488 5.98812 11.9248 5.76432 11.9248 5.48828C11.925 5.21241 12.1489 4.98844 12.4248 4.98828H20.4248Z",
            fill: "currentColor"
        })
    });



parcelRequire("h4Bez");

const $c239af17472eae06$export$9fb3c4dc634c9b1 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "ConnectIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/connect",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.4999 5.56637C4.63248 5.56639 4.75967 5.6191 4.85342 5.71285L10.3534 11.2129C10.5485 11.4081 10.5486 11.7247 10.3534 11.9199L8.85342 13.4199C8.39511 13.8781 7.41885 14.4212 6.29385 14.5918C5.2658 14.7475 4.07324 14.5947 3.02041 13.7519L0.853417 15.9199C0.658186 16.115 0.341617 16.115 0.146386 15.9199C-0.0488359 15.7247 -0.0487545 15.4081 0.146386 15.2129L2.31338 13.0449C1.47121 11.9923 1.31884 10.8002 1.47451 9.77242C1.64505 8.6474 2.18816 7.67118 2.64639 7.21285L4.14639 5.71285L4.22256 5.65035C4.30408 5.59602 4.40049 5.56637 4.4999 5.56637ZM3.35342 7.91988C3.06171 8.2117 2.60478 8.98573 2.46279 9.92281C2.3249 10.8337 2.4899 11.8493 3.35342 12.7129C4.21698 13.5763 5.23257 13.7414 6.14346 13.6035C7.08055 13.4615 7.8546 13.0046 8.14639 12.7129L9.29287 11.5664L4.4999 6.7734L3.35342 7.91988ZM15.3075 0.146447C15.5028 -0.0488155 15.8193 -0.0488155 16.0145 0.146447C16.2098 0.341709 16.2098 0.658216 16.0145 0.853478L13.8466 3.02047C14.6894 4.07334 14.8422 5.26582 14.6864 6.29391C14.5159 7.41901 13.9728 8.39521 13.5145 8.85348L12.0145 10.3535C11.8193 10.5487 11.5028 10.5487 11.3075 10.3535L5.80752 4.85348C5.71376 4.75972 5.66105 4.63255 5.66103 4.49996C5.66103 4.36737 5.71377 4.24021 5.80752 4.14645L7.30752 2.64645C7.76579 2.18816 8.74195 1.64512 9.86709 1.47457C10.8948 1.31885 12.0869 1.4713 13.1395 2.31344L15.3075 0.146447ZM12.8075 3.35348C11.9439 2.48988 10.9284 2.32491 10.0175 2.46285C9.08025 2.60486 8.30624 3.06177 8.01455 3.35348L6.86807 4.49996L11.661 9.29293L12.8075 8.14645C13.0992 7.85472 13.5561 7.08073 13.6981 6.14352C13.8361 5.23258 13.6711 4.21708 12.8075 3.35348Z",
                fill: "currentColor"
            })
        })
    });



parcelRequire("h4Bez");

const $00ca338ba2f14773$export$51b6cd98f8778f0d = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "CopyIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/copy",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                id: "Vector",
                d: "M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4M10 8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V10C8 8.89543 8.89543 8 10 8Z",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $4a83180cadddc43e$export$7c291b8c282f660d = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "CurlyBracketsIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/curly-brackets",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                id: "Vector",
                d: "M8 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V10C5 10.5304 4.78929 11.0391 4.41421 11.4142C4.03914 11.7893 3.53043 12 3 12C3.53043 12 4.03914 12.2107 4.41421 12.5858C4.78929 12.9609 5 13.4696 5 14V19C5 20.1 5.9 21 7 21H8M16 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V14C19 12.9 19.9 12 21 12C20.4696 12 19.9609 11.7893 19.5858 11.4142C19.2107 11.0391 19 10.5304 19 10V5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3H16",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");



function $bef56d69afec4a03$export$6c57c6e16b4063b(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiCheckbox', slot);
}
const $bef56d69afec4a03$var$checkboxClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $bef56d69afec4a03$export$2e2bcd8739ae039 = $bef56d69afec4a03$var$checkboxClasses;



function $4e58bfa35037c63d$export$31444911e4ee6fdd(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiChip', slot);
}
const $4e58bfa35037c63d$var$chipClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorDefault',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $4e58bfa35037c63d$export$2e2bcd8739ae039 = $4e58bfa35037c63d$var$chipClasses;



function $679b3da5719098bd$export$e4ce0a775adf2f74(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiPaginationItem', slot);
}
const $679b3da5719098bd$var$paginationItemClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiPaginationItem', [
    'root',
    'page',
    'sizeSmall',
    'sizeLarge',
    'text',
    'textPrimary',
    'textSecondary',
    'outlined',
    'outlinedPrimary',
    'outlinedSecondary',
    'rounded',
    'ellipsis',
    'firstLast',
    'previousNext',
    'focusVisible',
    'disabled',
    'selected',
    'icon',
    'colorPrimary',
    'colorSecondary'
]);
var $679b3da5719098bd$export$2e2bcd8739ae039 = $679b3da5719098bd$var$paginationItemClasses;



function $823e90498c56952a$export$33a0f07a16a10b1b(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiTableCell', slot);
}
const $823e90498c56952a$var$tableCellClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $823e90498c56952a$export$2e2bcd8739ae039 = $823e90498c56952a$var$tableCellClasses;



function $2fb9c2cc5ba0457d$export$ba0a6d6c28940107(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiTableRow', slot);
}
const $2fb9c2cc5ba0457d$var$tableRowClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $2fb9c2cc5ba0457d$export$2e2bcd8739ae039 = $2fb9c2cc5ba0457d$var$tableRowClasses;



function $375bbd4a107cd711$export$645d356c89a51794(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiTableSortLabel', slot);
}
const $375bbd4a107cd711$var$tableSortLabelClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiTableSortLabel', [
    'root',
    'active',
    'icon',
    'iconDirectionDesc',
    'iconDirectionAsc',
    'directionDesc',
    'directionAsc'
]);
var $375bbd4a107cd711$export$2e2bcd8739ae039 = $375bbd4a107cd711$var$tableSortLabelClasses;





const $5f78a8132f139ecb$export$e12884ceee1ae29c = 0.4;
const $5f78a8132f139ecb$export$642d8a5846df7ebb = 28;
const $5f78a8132f139ecb$var$FOCUS_RING_WIDTH = 2;
const $5f78a8132f139ecb$var$FOCUS_RING_GAP = 2;
const $5f78a8132f139ecb$var$ICON_BUTTON_FOCUS_RING_OFFSET = 1;
const $5f78a8132f139ecb$export$5fabbec8f6ea1c3f = (theme)=>({
        outline: `${$5f78a8132f139ecb$var$FOCUS_RING_WIDTH}px solid ${theme.palette.primary[500]}`,
        outlineOffset: $5f78a8132f139ecb$var$ICON_BUTTON_FOCUS_RING_OFFSET
    });
const $5f78a8132f139ecb$var$FOCUS_OUTLINE_WIDTH = 2;
const $5f78a8132f139ecb$export$a86f5934025b6e94 = (theme)=>({
        outline: `${$5f78a8132f139ecb$var$FOCUS_OUTLINE_WIDTH}px solid ${theme.palette.primary[700]}`,
        outlineOffset: -$5f78a8132f139ecb$var$FOCUS_OUTLINE_WIDTH
    });
const $5f78a8132f139ecb$export$246d341c4b0b3057 = (theme)=>({
        color: theme.palette.grey[700],
        backgroundColor: theme.palette.common.white,
        borderColor: theme.palette.grey[300],
        '&:hover': {
            backgroundColor: theme.palette.grey[50]
        },
        '&:active': {
            backgroundColor: theme.palette.grey[100],
            borderColor: theme.palette.grey[400]
        },
        '&:disabled': {
            color: theme.palette.grey[700]
        }
    });
const $5f78a8132f139ecb$var$variantStyles = [
    {
        props: {
            variant: 'primary'
        },
        style: ({ theme: theme })=>({
                color: theme.palette.common.white,
                backgroundColor: theme.palette.primary[700],
                '&:hover': {
                    backgroundColor: theme.palette.primary[800]
                },
                '&:active': {
                    backgroundColor: theme.palette.primary[900]
                },
                '&:disabled': {
                    color: theme.palette.common.white,
                    backgroundColor: theme.palette.primary[700]
                }
            })
    },
    {
        props: {
            variant: 'secondary'
        },
        style: ({ theme: theme })=>$5f78a8132f139ecb$export$246d341c4b0b3057(theme)
    },
    {
        props: {
            variant: 'primaryOutline'
        },
        style: ({ theme: theme })=>({
                color: theme.palette.primary[700],
                backgroundColor: theme.palette.common.white,
                borderColor: theme.palette.primary[300],
                '&:hover': {
                    backgroundColor: theme.palette.primary[100]
                },
                '&:active': {
                    color: theme.palette.primary[800],
                    backgroundColor: theme.palette.primary[200],
                    borderColor: theme.palette.primary[400]
                },
                '&:disabled': {
                    color: theme.palette.primary[700]
                }
            })
    },
    {
        props: {
            variant: 'primaryGhost'
        },
        style: ({ theme: theme })=>({
                color: theme.palette.primary[700],
                '&:hover': {
                    backgroundColor: theme.palette.grey[50]
                },
                '&:active': {
                    backgroundColor: theme.palette.grey[100]
                },
                '&:disabled': {
                    color: theme.palette.primary[500]
                }
            })
    },
    {
        props: {
            variant: 'ghost'
        },
        style: ({ theme: theme })=>({
                color: theme.palette.grey[600],
                '&:hover': {
                    color: theme.palette.grey[700],
                    backgroundColor: theme.palette.grey[100]
                },
                '&:active': {
                    color: theme.palette.grey[800],
                    backgroundColor: theme.palette.grey[200]
                },
                '&:disabled': {
                    color: theme.palette.grey[600]
                }
            })
    },
    {
        props: {
            variant: 'danger'
        },
        style: ({ theme: theme })=>({
                color: theme.palette.common.white,
                backgroundColor: theme.palette.error[600],
                '&:hover': {
                    backgroundColor: theme.palette.error[700]
                },
                '&:active': {
                    backgroundColor: theme.palette.error[800]
                },
                '&:disabled': {
                    color: theme.palette.common.white,
                    backgroundColor: theme.palette.error[600]
                }
            })
    },
    {
        props: {
            variant: 'dangerOutline'
        },
        style: ({ theme: theme })=>({
                color: theme.palette.error[700],
                backgroundColor: theme.palette.common.white,
                borderColor: theme.palette.error[300],
                '&:hover': {
                    backgroundColor: theme.palette.error[50],
                    borderColor: theme.palette.error[400]
                },
                '&:active': {
                    color: theme.palette.error[800],
                    backgroundColor: theme.palette.error[100],
                    borderColor: theme.palette.error[500]
                },
                '&:disabled': {
                    color: theme.palette.error[700]
                }
            })
    },
    {
        props: {
            variant: 'dangerGhost'
        },
        style: ({ theme: theme })=>({
                color: theme.palette.error[600],
                '&:hover': {
                    color: theme.palette.error[700],
                    backgroundColor: theme.palette.error[50]
                },
                '&:active': {
                    color: theme.palette.error[800],
                    backgroundColor: theme.palette.error[100]
                },
                '&:disabled': {
                    color: theme.palette.error[600]
                }
            })
    },
    /**
     * TODO: delete legacyAmber variant
     * @see https://cybusio.atlassian.net/browse/CC-4243
     */ {
        props: {
            variant: 'legacyAmber'
        },
        style: ({ theme: theme })=>({
                color: theme.palette.common.white,
                backgroundColor: theme.palette.secondary.main,
                '&:hover': {
                    backgroundColor: (0, $3289d56f59a873c2$export$4b073707ff63303)(theme.palette.secondary.main, 0.1)
                },
                '&:active': {
                    backgroundColor: (0, $3289d56f59a873c2$export$4b073707ff63303)(theme.palette.secondary.main, 0.2)
                },
                '&:disabled': {
                    color: theme.palette.common.white,
                    backgroundColor: theme.palette.secondary.main
                }
            })
    }
];
const $5f78a8132f139ecb$var$ARIA_DISABLED = '&[aria-disabled="true"]';
/** An `aria-disabled` icon button keeps its focus and its tooltip; it looks disabled, keeping its rest colours on hover and press */ const $5f78a8132f139ecb$var$withAriaDisabledRest = ({ props: props, style: style })=>({
        props: props,
        style: (args)=>{
            const base = style(args);
            return {
                ...base,
                [`${$5f78a8132f139ecb$var$ARIA_DISABLED}:hover, ${$5f78a8132f139ecb$var$ARIA_DISABLED}:active`]: {
                    color: base.color,
                    backgroundColor: base.backgroundColor ?? 'transparent',
                    borderColor: base.borderColor ?? 'transparent'
                }
            };
        }
    });
const $5f78a8132f139ecb$var$variants = (styles)=>styles;
const $5f78a8132f139ecb$export$6dfab79633b2e017 = {
    defaultProps: {
        // disables ripple effect for all buttons
        disableRipple: true
    }
};
const $5f78a8132f139ecb$export$89fc15b83affe05f = {
    styleOverrides: {
        root: ({ theme: theme })=>({
                ...theme.typography.caption,
                letterSpacing: 0,
                fontWeight: 400,
                textTransform: 'none',
                minWidth: 'unset',
                border: '1px solid transparent',
                '&:disabled': {
                    opacity: $5f78a8132f139ecb$export$e12884ceee1ae29c
                },
                /** A gap in the page's background color, then the ring, so the ring never merges with the button's own border */ [`&.${(0, $cbad1124ad327257$export$2e2bcd8739ae039).focusVisible}`]: {
                    boxShadow: `0 0 0 ${$5f78a8132f139ecb$var$FOCUS_RING_GAP}px ${theme.palette.background.default}, 0 0 0 ${$5f78a8132f139ecb$var$FOCUS_RING_GAP + $5f78a8132f139ecb$var$FOCUS_RING_WIDTH}px ${theme.palette.primary[500]}`
                }
            }),
        sizeSmall: ({ theme: theme })=>({
                minHeight: 24,
                padding: theme.spacing(0, 2),
                [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
                    height: 12,
                    width: 12
                }
            }),
        sizeMedium: ({ theme: theme })=>({
                minHeight: 28,
                padding: theme.spacing(0, 3),
                [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
                    height: 16,
                    width: 16
                }
            }),
        sizeLarge: ({ theme: theme })=>({
                minHeight: 32,
                padding: theme.spacing(0, 4),
                [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
                    height: 16,
                    width: 16
                }
            })
    },
    variants: $5f78a8132f139ecb$var$variants($5f78a8132f139ecb$var$variantStyles)
};
const $5f78a8132f139ecb$export$5702f43d08d0fe41 = {
    styleOverrides: {
        root: ({ theme: theme })=>({
                border: '1px solid transparent',
                borderRadius: 4,
                padding: 0,
                [`&:disabled, ${$5f78a8132f139ecb$var$ARIA_DISABLED}`]: {
                    opacity: $5f78a8132f139ecb$export$e12884ceee1ae29c
                },
                [$5f78a8132f139ecb$var$ARIA_DISABLED]: {
                    cursor: 'default'
                },
                [`&.${(0, $cbad1124ad327257$export$2e2bcd8739ae039).focusVisible}`]: $5f78a8132f139ecb$export$5fabbec8f6ea1c3f(theme)
            }),
        sizeSmall: {
            height: 24,
            width: 24,
            [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
                height: 12,
                width: 12
            }
        },
        sizeMedium: {
            height: $5f78a8132f139ecb$export$642d8a5846df7ebb,
            width: $5f78a8132f139ecb$export$642d8a5846df7ebb,
            [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
                height: 16,
                width: 16
            }
        },
        sizeLarge: {
            height: 32,
            width: 32,
            [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
                height: 16,
                width: 16
            }
        }
    },
    variants: $5f78a8132f139ecb$var$variants($5f78a8132f139ecb$var$variantStyles.map($5f78a8132f139ecb$var$withAriaDisabledRest))
};



const $a1537862b7417309$export$befff265f4340460 = 36;
const $a1537862b7417309$export$db3bf26306c7aefe = 1;
const $a1537862b7417309$export$6d71d73a386a4ab5 = 40;
const $a1537862b7417309$var$SELECTED_ROW_BAR_WIDTH = 2;
/** In spacing steps: (24px medium chip - 20px text line) / 2 */ const $a1537862b7417309$var$CHIP_LINE_OVERHANG = 0.5;
const $a1537862b7417309$var$ERROR_ICON_SIZE = 16;
const $a1537862b7417309$var$SORT_ICON_SIZE = 12;
const $a1537862b7417309$var$SORT_ICON_HOVER_OPACITY = 0.45;
const $a1537862b7417309$export$7f13d34a1f1ef207 = 600;
const $a1537862b7417309$var$PAGE_ITEM_SIZE = 32;
const $a1537862b7417309$var$PAGE_PREVIOUS_NEXT_SIZE = 28;
const $a1537862b7417309$var$PAGE_ITEM_GAP = 3.5;
const $a1537862b7417309$var$PAGE_ICON_SIZE = 16;
const $a1537862b7417309$export$cd28f66d0221a810 = {
    styleOverrides: {
        root: ({ theme: theme })=>({
                border: `${$a1537862b7417309$export$db3bf26306c7aefe}px solid ${theme.palette.grey[200]}`,
                borderRadius: 8,
                backgroundColor: theme.palette.background.default
            })
    }
};
const $a1537862b7417309$export$8fcf03edac3f9b8 = {
    styleOverrides: {
        root: ({ theme: theme })=>({
                [`&:last-child > .${(0, $823e90498c56952a$export$2e2bcd8739ae039).body}`]: {
                    borderBottom: 'none'
                },
                [`&.${(0, $2fb9c2cc5ba0457d$export$2e2bcd8739ae039).hover}:hover`]: {
                    backgroundColor: theme.palette.grey[50]
                },
                [`&.${(0, $2fb9c2cc5ba0457d$export$2e2bcd8739ae039).selected}, &.${(0, $2fb9c2cc5ba0457d$export$2e2bcd8739ae039).selected}:hover`]: {
                    backgroundColor: theme.palette.primary[50]
                },
                /** Drawn on the first cell, since browsers don't reliably paint a box-shadow on a table row */ [`&.${(0, $2fb9c2cc5ba0457d$export$2e2bcd8739ae039).selected} > .${(0, $823e90498c56952a$export$2e2bcd8739ae039).root}:first-of-type`]: {
                    boxShadow: `inset ${$a1537862b7417309$var$SELECTED_ROW_BAR_WIDTH}px 0 0 0 ${theme.palette.primary[700]}`
                },
                '&:focus-visible': (0, $5f78a8132f139ecb$export$a86f5934025b6e94)(theme)
            }),
        head: {
            height: $a1537862b7417309$export$befff265f4340460
        }
    }
};
const $a1537862b7417309$export$dc287f7e97e5fcab = {
    styleOverrides: {
        root: ({ theme: theme })=>({
                ...theme.typography.body2,
                color: theme.palette.grey[900],
                /**
             * 6px + a 20px line + 5px + the 1px divider keeps a single-line row at 32px, while taller rows grow and stay top-aligned.
             * The last row's line is the container's own border instead.
             */ padding: theme.spacing(1.5, 3, 1.25),
                verticalAlign: 'top',
                borderBottom: `1px solid ${theme.palette.grey[200]}`,
                /**
             * A 24px chip (e.g. `Status`) in the cell's 20px text line: top-aligned and pulled 2px into the cell padding above and below,
             * so it centres on the line without making the row taller
             */ [`& > .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).root}.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).sizeMedium}`]: {
                    verticalAlign: 'top',
                    marginTop: theme.spacing(-$a1537862b7417309$var$CHIP_LINE_OVERHANG),
                    marginBottom: theme.spacing(-$a1537862b7417309$var$CHIP_LINE_OVERHANG)
                },
                /** An error message is page-sized by default; in a cell it takes the cell's text size, so an error row stays as tall as the others */ [`& .${(0, $ab72aeb277ab974e$export$a100fd7a4d4ccbc7).root}`]: {
                    [`& .${(0, $f9ef756b8f6a1b37$export$2e2bcd8739ae039).root}`]: theme.typography.body2,
                    [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
                        fontSize: $a1537862b7417309$var$ERROR_ICON_SIZE
                    }
                }
            }),
        head: ({ theme: theme })=>({
                ...theme.typography.caption,
                fontWeight: theme.typography.fontWeightMedium,
                color: theme.palette.grey[600],
                backgroundColor: theme.palette.background.default,
                padding: theme.spacing(0, 3),
                verticalAlign: 'middle',
                whiteSpace: 'nowrap',
                borderBottomColor: theme.palette.grey[300],
                /** The sort label fills a sortable header cell, so the whole cell is its hover and click target */ [`&:has(> .${(0, $375bbd4a107cd711$export$2e2bcd8739ae039).root})`]: {
                    padding: 0
                }
            }),
        paddingCheckbox: ({ theme: theme })=>({
                boxSizing: 'border-box',
                width: $a1537862b7417309$export$6d71d73a386a4ab5,
                /** 8px down, the 16px checkbox centers on the other cells' first 20px text line */ padding: theme.spacing(2, 3, 0),
                /** Block-level, so it sits on the padding edge instead of being aligned to a text baseline */ [`& > .${(0, $bef56d69afec4a03$export$2e2bcd8739ae039).root}`]: {
                    display: 'flex'
                },
                [`&.${(0, $823e90498c56952a$export$2e2bcd8739ae039).head}`]: {
                    paddingTop: 0
                }
            })
    }
};
const $a1537862b7417309$export$59b8153d30e2f0c3 = {
    defaultProps: {
        IconComponent: (0, $024b35d06a10e12d$export$4857d3f3f5f8319b)
    },
    styleOverrides: {
        root: ({ theme: theme })=>({
                width: '100%',
                height: $a1537862b7417309$export$befff265f4340460,
                padding: theme.spacing(0, 3),
                color: 'inherit',
                [`&:hover, &:focus, &.${(0, $375bbd4a107cd711$export$2e2bcd8739ae039).active}`]: {
                    color: 'inherit'
                },
                '&:hover': {
                    backgroundColor: theme.palette.grey[100],
                    color: theme.palette.grey[700],
                    fontWeight: $a1537862b7417309$export$7f13d34a1f1ef207,
                    [`& .${(0, $375bbd4a107cd711$export$2e2bcd8739ae039).icon}`]: {
                        opacity: $a1537862b7417309$var$SORT_ICON_HOVER_OPACITY
                    }
                },
                [`&.${(0, $375bbd4a107cd711$export$2e2bcd8739ae039).active} .${(0, $375bbd4a107cd711$export$2e2bcd8739ae039).icon}`]: {
                    opacity: 1,
                    color: 'inherit'
                },
                /** An idle sortable column gets `direction="asc"`, but its hover hint should point down, unrotated */ [`&:not(.${(0, $375bbd4a107cd711$export$2e2bcd8739ae039).active}) .${(0, $375bbd4a107cd711$export$2e2bcd8739ae039).icon}`]: {
                    transform: 'none'
                },
                [`&.${(0, $cbad1124ad327257$export$2e2bcd8739ae039).focusVisible}`]: (0, $5f78a8132f139ecb$export$a86f5934025b6e94)(theme)
            }),
        icon: ({ theme: theme })=>({
                fontSize: $a1537862b7417309$var$SORT_ICON_SIZE,
                margin: theme.spacing(0, 0, 0, 1),
                /** A right-aligned cell reverses the label, putting the icon before the text, so the gap moves to the icon's other side */ [`.${(0, $823e90498c56952a$export$2e2bcd8739ae039).alignRight} &`]: {
                    margin: theme.spacing(0, 1, 0, 0)
                }
            })
    }
};
const $a1537862b7417309$export$7d9d7373f56f7427 = {
    styleOverrides: {
        ul: ({ theme: theme })=>({
                gap: theme.spacing($a1537862b7417309$var$PAGE_ITEM_GAP)
            })
    }
};
const $a1537862b7417309$export$f0644cd8080fd229 = {
    styleOverrides: {
        root: ({ theme: theme })=>({
                ...theme.typography.caption,
                fontVariantNumeric: 'tabular-nums',
                color: theme.palette.grey[900],
                minWidth: $a1537862b7417309$var$PAGE_ITEM_SIZE,
                height: $a1537862b7417309$var$PAGE_ITEM_SIZE,
                margin: 0,
                padding: 0,
                borderRadius: 0
            }),
        page: ({ theme: theme })=>({
                /** Transparent at rest, so marking the current page never changes the item's height */ borderBottom: '1px solid transparent',
                '&:hover': {
                    backgroundColor: 'transparent',
                    color: theme.palette.primary[700]
                },
                [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).selected}, &.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).selected}:hover`]: {
                    backgroundColor: 'transparent',
                    color: theme.palette.primary[700],
                    borderBottomColor: theme.palette.primary[700]
                },
                [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).focusVisible}, &.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).selected}.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: 'transparent',
                    ...(0, $5f78a8132f139ecb$export$a86f5934025b6e94)(theme),
                    borderRadius: 4
                }
            }),
        ellipsis: {
            height: 'auto'
        },
        icon: {
            fontSize: $a1537862b7417309$var$PAGE_ICON_SIZE,
            margin: 0
        },
        previousNext: ({ theme: theme })=>({
                ...(0, $5f78a8132f139ecb$export$246d341c4b0b3057)(theme),
                minWidth: $a1537862b7417309$var$PAGE_PREVIOUS_NEXT_SIZE,
                width: $a1537862b7417309$var$PAGE_PREVIOUS_NEXT_SIZE,
                height: $a1537862b7417309$var$PAGE_PREVIOUS_NEXT_SIZE,
                borderWidth: 1,
                borderStyle: 'solid',
                borderRadius: 4,
                [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).focusVisible}`]: (0, $5f78a8132f139ecb$export$5fabbec8f6ea1c3f)(theme),
                /** Undoes MUI's focus-visible background at rest only, so a focused button still shows its hover and active backgrounds */ [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).focusVisible}:not(:hover):not(:active)`]: {
                    backgroundColor: theme.palette.common.white
                },
                [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).disabled}`]: {
                    opacity: (0, $5f78a8132f139ecb$export$e12884ceee1ae29c)
                }
            })
    }
};


/**
 * The line thickness for each icon size, in the units of a 24-unit drawing. Shown at its size, each paints 0.9px, 1.075px,
 * 1.25px and 1.4px: a small icon gets a slightly heavier line, so every size looks equally bold.
 */ const $833922d52afcf466$var$LINE_WIDTH_BY_SIZE = {
    12: 1.8,
    16: 1.6125,
    20: 1.5,
    24: 1.4
};
const $833922d52afcf466$export$d81cc31fdf858305 = (size)=>({
        width: size,
        height: size,
        '& [stroke]': {
            strokeWidth: $833922d52afcf466$var$LINE_WIDTH_BY_SIZE[size]
        }
    });
const $833922d52afcf466$export$e34d2553ba553d7c = 20;
const $833922d52afcf466$var$SIDE_BAR_DRAWING_SCALE = 0.9;
/** Paints 0.83px once the drawing is scaled to 90% of its 20px frame */ const $833922d52afcf466$var$SIDE_BAR_LINE_WIDTH = 1.11;
const $833922d52afcf466$export$5f737a2a865aaa0c = ()=>({
        width: $833922d52afcf466$export$e34d2553ba553d7c,
        height: $833922d52afcf466$export$e34d2553ba553d7c,
        transform: `scale(${$833922d52afcf466$var$SIDE_BAR_DRAWING_SCALE})`,
        '& [stroke]': {
            strokeWidth: $833922d52afcf466$var$SIDE_BAR_LINE_WIDTH
        }
    });



const $190611ecca6afed0$var$shadowsMap = {
    XS: '0 1px 2px 0 rgba(10, 13, 18, 0.05)',
    SM: '0 1px 3px 0 rgba(10, 13, 18, 0.10), 0 1px 2px 0 rgba(10, 13, 18, 0.06)',
    MD: '0 4px 8px -2px rgba(10, 13, 18, 0.10), 0 2px 4px -2px rgba(10, 13, 18, 0.06)',
    LG: '0 12px 16px -4px rgba(10, 13, 18, 0.08), 0 4px 6px -2px rgba(10, 13, 18, 0.03)',
    XL: '0 20px 24px -4px rgba(10, 13, 18, 0.08), 0 8px 8px -4px rgba(10, 13, 18, 0.03)',
    '2XL': '0 24px 48px -12px rgba(10, 13, 18, 0.18)',
    '3XL': '0 32px 64px -12px rgba(10, 13, 18, 0.14)'
};
const $190611ecca6afed0$export$5db70ad5f005c786 = '-1px 0 1px 0 rgba(10, 13, 18, 0.03), -3px 0 3px 0 rgba(10, 13, 18, 0.03), -6px 0 3px 0 rgba(10, 13, 18, 0.02)';
const $190611ecca6afed0$export$3eb26d38a832ce9a = [
    'none',
    $190611ecca6afed0$var$shadowsMap.XS,
    $190611ecca6afed0$var$shadowsMap.SM,
    $190611ecca6afed0$var$shadowsMap.MD,
    $190611ecca6afed0$var$shadowsMap.LG,
    $190611ecca6afed0$var$shadowsMap.XL,
    $190611ecca6afed0$var$shadowsMap['2XL'],
    $190611ecca6afed0$var$shadowsMap['3XL'],
    /**
     * MUI requires exactly 25 elevations when defining shadows.
     * Our design system has 7 only, so any elevation above 7 is the same as 3XL.
     */ ...Array(17).fill($190611ecca6afed0$var$shadowsMap['3XL'])
];





parcelRequire("h4Bez");


function $dbbe785332a10def$export$8ee01529667e66d9(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiAutocomplete', slot);
}
const $dbbe785332a10def$var$autocompleteClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $dbbe785332a10def$export$2e2bcd8739ae039 = $dbbe785332a10def$var$autocompleteClasses;





function $0886a41ab9c710ef$export$ef57d5c8ca2278f6(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiInputBase', slot);
}
const $0886a41ab9c710ef$var$inputBaseClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $0886a41ab9c710ef$export$2e2bcd8739ae039 = $0886a41ab9c710ef$var$inputBaseClasses;


function $8f2ed57594b78c76$export$89922944c7227687(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiOutlinedInput', slot);
}
const $8f2ed57594b78c76$var$outlinedInputClasses = {
    ...(0, $0886a41ab9c710ef$export$2e2bcd8739ae039),
    ...(0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var $8f2ed57594b78c76$export$2e2bcd8739ae039 = $8f2ed57594b78c76$var$outlinedInputClasses;



const $41a26c36a83d7551$var$AUTOCOMPLETE_TAG_HEIGHT = 20 // px, matches MuiChip's own `size="small"` height (see theme/chip.tsx)
;
const $41a26c36a83d7551$export$e59fbfa5ffe25cdd = {
    defaultProps: {
        clearIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b9a3c6876c67d06c$export$cae179f078f4b4a4), {}),
        popupIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $024b35d06a10e12d$export$4857d3f3f5f8319b), {})
    },
    styleOverrides: {
        root: ({ theme: theme, ownerState: ownerState })=>({
                /**
             * Autocomplete hardcodes its own OutlinedInput padding at the same specificity as ours;
             * `&&` repeats the generated class to outrank it. Padding (not minHeight) is what drives
             * the row's height here, so it has to vary by size itself, matching `theme/inputs.tsx`'s
             * own small/medium heights (28/32px) via the same padding-to-line-height math.
             */ [`&& .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).root}`]: {
                    padding: theme.spacing(ownerState.size === 'small' ? 1 : 1.5, 2)
                },
                /**
             * Only relevant once there's at least one tag (the `.MuiAutocomplete-tag` sibling requirement) -
             * a single-select/freeSolo field with no tags has nothing else to display its value, so its
             * input must stay full width and visible even while unfocused. With tags present, the input is
             * just a secondary "type to search" box that should get out of the tags' way (its own `flexGrow: 1`
             * would otherwise keep claiming layout room) once it's not actually being typed into.
             */ [`&& .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).root}:not(.${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).focused}) .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).tag} ~ .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).input}`]: {
                    flexGrow: 0,
                    width: 0,
                    minWidth: 0,
                    padding: 0
                },
                [`&& .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).root} .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).input}`]: {
                    padding: theme.spacing(0, 1),
                    height: $41a26c36a83d7551$var$AUTOCOMPLETE_TAG_HEIGHT
                },
                /**
             * Selected-value tags render as MuiChip's own `primary` variant (see `renderMultipleValue` in
             * `common/Input/Autocomplete.tsx` and `theme/chip.tsx`) - this only tightens the line-height
             * Chip otherwise sets for its larger default use, so the label doesn't overflow this fixed tag height.
             * `pointerEvents: 'none'` makes the tag itself inert to hover (it's a value display, not an
             * affordance), while re-enabling it on the delete icon so that stays hoverable/clickable.
             */ [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).tag}.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).root}`]: {
                    lineHeight: 1,
                    pointerEvents: 'none',
                    [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).deleteIcon}`]: {
                        pointerEvents: 'auto'
                    }
                },
                /**
             * All tags, including "+N more" text
             */ [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).tag}`]: {
                    margin: 0
                },
                /**
             * "+N more" text only (not actual chips)
             */ [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).tag}:not(.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).root})`]: {
                    ...theme.typography.body2,
                    color: theme.palette.grey[500]
                },
                /**
             * "close" and "chevron" icons
             */ [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).clearIndicator}:hover, & .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).popupIndicator}:hover`]: {
                    backgroundColor: 'transparent'
                }
            }),
        // matches theme/dropdown.ts's MuiMenu.styleOverrides.paper values
        paper: ({ theme: theme })=>({
                borderRadius: 8,
                border: `1px solid ${theme.palette.grey[300]}`,
                backgroundColor: theme.palette.common.white,
                boxShadow: theme.shadows[4]
            }),
        listbox: ({ theme: theme })=>({
                padding: theme.spacing(1, 0)
            }),
        /**
         * `!important` because MUI's own `AutocompleteListbox` hardcodes a same-specificity
         * `[aria-disabled="true"]` rule (opacity ~0.38) that otherwise wins on injection order.
         */ option: {
            '&[aria-disabled="true"]': {
                opacity: '0.5 !important'
            }
        }
    }
};




parcelRequire("h4Bez");

const $1e8a842489f032c5$var$CheckboxIndeterminateIcon = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "CheckboxIndeterminateIcon",
        viewBox: "0 0 16 16",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("rect", {
                width: "16",
                height: "16",
                rx: "2",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                d: "M5 8H11",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            })
        ]
    });
const $1e8a842489f032c5$var$CheckboxUncheckedIcon = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "CheckboxUncheckedIcon",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "15",
                height: "15",
                rx: "1.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("rect", {
                fill: "none",
                x: "0.5",
                y: "0.5",
                width: "15",
                height: "15",
                rx: "1.5",
                stroke: "currentColor",
                strokeWidth: "1"
            })
        ]
    });
const $1e8a842489f032c5$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "CheckboxCheckedIcon",
        viewBox: "0 0 16 16",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("rect", {
                width: "16",
                height: "16",
                rx: "2",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                d: "M12 5L6.5 10.5L4 8",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const $1e8a842489f032c5$export$aaa6d800b3b5976a = {
    defaultProps: {
        disableRipple: true,
        icon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1e8a842489f032c5$var$CheckboxUncheckedIcon, {}),
        checkedIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1e8a842489f032c5$var$CheckboxCheckedIcon, {}),
        indeterminateIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1e8a842489f032c5$var$CheckboxIndeterminateIcon, {})
    },
    styleOverrides: {
        root: ({ theme: theme })=>({
                color: theme.palette.grey[300],
                '&:hover': {
                    backgroundColor: 'unset'
                },
                [`&.${(0, $bef56d69afec4a03$export$2e2bcd8739ae039).checked}, &.${(0, $bef56d69afec4a03$export$2e2bcd8739ae039).indeterminate}`]: {
                    color: theme.palette.primary[700]
                },
                // Focus
                '&.Mui-focusVisible': {
                    [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
                        outline: `2px solid ${theme.palette.primary[700]}`,
                        outlineOffset: 1,
                        borderRadius: 1
                    }
                },
                // Disabled
                [`&.${(0, $bef56d69afec4a03$export$2e2bcd8739ae039).disabled}`]: {
                    color: theme.palette.grey[200]
                }
            }),
        sizeSmall: {
            [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
                fontSize: 16
            }
        },
        sizeMedium: {
            [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
                fontSize: 20
            }
        }
    }
};



parcelRequire("h4Bez");


const $310787696616542c$var$CHIP_HEIGHTS = {
    small: 20,
    medium: 24
};
const $310787696616542c$var$chipColorVariantStyle = (ramp, borderShade, hoverBorderShade)=>({ theme: theme })=>({
            color: theme.palette[ramp][700],
            backgroundColor: theme.palette[ramp][100],
            border: `1px solid ${theme.palette[ramp][borderShade]}`,
            /** Only chips that do something react to hover; a plain chip (e.g. a status) stays still */ [`&.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).clickable}:hover:not(.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).disabled}), &.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).deletable}:hover:not(.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).disabled})`]: {
                borderColor: theme.palette[ramp][hoverBorderShade],
                backgroundColor: theme.palette[ramp][200]
            },
            [`&.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).focusVisible}`]: {
                borderColor: theme.palette.primary[700],
                backgroundColor: theme.palette[ramp][100],
                boxShadow: `0 0 0 2px ${theme.palette.primary[200]}`
            },
            [`&.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).disabled}`]: {
                borderColor: theme.palette[ramp][200],
                backgroundColor: theme.palette[ramp][100],
                opacity: 0.5
            }
        });
/** Status chips are non-interactive, so unlike `chipColorVariantStyle` they define no hover, focus or disabled states */ const $310787696616542c$var$chipSoftVariantStyle = (ramp)=>({ theme: theme })=>({
            color: theme.palette[ramp][ramp === 'grey' ? 700 : 800],
            backgroundColor: theme.palette[ramp][100],
            border: '1px solid transparent',
            padding: theme.spacing(0, 2),
            lineHeight: theme.typography.caption.lineHeight,
            [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).icon}`]: {
                color: theme.palette[ramp][500]
            }
        });
const $310787696616542c$var$variants = [
    {
        props: {
            variant: 'neutral'
        },
        style: $310787696616542c$var$chipColorVariantStyle('grey', 300, 300)
    },
    {
        props: {
            variant: 'primary'
        },
        style: $310787696616542c$var$chipColorVariantStyle('primary', 200, 700)
    },
    {
        props: {
            variant: 'success'
        },
        style: $310787696616542c$var$chipSoftVariantStyle('success')
    },
    {
        props: {
            variant: 'warning'
        },
        style: $310787696616542c$var$chipSoftVariantStyle('warning')
    },
    {
        props: {
            variant: 'danger'
        },
        style: $310787696616542c$var$chipSoftVariantStyle('error')
    },
    {
        props: {
            variant: 'grey'
        },
        style: $310787696616542c$var$chipSoftVariantStyle('grey')
    },
    {
        props: {
            size: 'small'
        },
        style: {
            height: $310787696616542c$var$CHIP_HEIGHTS.small
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            height: $310787696616542c$var$CHIP_HEIGHTS.medium
        }
    }
];
const $310787696616542c$export$dc8bf454cdb2df34 = {
    defaultProps: {
        variant: 'neutral',
        deleteIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b9a3c6876c67d06c$export$cae179f078f4b4a4), {})
    },
    styleOverrides: {
        root: ({ theme: theme })=>({
                ...theme.typography.caption,
                lineHeight: 2,
                boxSizing: 'border-box',
                borderRadius: 4,
                gap: theme.spacing(1),
                padding: theme.spacing(1, 2),
                [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).icon}, & .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).deleteIcon}`]: {
                    color: 'inherit',
                    fontSize: '1em',
                    margin: 0
                },
                [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).deleteIcon}:hover`]: {
                    color: 'inherit',
                    opacity: 0.7
                },
                [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).label}`]: {
                    padding: 0
                }
            })
    },
    variants: $310787696616542c$var$variants
};




function $0a3c88125d2562b8$export$515f8c67b5305377(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiMenuItem', slot);
}
const $0a3c88125d2562b8$var$menuItemClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $0a3c88125d2562b8$export$2e2bcd8739ae039 = $0a3c88125d2562b8$var$menuItemClasses;



const $5f4401162cf072d8$export$2f632c059ec3efb7 = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MenuItem', [
    'small',
    'medium'
]);


const $2632863671085cd6$export$8192a73b74ebd486 = {
    styleOverrides: {
        paper: ({ theme: theme })=>({
                borderRadius: 8,
                border: `1px solid ${theme.palette.grey[300]}`,
                backgroundColor: theme.palette.common.white,
                boxShadow: theme.shadows[4]
            }),
        list: ({ theme: theme })=>({
                padding: theme.spacing(1, 0)
            })
    }
};
const $2632863671085cd6$export$c9e01ca7c0e9be76 = {
    styleOverrides: {
        root: ({ theme: theme })=>({
                ...theme.typography.body2,
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                borderRadius: 4,
                /**
             * `!important`: MUI's own `MenuItemRoot` sets `paddingTop`/`paddingBottom` directly plus
             * `paddingLeft`/`paddingRight` via its own `!disableGutters` variant - both longhand, both
             * beating this shorthand override without it (confirmed via the real computed styles:
             * 6px/16px, MUI's own values, not this rule's 4px/12px).
             */ padding: `${theme.spacing(1, 3)} !important`,
                margin: theme.spacing(0, 2),
                background: theme.palette.grey[100],
                color: theme.palette.grey[900],
                /** `!important`: MUI's own conditional `minHeight: auto` (at the `sm` breakpoint) otherwise wins over this - Figma's medium row is a fixed 32px, not content-driven */ minHeight: '32px !important',
                [`&.${(0, $0a3c88125d2562b8$export$2e2bcd8739ae039).disabled}`]: {
                    opacity: 0.5
                },
                /**
             * `!important` on `fontSize` here too - without it, this rule (lower specificity, 3 classes)
             * would lose to the unconditional `.${svgIconClasses.root}` rule below (`!important`, 2
             * classes), even though this one is meant to win for icons inside a Button's `endIcon` slot.
             */ [`& .${(0, $ef73307de6008871$export$2e2bcd8739ae039).endIcon} .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
                    ...theme.typography.body1,
                    fontSize: `${theme.typography.body1.fontSize} !important`
                },
                /**
             * The checkmark (`common/Dropdown/MenuItem.tsx`) only renders when selected, so this only
             * ever sizes a visible icon, not reserved empty space. `!important`: empirically, in the
             * real browser, a plain (non-`!important`) version of this rule lost to `CheckIcon`'s own
             * `sx`-generated class despite this selector's higher CSS specificity on paper - the exact
             * cascade mechanism wasn't conclusively identified (CSS layers were checked and ruled out
             * for this theme), so treat this as an empirically-verified, not fully explained, fix.
             */ [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
                    fontSize: `${theme.typography.body1.fontSize} !important`
                },
                [`&.${(0, $0a3c88125d2562b8$export$2e2bcd8739ae039).gutters}`]: {
                    background: 'none',
                    '&:hover': {
                        background: theme.palette.grey[100]
                    },
                    [`&.${(0, $0a3c88125d2562b8$export$2e2bcd8739ae039).selected}`]: {
                        background: theme.palette.grey[100]
                    }
                },
                [`&.${(0, $5f4401162cf072d8$export$2f632c059ec3efb7).small}`]: {
                    ...theme.typography.caption,
                    margin: theme.spacing(0, 1),
                    /** `!important`: needed to beat the base rule's own now-`!important` `32px` above, not just MUI's default */ minHeight: 'auto !important',
                    [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
                        fontSize: `${theme.typography.caption.fontSize} !important`
                    },
                    [`& .${(0, $ef73307de6008871$export$2e2bcd8739ae039).endIcon} .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
                        ...theme.typography.caption,
                        fontSize: `${theme.typography.caption.fontSize} !important`
                    }
                }
            })
    }
};




function $6618c564725dc18f$export$a394fa61b1d583a9(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiFormHelperText', slot);
}
const $6618c564725dc18f$var$formHelperTextClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $6618c564725dc18f$export$2e2bcd8739ae039 = $6618c564725dc18f$var$formHelperTextClasses;



function $0f9a46367366d2ec$export$4b135a4b3a6c4550(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiInputAdornment', slot);
}
const $0f9a46367366d2ec$var$inputAdornmentClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $0f9a46367366d2ec$export$2e2bcd8739ae039 = $0f9a46367366d2ec$var$inputAdornmentClasses;



function $bec79423f6a79e81$export$c1c4b4545ad2ea5f(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiInputLabel', slot);
}
const $bec79423f6a79e81$var$inputLabelClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $bec79423f6a79e81$export$2e2bcd8739ae039 = $bec79423f6a79e81$var$inputLabelClasses;


const $ae59d6ecb34fe2b7$export$9a46b342354429 = {
    defaultProps: {
        shrink: true,
        disableAnimation: true
    },
    styleOverrides: {
        root: ({ theme: theme })=>({
                ...theme.typography.body2,
                marginBottom: theme.spacing(1),
                color: theme.palette.grey[700],
                // Disables label animation (aka "floating notched label")
                position: 'static',
                transform: 'none',
                transition: 'none',
                maxWidth: 'none',
                [`&.${(0, $bec79423f6a79e81$export$2e2bcd8739ae039).shrink}`]: {
                    transform: 'none',
                    maxWidth: 'none'
                },
                [`&.${(0, $bec79423f6a79e81$export$2e2bcd8739ae039).focused}, &.${(0, $bec79423f6a79e81$export$2e2bcd8739ae039).error}, &.${(0, $bec79423f6a79e81$export$2e2bcd8739ae039).disabled}`]: {
                    color: theme.palette.grey[700]
                }
            })
    }
};
const $ae59d6ecb34fe2b7$export$3d5ebbcde6655f = {
    defaultProps: {
        notched: false
    },
    styleOverrides: {
        root: ({ theme: theme })=>({
                ...theme.typography.body2,
                display: 'flex',
                minHeight: 32,
                padding: theme.spacing(1, 2),
                alignItems: 'center',
                gap: theme.spacing(1),
                alignSelf: 'stretch',
                borderRadius: 4,
                backgroundColor: theme.palette.common.white,
                [`&:hover:not(.${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).focused}, .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).disabled}, .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).error})`]: {
                    backgroundColor: theme.palette.common.white,
                    [`& .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: theme.palette.grey[400]
                    }
                },
                [`&.${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.palette.common.white,
                    boxShadow: `0 0 0 2px ${theme.palette.primary[200]}`,
                    [`& .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: theme.palette.primary[600],
                        borderWidth: 1
                    }
                },
                [`&.${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).disabled}`]: {
                    backgroundColor: theme.palette.grey[50],
                    color: theme.palette.grey[400],
                    [`& .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: theme.palette.grey[200]
                    },
                    [`& .${(0, $0f9a46367366d2ec$export$2e2bcd8739ae039).positionEnd} .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
                        color: theme.palette.grey[300]
                    }
                },
                [`&.${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).error}`]: {
                    backgroundColor: theme.palette.common.white,
                    [`& .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: theme.palette.error[600]
                    },
                    [`& .${(0, $0f9a46367366d2ec$export$2e2bcd8739ae039).positionStart}`]: {
                        color: theme.palette.error[600]
                    }
                }
            }),
        sizeSmall: {
            minHeight: 28
        },
        notchedOutline: ({ theme: theme })=>({
                borderColor: theme.palette.grey[300],
                borderWidth: 1,
                borderRadius: 'inherit'
            }),
        input: ({ theme: theme })=>({
                ...theme.typography.body2,
                height: 'auto',
                padding: 0,
                color: 'currentColor',
                /**
             * Browsers dim ::placeholder via a default opacity, regardless of `color`.
             * In addition, Chromium/WebKit ignore `color` on disabled inputs, using -webkit-text-fill-color instead.
             */ '&:disabled, &::placeholder': {
                    color: theme.palette.grey[400],
                    WebkitTextFillColor: theme.palette.grey[400],
                    opacity: 1
                }
            })
    }
};
const $ae59d6ecb34fe2b7$export$110aeb78f04c8ad2 = {
    styleOverrides: {
        root: ({ theme: theme })=>({
                color: theme.palette.grey[500],
                marginRight: 0,
                [`&.${(0, $0f9a46367366d2ec$export$2e2bcd8739ae039).positionEnd}`]: {
                    gap: theme.spacing(1),
                    cursor: 'pointer'
                }
            })
    }
};
const $ae59d6ecb34fe2b7$export$438c2b53b24897dd = {
    styleOverrides: {
        root: ({ theme: theme })=>({
                ...theme.typography.caption,
                marginTop: theme.spacing(1),
                marginRight: 0,
                marginLeft: 0,
                color: theme.palette.grey[600],
                [`&.${(0, $6618c564725dc18f$export$2e2bcd8739ae039).error}`]: {
                    color: theme.palette.error[700]
                },
                [`&.${(0, $6618c564725dc18f$export$2e2bcd8739ae039).disabled}`]: {
                    color: theme.palette.grey[600]
                }
            })
    }
};




function $ec69fe0e5fb4f961$export$39f6debbec19b3ba(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiSwitch', slot);
}
const $ec69fe0e5fb4f961$var$switchClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $ec69fe0e5fb4f961$export$2e2bcd8739ae039 = $ec69fe0e5fb4f961$var$switchClasses;


const $d146c8b855e72f46$export$e7eb69171e142c83 = {
    styleOverrides: {
        root: ({ theme: theme })=>({
                width: 36,
                height: 20,
                padding: 0,
                marginRight: theme.spacing(2),
                overflow: 'visible',
                [`& .${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).track}`]: {
                    borderRadius: 12,
                    backgroundColor: theme.palette.grey[100],
                    opacity: 1
                },
                [`& .${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16,
                    boxShadow: theme.shadows[1]
                },
                [`& .${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 2,
                    color: theme.palette.common.white,
                    [`&.Mui-focusVisible + .${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).track}`]: {
                        outline: `2px solid ${theme.palette.primary[700]}`,
                        outlineOffset: 2,
                        borderRadius: 12
                    },
                    // --- OFF states ---
                    [`&:hover + .${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).track}`]: {
                        backgroundColor: theme.palette.grey[200]
                    },
                    [`&.${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).disabled}`]: {
                        [`& + .${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).track}`]: {
                            opacity: 1
                        },
                        [`& .${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).thumb}`]: {
                            backgroundColor: theme.palette.grey[50]
                        }
                    },
                    // --- ON states ---
                    [`&.${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).checked}`]: {
                        transform: 'translateX(16px)',
                        color: theme.palette.common.white,
                        // default
                        [`& + .${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: theme.palette.primary[700],
                            opacity: 1
                        },
                        // hover
                        [`&:hover + .${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: theme.palette.primary[600]
                        },
                        // disabled
                        [`&.${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).disabled} + .${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: theme.palette.primary[100],
                            opacity: 1
                        }
                    }
                }
            })
    }
};





function $62bfdfa4f6c0c890$export$21f89b560b65a301(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiToggleButton', slot);
}
const $62bfdfa4f6c0c890$var$toggleButtonClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiToggleButton', [
    'root',
    'disabled',
    'selected',
    'standard',
    'primary',
    'secondary',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'fullWidth'
]);
var $62bfdfa4f6c0c890$export$2e2bcd8739ae039 = $62bfdfa4f6c0c890$var$toggleButtonClasses;



function $e26e3704b6dc01bd$export$44aa3ae5b353cef1(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiToggleButtonGroup', slot);
}
const $e26e3704b6dc01bd$var$toggleButtonGroupClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiToggleButtonGroup', [
    'root',
    'selected',
    'horizontal',
    'vertical',
    'disabled',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'fullWidth',
    'firstButton',
    'lastButton',
    'middleButton'
]);
var $e26e3704b6dc01bd$export$2e2bcd8739ae039 = $e26e3704b6dc01bd$var$toggleButtonGroupClasses;


const $aa7a851c8eaf67ef$export$b6fef6057e0967f = {
    styleOverrides: {
        root: ({ theme: theme })=>({
                display: 'inline-flex',
                alignItems: 'center',
                padding: 4,
                borderRadius: 4,
                border: `1px solid ${theme.palette.grey[300]}`,
                backgroundColor: theme.palette.grey[100],
                height: 32
            })
    }
};
const $aa7a851c8eaf67ef$export$1451da7b8d44aa55 = {
    defaultProps: {
        disableRipple: true
    },
    styleOverrides: {
        root: ({ theme: theme })=>({
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '0px 8px',
                borderRadius: 2,
                border: '1px solid transparent',
                backgroundColor: 'transparent',
                textTransform: 'none',
                fontSize: 12,
                fontWeight: 400,
                marginLeft: 0,
                color: theme.palette.grey[500],
                height: 24,
                gap: 4,
                lineHeight: '18px',
                letterSpacing: 'normal',
                [`&.${(0, $62bfdfa4f6c0c890$export$2e2bcd8739ae039).selected}`]: {
                    border: `1px solid ${theme.palette.grey[200]}`,
                    backgroundColor: theme.palette.common.white,
                    color: theme.palette.grey[900],
                    borderRadius: 2
                },
                [`&:hover:not(.${(0, $62bfdfa4f6c0c890$export$2e2bcd8739ae039).selected})`]: {
                    backgroundColor: theme.palette.grey[200],
                    borderRadius: 2,
                    color: theme.palette.grey[700]
                },
                // Override for middle button
                [`&.${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).middleButton}`]: {
                    marginLeft: 0
                }
            })
    }
};



const $aacd7aa2f78b1080$export$872d73a4c63ee9c0 = {
    defaultProps: {
        arrow: true,
        slots: {
            transition: (0, $a5aa955e27ea098e$export$2e2bcd8739ae039)
        },
        slotProps: {
            popper: {
                modifiers: [
                    {
                        name: 'preventOverflow',
                        options: {
                            // when tooltip text is too long, it should have padding,
                            // preventing it from being flush against the window edge
                            padding: 16
                        }
                    }
                ]
            }
        }
    },
    styleOverrides: {
        tooltip: ({ theme: theme })=>({
                ...theme.typography.body2,
                backgroundColor: theme.palette.grey[900],
                padding: theme.spacing(1.5, 3)
            }),
        arrow: ({ theme: theme })=>({
                color: theme.palette.grey[900]
            }),
        popper: {
            '&[data-popper-placement*="bottom"]': {
                // overrides popper offsets
                inset: '-5px auto auto 1px !important'
            }
        }
    }
};


const $646c25e6dbcae0e9$export$9b5ac10f59f76296 = {
    MuiAlert: $0456fe2a0c5df307$export$752ab86848a89b46,
    MuiAutocomplete: $41a26c36a83d7551$export$e59fbfa5ffe25cdd,
    MuiButton: $5f78a8132f139ecb$export$89fc15b83affe05f,
    MuiButtonBase: $5f78a8132f139ecb$export$6dfab79633b2e017,
    MuiCheckbox: $1e8a842489f032c5$export$aaa6d800b3b5976a,
    MuiChip: $310787696616542c$export$dc8bf454cdb2df34,
    MuiIconButton: $5f78a8132f139ecb$export$5702f43d08d0fe41,
    MuiInputAdornment: $ae59d6ecb34fe2b7$export$110aeb78f04c8ad2,
    MuiInputLabel: $ae59d6ecb34fe2b7$export$9a46b342354429,
    MuiFormHelperText: $ae59d6ecb34fe2b7$export$438c2b53b24897dd,
    MuiMenu: $2632863671085cd6$export$8192a73b74ebd486,
    MuiMenuItem: $2632863671085cd6$export$c9e01ca7c0e9be76,
    MuiOutlinedInput: $ae59d6ecb34fe2b7$export$3d5ebbcde6655f,
    MuiPagination: $a1537862b7417309$export$7d9d7373f56f7427,
    MuiPaginationItem: $a1537862b7417309$export$f0644cd8080fd229,
    MuiSwitch: $d146c8b855e72f46$export$e7eb69171e142c83,
    MuiTableCell: $a1537862b7417309$export$dc287f7e97e5fcab,
    MuiTableContainer: $a1537862b7417309$export$cd28f66d0221a810,
    MuiTableRow: $a1537862b7417309$export$8fcf03edac3f9b8,
    MuiTableSortLabel: $a1537862b7417309$export$59b8153d30e2f0c3,
    MuiToggleButton: $aa7a851c8eaf67ef$export$1451da7b8d44aa55,
    MuiToggleButtonGroup: $aa7a851c8eaf67ef$export$b6fef6057e0967f,
    MuiTooltip: $aacd7aa2f78b1080$export$872d73a4c63ee9c0
};


var $40dc3c8ec418f02f$exports = {};

$parcel$export($40dc3c8ec418f02f$exports, "common", function () { return $4d4b47eab2d24330$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "red", function () { return $0f104a22d3b52277$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "pink", function () { return $d66e526fb6a8a4fa$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "purple", function () { return $4cd88d873f6e878d$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "deepPurple", function () { return $416fc14d64dd1318$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "indigo", function () { return $1d862baac25ee3f4$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "blue", function () { return $98fa899c63f712d1$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "lightBlue", function () { return $2c87fbc8fad6829c$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "cyan", function () { return $858647fe6f4cf17f$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "teal", function () { return $a8789d812ffe8ded$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "green", function () { return $818d52d57cc7c0de$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "lightGreen", function () { return $ddea828d454798cf$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "lime", function () { return $408e83042c95bde3$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "yellow", function () { return $63179e78ee935374$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "amber", function () { return $008aa5f791c9efbd$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "orange", function () { return $95195ddba3567eda$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "deepOrange", function () { return $dded6dc6ae2ac0b4$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "brown", function () { return $54ee873524b9e3ad$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "grey", function () { return $fcc7f3d7aad5bcb9$export$2e2bcd8739ae039; });
$parcel$export($40dc3c8ec418f02f$exports, "blueGrey", function () { return $3a6efaeb4748d874$export$2e2bcd8739ae039; });


const $d66e526fb6a8a4fa$var$pink = {
    50: '#fce4ec',
    100: '#f8bbd0',
    200: '#f48fb1',
    300: '#f06292',
    400: '#ec407a',
    500: '#e91e63',
    600: '#d81b60',
    700: '#c2185b',
    800: '#ad1457',
    900: '#880e4f',
    A100: '#ff80ab',
    A200: '#ff4081',
    A400: '#f50057',
    A700: '#c51162'
};
var $d66e526fb6a8a4fa$export$2e2bcd8739ae039 = $d66e526fb6a8a4fa$var$pink;



const $416fc14d64dd1318$var$deepPurple = {
    50: '#ede7f6',
    100: '#d1c4e9',
    200: '#b39ddb',
    300: '#9575cd',
    400: '#7e57c2',
    500: '#673ab7',
    600: '#5e35b1',
    700: '#512da8',
    800: '#4527a0',
    900: '#311b92',
    A100: '#b388ff',
    A200: '#7c4dff',
    A400: '#651fff',
    A700: '#6200ea'
};
var $416fc14d64dd1318$export$2e2bcd8739ae039 = $416fc14d64dd1318$var$deepPurple;


const $1d862baac25ee3f4$var$indigo = {
    50: '#e8eaf6',
    100: '#c5cae9',
    200: '#9fa8da',
    300: '#7986cb',
    400: '#5c6bc0',
    500: '#3f51b5',
    600: '#3949ab',
    700: '#303f9f',
    800: '#283593',
    900: '#1a237e',
    A100: '#8c9eff',
    A200: '#536dfe',
    A400: '#3d5afe',
    A700: '#304ffe'
};
var $1d862baac25ee3f4$export$2e2bcd8739ae039 = $1d862baac25ee3f4$var$indigo;




const $858647fe6f4cf17f$var$cyan = {
    50: '#e0f7fa',
    100: '#b2ebf2',
    200: '#80deea',
    300: '#4dd0e1',
    400: '#26c6da',
    500: '#00bcd4',
    600: '#00acc1',
    700: '#0097a7',
    800: '#00838f',
    900: '#006064',
    A100: '#84ffff',
    A200: '#18ffff',
    A400: '#00e5ff',
    A700: '#00b8d4'
};
var $858647fe6f4cf17f$export$2e2bcd8739ae039 = $858647fe6f4cf17f$var$cyan;


const $a8789d812ffe8ded$var$teal = {
    50: '#e0f2f1',
    100: '#b2dfdb',
    200: '#80cbc4',
    300: '#4db6ac',
    400: '#26a69a',
    500: '#009688',
    600: '#00897b',
    700: '#00796b',
    800: '#00695c',
    900: '#004d40',
    A100: '#a7ffeb',
    A200: '#64ffda',
    A400: '#1de9b6',
    A700: '#00bfa5'
};
var $a8789d812ffe8ded$export$2e2bcd8739ae039 = $a8789d812ffe8ded$var$teal;



const $ddea828d454798cf$var$lightGreen = {
    50: '#f1f8e9',
    100: '#dcedc8',
    200: '#c5e1a5',
    300: '#aed581',
    400: '#9ccc65',
    500: '#8bc34a',
    600: '#7cb342',
    700: '#689f38',
    800: '#558b2f',
    900: '#33691e',
    A100: '#ccff90',
    A200: '#b2ff59',
    A400: '#76ff03',
    A700: '#64dd17'
};
var $ddea828d454798cf$export$2e2bcd8739ae039 = $ddea828d454798cf$var$lightGreen;


const $408e83042c95bde3$var$lime = {
    50: '#f9fbe7',
    100: '#f0f4c3',
    200: '#e6ee9c',
    300: '#dce775',
    400: '#d4e157',
    500: '#cddc39',
    600: '#c0ca33',
    700: '#afb42b',
    800: '#9e9d24',
    900: '#827717',
    A100: '#f4ff81',
    A200: '#eeff41',
    A400: '#c6ff00',
    A700: '#aeea00'
};
var $408e83042c95bde3$export$2e2bcd8739ae039 = $408e83042c95bde3$var$lime;


const $63179e78ee935374$var$yellow = {
    50: '#fffde7',
    100: '#fff9c4',
    200: '#fff59d',
    300: '#fff176',
    400: '#ffee58',
    500: '#ffeb3b',
    600: '#fdd835',
    700: '#fbc02d',
    800: '#f9a825',
    900: '#f57f17',
    A100: '#ffff8d',
    A200: '#ffff00',
    A400: '#ffea00',
    A700: '#ffd600'
};
var $63179e78ee935374$export$2e2bcd8739ae039 = $63179e78ee935374$var$yellow;


const $008aa5f791c9efbd$var$amber = {
    50: '#fff8e1',
    100: '#ffecb3',
    200: '#ffe082',
    300: '#ffd54f',
    400: '#ffca28',
    500: '#ffc107',
    600: '#ffb300',
    700: '#ffa000',
    800: '#ff8f00',
    900: '#ff6f00',
    A100: '#ffe57f',
    A200: '#ffd740',
    A400: '#ffc400',
    A700: '#ffab00'
};
var $008aa5f791c9efbd$export$2e2bcd8739ae039 = $008aa5f791c9efbd$var$amber;



const $dded6dc6ae2ac0b4$var$deepOrange = {
    50: '#fbe9e7',
    100: '#ffccbc',
    200: '#ffab91',
    300: '#ff8a65',
    400: '#ff7043',
    500: '#ff5722',
    600: '#f4511e',
    700: '#e64a19',
    800: '#d84315',
    900: '#bf360c',
    A100: '#ff9e80',
    A200: '#ff6e40',
    A400: '#ff3d00',
    A700: '#dd2c00'
};
var $dded6dc6ae2ac0b4$export$2e2bcd8739ae039 = $dded6dc6ae2ac0b4$var$deepOrange;


const $54ee873524b9e3ad$var$brown = {
    50: '#efebe9',
    100: '#d7ccc8',
    200: '#bcaaa4',
    300: '#a1887f',
    400: '#8d6e63',
    500: '#795548',
    600: '#6d4c41',
    700: '#5d4037',
    800: '#4e342e',
    900: '#3e2723',
    A100: '#d7ccc8',
    A200: '#bcaaa4',
    A400: '#8d6e63',
    A700: '#5d4037'
};
var $54ee873524b9e3ad$export$2e2bcd8739ae039 = $54ee873524b9e3ad$var$brown;



const $3a6efaeb4748d874$var$blueGrey = {
    50: '#eceff1',
    100: '#cfd8dc',
    200: '#b0bec5',
    300: '#90a4ae',
    400: '#78909c',
    500: '#607d8b',
    600: '#546e7a',
    700: '#455a64',
    800: '#37474f',
    900: '#263238',
    A100: '#cfd8dc',
    A200: '#b0bec5',
    A400: '#78909c',
    A700: '#455a64'
};
var $3a6efaeb4748d874$export$2e2bcd8739ae039 = $3a6efaeb4748d874$var$blueGrey;




const $526df5129b7cfda6$var$GREY = {
    25: '#FDFDFD',
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#E9EAEB',
    300: '#D5D7DA',
    400: '#A4A7AE',
    500: '#717680',
    600: '#535862',
    700: '#414651',
    800: '#252B37',
    900: '#101828'
};
const $526df5129b7cfda6$var$PRIMARY = {
    25: '#FCFAFF',
    50: '#E8F6FF',
    100: '#D5EEFF',
    200: '#B3DEFF',
    300: '#85C6FF',
    400: '#569FFF',
    500: '#2F77FF',
    600: '#0C49FF',
    700: '#0039ec',
    800: '#0639CD',
    900: '#10389F'
};
const $526df5129b7cfda6$var$ERROR = {
    25: '#FFFBFA',
    50: '#FEF3F2',
    100: '#FEE4E2',
    200: '#FECDCA',
    300: '#FDA29B',
    400: '#F97066',
    500: '#F04438',
    600: '#D92D20',
    700: '#B42318',
    800: '#912018',
    900: '#7A271A'
};
const $526df5129b7cfda6$var$WARNING = {
    25: '#FFFCF5',
    50: '#FFFAEB',
    100: '#FEF0C7',
    200: '#FEDF89',
    300: '#FEC84B',
    400: '#FDB022',
    500: '#F79009',
    600: '#DC6803',
    700: '#B54708',
    800: '#93370D',
    900: '#7A2E0E'
};
const $526df5129b7cfda6$var$SUCCESS = {
    25: '#F6FEF9',
    50: '#ECFDF3',
    100: '#D1FADF',
    200: '#A6F4C5',
    300: '#6CE9A6',
    400: '#32D583',
    500: '#12B76A',
    600: '#039855',
    700: '#027A48',
    800: '#05603A',
    900: '#054F31'
};
/**
 * "Hanging" colors, used for legacy compatibility (with our old design)
 * @deprecated
 */ const $526df5129b7cfda6$var$AMBER = {
    main: '#F5A119'
};
const $526df5129b7cfda6$export$eaad8caa32d2521d = {
    ...(0, $40dc3c8ec418f02f$exports),
    grey: {
        ...$526df5129b7cfda6$var$GREY
    },
    primary: {
        ...$526df5129b7cfda6$var$PRIMARY,
        main: $526df5129b7cfda6$var$PRIMARY[500],
        light: $526df5129b7cfda6$var$PRIMARY[200],
        dark: $526df5129b7cfda6$var$PRIMARY[800]
    },
    error: {
        ...$526df5129b7cfda6$var$ERROR,
        main: $526df5129b7cfda6$var$ERROR[500],
        light: $526df5129b7cfda6$var$ERROR[200],
        dark: $526df5129b7cfda6$var$ERROR[800]
    },
    warning: {
        ...$526df5129b7cfda6$var$WARNING,
        main: $526df5129b7cfda6$var$WARNING[500],
        light: $526df5129b7cfda6$var$WARNING[200],
        dark: $526df5129b7cfda6$var$WARNING[800]
    },
    success: {
        ...$526df5129b7cfda6$var$SUCCESS,
        main: $526df5129b7cfda6$var$SUCCESS[500],
        light: $526df5129b7cfda6$var$SUCCESS[100],
        dark: $526df5129b7cfda6$var$SUCCESS[800]
    },
    info: {
        ...$526df5129b7cfda6$var$PRIMARY,
        main: $526df5129b7cfda6$var$PRIMARY[500],
        light: $526df5129b7cfda6$var$PRIMARY[200],
        dark: $526df5129b7cfda6$var$PRIMARY[800]
    },
    /**
     * Overrides below are the legacy ones,
     * TODO: Should be refined and replaced with the colors from ramp.
     * TODO: the secondary color should be removed.
     */ secondary: {
        ...$526df5129b7cfda6$var$AMBER,
        contrastText: '#FFFFFF'
    },
    background: {
        default: '#FFFFFF',
        paper: $526df5129b7cfda6$var$GREY[50]
    },
    text: {
        primary: '#262830',
        secondary: '#2D2F3699',
        disabled: '#2D2F3640'
    },
    divider: '#D9D9D9'
};










const $10d5bb839a0de6da$export$d846a084e680d8e = {
    /** Figma: Display 2xl */ h1: {
        fontSize: '4.5rem',
        lineHeight: '5.625rem',
        letterSpacing: '-0.02em'
    },
    /** Figma: Display xl */ h2: {
        fontSize: '3.75rem',
        lineHeight: '4.5rem',
        letterSpacing: '-0.02em'
    },
    /** Figma: Display lg */ h3: {
        fontSize: '3rem',
        lineHeight: '3.75rem',
        letterSpacing: '-0.02em'
    },
    /** Figma: Display md */ h4: {
        fontSize: '2.25rem',
        lineHeight: '2.75rem',
        letterSpacing: '-0.02em'
    },
    /** Figma: Display sm */ h5: {
        fontSize: '1.875rem',
        lineHeight: '2.375rem',
        letterSpacing: 0
    },
    /** Figma: Display xs */ h6: {
        fontSize: '1.5rem',
        lineHeight: '2rem',
        letterSpacing: 0
    },
    /** Figma: Text xl */ subtitle1: {
        fontSize: '1.25rem',
        lineHeight: '1.875rem',
        letterSpacing: 0
    },
    /** Figma: Text lg */ subtitle2: {
        fontSize: '1.125rem',
        lineHeight: '1.75rem',
        letterSpacing: 0
    },
    /** Figma: Text md */ body1: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
        letterSpacing: 0
    },
    /** Figma: Text sm */ body2: {
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        letterSpacing: 0
    },
    /** Figma: Text xs */ caption: {
        fontSize: '0.75rem',
        lineHeight: '1.125rem',
        letterSpacing: 0
    },
    /** Figma: Code sm */ code1: {
        fontFamily: "'Roboto Mono', Consolas, Menlo, monospace",
        fontSize: '0.875rem',
        lineHeight: '1.25rem'
    },
    /** Figma: Code xs */ code2: {
        fontFamily: "'Roboto Mono', Consolas, Menlo, monospace",
        fontSize: '0.75rem',
        lineHeight: '1.125rem'
    }
};


const $1a6512ae4318d72b$export$1d5937c6c580f51 = 4;
const $1a6512ae4318d72b$export$f951e619290d8fb2 = (0, $c6bd6699c9daa002$export$2e2bcd8739ae039)({
    spacing: $1a6512ae4318d72b$export$1d5937c6c580f51,
    typography: $10d5bb839a0de6da$export$d846a084e680d8e,
    palette: $526df5129b7cfda6$export$eaad8caa32d2521d,
    shadows: $190611ecca6afed0$export$3eb26d38a832ce9a,
    components: $646c25e6dbcae0e9$export$9b5ac10f59f76296,
    transitions: {
        duration: {
            enteringScreen: 240,
            leavingScreen: 180
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            /** Original value was 1200 */ lg: 1280,
            xl: 1536
        }
    }
});




const $85bb28abbe457e98$var$logoStyle = {
    width: '100%',
    height: '100%'
};
const $85bb28abbe457e98$export$3b64d7c25f39d3f5 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        sx: $85bb28abbe457e98$var$logoStyle,
        viewBox: "0 400 1920 300",
        width: "201",
        height: "45",
        ...props,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                d: "M362.3 656.5c-.4 9.7-3.1 18.3-7.9 25.7-4.8 7.4-11.5 13.2-20.2 17.3-8.7 4.1-18.5 6.1-29.6 6.1-18.3 0-32.7-6-43.3-17.9-10.5-11.9-15.8-28.8-15.8-50.6v-6.9c0-13.7 2.4-25.6 7.1-35.9 4.8-10.2 11.6-18.2 20.5-23.7 8.9-5.6 19.3-8.4 31-8.4 16.9 0 30.5 4.5 40.8 13.4 10.3 8.9 16.1 21.2 17.5 36.8h-33.5c-.3-8.5-2.4-14.6-6.4-18.3-4-3.7-10.1-5.6-18.4-5.6-8.4 0-14.5 3.1-18.4 9.4-3.9 6.3-5.9 16.2-6.1 30v9.9c0 14.9 1.9 25.5 5.6 31.9 3.7 6.4 10.2 9.6 19.3 9.6 7.7 0 13.6-1.8 17.7-5.5 4.1-3.6 6.3-9.4 6.5-17.3h33.6zM496.2 636.9c0 13.6-2.5 25.6-7.6 36.1-5 10.5-12.2 18.5-21.5 24.2s-19.9 8.5-31.7 8.5c-11.9 0-22.4-2.7-31.6-8.2-9.2-5.5-16.4-13.3-21.5-23.4-5.1-10.2-7.8-21.8-8.1-35v-7.9c0-13.7 2.5-25.7 7.5-36.1 5-10.4 12.2-18.5 21.5-24.2 9.4-5.7 20-8.5 31.9-8.5 11.8 0 22.3 2.8 31.6 8.4 9.3 5.6 16.5 13.6 21.6 24 5.1 10.4 7.7 22.3 7.8 35.7v6.4zm-34.1-5.9c0-13.9-2.3-24.4-6.9-31.6-4.6-7.2-11.2-10.8-19.9-10.8-16.9 0-25.8 12.6-26.7 37.9l-.1 10.2c0 13.7 2.3 24.2 6.8 31.5 4.5 7.3 11.3 11 20.2 11 8.5 0 15-3.6 19.6-10.8 4.6-7.2 6.9-17.6 7-31.1V631zM630 703.7h-33.4L547.2 617v86.8h-33.6V564.3h33.6l49.3 86.8v-86.8H630v139.4zM767.7 703.7h-33.4L684.9 617v86.8h-33.6V564.3h33.6l49.3 86.8v-86.8h33.5v139.4zM875.4 644.5h-52.9v33.3H885v25.9h-96V564.3h96.2v25.9h-62.6v29.4h52.9v24.9zM1011.5 656.5c-.4 9.7-3.1 18.3-7.9 25.7-4.8 7.4-11.5 13.2-20.2 17.3-8.7 4.1-18.5 6.1-29.6 6.1-18.3 0-32.7-6-43.3-17.9-10.5-11.9-15.8-28.8-15.8-50.6v-6.9c0-13.7 2.4-25.6 7.1-35.9 4.8-10.2 11.6-18.2 20.5-23.7 8.9-5.6 19.3-8.4 31-8.4 16.9 0 30.5 4.5 40.8 13.4 10.3 8.9 16.1 21.2 17.5 36.8h-33.5c-.3-8.5-2.4-14.6-6.4-18.3-4-3.7-10.1-5.6-18.4-5.6-8.4 0-14.5 3.1-18.4 9.4-3.9 6.3-5.9 16.2-6.1 30v9.9c0 14.9 1.9 25.5 5.6 31.9 3.7 6.4 10.2 9.6 19.3 9.6 7.7 0 13.6-1.8 17.7-5.5 4.1-3.6 6.3-9.4 6.5-17.3h33.6zM1134.1 590.2h-41.8v113.5h-33.6V590.2h-41.1v-25.9h116.5v25.9zM1257.7 651.7l16-87.4h33.3l-29.6 139.4h-34.9l-18.7-79.5-18.3 79.5h-34.8L1141 564.3h33.4l16 87.4 19.2-87.4h28.5l19.6 87.4zM1395.2 677.7h-46.1l-8 26h-35.9l51.1-139.4h31.6l51.5 139.4h-36.1l-8.1-26zm-38-26h30l-15-48.4-15 48.4zM1501.4 654.4h-18.2v49.3h-33.6V564.3h54.9c16.5 0 29.5 3.7 38.8 11 9.3 7.3 14 17.7 14 31.1 0 9.7-2 17.7-5.9 24.1-3.9 6.4-10.1 11.5-18.4 15.5l29.1 56.3v1.4h-36l-24.7-49.3zm-18.2-25.9h21.3c6.4 0 11.2-1.7 14.4-5 3.2-3.4 4.8-8 4.8-14.1 0-6-1.6-10.7-4.9-14.2-3.3-3.4-8-5.1-14.4-5.1h-21.3v38.4zM1664 644.5h-52.9v33.3h62.4v25.9h-96V564.3h96.2v25.9h-62.6v29.4h52.9v24.9z",
                fill: (0, $1a6512ae4318d72b$export$f951e619290d8fb2).palette.info.contrastText
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                d: "M894.9 424.9h-10.8l-2.9-16c-2.5-2.4-5.6-4.4-9.2-6-3.6-1.6-8-2.3-13-2.3-11.8 0-20.8 4.3-27.2 12.8-6.3 8.5-9.5 19.4-9.5 32.5v1.8c0 13.1 3.1 24 9.3 32.6 6.2 8.6 14.8 12.9 25.8 12.9 5.1 0 9.8-.8 14-2.4 4.2-1.6 7.4-3.6 9.7-5.9l2.9-16h10.8v20.2c-3.3 4.2-8.2 8-14.7 11.3-6.5 3.3-14.1 4.9-22.7 4.9-14.7 0-26.8-5.4-36.3-16.3-9.4-10.9-14.2-24.6-14.2-41.1V446c0-16.6 4.6-30.4 13.9-41.2 9.3-10.9 21.5-16.3 36.5-16.3 8.6 0 16.2 1.7 22.7 5s11.4 7.1 14.7 11.3v20.1h.2zm96.4 4.3-7.6 1.2-32.1 86.1c-2.1 5.7-5.2 10.6-9.2 14.8-4 4.2-9.4 6.3-16.1 6.3-1.2 0-2.8-.1-4.7-.4-1.9-.3-3.4-.6-4.4-.8l1.6-12.1c-.3-.1.6 0 2.8.2 2.2.2 3.5.2 4.1.2 3.3 0 5.9-1.4 7.9-4.2 2-2.8 3.8-6.1 5.3-9.8l3.7-8.7-27.8-71.5-7.7-1.2v-9.9h34v9.9l-9.5 1.6 14.6 41.6 2.8 10.7h.5l17.5-52.3-9.6-1.6v-9.9h33.9v9.8zm87.5 35.4c0 12.1-2.9 21.9-8.8 29.4-5.8 7.4-13.9 11.2-24.1 11.2-5.5 0-10.3-1.1-14.3-3.2s-7.4-5.2-10.1-9.3l-1.4 10.8h-13.2V394.1l-12.7-2.2V382h28v47.2c2.6-3.7 5.9-6.6 9.8-8.6 3.9-2 8.5-3 13.7-3 10.4 0 18.5 4.2 24.3 12.5 5.8 8.3 8.7 19.2 8.7 32.8v1.7h.1zm-15.4-1.7c0-9.7-1.8-17.6-5.3-23.7-3.5-6.1-8.9-9.1-16.2-9.1-4.7 0-8.7 1.1-12 3.4-3.2 2.3-5.8 5.3-7.7 9.2V480c1.9 3.9 4.5 7 7.8 9.3 3.3 2.3 7.3 3.4 12 3.4 7.2 0 12.6-2.6 16.1-7.7 3.5-5.1 5.3-11.9 5.3-20.4v-1.7zm90.9 28.1c-2.6 4.5-6.1 8-10.2 10.4-4.2 2.4-9 3.7-14.4 3.7-9.1 0-16.3-2.9-21.4-8.8-5.1-5.9-7.7-15-7.7-27.4v-37.6l-9.7-2.2v-9.9h25V469c0 9 1.3 15.2 4 18.5 2.6 3.4 6.8 5.1 12.4 5.1 5.4 0 10-1.1 13.5-3.3 3.6-2.2 6.2-5.3 8.1-9.4v-48.7l-11.3-2.2v-9.9h26.6v72.2l9.7 2.2v9.8h-23.4l-1.2-12.3zm101.1-45.3h-11.5l-2.5-10.1c-1.9-1.8-4.2-3.2-7-4.2-2.8-1.1-6-1.6-9.6-1.6-5.5 0-9.5 1.2-12.1 3.6-2.6 2.4-4 5.3-4 8.6s1.2 5.9 3.5 7.9c2.3 1.9 7.1 3.6 14.2 5.1 10.6 2.3 18.6 5.4 23.7 9.3 5.2 3.9 7.8 9.2 7.8 15.8 0 7.5-3 13.5-9.1 18.1-6 4.6-13.9 6.9-23.7 6.9-6.4 0-12.1-.7-17.2-2.2-5.1-1.5-9.6-3.6-13.6-6.4l-.1-19.2h11.5l2.9 11.3c1.8 1.6 4.2 2.8 7.2 3.5 3 .7 6.1 1.1 9.3 1.1 5.5 0 9.7-1.1 12.8-3.3 3.1-2.2 4.6-5.1 4.6-8.7 0-3.4-1.3-6.2-3.9-8.3-2.6-2.2-7.4-4.1-14.6-5.7-10.2-2.2-17.9-5.3-23.1-9.1-5.2-3.8-7.8-9-7.8-15.6 0-6.9 2.9-12.7 8.8-17.5 5.8-4.8 13.4-7.2 22.8-7.2 6.4 0 12.1.8 17.2 2.5s9.3 4 12.7 6.9l.8 18.5zm0 0",
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: (0, $1a6512ae4318d72b$export$f951e619290d8fb2).palette.info.contrastText
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                d: "m683.6 428.7 35 54.8h-20.3L657.8 430v-2.6l40.5-53.5h20.3l-35 54.8zm0 0",
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "#f4a01d"
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                d: "m749 465.5-35.1-54.7h20.3l40.5 53.5v2.6l-40.5 53.5h-20.3l35.1-54.9zm0 0",
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "#f4a01d"
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                d: "M362.3-573.4c-.4 9.7-3.1 18.3-7.9 25.7-4.8 7.4-11.5 13.2-20.2 17.3-8.7 4.1-18.5 6.1-29.6 6.1-18.3 0-32.7-6-43.3-17.9-10.5-11.9-15.8-28.8-15.8-50.6v-6.9c0-13.7 2.4-25.6 7.1-35.9 4.8-10.2 11.6-18.2 20.5-23.7 8.9-5.6 19.3-8.4 31-8.4 16.9 0 30.5 4.5 40.8 13.4 10.3 8.9 16.1 21.2 17.5 36.8h-33.5c-.3-8.5-2.4-14.6-6.4-18.3-4-3.7-10.1-5.6-18.4-5.6-8.4 0-14.5 3.1-18.4 9.4-3.9 6.3-5.9 16.2-6.1 30v9.9c0 14.9 1.9 25.5 5.6 31.9 3.7 6.4 10.2 9.6 19.3 9.6 7.7 0 13.6-1.8 17.7-5.5 4.1-3.6 6.3-9.4 6.5-17.3h33.6zM496.2-593.1c0 13.6-2.5 25.6-7.6 36.1-5 10.5-12.2 18.5-21.5 24.2s-19.9 8.5-31.7 8.5c-11.9 0-22.4-2.7-31.6-8.2-9.2-5.5-16.4-13.3-21.5-23.4-5.1-10.2-7.8-21.8-8.1-35v-7.9c0-13.7 2.5-25.7 7.5-36.1 5-10.4 12.2-18.5 21.5-24.2 9.4-5.7 20-8.5 31.9-8.5 11.8 0 22.3 2.8 31.6 8.4 9.3 5.6 16.5 13.6 21.6 24 5.1 10.4 7.7 22.3 7.8 35.7v6.4zm-34.1-5.8c0-13.9-2.3-24.4-6.9-31.6-4.6-7.2-11.2-10.8-19.9-10.8-16.9 0-25.8 12.6-26.7 37.9l-.1 10.2c0 13.7 2.3 24.2 6.8 31.5 4.5 7.3 11.3 11 20.2 11 8.5 0 15-3.6 19.6-10.8 4.6-7.2 6.9-17.6 7-31.1v-6.3zM630-526.2h-33.4L547.2-613v86.8h-33.6v-139.4h33.6l49.3 86.8v-86.8H630v139.4zM767.7-526.2h-33.4L684.9-613v86.8h-33.6v-139.4h33.6l49.3 86.8v-86.8h33.5v139.4zM875.4-585.4h-52.9v33.3H885v25.9h-96v-139.4h96.2v25.9h-62.6v29.4h52.9v24.9zM1011.5-573.4c-.4 9.7-3.1 18.3-7.9 25.7-4.8 7.4-11.5 13.2-20.2 17.3-8.7 4.1-18.5 6.1-29.6 6.1-18.3 0-32.7-6-43.3-17.9-10.5-11.9-15.8-28.8-15.8-50.6v-6.9c0-13.7 2.4-25.6 7.1-35.9 4.8-10.2 11.6-18.2 20.5-23.7 8.9-5.6 19.3-8.4 31-8.4 16.9 0 30.5 4.5 40.8 13.4 10.3 8.9 16.1 21.2 17.5 36.8h-33.5c-.3-8.5-2.4-14.6-6.4-18.3-4-3.7-10.1-5.6-18.4-5.6-8.4 0-14.5 3.1-18.4 9.4-3.9 6.3-5.9 16.2-6.1 30v9.9c0 14.9 1.9 25.5 5.6 31.9 3.7 6.4 10.2 9.6 19.3 9.6 7.7 0 13.6-1.8 17.7-5.5 4.1-3.6 6.3-9.4 6.5-17.3h33.6zM1134.1-639.7h-41.8v113.5h-33.6v-113.5h-41.1v-25.9h116.5v25.9zM1257.7-578.2l16-87.4h33.3l-29.6 139.4h-34.9l-18.7-79.5-18.3 79.5h-34.8L1141-665.6h33.4l16 87.4 19.2-87.4h28.5l19.6 87.4zM1395.2-552.3h-46.1l-8 26h-35.9l51.1-139.4h31.6l51.5 139.4h-36.1l-8.1-26zm-38-25.9h30l-15-48.4-15 48.4zM1501.4-575.5h-18.2v49.3h-33.6v-139.4h54.9c16.5 0 29.5 3.7 38.8 11 9.3 7.3 14 17.7 14 31.1 0 9.7-2 17.7-5.9 24.1-3.9 6.4-10.1 11.5-18.4 15.5l29.1 56.3v1.4h-36l-24.7-49.3zm-18.2-25.9h21.3c6.4 0 11.2-1.7 14.4-5 3.2-3.4 4.8-8 4.8-14.1 0-6-1.6-10.7-4.9-14.2-3.3-3.4-8-5.1-14.4-5.1h-21.3v38.4zM1664-585.4h-52.9v33.3h62.4v25.9h-96v-139.4h96.2v25.9h-62.6v29.4h52.9v24.9z",
                fill: (0, $1a6512ae4318d72b$export$f951e619290d8fb2).palette.primary.dark
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                d: "M894.9-805h-10.8l-2.9-16c-2.5-2.4-5.6-4.4-9.2-6-3.6-1.6-8-2.3-13-2.3-11.8 0-20.8 4.3-27.2 12.8-6.3 8.5-9.5 19.4-9.5 32.5v1.8c0 13.1 3.1 24 9.3 32.6 6.2 8.6 14.8 12.9 25.8 12.9 5.1 0 9.8-.8 14-2.4 4.2-1.6 7.4-3.6 9.7-5.9l2.9-16h10.8v20.2c-3.3 4.2-8.2 8-14.7 11.3-6.5 3.3-14.1 4.9-22.7 4.9-14.7 0-26.8-5.4-36.3-16.3-9.4-10.9-14.2-24.6-14.2-41.1v-1.6c0-16.6 4.6-30.4 13.9-41.2 9.3-10.9 21.5-16.3 36.5-16.3 8.6 0 16.2 1.7 22.7 5s11.4 7.1 14.7 11.3v19.8h.2zm96.4 4.2-7.6 1.2-32.1 86.1c-2.1 5.7-5.2 10.6-9.2 14.8-4 4.2-9.4 6.3-16.1 6.3-1.2 0-2.8-.1-4.7-.4-1.9-.3-3.4-.6-4.4-.8l1.6-12.1c-.3-.1.6 0 2.8.2 2.2.2 3.5.2 4.1.2 3.3 0 5.9-1.4 7.9-4.2 2-2.8 3.8-6.1 5.3-9.8l3.7-8.7-27.8-71.5-7.7-1.2v-9.9h34v9.9l-9.5 1.6 14.6 41.6 2.8 10.7h.5l17.5-52.3-9.6-1.6v-9.9h33.9v9.8zm87.5 35.4c0 12.1-2.9 21.9-8.8 29.4-5.8 7.4-13.9 11.2-24.1 11.2-5.5 0-10.3-1.1-14.3-3.2s-7.4-5.2-10.1-9.3l-1.4 10.8h-13.2v-109.4l-12.7-2.2v-9.9h28v47.2c2.6-3.7 5.9-6.6 9.8-8.6 3.9-2 8.5-3 13.7-3 10.4 0 18.5 4.2 24.3 12.5 5.8 8.3 8.7 19.2 8.7 32.8v1.7h.1zm-15.4-1.6c0-9.7-1.8-17.6-5.3-23.7-3.5-6.1-8.9-9.1-16.2-9.1-4.7 0-8.7 1.1-12 3.4-3.2 2.3-5.8 5.3-7.7 9.2v37.2c1.9 3.9 4.5 7 7.8 9.3 3.3 2.3 7.3 3.4 12 3.4 7.2 0 12.6-2.6 16.1-7.7 3.5-5.1 5.3-11.9 5.3-20.4v-1.6zm90.9 28.1c-2.6 4.5-6.1 8-10.2 10.4-4.2 2.4-9 3.7-14.4 3.7-9.1 0-16.3-2.9-21.4-8.8-5.1-5.9-7.7-15-7.7-27.4v-37.6l-9.7-2.2v-9.9h25v49.8c0 9 1.3 15.2 4 18.5 2.6 3.4 6.8 5.1 12.4 5.1 5.4 0 10-1.1 13.5-3.3 3.6-2.2 6.2-5.3 8.1-9.4v-48.7l-11.3-2.2v-9.9h26.6v72.2l9.7 2.2v9.8h-23.4l-1.2-12.3zm101.1-45.3h-11.5l-2.5-10.1c-1.9-1.8-4.2-3.2-7-4.2-2.8-1.1-6-1.6-9.6-1.6-5.5 0-9.5 1.2-12.1 3.6-2.6 2.4-4 5.3-4 8.6s1.2 5.9 3.5 7.9c2.3 1.9 7.1 3.6 14.2 5.1 10.6 2.3 18.6 5.4 23.7 9.3 5.2 3.9 7.8 9.2 7.8 15.8 0 7.5-3 13.5-9.1 18.1-6 4.6-13.9 6.9-23.7 6.9-6.4 0-12.1-.7-17.2-2.2-5.1-1.5-9.6-3.6-13.6-6.4l-.1-19.2h11.5l2.9 11.3c1.8 1.6 4.2 2.8 7.2 3.5 3 .7 6.1 1.1 9.3 1.1 5.5 0 9.7-1.1 12.8-3.3 3.1-2.2 4.6-5.1 4.6-8.7 0-3.4-1.3-6.2-3.9-8.3-2.6-2.2-7.4-4.1-14.6-5.7-10.2-2.2-17.9-5.3-23.1-9.1-5.2-3.8-7.8-9-7.8-15.6 0-6.9 2.9-12.7 8.8-17.5 5.8-4.8 13.4-7.2 22.8-7.2 6.4 0 12.1.8 17.2 2.5s9.3 4 12.7 6.9l.8 18.5zm0 0",
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: (0, $1a6512ae4318d72b$export$f951e619290d8fb2).palette.primary.dark
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                d: "m683.6-801.2 35 54.8h-20.3L657.8-800v-2.6l40.5-53.5h20.3l-35 54.9zm0 0",
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "#f4a01d"
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                d: "m749-764.4-35.1-54.7h20.3l40.5 53.5v2.6l-40.5 53.5h-20.3l35.1-54.9zm0 0",
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "#f4a01d"
            })
        ]
    });



parcelRequire("h4Bez");

const $9fadce0ec9a8b88e$export$3a7d64416858c53c = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("g", {
                clipPath: "url(#clip0_3291_2184)",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M6.64209 8.87653L12.3976 18.1043H9.06008L2.4 9.09407V8.65898L9.06008 -0.350586H12.3976L6.64209 8.87653Z",
                        fill: "#F5A119"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M17.3716 15.1087L11.6018 5.89502H14.9393L21.6 14.9059V15.341L14.9393 24.3505H11.6018L17.3716 15.1087Z",
                        fill: "#F5A119"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("clipPath", {
                    id: "clip0_3291_2184",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });



parcelRequire("h4Bez");

const $a8ef2defa7a3722a$export$53728f83fb948d97 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "DataOutlineIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/data/outline",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                d: "M12.0011 4.20996C14.3701 4.21005 16.6857 4.91389 18.6544 6.23145C20.6233 7.54922 22.1574 9.42207 23.0607 11.6123C23.1534 11.862 23.1532 12.137 23.0607 12.3867C22.1574 14.577 20.6234 16.4498 18.6544 17.7676C16.6856 19.0853 14.3702 19.789 12.0011 19.7891C9.63185 19.7891 7.31577 19.0854 5.34681 17.7676C3.37786 16.4498 1.84388 14.577 0.940562 12.3867C0.847999 12.137 0.847876 11.862 0.940562 11.6123C1.84389 9.42206 3.37789 7.54922 5.34681 6.23145C7.3157 4.91379 9.63198 4.20996 12.0011 4.20996ZM12.0001 8.02441C9.80468 8.02441 8.02468 9.80458 8.02455 12C8.02455 14.1955 9.8046 15.9756 12.0001 15.9756C14.1956 15.9755 15.9757 14.1955 15.9757 12C15.9756 9.80461 14.1955 8.02447 12.0001 8.02441Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $d917252aed0e3bef$export$1ae95d1a7411cb7b = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "DeleteIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/delete",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                d: "M14.7872 9.00546L14.4352 18.236M9.56498 18.236L9.21304 9.00546M15.8145 5.30607C16.9983 5.39847 18.1783 5.53429 19.3522 5.71324C19.7001 5.76657 20.046 5.82298 20.3918 5.88349M19.3522 5.71324L18.2659 19.9518C18.2216 20.5315 17.9618 21.073 17.5386 21.4679C17.1154 21.8629 16.56 22.0822 15.9834 22.082H8.01684C7.4402 22.0822 6.88474 21.8629 6.46155 21.4679C6.03837 21.073 5.77863 20.5315 5.7343 19.9518L4.64795 5.71324M4.64795 5.71324C4.30008 5.76554 3.95424 5.82195 3.6084 5.88246M4.64795 5.71324C5.82191 5.53429 7.00193 5.39848 8.18569 5.30607M15.8145 5.30607V4.36661C15.8145 3.15638 14.8889 2.14718 13.6886 2.10923C12.5632 2.07296 11.437 2.07296 10.3116 2.10923C9.11132 2.14718 8.18569 3.15741 8.18569 4.36661V5.30607M15.8145 5.30607C13.2754 5.10821 10.7248 5.10821 8.18569 5.30607",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $b218f37bf97f91b3$export$541a84723b7db0e9 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "DisconnectIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/disconnect",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.14645 7.64645C7.34171 7.45118 7.65822 7.45118 7.85348 7.64645C8.04863 7.84172 8.0487 8.15825 7.85348 8.35348L6.20699 9.99996L8.99996 12.7929L10.6464 11.1464C10.8417 10.9512 11.1582 10.9512 11.3535 11.1464C11.5486 11.3417 11.5487 11.6583 11.3535 11.8535L9.70699 13.5L10.3535 14.1464C10.5486 14.3417 10.5486 14.6583 10.3535 14.8535L8.85348 16.3535C8.39523 16.8118 7.41897 17.3548 6.29391 17.5254C5.26586 17.6811 4.07331 17.5283 3.02047 16.6855L0.853478 18.8535C0.658253 19.0487 0.341718 19.0486 0.146446 18.8535C-0.0488156 18.6582 -0.0488153 18.3417 0.146446 18.1464L2.31344 15.9785C1.47125 14.9259 1.31887 13.7338 1.47457 12.706C1.64513 11.5809 2.1882 10.6047 2.64645 10.1464L4.14645 8.64645L4.22262 8.58395C4.30413 8.52963 4.40056 8.49996 4.49996 8.49996C4.6325 8.50001 4.75975 8.55272 4.85348 8.64645L5.49996 9.29293L7.14645 7.64645ZM3.35348 10.8535C3.06177 11.1452 2.60486 11.9192 2.46285 12.8564C2.32492 13.7673 2.48991 14.7829 3.35348 15.6464C4.21706 16.5099 5.23262 16.675 6.14352 16.5371C7.0807 16.3951 7.85477 15.9381 8.14645 15.6464L9.29293 14.5L4.49996 9.70699L3.35348 10.8535ZM18.1464 0.146446C18.3417 -0.0488153 18.6582 -0.0488156 18.8535 0.146446C19.0486 0.341718 19.0487 0.658253 18.8535 0.853478L16.6855 3.02047C17.5283 4.07331 17.6811 5.26586 17.5254 6.29391C17.3548 7.41897 16.8117 8.39522 16.3535 8.85348L14.8535 10.3535C14.6583 10.5487 14.3417 10.5486 14.1464 10.3535L8.64645 4.85348C8.55272 4.75975 8.50001 4.63251 8.49996 4.49996C8.49996 4.36737 8.5527 4.24021 8.64645 4.14645L10.1464 2.64645C10.6047 2.18815 11.5809 1.64512 12.706 1.47457C13.7338 1.31887 14.9259 1.47124 15.9785 2.31344L18.1464 0.146446ZM15.6464 3.35348C14.7829 2.48991 13.7673 2.32493 12.8564 2.46285C11.9192 2.60485 11.1452 3.06177 10.8535 3.35348L9.70699 4.49996L14.5 9.29293L15.6464 8.14645C15.9381 7.85473 16.3951 7.08069 16.5371 6.14352C16.675 5.23262 16.5099 4.21705 15.6464 3.35348Z",
                fill: "currentColor"
            })
        })
    });



parcelRequire("h4Bez");

const $2f9668e957d9d1e8$export$d9fa4bf8819fddad = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "DocumentationFilledIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/documentation/filled",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("g", {
                id: "Vector",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M5.99805 4.02686C4.94605 4.02686 3.93605 4.20686 2.99805 4.53886V18.7889C3.96167 18.4489 4.97621 18.2757 5.99805 18.2769C7.9593 18.2769 9.77431 18.9046 11.2527 19.9696V5.71884C9.72929 4.62103 7.8919 4.02425 5.99805 4.02686Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M18.0029 4.03077C19.0549 4.03077 20.0649 4.21077 21.0029 4.54277V18.7928C20.0393 18.4528 19.0248 18.2796 18.0029 18.2808C16.0417 18.2808 14.2267 18.9085 12.7483 19.9735V5.72275C14.2717 4.62494 16.1091 4.02816 18.0029 4.03077Z",
                        fill: "currentColor"
                    })
                ]
            })
        })
    });



parcelRequire("h4Bez");

const $eae940bbacb73299$export$b459ff73c06b67ec = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "DotsThreeIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("g", {
            id: "icon/dots-three",
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                    d: "M13.5032 4.9967C13.5032 5.82709 12.83 6.50024 11.9996 6.50024C11.1693 6.50024 10.4961 5.82709 10.4961 4.9967C10.4961 4.16632 11.1693 3.49316 11.9996 3.49316C12.83 3.49316 13.5032 4.16632 13.5032 4.9967Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                    d: "M13.5032 12.0005C13.5032 12.8309 12.83 13.504 11.9996 13.504C11.1693 13.504 10.4961 12.8309 10.4961 12.0005C10.4961 11.1701 11.1693 10.4969 11.9996 10.4969C12.83 10.4969 13.5032 11.1701 13.5032 12.0005Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                    d: "M13.5032 19.0043C13.5032 19.8347 12.83 20.5078 11.9996 20.5078C11.1693 20.5078 10.4961 19.8347 10.4961 19.0043C10.4961 18.1739 11.1693 17.5007 11.9996 17.5007C12.83 17.5007 13.5032 18.1739 13.5032 19.0043Z",
                    fill: "currentColor"
                })
            ]
        })
    });



parcelRequire("h4Bez");

const $6c4ecf59edd403be$export$4e54df4252b4a99c = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "DownloadIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/download",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                id: "Vector",
                d: "M12 17V3M12 17L6 11M12 17L18 11M19 21H5",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $406058546778b7c9$export$7d3bc85820ac4455 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "DragHandleIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("g", {
            id: "icon/drag-handle",
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("rect", {
                    x: "9",
                    y: "6",
                    width: "2",
                    height: "2",
                    rx: "1",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("rect", {
                    x: "13",
                    y: "6",
                    width: "2",
                    height: "2",
                    rx: "1",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("rect", {
                    x: "9",
                    y: "11",
                    width: "2",
                    height: "2",
                    rx: "1",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("rect", {
                    x: "13",
                    y: "11",
                    width: "2",
                    height: "2",
                    rx: "1",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("rect", {
                    x: "9",
                    y: "16",
                    width: "2",
                    height: "2",
                    rx: "1",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("rect", {
                    x: "13",
                    y: "16",
                    width: "2",
                    height: "2",
                    rx: "1",
                    fill: "currentColor"
                })
            ]
        })
    });



parcelRequire("h4Bez");

const $3294d981d8a1956f$export$aed5667c83867b85 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "EnableIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/enable",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                d: "M5 4.83167C5 4.0405 5.87525 3.56266 6.54076 3.99049L17.6915 11.1588C18.3038 11.5525 18.3038 12.4475 17.6915 12.8412L6.54076 20.0095C5.87525 20.4373 5 19.9595 5 19.1683V4.83167Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "none"
            })
        })
    });



parcelRequire("h4Bez");

const $ac7419a80d9dddce$export$da06aec6965c7ba5 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "ExplorerOutlineIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/explorer/outline",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                id: "Vector",
                d: "M3 5C3 5.53043 3.21071 6.03914 3.58579 6.41421C3.96086 6.78929 4.46957 7 5 7H8M3 3V16C3 16.5304 3.21071 17.0391 3.58579 17.4142C3.96086 17.7893 4.46957 18 5 18H8M20 10C20.2652 10 20.5196 9.89464 20.7071 9.70711C20.8946 9.51957 21 9.26522 21 9V6C21 5.73478 20.8946 5.48043 20.7071 5.29289C20.5196 5.10536 20.2652 5 20 5H17.5C17.3448 5 17.1916 4.96386 17.0528 4.89443C16.9139 4.825 16.7931 4.7242 16.7 4.6L15.8 3.4C15.7069 3.2758 15.5861 3.175 15.4472 3.10557C15.3084 3.03614 15.1552 3 15 3H13C12.7348 3 12.4804 3.10536 12.2929 3.29289C12.1054 3.48043 12 3.73478 12 4V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10H20ZM20 21C20.2652 21 20.5196 20.8946 20.7071 20.7071C20.8946 20.5196 21 20.2652 21 20V17C21 16.7348 20.8946 16.4804 20.7071 16.2929C20.5196 16.1054 20.2652 16 20 16H17.1C16.917 15.9976 16.7382 15.9451 16.5831 15.8481C16.4279 15.7511 16.3023 15.6134 16.22 15.45L15.8 14.6C15.7219 14.4211 15.5932 14.269 15.4298 14.1624C15.2663 14.0558 15.0752 13.9993 14.88 14H13C12.7348 14 12.4804 14.1054 12.2929 14.2929C12.1054 14.4804 12 14.7348 12 15V20C12 20.2652 12.1054 20.5196 12.2929 20.7071C12.4804 20.8946 12.7348 21 13 21H20Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $cad423c29bb1ebe8$export$fe32c9a7508b4c4a = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "HelpOutlineIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/help/outline",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                id: "Vector",
                d: "M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13M12 17H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "none"
            })
        })
    });



parcelRequire("h4Bez");

const $c29ab90985853eda$export$fa82770841cc54a0 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "InfoOutlineIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/info/outline",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("g", {
                id: "Vector",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12C11 11.4477 11.4477 11 12 11Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9H12.01C12.5623 9 13.01 8.55228 13.01 8C13.01 7.44772 12.5623 7 12.01 7H12Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z",
                        fill: "currentColor"
                    })
                ]
            })
        })
    });



parcelRequire("h4Bez");

const $925b67d17bae5efe$export$2c9e30524eeaa42e = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "LogoutIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/logout",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("g", {
                id: "Vector",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M9.64746 2.47109C10.2969 2.2416 10.9779 2.72152 10.9805 3.40957H13.8955C14.7238 3.40957 15.3954 4.08126 15.3955 4.90957V7.95449C15.3954 8.23052 15.1716 8.45449 14.8955 8.45449C14.6194 8.45449 14.3956 8.23052 14.3955 7.95449V4.90957C14.3954 4.63355 14.1716 4.40957 13.8955 4.40957H10.9805V19.5883H13.8955C14.1716 19.5883 14.3955 19.3644 14.3955 19.0883V16.0434C14.3958 15.7675 14.6195 15.5434 14.8955 15.5434C15.1715 15.5434 15.3952 15.7675 15.3955 16.0434V19.0883C15.3955 19.9167 14.7239 20.5883 13.8955 20.5883H10.9805C10.9786 21.2768 10.2972 21.7581 9.64746 21.5287L4.40039 19.6752C4.00051 19.534 3.73321 19.1559 3.7334 18.7318L3.74512 5.26406C3.74551 4.84063 4.0129 4.46284 4.41211 4.32168L9.64746 2.47109Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M16.2314 8.46914C16.4267 8.27405 16.7432 8.27405 16.9385 8.46914L20.1201 11.6508C20.3153 11.846 20.3152 12.1625 20.1201 12.3578L16.9385 15.5395C16.7432 15.7347 16.4267 15.7347 16.2314 15.5395C16.0363 15.3442 16.0362 15.0276 16.2314 14.8324L18.5596 12.5043H12.7607C12.4846 12.5043 12.2607 12.2804 12.2607 12.0043C12.2609 11.7283 12.4847 11.5043 12.7607 11.5043H18.5596L16.2314 9.17617C16.0363 8.9809 16.0362 8.66436 16.2314 8.46914Z",
                        fill: "currentColor"
                    })
                ]
            })
        })
    });



parcelRequire("h4Bez");

const $db5721617f0596ac$export$58a57064519df6a0 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "LogsIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/logs",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                id: "Vector",
                d: "M13 12H21M13 18H21M13 6H21M3 12H4M3 18H4M3 6H4M8 12H9M8 18H9M8 6H9",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $ec178a7cbf24362e$export$ad8cd11d6f0ad24c = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "MaximizeIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/expander/maximize",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                d: "M21 9V3H15M21 3L14 10M3 15V21H9M3 21L10 14",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $1db79fc0e1cdd4b8$export$ebde1bbb54d9e014 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "MenuHamburgerIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/menu-hamburger",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                d: "M3.75 6.75h16.5M3.75 12h16.5M3.75 17.25h16.5",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $7e6e60d0b721be32$export$cb808a3c41736d8e = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "MinusIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/minus",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                id: "Vector",
                d: "M6 12H18",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $42132986531c4c1a$export$9feb27937f9de9ba = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "MSIcon",
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 21,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        fill: "#F35325",
                        d: "M.87 1.44h8.695v8.696H.87V1.44Z"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        fill: "#81BC06",
                        d: "M10.435 1.44h8.695v8.696h-8.695V1.44Z"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        fill: "#05A6F0",
                        d: "M.87 11.005h8.695V19.7H.87v-8.696Z"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        fill: "#FFBA08",
                        d: "M10.435 11.005h8.695V19.7h-8.695v-8.696Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 .57h20v20H0z"
                    })
                })
            })
        ]
    });



parcelRequire("h4Bez");

const $1c4f80122f419596$export$15a9884428879c5d = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "NodeRedWorkbenchOutlineIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/node-red-workbench/outline",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                id: "Vector",
                d: "M16.543 19H11.5287C11.2634 19 11.0091 18.8946 10.8216 18.7071C10.634 18.5196 10.4801 18.2652 10.4801 18V6C10.4801 5.73478 10.634 5.48043 10.8216 5.29289C11.0091 5.10536 11.2634 5 11.5287 5H14.545M10.4805 12H7.45898M14.554 7V3C14.554 2.44772 15.0017 2 15.554 2L19.554 2C20.1063 2 20.554 2.44772 20.554 3V7C20.554 7.55228 20.1063 8 19.554 8H15.554C15.0017 8 14.554 7.55228 14.554 7ZM16.541 21V17C16.541 16.4477 16.9887 16 17.541 16H21.541C22.0933 16 22.541 16.4477 22.541 17V21C22.541 21.5523 22.0933 22 21.541 22H17.541C16.9887 22 16.541 21.5523 16.541 21ZM1.45898 14L1.45898 10C1.45898 9.44772 1.9067 9 2.45898 9H6.45898C7.01127 9 7.45898 9.44772 7.45898 10V14C7.45898 14.5523 7.01127 15 6.45898 15H2.45898C1.9067 15 1.45898 14.5523 1.45898 14Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $21dfcf72ba003711$export$c6aaa6e4eb91ba91 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "OverviewIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/overview",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("g", {
                id: "Vector",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M3 12H3.01H3Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M3 18H3.01H3Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M3 6H3.01H3Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M8 12H21H8Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M8 18H21H8Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M8 6H21H8Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        fill: "none",
                        d: "M3 12H3.01M3 18H3.01M3 6H3.01M8 12H21M8 18H21M8 6H21",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        })
    });



parcelRequire("h4Bez");

const $e722d83d0f724e52$export$d0ac701a5f7df20a = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "PasswordOutlineIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/password/outline",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                id: "Vector",
                d: "M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11M5 11H19C20.1046 11 21 11.8954 21 13V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V13C3 11.8954 3.89543 11 5 11Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $b9d7f820c3e6958b$export$9b47433640e5db3a = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "PauseIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/pause",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("g", {
                id: "vector",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M8.91699 4.06738C9.46928 4.06738 9.91699 4.5151 9.91699 5.06738V18.9326C9.91674 19.4847 9.46912 19.9326 8.91699 19.9326H7.88086C7.32873 19.9326 6.88111 19.4847 6.88086 18.9326V5.06738C6.88086 4.5151 7.32857 4.06738 7.88086 4.06738H8.91699Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M16.1201 4.06738C16.6724 4.06738 17.1201 4.5151 17.1201 5.06738V18.9326C17.1199 19.4847 16.6722 19.9326 16.1201 19.9326H15.084C14.5319 19.9326 14.0842 19.4847 14.084 18.9326V5.06738C14.084 4.5151 14.5317 4.06738 15.084 4.06738H16.1201Z",
                        fill: "currentColor"
                    })
                ]
            })
        })
    });



parcelRequire("h4Bez");

const $8ca04bc134762c18$export$ae210882c8fc9b1d = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "PinFilledIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/pin/filled",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                d: "M16 2C16.5304 2 17.039 2.21086 17.4141 2.58594C17.7891 2.96101 18 3.46957 18 4C18 4.53043 17.7891 5.03899 17.4141 5.41406C17.0858 5.74235 16.6553 5.94485 16.1973 5.99023L15.9014 6.00488C15.6724 6.02757 15.4571 6.12883 15.293 6.29297C15.1054 6.4805 15 6.73478 15 7V10.7598C15.0002 11.1316 15.1039 11.4964 15.2998 11.8125C15.4959 12.1287 15.7771 12.3842 16.1104 12.5498L17.8896 13.4502C18.2229 13.6158 18.5041 13.8713 18.7002 14.1875C18.8961 14.5036 18.9998 14.8684 19 15.2402V16C19 16.2652 18.8946 16.5195 18.707 16.707C18.5195 16.8946 18.2652 17 18 17H13V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V17H6C5.73478 17 5.48051 16.8946 5.29297 16.707C5.10543 16.5195 5 16.2652 5 16V15.2402C5.0002 14.8684 5.10393 14.5036 5.2998 14.1875C5.4959 13.8713 5.77714 13.6158 6.11035 13.4502L7.88965 12.5498C8.22286 12.3842 8.5041 12.1287 8.7002 11.8125C8.89607 11.4964 8.9998 11.1316 9 10.7598V7C9 6.73478 8.89457 6.4805 8.70703 6.29297C8.54289 6.12883 8.32763 6.02757 8.09863 6.00488L7.80273 5.99023C7.34474 5.94485 6.91422 5.74235 6.58594 5.41406C6.21086 5.03899 6 4.53043 6 4C6 3.46957 6.21086 2.96101 6.58594 2.58594C6.96101 2.21086 7.46957 2 8 2H16Z",
                fill: "currentColor"
            })
        })
    });



parcelRequire("h4Bez");

const $3ed56309b51b8a84$export$939bbb55cf6eefc7 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "PinOutlineIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/pin/outline",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                d: "M16 1.5C16.663 1.5 17.2987 1.76358 17.7676 2.23242C18.2364 2.70126 18.5 3.33696 18.5 4C18.5 4.66304 18.2364 5.29874 17.7676 5.76758C17.2987 6.23642 16.663 6.5 16 6.5C15.8674 6.5 15.7403 6.55272 15.6465 6.64648C15.5527 6.74025 15.5 6.86739 15.5 7V10.7598L15.5146 10.9678C15.5436 11.1734 15.6153 11.372 15.7256 11.5498C15.8359 11.7276 15.9818 11.8798 16.1533 11.9971L16.332 12.1025L16.3359 12.1035L18.1113 13.002H18.1123C18.5288 13.2089 18.8799 13.5286 19.125 13.9238C19.3699 14.3189 19.4997 14.7745 19.5 15.2393V16C19.5 16.3978 19.3419 16.7792 19.0605 17.0605C18.7792 17.3419 18.3978 17.5 18 17.5H12.5V22C12.5 22.2761 12.2761 22.5 12 22.5C11.7239 22.5 11.5 22.2761 11.5 22V17.5H6C5.60218 17.5 5.22076 17.3419 4.93945 17.0605C4.65815 16.7792 4.5 16.3978 4.5 16V15.2393L4.50586 15.0654C4.5343 14.6615 4.66073 14.2695 4.875 13.9238C5.08947 13.578 5.38492 13.2901 5.73438 13.085L5.8877 13.002L7.66406 12.1035L7.66797 12.1025C7.91762 11.9784 8.12741 11.7867 8.27441 11.5498C8.38467 11.372 8.45643 11.1734 8.48535 10.9678L8.5 10.7598V7C8.5 6.86739 8.44728 6.74025 8.35352 6.64648C8.25975 6.55272 8.13261 6.5 8 6.5C7.33696 6.5 6.70126 6.23642 6.23242 5.76758C5.76358 5.29874 5.5 4.66304 5.5 4C5.5 3.33696 5.76358 2.70126 6.23242 2.23242C6.70126 1.76358 7.33696 1.5 8 1.5H16ZM8 2.5C7.60218 2.5 7.22076 2.65815 6.93945 2.93945C6.65815 3.22076 6.5 3.60218 6.5 4C6.5 4.39782 6.65815 4.77924 6.93945 5.06055C7.18554 5.30663 7.50826 5.45805 7.85156 5.49219L8.14844 5.50781C8.49174 5.54195 8.81446 5.69337 9.06055 5.93945C9.34185 6.22076 9.5 6.60217 9.5 7V10.7607C9.49966 11.2255 9.36988 11.6811 9.125 12.0762C8.87989 12.4714 8.52882 12.7911 8.1123 12.998L8.11133 12.9971L6.33594 13.8965L6.33203 13.8975C6.08238 14.0216 5.87259 14.2133 5.72559 14.4502C5.57852 14.6874 5.50015 14.9612 5.5 15.2402V16C5.5 16.1326 5.55272 16.2597 5.64648 16.3535C5.74025 16.4473 5.86739 16.5 6 16.5H18C18.1326 16.5 18.2597 16.4473 18.3535 16.3535C18.4473 16.2597 18.5 16.1326 18.5 16V15.2402C18.4998 14.9612 18.4215 14.6874 18.2744 14.4502C18.1274 14.2133 17.9176 14.0216 17.668 13.8975L17.6641 13.8965L15.8877 12.9971V12.998C15.4712 12.7911 15.1201 12.4714 14.875 12.0762C14.6301 11.6811 14.5003 11.2255 14.5 10.7607V7C14.5 6.60217 14.6581 6.22076 14.9395 5.93945C15.1855 5.69337 15.5083 5.54195 15.8516 5.50781L16.1484 5.49219C16.4917 5.45805 16.8145 5.30663 17.0605 5.06055C17.3419 4.77924 17.5 4.39782 17.5 4C17.5 3.60218 17.3419 3.22076 17.0605 2.93945C16.7792 2.65815 16.3978 2.5 16 2.5H8Z",
                fill: "currentColor"
            })
        })
    });



parcelRequire("h4Bez");

const $4f94c67c9a03ae7a$export$69f2027e16370dfe = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "ResourcesOutlineIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/resources/outline",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("g", {
                id: "Vector",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M8.3 9.99981C8.17109 10.0068 8.04274 9.97809 7.92916 9.91673C7.81557 9.85537 7.72116 9.76379 7.65637 9.65212C7.59159 9.54046 7.55894 9.41304 7.56205 9.28398C7.56517 9.15492 7.60391 9.02922 7.674 8.92081L11.4 2.99981C11.4585 2.89437 11.5433 2.80586 11.6462 2.74284C11.749 2.67981 11.8663 2.64442 11.9869 2.6401C12.1074 2.63577 12.227 2.66266 12.334 2.71815C12.4411 2.77363 12.532 2.85584 12.598 2.95681L16.3 8.89981C16.373 9.0046 16.4159 9.12735 16.4241 9.25478C16.4323 9.38221 16.4055 9.50946 16.3466 9.62276C16.2877 9.73605 16.1989 9.83107 16.0899 9.89753C15.9808 9.96399 15.8557 9.99936 15.728 9.99981H8.3Z",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M9 13.9998H4C3.44772 13.9998 3 14.4475 3 14.9998V19.9998C3 20.5521 3.44772 20.9998 4 20.9998H9C9.55228 20.9998 10 20.5521 10 19.9998V14.9998C10 14.4475 9.55228 13.9998 9 13.9998Z",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M17.5 20.9998C19.433 20.9998 21 19.4328 21 17.4998C21 15.5668 19.433 13.9998 17.5 13.9998C15.567 13.9998 14 15.5668 14 17.4998C14 19.4328 15.567 20.9998 17.5 20.9998Z",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        })
    });



parcelRequire("h4Bez");

const $3424f87597dd31eb$export$88769f64c4ce504d = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "ServicesOutlineIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/services/outline",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                d: "M12 2.75L20.25 7.25V16.75L12 21.25L3.75 16.75V7.25L12 2.75ZM3.75 7.25L12 11.75L20.25 7.25M12 11.75V21.25M7.875 5L16.125 9.5",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $ac038d8538832e98$export$ac4e8b8ca2b79f39 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "SettingsIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/settings",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("g", {
                id: "Vector",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M11.9999 6.71821C11.9999 3.80121 14.3646 1.43652 17.2816 1.43652C17.8139 1.43652 18.3292 1.51551 18.8155 1.66293C19.0693 1.73985 19.2641 1.94436 19.3286 2.2016C19.393 2.45883 19.3177 2.73103 19.1302 2.91855L15.7915 6.25727C15.8535 6.73572 16.0681 7.19689 16.4355 7.56427C16.8029 7.93165 17.2641 8.14625 17.7425 8.20831L21.0812 4.86959C21.2688 4.68207 21.5409 4.60676 21.7982 4.67123C22.0554 4.73569 22.2599 4.93047 22.3369 5.18426C22.4843 5.67063 22.5633 6.18587 22.5633 6.71821C22.5633 9.6352 20.1986 11.9999 17.2816 11.9999C17.1302 11.9999 16.9801 11.9935 16.8316 11.9809C15.8082 11.8944 14.9514 12.082 14.5094 12.6187L7.31506 21.3547C6.68485 22.1199 5.74545 22.5633 4.75411 22.5633C2.92186 22.5633 1.43652 21.0779 1.43652 19.2457C1.43652 18.2543 1.87985 17.3149 2.6451 16.6847L11.3811 9.49041C11.9178 9.04841 12.1053 8.19157 12.0188 7.16819C12.0063 7.0197 11.9999 6.86961 11.9999 6.71821ZM4.06955 19.1679C4.06955 18.7512 4.40737 18.4134 4.82408 18.4134H4.83162C5.24834 18.4134 5.58615 18.7512 5.58615 19.1679V19.1755C5.58615 19.5922 5.24834 19.93 4.83162 19.93H4.82408C4.40737 19.93 4.06955 19.5922 4.06955 19.1755V19.1679Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M10.0643 8.61993L7.85001 6.40569V4.83191C7.85001 4.56687 7.71096 4.32127 7.48369 4.18491L3.71106 1.92133C3.41417 1.7432 3.03414 1.78998 2.78932 2.0348L2.0348 2.78932C1.78998 3.03414 1.7432 3.41417 1.92133 3.71106L4.18491 7.48369C4.32127 7.71095 4.56687 7.85001 4.83191 7.85001H6.40569L8.48015 9.92448L10.0643 8.61993Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12.5592 17.3607L16.7671 21.5687C18.0931 22.8947 20.2429 22.8947 21.5689 21.5687C22.8949 20.2427 22.8949 18.0929 21.5689 16.7669L18.2433 13.4413C17.9292 13.4859 17.6081 13.5089 17.2817 13.5089C17.0878 13.5089 16.8953 13.5007 16.7046 13.4846C16.3079 13.4511 16.0179 13.4784 15.8318 13.5267C15.7275 13.5538 15.6794 13.5806 15.6638 13.5909L12.5592 17.3607ZM15.9936 15.9935C16.2883 15.6989 16.766 15.6989 17.0607 15.9935L18.947 17.8798C19.2416 18.1745 19.2416 18.6522 18.947 18.9469C18.6523 19.2416 18.1746 19.2416 17.8799 18.9469L15.9936 17.0606C15.6989 16.7659 15.6989 16.2882 15.9936 15.9935Z",
                        fill: "currentColor"
                    })
                ]
            })
        })
    });



parcelRequire("h4Bez");

const $ce136346c7e03d64$export$4167fcc1b9e413a0 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "SettingsOutlineIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("g", {
            id: "icon/settings/outline",
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                    d: "M12.22 2H11.78C11.2496 2 10.7409 2.21071 10.3658 2.58579C9.99072 2.96086 9.78 3.46957 9.78 4V4.18C9.77964 4.53073 9.68706 4.87519 9.51154 5.17884C9.33602 5.48248 9.08374 5.73464 8.78 5.91L8.35 6.16C8.04596 6.33554 7.70108 6.42795 7.35 6.42795C6.99893 6.42795 6.65404 6.33554 6.35 6.16L6.2 6.08C5.74107 5.81526 5.19584 5.74344 4.684 5.88031C4.17217 6.01717 3.73555 6.35154 3.47 6.81L3.25 7.19C2.98526 7.64893 2.91345 8.19416 3.05031 8.706C3.18717 9.21783 3.52154 9.65445 3.98 9.92L4.13 10.02C4.43228 10.1945 4.68362 10.4451 4.85905 10.7468C5.03448 11.0486 5.1279 11.391 5.13 11.74V12.25C5.1314 12.6024 5.03965 12.949 4.86405 13.2545C4.68844 13.5601 4.43521 13.8138 4.13 13.99L3.98 14.08C3.52154 14.3456 3.18717 14.7822 3.05031 15.294C2.91345 15.8058 2.98526 16.3511 3.25 16.81L3.47 17.19C3.73555 17.6485 4.17217 17.9828 4.684 18.1197C5.19584 18.2566 5.74107 18.1847 6.2 17.92L6.35 17.84C6.65404 17.6645 6.99893 17.5721 7.35 17.5721C7.70108 17.5721 8.04596 17.6645 8.35 17.84L8.78 18.09C9.08374 18.2654 9.33602 18.5175 9.51154 18.8212C9.68706 19.1248 9.77964 19.4693 9.78 19.82V20C9.78 20.5304 9.99072 21.0391 10.3658 21.4142C10.7409 21.7893 11.2496 22 11.78 22H12.22C12.7504 22 13.2591 21.7893 13.6342 21.4142C14.0093 21.0391 14.22 20.5304 14.22 20V19.82C14.2204 19.4693 14.3129 19.1248 14.4885 18.8212C14.664 18.5175 14.9163 18.2654 15.22 18.09L15.65 17.84C15.954 17.6645 16.2989 17.5721 16.65 17.5721C17.0011 17.5721 17.346 17.6645 17.65 17.84L17.8 17.92C18.2589 18.1847 18.8042 18.2566 19.316 18.1197C19.8278 17.9828 20.2645 17.6485 20.53 17.19L20.75 16.8C21.0147 16.3411 21.0866 15.7958 20.9497 15.284C20.8128 14.7722 20.4785 14.3356 20.02 14.07L19.87 13.99C19.5648 13.8138 19.3116 13.5601 19.136 13.2545C18.9604 12.949 18.8686 12.6024 18.87 12.25V11.75C18.8686 11.3976 18.9604 11.051 19.136 10.7455C19.3116 10.4399 19.5648 10.1862 19.87 10.01L20.02 9.92C20.4785 9.65445 20.8128 9.21783 20.9497 8.706C21.0866 8.19416 21.0147 7.64893 20.75 7.19L20.53 6.81C20.2645 6.35154 19.8278 6.01717 19.316 5.88031C18.8042 5.74344 18.2589 5.81526 17.8 6.08L17.65 6.16C17.346 6.33554 17.0011 6.42795 16.65 6.42795C16.2989 6.42795 15.954 6.33554 15.65 6.16L15.22 5.91C14.9163 5.73464 14.664 5.48248 14.4885 5.17884C14.3129 4.87519 14.2204 4.53073 14.22 4.18V4C14.22 3.46957 14.0093 2.96086 13.6342 2.58579C13.2591 2.21071 12.7504 2 12.22 2Z",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                    d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });



parcelRequire("h4Bez");

const $448e9e65bf8dd2f3$export$53b2dd97264155a8 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "SidePanelCloseIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/side-panel/close",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                id: "Vector (Stroke)",
                d: "M20.2998 5C20.2998 4.28203 19.718 3.7002 19 3.7002H15.7002V20.2998H19C19.718 20.2998 20.2998 19.718 20.2998 19V5ZM9.50488 8.50488C9.77825 8.23152 10.2218 8.23152 10.4951 8.50488C10.7685 8.77825 10.7685 9.22175 10.4951 9.49512L7.99023 12L10.4951 14.5049C10.7685 14.7782 10.7685 15.2218 10.4951 15.4951C10.2218 15.7685 9.77825 15.7685 9.50488 15.4951L6.50488 12.4951C6.23152 12.2218 6.23152 11.7782 6.50488 11.5049L9.50488 8.50488ZM3.7002 19C3.7002 19.718 4.28203 20.2998 5 20.2998H14.2998V3.7002H5C4.28203 3.7002 3.7002 4.28203 3.7002 5V19ZM21.7002 19C21.7002 20.4912 20.4912 21.7002 19 21.7002H5C3.50883 21.7002 2.2998 20.4912 2.2998 19V5C2.2998 3.50883 3.50883 2.2998 5 2.2998H19C20.4912 2.2998 21.7002 3.50883 21.7002 5V19Z",
                fill: "currentColor"
            })
        })
    });



parcelRequire("h4Bez");

const $08f5bd1d83fa4a5f$export$dc6949a98411e916 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "StopIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/stop",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                d: "M6 2.75H18C19.7949 2.75 21.25 4.20507 21.25 6V18C21.25 19.7949 19.7949 21.25 18 21.25H6C4.20507 21.25 2.75 19.7949 2.75 18V6C2.75 4.20507 4.20507 2.75 6 2.75Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                fill: "none"
            })
        })
    });



parcelRequire("h4Bez");

const $3b67c52f9dbf3f4d$export$e34663dc4a1f3f47 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "SystemOutlineIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/system/outline",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                d: "M3.91406 13.5H19.9141C20.7425 13.5 21.4141 14.1716 21.4141 15V19C21.4141 19.8284 20.7425 20.5 19.9141 20.5H3.91406C3.08564 20.5 2.41406 19.8284 2.41406 19V15C2.41406 14.1716 3.08564 13.5 3.91406 13.5ZM6.54883 15.5254C5.7204 15.5254 5.04883 16.197 5.04883 17.0254C5.04909 17.8536 5.72056 18.5254 6.54883 18.5254C7.37709 18.5254 8.04856 17.8536 8.04883 17.0254C8.04883 16.197 7.37726 15.5254 6.54883 15.5254ZM4.08594 3.5H20.0859C20.9144 3.5 21.5859 4.17157 21.5859 5V9C21.5859 9.82843 20.9144 10.5 20.0859 10.5H4.08594C3.25751 10.5 2.58594 9.82843 2.58594 9V5C2.58594 4.17157 3.25751 3.5 4.08594 3.5ZM6.7207 5.52539C5.89228 5.52539 5.2207 6.19696 5.2207 7.02539C5.22097 7.85359 5.89244 8.52539 6.7207 8.52539C7.54897 8.52539 8.22044 7.85359 8.2207 7.02539C8.2207 6.19696 7.54913 5.52539 6.7207 5.52539Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $2732dd7e592f0ccd$export$34b309d75bd5827e = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "StatusIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/status",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                id: "Vector",
                d: "M22 12H19.52C19.083 11.9991 18.6577 12.1413 18.3091 12.405C17.9606 12.6686 17.708 13.0392 17.59 13.46L15.24 21.82C15.2249 21.8719 15.1933 21.9175 15.15 21.95C15.1067 21.9825 15.0541 22 15 22C14.9459 22 14.8933 21.9825 14.85 21.95C14.8067 21.9175 14.7751 21.8719 14.76 21.82L9.24 2.18C9.22485 2.12807 9.19327 2.08246 9.15 2.05C9.10673 2.01754 9.05409 2 9 2C8.94591 2 8.89327 2.01754 8.85 2.05C8.80673 2.08246 8.77515 2.12807 8.76 2.18L6.41 10.54C6.29246 10.9592 6.04138 11.3285 5.69486 11.592C5.34835 11.8555 4.92532 11.9988 4.49 12H2",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $ce4e3ee315615fb1$export$35f5c3e250802cd1 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "UpdateIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/update",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                id: "Vector",
                d: "M3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.516 3.00947 16.931 3.99122 18.74 5.74L21 8M21 8V3M21 8H16M21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21C9.48395 20.9905 7.06897 20.0088 5.26 18.26L3 16M3 16H8M3 16V21",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $5154eed3dac5502e$export$8df90684a752ef81 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "UploadIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/upload",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                id: "Vector",
                d: "M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M17 8L12 3M12 3L7 8M12 3V15",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "none"
            })
        })
    });



parcelRequire("h4Bez");

const $93476d9be7ee0f23$export$35e00e6a4faf5730 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "UserSettingsIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/user-settings",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                id: "Vector",
                d: "M10.1504 15H6.15039C5.08952 15 4.07211 15.4214 3.32196 16.1716C2.57182 16.9217 2.15039 17.9391 2.15039 19V21M21.8504 16.4L20.9504 16.1M15.3504 13.9L14.4504 13.6M16.7504 18.7L17.0504 17.8M19.2504 12.2L19.5504 11.3M19.7504 18.7L19.3504 17.7M16.9504 12.3L16.5504 11.3M14.4504 16.6L15.4504 16.2M20.8504 13.8L21.8504 13.4M21.1504 15C21.1504 16.6569 19.8072 18 18.1504 18C16.4935 18 15.1504 16.6569 15.1504 15C15.1504 13.3431 16.4935 12 18.1504 12C19.8072 12 21.1504 13.3431 21.1504 15ZM13.1504 7C13.1504 9.20914 11.3595 11 9.15039 11C6.94125 11 5.15039 9.20914 5.15039 7C5.15039 4.79086 6.94125 3 9.15039 3C11.3595 3 13.1504 4.79086 13.1504 7Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });



parcelRequire("h4Bez");

const $e4055172f1fb8a23$export$5c55f94c71e43066 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "UsersOutlineIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/user/users",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                fill: "none",
                d: "M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13M16 3.13C16.8604 3.3503 17.623 3.8507 18.1676 4.55231C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });





const $7961523996af9181$export$cec97b703aeeca3b = {
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).ERROR]: 'error',
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).INFO]: 'info',
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).SUCCESS]: 'success',
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).WARNING]: 'warning'
};
const $7961523996af9181$export$bba395dcdd6a67ba = {
    error: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ce81745a3cd16b5f$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $63351b87e92a3af6$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    success: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $90b68bb2354d9221$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4d0c3371e4bf5696$export$794f4e1bebe11db5), {
        fontSize: "inherit"
    })
};


const $119355ef04841c82$export$1c4fb467540dfc73 = 14;
const $119355ef04841c82$export$c9b0a34c3bf956a1 = 20;
const $119355ef04841c82$export$a9113f8d53e26531 = {
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).INFO]: 4000,
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).SUCCESS]: 4000,
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).WARNING]: 8000,
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).ERROR]: 8000
};
const $119355ef04841c82$var$TOAST_WIDTH = 320;
const $119355ef04841c82$var$containerStyle = {
    width: $119355ef04841c82$var$TOAST_WIDTH,
    position: 'relative',
    overflow: 'hidden',
    borderRadius: 1,
    '&:hover .notification-toast-timer-fill': {
        animationPlayState: 'paused'
    }
};
const $119355ef04841c82$var$alertStyle = {
    alignItems: 'center'
};
const $119355ef04841c82$var$actionsStyle = {
    alignItems: 'center',
    display: 'flex',
    gap: 0.5
};
const $119355ef04841c82$var$counterBadgeStyle = (severity)=>(theme)=>({
            alignItems: 'center',
            bgcolor: theme.palette[(0, $7961523996af9181$export$cec97b703aeeca3b)[severity]][600],
            borderRadius: '50%',
            color: theme.palette.common.white,
            display: 'flex',
            fontSize: 10,
            fontWeight: 700,
            height: 24,
            justifyContent: 'center',
            lineHeight: 1,
            width: 24
        });
/** Structurally identical to `primaryOutline`/`dangerOutline` - reused as-is where the colors already match (info, error). */ const $119355ef04841c82$var$actionButtonVariant = {
    error: 'dangerOutline',
    info: 'primaryOutline',
    success: 'primaryOutline',
    warning: 'primaryOutline'
};
/**
 * `primaryOutline`/`dangerOutline` are colored for info/error, so those two need no override here.
 * warning's colors are Figma-confirmed (border/700-text); success has no Figma reference yet, so it
 * mirrors the same border/200 + text/700 pattern as an assumption, flagged for confirmation. Hover/
 * active states aren't shown in either Figma export either - mirrored from `primaryOutline`'s own
 * default/hover/active progression (100/200/400 steps) rather than left uncovered.
 */ const $119355ef04841c82$var$actionButtonSeverityStyle = {
    warning: (theme)=>({
            color: theme.palette.warning[700],
            borderColor: theme.palette.warning[200],
            '&:hover': {
                backgroundColor: theme.palette.warning[100]
            },
            '&:active': {
                color: theme.palette.warning[800],
                backgroundColor: theme.palette.warning[200],
                borderColor: theme.palette.warning[400]
            }
        }),
    success: (theme)=>({
            color: theme.palette.success[700],
            borderColor: theme.palette.success[200],
            '&:hover': {
                backgroundColor: theme.palette.success[100]
            },
            '&:active': {
                color: theme.palette.success[800],
                backgroundColor: theme.palette.success[200],
                borderColor: theme.palette.success[400]
            }
        })
};
const $119355ef04841c82$var$timerTrackLayoutStyle = {
    bottom: 0,
    height: 3,
    left: 0,
    position: 'absolute',
    right: 0
};
const $119355ef04841c82$var$timerTrackStyle = (severity)=>(theme)=>{
        const borderColor = (0, $0456fe2a0c5df307$export$c22ec15e3373c8f5)[(0, $7961523996af9181$export$cec97b703aeeca3b)[severity]](theme);
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(borderColor, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Theme is missing a notification border color', {
            severity: severity
        }));
        return {
            ...$119355ef04841c82$var$timerTrackLayoutStyle,
            bgcolor: (0, $3289d56f59a873c2$export$58f0f39f63f3cf42)(borderColor, 0.4)
        };
    };
const $119355ef04841c82$var$closeIconStyle = (severity)=>(theme)=>{
        const color = (0, $0456fe2a0c5df307$export$137de82bdbba50d6)[(0, $7961523996af9181$export$cec97b703aeeca3b)[severity]](theme);
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(color, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Theme is missing a notification close icon color', {
            severity: severity
        }));
        return {
            color: color
        };
    };
const $119355ef04841c82$var$shrinkFromFullWidth = (0, $2260c64920c0bb2a$export$d25ddfdf17c3ad3e)`
    from { transform: scaleX(1); }
    to { transform: scaleX(0); }
`;
/**
 * Owns the single timer that both actually dismisses the toast and drives the countdown bar's
 * animation duration, so the two can't drift apart - previously the bar was purely CSS (paused via
 * `:hover`) while the real dismiss was a separate, caller-owned `setTimeout` that never paused on
 * hover, so a hovered toast could vanish out from under the user even while its bar looked frozen.
 * Pauses/resumes on mouseenter/mouseleave of the same element the CSS `:hover` rule targets, using
 * refs (not state) so hovering never triggers a re-render.
 */ const $119355ef04841c82$var$usePausableAutoHide = (autoHideDurationMs, onElapsed, resetKey)=>{
    const isHoveredRef = (0, $h4Bez.useRef)(false);
    const remainingMsRef = (0, $h4Bez.useRef)(0);
    const startedAtRef = (0, $h4Bez.useRef)(0);
    const timeoutIdRef = (0, $h4Bez.useRef)();
    const onElapsedRef = (0, $h4Bez.useRef)(onElapsed);
    (0, $h4Bez.useEffect)(()=>{
        onElapsedRef.current = onElapsed;
    });
    (0, $h4Bez.useEffect)(()=>{
        if (autoHideDurationMs === undefined) return;
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(onElapsedRef.current, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Toast has autoHideDurationMs but nothing to call when it elapses'));
        remainingMsRef.current = autoHideDurationMs;
        if (!isHoveredRef.current) {
            startedAtRef.current = Date.now();
            timeoutIdRef.current = setTimeout(()=>onElapsedRef.current?.(), remainingMsRef.current);
        }
        return ()=>clearTimeout(timeoutIdRef.current);
    // `resetKey` (e.g. an aggregated toast's count) is the deliberate reset trigger, not `onElapsed` - see `onElapsedRef` above
    }, [
        autoHideDurationMs,
        resetKey
    ]);
    return {
        onMouseEnter: ()=>{
            isHoveredRef.current = true;
            if (autoHideDurationMs === undefined || timeoutIdRef.current === undefined) return;
            clearTimeout(timeoutIdRef.current);
            timeoutIdRef.current = undefined;
            remainingMsRef.current -= Date.now() - startedAtRef.current;
        },
        onMouseLeave: ()=>{
            isHoveredRef.current = false;
            if (autoHideDurationMs === undefined) return;
            /** Guards against a stray double `mouseleave` (e.g. the hovered element being removed/replaced under the cursor, like the timer-fill `Box` remounting via its own `key={count}` on an aggregated repeat) scheduling two timeouts for the same remaining duration - clear any already-running one first. */ clearTimeout(timeoutIdRef.current);
            startedAtRef.current = Date.now();
            timeoutIdRef.current = setTimeout(()=>onElapsedRef.current?.(), remainingMsRef.current);
        }
    };
};
const $119355ef04841c82$export$8d8dc7d5f743331b = ({ severity: severity, title: title, description: description, action: action, onClose: onClose, onAutoHide: onAutoHide, autoHideDurationMs: autoHideDurationMs, count: count })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const hoverHandlers = $119355ef04841c82$var$usePausableAutoHide(autoHideDurationMs, onAutoHide ?? onClose, count);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "notification-toast",
        "data-severity": severity,
        sx: $119355ef04841c82$var$containerStyle,
        ...hoverHandlers,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $bb140bd70ba0d464$export$2e2bcd8739ae039), {
                severity: (0, $7961523996af9181$export$cec97b703aeeca3b)[severity],
                iconMapping: (0, $7961523996af9181$export$bba395dcdd6a67ba),
                icon: count && count > 1 ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    "data-testid": "notification-toast-count",
                    sx: $119355ef04841c82$var$counterBadgeStyle(severity),
                    children: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).NOTIFICATION_TOAST_COUNT, {
                        count: count
                    })
                }) : undefined,
                variant: "notification",
                sx: $119355ef04841c82$var$alertStyle,
                action: (action ?? onClose) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: $119355ef04841c82$var$actionsStyle,
                    children: [
                        action && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                            "data-testid": "notification-toast-action",
                            variant: $119355ef04841c82$var$actionButtonVariant[(0, $7961523996af9181$export$cec97b703aeeca3b)[severity]],
                            sx: $119355ef04841c82$var$actionButtonSeverityStyle[(0, $7961523996af9181$export$cec97b703aeeca3b)[severity]],
                            size: "small",
                            onClick: action.onClick,
                            children: action.label
                        }),
                        onClose && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
                            "data-testid": "notification-toast-close",
                            "aria-label": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).CLOSE),
                            variant: "ghost",
                            size: "small",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b9a3c6876c67d06c$export$cae179f078f4b4a4), {
                                fontSize: "small",
                                sx: $119355ef04841c82$var$closeIconStyle(severity)
                            })
                        })
                    ]
                }),
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f0ab7fd79b13f26$export$2e2bcd8739ae039), {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        variant: "body2",
                        children: description
                    })
                ]
            }),
            typeof autoHideDurationMs === 'number' && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                "aria-hidden": "true",
                "data-testid": "notification-toast-timer",
                sx: $119355ef04841c82$var$timerTrackStyle(severity),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    className: "notification-toast-timer-fill",
                    "data-testid": "notification-toast-timer-fill",
                    sx: (theme)=>({
                            animation: `${$119355ef04841c82$var$shrinkFromFullWidth} linear forwards`,
                            animationDuration: `${autoHideDurationMs}ms`,
                            bgcolor: theme.palette[(0, $7961523996af9181$export$cec97b703aeeca3b)[severity]].main,
                            height: '100%',
                            transformOrigin: 'left',
                            width: '100%',
                            '@media (prefers-reduced-motion: reduce)': {
                                animation: 'none'
                            }
                        })
                }, count)
            })
        ]
    });
};




parcelRequire("h4Bez");





const $e2c4c4ee1e8614f4$var$actionsStyle = {
    alignItems: 'center',
    display: 'flex',
    gap: 1
};
const $e2c4c4ee1e8614f4$var$actionButtonVariant = {
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).ERROR]: 'dangerOutline',
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).WARNING]: 'dangerOutline',
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).INFO]: 'primaryOutline'
};
const $e2c4c4ee1e8614f4$var$closeButtonVariant = {
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).ERROR]: 'dangerGhost',
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).WARNING]: 'dangerGhost',
    [(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).INFO]: 'primaryGhost'
};
/**
 * Full-width by design (docked below the top nav, pushes page content down) - actual placement
 * in the page layout is the caller's responsibility, not this component's.
 * Overrides the `notification` variant's colors and border: Banner has a stronger fill and no border, unlike Toast/InlineAlert.
 */ const $e2c4c4ee1e8614f4$var$createBannerStyle = (severity)=>(theme)=>{
        const ramp = theme.palette[(0, $7961523996af9181$export$cec97b703aeeca3b)[severity]];
        return {
            width: '100%',
            border: 'none',
            alignItems: 'center',
            backgroundColor: ramp[100],
            color: ramp[700],
            [`& .${(0, $7e4341771c0d156d$export$2e2bcd8739ae039).icon}`]: {
                color: ramp[700]
            },
            [`& .${(0, $119222338d2d45d2$export$2e2bcd8739ae039).root}`]: {
                color: ramp[800]
            }
        };
    };
const $e2c4c4ee1e8614f4$export$3b4e64e77073e307 = ({ severity: severity, title: title, description: description, action: action, onClose: onClose, live: live = true, 'data-testid': dataTestId = 'notification-banner' })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $bb140bd70ba0d464$export$2e2bcd8739ae039), {
        "data-testid": dataTestId,
        "data-severity": severity,
        role: live ? 'alert' : 'none',
        severity: (0, $7961523996af9181$export$cec97b703aeeca3b)[severity],
        iconMapping: (0, $7961523996af9181$export$bba395dcdd6a67ba),
        variant: "notification",
        sx: $e2c4c4ee1e8614f4$var$createBannerStyle(severity),
        action: (action ?? onClose) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
            sx: $e2c4c4ee1e8614f4$var$actionsStyle,
            children: [
                action && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                    "data-testid": "notification-banner-action",
                    variant: $e2c4c4ee1e8614f4$var$actionButtonVariant[severity],
                    size: "large",
                    onClick: action.onClick,
                    children: action.label
                }),
                onClose && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
                    "data-testid": "notification-banner-close",
                    "aria-label": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).CLOSE),
                    variant: $e2c4c4ee1e8614f4$var$closeButtonVariant[severity],
                    size: "small",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b9a3c6876c67d06c$export$cae179f078f4b4a4), {
                        fontSize: "small"
                    })
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f0ab7fd79b13f26$export$2e2bcd8739ae039), {
                gutterBottom: Boolean(description),
                children: title
            }),
            description && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "body2",
                children: description
            })
        ]
    });
};




var $h4Bez = parcelRequire("h4Bez");






var $h4Bez = parcelRequire("h4Bez");
'use client';
/**
 * @ignore - internal component.
 */ const $4be71481ffac437a$var$ListContext = /*#__PURE__*/ $h4Bez.createContext({});
var $4be71481ffac437a$export$2e2bcd8739ae039 = $4be71481ffac437a$var$ListContext;




function $ad852a2a00132f55$export$c6bd6795ed6e3203(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiList', slot);
}
const $ad852a2a00132f55$var$listClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $ad852a2a00132f55$export$2e2bcd8739ae039 = $ad852a2a00132f55$var$listClasses;



'use client';
const $e38cb871010a9357$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $ad852a2a00132f55$export$c6bd6795ed6e3203), classes);
};
const $e38cb871010a9357$var$ListRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $e38cb871010a9357$var$List = /*#__PURE__*/ $h4Bez.forwardRef(function List(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $h4Bez.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $e38cb871010a9357$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4be71481ffac437a$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($e38cb871010a9357$var$ListRoot, {
            as: component,
            className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $e38cb871010a9357$export$2e2bcd8739ae039 = $e38cb871010a9357$var$List;


var $h4Bez = parcelRequire("h4Bez");










var $h4Bez = parcelRequire("h4Bez");
function $3e397a3d4c91f25d$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $h4Bez.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is available in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}


var $18df94e751f33253$export$2e2bcd8739ae039 = (0, $3e397a3d4c91f25d$export$2e2bcd8739ae039);







function $9ff1bd6366469c7b$export$5682c366c0c669d9(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiListItem', slot);
}
const $9ff1bd6366469c7b$var$listItemClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiListItem', [
    'root',
    'container',
    'dense',
    'alignItemsFlexStart',
    'divider',
    'gutters',
    'padding',
    'secondaryAction'
]);
var $9ff1bd6366469c7b$export$2e2bcd8739ae039 = $9ff1bd6366469c7b$var$listItemClasses;




function $cc377f7b9f79d748$export$c09531d8563c67a5(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiListItemButton', slot);
}
const $cc377f7b9f79d748$var$listItemButtonClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $cc377f7b9f79d748$export$2e2bcd8739ae039 = $cc377f7b9f79d748$var$listItemButtonClasses;



var $h4Bez = parcelRequire("h4Bez");








function $f5fca96aa9ec50da$export$ccdb26aeba48a86e(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiListItemSecondaryAction', slot);
}
const $f5fca96aa9ec50da$var$listItemSecondaryActionClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $f5fca96aa9ec50da$export$2e2bcd8739ae039 = $f5fca96aa9ec50da$var$listItemSecondaryActionClasses;



'use client';
const $8edd61dc466484ad$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $f5fca96aa9ec50da$export$ccdb26aeba48a86e), classes);
};
const $8edd61dc466484ad$var$ListItemSecondaryActionRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 *
 * @deprecated Use the `secondaryAction` prop in the `ListItem` component instead. This component will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
 */ const $8edd61dc466484ad$var$ListItemSecondaryAction = /*#__PURE__*/ $h4Bez.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className, ...other } = props;
    const context = $h4Bez.useContext((0, $4be71481ffac437a$export$2e2bcd8739ae039));
    const ownerState = {
        ...props,
        disableGutters: context.disableGutters
    };
    const classes = $8edd61dc466484ad$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($8edd61dc466484ad$var$ListItemSecondaryActionRoot, {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$8edd61dc466484ad$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $8edd61dc466484ad$export$2e2bcd8739ae039 = $8edd61dc466484ad$var$ListItemSecondaryAction;



'use client';
const $4b454249f6da9127$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $4b454249f6da9127$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction'
        ],
        container: [
            'container'
        ],
        secondaryAction: [
            'secondaryAction'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $9ff1bd6366469c7b$export$5682c366c0c669d9), classes);
};
const $4b454249f6da9127$export$aed538f7519abe89 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $4b454249f6da9127$export$4334bb34c76fef24
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${(0, $cc377f7b9f79d748$export$2e2bcd8739ae039).root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.button,
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    '&:hover': {
                        textDecoration: 'none',
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasSecondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            }
        ]
    })));
const $4b454249f6da9127$var$ListItemContainer = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('li', {
    name: 'MuiListItem',
    slot: 'Container'
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $4b454249f6da9127$var$ListItem = /*#__PURE__*/ $h4Bez.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName, ...ContainerProps } = {}, dense: dense = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, secondaryAction: secondaryAction, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const context = $h4Bez.useContext((0, $4be71481ffac437a$export$2e2bcd8739ae039));
    const childContext = $h4Bez.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $h4Bez.useRef(null);
    const children = $h4Bez.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v6, will be removed in a future major release
    const hasSecondaryAction = children.length && (0, $18df94e751f33253$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction
    };
    const classes = $4b454249f6da9127$var$useUtilityClasses(ownerState);
    const handleRef = (0, $6fa00ac7fde563d8$export$2e2bcd8739ae039)(listItemRef, ref);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [SecondaryActionSlot, secondaryActionSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('secondaryAction', {
        elementType: (0, $8edd61dc466484ad$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.secondaryAction
    });
    const Root = slots.root || components.Root || $4b454249f6da9127$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, rootProps.className, className),
        ...other
    };
    let Component = componentProp || 'li';
    // v4 implementation, deprecated in v6, will be removed in a future major release
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4be71481ffac437a$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($4b454249f6da9127$var$ListItemContainer, {
                as: ContainerComponent,
                className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState,
                ...ContainerProps,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Root, {
                        ...rootProps,
                        ...!(0, $4062a7b1f5a47416$export$2e2bcd8739ae039)(Root) && {
                            as: Component,
                            ownerState: {
                                ...ownerState,
                                ...rootProps.ownerState
                            }
                        },
                        ...componentProps,
                        children: children
                    }),
                    children.pop()
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4be71481ffac437a$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)(Root, {
            ...rootProps,
            as: Component,
            ref: handleRef,
            ...!(0, $4062a7b1f5a47416$export$2e2bcd8739ae039)(Root) && {
                ownerState: {
                    ...ownerState,
                    ...rootProps.ownerState
                }
            },
            ...componentProps,
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(SecondaryActionSlot, {
                    ...secondaryActionSlotProps,
                    children: secondaryAction
                })
            ]
        })
    });
});
var $4b454249f6da9127$export$2e2bcd8739ae039 = $4b454249f6da9127$var$ListItem;


parcelRequire("h4Bez");







/** The error list is a step darker than a description */ const $2a12619a779dd8d7$var$errorListStyle = (severity)=>(theme)=>({
            color: theme.palette[(0, $7961523996af9181$export$cec97b703aeeca3b)[severity]][700]
        });
const $2a12619a779dd8d7$var$renderContent = (severity, content)=>{
    switch(content.kind){
        case 'title':
            return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f0ab7fd79b13f26$export$2e2bcd8739ae039), {
                children: content.title
            });
        case 'titleAndDescription':
            return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f0ab7fd79b13f26$export$2e2bcd8739ae039), {
                        children: content.title
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        variant: "body2",
                        children: content.description
                    })
                ]
            });
        case 'descriptionOnly':
            return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "body2",
                children: content.description
            });
        case 'errorList':
            return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f0ab7fd79b13f26$export$2e2bcd8739ae039), {
                        children: content.title
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e38cb871010a9357$export$2e2bcd8739ae039), {
                        dense: true,
                        disablePadding: true,
                        sx: $2a12619a779dd8d7$var$errorListStyle(severity),
                        children: content.errors.map((error)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4b454249f6da9127$export$2e2bcd8739ae039), {
                                disableGutters: true,
                                disablePadding: true,
                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    children: error
                                })
                            }, error))
                    })
                ]
            });
    }
};
const $2a12619a779dd8d7$var$closeIconStyle = (severity)=>(theme)=>{
        const color = (0, $0456fe2a0c5df307$export$137de82bdbba50d6)[(0, $7961523996af9181$export$cec97b703aeeca3b)[severity]](theme);
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(color, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Theme is missing a notification close icon color', {
            severity: severity
        }));
        return {
            color: color
        };
    };
const $2a12619a779dd8d7$export$a3b2c96db9b0eb71 = ({ severity: severity, content: content, onClose: onClose })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bb140bd70ba0d464$export$2e2bcd8739ae039), {
        "data-testid": "notification-inline-alert",
        "data-severity": severity,
        severity: (0, $7961523996af9181$export$cec97b703aeeca3b)[severity],
        iconMapping: (0, $7961523996af9181$export$bba395dcdd6a67ba),
        variant: "notification",
        action: onClose && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
            "data-testid": "notification-inline-alert-close",
            "aria-label": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).CLOSE),
            variant: "ghost",
            size: "small",
            onClick: onClose,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b9a3c6876c67d06c$export$cae179f078f4b4a4), {
                fontSize: "small",
                sx: $2a12619a779dd8d7$var$closeIconStyle(severity)
            })
        }),
        children: $2a12619a779dd8d7$var$renderContent(severity, content)
    });
};




const $23912206cef801f2$export$3237683fe7eeac = /*#__PURE__*/ (0, $h4Bez.forwardRef)(({ item: item }, ref)=>{
    const toastUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('toastUsecase');
    const liveItem = (0, $be523f14267dcd17$export$9973955de2bf96cf)((state)=>(0, $83da31ffcebd71d6$export$8f481e8a25f70299)(state).find((toast)=>toast.id === item.id), [
        item.id
    ]) ?? item;
    const autoHideDurationMs = liveItem.persist ? undefined : (0, $119355ef04841c82$export$a9113f8d53e26531)[liveItem.severity];
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $119355ef04841c82$export$8d8dc7d5f743331b), {
            severity: liveItem.severity,
            title: liveItem.title,
            description: liveItem.description,
            action: liveItem.action,
            count: liveItem.count,
            autoHideDurationMs: autoHideDurationMs,
            onClose: ()=>toastUsecase.dismiss(item.id)
        })
    });
});
$23912206cef801f2$export$3237683fe7eeac.displayName = 'ToastSnackbarContent';
const $23912206cef801f2$export$7a1b3d78151ab510 = ()=>{
    const toasts = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $83da31ffcebd71d6$export$8f481e8a25f70299));
    const toastUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('toastUsecase');
    const { enqueueSnackbar: enqueueSnackbar, closeSnackbar: closeSnackbar } = (0, $dcf623fd84dea6d4$export$1c97ac2c9a6e7c09)();
    const rendered = (0, $h4Bez.useRef)(new Set());
    (0, $h4Bez.useEffect)(()=>{
        const current = new Set(toasts.map((item)=>item.id));
        for (const id of rendered.current)if (!current.has(id)) closeSnackbar(id);
        for (const item of toasts)if (!rendered.current.has(item.id)) enqueueSnackbar(item.title, {
            key: item.id,
            variant: 'toast',
            item: item,
            // null, not omitted: notistack defaults to a 5s auto-hide when this is left unset, which would
            // race the real timer `ToastSnackbarContent` manages below with notistack's own, unrelated one
            autoHideDuration: null,
            onClose: ()=>toastUsecase.dismiss(item.id)
        });
        rendered.current = current;
    }, [
        toasts,
        toastUsecase,
        enqueueSnackbar,
        closeSnackbar
    ]);
    return null;
};



parcelRequire("h4Bez");



const $fd33ca2436f16cce$export$809c310d187fd9ec = ()=>{
    const activeBanner = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $39d33484e8b79466$export$6909fb9b4ba29917));
    const bannerUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bannerUsecase');
    if (!activeBanner) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e2c4c4ee1e8614f4$export$3b4e64e77073e307), {
        severity: activeBanner.severity,
        title: activeBanner.title,
        description: activeBanner.description,
        action: activeBanner.action,
        onClose: ()=>bannerUsecase.dismiss()
    });
};








var $h4Bez = parcelRequire("h4Bez");





const $bf73078eff32ce9f$var$EVENT_TOAST_DURATION_MS = 4000;
const $bf73078eff32ce9f$var$COUNTER_TOAST_DURATION_MS = (0, $119355ef04841c82$export$a9113f8d53e26531)[(0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).WARNING];
/** Matches notistack's own inter-snack gap (`indents.snackbar.default` = 6px). This theme's spacing unit is 4px, so `1.5` = 6px. */ const $bf73078eff32ce9f$var$ZONE_GAP = 1.5;
const $bf73078eff32ce9f$export$465edecf9e81ad23 = '--deviation-toast-zone-height';
const $bf73078eff32ce9f$var$zoneStyle = {
    position: 'fixed',
    bottom: (0, $119355ef04841c82$export$1c4fb467540dfc73),
    right: (0, $119355ef04841c82$export$c9b0a34c3bf956a1),
    display: 'flex',
    flexDirection: 'column',
    gap: $bf73078eff32ce9f$var$ZONE_GAP,
    zIndex: (theme)=>theme.zIndex.snackbar
};
/** Independent per-event timer - never reset by another event arriving/leaving - falls out for free here: each event keeps its own `key={item.id}` at the call site below, so a new event is a fresh `Toast` instance with its own auto-hide timer, never sharing or resetting an existing one. */ const $bf73078eff32ce9f$var$DeviationEventToast = ({ item: item })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const deviationToastsUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('deviationToastsUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $119355ef04841c82$export$8d8dc7d5f743331b), {
        severity: item.kind === 'new' ? (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).WARNING : (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).SUCCESS,
        title: translator.formatTranslation(item.kind === 'new' ? (0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVIATION_NEW_TOAST : (0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVIATION_RESOLVED, {
            id: item.serviceId
        }),
        autoHideDurationMs: $bf73078eff32ce9f$var$EVENT_TOAST_DURATION_MS,
        onClose: ()=>deviationToastsUsecase.dismissEvent(item.id)
    });
};
/** No close button (Figma) - `onAutoHide` is `Toast`'s only path to `dismissCounter()`, since there's no `onClose` to fall back on. `Toast` itself resets its auto-hide timer whenever `count` changes, re-announcing a changed total for a fresh 8s. */ const $bf73078eff32ce9f$var$DeviationCounterToast = ({ count: count })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const deviationToastsUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('deviationToastsUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $119355ef04841c82$export$8d8dc7d5f743331b), {
        severity: (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).WARNING,
        title: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVIATION_TOAST_COUNTER, {
            count: count
        }),
        count: count,
        autoHideDurationMs: $bf73078eff32ce9f$var$COUNTER_TOAST_DURATION_MS,
        onAutoHide: ()=>deviationToastsUsecase.dismissCounter()
    });
};
const $bf73078eff32ce9f$export$37da67946f71df52 = ()=>{
    const events = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $326a003cf0269e2b$export$8cce705316c4c043));
    const counter = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $326a003cf0269e2b$export$e4e9003e796cb10));
    const containerRef = (0, $h4Bez.useRef)(null);
    /** Depends on `events` itself, not `.length` - at the 3-item cap a new event replaces the oldest one in place, so length alone wouldn't change. */ (0, $h4Bez.useLayoutEffect)(()=>{
        document.documentElement.style.setProperty($bf73078eff32ce9f$export$465edecf9e81ad23, `${containerRef.current?.offsetHeight ?? 0}px`);
        return ()=>document.documentElement.style.setProperty($bf73078eff32ce9f$export$465edecf9e81ad23, '0px');
    }, [
        events,
        counter
    ]);
    if (events.length === 0 && !counter) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "deviation-toast-zone",
        ref: containerRef,
        sx: $bf73078eff32ce9f$var$zoneStyle,
        children: [
            events.map((item)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($bf73078eff32ce9f$var$DeviationEventToast, {
                    item: item
                }, item.id)),
            counter && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($bf73078eff32ce9f$var$DeviationCounterToast, {
                count: counter.count
            })
        ]
    });
};


const $f2541c61ee606526$var$snackbarComponents = {
    toast: (0, $23912206cef801f2$export$3237683fe7eeac)
};
const $f2541c61ee606526$var$GENERAL_TOAST_ZONE_OFFSET_CLASS = 'connectware-general-toast-zone-offset';
/** This theme's spacing unit is 4px, so `4` = 16px, the gap Figma specifies between the two toast zones. */ const $f2541c61ee606526$var$DEVIATION_ZONE_GAP_SPACING_STEPS = 4;
/** Shifts the general Toast zone's container up by the deviation zone's published height plus the gap, so the two never overlap. */ const $f2541c61ee606526$var$generalToastZoneOffsetStyles = (theme)=>({
        [`.${$f2541c61ee606526$var$GENERAL_TOAST_ZONE_OFFSET_CLASS}`]: {
            bottom: `calc(${0, $119355ef04841c82$export$1c4fb467540dfc73}px + var(${0, $bf73078eff32ce9f$export$465edecf9e81ad23}, 0px) + ${theme.spacing($f2541c61ee606526$var$DEVIATION_ZONE_GAP_SPACING_STEPS)}) !important`
        }
    });
const $f2541c61ee606526$var$snackbarProviderClasses = {
    containerAnchorOriginBottomRight: $f2541c61ee606526$var$GENERAL_TOAST_ZONE_OFFSET_CLASS
};
/**
 * `ToastUsecase.applyCaps` excludes `persist: true` toasts from its own max-3 cap (a persist toast,
 * e.g. `PermissionsReducedModal`'s reminder, isn't capped by count), so notistack's own `maxSnack`
 * (default 3) still needs enough headroom for the general cap plus at least one persist toast, or
 * notistack would evict it once enough other toasts arrive - `ToastPortal` has no way to tell
 * notistack a given snack is exempt. Matches this app's original notistack config.
 */ const $f2541c61ee606526$var$MAX_SNACK = 5;
/**
 * notistack's own default anchor is bottom-*left* - never overridden until now, so the general Toast
 * zone has been rendering there regardless of Figma's "anchored bottom-right" spec (caught live during
 * CC-4855's QA pass, checking the two-zone layout coordination - a pre-existing gap this ticket
 * depends on, not something CC-4855 introduced). Explicit here so `containerAnchorOriginBottomRight`
 * (the class the deviation-zone-offset override above targets) actually matches where toasts render.
 */ const $f2541c61ee606526$var$TOAST_ANCHOR_ORIGIN = {
    vertical: 'bottom',
    horizontal: 'right'
};
const $f2541c61ee606526$export$6cd5d5c1dae69a36 = ({ internationalization: internationalization, manager: manager, usecases: usecases, children: children, theme: theme })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $be523f14267dcd17$export$d56d5432daeb70cb), {
        manager: manager,
        usecases: usecases,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$19678796a8dffb7d), {
            internationalization: internationalization,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $bed3dc7f03d1e028$export$2e2bcd8739ae039), {
                theme: theme,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $726d3fe46e12654c$export$2e2bcd8739ae039), {
                        styles: $f2541c61ee606526$var$generalToastZoneOffsetStyles
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcf623fd84dea6d4$export$d1e619fddc3508ce), {
                        Components: $f2541c61ee606526$var$snackbarComponents,
                        classes: $f2541c61ee606526$var$snackbarProviderClasses,
                        maxSnack: $f2541c61ee606526$var$MAX_SNACK,
                        preventDuplicate: true,
                        anchorOrigin: $f2541c61ee606526$var$TOAST_ANCHOR_ORIGIN,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $863ca392f900a852$export$96827c5c36a77a5a), {
                            children: children
                        })
                    })
                ]
            })
        })
    });




var $h4Bez = parcelRequire("h4Bez");
var $297072211b4ec977$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $297072211b4ec977$var$ReactIs, $297072211b4ec977$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$297072211b4ec977$exports = (parcelRequire("2bPoT"))();


var $2c0b81a0d0126930$exports = {};
'use strict';
function $2c0b81a0d0126930$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $h4Bez = parcelRequire("h4Bez");
var $2c0b81a0d0126930$var$React__default = $2c0b81a0d0126930$var$_interopDefault($h4Bez);
function $2c0b81a0d0126930$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2c0b81a0d0126930$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $2c0b81a0d0126930$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $2c0b81a0d0126930$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $2c0b81a0d0126930$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $2c0b81a0d0126930$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($h4Bez.PureComponent);
        $2c0b81a0d0126930$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $2c0b81a0d0126930$var$_defineProperty(SideEffect, "canUseDOM", $2c0b81a0d0126930$var$canUseDOM);
        return SideEffect;
    };
}
$2c0b81a0d0126930$exports = $2c0b81a0d0126930$var$withSideEffect;


var $313127b53624e265$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $313127b53624e265$var$hasElementType = typeof Element !== 'undefined';
var $313127b53624e265$var$hasMap = typeof Map === 'function';
var $313127b53624e265$var$hasSet = typeof Set === 'function';
var $313127b53624e265$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $313127b53624e265$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$313127b53624e265$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($313127b53624e265$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$313127b53624e265$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($313127b53624e265$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($313127b53624e265$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($313127b53624e265$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$313127b53624e265$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$313127b53624e265$exports = function isEqual(a, b) {
    try {
        return $313127b53624e265$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $h4Bez = parcelRequire("h4Bez");
var $8c2e513da399cc2a$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $8c2e513da399cc2a$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $8c2e513da399cc2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $8c2e513da399cc2a$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $8c2e513da399cc2a$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $8c2e513da399cc2a$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$8c2e513da399cc2a$exports = $8c2e513da399cc2a$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $8c2e513da399cc2a$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($8c2e513da399cc2a$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($8c2e513da399cc2a$var$getOwnPropertySymbols) {
            symbols = $8c2e513da399cc2a$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($8c2e513da399cc2a$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $1bd9fb60dd595f5c$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $1bd9fb60dd595f5c$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $1bd9fb60dd595f5c$var$VALID_TAG_NAMES = Object.keys($1bd9fb60dd595f5c$var$TAG_NAMES).map(function(name) {
    return $1bd9fb60dd595f5c$var$TAG_NAMES[name];
});
var $1bd9fb60dd595f5c$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $1bd9fb60dd595f5c$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $1bd9fb60dd595f5c$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $1bd9fb60dd595f5c$var$HTML_TAG_MAP = Object.keys($1bd9fb60dd595f5c$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$1bd9fb60dd595f5c$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $1bd9fb60dd595f5c$var$SELF_CLOSING_TAGS = [
    $1bd9fb60dd595f5c$var$TAG_NAMES.NOSCRIPT,
    $1bd9fb60dd595f5c$var$TAG_NAMES.SCRIPT,
    $1bd9fb60dd595f5c$var$TAG_NAMES.STYLE
];
var $1bd9fb60dd595f5c$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $1bd9fb60dd595f5c$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $1bd9fb60dd595f5c$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $1bd9fb60dd595f5c$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $1bd9fb60dd595f5c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $1bd9fb60dd595f5c$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $1bd9fb60dd595f5c$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $1bd9fb60dd595f5c$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $1bd9fb60dd595f5c$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $1bd9fb60dd595f5c$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $1bd9fb60dd595f5c$var$getInnermostProperty(propsList, $1bd9fb60dd595f5c$var$TAG_NAMES.TITLE);
    var innermostTemplate = $1bd9fb60dd595f5c$var$getInnermostProperty(propsList, $1bd9fb60dd595f5c$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $1bd9fb60dd595f5c$var$getInnermostProperty(propsList, $1bd9fb60dd595f5c$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $1bd9fb60dd595f5c$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $1bd9fb60dd595f5c$var$getInnermostProperty(propsList, $1bd9fb60dd595f5c$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $1bd9fb60dd595f5c$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $1bd9fb60dd595f5c$var$_extends({}, tagAttrs, current);
    }, {});
};
var $1bd9fb60dd595f5c$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$1bd9fb60dd595f5c$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$1bd9fb60dd595f5c$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $1bd9fb60dd595f5c$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $1bd9fb60dd595f5c$var$warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + $1bd9fb60dd595f5c$var$_typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $1bd9fb60dd595f5c$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $1bd9fb60dd595f5c$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $1bd9fb60dd595f5c$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $1bd9fb60dd595f5c$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $1bd9fb60dd595f5c$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($8c2e513da399cc2a$exports)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $1bd9fb60dd595f5c$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $1bd9fb60dd595f5c$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $1bd9fb60dd595f5c$var$getBaseTagFromPropsList([
            $1bd9fb60dd595f5c$var$TAG_PROPERTIES.HREF,
            $1bd9fb60dd595f5c$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $1bd9fb60dd595f5c$var$getAttributesFromPropsList($1bd9fb60dd595f5c$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $1bd9fb60dd595f5c$var$getInnermostProperty(propsList, $1bd9fb60dd595f5c$var$HELMET_PROPS.DEFER),
        encode: $1bd9fb60dd595f5c$var$getInnermostProperty(propsList, $1bd9fb60dd595f5c$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $1bd9fb60dd595f5c$var$getAttributesFromPropsList($1bd9fb60dd595f5c$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $1bd9fb60dd595f5c$var$getTagsFromPropsList($1bd9fb60dd595f5c$var$TAG_NAMES.LINK, [
            $1bd9fb60dd595f5c$var$TAG_PROPERTIES.REL,
            $1bd9fb60dd595f5c$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $1bd9fb60dd595f5c$var$getTagsFromPropsList($1bd9fb60dd595f5c$var$TAG_NAMES.META, [
            $1bd9fb60dd595f5c$var$TAG_PROPERTIES.NAME,
            $1bd9fb60dd595f5c$var$TAG_PROPERTIES.CHARSET,
            $1bd9fb60dd595f5c$var$TAG_PROPERTIES.HTTPEQUIV,
            $1bd9fb60dd595f5c$var$TAG_PROPERTIES.PROPERTY,
            $1bd9fb60dd595f5c$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $1bd9fb60dd595f5c$var$getTagsFromPropsList($1bd9fb60dd595f5c$var$TAG_NAMES.NOSCRIPT, [
            $1bd9fb60dd595f5c$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $1bd9fb60dd595f5c$var$getOnChangeClientState(propsList),
        scriptTags: $1bd9fb60dd595f5c$var$getTagsFromPropsList($1bd9fb60dd595f5c$var$TAG_NAMES.SCRIPT, [
            $1bd9fb60dd595f5c$var$TAG_PROPERTIES.SRC,
            $1bd9fb60dd595f5c$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $1bd9fb60dd595f5c$var$getTagsFromPropsList($1bd9fb60dd595f5c$var$TAG_NAMES.STYLE, [
            $1bd9fb60dd595f5c$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $1bd9fb60dd595f5c$var$getTitleFromPropsList(propsList),
        titleAttributes: $1bd9fb60dd595f5c$var$getAttributesFromPropsList($1bd9fb60dd595f5c$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $1bd9fb60dd595f5c$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $1bd9fb60dd595f5c$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $1bd9fb60dd595f5c$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $1bd9fb60dd595f5c$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $1bd9fb60dd595f5c$var$rafPolyfill : $parcel$global.requestAnimationFrame || $1bd9fb60dd595f5c$var$rafPolyfill;
var $1bd9fb60dd595f5c$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $1bd9fb60dd595f5c$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $1bd9fb60dd595f5c$var$cafPolyfill;
var $1bd9fb60dd595f5c$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $1bd9fb60dd595f5c$var$_helmetCallback = null;
var $1bd9fb60dd595f5c$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($1bd9fb60dd595f5c$var$_helmetCallback) $1bd9fb60dd595f5c$var$cancelAnimationFrame($1bd9fb60dd595f5c$var$_helmetCallback);
    if (newState.defer) $1bd9fb60dd595f5c$var$_helmetCallback = $1bd9fb60dd595f5c$var$requestAnimationFrame(function() {
        $1bd9fb60dd595f5c$var$commitTagChanges(newState, function() {
            $1bd9fb60dd595f5c$var$_helmetCallback = null;
        });
    });
    else {
        $1bd9fb60dd595f5c$var$commitTagChanges(newState);
        $1bd9fb60dd595f5c$var$_helmetCallback = null;
    }
};
var $1bd9fb60dd595f5c$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $1bd9fb60dd595f5c$var$updateAttributes($1bd9fb60dd595f5c$var$TAG_NAMES.BODY, bodyAttributes);
    $1bd9fb60dd595f5c$var$updateAttributes($1bd9fb60dd595f5c$var$TAG_NAMES.HTML, htmlAttributes);
    $1bd9fb60dd595f5c$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $1bd9fb60dd595f5c$var$updateTags($1bd9fb60dd595f5c$var$TAG_NAMES.BASE, baseTag),
        linkTags: $1bd9fb60dd595f5c$var$updateTags($1bd9fb60dd595f5c$var$TAG_NAMES.LINK, linkTags),
        metaTags: $1bd9fb60dd595f5c$var$updateTags($1bd9fb60dd595f5c$var$TAG_NAMES.META, metaTags),
        noscriptTags: $1bd9fb60dd595f5c$var$updateTags($1bd9fb60dd595f5c$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $1bd9fb60dd595f5c$var$updateTags($1bd9fb60dd595f5c$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $1bd9fb60dd595f5c$var$updateTags($1bd9fb60dd595f5c$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $1bd9fb60dd595f5c$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $1bd9fb60dd595f5c$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $1bd9fb60dd595f5c$var$flattenArray(title);
    $1bd9fb60dd595f5c$var$updateAttributes($1bd9fb60dd595f5c$var$TAG_NAMES.TITLE, attributes);
};
var $1bd9fb60dd595f5c$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($1bd9fb60dd595f5c$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($1bd9fb60dd595f5c$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($1bd9fb60dd595f5c$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($1bd9fb60dd595f5c$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $1bd9fb60dd595f5c$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($1bd9fb60dd595f5c$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $1bd9fb60dd595f5c$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $1bd9fb60dd595f5c$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $1bd9fb60dd595f5c$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($1bd9fb60dd595f5c$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $1bd9fb60dd595f5c$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $1bd9fb60dd595f5c$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $1bd9fb60dd595f5c$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $1bd9fb60dd595f5c$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $1bd9fb60dd595f5c$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + $1bd9fb60dd595f5c$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $1bd9fb60dd595f5c$var$HELMET_ATTRIBUTE + "=\"true\">" + $1bd9fb60dd595f5c$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $1bd9fb60dd595f5c$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $1bd9fb60dd595f5c$var$TAG_PROPERTIES.INNER_HTML || attribute === $1bd9fb60dd595f5c$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + $1bd9fb60dd595f5c$var$encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $1bd9fb60dd595f5c$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $1bd9fb60dd595f5c$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $1bd9fb60dd595f5c$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$1bd9fb60dd595f5c$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $1bd9fb60dd595f5c$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$1bd9fb60dd595f5c$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $1bd9fb60dd595f5c$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$1bd9fb60dd595f5c$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $1bd9fb60dd595f5c$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($1bd9fb60dd595f5c$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $1bd9fb60dd595f5c$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$1bd9fb60dd595f5c$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $1bd9fb60dd595f5c$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $1bd9fb60dd595f5c$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $1bd9fb60dd595f5c$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(type, mappedTag);
    });
};
var $1bd9fb60dd595f5c$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $1bd9fb60dd595f5c$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $1bd9fb60dd595f5c$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $1bd9fb60dd595f5c$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $1bd9fb60dd595f5c$var$ATTRIBUTE_NAMES.BODY:
        case $1bd9fb60dd595f5c$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $1bd9fb60dd595f5c$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $1bd9fb60dd595f5c$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $1bd9fb60dd595f5c$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $1bd9fb60dd595f5c$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $1bd9fb60dd595f5c$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $1bd9fb60dd595f5c$var$getMethodsForTag($1bd9fb60dd595f5c$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $1bd9fb60dd595f5c$var$getMethodsForTag($1bd9fb60dd595f5c$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $1bd9fb60dd595f5c$var$getMethodsForTag($1bd9fb60dd595f5c$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $1bd9fb60dd595f5c$var$getMethodsForTag($1bd9fb60dd595f5c$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $1bd9fb60dd595f5c$var$getMethodsForTag($1bd9fb60dd595f5c$var$TAG_NAMES.META, metaTags, encode),
        noscript: $1bd9fb60dd595f5c$var$getMethodsForTag($1bd9fb60dd595f5c$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $1bd9fb60dd595f5c$var$getMethodsForTag($1bd9fb60dd595f5c$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $1bd9fb60dd595f5c$var$getMethodsForTag($1bd9fb60dd595f5c$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $1bd9fb60dd595f5c$var$getMethodsForTag($1bd9fb60dd595f5c$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $1bd9fb60dd595f5c$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $1bd9fb60dd595f5c$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $1bd9fb60dd595f5c$var$classCallCheck(this, HelmetWrapper);
            return $1bd9fb60dd595f5c$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($313127b53624e265$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $1bd9fb60dd595f5c$var$TAG_NAMES.SCRIPT:
                case $1bd9fb60dd595f5c$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $1bd9fb60dd595f5c$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $1bd9fb60dd595f5c$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $1bd9fb60dd595f5c$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $1bd9fb60dd595f5c$var$TAG_NAMES.TITLE:
                    return $1bd9fb60dd595f5c$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $1bd9fb60dd595f5c$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $1bd9fb60dd595f5c$var$TAG_NAMES.BODY:
                    return $1bd9fb60dd595f5c$var$_extends({}, newProps, {
                        bodyAttributes: $1bd9fb60dd595f5c$var$_extends({}, newChildProps)
                    });
                case $1bd9fb60dd595f5c$var$TAG_NAMES.HTML:
                    return $1bd9fb60dd595f5c$var$_extends({}, newProps, {
                        htmlAttributes: $1bd9fb60dd595f5c$var$_extends({}, newChildProps)
                    });
            }
            return $1bd9fb60dd595f5c$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $1bd9fb60dd595f5c$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $1bd9fb60dd595f5c$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $1bd9fb60dd595f5c$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $1bd9fb60dd595f5c$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $1bd9fb60dd595f5c$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $1bd9fb60dd595f5c$var$TAG_NAMES.LINK:
                    case $1bd9fb60dd595f5c$var$TAG_NAMES.META:
                    case $1bd9fb60dd595f5c$var$TAG_NAMES.NOSCRIPT:
                    case $1bd9fb60dd595f5c$var$TAG_NAMES.SCRIPT:
                    case $1bd9fb60dd595f5c$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $1bd9fb60dd595f5c$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $1bd9fb60dd595f5c$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(Component, newProps);
        };
        $1bd9fb60dd595f5c$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $1bd9fb60dd595f5c$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $1bd9fb60dd595f5c$var$NullComponent = function NullComponent() {
    return null;
};
var $1bd9fb60dd595f5c$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($2c0b81a0d0126930$exports)))($1bd9fb60dd595f5c$var$reducePropsToState, $1bd9fb60dd595f5c$var$handleClientStateChange, $1bd9fb60dd595f5c$var$mapStateOnServer)($1bd9fb60dd595f5c$var$NullComponent);
var $1bd9fb60dd595f5c$export$dcef8f9bb9a41431 = $1bd9fb60dd595f5c$var$Helmet($1bd9fb60dd595f5c$var$HelmetSideEffects);
$1bd9fb60dd595f5c$export$dcef8f9bb9a41431.renderStatic = $1bd9fb60dd595f5c$export$dcef8f9bb9a41431.rewind;
var $1bd9fb60dd595f5c$export$2e2bcd8739ae039 = $1bd9fb60dd595f5c$export$dcef8f9bb9a41431;






const $a3412fd06c064a0d$export$e93312b7773dfcac = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const getApplicationMetadataUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('getApplicationMetadataUsecase');
    const metadata = (0, $h4Bez.useMemo)(()=>getApplicationMetadataUsecase.invoke(), [
        getApplicationMetadataUsecase
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $1bd9fb60dd595f5c$export$dcef8f9bb9a41431), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("title", {
                children: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).APPLICATION_TITLE)
            }),
            (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(metadata).map(([name, value], k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("meta", {
                    httpEquiv: name,
                    content: value
                }, k))
        ]
    });
};







var $h4Bez = parcelRequire("h4Bez");


var $h4Bez = parcelRequire("h4Bez");


function $f2bf609c17c56526$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $f2bf609c17c56526$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $f2bf609c17c56526$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $f2bf609c17c56526$var$isAbsolute(to);
    var isFromAbs = from && $f2bf609c17c56526$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $f2bf609c17c56526$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $f2bf609c17c56526$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $f2bf609c17c56526$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $f2bf609c17c56526$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$f2bf609c17c56526$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $f2bf609c17c56526$export$2e2bcd8739ae039 = $f2bf609c17c56526$var$resolvePathname;


function $2522c78fe50c5a47$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $2522c78fe50c5a47$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $2522c78fe50c5a47$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $2522c78fe50c5a47$var$valueOf(a);
        var bValue = $2522c78fe50c5a47$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $2522c78fe50c5a47$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $2522c78fe50c5a47$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $2522c78fe50c5a47$export$2e2bcd8739ae039 = $2522c78fe50c5a47$var$valueEqual;



var $c862936c9f17acdc$var$isProduction = true;
var $c862936c9f17acdc$var$prefix = 'Invariant failed';
function $c862936c9f17acdc$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($c862936c9f17acdc$var$isProduction) throw new Error($c862936c9f17acdc$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($c862936c9f17acdc$var$prefix, ": ").concat(provided) : $c862936c9f17acdc$var$prefix;
    throw new Error(value);
}


function $044ea197e08add36$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $044ea197e08add36$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $044ea197e08add36$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $044ea197e08add36$var$stripBasename(path, prefix) {
    return $044ea197e08add36$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $044ea197e08add36$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $044ea197e08add36$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $044ea197e08add36$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $044ea197e08add36$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $044ea197e08add36$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $f2bf609c17c56526$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $044ea197e08add36$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $2522c78fe50c5a47$export$2e2bcd8739ae039)(a.state, b.state);
}
function $044ea197e08add36$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $044ea197e08add36$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $044ea197e08add36$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $044ea197e08add36$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $044ea197e08add36$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $044ea197e08add36$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $044ea197e08add36$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $044ea197e08add36$var$PopStateEvent = 'popstate';
var $044ea197e08add36$var$HashChangeEvent = 'hashchange';
function $044ea197e08add36$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $044ea197e08add36$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$044ea197e08add36$var$canUseDOM && (0, $c862936c9f17acdc$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $044ea197e08add36$var$supportsHistory();
    var needsHashChangeListener = !$044ea197e08add36$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $044ea197e08add36$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $044ea197e08add36$var$stripTrailingSlash($044ea197e08add36$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $044ea197e08add36$var$stripBasename(path, basename);
        return $044ea197e08add36$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $044ea197e08add36$var$createTransitionManager();
    function setState(nextState) {
        (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($044ea197e08add36$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($044ea197e08add36$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($044ea197e08add36$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $044ea197e08add36$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $044ea197e08add36$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $044ea197e08add36$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($044ea197e08add36$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($044ea197e08add36$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($044ea197e08add36$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($044ea197e08add36$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $044ea197e08add36$var$HashChangeEvent$1 = 'hashchange';
var $044ea197e08add36$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $044ea197e08add36$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $044ea197e08add36$var$stripLeadingSlash,
        decodePath: $044ea197e08add36$var$addLeadingSlash
    },
    slash: {
        encodePath: $044ea197e08add36$var$addLeadingSlash,
        decodePath: $044ea197e08add36$var$addLeadingSlash
    }
};
function $044ea197e08add36$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $044ea197e08add36$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $044ea197e08add36$var$pushHashPath(path) {
    window.location.hash = path;
}
function $044ea197e08add36$var$replaceHashPath(path) {
    window.location.replace($044ea197e08add36$var$stripHash(window.location.href) + '#' + path);
}
function $044ea197e08add36$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$044ea197e08add36$var$canUseDOM && (0, $c862936c9f17acdc$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $044ea197e08add36$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $044ea197e08add36$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $044ea197e08add36$var$stripTrailingSlash($044ea197e08add36$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $044ea197e08add36$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($044ea197e08add36$var$getHashPath());
        if (basename) path = $044ea197e08add36$var$stripBasename(path, basename);
        return $044ea197e08add36$export$90c043f1c57770b8(path);
    }
    var transitionManager = $044ea197e08add36$var$createTransitionManager();
    function setState(nextState) {
        (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $044ea197e08add36$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $044ea197e08add36$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $044ea197e08add36$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($044ea197e08add36$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($044ea197e08add36$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $044ea197e08add36$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $044ea197e08add36$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $044ea197e08add36$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $044ea197e08add36$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $044ea197e08add36$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $044ea197e08add36$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $044ea197e08add36$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $044ea197e08add36$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $044ea197e08add36$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($044ea197e08add36$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $044ea197e08add36$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $044ea197e08add36$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $044ea197e08add36$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $044ea197e08add36$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($044ea197e08add36$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($044ea197e08add36$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($044ea197e08add36$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $044ea197e08add36$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $044ea197e08add36$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $044ea197e08add36$var$createTransitionManager();
    function setState(nextState) {
        (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $044ea197e08add36$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $044ea197e08add36$export$90c043f1c57770b8(entry, undefined, createKey()) : $044ea197e08add36$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $044ea197e08add36$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $044ea197e08add36$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $044ea197e08add36$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $044ea197e08add36$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $b6d8e1f555b75306$exports = {};
var $066b0f5d1bbcfbb9$exports = {};
$066b0f5d1bbcfbb9$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $b6d8e1f555b75306$exports = $b6d8e1f555b75306$var$pathToRegexp;
$b6d8e1f555b75306$exports.parse = $b6d8e1f555b75306$var$parse;
$b6d8e1f555b75306$exports.compile = $b6d8e1f555b75306$var$compile;
$b6d8e1f555b75306$exports.tokensToFunction = $b6d8e1f555b75306$var$tokensToFunction;
$b6d8e1f555b75306$exports.tokensToRegExp = $b6d8e1f555b75306$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $b6d8e1f555b75306$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $b6d8e1f555b75306$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $b6d8e1f555b75306$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $b6d8e1f555b75306$var$escapeGroup(pattern) : asterisk ? '.*' : $b6d8e1f555b75306$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $b6d8e1f555b75306$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $b6d8e1f555b75306$var$escapeString(delimiter) + ']+?';
    return $b6d8e1f555b75306$var$escapeString(prevText) + '|(?:(?!' + $b6d8e1f555b75306$var$escapeString(prevText) + ')[^' + $b6d8e1f555b75306$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $b6d8e1f555b75306$var$compile(str, options) {
    return $b6d8e1f555b75306$var$tokensToFunction($b6d8e1f555b75306$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $b6d8e1f555b75306$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $b6d8e1f555b75306$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $b6d8e1f555b75306$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $b6d8e1f555b75306$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $b6d8e1f555b75306$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($066b0f5d1bbcfbb9$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $b6d8e1f555b75306$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $b6d8e1f555b75306$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $b6d8e1f555b75306$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $b6d8e1f555b75306$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $b6d8e1f555b75306$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $b6d8e1f555b75306$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $b6d8e1f555b75306$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $b6d8e1f555b75306$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($b6d8e1f555b75306$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $b6d8e1f555b75306$var$flags(options));
    return $b6d8e1f555b75306$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $b6d8e1f555b75306$var$stringToRegexp(path, keys, options) {
    return $b6d8e1f555b75306$var$tokensToRegExp($b6d8e1f555b75306$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $b6d8e1f555b75306$var$tokensToRegExp(tokens, keys, options) {
    if (!$066b0f5d1bbcfbb9$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $b6d8e1f555b75306$var$escapeString(token);
        else {
            var prefix = $b6d8e1f555b75306$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $b6d8e1f555b75306$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $b6d8e1f555b75306$var$attachKeys(new RegExp('^' + route, $b6d8e1f555b75306$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $b6d8e1f555b75306$var$pathToRegexp(path, keys, options) {
    if (!$066b0f5d1bbcfbb9$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $b6d8e1f555b75306$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($066b0f5d1bbcfbb9$exports(path)) return $b6d8e1f555b75306$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $b6d8e1f555b75306$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}





var $caf14a9745a003dc$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $caf14a9745a003dc$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $caf14a9745a003dc$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $caf14a9745a003dc$var$commonjsGlobal[key] = ($caf14a9745a003dc$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $caf14a9745a003dc$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $caf14a9745a003dc$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $caf14a9745a003dc$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $caf14a9745a003dc$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $caf14a9745a003dc$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $d6dc968cc2ff4ccc$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $caf14a9745a003dc$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($caf14a9745a003dc$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $caf14a9745a003dc$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $d6dc968cc2ff4ccc$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $caf14a9745a003dc$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $caf14a9745a003dc$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $caf14a9745a003dc$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $caf14a9745a003dc$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createContext || $caf14a9745a003dc$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $caf14a9745a003dc$var$createNamedContext = function createNamedContext(name) {
    var context = $caf14a9745a003dc$var$createContext();
    context.displayName = name;
    return context;
};
var $caf14a9745a003dc$export$c213558b66925821 = /*#__PURE__*/ $caf14a9745a003dc$var$createNamedContext("Router-History");
var $caf14a9745a003dc$export$63baa8ccbe60bb07 = /*#__PURE__*/ $caf14a9745a003dc$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $caf14a9745a003dc$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $d6dc968cc2ff4ccc$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($caf14a9745a003dc$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($caf14a9745a003dc$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $caf14a9745a003dc$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $d6dc968cc2ff4ccc$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $044ea197e08add36$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($caf14a9745a003dc$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Component);
var $caf14a9745a003dc$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $d6dc968cc2ff4ccc$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $caf14a9745a003dc$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($caf14a9745a003dc$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $c862936c9f17acdc$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($caf14a9745a003dc$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $caf14a9745a003dc$var$messageType;
var $caf14a9745a003dc$var$cache = {};
var $caf14a9745a003dc$var$cacheLimit = 10000;
var $caf14a9745a003dc$var$cacheCount = 0;
function $caf14a9745a003dc$var$compilePath(path) {
    if ($caf14a9745a003dc$var$cache[path]) return $caf14a9745a003dc$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($b6d8e1f555b75306$exports))).compile(path);
    if ($caf14a9745a003dc$var$cacheCount < $caf14a9745a003dc$var$cacheLimit) {
        $caf14a9745a003dc$var$cache[path] = generator;
        $caf14a9745a003dc$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $caf14a9745a003dc$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $caf14a9745a003dc$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $caf14a9745a003dc$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($caf14a9745a003dc$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $c862936c9f17acdc$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $044ea197e08add36$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $caf14a9745a003dc$export$82476f982757e71e(to, computedMatch.params) : (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, to, {
            pathname: $caf14a9745a003dc$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($caf14a9745a003dc$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $044ea197e08add36$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $044ea197e08add36$export$c3e8bb440bd55b18)(prevLocation, (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $caf14a9745a003dc$var$cache$1 = {};
var $caf14a9745a003dc$var$cacheLimit$1 = 10000;
var $caf14a9745a003dc$var$cacheCount$1 = 0;
function $caf14a9745a003dc$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $caf14a9745a003dc$var$cache$1[cacheKey] || ($caf14a9745a003dc$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($b6d8e1f555b75306$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($caf14a9745a003dc$var$cacheCount$1 < $caf14a9745a003dc$var$cacheLimit$1) {
        pathCache[path] = result;
        $caf14a9745a003dc$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $caf14a9745a003dc$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $caf14a9745a003dc$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $caf14a9745a003dc$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Children.count(children) === 0;
}
function $caf14a9745a003dc$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $caf14a9745a003dc$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $d6dc968cc2ff4ccc$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($caf14a9745a003dc$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $c862936c9f17acdc$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $caf14a9745a003dc$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $caf14a9745a003dc$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($caf14a9745a003dc$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Component);
function $caf14a9745a003dc$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $caf14a9745a003dc$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, location, {
        pathname: $caf14a9745a003dc$var$addLeadingSlash(basename) + location.pathname
    });
}
function $caf14a9745a003dc$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $caf14a9745a003dc$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $caf14a9745a003dc$var$createURL(location) {
    return typeof location === "string" ? location : (0, $044ea197e08add36$export$fe53371bee54353d)(location);
}
function $caf14a9745a003dc$var$staticHandler(methodName) {
    return function() {
        (0, $c862936c9f17acdc$export$2e2bcd8739ae039)(false);
    };
}
function $caf14a9745a003dc$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $caf14a9745a003dc$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $d6dc968cc2ff4ccc$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $caf14a9745a003dc$var$noop;
        };
        _this.handleBlock = function() {
            return $caf14a9745a003dc$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $caf14a9745a003dc$var$addBasename(basename, (0, $044ea197e08add36$export$90c043f1c57770b8)(location));
        context.url = $caf14a9745a003dc$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $4b23e67a53a2b954$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $caf14a9745a003dc$var$addLeadingSlash(basename + $caf14a9745a003dc$var$createURL(path));
            },
            action: "POP",
            location: $caf14a9745a003dc$var$stripBasename(basename, (0, $044ea197e08add36$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $caf14a9745a003dc$var$staticHandler("go"),
            goBack: $caf14a9745a003dc$var$staticHandler("goBack"),
            goForward: $caf14a9745a003dc$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($caf14a9745a003dc$export$55185c17a0fcbe46, (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $caf14a9745a003dc$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $d6dc968cc2ff4ccc$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($caf14a9745a003dc$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $c862936c9f17acdc$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $caf14a9745a003dc$export$81336c211d5ff295(location.pathname, (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $caf14a9745a003dc$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $4b23e67a53a2b954$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($caf14a9745a003dc$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $c862936c9f17acdc$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(Component, (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($25cb7246cfccd3af$exports)))(C, Component);
}
var $caf14a9745a003dc$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).useContext;
function $caf14a9745a003dc$export$3420e1dc2c4a518c() {
    return $caf14a9745a003dc$var$useContext($caf14a9745a003dc$export$c213558b66925821);
}
function $caf14a9745a003dc$export$45d76561a5302f2b() {
    return $caf14a9745a003dc$var$useContext($caf14a9745a003dc$export$63baa8ccbe60bb07).location;
}
function $caf14a9745a003dc$export$99eaa27ddbbb95ef() {
    var match = $caf14a9745a003dc$var$useContext($caf14a9745a003dc$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $caf14a9745a003dc$export$632be4bb944c1bc7(path) {
    var location = $caf14a9745a003dc$export$45d76561a5302f2b();
    var match = $caf14a9745a003dc$var$useContext($caf14a9745a003dc$export$63baa8ccbe60bb07).match;
    return path ? $caf14a9745a003dc$export$81336c211d5ff295(location.pathname, path) : match;
}
var $caf14a9745a003dc$var$global$1, $caf14a9745a003dc$var$key, $caf14a9745a003dc$var$buildNames, $caf14a9745a003dc$var$initialBuildName, $caf14a9745a003dc$var$secondaryBuildName;




var $h4Bez = parcelRequire("h4Bez");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $194709df1d74eb82$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $d6dc968cc2ff4ccc$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $044ea197e08add36$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement((0, $caf14a9745a003dc$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $194709df1d74eb82$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $d6dc968cc2ff4ccc$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $044ea197e08add36$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement((0, $caf14a9745a003dc$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Component);
var $194709df1d74eb82$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $194709df1d74eb82$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $044ea197e08add36$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $194709df1d74eb82$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $194709df1d74eb82$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).forwardRef;
if (typeof $194709df1d74eb82$var$forwardRef === "undefined") $194709df1d74eb82$var$forwardRef = $194709df1d74eb82$var$forwardRefShim;
function $194709df1d74eb82$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $194709df1d74eb82$var$LinkAnchor = $194709df1d74eb82$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $4b23e67a53a2b954$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$194709df1d74eb82$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($194709df1d74eb82$var$forwardRefShim !== $194709df1d74eb82$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $194709df1d74eb82$export$a6c7ac8248d6e38a = $194709df1d74eb82$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $194709df1d74eb82$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $4b23e67a53a2b954$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement((0, $caf14a9745a003dc$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $c862936c9f17acdc$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $194709df1d74eb82$var$normalizeToLocation($194709df1d74eb82$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $194709df1d74eb82$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $044ea197e08add36$export$fe53371bee54353d)(context.location) === (0, $044ea197e08add36$export$fe53371bee54353d)($194709df1d74eb82$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($194709df1d74eb82$var$forwardRefShim !== $194709df1d74eb82$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(component, props);
    });
});
var $194709df1d74eb82$var$toType, $194709df1d74eb82$var$refType;
var $194709df1d74eb82$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $194709df1d74eb82$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).forwardRef;
if (typeof $194709df1d74eb82$var$forwardRef$1 === "undefined") $194709df1d74eb82$var$forwardRef$1 = $194709df1d74eb82$var$forwardRefShim$1;
function $194709df1d74eb82$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $194709df1d74eb82$export$b0d92dbee9b5b60d = $194709df1d74eb82$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $4b23e67a53a2b954$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement((0, $caf14a9745a003dc$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $c862936c9f17acdc$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $194709df1d74eb82$var$normalizeToLocation($194709df1d74eb82$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $caf14a9745a003dc$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $194709df1d74eb82$var$joinClassnames(className, activeClassName);
            style = (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($194709df1d74eb82$var$forwardRefShim$1 !== $194709df1d74eb82$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($194709df1d74eb82$export$a6c7ac8248d6e38a, props);
    });
});
var $194709df1d74eb82$var$ariaCurrentType;



var $h4Bez = parcelRequire("h4Bez");




'use client';
const $1944c28923ef9414$var$isDynamicSupport = typeof (0, $9fc46070fdf093c8$export$db53682eef82cc11)({}) === 'function';
const $1944c28923ef9414$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%',
        // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
        ...enableColorScheme && !theme.vars && {
            colorScheme: theme.palette.mode
        }
    });
const $1944c28923ef9414$export$32180ef41b15b513 = (theme)=>({
        color: (theme.vars || theme).palette.text.primary,
        ...theme.typography.body1,
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $1944c28923ef9414$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes && typeof theme.getColorSchemeSelector === 'function') Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        colorSchemeStyles[selector] = {
            ':root': {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        colorSchemeStyles[selector.replace(/\s*&/, '')] = {
            colorScheme: scheme.palette?.mode
        };
    });
    let defaultStyles = {
        html: $1944c28923ef9414$export$c0bb0b647f701bb5(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: {
            margin: 0,
            // Remove the margin in all browsers.
            ...$1944c28923ef9414$export$32180ef41b15b513(theme),
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        },
        ...colorSchemeStyles
    };
    const themeOverrides = theme.components?.MuiCssBaseline?.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
// `ecs` stands for enableColorScheme. This is internal logic to make it work with Pigment CSS, so shorter is better.
const $1944c28923ef9414$var$SELECTOR = 'mui-ecs';
const $1944c28923ef9414$var$staticStyles = (theme)=>{
    const result = $1944c28923ef9414$export$9dd6ff9ea0189349(theme, false);
    const baseStyles = Array.isArray(result) ? result[0] : result;
    if (!theme.vars && baseStyles) baseStyles.html[`:root:has(${$1944c28923ef9414$var$SELECTOR})`] = {
        colorScheme: theme.palette.mode
    };
    if (theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        baseStyles[selector] = {
            [`:root:not(:has(.${$1944c28923ef9414$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        baseStyles[selector.replace(/\s*&/, '')] = {
            [`&:not(:has(.${$1944c28923ef9414$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
    });
    return result;
};
const $1944c28923ef9414$var$GlobalStyles = (0, $9fc46070fdf093c8$export$db53682eef82cc11)($1944c28923ef9414$var$isDynamicSupport ? ({ theme: theme, enableColorScheme: enableColorScheme })=>$1944c28923ef9414$export$9dd6ff9ea0189349(theme, enableColorScheme) : ({ theme: theme })=>$1944c28923ef9414$var$staticStyles(theme));
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $1944c28923ef9414$var$CssBaseline(inProps) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($h4Bez.Fragment, {
        children: [
            $1944c28923ef9414$var$isDynamicSupport && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1944c28923ef9414$var$GlobalStyles, {
                enableColorScheme: enableColorScheme
            }),
            !$1944c28923ef9414$var$isDynamicSupport && !enableColorScheme && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
                className: $1944c28923ef9414$var$SELECTOR,
                style: {
                    display: 'none'
                }
            }),
            children
        ]
    });
}
var $1944c28923ef9414$export$2e2bcd8739ae039 = $1944c28923ef9414$var$CssBaseline;






var $h4Bez = parcelRequire("h4Bez");



"use client";
var $7c31c359ca9de8e7$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z"
}), 'ArrowDownward');






var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");










'use client';
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $538d4bbadaa2ab59$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $aec1308c8f28d758$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $2552d8bac41e7610$export$2e2bcd8739ae039)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $4fa58c431bc87919$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $d66d448a6f54282f$export$2e2bcd8739ae039)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $538d4bbadaa2ab59$export$2e2bcd8739ae039 = $538d4bbadaa2ab59$var$useSlotProps;



var $h4Bez = parcelRequire("h4Bez");






var $4463e0a5aae00ff8$export$2e2bcd8739ae039 = (0, $861cc607c015e86b$export$2e2bcd8739ae039);




'use client';
var $d5e2631a7db85235$export$2e2bcd8739ae039 = (0, $01a3a2b63fe8dafe$export$2e2bcd8739ae039);




'use client';
function $98b4295fa0499900$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $98b4295fa0499900$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $98b4295fa0499900$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $98b4295fa0499900$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$98b4295fa0499900$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $98b4295fa0499900$var$MenuList = /*#__PURE__*/ $h4Bez.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu', ...other } = props;
    const listRef = $h4Bez.useRef(null);
    const textCriteriaRef = $h4Bez.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $d5e2631a7db85235$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $h4Bez.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $4463e0a5aae00ff8$export$2e2bcd8739ae039)((0, $eb0aab3eb5dc2a90$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $0af2c8a204f06237$export$2e2bcd8739ae039)((0, $4fa343ae2434ad28$export$2e2bcd8739ae039)(list));
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $98b4295fa0499900$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $98b4295fa0499900$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $98b4295fa0499900$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $98b4295fa0499900$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $98b4295fa0499900$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $98b4295fa0499900$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $98b4295fa0499900$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $98b4295fa0499900$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $98b4295fa0499900$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $98b4295fa0499900$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $98b4295fa0499900$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $6fa00ac7fde563d8$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $h4Bez.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $h4Bez.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $h4Bez.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $h4Bez.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e38cb871010a9357$export$2e2bcd8739ae039), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $98b4295fa0499900$export$2e2bcd8739ae039 = $98b4295fa0499900$var$MenuList;








function $c1444d162238d4f2$export$2cf86a63a84fe23d(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiMenu', slot);
}
const $c1444d162238d4f2$var$menuClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $c1444d162238d4f2$export$2e2bcd8739ae039 = $c1444d162238d4f2$var$menuClasses;




'use client';
const $1949838101ccf179$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $1949838101ccf179$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $1949838101ccf179$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $c1444d162238d4f2$export$2cf86a63a84fe23d), classes);
};
const $1949838101ccf179$var$MenuRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $63ee27f962173109$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $19087586f17e5d57$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root'
})({});
const $1949838101ccf179$export$4f7c51a5920c9f33 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $63ee27f962173109$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper'
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $1949838101ccf179$var$MenuMenuList = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $98b4295fa0499900$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List'
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $1949838101ccf179$var$Menu = /*#__PURE__*/ $h4Bez.forwardRef(function Menu(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $c12c19e2bf4d75c0$export$b2dd014b6c321cb)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $1949838101ccf179$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $h4Bez.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $h4Bez.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $h4Bez.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('paper', {
        className: classes.paper,
        elementType: $1949838101ccf179$export$4f7c51a5920c9f33,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('list', {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.list, MenuListProps.className),
        elementType: $1949838101ccf179$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1949838101ccf179$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $1949838101ccf179$var$RTL_ORIGIN : $1949838101ccf179$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var $1949838101ccf179$export$2e2bcd8739ae039 = $1949838101ccf179$var$Menu;


var $h4Bez = parcelRequire("h4Bez");













function $ba2853110145d5d6$export$46f01d01378ec5a2(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiDivider', slot);
}
const $ba2853110145d5d6$var$dividerClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $ba2853110145d5d6$export$2e2bcd8739ae039 = $ba2853110145d5d6$var$dividerClasses;




function $d01f67d02e170158$export$81478e24460c57f2(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiListItemIcon', slot);
}
const $d01f67d02e170158$var$listItemIconClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $d01f67d02e170158$export$2e2bcd8739ae039 = $d01f67d02e170158$var$listItemIconClasses;




function $a7195a7c6f38083f$export$1061006a0db3aeb5(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiListItemText', slot);
}
const $a7195a7c6f38083f$var$listItemTextClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $a7195a7c6f38083f$export$2e2bcd8739ae039 = $a7195a7c6f38083f$var$listItemTextClasses;




'use client';
const $b7bd066558465dcb$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $b7bd066558465dcb$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $0a3c88125d2562b8$export$515f8c67b5305377), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $b7bd066558465dcb$var$MenuItemRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d02728b6fe958b24$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $19087586f17e5d57$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $b7bd066558465dcb$export$4334bb34c76fef24
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $0a3c88125d2562b8$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            [`&.${(0, $0a3c88125d2562b8$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
            }
        },
        [`&.${(0, $0a3c88125d2562b8$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $0a3c88125d2562b8$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $0a3c88125d2562b8$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $ba2853110145d5d6$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $ba2853110145d5d6$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $a7195a7c6f38083f$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $a7195a7c6f38083f$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $d01f67d02e170158$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${(0, $d01f67d02e170158$export$2e2bcd8739ae039).root} svg`]: {
                        fontSize: '1.25rem'
                    }
                }
            }
        ]
    })));
const $b7bd066558465dcb$var$MenuItem = /*#__PURE__*/ $h4Bez.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className, ...other } = props;
    const context = $h4Bez.useContext((0, $4be71481ffac437a$export$2e2bcd8739ae039));
    const childContext = $h4Bez.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $h4Bez.useRef(null);
    (0, $d5e2631a7db85235$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $b7bd066558465dcb$var$useUtilityClasses(props);
    const handleRef = (0, $6fa00ac7fde563d8$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4be71481ffac437a$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b7bd066558465dcb$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
            className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var $b7bd066558465dcb$export$2e2bcd8739ae039 = $b7bd066558465dcb$var$MenuItem;





/** `700`, as on the toolbar's `dangerOutline` Delete: `600` falls below AA contrast on the hovered item's grey background. The icon inherits it */ const $a3b9a942eeea294b$var$destructiveItemStyle = {
    color: 'error.700'
};
const $a3b9a942eeea294b$var$ACTIVATION_KEYS = [
    'Enter',
    ' '
];
/**
 * Lives inside clickable containers such as table rows, which open on click and Enter, and React events
 * bubble through the menu's portal - so those stop here instead of also activating the container
 */ const $a3b9a942eeea294b$var$stopPropagation = (e)=>e.stopPropagation();
const $a3b9a942eeea294b$var$stopActivationKeyPropagation = (e)=>{
    if ($a3b9a942eeea294b$var$ACTIVATION_KEYS.includes(e.key)) e.stopPropagation();
};
const $a3b9a942eeea294b$export$ed57a210b9d13bb6 = ({ label: label, items: items, ...props })=>{
    const buttonRef = (0, $h4Bez.useRef)(null);
    const [open, setOpen] = (0, $h4Bez.useState)(false);
    const triggerId = (0, $h4Bez.useId)();
    const menuId = (0, $h4Bez.useId)();
    const testId = (0, $3dd52092ec4fc8cb$export$eea0c9f46a8cc3f9)(props) || 'action-menu';
    const select = (item)=>{
        /** A disabled item blocks the pointer through its style only, so a click dispatched to it still arrives */ if (item.disabled) return;
        setOpen(false);
        item.onClick();
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
                ref: buttonRef,
                id: triggerId,
                "data-testid": `${testId}-button`,
                variant: "ghost",
                size: "medium",
                "aria-label": label,
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? menuId : undefined,
                onClick: (e)=>{
                    e.stopPropagation();
                    setOpen(true);
                },
                onKeyDown: $a3b9a942eeea294b$var$stopActivationKeyPropagation,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $eae940bbacb73299$export$b459ff73c06b67ec), {})
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1949838101ccf179$export$2e2bcd8739ae039), {
                "data-testid": `${testId}-menu`,
                anchorEl: buttonRef.current,
                open: open,
                onClose: ()=>setOpen(false),
                onClick: $a3b9a942eeea294b$var$stopPropagation,
                onKeyDown: $a3b9a942eeea294b$var$stopActivationKeyPropagation,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                slotProps: {
                    list: {
                        id: menuId,
                        'aria-labelledby': triggerId
                    }
                },
                children: items.map((item)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $b7bd066558465dcb$export$2e2bcd8739ae039), {
                        "data-testid": `${testId}-item-${item.key}`,
                        sx: item.destructive ? $a3b9a942eeea294b$var$destructiveItemStyle : undefined,
                        disabled: item.disabled,
                        onClick: ()=>select(item),
                        children: [
                            item.icon && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(item.icon, {}),
                            item.label
                        ]
                    }, item.key))
            })
        ]
    });
};



parcelRequire("h4Bez");



const $39d0bead0a2e8d87$var$defaultIcons = {
    empty: (0, $4f94c67c9a03ae7a$export$69f2027e16370dfe),
    error: (0, $4d0c3371e4bf5696$export$794f4e1bebe11db5)
};
const $39d0bead0a2e8d87$var$colors = {
    empty: 'grey.600',
    error: 'error.main'
};
const $39d0bead0a2e8d87$var$titleColors = {
    empty: 'grey.900',
    error: 'error.main'
};
const $39d0bead0a2e8d87$var$wrapperStyle = {
    alignItems: 'center',
    justifyContent: 'center',
    gap: 3,
    py: 10,
    px: 6,
    textAlign: 'center'
};
const $39d0bead0a2e8d87$var$messageStyle = {
    alignItems: 'center',
    gap: 3
};
const $39d0bead0a2e8d87$var$descriptionStyle = {
    maxWidth: 360,
    color: 'grey.600'
};
const $39d0bead0a2e8d87$var$actionsStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: 2,
    mt: 2
};
const $39d0bead0a2e8d87$export$f69219e9125094cf = ({ variant: variant = 'empty', icon: Icon = $39d0bead0a2e8d87$var$defaultIcons[variant], title: title, actions: actions, children: children, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
        sx: [
            $39d0bead0a2e8d87$var$wrapperStyle,
            {
                color: $39d0bead0a2e8d87$var$colors[variant]
            }
        ],
        "data-testid": (0, $3dd52092ec4fc8cb$export$eea0c9f46a8cc3f9)(props) || `state-block-${variant}`,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Icon, {
                fontSize: "medium"
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
                sx: $39d0bead0a2e8d87$var$messageStyle,
                role: variant === 'error' ? 'alert' : undefined,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        variant: "body2",
                        component: "p",
                        fontWeight: 600,
                        color: $39d0bead0a2e8d87$var$titleColors[variant],
                        children: title
                    }),
                    children && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        variant: "body2",
                        component: "div",
                        sx: $39d0bead0a2e8d87$var$descriptionStyle,
                        children: children
                    })
                ]
            }),
            actions && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $39d0bead0a2e8d87$var$actionsStyle,
                children: actions
            })
        ]
    });



parcelRequire("h4Bez");


const $617663da3bdf6296$var$baseValues = {
    b: (0, $4772774eee62bdcc$export$582aafb958f7fe50),
    br: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("br", {})
};
const $617663da3bdf6296$var$truncatedTextStyle = {
    textOverflow: 'ellipsis',
    overflowX: 'hidden',
    whiteSpace: 'nowrap'
};
const $617663da3bdf6296$var$Base = ({ id: id, values: values, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: id,
            values: {
                ...values,
                ...$617663da3bdf6296$var$baseValues
            }
        })
    });
const $617663da3bdf6296$export$f99233281efd08a0 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($617663da3bdf6296$var$Base, {
        variant: "subtitle1",
        ...props
    });
const $617663da3bdf6296$export$2661e2422bcf54ba = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($617663da3bdf6296$var$Base, {
        variant: "body2",
        ...props
    });
const $617663da3bdf6296$export$20b3b2f62cca41 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($617663da3bdf6296$var$Base, {
        variant: "body1",
        ...props
    });
const $617663da3bdf6296$export$32fbfacc5d962e0c = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($617663da3bdf6296$var$Base, {
        variant: "caption",
        ...props
    });
const $617663da3bdf6296$var$outputTextLeftToRight = (output)=>{
    return `\u2066${output}\u2069`;
};
const $617663da3bdf6296$export$f51edccf37a41a2a = ({ children: children, sx: sx, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        component: "span",
        dir: "rtl",
        sx: {
            ...$617663da3bdf6296$var$truncatedTextStyle,
            ...sx
        },
        ...props,
        children: $617663da3bdf6296$var$outputTextLeftToRight(children)
    });
const $617663da3bdf6296$var$hyphenStyle = {
    color: 'grey.600'
};
const $617663da3bdf6296$export$3eec49f24c546686 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
        component: "span",
        variant: "inherit",
        sx: $617663da3bdf6296$var$hyphenStyle,
        children: "\u2014"
    });




var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");















function $59e8a804d60491d9$export$5162da8f798e0959(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiCollapse', slot);
}
const $59e8a804d60491d9$var$collapseClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $59e8a804d60491d9$export$2e2bcd8739ae039 = $59e8a804d60491d9$var$collapseClasses;



'use client';
const $7830414f6fe32da6$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $59e8a804d60491d9$export$5162da8f798e0959), classes);
};
const $7830414f6fe32da6$var$CollapseRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height'),
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'auto',
                    width: 0,
                    transition: theme.transitions.create('width')
                }
            },
            {
                props: {
                    state: 'entered'
                },
                style: {
                    height: 'auto',
                    overflow: 'visible'
                }
            },
            {
                props: {
                    state: 'entered',
                    orientation: 'horizontal'
                },
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px',
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $7830414f6fe32da6$var$CollapseWrapper = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper'
})({
    // Hack to get children with a negative margin to not falsify the height computation.
    display: 'flex',
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
const $7830414f6fe32da6$var$CollapseWrapperInner = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner'
})({
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $7830414f6fe32da6$var$Collapse = /*#__PURE__*/ $h4Bez.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', slots: slots = {}, slotProps: slotProps = {}, style: style, timeout: timeout = (0, $9e70812d00b733f4$export$1f34108aa9eb96ab).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $fee6626576e0ac90$export$2e2bcd8739ae039), ...other } = props;
    const ownerState = {
        ...props,
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    };
    const classes = $7830414f6fe32da6$var$useUtilityClasses(ownerState);
    const theme = (0, $cd99783e1cac2d84$export$2e2bcd8739ae039)();
    const timer = (0, $4497065fec36f675$export$2e2bcd8739ae039)();
    const wrapperRef = $h4Bez.useRef(null);
    const autoTransitionDuration = $h4Bez.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $h4Bez.useRef(null);
    const handleRef = (0, $6fa00ac7fde563d8$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $93e522fc190a5b9f$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $93e522fc190a5b9f$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps,
        component: component
    };
    const [RootSlot, rootSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('root', {
        ref: handleRef,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $7830414f6fe32da6$var$CollapseRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: {
                [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize,
                ...style
            }
        }
    });
    const [WrapperSlot, wrapperSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('wrapper', {
        ref: wrapperRef,
        className: classes.wrapper,
        elementType: $7830414f6fe32da6$var$CollapseWrapper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [WrapperInnerSlot, wrapperInnerSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('wrapperInner', {
        className: classes.wrapperInner,
        elementType: $7830414f6fe32da6$var$CollapseWrapperInner,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(TransitionComponent, {
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: incomingOwnerState, ...restChildProps })=>{
            const stateOwnerState = {
                ...ownerState,
                state: state
            };
            return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(RootSlot, {
                ...rootSlotProps,
                className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(rootSlotProps.className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                ownerState: stateOwnerState,
                ...restChildProps,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(WrapperSlot, {
                    ...wrapperSlotProps,
                    ownerState: stateOwnerState,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(WrapperInnerSlot, {
                        ...wrapperInnerSlotProps,
                        ownerState: stateOwnerState,
                        children: children
                    })
                })
            });
        }
    });
});
if ($7830414f6fe32da6$var$Collapse) $7830414f6fe32da6$var$Collapse.muiSupportAuto = true;
var $7830414f6fe32da6$export$2e2bcd8739ae039 = $7830414f6fe32da6$var$Collapse;


var $h4Bez = parcelRequire("h4Bez");








'use client';
const $9f72024c38d1931c$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $ba2853110145d5d6$export$46f01d01378ec5a2), classes);
};
const $9f72024c38d1931c$var$DividerRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.alpha((theme.vars || theme).palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const $9f72024c38d1931c$var$DividerWrapper = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $9f72024c38d1931c$var$Divider = /*#__PURE__*/ $h4Bez.forwardRef(function Divider(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = 'horizontal', component: component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth', ...other } = props;
    const ownerState = {
        ...props,
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    };
    const classes = $9f72024c38d1931c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($9f72024c38d1931c$var$DividerRoot, {
        as: component,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($9f72024c38d1931c$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if ($9f72024c38d1931c$var$Divider) $9f72024c38d1931c$var$Divider.muiSkipListHighlight = true;
var $9f72024c38d1931c$export$2e2bcd8739ae039 = $9f72024c38d1931c$var$Divider;





const $be3703687194c6e0$var$headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    my: 4
};
const $be3703687194c6e0$var$headerTyleStyle = {
    /**
     * Due to the flex-box parent,
     * using traditional white-space approach proved too difficult,
     * so this approach was used
     */ display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    overflowY: 'hidden',
    wordBreak: 'break-all'
};
const $be3703687194c6e0$var$actionStyle = {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
};
const $be3703687194c6e0$var$Title = ({ title: title, appendix: appendix, actions: actions })=>{
    const [id, values] = (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(title) ? title : [
        title,
        {}
    ];
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $be3703687194c6e0$var$headerStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                "data-testid": "details-header-title",
                sx: $be3703687194c6e0$var$headerTyleStyle,
                variant: "h4",
                component: "h4",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: id,
                        values: values
                    }),
                    Boolean(appendix) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
                                children: ': '
                            }),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
                                children: appendix
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $be3703687194c6e0$var$actionStyle,
                children: actions
            })
        ]
    });
};
const $be3703687194c6e0$var$infoWrapperStyle = {
    my: 4
};
const $be3703687194c6e0$var$infoTitleStyle = {
    display: 'flex',
    mb: 4,
    color: 'grey.600',
    cursor: 'pointer'
};
const $be3703687194c6e0$var$infoIconStyle = {
    mr: 2,
    width: 20,
    height: 20,
    mt: 0.4
};
const $be3703687194c6e0$var$infoBodyStyle = {
    color: 'grey.600',
    maxWidth: 600,
    fontSize: 'body2.fontSize',
    my: 4
};
const $be3703687194c6e0$var$formatting = {
    b: (0, $4772774eee62bdcc$export$582aafb958f7fe50),
    br: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("br", {})
};
const $be3703687194c6e0$var$Description = ({ translations: [summary, body] })=>{
    const [opened, setOpen] = (0, $h4Bez.useState)(false);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $be3703687194c6e0$var$infoWrapperStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                "data-testid": "info-title",
                sx: $be3703687194c6e0$var$infoTitleStyle,
                onClick: ()=>setOpen(!opened),
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c29ab90985853eda$export$fa82770841cc54a0), {
                        sx: $be3703687194c6e0$var$infoIconStyle
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: summary
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7830414f6fe32da6$export$2e2bcd8739ae039), {
                in: opened,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    "data-testid": "info-body",
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                            sx: $be3703687194c6e0$var$infoBodyStyle,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: body,
                                values: $be3703687194c6e0$var$formatting
                            })
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {})
                    ]
                })
            })
        ]
    });
};
const $be3703687194c6e0$export$56e2352e63353d99 = ({ title: title, titleAppendix: titleAppendix, titleActions: titleActions, description: description })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($be3703687194c6e0$var$Title, {
                title: title,
                appendix: titleAppendix,
                actions: titleActions
            }),
            (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(description) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($be3703687194c6e0$var$Description, {
                translations: description
            })
        ]
    });






parcelRequire("h4Bez");


var $h4Bez = parcelRequire("h4Bez");





'use client';
var $b9233f9112215cb5$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');













'use client';
const $5c72e4be84329d1d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            `${variant}${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`
        ],
        label: [
            'label',
            `label${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`,
            `avatarColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`,
            `iconColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`,
            `deleteIconColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            `deleteIcon${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(variant)}Color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $4e58bfa35037c63d$export$31444911e4ee6fdd), classes);
};
const $5c72e4be84329d1d$var$ChipRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`]
            },
            {
                [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(iconColor)}`]
            },
            {
                [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`]
            },
            {
                [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(variant)}Color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`]
            },
            styles.root,
            styles[`size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`],
            styles[`color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return {
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        lineHeight: 1.5,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 5,
            marginRight: -6
        },
        [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).deleteIcon}`]: {
            WebkitTapHighlightColor: 'transparent',
            color: theme.alpha((theme.vars || theme).palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.alpha((theme.vars || theme).palette.text.primary, 0.4)
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    height: 24,
                    [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).icon}`]: {
                        fontSize: 18,
                        marginLeft: 4,
                        marginRight: -4
                    },
                    [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).deleteIcon}`]: {
                        fontSize: 16,
                        marginRight: 4,
                        marginLeft: -4
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)([
                'contrastText'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText,
                        [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).deleteIcon}`]: {
                            color: theme.alpha((theme.vars || theme).palette[color].contrastText, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].contrastText
                            }
                        }
                    }
                };
            }),
            {
                props: (props)=>props.iconColor === props.color,
                style: {
                    [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).icon}`]: {
                        color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
                    }
                }
            },
            {
                props: (props)=>props.iconColor === props.color && props.color !== 'default',
                style: {
                    [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).icon}`]: {
                        color: 'inherit'
                    }
                }
            },
            {
                props: {
                    onDelete: true
                },
                style: {
                    [`&.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color,
                        onDelete: true
                    },
                    style: {
                        [`&.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).focusVisible}`]: {
                            background: (theme.vars || theme).palette[color].dark
                        }
                    }
                };
            }),
            {
                props: {
                    clickable: true
                },
                style: {
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`)
                    },
                    [`&.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[1]
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        color: color,
                        clickable: true
                    },
                    style: {
                        [`&:hover, &.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).focusVisible}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                })),
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    backgroundColor: 'transparent',
                    border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
                    [`&.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).clickable}:hover`]: {
                        backgroundColor: (theme.vars || theme).palette.action.hover
                    },
                    [`&.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: (theme.vars || theme).palette.action.focus
                    },
                    [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).avatar}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).avatarSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).icon}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).iconSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).deleteIcon}`]: {
                        marginRight: 5
                    },
                    [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).deleteIconSmall}`]: {
                        marginRight: 3
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()) // no need to check for mainChannel as it's calculated from main
            .map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        border: `1px solid ${theme.alpha((theme.vars || theme).palette[color].main, 0.7)}`,
                        [`&.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).clickable}:hover`]: {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        },
                        [`&.${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).focusVisible}`]: {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.focusOpacity)
                        },
                        [`& .${(0, $4e58bfa35037c63d$export$2e2bcd8739ae039).deleteIcon}`]: {
                            color: theme.alpha((theme.vars || theme).palette[color].main, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    };
}));
const $5c72e4be84329d1d$var$ChipLabel = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`]
        ];
    }
})({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: 'nowrap',
    variants: [
        {
            props: {
                variant: 'outlined'
            },
            style: {
                paddingLeft: 11,
                paddingRight: 11
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                size: 'small',
                variant: 'outlined'
            },
            style: {
                paddingLeft: 7,
                paddingRight: 7
            }
        }
    ]
});
function $5c72e4be84329d1d$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $5c72e4be84329d1d$var$Chip = /*#__PURE__*/ $h4Bez.forwardRef(function Chip(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false, slots: // TODO v6: Rename to `focusableWhenDisabled`.
    slots = {}, slotProps: slotProps = {}, ...other } = props;
    const chipRef = $h4Bez.useRef(null);
    const handleRef = (0, $6fa00ac7fde563d8$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $5c72e4be84329d1d$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $5c72e4be84329d1d$var$isDeleteKeyboardEvent(event)) onDelete(event);
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $d02728b6fe958b24$export$2e2bcd8739ae039) : ComponentProp || 'div';
    const ownerState = {
        ...props,
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $h4Bez.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    };
    const classes = $5c72e4be84329d1d$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $d02728b6fe958b24$export$2e2bcd8739ae039) ? {
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible,
        ...onDelete && {
            disableRipple: true
        }
    } : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $h4Bez.isValidElement(deleteIconProp) ? /*#__PURE__*/ $h4Bez.cloneElement(deleteIconProp, {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b9233f9112215cb5$export$2e2bcd8739ae039), {
        className: classes.deleteIcon,
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $h4Bez.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $h4Bez.cloneElement(avatarProp, {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $h4Bez.isValidElement(iconProp)) icon = /*#__PURE__*/ $h4Bez.cloneElement(iconProp, {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.icon, iconProp.props.className)
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('root', {
        elementType: $5c72e4be84329d1d$var$ChipRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        // The `component` prop is preserved because `Chip` relies on it for internal logic. If `shouldForwardComponentProp` were `false`, `useSlot` would remove the `component` prop, potentially breaking the component's behavior.
        shouldForwardComponentProp: true,
        ref: handleRef,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        additionalProps: {
            disabled: clickable && disabled ? true : undefined,
            tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
            ...moreProps
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onClick: (event)=>{
                    handlers.onClick?.(event);
                    onClick?.(event);
                },
                onKeyDown: (event)=>{
                    handlers.onKeyDown?.(event);
                    handleKeyDown(event);
                },
                onKeyUp: (event)=>{
                    handlers.onKeyUp?.(event);
                    handleKeyUp(event);
                }
            })
    });
    const [LabelSlot, labelProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('label', {
        elementType: $5c72e4be84329d1d$var$ChipLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.label
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)(RootSlot, {
        as: component,
        ...rootProps,
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(LabelSlot, {
                ...labelProps,
                children: label
            }),
            deleteIcon
        ]
    });
});
var $5c72e4be84329d1d$export$2e2bcd8739ae039 = $5c72e4be84329d1d$var$Chip;


const $e2c1c86842962ae2$export$5a7f9a6004988d01 = (0, $5c72e4be84329d1d$export$2e2bcd8739ae039);



parcelRequire("h4Bez");

const $544912f84b2ee288$var$DEFAULT_DOT_SIZE = 6;
const $544912f84b2ee288$var$dotStyle = (size, tone)=>({
        flex: 'none',
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: tone ? `${tone}.500` : 'currentColor'
    });
const $544912f84b2ee288$export$eaa9dcd62e0d5ec6 = ({ className: className, size: size = $544912f84b2ee288$var$DEFAULT_DOT_SIZE, tone: tone })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        component: "span",
        className: className,
        sx: $544912f84b2ee288$var$dotStyle(size, tone)
    });




const $cb95d5d6a1876bbb$var$mapTranslationParameters = (status)=>[
        (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS_LABEL,
        {
            status: status
        }
    ];
const $cb95d5d6a1876bbb$export$dde6f3ba8f2fdee = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return (status)=>translator.formatTranslation(...$cb95d5d6a1876bbb$var$mapTranslationParameters(status));
};


const $b38816d2b66de72f$var$variants = {
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).DEAD]: 'danger',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISCONNECTED]: 'danger',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).EXITED]: 'danger',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).INVALID]: 'danger',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).OFFLINE]: 'danger',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).UNAVAILABLE]: 'danger',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).UNEXPECTED]: 'danger',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).UNREACHABLE]: 'danger',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).CONNECTING]: 'warning',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).DEVIATED]: 'warning',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISABLING]: 'warning',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISCONNECTING]: 'warning',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLING]: 'warning',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).RECONNECTING]: 'warning',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).REENABLING]: 'warning',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).RESTARTING]: 'warning',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).ROLLING_BACK]: 'warning',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).STARTING]: 'warning',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).STOPPING]: 'warning',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).UPDATING]: 'warning',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).ACTIVE]: 'success',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).AVAILABLE]: 'success',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).CONNECTED]: 'success',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLED]: 'success',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).NO_DEVIATION]: 'success',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).ONLINE]: 'success',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).REACHABLE]: 'success',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).RUNNING]: 'success',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).VALID]: 'success',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).CREATED]: 'grey',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISABLED]: 'grey',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).INACTIVE]: 'grey',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).NOT_ENABLED]: 'grey',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).PAUSED]: 'grey',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).TERMINATED]: 'grey',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).UNKNOWN]: 'grey',
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).WAITING]: 'grey'
};
const $b38816d2b66de72f$var$Status = ({ status: status, ...props })=>{
    const translateStatus = (0, $cb95d5d6a1876bbb$export$dde6f3ba8f2fdee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e2c1c86842962ae2$export$5a7f9a6004988d01), {
        ...props,
        variant: $b38816d2b66de72f$var$variants[status],
        size: "medium",
        icon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $544912f84b2ee288$export$eaa9dcd62e0d5ec6), {}),
        label: translateStatus(status)
    });
};
var $b38816d2b66de72f$export$2e2bcd8739ae039 = $b38816d2b66de72f$var$Status;







parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");




var $h4Bez = parcelRequire("h4Bez");
'use client';
/**
 * @ignore - internal component.
 */ const $07add90c307cf79e$var$TableContext = /*#__PURE__*/ $h4Bez.createContext();
var $07add90c307cf79e$export$2e2bcd8739ae039 = $07add90c307cf79e$var$TableContext;







function $1b820a705e600d75$export$315cb19215f77ce0(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiTable', slot);
}
const $1b820a705e600d75$var$tableClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $1b820a705e600d75$export$2e2bcd8739ae039 = $1b820a705e600d75$var$tableClasses;



'use client';
const $556c9cdfdbb1f7f2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $1b820a705e600d75$export$315cb19215f77ce0), classes);
};
const $556c9cdfdbb1f7f2$var$TableRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': {
            ...theme.typography.body2,
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    borderCollapse: 'separate'
                }
            }
        ]
    })));
const $556c9cdfdbb1f7f2$var$defaultComponent = 'table';
const $556c9cdfdbb1f7f2$var$Table = /*#__PURE__*/ $h4Bez.forwardRef(function Table(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $556c9cdfdbb1f7f2$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    };
    const classes = $556c9cdfdbb1f7f2$var$useUtilityClasses(ownerState);
    const table = $h4Bez.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $07add90c307cf79e$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($556c9cdfdbb1f7f2$var$TableRoot, {
            as: component,
            role: component === $556c9cdfdbb1f7f2$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
            ownerState: ownerState,
            ...other
        })
    });
});
var $556c9cdfdbb1f7f2$export$2e2bcd8739ae039 = $556c9cdfdbb1f7f2$var$Table;


var $h4Bez = parcelRequire("h4Bez");




var $h4Bez = parcelRequire("h4Bez");
'use client';
/**
 * @ignore - internal component.
 */ const $506bb8e6c9c3cb58$var$Tablelvl2Context = /*#__PURE__*/ $h4Bez.createContext();
var $506bb8e6c9c3cb58$export$2e2bcd8739ae039 = $506bb8e6c9c3cb58$var$Tablelvl2Context;






function $c4f498a7b670321b$export$98bd2a9b566ec665(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiTableBody', slot);
}
const $c4f498a7b670321b$var$tableBodyClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiTableBody', [
    'root'
]);
var $c4f498a7b670321b$export$2e2bcd8739ae039 = $c4f498a7b670321b$var$tableBodyClasses;



'use client';
const $5584ae6c05089f22$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $c4f498a7b670321b$export$98bd2a9b566ec665), classes);
};
const $5584ae6c05089f22$var$TableBodyRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root'
})({
    display: 'table-row-group'
});
const $5584ae6c05089f22$var$tablelvl2 = {
    variant: 'body'
};
const $5584ae6c05089f22$var$defaultComponent = 'tbody';
const $5584ae6c05089f22$var$TableBody = /*#__PURE__*/ $h4Bez.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $5584ae6c05089f22$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $5584ae6c05089f22$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $506bb8e6c9c3cb58$export$2e2bcd8739ae039).Provider, {
        value: $5584ae6c05089f22$var$tablelvl2,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($5584ae6c05089f22$var$TableBodyRoot, {
            className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $5584ae6c05089f22$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var $5584ae6c05089f22$export$2e2bcd8739ae039 = $5584ae6c05089f22$var$TableBody;


var $h4Bez = parcelRequire("h4Bez");







function $c11abe0edbf350cc$export$eed427986a7abdf9(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiTableContainer', slot);
}
const $c11abe0edbf350cc$var$tableContainerClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiTableContainer', [
    'root'
]);
var $c11abe0edbf350cc$export$2e2bcd8739ae039 = $c11abe0edbf350cc$var$tableContainerClasses;



'use client';
const $e5ad0c1c6afb18b6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $c11abe0edbf350cc$export$eed427986a7abdf9), classes);
};
const $e5ad0c1c6afb18b6$var$TableContainerRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiTableContainer',
    slot: 'Root'
})({
    width: '100%',
    overflowX: 'auto'
});
const $e5ad0c1c6afb18b6$var$TableContainer = /*#__PURE__*/ $h4Bez.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $e5ad0c1c6afb18b6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($e5ad0c1c6afb18b6$var$TableContainerRoot, {
        ref: ref,
        as: component,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ...other
    });
});
var $e5ad0c1c6afb18b6$export$2e2bcd8739ae039 = $e5ad0c1c6afb18b6$var$TableContainer;





parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");











'use client';
const $96e1a88505b6a102$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(align)}`,
            padding !== 'normal' && `padding${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(padding)}`,
            `size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $823e90498c56952a$export$33a0f07a16a10b1b), classes);
};
const $96e1a88505b6a102$var$TableCellRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body2,
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? theme.lighten(theme.alpha(theme.palette.divider, 1), 0.88) : theme.darken(theme.alpha(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16,
        variants: [
            {
                props: {
                    variant: 'head'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary,
                    lineHeight: theme.typography.pxToRem(24),
                    fontWeight: theme.typography.fontWeightMedium
                }
            },
            {
                props: {
                    variant: 'body'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            },
            {
                props: {
                    variant: 'footer'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    lineHeight: theme.typography.pxToRem(21),
                    fontSize: theme.typography.pxToRem(12)
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '6px 16px',
                    [`&.${(0, $823e90498c56952a$export$2e2bcd8739ae039).paddingCheckbox}`]: {
                        width: 24,
                        // prevent the checkbox column from growing
                        padding: '0 12px 0 16px',
                        '& > *': {
                            padding: 0
                        }
                    }
                }
            },
            {
                props: {
                    padding: 'checkbox'
                },
                style: {
                    width: 48,
                    // prevent the checkbox column from growing
                    padding: '0 0 0 4px'
                }
            },
            {
                props: {
                    padding: 'none'
                },
                style: {
                    padding: 0
                }
            },
            {
                props: {
                    align: 'left'
                },
                style: {
                    textAlign: 'left'
                }
            },
            {
                props: {
                    align: 'center'
                },
                style: {
                    textAlign: 'center'
                }
            },
            {
                props: {
                    align: 'right'
                },
                style: {
                    textAlign: 'right',
                    flexDirection: 'row-reverse'
                }
            },
            {
                props: {
                    align: 'justify'
                },
                style: {
                    textAlign: 'justify'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: (theme.vars || theme).palette.background.default
                }
            }
        ]
    })));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $96e1a88505b6a102$var$TableCell = /*#__PURE__*/ $h4Bez.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp, ...other } = props;
    const table = $h4Bez.useContext((0, $07add90c307cf79e$export$2e2bcd8739ae039));
    const tablelvl2 = $h4Bez.useContext((0, $506bb8e6c9c3cb58$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = {
        ...props,
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    };
    const classes = $96e1a88505b6a102$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($96e1a88505b6a102$var$TableCellRoot, {
        as: component,
        ref: ref,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState,
        ...other
    });
});
var $96e1a88505b6a102$export$2e2bcd8739ae039 = $96e1a88505b6a102$var$TableCell;


var $h4Bez = parcelRequire("h4Bez");









'use client';
const $f771ba0376b3fe85$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $2fb9c2cc5ba0457d$export$ba0a6d6c28940107), classes);
};
const $f771ba0376b3fe85$var$TableRowRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $2fb9c2cc5ba0457d$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $2fb9c2cc5ba0457d$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`)
            }
        }
    })));
const $f771ba0376b3fe85$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $f771ba0376b3fe85$var$TableRow = /*#__PURE__*/ $h4Bez.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $f771ba0376b3fe85$var$defaultComponent, hover: hover = false, selected: selected = false, ...other } = props;
    const tablelvl2 = $h4Bez.useContext((0, $506bb8e6c9c3cb58$export$2e2bcd8739ae039));
    const ownerState = {
        ...props,
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    };
    const classes = $f771ba0376b3fe85$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($f771ba0376b3fe85$var$TableRowRoot, {
        as: component,
        ref: ref,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        role: component === $f771ba0376b3fe85$var$defaultComponent ? null : 'row',
        ownerState: ownerState,
        ...other
    });
});
var $f771ba0376b3fe85$export$2e2bcd8739ae039 = $f771ba0376b3fe85$var$TableRow;







var $h4Bez = parcelRequire("h4Bez");



/**
 * This state provides internal usage of the props passed to the Table component
 */ const $365b0b4d68ac9bb9$var$PropsState = (0, $08b3e6ee09ecfd12$export$e50ad042342a539d)({
    ignorePropsChanges: false
});
const $365b0b4d68ac9bb9$var$useProp = $365b0b4d68ac9bb9$var$PropsState.useExtendedState;
const $365b0b4d68ac9bb9$var$usePropDispatcher = $365b0b4d68ac9bb9$var$PropsState.useExtendedStateDispatcher;
const $365b0b4d68ac9bb9$var$selectSearch = ({ search: search })=>typeof search !== 'boolean' && search || '';
const $365b0b4d68ac9bb9$var$selectSearchThreshold = ({ searchThreshold: searchThreshold })=>searchThreshold ?? 0;
/** A search shorter than the threshold isn't applied: the rows stay unfiltered */ const $365b0b4d68ac9bb9$var$selectAppliedSearch = (s)=>{
    const search = $365b0b4d68ac9bb9$var$selectSearch(s);
    return search.length < $365b0b4d68ac9bb9$var$selectSearchThreshold(s) ? '' : search;
};
const $365b0b4d68ac9bb9$var$selectPageSizeOptions = ({ pagination: pagination })=>pagination?.pageSizeOptions ?? null;
const $365b0b4d68ac9bb9$var$selectPageSize = (s)=>s.pagination?.pageSize ?? $365b0b4d68ac9bb9$var$selectPageSizeOptions(s)?.[0] ?? null;
const $365b0b4d68ac9bb9$var$selectPage = (s)=>s.pagination?.page ?? 0;
const $365b0b4d68ac9bb9$var$selectSortOrder = (s)=>s.sortOrder ?? null;
const $365b0b4d68ac9bb9$var$selectSelection = (s)=>s.selection;
const $365b0b4d68ac9bb9$var$selectHasSelection = (s)=>Boolean($365b0b4d68ac9bb9$var$selectSelection(s));
/** The row actions and the column view menu share it */ const $365b0b4d68ac9bb9$var$selectHasTrailingColumn = (s)=>$365b0b4d68ac9bb9$var$selectHasSelection(s) || Boolean(s.onColumnViewChange);
/** The rendered columns, in the column view's order and without its hidden columns, if any */ const $365b0b4d68ac9bb9$var$selectColumnNames = ({ columns: columns, columnView: columnView })=>{
    const names = (0, $2ae70427bab197d4$export$ed97f33186d4b816)(columns);
    return columnView ? (0, $2ac73d5fe610e8da$export$1b6de485b4f669da)(names, columnView) : names;
};
const $365b0b4d68ac9bb9$var$selectRequiredProperty = (s, selector, name)=>{
    const property = selector(s);
    (0, $14eddac5f20c576c$export$a7a9523472993e97)(property, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Property is not setup', {
        name: name
    }));
    return property;
};
const $365b0b4d68ac9bb9$var$selectRequiredSelection = (s)=>$365b0b4d68ac9bb9$var$selectRequiredProperty(s, $365b0b4d68ac9bb9$var$selectSelection, 'selection');
const $365b0b4d68ac9bb9$var$selectRequiredPagination = (s)=>$365b0b4d68ac9bb9$var$selectRequiredProperty(s, (s)=>s.pagination, 'pagination');
/**
 * By default we sort the data on FE
 * Unless we explicitly tell not to sort for the tables where data comes from BE presorted
 */ const $365b0b4d68ac9bb9$var$selectIsSortData = ({ sortData: sortData })=>sortData ?? true;
const $365b0b4d68ac9bb9$var$AuxState = (0, $08b3e6ee09ecfd12$export$e50ad042342a539d)({
    ignorePropsChanges: true
});
const $365b0b4d68ac9bb9$var$useAux = $365b0b4d68ac9bb9$var$AuxState.useExtendedState;
const $365b0b4d68ac9bb9$var$useAuxDispatcher = $365b0b4d68ac9bb9$var$AuxState.useExtendedStateDispatcher;
const $365b0b4d68ac9bb9$var$selectSelectedIds = (s)=>s.selectedIds;
class $365b0b4d68ac9bb9$var$VisibleDataMapper {
    static #_ = this.directionMap = {
        asc: 1,
        desc: -1
    };
    static search(value, normalizedTerms) {
        return (0, $d54af89b52a0b804$export$d76128d007d19019)((0, $1e2b62fb1507b421$export$a3295358bff77e)(String(value)), normalizedTerms);
    }
    constructor(props){
        this.props = props;
    }
    mapFiller() {
        const { data: data, pagination: pagination } = this.props;
        /** Offset filler for external pagination */ return pagination && typeof pagination.totalCount === 'number' && typeof pagination.pageSize === 'number' && typeof pagination.page === 'number' && (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(data) ? Array(pagination.page * pagination.pageSize).fill(data[0]) : [];
    }
    getFilteredData() {
        const { data: data, columns: columns } = this.props;
        const search = $365b0b4d68ac9bb9$var$selectAppliedSearch(this.props);
        const filler = this.mapFiller();
        if (!search) return [
            ...filler,
            ...data
        ];
        const normalizedTerms = (0, $1e2b62fb1507b421$export$a3295358bff77e)(search).trim().split(/\s+/);
        return [
            ...filler,
            ...data.filter((row)=>(0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(columns).some(([name])=>$365b0b4d68ac9bb9$var$VisibleDataMapper.search(row[name], normalizedTerms)))
        ];
    }
    getSortedData() {
        const data = this.getFilteredData();
        const sortOrder = $365b0b4d68ac9bb9$var$selectSortOrder(this.props);
        const { columns: columns } = this.props;
        if (!sortOrder) return data;
        const configuredSorter = columns[sortOrder.name]?.sort;
        const sortValueExtractor = typeof configuredSorter === 'function' ? configuredSorter : (v)=>String(v ?? '');
        return data.sort((a, b)=>{
            const { name: name, direction: direction } = sortOrder;
            const compA = sortValueExtractor(a[name]);
            const compB = sortValueExtractor(b[name]);
            if (compA === compB) return 0;
            return $365b0b4d68ac9bb9$var$VisibleDataMapper.directionMap[direction] * (compA < compB ? -1 : 1);
        });
    }
    map() {
        const data = $365b0b4d68ac9bb9$var$selectIsSortData(this.props) ? this.getSortedData() : this.getFilteredData();
        const pageSize = $365b0b4d68ac9bb9$var$selectPageSize(this.props);
        const page = $365b0b4d68ac9bb9$var$selectPage(this.props);
        return typeof pageSize === 'number' ? data.slice(page * pageSize, page * pageSize + pageSize) : data;
    }
}
const $365b0b4d68ac9bb9$var$VisibleDataUpdater = ()=>{
    const visibleData = $365b0b4d68ac9bb9$var$useProp((s)=>new $365b0b4d68ac9bb9$var$VisibleDataMapper(s).map(), (a, b)=>(0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(a, b, {
            sort: false
        }));
    const dispatch = $365b0b4d68ac9bb9$var$useAuxDispatcher();
    (0, $h4Bez.useEffect)(()=>dispatch({
            visibleData: visibleData
        }), [
        visibleData
    ]);
    return null;
};
const $365b0b4d68ac9bb9$export$4e02b9968dad1f = ({ value: value, children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($365b0b4d68ac9bb9$var$PropsState.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($365b0b4d68ac9bb9$var$AuxState.Provider, {
            value: {
                selectedIds: [],
                visibleData: [],
                resizing: null
            },
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($365b0b4d68ac9bb9$var$VisibleDataUpdater, {}),
                children
            ]
        })
    });
const $365b0b4d68ac9bb9$export$15313dbeba21e0cd = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>{
        if (s.error) return 'error';
        if (!s.loading) return 'rows';
        return (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(new $365b0b4d68ac9bb9$var$VisibleDataMapper(s).map()) ? 'reloading' : 'skeleton';
    });
const $365b0b4d68ac9bb9$export$a7fa9df522e0d0db = ()=>$365b0b4d68ac9bb9$export$15313dbeba21e0cd() === 'rows';
const $365b0b4d68ac9bb9$export$5027865de34f9ec6 = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>s.error ?? null);
const $365b0b4d68ac9bb9$export$30dc190df7e420c4 = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>s.height);
const $365b0b4d68ac9bb9$export$77e1d8b85595b1b2 = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>{
        const pageSize = $365b0b4d68ac9bb9$var$selectPageSize(s);
        if (pageSize === null) return Infinity;
        const rowCount = s.pagination?.totalCount ?? s.data.length;
        return Math.ceil(rowCount / pageSize);
    });
const $365b0b4d68ac9bb9$export$973ca22476b0e05f = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>s.filters);
const $365b0b4d68ac9bb9$export$64bb4c8f3f725dd0 = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>s.utilities);
const $365b0b4d68ac9bb9$export$a6cc3d417b945bb7 = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>Boolean(s.pagination?.hideJumpToPage));
const $365b0b4d68ac9bb9$export$b8a95f23b06f15f3 = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>Boolean(s.pagination?.showTotalCount));
const $365b0b4d68ac9bb9$export$9c745eae7a46cfdb = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>s.onDownloadCSV);
const $365b0b4d68ac9bb9$export$db30c675496008e0 = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>s.onRowClick ?? null);
const $365b0b4d68ac9bb9$export$d76d5f6ada6e0635 = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>s.onRowOpenInNewTab ?? null);
const $365b0b4d68ac9bb9$export$7630f92e7d8440de = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>s.rowRef ?? null);
const $365b0b4d68ac9bb9$export$d0a86e60c44d2654 = (row)=>$365b0b4d68ac9bb9$var$useProp((s)=>s.isRowActive?.(row) ?? false, [
        row
    ]);
const $365b0b4d68ac9bb9$export$4fcd4d06ac62e583 = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>s.search !== false);
const $365b0b4d68ac9bb9$export$2be88e8ec3fb8bbd = ()=>$365b0b4d68ac9bb9$var$useProp($365b0b4d68ac9bb9$var$selectSearchThreshold);
const $365b0b4d68ac9bb9$export$2766bc1f66000a0b = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>{
        const length = $365b0b4d68ac9bb9$var$selectSearch(s).length;
        return length > 0 ? Math.max($365b0b4d68ac9bb9$var$selectSearchThreshold(s) - length, 0) : 0;
    });
const $365b0b4d68ac9bb9$export$bd221a7c56b93941 = ()=>$365b0b4d68ac9bb9$var$useProp($365b0b4d68ac9bb9$var$selectSearch);
const $365b0b4d68ac9bb9$export$bf79ea3e2bede58c = ()=>$365b0b4d68ac9bb9$var$useProp($365b0b4d68ac9bb9$var$selectAppliedSearch);
const $365b0b4d68ac9bb9$export$e13a77e1f84cc73b = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>s.translations) ?? {};
const $365b0b4d68ac9bb9$export$ee823454c92c1f0c = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>!('hideHeader' in s && s.hideHeader));
const $365b0b4d68ac9bb9$export$962ffaf51b485576 = ()=>$365b0b4d68ac9bb9$var$useProp($365b0b4d68ac9bb9$var$selectSortOrder);
const $365b0b4d68ac9bb9$export$dbeaeea714145b36 = ()=>$365b0b4d68ac9bb9$var$useProp($365b0b4d68ac9bb9$var$selectHasSelection);
const $365b0b4d68ac9bb9$export$68419e81990e3a75 = ()=>$365b0b4d68ac9bb9$var$useProp($365b0b4d68ac9bb9$var$selectHasTrailingColumn);
const $365b0b4d68ac9bb9$export$b17375fa3d9f6db1 = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>Number($365b0b4d68ac9bb9$var$selectHasSelection(s)) + $365b0b4d68ac9bb9$var$selectColumnNames(s).length + Number($365b0b4d68ac9bb9$var$selectHasTrailingColumn(s)));
const $365b0b4d68ac9bb9$export$8dc4d8418d8568f5 = ()=>$365b0b4d68ac9bb9$var$useProp($365b0b4d68ac9bb9$var$selectPageSize);
const $365b0b4d68ac9bb9$export$178e57c9fecff4cc = ()=>$365b0b4d68ac9bb9$var$useProp($365b0b4d68ac9bb9$var$selectPage);
const $365b0b4d68ac9bb9$export$ec11ebe036e44ff6 = ()=>$365b0b4d68ac9bb9$var$useProp($365b0b4d68ac9bb9$var$selectPageSizeOptions);
const $365b0b4d68ac9bb9$export$8b715ac3f253d94f = ()=>$365b0b4d68ac9bb9$var$useProp($365b0b4d68ac9bb9$var$selectColumnNames, (a, b)=>(0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(a, b, {
            sort: false
        }));
const $365b0b4d68ac9bb9$export$edd9cd4ea59a06e0 = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>(0, $2ae70427bab197d4$export$ed97f33186d4b816)(s.columns), (a, b)=>(0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(a, b, {
            sort: false
        }));
const $365b0b4d68ac9bb9$export$c97dded465ef56fb = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>s.columns);
const $365b0b4d68ac9bb9$export$ddca39529720c1e7 = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>s.columnView ?? (0, $2ac73d5fe610e8da$export$638aea850a86a555));
const $365b0b4d68ac9bb9$export$d7e6be191e8598da = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>s.onColumnViewChange);
const $365b0b4d68ac9bb9$export$e904f852b627a2bb = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>Boolean(s.onColumnViewChange));
const $365b0b4d68ac9bb9$export$ba0a914f5e13434b = (name)=>$365b0b4d68ac9bb9$export$c97dded465ef56fb()[name];
const $365b0b4d68ac9bb9$export$7c9c226b640ed210 = ()=>$365b0b4d68ac9bb9$var$useAux((s)=>s.visibleData);
const $365b0b4d68ac9bb9$export$21bdbb26575478ef = ()=>{
    const bodyState = $365b0b4d68ac9bb9$export$15313dbeba21e0cd();
    const visibleRows = $365b0b4d68ac9bb9$export$7c9c226b640ed210();
    return (bodyState === 'rows' || bodyState === 'reloading') && (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(visibleRows);
};
const $365b0b4d68ac9bb9$export$f46934223cd71381 = ()=>$365b0b4d68ac9bb9$var$useAux((s)=>s.resizing);
const $365b0b4d68ac9bb9$export$f4617cd8c1cea916 = ()=>{
    const dispatch = $365b0b4d68ac9bb9$var$useAuxDispatcher();
    return (resizing)=>dispatch({
            resizing: resizing
        });
};
const $365b0b4d68ac9bb9$var$useSelectionIdField = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>$365b0b4d68ac9bb9$var$selectSelection(s)?.idField ?? null);
const $365b0b4d68ac9bb9$var$useSelectedRows = (mapper, nonSelected)=>{
    const visibleRows = $365b0b4d68ac9bb9$export$7c9c226b640ed210();
    const idField = $365b0b4d68ac9bb9$var$useSelectionIdField();
    const selectedIds = $365b0b4d68ac9bb9$var$useAux($365b0b4d68ac9bb9$var$selectSelectedIds);
    if (!selectedIds.length || !idField) return nonSelected;
    const selected = new Set(selectedIds);
    return mapper(visibleRows, (line)=>selected.has(line[idField]));
};
const $365b0b4d68ac9bb9$export$37c02c2c66380263 = ()=>$365b0b4d68ac9bb9$var$useSelectedRows((rows, isSelected)=>rows.filter(isSelected), []);
const $365b0b4d68ac9bb9$export$1c9b7756eccadc96 = ()=>{
    const idField = $365b0b4d68ac9bb9$var$useSelectionIdField();
    const selected = $365b0b4d68ac9bb9$export$37c02c2c66380263();
    return idField === null ? [] : selected.map((line)=>String(line[idField]));
};
const $365b0b4d68ac9bb9$export$b7ea63286f69ae91 = ()=>$365b0b4d68ac9bb9$var$useSelectedRows((rows, isSelected)=>rows.some(isSelected), false);
const $365b0b4d68ac9bb9$export$459a847cde06c169 = ()=>$365b0b4d68ac9bb9$var$useProp($365b0b4d68ac9bb9$var$selectRequiredSelection);
const $365b0b4d68ac9bb9$export$a97c3cc4bf1da1ca = (row)=>{
    const idField = $365b0b4d68ac9bb9$var$useSelectionIdField();
    const selectedIds = $365b0b4d68ac9bb9$var$useAux($365b0b4d68ac9bb9$var$selectSelectedIds);
    const dispatch = $365b0b4d68ac9bb9$var$useAuxDispatcher();
    if (!idField) return [
        null,
        undefined
    ];
    const id = row[idField];
    const index = selectedIds.indexOf(id);
    const selected = index >= 0;
    return [
        selected,
        ()=>dispatch({
                /**
                 * Either exclude current entry or append it
                 */ selectedIds: selected ? [
                    ...selectedIds.slice(0, index),
                    ...selectedIds.slice(index + 1)
                ] : [
                    ...selectedIds,
                    id
                ]
            })
    ];
};
const $365b0b4d68ac9bb9$export$2802d569b9a7f906 = ()=>{
    const idField = $365b0b4d68ac9bb9$var$useSelectionIdField();
    const visible = $365b0b4d68ac9bb9$export$7c9c226b640ed210();
    const selectedIds = $365b0b4d68ac9bb9$var$useAux($365b0b4d68ac9bb9$var$selectSelectedIds);
    const dispatch = $365b0b4d68ac9bb9$var$useAuxDispatcher();
    if (idField === null) return [
        null,
        undefined
    ];
    const actuallySelected = [];
    const allIds = [];
    const idsLeft = new Set(selectedIds);
    visible.forEach((row)=>{
        const id = row[idField];
        if (idsLeft.delete(id)) actuallySelected.push(id);
        allIds.push(id);
    });
    return [
        {
            all: visible.length > 0 && actuallySelected.length === visible.length,
            onlySome: (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(actuallySelected) && actuallySelected.length < visible.length
        },
        ()=>dispatch({
                /**
                 * Either exclude current entry or append it
                 */ selectedIds: (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(actuallySelected) ? [] : allIds
            })
    ];
};
const $365b0b4d68ac9bb9$export$d2838f462516652 = ()=>{
    const dispatch = $365b0b4d68ac9bb9$var$useAuxDispatcher();
    return ()=>dispatch({
            selectedIds: []
        });
};
/**
 * This utility function allows for the creation of hooks that
 * - Signal the onCustomized function
 * - Update the props
 */ const $365b0b4d68ac9bb9$var$createDispatcherHookWithCustomization = (/** Mapper to extract current value from the props */ mapCurrentValue, /** Map new input, perhaps merging it with current props, into the updated props */ mapChangedState, /** Convert the value into a customized state so it can be passed to onCustomized */ mapCustomization)=>()=>{
        const onCustomized = $365b0b4d68ac9bb9$var$useProp((s)=>s.onCustomized);
        const dispatch = $365b0b4d68ac9bb9$var$usePropDispatcher();
        const currentValue = $365b0b4d68ac9bb9$var$useProp(mapCurrentValue);
        return (updatedValue)=>{
            if (currentValue === updatedValue) return;
            dispatch((props)=>mapChangedState(updatedValue, props));
            if (onCustomized) onCustomized(mapCustomization(updatedValue));
        };
    };
const $365b0b4d68ac9bb9$export$7768d9cbb1ba6f45 = $365b0b4d68ac9bb9$var$createDispatcherHookWithCustomization($365b0b4d68ac9bb9$var$selectSearch, (search)=>({
        search: search
    }), (search)=>({
        search: search
    }));
const $365b0b4d68ac9bb9$export$25aba3f9e4b4587 = $365b0b4d68ac9bb9$var$createDispatcherHookWithCustomization($365b0b4d68ac9bb9$var$selectSortOrder, (sortOrder)=>({
        sortOrder: sortOrder
    }), (sortOrder)=>({
        sortOrder: sortOrder
    }));
const $365b0b4d68ac9bb9$export$4d0dbe999816fb14 = $365b0b4d68ac9bb9$var$createDispatcherHookWithCustomization($365b0b4d68ac9bb9$var$selectPageSize, (pageSize, s)=>({
        pagination: {
            ...$365b0b4d68ac9bb9$var$selectRequiredPagination(s),
            pageSize: pageSize
        }
    }), (pageSize)=>({
        pageSize: pageSize
    }));
const $365b0b4d68ac9bb9$export$34b36a046567f2ef = $365b0b4d68ac9bb9$var$createDispatcherHookWithCustomization($365b0b4d68ac9bb9$var$selectPage, (page, s)=>({
        pagination: {
            ...$365b0b4d68ac9bb9$var$selectRequiredPagination(s),
            page: page
        }
    }), (page)=>({
        page: page
    }));
const $365b0b4d68ac9bb9$export$4af6cc58a9a6c026 = ()=>$365b0b4d68ac9bb9$var$useProp((s)=>s.pagination?.totalCount) || null;


const $9f5cd22834412711$var$bodyMessageCellStyle = {
    px: 3,
    py: 6
};
const $9f5cd22834412711$export$5c76b8ecf2a0ec3b = {
    p: 0
};
const $9f5cd22834412711$export$cb26bcc37361661c = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const search = (0, $365b0b4d68ac9bb9$export$bf79ea3e2bede58c)();
    const colSpan = (0, $365b0b4d68ac9bb9$export$b17375fa3d9f6db1)();
    const translations = (0, $365b0b4d68ac9bb9$export$e13a77e1f84cc73b)();
    const { noResultsOrEmptyTable: noResultsOrEmptyTable = (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_RESULTS_FOUND, emptyTable: emptyTable = noResultsOrEmptyTable, noResults: noResults = noResultsOrEmptyTable } = translations;
    /** Only a table whose caller names what it lists gets the first-run block; generic "no results" texts stay a one-liner */ const showsBlock = !search && translations.emptyTable !== undefined;
    const target = search ? noResults : emptyTable;
    const content = (0, $40a99dac858c1d75$export$552cd99e43fa1085)(target) ? translator.formatTranslation(target) : target;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f771ba0376b3fe85$export$2e2bcd8739ae039), {
        "data-testid": "empty-table-body",
        children: showsBlock ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $96e1a88505b6a102$export$2e2bcd8739ae039), {
            colSpan: colSpan,
            sx: $9f5cd22834412711$export$5c76b8ecf2a0ec3b,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $39d0bead0a2e8d87$export$f69219e9125094cf), {
                title: content
            })
        }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $96e1a88505b6a102$export$2e2bcd8739ae039), {
            colSpan: colSpan,
            sx: $9f5cd22834412711$var$bodyMessageCellStyle,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "body2",
                component: "p",
                color: "grey.600",
                textAlign: "center",
                children: content
            })
        })
    });
};



parcelRequire("h4Bez");










const $566162f982754e39$export$4527cc126632fbc1 = ()=>{
    const colSpan = (0, $365b0b4d68ac9bb9$export$b17375fa3d9f6db1)();
    const tableError = (0, $365b0b4d68ac9bb9$export$5027865de34f9ec6)();
    (0, $14eddac5f20c576c$export$a7a9523472993e97)(tableError, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'The error body is rendered without an error'));
    const { error: error, onRetry: onRetry } = tableError;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f771ba0376b3fe85$export$2e2bcd8739ae039), {
        "data-testid": "error-table-body",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $96e1a88505b6a102$export$2e2bcd8739ae039), {
            colSpan: colSpan,
            sx: (0, $9f5cd22834412711$export$5c76b8ecf2a0ec3b),
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $39d0bead0a2e8d87$export$f69219e9125094cf), {
                variant: "error",
                title: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TABLE_LOAD_ERROR
                }),
                actions: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
                    children: [
                        onRetry && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                            "data-testid": "table-try-again",
                            variant: "secondary",
                            size: "medium",
                            startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ce4e3ee315615fb1$export$35f5c3e250802cd1), {}),
                            onClick: onRetry,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TRY_AGAIN
                            })
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6354af2b130548c7$export$d053ec805ce391aa), {
                            error: error
                        })
                    ]
                }),
                children: error.message
            })
        })
    });
};




var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");



function $51f4e256a7eeb494$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");
'use client';
/**
 * @ignore - internal component.
 */ const $afe0146e047a78c2$var$FormControlContext = /*#__PURE__*/ $h4Bez.createContext(undefined);
var $afe0146e047a78c2$export$2e2bcd8739ae039 = $afe0146e047a78c2$var$FormControlContext;


'use client';
function $364d4e99dd433e44$export$2e2bcd8739ae039() {
    return $h4Bez.useContext((0, $afe0146e047a78c2$export$2e2bcd8739ae039));
}



var $h4Bez = parcelRequire("h4Bez");












function $8d9730a98a6e79e3$export$f7d501e40371cd17(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiFormLabel', slot);
}
const $8d9730a98a6e79e3$var$formLabelClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $8d9730a98a6e79e3$export$2e2bcd8739ae039 = $8d9730a98a6e79e3$var$formLabelClasses;



'use client';
const $f1635ddd0790fd36$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $8d9730a98a6e79e3$export$f7d501e40371cd17), classes);
};
const $f1635ddd0790fd36$export$aa5bc7f8a4705b27 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $8d9730a98a6e79e3$export$2e2bcd8739ae039).focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${(0, $8d9730a98a6e79e3$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${(0, $8d9730a98a6e79e3$export$2e2bcd8739ae039).error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $f1635ddd0790fd36$var$AsteriskComponent = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        [`&.${(0, $8d9730a98a6e79e3$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $f1635ddd0790fd36$var$FormLabel = /*#__PURE__*/ $h4Bez.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, color: color, component: component = 'label', disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $364d4e99dd433e44$export$2e2bcd8739ae039)();
    const fcs = (0, $51f4e256a7eeb494$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $f1635ddd0790fd36$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($f1635ddd0790fd36$export$aa5bc7f8a4705b27, {
        as: component,
        ownerState: ownerState,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($f1635ddd0790fd36$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
var $f1635ddd0790fd36$export$2e2bcd8739ae039 = $f1635ddd0790fd36$var$FormLabel;









'use client';
const $401b148a65fd432a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'medium' && `size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $bec79423f6a79e81$export$c1c4b4545ad2ea5f), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $401b148a65fd432a$var$InputLabelRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $f1635ddd0790fd36$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $19087586f17e5d57$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $8d9730a98a6e79e3$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const $401b148a65fd432a$var$InputLabel = /*#__PURE__*/ $h4Bez.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $364d4e99dd433e44$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $51f4e256a7eeb494$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $401b148a65fd432a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($401b148a65fd432a$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var $401b148a65fd432a$export$2e2bcd8739ae039 = $401b148a65fd432a$var$InputLabel;


var $h4Bez = parcelRequire("h4Bez");








'use client';
var $014ef4f721c90d9b$var$_span;
const $014ef4f721c90d9b$var$NotchedOutlineRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $19087586f17e5d57$export$2e2bcd8739ae039)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $014ef4f721c90d9b$var$NotchedOutlineLegend = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $19087586f17e5d57$export$2e2bcd8739ae039)
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
function $014ef4f721c90d9b$export$2e2bcd8739ae039(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($014ef4f721c90d9b$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($014ef4f721c90d9b$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
                children: label
            }) : $014ef4f721c90d9b$var$_span || ($014ef4f721c90d9b$var$_span = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}












var $h4Bez = parcelRequire("h4Bez");







var $h4Bez = parcelRequire("h4Bez");







'use client';
function $91c807039d947138$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $91c807039d947138$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $91c807039d947138$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $91c807039d947138$var$isEmpty(obj) {
    return $91c807039d947138$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $91c807039d947138$var$TextareaAutosize = /*#__PURE__*/ $h4Bez.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $h4Bez.useRef(value != null);
    const textareaRef = $h4Bez.useRef(null);
    const handleRef = (0, $4fa58c431bc87919$export$2e2bcd8739ae039)(forwardedRef, textareaRef);
    const heightRef = $h4Bez.useRef(null);
    const hiddenTextareaRef = $h4Bez.useRef(null);
    const calculateTextareaStyles = $h4Bez.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $328f2d6822f57247$export$2e2bcd8739ae039)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $91c807039d947138$var$getStyleValue(computedStyle.paddingBottom) + $91c807039d947138$var$getStyleValue(computedStyle.paddingTop);
        const border = $91c807039d947138$var$getStyleValue(computedStyle.borderBottomWidth) + $91c807039d947138$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $91c807039d947138$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $h4Bez.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $91c807039d947138$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $h4Bez.useRef(-1);
    (0, $01a3a2b63fe8dafe$export$2e2bcd8739ae039)(()=>{
        const debouncedHandleResize = (0, $c5adc846d2f2ee36$export$2e2bcd8739ae039)(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $328f2d6822f57247$export$2e2bcd8739ae039)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $01a3a2b63fe8dafe$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        const textarea = event.target;
        const countOfCharacters = textarea.value.length;
        const isLastCharacterNewLine = textarea.value.endsWith('\n');
        const isEndOfTheLine = textarea.selectionStart === countOfCharacters;
        // Set the cursor position to the very end of the text.
        if (isLastCharacterNewLine && isEndOfTheLine) textarea.setSelectionRange(countOfCharacters, countOfCharacters);
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($h4Bez.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...$91c807039d947138$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $91c807039d947138$export$2e2bcd8739ae039 = $91c807039d947138$var$TextareaAutosize;











// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $f1145a6934ab22e0$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $f1145a6934ab22e0$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($f1145a6934ab22e0$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $f1145a6934ab22e0$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $f1145a6934ab22e0$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}




'use client';
var $5ac8c4302ca79792$var$_InputGlobalStyles;
const $5ac8c4302ca79792$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $5ac8c4302ca79792$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $5ac8c4302ca79792$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $0886a41ab9c710ef$export$ef57d5c8ca2278f6), classes);
};
const $5ac8c4302ca79792$export$298a043133d72a38 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $5ac8c4302ca79792$export$965edad20a84fa75
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $0886a41ab9c710ef$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $5ac8c4302ca79792$export$ee10465db6ff6017 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $5ac8c4302ca79792$export$cf507b112810e72d
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $0886a41ab9c710ef$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $0886a41ab9c710ef$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $5ac8c4302ca79792$var$InputGlobalStyles = (0, $9fc46070fdf093c8$export$db53682eef82cc11)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $5ac8c4302ca79792$var$InputBase = /*#__PURE__*/ $h4Bez.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $h4Bez.useRef(value != null);
    const inputRef = $h4Bez.useRef();
    const handleInputRefWarning = $h4Bez.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $6fa00ac7fde563d8$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $h4Bez.useState(false);
    const muiFormControl = (0, $364d4e99dd433e44$export$2e2bcd8739ae039)();
    const fcs = (0, $51f4e256a7eeb494$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $h4Bez.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $h4Bez.useCallback((obj)=>{
        if ((0, $f1145a6934ab22e0$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $d5e2631a7db85235$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $7052f9417b2e0e56$export$2e2bcd8739ae039)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $h4Bez.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = (0, $91c807039d947138$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $h4Bez.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $5ac8c4302ca79792$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $5ac8c4302ca79792$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $5ac8c4302ca79792$export$ee10465db6ff6017;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($h4Bez.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $5ac8c4302ca79792$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($5ac8c4302ca79792$var$_InputGlobalStyles || ($5ac8c4302ca79792$var$_InputGlobalStyles = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($5ac8c4302ca79792$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $4062a7b1f5a47416$export$2e2bcd8739ae039)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $afe0146e047a78c2$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $4062a7b1f5a47416$export$2e2bcd8739ae039)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $5ac8c4302ca79792$export$2e2bcd8739ae039 = $5ac8c4302ca79792$var$InputBase;




'use client';
const $1be879c5f72a2d8d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $8f2ed57594b78c76$export$89922944c7227687), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $1be879c5f72a2d8d$var$OutlinedInputRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $5ac8c4302ca79792$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $19087586f17e5d57$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $5ac8c4302ca79792$export$965edad20a84fa75)
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
            }
        },
        [`&.${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).focused} .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).focused} .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to override the above style
                style: {
                    [`&.${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).error} .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).disabled} .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const $1be879c5f72a2d8d$var$NotchedOutlineRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $014ef4f721c90d9b$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
    };
}));
const $1be879c5f72a2d8d$var$OutlinedInputInput = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $5ac8c4302ca79792$export$ee10465db6ff6017), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $5ac8c4302ca79792$export$cf507b112810e72d)
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $1be879c5f72a2d8d$var$OutlinedInput = /*#__PURE__*/ $h4Bez.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, slotProps: slotProps = {}, type: type = 'text', ...other } = props;
    const classes = $1be879c5f72a2d8d$var$useUtilityClasses(props);
    const muiFormControl = (0, $364d4e99dd433e44$export$2e2bcd8739ae039)();
    const fcs = (0, $51f4e256a7eeb494$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    const RootSlot = slots.root ?? components.Root ?? $1be879c5f72a2d8d$var$OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $1be879c5f72a2d8d$var$OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('notchedOutline', {
        elementType: $1be879c5f72a2d8d$var$NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($h4Bez.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5ac8c4302ca79792$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(NotchedSlot, {
                ...notchedProps,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
$1be879c5f72a2d8d$var$OutlinedInput.muiName = 'Input';
var $1be879c5f72a2d8d$export$2e2bcd8739ae039 = $1be879c5f72a2d8d$var$OutlinedInput;


var $h4Bez = parcelRequire("h4Bez");






function $15d6412a0f020be4$export$427f1c1e2e839f85(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiPagination', slot);
}
const $15d6412a0f020be4$var$paginationClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiPagination', [
    'root',
    'ul',
    'outlined',
    'text'
]);
var $15d6412a0f020be4$export$2e2bcd8739ae039 = $15d6412a0f020be4$var$paginationClasses;



var $h4Bez = parcelRequire("h4Bez");
'use client';
function $1e812888fb3f7236$export$2e2bcd8739ae039(props) {
    const { controlled: controlled, default: defaultProp, name: name, state: state = 'value' } = props;
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $h4Bez.useRef(controlled !== undefined);
    const [valueState, setValue] = $h4Bez.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $h4Bez.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    // TODO: provide overloads for the useControlled function to account for the case where either
    // controlled or default is not undefined.
    // In that case the return type should be [T, React.Dispatch<React.SetStateAction<T>>]
    // otherwise it should be [T | undefined, React.Dispatch<React.SetStateAction<T | undefined>>]
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
function $d87e70eb8df2cb93$export$2e2bcd8739ae039(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount: boundaryCount = 1, componentName: componentName = 'usePagination', count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1, ...other } = props;
    const [page, setPageState] = (0, $1e812888fb3f7236$export$2e2bcd8739ae039)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: 'page'
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length: length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    count - boundaryCount - 1);
    // Basic list of items to render
    // for example itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            'first'
        ] : [],
        ...hidePrevButton ? [] : [
            'previous'
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            'start-ellipsis'
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            'end-ellipsis'
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            'next'
        ],
        ...showLastButton ? [
            'last'
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case 'first':
                return 1;
            case 'previous':
                return page - 1;
            case 'next':
                return page + 1;
            case 'last':
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === 'number' ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: 'page',
            page: item,
            selected: item === page,
            disabled: disabled,
            'aria-current': item === page ? 'page' : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || !item.includes('ellipsis') && (item === 'next' || item === 'last' ? page >= count : page <= 1)
        };
    });
    return {
        items: items,
        ...other
    };
}



var $h4Bez = parcelRequire("h4Bez");










'use client';
var $929e97f46a507050$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');




'use client';
var $7ea49e803a8b1e9c$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');




'use client';
var $9deb0bcadf859006$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');




'use client';
var $0973d118bb8a389f$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');







'use client';
const $85ba38ba0fcc27db$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.size)}`],
        ownerState.variant === 'text' && styles[`text${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`],
        ownerState.variant === 'outlined' && styles[`outlined${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`],
        ownerState.shape === 'rounded' && styles.rounded,
        ownerState.type === 'page' && styles.page,
        (ownerState.type === 'start-ellipsis' || ownerState.type === 'end-ellipsis') && styles.ellipsis,
        (ownerState.type === 'previous' || ownerState.type === 'next') && styles.previousNext,
        (ownerState.type === 'first' || ownerState.type === 'last') && styles.firstLast
    ];
};
const $85ba38ba0fcc27db$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, selected: selected, size: size, shape: shape, type: type, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            `size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`,
            variant,
            shape,
            color !== 'standard' && `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            color !== 'standard' && `${variant}${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            selected && 'selected',
            {
                page: 'page',
                first: 'firstLast',
                last: 'firstLast',
                'start-ellipsis': 'ellipsis',
                'end-ellipsis': 'ellipsis',
                previous: 'previousNext',
                next: 'previousNext'
            }[type]
        ],
        icon: [
            'icon'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $679b3da5719098bd$export$e4ce0a775adf2f74), classes);
};
const $85ba38ba0fcc27db$var$PaginationItemEllipsis = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: $85ba38ba0fcc27db$var$overridesResolver
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body2,
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        height: 'auto',
        [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    minWidth: 26,
                    borderRadius: 13,
                    margin: '0 1px',
                    padding: '0 4px'
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    minWidth: 40,
                    borderRadius: 20,
                    padding: '0 10px',
                    fontSize: theme.typography.pxToRem(15)
                }
            }
        ]
    })));
const $85ba38ba0fcc27db$var$PaginationItemPage = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d02728b6fe958b24$export$2e2bcd8739ae039), {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: $85ba38ba0fcc27db$var$overridesResolver
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body2,
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        height: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            'color',
            'background-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            '&:hover': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
            },
            [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    minWidth: 26,
                    height: 26,
                    borderRadius: 13,
                    margin: '0 1px',
                    padding: '0 4px'
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    minWidth: 40,
                    height: 40,
                    borderRadius: 20,
                    padding: '0 10px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    shape: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                    [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).selected}`]: {
                        [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).disabled}`]: {
                            borderColor: (theme.vars || theme).palette.action.disabledBackground,
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).selected}`]: {
                        [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)([
                'dark',
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        variant: 'text',
                        color: color
                    },
                    style: {
                        [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).selected}`]: {
                            color: (theme.vars || theme).palette[color].contrastText,
                            backgroundColor: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: (theme.vars || theme).palette[color].dark,
                                // Reset on touch devices, it doesn't add specificity
                                '@media (hover: none)': {
                                    backgroundColor: (theme.vars || theme).palette[color].main
                                }
                            },
                            [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).focusVisible}`]: {
                                backgroundColor: (theme.vars || theme).palette[color].dark
                            },
                            [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).disabled}`]: {
                                color: (theme.vars || theme).palette.action.disabled
                            }
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)([
                'light'
            ])).map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color: color
                    },
                    style: {
                        [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).selected}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            border: `1px solid ${theme.alpha((theme.vars || theme).palette[color].main, 0.5)}`,
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.activatedOpacity),
                            '&:hover': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, `${(theme.vars || theme).palette.action.activatedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`),
                                // Reset on touch devices, it doesn't add specificity
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $679b3da5719098bd$export$2e2bcd8739ae039).focusVisible}`]: {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, `${(theme.vars || theme).palette.action.activatedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                            }
                        }
                    }
                }))
        ]
    })));
const $85ba38ba0fcc27db$var$PaginationItemPageIcon = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiPaginationItem',
    slot: 'Icon'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        fontSize: theme.typography.pxToRem(20),
        margin: '0 -8px',
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    fontSize: theme.typography.pxToRem(22)
                }
            }
        ]
    })));
const $85ba38ba0fcc27db$var$PaginationItem = /*#__PURE__*/ $h4Bez.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPaginationItem'
    });
    const { className: className, color: color = 'standard', component: component, components: components = {}, disabled: disabled = false, page: page, selected: selected = false, shape: shape = 'circular', size: size = 'medium', slots: slots = {}, slotProps: slotProps = {}, type: type = 'page', variant: variant = 'text', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disabled: disabled,
        selected: selected,
        shape: shape,
        size: size,
        type: type,
        variant: variant
    };
    const isRtl = (0, $c12c19e2bf4d75c0$export$b2dd014b6c321cb)();
    const classes = $85ba38ba0fcc27db$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            previous: slots.previous ?? components.previous,
            next: slots.next ?? components.next,
            first: slots.first ?? components.first,
            last: slots.last ?? components.last
        },
        slotProps: slotProps
    };
    const [PreviousSlot, previousSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('previous', {
        elementType: (0, $9deb0bcadf859006$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [NextSlot, nextSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('next', {
        elementType: (0, $0973d118bb8a389f$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FirstSlot, firstSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('first', {
        elementType: (0, $929e97f46a507050$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [LastSlot, lastSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('last', {
        elementType: (0, $7ea49e803a8b1e9c$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const rtlAwareType = isRtl ? ({
        previous: 'next',
        next: 'previous',
        first: 'last',
        last: 'first'
    })[type] : type;
    const IconSlot = {
        previous: PreviousSlot,
        next: NextSlot,
        first: FirstSlot,
        last: LastSlot
    }[rtlAwareType];
    const iconSlotProps = {
        previous: previousSlotProps,
        next: nextSlotProps,
        first: firstSlotProps,
        last: lastSlotProps
    }[rtlAwareType];
    return type === 'start-ellipsis' || type === 'end-ellipsis' ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($85ba38ba0fcc27db$var$PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($85ba38ba0fcc27db$var$PaginationItemPage, {
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ...other,
        children: [
            type === 'page' && page,
            IconSlot ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($85ba38ba0fcc27db$var$PaginationItemPageIcon, {
                ...iconSlotProps,
                className: classes.icon,
                as: IconSlot
            }) : null
        ]
    });
});
var $85ba38ba0fcc27db$export$2e2bcd8739ae039 = $85ba38ba0fcc27db$var$PaginationItem;





'use client';
const $440939d09c2fcfbc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant
        ],
        ul: [
            'ul'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $15d6412a0f020be4$export$427f1c1e2e839f85), classes);
};
const $440939d09c2fcfbc$var$PaginationRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('nav', {
    name: 'MuiPagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const $440939d09c2fcfbc$var$PaginationUl = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('ul', {
    name: 'MuiPagination',
    slot: 'Ul'
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
function $440939d09c2fcfbc$var$defaultGetAriaLabel(type, page, selected) {
    if (type === 'page') return `${selected ? '' : 'Go to '}page ${page}`;
    return `Go to ${type} page`;
}
const $440939d09c2fcfbc$var$Pagination = /*#__PURE__*/ $h4Bez.forwardRef(function Pagination(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPagination'
    });
    const { boundaryCount: boundaryCount = 1, className: className, color: color = 'standard', count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $440939d09c2fcfbc$var$defaultGetAriaLabel, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, onChange: onChange, page: page, renderItem: renderItem = (item)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $85ba38ba0fcc27db$export$2e2bcd8739ae039), {
            ...item
        }), shape: shape = 'circular', showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1, size: size = 'medium', variant: variant = 'text', ...other } = props;
    const { items: items } = (0, $d87e70eb8df2cb93$export$2e2bcd8739ae039)({
        ...props,
        componentName: 'Pagination'
    });
    const ownerState = {
        ...props,
        boundaryCount: boundaryCount,
        color: color,
        count: count,
        defaultPage: defaultPage,
        disabled: disabled,
        getItemAriaLabel: getItemAriaLabel,
        hideNextButton: hideNextButton,
        hidePrevButton: hidePrevButton,
        renderItem: renderItem,
        shape: shape,
        showFirstButton: showFirstButton,
        showLastButton: showLastButton,
        siblingCount: siblingCount,
        size: size,
        variant: variant
    };
    const classes = $440939d09c2fcfbc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($440939d09c2fcfbc$var$PaginationRoot, {
        "aria-label": "pagination navigation",
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($440939d09c2fcfbc$var$PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("li", {
                    children: renderItem({
                        ...item,
                        color: color,
                        'aria-label': getItemAriaLabel(item.type, item.page, item.selected),
                        shape: shape,
                        size: size,
                        variant: variant
                    })
                }, index))
        })
    });
});
var $440939d09c2fcfbc$export$2e2bcd8739ae039 = $440939d09c2fcfbc$var$Pagination;







var $h4Bez = parcelRequire("h4Bez");






parcelRequire("h4Bez");


const $7ee94322a0c893de$var$checkIconStyle = {
    color: 'primary.700'
};
/** `gap` isn't set here - `theme/dropdown.ts`'s own `MuiMenuItem.styleOverrides.root` already sets it (12px, matching Figma); an sx-level override here would win over that and silently drift from it */ const $7ee94322a0c893de$var$menuItemStyle = {
    display: 'flex',
    justifyContent: 'space-between'
};
/**
 * `flexGrow` alone only stretches this box's own outer edge - without `display: 'flex'` too, a
 * percentage width set further inside it can't reliably resolve against that stretched size, leaving
 * content that wants to push something (e.g. trailing text) to the row's actual right edge stuck.
 */ const $7ee94322a0c893de$var$contentStyle = {
    display: 'flex',
    flexGrow: 1,
    minWidth: 0
};
const $7ee94322a0c893de$export$2ce376c2cc3355c8 = ({ sizeClassName: sizeClassName, className: className, children: children, selected: selected, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $b7bd066558465dcb$export$2e2bcd8739ae039), {
        ...props,
        sx: $7ee94322a0c893de$var$menuItemStyle,
        selected: selected,
        className: [
            className,
            sizeClassName
        ].filter(Boolean).join(' '),
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $7ee94322a0c893de$var$contentStyle,
                children: children
            }),
            selected && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7611395e1ba5aa98$export$7dd004358974b05d), {
                sx: $7ee94322a0c893de$var$checkIconStyle
            })
        ]
    });



const $d85f7a63a75c527f$var$createIconStyle = (rotation)=>({
        [`& .${(0, $ef73307de6008871$export$2e2bcd8739ae039).endIcon}`]: {
            transform: `rotate(${rotation}deg)`,
            transition: 'transform 200ms ease'
        }
    });
const $d85f7a63a75c527f$var$closedIconStyle = $d85f7a63a75c527f$var$createIconStyle(180);
const $d85f7a63a75c527f$var$openIconStyle = $d85f7a63a75c527f$var$createIconStyle(0);
const $d85f7a63a75c527f$export$931cbfb6bfb85fc = ({ buttonLabel: buttonLabel, options: options, size: size, value: value, onChange: onChange, ...props })=>{
    const buttonRef = (0, $h4Bez.useRef)(null);
    const [opened, setOpened] = (0, $h4Bez.useState)(false);
    const selectedValues = (0, $h4Bez.useMemo)(()=>{
        if (value === null) return [];
        return (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(value) ? value : [
            value
        ];
    }, [
        value
    ]);
    const close = ()=>{
        setOpened(false);
    };
    const isSelected = (optionValue)=>selectedValues.includes(optionValue);
    const selectOption = (selectedValue)=>{
        onChange(selectedValue);
        close();
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                ref: buttonRef,
                "data-testid": (0, $3dd52092ec4fc8cb$export$eea0c9f46a8cc3f9)(props, '-button'),
                variant: "secondary",
                size: size,
                endIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $024b35d06a10e12d$export$4857d3f3f5f8319b), {}),
                sx: opened ? $d85f7a63a75c527f$var$openIconStyle : $d85f7a63a75c527f$var$closedIconStyle,
                "aria-expanded": opened,
                onClick: ()=>setOpened(true),
                children: buttonLabel
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1949838101ccf179$export$2e2bcd8739ae039), {
                "data-testid": (0, $3dd52092ec4fc8cb$export$eea0c9f46a8cc3f9)(props, '-menu'),
                anchorEl: buttonRef.current,
                open: opened,
                onClose: close,
                children: options.map((option)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7ee94322a0c893de$export$2ce376c2cc3355c8), {
                        sizeClassName: (0, $5f4401162cf072d8$export$2f632c059ec3efb7)[size],
                        "data-testid": (0, $3dd52092ec4fc8cb$export$eea0c9f46a8cc3f9)(props, `-item-${option.value}`),
                        selected: isSelected(option.value),
                        onClick: ()=>selectOption(option.value),
                        children: option.label
                    }, option.value))
            })
        ]
    });
};





const $3bcd022418ca4732$var$boxStyle = {
    flex: 1
};
const $3bcd022418ca4732$var$totalCountStyle = {
    flex: 1,
    typography: 'caption',
    color: 'grey.900'
};
const $3bcd022418ca4732$var$jumpToPageLabelStyle = {
    mr: 2,
    color: 'grey.900'
};
const $3bcd022418ca4732$var$jumpToPageInputStyle = {
    width: 54,
    '& input[type=number]': {
        MozAppearance: 'textfield'
    },
    '& input[type=number]::-webkit-outer-spin-button': {
        WebkitAppearance: 'none',
        margin: 0
    },
    '& input[type=number]::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0
    }
};
const $3bcd022418ca4732$var$TotalCount = ()=>{
    const totalCount = (0, $365b0b4d68ac9bb9$export$4af6cc58a9a6c026)();
    const pageSize = (0, $365b0b4d68ac9bb9$export$8dc4d8418d8568f5)();
    const page = (0, $365b0b4d68ac9bb9$export$178e57c9fecff4cc)();
    const { paginationDataType: type } = (0, $365b0b4d68ac9bb9$export$e13a77e1f84cc73b)();
    if (!(totalCount && pageSize && type)) return null;
    const startNum = Math.max(pageSize * page + 1, 1);
    const endNum = Math.min(pageSize * (page + 1), totalCount);
    const showShort = totalCount <= pageSize;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $3bcd022418ca4732$var$totalCountStyle,
        "data-testid": "totalCount",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TABLE_PAGINATION_DISPLAYED_ROWS,
                values: {
                    startNum: startNum,
                    endNum: endNum,
                    totalCount: totalCount,
                    showShort: showShort
                }
            }),
            ' ',
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1)[type],
                values: {
                    count: totalCount
                }
            })
        ]
    });
};
const $3bcd022418ca4732$var$JumpToPage = ()=>{
    const page = (0, $365b0b4d68ac9bb9$export$178e57c9fecff4cc)() + 1;
    const totalPages = (0, $365b0b4d68ac9bb9$export$77e1d8b85595b1b2)();
    const changePage = (0, $365b0b4d68ac9bb9$export$34b36a046567f2ef)();
    const hideJumpToPage = (0, $365b0b4d68ac9bb9$export$a6cc3d417b945bb7)();
    const inputId = (0, $h4Bez.useId)();
    const [currentPage, setCurrentPage] = (0, $h4Bez.useState)(page);
    (0, $h4Bez.useEffect)(()=>setCurrentPage(page), [
        page
    ]);
    const onChange = (0, $h4Bez.useCallback)(({ target: { valueAsNumber: valueAsNumber } })=>setCurrentPage(isNaN(valueAsNumber) ? '' : Math.min(Math.max(valueAsNumber, 1), totalPages)), [
        totalPages
    ]);
    const onKeyDown = (0, $h4Bez.useCallback)((0, $1fdb53e1bec07519$export$d9ea00e8a3cf8cca)(()=>{
        if (currentPage) changePage(currentPage - 1);
    }), [
        page,
        currentPage
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $3bcd022418ca4732$var$boxStyle,
        children: !hideJumpToPage && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
            direction: "row",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    component: "label",
                    variant: "caption",
                    htmlFor: inputId,
                    sx: $3bcd022418ca4732$var$jumpToPageLabelStyle,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).JUMP_TO_PAGE
                    })
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1be879c5f72a2d8d$export$2e2bcd8739ae039), {
                    "data-testid": "jumpToPage",
                    id: inputId,
                    size: "small",
                    type: "number",
                    sx: $3bcd022418ca4732$var$jumpToPageInputStyle,
                    value: currentPage,
                    onChange: onChange,
                    onKeyDown: onKeyDown
                })
            ]
        })
    });
};
const $3bcd022418ca4732$var$LeftSidebar = ()=>{
    const showTotalCount = (0, $365b0b4d68ac9bb9$export$b8a95f23b06f15f3)();
    const { paginationDataType: paginationDataType } = (0, $365b0b4d68ac9bb9$export$e13a77e1f84cc73b)();
    return showTotalCount && paginationDataType ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($3bcd022418ca4732$var$TotalCount, {}) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($3bcd022418ca4732$var$JumpToPage, {});
};
const $3bcd022418ca4732$var$Pagination = ()=>{
    const totalPages = (0, $365b0b4d68ac9bb9$export$77e1d8b85595b1b2)();
    const page = (0, $365b0b4d68ac9bb9$export$178e57c9fecff4cc)();
    const changePage = (0, $365b0b4d68ac9bb9$export$34b36a046567f2ef)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $440939d09c2fcfbc$export$2e2bcd8739ae039), {
        count: totalPages,
        page: page + 1,
        onChange: (_, page)=>changePage(page - 1)
    });
};
const $3bcd022418ca4732$var$pageSizeMenuWrapperStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
};
const $3bcd022418ca4732$var$pageSizeMenuLabelStyle = {
    mr: 2,
    typography: 'caption',
    color: 'grey.900'
};
const $3bcd022418ca4732$var$PageSizeMenu = ()=>{
    const pageSize = (0, $365b0b4d68ac9bb9$export$8dc4d8418d8568f5)();
    const changePageSize = (0, $365b0b4d68ac9bb9$export$4d0dbe999816fb14)();
    const pageSizeOptions = (0, $365b0b4d68ac9bb9$export$ec11ebe036e44ff6)();
    return pageSizeOptions && pageSizeOptions.length > 1 ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: [
            $3bcd022418ca4732$var$boxStyle,
            $3bcd022418ca4732$var$pageSizeMenuWrapperStyle
        ],
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $401b148a65fd432a$export$2e2bcd8739ae039), {
                variant: "standard",
                sx: $3bcd022418ca4732$var$pageSizeMenuLabelStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ROWS_PER_PAGE
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d85f7a63a75c527f$export$931cbfb6bfb85fc), {
                options: pageSizeOptions.map((value)=>({
                        value: value,
                        label: value
                    })),
                size: "small",
                "data-testid": "pagination-rows",
                value: pageSize,
                onChange: (value)=>changePageSize(value),
                buttonLabel: pageSize
            })
        ]
    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $3bcd022418ca4732$var$boxStyle
    });
};
const $3bcd022418ca4732$var$FOOTER_HEIGHT = 44;
const $3bcd022418ca4732$var$cellStyle = {
    display: 'flex',
    gap: 4,
    minHeight: $3bcd022418ca4732$var$FOOTER_HEIGHT,
    px: 6,
    alignItems: 'center',
    justifyContent: 'space-between',
    borderTop: '1px solid',
    borderTopColor: 'grey.300'
};
const $3bcd022418ca4732$export$a06f1c675e846f6f = ()=>{
    const bodyState = (0, $365b0b4d68ac9bb9$export$15313dbeba21e0cd)();
    const hasBodyContent = bodyState === 'rows' || bodyState === 'reloading';
    const totalPages = (0, $365b0b4d68ac9bb9$export$77e1d8b85595b1b2)();
    const pageSizeOptions = (0, $365b0b4d68ac9bb9$export$ec11ebe036e44ff6)();
    /**
     * If pageSize or pageSizeOptions are falsy,
     * that means we show all data on the table,
     * and there is no need to display pagination
     */ if (!hasBodyContent || !isFinite(totalPages) || totalPages === 0 || pageSizeOptions === null) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "table-footer",
        sx: $3bcd022418ca4732$var$cellStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($3bcd022418ca4732$var$LeftSidebar, {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($3bcd022418ca4732$var$Pagination, {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($3bcd022418ca4732$var$PageSizeMenu, {})
        ]
    });
};



parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");








function $270343835d33d7e3$export$2e731cea2d1c2392(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiTableHead', slot);
}
const $270343835d33d7e3$var$tableHeadClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiTableHead', [
    'root'
]);
var $270343835d33d7e3$export$2e2bcd8739ae039 = $270343835d33d7e3$var$tableHeadClasses;



'use client';
const $f6709e6d86243a70$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $270343835d33d7e3$export$2e731cea2d1c2392), classes);
};
const $f6709e6d86243a70$var$TableHeadRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('thead', {
    name: 'MuiTableHead',
    slot: 'Root'
})({
    display: 'table-header-group'
});
const $f6709e6d86243a70$var$tablelvl2 = {
    variant: 'head'
};
const $f6709e6d86243a70$var$defaultComponent = 'thead';
const $f6709e6d86243a70$var$TableHead = /*#__PURE__*/ $h4Bez.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $f6709e6d86243a70$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $f6709e6d86243a70$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $506bb8e6c9c3cb58$export$2e2bcd8739ae039).Provider, {
        value: $f6709e6d86243a70$var$tablelvl2,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($f6709e6d86243a70$var$TableHeadRoot, {
            as: component,
            className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            role: component === $f6709e6d86243a70$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var $f6709e6d86243a70$export$2e2bcd8739ae039 = $f6709e6d86243a70$var$TableHead;





var $h4Bez = parcelRequire("h4Bez");



'use client';
var $e75dd00e441ee553$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');









'use client';
const $b33264bd28ba4b44$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, direction: direction, active: active } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active',
            `direction${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(direction)}`
        ],
        icon: [
            'icon',
            `iconDirection${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(direction)}`
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $375bbd4a107cd711$export$645d356c89a51794), classes);
};
const $b33264bd28ba4b44$var$TableSortLabelRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d02728b6fe958b24$export$2e2bcd8739ae039), {
    name: 'MuiTableSortLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.active && styles.active
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        cursor: 'pointer',
        display: 'inline-flex',
        justifyContent: 'flex-start',
        flexDirection: 'inherit',
        alignItems: 'center',
        '&:focus': {
            color: (theme.vars || theme).palette.text.secondary
        },
        '&:hover': {
            color: (theme.vars || theme).palette.text.secondary,
            [`& .${(0, $375bbd4a107cd711$export$2e2bcd8739ae039).icon}`]: {
                opacity: 0.5
            }
        },
        [`&.${(0, $375bbd4a107cd711$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            [`& .${(0, $375bbd4a107cd711$export$2e2bcd8739ae039).icon}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.text.secondary
            }
        }
    })));
const $b33264bd28ba4b44$var$TableSortLabelIcon = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiTableSortLabel',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            styles[`iconDirection${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.direction)}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        fontSize: 18,
        marginRight: 4,
        marginLeft: 4,
        opacity: 0,
        transition: theme.transitions.create([
            'opacity',
            'transform'
        ], {
            duration: theme.transitions.duration.shorter
        }),
        userSelect: 'none',
        variants: [
            {
                props: {
                    direction: 'desc'
                },
                style: {
                    transform: 'rotate(0deg)'
                }
            },
            {
                props: {
                    direction: 'asc'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */ const $b33264bd28ba4b44$var$TableSortLabel = /*#__PURE__*/ $h4Bez.forwardRef(function TableSortLabel(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTableSortLabel'
    });
    const { active: active = false, children: children, className: className, direction: direction = 'asc', hideSortIcon: hideSortIcon = false, IconComponent: IconComponent = (0, $e75dd00e441ee553$export$2e2bcd8739ae039), slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        active: active,
        direction: direction,
        hideSortIcon: hideSortIcon,
        IconComponent: IconComponent
    };
    const classes = $b33264bd28ba4b44$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('root', {
        elementType: $b33264bd28ba4b44$var$TableSortLabelRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    });
    const [IconSlot, iconProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('icon', {
        elementType: $b33264bd28ba4b44$var$TableSortLabelIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.icon
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)(RootSlot, {
        disableRipple: true,
        component: "span",
        ...rootProps,
        ...other,
        children: [
            children,
            hideSortIcon && !active ? null : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(IconSlot, {
                as: IconComponent,
                ...iconProps
            })
        ]
    });
});
var $b33264bd28ba4b44$export$2e2bcd8739ae039 = $b33264bd28ba4b44$var$TableSortLabel;



parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");




var $h4Bez = parcelRequire("h4Bez");







'use client';
var $7e1e510fcc288095$export$2e2bcd8739ae039 = (0, $1e812888fb3f7236$export$2e2bcd8739ae039);






function $db1236cb1936c615$export$baa0faa0c7ad8085(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('PrivateSwitchBase', slot);
}
const $db1236cb1936c615$var$switchBaseClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $db1236cb1936c615$export$2e2bcd8739ae039 = $db1236cb1936c615$var$switchBaseClasses;




'use client';
const $3bb54a012d66bf14$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $db1236cb1936c615$export$baa0faa0c7ad8085), classes);
};
const $3bb54a012d66bf14$var$SwitchBaseRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d02728b6fe958b24$export$2e2bcd8739ae039), {
    name: 'MuiSwitchBase'
})({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const $3bb54a012d66bf14$var$SwitchBaseInput = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('input', {
    name: 'MuiSwitchBase',
    shouldForwardProp: (0, $19087586f17e5d57$export$2e2bcd8739ae039)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $3bb54a012d66bf14$var$SwitchBase = /*#__PURE__*/ $h4Bez.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const [checked, setCheckedState] = (0, $7e1e510fcc288095$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $364d4e99dd433e44$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented || readOnly) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = {
        ...props,
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    };
    const classes = $3bb54a012d66bf14$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: inputProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $3bb54a012d66bf14$var$SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: 'span',
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleFocus(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleBlur(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            disabled: disabled,
            role: undefined,
            tabIndex: null
        }
    });
    const [InputSlot, inputSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('input', {
        ref: inputRef,
        elementType: $3bb54a012d66bf14$var$SwitchBaseInput,
        className: classes.input,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event)=>{
                    handlers.onChange?.(event);
                    handleInputChange(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            autoFocus: autoFocus,
            checked: checkedProp,
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: hasLabelFor ? id : undefined,
            name: name,
            readOnly: readOnly,
            required: required,
            tabIndex: tabIndex,
            type: type,
            ...type === 'checkbox' && value === undefined ? {} : {
                value: value
            }
        }
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(InputSlot, {
                ...inputSlotProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
var $3bb54a012d66bf14$export$2e2bcd8739ae039 = $3bb54a012d66bf14$var$SwitchBase;




'use client';
var $def427222b8ecde6$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');




'use client';
var $4d16153f863cb602$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');




'use client';
var $0fbdb9e142efe559$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');












'use client';
const $96d9ff0232abe8ca$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`
        ]
    };
    const composedClasses = (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $bef56d69afec4a03$export$6c57c6e16b4063b), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $96d9ff0232abe8ca$var$CheckboxRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $3bb54a012d66bf14$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $19087586f17e5d57$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    color: 'default',
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $bef56d69afec4a03$export$2e2bcd8739ae039).checked}, &.${(0, $bef56d69afec4a03$export$2e2bcd8739ae039).indeterminate}`]: {
                            color: (theme.vars || theme).palette[color].main
                        },
                        [`&.${(0, $bef56d69afec4a03$export$2e2bcd8739ae039).disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
const $96d9ff0232abe8ca$var$defaultCheckedIcon = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4d16153f863cb602$export$2e2bcd8739ae039), {});
const $96d9ff0232abe8ca$var$defaultIcon = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $def427222b8ecde6$export$2e2bcd8739ae039), {});
const $96d9ff0232abe8ca$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0fbdb9e142efe559$export$2e2bcd8739ae039), {});
const $96d9ff0232abe8ca$var$Checkbox = /*#__PURE__*/ $h4Bez.forwardRef(function Checkbox(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $96d9ff0232abe8ca$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $96d9ff0232abe8ca$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $96d9ff0232abe8ca$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', disableRipple: disableRipple = false, className: className, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = {
        ...props,
        disableRipple: disableRipple,
        color: color,
        indeterminate: indeterminate,
        size: size
    };
    const classes = $96d9ff0232abe8ca$var$useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $96d9ff0232abe8ca$var$CheckboxRoot,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            type: 'checkbox',
            icon: /*#__PURE__*/ $h4Bez.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $h4Bez.cloneElement(indeterminateIcon, {
                fontSize: indeterminateIcon.props.fontSize ?? size
            }),
            disableRipple: disableRipple,
            slots: slots,
            slotProps: {
                input: (0, $a2e9ce20abe2966a$export$2e2bcd8739ae039)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                    'data-indeterminate': indeterminate
                })
            }
        }
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $96d9ff0232abe8ca$export$2e2bcd8739ae039 = $96d9ff0232abe8ca$var$Checkbox;


const $2d1d930894f85d66$export$48513f6b9f8ce62d = (0, $96d9ff0232abe8ca$export$2e2bcd8739ae039);


const $3a05949b3b89f754$var$checkboxStyle = {
    p: 0
};
const $3a05949b3b89f754$export$d5fc9b27802c0882 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2d1d930894f85d66$export$48513f6b9f8ce62d), {
        ...props,
        size: "small",
        sx: $3a05949b3b89f754$var$checkboxStyle
    });




var $h4Bez = parcelRequire("h4Bez");



const $c48a918c0b66dee1$export$1cd1097fe7c7b76c = ({ name: name })=>{
    const { label: LabelContent } = (0, $365b0b4d68ac9bb9$export$ba0a914f5e13434b)(name);
    if ((0, $40a99dac858c1d75$export$552cd99e43fa1085)(LabelContent)) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
        id: LabelContent
    });
    return typeof LabelContent === 'function' ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(LabelContent, {
        children: name
    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
        children: LabelContent
    });
};
const $c48a918c0b66dee1$export$26cca3fbd53af9cb = ()=>{
    const columns = (0, $365b0b4d68ac9bb9$export$c97dded465ef56fb)();
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return (0, $h4Bez.useCallback)((name)=>{
        const label = columns[name]?.label;
        if ((0, $40a99dac858c1d75$export$552cd99e43fa1085)(label)) return translator.formatTranslation(label);
        return typeof label === 'string' ? label : name;
    }, [
        columns,
        translator
    ]);
};




var $h4Bez = parcelRequire("h4Bez");




var $h4Bez = parcelRequire("h4Bez");
const $fa3f09262d9686d4$export$380fc35952b6395a = 'col-resize';
const $fa3f09262d9686d4$export$3044d9fa820d116a = (dragging)=>(0, $h4Bez.useEffect)(()=>{
        if (!dragging) return;
        const { cursor: cursor, userSelect: userSelect } = document.body.style;
        document.body.style.cursor = $fa3f09262d9686d4$export$380fc35952b6395a;
        document.body.style.userSelect = 'none';
        return ()=>{
            document.body.style.cursor = cursor;
            document.body.style.userSelect = userSelect;
        };
    }, [
        dragging
    ]);








parcelRequire("h4Bez");



parcelRequire("h4Bez");








"use client";
var $06e9db9e3c921f60$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'Delete');



"use client";
var $17a5ddc134ac4f1f$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-1 14H9V8h2zm4 0h-2V8h2z"
}), 'PauseCircleFilled');



"use client";
var $d5ccdb53d4f7a1b0$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8"
}), 'Replay');



"use client";
var $e48ceac01897a12d$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M17 7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h10c2.76 0 5-2.24 5-5s-2.24-5-5-5m0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3"
}), 'ToggleOn');



const $80eac538e231fc01$export$2d2b69fca0cded9e = [
    'ENABLE',
    'DISABLE',
    'DELETE',
    'RESTART'
];
const $80eac538e231fc01$export$adee39cfbee1cf99 = {
    DELETE: (0, $06e9db9e3c921f60$export$2e2bcd8739ae039),
    DISABLE: (0, $17a5ddc134ac4f1f$export$2e2bcd8739ae039),
    ENABLE: (0, $e48ceac01897a12d$export$2e2bcd8739ae039),
    RESTART: (0, $d5ccdb53d4f7a1b0$export$2e2bcd8739ae039)
};
const $80eac538e231fc01$export$d05858291b5222ca = {
    DELETE: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE,
    DISABLE: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE,
    ENABLE: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENABLE,
    RESTART: (0, $40a99dac858c1d75$export$b63289fbda65eed1).RESTART
};
const $80eac538e231fc01$export$d8f733b7bbec3a6 = 'DELETE';



const $74cb18f1bcbeda31$var$TRIGGER = `& > .${(0, $d11898bbe79f09e3$export$2e2bcd8739ae039).root}`;
/** In spacing steps */ const $74cb18f1bcbeda31$var$TRAILING_COLUMN_PADDING_X = 2;
const $74cb18f1bcbeda31$export$139e32077d3d7f8a = {
    width: 0,
    px: $74cb18f1bcbeda31$var$TRAILING_COLUMN_PADDING_X
};
const $74cb18f1bcbeda31$export$6ea8395b8074fac4 = (0, $5f78a8132f139ecb$export$642d8a5846df7ebb) + 2 * $74cb18f1bcbeda31$var$TRAILING_COLUMN_PADDING_X * (0, $1a6512ae4318d72b$export$1d5937c6c580f51);
/**
 * The trigger stays hidden, but focusable, until its row is hovered or has focus, or while its menu is open, whose focus is in a portal.
 * Touch screens can't hover, so they always show it.
 * It is pulled 4px into the cell padding above and below, so the 28px button centres on the 20px text line without making the row taller.
 */ const $74cb18f1bcbeda31$var$bodyCellStyle = {
    ...$74cb18f1bcbeda31$export$139e32077d3d7f8a,
    [$74cb18f1bcbeda31$var$TRIGGER]: {
        display: 'flex',
        my: -1,
        opacity: 0,
        transition: ({ transitions: transitions })=>transitions.create('opacity', {
                duration: transitions.duration.shortest
            })
    },
    [`.${(0, $2fb9c2cc5ba0457d$export$2e2bcd8739ae039).root}:hover > &, .${(0, $2fb9c2cc5ba0457d$export$2e2bcd8739ae039).root}:focus-within > &`]: {
        [$74cb18f1bcbeda31$var$TRIGGER]: {
            opacity: 1
        }
    },
    [`${$74cb18f1bcbeda31$var$TRIGGER}[aria-expanded="true"]`]: {
        opacity: 1
    },
    '@media (hover: none)': {
        [$74cb18f1bcbeda31$var$TRIGGER]: {
            opacity: 1
        }
    }
};
const $74cb18f1bcbeda31$export$935284610f07e8be = ({ index: index, row: row })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const { onSelect: onSelect, idField: idField, icons: icons, labels: labels } = (0, $365b0b4d68ac9bb9$export$459a847cde06c169)();
    const actions = onSelect([
        row
    ]);
    const loaded = (0, $365b0b4d68ac9bb9$export$a7fa9df522e0d0db)();
    const items = [];
    for (const action of (0, $80eac538e231fc01$export$2d2b69fca0cded9e)){
        const onClick = actions[action];
        if (onClick) items.push({
            key: action,
            label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: labels[action] ?? (0, $80eac538e231fc01$export$d05858291b5222ca)[action]
            }),
            icon: icons[action] ?? (0, $80eac538e231fc01$export$adee39cfbee1cf99)[action],
            destructive: action === (0, $80eac538e231fc01$export$d8f733b7bbec3a6),
            /** As the toolbar's: the actions' dialogs only find the record in loaded rows */ disabled: !loaded,
            onClick: ()=>onClick([
                    row
                ])
        });
    }
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $96e1a88505b6a102$export$2e2bcd8739ae039), {
        sx: $74cb18f1bcbeda31$var$bodyCellStyle,
        children: (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(items) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a3b9a942eeea294b$export$ed57a210b9d13bb6), {
            "data-testid": `table-row-actions-${index}`,
            label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).ROW_ACTIONS, {
                name: String(row[idField])
            }),
            items: items
        })
    });
};



const $a32335fbd01007d5$var$DEFAULT_COLUMN_MIN_WIDTH = 100;
const $a32335fbd01007d5$var$COLUMN_TYPE_MIN_WIDTHS = {
    number: 80,
    datetime: 140
};
const $a32335fbd01007d5$export$dc572e5846332cb1 = ({ type: type })=>type ? $a32335fbd01007d5$var$COLUMN_TYPE_MIN_WIDTHS[type] : $a32335fbd01007d5$var$DEFAULT_COLUMN_MIN_WIDTH;
/** The column view with the width of the column being resized, if any, as it will be once committed */ const $a32335fbd01007d5$var$useRenderedColumnView = ()=>{
    const allNames = (0, $365b0b4d68ac9bb9$export$edd9cd4ea59a06e0)();
    const view = (0, $365b0b4d68ac9bb9$export$ddca39529720c1e7)();
    const resizing = (0, $365b0b4d68ac9bb9$export$f46934223cd71381)();
    return resizing ? (0, $2ac73d5fe610e8da$export$2e875294f1e55b35)(allNames, view, resizing.name, resizing.width, resizing.minWidth) : view;
};
/** `null` for a table without a column view, which keeps the browser's automatic layout */ const $a32335fbd01007d5$var$useColumnLayout = ()=>{
    const hasColumnView = (0, $365b0b4d68ac9bb9$export$e904f852b627a2bb)();
    const hasSelection = (0, $365b0b4d68ac9bb9$export$dbeaeea714145b36)();
    const names = (0, $365b0b4d68ac9bb9$export$8b715ac3f253d94f)();
    const columns = (0, $365b0b4d68ac9bb9$export$c97dded465ef56fb)();
    const view = $a32335fbd01007d5$var$useRenderedColumnView();
    if (!hasColumnView) return null;
    const sized = (0, $2ac73d5fe610e8da$export$1184d6eee78c7c79)(names, view);
    const columnsWidths = names.map((name, index)=>{
        const minWidth = $a32335fbd01007d5$export$dc572e5846332cb1(columns[name]);
        const stored = sized[name];
        const width = stored === undefined ? null : Math.max(stored, minWidth);
        /**
         * A fixed layout at `width: 100%` spreads any spare space over every sized column once none is left unsized,
         * so the last one always stays unsized to absorb it, its stored width still setting its floor
         */ return index === names.length - 1 ? {
            width: null,
            minWidth: width ?? minWidth
        } : {
            width: width,
            minWidth: minWidth
        };
    });
    const sizedWidth = columnsWidths.reduce((sum, { width: width })=>sum + (width ?? 0), 0);
    const unsizedMinWidths = columnsWidths.filter(({ width: width })=>width === null).map(({ minWidth: minWidth })=>minWidth);
    /** Fixed layout gives the unsized columns equal shares, so each needs the largest of their minimums for none to fall below its own */ const unsizedWidth = unsizedMinWidths.length * Math.max(0, ...unsizedMinWidths);
    const checkboxWidth = hasSelection ? (0, $a1537862b7417309$export$6d71d73a386a4ab5) : 0;
    return {
        widths: [
            ...hasSelection ? [
                (0, $a1537862b7417309$export$6d71d73a386a4ab5)
            ] : [],
            ...columnsWidths.map(({ width: width })=>width),
            (0, $74cb18f1bcbeda31$export$6ea8395b8074fac4)
        ],
        minWidth: checkboxWidth + sizedWidth + unsizedWidth + (0, $74cb18f1bcbeda31$export$6ea8395b8074fac4)
    };
};
const $a32335fbd01007d5$var$fixedLayoutStyle = {
    tableLayout: 'fixed',
    width: '100%'
};
const $a32335fbd01007d5$export$4446f89fea009832 = ()=>{
    const layout = $a32335fbd01007d5$var$useColumnLayout();
    return layout ? {
        sx: $a32335fbd01007d5$var$fixedLayoutStyle,
        style: {
            minWidth: layout.minWidth
        }
    } : null;
};
const $a32335fbd01007d5$export$8a8fbc71323f074 = ()=>{
    const layout = $a32335fbd01007d5$var$useColumnLayout();
    if (!layout) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("colgroup", {
        children: layout.widths.map((width, index)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("col", {
                style: width === null ? undefined : {
                    width: width
                }
            }, index))
    });
};


/** The widest a fit makes a column, so one long value doesn't push the other columns out of view */ const $0c0f9342266be860$var$AUTO_FIT_MAX = 480;
/** Out of sight and out of the page's flow, sized by its content alone, whatever the measured table's own layout */ const $0c0f9342266be860$var$MEASURER_STYLE = {
    position: 'absolute',
    top: '0',
    left: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    tableLayout: 'auto',
    width: 'max-content',
    minWidth: '0'
};
/** A sort label is bolder while hovered, so it's measured at that weight: the fitted width must still hold it whole when the user hovers the header */ const $0c0f9342266be860$var$cloneCell = (cell)=>{
    const clone = cell.cloneNode(true);
    (0, $14eddac5f20c576c$export$a7a9523472993e97)(clone instanceof HTMLTableCellElement, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'A table cell must clone into a table cell'));
    clone.querySelectorAll(`.${(0, $375bbd4a107cd711$export$2e2bcd8739ae039).root}`).forEach(({ style: style })=>{
        style.fontWeight = String((0, $a1537862b7417309$export$7f13d34a1f1ef207));
    });
    return clone;
};
const $0c0f9342266be860$export$25a3c2f5956f9b8 = (table, keys, cellIndexOf)=>{
    const measurer = document.createElement('table');
    measurer.className = table.className;
    Object.assign(measurer.style, $0c0f9342266be860$var$MEASURER_STYLE);
    const rows = Array.from(table.rows).filter((row)=>Array.from(row.cells).every(({ colSpan: colSpan })=>colSpan === 1)).map((source)=>({
            source: source,
            copy: measurer.insertRow()
        }));
    const columns = keys.map((key)=>{
        const index = cellIndexOf(key);
        const cells = rows.map(({ source: source, copy: copy })=>{
            const cell = source.cells.item(index);
            (0, $14eddac5f20c576c$export$a7a9523472993e97)(cell, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'A measured column must have a cell in every row', {
                index: index
            }));
            return copy.appendChild($0c0f9342266be860$var$cloneCell(cell));
        });
        return [
            key,
            cells
        ];
    });
    table.after(measurer);
    try {
        return columns.map(([key, cells])=>[
                key,
                Math.max(0, ...cells.map((cell)=>cell.getBoundingClientRect().width))
            ]);
    } finally{
        measurer.remove();
    }
};
const $0c0f9342266be860$export$33bd6e61645280a7 = (contentWidth, minWidth)=>contentWidth > 0 ? Math.max(minWidth, Math.min($0c0f9342266be860$var$AUTO_FIT_MAX, Math.ceil(contentWidth))) : null;
const $0c0f9342266be860$export$b12b86e52c431902 = (onChange)=>{
    const allNames = (0, $365b0b4d68ac9bb9$export$edd9cd4ea59a06e0)();
    const renderedNames = (0, $365b0b4d68ac9bb9$export$8b715ac3f253d94f)();
    const columns = (0, $365b0b4d68ac9bb9$export$c97dded465ef56fb)();
    const view = (0, $365b0b4d68ac9bb9$export$ddca39529720c1e7)();
    const firstColumnCellIndex = Number((0, $365b0b4d68ac9bb9$export$dbeaeea714145b36)());
    return (from, names)=>{
        const table = from.closest('table');
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(table, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Columns can only be fitted from inside their table', {
            names: names
        }));
        const cellIndexOf = (name)=>{
            const index = renderedNames.indexOf(name);
            (0, $14eddac5f20c576c$export$a7a9523472993e97)(index !== -1, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Only a rendered column can be fitted', {
                name: name
            }));
            return firstColumnCellIndex + index;
        };
        const fits = $0c0f9342266be860$export$25a3c2f5956f9b8(table, names, cellIndexOf).flatMap(([name, contentWidth])=>{
            const column = columns[name];
            (0, $14eddac5f20c576c$export$a7a9523472993e97)(column, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'A fitted column must be configured', {
                name: name
            }));
            const minWidth = (0, $a32335fbd01007d5$export$dc572e5846332cb1)(column);
            const width = $0c0f9342266be860$export$33bd6e61645280a7(contentWidth, minWidth);
            return width === null ? [] : [
                {
                    name: name,
                    width: width,
                    minWidth: minWidth
                }
            ];
        });
        if (fits.length > 0) onChange(fits.reduce((fitted, { name: name, width: width, minWidth: minWidth })=>(0, $2ac73d5fe610e8da$export$2e875294f1e55b35)(allNames, fitted, name, width, minWidth), view));
    };
};




/** In spacing steps: 8px, wide enough to grab, centred on the column's edge, while the line drawn in it stays 1px */ const $5ee1e722544b740d$var$GRIP_WIDTH = 2;
/** In px, as a bare 1 in `sx` would be a 100% width */ const $5ee1e722544b740d$var$GRIP_LINE_WIDTH = 1;
/** In px: a press moving less than this, as a double click's jitter does, is no drag yet */ const $5ee1e722544b740d$var$DRAG_DEAD_ZONE = 4;
const $5ee1e722544b740d$var$gripStyle = (dragging)=>(theme)=>{
        const line = (visible)=>({
                content: '""',
                width: `${$5ee1e722544b740d$var$GRIP_LINE_WIDTH}px`,
                height: '100%',
                backgroundColor: visible ? theme.palette.grey[300] : 'transparent'
            });
        return {
            position: 'absolute',
            top: 0,
            right: theme.spacing(-$5ee1e722544b740d$var$GRIP_WIDTH / 2),
            zIndex: 1,
            display: 'flex',
            justifyContent: 'center',
            width: theme.spacing($5ee1e722544b740d$var$GRIP_WIDTH),
            height: '100%',
            cursor: (0, $fa3f09262d9686d4$export$380fc35952b6395a),
            touchAction: 'none',
            '&::after': line(dragging),
            [`.${(0, $823e90498c56952a$export$2e2bcd8739ae039).head}:hover > &::after`]: line(true)
        };
    };
const $5ee1e722544b740d$export$97b609de3b8b1942 = ({ name: name, onChange: onChange })=>{
    const column = (0, $365b0b4d68ac9bb9$export$ba0a914f5e13434b)(name);
    const names = (0, $365b0b4d68ac9bb9$export$edd9cd4ea59a06e0)();
    const view = (0, $365b0b4d68ac9bb9$export$ddca39529720c1e7)();
    const setResizing = (0, $365b0b4d68ac9bb9$export$f4617cd8c1cea916)();
    const autoFit = (0, $0c0f9342266be860$export$b12b86e52c431902)(onChange);
    const showsRows = (0, $365b0b4d68ac9bb9$export$21bdbb26575478ef)();
    const drag = (0, $h4Bez.useRef)(null);
    const [dragging, setDragging] = (0, $h4Bez.useState)(false);
    (0, $fa3f09262d9686d4$export$3044d9fa820d116a)(dragging);
    /** Unmounted mid-drag, the table would otherwise keep rendering the uncommitted width */ (0, $h4Bez.useEffect)(()=>{
        if (!dragging) return;
        return ()=>{
            if (drag.current) setResizing(null);
        };
    }, [
        dragging
    ]);
    const findDrag = (event)=>drag.current?.pointerId === event.pointerId ? drag.current : null;
    const end = ()=>{
        drag.current = null;
        setDragging(false);
        setResizing(null);
    };
    const onPointerDown = (event)=>{
        if (event.button !== 0 || !event.isPrimary || drag.current) return;
        /** Keeps the press from selecting text or moving the focus */ event.preventDefault();
        const cell = event.currentTarget.parentElement;
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(cell, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'A resize grip must be inside its header cell', {
            name: name
        }));
        event.currentTarget.setPointerCapture(event.pointerId);
        drag.current = {
            pointerId: event.pointerId,
            startX: event.clientX,
            startWidth: cell.getBoundingClientRect().width,
            minWidth: (0, $a32335fbd01007d5$export$dc572e5846332cb1)(column),
            width: null
        };
        setDragging(true);
    };
    const onPointerMove = (event)=>{
        const current = findDrag(event);
        if (!current) return;
        /** No button pressed anymore means the release was missed, so the drag is over, uncommitted */ if (event.buttons === 0) {
            end();
            return;
        }
        const offset = event.clientX - current.startX;
        if (current.width === null && Math.abs(offset) < $5ee1e722544b740d$var$DRAG_DEAD_ZONE) return;
        current.width = Math.max(current.minWidth, current.startWidth + offset);
        setResizing({
            name: name,
            width: current.width,
            minWidth: current.minWidth
        });
    };
    const onPointerUp = (event)=>{
        const current = findDrag(event);
        if (!current) return;
        if (current.width !== null) onChange((0, $2ac73d5fe610e8da$export$2e875294f1e55b35)(names, view, name, current.width, current.minWidth));
        end();
    };
    /** A cancel, or a capture lost without a release, ends the drag uncommitted; after a release there's no drag left to end */ const onInterrupt = (event)=>{
        if (findDrag(event)) end();
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        component: "span",
        "aria-hidden": true,
        "data-testid": `column-header-resize-${name}`,
        sx: $5ee1e722544b740d$var$gripStyle(dragging),
        onPointerDown: onPointerDown,
        onPointerMove: onPointerMove,
        onPointerUp: onPointerUp,
        onPointerCancel: onInterrupt,
        onLostPointerCapture: onInterrupt,
        onDoubleClick: (event)=>{
            if (showsRows) autoFit(event.currentTarget, [
                name
            ]);
        }
    });
};




parcelRequire("h4Bez");

const $7e4b04c742d6c9ba$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $7e4b04c742d6c9ba$export$2e2bcd8739ae039 = $7e4b04c742d6c9ba$var$visuallyHidden;






var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");


















var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");






function $73f1109189a1b46c$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $83f94d39b583c55f$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $73f1109189a1b46c$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $83f94d39b583c55f$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $73f1109189a1b46c$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $83f94d39b583c55f$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $73f1109189a1b46c$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $6ef21f0f78b05b42$export$8960430cfd85939f = Math.max;
var $6ef21f0f78b05b42$export$96ec731ed4dcb222 = Math.min;
var $6ef21f0f78b05b42$export$2077e0241d6afd3c = Math.round;



function $62013a55a6c86067$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $311a07666676f1d7$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $62013a55a6c86067$export$2e2bcd8739ae039)());
}


function $b10d071948f3b3d7$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $83f94d39b583c55f$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $6ef21f0f78b05b42$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $6ef21f0f78b05b42$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $83f94d39b583c55f$export$45a5e7f76e0caa8d)(element) ? (0, $73f1109189a1b46c$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $311a07666676f1d7$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $5992f7d600cc2b32$export$2e2bcd8739ae039(node) {
    var win = (0, $73f1109189a1b46c$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $4f4048bbbe6a6a61$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $50bcc7347c8543b7$export$2e2bcd8739ae039(node) {
    if (node === (0, $73f1109189a1b46c$export$2e2bcd8739ae039)(node) || !(0, $83f94d39b583c55f$export$1b3bfaa9684536aa)(node)) return (0, $5992f7d600cc2b32$export$2e2bcd8739ae039)(node);
    else return (0, $4f4048bbbe6a6a61$export$2e2bcd8739ae039)(node);
}


function $626c72a68618ea30$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $5848a80bf92a377c$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $83f94d39b583c55f$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $9797d9daec794f84$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $b10d071948f3b3d7$export$2e2bcd8739ae039)((0, $5848a80bf92a377c$export$2e2bcd8739ae039)(element)).left + (0, $5992f7d600cc2b32$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $a75320e9b4942330$export$2e2bcd8739ae039(element) {
    return (0, $73f1109189a1b46c$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $1a20bc7110b90c3c$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $a75320e9b4942330$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $1b5e1f4e4dc3690e$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $6ef21f0f78b05b42$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $6ef21f0f78b05b42$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $1b5e1f4e4dc3690e$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $83f94d39b583c55f$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $83f94d39b583c55f$export$1b3bfaa9684536aa)(offsetParent) && $1b5e1f4e4dc3690e$var$isElementScaled(offsetParent);
    var documentElement = (0, $5848a80bf92a377c$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $b10d071948f3b3d7$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $626c72a68618ea30$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $1a20bc7110b90c3c$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $50bcc7347c8543b7$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $83f94d39b583c55f$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $b10d071948f3b3d7$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $9797d9daec794f84$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $1740287cad636dee$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $b10d071948f3b3d7$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $bb1a880242472ca7$export$2e2bcd8739ae039(element) {
    if ((0, $626c72a68618ea30$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $83f94d39b583c55f$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $5848a80bf92a377c$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $ce6d3ca79c6e0692$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $626c72a68618ea30$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $83f94d39b583c55f$export$1b3bfaa9684536aa)(node) && (0, $1a20bc7110b90c3c$export$2e2bcd8739ae039)(node)) return node;
    return $ce6d3ca79c6e0692$export$2e2bcd8739ae039((0, $bb1a880242472ca7$export$2e2bcd8739ae039)(node));
}





function $2e6583a0aa21daa4$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $ce6d3ca79c6e0692$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $73f1109189a1b46c$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $1a20bc7110b90c3c$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($2e6583a0aa21daa4$export$2e2bcd8739ae039((0, $bb1a880242472ca7$export$2e2bcd8739ae039)(target)));
}







function $65d653b3f1159648$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $626c72a68618ea30$export$2e2bcd8739ae039)(element)) >= 0;
}




function $660a963acc67df3f$var$getTrueOffsetParent(element) {
    if (!(0, $83f94d39b583c55f$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $a75320e9b4942330$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $660a963acc67df3f$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $62013a55a6c86067$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $62013a55a6c86067$export$2e2bcd8739ae039)());
    if (isIE && (0, $83f94d39b583c55f$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $a75320e9b4942330$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $bb1a880242472ca7$export$2e2bcd8739ae039)(element);
    if ((0, $83f94d39b583c55f$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $83f94d39b583c55f$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $626c72a68618ea30$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $a75320e9b4942330$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $660a963acc67df3f$export$2e2bcd8739ae039(element) {
    var window = (0, $73f1109189a1b46c$export$2e2bcd8739ae039)(element);
    var offsetParent = $660a963acc67df3f$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $65d653b3f1159648$export$2e2bcd8739ae039)(offsetParent) && (0, $a75320e9b4942330$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $660a963acc67df3f$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $626c72a68618ea30$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $626c72a68618ea30$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $a75320e9b4942330$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $660a963acc67df3f$var$getContainingBlock(element) || window;
}


var $e0353e19747514cd$export$1e95b668f3b82d = 'top';
var $e0353e19747514cd$export$40e543e69a8b3fbb = 'bottom';
var $e0353e19747514cd$export$79ffe56a765070d2 = 'right';
var $e0353e19747514cd$export$eabcd2c8791e7bf4 = 'left';
var $e0353e19747514cd$export$dfb5619354ba860 = 'auto';
var $e0353e19747514cd$export$aec2ce47c367b8c3 = [
    $e0353e19747514cd$export$1e95b668f3b82d,
    $e0353e19747514cd$export$40e543e69a8b3fbb,
    $e0353e19747514cd$export$79ffe56a765070d2,
    $e0353e19747514cd$export$eabcd2c8791e7bf4
];
var $e0353e19747514cd$export$b3571188c770cc5a = 'start';
var $e0353e19747514cd$export$bd5df0f255a350f8 = 'end';
var $e0353e19747514cd$export$390fd549c5303b4d = 'clippingParents';
var $e0353e19747514cd$export$d7b7311ec04a3e8f = 'viewport';
var $e0353e19747514cd$export$ae5ab1c730825774 = 'popper';
var $e0353e19747514cd$export$ca50aac9f3ba507f = 'reference';
var $e0353e19747514cd$export$368f9a87e87fa4e1 = /*#__PURE__*/ $e0353e19747514cd$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $e0353e19747514cd$export$b3571188c770cc5a,
        placement + "-" + $e0353e19747514cd$export$bd5df0f255a350f8
    ]);
}, []);
var $e0353e19747514cd$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($e0353e19747514cd$export$aec2ce47c367b8c3, [
    $e0353e19747514cd$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $e0353e19747514cd$export$b3571188c770cc5a,
        placement + "-" + $e0353e19747514cd$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $e0353e19747514cd$export$421679a7c3d56e = 'beforeRead';
var $e0353e19747514cd$export$aafa59e2e03f2942 = 'read';
var $e0353e19747514cd$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $e0353e19747514cd$export$c65e99957a05207c = 'beforeMain';
var $e0353e19747514cd$export$f22da7240b7add18 = 'main';
var $e0353e19747514cd$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $e0353e19747514cd$export$8d4d2d70e7d46032 = 'beforeWrite';
var $e0353e19747514cd$export$68d8715fc104d294 = 'write';
var $e0353e19747514cd$export$70a6e5159acce2e6 = 'afterWrite';
var $e0353e19747514cd$export$d087d3878fdf71d5 = [
    $e0353e19747514cd$export$421679a7c3d56e,
    $e0353e19747514cd$export$aafa59e2e03f2942,
    $e0353e19747514cd$export$6964f6c886723980,
    $e0353e19747514cd$export$c65e99957a05207c,
    $e0353e19747514cd$export$f22da7240b7add18,
    $e0353e19747514cd$export$bab79516f2d662fe,
    $e0353e19747514cd$export$8d4d2d70e7d46032,
    $e0353e19747514cd$export$68d8715fc104d294,
    $e0353e19747514cd$export$70a6e5159acce2e6
];


function $8db38ce9f7366109$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $8db38ce9f7366109$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $8db38ce9f7366109$var$order(modifiers); // order based on phase
    return (0, $e0353e19747514cd$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $547cbebca0c7def4$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $0eea8341e108c5fa$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $dafbbaa64c367ed0$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $dafbbaa64c367ed0$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $dafbbaa64c367ed0$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $dafbbaa64c367ed0$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $dafbbaa64c367ed0$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $83f94d39b583c55f$export$45a5e7f76e0caa8d)(reference) ? (0, $2e6583a0aa21daa4$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $2e6583a0aa21daa4$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $2e6583a0aa21daa4$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $8db38ce9f7366109$export$2e2bcd8739ae039)((0, $0eea8341e108c5fa$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$dafbbaa64c367ed0$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $1b5e1f4e4dc3690e$export$2e2bcd8739ae039)(reference, (0, $660a963acc67df3f$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $1740287cad636dee$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $547cbebca0c7def4$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$dafbbaa64c367ed0$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $dafbbaa64c367ed0$export$8f7491d57c8f97a9 = /*#__PURE__*/ $dafbbaa64c367ed0$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $cf024573759ceac7$var$passive = {
    passive: true
};
function $cf024573759ceac7$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $73f1109189a1b46c$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $cf024573759ceac7$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $cf024573759ceac7$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $cf024573759ceac7$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $cf024573759ceac7$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $cf024573759ceac7$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $cf024573759ceac7$var$effect,
    data: {}
};



function $6ea1dba79859e65b$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $887807fbc3cfc257$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $e77032ca49bef06d$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $2ee16575fd0986d8$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $6ea1dba79859e65b$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $887807fbc3cfc257$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $e0353e19747514cd$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $e0353e19747514cd$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $e0353e19747514cd$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $e0353e19747514cd$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $e77032ca49bef06d$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $e0353e19747514cd$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $e0353e19747514cd$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $425bc067444cf775$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $2ee16575fd0986d8$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $425bc067444cf775$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $425bc067444cf775$var$popperOffsets,
    data: {}
};










var $9f0720af9d2106c8$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $9f0720af9d2106c8$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $6ef21f0f78b05b42$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $6ef21f0f78b05b42$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $9f0720af9d2106c8$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $e0353e19747514cd$export$eabcd2c8791e7bf4);
    var sideY = (0, $e0353e19747514cd$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $660a963acc67df3f$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $73f1109189a1b46c$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $5848a80bf92a377c$export$2e2bcd8739ae039)(popper);
            if ((0, $a75320e9b4942330$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $e0353e19747514cd$export$1e95b668f3b82d) || (placement === (0, $e0353e19747514cd$export$eabcd2c8791e7bf4) || placement === (0, $e0353e19747514cd$export$79ffe56a765070d2)) && variation === (0, $e0353e19747514cd$export$bd5df0f255a350f8)) {
            sideY = (0, $e0353e19747514cd$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $e0353e19747514cd$export$eabcd2c8791e7bf4) || (placement === (0, $e0353e19747514cd$export$1e95b668f3b82d) || placement === (0, $e0353e19747514cd$export$40e543e69a8b3fbb)) && variation === (0, $e0353e19747514cd$export$bd5df0f255a350f8)) {
            sideX = (0, $e0353e19747514cd$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $9f0720af9d2106c8$var$unsetSides);
    var _ref4 = roundOffsets === true ? $9f0720af9d2106c8$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $73f1109189a1b46c$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $9f0720af9d2106c8$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $6ea1dba79859e65b$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $887807fbc3cfc257$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $9f0720af9d2106c8$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $9f0720af9d2106c8$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $9f0720af9d2106c8$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $9f0720af9d2106c8$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $46495d70e14a5f77$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $83f94d39b583c55f$export$1b3bfaa9684536aa)(element) || !(0, $626c72a68618ea30$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $46495d70e14a5f77$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $83f94d39b583c55f$export$1b3bfaa9684536aa)(element) || !(0, $626c72a68618ea30$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $46495d70e14a5f77$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $46495d70e14a5f77$var$applyStyles,
    effect: $46495d70e14a5f77$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $08cee96b8329b7fe$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $6ea1dba79859e65b$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $e0353e19747514cd$export$eabcd2c8791e7bf4),
        (0, $e0353e19747514cd$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $e0353e19747514cd$export$eabcd2c8791e7bf4),
        (0, $e0353e19747514cd$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $08cee96b8329b7fe$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $e0353e19747514cd$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $08cee96b8329b7fe$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $08cee96b8329b7fe$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $08cee96b8329b7fe$var$offset
};


var $005997f04a5ae1fb$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $005997f04a5ae1fb$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $005997f04a5ae1fb$var$hash[matched];
    });
}



var $9ecb6e424741d91a$var$hash = {
    start: 'end',
    end: 'start'
};
function $9ecb6e424741d91a$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $9ecb6e424741d91a$var$hash[matched];
    });
}







function $99ef3f152add92c8$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $73f1109189a1b46c$export$2e2bcd8739ae039)(element);
    var html = (0, $5848a80bf92a377c$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $311a07666676f1d7$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $9797d9daec794f84$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $14c1114ca45117c4$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $5848a80bf92a377c$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $5992f7d600cc2b32$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $6ef21f0f78b05b42$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $6ef21f0f78b05b42$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $9797d9daec794f84$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $a75320e9b4942330$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $6ef21f0f78b05b42$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $a497a521440eee43$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $83f94d39b583c55f$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $ec1246e22252da73$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $df7b77b1be31a4fd$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $b10d071948f3b3d7$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $df7b77b1be31a4fd$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $e0353e19747514cd$export$d7b7311ec04a3e8f) ? (0, $ec1246e22252da73$export$2e2bcd8739ae039)((0, $99ef3f152add92c8$export$2e2bcd8739ae039)(element, strategy)) : (0, $83f94d39b583c55f$export$45a5e7f76e0caa8d)(clippingParent) ? $df7b77b1be31a4fd$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ec1246e22252da73$export$2e2bcd8739ae039)((0, $14c1114ca45117c4$export$2e2bcd8739ae039)((0, $5848a80bf92a377c$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $df7b77b1be31a4fd$var$getClippingParents(element) {
    var clippingParents = (0, $2e6583a0aa21daa4$export$2e2bcd8739ae039)((0, $bb1a880242472ca7$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $a75320e9b4942330$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $83f94d39b583c55f$export$1b3bfaa9684536aa)(element) ? (0, $660a963acc67df3f$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $83f94d39b583c55f$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $83f94d39b583c55f$export$45a5e7f76e0caa8d)(clippingParent) && (0, $a497a521440eee43$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $626c72a68618ea30$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $df7b77b1be31a4fd$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $df7b77b1be31a4fd$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $df7b77b1be31a4fd$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $6ef21f0f78b05b42$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $6ef21f0f78b05b42$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $6ef21f0f78b05b42$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $6ef21f0f78b05b42$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $df7b77b1be31a4fd$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $6b48e5e1dd3042c6$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $ca4f89cf7a7cf2a0$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $6b48e5e1dd3042c6$export$2e2bcd8739ae039)(), paddingObject);
}


function $0a01993d8a8ec30f$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $da2725863909d664$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $e0353e19747514cd$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $e0353e19747514cd$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $e0353e19747514cd$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $ca4f89cf7a7cf2a0$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $0a01993d8a8ec30f$export$2e2bcd8739ae039)(padding, (0, $e0353e19747514cd$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $e0353e19747514cd$export$ae5ab1c730825774) ? (0, $e0353e19747514cd$export$ca50aac9f3ba507f) : (0, $e0353e19747514cd$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $df7b77b1be31a4fd$export$2e2bcd8739ae039)((0, $83f94d39b583c55f$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $5848a80bf92a377c$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $b10d071948f3b3d7$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $2ee16575fd0986d8$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $ec1246e22252da73$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $e0353e19747514cd$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $e0353e19747514cd$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $e0353e19747514cd$export$79ffe56a765070d2),
                (0, $e0353e19747514cd$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $e0353e19747514cd$export$1e95b668f3b82d),
                (0, $e0353e19747514cd$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $41ce11199e15478d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $e0353e19747514cd$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $887807fbc3cfc257$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $e0353e19747514cd$export$368f9a87e87fa4e1) : (0, $e0353e19747514cd$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $887807fbc3cfc257$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $e0353e19747514cd$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $da2725863909d664$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $6ea1dba79859e65b$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $ec97543825a11fdd$var$getExpandedFallbackPlacements(placement) {
    if ((0, $6ea1dba79859e65b$export$2e2bcd8739ae039)(placement) === (0, $e0353e19747514cd$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $005997f04a5ae1fb$export$2e2bcd8739ae039)(placement);
    return [
        (0, $9ecb6e424741d91a$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $9ecb6e424741d91a$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $ec97543825a11fdd$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $6ea1dba79859e65b$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $005997f04a5ae1fb$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $ec97543825a11fdd$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $6ea1dba79859e65b$export$2e2bcd8739ae039)(placement) === (0, $e0353e19747514cd$export$dfb5619354ba860) ? (0, $41ce11199e15478d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $6ea1dba79859e65b$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $887807fbc3cfc257$export$2e2bcd8739ae039)(placement) === (0, $e0353e19747514cd$export$b3571188c770cc5a);
        var isVertical = [
            (0, $e0353e19747514cd$export$1e95b668f3b82d),
            (0, $e0353e19747514cd$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $da2725863909d664$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $e0353e19747514cd$export$79ffe56a765070d2) : (0, $e0353e19747514cd$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $e0353e19747514cd$export$40e543e69a8b3fbb) : (0, $e0353e19747514cd$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $005997f04a5ae1fb$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $005997f04a5ae1fb$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $ec97543825a11fdd$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $ec97543825a11fdd$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $6c666a63b1170d66$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $a74f4705448ffa34$export$f28d906d67a997f3(min, value, max) {
    return (0, $6ef21f0f78b05b42$export$8960430cfd85939f)(min, (0, $6ef21f0f78b05b42$export$96ec731ed4dcb222)(value, max));
}
function $a74f4705448ffa34$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $a74f4705448ffa34$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $7c85c67794877a2e$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $da2725863909d664$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $6ea1dba79859e65b$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $887807fbc3cfc257$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $e77032ca49bef06d$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $6c666a63b1170d66$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $e0353e19747514cd$export$1e95b668f3b82d) : (0, $e0353e19747514cd$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $e0353e19747514cd$export$40e543e69a8b3fbb) : (0, $e0353e19747514cd$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $e0353e19747514cd$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $e0353e19747514cd$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $1740287cad636dee$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $6b48e5e1dd3042c6$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $a74f4705448ffa34$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $660a963acc67df3f$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $a74f4705448ffa34$export$f28d906d67a997f3)(tether ? (0, $6ef21f0f78b05b42$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $6ef21f0f78b05b42$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $e0353e19747514cd$export$1e95b668f3b82d) : (0, $e0353e19747514cd$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $e0353e19747514cd$export$40e543e69a8b3fbb) : (0, $e0353e19747514cd$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $e0353e19747514cd$export$1e95b668f3b82d),
            (0, $e0353e19747514cd$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $a74f4705448ffa34$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $a74f4705448ffa34$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7c85c67794877a2e$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $7c85c67794877a2e$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $bef34c9598b43fa4$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $ca4f89cf7a7cf2a0$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $0a01993d8a8ec30f$export$2e2bcd8739ae039)(padding, (0, $e0353e19747514cd$export$aec2ce47c367b8c3)));
};
function $bef34c9598b43fa4$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $6ea1dba79859e65b$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $e77032ca49bef06d$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $e0353e19747514cd$export$eabcd2c8791e7bf4),
        (0, $e0353e19747514cd$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $bef34c9598b43fa4$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $1740287cad636dee$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $e0353e19747514cd$export$1e95b668f3b82d) : (0, $e0353e19747514cd$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $e0353e19747514cd$export$40e543e69a8b3fbb) : (0, $e0353e19747514cd$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $660a963acc67df3f$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $a74f4705448ffa34$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $bef34c9598b43fa4$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $a497a521440eee43$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $bef34c9598b43fa4$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $bef34c9598b43fa4$var$arrow,
    effect: $bef34c9598b43fa4$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $8fdb497d6d06dab9$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $8fdb497d6d06dab9$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $e0353e19747514cd$export$1e95b668f3b82d),
        (0, $e0353e19747514cd$export$79ffe56a765070d2),
        (0, $e0353e19747514cd$export$40e543e69a8b3fbb),
        (0, $e0353e19747514cd$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $8fdb497d6d06dab9$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $da2725863909d664$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $da2725863909d664$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $8fdb497d6d06dab9$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $8fdb497d6d06dab9$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $8fdb497d6d06dab9$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $8fdb497d6d06dab9$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $8fdb497d6d06dab9$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $8fdb497d6d06dab9$var$hide
};




var $e453b94f22a42d77$export$d34966752335dd47 = [
    (0, $cf024573759ceac7$export$2e2bcd8739ae039),
    (0, $425bc067444cf775$export$2e2bcd8739ae039),
    (0, $9f0720af9d2106c8$export$2e2bcd8739ae039),
    (0, $46495d70e14a5f77$export$2e2bcd8739ae039),
    (0, $08cee96b8329b7fe$export$2e2bcd8739ae039),
    (0, $ec97543825a11fdd$export$2e2bcd8739ae039),
    (0, $7c85c67794877a2e$export$2e2bcd8739ae039),
    (0, $bef34c9598b43fa4$export$2e2bcd8739ae039),
    (0, $8fdb497d6d06dab9$export$2e2bcd8739ae039)
];
var $e453b94f22a42d77$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $dafbbaa64c367ed0$export$ed5e13716264f202)({
    defaultModifiers: $e453b94f22a42d77$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules








function $d7475a3250f52642$export$1b69b6cd0fa638a1(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiPopper', slot);
}
const $d7475a3250f52642$var$popperClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiPopper', [
    'root'
]);
var $d7475a3250f52642$export$2e2bcd8739ae039 = $d7475a3250f52642$var$popperClasses;



'use client';
function $da4754cc0fb2cb47$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $da4754cc0fb2cb47$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $da4754cc0fb2cb47$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $da4754cc0fb2cb47$var$isVirtualElement(element) {
    return !$da4754cc0fb2cb47$var$isHTMLElement(element);
}
const $da4754cc0fb2cb47$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $d7475a3250f52642$export$1b69b6cd0fa638a1), classes);
};
const $da4754cc0fb2cb47$var$defaultPopperOptions = {};
const $da4754cc0fb2cb47$var$PopperTooltip = /*#__PURE__*/ $h4Bez.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp, // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other } = props;
    const tooltipRef = $h4Bez.useRef(null);
    const ownRef = (0, $4fa58c431bc87919$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $h4Bez.useRef(null);
    const handlePopperRef = (0, $4fa58c431bc87919$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $h4Bez.useRef(handlePopperRef);
    (0, $01a3a2b63fe8dafe$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $h4Bez.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $da4754cc0fb2cb47$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $h4Bez.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $h4Bez.useState($da4754cc0fb2cb47$var$resolveAnchorEl(anchorEl));
    $h4Bez.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $h4Bez.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($da4754cc0fb2cb47$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $01a3a2b63fe8dafe$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $e453b94f22a42d77$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, {
            placement: rtlPlacement,
            ...popperOptions,
            modifiers: popperModifiers
        });
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $da4754cc0fb2cb47$var$useUtilityClasses(props);
    const Root = slots.root ?? 'div';
    const rootProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Root, {
        ...rootProps,
        children: typeof children === 'function' ? children(childProps) : children
    });
});
/**
 * @ignore - internal component.
 */ const $da4754cc0fb2cb47$var$Popper = /*#__PURE__*/ $h4Bez.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $da4754cc0fb2cb47$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const [exited, setExited] = $h4Bez.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $da4754cc0fb2cb47$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $da4754cc0fb2cb47$var$isHTMLElement(resolvedAnchorEl) ? (0, $2e2b971777d65c3c$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $2e2b971777d65c3c$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8653e21686aeef13$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($da4754cc0fb2cb47$var$PopperTooltip, {
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots,
            ...other,
            style: {
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display,
                ...style
            },
            TransitionProps: transitionProps,
            children: children
        })
    });
});
var $da4754cc0fb2cb47$export$2e2bcd8739ae039 = $da4754cc0fb2cb47$var$Popper;





'use client';
const $5882b72728fa3109$var$PopperRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $da4754cc0fb2cb47$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root'
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $5882b72728fa3109$var$Popper = /*#__PURE__*/ $h4Bez.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, $c12c19e2bf4d75c0$export$b2dd014b6c321cb)();
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps, ...other } = props;
    const RootComponent = slots?.root ?? components?.Root;
    const otherProps = {
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition,
        ...other
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($5882b72728fa3109$var$PopperRoot, {
        as: component,
        direction: isRtl ? 'rtl' : 'ltr',
        slots: {
            root: RootComponent
        },
        slotProps: slotProps ?? componentsProps,
        ...otherProps,
        ref: ref
    });
});
var $5882b72728fa3109$export$2e2bcd8739ae039 = $5882b72728fa3109$var$Popper;









function $46cce084e2d17d19$export$837848f5f6cee923(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiTooltip', slot);
}
const $46cce084e2d17d19$var$tooltipClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $46cce084e2d17d19$export$2e2bcd8739ae039 = $46cce084e2d17d19$var$tooltipClasses;



'use client';
function $69cdbe69cde47e02$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $69cdbe69cde47e02$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $46cce084e2d17d19$export$837848f5f6cee923), classes);
};
const $69cdbe69cde47e02$var$TooltipPopper = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $5882b72728fa3109$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInteractive,
                style: {
                    pointerEvents: 'auto'
                }
            },
            {
                props: ({ open: open })=>!open,
                style: {
                    pointerEvents: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    [`&[data-popper-placement*="bottom"] .${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).arrow}`]: {
                        top: 0,
                        marginTop: '-0.71em',
                        '&::before': {
                            transformOrigin: '0 100%'
                        }
                    },
                    [`&[data-popper-placement*="top"] .${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).arrow}`]: {
                        bottom: 0,
                        marginBottom: '-0.71em',
                        '&::before': {
                            transformOrigin: '100% 0'
                        }
                    },
                    [`&[data-popper-placement*="right"] .${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '100% 100%'
                        }
                    },
                    [`&[data-popper-placement*="left"] .${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '0 0'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            }
        ]
    })));
const $69cdbe69cde47e02$var$TooltipTooltip = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.placement.split('-')[0])}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium,
        [`.${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
            transformOrigin: 'right center'
        },
        [`.${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
            transformOrigin: 'left center'
        },
        [`.${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: {
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        },
        [`.${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: {
            transformOrigin: 'center top',
            marginTop: '14px'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    position: 'relative',
                    margin: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    padding: '8px 16px',
                    fontSize: theme.typography.pxToRem(14),
                    lineHeight: `${$69cdbe69cde47e02$var$round(16 / 14)}em`,
                    fontWeight: theme.typography.fontWeightRegular
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl,
                style: {
                    [`.${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '14px'
                    },
                    [`.${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '24px'
                    },
                    [`.${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl,
                style: {
                    [`.${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '14px'
                    },
                    [`.${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '24px'
                    },
                    [`.${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: {
                        marginBottom: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $46cce084e2d17d19$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: {
                        marginTop: '24px'
                    }
                }
            }
        ]
    })));
const $69cdbe69cde47e02$var$TooltipArrow = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    })));
let $69cdbe69cde47e02$var$hystersisOpen = false;
const $69cdbe69cde47e02$var$hystersisTimer = new (0, $4497065fec36f675$export$786b4da70f00938b)();
let $69cdbe69cde47e02$var$cursorPosition = {
    x: 0,
    y: 0
};
function $69cdbe69cde47e02$export$b9ee5a7ace0541f8() {
    $69cdbe69cde47e02$var$hystersisOpen = false;
    $69cdbe69cde47e02$var$hystersisTimer.clear();
}
function $69cdbe69cde47e02$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $69cdbe69cde47e02$var$Tooltip = /*#__PURE__*/ $h4Bez.forwardRef(function Tooltip(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, classes: classesProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionProps, ...other } = props;
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $h4Bez.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $cd99783e1cac2d84$export$2e2bcd8739ae039)();
    const isRtl = (0, $c12c19e2bf4d75c0$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $h4Bez.useState();
    const [arrowRef, setArrowRef] = $h4Bez.useState(null);
    const ignoreNonTouchEvents = $h4Bez.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $4497065fec36f675$export$2e2bcd8739ae039)();
    const enterTimer = (0, $4497065fec36f675$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $4497065fec36f675$export$2e2bcd8739ae039)();
    const touchTimer = (0, $4497065fec36f675$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $7e1e510fcc288095$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $05678a2096742019$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $h4Bez.useRef();
    const stopTouchInteraction = (0, $ea79b826054a58a6$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $h4Bez.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $69cdbe69cde47e02$var$hystersisTimer.clear();
        $69cdbe69cde47e02$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $ea79b826054a58a6$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $69cdbe69cde47e02$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $69cdbe69cde47e02$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $69cdbe69cde47e02$var$hystersisOpen && enterNextDelay) enterTimer.start($69cdbe69cde47e02$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const [, setChildIsFocusVisible] = $h4Bez.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $90a9a7d90476ac81$export$2e2bcd8739ae039)(event.target)) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        if ((0, $90a9a7d90476ac81$export$2e2bcd8739ae039)(event.target)) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $h4Bez.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (nativeEvent.key === 'Escape') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $6fa00ac7fde563d8$export$2e2bcd8739ae039)((0, $ba4f9121b652949b$export$2e2bcd8739ae039)(children), setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $h4Bez.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $69cdbe69cde47e02$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = {
        ...nameOrDescProps,
        ...other,
        ...children.props,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef,
        ...followCursor ? {
            onMouseMove: handleMouseMove
        } : {}
    };
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $69cdbe69cde47e02$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $69cdbe69cde47e02$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $69cdbe69cde47e02$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $69cdbe69cde47e02$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const ownerState = {
        ...props,
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    };
    const resolvedPopperProps = typeof slotProps.popper === 'function' ? slotProps.popper(ownerState) : slotProps.popper;
    const popperOptions = $h4Bez.useMemo(()=>{
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if (PopperProps.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        if (resolvedPopperProps?.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
        return {
            ...PopperProps.popperOptions,
            ...resolvedPopperProps?.popperOptions,
            modifiers: tooltipModifiers
        };
    }, [
        arrowRef,
        PopperProps.popperOptions,
        resolvedPopperProps?.popperOptions
    ]);
    const classes = $69cdbe69cde47e02$var$useUtilityClasses(ownerState);
    const resolvedTransitionProps = typeof slotProps.transition === 'function' ? slotProps.transition(ownerState) : slotProps.transition;
    const externalForwardedProps = {
        slots: {
            popper: components.Popper,
            transition: components.Transition ?? TransitionComponentProp,
            tooltip: components.Tooltip,
            arrow: components.Arrow,
            ...slots
        },
        slotProps: {
            arrow: slotProps.arrow ?? componentsProps.arrow,
            popper: {
                ...PopperProps,
                ...resolvedPopperProps ?? componentsProps.popper
            },
            // resolvedPopperProps can be spread because it's already an object
            tooltip: slotProps.tooltip ?? componentsProps.tooltip,
            transition: {
                ...TransitionProps,
                ...resolvedTransitionProps ?? componentsProps.transition
            }
        }
    };
    const [PopperSlot, popperSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('popper', {
        elementType: $69cdbe69cde47e02$var$TooltipPopper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.popper, PopperProps?.className)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $73da2bbf79b5829f$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('tooltip', {
        elementType: $69cdbe69cde47e02$var$TooltipTooltip,
        className: classes.tooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ArrowSlot, arrowSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('arrow', {
        elementType: $69cdbe69cde47e02$var$TooltipArrow,
        className: classes.arrow,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: setArrowRef
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($h4Bez.Fragment, {
        children: [
            /*#__PURE__*/ $h4Bez.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(PopperSlot, {
                as: PopperComponentProp ?? (0, $5882b72728fa3109$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $69cdbe69cde47e02$var$cursorPosition.y,
                            left: $69cdbe69cde47e02$var$cursorPosition.x,
                            right: $69cdbe69cde47e02$var$cursorPosition.x,
                            bottom: $69cdbe69cde47e02$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true,
                ...interactiveWrapperListeners,
                ...popperSlotProps,
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(TransitionSlot, {
                        timeout: theme.transitions.duration.shorter,
                        ...TransitionPropsInner,
                        ...transitionSlotProps,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)(TooltipSlot, {
                            ...tooltipSlotProps,
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(ArrowSlot, {
                                    ...arrowSlotProps
                                }) : null
                            ]
                        })
                    })
            })
        ]
    });
});
var $69cdbe69cde47e02$export$2e2bcd8739ae039 = $69cdbe69cde47e02$var$Tooltip;



var $h4Bez = parcelRequire("h4Bez");


var $h4Bez = parcelRequire("h4Bez");
function $2b2eb81dab4d649a$export$2f8294366bb2d67a() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, $h4Bez.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const $2b2eb81dab4d649a$export$71594e8a50f746f4 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
function $2b2eb81dab4d649a$export$5a096129d439f843(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === '[object Window]' || // In Electron context the Window object serializes to [object global]
    elementString === '[object global]';
}
function $2b2eb81dab4d649a$export$8ee0fc9ee280b4ee(node) {
    return 'nodeType' in node;
}
function $2b2eb81dab4d649a$export$38b2d434cce3ea22(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if ($2b2eb81dab4d649a$export$5a096129d439f843(target)) return target;
    if (!$2b2eb81dab4d649a$export$8ee0fc9ee280b4ee(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function $2b2eb81dab4d649a$export$62858bae88b53fd0(node) {
    const { Document: Document } = $2b2eb81dab4d649a$export$38b2d434cce3ea22(node);
    return node instanceof Document;
}
function $2b2eb81dab4d649a$export$1b3bfaa9684536aa(node) {
    if ($2b2eb81dab4d649a$export$5a096129d439f843(node)) return false;
    return node instanceof $2b2eb81dab4d649a$export$38b2d434cce3ea22(node).HTMLElement;
}
function $2b2eb81dab4d649a$export$17eda790a720ec57(node) {
    return node instanceof $2b2eb81dab4d649a$export$38b2d434cce3ea22(node).SVGElement;
}
function $2b2eb81dab4d649a$export$b204af158042fbac(target) {
    if (!target) return document;
    if ($2b2eb81dab4d649a$export$5a096129d439f843(target)) return target.document;
    if (!$2b2eb81dab4d649a$export$8ee0fc9ee280b4ee(target)) return document;
    if ($2b2eb81dab4d649a$export$62858bae88b53fd0(target)) return target;
    if ($2b2eb81dab4d649a$export$1b3bfaa9684536aa(target) || $2b2eb81dab4d649a$export$17eda790a720ec57(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const $2b2eb81dab4d649a$export$700979bc83e7db82 = $2b2eb81dab4d649a$export$71594e8a50f746f4 ? (0, $h4Bez.useLayoutEffect) : (0, $h4Bez.useEffect);
function $2b2eb81dab4d649a$export$90fc3a17d93f704c(handler) {
    const handlerRef = (0, $h4Bez.useRef)(handler);
    $2b2eb81dab4d649a$export$700979bc83e7db82(()=>{
        handlerRef.current = handler;
    });
    return (0, $h4Bez.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function $2b2eb81dab4d649a$export$f4b266cd2aae9cb1() {
    const intervalRef = (0, $h4Bez.useRef)(null);
    const set = (0, $h4Bez.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, $h4Bez.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function $2b2eb81dab4d649a$export$86c4283a11f23f95(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, $h4Bez.useRef)(value);
    $2b2eb81dab4d649a$export$700979bc83e7db82(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function $2b2eb81dab4d649a$export$b0d7b7f1fcd613d1(callback, dependencies) {
    const valueRef = (0, $h4Bez.useRef)();
    return (0, $h4Bez.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function $2b2eb81dab4d649a$export$bc23c270f170c912(onChange) {
    const onChangeHandler = $2b2eb81dab4d649a$export$90fc3a17d93f704c(onChange);
    const node = (0, $h4Bez.useRef)(null);
    const setNodeRef = (0, $h4Bez.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function $2b2eb81dab4d649a$export$5cae361ad82dce8b(value) {
    const ref = (0, $h4Bez.useRef)();
    (0, $h4Bez.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let $2b2eb81dab4d649a$var$ids = {};
function $2b2eb81dab4d649a$export$c485849f2e393253(prefix, value) {
    return (0, $h4Bez.useMemo)(()=>{
        if (value) return value;
        const id = $2b2eb81dab4d649a$var$ids[prefix] == null ? 0 : $2b2eb81dab4d649a$var$ids[prefix] + 1;
        $2b2eb81dab4d649a$var$ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function $2b2eb81dab4d649a$var$createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, {
            ...object
        });
    };
}
const $2b2eb81dab4d649a$export$e16d8520af44a096 = /*#__PURE__*/ $2b2eb81dab4d649a$var$createAdjustmentFn(1);
const $2b2eb81dab4d649a$export$4e2d2ead65e5f7e3 = /*#__PURE__*/ $2b2eb81dab4d649a$var$createAdjustmentFn(-1);
function $2b2eb81dab4d649a$export$d0e71af79cd586c6(event) {
    return 'clientX' in event && 'clientY' in event;
}
function $2b2eb81dab4d649a$export$130b789831072f4c(event) {
    if (!event) return false;
    const { KeyboardEvent: KeyboardEvent } = $2b2eb81dab4d649a$export$38b2d434cce3ea22(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function $2b2eb81dab4d649a$export$c4dfce035d43d1e0(event) {
    if (!event) return false;
    const { TouchEvent: TouchEvent } = $2b2eb81dab4d649a$export$38b2d434cce3ea22(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function $2b2eb81dab4d649a$export$36195c8aa1517e04(event) {
    if ($2b2eb81dab4d649a$export$c4dfce035d43d1e0(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x: x,
                y: y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x: x,
                y: y
            };
        }
    }
    if ($2b2eb81dab4d649a$export$d0e71af79cd586c6(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const $2b2eb81dab4d649a$export$c4ffa16951855e28 = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x: x, y: y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX: scaleX, scaleY: scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                $2b2eb81dab4d649a$export$c4ffa16951855e28.Translate.toString(transform),
                $2b2eb81dab4d649a$export$c4ffa16951855e28.Scale.toString(transform)
            ].join(' ');
        }
    },
    Transition: {
        toString (_ref) {
            let { property: property, duration: duration, easing: easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const $2b2eb81dab4d649a$var$SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';
function $2b2eb81dab4d649a$export$44f71d798fd0a62b(element) {
    if (element.matches($2b2eb81dab4d649a$var$SELECTOR)) return element;
    return element.querySelector($2b2eb81dab4d649a$var$SELECTOR);
}



var $h4Bez = parcelRequire("h4Bez");
const $db813ef98be0f9d8$var$hiddenStyles = {
    display: 'none'
};
function $db813ef98be0f9d8$export$1496ac55023363a5(_ref) {
    let { id: id, value: value } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("div", {
        id: id,
        style: $db813ef98be0f9d8$var$hiddenStyles
    }, value);
}
function $db813ef98be0f9d8$export$ae99b902be98b17(_ref) {
    let { id: id, announcement: announcement, ariaLiveType: ariaLiveType = "assertive" } = _ref;
    // Hide element visually but keep it readable by screen readers
    const visuallyHidden = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        margin: -1,
        border: 0,
        padding: 0,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(100%)',
        whiteSpace: 'nowrap'
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("div", {
        id: id,
        style: visuallyHidden,
        role: "status",
        "aria-live": ariaLiveType,
        "aria-atomic": true
    }, announcement);
}
function $db813ef98be0f9d8$export$97d78af8d95ca8bd() {
    const [announcement, setAnnouncement] = (0, $h4Bez.useState)('');
    const announce = (0, $h4Bez.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce: announce,
        announcement: announcement
    };
}


const $554db1c65281cd7c$var$DndMonitorContext = /*#__PURE__*/ (0, $h4Bez.createContext)(null);
function $554db1c65281cd7c$export$1182af90218a7b81(listener) {
    const registerListener = (0, $h4Bez.useContext)($554db1c65281cd7c$var$DndMonitorContext);
    (0, $h4Bez.useEffect)(()=>{
        if (!registerListener) throw new Error('useDndMonitor must be used within a children of <DndContext>');
        const unsubscribe = registerListener(listener);
        return unsubscribe;
    }, [
        listener,
        registerListener
    ]);
}
function $554db1c65281cd7c$var$useDndMonitorProvider() {
    const [listeners] = (0, $h4Bez.useState)(()=>new Set());
    const registerListener = (0, $h4Bez.useCallback)((listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }, [
        listeners
    ]);
    const dispatch = (0, $h4Bez.useCallback)((_ref)=>{
        let { type: type, event: event } = _ref;
        listeners.forEach((listener)=>{
            var _listener$type;
            return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
        });
    }, [
        listeners
    ]);
    return [
        dispatch,
        registerListener
    ];
}
const $554db1c65281cd7c$export$2547556495408594 = {
    draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const $554db1c65281cd7c$export$6acb64047911dd54 = {
    onDragStart (_ref) {
        let { active: active } = _ref;
        return "Picked up draggable item " + active.id + ".";
    },
    onDragOver (_ref2) {
        let { active: active, over: over } = _ref2;
        if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
        return "Draggable item " + active.id + " is no longer over a droppable area.";
    },
    onDragEnd (_ref3) {
        let { active: active, over: over } = _ref3;
        if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
        return "Draggable item " + active.id + " was dropped.";
    },
    onDragCancel (_ref4) {
        let { active: active } = _ref4;
        return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
    }
};
function $554db1c65281cd7c$var$Accessibility(_ref) {
    let { announcements: announcements = $554db1c65281cd7c$export$6acb64047911dd54, container: container, hiddenTextDescribedById: hiddenTextDescribedById, screenReaderInstructions: screenReaderInstructions = $554db1c65281cd7c$export$2547556495408594 } = _ref;
    const { announce: announce, announcement: announcement } = (0, $db813ef98be0f9d8$export$97d78af8d95ca8bd)();
    const liveRegionId = (0, $2b2eb81dab4d649a$export$c485849f2e393253)("DndLiveRegion");
    const [mounted, setMounted] = (0, $h4Bez.useState)(false);
    (0, $h4Bez.useEffect)(()=>{
        setMounted(true);
    }, []);
    $554db1c65281cd7c$export$1182af90218a7b81((0, $h4Bez.useMemo)(()=>({
            onDragStart (_ref2) {
                let { active: active } = _ref2;
                announce(announcements.onDragStart({
                    active: active
                }));
            },
            onDragMove (_ref3) {
                let { active: active, over: over } = _ref3;
                if (announcements.onDragMove) announce(announcements.onDragMove({
                    active: active,
                    over: over
                }));
            },
            onDragOver (_ref4) {
                let { active: active, over: over } = _ref4;
                announce(announcements.onDragOver({
                    active: active,
                    over: over
                }));
            },
            onDragEnd (_ref5) {
                let { active: active, over: over } = _ref5;
                announce(announcements.onDragEnd({
                    active: active,
                    over: over
                }));
            },
            onDragCancel (_ref6) {
                let { active: active, over: over } = _ref6;
                announce(announcements.onDragCancel({
                    active: active,
                    over: over
                }));
            }
        }), [
        announce,
        announcements
    ]));
    if (!mounted) return null;
    const markup = (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement((0, $db813ef98be0f9d8$export$1496ac55023363a5), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement((0, $db813ef98be0f9d8$export$ae99b902be98b17), {
        id: liveRegionId,
        announcement: announcement
    }));
    return container ? (0, $68fd039c491aa2b2$exports.createPortal)(markup, container) : markup;
}
var $554db1c65281cd7c$var$Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})($554db1c65281cd7c$var$Action || ($554db1c65281cd7c$var$Action = {}));
function $554db1c65281cd7c$var$noop() {}
function $554db1c65281cd7c$export$cc72dd71f4ec69eb(sensor, options) {
    return (0, $h4Bez.useMemo)(()=>({
            sensor: sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function $554db1c65281cd7c$export$19012f58216d597f() {
    for(var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++)sensors[_key] = arguments[_key];
    return (0, $h4Bez.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
const $554db1c65281cd7c$export$597cbd7bbd10deb4 = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function $554db1c65281cd7c$var$distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function $554db1c65281cd7c$var$getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, $2b2eb81dab4d649a$export$36195c8aa1517e04)(event);
    if (!eventCoordinates) return '0 0';
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return transformOrigin.x + "% " + transformOrigin.y + "%";
}
/**
 * Sort collisions from smallest to greatest value
 */ function $554db1c65281cd7c$var$sortCollisionsAsc(_ref, _ref2) {
    let { data: { value: a } } = _ref;
    let { data: { value: b } } = _ref2;
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function $554db1c65281cd7c$var$sortCollisionsDesc(_ref3, _ref4) {
    let { data: { value: a } } = _ref3;
    let { data: { value: b } } = _ref4;
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function $554db1c65281cd7c$var$cornersOfRectangle(_ref5) {
    let { left: left, top: top, height: height, width: width } = _ref5;
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function $554db1c65281cd7c$export$ef1beab6d7287295(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function $554db1c65281cd7c$var$centerOfRectangle(rect, left, top) {
    if (left === void 0) left = rect.left;
    if (top === void 0) top = rect.top;
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const $554db1c65281cd7c$export$c8e785ae6b74bab8 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const centerRect = $554db1c65281cd7c$var$centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const distBetween = $554db1c65281cd7c$var$distanceBetween($554db1c65281cd7c$var$centerOfRectangle(rect), centerRect);
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort($554db1c65281cd7c$var$sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const $554db1c65281cd7c$export$c3a6c1c7122b31c9 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const corners = $554db1c65281cd7c$var$cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const rectCorners = $554db1c65281cd7c$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + $554db1c65281cd7c$var$distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($554db1c65281cd7c$var$sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function $554db1c65281cd7c$var$getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const $554db1c65281cd7c$export$953346c40b5eb62a = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const intersectionRatio = $554db1c65281cd7c$var$getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort($554db1c65281cd7c$var$sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function $554db1c65281cd7c$var$isPointWithinRect(point, rect) {
    const { top: top, left: left, bottom: bottom, right: right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const $554db1c65281cd7c$export$cd834c0ba378cb94 = (_ref)=>{
    let { droppableContainers: droppableContainers, droppableRects: droppableRects, pointerCoordinates: pointerCoordinates } = _ref;
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect && $554db1c65281cd7c$var$isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = $554db1c65281cd7c$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + $554db1c65281cd7c$var$distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($554db1c65281cd7c$var$sortCollisionsAsc);
};
function $554db1c65281cd7c$var$adjustScale(transform, rect1, rect2) {
    return {
        ...transform,
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    };
}
function $554db1c65281cd7c$var$getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : $554db1c65281cd7c$export$597cbd7bbd10deb4;
}
function $554db1c65281cd7c$var$createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((acc, adjustment)=>({
                ...acc,
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), {
            ...rect
        });
    };
}
const $554db1c65281cd7c$var$getAdjustedRect = /*#__PURE__*/ $554db1c65281cd7c$var$createRectAdjustmentFn(1);
function $554db1c65281cd7c$var$parseTransform(transform) {
    if (transform.startsWith('matrix3d(')) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith('matrix(')) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
function $554db1c65281cd7c$var$inverseTransform(rect, transform, transformOrigin) {
    const parsedTransform = $554db1c65281cd7c$var$parseTransform(transform);
    if (!parsedTransform) return rect;
    const { scaleX: scaleX, scaleY: scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(' ') + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const $554db1c65281cd7c$var$defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function $554db1c65281cd7c$export$b6aa1f30c53d7454(element, options) {
    if (options === void 0) options = $554db1c65281cd7c$var$defaultOptions;
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { transform: transform, transformOrigin: transformOrigin } = (0, $2b2eb81dab4d649a$export$38b2d434cce3ea22)(element).getComputedStyle(element);
        if (transform) rect = $554db1c65281cd7c$var$inverseTransform(rect, transform, transformOrigin);
    }
    const { top: top, left: left, width: width, height: height, bottom: bottom, right: right } = rect;
    return {
        top: top,
        left: left,
        width: width,
        height: height,
        bottom: bottom,
        right: right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function $554db1c65281cd7c$var$getTransformAgnosticClientRect(element) {
    return $554db1c65281cd7c$export$b6aa1f30c53d7454(element, {
        ignoreTransform: true
    });
}
function $554db1c65281cd7c$var$getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width: width,
        height: height
    };
}
function $554db1c65281cd7c$var$isFixed(node, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $2b2eb81dab4d649a$export$38b2d434cce3ea22)(node).getComputedStyle(node);
    return computedStyle.position === 'fixed';
}
function $554db1c65281cd7c$var$isScrollable(element, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $2b2eb81dab4d649a$export$38b2d434cce3ea22)(element).getComputedStyle(element);
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        'overflow',
        'overflowX',
        'overflowY'
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === 'string' ? overflowRegex.test(value) : false;
    });
}
function $554db1c65281cd7c$export$e4864aa91b5ed091(element, limit) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.length >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ((0, $2b2eb81dab4d649a$export$62858bae88b53fd0)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, $2b2eb81dab4d649a$export$1b3bfaa9684536aa)(node) || (0, $2b2eb81dab4d649a$export$17eda790a720ec57)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const computedStyle = (0, $2b2eb81dab4d649a$export$38b2d434cce3ea22)(element).getComputedStyle(node);
        if (node !== element) {
            if ($554db1c65281cd7c$var$isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if ($554db1c65281cd7c$var$isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function $554db1c65281cd7c$var$getFirstScrollableAncestor(node) {
    const [firstScrollableAncestor] = $554db1c65281cd7c$export$e4864aa91b5ed091(node, 1);
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function $554db1c65281cd7c$var$getScrollableElement(element) {
    if (!(0, $2b2eb81dab4d649a$export$71594e8a50f746f4) || !element) return null;
    if ((0, $2b2eb81dab4d649a$export$5a096129d439f843)(element)) return element;
    if (!(0, $2b2eb81dab4d649a$export$8ee0fc9ee280b4ee)(element)) return null;
    if ((0, $2b2eb81dab4d649a$export$62858bae88b53fd0)(element) || element === (0, $2b2eb81dab4d649a$export$b204af158042fbac)(element).scrollingElement) return window;
    if ((0, $2b2eb81dab4d649a$export$1b3bfaa9684536aa)(element)) return element;
    return null;
}
function $554db1c65281cd7c$var$getScrollXCoordinate(element) {
    if ((0, $2b2eb81dab4d649a$export$5a096129d439f843)(element)) return element.scrollX;
    return element.scrollLeft;
}
function $554db1c65281cd7c$var$getScrollYCoordinate(element) {
    if ((0, $2b2eb81dab4d649a$export$5a096129d439f843)(element)) return element.scrollY;
    return element.scrollTop;
}
function $554db1c65281cd7c$var$getScrollCoordinates(element) {
    return {
        x: $554db1c65281cd7c$var$getScrollXCoordinate(element),
        y: $554db1c65281cd7c$var$getScrollYCoordinate(element)
    };
}
var $554db1c65281cd7c$var$Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})($554db1c65281cd7c$var$Direction || ($554db1c65281cd7c$var$Direction = {}));
function $554db1c65281cd7c$var$isDocumentScrollingElement(element) {
    if (!(0, $2b2eb81dab4d649a$export$71594e8a50f746f4) || !element) return false;
    return element === document.scrollingElement;
}
function $554db1c65281cd7c$var$getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = $554db1c65281cd7c$var$isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll
    };
}
const $554db1c65281cd7c$var$defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function $554db1c65281cd7c$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
    let { top: top, left: left, right: right, bottom: bottom } = _ref;
    if (acceleration === void 0) acceleration = 10;
    if (thresholdPercentage === void 0) thresholdPercentage = $554db1c65281cd7c$var$defaultThreshold;
    const { isTop: isTop, isBottom: isBottom, isLeft: isLeft, isRight: isRight } = $554db1c65281cd7c$var$getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= scrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = $554db1c65281cd7c$var$Direction.Backward;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = $554db1c65281cd7c$var$Direction.Forward;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= scrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = $554db1c65281cd7c$var$Direction.Forward;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = $554db1c65281cd7c$var$Direction.Backward;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction: direction,
        speed: speed
    };
}
function $554db1c65281cd7c$var$getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top: top, left: left, right: right, bottom: bottom } = element.getBoundingClientRect();
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $554db1c65281cd7c$var$getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, $2b2eb81dab4d649a$export$e16d8520af44a096)(acc, $554db1c65281cd7c$var$getScrollCoordinates(node));
    }, $554db1c65281cd7c$export$597cbd7bbd10deb4);
}
function $554db1c65281cd7c$var$getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $554db1c65281cd7c$var$getScrollXCoordinate(node);
    }, 0);
}
function $554db1c65281cd7c$var$getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $554db1c65281cd7c$var$getScrollYCoordinate(node);
    }, 0);
}
function $554db1c65281cd7c$var$scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) measure = $554db1c65281cd7c$export$b6aa1f30c53d7454;
    if (!element) return;
    const { top: top, left: left, bottom: bottom, right: right } = measure(element);
    const firstScrollableAncestor = $554db1c65281cd7c$var$getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) return;
    if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
        block: 'center',
        inline: 'center'
    });
}
const $554db1c65281cd7c$var$properties = [
    [
        'x',
        [
            'left',
            'right'
        ],
        $554db1c65281cd7c$var$getScrollXOffset
    ],
    [
        'y',
        [
            'top',
            'bottom'
        ],
        $554db1c65281cd7c$var$getScrollYOffset
    ]
];
class $554db1c65281cd7c$var$Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = $554db1c65281cd7c$export$e4864aa91b5ed091(element);
        const scrollOffsets = $554db1c65281cd7c$var$getScrollOffsets(scrollableAncestors);
        this.rect = {
            ...rect
        };
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of $554db1c65281cd7c$var$properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, 'rect', {
            enumerable: false
        });
    }
}
class $554db1c65281cd7c$var$Listeners {
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}
function $554db1c65281cd7c$var$getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget: EventTarget } = (0, $2b2eb81dab4d649a$export$38b2d434cce3ea22)(target);
    return target instanceof EventTarget ? target : (0, $2b2eb81dab4d649a$export$b204af158042fbac)(target);
}
function $554db1c65281cd7c$var$hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === 'number') return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ('x' in measurement && 'y' in measurement) return dx > measurement.x && dy > measurement.y;
    if ('x' in measurement) return dx > measurement.x;
    if ('y' in measurement) return dy > measurement.y;
    return false;
}
var $554db1c65281cd7c$var$EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})($554db1c65281cd7c$var$EventName || ($554db1c65281cd7c$var$EventName = {}));
function $554db1c65281cd7c$var$preventDefault(event) {
    event.preventDefault();
}
function $554db1c65281cd7c$var$stopPropagation(event) {
    event.stopPropagation();
}
var $554db1c65281cd7c$export$a8b1916dba3ae88b;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
    KeyboardCode["Tab"] = "Tab";
})($554db1c65281cd7c$export$a8b1916dba3ae88b || ($554db1c65281cd7c$export$a8b1916dba3ae88b = {}));
const $554db1c65281cd7c$var$defaultKeyboardCodes = {
    start: [
        $554db1c65281cd7c$export$a8b1916dba3ae88b.Space,
        $554db1c65281cd7c$export$a8b1916dba3ae88b.Enter
    ],
    cancel: [
        $554db1c65281cd7c$export$a8b1916dba3ae88b.Esc
    ],
    end: [
        $554db1c65281cd7c$export$a8b1916dba3ae88b.Space,
        $554db1c65281cd7c$export$a8b1916dba3ae88b.Enter,
        $554db1c65281cd7c$export$a8b1916dba3ae88b.Tab
    ]
};
const $554db1c65281cd7c$export$ae4c9a18005b0235 = (event, _ref)=>{
    let { currentCoordinates: currentCoordinates } = _ref;
    switch(event.code){
        case $554db1c65281cd7c$export$a8b1916dba3ae88b.Right:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x + 25
            };
        case $554db1c65281cd7c$export$a8b1916dba3ae88b.Left:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x - 25
            };
        case $554db1c65281cd7c$export$a8b1916dba3ae88b.Down:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y + 25
            };
        case $554db1c65281cd7c$export$a8b1916dba3ae88b.Up:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y - 25
            };
    }
    return undefined;
};
class $554db1c65281cd7c$export$44d67f2a438aeba9 {
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.referenceCoordinates = void 0;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target: target } } = props;
        this.props = props;
        this.listeners = new $554db1c65281cd7c$var$Listeners((0, $2b2eb81dab4d649a$export$b204af158042fbac)(target));
        this.windowListeners = new $554db1c65281cd7c$var$Listeners((0, $2b2eb81dab4d649a$export$38b2d434cce3ea22)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        this.handleStart();
        this.windowListeners.add($554db1c65281cd7c$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($554db1c65281cd7c$var$EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add($554db1c65281cd7c$var$EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode: activeNode, onStart: onStart } = this.props;
        const node = activeNode.node.current;
        if (node) $554db1c65281cd7c$var$scrollIntoViewIfNeeded(node);
        onStart($554db1c65281cd7c$export$597cbd7bbd10deb4);
    }
    handleKeyDown(event) {
        if ((0, $2b2eb81dab4d649a$export$130b789831072f4c)(event)) {
            const { active: active, context: context, options: options } = this.props;
            const { keyboardCodes: keyboardCodes = $554db1c65281cd7c$var$defaultKeyboardCodes, coordinateGetter: coordinateGetter = $554db1c65281cd7c$export$ae4c9a18005b0235, scrollBehavior: scrollBehavior = 'smooth' } = options;
            const { code: code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect: collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : $554db1c65281cd7c$export$597cbd7bbd10deb4;
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            const newCoordinates = coordinateGetter(event, {
                active: active,
                context: context.current,
                currentCoordinates: currentCoordinates
            });
            if (newCoordinates) {
                const coordinatesDelta = (0, $2b2eb81dab4d649a$export$4e2d2ead65e5f7e3)(newCoordinates, currentCoordinates);
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors: scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const { isTop: isTop, isRight: isRight, isLeft: isLeft, isBottom: isBottom, maxScroll: maxScroll, minScroll: minScroll } = $554db1c65281cd7c$var$getScrollPosition(scrollContainer);
                    const scrollElementRect = $554db1c65281cd7c$var$getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === $554db1c65281cd7c$export$a8b1916dba3ae88b.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === $554db1c65281cd7c$export$a8b1916dba3ae88b.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === $554db1c65281cd7c$export$a8b1916dba3ae88b.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === $554db1c65281cd7c$export$a8b1916dba3ae88b.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === $554db1c65281cd7c$export$a8b1916dba3ae88b.Right && !isRight || direction === $554db1c65281cd7c$export$a8b1916dba3ae88b.Left && !isLeft;
                    const canScrollY = direction === $554db1c65281cd7c$export$a8b1916dba3ae88b.Down && !isBottom || direction === $554db1c65281cd7c$export$a8b1916dba3ae88b.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
                        const canScrollToNewCoordinates = direction === $554db1c65281cd7c$export$a8b1916dba3ae88b.Right && newScrollCoordinates <= maxScroll.x || direction === $554db1c65281cd7c$export$a8b1916dba3ae88b.Left && newScrollCoordinates >= minScroll.x;
                        if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                left: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
                        else scrollDelta.x = direction === $554db1c65281cd7c$export$a8b1916dba3ae88b.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        if (scrollDelta.x) scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
                        const canScrollToNewCoordinates = direction === $554db1c65281cd7c$export$a8b1916dba3ae88b.Down && newScrollCoordinates <= maxScroll.y || direction === $554db1c65281cd7c$export$a8b1916dba3ae88b.Up && newScrollCoordinates >= minScroll.y;
                        if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                top: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
                        else scrollDelta.y = direction === $554db1c65281cd7c$export$a8b1916dba3ae88b.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        if (scrollDelta.y) scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, $2b2eb81dab4d649a$export$e16d8520af44a096)((0, $2b2eb81dab4d649a$export$4e2d2ead65e5f7e3)(newCoordinates, this.referenceCoordinates), scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove: onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd: onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel: onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
$554db1c65281cd7c$export$44d67f2a438aeba9.activators = [
    {
        eventName: 'onKeyDown',
        handler: (event, _ref, _ref2)=>{
            let { keyboardCodes: keyboardCodes = $554db1c65281cd7c$var$defaultKeyboardCodes, onActivation: onActivation } = _ref;
            let { active: active } = _ref2;
            const { code: code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function $554db1c65281cd7c$var$isDistanceConstraint(constraint) {
    return Boolean(constraint && 'distance' in constraint);
}
function $554db1c65281cd7c$var$isDelayConstraint(constraint) {
    return Boolean(constraint && 'delay' in constraint);
}
class $554db1c65281cd7c$var$AbstractPointerSensor {
    constructor(props, events, listenerTarget){
        var _getEventCoordinates;
        if (listenerTarget === void 0) listenerTarget = $554db1c65281cd7c$var$getEventListenerTarget(props.event.target);
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event: event } = props;
        const { target: target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, $2b2eb81dab4d649a$export$b204af158042fbac)(target);
        this.documentListeners = new $554db1c65281cd7c$var$Listeners(this.document);
        this.listeners = new $554db1c65281cd7c$var$Listeners(listenerTarget);
        this.windowListeners = new $554db1c65281cd7c$var$Listeners((0, $2b2eb81dab4d649a$export$38b2d434cce3ea22)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, $2b2eb81dab4d649a$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates : $554db1c65281cd7c$export$597cbd7bbd10deb4;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
    attach() {
        const { events: events, props: { options: { activationConstraint: activationConstraint, bypassActivationConstraint: bypassActivationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        if (events.cancel) this.listeners.add(events.cancel.name, this.handleCancel);
        this.windowListeners.add($554db1c65281cd7c$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($554db1c65281cd7c$var$EventName.DragStart, $554db1c65281cd7c$var$preventDefault);
        this.windowListeners.add($554db1c65281cd7c$var$EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add($554db1c65281cd7c$var$EventName.ContextMenu, $554db1c65281cd7c$var$preventDefault);
        this.documentListeners.add($554db1c65281cd7c$var$EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if (bypassActivationConstraint != null && bypassActivationConstraint({
                event: this.props.event,
                activeNode: this.props.activeNode,
                options: this.props.options
            })) return this.handleStart();
            if ($554db1c65281cd7c$var$isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                this.handlePending(activationConstraint);
                return;
            }
            if ($554db1c65281cd7c$var$isDistanceConstraint(activationConstraint)) {
                this.handlePending(activationConstraint);
                return;
            }
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handlePending(constraint, offset) {
        const { active: active, onPending: onPending } = this.props;
        onPending(active, constraint, this.initialCoordinates, offset);
    }
    handleStart() {
        const { initialCoordinates: initialCoordinates } = this;
        const { onStart: onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add($554db1c65281cd7c$var$EventName.Click, $554db1c65281cd7c$var$stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add($554db1c65281cd7c$var$EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated: activated, initialCoordinates: initialCoordinates, props: props } = this;
        const { onMove: onMove, options: { activationConstraint: activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, $2b2eb81dab4d649a$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates2 : $554db1c65281cd7c$export$597cbd7bbd10deb4;
        const delta = (0, $2b2eb81dab4d649a$export$4e2d2ead65e5f7e3)(initialCoordinates, coordinates); // Constraint validation
        if (!activated && activationConstraint) {
            if ($554db1c65281cd7c$var$isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && $554db1c65281cd7c$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if ($554db1c65281cd7c$var$hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
            }
            if ($554db1c65281cd7c$var$isDelayConstraint(activationConstraint)) {
                if ($554db1c65281cd7c$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
            }
            this.handlePending(activationConstraint, delta);
            return;
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onAbort: onAbort, onEnd: onEnd } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onEnd();
    }
    handleCancel() {
        const { onAbort: onAbort, onCancel: onCancel } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === $554db1c65281cd7c$export$a8b1916dba3ae88b.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
}
const $554db1c65281cd7c$var$events = {
    cancel: {
        name: 'pointercancel'
    },
    move: {
        name: 'pointermove'
    },
    end: {
        name: 'pointerup'
    }
};
class $554db1c65281cd7c$export$b26af955418d6638 extends $554db1c65281cd7c$var$AbstractPointerSensor {
    constructor(props){
        const { event: event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, $2b2eb81dab4d649a$export$b204af158042fbac)(event.target);
        super(props, $554db1c65281cd7c$var$events, listenerTarget);
    }
}
$554db1c65281cd7c$export$b26af955418d6638.activators = [
    {
        eventName: 'onPointerDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $554db1c65281cd7c$var$events$1 = {
    move: {
        name: 'mousemove'
    },
    end: {
        name: 'mouseup'
    }
};
var $554db1c65281cd7c$var$MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})($554db1c65281cd7c$var$MouseButton || ($554db1c65281cd7c$var$MouseButton = {}));
class $554db1c65281cd7c$export$b28554b50bf7f273 extends $554db1c65281cd7c$var$AbstractPointerSensor {
    constructor(props){
        super(props, $554db1c65281cd7c$var$events$1, (0, $2b2eb81dab4d649a$export$b204af158042fbac)(props.event.target));
    }
}
$554db1c65281cd7c$export$b28554b50bf7f273.activators = [
    {
        eventName: 'onMouseDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (event.button === $554db1c65281cd7c$var$MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $554db1c65281cd7c$var$events$2 = {
    cancel: {
        name: 'touchcancel'
    },
    move: {
        name: 'touchmove'
    },
    end: {
        name: 'touchend'
    }
};
class $554db1c65281cd7c$export$19b41baf2e1bcdc0 extends $554db1c65281cd7c$var$AbstractPointerSensor {
    constructor(props){
        super(props, $554db1c65281cd7c$var$events$2);
    }
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener($554db1c65281cd7c$var$events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener($554db1c65281cd7c$var$events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
}
$554db1c65281cd7c$export$19b41baf2e1bcdc0.activators = [
    {
        eventName: 'onTouchStart',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            const { touches: touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
var $554db1c65281cd7c$export$eefe60e26f04c318;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})($554db1c65281cd7c$export$eefe60e26f04c318 || ($554db1c65281cd7c$export$eefe60e26f04c318 = {}));
var $554db1c65281cd7c$export$f93aa492a37e1b0e;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})($554db1c65281cd7c$export$f93aa492a37e1b0e || ($554db1c65281cd7c$export$f93aa492a37e1b0e = {}));
function $554db1c65281cd7c$var$useAutoScroller(_ref) {
    let { acceleration: acceleration, activator: activator = $554db1c65281cd7c$export$eefe60e26f04c318.Pointer, canScroll: canScroll, draggingRect: draggingRect, enabled: enabled, interval: interval = 5, order: order = $554db1c65281cd7c$export$f93aa492a37e1b0e.TreeOrder, pointerCoordinates: pointerCoordinates, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, delta: delta, threshold: threshold } = _ref;
    const scrollIntent = $554db1c65281cd7c$var$useScrollIntent({
        delta: delta,
        disabled: !enabled
    });
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, $2b2eb81dab4d649a$export$f4b266cd2aae9cb1)();
    const scrollSpeed = (0, $h4Bez.useRef)({
        x: 0,
        y: 0
    });
    const scrollDirection = (0, $h4Bez.useRef)({
        x: 0,
        y: 0
    });
    const rect = (0, $h4Bez.useMemo)(()=>{
        switch(activator){
            case $554db1c65281cd7c$export$eefe60e26f04c318.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case $554db1c65281cd7c$export$eefe60e26f04c318.DraggableRect:
                return draggingRect;
        }
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollContainerRef = (0, $h4Bez.useRef)(null);
    const autoScroll = (0, $h4Bez.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, $h4Bez.useMemo)(()=>order === $554db1c65281cd7c$export$f93aa492a37e1b0e.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, $h4Bez.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction: direction, speed: speed } = $554db1c65281cd7c$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            for (const axis of [
                'x',
                'y'
            ])if (!scrollIntent[axis][direction[axis]]) {
                speed[axis] = 0;
                direction[axis] = 0;
            }
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        JSON.stringify(scrollIntent),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
const $554db1c65281cd7c$var$defaultScrollIntent = {
    x: {
        [$554db1c65281cd7c$var$Direction.Backward]: false,
        [$554db1c65281cd7c$var$Direction.Forward]: false
    },
    y: {
        [$554db1c65281cd7c$var$Direction.Backward]: false,
        [$554db1c65281cd7c$var$Direction.Forward]: false
    }
};
function $554db1c65281cd7c$var$useScrollIntent(_ref2) {
    let { delta: delta, disabled: disabled } = _ref2;
    const previousDelta = (0, $2b2eb81dab4d649a$export$5cae361ad82dce8b)(delta);
    return (0, $2b2eb81dab4d649a$export$b0d7b7f1fcd613d1)((previousIntent)=>{
        if (disabled || !previousDelta || !previousIntent) // Reset scroll intent tracking when auto-scrolling is disabled
        return $554db1c65281cd7c$var$defaultScrollIntent;
        const direction = {
            x: Math.sign(delta.x - previousDelta.x),
            y: Math.sign(delta.y - previousDelta.y)
        }; // Keep track of the user intent to scroll in each direction for both axis
        return {
            x: {
                [$554db1c65281cd7c$var$Direction.Backward]: previousIntent.x[$554db1c65281cd7c$var$Direction.Backward] || direction.x === -1,
                [$554db1c65281cd7c$var$Direction.Forward]: previousIntent.x[$554db1c65281cd7c$var$Direction.Forward] || direction.x === 1
            },
            y: {
                [$554db1c65281cd7c$var$Direction.Backward]: previousIntent.y[$554db1c65281cd7c$var$Direction.Backward] || direction.y === -1,
                [$554db1c65281cd7c$var$Direction.Forward]: previousIntent.y[$554db1c65281cd7c$var$Direction.Forward] || direction.y === 1
            }
        };
    }, [
        disabled,
        delta,
        previousDelta
    ]);
}
function $554db1c65281cd7c$var$useCachedNode(draggableNodes, id) {
    const draggableNode = id != null ? draggableNodes.get(id) : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, $2b2eb81dab4d649a$export$b0d7b7f1fcd613d1)((cachedNode)=>{
        var _ref;
        if (id == null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function $554db1c65281cd7c$var$useCombineActivators(sensors, getSyntheticHandler) {
    return (0, $h4Bez.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var $554db1c65281cd7c$export$571c10ffffe014ab;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})($554db1c65281cd7c$export$571c10ffffe014ab || ($554db1c65281cd7c$export$571c10ffffe014ab = {}));
var $554db1c65281cd7c$export$8e062c3160beefd5;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})($554db1c65281cd7c$export$8e062c3160beefd5 || ($554db1c65281cd7c$export$8e062c3160beefd5 = {}));
const $554db1c65281cd7c$var$defaultValue = /*#__PURE__*/ new Map();
function $554db1c65281cd7c$var$useDroppableMeasuring(containers, _ref) {
    let { dragging: dragging, dependencies: dependencies, config: config } = _ref;
    const [queue, setQueue] = (0, $h4Bez.useState)(null);
    const { frequency: frequency, measure: measure, strategy: strategy } = config;
    const containersRef = (0, $h4Bez.useRef)(containers);
    const disabled = isDisabled();
    const disabledRef = (0, $2b2eb81dab4d649a$export$86c4283a11f23f95)(disabled);
    const measureDroppableContainers = (0, $h4Bez.useCallback)(function(ids) {
        if (ids === void 0) ids = [];
        if (disabledRef.current) return;
        setQueue((value)=>{
            if (value === null) return ids;
            return value.concat(ids.filter((id)=>!value.includes(id)));
        });
    }, [
        disabledRef
    ]);
    const timeoutId = (0, $h4Bez.useRef)(null);
    const droppableRects = (0, $2b2eb81dab4d649a$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (disabled && !dragging) return $554db1c65281cd7c$var$defaultValue;
        if (!previousValue || previousValue === $554db1c65281cd7c$var$defaultValue || containersRef.current !== containers || queue != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new $554db1c65281cd7c$var$Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        queue,
        dragging,
        disabled,
        measure
    ]);
    (0, $h4Bez.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, $h4Bez.useEffect)(()=>{
        if (disabled) return;
        measureDroppableContainers();
    }, [
        dragging,
        disabled
    ]);
    (0, $h4Bez.useEffect)(()=>{
        if (queue && queue.length > 0) setQueue(null);
    }, [
        JSON.stringify(queue)
    ]);
    (0, $h4Bez.useEffect)(()=>{
        if (disabled || typeof frequency !== 'number' || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects: droppableRects,
        measureDroppableContainers: measureDroppableContainers,
        measuringScheduled: queue != null
    };
    function isDisabled() {
        switch(strategy){
            case $554db1c65281cd7c$export$571c10ffffe014ab.Always:
                return false;
            case $554db1c65281cd7c$export$571c10ffffe014ab.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
function $554db1c65281cd7c$var$useInitialValue(value, computeFn) {
    return (0, $2b2eb81dab4d649a$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!value) return null;
        if (previousValue) return previousValue;
        return typeof computeFn === 'function' ? computeFn(value) : value;
    }, [
        computeFn,
        value
    ]);
}
function $554db1c65281cd7c$var$useInitialRect(node, measure) {
    return $554db1c65281cd7c$var$useInitialValue(node, measure);
}
/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */ function $554db1c65281cd7c$var$useMutationObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleMutations = (0, $2b2eb81dab4d649a$export$90fc3a17d93f704c)(callback);
    const mutationObserver = (0, $h4Bez.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.MutationObserver === 'undefined') return undefined;
        const { MutationObserver: MutationObserver } = window;
        return new MutationObserver(handleMutations);
    }, [
        handleMutations,
        disabled
    ]);
    (0, $h4Bez.useEffect)(()=>{
        return ()=>mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }, [
        mutationObserver
    ]);
    return mutationObserver;
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function $554db1c65281cd7c$var$useResizeObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleResize = (0, $2b2eb81dab4d649a$export$90fc3a17d93f704c)(callback);
    const resizeObserver = (0, $h4Bez.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.ResizeObserver === 'undefined') return undefined;
        const { ResizeObserver: ResizeObserver } = window;
        return new ResizeObserver(handleResize);
    }, [
        disabled
    ]);
    (0, $h4Bez.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function $554db1c65281cd7c$var$defaultMeasure(element) {
    return new $554db1c65281cd7c$var$Rect($554db1c65281cd7c$export$b6aa1f30c53d7454(element), element);
}
function $554db1c65281cd7c$var$useRect(element, measure, fallbackRect) {
    if (measure === void 0) measure = $554db1c65281cd7c$var$defaultMeasure;
    const [rect, setRect] = (0, $h4Bez.useState)(null);
    function measureRect() {
        setRect((currentRect)=>{
            if (!element) return null;
            if (element.isConnected === false) {
                var _ref;
                // Fall back to last rect we measured if the element is
                // no longer connected to the DOM.
                return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
            }
            const newRect = measure(element);
            if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
            return newRect;
        });
    }
    const mutationObserver = $554db1c65281cd7c$var$useMutationObserver({
        callback (records) {
            if (!element) return;
            for (const record of records){
                const { type: type, target: target } = record;
                if (type === 'childList' && target instanceof HTMLElement && target.contains(element)) {
                    measureRect();
                    break;
                }
            }
        }
    });
    const resizeObserver = $554db1c65281cd7c$var$useResizeObserver({
        callback: measureRect
    });
    (0, $2b2eb81dab4d649a$export$700979bc83e7db82)(()=>{
        measureRect();
        if (element) {
            resizeObserver == null || resizeObserver.observe(element);
            mutationObserver == null || mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            resizeObserver == null || resizeObserver.disconnect();
            mutationObserver == null || mutationObserver.disconnect();
        }
    }, [
        element
    ]);
    return rect;
}
function $554db1c65281cd7c$var$useRectDelta(rect) {
    const initialRect = $554db1c65281cd7c$var$useInitialValue(rect);
    return $554db1c65281cd7c$var$getRectDelta(rect, initialRect);
}
const $554db1c65281cd7c$var$defaultValue$1 = [];
function $554db1c65281cd7c$var$useScrollableAncestors(node) {
    const previousNode = (0, $h4Bez.useRef)(node);
    const ancestors = (0, $2b2eb81dab4d649a$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!node) return $554db1c65281cd7c$var$defaultValue$1;
        if (previousValue && previousValue !== $554db1c65281cd7c$var$defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return $554db1c65281cd7c$export$e4864aa91b5ed091(node);
    }, [
        node
    ]);
    (0, $h4Bez.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function $554db1c65281cd7c$var$useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, $h4Bez.useState)(null);
    const prevElements = (0, $h4Bez.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, $h4Bez.useCallback)((event)=>{
        const scrollingElement = $554db1c65281cd7c$var$getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, $554db1c65281cd7c$var$getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, $h4Bez.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = $554db1c65281cd7c$var$getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener('scroll', handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        $554db1c65281cd7c$var$getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = $554db1c65281cd7c$var$getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener('scroll', handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, $h4Bez.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, $2b2eb81dab4d649a$export$e16d8520af44a096)(acc, coordinates), $554db1c65281cd7c$export$597cbd7bbd10deb4) : $554db1c65281cd7c$var$getScrollOffsets(elements);
        return $554db1c65281cd7c$export$597cbd7bbd10deb4;
    }, [
        elements,
        scrollCoordinates
    ]);
}
function $554db1c65281cd7c$var$useScrollOffsetsDelta(scrollOffsets, dependencies) {
    if (dependencies === void 0) dependencies = [];
    const initialScrollOffsets = (0, $h4Bez.useRef)(null);
    (0, $h4Bez.useEffect)(()=>{
        initialScrollOffsets.current = null;
    }, dependencies);
    (0, $h4Bez.useEffect)(()=>{
        const hasScrollOffsets = scrollOffsets !== $554db1c65281cd7c$export$597cbd7bbd10deb4;
        if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
        if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
    }, [
        scrollOffsets
    ]);
    return initialScrollOffsets.current ? (0, $2b2eb81dab4d649a$export$4e2d2ead65e5f7e3)(scrollOffsets, initialScrollOffsets.current) : $554db1c65281cd7c$export$597cbd7bbd10deb4;
}
function $554db1c65281cd7c$var$useSensorSetup(sensors) {
    (0, $h4Bez.useEffect)(()=>{
        if (!(0, $2b2eb81dab4d649a$export$71594e8a50f746f4)) return;
        const teardownFns = sensors.map((_ref)=>{
            let { sensor: sensor } = _ref;
            return sensor.setup == null ? void 0 : sensor.setup();
        });
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2)=>{
        let { sensor: sensor } = _ref2;
        return sensor;
    }));
}
function $554db1c65281cd7c$var$useSyntheticListeners(listeners, id) {
    return (0, $h4Bez.useMemo)(()=>{
        return listeners.reduce((acc, _ref)=>{
            let { eventName: eventName, handler: handler } = _ref;
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
function $554db1c65281cd7c$var$useWindowRect(element) {
    return (0, $h4Bez.useMemo)(()=>element ? $554db1c65281cd7c$var$getWindowClientRect(element) : null, [
        element
    ]);
}
const $554db1c65281cd7c$var$defaultValue$2 = [];
function $554db1c65281cd7c$var$useRects(elements, measure) {
    if (measure === void 0) measure = $554db1c65281cd7c$export$b6aa1f30c53d7454;
    const [firstElement] = elements;
    const windowRect = $554db1c65281cd7c$var$useWindowRect(firstElement ? (0, $2b2eb81dab4d649a$export$38b2d434cce3ea22)(firstElement) : null);
    const [rects, setRects] = (0, $h4Bez.useState)($554db1c65281cd7c$var$defaultValue$2);
    function measureRects() {
        setRects(()=>{
            if (!elements.length) return $554db1c65281cd7c$var$defaultValue$2;
            return elements.map((element)=>$554db1c65281cd7c$var$isDocumentScrollingElement(element) ? windowRect : new $554db1c65281cd7c$var$Rect(measure(element), element));
        });
    }
    const resizeObserver = $554db1c65281cd7c$var$useResizeObserver({
        callback: measureRects
    });
    (0, $2b2eb81dab4d649a$export$700979bc83e7db82)(()=>{
        resizeObserver == null || resizeObserver.disconnect();
        measureRects();
        elements.forEach((element)=>resizeObserver == null ? void 0 : resizeObserver.observe(element));
    }, [
        elements
    ]);
    return rects;
}
function $554db1c65281cd7c$var$getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, $2b2eb81dab4d649a$export$1b3bfaa9684536aa)(firstChild) ? firstChild : node;
}
function $554db1c65281cd7c$var$useDragOverlayMeasuring(_ref) {
    let { measure: measure } = _ref;
    const [rect, setRect] = (0, $h4Bez.useState)(null);
    const handleResize = (0, $h4Bez.useCallback)((entries)=>{
        for (const { target: target } of entries)if ((0, $2b2eb81dab4d649a$export$1b3bfaa9684536aa)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? {
                    ...rect,
                    width: newRect.width,
                    height: newRect.height
                } : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = $554db1c65281cd7c$var$useResizeObserver({
        callback: handleResize
    });
    const handleNodeChange = (0, $h4Bez.useCallback)((element)=>{
        const node = $554db1c65281cd7c$var$getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, $2b2eb81dab4d649a$export$bc23c270f170c912)(handleNodeChange);
    return (0, $h4Bez.useMemo)(()=>({
            nodeRef: nodeRef,
            rect: rect,
            setRef: setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
const $554db1c65281cd7c$var$defaultSensors = [
    {
        sensor: $554db1c65281cd7c$export$b26af955418d6638,
        options: {}
    },
    {
        sensor: $554db1c65281cd7c$export$44d67f2a438aeba9,
        options: {}
    }
];
const $554db1c65281cd7c$var$defaultData = {
    current: {}
};
const $554db1c65281cd7c$var$defaultMeasuringConfiguration = {
    draggable: {
        measure: $554db1c65281cd7c$var$getTransformAgnosticClientRect
    },
    droppable: {
        measure: $554db1c65281cd7c$var$getTransformAgnosticClientRect,
        strategy: $554db1c65281cd7c$export$571c10ffffe014ab.WhileDragging,
        frequency: $554db1c65281cd7c$export$8e062c3160beefd5.Optimized
    },
    dragOverlay: {
        measure: $554db1c65281cd7c$export$b6aa1f30c53d7454
    }
};
class $554db1c65281cd7c$var$DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter((_ref)=>{
            let { disabled: disabled } = _ref;
            return !disabled;
        });
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const $554db1c65281cd7c$var$defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: /*#__PURE__*/ new Map(),
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new $554db1c65281cd7c$var$DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: $554db1c65281cd7c$var$noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: $554db1c65281cd7c$var$defaultMeasuringConfiguration,
    measureDroppableContainers: $554db1c65281cd7c$var$noop,
    windowRect: null,
    measuringScheduled: false
};
const $554db1c65281cd7c$var$defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ''
    },
    dispatch: $554db1c65281cd7c$var$noop,
    draggableNodes: /*#__PURE__*/ new Map(),
    over: null,
    measureDroppableContainers: $554db1c65281cd7c$var$noop
};
const $554db1c65281cd7c$var$InternalContext = /*#__PURE__*/ (0, $h4Bez.createContext)($554db1c65281cd7c$var$defaultInternalContext);
const $554db1c65281cd7c$var$PublicContext = /*#__PURE__*/ (0, $h4Bez.createContext)($554db1c65281cd7c$var$defaultPublicContext);
function $554db1c65281cd7c$var$getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: new Map(),
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new $554db1c65281cd7c$var$DroppableContainersMap()
        }
    };
}
function $554db1c65281cd7c$var$reducer(state, action) {
    switch(action.type){
        case $554db1c65281cd7c$var$Action.DragStart:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                }
            };
        case $554db1c65281cd7c$var$Action.DragMove:
            if (state.draggable.active == null) return state;
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                }
            };
        case $554db1c65281cd7c$var$Action.DragEnd:
        case $554db1c65281cd7c$var$Action.DragCancel:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                }
            };
        case $554db1c65281cd7c$var$Action.RegisterDroppable:
            {
                const { element: element } = action;
                const { id: id } = element;
                const containers = new $554db1c65281cd7c$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $554db1c65281cd7c$var$Action.SetDroppableDisabled:
            {
                const { id: id, key: key, disabled: disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $554db1c65281cd7c$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, {
                    ...element,
                    disabled: disabled
                });
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $554db1c65281cd7c$var$Action.UnregisterDroppable:
            {
                const { id: id, key: key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $554db1c65281cd7c$var$DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        default:
            return state;
    }
}
function $554db1c65281cd7c$var$RestoreFocus(_ref) {
    let { disabled: disabled } = _ref;
    const { active: active, activatorEvent: activatorEvent, draggableNodes: draggableNodes } = (0, $h4Bez.useContext)($554db1c65281cd7c$var$InternalContext);
    const previousActivatorEvent = (0, $2b2eb81dab4d649a$export$5cae361ad82dce8b)(activatorEvent);
    const previousActiveId = (0, $2b2eb81dab4d649a$export$5cae361ad82dce8b)(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node
    (0, $h4Bez.useEffect)(()=>{
        if (disabled) return;
        if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
            if (!(0, $2b2eb81dab4d649a$export$130b789831072f4c)(previousActivatorEvent)) return;
            if (document.activeElement === previousActivatorEvent.target) // No need to restore focus
            return;
            const draggableNode = draggableNodes.get(previousActiveId);
            if (!draggableNode) return;
            const { activatorNode: activatorNode, node: node } = draggableNode;
            if (!activatorNode.current && !node.current) return;
            requestAnimationFrame(()=>{
                for (const element of [
                    activatorNode.current,
                    node.current
                ]){
                    if (!element) continue;
                    const focusableNode = (0, $2b2eb81dab4d649a$export$44f71d798fd0a62b)(element);
                    if (focusableNode) {
                        focusableNode.focus();
                        break;
                    }
                }
            });
        }
    }, [
        activatorEvent,
        disabled,
        draggableNodes,
        previousActiveId,
        previousActivatorEvent
    ]);
    return null;
}
function $554db1c65281cd7c$export$f1696300e8775372(modifiers, _ref) {
    let { transform: transform, ...args } = _ref;
    return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier)=>{
        return modifier({
            transform: accumulator,
            ...args
        });
    }, transform) : transform;
}
function $554db1c65281cd7c$var$useMeasuringConfiguration(config) {
    return (0, $h4Bez.useMemo)(()=>({
            draggable: {
                ...$554db1c65281cd7c$var$defaultMeasuringConfiguration.draggable,
                ...config == null ? void 0 : config.draggable
            },
            droppable: {
                ...$554db1c65281cd7c$var$defaultMeasuringConfiguration.droppable,
                ...config == null ? void 0 : config.droppable
            },
            dragOverlay: {
                ...$554db1c65281cd7c$var$defaultMeasuringConfiguration.dragOverlay,
                ...config == null ? void 0 : config.dragOverlay
            }
        }), [
        config == null ? void 0 : config.draggable,
        config == null ? void 0 : config.droppable,
        config == null ? void 0 : config.dragOverlay
    ]);
}
function $554db1c65281cd7c$var$useLayoutShiftScrollCompensation(_ref) {
    let { activeNode: activeNode, measure: measure, initialRect: initialRect, config: config = true } = _ref;
    const initialized = (0, $h4Bez.useRef)(false);
    const { x: x, y: y } = typeof config === 'boolean' ? {
        x: config,
        y: config
    } : config;
    (0, $2b2eb81dab4d649a$export$700979bc83e7db82)(()=>{
        const disabled = !x && !y;
        if (disabled || !activeNode) {
            initialized.current = false;
            return;
        }
        if (initialized.current || !initialRect) // Return early if layout shift scroll compensation was already attempted
        // or if there is no initialRect to compare to.
        return;
         // Get the most up to date node ref for the active draggable
        const node = activeNode == null ? void 0 : activeNode.node.current;
        if (!node || node.isConnected === false) // Return early if there is no attached node ref or if the node is
        // disconnected from the document.
        return;
        const rect = measure(node);
        const rectDelta = $554db1c65281cd7c$var$getRectDelta(rect, initialRect);
        if (!x) rectDelta.x = 0;
        if (!y) rectDelta.y = 0;
         // Only perform layout shift scroll compensation once
        initialized.current = true;
        if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
            const firstScrollableAncestor = $554db1c65281cd7c$var$getFirstScrollableAncestor(node);
            if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
                top: rectDelta.y,
                left: rectDelta.x
            });
        }
    }, [
        activeNode,
        x,
        y,
        initialRect,
        measure
    ]);
}
const $554db1c65281cd7c$var$ActiveDraggableContext = /*#__PURE__*/ (0, $h4Bez.createContext)({
    ...$554db1c65281cd7c$export$597cbd7bbd10deb4,
    scaleX: 1,
    scaleY: 1
});
var $554db1c65281cd7c$var$Status;
(function(Status) {
    Status[Status["Uninitialized"] = 0] = "Uninitialized";
    Status[Status["Initializing"] = 1] = "Initializing";
    Status[Status["Initialized"] = 2] = "Initialized";
})($554db1c65281cd7c$var$Status || ($554db1c65281cd7c$var$Status = {}));
const $554db1c65281cd7c$export$2d5c5ceac203fc1e = /*#__PURE__*/ (0, $h4Bez.memo)(function DndContext(_ref) {
    var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    let { id: id, accessibility: accessibility, autoScroll: autoScroll = true, children: children, sensors: sensors = $554db1c65281cd7c$var$defaultSensors, collisionDetection: collisionDetection = $554db1c65281cd7c$export$953346c40b5eb62a, measuring: measuring, modifiers: modifiers, ...props } = _ref;
    const store = (0, $h4Bez.useReducer)($554db1c65281cd7c$var$reducer, undefined, $554db1c65281cd7c$var$getInitialState);
    const [state, dispatch] = store;
    const [dispatchMonitorEvent, registerMonitorListener] = $554db1c65281cd7c$var$useDndMonitorProvider();
    const [status, setStatus] = (0, $h4Bez.useState)($554db1c65281cd7c$var$Status.Uninitialized);
    const isInitialized = status === $554db1c65281cd7c$var$Status.Initialized;
    const { draggable: { active: activeId, nodes: draggableNodes, translate: translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId != null ? draggableNodes.get(activeId) : null;
    const activeRects = (0, $h4Bez.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, $h4Bez.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : $554db1c65281cd7c$var$defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, $h4Bez.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, $h4Bez.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, $h4Bez.useState)(null);
    const latestProps = (0, $2b2eb81dab4d649a$export$86c4283a11f23f95)(props, Object.values(props));
    const draggableDescribedById = (0, $2b2eb81dab4d649a$export$c485849f2e393253)("DndDescribedBy", id);
    const enabledDroppableContainers = (0, $h4Bez.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const measuringConfiguration = $554db1c65281cd7c$var$useMeasuringConfiguration(measuring);
    const { droppableRects: droppableRects, measureDroppableContainers: measureDroppableContainers, measuringScheduled: measuringScheduled } = $554db1c65281cd7c$var$useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isInitialized,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuringConfiguration.droppable
    });
    const activeNode = $554db1c65281cd7c$var$useCachedNode(draggableNodes, activeId);
    const activationCoordinates = (0, $h4Bez.useMemo)(()=>activatorEvent ? (0, $2b2eb81dab4d649a$export$36195c8aa1517e04)(activatorEvent) : null, [
        activatorEvent
    ]);
    const autoScrollOptions = getAutoScrollerOptions();
    const initialActiveNodeRect = $554db1c65281cd7c$var$useInitialRect(activeNode, measuringConfiguration.draggable.measure);
    $554db1c65281cd7c$var$useLayoutShiftScrollCompensation({
        activeNode: activeId != null ? draggableNodes.get(activeId) : null,
        config: autoScrollOptions.layoutShiftCompensation,
        initialRect: initialActiveNodeRect,
        measure: measuringConfiguration.draggable.measure
    });
    const activeNodeRect = $554db1c65281cd7c$var$useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
    const containerNodeRect = $554db1c65281cd7c$var$useRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, $h4Bez.useRef)({
        activatorEvent: null,
        active: null,
        activeNode: activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects: droppableRects,
        draggableNodes: draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers: droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = $554db1c65281cd7c$var$useDragOverlayMeasuring({
        measure: measuringConfiguration.dragOverlay.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
    const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = $554db1c65281cd7c$var$useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node
    const windowRect = $554db1c65281cd7c$var$useWindowRect(draggingNode ? (0, $2b2eb81dab4d649a$export$38b2d434cce3ea22)(draggingNode) : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = $554db1c65281cd7c$var$useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
    const scrollableAncestorRects = $554db1c65281cd7c$var$useRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = $554db1c65281cd7c$export$f1696300e8775372(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        windowRect: windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, $2b2eb81dab4d649a$export$e16d8520af44a096)(activationCoordinates, translate) : null;
    const scrollOffsets = $554db1c65281cd7c$var$useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated
    const scrollAdjustment = $554db1c65281cd7c$var$useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured
    const activeNodeScrollDelta = $554db1c65281cd7c$var$useScrollOffsetsDelta(scrollOffsets, [
        activeNodeRect
    ]);
    const scrollAdjustedTranslate = (0, $2b2eb81dab4d649a$export$e16d8520af44a096)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? $554db1c65281cd7c$var$getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active: active,
        collisionRect: collisionRect,
        droppableRects: droppableRects,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates: pointerCoordinates
    }) : null;
    const overId = $554db1c65281cd7c$export$ef1beab6d7287295(collisions, 'id');
    const [over, setOver] = (0, $h4Bez.useState)(null); // When there is no drag overlay used, we need to account for the
    // window scroll delta
    const appliedTranslate = usesDragOverlay ? modifiedTranslate : (0, $2b2eb81dab4d649a$export$e16d8520af44a096)(modifiedTranslate, activeNodeScrollDelta);
    const transform = $554db1c65281cd7c$var$adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const activeSensorRef = (0, $h4Bez.useRef)(null);
    const instantiateSensor = (0, $h4Bez.useCallback)((event, _ref2)=>{
        let { sensor: Sensor, options: options } = _ref2;
        if (activeRef.current == null) return;
        const activeNode = draggableNodes.get(activeRef.current);
        if (!activeNode) return;
        const activatorEvent = event.nativeEvent;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode: activeNode,
            event: activatorEvent,
            options: options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onAbort (id) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragAbort: onDragAbort } = latestProps.current;
                const event = {
                    id: id
                };
                onDragAbort == null || onDragAbort(event);
                dispatchMonitorEvent({
                    type: 'onDragAbort',
                    event: event
                });
            },
            onPending (id, constraint, initialCoordinates, offset) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragPending: onDragPending } = latestProps.current;
                const event = {
                    id: id,
                    constraint: constraint,
                    initialCoordinates: initialCoordinates,
                    offset: offset
                };
                onDragPending == null || onDragPending(event);
                dispatchMonitorEvent({
                    type: 'onDragPending',
                    event: event
                });
            },
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (id == null) return;
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragStart: onDragStart } = latestProps.current;
                const event = {
                    activatorEvent: activatorEvent,
                    active: {
                        id: id,
                        data: draggableNode.data,
                        rect: activeRects
                    }
                };
                (0, $68fd039c491aa2b2$exports.unstable_batchedUpdates)(()=>{
                    onDragStart == null || onDragStart(event);
                    setStatus($554db1c65281cd7c$var$Status.Initializing);
                    dispatch({
                        type: $554db1c65281cd7c$var$Action.DragStart,
                        initialCoordinates: initialCoordinates,
                        active: id
                    });
                    dispatchMonitorEvent({
                        type: 'onDragStart',
                        event: event
                    });
                    setActiveSensor(activeSensorRef.current);
                    setActivatorEvent(activatorEvent);
                });
            },
            onMove (coordinates) {
                dispatch({
                    type: $554db1c65281cd7c$var$Action.DragMove,
                    coordinates: coordinates
                });
            },
            onEnd: createHandler($554db1c65281cd7c$var$Action.DragEnd),
            onCancel: createHandler($554db1c65281cd7c$var$Action.DragCancel)
        });
        activeSensorRef.current = sensorInstance;
        function createHandler(type) {
            return async function handler() {
                const { active: active, collisions: collisions, over: over, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop: cancelDrop } = latestProps.current;
                    event = {
                        activatorEvent: activatorEvent,
                        active: active,
                        collisions: collisions,
                        delta: scrollAdjustedTranslate,
                        over: over
                    };
                    if (type === $554db1c65281cd7c$var$Action.DragEnd && typeof cancelDrop === 'function') {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = $554db1c65281cd7c$var$Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, $68fd039c491aa2b2$exports.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type: type
                    });
                    setStatus($554db1c65281cd7c$var$Status.Uninitialized);
                    setOver(null);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    activeSensorRef.current = null;
                    const eventName = type === $554db1c65281cd7c$var$Action.DragEnd ? 'onDragEnd' : 'onDragCancel';
                    if (event) {
                        const handler = latestProps.current[eventName];
                        handler == null || handler(event);
                        dispatchMonitorEvent({
                            type: eventName,
                            event: event
                        });
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, $h4Bez.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            const activeDraggableNode = draggableNodes.get(active);
            if (activeRef.current !== null || // No active draggable
            !activeDraggableNode || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            const activationContext = {
                active: activeDraggableNode
            };
            const shouldActivate = handler(event, sensor.options, activationContext);
            if (shouldActivate === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        draggableNodes,
        instantiateSensor
    ]);
    const activators = $554db1c65281cd7c$var$useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    $554db1c65281cd7c$var$useSensorSetup(sensors);
    (0, $2b2eb81dab4d649a$export$700979bc83e7db82)(()=>{
        if (activeNodeRect && status === $554db1c65281cd7c$var$Status.Initializing) setStatus($554db1c65281cd7c$var$Status.Initialized);
    }, [
        activeNodeRect,
        status
    ]);
    (0, $h4Bez.useEffect)(()=>{
        const { onDragMove: onDragMove } = latestProps.current;
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, over: over } = sensorContext.current;
        if (!active || !activatorEvent) return;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $68fd039c491aa2b2$exports.unstable_batchedUpdates)(()=>{
            onDragMove == null || onDragMove(event);
            dispatchMonitorEvent({
                type: 'onDragMove',
                event: event
            });
        });
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, $h4Bez.useEffect)(()=>{
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, droppableContainers: droppableContainers, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
        if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
        const { onDragOver: onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $68fd039c491aa2b2$exports.unstable_batchedUpdates)(()=>{
            setOver(over);
            onDragOver == null || onDragOver(event);
            dispatchMonitorEvent({
                type: 'onDragOver',
                event: event
            });
        });
    }, [
        overId
    ]);
    (0, $2b2eb81dab4d649a$export$700979bc83e7db82)(()=>{
        sensorContext.current = {
            activatorEvent: activatorEvent,
            active: active,
            activeNode: activeNode,
            collisionRect: collisionRect,
            collisions: collisions,
            droppableRects: droppableRects,
            draggableNodes: draggableNodes,
            draggingNode: draggingNode,
            draggingNodeRect: draggingNodeRect,
            droppableContainers: droppableContainers,
            over: over,
            scrollableAncestors: scrollableAncestors,
            scrollAdjustedTranslate: scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    $554db1c65281cd7c$var$useAutoScroller({
        ...autoScrollOptions,
        delta: translate,
        draggingRect: collisionRect,
        pointerCoordinates: pointerCoordinates,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects
    });
    const publicContext = (0, $h4Bez.useMemo)(()=>{
        const context = {
            active: active,
            activeNode: activeNode,
            activeNodeRect: activeNodeRect,
            activatorEvent: activatorEvent,
            collisions: collisions,
            containerNodeRect: containerNodeRect,
            dragOverlay: dragOverlay,
            draggableNodes: draggableNodes,
            droppableContainers: droppableContainers,
            droppableRects: droppableRects,
            over: over,
            measureDroppableContainers: measureDroppableContainers,
            scrollableAncestors: scrollableAncestors,
            scrollableAncestorRects: scrollableAncestorRects,
            measuringConfiguration: measuringConfiguration,
            measuringScheduled: measuringScheduled,
            windowRect: windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringConfiguration,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, $h4Bez.useMemo)(()=>{
        const context = {
            activatorEvent: activatorEvent,
            activators: activators,
            active: active,
            activeNodeRect: activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch: dispatch,
            draggableNodes: draggableNodes,
            over: over,
            measureDroppableContainers: measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($554db1c65281cd7c$var$DndMonitorContext.Provider, {
        value: registerMonitorListener
    }, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($554db1c65281cd7c$var$InternalContext.Provider, {
        value: internalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($554db1c65281cd7c$var$PublicContext.Provider, {
        value: publicContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($554db1c65281cd7c$var$ActiveDraggableContext.Provider, {
        value: transform
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($554db1c65281cd7c$var$RestoreFocus, {
        disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
    })), (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($554db1c65281cd7c$var$Accessibility, {
        ...accessibility,
        hiddenTextDescribedById: draggableDescribedById
    }));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === 'object' ? autoScroll.enabled === false : autoScroll === false;
        const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === 'object') return {
            ...autoScroll,
            enabled: enabled
        };
        return {
            enabled: enabled
        };
    }
});
const $554db1c65281cd7c$var$NullContext = /*#__PURE__*/ (0, $h4Bez.createContext)(null);
const $554db1c65281cd7c$var$defaultRole = 'button';
const $554db1c65281cd7c$var$ID_PREFIX = 'Draggable';
function $554db1c65281cd7c$export$df30c81f5aa01ff7(_ref) {
    let { id: id, data: data, disabled: disabled = false, attributes: attributes } = _ref;
    const key = (0, $2b2eb81dab4d649a$export$c485849f2e393253)($554db1c65281cd7c$var$ID_PREFIX);
    const { activators: activators, activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, ariaDescribedById: ariaDescribedById, draggableNodes: draggableNodes, over: over } = (0, $h4Bez.useContext)($554db1c65281cd7c$var$InternalContext);
    const { role: role = $554db1c65281cd7c$var$defaultRole, roleDescription: roleDescription = 'draggable', tabIndex: tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, $h4Bez.useContext)(isDragging ? $554db1c65281cd7c$var$ActiveDraggableContext : $554db1c65281cd7c$var$NullContext);
    const [node, setNodeRef] = (0, $2b2eb81dab4d649a$export$bc23c270f170c912)();
    const [activatorNode, setActivatorNodeRef] = (0, $2b2eb81dab4d649a$export$bc23c270f170c912)();
    const listeners = $554db1c65281cd7c$var$useSyntheticListeners(activators, id);
    const dataRef = (0, $2b2eb81dab4d649a$export$86c4283a11f23f95)(data);
    (0, $2b2eb81dab4d649a$export$700979bc83e7db82)(()=>{
        draggableNodes.set(id, {
            id: id,
            key: key,
            node: node,
            activatorNode: activatorNode,
            data: dataRef
        });
        return ()=>{
            const node = draggableNodes.get(id);
            if (node && node.key === key) draggableNodes.delete(id);
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, $h4Bez.useMemo)(()=>({
            role: role,
            tabIndex: tabIndex,
            'aria-disabled': disabled,
            'aria-pressed': isDragging && role === $554db1c65281cd7c$var$defaultRole ? true : undefined,
            'aria-roledescription': roleDescription,
            'aria-describedby': ariaDescribedById.draggable
        }), [
        disabled,
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active: active,
        activatorEvent: activatorEvent,
        activeNodeRect: activeNodeRect,
        attributes: memoizedAttributes,
        isDragging: isDragging,
        listeners: disabled ? undefined : listeners,
        node: node,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        transform: transform
    };
}
function $554db1c65281cd7c$export$4930f6bf413be70e() {
    return (0, $h4Bez.useContext)($554db1c65281cd7c$var$PublicContext);
}
const $554db1c65281cd7c$var$ID_PREFIX$1 = 'Droppable';
const $554db1c65281cd7c$var$defaultResizeObserverConfig = {
    timeout: 25
};
function $554db1c65281cd7c$export$d74e5d67dc2b3176(_ref) {
    let { data: data, disabled: disabled = false, id: id, resizeObserverConfig: resizeObserverConfig } = _ref;
    const key = (0, $2b2eb81dab4d649a$export$c485849f2e393253)($554db1c65281cd7c$var$ID_PREFIX$1);
    const { active: active, dispatch: dispatch, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $h4Bez.useContext)($554db1c65281cd7c$var$InternalContext);
    const previous = (0, $h4Bez.useRef)({
        disabled: disabled
    });
    const resizeObserverConnected = (0, $h4Bez.useRef)(false);
    const rect = (0, $h4Bez.useRef)(null);
    const callbackId = (0, $h4Bez.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor: updateMeasurementsFor, timeout: resizeObserverTimeout } = {
        ...$554db1c65281cd7c$var$defaultResizeObserverConfig,
        ...resizeObserverConfig
    };
    const ids = (0, $2b2eb81dab4d649a$export$86c4283a11f23f95)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, $h4Bez.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [
                ids.current
            ]);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = $554db1c65281cd7c$var$useResizeObserver({
        callback: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, $h4Bez.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, $2b2eb81dab4d649a$export$bc23c270f170c912)(handleNodeChange);
    const dataRef = (0, $2b2eb81dab4d649a$export$86c4283a11f23f95)(data);
    (0, $h4Bez.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, $h4Bez.useEffect)(()=>{
        dispatch({
            type: $554db1c65281cd7c$var$Action.RegisterDroppable,
            element: {
                id: id,
                key: key,
                disabled: disabled,
                node: nodeRef,
                rect: rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: $554db1c65281cd7c$var$Action.UnregisterDroppable,
                key: key,
                id: id
            });
    }, [
        id
    ]);
    (0, $h4Bez.useEffect)(()=>{
        if (disabled !== previous.current.disabled) {
            dispatch({
                type: $554db1c65281cd7c$var$Action.SetDroppableDisabled,
                id: id,
                key: key,
                disabled: disabled
            });
            previous.current.disabled = disabled;
        }
    }, [
        id,
        key,
        disabled,
        dispatch
    ]);
    return {
        active: active,
        rect: rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over: over,
        setNodeRef: setNodeRef
    };
}
function $554db1c65281cd7c$var$AnimationManager(_ref) {
    let { animation: animation, children: children } = _ref;
    const [clonedChildren, setClonedChildren] = (0, $h4Bez.useState)(null);
    const [element, setElement] = (0, $h4Bez.useState)(null);
    const previousChildren = (0, $2b2eb81dab4d649a$export$5cae361ad82dce8b)(children);
    if (!children && !clonedChildren && previousChildren) setClonedChildren(previousChildren);
    (0, $2b2eb81dab4d649a$export$700979bc83e7db82)(()=>{
        if (!element) return;
        const key = clonedChildren == null ? void 0 : clonedChildren.key;
        const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
        if (key == null || id == null) {
            setClonedChildren(null);
            return;
        }
        Promise.resolve(animation(id, element)).then(()=>{
            setClonedChildren(null);
        });
    }, [
        animation,
        clonedChildren,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Fragment, null, children, clonedChildren ? (0, $h4Bez.cloneElement)(clonedChildren, {
        ref: setElement
    }) : null);
}
const $554db1c65281cd7c$var$defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
function $554db1c65281cd7c$var$NullifiedContextProvider(_ref) {
    let { children: children } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($554db1c65281cd7c$var$InternalContext.Provider, {
        value: $554db1c65281cd7c$var$defaultInternalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($554db1c65281cd7c$var$ActiveDraggableContext.Provider, {
        value: $554db1c65281cd7c$var$defaultTransform
    }, children));
}
const $554db1c65281cd7c$var$baseStyles = {
    position: 'fixed',
    touchAction: 'none'
};
const $554db1c65281cd7c$var$defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, $2b2eb81dab4d649a$export$130b789831072f4c)(activatorEvent);
    return isKeyboardActivator ? 'transform 250ms ease' : undefined;
};
const $554db1c65281cd7c$var$PositionedOverlay = /*#__PURE__*/ (0, $h4Bez.forwardRef)((_ref, ref)=>{
    let { as: as, activatorEvent: activatorEvent, adjustScale: adjustScale, children: children, className: className, rect: rect, style: style, transform: transform, transition: transition = $554db1c65281cd7c$var$defaultTransition } = _ref;
    if (!rect) return null;
    const scaleAdjustedTransform = adjustScale ? transform : {
        ...transform,
        scaleX: 1,
        scaleY: 1
    };
    const styles = {
        ...$554db1c65281cd7c$var$baseStyles,
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        transform: (0, $2b2eb81dab4d649a$export$c4ffa16951855e28).Transform.toString(scaleAdjustedTransform),
        transformOrigin: adjustScale && activatorEvent ? $554db1c65281cd7c$var$getRelativeTransformOrigin(activatorEvent, rect) : undefined,
        transition: typeof transition === 'function' ? transition(activatorEvent) : transition,
        ...style
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(as, {
        className: className,
        style: styles,
        ref: ref
    }, children);
});
const $554db1c65281cd7c$export$28c62adcaabe654c = (options)=>(_ref)=>{
        let { active: active, dragOverlay: dragOverlay } = _ref;
        const originalStyles = {};
        const { styles: styles, className: className } = options;
        if (styles != null && styles.active) for (const [key, value] of Object.entries(styles.active)){
            if (value === undefined) continue;
            originalStyles[key] = active.node.style.getPropertyValue(key);
            active.node.style.setProperty(key, value);
        }
        if (styles != null && styles.dragOverlay) for (const [key, value] of Object.entries(styles.dragOverlay)){
            if (value === undefined) continue;
            dragOverlay.node.style.setProperty(key, value);
        }
        if (className != null && className.active) active.node.classList.add(className.active);
        if (className != null && className.dragOverlay) dragOverlay.node.classList.add(className.dragOverlay);
        return function cleanup() {
            for (const [key, value] of Object.entries(originalStyles))active.node.style.setProperty(key, value);
            if (className != null && className.active) active.node.classList.remove(className.active);
        };
    };
const $554db1c65281cd7c$var$defaultKeyframeResolver = (_ref2)=>{
    let { transform: { initial: initial, final: final } } = _ref2;
    return [
        {
            transform: (0, $2b2eb81dab4d649a$export$c4ffa16951855e28).Transform.toString(initial)
        },
        {
            transform: (0, $2b2eb81dab4d649a$export$c4ffa16951855e28).Transform.toString(final)
        }
    ];
};
const $554db1c65281cd7c$export$10f7ab1c653bb60e = {
    duration: 250,
    easing: 'ease',
    keyframes: $554db1c65281cd7c$var$defaultKeyframeResolver,
    sideEffects: /*#__PURE__*/ $554db1c65281cd7c$export$28c62adcaabe654c({
        styles: {
            active: {
                opacity: '0'
            }
        }
    })
};
function $554db1c65281cd7c$var$useDropAnimation(_ref3) {
    let { config: config, draggableNodes: draggableNodes, droppableContainers: droppableContainers, measuringConfiguration: measuringConfiguration } = _ref3;
    return (0, $2b2eb81dab4d649a$export$90fc3a17d93f704c)((id, node)=>{
        if (config === null) return;
        const activeDraggable = draggableNodes.get(id);
        if (!activeDraggable) return;
        const activeNode = activeDraggable.node.current;
        if (!activeNode) return;
        const measurableNode = $554db1c65281cd7c$var$getMeasurableNode(node);
        if (!measurableNode) return;
        const { transform: transform } = (0, $2b2eb81dab4d649a$export$38b2d434cce3ea22)(node).getComputedStyle(node);
        const parsedTransform = $554db1c65281cd7c$var$parseTransform(transform);
        if (!parsedTransform) return;
        const animation = typeof config === 'function' ? config : $554db1c65281cd7c$var$createDefaultDropAnimation(config);
        $554db1c65281cd7c$var$scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
        return animation({
            active: {
                id: id,
                data: activeDraggable.data,
                node: activeNode,
                rect: measuringConfiguration.draggable.measure(activeNode)
            },
            draggableNodes: draggableNodes,
            dragOverlay: {
                node: node,
                rect: measuringConfiguration.dragOverlay.measure(measurableNode)
            },
            droppableContainers: droppableContainers,
            measuringConfiguration: measuringConfiguration,
            transform: parsedTransform
        });
    });
}
function $554db1c65281cd7c$var$createDefaultDropAnimation(options) {
    const { duration: duration, easing: easing, sideEffects: sideEffects, keyframes: keyframes } = {
        ...$554db1c65281cd7c$export$10f7ab1c653bb60e,
        ...options
    };
    return (_ref4)=>{
        let { active: active, dragOverlay: dragOverlay, transform: transform, ...rest } = _ref4;
        if (!duration) // Do not animate if animation duration is zero.
        return;
        const delta = {
            x: dragOverlay.rect.left - active.rect.left,
            y: dragOverlay.rect.top - active.rect.top
        };
        const scale = {
            scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
            scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
        };
        const finalTransform = {
            x: transform.x - delta.x,
            y: transform.y - delta.y,
            ...scale
        };
        const animationKeyframes = keyframes({
            ...rest,
            active: active,
            dragOverlay: dragOverlay,
            transform: {
                initial: transform,
                final: finalTransform
            }
        });
        const [firstKeyframe] = animationKeyframes;
        const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
        if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) // The start and end keyframes are the same, infer that there is no animation needed.
        return;
        const cleanup = sideEffects == null ? void 0 : sideEffects({
            active: active,
            dragOverlay: dragOverlay,
            ...rest
        });
        const animation = dragOverlay.node.animate(animationKeyframes, {
            duration: duration,
            easing: easing,
            fill: 'forwards'
        });
        return new Promise((resolve)=>{
            animation.onfinish = ()=>{
                cleanup == null || cleanup();
                resolve();
            };
        });
    };
}
let $554db1c65281cd7c$var$key = 0;
function $554db1c65281cd7c$var$useKey(id) {
    return (0, $h4Bez.useMemo)(()=>{
        if (id == null) return;
        $554db1c65281cd7c$var$key++;
        return $554db1c65281cd7c$var$key;
    }, [
        id
    ]);
}
const $554db1c65281cd7c$export$aca73479aa40659d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).memo((_ref)=>{
    let { adjustScale: adjustScale = false, children: children, dropAnimation: dropAnimationConfig, style: style, transition: transition, modifiers: modifiers, wrapperElement: wrapperElement = 'div', className: className, zIndex: zIndex = 999 } = _ref;
    const { activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, containerNodeRect: containerNodeRect, draggableNodes: draggableNodes, droppableContainers: droppableContainers, dragOverlay: dragOverlay, over: over, measuringConfiguration: measuringConfiguration, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, windowRect: windowRect } = $554db1c65281cd7c$export$4930f6bf413be70e();
    const transform = (0, $h4Bez.useContext)($554db1c65281cd7c$var$ActiveDraggableContext);
    const key = $554db1c65281cd7c$var$useKey(active == null ? void 0 : active.id);
    const modifiedTransform = $554db1c65281cd7c$export$f1696300e8775372(modifiers, {
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over: over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        transform: transform,
        windowRect: windowRect
    });
    const initialRect = $554db1c65281cd7c$var$useInitialValue(activeNodeRect);
    const dropAnimation = $554db1c65281cd7c$var$useDropAnimation({
        config: dropAnimationConfig,
        draggableNodes: draggableNodes,
        droppableContainers: droppableContainers,
        measuringConfiguration: measuringConfiguration
    }); // We need to wait for the active node to be measured before connecting the drag overlay ref
    // otherwise collisions can be computed against a mispositioned drag overlay
    const ref = initialRect ? dragOverlay.setRef : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($554db1c65281cd7c$var$NullifiedContextProvider, null, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($554db1c65281cd7c$var$AnimationManager, {
        animation: dropAnimation
    }, active && key ? (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($554db1c65281cd7c$var$PositionedOverlay, {
        key: key,
        id: active.id,
        ref: ref,
        as: wrapperElement,
        activatorEvent: activatorEvent,
        adjustScale: adjustScale,
        className: className,
        transition: transition,
        rect: initialRect,
        style: {
            zIndex: zIndex,
            ...style
        },
        transform: modifiedTransform
    }, children) : null));
});



var $h4Bez = parcelRequire("h4Bez");


/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */ function $f6c34cfee0d646a7$export$5d49d615ad5ea2b0(array, from, to) {
    const newArray = array.slice();
    newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */ function $f6c34cfee0d646a7$export$5d3a3e794fd2dcef(array, from, to) {
    const newArray = array.slice();
    newArray[from] = array[to];
    newArray[to] = array[from];
    return newArray;
}
function $f6c34cfee0d646a7$var$getSortedRects(items, rects) {
    return items.reduce((accumulator, id, index)=>{
        const rect = rects.get(id);
        if (rect) accumulator[index] = rect;
        return accumulator;
    }, Array(items.length));
}
function $f6c34cfee0d646a7$var$isValidIndex(index) {
    return index !== null && index >= 0;
}
function $f6c34cfee0d646a7$var$itemsEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $f6c34cfee0d646a7$var$normalizeDisabled(disabled) {
    if (typeof disabled === 'boolean') return {
        draggable: disabled,
        droppable: disabled
    };
    return disabled;
}
// To-do: We should be calculating scale transformation
const $f6c34cfee0d646a7$var$defaultScale = {
    scaleX: 1,
    scaleY: 1
};
const $f6c34cfee0d646a7$export$7a687825fa98548a = (_ref)=>{
    var _rects$activeIndex;
    let { rects: rects, activeNodeRect: fallbackActiveRect, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    const itemGap = $f6c34cfee0d646a7$var$getItemGap(rects, index, activeIndex);
    if (index === activeIndex) {
        const newIndexRect = rects[overIndex];
        if (!newIndexRect) return null;
        return {
            x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
            y: 0,
            ...$f6c34cfee0d646a7$var$defaultScale
        };
    }
    if (index > activeIndex && index <= overIndex) return {
        x: -activeNodeRect.width - itemGap,
        y: 0,
        ...$f6c34cfee0d646a7$var$defaultScale
    };
    if (index < activeIndex && index >= overIndex) return {
        x: activeNodeRect.width + itemGap,
        y: 0,
        ...$f6c34cfee0d646a7$var$defaultScale
    };
    return {
        x: 0,
        y: 0,
        ...$f6c34cfee0d646a7$var$defaultScale
    };
};
function $f6c34cfee0d646a7$var$getItemGap(rects, index, activeIndex) {
    const currentRect = rects[index];
    const previousRect = rects[index - 1];
    const nextRect = rects[index + 1];
    if (!currentRect || !previousRect && !nextRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
    return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const $f6c34cfee0d646a7$export$9377a9486e3fbbe1 = (_ref)=>{
    let { rects: rects, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const newRects = $f6c34cfee0d646a7$export$5d49d615ad5ea2b0(rects, overIndex, activeIndex);
    const oldRect = rects[index];
    const newRect = newRects[index];
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
const $f6c34cfee0d646a7$export$8b26fb37076c162 = (_ref)=>{
    let { activeIndex: activeIndex, index: index, rects: rects, overIndex: overIndex } = _ref;
    let oldRect;
    let newRect;
    if (index === activeIndex) {
        oldRect = rects[index];
        newRect = rects[overIndex];
    }
    if (index === overIndex) {
        oldRect = rects[index];
        newRect = rects[activeIndex];
    }
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
// To-do: We should be calculating scale transformation
const $f6c34cfee0d646a7$var$defaultScale$1 = {
    scaleX: 1,
    scaleY: 1
};
const $f6c34cfee0d646a7$export$fe2be640df2ffb9e = (_ref)=>{
    var _rects$activeIndex;
    let { activeIndex: activeIndex, activeNodeRect: fallbackActiveRect, index: index, rects: rects, overIndex: overIndex } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    if (index === activeIndex) {
        const overIndexRect = rects[overIndex];
        if (!overIndexRect) return null;
        return {
            x: 0,
            y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
            ...$f6c34cfee0d646a7$var$defaultScale$1
        };
    }
    const itemGap = $f6c34cfee0d646a7$var$getItemGap$1(rects, index, activeIndex);
    if (index > activeIndex && index <= overIndex) return {
        x: 0,
        y: -activeNodeRect.height - itemGap,
        ...$f6c34cfee0d646a7$var$defaultScale$1
    };
    if (index < activeIndex && index >= overIndex) return {
        x: 0,
        y: activeNodeRect.height + itemGap,
        ...$f6c34cfee0d646a7$var$defaultScale$1
    };
    return {
        x: 0,
        y: 0,
        ...$f6c34cfee0d646a7$var$defaultScale$1
    };
};
function $f6c34cfee0d646a7$var$getItemGap$1(clientRects, index, activeIndex) {
    const currentRect = clientRects[index];
    const previousRect = clientRects[index - 1];
    const nextRect = clientRects[index + 1];
    if (!currentRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
    return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const $f6c34cfee0d646a7$var$ID_PREFIX = 'Sortable';
const $f6c34cfee0d646a7$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createContext({
    activeIndex: -1,
    containerId: $f6c34cfee0d646a7$var$ID_PREFIX,
    disableTransforms: false,
    items: [],
    overIndex: -1,
    useDragOverlay: false,
    sortedRects: [],
    strategy: $f6c34cfee0d646a7$export$9377a9486e3fbbe1,
    disabled: {
        draggable: false,
        droppable: false
    }
});
function $f6c34cfee0d646a7$export$86155fde54f06e6a(_ref) {
    let { children: children, id: id, items: userDefinedItems, strategy: strategy = $f6c34cfee0d646a7$export$9377a9486e3fbbe1, disabled: disabledProp = false } = _ref;
    const { active: active, dragOverlay: dragOverlay, droppableRects: droppableRects, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $554db1c65281cd7c$export$4930f6bf413be70e)();
    const containerId = (0, $2b2eb81dab4d649a$export$c485849f2e393253)($f6c34cfee0d646a7$var$ID_PREFIX, id);
    const useDragOverlay = Boolean(dragOverlay.rect !== null);
    const items = (0, $h4Bez.useMemo)(()=>userDefinedItems.map((item)=>typeof item === 'object' && 'id' in item ? item.id : item), [
        userDefinedItems
    ]);
    const isDragging = active != null;
    const activeIndex = active ? items.indexOf(active.id) : -1;
    const overIndex = over ? items.indexOf(over.id) : -1;
    const previousItemsRef = (0, $h4Bez.useRef)(items);
    const itemsHaveChanged = !$f6c34cfee0d646a7$var$itemsEqual(items, previousItemsRef.current);
    const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
    const disabled = $f6c34cfee0d646a7$var$normalizeDisabled(disabledProp);
    (0, $2b2eb81dab4d649a$export$700979bc83e7db82)(()=>{
        if (itemsHaveChanged && isDragging) measureDroppableContainers(items);
    }, [
        itemsHaveChanged,
        items,
        isDragging,
        measureDroppableContainers
    ]);
    (0, $h4Bez.useEffect)(()=>{
        previousItemsRef.current = items;
    }, [
        items
    ]);
    const contextValue = (0, $h4Bez.useMemo)(()=>({
            activeIndex: activeIndex,
            containerId: containerId,
            disabled: disabled,
            disableTransforms: disableTransforms,
            items: items,
            overIndex: overIndex,
            useDragOverlay: useDragOverlay,
            sortedRects: $f6c34cfee0d646a7$var$getSortedRects(items, droppableRects),
            strategy: strategy
        }), [
        activeIndex,
        containerId,
        disabled.draggable,
        disabled.droppable,
        disableTransforms,
        items,
        overIndex,
        droppableRects,
        useDragOverlay,
        strategy
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($f6c34cfee0d646a7$var$Context.Provider, {
        value: contextValue
    }, children);
}
const $f6c34cfee0d646a7$export$e1ca29a833a61b5e = (_ref)=>{
    let { id: id, items: items, activeIndex: activeIndex, overIndex: overIndex } = _ref;
    return $f6c34cfee0d646a7$export$5d49d615ad5ea2b0(items, activeIndex, overIndex).indexOf(id);
};
const $f6c34cfee0d646a7$export$633d85fd1dcf5e11 = (_ref2)=>{
    let { containerId: containerId, isSorting: isSorting, wasDragging: wasDragging, index: index, items: items, newIndex: newIndex, previousItems: previousItems, previousContainerId: previousContainerId, transition: transition } = _ref2;
    if (!transition || !wasDragging) return false;
    if (previousItems !== items && index === newIndex) return false;
    if (isSorting) return true;
    return newIndex !== index && containerId === previousContainerId;
};
const $f6c34cfee0d646a7$var$defaultTransition = {
    duration: 200,
    easing: 'ease'
};
const $f6c34cfee0d646a7$var$transitionProperty = 'transform';
const $f6c34cfee0d646a7$var$disabledTransition = /*#__PURE__*/ (0, $2b2eb81dab4d649a$export$c4ffa16951855e28).Transition.toString({
    property: $f6c34cfee0d646a7$var$transitionProperty,
    duration: 0,
    easing: 'linear'
});
const $f6c34cfee0d646a7$var$defaultAttributes = {
    roleDescription: 'sortable'
};
/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */ function $f6c34cfee0d646a7$var$useDerivedTransform(_ref) {
    let { disabled: disabled, index: index, node: node, rect: rect } = _ref;
    const [derivedTransform, setDerivedtransform] = (0, $h4Bez.useState)(null);
    const previousIndex = (0, $h4Bez.useRef)(index);
    (0, $2b2eb81dab4d649a$export$700979bc83e7db82)(()=>{
        if (!disabled && index !== previousIndex.current && node.current) {
            const initial = rect.current;
            if (initial) {
                const current = (0, $554db1c65281cd7c$export$b6aa1f30c53d7454)(node.current, {
                    ignoreTransform: true
                });
                const delta = {
                    x: initial.left - current.left,
                    y: initial.top - current.top,
                    scaleX: initial.width / current.width,
                    scaleY: initial.height / current.height
                };
                if (delta.x || delta.y) setDerivedtransform(delta);
            }
        }
        if (index !== previousIndex.current) previousIndex.current = index;
    }, [
        disabled,
        index,
        node,
        rect
    ]);
    (0, $h4Bez.useEffect)(()=>{
        if (derivedTransform) setDerivedtransform(null);
    }, [
        derivedTransform
    ]);
    return derivedTransform;
}
function $f6c34cfee0d646a7$export$4ebcb6201122185a(_ref) {
    let { animateLayoutChanges: animateLayoutChanges = $f6c34cfee0d646a7$export$633d85fd1dcf5e11, attributes: userDefinedAttributes, disabled: localDisabled, data: customData, getNewIndex: getNewIndex = $f6c34cfee0d646a7$export$e1ca29a833a61b5e, id: id, strategy: localStrategy, resizeObserverConfig: resizeObserverConfig, transition: transition = $f6c34cfee0d646a7$var$defaultTransition } = _ref;
    const { items: items, containerId: containerId, activeIndex: activeIndex, disabled: globalDisabled, disableTransforms: disableTransforms, sortedRects: sortedRects, overIndex: overIndex, useDragOverlay: useDragOverlay, strategy: globalStrategy } = (0, $h4Bez.useContext)($f6c34cfee0d646a7$var$Context);
    const disabled = $f6c34cfee0d646a7$var$normalizeLocalDisabled(localDisabled, globalDisabled);
    const index = items.indexOf(id);
    const data = (0, $h4Bez.useMemo)(()=>({
            sortable: {
                containerId: containerId,
                index: index,
                items: items
            },
            ...customData
        }), [
        containerId,
        customData,
        index,
        items
    ]);
    const itemsAfterCurrentSortable = (0, $h4Bez.useMemo)(()=>items.slice(items.indexOf(id)), [
        items,
        id
    ]);
    const { rect: rect, node: node, isOver: isOver, setNodeRef: setDroppableNodeRef } = (0, $554db1c65281cd7c$export$d74e5d67dc2b3176)({
        id: id,
        data: data,
        disabled: disabled.droppable,
        resizeObserverConfig: {
            updateMeasurementsFor: itemsAfterCurrentSortable,
            ...resizeObserverConfig
        }
    });
    const { active: active, activatorEvent: activatorEvent, activeNodeRect: activeNodeRect, attributes: attributes, setNodeRef: setDraggableNodeRef, listeners: listeners, isDragging: isDragging, over: over, setActivatorNodeRef: setActivatorNodeRef, transform: transform } = (0, $554db1c65281cd7c$export$df30c81f5aa01ff7)({
        id: id,
        data: data,
        attributes: {
            ...$f6c34cfee0d646a7$var$defaultAttributes,
            ...userDefinedAttributes
        },
        disabled: disabled.draggable
    });
    const setNodeRef = (0, $2b2eb81dab4d649a$export$2f8294366bb2d67a)(setDroppableNodeRef, setDraggableNodeRef);
    const isSorting = Boolean(active);
    const displaceItem = isSorting && !disableTransforms && $f6c34cfee0d646a7$var$isValidIndex(activeIndex) && $f6c34cfee0d646a7$var$isValidIndex(overIndex);
    const shouldDisplaceDragSource = !useDragOverlay && isDragging;
    const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
    const strategy = localStrategy != null ? localStrategy : globalStrategy;
    const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
        rects: sortedRects,
        activeNodeRect: activeNodeRect,
        activeIndex: activeIndex,
        overIndex: overIndex,
        index: index
    }) : null;
    const newIndex = $f6c34cfee0d646a7$var$isValidIndex(activeIndex) && $f6c34cfee0d646a7$var$isValidIndex(overIndex) ? getNewIndex({
        id: id,
        items: items,
        activeIndex: activeIndex,
        overIndex: overIndex
    }) : index;
    const activeId = active == null ? void 0 : active.id;
    const previous = (0, $h4Bez.useRef)({
        activeId: activeId,
        items: items,
        newIndex: newIndex,
        containerId: containerId
    });
    const itemsHaveChanged = items !== previous.current.items;
    const shouldAnimateLayoutChanges = animateLayoutChanges({
        active: active,
        containerId: containerId,
        isDragging: isDragging,
        isSorting: isSorting,
        id: id,
        index: index,
        items: items,
        newIndex: previous.current.newIndex,
        previousItems: previous.current.items,
        previousContainerId: previous.current.containerId,
        transition: transition,
        wasDragging: previous.current.activeId != null
    });
    const derivedTransform = $f6c34cfee0d646a7$var$useDerivedTransform({
        disabled: !shouldAnimateLayoutChanges,
        index: index,
        node: node,
        rect: rect
    });
    (0, $h4Bez.useEffect)(()=>{
        if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
        if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
        if (items !== previous.current.items) previous.current.items = items;
    }, [
        isSorting,
        newIndex,
        containerId,
        items
    ]);
    (0, $h4Bez.useEffect)(()=>{
        if (activeId === previous.current.activeId) return;
        if (activeId != null && previous.current.activeId == null) {
            previous.current.activeId = activeId;
            return;
        }
        const timeoutId = setTimeout(()=>{
            previous.current.activeId = activeId;
        }, 50);
        return ()=>clearTimeout(timeoutId);
    }, [
        activeId
    ]);
    return {
        active: active,
        activeIndex: activeIndex,
        attributes: attributes,
        data: data,
        rect: rect,
        index: index,
        newIndex: newIndex,
        items: items,
        isOver: isOver,
        isSorting: isSorting,
        isDragging: isDragging,
        listeners: listeners,
        node: node,
        overIndex: overIndex,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        setDroppableNodeRef: setDroppableNodeRef,
        setDraggableNodeRef: setDraggableNodeRef,
        transform: derivedTransform != null ? derivedTransform : finalTransform,
        transition: getTransition()
    };
    function getTransition() {
        if (derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
        itemsHaveChanged && previous.current.newIndex === index) return $f6c34cfee0d646a7$var$disabledTransition;
        if (shouldDisplaceDragSource && !(0, $2b2eb81dab4d649a$export$130b789831072f4c)(activatorEvent) || !transition) return undefined;
        if (isSorting || shouldAnimateLayoutChanges) return (0, $2b2eb81dab4d649a$export$c4ffa16951855e28).Transition.toString({
            ...transition,
            property: $f6c34cfee0d646a7$var$transitionProperty
        });
        return undefined;
    }
}
function $f6c34cfee0d646a7$var$normalizeLocalDisabled(localDisabled, globalDisabled) {
    var _localDisabled$dragga, _localDisabled$droppa;
    if (typeof localDisabled === 'boolean') return {
        draggable: localDisabled,
        // Backwards compatibility
        droppable: false
    };
    return {
        draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
        droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
    };
}
function $f6c34cfee0d646a7$export$6424ec8a0d450b09(entry) {
    if (!entry) return false;
    const data = entry.data.current;
    if (data && 'sortable' in data && typeof data.sortable === 'object' && 'containerId' in data.sortable && 'items' in data.sortable && 'index' in data.sortable) return true;
    return false;
}
const $f6c34cfee0d646a7$var$directions = [
    (0, $554db1c65281cd7c$export$a8b1916dba3ae88b).Down,
    (0, $554db1c65281cd7c$export$a8b1916dba3ae88b).Right,
    (0, $554db1c65281cd7c$export$a8b1916dba3ae88b).Up,
    (0, $554db1c65281cd7c$export$a8b1916dba3ae88b).Left
];
const $f6c34cfee0d646a7$export$a6f27ecf02eb3a67 = (event, _ref)=>{
    let { context: { active: active, collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers, over: over, scrollableAncestors: scrollableAncestors } } = _ref;
    if ($f6c34cfee0d646a7$var$directions.includes(event.code)) {
        event.preventDefault();
        if (!active || !collisionRect) return;
        const filteredContainers = [];
        droppableContainers.getEnabled().forEach((entry)=>{
            if (!entry || entry != null && entry.disabled) return;
            const rect = droppableRects.get(entry.id);
            if (!rect) return;
            switch(event.code){
                case (0, $554db1c65281cd7c$export$a8b1916dba3ae88b).Down:
                    if (collisionRect.top < rect.top) filteredContainers.push(entry);
                    break;
                case (0, $554db1c65281cd7c$export$a8b1916dba3ae88b).Up:
                    if (collisionRect.top > rect.top) filteredContainers.push(entry);
                    break;
                case (0, $554db1c65281cd7c$export$a8b1916dba3ae88b).Left:
                    if (collisionRect.left > rect.left) filteredContainers.push(entry);
                    break;
                case (0, $554db1c65281cd7c$export$a8b1916dba3ae88b).Right:
                    if (collisionRect.left < rect.left) filteredContainers.push(entry);
                    break;
            }
        });
        const collisions = (0, $554db1c65281cd7c$export$c3a6c1c7122b31c9)({
            active: active,
            collisionRect: collisionRect,
            droppableRects: droppableRects,
            droppableContainers: filteredContainers,
            pointerCoordinates: null
        });
        let closestId = (0, $554db1c65281cd7c$export$ef1beab6d7287295)(collisions, 'id');
        if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) closestId = collisions[1].id;
        if (closestId != null) {
            const activeDroppable = droppableContainers.get(active.id);
            const newDroppable = droppableContainers.get(closestId);
            const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
            const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
            if (newNode && newRect && activeDroppable && newDroppable) {
                const newScrollAncestors = (0, $554db1c65281cd7c$export$e4864aa91b5ed091)(newNode);
                const hasDifferentScrollAncestors = newScrollAncestors.some((element, index)=>scrollableAncestors[index] !== element);
                const hasSameContainer = $f6c34cfee0d646a7$var$isSameContainer(activeDroppable, newDroppable);
                const isAfterActive = $f6c34cfee0d646a7$var$isAfter(activeDroppable, newDroppable);
                const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
                    x: 0,
                    y: 0
                } : {
                    x: isAfterActive ? collisionRect.width - newRect.width : 0,
                    y: isAfterActive ? collisionRect.height - newRect.height : 0
                };
                const rectCoordinates = {
                    x: newRect.left,
                    y: newRect.top
                };
                const newCoordinates = offset.x && offset.y ? rectCoordinates : (0, $2b2eb81dab4d649a$export$4e2d2ead65e5f7e3)(rectCoordinates, offset);
                return newCoordinates;
            }
        }
    }
    return undefined;
};
function $f6c34cfee0d646a7$var$isSameContainer(a, b) {
    if (!$f6c34cfee0d646a7$export$6424ec8a0d450b09(a) || !$f6c34cfee0d646a7$export$6424ec8a0d450b09(b)) return false;
    return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}
function $f6c34cfee0d646a7$var$isAfter(a, b) {
    if (!$f6c34cfee0d646a7$export$6424ec8a0d450b09(a) || !$f6c34cfee0d646a7$export$6424ec8a0d450b09(b)) return false;
    if (!$f6c34cfee0d646a7$var$isSameContainer(a, b)) return false;
    return a.data.current.sortable.index < b.data.current.sortable.index;
}











const $6f31109cb10dde07$var$PANEL_WIDTH = 280;
const $6f31109cb10dde07$var$SECTION_LABEL_HEIGHT = 24;
const $6f31109cb10dde07$var$ROW_HEIGHT = 32;
const $6f31109cb10dde07$var$HANDLE_ICON_SIZE = 16;
/** Marks the elements of a row that take the focus, so a change that moves or remounts the row can give it back */ const $6f31109cb10dde07$var$CONTROL_ATTRIBUTE = 'data-column-control';
const $6f31109cb10dde07$var$controlAttributes = (name, kind)=>({
        [$6f31109cb10dde07$var$CONTROL_ATTRIBUTE]: `${name}:${kind}`
    });
const $6f31109cb10dde07$var$restrictToVerticalAxis = ({ transform: transform })=>({
        ...transform,
        x: 0
    });
const $6f31109cb10dde07$var$paperStyle = {
    width: $6f31109cb10dde07$var$PANEL_WIDTH,
    p: 2,
    borderRadius: 2,
    border: 1,
    borderColor: 'grey.300',
    boxShadow: 4
};
const $6f31109cb10dde07$var$sectionLabelStyle = {
    display: 'flex',
    alignItems: 'center',
    height: $6f31109cb10dde07$var$SECTION_LABEL_HEIGHT,
    px: 2,
    fontWeight: 'fontWeightMedium',
    color: 'grey.500'
};
const $6f31109cb10dde07$var$dividerStyle = {
    my: 1.5,
    mx: 1
};
const $6f31109cb10dde07$var$rowStyle = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    height: $6f31109cb10dde07$var$ROW_HEIGHT,
    px: 2,
    borderRadius: 1,
    typography: 'body2',
    color: 'grey.900',
    bgcolor: 'common.white',
    '&:hover': {
        bgcolor: 'grey.100'
    }
};
/** A hidden column's label goes quiet, so a section reads as shown and hidden columns without comparing checkboxes */ const $6f31109cb10dde07$var$hiddenRowStyle = {
    color: 'grey.500'
};
const $6f31109cb10dde07$var$lockedRowStyle = {
    color: 'grey.400'
};
const $6f31109cb10dde07$var$draggedRowStyle = {
    zIndex: 1,
    bgcolor: 'grey.100',
    boxShadow: 3
};
const $6f31109cb10dde07$var$handleStyle = {
    color: 'grey.500',
    cursor: 'grab',
    touchAction: 'none',
    '& svg': {
        width: $6f31109cb10dde07$var$HANDLE_ICON_SIZE,
        height: $6f31109cb10dde07$var$HANDLE_ICON_SIZE
    }
};
const $6f31109cb10dde07$var$labelStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    flex: 1,
    minWidth: 0,
    cursor: 'pointer'
};
const $6f31109cb10dde07$var$labelTextStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
};
const $6f31109cb10dde07$var$pinStyle = {
    color: 'grey.500'
};
const $6f31109cb10dde07$var$pinnedStyle = {
    color: 'primary.700',
    '&:hover': {
        color: 'primary.700'
    }
};
const $6f31109cb10dde07$var$actionStyle = {
    justifyContent: 'flex-start',
    px: 2
};
/** The column a drag is over, unless it's the dragged column itself, where dropping changes nothing */ const $6f31109cb10dde07$var$dropTarget = (active, over)=>over === null || over.id === active.id ? null : String(over.id);
const $6f31109cb10dde07$var$ColumnRow = ({ name: name, names: names, view: view, visible: visible, locked: locked, onChange: onChange })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const labelText = (0, $c48a918c0b66dee1$export$26cca3fbd53af9cb)()(name);
    const { label: label } = (0, $365b0b4d68ac9bb9$export$ba0a914f5e13434b)(name);
    const pinned = view.pinned.includes(name);
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, setActivatorNodeRef: setActivatorNodeRef, transform: transform, transition: transition, isDragging: isDragging } = (0, $f6c34cfee0d646a7$export$4ebcb6201122185a)({
        id: name
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        ref: setNodeRef,
        "data-testid": `table-column-view-row-${name}`,
        sx: [
            $6f31109cb10dde07$var$rowStyle,
            !visible && $6f31109cb10dde07$var$hiddenRowStyle,
            locked && $6f31109cb10dde07$var$lockedRowStyle,
            isDragging && $6f31109cb10dde07$var$draggedRowStyle
        ],
        style: {
            transform: transform ? `translate3d(0, ${transform.y}px, 0)` : undefined,
            transition: transition
        },
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
                ref: setActivatorNodeRef,
                "data-testid": `table-column-view-handle-${name}`,
                ...$6f31109cb10dde07$var$controlAttributes(name, 'handle'),
                variant: "ghost",
                size: "small",
                sx: $6f31109cb10dde07$var$handleStyle,
                "aria-label": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).REORDER_COLUMN, {
                    column: labelText
                }),
                "aria-describedby": attributes['aria-describedby'],
                ...listeners,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $406058546778b7c9$export$7d3bc85820ac4455), {})
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                component: "label",
                sx: $6f31109cb10dde07$var$labelStyle,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $3a05949b3b89f754$export$d5fc9b27802c0882), {
                        "data-testid": `table-column-view-visible-${name}`,
                        slotProps: {
                            input: {
                                ...$6f31109cb10dde07$var$controlAttributes(name, 'visible')
                            }
                        },
                        checked: visible,
                        disabled: locked,
                        onChange: ()=>onChange((0, $2ac73d5fe610e8da$export$d643e649b02b904a)(names, view, name))
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        component: "span",
                        sx: $6f31109cb10dde07$var$labelTextStyle,
                        children: label === undefined ? labelText : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c48a918c0b66dee1$export$1cd1097fe7c7b76c), {
                            name: name
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
                "data-testid": `table-column-view-pin-${name}`,
                ...$6f31109cb10dde07$var$controlAttributes(name, 'pin'),
                variant: "ghost",
                size: "small",
                sx: pinned ? $6f31109cb10dde07$var$pinnedStyle : $6f31109cb10dde07$var$pinStyle,
                "aria-label": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).PIN_COLUMN, {
                    column: labelText
                }),
                "aria-pressed": pinned,
                onClick: ()=>onChange((0, $2ac73d5fe610e8da$export$947f0ad0b9bf6750)(names, view, name)),
                children: pinned ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8ca04bc134762c18$export$ae210882c8fc9b1d), {}) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $3ed56309b51b8a84$export$939bbb55cf6eefc7), {})
            })
        ]
    });
};
/** Its own drag and drop context, so a column is only ever dropped within its own group */ const $6f31109cb10dde07$var$Section = ({ title: title, columns: columns, names: names, view: view, visible: visible, onChange: onChange, onDragging: onDragging })=>{
    const titleId = (0, $h4Bez.useId)();
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const labelText = (0, $c48a918c0b66dee1$export$26cca3fbd53af9cb)();
    const sensors = (0, $554db1c65281cd7c$export$19012f58216d597f)((0, $554db1c65281cd7c$export$cc72dd71f4ec69eb)((0, $554db1c65281cd7c$export$b26af955418d6638)), (0, $554db1c65281cd7c$export$cc72dd71f4ec69eb)((0, $554db1c65281cd7c$export$44d67f2a438aeba9), {
        coordinateGetter: (0, $f6c34cfee0d646a7$export$a6f27ecf02eb3a67)
    }));
    const announcements = (0, $h4Bez.useMemo)(()=>{
        const text = (id)=>labelText(String(id));
        return {
            onDragStart: ({ active: active })=>translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).COLUMN_DRAG_START, {
                    column: text(active.id)
                }),
            onDragOver: ({ active: active, over: over })=>{
                const target = $6f31109cb10dde07$var$dropTarget(active, over);
                return target === null ? undefined : translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).COLUMN_DRAG_OVER, {
                    column: text(active.id),
                    target: text(target)
                });
            },
            onDragEnd: ({ active: active, over: over })=>{
                const target = $6f31109cb10dde07$var$dropTarget(active, over);
                return target === null ? translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).COLUMN_DRAG_CANCEL, {
                    column: text(active.id)
                }) : translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).COLUMN_DRAG_END, {
                    column: text(active.id),
                    target: text(target)
                });
            },
            onDragCancel: ({ active: active })=>translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).COLUMN_DRAG_CANCEL, {
                    column: text(active.id)
                })
        };
    }, [
        translator,
        labelText
    ]);
    const onDragEnd = ({ active: active, over: over })=>{
        onDragging(false);
        const target = $6f31109cb10dde07$var$dropTarget(active, over);
        if (target !== null) onChange((0, $2ac73d5fe610e8da$export$d1fbe0eb3fc9219)(names, view, String(active.id), target));
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        role: "group",
        "aria-labelledby": titleId,
        "data-testid": `table-column-view-section-${title.toLowerCase()}`,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                id: titleId,
                variant: "caption",
                component: "p",
                sx: $6f31109cb10dde07$var$sectionLabelStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: title
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $554db1c65281cd7c$export$2d5c5ceac203fc1e), {
                sensors: sensors,
                collisionDetection: (0, $554db1c65281cd7c$export$c8e785ae6b74bab8),
                modifiers: [
                    $6f31109cb10dde07$var$restrictToVerticalAxis
                ],
                accessibility: {
                    announcements: announcements,
                    screenReaderInstructions: {
                        draggable: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).COLUMN_DRAG_INSTRUCTIONS)
                    }
                },
                onDragStart: ()=>onDragging(true),
                onDragCancel: ()=>onDragging(false),
                onDragEnd: onDragEnd,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f6c34cfee0d646a7$export$86155fde54f06e6a), {
                    items: [
                        ...columns
                    ],
                    strategy: (0, $f6c34cfee0d646a7$export$fe2be640df2ffb9e),
                    children: columns.map((name)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($6f31109cb10dde07$var$ColumnRow, {
                            name: name,
                            names: names,
                            view: view,
                            visible: visible.includes(name),
                            locked: visible.length === 1 && visible.includes(name),
                            onChange: onChange
                        }, name))
                })
            })
        ]
    });
};
const $6f31109cb10dde07$export$3f1a42862a2a067c = ({ view: view, onChange: onChange })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const buttonRef = (0, $h4Bez.useRef)(null);
    const names = (0, $365b0b4d68ac9bb9$export$edd9cd4ea59a06e0)();
    const [open, setOpen] = (0, $h4Bez.useState)(false);
    const [dragging, setDragging] = (0, $h4Bez.useState)(false);
    const autoFit = (0, $0c0f9342266be860$export$b12b86e52c431902)(onChange);
    const showsRows = (0, $365b0b4d68ac9bb9$export$21bdbb26575478ef)();
    const paperRef = (0, $h4Bez.useRef)(null);
    /** A change can move a row, or remount it in the other section, which loses the focus: it goes back to the same control */ const focusedControl = (0, $h4Bez.useRef)(null);
    (0, $h4Bez.useLayoutEffect)(()=>{
        const paper = paperRef.current;
        const active = document.activeElement;
        if (focusedControl.current === null || paper === null || active !== null && active !== document.body && active !== paper) return;
        const control = Array.from(paper.querySelectorAll(`[${$6f31109cb10dde07$var$CONTROL_ATTRIBUTE}]`)).find((element)=>element.getAttribute($6f31109cb10dde07$var$CONTROL_ATTRIBUTE) === focusedControl.current);
        control?.focus();
    }, [
        view
    ]);
    const close = ()=>{
        focusedControl.current = null;
        setOpen(false);
    };
    const label = translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).CONFIGURE_COLUMNS);
    const ordered = (0, $2ac73d5fe610e8da$export$ac763d2b0470e663)(names, view);
    const visible = (0, $2ac73d5fe610e8da$export$1b6de485b4f669da)(names, view);
    const sections = [
        [
            (0, $40a99dac858c1d75$export$b63289fbda65eed1).PINNED,
            ordered.filter((name)=>view.pinned.includes(name))
        ],
        [
            (0, $40a99dac858c1d75$export$b63289fbda65eed1).COLUMNS,
            ordered.filter((name)=>!view.pinned.includes(name))
        ]
    ];
    const nonEmptySections = sections.filter(([, columns])=>columns.length > 0);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $69cdbe69cde47e02$export$2e2bcd8739ae039), {
                title: label,
                placement: "left",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
                    ref: buttonRef,
                    "data-testid": "table-column-view-button",
                    variant: "ghost",
                    size: "medium",
                    "aria-label": label,
                    "aria-haspopup": "dialog",
                    "aria-expanded": open,
                    onClick: ()=>setOpen(true),
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ce136346c7e03d64$export$4167fcc1b9e413a0), {})
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $63ee27f962173109$export$2e2bcd8739ae039), {
                onFocus: (e)=>{
                    focusedControl.current = e.target.getAttribute($6f31109cb10dde07$var$CONTROL_ATTRIBUTE);
                },
                "data-testid": "table-column-view-menu",
                open: open,
                anchorEl: buttonRef.current,
                onClose: close,
                disableEscapeKeyDown: dragging,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                slotProps: {
                    paper: {
                        ref: paperRef,
                        role: 'dialog',
                        'aria-modal': true,
                        'aria-label': label,
                        sx: $6f31109cb10dde07$var$paperStyle
                    }
                },
                children: [
                    nonEmptySections.map(([title, columns], index)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Fragment, {
                            children: [
                                index > 0 && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {
                                    sx: $6f31109cb10dde07$var$dividerStyle
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($6f31109cb10dde07$var$Section, {
                                    title: title,
                                    columns: columns,
                                    names: names,
                                    view: view,
                                    visible: visible,
                                    onChange: onChange,
                                    onDragging: setDragging
                                })
                            ]
                        }, title)),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {
                        sx: $6f31109cb10dde07$var$dividerStyle
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                        "data-testid": "table-column-view-auto-fit",
                        variant: "ghost",
                        size: "medium",
                        fullWidth: true,
                        sx: $6f31109cb10dde07$var$actionStyle,
                        startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ec178a7cbf24362e$export$ad8cd11d6f0ad24c), {}),
                        /**
                     * The last column absorbs the remaining width, so a single one has nothing to fit.
                     * Without data rows only the headers would be measured, shrinking the columns to them
                     */ disabled: visible.length < 2 || !showsRows,
                        onClick: ()=>{
                            const button = buttonRef.current;
                            (0, $14eddac5f20c576c$export$a7a9523472993e97)(button, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'The column view menu must be opened from its button'));
                            close();
                            autoFit(button, visible.slice(0, -1));
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).AUTO_FIT_COLUMNS
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                        "data-testid": "table-column-view-reset",
                        variant: "ghost",
                        size: "medium",
                        fullWidth: true,
                        sx: $6f31109cb10dde07$var$actionStyle,
                        startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ce4e3ee315615fb1$export$35f5c3e250802cd1), {}),
                        disabled: (0, $2ac73d5fe610e8da$export$e1be355857979d95)(names, view),
                        onClick: ()=>{
                            close();
                            onChange((0, $2ac73d5fe610e8da$export$638aea850a86a555));
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).RESET_VIEW
                        })
                    })
                ]
            })
        ]
    });
};




const $65daccee4cca2dff$export$ba51118a8204c870 = ()=>{
    const hasSelection = (0, $365b0b4d68ac9bb9$export$dbeaeea714145b36)();
    const view = (0, $365b0b4d68ac9bb9$export$ddca39529720c1e7)();
    const onColumnViewChange = (0, $365b0b4d68ac9bb9$export$d7e6be191e8598da)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $96e1a88505b6a102$export$2e2bcd8739ae039), {
        "data-testid": "column-header-trailing",
        sx: (0, $74cb18f1bcbeda31$export$139e32077d3d7f8a),
        children: [
            hasSelection && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
                style: (0, $7e4b04c742d6c9ba$export$2e2bcd8739ae039),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ACTION,
                    values: {
                        count: 2
                    }
                })
            }),
            onColumnViewChange && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6f31109cb10dde07$export$3f1a42862a2a067c), {
                view: view,
                onChange: onColumnViewChange
            })
        ]
    });
};
const $65daccee4cca2dff$export$983528750b2086e1 = ({ index: index, row: row })=>{
    const hasSelection = (0, $365b0b4d68ac9bb9$export$dbeaeea714145b36)();
    return hasSelection ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $74cb18f1bcbeda31$export$935284610f07e8be), {
        index: index,
        row: row
    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $96e1a88505b6a102$export$2e2bcd8739ae039), {
        sx: (0, $74cb18f1bcbeda31$export$139e32077d3d7f8a)
    });
};


const $0076e67121b41141$var$directionsInversion = {
    asc: 'desc',
    desc: 'asc'
};
/**
 * The label ellipsizes itself rather than the cell clipping, so the sort icon and anything on the cell's edge stay whole.
 * A block, so inside the sort label it's a flex item that can shrink below its text
 */ const $0076e67121b41141$var$oneLineLabelStyle = {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
};
const $0076e67121b41141$export$19ca7ae5fe2f8d1 = 2;
/**
 * A grip reaches past its cell's edge into the next header cell, which would paint over it, so each header cell stacks above the one after it.
 * The head is a single layer at MUI's sticky z-index, so these values only order the header cells among themselves
 */ const $0076e67121b41141$var$resizableHeadStyle = {
    position: 'relative',
    zIndex: $0076e67121b41141$export$19ca7ae5fe2f8d1
};
const $0076e67121b41141$var$SelectionCell = ()=>{
    const [selection, toggle] = (0, $365b0b4d68ac9bb9$export$2802d569b9a7f906)();
    return selection ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $96e1a88505b6a102$export$2e2bcd8739ae039), {
        padding: "checkbox",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $3a05949b3b89f754$export$d5fc9b27802c0882), {
            "data-testid": "checkbox-all",
            indeterminate: selection.onlySome,
            checked: selection.all,
            onChange: toggle
        })
    }, "table-header-checkbox") : null;
};
const $0076e67121b41141$var$HeaderLabel = ({ name: name })=>{
    const currentSort = (0, $365b0b4d68ac9bb9$export$962ffaf51b485576)();
    const setSort = (0, $365b0b4d68ac9bb9$export$25aba3f9e4b4587)();
    const { sort: sort = false } = (0, $365b0b4d68ac9bb9$export$ba0a914f5e13434b)(name);
    const hasColumnView = (0, $365b0b4d68ac9bb9$export$e904f852b627a2bb)();
    const label = hasColumnView ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        component: "span",
        "data-testid": `column-header-label-${String(name)}`,
        sx: $0076e67121b41141$var$oneLineLabelStyle,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c48a918c0b66dee1$export$1cd1097fe7c7b76c), {
            name: name
        })
    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c48a918c0b66dee1$export$1cd1097fe7c7b76c), {
        name: name
    });
    if (!sort) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
        children: label
    });
    const active = currentSort?.name === name;
    /**
     * If active, then use configuration, otherwise, settle for ascending
     */ const currentDirection = active ? currentSort.direction : 'asc';
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b33264bd28ba4b44$export$2e2bcd8739ae039), {
        active: active,
        direction: currentDirection,
        onClick: ()=>setSort({
                name: name,
                /**
                     * If active, then invert, otherwise, use the currently displayed direction
                     */ direction: active ? $0076e67121b41141$var$directionsInversion[currentDirection] : currentDirection
            }),
        children: label
    });
};
const $0076e67121b41141$var$HeaderCell = ({ name: name, resizable: resizable, zIndex: zIndex })=>{
    const { type: type = null } = (0, $365b0b4d68ac9bb9$export$ba0a914f5e13434b)(name);
    const onColumnViewChange = (0, $365b0b4d68ac9bb9$export$d7e6be191e8598da)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $96e1a88505b6a102$export$2e2bcd8739ae039), {
        align: type === 'number' ? 'right' : undefined,
        "data-testid": `column-header-${name}`,
        style: zIndex === undefined ? undefined : {
            zIndex: zIndex
        },
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($0076e67121b41141$var$HeaderLabel, {
                name: name
            }),
            resizable && onColumnViewChange && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5ee1e722544b740d$export$97b609de3b8b1942), {
                name: name,
                onChange: onColumnViewChange
            })
        ]
    });
};
const $0076e67121b41141$export$8b251419efc915eb = ()=>{
    const names = (0, $365b0b4d68ac9bb9$export$8b715ac3f253d94f)();
    const shouldShow = (0, $365b0b4d68ac9bb9$export$ee823454c92c1f0c)();
    const hasTrailingColumn = (0, $365b0b4d68ac9bb9$export$68419e81990e3a75)();
    const hasColumnView = (0, $365b0b4d68ac9bb9$export$e904f852b627a2bb)();
    if (!shouldShow) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f6709e6d86243a70$export$2e2bcd8739ae039), {
        sx: hasColumnView ? $0076e67121b41141$var$resizableHeadStyle : undefined,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $f771ba0376b3fe85$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($0076e67121b41141$var$SelectionCell, {}),
                names.map((name, index)=>/** The last column absorbs the remaining width, so it has no edge of its own to drag */ /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($0076e67121b41141$var$HeaderCell, {
                        name: name,
                        resizable: index < names.length - 1,
                        zIndex: hasColumnView ? $0076e67121b41141$export$19ca7ae5fe2f8d1 + names.length - index : undefined
                    }, String(name))),
                hasTrailingColumn && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $65daccee4cca2dff$export$ba51118a8204c870), {})
            ]
        })
    });
};



parcelRequire("h4Bez");






const $d04adac75ff678c7$var$wrappingCellStyle = {
    wordBreak: 'break-all'
};
/** Custom content that can't ellipsize itself (e.g. a row of links) is clipped at the cell's edge */ const $d04adac75ff678c7$var$oneLineCellStyle = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
};
const $d04adac75ff678c7$var$clickableRowStyle = {
    cursor: 'pointer'
};
const $d04adac75ff678c7$var$columnTypeStyles = {
    number: {
        fontVariantNumeric: 'tabular-nums'
    },
    datetime: {
        fontVariantNumeric: 'tabular-nums',
        color: 'grey.600'
    }
};
const $d04adac75ff678c7$var$isEmptyValue = (value)=>value === null || value === undefined || value === '';
const $d04adac75ff678c7$var$isPlainText = (value)=>typeof value === 'string' && value !== '' || typeof value === 'number';
const $d04adac75ff678c7$var$Cell = ({ name: name, row: row, index: index })=>{
    const { customCellRender: customCellRender, sx: sx = null, type: type = null } = (0, $365b0b4d68ac9bb9$export$ba0a914f5e13434b)(name);
    const hasColumnView = (0, $365b0b4d68ac9bb9$export$e904f852b627a2bb)();
    const value = row[name];
    /** One line can hide the end of the text, so a plain text cell carries all of it */ const title = hasColumnView && !customCellRender && $d04adac75ff678c7$var$isPlainText(value) ? String(value) : undefined;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $96e1a88505b6a102$export$2e2bcd8739ae039), {
        align: type === 'number' ? 'right' : undefined,
        title: title,
        sx: {
            ...hasColumnView ? $d04adac75ff678c7$var$oneLineCellStyle : $d04adac75ff678c7$var$wrappingCellStyle,
            ...type && $d04adac75ff678c7$var$columnTypeStyles[type],
            ...sx
        },
        children: customCellRender ? customCellRender(value, row, index) : $d04adac75ff678c7$var$isEmptyValue(value) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$3eec49f24c546686), {}) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
            children: value
        })
    });
};
const $d04adac75ff678c7$var$MIDDLE_BUTTON = 1;
const $d04adac75ff678c7$var$isNewTabClick = (e)=>e.metaKey || e.ctrlKey || e.shiftKey;
const $d04adac75ff678c7$var$INNER_CONTROLS = [
    'a',
    'button',
    'input',
    'select',
    'textarea',
    'label',
    '[role="button"]',
    '[role="menuitem"]',
    '[role="checkbox"]',
    '[contenteditable="true"]',
    '[contenteditable=""]'
].join(', ');
/**
 * A middle-click belongs to the row only on the row's own DOM, outside of its links and controls
 * Events from the row's portals (e.g. an open actions menu) reach it through the React tree too, so they're excluded
 */ const $d04adac75ff678c7$var$isOwnMiddleClick = (e)=>e.button === $d04adac75ff678c7$var$MIDDLE_BUTTON && e.target instanceof Element && e.currentTarget.contains(e.target) && (e.target === e.currentTarget || e.target.closest($d04adac75ff678c7$var$INNER_CONTROLS) === null);
/**
 * Only the row's own Enter acts: a key pressed on a control inside the row belongs to that control, and a held key doesn't act again
 * Plain Enter opens the row, Cmd/Ctrl+Enter opens it in a new tab, any other modified Enter is left to the page
 */ const $d04adac75ff678c7$var$onOwnEnter = (e, open, openInNewTab)=>{
    if (e.key !== 'Enter' || e.target !== e.currentTarget || e.repeat || e.shiftKey || e.altKey) return;
    if (e.ctrlKey || e.metaKey) {
        openInNewTab?.();
        return;
    }
    open?.();
};
const $d04adac75ff678c7$var$onClick = (e, open, openInNewTab)=>{
    if (openInNewTab && $d04adac75ff678c7$var$isNewTabClick(e)) {
        openInNewTab();
        return;
    }
    open?.();
};
const $d04adac75ff678c7$var$onMiddleButton = (e, handle)=>{
    if ($d04adac75ff678c7$var$isOwnMiddleClick(e)) handle();
};
const $d04adac75ff678c7$export$b59bdbef9ce70de2 = ({ index: index, row: row })=>{
    const names = (0, $365b0b4d68ac9bb9$export$8b715ac3f253d94f)();
    const onRowClick = (0, $365b0b4d68ac9bb9$export$db30c675496008e0)();
    const onRowOpenInNewTab = (0, $365b0b4d68ac9bb9$export$d76d5f6ada6e0635)();
    const active = (0, $365b0b4d68ac9bb9$export$d0a86e60c44d2654)(row);
    const rowRef = (0, $365b0b4d68ac9bb9$export$7630f92e7d8440de)();
    const hasTrailingColumn = (0, $365b0b4d68ac9bb9$export$68419e81990e3a75)();
    const [selected, toggleSelection] = (0, $365b0b4d68ac9bb9$export$a97c3cc4bf1da1ca)(row);
    const open = onRowClick && (()=>onRowClick(row));
    const openInNewTab = open && onRowOpenInNewTab && (()=>onRowOpenInNewTab(row));
    const interactive = Boolean(open);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $f771ba0376b3fe85$export$2e2bcd8739ae039), {
        ref: rowRef ? (element)=>rowRef(row, element) : undefined,
        onClick: interactive ? (e)=>$d04adac75ff678c7$var$onClick(e, open, openInNewTab) : undefined,
        onAuxClick: openInNewTab ? (e)=>$d04adac75ff678c7$var$onMiddleButton(e, openInNewTab) : undefined,
        /** Keeps the middle button from starting the browser's autoscroll */ onMouseDown: openInNewTab ? (e)=>$d04adac75ff678c7$var$onMiddleButton(e, ()=>e.preventDefault()) : undefined,
        tabIndex: interactive ? 0 : undefined,
        onKeyDown: interactive ? (e)=>$d04adac75ff678c7$var$onOwnEnter(e, open, openInNewTab) : undefined,
        hover: interactive,
        selected: active,
        "aria-current": active ? 'true' : undefined,
        sx: interactive ? $d04adac75ff678c7$var$clickableRowStyle : undefined,
        children: [
            selected !== null && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $96e1a88505b6a102$export$2e2bcd8739ae039), {
                padding: "checkbox",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $3a05949b3b89f754$export$d5fc9b27802c0882), {
                    "data-testid": `checkbox-${index}`,
                    checked: selected,
                    onClick: (0, $1fdb53e1bec07519$export$5532d7f774835bb3)(toggleSelection)
                })
            }, `checkbox-${index}`),
            names.map((name)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($d04adac75ff678c7$var$Cell, {
                    name: name,
                    row: row,
                    index: index
                }, String(name))),
            hasTrailingColumn && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $65daccee4cca2dff$export$983528750b2086e1), {
                index: index,
                row: row
            })
        ]
    }, `table-row-${index}`);
};



parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");











function $1f5a3c34ac1a2e19$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiLinearProgress', slot);
}
const $1f5a3c34ac1a2e19$var$linearProgressClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'bar1',
    'bar2',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
var $1f5a3c34ac1a2e19$export$2e2bcd8739ae039 = $1f5a3c34ac1a2e19$var$linearProgressClasses;



'use client';
const $2db76c9e9f88b3ff$var$TRANSITION_DURATION = 4; // seconds
const $2db76c9e9f88b3ff$var$indeterminate1Keyframe = (0, $2260c64920c0bb2a$export$d25ddfdf17c3ad3e)`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $2db76c9e9f88b3ff$var$indeterminate1Animation = typeof $2db76c9e9f88b3ff$var$indeterminate1Keyframe !== 'string' ? (0, $2260c64920c0bb2a$export$dbf350e5966cf602)`
        animation: ${$2db76c9e9f88b3ff$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null;
const $2db76c9e9f88b3ff$var$indeterminate2Keyframe = (0, $2260c64920c0bb2a$export$d25ddfdf17c3ad3e)`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`;
const $2db76c9e9f88b3ff$var$indeterminate2Animation = typeof $2db76c9e9f88b3ff$var$indeterminate2Keyframe !== 'string' ? (0, $2260c64920c0bb2a$export$dbf350e5966cf602)`
        animation: ${$2db76c9e9f88b3ff$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null;
const $2db76c9e9f88b3ff$var$bufferKeyframe = (0, $2260c64920c0bb2a$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`;
const $2db76c9e9f88b3ff$var$bufferAnimation = typeof $2db76c9e9f88b3ff$var$bufferKeyframe !== 'string' ? (0, $2260c64920c0bb2a$export$dbf350e5966cf602)`
        animation: ${$2db76c9e9f88b3ff$var$bufferKeyframe} 3s infinite linear;
      ` : null;
const $2db76c9e9f88b3ff$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`
        ],
        bar1: [
            'bar',
            'bar1',
            `barColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            'bar2',
            variant !== 'buffer' && `barColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            variant === 'buffer' && `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $1f5a3c34ac1a2e19$export$bc8a6ea1eb17d7c6), classes);
};
const $2db76c9e9f88b3ff$var$getColorShade = (theme, color)=>{
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? theme.lighten(theme.palette[color].main, 0.62) : theme.darken(theme.palette[color].main, 0.5);
};
const $2db76c9e9f88b3ff$var$LinearProgressRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        // Fix Safari's bug during composition of different paint.
        zIndex: 0,
        '@media print': {
            colorAdjust: 'exact'
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: $2db76c9e9f88b3ff$var$getColorShade(theme, color)
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.color === 'inherit' && ownerState.variant !== 'buffer',
                style: {
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'currentColor',
                        opacity: 0.3
                    }
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    backgroundColor: 'transparent'
                }
            },
            {
                props: {
                    variant: 'query'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
const $2db76c9e9f88b3ff$var$LinearProgressDashed = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%',
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3,
                    backgroundImage: `radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>{
                const backgroundColor = $2db76c9e9f88b3ff$var$getColorShade(theme, color);
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`
                    }
                };
            })
        ]
    })), $2db76c9e9f88b3ff$var$bufferAnimation || {
    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
    animation: `${$2db76c9e9f88b3ff$var$bufferKeyframe} 3s infinite linear`
});
const $2db76c9e9f88b3ff$var$LinearProgressBar1 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar1,
            styles[`barColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: `transform .${$2db76c9e9f88b3ff$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    zIndex: 1,
                    transition: `transform .${$2db76c9e9f88b3ff$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $2db76c9e9f88b3ff$var$indeterminate1Animation || {
                    animation: `${$2db76c9e9f88b3ff$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
                }
            }
        ]
    })));
const $2db76c9e9f88b3ff$var$LinearProgressBar2 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar2,
            styles[`barColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--LinearProgressBar2-barColor': (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color !== 'inherit',
                style: {
                    backgroundColor: 'var(--LinearProgressBar2-barColor, currentColor)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color === 'inherit',
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        variant: 'buffer'
                    },
                    style: {
                        backgroundColor: $2db76c9e9f88b3ff$var$getColorShade(theme, color),
                        transition: `transform .${$2db76c9e9f88b3ff$var$TRANSITION_DURATION}s linear`
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $2db76c9e9f88b3ff$var$indeterminate2Animation || {
                    animation: `${$2db76c9e9f88b3ff$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $2db76c9e9f88b3ff$var$LinearProgress = /*#__PURE__*/ $h4Bez.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className: className, color: color = 'primary', value: value, valueBuffer: valueBuffer, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        variant: variant
    };
    const classes = $2db76c9e9f88b3ff$var$useUtilityClasses(ownerState);
    const isRtl = (0, $c12c19e2bf4d75c0$export$b2dd014b6c321cb)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($2db76c9e9f88b3ff$var$LinearProgressRoot, {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar",
        ...rootProps,
        ref: ref,
        ...other,
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($2db76c9e9f88b3ff$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($2db76c9e9f88b3ff$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($2db76c9e9f88b3ff$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    });
});
var $2db76c9e9f88b3ff$export$2e2bcd8739ae039 = $2db76c9e9f88b3ff$var$LinearProgress;


var $h4Bez = parcelRequire("h4Bez");



function $24286c160c1cb1b8$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $24286c160c1cb1b8$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function $24286c160c1cb1b8$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $24286c160c1cb1b8$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $24286c160c1cb1b8$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $24286c160c1cb1b8$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $24286c160c1cb1b8$export$8af1d214c6c2f0f1(length) * $24286c160c1cb1b8$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $24286c160c1cb1b8$export$8af1d214c6c2f0f1(length) * $24286c160c1cb1b8$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $24286c160c1cb1b8$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $24286c160c1cb1b8$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $24286c160c1cb1b8$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $24286c160c1cb1b8$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $24286c160c1cb1b8$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}







function $abe7767b5e7dc7a2$export$c987db9fc844f86(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiSkeleton', slot);
}
const $abe7767b5e7dc7a2$var$skeletonClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $abe7767b5e7dc7a2$export$2e2bcd8739ae039 = $abe7767b5e7dc7a2$var$skeletonClasses;



'use client';
const $aed0c3ec5f0eae1f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $abe7767b5e7dc7a2$export$c987db9fc844f86), classes);
};
const $aed0c3ec5f0eae1f$var$pulseKeyframe = (0, $2260c64920c0bb2a$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`;
const $aed0c3ec5f0eae1f$var$waveKeyframe = (0, $2260c64920c0bb2a$export$d25ddfdf17c3ad3e)`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $aed0c3ec5f0eae1f$var$pulseAnimation = typeof $aed0c3ec5f0eae1f$var$pulseKeyframe !== 'string' ? (0, $2260c64920c0bb2a$export$dbf350e5966cf602)`
        animation: ${$aed0c3ec5f0eae1f$var$pulseKeyframe} 2s ease-in-out 0.5s infinite;
      ` : null;
const $aed0c3ec5f0eae1f$var$waveAnimation = typeof $aed0c3ec5f0eae1f$var$waveKeyframe !== 'string' ? (0, $2260c64920c0bb2a$export$dbf350e5966cf602)`
        &::after {
          animation: ${$aed0c3ec5f0eae1f$var$waveKeyframe} 2s linear 0.5s infinite;
        }
      ` : null;
const $aed0c3ec5f0eae1f$var$SkeletonRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const radiusUnit = (0, $24286c160c1cb1b8$export$65f2564e9a9b9222)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $24286c160c1cb1b8$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return {
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : theme.alpha(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em',
        variants: [
            {
                props: {
                    variant: 'text'
                },
                style: {
                    marginTop: 0,
                    marginBottom: 0,
                    height: 'auto',
                    transformOrigin: '0 55%',
                    transform: 'scale(1, 0.60)',
                    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
                    '&:empty:before': {
                        content: '"\\00a0"'
                    }
                }
            },
            {
                props: {
                    variant: 'circular'
                },
                style: {
                    borderRadius: '50%'
                }
            },
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren,
                style: {
                    '& > *': {
                        visibility: 'hidden'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.width,
                style: {
                    maxWidth: 'fit-content'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.height,
                style: {
                    height: 'auto'
                }
            },
            {
                props: {
                    animation: 'pulse'
                },
                style: $aed0c3ec5f0eae1f$var$pulseAnimation || {
                    animation: `${$aed0c3ec5f0eae1f$var$pulseKeyframe} 2s ease-in-out 0.5s infinite`
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: {
                    position: 'relative',
                    overflow: 'hidden',
                    /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */ WebkitMaskImage: '-webkit-radial-gradient(white, black)',
                    '&::after': {
                        background: `linear-gradient(
                90deg,
                transparent,
                ${(theme.vars || theme).palette.action.hover},
                transparent
              )`,
                        content: '""',
                        position: 'absolute',
                        transform: 'translateX(-100%)' /* Avoid flash during server-side hydration */ ,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        top: 0
                    }
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: $aed0c3ec5f0eae1f$var$waveAnimation || {
                    '&::after': {
                        animation: `${$aed0c3ec5f0eae1f$var$waveKeyframe} 2s linear 0.5s infinite`
                    }
                }
            }
        ]
    };
}));
const $aed0c3ec5f0eae1f$var$Skeleton = /*#__PURE__*/ $h4Bez.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width, ...other } = props;
    const ownerState = {
        ...props,
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    };
    const classes = $aed0c3ec5f0eae1f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($aed0c3ec5f0eae1f$var$SkeletonRoot, {
        as: component,
        ref: ref,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ...other,
        style: {
            width: width,
            height: height,
            ...style
        }
    });
});
var $aed0c3ec5f0eae1f$export$2e2bcd8739ae039 = $aed0c3ec5f0eae1f$var$Skeleton;








const $16aede0005caa95c$var$MAX_SKELETON_ROWS = 10;
const $16aede0005caa95c$var$UNPAGED_SKELETON_ROWS = 5;
const $16aede0005caa95c$var$skeletonRowStyle = {
    gap: 3,
    alignItems: 'center'
};
const $16aede0005caa95c$var$skeletonMarkStyle = {
    flexShrink: 0,
    borderRadius: 0.5
};
const $16aede0005caa95c$var$RELOADING_BAR_HEIGHT = 2;
/** Above the sticky header */ const $16aede0005caa95c$var$reloadingBarStyle = {
    position: 'absolute',
    left: (0, $a1537862b7417309$export$db3bf26306c7aefe),
    right: (0, $a1537862b7417309$export$db3bf26306c7aefe),
    height: $16aede0005caa95c$var$RELOADING_BAR_HEIGHT,
    zIndex: (0, $0076e67121b41141$export$19ca7ae5fe2f8d1) + 1
};
/** Varies the bar lengths so the placeholder reads as text of different lengths, not as a grid */ const $16aede0005caa95c$var$toBarWidth = (index)=>`${55 + index * 37 % 40}%`;
const $16aede0005caa95c$export$7fd4dd39ae6c4c57 = ()=>{
    const colSpan = (0, $365b0b4d68ac9bb9$export$b17375fa3d9f6db1)();
    const pageSize = (0, $365b0b4d68ac9bb9$export$8dc4d8418d8568f5)();
    const rows = Math.min(pageSize ?? $16aede0005caa95c$var$UNPAGED_SKELETON_ROWS, $16aede0005caa95c$var$MAX_SKELETON_ROWS);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
        children: Array.from({
            length: rows
        }, (_, index)=>/** Only the first row stays exposed, to announce the loading once */ /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f771ba0376b3fe85$export$2e2bcd8739ae039), {
                "data-testid": "table-skeleton-row",
                "aria-hidden": index > 0 || undefined,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $96e1a88505b6a102$export$2e2bcd8739ae039), {
                    colSpan: colSpan,
                    children: [
                        index === 0 && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
                            style: (0, $7e4b04c742d6c9ba$export$2e2bcd8739ae039),
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TABLE_LOADING
                            })
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
                            direction: "row",
                            sx: $16aede0005caa95c$var$skeletonRowStyle,
                            "aria-hidden": true,
                            children: [
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $aed0c3ec5f0eae1f$export$2e2bcd8739ae039), {
                                    variant: "rectangular",
                                    animation: "wave",
                                    width: 20,
                                    height: 20,
                                    sx: $16aede0005caa95c$var$skeletonMarkStyle
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $aed0c3ec5f0eae1f$export$2e2bcd8739ae039), {
                                    variant: "rounded",
                                    animation: "wave",
                                    width: $16aede0005caa95c$var$toBarWidth(index + 1),
                                    height: 12
                                })
                            ]
                        })
                    ]
                })
            }, index))
    });
};
const $16aede0005caa95c$export$726d2a5861fcd2a = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const top = (0, $a1537862b7417309$export$db3bf26306c7aefe) + ((0, $365b0b4d68ac9bb9$export$ee823454c92c1f0c)() ? (0, $a1537862b7417309$export$befff265f4340460) - $16aede0005caa95c$var$RELOADING_BAR_HEIGHT : 0);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2db76c9e9f88b3ff$export$2e2bcd8739ae039), {
        "data-testid": "table-reloading",
        sx: [
            $16aede0005caa95c$var$reloadingBarStyle,
            {
                top: top
            }
        ],
        "aria-label": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).TABLE_LOADING)
    });
};





var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");












'use client';
var $2aefb57dc041c2ec$var$_span;
const $2aefb57dc041c2ec$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $2aefb57dc041c2ec$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $0f9a46367366d2ec$export$4b135a4b3a6c4550), classes);
};
const $2aefb57dc041c2ec$var$InputAdornmentRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $2aefb57dc041c2ec$var$overridesResolver
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active,
        variants: [
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    [`&.${(0, $0f9a46367366d2ec$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $0f9a46367366d2ec$export$2e2bcd8739ae039).hiddenLabel})`]: {
                        marginTop: 16
                    }
                }
            },
            {
                props: {
                    position: 'start'
                },
                style: {
                    marginRight: 8
                }
            },
            {
                props: {
                    position: 'end'
                },
                style: {
                    marginLeft: 8
                }
            },
            {
                props: {
                    disablePointerEvents: true
                },
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const $2aefb57dc041c2ec$var$InputAdornment = /*#__PURE__*/ $h4Bez.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp, ...other } = props;
    const muiFormControl = (0, $364d4e99dd433e44$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = {
        ...props,
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    };
    const classes = $2aefb57dc041c2ec$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $afe0146e047a78c2$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($2aefb57dc041c2ec$var$InputAdornmentRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ...other,
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                color: "textSecondary",
                children: children
            }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($h4Bez.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $2aefb57dc041c2ec$var$_span || ($2aefb57dc041c2ec$var$_span = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
                        className: "notranslate",
                        "aria-hidden": true,
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        })
    });
});
var $2aefb57dc041c2ec$export$2e2bcd8739ae039 = $2aefb57dc041c2ec$var$InputAdornment;




"use client";
var $5844aca28da17e19$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');








const $5133aad883f0cf99$var$TOOLBAR_HEIGHT = 44;
const $5133aad883f0cf99$var$HAIRLINE_HEIGHT = 20;
const $5133aad883f0cf99$var$toolbarStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 2,
    minHeight: $5133aad883f0cf99$var$TOOLBAR_HEIGHT,
    my: 3
};
const $5133aad883f0cf99$var$groupStyle = {
    display: 'flex',
    gap: 2,
    alignItems: 'center',
    flexWrap: 'nowrap'
};
const $5133aad883f0cf99$var$pushedRightStyle = {
    ...$5133aad883f0cf99$var$groupStyle,
    ml: 'auto'
};
const $5133aad883f0cf99$var$hairlineStyle = {
    flex: 'none',
    width: '1px',
    height: $5133aad883f0cf99$var$HAIRLINE_HEIGHT,
    mr: 1,
    bgcolor: 'grey.200'
};
const $5133aad883f0cf99$var$selectedCountStyle = {
    fontWeight: 'fontWeightMedium',
    color: 'grey.900',
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap'
};
const $5133aad883f0cf99$var$searchIconStyle = {
    mr: 2
};
/** Laid over the input's end, so showing or hiding it never resizes the field */ const $5133aad883f0cf99$var$charactersLeftStyle = {
    position: 'absolute',
    right: ({ spacing: spacing })=>spacing(2),
    top: '50%',
    transform: 'translateY(-50%)',
    pointerEvents: 'none'
};
const $5133aad883f0cf99$var$SelectionActionButton = ({ action: action })=>{
    const { icons: { [action]: Icon = (0, $80eac538e231fc01$export$adee39cfbee1cf99)[action] }, labels: { [action]: label = (0, $80eac538e231fc01$export$d05858291b5222ca)[action] }, onSelect: onSelect } = (0, $365b0b4d68ac9bb9$export$459a847cde06c169)();
    const lines = (0, $365b0b4d68ac9bb9$export$37c02c2c66380263)();
    const loaded = (0, $365b0b4d68ac9bb9$export$a7fa9df522e0d0db)();
    const { [action]: onClick } = onSelect(lines);
    if (!onClick) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
        variant: action === (0, $80eac538e231fc01$export$d8f733b7bbec3a6) ? 'dangerOutline' : 'secondary',
        size: "medium",
        startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Icon, {}),
        /** The actions' dialogs only find the selected records in loaded rows */ disabled: !loaded,
        onClick: ()=>onClick(lines),
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: label
        })
    });
};
/** Added to the bar while rows are selected, instead of replacing the bar: search, filters and utilities stay usable */ const $5133aad883f0cf99$var$SelectionGroup = ()=>{
    const count = (0, $365b0b4d68ac9bb9$export$37c02c2c66380263)().length;
    const clear = (0, $365b0b4d68ac9bb9$export$d2838f462516652)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "table-selection",
        sx: $5133aad883f0cf99$var$pushedRightStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $5133aad883f0cf99$var$hairlineStyle,
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                role: "status",
                variant: "body2",
                sx: $5133aad883f0cf99$var$selectedCountStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SELECTED_COUNT,
                    values: {
                        count: count
                    }
                })
            }),
            (0, $80eac538e231fc01$export$2d2b69fca0cded9e).map((action)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($5133aad883f0cf99$var$SelectionActionButton, {
                    action: action
                }, action)),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                variant: "ghost",
                size: "medium",
                onClick: clear,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CLEAR
                })
            })
        ]
    });
};
/**
 * Tells how many more characters a search needs to run.
 * It is a polite live region, rendered even while empty, so screen readers announce the count as it changes while typing.
 */ const $5133aad883f0cf99$var$SearchCharactersLeft = ({ id: id, count: count })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2aefb57dc041c2ec$export$2e2bcd8739ae039), {
        position: "end",
        sx: $5133aad883f0cf99$var$charactersLeftStyle,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
            id: id,
            "data-testid": "table-search-characters-left",
            component: "span",
            variant: "caption",
            color: "grey.500",
            "aria-live": "polite",
            "aria-atomic": "true",
            children: count > 0 && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SEARCH_CHARACTERS_LEFT,
                values: {
                    count: count
                }
            })
        })
    });
const $5133aad883f0cf99$var$DownloadCSVButton = ({ onClick: onClick })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
        variant: "secondary",
        size: "medium",
        startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6c4ecf59edd403be$export$4e54df4252b4a99c), {}),
        onClick: onClick,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DOWNLOAD_CSV
        })
    });
const $5133aad883f0cf99$export$4c260019440d418f = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const filters = (0, $365b0b4d68ac9bb9$export$973ca22476b0e05f)();
    const utilities = (0, $365b0b4d68ac9bb9$export$64bb4c8f3f725dd0)();
    const onDownloadCSV = (0, $365b0b4d68ac9bb9$export$9c745eae7a46cfdb)();
    const hasSelection = (0, $365b0b4d68ac9bb9$export$b7ea63286f69ae91)();
    const isSearching = (0, $365b0b4d68ac9bb9$export$4fcd4d06ac62e583)();
    const searchText = (0, $365b0b4d68ac9bb9$export$bd221a7c56b93941)();
    const dispatchSearch = (0, $365b0b4d68ac9bb9$export$7768d9cbb1ba6f45)();
    const searchThreshold = (0, $365b0b4d68ac9bb9$export$2be88e8ec3fb8bbd)();
    const charactersLeftId = (0, $h4Bez.useId)();
    const charactersLeft = (0, $365b0b4d68ac9bb9$export$2766bc1f66000a0b)();
    const hasUtilities = Boolean(onDownloadCSV) || Boolean(utilities);
    if (!isSearching && !filters && !hasUtilities && !hasSelection) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "table-toolbar",
        sx: $5133aad883f0cf99$var$toolbarStyle,
        children: [
            isSearching && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d887fad28e7ec96c$export$2c73285ae9390cec), {
                "data-testid": "table-search-input",
                size: "small",
                placeholder: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).SEARCH_PLACEHOLDER, {
                    count: searchThreshold
                }),
                startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5844aca28da17e19$export$2e2bcd8739ae039), {
                    sx: $5133aad883f0cf99$var$searchIconStyle
                }),
                value: searchText,
                onChange: ({ target: target })=>dispatchSearch(target.value),
                slotProps: searchThreshold > 0 ? {
                    input: {
                        endAdornment: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($5133aad883f0cf99$var$SearchCharactersLeft, {
                            id: charactersLeftId,
                            count: charactersLeft
                        })
                    },
                    htmlInput: {
                        'aria-describedby': charactersLeftId
                    }
                } : undefined
            }),
            filters && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $5133aad883f0cf99$var$groupStyle,
                children: filters
            }),
            hasSelection && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($5133aad883f0cf99$var$SelectionGroup, {}),
            hasUtilities && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: hasSelection ? $5133aad883f0cf99$var$groupStyle : $5133aad883f0cf99$var$pushedRightStyle,
                children: [
                    onDownloadCSV ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($5133aad883f0cf99$var$DownloadCSVButton, {
                        onClick: onDownloadCSV
                    }) : null,
                    utilities
                ]
            })
        ]
    });
};



const $1a719df2b816a6fd$var$containerWrapperStyle = {
    position: 'relative'
};
/** The frame draws the border and doesn't scroll, so the pager below the rows stays outside the scroll area and its scrollbar */ const $1a719df2b816a6fd$var$frameStyle = {
    overflow: 'hidden'
};
const $1a719df2b816a6fd$var$scrollAreaStyle = {
    overflow: 'auto'
};
const $1a719df2b816a6fd$var$ScrollArea = ({ children: children })=>{
    const maxHeight = (0, $365b0b4d68ac9bb9$export$30dc190df7e420c4)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "table-scroll-area",
        sx: [
            $1a719df2b816a6fd$var$scrollAreaStyle,
            {
                maxHeight: maxHeight
            }
        ],
        children: children
    });
};
const $1a719df2b816a6fd$var$LoadedBodyContent = ()=>{
    const visibleRows = (0, $365b0b4d68ac9bb9$export$7c9c226b640ed210)();
    if (!(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(visibleRows)) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f5cd22834412711$export$cb26bcc37361661c), {});
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
        children: visibleRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d04adac75ff678c7$export$b59bdbef9ce70de2), {
                index: rowIndex,
                row: row
            }, rowIndex))
    });
};
const $1a719df2b816a6fd$var$BodyContent = ()=>{
    switch((0, $365b0b4d68ac9bb9$export$15313dbeba21e0cd)()){
        case 'error':
            return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $566162f982754e39$export$4527cc126632fbc1), {});
        case 'rows':
            return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1a719df2b816a6fd$var$LoadedBodyContent, {});
        case 'skeleton':
            return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $16aede0005caa95c$export$7fd4dd39ae6c4c57), {});
        case 'reloading':
            return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1a719df2b816a6fd$var$LoadedBodyContent, {});
    }
};
const $1a719df2b816a6fd$var$ReloadingOverlay = ()=>(0, $365b0b4d68ac9bb9$export$15313dbeba21e0cd)() === 'reloading' ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $16aede0005caa95c$export$726d2a5861fcd2a), {}) : null;
const $1a719df2b816a6fd$var$BusyTable = ({ children: children })=>{
    const bodyState = (0, $365b0b4d68ac9bb9$export$15313dbeba21e0cd)();
    const busy = bodyState === 'skeleton' || bodyState === 'reloading';
    const layout = (0, $a32335fbd01007d5$export$4446f89fea009832)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $556c9cdfdbb1f7f2$export$2e2bcd8739ae039), {
        stickyHeader: true,
        size: "medium",
        "aria-busy": busy || undefined,
        sx: layout?.sx,
        style: layout?.style,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a32335fbd01007d5$export$8a8fbc71323f074), {}),
            children
        ]
    });
};
const $1a719df2b816a6fd$export$54ec01a60f47d33d = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $365b0b4d68ac9bb9$export$4e02b9968dad1f), {
        value: props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
            "data-testid": (0, $3dd52092ec4fc8cb$export$eea0c9f46a8cc3f9)(props) || 'common-table',
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5133aad883f0cf99$export$4c260019440d418f), {}),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: $1a719df2b816a6fd$var$containerWrapperStyle,
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $e5ad0c1c6afb18b6$export$2e2bcd8739ae039), {
                            sx: $1a719df2b816a6fd$var$frameStyle,
                            children: [
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1a719df2b816a6fd$var$ScrollArea, {
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($1a719df2b816a6fd$var$BusyTable, {
                                        children: [
                                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0076e67121b41141$export$8b251419efc915eb), {}),
                                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5584ae6c05089f22$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1a719df2b816a6fd$var$BodyContent, {})
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $3bcd022418ca4732$export$a06f1c675e846f6f), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1a719df2b816a6fd$var$ReloadingOverlay, {})
                    ]
                }),
                children
            ]
        })
    });










var $h4Bez = parcelRequire("h4Bez");
const $f81bd50c14cd4ce4$export$f0b9a6b1089d086a = /*#__PURE__*/ (0, $h4Bez.forwardRef)(({ accept: accept, onChange: onChange, ...props }, ref)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("input", {
        ...props,
        type: "file",
        hidden: true,
        accept: accept?.map((t)=>`.${t}`).join(','),
        ref: ref,
        onChange: (e)=>{
            onChange(Array.from(e.target.files ?? []));
            /**
             * This drops the internal value
             * Forcing any further selection to also be accepted
             *
             * Before this change, a file upload (no matter the content of it)
             * would be ignored if it had the same file path
             */ e.target.value = '';
        }
    }));




var $h4Bez = parcelRequire("h4Bez");






const $fec793432225fcda$var$wrapperStyle = {
    display: 'flex',
    overflow: 'hidden',
    '& > *': {
        my: 'auto'
    }
};
const $fec793432225fcda$var$buttonStyle = {
    px: 4,
    mr: 2,
    minWidth: 120,
    overflow: 'hidden'
};
const $fec793432225fcda$var$labelStyle = {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center'
};
const $fec793432225fcda$export$d92f83d2e295fa99 = ({ initialValue: initialValue = [], onChange: onChange, readOnly: readOnly, ...props })=>{
    const ref = /*#__PURE__*/ (0, $h4Bez.createRef)();
    const [{ length: length, 0: firstFile }, setFakeValue] = (0, $h4Bez.useState)(()=>initialValue);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $fec793432225fcda$var$wrapperStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                sx: $fec793432225fcda$var$buttonStyle,
                variant: "primaryOutline",
                size: "large",
                disabled: readOnly,
                onClick: (0, $1fdb53e1bec07519$export$a5a34735bf65cdae)(ref),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).FILE_UPLOAD_LABEL
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                sx: $fec793432225fcda$var$labelStyle,
                variant: "body2",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).FILE_UPLOAD,
                    values: {
                        length: length,
                        firstFileName: firstFile?.name
                    }
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f81bd50c14cd4ce4$export$f0b9a6b1089d086a), {
                ...props,
                readOnly: readOnly,
                ref: ref,
                onChange: (files)=>{
                    setFakeValue(files);
                    onChange?.(files);
                }
            })
        ]
    });
};










var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");

/**
 * @warning keep deps here
 */ const $076f55b7ca6ba74a$var$fallbackDeps = [];
const $076f55b7ca6ba74a$export$ede2eb47b82c13a2 = (callback, interval, deps = $076f55b7ca6ba74a$var$fallbackDeps)=>{
    /** Ensure no closure mishaps occur */ const cachedCallback = (0, $h4Bez.useCallback)(callback, deps);
    /** Sets up timed-updater */ (0, $h4Bez.useLayoutEffect)(()=>{
        /** First ensure that the time is up an running */ const off = (0, $ad06b61c4606f6df$export$5fe74ec28e3a5524)(cachedCallback, interval);
        /** Make the initial call */ cachedCallback();
        /** And give the unhook function to the use effect hook to do its thing */ return off;
    }, [
        interval,
        cachedCallback
    ]);
};




const $837dcb3f32a07e41$export$7419ff430885d61c = ({ delay: delay, children: children })=>{
    const updatedChildrenRef = (0, $h4Bez.useRef)();
    updatedChildrenRef.current = children;
    const [renderedChildren, setRenderedChildren] = (0, $h4Bez.useState)(()=>updatedChildrenRef.current);
    /**
     * At the given refresh rate
     * Update the children
     */ (0, $076f55b7ca6ba74a$export$ede2eb47b82c13a2)(()=>{
        if (updatedChildrenRef.current !== renderedChildren) setRenderedChildren(updatedChildrenRef.current);
    }, delay);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
        children: renderedChildren
    });
};






var $h4Bez = parcelRequire("h4Bez");

const $39543ef1c93c1508$var$defaultRenderer = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        ...props
    });
const $39543ef1c93c1508$export$a49368ab94976679 = ({ renderer: Renderer = $39543ef1c93c1508$var$defaultRenderer, children: children, ...props })=>{
    const [hovering, setHovering] = (0, $h4Bez.useState)(false);
    const [updatedChildren, updateChildren] = (0, $h4Bez.useState)(()=>children);
    (0, $h4Bez.useEffect)(()=>{
        if (!hovering) updateChildren(children);
    }, [
        children,
        hovering
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Renderer, {
        ...props,
        onMouseEnter: ()=>setHovering(true),
        onMouseLeave: ()=>setHovering(false),
        children: updatedChildren
    });
};






var $h4Bez = parcelRequire("h4Bez");


parcelRequire("h4Bez");




const $d700fad781a6ea93$var$formatPayload = (payload, type)=>{
    switch(type){
        case (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).OBJECT:
            return JSON.parse(payload.toString());
        case (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).HEX:
            return payload.toString('hex');
        case (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).NUMBER:
            return Number(payload.toString());
        case (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).LARGE_BUFFER:
        default:
            return payload.toString();
    }
};
const $d700fad781a6ea93$export$bc337bf4c402f8eb = ({ className: className, buffer: buffer, type: type, minimized: minimized = false, sx: sx })=>{
    if (type === (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).OBJECT) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $39543ef1c93c1508$export$a49368ab94976679), {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $47ae8c6618e10a1b$export$48880ac635f47186), {
            src: $d700fad781a6ea93$var$formatPayload(buffer, type),
            displayObjectSize: false,
            collapsed: minimized ? true : 1
        })
    });
    const value = String($d700fad781a6ea93$var$formatPayload(buffer, type));
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: sx,
        className: className,
        title: type === (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).LARGE_BUFFER ? undefined : value,
        children: [
            value,
            type === (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).LARGE_BUFFER && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("b", {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
                        children: ' ...'
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BUFFER_TOO_LARGE_TO_BE_DISPLAYED
                    })
                ]
            })
        ]
    });
};



parcelRequire("h4Bez");




const $e6cc39abef12fe2c$export$7b34e01a92f12324 = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return (type)=>{
        return translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).TOPIC_TYPE, {
            type: type
        });
    };
};


const $44de09297248da6f$export$243ac2346c8e8d3c = ({ value: value, types: types, onChange: onChange, sx: sx })=>{
    const translate = (0, $e6cc39abef12fe2c$export$7b34e01a92f12324)();
    if (types.length < 2) /**
         * No real choice is possible, give up
         */ return null;
    const bufferOptions = types.map((type)=>({
            value: type,
            label: translate(type)
        })).sort(({ label: a }, { label: b })=>b.localeCompare(a));
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: sx,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d85f7a63a75c527f$export$931cbfb6bfb85fc), {
            buttonLabel: translate(value),
            options: bufferOptions,
            size: "medium",
            "data-testid": "buffer-type-select",
            value: value,
            onChange: onChange
        })
    });
};


const $0ef57b6c25dc3e6b$var$wrapperStyle = {
    display: 'flex'
};
const $0ef57b6c25dc3e6b$var$columBaseStyle = {
    m: 'auto 0',
    fontSize: 'body2.fontSize'
};
const $0ef57b6c25dc3e6b$var$columnStyle = {
    ...$0ef57b6c25dc3e6b$var$columBaseStyle,
    ml: 0.5
};
const $0ef57b6c25dc3e6b$var$columnFullWidthStyle = {
    ...$0ef57b6c25dc3e6b$var$columnStyle,
    ml: 'auto'
};
const $0ef57b6c25dc3e6b$export$76748c987176663a = ({ buffer: buffer, types: types, fullWidth: fullWidth = false, minimized: minimized, onChange: onChange, sx: sx, className: className, ...props })=>{
    const [type, setType] = (0, $h4Bez.useState)(()=>types[0]);
    (0, $h4Bez.useEffect)(()=>{
        setType(types[0]);
    }, [
        [
            ...types
        ].sort().join(' ')
    ]);
    /** If the new types do not include the selected type, then don't render anything */ if (!types.includes(type)) return null;
    const column = fullWidth ? $0ef57b6c25dc3e6b$var$columnFullWidthStyle : $0ef57b6c25dc3e6b$var$columnStyle;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        ...props,
        className: className,
        sx: {
            ...$0ef57b6c25dc3e6b$var$wrapperStyle,
            ...sx
        },
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d700fad781a6ea93$export$bc337bf4c402f8eb), {
                sx: $0ef57b6c25dc3e6b$var$columBaseStyle,
                buffer: buffer,
                type: type,
                minimized: minimized
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $44de09297248da6f$export$243ac2346c8e8d3c), {
                sx: column,
                value: type,
                types: types,
                onChange: (type)=>{
                    setType(type);
                    onChange?.(type);
                }
            })
        ]
    });
};









var $h4Bez = parcelRequire("h4Bez");













'use client';
const $16c5441b130409bf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $ec69fe0e5fb4f961$export$39f6debbec19b3ba), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $16c5441b130409bf$var$SwitchRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $16c5441b130409bf$var$SwitchSwitchBase = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $3bb54a012d66bf14$export$2e2bcd8739ae039), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).checked} + .${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).disabled} + .${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).input}`]: {
            left: '-100%',
            width: '300%'
        }
    })), (0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)([
                'light'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? theme.lighten(theme.palette[color].main, 0.62) : theme.darken(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).checked} + .${(0, $ec69fe0e5fb4f961$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    })));
const $16c5441b130409bf$var$SwitchTrack = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiSwitch',
    slot: 'Track'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    })));
const $16c5441b130409bf$var$SwitchThumb = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    })));
const $16c5441b130409bf$var$Switch = /*#__PURE__*/ $h4Bez.forwardRef(function Switch(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        edge: edge,
        size: size
    };
    const classes = $16c5441b130409bf$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('root', {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $16c5441b130409bf$var$SwitchRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            sx: sx
        }
    });
    const [ThumbSlot, thumbSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('thumb', {
        className: classes.thumb,
        elementType: $16c5441b130409bf$var$SwitchThumb,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const icon = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(ThumbSlot, {
        ...thumbSlotProps
    });
    const [TrackSlot, trackSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('track', {
        className: classes.track,
        elementType: $16c5441b130409bf$var$SwitchTrack,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($16c5441b130409bf$var$SwitchSwitchBase, {
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState,
                ...other,
                classes: {
                    ...classes,
                    root: classes.switchBase
                },
                slots: {
                    ...slots.switchBase && {
                        root: slots.switchBase
                    },
                    ...slots.input && {
                        input: slots.input
                    }
                },
                slotProps: {
                    ...slotProps.switchBase && {
                        root: typeof slotProps.switchBase === 'function' ? slotProps.switchBase(ownerState) : slotProps.switchBase
                    },
                    input: {
                        role: 'switch'
                    },
                    ...slotProps.input && {
                        input: typeof slotProps.input === 'function' ? slotProps.input(ownerState) : slotProps.input
                    }
                }
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(TrackSlot, {
                ...trackSlotProps
            })
        ]
    });
});
var $16c5441b130409bf$export$2e2bcd8739ae039 = $16c5441b130409bf$var$Switch;


const $74886ba3288b8cfe$export$b5d5cf8927ab7262 = (0, $16c5441b130409bf$export$2e2bcd8739ae039);



var $h4Bez = parcelRequire("h4Bez");












var $h4Bez = parcelRequire("h4Bez");
'use client';
/**
 * @ignore - internal component.
 */ const $26af2589a63e2674$var$ToggleButtonGroupContext = /*#__PURE__*/ $h4Bez.createContext({});
var $26af2589a63e2674$export$2e2bcd8739ae039 = $26af2589a63e2674$var$ToggleButtonGroupContext;



var $h4Bez = parcelRequire("h4Bez");
'use client';
/**
 * @ignore - internal component.
 */ const $5de439811e2105e6$var$ToggleButtonGroupButtonContext = /*#__PURE__*/ $h4Bez.createContext(undefined);
var $5de439811e2105e6$export$2e2bcd8739ae039 = $5de439811e2105e6$var$ToggleButtonGroupButtonContext;


// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function $67469d46f014102c$export$2e2bcd8739ae039(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.includes(value);
    return value === candidate;
}



'use client';
const $83ee6cefddea3f04$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, fullWidth: fullWidth, selected: selected, disabled: disabled, size: size, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled',
            fullWidth && 'fullWidth',
            `size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`,
            color
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $62bfdfa4f6c0c890$export$21f89b560b65a301), classes);
};
const $83ee6cefddea3f04$var$ToggleButtonRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d02728b6fe958b24$export$2e2bcd8739ae039), {
    name: 'MuiToggleButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.button,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $62bfdfa4f6c0c890$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        },
        '&:hover': {
            textDecoration: 'none',
            // Reset on mouse devices
            backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            {
                props: {
                    color: 'standard'
                },
                style: {
                    [`&.${(0, $62bfdfa4f6c0c890$export$2e2bcd8739ae039).selected}`]: {
                        color: (theme.vars || theme).palette.text.primary,
                        backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.selectedOpacity),
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                            // Reset on touch devices, it doesn't add specificity
                            '@media (hover: none)': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.selectedOpacity)
                            }
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $62bfdfa4f6c0c890$export$2e2bcd8739ae039).selected}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.selectedOpacity),
                            '&:hover': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                                // Reset on touch devices, it doesn't add specificity
                                '@media (hover: none)': {
                                    backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.selectedOpacity)
                                }
                            }
                        }
                    }
                })),
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 7,
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 15,
                    fontSize: theme.typography.pxToRem(15)
                }
            }
        ]
    })));
const $83ee6cefddea3f04$var$ToggleButton = /*#__PURE__*/ $h4Bez.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const { value: contextValue, ...contextProps } = $h4Bez.useContext((0, $26af2589a63e2674$export$2e2bcd8739ae039));
    const toggleButtonGroupButtonContextPositionClassName = $h4Bez.useContext((0, $5de439811e2105e6$export$2e2bcd8739ae039));
    const resolvedProps = (0, $8a4b1f01109d1a9b$export$2e2bcd8739ae039)({
        ...contextProps,
        selected: (0, $67469d46f014102c$export$2e2bcd8739ae039)(inProps.value, contextValue)
    }, inProps);
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: resolvedProps,
        name: 'MuiToggleButton'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: fullWidth = false, onChange: onChange, onClick: onClick, selected: selected, size: size = 'medium', value: value, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size
    };
    const classes = $83ee6cefddea3f04$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) return;
        }
        if (onChange) onChange(event, value);
    };
    const positionClassName = toggleButtonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($83ee6cefddea3f04$var$ToggleButtonRoot, {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected,
        ...other,
        children: children
    });
});
var $83ee6cefddea3f04$export$2e2bcd8739ae039 = $83ee6cefddea3f04$var$ToggleButton;


const $a0c70995540c0264$export$d2b052e7b4be1756 = (0, $83ee6cefddea3f04$export$2e2bcd8739ae039);



var $h4Bez = parcelRequire("h4Bez");





var $h4Bez = parcelRequire("h4Bez");
function $48607cded6ebfb4f$export$2e2bcd8739ae039(children) {
    return $h4Bez.Children.toArray(children).filter((child)=>/*#__PURE__*/ $h4Bez.isValidElement(child));
}











'use client';
const $716388be379d72a2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, fullWidth: fullWidth, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            fullWidth && 'fullWidth'
        ],
        grouped: [
            'grouped',
            `grouped${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(orientation)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $e26e3704b6dc01bd$export$44aa3ae5b353cef1), classes);
};
const $716388be379d72a2$var$ToggleButtonGroupRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiToggleButtonGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).grouped}`]: styles.grouped
            },
            {
                [`& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.orientation)}`]
            },
            {
                [`& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
            },
            {
                [`& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
            },
            {
                [`& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
            },
            styles.root,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).grouped}`]: {
                        [`&.${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).selected} + .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).grouped}.${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).selected}`]: {
                            borderTop: 0,
                            marginTop: 0
                        }
                    },
                    [`& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).firstButton},& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).lastButton},& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).middleButton}`]: {
                        marginTop: -1,
                        borderTop: '1px solid transparent',
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0
                    },
                    [`& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).lastButton}.${(0, $62bfdfa4f6c0c890$export$2e2bcd8739ae039).disabled},& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).middleButton}.${(0, $62bfdfa4f6c0c890$export$2e2bcd8739ae039).disabled}`]: {
                        borderTop: '1px solid transparent'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).grouped}`]: {
                        [`&.${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).selected} + .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).grouped}.${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).selected}`]: {
                            borderLeft: 0,
                            marginLeft: 0
                        }
                    },
                    [`& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).firstButton},& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).lastButton},& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).middleButton}`]: {
                        marginLeft: -1,
                        borderLeft: '1px solid transparent',
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    },
                    [`& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).lastButton}.${(0, $62bfdfa4f6c0c890$export$2e2bcd8739ae039).disabled},& .${(0, $e26e3704b6dc01bd$export$2e2bcd8739ae039).middleButton}.${(0, $62bfdfa4f6c0c890$export$2e2bcd8739ae039).disabled}`]: {
                        borderLeft: '1px solid transparent'
                    }
                }
            }
        ]
    })));
const $716388be379d72a2$var$ToggleButtonGroup = /*#__PURE__*/ $h4Bez.forwardRef(function ToggleButtonGroup(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiToggleButtonGroup'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, exclusive: exclusive = false, fullWidth: fullWidth = false, onChange: onChange, orientation: orientation = 'horizontal', size: size = 'medium', value: value, ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size
    };
    const classes = $716388be379d72a2$var$useUtilityClasses(ownerState);
    const handleChange = $h4Bez.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        const index = value && value.indexOf(buttonValue);
        let newValue;
        if (value && index >= 0) {
            newValue = value.slice();
            newValue.splice(index, 1);
        } else newValue = value ? value.concat(buttonValue) : [
            buttonValue
        ];
        onChange(event, newValue);
    }, [
        onChange,
        value
    ]);
    const handleExclusiveChange = $h4Bez.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        onChange(event, value === buttonValue ? null : buttonValue);
    }, [
        onChange,
        value
    ]);
    const context = $h4Bez.useMemo(()=>({
            className: classes.grouped,
            onChange: exclusive ? handleExclusiveChange : handleChange,
            value: value,
            size: size,
            fullWidth: fullWidth,
            color: color,
            disabled: disabled
        }), [
        classes.grouped,
        exclusive,
        handleExclusiveChange,
        handleChange,
        value,
        size,
        fullWidth,
        color,
        disabled
    ]);
    const validChildren = (0, $48607cded6ebfb4f$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($716388be379d72a2$var$ToggleButtonGroupRoot, {
        role: "group",
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $26af2589a63e2674$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5de439811e2105e6$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
var $716388be379d72a2$export$2e2bcd8739ae039 = $716388be379d72a2$var$ToggleButtonGroup;


const $14b4a2aa98aa8378$export$40258cc1d95ff477 = (0, $716388be379d72a2$export$2e2bcd8739ae039);



parcelRequire("h4Bez");

var $705b558413bac00d$exports = {};

!function(e, t) {
    $705b558413bac00d$exports = t((parcelRequire("h4Bez")));
}($705b558413bac00d$exports, (e)=>(()=>{
        var t = {
            9735: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "apathy",
                    author: "jannik siebert (https://github.com/janniks)",
                    base00: "#031A16",
                    base01: "#0B342D",
                    base02: "#184E45",
                    base03: "#2B685E",
                    base04: "#5F9C92",
                    base05: "#81B5AC",
                    base06: "#A7CEC8",
                    base07: "#D2E7E4",
                    base08: "#3E9688",
                    base09: "#3E7996",
                    base0A: "#3E4C96",
                    base0B: "#883E96",
                    base0C: "#963E4C",
                    base0D: "#96883E",
                    base0E: "#4C963E",
                    base0F: "#3E965B"
                }, e.exports = t.default;
            },
            294: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "ashes",
                    author: "jannik siebert (https://github.com/janniks)",
                    base00: "#1C2023",
                    base01: "#393F45",
                    base02: "#565E65",
                    base03: "#747C84",
                    base04: "#ADB3BA",
                    base05: "#C7CCD1",
                    base06: "#DFE2E5",
                    base07: "#F3F4F5",
                    base08: "#C7AE95",
                    base09: "#C7C795",
                    base0A: "#AEC795",
                    base0B: "#95C7AE",
                    base0C: "#95AEC7",
                    base0D: "#AE95C7",
                    base0E: "#C795AE",
                    base0F: "#C79595"
                }, e.exports = t.default;
            },
            1733: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "atelier dune",
                    author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/dune)",
                    base00: "#20201d",
                    base01: "#292824",
                    base02: "#6e6b5e",
                    base03: "#7d7a68",
                    base04: "#999580",
                    base05: "#a6a28c",
                    base06: "#e8e4cf",
                    base07: "#fefbec",
                    base08: "#d73737",
                    base09: "#b65611",
                    base0A: "#cfb017",
                    base0B: "#60ac39",
                    base0C: "#1fad83",
                    base0D: "#6684e1",
                    base0E: "#b854d4",
                    base0F: "#d43552"
                }, e.exports = t.default;
            },
            8974: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "atelier forest",
                    author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/forest)",
                    base00: "#1b1918",
                    base01: "#2c2421",
                    base02: "#68615e",
                    base03: "#766e6b",
                    base04: "#9c9491",
                    base05: "#a8a19f",
                    base06: "#e6e2e0",
                    base07: "#f1efee",
                    base08: "#f22c40",
                    base09: "#df5320",
                    base0A: "#d5911a",
                    base0B: "#5ab738",
                    base0C: "#00ad9c",
                    base0D: "#407ee7",
                    base0E: "#6666ea",
                    base0F: "#c33ff3"
                }, e.exports = t.default;
            },
            6933: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "atelier heath",
                    author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/heath)",
                    base00: "#1b181b",
                    base01: "#292329",
                    base02: "#695d69",
                    base03: "#776977",
                    base04: "#9e8f9e",
                    base05: "#ab9bab",
                    base06: "#d8cad8",
                    base07: "#f7f3f7",
                    base08: "#ca402b",
                    base09: "#a65926",
                    base0A: "#bb8a35",
                    base0B: "#379a37",
                    base0C: "#159393",
                    base0D: "#516aec",
                    base0E: "#7b59c0",
                    base0F: "#cc33cc"
                }, e.exports = t.default;
            },
            523: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "atelier lakeside",
                    author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/lakeside/)",
                    base00: "#161b1d",
                    base01: "#1f292e",
                    base02: "#516d7b",
                    base03: "#5a7b8c",
                    base04: "#7195a8",
                    base05: "#7ea2b4",
                    base06: "#c1e4f6",
                    base07: "#ebf8ff",
                    base08: "#d22d72",
                    base09: "#935c25",
                    base0A: "#8a8a0f",
                    base0B: "#568c3b",
                    base0C: "#2d8f6f",
                    base0D: "#257fad",
                    base0E: "#5d5db1",
                    base0F: "#b72dd2"
                }, e.exports = t.default;
            },
            1223: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "atelier seaside",
                    author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/seaside/)",
                    base00: "#131513",
                    base01: "#242924",
                    base02: "#5e6e5e",
                    base03: "#687d68",
                    base04: "#809980",
                    base05: "#8ca68c",
                    base06: "#cfe8cf",
                    base07: "#f0fff0",
                    base08: "#e6193c",
                    base09: "#87711d",
                    base0A: "#c3c322",
                    base0B: "#29a329",
                    base0C: "#1999b3",
                    base0D: "#3d62f5",
                    base0E: "#ad2bee",
                    base0F: "#e619c3"
                }, e.exports = t.default;
            },
            1233: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "bespin",
                    author: "jan t. sott",
                    base00: "#28211c",
                    base01: "#36312e",
                    base02: "#5e5d5c",
                    base03: "#666666",
                    base04: "#797977",
                    base05: "#8a8986",
                    base06: "#9d9b97",
                    base07: "#baae9e",
                    base08: "#cf6a4c",
                    base09: "#cf7d34",
                    base0A: "#f9ee98",
                    base0B: "#54be0d",
                    base0C: "#afc4db",
                    base0D: "#5ea6ea",
                    base0E: "#9b859d",
                    base0F: "#937121"
                }, e.exports = t.default;
            },
            2847: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "brewer",
                    author: "timoth\xe9e poisot (http://github.com/tpoisot)",
                    base00: "#0c0d0e",
                    base01: "#2e2f30",
                    base02: "#515253",
                    base03: "#737475",
                    base04: "#959697",
                    base05: "#b7b8b9",
                    base06: "#dadbdc",
                    base07: "#fcfdfe",
                    base08: "#e31a1c",
                    base09: "#e6550d",
                    base0A: "#dca060",
                    base0B: "#31a354",
                    base0C: "#80b1d3",
                    base0D: "#3182bd",
                    base0E: "#756bb1",
                    base0F: "#b15928"
                }, e.exports = t.default;
            },
            8120: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "bright",
                    author: "chris kempson (http://chriskempson.com)",
                    base00: "#000000",
                    base01: "#303030",
                    base02: "#505050",
                    base03: "#b0b0b0",
                    base04: "#d0d0d0",
                    base05: "#e0e0e0",
                    base06: "#f5f5f5",
                    base07: "#ffffff",
                    base08: "#fb0120",
                    base09: "#fc6d24",
                    base0A: "#fda331",
                    base0B: "#a1c659",
                    base0C: "#76c7b7",
                    base0D: "#6fb3d2",
                    base0E: "#d381c3",
                    base0F: "#be643c"
                }, e.exports = t.default;
            },
            6305: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "chalk",
                    author: "chris kempson (http://chriskempson.com)",
                    base00: "#151515",
                    base01: "#202020",
                    base02: "#303030",
                    base03: "#505050",
                    base04: "#b0b0b0",
                    base05: "#d0d0d0",
                    base06: "#e0e0e0",
                    base07: "#f5f5f5",
                    base08: "#fb9fb1",
                    base09: "#eda987",
                    base0A: "#ddb26f",
                    base0B: "#acc267",
                    base0C: "#12cfc0",
                    base0D: "#6fc2ef",
                    base0E: "#e1a3ee",
                    base0F: "#deaf8f"
                }, e.exports = t.default;
            },
            525: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "codeschool",
                    author: "brettof86",
                    base00: "#232c31",
                    base01: "#1c3657",
                    base02: "#2a343a",
                    base03: "#3f4944",
                    base04: "#84898c",
                    base05: "#9ea7a6",
                    base06: "#a7cfa3",
                    base07: "#b5d8f6",
                    base08: "#2a5491",
                    base09: "#43820d",
                    base0A: "#a03b1e",
                    base0B: "#237986",
                    base0C: "#b02f30",
                    base0D: "#484d79",
                    base0E: "#c59820",
                    base0F: "#c98344"
                }, e.exports = t.default;
            },
            4124: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "colors",
                    author: "mrmrs (http://clrs.cc)",
                    base00: "#111111",
                    base01: "#333333",
                    base02: "#555555",
                    base03: "#777777",
                    base04: "#999999",
                    base05: "#bbbbbb",
                    base06: "#dddddd",
                    base07: "#ffffff",
                    base08: "#ff4136",
                    base09: "#ff851b",
                    base0A: "#ffdc00",
                    base0B: "#2ecc40",
                    base0C: "#7fdbff",
                    base0D: "#0074d9",
                    base0E: "#b10dc9",
                    base0F: "#85144b"
                }, e.exports = t.default;
            },
            7167: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "default",
                    author: "chris kempson (http://chriskempson.com)",
                    base00: "#181818",
                    base01: "#282828",
                    base02: "#383838",
                    base03: "#585858",
                    base04: "#b8b8b8",
                    base05: "#d8d8d8",
                    base06: "#e8e8e8",
                    base07: "#f8f8f8",
                    base08: "#ab4642",
                    base09: "#dc9656",
                    base0A: "#f7ca88",
                    base0B: "#a1b56c",
                    base0C: "#86c1b9",
                    base0D: "#7cafc2",
                    base0E: "#ba8baf",
                    base0F: "#a16946"
                }, e.exports = t.default;
            },
            4582: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "eighties",
                    author: "chris kempson (http://chriskempson.com)",
                    base00: "#2d2d2d",
                    base01: "#393939",
                    base02: "#515151",
                    base03: "#747369",
                    base04: "#a09f93",
                    base05: "#d3d0c8",
                    base06: "#e8e6df",
                    base07: "#f2f0ec",
                    base08: "#f2777a",
                    base09: "#f99157",
                    base0A: "#ffcc66",
                    base0B: "#99cc99",
                    base0C: "#66cccc",
                    base0D: "#6699cc",
                    base0E: "#cc99cc",
                    base0F: "#d27b53"
                }, e.exports = t.default;
            },
            7096: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "embers",
                    author: "jannik siebert (https://github.com/janniks)",
                    base00: "#16130F",
                    base01: "#2C2620",
                    base02: "#433B32",
                    base03: "#5A5047",
                    base04: "#8A8075",
                    base05: "#A39A90",
                    base06: "#BEB6AE",
                    base07: "#DBD6D1",
                    base08: "#826D57",
                    base09: "#828257",
                    base0A: "#6D8257",
                    base0B: "#57826D",
                    base0C: "#576D82",
                    base0D: "#6D5782",
                    base0E: "#82576D",
                    base0F: "#825757"
                }, e.exports = t.default;
            },
            9887: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "flat",
                    author: "chris kempson (http://chriskempson.com)",
                    base00: "#2C3E50",
                    base01: "#34495E",
                    base02: "#7F8C8D",
                    base03: "#95A5A6",
                    base04: "#BDC3C7",
                    base05: "#e0e0e0",
                    base06: "#f5f5f5",
                    base07: "#ECF0F1",
                    base08: "#E74C3C",
                    base09: "#E67E22",
                    base0A: "#F1C40F",
                    base0B: "#2ECC71",
                    base0C: "#1ABC9C",
                    base0D: "#3498DB",
                    base0E: "#9B59B6",
                    base0F: "#be643c"
                }, e.exports = t.default;
            },
            7199: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "google",
                    author: "seth wright (http://sethawright.com)",
                    base00: "#1d1f21",
                    base01: "#282a2e",
                    base02: "#373b41",
                    base03: "#969896",
                    base04: "#b4b7b4",
                    base05: "#c5c8c6",
                    base06: "#e0e0e0",
                    base07: "#ffffff",
                    base08: "#CC342B",
                    base09: "#F96A38",
                    base0A: "#FBA922",
                    base0B: "#198844",
                    base0C: "#3971ED",
                    base0D: "#3971ED",
                    base0E: "#A36AC7",
                    base0F: "#3971ED"
                }, e.exports = t.default;
            },
            1985: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "grayscale",
                    author: "alexandre gavioli (https://github.com/alexx2/)",
                    base00: "#101010",
                    base01: "#252525",
                    base02: "#464646",
                    base03: "#525252",
                    base04: "#ababab",
                    base05: "#b9b9b9",
                    base06: "#e3e3e3",
                    base07: "#f7f7f7",
                    base08: "#7c7c7c",
                    base09: "#999999",
                    base0A: "#a0a0a0",
                    base0B: "#8e8e8e",
                    base0C: "#868686",
                    base0D: "#686868",
                    base0E: "#747474",
                    base0F: "#5e5e5e"
                }, e.exports = t.default;
            },
            8093: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "green screen",
                    author: "chris kempson (http://chriskempson.com)",
                    base00: "#001100",
                    base01: "#003300",
                    base02: "#005500",
                    base03: "#007700",
                    base04: "#009900",
                    base05: "#00bb00",
                    base06: "#00dd00",
                    base07: "#00ff00",
                    base08: "#007700",
                    base09: "#009900",
                    base0A: "#007700",
                    base0B: "#00bb00",
                    base0C: "#005500",
                    base0D: "#009900",
                    base0E: "#00bb00",
                    base0F: "#005500"
                }, e.exports = t.default;
            },
            1615: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "harmonic16",
                    author: "jannik siebert (https://github.com/janniks)",
                    base00: "#0b1c2c",
                    base01: "#223b54",
                    base02: "#405c79",
                    base03: "#627e99",
                    base04: "#aabcce",
                    base05: "#cbd6e2",
                    base06: "#e5ebf1",
                    base07: "#f7f9fb",
                    base08: "#bf8b56",
                    base09: "#bfbf56",
                    base0A: "#8bbf56",
                    base0B: "#56bf8b",
                    base0C: "#568bbf",
                    base0D: "#8b56bf",
                    base0E: "#bf568b",
                    base0F: "#bf5656"
                }, e.exports = t.default;
            },
            9063: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "hopscotch",
                    author: "jan t. sott",
                    base00: "#322931",
                    base01: "#433b42",
                    base02: "#5c545b",
                    base03: "#797379",
                    base04: "#989498",
                    base05: "#b9b5b8",
                    base06: "#d5d3d5",
                    base07: "#ffffff",
                    base08: "#dd464c",
                    base09: "#fd8b19",
                    base0A: "#fdcc59",
                    base0B: "#8fc13e",
                    base0C: "#149b93",
                    base0D: "#1290bf",
                    base0E: "#c85e7c",
                    base0F: "#b33508"
                }, e.exports = t.default;
            },
            9446: (e, t, a)=>{
                "use strict";
                function r(e) {
                    return e && e.__esModule ? e.default : e;
                }
                t.__esModule = !0;
                var n = a(1308);
                t.threezerotwofour = r(n);
                var o = a(9735);
                t.apathy = r(o);
                var s = a(294);
                t.ashes = r(s);
                var i = a(1733);
                t.atelierDune = r(i);
                var l = a(8974);
                t.atelierForest = r(l);
                var c = a(6933);
                t.atelierHeath = r(c);
                var u = a(523);
                t.atelierLakeside = r(u);
                var d = a(1223);
                t.atelierSeaside = r(d);
                var b = a(1233);
                t.bespin = r(b);
                var p = a(2847);
                t.brewer = r(p);
                var f = a(8120);
                t.bright = r(f);
                var h = a(6305);
                t.chalk = r(h);
                var m = a(525);
                t.codeschool = r(m);
                var v = a(4124);
                t.colors = r(v);
                var g = a(7167);
                t.default = r(g);
                var y = a(4582);
                t.eighties = r(y);
                var k = a(7096);
                t.embers = r(k);
                var E = a(9887);
                t.flat = r(E);
                var w = a(7199);
                t.google = r(w);
                var j = a(1985);
                t.grayscale = r(j);
                var x = a(8093);
                t.greenscreen = r(x);
                var C = a(1615);
                t.harmonic = r(C);
                var O = a(9063);
                t.hopscotch = r(O);
                var M = a(9033);
                t.isotope = r(M);
                var S = a(4112);
                t.marrakesh = r(S);
                var _ = a(9600);
                t.mocha = r(_);
                var A = a(1240);
                t.monokai = r(A);
                var F = a(9768);
                t.ocean = r(F);
                var P = a(8293);
                t.paraiso = r(P);
                var R = a(3093);
                t.pop = r(R);
                var D = a(1951);
                t.railscasts = r(D);
                var I = a(6368);
                t.shapeshifter = r(I);
                var z = a(2317);
                t.solarized = r(z);
                var B = a(1091);
                t.summerfruit = r(B);
                var N = a(6943);
                t.tomorrow = r(N);
                var L = a(5670);
                t.tube = r(L);
                var q = a(2536);
                t.twilight = r(q);
            },
            9033: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "isotope",
                    author: "jan t. sott",
                    base00: "#000000",
                    base01: "#404040",
                    base02: "#606060",
                    base03: "#808080",
                    base04: "#c0c0c0",
                    base05: "#d0d0d0",
                    base06: "#e0e0e0",
                    base07: "#ffffff",
                    base08: "#ff0000",
                    base09: "#ff9900",
                    base0A: "#ff0099",
                    base0B: "#33ff00",
                    base0C: "#00ffff",
                    base0D: "#0066ff",
                    base0E: "#cc00ff",
                    base0F: "#3300ff"
                }, e.exports = t.default;
            },
            4112: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "marrakesh",
                    author: "alexandre gavioli (http://github.com/alexx2/)",
                    base00: "#201602",
                    base01: "#302e00",
                    base02: "#5f5b17",
                    base03: "#6c6823",
                    base04: "#86813b",
                    base05: "#948e48",
                    base06: "#ccc37a",
                    base07: "#faf0a5",
                    base08: "#c35359",
                    base09: "#b36144",
                    base0A: "#a88339",
                    base0B: "#18974e",
                    base0C: "#75a738",
                    base0D: "#477ca1",
                    base0E: "#8868b3",
                    base0F: "#b3588e"
                }, e.exports = t.default;
            },
            9600: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "mocha",
                    author: "chris kempson (http://chriskempson.com)",
                    base00: "#3B3228",
                    base01: "#534636",
                    base02: "#645240",
                    base03: "#7e705a",
                    base04: "#b8afad",
                    base05: "#d0c8c6",
                    base06: "#e9e1dd",
                    base07: "#f5eeeb",
                    base08: "#cb6077",
                    base09: "#d28b71",
                    base0A: "#f4bc87",
                    base0B: "#beb55b",
                    base0C: "#7bbda4",
                    base0D: "#8ab3b5",
                    base0E: "#a89bb9",
                    base0F: "#bb9584"
                }, e.exports = t.default;
            },
            1240: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "monokai",
                    author: "wimer hazenberg (http://www.monokai.nl)",
                    base00: "#272822",
                    base01: "#383830",
                    base02: "#49483e",
                    base03: "#75715e",
                    base04: "#a59f85",
                    base05: "#f8f8f2",
                    base06: "#f5f4f1",
                    base07: "#f9f8f5",
                    base08: "#f92672",
                    base09: "#fd971f",
                    base0A: "#f4bf75",
                    base0B: "#a6e22e",
                    base0C: "#a1efe4",
                    base0D: "#66d9ef",
                    base0E: "#ae81ff",
                    base0F: "#cc6633"
                }, e.exports = t.default;
            },
            9768: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "ocean",
                    author: "chris kempson (http://chriskempson.com)",
                    base00: "#2b303b",
                    base01: "#343d46",
                    base02: "#4f5b66",
                    base03: "#65737e",
                    base04: "#a7adba",
                    base05: "#c0c5ce",
                    base06: "#dfe1e8",
                    base07: "#eff1f5",
                    base08: "#bf616a",
                    base09: "#d08770",
                    base0A: "#ebcb8b",
                    base0B: "#a3be8c",
                    base0C: "#96b5b4",
                    base0D: "#8fa1b3",
                    base0E: "#b48ead",
                    base0F: "#ab7967"
                }, e.exports = t.default;
            },
            8293: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "paraiso",
                    author: "jan t. sott",
                    base00: "#2f1e2e",
                    base01: "#41323f",
                    base02: "#4f424c",
                    base03: "#776e71",
                    base04: "#8d8687",
                    base05: "#a39e9b",
                    base06: "#b9b6b0",
                    base07: "#e7e9db",
                    base08: "#ef6155",
                    base09: "#f99b15",
                    base0A: "#fec418",
                    base0B: "#48b685",
                    base0C: "#5bc4bf",
                    base0D: "#06b6ef",
                    base0E: "#815ba4",
                    base0F: "#e96ba8"
                }, e.exports = t.default;
            },
            3093: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "pop",
                    author: "chris kempson (http://chriskempson.com)",
                    base00: "#000000",
                    base01: "#202020",
                    base02: "#303030",
                    base03: "#505050",
                    base04: "#b0b0b0",
                    base05: "#d0d0d0",
                    base06: "#e0e0e0",
                    base07: "#ffffff",
                    base08: "#eb008a",
                    base09: "#f29333",
                    base0A: "#f8ca12",
                    base0B: "#37b349",
                    base0C: "#00aabb",
                    base0D: "#0e5a94",
                    base0E: "#b31e8d",
                    base0F: "#7a2d00"
                }, e.exports = t.default;
            },
            1951: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "railscasts",
                    author: "ryan bates (http://railscasts.com)",
                    base00: "#2b2b2b",
                    base01: "#272935",
                    base02: "#3a4055",
                    base03: "#5a647e",
                    base04: "#d4cfc9",
                    base05: "#e6e1dc",
                    base06: "#f4f1ed",
                    base07: "#f9f7f3",
                    base08: "#da4939",
                    base09: "#cc7833",
                    base0A: "#ffc66d",
                    base0B: "#a5c261",
                    base0C: "#519f50",
                    base0D: "#6d9cbe",
                    base0E: "#b6b3eb",
                    base0F: "#bc9458"
                }, e.exports = t.default;
            },
            6368: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "shapeshifter",
                    author: "tyler benziger (http://tybenz.com)",
                    base00: "#000000",
                    base01: "#040404",
                    base02: "#102015",
                    base03: "#343434",
                    base04: "#555555",
                    base05: "#ababab",
                    base06: "#e0e0e0",
                    base07: "#f9f9f9",
                    base08: "#e92f2f",
                    base09: "#e09448",
                    base0A: "#dddd13",
                    base0B: "#0ed839",
                    base0C: "#23edda",
                    base0D: "#3b48e3",
                    base0E: "#f996e2",
                    base0F: "#69542d"
                }, e.exports = t.default;
            },
            2317: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "solarized",
                    author: "ethan schoonover (http://ethanschoonover.com/solarized)",
                    base00: "#002b36",
                    base01: "#073642",
                    base02: "#586e75",
                    base03: "#657b83",
                    base04: "#839496",
                    base05: "#93a1a1",
                    base06: "#eee8d5",
                    base07: "#fdf6e3",
                    base08: "#dc322f",
                    base09: "#cb4b16",
                    base0A: "#b58900",
                    base0B: "#859900",
                    base0C: "#2aa198",
                    base0D: "#268bd2",
                    base0E: "#6c71c4",
                    base0F: "#d33682"
                }, e.exports = t.default;
            },
            1091: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "summerfruit",
                    author: "christopher corley (http://cscorley.github.io/)",
                    base00: "#151515",
                    base01: "#202020",
                    base02: "#303030",
                    base03: "#505050",
                    base04: "#B0B0B0",
                    base05: "#D0D0D0",
                    base06: "#E0E0E0",
                    base07: "#FFFFFF",
                    base08: "#FF0086",
                    base09: "#FD8900",
                    base0A: "#ABA800",
                    base0B: "#00C918",
                    base0C: "#1faaaa",
                    base0D: "#3777E6",
                    base0E: "#AD00A1",
                    base0F: "#cc6633"
                }, e.exports = t.default;
            },
            1308: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "threezerotwofour",
                    author: "jan t. sott (http://github.com/idleberg)",
                    base00: "#090300",
                    base01: "#3a3432",
                    base02: "#4a4543",
                    base03: "#5c5855",
                    base04: "#807d7c",
                    base05: "#a5a2a2",
                    base06: "#d6d5d4",
                    base07: "#f7f7f7",
                    base08: "#db2d20",
                    base09: "#e8bbd0",
                    base0A: "#fded02",
                    base0B: "#01a252",
                    base0C: "#b5e4f4",
                    base0D: "#01a0e4",
                    base0E: "#a16a94",
                    base0F: "#cdab53"
                }, e.exports = t.default;
            },
            6943: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "tomorrow",
                    author: "chris kempson (http://chriskempson.com)",
                    base00: "#1d1f21",
                    base01: "#282a2e",
                    base02: "#373b41",
                    base03: "#969896",
                    base04: "#b4b7b4",
                    base05: "#c5c8c6",
                    base06: "#e0e0e0",
                    base07: "#ffffff",
                    base08: "#cc6666",
                    base09: "#de935f",
                    base0A: "#f0c674",
                    base0B: "#b5bd68",
                    base0C: "#8abeb7",
                    base0D: "#81a2be",
                    base0E: "#b294bb",
                    base0F: "#a3685a"
                }, e.exports = t.default;
            },
            5670: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "london tube",
                    author: "jan t. sott",
                    base00: "#231f20",
                    base01: "#1c3f95",
                    base02: "#5a5758",
                    base03: "#737171",
                    base04: "#959ca1",
                    base05: "#d9d8d8",
                    base06: "#e7e7e8",
                    base07: "#ffffff",
                    base08: "#ee2e24",
                    base09: "#f386a1",
                    base0A: "#ffd204",
                    base0B: "#00853e",
                    base0C: "#85cebc",
                    base0D: "#009ddc",
                    base0E: "#98005d",
                    base0F: "#b06110"
                }, e.exports = t.default;
            },
            2536: (e, t)=>{
                "use strict";
                t.__esModule = !0, t.default = {
                    scheme: "twilight",
                    author: "david hart (http://hart-dev.com)",
                    base00: "#1e1e1e",
                    base01: "#323537",
                    base02: "#464b50",
                    base03: "#5f5a60",
                    base04: "#838184",
                    base05: "#a7a7a7",
                    base06: "#c3c3c3",
                    base07: "#ffffff",
                    base08: "#cf6a4c",
                    base09: "#cda869",
                    base0A: "#f9ee98",
                    base0B: "#8f9d6a",
                    base0C: "#afc4db",
                    base0D: "#7587a6",
                    base0E: "#9b859d",
                    base0F: "#9b703f"
                }, e.exports = t.default;
            },
            6481: (e, t, a)=>{
                var r = a(4176), n = {};
                for(var o in r)r.hasOwnProperty(o) && (n[r[o]] = o);
                var s = e.exports = {
                    rgb: {
                        channels: 3,
                        labels: "rgb"
                    },
                    hsl: {
                        channels: 3,
                        labels: "hsl"
                    },
                    hsv: {
                        channels: 3,
                        labels: "hsv"
                    },
                    hwb: {
                        channels: 3,
                        labels: "hwb"
                    },
                    cmyk: {
                        channels: 4,
                        labels: "cmyk"
                    },
                    xyz: {
                        channels: 3,
                        labels: "xyz"
                    },
                    lab: {
                        channels: 3,
                        labels: "lab"
                    },
                    lch: {
                        channels: 3,
                        labels: "lch"
                    },
                    hex: {
                        channels: 1,
                        labels: [
                            "hex"
                        ]
                    },
                    keyword: {
                        channels: 1,
                        labels: [
                            "keyword"
                        ]
                    },
                    ansi16: {
                        channels: 1,
                        labels: [
                            "ansi16"
                        ]
                    },
                    ansi256: {
                        channels: 1,
                        labels: [
                            "ansi256"
                        ]
                    },
                    hcg: {
                        channels: 3,
                        labels: [
                            "h",
                            "c",
                            "g"
                        ]
                    },
                    apple: {
                        channels: 3,
                        labels: [
                            "r16",
                            "g16",
                            "b16"
                        ]
                    },
                    gray: {
                        channels: 1,
                        labels: [
                            "gray"
                        ]
                    }
                };
                for(var i in s)if (s.hasOwnProperty(i)) {
                    if (!("channels" in s[i])) throw new Error("missing channels property: " + i);
                    if (!("labels" in s[i])) throw new Error("missing channel labels property: " + i);
                    if (s[i].labels.length !== s[i].channels) throw new Error("channel and label counts mismatch: " + i);
                    var l = s[i].channels, c = s[i].labels;
                    delete s[i].channels, delete s[i].labels, Object.defineProperty(s[i], "channels", {
                        value: l
                    }), Object.defineProperty(s[i], "labels", {
                        value: c
                    });
                }
                s.rgb.hsl = function(e) {
                    var t, a, r = e[0] / 255, n = e[1] / 255, o = e[2] / 255, s = Math.min(r, n, o), i = Math.max(r, n, o), l = i - s;
                    return i === s ? t = 0 : r === i ? t = (n - o) / l : n === i ? t = 2 + (o - r) / l : o === i && (t = 4 + (r - n) / l), (t = Math.min(60 * t, 360)) < 0 && (t += 360), a = (s + i) / 2, [
                        t,
                        100 * (i === s ? 0 : a <= .5 ? l / (i + s) : l / (2 - i - s)),
                        100 * a
                    ];
                }, s.rgb.hsv = function(e) {
                    var t, a, r, n, o, s = e[0] / 255, i = e[1] / 255, l = e[2] / 255, c = Math.max(s, i, l), u = c - Math.min(s, i, l), d = function(e) {
                        return (c - e) / 6 / u + .5;
                    };
                    return 0 === u ? n = o = 0 : (o = u / c, t = d(s), a = d(i), r = d(l), s === c ? n = r - a : i === c ? n = 1 / 3 + t - r : l === c && (n = 2 / 3 + a - t), n < 0 ? n += 1 : n > 1 && (n -= 1)), [
                        360 * n,
                        100 * o,
                        100 * c
                    ];
                }, s.rgb.hwb = function(e) {
                    var t = e[0], a = e[1], r = e[2];
                    return [
                        s.rgb.hsl(e)[0],
                        100 * (1 / 255 * Math.min(t, Math.min(a, r))),
                        100 * (r = 1 - 1 / 255 * Math.max(t, Math.max(a, r)))
                    ];
                }, s.rgb.cmyk = function(e) {
                    var t, a = e[0] / 255, r = e[1] / 255, n = e[2] / 255;
                    return [
                        100 * ((1 - a - (t = Math.min(1 - a, 1 - r, 1 - n))) / (1 - t) || 0),
                        100 * ((1 - r - t) / (1 - t) || 0),
                        100 * ((1 - n - t) / (1 - t) || 0),
                        100 * t
                    ];
                }, s.rgb.keyword = function(e) {
                    var t = n[e];
                    if (t) return t;
                    var a, o, s, i = 1 / 0;
                    for(var l in r)if (r.hasOwnProperty(l)) {
                        var c = r[l], u = (o = e, s = c, Math.pow(o[0] - s[0], 2) + Math.pow(o[1] - s[1], 2) + Math.pow(o[2] - s[2], 2));
                        u < i && (i = u, a = l);
                    }
                    return a;
                }, s.keyword.rgb = function(e) {
                    return r[e];
                }, s.rgb.xyz = function(e) {
                    var t = e[0] / 255, a = e[1] / 255, r = e[2] / 255;
                    return [
                        100 * (.4124 * (t = t > .04045 ? Math.pow((t + .055) / 1.055, 2.4) : t / 12.92) + .3576 * (a = a > .04045 ? Math.pow((a + .055) / 1.055, 2.4) : a / 12.92) + .1805 * (r = r > .04045 ? Math.pow((r + .055) / 1.055, 2.4) : r / 12.92)),
                        100 * (.2126 * t + .7152 * a + .0722 * r),
                        100 * (.0193 * t + .1192 * a + .9505 * r)
                    ];
                }, s.rgb.lab = function(e) {
                    var t = s.rgb.xyz(e), a = t[0], r = t[1], n = t[2];
                    return r /= 100, n /= 108.883, a = (a /= 95.047) > .008856 ? Math.pow(a, 1 / 3) : 7.787 * a + 16 / 116, [
                        116 * (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116) - 16,
                        500 * (a - r),
                        200 * (r - (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116))
                    ];
                }, s.hsl.rgb = function(e) {
                    var t, a, r, n, o, s = e[0] / 360, i = e[1] / 100, l = e[2] / 100;
                    if (0 === i) return [
                        o = 255 * l,
                        o,
                        o
                    ];
                    t = 2 * l - (a = l < .5 ? l * (1 + i) : l + i - l * i), n = [
                        0,
                        0,
                        0
                    ];
                    for(var c = 0; c < 3; c++)(r = s + 1 / 3 * -(c - 1)) < 0 && r++, r > 1 && r--, o = 6 * r < 1 ? t + 6 * (a - t) * r : 2 * r < 1 ? a : 3 * r < 2 ? t + (a - t) * (2 / 3 - r) * 6 : t, n[c] = 255 * o;
                    return n;
                }, s.hsl.hsv = function(e) {
                    var t = e[0], a = e[1] / 100, r = e[2] / 100, n = a, o = Math.max(r, .01);
                    return a *= (r *= 2) <= 1 ? r : 2 - r, n *= o <= 1 ? o : 2 - o, [
                        t,
                        100 * (0 === r ? 2 * n / (o + n) : 2 * a / (r + a)),
                        100 * ((r + a) / 2)
                    ];
                }, s.hsv.rgb = function(e) {
                    var t = e[0] / 60, a = e[1] / 100, r = e[2] / 100, n = Math.floor(t) % 6, o = t - Math.floor(t), s = 255 * r * (1 - a), i = 255 * r * (1 - a * o), l = 255 * r * (1 - a * (1 - o));
                    switch(r *= 255, n){
                        case 0:
                            return [
                                r,
                                l,
                                s
                            ];
                        case 1:
                            return [
                                i,
                                r,
                                s
                            ];
                        case 2:
                            return [
                                s,
                                r,
                                l
                            ];
                        case 3:
                            return [
                                s,
                                i,
                                r
                            ];
                        case 4:
                            return [
                                l,
                                s,
                                r
                            ];
                        case 5:
                            return [
                                r,
                                s,
                                i
                            ];
                    }
                }, s.hsv.hsl = function(e) {
                    var t, a, r, n = e[0], o = e[1] / 100, s = e[2] / 100, i = Math.max(s, .01);
                    return r = (2 - o) * s, a = o * i, [
                        n,
                        100 * (a = (a /= (t = (2 - o) * i) <= 1 ? t : 2 - t) || 0),
                        100 * (r /= 2)
                    ];
                }, s.hwb.rgb = function(e) {
                    var t, a, r, n, o, s, i, l = e[0] / 360, c = e[1] / 100, u = e[2] / 100, d = c + u;
                    switch(d > 1 && (c /= d, u /= d), r = 6 * l - (t = Math.floor(6 * l)), 1 & t && (r = 1 - r), n = c + r * ((a = 1 - u) - c), t){
                        default:
                        case 6:
                        case 0:
                            o = a, s = n, i = c;
                            break;
                        case 1:
                            o = n, s = a, i = c;
                            break;
                        case 2:
                            o = c, s = a, i = n;
                            break;
                        case 3:
                            o = c, s = n, i = a;
                            break;
                        case 4:
                            o = n, s = c, i = a;
                            break;
                        case 5:
                            o = a, s = c, i = n;
                    }
                    return [
                        255 * o,
                        255 * s,
                        255 * i
                    ];
                }, s.cmyk.rgb = function(e) {
                    var t = e[0] / 100, a = e[1] / 100, r = e[2] / 100, n = e[3] / 100;
                    return [
                        255 * (1 - Math.min(1, t * (1 - n) + n)),
                        255 * (1 - Math.min(1, a * (1 - n) + n)),
                        255 * (1 - Math.min(1, r * (1 - n) + n))
                    ];
                }, s.xyz.rgb = function(e) {
                    var t, a, r, n = e[0] / 100, o = e[1] / 100, s = e[2] / 100;
                    return a = -0.9689 * n + 1.8758 * o + .0415 * s, r = .0557 * n + -0.204 * o + 1.057 * s, t = (t = 3.2406 * n + -1.5372 * o + -0.4986 * s) > .0031308 ? 1.055 * Math.pow(t, 1 / 2.4) - .055 : 12.92 * t, a = a > .0031308 ? 1.055 * Math.pow(a, 1 / 2.4) - .055 : 12.92 * a, r = r > .0031308 ? 1.055 * Math.pow(r, 1 / 2.4) - .055 : 12.92 * r, [
                        255 * (t = Math.min(Math.max(0, t), 1)),
                        255 * (a = Math.min(Math.max(0, a), 1)),
                        255 * (r = Math.min(Math.max(0, r), 1))
                    ];
                }, s.xyz.lab = function(e) {
                    var t = e[0], a = e[1], r = e[2];
                    return a /= 100, r /= 108.883, t = (t /= 95.047) > .008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116, [
                        116 * (a = a > .008856 ? Math.pow(a, 1 / 3) : 7.787 * a + 16 / 116) - 16,
                        500 * (t - a),
                        200 * (a - (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116))
                    ];
                }, s.lab.xyz = function(e) {
                    var t, a, r, n = e[0];
                    t = e[1] / 500 + (a = (n + 16) / 116), r = a - e[2] / 200;
                    var o = Math.pow(a, 3), s = Math.pow(t, 3), i = Math.pow(r, 3);
                    return a = o > .008856 ? o : (a - 16 / 116) / 7.787, t = s > .008856 ? s : (t - 16 / 116) / 7.787, r = i > .008856 ? i : (r - 16 / 116) / 7.787, [
                        t *= 95.047,
                        a *= 100,
                        r *= 108.883
                    ];
                }, s.lab.lch = function(e) {
                    var t, a = e[0], r = e[1], n = e[2];
                    return (t = 360 * Math.atan2(n, r) / 2 / Math.PI) < 0 && (t += 360), [
                        a,
                        Math.sqrt(r * r + n * n),
                        t
                    ];
                }, s.lch.lab = function(e) {
                    var t, a = e[0], r = e[1];
                    return t = e[2] / 360 * 2 * Math.PI, [
                        a,
                        r * Math.cos(t),
                        r * Math.sin(t)
                    ];
                }, s.rgb.ansi16 = function(e) {
                    var t = e[0], a = e[1], r = e[2], n = 1 in arguments ? arguments[1] : s.rgb.hsv(e)[2];
                    if (0 === (n = Math.round(n / 50))) return 30;
                    var o = 30 + (Math.round(r / 255) << 2 | Math.round(a / 255) << 1 | Math.round(t / 255));
                    return 2 === n && (o += 60), o;
                }, s.hsv.ansi16 = function(e) {
                    return s.rgb.ansi16(s.hsv.rgb(e), e[2]);
                }, s.rgb.ansi256 = function(e) {
                    var t = e[0], a = e[1], r = e[2];
                    return t === a && a === r ? t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(a / 255 * 5) + Math.round(r / 255 * 5);
                }, s.ansi16.rgb = function(e) {
                    var t = e % 10;
                    if (0 === t || 7 === t) return e > 50 && (t += 3.5), [
                        t = t / 10.5 * 255,
                        t,
                        t
                    ];
                    var a = .5 * (1 + ~~(e > 50));
                    return [
                        (1 & t) * a * 255,
                        (t >> 1 & 1) * a * 255,
                        (t >> 2 & 1) * a * 255
                    ];
                }, s.ansi256.rgb = function(e) {
                    if (e >= 232) {
                        var t = 10 * (e - 232) + 8;
                        return [
                            t,
                            t,
                            t
                        ];
                    }
                    var a;
                    return e -= 16, [
                        Math.floor(e / 36) / 5 * 255,
                        Math.floor((a = e % 36) / 6) / 5 * 255,
                        a % 6 / 5 * 255
                    ];
                }, s.rgb.hex = function(e) {
                    var t = (((255 & Math.round(e[0])) << 16) + ((255 & Math.round(e[1])) << 8) + (255 & Math.round(e[2]))).toString(16).toUpperCase();
                    return "000000".substring(t.length) + t;
                }, s.hex.rgb = function(e) {
                    var t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
                    if (!t) return [
                        0,
                        0,
                        0
                    ];
                    var a = t[0];
                    3 === t[0].length && (a = a.split("").map(function(e) {
                        return e + e;
                    }).join(""));
                    var r = parseInt(a, 16);
                    return [
                        r >> 16 & 255,
                        r >> 8 & 255,
                        255 & r
                    ];
                }, s.rgb.hcg = function(e) {
                    var t, a = e[0] / 255, r = e[1] / 255, n = e[2] / 255, o = Math.max(Math.max(a, r), n), s = Math.min(Math.min(a, r), n), i = o - s;
                    return t = i <= 0 ? 0 : o === a ? (r - n) / i % 6 : o === r ? 2 + (n - a) / i : 4 + (a - r) / i + 4, t /= 6, [
                        360 * (t %= 1),
                        100 * i,
                        100 * (i < 1 ? s / (1 - i) : 0)
                    ];
                }, s.hsl.hcg = function(e) {
                    var t = e[1] / 100, a = e[2] / 100, r = 1, n = 0;
                    return (r = a < .5 ? 2 * t * a : 2 * t * (1 - a)) < 1 && (n = (a - .5 * r) / (1 - r)), [
                        e[0],
                        100 * r,
                        100 * n
                    ];
                }, s.hsv.hcg = function(e) {
                    var t = e[1] / 100, a = e[2] / 100, r = t * a, n = 0;
                    return r < 1 && (n = (a - r) / (1 - r)), [
                        e[0],
                        100 * r,
                        100 * n
                    ];
                }, s.hcg.rgb = function(e) {
                    var t = e[0] / 360, a = e[1] / 100, r = e[2] / 100;
                    if (0 === a) return [
                        255 * r,
                        255 * r,
                        255 * r
                    ];
                    var n, o = [
                        0,
                        0,
                        0
                    ], s = t % 1 * 6, i = s % 1, l = 1 - i;
                    switch(Math.floor(s)){
                        case 0:
                            o[0] = 1, o[1] = i, o[2] = 0;
                            break;
                        case 1:
                            o[0] = l, o[1] = 1, o[2] = 0;
                            break;
                        case 2:
                            o[0] = 0, o[1] = 1, o[2] = i;
                            break;
                        case 3:
                            o[0] = 0, o[1] = l, o[2] = 1;
                            break;
                        case 4:
                            o[0] = i, o[1] = 0, o[2] = 1;
                            break;
                        default:
                            o[0] = 1, o[1] = 0, o[2] = l;
                    }
                    return n = (1 - a) * r, [
                        255 * (a * o[0] + n),
                        255 * (a * o[1] + n),
                        255 * (a * o[2] + n)
                    ];
                }, s.hcg.hsv = function(e) {
                    var t = e[1] / 100, a = t + e[2] / 100 * (1 - t), r = 0;
                    return a > 0 && (r = t / a), [
                        e[0],
                        100 * r,
                        100 * a
                    ];
                }, s.hcg.hsl = function(e) {
                    var t = e[1] / 100, a = e[2] / 100 * (1 - t) + .5 * t, r = 0;
                    return a > 0 && a < .5 ? r = t / (2 * a) : a >= .5 && a < 1 && (r = t / (2 * (1 - a))), [
                        e[0],
                        100 * r,
                        100 * a
                    ];
                }, s.hcg.hwb = function(e) {
                    var t = e[1] / 100, a = t + e[2] / 100 * (1 - t);
                    return [
                        e[0],
                        100 * (a - t),
                        100 * (1 - a)
                    ];
                }, s.hwb.hcg = function(e) {
                    var t = e[1] / 100, a = 1 - e[2] / 100, r = a - t, n = 0;
                    return r < 1 && (n = (a - r) / (1 - r)), [
                        e[0],
                        100 * r,
                        100 * n
                    ];
                }, s.apple.rgb = function(e) {
                    return [
                        e[0] / 65535 * 255,
                        e[1] / 65535 * 255,
                        e[2] / 65535 * 255
                    ];
                }, s.rgb.apple = function(e) {
                    return [
                        e[0] / 255 * 65535,
                        e[1] / 255 * 65535,
                        e[2] / 255 * 65535
                    ];
                }, s.gray.rgb = function(e) {
                    return [
                        e[0] / 100 * 255,
                        e[0] / 100 * 255,
                        e[0] / 100 * 255
                    ];
                }, s.gray.hsl = s.gray.hsv = function(e) {
                    return [
                        0,
                        0,
                        e[0]
                    ];
                }, s.gray.hwb = function(e) {
                    return [
                        0,
                        100,
                        e[0]
                    ];
                }, s.gray.cmyk = function(e) {
                    return [
                        0,
                        0,
                        0,
                        e[0]
                    ];
                }, s.gray.lab = function(e) {
                    return [
                        e[0],
                        0,
                        0
                    ];
                }, s.gray.hex = function(e) {
                    var t = 255 & Math.round(e[0] / 100 * 255), a = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
                    return "000000".substring(a.length) + a;
                }, s.rgb.gray = function(e) {
                    return [
                        (e[0] + e[1] + e[2]) / 3 / 255 * 100
                    ];
                };
            },
            4732: (e, t, a)=>{
                var r = a(6481), n = a(1157), o = {};
                Object.keys(r).forEach(function(e) {
                    o[e] = {}, Object.defineProperty(o[e], "channels", {
                        value: r[e].channels
                    }), Object.defineProperty(o[e], "labels", {
                        value: r[e].labels
                    });
                    var t = n(e);
                    Object.keys(t).forEach(function(a) {
                        var r = t[a];
                        o[e][a] = function(e) {
                            var t = function(t) {
                                if (null == t) return t;
                                arguments.length > 1 && (t = Array.prototype.slice.call(arguments));
                                var a = e(t);
                                if ("object" == typeof a) for(var r = a.length, n = 0; n < r; n++)a[n] = Math.round(a[n]);
                                return a;
                            };
                            return "conversion" in e && (t.conversion = e.conversion), t;
                        }(r), o[e][a].raw = function(e) {
                            var t = function(t) {
                                return null == t ? t : (arguments.length > 1 && (t = Array.prototype.slice.call(arguments)), e(t));
                            };
                            return "conversion" in e && (t.conversion = e.conversion), t;
                        }(r);
                    });
                }), e.exports = o;
            },
            1157: (e, t, a)=>{
                var r = a(6481);
                function n(e) {
                    var t = function() {
                        for(var e = {}, t = Object.keys(r), a = t.length, n = 0; n < a; n++)e[t[n]] = {
                            distance: -1,
                            parent: null
                        };
                        return e;
                    }(), a = [
                        e
                    ];
                    for(t[e].distance = 0; a.length;)for(var n = a.pop(), o = Object.keys(r[n]), s = o.length, i = 0; i < s; i++){
                        var l = o[i], c = t[l];
                        -1 === c.distance && (c.distance = t[n].distance + 1, c.parent = n, a.unshift(l));
                    }
                    return t;
                }
                function o(e, t) {
                    return function(a) {
                        return t(e(a));
                    };
                }
                function s(e, t) {
                    for(var a = [
                        t[e].parent,
                        e
                    ], n = r[t[e].parent][e], s = t[e].parent; t[s].parent;)a.unshift(t[s].parent), n = o(r[t[s].parent][s], n), s = t[s].parent;
                    return n.conversion = a, n;
                }
                e.exports = function(e) {
                    for(var t = n(e), a = {}, r = Object.keys(t), o = r.length, i = 0; i < o; i++){
                        var l = r[i];
                        null !== t[l].parent && (a[l] = s(l, t));
                    }
                    return a;
                };
            },
            4176: (e)=>{
                "use strict";
                e.exports = {
                    aliceblue: [
                        240,
                        248,
                        255
                    ],
                    antiquewhite: [
                        250,
                        235,
                        215
                    ],
                    aqua: [
                        0,
                        255,
                        255
                    ],
                    aquamarine: [
                        127,
                        255,
                        212
                    ],
                    azure: [
                        240,
                        255,
                        255
                    ],
                    beige: [
                        245,
                        245,
                        220
                    ],
                    bisque: [
                        255,
                        228,
                        196
                    ],
                    black: [
                        0,
                        0,
                        0
                    ],
                    blanchedalmond: [
                        255,
                        235,
                        205
                    ],
                    blue: [
                        0,
                        0,
                        255
                    ],
                    blueviolet: [
                        138,
                        43,
                        226
                    ],
                    brown: [
                        165,
                        42,
                        42
                    ],
                    burlywood: [
                        222,
                        184,
                        135
                    ],
                    cadetblue: [
                        95,
                        158,
                        160
                    ],
                    chartreuse: [
                        127,
                        255,
                        0
                    ],
                    chocolate: [
                        210,
                        105,
                        30
                    ],
                    coral: [
                        255,
                        127,
                        80
                    ],
                    cornflowerblue: [
                        100,
                        149,
                        237
                    ],
                    cornsilk: [
                        255,
                        248,
                        220
                    ],
                    crimson: [
                        220,
                        20,
                        60
                    ],
                    cyan: [
                        0,
                        255,
                        255
                    ],
                    darkblue: [
                        0,
                        0,
                        139
                    ],
                    darkcyan: [
                        0,
                        139,
                        139
                    ],
                    darkgoldenrod: [
                        184,
                        134,
                        11
                    ],
                    darkgray: [
                        169,
                        169,
                        169
                    ],
                    darkgreen: [
                        0,
                        100,
                        0
                    ],
                    darkgrey: [
                        169,
                        169,
                        169
                    ],
                    darkkhaki: [
                        189,
                        183,
                        107
                    ],
                    darkmagenta: [
                        139,
                        0,
                        139
                    ],
                    darkolivegreen: [
                        85,
                        107,
                        47
                    ],
                    darkorange: [
                        255,
                        140,
                        0
                    ],
                    darkorchid: [
                        153,
                        50,
                        204
                    ],
                    darkred: [
                        139,
                        0,
                        0
                    ],
                    darksalmon: [
                        233,
                        150,
                        122
                    ],
                    darkseagreen: [
                        143,
                        188,
                        143
                    ],
                    darkslateblue: [
                        72,
                        61,
                        139
                    ],
                    darkslategray: [
                        47,
                        79,
                        79
                    ],
                    darkslategrey: [
                        47,
                        79,
                        79
                    ],
                    darkturquoise: [
                        0,
                        206,
                        209
                    ],
                    darkviolet: [
                        148,
                        0,
                        211
                    ],
                    deeppink: [
                        255,
                        20,
                        147
                    ],
                    deepskyblue: [
                        0,
                        191,
                        255
                    ],
                    dimgray: [
                        105,
                        105,
                        105
                    ],
                    dimgrey: [
                        105,
                        105,
                        105
                    ],
                    dodgerblue: [
                        30,
                        144,
                        255
                    ],
                    firebrick: [
                        178,
                        34,
                        34
                    ],
                    floralwhite: [
                        255,
                        250,
                        240
                    ],
                    forestgreen: [
                        34,
                        139,
                        34
                    ],
                    fuchsia: [
                        255,
                        0,
                        255
                    ],
                    gainsboro: [
                        220,
                        220,
                        220
                    ],
                    ghostwhite: [
                        248,
                        248,
                        255
                    ],
                    gold: [
                        255,
                        215,
                        0
                    ],
                    goldenrod: [
                        218,
                        165,
                        32
                    ],
                    gray: [
                        128,
                        128,
                        128
                    ],
                    green: [
                        0,
                        128,
                        0
                    ],
                    greenyellow: [
                        173,
                        255,
                        47
                    ],
                    grey: [
                        128,
                        128,
                        128
                    ],
                    honeydew: [
                        240,
                        255,
                        240
                    ],
                    hotpink: [
                        255,
                        105,
                        180
                    ],
                    indianred: [
                        205,
                        92,
                        92
                    ],
                    indigo: [
                        75,
                        0,
                        130
                    ],
                    ivory: [
                        255,
                        255,
                        240
                    ],
                    khaki: [
                        240,
                        230,
                        140
                    ],
                    lavender: [
                        230,
                        230,
                        250
                    ],
                    lavenderblush: [
                        255,
                        240,
                        245
                    ],
                    lawngreen: [
                        124,
                        252,
                        0
                    ],
                    lemonchiffon: [
                        255,
                        250,
                        205
                    ],
                    lightblue: [
                        173,
                        216,
                        230
                    ],
                    lightcoral: [
                        240,
                        128,
                        128
                    ],
                    lightcyan: [
                        224,
                        255,
                        255
                    ],
                    lightgoldenrodyellow: [
                        250,
                        250,
                        210
                    ],
                    lightgray: [
                        211,
                        211,
                        211
                    ],
                    lightgreen: [
                        144,
                        238,
                        144
                    ],
                    lightgrey: [
                        211,
                        211,
                        211
                    ],
                    lightpink: [
                        255,
                        182,
                        193
                    ],
                    lightsalmon: [
                        255,
                        160,
                        122
                    ],
                    lightseagreen: [
                        32,
                        178,
                        170
                    ],
                    lightskyblue: [
                        135,
                        206,
                        250
                    ],
                    lightslategray: [
                        119,
                        136,
                        153
                    ],
                    lightslategrey: [
                        119,
                        136,
                        153
                    ],
                    lightsteelblue: [
                        176,
                        196,
                        222
                    ],
                    lightyellow: [
                        255,
                        255,
                        224
                    ],
                    lime: [
                        0,
                        255,
                        0
                    ],
                    limegreen: [
                        50,
                        205,
                        50
                    ],
                    linen: [
                        250,
                        240,
                        230
                    ],
                    magenta: [
                        255,
                        0,
                        255
                    ],
                    maroon: [
                        128,
                        0,
                        0
                    ],
                    mediumaquamarine: [
                        102,
                        205,
                        170
                    ],
                    mediumblue: [
                        0,
                        0,
                        205
                    ],
                    mediumorchid: [
                        186,
                        85,
                        211
                    ],
                    mediumpurple: [
                        147,
                        112,
                        219
                    ],
                    mediumseagreen: [
                        60,
                        179,
                        113
                    ],
                    mediumslateblue: [
                        123,
                        104,
                        238
                    ],
                    mediumspringgreen: [
                        0,
                        250,
                        154
                    ],
                    mediumturquoise: [
                        72,
                        209,
                        204
                    ],
                    mediumvioletred: [
                        199,
                        21,
                        133
                    ],
                    midnightblue: [
                        25,
                        25,
                        112
                    ],
                    mintcream: [
                        245,
                        255,
                        250
                    ],
                    mistyrose: [
                        255,
                        228,
                        225
                    ],
                    moccasin: [
                        255,
                        228,
                        181
                    ],
                    navajowhite: [
                        255,
                        222,
                        173
                    ],
                    navy: [
                        0,
                        0,
                        128
                    ],
                    oldlace: [
                        253,
                        245,
                        230
                    ],
                    olive: [
                        128,
                        128,
                        0
                    ],
                    olivedrab: [
                        107,
                        142,
                        35
                    ],
                    orange: [
                        255,
                        165,
                        0
                    ],
                    orangered: [
                        255,
                        69,
                        0
                    ],
                    orchid: [
                        218,
                        112,
                        214
                    ],
                    palegoldenrod: [
                        238,
                        232,
                        170
                    ],
                    palegreen: [
                        152,
                        251,
                        152
                    ],
                    paleturquoise: [
                        175,
                        238,
                        238
                    ],
                    palevioletred: [
                        219,
                        112,
                        147
                    ],
                    papayawhip: [
                        255,
                        239,
                        213
                    ],
                    peachpuff: [
                        255,
                        218,
                        185
                    ],
                    peru: [
                        205,
                        133,
                        63
                    ],
                    pink: [
                        255,
                        192,
                        203
                    ],
                    plum: [
                        221,
                        160,
                        221
                    ],
                    powderblue: [
                        176,
                        224,
                        230
                    ],
                    purple: [
                        128,
                        0,
                        128
                    ],
                    rebeccapurple: [
                        102,
                        51,
                        153
                    ],
                    red: [
                        255,
                        0,
                        0
                    ],
                    rosybrown: [
                        188,
                        143,
                        143
                    ],
                    royalblue: [
                        65,
                        105,
                        225
                    ],
                    saddlebrown: [
                        139,
                        69,
                        19
                    ],
                    salmon: [
                        250,
                        128,
                        114
                    ],
                    sandybrown: [
                        244,
                        164,
                        96
                    ],
                    seagreen: [
                        46,
                        139,
                        87
                    ],
                    seashell: [
                        255,
                        245,
                        238
                    ],
                    sienna: [
                        160,
                        82,
                        45
                    ],
                    silver: [
                        192,
                        192,
                        192
                    ],
                    skyblue: [
                        135,
                        206,
                        235
                    ],
                    slateblue: [
                        106,
                        90,
                        205
                    ],
                    slategray: [
                        112,
                        128,
                        144
                    ],
                    slategrey: [
                        112,
                        128,
                        144
                    ],
                    snow: [
                        255,
                        250,
                        250
                    ],
                    springgreen: [
                        0,
                        255,
                        127
                    ],
                    steelblue: [
                        70,
                        130,
                        180
                    ],
                    tan: [
                        210,
                        180,
                        140
                    ],
                    teal: [
                        0,
                        128,
                        128
                    ],
                    thistle: [
                        216,
                        191,
                        216
                    ],
                    tomato: [
                        255,
                        99,
                        71
                    ],
                    turquoise: [
                        64,
                        224,
                        208
                    ],
                    violet: [
                        238,
                        130,
                        238
                    ],
                    wheat: [
                        245,
                        222,
                        179
                    ],
                    white: [
                        255,
                        255,
                        255
                    ],
                    whitesmoke: [
                        245,
                        245,
                        245
                    ],
                    yellow: [
                        255,
                        255,
                        0
                    ],
                    yellowgreen: [
                        154,
                        205,
                        50
                    ]
                };
            },
            4877: (e)=>{
                "use strict";
                e.exports = {
                    aliceblue: [
                        240,
                        248,
                        255
                    ],
                    antiquewhite: [
                        250,
                        235,
                        215
                    ],
                    aqua: [
                        0,
                        255,
                        255
                    ],
                    aquamarine: [
                        127,
                        255,
                        212
                    ],
                    azure: [
                        240,
                        255,
                        255
                    ],
                    beige: [
                        245,
                        245,
                        220
                    ],
                    bisque: [
                        255,
                        228,
                        196
                    ],
                    black: [
                        0,
                        0,
                        0
                    ],
                    blanchedalmond: [
                        255,
                        235,
                        205
                    ],
                    blue: [
                        0,
                        0,
                        255
                    ],
                    blueviolet: [
                        138,
                        43,
                        226
                    ],
                    brown: [
                        165,
                        42,
                        42
                    ],
                    burlywood: [
                        222,
                        184,
                        135
                    ],
                    cadetblue: [
                        95,
                        158,
                        160
                    ],
                    chartreuse: [
                        127,
                        255,
                        0
                    ],
                    chocolate: [
                        210,
                        105,
                        30
                    ],
                    coral: [
                        255,
                        127,
                        80
                    ],
                    cornflowerblue: [
                        100,
                        149,
                        237
                    ],
                    cornsilk: [
                        255,
                        248,
                        220
                    ],
                    crimson: [
                        220,
                        20,
                        60
                    ],
                    cyan: [
                        0,
                        255,
                        255
                    ],
                    darkblue: [
                        0,
                        0,
                        139
                    ],
                    darkcyan: [
                        0,
                        139,
                        139
                    ],
                    darkgoldenrod: [
                        184,
                        134,
                        11
                    ],
                    darkgray: [
                        169,
                        169,
                        169
                    ],
                    darkgreen: [
                        0,
                        100,
                        0
                    ],
                    darkgrey: [
                        169,
                        169,
                        169
                    ],
                    darkkhaki: [
                        189,
                        183,
                        107
                    ],
                    darkmagenta: [
                        139,
                        0,
                        139
                    ],
                    darkolivegreen: [
                        85,
                        107,
                        47
                    ],
                    darkorange: [
                        255,
                        140,
                        0
                    ],
                    darkorchid: [
                        153,
                        50,
                        204
                    ],
                    darkred: [
                        139,
                        0,
                        0
                    ],
                    darksalmon: [
                        233,
                        150,
                        122
                    ],
                    darkseagreen: [
                        143,
                        188,
                        143
                    ],
                    darkslateblue: [
                        72,
                        61,
                        139
                    ],
                    darkslategray: [
                        47,
                        79,
                        79
                    ],
                    darkslategrey: [
                        47,
                        79,
                        79
                    ],
                    darkturquoise: [
                        0,
                        206,
                        209
                    ],
                    darkviolet: [
                        148,
                        0,
                        211
                    ],
                    deeppink: [
                        255,
                        20,
                        147
                    ],
                    deepskyblue: [
                        0,
                        191,
                        255
                    ],
                    dimgray: [
                        105,
                        105,
                        105
                    ],
                    dimgrey: [
                        105,
                        105,
                        105
                    ],
                    dodgerblue: [
                        30,
                        144,
                        255
                    ],
                    firebrick: [
                        178,
                        34,
                        34
                    ],
                    floralwhite: [
                        255,
                        250,
                        240
                    ],
                    forestgreen: [
                        34,
                        139,
                        34
                    ],
                    fuchsia: [
                        255,
                        0,
                        255
                    ],
                    gainsboro: [
                        220,
                        220,
                        220
                    ],
                    ghostwhite: [
                        248,
                        248,
                        255
                    ],
                    gold: [
                        255,
                        215,
                        0
                    ],
                    goldenrod: [
                        218,
                        165,
                        32
                    ],
                    gray: [
                        128,
                        128,
                        128
                    ],
                    green: [
                        0,
                        128,
                        0
                    ],
                    greenyellow: [
                        173,
                        255,
                        47
                    ],
                    grey: [
                        128,
                        128,
                        128
                    ],
                    honeydew: [
                        240,
                        255,
                        240
                    ],
                    hotpink: [
                        255,
                        105,
                        180
                    ],
                    indianred: [
                        205,
                        92,
                        92
                    ],
                    indigo: [
                        75,
                        0,
                        130
                    ],
                    ivory: [
                        255,
                        255,
                        240
                    ],
                    khaki: [
                        240,
                        230,
                        140
                    ],
                    lavender: [
                        230,
                        230,
                        250
                    ],
                    lavenderblush: [
                        255,
                        240,
                        245
                    ],
                    lawngreen: [
                        124,
                        252,
                        0
                    ],
                    lemonchiffon: [
                        255,
                        250,
                        205
                    ],
                    lightblue: [
                        173,
                        216,
                        230
                    ],
                    lightcoral: [
                        240,
                        128,
                        128
                    ],
                    lightcyan: [
                        224,
                        255,
                        255
                    ],
                    lightgoldenrodyellow: [
                        250,
                        250,
                        210
                    ],
                    lightgray: [
                        211,
                        211,
                        211
                    ],
                    lightgreen: [
                        144,
                        238,
                        144
                    ],
                    lightgrey: [
                        211,
                        211,
                        211
                    ],
                    lightpink: [
                        255,
                        182,
                        193
                    ],
                    lightsalmon: [
                        255,
                        160,
                        122
                    ],
                    lightseagreen: [
                        32,
                        178,
                        170
                    ],
                    lightskyblue: [
                        135,
                        206,
                        250
                    ],
                    lightslategray: [
                        119,
                        136,
                        153
                    ],
                    lightslategrey: [
                        119,
                        136,
                        153
                    ],
                    lightsteelblue: [
                        176,
                        196,
                        222
                    ],
                    lightyellow: [
                        255,
                        255,
                        224
                    ],
                    lime: [
                        0,
                        255,
                        0
                    ],
                    limegreen: [
                        50,
                        205,
                        50
                    ],
                    linen: [
                        250,
                        240,
                        230
                    ],
                    magenta: [
                        255,
                        0,
                        255
                    ],
                    maroon: [
                        128,
                        0,
                        0
                    ],
                    mediumaquamarine: [
                        102,
                        205,
                        170
                    ],
                    mediumblue: [
                        0,
                        0,
                        205
                    ],
                    mediumorchid: [
                        186,
                        85,
                        211
                    ],
                    mediumpurple: [
                        147,
                        112,
                        219
                    ],
                    mediumseagreen: [
                        60,
                        179,
                        113
                    ],
                    mediumslateblue: [
                        123,
                        104,
                        238
                    ],
                    mediumspringgreen: [
                        0,
                        250,
                        154
                    ],
                    mediumturquoise: [
                        72,
                        209,
                        204
                    ],
                    mediumvioletred: [
                        199,
                        21,
                        133
                    ],
                    midnightblue: [
                        25,
                        25,
                        112
                    ],
                    mintcream: [
                        245,
                        255,
                        250
                    ],
                    mistyrose: [
                        255,
                        228,
                        225
                    ],
                    moccasin: [
                        255,
                        228,
                        181
                    ],
                    navajowhite: [
                        255,
                        222,
                        173
                    ],
                    navy: [
                        0,
                        0,
                        128
                    ],
                    oldlace: [
                        253,
                        245,
                        230
                    ],
                    olive: [
                        128,
                        128,
                        0
                    ],
                    olivedrab: [
                        107,
                        142,
                        35
                    ],
                    orange: [
                        255,
                        165,
                        0
                    ],
                    orangered: [
                        255,
                        69,
                        0
                    ],
                    orchid: [
                        218,
                        112,
                        214
                    ],
                    palegoldenrod: [
                        238,
                        232,
                        170
                    ],
                    palegreen: [
                        152,
                        251,
                        152
                    ],
                    paleturquoise: [
                        175,
                        238,
                        238
                    ],
                    palevioletred: [
                        219,
                        112,
                        147
                    ],
                    papayawhip: [
                        255,
                        239,
                        213
                    ],
                    peachpuff: [
                        255,
                        218,
                        185
                    ],
                    peru: [
                        205,
                        133,
                        63
                    ],
                    pink: [
                        255,
                        192,
                        203
                    ],
                    plum: [
                        221,
                        160,
                        221
                    ],
                    powderblue: [
                        176,
                        224,
                        230
                    ],
                    purple: [
                        128,
                        0,
                        128
                    ],
                    rebeccapurple: [
                        102,
                        51,
                        153
                    ],
                    red: [
                        255,
                        0,
                        0
                    ],
                    rosybrown: [
                        188,
                        143,
                        143
                    ],
                    royalblue: [
                        65,
                        105,
                        225
                    ],
                    saddlebrown: [
                        139,
                        69,
                        19
                    ],
                    salmon: [
                        250,
                        128,
                        114
                    ],
                    sandybrown: [
                        244,
                        164,
                        96
                    ],
                    seagreen: [
                        46,
                        139,
                        87
                    ],
                    seashell: [
                        255,
                        245,
                        238
                    ],
                    sienna: [
                        160,
                        82,
                        45
                    ],
                    silver: [
                        192,
                        192,
                        192
                    ],
                    skyblue: [
                        135,
                        206,
                        235
                    ],
                    slateblue: [
                        106,
                        90,
                        205
                    ],
                    slategray: [
                        112,
                        128,
                        144
                    ],
                    slategrey: [
                        112,
                        128,
                        144
                    ],
                    snow: [
                        255,
                        250,
                        250
                    ],
                    springgreen: [
                        0,
                        255,
                        127
                    ],
                    steelblue: [
                        70,
                        130,
                        180
                    ],
                    tan: [
                        210,
                        180,
                        140
                    ],
                    teal: [
                        0,
                        128,
                        128
                    ],
                    thistle: [
                        216,
                        191,
                        216
                    ],
                    tomato: [
                        255,
                        99,
                        71
                    ],
                    turquoise: [
                        64,
                        224,
                        208
                    ],
                    violet: [
                        238,
                        130,
                        238
                    ],
                    wheat: [
                        245,
                        222,
                        179
                    ],
                    white: [
                        255,
                        255,
                        255
                    ],
                    whitesmoke: [
                        245,
                        245,
                        245
                    ],
                    yellow: [
                        255,
                        255,
                        0
                    ],
                    yellowgreen: [
                        154,
                        205,
                        50
                    ]
                };
            },
            6138: (e, t, a)=>{
                var r = a(4877), n = a(301), o = Object.hasOwnProperty, s = Object.create(null);
                for(var i in r)o.call(r, i) && (s[r[i]] = i);
                var l = e.exports = {
                    to: {},
                    get: {}
                };
                function c(e, t, a) {
                    return Math.min(Math.max(t, e), a);
                }
                function u(e) {
                    var t = Math.round(e).toString(16).toUpperCase();
                    return t.length < 2 ? "0" + t : t;
                }
                l.get = function(e) {
                    var t, a;
                    switch(e.substring(0, 3).toLowerCase()){
                        case "hsl":
                            t = l.get.hsl(e), a = "hsl";
                            break;
                        case "hwb":
                            t = l.get.hwb(e), a = "hwb";
                            break;
                        default:
                            t = l.get.rgb(e), a = "rgb";
                    }
                    return t ? {
                        model: a,
                        value: t
                    } : null;
                }, l.get.rgb = function(e) {
                    if (!e) return null;
                    var t, a, n, s = [
                        0,
                        0,
                        0,
                        1
                    ];
                    if (t = e.match(/^#([a-f0-9]{6})([a-f0-9]{2})?$/i)) {
                        for(n = t[2], t = t[1], a = 0; a < 3; a++){
                            var i = 2 * a;
                            s[a] = parseInt(t.slice(i, i + 2), 16);
                        }
                        n && (s[3] = parseInt(n, 16) / 255);
                    } else if (t = e.match(/^#([a-f0-9]{3,4})$/i)) {
                        for(n = (t = t[1])[3], a = 0; a < 3; a++)s[a] = parseInt(t[a] + t[a], 16);
                        n && (s[3] = parseInt(n + n, 16) / 255);
                    } else if (t = e.match(/^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/)) {
                        for(a = 0; a < 3; a++)s[a] = parseInt(t[a + 1], 0);
                        t[4] && (t[5] ? s[3] = .01 * parseFloat(t[4]) : s[3] = parseFloat(t[4]));
                    } else {
                        if (!(t = e.match(/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/))) return (t = e.match(/^(\w+)$/)) ? "transparent" === t[1] ? [
                            0,
                            0,
                            0,
                            0
                        ] : o.call(r, t[1]) ? ((s = r[t[1]])[3] = 1, s) : null : null;
                        for(a = 0; a < 3; a++)s[a] = Math.round(2.55 * parseFloat(t[a + 1]));
                        t[4] && (t[5] ? s[3] = .01 * parseFloat(t[4]) : s[3] = parseFloat(t[4]));
                    }
                    for(a = 0; a < 3; a++)s[a] = c(s[a], 0, 255);
                    return s[3] = c(s[3], 0, 1), s;
                }, l.get.hsl = function(e) {
                    if (!e) return null;
                    var t = e.match(/^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
                    if (t) {
                        var a = parseFloat(t[4]);
                        return [
                            (parseFloat(t[1]) % 360 + 360) % 360,
                            c(parseFloat(t[2]), 0, 100),
                            c(parseFloat(t[3]), 0, 100),
                            c(isNaN(a) ? 1 : a, 0, 1)
                        ];
                    }
                    return null;
                }, l.get.hwb = function(e) {
                    if (!e) return null;
                    var t = e.match(/^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
                    if (t) {
                        var a = parseFloat(t[4]);
                        return [
                            (parseFloat(t[1]) % 360 + 360) % 360,
                            c(parseFloat(t[2]), 0, 100),
                            c(parseFloat(t[3]), 0, 100),
                            c(isNaN(a) ? 1 : a, 0, 1)
                        ];
                    }
                    return null;
                }, l.to.hex = function() {
                    var e = n(arguments);
                    return "#" + u(e[0]) + u(e[1]) + u(e[2]) + (e[3] < 1 ? u(Math.round(255 * e[3])) : "");
                }, l.to.rgb = function() {
                    var e = n(arguments);
                    return e.length < 4 || 1 === e[3] ? "rgb(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ")" : "rgba(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ", " + e[3] + ")";
                }, l.to.rgb.percent = function() {
                    var e = n(arguments), t = Math.round(e[0] / 255 * 100), a = Math.round(e[1] / 255 * 100), r = Math.round(e[2] / 255 * 100);
                    return e.length < 4 || 1 === e[3] ? "rgb(" + t + "%, " + a + "%, " + r + "%)" : "rgba(" + t + "%, " + a + "%, " + r + "%, " + e[3] + ")";
                }, l.to.hsl = function() {
                    var e = n(arguments);
                    return e.length < 4 || 1 === e[3] ? "hsl(" + e[0] + ", " + e[1] + "%, " + e[2] + "%)" : "hsla(" + e[0] + ", " + e[1] + "%, " + e[2] + "%, " + e[3] + ")";
                }, l.to.hwb = function() {
                    var e = n(arguments), t = "";
                    return e.length >= 4 && 1 !== e[3] && (t = ", " + e[3]), "hwb(" + e[0] + ", " + e[1] + "%, " + e[2] + "%" + t + ")";
                }, l.to.keyword = function(e) {
                    return s[e.slice(0, 3)];
                };
            },
            3639: (e, t, a)=>{
                "use strict";
                var r = a(6138), n = a(4732), o = [].slice, s = [
                    "keyword",
                    "gray",
                    "hex"
                ], i = {};
                Object.keys(n).forEach(function(e) {
                    i[o.call(n[e].labels).sort().join("")] = e;
                });
                var l = {};
                function c(e, t) {
                    if (!(this instanceof c)) return new c(e, t);
                    if (t && t in s && (t = null), t && !(t in n)) throw new Error("Unknown model: " + t);
                    var a, u;
                    if (null == e) this.model = "rgb", this.color = [
                        0,
                        0,
                        0
                    ], this.valpha = 1;
                    else if (e instanceof c) this.model = e.model, this.color = e.color.slice(), this.valpha = e.valpha;
                    else if ("string" == typeof e) {
                        var d = r.get(e);
                        if (null === d) throw new Error("Unable to parse color from string: " + e);
                        this.model = d.model, u = n[this.model].channels, this.color = d.value.slice(0, u), this.valpha = "number" == typeof d.value[u] ? d.value[u] : 1;
                    } else if (e.length) {
                        this.model = t || "rgb", u = n[this.model].channels;
                        var p = o.call(e, 0, u);
                        this.color = b(p, u), this.valpha = "number" == typeof e[u] ? e[u] : 1;
                    } else if ("number" == typeof e) e &= 16777215, this.model = "rgb", this.color = [
                        e >> 16 & 255,
                        e >> 8 & 255,
                        255 & e
                    ], this.valpha = 1;
                    else {
                        this.valpha = 1;
                        var f = Object.keys(e);
                        "alpha" in e && (f.splice(f.indexOf("alpha"), 1), this.valpha = "number" == typeof e.alpha ? e.alpha : 0);
                        var h = f.sort().join("");
                        if (!(h in i)) throw new Error("Unable to parse color from object: " + JSON.stringify(e));
                        this.model = i[h];
                        var m = n[this.model].labels, v = [];
                        for(a = 0; a < m.length; a++)v.push(e[m[a]]);
                        this.color = b(v);
                    }
                    if (l[this.model]) for(u = n[this.model].channels, a = 0; a < u; a++){
                        var g = l[this.model][a];
                        g && (this.color[a] = g(this.color[a]));
                    }
                    this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
                }
                function u(e, t, a) {
                    return (e = Array.isArray(e) ? e : [
                        e
                    ]).forEach(function(e) {
                        (l[e] || (l[e] = []))[t] = a;
                    }), e = e[0], function(r) {
                        var n;
                        return arguments.length ? (a && (r = a(r)), (n = this[e]()).color[t] = r, n) : (n = this[e]().color[t], a && (n = a(n)), n);
                    };
                }
                function d(e) {
                    return function(t) {
                        return Math.max(0, Math.min(e, t));
                    };
                }
                function b(e, t) {
                    for(var a = 0; a < t; a++)"number" != typeof e[a] && (e[a] = 0);
                    return e;
                }
                c.prototype = {
                    toString: function() {
                        return this.string();
                    },
                    toJSON: function() {
                        return this[this.model]();
                    },
                    string: function(e) {
                        var t = this.model in r.to ? this : this.rgb(), a = 1 === (t = t.round("number" == typeof e ? e : 1)).valpha ? t.color : t.color.concat(this.valpha);
                        return r.to[t.model](a);
                    },
                    percentString: function(e) {
                        var t = this.rgb().round("number" == typeof e ? e : 1), a = 1 === t.valpha ? t.color : t.color.concat(this.valpha);
                        return r.to.rgb.percent(a);
                    },
                    array: function() {
                        return 1 === this.valpha ? this.color.slice() : this.color.concat(this.valpha);
                    },
                    object: function() {
                        for(var e = {}, t = n[this.model].channels, a = n[this.model].labels, r = 0; r < t; r++)e[a[r]] = this.color[r];
                        return 1 !== this.valpha && (e.alpha = this.valpha), e;
                    },
                    unitArray: function() {
                        var e = this.rgb().color;
                        return e[0] /= 255, e[1] /= 255, e[2] /= 255, 1 !== this.valpha && e.push(this.valpha), e;
                    },
                    unitObject: function() {
                        var e = this.rgb().object();
                        return e.r /= 255, e.g /= 255, e.b /= 255, 1 !== this.valpha && (e.alpha = this.valpha), e;
                    },
                    round: function(e) {
                        return e = Math.max(e || 0, 0), new c(this.color.map(function(e) {
                            return function(t) {
                                return function(e, t) {
                                    return Number(e.toFixed(t));
                                }(t, e);
                            };
                        }(e)).concat(this.valpha), this.model);
                    },
                    alpha: function(e) {
                        return arguments.length ? new c(this.color.concat(Math.max(0, Math.min(1, e))), this.model) : this.valpha;
                    },
                    red: u("rgb", 0, d(255)),
                    green: u("rgb", 1, d(255)),
                    blue: u("rgb", 2, d(255)),
                    hue: u([
                        "hsl",
                        "hsv",
                        "hsl",
                        "hwb",
                        "hcg"
                    ], 0, function(e) {
                        return (e % 360 + 360) % 360;
                    }),
                    saturationl: u("hsl", 1, d(100)),
                    lightness: u("hsl", 2, d(100)),
                    saturationv: u("hsv", 1, d(100)),
                    value: u("hsv", 2, d(100)),
                    chroma: u("hcg", 1, d(100)),
                    gray: u("hcg", 2, d(100)),
                    white: u("hwb", 1, d(100)),
                    wblack: u("hwb", 2, d(100)),
                    cyan: u("cmyk", 0, d(100)),
                    magenta: u("cmyk", 1, d(100)),
                    yellow: u("cmyk", 2, d(100)),
                    black: u("cmyk", 3, d(100)),
                    x: u("xyz", 0, d(100)),
                    y: u("xyz", 1, d(100)),
                    z: u("xyz", 2, d(100)),
                    l: u("lab", 0, d(100)),
                    a: u("lab", 1),
                    b: u("lab", 2),
                    keyword: function(e) {
                        return arguments.length ? new c(e) : n[this.model].keyword(this.color);
                    },
                    hex: function(e) {
                        return arguments.length ? new c(e) : r.to.hex(this.rgb().round().color);
                    },
                    rgbNumber: function() {
                        var e = this.rgb().color;
                        return (255 & e[0]) << 16 | (255 & e[1]) << 8 | 255 & e[2];
                    },
                    luminosity: function() {
                        for(var e = this.rgb().color, t = [], a = 0; a < e.length; a++){
                            var r = e[a] / 255;
                            t[a] = r <= .03928 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
                        }
                        return .2126 * t[0] + .7152 * t[1] + .0722 * t[2];
                    },
                    contrast: function(e) {
                        var t = this.luminosity(), a = e.luminosity();
                        return t > a ? (t + .05) / (a + .05) : (a + .05) / (t + .05);
                    },
                    level: function(e) {
                        var t = this.contrast(e);
                        return t >= 7.1 ? "AAA" : t >= 4.5 ? "AA" : "";
                    },
                    isDark: function() {
                        var e = this.rgb().color;
                        return (299 * e[0] + 587 * e[1] + 114 * e[2]) / 1e3 < 128;
                    },
                    isLight: function() {
                        return !this.isDark();
                    },
                    negate: function() {
                        for(var e = this.rgb(), t = 0; t < 3; t++)e.color[t] = 255 - e.color[t];
                        return e;
                    },
                    lighten: function(e) {
                        var t = this.hsl();
                        return t.color[2] += t.color[2] * e, t;
                    },
                    darken: function(e) {
                        var t = this.hsl();
                        return t.color[2] -= t.color[2] * e, t;
                    },
                    saturate: function(e) {
                        var t = this.hsl();
                        return t.color[1] += t.color[1] * e, t;
                    },
                    desaturate: function(e) {
                        var t = this.hsl();
                        return t.color[1] -= t.color[1] * e, t;
                    },
                    whiten: function(e) {
                        var t = this.hwb();
                        return t.color[1] += t.color[1] * e, t;
                    },
                    blacken: function(e) {
                        var t = this.hwb();
                        return t.color[2] += t.color[2] * e, t;
                    },
                    grayscale: function() {
                        var e = this.rgb().color, t = .3 * e[0] + .59 * e[1] + .11 * e[2];
                        return c.rgb(t, t, t);
                    },
                    fade: function(e) {
                        return this.alpha(this.valpha - this.valpha * e);
                    },
                    opaquer: function(e) {
                        return this.alpha(this.valpha + this.valpha * e);
                    },
                    rotate: function(e) {
                        var t = this.hsl(), a = t.color[0];
                        return a = (a = (a + e) % 360) < 0 ? 360 + a : a, t.color[0] = a, t;
                    },
                    mix: function(e, t) {
                        if (!e || !e.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof e);
                        var a = e.rgb(), r = this.rgb(), n = void 0 === t ? .5 : t, o = 2 * n - 1, s = a.alpha() - r.alpha(), i = ((o * s == -1 ? o : (o + s) / (1 + o * s)) + 1) / 2, l = 1 - i;
                        return c.rgb(i * a.red() + l * r.red(), i * a.green() + l * r.green(), i * a.blue() + l * r.blue(), a.alpha() * n + r.alpha() * (1 - n));
                    }
                }, Object.keys(n).forEach(function(e) {
                    if (-1 === s.indexOf(e)) {
                        var t = n[e].channels;
                        c.prototype[e] = function() {
                            if (this.model === e) return new c(this);
                            if (arguments.length) return new c(arguments, e);
                            var a, r = "number" == typeof arguments[t] ? t : this.valpha;
                            return new c((a = n[this.model][e].raw(this.color), Array.isArray(a) ? a : [
                                a
                            ]).concat(r), e);
                        }, c[e] = function(a) {
                            return "number" == typeof a && (a = b(o.call(arguments), t)), new c(a, e);
                        };
                    }
                }), e.exports = c;
            },
            9784: (e)=>{
                "use strict";
                var t, a = "object" == typeof Reflect ? Reflect : null, r = a && "function" == typeof a.apply ? a.apply : function(e, t, a) {
                    return Function.prototype.apply.call(e, t, a);
                };
                t = a && "function" == typeof a.ownKeys ? a.ownKeys : Object.getOwnPropertySymbols ? function(e) {
                    return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
                } : function(e) {
                    return Object.getOwnPropertyNames(e);
                };
                var n = Number.isNaN || function(e) {
                    return e != e;
                };
                function o() {
                    o.init.call(this);
                }
                e.exports = o, e.exports.once = function(e, t) {
                    return new Promise(function(a, r) {
                        function n(a) {
                            e.removeListener(t, o), r(a);
                        }
                        function o() {
                            "function" == typeof e.removeListener && e.removeListener("error", n), a([].slice.call(arguments));
                        }
                        h(e, t, o, {
                            once: !0
                        }), "error" !== t && function(e, t, a) {
                            "function" == typeof e.on && h(e, "error", t, a);
                        }(e, n, {
                            once: !0
                        });
                    });
                }, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
                var s = 10;
                function i(e) {
                    if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
                }
                function l(e) {
                    return void 0 === e._maxListeners ? o.defaultMaxListeners : e._maxListeners;
                }
                function c(e, t, a, r) {
                    var n, o, s, c;
                    if (i(a), void 0 === (o = e._events) ? (o = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== o.newListener && (e.emit("newListener", t, a.listener ? a.listener : a), o = e._events), s = o[t]), void 0 === s) s = o[t] = a, ++e._eventsCount;
                    else if ("function" == typeof s ? s = o[t] = r ? [
                        a,
                        s
                    ] : [
                        s,
                        a
                    ] : r ? s.unshift(a) : s.push(a), (n = l(e)) > 0 && s.length > n && !s.warned) {
                        s.warned = !0;
                        var u = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                        u.name = "MaxListenersExceededWarning", u.emitter = e, u.type = t, u.count = s.length, c = u, console && console.warn && console.warn(c);
                    }
                    return e;
                }
                function u() {
                    if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
                }
                function d(e, t, a) {
                    var r = {
                        fired: !1,
                        wrapFn: void 0,
                        target: e,
                        type: t,
                        listener: a
                    }, n = u.bind(r);
                    return n.listener = a, r.wrapFn = n, n;
                }
                function b(e, t, a) {
                    var r = e._events;
                    if (void 0 === r) return [];
                    var n = r[t];
                    return void 0 === n ? [] : "function" == typeof n ? a ? [
                        n.listener || n
                    ] : [
                        n
                    ] : a ? function(e) {
                        for(var t = new Array(e.length), a = 0; a < t.length; ++a)t[a] = e[a].listener || e[a];
                        return t;
                    }(n) : f(n, n.length);
                }
                function p(e) {
                    var t = this._events;
                    if (void 0 !== t) {
                        var a = t[e];
                        if ("function" == typeof a) return 1;
                        if (void 0 !== a) return a.length;
                    }
                    return 0;
                }
                function f(e, t) {
                    for(var a = new Array(t), r = 0; r < t; ++r)a[r] = e[r];
                    return a;
                }
                function h(e, t, a, r) {
                    if ("function" == typeof e.on) r.once ? e.once(t, a) : e.on(t, a);
                    else {
                        if ("function" != typeof e.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
                        e.addEventListener(t, function n(o) {
                            r.once && e.removeEventListener(t, n), a(o);
                        });
                    }
                }
                Object.defineProperty(o, "defaultMaxListeners", {
                    enumerable: !0,
                    get: function() {
                        return s;
                    },
                    set: function(e) {
                        if ("number" != typeof e || e < 0 || n(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
                        s = e;
                    }
                }), o.init = function() {
                    void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                }, o.prototype.setMaxListeners = function(e) {
                    if ("number" != typeof e || e < 0 || n(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
                    return this._maxListeners = e, this;
                }, o.prototype.getMaxListeners = function() {
                    return l(this);
                }, o.prototype.emit = function(e) {
                    for(var t = [], a = 1; a < arguments.length; a++)t.push(arguments[a]);
                    var n = "error" === e, o = this._events;
                    if (void 0 !== o) n = n && void 0 === o.error;
                    else if (!n) return !1;
                    if (n) {
                        var s;
                        if (t.length > 0 && (s = t[0]), s instanceof Error) throw s;
                        var i = new Error("Unhandled error." + (s ? " (" + s.message + ")" : ""));
                        throw i.context = s, i;
                    }
                    var l = o[e];
                    if (void 0 === l) return !1;
                    if ("function" == typeof l) r(l, this, t);
                    else {
                        var c = l.length, u = f(l, c);
                        for(a = 0; a < c; ++a)r(u[a], this, t);
                    }
                    return !0;
                }, o.prototype.addListener = function(e, t) {
                    return c(this, e, t, !1);
                }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(e, t) {
                    return c(this, e, t, !0);
                }, o.prototype.once = function(e, t) {
                    return i(t), this.on(e, d(this, e, t)), this;
                }, o.prototype.prependOnceListener = function(e, t) {
                    return i(t), this.prependListener(e, d(this, e, t)), this;
                }, o.prototype.removeListener = function(e, t) {
                    var a, r, n, o, s;
                    if (i(t), void 0 === (r = this._events)) return this;
                    if (void 0 === (a = r[e])) return this;
                    if (a === t || a.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete r[e], r.removeListener && this.emit("removeListener", e, a.listener || t));
                    else if ("function" != typeof a) {
                        for(n = -1, o = a.length - 1; o >= 0; o--)if (a[o] === t || a[o].listener === t) {
                            s = a[o].listener, n = o;
                            break;
                        }
                        if (n < 0) return this;
                        0 === n ? a.shift() : function(e, t) {
                            for(; t + 1 < e.length; t++)e[t] = e[t + 1];
                            e.pop();
                        }(a, n), 1 === a.length && (r[e] = a[0]), void 0 !== r.removeListener && this.emit("removeListener", e, s || t);
                    }
                    return this;
                }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(e) {
                    var t, a, r;
                    if (void 0 === (a = this._events)) return this;
                    if (void 0 === a.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== a[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete a[e]), this;
                    if (0 === arguments.length) {
                        var n, o = Object.keys(a);
                        for(r = 0; r < o.length; ++r)"removeListener" !== (n = o[r]) && this.removeAllListeners(n);
                        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
                    }
                    if ("function" == typeof (t = a[e])) this.removeListener(e, t);
                    else if (void 0 !== t) for(r = t.length - 1; r >= 0; r--)this.removeListener(e, t[r]);
                    return this;
                }, o.prototype.listeners = function(e) {
                    return b(this, e, !0);
                }, o.prototype.rawListeners = function(e) {
                    return b(this, e, !1);
                }, o.listenerCount = function(e, t) {
                    return "function" == typeof e.listenerCount ? e.listenerCount(t) : p.call(e, t);
                }, o.prototype.listenerCount = p, o.prototype.eventNames = function() {
                    return this._eventsCount > 0 ? t(this._events) : [];
                };
            },
            8336: (e)=>{
                e.exports = function(e) {
                    return !(!e || "string" == typeof e) && (e instanceof Array || Array.isArray(e) || e.length >= 0 && (e.splice instanceof Function || Object.getOwnPropertyDescriptor(e, e.length - 1) && "String" !== e.constructor.name));
                };
            },
            3989: (e)=>{
                var t = "__lodash_placeholder__", a = 32, r = 1 / 0, n = NaN, o = [
                    [
                        "ary",
                        128
                    ],
                    [
                        "bind",
                        1
                    ],
                    [
                        "bindKey",
                        2
                    ],
                    [
                        "curry",
                        8
                    ],
                    [
                        "curryRight",
                        16
                    ],
                    [
                        "flip",
                        512
                    ],
                    [
                        "partial",
                        a
                    ],
                    [
                        "partialRight",
                        64
                    ],
                    [
                        "rearg",
                        256
                    ]
                ], s = "[object Function]", i = "[object GeneratorFunction]", l = /^\s+|\s+$/g, c = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, u = /\{\n\/\* \[wrapped with (.+)\] \*/, d = /,? & /, b = /^[-+]0x[0-9a-f]+$/i, p = /^0b[01]+$/i, f = /^\[object .+?Constructor\]$/, h = /^0o[0-7]+$/i, m = /^(?:0|[1-9]\d*)$/, v = parseInt, g = "object" == typeof $parcel$global && $parcel$global && $parcel$global.Object === Object && $parcel$global, y = "object" == typeof self && self && self.Object === Object && self, k = g || y || Function("return this")();
                function E(e, t, a) {
                    switch(a.length){
                        case 0:
                            return e.call(t);
                        case 1:
                            return e.call(t, a[0]);
                        case 2:
                            return e.call(t, a[0], a[1]);
                        case 3:
                            return e.call(t, a[0], a[1], a[2]);
                    }
                    return e.apply(t, a);
                }
                function w(e, t) {
                    return !!(e ? e.length : 0) && function(e, t, a) {
                        if (t != t) return function(e, t, a, r) {
                            var n = e.length, o = a + (r ? 1 : -1);
                            for(; r ? o-- : ++o < n;)if (t(e[o], o, e)) return o;
                            return -1;
                        }(e, j, a);
                        var r = a - 1, n = e.length;
                        for(; ++r < n;)if (e[r] === t) return r;
                        return -1;
                    }(e, t, 0) > -1;
                }
                function j(e) {
                    return e != e;
                }
                function x(e, a) {
                    for(var r = -1, n = e.length, o = 0, s = []; ++r < n;){
                        var i = e[r];
                        i !== a && i !== t || (e[r] = t, s[o++] = r);
                    }
                    return s;
                }
                var C, O, M, S = Function.prototype, _ = Object.prototype, A = k["__core-js_shared__"], F = (C = /[^.]+$/.exec(A && A.keys && A.keys.IE_PROTO || "")) ? "Symbol(src)_1." + C : "", P = S.toString, R = _.hasOwnProperty, D = _.toString, I = RegExp("^" + P.call(R).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), z = Object.create, B = Math.max, N = Math.min, L = (O = H(Object, "defineProperty"), (M = H.name) && M.length > 2 ? O : void 0);
                function q(e) {
                    if (!X(e) || function(e) {
                        return !!F && F in e;
                    }(e)) return !1;
                    var t = function(e) {
                        var t = X(e) ? D.call(e) : "";
                        return t == s || t == i;
                    }(e) || function(e) {
                        var t = !1;
                        if (null != e && "function" != typeof e.toString) try {
                            t = !!(e + "");
                        } catch (e) {}
                        return t;
                    }(e) ? I : f;
                    return t.test(function(e) {
                        if (null != e) {
                            try {
                                return P.call(e);
                            } catch (e) {}
                            try {
                                return e + "";
                            } catch (e) {}
                        }
                        return "";
                    }(e));
                }
                function V(e) {
                    return function() {
                        var t = arguments;
                        switch(t.length){
                            case 0:
                                return new e;
                            case 1:
                                return new e(t[0]);
                            case 2:
                                return new e(t[0], t[1]);
                            case 3:
                                return new e(t[0], t[1], t[2]);
                            case 4:
                                return new e(t[0], t[1], t[2], t[3]);
                            case 5:
                                return new e(t[0], t[1], t[2], t[3], t[4]);
                            case 6:
                                return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
                            case 7:
                                return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                        }
                        var a, r = X(a = e.prototype) ? z(a) : {}, n = e.apply(r, t);
                        return X(n) ? n : r;
                    };
                }
                function T(e, t, a, r, n, o, s, i, l, c) {
                    var u = 128 & t, d = 1 & t, b = 2 & t, p = 24 & t, f = 512 & t, h = b ? void 0 : V(e);
                    return function m() {
                        for(var v = arguments.length, g = Array(v), y = v; y--;)g[y] = arguments[y];
                        if (p) var E = U(m), w = function(e, t) {
                            for(var a = e.length, r = 0; a--;)e[a] === t && r++;
                            return r;
                        }(g, E);
                        if (r && (g = function(e, t, a, r) {
                            for(var n = -1, o = e.length, s = a.length, i = -1, l = t.length, c = B(o - s, 0), u = Array(l + c), d = !r; ++i < l;)u[i] = t[i];
                            for(; ++n < s;)(d || n < o) && (u[a[n]] = e[n]);
                            for(; c--;)u[i++] = e[n++];
                            return u;
                        }(g, r, n, p)), o && (g = function(e, t, a, r) {
                            for(var n = -1, o = e.length, s = -1, i = a.length, l = -1, c = t.length, u = B(o - i, 0), d = Array(u + c), b = !r; ++n < u;)d[n] = e[n];
                            for(var p = n; ++l < c;)d[p + l] = t[l];
                            for(; ++s < i;)(b || n < o) && (d[p + a[s]] = e[n++]);
                            return d;
                        }(g, o, s, p)), v -= w, p && v < c) {
                            var j = x(g, E);
                            return K(e, t, T, m.placeholder, a, g, j, i, l, c - v);
                        }
                        var C = d ? a : this, O = b ? C[e] : e;
                        return v = g.length, i ? g = function(e, t) {
                            var a = e.length, r = N(t.length, a), n = function(e, t) {
                                var a = -1, r = e.length;
                                for(t || (t = Array(r)); ++a < r;)t[a] = e[a];
                                return t;
                            }(e);
                            for(; r--;){
                                var o = t[r];
                                e[r] = J(o, a) ? n[o] : void 0;
                            }
                            return e;
                        }(g, i) : f && v > 1 && g.reverse(), u && l < v && (g.length = l), this && this !== k && this instanceof m && (O = h || V(O)), O.apply(C, g);
                    };
                }
                function K(e, t, r, n, o, s, i, l, c, u) {
                    var d = 8 & t;
                    t |= d ? a : 64, 4 & (t &= ~(d ? 64 : a)) || (t &= -4);
                    var b = r(e, t, o, d ? s : void 0, d ? i : void 0, d ? void 0 : s, d ? void 0 : i, l, c, u);
                    return b.placeholder = n, G(b, e, t);
                }
                function W(e, t, r, n, o, s, i, l) {
                    var c = 2 & t;
                    if (!c && "function" != typeof e) throw new TypeError("Expected a function");
                    var u = n ? n.length : 0;
                    if (u || (t &= -97, n = o = void 0), i = void 0 === i ? i : B(te(i), 0), l = void 0 === l ? l : te(l), u -= o ? o.length : 0, 64 & t) {
                        var d = n, b = o;
                        n = o = void 0;
                    }
                    var p = [
                        e,
                        t,
                        r,
                        n,
                        o,
                        d,
                        b,
                        s,
                        i,
                        l
                    ];
                    if (e = p[0], t = p[1], r = p[2], n = p[3], o = p[4], !(l = p[9] = null == p[9] ? c ? 0 : e.length : B(p[9] - u, 0)) && 24 & t && (t &= -25), t && 1 != t) f = 8 == t || 16 == t ? function(e, t, a) {
                        var r = V(e);
                        return function n() {
                            for(var o = arguments.length, s = Array(o), i = o, l = U(n); i--;)s[i] = arguments[i];
                            var c = o < 3 && s[0] !== l && s[o - 1] !== l ? [] : x(s, l);
                            return (o -= c.length) < a ? K(e, t, T, n.placeholder, void 0, s, c, void 0, void 0, a - o) : E(this && this !== k && this instanceof n ? r : e, this, s);
                        };
                    }(e, t, l) : t != a && 33 != t || o.length ? T.apply(void 0, p) : function(e, t, a, r) {
                        var n = 1 & t, o = V(e);
                        return function t() {
                            for(var s = -1, i = arguments.length, l = -1, c = r.length, u = Array(c + i), d = this && this !== k && this instanceof t ? o : e; ++l < c;)u[l] = r[l];
                            for(; i--;)u[l++] = arguments[++s];
                            return E(d, n ? a : this, u);
                        };
                    }(e, t, r, n);
                    else var f = function(e, t, a) {
                        var r = 1 & t, n = V(e);
                        return function t() {
                            return (this && this !== k && this instanceof t ? n : e).apply(r ? a : this, arguments);
                        };
                    }(e, t, r);
                    return G(f, e, t);
                }
                function U(e) {
                    return e.placeholder;
                }
                function H(e, t) {
                    var a = function(e, t) {
                        return null == e ? void 0 : e[t];
                    }(e, t);
                    return q(a) ? a : void 0;
                }
                function $(e) {
                    var t = e.match(u);
                    return t ? t[1].split(d) : [];
                }
                function Y(e, t) {
                    var a = t.length, r = a - 1;
                    return t[r] = (a > 1 ? "& " : "") + t[r], t = t.join(a > 2 ? ", " : " "), e.replace(c, "{\n/* [wrapped with " + t + "] */\n");
                }
                function J(e, t) {
                    return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || m.test(e)) && e > -1 && e % 1 == 0 && e < t;
                }
                var G = L ? function(e, t, a) {
                    var r, n = t + "";
                    return L(e, "toString", {
                        configurable: !0,
                        enumerable: !1,
                        value: (r = Y(n, Q($(n), a)), function() {
                            return r;
                        })
                    });
                } : function(e) {
                    return e;
                };
                function Q(e, t) {
                    return function(e, t) {
                        for(var a = -1, r = e ? e.length : 0; ++a < r && !1 !== t(e[a], a, e););
                    }(o, function(a) {
                        var r = "_." + a[0];
                        t & a[1] && !w(e, r) && e.push(r);
                    }), e.sort();
                }
                function Z(e, t, a) {
                    var r = W(e, 8, void 0, void 0, void 0, void 0, void 0, t = a ? void 0 : t);
                    return r.placeholder = Z.placeholder, r;
                }
                function X(e) {
                    var t = typeof e;
                    return !!e && ("object" == t || "function" == t);
                }
                function ee(e) {
                    return e ? (e = function(e) {
                        if ("number" == typeof e) return e;
                        if (function(e) {
                            return "symbol" == typeof e || function(e) {
                                return !!e && "object" == typeof e;
                            }(e) && "[object Symbol]" == D.call(e);
                        }(e)) return n;
                        if (X(e)) {
                            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                            e = X(t) ? t + "" : t;
                        }
                        if ("string" != typeof e) return 0 === e ? e : +e;
                        e = e.replace(l, "");
                        var a = p.test(e);
                        return a || h.test(e) ? v(e.slice(2), a ? 2 : 8) : b.test(e) ? n : +e;
                    }(e)) === r || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
                }
                function te(e) {
                    var t = ee(e), a = t % 1;
                    return t == t ? a ? t - a : t : 0;
                }
                Z.placeholder = {}, e.exports = Z;
            },
            301: (e, t, a)=>{
                "use strict";
                var r = a(8336), n = Array.prototype.concat, o = Array.prototype.slice, s = e.exports = function(e) {
                    for(var t = [], a = 0, s = e.length; a < s; a++){
                        var i = e[a];
                        r(i) ? t = n.call(t, o.call(i)) : t.push(i);
                    }
                    return t;
                };
                s.wrap = function(e) {
                    return function() {
                        return e(s(arguments));
                    };
                };
            },
            4119: (t)=>{
                "use strict";
                t.exports = e;
            }
        }, a = {};
        function r(e) {
            var n = a[e];
            if (void 0 !== n) return n.exports;
            var o = a[e] = {
                exports: {}
            };
            return t[e](o, o.exports, r), o.exports;
        }
        r.n = (e)=>{
            var t = e && e.__esModule ? ()=>e.default : ()=>e;
            return r.d(t, {
                a: t
            }), t;
        }, r.d = (e, t)=>{
            for(var a in t)r.o(t, a) && !r.o(e, a) && Object.defineProperty(e, a, {
                enumerable: !0,
                get: t[a]
            });
        }, r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var n = {};
        return (()=>{
            "use strict";
            function e(t) {
                return e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, e(t);
            }
            function t(t) {
                var a = function(t, a) {
                    if ("object" != e(t) || !t) return t;
                    var r = t[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(t, a || "default");
                        if ("object" != e(n)) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === a ? String : Number)(t);
                }(t, "string");
                return "symbol" == e(a) ? a : a + "";
            }
            function a(e, a, r) {
                return (a = t(a)) in e ? Object.defineProperty(e, a, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[a] = r, e;
            }
            function o(e, t) {
                var a = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(e);
                    t && (r = r.filter(function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })), a.push.apply(a, r);
                }
                return a;
            }
            function s(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? o(Object(r), !0).forEach(function(t) {
                        a(e, t, r[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : o(Object(r)).forEach(function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                    });
                }
                return e;
            }
            function i(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function l(e, a) {
                for(var r = 0; r < a.length; r++){
                    var n = a[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, t(n.key), n);
                }
            }
            function c(e, t, a) {
                return t && l(e.prototype, t), a && l(e, a), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), e;
            }
            function u(e) {
                return u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                }, u(e);
            }
            function d() {
                try {
                    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                } catch (e) {}
                return (d = function() {
                    return !!e;
                })();
            }
            function b(t, a) {
                if (a && ("object" == e(a) || "function" == typeof a)) return a;
                if (void 0 !== a) throw new TypeError("Derived constructors may only return object or undefined");
                return function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(t);
            }
            function p(e, t, a) {
                return t = u(t), b(e, d() ? Reflect.construct(t, a || [], u(e).constructor) : t.apply(e, a));
            }
            function f(e, t) {
                return f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                    return e.__proto__ = t, e;
                }, f(e, t);
            }
            function h(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && f(e, t);
            }
            r.r(n), r.d(n, {
                default: ()=>Et
            });
            var m = r(4119), v = r.n(m);
            function g() {
                var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
                null != e && this.setState(e);
            }
            function y(e) {
                this.setState((function(t) {
                    var a = this.constructor.getDerivedStateFromProps(e, t);
                    return null != a ? a : null;
                }).bind(this));
            }
            function k(e, t) {
                try {
                    var a = this.props, r = this.state;
                    this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(a, r);
                } finally{
                    this.props = a, this.state = r;
                }
            }
            function E(e) {
                var t = e.prototype;
                if (!t || !t.isReactComponent) throw new Error("Can only polyfill class components");
                if ("function" != typeof e.getDerivedStateFromProps && "function" != typeof t.getSnapshotBeforeUpdate) return e;
                var a = null, r = null, n = null;
                if ("function" == typeof t.componentWillMount ? a = "componentWillMount" : "function" == typeof t.UNSAFE_componentWillMount && (a = "UNSAFE_componentWillMount"), "function" == typeof t.componentWillReceiveProps ? r = "componentWillReceiveProps" : "function" == typeof t.UNSAFE_componentWillReceiveProps && (r = "UNSAFE_componentWillReceiveProps"), "function" == typeof t.componentWillUpdate ? n = "componentWillUpdate" : "function" == typeof t.UNSAFE_componentWillUpdate && (n = "UNSAFE_componentWillUpdate"), null !== a || null !== r || null !== n) {
                    var o = e.displayName || e.name, s = "function" == typeof e.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                    throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + o + " uses " + s + " but also contains the following legacy lifecycles:" + (null !== a ? "\n  " + a : "") + (null !== r ? "\n  " + r : "") + (null !== n ? "\n  " + n : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks");
                }
                if ("function" == typeof e.getDerivedStateFromProps && (t.componentWillMount = g, t.componentWillReceiveProps = y), "function" == typeof t.getSnapshotBeforeUpdate) {
                    if ("function" != typeof t.componentDidUpdate) throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
                    t.componentWillUpdate = k;
                    var i = t.componentDidUpdate;
                    t.componentDidUpdate = function(e, t, a) {
                        var r = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : a;
                        i.call(this, e, t, r);
                    };
                }
                return e;
            }
            function w(e, t) {
                if (null == e) return {};
                var a = {};
                for(var r in e)if (({}).hasOwnProperty.call(e, r)) {
                    if (t.includes(r)) continue;
                    a[r] = e[r];
                }
                return a;
            }
            function j(e, t) {
                if (null == e) return {};
                var a, r, n = w(e, t);
                if (Object.getOwnPropertySymbols) {
                    var o = Object.getOwnPropertySymbols(e);
                    for(r = 0; r < o.length; r++)a = o[r], t.includes(a) || ({}).propertyIsEnumerable.call(e, a) && (n[a] = e[a]);
                }
                return n;
            }
            function x(e, t) {
                if (t && (null == e ? void 0 : e.constructor) === t) return "bigNumber";
                var a = function(e) {
                    return ({}).toString.call(e).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
                }(e);
                return "number" === a && (a = isNaN(e) ? "nan" : (0 | e) != e ? "float" : "integer"), a;
            }
            function C(e) {
                return e.replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r").replace(/\f/g, "\\f");
            }
            g.__suppressDeprecationWarning = !0, y.__suppressDeprecationWarning = !0, k.__suppressDeprecationWarning = !0;
            var O = {
                scheme: "rjv-default",
                author: "mac gainor",
                base00: "rgba(0, 0, 0, 0)",
                base01: "rgb(245, 245, 245)",
                base02: "rgb(235, 235, 235)",
                base03: "#93a1a1",
                base04: "rgba(0, 0, 0, 0.3)",
                base05: "#586e75",
                base06: "#073642",
                base07: "#002b36",
                base08: "#d33682",
                base09: "#cb4b16",
                base0A: "#dc322f",
                base0B: "#859900",
                base0C: "#6c71c4",
                base0D: "#586e75",
                base0E: "#2aa198",
                base0F: "#268bd2"
            }, M = {
                scheme: "rjv-grey",
                author: "mac gainor",
                base00: "rgba(1, 1, 1, 0)",
                base01: "rgba(1, 1, 1, 0.1)",
                base02: "rgba(0, 0, 0, 0.2)",
                base03: "rgba(1, 1, 1, 0.3)",
                base04: "rgba(0, 0, 0, 0.4)",
                base05: "rgba(1, 1, 1, 0.5)",
                base06: "rgba(1, 1, 1, 0.6)",
                base07: "rgba(1, 1, 1, 0.7)",
                base08: "rgba(1, 1, 1, 0.8)",
                base09: "rgba(1, 1, 1, 0.8)",
                base0A: "rgba(1, 1, 1, 0.8)",
                base0B: "rgba(1, 1, 1, 0.8)",
                base0C: "rgba(1, 1, 1, 0.8)",
                base0D: "rgba(1, 1, 1, 0.8)",
                base0E: "rgba(1, 1, 1, 0.8)",
                base0F: "rgba(1, 1, 1, 0.8)"
            };
            const S = {
                white: "#fff",
                black: "#000",
                transparent: "rgba(1, 1, 1, 0)",
                globalFontFamily: "monospace",
                globalCursor: "default",
                indentBlockWidth: "5px",
                braceFontWeight: "bold",
                braceCursor: "pointer",
                ellipsisFontSize: "18px",
                ellipsisLineHeight: "10px",
                ellipsisCursor: "pointer",
                keyMargin: "0px 5px",
                keyLetterSpacing: "0.5px",
                keyFontStyle: "none",
                keyBorderRadius: "3px",
                keyColonWeight: "bold",
                keyVerticalAlign: "top",
                keyOpacity: "0.85",
                keyOpacityHover: "1",
                keyValPaddingTop: "3px",
                keyValPaddingBottom: "3px",
                keyValPaddingRight: "5px",
                keyValBorderLeft: "1px solid",
                keyValBorderHover: "2px solid",
                keyValPaddingHover: "3px 5px 3px 4px",
                pushedContentMarginLeft: "6px",
                variableValuePaddingRight: "6px",
                nullFontSize: "11px",
                nullFontWeight: "bold",
                nullPadding: "1px 2px",
                nullBorderRadius: "3px",
                nanFontSize: "11px",
                nanFontWeight: "bold",
                nanPadding: "1px 2px",
                nanBorderRadius: "3px",
                undefinedFontSize: "11px",
                undefinedFontWeight: "bold",
                undefinedPadding: "1px 2px",
                undefinedBorderRadius: "3px",
                dataTypeFontSize: "11px",
                dataTypeMarginRight: "4px",
                datatypeOpacity: "0.8",
                objectSizeBorderRadius: "3px",
                objectSizeFontStyle: "italic",
                objectSizeMargin: "0px 6px 0px 0px",
                clipboardCursor: "pointer",
                clipboardCheckMarginLeft: "-12px",
                metaDataPadding: "0px 0px 0px 10px",
                arrayGroupMetaPadding: "0px 0px 0px 4px",
                iconContainerWidth: "17px",
                tooltipPadding: "4px",
                editInputMinWidth: "130px",
                editInputBorderRadius: "2px",
                editInputPadding: "5px",
                editInputMarginRight: "4px",
                editInputFontFamily: "monospace",
                iconCursor: "pointer",
                iconFontSize: "15px",
                iconPaddingRight: "1px",
                dateValueMarginLeft: "2px",
                iconMarginRight: "3px",
                detectedRowPaddingTop: "3px",
                addKeyCoverBackground: "rgba(255, 255, 255, 0.3)",
                addKeyCoverPosition: "absolute",
                addKeyCoverPositionPx: "0px",
                addKeyModalWidth: "200px",
                addKeyModalMargin: "auto",
                addKeyModalPadding: "10px",
                addKeyModalRadius: "3px",
                commaColor: "#666",
                commaFontSize: "12px",
                commaMarginRight: "4px"
            };
            function _(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var a = 0, r = Array(t); a < t; a++)r[a] = e[a];
                return r;
            }
            function A(e, t) {
                if (e) {
                    if ("string" == typeof e) return _(e, t);
                    var a = ({}).toString.call(e).slice(8, -1);
                    return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Array.from(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? _(e, t) : void 0;
                }
            }
            function F(e, t) {
                return function(e) {
                    if (Array.isArray(e)) return e;
                }(e) || function(e, t) {
                    var a = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (null != a) {
                        var r, n, o, s, i = [], l = !0, c = !1;
                        try {
                            if (o = (a = a.call(e)).next, 0 === t) {
                                if (Object(a) !== a) return;
                                l = !1;
                            } else for(; !(l = (r = o.call(a)).done) && (i.push(r.value), i.length !== t); l = !0);
                        } catch (e) {
                            c = !0, n = e;
                        } finally{
                            try {
                                if (!l && null != a.return && (s = a.return(), Object(s) !== s)) return;
                            } finally{
                                if (c) throw n;
                            }
                        }
                        return i;
                    }
                }(e, t) || A(e, t) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            var P = r(9446), R = r(3639), D = r.n(R), I = r(3989), z = r.n(I);
            function B(e, t) {
                var a = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(e);
                    t && (r = r.filter(function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })), a.push.apply(a, r);
                }
                return a;
            }
            function N(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? B(Object(r), !0).forEach(function(t) {
                        a(e, t, r[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : B(Object(r)).forEach(function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                    });
                }
                return e;
            }
            var L = P.default, q = Object.keys(L), V = function(e) {
                var t, a = function(e) {
                    var t = e[0] / 255, a = e[1] / 255, r = e[2] / 255;
                    return [
                        .299 * t + .587 * a + .114 * r,
                        -0.14713 * t + -0.28886 * a + .436 * r,
                        .615 * t + -0.51499 * a + -0.10001 * r
                    ];
                }(D()(e).array()), r = F(a, 3), n = r[0], o = r[1], s = r[2], i = function(e) {
                    var t, a, r, n = e[0], o = e[1], s = e[2];
                    return t = 1 * n + 0 * o + 1.13983 * s, a = 1 * n + -0.39465 * o + -0.5806 * s, r = 1 * n + 2.02311 * o + 0 * s, [
                        255 * (t = Math.min(Math.max(0, t), 1)),
                        255 * (a = Math.min(Math.max(0, a), 1)),
                        255 * (r = Math.min(Math.max(0, r), 1))
                    ];
                }([
                    (t = n, t < .25 ? 1 : t < .5 ? .9 - t : 1.1 - t),
                    o,
                    s
                ]);
                return D().rgb(i).hex();
            }, T = function(e) {
                return function(t) {
                    return {
                        className: [
                            t.className,
                            e.className
                        ].filter(Boolean).join(" "),
                        style: N(N({}, t.style || {}), e.style || {})
                    };
                };
            }, K = function(t, a) {
                var r = Object.keys(a);
                for(var n in t)-1 === r.indexOf(n) && r.push(n);
                return r.reduce(function(r, n) {
                    return r[n] = function(t, a) {
                        if (void 0 === t) return a;
                        if (void 0 === a) return t;
                        var r = e(t), n = e(a);
                        switch(r){
                            case "string":
                                switch(n){
                                    case "string":
                                        return [
                                            a,
                                            t
                                        ].filter(Boolean).join(" ");
                                    case "object":
                                        return T({
                                            className: t,
                                            style: a
                                        });
                                    case "function":
                                        return function(e) {
                                            for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)n[o - 1] = arguments[o];
                                            return T({
                                                className: t
                                            })(a.apply(void 0, [
                                                e
                                            ].concat(n)));
                                        };
                                }
                                break;
                            case "object":
                                switch(n){
                                    case "string":
                                        return T({
                                            className: a,
                                            style: t
                                        });
                                    case "object":
                                        return N(N({}, a), t);
                                    case "function":
                                        return function(e) {
                                            for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)n[o - 1] = arguments[o];
                                            return T({
                                                style: t
                                            })(a.apply(void 0, [
                                                e
                                            ].concat(n)));
                                        };
                                }
                                break;
                            case "function":
                                switch(n){
                                    case "string":
                                        return function(e) {
                                            for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)n[o - 1] = arguments[o];
                                            return t.apply(void 0, [
                                                T(e)({
                                                    className: a
                                                })
                                            ].concat(n));
                                        };
                                    case "object":
                                        return function(e) {
                                            for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)n[o - 1] = arguments[o];
                                            return t.apply(void 0, [
                                                T(e)({
                                                    style: a
                                                })
                                            ].concat(n));
                                        };
                                    case "function":
                                        return function(e) {
                                            for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)n[o - 1] = arguments[o];
                                            return t.apply(void 0, [
                                                a.apply(void 0, [
                                                    e
                                                ].concat(n))
                                            ].concat(n));
                                        };
                                }
                        }
                    }(t[n], a[n]), r;
                }, {});
            }, W = function(t, a) {
                for(var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++)n[o - 2] = arguments[o];
                if (null === a) return t;
                Array.isArray(a) || (a = [
                    a
                ]);
                var s = a.map(function(e) {
                    return t[e];
                }).filter(Boolean).reduce(function(t, a) {
                    return "string" == typeof a ? t.className = [
                        t.className,
                        a
                    ].filter(Boolean).join(" ") : "object" === e(a) ? t.style = N(N({}, t.style), a) : "function" == typeof a && (t = N(N({}, t), a.apply(void 0, [
                        t
                    ].concat(n)))), t;
                }, {
                    className: "",
                    style: {}
                });
                return s.className || delete s.className, 0 === Object.keys(s.style).length && delete s.style, s;
            }, U = function(e) {
                return Object.keys(e).reduce(function(t, a) {
                    return t[a] = /^base/.test(a) ? V(e[a]) : "scheme" === a ? e[a] + ":inverted" : e[a], t;
                }, {});
            }, H = z()(function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = t.defaultBase16, n = void 0 === r ? L : r, o = t.base16Themes, s = Y(a, void 0 === o ? null : o);
                s && (a = N(N({}, s), a));
                for(var i = q.reduce(function(e, t) {
                    return e[t] = a[t] || n[t], e;
                }, {}), l = Object.keys(a).reduce(function(e, t) {
                    return -1 === q.indexOf(t) ? (e[t] = a[t], e) : e;
                }, {}), c = e(i), u = K(l, c), d = arguments.length, b = new Array(d > 3 ? d - 3 : 0), p = 3; p < d; p++)b[p - 3] = arguments[p];
                return z()(W, 2).apply(void 0, [
                    u
                ].concat(b));
            }, 3), $ = function(e) {
                return !!e.extend;
            }, Y = function(e, t) {
                if (e && $(e) && e.extend && (e = e.extend), "string" == typeof e) {
                    var a = F(e.split(":"), 2), r = a[0], n = a[1];
                    e = t ? t[r] : P[r], "inverted" === n && (e = U(e));
                }
                return e && Object.prototype.hasOwnProperty.call(e, "base00") ? e : void 0;
            }, J = function(e) {
                var t = function(e) {
                    return {
                        backgroundColor: e.base00,
                        ellipsisColor: e.base09,
                        braceColor: e.base07,
                        expandedIcon: e.base0D,
                        collapsedIcon: e.base0E,
                        keyColor: e.base07,
                        arrayKeyColor: e.base0C,
                        objectSize: e.base04,
                        copyToClipboard: e.base0F,
                        copyToClipboardCheck: e.base0D,
                        objectBorder: e.base02,
                        dataTypes: {
                            boolean: e.base0E,
                            date: e.base0D,
                            float: e.base0B,
                            function: e.base0D,
                            integer: e.base0F,
                            string: e.base09,
                            nan: e.base08,
                            null: e.base0A,
                            undefined: e.base05,
                            regexp: e.base0A,
                            background: e.base02,
                            bigNumber: e.base09
                        },
                        editVariable: {
                            editIcon: e.base0E,
                            cancelIcon: e.base09,
                            removeIcon: e.base09,
                            addIcon: e.base0E,
                            checkIcon: e.base0E,
                            background: e.base01,
                            color: e.base0A,
                            border: e.base07
                        },
                        addKeyModal: {
                            background: e.base05,
                            border: e.base04,
                            color: e.base0A,
                            labelColor: e.base01
                        },
                        validationFailure: {
                            background: e.base09,
                            iconColor: e.base01,
                            fontColor: e.base01
                        }
                    };
                }(e);
                return {
                    "app-container": {
                        fontFamily: S.globalFontFamily,
                        cursor: S.globalCursor,
                        backgroundColor: t.backgroundColor,
                        position: "relative"
                    },
                    ellipsis: {
                        display: "inline-block",
                        color: t.ellipsisColor,
                        fontSize: S.ellipsisFontSize,
                        lineHeight: S.ellipsisLineHeight,
                        cursor: S.ellipsisCursor
                    },
                    "brace-row": {
                        display: "inline-block",
                        cursor: "pointer"
                    },
                    brace: {
                        display: "inline-block",
                        cursor: S.braceCursor,
                        fontWeight: S.braceFontWeight,
                        color: t.braceColor
                    },
                    "expanded-icon": {
                        color: t.expandedIcon
                    },
                    "collapsed-icon": {
                        color: t.collapsedIcon
                    },
                    colon: {
                        display: "inline-block",
                        margin: S.keyMargin,
                        color: t.keyColor,
                        verticalAlign: "top"
                    },
                    objectKeyVal: function(e, a) {
                        return {
                            style: s({
                                paddingTop: S.keyValPaddingTop,
                                paddingRight: S.keyValPaddingRight,
                                paddingBottom: S.keyValPaddingBottom,
                                borderLeft: S.keyValBorderLeft + " " + t.objectBorder,
                                ":hover": {
                                    paddingLeft: a.paddingLeft - 1 + "px",
                                    borderLeft: S.keyValBorderHover + " " + t.objectBorder
                                }
                            }, a)
                        };
                    },
                    "object-key-val-no-border": {
                        padding: S.keyValPadding
                    },
                    "pushed-content": {
                        marginLeft: S.pushedContentMarginLeft
                    },
                    variableValue: function(e, t) {
                        return {
                            style: s({
                                display: "inline-block",
                                paddingRight: S.variableValuePaddingRight,
                                position: "relative"
                            }, t)
                        };
                    },
                    "object-name": {
                        display: "inline-block",
                        color: t.keyColor,
                        letterSpacing: S.keyLetterSpacing,
                        fontStyle: S.keyFontStyle,
                        verticalAlign: S.keyVerticalAlign,
                        opacity: S.keyOpacity,
                        ":hover": {
                            opacity: S.keyOpacityHover
                        }
                    },
                    "array-key": {
                        display: "inline-block",
                        color: t.arrayKeyColor,
                        letterSpacing: S.keyLetterSpacing,
                        fontStyle: S.keyFontStyle,
                        verticalAlign: S.keyVerticalAlign,
                        opacity: S.keyOpacity,
                        ":hover": {
                            opacity: S.keyOpacityHover
                        }
                    },
                    "object-size": {
                        color: t.objectSize,
                        borderRadius: S.objectSizeBorderRadius,
                        fontStyle: S.objectSizeFontStyle,
                        margin: S.objectSizeMargin,
                        cursor: "default"
                    },
                    "data-type-label": {
                        fontSize: S.dataTypeFontSize,
                        marginRight: S.dataTypeMarginRight,
                        opacity: S.datatypeOpacity
                    },
                    boolean: {
                        display: "inline-block",
                        color: t.dataTypes.boolean
                    },
                    date: {
                        display: "inline-block",
                        color: t.dataTypes.date
                    },
                    "date-value": {
                        marginLeft: S.dateValueMarginLeft
                    },
                    float: {
                        display: "inline-block",
                        color: t.dataTypes.float
                    },
                    function: {
                        display: "inline-block",
                        color: t.dataTypes.function,
                        cursor: "pointer",
                        whiteSpace: "pre-line"
                    },
                    "function-value": {
                        fontStyle: "italic"
                    },
                    integer: {
                        display: "inline-block",
                        color: t.dataTypes.integer
                    },
                    bigNumber: {
                        display: "inline-block",
                        color: t.dataTypes.bigNumber
                    },
                    string: {
                        display: "inline-block",
                        color: t.dataTypes.string
                    },
                    nan: {
                        display: "inline-block",
                        color: t.dataTypes.nan,
                        fontSize: S.nanFontSize,
                        fontWeight: S.nanFontWeight,
                        backgroundColor: t.dataTypes.background,
                        padding: S.nanPadding,
                        borderRadius: S.nanBorderRadius
                    },
                    null: {
                        display: "inline-block",
                        color: t.dataTypes.null,
                        fontSize: S.nullFontSize,
                        fontWeight: S.nullFontWeight,
                        backgroundColor: t.dataTypes.background,
                        padding: S.nullPadding,
                        borderRadius: S.nullBorderRadius
                    },
                    undefined: {
                        display: "inline-block",
                        color: t.dataTypes.undefined,
                        fontSize: S.undefinedFontSize,
                        padding: S.undefinedPadding,
                        borderRadius: S.undefinedBorderRadius,
                        backgroundColor: t.dataTypes.background
                    },
                    regexp: {
                        display: "inline-block",
                        color: t.dataTypes.regexp
                    },
                    "copy-to-clipboard": {
                        cursor: S.clipboardCursor
                    },
                    "copy-icon": {
                        color: t.copyToClipboard,
                        fontSize: S.iconFontSize,
                        marginRight: S.iconMarginRight,
                        verticalAlign: "top"
                    },
                    "copy-icon-copied": {
                        color: t.copyToClipboardCheck,
                        marginLeft: S.clipboardCheckMarginLeft
                    },
                    "array-group-meta-data": {
                        display: "inline-block",
                        padding: S.arrayGroupMetaPadding
                    },
                    "object-meta-data": {
                        display: "inline-block",
                        padding: S.metaDataPadding
                    },
                    "icon-container": {
                        display: "inline-block",
                        width: S.iconContainerWidth
                    },
                    tooltip: {
                        padding: S.tooltipPadding
                    },
                    removeVarIcon: {
                        verticalAlign: "top",
                        display: "inline-block",
                        color: t.editVariable.removeIcon,
                        cursor: S.iconCursor,
                        fontSize: S.iconFontSize,
                        marginRight: S.iconMarginRight
                    },
                    addVarIcon: {
                        verticalAlign: "top",
                        display: "inline-block",
                        color: t.editVariable.addIcon,
                        cursor: S.iconCursor,
                        fontSize: S.iconFontSize,
                        marginRight: S.iconMarginRight
                    },
                    editVarIcon: {
                        verticalAlign: "top",
                        display: "inline-block",
                        color: t.editVariable.editIcon,
                        cursor: S.iconCursor,
                        fontSize: S.iconFontSize,
                        marginRight: S.iconMarginRight
                    },
                    "edit-icon-container": {
                        display: "inline-block",
                        verticalAlign: "top"
                    },
                    "check-icon": {
                        display: "inline-block",
                        cursor: S.iconCursor,
                        color: t.editVariable.checkIcon,
                        fontSize: S.iconFontSize,
                        paddingRight: S.iconPaddingRight
                    },
                    "cancel-icon": {
                        display: "inline-block",
                        cursor: S.iconCursor,
                        color: t.editVariable.cancelIcon,
                        fontSize: S.iconFontSize,
                        paddingRight: S.iconPaddingRight
                    },
                    "edit-input": {
                        display: "inline-block",
                        minWidth: S.editInputMinWidth,
                        borderRadius: S.editInputBorderRadius,
                        backgroundColor: t.editVariable.background,
                        color: t.editVariable.color,
                        padding: S.editInputPadding,
                        marginRight: S.editInputMarginRight,
                        fontFamily: S.editInputFontFamily
                    },
                    "detected-row": {
                        paddingTop: S.detectedRowPaddingTop
                    },
                    "key-modal-request": {
                        position: S.addKeyCoverPosition,
                        top: S.addKeyCoverPositionPx,
                        left: S.addKeyCoverPositionPx,
                        right: S.addKeyCoverPositionPx,
                        bottom: S.addKeyCoverPositionPx,
                        backgroundColor: S.addKeyCoverBackground
                    },
                    "key-modal": {
                        width: S.addKeyModalWidth,
                        backgroundColor: t.addKeyModal.background,
                        marginLeft: S.addKeyModalMargin,
                        marginRight: S.addKeyModalMargin,
                        padding: S.addKeyModalPadding,
                        borderRadius: S.addKeyModalRadius,
                        marginTop: "15px",
                        position: "relative"
                    },
                    "key-modal-label": {
                        color: t.addKeyModal.labelColor,
                        marginLeft: "2px",
                        marginBottom: "5px",
                        fontSize: "11px"
                    },
                    "key-modal-input-container": {
                        overflow: "hidden"
                    },
                    "key-modal-input": {
                        width: "100%",
                        padding: "3px 6px",
                        fontFamily: "monospace",
                        color: t.addKeyModal.color,
                        border: "none",
                        boxSizing: "border-box",
                        borderRadius: "2px"
                    },
                    "key-modal-cancel": {
                        backgroundColor: t.editVariable.removeIcon,
                        position: "absolute",
                        top: "0px",
                        right: "0px",
                        borderRadius: "0px 3px 0px 3px",
                        cursor: "pointer"
                    },
                    "key-modal-cancel-icon": {
                        color: t.addKeyModal.labelColor,
                        fontSize: S.iconFontSize,
                        transform: "rotate(45deg)"
                    },
                    "key-modal-submit": {
                        color: t.editVariable.addIcon,
                        fontSize: S.iconFontSize,
                        position: "absolute",
                        right: "2px",
                        top: "3px",
                        cursor: "pointer"
                    },
                    "function-ellipsis": {
                        display: "inline-block",
                        color: t.ellipsisColor,
                        fontSize: S.ellipsisFontSize,
                        lineHeight: S.ellipsisLineHeight,
                        cursor: S.ellipsisCursor
                    },
                    "validation-failure": {
                        float: "right",
                        padding: "3px 6px",
                        borderRadius: "2px",
                        cursor: "pointer",
                        color: t.validationFailure.fontColor,
                        backgroundColor: t.validationFailure.background
                    },
                    "validation-failure-label": {
                        marginRight: "6px"
                    },
                    "validation-failure-clear": {
                        position: "relative",
                        verticalAlign: "top",
                        cursor: "pointer",
                        color: t.validationFailure.iconColor,
                        fontSize: S.iconFontSize,
                        transform: "rotate(45deg)"
                    },
                    comma: {
                        display: "inline-block",
                        color: S.commaColor,
                        fontSize: S.commaFontSize,
                        marginRight: S.commaMarginRight,
                        cursor: "default"
                    }
                };
            };
            function G(e, t, a) {
                return e || console.error("theme has not been set"), (function(e) {
                    var t = O;
                    return !1 !== e && "none" !== e || (t = M), H(J, {
                        defaultBase16: t
                    })(e);
                })(e)(t, a);
            }
            var Q = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = (e.rjvId, e.type_name), a = e.displayDataTypes, r = e.theme;
                            return a ? v().createElement("span", Object.assign({
                                className: "data-type-label"
                            }, G(r, "data-type-label")), t) : null;
                        }
                    }
                ]);
            }(v().PureComponent), Z = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props;
                            return v().createElement("div", G(e.theme, "boolean"), v().createElement(Q, Object.assign({
                                type_name: "bool"
                            }, e)), e.value ? "true" : "false");
                        }
                    }
                ]);
            }(v().PureComponent), X = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props;
                            return v().createElement("div", G(e.theme, "date"), v().createElement(Q, Object.assign({
                                type_name: "date"
                            }, e)), v().createElement("span", Object.assign({
                                className: "date-value"
                            }, G(e.theme, "date-value")), e.value.toLocaleTimeString("en-us", {
                                weekday: "short",
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit"
                            })));
                        }
                    }
                ]);
            }(v().PureComponent), ee = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props;
                            return v().createElement("div", G(e.theme, "float"), v().createElement(Q, Object.assign({
                                type_name: "float"
                            }, e)), this.props.value);
                        }
                    }
                ]);
            }(v().PureComponent);
            function te(e) {
                return function(e) {
                    if (Array.isArray(e)) return _(e);
                }(e) || function(e) {
                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                }(e) || A(e) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            var ae = r(9784), re = function() {
                return c(function e() {
                    i(this, e), this.handler = function() {};
                }, [
                    {
                        key: "register",
                        value: function(e) {
                            this.handler = e;
                        }
                    },
                    {
                        key: "dispatch",
                        value: function(e) {
                            var t;
                            null === (t = this.handler) || void 0 === t || t.call(this, e);
                        }
                    }
                ]);
            }();
            globalThis.__globalDispatcherInstance || (globalThis.__globalDispatcherInstance = new re);
            const ne = globalThis.__globalDispatcherInstance;
            var oe = new (function(e) {
                function t() {
                    var e;
                    i(this, t);
                    for(var a = arguments.length, r = new Array(a), n = 0; n < a; n++)r[n] = arguments[n];
                    return (e = p(this, t, [].concat(r))).objects = {}, e.set = function(t, a, r, n) {
                        void 0 === e.objects[t] && (e.objects[t] = {}), void 0 === e.objects[t][a] && (e.objects[t][a] = {}), e.objects[t][a][r] = n;
                    }, e.get = function(t, a, r, n) {
                        return void 0 === e.objects[t] || void 0 === e.objects[t][a] || null == e.objects[t][a][r] ? n : e.objects[t][a][r];
                    }, e.handleAction = function(t) {
                        var a = t.rjvId, r = t.data;
                        switch(t.name){
                            case "RESET":
                                e.emit("reset-" + a);
                                break;
                            case "VARIABLE_UPDATED":
                                t.data.updated_src = e.updateSrc(a, r), e.set(a, "action", "variable-update", s(s({}, r), {}, {
                                    type: "variable-edited"
                                })), e.emit("variable-update-" + a);
                                break;
                            case "VARIABLE_REMOVED":
                                t.data.updated_src = e.updateSrc(a, r), e.set(a, "action", "variable-update", s(s({}, r), {}, {
                                    type: "variable-removed"
                                })), e.emit("variable-update-" + a);
                                break;
                            case "VARIABLE_ADDED":
                                t.data.updated_src = e.updateSrc(a, r), e.set(a, "action", "variable-update", s(s({}, r), {}, {
                                    type: "variable-added"
                                })), e.emit("variable-update-" + a);
                                break;
                            case "ADD_VARIABLE_KEY_REQUEST":
                                e.set(a, "action", "new-key-request", r), e.emit("add-key-request-" + a);
                        }
                    }, e.updateSrc = function(t, a) {
                        var r = a.name, n = a.namespace, o = a.new_value, s = (a.existing_value, a.variable_removed);
                        n.shift();
                        var i, l = e.get(t, "global", "src"), c = e.deepCopy(l, te(n)), u = c, d = function(e, t) {
                            var a = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                            if (!a) {
                                if (Array.isArray(e) || (a = A(e)) || t && e && "number" == typeof e.length) {
                                    a && (e = a);
                                    var r = 0, n = function() {};
                                    return {
                                        s: n,
                                        n: function() {
                                            return r >= e.length ? {
                                                done: !0
                                            } : {
                                                done: !1,
                                                value: e[r++]
                                            };
                                        },
                                        e: function(e) {
                                            throw e;
                                        },
                                        f: n
                                    };
                                }
                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }
                            var o, s = !0, i = !1;
                            return {
                                s: function() {
                                    a = a.call(e);
                                },
                                n: function() {
                                    var e = a.next();
                                    return s = e.done, e;
                                },
                                e: function(e) {
                                    i = !0, o = e;
                                },
                                f: function() {
                                    try {
                                        s || null == a.return || a.return();
                                    } finally{
                                        if (i) throw o;
                                    }
                                }
                            };
                        }(n);
                        try {
                            for(d.s(); !(i = d.n()).done;)u = u[i.value];
                        } catch (e) {
                            d.e(e);
                        } finally{
                            d.f();
                        }
                        return s ? "array" == x(u) ? u.splice(r, 1) : delete u[r] : null !== r ? u[r] = o : c = o, e.set(t, "global", "src", c), c;
                    }, e.deepCopy = function(t, a) {
                        var r, n = x(t), o = a.shift();
                        return "array" == n ? r = te(t) : "object" == n && (r = s({}, t)), void 0 !== o && (r[o] = e.deepCopy(t[o], a)), r;
                    }, e;
                }
                return h(t, e), c(t);
            }(ae.EventEmitter));
            ne.register(oe.handleAction.bind(oe));
            const se = oe;
            var ie = function(e) {
                function t(e) {
                    var a;
                    return i(this, t), (a = p(this, t, [
                        e
                    ])).toggleCollapsed = function() {
                        a.setState({
                            collapsed: !a.state.collapsed
                        }, function() {
                            se.set(a.props.rjvId, a.props.namespace, "collapsed", a.state.collapsed);
                        });
                    }, a.getFunctionDisplay = function(e) {
                        var t = a.props;
                        return e ? v().createElement("span", null, a.props.value.toString().slice(9, -1).replace(/\{[\s\S]+/, ""), v().createElement("span", {
                            className: "function-collapsed",
                            style: {
                                fontWeight: "bold"
                            }
                        }, v().createElement("span", null, "{"), v().createElement("span", G(t.theme, "ellipsis"), "..."), v().createElement("span", null, "}"))) : a.props.value.toString().slice(9, -1);
                    }, a.state = {
                        collapsed: se.get(e.rjvId, e.namespace, "collapsed", !0)
                    }, a;
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = this.state.collapsed;
                            return v().createElement("div", G(e.theme, "function"), v().createElement(Q, Object.assign({
                                type_name: "function"
                            }, e)), v().createElement("span", Object.assign({}, G(e.theme, "function-value"), {
                                className: "rjv-function-container",
                                onClick: this.toggleCollapsed
                            }), this.getFunctionDisplay(t)));
                        }
                    }
                ]);
            }(v().PureComponent), le = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            return v().createElement("div", G(this.props.theme, "nan"), "NaN");
                        }
                    }
                ]);
            }(v().PureComponent), ce = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            return v().createElement("div", G(this.props.theme, "null"), "NULL");
                        }
                    }
                ]);
            }(v().PureComponent), ue = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props;
                            return v().createElement("div", G(e.theme, "integer"), v().createElement(Q, Object.assign({
                                type_name: "int"
                            }, e)), this.props.value);
                        }
                    }
                ]);
            }(v().PureComponent), de = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props;
                            return v().createElement("div", G(e.theme, "regexp"), v().createElement(Q, Object.assign({
                                type_name: "regexp"
                            }, e)), this.props.value.toString());
                        }
                    }
                ]);
            }(v().PureComponent), be = function(e) {
                function t(e) {
                    var a;
                    return i(this, t), (a = p(this, t, [
                        e
                    ])).toggleCollapsed = function() {
                        a.setState({
                            collapsed: !a.state.collapsed
                        }, function() {
                            se.set(a.props.rjvId, a.props.namespace, "collapsed", a.state.collapsed);
                        });
                    }, a.state = {
                        collapsed: se.get(e.rjvId, e.namespace, "collapsed", !0)
                    }, a;
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.state.collapsed, t = this.props, a = t.collapseStringsAfterLength, r = t.theme, n = t.escapeStrings, o = t.value, s = "integer" === x(a), i = {
                                style: {
                                    cursor: "default",
                                    wordBreak: "break-all"
                                }
                            };
                            return n && (o = C(o)), s && o.length > a && (i.style.cursor = "pointer", e && (o = v().createElement("span", null, o.substring(0, a), v().createElement("span", G(r, "ellipsis"), " ...")))), v().createElement("div", G(r, "string"), v().createElement(Q, Object.assign({
                                type_name: "string"
                            }, t)), v().createElement("span", Object.assign({
                                className: "string-value"
                            }, i, {
                                onClick: this.toggleCollapsed
                            }), '"', o, '"'));
                        }
                    }
                ]);
            }(v().PureComponent), pe = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            return v().createElement("div", G(this.props.theme, "undefined"), "undefined");
                        }
                    }
                ]);
            }(v().PureComponent), fe = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props;
                            return v().createElement("div", G(e.theme, "bigNumber"), v().createElement(Q, Object.assign({
                                type_name: "bigNumber"
                            }, e)), this.props.value.toString());
                        }
                    }
                ]);
            }(v().PureComponent);
            function he() {
                return he = Object.assign ? Object.assign.bind() : function(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var a = arguments[t];
                        for(var r in a)({}).hasOwnProperty.call(a, r) && (e[r] = a[r]);
                    }
                    return e;
                }, he.apply(null, arguments);
            }
            const me = m.useLayoutEffect;
            var ve = function(e, t) {
                "function" != typeof e ? e.current = t : e(t);
            };
            const ge = function(e, t) {
                var a = (0, m.useRef)();
                return (0, m.useCallback)(function(r) {
                    e.current = r, a.current && ve(a.current, null), a.current = t, t && ve(t, r);
                }, [
                    t
                ]);
            };
            var ye = {
                "min-height": "0",
                "max-height": "none",
                height: "0",
                visibility: "hidden",
                overflow: "hidden",
                position: "absolute",
                "z-index": "-1000",
                top: "0",
                right: "0",
                display: "block"
            }, ke = function(e) {
                Object.keys(ye).forEach(function(t) {
                    e.style.setProperty(t, ye[t], "important");
                });
            }, Ee = null, we = function(e, t) {
                var a = e.scrollHeight;
                return "border-box" === t.sizingStyle.boxSizing ? a + t.borderSize : a - t.paddingSize;
            };
            var je = function() {}, xe = [
                "borderBottomWidth",
                "borderLeftWidth",
                "borderRightWidth",
                "borderTopWidth",
                "boxSizing",
                "fontFamily",
                "fontSize",
                "fontStyle",
                "fontWeight",
                "letterSpacing",
                "lineHeight",
                "paddingBottom",
                "paddingLeft",
                "paddingRight",
                "paddingTop",
                "tabSize",
                "textIndent",
                "textRendering",
                "textTransform",
                "width",
                "wordBreak",
                "wordSpacing",
                "scrollbarGutter"
            ], Ce = !!document.documentElement.currentStyle, Oe = function(e) {
                var t = window.getComputedStyle(e);
                if (null === t) return null;
                var a, r = (a = t, xe.reduce(function(e, t) {
                    return e[t] = a[t], e;
                }, {})), n = r.boxSizing;
                return "" === n ? null : (Ce && "border-box" === n && (r.width = parseFloat(r.width) + parseFloat(r.borderRightWidth) + parseFloat(r.borderLeftWidth) + parseFloat(r.paddingRight) + parseFloat(r.paddingLeft) + "px"), {
                    sizingStyle: r,
                    paddingSize: parseFloat(r.paddingBottom) + parseFloat(r.paddingTop),
                    borderSize: parseFloat(r.borderBottomWidth) + parseFloat(r.borderTopWidth)
                });
            };
            function Me(e, t, a) {
                var r, n, o = (r = a, n = m.useRef(r), me(function() {
                    n.current = r;
                }), n);
                m.useLayoutEffect(function() {
                    var a = function(e) {
                        return o.current(e);
                    };
                    if (e) return e.addEventListener(t, a), function() {
                        return e.removeEventListener(t, a);
                    };
                }, []);
            }
            var Se = [
                "cacheMeasurements",
                "maxRows",
                "minRows",
                "onChange",
                "onHeightChange"
            ], _e = function(e, t) {
                var a = e.cacheMeasurements, r = e.maxRows, n = e.minRows, o = e.onChange, s = void 0 === o ? je : o, i = e.onHeightChange, l = void 0 === i ? je : i, c = w(e, Se), u = void 0 !== c.value, d = m.useRef(null), b = ge(d, t), p = m.useRef(0), f = m.useRef(), h = function() {
                    var e = d.current, t = a && f.current ? f.current : Oe(e);
                    if (t) {
                        f.current = t;
                        var o = function(e, t, a, r) {
                            void 0 === a && (a = 1), void 0 === r && (r = 1 / 0), Ee || ((Ee = document.createElement("textarea")).setAttribute("tabindex", "-1"), Ee.setAttribute("aria-hidden", "true"), ke(Ee)), null === Ee.parentNode && document.body.appendChild(Ee);
                            var n = e.paddingSize, o = e.borderSize, s = e.sizingStyle, i = s.boxSizing;
                            Object.keys(s).forEach(function(e) {
                                var t = e;
                                Ee.style[t] = s[t];
                            }), ke(Ee), Ee.value = t;
                            var l = we(Ee, e);
                            Ee.value = t, l = we(Ee, e), Ee.value = "x";
                            var c = Ee.scrollHeight - n, u = c * a;
                            "border-box" === i && (u = u + n + o), l = Math.max(u, l);
                            var d = c * r;
                            return "border-box" === i && (d = d + n + o), [
                                l = Math.min(d, l),
                                c
                            ];
                        }(t, e.value || e.placeholder || "x", n, r), s = o[0], i = o[1];
                        p.current !== s && (p.current = s, e.style.setProperty("height", s + "px", "important"), l(s, {
                            rowHeight: i
                        }));
                    }
                };
                return m.useLayoutEffect(h), function(e, t) {
                    Me(document.body, "reset", function(a) {
                        e.current.form === a.target && t(a);
                    });
                }(d, function() {
                    if (!u) {
                        var e = d.current.value;
                        requestAnimationFrame(function() {
                            var t = d.current;
                            t && e !== t.value && h();
                        });
                    }
                }), Me(window, "resize", h), function(e) {
                    Me(document.fonts, "loadingdone", e);
                }(h), m.createElement("textarea", he({}, c, {
                    onChange: function(e) {
                        u || h(), s(e);
                    },
                    ref: b
                }));
            }, Ae = m.forwardRef(_e);
            function Fe(e, t) {
                e = e.trim();
                try {
                    if ("[" === (e = structuredClone(e))[0]) return Pe("array", JSON.parse(e));
                    if ("{" === e[0]) return Pe("object", JSON.parse(e));
                    if (e.match(/\-?\d+\.\d+/) && e.match(/\-?\d+\.\d+/)[0] === e) return t && parseFloat(e).toString() !== e ? Pe("bigNumber", e) : Pe("float", parseFloat(e));
                    if (e.match(/\-?\d+e-\d+/) && e.match(/\-?\d+e-\d+/)[0] === e) return Pe("float", Number(e));
                    if (e.match(/\-?\d+/) && e.match(/\-?\d+/)[0] === e) return t && parseInt(e).toString() !== e ? Pe("bigNumber", e) : Pe("integer", parseInt(e));
                    if (e.match(/\-?\d+e\+\d+/) && e.match(/\-?\d+e\+\d+/)[0] === e) return Pe("integer", Number(e));
                } catch (e) {}
                switch(e = e.toLowerCase()){
                    case "undefined":
                        return Pe("undefined", void 0);
                    case "nan":
                        return Pe("nan", NaN);
                    case "null":
                        return Pe("null", null);
                    case "true":
                        return Pe("boolean", !0);
                    case "false":
                        return Pe("boolean", !1);
                    default:
                        if (e = Date.parse(e)) return Pe("date", new Date(e));
                }
                return Pe(!1, null);
            }
            function Pe(e, t) {
                return {
                    type: e,
                    value: t
                };
            }
            var Re = [
                "style"
            ], De = [
                "style"
            ], Ie = [
                "style"
            ], ze = [
                "style"
            ], Be = [
                "style"
            ], Ne = [
                "style"
            ], Le = [
                "style"
            ], qe = [
                "style"
            ], Ve = [
                "style"
            ], Te = [
                "style"
            ], Ke = [
                "style"
            ], We = [
                "style"
            ], Ue = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = e.style, a = j(e, Re);
                            return v().createElement("span", a, v().createElement("svg", Object.assign({}, rt(t), {
                                viewBox: "0 0 24 24",
                                fill: "currentColor",
                                preserveAspectRatio: "xMidYMid meet"
                            }), v().createElement("path", {
                                d: "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,13H17V11H7"
                            })));
                        }
                    }
                ]);
            }(v().PureComponent), He = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = e.style, a = j(e, De);
                            return v().createElement("span", a, v().createElement("svg", Object.assign({}, rt(t), {
                                viewBox: "0 0 24 24",
                                fill: "currentColor",
                                preserveAspectRatio: "xMidYMid meet"
                            }), v().createElement("path", {
                                d: "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z"
                            })));
                        }
                    }
                ]);
            }(v().PureComponent), $e = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = e.style, a = j(e, Ie), r = rt(t).style;
                            return v().createElement("span", a, v().createElement("svg", {
                                fill: r.color,
                                width: r.height,
                                height: r.width,
                                style: r,
                                viewBox: "0 0 1792 1792"
                            }, v().createElement("path", {
                                d: "M1344 800v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h832q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"
                            })));
                        }
                    }
                ]);
            }(v().PureComponent), Ye = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = e.style, a = j(e, ze), r = rt(t).style;
                            return v().createElement("span", a, v().createElement("svg", {
                                fill: r.color,
                                width: r.height,
                                height: r.width,
                                style: r,
                                viewBox: "0 0 1792 1792"
                            }, v().createElement("path", {
                                d: "M1344 800v64q0 14-9 23t-23 9h-352v352q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-352h-352q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-352q0-14 9-23t23-9h64q14 0 23 9t9 23v352h352q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"
                            })));
                        }
                    }
                ]);
            }(v().PureComponent), Je = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = e.style, a = j(e, Be);
                            return v().createElement("span", a, v().createElement("svg", {
                                style: s(s({}, rt(t).style), {}, {
                                    paddingLeft: "2px",
                                    verticalAlign: "top"
                                }),
                                viewBox: "0 0 15 15",
                                fill: "currentColor"
                            }, v().createElement("path", {
                                d: "M0 14l6-6-6-6z"
                            })));
                        }
                    }
                ]);
            }(v().PureComponent), Ge = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = e.style, a = j(e, Ne);
                            return v().createElement("span", a, v().createElement("svg", {
                                style: s(s({}, rt(t).style), {}, {
                                    paddingLeft: "2px",
                                    verticalAlign: "top"
                                }),
                                viewBox: "0 0 15 15",
                                fill: "currentColor"
                            }, v().createElement("path", {
                                d: "M0 5l6 6 6-6z"
                            })));
                        }
                    }
                ]);
            }(v().PureComponent), Qe = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = e.style, a = j(e, Le);
                            return v().createElement("span", a, v().createElement("svg", Object.assign({}, rt(t), {
                                viewBox: "0 0 40 40",
                                fill: "currentColor",
                                preserveAspectRatio: "xMidYMid meet"
                            }), v().createElement("g", null, v().createElement("path", {
                                d: "m30 35h-25v-22.5h25v7.5h2.5v-12.5c0-1.4-1.1-2.5-2.5-2.5h-7.5c0-2.8-2.2-5-5-5s-5 2.2-5 5h-7.5c-1.4 0-2.5 1.1-2.5 2.5v27.5c0 1.4 1.1 2.5 2.5 2.5h25c1.4 0 2.5-1.1 2.5-2.5v-5h-2.5v5z m-20-27.5h2.5s2.5-1.1 2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5 1.3 2.5 2.5 2.5h2.5s2.5 1.1 2.5 2.5h-20c0-1.5 1.1-2.5 2.5-2.5z m-2.5 20h5v-2.5h-5v2.5z m17.5-5v-5l-10 7.5 10 7.5v-5h12.5v-5h-12.5z m-17.5 10h7.5v-2.5h-7.5v2.5z m12.5-17.5h-12.5v2.5h12.5v-2.5z m-7.5 5h-5v2.5h5v-2.5z"
                            }))));
                        }
                    }
                ]);
            }(v().PureComponent), Ze = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = e.style, a = j(e, qe);
                            return v().createElement("span", a, v().createElement("svg", Object.assign({}, rt(t), {
                                viewBox: "0 0 40 40",
                                fill: "currentColor",
                                preserveAspectRatio: "xMidYMid meet"
                            }), v().createElement("g", null, v().createElement("path", {
                                d: "m28.6 25q0-0.5-0.4-1l-4-4 4-4q0.4-0.5 0.4-1 0-0.6-0.4-1.1l-2-2q-0.4-0.4-1-0.4-0.6 0-1 0.4l-4.1 4.1-4-4.1q-0.4-0.4-1-0.4-0.6 0-1 0.4l-2 2q-0.5 0.5-0.5 1.1 0 0.5 0.5 1l4 4-4 4q-0.5 0.5-0.5 1 0 0.7 0.5 1.1l2 2q0.4 0.4 1 0.4 0.6 0 1-0.4l4-4.1 4.1 4.1q0.4 0.4 1 0.4 0.6 0 1-0.4l2-2q0.4-0.4 0.4-1z m8.7-5q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"
                            }))));
                        }
                    }
                ]);
            }(v().PureComponent), Xe = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = e.style, a = j(e, Ve);
                            return v().createElement("span", a, v().createElement("svg", Object.assign({}, rt(t), {
                                viewBox: "0 0 40 40",
                                fill: "currentColor",
                                preserveAspectRatio: "xMidYMid meet"
                            }), v().createElement("g", null, v().createElement("path", {
                                d: "m30.1 21.4v-2.8q0-0.6-0.4-1t-1-0.5h-5.7v-5.7q0-0.6-0.4-1t-1-0.4h-2.9q-0.6 0-1 0.4t-0.4 1v5.7h-5.7q-0.6 0-1 0.5t-0.5 1v2.8q0 0.6 0.5 1t1 0.5h5.7v5.7q0 0.5 0.4 1t1 0.4h2.9q0.6 0 1-0.4t0.4-1v-5.7h5.7q0.6 0 1-0.5t0.4-1z m7.2-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"
                            }))));
                        }
                    }
                ]);
            }(v().PureComponent), et = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = e.style, a = j(e, Te);
                            return v().createElement("span", a, v().createElement("svg", Object.assign({}, rt(t), {
                                viewBox: "0 0 40 40",
                                fill: "currentColor",
                                preserveAspectRatio: "xMidYMid meet"
                            }), v().createElement("g", null, v().createElement("path", {
                                d: "m31.6 21.6h-10v10h-3.2v-10h-10v-3.2h10v-10h3.2v10h10v3.2z"
                            }))));
                        }
                    }
                ]);
            }(v().PureComponent), tt = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = e.style, a = j(e, Ke);
                            return v().createElement("span", a, v().createElement("svg", Object.assign({}, rt(t), {
                                viewBox: "0 0 40 40",
                                fill: "currentColor",
                                preserveAspectRatio: "xMidYMid meet"
                            }), v().createElement("g", null, v().createElement("path", {
                                d: "m19.8 26.4l2.6-2.6-3.4-3.4-2.6 2.6v1.3h2.2v2.1h1.2z m9.8-16q-0.3-0.4-0.7 0l-7.8 7.8q-0.4 0.4 0 0.7t0.7 0l7.8-7.8q0.4-0.4 0-0.7z m1.8 13.2v4.3q0 2.6-1.9 4.5t-4.5 1.9h-18.6q-2.6 0-4.5-1.9t-1.9-4.5v-18.6q0-2.7 1.9-4.6t4.5-1.8h18.6q1.4 0 2.6 0.5 0.3 0.2 0.4 0.5 0.1 0.4-0.2 0.7l-1.1 1.1q-0.3 0.3-0.7 0.1-0.5-0.1-1-0.1h-18.6q-1.4 0-2.5 1.1t-1 2.5v18.6q0 1.4 1 2.5t2.5 1h18.6q1.5 0 2.5-1t1.1-2.5v-2.9q0-0.2 0.2-0.4l1.4-1.5q0.3-0.3 0.8-0.1t0.4 0.6z m-2.1-16.5l6.4 6.5-15 15h-6.4v-6.5z m9.9 3l-2.1 2-6.4-6.4 2.1-2q0.6-0.7 1.5-0.7t1.5 0.7l3.4 3.4q0.6 0.6 0.6 1.5t-0.6 1.5z"
                            }))));
                        }
                    }
                ]);
            }(v().PureComponent), at = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = e.style, a = j(e, We);
                            return v().createElement("span", a, v().createElement("svg", Object.assign({}, rt(t), {
                                viewBox: "0 0 40 40",
                                fill: "currentColor",
                                preserveAspectRatio: "xMidYMid meet"
                            }), v().createElement("g", null, v().createElement("path", {
                                d: "m31.7 16.4q0-0.6-0.4-1l-2.1-2.1q-0.4-0.4-1-0.4t-1 0.4l-9.1 9.1-5-5q-0.5-0.4-1-0.4t-1 0.4l-2.1 2q-0.4 0.4-0.4 1 0 0.6 0.4 1l8.1 8.1q0.4 0.4 1 0.4 0.6 0 1-0.4l12.2-12.1q0.4-0.4 0.4-1z m5.6 3.6q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"
                            }))));
                        }
                    }
                ]);
            }(v().PureComponent);
            function rt(e) {
                return e || (e = {}), {
                    style: s(s({
                        verticalAlign: "middle"
                    }, e), {}, {
                        color: e.color ? e.color : "#000000",
                        height: "1em",
                        width: "1em"
                    })
                };
            }
            var nt = function(e) {
                function t(e) {
                    var a;
                    return i(this, t), (a = p(this, t, [
                        e
                    ])).copiedTimer = null, a.copyToClipboardFallback = function(e) {
                        var t = document.createElement("textarea");
                        t.value = e, document.body.appendChild(t), t.select(), document.execCommand("copy"), document.body.removeChild(t);
                    }, a.handleCopy = function() {
                        var e = a.props, t = e.clickCallback, r = e.src, n = e.namespace, o = JSON.stringify(a.clipboardValue(r), null, "  ");
                        navigator.clipboard ? navigator.clipboard.writeText(o).catch(function() {
                            a.copyToClipboardFallback(o);
                        }) : a.copyToClipboardFallback(o), a.copiedTimer = setTimeout(function() {
                            a.setState({
                                copied: !1
                            });
                        }, 5500), a.setState({
                            copied: !0
                        }, function() {
                            "function" == typeof t && t({
                                src: r,
                                namespace: n,
                                name: n[n.length - 1]
                            });
                        });
                    }, a.getClippyIcon = function() {
                        var e = a.props.theme;
                        return a.state.copied ? v().createElement("span", null, v().createElement(Qe, Object.assign({
                            className: "copy-icon"
                        }, G(e, "copy-icon"))), v().createElement("span", G(e, "copy-icon-copied"), "\u2714")) : v().createElement(Qe, Object.assign({
                            className: "copy-icon"
                        }, G(e, "copy-icon")));
                    }, a.clipboardValue = function(e) {
                        switch(x(e)){
                            case "function":
                            case "regexp":
                                return e.toString();
                            default:
                                return e;
                        }
                    }, a.state = {
                        copied: !1
                    }, a;
                }
                return h(t, e), c(t, [
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.copiedTimer && (clearTimeout(this.copiedTimer), this.copiedTimer = null);
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = (e.src, e.theme), a = e.hidden, r = e.rowHovered, n = G(t, "copy-to-clipboard").style, o = "inline";
                            return a && (o = "none"), v().createElement("span", {
                                className: "copy-to-clipboard-container",
                                title: "Copy to clipboard",
                                style: {
                                    verticalAlign: "top",
                                    display: r ? "inline-block" : "none"
                                }
                            }, v().createElement("span", {
                                style: s(s({}, n), {}, {
                                    display: o
                                }),
                                onClick: this.handleCopy
                            }, this.getClippyIcon()));
                        }
                    }
                ]);
            }(v().PureComponent);
            const ot = function(e) {
                function t(e) {
                    var a;
                    return i(this, t), (a = p(this, t, [
                        e
                    ])).getEditIcon = function() {
                        var e = a.props, t = e.variable, r = e.theme;
                        return v().createElement("div", {
                            className: "click-to-edit",
                            style: {
                                verticalAlign: "top",
                                display: a.state.hovered ? "inline-block" : "none"
                            }
                        }, v().createElement(tt, Object.assign({
                            className: "click-to-edit-icon"
                        }, G(r, "editVarIcon"), {
                            onClick: function() {
                                a.prepopInput(t);
                            }
                        })));
                    }, a.prepopInput = function(e) {
                        if (!1 !== a.props.onEdit) {
                            var t = function(e, t) {
                                var a;
                                switch(x(e, t)){
                                    case "undefined":
                                        a = "undefined";
                                        break;
                                    case "nan":
                                        a = "NaN";
                                        break;
                                    case "string":
                                        a = e;
                                        break;
                                    case "bigNumber":
                                    case "date":
                                    case "function":
                                    case "regexp":
                                        a = e.toString();
                                        break;
                                    default:
                                        try {
                                            a = JSON.stringify(e, null, "  ");
                                        } catch (e) {
                                            a = "";
                                        }
                                }
                                return a;
                            }(e.value, a.props.bigNumber), r = Fe(t, a.props.bigNumber);
                            a.setState({
                                editMode: !0,
                                editValue: t,
                                parsedInput: {
                                    type: r.type,
                                    value: r.value
                                }
                            });
                        }
                    }, a.getRemoveIcon = function() {
                        var e = a.props, t = e.variable, r = e.namespace, n = e.theme, o = e.rjvId;
                        return v().createElement("div", {
                            className: "click-to-remove",
                            style: {
                                verticalAlign: "top",
                                display: a.state.hovered ? "inline-block" : "none"
                            }
                        }, v().createElement(Ze, Object.assign({
                            className: "click-to-remove-icon"
                        }, G(n, "removeVarIcon"), {
                            onClick: function() {
                                ne.dispatch({
                                    name: "VARIABLE_REMOVED",
                                    rjvId: o,
                                    data: {
                                        name: t.name,
                                        namespace: r,
                                        existing_value: t.value,
                                        variable_removed: !0
                                    }
                                });
                            }
                        })));
                    }, a.getValue = function(e, t) {
                        var r = !t && e.type, n = a.props;
                        switch(r){
                            case !1:
                                return a.getEditInput();
                            case "string":
                                return v().createElement(be, Object.assign({
                                    value: e.value
                                }, n));
                            case "integer":
                                return v().createElement(ue, Object.assign({
                                    value: e.value
                                }, n));
                            case "float":
                                return v().createElement(ee, Object.assign({
                                    value: e.value
                                }, n));
                            case "boolean":
                                return v().createElement(Z, Object.assign({
                                    value: e.value
                                }, n));
                            case "function":
                                return v().createElement(ie, Object.assign({
                                    value: e.value
                                }, n));
                            case "null":
                                return v().createElement(ce, n);
                            case "nan":
                                return v().createElement(le, n);
                            case "undefined":
                                return v().createElement(pe, n);
                            case "date":
                                return v().createElement(X, Object.assign({
                                    value: e.value
                                }, n));
                            case "regexp":
                                return v().createElement(de, Object.assign({
                                    value: e.value
                                }, n));
                            case "bigNumber":
                                return v().createElement(fe, Object.assign({
                                    value: e.value
                                }, n));
                            default:
                                return v().createElement("div", {
                                    className: "object-value"
                                }, JSON.stringify(e.value));
                        }
                    }, a.getEditInput = function() {
                        var e = a.props, t = e.keyModifier, r = e.selectOnFocus, n = e.theme, o = a.state.editValue;
                        return v().createElement("div", null, v().createElement(Ae, Object.assign({
                            type: "text",
                            ref: function(e) {
                                e && e[r ? "select" : "focus"]();
                            },
                            value: o,
                            className: "variable-editor",
                            onChange: function(e) {
                                var t = e.target.value, r = Fe(t, a.props.bigNumber);
                                a.setState({
                                    editValue: t,
                                    parsedInput: {
                                        type: r.type,
                                        value: r.value
                                    }
                                });
                            },
                            onKeyDown: function(e) {
                                switch(e.key){
                                    case "Escape":
                                        a.setState({
                                            editMode: !1,
                                            editValue: ""
                                        });
                                        break;
                                    case "Enter":
                                        t(e, "submit") && a.submitEdit(!0);
                                }
                                e.stopPropagation();
                            },
                            placeholder: "update this value",
                            minRows: 2
                        }, G(n, "edit-input"))), v().createElement("div", G(n, "edit-icon-container"), v().createElement(Ze, Object.assign({
                            className: "edit-cancel"
                        }, G(n, "cancel-icon"), {
                            onClick: function(e) {
                                e && e.stopPropagation(), a.setState({
                                    editMode: !1,
                                    editValue: ""
                                });
                            }
                        })), v().createElement(at, Object.assign({
                            className: "edit-check string-value"
                        }, G(n, "check-icon"), {
                            onClick: function(e) {
                                e && e.stopPropagation(), a.submitEdit();
                            }
                        })), v().createElement("div", null, a.showDetected())));
                    }, a.submitEdit = function(e) {
                        var t = a.props, r = t.variable, n = t.namespace, o = t.rjvId, s = t.bigNumber, i = a.state, l = i.editValue, c = i.parsedInput, u = l;
                        e && c.type && (u = c.value, s && "bigNumber" === c.type && (u = new s(u))), a.setState({
                            editMode: !1
                        }), ne.dispatch({
                            name: "VARIABLE_UPDATED",
                            rjvId: o,
                            data: {
                                name: r.name,
                                namespace: n,
                                existing_value: r.value,
                                new_value: u,
                                variable_removed: !1
                            }
                        });
                    }, a.showDetected = function() {
                        var e = a.props, t = e.theme, r = (e.variable, e.namespace, e.rjvId, a.state.parsedInput), n = (r.type, r.value, a.getDetectedInput());
                        if (n) return v().createElement("div", null, v().createElement("div", G(t, "detected-row"), n, v().createElement(at, {
                            className: "edit-check detected",
                            style: s({
                                verticalAlign: "top",
                                paddingLeft: "3px"
                            }, G(t, "check-icon").style),
                            onClick: function(e) {
                                e && e.stopPropagation(), a.submitEdit(!0);
                            }
                        })));
                    }, a.getDetectedInput = function() {
                        var e = a.state.parsedInput, t = e.type, r = e.value, n = a.props, o = n.theme;
                        if (!1 !== t) switch(t.toLowerCase()){
                            case "object":
                                return v().createElement("span", null, v().createElement("span", {
                                    style: s(s({}, G(o, "brace").style), {}, {
                                        cursor: "default"
                                    })
                                }, "{"), v().createElement("span", {
                                    style: s(s({}, G(o, "ellipsis").style), {}, {
                                        cursor: "default"
                                    })
                                }, "..."), v().createElement("span", {
                                    style: s(s({}, G(o, "brace").style), {}, {
                                        cursor: "default"
                                    })
                                }, "}"));
                            case "array":
                                return v().createElement("span", null, v().createElement("span", {
                                    style: s(s({}, G(o, "brace").style), {}, {
                                        cursor: "default"
                                    })
                                }, "["), v().createElement("span", {
                                    style: s(s({}, G(o, "ellipsis").style), {}, {
                                        cursor: "default"
                                    })
                                }, "..."), v().createElement("span", {
                                    style: s(s({}, G(o, "brace").style), {}, {
                                        cursor: "default"
                                    })
                                }, "]"));
                            case "string":
                                return v().createElement(be, Object.assign({
                                    value: r
                                }, n));
                            case "integer":
                                return v().createElement(ue, Object.assign({
                                    value: r
                                }, n));
                            case "float":
                                return v().createElement(ee, Object.assign({
                                    value: r
                                }, n));
                            case "boolean":
                                return v().createElement(Z, Object.assign({
                                    value: r
                                }, n));
                            case "function":
                                return v().createElement(ie, Object.assign({
                                    value: r
                                }, n));
                            case "null":
                                return v().createElement(ce, n);
                            case "nan":
                                return v().createElement(le, n);
                            case "undefined":
                                return v().createElement(pe, n);
                            case "date":
                                return v().createElement(X, Object.assign({
                                    value: new Date(r)
                                }, n));
                            case "bignumber":
                                return v().createElement(fe, Object.assign({
                                    value: r
                                }, n));
                        }
                    }, a.state = {
                        editMode: !1,
                        editValue: "",
                        hovered: !1,
                        renameKey: !1,
                        parsedInput: {
                            type: !1,
                            value: null
                        }
                    }, a;
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this, t = this.props, a = t.variable, r = t.singleIndent, n = t.type, o = t.theme, i = t.namespace, l = t.indentWidth, c = t.enableClipboard, u = t.onEdit, d = t.onDelete, b = t.onSelect, p = t.displayArrayKey, f = t.quotesOnKeys, h = t.keyModifier, m = t.showComma, g = t.isLast, y = this.state.editMode;
                            return v().createElement("div", Object.assign({}, G(o, "objectKeyVal", {
                                paddingLeft: l * r
                            }), {
                                onMouseEnter: function() {
                                    return e.setState(s(s({}, e.state), {}, {
                                        hovered: !0
                                    }));
                                },
                                onMouseLeave: function() {
                                    return e.setState(s(s({}, e.state), {}, {
                                        hovered: !1
                                    }));
                                },
                                className: "variable-row",
                                key: a.name
                            }), "array" == n ? p ? v().createElement("span", Object.assign({}, G(o, "array-key"), {
                                key: a.name + "_" + i
                            }), a.name, v().createElement("div", G(o, "colon"), ":")) : null : v().createElement("span", null, v().createElement("span", Object.assign({}, G(o, "object-name"), {
                                className: "object-key",
                                key: a.name + "_" + i
                            }), !!f && v().createElement("span", {
                                style: {
                                    verticalAlign: "top"
                                }
                            }, '"'), v().createElement("span", {
                                style: {
                                    display: "inline-block"
                                }
                            }, C(a.name)), !!f && v().createElement("span", {
                                style: {
                                    verticalAlign: "top"
                                }
                            }, '"')), v().createElement("span", G(o, "colon"), ":")), v().createElement("div", Object.assign({
                                className: "variable-value",
                                onClick: !1 === b && !1 === u ? null : function(t) {
                                    var r = te(i);
                                    h(t, "edit") && !1 !== u ? e.prepopInput(a) : !1 !== b && (r.shift(), b(s(s({}, a), {}, {
                                        namespace: r
                                    })));
                                }
                            }, G(o, "variableValue", {
                                cursor: !1 === b ? "default" : "pointer"
                            })), this.getValue(a, y)), m && !g && v().createElement("span", G(o, "comma"), ","), c ? v().createElement(nt, {
                                rowHovered: this.state.hovered,
                                hidden: y,
                                src: a.value,
                                clickCallback: c,
                                theme: o,
                                namespace: [].concat(te(i), [
                                    a.name
                                ])
                            }) : null, !1 !== u && 0 == y ? this.getEditIcon() : null, !1 !== d && 0 == y ? this.getRemoveIcon() : null);
                        }
                    }
                ]);
            }(v().PureComponent);
            var st = function(e) {
                function t() {
                    var e;
                    i(this, t);
                    for(var a = arguments.length, r = new Array(a), n = 0; n < a; n++)r[n] = arguments[n];
                    return (e = p(this, t, [].concat(r))).getObjectSize = function() {
                        var t = e.props, a = t.size, r = t.theme;
                        if (t.displayObjectSize) return v().createElement("span", Object.assign({
                            className: "object-size"
                        }, G(r, "object-size")), a, " item", 1 === a ? "" : "s");
                    }, e.getAddAttribute = function(t) {
                        var a = e.props, r = a.theme, n = a.namespace, o = a.name, i = a.src, l = a.rjvId, c = a.depth;
                        return v().createElement("span", {
                            className: "click-to-add",
                            style: {
                                verticalAlign: "top",
                                display: t ? "inline-block" : "none"
                            }
                        }, v().createElement(Xe, Object.assign({
                            className: "click-to-add-icon"
                        }, G(r, "addVarIcon"), {
                            onClick: function() {
                                var e = {
                                    name: c > 0 ? o : null,
                                    namespace: n.splice(0, n.length - 1),
                                    existing_value: i,
                                    variable_removed: !1,
                                    key_name: null
                                };
                                "object" === x(i) ? ne.dispatch({
                                    name: "ADD_VARIABLE_KEY_REQUEST",
                                    rjvId: l,
                                    data: e
                                }) : ne.dispatch({
                                    name: "VARIABLE_ADDED",
                                    rjvId: l,
                                    data: s(s({}, e), {}, {
                                        new_value: [].concat(te(i), [
                                            null
                                        ])
                                    })
                                });
                            }
                        })));
                    }, e.getRemoveObject = function(t) {
                        var a = e.props, r = a.theme, n = (a.hover, a.namespace), o = a.name, s = a.src, i = a.rjvId;
                        if (1 !== n.length) return v().createElement("span", {
                            className: "click-to-remove",
                            style: {
                                display: t ? "inline-block" : "none"
                            }
                        }, v().createElement(Ze, Object.assign({
                            className: "click-to-remove-icon"
                        }, G(r, "removeVarIcon"), {
                            onClick: function() {
                                ne.dispatch({
                                    name: "VARIABLE_REMOVED",
                                    rjvId: i,
                                    data: {
                                        name: o,
                                        namespace: n.splice(0, n.length - 1),
                                        existing_value: s,
                                        variable_removed: !0
                                    }
                                });
                            }
                        })));
                    }, e.render = function() {
                        var t = e.props, a = t.theme, r = t.onDelete, n = t.onAdd, o = t.enableClipboard, s = t.src, i = t.namespace, l = t.rowHovered;
                        return v().createElement("div", Object.assign({}, G(a, "object-meta-data"), {
                            className: "object-meta-data",
                            onClick: function(e) {
                                e.stopPropagation();
                            }
                        }), e.getObjectSize(), o ? v().createElement(nt, {
                            rowHovered: l,
                            clickCallback: o,
                            src: s,
                            theme: a,
                            namespace: i
                        }) : null, !1 !== n ? e.getAddAttribute(l) : null, !1 !== r ? e.getRemoveObject(l) : null);
                    }, e;
                }
                return h(t, e), c(t);
            }(v().PureComponent);
            function it(e) {
                var t = e.parent_type, a = e.namespace, r = e.quotesOnKeys, n = e.theme, o = e.jsvRoot, s = e.name, i = e.displayArrayKey, l = e.name ? e.name : "";
                return !o || !1 !== s && null !== s ? "array" == t ? i ? v().createElement("span", Object.assign({}, G(n, "array-key"), {
                    key: a
                }), v().createElement("span", {
                    className: "array-key"
                }, l), v().createElement("span", G(n, "colon"), ":")) : v().createElement("span", null) : v().createElement("span", Object.assign({}, G(n, "object-name"), {
                    key: a
                }), v().createElement("span", {
                    className: "object-key"
                }, r && v().createElement("span", {
                    style: {
                        verticalAlign: "top"
                    }
                }, '"'), v().createElement("span", null, l), r && v().createElement("span", {
                    style: {
                        verticalAlign: "top"
                    }
                }, '"')), v().createElement("span", G(n, "colon"), ":")) : v().createElement("span", null);
            }
            function lt(e) {
                var t = e.theme;
                switch(e.iconStyle){
                    case "triangle":
                        return v().createElement(Ge, Object.assign({}, G(t, "expanded-icon"), {
                            className: "expanded-icon"
                        }));
                    case "square":
                        return v().createElement($e, Object.assign({}, G(t, "expanded-icon"), {
                            className: "expanded-icon"
                        }));
                    default:
                        return v().createElement(Ue, Object.assign({}, G(t, "expanded-icon"), {
                            className: "expanded-icon"
                        }));
                }
            }
            function ct(e) {
                var t = e.theme;
                switch(e.iconStyle){
                    case "triangle":
                        return v().createElement(Je, Object.assign({}, G(t, "collapsed-icon"), {
                            className: "collapsed-icon"
                        }));
                    case "square":
                        return v().createElement(Ye, Object.assign({}, G(t, "collapsed-icon"), {
                            className: "collapsed-icon"
                        }));
                    default:
                        return v().createElement(He, Object.assign({}, G(t, "collapsed-icon"), {
                            className: "collapsed-icon"
                        }));
                }
            }
            var ut = [
                "src",
                "groupArraysAfterLength",
                "depth",
                "name",
                "theme",
                "jsvRoot",
                "namespace",
                "parent_type"
            ], dt = function(e) {
                function t(e) {
                    var a;
                    return i(this, t), (a = p(this, t, [
                        e
                    ])).toggleCollapsed = function(e) {
                        var t = [];
                        for(var r in a.state.expanded)t.push(a.state.expanded[r]);
                        t[e] = !t[e], a.setState({
                            expanded: t
                        });
                    }, a.state = {
                        expanded: []
                    }, a;
                }
                return h(t, e), c(t, [
                    {
                        key: "getExpandedIcon",
                        value: function(e) {
                            var t = this.props, a = t.theme, r = t.iconStyle;
                            return this.state.expanded[e] ? v().createElement(lt, {
                                theme: a,
                                iconStyle: r
                            }) : v().createElement(ct, {
                                theme: a,
                                iconStyle: r
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e = this, t = this.props, a = t.src, r = t.groupArraysAfterLength, n = (t.depth, t.name), o = t.theme, s = t.jsvRoot, i = t.namespace, l = (t.parent_type, j(t, ut)), c = 0, u = 5 * this.props.indentWidth;
                            s || (c = 5 * this.props.indentWidth);
                            var d = r, b = Math.ceil(a.length / d);
                            return v().createElement("div", Object.assign({
                                className: "object-key-val"
                            }, G(o, s ? "jsv-root" : "objectKeyVal", {
                                paddingLeft: c
                            })), v().createElement(it, this.props), v().createElement("span", null, v().createElement(st, Object.assign({
                                size: a.length
                            }, this.props))), te(Array(b)).map(function(t, r) {
                                return v().createElement("div", Object.assign({
                                    key: r,
                                    className: "object-key-val array-group"
                                }, G(o, "objectKeyVal", {
                                    marginLeft: 6,
                                    paddingLeft: u
                                })), v().createElement("span", G(o, "brace-row"), v().createElement("div", Object.assign({
                                    className: "icon-container"
                                }, G(o, "icon-container"), {
                                    onClick: function(t) {
                                        e.toggleCollapsed(r);
                                    }
                                }), e.getExpandedIcon(r)), e.state.expanded[r] ? v().createElement(ht, Object.assign({
                                    key: n + r,
                                    depth: 0,
                                    name: !1,
                                    collapsed: !1,
                                    groupArraysAfterLength: d,
                                    index_offset: r * d,
                                    src: a.slice(r * d, r * d + d),
                                    namespace: i,
                                    type: "array",
                                    parent_type: "array_group",
                                    theme: o,
                                    showComma: e.props.showComma,
                                    isLast: r === b - 1
                                }, l)) : v().createElement("span", Object.assign({}, G(o, "brace"), {
                                    onClick: function(t) {
                                        e.toggleCollapsed(r);
                                    },
                                    className: "array-group-brace"
                                }), "[", v().createElement("div", Object.assign({}, G(o, "array-group-meta-data"), {
                                    className: "array-group-meta-data"
                                }), v().createElement("span", Object.assign({
                                    className: "object-size"
                                }, G(o, "object-size")), r * d, " - ", r * d + d > a.length ? a.length : r * d + d)), "]")));
                            }));
                        }
                    }
                ]);
            }(v().PureComponent), bt = [
                "depth",
                "src",
                "namespace",
                "name",
                "type",
                "parent_type",
                "theme",
                "jsvRoot",
                "iconStyle",
                "showComma",
                "isLast"
            ], pt = function(e) {
                function t(e) {
                    var a;
                    i(this, t), (a = p(this, t, [
                        e
                    ])).toggleCollapsed = function() {
                        a.setState({
                            expanded: !a.state.expanded
                        }, function() {
                            se.set(a.props.rjvId, a.props.namespace, "expanded", a.state.expanded);
                        });
                    }, a.getObjectContent = function(e, t, r) {
                        return v().createElement("div", {
                            className: "pushed-content object-container"
                        }, v().createElement("div", Object.assign({
                            className: "object-content"
                        }, G(a.props.theme, "pushed-content")), a.renderObjectContents(t, r)));
                    }, a.getEllipsis = function() {
                        return 0 === a.state.size ? null : v().createElement("div", Object.assign({}, G(a.props.theme, "ellipsis"), {
                            className: "node-ellipsis",
                            onClick: a.toggleCollapsed
                        }), "...");
                    }, a.getObjectMetaData = function(e) {
                        var t = a.props, r = (t.rjvId, t.theme, a.state), n = r.size, o = r.hovered;
                        return v().createElement(st, Object.assign({
                            rowHovered: o,
                            size: n
                        }, a.props));
                    }, a.renderObjectContents = function(e, t) {
                        var r, n = a.props, o = n.depth, s = n.parent_type, i = n.index_offset, l = n.groupArraysAfterLength, c = n.namespace, u = n.showComma, d = a.state.object_type, b = [], p = Object.keys(e || {});
                        return a.props.sortKeys && "array" !== d && (p = p.sort()), p.forEach(function(n, f) {
                            r = new ft(n, e[n], t.bigNumber);
                            var h = f === p.length - 1;
                            if ("array_group" === s && i && (r.name = parseInt(r.name) + i), Object.prototype.hasOwnProperty.call(e, n)) {
                                if ("object" === r.type) b.push(v().createElement(ht, Object.assign({
                                    key: r.name,
                                    depth: o + 1,
                                    name: r.name,
                                    src: r.value,
                                    namespace: c.concat(r.name),
                                    parent_type: d,
                                    isLast: h,
                                    showComma: u
                                }, t)));
                                else if ("array" === r.type) {
                                    var m = ht;
                                    l && r.value.length > l && (m = dt), b.push(v().createElement(m, Object.assign({
                                        key: r.name,
                                        depth: o + 1,
                                        name: r.name,
                                        src: r.value,
                                        namespace: c.concat(r.name),
                                        type: "array",
                                        parent_type: d,
                                        isLast: h,
                                        showComma: u
                                    }, t)));
                                } else b.push(v().createElement(ot, Object.assign({
                                    key: r.name + "_" + c,
                                    variable: r,
                                    singleIndent: 5,
                                    namespace: c,
                                    type: a.props.type,
                                    isLast: h,
                                    showComma: u
                                }, t)));
                            } else ;
                        }), b;
                    };
                    var r = t.getState(e);
                    return a.state = s(s({}, r), {}, {
                        prevProps: {}
                    }), a;
                }
                return h(t, e), c(t, [
                    {
                        key: "getBraceStart",
                        value: function(e, t) {
                            var a = this, r = this.props, n = (r.src, r.theme), o = r.iconStyle;
                            if ("array_group" === r.parent_type) return v().createElement("span", null, v().createElement("span", G(n, "brace"), "array" === e ? "[" : "{"));
                            var s = t ? lt : ct;
                            return v().createElement("span", null, v().createElement("span", Object.assign({
                                onClick: function(e) {
                                    a.toggleCollapsed();
                                }
                            }, G(n, "brace-row")), v().createElement("div", Object.assign({
                                className: "icon-container"
                            }, G(n, "icon-container")), v().createElement(s, {
                                theme: n,
                                iconStyle: o
                            })), v().createElement(it, this.props), v().createElement("span", G(n, "brace"), "array" === e ? "[" : "{")));
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e = this, t = this.props, a = t.depth, r = t.src, n = (t.namespace, t.name, t.type, t.parent_type), o = t.theme, i = t.jsvRoot, l = t.iconStyle, c = t.showComma, u = t.isLast, d = j(t, bt), b = this.state, p = b.object_type, f = b.expanded, h = {};
                            return i || "array_group" === n ? "array_group" === n && (h.borderLeft = 0, h.display = "inline") : h.paddingLeft = 5 * this.props.indentWidth, v().createElement("div", Object.assign({
                                className: "object-key-val",
                                onMouseEnter: function() {
                                    return e.setState(s(s({}, e.state), {}, {
                                        hovered: !0
                                    }));
                                },
                                onMouseLeave: function() {
                                    return e.setState(s(s({}, e.state), {}, {
                                        hovered: !1
                                    }));
                                }
                            }, G(o, i ? "jsv-root" : "objectKeyVal", h)), this.getBraceStart(p, f), f ? this.getObjectContent(a, r, s({
                                theme: o,
                                iconStyle: l
                            }, d)) : this.getEllipsis(), v().createElement("span", {
                                className: "brace-row"
                            }, v().createElement("span", {
                                style: s(s({}, G(o, "brace").style), {}, {
                                    paddingLeft: f ? "3px" : "0px"
                                })
                            }, "array" === p ? "]" : "}")), c && !u && !i && v().createElement("span", G(o, "comma"), ","), this.getObjectMetaData(r));
                        }
                    }
                ], [
                    {
                        key: "getDerivedStateFromProps",
                        value: function(e, a) {
                            var r = a.prevProps;
                            return e.src !== r.src || e.collapsed !== r.collapsed || e.name !== r.name || e.namespace !== r.namespace || e.rjvId !== r.rjvId ? s(s({}, t.getState(e)), {}, {
                                prevProps: e
                            }) : null;
                        }
                    }
                ]);
            }(v().PureComponent);
            pt.getState = function(e) {
                var t = Object.keys(e.src).length, a = (!1 === e.collapsed || !0 !== e.collapsed && e.collapsed > e.depth) && (!e.shouldCollapse || !1 === e.shouldCollapse({
                    name: e.name,
                    src: e.src,
                    type: x(e.src),
                    namespace: e.namespace
                })) && 0 !== t;
                return {
                    expanded: se.get(e.rjvId, e.namespace, "expanded", a),
                    object_type: "array" === e.type ? "array" : "object",
                    parent_type: "array" === e.type ? "array" : "object",
                    size: t,
                    hovered: !1
                };
            };
            var ft = c(function e(t, a, r) {
                i(this, e), this.name = t, this.value = a, this.type = x(a, r);
            });
            E(pt);
            const ht = pt;
            var mt = function(e) {
                function t() {
                    var e;
                    i(this, t);
                    for(var a = arguments.length, r = new Array(a), n = 0; n < a; n++)r[n] = arguments[n];
                    return (e = p(this, t, [].concat(r))).render = function() {
                        var t, a, r, n, o = e.props, s = [
                            o.name
                        ], i = ht;
                        "object" != typeof o.name || Array.isArray(o.name) || (s = [
                            (null === (t = o.name) || void 0 === t ? void 0 : t.displayName) || (null === (a = o.name) || void 0 === a ? void 0 : a.name) || (null === (r = o.name) || void 0 === r || null === (n = r.type) || void 0 === n ? void 0 : n.name) || "Anonymous"
                        ]);
                        return Array.isArray(o.src) && o.groupArraysAfterLength && o.src.length > o.groupArraysAfterLength && (i = dt), v().createElement("div", {
                            className: "pretty-json-container object-container"
                        }, v().createElement("div", {
                            className: "object-content"
                        }, v().createElement(i, Object.assign({
                            namespace: s,
                            depth: 0,
                            jsvRoot: !0
                        }, o))));
                    }, e;
                }
                return h(t, e), c(t);
            }(v().PureComponent), vt = function(e) {
                function t(e) {
                    var a;
                    return i(this, t), (a = p(this, t, [
                        e
                    ])).closeModal = function() {
                        ne.dispatch({
                            rjvId: a.props.rjvId,
                            name: "RESET"
                        });
                    }, a.submit = function() {
                        a.props.submit(a.state.input);
                    }, a.state = {
                        input: e.input ? e.input : ""
                    }, a;
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this, t = this.props, a = t.theme, r = t.rjvId, n = t.isValid, o = this.state.input, s = n(o);
                            return v().createElement("div", Object.assign({
                                className: "key-modal-request"
                            }, G(a, "key-modal-request"), {
                                onClick: this.closeModal
                            }), v().createElement("div", Object.assign({}, G(a, "key-modal"), {
                                onClick: function(e) {
                                    e.stopPropagation();
                                }
                            }), v().createElement("div", G(a, "key-modal-label"), "Key Name:"), v().createElement("div", {
                                style: {
                                    position: "relative"
                                }
                            }, v().createElement("input", Object.assign({}, G(a, "key-modal-input"), {
                                className: "key-modal-input",
                                ref: function(e) {
                                    return e && e.focus();
                                },
                                spellCheck: !1,
                                value: o,
                                placeholder: "...",
                                onChange: function(t) {
                                    e.setState({
                                        input: t.target.value
                                    });
                                },
                                onKeyPress: function(t) {
                                    s && "Enter" === t.key ? e.submit() : "Escape" === t.key && e.closeModal();
                                }
                            })), s ? v().createElement(at, Object.assign({}, G(a, "key-modal-submit"), {
                                className: "key-modal-submit",
                                onClick: function(t) {
                                    return e.submit();
                                }
                            })) : null), v().createElement("span", G(a, "key-modal-cancel"), v().createElement(et, Object.assign({}, G(a, "key-modal-cancel-icon"), {
                                className: "key-modal-cancel",
                                onClick: function() {
                                    ne.dispatch({
                                        rjvId: r,
                                        name: "RESET"
                                    });
                                }
                            })))));
                        }
                    }
                ]);
            }(v().PureComponent), gt = function(e) {
                function t() {
                    var e;
                    i(this, t);
                    for(var a = arguments.length, r = new Array(a), n = 0; n < a; n++)r[n] = arguments[n];
                    return (e = p(this, t, [].concat(r))).isValid = function(t) {
                        var a = e.props.rjvId, r = se.get(a, "action", "new-key-request");
                        return "" != t && -1 === Object.keys(r.existing_value).indexOf(t);
                    }, e.submit = function(t) {
                        var a = e.props.rjvId, r = se.get(a, "action", "new-key-request");
                        r.new_value = s({}, r.existing_value), r.new_value[t] = e.props.defaultValue, ne.dispatch({
                            name: "VARIABLE_ADDED",
                            rjvId: a,
                            data: r
                        });
                    }, e;
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = e.active, a = e.theme, r = e.rjvId;
                            return t ? v().createElement(vt, {
                                rjvId: r,
                                theme: a,
                                isValid: this.isValid,
                                submit: this.submit
                            }) : null;
                        }
                    }
                ]);
            }(v().PureComponent), yt = function(e) {
                function t() {
                    return i(this, t), p(this, t, arguments);
                }
                return h(t, e), c(t, [
                    {
                        key: "render",
                        value: function() {
                            var e = this.props, t = e.message, a = e.active, r = e.theme, n = e.rjvId;
                            return a ? v().createElement("div", Object.assign({
                                className: "validation-failure"
                            }, G(r, "validation-failure"), {
                                onClick: function() {
                                    ne.dispatch({
                                        rjvId: n,
                                        name: "RESET"
                                    });
                                }
                            }), v().createElement("span", G(r, "validation-failure-label"), t), v().createElement(et, G(r, "validation-failure-clear"))) : null;
                        }
                    }
                ]);
            }(v().PureComponent), kt = function(e) {
                function t(e) {
                    var a;
                    return i(this, t), (a = p(this, t, [
                        e
                    ])).rjvId = Date.now().toString() + Math.random().toString(36).slice(2), a.getListeners = function() {
                        return {
                            reset: a.resetState,
                            "variable-update": a.updateSrc,
                            "add-key-request": a.addKeyRequest
                        };
                    }, a.updateSrc = function() {
                        var e, t = se.get(a.rjvId, "action", "variable-update"), r = t.name, n = t.namespace, o = t.new_value, s = t.existing_value, i = t.updated_src, l = t.type, c = a.props, u = c.onEdit, d = c.onDelete, b = c.onAdd, p = {
                            existing_src: a.state.src,
                            new_value: o,
                            updated_src: i,
                            name: r,
                            namespace: n,
                            existing_value: s
                        };
                        switch(l){
                            case "variable-added":
                                e = b(p);
                                break;
                            case "variable-edited":
                                e = u(p);
                                break;
                            case "variable-removed":
                                e = d(p);
                        }
                        !1 !== e ? (se.set(a.rjvId, "global", "src", i), a.setState({
                            src: i
                        })) : a.setState({
                            validationFailure: !0
                        });
                    }, a.addKeyRequest = function() {
                        a.setState({
                            addKeyRequest: !0
                        });
                    }, a.resetState = function() {
                        a.setState({
                            validationFailure: !1,
                            addKeyRequest: !1
                        });
                    }, a.state = {
                        addKeyRequest: !1,
                        editKeyRequest: !1,
                        validationFailure: !1,
                        src: t.defaultProps.src,
                        name: t.defaultProps.name,
                        theme: t.defaultProps.theme,
                        validationMessage: t.defaultProps.validationMessage,
                        prevSrc: t.defaultProps.src,
                        prevName: t.defaultProps.name,
                        prevTheme: t.defaultProps.theme
                    }, a;
                }
                return h(t, e), c(t, [
                    {
                        key: "componentDidMount",
                        value: function() {
                            se.set(this.rjvId, "global", "src", this.state.src);
                            var e = this.getListeners();
                            for(var t in e)se.on(t + "-" + this.rjvId, e[t]);
                            this.setState({
                                addKeyRequest: !1,
                                editKeyRequest: !1
                            });
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function(e, t) {
                            !1 !== t.addKeyRequest && this.setState({
                                addKeyRequest: !1
                            }), !1 !== t.editKeyRequest && this.setState({
                                editKeyRequest: !1
                            }), e.src !== this.state.src && se.set(this.rjvId, "global", "src", this.state.src);
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            var e = this.getListeners();
                            for(var t in e)se.removeListener(t + "-" + this.rjvId, e[t]);
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e = this.state, t = e.validationFailure, a = e.validationMessage, r = e.addKeyRequest, n = e.theme, o = e.src, i = e.name, l = this.props, c = l.style, u = l.defaultValue;
                            return v().createElement("div", {
                                className: "react-json-view",
                                style: s(s({}, G(n, "app-container").style), c)
                            }, v().createElement(yt, {
                                message: a,
                                active: t,
                                theme: n,
                                rjvId: this.rjvId
                            }), v().createElement(mt, Object.assign({}, this.props, {
                                src: o,
                                name: i,
                                theme: n,
                                type: x(o),
                                rjvId: this.rjvId
                            })), v().createElement(gt, {
                                active: r,
                                theme: n,
                                rjvId: this.rjvId,
                                defaultValue: u
                            }));
                        }
                    }
                ], [
                    {
                        key: "getDerivedStateFromProps",
                        value: function(e, a) {
                            if (e.src !== a.prevSrc || e.name !== a.prevName || e.theme !== a.prevTheme) {
                                var r = {
                                    src: e.src,
                                    name: e.name,
                                    theme: e.theme,
                                    validationMessage: e.validationMessage,
                                    prevSrc: e.src,
                                    prevName: e.name,
                                    prevTheme: e.theme
                                };
                                return t.validateState(r);
                            }
                            return null;
                        }
                    }
                ]);
            }(v().PureComponent);
            kt.defaultProps = {
                src: {},
                name: "root",
                theme: "rjv-default",
                collapsed: !1,
                collapseStringsAfterLength: !1,
                shouldCollapse: !1,
                sortKeys: !1,
                quotesOnKeys: !0,
                groupArraysAfterLength: 100,
                indentWidth: 4,
                enableClipboard: !0,
                escapeStrings: !0,
                displayObjectSize: !0,
                displayDataTypes: !0,
                onEdit: !1,
                onDelete: !1,
                onAdd: !1,
                onSelect: !1,
                iconStyle: "triangle",
                style: {},
                validationMessage: "Validation Error",
                defaultValue: null,
                displayArrayKey: !0,
                selectOnFocus: !1,
                keyModifier: function(e) {
                    return e.metaKey || e.ctrlKey;
                },
                bigNumber: null,
                showComma: !0
            }, kt.validateState = function(e) {
                var t = {};
                return "object" !== x(e.theme) || function(e) {
                    var t = [
                        "base00",
                        "base01",
                        "base02",
                        "base03",
                        "base04",
                        "base05",
                        "base06",
                        "base07",
                        "base08",
                        "base09",
                        "base0A",
                        "base0B",
                        "base0C",
                        "base0D",
                        "base0E",
                        "base0F"
                    ];
                    if ("object" === x(e)) {
                        for(var a = 0; a < t.length; a++)if (!(t[a] in e)) return !1;
                        return !0;
                    }
                    return !1;
                }(e.theme) || (console.error("react-json-view error:", "theme prop must be a theme name or valid base-16 theme object.", 'defaulting to "rjv-default" theme'), t.theme = "rjv-default"), "object" !== x(e.src) && "array" !== x(e.src) && (console.error("react-json-view error:", "src property must be a valid json object"), t.name = "ERROR", t.src = {
                    message: "src property must be a valid json object"
                }), s(s({}, e), t);
            }, E(kt);
            const Et = kt;
        })(), n;
    })());


const $47ae8c6618e10a1b$var$style = {
    typography: 'body2',
    wordBreak: 'break-all'
};
const $47ae8c6618e10a1b$export$48880ac635f47186 = ({ src: src, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $47ae8c6618e10a1b$var$style,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($705b558413bac00d$exports))), {
            ...props,
            src: src,
            sortKeys: true,
            name: false,
            displayDataTypes: false
        })
    });





parcelRequire("h4Bez");


parcelRequire("h4Bez");

const $e4139f30f665a5a2$var$wrapperStyle = {
    textAlign: 'center'
};
const $e4139f30f665a5a2$var$smallStyle = {
    my: 1
};
const $e4139f30f665a5a2$var$regularStyle = {
    my: 1
};
const $e4139f30f665a5a2$var$marginStyles = {
    small: $e4139f30f665a5a2$var$smallStyle,
    regular: $e4139f30f665a5a2$var$regularStyle
};
const $e4139f30f665a5a2$export$e0217278edc1ac28 = ({ margin: margin = 'regular', ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        ...props,
        sx: [
            $e4139f30f665a5a2$var$wrapperStyle,
            $e4139f30f665a5a2$var$marginStyles[margin]
        ]
    });


const $35e2f7ba0c5bb8e5$export$8b8493c40023057 = ({ size: size, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e4139f30f665a5a2$export$e0217278edc1ac28), {
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $95388f9578043f1e$export$2e2bcd8739ae039), {
            size: size
        })
    });






parcelRequire("h4Bez");



"use client";
var $d8b611a4fadfe6bf$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), 'ErrorOutlined');







const $d36390f84a2ea7c3$var$wrapperStlye = {
    p: 1.5,
    maxWidth: 400,
    wordBreak: 'break-word'
};
const $d36390f84a2ea7c3$var$buttonStyle = {
    mr: 1,
    minWidth: 0
};
const $d36390f84a2ea7c3$var$topicHighlightStyle = {
    color: 'error.main'
};
const $d36390f84a2ea7c3$var$stopPropagation = (0, $1fdb53e1bec07519$export$5532d7f774835bb3)();
const $d36390f84a2ea7c3$var$Content = ({ topics: topics, errors: errors, onRetry: onRetry, onUnsub: onUnsub, ...props })=>{
    const setAnchor = (0, $5c50dcf7e155ce8c$export$b13dce3af0135d87)();
    const close = (0, $5c50dcf7e155ce8c$export$89554eb4b4787636)();
    const createCloser = (afterClose)=>afterClose ? ()=>{
            close();
            afterClose();
        } : close;
    const testId = (0, $3dd52092ec4fc8cb$export$eea0c9f46a8cc3f9)(props) || topics.join('-').replace(/\W+/g, '');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d8b611a4fadfe6bf$export$2e2bcd8739ae039), {
                "data-testid": `show-topic-error-button-${testId}`,
                color: "error",
                fontSize: "medium",
                onClick: (0, $1fdb53e1bec07519$export$5532d7f774835bb3)((e)=>setAnchor(e.currentTarget))
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $40650a35df6eb212$export$2e2bcd8739ae039), {
                "data-testid": `show-topic-error-popover-${testId}`,
                onClick: $d36390f84a2ea7c3$var$stopPropagation,
                onClose: (0, $1fdb53e1bec07519$export$5532d7f774835bb3)(close),
                anchorOrigin: {
                    vertical: 'center',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                },
                elevation: 1,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: $d36390f84a2ea7c3$var$wrapperStlye,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TOPIC_SUBSCRIPTION_ERROR,
                        values: {
                            topicsCount: topics.length,
                            topics: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbba8fd6e98bab28$export$f52b44e459e6e71d), {
                                value: topics.map((topic, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                                        component: "b",
                                        sx: $d36390f84a2ea7c3$var$topicHighlightStyle,
                                        title: topic,
                                        children: topic
                                    }, k))
                            }),
                            error: errors.size > 1 ? 'multiple' : errors.values().next().value,
                            retry: Boolean(onRetry) && errors.has('unknown'),
                            retryButton: (0, $4772774eee62bdcc$export$18fadbe56dfcb1a1)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                                'data-testid': `retry-topic-link-${testId}`,
                                sx: $d36390f84a2ea7c3$var$buttonStyle,
                                onClick: createCloser(onRetry),
                                variant: 'ghost',
                                size: 'small'
                            }),
                            unsub: Boolean(onUnsub),
                            unsubButton: (0, $4772774eee62bdcc$export$18fadbe56dfcb1a1)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                                'data-testid': `unsub-topic-link-${testId}`,
                                sx: $d36390f84a2ea7c3$var$buttonStyle,
                                onClick: createCloser(onUnsub),
                                variant: 'ghost',
                                size: 'small'
                            }),
                            paragraph: (0, $4772774eee62bdcc$export$18fadbe56dfcb1a1)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                                variant: 'body2'
                            })
                        }
                    })
                })
            })
        ]
    });
};
const $d36390f84a2ea7c3$export$79f270ed0b847a48 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5c50dcf7e155ce8c$export$1d7e255c6105d39b), {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($d36390f84a2ea7c3$var$Content, {
            ...props
        })
    });






var $h4Bez = parcelRequire("h4Bez");




parcelRequire("h4Bez");


// An open-started range ("up to end") is prefixed with a dash to distinguish it from an open-ended one
// ("from start onward"), which needs none; a full range separates its two bounds with a dash.
const $f96805b54bc850bf$var$dashSeparator = (start, end)=>{
    if (!end) return '';
    return start ? " \u2013 " : "\u2013 ";
};
const $f96805b54bc850bf$export$27057d02d4068174 = ({ value: { start: start, end: end }, onClear: onClear })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e2c1c86842962ae2$export$5a7f9a6004988d01), {
        label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
            children: [
                start && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$d275c5eeba29af75), {
                    date: start,
                    format: "dateRangeChip"
                }),
                $f96805b54bc850bf$var$dashSeparator(start, end),
                end && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$d275c5eeba29af75), {
                    date: end,
                    format: "dateRangeChip"
                })
            ]
        }),
        onDelete: onClear,
        variant: "primary",
        "data-testid": "date-range-chip"
    });




var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");










function $7b20f02275dd319b$export$2177af0aa15c34c2(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiDialog', slot);
}
const $7b20f02275dd319b$var$dialogClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiDialog', [
    'root',
    'backdrop',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $7b20f02275dd319b$export$2e2bcd8739ae039 = $7b20f02275dd319b$var$dialogClasses;



var $h4Bez = parcelRequire("h4Bez");
'use client';
const $a33cb60cc787889f$var$DialogContext = /*#__PURE__*/ $h4Bez.createContext({});
var $a33cb60cc787889f$export$2e2bcd8739ae039 = $a33cb60cc787889f$var$DialogContext;








'use client';
const $55a2a796d4e0875c$var$DialogBackdrop = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $1e67fed7a77f91a6$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop'
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $55a2a796d4e0875c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        backdrop: [
            'backdrop'
        ],
        container: [
            'container',
            `scroll${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(scroll)}`,
            `paperWidth${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $7b20f02275dd319b$export$2177af0aa15c34c2), classes);
};
const $55a2a796d4e0875c$var$DialogRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $22fdbb8607c29afa$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root'
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $55a2a796d4e0875c$var$DialogContainer = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.scroll)}`]
        ];
    }
})({
    height: '100%',
    '@media print': {
        height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: 'paper'
            },
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        },
        {
            props: {
                scroll: 'body'
            },
            style: {
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'center',
                '&::after': {
                    content: '""',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%',
                    width: '0'
                }
            }
        }
    ]
});
const $55a2a796d4e0875c$var$DialogPaper = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        },
        variants: [
            {
                props: {
                    scroll: 'paper'
                },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    scroll: 'body'
                },
                style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textAlign: 'initial'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    maxWidth: 'xs'
                },
                style: {
                    maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
                    [`&.${(0, $7b20f02275dd319b$export$2e2bcd8739ae039).paperScrollBody}`]: {
                        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                            maxWidth: 'calc(100% - 64px)'
                        }
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth: maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
                        [`&.${(0, $7b20f02275dd319b$export$2e2bcd8739ae039).paperScrollBody}`]: {
                            [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                                maxWidth: 'calc(100% - 64px)'
                            }
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: 'calc(100% - 64px)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 'none',
                    borderRadius: 0,
                    [`&.${(0, $7b20f02275dd319b$export$2e2bcd8739ae039).paperScrollBody}`]: {
                        margin: 0,
                        maxWidth: '100%'
                    }
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $55a2a796d4e0875c$var$Dialog = /*#__PURE__*/ $h4Bez.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $cd99783e1cac2d84$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, 'aria-modal': ariaModal = true, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $d6020d3fa35703e9$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponent = (0, $a5aa955e27ea098e$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps, ...other } = props;
    const ownerState = {
        ...props,
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    };
    const classes = $55a2a796d4e0875c$var$useUtilityClasses(ownerState);
    const backdropClick = $h4Bez.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $8bcd24cec5c7b3d6$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $h4Bez.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    const backwardCompatibleSlots = {
        transition: TransitionComponent,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionProps,
        paper: PaperProps,
        backdrop: BackdropProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('root', {
        elementType: $55a2a796d4e0875c$var$DialogRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    });
    const [BackdropSlot, backdropSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('backdrop', {
        elementType: $55a2a796d4e0875c$var$DialogBackdrop,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.backdrop
    });
    const [PaperSlot, paperSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('paper', {
        elementType: $55a2a796d4e0875c$var$DialogPaper,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.paper, PaperProps.className)
    });
    const [ContainerSlot, containerSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('container', {
        elementType: $55a2a796d4e0875c$var$DialogContainer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.container
    });
    const [TransitionSlot, transitionSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $a5aa955e27ea098e$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: 'presentation'
        }
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(RootSlot, {
        closeAfterTransition: true,
        slots: {
            backdrop: BackdropSlot
        },
        slotProps: {
            backdrop: {
                transitionDuration: transitionDuration,
                as: BackdropComponent,
                ...backdropSlotProps
            }
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        onClick: handleBackdropClick,
        ...rootSlotProps,
        ...other,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(ContainerSlot, {
                onMouseDown: handleMouseDown,
                ...containerSlotProps,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(PaperSlot, {
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby,
                    "aria-modal": ariaModal,
                    ...paperSlotProps,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a33cb60cc787889f$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                })
            })
        })
    });
});
var $55a2a796d4e0875c$export$2e2bcd8739ae039 = $55a2a796d4e0875c$var$Dialog;





parcelRequire("h4Bez");




const $870b65d56f8a27bd$var$containerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 2
};
const $870b65d56f8a27bd$export$88c65d2d98aab183 = ({ onCancel: onCancel, onApply: onApply, disabled: disabled })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $870b65d56f8a27bd$var$containerStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                size: "medium",
                variant: "secondary",
                onClick: onCancel,
                "data-testid": "cancel-button",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CANCEL
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                size: "medium",
                variant: "primary",
                onClick: onApply,
                disabled: disabled,
                "data-testid": "apply-button",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).APPLY
                })
            })
        ]
    });




var $h4Bez = parcelRequire("h4Bez");


var $h4Bez = parcelRequire("h4Bez");
/**
 * The symbol to access the `TZDate`'s function to construct a new instance from
 * the provided value. It helps date-fns to inherit the time zone.
 */ const $20991d2b356c5f58$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


/**
 * Time zone name format.
 */ /**
 * The function returns the time zone name for the given date in the specified
 * time zone.
 *
 * It uses the `Intl.DateTimeFormat` API and by default outputs the time zone
 * name in a long format, e.g. "Pacific Standard Time" or
 * "Singapore Standard Time".
 *
 * It is possible to specify the format as the third argument using one of the following options
 *
 * - "short": e.g. "EDT" or "GMT+8".
 * - "long": e.g. "Eastern Daylight Time".
 * - "shortGeneric": e.g. "ET" or "Singapore Time".
 * - "longGeneric": e.g. "Eastern Time" or "Singapore Standard Time".
 *
 * These options correspond to TR35 tokens `z..zzz`, `zzzz`, `v`, and `vvvv` respectively: https://www.unicode.org/reports/tr35/tr35-dates.html#dfst-zone
 *
 * @param timeZone - Time zone name (IANA or UTC offset)
 * @param date - Date object to get the time zone name for
 * @param format - Optional format of the time zone name. Defaults to "long". Can be "short", "long", "shortGeneric", or "longGeneric".
 *
 * @returns Time zone name (e.g. "Singapore Standard Time")
 */ function $943e25da0048d8e0$export$da16a9b5e878a278(timeZone, date, format = "long") {
    return new Intl.DateTimeFormat("en-US", {
        // Enforces engine to render the time. Without the option JavaScriptCore omits it.
        hour: "numeric",
        timeZone: timeZone,
        timeZoneName: format
    }).format(date).split(/\s/g) // Format.JS uses non-breaking spaces
    .slice(2) // Skip the hour and AM/PM parts
    .join(" ");
}


const $9157ce4fe9022419$var$offsetFormatCache = {};
const $9157ce4fe9022419$var$offsetCache = {};
function $9157ce4fe9022419$export$9047ae35a63b6344(timeZone, date) {
    try {
        // Create `Intl.DateTimeFormat` with `"longOffset"` that gives us consistent
        // date strings like `"5/19/2026, GMT-08:00"`.
        const format = $9157ce4fe9022419$var$offsetFormatCache[timeZone] ||= new Intl.DateTimeFormat("en-US", {
            timeZone: timeZone,
            timeZoneName: "longOffset"
        }).format;
        // Get `"-08:00"`.
        const offsetStr = format(date).split("GMT")[1];
        // Avoid parsing the same offset string.
        if (offsetStr in $9157ce4fe9022419$var$offsetCache) return $9157ce4fe9022419$var$offsetCache[offsetStr];
        // Calculate offset from `["-08", "00"]` and cache it.
        return $9157ce4fe9022419$var$calcOffset(offsetStr, offsetStr.split(":"));
    } catch  {
        // Fallback to manual parsing if the runtime doesn't support
        // `±HH:MM/±HHMM/±HH`. See: https://github.com/nodejs/node/issues/53419.
        if (timeZone in $9157ce4fe9022419$var$offsetCache) return $9157ce4fe9022419$var$offsetCache[timeZone];
        const captures = timeZone?.match($9157ce4fe9022419$var$offsetRe);
        if (captures) return $9157ce4fe9022419$var$calcOffset(timeZone, captures.slice(1));
        return NaN;
    }
}
const $9157ce4fe9022419$var$offsetRe = /([+-]\d\d):?(\d\d)?/;
function $9157ce4fe9022419$var$calcOffset(cacheStr, values) {
    const hours = +(values[0] || 0);
    const minutes = +(values[1] || 0);
    // Convert seconds to minutes by dividing by 60 to keep the function return in minutes.
    const seconds = +(values[2] || 0) / 60;
    return $9157ce4fe9022419$var$offsetCache[cacheStr] = hours * 60 + minutes > 0 ? hours * 60 + minutes + seconds : hours * 60 - minutes - seconds;
}


class $b8b43f07d6079807$export$b6261598d9222eec extends Date {
    //#region static
    constructor(...args){
        super();
        // Time zone string is always the last string argument unless date string
        // is passed (as a single argument).
        if (args.length > 1 && typeof args[args.length - 1] === "string") this.timeZone = args.pop();
        this.internal = new Date();
        // Validate the time zone by checking its offset.
        if (isNaN((0, $9157ce4fe9022419$export$9047ae35a63b6344)(this.timeZone, this))) this.setTime(NaN);
        else {
            if (!args.length) // No arguments passed: use current time
            this.setTime(Date.now());
            else if (typeof args[0] === "number" && (args.length === 1 || args.length === 2 && typeof args[1] !== "number")) // Timestamp passed: use it as is
            this.setTime(args[0]);
            else if (typeof args[0] === "string") // `Date` string passed: parse it as external date
            this.setTime(+new Date(args[0]));
            else if (args[0] instanceof Date) // `Date` passed: use its timestamp
            this.setTime(+args[0]);
            else {
                // `Date` values passed:
                // Set it as external date.
                this.setTime(+new Date(...args));
                // Adjust internal and external dates considering that we might have
                // landed on the DST hour.
                $b8b43f07d6079807$var$adjustToSystemTZ(this, args);
            }
        }
    }
    static tz(tz, ...args) {
        return args.length ? new $b8b43f07d6079807$export$b6261598d9222eec(...args, tz) : new $b8b43f07d6079807$export$b6261598d9222eec(Date.now(), tz);
    }
    //#endregion
    //#region time zone
    withTimeZone(timeZone) {
        return new $b8b43f07d6079807$export$b6261598d9222eec(+this, timeZone);
    }
    getTimezoneOffset() {
        const offset = -(0, $9157ce4fe9022419$export$9047ae35a63b6344)(this.timeZone, this);
        // Remove the seconds offset using `Math.floor` for negative UTC time zones
        // and `Math.ceil` for positive UTC time zones.
        return offset > 0 ? Math.floor(offset) : Math.ceil(offset);
    }
    //#endregion
    //#region time
    setTime(_time) {
        // Use the native `setTime` to the external date time.
        Date.prototype.setTime.apply(this, arguments);
        // Then apply it to the internal date adjusting to the timezone offset.
        $b8b43f07d6079807$var$syncToInternal(this);
        return +this;
    }
    //#endregion
    //#region date-fns integration
    [Symbol.for("constructDateFrom")](date) {
        return new $b8b43f07d6079807$export$b6261598d9222eec(+new Date(date), this.timeZone);
    }
}
// Assign getters and setters
const $b8b43f07d6079807$var$re = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((method)=>{
    if (!$b8b43f07d6079807$var$re.test(method)) return;
    const utcMethod = method.replace($b8b43f07d6079807$var$re, "$1UTC");
    // Filter out methods without UTC counterparts
    if (!$b8b43f07d6079807$export$b6261598d9222eec.prototype[utcMethod]) return;
    if (method.startsWith("get")) // Delegate to internal date's UTC method
    $b8b43f07d6079807$export$b6261598d9222eec.prototype[method] = function() {
        return this.internal[utcMethod]();
    };
    else {
        // Assign regular setter
        $b8b43f07d6079807$export$b6261598d9222eec.prototype[method] = function() {
            Date.prototype[utcMethod].apply(this.internal, arguments);
            $b8b43f07d6079807$var$syncFromInternal(this);
            return +this;
        };
        // Assign UTC setter
        $b8b43f07d6079807$export$b6261598d9222eec.prototype[utcMethod] = function() {
            Date.prototype[utcMethod].apply(this, arguments);
            $b8b43f07d6079807$var$syncToInternal(this);
            return +this;
        };
    }
});
/**
 * @internal
 * Function syncs time to internal date, applying the current time zone offset.
 *
 * @param {Date} date - `Date` to sync
 */ function $b8b43f07d6079807$var$syncToInternal(date) {
    // Start internal from the same real timestamp as external.
    date.internal.setTime(+date);
    // Shift internal by the target offset so its UTC fields become the target-zone
    // wall-clock fields for the external timestamp.
    //
    //   o internal UTC fields: 2024-02-11 00:00
    //   |
    //   | + Asia/Singapore offset (+08:00)
    //   v
    //   x internal UTC fields: 2024-02-11 08:00
    //
    date.internal.setUTCSeconds(date.internal.getUTCSeconds() - // Round after converting minutes to seconds to avoid fractional offset
    // precision errors from historical offsets.
    Math.round(-(0, $9157ce4fe9022419$export$9047ae35a63b6344)(date.timeZone, date) * 60));
}
/**
 * @internal
 * Function syncs internal wall-clock fields into the external date.
 *
 * @param {Date} date - The date to sync
 */ function $b8b43f07d6079807$var$syncFromInternal(date) {
    // Copy target-zone wall-clock fields from internal into external using native
    // local setters. At this point external holds the right field values but they
    // are interpreted in the system time zone; `adjustToSystemTZ` fixes that.
    Date.prototype.setFullYear.call(date, date.internal.getUTCFullYear(), date.internal.getUTCMonth(), date.internal.getUTCDate());
    Date.prototype.setHours.call(date, date.internal.getUTCHours(), date.internal.getUTCMinutes(), date.internal.getUTCSeconds(), date.internal.getUTCMilliseconds());
    // Now we have to adjust the date to the system time zone
    $b8b43f07d6079807$var$adjustToSystemTZ(date);
}
/**
 * @internal
 * Function adjusts the date to the system time zone. It uses the time zone
 * differences to calculate the offset and adjust the date.
 *
 * We use it when constructing `TZDate` and syncing the external date from
 * the internal one.
 *
 * @param {TZDate} date - `TZDate` to adjust.
 */ function $b8b43f07d6079807$var$adjustToSystemTZ(date, constructorArgs) {
    // Keep the intended target-zone wall-clock value before native Date/system
    // time zone normalization can move it. Later corrections compare against this
    // value to distinguish intended DST normalization from accidental drift.
    const expectedInternalTime = Array.isArray(constructorArgs) ? $b8b43f07d6079807$var$constructorArgsToInternalTime(constructorArgs) : +date.internal;
    //#region Initial offset calculation
    // Current target time zone offset at the native timestamp. It may include
    // historical offset seconds, which we preserve for the seconds adjustment.
    const offsetWithSeconds = (0, $9157ce4fe9022419$export$9047ae35a63b6344)(date.timeZone, date);
    // Minute-precision target offset used by minute-based timestamp adjustments.
    // Historical offsets can contain seconds, so we strip the fractional minute
    // here and handle remaining seconds in the seconds adjustment below.
    const offset = offsetWithSeconds > 0 ? Math.floor(offsetWithSeconds) : Math.ceil(offsetWithSeconds);
    //#endregion
    //#region System DST adjustment
    // Native `Date` may normalize the requested wall time when the system time
    // zone skips that hour for DST.
    //
    // We compare the system wall-clock hour represented by the external date with
    // the wall-clock hour stored in the internal date. If they differ, the next
    // offset-diff calculation may need the previous system offset, because the
    // current external timestamp is already after the system DST jump.
    // Previous-hour reference used to detect whether the system offset changed
    // immediately before the current native timestamp.
    const prevHour = new Date(+date);
    // Use UTC math so subtracting one hour cannot be normalized back into the
    // same missing local DST hour.
    prevHour.setUTCHours(prevHour.getUTCHours() - 1);
    // Current system offset at the native timestamp.
    const systemOffset = -new Date(+date).getTimezoneOffset();
    // System offset one real hour before the native timestamp.
    const prevHourSystemOffset = -new Date(+prevHour).getTimezoneOffset();
    // Non-zero when the system offset changed between `prevHour` and `date`.
    const systemDSTChange = systemOffset - prevHourSystemOffset;
    // System offset to use in the later system-target offset difference.
    // Defaults to the current system offset and switches to the previous offset
    // only when native `Date` normalized a missing system wall time.
    let systemOffsetForDiff = systemOffset;
    if (systemDSTChange && systemOffset !== offset) {
        // System wall-clock hour represented by the current external timestamp.
        const systemHour = Date.prototype.getHours.apply(date);
        // Target wall-clock hour currently stored in internal fields. Constructors
        // get it from arguments because internal may have already been synced from
        // the normalized external timestamp; setters get it directly from internal.
        const expectedHour = Array.isArray(constructorArgs) ? constructorArgs[3] || 0 : date.internal.getUTCHours();
        if (systemHour !== expectedHour) {
            // Check whether using the current system offset would keep the target
            // offset unchanged. If so, the only DST jump we crossed is the system
            // one, so the diff should use the pre-DST system offset.
            const testDate = new Date(+date);
            // Difference that the later offset-diff step would apply with the
            // current system offset.
            const testOffsetDiff = systemOffset - offset;
            if (testOffsetDiff) testDate.setUTCMinutes(testDate.getUTCMinutes() + testOffsetDiff);
            // Target offset after applying the current system offset difference.
            const testOffsetWithSeconds = (0, $9157ce4fe9022419$export$9047ae35a63b6344)(date.timeZone, testDate);
            // Target offset without historical seconds, matching `offset`.
            const testOffset = testOffsetWithSeconds > 0 ? Math.floor(testOffsetWithSeconds) : Math.ceil(testOffsetWithSeconds);
            if (testOffset === offset) systemOffsetForDiff = prevHourSystemOffset;
        }
    }
    //#endregion
    //#region System diff adjustment
    // Move external from the system-zone interpretation of internal fields toward
    // the timestamp that represents those fields in the target time zone.
    //
    // At this point native `Date` has treated the internal wall-clock fields as if
    // they belonged to the system zone. The system-target offset difference moves
    // external by the distance between that system interpretation and the target
    // interpretation.
    // Difference between the system offset selected above and the minute-precision
    // target offset. Positive values move external forward; negative values move
    // it backward.
    const offsetDiff = systemOffsetForDiff - offset;
    if (offsetDiff) // Apply the system-target minute difference to external. Internal is
    // rebuilt from the final external timestamp after all adjustments are
    // complete.
    //
    //   o  external as target: 2023-01-31 23:00
    //   |
    //   |  add `offsetDiff`
    //   v
    //   x  external as target: 2023-02-01 12:00
    //
    Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + offsetDiff);
    //#endregion
    //#region Seconds system diff adjustment
    // Historical time zone offsets can include seconds, but the minute-based
    // offset adjustment above intentionally used minute precision.
    //
    // This adjustment applies the remaining seconds difference to external. For
    // example, historical Singapore used UTC+06:55:25, while ISO formatting shows
    // only `+06:55`; without the seconds correction, setter paths keep the wrong
    // wall-clock seconds.
    // Clone external as a native `Date` so we can inspect how the system time zone
    // represents the same timestamp.
    const systemDate = new Date(+date);
    // Zero UTC seconds before reading system seconds. Any remaining local seconds
    // then come from the system time zone offset rather than from the timestamp's
    // own seconds value.
    systemDate.setUTCSeconds(0);
    // Seconds part contributed by the system time zone offset. Negative offsets
    // need wrapping because `Date#getSeconds()` returns values in the 0..59 range.
    const systemSecondsOffset = systemOffset > 0 ? systemDate.getSeconds() : (systemDate.getSeconds() - 60) % 60;
    // Seconds part contributed by the target time zone offset.
    const secondsOffset = Math.round(-((0, $9157ce4fe9022419$export$9047ae35a63b6344)(date.timeZone, date) * 60)) % 60;
    if (secondsOffset || systemSecondsOffset) // Apply the remaining second-level system-target difference to external.
    //
    //   o  external as Asia/Singapore: 1900-01-01 00:00:56
    //   |
    //   |  + `secondsOffset`
    //   |  + `systemSecondsOffset`
    //   v
    //   x  external as Asia/Singapore: 1900-01-01 00:00:31
    //
    Date.prototype.setUTCSeconds.call(date, Date.prototype.getUTCSeconds.call(date) + secondsOffset + systemSecondsOffset);
    //#endregion
    //#region Post-adjustment DST fix
    // The first system-target offset move can cross a target-zone DST boundary.
    //
    // When that happens, the target offset at the new external timestamp differs
    // from the target offset used for `offsetDiff`. We compare the original move
    // with the move that would be calculated at the new timestamp, then apply the
    // difference to external.
    // Target offset at the current external timestamp, including historical
    // seconds for the later seconds adjustment.
    const postOffsetWithSeconds = (0, $9157ce4fe9022419$export$9047ae35a63b6344)(date.timeZone, date);
    // Minute-precision target offset at the current external timestamp.
    const postOffset = postOffsetWithSeconds > 0 ? Math.floor(postOffsetWithSeconds) : Math.ceil(postOffsetWithSeconds);
    // System offset at the current external timestamp.
    const postSystemOffset = -new Date(+date).getTimezoneOffset();
    // System-target offset difference at the current external timestamp.
    const postOffsetDiff = postSystemOffset - postOffset;
    // Whether the target offset changed after the first offset move.
    const offsetChanged = postOffset !== offset;
    // Difference between the current offset move and the move already applied.
    const postDiff = postOffsetDiff - offsetDiff;
    // If the first offset move already normalized a target DST gap forward, the
    // generic post-DST correction below would undo that valid normalization. This
    // happens, for example, with America/New_York 02:00 during spring-forward when
    // the system zone also changes offset around the same instant.
    const targetDSTShift = postOffset - offset;
    // Candidate timestamp that would represent the requested wall-clock time with
    // the post-transition target offset. If it still does not round-trip to the
    // requested wall-clock fields, the requested time is inside a target DST gap.
    const postOffsetCandidate = expectedInternalTime - postOffset * 60000;
    // Only positive target offset shifts are spring-forward gaps. Negative shifts
    // are fall-back overlaps and still need the regular post-adjustment path.
    const normalizedTargetDSTGap = targetDSTShift > 0 && $b8b43f07d6079807$var$targetInternalTime(date) - expectedInternalTime === targetDSTShift * 60000 && $b8b43f07d6079807$var$targetInternalTime(date, postOffsetCandidate) !== expectedInternalTime;
    if (offsetChanged && postDiff && !normalizedTargetDSTGap) {
        // Apply the target-DST correction to external. In the backward-crossing case
        // shown here, this lands on an intermediate value that needs `offsetChange`
        // below.
        //
        //   o  external as America/New_York: 2023-03-12 03:00 EDT
        //   |
        //   |  + `postDiff`
        //   v
        //   x  external as America/New_York: 2023-03-12 01:00 EST
        //
        Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + postDiff);
        // Target offset after applying `postDiff`. It may change again if the
        // correction itself crosses a target-zone DST boundary.
        const newOffsetWithSeconds = (0, $9157ce4fe9022419$export$9047ae35a63b6344)(date.timeZone, date);
        // Minute-precision target offset after applying `postDiff`.
        const newOffset = newOffsetWithSeconds > 0 ? Math.floor(newOffsetWithSeconds) : Math.ceil(newOffsetWithSeconds);
        // Offset change caused by the `postDiff` move itself.
        const offsetChange = postOffset - newOffset;
        // If the correction moved external backward across the target DST boundary,
        // apply the boundary change so external lands on the valid target-zone
        // timestamp. Forward crossings are already normalized by native Date, and
        // applying this correction there would undo the valid post-DST result.
        if (offsetChange && postDiff < 0) // Apply the second target-DST correction to external.
        //
        //   o  external as America/New_York: 2023-03-12 01:00 EST
        //   |
        //   |  + `offsetChange`
        //   v
        //   x  external as America/New_York: 2023-03-12 03:00 EDT
        //
        Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + offsetChange);
    }
    //#endregion
    // Rebuild internal wall-clock fields from the final external timestamp.
    $b8b43f07d6079807$var$syncToInternal(date);
    // Native Date can normalize historical system offsets with minute and second
    // precision before we adjust to the target time zone. Correct only small
    // historical drift so DST gap normalization (usually one hour) remains intact.
    const expectedTime = constructorArgs ? expectedInternalTime : expectedInternalTime + secondsOffset * 1000;
    const drift = expectedTime - +date.internal;
    if (drift && Math.abs(drift) < 1800000) {
        Date.prototype.setTime.call(date, +date + drift);
        $b8b43f07d6079807$var$syncToInternal(date);
    }
}
function $b8b43f07d6079807$var$constructorArgsToInternalTime(args) {
    // Mirror Date's date-value constructor defaults while preserving explicit
    // `undefined` behavior. Missing month/day default, but passed `undefined`
    // should remain invalid just like `Date.UTC(year, undefined, ...)`.
    return Date.UTC(args[0], args.length > 1 ? args[1] : 0, args.length > 2 ? args[2] : 1, ...args.slice(3));
}
function $b8b43f07d6079807$var$targetInternalTime(date, time) {
    // Compute the target-zone wall-clock representation for a timestamp without
    // mutating the TZDate. This mirrors syncToInternal for temporary checks.
    const internal = new Date(time ?? +date);
    internal.setUTCSeconds(internal.getUTCSeconds() - Math.round(-(0, $9157ce4fe9022419$export$9047ae35a63b6344)(date.timeZone, internal) * 60));
    return +internal;
}


class $8f2a7769b12c0486$export$8de43e28dd4af6bd extends (0, $b8b43f07d6079807$export$b6261598d9222eec) {
    //#region static
    static tz(tz, ...args) {
        return args.length ? new $8f2a7769b12c0486$export$8de43e28dd4af6bd(...args, tz) : new $8f2a7769b12c0486$export$8de43e28dd4af6bd(Date.now(), tz);
    }
    //#endregion
    //#region representation
    toISOString() {
        const [sign, hours, minutes] = this.tzComponents();
        const tz = `${sign}${hours}:${minutes}`;
        return this.internal.toISOString().slice(0, -1) + tz;
    }
    toString() {
        // "Tue Aug 13 2024 07:50:19 GMT+0800 (Singapore Standard Time)";
        return `${this.toDateString()} ${this.toTimeString()}`;
    }
    toDateString() {
        // toUTCString returns RFC 7231 ("Mon, 12 Aug 2024 23:36:08 GMT")
        const [day, date, month, year] = this.internal.toUTCString().split(" ");
        // "Tue Aug 13 2024"
        return `${day?.slice(0, -1)} ${month} ${date} ${year}`;
    }
    toTimeString() {
        // toUTCString returns RFC 7231 ("Mon, 12 Aug 2024 23:36:08 GMT")
        const time = this.internal.toUTCString().split(" ")[4];
        const [sign, hours, minutes] = this.tzComponents();
        // "07:42:23 GMT+0800 (Singapore Standard Time)"
        return `${time} GMT${sign}${hours}${minutes} (${(0, $943e25da0048d8e0$export$da16a9b5e878a278)(this.timeZone, this)})`;
    }
    toLocaleString(locales, options) {
        return Date.prototype.toLocaleString.call(this, locales, {
            ...options,
            timeZone: options?.timeZone || this.timeZone
        });
    }
    toLocaleDateString(locales, options) {
        return Date.prototype.toLocaleDateString.call(this, locales, {
            ...options,
            timeZone: options?.timeZone || this.timeZone
        });
    }
    toLocaleTimeString(locales, options) {
        return Date.prototype.toLocaleTimeString.call(this, locales, {
            ...options,
            timeZone: options?.timeZone || this.timeZone
        });
    }
    //#endregion
    //#region private
    tzComponents() {
        const offset = this.getTimezoneOffset();
        const sign = offset > 0 ? "-" : "+";
        const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0");
        const minutes = String(Math.abs(offset) % 60).padStart(2, "0");
        return [
            sign,
            hours,
            minutes
        ];
    }
    //#endregion
    withTimeZone(timeZone) {
        return new $8f2a7769b12c0486$export$8de43e28dd4af6bd(+this, timeZone);
    }
    //#region date-fns integration
    [Symbol.for("constructDateFrom")](date) {
        return new $8f2a7769b12c0486$export$8de43e28dd4af6bd(+new Date(date), this.timeZone);
    }
}




const $a116619e3b367957$export$566f85d6e9c9e82d = (timeZone)=>(value)=>(0, $8f2a7769b12c0486$export$8de43e28dd4af6bd).tz(timeZone, +new Date(value));




function $0826e2ef91e87f5e$export$ac7720f54463288a(timeZone, interval) {
    const changes = [];
    const monthDate = new Date(interval.start);
    monthDate.setUTCSeconds(0, 0);
    const endDate = new Date(interval.end);
    endDate.setUTCSeconds(0, 0);
    const endMonthTime = +endDate;
    let lastOffset = (0, $9157ce4fe9022419$export$9047ae35a63b6344)(timeZone, monthDate);
    while(+monthDate < endMonthTime){
        // Month forward
        monthDate.setUTCMonth(monthDate.getUTCMonth() + 1);
        // Find the month where the offset changes
        const offset = (0, $9157ce4fe9022419$export$9047ae35a63b6344)(timeZone, monthDate);
        if (offset != lastOffset) {
            // Rewind a month back to find the day where the offset changes
            const dayDate = new Date(monthDate);
            dayDate.setUTCMonth(dayDate.getUTCMonth() - 1);
            const endDayTime = +monthDate;
            lastOffset = (0, $9157ce4fe9022419$export$9047ae35a63b6344)(timeZone, dayDate);
            while(+dayDate < endDayTime){
                // Day forward
                dayDate.setUTCDate(dayDate.getUTCDate() + 1);
                // Find the day where the offset changes
                const offset = (0, $9157ce4fe9022419$export$9047ae35a63b6344)(timeZone, dayDate);
                if (offset != lastOffset) {
                    // Rewind a day back to find the time where the offset changes
                    const hourDate = new Date(dayDate);
                    hourDate.setUTCDate(hourDate.getUTCDate() - 1);
                    const endHourTime = +dayDate;
                    lastOffset = (0, $9157ce4fe9022419$export$9047ae35a63b6344)(timeZone, hourDate);
                    while(+hourDate < endHourTime){
                        // Hour forward
                        hourDate.setUTCHours(hourDate.getUTCHours() + 1);
                        // Find the hour where the offset changes
                        const hourOffset = (0, $9157ce4fe9022419$export$9047ae35a63b6344)(timeZone, hourDate);
                        if (hourOffset !== lastOffset) changes.push({
                            date: new Date(hourDate),
                            change: hourOffset - lastOffset,
                            offset: hourOffset
                        });
                        lastOffset = hourOffset;
                    }
                }
                lastOffset = offset;
            }
        }
        lastOffset = offset;
    }
    return changes;
}





/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $567b27798158d1da$export$dfd9b671c89acc8e = 7;
const $567b27798158d1da$export$3913210603d8e9ae = 365.2425;
const $567b27798158d1da$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $567b27798158d1da$export$4dec998e48f9c246 = -$567b27798158d1da$export$81caae6e1cc7a622;
const $567b27798158d1da$export$4fad13613e88edc8 = 604800000;
const $567b27798158d1da$export$b76b1809a2898f9a = 86400000;
const $567b27798158d1da$export$91246f0b9bd9beff = 60000;
const $567b27798158d1da$export$7f72910d6dfd237a = 3600000;
const $567b27798158d1da$export$397c2d5776aa9055 = 1000;
const $567b27798158d1da$export$3633035e63cee86a = 525600;
const $567b27798158d1da$export$ab7da2ccd1075c38 = 43200;
const $567b27798158d1da$export$2423174df8cd3cd2 = 1440;
const $567b27798158d1da$export$f2f5ae5a8e2d8f9f = 60;
const $567b27798158d1da$export$3c58128db900d44e = 3;
const $567b27798158d1da$export$80d7e435f744f319 = 12;
const $567b27798158d1da$export$4db7641526e3241f = 4;
const $567b27798158d1da$export$698aec755e92c695 = 3600;
const $567b27798158d1da$export$a77c1a7ebebe2a5a = 60;
const $567b27798158d1da$export$815a9362476d2fe3 = $567b27798158d1da$export$698aec755e92c695 * 24;
const $567b27798158d1da$export$34804a017b31e2fe = $567b27798158d1da$export$815a9362476d2fe3 * 7;
const $567b27798158d1da$export$7271e9e3478110d1 = $567b27798158d1da$export$815a9362476d2fe3 * $567b27798158d1da$export$3913210603d8e9ae;
const $567b27798158d1da$export$8e6600bbdee7dabb = $567b27798158d1da$export$7271e9e3478110d1 / 12;
const $567b27798158d1da$export$be1dccf2de902d31 = $567b27798158d1da$export$8e6600bbdee7dabb * 3;
const $567b27798158d1da$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $fddf8cff9f079e87$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $567b27798158d1da$export$2a7b97929c48d47d) in date) return date[0, $567b27798158d1da$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$fddf8cff9f079e87$export$2e2bcd8739ae039 = $fddf8cff9f079e87$export$ead8a1812b171991;



function $0ff754644d3c01e4$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $fddf8cff9f079e87$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$0ff754644d3c01e4$export$2e2bcd8739ae039 = $0ff754644d3c01e4$export$e67a095c620b86fe;


function $568b1b2011306da0$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $fddf8cff9f079e87$export$ead8a1812b171991)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$568b1b2011306da0$export$2e2bcd8739ae039 = $568b1b2011306da0$export$dd412b56f1e4d8aa;



function $f338162c950e78a7$export$17c93e242b2d3a22(date, amount, options) {
    const _date = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $fddf8cff9f079e87$export$ead8a1812b171991)(options?.in || date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $fddf8cff9f079e87$export$ead8a1812b171991)(options?.in || date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
var // Fallback for modularized imports:
$f338162c950e78a7$export$2e2bcd8739ae039 = $f338162c950e78a7$export$17c93e242b2d3a22;


function $a499d4b7c7f933d0$export$ef501a2bb4f3ee6b(date, amount, options) {
    return (0, $568b1b2011306da0$export$dd412b56f1e4d8aa)(date, amount * 7, options);
}
var // Fallback for modularized imports:
$a499d4b7c7f933d0$export$2e2bcd8739ae039 = $a499d4b7c7f933d0$export$ef501a2bb4f3ee6b;


function $3e58f78ec3feb2f9$export$3d83eec43f4ea476(date, amount, options) {
    return (0, $f338162c950e78a7$export$17c93e242b2d3a22)(date, amount * 12, options);
}
var // Fallback for modularized imports:
$3e58f78ec3feb2f9$export$2e2bcd8739ae039 = $3e58f78ec3feb2f9$export$3d83eec43f4ea476;


function $020fa0be23177ed6$export$113002b5eff6e430(date) {
    const _date = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}



function $b60c0892a3f60201$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $fddf8cff9f079e87$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}




function $ee83c30eda21af24$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$ee83c30eda21af24$export$2e2bcd8739ae039 = $ee83c30eda21af24$export$63fa379ae8a9ba2;


function $445b7002ca244bfc$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $b60c0892a3f60201$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $ee83c30eda21af24$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $ee83c30eda21af24$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $020fa0be23177ed6$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $020fa0be23177ed6$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $567b27798158d1da$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$445b7002ca244bfc$export$2e2bcd8739ae039 = $445b7002ca244bfc$export$4a02e9c37dab4871;


function $1a80c80bb8f702c0$export$489984ac7c996389(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $b60c0892a3f60201$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
    return yearsDiff * 12 + monthsDiff;
}
var // Fallback for modularized imports:
$1a80c80bb8f702c0$export$2e2bcd8739ae039 = $1a80c80bb8f702c0$export$489984ac7c996389;


function $953e616f00001a27$export$17b5b2669f734364(context, interval) {
    const [start, end] = (0, $b60c0892a3f60201$export$9f53b88e82f64d8d)(context, interval.start, interval.end);
    return {
        start: start,
        end: end
    };
}



function $61cee19c7e32adc4$export$1c9322f2d2a5eed3(interval, options) {
    const { start: start, end: end } = (0, $953e616f00001a27$export$17b5b2669f734364)(options?.in, interval);
    let reversed = +start > +end;
    const endTime = reversed ? +start : +end;
    const date = reversed ? end : start;
    date.setHours(0, 0, 0, 0);
    date.setDate(1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+date <= endTime){
        dates.push((0, $fddf8cff9f079e87$export$ead8a1812b171991)(start, date));
        date.setMonth(date.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}
var // Fallback for modularized imports:
$61cee19c7e32adc4$export$2e2bcd8739ae039 = $61cee19c7e32adc4$export$1c9322f2d2a5eed3;



function $fcb73630c07a7f58$export$9b7f165f0a71d2a5(interval, options) {
    const { start: start, end: end } = (0, $953e616f00001a27$export$17b5b2669f734364)(options?.in, interval);
    let reversed = +start > +end;
    const endTime = reversed ? +start : +end;
    const date = reversed ? end : start;
    date.setHours(0, 0, 0, 0);
    date.setMonth(0, 1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+date <= endTime){
        dates.push((0, $fddf8cff9f079e87$export$ead8a1812b171991)(start, date));
        date.setFullYear(date.getFullYear() + step);
    }
    return reversed ? dates.reverse() : dates;
}
var // Fallback for modularized imports:
$fcb73630c07a7f58$export$2e2bcd8739ae039 = $fcb73630c07a7f58$export$9b7f165f0a71d2a5;

let $f25ae212d7545bbb$var$defaultOptions = {};
function $f25ae212d7545bbb$export$430a3269e24b912e() {
    return $f25ae212d7545bbb$var$defaultOptions;
}
function $f25ae212d7545bbb$export$95365be1b0704abc(newOptions) {
    $f25ae212d7545bbb$var$defaultOptions = newOptions;
}



function $d31b818d8fa354ce$export$ef8b6d9133084f4e(date, options) {
    const defaultOptions = (0, $f25ae212d7545bbb$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$d31b818d8fa354ce$export$2e2bcd8739ae039 = $d31b818d8fa354ce$export$ef8b6d9133084f4e;


function $fb1886d8801ac1e7$export$186cd934f32084be(date, options) {
    return (0, $d31b818d8fa354ce$export$ef8b6d9133084f4e)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$fb1886d8801ac1e7$export$2e2bcd8739ae039 = $fb1886d8801ac1e7$export$186cd934f32084be;


function $34efc093397364b0$export$a2258d9c4118825c(date, options) {
    const _date = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$34efc093397364b0$export$2e2bcd8739ae039 = $34efc093397364b0$export$a2258d9c4118825c;


function $2492100fac9d4bcd$export$8b7aa55c66d5569e(date, options) {
    const _date = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$2492100fac9d4bcd$export$2e2bcd8739ae039 = $2492100fac9d4bcd$export$8b7aa55c66d5569e;

const $4b3b5dca4d8bb6b2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $4b3b5dca4d8bb6b2$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $4b3b5dca4d8bb6b2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $ac68d3c0a1b497bc$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $5b0847dcfc899343$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $5b0847dcfc899343$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $5b0847dcfc899343$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $5b0847dcfc899343$export$cbf60ecb96cbb82f = {
    date: (0, $ac68d3c0a1b497bc$export$38e44e97ce4dbb7d)({
        formats: $5b0847dcfc899343$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $ac68d3c0a1b497bc$export$38e44e97ce4dbb7d)({
        formats: $5b0847dcfc899343$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $ac68d3c0a1b497bc$export$38e44e97ce4dbb7d)({
        formats: $5b0847dcfc899343$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $7877e79cb08b7ab4$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $7877e79cb08b7ab4$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$7877e79cb08b7ab4$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $9df32447a363ba40$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $6f0cbc1198c1a0cd$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $6f0cbc1198c1a0cd$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $6f0cbc1198c1a0cd$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $6f0cbc1198c1a0cd$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $6f0cbc1198c1a0cd$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $6f0cbc1198c1a0cd$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $6f0cbc1198c1a0cd$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $6f0cbc1198c1a0cd$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $6f0cbc1198c1a0cd$var$ordinalNumber,
    era: (0, $9df32447a363ba40$export$63596d6ee8878b25)({
        values: $6f0cbc1198c1a0cd$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $9df32447a363ba40$export$63596d6ee8878b25)({
        values: $6f0cbc1198c1a0cd$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $9df32447a363ba40$export$63596d6ee8878b25)({
        values: $6f0cbc1198c1a0cd$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $9df32447a363ba40$export$63596d6ee8878b25)({
        values: $6f0cbc1198c1a0cd$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $9df32447a363ba40$export$63596d6ee8878b25)({
        values: $6f0cbc1198c1a0cd$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $6f0cbc1198c1a0cd$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $4809e42f47de4898$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $4809e42f47de4898$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $4809e42f47de4898$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $4809e42f47de4898$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $4809e42f47de4898$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $b5e460607814bc59$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $d151ce2aef57bb3b$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $d151ce2aef57bb3b$var$parseOrdinalNumberPattern = /\d+/i;
const $d151ce2aef57bb3b$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $d151ce2aef57bb3b$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $d151ce2aef57bb3b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $d151ce2aef57bb3b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d151ce2aef57bb3b$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $d151ce2aef57bb3b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $d151ce2aef57bb3b$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $d151ce2aef57bb3b$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $d151ce2aef57bb3b$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $d151ce2aef57bb3b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $d151ce2aef57bb3b$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $b5e460607814bc59$export$fdaf2fd6d7edde95)({
        matchPattern: $d151ce2aef57bb3b$var$matchOrdinalNumberPattern,
        parsePattern: $d151ce2aef57bb3b$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $4809e42f47de4898$export$1430a0f35710914d)({
        matchPatterns: $d151ce2aef57bb3b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d151ce2aef57bb3b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $4809e42f47de4898$export$1430a0f35710914d)({
        matchPatterns: $d151ce2aef57bb3b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d151ce2aef57bb3b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $4809e42f47de4898$export$1430a0f35710914d)({
        matchPatterns: $d151ce2aef57bb3b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d151ce2aef57bb3b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $4809e42f47de4898$export$1430a0f35710914d)({
        matchPatterns: $d151ce2aef57bb3b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d151ce2aef57bb3b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $4809e42f47de4898$export$1430a0f35710914d)({
        matchPatterns: $d151ce2aef57bb3b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d151ce2aef57bb3b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $1e84530f7c33abaf$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $4b3b5dca4d8bb6b2$export$2c14ff85d6318973),
    formatLong: (0, $5b0847dcfc899343$export$cbf60ecb96cbb82f),
    formatRelative: (0, $7877e79cb08b7ab4$export$8fbbfd65594f46a0),
    localize: (0, $6f0cbc1198c1a0cd$export$b3bd0bc58e36cd63),
    match: (0, $d151ce2aef57bb3b$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$1e84530f7c33abaf$export$2e2bcd8739ae039 = $1e84530f7c33abaf$export$137380d9ce54f7f;





function $4fc7429dfc73d6f1$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$4fc7429dfc73d6f1$export$2e2bcd8739ae039 = $4fc7429dfc73d6f1$export$f91e89d3d0406102;



function $56170af38065a545$export$d3b42cd8452deec(date, options) {
    const _date = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $445b7002ca244bfc$export$4a02e9c37dab4871)(_date, (0, $4fc7429dfc73d6f1$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$56170af38065a545$export$2e2bcd8739ae039 = $56170af38065a545$export$d3b42cd8452deec;





function $5a0254889428bf11$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $f25ae212d7545bbb$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$5a0254889428bf11$export$2e2bcd8739ae039 = $5a0254889428bf11$export$42c81a444fbfb5d4;


function $3f1d2fed4bd06dfc$export$6173213f95a4431e(date, options) {
    return (0, $5a0254889428bf11$export$42c81a444fbfb5d4)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$3f1d2fed4bd06dfc$export$2e2bcd8739ae039 = $3f1d2fed4bd06dfc$export$6173213f95a4431e;






function $7550ba646b8516e0$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $fddf8cff9f079e87$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $3f1d2fed4bd06dfc$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $fddf8cff9f079e87$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $3f1d2fed4bd06dfc$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$7550ba646b8516e0$export$2e2bcd8739ae039 = $7550ba646b8516e0$export$3dbc52535f6f8fcc;



function $854a0be0a7a977bb$export$236bdfa374eb69a9(date, options) {
    const year = (0, $7550ba646b8516e0$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $fddf8cff9f079e87$export$ead8a1812b171991)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $3f1d2fed4bd06dfc$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$854a0be0a7a977bb$export$2e2bcd8739ae039 = $854a0be0a7a977bb$export$236bdfa374eb69a9;



function $600ddd1bbcdf2158$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $3f1d2fed4bd06dfc$export$6173213f95a4431e)(_date) - +(0, $854a0be0a7a977bb$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $567b27798158d1da$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$600ddd1bbcdf2158$export$2e2bcd8739ae039 = $600ddd1bbcdf2158$export$7cabdc5698b63e2f;











function $8fe1b6bd0eba6c66$export$12d572480ceb6e58(date, options) {
    const _date = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $f25ae212d7545bbb$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $fddf8cff9f079e87$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $5a0254889428bf11$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $fddf8cff9f079e87$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $5a0254889428bf11$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$8fe1b6bd0eba6c66$export$2e2bcd8739ae039 = $8fe1b6bd0eba6c66$export$12d572480ceb6e58;



function $9cd730f14b38e09b$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $f25ae212d7545bbb$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $8fe1b6bd0eba6c66$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $fddf8cff9f079e87$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $5a0254889428bf11$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$9cd730f14b38e09b$export$2e2bcd8739ae039 = $9cd730f14b38e09b$export$bb7b45bb8e74da0f;



function $55a92e939000650b$export$efe19b760242b2fc(date, options) {
    const _date = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $5a0254889428bf11$export$42c81a444fbfb5d4)(_date, options) - +(0, $9cd730f14b38e09b$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $567b27798158d1da$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$55a92e939000650b$export$2e2bcd8739ae039 = $55a92e939000650b$export$efe19b760242b2fc;



function $bb9af254e1a39bfd$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $b409926c24190da7$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $2235d14ebbe71fa9$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $2235d14ebbe71fa9$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $b409926c24190da7$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $8fe1b6bd0eba6c66$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $7550ba646b8516e0$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $b409926c24190da7$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $55a92e939000650b$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $600ddd1bbcdf2158$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $b409926c24190da7$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $56170af38065a545$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $2235d14ebbe71fa9$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $2235d14ebbe71fa9$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $2235d14ebbe71fa9$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $2235d14ebbe71fa9$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $2235d14ebbe71fa9$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $2235d14ebbe71fa9$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $b409926c24190da7$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $b409926c24190da7$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $b409926c24190da7$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $b409926c24190da7$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $b409926c24190da7$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $2235d14ebbe71fa9$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $2235d14ebbe71fa9$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $2235d14ebbe71fa9$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $2235d14ebbe71fa9$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $2235d14ebbe71fa9$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $2235d14ebbe71fa9$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $2235d14ebbe71fa9$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $2235d14ebbe71fa9$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $2235d14ebbe71fa9$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $2235d14ebbe71fa9$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $2235d14ebbe71fa9$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(minutes, 2);
}
function $2235d14ebbe71fa9$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $2235d14ebbe71fa9$var$formatTimezone(offset, delimiter);
}
function $2235d14ebbe71fa9$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $bb9af254e1a39bfd$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $3593841d297910e0$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $3593841d297910e0$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $3593841d297910e0$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $3593841d297910e0$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $3593841d297910e0$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $3593841d297910e0$var$timeLongFormatter(timePattern, formatLong));
};
const $3593841d297910e0$export$70cc8fd02856fd58 = {
    p: $3593841d297910e0$var$timeLongFormatter,
    P: $3593841d297910e0$var$dateTimeLongFormatter
};


const $a9353024f06b39ad$var$dayOfYearTokenRE = /^D+$/;
const $a9353024f06b39ad$var$weekYearTokenRE = /^Y+$/;
const $a9353024f06b39ad$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $a9353024f06b39ad$export$c6cc36aa33304772(token) {
    return $a9353024f06b39ad$var$dayOfYearTokenRE.test(token);
}
function $a9353024f06b39ad$export$c6b49d6dceb604a1(token) {
    return $a9353024f06b39ad$var$weekYearTokenRE.test(token);
}
function $a9353024f06b39ad$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $a9353024f06b39ad$var$message(token, format, input);
    console.warn(_message);
    if ($a9353024f06b39ad$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $a9353024f06b39ad$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $c141f6fee15c7ef5$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$c141f6fee15c7ef5$export$2e2bcd8739ae039 = $c141f6fee15c7ef5$export$871608497c498473;



function $c1ccf5f97744f181$export$1ea939691cdc45b8(date) {
    return !(!(0, $c141f6fee15c7ef5$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$c1ccf5f97744f181$export$2e2bcd8739ae039 = $c1ccf5f97744f181$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $638002f8a99b0703$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $638002f8a99b0703$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $638002f8a99b0703$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $638002f8a99b0703$var$doubleQuoteRegExp = /''/g;
const $638002f8a99b0703$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $638002f8a99b0703$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $f25ae212d7545bbb$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $1e84530f7c33abaf$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    if (!(0, $c1ccf5f97744f181$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($638002f8a99b0703$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $3593841d297910e0$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($638002f8a99b0703$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $638002f8a99b0703$var$cleanEscapedString(substring)
        };
        if ((0, $2235d14ebbe71fa9$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($638002f8a99b0703$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $a9353024f06b39ad$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $a9353024f06b39ad$export$c6cc36aa33304772)(token)) (0, $a9353024f06b39ad$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $2235d14ebbe71fa9$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $638002f8a99b0703$var$cleanEscapedString(input) {
    const matched = input.match($638002f8a99b0703$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($638002f8a99b0703$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$638002f8a99b0703$export$2e2bcd8739ae039 = $638002f8a99b0703$export$d9468344d3651243;


function $18258b7d5de142ee$export$6ce1b5acc29cb53b(date, options) {
    return (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in).getMonth();
}
var // Fallback for modularized imports:
$18258b7d5de142ee$export$2e2bcd8739ae039 = $18258b7d5de142ee$export$6ce1b5acc29cb53b;


function $1770d1af43db1ef7$export$5846dc2d57a5c860(date, options) {
    return (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in).getFullYear();
}
var // Fallback for modularized imports:
$1770d1af43db1ef7$export$2e2bcd8739ae039 = $1770d1af43db1ef7$export$5846dc2d57a5c860;


function $cc552e7c71320f16$export$e4de839670987035(date, dateToCompare) {
    return +(0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date) > +(0, $0ff754644d3c01e4$export$e67a095c620b86fe)(dateToCompare);
}
var // Fallback for modularized imports:
$cc552e7c71320f16$export$2e2bcd8739ae039 = $cc552e7c71320f16$export$e4de839670987035;


function $3aa7d660e20d5d29$export$5c007e10c6929c95(date, dateToCompare) {
    return +(0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date) < +(0, $0ff754644d3c01e4$export$e67a095c620b86fe)(dateToCompare);
}
var // Fallback for modularized imports:
$3aa7d660e20d5d29$export$2e2bcd8739ae039 = $3aa7d660e20d5d29$export$5c007e10c6929c95;



function $186c42293170c248$export$ea39ec197993aef0(laterDate, earlierDate, options) {
    const [dateLeft_, dateRight_] = (0, $b60c0892a3f60201$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return +(0, $ee83c30eda21af24$export$63fa379ae8a9ba2)(dateLeft_) === +(0, $ee83c30eda21af24$export$63fa379ae8a9ba2)(dateRight_);
}
var // Fallback for modularized imports:
$186c42293170c248$export$2e2bcd8739ae039 = $186c42293170c248$export$ea39ec197993aef0;


function $2ff8c83b1f07b7f1$export$a18c89cbd24170ff(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $b60c0892a3f60201$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear() && laterDate_.getMonth() === earlierDate_.getMonth();
}
var // Fallback for modularized imports:
$2ff8c83b1f07b7f1$export$2e2bcd8739ae039 = $2ff8c83b1f07b7f1$export$a18c89cbd24170ff;


function $7b3f0c9983afdfc4$export$5841f9eb9773f25f(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $b60c0892a3f60201$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$7b3f0c9983afdfc4$export$2e2bcd8739ae039 = $7b3f0c9983afdfc4$export$5841f9eb9773f25f;



function $64d0647cea9cb1e5$export$8960430cfd85939f(dates, options) {
    let result;
    let context = options?.in;
    dates.forEach((date)=>{
        // Use the first date object as the context function
        if (!context && typeof date === "object") context = (0, $fddf8cff9f079e87$export$ead8a1812b171991).bind(null, date);
        const date_ = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, context);
        if (!result || result < date_ || isNaN(+date_)) result = date_;
    });
    return (0, $fddf8cff9f079e87$export$ead8a1812b171991)(context, result || NaN);
}
var // Fallback for modularized imports:
$64d0647cea9cb1e5$export$2e2bcd8739ae039 = $64d0647cea9cb1e5$export$8960430cfd85939f;



function $a046dada6882424a$export$96ec731ed4dcb222(dates, options) {
    let result;
    let context = options?.in;
    dates.forEach((date)=>{
        // Use the first date object as the context function
        if (!context && typeof date === "object") context = (0, $fddf8cff9f079e87$export$ead8a1812b171991).bind(null, date);
        const date_ = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, context);
        if (!result || result > date_ || isNaN(+date_)) result = date_;
    });
    return (0, $fddf8cff9f079e87$export$ead8a1812b171991)(context, result || NaN);
}
var // Fallback for modularized imports:
$a046dada6882424a$export$2e2bcd8739ae039 = $a046dada6882424a$export$96ec731ed4dcb222;




function $ecdf57820639ab97$export$f645ddd439eb259d(date, options) {
    const _date = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $fddf8cff9f079e87$export$ead8a1812b171991)(_date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}
var // Fallback for modularized imports:
$ecdf57820639ab97$export$2e2bcd8739ae039 = $ecdf57820639ab97$export$f645ddd439eb259d;



function $6a11b8d9c0cccc07$export$63264690f8e36790(date, month, options) {
    const _date = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const midMonth = (0, $fddf8cff9f079e87$export$ead8a1812b171991)(options?.in || date, 0);
    midMonth.setFullYear(year, month, 15);
    midMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $ecdf57820639ab97$export$f645ddd439eb259d)(midMonth);
    // Set the earlier date, allows to wrap Jan 31 to Feb 28
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}
var // Fallback for modularized imports:
$6a11b8d9c0cccc07$export$2e2bcd8739ae039 = $6a11b8d9c0cccc07$export$63264690f8e36790;



function $190f37e8bbd26230$export$a8408b6c5639cab7(date, year, options) {
    const date_ = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+date_)) return (0, $fddf8cff9f079e87$export$ead8a1812b171991)(options?.in || date, NaN);
    date_.setFullYear(year);
    return date_;
}
var // Fallback for modularized imports:
$190f37e8bbd26230$export$2e2bcd8739ae039 = $190f37e8bbd26230$export$a8408b6c5639cab7;


function $84c7a9fe404daedc$export$a5a3b454ada2268e(date, options) {
    const _date = (0, $0ff754644d3c01e4$export$e67a095c620b86fe)(date, options?.in);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$84c7a9fe404daedc$export$2e2bcd8739ae039 = $84c7a9fe404daedc$export$a5a3b454ada2268e;


const $4a9bcccf150c63f5$var$FIVE_WEEKS = 5;
const $4a9bcccf150c63f5$var$FOUR_WEEKS = 4;
function $4a9bcccf150c63f5$export$343e859fa2b0f8fe(month, dateLib) {
    // Get the first day of the month
    const firstDayOfMonth = dateLib.startOfMonth(month);
    // Get the day of the week for the first day of the month (1-7, where 1 is Monday)
    const firstDayOfWeek = firstDayOfMonth.getDay() > 0 ? firstDayOfMonth.getDay() : 7;
    const broadcastStartDate = dateLib.addDays(month, -firstDayOfWeek + 1);
    const lastDateOfLastWeek = dateLib.addDays(broadcastStartDate, $4a9bcccf150c63f5$var$FIVE_WEEKS * 7 - 1);
    const numberOfWeeks = dateLib.getMonth(month) === dateLib.getMonth(lastDateOfLastWeek) ? $4a9bcccf150c63f5$var$FIVE_WEEKS : $4a9bcccf150c63f5$var$FOUR_WEEKS;
    return numberOfWeeks;
}


/**
 * Returns the start date of the week in the broadcast calendar.
 *
 * The broadcast week starts on Monday. If the first day of the month is not a
 * Monday, this function calculates the previous Monday as the start of the
 * broadcast week.
 *
 * @since 9.4.0
 * @param date The date for which to calculate the start of the broadcast week.
 * @param dateLib The date library to use for date manipulation.
 * @returns The start date of the broadcast week.
 */ function $9cd85a0e277557ee$export$b48393ee26dd6e5b(date, dateLib) {
    const firstOfMonth = dateLib.startOfMonth(date);
    const dayOfWeek = firstOfMonth.getDay();
    if (dayOfWeek === 1) return firstOfMonth;
    else if (dayOfWeek === 0) return dateLib.addDays(firstOfMonth, -6);
    else return dateLib.addDays(firstOfMonth, -1 * (dayOfWeek - 1));
}


function $d4007a01b6f233f1$export$b29eb013c51db966(date, dateLib) {
    const startDate = (0, $9cd85a0e277557ee$export$b48393ee26dd6e5b)(date, dateLib);
    const numberOfWeeks = (0, $4a9bcccf150c63f5$export$343e859fa2b0f8fe)(date, dateLib);
    const endDate = dateLib.addDays(startDate, numberOfWeeks * 7 - 1);
    return endDate;
}





const $83244f94822f3936$export$137380d9ce54f7f = {
    ...(0, $1e84530f7c33abaf$export$137380d9ce54f7f),
    labels: {
        labelDayButton: (date, modifiers, options, dateLib)=>{
            let formatDate;
            if (dateLib && typeof dateLib.format === "function") formatDate = dateLib.format.bind(dateLib);
            else formatDate = (d, pattern)=>(0, $638002f8a99b0703$export$d9468344d3651243)(d, pattern, {
                    locale: (0, $1e84530f7c33abaf$export$137380d9ce54f7f),
                    ...options
                });
            let label = formatDate(date, "PPPP");
            if (modifiers.today) label = `Today, ${label}`;
            if (modifiers.selected) label = `${label}, selected`;
            return label;
        },
        labelMonthDropdown: "Choose the Month",
        labelNext: "Go to the Next Month",
        labelPrevious: "Go to the Previous Month",
        labelWeekNumber: (weekNumber)=>`Week ${weekNumber}`,
        labelYearDropdown: "Choose the Year",
        labelGrid: (date, options, dateLib)=>{
            let formatDate;
            if (dateLib && typeof dateLib.format === "function") formatDate = dateLib.format.bind(dateLib);
            else formatDate = (d, pattern)=>(0, $638002f8a99b0703$export$d9468344d3651243)(d, pattern, {
                    locale: (0, $1e84530f7c33abaf$export$137380d9ce54f7f),
                    ...options
                });
            return formatDate(date, "LLLL yyyy");
        },
        labelGridcell: (date, modifiers, options, dateLib)=>{
            let formatDate;
            if (dateLib && typeof dateLib.format === "function") formatDate = dateLib.format.bind(dateLib);
            else formatDate = (d, pattern)=>(0, $638002f8a99b0703$export$d9468344d3651243)(d, pattern, {
                    locale: (0, $1e84530f7c33abaf$export$137380d9ce54f7f),
                    ...options
                });
            let label = formatDate(date, "PPPP");
            if (modifiers?.today) label = `Today, ${label}`;
            return label;
        },
        labelNav: "Navigation bar",
        labelWeekNumberHeader: "Week Number",
        labelWeekday: (date, options, dateLib)=>{
            let formatDate;
            if (dateLib && typeof dateLib.format === "function") formatDate = dateLib.format.bind(dateLib);
            else formatDate = (d, pattern)=>(0, $638002f8a99b0703$export$d9468344d3651243)(d, pattern, {
                    locale: (0, $1e84530f7c33abaf$export$137380d9ce54f7f),
                    ...options
                });
            return formatDate(date, "cccc");
        }
    }
};


class $5bc78e2210779f86$export$87f71ed78036473c {
    /**
     * Creates an instance of `DateLib`.
     *
     * @param options Configuration options for the date library.
     * @param overrides Custom overrides for the date library functions.
     */ constructor(options, overrides){
        /**
         * Creates a new `Date` object representing today's date.
         *
         * @since 9.5.0
         * @returns A `Date` object for today's date.
         */ this.today = ()=>{
            if (this.overrides?.today) return this.overrides.today();
            if (this.options.timeZone) return (0, $8f2a7769b12c0486$export$8de43e28dd4af6bd).tz(this.options.timeZone);
            const DateCtor = this.options.Date ?? Date;
            return new DateCtor();
        };
        /**
         * Creates a new `Date` object with the specified year, month, and day.
         *
         * @since 9.5.0
         * @param year The year.
         * @param monthIndex The month (0-11).
         * @param date The day of the month.
         * @returns A new `Date` object.
         */ this.newDate = (year, monthIndex, date)=>{
            if (this.overrides?.newDate) return this.overrides.newDate(year, monthIndex, date);
            if (this.options.timeZone) return new (0, $8f2a7769b12c0486$export$8de43e28dd4af6bd)(year, monthIndex, date, this.options.timeZone);
            return new Date(year, monthIndex, date);
        };
        /**
         * Adds the specified number of days to the given date.
         *
         * @param date The date to add days to.
         * @param amount The number of days to add.
         * @returns The new date with the days added.
         */ this.addDays = (date, amount)=>{
            return this.overrides?.addDays ? this.overrides.addDays(date, amount) : (0, $568b1b2011306da0$export$dd412b56f1e4d8aa)(date, amount);
        };
        /**
         * Adds the specified number of months to the given date.
         *
         * @param date The date to add months to.
         * @param amount The number of months to add.
         * @returns The new date with the months added.
         */ this.addMonths = (date, amount)=>{
            return this.overrides?.addMonths ? this.overrides.addMonths(date, amount) : (0, $f338162c950e78a7$export$17c93e242b2d3a22)(date, amount);
        };
        /**
         * Adds the specified number of weeks to the given date.
         *
         * @param date The date to add weeks to.
         * @param amount The number of weeks to add.
         * @returns The new date with the weeks added.
         */ this.addWeeks = (date, amount)=>{
            return this.overrides?.addWeeks ? this.overrides.addWeeks(date, amount) : (0, $a499d4b7c7f933d0$export$ef501a2bb4f3ee6b)(date, amount);
        };
        /**
         * Adds the specified number of years to the given date.
         *
         * @param date The date to add years to.
         * @param amount The number of years to add.
         * @returns The new date with the years added.
         */ this.addYears = (date, amount)=>{
            return this.overrides?.addYears ? this.overrides.addYears(date, amount) : (0, $3e58f78ec3feb2f9$export$3d83eec43f4ea476)(date, amount);
        };
        /**
         * Returns the number of calendar days between the given dates.
         *
         * @param dateLeft The later date.
         * @param dateRight The earlier date.
         * @returns The number of calendar days between the dates.
         */ this.differenceInCalendarDays = (dateLeft, dateRight)=>{
            return this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(dateLeft, dateRight) : (0, $445b7002ca244bfc$export$4a02e9c37dab4871)(dateLeft, dateRight);
        };
        /**
         * Returns the number of calendar months between the given dates.
         *
         * @param dateLeft The later date.
         * @param dateRight The earlier date.
         * @returns The number of calendar months between the dates.
         */ this.differenceInCalendarMonths = (dateLeft, dateRight)=>{
            return this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(dateLeft, dateRight) : (0, $1a80c80bb8f702c0$export$489984ac7c996389)(dateLeft, dateRight);
        };
        /**
         * Returns the months between the given dates.
         *
         * @param interval The interval to get the months for.
         */ this.eachMonthOfInterval = (interval)=>{
            return this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(interval) : (0, $61cee19c7e32adc4$export$1c9322f2d2a5eed3)(interval);
        };
        /**
         * Returns the years between the given dates.
         *
         * @since 9.11.1
         * @param interval The interval to get the years for.
         * @returns The array of years in the interval.
         */ this.eachYearOfInterval = (interval)=>{
            const years = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(interval) : (0, $fcb73630c07a7f58$export$9b7f165f0a71d2a5)(interval);
            // Remove duplicates that may happen across DST transitions (e.g., "America/Sao_Paulo")
            // See https://github.com/date-fns/tz/issues/72
            const uniqueYears = new Set(years.map((d)=>this.getYear(d)));
            if (uniqueYears.size === years.length) // No duplicates, return as is
            return years;
            // Rebuild the array to ensure one date per year
            const yearsArray = [];
            uniqueYears.forEach((y)=>{
                yearsArray.push(new Date(y, 0, 1));
            });
            return yearsArray;
        };
        /**
         * Returns the end of the broadcast week for the given date.
         *
         * @param date The original date.
         * @returns The end of the broadcast week.
         */ this.endOfBroadcastWeek = (date)=>{
            return this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(date) : (0, $d4007a01b6f233f1$export$b29eb013c51db966)(date, this);
        };
        /**
         * Returns the end of the ISO week for the given date.
         *
         * @param date The original date.
         * @returns The end of the ISO week.
         */ this.endOfISOWeek = (date)=>{
            return this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(date) : (0, $fb1886d8801ac1e7$export$186cd934f32084be)(date);
        };
        /**
         * Returns the end of the month for the given date.
         *
         * @param date The original date.
         * @returns The end of the month.
         */ this.endOfMonth = (date)=>{
            return this.overrides?.endOfMonth ? this.overrides.endOfMonth(date) : (0, $34efc093397364b0$export$a2258d9c4118825c)(date);
        };
        /**
         * Returns the end of the week for the given date.
         *
         * @param date The original date.
         * @returns The end of the week.
         */ this.endOfWeek = (date, options)=>{
            return this.overrides?.endOfWeek ? this.overrides.endOfWeek(date, options) : (0, $d31b818d8fa354ce$export$ef8b6d9133084f4e)(date, this.options);
        };
        /**
         * Returns the end of the year for the given date.
         *
         * @param date The original date.
         * @returns The end of the year.
         */ this.endOfYear = (date)=>{
            return this.overrides?.endOfYear ? this.overrides.endOfYear(date) : (0, $2492100fac9d4bcd$export$8b7aa55c66d5569e)(date);
        };
        /**
         * Formats the given date using the specified format string.
         *
         * @param date The date to format.
         * @param formatStr The format string.
         * @returns The formatted date string.
         */ this.format = (date, formatStr, _options)=>{
            const formatted = this.overrides?.format ? this.overrides.format(date, formatStr, this.options) : (0, $638002f8a99b0703$export$d9468344d3651243)(date, formatStr, this.options);
            if (this.options.numerals && this.options.numerals !== "latn") return this.replaceDigits(formatted);
            return formatted;
        };
        /**
         * Returns the ISO week number for the given date.
         *
         * @param date The date to get the ISO week number for.
         * @returns The ISO week number.
         */ this.getISOWeek = (date)=>{
            return this.overrides?.getISOWeek ? this.overrides.getISOWeek(date) : (0, $600ddd1bbcdf2158$export$7cabdc5698b63e2f)(date);
        };
        /**
         * Returns the month of the given date.
         *
         * @param date The date to get the month for.
         * @returns The month.
         */ this.getMonth = (date, _options)=>{
            return this.overrides?.getMonth ? this.overrides.getMonth(date, this.options) : (0, $18258b7d5de142ee$export$6ce1b5acc29cb53b)(date, this.options);
        };
        /**
         * Returns the year of the given date.
         *
         * @param date The date to get the year for.
         * @returns The year.
         */ this.getYear = (date, _options)=>{
            return this.overrides?.getYear ? this.overrides.getYear(date, this.options) : (0, $1770d1af43db1ef7$export$5846dc2d57a5c860)(date, this.options);
        };
        /**
         * Returns the local week number for the given date.
         *
         * @param date The date to get the week number for.
         * @returns The week number.
         */ this.getWeek = (date, _options)=>{
            return this.overrides?.getWeek ? this.overrides.getWeek(date, this.options) : (0, $55a92e939000650b$export$efe19b760242b2fc)(date, this.options);
        };
        /**
         * Checks if the first date is after the second date.
         *
         * @param date The date to compare.
         * @param dateToCompare The date to compare with.
         * @returns True if the first date is after the second date.
         */ this.isAfter = (date, dateToCompare)=>{
            return this.overrides?.isAfter ? this.overrides.isAfter(date, dateToCompare) : (0, $cc552e7c71320f16$export$e4de839670987035)(date, dateToCompare);
        };
        /**
         * Checks if the first date is before the second date.
         *
         * @param date The date to compare.
         * @param dateToCompare The date to compare with.
         * @returns True if the first date is before the second date.
         */ this.isBefore = (date, dateToCompare)=>{
            return this.overrides?.isBefore ? this.overrides.isBefore(date, dateToCompare) : (0, $3aa7d660e20d5d29$export$5c007e10c6929c95)(date, dateToCompare);
        };
        /**
         * Checks if the given value is a Date object.
         *
         * @param value The value to check.
         * @returns True if the value is a Date object.
         */ this.isDate = (value)=>{
            return this.overrides?.isDate ? this.overrides.isDate(value) : (0, $c141f6fee15c7ef5$export$871608497c498473)(value);
        };
        /**
         * Checks if the given dates are on the same day.
         *
         * @param dateLeft The first date to compare.
         * @param dateRight The second date to compare.
         * @returns True if the dates are on the same day.
         */ this.isSameDay = (dateLeft, dateRight)=>{
            return this.overrides?.isSameDay ? this.overrides.isSameDay(dateLeft, dateRight) : (0, $186c42293170c248$export$ea39ec197993aef0)(dateLeft, dateRight);
        };
        /**
         * Checks if the given dates are in the same month.
         *
         * @param dateLeft The first date to compare.
         * @param dateRight The second date to compare.
         * @returns True if the dates are in the same month.
         */ this.isSameMonth = (dateLeft, dateRight)=>{
            return this.overrides?.isSameMonth ? this.overrides.isSameMonth(dateLeft, dateRight) : (0, $2ff8c83b1f07b7f1$export$a18c89cbd24170ff)(dateLeft, dateRight);
        };
        /**
         * Checks if the given dates are in the same year.
         *
         * @param dateLeft The first date to compare.
         * @param dateRight The second date to compare.
         * @returns True if the dates are in the same year.
         */ this.isSameYear = (dateLeft, dateRight)=>{
            return this.overrides?.isSameYear ? this.overrides.isSameYear(dateLeft, dateRight) : (0, $7b3f0c9983afdfc4$export$5841f9eb9773f25f)(dateLeft, dateRight);
        };
        /**
         * Returns the latest date in the given array of dates.
         *
         * @param dates The array of dates to compare.
         * @returns The latest date.
         */ this.max = (dates)=>{
            return this.overrides?.max ? this.overrides.max(dates) : (0, $64d0647cea9cb1e5$export$8960430cfd85939f)(dates);
        };
        /**
         * Returns the earliest date in the given array of dates.
         *
         * @param dates The array of dates to compare.
         * @returns The earliest date.
         */ this.min = (dates)=>{
            return this.overrides?.min ? this.overrides.min(dates) : (0, $a046dada6882424a$export$96ec731ed4dcb222)(dates);
        };
        /**
         * Sets the month of the given date.
         *
         * @param date The date to set the month on.
         * @param month The month to set (0-11).
         * @returns The new date with the month set.
         */ this.setMonth = (date, month)=>{
            return this.overrides?.setMonth ? this.overrides.setMonth(date, month) : (0, $6a11b8d9c0cccc07$export$63264690f8e36790)(date, month);
        };
        /**
         * Sets the year of the given date.
         *
         * @param date The date to set the year on.
         * @param year The year to set.
         * @returns The new date with the year set.
         */ this.setYear = (date, year)=>{
            return this.overrides?.setYear ? this.overrides.setYear(date, year) : (0, $190f37e8bbd26230$export$a8408b6c5639cab7)(date, year);
        };
        /**
         * Returns the start of the broadcast week for the given date.
         *
         * @param date The original date.
         * @returns The start of the broadcast week.
         */ this.startOfBroadcastWeek = (date, _dateLib)=>{
            return this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(date, this) : (0, $9cd85a0e277557ee$export$b48393ee26dd6e5b)(date, this);
        };
        /**
         * Returns the start of the day for the given date.
         *
         * @param date The original date.
         * @returns The start of the day.
         */ this.startOfDay = (date)=>{
            return this.overrides?.startOfDay ? this.overrides.startOfDay(date) : (0, $ee83c30eda21af24$export$63fa379ae8a9ba2)(date);
        };
        /**
         * Returns the start of the ISO week for the given date.
         *
         * @param date The original date.
         * @returns The start of the ISO week.
         */ this.startOfISOWeek = (date)=>{
            return this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(date) : (0, $3f1d2fed4bd06dfc$export$6173213f95a4431e)(date);
        };
        /**
         * Returns the start of the month for the given date.
         *
         * @param date The original date.
         * @returns The start of the month.
         */ this.startOfMonth = (date)=>{
            return this.overrides?.startOfMonth ? this.overrides.startOfMonth(date) : (0, $84c7a9fe404daedc$export$a5a3b454ada2268e)(date);
        };
        /**
         * Returns the start of the week for the given date.
         *
         * @param date The original date.
         * @returns The start of the week.
         */ this.startOfWeek = (date, _options)=>{
            return this.overrides?.startOfWeek ? this.overrides.startOfWeek(date, this.options) : (0, $5a0254889428bf11$export$42c81a444fbfb5d4)(date, this.options);
        };
        /**
         * Returns the start of the year for the given date.
         *
         * @param date The original date.
         * @returns The start of the year.
         */ this.startOfYear = (date)=>{
            return this.overrides?.startOfYear ? this.overrides.startOfYear(date) : (0, $4fc7429dfc73d6f1$export$f91e89d3d0406102)(date);
        };
        this.options = {
            locale: (0, $83244f94822f3936$export$137380d9ce54f7f),
            ...options
        };
        this.overrides = overrides;
    }
    /**
     * Generates a mapping of Arabic digits (0-9) to the target numbering system
     * digits.
     *
     * @since 9.5.0
     * @returns A record mapping Arabic digits to the target numerals.
     */ getDigitMap() {
        const { numerals: numerals = "latn" } = this.options;
        // Use Intl.NumberFormat to create a formatter with the specified numbering system
        const formatter = new Intl.NumberFormat("en-US", {
            numberingSystem: numerals
        });
        // Map Arabic digits (0-9) to the target numerals
        const digitMap = {};
        for(let i = 0; i < 10; i++)digitMap[i.toString()] = formatter.format(i);
        return digitMap;
    }
    /**
     * Replaces Arabic digits in a string with the target numbering system digits.
     *
     * @since 9.5.0
     * @param input The string containing Arabic digits.
     * @returns The string with digits replaced.
     */ replaceDigits(input) {
        const digitMap = this.getDigitMap();
        return input.replace(/\d/g, (digit)=>digitMap[digit] || digit);
    }
    /**
     * Formats a number using the configured numbering system.
     *
     * @since 9.5.0
     * @param value The number to format.
     * @returns The formatted number as a string.
     */ formatNumber(value) {
        return this.replaceDigits(value.toString());
    }
    /**
     * Returns the preferred ordering for month and year labels for the current
     * locale.
     */ getMonthYearOrder() {
        const code = this.options.locale?.code;
        if (!code) return "month-first";
        return $5bc78e2210779f86$export$87f71ed78036473c.yearFirstLocales.has(code) ? "year-first" : "month-first";
    }
    /**
     * Formats the month/year pair respecting locale conventions.
     *
     * @since 9.11.0
     */ formatMonthYear(date) {
        const { locale: locale, timeZone: timeZone, numerals: numerals } = this.options;
        const localeCode = locale?.code;
        if (localeCode && $5bc78e2210779f86$export$87f71ed78036473c.yearFirstLocales.has(localeCode)) try {
            const intl = new Intl.DateTimeFormat(localeCode, {
                month: "long",
                year: "numeric",
                timeZone: timeZone,
                numberingSystem: numerals
            });
            const formatted = intl.format(date);
            return formatted;
        } catch  {
        // Fallback to date-fns formatting below.
        }
        const pattern = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
        return this.format(date, pattern);
    }
}
$5bc78e2210779f86$export$87f71ed78036473c.yearFirstLocales = new Set([
    "eu",
    "hu",
    "ja",
    "ja-Hira",
    "ja-JP",
    "ko",
    "ko-KR",
    "lt",
    "lt-LT",
    "lv",
    "lv-LV",
    "mn",
    "mn-MN",
    "zh",
    "zh-CN",
    "zh-HK",
    "zh-TW"
]);
const $5bc78e2210779f86$export$6575cc37c71cbcd2 = new $5bc78e2210779f86$export$87f71ed78036473c();


/**
 * Enum representing the UI elements composing DayPicker. These elements are
 * mapped to {@link CustomComponents}, {@link ClassNames}, and {@link Styles}.
 *
 * Some elements are extended by flags and modifiers.
 */ var $d4e669abc392b351$export$4b08aed5f1ec6952;
(function(UI) {
    /** The root component displaying the months and the navigation bar. */ UI["Root"] = "root";
    /** The Chevron SVG element used by navigation buttons and dropdowns. */ UI["Chevron"] = "chevron";
    /**
     * The grid cell with the day's date. Extended by {@link DayFlag} and
     * {@link SelectionState}.
     */ UI["Day"] = "day";
    /** The button containing the formatted day's date, inside the grid cell. */ UI["DayButton"] = "day_button";
    /** The caption label of the month (when not showing the dropdown navigation). */ UI["CaptionLabel"] = "caption_label";
    /** The container of the dropdown navigation (when enabled). */ UI["Dropdowns"] = "dropdowns";
    /** The dropdown element to select for years and months. */ UI["Dropdown"] = "dropdown";
    /** The container element of the dropdown. */ UI["DropdownRoot"] = "dropdown_root";
    /** The root element of the footer. */ UI["Footer"] = "footer";
    /** The month grid. */ UI["MonthGrid"] = "month_grid";
    /** Contains the dropdown navigation or the caption label. */ UI["MonthCaption"] = "month_caption";
    /** The dropdown with the months. */ UI["MonthsDropdown"] = "months_dropdown";
    /** Wrapper of the month grid. */ UI["Month"] = "month";
    /** The container of the displayed months. */ UI["Months"] = "months";
    /** The navigation bar with the previous and next buttons. */ UI["Nav"] = "nav";
    /**
     * The next month button in the navigation. *
     *
     * @since 9.1.0
     */ UI["NextMonthButton"] = "button_next";
    /**
     * The previous month button in the navigation.
     *
     * @since 9.1.0
     */ UI["PreviousMonthButton"] = "button_previous";
    /** The row containing the week. */ UI["Week"] = "week";
    /** The group of row weeks in a month (`tbody`). */ UI["Weeks"] = "weeks";
    /** The column header with the weekday. */ UI["Weekday"] = "weekday";
    /** The row grouping the weekdays in the column headers. */ UI["Weekdays"] = "weekdays";
    /** The cell containing the week number. */ UI["WeekNumber"] = "week_number";
    /** The cell header of the week numbers column. */ UI["WeekNumberHeader"] = "week_number_header";
    /** The dropdown with the years. */ UI["YearsDropdown"] = "years_dropdown";
})($d4e669abc392b351$export$4b08aed5f1ec6952 || ($d4e669abc392b351$export$4b08aed5f1ec6952 = {}));
var $d4e669abc392b351$export$c2fd8ae3501086f5;
(function(DayFlag) {
    /** The day is disabled. */ DayFlag["disabled"] = "disabled";
    /** The day is hidden. */ DayFlag["hidden"] = "hidden";
    /** The day is outside the current month. */ DayFlag["outside"] = "outside";
    /** The day is focused. */ DayFlag["focused"] = "focused";
    /** The day is today. */ DayFlag["today"] = "today";
})($d4e669abc392b351$export$c2fd8ae3501086f5 || ($d4e669abc392b351$export$c2fd8ae3501086f5 = {}));
var $d4e669abc392b351$export$2255d92a85eab347;
(function(SelectionState) {
    /** The day is at the end of a selected range. */ SelectionState["range_end"] = "range_end";
    /** The day is at the middle of a selected range. */ SelectionState["range_middle"] = "range_middle";
    /** The day is at the start of a selected range. */ SelectionState["range_start"] = "range_start";
    /** The day is selected. */ SelectionState["selected"] = "selected";
})($d4e669abc392b351$export$2255d92a85eab347 || ($d4e669abc392b351$export$2255d92a85eab347 = {}));
var $d4e669abc392b351$export$c35d437ae5945fcd;
(function(Animation) {
    /** The entering weeks when they appear before the exiting month. */ Animation["weeks_before_enter"] = "weeks_before_enter";
    /** The exiting weeks when they disappear before the entering month. */ Animation["weeks_before_exit"] = "weeks_before_exit";
    /** The entering weeks when they appear after the exiting month. */ Animation["weeks_after_enter"] = "weeks_after_enter";
    /** The exiting weeks when they disappear after the entering month. */ Animation["weeks_after_exit"] = "weeks_after_exit";
    /** The entering caption when it appears after the exiting month. */ Animation["caption_after_enter"] = "caption_after_enter";
    /** The exiting caption when it disappears after the entering month. */ Animation["caption_after_exit"] = "caption_after_exit";
    /** The entering caption when it appears before the exiting month. */ Animation["caption_before_enter"] = "caption_before_enter";
    /** The exiting caption when it disappears before the entering month. */ Animation["caption_before_exit"] = "caption_before_exit";
})($d4e669abc392b351$export$c35d437ae5945fcd || ($d4e669abc392b351$export$c35d437ae5945fcd = {}));




function $002f4c7bfd16f136$export$ea4b24aaa0e5da4a(range, date, excludeEnds = false, dateLib = (0, $5bc78e2210779f86$export$6575cc37c71cbcd2)) {
    let { from: from, to: to } = range;
    const { differenceInCalendarDays: differenceInCalendarDays, isSameDay: isSameDay } = dateLib;
    if (from && to) {
        const isRangeInverted = differenceInCalendarDays(to, from) < 0;
        if (isRangeInverted) [from, to] = [
            to,
            from
        ];
        const isInRange = differenceInCalendarDays(date, from) >= (excludeEnds ? 1 : 0) && differenceInCalendarDays(to, date) >= (excludeEnds ? 1 : 0);
        return isInRange;
    }
    if (!excludeEnds && to) return isSameDay(to, date);
    if (!excludeEnds && from) return isSameDay(from, date);
    return false;
}


/**
 * Checks if the given value is of type {@link DateInterval}.
 *
 * @param matcher - The value to check.
 * @returns `true` if the value is a {@link DateInterval}, otherwise `false`.
 * @group Utilities
 */ function $73b4472bf8fc0b4f$export$654311eaff47f3cd(matcher) {
    return Boolean(matcher && typeof matcher === "object" && "before" in matcher && "after" in matcher);
}
function $73b4472bf8fc0b4f$export$dd455b9c98fea187(value) {
    return Boolean(value && typeof value === "object" && "from" in value);
}
function $73b4472bf8fc0b4f$export$4760905e07020cd4(value) {
    return Boolean(value && typeof value === "object" && "after" in value);
}
function $73b4472bf8fc0b4f$export$a3bef2c4e855ef4e(value) {
    return Boolean(value && typeof value === "object" && "before" in value);
}
function $73b4472bf8fc0b4f$export$483c833837970a3(value) {
    return Boolean(value && typeof value === "object" && "dayOfWeek" in value);
}
function $73b4472bf8fc0b4f$export$1586b56a557d6c60(value, dateLib) {
    return Array.isArray(value) && value.every(dateLib.isDate);
}


function $be70a17d869d8600$export$9c6809d9e0449c2e(date, matchers, dateLib = (0, $5bc78e2210779f86$export$6575cc37c71cbcd2)) {
    const matchersArr = !Array.isArray(matchers) ? [
        matchers
    ] : matchers;
    const { isSameDay: isSameDay, differenceInCalendarDays: differenceInCalendarDays, isAfter: isAfter } = dateLib;
    return matchersArr.some((matcher)=>{
        if (typeof matcher === "boolean") return matcher;
        if (dateLib.isDate(matcher)) return isSameDay(date, matcher);
        if ((0, $73b4472bf8fc0b4f$export$1586b56a557d6c60)(matcher, dateLib)) return matcher.some((matcherDate)=>isSameDay(date, matcherDate));
        if ((0, $73b4472bf8fc0b4f$export$dd455b9c98fea187)(matcher)) return (0, $002f4c7bfd16f136$export$ea4b24aaa0e5da4a)(matcher, date, false, dateLib);
        if ((0, $73b4472bf8fc0b4f$export$483c833837970a3)(matcher)) {
            if (!Array.isArray(matcher.dayOfWeek)) return matcher.dayOfWeek === date.getDay();
            return matcher.dayOfWeek.includes(date.getDay());
        }
        if ((0, $73b4472bf8fc0b4f$export$654311eaff47f3cd)(matcher)) {
            const diffBefore = differenceInCalendarDays(matcher.before, date);
            const diffAfter = differenceInCalendarDays(matcher.after, date);
            const isDayBefore = diffBefore > 0;
            const isDayAfter = diffAfter < 0;
            const isClosedInterval = isAfter(matcher.before, matcher.after);
            if (isClosedInterval) return isDayAfter && isDayBefore;
            else return isDayBefore || isDayAfter;
        }
        if ((0, $73b4472bf8fc0b4f$export$4760905e07020cd4)(matcher)) return differenceInCalendarDays(date, matcher.after) > 0;
        if ((0, $73b4472bf8fc0b4f$export$a3bef2c4e855ef4e)(matcher)) return differenceInCalendarDays(matcher.before, date) > 0;
        if (typeof matcher === "function") return matcher(date);
        return false;
    });
}


function $daaccbc85e0325f4$export$d8e8c7c9d8ef915a(days, props, navStart, navEnd, dateLib) {
    const { disabled: disabled, hidden: hidden, modifiers: modifiers, showOutsideDays: showOutsideDays, broadcastCalendar: broadcastCalendar, today: today = dateLib.today() } = props;
    const { isSameDay: isSameDay, isSameMonth: isSameMonth, startOfMonth: startOfMonth, isBefore: isBefore, endOfMonth: endOfMonth, isAfter: isAfter } = dateLib;
    const computedNavStart = navStart && startOfMonth(navStart);
    const computedNavEnd = navEnd && endOfMonth(navEnd);
    const internalModifiersMap = {
        [(0, $d4e669abc392b351$export$c2fd8ae3501086f5).focused]: [],
        [(0, $d4e669abc392b351$export$c2fd8ae3501086f5).outside]: [],
        [(0, $d4e669abc392b351$export$c2fd8ae3501086f5).disabled]: [],
        [(0, $d4e669abc392b351$export$c2fd8ae3501086f5).hidden]: [],
        [(0, $d4e669abc392b351$export$c2fd8ae3501086f5).today]: []
    };
    const customModifiersMap = {};
    for (const day of days){
        const { date: date, displayMonth: displayMonth } = day;
        const isOutside = Boolean(displayMonth && !isSameMonth(date, displayMonth));
        const isBeforeNavStart = Boolean(computedNavStart && isBefore(date, computedNavStart));
        const isAfterNavEnd = Boolean(computedNavEnd && isAfter(date, computedNavEnd));
        const isDisabled = Boolean(disabled && (0, $be70a17d869d8600$export$9c6809d9e0449c2e)(date, disabled, dateLib));
        const isHidden = Boolean(hidden && (0, $be70a17d869d8600$export$9c6809d9e0449c2e)(date, hidden, dateLib)) || isBeforeNavStart || isAfterNavEnd || // Broadcast calendar will show outside days as default
        !broadcastCalendar && !showOutsideDays && isOutside || broadcastCalendar && showOutsideDays === false && isOutside;
        const isToday = isSameDay(date, today);
        if (isOutside) internalModifiersMap.outside.push(day);
        if (isDisabled) internalModifiersMap.disabled.push(day);
        if (isHidden) internalModifiersMap.hidden.push(day);
        if (isToday) internalModifiersMap.today.push(day);
        // Add custom modifiers
        if (modifiers) Object.keys(modifiers).forEach((name)=>{
            const modifierValue = modifiers?.[name];
            const isMatch = modifierValue ? (0, $be70a17d869d8600$export$9c6809d9e0449c2e)(date, modifierValue, dateLib) : false;
            if (!isMatch) return;
            if (customModifiersMap[name]) customModifiersMap[name].push(day);
            else customModifiersMap[name] = [
                day
            ];
        });
    }
    return (day)=>{
        // Initialize all the modifiers to false
        const dayFlags = {
            [(0, $d4e669abc392b351$export$c2fd8ae3501086f5).focused]: false,
            [(0, $d4e669abc392b351$export$c2fd8ae3501086f5).disabled]: false,
            [(0, $d4e669abc392b351$export$c2fd8ae3501086f5).hidden]: false,
            [(0, $d4e669abc392b351$export$c2fd8ae3501086f5).outside]: false,
            [(0, $d4e669abc392b351$export$c2fd8ae3501086f5).today]: false
        };
        const customModifiers = {};
        // Find the modifiers for the given day
        for(const name in internalModifiersMap){
            const days = internalModifiersMap[name];
            dayFlags[name] = days.some((d)=>d === day);
        }
        for(const name in customModifiersMap)customModifiers[name] = customModifiersMap[name].some((d)=>d === day);
        return {
            ...dayFlags,
            // custom modifiers should override all the previous ones
            ...customModifiers
        };
    };
}



function $85f558efa293d47f$export$93628caec3887c55(modifiers, classNames, modifiersClassNames = {}) {
    const modifierClassNames = Object.entries(modifiers).filter(([, active])=>active === true).reduce((previousValue, [key])=>{
        if (modifiersClassNames[key]) previousValue.push(modifiersClassNames[key]);
        else if (classNames[(0, $d4e669abc392b351$export$c2fd8ae3501086f5)[key]]) previousValue.push(classNames[(0, $d4e669abc392b351$export$c2fd8ae3501086f5)[key]]);
        else if (classNames[(0, $d4e669abc392b351$export$2255d92a85eab347)[key]]) previousValue.push(classNames[(0, $d4e669abc392b351$export$2255d92a85eab347)[key]]);
        return previousValue;
    }, [
        classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Day]
    ]);
    return modifierClassNames;
}


var $85d6554d90ec2b60$exports = {};
var $0a51d1a604b3e64e$exports = {};

$parcel$export($0a51d1a604b3e64e$exports, "CaptionLabel", function () { return $0a51d1a604b3e64e$export$5b9f95302ae85eba; });

var $h4Bez = parcelRequire("h4Bez");
function $0a51d1a604b3e64e$export$5b9f95302ae85eba(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("span", {
        ...props
    });
}


var $a6722f4eb1ff91d4$exports = {};

$parcel$export($a6722f4eb1ff91d4$exports, "Chevron", function () { return $a6722f4eb1ff91d4$export$65be7b63f510f362; });

var $h4Bez = parcelRequire("h4Bez");
function $a6722f4eb1ff91d4$export$65be7b63f510f362(props) {
    const { size: size = 24, orientation: orientation = "left", className: className, style: style } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("svg", {
        className: className,
        style: style,
        width: size,
        height: size,
        viewBox: "0 0 24 24"
    }, orientation === "up" && (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("polygon", {
        points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28"
    }), orientation === "down" && (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("polygon", {
        points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72"
    }), orientation === "left" && (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("polygon", {
        points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20"
    }), orientation === "right" && (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("polygon", {
        points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20"
    }));
}


var $6f62f137af8eb771$exports = {};

$parcel$export($6f62f137af8eb771$exports, "Day", function () { return $6f62f137af8eb771$export$7a9a31a911eb9a20; });

var $h4Bez = parcelRequire("h4Bez");
function $6f62f137af8eb771$export$7a9a31a911eb9a20(props) {
    const { day: day, modifiers: modifiers, ...tdProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("td", {
        ...tdProps
    });
}


var $72d7106fa1e4ce9f$exports = {};

$parcel$export($72d7106fa1e4ce9f$exports, "DayButton", function () { return $72d7106fa1e4ce9f$export$162a17f4c1ec6e1e; });

var $h4Bez = parcelRequire("h4Bez");
function $72d7106fa1e4ce9f$export$162a17f4c1ec6e1e(props) {
    const { day: day, modifiers: modifiers, ...buttonProps } = props;
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).useEffect(()=>{
        if (modifiers.focused) ref.current?.focus();
    }, [
        modifiers.focused
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("button", {
        ref: ref,
        ...buttonProps
    });
}


var $0bdbcb006f22fd8e$exports = {};

$parcel$export($0bdbcb006f22fd8e$exports, "Dropdown", function () { return $0bdbcb006f22fd8e$export$931cbfb6bfb85fc; });

var $h4Bez = parcelRequire("h4Bez");


var $h4Bez = parcelRequire("h4Bez");
const $5ea8c07a697b6a0f$export$468c0287d43ba92a = (0, $h4Bez.createContext)(undefined);
function $5ea8c07a697b6a0f$export$332e9e0d64b1f294() {
    const context = (0, $h4Bez.useContext)($5ea8c07a697b6a0f$export$468c0287d43ba92a);
    if (context === undefined) throw new Error("useDayPicker() must be used within a custom component.");
    return context;
}


function $0bdbcb006f22fd8e$export$931cbfb6bfb85fc(props) {
    const { options: options, className: className, ...selectProps } = props;
    const { classNames: classNames, components: components, styles: styles } = (0, $5ea8c07a697b6a0f$export$332e9e0d64b1f294)();
    const cssClassSelect = [
        classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Dropdown],
        className
    ].join(" ");
    const selectedOption = options?.find(({ value: value })=>value === selectProps.value);
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("span", {
        "data-disabled": selectProps.disabled,
        className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).DropdownRoot],
        style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).DropdownRoot]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Select, {
        className: cssClassSelect,
        ...selectProps
    }, options?.map(({ value: value, label: label, disabled: disabled })=>(0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Option, {
            key: value,
            value: value,
            disabled: disabled
        }, label))), (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("span", {
        className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).CaptionLabel],
        style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).CaptionLabel],
        "aria-hidden": true
    }, selectedOption?.label, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Chevron, {
        orientation: "down",
        size: 18,
        className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Chevron],
        style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Chevron]
    })));
}


var $a3d0f176a8031177$exports = {};

$parcel$export($a3d0f176a8031177$exports, "DropdownNav", function () { return $a3d0f176a8031177$export$a76037c4c1362518; });

var $h4Bez = parcelRequire("h4Bez");
function $a3d0f176a8031177$export$a76037c4c1362518(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("div", {
        ...props
    });
}


var $86bfedcd4b643f39$exports = {};

$parcel$export($86bfedcd4b643f39$exports, "Footer", function () { return $86bfedcd4b643f39$export$a06f1c675e846f6f; });

var $h4Bez = parcelRequire("h4Bez");
function $86bfedcd4b643f39$export$a06f1c675e846f6f(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("div", {
        ...props
    });
}


var $b7cf1eb5c6f2306a$exports = {};

$parcel$export($b7cf1eb5c6f2306a$exports, "Month", function () { return $b7cf1eb5c6f2306a$export$951c8378cdfec6e6; });

var $h4Bez = parcelRequire("h4Bez");
function $b7cf1eb5c6f2306a$export$951c8378cdfec6e6(props) {
    const { calendarMonth: calendarMonth, displayIndex: displayIndex, ...divProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("div", {
        ...divProps
    }, props.children);
}


var $6479db97cfca3f2a$exports = {};

$parcel$export($6479db97cfca3f2a$exports, "MonthCaption", function () { return $6479db97cfca3f2a$export$1898376853bad7d4; });

var $h4Bez = parcelRequire("h4Bez");
function $6479db97cfca3f2a$export$1898376853bad7d4(props) {
    const { calendarMonth: calendarMonth, displayIndex: displayIndex, ...divProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("div", {
        ...divProps
    });
}


var $ca7557df6eaf3e0f$exports = {};

$parcel$export($ca7557df6eaf3e0f$exports, "MonthGrid", function () { return $ca7557df6eaf3e0f$export$9be4b423b21fa82; });

var $h4Bez = parcelRequire("h4Bez");
function $ca7557df6eaf3e0f$export$9be4b423b21fa82(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("table", {
        ...props
    });
}


var $dcbbf52e2376d0ba$exports = {};

$parcel$export($dcbbf52e2376d0ba$exports, "Months", function () { return $dcbbf52e2376d0ba$export$a0ec4efdb90fa181; });

var $h4Bez = parcelRequire("h4Bez");
function $dcbbf52e2376d0ba$export$a0ec4efdb90fa181(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("div", {
        ...props
    });
}


var $d0d4cf793fc7c6bc$exports = {};

$parcel$export($d0d4cf793fc7c6bc$exports, "MonthsDropdown", function () { return $d0d4cf793fc7c6bc$export$890818c4dfdc5b81; });

var $h4Bez = parcelRequire("h4Bez");

function $d0d4cf793fc7c6bc$export$890818c4dfdc5b81(props) {
    const { components: components } = (0, $5ea8c07a697b6a0f$export$332e9e0d64b1f294)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Dropdown, {
        ...props
    });
}


var $df2758d8f64d7b23$exports = {};

$parcel$export($df2758d8f64d7b23$exports, "Nav", function () { return $df2758d8f64d7b23$export$39140c7d8b0ba7b3; });

var $h4Bez = parcelRequire("h4Bez");


function $df2758d8f64d7b23$export$39140c7d8b0ba7b3(props) {
    const { onPreviousClick: onPreviousClick, onNextClick: onNextClick, previousMonth: previousMonth, nextMonth: nextMonth, ...navProps } = props;
    const { components: components, classNames: classNames, styles: styles, labels: { labelPrevious: labelPrevious, labelNext: labelNext } } = (0, $5ea8c07a697b6a0f$export$332e9e0d64b1f294)();
    const handleNextClick = (0, $h4Bez.useCallback)((e)=>{
        if (nextMonth) onNextClick?.(e);
    }, [
        nextMonth,
        onNextClick
    ]);
    const handlePreviousClick = (0, $h4Bez.useCallback)((e)=>{
        if (previousMonth) onPreviousClick?.(e);
    }, [
        previousMonth,
        onPreviousClick
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("nav", {
        ...navProps
    }, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.PreviousMonthButton, {
        type: "button",
        className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).PreviousMonthButton],
        style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).PreviousMonthButton],
        tabIndex: previousMonth ? undefined : -1,
        "aria-disabled": previousMonth ? undefined : true,
        "aria-label": labelPrevious(previousMonth),
        onClick: handlePreviousClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Chevron, {
        disabled: previousMonth ? undefined : true,
        className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Chevron],
        style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Chevron],
        orientation: "left"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.NextMonthButton, {
        type: "button",
        className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).NextMonthButton],
        style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).NextMonthButton],
        tabIndex: nextMonth ? undefined : -1,
        "aria-disabled": nextMonth ? undefined : true,
        "aria-label": labelNext(nextMonth),
        onClick: handleNextClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Chevron, {
        disabled: nextMonth ? undefined : true,
        orientation: "right",
        className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Chevron],
        style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Chevron]
    })));
}


var $ed22d6a37c5e811c$exports = {};

$parcel$export($ed22d6a37c5e811c$exports, "NextMonthButton", function () { return $ed22d6a37c5e811c$export$32eaef38b5dcafde; });

var $h4Bez = parcelRequire("h4Bez");
function $ed22d6a37c5e811c$export$32eaef38b5dcafde(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("button", {
        ...props
    });
}


var $8205a00a096ce8de$exports = {};

$parcel$export($8205a00a096ce8de$exports, "Option", function () { return $8205a00a096ce8de$export$36d18380658d5d20; });

var $h4Bez = parcelRequire("h4Bez");
function $8205a00a096ce8de$export$36d18380658d5d20(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("option", {
        ...props
    });
}


var $6029c76fee97f63d$exports = {};

$parcel$export($6029c76fee97f63d$exports, "PreviousMonthButton", function () { return $6029c76fee97f63d$export$8b1a143b10000389; });

var $h4Bez = parcelRequire("h4Bez");
function $6029c76fee97f63d$export$8b1a143b10000389(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("button", {
        ...props
    });
}


var $0b1afc491d55929b$exports = {};

$parcel$export($0b1afc491d55929b$exports, "Root", function () { return $0b1afc491d55929b$export$be92b6f5f03c0fe9; });

var $h4Bez = parcelRequire("h4Bez");
function $0b1afc491d55929b$export$be92b6f5f03c0fe9(props) {
    const { rootRef: rootRef, ...rest } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("div", {
        ...rest,
        ref: rootRef
    });
}


var $29183e40bf9db9be$exports = {};

$parcel$export($29183e40bf9db9be$exports, "Select", function () { return $29183e40bf9db9be$export$ef9b1a59e592288f; });

var $h4Bez = parcelRequire("h4Bez");
function $29183e40bf9db9be$export$ef9b1a59e592288f(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("select", {
        ...props
    });
}


var $c6e24d78a345c462$exports = {};

$parcel$export($c6e24d78a345c462$exports, "Week", function () { return $c6e24d78a345c462$export$fca4f8121099df57; });

var $h4Bez = parcelRequire("h4Bez");
function $c6e24d78a345c462$export$fca4f8121099df57(props) {
    const { week: week, ...trProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("tr", {
        ...trProps
    });
}


var $0e37875ca65c9ade$exports = {};

$parcel$export($0e37875ca65c9ade$exports, "Weekday", function () { return $0e37875ca65c9ade$export$94dd8a9f089c7f53; });

var $h4Bez = parcelRequire("h4Bez");
function $0e37875ca65c9ade$export$94dd8a9f089c7f53(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("th", {
        ...props
    });
}


var $7c0d8d27b13a4846$exports = {};

$parcel$export($7c0d8d27b13a4846$exports, "Weekdays", function () { return $7c0d8d27b13a4846$export$ecadcd5acd8b48a2; });

var $h4Bez = parcelRequire("h4Bez");
function $7c0d8d27b13a4846$export$ecadcd5acd8b48a2(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("thead", {
        "aria-hidden": true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("tr", {
        ...props
    }));
}


var $bab97259cec7c552$exports = {};

$parcel$export($bab97259cec7c552$exports, "WeekNumber", function () { return $bab97259cec7c552$export$f52f5e0fedb732da; });

var $h4Bez = parcelRequire("h4Bez");
function $bab97259cec7c552$export$f52f5e0fedb732da(props) {
    const { week: week, ...thProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("th", {
        ...thProps
    });
}


var $9fa14577b4c989af$exports = {};

$parcel$export($9fa14577b4c989af$exports, "WeekNumberHeader", function () { return $9fa14577b4c989af$export$67dc2d331c60b612; });

var $h4Bez = parcelRequire("h4Bez");
function $9fa14577b4c989af$export$67dc2d331c60b612(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("th", {
        ...props
    });
}


var $ab6ba6619f202729$exports = {};

$parcel$export($ab6ba6619f202729$exports, "Weeks", function () { return $ab6ba6619f202729$export$cee3aa9d41feb83e; });

var $h4Bez = parcelRequire("h4Bez");
function $ab6ba6619f202729$export$cee3aa9d41feb83e(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("tbody", {
        ...props
    });
}


var $b13a23eb1e4c92f9$exports = {};

$parcel$export($b13a23eb1e4c92f9$exports, "YearsDropdown", function () { return $b13a23eb1e4c92f9$export$cbcb737020db5a92; });

var $h4Bez = parcelRequire("h4Bez");

function $b13a23eb1e4c92f9$export$cbcb737020db5a92(props) {
    const { components: components } = (0, $5ea8c07a697b6a0f$export$332e9e0d64b1f294)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Dropdown, {
        ...props
    });
}


$parcel$exportWildcard($85d6554d90ec2b60$exports, $0a51d1a604b3e64e$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $a6722f4eb1ff91d4$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $6f62f137af8eb771$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $72d7106fa1e4ce9f$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $0bdbcb006f22fd8e$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $a3d0f176a8031177$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $86bfedcd4b643f39$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $b7cf1eb5c6f2306a$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $6479db97cfca3f2a$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $ca7557df6eaf3e0f$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $dcbbf52e2376d0ba$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $d0d4cf793fc7c6bc$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $df2758d8f64d7b23$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $ed22d6a37c5e811c$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $8205a00a096ce8de$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $6029c76fee97f63d$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $0b1afc491d55929b$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $29183e40bf9db9be$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $c6e24d78a345c462$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $0e37875ca65c9ade$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $7c0d8d27b13a4846$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $bab97259cec7c552$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $9fa14577b4c989af$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $ab6ba6619f202729$exports);
$parcel$exportWildcard($85d6554d90ec2b60$exports, $b13a23eb1e4c92f9$exports);


function $db599084b1cae9af$export$4e811121b221213b(customComponents) {
    return {
        ...$85d6554d90ec2b60$exports,
        ...customComponents
    };
}


/**
 * Extracts `data-` attributes from the DayPicker props.
 *
 * This function collects all `data-` attributes from the props and adds
 * additional attributes based on the DayPicker configuration.
 *
 * @param props The DayPicker props.
 * @returns An object containing the `data-` attributes.
 */ function $e53eb300bca63c43$export$e5ac556b1404ae1e(props) {
    const dataAttributes = {
        "data-mode": props.mode ?? undefined,
        "data-required": "required" in props ? props.required : undefined,
        "data-multiple-months": props.numberOfMonths && props.numberOfMonths > 1 || undefined,
        "data-week-numbers": props.showWeekNumber || undefined,
        "data-broadcast-calendar": props.broadcastCalendar || undefined,
        "data-nav-layout": props.navLayout || undefined
    };
    Object.entries(props).forEach(([key, val])=>{
        if (key.startsWith("data-")) dataAttributes[key] = val;
    });
    return dataAttributes;
}



function $bba0d7038cd68da0$export$8f10228aec87fae6() {
    const classNames = {};
    for(const key in 0, $d4e669abc392b351$export$4b08aed5f1ec6952)classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952)[key]] = `rdp-${(0, $d4e669abc392b351$export$4b08aed5f1ec6952)[key]}`;
    for(const key in 0, $d4e669abc392b351$export$c2fd8ae3501086f5)classNames[(0, $d4e669abc392b351$export$c2fd8ae3501086f5)[key]] = `rdp-${(0, $d4e669abc392b351$export$c2fd8ae3501086f5)[key]}`;
    for(const key in 0, $d4e669abc392b351$export$2255d92a85eab347)classNames[(0, $d4e669abc392b351$export$2255d92a85eab347)[key]] = `rdp-${(0, $d4e669abc392b351$export$2255d92a85eab347)[key]}`;
    for(const key in 0, $d4e669abc392b351$export$c35d437ae5945fcd)classNames[(0, $d4e669abc392b351$export$c35d437ae5945fcd)[key]] = `rdp-${(0, $d4e669abc392b351$export$c35d437ae5945fcd)[key]}`;
    return classNames;
}


var $8ed0694810d87777$exports = {};
var $b575982e7da2363d$exports = {};

$parcel$export($b575982e7da2363d$exports, "formatCaption", function () { return $b575982e7da2363d$export$e5fe65a0769e345a; });

function $b575982e7da2363d$export$e5fe65a0769e345a(month, options, dateLib) {
    const lib = dateLib ?? new (0, $5bc78e2210779f86$export$87f71ed78036473c)(options);
    return lib.formatMonthYear(month);
}


var $3e1938c0a7d3bacd$exports = {};

$parcel$export($3e1938c0a7d3bacd$exports, "formatDay", function () { return $3e1938c0a7d3bacd$export$a7f242eff11c1345; });

function $3e1938c0a7d3bacd$export$a7f242eff11c1345(date, options, dateLib) {
    return (dateLib ?? new (0, $5bc78e2210779f86$export$87f71ed78036473c)(options)).format(date, "d");
}


var $0193fb07de148d2a$exports = {};

$parcel$export($0193fb07de148d2a$exports, "formatMonthDropdown", function () { return $0193fb07de148d2a$export$13c80aa65ab48bbb; });

function $0193fb07de148d2a$export$13c80aa65ab48bbb(month, dateLib = (0, $5bc78e2210779f86$export$6575cc37c71cbcd2)) {
    return dateLib.format(month, "LLLL");
}


var $15f10ac6512c048b$exports = {};

$parcel$export($15f10ac6512c048b$exports, "formatWeekdayName", function () { return $15f10ac6512c048b$export$3dc11f5aa937dc1f; });

function $15f10ac6512c048b$export$3dc11f5aa937dc1f(weekday, options, dateLib) {
    return (dateLib ?? new (0, $5bc78e2210779f86$export$87f71ed78036473c)(options)).format(weekday, "cccccc");
}


var $6db1cf3552db36ae$exports = {};

$parcel$export($6db1cf3552db36ae$exports, "formatWeekNumber", function () { return $6db1cf3552db36ae$export$b3488d9cee3ab7cc; });

function $6db1cf3552db36ae$export$b3488d9cee3ab7cc(weekNumber, dateLib = (0, $5bc78e2210779f86$export$6575cc37c71cbcd2)) {
    if (weekNumber < 10) return dateLib.formatNumber(`0${weekNumber.toLocaleString()}`);
    return dateLib.formatNumber(`${weekNumber.toLocaleString()}`);
}


var $28ae19786ede51c0$exports = {};

$parcel$export($28ae19786ede51c0$exports, "formatWeekNumberHeader", function () { return $28ae19786ede51c0$export$a6eef91e1d918d7d; });
/**
 * Formats the header for the week number column.
 *
 * @defaultValue An empty string `""`.
 * @returns The formatted week number header as a string.
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */ function $28ae19786ede51c0$export$a6eef91e1d918d7d() {
    return ``;
}


var $9d087b04f9f1c800$exports = {};

$parcel$export($9d087b04f9f1c800$exports, "formatYearDropdown", function () { return $9d087b04f9f1c800$export$d3d30ccad02af945; });

function $9d087b04f9f1c800$export$d3d30ccad02af945(year, dateLib = (0, $5bc78e2210779f86$export$6575cc37c71cbcd2)) {
    return dateLib.format(year, "yyyy");
}


$parcel$exportWildcard($8ed0694810d87777$exports, $b575982e7da2363d$exports);
$parcel$exportWildcard($8ed0694810d87777$exports, $3e1938c0a7d3bacd$exports);
$parcel$exportWildcard($8ed0694810d87777$exports, $0193fb07de148d2a$exports);
$parcel$exportWildcard($8ed0694810d87777$exports, $15f10ac6512c048b$exports);
$parcel$exportWildcard($8ed0694810d87777$exports, $6db1cf3552db36ae$exports);
$parcel$exportWildcard($8ed0694810d87777$exports, $28ae19786ede51c0$exports);
$parcel$exportWildcard($8ed0694810d87777$exports, $9d087b04f9f1c800$exports);


function $fa8c577a652dc9c3$export$2eec0f50813b8d07(customFormatters) {
    return {
        ...$8ed0694810d87777$exports,
        ...customFormatters
    };
}


var $cb064966038e6f54$exports = {};
var $2e4eb648f4c8d783$exports = {};

$parcel$export($2e4eb648f4c8d783$exports, "labelDayButton", function () { return $2e4eb648f4c8d783$export$a170841bc3306cdb; });

function $2e4eb648f4c8d783$export$a170841bc3306cdb(date, modifiers, options, dateLib) {
    let label = (dateLib ?? new (0, $5bc78e2210779f86$export$87f71ed78036473c)(options)).format(date, "PPPP");
    if (modifiers.today) label = `Today, ${label}`;
    if (modifiers.selected) label = `${label}, selected`;
    return label;
}


var $541f9382c373ba67$exports = {};

$parcel$export($541f9382c373ba67$exports, "labelGrid", function () { return $541f9382c373ba67$export$94d581252e061544; });

function $541f9382c373ba67$export$94d581252e061544(date, options, dateLib) {
    const lib = dateLib ?? new (0, $5bc78e2210779f86$export$87f71ed78036473c)(options);
    return lib.formatMonthYear(date);
}


var $808813cd82949079$exports = {};

$parcel$export($808813cd82949079$exports, "labelGridcell", function () { return $808813cd82949079$export$22b50784bb867133; });

function $808813cd82949079$export$22b50784bb867133(date, modifiers, options, dateLib) {
    let label = (dateLib ?? new (0, $5bc78e2210779f86$export$87f71ed78036473c)(options)).format(date, "PPPP");
    if (modifiers?.today) label = `Today, ${label}`;
    return label;
}


var $8750498aac541fd8$exports = {};

$parcel$export($8750498aac541fd8$exports, "labelMonthDropdown", function () { return $8750498aac541fd8$export$c8d98e15d7658afe; });
/**
 * Generates the ARIA label for the months dropdown.
 *
 * @defaultValue `"Choose the Month"`
 * @param options - Optional configuration for the date formatting library.
 * @returns The ARIA label for the months dropdown.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ function $8750498aac541fd8$export$c8d98e15d7658afe(_options) {
    return "Choose the Month";
}


var $008f60203a2a969a$exports = {};

$parcel$export($008f60203a2a969a$exports, "labelNav", function () { return $008f60203a2a969a$export$49418de60e44a464; });
/**
 * Generates the ARIA label for the navigation toolbar.
 *
 * @defaultValue `""`
 * @returns The ARIA label for the navigation toolbar.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ function $008f60203a2a969a$export$49418de60e44a464() {
    return "";
}


var $a959372acd98a2da$exports = {};

$parcel$export($a959372acd98a2da$exports, "labelNext", function () { return $a959372acd98a2da$export$6e2010051a8f28c0; });
const $a959372acd98a2da$var$defaultLabel = "Go to the Next Month";
function $a959372acd98a2da$export$6e2010051a8f28c0(_month, _options) {
    return $a959372acd98a2da$var$defaultLabel;
}


var $d7c288a2ce9cb7fa$exports = {};

$parcel$export($d7c288a2ce9cb7fa$exports, "labelPrevious", function () { return $d7c288a2ce9cb7fa$export$e46be0cf57082a1d; });
/**
 * Generates the ARIA label for the "previous month" button.
 *
 * @defaultValue `"Go to the Previous Month"`
 * @param month - The date representing the previous month, or `undefined` if
 *   there is no previous month.
 * @returns The ARIA label for the "previous month" button.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ function $d7c288a2ce9cb7fa$export$e46be0cf57082a1d(_month) {
    return "Go to the Previous Month";
}


var $5bfba100f64f4583$exports = {};

$parcel$export($5bfba100f64f4583$exports, "labelWeekday", function () { return $5bfba100f64f4583$export$9006638f42311a57; });

function $5bfba100f64f4583$export$9006638f42311a57(date, options, dateLib) {
    return (dateLib ?? new (0, $5bc78e2210779f86$export$87f71ed78036473c)(options)).format(date, "cccc");
}


var $5703aa2bbbfb2320$exports = {};

$parcel$export($5703aa2bbbfb2320$exports, "labelWeekNumber", function () { return $5703aa2bbbfb2320$export$dbe69561a3e50132; });
/**
 * Generates the ARIA label for the week number cell (the first cell in a row).
 *
 * @defaultValue `Week ${weekNumber}`
 * @param weekNumber - The number of the week.
 * @param options - Optional configuration for the date formatting library.
 * @returns The ARIA label for the week number cell.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ function $5703aa2bbbfb2320$export$dbe69561a3e50132(weekNumber, _options) {
    return `Week ${weekNumber}`;
}


var $cf0bfd99af3d18f1$exports = {};

$parcel$export($cf0bfd99af3d18f1$exports, "labelWeekNumberHeader", function () { return $cf0bfd99af3d18f1$export$6d49daa26397861; });
/**
 * Generates the ARIA label for the week number header element.
 *
 * @defaultValue `"Week Number"`
 * @param options - Optional configuration for the date formatting library.
 * @returns The ARIA label for the week number header.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ function $cf0bfd99af3d18f1$export$6d49daa26397861(_options) {
    return "Week Number";
}


var $37c32cfaf413c54c$exports = {};

$parcel$export($37c32cfaf413c54c$exports, "labelYearDropdown", function () { return $37c32cfaf413c54c$export$5e631ce1249f481f; });
/**
 * Generates the ARIA label for the years dropdown.
 *
 * @defaultValue `"Choose the Year"`
 * @param options - Optional configuration for the date formatting library.
 * @returns The ARIA label for the years dropdown.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ function $37c32cfaf413c54c$export$5e631ce1249f481f(_options) {
    return "Choose the Year";
}


$parcel$exportWildcard($cb064966038e6f54$exports, $2e4eb648f4c8d783$exports);
$parcel$exportWildcard($cb064966038e6f54$exports, $541f9382c373ba67$exports);
$parcel$exportWildcard($cb064966038e6f54$exports, $808813cd82949079$exports);
$parcel$exportWildcard($cb064966038e6f54$exports, $8750498aac541fd8$exports);
$parcel$exportWildcard($cb064966038e6f54$exports, $008f60203a2a969a$exports);
$parcel$exportWildcard($cb064966038e6f54$exports, $a959372acd98a2da$exports);
$parcel$exportWildcard($cb064966038e6f54$exports, $d7c288a2ce9cb7fa$exports);
$parcel$exportWildcard($cb064966038e6f54$exports, $5bfba100f64f4583$exports);
$parcel$exportWildcard($cb064966038e6f54$exports, $5703aa2bbbfb2320$exports);
$parcel$exportWildcard($cb064966038e6f54$exports, $cf0bfd99af3d18f1$exports);
$parcel$exportWildcard($cb064966038e6f54$exports, $37c32cfaf413c54c$exports);


const $94731da4de449200$var$resolveLabel = (defaultLabel, customLabel, localeLabel)=>{
    if (customLabel) return customLabel;
    if (localeLabel) return typeof localeLabel === "function" ? localeLabel : (..._args)=>localeLabel;
    return defaultLabel;
};
function $94731da4de449200$export$f81a3ec2bfb3f287(customLabels, options) {
    const localeLabels = options.locale?.labels ?? {};
    return {
        ...$cb064966038e6f54$exports,
        ...customLabels ?? {},
        labelDayButton: $94731da4de449200$var$resolveLabel($cb064966038e6f54$exports.labelDayButton, customLabels?.labelDayButton, localeLabels.labelDayButton),
        labelMonthDropdown: $94731da4de449200$var$resolveLabel($cb064966038e6f54$exports.labelMonthDropdown, customLabels?.labelMonthDropdown, localeLabels.labelMonthDropdown),
        labelNext: $94731da4de449200$var$resolveLabel($cb064966038e6f54$exports.labelNext, customLabels?.labelNext, localeLabels.labelNext),
        labelPrevious: $94731da4de449200$var$resolveLabel($cb064966038e6f54$exports.labelPrevious, customLabels?.labelPrevious, localeLabels.labelPrevious),
        labelWeekNumber: $94731da4de449200$var$resolveLabel($cb064966038e6f54$exports.labelWeekNumber, customLabels?.labelWeekNumber, localeLabels.labelWeekNumber),
        labelYearDropdown: $94731da4de449200$var$resolveLabel($cb064966038e6f54$exports.labelYearDropdown, customLabels?.labelYearDropdown, localeLabels.labelYearDropdown),
        labelGrid: $94731da4de449200$var$resolveLabel($cb064966038e6f54$exports.labelGrid, customLabels?.labelGrid, localeLabels.labelGrid),
        labelGridcell: $94731da4de449200$var$resolveLabel($cb064966038e6f54$exports.labelGridcell, customLabels?.labelGridcell, localeLabels.labelGridcell),
        labelNav: $94731da4de449200$var$resolveLabel($cb064966038e6f54$exports.labelNav, customLabels?.labelNav, localeLabels.labelNav),
        labelWeekNumberHeader: $94731da4de449200$var$resolveLabel($cb064966038e6f54$exports.labelWeekNumberHeader, customLabels?.labelWeekNumberHeader, localeLabels.labelWeekNumberHeader),
        labelWeekday: $94731da4de449200$var$resolveLabel($cb064966038e6f54$exports.labelWeekday, customLabels?.labelWeekday, localeLabels.labelWeekday)
    };
}


/**
 * Returns the months to show in the dropdown.
 *
 * This function generates a list of months for the current year, formatted
 * using the provided formatter, and determines whether each month should be
 * disabled based on the navigation range.
 *
 * @param displayMonth The currently displayed month.
 * @param navStart The start date for navigation.
 * @param navEnd The end date for navigation.
 * @param formatters The formatters to use for formatting the month labels.
 * @param dateLib The date library to use for date manipulation.
 * @returns An array of dropdown options representing the months, or `undefined`
 *   if no months are available.
 */ function $90713fbc017dba79$export$5365e964dff332d1(displayMonth, navStart, navEnd, formatters, dateLib) {
    const { startOfMonth: startOfMonth, startOfYear: startOfYear, endOfYear: endOfYear, eachMonthOfInterval: eachMonthOfInterval, getMonth: getMonth } = dateLib;
    const months = eachMonthOfInterval({
        start: startOfYear(displayMonth),
        end: endOfYear(displayMonth)
    });
    const options = months.map((month)=>{
        const label = formatters.formatMonthDropdown(month, dateLib);
        const value = getMonth(month);
        const disabled = navStart && month < startOfMonth(navStart) || navEnd && month > startOfMonth(navEnd) || false;
        return {
            value: value,
            label: label,
            disabled: disabled
        };
    });
    return options;
}



function $8c5584b22931018a$export$aee95183ff1527a6(dayModifiers, styles = {}, modifiersStyles = {}) {
    let style = {
        ...styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Day]
    };
    Object.entries(dayModifiers).filter(([, active])=>active === true).forEach(([modifier])=>{
        style = {
            ...style,
            ...modifiersStyles?.[modifier]
        };
    });
    return style;
}


/**
 * Generates a series of 7 days, starting from the beginning of the week, to use
 * for formatting weekday names (e.g., Monday, Tuesday, etc.).
 *
 * @param dateLib The date library to use for date manipulation.
 * @param ISOWeek Whether to use ISO week numbering (weeks start on Monday).
 * @param broadcastCalendar Whether to use the broadcast calendar (weeks start
 *   on Monday, but may include adjustments for broadcast-specific rules).
 * @returns An array of 7 dates representing the weekdays.
 */ function $3afc993949ef4a60$export$24c38139da66592d(dateLib, ISOWeek, broadcastCalendar, today) {
    const referenceToday = today ?? dateLib.today();
    const start = broadcastCalendar ? dateLib.startOfBroadcastWeek(referenceToday, dateLib) : ISOWeek ? dateLib.startOfISOWeek(referenceToday) : dateLib.startOfWeek(referenceToday);
    const days = [];
    for(let i = 0; i < 7; i++){
        const day = dateLib.addDays(start, i);
        days.push(day);
    }
    return days;
}


/**
 * Returns the years to display in the dropdown.
 *
 * This function generates a list of years between the navigation start and end
 * dates, formatted using the provided formatter.
 *
 * @param navStart The start date for navigation.
 * @param navEnd The end date for navigation.
 * @param formatters The formatters to use for formatting the year labels.
 * @param dateLib The date library to use for date manipulation.
 * @param reverse If true, reverses the order of the years (descending).
 * @returns An array of dropdown options representing the years, or `undefined`
 *   if `navStart` or `navEnd` is not provided.
 */ function $acfb360b526a2de1$export$9865296f13ed9cac(navStart, navEnd, formatters, dateLib, reverse = false) {
    if (!navStart) return undefined;
    if (!navEnd) return undefined;
    const { startOfYear: startOfYear, endOfYear: endOfYear, eachYearOfInterval: eachYearOfInterval, getYear: getYear } = dateLib;
    const firstNavYear = startOfYear(navStart);
    const lastNavYear = endOfYear(navEnd);
    const years = eachYearOfInterval({
        start: firstNavYear,
        end: lastNavYear
    });
    if (reverse) years.reverse();
    return years.map((year)=>{
        const label = formatters.formatYearDropdown(year, dateLib);
        return {
            value: getYear(year),
            label: label,
            disabled: false
        };
    });
}




function $acf78e4d36e443cb$export$616f3fa68501513e(timeZone, options = {}) {
    const { weekStartsOn: weekStartsOn, locale: locale } = options;
    const fallbackWeekStartsOn = weekStartsOn ?? locale?.options?.weekStartsOn ?? 0;
    // Keep all internal math anchored at noon in the target zone to avoid
    // historical second-level offsets from crossing midnight.
    const toNoonTZDate = (date)=>{
        const normalizedDate = typeof date === "number" || typeof date === "string" ? new Date(date) : date;
        return new (0, $8f2a7769b12c0486$export$8de43e28dd4af6bd)(normalizedDate.getFullYear(), normalizedDate.getMonth(), normalizedDate.getDate(), 12, 0, 0, timeZone);
    };
    // Convert a value into a host `Date` that represents the same calendar day
    // as the target-zone noon. This is useful for helpers (e.g., date-fns week
    // utilities) that expect local `Date` instances rather than `TZDate`s.
    const toCalendarDate = (date)=>{
        const zoned = toNoonTZDate(date);
        return new Date(zoned.getFullYear(), zoned.getMonth(), zoned.getDate(), 0, 0, 0, 0);
    };
    return {
        today: ()=>{
            return toNoonTZDate((0, $8f2a7769b12c0486$export$8de43e28dd4af6bd).tz(timeZone));
        },
        newDate: (year, monthIndex, date)=>{
            return new (0, $8f2a7769b12c0486$export$8de43e28dd4af6bd)(year, monthIndex, date, 12, 0, 0, timeZone);
        },
        startOfDay: (date)=>{
            return toNoonTZDate(date);
        },
        startOfWeek: (date, options)=>{
            const base = toNoonTZDate(date);
            const weekStartsOnValue = options?.weekStartsOn ?? fallbackWeekStartsOn;
            const diff = (base.getDay() - weekStartsOnValue + 7) % 7;
            base.setDate(base.getDate() - diff);
            return base;
        },
        startOfISOWeek: (date)=>{
            const base = toNoonTZDate(date);
            const diff = (base.getDay() - 1 + 7) % 7;
            base.setDate(base.getDate() - diff);
            return base;
        },
        startOfMonth: (date)=>{
            const base = toNoonTZDate(date);
            base.setDate(1);
            return base;
        },
        startOfYear: (date)=>{
            const base = toNoonTZDate(date);
            base.setMonth(0, 1);
            return base;
        },
        endOfWeek: (date, options)=>{
            const base = toNoonTZDate(date);
            const weekStartsOnValue = options?.weekStartsOn ?? fallbackWeekStartsOn;
            const endDow = (weekStartsOnValue + 6) % 7;
            const diff = (endDow - base.getDay() + 7) % 7;
            base.setDate(base.getDate() + diff);
            return base;
        },
        endOfISOWeek: (date)=>{
            const base = toNoonTZDate(date);
            const diff = (7 - base.getDay()) % 7;
            base.setDate(base.getDate() + diff);
            return base;
        },
        endOfMonth: (date)=>{
            const base = toNoonTZDate(date);
            base.setMonth(base.getMonth() + 1, 0);
            return base;
        },
        endOfYear: (date)=>{
            const base = toNoonTZDate(date);
            base.setMonth(11, 31);
            return base;
        },
        eachMonthOfInterval: (interval)=>{
            const start = toNoonTZDate(interval.start);
            const end = toNoonTZDate(interval.end);
            const result = [];
            const cursor = new (0, $8f2a7769b12c0486$export$8de43e28dd4af6bd)(start.getFullYear(), start.getMonth(), 1, 12, 0, 0, timeZone);
            const endKey = end.getFullYear() * 12 + end.getMonth();
            while(cursor.getFullYear() * 12 + cursor.getMonth() <= endKey){
                result.push(new (0, $8f2a7769b12c0486$export$8de43e28dd4af6bd)(cursor, timeZone));
                cursor.setMonth(cursor.getMonth() + 1, 1);
            }
            return result;
        },
        // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
        // mutate the same TZDate, and return it.
        addDays: (date, amount)=>{
            const base = toNoonTZDate(date);
            base.setDate(base.getDate() + amount);
            return base;
        },
        addWeeks: (date, amount)=>{
            const base = toNoonTZDate(date);
            base.setDate(base.getDate() + amount * 7);
            return base;
        },
        addMonths: (date, amount)=>{
            const base = toNoonTZDate(date);
            base.setMonth(base.getMonth() + amount);
            return base;
        },
        addYears: (date, amount)=>{
            const base = toNoonTZDate(date);
            base.setFullYear(base.getFullYear() + amount);
            return base;
        },
        eachYearOfInterval: (interval)=>{
            const start = toNoonTZDate(interval.start);
            const end = toNoonTZDate(interval.end);
            const years = [];
            const cursor = new (0, $8f2a7769b12c0486$export$8de43e28dd4af6bd)(start.getFullYear(), 0, 1, 12, 0, 0, timeZone);
            while(cursor.getFullYear() <= end.getFullYear()){
                years.push(new (0, $8f2a7769b12c0486$export$8de43e28dd4af6bd)(cursor, timeZone));
                cursor.setFullYear(cursor.getFullYear() + 1, 0, 1);
            }
            return years;
        },
        getWeek: (date, options)=>{
            const base = toCalendarDate(date);
            return (0, $55a92e939000650b$export$efe19b760242b2fc)(base, {
                weekStartsOn: options?.weekStartsOn ?? fallbackWeekStartsOn,
                firstWeekContainsDate: options?.firstWeekContainsDate ?? locale?.options?.firstWeekContainsDate ?? 1
            });
        },
        getISOWeek: (date)=>{
            const base = toCalendarDate(date);
            return (0, $600ddd1bbcdf2158$export$7cabdc5698b63e2f)(base);
        },
        differenceInCalendarDays: (dateLeft, dateRight)=>{
            const left = toCalendarDate(dateLeft);
            const right = toCalendarDate(dateRight);
            return (0, $445b7002ca244bfc$export$4a02e9c37dab4871)(left, right);
        },
        differenceInCalendarMonths: (dateLeft, dateRight)=>{
            const left = toCalendarDate(dateLeft);
            const right = toCalendarDate(dateRight);
            return (0, $1a80c80bb8f702c0$export$489984ac7c996389)(left, right);
        }
    };
}




var $h4Bez = parcelRequire("h4Bez");

const $bd468b6c3a02cdcb$var$asHtmlElement = (element)=>{
    if (element instanceof HTMLElement) return element;
    return null;
};
const $bd468b6c3a02cdcb$var$queryMonthEls = (element)=>[
        ...element.querySelectorAll("[data-animated-month]") ?? []
    ];
const $bd468b6c3a02cdcb$var$queryMonthEl = (element)=>$bd468b6c3a02cdcb$var$asHtmlElement(element.querySelector("[data-animated-month]"));
const $bd468b6c3a02cdcb$var$queryCaptionEl = (element)=>$bd468b6c3a02cdcb$var$asHtmlElement(element.querySelector("[data-animated-caption]"));
const $bd468b6c3a02cdcb$var$queryWeeksEl = (element)=>$bd468b6c3a02cdcb$var$asHtmlElement(element.querySelector("[data-animated-weeks]"));
const $bd468b6c3a02cdcb$var$queryNavEl = (element)=>$bd468b6c3a02cdcb$var$asHtmlElement(element.querySelector("[data-animated-nav]"));
const $bd468b6c3a02cdcb$var$queryWeekdaysEl = (element)=>$bd468b6c3a02cdcb$var$asHtmlElement(element.querySelector("[data-animated-weekdays]"));
function $bd468b6c3a02cdcb$export$9e2608686d4ad846(rootElRef, enabled, { classNames: classNames, months: months, focused: focused, dateLib: dateLib }) {
    const previousRootElSnapshotRef = (0, $h4Bez.useRef)(null);
    const previousMonthsRef = (0, $h4Bez.useRef)(months);
    const animatingRef = (0, $h4Bez.useRef)(false);
    (0, $h4Bez.useLayoutEffect)(()=>{
        // get previous months before updating the previous months ref
        const previousMonths = previousMonthsRef.current;
        // update previous months ref for next effect trigger
        previousMonthsRef.current = months;
        if (!enabled || !rootElRef.current || // safety check because the ref can be set to anything by consumers
        !(rootElRef.current instanceof HTMLElement) || // validation required for the animation to work as expected
        months.length === 0 || previousMonths.length === 0 || months.length !== previousMonths.length) return;
        const isSameMonth = dateLib.isSameMonth(months[0].date, previousMonths[0].date);
        const isAfterPreviousMonth = dateLib.isAfter(months[0].date, previousMonths[0].date);
        const captionAnimationClass = isAfterPreviousMonth ? classNames[(0, $d4e669abc392b351$export$c35d437ae5945fcd).caption_after_enter] : classNames[(0, $d4e669abc392b351$export$c35d437ae5945fcd).caption_before_enter];
        const weeksAnimationClass = isAfterPreviousMonth ? classNames[(0, $d4e669abc392b351$export$c35d437ae5945fcd).weeks_after_enter] : classNames[(0, $d4e669abc392b351$export$c35d437ae5945fcd).weeks_before_enter];
        // get previous root element snapshot before updating the snapshot ref
        const previousRootElSnapshot = previousRootElSnapshotRef.current;
        // update snapshot for next effect trigger
        const rootElSnapshot = rootElRef.current.cloneNode(true);
        if (rootElSnapshot instanceof HTMLElement) {
            // if this effect is triggered while animating, we need to clean up the new root snapshot
            // to put it in the same state as when not animating, to correctly animate the next month change
            const currentMonthElsSnapshot = $bd468b6c3a02cdcb$var$queryMonthEls(rootElSnapshot);
            currentMonthElsSnapshot.forEach((currentMonthElSnapshot)=>{
                if (!(currentMonthElSnapshot instanceof HTMLElement)) return;
                // remove the old month snapshots from the new root snapshot
                const previousMonthElSnapshot = $bd468b6c3a02cdcb$var$queryMonthEl(currentMonthElSnapshot);
                if (previousMonthElSnapshot && currentMonthElSnapshot.contains(previousMonthElSnapshot)) currentMonthElSnapshot.removeChild(previousMonthElSnapshot);
                // remove animation classes from the new month snapshots
                const captionEl = $bd468b6c3a02cdcb$var$queryCaptionEl(currentMonthElSnapshot);
                if (captionEl) captionEl.classList.remove(captionAnimationClass);
                const weeksEl = $bd468b6c3a02cdcb$var$queryWeeksEl(currentMonthElSnapshot);
                if (weeksEl) weeksEl.classList.remove(weeksAnimationClass);
            });
            previousRootElSnapshotRef.current = rootElSnapshot;
        } else previousRootElSnapshotRef.current = null;
        if (animatingRef.current || isSameMonth || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
        focused) return;
        const previousMonthEls = previousRootElSnapshot instanceof HTMLElement ? $bd468b6c3a02cdcb$var$queryMonthEls(previousRootElSnapshot) : [];
        const currentMonthEls = $bd468b6c3a02cdcb$var$queryMonthEls(rootElRef.current);
        if (currentMonthEls?.every((el)=>el instanceof HTMLElement) && previousMonthEls?.every((el)=>el instanceof HTMLElement)) {
            animatingRef.current = true;
            const cleanUpFunctions = [];
            // set isolation to isolate to isolate the stacking context during animation
            rootElRef.current.style.isolation = "isolate";
            // set z-index to 1 to ensure the nav is clickable over the other elements being animated
            const navEl = $bd468b6c3a02cdcb$var$queryNavEl(rootElRef.current);
            if (navEl) navEl.style.zIndex = "1";
            currentMonthEls.forEach((currentMonthEl, index)=>{
                const previousMonthEl = previousMonthEls[index];
                if (!previousMonthEl) return;
                // animate new displayed month
                currentMonthEl.style.position = "relative";
                currentMonthEl.style.overflow = "hidden";
                const captionEl = $bd468b6c3a02cdcb$var$queryCaptionEl(currentMonthEl);
                if (captionEl) captionEl.classList.add(captionAnimationClass);
                const weeksEl = $bd468b6c3a02cdcb$var$queryWeeksEl(currentMonthEl);
                if (weeksEl) weeksEl.classList.add(weeksAnimationClass);
                // animate new displayed month end
                const cleanUp = ()=>{
                    animatingRef.current = false;
                    if (rootElRef.current) rootElRef.current.style.isolation = "";
                    if (navEl) navEl.style.zIndex = "";
                    if (captionEl) captionEl.classList.remove(captionAnimationClass);
                    if (weeksEl) weeksEl.classList.remove(weeksAnimationClass);
                    currentMonthEl.style.position = "";
                    currentMonthEl.style.overflow = "";
                    if (currentMonthEl.contains(previousMonthEl)) currentMonthEl.removeChild(previousMonthEl);
                };
                cleanUpFunctions.push(cleanUp);
                // animate old displayed month
                previousMonthEl.style.pointerEvents = "none";
                previousMonthEl.style.position = "absolute";
                previousMonthEl.style.overflow = "hidden";
                previousMonthEl.setAttribute("aria-hidden", "true");
                // hide the weekdays container of the old month and only the new one
                const previousWeekdaysEl = $bd468b6c3a02cdcb$var$queryWeekdaysEl(previousMonthEl);
                if (previousWeekdaysEl) previousWeekdaysEl.style.opacity = "0";
                const previousCaptionEl = $bd468b6c3a02cdcb$var$queryCaptionEl(previousMonthEl);
                if (previousCaptionEl) {
                    previousCaptionEl.classList.add(isAfterPreviousMonth ? classNames[(0, $d4e669abc392b351$export$c35d437ae5945fcd).caption_before_exit] : classNames[(0, $d4e669abc392b351$export$c35d437ae5945fcd).caption_after_exit]);
                    previousCaptionEl.addEventListener("animationend", cleanUp);
                }
                const previousWeeksEl = $bd468b6c3a02cdcb$var$queryWeeksEl(previousMonthEl);
                if (previousWeeksEl) previousWeeksEl.classList.add(isAfterPreviousMonth ? classNames[(0, $d4e669abc392b351$export$c35d437ae5945fcd).weeks_before_exit] : classNames[(0, $d4e669abc392b351$export$c35d437ae5945fcd).weeks_after_exit]);
                currentMonthEl.insertBefore(previousMonthEl, currentMonthEl.firstChild);
            });
        }
    });
}



var $h4Bez = parcelRequire("h4Bez");
/**
 * Returns all the dates to display in the calendar.
 *
 * This function calculates the range of dates to display based on the provided
 * display months, constraints, and calendar configuration.
 *
 * @param displayMonths The months to display in the calendar.
 * @param maxDate The maximum date to include in the range.
 * @param props The DayPicker props, including calendar configuration options.
 * @param dateLib The date library to use for date manipulation.
 * @returns An array of dates to display in the calendar.
 */ function $4694a739e0e875bc$export$dd09f40777b29234(displayMonths, maxDate, props, dateLib) {
    const firstMonth = displayMonths[0];
    const lastMonth = displayMonths[displayMonths.length - 1];
    const { ISOWeek: ISOWeek, fixedWeeks: fixedWeeks, broadcastCalendar: broadcastCalendar } = props ?? {};
    const { addDays: addDays, differenceInCalendarDays: differenceInCalendarDays, differenceInCalendarMonths: differenceInCalendarMonths, endOfBroadcastWeek: endOfBroadcastWeek, endOfISOWeek: endOfISOWeek, endOfMonth: endOfMonth, endOfWeek: endOfWeek, isAfter: isAfter, startOfBroadcastWeek: startOfBroadcastWeek, startOfISOWeek: startOfISOWeek, startOfWeek: startOfWeek } = dateLib;
    const startWeekFirstDate = broadcastCalendar ? startOfBroadcastWeek(firstMonth, dateLib) : ISOWeek ? startOfISOWeek(firstMonth) : startOfWeek(firstMonth);
    const displayMonthsWeekEnd = broadcastCalendar ? endOfBroadcastWeek(lastMonth) : ISOWeek ? endOfISOWeek(endOfMonth(lastMonth)) : endOfWeek(endOfMonth(lastMonth));
    // If maxDate is set, clamp the grid to the end of that week.
    const constraintWeekEnd = maxDate && (broadcastCalendar ? endOfBroadcastWeek(maxDate) : ISOWeek ? endOfISOWeek(maxDate) : endOfWeek(maxDate));
    // Pick the earliest week end between the displayed months and the constraint.
    const gridEndDate = constraintWeekEnd && isAfter(displayMonthsWeekEnd, constraintWeekEnd) ? constraintWeekEnd : displayMonthsWeekEnd;
    const nOfDays = differenceInCalendarDays(gridEndDate, startWeekFirstDate);
    const nOfMonths = differenceInCalendarMonths(lastMonth, firstMonth) + 1;
    const dates = [];
    for(let i = 0; i <= nOfDays; i++){
        const date = addDays(startWeekFirstDate, i);
        dates.push(date);
    }
    // If fixed weeks is enabled, add the extra dates to the array
    const nrOfDaysWithFixedWeeks = broadcastCalendar ? 35 : 42;
    const extraDates = nrOfDaysWithFixedWeeks * nOfMonths;
    if (fixedWeeks && dates.length < extraDates) {
        const daysToAdd = extraDates - dates.length;
        for(let i = 0; i < daysToAdd; i++){
            const date = addDays(dates[dates.length - 1], 1);
            dates.push(date);
        }
    }
    return dates;
}


/**
 * Returns all the days belonging to the calendar by merging the days in the
 * weeks for each month.
 *
 * @param calendarMonths The array of calendar months.
 * @returns An array of `CalendarDay` objects representing all the days in the
 *   calendar.
 */ function $621f27212b5b3aa2$export$5f84d4e06c0693c4(calendarMonths) {
    const initialDays = [];
    return calendarMonths.reduce((days, month)=>{
        const weekDays = month.weeks.reduce((weekDays, week)=>{
            return weekDays.concat(week.days.slice());
        }, initialDays.slice());
        return days.concat(weekDays.slice());
    }, initialDays.slice());
}


/**
 * Returns the months to display in the calendar.
 *
 * @param firstDisplayedMonth The first month currently displayed in the
 *   calendar.
 * @param calendarEndMonth The latest month the user can navigate to.
 * @param props The DayPicker props, including `numberOfMonths`.
 * @param dateLib The date library to use for date manipulation.
 * @returns An array of dates representing the months to display.
 */ function $eda40b5807336ce9$export$821489a553cc3c7a(firstDisplayedMonth, calendarEndMonth, props, dateLib) {
    const { numberOfMonths: numberOfMonths = 1 } = props;
    const months = [];
    for(let i = 0; i < numberOfMonths; i++){
        const month = dateLib.addMonths(firstDisplayedMonth, i);
        if (calendarEndMonth && month > calendarEndMonth) break;
        months.push(month);
    }
    return months;
}


/**
 * Determines the initial month to display in the calendar based on the provided
 * props.
 *
 * This function calculates the starting month, considering constraints such as
 * `startMonth`, `endMonth`, and the number of months to display.
 *
 * @param props The DayPicker props, including navigation and date constraints.
 * @param dateLib The date library to use for date manipulation.
 * @returns The initial month to display.
 */ function $44c4256113021c8f$export$8093856c9cba2ab4(props, navStart, navEnd, dateLib) {
    const { month: month, defaultMonth: defaultMonth, today: today = dateLib.today(), numberOfMonths: numberOfMonths = 1 } = props;
    let initialMonth = month || defaultMonth || today;
    const { differenceInCalendarMonths: differenceInCalendarMonths, addMonths: addMonths, startOfMonth: startOfMonth } = dateLib;
    if (navEnd && differenceInCalendarMonths(navEnd, initialMonth) < numberOfMonths - 1) {
        const offset = -1 * (numberOfMonths - 1);
        initialMonth = addMonths(navEnd, offset);
    }
    if (navStart && differenceInCalendarMonths(initialMonth, navStart) < 0) initialMonth = navStart;
    return startOfMonth(initialMonth);
}



class $ec1e3e4e6a984b48$export$25888c98befaa9a2 {
    constructor(date, displayMonth, dateLib = (0, $5bc78e2210779f86$export$6575cc37c71cbcd2)){
        this.date = date;
        this.displayMonth = displayMonth;
        this.outside = Boolean(displayMonth && !dateLib.isSameMonth(date, displayMonth));
        this.dateLib = dateLib;
        this.isoDate = dateLib.format(date, "yyyy-MM-dd");
        this.displayMonthId = dateLib.format(displayMonth, "yyyy-MM");
        this.dateMonthId = dateLib.format(date, "yyyy-MM");
    }
    /**
     * Checks if this day is equal to another `CalendarDay`, considering both the
     * date and the displayed month.
     *
     * @param day The `CalendarDay` to compare with.
     * @returns `true` if the days are equal, otherwise `false`.
     */ isEqualTo(day) {
        return this.dateLib.isSameDay(day.date, this.date) && this.dateLib.isSameMonth(day.displayMonth, this.displayMonth);
    }
}

/**
 * Represents a month in a calendar year.
 *
 * A `CalendarMonth` contains the weeks within the month and the date of the
 * month.
 */ class $98e04958c5a2e6f5$export$26e2752316b9a375 {
    constructor(month, weeks){
        this.date = month;
        this.weeks = weeks;
    }
}

/**
 * Represents a week in a calendar month.
 *
 * A `CalendarWeek` contains the days within the week and the week number.
 */ class $53e7eda666613a09$export$adf10f8fbb88fe03 {
    constructor(weekNumber, days){
        this.days = days;
        this.weekNumber = weekNumber;
    }
}


function $b83025d0d4736ff3$export$ab152e6ff2cc840e(displayMonths, dates, props, dateLib) {
    const { addDays: addDays, endOfBroadcastWeek: endOfBroadcastWeek, endOfISOWeek: endOfISOWeek, endOfMonth: endOfMonth, endOfWeek: endOfWeek, getISOWeek: getISOWeek, getWeek: getWeek, startOfBroadcastWeek: startOfBroadcastWeek, startOfISOWeek: startOfISOWeek, startOfWeek: startOfWeek } = dateLib;
    const dayPickerMonths = displayMonths.reduce((months, month)=>{
        const firstDateOfFirstWeek = props.broadcastCalendar ? startOfBroadcastWeek(month, dateLib) : props.ISOWeek ? startOfISOWeek(month) : startOfWeek(month);
        const lastDateOfLastWeek = props.broadcastCalendar ? endOfBroadcastWeek(month) : props.ISOWeek ? endOfISOWeek(endOfMonth(month)) : endOfWeek(endOfMonth(month));
        /** The dates to display in the month. */ const monthDates = dates.filter((date)=>{
            return date >= firstDateOfFirstWeek && date <= lastDateOfLastWeek;
        });
        const nrOfDaysWithFixedWeeks = props.broadcastCalendar ? 35 : 42;
        if (props.fixedWeeks && monthDates.length < nrOfDaysWithFixedWeeks) {
            const extraDates = dates.filter((date)=>{
                const daysToAdd = nrOfDaysWithFixedWeeks - monthDates.length;
                return date > lastDateOfLastWeek && date <= addDays(lastDateOfLastWeek, daysToAdd);
            });
            monthDates.push(...extraDates);
        }
        const weeks = monthDates.reduce((weeks, date)=>{
            const weekNumber = props.ISOWeek ? getISOWeek(date) : getWeek(date);
            const week = weeks.find((week)=>week.weekNumber === weekNumber);
            const day = new (0, $ec1e3e4e6a984b48$export$25888c98befaa9a2)(date, month, dateLib);
            if (!week) weeks.push(new (0, $53e7eda666613a09$export$adf10f8fbb88fe03)(weekNumber, [
                day
            ]));
            else week.days.push(day);
            return weeks;
        }, []);
        const dayPickerMonth = new (0, $98e04958c5a2e6f5$export$26e2752316b9a375)(month, weeks);
        months.push(dayPickerMonth);
        return months;
    }, []);
    if (!props.reverseMonths) return dayPickerMonths;
    else return dayPickerMonths.reverse();
}


/**
 * Returns the start and end months for calendar navigation.
 *
 * @param props The DayPicker props, including navigation and layout options.
 * @param dateLib The date library to use for date manipulation.
 * @returns A tuple containing the start and end months for navigation.
 */ function $caae11a639ee188b$export$b6d22bad34acd54e(props, dateLib) {
    let { startMonth: startMonth, endMonth: endMonth } = props;
    const { startOfYear: startOfYear, startOfDay: startOfDay, startOfMonth: startOfMonth, endOfMonth: endOfMonth, addYears: addYears, endOfYear: endOfYear, today: today } = dateLib;
    const hasYearDropdown = props.captionLayout === "dropdown" || props.captionLayout === "dropdown-years";
    if (startMonth) startMonth = startOfMonth(startMonth);
    else if (!startMonth && hasYearDropdown) startMonth = startOfYear(addYears(props.today ?? today(), -100));
    if (endMonth) endMonth = endOfMonth(endMonth);
    else if (!endMonth && hasYearDropdown) endMonth = endOfYear(props.today ?? today());
    return [
        startMonth ? startOfDay(startMonth) : startMonth,
        endMonth ? startOfDay(endMonth) : endMonth
    ];
}


/**
 * Returns the next month the user can navigate to, based on the given options.
 *
 * The next month is not always the next calendar month:
 *
 * - If it is after the `calendarEndMonth`, it returns `undefined`.
 * - If paged navigation is enabled, it skips forward by the number of displayed
 *   months.
 *
 * @param firstDisplayedMonth The first month currently displayed in the
 *   calendar.
 * @param calendarEndMonth The latest month the user can navigate to.
 * @param options Navigation options, including `numberOfMonths` and
 *   `pagedNavigation`.
 * @param dateLib The date library to use for date manipulation.
 * @returns The next month, or `undefined` if navigation is not possible.
 */ function $4a5906c6e3f10d35$export$336804f18a0452c1(firstDisplayedMonth, calendarEndMonth, options, dateLib) {
    if (options.disableNavigation) return undefined;
    const { pagedNavigation: pagedNavigation, numberOfMonths: numberOfMonths = 1 } = options;
    const { startOfMonth: startOfMonth, addMonths: addMonths, differenceInCalendarMonths: differenceInCalendarMonths } = dateLib;
    const offset = pagedNavigation ? numberOfMonths : 1;
    const month = startOfMonth(firstDisplayedMonth);
    if (!calendarEndMonth) return addMonths(month, offset);
    const monthsDiff = differenceInCalendarMonths(calendarEndMonth, firstDisplayedMonth);
    if (monthsDiff < numberOfMonths) return undefined;
    return addMonths(month, offset);
}


/**
 * Returns the previous month the user can navigate to, based on the given
 * options.
 *
 * The previous month is not always the previous calendar month:
 *
 * - If it is before the `calendarStartMonth`, it returns `undefined`.
 * - If paged navigation is enabled, it skips back by the number of displayed
 *   months.
 *
 * @param firstDisplayedMonth The first month currently displayed in the
 *   calendar.
 * @param calendarStartMonth The earliest month the user can navigate to.
 * @param options Navigation options, including `numberOfMonths` and
 *   `pagedNavigation`.
 * @param dateLib The date library to use for date manipulation.
 * @returns The previous month, or `undefined` if navigation is not possible.
 */ function $79cad8d3b57f7e69$export$dee316666c2ef75b(firstDisplayedMonth, calendarStartMonth, options, dateLib) {
    if (options.disableNavigation) return undefined;
    const { pagedNavigation: pagedNavigation, numberOfMonths: numberOfMonths } = options;
    const { startOfMonth: startOfMonth, addMonths: addMonths, differenceInCalendarMonths: differenceInCalendarMonths } = dateLib;
    const offset = pagedNavigation ? numberOfMonths ?? 1 : 1;
    const month = startOfMonth(firstDisplayedMonth);
    if (!calendarStartMonth) return addMonths(month, -offset);
    const monthsDiff = differenceInCalendarMonths(month, calendarStartMonth);
    if (monthsDiff <= 0) return undefined;
    return addMonths(month, -offset);
}


/**
 * Returns an array of calendar weeks from an array of calendar months.
 *
 * @param months The array of calendar months.
 * @returns An array of calendar weeks.
 */ function $9a287d79ce692577$export$6bf1a256dbbcec82(months) {
    const initialWeeks = [];
    return months.reduce((weeks, month)=>{
        return weeks.concat(month.weeks.slice());
    }, initialWeeks.slice());
}



var $h4Bez = parcelRequire("h4Bez");
function $951a42baf2faefdb$export$ac06ac6808815c7c(defaultValue, controlledValue) {
    const [uncontrolledValue, setValue] = (0, $h4Bez.useState)(defaultValue);
    const value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [
        value,
        setValue
    ];
}


function $315a295b5cb9f424$export$3ee915f8151bd4f1(props, dateLib) {
    const [navStart, navEnd] = (0, $caae11a639ee188b$export$b6d22bad34acd54e)(props, dateLib);
    const { startOfMonth: startOfMonth, endOfMonth: endOfMonth } = dateLib;
    const initialMonth = (0, $44c4256113021c8f$export$8093856c9cba2ab4)(props, navStart, navEnd, dateLib);
    const [firstMonth, setFirstMonth] = (0, $951a42baf2faefdb$export$ac06ac6808815c7c)(initialMonth, // initialMonth is always computed from props.month if provided
    props.month ? initialMonth : undefined);
    // biome-ignore lint/correctness/useExhaustiveDependencies: change the initial month when the time zone changes.
    (0, $h4Bez.useEffect)(()=>{
        const newInitialMonth = (0, $44c4256113021c8f$export$8093856c9cba2ab4)(props, navStart, navEnd, dateLib);
        setFirstMonth(newInitialMonth);
    }, [
        props.timeZone
    ]);
    /** The months displayed in the calendar. */ // biome-ignore lint/correctness/useExhaustiveDependencies: We want to recompute only when specific props change.
    const { months: months, weeks: weeks, days: days, previousMonth: previousMonth, nextMonth: nextMonth } = (0, $h4Bez.useMemo)(()=>{
        const displayMonths = (0, $eda40b5807336ce9$export$821489a553cc3c7a)(firstMonth, navEnd, {
            numberOfMonths: props.numberOfMonths
        }, dateLib);
        const dates = (0, $4694a739e0e875bc$export$dd09f40777b29234)(displayMonths, props.endMonth ? endOfMonth(props.endMonth) : undefined, {
            ISOWeek: props.ISOWeek,
            fixedWeeks: props.fixedWeeks,
            broadcastCalendar: props.broadcastCalendar
        }, dateLib);
        const months = (0, $b83025d0d4736ff3$export$ab152e6ff2cc840e)(displayMonths, dates, {
            broadcastCalendar: props.broadcastCalendar,
            fixedWeeks: props.fixedWeeks,
            ISOWeek: props.ISOWeek,
            reverseMonths: props.reverseMonths
        }, dateLib);
        const weeks = (0, $9a287d79ce692577$export$6bf1a256dbbcec82)(months);
        const days = (0, $621f27212b5b3aa2$export$5f84d4e06c0693c4)(months);
        const previousMonth = (0, $79cad8d3b57f7e69$export$dee316666c2ef75b)(firstMonth, navStart, props, dateLib);
        const nextMonth = (0, $4a5906c6e3f10d35$export$336804f18a0452c1)(firstMonth, navEnd, props, dateLib);
        return {
            months: months,
            weeks: weeks,
            days: days,
            previousMonth: previousMonth,
            nextMonth: nextMonth
        };
    }, [
        dateLib,
        firstMonth.getTime(),
        navEnd?.getTime(),
        navStart?.getTime(),
        props.disableNavigation,
        props.broadcastCalendar,
        props.endMonth?.getTime(),
        props.fixedWeeks,
        props.ISOWeek,
        props.numberOfMonths,
        props.pagedNavigation,
        props.reverseMonths
    ]);
    const { disableNavigation: disableNavigation, onMonthChange: onMonthChange } = props;
    const isDayInCalendar = (day)=>weeks.some((week)=>week.days.some((d)=>d.isEqualTo(day)));
    const goToMonth = (date)=>{
        if (disableNavigation) return;
        let newMonth = startOfMonth(date);
        // if month is before start, use the first month instead
        if (navStart && newMonth < startOfMonth(navStart)) newMonth = startOfMonth(navStart);
        // if month is after endMonth, use the last month instead
        if (navEnd && newMonth > startOfMonth(navEnd)) newMonth = startOfMonth(navEnd);
        setFirstMonth(newMonth);
        onMonthChange?.(newMonth);
    };
    const goToDay = (day)=>{
        // is this check necessary?
        if (isDayInCalendar(day)) return;
        goToMonth(day.date);
    };
    const calendar = {
        months: months,
        weeks: weeks,
        days: days,
        navStart: navStart,
        navEnd: navEnd,
        previousMonth: previousMonth,
        nextMonth: nextMonth,
        goToMonth: goToMonth,
        goToDay: goToDay
    };
    return calendar;
}




var $h4Bez = parcelRequire("h4Bez");

var $fe52a5a900a0de57$var$FocusTargetPriority;
(function(FocusTargetPriority) {
    FocusTargetPriority[FocusTargetPriority["Today"] = 0] = "Today";
    FocusTargetPriority[FocusTargetPriority["Selected"] = 1] = "Selected";
    FocusTargetPriority[FocusTargetPriority["LastFocused"] = 2] = "LastFocused";
    FocusTargetPriority[FocusTargetPriority["FocusedModifier"] = 3] = "FocusedModifier";
})($fe52a5a900a0de57$var$FocusTargetPriority || ($fe52a5a900a0de57$var$FocusTargetPriority = {}));
/**
 * Determines if a day is focusable based on its modifiers.
 *
 * A day is considered focusable if it is not disabled, hidden, or outside the
 * displayed month.
 *
 * @param modifiers The modifiers applied to the day.
 * @returns `true` if the day is focusable, otherwise `false`.
 */ function $fe52a5a900a0de57$var$isFocusableDay(modifiers) {
    return !modifiers[(0, $d4e669abc392b351$export$c2fd8ae3501086f5).disabled] && !modifiers[(0, $d4e669abc392b351$export$c2fd8ae3501086f5).hidden] && !modifiers[(0, $d4e669abc392b351$export$c2fd8ae3501086f5).outside];
}
function $fe52a5a900a0de57$export$d1565046db0d2be9(days, getModifiers, isSelected, lastFocused) {
    let focusTarget;
    let foundFocusTargetPriority = -1;
    for (const day of days){
        const modifiers = getModifiers(day);
        if ($fe52a5a900a0de57$var$isFocusableDay(modifiers)) {
            if (modifiers[(0, $d4e669abc392b351$export$c2fd8ae3501086f5).focused] && foundFocusTargetPriority < $fe52a5a900a0de57$var$FocusTargetPriority.FocusedModifier) {
                focusTarget = day;
                foundFocusTargetPriority = $fe52a5a900a0de57$var$FocusTargetPriority.FocusedModifier;
            } else if (lastFocused?.isEqualTo(day) && foundFocusTargetPriority < $fe52a5a900a0de57$var$FocusTargetPriority.LastFocused) {
                focusTarget = day;
                foundFocusTargetPriority = $fe52a5a900a0de57$var$FocusTargetPriority.LastFocused;
            } else if (isSelected(day.date) && foundFocusTargetPriority < $fe52a5a900a0de57$var$FocusTargetPriority.Selected) {
                focusTarget = day;
                foundFocusTargetPriority = $fe52a5a900a0de57$var$FocusTargetPriority.Selected;
            } else if (modifiers[(0, $d4e669abc392b351$export$c2fd8ae3501086f5).today] && foundFocusTargetPriority < $fe52a5a900a0de57$var$FocusTargetPriority.Today) {
                focusTarget = day;
                foundFocusTargetPriority = $fe52a5a900a0de57$var$FocusTargetPriority.Today;
            }
        }
    }
    if (!focusTarget) // Return the first day that is focusable
    focusTarget = days.find((day)=>$fe52a5a900a0de57$var$isFocusableDay(getModifiers(day)));
    return focusTarget;
}




/**
 * Calculates the next date that should be focused in the calendar.
 *
 * This function determines the next focusable date based on the movement
 * direction, constraints, and calendar configuration.
 *
 * @param moveBy The unit of movement (e.g., "day", "week").
 * @param moveDir The direction of movement ("before" or "after").
 * @param refDate The reference date from which to calculate the next focusable
 *   date.
 * @param navStart The earliest date the user can navigate to.
 * @param navEnd The latest date the user can navigate to.
 * @param props The DayPicker props, including calendar configuration options.
 * @param dateLib The date library to use for date manipulation.
 * @returns The next focusable date.
 */ function $be5bea5631ae5a97$export$8b23062bff9cc216(moveBy, moveDir, refDate, navStart, navEnd, props, dateLib) {
    const { ISOWeek: ISOWeek, broadcastCalendar: broadcastCalendar } = props;
    const { addDays: addDays, addMonths: addMonths, addWeeks: addWeeks, addYears: addYears, endOfBroadcastWeek: endOfBroadcastWeek, endOfISOWeek: endOfISOWeek, endOfWeek: endOfWeek, max: max, min: min, startOfBroadcastWeek: startOfBroadcastWeek, startOfISOWeek: startOfISOWeek, startOfWeek: startOfWeek } = dateLib;
    const moveFns = {
        day: addDays,
        week: addWeeks,
        month: addMonths,
        year: addYears,
        startOfWeek: (date)=>broadcastCalendar ? startOfBroadcastWeek(date, dateLib) : ISOWeek ? startOfISOWeek(date) : startOfWeek(date),
        endOfWeek: (date)=>broadcastCalendar ? endOfBroadcastWeek(date) : ISOWeek ? endOfISOWeek(date) : endOfWeek(date)
    };
    let focusableDate = moveFns[moveBy](refDate, moveDir === "after" ? 1 : -1);
    if (moveDir === "before" && navStart) focusableDate = max([
        navStart,
        focusableDate
    ]);
    else if (moveDir === "after" && navEnd) focusableDate = min([
        navEnd,
        focusableDate
    ]);
    return focusableDate;
}


function $d662bf02019fcdf9$export$4465a4fc56223a7(moveBy, moveDir, refDay, calendarStartMonth, calendarEndMonth, props, dateLib, attempt = 0) {
    if (attempt > 365) // Limit the recursion to 365 attempts
    return undefined;
    const focusableDate = (0, $be5bea5631ae5a97$export$8b23062bff9cc216)(moveBy, moveDir, refDay.date, calendarStartMonth, calendarEndMonth, props, dateLib);
    const isDisabled = Boolean(props.disabled && (0, $be70a17d869d8600$export$9c6809d9e0449c2e)(focusableDate, props.disabled, dateLib));
    const isHidden = Boolean(props.hidden && (0, $be70a17d869d8600$export$9c6809d9e0449c2e)(focusableDate, props.hidden, dateLib));
    const targetMonth = focusableDate;
    const focusDay = new (0, $ec1e3e4e6a984b48$export$25888c98befaa9a2)(focusableDate, targetMonth, dateLib);
    if (!isDisabled && !isHidden) return focusDay;
    // Recursively attempt to find the next focusable date
    return $d662bf02019fcdf9$export$4465a4fc56223a7(moveBy, moveDir, focusDay, calendarStartMonth, calendarEndMonth, props, dateLib, attempt + 1);
}


function $05fcec36e8a016fc$export$f8168d8dd8fd66e6(props, calendar, getModifiers, isSelected, dateLib) {
    const { autoFocus: autoFocus } = props;
    const [lastFocused, setLastFocused] = (0, $h4Bez.useState)();
    const focusTarget = (0, $fe52a5a900a0de57$export$d1565046db0d2be9)(calendar.days, getModifiers, isSelected || (()=>false), lastFocused);
    const [focusedDay, setFocused] = (0, $h4Bez.useState)(autoFocus ? focusTarget : undefined);
    const blur = ()=>{
        setLastFocused(focusedDay);
        setFocused(undefined);
    };
    const moveFocus = (moveBy, moveDir)=>{
        if (!focusedDay) return;
        const nextFocus = (0, $d662bf02019fcdf9$export$4465a4fc56223a7)(moveBy, moveDir, focusedDay, calendar.navStart, calendar.navEnd, props, dateLib);
        if (!nextFocus) return;
        if (props.disableNavigation) {
            const isNextInCalendar = calendar.days.some((day)=>day.isEqualTo(nextFocus));
            if (!isNextInCalendar) return;
        }
        calendar.goToDay(nextFocus);
        setFocused(nextFocus);
    };
    const isFocusTarget = (day)=>{
        return Boolean(focusTarget?.isEqualTo(day));
    };
    const useFocus = {
        isFocusTarget: isFocusTarget,
        setFocused: setFocused,
        focused: focusedDay,
        blur: blur,
        moveFocus: moveFocus
    };
    return useFocus;
}



function $fcf9d953e34848e8$export$fe656f71238ed465(props, dateLib) {
    const { selected: initiallySelected, required: required, onSelect: onSelect } = props;
    const [internallySelected, setSelected] = (0, $951a42baf2faefdb$export$ac06ac6808815c7c)(initiallySelected, onSelect ? initiallySelected : undefined);
    const selected = !onSelect ? internallySelected : initiallySelected;
    const { isSameDay: isSameDay } = dateLib;
    const isSelected = (date)=>{
        return selected?.some((d)=>isSameDay(d, date)) ?? false;
    };
    const { min: min, max: max } = props;
    const select = (triggerDate, modifiers, e)=>{
        let newDates = [
            ...selected ?? []
        ];
        if (isSelected(triggerDate)) {
            if (selected?.length === min) // Min value reached, do nothing
            return;
            if (required && selected?.length === 1) // Required value already selected do nothing
            return;
            newDates = selected?.filter((d)=>!isSameDay(d, triggerDate));
        } else if (selected?.length === max) // Max value reached, reset the selection to date
        newDates = [
            triggerDate
        ];
        else // Add the date to the selection
        newDates = [
            ...newDates,
            triggerDate
        ];
        if (!onSelect) setSelected(newDates);
        onSelect?.(newDates, triggerDate, modifiers, e);
        return newDates;
    };
    return {
        selected: selected,
        select: select,
        isSelected: isSelected
    };
}




function $58c4a4e49bcf4c3b$export$27ef550b4e6acc0c(date, initialRange, min = 0, max = 0, required = false, dateLib = (0, $5bc78e2210779f86$export$6575cc37c71cbcd2)) {
    const { from: from, to: to } = initialRange || {};
    const { isSameDay: isSameDay, isAfter: isAfter, isBefore: isBefore } = dateLib;
    let range;
    if (!from && !to) // the range is empty, add the date
    range = {
        from: date,
        to: min > 0 ? undefined : date
    };
    else if (from && !to) {
        // adding date to an incomplete range
        if (isSameDay(from, date)) {
            // adding a date equal to the start of the range
            if (min === 0) range = {
                from: from,
                to: date
            };
            else if (required) range = {
                from: from,
                to: undefined
            };
            else range = undefined;
        } else if (isBefore(date, from)) // adding a date before the start of the range
        range = {
            from: date,
            to: from
        };
        else // adding a date after the start of the range
        range = {
            from: from,
            to: date
        };
    } else if (from && to) {
        // adding date to a complete range
        if (isSameDay(from, date) && isSameDay(to, date)) {
            // adding a date that is equal to both start and end of the range
            if (required) range = {
                from: from,
                to: to
            };
            else range = undefined;
        } else if (isSameDay(from, date)) // adding a date equal to the the start of the range
        range = {
            from: from,
            to: min > 0 ? undefined : date
        };
        else if (isSameDay(to, date)) // adding a dare equal to the end of the range
        range = {
            from: date,
            to: min > 0 ? undefined : date
        };
        else if (isBefore(date, from)) // adding a date before the start of the range
        range = {
            from: date,
            to: to
        };
        else if (isAfter(date, from)) // adding a date after the start of the range
        range = {
            from: from,
            to: date
        };
        else if (isAfter(date, to)) // adding a date after the end of the range
        range = {
            from: from,
            to: date
        };
        else throw new Error("Invalid range");
    }
    // check for min / max
    if (range?.from && range?.to) {
        const diff = dateLib.differenceInCalendarDays(range.to, range.from);
        if (max > 0 && diff > max) range = {
            from: date,
            to: undefined
        };
        else if (min > 1 && diff < min) range = {
            from: date,
            to: undefined
        };
    }
    return range;
}




function $0d04cdd4e74f9fc8$export$fbe8c32778db3e4c(range, dayOfWeek, dateLib = (0, $5bc78e2210779f86$export$6575cc37c71cbcd2)) {
    const dayOfWeekArr = !Array.isArray(dayOfWeek) ? [
        dayOfWeek
    ] : dayOfWeek;
    let date = range.from;
    const totalDays = dateLib.differenceInCalendarDays(range.to, range.from);
    // iterate at maximum one week or the total days if the range is shorter than one week
    const totalDaysLimit = Math.min(totalDays, 6);
    for(let i = 0; i <= totalDaysLimit; i++){
        if (dayOfWeekArr.includes(date.getDay())) return true;
        date = dateLib.addDays(date, 1);
    }
    return false;
}





function $d86af0294878535a$export$255adf1d7bd005ac(rangeLeft, rangeRight, dateLib = (0, $5bc78e2210779f86$export$6575cc37c71cbcd2)) {
    return (0, $002f4c7bfd16f136$export$ea4b24aaa0e5da4a)(rangeLeft, rangeRight.from, false, dateLib) || (0, $002f4c7bfd16f136$export$ea4b24aaa0e5da4a)(rangeLeft, rangeRight.to, false, dateLib) || (0, $002f4c7bfd16f136$export$ea4b24aaa0e5da4a)(rangeRight, rangeLeft.from, false, dateLib) || (0, $002f4c7bfd16f136$export$ea4b24aaa0e5da4a)(rangeRight, rangeLeft.to, false, dateLib);
}



function $698903707497999f$export$129e86809f92e546(range, modifiers, dateLib = (0, $5bc78e2210779f86$export$6575cc37c71cbcd2)) {
    const matchers = Array.isArray(modifiers) ? modifiers : [
        modifiers
    ];
    // Defer function matchers evaluation as they are the least performant.
    const nonFunctionMatchers = matchers.filter((matcher)=>typeof matcher !== "function");
    const nonFunctionMatchersResult = nonFunctionMatchers.some((matcher)=>{
        if (typeof matcher === "boolean") return matcher;
        if (dateLib.isDate(matcher)) return (0, $002f4c7bfd16f136$export$ea4b24aaa0e5da4a)(range, matcher, false, dateLib);
        if ((0, $73b4472bf8fc0b4f$export$1586b56a557d6c60)(matcher, dateLib)) return matcher.some((date)=>(0, $002f4c7bfd16f136$export$ea4b24aaa0e5da4a)(range, date, false, dateLib));
        if ((0, $73b4472bf8fc0b4f$export$dd455b9c98fea187)(matcher)) {
            if (matcher.from && matcher.to) return (0, $d86af0294878535a$export$255adf1d7bd005ac)(range, {
                from: matcher.from,
                to: matcher.to
            }, dateLib);
            return false;
        }
        if ((0, $73b4472bf8fc0b4f$export$483c833837970a3)(matcher)) return (0, $0d04cdd4e74f9fc8$export$fbe8c32778db3e4c)(range, matcher.dayOfWeek, dateLib);
        if ((0, $73b4472bf8fc0b4f$export$654311eaff47f3cd)(matcher)) {
            const isClosedInterval = dateLib.isAfter(matcher.before, matcher.after);
            if (isClosedInterval) return (0, $d86af0294878535a$export$255adf1d7bd005ac)(range, {
                from: dateLib.addDays(matcher.after, 1),
                to: dateLib.addDays(matcher.before, -1)
            }, dateLib);
            return (0, $be70a17d869d8600$export$9c6809d9e0449c2e)(range.from, matcher, dateLib) || (0, $be70a17d869d8600$export$9c6809d9e0449c2e)(range.to, matcher, dateLib);
        }
        if ((0, $73b4472bf8fc0b4f$export$4760905e07020cd4)(matcher) || (0, $73b4472bf8fc0b4f$export$a3bef2c4e855ef4e)(matcher)) return (0, $be70a17d869d8600$export$9c6809d9e0449c2e)(range.from, matcher, dateLib) || (0, $be70a17d869d8600$export$9c6809d9e0449c2e)(range.to, matcher, dateLib);
        return false;
    });
    if (nonFunctionMatchersResult) return true;
    const functionMatchers = matchers.filter((matcher)=>typeof matcher === "function");
    if (functionMatchers.length) {
        let date = range.from;
        const totalDays = dateLib.differenceInCalendarDays(range.to, range.from);
        for(let i = 0; i <= totalDays; i++){
            if (functionMatchers.some((matcher)=>matcher(date))) return true;
            date = dateLib.addDays(date, 1);
        }
    }
    return false;
}



function $54ddf24d87ad0e98$export$7f6d8a9c788c158e(props, dateLib) {
    const { disabled: disabled, excludeDisabled: excludeDisabled, resetOnSelect: resetOnSelect, selected: initiallySelected, required: required, onSelect: onSelect } = props;
    const [internallySelected, setSelected] = (0, $951a42baf2faefdb$export$ac06ac6808815c7c)(initiallySelected, onSelect ? initiallySelected : undefined);
    const selected = !onSelect ? internallySelected : initiallySelected;
    const isSelected = (date)=>selected && (0, $002f4c7bfd16f136$export$ea4b24aaa0e5da4a)(selected, date, false, dateLib);
    const select = (triggerDate, modifiers, e)=>{
        const { min: min, max: max } = props;
        let newRange;
        if (triggerDate) {
            const selectedFrom = selected?.from;
            const selectedTo = selected?.to;
            const hasFullRange = !!selectedFrom && !!selectedTo;
            const isClickingSingleDayRange = !!selectedFrom && !!selectedTo && dateLib.isSameDay(selectedFrom, selectedTo) && dateLib.isSameDay(triggerDate, selectedFrom);
            if (resetOnSelect && (hasFullRange || !selected?.from)) {
                if (!required && isClickingSingleDayRange) newRange = undefined;
                else newRange = {
                    from: triggerDate,
                    to: undefined
                };
            } else newRange = (0, $58c4a4e49bcf4c3b$export$27ef550b4e6acc0c)(triggerDate, selected, min, max, required, dateLib);
        }
        if (excludeDisabled && disabled && newRange?.from && newRange.to) {
            if ((0, $698903707497999f$export$129e86809f92e546)({
                from: newRange.from,
                to: newRange.to
            }, disabled, dateLib)) {
                // if a disabled days is found, the range is reset
                newRange.from = triggerDate;
                newRange.to = undefined;
            }
        }
        if (!onSelect) setSelected(newRange);
        onSelect?.(newRange, triggerDate, modifiers, e);
        return newRange;
    };
    return {
        selected: selected,
        select: select,
        isSelected: isSelected
    };
}



function $aa4109486aff28e1$export$3bf0ca7eec2741(props, dateLib) {
    const { selected: initiallySelected, required: required, onSelect: onSelect } = props;
    const [internallySelected, setSelected] = (0, $951a42baf2faefdb$export$ac06ac6808815c7c)(initiallySelected, onSelect ? initiallySelected : undefined);
    const selected = !onSelect ? internallySelected : initiallySelected;
    const { isSameDay: isSameDay } = dateLib;
    const isSelected = (compareDate)=>{
        return selected ? isSameDay(selected, compareDate) : false;
    };
    const select = (triggerDate, modifiers, e)=>{
        let newDate = triggerDate;
        if (!required && selected && selected && isSameDay(triggerDate, selected)) // If the date is the same, clear the selection.
        newDate = undefined;
        if (!onSelect) setSelected(newDate);
        if (required) onSelect?.(newDate, triggerDate, modifiers, e);
        else onSelect?.(newDate, triggerDate, modifiers, e);
        return newDate;
    };
    return {
        selected: selected,
        select: select,
        isSelected: isSelected
    };
}


function $2fb9712d7a114209$export$a97c3cc4bf1da1ca(props, dateLib) {
    const single = (0, $aa4109486aff28e1$export$3bf0ca7eec2741)(props, dateLib);
    const multi = (0, $fcf9d953e34848e8$export$fe656f71238ed465)(props, dateLib);
    const range = (0, $54ddf24d87ad0e98$export$7f6d8a9c788c158e)(props, dateLib);
    switch(props.mode){
        case "single":
            return single;
        case "multiple":
            return multi;
        case "range":
            return range;
        default:
            return undefined;
    }
}




function $63b450fcd0575e26$export$538b00033cc11c75(date, timeZone) {
    if (date instanceof (0, $8f2a7769b12c0486$export$8de43e28dd4af6bd) && date.timeZone === timeZone) return date;
    return new (0, $8f2a7769b12c0486$export$8de43e28dd4af6bd)(date, timeZone);
}



function $b8bd8433ace98451$var$toZoneNoon(date, timeZone, noonSafe) {
    if (!noonSafe) return (0, $63b450fcd0575e26$export$538b00033cc11c75)(date, timeZone);
    const zoned = (0, $63b450fcd0575e26$export$538b00033cc11c75)(date, timeZone);
    const noonZoned = new (0, $8f2a7769b12c0486$export$8de43e28dd4af6bd)(zoned.getFullYear(), zoned.getMonth(), zoned.getDate(), 12, 0, 0, timeZone);
    return new Date(noonZoned.getTime());
}
function $b8bd8433ace98451$var$convertMatcher(matcher, timeZone, noonSafe) {
    if (typeof matcher === "boolean" || typeof matcher === "function") return matcher;
    if (matcher instanceof Date) return $b8bd8433ace98451$var$toZoneNoon(matcher, timeZone, noonSafe);
    if (Array.isArray(matcher)) return matcher.map((value)=>value instanceof Date ? $b8bd8433ace98451$var$toZoneNoon(value, timeZone, noonSafe) : value);
    if ((0, $73b4472bf8fc0b4f$export$dd455b9c98fea187)(matcher)) return {
        ...matcher,
        from: matcher.from ? (0, $63b450fcd0575e26$export$538b00033cc11c75)(matcher.from, timeZone) : matcher.from,
        to: matcher.to ? (0, $63b450fcd0575e26$export$538b00033cc11c75)(matcher.to, timeZone) : matcher.to
    };
    if ((0, $73b4472bf8fc0b4f$export$654311eaff47f3cd)(matcher)) return {
        before: $b8bd8433ace98451$var$toZoneNoon(matcher.before, timeZone, noonSafe),
        after: $b8bd8433ace98451$var$toZoneNoon(matcher.after, timeZone, noonSafe)
    };
    if ((0, $73b4472bf8fc0b4f$export$4760905e07020cd4)(matcher)) return {
        after: $b8bd8433ace98451$var$toZoneNoon(matcher.after, timeZone, noonSafe)
    };
    if ((0, $73b4472bf8fc0b4f$export$a3bef2c4e855ef4e)(matcher)) return {
        before: $b8bd8433ace98451$var$toZoneNoon(matcher.before, timeZone, noonSafe)
    };
    return matcher;
}
function $b8bd8433ace98451$export$d02b6a759fa274a4(matchers, timeZone, noonSafe) {
    if (!matchers) return matchers;
    if (Array.isArray(matchers)) return matchers.map((matcher)=>$b8bd8433ace98451$var$convertMatcher(matcher, timeZone, noonSafe));
    return $b8bd8433ace98451$var$convertMatcher(matchers, timeZone, noonSafe);
}





function $eb41165c6fd11357$export$97e6db89a86ff7ab(initialProps) {
    let props = initialProps;
    const timeZone = props.timeZone;
    if (timeZone) {
        props = {
            ...initialProps,
            timeZone: timeZone
        };
        if (props.today) props.today = (0, $63b450fcd0575e26$export$538b00033cc11c75)(props.today, timeZone);
        if (props.month) props.month = (0, $63b450fcd0575e26$export$538b00033cc11c75)(props.month, timeZone);
        if (props.defaultMonth) props.defaultMonth = (0, $63b450fcd0575e26$export$538b00033cc11c75)(props.defaultMonth, timeZone);
        if (props.startMonth) props.startMonth = (0, $63b450fcd0575e26$export$538b00033cc11c75)(props.startMonth, timeZone);
        if (props.endMonth) props.endMonth = (0, $63b450fcd0575e26$export$538b00033cc11c75)(props.endMonth, timeZone);
        if (props.mode === "single" && props.selected) props.selected = (0, $63b450fcd0575e26$export$538b00033cc11c75)(props.selected, timeZone);
        else if (props.mode === "multiple" && props.selected) props.selected = props.selected?.map((date)=>(0, $63b450fcd0575e26$export$538b00033cc11c75)(date, timeZone));
        else if (props.mode === "range" && props.selected) props.selected = {
            from: props.selected.from ? (0, $63b450fcd0575e26$export$538b00033cc11c75)(props.selected.from, timeZone) : props.selected.from,
            to: props.selected.to ? (0, $63b450fcd0575e26$export$538b00033cc11c75)(props.selected.to, timeZone) : props.selected.to
        };
        if (props.disabled !== undefined) props.disabled = (0, $b8bd8433ace98451$export$d02b6a759fa274a4)(props.disabled, timeZone);
        if (props.hidden !== undefined) props.hidden = (0, $b8bd8433ace98451$export$d02b6a759fa274a4)(props.hidden, timeZone);
        if (props.modifiers) {
            const nextModifiers = {};
            Object.keys(props.modifiers).forEach((key)=>{
                nextModifiers[key] = (0, $b8bd8433ace98451$export$d02b6a759fa274a4)(props.modifiers?.[key], timeZone);
            });
            props.modifiers = nextModifiers;
        }
    }
    const { components: components, formatters: formatters, labels: labels, dateLib: dateLib, locale: locale, classNames: classNames } = (0, $h4Bez.useMemo)(()=>{
        const locale = {
            ...(0, $83244f94822f3936$export$137380d9ce54f7f),
            ...props.locale
        };
        const weekStartsOn = props.broadcastCalendar ? 1 : props.weekStartsOn;
        const noonOverrides = props.noonSafe && props.timeZone ? (0, $acf78e4d36e443cb$export$616f3fa68501513e)(props.timeZone, {
            weekStartsOn: weekStartsOn,
            locale: locale
        }) : undefined;
        const overrides = props.dateLib && noonOverrides ? {
            ...noonOverrides,
            ...props.dateLib
        } : props.dateLib ?? noonOverrides;
        const dateLib = new (0, $5bc78e2210779f86$export$87f71ed78036473c)({
            locale: locale,
            weekStartsOn: weekStartsOn,
            firstWeekContainsDate: props.firstWeekContainsDate,
            useAdditionalWeekYearTokens: props.useAdditionalWeekYearTokens,
            useAdditionalDayOfYearTokens: props.useAdditionalDayOfYearTokens,
            timeZone: props.timeZone,
            numerals: props.numerals
        }, overrides);
        return {
            dateLib: dateLib,
            components: (0, $db599084b1cae9af$export$4e811121b221213b)(props.components),
            formatters: (0, $fa8c577a652dc9c3$export$2eec0f50813b8d07)(props.formatters),
            labels: (0, $94731da4de449200$export$f81a3ec2bfb3f287)(props.labels, dateLib.options),
            locale: locale,
            classNames: {
                ...(0, $bba0d7038cd68da0$export$8f10228aec87fae6)(),
                ...props.classNames
            }
        };
    }, [
        props.locale,
        props.broadcastCalendar,
        props.weekStartsOn,
        props.firstWeekContainsDate,
        props.useAdditionalWeekYearTokens,
        props.useAdditionalDayOfYearTokens,
        props.timeZone,
        props.numerals,
        props.dateLib,
        props.noonSafe,
        props.components,
        props.formatters,
        props.labels,
        props.classNames
    ]);
    if (!props.today) props = {
        ...props,
        today: dateLib.today()
    };
    const { captionLayout: captionLayout, mode: mode, navLayout: navLayout, numberOfMonths: numberOfMonths = 1, onDayBlur: onDayBlur, onDayClick: onDayClick, onDayFocus: onDayFocus, onDayKeyDown: onDayKeyDown, onDayMouseEnter: onDayMouseEnter, onDayMouseLeave: onDayMouseLeave, onNextClick: onNextClick, onPrevClick: onPrevClick, showWeekNumber: showWeekNumber, styles: styles } = props;
    const { formatCaption: formatCaption, formatDay: formatDay, formatMonthDropdown: formatMonthDropdown, formatWeekNumber: formatWeekNumber, formatWeekNumberHeader: formatWeekNumberHeader, formatWeekdayName: formatWeekdayName, formatYearDropdown: formatYearDropdown } = formatters;
    const calendar = (0, $315a295b5cb9f424$export$3ee915f8151bd4f1)(props, dateLib);
    const { days: days, months: months, navStart: navStart, navEnd: navEnd, previousMonth: previousMonth, nextMonth: nextMonth, goToMonth: goToMonth } = calendar;
    const getModifiers = (0, $daaccbc85e0325f4$export$d8e8c7c9d8ef915a)(days, props, navStart, navEnd, dateLib);
    const { isSelected: isSelected, select: select, selected: selectedValue } = (0, $2fb9712d7a114209$export$a97c3cc4bf1da1ca)(props, dateLib) ?? {};
    const { blur: blur, focused: focused, isFocusTarget: isFocusTarget, moveFocus: moveFocus, setFocused: setFocused } = (0, $05fcec36e8a016fc$export$f8168d8dd8fd66e6)(props, calendar, getModifiers, isSelected ?? (()=>false), dateLib);
    const { labelDayButton: labelDayButton, labelGridcell: labelGridcell, labelGrid: labelGrid, labelMonthDropdown: labelMonthDropdown, labelNav: labelNav, labelPrevious: labelPrevious, labelNext: labelNext, labelWeekday: labelWeekday, labelWeekNumber: labelWeekNumber, labelWeekNumberHeader: labelWeekNumberHeader, labelYearDropdown: labelYearDropdown } = labels;
    const weekdays = (0, $h4Bez.useMemo)(()=>(0, $3afc993949ef4a60$export$24c38139da66592d)(dateLib, props.ISOWeek, props.broadcastCalendar, props.today), [
        dateLib,
        props.ISOWeek,
        props.broadcastCalendar,
        props.today
    ]);
    const isInteractive = mode !== undefined || onDayClick !== undefined;
    const handlePreviousClick = (0, $h4Bez.useCallback)(()=>{
        if (!previousMonth) return;
        goToMonth(previousMonth);
        onPrevClick?.(previousMonth);
    }, [
        previousMonth,
        goToMonth,
        onPrevClick
    ]);
    const handleNextClick = (0, $h4Bez.useCallback)(()=>{
        if (!nextMonth) return;
        goToMonth(nextMonth);
        onNextClick?.(nextMonth);
    }, [
        goToMonth,
        nextMonth,
        onNextClick
    ]);
    const handleDayClick = (0, $h4Bez.useCallback)((day, m)=>(e)=>{
            e.preventDefault();
            e.stopPropagation();
            setFocused(day);
            if (m.disabled) return;
            select?.(day.date, m, e);
            onDayClick?.(day.date, m, e);
        }, [
        select,
        onDayClick,
        setFocused
    ]);
    const handleDayFocus = (0, $h4Bez.useCallback)((day, m)=>(e)=>{
            setFocused(day);
            onDayFocus?.(day.date, m, e);
        }, [
        onDayFocus,
        setFocused
    ]);
    const handleDayBlur = (0, $h4Bez.useCallback)((day, m)=>(e)=>{
            blur();
            onDayBlur?.(day.date, m, e);
        }, [
        blur,
        onDayBlur
    ]);
    const handleDayKeyDown = (0, $h4Bez.useCallback)((day, modifiers)=>(e)=>{
            const keyMap = {
                ArrowLeft: [
                    e.shiftKey ? "month" : "day",
                    props.dir === "rtl" ? "after" : "before"
                ],
                ArrowRight: [
                    e.shiftKey ? "month" : "day",
                    props.dir === "rtl" ? "before" : "after"
                ],
                ArrowDown: [
                    e.shiftKey ? "year" : "week",
                    "after"
                ],
                ArrowUp: [
                    e.shiftKey ? "year" : "week",
                    "before"
                ],
                PageUp: [
                    e.shiftKey ? "year" : "month",
                    "before"
                ],
                PageDown: [
                    e.shiftKey ? "year" : "month",
                    "after"
                ],
                Home: [
                    "startOfWeek",
                    "before"
                ],
                End: [
                    "endOfWeek",
                    "after"
                ]
            };
            if (keyMap[e.key]) {
                e.preventDefault();
                e.stopPropagation();
                const [moveBy, moveDir] = keyMap[e.key];
                moveFocus(moveBy, moveDir);
            }
            onDayKeyDown?.(day.date, modifiers, e);
        }, [
        moveFocus,
        onDayKeyDown,
        props.dir
    ]);
    const handleDayMouseEnter = (0, $h4Bez.useCallback)((day, modifiers)=>(e)=>{
            onDayMouseEnter?.(day.date, modifiers, e);
        }, [
        onDayMouseEnter
    ]);
    const handleDayMouseLeave = (0, $h4Bez.useCallback)((day, modifiers)=>(e)=>{
            onDayMouseLeave?.(day.date, modifiers, e);
        }, [
        onDayMouseLeave
    ]);
    const handleMonthChange = (0, $h4Bez.useCallback)((date, monthOffset)=>(e)=>{
            const selectedMonth = Number(e.target.value);
            const month = dateLib.setMonth(dateLib.startOfMonth(date), selectedMonth);
            goToMonth(dateLib.addMonths(month, -monthOffset));
        }, [
        dateLib,
        goToMonth
    ]);
    const handleYearChange = (0, $h4Bez.useCallback)((date, monthOffset)=>(e)=>{
            const selectedYear = Number(e.target.value);
            const month = dateLib.setYear(dateLib.startOfMonth(date), selectedYear);
            goToMonth(dateLib.addMonths(month, -monthOffset));
        }, [
        dateLib,
        goToMonth
    ]);
    const { className: className, style: style } = (0, $h4Bez.useMemo)(()=>({
            className: [
                classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Root],
                props.className
            ].filter(Boolean).join(" "),
            style: {
                ...styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Root],
                ...props.style
            }
        }), [
        classNames,
        props.className,
        props.style,
        styles
    ]);
    const dataAttributes = (0, $e53eb300bca63c43$export$e5ac556b1404ae1e)(props);
    const getDropdownStyle = (dropdown)=>{
        const dropdownStyle = styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Dropdown];
        const specificDropdownStyle = styles?.[dropdown];
        if (!dropdownStyle && !specificDropdownStyle) return undefined;
        return {
            ...dropdownStyle,
            ...specificDropdownStyle
        };
    };
    const rootElRef = (0, $h4Bez.useRef)(null);
    (0, $bd468b6c3a02cdcb$export$9e2608686d4ad846)(rootElRef, Boolean(props.animate), {
        classNames: classNames,
        months: months,
        focused: focused,
        dateLib: dateLib
    });
    const contextValue = {
        dayPickerProps: props,
        selected: selectedValue,
        select: select,
        isSelected: isSelected,
        months: months,
        nextMonth: nextMonth,
        previousMonth: previousMonth,
        goToMonth: goToMonth,
        getModifiers: getModifiers,
        components: components,
        classNames: classNames,
        styles: styles,
        labels: labels,
        formatters: formatters
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement((0, $5ea8c07a697b6a0f$export$468c0287d43ba92a).Provider, {
        value: contextValue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Root, {
        rootRef: props.animate ? rootElRef : undefined,
        className: className,
        style: style,
        dir: props.dir,
        id: props.id,
        lang: props.lang ?? locale.code,
        nonce: props.nonce,
        title: props.title,
        role: props.role,
        "aria-label": props["aria-label"],
        "aria-labelledby": props["aria-labelledby"],
        ...dataAttributes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Months, {
        className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Months],
        style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Months]
    }, !props.hideNavigation && !navLayout && (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Nav, {
        "data-animated-nav": props.animate ? "true" : undefined,
        className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Nav],
        style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Nav],
        "aria-label": labelNav(),
        onPreviousClick: handlePreviousClick,
        onNextClick: handleNextClick,
        previousMonth: previousMonth,
        nextMonth: nextMonth
    }), months.map((calendarMonth, displayIndex)=>{
        const monthOffset = props.reverseMonths ? months.length - 1 - displayIndex : displayIndex;
        return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Month, {
            "data-animated-month": props.animate ? "true" : undefined,
            className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Month],
            style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: displayIndex,
            displayIndex: displayIndex,
            calendarMonth: calendarMonth
        }, navLayout === "around" && !props.hideNavigation && displayIndex === 0 && (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.PreviousMonthButton, {
            type: "button",
            className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).PreviousMonthButton],
            style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).PreviousMonthButton],
            tabIndex: previousMonth ? undefined : -1,
            "aria-disabled": previousMonth ? undefined : true,
            "aria-label": labelPrevious(previousMonth),
            onClick: handlePreviousClick,
            "data-animated-button": props.animate ? "true" : undefined
        }, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Chevron, {
            disabled: previousMonth ? undefined : true,
            className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Chevron],
            style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Chevron],
            orientation: props.dir === "rtl" ? "right" : "left"
        })), (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.MonthCaption, {
            "data-animated-caption": props.animate ? "true" : undefined,
            className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).MonthCaption],
            style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).MonthCaption],
            calendarMonth: calendarMonth,
            displayIndex: displayIndex
        }, captionLayout?.startsWith("dropdown") ? (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.DropdownNav, {
            className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Dropdowns],
            style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Dropdowns]
        }, (()=>{
            const monthControl = captionLayout === "dropdown" || captionLayout === "dropdown-months" ? (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.MonthsDropdown, {
                key: "month",
                className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).MonthsDropdown],
                "aria-label": labelMonthDropdown(),
                disabled: Boolean(props.disableNavigation),
                onChange: handleMonthChange(calendarMonth.date, monthOffset),
                options: (0, $90713fbc017dba79$export$5365e964dff332d1)(calendarMonth.date, navStart, navEnd, formatters, dateLib),
                style: getDropdownStyle((0, $d4e669abc392b351$export$4b08aed5f1ec6952).MonthsDropdown),
                value: dateLib.getMonth(calendarMonth.date)
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("span", {
                key: "month"
            }, formatMonthDropdown(calendarMonth.date, dateLib));
            const yearControl = captionLayout === "dropdown" || captionLayout === "dropdown-years" ? (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.YearsDropdown, {
                key: "year",
                className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).YearsDropdown],
                "aria-label": labelYearDropdown(dateLib.options),
                disabled: Boolean(props.disableNavigation),
                onChange: handleYearChange(calendarMonth.date, monthOffset),
                options: (0, $acfb360b526a2de1$export$9865296f13ed9cac)(navStart, navEnd, formatters, dateLib, Boolean(props.reverseYears)),
                style: getDropdownStyle((0, $d4e669abc392b351$export$4b08aed5f1ec6952).YearsDropdown),
                value: dateLib.getYear(calendarMonth.date)
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("span", {
                key: "year"
            }, formatYearDropdown(calendarMonth.date, dateLib));
            const controls = dateLib.getMonthYearOrder() === "year-first" ? [
                yearControl,
                monthControl
            ] : [
                monthControl,
                yearControl
            ];
            return controls;
        })(), (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("span", {
            role: "status",
            "aria-live": "polite",
            style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: "1px",
                margin: "-1px",
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: "1px",
                whiteSpace: "nowrap",
                wordWrap: "normal"
            }
        }, formatCaption(calendarMonth.date, dateLib.options, dateLib))) : (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.CaptionLabel, {
            className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).CaptionLabel],
            style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).CaptionLabel],
            role: "status",
            "aria-live": "polite"
        }, formatCaption(calendarMonth.date, dateLib.options, dateLib))), navLayout === "around" && !props.hideNavigation && displayIndex === numberOfMonths - 1 && (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.NextMonthButton, {
            type: "button",
            className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).NextMonthButton],
            style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).NextMonthButton],
            tabIndex: nextMonth ? undefined : -1,
            "aria-disabled": nextMonth ? undefined : true,
            "aria-label": labelNext(nextMonth),
            onClick: handleNextClick,
            "data-animated-button": props.animate ? "true" : undefined
        }, (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Chevron, {
            disabled: nextMonth ? undefined : true,
            className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Chevron],
            style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Chevron],
            orientation: props.dir === "rtl" ? "left" : "right"
        })), displayIndex === numberOfMonths - 1 && navLayout === "after" && !props.hideNavigation && (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Nav, {
            "data-animated-nav": props.animate ? "true" : undefined,
            className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Nav],
            style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Nav],
            "aria-label": labelNav(),
            onPreviousClick: handlePreviousClick,
            onNextClick: handleNextClick,
            previousMonth: previousMonth,
            nextMonth: nextMonth
        }), (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.MonthGrid, {
            role: "grid",
            "aria-multiselectable": mode === "multiple" || mode === "range",
            "aria-label": labelGrid(calendarMonth.date, dateLib.options, dateLib) || undefined,
            className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).MonthGrid],
            style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).MonthGrid]
        }, !props.hideWeekdays && (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Weekdays, {
            "data-animated-weekdays": props.animate ? "true" : undefined,
            className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Weekdays],
            style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Weekdays]
        }, showWeekNumber && (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.WeekNumberHeader, {
            "aria-label": labelWeekNumberHeader(dateLib.options),
            className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).WeekNumberHeader],
            style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).WeekNumberHeader],
            scope: "col"
        }, formatWeekNumberHeader()), weekdays.map((weekday)=>(0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Weekday, {
                "aria-label": labelWeekday(weekday, dateLib.options, dateLib),
                className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Weekday],
                key: String(weekday),
                style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Weekday],
                scope: "col"
            }, formatWeekdayName(weekday, dateLib.options, dateLib)))), (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Weeks, {
            "data-animated-weeks": props.animate ? "true" : undefined,
            className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Weeks],
            style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Weeks]
        }, calendarMonth.weeks.map((week)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Week, {
                className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Week],
                key: week.weekNumber,
                style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Week],
                week: week
            }, showWeekNumber && (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.WeekNumber, {
                week: week,
                style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).WeekNumber],
                "aria-label": labelWeekNumber(week.weekNumber, {
                    locale: locale
                }),
                className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).WeekNumber],
                scope: "row",
                role: "rowheader"
            }, formatWeekNumber(week.weekNumber, dateLib)), week.days.map((day)=>{
                const { date: date } = day;
                const modifiers = getModifiers(day);
                modifiers[(0, $d4e669abc392b351$export$c2fd8ae3501086f5).focused] = !modifiers.hidden && Boolean(focused?.isEqualTo(day));
                modifiers[(0, $d4e669abc392b351$export$2255d92a85eab347).selected] = isSelected?.(date) || modifiers.selected;
                if ((0, $73b4472bf8fc0b4f$export$dd455b9c98fea187)(selectedValue)) {
                    // add range modifiers
                    const { from: from, to: to } = selectedValue;
                    modifiers[(0, $d4e669abc392b351$export$2255d92a85eab347).range_start] = Boolean(from && to && dateLib.isSameDay(date, from));
                    modifiers[(0, $d4e669abc392b351$export$2255d92a85eab347).range_end] = Boolean(from && to && dateLib.isSameDay(date, to));
                    modifiers[(0, $d4e669abc392b351$export$2255d92a85eab347).range_middle] = (0, $002f4c7bfd16f136$export$ea4b24aaa0e5da4a)(selectedValue, date, true, dateLib);
                }
                const style = (0, $8c5584b22931018a$export$aee95183ff1527a6)(modifiers, styles, props.modifiersStyles);
                const className = (0, $85f558efa293d47f$export$93628caec3887c55)(modifiers, classNames, props.modifiersClassNames);
                const ariaLabel = !isInteractive && !modifiers.hidden ? labelGridcell(date, modifiers, dateLib.options, dateLib) : undefined;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Day, {
                    key: `${day.isoDate}_${day.displayMonthId}`,
                    day: day,
                    modifiers: modifiers,
                    className: className.join(" "),
                    style: style,
                    role: "gridcell",
                    "aria-selected": modifiers.selected || undefined,
                    "aria-label": ariaLabel,
                    "data-day": day.isoDate,
                    "data-month": day.outside ? day.dateMonthId : undefined,
                    "data-selected": modifiers.selected || undefined,
                    "data-disabled": modifiers.disabled || undefined,
                    "data-hidden": modifiers.hidden || undefined,
                    "data-outside": day.outside || undefined,
                    "data-focused": modifiers.focused || undefined,
                    "data-today": modifiers.today || undefined
                }, !modifiers.hidden && isInteractive ? (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.DayButton, {
                    className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).DayButton],
                    style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).DayButton],
                    type: "button",
                    day: day,
                    modifiers: modifiers,
                    disabled: !modifiers.focused && modifiers.disabled || undefined,
                    "aria-disabled": modifiers.focused && modifiers.disabled || undefined,
                    tabIndex: isFocusTarget(day) ? 0 : -1,
                    "aria-label": labelDayButton(date, modifiers, dateLib.options, dateLib),
                    onClick: handleDayClick(day, modifiers),
                    onBlur: handleDayBlur(day, modifiers),
                    onFocus: handleDayFocus(day, modifiers),
                    onKeyDown: handleDayKeyDown(day, modifiers),
                    onMouseEnter: handleDayMouseEnter(day, modifiers),
                    onMouseLeave: handleDayMouseLeave(day, modifiers)
                }, formatDay(date, dateLib.options, dateLib)) : !modifiers.hidden && formatDay(day.date, dateLib.options, dateLib));
            }));
        }))));
    })), props.footer && (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement(components.Footer, {
        className: classNames[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Footer],
        style: styles?.[(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Footer],
        role: "status",
        "aria-live": "polite"
    }, props.footer)));
}



const $66ac769ec81c47b1$var$defaultClassNames = (0, $bba0d7038cd68da0$export$8f10228aec87fae6)();
/**
 * Appends our own stable class name alongside react-day-picker's default one (which keeps its base
 * stylesheet, imported for structural/spacing rules, working) so our styling hooks in {@link CALENDAR_SELECTORS}
 * don't depend on the library's internal `.rdp-*` naming, which is unlikely but not guaranteed to survive a version bump
 */ const $66ac769ec81c47b1$var$withOwnClass = (uiElement, ownClass)=>`${$66ac769ec81c47b1$var$defaultClassNames[uiElement]} ${ownClass}`;
/**
 * The single source of truth for our own `cal-*` class names, referenced by both {@link CALENDAR_CLASS_NAMES}
 * and {@link CALENDAR_SELECTORS} so the two can never drift apart.
 */ const $66ac769ec81c47b1$var$CLASSES = {
    ROOT: 'cal-root',
    DAY: 'cal-day',
    DAY_BUTTON: 'cal-day-button',
    MONTH_CAPTION: 'cal-month-caption',
    CAPTION_LABEL: 'cal-caption-label',
    WEEKDAY: 'cal-weekday',
    CHEVRON: 'cal-chevron',
    TODAY: 'cal-today',
    OUTSIDE: 'cal-outside',
    RANGE_START: 'cal-range-start',
    RANGE_MIDDLE: 'cal-range-middle',
    RANGE_END: 'cal-range-end',
    SELECTED: 'cal-selected',
    /**
     * Our own custom modifier (not one of react-day-picker's), applied to the sole day of an
     * open-started/open-ended range - i.e. a `selected` day that isn't also `range_start`/`range_end`,
     * which the library only sets when *both* `from` and `to` are defined. Without this, such a day gets
     * no highlight pill at all (see {@link CALENDAR_SELECTORS.OPEN_BOUND} usage in `Calendar.tsx`).
     */ OPEN_BOUND: 'cal-open-bound'
};
const $66ac769ec81c47b1$export$83e595c0c32140ca = {
    [(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Root]: $66ac769ec81c47b1$var$withOwnClass((0, $d4e669abc392b351$export$4b08aed5f1ec6952).Root, $66ac769ec81c47b1$var$CLASSES.ROOT),
    [(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Day]: $66ac769ec81c47b1$var$withOwnClass((0, $d4e669abc392b351$export$4b08aed5f1ec6952).Day, $66ac769ec81c47b1$var$CLASSES.DAY),
    [(0, $d4e669abc392b351$export$4b08aed5f1ec6952).DayButton]: $66ac769ec81c47b1$var$withOwnClass((0, $d4e669abc392b351$export$4b08aed5f1ec6952).DayButton, $66ac769ec81c47b1$var$CLASSES.DAY_BUTTON),
    [(0, $d4e669abc392b351$export$4b08aed5f1ec6952).MonthCaption]: $66ac769ec81c47b1$var$withOwnClass((0, $d4e669abc392b351$export$4b08aed5f1ec6952).MonthCaption, $66ac769ec81c47b1$var$CLASSES.MONTH_CAPTION),
    [(0, $d4e669abc392b351$export$4b08aed5f1ec6952).CaptionLabel]: $66ac769ec81c47b1$var$withOwnClass((0, $d4e669abc392b351$export$4b08aed5f1ec6952).CaptionLabel, $66ac769ec81c47b1$var$CLASSES.CAPTION_LABEL),
    [(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Weekday]: $66ac769ec81c47b1$var$withOwnClass((0, $d4e669abc392b351$export$4b08aed5f1ec6952).Weekday, $66ac769ec81c47b1$var$CLASSES.WEEKDAY),
    [(0, $d4e669abc392b351$export$4b08aed5f1ec6952).Chevron]: $66ac769ec81c47b1$var$withOwnClass((0, $d4e669abc392b351$export$4b08aed5f1ec6952).Chevron, $66ac769ec81c47b1$var$CLASSES.CHEVRON),
    [(0, $d4e669abc392b351$export$c2fd8ae3501086f5).today]: $66ac769ec81c47b1$var$withOwnClass((0, $d4e669abc392b351$export$c2fd8ae3501086f5).today, $66ac769ec81c47b1$var$CLASSES.TODAY),
    [(0, $d4e669abc392b351$export$c2fd8ae3501086f5).outside]: $66ac769ec81c47b1$var$withOwnClass((0, $d4e669abc392b351$export$c2fd8ae3501086f5).outside, $66ac769ec81c47b1$var$CLASSES.OUTSIDE),
    [(0, $d4e669abc392b351$export$2255d92a85eab347).range_start]: $66ac769ec81c47b1$var$withOwnClass((0, $d4e669abc392b351$export$2255d92a85eab347).range_start, $66ac769ec81c47b1$var$CLASSES.RANGE_START),
    [(0, $d4e669abc392b351$export$2255d92a85eab347).range_middle]: $66ac769ec81c47b1$var$withOwnClass((0, $d4e669abc392b351$export$2255d92a85eab347).range_middle, $66ac769ec81c47b1$var$CLASSES.RANGE_MIDDLE),
    [(0, $d4e669abc392b351$export$2255d92a85eab347).range_end]: $66ac769ec81c47b1$var$withOwnClass((0, $d4e669abc392b351$export$2255d92a85eab347).range_end, $66ac769ec81c47b1$var$CLASSES.RANGE_END),
    [(0, $d4e669abc392b351$export$2255d92a85eab347).selected]: $66ac769ec81c47b1$var$withOwnClass((0, $d4e669abc392b351$export$2255d92a85eab347).selected, $66ac769ec81c47b1$var$CLASSES.SELECTED)
};
const $66ac769ec81c47b1$export$9d27ef53f267040d = $66ac769ec81c47b1$var$CLASSES.OPEN_BOUND;
const $66ac769ec81c47b1$export$1b34b7f49449a702 = {
    ROOT: `.${$66ac769ec81c47b1$var$CLASSES.ROOT}`,
    DAY_BUTTON: `.${$66ac769ec81c47b1$var$CLASSES.DAY_BUTTON}`,
    DAY: `.${$66ac769ec81c47b1$var$CLASSES.DAY}`,
    TODAY: `.${$66ac769ec81c47b1$var$CLASSES.TODAY}:not(.${$66ac769ec81c47b1$var$CLASSES.OUTSIDE})`,
    RANGE_START: `.${$66ac769ec81c47b1$var$CLASSES.RANGE_START}`,
    RANGE_MIDDLE: `.${$66ac769ec81c47b1$var$CLASSES.RANGE_MIDDLE}`,
    RANGE_END: `.${$66ac769ec81c47b1$var$CLASSES.RANGE_END}`,
    MONTH_CAPTION: `.${$66ac769ec81c47b1$var$CLASSES.MONTH_CAPTION}`,
    CAPTION_LABEL: `.${$66ac769ec81c47b1$var$CLASSES.CAPTION_LABEL}`,
    WEEKDAY: `.${$66ac769ec81c47b1$var$CLASSES.WEEKDAY}`,
    CHEVRON: `.${$66ac769ec81c47b1$var$CLASSES.CHEVRON}`,
    SELECTED: `.${$66ac769ec81c47b1$var$CLASSES.SELECTED}`,
    OPEN_BOUND: `.${$66ac769ec81c47b1$var$CLASSES.OPEN_BOUND}`
};
const $66ac769ec81c47b1$export$15c628c679857068 = {
    ACCENT_BACKGROUND_COLOR: '--rdp-accent-background-color',
    DAY_WIDTH: '--rdp-day-width',
    DAY_HEIGHT: '--rdp-day-height',
    DAY_BUTTON_WIDTH: '--rdp-day_button-width',
    DAY_BUTTON_HEIGHT: '--rdp-day_button-height',
    NAV_HEIGHT: '--rdp-nav-height',
    NAV_BUTTON_WIDTH: '--rdp-nav_button-width',
    NAV_BUTTON_HEIGHT: '--rdp-nav_button-height',
    ACCENT_COLOR: '--rdp-accent-color',
    RANGE_START_DATE_BACKGROUND_COLOR: '--rdp-range_start-date-background-color',
    RANGE_END_DATE_BACKGROUND_COLOR: '--rdp-range_end-date-background-color',
    RANGE_MIDDLE_BACKGROUND_COLOR: '--rdp-range_middle-background-color',
    SELECTED_BORDER: '--rdp-selected-border',
    TODAY_COLOR: '--rdp-today-color',
    WEEKDAY_PADDING: '--rdp-weekday-padding',
    WEEKDAY_OPACITY: '--rdp-weekday-opacity'
};


const $0f1298553ba7903b$var$calendarStyle = (theme)=>({
        position: 'relative',
        [`& ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).ROOT}`]: {
            padding: 3,
            [(0, $66ac769ec81c47b1$export$15c628c679857068).ACCENT_BACKGROUND_COLOR]: theme.palette.primary.light,
            [(0, $66ac769ec81c47b1$export$15c628c679857068).DAY_WIDTH]: '32px',
            [(0, $66ac769ec81c47b1$export$15c628c679857068).DAY_HEIGHT]: '32px',
            [(0, $66ac769ec81c47b1$export$15c628c679857068).DAY_BUTTON_WIDTH]: '32px',
            [(0, $66ac769ec81c47b1$export$15c628c679857068).DAY_BUTTON_HEIGHT]: '32px',
            [(0, $66ac769ec81c47b1$export$15c628c679857068).NAV_HEIGHT]: '28px',
            [(0, $66ac769ec81c47b1$export$15c628c679857068).NAV_BUTTON_WIDTH]: '28px',
            [(0, $66ac769ec81c47b1$export$15c628c679857068).NAV_BUTTON_HEIGHT]: '28px',
            [(0, $66ac769ec81c47b1$export$15c628c679857068).ACCENT_COLOR]: theme.palette.grey[700],
            [(0, $66ac769ec81c47b1$export$15c628c679857068).RANGE_START_DATE_BACKGROUND_COLOR]: theme.palette.primary[600],
            [(0, $66ac769ec81c47b1$export$15c628c679857068).RANGE_END_DATE_BACKGROUND_COLOR]: theme.palette.primary[600],
            [(0, $66ac769ec81c47b1$export$15c628c679857068).RANGE_MIDDLE_BACKGROUND_COLOR]: theme.palette.primary[50],
            [(0, $66ac769ec81c47b1$export$15c628c679857068).SELECTED_BORDER]: 'unset',
            [(0, $66ac769ec81c47b1$export$15c628c679857068).TODAY_COLOR]: theme.palette.primary[600],
            [(0, $66ac769ec81c47b1$export$15c628c679857068).WEEKDAY_PADDING]: 0,
            [(0, $66ac769ec81c47b1$export$15c628c679857068).WEEKDAY_OPACITY]: 'unset'
        },
        [`& ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).DAY}`]: {
            position: 'relative',
            padding: 1
        },
        [`& ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).DAY_BUTTON}`]: {
            position: 'relative',
            zIndex: 1,
            borderRadius: '50%'
        },
        [`& ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).SELECTED}`]: {
            fontWeight: 'unset',
            fontSize: theme.typography.body1.fontSize
        },
        [`& ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).MONTH_CAPTION}`]: {
            justifyContent: 'center',
            mb: 5
        },
        [`& ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).CAPTION_LABEL}`]: {
            ...theme.typography.subtitle2,
            fontWeight: 500,
            color: 'grey.900'
        },
        [`& ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).WEEKDAY}`]: {
            ...theme.typography.caption,
            fontWeight: 600,
            color: 'grey.700',
            height: 32
        },
        [`& ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).CHEVRON}`]: {
            width: 16,
            height: 16
        },
        [`& ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).TODAY} ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).DAY_BUTTON}`]: {
            border: '1.5px solid',
            borderColor: 'primary.600'
        },
        // An open-started/open-ended range has only one bound, so its day is never both range_start and range_end -
        // give its day button the same bright fill a range boundary's day button gets, instead of no highlight at all
        [`& ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).OPEN_BOUND} ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).DAY_BUTTON}`]: {
            backgroundColor: 'primary.600',
            color: 'common.white'
        },
        [`& ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).RANGE_START}, & ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).RANGE_MIDDLE}, & ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).RANGE_END}`]: {
            background: 'none'
        },
        // inset: 0 (rather than insetting the top/bottom) keeps this pseudo-element exactly as tall as the day cell/button,
        // so it stays square and its rounded ends below form a true circle matching the day button's - insetting the
        // vertical edges would make it wider than tall, turning those rounded ends into ellipses that peek out from behind
        // the circular day button at the range's start/end
        [`& ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).RANGE_START}::before, & ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).RANGE_MIDDLE}::before, & ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).RANGE_END}::before`]: {
            content: '""',
            position: 'absolute',
            inset: 0,
            background: theme.palette.primary[100]
        },
        [`& ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).RANGE_START}${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).RANGE_END}::before`]: {
            display: 'none'
        },
        [`& ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).RANGE_START}::before, & ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).DAY}:first-of-type::before`]: {
            borderTopLeftRadius: '50%',
            borderBottomLeftRadius: '50%'
        },
        [`& ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).RANGE_END}::before, & ${(0, $66ac769ec81c47b1$export$1b34b7f49449a702).DAY}:last-of-type::before`]: {
            borderTopRightRadius: '50%',
            borderBottomRightRadius: '50%'
        }
    });
const $0f1298553ba7903b$var$dividerStyle = {
    position: 'absolute',
    left: '50%',
    top: '20%',
    bottom: 0,
    width: '1px',
    bgcolor: 'divider',
    transform: 'translateX(-50%)'
};
// The sole day of an open-started/open-ended range (only one of `from`/`to` defined) - react-day-picker only
// marks a day as range_start/range_end when *both* bounds are defined, so that day would otherwise get no
// highlight at all; see the `cal-open-bound` modifier this feeds into `Calendar`'s CSS.
const $0f1298553ba7903b$var$getOpenBoundDay = (selectedRange)=>{
    if (!selectedRange) return undefined;
    const { from: from, to: to } = selectedRange;
    return Boolean(from) !== Boolean(to) ? from ?? to : undefined;
};
const $0f1298553ba7903b$export$e1aef45b828286de = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).memo(({ selectedRange: selectedRange, onRangeSelect: onRangeSelect, displayMonth: displayMonth, onMonthChange: onMonthChange, disableAfter: disableAfter })=>{
    const openBoundDay = $0f1298553ba7903b$var$getOpenBoundDay(selectedRange);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $0f1298553ba7903b$var$calendarStyle,
        "data-testid": "calendar-picker",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $eb41165c6fd11357$export$97e6db89a86ff7ab), {
                mode: "range",
                classNames: (0, $66ac769ec81c47b1$export$83e595c0c32140ca),
                modifiers: {
                    openBound: openBoundDay ?? []
                },
                modifiersClassNames: {
                    openBound: (0, $66ac769ec81c47b1$export$9d27ef53f267040d)
                },
                selected: selectedRange,
                onSelect: onRangeSelect,
                month: displayMonth,
                onMonthChange: onMonthChange,
                numberOfMonths: 2,
                weekStartsOn: 1,
                fixedWeeks: true,
                navLayout: "around",
                disabled: disableAfter ? {
                    after: disableAfter
                } : undefined,
                resetOnSelect: true
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $0f1298553ba7903b$var$dividerStyle
            })
        ]
    });
});



parcelRequire("h4Bez");







var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");








var $h4Bez = parcelRequire("h4Bez");













function $13ae6891fee2d602$export$cdb270390122322b(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiInput', slot);
}
const $13ae6891fee2d602$var$inputClasses = {
    ...(0, $0886a41ab9c710ef$export$2e2bcd8739ae039),
    ...(0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var $13ae6891fee2d602$export$2e2bcd8739ae039 = $13ae6891fee2d602$var$inputClasses;




'use client';
const $c290ac25ab5dfe94$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $13ae6891fee2d602$export$cdb270390122322b), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $c290ac25ab5dfe94$var$InputRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $5ac8c4302ca79792$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $19087586f17e5d57$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $5ac8c4302ca79792$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline);
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $13ae6891fee2d602$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $13ae6891fee2d602$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $13ae6891fee2d602$export$2e2bcd8739ae039).disabled}, .${(0, $13ae6891fee2d602$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $13ae6891fee2d602$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $c290ac25ab5dfe94$var$InputInput = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $5ac8c4302ca79792$export$ee10465db6ff6017), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $5ac8c4302ca79792$export$cf507b112810e72d)
})({});
const $c290ac25ab5dfe94$var$Input = /*#__PURE__*/ $h4Bez.forwardRef(function Input(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $c290ac25ab5dfe94$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $a539fc8639d0a7b4$export$2e2bcd8739ae039)(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $c290ac25ab5dfe94$var$InputRoot;
    const InputSlot = slots.input ?? components.Input ?? $c290ac25ab5dfe94$var$InputInput;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5ac8c4302ca79792$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$c290ac25ab5dfe94$var$Input.muiName = 'Input';
var $c290ac25ab5dfe94$export$2e2bcd8739ae039 = $c290ac25ab5dfe94$var$Input;



var $h4Bez = parcelRequire("h4Bez");













function $821c50d574a0274c$export$3331e419f1a48437(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiFilledInput', slot);
}
const $821c50d574a0274c$var$filledInputClasses = {
    ...(0, $0886a41ab9c710ef$export$2e2bcd8739ae039),
    ...(0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var $821c50d574a0274c$export$2e2bcd8739ae039 = $821c50d574a0274c$var$filledInputClasses;





'use client';
const $786cf08051149113$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $821c50d574a0274c$export$3331e419f1a48437), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $786cf08051149113$var$FilledInputRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $5ac8c4302ca79792$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $19087586f17e5d57$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $5ac8c4302ca79792$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $821c50d574a0274c$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $821c50d574a0274c$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $821c50d574a0274c$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $821c50d574a0274c$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline) : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $821c50d574a0274c$export$2e2bcd8739ae039).disabled}, .${(0, $821c50d574a0274c$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $821c50d574a0274c$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $786cf08051149113$var$FilledInputInput = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $5ac8c4302ca79792$export$ee10465db6ff6017), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $5ac8c4302ca79792$export$cf507b112810e72d)
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $786cf08051149113$var$FilledInput = /*#__PURE__*/ $h4Bez.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $786cf08051149113$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $a539fc8639d0a7b4$export$2e2bcd8739ae039)(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $786cf08051149113$var$FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $786cf08051149113$var$FilledInputInput;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5ac8c4302ca79792$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$786cf08051149113$var$FilledInput.muiName = 'Input';
var $786cf08051149113$export$2e2bcd8739ae039 = $786cf08051149113$var$FilledInput;





var $h4Bez = parcelRequire("h4Bez");











function $c87f9ff1ed727ebc$export$149c8b8bab2289d1(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiFormControl', slot);
}
const $c87f9ff1ed727ebc$var$formControlClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $c87f9ff1ed727ebc$export$2e2bcd8739ae039 = $c87f9ff1ed727ebc$var$formControlClasses;



'use client';
const $bd2f0ef06c4947fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $c87f9ff1ed727ebc$export$149c8b8bab2289d1), classes);
};
const $bd2f0ef06c4947fc$var$FormControlRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $bd2f0ef06c4947fc$var$FormControl = /*#__PURE__*/ $h4Bez.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $bd2f0ef06c4947fc$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $h4Bez.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $h4Bez.Children.forEach(children, (child)=>{
            if (!(0, $18df94e751f33253$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $18df94e751f33253$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $f1145a6934ab22e0$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $h4Bez.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $h4Bez.Children.forEach(children, (child)=>{
            if (!(0, $18df94e751f33253$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $f1145a6934ab22e0$export$d652b828d7fdeff8)(child.props, true) || (0, $f1145a6934ab22e0$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $h4Bez.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $h4Bez.useRef(false);
    const onFilled = $h4Bez.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $h4Bez.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = $h4Bez.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty: onEmpty,
            onFilled: onFilled,
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $afe0146e047a78c2$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($bd2f0ef06c4947fc$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var $bd2f0ef06c4947fc$export$2e2bcd8739ae039 = $bd2f0ef06c4947fc$var$FormControl;



var $h4Bez = parcelRequire("h4Bez");











'use client';
var $c0f4202dc2b8182f$var$_span;
const $c0f4202dc2b8182f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $6618c564725dc18f$export$a394fa61b1d583a9), classes);
};
const $c0f4202dc2b8182f$var$FormHelperTextRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $6618c564725dc18f$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $6618c564725dc18f$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $c0f4202dc2b8182f$var$FormHelperText = /*#__PURE__*/ $h4Bez.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p', disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $364d4e99dd433e44$export$2e2bcd8739ae039)();
    const fcs = (0, $51f4e256a7eeb494$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $c0f4202dc2b8182f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($c0f4202dc2b8182f$var$FormHelperTextRoot, {
        as: component,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? $c0f4202dc2b8182f$var$_span || ($c0f4202dc2b8182f$var$_span = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var $c0f4202dc2b8182f$export$2e2bcd8739ae039 = $c0f4202dc2b8182f$var$FormHelperText;



var $h4Bez = parcelRequire("h4Bez");







var $h4Bez = parcelRequire("h4Bez");










var $h4Bez = parcelRequire("h4Bez");







function $2c8578bee5e29793$export$1ee13051fd9e2ab5(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiNativeSelect', slot);
}
const $2c8578bee5e29793$var$nativeSelectClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $2c8578bee5e29793$export$2e2bcd8739ae039 = $2c8578bee5e29793$var$nativeSelectClasses;





'use client';
const $505d4d675183cef4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $2c8578bee5e29793$export$1ee13051fd9e2ab5), classes);
};
const $505d4d675183cef4$export$50b3545a8ccd87af = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('select', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${(0, $2c8578bee5e29793$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $505d4d675183cef4$var$NativeSelectSelect = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)($505d4d675183cef4$export$50b3545a8ccd87af, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $19087586f17e5d57$export$2e2bcd8739ae039),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $2c8578bee5e29793$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $505d4d675183cef4$export$7dd4d92f143902e3 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('svg', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $2c8578bee5e29793$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $505d4d675183cef4$var$NativeSelectIcon = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)($505d4d675183cef4$export$7dd4d92f143902e3, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $505d4d675183cef4$var$NativeSelectInput = /*#__PURE__*/ $h4Bez.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $505d4d675183cef4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($h4Bez.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($505d4d675183cef4$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($505d4d675183cef4$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $505d4d675183cef4$export$2e2bcd8739ae039 = $505d4d675183cef4$var$NativeSelectInput;









function $3e49bb929f62cf81$export$2c0c1ee5a3392e(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiSelect', slot);
}
const $3e49bb929f62cf81$var$selectClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $3e49bb929f62cf81$export$2e2bcd8739ae039 = $3e49bb929f62cf81$var$selectClasses;



'use client';
var $0776e0b567e27ef7$var$_span;
const $0776e0b567e27ef7$var$SelectSelect = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $505d4d675183cef4$export$50b3545a8ccd87af), {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $3e49bb929f62cf81$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $3e49bb929f62cf81$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $3e49bb929f62cf81$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $3e49bb929f62cf81$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${(0, $3e49bb929f62cf81$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $0776e0b567e27ef7$var$SelectIcon = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $505d4d675183cef4$export$7dd4d92f143902e3), {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $0776e0b567e27ef7$var$SelectNativeInput = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('input', {
    shouldForwardProp: (prop)=>(0, $43f40a41b3374964$export$2e2bcd8739ae039)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput'
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $0776e0b567e27ef7$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $0776e0b567e27ef7$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $0776e0b567e27ef7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $3e49bb929f62cf81$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $0776e0b567e27ef7$var$SelectInput = /*#__PURE__*/ $h4Bez.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onKeyDown: // eslint-disable-next-line react/prop-types
    onKeyDown, onMouseDown: // eslint-disable-next-line react/prop-types
    onMouseDown, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, $7e1e510fcc288095$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $7e1e510fcc288095$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $h4Bez.useRef(null);
    const displayRef = $h4Bez.useRef(null);
    const [displayNode, setDisplayNode] = $h4Bez.useState(null);
    const { current: isOpenControlled } = $h4Bez.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $h4Bez.useState();
    const handleRef = (0, $6fa00ac7fde563d8$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $h4Bez.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    $h4Bez.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    const open = displayNode !== null && openState;
    $h4Bez.useEffect(()=>{
        if (!open || !anchorElement || autoWidth) return undefined;
        if (typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(()=>{
            setMenuMinWidthState(anchorElement.clientWidth);
        });
        observer.observe(anchorElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        open,
        anchorElement,
        autoWidth
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $h4Bez.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $h4Bez.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $h4Bez.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $4fa343ae2434ad28$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (openParam, event)=>{
        if (openParam) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(openParam);
        }
    };
    const handleMouseDown = (event)=>{
        onMouseDown?.(event);
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $h4Bez.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
            onKeyDown?.(event);
        }
    };
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $f1145a6934ab22e0$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $h4Bez.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $7052f9417b2e0e56$export$2e2bcd8739ae039)(2));
            selected = value.some((v)=>$0776e0b567e27ef7$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $0776e0b567e27ef7$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $h4Bez.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $0776e0b567e27ef7$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...typeof MenuProps.slotProps?.paper === 'function' ? MenuProps.slotProps.paper(ownerState) : MenuProps.slotProps?.paper
    };
    const listProps = {
        ...MenuProps.MenuListProps,
        ...typeof MenuProps.slotProps?.list === 'function' ? MenuProps.slotProps.list(ownerState) : MenuProps.slotProps?.list
    };
    const listboxId = (0, $8bcd24cec5c7b3d6$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($h4Bez.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($0776e0b567e27ef7$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $0776e0b567e27ef7$var$isEmpty(display) ? $0776e0b567e27ef7$var$_span || ($0776e0b567e27ef7$var$_span = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($0776e0b567e27ef7$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($0776e0b567e27ef7$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1949838101ccf179$export$2e2bcd8739ae039), {
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                ...MenuProps,
                slotProps: {
                    ...MenuProps.slotProps,
                    list: {
                        'aria-labelledby': labelId,
                        role: 'listbox',
                        'aria-multiselectable': multiple ? 'true' : undefined,
                        disableListWrap: true,
                        id: listboxId,
                        ...listProps
                    },
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var $0776e0b567e27ef7$export$2e2bcd8739ae039 = $0776e0b567e27ef7$var$SelectInput;






'use client';
var $b80b59f454a18be6$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');












'use client';
const $bb6ec403134e8f63$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $3e49bb929f62cf81$export$2c0c1ee5a3392e), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $bb6ec403134e8f63$var$styledRootConfig = {
    name: 'MuiSelect',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $19087586f17e5d57$export$2e2bcd8739ae039)(prop) && prop !== 'variant'
};
const $bb6ec403134e8f63$var$StyledInput = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $c290ac25ab5dfe94$export$2e2bcd8739ae039), $bb6ec403134e8f63$var$styledRootConfig)('');
const $bb6ec403134e8f63$var$StyledOutlinedInput = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $1be879c5f72a2d8d$export$2e2bcd8739ae039), $bb6ec403134e8f63$var$styledRootConfig)('');
const $bb6ec403134e8f63$var$StyledFilledInput = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $786cf08051149113$export$2e2bcd8739ae039), $bb6ec403134e8f63$var$styledRootConfig)('');
const $bb6ec403134e8f63$var$Select = /*#__PURE__*/ $h4Bez.forwardRef(function Select(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $b80b59f454a18be6$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? (0, $505d4d675183cef4$export$2e2bcd8739ae039) : (0, $0776e0b567e27ef7$export$2e2bcd8739ae039);
    const muiFormControl = (0, $364d4e99dd433e44$export$2e2bcd8739ae039)();
    const fcs = (0, $51f4e256a7eeb494$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $bb6ec403134e8f63$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($bb6ec403134e8f63$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($bb6ec403134e8f63$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($bb6ec403134e8f63$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $6fa00ac7fde563d8$export$2e2bcd8739ae039)(ref, (0, $ba4f9121b652949b$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($h4Bez.Fragment, {
        children: /*#__PURE__*/ $h4Bez.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, $a539fc8639d0a7b4$export$2e2bcd8739ae039)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$bb6ec403134e8f63$var$Select.muiName = 'Select';
var $bb6ec403134e8f63$export$2e2bcd8739ae039 = $bb6ec403134e8f63$var$Select;




function $ed04236eeb040ea1$export$c1bdcbaf0596aeda(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiTextField', slot);
}
const $ed04236eeb040ea1$var$textFieldClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiTextField', [
    'root'
]);
var $ed04236eeb040ea1$export$2e2bcd8739ae039 = $ed04236eeb040ea1$var$textFieldClasses;




'use client';
const $556393662cf0f57c$var$variantComponent = {
    standard: (0, $c290ac25ab5dfe94$export$2e2bcd8739ae039),
    filled: (0, $786cf08051149113$export$2e2bcd8739ae039),
    outlined: (0, $1be879c5f72a2d8d$export$2e2bcd8739ae039)
};
const $556393662cf0f57c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $ed04236eeb040ea1$export$c1bdcbaf0596aeda), classes);
};
const $556393662cf0f57c$var$TextFieldRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $bd2f0ef06c4947fc$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root'
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $556393662cf0f57c$var$TextField = /*#__PURE__*/ $h4Bez.forwardRef(function TextField(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $556393662cf0f57c$var$useUtilityClasses(ownerState);
    const id = (0, $8bcd24cec5c7b3d6$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $556393662cf0f57c$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('root', {
        elementType: $556393662cf0f57c$var$TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        additionalProps: {
            disabled: disabled,
            error: error,
            fullWidth: fullWidth,
            required: required,
            color: color,
            variant: variant
        }
    });
    const [InputSlot, inputProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('inputLabel', {
        elementType: (0, $401b148a65fd432a$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('formHelperText', {
        elementType: (0, $c0f4202dc2b8182f$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('select', {
        elementType: (0, $bb6ec403134e8f63$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var $556393662cf0f57c$export$2e2bcd8739ae039 = $556393662cf0f57c$var$TextField;






const $d887fad28e7ec96c$var$labelRowStyle = {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1
};
const $d887fad28e7ec96c$var$textStyle = {
    display: 'inline-flex',
    alignItems: 'center'
};
const $d887fad28e7ec96c$var$asteriskStyle = {
    color: 'error.600',
    ml: 0.5
};
const $d887fad28e7ec96c$var$helperTextIconStyle = {
    mr: 1
};
const $d887fad28e7ec96c$var$helpIconStyle = {
    ml: 1,
    verticalAlign: 'middle',
    color: 'grey.500'
};
const $d887fad28e7ec96c$export$6e6cc632aa66aa48 = {
    fontSize: '1rem'
};
const $d887fad28e7ec96c$var$StyledIcon = ({ icon: icon, extraSx: extraSx })=>/*#__PURE__*/ (0, $h4Bez.cloneElement)(icon, {
        sx: {
            ...$d887fad28e7ec96c$export$6e6cc632aa66aa48,
            ...extraSx,
            ...icon.props.sx
        }
    });
const $d887fad28e7ec96c$var$InputLabel = ({ label: label, required: required, optional: optional, helpTooltip: helpTooltip })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        component: "span",
        sx: $d887fad28e7ec96c$var$labelRowStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                component: "span",
                sx: $d887fad28e7ec96c$var$textStyle,
                children: [
                    label,
                    required && /**
                 * MuiFormLabel's native asterisk lands after the help icon, not the text,
                 * so we render our own and disable the native one via slotProps.inputLabel.required
                 */ /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        component: "span",
                        "aria-hidden": true,
                        sx: $d887fad28e7ec96c$var$asteriskStyle,
                        children: "*"
                    }),
                    helpTooltip && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $69cdbe69cde47e02$export$2e2bcd8739ae039), {
                        title: helpTooltip,
                        placement: "top",
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                            component: "span",
                            sx: $d887fad28e7ec96c$var$textStyle,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $cad423c29bb1ebe8$export$fe32c9a7508b4c4a), {
                                sx: [
                                    $d887fad28e7ec96c$export$6e6cc632aa66aa48,
                                    $d887fad28e7ec96c$var$helpIconStyle
                                ]
                            })
                        })
                    })
                ]
            }),
            optional && !required && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$32fbfacc5d962e0c), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).OPTIONAL
            })
        ]
    });
const $d887fad28e7ec96c$export$2c73285ae9390cec = ({ label: label, startIcon: startIcon, endIcon: endIcon, helperText: helperText, helperTextIcon: helperTextIcon, slotProps: slotProps, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $556393662cf0f57c$export$2e2bcd8739ae039), {
        variant: "outlined",
        label: label && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($d887fad28e7ec96c$var$InputLabel, {
            label: label,
            ...props
        }),
        helperText: helperText && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
            component: "span",
            sx: $d887fad28e7ec96c$var$textStyle,
            children: [
                helperTextIcon && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($d887fad28e7ec96c$var$StyledIcon, {
                    icon: helperTextIcon,
                    extraSx: $d887fad28e7ec96c$var$helperTextIconStyle
                }),
                helperText
            ]
        }),
        ...(0, $2ae70427bab197d4$export$12b617052eb9d30e)(props, 'helpTooltip', 'optional'),
        slotProps: {
            input: {
                ...slotProps?.input,
                /**
                 * We respect passed start and end adornments,
                 * because callers (such as Autocomplete's `renderInput`),
                 * may forward their own adornments through `slotProps.input`.
                 */ startAdornment: slotProps?.input?.startAdornment ?? (startIcon && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2aefb57dc041c2ec$export$2e2bcd8739ae039), {
                    position: "start",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($d887fad28e7ec96c$var$StyledIcon, {
                        icon: startIcon
                    })
                })),
                endAdornment: slotProps?.input?.endAdornment ?? (endIcon && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2aefb57dc041c2ec$export$2e2bcd8739ae039), {
                    position: "end",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($d887fad28e7ec96c$var$StyledIcon, {
                        icon: endIcon
                    })
                }))
            },
            inputLabel: {
                ...slotProps?.inputLabel,
                /**
                 * Disables MuiFormLabel's native "required" asterisk:
                 * InputLabel above renders its own, correctly positioned.
                 */ required: false
            },
            htmlInput: slotProps?.htmlInput
        }
    });



parcelRequire("h4Bez");


const $6f84d94c688eb85b$export$57753b0d185cad1a = ({ label: label, placeholder: placeholder = label, onChange: onChange, ...props })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const translatedLabel = label && translator.formatTranslation(label);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d887fad28e7ec96c$export$2c73285ae9390cec), {
        label: translatedLabel,
        placeholder: placeholder && translator.formatTranslation(placeholder),
        onChange: ({ target: target })=>onChange(target.value),
        ...props
    });
};




var $h4Bez = parcelRequire("h4Bez");



const $fb8050ff7801b6d6$var$valueMappers = {
    /**
     * Validate if a given input is a single digit (0-9), If it's single digit, it returns the digit as a string else, it returns null
     */ tel: (rawValue)=>/^\d{1}$/.test(rawValue) ? rawValue : null
};
const $fb8050ff7801b6d6$var$fixedLengthTextFieldWrapperStyle = {
    display: 'flex',
    justifyContent: 'space-between'
};
const $fb8050ff7801b6d6$var$baseNumberedTextFieldProps = {
    required: true,
    fullWidth: false,
    sx: {
        mr: 1,
        '&:last-of-type': {
            mr: 0
        }
    },
    slotProps: {
        input: {
            sx: {
                aspectRatio: '1',
                [`& input.${(0, $0886a41ab9c710ef$export$2e2bcd8739ae039).input}`]: {
                    textAlign: 'center'
                },
                [[
                    `& input.${(0, $0886a41ab9c710ef$export$2e2bcd8739ae039).input}::-webkit-outer-spin-button', '& input.${(0, $0886a41ab9c710ef$export$2e2bcd8739ae039).input}::-webkit-inner-spin-button`
                ].join(', ')]: {
                    WebkitAppearance: 'none'
                }
            }
        }
    }
};
const $fb8050ff7801b6d6$export$389d4885dfc5ad06 = ({ autoFocus: autoFocus, type: type, value: value, onChange: onChange, slotProps: slotProps, disabled: disabled, ...props })=>{
    const extractValue = $fb8050ff7801b6d6$var$valueMappers[type];
    const parentRef = /*#__PURE__*/ (0, $h4Bez.createRef)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        ...props,
        ref: parentRef,
        sx: $fb8050ff7801b6d6$var$fixedLengthTextFieldWrapperStyle,
        children: value.map((part, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d887fad28e7ec96c$export$2c73285ae9390cec), {
                "data-testid": (0, $3dd52092ec4fc8cb$export$eea0c9f46a8cc3f9)(props, `-${k + 1}`),
                ...$fb8050ff7801b6d6$var$baseNumberedTextFieldProps,
                slotProps: {
                    ...slotProps,
                    input: {
                        ...$fb8050ff7801b6d6$var$baseNumberedTextFieldProps.slotProps.input,
                        ...slotProps?.input,
                        sx: {
                            ...$fb8050ff7801b6d6$var$baseNumberedTextFieldProps.slotProps.input.sx,
                            ...slotProps?.input?.sx
                        }
                    }
                },
                sx: {
                    ...$fb8050ff7801b6d6$var$baseNumberedTextFieldProps.sx,
                    width: `calc(100% / ${value.length})`
                },
                type: type,
                autoFocus: autoFocus && k === 0,
                value: part,
                onKeyDown: (e)=>{
                    let newPart = part;
                    let clearPrevious = false;
                    /** Highest the value, more to the right/down the node tree */ let move = 0;
                    const validatedValue = extractValue(e.key);
                    if (validatedValue !== null) {
                        newPart = validatedValue;
                        /** Done on this block, move to the next */ move = 1;
                    }
                    if ((0, $1fdb53e1bec07519$export$13dc79c32630341b)(e, 'Backspace')) {
                        /** User wants to delete the value */ newPart = '';
                        if (!part) {
                            /** Was already empty, move to the previous */ move = -1;
                            clearPrevious = k > 0;
                        }
                    }
                    if ((0, $1fdb53e1bec07519$export$13dc79c32630341b)(e, 'ArrowLeft')) /** Just move to the previous one */ move = -1;
                    if ((0, $1fdb53e1bec07519$export$13dc79c32630341b)(e, 'ArrowRight')) /** Just move to the next one */ move = 1;
                    if ((0, $1fdb53e1bec07519$export$13dc79c32630341b)(e, 'Enter') && k + 1 !== value.length) /** User wants to move to next value unless they are on the last input */ move = 1;
                    const hasChanged = newPart !== part;
                    if (hasChanged || clearPrevious) {
                        const update = [
                            ...value
                        ];
                        if (hasChanged) update[k] = newPart;
                        if (clearPrevious) update[k - 1] = '';
                        onChange(update);
                    }
                    const inputToMoveTo = move !== 0 && parentRef.current && Array.from(parentRef.current.querySelectorAll(`.${(0, $ed04236eeb040ea1$export$2e2bcd8739ae039).root} .${(0, $0886a41ab9c710ef$export$2e2bcd8739ae039).root} input.${(0, $0886a41ab9c710ef$export$2e2bcd8739ae039).input}`)).find((_, k, all)=>all[k - move] === e.target);
                    if (inputToMoveTo) inputToMoveTo.focus();
                },
                onPaste: (e)=>{
                    const copy = [
                        ...value
                    ];
                    const parsedValues = e.clipboardData.getData('Text').split('');
                    parsedValues.slice(0, value.length - k).forEach((rawValue, i)=>{
                        const validatedValue = extractValue(rawValue);
                        if (validatedValue !== null) copy[k + i] = validatedValue;
                    });
                    onChange(copy);
                },
                disabled: disabled
            }, k))
    });
};




var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");






var $h4Bez = parcelRequire("h4Bez");





var $h4Bez = parcelRequire("h4Bez");
'use client';
function $87b387df84ad2f24$var$usePreviousProps(value) {
    const ref = $h4Bez.useRef({});
    $h4Bez.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
}
var $87b387df84ad2f24$export$2e2bcd8739ae039 = $87b387df84ad2f24$var$usePreviousProps;


'use client';
function $987ea52e7abf9b98$var$areArraysSame({ array1: array1, array2: array2, parser: parser = (value)=>value }) {
    return array1 && array2 && array1.length === array2.length && array1.every((prevOption, index)=>parser(prevOption) === parser(array2[index]));
}
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
function $987ea52e7abf9b98$var$stripDiacritics(string) {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function $987ea52e7abf9b98$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $987ea52e7abf9b98$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $987ea52e7abf9b98$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.startsWith(input) : candidate.includes(input);
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
const $987ea52e7abf9b98$var$defaultFilterOptions = $987ea52e7abf9b98$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $987ea52e7abf9b98$var$pageSize = 5;
const $987ea52e7abf9b98$var$defaultIsActiveElementInListbox = (listboxRef)=>listboxRef.current !== null && listboxRef.current.parentElement?.contains(document.activeElement);
const $987ea52e7abf9b98$var$MULTIPLE_DEFAULT_VALUE = [];
function $987ea52e7abf9b98$var$getInputValue(value, multiple, getOptionLabel, renderValue) {
    if (multiple || value == null || renderValue) return '';
    const optionLabel = getOptionLabel(value);
    return typeof optionLabel === 'string' ? optionLabel : '';
}
function $987ea52e7abf9b98$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $987ea52e7abf9b98$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $987ea52e7abf9b98$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $987ea52e7abf9b98$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>option.label ?? option, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, renderValue: renderValue, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $8bcd24cec5c7b3d6$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $h4Bez.useRef(false);
    const firstFocus = $h4Bez.useRef(true);
    const inputRef = $h4Bez.useRef(null);
    const listboxRef = $h4Bez.useRef(null);
    const [anchorEl, setAnchorEl] = $h4Bez.useState(null);
    const [focusedItem, setFocusedItem] = $h4Bez.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $h4Bez.useRef(defaultHighlighted);
    // Calculate the initial inputValue on mount only.
    // useRef ensures it doesn't update dynamically with defaultValue or value props.
    const initialInputValue = $h4Bez.useRef($987ea52e7abf9b98$var$getInputValue(defaultValue ?? valueProp, multiple, getOptionLabel)).current;
    const [value, setValueState] = (0, $1e812888fb3f7236$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $1e812888fb3f7236$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: initialInputValue,
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $h4Bez.useState(false);
    const resetInputValue = $h4Bez.useCallback((event, newValue, reason)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        const newInputValue = $987ea52e7abf9b98$var$getInputValue(newValue, multiple, getOptionLabel, renderValue);
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, reason);
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value,
        renderValue
    ]);
    const [open, setOpenState] = (0, $1e812888fb3f7236$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $h4Bez.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $87b387df84ad2f24$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $h4Bez.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value, 'reset');
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusItem = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)((itemToFocus)=>{
        if (itemToFocus === -1) inputRef.current.focus();
        else {
            // Using `data-tag-index` for deprecated `renderTags`. Remove when `renderTags` is gone.
            const indexType = renderValue ? 'data-item-index' : 'data-tag-index';
            anchorEl.querySelector(`[${indexType}="${itemToFocus}"]`).focus();
        }
    });
    // Ensure the focusedItem is never inconsistent
    $h4Bez.useEffect(()=>{
        if (multiple && focusedItem > value.length - 1) {
            setFocusedItem(-1);
            focusItem(-1);
        }
    }, [
        value,
        multiple,
        focusedItem,
        focusItem
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange && [
            'mouse',
            'keyboard',
            'touch'
        ].includes(reason)) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = 'next', reason: reason })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const filteredOptionsChanged = !$987ea52e7abf9b98$var$areArraysSame({
        array1: previousProps.filteredOptions,
        array2: filteredOptions,
        parser: getOptionLabel
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && !$987ea52e7abf9b98$var$areArraysSame({
            array1: previousProps.filteredOptions,
            array2: filteredOptions,
            parser: getOptionLabel
        }) && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return filteredOptions.findIndex((option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $h4Bez.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && value.findIndex((val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = filteredOptions.findIndex((optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)((node)=>{
        (0, $9a781affb256ebc4$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $h4Bez.useEffect(()=>{
        if (filteredOptionsChanged || popupOpen) syncHighlightedIndex();
    }, [
        syncHighlightedIndex,
        filteredOptionsChanged,
        popupOpen
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $h4Bez.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = newValue.findIndex((valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue, reason);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validItemIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            // Using `data-tag-index` for deprecated `renderTags`. Remove when `renderTags` is removed.
            const indexType = renderValue ? 'data-item-index' : 'data-tag-index';
            const option = anchorEl.querySelector(`[${indexType}="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusItem = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextItem = focusedItem;
        // When moving focus from the input to tags with ArrowLeft,
        // always jump to the last tag (if any) from the input.
        if (focusedItem === -1 && direction === 'previous') {
            nextItem = value.length - 1;
            // In freeSolo, clear any draft text so it doesn't "come back" later.
            if (freeSolo && inputValue !== '') {
                setInputValueState('');
                if (onInputChange) onInputChange(event, '', 'reset');
            }
        } else {
            nextItem += direction === 'next' ? 1 : -1;
            if (nextItem < 0) nextItem = 0;
            if (nextItem === value.length) nextItem = -1;
        }
        nextItem = validItemIndex(nextItem, direction);
        setFocusedItem(nextItem);
        focusItem(nextItem);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedItem !== -1 && ![
                'ArrowLeft',
                'ArrowRight'
            ].includes(event.key)) {
                setFocusedItem(-1);
                focusItem(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$987ea52e7abf9b98$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $987ea52e7abf9b98$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    {
                        const input = inputRef.current;
                        // Only handle ArrowLeft when the caret is at the start of the input.
                        // Otherwise let the browser move the caret normally.
                        const caretAtStart = input && input.selectionStart === 0 && input.selectionEnd === 0;
                        if (!caretAtStart) // Let the browser handle normal cursor movement
                        return;
                        // Single-value rendering: move focus from input to the single tag.
                        if (!multiple && renderValue && value != null) {
                            // Moving from input to single tag; clear freeSolo draft text,
                            // so it doesn't reappear when we move back.
                            if (freeSolo && inputValue !== '') {
                                setInputValueState('');
                                if (onInputChange) onInputChange(event, '', 'reset');
                            }
                            setFocusedItem(0);
                            focusItem(0);
                        } else // Multi-value: delegate to tag navigation helper.
                        handleFocusItem(event, 'previous');
                        break;
                    }
                case 'ArrowRight':
                    if (!multiple && renderValue) {
                        setFocusedItem(-1);
                        focusItem(-1);
                    } else handleFocusItem(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0 || renderValue)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedItem === -1 ? value.length - 1 : focusedItem;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    if (!multiple && renderValue && !readOnly && inputValue === '') handleValue(event, null, 'removeOption', {
                        option: value
                    });
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedItem !== -1) {
                        const index = focusedItem;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    if (!multiple && renderValue && !readOnly && inputValue === '') // Single-value rendering: Delete on empty input removes
                    // the single rendered option, same "removeOption" reason as multiple.
                    handleValue(event, null, 'removeOption', {
                        option: value
                    });
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        // When focusing the input, ensure any previously focused item (chip)
        // is cleared so the input receives the visible caret and the
        // input-focused styling is applied.
        if (focusedItem !== -1) {
            setFocusedItem(-1);
            // Ensure DOM focus lands on the input
            focusItem(-1);
        }
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value, 'blur');
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') // For normal single-select, clearing the input clears the value.
        // For renderValue (chip-style single), only Backspace/Delete clear the value.
        {
            if (!disableClearable && !multiple && !renderValue) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleItemDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handleSingleItemDelete = (event)=>{
        handleValue(event, null, 'removeOption', {
            option: value
        });
    };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>({
                ...other,
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getItemProps: ({ index: index = 0 } = {})=>({
                ...multiple && {
                    key: index
                },
                ...renderValue ? {
                    'data-item-index': index
                } : {
                    'data-tag-index': index
                },
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: multiple ? handleItemDelete(index) : handleSingleItemDelete
                }
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        // deprecated
        getTagProps: ({ index: index })=>({
                key: index,
                'data-tag-index': index,
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: handleItemDelete(index)
                }
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: getOptionKey?.(option) ?? getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedItem !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedItem: focusedItem,
        // deprecated
        focusedTag: focusedItem,
        groupedOptions: groupedOptions
    };
}
var $987ea52e7abf9b98$export$2e2bcd8739ae039 = $987ea52e7abf9b98$var$useAutocomplete;




var $h4Bez = parcelRequire("h4Bez");









function $3a49b98b2127d159$export$6816d4fc0981ec7(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiListSubheader', slot);
}
const $3a49b98b2127d159$var$listSubheaderClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $3a49b98b2127d159$export$2e2bcd8739ae039 = $3a49b98b2127d159$var$listSubheaderClasses;



'use client';
const $dbf9d389b60a3979$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $3a49b98b2127d159$export$6816d4fc0981ec7), classes);
};
const $dbf9d389b60a3979$var$ListSubheaderRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14),
        variants: [
            {
                props: {
                    color: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.inset,
                style: {
                    paddingLeft: 72
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableSticky,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    backgroundColor: (theme.vars || theme).palette.background.paper
                }
            }
        ]
    })));
const $dbf9d389b60a3979$var$ListSubheader = /*#__PURE__*/ $h4Bez.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    };
    const classes = $dbf9d389b60a3979$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($dbf9d389b60a3979$var$ListSubheaderRoot, {
        as: component,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
if ($dbf9d389b60a3979$var$ListSubheader) $dbf9d389b60a3979$var$ListSubheader.muiSkipListHighlight = true;
var $dbf9d389b60a3979$export$2e2bcd8739ae039 = $dbf9d389b60a3979$var$ListSubheader;


















'use client';
var $48552b15399f7d9d$var$_ClearIcon, $48552b15399f7d9d$var$_ArrowDropDownIcon;
const $48552b15399f7d9d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $dbbe785332a10def$export$8ee01529667e66d9), classes);
};
const $48552b15399f7d9d$var$AutocompleteRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $dbbe785332a10def$export$2e2bcd8739ae039).focused} .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).inputRoot}`]: {
        [`.${(0, $dbbe785332a10def$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $dbbe785332a10def$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $dbbe785332a10def$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $13ae6891fee2d602$export$2e2bcd8739ae039).root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${(0, $13ae6891fee2d602$export$2e2bcd8739ae039).root}.${(0, $0886a41ab9c710ef$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $13ae6891fee2d602$export$2e2bcd8739ae039).input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).root}`]: {
        padding: 9,
        [`.${(0, $dbbe785332a10def$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $dbbe785332a10def$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $dbbe785332a10def$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).root}.${(0, $0886a41ab9c710ef$export$2e2bcd8739ae039).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${(0, $821c50d574a0274c$export$2e2bcd8739ae039).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $dbbe785332a10def$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $dbbe785332a10def$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $dbbe785332a10def$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $821c50d574a0274c$export$2e2bcd8739ae039).input}`]: {
            padding: '7px 4px'
        },
        [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $821c50d574a0274c$export$2e2bcd8739ae039).root}.${(0, $0886a41ab9c710ef$export$2e2bcd8739ae039).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $821c50d574a0274c$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${(0, $0886a41ab9c710ef$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $821c50d574a0274c$export$2e2bcd8739ae039).root}.${(0, $0886a41ab9c710ef$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $821c50d574a0274c$export$2e2bcd8739ae039).root}.${(0, $0886a41ab9c710ef$export$2e2bcd8739ae039).hiddenLabel}.${(0, $0886a41ab9c710ef$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $48552b15399f7d9d$var$AutocompleteEndAdornment = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment'
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $48552b15399f7d9d$var$AutocompleteClearIndicator = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $8ccbf49a69947e95$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator'
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $48552b15399f7d9d$var$AutocompletePopupIndicator = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $8ccbf49a69947e95$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popupIndicator,
            ownerState.popupOpen && styles.popupIndicatorOpen
        ];
    }
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $48552b15399f7d9d$var$AutocompletePopper = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $5882b72728fa3109$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    })));
const $48552b15399f7d9d$var$AutocompletePaper = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Paper'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body1,
        overflow: 'auto'
    })));
const $48552b15399f7d9d$var$AutocompleteLoading = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $48552b15399f7d9d$var$AutocompleteNoOptions = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $48552b15399f7d9d$var$AutocompleteListbox = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('ul', {
    name: 'MuiAutocomplete',
    slot: 'Listbox'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $dbbe785332a10def$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $dbbe785332a10def$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
                [`&.${(0, $dbbe785332a10def$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $dbbe785332a10def$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                }
            }
        }
    })));
const $48552b15399f7d9d$var$AutocompleteGroupLabel = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $dbf9d389b60a3979$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    })));
const $48552b15399f7d9d$var$AutocompleteGroupUl = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl'
})({
    padding: 0,
    [`& .${(0, $dbbe785332a10def$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $48552b15399f7d9d$var$Autocomplete = /*#__PURE__*/ $h4Bez.forwardRef(function Autocomplete(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipPropsProp, className: className, clearIcon: clearIcon = $48552b15399f7d9d$var$_ClearIcon || ($48552b15399f7d9d$var$_ClearIcon = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7fb90e10244d933a$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterOptions: filterOptions, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp, isOptionEqualToValue: isOptionEqualToValue, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, limitTags: limitTags = -1, ListboxComponent: ListboxComponentProp, ListboxProps: ListboxPropsProp, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: open, openOnFocus: openOnFocus = false, openText: openText = 'Open', options: options, PaperComponent: PaperComponentProp, PopperComponent: PopperComponentProp, popupIcon: popupIcon = $48552b15399f7d9d$var$_ArrowDropDownIcon || ($48552b15399f7d9d$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b80b59f454a18be6$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, renderValue: renderValue, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slots: slots = {}, slotProps: slotProps = {}, value: valueProp, ...other } = props;
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getItemProps: getItemProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedItem: focusedItem, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $987ea52e7abf9b98$export$2e2bcd8739ae039)({
        ...props,
        componentName: 'Autocomplete'
    });
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: listboxRef, ...otherListboxProps } = getListboxProps();
    const defaultGetOptionLabel = (option)=>option.label ?? option;
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = {
        ...props,
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedItem === -1,
        popupOpen: popupOpen,
        size: size
    };
    const classes = $48552b15399f7d9d$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            paper: PaperComponentProp,
            popper: PopperComponentProp,
            ...slots
        },
        slotProps: {
            chip: ChipPropsProp,
            listbox: ListboxPropsProp,
            ...componentsProps,
            ...slotProps
        }
    };
    const [ListboxSlot, listboxProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('listbox', {
        elementType: $48552b15399f7d9d$var$AutocompleteListbox,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.listbox,
        additionalProps: otherListboxProps,
        ref: listboxRef
    });
    const [PaperSlot, paperProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('paper', {
        elementType: (0, $d6020d3fa35703e9$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.paper
    });
    const [PopperSlot, popperProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('popper', {
        elementType: (0, $5882b72728fa3109$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.popper,
        additionalProps: {
            disablePortal: disablePortal,
            style: {
                width: anchorEl ? anchorEl.clientWidth : null
            },
            role: 'presentation',
            anchorEl: anchorEl,
            open: popupOpen
        }
    });
    let startAdornment;
    const getCustomizedItemProps = (params)=>({
            className: classes.tag,
            disabled: disabled,
            ...getItemProps(params)
        });
    if (multiple) {
        if (value.length > 0) {
            if (renderTags) startAdornment = renderTags(value, getCustomizedItemProps, ownerState);
            else if (renderValue) startAdornment = renderValue(value, getCustomizedItemProps, ownerState);
            else startAdornment = value.map((option, index)=>{
                const { key: key, ...customItemProps } = getCustomizedItemProps({
                    index: index
                });
                return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5c72e4be84329d1d$export$2e2bcd8739ae039), {
                    label: getOptionLabel(option),
                    size: size,
                    ...customItemProps,
                    ...externalForwardedProps.slotProps.chip
                }, key);
            });
        }
    } else if (renderValue && value != null) startAdornment = renderValue(value, getCustomizedItemProps, ownerState);
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($48552b15399f7d9d$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($48552b15399f7d9d$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key, ...otherProps } = props2;
        return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("li", {
            ...otherProps,
            children: getOptionLabel(option)
        }, key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption({
            ...optionProps,
            className: classes.option
        }, option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = externalForwardedProps.slotProps.clearIndicator;
    const popupIndicatorSlotProps = externalForwardedProps.slotProps.popupIndicator;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($h4Bez.Fragment, {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($48552b15399f7d9d$var$AutocompleteRoot, {
                ref: ref,
                className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
                ownerState: ownerState,
                ...getRootProps(other),
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: {
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onMouseDown: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        },
                        ...(hasClearIcon || hasPopupIcon) && {
                            endAdornment: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($48552b15399f7d9d$var$AutocompleteEndAdornment, {
                                className: classes.endAdornment,
                                ownerState: ownerState,
                                children: [
                                    hasClearIcon ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($48552b15399f7d9d$var$AutocompleteClearIndicator, {
                                        ...getClearProps(),
                                        "aria-label": clearText,
                                        title: clearText,
                                        ownerState: ownerState,
                                        ...clearIndicatorSlotProps,
                                        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.clearIndicator, clearIndicatorSlotProps?.className),
                                        children: clearIcon
                                    }) : null,
                                    hasPopupIcon ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($48552b15399f7d9d$var$AutocompletePopupIndicator, {
                                        ...getPopupIndicatorProps(),
                                        disabled: disabled,
                                        "aria-label": popupOpen ? closeText : openText,
                                        title: popupOpen ? closeText : openText,
                                        ownerState: ownerState,
                                        ...popupIndicatorSlotProps,
                                        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.popupIndicator, popupIndicatorSlotProps?.className),
                                        children: popupIcon
                                    }) : null
                                ]
                            })
                        }
                    },
                    inputProps: {
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly,
                        ...getInputProps()
                    }
                })
            }),
            anchorEl ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($48552b15399f7d9d$var$AutocompletePopper, {
                as: PopperSlot,
                ...popperProps,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($48552b15399f7d9d$var$AutocompletePaper, {
                    as: PaperSlot,
                    ...paperProps,
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($48552b15399f7d9d$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($48552b15399f7d9d$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(ListboxSlot, {
                            as: ListboxComponentProp,
                            ...listboxProps,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        }) : null
                    ]
                })
            }) : null
        ]
    });
});
var $48552b15399f7d9d$export$2e2bcd8739ae039 = $48552b15399f7d9d$var$Autocomplete;










const $e878dbad11e3bdcd$var$hasIcon = (value)=>typeof value === 'object' && value !== null && Boolean(value.icon);
const $e878dbad11e3bdcd$var$hasMeta = (value)=>typeof value === 'object' && value !== null && Boolean(value.meta);
const $e878dbad11e3bdcd$var$hasStatus = (value)=>typeof value === 'object' && value !== null && Boolean(value.status);
const $e878dbad11e3bdcd$var$isRequired = (value)=>typeof value === 'object' && value !== null && Boolean(value.required);
/**
 * MUI's `Autocomplete` only knows the deprecated `InputProps`/`InputLabelProps`/`inputProps` API for its
 * `renderInput` slot - it uses them to wire up the popup/clear adornments, selected-value chips, and the
 * actual input's ref/value/keyboard handlers. This maps those onto the `slotProps` that our TextField accepts,
 * so an Autocomplete stays fully functional without reintroducing the deprecated props on TextField itself.
 * @see https://mui.com/material-ui/api/autocomplete/#autocomplete-prop-renderInput
 */ const $e878dbad11e3bdcd$var$adaptAutocompleteRenderInputParams = (params)=>({
        ...(0, $2ae70427bab197d4$export$12b617052eb9d30e)(params, 'InputProps', 'InputLabelProps', 'inputProps'),
        slotProps: {
            input: params.InputProps,
            inputLabel: params.InputLabelProps,
            htmlInput: params.inputProps
        }
    });
const $e878dbad11e3bdcd$var$MAX_VISIBLE_TAGS = 2;
const $e878dbad11e3bdcd$var$ICON_DIMENSION = {
    small: 14,
    medium: 16
};
const $e878dbad11e3bdcd$var$optionIconStyle = (size)=>{
    const dimension = $e878dbad11e3bdcd$var$ICON_DIMENSION[size];
    return {
        display: 'flex',
        width: dimension,
        height: dimension,
        flexShrink: 0,
        '& svg': {
            width: dimension,
            height: dimension
        }
    };
};
/** Figma's status-dot-to-label gap is tighter than the plain icon/label-to-meta gap (12px both sizes) */ const $e878dbad11e3bdcd$var$DOT_GAP = {
    small: 1.5,
    medium: 2
} // 6px / 8px
;
const $e878dbad11e3bdcd$var$optionRowStyle = (size, hasDot)=>({
        display: 'flex',
        alignItems: 'center',
        gap: hasDot ? $e878dbad11e3bdcd$var$DOT_GAP[size] : 3,
        flexGrow: 1,
        minWidth: 0
    });
const $e878dbad11e3bdcd$var$optionLabelStyle = {
    flexGrow: 1,
    minWidth: 0
};
const $e878dbad11e3bdcd$var$optionLabelVariant = {
    small: 'caption',
    medium: 'body2'
};
/** `marginLeft: 'auto'` pushes this flush to the row's right edge, independent of whether the label's own `flexGrow` claimed the space first. Figma's trailing text: plain Roboto at a size with no matching theme token */ const $e878dbad11e3bdcd$var$META_CAPTION_STYLE = {
    small: {
        fontSize: '0.6875rem',
        lineHeight: '0.8125rem'
    },
    medium: {
        fontSize: '0.75rem',
        lineHeight: '0.875rem'
    }
};
const $e878dbad11e3bdcd$var$optionMetaCaptionStyle = (size)=>({
        marginLeft: 'auto',
        ...$e878dbad11e3bdcd$var$META_CAPTION_STYLE[size]
    });
const $e878dbad11e3bdcd$var$DOT_DIMENSION = {
    small: 6,
    medium: 7
};
const $e878dbad11e3bdcd$var$getLimitTagsText = (more)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MORE_TAGS_COUNT,
        values: {
            count: more
        }
    });
const $e878dbad11e3bdcd$var$NoOptionsText = ({ translationId: translationId, options: options })=>{
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(options) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "body2",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: translationId
                })
            }),
            options === null && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2db76c9e9f88b3ff$export$2e2bcd8739ae039), {})
            }),
            (0, $c3e1b746ad236797$export$8d524fb6540252df).is(options) && ((0, $c3e1b746ad236797$export$8d524fb6540252df).isOfTypes(options, (0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST) ? options.message : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
                titleVariant: "body2",
                error: options
            }))
        ]
    });
};
const $e878dbad11e3bdcd$export$2f2b9559550c7bbc = ({ options: options, noOptionsText: noOptionsText, onSearch: onSearch, onSelect: onSelect, disabled: disabled, value: value, size: size = 'medium', ...props })=>{
    /** `inputValue` isn't an exposed prop (see the Omit above), so this tracks it locally to avoid disabling the field as "no data" mid-typing */ const [searchTerm, setSearchTerm] = (0, $h4Bez.useState)('');
    const availableOptions = (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(options) ? options : [];
    /** freeSolo entries aren't picked from `options`, so an empty set doesn't mean there's nothing to do here */ const noData = !props.freeSolo && !searchTerm && (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(options) && options.length === 0;
    /**
     * `renderOption` isn't a caller-exposed prop (see the Omit above) - every option renders through the
     * shared `Dropdown` menu chrome (`MenuItem`), so consumers express content via `WithIcon`/`WithMeta` data
     * instead of a bespoke render function. One unified row: optional status dot, optional icon, label,
     * optional right-aligned trailing text.
     */ const defaultRenderOption = (optionProps, option, state, ownerState)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7ee94322a0c893de$export$2ce376c2cc3355c8), {
            ...optionProps,
            "data-testid": `option-${ownerState.getOptionLabel(option)}`,
            selected: state.selected,
            sizeClassName: (0, $5f4401162cf072d8$export$2f632c059ec3efb7)[size],
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $e878dbad11e3bdcd$var$optionRowStyle(size, $e878dbad11e3bdcd$var$hasStatus(option)),
                children: [
                    $e878dbad11e3bdcd$var$hasStatus(option) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $544912f84b2ee288$export$eaa9dcd62e0d5ec6), {
                        tone: option.status,
                        size: $e878dbad11e3bdcd$var$DOT_DIMENSION[size]
                    }),
                    $e878dbad11e3bdcd$var$hasIcon(option) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        sx: $e878dbad11e3bdcd$var$optionIconStyle(size),
                        children: option.icon
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        variant: $e878dbad11e3bdcd$var$optionLabelVariant[size],
                        noWrap: true,
                        sx: $e878dbad11e3bdcd$var$optionLabelStyle,
                        children: ownerState.getOptionLabel(option)
                    }),
                    $e878dbad11e3bdcd$var$hasMeta(option) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        variant: "caption",
                        color: "grey.500",
                        sx: $e878dbad11e3bdcd$var$optionMetaCaptionStyle(size),
                        children: option.meta
                    })
                ]
            })
        });
    /**
     * Chip equivalent of `defaultRenderOption`, typed against a literal `Multiple = true` - see the cast below.
     * Must return a plain array (not a Fragment) - MUI's own `limitTags`/`getLimitTagsText` truncation only
     * kicks in when `Array.isArray(startAdornment)` holds for whatever this returns.
     */ const renderMultipleValue = (tags, getItemProps, ownerState)=>tags.map((option, index)=>{
            const itemProps = getItemProps({
                index: index
            });
            return /*#__PURE__*/ (0, $h4Bez.createElement)((0, $5c72e4be84329d1d$export$2e2bcd8739ae039), {
                variant: "primary",
                size: "small",
                icon: $e878dbad11e3bdcd$var$hasIcon(option) ? option.icon : undefined,
                label: ownerState.getOptionLabel(option),
                ...itemProps,
                /** Hides the per-chip delete icon for `WithRequired` options - see `WithRequired` */ onDelete: $e878dbad11e3bdcd$var$isRequired(option) ? undefined : itemProps.onDelete,
                key: index
            });
        });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $48552b15399f7d9d$export$2e2bcd8739ae039), {
        ...props,
        /**
             * Cast back to mutable for MUI's prop type
             * @see https://github.com/mui/material-ui/pull/47948
             */ value: value,
        filterSelectedOptions: true,
        size: size,
        limitTags: $e878dbad11e3bdcd$var$MAX_VISIBLE_TAGS,
        getLimitTagsText: $e878dbad11e3bdcd$var$getLimitTagsText,
        options: availableOptions,
        noOptionsText: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($e878dbad11e3bdcd$var$NoOptionsText, {
            translationId: noOptionsText,
            options: options
        }),
        disabled: disabled || noData,
        renderOption: defaultRenderOption,
        /**
             * `AutocompleteRenderValue`/`AutocompleteRenderValueGetItemProps` are `Multiple extends true ? ... : ...` conditionals
             * that can't resolve while `Multiple` is still abstract here, so `renderMultipleValue` is typed against a literal
             * `true` instead - the cast below is safe since it's only ever wired in for `multiple` selections
             */ renderValue: props.multiple ? renderMultipleValue : undefined,
        renderInput: (params)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d887fad28e7ec96c$export$2c73285ae9390cec), {
                ...$e878dbad11e3bdcd$var$adaptAutocompleteRenderInputParams(params),
                onChange: ({ currentTarget: { value: value } })=>{
                    setSearchTerm(value);
                    onSearch?.(value);
                }
            }),
        onChange: (_, value)=>onSelect(value)
    });
};



parcelRequire("h4Bez");


"use client";
var $308788bd9935f809$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6m-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14M2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45zm7.5 7.5 2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13m-3.4-3.4 1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53"
}), 'VisibilityOffOutlined');



"use client";
var $369aad4adb4c0e5d$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7"
}), 'VisibilityOutlined');




const $ce2f632502216d89$export$241ba0b938fcb9f = ({ visible: visible, onToggle: onToggle, disabled: disabled, showLabel: showLabel, hideLabel: hideLabel, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
        "data-testid": dataTestId,
        size: "small",
        variant: "ghost",
        disabled: disabled,
        onClick: onToggle,
        children: visible ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $308788bd9935f809$export$2e2bcd8739ae039), {
            sx: (0, $d887fad28e7ec96c$export$6e6cc632aa66aa48),
            titleAccess: hideLabel
        }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $369aad4adb4c0e5d$export$2e2bcd8739ae039), {
            sx: (0, $d887fad28e7ec96c$export$6e6cc632aa66aa48),
            titleAccess: showLabel
        })
    });




const $55803b42aecede9b$var$rowStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5
};
const $55803b42aecede9b$var$containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5
};
const $55803b42aecede9b$var$labelStyle = (theme)=>({
        ...theme.typography.body2,
        minWidth: 40,
        fontWeight: 600,
        color: 'grey.700'
    });
const $55803b42aecede9b$var$dateInputStyle = {
    minWidth: 160
};
const $55803b42aecede9b$var$timeInputStyle = {
    minWidth: 80,
    [`& .${(0, $8f2ed57594b78c76$export$2e2bcd8739ae039).input}[type="time"]::-webkit-calendar-picker-indicator`]: {
        display: 'none'
    }
};
const $55803b42aecede9b$var$TimeInput = ({ label: label, date: date, time: time, minTime: minTime, now: now, onTimeChange: onTimeChange, datePlaceholderId: datePlaceholderId, ...props })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    // Logs aren't available for future times, so today's selection can't go past the current time
    const maxTime = date && (0, $091b76300838ede1$export$3cda43bb863908d4)(date, now) ? (0, $091b76300838ede1$export$3203edd9e5edd663)(now) : undefined;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $55803b42aecede9b$var$rowStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                sx: $55803b42aecede9b$var$labelStyle,
                children: translator.formatTranslation(label)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d887fad28e7ec96c$export$2c73285ae9390cec), {
                type: "text",
                value: date ? (0, $091b76300838ede1$export$3ae94a2503e890a1)(date) : '',
                sx: $55803b42aecede9b$var$dateInputStyle,
                "data-testid": (0, $3dd52092ec4fc8cb$export$eea0c9f46a8cc3f9)(props, '-date-input'),
                slotProps: {
                    input: {
                        readOnly: true,
                        sx: {
                            typography: 'body2'
                        }
                    }
                },
                placeholder: translator.formatTranslation(datePlaceholderId)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d887fad28e7ec96c$export$2c73285ae9390cec), {
                type: "time",
                value: date ? time : '',
                disabled: !date,
                onChange: (e)=>onTimeChange(e.target.value),
                sx: $55803b42aecede9b$var$timeInputStyle,
                slotProps: {
                    htmlInput: {
                        max: maxTime,
                        min: minTime
                    }
                },
                "data-testid": (0, $3dd52092ec4fc8cb$export$eea0c9f46a8cc3f9)(props, '-time-input'),
                placeholder: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).TIME)
            })
        ]
    });
};
const $55803b42aecede9b$export$f5ffd13ff26fef2f = ({ startTime: startTime, endTime: endTime, startDate: startDate, endDate: endDate, endMinTime: endMinTime, now: now, onStartTimeChange: onStartTimeChange, onEndTimeChange: onEndTimeChange })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $55803b42aecede9b$var$containerStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($55803b42aecede9b$var$TimeInput, {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).START,
                date: startDate,
                time: startTime,
                now: now,
                onTimeChange: onStartTimeChange,
                "data-testid": "start",
                datePlaceholderId: (0, $40a99dac858c1d75$export$b63289fbda65eed1).START_DATE
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($55803b42aecede9b$var$TimeInput, {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).END,
                date: endDate,
                time: endTime,
                minTime: endMinTime,
                now: now,
                onTimeChange: onEndTimeChange,
                "data-testid": "end",
                datePlaceholderId: (0, $40a99dac858c1d75$export$b63289fbda65eed1).END_DATE
            })
        ]
    });


const $2eaf0b88238e089a$var$containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    width: 'fit-content',
    maxWidth: 625,
    borderRadius: 1,
    border: '1px solid',
    borderColor: 'divider',
    bgcolor: 'background.paper',
    boxShadow: 8,
    overflow: 'hidden'
};
const $2eaf0b88238e089a$var$dividerStyle = {
    height: '1px',
    width: '100%',
    bgcolor: 'divider'
};
const $2eaf0b88238e089a$var$footerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 3,
    padding: 3
};
// The times a freshly-picked day's field defaults to, so the user doesn't have to type a time just to enable
// Apply - still fully editable before applying. The start begins its day and the end closes it, so a range includes its end day in full.
const $2eaf0b88238e089a$var$DEFAULT_START_TIME = '00:00';
const $2eaf0b88238e089a$var$DEFAULT_END_TIME = '23:59';
// An end day of today can't default past the current time, which is the latest the picker accepts
const $2eaf0b88238e089a$var$defaultEndTime = (day, now)=>(0, $091b76300838ede1$export$3cda43bb863908d4)(day, now) ? (0, $091b76300838ede1$export$3203edd9e5edd663)(now) : $2eaf0b88238e089a$var$DEFAULT_END_TIME;
const $2eaf0b88238e089a$export$2d9d261e8d6cfeef = ({ value: value, onApply: onApply, onCancel: onCancel, disableAfter: disableAfter })=>{
    const [range, setRange] = (0, $h4Bez.useState)(value ? {
        from: value.start ?? undefined,
        to: value.end ?? undefined
    } : undefined);
    const [displayMonth, setDisplayMonth] = (0, $h4Bez.useState)(()=>{
        const date = value?.start ?? value?.end ?? new Date();
        return new Date(date.getFullYear(), date.getMonth(), 1);
    });
    const [times, setTimes] = (0, $h4Bez.useState)({
        start: value?.start ? (0, $091b76300838ede1$export$3203edd9e5edd663)(value.start) : '',
        end: value?.end ? (0, $091b76300838ede1$export$3203edd9e5edd663)(value.end) : ''
    });
    const now = new Date();
    const start = range?.from && times.start ? (0, $091b76300838ede1$export$6195456a656da885)(range.from, times.start) : undefined;
    const end = range?.to && times.end ? (0, $091b76300838ede1$export$6195456a656da885)(range.to, times.end) : undefined;
    const isSameStartEndDay = range?.from && range?.to ? (0, $091b76300838ede1$export$3cda43bb863908d4)(range.from, range.to) : false;
    const endMinTime = isSameStartEndDay ? times.start : undefined;
    // Each present bound must not be in the future, and start can't be after end
    const canApply = (start !== undefined || end !== undefined) && (start === undefined || start <= now) && (end === undefined || end <= now) && (start === undefined || end === undefined || start <= end);
    const handleApply = ()=>{
        // The end time is shown as HH:mm, so the range includes its whole last minute
        onApply({
            start: start ?? null,
            end: end ? (0, $091b76300838ede1$export$bfdf65d751e28457)(end) : null
        });
    };
    // Stable across renders triggered by typing in the time inputs, so `Calendar` (wrapped in React.memo)
    // doesn't re-render its whole two-month grid on every keystroke
    const handleRangeSelect = (0, $h4Bez.useCallback)((newRange)=>{
        // A new start day discards any previously typed start time - it belonged to a different day. This
        // covers a fresh anchor, a full range collapsing back to just a start day (react-day-picker's own
        // reset-on-reselect, which keeps `from` anchored to the clicked day even when it matches the previous
        // range's start), and a range "swap" (clicking a day before the current anchor makes that earlier day
        // the new start and the current anchor the new end, in one click) - the new start day is a day that
        // never had a start time typed for it, so it still gets a fresh default.
        const isReset = range?.to !== undefined && newRange?.to === undefined;
        const startDayChanged = isReset || newRange?.from?.getTime() !== range?.from?.getTime();
        // A freshly-picked start day (or a discarded one, per above) defaults to the start of its day, not
        // reapplied over a time the user already typed (including deliberately clearing it back to blank).
        // The end time always gets its default: every click either wipes `to` or freshly defines it (see
        // `useRange.select` in react-day-picker). On a swap the old anchor becomes the end day, and gets the
        // end's default like any other end day, not the start time it had.
        setTimes((t)=>({
                start: newRange?.from ? startDayChanged ? $2eaf0b88238e089a$var$DEFAULT_START_TIME : t.start : '',
                end: newRange?.to ? $2eaf0b88238e089a$var$defaultEndTime(newRange.to, new Date()) : ''
            }));
        setRange(newRange);
    }, [
        range
    ]);
    return(// Dialog provides modal overlay and focus management for the date time range picker
    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $55a2a796d4e0875c$export$2e2bcd8739ae039), {
        open: true,
        onClose: onCancel,
        maxWidth: false,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
            sx: $2eaf0b88238e089a$var$containerStyle,
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0f1298553ba7903b$export$e1aef45b828286de), {
                    selectedRange: range,
                    onRangeSelect: handleRangeSelect,
                    displayMonth: displayMonth,
                    onMonthChange: setDisplayMonth,
                    disableAfter: disableAfter
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: $2eaf0b88238e089a$var$dividerStyle
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: $2eaf0b88238e089a$var$footerStyle,
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $55803b42aecede9b$export$f5ffd13ff26fef2f), {
                            startTime: times.start,
                            endTime: times.end,
                            startDate: range?.from,
                            endDate: range?.to,
                            endMinTime: endMinTime,
                            now: now,
                            onStartTimeChange: (s)=>setTimes((t)=>({
                                        ...t,
                                        start: s
                                    })),
                            onEndTimeChange: (e)=>setTimes((t)=>({
                                        ...t,
                                        end: e
                                    }))
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $870b65d56f8a27bd$export$88c65d2d98aab183), {
                            onCancel: onCancel,
                            onApply: handleApply,
                            disabled: !canApply
                        })
                    ]
                })
            ]
        })
    }));
};


const $45305f2cebf25d3d$export$19bfc49083d6bd5d = ({ value: { start: start, end: end }, onApply: onApply, disableAfter: disableAfter })=>{
    const [isPickerOpen, setIsPickerOpen] = (0, $h4Bez.useState)(false);
    const appliedRange = start ?? end ? {
        start: start,
        end: end
    } : undefined;
    const handleApply = ({ start: start, end: end })=>{
        onApply({
            start: start,
            end: end
        });
        setIsPickerOpen(false);
    };
    const handleClear = ()=>{
        onApply({
            start: null,
            end: null
        });
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                "data-testid": "time-button",
                size: "medium",
                variant: "secondary",
                onClick: ()=>setIsPickerOpen(true),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TIME
                })
            }),
            appliedRange && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f96805b54bc850bf$export$27057d02d4068174), {
                value: appliedRange,
                onClear: handleClear
            }),
            isPickerOpen && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2eaf0b88238e089a$export$2d9d261e8d6cfeef), {
                value: appliedRange,
                onApply: handleApply,
                onCancel: ()=>setIsPickerOpen(false),
                disableAfter: disableAfter
            })
        ]
    });
};








var $h4Bez = parcelRequire("h4Bez");
var $c8cf8cc7ac0beb95$var$__defProp = Object.defineProperty;
var $c8cf8cc7ac0beb95$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c8cf8cc7ac0beb95$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c8cf8cc7ac0beb95$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c8cf8cc7ac0beb95$var$__defNormalProp = (obj, key, value)=>key in obj ? $c8cf8cc7ac0beb95$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c8cf8cc7ac0beb95$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c8cf8cc7ac0beb95$var$__hasOwnProp.call(b, prop)) $c8cf8cc7ac0beb95$var$__defNormalProp(a, prop, b[prop]);
    if ($c8cf8cc7ac0beb95$var$__getOwnPropSymbols) {
        for (var prop of $c8cf8cc7ac0beb95$var$__getOwnPropSymbols(b))if ($c8cf8cc7ac0beb95$var$__propIsEnum.call(b, prop)) $c8cf8cc7ac0beb95$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c8cf8cc7ac0beb95$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c8cf8cc7ac0beb95$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c8cf8cc7ac0beb95$var$__getOwnPropSymbols) {
        for (var prop of $c8cf8cc7ac0beb95$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c8cf8cc7ac0beb95$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/third-party/qrcodegen/index.ts
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */ var $c8cf8cc7ac0beb95$var$qrcodegen;
((qrcodegen2)=>{
    const _QrCode = class {
        constructor(version, errorCorrectionLevel, dataCodewords, msk){
            this.version = version;
            this.errorCorrectionLevel = errorCorrectionLevel;
            this.modules = [];
            this.isFunction = [];
            if (version < _QrCode.MIN_VERSION || version > _QrCode.MAX_VERSION) throw new RangeError("Version value out of range");
            if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
            this.size = version * 4 + 17;
            let row = [];
            for(let i = 0; i < this.size; i++)row.push(false);
            for(let i = 0; i < this.size; i++){
                this.modules.push(row.slice());
                this.isFunction.push(row.slice());
            }
            this.drawFunctionPatterns();
            const allCodewords = this.addEccAndInterleave(dataCodewords);
            this.drawCodewords(allCodewords);
            if (msk == -1) {
                let minPenalty = 1e9;
                for(let i = 0; i < 8; i++){
                    this.applyMask(i);
                    this.drawFormatBits(i);
                    const penalty = this.getPenaltyScore();
                    if (penalty < minPenalty) {
                        msk = i;
                        minPenalty = penalty;
                    }
                    this.applyMask(i);
                }
            }
            assert(0 <= msk && msk <= 7);
            this.mask = msk;
            this.applyMask(msk);
            this.drawFormatBits(msk);
            this.isFunction = [];
        }
        static encodeText(text, ecl) {
            const segs = qrcodegen2.QrSegment.makeSegments(text);
            return _QrCode.encodeSegments(segs, ecl);
        }
        static encodeBinary(data, ecl) {
            const seg = qrcodegen2.QrSegment.makeBytes(data);
            return _QrCode.encodeSegments([
                seg
            ], ecl);
        }
        static encodeSegments(segs, ecl, minVersion = 1, maxVersion = 40, mask = -1, boostEcl = true) {
            if (!(_QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= _QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
            let version;
            let dataUsedBits;
            for(version = minVersion;; version++){
                const dataCapacityBits2 = _QrCode.getNumDataCodewords(version, ecl) * 8;
                const usedBits = QrSegment.getTotalBits(segs, version);
                if (usedBits <= dataCapacityBits2) {
                    dataUsedBits = usedBits;
                    break;
                }
                if (version >= maxVersion) throw new RangeError("Data too long");
            }
            for (const newEcl of [
                _QrCode.Ecc.MEDIUM,
                _QrCode.Ecc.QUARTILE,
                _QrCode.Ecc.HIGH
            ])if (boostEcl && dataUsedBits <= _QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
            let bb = [];
            for (const seg of segs){
                appendBits(seg.mode.modeBits, 4, bb);
                appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
                for (const b of seg.getData())bb.push(b);
            }
            assert(bb.length == dataUsedBits);
            const dataCapacityBits = _QrCode.getNumDataCodewords(version, ecl) * 8;
            assert(bb.length <= dataCapacityBits);
            appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
            appendBits(0, (8 - bb.length % 8) % 8, bb);
            assert(bb.length % 8 == 0);
            for(let padByte = 236; bb.length < dataCapacityBits; padByte ^= 253)appendBits(padByte, 8, bb);
            let dataCodewords = [];
            while(dataCodewords.length * 8 < bb.length)dataCodewords.push(0);
            bb.forEach((b, i)=>dataCodewords[i >>> 3] |= b << 7 - (i & 7));
            return new _QrCode(version, ecl, dataCodewords, mask);
        }
        getModule(x, y) {
            return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
        }
        getModules() {
            return this.modules;
        }
        drawFunctionPatterns() {
            for(let i = 0; i < this.size; i++){
                this.setFunctionModule(6, i, i % 2 == 0);
                this.setFunctionModule(i, 6, i % 2 == 0);
            }
            this.drawFinderPattern(3, 3);
            this.drawFinderPattern(this.size - 4, 3);
            this.drawFinderPattern(3, this.size - 4);
            const alignPatPos = this.getAlignmentPatternPositions();
            const numAlign = alignPatPos.length;
            for(let i = 0; i < numAlign; i++){
                for(let j = 0; j < numAlign; j++)if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
            }
            this.drawFormatBits(0);
            this.drawVersion();
        }
        drawFormatBits(mask) {
            const data = this.errorCorrectionLevel.formatBits << 3 | mask;
            let rem = data;
            for(let i = 0; i < 10; i++)rem = rem << 1 ^ (rem >>> 9) * 1335;
            const bits = (data << 10 | rem) ^ 21522;
            assert(bits >>> 15 == 0);
            for(let i = 0; i <= 5; i++)this.setFunctionModule(8, i, getBit(bits, i));
            this.setFunctionModule(8, 7, getBit(bits, 6));
            this.setFunctionModule(8, 8, getBit(bits, 7));
            this.setFunctionModule(7, 8, getBit(bits, 8));
            for(let i = 9; i < 15; i++)this.setFunctionModule(14 - i, 8, getBit(bits, i));
            for(let i = 0; i < 8; i++)this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
            for(let i = 8; i < 15; i++)this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
            this.setFunctionModule(8, this.size - 8, true);
        }
        drawVersion() {
            if (this.version < 7) return;
            let rem = this.version;
            for(let i = 0; i < 12; i++)rem = rem << 1 ^ (rem >>> 11) * 7973;
            const bits = this.version << 12 | rem;
            assert(bits >>> 18 == 0);
            for(let i = 0; i < 18; i++){
                const color = getBit(bits, i);
                const a = this.size - 11 + i % 3;
                const b = Math.floor(i / 3);
                this.setFunctionModule(a, b, color);
                this.setFunctionModule(b, a, color);
            }
        }
        drawFinderPattern(x, y) {
            for(let dy = -4; dy <= 4; dy++)for(let dx = -4; dx <= 4; dx++){
                const dist = Math.max(Math.abs(dx), Math.abs(dy));
                const xx = x + dx;
                const yy = y + dy;
                if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
            }
        }
        drawAlignmentPattern(x, y) {
            for(let dy = -2; dy <= 2; dy++)for(let dx = -2; dx <= 2; dx++)this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
        }
        setFunctionModule(x, y, isDark) {
            this.modules[y][x] = isDark;
            this.isFunction[y][x] = true;
        }
        addEccAndInterleave(data) {
            const ver = this.version;
            const ecl = this.errorCorrectionLevel;
            if (data.length != _QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
            const numBlocks = _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
            const blockEccLen = _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
            const rawCodewords = Math.floor(_QrCode.getNumRawDataModules(ver) / 8);
            const numShortBlocks = numBlocks - rawCodewords % numBlocks;
            const shortBlockLen = Math.floor(rawCodewords / numBlocks);
            let blocks = [];
            const rsDiv = _QrCode.reedSolomonComputeDivisor(blockEccLen);
            for(let i = 0, k = 0; i < numBlocks; i++){
                let dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
                k += dat.length;
                const ecc = _QrCode.reedSolomonComputeRemainder(dat, rsDiv);
                if (i < numShortBlocks) dat.push(0);
                blocks.push(dat.concat(ecc));
            }
            let result = [];
            for(let i = 0; i < blocks[0].length; i++)blocks.forEach((block, j)=>{
                if (i != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[i]);
            });
            assert(result.length == rawCodewords);
            return result;
        }
        drawCodewords(data) {
            if (data.length != Math.floor(_QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
            let i = 0;
            for(let right = this.size - 1; right >= 1; right -= 2){
                if (right == 6) right = 5;
                for(let vert = 0; vert < this.size; vert++)for(let j = 0; j < 2; j++){
                    const x = right - j;
                    const upward = (right + 1 & 2) == 0;
                    const y = upward ? this.size - 1 - vert : vert;
                    if (!this.isFunction[y][x] && i < data.length * 8) {
                        this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
                        i++;
                    }
                }
            }
            assert(i == data.length * 8);
        }
        applyMask(mask) {
            if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");
            for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++){
                let invert;
                switch(mask){
                    case 0:
                        invert = (x + y) % 2 == 0;
                        break;
                    case 1:
                        invert = y % 2 == 0;
                        break;
                    case 2:
                        invert = x % 3 == 0;
                        break;
                    case 3:
                        invert = (x + y) % 3 == 0;
                        break;
                    case 4:
                        invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
                        break;
                    case 5:
                        invert = x * y % 2 + x * y % 3 == 0;
                        break;
                    case 6:
                        invert = (x * y % 2 + x * y % 3) % 2 == 0;
                        break;
                    case 7:
                        invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
                        break;
                    default:
                        throw new Error("Unreachable");
                }
                if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
            }
        }
        getPenaltyScore() {
            let result = 0;
            for(let y = 0; y < this.size; y++){
                let runColor = false;
                let runX = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let x = 0; x < this.size; x++)if (this.modules[y][x] == runColor) {
                    runX++;
                    if (runX == 5) result += _QrCode.PENALTY_N1;
                    else if (runX > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runX, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runX = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let x = 0; x < this.size; x++){
                let runColor = false;
                let runY = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let y = 0; y < this.size; y++)if (this.modules[y][x] == runColor) {
                    runY++;
                    if (runY == 5) result += _QrCode.PENALTY_N1;
                    else if (runY > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runY, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runY = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let y = 0; y < this.size - 1; y++)for(let x = 0; x < this.size - 1; x++){
                const color = this.modules[y][x];
                if (color == this.modules[y][x + 1] && color == this.modules[y + 1][x] && color == this.modules[y + 1][x + 1]) result += _QrCode.PENALTY_N2;
            }
            let dark = 0;
            for (const row of this.modules)dark = row.reduce((sum, color)=>sum + (color ? 1 : 0), dark);
            const total = this.size * this.size;
            const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
            assert(0 <= k && k <= 9);
            result += k * _QrCode.PENALTY_N4;
            assert(0 <= result && result <= 2568888);
            return result;
        }
        getAlignmentPatternPositions() {
            if (this.version == 1) return [];
            else {
                const numAlign = Math.floor(this.version / 7) + 2;
                const step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
                let result = [
                    6
                ];
                for(let pos = this.size - 7; result.length < numAlign; pos -= step)result.splice(1, 0, pos);
                return result;
            }
        }
        static getNumRawDataModules(ver) {
            if (ver < _QrCode.MIN_VERSION || ver > _QrCode.MAX_VERSION) throw new RangeError("Version number out of range");
            let result = (16 * ver + 128) * ver + 64;
            if (ver >= 2) {
                const numAlign = Math.floor(ver / 7) + 2;
                result -= (25 * numAlign - 10) * numAlign - 55;
                if (ver >= 7) result -= 36;
            }
            assert(208 <= result && result <= 29648);
            return result;
        }
        static getNumDataCodewords(ver, ecl) {
            return Math.floor(_QrCode.getNumRawDataModules(ver) / 8) - _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
        }
        static reedSolomonComputeDivisor(degree) {
            if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
            let result = [];
            for(let i = 0; i < degree - 1; i++)result.push(0);
            result.push(1);
            let root = 1;
            for(let i = 0; i < degree; i++){
                for(let j = 0; j < result.length; j++){
                    result[j] = _QrCode.reedSolomonMultiply(result[j], root);
                    if (j + 1 < result.length) result[j] ^= result[j + 1];
                }
                root = _QrCode.reedSolomonMultiply(root, 2);
            }
            return result;
        }
        static reedSolomonComputeRemainder(data, divisor) {
            let result = divisor.map((_)=>0);
            for (const b of data){
                const factor = b ^ result.shift();
                result.push(0);
                divisor.forEach((coef, i)=>result[i] ^= _QrCode.reedSolomonMultiply(coef, factor));
            }
            return result;
        }
        static reedSolomonMultiply(x, y) {
            if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError("Byte out of range");
            let z = 0;
            for(let i = 7; i >= 0; i--){
                z = z << 1 ^ (z >>> 7) * 285;
                z ^= (y >>> i & 1) * x;
            }
            assert(z >>> 8 == 0);
            return z;
        }
        finderPenaltyCountPatterns(runHistory) {
            const n = runHistory[1];
            assert(n <= this.size * 3);
            const core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
            return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
        }
        finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
            if (currentRunColor) {
                this.finderPenaltyAddHistory(currentRunLength, runHistory);
                currentRunLength = 0;
            }
            currentRunLength += this.size;
            this.finderPenaltyAddHistory(currentRunLength, runHistory);
            return this.finderPenaltyCountPatterns(runHistory);
        }
        finderPenaltyAddHistory(currentRunLength, runHistory) {
            if (runHistory[0] == 0) currentRunLength += this.size;
            runHistory.pop();
            runHistory.unshift(currentRunLength);
        }
    };
    let QrCode = _QrCode;
    QrCode.MIN_VERSION = 1;
    QrCode.MAX_VERSION = 40;
    QrCode.PENALTY_N1 = 3;
    QrCode.PENALTY_N2 = 3;
    QrCode.PENALTY_N3 = 40;
    QrCode.PENALTY_N4 = 10;
    QrCode.ECC_CODEWORDS_PER_BLOCK = [
        [
            -1,
            7,
            10,
            15,
            20,
            26,
            18,
            20,
            24,
            30,
            18,
            20,
            24,
            26,
            30,
            22,
            24,
            28,
            30,
            28,
            28,
            28,
            28,
            30,
            30,
            26,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        [
            -1,
            10,
            16,
            26,
            18,
            24,
            16,
            18,
            22,
            22,
            26,
            30,
            22,
            22,
            24,
            24,
            28,
            28,
            26,
            26,
            26,
            26,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28
        ],
        [
            -1,
            13,
            22,
            18,
            26,
            18,
            24,
            18,
            22,
            20,
            24,
            28,
            26,
            24,
            20,
            30,
            24,
            28,
            28,
            26,
            30,
            28,
            30,
            30,
            30,
            30,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        [
            -1,
            17,
            28,
            22,
            16,
            22,
            28,
            26,
            26,
            24,
            28,
            24,
            28,
            22,
            24,
            24,
            30,
            28,
            28,
            26,
            28,
            30,
            24,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ]
    ];
    QrCode.NUM_ERROR_CORRECTION_BLOCKS = [
        [
            -1,
            1,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            4,
            4,
            4,
            4,
            4,
            6,
            6,
            6,
            6,
            7,
            8,
            8,
            9,
            9,
            10,
            12,
            12,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            19,
            20,
            21,
            22,
            24,
            25
        ],
        [
            -1,
            1,
            1,
            1,
            2,
            2,
            4,
            4,
            4,
            5,
            5,
            5,
            8,
            9,
            9,
            10,
            10,
            11,
            13,
            14,
            16,
            17,
            17,
            18,
            20,
            21,
            23,
            25,
            26,
            28,
            29,
            31,
            33,
            35,
            37,
            38,
            40,
            43,
            45,
            47,
            49
        ],
        [
            -1,
            1,
            1,
            2,
            2,
            4,
            4,
            6,
            6,
            8,
            8,
            8,
            10,
            12,
            16,
            12,
            17,
            16,
            18,
            21,
            20,
            23,
            23,
            25,
            27,
            29,
            34,
            34,
            35,
            38,
            40,
            43,
            45,
            48,
            51,
            53,
            56,
            59,
            62,
            65,
            68
        ],
        [
            -1,
            1,
            1,
            2,
            4,
            4,
            4,
            5,
            6,
            8,
            8,
            11,
            11,
            16,
            16,
            18,
            16,
            19,
            21,
            25,
            25,
            25,
            34,
            30,
            32,
            35,
            37,
            40,
            42,
            45,
            48,
            51,
            54,
            57,
            60,
            63,
            66,
            70,
            74,
            77,
            81
        ]
    ];
    qrcodegen2.QrCode = QrCode;
    function appendBits(val, len, bb) {
        if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError("Value out of range");
        for(let i = len - 1; i >= 0; i--)bb.push(val >>> i & 1);
    }
    function getBit(x, i) {
        return (x >>> i & 1) != 0;
    }
    function assert(cond) {
        if (!cond) throw new Error("Assertion error");
    }
    const _QrSegment = class {
        constructor(mode, numChars, bitData){
            this.mode = mode;
            this.numChars = numChars;
            this.bitData = bitData;
            if (numChars < 0) throw new RangeError("Invalid argument");
            this.bitData = bitData.slice();
        }
        static makeBytes(data) {
            let bb = [];
            for (const b of data)appendBits(b, 8, bb);
            return new _QrSegment(_QrSegment.Mode.BYTE, data.length, bb);
        }
        static makeNumeric(digits) {
            if (!_QrSegment.isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
            let bb = [];
            for(let i = 0; i < digits.length;){
                const n = Math.min(digits.length - i, 3);
                appendBits(parseInt(digits.substr(i, n), 10), n * 3 + 1, bb);
                i += n;
            }
            return new _QrSegment(_QrSegment.Mode.NUMERIC, digits.length, bb);
        }
        static makeAlphanumeric(text) {
            if (!_QrSegment.isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
            let bb = [];
            let i;
            for(i = 0; i + 2 <= text.length; i += 2){
                let temp = _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
                temp += _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
                appendBits(temp, 11, bb);
            }
            if (i < text.length) appendBits(_QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
            return new _QrSegment(_QrSegment.Mode.ALPHANUMERIC, text.length, bb);
        }
        static makeSegments(text) {
            if (text == "") return [];
            else if (_QrSegment.isNumeric(text)) return [
                _QrSegment.makeNumeric(text)
            ];
            else if (_QrSegment.isAlphanumeric(text)) return [
                _QrSegment.makeAlphanumeric(text)
            ];
            else return [
                _QrSegment.makeBytes(_QrSegment.toUtf8ByteArray(text))
            ];
        }
        static makeEci(assignVal) {
            let bb = [];
            if (assignVal < 0) throw new RangeError("ECI assignment value out of range");
            else if (assignVal < 128) appendBits(assignVal, 8, bb);
            else if (assignVal < 16384) {
                appendBits(2, 2, bb);
                appendBits(assignVal, 14, bb);
            } else if (assignVal < 1e6) {
                appendBits(6, 3, bb);
                appendBits(assignVal, 21, bb);
            } else throw new RangeError("ECI assignment value out of range");
            return new _QrSegment(_QrSegment.Mode.ECI, 0, bb);
        }
        static isNumeric(text) {
            return _QrSegment.NUMERIC_REGEX.test(text);
        }
        static isAlphanumeric(text) {
            return _QrSegment.ALPHANUMERIC_REGEX.test(text);
        }
        getData() {
            return this.bitData.slice();
        }
        static getTotalBits(segs, version) {
            let result = 0;
            for (const seg of segs){
                const ccbits = seg.mode.numCharCountBits(version);
                if (seg.numChars >= 1 << ccbits) return Infinity;
                result += 4 + ccbits + seg.bitData.length;
            }
            return result;
        }
        static toUtf8ByteArray(str) {
            str = encodeURI(str);
            let result = [];
            for(let i = 0; i < str.length; i++)if (str.charAt(i) != "%") result.push(str.charCodeAt(i));
            else {
                result.push(parseInt(str.substr(i + 1, 2), 16));
                i += 2;
            }
            return result;
        }
    };
    let QrSegment = _QrSegment;
    QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
    QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
    QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
    qrcodegen2.QrSegment = QrSegment;
})($c8cf8cc7ac0beb95$var$qrcodegen || ($c8cf8cc7ac0beb95$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrCode;
    ((QrCode2)=>{
        const _Ecc = class {
            constructor(ordinal, formatBits){
                this.ordinal = ordinal;
                this.formatBits = formatBits;
            }
        };
        let Ecc = _Ecc;
        Ecc.LOW = new _Ecc(0, 1);
        Ecc.MEDIUM = new _Ecc(1, 0);
        Ecc.QUARTILE = new _Ecc(2, 3);
        Ecc.HIGH = new _Ecc(3, 2);
        QrCode2.Ecc = Ecc;
    })(QrCode = qrcodegen2.QrCode || (qrcodegen2.QrCode = {}));
})($c8cf8cc7ac0beb95$var$qrcodegen || ($c8cf8cc7ac0beb95$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrSegment;
    ((QrSegment2)=>{
        const _Mode = class {
            constructor(modeBits, numBitsCharCount){
                this.modeBits = modeBits;
                this.numBitsCharCount = numBitsCharCount;
            }
            numCharCountBits(ver) {
                return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
            }
        };
        let Mode = _Mode;
        Mode.NUMERIC = new _Mode(1, [
            10,
            12,
            14
        ]);
        Mode.ALPHANUMERIC = new _Mode(2, [
            9,
            11,
            13
        ]);
        Mode.BYTE = new _Mode(4, [
            8,
            16,
            16
        ]);
        Mode.KANJI = new _Mode(8, [
            8,
            10,
            12
        ]);
        Mode.ECI = new _Mode(7, [
            0,
            0,
            0
        ]);
        QrSegment2.Mode = Mode;
    })(QrSegment = qrcodegen2.QrSegment || (qrcodegen2.QrSegment = {}));
})($c8cf8cc7ac0beb95$var$qrcodegen || ($c8cf8cc7ac0beb95$var$qrcodegen = {}));
var $c8cf8cc7ac0beb95$var$qrcodegen_default = $c8cf8cc7ac0beb95$var$qrcodegen;
// src/index.tsx
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */ var $c8cf8cc7ac0beb95$var$ERROR_LEVEL_MAP = {
    L: $c8cf8cc7ac0beb95$var$qrcodegen_default.QrCode.Ecc.LOW,
    M: $c8cf8cc7ac0beb95$var$qrcodegen_default.QrCode.Ecc.MEDIUM,
    Q: $c8cf8cc7ac0beb95$var$qrcodegen_default.QrCode.Ecc.QUARTILE,
    H: $c8cf8cc7ac0beb95$var$qrcodegen_default.QrCode.Ecc.HIGH
};
var $c8cf8cc7ac0beb95$var$DEFAULT_SIZE = 128;
var $c8cf8cc7ac0beb95$var$DEFAULT_LEVEL = "L";
var $c8cf8cc7ac0beb95$var$DEFAULT_BGCOLOR = "#FFFFFF";
var $c8cf8cc7ac0beb95$var$DEFAULT_FGCOLOR = "#000000";
var $c8cf8cc7ac0beb95$var$DEFAULT_INCLUDEMARGIN = false;
var $c8cf8cc7ac0beb95$var$MARGIN_SIZE = 4;
var $c8cf8cc7ac0beb95$var$DEFAULT_IMG_SCALE = 0.1;
function $c8cf8cc7ac0beb95$var$generatePath(modules, margin = 0) {
    const ops = [];
    modules.forEach(function(row, y) {
        let start = null;
        row.forEach(function(cell, x) {
            if (!cell && start !== null) {
                ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
                start = null;
                return;
            }
            if (x === row.length - 1) {
                if (!cell) return;
                if (start === null) ops.push(`M${x + margin},${y + margin} h1v1H${x + margin}z`);
                else ops.push(`M${start + margin},${y + margin} h${x + 1 - start}v1H${start + margin}z`);
                return;
            }
            if (cell && start === null) start = x;
        });
    });
    return ops.join("");
}
function $c8cf8cc7ac0beb95$var$excavateModules(modules, excavation) {
    return modules.slice().map((row, y)=>{
        if (y < excavation.y || y >= excavation.y + excavation.h) return row;
        return row.map((cell, x)=>{
            if (x < excavation.x || x >= excavation.x + excavation.w) return cell;
            return false;
        });
    });
}
function $c8cf8cc7ac0beb95$var$getImageSettings(cells, size, includeMargin, imageSettings) {
    if (imageSettings == null) return null;
    const margin = includeMargin ? $c8cf8cc7ac0beb95$var$MARGIN_SIZE : 0;
    const numCells = cells.length + margin * 2;
    const defaultSize = Math.floor(size * $c8cf8cc7ac0beb95$var$DEFAULT_IMG_SCALE);
    const scale = numCells / size;
    const w = (imageSettings.width || defaultSize) * scale;
    const h = (imageSettings.height || defaultSize) * scale;
    const x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
    const y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
    let excavation = null;
    if (imageSettings.excavate) {
        let floorX = Math.floor(x);
        let floorY = Math.floor(y);
        let ceilW = Math.ceil(w + x - floorX);
        let ceilH = Math.ceil(h + y - floorY);
        excavation = {
            x: floorX,
            y: floorY,
            w: ceilW,
            h: ceilH
        };
    }
    return {
        x: x,
        y: y,
        h: h,
        w: w,
        excavation: excavation
    };
}
var $c8cf8cc7ac0beb95$var$SUPPORTS_PATH2D = function() {
    try {
        new Path2D().addPath(new Path2D());
    } catch (e) {
        return false;
    }
    return true;
}();
function $c8cf8cc7ac0beb95$export$7e3713cf0c0fe9d0(props) {
    const _a = props, { value: value, size: size = $c8cf8cc7ac0beb95$var$DEFAULT_SIZE, level: level = $c8cf8cc7ac0beb95$var$DEFAULT_LEVEL, bgColor: bgColor = $c8cf8cc7ac0beb95$var$DEFAULT_BGCOLOR, fgColor: fgColor = $c8cf8cc7ac0beb95$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $c8cf8cc7ac0beb95$var$DEFAULT_INCLUDEMARGIN, style: style, imageSettings: imageSettings } = _a, otherProps = $c8cf8cc7ac0beb95$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "style",
        "imageSettings"
    ]);
    const imgSrc = imageSettings == null ? void 0 : imageSettings.src;
    const _canvas = (0, $h4Bez.useRef)(null);
    const _image = (0, $h4Bez.useRef)(null);
    const [isImgLoaded, setIsImageLoaded] = (0, $h4Bez.useState)(false);
    (0, $h4Bez.useEffect)(()=>{
        if (_canvas.current != null) {
            const canvas = _canvas.current;
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            let cells = $c8cf8cc7ac0beb95$var$qrcodegen_default.QrCode.encodeText(value, $c8cf8cc7ac0beb95$var$ERROR_LEVEL_MAP[level]).getModules();
            const margin = includeMargin ? $c8cf8cc7ac0beb95$var$MARGIN_SIZE : 0;
            const numCells = cells.length + margin * 2;
            const calculatedImageSettings = $c8cf8cc7ac0beb95$var$getImageSettings(cells, size, includeMargin, imageSettings);
            const image = _image.current;
            const haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;
            if (haveImageToRender) {
                if (calculatedImageSettings.excavation != null) cells = $c8cf8cc7ac0beb95$var$excavateModules(cells, calculatedImageSettings.excavation);
            }
            const pixelRatio = window.devicePixelRatio || 1;
            canvas.height = canvas.width = size * pixelRatio;
            const scale = size / numCells * pixelRatio;
            ctx.scale(scale, scale);
            ctx.fillStyle = bgColor;
            ctx.fillRect(0, 0, numCells, numCells);
            ctx.fillStyle = fgColor;
            if ($c8cf8cc7ac0beb95$var$SUPPORTS_PATH2D) ctx.fill(new Path2D($c8cf8cc7ac0beb95$var$generatePath(cells, margin)));
            else cells.forEach(function(row, rdx) {
                row.forEach(function(cell, cdx) {
                    if (cell) ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
                });
            });
            if (haveImageToRender) ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
        }
    });
    (0, $h4Bez.useEffect)(()=>{
        setIsImageLoaded(false);
    }, [
        imgSrc
    ]);
    const canvasStyle = $c8cf8cc7ac0beb95$var$__spreadValues({
        height: size,
        width: size
    }, style);
    let img = null;
    if (imgSrc != null) img = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("img", {
        src: imgSrc,
        key: imgSrc,
        style: {
            display: "none"
        },
        onLoad: ()=>{
            setIsImageLoaded(true);
        },
        ref: _image
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("canvas", $c8cf8cc7ac0beb95$var$__spreadValues({
        style: canvasStyle,
        height: size,
        width: size,
        ref: _canvas
    }, otherProps)), img);
}
function $c8cf8cc7ac0beb95$export$10307208e61210e9(props) {
    const _a = props, { value: value, size: size = $c8cf8cc7ac0beb95$var$DEFAULT_SIZE, level: level = $c8cf8cc7ac0beb95$var$DEFAULT_LEVEL, bgColor: bgColor = $c8cf8cc7ac0beb95$var$DEFAULT_BGCOLOR, fgColor: fgColor = $c8cf8cc7ac0beb95$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $c8cf8cc7ac0beb95$var$DEFAULT_INCLUDEMARGIN, imageSettings: imageSettings } = _a, otherProps = $c8cf8cc7ac0beb95$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "imageSettings"
    ]);
    let cells = $c8cf8cc7ac0beb95$var$qrcodegen_default.QrCode.encodeText(value, $c8cf8cc7ac0beb95$var$ERROR_LEVEL_MAP[level]).getModules();
    const margin = includeMargin ? $c8cf8cc7ac0beb95$var$MARGIN_SIZE : 0;
    const numCells = cells.length + margin * 2;
    const calculatedImageSettings = $c8cf8cc7ac0beb95$var$getImageSettings(cells, size, includeMargin, imageSettings);
    let image = null;
    if (imageSettings != null && calculatedImageSettings != null) {
        if (calculatedImageSettings.excavation != null) cells = $c8cf8cc7ac0beb95$var$excavateModules(cells, calculatedImageSettings.excavation);
        image = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("image", {
            xlinkHref: imageSettings.src,
            height: calculatedImageSettings.h,
            width: calculatedImageSettings.w,
            x: calculatedImageSettings.x + margin,
            y: calculatedImageSettings.y + margin,
            preserveAspectRatio: "none"
        });
    }
    const fgPath = $c8cf8cc7ac0beb95$var$generatePath(cells, margin);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("svg", $c8cf8cc7ac0beb95$var$__spreadValues({
        height: size,
        width: size,
        viewBox: `0 0 ${numCells} ${numCells}`
    }, otherProps), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("path", {
        fill: bgColor,
        d: `M0,0 h${numCells}v${numCells}H0z`,
        shapeRendering: "crispEdges"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement("path", {
        fill: fgColor,
        d: fgPath,
        shapeRendering: "crispEdges"
    }), image);
}
var $c8cf8cc7ac0beb95$export$2e2bcd8739ae039 = (props)=>{
    const _a = props, { renderAs: renderAs } = _a, otherProps = $c8cf8cc7ac0beb95$var$__objRest(_a, [
        "renderAs"
    ]);
    if (renderAs === "svg") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($c8cf8cc7ac0beb95$export$10307208e61210e9, $c8cf8cc7ac0beb95$var$__spreadValues({}, otherProps));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($h4Bez))).createElement($c8cf8cc7ac0beb95$export$7e3713cf0c0fe9d0, $c8cf8cc7ac0beb95$var$__spreadValues({}, otherProps));
};


parcelRequire("h4Bez");
var $86694586dead64c9$exports = {};
$86694586dead64c9$exports = $parcel$resolve("jWOtk");


const $8af41a648e2fa5a7$var$imageSize = 32;
const $8af41a648e2fa5a7$export$a77d98f00e648d58 = ({ size: size = 160, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c8cf8cc7ac0beb95$export$10307208e61210e9), {
        ...props,
        size: size,
        imageSettings: {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($86694586dead64c9$exports))),
            height: $8af41a648e2fa5a7$var$imageSize,
            width: $8af41a648e2fa5a7$var$imageSize,
            excavate: true
        }
    });






var $h4Bez = parcelRequire("h4Bez");

/**
 * Object with a set of instructions to convert a timespan into countdown digits
 */ const $9007db43a2391fe5$var$timeUnits = [
    {
        ignore: true,
        size: 1000
    },
    {
        ignore: false,
        size: 60
    },
    {
        ignore: false,
        size: 60
    },
    {
        ignore: false,
        size: 24
    }
];
const $9007db43a2391fe5$var$calculateRelativeTimeUnits = (value, unitsPaddingCount)=>{
    let timeLeft = value.getTime() - Date.now();
    const units = [];
    for (const { size: size, ignore: ignore } of $9007db43a2391fe5$var$timeUnits){
        if (timeLeft <= 0) break;
        const unitValue = timeLeft % size;
        if (!ignore) /** Value must no be ignored */ units.unshift(unitValue);
        timeLeft = (timeLeft - unitValue) / size;
    }
    const count = Math.max(units.length, unitsPaddingCount);
    const paddedUnits = [
        ...Array(count).fill(0),
        ...units
    ];
    return paddedUnits.slice(paddedUnits.length - count, paddedUnits.length);
};
const $9007db43a2391fe5$export$53819c0e58f98d49 = ({ value: value, unitsPaddingCount: unitsPaddingCount = 2 })=>{
    const [units, setUnits] = (0, $h4Bez.useState)(()=>$9007db43a2391fe5$var$calculateRelativeTimeUnits(value, unitsPaddingCount));
    (0, $076f55b7ca6ba74a$export$ede2eb47b82c13a2)(()=>setUnits($9007db43a2391fe5$var$calculateRelativeTimeUnits(value, unitsPaddingCount)), 1000, [
        value.getTime(),
        unitsPaddingCount
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
        children: units.map((part)=>String(part).padStart(2, '0')).join(':')
    });
};








var $h4Bez = parcelRequire("h4Bez");
/** `undefined` without a provider */ const $4cbbdab39f07fc39$var$RecordPanelOutletContext = /*#__PURE__*/ (0, $h4Bez.createContext)(undefined);
const $4cbbdab39f07fc39$export$6fdd3966acfaf7f2 = ({ outlet: outlet, children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($4cbbdab39f07fc39$var$RecordPanelOutletContext.Provider, {
        value: outlet,
        children: children
    });
const $4cbbdab39f07fc39$export$28b1fd6635048916 = ()=>(0, $h4Bez.useContext)($4cbbdab39f07fc39$var$RecordPanelOutletContext);




var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");












'use client';
function $4afea2d4eb954f7e$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $eb0aab3eb5dc2a90$export$2e2bcd8739ae039)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $4afea2d4eb954f7e$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $4afea2d4eb954f7e$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $4afea2d4eb954f7e$var$resolveContainer(containerProp);
    const transform = $4afea2d4eb954f7e$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4afea2d4eb954f7e$var$Slide = /*#__PURE__*/ $h4Bez.forwardRef(function Slide(props, ref) {
    const theme = (0, $cd99783e1cac2d84$export$2e2bcd8739ae039)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $fee6626576e0ac90$export$2e2bcd8739ae039), ...other } = props;
    const childrenRef = $h4Bez.useRef(null);
    const handleRef = (0, $6fa00ac7fde563d8$export$2e2bcd8739ae039)((0, $ba4f9121b652949b$export$2e2bcd8739ae039)(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $4afea2d4eb954f7e$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $93e522fc190a5b9f$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $93e522fc190a5b9f$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', {
            ...transitionProps
        });
        node.style.transition = theme.transitions.create('transform', {
            ...transitionProps
        });
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $93e522fc190a5b9f$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $4afea2d4eb954f7e$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $h4Bez.useCallback(()=>{
        if (childrenRef.current) $4afea2d4eb954f7e$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $h4Bez.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $c5f3fedd75c1d71e$export$2e2bcd8739ae039)(()=>{
            if (childrenRef.current) $4afea2d4eb954f7e$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $eb0aab3eb5dc2a90$export$2e2bcd8739ae039)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $h4Bez.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(TransitionComponent, {
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $h4Bez.cloneElement(children, {
                ref: handleRef,
                style: {
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...style,
                    ...children.props.style
                },
                ...restChildProps
            });
        }
    });
});
var $4afea2d4eb954f7e$export$2e2bcd8739ae039 = $4afea2d4eb954f7e$var$Slide;


var $h4Bez = parcelRequire("h4Bez");



'use client';
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $9fb34ef11c37be60$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $h4Bez.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $01a3a2b63fe8dafe$export$2e2bcd8739ae039)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $9fb34ef11c37be60$var$safeReact = {
    ...$h4Bez
};
const $9fb34ef11c37be60$var$maybeReactUseSyncExternalStore = $9fb34ef11c37be60$var$safeReact.useSyncExternalStore;
function $9fb34ef11c37be60$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $h4Bez.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $h4Bez.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $h4Bez.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $9fb34ef11c37be60$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $9fb34ef11c37be60$export$96d7927a982220b5(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $4609584b99dbdbe9$export$2e2bcd8739ae039)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $ada2059bb7e8f74d$export$2e2bcd8739ae039)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = $9fb34ef11c37be60$var$maybeReactUseSyncExternalStore !== undefined ? $9fb34ef11c37be60$var$useMediaQueryNew : $9fb34ef11c37be60$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $9fb34ef11c37be60$var$useMediaQuery = $9fb34ef11c37be60$export$96d7927a982220b5();
var $9fb34ef11c37be60$export$2e2bcd8739ae039 = $9fb34ef11c37be60$var$useMediaQuery;



const $ef7d21501e085d51$var$useMediaQuery = (0, $9fb34ef11c37be60$export$96d7927a982220b5)({
    themeId: (0, $3abbb2670cc8edff$export$2e2bcd8739ae039)
});
var $ef7d21501e085d51$export$2e2bcd8739ae039 = $ef7d21501e085d51$var$useMediaQuery;








const $754fff3a95ef867c$export$2b96349243a56116 = ()=>(0, $ef7d21501e085d51$export$2e2bcd8739ae039)((theme)=>theme.breakpoints.down('md'));




var $h4Bez = parcelRequire("h4Bez");







/** In px */ const $116d312d7f9d090a$var$MIN_WIDTH = 560;
/** Past this share of the outlet's width, letting go opens the page */ const $116d312d7f9d090a$var$SNAP_SHARE = 0.8;
/** In px: the snap point is never nearer, so a narrow outlet still leaves room to resize */ const $116d312d7f9d090a$var$SNAP_MIN_WIDTH = 640;
/** In px */ const $116d312d7f9d090a$var$KEY_STEP = 32;
/** In px: a press moving less than this, as a double click's jitter does, is no drag yet */ const $116d312d7f9d090a$var$DRAG_DEAD_ZONE = 4;
/** In px, centred on the panel's edge */ const $116d312d7f9d090a$var$HIT_WIDTH = 14;
/** In px */ const $116d312d7f9d090a$var$BAR_WIDTH = 4;
/** In px */ const $116d312d7f9d090a$var$BAR_HEIGHT = 40;
/** In px */ const $116d312d7f9d090a$var$BAR_HOVER_HEIGHT = 80;
const $116d312d7f9d090a$export$c2f74de4db729abe = 0;
const $116d312d7f9d090a$export$32a63717c7c12db7 = $116d312d7f9d090a$export$c2f74de4db729abe + 1;
const $116d312d7f9d090a$var$findSnapWidth = (outletWidth)=>Math.max(outletWidth * $116d312d7f9d090a$var$SNAP_SHARE, $116d312d7f9d090a$var$SNAP_MIN_WIDTH);
/** The widest the panel stays: up to the snap point when letting go there opens the page, else the outlet */ const $116d312d7f9d090a$var$findMaxWidth = (outletWidth, snaps)=>Math.floor(snaps ? Math.min(outletWidth, $116d312d7f9d090a$var$findSnapWidth(outletWidth)) : outletWidth);
const $116d312d7f9d090a$var$clampWidth = (width, maxWidth)=>Math.round(Math.min(maxWidth, Math.max($116d312d7f9d090a$var$MIN_WIDTH, width)));
const $116d312d7f9d090a$export$b4442c6bc39971b2 = (width, snaps)=>{
    const kept = `${Math.max($116d312d7f9d090a$var$MIN_WIDTH, width)}px`;
    return snaps ? `min(100%, ${kept}, max(${$116d312d7f9d090a$var$SNAP_SHARE * 100}%, ${$116d312d7f9d090a$var$SNAP_MIN_WIDTH}px))` : `min(100%, ${kept})`;
};
const $116d312d7f9d090a$var$gripStyle = (dragging)=>(theme)=>{
        const bar = (height, color)=>({
                height: height,
                backgroundColor: color
            });
        return {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: `${-$116d312d7f9d090a$var$HIT_WIDTH / 2}px`,
            zIndex: $116d312d7f9d090a$export$32a63717c7c12db7,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: `${$116d312d7f9d090a$var$HIT_WIDTH}px`,
            cursor: (0, $fa3f09262d9686d4$export$380fc35952b6395a),
            touchAction: 'none',
            '&::after': {
                content: '""',
                width: `${$116d312d7f9d090a$var$BAR_WIDTH}px`,
                borderRadius: `${$116d312d7f9d090a$var$BAR_WIDTH / 2}px`,
                transition: dragging ? 'none' : theme.transitions.create([
                    'height',
                    'background-color'
                ], {
                    duration: theme.transitions.duration.shorter
                }),
                ...dragging ? bar('100%', theme.palette.primary.main) : bar(`${$116d312d7f9d090a$var$BAR_HEIGHT}px`, theme.palette.grey[300])
            },
            '&:hover::after': dragging ? {} : bar(`${$116d312d7f9d090a$var$BAR_HOVER_HEIGHT}px`, theme.palette.primary.main),
            '&:focus-visible': (0, $5f78a8132f139ecb$export$5fabbec8f6ea1c3f)(theme),
            '@media (prefers-reduced-motion: reduce)': {
                '&::after': {
                    transition: 'none'
                }
            }
        };
    };
const $116d312d7f9d090a$var$measure = (grip)=>{
    const panel = grip?.parentElement;
    const outlet = panel?.parentElement;
    (0, $14eddac5f20c576c$export$a7a9523472993e97)(panel && outlet, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'A record panel grip must be inside its panel, inside its outlet'));
    return {
        width: panel.getBoundingClientRect().width,
        outletWidth: outlet.getBoundingClientRect().width
    };
};
const $116d312d7f9d090a$export$f1c36f6a7e5dd03 = ({ drag: drag, widthStyle: widthStyle, onExpand: onExpand, onDrag: onDrag, onWidthChange: onWidthChange })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const ref = (0, $h4Bez.useRef)(null);
    const dragRef = (0, $h4Bez.useRef)(null);
    const [dragging, setDragging] = (0, $h4Bez.useState)(false);
    const [bounds, setBounds] = (0, $h4Bez.useState)(null);
    const snaps = onExpand !== undefined;
    (0, $fa3f09262d9686d4$export$3044d9fa820d116a)(dragging);
    const remeasure = (0, $h4Bez.useCallback)(()=>{
        const next = $116d312d7f9d090a$var$measure(ref.current);
        setBounds((previous)=>previous?.width === next.width && previous.outletWidth === next.outletWidth ? previous : next);
    }, []);
    (0, $h4Bez.useLayoutEffect)(remeasure, [
        remeasure,
        widthStyle
    ]);
    (0, $h4Bez.useEffect)(()=>{
        window.addEventListener('resize', remeasure);
        return ()=>window.removeEventListener('resize', remeasure);
    }, [
        remeasure
    ]);
    /** Unmounted mid-drag, the panel would otherwise keep the uncommitted width */ (0, $h4Bez.useEffect)(()=>{
        if (!dragging) return;
        return ()=>{
            if (dragRef.current) onDrag(null);
        };
    }, [
        dragging
    ]);
    const findDrag = (event)=>dragRef.current?.pointerId === event.pointerId ? dragRef.current : null;
    const end = ()=>{
        dragRef.current = null;
        setDragging(false);
        onDrag(null);
    };
    const onPointerDown = (event)=>{
        if (event.button !== 0 || !event.isPrimary || dragRef.current) return;
        /** Keeps the press from selecting text or moving the focus */ event.preventDefault();
        event.currentTarget.setPointerCapture(event.pointerId);
        dragRef.current = {
            pointerId: event.pointerId,
            startX: event.clientX,
            start: $116d312d7f9d090a$var$measure(ref.current),
            moved: null
        };
        setDragging(true);
    };
    const onPointerMove = (event)=>{
        const active = findDrag(event);
        if (!active) return;
        /** No button pressed anymore means the release was missed, so the drag is over, uncommitted */ if (event.buttons === 0) {
            end();
            return;
        }
        /** The panel's right edge stays put, so moving left widens it */ const offset = active.startX - event.clientX;
        if (active.moved === null && Math.abs(offset) < $116d312d7f9d090a$var$DRAG_DEAD_ZONE) return;
        const { width: width, outletWidth: outletWidth } = active.start;
        const wanted = width + offset;
        const snapping = snaps && wanted > $116d312d7f9d090a$var$findSnapWidth(outletWidth);
        active.moved = {
            width: snapping ? outletWidth : $116d312d7f9d090a$var$clampWidth(wanted, $116d312d7f9d090a$var$findMaxWidth(outletWidth, snaps)),
            snapping: snapping
        };
        onDrag(active.moved);
    };
    const onPointerUp = (event)=>{
        const active = findDrag(event);
        if (!active) return;
        const { moved: moved } = active;
        end();
        if (moved?.snapping) onExpand?.();
        else if (moved) onWidthChange(moved.width);
    };
    /** A cancel, or a capture lost without a release, ends the drag uncommitted; after a release there's no drag left to end */ const onInterrupt = (event)=>{
        if (findDrag(event)) end();
    };
    const onKeyDown = (event)=>{
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        if (event.key === 'Enter' || event.key === ' ') {
            /** The separator has no action, and nothing else should take one from it */ event.preventDefault();
            return;
        }
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const { width: width, outletWidth: outletWidth } = $116d312d7f9d090a$var$measure(ref.current);
        const next = $116d312d7f9d090a$var$clampWidth(width + (event.key === 'ArrowLeft' ? $116d312d7f9d090a$var$KEY_STEP : -$116d312d7f9d090a$var$KEY_STEP), $116d312d7f9d090a$var$findMaxWidth(outletWidth, snaps));
        if (next !== Math.round(width)) onWidthChange(next);
    };
    const maxWidth = bounds ? $116d312d7f9d090a$var$findMaxWidth(bounds.outletWidth, snaps) : undefined;
    /** While snapping, the panel shows the outlet's width, but the widest it would keep is the maximum */ const value = drag ? drag.snapping && maxWidth !== undefined ? maxWidth : drag.width : bounds ? Math.round(bounds.width) : undefined;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                ref: ref,
                "data-testid": "record-panel-grip",
                role: "separator",
                tabIndex: 0,
                "aria-orientation": "vertical",
                "aria-label": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).RECORD_PANEL_WIDTH),
                "aria-valuenow": value,
                "aria-valuetext": value === undefined ? undefined : translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).RECORD_PANEL_WIDTH_VALUE, {
                    width: value
                }),
                "aria-valuemin": $116d312d7f9d090a$var$MIN_WIDTH,
                "aria-valuemax": maxWidth,
                sx: $116d312d7f9d090a$var$gripStyle(dragging),
                onPointerDown: onPointerDown,
                onPointerMove: onPointerMove,
                onPointerUp: onPointerUp,
                onPointerCancel: onInterrupt,
                onLostPointerCapture: onInterrupt,
                onDoubleClick: ()=>onWidthChange(null),
                onKeyDown: onKeyDown,
                onFocus: remeasure
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                "data-testid": "record-panel-snap-status",
                role: "status",
                sx: (0, $7e4b04c742d6c9ba$export$2e2bcd8739ae039),
                children: drag?.snapping ? translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).RECORD_PANEL_SNAP) : null
            })
        ]
    });
};




var $h4Bez = parcelRequire("h4Bez");

const $7c538ae6f8702809$var$KEY_OWNING_ROLES = [
    'dialog',
    'menu',
    'menubar',
    'listbox',
    'combobox',
    'tree',
    'grid',
    'treegrid',
    'tablist',
    'radiogroup',
    'spinbutton',
    'slider'
];
/**
 * Elements that use the keys themselves. A modal's own root counts too: our dialogs disable their Escape,
 * and the focus can rest on a dialog's or popover's container, outside its `role="dialog"`
 */ const $7c538ae6f8702809$var$KEY_OWNING_SELECTOR = [
    'input',
    'textarea',
    'select',
    '[contenteditable]:not([contenteditable="false"])',
    ...$7c538ae6f8702809$var$KEY_OWNING_ROLES.map((role)=>`[role="${role}"]`),
    `.${(0, $e372142bb6242c60$export$2e2bcd8739ae039).root}`
].join(', ');
/** Shift+Enter has a meaning of its own on these, e.g. a new window for a link */ const $7c538ae6f8702809$var$INTERACTIVE_SELECTOR = 'a[href], button, [role="button"]';
const $7c538ae6f8702809$var$closest = (target, selector)=>target instanceof Element ? target.closest(selector) : null;
const $7c538ae6f8702809$var$findShortcutHandler = (event, { onPrevious: onPrevious, onNext: onNext, onExpand: onExpand, onClose: onClose }, header)=>{
    if (event.defaultPrevented || event.repeat || event.altKey || event.ctrlKey || event.metaKey || $7c538ae6f8702809$var$closest(event.target, $7c538ae6f8702809$var$KEY_OWNING_SELECTOR)) return undefined;
    if (event.shiftKey) {
        const control = $7c538ae6f8702809$var$closest(event.target, $7c538ae6f8702809$var$INTERACTIVE_SELECTOR);
        const isOtherControl = control !== null && !header?.contains(control);
        return event.key === 'Enter' && !isOtherControl ? onExpand : undefined;
    }
    switch(event.key){
        case 'ArrowUp':
            return onPrevious;
        case 'ArrowDown':
            return onNext;
        case 'Escape':
            return onClose;
        default:
            return undefined;
    }
};
const $7c538ae6f8702809$export$f5e28678ff5d127f = (enabled, handlers, header)=>{
    const handlersRef = (0, $h4Bez.useRef)(handlers);
    (0, $h4Bez.useLayoutEffect)(()=>{
        handlersRef.current = handlers;
    });
    (0, $h4Bez.useEffect)(()=>{
        if (!enabled) return;
        const onKeyDown = (event)=>{
            const handler = $7c538ae6f8702809$var$findShortcutHandler(event, handlersRef.current, header.current);
            if (handler) {
                event.preventDefault();
                handler();
            }
        };
        document.addEventListener('keydown', onKeyDown);
        return ()=>document.removeEventListener('keydown', onKeyDown);
    }, [
        enabled,
        header
    ]);
};


const $2dbb652f558165cf$var$MIN_WIDTH = 600;
const $2dbb652f558165cf$var$MAX_WIDTH = 720;
/** In vw */ const $2dbb652f558165cf$var$PREFERRED_WIDTH = 33;
const $2dbb652f558165cf$var$HEADER_HEIGHT = 28;
/** In px */ const $2dbb652f558165cf$var$SNAP_OUTLINE_WIDTH = 2;
/** In px: fully rounds the ends of a one-line pill */ const $2dbb652f558165cf$var$PILL_RADIUS = 999;
const $2dbb652f558165cf$var$REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
const $2dbb652f558165cf$var$panelStyle = {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: (theme)=>theme.zIndex.appBar,
    width: {
        xs: '100%',
        md: `min(100%, clamp(${$2dbb652f558165cf$var$MIN_WIDTH}px, ${$2dbb652f558165cf$var$PREFERRED_WIDTH}vw, ${$2dbb652f558165cf$var$MAX_WIDTH}px))`
    },
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    py: 6,
    px: 4,
    boxShadow: (0, $190611ecca6afed0$export$5db70ad5f005c786)
};
/** Letting go would open the page */ const $2dbb652f558165cf$var$snappingStyle = (theme)=>({
        outline: `${$2dbb652f558165cf$var$SNAP_OUTLINE_WIDTH}px solid ${theme.palette.primary.main}`,
        outlineOffset: `${-$2dbb652f558165cf$var$SNAP_OUTLINE_WIDTH}px`
    });
const $2dbb652f558165cf$var$snapPillStyle = {
    position: 'absolute',
    top: 3,
    left: '50%',
    zIndex: (0, $116d312d7f9d090a$export$32a63717c7c12db7),
    transform: 'translateX(-50%)',
    px: 3,
    py: 1,
    borderRadius: `${$2dbb652f558165cf$var$PILL_RADIUS}px`,
    bgcolor: 'primary.700',
    color: 'common.white',
    whiteSpace: 'nowrap',
    pointerEvents: 'none'
};
const $2dbb652f558165cf$var$headerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    height: `${$2dbb652f558165cf$var$HEADER_HEIGHT}px`,
    flexShrink: 0
};
const $2dbb652f558165cf$var$titleStyle = {
    flex: 1,
    minWidth: 0,
    color: 'grey.900'
};
const $2dbb652f558165cf$var$positionStyle = {
    color: 'grey.500',
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap'
};
const $2dbb652f558165cf$var$bodyStyle = {
    position: 'relative',
    zIndex: (0, $116d312d7f9d090a$export$c2f74de4db729abe),
    flex: 1,
    minHeight: 0,
    overflowY: 'auto'
};
const $2dbb652f558165cf$var$withFixedStrategy = (popper)=>({
        ...popper,
        popperOptions: {
            ...popper?.popperOptions,
            strategy: 'fixed'
        }
    });
/**
 * A tooltip's popper is absolutely positioned in the document's body, outside the outlet's clipping: one shown while the panel slid out followed its anchor
 * past the page's edge and the page's scrollbars flashed. A fixed popper can't extend the page.
 */ const $2dbb652f558165cf$var$withFixedTooltips = (outerTheme)=>{
    const tooltip = outerTheme.components?.MuiTooltip;
    const defaultProps = tooltip?.defaultProps;
    const popper = defaultProps?.slotProps?.popper;
    return {
        ...outerTheme,
        components: {
            ...outerTheme.components,
            MuiTooltip: {
                ...tooltip,
                defaultProps: {
                    ...defaultProps,
                    slotProps: {
                        ...defaultProps?.slotProps,
                        popper: typeof popper === 'function' ? (ownerState)=>$2dbb652f558165cf$var$withFixedStrategy(popper(ownerState)) : $2dbb652f558165cf$var$withFixedStrategy(popper)
                    }
                }
            }
        }
    };
};
const $2dbb652f558165cf$var$keyShortcuts = {
    previous: 'ArrowUp',
    next: 'ArrowDown',
    expand: 'Shift+Enter',
    close: 'Escape'
};
const $2dbb652f558165cf$var$HeaderButton = ({ action: action, icon: icon, onClick: onClick })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $69cdbe69cde47e02$export$2e2bcd8739ae039), {
        title: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).RECORD_PANEL_ACTION_TOOLTIP, {
            action: action
        }),
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
            "data-testid": `record-panel-${action}`,
            variant: "ghost",
            size: "small",
            "aria-label": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).RECORD_PANEL_ACTION, {
                action: action
            }),
            "aria-keyshortcuts": $2dbb652f558165cf$var$keyShortcuts[action],
            "aria-disabled": onClick ? undefined : true,
            onClick: onClick,
            children: icon
        })
    });
};
const $2dbb652f558165cf$export$ab5c4b9e4514633f = ({ open: open, title: title, position: position, onPrevious: onPrevious, onNext: onNext, onExpand: onExpand, onClose: onClose, onExited: onExited, width: width, onWidthChange: onWidthChange, children: children })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const outlet = (0, $4cbbdab39f07fc39$export$28b1fd6635048916)();
    const titleId = (0, $h4Bez.useId)();
    const isMobile = (0, $754fff3a95ef867c$export$2b96349243a56116)();
    const reducedMotion = (0, $ef7d21501e085d51$export$2e2bcd8739ae039)($2dbb652f558165cf$var$REDUCED_MOTION_QUERY);
    const shownOnExpand = isMobile ? undefined : onExpand;
    const headerRef = (0, $h4Bez.useRef)(null);
    const [drag, setDrag] = (0, $h4Bez.useState)(null);
    (0, $7c538ae6f8702809$export$f5e28678ff5d127f)(open && outlet !== null, {
        onPrevious: onPrevious,
        onNext: onNext,
        onExpand: shownOnExpand,
        onClose: onClose
    }, headerRef);
    const widthStyle = isMobile ? undefined : drag ? `${drag.width}px` : typeof width === 'number' ? (0, $116d312d7f9d090a$export$b4442c6bc39971b2)(width, shownOnExpand !== undefined) : undefined;
    /** Waits for the outlet rather than mounting in place first and then again in it */ if (outlet === null) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8653e21686aeef13$export$2e2bcd8739ae039), {
        container: outlet,
        disablePortal: outlet === undefined,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4afea2d4eb954f7e$export$2e2bcd8739ae039), {
            in: open,
            direction: "left",
            timeout: reducedMotion ? 0 : undefined,
            mountOnEnter: true,
            unmountOnExit: true,
            onExited: onExited,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
                "data-testid": "record-panel",
                component: "section",
                "aria-labelledby": titleId,
                "aria-roledescription": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).RECORD_PANEL),
                square: true,
                elevation: 0,
                style: widthStyle === undefined ? undefined : {
                    width: widthStyle
                },
                sx: [
                    $2dbb652f558165cf$var$panelStyle,
                    drag?.snapping === true && $2dbb652f558165cf$var$snappingStyle
                ],
                children: [
                    open && !isMobile && onWidthChange && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $116d312d7f9d090a$export$f1c36f6a7e5dd03), {
                        drag: drag,
                        widthStyle: widthStyle,
                        onExpand: shownOnExpand,
                        onDrag: setDrag,
                        onWidthChange: onWidthChange
                    }),
                    drag?.snapping && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        "data-testid": "record-panel-snap",
                        "aria-hidden": true,
                        variant: "caption",
                        sx: $2dbb652f558165cf$var$snapPillStyle,
                        children: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).RECORD_PANEL_SNAP)
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $bed3dc7f03d1e028$export$2e2bcd8739ae039), {
                        theme: $2dbb652f558165cf$var$withFixedTooltips,
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                                ref: headerRef,
                                sx: $2dbb652f558165cf$var$headerStyle,
                                children: [
                                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                                        id: titleId,
                                        "data-testid": "record-panel-title",
                                        component: "h2",
                                        variant: "subtitle2",
                                        noWrap: true,
                                        sx: $2dbb652f558165cf$var$titleStyle,
                                        children: title
                                    }),
                                    position && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                                        "data-testid": "record-panel-position",
                                        variant: "caption",
                                        sx: $2dbb652f558165cf$var$positionStyle,
                                        children: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).RECORD_PANEL_POSITION, {
                                            index: position.index + 1,
                                            total: position.total
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($2dbb652f558165cf$var$HeaderButton, {
                                        action: "previous",
                                        icon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5200a8ede5ccc875$export$7f01a6cbee61a0f2), {}),
                                        onClick: onPrevious
                                    }),
                                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($2dbb652f558165cf$var$HeaderButton, {
                                        action: "next",
                                        icon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $024b35d06a10e12d$export$4857d3f3f5f8319b), {}),
                                        onClick: onNext
                                    }),
                                    shownOnExpand && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($2dbb652f558165cf$var$HeaderButton, {
                                        action: "expand",
                                        icon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ec178a7cbf24362e$export$ad8cd11d6f0ad24c), {}),
                                        onClick: shownOnExpand
                                    }),
                                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($2dbb652f558165cf$var$HeaderButton, {
                                        action: "close",
                                        icon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b9a3c6876c67d06c$export$cae179f078f4b4a4), {}),
                                        onClick: onClose
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                                "data-testid": "record-panel-body",
                                sx: $2dbb652f558165cf$var$bodyStyle,
                                children: children
                            })
                        ]
                    })
                ]
            })
        })
    });
};












var $h4Bez = parcelRequire("h4Bez");




var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");

const $413f2a7a2fb550d0$export$ddc16e8131368fb8 = ()=>{
    const droppable = (0, $h4Bez.useMemo)(()=>new (0, $092680ba287ef87d$export$423ec2075359570a)(), []);
    (0, $h4Bez.useEffect)(()=>{
        /**
         * When unhooked, drop it
         */ return ()=>droppable.drop();
    }, []);
    return droppable;
};
const $413f2a7a2fb550d0$export$3f0971de8b5ae96c = ()=>{
    const droppable = $413f2a7a2fb550d0$export$ddc16e8131368fb8();
    return (callback)=>droppable.ifNotDropped(callback);
};




const $13b0dee6e916241c$export$fbeb804c371ac8d = (asyncCallback, dep = [])=>{
    /**
     * This is here to make sure once things are unhooked they are no longer updated
     */ const ifHooked = (0, $413f2a7a2fb550d0$export$3f0971de8b5ae96c)();
    const [[isLoading, value], setState] = (0, $h4Bez.useState)([
        false,
        null
    ]);
    const callback = (0, $h4Bez.useCallback)((...args)=>{
        if (isLoading) return;
        /**
             * Mark that the execution has started
             */ ifHooked(()=>setState(([, lastValue])=>[
                    true,
                    lastValue
                ]));
        asyncCallback(...args)/**
                 * All good, update with the status and response
                 */ .then((r)=>ifHooked(()=>setState([
                    false,
                    r
                ])))/**
                 * Catch any errors and update the state
                 */ .catch((e)=>ifHooked(()=>setState([
                    false,
                    e
                ])));
    }, [
        ...dep,
        isLoading
    ]);
    return [
        callback,
        isLoading,
        value
    ];
};







const $91eb1f6e6d619b7d$var$wrapperStyle = {
    display: 'flex'
};
const $91eb1f6e6d619b7d$var$addStyle = {
    ml: 'auto'
};
const $91eb1f6e6d619b7d$export$d0265b2c425512d6 = ()=>{
    const ref = /*#__PURE__*/ (0, $h4Bez.createRef)();
    const addCertificate = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('addCertificateUsecase');
    const [onChange, loading, value] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)((files)=>(0, $2371d85f76b63637$export$925a4c3537ec7ca4)(files).then((content)=>content ? addCertificate.add(content) : Promise.resolve()), [
        addCertificate
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $91eb1f6e6d619b7d$var$wrapperStyle,
        className: "add-certificate",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                sx: $91eb1f6e6d619b7d$var$addStyle,
                size: "large",
                variant: "primary",
                title: (0, $c3e1b746ad236797$export$8d524fb6540252df).is(value) ? value.message : undefined,
                startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ec5894a60f9e2c5f$export$a6b7c34d56975de0), {}),
                endIcon: (0, $c3e1b746ad236797$export$8d524fb6540252df).is(value) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b535488bb7f5202c$export$25c6e96bbb971c7c), {
                    "data-testid": "new-certificate-error",
                    color: "error"
                }),
                onClick: (0, $1fdb53e1bec07519$export$a5a34735bf65cdae)(ref),
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ADD_CERTIFICATE
                    }),
                    loading && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2db76c9e9f88b3ff$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f81bd50c14cd4ce4$export$f0b9a6b1089d086a), {
                ref: ref,
                onChange: onChange
            })
        ]
    });
};




var $h4Bez = parcelRequire("h4Bez");


var $h4Bez = parcelRequire("h4Bez");










const $9681068affa45d17$export$f1ce4856483bd995 = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
const $9681068affa45d17$export$e04173f1577f18b7 = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $9681068affa45d17$export$f1ce4856483bd995(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};


function $69a61584c01358c6$var$getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function $69a61584c01358c6$var$getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const $69a61584c01358c6$var$selfColumnsVar = '--Grid-columns';
const $69a61584c01358c6$var$parentColumnsVar = '--Grid-parent-columns';
const $69a61584c01358c6$export$84053369756c53db = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $9681068affa45d17$export$e04173f1577f18b7)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${$69a61584c01358c6$var$parentColumnsVar}) - (var(${$69a61584c01358c6$var$parentColumnsVar}) - ${value}) * (var(${$69a61584c01358c6$var$getParentSpacingVar('column')}) / var(${$69a61584c01358c6$var$parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $69a61584c01358c6$export$c1d4f281314969c2 = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $9681068affa45d17$export$e04173f1577f18b7)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${$69a61584c01358c6$var$parentColumnsVar}) + var(${$69a61584c01358c6$var$getParentSpacingVar('column')}) * ${value} / var(${$69a61584c01358c6$var$parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $69a61584c01358c6$export$ccc4d4a4923f1b06 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [$69a61584c01358c6$var$selfColumnsVar]: 12
    };
    (0, $9681068affa45d17$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [$69a61584c01358c6$var$selfColumnsVar]: columns,
            '> *': {
                [$69a61584c01358c6$var$parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
const $69a61584c01358c6$export$68c4dad72dd49c74 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $9681068affa45d17$export$e04173f1577f18b7)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$69a61584c01358c6$var$getSelfSpacingVar('row')]: spacing,
            '> *': {
                [$69a61584c01358c6$var$getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
const $69a61584c01358c6$export$a89c28919b8e3bb5 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $9681068affa45d17$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$69a61584c01358c6$var$getSelfSpacingVar('column')]: spacing,
            '> *': {
                [$69a61584c01358c6$var$getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
const $69a61584c01358c6$export$2a0a3c01032b3f4 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $9681068affa45d17$export$e04173f1577f18b7)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
const $69a61584c01358c6$export$810b8c3ab5d46bf = ({ ownerState: ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${$69a61584c01358c6$var$getSelfSpacingVar('row')}) var(${$69a61584c01358c6$var$getSelfSpacingVar('column')})`
        }
    };
};
const $69a61584c01358c6$export$e2d1175061442d38 = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
const $69a61584c01358c6$export$6c7087d27c3329d3 = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
const $69a61584c01358c6$export$a7c8efbe2b138a60 = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};


const $0135b5104bcf838f$var$getLegacyGridWarning = (propName)=>{
    if ([
        'item',
        'zeroMinWidth'
    ].includes(propName)) return `The \`${propName}\` prop has been removed and is no longer necessary. You can safely remove it.`;
    // #host-reference
    return `The \`${propName}\` prop has been removed. See https://mui.com/material-ui/migration/upgrade-to-grid-v2/ for migration instructions.`;
};
const $0135b5104bcf838f$var$warnedAboutProps = [];
function $0135b5104bcf838f$export$2e2bcd8739ae039(props, breakpoints) {
    const propsToWarn = [];
    if (props.item !== undefined) {
        delete props.item;
        propsToWarn.push('item');
    }
    if (props.zeroMinWidth !== undefined) {
        delete props.zeroMinWidth;
        propsToWarn.push('zeroMinWidth');
    }
    breakpoints.keys.forEach((breakpoint)=>{
        if (props[breakpoint] !== undefined) {
            propsToWarn.push(breakpoint);
            delete props[breakpoint];
        }
    });
    var prop;
}



'use client';
const $e183b78a8b883585$var$defaultTheme = (0, $32d258d0759a439a$export$2e2bcd8739ae039)();
// widening Theme to any so that the consumer can own the theme structure.
const $e183b78a8b883585$var$defaultCreateStyledComponent = (0, $93c004e5d2e4907b$export$2e2bcd8739ae039)('div', {
    name: 'MuiGrid',
    slot: 'Root'
});
function $e183b78a8b883585$var$useThemePropsDefault(props) {
    return (0, $613bf551b55aae32$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiGrid',
        defaultTheme: $e183b78a8b883585$var$defaultTheme
    });
}
function $e183b78a8b883585$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $e183b78a8b883585$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $e183b78a8b883585$var$useThemePropsDefault, useTheme: useTheme = (0, $f8416c9663895cb7$export$2e2bcd8739ae039), componentName: componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, size: size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, $69a61584c01358c6$export$a7c8efbe2b138a60)(direction),
                ...(0, $69a61584c01358c6$export$e2d1175061442d38)(size),
                ...container ? (0, $69a61584c01358c6$export$6c7087d27c3329d3)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (slot)=>(0, $6b55eb7835363b92$export$2e2bcd8739ae039)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent((0, $69a61584c01358c6$export$ccc4d4a4923f1b06), (0, $69a61584c01358c6$export$a89c28919b8e3bb5), (0, $69a61584c01358c6$export$68c4dad72dd49c74), (0, $69a61584c01358c6$export$84053369756c53db), (0, $69a61584c01358c6$export$2a0a3c01032b3f4), (0, $69a61584c01358c6$export$810b8c3ab5d46bf), (0, $69a61584c01358c6$export$c1d4f281314969c2));
    const Grid = /*#__PURE__*/ $h4Bez.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = (0, $348688587c50d45e$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        // TODO v8: Remove when removing the legacy Grid component
        (0, $0135b5104bcf838f$export$2e2bcd8739ae039)(props, theme.breakpoints);
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = 'div', direction: direction = 'row', wrap: wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $b4ceee382bf9d5af$export$2e2bcd8739ae039)(classes.root, className),
            ...other,
            children: $h4Bez.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $h4Bez.isValidElement(child) && (0, $3e397a3d4c91f25d$export$2e2bcd8739ae039)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ $h4Bez.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}






'use client';
/**
 *
 * Demos:
 *
 * - [Grid](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/material-ui/api/grid/)
 */ const $98bfbe695b65cf7e$var$Grid = (0, $e183b78a8b883585$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
        name: 'MuiGrid',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                ownerState.container && styles.container
            ];
        }
    }),
    componentName: 'MuiGrid',
    useThemeProps: (inProps)=>(0, $16527687018ae2c4$export$2440da353cedad43)({
            props: inProps,
            name: 'MuiGrid'
        }),
    useTheme: $cd99783e1cac2d84$export$2e2bcd8739ae039
});
var $98bfbe695b65cf7e$export$2e2bcd8739ae039 = $98bfbe695b65cf7e$var$Grid;




"use client";
var $0c1414221f308967$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');



"use client";
var $f0c56636e9fb6837$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');










var $h4Bez = parcelRequire("h4Bez");





parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");







function $f67f6f2342b0ac69$export$5e57a444791c63be(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiDialogActions', slot);
}
const $f67f6f2342b0ac69$var$dialogActionsClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $f67f6f2342b0ac69$export$2e2bcd8739ae039 = $f67f6f2342b0ac69$var$dialogActionsClasses;



'use client';
const $12b0eeebf4fed103$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $f67f6f2342b0ac69$export$5e57a444791c63be), classes);
};
const $12b0eeebf4fed103$var$DialogActionsRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $12b0eeebf4fed103$var$DialogActions = /*#__PURE__*/ $h4Bez.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $12b0eeebf4fed103$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($12b0eeebf4fed103$var$DialogActionsRoot, {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $12b0eeebf4fed103$export$2e2bcd8739ae039 = $12b0eeebf4fed103$var$DialogActions;


var $h4Bez = parcelRequire("h4Bez");








function $caa422a8778ea536$export$61b0ee1f05fb344e(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiDialogContent', slot);
}
const $caa422a8778ea536$var$dialogContentClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $caa422a8778ea536$export$2e2bcd8739ae039 = $caa422a8778ea536$var$dialogContentClasses;




function $f910927ad5d8f0c3$export$f5d2ec7e4c47e088(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiDialogTitle', slot);
}
const $f910927ad5d8f0c3$var$dialogTitleClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiDialogTitle', [
    'root'
]);
var $f910927ad5d8f0c3$export$2e2bcd8739ae039 = $f910927ad5d8f0c3$var$dialogTitleClasses;



'use client';
const $0aa27c46708d7ed8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $caa422a8778ea536$export$61b0ee1f05fb344e), classes);
};
const $0aa27c46708d7ed8$var$DialogContentRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.dividers,
                style: {
                    padding: '16px 24px',
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dividers,
                style: {
                    [`.${(0, $f910927ad5d8f0c3$export$2e2bcd8739ae039).root} + &`]: {
                        paddingTop: 0
                    }
                }
            }
        ]
    })));
const $0aa27c46708d7ed8$var$DialogContent = /*#__PURE__*/ $h4Bez.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false, ...other } = props;
    const ownerState = {
        ...props,
        dividers: dividers
    };
    const classes = $0aa27c46708d7ed8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($0aa27c46708d7ed8$var$DialogContentRoot, {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $0aa27c46708d7ed8$export$2e2bcd8739ae039 = $0aa27c46708d7ed8$var$DialogContent;


var $h4Bez = parcelRequire("h4Bez");









'use client';
const $dfd39f6bb0de9c2f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $f910927ad5d8f0c3$export$f5d2ec7e4c47e088), classes);
};
const $dfd39f6bb0de9c2f$var$DialogTitleRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root'
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $dfd39f6bb0de9c2f$var$DialogTitle = /*#__PURE__*/ $h4Bez.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp, ...other } = props;
    const ownerState = props;
    const classes = $dfd39f6bb0de9c2f$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $h4Bez.useContext((0, $a33cb60cc787889f$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($dfd39f6bb0de9c2f$var$DialogTitleRoot, {
        component: "h2",
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp ?? titleId,
        ...other
    });
});
var $dfd39f6bb0de9c2f$export$2e2bcd8739ae039 = $dfd39f6bb0de9c2f$var$DialogTitle;







const $6dad3b57b5f21163$var$errorMessageStyle = {
    width: '100%'
};
const $6dad3b57b5f21163$var$dialogTitleStyle = {
    mb: 0
};
const $6dad3b57b5f21163$export$ad2a94d527926c21 = ({ certificate: certificate, confirmation: confirmation, confirmable: confirmable, onConfirm: onConfirm, onClose: onClose, children: children })=>{
    const title = (0, $aadfb82b994af9ea$export$5ace278d59015300)(certificate);
    const [confirm, isLoading, result] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(async ()=>{
        await onConfirm?.();
        onClose();
    }, [
        onConfirm
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $55a2a796d4e0875c$export$2e2bcd8739ae039), {
        maxWidth: "md",
        fullWidth: true,
        open: true,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dfd39f6bb0de9c2f$export$2e2bcd8739ae039), {
                sx: $6dad3b57b5f21163$var$dialogTitleStyle,
                variant: "body1",
                paragraph: true,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CERTIFICATE_VIEWER_TITLE,
                    values: {
                        title: title
                    }
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0aa27c46708d7ed8$export$2e2bcd8739ae039), {
                dividers: true,
                children: children
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $12b0eeebf4fed103$export$2e2bcd8739ae039), {
                children: [
                    isLoading && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $95388f9578043f1e$export$2e2bcd8739ae039), {
                        size: 20
                    }),
                    (0, $c3e1b746ad236797$export$8d524fb6540252df).is(result) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
                        sx: $6dad3b57b5f21163$var$errorMessageStyle,
                        "data-testid": "certificate-deletion-error",
                        error: result,
                        titleVariant: "body2",
                        extras: "popover"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                        variant: "secondary",
                        onClick: onClose,
                        "data-testid": "certificate-cancel-button",
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CLOSE
                        })
                    }),
                    confirmation && onConfirm && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                        "data-testid": "certificate-confirmation-button",
                        variant: "danger",
                        disabled: isLoading || confirmable === false,
                        onClick: confirm,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: confirmation
                        })
                    })
                ]
            })
        ]
    });
};


const $513f4886d7429842$export$719b9a3abb34c0ce = (props)=>{
    const { deleteCertificateUsecase: deleteCertificateUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    const [confirmation, setConfirmation] = (0, $h4Bez.useState)('');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $6dad3b57b5f21163$export$ad2a94d527926c21), {
        ...props,
        confirmation: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE,
        confirmable: confirmation === props.certificate.issuedBy.commonName,
        onConfirm: ()=>deleteCertificateUsecase.delete(props.certificate),
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_CERTIFICATE_CONFIRMATION,
                    values: {
                        br: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("br", {}),
                        confirmation: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("b", {
                            children: props.certificate.issuedBy.commonName
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d887fad28e7ec96c$export$2c73285ae9390cec), {
                "data-testid": "deletion-confirmation-input",
                value: confirmation,
                onChange: (e)=>setConfirmation(e.target.value)
            })
        ]
    });
};



parcelRequire("h4Bez");





var $h4Bez = parcelRequire("h4Bez");


"use client";
var $2a282a879c23969a$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'CheckOutlined');



"use client";
var $21873e61396fc6ee$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), 'ContentCopyOutlined');









const $dc012ce5611ea19e$export$20e92c49b5277b23 = (children)=>(0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>(0, $4220d57e589c900d$export$e41da262128eaf69)(s) === children, [
        children
    ]);


const $1ab636062450c95b$var$copiedIconStyle = {
    color: 'grey.400'
};
const $1ab636062450c95b$var$customButtonStyle = {
    border: 'unset'
};
/** Block-level and pulled 2px into the cell padding above and below, so the small 24px button centres on a table cell's 20px text line without making the row taller */ const $1ab636062450c95b$var$tableCopyStyle = {
    display: 'flex',
    my: -0.5
};
/**
 * Timeout for the copy icon to be reverted
 * in milliseconds
 */ const $1ab636062450c95b$var$ICONS_CHANGE_TIMEOUT = 3200;
/**
 * Shared across every copy button so repeated copies (same field twice, or different fields in a
 * row) merge into one toast with a counter badge while visible, instead of stacking a separate
 * "Copied to clipboard" toast per click (`ToastUsecase`'s dedupeKey aggregation).
 */ const $1ab636062450c95b$var$COPY_TOAST_DEDUPE_KEY = 'copy-to-clipboard';
const $1ab636062450c95b$var$InternalCopyWithSnackbar = ({ children: children, button: Button, ...props })=>{
    const { copyValueUsecase: copy, toastUsecase: toastUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    const isItemCopied = (0, $dc012ce5611ea19e$export$20e92c49b5277b23)(children);
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Button, {
        "aria-label": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).COPY_TO_CLIPBOARD),
        ...props,
        "data-testid": isItemCopied ? 'copied-id' : 'copy-id',
        onClick: ()=>{
            copy.invoke(children);
            toastUsecase.show({
                severity: (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).INFO,
                title: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).COPIED_TO_CLIPBOARD),
                dedupeKey: $1ab636062450c95b$var$COPY_TOAST_DEDUPE_KEY
            });
        },
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $00ca338ba2f14773$export$51b6cd98f8778f0d), {
            sx: isItemCopied ? $1ab636062450c95b$var$copiedIconStyle : undefined
        })
    });
};
const $1ab636062450c95b$var$CopyIconButton = ({ size: size = 'medium', ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
        variant: "ghost",
        size: size,
        ...props
    });
const $1ab636062450c95b$var$InternalCopyWithIconsChange = ({ children: children, title: title, timeout: timeout = $1ab636062450c95b$var$ICONS_CHANGE_TIMEOUT, ...props })=>{
    const copy = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('copyValueUsecase');
    const isItemCopied = (0, $dc012ce5611ea19e$export$20e92c49b5277b23)(children);
    const [isCopyClicked, setCopyClicked] = (0, $h4Bez.useState)(false);
    const onCopy = ()=>{
        copy.invoke(children);
        setCopyClicked(true);
    };
    // Revert the copied state after a timeout
    (0, $h4Bez.useEffect)(()=>(0, $d4622374f48a4eef$export$6eae7cf7a129a986)(()=>setCopyClicked(false), timeout), [
        isCopyClicked
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
        children: isItemCopied && isCopyClicked ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
            variant: "ghost",
            disabled: true,
            "data-testid": "copied-btn",
            ...props,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2a282a879c23969a$export$2e2bcd8739ae039), {
                color: "success"
            })
        }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
            variant: "ghost",
            onClick: onCopy,
            "data-testid": "copy-btn",
            ...props,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $21873e61396fc6ee$export$2e2bcd8739ae039), {
                titleAccess: title || ''
            })
        })
    });
};
const $1ab636062450c95b$export$92ce62e1201c4fc0 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1ab636062450c95b$var$InternalCopyWithSnackbar, {
        ...props,
        button: $1ab636062450c95b$var$CopyIconButton
    });
const $1ab636062450c95b$export$68054e84683f39b3 = ({ sx: sx, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1ab636062450c95b$export$92ce62e1201c4fc0, {
        ...props,
        size: "small",
        sx: {
            ...$1ab636062450c95b$var$tableCopyStyle,
            ...sx
        }
    });
const $1ab636062450c95b$export$2414c4478e2423d7 = ({ sx: sx, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1ab636062450c95b$var$InternalCopyWithSnackbar, {
        ...props,
        sx: {
            ...$1ab636062450c95b$var$customButtonStyle,
            ...sx
        }
    });
const $1ab636062450c95b$export$3907644cc4885eb4 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1ab636062450c95b$var$InternalCopyWithIconsChange, {
        ...props
    });





const $90d180d5c06bfd43$var$autoStyle = {
    m: 'auto',
    wordBreak: 'break-word'
};
const $90d180d5c06bfd43$var$detailsEntryStyle = {
    p: 4
};
const $90d180d5c06bfd43$var$detailsTitleStyle = {
    mr: 4
};
const $90d180d5c06bfd43$var$copyStyle = {
    ...$90d180d5c06bfd43$var$autoStyle,
    textAlign: 'right'
};
const $90d180d5c06bfd43$var$titleStyle = {
    backgroundColor: 'grey.200',
    p: 4
};
const $90d180d5c06bfd43$var$CertificateDetailsSection = ({ title: title, children: children, copy: copy })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                container: true,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        sx: $90d180d5c06bfd43$var$autoStyle,
                        className: "certificate-details-section",
                        size: {
                            xs: copy ? 8 : 12,
                            md: copy ? 10 : 12
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                            sx: $90d180d5c06bfd43$var$titleStyle,
                            variant: "body2",
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: title,
                                values: {
                                    count: children.length
                                }
                            })
                        })
                    }),
                    copy && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        sx: $90d180d5c06bfd43$var$copyStyle,
                        size: {
                            xs: 4,
                            md: 2
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                            sx: $90d180d5c06bfd43$var$titleStyle,
                            variant: "body2",
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ACTION,
                                values: {
                                    count: 0
                                }
                            })
                        })
                    })
                ]
            }),
            children
        ]
    });
const $90d180d5c06bfd43$var$CertificateDetailsEntry = ({ title: title, copy: copy, notAvailable: notAvailable, none: none, children: children })=>{
    if (!children && notAvailable) children = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
                children: '<'
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CERTIFICATE_PROPERTY_NOT_PROVIDED
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
                children: '>'
            })
        ]
    });
    if ((0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(children) && !(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(children) && none) children = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NONE
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                container: true,
                sx: $90d180d5c06bfd43$var$detailsEntryStyle,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        sx: $90d180d5c06bfd43$var$autoStyle,
                        size: {
                            xs: 4,
                            md: 2
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                            sx: $90d180d5c06bfd43$var$detailsTitleStyle,
                            className: "certificate-detail-title",
                            variant: "body2",
                            children: (0, $40a99dac858c1d75$export$552cd99e43fa1085)(title) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: title,
                                values: {
                                    count: (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(children) ? children.length : 0
                                }
                            }) : title
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        sx: $90d180d5c06bfd43$var$autoStyle,
                        className: "certificate-detail",
                        size: {
                            xs: copy ? 6 : 8,
                            md: copy ? 8 : 10
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                            variant: "body2",
                            children: (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(children) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbba8fd6e98bab28$export$f52b44e459e6e71d), {
                                type: "unit",
                                value: children
                            }) : children
                        })
                    }),
                    copy && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        sx: $90d180d5c06bfd43$var$copyStyle,
                        size: {
                            xs: 2,
                            md: 2
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1ab636062450c95b$export$92ce62e1201c4fc0), {
                            children: children
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {})
        ]
    });
};
const $90d180d5c06bfd43$export$95c15f215a3ac9d2 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($90d180d5c06bfd43$var$CertificateDetailsSection, {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ISSUED_TO,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($90d180d5c06bfd43$var$CertificateDetailsEntry, {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).COMMON_NAME,
                        notAvailable: true,
                        children: props.certificate.issuedTo.commonName
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($90d180d5c06bfd43$var$CertificateDetailsEntry, {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ORGANIZATION,
                        notAvailable: true,
                        children: props.certificate.issuedTo.organization
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($90d180d5c06bfd43$var$CertificateDetailsEntry, {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ORGANIZATIONAL_UNIT,
                        notAvailable: true,
                        children: props.certificate.issuedTo.organizationalUnit
                    }),
                    props.certificate.issuedTo.alternativeNames.length > 0 && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($90d180d5c06bfd43$var$CertificateDetailsEntry, {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ALTERNATIVE_NAME,
                        children: props.certificate.issuedTo.alternativeNames
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($90d180d5c06bfd43$var$CertificateDetailsSection, {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ISSUED_BY,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($90d180d5c06bfd43$var$CertificateDetailsEntry, {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).COMMON_NAME,
                        notAvailable: true,
                        children: props.certificate.issuedBy.commonName
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($90d180d5c06bfd43$var$CertificateDetailsEntry, {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ORGANIZATION,
                        notAvailable: true,
                        children: props.certificate.issuedBy.organization
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($90d180d5c06bfd43$var$CertificateDetailsEntry, {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ORGANIZATIONAL_UNIT,
                        notAvailable: true,
                        children: props.certificate.issuedBy.organizationalUnit
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($90d180d5c06bfd43$var$CertificateDetailsSection, {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VALIDITY_PERIOD,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($90d180d5c06bfd43$var$CertificateDetailsEntry, {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ISSUED_ON,
                        children: props.certificate.issuedOn.toISOString()
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($90d180d5c06bfd43$var$CertificateDetailsEntry, {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).EXPIRES_ON,
                        children: props.certificate.expiresOn.toISOString()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($90d180d5c06bfd43$var$CertificateDetailsSection, {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).EXTENSIONS,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($90d180d5c06bfd43$var$CertificateDetailsEntry, {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).KEY_USAGE,
                        none: true,
                        children: props.certificate.keyUsage.map((usage, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).KEY_USAGE_TYPE,
                                values: {
                                    usage: usage
                                }
                            }, k))
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($90d180d5c06bfd43$var$CertificateDetailsEntry, {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).EXTENDED_KEY_USAGE,
                        none: true,
                        children: props.certificate.extendedKeyUsage.map((usage, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).EXTENDED_KEY_USAGE_TYPE,
                                values: {
                                    usage: usage
                                }
                            }, k))
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($90d180d5c06bfd43$var$CertificateDetailsEntry, {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BASIC_CONSTRAINT,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CERTIFICATE_AUTHORITY
                                }),
                                ': ',
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BOOLEAN,
                                    values: {
                                        value: props.certificate.basicConstraints.authority
                                    }
                                }),
                                props.certificate.basicConstraints.authority && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
                                    children: [
                                        ", ",
                                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).PATH_LENGTH
                                        }),
                                        ": ",
                                        String(props.certificate.basicConstraints.pathLength)
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($90d180d5c06bfd43$var$CertificateDetailsSection, {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).FINGERPRINT,
                copy: true,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($90d180d5c06bfd43$var$CertificateDetailsEntry, {
                        title: "SHA-1",
                        copy: true,
                        children: props.certificate.fingerprints.sha1.toUpperCase()
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($90d180d5c06bfd43$var$CertificateDetailsEntry, {
                        title: "SHA-256",
                        copy: true,
                        children: props.certificate.fingerprints.sha256.toUpperCase()
                    })
                ]
            })
        ]
    });


const $1da62eede758c9da$var$Arrow = ({ open: open, ...props })=>open ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0c1414221f308967$export$2e2bcd8739ae039), {
        ...props
    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f0c56636e9fb6837$export$2e2bcd8739ae039), {
        ...props
    });
const $1da62eede758c9da$var$certificateDetailsStyle = {
    userSelect: 'none',
    py: 2,
    px: 4,
    '& > *': {
        mb: 4
    }
};
const $1da62eede758c9da$var$certificateItemStyle = {
    p: 4,
    userSelect: 'none'
};
const $1da62eede758c9da$var$arrowStyle = {
    color: 'grey.700',
    ml: 2,
    cursor: 'pointer'
};
const $1da62eede758c9da$var$buttonStyle = {
    display: 'flex',
    alignItems: 'center',
    '& > button': {
        mx: 2,
        p: 1
    }
};
const $1da62eede758c9da$var$headerStyle = {
    fontSize: 'body2.fontSize',
    transition: ({ transitions: transitions })=>transitions.create('font-size', {
            duration: transitions.duration.standard
        })
};
const $1da62eede758c9da$var$expandHeaderStyle = {
    fontSize: 'h5.fontSize'
};
const $1da62eede758c9da$var$CertificateItem = ({ divider: divider, certificate: certificate })=>{
    const title = (0, $aadfb82b994af9ea$export$5ace278d59015300)(certificate);
    const [isExpanded, setExpanded] = (0, $h4Bez.useState)(false);
    const [modal, setModal] = (0, $h4Bez.useState)(null);
    const { downloadCertificateUsecase: downloadCertificateUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    const ifHooked = (0, $413f2a7a2fb550d0$export$3f0971de8b5ae96c)();
    const closeModal = ()=>ifHooked(()=>setModal(null));
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                sx: $1da62eede758c9da$var$certificateItemStyle,
                container: true,
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                            "data-testid": "certificate-name",
                            sx: [
                                $1da62eede758c9da$var$headerStyle,
                                isExpanded && $1da62eede758c9da$var$expandHeaderStyle
                            ],
                            title: title,
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                            sx: $1da62eede758c9da$var$buttonStyle,
                            children: [
                                isExpanded && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                                            "data-testid": "download-btn",
                                            variant: "ghost",
                                            startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6c4ecf59edd403be$export$4e54df4252b4a99c), {}),
                                            onClick: ()=>void downloadCertificateUsecase.download(certificate),
                                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DOWNLOAD,
                                                values: {
                                                    count: 1
                                                }
                                            })
                                        }),
                                        certificate.removable && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                                            "data-testid": "delete-btn",
                                            variant: "ghost",
                                            startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $06e9db9e3c921f60$export$2e2bcd8739ae039), {}),
                                            onClick: ()=>setModal('delete'),
                                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1da62eede758c9da$var$Arrow, {
                                    fontSize: "small",
                                    open: isExpanded,
                                    sx: $1da62eede758c9da$var$arrowStyle,
                                    "data-testid": "certs-arrow",
                                    onClick: ()=>setExpanded(!isExpanded)
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7830414f6fe32da6$export$2e2bcd8739ae039), {
                in: isExpanded,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: $1da62eede758c9da$var$certificateDetailsStyle,
                    "data-testid": "certificate-details",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $90d180d5c06bfd43$export$95c15f215a3ac9d2), {
                        certificate: certificate
                    })
                })
            }),
            divider && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {}),
            modal === 'delete' && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $513f4886d7429842$export$719b9a3abb34c0ce), {
                certificate: certificate,
                onClose: closeModal
            })
        ]
    });
};
const $1da62eede758c9da$export$e21795389e60c55e = ({ certificates: certificates, divider: divider })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "organizations-certs",
        children: [
            divider && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5c50dcf7e155ce8c$export$1d7e255c6105d39b), {
                children: [
                    ...certificates
                ].sort((0, $aadfb82b994af9ea$export$ad6655e6c0becdd9)).map((cert, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1da62eede758c9da$var$CertificateItem, {
                        certificate: cert,
                        divider: k !== certificates.length - 1
                    }, k))
            })
        ]
    });





const $74bd7fbb20c19875$export$b63d7cb85a0dbc96 = ()=>{
    const certificates = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $aadfb82b994af9ea$export$e5be0e9f0af0ab8b));
    if (!(0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(certificates)) return certificates;
    const byOrganization = certificates.reduce((r, certificate)=>({
            ...r,
            [certificate.issuedBy.organization]: [
                ...r[certificate.issuedBy.organization] || [],
                certificate
            ]
        }), {});
    return (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(byOrganization).sort(([a], [b])=>a.localeCompare(b));
};


const $97384466d51b2d56$var$downArrowStyle = {
    ml: 0.8,
    color: 'grey.700'
};
const $97384466d51b2d56$var$certificateTitleStyle = {
    p: 4,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'grey.100'
};
const $97384466d51b2d56$export$c39d74429c80a86b = ()=>{
    const certificates = (0, $74bd7fbb20c19875$export$b63d7cb85a0dbc96)();
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('loadCertificatesUsecase');
    (0, $h4Bez.useEffect)(()=>usecase.invoke(), [
        usecase
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
        className: "certificates-list",
        spacing: 4,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $be3703687194c6e0$export$56e2352e63353d99), {
                title: [
                    (0, $40a99dac858c1d75$export$b63289fbda65eed1).CERTIFICATES,
                    {
                        count: 0
                    }
                ],
                titleActions: (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(certificates) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $91eb1f6e6d619b7d$export$d0265b2c425512d6), {}) : undefined,
                description: [
                    (0, $40a99dac858c1d75$export$b63289fbda65eed1).CERTIFICATES_DETAILS_DOCUMENTATION_TITLE,
                    (0, $40a99dac858c1d75$export$b63289fbda65eed1).CERTIFICATES_DETAILS_DOCUMENTATION_BODY
                ]
            }),
            certificates === null && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $35e2f7ba0c5bb8e5$export$8b8493c40023057), {}),
            (0, $c3e1b746ad236797$export$8d524fb6540252df).is(certificates) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
                "data-testid": "certificates-error",
                error: certificates,
                stack: true,
                extras: "section"
            }),
            (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(certificates) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        "data-testid": "certificate-title",
                        sx: $97384466d51b2d56$var$certificateTitleStyle,
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                                variant: "body2",
                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CERTIFICATES,
                                    values: {
                                        count: certificates.length
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7c31c359ca9de8e7$export$2e2bcd8739ae039), {
                                fontSize: "small",
                                sx: $97384466d51b2d56$var$downArrowStyle
                            })
                        ]
                    }),
                    certificates.map(([, certs], k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1da62eede758c9da$export$e21795389e60c55e), {
                            certificates: certs,
                            divider: k > 0
                        }, k)),
                    !(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(certificates) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        className: "no-certificates",
                        align: "center",
                        variant: "body2",
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_CERTIFICATES
                        })
                    })
                ]
            })
        ]
    });
};





parcelRequire("h4Bez");





parcelRequire("h4Bez");
const $0f6e6d34a7cdc5dd$export$b6009d9c113d57d8 = ({ resource: resource })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
        children: 'service' in resource && resource.service ? `${resource.name} (${resource.service})` : resource.id
    });




var $h4Bez = parcelRequire("h4Bez");










var $h4Bez = parcelRequire("h4Bez");




var $h4Bez = parcelRequire("h4Bez");

const $e5cfe4b27a81cb80$var$BulkModalScopeContext = /*#__PURE__*/ (0, $h4Bez.createContext)(null);
const $e5cfe4b27a81cb80$export$80126c38a2c1962c = ({ owner: owner, openId: openId, openRecordSelected: openRecordSelected, children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($e5cfe4b27a81cb80$var$BulkModalScopeContext.Provider, {
        value: {
            owner: owner,
            openId: openId,
            openRecordSelected: openRecordSelected
        },
        children: children
    });
const $e5cfe4b27a81cb80$export$93995fac08b83001 = ({ openId: openId, onOpenRecordSelected: onOpenRecordSelected, children: children })=>{
    const [selected, ...more] = (0, $365b0b4d68ac9bb9$export$1c9b7756eccadc96)();
    const openRecordSelected = openId !== null && more.length === 0 && selected === openId;
    (0, $h4Bez.useEffect)(()=>onOpenRecordSelected(openRecordSelected), [
        onOpenRecordSelected,
        openRecordSelected
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($e5cfe4b27a81cb80$export$80126c38a2c1962c, {
        owner: "list",
        openId: openId,
        openRecordSelected: openRecordSelected,
        children: children
    });
};
const $e5cfe4b27a81cb80$var$isOwned = (scope, ids, underWayOnMount)=>{
    if (scope === null) return true;
    const { owner: owner, openId: openId, openRecordSelected: openRecordSelected } = scope;
    const isPanelAction = openId !== null && !openRecordSelected && ids.length === 1 && ids[0] === openId;
    switch(owner){
        case 'list':
            return !isPanelAction;
        case 'panel':
            /** An action already under way when the panel's modals mount was the list's */ return isPanelAction && !underWayOnMount;
    }
};
const $e5cfe4b27a81cb80$export$7b6095cc374a51c9 = (ids)=>{
    const scope = (0, $h4Bez.useContext)($e5cfe4b27a81cb80$var$BulkModalScopeContext);
    const decision = (0, $h4Bez.useRef)(null);
    const mounted = (0, $h4Bez.useRef)(false);
    if (ids === null) decision.current = null;
    else if (decision.current?.ids !== ids) decision.current = {
        ids: ids,
        owned: $e5cfe4b27a81cb80$var$isOwned(scope, ids, !mounted.current)
    };
    (0, $h4Bez.useEffect)(()=>{
        mounted.current = true;
    }, []);
    return decision.current?.owned ?? true;
};


const $e4c7f584ea42cc55$var$RecordPanelContentContext = /*#__PURE__*/ (0, $h4Bez.createContext)(null);
const $e4c7f584ea42cc55$export$33c86ae21ccab5b4 = ({ value: value, children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($e4c7f584ea42cc55$var$RecordPanelContentContext.Provider, {
        value: value,
        children: children
    });
const $e4c7f584ea42cc55$export$d85795532116d29b = ()=>(0, $h4Bez.useContext)($e4c7f584ea42cc55$var$RecordPanelContentContext);
const $e4c7f584ea42cc55$export$326eba82f21a8b7a = ({ id: id, children: children })=>{
    const content = $e4c7f584ea42cc55$export$d85795532116d29b();
    (0, $14eddac5f20c576c$export$a7a9523472993e97)(content, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Record panel modals are rendered outside of a record panel', {
        id: id
    }));
    const { takeOverModals: takeOverModals, openRecordSelected: openRecordSelected } = content;
    (0, $h4Bez.useEffect)(()=>{
        takeOverModals(id);
        return ()=>takeOverModals(null);
    }, [
        takeOverModals,
        id
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e5cfe4b27a81cb80$export$80126c38a2c1962c), {
        owner: "panel",
        openId: id,
        openRecordSelected: openRecordSelected,
        children: children
    });
};




var $h4Bez = parcelRequire("h4Bez");

/* eslint-disable typescript-sort-keys/string-enum */ 
var $0e5d1fb0e9c69012$export$94983032f3209e0b = /*#__PURE__*/ function(AbsoluteRouteOnlyPath) {
    /** System */ AbsoluteRouteOnlyPath["SYSTEM"] = "SYSTEM";
    AbsoluteRouteOnlyPath["SYSTEM_STATUS"] = "SYSTEM_STATUS";
    AbsoluteRouteOnlyPath["SYSTEM_CONTAINERS"] = "SYSTEM_CONTAINERS";
    AbsoluteRouteOnlyPath["SYSTEM_INTERNET_CONNECTIVITY"] = "SYSTEM_INTERNET_CONNECTIVITY";
    AbsoluteRouteOnlyPath["SYSTEM_METRICS"] = "SYSTEM_METRICS";
    AbsoluteRouteOnlyPath["SYSTEM_AGENTS"] = "SYSTEM_AGENTS";
    AbsoluteRouteOnlyPath["SYSTEM_LICENSE"] = "SYSTEM_LICENSE";
    AbsoluteRouteOnlyPath["SYSTEM_INFORMATION"] = "SYSTEM_INFORMATION";
    /** Data */ AbsoluteRouteOnlyPath["DATA"] = "DATA";
    AbsoluteRouteOnlyPath["DATA_EXPLORER"] = "DATA_EXPLORER";
    /** Services */ AbsoluteRouteOnlyPath["SERVICES"] = "SERVICES";
    AbsoluteRouteOnlyPath["SERVICES_OVERVIEW"] = "SERVICES_OVERVIEW";
    AbsoluteRouteOnlyPath["DEVIATED_SERVICES"] = "DEVIATED_SERVICES";
    AbsoluteRouteOnlyPath["SERVICES_RESOURCES_LINKS"] = "SERVICES_RESOURCES_LINKS";
    AbsoluteRouteOnlyPath["SERVICES_RESOURCES"] = "SERVICES_RESOURCES";
    AbsoluteRouteOnlyPath["SERVICES_RESOURCES_SERVERS"] = "SERVICES_RESOURCES_SERVERS";
    AbsoluteRouteOnlyPath["SERVICES_RESOURCES_NODES"] = "SERVICES_RESOURCES_NODES";
    AbsoluteRouteOnlyPath["SERVICES_RESOURCES_CONTAINERS"] = "SERVICES_RESOURCES_CONTAINERS";
    AbsoluteRouteOnlyPath["SERVICES_RESOURCES_VOLUMES"] = "SERVICES_RESOURCES_VOLUMES";
    AbsoluteRouteOnlyPath["SERVICES_RESOURCES_CONNECTIONS"] = "SERVICES_RESOURCES_CONNECTIONS";
    AbsoluteRouteOnlyPath["SERVICES_RESOURCES_ENDPOINTS"] = "SERVICES_RESOURCES_ENDPOINTS";
    AbsoluteRouteOnlyPath["SERVICES_RESOURCES_MAPPINGS"] = "SERVICES_RESOURCES_MAPPINGS";
    AbsoluteRouteOnlyPath["SERVICES_LOGS"] = "SERVICES_LOGS";
    AbsoluteRouteOnlyPath["SERVICES_RULE_ENGINE_SANDBOX"] = "SERVICES_RULE_ENGINE_SANDBOX";
    AbsoluteRouteOnlyPath["SERVICES_WORKBENCH"] = "SERVICES_WORKBENCH";
    /** User */ AbsoluteRouteOnlyPath["USER"] = "USER";
    AbsoluteRouteOnlyPath["USER_MANAGEMENT"] = "USER_MANAGEMENT";
    AbsoluteRouteOnlyPath["USER_MANAGEMENT_USERS"] = "USER_MANAGEMENT_USERS";
    AbsoluteRouteOnlyPath["USER_MANAGEMENT_ROLES"] = "USER_MANAGEMENT_ROLES";
    AbsoluteRouteOnlyPath["USER_MANAGEMENT_PERMISSIONS"] = "USER_MANAGEMENT_PERMISSIONS";
    AbsoluteRouteOnlyPath["USER_CLIENT_REGISTRY"] = "USER_CLIENT_REGISTRY";
    AbsoluteRouteOnlyPath["USER_CERTIFICATES"] = "USER_CERTIFICATES";
    /** Settings */ AbsoluteRouteOnlyPath["SETTINGS"] = "SETTINGS";
    AbsoluteRouteOnlyPath["SETTINGS_LOGIN"] = "SETTINGS_LOGIN";
    /** Internal */ AbsoluteRouteOnlyPath["STORYBOOK"] = "STORYBOOK";
    AbsoluteRouteOnlyPath["STORYBOOK_FOUNDATIONS"] = "STORYBOOK_FOUNDATIONS";
    AbsoluteRouteOnlyPath["STORYBOOK_INPUTS"] = "STORYBOOK_INPUTS";
    AbsoluteRouteOnlyPath["STORYBOOK_BUTTONS"] = "STORYBOOK_BUTTONS";
    AbsoluteRouteOnlyPath["STORYBOOK_CHIPS_AND_STATUSES"] = "STORYBOOK_CHIPS_AND_STATUSES";
    AbsoluteRouteOnlyPath["STORYBOOK_TABLES"] = "STORYBOOK_TABLES";
    AbsoluteRouteOnlyPath["STORYBOOK_NOTIFICATIONS"] = "STORYBOOK_NOTIFICATIONS";
    return AbsoluteRouteOnlyPath;
}({});
const $0e5d1fb0e9c69012$export$bc9e294c57c6e14 = (0, $65583c3760a483fc$export$2b5e8179047d3ac4)($0e5d1fb0e9c69012$export$94983032f3209e0b);
var $0e5d1fb0e9c69012$export$91969d5ee4870de = /*#__PURE__*/ function(AbsoluteRoutePathWithServiceId) {
    AbsoluteRoutePathWithServiceId["SERVICES_OVERVIEW_SERVICE"] = "SERVICES_OVERVIEW_SERVICE";
    return AbsoluteRoutePathWithServiceId;
}({});
const $0e5d1fb0e9c69012$export$85e697329f119116 = (0, $65583c3760a483fc$export$2b5e8179047d3ac4)($0e5d1fb0e9c69012$export$91969d5ee4870de);
var $0e5d1fb0e9c69012$export$4aab3fd492e2cb26 = /*#__PURE__*/ function(AbsoluteRoutePathWithId) {
    AbsoluteRoutePathWithId["SERVICES_RESOURCES_SERVICE"] = "SERVICES_RESOURCES_SERVICE";
    AbsoluteRoutePathWithId["SERVICES_RESOURCES_SERVER"] = "SERVICES_RESOURCES_SERVER";
    AbsoluteRoutePathWithId["SERVICES_RESOURCES_CONTAINER"] = "SERVICES_RESOURCES_CONTAINER";
    AbsoluteRoutePathWithId["SERVICES_RESOURCES_VOLUME"] = "SERVICES_RESOURCES_VOLUME";
    AbsoluteRoutePathWithId["SERVICES_RESOURCES_CONNECTION"] = "SERVICES_RESOURCES_CONNECTION";
    AbsoluteRoutePathWithId["SERVICES_RESOURCES_ENDPOINT"] = "SERVICES_RESOURCES_ENDPOINT";
    AbsoluteRoutePathWithId["SERVICES_RESOURCES_MAPPING"] = "SERVICES_RESOURCES_MAPPING";
    AbsoluteRoutePathWithId["SYSTEM_CONTAINER"] = "SYSTEM_CONTAINER";
    return AbsoluteRoutePathWithId;
}({});
const $0e5d1fb0e9c69012$export$d6e6e655ee8621ab = (0, $65583c3760a483fc$export$2b5e8179047d3ac4)($0e5d1fb0e9c69012$export$4aab3fd492e2cb26);
var $0e5d1fb0e9c69012$export$6bdb9064cdfd6775 = /*#__PURE__*/ function(AbsoluteRoutePathWithServiceAndResourceId) {
    AbsoluteRoutePathWithServiceAndResourceId["SERVICE_SERVER"] = "SERVICE_SERVER";
    AbsoluteRoutePathWithServiceAndResourceId["SERVICE_CONTAINER"] = "SERVICE_CONTAINER";
    AbsoluteRoutePathWithServiceAndResourceId["SERVICE_VOLUME"] = "SERVICE_VOLUME";
    AbsoluteRoutePathWithServiceAndResourceId["SERVICE_CONNECTION"] = "SERVICE_CONNECTION";
    AbsoluteRoutePathWithServiceAndResourceId["SERVICE_ENDPOINT"] = "SERVICE_ENDPOINT";
    AbsoluteRoutePathWithServiceAndResourceId["SERVICE_MAPPING"] = "SERVICE_MAPPING";
    return AbsoluteRoutePathWithServiceAndResourceId;
}({});
const $0e5d1fb0e9c69012$export$c859ee50307dd2d3 = (0, $65583c3760a483fc$export$2b5e8179047d3ac4)($0e5d1fb0e9c69012$export$6bdb9064cdfd6775);
var $0e5d1fb0e9c69012$export$a87513c3fea633a5 = /*#__PURE__*/ function(RelativeRoutePathWithId) {
    RelativeRoutePathWithId["SERVER"] = "REL_SERVER";
    RelativeRoutePathWithId["CONTAINER"] = "REL_CONTAINER";
    RelativeRoutePathWithId["VOLUME"] = "REL_VOLUME";
    RelativeRoutePathWithId["CONNECTION"] = "REL_CONNECTION";
    RelativeRoutePathWithId["ENDPOINT"] = "REL_ENDPOINT";
    RelativeRoutePathWithId["MAPPING"] = "REL_MAPPING";
    RelativeRoutePathWithId["SERVICE"] = "REL_SERVICE";
    return RelativeRoutePathWithId;
}({});
const $0e5d1fb0e9c69012$export$b6418d9b7e088a5 = (0, $65583c3760a483fc$export$2b5e8179047d3ac4)($0e5d1fb0e9c69012$export$a87513c3fea633a5);







/**
 * A lot of configurations duplicate a lot of things
 * This helps keeping them less duplicated
 */ const $78200dbe96418bab$var$createDerivedConfigs = (base, derivations)=>(0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(derivations).reduce((r, [route, derivation])=>({
            ...r,
            [route]: {
                ...base,
                ...derivation
            }
        }), {});
/**
 * This function is expected to always be called with a route that has actual children
 * Otherwise it will lie that is has a non empty response
 *
 * @returns all the alternatives as given by the route's children
 */ const $78200dbe96418bab$var$getRouteChildrenCapabilities = (route)=>{
    const childrenCapabilities = (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)($78200dbe96418bab$var$routes).flatMap(([otherRoute, config])=>config.parent === route ? config.capabilities(otherRoute) : []);
    return childrenCapabilities;
};
/**
 * Use this object to define the routes of the application
 * Its a map to be used by 'react-router-dom' and the Connectware react components
 */ const $78200dbe96418bab$var$routes = {
    /** System */ [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM]: {
        path: '/system',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SYSTEM,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)($78200dbe96418bab$var$getRouteChildrenCapabilities)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_STATUS]: {
        path: '/system/status',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SYSTEM_STATUS,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)($78200dbe96418bab$var$getRouteChildrenCapabilities)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_CONTAINERS]: {
        path: '/system/status/container',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SYSTEM_CONTAINER,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_STATUS,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINERS_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINER_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINERS_MANAGE
                    ]
                }
            ])
    },
    [(0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SYSTEM_CONTAINER]: {
        path: '/system/status/container/:resourceId',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTAINER,
        isTitleSingular: true,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_CONTAINERS,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINER_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINERS_MANAGE,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ
                    ]
                }
            ]),
        relativeContext: 'resource'
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_INTERNET_CONNECTIVITY]: {
        path: '/system/status/internet-connectivity',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).INTERNET_CONNECTIVITY,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_STATUS,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).MINIMUM
                    ],
                    optional: []
                }
            ])
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_LICENSE]: {
        path: '/system/status/license',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_STATUS,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).MINIMUM
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_LICENSE_MANAGE
                    ]
                }
            ])
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_INFORMATION]: {
        path: '/system/status/information',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SYSTEM_INFORMATION,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_STATUS,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).MINIMUM
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_READ
                    ]
                }
            ])
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_METRICS]: {
        path: '/system/status/metrics',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).METRICS,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_STATUS,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_METRICS_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_METRICS_MANAGE
                    ]
                }
            ])
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_AGENTS]: {
        path: '/system/status/agents',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).AGENT,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_STATUS,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).AGENTS_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).AGENTS_MANAGE
                    ]
                }
            ])
    },
    /** Data */ [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).DATA]: {
        path: '/data',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DATA,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)($78200dbe96418bab$var$getRouteChildrenCapabilities)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).DATA_EXPLORER]: {
        path: '/data/explorer',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DATA_EXPLORER,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).DATA,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).TOPICS_SUBSCRIPTION
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).TOPIC_CHUNKS_READ
                    ]
                }
            ])
    },
    /** Services */ [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES]: {
        path: '/services',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)($78200dbe96418bab$var$getRouteChildrenCapabilities)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_OVERVIEW]: {
        path: '/services/overview',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_OVERVIEW,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_MANAGE,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_PARAMETERS_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_CREATE_OR_UPDATE
                    ]
                }
            ]),
        relativeContext: 'service'
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).DEVIATED_SERVICES]: {
        path: '/services/deviated',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVIATED_SERVICES,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).DEVIATIONS_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ
                    ]
                }
            ]),
        relativeContext: 'service'
    },
    ...$78200dbe96418bab$var$createDerivedConfigs({
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_DETAILS,
        isTitleSingular: true,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                /** Needed to allow to view parameters of a service */ {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_PARAMETERS_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_COMMISSIONING_FILE_READ
                    ],
                    optional: []
                },
                /** Needed to allow service creation or update */ {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_PARAMETERS_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_CREATE_OR_UPDATE,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_COMMISSIONING_FILE_READ
                    ],
                    optional: []
                },
                /** Needed for live data tab */ {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_SUBSCRIPTION_METADATA,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).TOPICS_SUBSCRIPTION
                    ],
                    optional: []
                },
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_COMMISSIONING_FILE_READ
                    ],
                    optional: []
                },
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_MANAGE
                    ],
                    optional: []
                },
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ
                    ],
                    optional: []
                },
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_READ
                    ],
                    optional: []
                },
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_READ
                    ],
                    optional: []
                },
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_READ
                    ],
                    optional: []
                },
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_READ
                    ],
                    optional: []
                },
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_READ
                    ],
                    optional: []
                },
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).NODES_READ
                    ],
                    optional: []
                },
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).VOLUMES_READ
                    ],
                    optional: []
                },
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ
                    ],
                    optional: []
                }
            ])
    }, {
        [(0, $0e5d1fb0e9c69012$export$91969d5ee4870de).SERVICES_OVERVIEW_SERVICE]: {
            path: '/services/overview/:serviceId',
            parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_OVERVIEW,
            relativeContext: 'service'
        },
        [(0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_SERVICE]: {
            path: '/services/resources/service/:resourceId',
            parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_LINKS,
            relativeContext: 'resource'
        }
    }),
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_LOGS]: {
        path: '/services/logs',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_LOGS,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ
                    ],
                    optional: []
                }
            ]),
        relativeContext: 'service'
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_WORKBENCH]: {
        path: '/services/workbench',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).WORKBENCH_TITLE,
        isTitleSingular: true,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).WORKBENCH
                    ],
                    optional: []
                }
            ]),
        external: true
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES]: {
        path: '/services/resources',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_RESOURCES,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)($78200dbe96418bab$var$getRouteChildrenCapabilities),
        relativeContext: 'resource'
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_LINKS]: {
        path: '/services/resources/links',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_LINK,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ
                    ]
                }
            ]),
        relativeContext: 'resource'
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_SERVERS]: {
        path: '/services/resources/servers',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVER,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVER_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_MANAGE
                    ]
                }
            ]),
        relativeContext: 'resource'
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_NODES]: {
        path: '/services/resources/nodes',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NODE,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).NODES_READ
                    ],
                    optional: []
                }
            ]),
        relativeContext: 'resource'
    },
    ...$78200dbe96418bab$var$createDerivedConfigs({
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVER,
        isTitleSingular: true,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVER_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_MANAGE,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).NODES_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ
                    ]
                }
            ])
    }, {
        [(0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_SERVER]: {
            path: '/services/overview/:serviceId/servers/:resourceId',
            parent: (0, $0e5d1fb0e9c69012$export$91969d5ee4870de).SERVICES_OVERVIEW_SERVICE,
            relativeContext: 'service'
        },
        [(0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_SERVER]: {
            path: '/services/resources/servers/:resourceId',
            parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_SERVERS,
            relativeContext: 'resource'
        }
    }),
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_CONTAINERS]: {
        path: '/services/resources/containers',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTAINER,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINER_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_MANAGE
                    ]
                }
            ]),
        relativeContext: 'resource'
    },
    ...$78200dbe96418bab$var$createDerivedConfigs({
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTAINER,
        isTitleSingular: true,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINER_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_MANAGE,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ
                    ]
                }
            ])
    }, {
        [(0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_CONTAINER]: {
            path: '/services/overview/:serviceId/containers/:resourceId',
            parent: (0, $0e5d1fb0e9c69012$export$91969d5ee4870de).SERVICES_OVERVIEW_SERVICE,
            relativeContext: 'service'
        },
        [(0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_CONTAINER]: {
            path: '/services/resources/containers/:resourceId',
            parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_CONTAINERS,
            relativeContext: 'resource'
        }
    }),
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_VOLUMES]: {
        path: '/services/resources/volumes',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VOLUME,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).VOLUMES_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).VOLUME_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).VOLUMES_MANAGE
                    ]
                }
            ]),
        relativeContext: 'resource'
    },
    ...$78200dbe96418bab$var$createDerivedConfigs({
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VOLUME,
        isTitleSingular: true,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).VOLUME_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).VOLUMES_MANAGE,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ
                    ]
                }
            ])
    }, {
        [(0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_VOLUME]: {
            path: '/services/overview/:serviceId/volumes/:resourceId',
            parent: (0, $0e5d1fb0e9c69012$export$91969d5ee4870de).SERVICES_OVERVIEW_SERVICE,
            relativeContext: 'service'
        },
        [(0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_VOLUME]: {
            path: '/services/resources/volumes/:resourceId',
            parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_VOLUMES,
            relativeContext: 'resource'
        }
    }),
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_CONNECTIONS]: {
        path: '/services/resources/connections',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTION,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTION_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_MANAGE
                    ]
                }
            ]),
        relativeContext: 'resource'
    },
    ...$78200dbe96418bab$var$createDerivedConfigs({
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTION,
        isTitleSingular: true,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTION_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_MANAGE,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ
                    ]
                }
            ])
    }, {
        [(0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_CONNECTION]: {
            path: '/services/overview/:serviceId/connections/:resourceId',
            parent: (0, $0e5d1fb0e9c69012$export$91969d5ee4870de).SERVICES_OVERVIEW_SERVICE,
            relativeContext: 'service'
        },
        [(0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_CONNECTION]: {
            path: '/services/resources/connections/:resourceId',
            parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_CONNECTIONS,
            relativeContext: 'resource'
        }
    }),
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_ENDPOINTS]: {
        path: '/services/resources/endpoints',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENDPOINT,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINT_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_MANAGE
                    ]
                }
            ]),
        relativeContext: 'resource'
    },
    ...$78200dbe96418bab$var$createDerivedConfigs({
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENDPOINT,
        isTitleSingular: true,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINT_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_MANAGE,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ
                    ]
                }
            ])
    }, {
        [(0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_ENDPOINT]: {
            path: '/services/overview/:serviceId/endpoints/:resourceId',
            parent: (0, $0e5d1fb0e9c69012$export$91969d5ee4870de).SERVICES_OVERVIEW_SERVICE,
            relativeContext: 'service'
        },
        [(0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_ENDPOINT]: {
            path: '/services/resources/endpoints/:resourceId',
            parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_ENDPOINTS,
            relativeContext: 'resource'
        }
    }),
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_MAPPINGS]: {
        path: '/services/resources/mappings',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MAPPING,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPING_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_MANAGE
                    ]
                }
            ]),
        relativeContext: 'resource'
    },
    ...$78200dbe96418bab$var$createDerivedConfigs({
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MAPPING,
        isTitleSingular: true,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPING_READ
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_MANAGE,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).TOPICS_SUBSCRIPTION
                    ]
                }
            ])
    }, {
        [(0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_MAPPING]: {
            path: '/services/overview/:serviceId/mappings/:resourceId',
            parent: (0, $0e5d1fb0e9c69012$export$91969d5ee4870de).SERVICES_OVERVIEW_SERVICE,
            relativeContext: 'service'
        },
        [(0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_MAPPING]: {
            path: '/services/resources/mappings/:resourceId',
            parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_MAPPINGS,
            relativeContext: 'resource'
        }
    }),
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RULE_ENGINE_SANDBOX]: {
        path: '/services/rule-engine-sandbox',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).RULE_ENGINE_SANDBOX,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).TOPICS_SUBSCRIPTION
                    ],
                    optional: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).RULE_ENGINE_RESOURCES
                    ]
                }
            ])
    },
    /** User */ [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER]: {
        path: '/user',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).USER,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)($78200dbe96418bab$var$getRouteChildrenCapabilities)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_MANAGEMENT]: {
        path: '/user/management',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).USER_MANAGEMENT,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)($78200dbe96418bab$var$getRouteChildrenCapabilities)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_MANAGEMENT_USERS]: {
        path: '/user/management/users',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).USER,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_MANAGEMENT,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_USERS,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).USER_MANAGEMENT_CONFIGURATION,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).RETRIEVE_USERNAME_POLICY,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).RETRIEVE_PASSWORD_POLICY
                    ],
                    optional: []
                }
            ])
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_MANAGEMENT_ROLES]: {
        path: '/user/management/roles',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ROLE,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_MANAGEMENT,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_ROLES,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).USER_MANAGEMENT_CONFIGURATION
                    ],
                    optional: []
                }
            ])
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_MANAGEMENT_PERMISSIONS]: {
        path: '/user/management/permissions',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).PERMISSION,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_MANAGEMENT,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_PERMISSIONS
                    ],
                    optional: []
                }
            ])
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_CLIENT_REGISTRY]: {
        path: '/user/client-registry',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CLIENT_REGISTRY,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).CLIENT_REGISTRY_MANAGE
                    ],
                    optional: []
                }
            ])
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_CERTIFICATES]: {
        path: '/user/certificates',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).USER_CERTIFICATES,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).CERTIFICATES_MANAGE
                    ],
                    optional: []
                }
            ])
    },
    /** Settings */ [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SETTINGS]: {
        path: '/settings',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SETTINGS,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)($78200dbe96418bab$var$getRouteChildrenCapabilities)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SETTINGS_LOGIN]: {
        path: '/settings/login',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LOGIN_SETTINGS,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SETTINGS,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [],
                    optional: []
                },
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_OWN_PASSWORD,
                        (0, $78670ebe9381a713$export$790a66df9dc00390).RETRIEVE_PASSWORD_POLICY
                    ],
                    optional: []
                },
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).USE_MFA
                    ],
                    optional: []
                }
            ])
    },
    /** Internal */ [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK]: {
        path: '/system/storybook',
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK,
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)($78200dbe96418bab$var$getRouteChildrenCapabilities)
    },
    ...$78200dbe96418bab$var$createDerivedConfigs({
        parent: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK,
        capabilities: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
                {
                    required: [
                        (0, $78670ebe9381a713$export$790a66df9dc00390).MINIMUM
                    ],
                    optional: []
                }
            ])
    }, {
        [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_FOUNDATIONS]: {
            path: '/system/storybook/foundations',
            title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_FOUNDATIONS
        },
        [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_INPUTS]: {
            path: '/system/storybook/inputs',
            title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_INPUTS
        },
        [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_BUTTONS]: {
            path: '/system/storybook/buttons',
            title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_BUTTONS
        },
        [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_CHIPS_AND_STATUSES]: {
            path: '/system/storybook/chips-and-statuses',
            title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_CHIPS_AND_STATUSES
        },
        [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_TABLES]: {
            path: '/system/storybook/tables',
            title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_TABLES
        },
        [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_NOTIFICATIONS]: {
            path: '/system/storybook/notifications',
            title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_NOTIFICATIONS
        }
    })
};
const $78200dbe96418bab$var$relativeRoutes = {
    resource: {
        [(0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).SERVER]: (0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_SERVER,
        [(0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).CONTAINER]: (0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_CONTAINER,
        [(0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).VOLUME]: (0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_VOLUME,
        [(0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).CONNECTION]: (0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_CONNECTION,
        [(0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).ENDPOINT]: (0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_ENDPOINT,
        [(0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).MAPPING]: (0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_MAPPING,
        [(0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).SERVICE]: (0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_SERVICE
    },
    service: {
        [(0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).SERVER]: (0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_SERVER,
        [(0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).CONTAINER]: (0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_CONTAINER,
        [(0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).VOLUME]: (0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_VOLUME,
        [(0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).CONNECTION]: (0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_CONNECTION,
        [(0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).ENDPOINT]: (0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_ENDPOINT,
        [(0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).MAPPING]: (0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_MAPPING,
        [(0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).SERVICE]: (0, $0e5d1fb0e9c69012$export$91969d5ee4870de).SERVICES_OVERVIEW_SERVICE
    }
};
const $78200dbe96418bab$export$94372477dfb6d533 = (path)=>$78200dbe96418bab$var$routes[path];
const $78200dbe96418bab$export$52f918acf509b2a9 = (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM;
const $78200dbe96418bab$export$d2ea89eca91e1c66 = (childRoute, parentRoute)=>$78200dbe96418bab$export$94372477dfb6d533(childRoute).parent === parentRoute;
const $78200dbe96418bab$export$339a323fb5b41ef8 = (path)=>$78200dbe96418bab$export$94372477dfb6d533(path).path;
const $78200dbe96418bab$export$c9f0b0bdbee36c23 = (path)=>$78200dbe96418bab$export$94372477dfb6d533(path).capabilities(path);
const $78200dbe96418bab$export$31553aaa555c1514 = (route)=>{
    const { relativeContext: relativeContext } = $78200dbe96418bab$export$94372477dfb6d533(route);
    (0, $14eddac5f20c576c$export$a7a9523472993e97)(relativeContext, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Could not find relative context', {
        route: route
    }));
    return relativeContext;
};
const $78200dbe96418bab$export$2ebb08705870ecc3 = (0, $beec4324cbd609ea$export$6b4e15ccdc547ae7)((0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>(0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)($78200dbe96418bab$var$routes).reduce((r, [route, config])=>config.external ? [
            ...r,
            route
        ] : r, [])), 'getExternalRoutes');
const $78200dbe96418bab$export$2b4fe756f346e3bb = (path, context)=>$78200dbe96418bab$var$relativeRoutes[context][path];
const $78200dbe96418bab$var$getAllChildren = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>(0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)($78200dbe96418bab$var$routes).reduce((r, [route, { parent: parent = null }])=>r.set(parent, [
            ...r.getDefault(parent, []),
            route
        ]), new (0, $f0cbf013be9038ef$export$c3f30dbb97e8bc91)()));
const $78200dbe96418bab$export$56850611992c1d8b = (route)=>{
    const children = $78200dbe96418bab$var$getAllChildren().get(route);
    (0, $14eddac5f20c576c$export$a7a9523472993e97)(children && (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(children), new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Unexpected route children setup', {
        route: route
    }));
    return children;
};





const $5eed2216d79d12d5$var$getParents = (parent)=>{
    const firstParent = (0, $78200dbe96418bab$export$94372477dfb6d533)(parent);
    const parents = [
        {
            title: firstParent.title,
            isTitleSingular: Boolean(firstParent.isTitleSingular),
            id: parent
        }
    ];
    if (firstParent.parent) /**
         * Recursive parent retrieval
         */ parents.push(...$5eed2216d79d12d5$var$getParents(firstParent.parent));
    return parents;
};
const $5eed2216d79d12d5$var$getBreadcrumbs = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>[
        ...Object.values((0, $0e5d1fb0e9c69012$export$94983032f3209e0b)),
        ...Object.values((0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26)),
        ...Object.values((0, $0e5d1fb0e9c69012$export$91969d5ee4870de)),
        ...Object.values((0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775))
    ].reduce((r, routePath)=>{
        const route = (0, $78200dbe96418bab$export$94372477dfb6d533)(routePath);
        const breadcrumb = {
            title: route.title,
            isTitleSingular: Boolean(route.isTitleSingular),
            path: route.path,
            parents: route.parent ? $5eed2216d79d12d5$var$getParents(route.parent) : []
        };
        return {
            ...r,
            [routePath]: breadcrumb
        };
    }, {}));
const $5eed2216d79d12d5$export$d6ed076c6911710a = (path)=>$5eed2216d79d12d5$var$getBreadcrumbs()[path];
const $5eed2216d79d12d5$export$f29254c3c4e3e9b9 = (path)=>path === (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK || $5eed2216d79d12d5$export$d6ed076c6911710a(path).parents.some(({ id: id })=>id === (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK);






var $h4Bez = parcelRequire("h4Bez");









const $ed3a79aec495d063$export$95fa16a10fc41701 = ()=>{
    const [hasCapabilities] = (0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>[
            (0, $1c05f13022cf1480$export$f57bfb60306fe35f)(s),
            (0, $1c05f13022cf1480$export$7326d92567ef4631)(s) ?? []
        ], ([, a], [, b])=>(0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(a, b, {
            sort: false
        }));
    const isStorybookEnabledUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('isStorybookEnabledUsecase');
    return (alternativesOrRoute)=>{
        /**
         * Storybook is an internal, dev/demo-only page: gated by app config rather than a backend capability
         */ if (!(0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(alternativesOrRoute) && (0, $5eed2216d79d12d5$export$f29254c3c4e3e9b9)(alternativesOrRoute) && !isStorybookEnabledUsecase.invoke()) return false;
        const alternatives = (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(alternativesOrRoute) ? [
            alternativesOrRoute
        ] : (0, $78200dbe96418bab$export$c9f0b0bdbee36c23)(alternativesOrRoute).map((capabilities)=>capabilities.required);
        return alternatives.some(hasCapabilities);
    };
};




var $h4Bez = parcelRequire("h4Bez");







const $d9696a24a7c3425c$var$RouterPropsState = (0, $08b3e6ee09ecfd12$export$e50ad042342a539d)();
const $d9696a24a7c3425c$export$63440d31ac7e2ba8 = $d9696a24a7c3425c$var$RouterPropsState.Provider;
const $d9696a24a7c3425c$export$13438030b8a2edc1 = ()=>$d9696a24a7c3425c$var$RouterPropsState.useExtendedState((s)=>s);
const $d9696a24a7c3425c$var$RouterStateState = (0, $08b3e6ee09ecfd12$export$e50ad042342a539d)();
const $d9696a24a7c3425c$export$710fb77a051eee27 = $d9696a24a7c3425c$var$RouterStateState.Provider;
const $d9696a24a7c3425c$export$6288a8c52efefdad = $d9696a24a7c3425c$var$RouterStateState.useExtendedStateDispatcher;
const $d9696a24a7c3425c$export$9ffe5a2365992c6e = ()=>$d9696a24a7c3425c$var$RouterStateState.useExtendedState((s)=>s);







const $29a5e76a1c2ddc0d$export$a337c713bdba072 = (path, resourceId, serviceId)=>{
    if (resourceId === null && serviceId === null && (0, $0e5d1fb0e9c69012$export$bc9e294c57c6e14)(path)) return {
        path: path,
        resourceId: resourceId,
        serviceId: serviceId
    };
    if (typeof resourceId === 'string' && serviceId === null && (0, $0e5d1fb0e9c69012$export$d6e6e655ee8621ab)(path)) return {
        path: path,
        resourceId: resourceId,
        serviceId: serviceId
    };
    if (resourceId === null && typeof serviceId === 'string' && (0, $0e5d1fb0e9c69012$export$85e697329f119116)(path)) return {
        path: path,
        resourceId: resourceId,
        serviceId: serviceId
    };
    if (typeof resourceId === 'string' && typeof serviceId === 'string' && (0, $0e5d1fb0e9c69012$export$c859ee50307dd2d3)(path)) return {
        path: path,
        resourceId: resourceId,
        serviceId: serviceId
    };
    throw new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Router state is invalid', {
        path: path,
        resourceId: resourceId,
        serviceId: serviceId
    });
};
const $29a5e76a1c2ddc0d$export$f6cc4b464535fb2 = (state, ...args)=>{
    if (args.length === 1) return {
        path: args[0],
        resourceId: null,
        serviceId: null
    };
    const [path, id] = args;
    const absolutePath = (0, $0e5d1fb0e9c69012$export$b6418d9b7e088a5)(path) ? (0, $78200dbe96418bab$export$2b4fe756f346e3bb)(path, (0, $78200dbe96418bab$export$31553aaa555c1514)(state.path)) : path;
    if ((0, $0e5d1fb0e9c69012$export$d6e6e655ee8621ab)(absolutePath)) return {
        path: absolutePath,
        resourceId: id,
        serviceId: null
    };
    if ((0, $0e5d1fb0e9c69012$export$85e697329f119116)(absolutePath)) return {
        path: absolutePath,
        resourceId: null,
        serviceId: id
    };
    const { serviceId: serviceId } = state;
    (0, $14eddac5f20c576c$export$a7a9523472993e97)(serviceId, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Could not find expected serviceId', {
        args: args
    }));
    return {
        path: absolutePath,
        serviceId: serviceId,
        resourceId: id
    };
};
const $29a5e76a1c2ddc0d$export$d6919acecff2376b = ({ path: path, serviceId: serviceId, resourceId: resourceId })=>(0, $caf14a9745a003dc$export$82476f982757e71e)((0, $78200dbe96418bab$export$339a323fb5b41ef8)(path), {
        serviceId: serviceId || undefined,
        resourceId: resourceId || undefined
    });


const $61c9080582b34f3e$var$DeniedAccess = ({ path: path })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const route = (0, $78200dbe96418bab$export$339a323fb5b41ef8)(path);
    const capabilitiesAlternatives = (0, $78200dbe96418bab$export$c9f0b0bdbee36c23)(path);
    const username = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $1c05f13022cf1480$export$f45ac34dd9e56631));
    const userCapabilities = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $1c05f13022cf1480$export$7326d92567ef4631));
    const { deniedAccess: DeniedAccessRenderer } = (0, $d9696a24a7c3425c$export$13438030b8a2edc1)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(DeniedAccessRenderer, {
        error: new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).AUTHENTICATION_ERROR_TITLE), {
            routeId: path,
            route: route,
            capabilitiesAlternatives: capabilitiesAlternatives,
            username: username,
            userCapabilities: userCapabilities
        })
    });
};
const $61c9080582b34f3e$export$7205e2e4abc22db4 = ({ path: path, children: children })=>{
    const hasRouteCapabilities = (0, $ed3a79aec495d063$export$95fa16a10fc41701)();
    const dispatch = (0, $d9696a24a7c3425c$export$6288a8c52efefdad)();
    const { resourceId: resourceId, serviceId: serviceId } = (0, $caf14a9745a003dc$export$99eaa27ddbbb95ef)();
    const state = (0, $29a5e76a1c2ddc0d$export$a337c713bdba072)(path, resourceId || null, serviceId || null);
    /**
     * Update the whole CybusRouter
     */ (0, $h4Bez.useEffect)(()=>dispatch(state), [
        state.path,
        state.resourceId,
        state.serviceId
    ]);
    /**
     * Re-declaring the provider ensures that the most up to date information will always be available
     */ return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d9696a24a7c3425c$export$710fb77a051eee27), {
        value: state,
        children: hasRouteCapabilities(path) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
            children: children
        }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($61c9080582b34f3e$var$DeniedAccess, {
            path: path
        })
    });
};
const $61c9080582b34f3e$export$a8179c61d425405b = ({ initial: initial, deniedAccess: deniedAccess, children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d9696a24a7c3425c$export$63440d31ac7e2ba8), {
        value: {
            deniedAccess: deniedAccess
        },
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d9696a24a7c3425c$export$710fb77a051eee27), {
            value: {
                path: initial,
                resourceId: null,
                serviceId: null
            },
            children: children
        })
    });


const $e20170eea887eb89$export$2d8d895a0a0f636e = ({ to: to, fallbackToSiblings: fallbackToSiblings })=>{
    const hasCapabilities = (0, $ed3a79aec495d063$export$95fa16a10fc41701)();
    const fallbackParent = fallbackToSiblings && (0, $78200dbe96418bab$export$94372477dfb6d533)(to).parent;
    /**
     * If there is a parent to fallback to, then check permissions of any of the pages under it
     */ const route = fallbackParent && [
        to,
        ...(0, $78200dbe96418bab$export$56850611992c1d8b)(fallbackParent)
    ].find(hasCapabilities) || to;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $caf14a9745a003dc$export$2d8d895a0a0f636e), {
        to: (0, $78200dbe96418bab$export$339a323fb5b41ef8)(route)
    });
};
const $e20170eea887eb89$export$e7b0ac011bb776c6 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $h4Bez.Fragment), {});
const $e20170eea887eb89$export$3b0b963b9c1f6f6c = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $h4Bez.Fragment), {});
const $e20170eea887eb89$var$DefaultRouteNavigation = ({ children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
        children: children
    });
const $e20170eea887eb89$var$isChildOfType = (child, Component)=>child.type === Component;
const $e20170eea887eb89$var$areChildrenOfType = (children, Component)=>children.every((c)=>$e20170eea887eb89$var$isChildOfType(c, Component));
const $e20170eea887eb89$var$resolvePaths = (c)=>'paths' in c.props ? c.props.paths : [
        c.props.path
    ];
const $e20170eea887eb89$export$b5d5cf8927ab7262 = ({ routeNavigation: RouteNavigation = $e20170eea887eb89$var$DefaultRouteNavigation, onNotFound: onNotFound, strict: strict, children: children })=>/**
     * Don't try to move this to another place
     * The ('react-router-dom').Route needs to be exposed directly to the Switch
     */ /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $caf14a9745a003dc$export$b5d5cf8927ab7262), {
        children: [
            ((0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(children) ? children : [
                children
            ]).map((child, k)=>{
                if ($e20170eea887eb89$var$isChildOfType(child, $e20170eea887eb89$export$e7b0ac011bb776c6)) {
                    const paths = $e20170eea887eb89$var$resolvePaths(child);
                    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $caf14a9745a003dc$export$e7b0ac011bb776c6), {
                        path: paths.map((0, $78200dbe96418bab$export$339a323fb5b41ef8)),
                        exact: paths.some((0, $0e5d1fb0e9c69012$export$bc9e294c57c6e14)),
                        render: ({ match: match })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(RouteNavigation, {
                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $61c9080582b34f3e$export$7205e2e4abc22db4), {
                                    path: paths.find((p)=>(0, $78200dbe96418bab$export$339a323fb5b41ef8)(p) === match.path),
                                    children: child.props.children
                                })
                            })
                    }, k);
                }
                if ($e20170eea887eb89$var$isChildOfType(child, $e20170eea887eb89$export$3b0b963b9c1f6f6c) && $e20170eea887eb89$var$areChildrenOfType(child.props.children, $e20170eea887eb89$export$e7b0ac011bb776c6)) {
                    const paths = child.props.children.flatMap($e20170eea887eb89$var$resolvePaths);
                    const Prefix = child.props.prefix;
                    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $caf14a9745a003dc$export$e7b0ac011bb776c6), {
                        path: paths.map((0, $78200dbe96418bab$export$339a323fb5b41ef8)),
                        exact: paths.some((0, $0e5d1fb0e9c69012$export$bc9e294c57c6e14)),
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)(RouteNavigation, {
                            children: [
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Prefix, {}),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($e20170eea887eb89$export$b5d5cf8927ab7262, {
                                    children: child.props.children
                                })
                            ]
                        })
                    }, k);
                }
                /**
             * If you are seeing this error you either:
             *
             * - Are doing something very wrong by passing unsupported child elements to the router/switcher
             * - Forgot to set strict to false in one of your unit tests
             */ (0, $14eddac5f20c576c$export$a7a9523472993e97)(!strict, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Unsupported child found while running in strict mode', {
                    supported: [
                        $e20170eea887eb89$export$e7b0ac011bb776c6.name,
                        $e20170eea887eb89$export$3b0b963b9c1f6f6c.name
                    ]
                }));
                return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $h4Bez.Fragment), {
                    children: child
                }, k);
            }),
            onNotFound && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($e20170eea887eb89$export$2d8d895a0a0f636e, {
                to: onNotFound,
                children: children
            })
        ]
    });
const $e20170eea887eb89$export$3c670f8556d976af = ({ appNavigation: AppNavigation = (0, $h4Bez.Fragment), deniedAccess: deniedAccess = (0, $h4Bez.Fragment), strict: strict = true, initial: initial, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $61c9080582b34f3e$export$a8179c61d425405b), {
        initial: initial,
        deniedAccess: deniedAccess,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(AppNavigation, {
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($e20170eea887eb89$export$b5d5cf8927ab7262, {
                ...props,
                strict: strict
            })
        })
    });




var $h4Bez = parcelRequire("h4Bez");


const $a2d5dfa0dde593a6$export$a2eedec2674b157 = ({ path: path, id: id, children: children })=>{
    const current = (0, $d9696a24a7c3425c$export$9ffe5a2365992c6e)();
    const state = (0, $h4Bez.useMemo)(()=>(0, $29a5e76a1c2ddc0d$export$f6cc4b464535fb2)(current, path, id), [
        current,
        path,
        id
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d9696a24a7c3425c$export$710fb77a051eee27), {
        value: state,
        children: children
    }, JSON.stringify(state));
};










class $42efdbd12003f6a9$var$RoutingHook {
    constructor(history, state){
        this.history = history;
        this.state = state;
    }
    generateRedirectionPath(...args) {
        return (0, $29a5e76a1c2ddc0d$export$d6919acecff2376b)((0, $29a5e76a1c2ddc0d$export$f6cc4b464535fb2)(this.state, ...args));
    }
    getParentAbsoluteRouteUpdateArgs(parent) {
        if ((0, $0e5d1fb0e9c69012$export$bc9e294c57c6e14)(parent)) return [
            parent
        ];
        if ((0, $0e5d1fb0e9c69012$export$85e697329f119116)(parent) && this.state.serviceId) return [
            parent,
            this.state.serviceId
        ];
        throw new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Could not resolve parent path route', {
            ...this.state,
            parent: parent
        });
    }
    redirect(...args) {
        this.history.push(this.generateRedirectionPath(...args));
    }
    redirectToParent() {
        const { parent: parent } = (0, $78200dbe96418bab$export$94372477dfb6d533)(this.state.path);
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(parent, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Route does not have a parent', {
            ...this.state
        }));
        this.redirect(...this.getParentAbsoluteRouteUpdateArgs(parent));
    }
    redirectHome() {
        this.redirect((0, $78200dbe96418bab$export$52f918acf509b2a9));
    }
    getNavigation() {
        const { parents: parents } = (0, $5eed2216d79d12d5$export$d6ed076c6911710a)(this.state.path);
        return [
            this.state.path,
            ...parents.map((p)=>p.id)
        ];
    }
    /** @returns the current page's full path, ids included, so two pages of the same route with different ids differ */ getCurrentPath() {
        return (0, $29a5e76a1c2ddc0d$export$d6919acecff2376b)(this.state);
    }
    /**
     * @returns boolean indicating if the given current route is either the parent route or its child
     */ isAtRoute(path) {
        return !this.state.path || /**
             * Either it is at the route it-self
             */ this.state.path === path || /**
             * Or the parent contains it
             */ (0, $5eed2216d79d12d5$export$d6ed076c6911710a)(this.state.path).parents.some((parent)=>parent.id === path);
    }
    goBack() {
        this.history.goBack();
    }
}
const $42efdbd12003f6a9$export$ddab236f5c469f6f = (0, $a1a6d7d0f76ede8d$export$902abe05969bdd53)(()=>[
        (0, $caf14a9745a003dc$export$3420e1dc2c4a518c)(),
        (0, $d9696a24a7c3425c$export$9ffe5a2365992c6e)()
    ], $42efdbd12003f6a9$var$RoutingHook, 'useRouting');







const $ca669ae6ce7b2d0a$export$607b8f485166a346 = (0, $42efdbd12003f6a9$export$ddab236f5c469f6f).extend((RoutingHook)=>class extends RoutingHook {
        getAbsoluteRoute(relativePath) {
            return (0, $78200dbe96418bab$export$2b4fe756f346e3bb)(relativePath, (0, $78200dbe96418bab$export$31553aaa555c1514)(this.state.path));
        }
        getParentAbsoluteRouteUpdateArgs(parent) {
            return super.getParentAbsoluteRouteUpdateArgs(parent);
        }
        createHref(...args) {
            return this.history.createHref((0, $044ea197e08add36$export$90c043f1c57770b8)(this.generateRedirectionPath(...args)));
        }
    }, 'useInternalRoutingHook');


const $8ac6a9562d3ad82e$export$be7d636ea06a97e0 = (route)=>{
    const hasCapabilities = (0, $ed3a79aec495d063$export$95fa16a10fc41701)();
    const router = (0, $ca669ae6ce7b2d0a$export$607b8f485166a346)();
    const absoluteRoute = (0, $0e5d1fb0e9c69012$export$b6418d9b7e088a5)(route) ? router.getAbsoluteRoute(route) : route;
    if (!hasCapabilities(absoluteRoute)) return null;
    return {
        path: absoluteRoute,
        redirect: (id)=>router.redirect(absoluteRoute, id),
        createHref: (id)=>router.createHref(absoluteRoute, id)
    };
};


const $8e52a8f0c49c306f$export$50a08f8725efa458 = (route, idMapper)=>{
    const routeWithId = (0, $8ac6a9562d3ad82e$export$be7d636ea06a97e0)(route);
    return routeWithId ? (i)=>routeWithId.redirect(idMapper(i)) : undefined;
};






class $124a99bb16e8bbff$var$RouteFormatter {
    constructor(translator){
        this.translator = translator;
    }
    formatTitle(routePath) {
        const { title: title, isTitleSingular: isTitleSingular = false } = (0, $78200dbe96418bab$export$94372477dfb6d533)(routePath);
        return this.translator.formatTranslation(title, {
            count: Number(isTitleSingular)
        });
    }
}
const $124a99bb16e8bbff$export$67610e1c203fd6f4 = (0, $a1a6d7d0f76ede8d$export$902abe05969bdd53)(()=>[
        (0, $dcd310acfec43287$export$e6df4a75350b1cee)()
    ], $124a99bb16e8bbff$var$RouteFormatter, 'useRouteFormatter');







const $cfc475b7bd8e89ca$var$createStateChecker = (isEnumOf)=>(state)=>isEnumOf(state.path);
const $cfc475b7bd8e89ca$var$isAbsoluteRoutePathWithResourceIdState = $cfc475b7bd8e89ca$var$createStateChecker((0, $0e5d1fb0e9c69012$export$d6e6e655ee8621ab));
const $cfc475b7bd8e89ca$var$isAbsoluteRoutePathWithServiceIdState = $cfc475b7bd8e89ca$var$createStateChecker((0, $0e5d1fb0e9c69012$export$85e697329f119116));
const $cfc475b7bd8e89ca$var$isAbsoluteRoutePathWithServiceAndResourceIdState = $cfc475b7bd8e89ca$var$createStateChecker((0, $0e5d1fb0e9c69012$export$c859ee50307dd2d3));
const $cfc475b7bd8e89ca$export$f680877a34711e37 = ()=>{
    const state = (0, $d9696a24a7c3425c$export$9ffe5a2365992c6e)();
    if ($cfc475b7bd8e89ca$var$isAbsoluteRoutePathWithResourceIdState(state) || $cfc475b7bd8e89ca$var$isAbsoluteRoutePathWithServiceAndResourceIdState(state)) return state.resourceId;
    if ($cfc475b7bd8e89ca$var$isAbsoluteRoutePathWithServiceIdState(state)) return state.serviceId;
    return (0, $ea3ab9f98af64a6e$export$7914be4505ea8cc6)(new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).STATE, 'Id not retrievable under this route', state), $cfc475b7bd8e89ca$export$f680877a34711e37);
};




var $h4Bez = parcelRequire("h4Bez");




const $7d5f64758ce3b1db$var$splitRoutingProps = (props)=>{
    if ('parent' in props) {
        const { parent: parent, ...parentLessProps } = props;
        return [
            {
                parent: parent
            },
            parentLessProps
        ];
    }
    if ('id' in props) {
        const { path: path, id: id, ...idLessProps } = props;
        return [
            {
                path: path,
                id: id
            },
            idLessProps
        ];
    }
    const { path: path, ...pathLessProps } = props;
    return [
        {
            path: path
        },
        pathLessProps
    ];
};
const $7d5f64758ce3b1db$var$resolveAbsoluteRouteUpdateArgs = (routing, props)=>{
    if ('id' in props) {
        const route = (0, $0e5d1fb0e9c69012$export$b6418d9b7e088a5)(props.path) ? routing.getAbsoluteRoute(props.path) : props.path;
        return [
            route,
            props.id
        ];
    }
    if ('parent' in props) return routing.getParentAbsoluteRouteUpdateArgs(props.parent);
    return [
        props.path
    ];
};
const $7d5f64758ce3b1db$var$defaultWrapper = ({ children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
        children: children
    });
const $7d5f64758ce3b1db$var$InternalLink = /*#__PURE__*/ (0, $h4Bez.forwardRef)((allProps, ref)=>{
    const [routeProps, { wrapper: Wrapper = $7d5f64758ce3b1db$var$defaultWrapper, routing: routing, hasCapabilities: hasCapabilities, children: children, ...props }] = $7d5f64758ce3b1db$var$splitRoutingProps(allProps);
    const args = $7d5f64758ce3b1db$var$resolveAbsoluteRouteUpdateArgs(routing, routeProps);
    const [route] = args;
    const authorized = hasCapabilities(route);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Wrapper, {
        authorized: authorized,
        children: authorized ? // data-testid comes before the spread so a caller's own one (via props) overrides this default.
        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a497eee141ca75b8$export$2e2bcd8739ae039), {
            "data-testid": `permissioned-link-${route}`,
            ...props,
            ref: ref,
            underline: "none",
            href: routing.createHref(...args),
            children: children
        }) : children
    });
});
const $7d5f64758ce3b1db$export$8c81d7b771b7392a = ()=>{
    const hasCapabilities = (0, $ed3a79aec495d063$export$95fa16a10fc41701)();
    const routing = (0, $ca669ae6ce7b2d0a$export$607b8f485166a346)();
    return (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($7d5f64758ce3b1db$var$InternalLink, {
            ...props,
            routing: routing,
            hasCapabilities: hasCapabilities
        });
};
const $7d5f64758ce3b1db$export$bf4bb1ff1ff62959 = (props)=>{
    const InternalLink = $7d5f64758ce3b1db$export$8c81d7b771b7392a();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(InternalLink, {
        ...props
    });
};
const $7d5f64758ce3b1db$export$93fe4a80834d0286 = /*#__PURE__*/ (0, $h4Bez.forwardRef)((props, ref)=>{
    const hasCapabilities = (0, $ed3a79aec495d063$export$95fa16a10fc41701)();
    const routing = (0, $ca669ae6ce7b2d0a$export$607b8f485166a346)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($7d5f64758ce3b1db$var$InternalLink, {
        ...props,
        ref: ref,
        routing: routing,
        hasCapabilities: hasCapabilities
    });
});








/** Where the record is in the whole list, if it's among the shown rows */ const $f15fafcfefe31e1a$var$locate = (rows, id, pagination)=>{
    const index = rows.findIndex((row)=>row.id === id);
    if (index < 0 || pagination === null) return null;
    const { page: page, pageSize: pageSize, totalCount: totalCount } = pagination;
    const position = {
        index: page * pageSize + index,
        total: totalCount
    };
    const previous = rows[index - 1];
    const next = rows[index + 1];
    return {
        position: position,
        previous: previous ? {
            id: previous.id
        } : position.index > 0 ? {
            page: page - 1
        } : null,
        next: next ? {
            id: next.id
        } : position.index + 1 < totalCount ? {
            page: page + 1
        } : null
    };
};
/** The record to open once the pending step's page has loaded, `null` if there is none, `undefined` while waiting */ const $f15fafcfefe31e1a$var$resolvePendingStep = ({ direction: direction, page: page, from: from }, { rows: rows, loaded: loaded, failed: failed, pagination: pagination })=>{
    if (failed) return null;
    /** Still the page turned from, also in a render before the request has reached the state */ if (!loaded || pagination === from) return undefined;
    if (pagination?.page !== page) return null;
    return (direction === 'next' ? rows[0] : rows[rows.length - 1]) ?? null;
};
const $f15fafcfefe31e1a$var$OpenRecordPanel = ({ route: route, details: Details, id: id, position: position, onPrevious: onPrevious, onNext: onNext, open: open, title: title, opening: opening, openRecordSelected: openRecordSelected, rowElements: rowElements, hide: hide, onExited: onExited, onTitle: onTitle, onModalsOwner: onModalsOwner, width: width, onWidthChange: onWidthChange })=>{
    const content = (0, $h4Bez.useMemo)(()=>({
            close: ()=>{
                hide();
                const row = rowElements.get(id);
                if (row?.isConnected) row.focus();
            },
            dismiss: hide,
            openRecordSelected: openRecordSelected,
            showTitle: onTitle,
            takeOverModals: onModalsOwner
        }), [
        hide,
        rowElements,
        id,
        openRecordSelected,
        onTitle,
        onModalsOwner
    ]);
    /**
     * The same element across the panel's own changes, such as its title or position, so they don't re-render the details
     *
     * TODO: CC-5041 (https://cybusio.atlassian.net/browse/CC-5041) - read the open record here, so the details don't report it up and this memo goes
     */ const details = (0, $h4Bez.useMemo)(()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a2d5dfa0dde593a6$export$a2eedec2674b157), {
            path: route.path,
            id: id,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e4c7f584ea42cc55$export$33c86ae21ccab5b4), {
                value: content,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Details, {})
            })
        }, opening), [
        opening,
        route.path,
        id,
        content,
        Details
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2dbb652f558165cf$export$ab5c4b9e4514633f), {
        open: open,
        title: title ?? id,
        position: position,
        onPrevious: onPrevious,
        onNext: onNext,
        onExpand: ()=>route.redirect(id),
        onClose: content.close,
        onExited: onExited,
        width: width,
        onWidthChange: onWidthChange,
        children: details
    });
};
const $f15fafcfefe31e1a$export$cb6091994270a19e = ({ route: route, details: details, rows: rows, loaded: loaded, failed: failed, pagination: pagination, turnPage: turnPage })=>{
    const recordPanelWidthUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('recordPanelWidthUsecase');
    /** The record shown, kept while the panel leaves */ const [openId, setOpenId] = (0, $h4Bez.useState)(null);
    const [open, setOpen] = (0, $h4Bez.useState)(false);
    const [title, setTitle] = (0, $h4Bez.useState)(null);
    const [modalsOwnerId, setModalsOwnerId] = (0, $h4Bez.useState)(null);
    const [openRecordSelected, setOpenRecordSelected] = (0, $h4Bez.useState)(false);
    const [opening, setOpening] = (0, $h4Bez.useState)(0);
    const [pendingStep, setPendingStep] = (0, $h4Bez.useState)(null);
    const [width, setWidth] = (0, $h4Bez.useState)(null);
    const rowElements = (0, $h4Bez.useRef)(new Map());
    /** The record whose row takes the focus once rendered, as the table renders a turned page's rows after it has loaded */ const focusOnRender = (0, $h4Bez.useRef)(null);
    const show = (0, $h4Bez.useCallback)((id)=>{
        if (id !== openId) setTitle(null);
        if (!open) {
            setOpening((count)=>count + 1);
            setWidth(recordPanelWidthUsecase.get());
        }
        setOpenId(id);
        setOpen(true);
        setPendingStep(null);
        focusOnRender.current = null;
    }, [
        openId,
        open,
        recordPanelWidthUsecase
    ]);
    const onWidthChange = (0, $h4Bez.useCallback)((changed)=>{
        setWidth(changed);
        recordPanelWidthUsecase.save(changed);
    }, [
        recordPanelWidthUsecase
    ]);
    const hide = (0, $h4Bez.useCallback)(()=>{
        setOpen(false);
        setPendingStep(null);
        focusOnRender.current = null;
    }, []);
    const onExited = (0, $h4Bez.useCallback)(()=>{
        setOpenId(null);
        setTitle(null);
    }, []);
    const rowRef = (0, $h4Bez.useCallback)((row, element)=>{
        if (element) {
            rowElements.current.set(row.id, element);
            if (focusOnRender.current === row.id) {
                focusOnRender.current = null;
                element.focus();
            }
        } else rowElements.current.delete(row.id);
    }, []);
    /** Before paint, so the panel doesn't show its record without a position in between */ (0, $h4Bez.useLayoutEffect)(()=>{
        if (pendingStep === null) return;
        const target = $f15fafcfefe31e1a$var$resolvePendingStep(pendingStep, {
            rows: rows,
            loaded: loaded,
            failed: failed,
            pagination: pagination
        });
        if (target === undefined) return;
        setPendingStep(null);
        if (target === null) return;
        show(target.id);
        if (pendingStep.focusRow) focusOnRender.current = target.id;
    }, [
        pendingStep,
        rows,
        loaded,
        failed,
        pagination,
        show
    ]);
    const location = openId === null ? null : $f15fafcfefe31e1a$var$locate(rows, openId, pagination);
    const toStepHandler = (step, direction)=>{
        if (!step || !loaded || pendingStep !== null || openId === null) return undefined;
        if ('id' in step) return ()=>show(step.id);
        return ()=>{
            setPendingStep({
                direction: direction,
                page: step.page,
                from: pagination,
                focusRow: document.activeElement === rowElements.current.get(openId)
            });
            turnPage(step.page);
        };
    };
    return {
        tableProps: {
            onRowClick: ({ id: id })=>show(id),
            isRowActive: ({ id: id })=>open && id === openId,
            rowRef: rowRef
        },
        modalsOwnerId: modalsOwnerId,
        onOpenRecordSelected: setOpenRecordSelected,
        panel: openId === null ? null : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($f15fafcfefe31e1a$var$OpenRecordPanel, {
            route: route,
            details: details,
            id: openId,
            position: location?.position ?? null,
            onPrevious: toStepHandler(location?.previous, 'previous'),
            onNext: toStepHandler(location?.next, 'next'),
            open: open,
            title: title,
            opening: opening,
            openRecordSelected: openRecordSelected,
            rowElements: rowElements.current,
            hide: hide,
            onExited: onExited,
            onTitle: setTitle,
            onModalsOwner: setModalsOwnerId,
            width: width,
            onWidthChange: onWidthChange
        })
    };
};




var $h4Bez = parcelRequire("h4Bez");

const $663c2020f609bbba$var$RecordPanelDetailsContext = /*#__PURE__*/ (0, $h4Bez.createContext)({});
const $663c2020f609bbba$export$6cb0eff68b40b60a = ({ details: details, children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($663c2020f609bbba$var$RecordPanelDetailsContext.Provider, {
        value: details,
        children: children
    });
const $663c2020f609bbba$export$b10166df39822642 = (route)=>{
    const details = (0, $h4Bez.useContext)($663c2020f609bbba$var$RecordPanelDetailsContext);
    const inPanel = (0, $e4c7f584ea42cc55$export$d85795532116d29b)() !== null;
    if (route === null || inPanel) return null;
    return details[route] ?? null;
};





const $1340d16cad42623c$var$dialogEntryStyle = {
    mt: 1
};
const $1340d16cad42623c$var$progressStyle = {
    width: '100%',
    position: 'absolute'
};
const $1340d16cad42623c$var$dialogTitleStyle = {
    pt: 5,
    px: 5,
    pb: 0
};
const $1340d16cad42623c$var$dialogContentStyle = {
    px: 5
};
const $1340d16cad42623c$var$dialogActionsStyle = {
    px: 5,
    pb: 5,
    pt: 2
};
const $1340d16cad42623c$var$OpenedBulkModal = ({ type: type, title: title, subtitle: subtitle, infoBody: infoBody, confirm: confirm, selected: selected, load: load, onRenderLine: Render = (0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), onRenderLineContent: RenderContent, onCancel: onCancel, onConfirm: onConfirm, showOnlyOnError: showOnlyOnError })=>{
    const [onClick] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(()=>Promise.resolve(onConfirm()), [
        onConfirm
    ]);
    if (showOnlyOnError && selected.every(showOnlyOnError) && !(0, $c3e1b746ad236797$export$8d524fb6540252df).is(load)) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $55a2a796d4e0875c$export$2e2bcd8739ae039), {
        "data-testid": `bulk-modal-${type}`,
        disableEscapeKeyDown: true,
        maxWidth: "md",
        open: true,
        children: [
            load === true && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2db76c9e9f88b3ff$export$2e2bcd8739ae039), {
                variant: "indeterminate",
                sx: $1340d16cad42623c$var$progressStyle
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dfd39f6bb0de9c2f$export$2e2bcd8739ae039), {
                "data-testid": `bulk-modal-${type}-title`,
                sx: $1340d16cad42623c$var$dialogTitleStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $be3703687194c6e0$export$56e2352e63353d99), {
                    title: [
                        title,
                        {
                            count: selected.length
                        }
                    ],
                    description: infoBody && [
                        subtitle,
                        infoBody
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $0aa27c46708d7ed8$export$2e2bcd8739ae039), {
                "data-testid": `bulk-modal-${type}-content`,
                sx: $1340d16cad42623c$var$dialogContentStyle,
                children: [
                    (0, $c3e1b746ad236797$export$8d524fb6540252df).is(load) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
                        error: load,
                        titleVariant: "subtitle1",
                        extras: "popover"
                    }),
                    !infoBody && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        sx: $1340d16cad42623c$var$dialogEntryStyle,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: subtitle,
                            values: {
                                count: selected.length,
                                br: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("br", {}),
                                p: (0, $4772774eee62bdcc$export$18fadbe56dfcb1a1)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                                    variant: 'body1',
                                    color: 'textSecondary'
                                })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
                        children: selected.map((resource, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Render, {
                                children: typeof RenderContent === 'string' ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
                                    children: resource[RenderContent]
                                }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(RenderContent, {
                                    resource: resource
                                })
                            }, k))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $12b0eeebf4fed103$export$2e2bcd8739ae039), {
                sx: $1340d16cad42623c$var$dialogActionsStyle,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                        "data-testid": `bulk-modal-${type}-cancellation`,
                        variant: "secondary",
                        onClick: onCancel,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CANCEL
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                        "data-testid": `bulk-modal-${type}-confirmation`,
                        variant: type === 'delete' ? 'danger' : 'primary',
                        onClick: onClick,
                        disabled: load === true,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: confirm
                        })
                    })
                ]
            })
        ]
    });
};
const $1340d16cad42623c$var$areHooksPropsEquals = (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
    selected: (a, b)=>(0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(a) && (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(b) && (0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(a, b, {
            sort: false
        }),
    load: null,
    shouldCancel: null
});
const $1340d16cad42623c$var$BulkModal = ({ resourceSelector: resourceSelector, ...props })=>{
    const { dimension: dimension, type: type, onCancel: onCancel } = props;
    const owned = (0, $e5cfe4b27a81cb80$export$7b6095cc374a51c9)((0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>(0, $5e13938500eec645$export$e9290a5ccd17ff37)(s, dimension, type).ids, [
        dimension,
        type
    ]));
    const { selected: selected, load: load, shouldCancel: shouldCancel } = (0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>{
        const { ids: ids, load: load } = (0, $5e13938500eec645$export$e9290a5ccd17ff37)(s, dimension, type);
        if (!owned) /** Another modal of the same action has it, so this one neither shows nor cancels it */ return {
            selected: [],
            load: false,
            shouldCancel: false
        };
        const selected = resourceSelector(s, ids ?? []);
        return {
            selected: selected,
            load: load,
            /** There is a mismatch and nothing is being loaded right now, then close the modal  */ shouldCancel: load === false && (ids?.length ?? 0) !== selected.length
        };
    }, [
        dimension,
        type,
        resourceSelector,
        owned
    ], $1340d16cad42623c$var$areHooksPropsEquals);
    (0, $h4Bez.useEffect)(()=>{
        if (shouldCancel) onCancel();
    }, [
        shouldCancel
    ]);
    return (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(selected) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1340d16cad42623c$var$OpenedBulkModal, {
        ...props,
        selected: selected,
        load: load
    }) : null;
};
const $1340d16cad42623c$export$f6737f912c21f59d = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1340d16cad42623c$var$BulkModal, {
        type: "disable",
        ...props
    });
const $1340d16cad42623c$export$10f512a97cdb6733 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1340d16cad42623c$var$BulkModal, {
        type: "enable",
        ...props
    });
const $1340d16cad42623c$export$974e9706e327ba45 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1340d16cad42623c$var$BulkModal, {
        type: "reenable",
        ...props
    });
const $1340d16cad42623c$export$54399887e057b4b7 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1340d16cad42623c$var$BulkModal, {
        type: "delete",
        ...props
    });




var $h4Bez = parcelRequire("h4Bez");








var $h4Bez = parcelRequire("h4Bez");

const $23ccc64722af8c7f$var$filterKinds = [
    'connection',
    'server',
    'service'
];
/**
 * One view per list and variant, whichever resource the list is filtered by.
 * The kind of filter is part of the variant, as it changes the columns (e.g. endpoints under a connection have no connection column),
 * and saving a view drops the names that aren't columns of the table it was saved from
 */ const $23ccc64722af8c7f$var$toColumnViewId = (subscriptionUsecaseName, short, filter)=>[
        subscriptionUsecaseName,
        short ? 'short' : 'full',
        ...$23ccc64722af8c7f$var$filterKinds.filter((kind)=>Boolean(filter[kind]))
    ].join(':');
const $23ccc64722af8c7f$export$ddca39529720c1e7 = (subscriptionUsecaseName, short, filter)=>{
    const tableColumnViewUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('tableColumnViewUsecase');
    const id = $23ccc64722af8c7f$var$toColumnViewId(subscriptionUsecaseName, short, filter);
    const saved = (0, $h4Bez.useMemo)(()=>tableColumnViewUsecase.get(id), [
        tableColumnViewUsecase,
        id
    ]);
    const [changed, setChanged] = (0, $h4Bez.useState)(null);
    const onColumnViewChange = (0, $h4Bez.useCallback)((view)=>{
        setChanged({
            id: id,
            view: view
        });
        tableColumnViewUsecase.save(id, view);
    }, [
        tableColumnViewUsecase,
        id
    ]);
    return {
        columnView: changed?.id === id ? changed.view : saved,
        onColumnViewChange: onColumnViewChange
    };
};





const $03ae09961ed46a28$export$a97c3cc4bf1da1ca = ({ hasManagementCapabilitiesSelector: hasManagementCapabilitiesSelector = ()=>true, selection: selection })=>{
    const usecases = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    const canManage = (0, $be523f14267dcd17$export$9973955de2bf96cf)(hasManagementCapabilitiesSelector);
    const icons = {};
    const labels = {};
    if (!selection || !canManage) return;
    const { resource: resource, usecaseMethod: selectionMethod, ...actions } = selection;
    (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(actions).forEach(([actionName, config])=>{
        if (config?.icon) icons[actionName] = config.icon;
        if (config?.label) labels[actionName] = config.label;
    });
    return {
        onSelect: (lines)=>{
            const out = {};
            (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(actions).forEach(([actionName, config])=>{
                (0, $14eddac5f20c576c$export$a7a9523472993e97)(config, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Undefined value is not expected as valid'));
                if (config.filterAll && !config.filterAll(lines) || config.filter && !lines.every(config.filter)) /**
                     * Either filter is present, but has rejeced the selection
                     * Therefore the action is not available for the given resources
                     */ return;
                const { [config.usecase]: usecase } = usecases;
                out[actionName] = (resources)=>usecase[selectionMethod](resources.map((r)=>String(r[resource])));
            });
            return out;
        },
        idField: selection.resource,
        icons: icons,
        labels: labels
    };
};


const $8aa67788985a70f6$var$isPageDataLoaded = (data)=>data !== null && !(0, $c3e1b746ad236797$export$8d524fb6540252df).is(data);
const $8aa67788985a70f6$var$useLastLoadedPageData = (page, subscriptionKey)=>{
    const committedSubscriptionKey = (0, $h4Bez.useRef)(subscriptionKey);
    const last = (0, $h4Bez.useRef)(null);
    /** On the render where the subscription changes, the page still holds the previous subscription's data */ const pageData = page?.data ?? null;
    const currentData = committedSubscriptionKey.current === subscriptionKey && $8aa67788985a70f6$var$isPageDataLoaded(pageData) ? pageData : null;
    const pageIndex = page?.pagination.page ?? null;
    const pageSize = page?.pagination.pageSize ?? null;
    const current = (0, $h4Bez.useMemo)(()=>currentData !== null && pageIndex !== null && pageSize !== null ? {
            data: currentData,
            pagination: {
                page: pageIndex,
                pageSize: pageSize
            }
        } : null, [
        currentData,
        pageIndex,
        pageSize
    ]);
    (0, $h4Bez.useEffect)(()=>{
        committedSubscriptionKey.current = subscriptionKey;
        if (current !== null) last.current = {
            subscriptionKey: subscriptionKey,
            page: current
        };
    }, [
        current,
        subscriptionKey
    ]);
    if (current !== null) return {
        page: current,
        loaded: true
    };
    return {
        page: last.current?.subscriptionKey === subscriptionKey ? last.current.page : null,
        loaded: false
    };
};
const $8aa67788985a70f6$var$mapTableCustomizedStateToSubscriptionUpdateParameters = (s)=>{
    if ('search' in s) /**
         * Search is nullable on SubscriptionUpdateParameters
         * @see {SubscriptionUpdateParameters['search']}
         */ return {
        search: s.search || null
    };
    if ('sortOrder' in s) return {
        /**
             * This coercion is fine, as the type SortableCoercion above is only allowing sorting for column in data
             * @see {SortableCoercion}
             */ sort: {
            column: s.sortOrder.name,
            asc: s.sortOrder.direction === 'asc'
        }
    };
    /** These can be passed as is */ return s;
};
/**
 * The state behind a table that
 *
 * - While mounted, subscribes to the given usecase (if the same is subscribable)
 * - Handles state changes (loading, error, success) of the given resources in order to properly render the contents
 */ const $8aa67788985a70f6$var$useResourcesTable = ({ subscriptionUsecase: subscriptionUsecaseName, filter: filter = {}, data: dataSelector, hasManagementCapabilitiesSelector: hasManagementCapabilitiesSelector, dataTableMapper: dataTableMapper, translations: translations, selection: selection, short: short = false, ...props })=>{
    const subscriptionUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)(subscriptionUsecaseName);
    const resourcesPage = (0, $be523f14267dcd17$export$9973955de2bf96cf)(dataSelector, (0, $e926476d3d092144$export$befd6eec7b379c32));
    const selectionConfig = (0, $03ae09961ed46a28$export$a97c3cc4bf1da1ca)({
        hasManagementCapabilitiesSelector: hasManagementCapabilitiesSelector,
        selection: selection
    });
    const { columnView: columnView, onColumnViewChange: onColumnViewChange } = (0, $23ccc64722af8c7f$export$ddca39529720c1e7)(subscriptionUsecaseName, short, filter);
    const shownData = $8aa67788985a70f6$var$useLastLoadedPageData(resourcesPage, JSON.stringify([
        filter.connection,
        filter.server,
        filter.service,
        short
    ]));
    /** Retrying drops the current subscription and subscribes again, which starts the page over */ const [subscriptionAttempt, retrySubscription] = (0, $9dfd779a84325298$export$aa7f9ebe4f644d13)();
    /** Subscribe to changes of resources */ (0, $h4Bez.useEffect)(()=>subscriptionUsecase.subscribe({
            ...filter,
            short: short
        }), [
        subscriptionUsecase,
        filter.connection,
        filter.server,
        filter.service,
        short,
        subscriptionAttempt
    ]);
    /** Load the possible page sizes to be used */ const [pageSizeOptions, searchThreshold] = (0, $h4Bez.useMemo)(()=>[
            (0, $091d28ec500ee607$export$efe56791b10fc931)(subscriptionUsecase.getPaginationSizes()),
            subscriptionUsecase.getResourcesSearchThreshold()
        ], []);
    const onCustomized = (0, $h4Bez.useCallback)((s)=>subscriptionUsecase.updateParameters($8aa67788985a70f6$var$mapTableCustomizedStateToSubscriptionUpdateParameters(s)), [
        subscriptionUsecase
    ]);
    const turnPage = (0, $h4Bez.useCallback)((page)=>subscriptionUsecase.updateParameters({
            page: page
        }), [
        subscriptionUsecase
    ]);
    const shownPage = shownData.page;
    const totalCount = shownPage?.data.totalCount ?? null;
    const pagination = (0, $h4Bez.useMemo)(()=>shownPage && {
            ...shownPage.pagination,
            totalCount: shownPage.data.totalCount
        }, [
        shownPage
    ]);
    const tablePagination = resourcesPage ? {
        ...resourcesPage.pagination,
        pageSizeOptions: pageSizeOptions,
        ...totalCount !== null && {
            totalCount: totalCount
        },
        showTotalCount: true
    } : undefined;
    const error = resourcesPage !== null && (0, $c3e1b746ad236797$export$8d524fb6540252df).is(resourcesPage.data) ? {
        error: resourcesPage.data,
        onRetry: retrySubscription
    } : undefined;
    const rows = shownPage === null ? [] : dataTableMapper(shownPage.data.current);
    return {
        tableProps: {
            'data-testid': subscriptionUsecaseName,
            error: error,
            selection: selectionConfig,
            search: resourcesPage === null || resourcesPage.search === null || resourcesPage.search,
            searchThreshold: searchThreshold,
            data: rows,
            loading: !shownData.loaded,
            pagination: tablePagination,
            sortOrder: resourcesPage ? {
                name: resourcesPage.sort.column,
                direction: resourcesPage.sort.asc ? 'asc' : 'desc'
            } : undefined,
            translations: translations,
            onCustomized: onCustomized,
            sortData: false,
            columnView: columnView,
            onColumnViewChange: onColumnViewChange,
            ...props
        },
        rows: rows,
        loaded: shownData.loaded,
        failed: error !== undefined,
        pagination: pagination,
        turnPage: turnPage
    };
};
const $8aa67788985a70f6$export$b5d723e193e2be22 = ({ children: children, ...props })=>{
    const { tableProps: tableProps } = $8aa67788985a70f6$var$useResourcesTable(props);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        ...tableProps,
        children: children
    });
};
const $8aa67788985a70f6$var$openInNewTab = (route, id)=>{
    window.open(route.createHref(id), '_blank', 'noopener');
};
const $8aa67788985a70f6$var$PanelHostingResourcesTable = ({ route: route, details: details, children: children, ...props })=>{
    const { tableProps: tableProps, ...shown } = $8aa67788985a70f6$var$useResourcesTable(props);
    const host = (0, $f15fafcfefe31e1a$export$cb6091994270a19e)({
        route: route,
        details: details,
        ...shown
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
                ...tableProps,
                ...host.tableProps,
                onRowOpenInNewTab: ({ id: id })=>$8aa67788985a70f6$var$openInNewTab(route, id),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e5cfe4b27a81cb80$export$93995fac08b83001), {
                    openId: host.modalsOwnerId,
                    onOpenRecordSelected: host.onOpenRecordSelected,
                    children: children
                })
            }),
            host.panel
        ]
    });
};
const $8aa67788985a70f6$export$b3c28590d63f6eca = ({ redirectOnRowclick: redirectOnRowclick, ...props })=>{
    const route = (0, $8ac6a9562d3ad82e$export$be7d636ea06a97e0)(redirectOnRowclick);
    const details = (0, $663c2020f609bbba$export$b10166df39822642)(route?.path ?? null);
    if (!route) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($8aa67788985a70f6$export$b5d723e193e2be22, {
        ...props
    });
    if (details) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($8aa67788985a70f6$var$PanelHostingResourcesTable, {
        ...props,
        route: route,
        details: details
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($8aa67788985a70f6$export$b5d723e193e2be22, {
        ...props,
        onRowClick: ({ id: id })=>route.redirect(id),
        onRowOpenInNewTab: ({ id: id })=>$8aa67788985a70f6$var$openInNewTab(route, id)
    });
};






var $h4Bez = parcelRequire("h4Bez");








const $264fddb75d092ad2$var$wrapperStyle = {
    mt: 2,
    width: '100%'
};
const $264fddb75d092ad2$var$panelActionsStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
};
const $264fddb75d092ad2$export$2e9120d34faa9c1f = ({ resourceSelector: resourceSelector, subscriptionUsecase: subscriptionUsecase, notFoundTitle: notFoundTitle, modals: Modals, headerResourceName: headerResourceName, headerName: headerName, headerActions: HeaderActions, infoTitle: infoTitle, infoBody: infoBody, headerDetails: HeaderDetails, content: Content })=>{
    const id = (0, $cfc475b7bd8e89ca$export$f680877a34711e37)();
    const routing = (0, $42efdbd12003f6a9$export$ddab236f5c469f6f)();
    const panel = (0, $e4c7f584ea42cc55$export$d85795532116d29b)();
    const resource = (0, $be523f14267dcd17$export$9973955de2bf96cf)(resourceSelector);
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const subscription = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)(subscriptionUsecase);
    /**
     * Subscribe to resource changes
     */ (0, $h4Bez.useEffect)(()=>subscription.subscribe(id), [
        subscription,
        id
    ]);
    /** In a panel, until the subscription resets it, the state can still hold the previous record's resource */ const current = resource !== null && !(0, $c3e1b746ad236797$export$8d524fb6540252df).is(resource) && (panel === null || resource.id === id) ? resource : null;
    const lastFound = (0, $h4Bez.useRef)(null);
    lastFound.current = current ?? lastFound.current;
    /** In a panel, a resource found before and then not found anymore (e.g. deleted from the list) stays shown while the panel leaves */ const gone = panel !== null && lastFound.current !== null && (0, $c3e1b746ad236797$export$8d524fb6540252df).isOfTypes(resource, (0, $c3e1b746ad236797$export$13cd8ea82c82bf53).NOT_FOUND);
    const shown = current ?? (gone ? lastFound.current : null);
    const title = shown === null ? null : String(shown[headerName]);
    /**
     * The panel's facts about its record, reported up from here because only the details know the resource
     *
     * TODO: CC-5041 (https://cybusio.atlassian.net/browse/CC-5041) - let the panel read its record itself, so these effects go
     */ (0, $h4Bez.useEffect)(()=>{
        if (gone) panel?.dismiss();
    }, [
        gone,
        panel
    ]);
    (0, $h4Bez.useEffect)(()=>{
        if (panel && title !== null) panel.showTitle(title);
    }, [
        panel,
        title
    ]);
    if (shown === null) return (0, $c3e1b746ad236797$export$8d524fb6540252df).is(resource) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
        "data-testid": "resource-details-error",
        customTitle: (e)=>(0, $c3e1b746ad236797$export$8d524fb6540252df).isOfTypes(e, (0, $c3e1b746ad236797$export$13cd8ea82c82bf53).NOT_FOUND) ? translator.formatTranslation(notFoundTitle, {
                id: id
            }) : null,
        error: resource,
        stack: true,
        extras: "section"
    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $35e2f7ba0c5bb8e5$export$8b8493c40023057), {});
    if (panel) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                "data-testid": "resource-details-panel-actions",
                sx: $264fddb75d092ad2$var$panelActionsStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(HeaderActions, {
                    resource: shown
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(HeaderDetails, {
                resource: shown
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $264fddb75d092ad2$var$wrapperStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Content, {
                    resource: shown
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e4c7f584ea42cc55$export$326eba82f21a8b7a), {
                id: id,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Modals, {
                    leave: panel.close
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $be3703687194c6e0$export$56e2352e63353d99), {
                title: [
                    headerResourceName,
                    {
                        count: 1
                    }
                ],
                titleAppendix: String(shown[headerName]),
                titleActions: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(HeaderActions, {
                    resource: shown
                }),
                description: [
                    infoTitle,
                    infoBody
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(HeaderDetails, {
                resource: shown
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $264fddb75d092ad2$var$wrapperStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Content, {
                    resource: shown
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Modals, {
                leave: ()=>routing.redirectToParent()
            })
        ]
    });
};




parcelRequire("h4Bez");




var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");











function $bdc03ab893a59c5d$export$72aef224d6115253(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiTab', slot);
}
const $bdc03ab893a59c5d$var$tabClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper',
    'icon'
]);
var $bdc03ab893a59c5d$export$2e2bcd8739ae039 = $bdc03ab893a59c5d$var$tabClasses;



'use client';
const $ca50fd7418c7c1d3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        icon: [
            'iconWrapper',
            'icon'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $bdc03ab893a59c5d$export$72aef224d6115253), classes);
};
const $ca50fd7418c7c1d3$var$TabRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d02728b6fe958b24$export$2e2bcd8739ae039), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $bdc03ab893a59c5d$export$2e2bcd8739ae039).iconWrapper}`]: styles.iconWrapper
            },
            {
                [`& .${(0, $bdc03ab893a59c5d$export$2e2bcd8739ae039).icon}`]: styles.icon
            }
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.button,
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center',
        lineHeight: 1.25,
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.label && (ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom'),
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.label && ownerState.iconPosition !== 'top' && ownerState.iconPosition !== 'bottom',
                style: {
                    flexDirection: 'row'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.icon && ownerState.label,
                style: {
                    minHeight: 72,
                    paddingTop: 9,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'top',
                style: {
                    [`& > .${(0, $bdc03ab893a59c5d$export$2e2bcd8739ae039).icon}`]: {
                        marginBottom: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'bottom',
                style: {
                    [`& > .${(0, $bdc03ab893a59c5d$export$2e2bcd8739ae039).icon}`]: {
                        marginTop: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'start',
                style: {
                    [`& > .${(0, $bdc03ab893a59c5d$export$2e2bcd8739ae039).icon}`]: {
                        marginRight: theme.spacing(1)
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'end',
                style: {
                    [`& > .${(0, $bdc03ab893a59c5d$export$2e2bcd8739ae039).icon}`]: {
                        marginLeft: theme.spacing(1)
                    }
                }
            },
            {
                props: {
                    textColor: 'inherit'
                },
                style: {
                    color: 'inherit',
                    opacity: 0.6,
                    // same opacity as theme.palette.text.secondary
                    [`&.${(0, $bdc03ab893a59c5d$export$2e2bcd8739ae039).selected}`]: {
                        opacity: 1
                    },
                    [`&.${(0, $bdc03ab893a59c5d$export$2e2bcd8739ae039).disabled}`]: {
                        opacity: (theme.vars || theme).palette.action.disabledOpacity
                    }
                }
            },
            {
                props: {
                    textColor: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $bdc03ab893a59c5d$export$2e2bcd8739ae039).selected}`]: {
                        color: (theme.vars || theme).palette.primary.main
                    },
                    [`&.${(0, $bdc03ab893a59c5d$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: {
                    textColor: 'secondary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $bdc03ab893a59c5d$export$2e2bcd8739ae039).selected}`]: {
                        color: (theme.vars || theme).palette.secondary.main
                    },
                    [`&.${(0, $bdc03ab893a59c5d$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    flexShrink: 1,
                    flexGrow: 1,
                    flexBasis: 0,
                    maxWidth: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.wrapped,
                style: {
                    fontSize: theme.typography.pxToRem(12)
                }
            }
        ]
    })));
const $ca50fd7418c7c1d3$var$Tab = /*#__PURE__*/ $h4Bez.forwardRef(function Tab(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false, ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    };
    const classes = $ca50fd7418c7c1d3$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $h4Bez.isValidElement(iconProp) ? /*#__PURE__*/ $h4Bez.cloneElement(iconProp, {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.icon, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($ca50fd7418c7c1d3$var$TabRoot, {
        focusRipple: !disableFocusRipple,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1,
        ...other,
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($h4Bez.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($h4Bez.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    });
});
var $ca50fd7418c7c1d3$export$2e2bcd8739ae039 = $ca50fd7418c7c1d3$var$Tab;



function $d2ec0016c0ed66e9$export$cdd93bd054dec359(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiTabs', slot);
}
const $d2ec0016c0ed66e9$var$tabsClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiTabs', [
    'root',
    'vertical',
    'list',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $d2ec0016c0ed66e9$export$2e2bcd8739ae039 = $d2ec0016c0ed66e9$var$tabsClasses;



function $d5bdab322ea70bb4$export$34861783d3c2eef8(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiTabScrollButton', slot);
}
const $d5bdab322ea70bb4$var$tabScrollButtonClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $d5bdab322ea70bb4$export$2e2bcd8739ae039 = $d5bdab322ea70bb4$var$tabScrollButtonClasses;



var $h4Bez = parcelRequire("h4Bez");


'use client';
const $ffdd32cb3f5e7e7e$var$Context = /*#__PURE__*/ $h4Bez.createContext(null);
function $ffdd32cb3f5e7e7e$var$useUniquePrefix() {
    const [id, setId] = $h4Bez.useState(null);
    $h4Bez.useEffect(()=>{
        setId(`mui-p-${Math.round(Math.random() * 1e5)}`);
    }, []);
    return id;
}
function $ffdd32cb3f5e7e7e$export$2e2bcd8739ae039(props) {
    const { children: children, value: value } = props;
    const idPrefix = $ffdd32cb3f5e7e7e$var$useUniquePrefix();
    const context = $h4Bez.useMemo(()=>{
        return {
            idPrefix: idPrefix,
            value: value
        };
    }, [
        idPrefix,
        value
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($ffdd32cb3f5e7e7e$var$Context.Provider, {
        value: context,
        children: children
    });
}
function $ffdd32cb3f5e7e7e$export$5a3bad273ac578e0() {
    return $h4Bez.useContext($ffdd32cb3f5e7e7e$var$Context);
}
function $ffdd32cb3f5e7e7e$export$629f80328afcade5(context, value) {
    const { idPrefix: idPrefix } = context;
    if (idPrefix === null) return null;
    return `${context.idPrefix}-P-${value}`;
}
function $ffdd32cb3f5e7e7e$export$46f6d19d28231cb8(context, value) {
    const { idPrefix: idPrefix } = context;
    if (idPrefix === null) return null;
    return `${context.idPrefix}-T-${value}`;
}


var $h4Bez = parcelRequire("h4Bez");


var $h4Bez = parcelRequire("h4Bez");











function $8304f6c93e0f2d50$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $8304f6c93e0f2d50$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $8304f6c93e0f2d50$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $h4Bez = parcelRequire("h4Bez");




'use client';
const $5b3fb67e068803c6$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $5b3fb67e068803c6$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, ...other } = props;
    const scrollbarHeight = $h4Bez.useRef();
    const nodeRef = $h4Bez.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $d5e2631a7db85235$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $c5f3fedd75c1d71e$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $eb0aab3eb5dc2a90$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $h4Bez.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("div", {
        style: $5b3fb67e068803c6$var$styles,
        ...other,
        ref: nodeRef
    });
}



var $h4Bez = parcelRequire("h4Bez");







'use client';
var $6f683ae21fc45317$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');




'use client';
var $df02eacce232e2af$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');







'use client';
const $767b32a3321b85fe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $d5bdab322ea70bb4$export$34861783d3c2eef8), classes);
};
const $767b32a3321b85fe$var$TabScrollButtonRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d02728b6fe958b24$export$2e2bcd8739ae039), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})({
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    [`&.${(0, $d5bdab322ea70bb4$export$2e2bcd8739ae039).disabled}`]: {
        opacity: 0
    },
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                width: '100%',
                height: 40,
                '& svg': {
                    transform: 'var(--TabScrollButton-svgRotate)'
                }
            }
        }
    ]
});
const $767b32a3321b85fe$var$TabScrollButton = /*#__PURE__*/ $h4Bez.forwardRef(function TabScrollButton(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction, orientation: orientation, disabled: disabled, ...other } = props;
    const isRtl = (0, $c12c19e2bf4d75c0$export$b2dd014b6c321cb)();
    const ownerState = {
        isRtl: isRtl,
        ...props
    };
    const classes = $767b32a3321b85fe$var$useUtilityClasses(ownerState);
    const StartButtonIcon = slots.StartScrollButtonIcon ?? (0, $6f683ae21fc45317$export$2e2bcd8739ae039);
    const EndButtonIcon = slots.EndScrollButtonIcon ?? (0, $df02eacce232e2af$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($767b32a3321b85fe$var$TabScrollButtonRoot, {
        component: "div",
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null,
        ...other,
        style: {
            ...other.style,
            ...orientation === 'vertical' && {
                '--TabScrollButton-svgRotate': `rotate(${isRtl ? -90 : 90}deg)`
            }
        },
        children: direction === 'left' ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(StartButtonIcon, {
            ...startButtonIconProps
        }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(EndButtonIcon, {
            ...endButtonIconProps
        })
    });
});
var $767b32a3321b85fe$export$2e2bcd8739ae039 = $767b32a3321b85fe$var$TabScrollButton;









'use client';
const $f113645bdb4030ab$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $f113645bdb4030ab$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $f113645bdb4030ab$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $f113645bdb4030ab$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        list: [
            'list',
            'flexContainer',
            vertical && 'flexContainerVertical',
            vertical && 'vertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $d2ec0016c0ed66e9$export$cdd93bd054dec359), classes);
};
const $f113645bdb4030ab$var$TabsRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $d2ec0016c0ed66e9$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $d2ec0016c0ed66e9$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.scrollButtonsHideMobile,
                style: {
                    [`& .${(0, $d2ec0016c0ed66e9$export$2e2bcd8739ae039).scrollButtons}`]: {
                        [theme.breakpoints.down('sm')]: {
                            display: 'none'
                        }
                    }
                }
            }
        ]
    })));
const $f113645bdb4030ab$var$TabsScroller = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})({
    position: 'relative',
    display: 'inline-block',
    flex: '1 1 auto',
    whiteSpace: 'nowrap',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.fixed,
            style: {
                overflowX: 'hidden',
                width: '100%'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.hideScrollbar,
            style: {
                // Hide dimensionless scrollbar on macOS
                scrollbarWidth: 'none',
                // Firefox
                '&::-webkit-scrollbar': {
                    display: 'none' // Safari + Chrome
                }
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableX,
            style: {
                overflowX: 'auto',
                overflowY: 'hidden'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableY,
            style: {
                overflowY: 'auto',
                overflowX: 'hidden'
            }
        }
    ]
});
const $f113645bdb4030ab$var$List = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiTabs',
    slot: 'List',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.list,
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})({
    display: 'flex',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.vertical,
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.centered,
            style: {
                justifyContent: 'center'
            }
        }
    ]
});
const $f113645bdb4030ab$var$TabsIndicator = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiTabs',
    slot: 'Indicator'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create(),
        variants: [
            {
                props: {
                    indicatorColor: 'primary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    indicatorColor: 'secondary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.secondary.main
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    height: '100%',
                    width: 2,
                    right: 0
                }
            }
        ]
    })));
const $f113645bdb4030ab$var$TabsScrollbarSize = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $5b3fb67e068803c6$export$2e2bcd8739ae039))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $f113645bdb4030ab$var$defaultIndicatorStyle = {};
let $f113645bdb4030ab$var$warnedOnceTabPresent = false;
const $f113645bdb4030ab$var$Tabs = /*#__PURE__*/ $h4Bez.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $cd99783e1cac2d84$export$2e2bcd8739ae039)();
    const isRtl = (0, $c12c19e2bf4d75c0$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent, scrollButtons: // TODO: remove in v7 (deprecated in v6)
    scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: // TODO: remove in v7 (deprecated in v6)
    TabScrollButtonProps = {}, textColor: // TODO: remove in v7 (deprecated in v6)
    textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false, ...other } = props;
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = {
        ...props,
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    };
    const classes = $f113645bdb4030ab$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $h4Bez.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $h4Bez.useState($f113645bdb4030ab$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $h4Bez.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $h4Bez.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $h4Bez.useState(false);
    const [scrollerStyle, setScrollerStyle] = $h4Bez.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $h4Bez.useRef(null);
    const tabListRef = $h4Bez.useRef(null);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            indicator: TabIndicatorProps,
            scrollButtons: TabScrollButtonProps,
            ...slotProps
        }
    };
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $ea79b826054a58a6$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + tabsMeta.scrollLeft);
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        if (typeof indicatorStyle[startIndicator] !== 'number' || typeof indicatorStyle[size] !== 'number') setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $8304f6c93e0f2d50$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else scrollValue += delta * (isRtl ? -1 : 1);
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    const [ScrollbarSlot, { onChange: scrollbarOnChange, ...scrollbarSlotProps }] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('scrollbar', {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.scrollableX, classes.hideScrollbar),
        elementType: $f113645bdb4030ab$var$TabsScrollbarSize,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $h4Bez.useCallback((scrollbarWidth)=>{
        scrollbarOnChange?.(scrollbarWidth);
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, [
        scrollbarOnChange
    ]);
    const [ScrollButtonsSlot, scrollButtonSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('scrollButtons', {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.scrollButtons, TabScrollButtonProps.className),
        elementType: (0, $767b32a3321b85fe$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            orientation: orientation,
            slots: {
                StartScrollButtonIcon: slots.startScrollButtonIcon || slots.StartScrollButtonIcon,
                EndScrollButtonIcon: slots.endScrollButtonIcon || slots.EndScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps,
                endScrollButtonIcon: endScrollButtonIconProps
            }
        }
    });
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(ScrollbarSlot, {
            ...scrollbarSlotProps,
            onChange: handleScrollbarSizeChange
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll,
            ...scrollButtonSlotProps
        }) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll,
            ...scrollButtonSlotProps
        }) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $ea79b826054a58a6$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $ea79b826054a58a6$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $h4Bez.useEffect(()=>{
        const handleResize = (0, $c5f3fedd75c1d71e$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    resizeObserver?.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    resizeObserver?.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $eb0aab3eb5dc2a90$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            mutationObserver?.disconnect();
            resizeObserver?.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $h4Bez.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp?.length
    ]);
    $h4Bez.useEffect(()=>{
        setMounted(true);
    }, []);
    $h4Bez.useEffect(()=>{
        updateIndicatorState();
    });
    $h4Bez.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($f113645bdb4030ab$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $h4Bez.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const [IndicatorSlot, indicatorSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('indicator', {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.indicator, TabIndicatorProps.className),
        elementType: $f113645bdb4030ab$var$TabsIndicator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: indicatorStyle
        }
    });
    const indicator = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(IndicatorSlot, {
        ...indicatorSlotProps
    });
    let childIndex = 0;
    const children = $h4Bez.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $h4Bez.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $h4Bez.cloneElement(child, {
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue,
            ...childIndex === 1 && value === false && !child.props.tabIndex ? {
                tabIndex: 0
            } : {}
        });
    });
    const handleKeyDown = (event)=>{
        // Check if a modifier key (Alt, Shift, Ctrl, Meta) is pressed
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        const list = tabListRef.current;
        const currentFocus = (0, $0af2c8a204f06237$export$2e2bcd8739ae039)((0, $4fa343ae2434ad28$export$2e2bcd8739ae039)(list));
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus?.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $f113645bdb4030ab$var$moveFocus(list, currentFocus, $f113645bdb4030ab$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $f113645bdb4030ab$var$moveFocus(list, currentFocus, $f113645bdb4030ab$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $f113645bdb4030ab$var$moveFocus(list, null, $f113645bdb4030ab$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $f113645bdb4030ab$var$moveFocus(list, null, $f113645bdb4030ab$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    const [RootSlot, rootSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('root', {
        ref: ref,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $f113645bdb4030ab$var$TabsRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        ownerState: ownerState
    });
    const [ScrollerSlot, scrollerSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('scroller', {
        ref: tabsRef,
        className: classes.scroller,
        elementType: $f113645bdb4030ab$var$TabsScroller,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: {
                overflow: scrollerStyle.overflow,
                [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
            }
        }
    });
    const [ListSlot, listSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('list', {
        ref: tabListRef,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.list, classes.flexContainer),
        elementType: $f113645bdb4030ab$var$List,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            })
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)(ScrollerSlot, {
                ...scrollerSlotProps,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(ListSlot, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        role: "tablist",
                        ...listSlotProps,
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    });
});
var $f113645bdb4030ab$export$2e2bcd8739ae039 = $f113645bdb4030ab$var$Tabs;




'use client';
const $a44c1239371a85c6$var$TabList = /*#__PURE__*/ $h4Bez.forwardRef(function TabList(props, ref) {
    const { children: childrenProp, ...other } = props;
    const context = (0, $ffdd32cb3f5e7e7e$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError('No TabContext provided');
    const children = $h4Bez.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $h4Bez.isValidElement(child)) return null;
        return /*#__PURE__*/ $h4Bez.cloneElement(child, {
            // SOMEDAY: `Tabs` will set those themselves
            'aria-controls': (0, $ffdd32cb3f5e7e7e$export$629f80328afcade5)(context, child.props.value),
            id: (0, $ffdd32cb3f5e7e7e$export$46f6d19d28231cb8)(context, child.props.value)
        });
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f113645bdb4030ab$export$2e2bcd8739ae039), {
        ...other,
        ref: ref,
        value: context.value,
        children: children
    });
});
var $a44c1239371a85c6$export$2e2bcd8739ae039 = $a44c1239371a85c6$var$TabList;


var $h4Bez = parcelRequire("h4Bez");

function $a0193734eadf0ab9$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $a0193734eadf0ab9$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $a0193734eadf0ab9$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $a0193734eadf0ab9$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $a0193734eadf0ab9$export$2e2bcd8739ae039 = $a0193734eadf0ab9$export$4f5d2d50c9deca37;





'use client';
function $9058b9cdfb80ec1e$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $613bf551b55aae32$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $1501f617dbde04aa$export$2e2bcd8739ae039,
        themeId: (0, $3abbb2670cc8edff$export$2e2bcd8739ae039)
    });
}





function $d23931832ff5fc55$export$cfb3da2e74936ec(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiTabPanel', slot);
}
const $d23931832ff5fc55$var$tabPanelClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiTabPanel', [
    'root',
    'hidden'
]);
var $d23931832ff5fc55$export$2e2bcd8739ae039 = $d23931832ff5fc55$var$tabPanelClasses;




'use client';
const $4bc840b5ee09e9d7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, hidden: hidden } = ownerState;
    const slots = {
        root: [
            'root',
            hidden && 'hidden'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $d23931832ff5fc55$export$cfb3da2e74936ec), classes);
};
const $4bc840b5ee09e9d7$var$TabPanelRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiTabPanel',
    slot: 'Root'
})(({ theme: theme })=>({
        padding: theme.spacing(3)
    }));
const $4bc840b5ee09e9d7$var$TabPanel = /*#__PURE__*/ $h4Bez.forwardRef(function TabPanel(inProps, ref) {
    const props = (0, $9058b9cdfb80ec1e$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiTabPanel'
    });
    const { children: children, className: className, value: value, keepMounted: keepMounted = false, ...other } = props;
    const ownerState = {
        ...props
    };
    const classes = $4bc840b5ee09e9d7$var$useUtilityClasses(ownerState);
    const context = (0, $ffdd32cb3f5e7e7e$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError('No TabContext provided');
    const id = (0, $ffdd32cb3f5e7e7e$export$629f80328afcade5)(context, value);
    const tabId = (0, $ffdd32cb3f5e7e7e$export$46f6d19d28231cb8)(context, value);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($4bc840b5ee09e9d7$var$TabPanelRoot, {
        "aria-labelledby": tabId,
        className: (0, $a0193734eadf0ab9$export$2e2bcd8739ae039)(classes.root, className),
        hidden: value !== context.value,
        id: id,
        ref: ref,
        role: "tabpanel",
        ownerState: ownerState,
        ...other,
        children: (keepMounted || value === context.value) && children
    });
});
var $4bc840b5ee09e9d7$export$2e2bcd8739ae039 = $4bc840b5ee09e9d7$var$TabPanel;







parcelRequire("h4Bez");



"use client";
var $9f651ed2ab7524a8$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2M9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9zm9 14H6V10h12zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2"
}), 'LockOutlined');




const $5d175dd5f360d315$var$wrapperStyle = {
    display: 'flex',
    flexDirection: 'column',
    p: 2
};
const $5d175dd5f360d315$var$iconMessageStyle = {
    display: 'flex',
    alignItems: 'center'
};
const $5d175dd5f360d315$var$iconStyle = {
    color: 'orange.400',
    fontSize: 20
};
const $5d175dd5f360d315$var$titleStyle = {
    color: 'primary.dark',
    ml: 1
};
const $5d175dd5f360d315$var$subTitleStyle = {
    ml: 3.5
};
const $5d175dd5f360d315$export$5946e841896fa02f = ()=>{
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $5d175dd5f360d315$var$wrapperStyle,
        "data-testid": "no-permission-message",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $5d175dd5f360d315$var$iconMessageStyle,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f651ed2ab7524a8$export$2e2bcd8739ae039), {
                        sx: $5d175dd5f360d315$var$iconStyle
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        sx: $5d175dd5f360d315$var$titleStyle,
                        variant: "subtitle1",
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).YOU_NEED_PERMISSION_TO_VIEW_THIS_DATA
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                sx: $5d175dd5f360d315$var$subTitleStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ASK_YOUR_ADMIN_TO_GAIN_ACCESS
                })
            })
        ]
    });
};


const $2bf638d791e22cc5$var$tabPanelStyle = {
    px: 0
};
const $2bf638d791e22cc5$var$tabSxProps = (theme)=>({
        ...theme.typography.body2,
        fontWeight: 400,
        color: 'grey.500',
        textTransform: 'initial',
        minHeight: 'inherit',
        minWidth: 'unset',
        px: 2,
        py: 1,
        mr: 1,
        borderBottom: 1.5,
        borderBottomColor: 'transparent',
        '&:hover': {
            color: 'black',
            borderBottomColor: 'grey.400'
        },
        [`&.${(0, $bdc03ab893a59c5d$export$2e2bcd8739ae039).selected}`]: {
            color: 'primary.700'
        }
    });
const $2bf638d791e22cc5$var$tabListStyle = (theme)=>{
    const bgColor = theme.palette.background.default;
    return {
        minHeight: 31,
        position: 'relative',
        '& [role="tablist"]': {
            height: '100%'
        },
        '&:hover': {
            [`& .${(0, $d2ec0016c0ed66e9$export$2e2bcd8739ae039).scrollButtons}`]: {
                visibility: 'visible'
            }
        },
        // fade effect on the left & right edges of tablist
        '&::before, &::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            bottom: 0,
            width: 56,
            zIndex: 1,
            pointerEvents: 'none',
            opacity: 0
        },
        '&::before': {
            left: 0,
            background: `linear-gradient(to right, ${bgColor}, ${(0, $3289d56f59a873c2$export$58f0f39f63f3cf42)(bgColor, 0)})`
        },
        '&::after': {
            right: 0,
            background: `linear-gradient(to left, ${bgColor}, ${(0, $3289d56f59a873c2$export$58f0f39f63f3cf42)(bgColor, 0)})`
        },
        // displays each fade only when the matching scroll button is enabled
        [`&:has(> .${(0, $d2ec0016c0ed66e9$export$2e2bcd8739ae039).scrollButtons}:not(.${(0, $d5bdab322ea70bb4$export$2e2bcd8739ae039).disabled}):first-of-type)::before`]: {
            opacity: 1
        },
        [`&:has(> .${(0, $d2ec0016c0ed66e9$export$2e2bcd8739ae039).scrollButtons}:not(.${(0, $d5bdab322ea70bb4$export$2e2bcd8739ae039).disabled}):last-of-type)::after`]: {
            opacity: 1
        }
    };
};
const $2bf638d791e22cc5$var$scrollButtonsStyle = (theme)=>({
        visibility: 'hidden',
        width: 24,
        height: 24,
        position: 'absolute',
        zIndex: 2,
        '&:last-of-type': {
            right: 0
        },
        backgroundColor: 'white',
        m: 0.5,
        color: 'grey.700',
        opacity: 1,
        borderRadius: 1,
        boxShadow: theme.shadows[2],
        [`&.${(0, $d5bdab322ea70bb4$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    });
const $2bf638d791e22cc5$var$tabIndicatorStyle = {
    backgroundColor: 'primary.700',
    height: 1.5
};
const $2bf638d791e22cc5$var$dividerStyle = {
    borderColor: 'grey.300',
    marginTop: '-1px'
};
const $2bf638d791e22cc5$var$labelStyle = {
    display: 'flex',
    alignItems: 'center'
};
const $2bf638d791e22cc5$var$counterStyle = {
    ml: 2,
    px: 1,
    borderRadius: 1,
    backgroundColor: 'grey.200',
    minWidth: 24,
    [`.${(0, $bdc03ab893a59c5d$export$2e2bcd8739ae039).root}:hover:not(.${(0, $bdc03ab893a59c5d$export$2e2bcd8739ae039).selected}) &`]: {
        backgroundColor: 'grey.300',
        color: 'grey.500'
    },
    [`.${(0, $bdc03ab893a59c5d$export$2e2bcd8739ae039).selected} &`]: {
        backgroundColor: 'primary.100'
    }
};
const $2bf638d791e22cc5$var$Label = ({ title: title, count: count })=>{
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $2bf638d791e22cc5$var$labelStyle,
        children: [
            title,
            count ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $2bf638d791e22cc5$var$counterStyle,
                children: count
            }) : null
        ]
    });
};
const $2bf638d791e22cc5$export$3e41faf802a29e71 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {});
const $2bf638d791e22cc5$export$b2539bed5023c21c = ({ children: children, onChange: onChange, value: controlledValue, ...props })=>{
    const translation = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const hasCapabilities = (0, $ed3a79aec495d063$export$95fa16a10fc41701)();
    const enabledValues = [];
    const tabs = [];
    const panels = [];
    children.forEach(({ props: { title: title, value: customValue, count: count, disabled: disabled, requiredCapabilities: capabilities = [], children: children } }, k)=>{
        const value = customValue ?? String(k);
        const actuallyDisabled = disabled || (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(capabilities) && !hasCapabilities(capabilities);
        if (!actuallyDisabled) enabledValues.push(value);
        const translatedTitle = (0, $40a99dac858c1d75$export$552cd99e43fa1085)(title) ? translation.formatTranslation(title, {
            count: count
        }) : title;
        tabs.push(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca50fd7418c7c1d3$export$2e2bcd8739ae039), {
            "data-testid": translatedTitle,
            label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($2bf638d791e22cc5$var$Label, {
                title: translatedTitle,
                count: count
            }),
            value: value,
            disabled: actuallyDisabled,
            sx: $2bf638d791e22cc5$var$tabSxProps,
            disableRipple: true
        }, value));
        if (children) panels.push(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4bc840b5ee09e9d7$export$2e2bcd8739ae039), {
            sx: $2bf638d791e22cc5$var$tabPanelStyle,
            value: value,
            children: children
        }, value));
    });
    const [selection, setValue] = (0, $h4Bez.useState)(null);
    /** If there is a selection, and its enabled, use it, otherwise, overwrite it */ const value = controlledValue ?? (selection && enabledValues.includes(selection) ? selection : enabledValues[0]);
    const handleOnChange = (0, $h4Bez.useCallback)((_, value)=>{
        if (onChange) onChange(value);
        else setValue(value);
    }, []);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $ffdd32cb3f5e7e7e$export$2e2bcd8739ae039), {
        value: value || '0',
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a44c1239371a85c6$export$2e2bcd8739ae039), {
                ...props,
                onChange: handleOnChange,
                sx: $2bf638d791e22cc5$var$tabListStyle,
                slotProps: {
                    indicator: {
                        sx: $2bf638d791e22cc5$var$tabIndicatorStyle
                    },
                    scrollButtons: {
                        sx: $2bf638d791e22cc5$var$scrollButtonsStyle
                    }
                },
                variant: "scrollable",
                children: tabs
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {
                sx: $2bf638d791e22cc5$var$dividerStyle
            }),
            value ? panels : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5d175dd5f360d315$export$5946e841896fa02f), {})
        ]
    });
};




var $h4Bez = parcelRequire("h4Bez");





var $h4Bez = parcelRequire("h4Bez");



parcelRequire("h4Bez");



const $93093fe5e980edc3$export$7fce389886c4768b = ()=>{
    const isLoading = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $da778fcb2b39c6da$export$62d55b06c6965c86));
    return isLoading ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2db76c9e9f88b3ff$export$2e2bcd8739ae039), {}) : null;
};






var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");















function $e1f1b421521ff43f$export$b801318a856c9cd2(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiDrawer', slot);
}
const $e1f1b421521ff43f$var$drawerClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiDrawer', [
    'root',
    'docked',
    'paper',
    'anchorLeft',
    'anchorRight',
    'anchorTop',
    'anchorBottom',
    'paperAnchorLeft',
    'paperAnchorRight',
    'paperAnchorTop',
    'paperAnchorBottom',
    'paperAnchorDockedLeft',
    'paperAnchorDockedRight',
    'paperAnchorDockedTop',
    'paperAnchorDockedBottom',
    'modal'
]);
var $e1f1b421521ff43f$export$2e2bcd8739ae039 = $e1f1b421521ff43f$var$drawerClasses;





'use client';
const $5ae8551b9622d985$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked,
        styles.modal
    ];
};
const $5ae8551b9622d985$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            `anchor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(anchor)}`
        ],
        docked: [
            (variant === 'permanent' || variant === 'persistent') && 'docked'
        ],
        modal: [
            'modal'
        ],
        paper: [
            'paper',
            `paperAnchor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(anchor)}`,
            variant !== 'temporary' && `paperAnchorDocked${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(anchor)}`
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $e1f1b421521ff43f$export$b801318a856c9cd2), classes);
};
const $5ae8551b9622d985$var$DrawerRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $22fdbb8607c29afa$export$2e2bcd8739ae039), {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver: $5ae8551b9622d985$var$overridesResolver
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    })));
const $5ae8551b9622d985$var$DrawerDockedRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    shouldForwardProp: (0, $19087586f17e5d57$export$2e2bcd8739ae039),
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver: $5ae8551b9622d985$var$overridesResolver
})({
    flex: '0 0 auto'
});
const $5ae8551b9622d985$var$DrawerPaper = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.anchor)}`],
            ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.anchor)}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 0 auto',
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        // temporary style
        position: 'fixed',
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0,
        variants: [
            {
                props: {
                    anchor: 'left'
                },
                style: {
                    left: 0
                }
            },
            {
                props: {
                    anchor: 'top'
                },
                style: {
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: {
                    anchor: 'right'
                },
                style: {
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'bottom'
                },
                style: {
                    top: 'auto',
                    left: 0,
                    bottom: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'left' && ownerState.variant !== 'temporary',
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'top' && ownerState.variant !== 'temporary',
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'right' && ownerState.variant !== 'temporary',
                style: {
                    borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary',
                style: {
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            }
        ]
    })));
const $5ae8551b9622d985$var$oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function $5ae8551b9622d985$export$2a62b49acb270576(anchor) {
    return [
        'left',
        'right'
    ].includes(anchor);
}
function $5ae8551b9622d985$export$830f4f08342d299e({ direction: direction }, anchor) {
    return direction === 'rtl' && $5ae8551b9622d985$export$2a62b49acb270576(anchor) ? $5ae8551b9622d985$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $5ae8551b9622d985$var$Drawer = /*#__PURE__*/ $h4Bez.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDrawer'
    });
    const theme = (0, $cd99783e1cac2d84$export$2e2bcd8739ae039)();
    const isRtl = (0, $c12c19e2bf4d75c0$export$b2dd014b6c321cb)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = 'left', BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp, ...ModalProps } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent, transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = 'temporary', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $h4Bez.useRef(false);
    $h4Bez.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $5ae8551b9622d985$export$830f4f08342d299e({
        direction: isRtl ? 'rtl' : 'ltr'
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = {
        ...props,
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant,
        ...other
    };
    const classes = $5ae8551b9622d985$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            paper: PaperProps,
            transition: SlideProps,
            ...slotProps,
            backdrop: (0, $a2e9ce20abe2966a$export$2e2bcd8739ae039)(slotProps.backdrop || {
                ...BackdropProps,
                ...BackdropPropsProp
            }, {
                transitionDuration: transitionDuration
            })
        }
    };
    const [RootSlot, rootSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $5ae8551b9622d985$var$DrawerRoot,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, classes.modal, className),
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            ...ModalProps
        },
        additionalProps: {
            open: open,
            onClose: onClose,
            hideBackdrop: hideBackdrop,
            slots: {
                backdrop: externalForwardedProps.slots.backdrop
            },
            slotProps: {
                backdrop: externalForwardedProps.slotProps.backdrop
            }
        }
    });
    const [PaperSlot, paperSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('paper', {
        elementType: $5ae8551b9622d985$var$DrawerPaper,
        shouldForwardComponentProp: true,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            elevation: variant === 'temporary' ? elevation : 0,
            square: true,
            ...variant === 'temporary' && {
                role: 'dialog',
                'aria-modal': 'true'
            }
        }
    });
    const [DockedSlot, dockedSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('docked', {
        elementType: $5ae8551b9622d985$var$DrawerDockedRoot,
        ref: ref,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, classes.docked, className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: other // pass `other` here because `DockedSlot` is also a root slot for some variants
    });
    const [TransitionSlot, transitionSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $4afea2d4eb954f7e$export$2e2bcd8739ae039),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            in: open,
            direction: $5ae8551b9622d985$var$oppositeDirection[anchorInvariant],
            timeout: transitionDuration,
            appear: mounted.current
        }
    });
    const drawer = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(PaperSlot, {
        ...paperSlotProps,
        children: children
    });
    if (variant === 'permanent') return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(DockedSlot, {
        ...dockedSlotProps,
        children: drawer
    });
    const slidingDrawer = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(TransitionSlot, {
        ...transitionSlotProps,
        children: drawer
    });
    if (variant === 'persistent') return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(DockedSlot, {
        ...dockedSlotProps,
        children: slidingDrawer
    });
    // variant === temporary
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(RootSlot, {
        ...rootSlotProps,
        children: slidingDrawer
    });
});
var $5ae8551b9622d985$export$2e2bcd8739ae039 = $5ae8551b9622d985$var$Drawer;








var $h4Bez = parcelRequire("h4Bez");


const $57ff7f54e54013be$export$330e3f340a9faef5 = (type)=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('documentationUsecase');
    return (0, $h4Bez.useMemo)(()=>usecase.createURL(type).toString(), [
        usecase,
        type
    ]);
};
const $57ff7f54e54013be$export$6eb1e07b1de459cd = ({ type: type, ...props })=>{
    const href = $57ff7f54e54013be$export$330e3f340a9faef5(type);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a497eee141ca75b8$export$2e2bcd8739ae039), {
        "data-testid": `documentation-link-${type.toLowerCase().replaceAll(/_+/g, '-')}`,
        target: "_blank",
        ...props,
        href: href
    });
};







parcelRequire("h4Bez");






/** Height of the top bar, and of the brand block at the top of the side bar, so the two line up */ const $ec6d88728b15dea0$export$13f84e577eb08343 = 52;


/** In spacing steps */ const $7e02f1e3fb8177b2$var$SIDE_PADDING = 3;
const $7e02f1e3fb8177b2$var$LOGO_SIZE = 22;
const $7e02f1e3fb8177b2$var$brandStyle = (theme)=>({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 2,
        flexShrink: 0,
        width: '100%',
        height: (0, $ec6d88728b15dea0$export$13f84e577eb08343),
        px: $7e02f1e3fb8177b2$var$SIDE_PADDING,
        color: 'grey.600',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        '&:focus-visible': (0, $5f78a8132f139ecb$export$a86f5934025b6e94)(theme)
    });
/** A logo rather than an icon, so it doesn't take the 20px icon size */ const $7e02f1e3fb8177b2$var$logoStyle = {
    width: $7e02f1e3fb8177b2$var$LOGO_SIZE,
    height: $7e02f1e3fb8177b2$var$LOGO_SIZE
};
/**
 * When there's no room for the name, it drops onto a second line, which the block hides, so it disappears whole and the logo
 * stays, centred in the block, instead of the name being cut. The block never gets narrower than the logo and its padding.
 */ const $7e02f1e3fb8177b2$var$fittingBrandStyle = {
    width: 'auto',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    justifyContent: 'center',
    minWidth: `${$7e02f1e3fb8177b2$var$LOGO_SIZE + 2 * $7e02f1e3fb8177b2$var$SIDE_PADDING * (0, $1a6512ae4318d72b$export$1d5937c6c580f51)}px`
};
const $7e02f1e3fb8177b2$var$fittingLogoStyle = {
    my: `${((0, $ec6d88728b15dea0$export$13f84e577eb08343) - $7e02f1e3fb8177b2$var$LOGO_SIZE) / 2}px`
};
const $7e02f1e3fb8177b2$var$fittingNameStyle = {
    lineHeight: `${(0, $ec6d88728b15dea0$export$13f84e577eb08343)}px`
};
/** The company name stands out from the product name, darker and semibold. The theme's typography has no semibold weight. */ const $7e02f1e3fb8177b2$var$COMPANY_NAME_WEIGHT = 600;
const $7e02f1e3fb8177b2$var$nameStyle = {
    '& b': {
        fontWeight: $7e02f1e3fb8177b2$var$COMPANY_NAME_WEIGHT,
        color: 'grey.900'
    }
};
const $7e02f1e3fb8177b2$var$companyNameFormatter = (0, $4772774eee62bdcc$export$18fadbe56dfcb1a1)((props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("b", {
        ...props
    }), {
    'data-testid': 'navigation-brand-company'
});
const $7e02f1e3fb8177b2$export$75d5b518c51e7fd6 = ({ collapsed: collapsed = false, hideNameWhenTight: hideNameWhenTight = false })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const hasCapabilities = (0, $ed3a79aec495d063$export$95fa16a10fc41701)();
    const homeLabel = translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_BRAND_HOME);
    const content = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9fadce0ec9a8b88e$export$3a7d64416858c53c), {
                "data-testid": "navigation-brand-logo",
                sx: [
                    $7e02f1e3fb8177b2$var$logoStyle,
                    hideNameWhenTight && $7e02f1e3fb8177b2$var$fittingLogoStyle
                ]
            }),
            !collapsed && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                component: "span",
                variant: "body2",
                "data-testid": "navigation-brand-name",
                sx: [
                    $7e02f1e3fb8177b2$var$nameStyle,
                    hideNameWhenTight && $7e02f1e3fb8177b2$var$fittingNameStyle
                ],
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_BRAND,
                    values: {
                        b: $7e02f1e3fb8177b2$var$companyNameFormatter
                    }
                })
            })
        ]
    });
    if (!hasCapabilities((0, $78200dbe96418bab$export$52f918acf509b2a9))) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "navigation-brand",
        sx: [
            $7e02f1e3fb8177b2$var$brandStyle,
            hideNameWhenTight && $7e02f1e3fb8177b2$var$fittingBrandStyle
        ],
        children: content
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $69cdbe69cde47e02$export$2e2bcd8739ae039), {
        title: collapsed ? homeLabel : '',
        placement: "right",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7d5f64758ce3b1db$export$93fe4a80834d0286), {
            "data-testid": "navigation-brand",
            "aria-label": homeLabel,
            path: (0, $78200dbe96418bab$export$52f918acf509b2a9),
            color: "inherit",
            sx: [
                $7e02f1e3fb8177b2$var$brandStyle,
                hideNameWhenTight && $7e02f1e3fb8177b2$var$fittingBrandStyle
            ],
            children: content
        })
    });
};






const $2ea6382bc105e2d6$var$navigationConfig = {
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM]: {
        icon: (0, $3b67c52f9dbf3f4d$export$e34663dc4a1f3f47)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).DATA]: {
        icon: (0, $a8ef2defa7a3722a$export$53728f83fb948d97)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES]: {
        icon: (0, $3424f87597dd31eb$export$88769f64c4ce504d)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER]: {
        icon: (0, $e4055172f1fb8a23$export$5c55f94c71e43066)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SETTINGS]: {
        icon: (0, $ac038d8538832e98$export$ac4e8b8ca2b79f39)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_OVERVIEW]: {
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_SERVICES_DESCRIPTION,
        icon: (0, $21dfcf72ba003711$export$c6aaa6e4eb91ba91)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).DEVIATED_SERVICES]: {
        icon: (0, $ed6f3d571c93aafd$export$b7910236d21ed8ef)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_LOGS]: {
        icon: (0, $db5721617f0596ac$export$58a57064519df6a0)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_WORKBENCH]: {
        isExtraMenu: true,
        icon: (0, $1c4f80122f419596$export$15a9884428879c5d)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES]: {
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_MAPPINGS_DESCRIPTION,
        icon: (0, $4f94c67c9a03ae7a$export$69f2027e16370dfe)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RULE_ENGINE_SANDBOX]: {
        isExtraMenu: true,
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_RULE_ENGINE_SANDBOX_DESCRIPTION,
        icon: (0, $4a83180cadddc43e$export$7c291b8c282f660d)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_STATUS]: {
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_SYSTEM_STATUSES_DESCRIPTION,
        icon: (0, $2732dd7e592f0ccd$export$34b309d75bd5827e)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).DATA_EXPLORER]: {
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_EXPLORER_DESCRIPTION,
        icon: (0, $ac7419a80d9dddce$export$da06aec6965c7ba5)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_MANAGEMENT]: {
        icon: (0, $93476d9be7ee0f23$export$35e00e6a4faf5730)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_CLIENT_REGISTRY]: {
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_CLIENT_REGISTRY_DESCRIPTION,
        icon: (0, $3f17bc125b2f71c3$export$481a7013a5a1a9ef)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_CERTIFICATES]: {
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_CERTIFICATES_DESCRIPTION,
        icon: (0, $7be2eff253c48d8a$export$69ed718e88f9cee1)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SETTINGS_LOGIN]: {
        icon: (0, $e722d83d0f724e52$export$d0ac701a5f7df20a)
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_LICENSE]: {
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_SYSTEM_LICENSE_DESCRIPTION
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_METRICS]: {
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_SYSTEM_METRICS_DESCRIPTION
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_AGENTS]: {
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_SYSTEM_AGENTS_DESCRIPTION
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_LINKS]: {
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_SERVICES_LINKS_DESCRIPTION
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_SERVERS]: {
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_SERVERS_DESCRIPTION
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_NODES]: {
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_NODES_DESCRIPTION
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_CONTAINERS]: {
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_CONTAINERS_DESCRIPTION
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_VOLUMES]: {
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_VOLUMES_DESCRIPTION
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_CONNECTIONS]: {
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_CONNECTIONS_DESCRIPTION
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_ENDPOINTS]: {
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_ENDPOINTS_DESCRIPTION
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_MAPPINGS]: {
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_MAPPINGS_DESCRIPTION
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK]: {
        icon: (0, $db5721617f0596ac$export$58a57064519df6a0),
        description: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK
    }
};
const $2ea6382bc105e2d6$export$62609118ae1497c6 = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>Object.values((0, $0e5d1fb0e9c69012$export$94983032f3209e0b)));
const $2ea6382bc105e2d6$export$3230c9e059765c6e = [
    (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES,
    (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).DATA,
    (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER,
    (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM
];
const $2ea6382bc105e2d6$export$f929b0bf838909b4 = (path, prop)=>$2ea6382bc105e2d6$var$navigationConfig[path]?.[prop] ?? null;






const $00ca74462cc42d7b$export$bb747d72848d9c48 = (0, $124a99bb16e8bbff$export$67610e1c203fd6f4).extend((RouteFormatter)=>class extends RouteFormatter {
        formatDescription(routePath) {
            const description = (0, $2ea6382bc105e2d6$export$f929b0bf838909b4)(routePath, 'description');
            return description ? this.translator.formatTranslation(description) : null;
        }
        formatIcon(routePath) {
            const icon = (0, $2ea6382bc105e2d6$export$f929b0bf838909b4)(routePath, 'icon');
            (0, $14eddac5f20c576c$export$a7a9523472993e97)(icon, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'This route must have an icon', {
                routePath: routePath
            }));
            return icon;
        }
    }, 'useNavigationFormatter');



parcelRequire("h4Bez");



const $da6345f06052c88c$var$Wrapper = ({ authorized: authorized, children: children })=>authorized ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
        children: children
    }) : null;
const $da6345f06052c88c$export$1bacad896f21662 = ({ path: path, withTooltip: withTooltip, ...rest })=>{
    const formatter = (0, $00ca74462cc42d7b$export$bb747d72848d9c48)();
    return withTooltip ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $69cdbe69cde47e02$export$2e2bcd8739ae039), {
        title: formatter.formatTitle(path),
        placement: "right",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7d5f64758ce3b1db$export$93fe4a80834d0286), {
            path: path,
            color: "inherit",
            wrapper: $da6345f06052c88c$var$Wrapper,
            ...rest
        })
    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7d5f64758ce3b1db$export$bf4bb1ff1ff62959), {
        path: path,
        color: "inherit",
        title: formatter.formatDescription(path) ?? undefined,
        wrapper: $da6345f06052c88c$var$Wrapper,
        ...rest
    });
};




const $3594775a147b3957$export$8dfcf1b19fcf9290 = (0, $42efdbd12003f6a9$export$ddab236f5c469f6f).extend((RoutingHook)=>class extends RoutingHook {
        getCurrentSection() {
            const currentPath = this.state.path;
            const { parents: parents } = (0, $5eed2216d79d12d5$export$d6ed076c6911710a)(currentPath);
            /**
                 *  Breadcrumbs are sorted from children to parent,
                 *  so we take the last parent, which is the top parent.
                 */ const [topParent] = parents.slice(-1);
            return topParent ? topParent.id : currentPath;
        }
        getSectionMenuGroups(section, pool) {
            return pool.reduce((prev, route)=>{
                // Check if the child route is not part of the section, then skip assigning the route
                if (!(0, $78200dbe96418bab$export$d2ea89eca91e1c66)(route, section)) return prev;
                // Check if a child route should be in the extra menu, then add it to the second list
                if ((0, $2ea6382bc105e2d6$export$f929b0bf838909b4)(route, 'isExtraMenu')) prev[1].push(route);
                else // otherwise, add it to the main menu
                prev[0].push(route);
                return prev;
            }, [
                [],
                []
            ]);
        }
        getSideMenuGroups(pool) {
            return this.getSectionMenuGroups(this.getCurrentSection(), pool);
        }
    }, 'useNavigationRouting');


const $b42edc8b93f3ea44$var$selectedRing = (theme)=>`0 0 0 1px ${theme.palette.grey[200]}, ${theme.shadows[1]}`;
const $b42edc8b93f3ea44$export$d0c0dc258af67699 = {
    color: 'primary.700',
    backgroundColor: 'common.white',
    boxShadow: $b42edc8b93f3ea44$var$selectedRing,
    '&:hover': {
        backgroundColor: 'common.white'
    }
};



parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");











function $6215c2d858a888c8$export$47a2da616e55e8e9(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiAppBar', slot);
}
const $6215c2d858a888c8$var$appBarClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $6215c2d858a888c8$export$2e2bcd8739ae039 = $6215c2d858a888c8$var$appBarClasses;



'use client';
const $154486ef2dc8e36e$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            `position${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(position)}`
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $6215c2d858a888c8$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $154486ef2dc8e36e$var$joinVars = (var1, var2)=>var1 ? `${var1?.replace(')', '')}, ${var2})` : var2;
const $154486ef2dc8e36e$var$AppBarRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.position)}`],
            styles[`color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0,
        variants: [
            {
                props: {
                    position: 'fixed'
                },
                style: {
                    position: 'fixed',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0,
                    '@media print': {
                        // Prevent the app bar to be visible on each printed page.
                        position: 'absolute'
                    }
                }
            },
            {
                props: {
                    position: 'absolute'
                },
                style: {
                    position: 'absolute',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'sticky'
                },
                style: {
                    position: 'sticky',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'static'
                },
                style: {
                    position: 'static'
                }
            },
            {
                props: {
                    position: 'relative'
                },
                style: {
                    position: 'relative'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    '--AppBar-color': 'inherit',
                    color: 'var(--AppBar-color)'
                }
            },
            {
                props: {
                    color: 'default'
                },
                style: {
                    '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[100],
                    '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[100]),
                    ...theme.applyStyles('dark', {
                        '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[900],
                        '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[900])
                    })
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--AppBar-background': (theme.vars ?? theme).palette[color].main,
                        '--AppBar-color': (theme.vars ?? theme).palette[color].contrastText
                    }
                })),
            {
                props: (props)=>props.enableColorOnDark === true && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)'
                }
            },
            {
                props: (props)=>props.enableColorOnDark === false && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundColor: theme.vars ? $154486ef2dc8e36e$var$joinVars(theme.vars.palette.AppBar.darkBg, 'var(--AppBar-background)') : null,
                        color: theme.vars ? $154486ef2dc8e36e$var$joinVars(theme.vars.palette.AppBar.darkColor, 'var(--AppBar-color)') : null
                    })
                }
            },
            {
                props: {
                    color: 'transparent'
                },
                style: {
                    '--AppBar-background': 'transparent',
                    '--AppBar-color': 'inherit',
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundImage: 'none'
                    })
                }
            }
        ]
    })));
const $154486ef2dc8e36e$var$AppBar = /*#__PURE__*/ $h4Bez.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    };
    const classes = $154486ef2dc8e36e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($154486ef2dc8e36e$var$AppBarRoot, {
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref,
        ...other
    });
});
var $154486ef2dc8e36e$export$2e2bcd8739ae039 = $154486ef2dc8e36e$var$AppBar;


var $h4Bez = parcelRequire("h4Bez");








function $5c1f17c3a5bb70c5$export$b12cb262231eef32(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiToolbar', slot);
}
const $5c1f17c3a5bb70c5$var$toolbarClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $5c1f17c3a5bb70c5$export$2e2bcd8739ae039 = $5c1f17c3a5bb70c5$var$toolbarClasses;



'use client';
const $bba1e55ccd3c8aaa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $5c1f17c3a5bb70c5$export$b12cb262231eef32), classes);
};
const $bba1e55ccd3c8aaa$var$ToolbarRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2),
                    [theme.breakpoints.up('sm')]: {
                        paddingLeft: theme.spacing(3),
                        paddingRight: theme.spacing(3)
                    }
                }
            },
            {
                props: {
                    variant: 'dense'
                },
                style: {
                    minHeight: 48
                }
            },
            {
                props: {
                    variant: 'regular'
                },
                style: theme.mixins.toolbar
            }
        ]
    })));
const $bba1e55ccd3c8aaa$var$Toolbar = /*#__PURE__*/ $h4Bez.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableGutters: disableGutters,
        variant: variant
    };
    const classes = $bba1e55ccd3c8aaa$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($bba1e55ccd3c8aaa$var$ToolbarRoot, {
        as: component,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $bba1e55ccd3c8aaa$export$2e2bcd8739ae039 = $bba1e55ccd3c8aaa$var$Toolbar;



/** No line under it: the page's white panel below sets it apart */ const $bf0ec0058321f0af$var$appBarStyle = {
    backgroundColor: 'grey.100',
    boxShadow: 0,
    height: `${(0, $ec6d88728b15dea0$export$13f84e577eb08343)}px`
};
const $bf0ec0058321f0af$var$toolbarStyle = {
    height: `${(0, $ec6d88728b15dea0$export$13f84e577eb08343)}px`,
    minHeight: `${(0, $ec6d88728b15dea0$export$13f84e577eb08343)}px`
};
const $bf0ec0058321f0af$export$c4e96258f3b6511 = ({ children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $154486ef2dc8e36e$export$2e2bcd8739ae039), {
        position: "sticky",
        sx: $bf0ec0058321f0af$var$appBarStyle,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bba1e55ccd3c8aaa$export$2e2bcd8739ae039), {
            disableGutters: true,
            variant: "dense",
            sx: $bf0ec0058321f0af$var$toolbarStyle,
            children: children
        })
    });



const $4d66ebfe274b27c5$var$DRAWER_ID = 'mobile-navigation-drawer';
const $4d66ebfe274b27c5$var$DRAWER_SCREEN_SHARE = '86vw';
const $4d66ebfe274b27c5$var$DRAWER_MAX_WIDTH = 300;
const $4d66ebfe274b27c5$var$MENU_BUTTON_SIZE = 40;
const $4d66ebfe274b27c5$var$MENU_ICON_SIZE = 24;
const $4d66ebfe274b27c5$var$ROW_MIN_HEIGHT = 44;
const $4d66ebfe274b27c5$var$SECTION_HEADER_MIN_HEIGHT = 48;
const $4d66ebfe274b27c5$var$ROW_ICON_SIZE = 20;
const $4d66ebfe274b27c5$var$AVATAR_SIZE = 28;
const $4d66ebfe274b27c5$var$BACKDROP_OPACITY = 0.45;
/** Three columns: the menu button, the brand in the middle, and the badge at the end */ const $4d66ebfe274b27c5$var$toolbarContentStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    alignItems: 'center',
    gap: 2,
    width: '100%',
    height: '100%',
    px: 2
};
const $4d66ebfe274b27c5$var$barEndStyle = {
    display: 'flex',
    alignItems: 'center',
    justifySelf: 'end'
};
const $4d66ebfe274b27c5$var$menuButtonStyle = {
    justifySelf: 'start',
    width: `${$4d66ebfe274b27c5$var$MENU_BUTTON_SIZE}px`,
    height: `${$4d66ebfe274b27c5$var$MENU_BUTTON_SIZE}px`,
    color: 'grey.700',
    '&:hover': {
        color: 'grey.700',
        backgroundColor: 'grey.200'
    },
    [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: (0, $833922d52afcf466$export$d81cc31fdf858305)($4d66ebfe274b27c5$var$MENU_ICON_SIZE)
};
/** Browsers without CSS `round()` drop the whole declaration, so they get the unrounded width first */ const $4d66ebfe274b27c5$var$drawerPaperStyle = {
    width: `min(${$4d66ebfe274b27c5$var$DRAWER_SCREEN_SHARE}, ${$4d66ebfe274b27c5$var$DRAWER_MAX_WIDTH}px)`,
    /** Rounded down to a whole pixel, so the panel's edge stays on the pixel grid on any phone */ '@supports (width: round(down, 1px, 1px))': {
        width: `min(round(down, ${$4d66ebfe274b27c5$var$DRAWER_SCREEN_SHARE}, 1px), ${$4d66ebfe274b27c5$var$DRAWER_MAX_WIDTH}px)`
    },
    backgroundColor: 'grey.100',
    boxShadow: 4
};
const $4d66ebfe274b27c5$var$backdropStyle = {
    backgroundColor: (theme)=>(0, $3289d56f59a873c2$export$58f0f39f63f3cf42)(theme.palette.grey[900], $4d66ebfe274b27c5$var$BACKDROP_OPACITY)
};
const $4d66ebfe274b27c5$var$closeButtonStyle = {
    alignSelf: 'flex-start'
};
const $4d66ebfe274b27c5$var$drawerContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    gap: 2,
    py: 4,
    px: 3
};
const $4d66ebfe274b27c5$var$navStyle = {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    gap: 2
};
const $4d66ebfe274b27c5$var$rowStyle = (theme)=>({
        ...theme.typography.body2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 3,
        width: '100%',
        minHeight: `${$4d66ebfe274b27c5$var$ROW_MIN_HEIGHT}px`,
        px: 2,
        borderRadius: 1,
        color: 'grey.700',
        textAlign: 'left',
        '&:hover': {
            backgroundColor: 'grey.200'
        },
        [`&:focus-visible, &.${(0, $cbad1124ad327257$export$2e2bcd8739ae039).focusVisible}`]: (0, $5f78a8132f139ecb$export$a86f5934025b6e94)(theme)
    });
const $4d66ebfe274b27c5$var$rowIconStyle = {
    width: `${$4d66ebfe274b27c5$var$ROW_ICON_SIZE}px`,
    height: `${$4d66ebfe274b27c5$var$ROW_ICON_SIZE}px`,
    color: 'grey.500'
};
const $4d66ebfe274b27c5$var$sectionsStyle = {
    display: 'flex',
    flexDirection: 'column'
};
const $4d66ebfe274b27c5$var$sectionHeaderStyle = {
    minHeight: `${$4d66ebfe274b27c5$var$SECTION_HEADER_MIN_HEIGHT}px`,
    fontWeight: 500
};
const $4d66ebfe274b27c5$var$currentSectionStyle = {
    color: 'primary.700',
    [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
        color: 'primary.700'
    }
};
const $4d66ebfe274b27c5$var$sectionLabelStyle = {
    flex: 1
};
const $4d66ebfe274b27c5$var$chevronStyle = {
    ...$4d66ebfe274b27c5$var$rowIconStyle,
    transition: (theme)=>theme.transitions.create('transform', {
            duration: theme.transitions.duration.shorter
        })
};
const $4d66ebfe274b27c5$var$expandedChevronStyle = {
    transform: 'rotate(180deg)'
};
const $4d66ebfe274b27c5$var$pageListStyle = {
    listStyle: 'none',
    m: 0,
    pt: 1,
    pb: 2,
    px: 0
};
const $4d66ebfe274b27c5$var$pageLinkStyle = {
    pl: 8
};
const $4d66ebfe274b27c5$var$currentPageIconStyle = {
    [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
        color: 'primary.700'
    }
};
const $4d66ebfe274b27c5$var$groupDividerStyle = {
    mx: 2,
    my: 1,
    borderColor: 'grey.300'
};
const $4d66ebfe274b27c5$var$accountAreaStyle = {
    mt: 'auto',
    pt: 2,
    borderTop: 1,
    borderColor: 'grey.300'
};
const $4d66ebfe274b27c5$var$accountRowStyle = {
    fontWeight: 500
};
const $4d66ebfe274b27c5$var$avatarStyle = (theme)=>({
        ...theme.typography.caption,
        display: 'grid',
        placeItems: 'center',
        flexShrink: 0,
        width: `${$4d66ebfe274b27c5$var$AVATAR_SIZE}px`,
        height: `${$4d66ebfe274b27c5$var$AVATAR_SIZE}px`,
        borderRadius: '50%',
        backgroundColor: 'primary.50',
        color: 'primary.900',
        fontWeight: 600
    });
/** A name the user chose can be any length, so it wraps rather than being cut off */ const $4d66ebfe274b27c5$var$accountNameStyle = {
    flex: 1,
    overflowWrap: 'anywhere'
};
/** The card opens just above the account row, and the account row's width is set when it opens */ const $4d66ebfe274b27c5$var$accountCardStyle = {
    mt: -1
};
const $4d66ebfe274b27c5$var$accountHeadingStyle = (theme)=>({
        ...theme.typography.caption,
        fontWeight: 'fontWeightRegular',
        px: 4,
        pt: 2,
        pb: 1.5,
        color: 'grey.500',
        overflowWrap: 'anywhere'
    });
/** As on the action menu's destructive items: `700` keeps AA contrast on the hovered item's grey */ const $4d66ebfe274b27c5$var$logoutItemStyle = {
    color: 'error.700',
    [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
        color: 'inherit'
    }
};
/** The paper slot's type has no `data-testid`, and a spread property isn't checked against it the way a written one is */ const $4d66ebfe274b27c5$var$accountCardPaperTestId = {
    'data-testid': 'mobile-navigation-account-card-paper'
};
/** A modified click opens the link elsewhere (new tab, window), so the user stays on this page and the drawer stays open */ const $4d66ebfe274b27c5$var$isPlainPrimaryClick = (event)=>event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
/** A click on the link bubbles up here: `NavigationPermissionedLink` takes no click handler of its own */ const $4d66ebfe274b27c5$var$PageItem = ({ onNavigate: onNavigate, children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        component: "li",
        onClick: (event)=>{
            if ($4d66ebfe274b27c5$var$isPlainPrimaryClick(event)) onNavigate();
        },
        children: children
    });
const $4d66ebfe274b27c5$var$PageLink = ({ route: route, onNavigate: onNavigate })=>{
    const routing = (0, $42efdbd12003f6a9$export$ddab236f5c469f6f)();
    const formatter = (0, $00ca74462cc42d7b$export$bb747d72848d9c48)();
    const Icon = formatter.formatIcon(route);
    const current = routing.isAtRoute(route);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($4d66ebfe274b27c5$var$PageItem, {
        onNavigate: onNavigate,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $da6345f06052c88c$export$1bacad896f21662), {
            path: route,
            "aria-current": current ? 'page' : undefined,
            sx: [
                $4d66ebfe274b27c5$var$rowStyle,
                $4d66ebfe274b27c5$var$pageLinkStyle,
                current && (0, $b42edc8b93f3ea44$export$d0c0dc258af67699),
                current && $4d66ebfe274b27c5$var$currentPageIconStyle
            ],
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Icon, {
                    sx: $4d66ebfe274b27c5$var$rowIconStyle
                }),
                formatter.formatTitle(route)
            ]
        })
    });
};
const $4d66ebfe274b27c5$var$Section = ({ section: section, current: current, expanded: expanded, onToggle: onToggle, onNavigate: onNavigate })=>{
    const routing = (0, $3594775a147b3957$export$8dfcf1b19fcf9290)();
    const formatter = (0, $00ca74462cc42d7b$export$bb747d72848d9c48)();
    const hasCapabilities = (0, $ed3a79aec495d063$export$95fa16a10fc41701)();
    const theme = (0, $cd99783e1cac2d84$export$2e2bcd8739ae039)();
    if (!hasCapabilities(section)) return null;
    const Icon = formatter.formatIcon(section);
    const pagesId = `mobile-navigation-section-${section}`;
    const groups = routing.getSectionMenuGroups(section, (0, $2ea6382bc105e2d6$export$62609118ae1497c6)()).map((group)=>group.filter((route)=>hasCapabilities(route))).filter((group)=>group.length > 0);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "mobile-navigation-section",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d02728b6fe958b24$export$2e2bcd8739ae039), {
                "aria-expanded": expanded,
                "aria-controls": expanded ? pagesId : undefined,
                onClick: onToggle,
                sx: [
                    $4d66ebfe274b27c5$var$rowStyle,
                    $4d66ebfe274b27c5$var$sectionHeaderStyle,
                    current && $4d66ebfe274b27c5$var$currentSectionStyle
                ],
                "data-testid": "mobile-navigation-section-header",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Icon, {
                        sx: $4d66ebfe274b27c5$var$rowIconStyle
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        component: "span",
                        sx: $4d66ebfe274b27c5$var$sectionLabelStyle,
                        children: formatter.formatTitle(section)
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $024b35d06a10e12d$export$4857d3f3f5f8319b), {
                        sx: [
                            $4d66ebfe274b27c5$var$chevronStyle,
                            expanded && $4d66ebfe274b27c5$var$expandedChevronStyle
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7830414f6fe32da6$export$2e2bcd8739ae039), {
                in: expanded,
                timeout: theme.transitions.duration.shorter,
                unmountOnExit: true,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    id: pagesId,
                    component: "ul",
                    sx: $4d66ebfe274b27c5$var$pageListStyle,
                    children: groups.map((group, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $h4Bez.Fragment), {
                            children: [
                                k > 0 && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {
                                    component: "li",
                                    sx: $4d66ebfe274b27c5$var$groupDividerStyle,
                                    "data-testid": "mobile-navigation-group-divider"
                                }),
                                group.map((route)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($4d66ebfe274b27c5$var$PageLink, {
                                        route: route,
                                        onNavigate: onNavigate
                                    }, route))
                            ]
                        }, k))
                })
            })
        ]
    });
};
const $4d66ebfe274b27c5$var$NAME_SEPARATORS = /[\s._-]+/;
/**
 * Two letters for the account circle: the first letters of the name's first two parts ("jane.doe" → JD), or the first two
 * letters of its only part ("_admin" → AD). `Array.from` splits by character, so a letter outside the BMP stays whole.
 */ const $4d66ebfe274b27c5$var$getInitials = (name)=>{
    const [first = name, second] = name.split($4d66ebfe274b27c5$var$NAME_SEPARATORS).filter(Boolean);
    const letters = second === undefined ? Array.from(first).slice(0, 2) : [
        Array.from(first)[0],
        Array.from(second)[0]
    ];
    return letters.join('').toUpperCase();
};
const $4d66ebfe274b27c5$var$AccountMenu = ({ onNavigate: onNavigate })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const routing = (0, $42efdbd12003f6a9$export$ddab236f5c469f6f)();
    const formatter = (0, $00ca74462cc42d7b$export$bb747d72848d9c48)();
    const hasCapabilities = (0, $ed3a79aec495d063$export$95fa16a10fc41701)();
    const logoutUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('logoutUsecase');
    const username = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $1c05f13022cf1480$export$f45ac34dd9e56631));
    (0, $14eddac5f20c576c$export$a7a9523472993e97)(username !== null, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'The navigation is only rendered for an authenticated user'));
    const rowId = (0, $h4Bez.useId)();
    const cardId = (0, $h4Bez.useId)();
    const [anchor, setAnchor] = (0, $h4Bez.useState)(null);
    const documentationHref = (0, $57ff7f54e54013be$export$330e3f340a9faef5)((0, $de76aa5bd91d062d$export$26609300e3bf37cf).CYBUS_DOCS);
    const SettingsIcon = formatter.formatIcon((0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SETTINGS);
    const atSettings = routing.isAtRoute((0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SETTINGS);
    const open = anchor !== null;
    const closeCard = ()=>setAnchor(null);
    const closeAll = (event)=>{
        if ($4d66ebfe274b27c5$var$isPlainPrimaryClick(event)) {
            closeCard();
            onNavigate();
        }
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $4d66ebfe274b27c5$var$accountAreaStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d02728b6fe958b24$export$2e2bcd8739ae039), {
                id: rowId,
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? cardId : undefined,
                onClick: (event)=>setAnchor(event.currentTarget),
                sx: [
                    $4d66ebfe274b27c5$var$rowStyle,
                    $4d66ebfe274b27c5$var$accountRowStyle
                ],
                "data-testid": "mobile-navigation-account",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        component: "span",
                        sx: $4d66ebfe274b27c5$var$avatarStyle,
                        "aria-hidden": true,
                        children: $4d66ebfe274b27c5$var$getInitials(username)
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        component: "span",
                        sx: $4d66ebfe274b27c5$var$accountNameStyle,
                        "data-testid": "mobile-navigation-username",
                        children: username
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $024b35d06a10e12d$export$4857d3f3f5f8319b), {
                        sx: [
                            $4d66ebfe274b27c5$var$chevronStyle,
                            open && $4d66ebfe274b27c5$var$expandedChevronStyle
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $1949838101ccf179$export$2e2bcd8739ae039), {
                anchorEl: anchor,
                open: open,
                onClose: closeCard,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                },
                transformOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                },
                slotProps: {
                    paper: {
                        sx: [
                            $4d66ebfe274b27c5$var$accountCardStyle,
                            {
                                width: anchor?.offsetWidth
                            }
                        ],
                        ...$4d66ebfe274b27c5$var$accountCardPaperTestId
                    },
                    list: {
                        id: cardId,
                        'aria-labelledby': rowId
                    }
                },
                "data-testid": "mobile-navigation-account-card",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbf9d389b60a3979$export$2e2bcd8739ae039), {
                        role: "none",
                        disableSticky: true,
                        sx: $4d66ebfe274b27c5$var$accountHeadingStyle,
                        children: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_PHONE_SIGNED_IN_AS, {
                            username: username
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $b7bd066558465dcb$export$2e2bcd8739ae039), {
                        component: "a",
                        href: documentationHref,
                        target: "_blank",
                        onClick: closeAll,
                        "data-testid": "mobile-navigation-documentation",
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2f9668e957d9d1e8$export$d9fa4bf8819fddad), {
                                sx: $4d66ebfe274b27c5$var$rowIconStyle
                            }),
                            translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).DOCUMENTATION)
                        ]
                    }),
                    hasCapabilities((0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SETTINGS) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $b7bd066558465dcb$export$2e2bcd8739ae039), {
                        component: (0, $7d5f64758ce3b1db$export$93fe4a80834d0286),
                        path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SETTINGS,
                        color: "inherit",
                        "aria-current": atSettings ? 'page' : undefined,
                        selected: atSettings,
                        sx: atSettings ? $4d66ebfe274b27c5$var$currentSectionStyle : undefined,
                        onClick: closeAll,
                        "data-testid": "mobile-navigation-settings",
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(SettingsIcon, {
                                sx: $4d66ebfe274b27c5$var$rowIconStyle
                            }),
                            formatter.formatTitle((0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SETTINGS)
                        ]
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {
                        component: "li",
                        "data-testid": "mobile-navigation-account-divider"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $b7bd066558465dcb$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            closeCard();
                            onNavigate();
                            logoutUsecase.logout((0, $3f24850e5c974db2$export$55e75bec2b906c5e).MANUAL_LOGOUT);
                        },
                        sx: $4d66ebfe274b27c5$var$logoutItemStyle,
                        "data-testid": "mobile-navigation-logout",
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $925b67d17bae5efe$export$2c9e30524eeaa42e), {
                                sx: $4d66ebfe274b27c5$var$rowIconStyle
                            }),
                            translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).LOGOUT)
                        ]
                    })
                ]
            })
        ]
    });
};
const $4d66ebfe274b27c5$export$db34cf84ea784258 = ({ deviationsBadge: deviationsBadge })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const routing = (0, $3594775a147b3957$export$8dfcf1b19fcf9290)();
    const [open, setOpen] = (0, $h4Bez.useState)(false);
    const [expandedSection, setExpandedSection] = (0, $h4Bez.useState)(null);
    const currentSection = routing.getCurrentSection();
    const close = ()=>setOpen(false);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bf0ec0058321f0af$export$c4e96258f3b6511), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: $4d66ebfe274b27c5$var$toolbarContentStyle,
                    "data-testid": "mobile-navigation-bar",
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8ccbf49a69947e95$export$2e2bcd8739ae039), {
                            variant: "ghost",
                            "aria-label": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).MENU),
                            "aria-expanded": open,
                            "aria-controls": open ? $4d66ebfe274b27c5$var$DRAWER_ID : undefined,
                            onClick: ()=>{
                                setExpandedSection(currentSection);
                                setOpen(true);
                            },
                            sx: $4d66ebfe274b27c5$var$menuButtonStyle,
                            "data-testid": "mobile-navigation-menu-button",
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1db79fc0e1cdd4b8$export$ebde1bbb54d9e014), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7e02f1e3fb8177b2$export$75d5b518c51e7fd6), {
                            hideNameWhenTight: true
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                            sx: $4d66ebfe274b27c5$var$barEndStyle,
                            children: deviationsBadge
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5ae8551b9622d985$export$2e2bcd8739ae039), {
                id: $4d66ebfe274b27c5$var$DRAWER_ID,
                anchor: "left",
                open: open,
                onClose: close,
                slotProps: {
                    paper: {
                        sx: $4d66ebfe274b27c5$var$drawerPaperStyle
                    },
                    backdrop: {
                        sx: $4d66ebfe274b27c5$var$backdropStyle
                    }
                },
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: $4d66ebfe274b27c5$var$drawerContentStyle,
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8ccbf49a69947e95$export$2e2bcd8739ae039), {
                            variant: "ghost",
                            "aria-label": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_PHONE_MENU_CLOSE),
                            onClick: close,
                            sx: [
                                $4d66ebfe274b27c5$var$menuButtonStyle,
                                $4d66ebfe274b27c5$var$closeButtonStyle
                            ],
                            "data-testid": "mobile-navigation-close",
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b9a3c6876c67d06c$export$cae179f078f4b4a4), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                            component: "nav",
                            "aria-label": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).MENU),
                            sx: $4d66ebfe274b27c5$var$navStyle,
                            "data-testid": "mobile-navigation-drawer",
                            children: [
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                                    sx: $4d66ebfe274b27c5$var$sectionsStyle,
                                    children: (0, $2ea6382bc105e2d6$export$3230c9e059765c6e).map((section)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($4d66ebfe274b27c5$var$Section, {
                                            section: section,
                                            current: section === currentSection,
                                            expanded: section === expandedSection,
                                            onToggle: ()=>setExpandedSection(section === expandedSection ? null : section),
                                            onNavigate: close
                                        }, section))
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($4d66ebfe274b27c5$var$AccountMenu, {
                                    onNavigate: close
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};




var $h4Bez = parcelRequire("h4Bez");













const $d6ca7705bdce190b$var$SIDEBAR_ANIMATION_CSS = '.25s ease-in-out';
const $d6ca7705bdce190b$var$OPEN_WIDTH = 200;
const $d6ca7705bdce190b$var$ITEM_SIZE = 32;
const $d6ca7705bdce190b$var$ICON_SIZE = (0, $833922d52afcf466$export$e34d2553ba553d7c);
/** In spacing steps of THEME_SPACING_UNIT (4px), used both by the styles below and by the widths, so they can't drift apart */ const $d6ca7705bdce190b$var$BODY_SIDE_PADDING = 2;
const $d6ca7705bdce190b$var$ITEM_SIDE_PADDING = 2;
const $d6ca7705bdce190b$var$ICON_TO_LABEL = 3;
/**
 * The label's room on one line in the open side bar: 200px, less 8px side padding twice, 8px item padding twice, the icon and
 * the 12px gap. It is fixed, so while the side bar animates open the label already wraps as it will at full width, and the
 * narrow side bar clips it instead of squeezing it word by word.
 */ const $d6ca7705bdce190b$var$LABEL_WIDTH = $d6ca7705bdce190b$var$OPEN_WIDTH - (2 * $d6ca7705bdce190b$var$BODY_SIDE_PADDING + 2 * $d6ca7705bdce190b$var$ITEM_SIDE_PADDING + $d6ca7705bdce190b$var$ICON_TO_LABEL) * (0, $1a6512ae4318d72b$export$1d5937c6c580f51) - $d6ca7705bdce190b$var$ICON_SIZE;
/** 48px: a 32px item plus the body's side padding, so a left-aligned item is already centred */ const $d6ca7705bdce190b$var$CLOSED_WIDTH = $d6ca7705bdce190b$var$ITEM_SIZE + 2 * $d6ca7705bdce190b$var$BODY_SIDE_PADDING * (0, $1a6512ae4318d72b$export$1d5937c6c580f51);
/**
 * A label too long for one line wraps onto more lines rather than being cut off, so it is always readable in full, on touch
 * screens too. The item grows from 32px by 20px per extra line, and the icon stays level with the first line.
 */ const $d6ca7705bdce190b$var$linkStyle = (theme)=>({
        display: 'flex',
        alignItems: 'flex-start',
        gap: $d6ca7705bdce190b$var$ICON_TO_LABEL,
        minHeight: $d6ca7705bdce190b$var$ITEM_SIZE,
        boxSizing: 'border-box',
        px: $d6ca7705bdce190b$var$ITEM_SIDE_PADDING,
        py: 1.5,
        borderRadius: 1,
        color: 'grey.700',
        typography: 'body2',
        overflow: 'hidden',
        '&:hover': {
            backgroundColor: 'grey.200'
        },
        '&:focus-visible': (0, $5f78a8132f139ecb$export$a86f5934025b6e94)(theme)
    });
/**
 * Closed, an item is a 32px square with its icon centred. The square itself stays left-aligned in the list: at 48px wide with
 * 8px padding it is already centred, and it doesn't jump to the middle while the width animates.
 */ const $d6ca7705bdce190b$var$collapsedLinkStyle = {
    width: $d6ca7705bdce190b$var$ITEM_SIZE,
    px: 0,
    justifyContent: 'center'
};
/** The icon sits in a box as tall as one line of label text, so it stays level with the first line at any text size */ const $d6ca7705bdce190b$var$iconBoxStyle = {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    height: (theme)=>theme.typography.body2.lineHeight
};
const $d6ca7705bdce190b$var$iconStyle = {
    ...(0, $833922d52afcf466$export$5f737a2a865aaa0c)(),
    color: 'grey.500'
};
const $d6ca7705bdce190b$var$selectedIconStyle = {
    color: 'primary.700'
};
const $d6ca7705bdce190b$var$labelStyle = {
    flexShrink: 0,
    width: $d6ca7705bdce190b$var$LABEL_WIDTH,
    overflowWrap: 'break-word'
};
const $d6ca7705bdce190b$var$NavigationLink = ({ route: route })=>{
    const routing = (0, $42efdbd12003f6a9$export$ddab236f5c469f6f)();
    const formatter = (0, $00ca74462cc42d7b$export$bb747d72848d9c48)();
    const collapsed = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $b0991a9a4ef4845f$export$7ee49b75b6d0f0fb));
    const selected = routing.isAtRoute(route);
    const Icon = formatter.formatIcon(route);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $da6345f06052c88c$export$1bacad896f21662), {
        path: route,
        withTooltip: collapsed,
        "aria-current": selected ? 'page' : undefined,
        sx: [
            $d6ca7705bdce190b$var$linkStyle,
            selected && (0, $b42edc8b93f3ea44$export$d0c0dc258af67699),
            collapsed && $d6ca7705bdce190b$var$collapsedLinkStyle
        ],
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                component: "span",
                sx: $d6ca7705bdce190b$var$iconBoxStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Icon, {
                    sx: [
                        $d6ca7705bdce190b$var$iconStyle,
                        selected && $d6ca7705bdce190b$var$selectedIconStyle
                    ]
                })
            }),
            !collapsed && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                component: "span",
                sx: $d6ca7705bdce190b$var$labelStyle,
                children: formatter.formatTitle(route)
            })
        ]
    });
};
const $d6ca7705bdce190b$var$listStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    width: '100%'
};
const $d6ca7705bdce190b$var$NavigationLinkList = ({ routes: routes, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $d6ca7705bdce190b$var$listStyle,
        ...props,
        children: routes.map((route)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($d6ca7705bdce190b$var$NavigationLink, {
                route: route
            }, route))
    });
const $d6ca7705bdce190b$var$drawerStyle = {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    width: $d6ca7705bdce190b$var$OPEN_WIDTH,
    backgroundColor: 'grey.100',
    transition: `width ${$d6ca7705bdce190b$var$SIDEBAR_ANIMATION_CSS}`
};
const $d6ca7705bdce190b$var$collapsedDrawerStyle = {
    width: $d6ca7705bdce190b$var$CLOSED_WIDTH
};
const $d6ca7705bdce190b$var$bodyStyle = {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    gap: 3,
    px: $d6ca7705bdce190b$var$BODY_SIDE_PADDING,
    py: 4
};
const $d6ca7705bdce190b$var$dividerStyle = {
    width: '100%',
    borderColor: 'grey.300'
};
const $d6ca7705bdce190b$var$collapsedDividerStyle = {
    width: $d6ca7705bdce190b$var$ITEM_SIZE
};
/**
 * The badge and the toggle sit at the bottom in the normal flow, so on a short window they never cover the items. They stay
 * right-aligned, so they slide with the edge while the width animates, and at 48px that is already centred.
 */ const $d6ca7705bdce190b$var$footStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 3,
    mt: 'auto'
};
/** The ghost button's own hover grey is the side bar's background, so it gets the side bar's item hover instead */ const $d6ca7705bdce190b$var$toggleStyle = {
    width: $d6ca7705bdce190b$var$ITEM_SIZE,
    height: $d6ca7705bdce190b$var$ITEM_SIZE,
    color: 'grey.500',
    '&:hover': {
        backgroundColor: 'grey.200',
        color: 'grey.700'
    },
    '&:active': {
        backgroundColor: 'grey.300'
    },
    [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
        width: $d6ca7705bdce190b$var$ICON_SIZE,
        height: $d6ca7705bdce190b$var$ICON_SIZE,
        transition: `transform ${$d6ca7705bdce190b$var$SIDEBAR_ANIMATION_CSS}`
    }
};
const $d6ca7705bdce190b$var$collapsedToggleIconStyle = {
    transform: 'scaleX(-1)'
};
const $d6ca7705bdce190b$export$cc4f63927c41742f = ({ deviationsBadge: deviationsBadge })=>{
    const routing = (0, $3594775a147b3957$export$8dfcf1b19fcf9290)();
    const groups = routing.getSideMenuGroups((0, $2ea6382bc105e2d6$export$62609118ae1497c6)());
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const navigationUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('navigationUsecase');
    const collapsed = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $b0991a9a4ef4845f$export$7ee49b75b6d0f0fb));
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        component: "nav",
        "aria-label": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_SIDE_LABEL),
        sx: [
            $d6ca7705bdce190b$var$drawerStyle,
            collapsed && $d6ca7705bdce190b$var$collapsedDrawerStyle
        ],
        "data-testid": "side-navigation",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7e02f1e3fb8177b2$export$75d5b518c51e7fd6), {
                collapsed: collapsed
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $d6ca7705bdce190b$var$bodyStyle,
                children: [
                    groups.map((group, k)=>{
                        if (group.length === 0) return null;
                        return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $h4Bez.Fragment), {
                            children: [
                                k > 0 && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {
                                    "data-testid": "side-navigation-divider",
                                    sx: [
                                        $d6ca7705bdce190b$var$dividerStyle,
                                        collapsed && $d6ca7705bdce190b$var$collapsedDividerStyle
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($d6ca7705bdce190b$var$NavigationLinkList, {
                                    "data-testid": `side-navigation-${k + 1}`,
                                    routes: group
                                })
                            ]
                        }, k);
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        sx: $d6ca7705bdce190b$var$footStyle,
                        children: [
                            deviationsBadge,
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
                                "data-testid": "side-navigation-toggle",
                                variant: "ghost",
                                "aria-label": translator.formatTranslation(collapsed ? (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_SIDE_EXPAND : (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_SIDE_COLLAPSE),
                                onClick: ()=>navigationUsecase.toggleSideNavCollapsed(),
                                sx: $d6ca7705bdce190b$var$toggleStyle,
                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $448e9e65bf8dd2f3$export$53b2dd97264155a8), {
                                    sx: [
                                        collapsed && $d6ca7705bdce190b$var$collapsedToggleIconStyle
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



parcelRequire("h4Bez");













parcelRequire("h4Bez");




const $bcdc534b637e5877$var$boxStyle = {
    display: 'flex',
    alignItems: 'center',
    height: 24,
    my: 'auto',
    mr: 2,
    px: 2,
    color: 'warning.800',
    backgroundColor: 'warning.100',
    borderColor: 'warning.200',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 1,
    userSelect: 'none',
    whiteSpace: 'nowrap'
};
const $bcdc534b637e5877$var$iconStyle = {
    width: 12,
    height: 12,
    color: 'warning.500',
    mr: 1
};
const $bcdc534b637e5877$var$captionStyle = {
    letterSpacing: 0
};
const $bcdc534b637e5877$export$b52310cb55a7314b = ()=>{
    const nearExpiration = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $1c05f13022cf1480$export$97c945ddcfd5e726));
    if (nearExpiration === null) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $bcdc534b637e5877$var$boxStyle,
        "data-testid": "session-countdown",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ce5ed6e542502f21$export$8099ab97743c966c), {
                sx: $bcdc534b637e5877$var$iconStyle
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$32fbfacc5d962e0c), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SESSION_COUNTDOWN,
                values: {
                    countdown: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9007db43a2391fe5$export$53819c0e58f98d49), {
                        value: nearExpiration
                    })
                },
                sx: $bcdc534b637e5877$var$captionStyle
            })
        ]
    });
};



/**
 * There are 2 types of links:
 * - text links (nav items with icon and text, on the left)
 * - icon links (nav items with icon only, on the right)
 */ /**
 * Left nav items (text links): a 36px row holding the icon and label, and 4px below it a 2px
 * line that turns blue under the selected tab. Hovering fills the row, not the whole tab.
 */ const $c3acbc82ba89dc41$var$TAB_ROW_HEIGHT = 36;
const $c3acbc82ba89dc41$var$TAB_LINE_HEIGHT = 2;
const $c3acbc82ba89dc41$var$ICON_SIZE = 20;
const $c3acbc82ba89dc41$var$TAB_ROW_CLASS = 'navigation-tab-row';
const $c3acbc82ba89dc41$var$linkTextLinkStyle = (theme)=>({
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        color: 'grey.700',
        whiteSpace: 'nowrap',
        ...theme.typography.body2,
        fontWeight: 500,
        [`&:hover .${$c3acbc82ba89dc41$var$TAB_ROW_CLASS}`]: {
            backgroundColor: 'grey.200'
        },
        // Like hover, the keyboard focus outline sits on the row, the same 2px inset blue outline as the side bar
        '&:focus-visible': {
            outline: 'none'
        },
        [`&:focus-visible .${$c3acbc82ba89dc41$var$TAB_ROW_CLASS}`]: (0, $5f78a8132f139ecb$export$a86f5934025b6e94)(theme)
    });
const $c3acbc82ba89dc41$var$selectedTextLinkStyle = {
    color: 'primary.700'
};
const $c3acbc82ba89dc41$var$tabRowStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 3,
    height: $c3acbc82ba89dc41$var$TAB_ROW_HEIGHT,
    boxSizing: 'border-box',
    p: 2,
    borderRadius: 1
};
/** A 4px corner on a 2px line gives it fully rounded ends */ const $c3acbc82ba89dc41$var$tabLineStyle = {
    height: $c3acbc82ba89dc41$var$TAB_LINE_HEIGHT,
    borderRadius: 1,
    backgroundColor: 'transparent'
};
const $c3acbc82ba89dc41$var$selectedTabLineStyle = {
    backgroundColor: 'primary.700'
};
const $c3acbc82ba89dc41$var$iconTextLinkStyle = {
    width: $c3acbc82ba89dc41$var$ICON_SIZE,
    height: $c3acbc82ba89dc41$var$ICON_SIZE,
    flexShrink: 0,
    color: 'grey.500'
};
const $c3acbc82ba89dc41$var$selectedIconTextLinkStyle = {
    color: 'inherit'
};
/** The tabs sit at the bottom of the bar, the blue line 1px above the page panel */ const $c3acbc82ba89dc41$var$tabsStyle = {
    alignSelf: 'stretch',
    alignItems: 'flex-end',
    pb: 0.25
};
// right nav items styles (icon links)
const $c3acbc82ba89dc41$var$linkIconLinkStyle = {
    display: 'flex',
    alignItems: 'center',
    p: 2,
    cursor: 'pointer',
    color: 'grey.500',
    '&:hover': {
        color: 'grey.700'
    }
};
const $c3acbc82ba89dc41$var$selectedIconLinkStyle = {
    color: 'primary.700'
};
const $c3acbc82ba89dc41$var$iconIconLinkStyle = {
    width: $c3acbc82ba89dc41$var$ICON_SIZE,
    height: $c3acbc82ba89dc41$var$ICON_SIZE,
    color: 'inherit'
};
const $c3acbc82ba89dc41$var$selectedIconIconLinkStyle = {
    color: 'primary.700'
};
const $c3acbc82ba89dc41$var$ExternalLink = ({ icon: Icon, title: title, ...props })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const linkTitle = translator.formatTranslation(title);
    if ('documentation' in props) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $57ff7f54e54013be$export$6eb1e07b1de459cd), {
        ...props,
        type: props.documentation,
        title: linkTitle,
        "aria-label": linkTitle,
        sx: $c3acbc82ba89dc41$var$linkIconLinkStyle,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Icon, {
            sx: $c3acbc82ba89dc41$var$iconIconLinkStyle
        })
    });
    return(// A real button, so it can be reached and used with the keyboard: a link without an address can't be
    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a497eee141ca75b8$export$2e2bcd8739ae039), {
        ...props,
        component: "button",
        type: "button",
        onClick: props.onClick,
        title: linkTitle,
        "aria-label": linkTitle,
        sx: $c3acbc82ba89dc41$var$linkIconLinkStyle,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Icon, {
            sx: $c3acbc82ba89dc41$var$iconIconLinkStyle
        })
    }));
};
const $c3acbc82ba89dc41$var$NavigationLink = ({ route: route })=>{
    const routing = (0, $42efdbd12003f6a9$export$ddab236f5c469f6f)();
    const formatter = (0, $00ca74462cc42d7b$export$bb747d72848d9c48)();
    const selected = routing.isAtRoute(route);
    const Icon = formatter.formatIcon(route);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $da6345f06052c88c$export$1bacad896f21662), {
        path: route,
        "aria-current": selected ? 'true' : undefined,
        sx: [
            $c3acbc82ba89dc41$var$linkTextLinkStyle,
            selected && $c3acbc82ba89dc41$var$selectedTextLinkStyle
        ],
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                component: "span",
                className: $c3acbc82ba89dc41$var$TAB_ROW_CLASS,
                sx: $c3acbc82ba89dc41$var$tabRowStyle,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Icon, {
                        sx: [
                            $c3acbc82ba89dc41$var$iconTextLinkStyle,
                            selected && $c3acbc82ba89dc41$var$selectedIconTextLinkStyle
                        ]
                    }),
                    formatter.formatTitle(route)
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                component: "span",
                sx: [
                    $c3acbc82ba89dc41$var$tabLineStyle,
                    selected && $c3acbc82ba89dc41$var$selectedTabLineStyle
                ]
            })
        ]
    });
};
const $c3acbc82ba89dc41$var$NavigationIconLink = ({ route: route })=>{
    const routing = (0, $42efdbd12003f6a9$export$ddab236f5c469f6f)();
    const formatter = (0, $00ca74462cc42d7b$export$bb747d72848d9c48)();
    const selected = routing.isAtRoute(route);
    const Icon = formatter.formatIcon(route);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $da6345f06052c88c$export$1bacad896f21662), {
        path: route,
        "aria-label": formatter.formatTitle(route),
        "aria-current": selected ? 'page' : undefined,
        sx: [
            $c3acbc82ba89dc41$var$linkIconLinkStyle,
            selected && $c3acbc82ba89dc41$var$selectedIconLinkStyle
        ],
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Icon, {
            sx: [
                $c3acbc82ba89dc41$var$iconIconLinkStyle,
                selected && $c3acbc82ba89dc41$var$selectedIconIconLinkStyle
            ]
        })
    });
};
const $c3acbc82ba89dc41$var$toolbarContentStyle = {
    width: '100%',
    height: '100%',
    justifyContent: 'space-between'
};
const $c3acbc82ba89dc41$var$linksWrapperStyle = {
    flex: 1,
    px: 4
};
const $c3acbc82ba89dc41$var$emptyBoxStyle = {
    mx: 'auto'
};
const $c3acbc82ba89dc41$export$8a421bddecb2bf5b = ()=>{
    const logoutUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('logoutUsecase');
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bf0ec0058321f0af$export$c4e96258f3b6511), {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
            direction: "row",
            sx: $c3acbc82ba89dc41$var$toolbarContentStyle,
            "data-testid": "navigation-bar",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
                direction: "row",
                sx: $c3acbc82ba89dc41$var$linksWrapperStyle,
                "data-testid": "navigation-list",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
                        component: "nav",
                        "aria-label": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).NAVIGATION_TOP_LABEL),
                        direction: "row",
                        gap: 5,
                        sx: $c3acbc82ba89dc41$var$tabsStyle,
                        children: (0, $2ea6382bc105e2d6$export$3230c9e059765c6e).map((route)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($c3acbc82ba89dc41$var$NavigationLink, {
                                route: route
                            }, route))
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        sx: $c3acbc82ba89dc41$var$emptyBoxStyle
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bcdc534b637e5877$export$b52310cb55a7314b), {}),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
                        direction: "row",
                        gap: 1.5,
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($c3acbc82ba89dc41$var$ExternalLink, {
                                "data-testid": "documentation-top-link",
                                icon: (0, $2f9668e957d9d1e8$export$d9fa4bf8819fddad),
                                documentation: (0, $de76aa5bd91d062d$export$26609300e3bf37cf).CYBUS_DOCS,
                                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DOCUMENTATION
                            }),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($c3acbc82ba89dc41$var$NavigationIconLink, {
                                route: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SETTINGS
                            }),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($c3acbc82ba89dc41$var$ExternalLink, {
                                "data-testid": "logout-top-link",
                                icon: (0, $925b67d17bae5efe$export$2c9e30524eeaa42e),
                                onClick: ()=>logoutUsecase.logout((0, $3f24850e5c974db2$export$55e75bec2b906c5e).MANUAL_LOGOUT),
                                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LOGOUT
                            })
                        ]
                    })
                ]
            })
        })
    });
};


const $cf0025d93820ff7a$var$wrapperStyle = {
    height: '100vh',
    backgroundColor: 'grey.100'
};
const $cf0025d93820ff7a$var$sideColumnStyle = {
    height: '100%',
    flexShrink: 0,
    overflowX: 'hidden',
    overflowY: 'auto'
};
const $cf0025d93820ff7a$var$mainColumnStyle = {
    height: '100%',
    minWidth: 0,
    flexGrow: 1
};
/** The record panel outlet: positioned, and clipping the panel while it slides */ const $cf0025d93820ff7a$var$contentWrapperStyle = {
    position: 'relative',
    flexGrow: 1,
    minHeight: 0,
    overflow: 'hidden'
};
const $cf0025d93820ff7a$export$140c5c8fcbe43661 = ({ deviationsBadge: deviationsBadge, mobileDeviationsBadge: mobileDeviationsBadge, children: children })=>{
    const isMobile = (0, $754fff3a95ef867c$export$2b96349243a56116)();
    const [recordPanelOutlet, setRecordPanelOutlet] = (0, $h4Bez.useState)(null);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
        direction: "row",
        sx: $cf0025d93820ff7a$var$wrapperStyle,
        children: [
            !isMobile && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $cf0025d93820ff7a$var$sideColumnStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d6ca7705bdce190b$export$cc4f63927c41742f), {
                    deviationsBadge: deviationsBadge
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
                sx: $cf0025d93820ff7a$var$mainColumnStyle,
                children: [
                    isMobile ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4d66ebfe274b27c5$export$db34cf84ea784258), {
                        deviationsBadge: mobileDeviationsBadge
                    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c3acbc82ba89dc41$export$8a421bddecb2bf5b), {}),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $93093fe5e980edc3$export$7fce389886c4768b), {}),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
                        ref: setRecordPanelOutlet,
                        direction: "row",
                        sx: $cf0025d93820ff7a$var$contentWrapperStyle,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4cbbdab39f07fc39$export$6fdd3966acfaf7f2), {
                            outlet: recordPanelOutlet,
                            children: children
                        })
                    })
                ]
            })
        ]
    });
};



parcelRequire("h4Bez");


parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");















'use client';
var $fcdcf6c307a78a17$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz');




'use client';
const $a4ca686f0887bc5d$var$BreadcrumbCollapsedButton = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d02728b6fe958b24$export$2e2bcd8739ae039), {
    name: 'MuiBreadcrumbCollapsed'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
        marginRight: `calc(${theme.spacing(1)} * 0.5)`,
        ...theme.palette.mode === 'light' ? {
            backgroundColor: theme.palette.grey[100],
            color: theme.palette.grey[700]
        } : {
            backgroundColor: theme.palette.grey[700],
            color: theme.palette.grey[100]
        },
        borderRadius: 2,
        '&:hover, &:focus': {
            ...theme.palette.mode === 'light' ? {
                backgroundColor: theme.palette.grey[200]
            } : {
                backgroundColor: theme.palette.grey[600]
            }
        },
        '&:active': {
            boxShadow: theme.shadows[0],
            ...theme.palette.mode === 'light' ? {
                backgroundColor: (0, $3289d56f59a873c2$export$e665714f76e581fd)(theme.palette.grey[200], 0.12)
            } : {
                backgroundColor: (0, $3289d56f59a873c2$export$e665714f76e581fd)(theme.palette.grey[600], 0.12)
            }
        }
    })));
const $a4ca686f0887bc5d$var$BreadcrumbCollapsedIcon = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $fcdcf6c307a78a17$export$2e2bcd8739ae039))({
    width: 24,
    height: 16
});
/**
 * @ignore - internal component.
 */ function $a4ca686f0887bc5d$var$BreadcrumbCollapsed(props) {
    const { slots: slots = {}, slotProps: slotProps = {}, ...otherProps } = props;
    const ownerState = props;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("li", {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($a4ca686f0887bc5d$var$BreadcrumbCollapsedButton, {
            focusRipple: true,
            ...otherProps,
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($a4ca686f0887bc5d$var$BreadcrumbCollapsedIcon, {
                as: slots.CollapsedIcon,
                ownerState: ownerState,
                ...slotProps.collapsedIcon
            })
        })
    });
}
var $a4ca686f0887bc5d$export$2e2bcd8739ae039 = $a4ca686f0887bc5d$var$BreadcrumbCollapsed;




function $673fd2d45379a1a3$export$17261110b18c8084(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiBreadcrumbs', slot);
}
const $673fd2d45379a1a3$var$breadcrumbsClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiBreadcrumbs', [
    'root',
    'ol',
    'li',
    'separator'
]);
var $673fd2d45379a1a3$export$2e2bcd8739ae039 = $673fd2d45379a1a3$var$breadcrumbsClasses;



'use client';
const $68eca94d3c141da6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        li: [
            'li'
        ],
        ol: [
            'ol'
        ],
        separator: [
            'separator'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $673fd2d45379a1a3$export$17261110b18c8084), classes);
};
const $68eca94d3c141da6$var$BreadcrumbsRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
    name: 'MuiBreadcrumbs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${(0, $673fd2d45379a1a3$export$2e2bcd8739ae039).li}`]: styles.li
            },
            styles.root
        ];
    }
})({});
const $68eca94d3c141da6$var$BreadcrumbsOl = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('ol', {
    name: 'MuiBreadcrumbs',
    slot: 'Ol'
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
const $68eca94d3c141da6$var$BreadcrumbsSeparator = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('li', {
    name: 'MuiBreadcrumbs',
    slot: 'Separator'
})({
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
});
function $68eca94d3c141da6$var$insertSeparators(items, className, separator, ownerState) {
    return items.reduce((acc, current, index)=>{
        if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($68eca94d3c141da6$var$BreadcrumbsSeparator, {
            "aria-hidden": true,
            className: className,
            ownerState: ownerState,
            children: separator
        }, `separator-${index}`));
        else acc.push(current);
        return acc;
    }, []);
}
const $68eca94d3c141da6$var$Breadcrumbs = /*#__PURE__*/ $h4Bez.forwardRef(function Breadcrumbs(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiBreadcrumbs'
    });
    const { children: children, className: className, component: component = 'nav', slots: slots = {}, slotProps: slotProps = {}, expandText: expandText = 'Show path', itemsAfterCollapse: itemsAfterCollapse = 1, itemsBeforeCollapse: itemsBeforeCollapse = 1, maxItems: maxItems = 8, separator: separator = '/', ...other } = props;
    const [expanded, setExpanded] = $h4Bez.useState(false);
    const ownerState = {
        ...props,
        component: component,
        expanded: expanded,
        expandText: expandText,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        maxItems: maxItems,
        separator: separator
    };
    const classes = $68eca94d3c141da6$var$useUtilityClasses(ownerState);
    const collapsedIconSlotProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: slots.CollapsedIcon,
        externalSlotProps: slotProps.collapsedIcon,
        ownerState: ownerState
    });
    const listRef = $h4Bez.useRef(null);
    const renderItemsBeforeAndAfter = (allItems)=>{
        const handleClickExpand = ()=>{
            setExpanded(true);
            // The clicked element received the focus but gets removed from the DOM.
            // Let's keep the focus in the component after expanding.
            // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
            // By moving it to some link/button at least we have some announcement.
            const focusable = listRef.current.querySelector('a[href],button,[tabindex]');
            if (focusable) focusable.focus();
        };
        // This defends against someone passing weird input, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        return [
            ...allItems.slice(0, itemsBeforeCollapse),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a4ca686f0887bc5d$export$2e2bcd8739ae039), {
                "aria-label": expandText,
                slots: {
                    CollapsedIcon: slots.CollapsedIcon
                },
                slotProps: {
                    collapsedIcon: collapsedIconSlotProps
                },
                onClick: handleClickExpand
            }, "ellipsis"),
            ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)
        ];
    };
    const allItems = $h4Bez.Children.toArray(children).filter((child)=>{
        return /*#__PURE__*/ $h4Bez.isValidElement(child);
    }).map((child, index)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("li", {
            className: classes.li,
            children: child
        }, `child-${index}`));
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($68eca94d3c141da6$var$BreadcrumbsRoot, {
        ref: ref,
        component: component,
        color: "textSecondary",
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($68eca94d3c141da6$var$BreadcrumbsOl, {
            className: classes.ol,
            ref: listRef,
            ownerState: ownerState,
            children: $68eca94d3c141da6$var$insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
        })
    });
});
var $68eca94d3c141da6$export$2e2bcd8739ae039 = $68eca94d3c141da6$var$Breadcrumbs;




"use client";
var $4ef084bdeb50267a$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');




const $1c8aeb9e5f335475$var$linkStyle = {
    color: 'info.main',
    cursor: 'pointer'
};
const $1c8aeb9e5f335475$export$2dc68d50d56fbbd = ()=>{
    const routing = (0, $42efdbd12003f6a9$export$ddab236f5c469f6f)();
    const formatter = (0, $00ca74462cc42d7b$export$bb747d72848d9c48)();
    const [current, ...parents] = routing.getNavigation();
    const currentTitle = formatter.formatTitle(current);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $68eca94d3c141da6$export$2e2bcd8739ae039), {
        "data-testid": "breadcrumbs",
        separator: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4ef084bdeb50267a$export$2e2bcd8739ae039), {
            fontSize: "small"
        }),
        children: [
            parents.reverse().map((route)=>{
                const title = formatter.formatTitle(route);
                return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7d5f64758ce3b1db$export$bf4bb1ff1ff62959), {
                    sx: $1c8aeb9e5f335475$var$linkStyle,
                    parent: route,
                    title: title,
                    children: title
                }, route);
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a497eee141ca75b8$export$2e2bcd8739ae039), {
                color: "inherit",
                underline: "none",
                title: currentTitle,
                children: currentTitle
            })
        ]
    });
};



parcelRequire("h4Bez");




const $e823e43882f6834e$export$9e418155083c0a3a = ()=>{
    const nearExpiration = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $1c05f13022cf1480$export$97c945ddcfd5e726));
    const isMobile = (0, $754fff3a95ef867c$export$2b96349243a56116)();
    if (nearExpiration === null || !isMobile) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e2c4c4ee1e8614f4$export$3b4e64e77073e307), {
        "data-testid": "session-banner",
        severity: (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).WARNING,
        live: false,
        title: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SESSION_BANNER,
            values: {
                countdown: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9007db43a2391fe5$export$53819c0e58f98d49), {
                    value: nearExpiration
                })
            }
        })
    });
};


/**
 * The page sits on a white panel with rounded top corners, laid on the grey frame. The corners are two steps of the
 * theme's corner unit, as `borderRadius: 2` would give, but `sx` only scales `borderRadius` itself, not single corners.
 */ const $2f937a6adf26c73c$var$getPanelRadius = (theme)=>Number(theme.shape.borderRadius) * 2;
const $2f937a6adf26c73c$var$panelStyle = {
    height: '100%',
    width: 0,
    flexGrow: 1,
    backgroundColor: 'common.white',
    borderTopLeftRadius: $2f937a6adf26c73c$var$getPanelRadius,
    borderTopRightRadius: $2f937a6adf26c73c$var$getPanelRadius,
    overflow: 'hidden'
};
const $2f937a6adf26c73c$var$mainContentStyle = {
    p: 6,
    flexGrow: 1,
    minHeight: 0,
    overflowY: 'auto'
};
const $2f937a6adf26c73c$export$fff6fad3c74051f6 = ({ banner: banner, children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
        sx: $2f937a6adf26c73c$var$panelStyle,
        "data-testid": "page-panel",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e823e43882f6834e$export$9e418155083c0a3a), {}),
            banner,
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $2f937a6adf26c73c$var$mainContentStyle,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1c8aeb9e5f335475$export$2dc68d50d56fbbd), {}),
                    children
                ]
            })
        ]
    });







const $dbf979062de799bc$var$defaultTabsWrapper = ({ children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
        children: children
    });
const $dbf979062de799bc$export$7d4a22e995b7a67e = ({ title: title, tabs: tabs, orientation: orientation, tabsWrapper: TabsWrapper = $dbf979062de799bc$var$defaultTabsWrapper, ...props })=>{
    const router = (0, $42efdbd12003f6a9$export$ddab236f5c469f6f)();
    const hasCapabilities = (0, $ed3a79aec495d063$export$95fa16a10fc41701)();
    const formatter = (0, $00ca74462cc42d7b$export$bb747d72848d9c48)();
    const keys = (0, $2ae70427bab197d4$export$ed97f33186d4b816)(tabs);
    const currentTab = (0, $h4Bez.useMemo)(()=>keys.find((route)=>router.isAtRoute(route)) ?? keys[0], [
        router
    ]);
    const { documentationTitle: documentationTitle, documentationBody: documentationBody, titleActions: titleActions } = tabs[currentTab];
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        ...props,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $be3703687194c6e0$export$56e2352e63353d99), {
                title: [
                    title,
                    {
                        count: 0
                    }
                ],
                titleActions: titleActions,
                description: [
                    documentationTitle,
                    documentationBody
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(TabsWrapper, {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$b2539bed5023c21c), {
                    orientation: orientation,
                    onChange: (value)=>router.redirect(value),
                    value: currentTab,
                    children: keys.map((route)=>{
                        const disabled = !hasCapabilities(route);
                        return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                            title: formatter.formatTitle(route),
                            value: route,
                            disabled: disabled
                        }, route);
                    })
                })
            })
        ]
    });
};




const $f034751aa3113dc8$var$tabs = {
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_LINKS]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).RESOURCES_AND_SERVICE_LINK_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).RESOURCES_AND_SERVICE_LINK_DOCUMENTATION_BODY
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_SERVERS]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVERS_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVERS_DOCUMENTATION_BODY
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_NODES]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NODES_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NODES_DOCUMENTATION_BODY
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_CONTAINERS]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTAINERS_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTAINERS_DOCUMENTATION_BODY
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_VOLUMES]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VOLUMES_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VOLUMES_DOCUMENTATION_BODY
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_CONNECTIONS]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTIONS_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTIONS_DOCUMENTATION_BODY
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_ENDPOINTS]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENDPOINTS_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENDPOINTS_DOCUMENTATION_BODY
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_MAPPINGS]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MAPPINGS_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MAPPINGS_DOCUMENTATION_BODY
    }
};
const $f034751aa3113dc8$export$c567de8874d31a3a = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbf979062de799bc$export$7d4a22e995b7a67e), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_RESOURCES,
        tabs: $f034751aa3113dc8$var$tabs
    });






parcelRequire("h4Bez");



const $b4910e4fa91aa958$export$e5607a3e105d74ac = ({ connectionsSelector: connectionsSelector, onConfirmed: onConfirmed })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bulkConnectConnectionsUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$10f512a97cdb6733), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECT_CONNECTIONS,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECT_CONNECTIONS_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECT,
        resourceSelector: connectionsSelector,
        dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CONNECTION,
        onRenderLineContent: (0, $0f6e6d34a7cdc5dd$export$b6009d9c113d57d8),
        onCancel: ()=>usecase.selectConnections(null),
        onConfirm: async ()=>{
            await usecase.connect();
            onConfirmed?.();
        }
    });
};
const $b4910e4fa91aa958$export$1fd910e39ac2d463 = ({ connectionsSelector: connectionsSelector, onConfirmed: onConfirmed })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bulkDisconnectConnectionsUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$f6737f912c21f59d), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISCONNECT_CONNECTIONS,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISCONNECT_CONNECTIONS_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISCONNECT,
        resourceSelector: connectionsSelector,
        dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CONNECTION,
        onRenderLineContent: (0, $0f6e6d34a7cdc5dd$export$b6009d9c113d57d8),
        onCancel: ()=>usecase.selectConnections(null),
        onConfirm: async ()=>{
            await usecase.disconnect();
            onConfirmed?.();
        }
    });
};
const $b4910e4fa91aa958$export$73392e09138fecd6 = ({ connectionsSelector: connectionsSelector, onConfirmed: onConfirmed })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bulkDeleteConnectionsUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$54399887e057b4b7), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_CONNECTIONS,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_CONNECTIONS_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE,
        resourceSelector: connectionsSelector,
        dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CONNECTION,
        onRenderLineContent: (0, $0f6e6d34a7cdc5dd$export$b6009d9c113d57d8),
        onCancel: ()=>usecase.selectConnections(null),
        onConfirm: async ()=>{
            await usecase.delete();
            onConfirmed();
        }
    });
};


const $dc980d3784041744$var$Modals = ()=>{
    const clear = (0, $365b0b4d68ac9bb9$export$d2838f462516652)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b4910e4fa91aa958$export$73392e09138fecd6), {
                connectionsSelector: (0, $e35c6a737caa74d7$export$33dfe39cb992963d),
                onConfirmed: clear
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b4910e4fa91aa958$export$e5607a3e105d74ac), {
                connectionsSelector: (0, $e35c6a737caa74d7$export$82c7e7af560ff833),
                onConfirmed: clear
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b4910e4fa91aa958$export$1fd910e39ac2d463), {
                connectionsSelector: (0, $e35c6a737caa74d7$export$4c56d54b7a77723d),
                onConfirmed: clear
            })
        ]
    });
};
const $dc980d3784041744$var$selectCanManageConnections = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_MANAGE);
const $dc980d3784041744$export$54ec01a60f47d33d = ({ serviceId: serviceId = null })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const translateHost = (0, $2f1767bcd18ea30e$export$2ab4aeb11c6b98d1)();
    const translatePort = (0, $2f1767bcd18ea30e$export$6ec19188becec0fc)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8aa67788985a70f6$export$b3c28590d63f6eca), {
        subscriptionUsecase: "manageConnectionsUsecase",
        filter: serviceId ? {
            service: serviceId
        } : undefined,
        data: (0, $e35c6a737caa74d7$export$22bff46b5e0f21b8),
        hasManagementCapabilitiesSelector: $dc980d3784041744$var$selectCanManageConnections,
        dataTableMapper: (connections)=>connections.map((c)=>({
                    id: c.id,
                    service: c.service,
                    name: c.name,
                    protocol: c.protocol,
                    hostLabel: translateHost(c),
                    portLabel: translatePort(c),
                    agent: c.agent,
                    status: c.status
                })),
        columns: {
            ...serviceId ? {} : {
                service: {
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_ID,
                    sort: true
                }
            },
            name: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTION_ID,
                sort: true
            },
            protocol: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).PROTOCOL, {
                    count: 1
                }),
                sort: true
            },
            hostLabel: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).HOST, {
                    count: 1
                })
            },
            portLabel: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).PORT, {
                    count: 1
                })
            },
            agent: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).AGENT, {
                    count: 1
                }),
                sort: true
            },
            status: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS,
                customCellRender: (status)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
                        status: status
                    })
            }
        },
        short: Boolean(serviceId),
        redirectOnRowclick: (0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).CONNECTION,
        selection: {
            DELETE: {
                usecase: 'bulkDeleteConnectionsUsecase'
            },
            DISABLE: {
                usecase: 'bulkDisconnectConnectionsUsecase',
                filter: (0, $b3e7a2ab0fd4d9ed$export$ab4361d7a1cbdab3),
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISCONNECT
            },
            ENABLE: {
                usecase: 'bulkConnectConnectionsUsecase',
                filter: (0, $b3e7a2ab0fd4d9ed$export$70bb1060ba23a5e6),
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECT
            },
            resource: 'id',
            usecaseMethod: 'selectConnections'
        },
        translations: {
            emptyTable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_CONNECTIONS_AVAILABLE,
            paginationDataType: 'CONNECTION'
        },
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($dc980d3784041744$var$Modals, {})
    });
};



const $2f1767bcd18ea30e$export$2ab4aeb11c6b98d1 = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return (c)=>c.ipAddress || c.brokers && translator.formatList(c.brokers) || c.host;
};
const $2f1767bcd18ea30e$export$6ec19188becec0fc = ()=>{
    return (c)=>c.cncType || c.device || c.port;
};



parcelRequire("h4Bez");




parcelRequire("h4Bez");




parcelRequire("h4Bez");






parcelRequire("h4Bez");



const $c8a68df80a38eb1f$export$e5607a3e105d74ac = ({ endpointsSelector: endpointsSelector, onConfirmed: onConfirmed })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bulkEnableEndpointsUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$10f512a97cdb6733), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENABLE_ENDPOINTS,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENABLE_ENDPOINTS_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENABLE,
        resourceSelector: endpointsSelector,
        dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).ENDPOINT,
        onRenderLineContent: (0, $0f6e6d34a7cdc5dd$export$b6009d9c113d57d8),
        onCancel: ()=>usecase.selectEndpoints(null),
        onConfirm: async ()=>{
            await usecase.enable();
            onConfirmed?.();
        }
    });
};
const $c8a68df80a38eb1f$export$1fd910e39ac2d463 = ({ endpointsSelector: endpointsSelector, onConfirmed: onConfirmed })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bulkDisableEndpointsUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$f6737f912c21f59d), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE_ENDPOINTS,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE_ENDPOINTS_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE,
        resourceSelector: endpointsSelector,
        dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).ENDPOINT,
        onRenderLineContent: (0, $0f6e6d34a7cdc5dd$export$b6009d9c113d57d8),
        onCancel: ()=>usecase.selectEndpoints(null),
        onConfirm: async ()=>{
            await usecase.disable();
            onConfirmed?.();
        }
    });
};
const $c8a68df80a38eb1f$export$73392e09138fecd6 = ({ endpointsSelector: endpointsSelector, onConfirmed: onConfirmed })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bulkDeleteEndpointsUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$54399887e057b4b7), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_ENDPOINTS,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_ENDPOINTS_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE,
        resourceSelector: endpointsSelector,
        dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).ENDPOINT,
        onRenderLineContent: (0, $0f6e6d34a7cdc5dd$export$b6009d9c113d57d8),
        onCancel: ()=>usecase.selectEndpoints(null),
        onConfirm: async ()=>{
            await usecase.delete();
            onConfirmed();
        }
    });
};


const $b82f9b509446bc25$var$Modals = ()=>{
    const clear = (0, $365b0b4d68ac9bb9$export$d2838f462516652)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c8a68df80a38eb1f$export$73392e09138fecd6), {
                endpointsSelector: (0, $c18490461364b14c$export$70f64a3afebd30c4),
                onConfirmed: clear
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c8a68df80a38eb1f$export$e5607a3e105d74ac), {
                endpointsSelector: (0, $c18490461364b14c$export$622e2693b8599e36),
                onConfirmed: clear
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c8a68df80a38eb1f$export$1fd910e39ac2d463), {
                endpointsSelector: (0, $c18490461364b14c$export$b2220f653c519314),
                onConfirmed: clear
            })
        ]
    });
};
const $b82f9b509446bc25$var$selectCanManageEndpoints = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_MANAGE);
const $b82f9b509446bc25$export$54ec01a60f47d33d = (props)=>{
    const connection = 'connectionId' in props ? props.connectionId : null;
    const service = 'serviceId' in props ? props.serviceId : null;
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8aa67788985a70f6$export$b3c28590d63f6eca), {
        subscriptionUsecase: "manageEndpointsUsecase",
        filter: connection ? {
            connection: connection
        } : service ? {
            service: service
        } : undefined,
        data: (0, $c18490461364b14c$export$cda0de9810c33af4),
        hasManagementCapabilitiesSelector: $b82f9b509446bc25$var$selectCanManageEndpoints,
        dataTableMapper: (endpoints)=>endpoints,
        columns: {
            ...service ? {} : {
                service: {
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_ID,
                    sort: true
                }
            },
            name: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                sort: true
            },
            ...connection ? {} : {
                connection: {
                    label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTION_ID, {
                        count: 1
                    }),
                    sort: true
                }
            },
            protocol: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).PROTOCOL, {
                    count: 1
                }),
                sort: true
            },
            operation: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).OPERATION, {
                    count: 1
                })
            },
            agent: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).AGENT, {
                    count: 1
                }),
                sort: true
            },
            status: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS,
                customCellRender: (status)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
                        status: status
                    })
            }
        },
        short: Boolean(service || connection),
        redirectOnRowclick: (0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).ENDPOINT,
        selection: {
            DELETE: {
                usecase: 'bulkDeleteEndpointsUsecase'
            },
            DISABLE: {
                usecase: 'bulkDisableEndpointsUsecase',
                filter: (0, $20a95c68bb34987c$export$43384fe56d68ed4)
            },
            ENABLE: {
                usecase: 'bulkEnableEndpointsUsecase',
                filter: (0, $20a95c68bb34987c$export$f4e830cc86f40e52)
            },
            resource: 'id',
            usecaseMethod: 'selectEndpoints'
        },
        translations: {
            emptyTable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ENDPOINTS_AVAILABLE,
            paginationDataType: 'ENDPOINT'
        },
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b82f9b509446bc25$var$Modals, {})
    });
};



parcelRequire("h4Bez");




parcelRequire("h4Bez");





var $h4Bez = parcelRequire("h4Bez");








parcelRequire("h4Bez");



"use client";
var $ed2233f83dfcebaa$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12z"
}), 'Label');




/** Block-level with 2px above and below, so the 16px icon fills exactly one 20px table text line instead of stretching it */ const $d58236801af19b8d$var$baseStyle = {
    display: 'block',
    width: 16,
    height: 16,
    my: 0.5
};
const $d58236801af19b8d$var$colors = {
    [(0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).DEBUG]: {
        ...$d58236801af19b8d$var$baseStyle,
        color: 'green.800'
    },
    [(0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).INFO]: {
        ...$d58236801af19b8d$var$baseStyle,
        color: 'primary.main'
    },
    [(0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).WARN]: {
        ...$d58236801af19b8d$var$baseStyle,
        color: 'orange.400'
    },
    [(0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).ERROR]: {
        ...$d58236801af19b8d$var$baseStyle,
        color: 'red.600'
    },
    [(0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).FATAL]: {
        ...$d58236801af19b8d$var$baseStyle,
        color: 'red.900'
    },
    [(0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).TRACE]: {
        ...$d58236801af19b8d$var$baseStyle,
        color: 'grey.600'
    }
};
const $d58236801af19b8d$export$243e62d78d3b544d = ({ level: level })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $69cdbe69cde47e02$export$2e2bcd8739ae039), {
        title: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LOG_LEVEL,
            values: {
                level: level
            }
        }),
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ed2233f83dfcebaa$export$2e2bcd8739ae039), {
            sx: $d58236801af19b8d$var$colors[level]
        })
    });



parcelRequire("h4Bez");






var $h4Bez = parcelRequire("h4Bez");

var $fF3mG = parcelRequire("fF3mG");



const { Provider: $c1a643e1e0d6a4e6$var$LogsStateProvider, useExtendedState: $c1a643e1e0d6a4e6$var$useLogsState, useExtendedStateDispatcher: $c1a643e1e0d6a4e6$var$useLogsDispatcher } = (0, $08b3e6ee09ecfd12$export$e50ad042342a539d)();
const $c1a643e1e0d6a4e6$var$createLogStateDispatcherCreator = (stateMapper, updateLogsPromise = true)=>{
    /**
     * This dispatcher creator function has 3 nests in order to force whoever is calling them
     * to pass the dependencies (EG the mapper) in a way that every render wouldn't cause a further
     * re-render on its useCallback
     */ return ()=>{
        const logsUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('containerLogsUsecase');
        const dispatch = $c1a643e1e0d6a4e6$var$useLogsDispatcher();
        return (0, $h4Bez.useCallback)((...args)=>{
            dispatch((currentState)=>{
                /** First remap any of the parameters */ const stateUpdate = stateMapper ? stateMapper(currentState, ...args) : {};
                const newState = {
                    ...currentState,
                    ...stateUpdate
                };
                let logsPromise;
                if (updateLogsPromise) {
                    /** Fetch logs again */ const { source: source, resource: resource, lines: lines, startDate: startDate, endDate: endDate, levels: levels } = newState;
                    logsPromise = logsUsecase.fetchLogs(source, {
                        resource: resource,
                        lines: lines,
                        start: startDate ?? null,
                        end: endDate ?? null,
                        levels: (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(levels) ? levels : null
                    });
                } else /** Don't fetch logs and use previous ones */ logsPromise = newState.logsPromise;
                /** Finally, just dispatch the changes */ return {
                    ...stateUpdate,
                    logsPromise: logsPromise
                };
            });
        }, [
            logsUsecase,
            stateMapper,
            updateLogsPromise
        ]);
    };
};
const $c1a643e1e0d6a4e6$export$f2120123c8bf7749 = $c1a643e1e0d6a4e6$var$createLogStateDispatcherCreator(null);
const $c1a643e1e0d6a4e6$export$1d1ecedad270f76c = $c1a643e1e0d6a4e6$var$createLogStateDispatcherCreator(({ levels: levels }, level)=>({
        levels: Array.from((0, $bf45460f43a51d1f$export$54c12c14e9d064)(new Set(levels), level))
    }));
const $c1a643e1e0d6a4e6$export$23b505f2183adb23 = $c1a643e1e0d6a4e6$var$createLogStateDispatcherCreator((_, { start: start, end: end })=>({
        startDate: start,
        /** if start > end then the range is inconsistent, so treat it as open-ended instead of storing corrupted state */ endDate: (0, $091b76300838ede1$export$1c4ee043487b1d5e)(start, end) ? null : end
    }));
const $c1a643e1e0d6a4e6$export$7acedc75ad0c4257 = $c1a643e1e0d6a4e6$var$createLogStateDispatcherCreator((_, selectedLog)=>({
        selectedLog: selectedLog
    }), false);
const $c1a643e1e0d6a4e6$var$createLogsStateHook = (prop)=>(0, $beec4324cbd609ea$export$6b4e15ccdc547ae7)(()=>$c1a643e1e0d6a4e6$var$useLogsState((s)=>s[prop]), `useLogState${prop}`);
const $c1a643e1e0d6a4e6$export$b8843e5550bb5d09 = $c1a643e1e0d6a4e6$var$createLogsStateHook('selectedLog');
const $c1a643e1e0d6a4e6$export$9f6abfd74295843b = $c1a643e1e0d6a4e6$var$createLogsStateHook('resource');
const $c1a643e1e0d6a4e6$export$fe488720f15adbf8 = $c1a643e1e0d6a4e6$var$createLogsStateHook('source');
const $c1a643e1e0d6a4e6$export$195a0d4df9850968 = $c1a643e1e0d6a4e6$var$createLogsStateHook('levels');
const $c1a643e1e0d6a4e6$export$2ae58ed47b46ea70 = $c1a643e1e0d6a4e6$var$createLogsStateHook('startDate');
const $c1a643e1e0d6a4e6$export$9b13d4522545f9e9 = $c1a643e1e0d6a4e6$var$createLogsStateHook('endDate');
const $c1a643e1e0d6a4e6$var$useLogsPromise = $c1a643e1e0d6a4e6$var$createLogsStateHook('logsPromise');
const $c1a643e1e0d6a4e6$export$a2531b53b2cc64c8 = ()=>{
    const promise = $c1a643e1e0d6a4e6$var$useLogsPromise();
    const sync = (0, $fF3mG.usePromise)(promise);
    return (0, $fF3mG.isPending)(sync) ? null : sync.value;
};
const $c1a643e1e0d6a4e6$var$initialState = {
    levels: [],
    logsPromise: null,
    selectedLog: null
};
const $c1a643e1e0d6a4e6$var$Loader = ()=>{
    const promise = $c1a643e1e0d6a4e6$var$useLogsPromise();
    const loadLogs = $c1a643e1e0d6a4e6$export$f2120123c8bf7749();
    const hasNotLoaded = promise === null;
    (0, $h4Bez.useEffect)(()=>{
        if (hasNotLoaded) loadLogs();
    }, [
        loadLogs,
        hasNotLoaded
    ]);
    return null;
};
const $c1a643e1e0d6a4e6$export$abec374e0d471401 = ({ lines: lines = 'limited', startDate: startDate = null, endDate: endDate = null, resource: resource, source: source, reloadOn: reloadOn, children: children })=>{
    /** A new value resets the store, and so reloads the logs, so it only changes with the props, not with every render */ const value = (0, $h4Bez.useMemo)(()=>({
            ...$c1a643e1e0d6a4e6$var$initialState,
            startDate: startDate,
            endDate: endDate,
            source: source,
            lines: lines,
            resource: resource
        }), [
        startDate,
        endDate,
        source,
        lines,
        resource,
        reloadOn
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($c1a643e1e0d6a4e6$var$LogsStateProvider, {
        value: value,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($c1a643e1e0d6a4e6$var$Loader, {}),
            children
        ]
    });
};


const $ea74636223886a2a$var$itemStyle = {
    p: 2,
    wordBreak: 'break-all'
};
const $ea74636223886a2a$var$Item = ({ primary: primary, secondary: secondary })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                container: true,
                sx: $ea74636223886a2a$var$itemStyle,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        size: {
                            xs: 2
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                            variant: "body2",
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: primary
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        size: {
                            xs: 10
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                            variant: "body2",
                            children: secondary
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {})
        ]
    });
const $ea74636223886a2a$export$2b77a92f1a5ad772 = ()=>{
    const selectLog = (0, $c1a643e1e0d6a4e6$export$7acedc75ad0c4257)();
    const log = (0, $c1a643e1e0d6a4e6$export$b8843e5550bb5d09)();
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    if (log === null) return null;
    const close = ()=>selectLog(null);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $55a2a796d4e0875c$export$2e2bcd8739ae039), {
        "data-testid": "log-details-modal",
        maxWidth: "lg",
        fullWidth: true,
        open: true,
        "aria-labelledby": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).LOG_DETAILS),
        onClose: close,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dfd39f6bb0de9c2f$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                children: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).LOG_DETAILS)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0aa27c46708d7ed8$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($ea74636223886a2a$var$Item, {
                            primary: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TIME,
                            secondary: log.timestamp.getTime()
                        }),
                        log.pid && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($ea74636223886a2a$var$Item, {
                            primary: (0, $40a99dac858c1d75$export$b63289fbda65eed1).PID,
                            secondary: log.pid
                        }),
                        log.hostname && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($ea74636223886a2a$var$Item, {
                            primary: (0, $40a99dac858c1d75$export$b63289fbda65eed1).HOSTNAME,
                            secondary: log.hostname
                        }),
                        log.className && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($ea74636223886a2a$var$Item, {
                            primary: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CLASS_NAME,
                            secondary: log.className
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($ea74636223886a2a$var$Item, {
                            primary: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MESSAGE,
                            secondary: log.message
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $12b0eeebf4fed103$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                    variant: "secondary",
                    onClick: close,
                    children: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).CLOSE)
                })
            })
        ]
    });
};



const $ac7334fad98808f5$var$DowloadRawLogsButton = ()=>{
    const containerLogs = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('containerLogsUsecase');
    const resource = (0, $c1a643e1e0d6a4e6$export$9f6abfd74295843b)();
    const source = (0, $c1a643e1e0d6a4e6$export$fe488720f15adbf8)();
    const [downloadRawlogs] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(()=>containerLogs.downloadRawlogs(source, resource), [
        containerLogs,
        source,
        resource
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
        variant: "secondary",
        size: "medium",
        startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6c4ecf59edd403be$export$4e54df4252b4a99c), {}),
        onClick: downloadRawlogs,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DOWNLOAD_RAW_LOGS
        })
    });
};
const $ac7334fad98808f5$var$RefreshLogsButton = ()=>{
    const loadLogs = (0, $c1a643e1e0d6a4e6$export$f2120123c8bf7749)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
        variant: "secondary",
        size: "medium",
        startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d5ccdb53d4f7a1b0$export$2e2bcd8739ae039), {}),
        onClick: loadLogs,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).REFRESH_LOGS
        })
    });
};
const $ac7334fad98808f5$var$logItemStyle = {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    gap: 2
};
const $ac7334fad98808f5$var$LogTypesFilter = ()=>{
    const levelFilters = (0, $c1a643e1e0d6a4e6$export$195a0d4df9850968)();
    const toggle = (0, $c1a643e1e0d6a4e6$export$1d1ecedad270f76c)();
    const filterOptions = Object.values((0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d)).map((level)=>({
            value: level,
            label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LOG_LEVEL,
                values: {
                    level: level
                }
            })
        }));
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $ac7334fad98808f5$var$logItemStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d85f7a63a75c527f$export$931cbfb6bfb85fc), {
                buttonLabel: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).FILTER
                }),
                options: filterOptions,
                size: "medium",
                "data-testid": "filter",
                value: levelFilters,
                onChange: toggle
            }),
            levelFilters.map((level)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e2c1c86842962ae2$export$5a7f9a6004988d01), {
                    "data-testid": `log-level-chip-${level}`,
                    label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LOG_LEVEL,
                        values: {
                            level: level
                        }
                    }),
                    onDelete: ()=>toggle(level),
                    variant: "neutral"
                }, level))
        ]
    });
};
const $ac7334fad98808f5$export$1bf7e0927a470222 = ()=>{
    const startDate = (0, $c1a643e1e0d6a4e6$export$2ae58ed47b46ea70)();
    const endDate = (0, $c1a643e1e0d6a4e6$export$9b13d4522545f9e9)();
    const setDateRange = (0, $c1a643e1e0d6a4e6$export$23b505f2183adb23)();
    const handleApply = (0, $h4Bez.useCallback)(({ start: start, end: end })=>{
        setDateRange({
            start: start,
            end: end
        });
    }, [
        setDateRange
    ]);
    /**
     * The current local day is the latest selectable date; future days are disabled since logs
     * are not available for them yet. Memoized on the current day (not on every render) so a page
     * left open across midnight still picks up the new day.
     */ const today = new Date().toDateString();
    const disableAfter = (0, $h4Bez.useMemo)(()=>{
        const date = new Date();
        date.setHours(0, 0, 0, 0);
        return date;
    }, [
        today
    ]);
    const value = (0, $h4Bez.useMemo)(()=>({
            start: startDate ?? null,
            end: endDate ?? null
        }), [
        startDate,
        endDate
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $45305f2cebf25d3d$export$19bfc49083d6bd5d), {
        value: value,
        onApply: handleApply,
        disableAfter: disableAfter
    });
};
const $ac7334fad98808f5$var$InternalTable = ({ showDownloadRawLogs: showDownloadRawLogs = false, showServiceId: showServiceId = false, ...props })=>{
    const containerLogs = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('containerLogsUsecase');
    const translation = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const selectLog = (0, $c1a643e1e0d6a4e6$export$7acedc75ad0c4257)();
    const logs = (0, $c1a643e1e0d6a4e6$export$a2531b53b2cc64c8)();
    const loadLogs = (0, $c1a643e1e0d6a4e6$export$f2120123c8bf7749)();
    const loaded = logs === null || (0, $c3e1b746ad236797$export$8d524fb6540252df).is(logs) ? null : logs;
    const data = loaded ?? [];
    const csvFileName = 'downloadSuffix' in props ? props.downloadSuffix : props.id;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        loading: logs === null,
        error: (0, $c3e1b746ad236797$export$8d524fb6540252df).is(logs) ? {
            error: logs,
            onRetry: loadLogs
        } : undefined,
        data: data.map((l)=>({
                ...l,
                date: l.timestamp
            })),
        columns: {
            level: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LEVEL,
                customCellRender: (level)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d58236801af19b8d$export$243e62d78d3b544d), {
                        level: level
                    }),
                sort: true
            },
            timestamp: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TIME,
                customCellRender: (date)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$d275c5eeba29af75), {
                        date: date,
                        format: "datetime"
                    }),
                sort: (t)=>t.getTime(),
                type: 'datetime'
            },
            ...showServiceId ? {
                serviceId: {
                    label: translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE, {
                        count: 1
                    }),
                    sort: true
                }
            } : {},
            message: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MESSAGE,
                sort: true
            }
        },
        pagination: {
            pageSizeOptions: [
                50
            ]
        },
        sortOrder: {
            name: 'timestamp',
            direction: 'desc'
        },
        filters: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($ac7334fad98808f5$var$LogTypesFilter, {}),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($ac7334fad98808f5$export$1bf7e0927a470222, {})
            ]
        }),
        utilities: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
            children: [
                showDownloadRawLogs && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($ac7334fad98808f5$var$DowloadRawLogsButton, {}),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($ac7334fad98808f5$var$RefreshLogsButton, {})
            ]
        }),
        onRowClick: selectLog,
        search: true,
        translations: {
            noResultsOrEmptyTable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_LOGS_FOUND
        },
        onDownloadCSV: loaded ? ()=>containerLogs.downloadCSV(loaded, csvFileName, showServiceId) : undefined,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ea74636223886a2a$export$2b77a92f1a5ad772), {})
    });
};
const $ac7334fad98808f5$export$54ec01a60f47d33d = ({ type: type, lines: lines, reloadOn: reloadOn, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c1a643e1e0d6a4e6$export$abec374e0d471401), {
        resource: 'id' in props ? props.id : null,
        source: type,
        lines: lines,
        reloadOn: reloadOn,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($ac7334fad98808f5$var$InternalTable, {
            ...props
        })
    });



parcelRequire("h4Bez");


var $h4Bez = parcelRequire("h4Bez");

var $fF3mG = parcelRequire("fF3mG");

const $b75b3c9750a4f99c$export$fef2e766873b1675 = (type, id)=>{
    const containerLogsUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('containerLogsUsecase');
    const logs = (0, $fF3mG.usePromise)((0, $h4Bez.useMemo)(()=>containerLogsUsecase.areLogsAvailable(type, id), [
        containerLogsUsecase,
        id,
        type
    ]));
    return (0, $fF3mG.isPending)(logs) ? null : logs.value;
};


const $b6b5ebbc4a51bb7b$export$fc34525e6b0d872d = ({ type: type, id: id, children: children })=>{
    const available = (0, $b75b3c9750a4f99c$export$fef2e766873b1675)(type, id);
    return available === null ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $35e2f7ba0c5bb8e5$export$8b8493c40023057), {}) : children(available);
};





const $51ba132a84c6c9cc$var$rulesStyle = {
    my: 2,
    mx: 1
};
const $51ba132a84c6c9cc$export$7c6e2c02157bb7d2 = ({ resource: resource })=>{
    const { id: id, address: address, rules: rules } = resource;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b6b5ebbc4a51bb7b$export$fc34525e6b0d872d), {
        type: (0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).ENDPOINT,
        id: id,
        children: (available)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2bf638d791e22cc5$export$b2539bed5023c21c), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENDPOINT_LOGS,
                        disabled: !available,
                        requiredCapabilities: [
                            (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ
                        ],
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ac7334fad98808f5$export$54ec01a60f47d33d), {
                            id: id,
                            type: (0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).ENDPOINT,
                            reloadOn: resource
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ADDRESS,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
                            data: (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(address).map(([name, value])=>({
                                    name: name,
                                    value: value instanceof Object ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $39543ef1c93c1508$export$a49368ab94976679), {
                                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $47ae8c6618e10a1b$export$48880ac635f47186), {
                                            src: value
                                        })
                                    }) : String(value)
                                })),
                            columns: {
                                name: {
                                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                                    sort: true
                                },
                                value: {
                                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VALUE
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).RULE,
                        disabled: rules === null,
                        children: rules && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $39543ef1c93c1508$export$a49368ab94976679), {
                            sx: $51ba132a84c6c9cc$var$rulesStyle,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $47ae8c6618e10a1b$export$48880ac635f47186), {
                                src: rules
                            })
                        })
                    })
                ]
            })
    });
};



parcelRequire("h4Bez");




var $h4Bez = parcelRequire("h4Bez");






const $6e0a77bb05c5018d$export$e9b7b60369596b67 = (disabled = false, capabilities)=>(0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>{
        if (!capabilities || disabled) /** It is disabled or has no capabilities, no need to check */ return !disabled;
        /** Check with permissions */ return (0, $1c05f13022cf1480$export$718d52259ef5bb58)(...capabilities)(s);
    }, // Warning: This dep list relies on the capabilities not changing order
    [
        capabilities && capabilities.join('_'),
        disabled
    ]);


const $71845f7cb75dafe2$var$suffixStyle = {
    ml: 1,
    my: 'auto'
};
const $71845f7cb75dafe2$var$buttonStyle = {
    mr: 2
};
const $71845f7cb75dafe2$export$cfc7921d29ef7b80 = ({ text: text, loading: loading = false, disabled: disabled, capabilities: capabilities, variant: variant = 'secondary', startIcon: startIcon, showText: showText, ...props })=>{
    const enabled = (0, $6e0a77bb05c5018d$export$e9b7b60369596b67)(disabled, capabilities);
    const Caption = (0, $40a99dac858c1d75$export$552cd99e43fa1085)(text) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
        id: text
    }) : text;
    const Icon = loading ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $95388f9578043f1e$export$2e2bcd8739ae039), {
        sx: $71845f7cb75dafe2$var$suffixStyle,
        size: "1rem",
        color: "inherit"
    }) : startIcon;
    if (showText) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
        ...props,
        variant: variant,
        size: "large",
        sx: $71845f7cb75dafe2$var$buttonStyle,
        disabled: !enabled,
        startIcon: Icon,
        children: Caption
    });
    const IconButton = /*#__PURE__*/ (0, $h4Bez.forwardRef)((buttonProps, ref)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
            ...buttonProps,
            ...props,
            ref: ref,
            variant: variant,
            size: "large",
            sx: $71845f7cb75dafe2$var$buttonStyle,
            disabled: !enabled,
            children: Icon
        }));
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $69cdbe69cde47e02$export$2e2bcd8739ae039), {
        placement: "bottom",
        title: Caption,
        children: enabled ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(IconButton, {}) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(IconButton, {})
        })
    });
};



parcelRequire("h4Bez");



const $99f11348ec734ff0$var$rootStyle = {
    display: 'flex',
    alignItems: 'center',
    typography: 'body2',
    mb: 1,
    wordBreak: 'break-all',
    '&:last-of-type': {
        marginBottom: 0
    }
};
const $99f11348ec734ff0$var$titleStyle = {
    minWidth: 120,
    mr: 2,
    fontSize: 'body2.fontSize'
};
const $99f11348ec734ff0$export$3bb977b3ba9d3b59 = ({ title: title, sx: sx = {}, children: children, type: type })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: {
            ...$99f11348ec734ff0$var$rootStyle,
            ...sx
        },
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                sx: $99f11348ec734ff0$var$titleStyle,
                children: (0, $40a99dac858c1d75$export$552cd99e43fa1085)(title) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: title
                }) : title
            }),
            type ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "body2",
                children: children
            }) : children
        ]
    });





const $71d4e03cc7ec3ac0$var$disableButtonLabels = {
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLED]: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE,
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLING]: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENABLING
};
const $71d4e03cc7ec3ac0$export$223875819fd7cf93 = ({ resource: { id: id, status: status } })=>{
    const { bulkDeleteEndpointsUsecase: bulkDeleteEndpointsUsecase, bulkEnableEndpointsUsecase: bulkEnableEndpointsUsecase, bulkDisableEndpointsUsecase: bulkDisableEndpointsUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                "data-testid": "endpoint-action-button",
                disabled: status !== (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLED && status !== (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISABLED,
                text: $71d4e03cc7ec3ac0$var$disableButtonLabels[status] || (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENABLE,
                capabilities: [
                    (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_MANAGE
                ],
                onClick: status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLED ? ()=>bulkDisableEndpointsUsecase.selectEndpoints([
                        id
                    ]) : ()=>bulkEnableEndpointsUsecase.selectEndpoints([
                        id
                    ]),
                startIcon: status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLED ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b9d7f820c3e6958b$export$9b47433640e5db3a), {}) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $3294d981d8a1956f$export$aed5667c83867b85), {}),
                showText: true
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                "data-testid": "delete-endpoint-button",
                text: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE,
                capabilities: [
                    (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_MANAGE
                ],
                onClick: ()=>bulkDeleteEndpointsUsecase.selectEndpoints([
                        id
                    ]),
                startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d917252aed0e3bef$export$1ae95d1a7411cb7b), {}),
                variant: "dangerOutline"
            })
        ]
    });
};




parcelRequire("h4Bez");






parcelRequire("h4Bez");



parcelRequire("h4Bez");


"use client";
var $7323656293fbee06$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 14.5v-9l6 4.5z"
}), 'PlayCircleFilled');







parcelRequire("h4Bez");



const $a355bb70b0ba7fda$export$5d9f3c571397c16e = ({ dimension: dimension, usecase: usecase, containersSelector: containersSelector, onConfirmed: onConfirmed })=>{
    const { [usecase]: startUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$10f512a97cdb6733), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).START_CONTAINERS,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).START_CONTAINERS_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).START,
        resourceSelector: containersSelector,
        dimension: dimension,
        onRenderLineContent: (0, $0f6e6d34a7cdc5dd$export$b6009d9c113d57d8),
        onCancel: ()=>startUsecase.selectContainers(null),
        onConfirm: async ()=>{
            await startUsecase.start();
            onConfirmed?.();
        }
    });
};
const $a355bb70b0ba7fda$export$ffd3ea9cd076cdb7 = ({ dimension: dimension, usecase: usecase, containersSelector: containersSelector, onConfirmed: onConfirmed })=>{
    const { [usecase]: restartUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$974e9706e327ba45), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).RESTART_CONTAINERS,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).RESTART_CONTAINERS_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).RESTART,
        resourceSelector: containersSelector,
        dimension: dimension,
        onRenderLineContent: (0, $0f6e6d34a7cdc5dd$export$b6009d9c113d57d8),
        onCancel: ()=>restartUsecase.selectContainers(null),
        onConfirm: async ()=>{
            await restartUsecase.restart();
            onConfirmed?.();
        }
    });
};
const $a355bb70b0ba7fda$export$eef432f28cb72346 = ({ dimension: dimension, usecase: usecase, containersSelector: containersSelector, onConfirmed: onConfirmed })=>{
    const { [usecase]: stopUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$f6737f912c21f59d), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STOP_CONTAINERS,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STOP_CONTAINERS_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STOP,
        resourceSelector: containersSelector,
        dimension: dimension,
        onRenderLineContent: (0, $0f6e6d34a7cdc5dd$export$b6009d9c113d57d8),
        onCancel: ()=>stopUsecase.selectContainers(null),
        onConfirm: async ()=>{
            await stopUsecase.stop();
            onConfirmed?.();
        }
    });
};
const $a355bb70b0ba7fda$export$73392e09138fecd6 = ({ dimension: dimension, usecase: usecase, containersSelector: containersSelector, onConfirmed: onConfirmed })=>{
    const { [usecase]: deleteUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$54399887e057b4b7), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_CONTAINERS,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_CONTAINERS_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE,
        resourceSelector: containersSelector,
        dimension: dimension,
        onRenderLineContent: (0, $0f6e6d34a7cdc5dd$export$b6009d9c113d57d8),
        onCancel: ()=>deleteUsecase.selectContainers(null),
        onConfirm: async ()=>{
            await deleteUsecase.delete();
            onConfirmed();
        }
    });
};



parcelRequire("h4Bez");



const $b68825f1f040d8c8$var$createRenderer = (Renderer)=>(timestamp)=>timestamp ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Renderer, {
            timestamp: timestamp
        }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NOT_AVAILABLE
        });
const $b68825f1f040d8c8$var$lastUpdateRenderer = $b68825f1f040d8c8$var$createRenderer(({ timestamp: timestamp })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$d275c5eeba29af75), {
        date: timestamp,
        format: "datetime"
    }));
const $b68825f1f040d8c8$var$createdRenderer = $b68825f1f040d8c8$var$createRenderer(({ timestamp: timestamp })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$1b17df352e43d1d3), {
        value: timestamp
    }));
const $b68825f1f040d8c8$export$2bb4647626d77979 = ()=>{
    const customCellRender = (status)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
            status: status
        });
    return {
        name: {
            label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
            sort: true
        },
        lastUpdate: {
            label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LAST_UPDATED,
            customCellRender: $b68825f1f040d8c8$var$lastUpdateRenderer,
            sort: true,
            type: 'datetime'
        },
        created: {
            label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CREATED_AT,
            customCellRender: $b68825f1f040d8c8$var$createdRenderer,
            sort: true,
            type: 'datetime'
        },
        status: {
            label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS,
            customCellRender: customCellRender,
            sort: true
        }
    };
};


const $10bd0f4559270f58$var$Modals = ()=>{
    const clear = (0, $365b0b4d68ac9bb9$export$d2838f462516652)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a355bb70b0ba7fda$export$eef432f28cb72346), {
                dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE_CONTAINER,
                usecase: "bulkStopServiceContainersUsecase",
                containersSelector: (0, $b474aaee01cbac2d$export$7ca4451abe73539c),
                onConfirmed: clear
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a355bb70b0ba7fda$export$5d9f3c571397c16e), {
                dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE_CONTAINER,
                usecase: "bulkStartServiceContainersUsecase",
                containersSelector: (0, $b474aaee01cbac2d$export$380069ca056ef14d),
                onConfirmed: clear
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a355bb70b0ba7fda$export$ffd3ea9cd076cdb7), {
                dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE_CONTAINER,
                usecase: "bulkRestartServiceContainersUsecase",
                containersSelector: (0, $b474aaee01cbac2d$export$c615125b5c5f3a39),
                onConfirmed: clear
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a355bb70b0ba7fda$export$73392e09138fecd6), {
                dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE_CONTAINER,
                usecase: "bulkDeleteServiceContainersUsecase",
                containersSelector: (0, $b474aaee01cbac2d$export$9c5d17d4eb33bc70),
                onConfirmed: clear
            })
        ]
    });
};
const $10bd0f4559270f58$var$selectCanManageServiceContainers = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_MANAGE);
const $10bd0f4559270f58$export$54ec01a60f47d33d = ({ serviceId: serviceId = null })=>{
    const { name: name, lastUpdate: lastUpdate, created: created, status: status } = (0, $b68825f1f040d8c8$export$2bb4647626d77979)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8aa67788985a70f6$export$b3c28590d63f6eca), {
        subscriptionUsecase: "manageServiceContainersUsecase",
        filter: serviceId ? {
            service: serviceId
        } : undefined,
        data: (0, $b474aaee01cbac2d$export$b585067996a6a19f),
        hasManagementCapabilitiesSelector: $10bd0f4559270f58$var$selectCanManageServiceContainers,
        dataTableMapper: (containers)=>containers,
        columns: {
            ...serviceId ? {} : {
                service: {
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_ID,
                    sort: true
                }
            },
            name: name,
            lastUpdate: lastUpdate,
            created: created,
            volumesCount: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NUMBER_OF_VOLUMES,
                sort: true,
                type: 'number'
            },
            status: status
        },
        short: Boolean(serviceId),
        translations: {
            emptyTable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_CONTAINERS_AVAILABLE,
            paginationDataType: 'CONTAINER'
        },
        redirectOnRowclick: (0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).CONTAINER,
        selection: {
            DELETE: {
                usecase: 'bulkDeleteServiceContainersUsecase',
                filter: (0, $dc261e1a4f8deea7$export$bebb768243e568eb)
            },
            DISABLE: {
                usecase: 'bulkStopServiceContainersUsecase',
                filter: (0, $dc261e1a4f8deea7$export$9dde073542957add),
                icon: (0, $17a5ddc134ac4f1f$export$2e2bcd8739ae039),
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STOP
            },
            ENABLE: {
                usecase: 'bulkStartServiceContainersUsecase',
                filter: (0, $dc261e1a4f8deea7$export$e49c64d84076eb0e),
                icon: (0, $7323656293fbee06$export$2e2bcd8739ae039),
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).START
            },
            RESTART: {
                usecase: 'bulkRestartServiceContainersUsecase',
                filter: (0, $dc261e1a4f8deea7$export$7f65084de65d53e5)
            },
            resource: 'id',
            usecaseMethod: 'selectContainers'
        },
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($10bd0f4559270f58$var$Modals, {})
    });
};



parcelRequire("h4Bez");




parcelRequire("h4Bez");






const $5eebd14190b74197$var$renderConfigValue = (value)=>{
    if (typeof value === 'boolean') return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BOOLEAN,
        values: {
            value: value
        }
    });
    if ((0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(value)) return value.length > 0 ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbba8fd6e98bab28$export$f52b44e459e6e71d), {
        value: value
    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$3eec49f24c546686), {});
    return value === null || value === '' ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$3eec49f24c546686), {}) : value;
};
const $5eebd14190b74197$export$7c6e2c02157bb7d2 = ({ logType: logType, resource: resource })=>{
    const { id: id, variables: variables, config: config } = resource;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b6b5ebbc4a51bb7b$export$fc34525e6b0d872d), {
        type: logType,
        id: id,
        children: (available)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2bf638d791e22cc5$export$b2539bed5023c21c), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTAINER_LOGS,
                        disabled: !available,
                        requiredCapabilities: [
                            (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ
                        ],
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ac7334fad98808f5$export$54ec01a60f47d33d), {
                            id: id,
                            type: logType,
                            showDownloadRawLogs: true,
                            reloadOn: resource
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONFIGURATION,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
                            data: (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(config).map(([name, value])=>({
                                    name: name,
                                    value: value
                                })),
                            columns: {
                                name: {
                                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                                    sort: true
                                },
                                value: {
                                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VALUE,
                                    customCellRender: $5eebd14190b74197$var$renderConfigValue
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENVIRONMENT_VARIABLE,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
                            data: (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(variables).map(([name, value])=>({
                                    name: name,
                                    value: value
                                })),
                            columns: {
                                name: {
                                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                                    sort: true
                                },
                                value: {
                                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VALUE
                                }
                            }
                        })
                    })
                ]
            })
    });
};




parcelRequire("h4Bez");






parcelRequire("h4Bez");






parcelRequire("h4Bez");



const $73b03509aefe523d$export$73392e09138fecd6 = ({ volumeSelector: volumeSelector, onConfirmed: onConfirmed })=>{
    const { bulkDeleteVolumesUsecase: bulkDeleteVolumesUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$54399887e057b4b7), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_VOLUMES,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_VOLUMES_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE,
        resourceSelector: volumeSelector,
        dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).VOLUME,
        onRenderLineContent: "id",
        onCancel: ()=>bulkDeleteVolumesUsecase.selectVolumes(null),
        onConfirm: async ()=>{
            await bulkDeleteVolumesUsecase.delete();
            onConfirmed();
        }
    });
};


const $4b9327e4a1d2954f$var$Modals = ()=>{
    const clear = (0, $365b0b4d68ac9bb9$export$d2838f462516652)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $73b03509aefe523d$export$73392e09138fecd6), {
        volumeSelector: (0, $00bfc083c82fb6bc$export$228022853b9a73d5),
        onConfirmed: clear
    });
};
const $4b9327e4a1d2954f$var$selectCanManageVolumes = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).VOLUMES_MANAGE);
const $4b9327e4a1d2954f$export$54ec01a60f47d33d = ({ serviceId: serviceId = null })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const customCellRender = (status)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
            status: status
        });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8aa67788985a70f6$export$b3c28590d63f6eca), {
        subscriptionUsecase: "manageVolumesUsecase",
        filter: serviceId ? {
            service: serviceId
        } : undefined,
        data: (0, $00bfc083c82fb6bc$export$83b9822c5d2e39f1),
        hasManagementCapabilitiesSelector: $4b9327e4a1d2954f$var$selectCanManageVolumes,
        dataTableMapper: (volumes)=>volumes,
        columns: {
            ...serviceId ? {} : {
                service: {
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_ID,
                    sort: true
                }
            },
            name: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                sort: true
            },
            created: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CREATED_AT,
                customCellRender: (date)=>translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).DATETIME, {
                        type: 'datetime',
                        date: date
                    }),
                sort: true,
                type: 'datetime'
            },
            status: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS,
                customCellRender: customCellRender,
                sort: true
            }
        },
        short: Boolean(serviceId),
        redirectOnRowclick: (0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).VOLUME,
        selection: {
            DELETE: {
                usecase: 'bulkDeleteVolumesUsecase'
            },
            resource: 'id',
            usecaseMethod: 'selectVolumes'
        },
        translations: {
            emptyTable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_VOLUMES_AVAILABLE,
            paginationDataType: 'VOLUME'
        },
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($4b9327e4a1d2954f$var$Modals, {})
    });
};



parcelRequire("h4Bez");




parcelRequire("h4Bez");





const $d6deb849e8e26b2a$export$7c6e2c02157bb7d2 = ({ resource: resource })=>{
    const { id: id, labels: labels } = resource;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b6b5ebbc4a51bb7b$export$fc34525e6b0d872d), {
        type: (0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).VOLUME,
        id: id,
        children: (available)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2bf638d791e22cc5$export$b2539bed5023c21c), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VOLUME_LOGS,
                        disabled: !available,
                        requiredCapabilities: [
                            (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ
                        ],
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ac7334fad98808f5$export$54ec01a60f47d33d), {
                            id: id,
                            type: (0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).VOLUME,
                            reloadOn: resource
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LABEL,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
                            data: (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(labels).map(([name, value])=>({
                                    name: name,
                                    value: value
                                })),
                            columns: {
                                name: {
                                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                                    sort: true
                                },
                                value: {
                                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VALUE
                                }
                            }
                        })
                    })
                ]
            })
    });
};



parcelRequire("h4Bez");




const $1aa3ffee43ecc27a$export$223875819fd7cf93 = ({ resource: { id: id } })=>{
    const bulkDeleteVolumesUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bulkDeleteVolumesUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
        "data-testid": "delete-volume-button",
        text: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE,
        capabilities: [
            (0, $78670ebe9381a713$export$790a66df9dc00390).VOLUMES_MANAGE
        ],
        onClick: ()=>bulkDeleteVolumesUsecase.selectVolumes([
                id
            ]),
        startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d917252aed0e3bef$export$1ae95d1a7411cb7b), {}),
        variant: "dangerOutline"
    });
};




parcelRequire("h4Bez");





const $48725d09cc4800b1$export$de1f3500221e9400 = ({ resource: { service: service, name: name, created: created, status: status } })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: true,
        alignItems: "center",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
            "data-testid": "volume-header-description",
            size: {
                xs: 7
            },
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                    type: "text",
                    children: name
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c96e1cfe23f7395a$export$13d1eb20012e1339), {
                    service: service
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CREATED_AT,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$d275c5eeba29af75), {
                        date: created,
                        format: "datetime"
                    })
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
                        status: status
                    })
                })
            ]
        })
    });


const $c6ea7bd2008464e0$var$Modals = ({ leave: leave })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $73b03509aefe523d$export$73392e09138fecd6), {
        volumeSelector: (0, $00bfc083c82fb6bc$export$9b6405391d17baaa),
        onConfirmed: leave
    });
const $c6ea7bd2008464e0$export$3e8048d3cf2ba3fd = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $264fddb75d092ad2$export$2e9120d34faa9c1f), {
        subscriptionUsecase: "manageVolumeUsecase",
        resourceSelector: (0, $00bfc083c82fb6bc$export$7889cfb86da68b4e),
        notFoundTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VOLUME_NOT_FOUND,
        modals: $c6ea7bd2008464e0$var$Modals,
        content: (0, $d6deb849e8e26b2a$export$7c6e2c02157bb7d2),
        headerResourceName: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VOLUME,
        headerName: "name",
        headerActions: (0, $1aa3ffee43ecc27a$export$223875819fd7cf93),
        infoTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VOLUME_DETAILS_DOCUMENTATION_TITLE,
        infoBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VOLUME_DETAILS_DOCUMENTATION_BODY,
        headerDetails: (0, $48725d09cc4800b1$export$de1f3500221e9400)
    });





parcelRequire("h4Bez");






const $35e01e15588e13d6$var$linkStyle = {
    '& > a': {
        color: 'primary.700',
        textDecoration: 'unset'
    }
};
const $35e01e15588e13d6$export$c8c505ba351266f8 = ({ volumes: volumes, linkVolumes: linkVolumes })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    if (!(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(volumes)) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
        title: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).VOLUME, {
            count: volumes.length
        }),
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
            sx: $35e01e15588e13d6$var$linkStyle,
            "data-testid": "volume-links",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbba8fd6e98bab28$export$f52b44e459e6e71d), {
                type: "conjunction",
                style: "long",
                value: linkVolumes ? volumes.map((volume, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7d5f64758ce3b1db$export$bf4bb1ff1ff62959), {
                        path: (0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).VOLUME,
                        id: volume,
                        children: volume
                    }, k)) : volumes
            })
        })
    });
};




const $795aa440e4459e4e$export$de1f3500221e9400 = ({ resource: { name: name, created: created, status: status, volumes: volumes }, resource: resource, linkVolumes: linkVolumes })=>{
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: true,
        alignItems: "center",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
            "data-testid": "container-header-description",
            size: {
                xs: 7
            },
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                    type: "text",
                    children: name
                }),
                'service' in resource && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c96e1cfe23f7395a$export$13d1eb20012e1339), {
                    service: resource.service
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $35e01e15588e13d6$export$c8c505ba351266f8), {
                    volumes: volumes,
                    linkVolumes: linkVolumes
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CREATED_AT,
                    children: created ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$d275c5eeba29af75), {
                        date: created,
                        format: "datetime"
                    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NOT_AVAILABLE
                    })
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
                        status: status
                    })
                })
            ]
        })
    });
};



parcelRequire("h4Bez");




const $2c099c4213d6e158$export$223875819fd7cf93 = ({ resource: resource, managementCapability: managementCapability, deleteUsecaseName: deleteUsecaseName, restartUsecaseName: restartUsecaseName, stopUsecaseName: stopUsecaseName, startUsecaseName: startUsecaseName })=>{
    const usecases = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            (0, $dc261e1a4f8deea7$export$e49c64d84076eb0e)(resource) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                "data-testid": "start-container-button",
                text: (0, $40a99dac858c1d75$export$b63289fbda65eed1).START,
                capabilities: [
                    managementCapability
                ],
                onClick: ()=>usecases[startUsecaseName].selectContainers([
                        resource.id
                    ]),
                startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $3294d981d8a1956f$export$aed5667c83867b85), {}),
                showText: true
            }),
            (0, $dc261e1a4f8deea7$export$9dde073542957add)(resource) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                "data-testid": "stop-container-button",
                text: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STOP,
                capabilities: [
                    managementCapability
                ],
                onClick: ()=>usecases[stopUsecaseName].selectContainers([
                        resource.id
                    ]),
                startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08f5bd1d83fa4a5f$export$dc6949a98411e916), {}),
                showText: true
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                "data-testid": "restart-container-button",
                text: (0, $40a99dac858c1d75$export$b63289fbda65eed1).RESTART,
                disabled: !(0, $dc261e1a4f8deea7$export$7f65084de65d53e5)(resource),
                capabilities: [
                    managementCapability
                ],
                onClick: ()=>usecases[restartUsecaseName].selectContainers([
                        resource.id
                    ]),
                startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ce4e3ee315615fb1$export$35f5c3e250802cd1), {})
            }),
            deleteUsecaseName && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                "data-testid": "delete-container-button",
                text: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE,
                disabled: !(0, $dc261e1a4f8deea7$export$bebb768243e568eb)(resource),
                capabilities: [
                    managementCapability
                ],
                onClick: ()=>usecases[deleteUsecaseName].selectContainers([
                        resource.id
                    ]),
                startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d917252aed0e3bef$export$1ae95d1a7411cb7b), {}),
                variant: "dangerOutline"
            })
        ]
    });
};




const $becc98231f066a19$var$Modals = ({ leave: leave })=>{
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a355bb70b0ba7fda$export$eef432f28cb72346), {
                dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE_CONTAINER,
                usecase: "bulkStopServiceContainersUsecase",
                containersSelector: (0, $b474aaee01cbac2d$export$50271cc70cef846f)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a355bb70b0ba7fda$export$5d9f3c571397c16e), {
                dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE_CONTAINER,
                usecase: "bulkStartServiceContainersUsecase",
                containersSelector: (0, $b474aaee01cbac2d$export$88ac17e423771031)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a355bb70b0ba7fda$export$ffd3ea9cd076cdb7), {
                dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE_CONTAINER,
                usecase: "bulkRestartServiceContainersUsecase",
                containersSelector: (0, $b474aaee01cbac2d$export$f0efde4c58bb83b3)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a355bb70b0ba7fda$export$73392e09138fecd6), {
                dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE_CONTAINER,
                usecase: "bulkDeleteServiceContainersUsecase",
                containersSelector: (0, $b474aaee01cbac2d$export$9424ad235af7a5ae),
                onConfirmed: leave
            })
        ]
    });
};
const $becc98231f066a19$export$3e8048d3cf2ba3fd = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $264fddb75d092ad2$export$2e9120d34faa9c1f), {
        subscriptionUsecase: "manageServiceContainerUsecase",
        resourceSelector: (0, $b474aaee01cbac2d$export$4526fb399dbb3dc8),
        notFoundTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTAINER_NOT_FOUND,
        modals: $becc98231f066a19$var$Modals,
        headerResourceName: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTAINER,
        headerName: "name",
        headerActions: (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2c099c4213d6e158$export$223875819fd7cf93), {
                deleteUsecaseName: "bulkDeleteServiceContainersUsecase",
                restartUsecaseName: "bulkRestartServiceContainersUsecase",
                startUsecaseName: "bulkStartServiceContainersUsecase",
                stopUsecaseName: "bulkStopServiceContainersUsecase",
                managementCapability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_MANAGE,
                ...props
            }),
        infoTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTAINER_DETAILS_DOCUMENTATION_TITLE,
        infoBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTAINER_DETAILS_DOCUMENTATION_BODY,
        headerDetails: (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $795aa440e4459e4e$export$de1f3500221e9400), {
                linkVolumes: true,
                ...props
            }),
        content: (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5eebd14190b74197$export$7c6e2c02157bb7d2), {
                logType: (0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).SERVICE_CONTAINER,
                ...props
            })
    });










parcelRequire("h4Bez");






parcelRequire("h4Bez");



const $d5f7e78a29d3e4a4$export$e5607a3e105d74ac = ({ mappingSelector: mappingSelector, onConfirmed: onConfirmed })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bulkEnableMappingsUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$10f512a97cdb6733), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENABLE_MAPPINGS,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENABLE_MAPPINGS_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENABLE,
        resourceSelector: mappingSelector,
        dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).MAPPING,
        onRenderLineContent: (0, $0f6e6d34a7cdc5dd$export$b6009d9c113d57d8),
        onCancel: ()=>usecase.selectMappings(null),
        onConfirm: async ()=>{
            await usecase.enable();
            onConfirmed?.();
        }
    });
};
const $d5f7e78a29d3e4a4$export$1fd910e39ac2d463 = ({ mappingSelector: mappingSelector, onConfirmed: onConfirmed })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bulkDisableMappingsUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$f6737f912c21f59d), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE_MAPPINGS,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE_MAPPINGS_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE,
        resourceSelector: mappingSelector,
        dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).MAPPING,
        onRenderLineContent: (0, $0f6e6d34a7cdc5dd$export$b6009d9c113d57d8),
        onCancel: ()=>usecase.selectMappings(null),
        onConfirm: async ()=>{
            await usecase.disable();
            onConfirmed?.();
        }
    });
};
const $d5f7e78a29d3e4a4$export$73392e09138fecd6 = ({ mappingSelector: mappingSelector, onConfirmed: onConfirmed })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bulkDeleteMappingsUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$54399887e057b4b7), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_MAPPINGS,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_MAPPINGS_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE,
        resourceSelector: mappingSelector,
        dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).MAPPING,
        onRenderLineContent: (0, $0f6e6d34a7cdc5dd$export$b6009d9c113d57d8),
        onCancel: ()=>usecase.selectMappings(null),
        onConfirm: async ()=>{
            await usecase.delete();
            onConfirmed();
        }
    });
};


const $50bc70341a26085b$var$Modals = ()=>{
    const clear = (0, $365b0b4d68ac9bb9$export$d2838f462516652)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d5f7e78a29d3e4a4$export$73392e09138fecd6), {
                mappingSelector: (0, $220733605f0fc2b5$export$569747daf24d8c0a),
                onConfirmed: clear
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d5f7e78a29d3e4a4$export$e5607a3e105d74ac), {
                mappingSelector: (0, $220733605f0fc2b5$export$4ec0e5692e6f249c),
                onConfirmed: clear
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d5f7e78a29d3e4a4$export$1fd910e39ac2d463), {
                mappingSelector: (0, $220733605f0fc2b5$export$86d2a80573febb6c),
                onConfirmed: clear
            })
        ]
    });
};
const $50bc70341a26085b$var$selectCanManageMappings = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_MANAGE);
const $50bc70341a26085b$export$54ec01a60f47d33d = ({ serviceId: serviceId = null })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8aa67788985a70f6$export$b3c28590d63f6eca), {
        subscriptionUsecase: "manageMappingsUsecase",
        filter: serviceId ? {
            service: serviceId
        } : undefined,
        data: (0, $220733605f0fc2b5$export$77c6c28de80b0eef),
        hasManagementCapabilitiesSelector: $50bc70341a26085b$var$selectCanManageMappings,
        dataTableMapper: (mappings)=>mappings,
        columns: {
            ...serviceId ? {} : {
                service: {
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_ID,
                    sort: true
                }
            },
            name: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                sort: true
            },
            entriesCount: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).ENTRY, {
                    count: 2
                }),
                type: 'number'
            },
            agent: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).AGENT, {
                    count: 1
                }),
                sort: true
            },
            status: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS,
                customCellRender: (status)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
                        status: status
                    })
            }
        },
        short: Boolean(serviceId),
        redirectOnRowclick: (0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).MAPPING,
        selection: {
            DELETE: {
                usecase: 'bulkDeleteMappingsUsecase',
                filter: (0, $bc868e3ec3b72477$export$9cfee36c0f112169)
            },
            DISABLE: {
                usecase: 'bulkDisableMappingsUsecase',
                filter: (0, $bc868e3ec3b72477$export$35bdda6c1d986771)
            },
            ENABLE: {
                usecase: 'bulkEnableMappingsUsecase',
                filter: (0, $bc868e3ec3b72477$export$b88823ef6a552fb1)
            },
            resource: 'id',
            usecaseMethod: 'selectMappings'
        },
        translations: {
            emptyTable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_MAPPINGS_AVAILABLE,
            paginationDataType: 'MAPPING'
        },
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($50bc70341a26085b$var$Modals, {})
    });
};



parcelRequire("h4Bez");




parcelRequire("h4Bez");





var $h4Bez = parcelRequire("h4Bez");







parcelRequire("h4Bez");


const $c11dcdded818120b$export$f370eb0719ef89ca = ({ externalBroker: externalBroker })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: externalBroker === null ? (0, $40a99dac858c1d75$export$b63289fbda65eed1).INTERNAL : (0, $40a99dac858c1d75$export$b63289fbda65eed1).EXTERNAL
            }),
            externalBroker && ` (${externalBroker})`
        ]
    });



parcelRequire("h4Bez");






const $40c29a9183a1c39f$var$wrapperStyle = {
    display: 'flex',
    '& > *': {
        my: 'auto',
        ml: 1
    }
};
const $40c29a9183a1c39f$var$labelStyle = {
    ml: 0,
    mr: 'auto'
};
const $40c29a9183a1c39f$var$LatestValue = ({ id: id })=>{
    const event = (0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>(0, $220733605f0fc2b5$export$c89f7c57bbdaad4c)(s, id), [
        id
    ]);
    if (event === null) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_MESSAGES
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $837dcb3f32a07e41$export$7419ff430885d61c), {
        delay: 300,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0ef57b6c25dc3e6b$export$76748c987176663a), {
            buffer: event.payload,
            types: event.possibleTypes,
            minimized: true
        })
    });
};
const $40c29a9183a1c39f$export$939228aba9bab083 = ({ pubSub: pubSub, enabled: enabled })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $40c29a9183a1c39f$var$wrapperStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $40c29a9183a1c39f$var$labelStyle,
                children: pubSub.type === (0, $bc868e3ec3b72477$export$5c8c128443e404df).ENDPOINT ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7d5f64758ce3b1db$export$bf4bb1ff1ff62959), {
                    path: (0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).ENDPOINT,
                    id: pubSub.id,
                    children: pubSub.id
                }) : pubSub.id
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                children: enabled && pubSub.externalBroker === null && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($40c29a9183a1c39f$var$LatestValue, {
                    id: pubSub.id
                })
            }),
            pubSub.subscriptionErrors.size > 0 && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d36390f84a2ea7c3$export$79f270ed0b847a48), {
                topics: pubSub.topics,
                errors: pubSub.subscriptionErrors
            })
        ]
    });



parcelRequire("h4Bez");



parcelRequire("h4Bez");



"use client";
var $b3344c5f781513f7$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), 'Warning');





var $h4Bez = parcelRequire("h4Bez");







var $h4Bez = parcelRequire("h4Bez");



"use client";
var $52b2a4d3f71f0751$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)([
    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("circle", {
        cx: "7",
        cy: "14",
        r: "3"
    }, "0"),
    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("circle", {
        cx: "11",
        cy: "6",
        r: "3"
    }, "1"),
    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("circle", {
        cx: "16.6",
        cy: "17.6",
        r: "3"
    }, "2")
], 'ScatterPlot');







var $h4Bez = parcelRequire("h4Bez");


const $2bc5d97c610fd2d2$var$createRuleEngineHook = (prop)=>()=>(0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $5491cfd462130f7a$export$26200e6f60f4189a)(prop));
const $2bc5d97c610fd2d2$export$5ca6b3e4c1eb36ae = $2bc5d97c610fd2d2$var$createRuleEngineHook('type');
const $2bc5d97c610fd2d2$export$a34765cf83023a90 = $2bc5d97c610fd2d2$var$createRuleEngineHook('endpoints');
const $2bc5d97c610fd2d2$export$8d6a11b369927376 = $2bc5d97c610fd2d2$var$createRuleEngineHook('selectedEndpoints');
const $2bc5d97c610fd2d2$export$1e36b9f257eee5fa = $2bc5d97c610fd2d2$var$createRuleEngineHook('input');
const $2bc5d97c610fd2d2$export$40974a7917137f29 = $2bc5d97c610fd2d2$var$createRuleEngineHook('selectedTopics');
const $2bc5d97c610fd2d2$export$e516bd2e893953b7 = $2bc5d97c610fd2d2$var$createRuleEngineHook('transformation');
const $2bc5d97c610fd2d2$var$useOutputState = $2bc5d97c610fd2d2$var$createRuleEngineHook('output');
const $2bc5d97c610fd2d2$export$57d4cd177bcf4fb6 = ()=>{
    const output = $2bc5d97c610fd2d2$var$useOutputState();
    const [loaded, setLoaded] = (0, $h4Bez.useState)(()=>output);
    (0, $h4Bez.useEffect)(()=>{
        if (output.loaded) setLoaded(output);
    }, [
        output
    ]);
    return loaded;
};


const $5d14ce3539e1faf0$var$noSelection = [];
const $5d14ce3539e1faf0$var$withOptionContent = (endpoint)=>({
        ...endpoint,
        icon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $52b2a4d3f71f0751$export$2e2bcd8739ae039), {}),
        meta: [
            endpoint.service,
            endpoint.connection
        ].filter(Boolean).join(" \xb7 ") || undefined
    });
/**
 * Keeps already-selected endpoints selectable/removable even if they're missing from the latest fetch
 * (eg. deleted after being referenced, or filtered out by the current search). Left untouched while
 * loading/erroring so `NoOptionsText` still shows its spinner/error for those states.
 */ const $5d14ce3539e1faf0$var$withSelected = (endpoints, selected)=>(0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(endpoints) ? Object.values([
        ...endpoints,
        ...selected
    ].reduce((r, option)=>({
            ...r,
            [option.id]: $5d14ce3539e1faf0$var$withOptionContent(option)
        }), {})) : endpoints;
const $5d14ce3539e1faf0$export$86186188099b2759 = ()=>{
    const filter = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('filterSandboxUsecase');
    const endpoints = (0, $2bc5d97c610fd2d2$export$a34765cf83023a90)();
    const selected = (0, $2bc5d97c610fd2d2$export$8d6a11b369927376)() ?? $5d14ce3539e1faf0$var$noSelection;
    const options = (0, $h4Bez.useMemo)(()=>$5d14ce3539e1faf0$var$withSelected(endpoints, selected), [
        endpoints,
        selected
    ]);
    const value = (0, $h4Bez.useMemo)(()=>selected.map($5d14ce3539e1faf0$var$withOptionContent), [
        selected
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e878dbad11e3bdcd$export$2f2b9559550c7bbc), {
        "data-testid": "rule-engine-endpoints-dropdown",
        multiple: true,
        options: options,
        noOptionsText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ENDPOINTS_AVAILABLE,
        value: value,
        getOptionLabel: (option)=>option.name,
        /** `withOptionContent` recreates its object on every call, so options/value can't be matched by reference */ isOptionEqualToValue: (option, value)=>option.id === value.id,
        onSearch: (term)=>filter.setEndpointsSearch(term),
        /** Strips the render-only `icon`/`meta` back off before it reaches app state, which has to stay framework-free/serializable */ onSelect: (endpoints)=>filter.selectEndpoints(endpoints.map((endpoint)=>(0, $2ae70427bab197d4$export$12b617052eb9d30e)(endpoint, 'icon', 'meta'))),
        slots: {
            popper: (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5882b72728fa3109$export$2e2bcd8739ae039), {
                    "data-testid": "rule-engine-endpoints-dropdown-popper",
                    ...props
                })
        }
    });
};




parcelRequire("h4Bez");



const $6bf9b4f414ab1965$export$373308ac21f5dfb6 = ({ Editor: Editor })=>{
    const filter = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('filterSandboxUsecase');
    const input = (0, $2bc5d97c610fd2d2$export$1e36b9f257eee5fa)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Editor, {
        initialJson: input.value,
        onChange: (newJson)=>{
            if (!(0, $c3e1b746ad236797$export$8d524fb6540252df).is(newJson)) filter.setJson(newJson);
        }
    });
};




var $h4Bez = parcelRequire("h4Bez");


"use client";
var $48a5d15124e1fbfb$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'Edit');









parcelRequire("h4Bez");



const $d593b3ce526b4865$var$wrapperStyle = {
    height: '100%'
};
const $d593b3ce526b4865$var$codeStyle = {
    my: 0,
    p: 2,
    lineHeight: 1.5,
    backgroundColor: '#f6f8fa',
    borderRadius: 1,
    border: 'solid 1px',
    borderColor: 'grey.500',
    color: 'grey.900',
    height: '100%',
    overflowY: 'auto'
};
const $d593b3ce526b4865$var$Display = ({ json: json })=>json instanceof Object ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $47ae8c6618e10a1b$export$48880ac635f47186), {
        src: json,
        displayObjectSize: false,
        collapsed: 1
    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
        children: String(json)
    });
const $d593b3ce526b4865$export$52f0f02147b12c03 = ({ children: children, buttons: buttons, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $39543ef1c93c1508$export$a49368ab94976679), {
        sx: $d593b3ce526b4865$var$wrapperStyle,
        children: [
            buttons,
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                ...(0, $2ae70427bab197d4$export$12b617052eb9d30e)(props, 'json'),
                component: "pre",
                sx: $d593b3ce526b4865$var$codeStyle,
                children: 'json' in props ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($d593b3ce526b4865$var$Display, {
                    json: props.json
                }) : children
            })
        ]
    });



const $0c600bd079f32a5e$var$customizeButtonWrapperStyle = {
    width: 40,
    height: 0,
    ml: 'auto',
    mr: 2.5,
    position: 'relative',
    zIndex: 1
};
const $0c600bd079f32a5e$var$customizeButtonStyle = {
    cursor: 'pointer',
    width: 40,
    height: 40,
    p: '10px'
};
const $0c600bd079f32a5e$export$cdaf4ada6224d05e = ()=>{
    const input = (0, $2bc5d97c610fd2d2$export$1e36b9f257eee5fa)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TRANSFORMATION_INPUT,
        values: {
            last: true,
            hasSource: Boolean(input.loaded && input.topic),
            source: input.topic,
            copy: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1ab636062450c95b$export$92ce62e1201c4fc0), {
                children: input.topic
            })
        }
    });
};
const $0c600bd079f32a5e$export$8b696015bdddd6c7 = ()=>{
    const topics = (0, $2bc5d97c610fd2d2$export$40974a7917137f29)();
    const input = (0, $2bc5d97c610fd2d2$export$1e36b9f257eee5fa)();
    const { subscribeToMessagesSandboxUsecase: subscribeToMessagesSandboxUsecase, filterSandboxUsecase: filterSandboxUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    (0, $h4Bez.useEffect)(()=>subscribeToMessagesSandboxUsecase.subscribe(), [
        subscribeToMessagesSandboxUsecase
    ]);
    if (!topics?.length) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d593b3ce526b4865$export$52f0f02147b12c03), {
        "data-testid": "rule-engine-last-message",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_TOPICS_SELECTED
        })
    });
    if (!input.loaded) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d593b3ce526b4865$export$52f0f02147b12c03), {
        "data-testid": "rule-engine-last-message",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_MESSAGES
        })
    });
    if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(input.value)) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
        "data-testid": "rule-engine-last-message",
        titleVariant: "subtitle1",
        error: input.value,
        extras: "popover"
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d593b3ce526b4865$export$52f0f02147b12c03), {
        "data-testid": "rule-engine-last-message",
        buttons: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
            sx: $0c600bd079f32a5e$var$customizeButtonWrapperStyle,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $48a5d15124e1fbfb$export$2e2bcd8739ae039), {
                "data-testid": "rule-engine-last-message-customize",
                sx: $0c600bd079f32a5e$var$customizeButtonStyle,
                onClick: ()=>filterSandboxUsecase.setJson(input.value)
            })
        }),
        json: input.value
    });
};



parcelRequire("h4Bez");




const $cb47848a260e13b1$export$1a24d96529bda261 = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const filter = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('filterSandboxUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d887fad28e7ec96c$export$2c73285ae9390cec), {
        "data-testid": "rule-engine-topics-input",
        fullWidth: true,
        placeholder: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).TOPIC_PLACEHOLDER),
        onChange: ({ target: target })=>filter.selectTopics(target.value ? [
                target.value
            ] : [])
    });
};



parcelRequire("h4Bez");









const $45ab37d0c1887fcc$var$textareaStyle = {
    p: 2,
    lineHeight: 1.5,
    backgroundColor: '#f6f8fa',
    border: 'solid 1px',
    borderColor: 'grey.500',
    outline: 'none',
    color: 'grey.900',
    width: '100%',
    height: '100%',
    resize: 'vertical',
    minHeight: 50
};
const $45ab37d0c1887fcc$var$documentationLinkStyle = {
    fontSize: '0.625rem',
    py: 0.125,
    px: 0.5,
    border: 1,
    borderColor: 'gray',
    borderRadius: 1,
    userSelect: 'none',
    verticalAlign: 'middle',
    textDecoration: 'none'
};
const $45ab37d0c1887fcc$var$helperTextStyle = {
    display: 'flex',
    mt: 1.5,
    [[
        (0, $f9ef756b8f6a1b37$export$2e2bcd8739ae039).root,
        (0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root
    ].map((clazz)=>`& > .${clazz}`).join(',')]: {
        my: 'auto'
    }
};
const $45ab37d0c1887fcc$export$2da9401da16be581 = ()=>{
    const transformation = (0, $2bc5d97c610fd2d2$export$e516bd2e893953b7)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TRANSFORMATION_RULE,
                values: {
                    copy: transformation && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1ab636062450c95b$export$92ce62e1201c4fc0), {
                        children: transformation
                    })
                }
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $57ff7f54e54013be$export$6eb1e07b1de459cd), {
                type: (0, $de76aa5bd91d062d$export$26609300e3bf37cf).RULE_ENGINE_PARSE_RULE,
                sx: $45ab37d0c1887fcc$var$documentationLinkStyle,
                variant: "caption",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).RULE_ENGINE_DOCUMENTATION
                })
            })
        ]
    });
};
const $45ab37d0c1887fcc$export$eeeaea760cc479da = ()=>{
    const transformation = (0, $2bc5d97c610fd2d2$export$e516bd2e893953b7)();
    if (!transformation) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $45ab37d0c1887fcc$var$helperTextStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b3344c5f781513f7$export$2e2bcd8739ae039), {
                color: "action"
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "body2",
                color: "textSecondary",
                "data-testid": "transform-helper-text",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TRANSFORMATION_INPUT_HELPER_TEXT,
                    values: {
                        link: (0, $4772774eee62bdcc$export$18fadbe56dfcb1a1)((0, $57ff7f54e54013be$export$6eb1e07b1de459cd), {
                            type: (0, $de76aa5bd91d062d$export$26609300e3bf37cf).RULE_ENGINE_PARSE_RULE
                        })
                    }
                })
            })
        ]
    });
};
const $45ab37d0c1887fcc$export$f8ad66be1988cb53 = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const transformation = (0, $2bc5d97c610fd2d2$export$e516bd2e893953b7)();
    const filter = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('filterSandboxUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        component: "textarea",
        "data-testid": "rule-engine-rule-input",
        sx: $45ab37d0c1887fcc$var$textareaStyle,
        placeholder: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).RULE_ENGINE_SANDBOX_TRANSFORMATION_PLACEHOLDER),
        value: transformation,
        onChange: ({ target: target })=>filter.setTransformation(target.value)
    });
};




var $h4Bez = parcelRequire("h4Bez");









const $78a0b622d856f1b6$var$messageStyle = {
    mb: 2
};
const $78a0b622d856f1b6$export$e8b870485cc62869 = ()=>{
    const transform = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('transformSandboxUsecase');
    const type = (0, $2bc5d97c610fd2d2$export$5ca6b3e4c1eb36ae)();
    const selectedTopics = (0, $2bc5d97c610fd2d2$export$40974a7917137f29)();
    const input = (0, $2bc5d97c610fd2d2$export$1e36b9f257eee5fa)();
    const transformation = (0, $2bc5d97c610fd2d2$export$e516bd2e893953b7)();
    const output = (0, $2bc5d97c610fd2d2$export$57d4cd177bcf4fb6)();
    (0, $h4Bez.useEffect)(()=>transform.invoke(), [
        transform,
        input,
        transformation
    ]);
    if (type !== (0, $5491cfd462130f7a$export$605f39a06a79387c).JSON && !selectedTopics?.length) /** Not a custom json, so topics are necessary */ return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d593b3ce526b4865$export$52f0f02147b12c03), {
        "data-testid": "rule-engine-output",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: type === (0, $5491cfd462130f7a$export$605f39a06a79387c).ENDPOINT ? (0, $40a99dac858c1d75$export$b63289fbda65eed1).SELECT_ENDPOINT : (0, $40a99dac858c1d75$export$b63289fbda65eed1).INPUT_MQTT_TOPIC
        })
    });
    if (!input.loaded) /** Everything is properly set, but input has yet to be loaded */ return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d593b3ce526b4865$export$52f0f02147b12c03), {
        "data-testid": "rule-engine-output",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_MESSAGES
        })
    });
    if (!transformation) /** Transformation was not inputted */ return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d593b3ce526b4865$export$52f0f02147b12c03), {
        "data-testid": "rule-engine-output",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).INPUT_TRANSFORMATION_RULE
        })
    });
    if (!output.loaded) /** Output is now loading */ return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d593b3ce526b4865$export$52f0f02147b12c03), {
        "data-testid": "rule-engine-output",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $95388f9578043f1e$export$2e2bcd8739ae039), {
            "data-testid": "loading-output"
        })
    });
    if ((0, $5491cfd462130f7a$export$79c7d16c94855997).is(output.value)) /** Issue with transformation */ return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d593b3ce526b4865$export$52f0f02147b12c03), {
        "data-testid": "rule-engine-output",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6a05e8632b0549a9$export$71f0d08616028f79), {
                "data-testid": "rule-engine-output-title",
                executionError: output.value
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6a05e8632b0549a9$export$5c652d30ea85314b), {
                "data-testid": "rule-engine-output-message",
                sx: $78a0b622d856f1b6$var$messageStyle,
                executionError: output.value
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        "data-testid": "rule-engine-output-payload",
                        size: {
                            xs: 6
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $39543ef1c93c1508$export$a49368ab94976679), {
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6a05e8632b0549a9$export$d5781936a2005791), {
                                executionError: output.value
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        "data-testid": "rule-engine-output-rule",
                        size: {
                            xs: 6
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $39543ef1c93c1508$export$a49368ab94976679), {
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6a05e8632b0549a9$export$9856247c8a6b3e8a), {
                                executionError: output.value
                            })
                        })
                    })
                ]
            })
        ]
    });
    if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(output.value)) /** Other issues */ return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d593b3ce526b4865$export$52f0f02147b12c03), {
        "data-testid": "rule-engine-output",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
            titleVariant: "subtitle1",
            error: output.value,
            extras: "section"
        })
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d593b3ce526b4865$export$52f0f02147b12c03), {
        "data-testid": "rule-engine-output",
        json: output.value
    });
};




var $h4Bez = parcelRequire("h4Bez");





const $42348ab845afdaeb$var$canReadResources = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).RULE_ENGINE_RESOURCES);
const $42348ab845afdaeb$export$1cbeb7199b91dfe2 = ()=>{
    const filter = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('filterSandboxUsecase');
    const type = (0, $2bc5d97c610fd2d2$export$5ca6b3e4c1eb36ae)();
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const canLoadEndpoints = (0, $be523f14267dcd17$export$9973955de2bf96cf)($42348ab845afdaeb$var$canReadResources);
    const options = (0, $h4Bez.useMemo)(()=>[
            {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).JSON),
                value: (0, $5491cfd462130f7a$export$605f39a06a79387c).JSON
            },
            ...canLoadEndpoints ? [
                {
                    label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).ENDPOINT, {
                        count: 1
                    }),
                    value: (0, $5491cfd462130f7a$export$605f39a06a79387c).ENDPOINT
                }
            ] : [],
            {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).MQTT_TOPIC),
                value: (0, $5491cfd462130f7a$export$605f39a06a79387c).MQTT_TOPIC
            }
        ], [
        translator,
        canLoadEndpoints
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $14b4a2aa98aa8378$export$40258cc1d95ff477), {
        "data-testid": "rule-engine-type",
        value: type,
        exclusive: true,
        /**
             * When we click the same button again, MUI returns null (deselects it).
             * We only accept a valid type, ignoring null to keep a selection active.
             */ onChange: (_, newType)=>newType && filter.selectType(newType),
        children: options.map((option)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a0c70995540c0264$export$d2b052e7b4be1756), {
                value: option.value,
                "aria-label": option.label,
                "data-testid": `type-selector-${option.value}`,
                children: option.label
            }, option.value))
    });
};


const $52f46374fd68acb2$var$Title = ({ children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
        marginTop: 2,
        marginBottom: 1,
        variant: "body2",
        fontWeight: "bold",
        children: children
    });
const $52f46374fd68acb2$var$rootStyle = {
    display: 'flex',
    flexDirection: 'row',
    gap: 2
};
const $52f46374fd68acb2$var$additionalInputWrapperStyle = {
    flex: 1
};
const $52f46374fd68acb2$var$createSelectedTypeComponent = (options, Component)=>{
    return (otherProps)=>{
        const type = (0, $2bc5d97c610fd2d2$export$5ca6b3e4c1eb36ae)();
        return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Component, {
            ...otherProps,
            ...options[type]
        });
    };
};
const $52f46374fd68acb2$var$SanboxAdditionalInput = $52f46374fd68acb2$var$createSelectedTypeComponent({
    [(0, $5491cfd462130f7a$export$605f39a06a79387c).ENDPOINT]: {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SELECT_ENDPOINT,
        Input: (0, $5d14ce3539e1faf0$export$86186188099b2759)
    },
    [(0, $5491cfd462130f7a$export$605f39a06a79387c).MQTT_TOPIC]: {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).INPUT_MQTT_TOPIC,
        Input: (0, $cb47848a260e13b1$export$1a24d96529bda261)
    },
    [(0, $5491cfd462130f7a$export$605f39a06a79387c).JSON]: {
        title: null,
        Input: null
    }
}, ({ title: title, Input: Input })=>title && Input ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($52f46374fd68acb2$var$Title, {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: title
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Input, {})
        ]
    }) : null);
const $52f46374fd68acb2$var$SanboxPayloadInput = $52f46374fd68acb2$var$createSelectedTypeComponent({
    [(0, $5491cfd462130f7a$export$605f39a06a79387c).ENDPOINT]: {
        TitleContent: (0, $0c600bd079f32a5e$export$cdaf4ada6224d05e),
        renderOnHover: true,
        Content: (0, $0c600bd079f32a5e$export$8b696015bdddd6c7)
    },
    [(0, $5491cfd462130f7a$export$605f39a06a79387c).MQTT_TOPIC]: {
        TitleContent: (0, $0c600bd079f32a5e$export$cdaf4ada6224d05e),
        renderOnHover: true,
        Content: (0, $0c600bd079f32a5e$export$8b696015bdddd6c7)
    },
    [(0, $5491cfd462130f7a$export$605f39a06a79387c).JSON]: {
        TitleContent: ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TRANSFORMATION_INPUT,
                values: {
                    last: false
                }
            }),
        renderOnHover: false,
        Content: (0, $6bf9b4f414ab1965$export$373308ac21f5dfb6)
    }
}, ({ TitleContent: TitleContent, renderOnHover: renderOnHover, Content: Content, Editor: Editor })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            renderOnHover ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $39543ef1c93c1508$export$a49368ab94976679), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($52f46374fd68acb2$var$Title, {
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(TitleContent, {})
                })
            }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($52f46374fd68acb2$var$Title, {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(TitleContent, {})
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Content, {
                Editor: Editor
            })
        ]
    }));
const $52f46374fd68acb2$var$SandboxTransformation = $52f46374fd68acb2$var$createSelectedTypeComponent({
    [(0, $5491cfd462130f7a$export$605f39a06a79387c).ENDPOINT]: {
        HelperText: (0, $45ab37d0c1887fcc$export$eeeaea760cc479da)
    },
    [(0, $5491cfd462130f7a$export$605f39a06a79387c).MQTT_TOPIC]: {
        HelperText: (0, $45ab37d0c1887fcc$export$eeeaea760cc479da)
    },
    [(0, $5491cfd462130f7a$export$605f39a06a79387c).JSON]: {
        HelperText: null
    }
}, ({ HelperText: HelperText })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($52f46374fd68acb2$var$Title, {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $45ab37d0c1887fcc$export$2da9401da16be581), {})
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $45ab37d0c1887fcc$export$f8ad66be1988cb53), {}),
            HelperText ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(HelperText, {}) : null
        ]
    }));
const $52f46374fd68acb2$var$SandboxOutput = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($52f46374fd68acb2$var$Title, {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TRANSFORMATION_RESULT
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $78a0b622d856f1b6$export$e8b870485cc62869), {})
        ]
    });
const $52f46374fd68acb2$export$aaaea0ead6b8e811 = ({ Editor: Editor })=>{
    const start = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('startSandboxUsecase');
    (0, $h4Bez.useEffect)(()=>start.invoke(), [
        start
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $be3703687194c6e0$export$56e2352e63353d99), {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).RULE_ENGINE_SANDBOX,
                description: [
                    (0, $40a99dac858c1d75$export$b63289fbda65eed1).RULE_ENGINE_SANDBOX_DOCUMENTATION_TITLE,
                    (0, $40a99dac858c1d75$export$b63289fbda65eed1).RULE_ENGINE_SANDBOX_DOCUMENTATION_BODY
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $52f46374fd68acb2$var$rootStyle,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($52f46374fd68acb2$var$Title, {
                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SELECT_TRANSFORMATION_SOURCE
                                })
                            }),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $42348ab845afdaeb$export$1cbeb7199b91dfe2), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        sx: $52f46374fd68acb2$var$additionalInputWrapperStyle,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($52f46374fd68acb2$var$SanboxAdditionalInput, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($52f46374fd68acb2$var$SanboxPayloadInput, {
                        Editor: Editor
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($52f46374fd68acb2$var$SandboxTransformation, {}),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($52f46374fd68acb2$var$SandboxOutput, {})
                ]
            })
        ]
    });
};





parcelRequire("h4Bez");





const $6a05e8632b0549a9$var$jsonStyle = {
    maxWidth: 600,
    maxHeight: 300,
    overflow: 'auto'
};
const $6a05e8632b0549a9$export$71f0d08616028f79 = ({ executionError: executionError, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
        ...props,
        titleVariant: "body1",
        customTitle: ({ ruleName: ruleName })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).RULE_ERROR,
                values: {
                    b: (0, $4772774eee62bdcc$export$582aafb958f7fe50),
                    ruleName: ruleName
                }
            }),
        error: executionError
    });
const $6a05e8632b0549a9$export$5c652d30ea85314b = ({ executionError: { messagePrefix: messagePrefix, messageDetails: messageDetails }, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
        ...props,
        variant: "body2",
        color: "error",
        children: [
            messagePrefix && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
                children: [
                    messagePrefix,
                    ":",
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("b", {
                children: messageDetails
            })
        ]
    });
const $6a05e8632b0549a9$var$Display = ({ title: title, titleArgs: titleArgs, json: json })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("b", {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: title,
                        values: titleArgs
                    }),
                    ":"
                ]
            }),
            json instanceof Object ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $6a05e8632b0549a9$var$jsonStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $47ae8c6618e10a1b$export$48880ac635f47186), {
                    src: json,
                    displayObjectSize: false,
                    collapsed: 1
                })
            }) : String(json)
        ]
    });
const $6a05e8632b0549a9$export$d5781936a2005791 = ({ executionError: { payload: payload } })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($6a05e8632b0549a9$var$Display, {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).INPUT,
        json: payload
    });
const $6a05e8632b0549a9$export$9856247c8a6b3e8a = ({ executionError: { rule: rule } })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($6a05e8632b0549a9$var$Display, {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).RULE,
        titleArgs: {
            count: 1
        },
        json: rule
    });




const $f45c88c6c1f6be8f$var$wrapperStyle = {
    p: 1
};
const $f45c88c6c1f6be8f$var$messageStyle = {
    maxWidth: 600,
    my: 1
};
const $f45c88c6c1f6be8f$var$buttonStyle = {
    cursor: 'pointer'
};
const $f45c88c6c1f6be8f$var$Popover = ({ executionError: executionError })=>{
    const close = (0, $5c50dcf7e155ce8c$export$89554eb4b4787636)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $40650a35df6eb212$export$2e2bcd8739ae039), {
        onClose: close,
        anchorOrigin: {
            vertical: 'top',
            horizontal: 'left'
        },
        transformOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
        },
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
            sx: $f45c88c6c1f6be8f$var$wrapperStyle,
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6a05e8632b0549a9$export$71f0d08616028f79), {
                    "data-testid": "mapping-rule-error-title",
                    executionError: executionError
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6a05e8632b0549a9$export$5c652d30ea85314b), {
                    "data-testid": "mapping-rule-error-message",
                    sx: $f45c88c6c1f6be8f$var$messageStyle,
                    executionError: executionError
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $39543ef1c93c1508$export$a49368ab94976679), {
                    "data-testid": "mapping-rule-error-input",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6a05e8632b0549a9$export$d5781936a2005791), {
                        executionError: executionError
                    })
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $39543ef1c93c1508$export$a49368ab94976679), {
                    "data-testid": "mapping-rule-error-rule",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6a05e8632b0549a9$export$9856247c8a6b3e8a), {
                        executionError: executionError
                    })
                })
            ]
        })
    });
};
const $f45c88c6c1f6be8f$var$Button = ()=>{
    const setPopover = (0, $5c50dcf7e155ce8c$export$b13dce3af0135d87)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b3344c5f781513f7$export$2e2bcd8739ae039), {
        "data-testid": "mapping-rule-error-button",
        sx: $f45c88c6c1f6be8f$var$buttonStyle,
        color: "error",
        onClick: ({ currentTarget: currentTarget })=>setPopover(currentTarget)
    });
};
const $f45c88c6c1f6be8f$export$8afccc1c0f0dfc45 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $5c50dcf7e155ce8c$export$1d7e255c6105d39b), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($f45c88c6c1f6be8f$var$Button, {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($f45c88c6c1f6be8f$var$Popover, {
                ...props
            })
        ]
    });


const $35dfb9bf595de391$var$wrapperStyle = {
    display: 'flex'
};
const $35dfb9bf595de391$var$rulesStyle = {
    my: 'auto',
    mx: 0,
    maxWidth: 320,
    overflowX: 'auto'
};
const $35dfb9bf595de391$var$errorStyle = {
    m: 'auto',
    mr: 0
};
const $35dfb9bf595de391$export$374633da432e5a39 = ({ rules: rules, executionError: executionError })=>rules ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $35dfb9bf595de391$var$wrapperStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $39543ef1c93c1508$export$a49368ab94976679), {
                sx: $35dfb9bf595de391$var$rulesStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $47ae8c6618e10a1b$export$48880ac635f47186), {
                    src: rules
                })
            }),
            executionError && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $35dfb9bf595de391$var$errorStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f45c88c6c1f6be8f$export$8afccc1c0f0dfc45), {
                    executionError: executionError
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$3eec49f24c546686), {});


const $06571aec5ab689b1$var$lineStyle = {
    minHeight: 32,
    lineHeight: '32px'
};
const $06571aec5ab689b1$var$Line = ({ children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $06571aec5ab689b1$var$lineStyle,
        children: children
    });
const $06571aec5ab689b1$export$be81f2ab9a4121eb = ({ entries: entries, status: status })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const entriesError = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $220733605f0fc2b5$export$f555eb9c70b44e48));
    const enabled = status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLED;
    /** Subscribe to all entries once, and again on each retry, which drops the failed subscription first */ const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('subscribeToMappingEntriesUsecase');
    const [subscriptionAttempt, retrySubscription] = (0, $9dfd779a84325298$export$aa7f9ebe4f644d13)();
    (0, $h4Bez.useEffect)(()=>enabled ? usecase.subscribe() : undefined, [
        usecase,
        enabled,
        subscriptionAttempt
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        error: entriesError ? {
            error: entriesError,
            onRetry: retrySubscription
        } : undefined,
        data: entries.map(({ subscribe: subscribe, publish: publish, ...rules })=>({
                subscribe: subscribe,
                subscribeExternalBrokers: subscribe.map((s)=>s.externalBroker),
                publish: publish,
                publishExternalBroker: publish.externalBroker,
                rules: rules
            })),
        columns: {
            subscribe: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SUBSCRIBE,
                customCellRender: (pubSubs)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
                        children: pubSubs.map((pubSub, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($06571aec5ab689b1$var$Line, {
                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $40c29a9183a1c39f$export$939228aba9bab083), {
                                    pubSub: pubSub,
                                    enabled: enabled
                                })
                            }, k))
                    })
            },
            subscribeExternalBrokers: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SUBSCRIBE_BROKER,
                customCellRender: (externalBrokers)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
                        children: externalBrokers.map((externalBroker, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($06571aec5ab689b1$var$Line, {
                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c11dcdded818120b$export$f370eb0719ef89ca), {
                                    externalBroker: externalBroker
                                })
                            }, k))
                    })
            },
            publish: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).PUBLISH,
                customCellRender: (pubSub)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $40c29a9183a1c39f$export$939228aba9bab083), {
                        pubSub: pubSub,
                        enabled: enabled
                    })
            },
            publishExternalBroker: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).PUBLISH_BROKER,
                customCellRender: (externalBroker)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c11dcdded818120b$export$f370eb0719ef89ca), {
                        externalBroker: externalBroker
                    })
            },
            rules: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).RULE, {
                    count: 2
                }),
                customCellRender: (rules)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $35dfb9bf595de391$export$374633da432e5a39), {
                        ...rules
                    })
            }
        },
        translations: {
            emptyTable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ENTRIES_AVAILABLE
        }
    });
};


const $beb7ef64417facd8$export$7c6e2c02157bb7d2 = ({ resource: resource })=>{
    const { id: id, entries: entries, status: status } = resource;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b6b5ebbc4a51bb7b$export$fc34525e6b0d872d), {
        type: (0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).MAPPING,
        id: id,
        children: (available)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2bf638d791e22cc5$export$b2539bed5023c21c), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MAPPING_LOGS,
                        disabled: !available,
                        requiredCapabilities: [
                            (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ
                        ],
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ac7334fad98808f5$export$54ec01a60f47d33d), {
                            id: id,
                            type: (0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).MAPPING,
                            reloadOn: resource
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENTRY,
                        requiredCapabilities: [
                            (0, $78670ebe9381a713$export$790a66df9dc00390).TOPICS_SUBSCRIPTION
                        ],
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $06571aec5ab689b1$export$be81f2ab9a4121eb), {
                            entries: entries,
                            status: status
                        })
                    })
                ]
            })
    });
};



parcelRequire("h4Bez");




const $ccfead2101402457$export$223875819fd7cf93 = ({ resource: { id: id, status: status } })=>{
    const { bulkDeleteMappingsUsecase: bulkDeleteMappingsUsecase, bulkEnableMappingsUsecase: bulkEnableMappingsUsecase, bulkDisableMappingsUsecase: bulkDisableMappingsUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                "data-testid": (0, $bc868e3ec3b72477$export$35bdda6c1d986771)({
                    status: status
                }) ? 'disable-mapping-button' : 'enable-mapping-button',
                disabled: !(0, $bc868e3ec3b72477$export$35bdda6c1d986771)({
                    status: status
                }) && !(0, $bc868e3ec3b72477$export$b88823ef6a552fb1)({
                    status: status
                }),
                text: (0, $bc868e3ec3b72477$export$35bdda6c1d986771)({
                    status: status
                }) ? (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE : (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENABLE,
                capabilities: [
                    (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_MANAGE
                ],
                onClick: (0, $bc868e3ec3b72477$export$35bdda6c1d986771)({
                    status: status
                }) ? ()=>bulkDisableMappingsUsecase.selectMappings([
                        id
                    ]) : ()=>bulkEnableMappingsUsecase.selectMappings([
                        id
                    ]),
                startIcon: (0, $bc868e3ec3b72477$export$35bdda6c1d986771)({
                    status: status
                }) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b9d7f820c3e6958b$export$9b47433640e5db3a), {}) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $3294d981d8a1956f$export$aed5667c83867b85), {}),
                showText: true
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                disabled: !(0, $bc868e3ec3b72477$export$9cfee36c0f112169)({
                    status: status
                }),
                "data-testid": "delete-mapping-button",
                text: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE,
                capabilities: [
                    (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_MANAGE
                ],
                onClick: ()=>bulkDeleteMappingsUsecase.selectMappings([
                        id
                    ]),
                startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d917252aed0e3bef$export$1ae95d1a7411cb7b), {}),
                variant: "dangerOutline"
            })
        ]
    });
};





parcelRequire("h4Bez");





const $7b253f32389b8e75$var$entriesErrorStyle = {
    display: 'flex',
    '& > *': {
        my: 'auto',
        mx: 0
    }
};
const $7b253f32389b8e75$var$errorTextStyle = {
    ml: 1
};
const $7b253f32389b8e75$export$de1f3500221e9400 = ({ resource: { service: service, id: id, status: status, entries: entries, agent: agent } })=>{
    const translation = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const errorsCount = entries.reduce((c, e)=>c + Number(Boolean(e.executionError)), 0);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: true,
        alignItems: "center",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
            "data-testid": "mapping-header-description",
            size: {
                xs: 7
            },
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MAPPING_ID,
                    type: "text",
                    children: id
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c96e1cfe23f7395a$export$13d1eb20012e1339), {
                    service: service
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).ENTRY, {
                        count: 2
                    }),
                    type: "number",
                    children: entries.length
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).AGENT, {
                        count: 1
                    }),
                    type: "text",
                    children: agent || translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_AGENTS_AVAILABLE)
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
                        status: status
                    })
                }),
                errorsCount > 0 && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).ERROR, {
                        count: 2
                    }),
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        sx: $7b253f32389b8e75$var$entriesErrorStyle,
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b3344c5f781513f7$export$2e2bcd8739ae039), {
                                fontSize: "small",
                                color: "error"
                            }),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                                variant: "body2",
                                color: "error",
                                sx: $7b253f32389b8e75$var$errorTextStyle,
                                children: translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).ERROR_COUNT, {
                                    count: errorsCount
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};


const $fb3f6e672e265b77$var$Modals = ({ leave: leave })=>{
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d5f7e78a29d3e4a4$export$e5607a3e105d74ac), {
                mappingSelector: (0, $220733605f0fc2b5$export$aa80e2a417628314)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d5f7e78a29d3e4a4$export$1fd910e39ac2d463), {
                mappingSelector: (0, $220733605f0fc2b5$export$5d11f63b60cf4570)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d5f7e78a29d3e4a4$export$73392e09138fecd6), {
                mappingSelector: (0, $220733605f0fc2b5$export$495c8147ac571b6d),
                onConfirmed: leave
            })
        ]
    });
};
const $fb3f6e672e265b77$export$3e8048d3cf2ba3fd = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $264fddb75d092ad2$export$2e9120d34faa9c1f), {
        subscriptionUsecase: "manageMappingUsecase",
        resourceSelector: (0, $220733605f0fc2b5$export$3921ef1972aa52e0),
        notFoundTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MAPPING_NOT_FOUND,
        modals: $fb3f6e672e265b77$var$Modals,
        content: (0, $beb7ef64417facd8$export$7c6e2c02157bb7d2),
        headerResourceName: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MAPPING,
        headerName: "name",
        headerActions: (0, $ccfead2101402457$export$223875819fd7cf93),
        infoTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MAPPING_DETAILS_DOCUMENTATION_TITLE,
        infoBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MAPPING_DETAILS_DOCUMENTATION_BODY,
        headerDetails: (0, $7b253f32389b8e75$export$de1f3500221e9400)
    });







parcelRequire("h4Bez");




const $77ad22a2e1029f2f$export$54ec01a60f47d33d = (filter)=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const customCellRender = (status)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
            status: status
        });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8aa67788985a70f6$export$b5d723e193e2be22), {
        subscriptionUsecase: "manageNodesUsecase",
        filter: {
            ...'serviceId' in filter && {
                service: filter.serviceId
            },
            ...'serverId' in filter && {
                server: filter.serverId
            }
        },
        data: (0, $f26ca34712d97a28$export$4d8d89a5c8a05d3e),
        dataTableMapper: (nodes)=>nodes,
        columns: {
            ...'serviceId' in filter ? {} : {
                service: {
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_ID,
                    sort: true
                }
            },
            name: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                sort: true
            },
            parent: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).PARENT,
                sort: true
            },
            protocol: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).PROTOCOL, {
                    count: 1
                }),
                sort: true
            },
            operation: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).OPERATION, {
                    count: 1
                })
            },
            status: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS,
                customCellRender: customCellRender
            }
        },
        translations: {
            emptyTable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_NODES_AVAILABLE
        }
    });
};






parcelRequire("h4Bez");






parcelRequire("h4Bez");



const $c2953a1db020d452$export$e5607a3e105d74ac = ({ serversSelector: serversSelector, onConfirmed: onConfirmed })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bulkEnableServersUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$10f512a97cdb6733), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENABLE_SERVERS,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENABLE_SERVERS_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENABLE,
        resourceSelector: serversSelector,
        dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVER,
        onRenderLineContent: (0, $0f6e6d34a7cdc5dd$export$b6009d9c113d57d8),
        onCancel: ()=>usecase.selectServers(null),
        onConfirm: async ()=>{
            await usecase.enable();
            onConfirmed?.();
        }
    });
};
const $c2953a1db020d452$export$1fd910e39ac2d463 = ({ serversSelector: serversSelector, onConfirmed: onConfirmed })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bulkDisableServersUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$f6737f912c21f59d), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE_SERVERS,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE_SERVERS_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE,
        resourceSelector: serversSelector,
        dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVER,
        onRenderLineContent: (0, $0f6e6d34a7cdc5dd$export$b6009d9c113d57d8),
        onCancel: ()=>usecase.selectServers(null),
        onConfirm: async ()=>{
            await usecase.disable();
            onConfirmed?.();
        }
    });
};
const $c2953a1db020d452$export$73392e09138fecd6 = ({ serversSelector: serversSelector, onConfirmed: onConfirmed })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bulkDeleteServersUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$54399887e057b4b7), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_SERVERS,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_SERVERS_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE,
        resourceSelector: serversSelector,
        dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVER,
        onRenderLineContent: (0, $0f6e6d34a7cdc5dd$export$b6009d9c113d57d8),
        onCancel: ()=>usecase.selectServers(null),
        onConfirm: async ()=>{
            await usecase.delete();
            onConfirmed?.();
        }
    });
};


const $91a76748a62a49cb$var$Modals = ()=>{
    const clear = (0, $365b0b4d68ac9bb9$export$d2838f462516652)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c2953a1db020d452$export$73392e09138fecd6), {
                serversSelector: (0, $f26ca34712d97a28$export$8c41444bcf536591),
                onConfirmed: clear
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c2953a1db020d452$export$e5607a3e105d74ac), {
                serversSelector: (0, $f26ca34712d97a28$export$abcdceac2ad6bded),
                onConfirmed: clear
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c2953a1db020d452$export$1fd910e39ac2d463), {
                serversSelector: (0, $f26ca34712d97a28$export$bc68d5ab6318d4e8),
                onConfirmed: clear
            })
        ]
    });
};
const $91a76748a62a49cb$var$selectCanManageServers = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_MANAGE);
const $91a76748a62a49cb$export$54ec01a60f47d33d = ({ serviceId: serviceId = null })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8aa67788985a70f6$export$b3c28590d63f6eca), {
        subscriptionUsecase: "manageServersUsecase",
        filter: serviceId ? {
            service: serviceId
        } : undefined,
        data: (0, $f26ca34712d97a28$export$818b466ecc63d5f1),
        hasManagementCapabilitiesSelector: $91a76748a62a49cb$var$selectCanManageServers,
        dataTableMapper: (servers)=>servers,
        columns: {
            ...serviceId ? {} : {
                service: {
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_ID,
                    sort: true
                }
            },
            name: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                sort: true
            },
            protocol: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).PROTOCOL, {
                    count: 1
                }),
                sort: true
            },
            status: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS,
                customCellRender: (status)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
                        status: status
                    })
            }
        },
        short: Boolean(serviceId),
        redirectOnRowclick: (0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).SERVER,
        selection: {
            DELETE: {
                usecase: 'bulkDeleteServersUsecase',
                filter: (0, $a79b5916972014a8$export$a0630811f022c903)
            },
            DISABLE: {
                usecase: 'bulkDisableServersUsecase',
                filter: (0, $a79b5916972014a8$export$a6c412803fd25277)
            },
            ENABLE: {
                usecase: 'bulkEnableServersUsecase',
                filter: (0, $a79b5916972014a8$export$7dc9519714001331)
            },
            resource: 'id',
            usecaseMethod: 'selectServers'
        },
        translations: {
            emptyTable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_SERVERS_AVAILABLE,
            paginationDataType: 'SERVER'
        },
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($91a76748a62a49cb$var$Modals, {})
    });
};



parcelRequire("h4Bez");




parcelRequire("h4Bez");




const $0d54c40c861ba9ba$export$7c6e2c02157bb7d2 = ({ resource: resource })=>{
    const { id: id } = resource;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b6b5ebbc4a51bb7b$export$fc34525e6b0d872d), {
        type: (0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).SERVER,
        id: id,
        children: (available)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2bf638d791e22cc5$export$b2539bed5023c21c), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVER_LOGS,
                        disabled: !available,
                        requiredCapabilities: [
                            (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ
                        ],
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ac7334fad98808f5$export$54ec01a60f47d33d), {
                            id: id,
                            type: (0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).SERVER,
                            reloadOn: resource
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NODE,
                        requiredCapabilities: [
                            (0, $78670ebe9381a713$export$790a66df9dc00390).NODES_READ
                        ],
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $77ad22a2e1029f2f$export$54ec01a60f47d33d), {
                            serverId: id
                        })
                    })
                ]
            })
    });
};



parcelRequire("h4Bez");




const $b95e1f9a08b143e2$var$disableButtonLabels = {
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLED]: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE,
    [(0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLING]: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENABLING
};
const $b95e1f9a08b143e2$export$223875819fd7cf93 = ({ resource: resource })=>{
    const { bulkDeleteServersUsecase: bulkDeleteServersUsecase, bulkEnableServersUsecase: bulkEnableServersUsecase, bulkDisableServersUsecase: bulkDisableServersUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                "data-testid": "server-action-button",
                disabled: !(0, $a79b5916972014a8$export$a6c412803fd25277)(resource) && !(0, $a79b5916972014a8$export$7dc9519714001331)(resource),
                text: $b95e1f9a08b143e2$var$disableButtonLabels[resource.status] || (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENABLE,
                capabilities: [
                    (0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_MANAGE
                ],
                onClick: (0, $a79b5916972014a8$export$a6c412803fd25277)(resource) ? ()=>bulkDisableServersUsecase.selectServers([
                        resource.id
                    ]) : ()=>bulkEnableServersUsecase.selectServers([
                        resource.id
                    ]),
                startIcon: (0, $a79b5916972014a8$export$a6c412803fd25277)(resource) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b9d7f820c3e6958b$export$9b47433640e5db3a), {}) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $3294d981d8a1956f$export$aed5667c83867b85), {}),
                showText: true
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                "data-testid": "delete-server-button",
                text: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE,
                disabled: !(0, $a79b5916972014a8$export$a0630811f022c903)(resource),
                capabilities: [
                    (0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_MANAGE
                ],
                onClick: ()=>bulkDeleteServersUsecase.selectServers([
                        resource.id
                    ]),
                startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d917252aed0e3bef$export$1ae95d1a7411cb7b), {}),
                variant: "dangerOutline"
            })
        ]
    });
};




parcelRequire("h4Bez");





const $c784c5253cbebe71$export$de1f3500221e9400 = ({ resource: { service: service, status: status, protocol: protocol, name: name } })=>{
    const translation = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        "data-testid": "server-header-description",
        size: {
            xs: 7
        },
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                type: "text",
                children: name
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c96e1cfe23f7395a$export$13d1eb20012e1339), {
                service: service
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                title: translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).PROTOCOL, {
                    count: 1
                }),
                type: "text",
                children: protocol
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
                    status: status
                })
            })
        ]
    });
};


const $d7661f3b06033a4b$var$Modals = ({ leave: leave })=>{
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c2953a1db020d452$export$e5607a3e105d74ac), {
                serversSelector: (0, $f26ca34712d97a28$export$817f98e6c3192618)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c2953a1db020d452$export$1fd910e39ac2d463), {
                serversSelector: (0, $f26ca34712d97a28$export$469eef6cf7a292fc)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c2953a1db020d452$export$73392e09138fecd6), {
                serversSelector: (0, $f26ca34712d97a28$export$cec3a3062033c610),
                onConfirmed: leave
            })
        ]
    });
};
const $d7661f3b06033a4b$export$3e8048d3cf2ba3fd = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $264fddb75d092ad2$export$2e9120d34faa9c1f), {
        subscriptionUsecase: "manageServerUsecase",
        resourceSelector: (0, $f26ca34712d97a28$export$87e15bc97bbe9a4a),
        notFoundTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVER_NOT_FOUND,
        modals: $d7661f3b06033a4b$var$Modals,
        content: (0, $0d54c40c861ba9ba$export$7c6e2c02157bb7d2),
        headerResourceName: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVER,
        headerName: "name",
        headerActions: (0, $b95e1f9a08b143e2$export$223875819fd7cf93),
        infoTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVER_DETAILS_DOCUMENTATION_TITLE,
        infoBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVER_DETAILS_DOCUMENTATION_BODY,
        headerDetails: (0, $c784c5253cbebe71$export$de1f3500221e9400)
    });










parcelRequire("h4Bez");







var $h4Bez = parcelRequire("h4Bez");





var $h4Bez = parcelRequire("h4Bez");

/** Determines whether a `thing` is an object for the purposes of RJSF. In this case, `thing` is an object if it has
 * the type `object` but is NOT null, an array or a File.
 *
 * @param thing - The thing to check to see whether it is an object
 * @returns - True if it is a non-null, non-array, non-File object
 */ function $a94aaa2913b539bc$export$2e2bcd8739ae039(thing) {
    if (typeof thing !== 'object' || thing === null) return false;
    // lastModified is guaranteed to be a number on a File instance
    // as per https://w3c.github.io/FileAPI/#dfn-lastModified
    if (typeof thing.lastModified === 'number' && typeof File !== 'undefined' && thing instanceof File) return false;
    // getMonth is guaranteed to be a method on a Date instance
    // as per https://tc39.es/ecma262/multipage/numbers-and-dates.html#sec-date.prototype.getmonth
    if (typeof thing.getMonth === 'function' && typeof Date !== 'undefined' && thing instanceof Date) return false;
    return !Array.isArray(thing);
}


function $abee29945f84e72d$export$2e2bcd8739ae039(schema) {
    if (schema.additionalItems === true) // oxlint-disable-next-line no-console
    console.warn('additionalItems=true is currently not supported');
    return (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(schema.additionalItems);
}


/** Attempts to convert the string into a number. If an empty string is provided, then `undefined` is returned. If a
 * `null` is provided, it is returned. If the string ends in a `.` then the string is returned because the user may be
 * in the middle of typing a float number. If a number ends in a pattern like `.0`, `.20`, `.030`, string is returned
 * because the user may be typing number that will end in a non-zero digit. Otherwise, the string is wrapped by
 * `Number()` and if that result is not `NaN`, that number will be returned, otherwise the string `value` will be.
 *
 * @param value - The string or null value to convert to a number
 * @returns - The `value` converted to a number when appropriate, otherwise the `value`
 */ function $f85108defa353a72$export$2e2bcd8739ae039(value) {
    if (value === '') return undefined;
    if (value === null) return null;
    // oxlint-disable-next-line typescript/prefer-string-starts-ends-with -- regex test() coerces undefined to "undefined" safely; endsWith() throws on undefined values passed at runtime
    if (/\.$/.test(value)) // '3.' can't really be considered a number even if it parses in js. The
    // user is most likely entering a float.
    return value;
    // oxlint-disable-next-line typescript/prefer-string-starts-ends-with -- same as above
    if (/\.0$/.test(value)) // we need to return this as a string here, to allow for input like 3.07
    return value;
    if (/\.\d*0$/.test(value)) // It's a number, that's cool - but we need it as a string so it doesn't screw
    // with the user when entering dollar amounts or other values (such as those with
    // specific precision or number of significant digits)
    return value;
    const n = Number(value);
    const valid = typeof n === 'number' && !Number.isNaN(n);
    return valid ? n : value;
}


/** Below are the list of all the keys into various elements of a RJSFSchema or UiSchema that are used by the various
 * utility functions. In addition to those keys, there are the special `ADDITIONAL_PROPERTY_FLAG` and
 * `RJSF_ADDITIONAL_PROPERTIES_FLAG` flags that is added to a schema under certain conditions by the `retrieveSchema()`
 * utility.
 */ const $cd207018ee28cb28$export$60d2d9c11642ddd6 = '__additional_property';
const $cd207018ee28cb28$export$42410ea1a2a130d1 = 'additionalProperties';
const $cd207018ee28cb28$export$d2b65f1d256ab906 = 'allOf';
const $cd207018ee28cb28$export$2014f14bbe7357bd = 'anyOf';
const $cd207018ee28cb28$export$532244974323b6ba = 'const';
const $cd207018ee28cb28$export$729d352c37f0a7df = 'default';
const $cd207018ee28cb28$export$eadde7280ea063cd = 'definitions';
const $cd207018ee28cb28$export$f2daf7b7d8cced48 = 'dependencies';
const $cd207018ee28cb28$export$fca9148df915a7b6 = 'enum';
const $cd207018ee28cb28$export$36fec1b8ab257149 = '__errors';
const $cd207018ee28cb28$export$f453fd324e92d331 = '$id';
const $cd207018ee28cb28$export$fa01b0fcf30c8319 = 'if';
const $cd207018ee28cb28$export$7a3255c70c8752d5 = 'items';
const $cd207018ee28cb28$export$9b4d24d10abfe212 = '_$junk_option_schema_id$_';
const $cd207018ee28cb28$export$299579ccbdd63cbc = '$name';
const $cd207018ee28cb28$export$c24c2c38af9a39c3 = 'oneOf';
const $cd207018ee28cb28$export$d5294cb04d742a01 = 'patternProperties';
const $cd207018ee28cb28$export$dd550d4e98f939a4 = 'properties';
const $cd207018ee28cb28$export$41fe6d5784a55183 = 'readonly';
const $cd207018ee28cb28$export$8efe7be9a05205be = 'required';
const $cd207018ee28cb28$export$a590c102372d2ff1 = 'submitButtonOptions';
const $cd207018ee28cb28$export$cf02ae06bf291db4 = '$ref';
const $cd207018ee28cb28$export$2a59f05123189784 = '__rjsf_ref';
const $cd207018ee28cb28$export$8a468b2f7e566028 = '$schema';
const $cd207018ee28cb28$export$fc1a2685f60ab9ef = 'root';
const $cd207018ee28cb28$export$cd88b6b1f03afce9 = '_';
const $cd207018ee28cb28$export$137032ceab080b94 = [
    'discriminator',
    'propertyName'
];
const $cd207018ee28cb28$export$ca7529cc4a51f890 = 'formContext';
const $cd207018ee28cb28$export$51524a5519b64d38 = 'layoutGridLookupMap';
const $cd207018ee28cb28$export$379f2e8c0717b331 = '__rjsf_additionalProperties';
const $cd207018ee28cb28$export$4f0f58ec8c545f3 = '__rjsf_rootSchema';
const $cd207018ee28cb28$export$3ee4d15a1e25438d = 'ui:field';
const $cd207018ee28cb28$export$6d66d36e6bc18c7c = 'ui:widget';
const $cd207018ee28cb28$export$61fb14aaf7aef60f = 'ui:options';
const $cd207018ee28cb28$export$c777bab3d600699 = 'ui:globalOptions';
const $cd207018ee28cb28$export$22333fc592b2ecf6 = 'ui:definitions';
const $cd207018ee28cb28$export$dcb10e91e0226750 = 'https://json-schema.org/draft/2019-09/schema';
const $cd207018ee28cb28$export$aea1c08d06ae9175 = 'https://json-schema.org/draft/2020-12/schema';



function $ac37610e58ee493c$export$2e2bcd8739ae039(uiSchema = {}, globalOptions = {}) {
    // Handle null or undefined uiSchema
    if (!uiSchema) return {
        ...globalOptions
    };
    return Object.keys(uiSchema).filter((key)=>key.startsWith('ui:')).reduce((options, key)=>{
        const value = uiSchema[key];
        if (key === (0, $cd207018ee28cb28$export$6d66d36e6bc18c7c) && (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(value)) {
            // oxlint-disable-next-line no-console
            console.error('Setting options via ui:widget object is no longer supported, use ui:options instead');
            return options;
        }
        if (key === (0, $cd207018ee28cb28$export$61fb14aaf7aef60f) && (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(value)) return {
            ...options,
            ...value
        };
        return {
            ...options,
            [key.substring(3)]: value
        };
    }, {
        ...globalOptions
    });
}


function $ec95fb101af801c1$export$2e2bcd8739ae039(schema, uiSchema = {}, formData) {
    if (!(schema.additionalProperties || schema.patternProperties)) return false;
    const { expandable: expandable = true } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    if (expandable === false) return expandable;
    // if ui:options.expandable was not explicitly set to false, we can add
    // another property if we have not exceeded maxProperties yet
    if (schema.maxProperties !== undefined && formData) return Object.keys(formData).length < schema.maxProperties;
    return true;
}



var $h5jK2 = parcelRequire("h5jK2");
/** Built-in value references. */ var $899304693344e559$var$Symbol = (0, $h5jK2.default).Symbol;
var $899304693344e559$export$2e2bcd8739ae039 = $899304693344e559$var$Symbol;



/** Used for built-in method references. */ var $a59cae000a927cb8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a59cae000a927cb8$var$hasOwnProperty = $a59cae000a927cb8$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a59cae000a927cb8$var$nativeObjectToString = $a59cae000a927cb8$var$objectProto.toString;
/** Built-in value references. */ var $a59cae000a927cb8$var$symToStringTag = (0, $899304693344e559$export$2e2bcd8739ae039) ? (0, $899304693344e559$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $a59cae000a927cb8$var$getRawTag(value) {
    var isOwn = $a59cae000a927cb8$var$hasOwnProperty.call(value, $a59cae000a927cb8$var$symToStringTag), tag = value[$a59cae000a927cb8$var$symToStringTag];
    try {
        value[$a59cae000a927cb8$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $a59cae000a927cb8$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$a59cae000a927cb8$var$symToStringTag] = tag;
        else delete value[$a59cae000a927cb8$var$symToStringTag];
    }
    return result;
}
var $a59cae000a927cb8$export$2e2bcd8739ae039 = $a59cae000a927cb8$var$getRawTag;


/** Used for built-in method references. */ var $53294069a9fe7368$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $53294069a9fe7368$var$nativeObjectToString = $53294069a9fe7368$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $53294069a9fe7368$var$objectToString(value) {
    return $53294069a9fe7368$var$nativeObjectToString.call(value);
}
var $53294069a9fe7368$export$2e2bcd8739ae039 = $53294069a9fe7368$var$objectToString;


/** `Object#toString` result references. */ var $95eecc554ecfdc33$var$nullTag = '[object Null]', $95eecc554ecfdc33$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $95eecc554ecfdc33$var$symToStringTag = (0, $899304693344e559$export$2e2bcd8739ae039) ? (0, $899304693344e559$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $95eecc554ecfdc33$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $95eecc554ecfdc33$var$undefinedTag : $95eecc554ecfdc33$var$nullTag;
    return $95eecc554ecfdc33$var$symToStringTag && $95eecc554ecfdc33$var$symToStringTag in Object(value) ? (0, $a59cae000a927cb8$export$2e2bcd8739ae039)(value) : (0, $53294069a9fe7368$export$2e2bcd8739ae039)(value);
}
var $95eecc554ecfdc33$export$2e2bcd8739ae039 = $95eecc554ecfdc33$var$baseGetTag;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $9f9ef0af16734d0c$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $9f9ef0af16734d0c$export$2e2bcd8739ae039 = $9f9ef0af16734d0c$var$overArg;


/** Built-in value references. */ var $0b14821d94ad35ef$var$getPrototype = (0, $9f9ef0af16734d0c$export$2e2bcd8739ae039)(Object.getPrototypeOf, Object);
var $0b14821d94ad35ef$export$2e2bcd8739ae039 = $0b14821d94ad35ef$var$getPrototype;


/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $754274dccdb4db10$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $754274dccdb4db10$export$2e2bcd8739ae039 = $754274dccdb4db10$var$isObjectLike;


/** `Object#toString` result references. */ var $d6bfaab5809eb5e3$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $d6bfaab5809eb5e3$var$funcProto = Function.prototype, $d6bfaab5809eb5e3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $d6bfaab5809eb5e3$var$funcToString = $d6bfaab5809eb5e3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $d6bfaab5809eb5e3$var$hasOwnProperty = $d6bfaab5809eb5e3$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $d6bfaab5809eb5e3$var$objectCtorString = $d6bfaab5809eb5e3$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $d6bfaab5809eb5e3$var$isPlainObject(value) {
    if (!(0, $754274dccdb4db10$export$2e2bcd8739ae039)(value) || (0, $95eecc554ecfdc33$export$2e2bcd8739ae039)(value) != $d6bfaab5809eb5e3$var$objectTag) return false;
    var proto = (0, $0b14821d94ad35ef$export$2e2bcd8739ae039)(value);
    if (proto === null) return true;
    var Ctor = $d6bfaab5809eb5e3$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $d6bfaab5809eb5e3$var$funcToString.call(Ctor) == $d6bfaab5809eb5e3$var$objectCtorString;
}
var $d6bfaab5809eb5e3$export$2e2bcd8739ae039 = $d6bfaab5809eb5e3$var$isPlainObject;



function $3d3c7c1156fce055$export$2e2bcd8739ae039(formData) {
    const handler = {
        // We store the list of errors for this node in a property named __errors
        // to avoid name collision with a possible sub schema field named
        // 'errors' (see `utils.toErrorSchema`).
        [(0, $cd207018ee28cb28$export$36fec1b8ab257149)]: [],
        addError (message) {
            this[0, $cd207018ee28cb28$export$36fec1b8ab257149].push(message);
        }
    };
    if (Array.isArray(formData)) return formData.reduce((acc, value, key)=>({
            ...acc,
            [key]: $3d3c7c1156fce055$export$2e2bcd8739ae039(value)
        }), handler);
    if ((0, $d6bfaab5809eb5e3$export$2e2bcd8739ae039)(formData)) {
        const formObject = formData;
        return Object.keys(formObject).reduce((acc, key)=>({
                ...acc,
                [key]: $3d3c7c1156fce055$export$2e2bcd8739ae039(formObject[key])
            }), handler);
    }
    return handler;
}


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $44621b626b9ac4b3$var$isArray = Array.isArray;
var $44621b626b9ac4b3$export$2e2bcd8739ae039 = $44621b626b9ac4b3$var$isArray;





/** `Object#toString` result references. */ var $ab251a97c515dcdc$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $ab251a97c515dcdc$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $754274dccdb4db10$export$2e2bcd8739ae039)(value) && (0, $95eecc554ecfdc33$export$2e2bcd8739ae039)(value) == $ab251a97c515dcdc$var$symbolTag;
}
var $ab251a97c515dcdc$export$2e2bcd8739ae039 = $ab251a97c515dcdc$var$isSymbol;


/** Used to match property names within property paths. */ var $5ff13a12e3e7316f$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $5ff13a12e3e7316f$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $5ff13a12e3e7316f$var$isKey(value, object) {
    if ((0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, $ab251a97c515dcdc$export$2e2bcd8739ae039)(value)) return true;
    return $5ff13a12e3e7316f$var$reIsPlainProp.test(value) || !$5ff13a12e3e7316f$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $5ff13a12e3e7316f$export$2e2bcd8739ae039 = $5ff13a12e3e7316f$var$isKey;



/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $d252d56fd76f41df$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $d252d56fd76f41df$export$2e2bcd8739ae039 = $d252d56fd76f41df$var$isObject;


/** `Object#toString` result references. */ var $e8276fc8779dcffd$var$asyncTag = '[object AsyncFunction]', $e8276fc8779dcffd$var$funcTag = '[object Function]', $e8276fc8779dcffd$var$genTag = '[object GeneratorFunction]', $e8276fc8779dcffd$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $e8276fc8779dcffd$var$isFunction(value) {
    if (!(0, $d252d56fd76f41df$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $95eecc554ecfdc33$export$2e2bcd8739ae039)(value);
    return tag == $e8276fc8779dcffd$var$funcTag || tag == $e8276fc8779dcffd$var$genTag || tag == $e8276fc8779dcffd$var$asyncTag || tag == $e8276fc8779dcffd$var$proxyTag;
}
var $e8276fc8779dcffd$export$2e2bcd8739ae039 = $e8276fc8779dcffd$var$isFunction;



var $h5jK2 = parcelRequire("h5jK2");
/** Used to detect overreaching core-js shims. */ var $5cad08b51a0e5240$var$coreJsData = (0, $h5jK2.default)['__core-js_shared__'];
var $5cad08b51a0e5240$export$2e2bcd8739ae039 = $5cad08b51a0e5240$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $55a4ece47f997819$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $5cad08b51a0e5240$export$2e2bcd8739ae039) && (0, $5cad08b51a0e5240$export$2e2bcd8739ae039).keys && (0, $5cad08b51a0e5240$export$2e2bcd8739ae039).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $55a4ece47f997819$var$isMasked(func) {
    return !!$55a4ece47f997819$var$maskSrcKey && $55a4ece47f997819$var$maskSrcKey in func;
}
var $55a4ece47f997819$export$2e2bcd8739ae039 = $55a4ece47f997819$var$isMasked;



/** Used for built-in method references. */ var $f39458f3848c447f$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $f39458f3848c447f$var$funcToString = $f39458f3848c447f$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $f39458f3848c447f$var$toSource(func) {
    if (func != null) {
        try {
            return $f39458f3848c447f$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $f39458f3848c447f$export$2e2bcd8739ae039 = $f39458f3848c447f$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $7225c0ee78d8ee44$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $7225c0ee78d8ee44$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $7225c0ee78d8ee44$var$funcProto = Function.prototype, $7225c0ee78d8ee44$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $7225c0ee78d8ee44$var$funcToString = $7225c0ee78d8ee44$var$funcProto.toString;
/** Used to check objects for own properties. */ var $7225c0ee78d8ee44$var$hasOwnProperty = $7225c0ee78d8ee44$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $7225c0ee78d8ee44$var$reIsNative = RegExp('^' + $7225c0ee78d8ee44$var$funcToString.call($7225c0ee78d8ee44$var$hasOwnProperty).replace($7225c0ee78d8ee44$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $7225c0ee78d8ee44$var$baseIsNative(value) {
    if (!(0, $d252d56fd76f41df$export$2e2bcd8739ae039)(value) || (0, $55a4ece47f997819$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $e8276fc8779dcffd$export$2e2bcd8739ae039)(value) ? $7225c0ee78d8ee44$var$reIsNative : $7225c0ee78d8ee44$var$reIsHostCtor;
    return pattern.test((0, $f39458f3848c447f$export$2e2bcd8739ae039)(value));
}
var $7225c0ee78d8ee44$export$2e2bcd8739ae039 = $7225c0ee78d8ee44$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $9506d48d8f6f64c7$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $9506d48d8f6f64c7$export$2e2bcd8739ae039 = $9506d48d8f6f64c7$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $3681d891f519dfa0$var$getNative(object, key) {
    var value = (0, $9506d48d8f6f64c7$export$2e2bcd8739ae039)(object, key);
    return (0, $7225c0ee78d8ee44$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $3681d891f519dfa0$export$2e2bcd8739ae039 = $3681d891f519dfa0$var$getNative;


/* Built-in method references that are verified to be native. */ var $f300f48025fab692$var$nativeCreate = (0, $3681d891f519dfa0$export$2e2bcd8739ae039)(Object, 'create');
var $f300f48025fab692$export$2e2bcd8739ae039 = $f300f48025fab692$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $e07135e63884a120$var$hashClear() {
    this.__data__ = (0, $f300f48025fab692$export$2e2bcd8739ae039) ? (0, $f300f48025fab692$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $e07135e63884a120$export$2e2bcd8739ae039 = $e07135e63884a120$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2713c9b61372d697$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $2713c9b61372d697$export$2e2bcd8739ae039 = $2713c9b61372d697$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $dadd0ff055828caf$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $dadd0ff055828caf$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dadd0ff055828caf$var$hasOwnProperty = $dadd0ff055828caf$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $dadd0ff055828caf$var$hashGet(key) {
    var data = this.__data__;
    if (0, $f300f48025fab692$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $dadd0ff055828caf$var$HASH_UNDEFINED ? undefined : result;
    }
    return $dadd0ff055828caf$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $dadd0ff055828caf$export$2e2bcd8739ae039 = $dadd0ff055828caf$var$hashGet;



/** Used for built-in method references. */ var $b4d602dd09a4161e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b4d602dd09a4161e$var$hasOwnProperty = $b4d602dd09a4161e$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b4d602dd09a4161e$var$hashHas(key) {
    var data = this.__data__;
    return (0, $f300f48025fab692$export$2e2bcd8739ae039) ? data[key] !== undefined : $b4d602dd09a4161e$var$hasOwnProperty.call(data, key);
}
var $b4d602dd09a4161e$export$2e2bcd8739ae039 = $b4d602dd09a4161e$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $6466e509a795e300$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $6466e509a795e300$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $f300f48025fab692$export$2e2bcd8739ae039) && value === undefined ? $6466e509a795e300$var$HASH_UNDEFINED : value;
    return this;
}
var $6466e509a795e300$export$2e2bcd8739ae039 = $6466e509a795e300$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $2eb9208e73236fa0$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$2eb9208e73236fa0$var$Hash.prototype.clear = (0, $e07135e63884a120$export$2e2bcd8739ae039);
$2eb9208e73236fa0$var$Hash.prototype['delete'] = (0, $2713c9b61372d697$export$2e2bcd8739ae039);
$2eb9208e73236fa0$var$Hash.prototype.get = (0, $dadd0ff055828caf$export$2e2bcd8739ae039);
$2eb9208e73236fa0$var$Hash.prototype.has = (0, $b4d602dd09a4161e$export$2e2bcd8739ae039);
$2eb9208e73236fa0$var$Hash.prototype.set = (0, $6466e509a795e300$export$2e2bcd8739ae039);
var $2eb9208e73236fa0$export$2e2bcd8739ae039 = $2eb9208e73236fa0$var$Hash;


/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $741992dc6ad60eab$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $741992dc6ad60eab$export$2e2bcd8739ae039 = $741992dc6ad60eab$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $b65447e8fe19238e$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $b65447e8fe19238e$export$2e2bcd8739ae039 = $b65447e8fe19238e$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d9238284100517ce$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $b65447e8fe19238e$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $d9238284100517ce$export$2e2bcd8739ae039 = $d9238284100517ce$var$assocIndexOf;


/** Used for built-in method references. */ var $7c8b6535aecdc6ab$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $7c8b6535aecdc6ab$var$splice = $7c8b6535aecdc6ab$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7c8b6535aecdc6ab$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $d9238284100517ce$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $7c8b6535aecdc6ab$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $7c8b6535aecdc6ab$export$2e2bcd8739ae039 = $7c8b6535aecdc6ab$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d242e7ebd1907027$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $d9238284100517ce$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $d242e7ebd1907027$export$2e2bcd8739ae039 = $d242e7ebd1907027$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b0a2efe54c0c3441$var$listCacheHas(key) {
    return (0, $d9238284100517ce$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $b0a2efe54c0c3441$export$2e2bcd8739ae039 = $b0a2efe54c0c3441$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $b7334ddf8130207e$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $d9238284100517ce$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $b7334ddf8130207e$export$2e2bcd8739ae039 = $b7334ddf8130207e$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $acf191f2a41c5d82$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$acf191f2a41c5d82$var$ListCache.prototype.clear = (0, $741992dc6ad60eab$export$2e2bcd8739ae039);
$acf191f2a41c5d82$var$ListCache.prototype['delete'] = (0, $7c8b6535aecdc6ab$export$2e2bcd8739ae039);
$acf191f2a41c5d82$var$ListCache.prototype.get = (0, $d242e7ebd1907027$export$2e2bcd8739ae039);
$acf191f2a41c5d82$var$ListCache.prototype.has = (0, $b0a2efe54c0c3441$export$2e2bcd8739ae039);
$acf191f2a41c5d82$var$ListCache.prototype.set = (0, $b7334ddf8130207e$export$2e2bcd8739ae039);
var $acf191f2a41c5d82$export$2e2bcd8739ae039 = $acf191f2a41c5d82$var$ListCache;




var $h5jK2 = parcelRequire("h5jK2");
/* Built-in method references that are verified to be native. */ var $59b6286b0bf4bde0$var$Map = (0, $3681d891f519dfa0$export$2e2bcd8739ae039)((0, $h5jK2.default), 'Map');
var $59b6286b0bf4bde0$export$2e2bcd8739ae039 = $59b6286b0bf4bde0$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $f1103b3e3a051b29$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $2eb9208e73236fa0$export$2e2bcd8739ae039),
        'map': new ((0, $59b6286b0bf4bde0$export$2e2bcd8739ae039) || (0, $acf191f2a41c5d82$export$2e2bcd8739ae039)),
        'string': new (0, $2eb9208e73236fa0$export$2e2bcd8739ae039)
    };
}
var $f1103b3e3a051b29$export$2e2bcd8739ae039 = $f1103b3e3a051b29$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $dd6193d0fb68acbf$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $dd6193d0fb68acbf$export$2e2bcd8739ae039 = $dd6193d0fb68acbf$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $8ff4a334ec834474$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $dd6193d0fb68acbf$export$2e2bcd8739ae039)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $8ff4a334ec834474$export$2e2bcd8739ae039 = $8ff4a334ec834474$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $820a170966aaf53e$var$mapCacheDelete(key) {
    var result = (0, $8ff4a334ec834474$export$2e2bcd8739ae039)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $820a170966aaf53e$export$2e2bcd8739ae039 = $820a170966aaf53e$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $82e5d1a7e81ea3e0$var$mapCacheGet(key) {
    return (0, $8ff4a334ec834474$export$2e2bcd8739ae039)(this, key).get(key);
}
var $82e5d1a7e81ea3e0$export$2e2bcd8739ae039 = $82e5d1a7e81ea3e0$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $60b4b2f078bba703$var$mapCacheHas(key) {
    return (0, $8ff4a334ec834474$export$2e2bcd8739ae039)(this, key).has(key);
}
var $60b4b2f078bba703$export$2e2bcd8739ae039 = $60b4b2f078bba703$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $befbcb6f87d89535$var$mapCacheSet(key, value) {
    var data = (0, $8ff4a334ec834474$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $befbcb6f87d89535$export$2e2bcd8739ae039 = $befbcb6f87d89535$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9935e83a362a1d93$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$9935e83a362a1d93$var$MapCache.prototype.clear = (0, $f1103b3e3a051b29$export$2e2bcd8739ae039);
$9935e83a362a1d93$var$MapCache.prototype['delete'] = (0, $820a170966aaf53e$export$2e2bcd8739ae039);
$9935e83a362a1d93$var$MapCache.prototype.get = (0, $82e5d1a7e81ea3e0$export$2e2bcd8739ae039);
$9935e83a362a1d93$var$MapCache.prototype.has = (0, $60b4b2f078bba703$export$2e2bcd8739ae039);
$9935e83a362a1d93$var$MapCache.prototype.set = (0, $befbcb6f87d89535$export$2e2bcd8739ae039);
var $9935e83a362a1d93$export$2e2bcd8739ae039 = $9935e83a362a1d93$var$MapCache;


/** Error message constants. */ var $3a4efc6f8eb4278f$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $3a4efc6f8eb4278f$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($3a4efc6f8eb4278f$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($3a4efc6f8eb4278f$var$memoize.Cache || (0, $9935e83a362a1d93$export$2e2bcd8739ae039));
    return memoized;
}
// Expose `MapCache`.
$3a4efc6f8eb4278f$var$memoize.Cache = (0, $9935e83a362a1d93$export$2e2bcd8739ae039);
var $3a4efc6f8eb4278f$export$2e2bcd8739ae039 = $3a4efc6f8eb4278f$var$memoize;


/** Used as the maximum memoize cache size. */ var $bf15eb7128a3cea8$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $bf15eb7128a3cea8$var$memoizeCapped(func) {
    var result = (0, $3a4efc6f8eb4278f$export$2e2bcd8739ae039)(func, function(key) {
        if (cache.size === $bf15eb7128a3cea8$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $bf15eb7128a3cea8$export$2e2bcd8739ae039 = $bf15eb7128a3cea8$var$memoizeCapped;


/** Used to match property names within property paths. */ var $89ea575de9e34a82$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $89ea575de9e34a82$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $89ea575de9e34a82$var$stringToPath = (0, $bf15eb7128a3cea8$export$2e2bcd8739ae039)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($89ea575de9e34a82$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($89ea575de9e34a82$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $89ea575de9e34a82$export$2e2bcd8739ae039 = $89ea575de9e34a82$var$stringToPath;



/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $a8b30b77f2b6a1c4$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $a8b30b77f2b6a1c4$export$2e2bcd8739ae039 = $a8b30b77f2b6a1c4$var$arrayMap;




/** Used as references for various `Number` constants. */ var $23e26e8eb248aad5$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $23e26e8eb248aad5$var$symbolProto = (0, $899304693344e559$export$2e2bcd8739ae039) ? (0, $899304693344e559$export$2e2bcd8739ae039).prototype : undefined, $23e26e8eb248aad5$var$symbolToString = $23e26e8eb248aad5$var$symbolProto ? $23e26e8eb248aad5$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $23e26e8eb248aad5$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $a8b30b77f2b6a1c4$export$2e2bcd8739ae039)(value, $23e26e8eb248aad5$var$baseToString) + '';
    if ((0, $ab251a97c515dcdc$export$2e2bcd8739ae039)(value)) return $23e26e8eb248aad5$var$symbolToString ? $23e26e8eb248aad5$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$23e26e8eb248aad5$var$INFINITY ? '-0' : result;
}
var $23e26e8eb248aad5$export$2e2bcd8739ae039 = $23e26e8eb248aad5$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $26fb36591628d13f$var$toString(value) {
    return value == null ? '' : (0, $23e26e8eb248aad5$export$2e2bcd8739ae039)(value);
}
var $26fb36591628d13f$export$2e2bcd8739ae039 = $26fb36591628d13f$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $550dd133df69fd0b$var$castPath(value, object) {
    if ((0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(value)) return value;
    return (0, $5ff13a12e3e7316f$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $89ea575de9e34a82$export$2e2bcd8739ae039)((0, $26fb36591628d13f$export$2e2bcd8739ae039)(value));
}
var $550dd133df69fd0b$export$2e2bcd8739ae039 = $550dd133df69fd0b$var$castPath;



/** Used as references for various `Number` constants. */ var $031a2cbe9b26e09a$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $031a2cbe9b26e09a$var$toKey(value) {
    if (typeof value == 'string' || (0, $ab251a97c515dcdc$export$2e2bcd8739ae039)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$031a2cbe9b26e09a$var$INFINITY ? '-0' : result;
}
var $031a2cbe9b26e09a$export$2e2bcd8739ae039 = $031a2cbe9b26e09a$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $f82e6a7e1b9a1d35$var$baseGet(object, path) {
    path = (0, $550dd133df69fd0b$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $031a2cbe9b26e09a$export$2e2bcd8739ae039)(path[index++])];
    return index && index == length ? object : undefined;
}
var $f82e6a7e1b9a1d35$export$2e2bcd8739ae039 = $f82e6a7e1b9a1d35$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $547524a1010b9f1e$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $f82e6a7e1b9a1d35$export$2e2bcd8739ae039)(object, path);
    return result === undefined ? defaultValue : result;
}
var $547524a1010b9f1e$export$2e2bcd8739ae039 = $547524a1010b9f1e$var$get;



const { getOwnPropertyNames: $821d8a96f52548fd$var$getOwnPropertyNames, getOwnPropertySymbols: $821d8a96f52548fd$var$getOwnPropertySymbols } = Object;
// eslint-disable-next-line @typescript-eslint/unbound-method
const { hasOwnProperty: $821d8a96f52548fd$var$hasOwnProperty } = Object.prototype;
/**
 * Combine two comparators into a single comparators.
 */ function $821d8a96f52548fd$var$combineComparators(comparatorA, comparatorB) {
    return function isEqual(a, b, state) {
        return comparatorA(a, b, state) && comparatorB(a, b, state);
    };
}
/**
 * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
 * for circular references to be safely included in the comparison without creating
 * stack overflows.
 */ function $821d8a96f52548fd$var$createIsCircular(areItemsEqual) {
    return function isCircular(a, b, state) {
        if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
        const { cache: cache } = state;
        const cachedA = cache.get(a);
        const cachedB = cache.get(b);
        if (cachedA && cachedB) return cachedA === b && cachedB === a;
        cache.set(a, b);
        cache.set(b, a);
        const result = areItemsEqual(a, b, state);
        cache.delete(a);
        cache.delete(b);
        return result;
    };
}
/**
 * Get the properties to strictly examine, which include both own properties that are
 * not enumerable and symbol properties.
 */ function $821d8a96f52548fd$var$getStrictProperties(object) {
    return $821d8a96f52548fd$var$getOwnPropertyNames(object).concat($821d8a96f52548fd$var$getOwnPropertySymbols(object));
}
/**
 * Whether the object contains the property passed as an own property.
 */ const $821d8a96f52548fd$var$hasOwn = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
Object.hasOwn || ((object, property)=>$821d8a96f52548fd$var$hasOwnProperty.call(object, property));
const $821d8a96f52548fd$var$PREACT_VNODE = '__v';
const $821d8a96f52548fd$var$PREACT_OWNER = '__o';
const $821d8a96f52548fd$var$REACT_OWNER = '_owner';
const { getOwnPropertyDescriptor: $821d8a96f52548fd$var$getOwnPropertyDescriptor, keys: $821d8a96f52548fd$var$keys } = Object;
/**
 * Whether the values passed are equal based on a [SameValue](https://262.ecma-international.org/7.0/#sec-samevalue) basis.
 * Simplified, this maps to if the two values are referentially equal to one another (`a === b`) or both are `NaN`.
 *
 * @note
 * When available in the environment, this is just a re-export of the global
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is) method.
 */ const $821d8a96f52548fd$export$671a9ea699133b99 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
Object.is || function sameValueEqual(a, b) {
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
};
/**
 * Whether the values passed are equal based on a [SameValue](https://262.ecma-international.org/7.0/#sec-samevaluezero) basis.
 * Simplified, this maps to if the two values are referentially equal to one another (`a === b`), both are `NaN`, or both
 * are either positive or negative zero.
 */ function $821d8a96f52548fd$export$394d149ccaecc68f(a, b) {
    return a === b || a !== a && b !== b;
}
/**
 * Whether the values passed are equal based on a
 * [Strict Equality Comparison](https://262.ecma-international.org/7.0/#sec-strict-equality-comparison) basis.
 * Simplified, this maps to if the two values are referentially equal to one another (`a === b`).
 *
 * @note
 * This is mainly available as a convenience function, such as being a default when a function to determine equality between
 * two objects is used.
 */ function $821d8a96f52548fd$export$24d177074f8dc6ef(a, b) {
    return a === b;
}
/**
 * Whether the array buffers are equal in value.
 */ function $821d8a96f52548fd$var$areArrayBuffersEqual(a, b) {
    return a.byteLength === b.byteLength && $821d8a96f52548fd$var$areTypedArraysEqual(new Uint8Array(a), new Uint8Array(b));
}
/**
 * Whether the arrays are equal in value.
 */ function $821d8a96f52548fd$var$areArraysEqual(a, b, state) {
    let index = a.length;
    if (b.length !== index) return false;
    while(index-- > 0){
        if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
    }
    return true;
}
/**
 * Whether the dataviews are equal in value.
 */ function $821d8a96f52548fd$var$areDataViewsEqual(a, b) {
    return a.byteLength === b.byteLength && $821d8a96f52548fd$var$areTypedArraysEqual(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength));
}
/**
 * Whether the dates passed are equal in value.
 */ function $821d8a96f52548fd$var$areDatesEqual(a, b) {
    return $821d8a96f52548fd$export$671a9ea699133b99(a.getTime(), b.getTime());
}
/**
 * Whether the errors passed are equal in value.
 */ function $821d8a96f52548fd$var$areErrorsEqual(a, b) {
    return a.name === b.name && a.message === b.message && a.cause === b.cause && a.stack === b.stack;
}
/**
 * Whether the `Map`s are equal in value.
 */ function $821d8a96f52548fd$var$areMapsEqual(a, b, state) {
    const size = a.size;
    if (size !== b.size) return false;
    if (!size) return true;
    const matchedIndices = new Array(size);
    const aIterable = a.entries();
    let aResult;
    let bResult;
    let index = 0;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    while(aResult = aIterable.next()){
        if (aResult.done) break;
        const bIterable = b.entries();
        let hasMatch = false;
        let matchIndex = 0;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while(bResult = bIterable.next()){
            if (bResult.done) break;
            if (matchedIndices[matchIndex]) {
                matchIndex++;
                continue;
            }
            const aEntry = aResult.value;
            const bEntry = bResult.value;
            if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
                hasMatch = matchedIndices[matchIndex] = true;
                break;
            }
            matchIndex++;
        }
        if (!hasMatch) return false;
        index++;
    }
    return true;
}
/**
 * Whether the objects are equal in value.
 */ function $821d8a96f52548fd$var$areObjectsEqual(a, b, state) {
    const properties = $821d8a96f52548fd$var$keys(a);
    let index = properties.length;
    if ($821d8a96f52548fd$var$keys(b).length !== index) return false;
    // Decrementing `while` showed faster results than either incrementing or
    // decrementing `for` loop and than an incrementing `while` loop. Declarative
    // methods like `some` / `every` were not used to avoid incurring the garbage
    // cost of anonymous callbacks.
    while(index-- > 0){
        if (!$821d8a96f52548fd$var$isPropertyEqual(a, b, state, properties[index])) return false;
    }
    return true;
}
/**
 * Whether the objects are equal in value with strict property checking.
 */ function $821d8a96f52548fd$var$areObjectsEqualStrict(a, b, state) {
    const properties = $821d8a96f52548fd$var$getStrictProperties(a);
    let index = properties.length;
    if ($821d8a96f52548fd$var$getStrictProperties(b).length !== index) return false;
    let property;
    let descriptorA;
    let descriptorB;
    // Decrementing `while` showed faster results than either incrementing or
    // decrementing `for` loop and than an incrementing `while` loop. Declarative
    // methods like `some` / `every` were not used to avoid incurring the garbage
    // cost of anonymous callbacks.
    while(index-- > 0){
        property = properties[index];
        if (!$821d8a96f52548fd$var$isPropertyEqual(a, b, state, property)) return false;
        descriptorA = $821d8a96f52548fd$var$getOwnPropertyDescriptor(a, property);
        descriptorB = $821d8a96f52548fd$var$getOwnPropertyDescriptor(b, property);
        if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
    }
    return true;
}
/**
 * Whether the primitive wrappers passed are equal in value.
 */ function $821d8a96f52548fd$var$arePrimitiveWrappersEqual(a, b) {
    return $821d8a96f52548fd$export$671a9ea699133b99(a.valueOf(), b.valueOf());
}
/**
 * Whether the regexps passed are equal in value.
 */ function $821d8a96f52548fd$var$areRegExpsEqual(a, b) {
    return a.source === b.source && a.flags === b.flags;
}
/**
 * Whether the `Set`s are equal in value.
 */ function $821d8a96f52548fd$var$areSetsEqual(a, b, state) {
    const size = a.size;
    if (size !== b.size) return false;
    if (!size) return true;
    const matchedIndices = new Array(size);
    const aIterable = a.values();
    let aResult;
    let bResult;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    while(aResult = aIterable.next()){
        if (aResult.done) break;
        const bIterable = b.values();
        let hasMatch = false;
        let matchIndex = 0;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while(bResult = bIterable.next()){
            if (bResult.done) break;
            if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
                hasMatch = matchedIndices[matchIndex] = true;
                break;
            }
            matchIndex++;
        }
        if (!hasMatch) return false;
    }
    return true;
}
/**
 * Whether the TypedArray instances are equal in value.
 */ function $821d8a96f52548fd$var$areTypedArraysEqual(a, b) {
    let index = a.byteLength;
    if (b.byteLength !== index || a.byteOffset !== b.byteOffset) return false;
    while(index-- > 0){
        if (a[index] !== b[index]) return false;
    }
    return true;
}
/**
 * Whether the URL instances are equal in value.
 */ function $821d8a96f52548fd$var$areUrlsEqual(a, b) {
    return a.hostname === b.hostname && a.pathname === b.pathname && a.protocol === b.protocol && a.port === b.port && a.hash === b.hash && a.username === b.username && a.password === b.password;
}
function $821d8a96f52548fd$var$isPropertyEqual(a, b, state, property) {
    if ((property === $821d8a96f52548fd$var$REACT_OWNER || property === $821d8a96f52548fd$var$PREACT_OWNER || property === $821d8a96f52548fd$var$PREACT_VNODE) && (a.$$typeof || b.$$typeof)) return true;
    return $821d8a96f52548fd$var$hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
}
// eslint-disable-next-line @typescript-eslint/unbound-method
const $821d8a96f52548fd$var$toString = Object.prototype.toString;
/**
 * Create a comparator method based on the type-specific equality comparators passed.
 */ function $821d8a96f52548fd$var$createEqualityComparator(config) {
    const supportedComparatorMap = $821d8a96f52548fd$var$createSupportedComparatorMap(config);
    const { areArraysEqual: areArraysEqual, areDatesEqual: areDatesEqual, areFunctionsEqual: areFunctionsEqual, areMapsEqual: areMapsEqual, areNumbersEqual: areNumbersEqual, areObjectsEqual: areObjectsEqual, areRegExpsEqual: areRegExpsEqual, areSetsEqual: areSetsEqual, getUnsupportedCustomComparator: getUnsupportedCustomComparator } = config;
    /**
     * compare the value of the two objects and return true if they are equivalent in values
     */ return function comparator(a, b, state) {
        // If the items are strictly equal, no need to do a value comparison.
        if (a === b) return true;
        // If either of the items are nullish and fail the strictly equal check
        // above, then they must be unequal.
        if (a == null || b == null) return false;
        const type = typeof a;
        if (type !== typeof b) return false;
        if (type !== 'object') {
            if (type === 'number' || type === 'bigint') return areNumbersEqual(a, b, state);
            if (type === 'function') return areFunctionsEqual(a, b, state);
            // If a primitive value that is not strictly equal, it must be unequal.
            return false;
        }
        const constructor = a.constructor;
        // Checks are listed in order of commonality of use-case:
        //   1. Common complex object types (plain object, array)
        //   2. Common data values (date, regexp)
        //   3. Less-common complex object types (map, set)
        //   4. Less-common data values (promise, primitive wrappers)
        // Inherently this is both subjective and assumptive, however
        // when reviewing comparable libraries in the wild this order
        // appears to be generally consistent.
        // Constructors should match, otherwise there is potential for false positives
        // between class and subclass or custom object and POJO.
        if (constructor !== b.constructor) return false;
        // Try to fast-path equality checks for other complex object types in the
        // same realm to avoid capturing the string tag. Strict equality is used
        // instead of `instanceof` because it is more performant for the common
        // use-case. If someone is creating a subclass from a native class, it will be
        // handled with the string tag comparison.
        if (constructor === Object) return areObjectsEqual(a, b, state);
        if (constructor === Array) return areArraysEqual(a, b, state);
        if (constructor === Date) return areDatesEqual(a, b, state);
        if (constructor === RegExp) return areRegExpsEqual(a, b, state);
        if (constructor === Map) return areMapsEqual(a, b, state);
        if (constructor === Set) return areSetsEqual(a, b, state);
        if (constructor === Promise) // Avoid tag checks for promise values, since we know if they are not referentially equal
        // then they are not equal.
        return false;
        // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
        // the string tag or doing an `instanceof` in edge cases.
        if (Array.isArray(a)) return areArraysEqual(a, b, state);
        // Since this is a custom object, capture the string tag to determining its type.
        // This is reasonably performant in modern environments like v8 and SpiderMonkey.
        const tag = $821d8a96f52548fd$var$toString.call(a);
        const supportedComparator = supportedComparatorMap[tag];
        if (supportedComparator) return supportedComparator(a, b, state);
        const unsupportedCustomComparator = getUnsupportedCustomComparator && getUnsupportedCustomComparator(a, b, state, tag);
        if (unsupportedCustomComparator) return unsupportedCustomComparator(a, b, state);
        // If not matching any tags that require a specific type of comparison, then we hard-code false because
        // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
        //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
        //     comparison that can be made.
        //   - For types that can be introspected but do not have an objective definition of what
        //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
        // In all cases, these decisions should be reevaluated based on changes to the language and
        // common development practices.
        return false;
    };
}
/**
 * Create the configuration object used for building comparators.
 */ function $821d8a96f52548fd$var$createEqualityComparatorConfig({ circular: circular, createCustomConfig: createCustomConfig, strict: strict }) {
    let config = {
        areArrayBuffersEqual: $821d8a96f52548fd$var$areArrayBuffersEqual,
        areArraysEqual: strict ? $821d8a96f52548fd$var$areObjectsEqualStrict : $821d8a96f52548fd$var$areArraysEqual,
        areDataViewsEqual: $821d8a96f52548fd$var$areDataViewsEqual,
        areDatesEqual: $821d8a96f52548fd$var$areDatesEqual,
        areErrorsEqual: $821d8a96f52548fd$var$areErrorsEqual,
        areFunctionsEqual: $821d8a96f52548fd$export$24d177074f8dc6ef,
        areMapsEqual: strict ? $821d8a96f52548fd$var$combineComparators($821d8a96f52548fd$var$areMapsEqual, $821d8a96f52548fd$var$areObjectsEqualStrict) : $821d8a96f52548fd$var$areMapsEqual,
        areNumbersEqual: $821d8a96f52548fd$export$671a9ea699133b99,
        areObjectsEqual: strict ? $821d8a96f52548fd$var$areObjectsEqualStrict : $821d8a96f52548fd$var$areObjectsEqual,
        arePrimitiveWrappersEqual: $821d8a96f52548fd$var$arePrimitiveWrappersEqual,
        areRegExpsEqual: $821d8a96f52548fd$var$areRegExpsEqual,
        areSetsEqual: strict ? $821d8a96f52548fd$var$combineComparators($821d8a96f52548fd$var$areSetsEqual, $821d8a96f52548fd$var$areObjectsEqualStrict) : $821d8a96f52548fd$var$areSetsEqual,
        areTypedArraysEqual: strict ? $821d8a96f52548fd$var$combineComparators($821d8a96f52548fd$var$areTypedArraysEqual, $821d8a96f52548fd$var$areObjectsEqualStrict) : $821d8a96f52548fd$var$areTypedArraysEqual,
        areUrlsEqual: $821d8a96f52548fd$var$areUrlsEqual,
        getUnsupportedCustomComparator: undefined
    };
    if (createCustomConfig) config = Object.assign({}, config, createCustomConfig(config));
    if (circular) {
        const areArraysEqual = $821d8a96f52548fd$var$createIsCircular(config.areArraysEqual);
        const areMapsEqual = $821d8a96f52548fd$var$createIsCircular(config.areMapsEqual);
        const areObjectsEqual = $821d8a96f52548fd$var$createIsCircular(config.areObjectsEqual);
        const areSetsEqual = $821d8a96f52548fd$var$createIsCircular(config.areSetsEqual);
        config = Object.assign({}, config, {
            areArraysEqual: areArraysEqual,
            areMapsEqual: areMapsEqual,
            areObjectsEqual: areObjectsEqual,
            areSetsEqual: areSetsEqual
        });
    }
    return config;
}
/**
 * Default equality comparator pass-through, used as the standard `isEqual` creator for
 * use inside the built comparator.
 */ function $821d8a96f52548fd$var$createInternalEqualityComparator(compare) {
    return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
        return compare(a, b, state);
    };
}
/**
 * Create the `isEqual` function used by the consuming application.
 */ function $821d8a96f52548fd$var$createIsEqual({ circular: circular, comparator: comparator, createState: createState, equals: equals, strict: strict }) {
    if (createState) return function isEqual(a, b) {
        const { cache: cache = circular ? new WeakMap() : undefined, meta: meta } = createState();
        return comparator(a, b, {
            cache: cache,
            equals: equals,
            meta: meta,
            strict: strict
        });
    };
    if (circular) return function isEqual(a, b) {
        return comparator(a, b, {
            cache: new WeakMap(),
            equals: equals,
            meta: undefined,
            strict: strict
        });
    };
    const state = {
        cache: undefined,
        equals: equals,
        meta: undefined,
        strict: strict
    };
    return function isEqual(a, b) {
        return comparator(a, b, state);
    };
}
/**
 * Create a map of `toString()` values to their respective handlers for `tag`-based lookups.
 */ function $821d8a96f52548fd$var$createSupportedComparatorMap({ areArrayBuffersEqual: areArrayBuffersEqual, areArraysEqual: areArraysEqual, areDataViewsEqual: areDataViewsEqual, areDatesEqual: areDatesEqual, areErrorsEqual: areErrorsEqual, areFunctionsEqual: areFunctionsEqual, areMapsEqual: areMapsEqual, areNumbersEqual: areNumbersEqual, areObjectsEqual: areObjectsEqual, arePrimitiveWrappersEqual: arePrimitiveWrappersEqual, areRegExpsEqual: areRegExpsEqual, areSetsEqual: areSetsEqual, areTypedArraysEqual: areTypedArraysEqual, areUrlsEqual: areUrlsEqual }) {
    return {
        '[object Arguments]': areObjectsEqual,
        '[object Array]': areArraysEqual,
        '[object ArrayBuffer]': areArrayBuffersEqual,
        '[object AsyncGeneratorFunction]': areFunctionsEqual,
        '[object BigInt]': areNumbersEqual,
        '[object BigInt64Array]': areTypedArraysEqual,
        '[object BigUint64Array]': areTypedArraysEqual,
        '[object Boolean]': arePrimitiveWrappersEqual,
        '[object DataView]': areDataViewsEqual,
        '[object Date]': areDatesEqual,
        // If an error tag, it should be tested explicitly. Like RegExp, the properties are not
        // enumerable, and therefore will give false positives if tested like a standard object.
        '[object Error]': areErrorsEqual,
        '[object Float16Array]': areTypedArraysEqual,
        '[object Float32Array]': areTypedArraysEqual,
        '[object Float64Array]': areTypedArraysEqual,
        '[object Function]': areFunctionsEqual,
        '[object GeneratorFunction]': areFunctionsEqual,
        '[object Int8Array]': areTypedArraysEqual,
        '[object Int16Array]': areTypedArraysEqual,
        '[object Int32Array]': areTypedArraysEqual,
        '[object Map]': areMapsEqual,
        '[object Number]': arePrimitiveWrappersEqual,
        '[object Object]': (a, b, state)=>// The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state),
        // For RegExp, the properties are not enumerable, and therefore will give false positives if
        // tested like a standard object.
        '[object RegExp]': areRegExpsEqual,
        '[object Set]': areSetsEqual,
        '[object String]': arePrimitiveWrappersEqual,
        '[object URL]': areUrlsEqual,
        '[object Uint8Array]': areTypedArraysEqual,
        '[object Uint8ClampedArray]': areTypedArraysEqual,
        '[object Uint16Array]': areTypedArraysEqual,
        '[object Uint32Array]': areTypedArraysEqual
    };
}
/**
 * Whether the items passed are deeply-equal in value.
 */ const $821d8a96f52548fd$export$9cb4719e2e525b7a = $821d8a96f52548fd$export$27d4033faa05be8f();
/**
 * Whether the items passed are deeply-equal in value based on strict comparison.
 */ const $821d8a96f52548fd$export$5bf96a264e958df0 = $821d8a96f52548fd$export$27d4033faa05be8f({
    strict: true
});
/**
 * Whether the items passed are deeply-equal in value, including circular references.
 */ const $821d8a96f52548fd$export$ead32ad79eb92624 = $821d8a96f52548fd$export$27d4033faa05be8f({
    circular: true
});
/**
 * Whether the items passed are deeply-equal in value, including circular references,
 * based on strict comparison.
 */ const $821d8a96f52548fd$export$8fbb1c3604f5ea1e = $821d8a96f52548fd$export$27d4033faa05be8f({
    circular: true,
    strict: true
});
/**
 * Whether the items passed are shallowly-equal in value.
 */ const $821d8a96f52548fd$export$d36bdfa510afb180 = $821d8a96f52548fd$export$27d4033faa05be8f({
    createInternalComparator: ()=>$821d8a96f52548fd$export$671a9ea699133b99
});
/**
 * Whether the items passed are shallowly-equal in value based on strict comparison
 */ const $821d8a96f52548fd$export$acc41f9a53a59825 = $821d8a96f52548fd$export$27d4033faa05be8f({
    strict: true,
    createInternalComparator: ()=>$821d8a96f52548fd$export$671a9ea699133b99
});
/**
 * Whether the items passed are shallowly-equal in value, including circular references.
 */ const $821d8a96f52548fd$export$c612fae31234bca2 = $821d8a96f52548fd$export$27d4033faa05be8f({
    circular: true,
    createInternalComparator: ()=>$821d8a96f52548fd$export$671a9ea699133b99
});
/**
 * Whether the items passed are shallowly-equal in value, including circular references,
 * based on strict comparison.
 */ const $821d8a96f52548fd$export$984c54f95b1e263c = $821d8a96f52548fd$export$27d4033faa05be8f({
    circular: true,
    createInternalComparator: ()=>$821d8a96f52548fd$export$671a9ea699133b99,
    strict: true
});
/**
 * Create a custom equality comparison method.
 *
 * This can be done to create very targeted comparisons in extreme hot-path scenarios
 * where the standard methods are not performant enough, but can also be used to provide
 * support for legacy environments that do not support expected features like
 * `RegExp.prototype.flags` out of the box.
 */ function $821d8a96f52548fd$export$27d4033faa05be8f(options = {}) {
    const { circular: circular = false, createInternalComparator: createCustomInternalComparator, createState: createState, strict: strict = false } = options;
    const config = $821d8a96f52548fd$var$createEqualityComparatorConfig(options);
    const comparator = $821d8a96f52548fd$var$createEqualityComparator(config);
    const equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : $821d8a96f52548fd$var$createInternalEqualityComparator(comparator);
    return $821d8a96f52548fd$var$createIsEqual({
        circular: circular,
        comparator: comparator,
        createState: createState,
        equals: equals,
        strict: strict
    });
}


/** Implements a deep equals using `fast-equals.createCustomEqual`. Functions
 * are always considered equal, and circular references are tracked to avoid
 * infinite recursion on self-referential inputs.
 *
 * @param a - The first element to compare
 * @param b - The second element to compare
 * @returns - True if the `a` and `b` are deeply equal, false otherwise
 */ const $d6d96b21f3c423a2$var$deepEquals = (0, $821d8a96f52548fd$export$27d4033faa05be8f)({
    circular: true,
    createCustomConfig: ()=>({
            areFunctionsEqual (_a, b) {
                return typeof b === 'function';
            }
        })
});
var $d6d96b21f3c423a2$export$2e2bcd8739ae039 = $d6d96b21f3c423a2$var$deepEquals;



var $9C0cr = parcelRequire("9C0cr");
var $0e66a35a574246f9$exports = {};

$parcel$export($0e66a35a574246f9$exports, "get", function () { return $0e66a35a574246f9$export$3988ae62b71be9a3; }, function (v) { return $0e66a35a574246f9$export$3988ae62b71be9a3 = v; });
$parcel$export($0e66a35a574246f9$exports, "set", function () { return $0e66a35a574246f9$export$adaa4cf7ef1b65be; }, function (v) { return $0e66a35a574246f9$export$adaa4cf7ef1b65be = v; });
$parcel$export($0e66a35a574246f9$exports, "compile", function () { return $0e66a35a574246f9$export$ef7acd7185315e22; }, function (v) { return $0e66a35a574246f9$export$ef7acd7185315e22 = v; });
var $0e66a35a574246f9$export$3988ae62b71be9a3;
var $0e66a35a574246f9$export$adaa4cf7ef1b65be;
var $0e66a35a574246f9$export$ef7acd7185315e22;
var $0e66a35a574246f9$var$hasExcape = /~/;
var $0e66a35a574246f9$var$escapeMatcher = /~[01]/g;
function $0e66a35a574246f9$var$escapeReplacer(m) {
    switch(m){
        case '~1':
            return '/';
        case '~0':
            return '~';
    }
    throw new Error('Invalid tilde escape: ' + m);
}
function $0e66a35a574246f9$var$untilde(str) {
    if (!$0e66a35a574246f9$var$hasExcape.test(str)) return str;
    return str.replace($0e66a35a574246f9$var$escapeMatcher, $0e66a35a574246f9$var$escapeReplacer);
}
function $0e66a35a574246f9$var$setter(obj, pointer, value) {
    var part;
    var hasNextPart;
    for(var p = 1, len = pointer.length; p < len;){
        if (pointer[p] === 'constructor' || pointer[p] === 'prototype' || pointer[p] === '__proto__') return obj;
        part = $0e66a35a574246f9$var$untilde(pointer[p++]);
        hasNextPart = len > p;
        if (typeof obj[part] === 'undefined') {
            // support setting of /-
            if (Array.isArray(obj) && part === '-') part = obj.length;
            // support nested objects/array when setting values
            if (hasNextPart) {
                if (pointer[p] !== '' && pointer[p] < Infinity || pointer[p] === '-') obj[part] = [];
                else obj[part] = {};
            }
        }
        if (!hasNextPart) break;
        obj = obj[part];
    }
    var oldValue = obj[part];
    if (value === undefined) delete obj[part];
    else obj[part] = value;
    return oldValue;
}
function $0e66a35a574246f9$var$compilePointer(pointer) {
    if (typeof pointer === 'string') {
        pointer = pointer.split('/');
        if (pointer[0] === '') return pointer;
        throw new Error('Invalid JSON pointer.');
    } else if (Array.isArray(pointer)) {
        for (const part of pointer){
            if (typeof part !== 'string' && typeof part !== 'number') throw new Error('Invalid JSON pointer. Must be of type string or number.');
        }
        return pointer;
    }
    throw new Error('Invalid JSON pointer.');
}
function $0e66a35a574246f9$var$get(obj, pointer) {
    if (typeof obj !== 'object') throw new Error('Invalid input object.');
    pointer = $0e66a35a574246f9$var$compilePointer(pointer);
    var len = pointer.length;
    if (len === 1) return obj;
    for(var p = 1; p < len;){
        obj = obj[$0e66a35a574246f9$var$untilde(pointer[p++])];
        if (len === p) return obj;
        if (typeof obj !== 'object' || obj === null) return undefined;
    }
}
function $0e66a35a574246f9$var$set(obj, pointer, value) {
    if (typeof obj !== 'object') throw new Error('Invalid input object.');
    pointer = $0e66a35a574246f9$var$compilePointer(pointer);
    if (pointer.length === 0) throw new Error('Invalid JSON pointer for set.');
    return $0e66a35a574246f9$var$setter(obj, pointer, value);
}
function $0e66a35a574246f9$var$compile(pointer) {
    var compiled = $0e66a35a574246f9$var$compilePointer(pointer);
    return {
        get: function(object) {
            return $0e66a35a574246f9$var$get(object, compiled);
        },
        set: function(object, value) {
            return $0e66a35a574246f9$var$set(object, compiled, value);
        }
    };
}
$0e66a35a574246f9$export$3988ae62b71be9a3 = $0e66a35a574246f9$var$get;
$0e66a35a574246f9$export$adaa4cf7ef1b65be = $0e66a35a574246f9$var$set;
$0e66a35a574246f9$export$ef7acd7185315e22 = $0e66a35a574246f9$var$compile;



/** Used for built-in method references. */ var $41489ff46ad7905c$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $41489ff46ad7905c$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $41489ff46ad7905c$var$objectProto;
    return value === proto;
}
var $41489ff46ad7905c$export$2e2bcd8739ae039 = $41489ff46ad7905c$var$isPrototype;



/* Built-in method references for those with the same name as other `lodash` methods. */ var $56d07b018f0fa73d$var$nativeKeys = (0, $9f9ef0af16734d0c$export$2e2bcd8739ae039)(Object.keys, Object);
var $56d07b018f0fa73d$export$2e2bcd8739ae039 = $56d07b018f0fa73d$var$nativeKeys;


/** Used for built-in method references. */ var $56444761aa3fad72$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $56444761aa3fad72$var$hasOwnProperty = $56444761aa3fad72$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $56444761aa3fad72$var$baseKeys(object) {
    if (!(0, $41489ff46ad7905c$export$2e2bcd8739ae039)(object)) return (0, $56d07b018f0fa73d$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($56444761aa3fad72$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $56444761aa3fad72$export$2e2bcd8739ae039 = $56444761aa3fad72$var$baseKeys;




var $h5jK2 = parcelRequire("h5jK2");
/* Built-in method references that are verified to be native. */ var $3cb2a65ba2b35027$var$DataView = (0, $3681d891f519dfa0$export$2e2bcd8739ae039)((0, $h5jK2.default), 'DataView');
var $3cb2a65ba2b35027$export$2e2bcd8739ae039 = $3cb2a65ba2b35027$var$DataView;





var $h5jK2 = parcelRequire("h5jK2");
/* Built-in method references that are verified to be native. */ var $98c2693caa779151$var$Promise = (0, $3681d891f519dfa0$export$2e2bcd8739ae039)((0, $h5jK2.default), 'Promise');
var $98c2693caa779151$export$2e2bcd8739ae039 = $98c2693caa779151$var$Promise;




var $h5jK2 = parcelRequire("h5jK2");
/* Built-in method references that are verified to be native. */ var $859ed7bb7a280e67$var$Set = (0, $3681d891f519dfa0$export$2e2bcd8739ae039)((0, $h5jK2.default), 'Set');
var $859ed7bb7a280e67$export$2e2bcd8739ae039 = $859ed7bb7a280e67$var$Set;




var $h5jK2 = parcelRequire("h5jK2");
/* Built-in method references that are verified to be native. */ var $815b4cb6d1752f10$var$WeakMap = (0, $3681d891f519dfa0$export$2e2bcd8739ae039)((0, $h5jK2.default), 'WeakMap');
var $815b4cb6d1752f10$export$2e2bcd8739ae039 = $815b4cb6d1752f10$var$WeakMap;




/** `Object#toString` result references. */ var $a3da4848ad90ced6$var$mapTag = '[object Map]', $a3da4848ad90ced6$var$objectTag = '[object Object]', $a3da4848ad90ced6$var$promiseTag = '[object Promise]', $a3da4848ad90ced6$var$setTag = '[object Set]', $a3da4848ad90ced6$var$weakMapTag = '[object WeakMap]';
var $a3da4848ad90ced6$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $a3da4848ad90ced6$var$dataViewCtorString = (0, $f39458f3848c447f$export$2e2bcd8739ae039)((0, $3cb2a65ba2b35027$export$2e2bcd8739ae039)), $a3da4848ad90ced6$var$mapCtorString = (0, $f39458f3848c447f$export$2e2bcd8739ae039)((0, $59b6286b0bf4bde0$export$2e2bcd8739ae039)), $a3da4848ad90ced6$var$promiseCtorString = (0, $f39458f3848c447f$export$2e2bcd8739ae039)((0, $98c2693caa779151$export$2e2bcd8739ae039)), $a3da4848ad90ced6$var$setCtorString = (0, $f39458f3848c447f$export$2e2bcd8739ae039)((0, $859ed7bb7a280e67$export$2e2bcd8739ae039)), $a3da4848ad90ced6$var$weakMapCtorString = (0, $f39458f3848c447f$export$2e2bcd8739ae039)((0, $815b4cb6d1752f10$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $a3da4848ad90ced6$var$getTag = (0, $95eecc554ecfdc33$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $3cb2a65ba2b35027$export$2e2bcd8739ae039) && $a3da4848ad90ced6$var$getTag(new (0, $3cb2a65ba2b35027$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $a3da4848ad90ced6$var$dataViewTag || (0, $59b6286b0bf4bde0$export$2e2bcd8739ae039) && $a3da4848ad90ced6$var$getTag(new (0, $59b6286b0bf4bde0$export$2e2bcd8739ae039)) != $a3da4848ad90ced6$var$mapTag || (0, $98c2693caa779151$export$2e2bcd8739ae039) && $a3da4848ad90ced6$var$getTag((0, $98c2693caa779151$export$2e2bcd8739ae039).resolve()) != $a3da4848ad90ced6$var$promiseTag || (0, $859ed7bb7a280e67$export$2e2bcd8739ae039) && $a3da4848ad90ced6$var$getTag(new (0, $859ed7bb7a280e67$export$2e2bcd8739ae039)) != $a3da4848ad90ced6$var$setTag || (0, $815b4cb6d1752f10$export$2e2bcd8739ae039) && $a3da4848ad90ced6$var$getTag(new (0, $815b4cb6d1752f10$export$2e2bcd8739ae039)) != $a3da4848ad90ced6$var$weakMapTag) $a3da4848ad90ced6$var$getTag = function(value) {
    var result = (0, $95eecc554ecfdc33$export$2e2bcd8739ae039)(value), Ctor = result == $a3da4848ad90ced6$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $f39458f3848c447f$export$2e2bcd8739ae039)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $a3da4848ad90ced6$var$dataViewCtorString:
            return $a3da4848ad90ced6$var$dataViewTag;
        case $a3da4848ad90ced6$var$mapCtorString:
            return $a3da4848ad90ced6$var$mapTag;
        case $a3da4848ad90ced6$var$promiseCtorString:
            return $a3da4848ad90ced6$var$promiseTag;
        case $a3da4848ad90ced6$var$setCtorString:
            return $a3da4848ad90ced6$var$setTag;
        case $a3da4848ad90ced6$var$weakMapCtorString:
            return $a3da4848ad90ced6$var$weakMapTag;
    }
    return result;
};
var $a3da4848ad90ced6$export$2e2bcd8739ae039 = $a3da4848ad90ced6$var$getTag;




/** `Object#toString` result references. */ var $ee87650593b52d70$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $ee87650593b52d70$var$baseIsArguments(value) {
    return (0, $754274dccdb4db10$export$2e2bcd8739ae039)(value) && (0, $95eecc554ecfdc33$export$2e2bcd8739ae039)(value) == $ee87650593b52d70$var$argsTag;
}
var $ee87650593b52d70$export$2e2bcd8739ae039 = $ee87650593b52d70$var$baseIsArguments;



/** Used for built-in method references. */ var $4ede6273d5b53f32$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4ede6273d5b53f32$var$hasOwnProperty = $4ede6273d5b53f32$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $4ede6273d5b53f32$var$propertyIsEnumerable = $4ede6273d5b53f32$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $4ede6273d5b53f32$var$isArguments = (0, $ee87650593b52d70$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $ee87650593b52d70$export$2e2bcd8739ae039) : function(value) {
    return (0, $754274dccdb4db10$export$2e2bcd8739ae039)(value) && $4ede6273d5b53f32$var$hasOwnProperty.call(value, 'callee') && !$4ede6273d5b53f32$var$propertyIsEnumerable.call(value, 'callee');
};
var $4ede6273d5b53f32$export$2e2bcd8739ae039 = $4ede6273d5b53f32$var$isArguments;




/** Used as references for various `Number` constants. */ var $284fcf77a1deaeef$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $284fcf77a1deaeef$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $284fcf77a1deaeef$var$MAX_SAFE_INTEGER;
}
var $284fcf77a1deaeef$export$2e2bcd8739ae039 = $284fcf77a1deaeef$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $baeea2f3638e715c$var$isArrayLike(value) {
    return value != null && (0, $284fcf77a1deaeef$export$2e2bcd8739ae039)(value.length) && !(0, $e8276fc8779dcffd$export$2e2bcd8739ae039)(value);
}
var $baeea2f3638e715c$export$2e2bcd8739ae039 = $baeea2f3638e715c$var$isArrayLike;



var $5Ckcr = parcelRequire("5Ckcr");




/** `Object#toString` result references. */ var $f7bcda3f8dfc469e$var$argsTag = '[object Arguments]', $f7bcda3f8dfc469e$var$arrayTag = '[object Array]', $f7bcda3f8dfc469e$var$boolTag = '[object Boolean]', $f7bcda3f8dfc469e$var$dateTag = '[object Date]', $f7bcda3f8dfc469e$var$errorTag = '[object Error]', $f7bcda3f8dfc469e$var$funcTag = '[object Function]', $f7bcda3f8dfc469e$var$mapTag = '[object Map]', $f7bcda3f8dfc469e$var$numberTag = '[object Number]', $f7bcda3f8dfc469e$var$objectTag = '[object Object]', $f7bcda3f8dfc469e$var$regexpTag = '[object RegExp]', $f7bcda3f8dfc469e$var$setTag = '[object Set]', $f7bcda3f8dfc469e$var$stringTag = '[object String]', $f7bcda3f8dfc469e$var$weakMapTag = '[object WeakMap]';
var $f7bcda3f8dfc469e$var$arrayBufferTag = '[object ArrayBuffer]', $f7bcda3f8dfc469e$var$dataViewTag = '[object DataView]', $f7bcda3f8dfc469e$var$float32Tag = '[object Float32Array]', $f7bcda3f8dfc469e$var$float64Tag = '[object Float64Array]', $f7bcda3f8dfc469e$var$int8Tag = '[object Int8Array]', $f7bcda3f8dfc469e$var$int16Tag = '[object Int16Array]', $f7bcda3f8dfc469e$var$int32Tag = '[object Int32Array]', $f7bcda3f8dfc469e$var$uint8Tag = '[object Uint8Array]', $f7bcda3f8dfc469e$var$uint8ClampedTag = '[object Uint8ClampedArray]', $f7bcda3f8dfc469e$var$uint16Tag = '[object Uint16Array]', $f7bcda3f8dfc469e$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $f7bcda3f8dfc469e$var$typedArrayTags = {};
$f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$float32Tag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$float64Tag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$int8Tag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$int16Tag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$int32Tag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$uint8Tag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$uint8ClampedTag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$uint16Tag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$uint32Tag] = true;
$f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$argsTag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$arrayTag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$arrayBufferTag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$boolTag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$dataViewTag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$dateTag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$errorTag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$funcTag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$mapTag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$numberTag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$objectTag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$regexpTag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$setTag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$stringTag] = $f7bcda3f8dfc469e$var$typedArrayTags[$f7bcda3f8dfc469e$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $f7bcda3f8dfc469e$var$baseIsTypedArray(value) {
    return (0, $754274dccdb4db10$export$2e2bcd8739ae039)(value) && (0, $284fcf77a1deaeef$export$2e2bcd8739ae039)(value.length) && !!$f7bcda3f8dfc469e$var$typedArrayTags[(0, $95eecc554ecfdc33$export$2e2bcd8739ae039)(value)];
}
var $f7bcda3f8dfc469e$export$2e2bcd8739ae039 = $f7bcda3f8dfc469e$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $b5e34b5af2871f86$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $b5e34b5af2871f86$export$2e2bcd8739ae039 = $b5e34b5af2871f86$var$baseUnary;



var $lGG4h = parcelRequire("lGG4h");
/* Node.js helper references. */ var $d7cefc60683de4c9$var$nodeIsTypedArray = (0, $lGG4h.default) && (0, $lGG4h.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $d7cefc60683de4c9$var$isTypedArray = $d7cefc60683de4c9$var$nodeIsTypedArray ? (0, $b5e34b5af2871f86$export$2e2bcd8739ae039)($d7cefc60683de4c9$var$nodeIsTypedArray) : (0, $f7bcda3f8dfc469e$export$2e2bcd8739ae039);
var $d7cefc60683de4c9$export$2e2bcd8739ae039 = $d7cefc60683de4c9$var$isTypedArray;


/** `Object#toString` result references. */ var $1fe6d5766df4f45f$var$mapTag = '[object Map]', $1fe6d5766df4f45f$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $1fe6d5766df4f45f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1fe6d5766df4f45f$var$hasOwnProperty = $1fe6d5766df4f45f$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $1fe6d5766df4f45f$var$isEmpty(value) {
    if (value == null) return true;
    if ((0, $baeea2f3638e715c$export$2e2bcd8739ae039)(value) && ((0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(value) || typeof value == 'string' || typeof value.splice == 'function' || (0, $5Ckcr.default)(value) || (0, $d7cefc60683de4c9$export$2e2bcd8739ae039)(value) || (0, $4ede6273d5b53f32$export$2e2bcd8739ae039)(value))) return !value.length;
    var tag = (0, $a3da4848ad90ced6$export$2e2bcd8739ae039)(value);
    if (tag == $1fe6d5766df4f45f$var$mapTag || tag == $1fe6d5766df4f45f$var$setTag) return !value.size;
    if ((0, $41489ff46ad7905c$export$2e2bcd8739ae039)(value)) return !(0, $56444761aa3fad72$export$2e2bcd8739ae039)(value).length;
    for(var key in value){
        if ($1fe6d5766df4f45f$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
var $1fe6d5766df4f45f$export$2e2bcd8739ae039 = $1fe6d5766df4f45f$var$isEmpty;






/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $f844566467411a48$var$stackClear() {
    this.__data__ = new (0, $acf191f2a41c5d82$export$2e2bcd8739ae039);
    this.size = 0;
}
var $f844566467411a48$export$2e2bcd8739ae039 = $f844566467411a48$var$stackClear;


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ade41543c2601b8f$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $ade41543c2601b8f$export$2e2bcd8739ae039 = $ade41543c2601b8f$var$stackDelete;


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2b7f47240ab697d$var$stackGet(key) {
    return this.__data__.get(key);
}
var $b2b7f47240ab697d$export$2e2bcd8739ae039 = $b2b7f47240ab697d$var$stackGet;


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29fbeb50a451c083$var$stackHas(key) {
    return this.__data__.has(key);
}
var $29fbeb50a451c083$export$2e2bcd8739ae039 = $29fbeb50a451c083$var$stackHas;





/** Used as the size to enable large array optimizations. */ var $be22f36303c729e8$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $be22f36303c729e8$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $acf191f2a41c5d82$export$2e2bcd8739ae039)) {
        var pairs = data.__data__;
        if (!(0, $59b6286b0bf4bde0$export$2e2bcd8739ae039) || pairs.length < $be22f36303c729e8$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $9935e83a362a1d93$export$2e2bcd8739ae039)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $be22f36303c729e8$export$2e2bcd8739ae039 = $be22f36303c729e8$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $955b5c2507d2790f$var$Stack(entries) {
    var data = this.__data__ = new (0, $acf191f2a41c5d82$export$2e2bcd8739ae039)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$955b5c2507d2790f$var$Stack.prototype.clear = (0, $f844566467411a48$export$2e2bcd8739ae039);
$955b5c2507d2790f$var$Stack.prototype['delete'] = (0, $ade41543c2601b8f$export$2e2bcd8739ae039);
$955b5c2507d2790f$var$Stack.prototype.get = (0, $b2b7f47240ab697d$export$2e2bcd8739ae039);
$955b5c2507d2790f$var$Stack.prototype.has = (0, $29fbeb50a451c083$export$2e2bcd8739ae039);
$955b5c2507d2790f$var$Stack.prototype.set = (0, $be22f36303c729e8$export$2e2bcd8739ae039);
var $955b5c2507d2790f$export$2e2bcd8739ae039 = $955b5c2507d2790f$var$Stack;


/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $d36a4232bf514589$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $d36a4232bf514589$export$2e2bcd8739ae039 = $d36a4232bf514589$var$arrayEach;



var $5cb8d80b626d0c53$var$defineProperty = function() {
    try {
        var func = (0, $3681d891f519dfa0$export$2e2bcd8739ae039)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $5cb8d80b626d0c53$export$2e2bcd8739ae039 = $5cb8d80b626d0c53$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $d0d577faa5319a30$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $5cb8d80b626d0c53$export$2e2bcd8739ae039)) (0, $5cb8d80b626d0c53$export$2e2bcd8739ae039)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $d0d577faa5319a30$export$2e2bcd8739ae039 = $d0d577faa5319a30$var$baseAssignValue;



/** Used for built-in method references. */ var $b51f6c87cf17fb01$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b51f6c87cf17fb01$var$hasOwnProperty = $b51f6c87cf17fb01$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $b51f6c87cf17fb01$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($b51f6c87cf17fb01$var$hasOwnProperty.call(object, key) && (0, $b65447e8fe19238e$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $d0d577faa5319a30$export$2e2bcd8739ae039)(object, key, value);
}
var $b51f6c87cf17fb01$export$2e2bcd8739ae039 = $b51f6c87cf17fb01$var$assignValue;




/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $626987d1111ad093$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $d0d577faa5319a30$export$2e2bcd8739ae039)(object, key, newValue);
        else (0, $b51f6c87cf17fb01$export$2e2bcd8739ae039)(object, key, newValue);
    }
    return object;
}
var $626987d1111ad093$export$2e2bcd8739ae039 = $626987d1111ad093$var$copyObject;


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $f4e8e766d057d979$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $f4e8e766d057d979$export$2e2bcd8739ae039 = $f4e8e766d057d979$var$baseTimes;





var $5Ckcr = parcelRequire("5Ckcr");
/** Used as references for various `Number` constants. */ var $a7f219d5ae6652bf$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $a7f219d5ae6652bf$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $a7f219d5ae6652bf$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $a7f219d5ae6652bf$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $a7f219d5ae6652bf$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $a7f219d5ae6652bf$export$2e2bcd8739ae039 = $a7f219d5ae6652bf$var$isIndex;



/** Used for built-in method references. */ var $f7effd55b0a892be$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f7effd55b0a892be$var$hasOwnProperty = $f7effd55b0a892be$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $f7effd55b0a892be$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(value), isArg = !isArr && (0, $4ede6273d5b53f32$export$2e2bcd8739ae039)(value), isBuff = !isArr && !isArg && (0, $5Ckcr.default)(value), isType = !isArr && !isArg && !isBuff && (0, $d7cefc60683de4c9$export$2e2bcd8739ae039)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $f4e8e766d057d979$export$2e2bcd8739ae039)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $f7effd55b0a892be$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $a7f219d5ae6652bf$export$2e2bcd8739ae039)(key, length)))) result.push(key);
    return result;
}
var $f7effd55b0a892be$export$2e2bcd8739ae039 = $f7effd55b0a892be$var$arrayLikeKeys;




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $39f39242faed4588$var$keys(object) {
    return (0, $baeea2f3638e715c$export$2e2bcd8739ae039)(object) ? (0, $f7effd55b0a892be$export$2e2bcd8739ae039)(object) : (0, $56444761aa3fad72$export$2e2bcd8739ae039)(object);
}
var $39f39242faed4588$export$2e2bcd8739ae039 = $39f39242faed4588$var$keys;


/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $d234a7931fdcf66d$var$baseAssign(object, source) {
    return object && (0, $626987d1111ad093$export$2e2bcd8739ae039)(source, (0, $39f39242faed4588$export$2e2bcd8739ae039)(source), object);
}
var $d234a7931fdcf66d$export$2e2bcd8739ae039 = $d234a7931fdcf66d$var$baseAssign;






/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c9bb91f6e79f9c80$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $c9bb91f6e79f9c80$export$2e2bcd8739ae039 = $c9bb91f6e79f9c80$var$nativeKeysIn;


/** Used for built-in method references. */ var $d5a19bd12ce74b7e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d5a19bd12ce74b7e$var$hasOwnProperty = $d5a19bd12ce74b7e$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $d5a19bd12ce74b7e$var$baseKeysIn(object) {
    if (!(0, $d252d56fd76f41df$export$2e2bcd8739ae039)(object)) return (0, $c9bb91f6e79f9c80$export$2e2bcd8739ae039)(object);
    var isProto = (0, $41489ff46ad7905c$export$2e2bcd8739ae039)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$d5a19bd12ce74b7e$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $d5a19bd12ce74b7e$export$2e2bcd8739ae039 = $d5a19bd12ce74b7e$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $d87639e714c649a8$var$keysIn(object) {
    return (0, $baeea2f3638e715c$export$2e2bcd8739ae039)(object) ? (0, $f7effd55b0a892be$export$2e2bcd8739ae039)(object, true) : (0, $d5a19bd12ce74b7e$export$2e2bcd8739ae039)(object);
}
var $d87639e714c649a8$export$2e2bcd8739ae039 = $d87639e714c649a8$var$keysIn;


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0d551aa828ed9242$var$baseAssignIn(object, source) {
    return object && (0, $626987d1111ad093$export$2e2bcd8739ae039)(source, (0, $d87639e714c649a8$export$2e2bcd8739ae039)(source), object);
}
var $0d551aa828ed9242$export$2e2bcd8739ae039 = $0d551aa828ed9242$var$baseAssignIn;



var $jxwfQ = parcelRequire("jxwfQ");
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $0888b9a44238f12f$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $0888b9a44238f12f$export$2e2bcd8739ae039 = $0888b9a44238f12f$var$copyArray;



/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $9532c2ca333cc408$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $9532c2ca333cc408$export$2e2bcd8739ae039 = $9532c2ca333cc408$var$arrayFilter;


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $2fedd707fbdecaf4$var$stubArray() {
    return [];
}
var $2fedd707fbdecaf4$export$2e2bcd8739ae039 = $2fedd707fbdecaf4$var$stubArray;


/** Used for built-in method references. */ var $4689817ecf49e5f8$var$objectProto = Object.prototype;
/** Built-in value references. */ var $4689817ecf49e5f8$var$propertyIsEnumerable = $4689817ecf49e5f8$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4689817ecf49e5f8$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $4689817ecf49e5f8$var$getSymbols = !$4689817ecf49e5f8$var$nativeGetSymbols ? (0, $2fedd707fbdecaf4$export$2e2bcd8739ae039) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $9532c2ca333cc408$export$2e2bcd8739ae039)($4689817ecf49e5f8$var$nativeGetSymbols(object), function(symbol) {
        return $4689817ecf49e5f8$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $4689817ecf49e5f8$export$2e2bcd8739ae039 = $4689817ecf49e5f8$var$getSymbols;


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $d2f62f2a735791ac$var$copySymbols(source, object) {
    return (0, $626987d1111ad093$export$2e2bcd8739ae039)(source, (0, $4689817ecf49e5f8$export$2e2bcd8739ae039)(source), object);
}
var $d2f62f2a735791ac$export$2e2bcd8739ae039 = $d2f62f2a735791ac$var$copySymbols;



/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $4474f8bd50c8ed05$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $4474f8bd50c8ed05$export$2e2bcd8739ae039 = $4474f8bd50c8ed05$var$arrayPush;





/* Built-in method references for those with the same name as other `lodash` methods. */ var $9a47b08b20d720df$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $9a47b08b20d720df$var$getSymbolsIn = !$9a47b08b20d720df$var$nativeGetSymbols ? (0, $2fedd707fbdecaf4$export$2e2bcd8739ae039) : function(object) {
    var result = [];
    while(object){
        (0, $4474f8bd50c8ed05$export$2e2bcd8739ae039)(result, (0, $4689817ecf49e5f8$export$2e2bcd8739ae039)(object));
        object = (0, $0b14821d94ad35ef$export$2e2bcd8739ae039)(object);
    }
    return result;
};
var $9a47b08b20d720df$export$2e2bcd8739ae039 = $9a47b08b20d720df$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $c61673011333b2f5$var$copySymbolsIn(source, object) {
    return (0, $626987d1111ad093$export$2e2bcd8739ae039)(source, (0, $9a47b08b20d720df$export$2e2bcd8739ae039)(source), object);
}
var $c61673011333b2f5$export$2e2bcd8739ae039 = $c61673011333b2f5$var$copySymbolsIn;




/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $2743f58b9b11319d$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(object) ? result : (0, $4474f8bd50c8ed05$export$2e2bcd8739ae039)(result, symbolsFunc(object));
}
var $2743f58b9b11319d$export$2e2bcd8739ae039 = $2743f58b9b11319d$var$baseGetAllKeys;




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $61e7ea9bc5ab67d7$var$getAllKeys(object) {
    return (0, $2743f58b9b11319d$export$2e2bcd8739ae039)(object, (0, $39f39242faed4588$export$2e2bcd8739ae039), (0, $4689817ecf49e5f8$export$2e2bcd8739ae039));
}
var $61e7ea9bc5ab67d7$export$2e2bcd8739ae039 = $61e7ea9bc5ab67d7$var$getAllKeys;





/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $cb4411947b1bbccd$var$getAllKeysIn(object) {
    return (0, $2743f58b9b11319d$export$2e2bcd8739ae039)(object, (0, $d87639e714c649a8$export$2e2bcd8739ae039), (0, $9a47b08b20d720df$export$2e2bcd8739ae039));
}
var $cb4411947b1bbccd$export$2e2bcd8739ae039 = $cb4411947b1bbccd$var$getAllKeysIn;



/** Used for built-in method references. */ var $ddb314e0a92d1828$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ddb314e0a92d1828$var$hasOwnProperty = $ddb314e0a92d1828$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $ddb314e0a92d1828$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $ddb314e0a92d1828$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $ddb314e0a92d1828$export$2e2bcd8739ae039 = $ddb314e0a92d1828$var$initCloneArray;



var $h5jK2 = parcelRequire("h5jK2");
/** Built-in value references. */ var $30da13388cbc1889$var$Uint8Array = (0, $h5jK2.default).Uint8Array;
var $30da13388cbc1889$export$2e2bcd8739ae039 = $30da13388cbc1889$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $c21c6bd264a2f756$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $30da13388cbc1889$export$2e2bcd8739ae039)(result).set(new (0, $30da13388cbc1889$export$2e2bcd8739ae039)(arrayBuffer));
    return result;
}
var $c21c6bd264a2f756$export$2e2bcd8739ae039 = $c21c6bd264a2f756$var$cloneArrayBuffer;



/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $dbd6c80b006b8ebe$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $c21c6bd264a2f756$export$2e2bcd8739ae039)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $dbd6c80b006b8ebe$export$2e2bcd8739ae039 = $dbd6c80b006b8ebe$var$cloneDataView;


/** Used to match `RegExp` flags from their coerced string values. */ var $675bffe570b2eb40$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $675bffe570b2eb40$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $675bffe570b2eb40$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $675bffe570b2eb40$export$2e2bcd8739ae039 = $675bffe570b2eb40$var$cloneRegExp;



/** Used to convert symbols to primitives and strings. */ var $10eab91ec2537237$var$symbolProto = (0, $899304693344e559$export$2e2bcd8739ae039) ? (0, $899304693344e559$export$2e2bcd8739ae039).prototype : undefined, $10eab91ec2537237$var$symbolValueOf = $10eab91ec2537237$var$symbolProto ? $10eab91ec2537237$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $10eab91ec2537237$var$cloneSymbol(symbol) {
    return $10eab91ec2537237$var$symbolValueOf ? Object($10eab91ec2537237$var$symbolValueOf.call(symbol)) : {};
}
var $10eab91ec2537237$export$2e2bcd8739ae039 = $10eab91ec2537237$var$cloneSymbol;



/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $fa52226bab133417$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $c21c6bd264a2f756$export$2e2bcd8739ae039)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $fa52226bab133417$export$2e2bcd8739ae039 = $fa52226bab133417$var$cloneTypedArray;


/** `Object#toString` result references. */ var $e15f83b2f781131c$var$boolTag = '[object Boolean]', $e15f83b2f781131c$var$dateTag = '[object Date]', $e15f83b2f781131c$var$mapTag = '[object Map]', $e15f83b2f781131c$var$numberTag = '[object Number]', $e15f83b2f781131c$var$regexpTag = '[object RegExp]', $e15f83b2f781131c$var$setTag = '[object Set]', $e15f83b2f781131c$var$stringTag = '[object String]', $e15f83b2f781131c$var$symbolTag = '[object Symbol]';
var $e15f83b2f781131c$var$arrayBufferTag = '[object ArrayBuffer]', $e15f83b2f781131c$var$dataViewTag = '[object DataView]', $e15f83b2f781131c$var$float32Tag = '[object Float32Array]', $e15f83b2f781131c$var$float64Tag = '[object Float64Array]', $e15f83b2f781131c$var$int8Tag = '[object Int8Array]', $e15f83b2f781131c$var$int16Tag = '[object Int16Array]', $e15f83b2f781131c$var$int32Tag = '[object Int32Array]', $e15f83b2f781131c$var$uint8Tag = '[object Uint8Array]', $e15f83b2f781131c$var$uint8ClampedTag = '[object Uint8ClampedArray]', $e15f83b2f781131c$var$uint16Tag = '[object Uint16Array]', $e15f83b2f781131c$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $e15f83b2f781131c$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $e15f83b2f781131c$var$arrayBufferTag:
            return (0, $c21c6bd264a2f756$export$2e2bcd8739ae039)(object);
        case $e15f83b2f781131c$var$boolTag:
        case $e15f83b2f781131c$var$dateTag:
            return new Ctor(+object);
        case $e15f83b2f781131c$var$dataViewTag:
            return (0, $dbd6c80b006b8ebe$export$2e2bcd8739ae039)(object, isDeep);
        case $e15f83b2f781131c$var$float32Tag:
        case $e15f83b2f781131c$var$float64Tag:
        case $e15f83b2f781131c$var$int8Tag:
        case $e15f83b2f781131c$var$int16Tag:
        case $e15f83b2f781131c$var$int32Tag:
        case $e15f83b2f781131c$var$uint8Tag:
        case $e15f83b2f781131c$var$uint8ClampedTag:
        case $e15f83b2f781131c$var$uint16Tag:
        case $e15f83b2f781131c$var$uint32Tag:
            return (0, $fa52226bab133417$export$2e2bcd8739ae039)(object, isDeep);
        case $e15f83b2f781131c$var$mapTag:
            return new Ctor;
        case $e15f83b2f781131c$var$numberTag:
        case $e15f83b2f781131c$var$stringTag:
            return new Ctor(object);
        case $e15f83b2f781131c$var$regexpTag:
            return (0, $675bffe570b2eb40$export$2e2bcd8739ae039)(object);
        case $e15f83b2f781131c$var$setTag:
            return new Ctor;
        case $e15f83b2f781131c$var$symbolTag:
            return (0, $10eab91ec2537237$export$2e2bcd8739ae039)(object);
    }
}
var $e15f83b2f781131c$export$2e2bcd8739ae039 = $e15f83b2f781131c$var$initCloneByTag;



/** Built-in value references. */ var $f163497528577208$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $f163497528577208$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $d252d56fd76f41df$export$2e2bcd8739ae039)(proto)) return {};
        if ($f163497528577208$var$objectCreate) return $f163497528577208$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $f163497528577208$export$2e2bcd8739ae039 = $f163497528577208$var$baseCreate;




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $47d27bba7487fbd1$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $41489ff46ad7905c$export$2e2bcd8739ae039)(object) ? (0, $f163497528577208$export$2e2bcd8739ae039)((0, $0b14821d94ad35ef$export$2e2bcd8739ae039)(object)) : {};
}
var $47d27bba7487fbd1$export$2e2bcd8739ae039 = $47d27bba7487fbd1$var$initCloneObject;




var $5Ckcr = parcelRequire("5Ckcr");


/** `Object#toString` result references. */ var $28808ec96be18be6$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $28808ec96be18be6$var$baseIsMap(value) {
    return (0, $754274dccdb4db10$export$2e2bcd8739ae039)(value) && (0, $a3da4848ad90ced6$export$2e2bcd8739ae039)(value) == $28808ec96be18be6$var$mapTag;
}
var $28808ec96be18be6$export$2e2bcd8739ae039 = $28808ec96be18be6$var$baseIsMap;




var $lGG4h = parcelRequire("lGG4h");
/* Node.js helper references. */ var $a6685a6fe0035047$var$nodeIsMap = (0, $lGG4h.default) && (0, $lGG4h.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $a6685a6fe0035047$var$isMap = $a6685a6fe0035047$var$nodeIsMap ? (0, $b5e34b5af2871f86$export$2e2bcd8739ae039)($a6685a6fe0035047$var$nodeIsMap) : (0, $28808ec96be18be6$export$2e2bcd8739ae039);
var $a6685a6fe0035047$export$2e2bcd8739ae039 = $a6685a6fe0035047$var$isMap;





/** `Object#toString` result references. */ var $3d11670d8708bfbd$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $3d11670d8708bfbd$var$baseIsSet(value) {
    return (0, $754274dccdb4db10$export$2e2bcd8739ae039)(value) && (0, $a3da4848ad90ced6$export$2e2bcd8739ae039)(value) == $3d11670d8708bfbd$var$setTag;
}
var $3d11670d8708bfbd$export$2e2bcd8739ae039 = $3d11670d8708bfbd$var$baseIsSet;




var $lGG4h = parcelRequire("lGG4h");
/* Node.js helper references. */ var $d938fc04ce69bf3d$var$nodeIsSet = (0, $lGG4h.default) && (0, $lGG4h.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $d938fc04ce69bf3d$var$isSet = $d938fc04ce69bf3d$var$nodeIsSet ? (0, $b5e34b5af2871f86$export$2e2bcd8739ae039)($d938fc04ce69bf3d$var$nodeIsSet) : (0, $3d11670d8708bfbd$export$2e2bcd8739ae039);
var $d938fc04ce69bf3d$export$2e2bcd8739ae039 = $d938fc04ce69bf3d$var$isSet;




/** Used to compose bitmasks for cloning. */ var $dcdfe05415212eb9$var$CLONE_DEEP_FLAG = 1, $dcdfe05415212eb9$var$CLONE_FLAT_FLAG = 2, $dcdfe05415212eb9$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $dcdfe05415212eb9$var$argsTag = '[object Arguments]', $dcdfe05415212eb9$var$arrayTag = '[object Array]', $dcdfe05415212eb9$var$boolTag = '[object Boolean]', $dcdfe05415212eb9$var$dateTag = '[object Date]', $dcdfe05415212eb9$var$errorTag = '[object Error]', $dcdfe05415212eb9$var$funcTag = '[object Function]', $dcdfe05415212eb9$var$genTag = '[object GeneratorFunction]', $dcdfe05415212eb9$var$mapTag = '[object Map]', $dcdfe05415212eb9$var$numberTag = '[object Number]', $dcdfe05415212eb9$var$objectTag = '[object Object]', $dcdfe05415212eb9$var$regexpTag = '[object RegExp]', $dcdfe05415212eb9$var$setTag = '[object Set]', $dcdfe05415212eb9$var$stringTag = '[object String]', $dcdfe05415212eb9$var$symbolTag = '[object Symbol]', $dcdfe05415212eb9$var$weakMapTag = '[object WeakMap]';
var $dcdfe05415212eb9$var$arrayBufferTag = '[object ArrayBuffer]', $dcdfe05415212eb9$var$dataViewTag = '[object DataView]', $dcdfe05415212eb9$var$float32Tag = '[object Float32Array]', $dcdfe05415212eb9$var$float64Tag = '[object Float64Array]', $dcdfe05415212eb9$var$int8Tag = '[object Int8Array]', $dcdfe05415212eb9$var$int16Tag = '[object Int16Array]', $dcdfe05415212eb9$var$int32Tag = '[object Int32Array]', $dcdfe05415212eb9$var$uint8Tag = '[object Uint8Array]', $dcdfe05415212eb9$var$uint8ClampedTag = '[object Uint8ClampedArray]', $dcdfe05415212eb9$var$uint16Tag = '[object Uint16Array]', $dcdfe05415212eb9$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $dcdfe05415212eb9$var$cloneableTags = {};
$dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$argsTag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$arrayTag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$arrayBufferTag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$dataViewTag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$boolTag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$dateTag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$float32Tag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$float64Tag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$int8Tag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$int16Tag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$int32Tag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$mapTag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$numberTag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$objectTag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$regexpTag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$setTag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$stringTag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$symbolTag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$uint8Tag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$uint8ClampedTag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$uint16Tag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$uint32Tag] = true;
$dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$errorTag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$funcTag] = $dcdfe05415212eb9$var$cloneableTags[$dcdfe05415212eb9$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $dcdfe05415212eb9$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $dcdfe05415212eb9$var$CLONE_DEEP_FLAG, isFlat = bitmask & $dcdfe05415212eb9$var$CLONE_FLAT_FLAG, isFull = bitmask & $dcdfe05415212eb9$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $d252d56fd76f41df$export$2e2bcd8739ae039)(value)) return value;
    var isArr = (0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(value);
    if (isArr) {
        result = (0, $ddb314e0a92d1828$export$2e2bcd8739ae039)(value);
        if (!isDeep) return (0, $0888b9a44238f12f$export$2e2bcd8739ae039)(value, result);
    } else {
        var tag = (0, $a3da4848ad90ced6$export$2e2bcd8739ae039)(value), isFunc = tag == $dcdfe05415212eb9$var$funcTag || tag == $dcdfe05415212eb9$var$genTag;
        if ((0, $5Ckcr.default)(value)) return (0, $jxwfQ.default)(value, isDeep);
        if (tag == $dcdfe05415212eb9$var$objectTag || tag == $dcdfe05415212eb9$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $47d27bba7487fbd1$export$2e2bcd8739ae039)(value);
            if (!isDeep) return isFlat ? (0, $c61673011333b2f5$export$2e2bcd8739ae039)(value, (0, $0d551aa828ed9242$export$2e2bcd8739ae039)(result, value)) : (0, $d2f62f2a735791ac$export$2e2bcd8739ae039)(value, (0, $d234a7931fdcf66d$export$2e2bcd8739ae039)(result, value));
        } else {
            if (!$dcdfe05415212eb9$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $e15f83b2f781131c$export$2e2bcd8739ae039)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $955b5c2507d2790f$export$2e2bcd8739ae039));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $d938fc04ce69bf3d$export$2e2bcd8739ae039)(value)) value.forEach(function(subValue) {
        result.add($dcdfe05415212eb9$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $a6685a6fe0035047$export$2e2bcd8739ae039)(value)) value.forEach(function(subValue, key) {
        result.set(key, $dcdfe05415212eb9$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $cb4411947b1bbccd$export$2e2bcd8739ae039) : (0, $61e7ea9bc5ab67d7$export$2e2bcd8739ae039) : isFlat ? (0, $d87639e714c649a8$export$2e2bcd8739ae039) : (0, $39f39242faed4588$export$2e2bcd8739ae039);
    var props = isArr ? undefined : keysFunc(value);
    (0, $d36a4232bf514589$export$2e2bcd8739ae039)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $b51f6c87cf17fb01$export$2e2bcd8739ae039)(result, key, $dcdfe05415212eb9$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $dcdfe05415212eb9$export$2e2bcd8739ae039 = $dcdfe05415212eb9$var$baseClone;



/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $c366ba9e6f84292f$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
var $c366ba9e6f84292f$export$2e2bcd8739ae039 = $c366ba9e6f84292f$var$last;



/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $b232e62b313e7212$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
var $b232e62b313e7212$export$2e2bcd8739ae039 = $b232e62b313e7212$var$baseSlice;


/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $9d5dc1c47cfcfa9a$var$parent(object, path) {
    return path.length < 2 ? object : (0, $f82e6a7e1b9a1d35$export$2e2bcd8739ae039)(object, (0, $b232e62b313e7212$export$2e2bcd8739ae039)(path, 0, -1));
}
var $9d5dc1c47cfcfa9a$export$2e2bcd8739ae039 = $9d5dc1c47cfcfa9a$var$parent;



/** Used for built-in method references. */ var $a124f80e43b8a96f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a124f80e43b8a96f$var$hasOwnProperty = $a124f80e43b8a96f$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $a124f80e43b8a96f$var$baseUnset(object, path) {
    path = (0, $550dd133df69fd0b$export$2e2bcd8739ae039)(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = (0, $031a2cbe9b26e09a$export$2e2bcd8739ae039)(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$a124f80e43b8a96f$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = (0, $9d5dc1c47cfcfa9a$export$2e2bcd8739ae039)(object, path);
    return obj == null || delete obj[(0, $031a2cbe9b26e09a$export$2e2bcd8739ae039)((0, $c366ba9e6f84292f$export$2e2bcd8739ae039)(path))];
}
var $a124f80e43b8a96f$export$2e2bcd8739ae039 = $a124f80e43b8a96f$var$baseUnset;





/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $985ce04637db0cd6$var$customOmitClone(value) {
    return (0, $d6bfaab5809eb5e3$export$2e2bcd8739ae039)(value) ? undefined : value;
}
var $985ce04637db0cd6$export$2e2bcd8739ae039 = $985ce04637db0cd6$var$customOmitClone;






/** Built-in value references. */ var $08063707cdc5ebef$var$spreadableSymbol = (0, $899304693344e559$export$2e2bcd8739ae039) ? (0, $899304693344e559$export$2e2bcd8739ae039).isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $08063707cdc5ebef$var$isFlattenable(value) {
    return (0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(value) || (0, $4ede6273d5b53f32$export$2e2bcd8739ae039)(value) || !!($08063707cdc5ebef$var$spreadableSymbol && value && value[$08063707cdc5ebef$var$spreadableSymbol]);
}
var $08063707cdc5ebef$export$2e2bcd8739ae039 = $08063707cdc5ebef$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $b2ff9fbe68cb378d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = (0, $08063707cdc5ebef$export$2e2bcd8739ae039));
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $b2ff9fbe68cb378d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else (0, $4474f8bd50c8ed05$export$2e2bcd8739ae039)(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
var $b2ff9fbe68cb378d$export$2e2bcd8739ae039 = $b2ff9fbe68cb378d$var$baseFlatten;


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $6fcc5c625b7f5a28$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? (0, $b2ff9fbe68cb378d$export$2e2bcd8739ae039)(array, 1) : [];
}
var $6fcc5c625b7f5a28$export$2e2bcd8739ae039 = $6fcc5c625b7f5a28$var$flatten;


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $d77a0d8c3ec6a188$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $d77a0d8c3ec6a188$export$2e2bcd8739ae039 = $d77a0d8c3ec6a188$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $1c116dd728aed3e1$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $1c116dd728aed3e1$var$overRest(func, start, transform) {
    start = $1c116dd728aed3e1$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $1c116dd728aed3e1$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $d77a0d8c3ec6a188$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $1c116dd728aed3e1$export$2e2bcd8739ae039 = $1c116dd728aed3e1$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $8466ae50f09b15cc$var$constant(value) {
    return function() {
        return value;
    };
}
var $8466ae50f09b15cc$export$2e2bcd8739ae039 = $8466ae50f09b15cc$var$constant;



/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $84818b6a0aba192a$var$identity(value) {
    return value;
}
var $84818b6a0aba192a$export$2e2bcd8739ae039 = $84818b6a0aba192a$var$identity;


/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1239d2404d2ef260$var$baseSetToString = !(0, $5cb8d80b626d0c53$export$2e2bcd8739ae039) ? (0, $84818b6a0aba192a$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $5cb8d80b626d0c53$export$2e2bcd8739ae039)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $8466ae50f09b15cc$export$2e2bcd8739ae039)(string),
        'writable': true
    });
};
var $1239d2404d2ef260$export$2e2bcd8739ae039 = $1239d2404d2ef260$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $9014ffd0f19ca7e4$var$HOT_COUNT = 800, $9014ffd0f19ca7e4$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9014ffd0f19ca7e4$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $9014ffd0f19ca7e4$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $9014ffd0f19ca7e4$var$nativeNow(), remaining = $9014ffd0f19ca7e4$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $9014ffd0f19ca7e4$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $9014ffd0f19ca7e4$export$2e2bcd8739ae039 = $9014ffd0f19ca7e4$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $a90dfd60dbe2e43f$var$setToString = (0, $9014ffd0f19ca7e4$export$2e2bcd8739ae039)((0, $1239d2404d2ef260$export$2e2bcd8739ae039));
var $a90dfd60dbe2e43f$export$2e2bcd8739ae039 = $a90dfd60dbe2e43f$var$setToString;


/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $673aabd57681060c$var$flatRest(func) {
    return (0, $a90dfd60dbe2e43f$export$2e2bcd8739ae039)((0, $1c116dd728aed3e1$export$2e2bcd8739ae039)(func, undefined, (0, $6fcc5c625b7f5a28$export$2e2bcd8739ae039)), func + '');
}
var $673aabd57681060c$export$2e2bcd8739ae039 = $673aabd57681060c$var$flatRest;



/** Used to compose bitmasks for cloning. */ var $56d3aa46749de9f1$var$CLONE_DEEP_FLAG = 1, $56d3aa46749de9f1$var$CLONE_FLAT_FLAG = 2, $56d3aa46749de9f1$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $56d3aa46749de9f1$var$omit = (0, $673aabd57681060c$export$2e2bcd8739ae039)(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = (0, $a8b30b77f2b6a1c4$export$2e2bcd8739ae039)(paths, function(path) {
        path = (0, $550dd133df69fd0b$export$2e2bcd8739ae039)(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    (0, $626987d1111ad093$export$2e2bcd8739ae039)(object, (0, $cb4411947b1bbccd$export$2e2bcd8739ae039)(object), result);
    if (isDeep) result = (0, $dcdfe05415212eb9$export$2e2bcd8739ae039)(result, $56d3aa46749de9f1$var$CLONE_DEEP_FLAG | $56d3aa46749de9f1$var$CLONE_FLAT_FLAG | $56d3aa46749de9f1$var$CLONE_SYMBOLS_FLAG, (0, $985ce04637db0cd6$export$2e2bcd8739ae039));
    var length = paths.length;
    while(length--)(0, $a124f80e43b8a96f$export$2e2bcd8739ae039)(result, paths[length]);
    return result;
});
var $56d3aa46749de9f1$export$2e2bcd8739ae039 = $56d3aa46749de9f1$var$omit;



/** Looks for the `$id` pointed by `ref` in the schema definitions embedded in
 * a JSON Schema bundle
 *
 * @param schema - The schema wherein `ref` should be searched
 * @param ref - The `$id` of the reference to search for
 * @returns - The schema matching the reference, or `undefined` if no match is found
 */ function $9bd5acf65f690f1a$var$findEmbeddedSchemaRecursive(schema, ref) {
    if ((0, $cd207018ee28cb28$export$f453fd324e92d331) in schema && (0, (/*@__PURE__*/$parcel$interopDefault($9C0cr))).equal(schema[0, $cd207018ee28cb28$export$f453fd324e92d331], ref)) return schema;
    for (const subSchema of Object.values(schema)){
        if (Array.isArray(subSchema)) {
            for (const item of subSchema)if ((0, $d252d56fd76f41df$export$2e2bcd8739ae039)(item)) {
                const result = $9bd5acf65f690f1a$var$findEmbeddedSchemaRecursive(item, ref);
                if (result !== undefined) return result;
            }
        } else if ((0, $d252d56fd76f41df$export$2e2bcd8739ae039)(subSchema)) {
            const result = $9bd5acf65f690f1a$var$findEmbeddedSchemaRecursive(subSchema, ref);
            if (result !== undefined) return result;
        }
    }
    return undefined;
}
function $9bd5acf65f690f1a$export$20de22aec449cb91(schema, baseURI) {
    const currentURI = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$f453fd324e92d331), baseURI);
    let result = schema;
    // Make all other references absolute
    if ((0, $cd207018ee28cb28$export$cf02ae06bf291db4) in result) result = {
        ...result,
        [(0, $cd207018ee28cb28$export$cf02ae06bf291db4)]: (0, (/*@__PURE__*/$parcel$interopDefault($9C0cr))).resolve(currentURI, result[0, $cd207018ee28cb28$export$cf02ae06bf291db4])
    };
    // Look for references in nested subschemas
    for (const [key, subSchema] of Object.entries(result)){
        if (Array.isArray(subSchema)) result = {
            ...result,
            [key]: subSchema.map((item)=>(0, $d252d56fd76f41df$export$2e2bcd8739ae039)(item) ? $9bd5acf65f690f1a$export$20de22aec449cb91(item, currentURI) : item)
        };
        else if ((0, $d252d56fd76f41df$export$2e2bcd8739ae039)(subSchema)) result = {
            ...result,
            [key]: $9bd5acf65f690f1a$export$20de22aec449cb91(subSchema, currentURI)
        };
    }
    return result;
}
function $9bd5acf65f690f1a$export$4faa4e6ce874f724(key, object) {
    const value = object[key];
    const remaining = (0, $56d3aa46749de9f1$export$2e2bcd8739ae039)(object, [
        key
    ]);
    return [
        remaining,
        value
    ];
}
function $9bd5acf65f690f1a$export$2f837d5ac6fe6cdf($ref, rootSchema = {}, recurseList = [], baseURI = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(rootSchema, [
    (0, $cd207018ee28cb28$export$f453fd324e92d331)
])) {
    const ref = $ref || '';
    let current = undefined;
    let currentBaseURI = baseURI;
    if (ref.startsWith('#')) {
        // Decode URI fragment representation.
        const decodedRef = decodeURIComponent(ref.substring(1));
        if (currentBaseURI === undefined || (0, $cd207018ee28cb28$export$f453fd324e92d331) in rootSchema && rootSchema[0, $cd207018ee28cb28$export$f453fd324e92d331] === currentBaseURI) current = (0, (/*@__PURE__*/$parcel$interopDefault($0e66a35a574246f9$exports))).get(rootSchema, decodedRef);
        else if (rootSchema[0, $cd207018ee28cb28$export$8a468b2f7e566028] === (0, $cd207018ee28cb28$export$aea1c08d06ae9175)) {
            current = $9bd5acf65f690f1a$var$findEmbeddedSchemaRecursive(rootSchema, currentBaseURI.replace(/\/$/, ''));
            if (current !== undefined) current = (0, (/*@__PURE__*/$parcel$interopDefault($0e66a35a574246f9$exports))).get(current, decodedRef);
        }
    } else if (rootSchema[0, $cd207018ee28cb28$export$8a468b2f7e566028] === (0, $cd207018ee28cb28$export$aea1c08d06ae9175)) {
        const resolvedRef = currentBaseURI ? (0, (/*@__PURE__*/$parcel$interopDefault($9C0cr))).resolve(currentBaseURI, ref) : ref;
        const [refId, ...refAnchor] = resolvedRef.replace(/#\/?$/, '').split('#');
        current = $9bd5acf65f690f1a$var$findEmbeddedSchemaRecursive(rootSchema, refId.replace(/\/$/, ''));
        if (current !== undefined) {
            currentBaseURI = current[0, $cd207018ee28cb28$export$f453fd324e92d331];
            if (!(0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(refAnchor)) current = (0, (/*@__PURE__*/$parcel$interopDefault($0e66a35a574246f9$exports))).get(current, decodeURIComponent(refAnchor.join('#')));
        }
    }
    if (current === undefined) throw new Error(`Could not find a definition for ${$ref}.`);
    const nextRef = current[0, $cd207018ee28cb28$export$cf02ae06bf291db4];
    if (nextRef) {
        // Check for circular references.
        if (recurseList.includes(nextRef)) {
            if (recurseList.length === 1) throw new Error(`Definition for ${$ref} is a circular reference`);
            const [firstRef, ...restRefs] = recurseList;
            const circularPath = [
                ...restRefs,
                ref,
                firstRef
            ].join(' -> ');
            throw new Error(`Definition for ${firstRef} contains a circular reference through ${circularPath}`);
        }
        const [remaining, theRef] = $9bd5acf65f690f1a$export$4faa4e6ce874f724((0, $cd207018ee28cb28$export$cf02ae06bf291db4), current);
        const subSchema = $9bd5acf65f690f1a$export$2f837d5ac6fe6cdf(theRef, rootSchema, [
            ...recurseList,
            ref
        ], currentBaseURI);
        if (Object.keys(remaining).length > 0) {
            if (rootSchema[0, $cd207018ee28cb28$export$8a468b2f7e566028] === (0, $cd207018ee28cb28$export$dcb10e91e0226750) || rootSchema[0, $cd207018ee28cb28$export$8a468b2f7e566028] === (0, $cd207018ee28cb28$export$aea1c08d06ae9175)) return {
                [(0, $cd207018ee28cb28$export$d2b65f1d256ab906)]: [
                    remaining,
                    subSchema
                ]
            };
            return {
                ...remaining,
                ...subSchema
            };
        }
        return subSchema;
    }
    return current;
}
function $9bd5acf65f690f1a$export$2e2bcd8739ae039($ref, rootSchema = {}, baseURI = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(rootSchema, [
    (0, $cd207018ee28cb28$export$f453fd324e92d331)
])) {
    const recurseList = [];
    return $9bd5acf65f690f1a$export$2f837d5ac6fe6cdf($ref, rootSchema, recurseList, baseURI);
}



/** Used for built-in method references. */ var $78246f843a7bcfb6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $78246f843a7bcfb6$var$hasOwnProperty = $78246f843a7bcfb6$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $78246f843a7bcfb6$var$baseHas(object, key) {
    return object != null && $78246f843a7bcfb6$var$hasOwnProperty.call(object, key);
}
var $78246f843a7bcfb6$export$2e2bcd8739ae039 = $78246f843a7bcfb6$var$baseHas;








/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $9bcfbfad7ec7e7b4$var$hasPath(object, path, hasFunc) {
    path = (0, $550dd133df69fd0b$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $031a2cbe9b26e09a$export$2e2bcd8739ae039)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $284fcf77a1deaeef$export$2e2bcd8739ae039)(length) && (0, $a7f219d5ae6652bf$export$2e2bcd8739ae039)(key, length) && ((0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(object) || (0, $4ede6273d5b53f32$export$2e2bcd8739ae039)(object));
}
var $9bcfbfad7ec7e7b4$export$2e2bcd8739ae039 = $9bcfbfad7ec7e7b4$var$hasPath;


/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $52f1e6e82878153c$var$has(object, path) {
    return object != null && (0, $9bcfbfad7ec7e7b4$export$2e2bcd8739ae039)(object, path, (0, $78246f843a7bcfb6$export$2e2bcd8739ae039));
}
var $52f1e6e82878153c$export$2e2bcd8739ae039 = $52f1e6e82878153c$var$has;










/** `Object#toString` result references. */ var $e6fe0b0844d2a1c4$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $e6fe0b0844d2a1c4$var$isString(value) {
    return typeof value == 'string' || !(0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(value) && (0, $754274dccdb4db10$export$2e2bcd8739ae039)(value) && (0, $95eecc554ecfdc33$export$2e2bcd8739ae039)(value) == $e6fe0b0844d2a1c4$var$stringTag;
}
var $e6fe0b0844d2a1c4$export$2e2bcd8739ae039 = $e6fe0b0844d2a1c4$var$isString;



function $9b9eddfbb66bfc4e$export$2e2bcd8739ae039(schema) {
    let discriminator;
    const maybeString = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$137032ceab080b94));
    if ((0, $e6fe0b0844d2a1c4$export$2e2bcd8739ae039)(maybeString)) discriminator = maybeString;
    else if (maybeString !== undefined) // oxlint-disable-next-line no-console
    console.warn(`Expecting discriminator to be a string, got "${typeof maybeString}" instead`);
    return discriminator;
}



/** Used as references for various `Number` constants. */ var $28f26c04657f54ba$var$INFINITY = 1 / 0;
/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */ function $28f26c04657f54ba$var$flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? (0, $b2ff9fbe68cb378d$export$2e2bcd8739ae039)(array, $28f26c04657f54ba$var$INFINITY) : [];
}
var $28f26c04657f54ba$export$2e2bcd8739ae039 = $28f26c04657f54ba$var$flattenDeep;







/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $feed295680dd5a8a$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $b65447e8fe19238e$export$2e2bcd8739ae039)(object[key], value) || value === undefined && !(key in object)) (0, $d0d577faa5319a30$export$2e2bcd8739ae039)(object, key, value);
}
var $feed295680dd5a8a$export$2e2bcd8739ae039 = $feed295680dd5a8a$var$assignMergeValue;


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $611f1c4a31fe534d$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $611f1c4a31fe534d$export$2e2bcd8739ae039 = $611f1c4a31fe534d$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $8430d27a79128691$var$baseFor = (0, $611f1c4a31fe534d$export$2e2bcd8739ae039)();
var $8430d27a79128691$export$2e2bcd8739ae039 = $8430d27a79128691$var$baseFor;




var $jxwfQ = parcelRequire("jxwfQ");







/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $1d95c744ae2c26f0$var$isArrayLikeObject(value) {
    return (0, $754274dccdb4db10$export$2e2bcd8739ae039)(value) && (0, $baeea2f3638e715c$export$2e2bcd8739ae039)(value);
}
var $1d95c744ae2c26f0$export$2e2bcd8739ae039 = $1d95c744ae2c26f0$var$isArrayLikeObject;



var $5Ckcr = parcelRequire("5Ckcr");




/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $dbc7856c15d23dba$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
var $dbc7856c15d23dba$export$2e2bcd8739ae039 = $dbc7856c15d23dba$var$safeGet;




/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $8ef015b78d6aad14$var$toPlainObject(value) {
    return (0, $626987d1111ad093$export$2e2bcd8739ae039)(value, (0, $d87639e714c649a8$export$2e2bcd8739ae039)(value));
}
var $8ef015b78d6aad14$export$2e2bcd8739ae039 = $8ef015b78d6aad14$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $881aa93d96adec9e$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $dbc7856c15d23dba$export$2e2bcd8739ae039)(object, key), srcValue = (0, $dbc7856c15d23dba$export$2e2bcd8739ae039)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $feed295680dd5a8a$export$2e2bcd8739ae039)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(srcValue), isBuff = !isArr && (0, $5Ckcr.default)(srcValue), isTyped = !isArr && !isBuff && (0, $d7cefc60683de4c9$export$2e2bcd8739ae039)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(objValue)) newValue = objValue;
            else if ((0, $1d95c744ae2c26f0$export$2e2bcd8739ae039)(objValue)) newValue = (0, $0888b9a44238f12f$export$2e2bcd8739ae039)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $jxwfQ.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $fa52226bab133417$export$2e2bcd8739ae039)(srcValue, true);
            } else newValue = [];
        } else if ((0, $d6bfaab5809eb5e3$export$2e2bcd8739ae039)(srcValue) || (0, $4ede6273d5b53f32$export$2e2bcd8739ae039)(srcValue)) {
            newValue = objValue;
            if ((0, $4ede6273d5b53f32$export$2e2bcd8739ae039)(objValue)) newValue = (0, $8ef015b78d6aad14$export$2e2bcd8739ae039)(objValue);
            else if (!(0, $d252d56fd76f41df$export$2e2bcd8739ae039)(objValue) || (0, $e8276fc8779dcffd$export$2e2bcd8739ae039)(objValue)) newValue = (0, $47d27bba7487fbd1$export$2e2bcd8739ae039)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, $feed295680dd5a8a$export$2e2bcd8739ae039)(object, key, newValue);
}
var $881aa93d96adec9e$export$2e2bcd8739ae039 = $881aa93d96adec9e$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $e60b01a639b5589c$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $8430d27a79128691$export$2e2bcd8739ae039)(source, function(srcValue, key) {
        stack || (stack = new (0, $955b5c2507d2790f$export$2e2bcd8739ae039));
        if ((0, $d252d56fd76f41df$export$2e2bcd8739ae039)(srcValue)) (0, $881aa93d96adec9e$export$2e2bcd8739ae039)(object, source, key, srcIndex, $e60b01a639b5589c$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $dbc7856c15d23dba$export$2e2bcd8739ae039)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $feed295680dd5a8a$export$2e2bcd8739ae039)(object, key, newValue);
        }
    }, (0, $d87639e714c649a8$export$2e2bcd8739ae039));
}
var $e60b01a639b5589c$export$2e2bcd8739ae039 = $e60b01a639b5589c$var$baseMerge;





/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $d3bee9049ca44be7$var$baseRest(func, start) {
    return (0, $a90dfd60dbe2e43f$export$2e2bcd8739ae039)((0, $1c116dd728aed3e1$export$2e2bcd8739ae039)(func, start, (0, $84818b6a0aba192a$export$2e2bcd8739ae039)), func + '');
}
var $d3bee9049ca44be7$export$2e2bcd8739ae039 = $d3bee9049ca44be7$var$baseRest;






/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $52da043b8243fcf2$var$isIterateeCall(value, index, object) {
    if (!(0, $d252d56fd76f41df$export$2e2bcd8739ae039)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, $baeea2f3638e715c$export$2e2bcd8739ae039)(object) && (0, $a7f219d5ae6652bf$export$2e2bcd8739ae039)(index, object.length) : type == 'string' && index in object) return (0, $b65447e8fe19238e$export$2e2bcd8739ae039)(object[index], value);
    return false;
}
var $52da043b8243fcf2$export$2e2bcd8739ae039 = $52da043b8243fcf2$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $98873b54e704e579$var$createAssigner(assigner) {
    return (0, $d3bee9049ca44be7$export$2e2bcd8739ae039)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, $52da043b8243fcf2$export$2e2bcd8739ae039)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $98873b54e704e579$export$2e2bcd8739ae039 = $98873b54e704e579$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $7e4a81f1f30416cf$var$merge = (0, $98873b54e704e579$export$2e2bcd8739ae039)(function(object, source, srcIndex) {
    (0, $e60b01a639b5589c$export$2e2bcd8739ae039)(object, source, srcIndex);
});
var $7e4a81f1f30416cf$export$2e2bcd8739ae039 = $7e4a81f1f30416cf$var$merge;







/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $07920a1e18250d4e$var$baseSet(object, path, value, customizer) {
    if (!(0, $d252d56fd76f41df$export$2e2bcd8739ae039)(object)) return object;
    path = (0, $550dd133df69fd0b$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = (0, $031a2cbe9b26e09a$export$2e2bcd8739ae039)(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = (0, $d252d56fd76f41df$export$2e2bcd8739ae039)(objValue) ? objValue : (0, $a7f219d5ae6652bf$export$2e2bcd8739ae039)(path[index + 1]) ? [] : {};
        }
        (0, $b51f6c87cf17fb01$export$2e2bcd8739ae039)(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
var $07920a1e18250d4e$export$2e2bcd8739ae039 = $07920a1e18250d4e$var$baseSet;


/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c78fa5e9588d54fe$var$set(object, path, value) {
    return object == null ? object : (0, $07920a1e18250d4e$export$2e2bcd8739ae039)(object, path, value);
}
var $c78fa5e9588d54fe$export$2e2bcd8739ae039 = $c78fa5e9588d54fe$var$set;




/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $41725e7aae11058e$var$castFunction(value) {
    return typeof value == 'function' ? value : (0, $84818b6a0aba192a$export$2e2bcd8739ae039);
}
var $41725e7aae11058e$export$2e2bcd8739ae039 = $41725e7aae11058e$var$castFunction;


/** Used to match a single whitespace character. */ var $16beb1315fec853a$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $16beb1315fec853a$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $16beb1315fec853a$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $16beb1315fec853a$export$2e2bcd8739ae039 = $16beb1315fec853a$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $b079e8fe6a5f120e$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $b079e8fe6a5f120e$var$baseTrim(string) {
    return string ? string.slice(0, (0, $16beb1315fec853a$export$2e2bcd8739ae039)(string) + 1).replace($b079e8fe6a5f120e$var$reTrimStart, '') : string;
}
var $b079e8fe6a5f120e$export$2e2bcd8739ae039 = $b079e8fe6a5f120e$var$baseTrim;




/** Used as references for various `Number` constants. */ var $a028161f0982a70d$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $a028161f0982a70d$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $a028161f0982a70d$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $a028161f0982a70d$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $a028161f0982a70d$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $a028161f0982a70d$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ((0, $ab251a97c515dcdc$export$2e2bcd8739ae039)(value)) return $a028161f0982a70d$var$NAN;
    if ((0, $d252d56fd76f41df$export$2e2bcd8739ae039)(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = (0, $d252d56fd76f41df$export$2e2bcd8739ae039)(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = (0, $b079e8fe6a5f120e$export$2e2bcd8739ae039)(value);
    var isBinary = $a028161f0982a70d$var$reIsBinary.test(value);
    return isBinary || $a028161f0982a70d$var$reIsOctal.test(value) ? $a028161f0982a70d$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $a028161f0982a70d$var$reIsBadHex.test(value) ? $a028161f0982a70d$var$NAN : +value;
}
var $a028161f0982a70d$export$2e2bcd8739ae039 = $a028161f0982a70d$var$toNumber;


/** Used as references for various `Number` constants. */ var $2ee6373d556e2ef9$var$INFINITY = 1 / 0, $2ee6373d556e2ef9$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $2ee6373d556e2ef9$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = (0, $a028161f0982a70d$export$2e2bcd8739ae039)(value);
    if (value === $2ee6373d556e2ef9$var$INFINITY || value === -$2ee6373d556e2ef9$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $2ee6373d556e2ef9$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
var $2ee6373d556e2ef9$export$2e2bcd8739ae039 = $2ee6373d556e2ef9$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $29bba4b1e2a20523$var$toInteger(value) {
    var result = (0, $2ee6373d556e2ef9$export$2e2bcd8739ae039)(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
var $29bba4b1e2a20523$export$2e2bcd8739ae039 = $29bba4b1e2a20523$var$toInteger;


/** Used as references for various `Number` constants. */ var $e2028ac919d540eb$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used as references for the maximum length and index of an array. */ var $e2028ac919d540eb$var$MAX_ARRAY_LENGTH = 4294967295;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e2028ac919d540eb$var$nativeMin = Math.min;
/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */ function $e2028ac919d540eb$var$times(n, iteratee) {
    n = (0, $29bba4b1e2a20523$export$2e2bcd8739ae039)(n);
    if (n < 1 || n > $e2028ac919d540eb$var$MAX_SAFE_INTEGER) return [];
    var index = $e2028ac919d540eb$var$MAX_ARRAY_LENGTH, length = $e2028ac919d540eb$var$nativeMin(n, $e2028ac919d540eb$var$MAX_ARRAY_LENGTH);
    iteratee = (0, $41725e7aae11058e$export$2e2bcd8739ae039)(iteratee);
    n -= $e2028ac919d540eb$var$MAX_ARRAY_LENGTH;
    var result = (0, $f4e8e766d057d979$export$2e2bcd8739ae039)(length, iteratee);
    while(++index < n)iteratee(index);
    return result;
}
var $e2028ac919d540eb$export$2e2bcd8739ae039 = $e2028ac919d540eb$var$times;






/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $c715a153ba2e3159$var$baseForOwn(object, iteratee) {
    return object && (0, $8430d27a79128691$export$2e2bcd8739ae039)(object, iteratee, (0, $39f39242faed4588$export$2e2bcd8739ae039));
}
var $c715a153ba2e3159$export$2e2bcd8739ae039 = $c715a153ba2e3159$var$baseForOwn;





/** Used to stand-in for `undefined` hash values. */ var $0c8fffdb750309c0$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $0c8fffdb750309c0$var$setCacheAdd(value) {
    this.__data__.set(value, $0c8fffdb750309c0$var$HASH_UNDEFINED);
    return this;
}
var $0c8fffdb750309c0$export$2e2bcd8739ae039 = $0c8fffdb750309c0$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $f231458cbf91cd93$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $f231458cbf91cd93$export$2e2bcd8739ae039 = $f231458cbf91cd93$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $ab54149517cb0b02$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $9935e83a362a1d93$export$2e2bcd8739ae039);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$ab54149517cb0b02$var$SetCache.prototype.add = $ab54149517cb0b02$var$SetCache.prototype.push = (0, $0c8fffdb750309c0$export$2e2bcd8739ae039);
$ab54149517cb0b02$var$SetCache.prototype.has = (0, $f231458cbf91cd93$export$2e2bcd8739ae039);
var $ab54149517cb0b02$export$2e2bcd8739ae039 = $ab54149517cb0b02$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $a5a72c31e5ae0734$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $a5a72c31e5ae0734$export$2e2bcd8739ae039 = $a5a72c31e5ae0734$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f4852737a03c39ca$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $f4852737a03c39ca$export$2e2bcd8739ae039 = $f4852737a03c39ca$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $a61715c82d03868d$var$COMPARE_PARTIAL_FLAG = 1, $a61715c82d03868d$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $a61715c82d03868d$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $a61715c82d03868d$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $a61715c82d03868d$var$COMPARE_UNORDERED_FLAG ? new (0, $ab54149517cb0b02$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $a5a72c31e5ae0734$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $f4852737a03c39ca$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $a61715c82d03868d$export$2e2bcd8739ae039 = $a61715c82d03868d$var$equalArrays;






/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $333090cb73a8ec50$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $333090cb73a8ec50$export$2e2bcd8739ae039 = $333090cb73a8ec50$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $06d82f661002cbfc$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $06d82f661002cbfc$export$2e2bcd8739ae039 = $06d82f661002cbfc$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $504189f87a506449$var$COMPARE_PARTIAL_FLAG = 1, $504189f87a506449$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $504189f87a506449$var$boolTag = '[object Boolean]', $504189f87a506449$var$dateTag = '[object Date]', $504189f87a506449$var$errorTag = '[object Error]', $504189f87a506449$var$mapTag = '[object Map]', $504189f87a506449$var$numberTag = '[object Number]', $504189f87a506449$var$regexpTag = '[object RegExp]', $504189f87a506449$var$setTag = '[object Set]', $504189f87a506449$var$stringTag = '[object String]', $504189f87a506449$var$symbolTag = '[object Symbol]';
var $504189f87a506449$var$arrayBufferTag = '[object ArrayBuffer]', $504189f87a506449$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $504189f87a506449$var$symbolProto = (0, $899304693344e559$export$2e2bcd8739ae039) ? (0, $899304693344e559$export$2e2bcd8739ae039).prototype : undefined, $504189f87a506449$var$symbolValueOf = $504189f87a506449$var$symbolProto ? $504189f87a506449$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $504189f87a506449$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $504189f87a506449$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $504189f87a506449$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $30da13388cbc1889$export$2e2bcd8739ae039)(object), new (0, $30da13388cbc1889$export$2e2bcd8739ae039)(other))) return false;
            return true;
        case $504189f87a506449$var$boolTag:
        case $504189f87a506449$var$dateTag:
        case $504189f87a506449$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $b65447e8fe19238e$export$2e2bcd8739ae039)(+object, +other);
        case $504189f87a506449$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $504189f87a506449$var$regexpTag:
        case $504189f87a506449$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $504189f87a506449$var$mapTag:
            var convert = (0, $333090cb73a8ec50$export$2e2bcd8739ae039);
        case $504189f87a506449$var$setTag:
            var isPartial = bitmask & $504189f87a506449$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $06d82f661002cbfc$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $504189f87a506449$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $a61715c82d03868d$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $504189f87a506449$var$symbolTag:
            if ($504189f87a506449$var$symbolValueOf) return $504189f87a506449$var$symbolValueOf.call(object) == $504189f87a506449$var$symbolValueOf.call(other);
    }
    return false;
}
var $504189f87a506449$export$2e2bcd8739ae039 = $504189f87a506449$var$equalByTag;



/** Used to compose bitmasks for value comparisons. */ var $14bf2ef5f490fb4a$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $14bf2ef5f490fb4a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $14bf2ef5f490fb4a$var$hasOwnProperty = $14bf2ef5f490fb4a$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $14bf2ef5f490fb4a$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $14bf2ef5f490fb4a$var$COMPARE_PARTIAL_FLAG, objProps = (0, $61e7ea9bc5ab67d7$export$2e2bcd8739ae039)(object), objLength = objProps.length, othProps = (0, $61e7ea9bc5ab67d7$export$2e2bcd8739ae039)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $14bf2ef5f490fb4a$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $14bf2ef5f490fb4a$export$2e2bcd8739ae039 = $14bf2ef5f490fb4a$var$equalObjects;





var $5Ckcr = parcelRequire("5Ckcr");

/** Used to compose bitmasks for value comparisons. */ var $c128c5baec54b800$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $c128c5baec54b800$var$argsTag = '[object Arguments]', $c128c5baec54b800$var$arrayTag = '[object Array]', $c128c5baec54b800$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $c128c5baec54b800$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c128c5baec54b800$var$hasOwnProperty = $c128c5baec54b800$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c128c5baec54b800$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(object), othIsArr = (0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(other), objTag = objIsArr ? $c128c5baec54b800$var$arrayTag : (0, $a3da4848ad90ced6$export$2e2bcd8739ae039)(object), othTag = othIsArr ? $c128c5baec54b800$var$arrayTag : (0, $a3da4848ad90ced6$export$2e2bcd8739ae039)(other);
    objTag = objTag == $c128c5baec54b800$var$argsTag ? $c128c5baec54b800$var$objectTag : objTag;
    othTag = othTag == $c128c5baec54b800$var$argsTag ? $c128c5baec54b800$var$objectTag : othTag;
    var objIsObj = objTag == $c128c5baec54b800$var$objectTag, othIsObj = othTag == $c128c5baec54b800$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $5Ckcr.default)(object)) {
        if (!(0, $5Ckcr.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $955b5c2507d2790f$export$2e2bcd8739ae039));
        return objIsArr || (0, $d7cefc60683de4c9$export$2e2bcd8739ae039)(object) ? (0, $a61715c82d03868d$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $504189f87a506449$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $c128c5baec54b800$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $c128c5baec54b800$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $c128c5baec54b800$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $955b5c2507d2790f$export$2e2bcd8739ae039));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $955b5c2507d2790f$export$2e2bcd8739ae039));
    return (0, $14bf2ef5f490fb4a$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $c128c5baec54b800$export$2e2bcd8739ae039 = $c128c5baec54b800$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $7b155f1420b50f4a$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $754274dccdb4db10$export$2e2bcd8739ae039)(value) && !(0, $754274dccdb4db10$export$2e2bcd8739ae039)(other)) return value !== value && other !== other;
    return (0, $c128c5baec54b800$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $7b155f1420b50f4a$var$baseIsEqual, stack);
}
var $7b155f1420b50f4a$export$2e2bcd8739ae039 = $7b155f1420b50f4a$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $827e0c6ac991ff26$var$COMPARE_PARTIAL_FLAG = 1, $827e0c6ac991ff26$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $827e0c6ac991ff26$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $955b5c2507d2790f$export$2e2bcd8739ae039);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $7b155f1420b50f4a$export$2e2bcd8739ae039)(srcValue, objValue, $827e0c6ac991ff26$var$COMPARE_PARTIAL_FLAG | $827e0c6ac991ff26$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $827e0c6ac991ff26$export$2e2bcd8739ae039 = $827e0c6ac991ff26$var$baseIsMatch;



/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $232ea07b060afa10$var$isStrictComparable(value) {
    return value === value && !(0, $d252d56fd76f41df$export$2e2bcd8739ae039)(value);
}
var $232ea07b060afa10$export$2e2bcd8739ae039 = $232ea07b060afa10$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $a6c23a087e75cdc0$var$getMatchData(object) {
    var result = (0, $39f39242faed4588$export$2e2bcd8739ae039)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $232ea07b060afa10$export$2e2bcd8739ae039)(value)
        ];
    }
    return result;
}
var $a6c23a087e75cdc0$export$2e2bcd8739ae039 = $a6c23a087e75cdc0$var$getMatchData;


/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $0100ed3c4d636166$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $0100ed3c4d636166$export$2e2bcd8739ae039 = $0100ed3c4d636166$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $2b441504a374fbd0$var$baseMatches(source) {
    var matchData = (0, $a6c23a087e75cdc0$export$2e2bcd8739ae039)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $0100ed3c4d636166$export$2e2bcd8739ae039)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $827e0c6ac991ff26$export$2e2bcd8739ae039)(object, source, matchData);
    };
}
var $2b441504a374fbd0$export$2e2bcd8739ae039 = $2b441504a374fbd0$var$baseMatches;




/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $669b0b88ebf2ca1f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $669b0b88ebf2ca1f$export$2e2bcd8739ae039 = $669b0b88ebf2ca1f$var$baseHasIn;



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $725ca700b89428ac$var$hasIn(object, path) {
    return object != null && (0, $9bcfbfad7ec7e7b4$export$2e2bcd8739ae039)(object, path, (0, $669b0b88ebf2ca1f$export$2e2bcd8739ae039));
}
var $725ca700b89428ac$export$2e2bcd8739ae039 = $725ca700b89428ac$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $9bf5b06b5cceb74a$var$COMPARE_PARTIAL_FLAG = 1, $9bf5b06b5cceb74a$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $9bf5b06b5cceb74a$var$baseMatchesProperty(path, srcValue) {
    if ((0, $5ff13a12e3e7316f$export$2e2bcd8739ae039)(path) && (0, $232ea07b060afa10$export$2e2bcd8739ae039)(srcValue)) return (0, $0100ed3c4d636166$export$2e2bcd8739ae039)((0, $031a2cbe9b26e09a$export$2e2bcd8739ae039)(path), srcValue);
    return function(object) {
        var objValue = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $725ca700b89428ac$export$2e2bcd8739ae039)(object, path) : (0, $7b155f1420b50f4a$export$2e2bcd8739ae039)(srcValue, objValue, $9bf5b06b5cceb74a$var$COMPARE_PARTIAL_FLAG | $9bf5b06b5cceb74a$var$COMPARE_UNORDERED_FLAG);
    };
}
var $9bf5b06b5cceb74a$export$2e2bcd8739ae039 = $9bf5b06b5cceb74a$var$baseMatchesProperty;




/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $1aa5edbdc6dd8ca1$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $1aa5edbdc6dd8ca1$export$2e2bcd8739ae039 = $1aa5edbdc6dd8ca1$var$baseProperty;



/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $f9a3e434ec29ecc2$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $f82e6a7e1b9a1d35$export$2e2bcd8739ae039)(object, path);
    };
}
var $f9a3e434ec29ecc2$export$2e2bcd8739ae039 = $f9a3e434ec29ecc2$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $76ea1e41076bbe27$var$property(path) {
    return (0, $5ff13a12e3e7316f$export$2e2bcd8739ae039)(path) ? (0, $1aa5edbdc6dd8ca1$export$2e2bcd8739ae039)((0, $031a2cbe9b26e09a$export$2e2bcd8739ae039)(path)) : (0, $f9a3e434ec29ecc2$export$2e2bcd8739ae039)(path);
}
var $76ea1e41076bbe27$export$2e2bcd8739ae039 = $76ea1e41076bbe27$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $bf4c4ea4610241c9$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return 0, $84818b6a0aba192a$export$2e2bcd8739ae039;
    if (typeof value == 'object') return (0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(value) ? (0, $9bf5b06b5cceb74a$export$2e2bcd8739ae039)(value[0], value[1]) : (0, $2b441504a374fbd0$export$2e2bcd8739ae039)(value);
    return (0, $76ea1e41076bbe27$export$2e2bcd8739ae039)(value);
}
var $bf4c4ea4610241c9$export$2e2bcd8739ae039 = $bf4c4ea4610241c9$var$baseIteratee;





var $5Ckcr = parcelRequire("5Ckcr");



/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */ function $9dd0d1c96cb95cfd$var$transform(object, iteratee, accumulator) {
    var isArr = (0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(object), isArrLike = isArr || (0, $5Ckcr.default)(object) || (0, $d7cefc60683de4c9$export$2e2bcd8739ae039)(object);
    iteratee = (0, $bf4c4ea4610241c9$export$2e2bcd8739ae039)(iteratee, 4);
    if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) accumulator = isArr ? new Ctor : [];
        else if ((0, $d252d56fd76f41df$export$2e2bcd8739ae039)(object)) accumulator = (0, $e8276fc8779dcffd$export$2e2bcd8739ae039)(Ctor) ? (0, $f163497528577208$export$2e2bcd8739ae039)((0, $0b14821d94ad35ef$export$2e2bcd8739ae039)(object)) : {};
        else accumulator = {};
    }
    (isArrLike ? (0, $d36a4232bf514589$export$2e2bcd8739ae039) : (0, $c715a153ba2e3159$export$2e2bcd8739ae039))(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
    });
    return accumulator;
}
var $9dd0d1c96cb95cfd$export$2e2bcd8739ae039 = $9dd0d1c96cb95cfd$var$transform;



/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a6be57a7183868a8$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
var $a6be57a7183868a8$export$2e2bcd8739ae039 = $a6be57a7183868a8$var$baseFindIndex;


/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $08af8998c0ce9781$var$baseIsNaN(value) {
    return value !== value;
}
var $08af8998c0ce9781$export$2e2bcd8739ae039 = $08af8998c0ce9781$var$baseIsNaN;


/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4faeaa71ff403422$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
var $4faeaa71ff403422$export$2e2bcd8739ae039 = $4faeaa71ff403422$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $64f5709d1e6fbd8c$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? (0, $4faeaa71ff403422$export$2e2bcd8739ae039)(array, value, fromIndex) : (0, $a6be57a7183868a8$export$2e2bcd8739ae039)(array, (0, $08af8998c0ce9781$export$2e2bcd8739ae039), fromIndex);
}
var $64f5709d1e6fbd8c$export$2e2bcd8739ae039 = $64f5709d1e6fbd8c$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5c89fabc27f935b9$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && (0, $64f5709d1e6fbd8c$export$2e2bcd8739ae039)(array, value, 0) > -1;
}
var $5c89fabc27f935b9$export$2e2bcd8739ae039 = $5c89fabc27f935b9$var$arrayIncludes;


/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $2f5198bd8bb7a519$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
var $2f5198bd8bb7a519$export$2e2bcd8739ae039 = $2f5198bd8bb7a519$var$arrayIncludesWith;




/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $46102801b81c7243$var$noop() {
// No operation performed.
}
var $46102801b81c7243$export$2e2bcd8739ae039 = $46102801b81c7243$var$noop;



/** Used as references for various `Number` constants. */ var $2619e8ecfb959c45$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $2619e8ecfb959c45$var$createSet = !((0, $859ed7bb7a280e67$export$2e2bcd8739ae039) && 1 / (0, $06d82f661002cbfc$export$2e2bcd8739ae039)(new (0, $859ed7bb7a280e67$export$2e2bcd8739ae039)([
    ,
    -0
]))[1] == $2619e8ecfb959c45$var$INFINITY) ? (0, $46102801b81c7243$export$2e2bcd8739ae039) : function(values) {
    return new (0, $859ed7bb7a280e67$export$2e2bcd8739ae039)(values);
};
var $2619e8ecfb959c45$export$2e2bcd8739ae039 = $2619e8ecfb959c45$var$createSet;



/** Used as the size to enable large array optimizations. */ var $1537bdde5f19630d$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $1537bdde5f19630d$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = (0, $5c89fabc27f935b9$export$2e2bcd8739ae039), length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = (0, $2f5198bd8bb7a519$export$2e2bcd8739ae039);
    } else if (length >= $1537bdde5f19630d$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : (0, $2619e8ecfb959c45$export$2e2bcd8739ae039)(array);
        if (set) return (0, $06d82f661002cbfc$export$2e2bcd8739ae039)(set);
        isCommon = false;
        includes = (0, $f4852737a03c39ca$export$2e2bcd8739ae039);
        seen = new (0, $ab54149517cb0b02$export$2e2bcd8739ae039);
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
var $1537bdde5f19630d$export$2e2bcd8739ae039 = $1537bdde5f19630d$var$baseUniq;


/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $773aceab9d457899$var$uniq(array) {
    return array && array.length ? (0, $1537bdde5f19630d$export$2e2bcd8739ae039)(array) : [];
}
var $773aceab9d457899$export$2e2bcd8739ae039 = $773aceab9d457899$var$uniq;






/** Given a specific `value` attempts to guess the type of a schema element. In the case where we have to implicitly
 *  create a schema, it is useful to know what type to use based on the data we are defining.
 *
 * @param value - The value from which to guess the type
 * @returns - The best guess for the object type
 */ function $815c94039bfc402f$export$2e2bcd8739ae039(value) {
    if (Array.isArray(value)) return 'array';
    if (typeof value === 'string') return 'string';
    if (value == null) return 'null';
    if (typeof value === 'boolean') return 'boolean';
    if (typeof value === 'number' && !Number.isNaN(value)) return 'number';
    if (typeof value === 'object') return 'object';
    // Default to string if we can't figure it out
    return 'string';
}







/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $4f8630a5c03fe9b7$var$union = (0, $d3bee9049ca44be7$export$2e2bcd8739ae039)(function(arrays) {
    return (0, $1537bdde5f19630d$export$2e2bcd8739ae039)((0, $b2ff9fbe68cb378d$export$2e2bcd8739ae039)(arrays, 1, (0, $1d95c744ae2c26f0$export$2e2bcd8739ae039), true));
});
var $4f8630a5c03fe9b7$export$2e2bcd8739ae039 = $4f8630a5c03fe9b7$var$union;




function $624c3ff4310242dc$export$2e2bcd8739ae039(schema) {
    let { type: type } = schema;
    if (!type && schema.const) return (0, $815c94039bfc402f$export$2e2bcd8739ae039)(schema.const);
    if (!type && schema.enum) return 'string';
    if (!type && (schema.properties || schema.additionalProperties || schema.patternProperties)) return 'object';
    if (Array.isArray(type)) {
        if (type.length === 2 && type.includes('null')) type = type.find((t)=>t !== 'null');
        else // oxlint-disable-next-line prefer-destructuring
        type = type[0];
    }
    return type;
}



function $c56cbb46ed08f5c4$export$2e2bcd8739ae039(obj1, obj2) {
    const acc = {
        ...obj1
    }; // Prevent mutation of source object.
    return Object.keys(obj2).reduce((accumulator, key)=>{
        const left = obj1 ? obj1[key] : {}, right = obj2[key];
        if (obj1 && key in obj1 && (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(right)) accumulator[key] = $c56cbb46ed08f5c4$export$2e2bcd8739ae039(left, right);
        else if (obj1 && obj2 && ((0, $624c3ff4310242dc$export$2e2bcd8739ae039)(obj1) === 'object' || (0, $624c3ff4310242dc$export$2e2bcd8739ae039)(obj2) === 'object') && key === (0, $cd207018ee28cb28$export$8efe7be9a05205be) && Array.isArray(left) && Array.isArray(right)) // Don't include duplicate values when merging 'required' fields.
        accumulator[key] = (0, $4f8630a5c03fe9b7$export$2e2bcd8739ae039)(left, right);
        else accumulator[key] = right;
        return accumulator;
    }, acc);
}






/** `Object#toString` result references. */ var $bebffe9914029076$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $bebffe9914029076$var$isNumber(value) {
    return typeof value == 'number' || (0, $754274dccdb4db10$export$2e2bcd8739ae039)(value) && (0, $95eecc554ecfdc33$export$2e2bcd8739ae039)(value) == $bebffe9914029076$var$numberTag;
}
var $bebffe9914029076$export$2e2bcd8739ae039 = $bebffe9914029076$var$isNumber;





function $bbbfab0ce98fd032$export$2e2bcd8739ae039(formData, options, discriminatorField) {
    var _a;
    if (formData && discriminatorField) {
        const value = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, discriminatorField);
        if (value === undefined) return undefined;
        for(let i = 0; i < options.length; i += 1){
            const option = options[i];
            const discriminator = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(option, [
                (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
                discriminatorField
            ], {});
            if (discriminator.type !== 'object' && discriminator.type !== 'array') {
                if (discriminator.const === value) return i;
                if ((_a = discriminator.enum) === null || _a === void 0 ? void 0 : _a.includes(value)) return i;
            }
        }
    }
    return undefined;
}


function $e6fc247cc688da7a$export$2e2bcd8739ae039(validator, formData, options, rootSchema, discriminatorField) {
    // For performance, skip validating subschemas if formData is undefined. We just
    // want to get the first option in that case.
    if (formData === undefined) return 0;
    const simpleDiscriminatorMatch = (0, $bbbfab0ce98fd032$export$2e2bcd8739ae039)(formData, options, discriminatorField);
    if ((0, $bebffe9914029076$export$2e2bcd8739ae039)(simpleDiscriminatorMatch)) return simpleDiscriminatorMatch;
    for(let i = 0; i < options.length; i += 1){
        const option = options[i];
        // If we have a discriminator field, then we will use this to make the determination
        if (discriminatorField && (0, $52f1e6e82878153c$export$2e2bcd8739ae039)(option, [
            (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
            discriminatorField
        ])) {
            const value = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, discriminatorField);
            const discriminator = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(option, [
                (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
                discriminatorField
            ], {});
            if (validator.isValid(discriminator, value, rootSchema)) return i;
        } else if (option[0, $cd207018ee28cb28$export$dd550d4e98f939a4]) {
            // If the schema describes an object then we need to add slightly more
            // strict matching to the schema, because unless the schema uses the
            // "requires" keyword, an object will match the schema as long as it
            // doesn't have matching keys with a conflicting type. To do this we use an
            // "anyOf" with an array of requires. This augmentation expresses that the
            // schema should match if any of the keys in the schema are present on the
            // object and pass validation.
            //
            // Create an "anyOf" schema that requires at least one of the keys in the
            // "properties" object
            const requiresAnyOf = {
                anyOf: Object.keys(option[0, $cd207018ee28cb28$export$dd550d4e98f939a4]).map((key)=>({
                        required: [
                            key
                        ]
                    }))
            };
            let augmentedSchema;
            // If the "anyOf" keyword already exists, wrap the augmentation in an "allOf"
            if (option.anyOf) {
                // Create a shallow clone of the option
                const { ...shallowClone } = option;
                if (!shallowClone.allOf) shallowClone.allOf = [];
                else // If "allOf" already exists, shallow clone the array
                shallowClone.allOf = shallowClone.allOf.slice();
                shallowClone.allOf.push(requiresAnyOf);
                augmentedSchema = shallowClone;
            } else augmentedSchema = {
                ...option,
                ...requiresAnyOf
            };
            // Remove the "required" field as it's likely that not all fields have
            // been filled in yet, which will mean that the schema is not valid
            delete augmentedSchema.required;
            if (validator.isValid(augmentedSchema, formData, rootSchema)) return i;
        } else if (validator.isValid(option, formData, rootSchema)) return i;
    }
    return 0;
}


function $04ce687fba4cf550$export$a6cdc56e425d0d0a(value) {
    return value !== null && typeof value === "object";
}
const $04ce687fba4cf550$var$objProto = Object.prototype;
function $04ce687fba4cf550$export$8a1d655ee8b14fec(rec) {
    for(const key in rec){
        if ($04ce687fba4cf550$var$objProto.hasOwnProperty.call(rec, key)) return false;
    }
    return true;
}


const $7949ef7920cdc300$export$b40976a0e7d73176 = [
    "array",
    "boolean",
    "integer",
    "null",
    "number",
    "object",
    "string"
];
const $7949ef7920cdc300$export$703c5769b5de600 = new Set($7949ef7920cdc300$export$b40976a0e7d73176);
function $7949ef7920cdc300$export$3ec2385b223da803(type) {
    return $7949ef7920cdc300$export$703c5769b5de600.has(type);
}
const $7949ef7920cdc300$export$c0fc07e519fe94d5 = [
    "$defs",
    "definitions",
    "properties",
    "patternProperties",
    "dependencies"
];
const $7949ef7920cdc300$export$f3430bea9199b317 = new Set($7949ef7920cdc300$export$c0fc07e519fe94d5);
const $7949ef7920cdc300$export$e6ee0830f0c0bed9 = [
    "items",
    "allOf",
    "oneOf",
    "anyOf"
];
const $7949ef7920cdc300$export$266b7e83f656b4fa = new Set($7949ef7920cdc300$export$e6ee0830f0c0bed9);
const $7949ef7920cdc300$export$604f2eafe72708ec = [
    "items",
    "additionalItems",
    "additionalProperties",
    "propertyNames",
    "contains",
    "if",
    "then",
    "else",
    "not"
];
const $7949ef7920cdc300$export$d4949425fa16a237 = new Set($7949ef7920cdc300$export$604f2eafe72708ec);
const $7949ef7920cdc300$export$52af7ed3bc8e7b08 = [
    ...$7949ef7920cdc300$export$c0fc07e519fe94d5,
    ...$7949ef7920cdc300$export$e6ee0830f0c0bed9,
    ...$7949ef7920cdc300$export$604f2eafe72708ec
];
function $7949ef7920cdc300$export$f7e911aee08201e7(schemaDef) {
    return typeof schemaDef === "object";
}
function $7949ef7920cdc300$export$e4f56d3943b8ff84(def) {
    return $7949ef7920cdc300$export$f7e911aee08201e7(def) ? (0, $04ce687fba4cf550$export$8a1d655ee8b14fec)(def) : def === true;
}



function $93cebf70b44ca780$export$c5a3030ad904ab4f(schema, transform, ctx = {
    type: "root",
    path: []
}) {
    if (!(0, $7949ef7920cdc300$export$f7e911aee08201e7)(schema)) return transform(schema, ctx);
    const shallowCopy = {
        ...schema
    };
    for (const key of (0, $7949ef7920cdc300$export$e6ee0830f0c0bed9)){
        const array = schema[key];
        if (array === undefined || !Array.isArray(array)) continue;
        const c = {
            type: "array",
            parent: schema,
            key: key,
            index: 0,
            path: ctx.path.concat(key, 0)
        };
        shallowCopy[key] = array.map((item, index)=>{
            c.index = index;
            c.path[c.path.length - 1] = index;
            return $93cebf70b44ca780$export$c5a3030ad904ab4f(item, transform, c);
        });
    }
    const map = new Map();
    for (const key of (0, $7949ef7920cdc300$export$c0fc07e519fe94d5)){
        const record = schema[key];
        if (record === undefined) continue;
        const c = {
            type: "record",
            parent: schema,
            key: key,
            property: "",
            path: ctx.path.concat(key, "")
        };
        const keys = Object.keys(record);
        const keysLen = keys.length;
        for(let i = 0; i < keysLen; i++){
            const property = keys[i];
            const value = record[property];
            if (Array.isArray(value)) {
                map.set(property, value);
                continue;
            }
            c.property = property;
            c.path[c.path.length - 1] = property;
            map.set(property, $93cebf70b44ca780$export$c5a3030ad904ab4f(value, transform, c));
        }
        shallowCopy[key] = Object.fromEntries(map);
        map.clear();
    }
    const c = {
        type: "sub",
        parent: schema,
        key: "items",
        path: ctx.path.concat("")
    };
    for (const key of (0, $7949ef7920cdc300$export$604f2eafe72708ec)){
        const value = schema[key];
        if (value === undefined || Array.isArray(value)) continue;
        c.key = key;
        c.path[c.path.length - 1] = key;
        shallowCopy[key] = $93cebf70b44ca780$export$c5a3030ad904ab4f(value, transform, c);
    }
    return transform(shallowCopy, ctx);
}




function $2d32319fc6eba3a4$export$c68383f08378a55e(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}


function $f2981d55fb4b30f4$export$971dd5b0dfd021b6(larger, smaller) {
    const ll = larger.length;
    if (ll === 0) return smaller;
    let sl = smaller.length;
    if (sl === 0) return larger;
    if (ll < sl) {
        const tmp = larger;
        larger = smaller;
        smaller = tmp;
        sl = ll;
    }
    const data = new Set(larger);
    for(let i = 0; i < sl; i++)data.add(smaller[i]);
    return Array.from(data);
}
function $f2981d55fb4b30f4$export$bc86dfbf7795668c(a, b) {
    const result = [];
    if (a.length === 0 || b.length === 0) return result;
    if (a.length > b.length) {
        const tmp = a;
        a = b;
        b = tmp;
    }
    const setB = new Set(b);
    for(let i = 0; i < a.length && setB.size > 0; i++){
        const val = a[i];
        if (setB.delete(val)) result.push(val);
    }
    return result;
}
function $f2981d55fb4b30f4$export$d9ff4a623e416a11(arr) {
    return arr.length === 0;
}
function $f2981d55fb4b30f4$export$9c813ac7100b0116(compare) {
    return (a, b)=>{
        const d = a.length - b.length;
        if (d !== 0) return d;
        for(let i = 0; i < a.length; i++)if (a[i] !== b[i]) {
            const d = compare(a[i], b[i]);
            if (d !== 0) return d;
        }
        return 0;
    };
}
function $f2981d55fb4b30f4$export$4ae7e3a10b31285b(compare, { threshold: threshold = 12 } = {}) {
    return (arr)=>{
        const al = arr.length;
        if (al === 0) return arr;
        if (al <= threshold) {
            const result = [];
            let rl = 0;
            outer: for(let i = 0; i < al; i++){
                const item = arr[i];
                for(let j = 0; j < rl; j++){
                    if (compare(item, result[j]) === 0) continue outer;
                }
                rl = result.push(item);
            }
            return result;
        }
        const sorted = arr.slice().sort(compare);
        let wIndex = 0;
        for(let rIndex = 1; rIndex < al; rIndex++){
            if (compare(sorted[wIndex], sorted[rIndex]) !== 0) {
                if (++wIndex !== rIndex) sorted[wIndex] = sorted[rIndex];
            }
        }
        sorted.length = wIndex + 1;
        return sorted;
    };
}
function $f2981d55fb4b30f4$export$97569edcb13929e9(compare) {
    return (a, b)=>{
        const result = [];
        let al = a.length;
        let bl = b.length;
        if (al === 0 || bl === 0) return result;
        if (al > bl) {
            const tmpArr = a;
            a = b;
            b = tmpArr;
            const tmpL = al;
            al = bl;
            bl = tmpL;
        }
        const aSorted = [
            ...a
        ].sort(compare);
        const bSorted = [
            ...b
        ].sort(compare);
        let i = 0, j = 0;
        while(i < al && j < bl){
            const cmp = compare(aSorted[i], bSorted[j]);
            if (cmp === 0) {
                // Only push if result is empty OR last pushed value is different
                if (result.length === 0 || compare(result[result.length - 1], aSorted[i]) !== 0) result.push(aSorted[i]);
                i++;
                j++;
            } else if (cmp < 0) i++;
            else j++;
        }
        return result;
    };
}



function $b6e7996478c903da$export$fc10aeed3a532e2a(cache, func) {
    return (arg)=>{
        if (cache.has(arg)) return cache.get(arg);
        const ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
}
const $b6e7996478c903da$export$f48f3887b310ec7c = $b6e7996478c903da$export$fc10aeed3a532e2a;



const $ce9c7d3ea1303df4$var$zero = ()=>0;
const $ce9c7d3ea1303df4$var$isUndefined = (v)=>v === undefined;
const $ce9c7d3ea1303df4$var$isSchemaPrimitiveExceptNull = (value)=>typeof value !== "object";
const $ce9c7d3ea1303df4$var$PRIMITIVE_TYPE_ORDER = {
    boolean: 0,
    number: 1,
    string: 2
};
function $ce9c7d3ea1303df4$var$compareSchemaPrimitive(a, b) {
    const ta = typeof a;
    const tb = typeof b;
    return ta === tb ? (0, $2d32319fc6eba3a4$export$c68383f08378a55e)(a, b) : $ce9c7d3ea1303df4$var$PRIMITIVE_TYPE_ORDER[ta] - $ce9c7d3ea1303df4$var$PRIMITIVE_TYPE_ORDER[tb];
}
function $ce9c7d3ea1303df4$var$insertUniqueValues(mutableTarget, mutableSource) {
    const tl = mutableTarget.length;
    if (tl === 0) return mutableSource;
    const sl = mutableSource.length;
    if (sl === 0) return mutableTarget;
    if (sl > tl) {
        const t = mutableTarget;
        mutableTarget = mutableSource;
        mutableSource = t;
    }
    const seen = new Set(mutableTarget);
    const l = mutableSource.length;
    for(let i = 0; i < l; i++){
        const key = mutableSource[i];
        if (!seen.has(key)) mutableTarget.push(key);
    }
    return mutableTarget;
}
function $ce9c7d3ea1303df4$var$createCmpMatcher(isEmpty, compare, compareEmpty = $ce9c7d3ea1303df4$var$zero) {
    return (a, b)=>{
        if (isEmpty(a)) {
            if (isEmpty(b)) return compareEmpty(a, b);
            return -1;
        }
        if (isEmpty(b)) return 1;
        return compare(a, b);
    };
}
function $ce9c7d3ea1303df4$var$createOptionalComparator(compare) {
    return $ce9c7d3ea1303df4$var$createCmpMatcher($ce9c7d3ea1303df4$var$isUndefined, compare);
}
function $ce9c7d3ea1303df4$var$createNarrowingOptionalComparator(isEmpty, compare) {
    return $ce9c7d3ea1303df4$var$createCmpMatcher((v)=>v === undefined || isEmpty(v), compare);
}
function $ce9c7d3ea1303df4$var$createArrayOrItemComparator(compare, compareArray) {
    return $ce9c7d3ea1303df4$var$createCmpMatcher(Array.isArray, compare, compareArray);
}
const $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives = $ce9c7d3ea1303df4$var$createOptionalComparator((0, $2d32319fc6eba3a4$export$c68383f08378a55e));
const $ce9c7d3ea1303df4$var$compareNumbersWithZeroDefault = $ce9c7d3ea1303df4$var$createNarrowingOptionalComparator((v)=>v === 0, (a, b)=>a - b);
function $ce9c7d3ea1303df4$export$f3c871744c6ad8b5({ deduplicationCache: deduplicationCache = new WeakMap(), sortedKeysCache: sortedKeysCache = new WeakMap() } = {}) {
    const getSortedKeys = (0, $b6e7996478c903da$export$f48f3887b310ec7c)(sortedKeysCache, (obj)=>Object.keys(obj).sort());
    function createRecordsComparator(compare) {
        return (a, b)=>{
            const aKeys = getSortedKeys(a);
            const bKeys = getSortedKeys(b);
            const l = Math.min(aKeys.length, bKeys.length);
            for(let i = 0; i < l; i++){
                const cmp = (0, $2d32319fc6eba3a4$export$c68383f08378a55e)(aKeys[i], bKeys[i]);
                if (cmp !== 0) return cmp;
            }
            if (aKeys.length !== bKeys.length) return aKeys.length - bKeys.length;
            for(let i = 0; i < l; i++){
                const key = aKeys[i];
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                const cmp = compare(a[key], b[key]);
                if (cmp !== 0) return cmp;
            }
            return 0;
        };
    }
    function createArrayComparatorWithDeduplication(compare) {
        const cmp = (0, $f2981d55fb4b30f4$export$9c813ac7100b0116)(compare);
        const deduplicate = (0, $b6e7996478c903da$export$f48f3887b310ec7c)(deduplicationCache, // NOTE: Always sort output
        (0, $f2981d55fb4b30f4$export$4ae7e3a10b31285b)(compare, {
            threshold: 0
        }));
        return (a, b)=>cmp(deduplicate(a), deduplicate(b));
    }
    const compareArrayOfSameTypePrimitivesWithDeduplication = createArrayComparatorWithDeduplication((0, $2d32319fc6eba3a4$export$c68383f08378a55e));
    function compareSchemaDefinitions(a, b) {
        if ((0, $7949ef7920cdc300$export$f7e911aee08201e7)(a)) {
            if ((0, $7949ef7920cdc300$export$f7e911aee08201e7)(b)) {
                const aKeys = Object.keys(a);
                const bKeys = Object.keys(b);
                const allKeys = $ce9c7d3ea1303df4$var$insertUniqueValues(aKeys, bKeys);
                const l = allKeys.length;
                for(let i = 0; i < l; i++){
                    const key = allKeys[i];
                    if (a[key] === b[key]) continue;
                    const cmp = COMPARATORS[key] ?? compareOptionalSchemaValues;
                    const d = cmp(a[key], b[key]);
                    if (d !== 0) return d;
                }
                return 0;
            }
            return b === true && (0, $04ce687fba4cf550$export$8a1d655ee8b14fec)(a) ? 0 : 1;
        }
        if ((0, $7949ef7920cdc300$export$f7e911aee08201e7)(b)) return a === true && (0, $04ce687fba4cf550$export$8a1d655ee8b14fec)(b) ? 0 : -1;
        return (0, $2d32319fc6eba3a4$export$c68383f08378a55e)(a, b);
    }
    const compareOptionalSchemaValues = $ce9c7d3ea1303df4$var$createOptionalComparator(compareSchemaValues);
    const compareNonNullSchemaValue = $ce9c7d3ea1303df4$var$createCmpMatcher($ce9c7d3ea1303df4$var$isSchemaPrimitiveExceptNull, $ce9c7d3ea1303df4$var$createArrayOrItemComparator(createRecordsComparator(compareOptionalSchemaValues), (0, $f2981d55fb4b30f4$export$9c813ac7100b0116)(compareSchemaValues)), $ce9c7d3ea1303df4$var$compareSchemaPrimitive);
    function compareSchemaValues(a, b) {
        if (a === null) return -1;
        if (b === null) return 1;
        return compareNonNullSchemaValue(a, b);
    }
    const compareOptionalSchemaDefinitions = $ce9c7d3ea1303df4$var$createOptionalComparator(compareSchemaDefinitions);
    const compareRecordOfOptionalSchemasWithEmptyRecordDefault = $ce9c7d3ea1303df4$var$createNarrowingOptionalComparator((0, $04ce687fba4cf550$export$8a1d655ee8b14fec), createRecordsComparator(compareOptionalSchemaDefinitions));
    const compareOptionalArrayOfSchemasWithDeduplication = $ce9c7d3ea1303df4$var$createOptionalComparator(createArrayComparatorWithDeduplication(compareSchemaDefinitions));
    const compareSchemaDefinitionsWithEmptyDefinitionDefault = $ce9c7d3ea1303df4$var$createNarrowingOptionalComparator((0, $7949ef7920cdc300$export$e4f56d3943b8ff84), compareSchemaDefinitions);
    const COMPARATORS = {
        $id: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        $comment: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        $defs: compareRecordOfOptionalSchemasWithEmptyRecordDefault,
        $ref: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        $schema: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        const: compareOptionalSchemaValues,
        contains: compareOptionalSchemaDefinitions,
        contentEncoding: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        contentMediaType: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        default: compareOptionalSchemaValues,
        definitions: compareRecordOfOptionalSchemasWithEmptyRecordDefault,
        description: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        else: compareOptionalSchemaDefinitions,
        examples: compareOptionalSchemaValues,
        exclusiveMaximum: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        exclusiveMinimum: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        format: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        if: compareOptionalSchemaDefinitions,
        maximum: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        maxItems: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        maxLength: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        maxProperties: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        minimum: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        multipleOf: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        not: compareOptionalSchemaDefinitions,
        pattern: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        propertyNames: compareOptionalSchemaDefinitions,
        readOnly: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        then: compareOptionalSchemaDefinitions,
        title: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        writeOnly: $ce9c7d3ea1303df4$var$compareOptionalSameTypeSchemaPrimitives,
        uniqueItems: $ce9c7d3ea1303df4$var$createNarrowingOptionalComparator((v)=>v === false, $ce9c7d3ea1303df4$var$zero),
        minLength: $ce9c7d3ea1303df4$var$compareNumbersWithZeroDefault,
        minItems: $ce9c7d3ea1303df4$var$compareNumbersWithZeroDefault,
        minProperties: $ce9c7d3ea1303df4$var$compareNumbersWithZeroDefault,
        required: $ce9c7d3ea1303df4$var$createNarrowingOptionalComparator((0, $f2981d55fb4b30f4$export$d9ff4a623e416a11), compareArrayOfSameTypePrimitivesWithDeduplication),
        enum: $ce9c7d3ea1303df4$var$createNarrowingOptionalComparator((0, $f2981d55fb4b30f4$export$d9ff4a623e416a11), createArrayComparatorWithDeduplication(compareSchemaValues)),
        type: $ce9c7d3ea1303df4$var$createOptionalComparator((a, b)=>{
            const isAArr = Array.isArray(a);
            const isBArr = Array.isArray(b);
            if (!isAArr && !isBArr) return (0, $2d32319fc6eba3a4$export$c68383f08378a55e)(a, b);
            return compareArrayOfSameTypePrimitivesWithDeduplication(isAArr ? a : [
                a
            ], isBArr ? b : [
                b
            ]);
        }),
        items: $ce9c7d3ea1303df4$var$createNarrowingOptionalComparator((v)=>!Array.isArray(v) && (0, $7949ef7920cdc300$export$e4f56d3943b8ff84)(v), $ce9c7d3ea1303df4$var$createArrayOrItemComparator(compareSchemaDefinitions, (0, $f2981d55fb4b30f4$export$9c813ac7100b0116)(compareSchemaDefinitions))),
        anyOf: compareOptionalArrayOfSchemasWithDeduplication,
        allOf: compareOptionalArrayOfSchemasWithDeduplication,
        oneOf: compareOptionalArrayOfSchemasWithDeduplication,
        properties: compareRecordOfOptionalSchemasWithEmptyRecordDefault,
        patternProperties: compareRecordOfOptionalSchemasWithEmptyRecordDefault,
        additionalProperties: compareSchemaDefinitionsWithEmptyDefinitionDefault,
        additionalItems: compareSchemaDefinitionsWithEmptyDefinitionDefault,
        dependencies: $ce9c7d3ea1303df4$var$createNarrowingOptionalComparator((0, $04ce687fba4cf550$export$8a1d655ee8b14fec), createRecordsComparator($ce9c7d3ea1303df4$var$createOptionalComparator($ce9c7d3ea1303df4$var$createArrayOrItemComparator(compareSchemaDefinitions, compareArrayOfSameTypePrimitivesWithDeduplication))))
    };
    return {
        compareSchemaValues: compareSchemaValues,
        compareSchemaDefinitions: compareSchemaDefinitions
    };
}





function $ef4010f7b1321f3b$export$f0954fd7d5368655(v) {
    return v;
}


const $2a1e175517194f74$export$f81847884871263e = (a, b)=>a ? $2a1e175517194f74$export$f81847884871263e(b % a, a) : b;
const $2a1e175517194f74$export$f686d97e407ec4ef = (a, b)=>Math.abs(a * b) / $2a1e175517194f74$export$f81847884871263e(a, b);



function $bd53835c49b9bb43$export$a560fcc471df238e(a, b) {
    return a === b ? a : `(?=${a})(?=${b})`;
}
function $bd53835c49b9bb43$export$d243ea1deb007280(a, b) {
    return a === b ? a : `(?=.*(?:${a}))(?=.*(?:${b}))`;
}


function $b76a5cd7e1a45223$var$createPairCombinations(l, r, action) {
    const ll = l.length;
    const rl = r.length;
    if (ll > 0 && rl > 0) for(let i = 0; i < ll; i++){
        const lv = l[i];
        for(let j = 0; j < rl; j++)action(lv, r[j]);
    }
}
function $b76a5cd7e1a45223$var$mergeBooleans(l, r) {
    return l || r;
}
function $b76a5cd7e1a45223$var$createRecordsMerge(merge) {
    return (left, right)=>{
        const target = {
            ...left
        };
        const keys = Object.keys(right);
        const l = keys.length;
        for(let i = 0; i < l; i++){
            const key = keys[i];
            target[key] = left[key] === undefined ? right[key] : merge(left[key], right[key]);
        }
        return target;
    };
}
function $b76a5cd7e1a45223$var$createMap(items) {
    const map = new Map();
    for (const pair of items)for (const key of pair[0])map.set(key, pair[1]);
    return map;
}
function $b76a5cd7e1a45223$var$assignSchemaDefinitionOrRecordOfSchemaDefinitions(target, key, value) {
    if (value === undefined || (0, $7949ef7920cdc300$export$e4f56d3943b8ff84)(value)) delete target[key];
    else target[key] = value;
}
const $b76a5cd7e1a45223$var$PROPERTIES_ASSIGNER_KEYS = [
    "properties",
    "patternProperties",
    "additionalProperties"
];
function $b76a5cd7e1a45223$var$compilePatterns(patterns) {
    const keys = Object.keys(patterns);
    const l = keys.length;
    const result = [];
    for(let i = 0; i < l; i++){
        const source = keys[i];
        result.push({
            regExp: new RegExp(source),
            schema: patterns[source]
        });
    }
    return [
        result,
        keys
    ];
}
const $b76a5cd7e1a45223$var$EMPTY_PATTERNS_AND_KEYS = [
    [],
    []
];
/**
 * @returns `true` when `false` schema occurred
 */ function $b76a5cd7e1a45223$var$appendKeyConstraints(target, key, patterns) {
    const l = patterns.length;
    for(let i = 0; i < l; i++){
        const p = patterns[i];
        if (!p.regExp.test(key)) continue;
        const s = p.schema;
        if (s === false) return true;
        target.push(s);
    }
    return false;
}
const $b76a5cd7e1a45223$var$ITEMS_ASSIGNER_KEYS = [
    "items",
    "additionalItems"
];
const $b76a5cd7e1a45223$var$CONDITION_ASSIGNER_KEYS = [
    "if",
    "then",
    "else"
];
function $b76a5cd7e1a45223$var$assignCondition(target, source) {
    if (source.if !== undefined) target.if = source.if;
    if (source.then !== undefined) target.then = source.then;
    if (source.else !== undefined) target.else = source.else;
    return target;
}
function $b76a5cd7e1a45223$var$intersectSchemaTypes(a, b) {
    if (a === b) return a;
    switch(a){
        case "number":
            if (b === "integer") return "integer";
        // eslint-disable-next-line no-fallthrough
        case "integer":
            if (b === "number") return "integer";
        // eslint-disable-next-line no-fallthrough
        default:
            return undefined;
    }
}
function $b76a5cd7e1a45223$export$35dc45686fc2dbd7(a, b, check) {
    return [
        a,
        b,
        check
    ];
}
function $b76a5cd7e1a45223$var$createChecksMap(checks) {
    const map = new Map();
    for (const [a, b, check] of checks){
        const fn = (target)=>{
            if (!check(target)) throw new Error(`Schema keys '${a}' and '${b}' are conflicting (${a}: ${JSON.stringify(target[a])}, ${b}: ${JSON.stringify(target[b])})`);
        };
        for (const k of [
            [
                a,
                b
            ],
            [
                b,
                a
            ]
        ]){
            let arr = map.get(k[0]);
            if (arr === undefined) {
                arr = [];
                map.set(k[0], arr);
            }
            arr.push({
                oppositeKey: k[1],
                check: fn
            });
        }
    }
    return map;
}
const $b76a5cd7e1a45223$export$258083a5ab0c3772 = [
    $b76a5cd7e1a45223$export$35dc45686fc2dbd7("minimum", "maximum", (t)=>t.maximum >= t.minimum),
    $b76a5cd7e1a45223$export$35dc45686fc2dbd7("exclusiveMinimum", "maximum", (t)=>t.maximum > t.exclusiveMinimum),
    $b76a5cd7e1a45223$export$35dc45686fc2dbd7("minimum", "exclusiveMaximum", (t)=>t.exclusiveMaximum > t.minimum),
    $b76a5cd7e1a45223$export$35dc45686fc2dbd7("exclusiveMinimum", "exclusiveMaximum", (t)=>t.exclusiveMaximum > t.exclusiveMinimum),
    $b76a5cd7e1a45223$export$35dc45686fc2dbd7("minLength", "maxLength", (t)=>t.maxLength >= t.minLength),
    $b76a5cd7e1a45223$export$35dc45686fc2dbd7("minItems", "maxItems", (t)=>t.maxItems >= t.minItems),
    $b76a5cd7e1a45223$export$35dc45686fc2dbd7("minProperties", "maxProperties", (t)=>t.maxProperties >= t.minProperties)
];
function $b76a5cd7e1a45223$export$7b3f3c3347220f87({ mergePatterns: mergePatterns = (0, $bd53835c49b9bb43$export$d243ea1deb007280), isSubRegExp: isSubRegExp = Object.is, intersectJson: intersectJson = (0, $f2981d55fb4b30f4$export$bc86dfbf7795668c), deduplicateJsonSchemaDef: deduplicateJsonSchemaDef = (0, $ef4010f7b1321f3b$export$f0954fd7d5368655), defaultMerger: defaultMerger = (0, $ef4010f7b1321f3b$export$f0954fd7d5368655), assigners: assigners = [], checks: checks = $b76a5cd7e1a45223$export$258083a5ab0c3772, mergers: mergers } = {}) {
    function mergeArrayOfSchemaDefinitions(schemas) {
        const l = schemas.length;
        let result = schemas[0];
        for(let i = 1; i < l; i++){
            const r = mergeSchemaDefinitions(result, schemas[i]);
            if (r === false) return false;
            if ((0, $7949ef7920cdc300$export$e4f56d3943b8ff84)(r)) continue;
            result = r;
        }
        return result;
    }
    function createProperty(constraints, key, value, patterns, oppositeValue, oppositePatterns, oppositeAdditional) {
        constraints.length = 0;
        if (value === false) return false;
        constraints.push(value);
        const isOppositeValueDefined = oppositeValue !== undefined;
        if (isOppositeValueDefined) {
            if (oppositeValue === false) return false;
            constraints.push(oppositeValue);
        }
        if ($b76a5cd7e1a45223$var$appendKeyConstraints(constraints, key, oppositePatterns)) return false;
        const isNotYetAllowed = constraints.length < 2;
        if (oppositeAdditional === false) {
            // There are no allowing constraints from opposite side -> drop property
            if (isNotYetAllowed) return undefined;
            // Applying patterns of current schema cause they may disappear
            if ($b76a5cd7e1a45223$var$appendKeyConstraints(constraints, key, patterns)) return false;
        } else if (isNotYetAllowed && oppositeAdditional !== undefined) constraints.push(oppositeAdditional);
        const l = constraints.length;
        if (l === 1) return constraints[0];
        return mergeArrayOfSchemaDefinitions(constraints);
    }
    function assignPatternPropertiesAndAdditionalPropertiesMerge(target, patterns, patternKeys, matchedPatterns, oppositeAdditional, isOppositeTruthy) {
        const l = patternKeys.length;
        if (l > 0 && oppositeAdditional !== false) {
            if (isOppositeTruthy) // TODO: in some cases we can just assign new value instead of copying
            Object.assign(target, patterns);
            else for(let i = 0; i < l; i++){
                const pattern = patternKeys[i];
                if (matchedPatterns.has(pattern)) continue;
                target[pattern] = mergeSchemaDefinitions(patterns[pattern], oppositeAdditional);
            }
        }
        return target;
    }
    const propertiesAssigner = (target, { properties: lProps = {}, patternProperties: lPatterns, additionalProperties: lAdditional = true }, { properties: rProps = {}, patternProperties: rPatterns, additionalProperties: rAdditional = true })=>{
        // Special case
        const isLAddTruthy = (0, $7949ef7920cdc300$export$e4f56d3943b8ff84)(lAdditional);
        const isRAddTruthy = (0, $7949ef7920cdc300$export$e4f56d3943b8ff84)(rAdditional);
        if (isLAddTruthy && isRAddTruthy) {
            $b76a5cd7e1a45223$var$assignSchemaDefinitionOrRecordOfSchemaDefinitions(target, "properties", mergeRecordsOfSchemaDefinitions(lProps, rProps));
            $b76a5cd7e1a45223$var$assignSchemaDefinitionOrRecordOfSchemaDefinitions(target, "patternProperties", lPatterns && rPatterns ? mergeRecordsOfSchemaDefinitions(lPatterns, rPatterns) : lPatterns ?? rPatterns);
            delete target.additionalProperties;
            return target;
        }
        // Additional Properties
        const additionalProperties = mergeSchemaDefinitions(lAdditional, rAdditional);
        $b76a5cd7e1a45223$var$assignSchemaDefinitionOrRecordOfSchemaDefinitions(target, "additionalProperties", additionalProperties);
        // Properties
        const properties = {};
        const lKeys = Object.keys(lProps);
        const lKeysLen = lKeys.length;
        const [lCompiledPatterns, lPatternKeys] = lPatterns ? $b76a5cd7e1a45223$var$compilePatterns(lPatterns) : $b76a5cd7e1a45223$var$EMPTY_PATTERNS_AND_KEYS;
        const [rCompiledPatterns, rPatternKeys] = rPatterns ? $b76a5cd7e1a45223$var$compilePatterns(rPatterns) : $b76a5cd7e1a45223$var$EMPTY_PATTERNS_AND_KEYS;
        const constraints = [];
        const lKeysSet = new Set();
        const mappedRAdditional = isRAddTruthy ? undefined : rAdditional;
        for(let i = 0; i < lKeysLen; i++){
            const key = lKeys[i];
            lKeysSet.add(key);
            const prop = createProperty(constraints, key, lProps[key], lCompiledPatterns, rProps[key], rCompiledPatterns, mappedRAdditional);
            if (prop !== undefined) properties[key] = prop;
        }
        const rKeys = Object.keys(rProps);
        const rKeysLen = rKeys.length;
        const mappedLAdditional = isLAddTruthy ? undefined : lAdditional;
        for(let i = 0; i < rKeysLen; i++){
            const key = rKeys[i];
            if (lKeysSet.has(key)) continue;
            const prop = createProperty(constraints, key, rProps[key], rCompiledPatterns, undefined, lCompiledPatterns, mappedLAdditional);
            if (prop !== undefined) properties[key] = prop;
        }
        $b76a5cd7e1a45223$var$assignSchemaDefinitionOrRecordOfSchemaDefinitions(target, "properties", properties);
        // Pattern Properties
        // (lPatterns and rPatterns) or (lPatterns and rAdditional) or (rPatterns and lAdditional)
        let patterns = {};
        const matchedPatterns = new Set();
        if (lPatternKeys.length > 0 && rPatternKeys.length > 0) $b76a5cd7e1a45223$var$createPairCombinations(lPatternKeys, rPatternKeys, (lKey, rKey)=>{
            if (isSubRegExp(lKey, rKey)) matchedPatterns.add(lKey);
            if (isSubRegExp(rKey, lKey)) matchedPatterns.add(rKey);
            patterns[mergePatterns(lKey, rKey)] = mergeSchemaDefinitions(lPatterns[lKey], rPatterns[rKey]);
        });
        patterns = assignPatternPropertiesAndAdditionalPropertiesMerge(patterns, lPatterns, lPatternKeys, matchedPatterns, rAdditional, isRAddTruthy);
        patterns = assignPatternPropertiesAndAdditionalPropertiesMerge(patterns, rPatterns, rPatternKeys, matchedPatterns, lAdditional, isLAddTruthy);
        $b76a5cd7e1a45223$var$assignSchemaDefinitionOrRecordOfSchemaDefinitions(target, "patternProperties", patterns);
        return target;
    };
    const itemsAssigner = (target, // NOTE: Schema that has `additionalItems` without an `items` keyword is invalid
    // so the assigner should be triggered only be colliding `items` properties
    // so default values are used only for type narrowing
    { items: lItems = [], additionalItems: lAdditional }, { items: rItems = [], additionalItems: rAdditional })=>{
        const isLArr = Array.isArray(lItems);
        const isRArr = Array.isArray(rItems);
        const itemsArray = [];
        target.items = itemsArray;
        if (isLArr && isRArr) {
            const [l, additional, tail] = lItems.length < rItems.length ? [
                lItems.length,
                lAdditional,
                rItems
            ] : [
                rItems.length,
                rAdditional,
                lItems
            ];
            let i = 0;
            for(; i < l; i++)itemsArray.push(mergeSchemaDefinitions(lItems[i], rItems[i]));
            if (additional === false) target.additionalItems = false;
            else {
                const isAdditionalTruthy = additional === undefined || (0, $7949ef7920cdc300$export$e4f56d3943b8ff84)(additional);
                for(; i < tail.length; i++)itemsArray.push(isAdditionalTruthy ? tail[i] : mergeSchemaDefinitions(tail[i], additional));
                $b76a5cd7e1a45223$var$assignSchemaDefinitionOrRecordOfSchemaDefinitions(target, "additionalItems", lAdditional !== undefined && rAdditional !== undefined ? mergeSchemaDefinitions(lAdditional, rAdditional) : lAdditional ?? rAdditional);
            }
        } else if (isLArr || isRArr) {
            const [arr, item, additional] = isLArr ? [
                lItems,
                rItems,
                lAdditional
            ] : [
                rItems,
                lItems,
                rAdditional
            ];
            $b76a5cd7e1a45223$var$assignSchemaDefinitionOrRecordOfSchemaDefinitions(target, "additionalItems", additional && mergeSchemaDefinitions(additional, item));
            for(let i = 0; i < arr.length; i++)itemsArray.push(mergeSchemaDefinitions(arr[i], item));
        } else {
            delete target.additionalItems;
            target.items = mergeSchemaDefinitions(lItems, rItems);
        }
        return target;
    };
    const conditionAssigner = (target, l, r)=>{
        $b76a5cd7e1a45223$var$assignCondition(target, l);
        const cond = $b76a5cd7e1a45223$var$assignCondition({}, r);
        if (target.allOf === undefined) target.allOf = [
            cond
        ];
        else target.allOf = target.allOf.concat(cond);
        return target;
    };
    function mergeArraysOfSchemaDefinition(l, r) {
        const definitions = [];
        $b76a5cd7e1a45223$var$createPairCombinations(l, r, (a, b)=>{
            try {
                definitions.push(mergeSchemaDefinitions(a, b));
            } catch  {}
        });
        if (definitions.length === 0) throw new Error(`No valid schema combinations could be produced for "${JSON.stringify(l)}" and "${JSON.stringify(r)}"; the merged result is empty`);
        return deduplicateJsonSchemaDef(definitions);
    }
    const ASSIGNERS_MAP = $b76a5cd7e1a45223$var$createMap([
        [
            $b76a5cd7e1a45223$var$PROPERTIES_ASSIGNER_KEYS,
            propertiesAssigner
        ],
        [
            $b76a5cd7e1a45223$var$ITEMS_ASSIGNER_KEYS,
            itemsAssigner
        ],
        [
            $b76a5cd7e1a45223$var$CONDITION_ASSIGNER_KEYS,
            conditionAssigner
        ],
        ...assigners
    ]);
    const CHECKS_MAP = $b76a5cd7e1a45223$var$createChecksMap(checks);
    function mergeSchemaDefinitions(left, right) {
        if (left === false || right === false) return false;
        if ((0, $7949ef7920cdc300$export$e4f56d3943b8ff84)(left)) {
            if ((0, $7949ef7920cdc300$export$e4f56d3943b8ff84)(right)) return true;
            return right;
        }
        if ((0, $7949ef7920cdc300$export$e4f56d3943b8ff84)(right)) return left;
        let target = {
            ...left
        };
        const assigners = new Set();
        const checks = new Set();
        const rKeys = Reflect.ownKeys(right);
        const l = rKeys.length;
        for(let i = 0; i < l; i++){
            const rKey = rKeys[i];
            const rv = right[rKey];
            if (rv === undefined) continue;
            const checkData = CHECKS_MAP.get(rKey);
            if (checkData !== undefined) {
                const l = checkData.length;
                for(let j = 0; j < l; j++){
                    const item = checkData[j];
                    if (left[item.oppositeKey] !== undefined) checks.add(item.check);
                }
            }
            const lv = left[rKey];
            if (lv === undefined) {
                // @ts-expect-error too complex
                target[rKey] = rv;
                continue;
            }
            const assign = ASSIGNERS_MAP.get(rKey);
            if (assign) {
                assigners.add(assign);
                continue;
            }
            const merge = MERGERS[rKey] ?? defaultMerger;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            target[rKey] = merge(lv, rv);
        }
        for (const assign of assigners)target = assign(target, left, right);
        for (const check of checks)check(target);
        return target;
    }
    const mergeRecordsOfSchemaDefinitions = $b76a5cd7e1a45223$var$createRecordsMerge(mergeSchemaDefinitions);
    const MERGERS = {
        $id: defaultMerger,
        $ref: defaultMerger,
        $schema: defaultMerger,
        $comment: defaultMerger,
        $defs: mergeRecordsOfSchemaDefinitions,
        definitions: mergeRecordsOfSchemaDefinitions,
        type: (a, b)=>{
            if (a === b) return a;
            const isAArr = Array.isArray(a);
            const isBArr = Array.isArray(b);
            if (!isAArr && !isBArr) {
                const intersection = $b76a5cd7e1a45223$var$intersectSchemaTypes(a, b);
                if (intersection !== undefined) return intersection;
            } else if (isAArr || isBArr) {
                const r = new Set();
                if (isAArr && isBArr) $b76a5cd7e1a45223$var$createPairCombinations(a, b, (x, y)=>{
                    const type = $b76a5cd7e1a45223$var$intersectSchemaTypes(x, y);
                    if (type !== undefined) r.add(type);
                });
                else {
                    const arr = isAArr ? a : b;
                    const el = isAArr ? b : a;
                    const l = arr.length;
                    for(let i = 0; i < l; i++){
                        const intersection = $b76a5cd7e1a45223$var$intersectSchemaTypes(el, arr[i]);
                        if (intersection !== undefined) r.add(intersection);
                    }
                }
                const s = r.size;
                if (s === 1) return r.values().next().value;
                if (s > 1) return Array.from(r);
            }
            throw new Error(`It is not possible to create an intersection of the following incompatible types: ${a.toString()}, ${b.toString()}`);
        },
        default: defaultMerger,
        description: defaultMerger,
        title: defaultMerger,
        const: defaultMerger,
        format: defaultMerger,
        contentEncoding: defaultMerger,
        contentMediaType: defaultMerger,
        not: (a, b)=>{
            const items = deduplicateJsonSchemaDef([
                a,
                b
            ]);
            return items.length === 1 ? items[0] : {
                anyOf: items
            };
        },
        pattern: mergePatterns,
        readOnly: $b76a5cd7e1a45223$var$mergeBooleans,
        writeOnly: $b76a5cd7e1a45223$var$mergeBooleans,
        enum: (a, b)=>{
            const data = intersectJson(a, b);
            if (data.length === 0) throw new Error(`Intersection of the following enums is empty: "${JSON.stringify(a)}", "${JSON.stringify(b)}"`);
            return data;
        },
        anyOf: mergeArraysOfSchemaDefinition,
        oneOf: mergeArraysOfSchemaDefinition,
        allOf: (l, r)=>deduplicateJsonSchemaDef(l.concat(r)),
        propertyNames: mergeSchemaDefinitions,
        contains: mergeSchemaDefinitions,
        dependencies: $b76a5cd7e1a45223$var$createRecordsMerge((a, b)=>{
            if (Array.isArray(a)) {
                if (Array.isArray(b)) return (0, $f2981d55fb4b30f4$export$971dd5b0dfd021b6)(a, b);
                return mergeSchemaDefinitions(b, {
                    required: a
                });
            }
            if (Array.isArray(b)) return mergeSchemaDefinitions(a, {
                required: b
            });
            return mergeSchemaDefinitions(a, b);
        }),
        examples: (l, r)=>{
            // https://datatracker.ietf.org/doc/html/draft-handrews-json-schema-validation-01#section-10.4
            if (!Array.isArray(l) || !Array.isArray(r)) throw new Error(`Value of the 'examples' field should be an array, but got "${JSON.stringify(l)}" and "${JSON.stringify(r)}"`);
            // TODO: Proper deduplication
            return (0, $f2981d55fb4b30f4$export$971dd5b0dfd021b6)(l, r);
        },
        multipleOf: (a, b)=>{
            let factor = 1;
            while(!Number.isInteger(a) || !Number.isInteger(b)){
                factor *= 10;
                a *= 10;
                b *= 10;
            }
            return (0, $2a1e175517194f74$export$f686d97e407ec4ef)(a, b) / factor;
        },
        exclusiveMaximum: Math.min,
        maximum: Math.min,
        maxItems: Math.min,
        maxLength: Math.min,
        maxProperties: Math.min,
        exclusiveMinimum: Math.max,
        minimum: Math.max,
        minItems: Math.max,
        minLength: Math.max,
        minProperties: Math.max,
        uniqueItems: $b76a5cd7e1a45223$var$mergeBooleans,
        required: (0, $f2981d55fb4b30f4$export$971dd5b0dfd021b6),
        ...mergers
    };
    return {
        mergeSchemaDefinitions: mergeSchemaDefinitions,
        mergeArrayOfSchemaDefinitions: mergeArrayOfSchemaDefinitions
    };
}



function $609f229ab379192a$var$getAllOfSchemas(schema) {
    const result = [];
    const stack = [
        schema
    ];
    while(stack.length > 0){
        const current = stack.pop();
        if (typeof current === "boolean" || current.allOf === undefined) {
            result.push(current);
            continue;
        }
        const { allOf: allOf, ...rest } = current;
        result.push(rest);
        for(let i = allOf.length - 1; i >= 0; i--)stack.push(allOf[i]);
    }
    return result;
}
function $609f229ab379192a$export$22d4eae2bf3e61fe(mergeArrayOfSchemaDefinitions) {
    return (schema)=>mergeArrayOfSchemaDefinitions($609f229ab379192a$var$getAllOfSchemas(schema));
}
function $609f229ab379192a$export$f52571b01ea9a60b(shallowMerge) {
    return (schemaDef)=>(0, $93cebf70b44ca780$export$c5a3030ad904ab4f)(schemaDef, (def)=>{
            if (typeof def === "boolean" || def.allOf === undefined) return def;
            return shallowMerge(def);
        });
}










const { compareSchemaDefinitions: $b3020f77cc91fc56$var$compareSchemaDefinitions, compareSchemaValues: $b3020f77cc91fc56$var$compareSchemaValues } = (0, $ce9c7d3ea1303df4$export$f3c871744c6ad8b5)();
const { mergeArrayOfSchemaDefinitions: $b3020f77cc91fc56$var$mergeArrayOfSchemaDefinitions } = (0, $b76a5cd7e1a45223$export$7b3f3c3347220f87)({
    intersectJson: (0, $f2981d55fb4b30f4$export$97569edcb13929e9)($b3020f77cc91fc56$var$compareSchemaValues),
    deduplicateJsonSchemaDef: (0, $f2981d55fb4b30f4$export$4ae7e3a10b31285b)($b3020f77cc91fc56$var$compareSchemaDefinitions)
});
var /** Shared `@x0k/json-schema-merge` shallow-allOf merge function used by `retrieveSchema` and
 * `omitExtraData`. Constructed once from a single comparator/merger/intersector/deduplicator
 * pipeline so both consumers share the same configuration without duplicating setup code.
 *
 * Usage: pass a schema that contains an `allOf` keyword and receive the merged result.
 *
 * @example
 * const merged = shallowAllOfMerge(schema); // schema.allOf is merged into the parent schema
 */ $b3020f77cc91fc56$export$2e2bcd8739ae039 = (0, $609f229ab379192a$export$22d4eae2bf3e61fe)($b3020f77cc91fc56$var$mergeArrayOfSchemaDefinitions);


function $9f63129bef70072a$export$2e2bcd8739ae039(validator, schema, rootSchema = {}, rawFormData, experimental_customMergeAllOf, resolveAnyOfOrOneOfRefs = false) {
    return $9f63129bef70072a$export$af6cd1140514df83(validator, schema, rootSchema, rawFormData, undefined, undefined, experimental_customMergeAllOf, resolveAnyOfOrOneOfRefs)[0];
}
function $9f63129bef70072a$export$4a1693e9ae621372(validator, schema, rootSchema, expandAllBranches, recurseList, formData, experimental_customMergeAllOf) {
    const { if: expression, then: then, else: otherwise, ...resolvedSchemaLessConditional } = schema;
    const conditionValue = validator.isValid(expression, formData || {}, rootSchema);
    let resolvedSchemas = [
        resolvedSchemaLessConditional
    ];
    let schemas = [];
    if (expandAllBranches) {
        if (then && typeof then !== 'boolean') schemas = schemas.concat($9f63129bef70072a$export$af6cd1140514df83(validator, then, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf));
        if (otherwise && typeof otherwise !== 'boolean') schemas = schemas.concat($9f63129bef70072a$export$af6cd1140514df83(validator, otherwise, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf));
    } else {
        const conditionalSchema = conditionValue ? then : otherwise;
        if (conditionalSchema && typeof conditionalSchema !== 'boolean') schemas = schemas.concat($9f63129bef70072a$export$af6cd1140514df83(validator, conditionalSchema, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf));
    }
    if (schemas.length) resolvedSchemas = schemas.map((s)=>(0, $c56cbb46ed08f5c4$export$2e2bcd8739ae039)(resolvedSchemaLessConditional, s));
    return resolvedSchemas.flatMap((s)=>$9f63129bef70072a$export$af6cd1140514df83(validator, s, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf));
}
function $9f63129bef70072a$export$d166c038a377d4c1(listOfLists) {
    const allPermutations = listOfLists.reduce((permutations, list)=>{
        // When there are more than one set of schemas for a row, duplicate the set of permutations and add in the values
        if (list.length > 1) return list.flatMap((element)=>(0, $e2028ac919d540eb$export$2e2bcd8739ae039)(permutations.length, (i)=>[
                    ...permutations[i]
                ].concat(element)));
        // Otherwise just push in the single value into the current set of permutations
        permutations.forEach((permutation)=>permutation.push(list[0]));
        return permutations;
    }, [
        []
    ]);
    return allPermutations;
}
function $9f63129bef70072a$export$1027233760346634(schema, key) {
    return Object.keys(schema.patternProperties).filter((pattern)=>RegExp(pattern).test(key)).reduce((obj, pattern)=>{
        // Pass the pattern using the `[]` index notation so that any `.` in the pattern are not used as a dotted path
        (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(obj, [
            pattern
        ], schema.patternProperties[pattern]);
        return obj;
    }, {});
}
function $9f63129bef70072a$export$108f8296d443cf05(validator, schema, rootSchema, expandAllBranches, recurseList, formData, experimental_customMergeAllOf, resolveAnyOfOrOneOfRefs) {
    const updatedSchemas = $9f63129bef70072a$export$35b163fd1a69f633(validator, schema, rootSchema, expandAllBranches, recurseList, formData, experimental_customMergeAllOf, resolveAnyOfOrOneOfRefs);
    if (updatedSchemas.length > 1 || updatedSchemas[0] !== schema) // return the updatedSchemas array if it has either multiple schemas within it
    // OR the first schema is not the same as the original schema
    return updatedSchemas;
    if ((0, $cd207018ee28cb28$export$f2daf7b7d8cced48) in schema) {
        const resolvedSchemas = $9f63129bef70072a$export$c2e2dc4e82e5a6ad(validator, schema, rootSchema, expandAllBranches, recurseList, formData, experimental_customMergeAllOf);
        return resolvedSchemas.flatMap((s)=>$9f63129bef70072a$export$af6cd1140514df83(validator, s, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf));
    }
    if ((0, $cd207018ee28cb28$export$d2b65f1d256ab906) in schema && Array.isArray(schema[0, $cd207018ee28cb28$export$d2b65f1d256ab906])) {
        const allOfSchemaElements = schema.allOf.map((allOfSubschema)=>$9f63129bef70072a$export$af6cd1140514df83(validator, allOfSubschema, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf));
        const allPermutations = $9f63129bef70072a$export$d166c038a377d4c1(allOfSchemaElements);
        return allPermutations.map((permutation)=>({
                ...schema,
                allOf: permutation
            }));
    }
    // No $ref or dependencies or allOf attribute was found, returning the original schema.
    return [
        schema
    ];
}
function $9f63129bef70072a$export$35b163fd1a69f633(validator, schema, rootSchema, expandAllBranches, recurseList, formData, experimental_customMergeAllOf, resolveAnyOfOrOneOfRefs) {
    const updatedSchema = $9f63129bef70072a$export$b19f555e2de5b541(schema, rootSchema, recurseList, undefined, resolveAnyOfOrOneOfRefs);
    if (updatedSchema !== schema) // Only call this if the schema was actually changed by the `resolveAllReferences()` function
    return $9f63129bef70072a$export$af6cd1140514df83(validator, updatedSchema, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf, resolveAnyOfOrOneOfRefs);
    return [
        schema
    ];
}
function $9f63129bef70072a$export$b19f555e2de5b541(schema, rootSchema, recurseList, baseURI, resolveAnyOfOrOneOfRefs) {
    if (!(0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(schema)) return schema;
    let resolvedSchema = schema;
    let currentBaseURI = baseURI;
    // resolve top level ref
    if ((0, $cd207018ee28cb28$export$cf02ae06bf291db4) in resolvedSchema) {
        const { $ref: $ref, ...localSchema } = resolvedSchema;
        // Check for a recursive reference and stop the loop
        if (recurseList.includes($ref)) return resolvedSchema;
        recurseList.push($ref);
        // Retrieve the referenced schema definition.
        const refSchema = (0, $9bd5acf65f690f1a$export$2e2bcd8739ae039)($ref, rootSchema, currentBaseURI);
        resolvedSchema = {
            ...refSchema,
            ...localSchema,
            [(0, $cd207018ee28cb28$export$2a59f05123189784)]: $ref
        };
        if ((0, $cd207018ee28cb28$export$f453fd324e92d331) in resolvedSchema) currentBaseURI = resolvedSchema[0, $cd207018ee28cb28$export$f453fd324e92d331];
    }
    if ((0, $cd207018ee28cb28$export$dd550d4e98f939a4) in resolvedSchema) {
        const childrenLists = [];
        const updatedProps = (0, $9dd0d1c96cb95cfd$export$2e2bcd8739ae039)(resolvedSchema[0, $cd207018ee28cb28$export$dd550d4e98f939a4], (acc, value, key)=>{
            const childList = [
                ...recurseList
            ];
            acc[key] = $9f63129bef70072a$export$b19f555e2de5b541(value, rootSchema, childList, currentBaseURI, resolveAnyOfOrOneOfRefs);
            childrenLists.push(childList);
        }, {});
        (0, $7e4a81f1f30416cf$export$2e2bcd8739ae039)(recurseList, (0, $773aceab9d457899$export$2e2bcd8739ae039)((0, $28f26c04657f54ba$export$2e2bcd8739ae039)(childrenLists)));
        resolvedSchema = {
            ...resolvedSchema,
            [(0, $cd207018ee28cb28$export$dd550d4e98f939a4)]: updatedProps
        };
    }
    if ((0, $cd207018ee28cb28$export$7a3255c70c8752d5) in resolvedSchema && !Array.isArray(resolvedSchema.items) && typeof resolvedSchema.items !== 'boolean') resolvedSchema = {
        ...resolvedSchema,
        items: $9f63129bef70072a$export$b19f555e2de5b541(resolvedSchema.items, rootSchema, recurseList, currentBaseURI, resolveAnyOfOrOneOfRefs)
    };
    if (resolveAnyOfOrOneOfRefs) {
        let key;
        let schemas;
        if ((0, $cd207018ee28cb28$export$2014f14bbe7357bd) in schema && Array.isArray(schema[0, $cd207018ee28cb28$export$2014f14bbe7357bd])) {
            key = (0, $cd207018ee28cb28$export$2014f14bbe7357bd);
            schemas = resolvedSchema[0, $cd207018ee28cb28$export$2014f14bbe7357bd];
        } else if ((0, $cd207018ee28cb28$export$c24c2c38af9a39c3) in schema && Array.isArray(schema[0, $cd207018ee28cb28$export$c24c2c38af9a39c3])) {
            key = (0, $cd207018ee28cb28$export$c24c2c38af9a39c3);
            schemas = resolvedSchema[0, $cd207018ee28cb28$export$c24c2c38af9a39c3];
        }
        if (key && schemas) resolvedSchema = {
            ...resolvedSchema,
            [key]: schemas.map((s)=>$9f63129bef70072a$export$b19f555e2de5b541(s, rootSchema, recurseList, currentBaseURI, resolveAnyOfOrOneOfRefs))
        };
    }
    return (0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(schema, resolvedSchema) ? schema : resolvedSchema;
}
function $9f63129bef70072a$export$7f455fe1643a61e7(validator, theSchema, rootSchema, aFormData, experimental_customMergeAllOf) {
    // Clone the schema so that we don't ruin the consumer's original
    const schema = {
        ...theSchema,
        properties: {
            ...theSchema.properties
        }
    };
    // make sure formData is an object
    const formData = aFormData && (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(aFormData) ? aFormData : {};
    Object.keys(formData).forEach((key)=>{
        if (key in schema.properties) // No need to stub, our schema already has the property
        return;
        if ((0, $cd207018ee28cb28$export$d5294cb04d742a01) in schema) {
            const matchingProperties = $9f63129bef70072a$export$1027233760346634(schema, key);
            if (!(0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(matchingProperties)) {
                schema.properties[key] = $9f63129bef70072a$export$2e2bcd8739ae039(validator, {
                    [(0, $cd207018ee28cb28$export$d2b65f1d256ab906)]: Object.values(matchingProperties)
                }, rootSchema, (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, [
                    key
                ]), experimental_customMergeAllOf);
                (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(schema.properties, [
                    key,
                    (0, $cd207018ee28cb28$export$60d2d9c11642ddd6)
                ], true);
                return;
            }
        }
        if ((0, $cd207018ee28cb28$export$42410ea1a2a130d1) in schema && schema.additionalProperties !== false) {
            let additionalProperties;
            if (typeof schema.additionalProperties !== 'boolean') {
                if ((0, $cd207018ee28cb28$export$cf02ae06bf291db4) in schema.additionalProperties) additionalProperties = $9f63129bef70072a$export$2e2bcd8739ae039(validator, {
                    [(0, $cd207018ee28cb28$export$cf02ae06bf291db4)]: (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(schema.additionalProperties, [
                        (0, $cd207018ee28cb28$export$cf02ae06bf291db4)
                    ])
                }, rootSchema, formData, experimental_customMergeAllOf);
                else if ('type' in schema.additionalProperties) additionalProperties = {
                    ...schema.additionalProperties
                };
                else if ((0, $cd207018ee28cb28$export$2014f14bbe7357bd) in schema.additionalProperties || (0, $cd207018ee28cb28$export$c24c2c38af9a39c3) in schema.additionalProperties) additionalProperties = {
                    type: 'object',
                    ...schema.additionalProperties
                };
                else additionalProperties = {
                    type: (0, $815c94039bfc402f$export$2e2bcd8739ae039)((0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, [
                        key
                    ]))
                };
            } else additionalProperties = {
                type: (0, $815c94039bfc402f$export$2e2bcd8739ae039)((0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, [
                    key
                ]))
            };
            // The type of our new key should match the additionalProperties value;
            schema.properties[key] = additionalProperties;
            // Set our additional property flag so we know it was dynamically added
            (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(schema.properties, [
                key,
                (0, $cd207018ee28cb28$export$60d2d9c11642ddd6)
            ], true);
        } else {
            // Invalid property
            schema.properties[key] = {
                type: 'null'
            };
            // Set our additional property flag so we know it was dynamically added
            (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(schema.properties, [
                key,
                (0, $cd207018ee28cb28$export$60d2d9c11642ddd6)
            ], true);
        }
    });
    return schema;
}
/**
 * Internal helper that merges allOf schemas using @x0k/json-schema-merge's shallow allOf merge
 * @param schema - The schema containing an `allOf` keyword
 * @returns The schema with allOf schemas merged
 */ function $9f63129bef70072a$var$mergeAllOf(schema) {
    return (0, $b3020f77cc91fc56$export$2e2bcd8739ae039)(schema);
}
function $9f63129bef70072a$export$af6cd1140514df83(validator, schema, rootSchema, rawFormData, expandAllBranches = false, recurseList = [], experimental_customMergeAllOf, resolveAnyOfOrOneOfRefs) {
    if (!(0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(schema)) return [
        {}
    ];
    const resolvedSchemas = $9f63129bef70072a$export$108f8296d443cf05(validator, schema, rootSchema, expandAllBranches, recurseList, rawFormData, experimental_customMergeAllOf, resolveAnyOfOrOneOfRefs);
    return resolvedSchemas.flatMap((s)=>{
        var _a;
        let resolvedSchema = s;
        if ((0, $cd207018ee28cb28$export$fa01b0fcf30c8319) in resolvedSchema) return $9f63129bef70072a$export$4a1693e9ae621372(validator, resolvedSchema, rootSchema, expandAllBranches, recurseList, rawFormData, experimental_customMergeAllOf);
        if ((0, $cd207018ee28cb28$export$d2b65f1d256ab906) in resolvedSchema) {
            // resolve allOf schemas
            if (expandAllBranches) {
                const { allOf: allOf, ...restOfSchema } = resolvedSchema;
                return [
                    ...allOf,
                    restOfSchema
                ];
            }
            try {
                const withContainsSchemas = [];
                const withoutContainsSchemas = [];
                (_a = resolvedSchema.allOf) === null || _a === void 0 || _a.forEach((allOfItem)=>{
                    if (typeof allOfItem === 'object' && allOfItem.contains) withContainsSchemas.push(allOfItem);
                    else withoutContainsSchemas.push(allOfItem);
                });
                if (withContainsSchemas.length) resolvedSchema = {
                    ...resolvedSchema,
                    allOf: withoutContainsSchemas
                };
                resolvedSchema = experimental_customMergeAllOf ? experimental_customMergeAllOf(resolvedSchema) : $9f63129bef70072a$var$mergeAllOf(resolvedSchema);
                if (withContainsSchemas.length) resolvedSchema.allOf = withContainsSchemas;
            } catch (e) {
                // oxlint-disable-next-line no-console
                console.warn('could not merge subschemas in allOf:\n', e);
                const { allOf: allOf, ...resolvedSchemaWithoutAllOf } = resolvedSchema;
                return resolvedSchemaWithoutAllOf;
            }
        }
        if ((0, $cd207018ee28cb28$export$dd550d4e98f939a4) in resolvedSchema && (0, $cd207018ee28cb28$export$d5294cb04d742a01) in resolvedSchema) resolvedSchema = Object.keys(resolvedSchema.properties).reduce((acc, key)=>{
            const matchingProperties = $9f63129bef70072a$export$1027233760346634(acc, key);
            if (!(0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(matchingProperties)) acc.properties[key] = $9f63129bef70072a$export$2e2bcd8739ae039(validator, {
                allOf: [
                    acc.properties[key],
                    ...Object.values(matchingProperties)
                ]
            }, rootSchema, (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(rawFormData, [
                key
            ]), experimental_customMergeAllOf);
            return acc;
        }, {
            ...resolvedSchema,
            properties: {
                ...resolvedSchema.properties
            }
        });
        const hasAdditionalProperties = (0, $cd207018ee28cb28$export$d5294cb04d742a01) in resolvedSchema || (0, $cd207018ee28cb28$export$42410ea1a2a130d1) in resolvedSchema && resolvedSchema.additionalProperties !== false;
        if (hasAdditionalProperties) return $9f63129bef70072a$export$7f455fe1643a61e7(validator, resolvedSchema, rootSchema, rawFormData, experimental_customMergeAllOf);
        return resolvedSchema;
    });
}
function $9f63129bef70072a$export$6f91e104388b9afc(validator, schema, rootSchema, expandAllBranches, rawFormData) {
    let anyOrOneOf;
    const { oneOf: oneOf, anyOf: anyOf, ...remaining } = schema;
    if (Array.isArray(oneOf)) anyOrOneOf = oneOf;
    else if (Array.isArray(anyOf)) anyOrOneOf = anyOf;
    if (anyOrOneOf) {
        // Ensure that during expand all branches we pass an object rather than undefined so that all options are interrogated
        const formData = rawFormData === undefined && expandAllBranches ? {} : rawFormData;
        const discriminator = (0, $9b9eddfbb66bfc4e$export$2e2bcd8739ae039)(schema);
        anyOrOneOf = anyOrOneOf.map((s)=>$9f63129bef70072a$export$b19f555e2de5b541(s, rootSchema, []));
        // Call this to trigger the set of isValid() calls that the schema parser will need
        const option = (0, $e6fc247cc688da7a$export$2e2bcd8739ae039)(validator, formData, anyOrOneOf, rootSchema, discriminator);
        if (expandAllBranches) {
            // Also trigger isValid() for the relaxed variants so that precompiled validators capture their hashes.
            // omitExtraData's handleOneOf relaxes additionalProperties:false → true before scoring; those mutated
            // schemas must be present in a precompiled validator's compiled set or isValid() will throw at runtime.
            // Using getFirstMatchingOption (rather than calling isValid directly) ensures that the augmented forms
            // of each option (as constructed internally by getFirstMatchingOption for options with properties) are
            // also captured. The return value is discarded — the call is purely for ParserValidator's side effect.
            const relaxed = $9f63129bef70072a$export$5f3402ad64950ace(anyOrOneOf, false, rootSchema);
            (0, $e6fc247cc688da7a$export$2e2bcd8739ae039)(validator, formData, relaxed, rootSchema, discriminator);
            return anyOrOneOf.map((item)=>(0, $c56cbb46ed08f5c4$export$2e2bcd8739ae039)(remaining, item));
        }
        return [
            (0, $c56cbb46ed08f5c4$export$2e2bcd8739ae039)(remaining, anyOrOneOf[option])
        ];
    }
    return [
        schema
    ];
}
function $9f63129bef70072a$export$5f3402ad64950ace(options, resolveRefs = false, rootSchema) {
    return options.map((d)=>{
        if (!(0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(d)) return d ? {} : {
            not: {}
        };
        const schema = resolveRefs && rootSchema ? $9f63129bef70072a$export$b19f555e2de5b541(d, rootSchema, []) : d;
        return schema.additionalProperties === false ? {
            ...schema,
            additionalProperties: true
        } : schema;
    });
}
function $9f63129bef70072a$export$c2e2dc4e82e5a6ad(validator, schema, rootSchema, expandAllBranches, recurseList, formData, experimental_customMergeAllOf) {
    // Drop the dependencies from the source schema.
    const { dependencies: dependencies, ...remainingSchema } = schema;
    const resolvedSchemas = $9f63129bef70072a$export$6f91e104388b9afc(validator, remainingSchema, rootSchema, expandAllBranches, formData);
    return resolvedSchemas.flatMap((resolvedSchema)=>$9f63129bef70072a$export$2c1d2d54429a2d6(validator, dependencies, resolvedSchema, rootSchema, expandAllBranches, recurseList, formData, experimental_customMergeAllOf));
}
function $9f63129bef70072a$export$2c1d2d54429a2d6(validator, dependencies, resolvedSchema, rootSchema, expandAllBranches, recurseList, formData, experimental_customMergeAllOf) {
    let schemas = [
        resolvedSchema
    ];
    // Process dependencies updating the local schema properties as appropriate.
    for(const dependencyKey in dependencies)if ((expandAllBranches || (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, [
        dependencyKey
    ]) !== undefined) && (!resolvedSchema.properties || dependencyKey in resolvedSchema.properties)) {
        const [remainingDependencies, dependencyValue] = (0, $9bd5acf65f690f1a$export$4faa4e6ce874f724)(dependencyKey, dependencies);
        if (Array.isArray(dependencyValue)) schemas[0] = $9f63129bef70072a$export$2567d99d112bf12a(resolvedSchema, dependencyValue);
        else if ((0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(dependencyValue)) schemas = $9f63129bef70072a$export$91bb5bbff3552c4f(validator, resolvedSchema, rootSchema, dependencyKey, dependencyValue, expandAllBranches, recurseList, formData, experimental_customMergeAllOf);
        return schemas.flatMap((schema)=>$9f63129bef70072a$export$2c1d2d54429a2d6(validator, remainingDependencies, schema, rootSchema, expandAllBranches, recurseList, formData, experimental_customMergeAllOf));
    }
    return schemas;
}
function $9f63129bef70072a$export$2567d99d112bf12a(schema, additionallyRequired) {
    if (!additionallyRequired) return schema;
    const required = Array.isArray(schema.required) ? Array.from(new Set([
        ...schema.required,
        ...additionallyRequired
    ])) : additionallyRequired;
    return {
        ...schema,
        required: required
    };
}
function $9f63129bef70072a$export$91bb5bbff3552c4f(validator, schema, rootSchema, dependencyKey, dependencyValue, expandAllBranches, recurseList, formData, experimental_customMergeAllOf) {
    const dependentSchemas = $9f63129bef70072a$export$af6cd1140514df83(validator, dependencyValue, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf);
    return dependentSchemas.flatMap((dependent)=>{
        const { oneOf: oneOf, ...dependentSchema } = dependent;
        const mergedSchema = (0, $c56cbb46ed08f5c4$export$2e2bcd8739ae039)(schema, dependentSchema);
        // Since it does not contain oneOf, we return the original schema.
        if (oneOf === undefined) return mergedSchema;
        // Resolve $refs inside oneOf.
        const resolvedOneOfs = oneOf.map((subschema)=>{
            if (typeof subschema === 'boolean' || !((0, $cd207018ee28cb28$export$cf02ae06bf291db4) in subschema)) return [
                subschema
            ];
            return $9f63129bef70072a$export$35b163fd1a69f633(validator, subschema, rootSchema, expandAllBranches, recurseList, formData);
        });
        const allPermutations = $9f63129bef70072a$export$d166c038a377d4c1(resolvedOneOfs);
        return allPermutations.flatMap((resolvedOneOf)=>$9f63129bef70072a$export$452ed1d0390cf00c(validator, mergedSchema, rootSchema, dependencyKey, resolvedOneOf, expandAllBranches, recurseList, formData, experimental_customMergeAllOf));
    });
}
function $9f63129bef70072a$export$452ed1d0390cf00c(validator, schema, rootSchema, dependencyKey, oneOf, expandAllBranches, recurseList, formData, experimental_customMergeAllOf) {
    const validSubschemas = oneOf.filter((subschema)=>{
        if (typeof subschema === 'boolean' || !subschema || !subschema.properties) return false;
        const { [dependencyKey]: conditionPropertySchema } = subschema.properties;
        if (conditionPropertySchema) {
            const conditionSchema = {
                type: 'object',
                properties: {
                    [dependencyKey]: conditionPropertySchema
                }
            };
            return validator.isValid(conditionSchema, formData, rootSchema) || expandAllBranches;
        }
        return false;
    });
    if (!expandAllBranches && validSubschemas.length !== 1) {
        // oxlint-disable-next-line no-console
        console.warn("ignoring oneOf in dependencies because there isn't exactly one subschema that is valid");
        return [
            schema
        ];
    }
    return validSubschemas.flatMap((s)=>{
        const subschema = s;
        const [dependentSubschema] = (0, $9bd5acf65f690f1a$export$4faa4e6ce874f724)(dependencyKey, subschema.properties);
        const dependentSchema = {
            ...subschema,
            properties: dependentSubschema
        };
        const schemas = $9f63129bef70072a$export$af6cd1140514df83(validator, dependentSchema, rootSchema, formData, expandAllBranches, recurseList, experimental_customMergeAllOf);
        return schemas.map((resolvedSubschema)=>(0, $c56cbb46ed08f5c4$export$2e2bcd8739ae039)(schema, resolvedSubschema));
    });
}


function $fd1332486306522a$export$2e2bcd8739ae039(validator, rootSchema, schema, fallbackField, xxx, formData = {}, experimental_customMergeAllOf) {
    if (Array.isArray(schema[xxx])) {
        const discriminator = (0, $9b9eddfbb66bfc4e$export$2e2bcd8739ae039)(schema);
        const selectorField = discriminator || fallbackField;
        const xxxOfs = schema[xxx].map((xxxOf)=>(0, $9f63129bef70072a$export$2e2bcd8739ae039)(validator, xxxOf, rootSchema, formData, experimental_customMergeAllOf));
        const data = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, selectorField);
        if (data !== undefined) return xxxOfs.find((xxxOfOption)=>(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)((0, $547524a1010b9f1e$export$2e2bcd8739ae039)(xxxOfOption, [
                (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
                selectorField,
                (0, $cd207018ee28cb28$export$729d352c37f0a7df)
            ], (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(xxxOfOption, [
                (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
                selectorField,
                (0, $cd207018ee28cb28$export$532244974323b6ba)
            ])), data));
    }
    return undefined;
}







/** Internal helper function that acts like lodash's `get` but additionally retrieves `$ref`s as needed to get the path
 * for schemas containing potentially nested `$ref`s.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param schema - The current node within the JSON schema recursion
 * @param path - The remaining keys in the path to the desired property
 * @param [experimental_customMergeAllOf] - Optional function that allows for custom merging of `allOf` schemas
 * @returns - The internal schema from the `schema` for the given `path` or undefined if not found
 */ function $42243afd61ffaaea$var$getFromSchemaInternal(validator, rootSchema, schema, path, experimental_customMergeAllOf) {
    let fieldSchema = schema;
    if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$cf02ae06bf291db4))) fieldSchema = (0, $9f63129bef70072a$export$2e2bcd8739ae039)(validator, schema, rootSchema, undefined, experimental_customMergeAllOf);
    if ((0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(path)) return fieldSchema;
    const pathList = Array.isArray(path) ? [
        ...path
    ] : path.split('.');
    const [part, ...nestedPath] = pathList;
    if (part !== undefined && part !== '' && (0, $52f1e6e82878153c$export$2e2bcd8739ae039)(fieldSchema, part)) {
        fieldSchema = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(fieldSchema, part);
        return $42243afd61ffaaea$var$getFromSchemaInternal(validator, rootSchema, fieldSchema, nestedPath, experimental_customMergeAllOf);
    }
    return undefined;
}
function $42243afd61ffaaea$export$2e2bcd8739ae039(validator, rootSchema, schema, path, defaultValue, experimental_customMergeAllOf) {
    const result = $42243afd61ffaaea$var$getFromSchemaInternal(validator, rootSchema, schema, path, experimental_customMergeAllOf);
    if (result === undefined) return defaultValue;
    return result;
}


const $80874c46ebba76fb$export$69daf2f8468e5739 = {
    title: '!@#$_UNKNOWN_$#@!'
};
function $80874c46ebba76fb$export$2e2bcd8739ae039(validator, rootSchema, schema, path, formData = {}, experimental_customMergeAllOf) {
    const pathList = Array.isArray(path) ? [
        ...path
    ] : path.split('.');
    let parentField = schema;
    // store the desired field into a variable and removing it from the `pathList`
    const fieldName = pathList.pop();
    const fieldNameKey = String(fieldName);
    if (pathList.length) // drilling into the schema for each sub-path and taking into account of the any/oneOfs
    pathList.forEach((subPath)=>{
        parentField = (0, $42243afd61ffaaea$export$2e2bcd8739ae039)(validator, rootSchema, parentField, [
            (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
            subPath
        ], {}, experimental_customMergeAllOf);
        if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(parentField, (0, $cd207018ee28cb28$export$c24c2c38af9a39c3))) // if this sub-path has a `oneOf` then use the formData to drill into the schema with the selected option
        parentField = (0, $fd1332486306522a$export$2e2bcd8739ae039)(validator, rootSchema, parentField, fieldNameKey, (0, $cd207018ee28cb28$export$c24c2c38af9a39c3), (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, subPath), experimental_customMergeAllOf);
        else if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(parentField, (0, $cd207018ee28cb28$export$2014f14bbe7357bd))) // if this sub-path has a `anyOf` then use the formData to drill into the schema with the selected option
        parentField = (0, $fd1332486306522a$export$2e2bcd8739ae039)(validator, rootSchema, parentField, fieldNameKey, (0, $cd207018ee28cb28$export$2014f14bbe7357bd), (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, subPath), experimental_customMergeAllOf);
    });
    if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(parentField, (0, $cd207018ee28cb28$export$c24c2c38af9a39c3))) // When oneOf is in the root schema, use the formData to drill into the schema with the selected option
    parentField = (0, $fd1332486306522a$export$2e2bcd8739ae039)(validator, rootSchema, parentField, fieldNameKey, (0, $cd207018ee28cb28$export$c24c2c38af9a39c3), formData, experimental_customMergeAllOf);
    else if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(parentField, (0, $cd207018ee28cb28$export$2014f14bbe7357bd))) // When anyOf is in the root schema, use the formData to drill into the schema with the selected option
    parentField = (0, $fd1332486306522a$export$2e2bcd8739ae039)(validator, rootSchema, parentField, fieldNameKey, (0, $cd207018ee28cb28$export$2014f14bbe7357bd), formData, experimental_customMergeAllOf);
    // taking the most updated `parentField`, get our desired field
    let field = (0, $42243afd61ffaaea$export$2e2bcd8739ae039)(validator, rootSchema, parentField, [
        (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
        fieldName
    ], $80874c46ebba76fb$export$69daf2f8468e5739, experimental_customMergeAllOf);
    if (field === $80874c46ebba76fb$export$69daf2f8468e5739) field = undefined;
    // check to see if our desired field is in the `required` list for its parent
    const requiredArray = (0, $42243afd61ffaaea$export$2e2bcd8739ae039)(validator, rootSchema, parentField, (0, $cd207018ee28cb28$export$8efe7be9a05205be), [], experimental_customMergeAllOf);
    let isRequired;
    if (field && Array.isArray(requiredArray)) isRequired = requiredArray.includes(fieldNameKey);
    return {
        field: field,
        isRequired: isRequired
    };
}








/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $deb30e872c96bbc1$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
var $deb30e872c96bbc1$export$2e2bcd8739ae039 = $deb30e872c96bbc1$var$arrayReduce;




/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $80b1d2d6856efff4$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, $baeea2f3638e715c$export$2e2bcd8739ae039)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
var $80b1d2d6856efff4$export$2e2bcd8739ae039 = $80b1d2d6856efff4$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $fa79510661ee2665$var$baseEach = (0, $80b1d2d6856efff4$export$2e2bcd8739ae039)((0, $c715a153ba2e3159$export$2e2bcd8739ae039));
var $fa79510661ee2665$export$2e2bcd8739ae039 = $fa79510661ee2665$var$baseEach;



/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $50ab8ea029c7614f$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
var $50ab8ea029c7614f$export$2e2bcd8739ae039 = $50ab8ea029c7614f$var$baseReduce;



/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $444ab737a83160c7$var$reduce(collection, iteratee, accumulator) {
    var func = (0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(collection) ? (0, $deb30e872c96bbc1$export$2e2bcd8739ae039) : (0, $50ab8ea029c7614f$export$2e2bcd8739ae039), initAccum = arguments.length < 3;
    return func(collection, (0, $bf4c4ea4610241c9$export$2e2bcd8739ae039)(iteratee, 4), accumulator, initAccum, (0, $fa79510661ee2665$export$2e2bcd8739ae039));
}
var $444ab737a83160c7$export$2e2bcd8739ae039 = $444ab737a83160c7$var$reduce;









const $3dd4655d2b27ee9e$export$867c690fb31c5bfe = {
    type: 'object',
    $id: (0, $cd207018ee28cb28$export$9b4d24d10abfe212),
    properties: {
        __not_really_there__: {
            type: 'number'
        }
    }
};
function $3dd4655d2b27ee9e$export$95b7d4239178cc04(validator, rootSchema, schema, formData, experimental_customMergeAllOf) {
    let totalScore = 0;
    if (schema) {
        if ((0, $d252d56fd76f41df$export$2e2bcd8739ae039)(schema.properties)) totalScore += (0, $444ab737a83160c7$export$2e2bcd8739ae039)(schema.properties, (score, value, key)=>{
            const formValue = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, key);
            if (typeof value === 'boolean') return score;
            if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(value, (0, $cd207018ee28cb28$export$cf02ae06bf291db4))) {
                const newSchema = (0, $9f63129bef70072a$export$2e2bcd8739ae039)(validator, value, rootSchema, formValue, experimental_customMergeAllOf);
                return score + $3dd4655d2b27ee9e$export$95b7d4239178cc04(validator, rootSchema, newSchema, formValue || {}, experimental_customMergeAllOf);
            }
            if (((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(value, (0, $cd207018ee28cb28$export$c24c2c38af9a39c3)) || (0, $52f1e6e82878153c$export$2e2bcd8739ae039)(value, (0, $cd207018ee28cb28$export$2014f14bbe7357bd))) && formValue) {
                const xxxOfKey = (0, $52f1e6e82878153c$export$2e2bcd8739ae039)(value, (0, $cd207018ee28cb28$export$c24c2c38af9a39c3)) ? (0, $cd207018ee28cb28$export$c24c2c38af9a39c3) : (0, $cd207018ee28cb28$export$2014f14bbe7357bd);
                const discriminator = (0, $9b9eddfbb66bfc4e$export$2e2bcd8739ae039)(value);
                return score + $3dd4655d2b27ee9e$export$2e2bcd8739ae039(validator, rootSchema, formValue, (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(value, xxxOfKey), -1, discriminator, experimental_customMergeAllOf);
            }
            if (value.type === 'object') {
                // If the structure is matching then give it a little boost in score
                const structureBoost = (0, $d252d56fd76f41df$export$2e2bcd8739ae039)(formValue) ? 1 : 0;
                return score + structureBoost + $3dd4655d2b27ee9e$export$95b7d4239178cc04(validator, rootSchema, value, formValue, experimental_customMergeAllOf);
            }
            if (value.type === (0, $815c94039bfc402f$export$2e2bcd8739ae039)(formValue)) {
                // If the types match, then we bump the score by one
                let newScore = score + 1;
                if (value.default) // If the schema contains a readonly default value score the value that matches the default higher and
                // any non-matching value lower
                newScore += formValue === value.default ? 1 : -1;
                else if (value.const) // If the schema contains a const value score the value that matches the default higher and
                // any non-matching value lower
                newScore += formValue === value.const ? 1 : -1;
                // TODO eventually, deal with enums/arrays
                return newScore;
            }
            return score;
        }, 0);
        else if ((0, $e6fe0b0844d2a1c4$export$2e2bcd8739ae039)(schema.type) && schema.type === (0, $815c94039bfc402f$export$2e2bcd8739ae039)(formData)) totalScore += 1;
    }
    return totalScore;
}
function $3dd4655d2b27ee9e$export$2e2bcd8739ae039(validator, rootSchema, formData, options, selectedOption = -1, discriminatorField, experimental_customMergeAllOf) {
    // First resolve any refs in the options
    const resolvedOptions = options.map((option)=>(0, $9f63129bef70072a$export$b19f555e2de5b541)(option, rootSchema, []));
    const simpleDiscriminatorMatch = (0, $bbbfab0ce98fd032$export$2e2bcd8739ae039)(formData, options, discriminatorField);
    if ((0, $bebffe9914029076$export$2e2bcd8739ae039)(simpleDiscriminatorMatch)) return simpleDiscriminatorMatch;
    // Reduce the array of options down to a list of the indexes that are considered matching options
    const allValidIndexes = resolvedOptions.reduce((validList, option, index)=>{
        const testOptions = [
            $3dd4655d2b27ee9e$export$867c690fb31c5bfe,
            option
        ];
        const match = (0, $e6fc247cc688da7a$export$2e2bcd8739ae039)(validator, formData, testOptions, rootSchema, discriminatorField);
        // The match is the real option, so add its index to list of valid indexes
        if (match === 1) validList.push(index);
        return validList;
    }, []);
    // There is only one valid index, so return it!
    if (allValidIndexes.length === 1) return allValidIndexes[0];
    if (!allValidIndexes.length) // No indexes were valid, so we'll score all the options, add all the indexes
    (0, $e2028ac919d540eb$export$2e2bcd8739ae039)(resolvedOptions.length, (i)=>allValidIndexes.push(i));
    const scoreCount = new Set();
    // Score all the options in the list of valid indexes and return the index with the best score
    const { bestIndex: bestIndex } = allValidIndexes.reduce((scoreData, index)=>{
        const { bestScore: bestScore } = scoreData;
        const option = resolvedOptions[index];
        const score = $3dd4655d2b27ee9e$export$95b7d4239178cc04(validator, rootSchema, option, formData, experimental_customMergeAllOf);
        scoreCount.add(score);
        if (score > bestScore) return {
            bestIndex: index,
            bestScore: score
        };
        return scoreData;
    }, {
        bestIndex: selectedOption,
        bestScore: 0
    });
    // if all scores are the same go with selectedOption
    if (scoreCount.size === 1 && selectedOption >= 0) return selectedOption;
    return bestIndex;
}







function $f84c7ca4a7434b14$export$2e2bcd8739ae039(schema) {
    const schemaConst = schema[0, $cd207018ee28cb28$export$532244974323b6ba];
    const schemaType = (0, $624c3ff4310242dc$export$2e2bcd8739ae039)(schema);
    return (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(schemaConst) && (0, $e6fe0b0844d2a1c4$export$2e2bcd8739ae039)(schemaConst === null || schemaConst === void 0 ? void 0 : schemaConst.$data) && schemaType !== 'object' && schemaType !== 'array';
}







function $9f4ca1c02304f30f$export$2e2bcd8739ae039(schema) {
    return Array.isArray(schema.enum) && schema.enum.length === 1 || (0, $cd207018ee28cb28$export$532244974323b6ba) in schema;
}



function $dfc36f50ea093ef6$export$2e2bcd8739ae039(schema) {
    return Array.isArray(schema.items) && schema.items.length > 0 && schema.items.every((item)=>(0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(item));
}




/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $1f65e0187a0081bc$var$isNil(value) {
    return value == null;
}
var $1f65e0187a0081bc$export$2e2bcd8739ae039 = $1f65e0187a0081bc$var$isNil;



function $197cd15f8a9b62b3$export$2e2bcd8739ae039(defaults, formData, mergeExtraArrayDefaults = false, defaultSupercedesUndefined = false, overrideFormDataWithDefaults = false) {
    if (Array.isArray(formData)) {
        const defaultsArray = Array.isArray(defaults) ? defaults : [];
        // If overrideFormDataWithDefaults is true, we want to override the formData with the defaults
        const overrideArray = overrideFormDataWithDefaults ? defaultsArray : formData;
        const overrideOppositeArray = overrideFormDataWithDefaults ? formData : defaultsArray;
        const mapped = overrideArray.map((value, idx)=>{
            // We want to explicitly make sure that the value is NOT undefined since null, 0 and empty space are valid values
            if (overrideOppositeArray[idx] !== undefined) return $197cd15f8a9b62b3$export$2e2bcd8739ae039(defaultsArray[idx], formData[idx], mergeExtraArrayDefaults, defaultSupercedesUndefined, overrideFormDataWithDefaults);
            return value;
        });
        // Merge any extra defaults when mergeExtraArrayDefaults is true
        // Or when overrideFormDataWithDefaults is true and the default array is shorter than the formData array
        if ((mergeExtraArrayDefaults || overrideFormDataWithDefaults) && mapped.length < overrideOppositeArray.length) mapped.push(...overrideOppositeArray.slice(mapped.length));
        return mapped;
    }
    if ((0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(formData)) {
        // oxlint-disable-next-line prefer-object-spread -- spread loses T type, Object.assign preserves it
        const acc = Object.assign({}, defaults); // Prevent mutation of source object.
        return Object.keys(formData).reduce((accumulator, key)=>{
            var _a;
            const keyValue = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, key);
            const keyExistsInDefaults = (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(defaults) && key in defaults;
            const keyExistsInFormData = key in formData;
            const keyDefault = (_a = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(defaults, key)) !== null && _a !== void 0 ? _a : {};
            const defaultValueIsNestedObject = keyExistsInDefaults && (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(keyDefault) && Object.values(keyDefault).some((v)=>(0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(v));
            const keyDefaultIsObject = keyExistsInDefaults && (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)((0, $547524a1010b9f1e$export$2e2bcd8739ae039)(defaults, key));
            const keyHasFormDataObject = keyExistsInFormData && (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(keyValue);
            if (keyDefaultIsObject && keyHasFormDataObject && !defaultValueIsNestedObject) {
                accumulator[key] = {
                    ...(0, $547524a1010b9f1e$export$2e2bcd8739ae039)(defaults, key),
                    ...keyValue
                };
                return accumulator;
            }
            accumulator[key] = $197cd15f8a9b62b3$export$2e2bcd8739ae039((0, $547524a1010b9f1e$export$2e2bcd8739ae039)(defaults, key), keyValue, mergeExtraArrayDefaults, defaultSupercedesUndefined, // overrideFormDataWithDefaults can be true only when the key value exists in defaults
            // Or if the key value doesn't exist in formData
            overrideFormDataWithDefaults && (keyExistsInDefaults || !keyExistsInFormData));
            return acc;
        }, acc);
    }
    /**
     * If the defaultSupercedesUndefined flag is true
     *    And formData is set to undefined or null and defaults are defined
     *    Or if formData is a number and is NaN return defaults
     * Or if overrideFormDataWithDefaults flag is true and formData is set to not undefined/null return defaults
     */ if (defaultSupercedesUndefined && (!(defaults === undefined) && (0, $1f65e0187a0081bc$export$2e2bcd8739ae039)(formData) || typeof formData === 'number' && Number.isNaN(formData)) || overrideFormDataWithDefaults && !(0, $1f65e0187a0081bc$export$2e2bcd8739ae039)(formData)) return defaults;
    return formData;
}



function $4ab7d05f28605536$export$2e2bcd8739ae039(obj1, obj2, concatArrays = false) {
    return Object.keys(obj2).reduce((acc, key)=>{
        const left = obj1 ? obj1[key] : {}, right = obj2[key];
        if (obj1 && key in obj1 && (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(right)) acc[key] = $4ab7d05f28605536$export$2e2bcd8739ae039(left, right, concatArrays);
        else if (concatArrays && Array.isArray(left) && Array.isArray(right)) {
            let toMerge = right;
            if (concatArrays === 'preventDuplicates') toMerge = right.reduce((result, value)=>{
                if (!left.includes(value)) result.push(value);
                return result;
            }, []);
            acc[key] = left.concat(toMerge);
        } else acc[key] = right;
        return acc;
    }, {
        ...obj1
    }); // Prevent mutation of source object.
}








function $3737d3b91c8a40a7$export$2e2bcd8739ae039(schema) {
    if ((0, $cd207018ee28cb28$export$fca9148df915a7b6) in schema && Array.isArray(schema.enum) && schema.enum.length === 1) return schema.enum[0];
    if ((0, $cd207018ee28cb28$export$532244974323b6ba) in schema) return schema.const;
    throw new Error('schema cannot be inferred as a constant');
}


/** Reorders `options` according to `order`, which may contain a `'*'` wildcard representing all
 * remaining options in their original order. Options not listed in `order` (and not covered by
 * a wildcard) are dropped.
 */ function $01e18c537fba1f55$var$applyEnumOrder(options, order) {
    const optionsByValue = new Map(options.map((opt)=>[
            String(opt.value),
            opt
        ]));
    const orderedKeys = new Set(order.filter((v)=>v !== '*').map(String));
    const rest = options.filter((opt)=>!orderedKeys.has(String(opt.value)));
    return order.flatMap((entry)=>{
        if (entry === '*') return rest;
        const opt = optionsByValue.get(String(entry));
        return opt ? [
            opt
        ] : [];
    });
}
function $01e18c537fba1f55$export$2e2bcd8739ae039(schema, uiSchema) {
    if (schema.enum) {
        let enumNames;
        let enumOrder;
        if (uiSchema) {
            const { enumNames: uiEnumNames, enumOrder: uiEnumOrder } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
            enumNames = uiEnumNames;
            enumOrder = uiEnumOrder;
        }
        let options = schema.enum.map((value, i)=>{
            const label = Array.isArray(enumNames) ? enumNames[i] || String(value) : (enumNames === null || enumNames === void 0 ? void 0 : enumNames[String(value)]) || String(value);
            return {
                label: label,
                value: value
            };
        });
        if (enumOrder) options = $01e18c537fba1f55$var$applyEnumOrder(options, enumOrder);
        return options;
    }
    let altSchemas = undefined;
    let altUiSchemas = undefined;
    if (schema.anyOf) {
        altSchemas = schema.anyOf;
        altUiSchemas = uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema.anyOf;
    } else if (schema.oneOf) {
        altSchemas = schema.oneOf;
        altUiSchemas = uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema.oneOf;
    }
    // See if there is a discriminator path specified in the schema, and if so, use it as the selectorField, otherwise
    // pull one from the uiSchema
    let selectorField = (0, $9b9eddfbb66bfc4e$export$2e2bcd8739ae039)(schema);
    if (uiSchema) {
        const { optionsSchemaSelector: optionsSchemaSelector = selectorField } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
        selectorField = optionsSchemaSelector;
    }
    return altSchemas && altSchemas.map((aSchemaDef, index)=>{
        const { title: title } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(altUiSchemas === null || altUiSchemas === void 0 ? void 0 : altUiSchemas[index]);
        const aSchema = aSchemaDef;
        let value;
        let label = title;
        if (selectorField) {
            const innerSchema = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(aSchema, [
                (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
                selectorField
            ], {});
            value = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(innerSchema, (0, $cd207018ee28cb28$export$729d352c37f0a7df), (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(innerSchema, (0, $cd207018ee28cb28$export$532244974323b6ba)));
            label = label || (innerSchema === null || innerSchema === void 0 ? void 0 : innerSchema.title) || aSchema.title || String(value);
        } else {
            value = (0, $3737d3b91c8a40a7$export$2e2bcd8739ae039)(aSchema);
            label = label || aSchema.title || String(value);
        }
        return {
            schema: aSchema,
            label: label,
            value: value
        };
    });
}





function $9d5b05a84f9ed2c6$export$2e2bcd8739ae039(validator, theSchema, rootSchema = {}, experimental_customMergeAllOf) {
    const schema = (0, $9f63129bef70072a$export$2e2bcd8739ae039)(validator, theSchema, rootSchema, undefined, experimental_customMergeAllOf);
    const altSchemas = schema.oneOf || schema.anyOf;
    if (Array.isArray(schema.enum)) return true;
    if (Array.isArray(altSchemas)) return altSchemas.every((altSchema)=>typeof altSchema !== 'boolean' && (0, $9f4ca1c02304f30f$export$2e2bcd8739ae039)(altSchema));
    return false;
}


function $9e7b34d3201d4232$export$2e2bcd8739ae039(validator, schema, rootSchema, experimental_customMergeAllOf) {
    if (!schema.uniqueItems || !schema.items || typeof schema.items === 'boolean') return false;
    return (0, $9d5b05a84f9ed2c6$export$2e2bcd8739ae039)(validator, schema.items, rootSchema, experimental_customMergeAllOf);
}




const $cd95df1262c32dce$var$PRIMITIVE_TYPES = [
    'string',
    'number',
    'integer',
    'boolean',
    'null'
];
var $cd95df1262c32dce$export$1df5d7bacaa65fa3;
(function(AdditionalItemsHandling) {
    AdditionalItemsHandling[AdditionalItemsHandling["Ignore"] = 0] = "Ignore";
    AdditionalItemsHandling[AdditionalItemsHandling["Invert"] = 1] = "Invert";
    AdditionalItemsHandling[AdditionalItemsHandling["Fallback"] = 2] = "Fallback";
})($cd95df1262c32dce$export$1df5d7bacaa65fa3 || ($cd95df1262c32dce$export$1df5d7bacaa65fa3 = {}));
function $cd95df1262c32dce$export$4c9049b7d2685d31(schema, additionalItems = $cd95df1262c32dce$export$1df5d7bacaa65fa3.Ignore, idx = -1) {
    if (idx >= 0) {
        if (Array.isArray(schema.items) && idx < schema.items.length) {
            const item = schema.items[idx];
            if (typeof item !== 'boolean') return item;
        }
    } else if (schema.items && !Array.isArray(schema.items) && typeof schema.items !== 'boolean') return schema.items;
    if (additionalItems !== $cd95df1262c32dce$export$1df5d7bacaa65fa3.Ignore && (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(schema.additionalItems)) return schema.additionalItems;
    return {};
}
function $cd95df1262c32dce$export$93631abce7e3f7ae(schema, computedDefault) {
    const { default: schemaDefault, type: type } = schema;
    const shouldReturnNullAsDefault = Array.isArray(type) && type.includes('null') && (0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(computedDefault) && schemaDefault === null;
    return shouldReturnNullAsDefault ? null : computedDefault;
}
/** Either add `computedDefault` at `key` into `obj` or not add it based on its value, the value of
 * `includeUndefinedValues`, the value of `emptyObjectFields` and if its parent field is required. Generally undefined
 * `computedDefault` values are added only when `includeUndefinedValues` is either true/"excludeObjectChildren". If `
 * includeUndefinedValues` is false and `emptyObjectFields` is not "skipDefaults", then non-undefined and non-empty-object
 * values will be added based on certain conditions.
 *
 * @param acc - The object into which the computed default may be added
 * @param key - The key into the object at which the computed default may be added
 * @param computedDefault - The computed default value that maybe should be added to the obj
 * @param includeUndefinedValues - Optional flag, if true, cause undefined values to be added as defaults.
 *          If "excludeObjectChildren", cause undefined values for this object and pass `includeUndefinedValues` as
 *          false when computing defaults for any nested object properties. If "allowEmptyObject", prevents undefined
 *          values in this object while allow the object itself to be empty and passing `includeUndefinedValues` as
 *          false when computing defaults for any nested object properties.
 * @param isParentRequired - The optional boolean that indicates whether the parent field is required
 * @param requiredFields - The list of fields that are required
 * @param experimental_defaultFormStateBehavior - Optional configuration object, if provided, allows users to override
 *        default form state behavior
 * @param isConst - Optional flag, if true, indicates that the schema has a const property defined, thus we should always return the computedDefault since it's coming from the const.
 * @param isNullType - The type of the schema is null
 */ function $cd95df1262c32dce$var$maybeAddDefaultToObject(acc, key, computedDefault, includeUndefinedValues, isParentRequired, requiredFields = [], experimental_defaultFormStateBehavior = {}, isConst = false, isNullType = false) {
    const { emptyObjectFields: emptyObjectFields = 'populateAllDefaults' } = experimental_defaultFormStateBehavior;
    if (includeUndefinedValues === true || isConst) // If includeUndefinedValues is explicitly true
    // Or if the schema has a const property defined, then we should always return the computedDefault since it's coming from the const.
    acc[key] = computedDefault;
    else if (includeUndefinedValues === 'excludeObjectChildren') // Fix for Issue #4709: When in 'excludeObjectChildren' mode, don't set primitive fields to empty objects
    // Only add the computed default if it's not an empty object placeholder for a primitive field
    {
        if (isNullType && computedDefault !== undefined || !(0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(computedDefault) || !(0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(computedDefault)) acc[key] = computedDefault;
    } else if (emptyObjectFields !== 'skipDefaults') {
        // If isParentRequired is undefined, then we are at the root level of the schema so defer to the requiredness of
        // the field key itself in the `requiredField` list
        const isSelfOrParentRequired = isParentRequired === undefined ? requiredFields.includes(key) : isParentRequired;
        if ((0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(computedDefault)) {
            // If emptyObjectFields 'skipEmptyDefaults' store computedDefault if it's a non-empty object(e.g. not {})
            if (emptyObjectFields === 'skipEmptyDefaults') {
                if (!(0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(computedDefault)) acc[key] = computedDefault;
            } else if ((!(0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(computedDefault) || requiredFields.includes(key)) && (isSelfOrParentRequired || emptyObjectFields !== 'populateRequiredDefaults')) acc[key] = computedDefault;
        } else if (// Store computedDefault if it's a defined primitive (e.g., true) and satisfies certain conditions
        // Condition 1: computedDefault is not undefined
        // Condition 2: If emptyObjectFields is 'populateAllDefaults' or 'skipEmptyDefaults)
        // Or if isSelfOrParentRequired is 'true' and the key is a required field
        computedDefault !== undefined && (emptyObjectFields === 'populateAllDefaults' || emptyObjectFields === 'skipEmptyDefaults' || isSelfOrParentRequired && requiredFields.includes(key))) acc[key] = computedDefault;
    }
}
function $cd95df1262c32dce$export$b085b07994411aa(validator, rawSchema, computeDefaultsProps = {}) {
    const { parentDefaults: parentDefaults, rawFormData: rawFormData, rootSchema: rootSchema = {}, includeUndefinedValues: includeUndefinedValues = false, _recurseList: _recurseList = [], experimental_defaultFormStateBehavior: experimental_defaultFormStateBehavior, experimental_customMergeAllOf: experimental_customMergeAllOf, required: required, shouldMergeDefaultsIntoFormData: shouldMergeDefaultsIntoFormData = false, initialDefaultsGenerated: initialDefaultsGenerated } = computeDefaultsProps;
    let formData = (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(rawFormData) ? rawFormData : {};
    const schema = (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(rawSchema) ? rawSchema : {};
    // Compute the defaults recursively: give highest priority to deepest nodes.
    let defaults = parentDefaults;
    // If we get a new schema, then we need to recompute defaults again for the new schema found.
    let schemaToCompute = null;
    let experimental_dfsb_to_compute = experimental_defaultFormStateBehavior;
    let updatedRecurseList = _recurseList;
    if (schema[0, $cd207018ee28cb28$export$532244974323b6ba] !== undefined && (experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.constAsDefaults) !== 'never' && !(0, $f84c7ca4a7434b14$export$2e2bcd8739ae039)(schema)) defaults = schema[0, $cd207018ee28cb28$export$532244974323b6ba];
    else if ((0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(defaults) && (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(schema.default) && !schema[0, $cd207018ee28cb28$export$2014f14bbe7357bd] && !schema[0, $cd207018ee28cb28$export$c24c2c38af9a39c3] && !schema[0, $cd207018ee28cb28$export$cf02ae06bf291db4]) // For object defaults, only override parent defaults that are defined in
    // schema.default. Skip this for anyOf/oneOf/$ref schemas - they need special handling.
    defaults = (0, $4ab7d05f28605536$export$2e2bcd8739ae039)(defaults, schema.default);
    else if ((0, $cd207018ee28cb28$export$729d352c37f0a7df) in schema && !schema[0, $cd207018ee28cb28$export$2014f14bbe7357bd] && !schema[0, $cd207018ee28cb28$export$c24c2c38af9a39c3] && !schema[0, $cd207018ee28cb28$export$cf02ae06bf291db4]) // If the schema has a default value, then we should use it as the default.
    // And if the schema does not have anyOf or oneOf, this is done because we need to merge the defaults with the formData.
    defaults = schema.default;
    else if ((0, $cd207018ee28cb28$export$cf02ae06bf291db4) in schema) {
        const refName = schema[0, $cd207018ee28cb28$export$cf02ae06bf291db4];
        // Use referenced schema defaults for this node.
        if (!_recurseList.includes(refName)) {
            updatedRecurseList = _recurseList.concat(refName);
            schemaToCompute = (0, $9bd5acf65f690f1a$export$2e2bcd8739ae039)(refName, rootSchema);
        }
        // If the referenced schema exists and parentDefaults is not set
        // Then set the defaults from the current schema for the referenced schema.
        // Only do this if rawFormData has no meaningful data - we don't want to override user's existing values.
        // Check for undefined OR empty object - rawFormData may be coerced to {} when not an object.
        const hasNoExistingData = rawFormData === undefined || (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(rawFormData) && (0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(rawFormData);
        if (schemaToCompute && !defaults && hasNoExistingData) defaults = schema.default;
        // If shouldMergeDefaultsIntoFormData is true
        // And the schemaToCompute is set and the rawFormData is not an object
        // Then set the formData to the rawFormData
        if (shouldMergeDefaultsIntoFormData && schemaToCompute && !(0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(rawFormData)) formData = rawFormData;
    } else if ((0, $cd207018ee28cb28$export$f2daf7b7d8cced48) in schema) {
        // Get the default if set from properties to ensure the dependencies conditions are resolved based on it
        const defaultFormData = {
            ...$cd95df1262c32dce$export$d4ecf10b4bbf358f(validator, schema, computeDefaultsProps, defaults),
            ...formData
        };
        const resolvedSchema = (0, $9f63129bef70072a$export$c2e2dc4e82e5a6ad)(validator, schema, rootSchema, false, [], defaultFormData, experimental_customMergeAllOf);
        [schemaToCompute] = resolvedSchema; // pick the first element from resolve dependencies
    } else if ((0, $dfc36f50ea093ef6$export$2e2bcd8739ae039)(schema)) defaults = schema.items.map((itemSchema, idx)=>$cd95df1262c32dce$export$b085b07994411aa(validator, itemSchema, {
            rootSchema: rootSchema,
            includeUndefinedValues: includeUndefinedValues,
            _recurseList: _recurseList,
            experimental_defaultFormStateBehavior: experimental_defaultFormStateBehavior,
            experimental_customMergeAllOf: experimental_customMergeAllOf,
            parentDefaults: Array.isArray(parentDefaults) ? parentDefaults[idx] : undefined,
            rawFormData: formData,
            required: required,
            shouldMergeDefaultsIntoFormData: shouldMergeDefaultsIntoFormData
        }));
    else if ((0, $cd207018ee28cb28$export$c24c2c38af9a39c3) in schema) {
        const { oneOf: oneOf, ...remaining } = schema;
        if (oneOf.length === 0) return undefined;
        const discriminator = (0, $9b9eddfbb66bfc4e$export$2e2bcd8739ae039)(schema);
        const { type: type = 'null' } = remaining;
        if (!Array.isArray(type) && $cd95df1262c32dce$var$PRIMITIVE_TYPES.includes(type) && (experimental_dfsb_to_compute === null || experimental_dfsb_to_compute === void 0 ? void 0 : experimental_dfsb_to_compute.constAsDefaults) === 'skipOneOf') // If we are in a oneOf of a primitive type, then we want to pass constAsDefaults as 'never' for the recursion
        experimental_dfsb_to_compute = {
            ...experimental_dfsb_to_compute,
            constAsDefaults: 'never'
        };
        schemaToCompute = oneOf[(0, $3dd4655d2b27ee9e$export$2e2bcd8739ae039)(validator, rootSchema, rawFormData !== null && rawFormData !== void 0 ? rawFormData : schema.default, oneOf, 0, discriminator, experimental_customMergeAllOf)];
        schemaToCompute = (0, $c56cbb46ed08f5c4$export$2e2bcd8739ae039)(remaining, schemaToCompute);
    } else if ((0, $cd207018ee28cb28$export$2014f14bbe7357bd) in schema) {
        const { anyOf: anyOf, ...remaining } = schema;
        if (anyOf.length === 0) return undefined;
        const discriminator = (0, $9b9eddfbb66bfc4e$export$2e2bcd8739ae039)(schema);
        schemaToCompute = anyOf[(0, $3dd4655d2b27ee9e$export$2e2bcd8739ae039)(validator, rootSchema, rawFormData !== null && rawFormData !== void 0 ? rawFormData : schema.default, anyOf, 0, discriminator, experimental_customMergeAllOf)];
        schemaToCompute = (0, $c56cbb46ed08f5c4$export$2e2bcd8739ae039)(remaining, schemaToCompute);
    }
    if (schemaToCompute) return $cd95df1262c32dce$export$b085b07994411aa(validator, schemaToCompute, {
        rootSchema: rootSchema,
        includeUndefinedValues: includeUndefinedValues,
        _recurseList: updatedRecurseList,
        experimental_defaultFormStateBehavior: experimental_dfsb_to_compute,
        experimental_customMergeAllOf: experimental_customMergeAllOf,
        parentDefaults: defaults,
        rawFormData: rawFormData !== null && rawFormData !== void 0 ? rawFormData : formData,
        required: required,
        shouldMergeDefaultsIntoFormData: shouldMergeDefaultsIntoFormData,
        initialDefaultsGenerated: initialDefaultsGenerated
    });
    // No defaults defined for this node, fallback to generic typed ones.
    if (defaults === undefined) defaults = schema.default;
    const defaultBasedOnSchemaType = $cd95df1262c32dce$export$d4ecf10b4bbf358f(validator, schema, computeDefaultsProps, defaults);
    let defaultsWithFormData = defaultBasedOnSchemaType !== null && defaultBasedOnSchemaType !== void 0 ? defaultBasedOnSchemaType : defaults;
    // if shouldMergeDefaultsIntoFormData is true, then merge the defaults into the formData.
    if (shouldMergeDefaultsIntoFormData) {
        const { arrayMinItems: arrayMinItems = {} } = experimental_defaultFormStateBehavior || {};
        const { mergeExtraDefaults: mergeExtraDefaults } = arrayMinItems;
        const matchingFormData = $cd95df1262c32dce$export$933363e5a4732b0c(validator, schema, rootSchema, rawFormData, experimental_defaultFormStateBehavior, experimental_customMergeAllOf);
        if (!(0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(rawFormData) || (0, $cd207018ee28cb28$export$d2b65f1d256ab906) in schema) // If the formData is not an object which means it's a primitive field, then we need to merge the defaults into the formData.
        // Or if the schema has allOf, we need to merge the defaults into the formData because we don't compute the defaults for allOf.
        defaultsWithFormData = (0, $197cd15f8a9b62b3$export$2e2bcd8739ae039)(defaultsWithFormData, matchingFormData, mergeExtraDefaults, true);
    }
    return defaultsWithFormData;
}
function $cd95df1262c32dce$export$933363e5a4732b0c(validator, schema, rootSchema, formData, experimental_defaultFormStateBehavior, experimental_customMergeAllOf) {
    const isSelectField = !(0, $9f4ca1c02304f30f$export$2e2bcd8739ae039)(schema) && (0, $9d5b05a84f9ed2c6$export$2e2bcd8739ae039)(validator, schema, rootSchema, experimental_customMergeAllOf);
    let validFormData = formData;
    if (isSelectField) {
        const getOptionsList = (0, $01e18c537fba1f55$export$2e2bcd8739ae039)(schema);
        const isValid = getOptionsList === null || getOptionsList === void 0 ? void 0 : getOptionsList.some((option)=>(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(option.value, formData));
        validFormData = isValid ? formData : undefined;
    }
    // Override the formData with the const if the constAsDefaults is set to always
    const constTakesPrecedence = schema[0, $cd207018ee28cb28$export$532244974323b6ba] && (experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.constAsDefaults) === 'always';
    if (constTakesPrecedence) validFormData = schema.const;
    return validFormData;
}
function $cd95df1262c32dce$export$488495daee4b27ba(validator, rawSchema, { rawFormData: rawFormData, rootSchema: rootSchema = {}, includeUndefinedValues: includeUndefinedValues = false, _recurseList: _recurseList = [], experimental_defaultFormStateBehavior: experimental_defaultFormStateBehavior, experimental_customMergeAllOf: experimental_customMergeAllOf, required: required, shouldMergeDefaultsIntoFormData: shouldMergeDefaultsIntoFormData, initialDefaultsGenerated: initialDefaultsGenerated } = {}, defaults) {
    {
        const formData = (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(rawFormData) ? rawFormData : {};
        const schema = rawSchema;
        // Retrieve the schema:
        // - If schema contains `allOf` AND `experimental_defaultFormStateBehavior.allOf` is set to `populateDefaults`
        // - OR if schema contains an 'if' AND `emptyObjectFields` is not set to `skipEmptyDefaults`
        // This ensures we compute defaults correctly for schemas with these keywords.
        const shouldRetrieveSchema = (experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.allOf) === 'populateDefaults' && (0, $cd207018ee28cb28$export$d2b65f1d256ab906) in schema || (experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.emptyObjectFields) !== 'skipEmptyDefaults' && (0, $cd207018ee28cb28$export$fa01b0fcf30c8319) in schema;
        const retrievedSchema = shouldRetrieveSchema ? (0, $9f63129bef70072a$export$2e2bcd8739ae039)(validator, schema, rootSchema, formData, experimental_customMergeAllOf) : schema;
        const parentConst = retrievedSchema[0, $cd207018ee28cb28$export$532244974323b6ba];
        const objectDefaults = Object.keys(retrievedSchema.properties || {}).reduce((acc, key)=>{
            var _a;
            const propertySchema = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(retrievedSchema, [
                (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
                key
            ], {});
            // Check if the parent schema has a const property defined AND we are supporting const as defaults, then we
            // should always return the computedDefault since it's coming from the const.
            const hasParentConst = (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(parentConst) && parentConst[key] !== undefined;
            const hasConst = ((0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(propertySchema) && (0, $cd207018ee28cb28$export$532244974323b6ba) in propertySchema || hasParentConst) && (experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.constAsDefaults) !== 'never' && !(0, $f84c7ca4a7434b14$export$2e2bcd8739ae039)(propertySchema);
            // Compute the defaults for this node, with the parent defaults we might
            // have from a previous run: defaults[key].
            const computedDefault = $cd95df1262c32dce$export$b085b07994411aa(validator, propertySchema, {
                rootSchema: rootSchema,
                _recurseList: _recurseList,
                experimental_defaultFormStateBehavior: experimental_defaultFormStateBehavior,
                experimental_customMergeAllOf: experimental_customMergeAllOf,
                includeUndefinedValues: includeUndefinedValues === true,
                parentDefaults: (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(defaults, [
                    key
                ]),
                rawFormData: (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, [
                    key
                ]),
                required: (_a = retrievedSchema.required) === null || _a === void 0 ? void 0 : _a.includes(key),
                shouldMergeDefaultsIntoFormData: shouldMergeDefaultsIntoFormData,
                initialDefaultsGenerated: initialDefaultsGenerated
            });
            $cd95df1262c32dce$var$maybeAddDefaultToObject(acc, key, computedDefault, includeUndefinedValues, required, retrievedSchema.required, experimental_defaultFormStateBehavior, hasConst, (propertySchema === null || propertySchema === void 0 ? void 0 : propertySchema.type) === 'null');
            return acc;
        }, {});
        if (retrievedSchema.additionalProperties && !initialDefaultsGenerated) {
            // as per spec additionalProperties may be either schema or boolean
            const additionalPropertiesSchema = (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(retrievedSchema.additionalProperties) ? retrievedSchema.additionalProperties : {};
            const keys = new Set();
            const formDataRequired = [];
            Object.keys(formData).filter((key)=>!retrievedSchema.properties || !retrievedSchema.properties[key]).forEach((key)=>{
                keys.add(key);
                formDataRequired.push(key);
            });
            // Only seed keys from schema defaults when formData has no additionalProperties of its own.
            // If the user already has data (e.g. after a key rename), injecting default keys would
            // re-add stale entries that no longer exist in formData.
            if ((0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(defaults) && formDataRequired.length === 0) Object.keys(defaults).filter((key)=>!retrievedSchema.properties || !retrievedSchema.properties[key]).forEach((key)=>keys.add(key));
            keys.forEach((key)=>{
                var _a;
                const computedDefault = $cd95df1262c32dce$export$b085b07994411aa(validator, additionalPropertiesSchema, {
                    rootSchema: rootSchema,
                    _recurseList: _recurseList,
                    experimental_defaultFormStateBehavior: experimental_defaultFormStateBehavior,
                    experimental_customMergeAllOf: experimental_customMergeAllOf,
                    includeUndefinedValues: includeUndefinedValues === true,
                    parentDefaults: (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(defaults, [
                        key
                    ]),
                    rawFormData: (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, [
                        key
                    ]),
                    required: (_a = retrievedSchema.required) === null || _a === void 0 ? void 0 : _a.includes(key),
                    shouldMergeDefaultsIntoFormData: shouldMergeDefaultsIntoFormData,
                    initialDefaultsGenerated: initialDefaultsGenerated
                });
                // Since these are additional properties we don't need to add the `experimental_defaultFormStateBehavior` prop
                $cd95df1262c32dce$var$maybeAddDefaultToObject(objectDefaults, key, computedDefault, includeUndefinedValues, required, formDataRequired);
            });
        }
        return $cd95df1262c32dce$export$93631abce7e3f7ae(rawSchema, objectDefaults);
    }
}
function $cd95df1262c32dce$export$7ab13b6b8d00b766(validator, rawSchema, { rawFormData: rawFormData, rootSchema: rootSchema = {}, _recurseList: _recurseList = [], experimental_defaultFormStateBehavior: experimental_defaultFormStateBehavior, experimental_customMergeAllOf: experimental_customMergeAllOf, required: required, requiredAsRoot: requiredAsRoot = false, shouldMergeDefaultsIntoFormData: shouldMergeDefaultsIntoFormData, initialDefaultsGenerated: initialDefaultsGenerated } = {}, initialDefaults) {
    var _a, _b;
    let defaults = initialDefaults;
    const schema = rawSchema;
    const arrayMinItemsStateBehavior = (_a = experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.arrayMinItems) !== null && _a !== void 0 ? _a : {};
    const { populate: arrayMinItemsPopulate, mergeExtraDefaults: arrayMergeExtraDefaults } = arrayMinItemsStateBehavior;
    const neverPopulate = arrayMinItemsPopulate === 'never';
    const ignoreMinItemsFlagSet = arrayMinItemsPopulate === 'requiredOnly';
    const isPopulateAll = arrayMinItemsPopulate === 'all' || !neverPopulate && !ignoreMinItemsFlagSet;
    const computeSkipPopulate = (_b = arrayMinItemsStateBehavior === null || arrayMinItemsStateBehavior === void 0 ? void 0 : arrayMinItemsStateBehavior.computeSkipPopulate) !== null && _b !== void 0 ? _b : ()=>false;
    const isSkipEmptyDefaults = (experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.emptyObjectFields) === 'skipEmptyDefaults';
    const emptyDefault = isSkipEmptyDefaults ? undefined : [];
    // Inject defaults into existing array defaults
    if (Array.isArray(defaults)) defaults = defaults.map((item, idx)=>{
        const schemaItem = $cd95df1262c32dce$export$4c9049b7d2685d31(schema, $cd95df1262c32dce$export$1df5d7bacaa65fa3.Fallback, idx);
        const itemFormData = Array.isArray(rawFormData) ? rawFormData[idx] : undefined;
        return $cd95df1262c32dce$export$b085b07994411aa(validator, schemaItem, {
            rootSchema: rootSchema,
            _recurseList: _recurseList,
            experimental_defaultFormStateBehavior: experimental_defaultFormStateBehavior,
            experimental_customMergeAllOf: experimental_customMergeAllOf,
            parentDefaults: item,
            rawFormData: itemFormData,
            required: required,
            shouldMergeDefaultsIntoFormData: shouldMergeDefaultsIntoFormData,
            initialDefaultsGenerated: initialDefaultsGenerated
        });
    });
    // Deeply inject defaults into already existing form data
    if (Array.isArray(rawFormData)) {
        const schemaItem = $cd95df1262c32dce$export$4c9049b7d2685d31(schema);
        if (neverPopulate) defaults = rawFormData;
        else {
            const itemDefaults = rawFormData.map((item, idx)=>$cd95df1262c32dce$export$b085b07994411aa(validator, schemaItem, {
                    rootSchema: rootSchema,
                    _recurseList: _recurseList,
                    experimental_defaultFormStateBehavior: experimental_defaultFormStateBehavior,
                    experimental_customMergeAllOf: experimental_customMergeAllOf,
                    rawFormData: item,
                    parentDefaults: (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(defaults, [
                        idx
                    ]),
                    required: required,
                    shouldMergeDefaultsIntoFormData: shouldMergeDefaultsIntoFormData,
                    initialDefaultsGenerated: initialDefaultsGenerated
                }));
            // If the populate 'requiredOnly' flag is set then we only merge and include extra defaults if they are required.
            // Or if populate 'all' is set we merge and include extra defaults.
            const mergeExtraDefaults = (ignoreMinItemsFlagSet && required || isPopulateAll) && arrayMergeExtraDefaults;
            defaults = (0, $197cd15f8a9b62b3$export$2e2bcd8739ae039)(defaults, itemDefaults, mergeExtraDefaults);
        }
    }
    if (neverPopulate) return defaults !== null && defaults !== void 0 ? defaults : emptyDefault;
    if (ignoreMinItemsFlagSet && !required) // If no form data exists or defaults are set leave the field empty/non-existent, otherwise
    // return form data/defaults
    return defaults || undefined;
    let arrayDefault;
    const defaultsLength = Array.isArray(defaults) ? defaults.length : 0;
    if (!schema.minItems || (0, $9e7b34d3201d4232$export$2e2bcd8739ae039)(validator, schema, rootSchema, experimental_customMergeAllOf) || computeSkipPopulate(validator, schema, rootSchema) || schema.minItems <= defaultsLength) // we don't want undefined defaults unless it is both not required or not required as root
    arrayDefault = defaults || !required && !requiredAsRoot ? defaults : emptyDefault;
    else {
        const defaultEntries = defaults || [];
        const fillerSchema = $cd95df1262c32dce$export$4c9049b7d2685d31(schema, $cd95df1262c32dce$export$1df5d7bacaa65fa3.Invert);
        const fillerDefault = fillerSchema.default;
        // Calculate filler entries for remaining items (minItems - existing raw data/defaults)
        const fillerEntries = Array.from({
            length: schema.minItems - defaultsLength
        }, ()=>$cd95df1262c32dce$export$b085b07994411aa(validator, fillerSchema, {
                parentDefaults: fillerDefault,
                rootSchema: rootSchema,
                _recurseList: _recurseList,
                experimental_defaultFormStateBehavior: experimental_defaultFormStateBehavior,
                experimental_customMergeAllOf: experimental_customMergeAllOf,
                required: required,
                shouldMergeDefaultsIntoFormData: shouldMergeDefaultsIntoFormData
            }));
        // then fill up the rest with either the item default or empty, up to minItems
        arrayDefault = defaultEntries.concat(fillerEntries);
    }
    return $cd95df1262c32dce$export$93631abce7e3f7ae(rawSchema, arrayDefault);
}
function $cd95df1262c32dce$export$d4ecf10b4bbf358f(validator, rawSchema, computeDefaultsProps = {}, defaults) {
    switch((0, $624c3ff4310242dc$export$2e2bcd8739ae039)(rawSchema)){
        // We need to recurse for object schema inner default values.
        case 'object':
            return $cd95df1262c32dce$export$488495daee4b27ba(validator, rawSchema, computeDefaultsProps, defaults);
        case 'array':
            return $cd95df1262c32dce$export$7ab13b6b8d00b766(validator, rawSchema, computeDefaultsProps, defaults);
        default:
            return undefined;
    }
}
function $cd95df1262c32dce$export$2e2bcd8739ae039(validator, theSchema, formData, rootSchema, includeUndefinedValues = false, experimental_defaultFormStateBehavior, experimental_customMergeAllOf, initialDefaultsGenerated) {
    if (!(0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(theSchema)) throw new Error(`Invalid schema: ${theSchema}`);
    const schema = (0, $9f63129bef70072a$export$2e2bcd8739ae039)(validator, theSchema, rootSchema, formData, experimental_customMergeAllOf);
    // Get the computed defaults with 'shouldMergeDefaultsIntoFormData' set to true to merge defaults into formData.
    // This is done when for example the value from formData does not exist in the schema 'enum' property, in such
    // cases we take the value from the defaults because the value from the formData is not valid.
    const defaults = $cd95df1262c32dce$export$b085b07994411aa(validator, schema, {
        rootSchema: rootSchema,
        includeUndefinedValues: includeUndefinedValues,
        experimental_defaultFormStateBehavior: experimental_defaultFormStateBehavior,
        experimental_customMergeAllOf: experimental_customMergeAllOf,
        rawFormData: formData,
        shouldMergeDefaultsIntoFormData: true,
        initialDefaultsGenerated: initialDefaultsGenerated,
        requiredAsRoot: true
    });
    if (schema.type !== 'object' && (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(schema.default)) return {
        ...defaults,
        ...formData
    };
    // If the formData is an object or an array, add additional properties from formData and override formData with
    // defaults since the defaults are already merged with formData.
    if ((0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(formData) || Array.isArray(formData)) {
        const { mergeDefaultsIntoFormData: mergeDefaultsIntoFormData } = experimental_defaultFormStateBehavior || {};
        const defaultSupercedesUndefined = mergeDefaultsIntoFormData === 'useDefaultIfFormDataUndefined';
        const result = (0, $197cd15f8a9b62b3$export$2e2bcd8739ae039)(defaults, formData, true, defaultSupercedesUndefined, true);
        return result;
    }
    return defaults;
}







function $2078450ae8c93797$export$2e2bcd8739ae039(uiSchema = {}) {
    return(// TODO: Remove the `&& uiSchema['ui:widget'] !== 'hidden'` once we support hidden widgets for arrays.
    // https://rjsf-team.github.io/react-jsonschema-form/docs/usage/widgets/#hidden-widgets
    'widget' in (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema) && (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema).widget !== 'hidden');
}




function $d7cb20ccb583218f$export$2e2bcd8739ae039(validator, schema, uiSchema = {}, rootSchema, experimental_customMergeAllOf) {
    if (uiSchema[0, $cd207018ee28cb28$export$6d66d36e6bc18c7c] === 'files') return true;
    if (schema.items) {
        const itemsSchema = (0, $9f63129bef70072a$export$2e2bcd8739ae039)(validator, schema.items, rootSchema, undefined, experimental_customMergeAllOf);
        return itemsSchema.type === 'string' && itemsSchema.format === 'data-url';
    }
    return false;
}



function $3b3b81219ed47025$export$2e2bcd8739ae039(validator, schema, uiSchema = {}, rootSchema, globalOptions, experimental_customMergeAllOf) {
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, globalOptions);
    const { label: label = true } = uiOptions;
    let displayLabel = Boolean(label);
    if (displayLabel) {
        const schemaType = (0, $624c3ff4310242dc$export$2e2bcd8739ae039)(schema);
        const addedByAdditionalProperty = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$60d2d9c11642ddd6), false);
        if (schemaType === 'array') displayLabel = addedByAdditionalProperty || (0, $9e7b34d3201d4232$export$2e2bcd8739ae039)(validator, schema, rootSchema, experimental_customMergeAllOf) || (0, $d7cb20ccb583218f$export$2e2bcd8739ae039)(validator, schema, uiSchema, rootSchema, experimental_customMergeAllOf) || (0, $2078450ae8c93797$export$2e2bcd8739ae039)(uiSchema);
        if (schemaType === 'object') displayLabel = addedByAdditionalProperty;
        if (schemaType === 'boolean' && uiSchema && !uiSchema[0, $cd207018ee28cb28$export$6d66d36e6bc18c7c]) displayLabel = false;
        if (uiSchema && uiSchema[0, $cd207018ee28cb28$export$3ee4d15a1e25438d]) displayLabel = false;
    }
    return displayLabel;
}













/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $a3a758bec8a223c0$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = (0, $f82e6a7e1b9a1d35$export$2e2bcd8739ae039)(object, path);
        if (predicate(value, path)) (0, $07920a1e18250d4e$export$2e2bcd8739ae039)(result, (0, $550dd133df69fd0b$export$2e2bcd8739ae039)(path, object), value);
    }
    return result;
}
var $a3a758bec8a223c0$export$2e2bcd8739ae039 = $a3a758bec8a223c0$var$basePickBy;



/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $4f61e72df73a61d4$var$basePick(object, paths) {
    return (0, $a3a758bec8a223c0$export$2e2bcd8739ae039)(object, paths, function(value, path) {
        return (0, $725ca700b89428ac$export$2e2bcd8739ae039)(object, path);
    });
}
var $4f61e72df73a61d4$export$2e2bcd8739ae039 = $4f61e72df73a61d4$var$basePick;



/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $ec25ad87a4fc6980$var$pick = (0, $673aabd57681060c$export$2e2bcd8739ae039)(function(object, paths) {
    return object == null ? {} : (0, $4f61e72df73a61d4$export$2e2bcd8739ae039)(object, paths);
});
var $ec25ad87a4fc6980$export$2e2bcd8739ae039 = $ec25ad87a4fc6980$var$pick;











function $e7d329486831c49a$export$ac9347ddfe1a1735(formData, fields) {
    // For the case of a single input form
    if (fields.length === 0 && typeof formData !== 'object') return formData;
    const data = (0, $ec25ad87a4fc6980$export$2e2bcd8739ae039)(formData, fields);
    if (Array.isArray(formData)) return Object.keys(data).map((key)=>data[key]);
    return data;
}
function $e7d329486831c49a$export$d814fe1c0e81ab0f(pathSchema, formData) {
    const formValueHasData = (value, isLeaf)=>typeof value !== 'object' || (0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(value) || isLeaf && !(0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(value);
    const getAllPaths = (_obj, acc = [], paths = [
        []
    ])=>{
        const objKeys = Object.keys(_obj);
        objKeys.forEach((key)=>{
            const data = _obj[key];
            if (typeof data === 'object') {
                const newPaths = paths.map((path)=>[
                        ...path,
                        key
                    ]);
                // If an object is marked with additionalProperties, all its keys are valid
                if (data[0, $cd207018ee28cb28$export$379f2e8c0717b331] && data[0, $cd207018ee28cb28$export$299579ccbdd63cbc] !== '') acc.push(data[0, $cd207018ee28cb28$export$299579ccbdd63cbc]);
                else getAllPaths(data, acc, newPaths);
            } else if (key === (0, $cd207018ee28cb28$export$299579ccbdd63cbc) && data !== '') paths.forEach((path)=>{
                const formValue = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, path);
                const isLeaf = objKeys.length === 1;
                // adds path to fieldNames if it points to a value or an empty object/array which is not a leaf
                if (formValueHasData(formValue, isLeaf) || Array.isArray(formValue) && formValue.every((val)=>formValueHasData(val, isLeaf))) acc.push(path);
            });
        });
        return acc;
    };
    return getAllPaths(pathSchema);
}
function $e7d329486831c49a$export$45ee1743c0763984(value) {
    if ((0, $1f65e0187a0081bc$export$2e2bcd8739ae039)(value) || value === '') return true;
    if (Array.isArray(value)) return value.length === 0;
    if ((0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(value)) return Object.values(value).every($e7d329486831c49a$export$45ee1743c0763984);
    return false;
}
/** Merges an `allOf` schema into a single flat schema, delegating to `experimental_customMergeAllOf`
 * when provided or falling back to the module-level `shallowAllOfMerge` otherwise.
 *
 * @param schema - A schema containing an `allOf` array to be merged
 * @param [experimental_customMergeAllOf] - Optional custom merge function; see `Form` documentation
 * @returns - The merged schema with `allOf` resolved into a single schema object
 */ function $e7d329486831c49a$var$doMergeAllOf(schema, experimental_customMergeAllOf) {
    return experimental_customMergeAllOf ? experimental_customMergeAllOf(schema) : (0, $b3020f77cc91fc56$export$2e2bcd8739ae039)(schema);
}
function $e7d329486831c49a$export$2e2bcd8739ae039(validator, schema, rootSchema = {}, formData, experimental_customMergeAllOf) {
    /** Type predicate that narrows `value` to `GenericObjectType` — true when `value` is a plain,
     * non-array object (i.e. a JSON object). Used to distinguish JSON objects from arrays and primitives.
     *
     * @param value - The value to check
     * @returns - True if `value` is a plain non-array object
     */ function isObjectValue(value) {
        return (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(value);
    }
    /** Type predicate that narrows a `S | boolean` schema definition to `S` — true when `schemaDef` is
     * a schema object rather than a JSON Schema boolean shorthand (`true` meaning allow-all, `false`
     * meaning deny-all).
     *
     * @param schemaDef - The schema definition to check
     * @returns - True if `schemaDef` is a schema object
     */ function isSchemaObj(schemaDef) {
        return (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(schemaDef);
    }
    /** Copies schema-defined properties from `source` into `target`, applying `omit` recursively for
     * each value. Handles `properties`, `patternProperties`, `additionalProperties`, and `propertyNames`.
     * Optional object-valued properties are pruned when every key in the filtered result is both
     * optional (per the inner schema's `required`) and empty (per `isValueEmpty`). This preserves
     * optional objects whose required children have empty values, while still dropping objects whose
     * schema-filtered content is entirely optional-and-empty. Required properties and scalar values
     * are always written when defined. Always returns `target` — pruning of the object itself is
     * the caller's responsibility.
     *
     * @param childSchema - The object schema describing which properties are allowed
     * @param source - The source form data object to read values from
     * @param target - The accumulator object to write filtered values into
     * @returns - `target` after all schema-defined properties have been processed
     */ function handleObject(childSchema, source, target) {
        var _a;
        const { properties: properties, additionalProperties: additionalProperties, patternProperties: patternProperties, propertyNames: propertyNames } = childSchema;
        const requiredSet = new Set((_a = childSchema.required) !== null && _a !== void 0 ? _a : []);
        /** Recursively omits extra data from `value` via `omit`, then conditionally writes the result to
         * `target[key]`. Optional object-valued properties are dropped when every key in the filtered
         * result is both optional (within the inner schema's `required` list) and has an empty value per
         * `isValueEmpty`. This per-key approach prevents required-but-empty child properties — kept by
         * inner `setProperty` calls — from inadvertently causing the parent optional object to be dropped,
         * while still pruning optional objects whose schema-filtered content is entirely empty. Vacuously
         * true for `{}`, so empty results are always dropped. Scalar and array values are not pruned here.
         *
         * @param key - The property key to write on `target`
         * @param schemaDef - The schema (or boolean shorthand) that governs the value at `key`
         * @param value - The raw source value to filter
         * @param [required=false] - When true the property is never pruned regardless of its filtered value
         */ function setProperty(key, schemaDef, value, required = false) {
            var _a;
            const v = omit(schemaDef, value, target[key]);
            if (!required && (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(v)) {
                // Resolve $ref so we can inspect the effective required list for the inner schema.
                let sd = isSchemaObj(schemaDef) ? schemaDef : {};
                if (sd.$ref !== undefined) sd = (0, $9bd5acf65f690f1a$export$2e2bcd8739ae039)(sd.$ref, rootSchema);
                const innerRequired = new Set((_a = sd.required) !== null && _a !== void 0 ? _a : []);
                // Drop this optional object when every key in v is both optional in the inner schema
                // and has an empty value. Vacuously true for {} so empty objects are always dropped.
                const shouldDrop = Object.entries(v).every(([k, val])=>!innerRequired.has(k) && $e7d329486831c49a$export$45ee1743c0763984(val));
                if (shouldDrop) return;
            }
            if (v !== undefined) // oxlint-disable-next-line no-param-reassign
            target[key] = v;
        }
        if (properties !== undefined) for (const [key, schemaDef] of Object.entries(properties))setProperty(key, schemaDef, source[key], requiredSet.has(key));
        // Track keys not handled by properties/patterns so additionalProperties can pick them up.
        let patternPropertiesRest;
        if (patternProperties !== undefined) {
            patternPropertiesRest = [];
            const patterns = Object.entries(patternProperties).map(([pattern, schemaDef])=>[
                    new RegExp(pattern),
                    schemaDef
                ]);
            const knownProperties = new Set(Object.keys(properties !== null && properties !== void 0 ? properties : {}));
            for (const [key, value] of Object.entries(source))if (!knownProperties.has(key)) {
                const matched = patterns.find(([re])=>re.test(key));
                if (matched === undefined) patternPropertiesRest.push(key);
                else setProperty(key, matched[1], value);
            }
        }
        // JSON Schema spec: absent additionalProperties defaults to true (allow all extra keys). Here
        // we treat it as false so omitExtraData never inadvertently passes through undescribed keys.
        if (additionalProperties !== undefined && additionalProperties !== false) {
            const addlSchema = additionalProperties;
            if (patternPropertiesRest !== undefined) for (const key of patternPropertiesRest)setProperty(key, addlSchema, source[key]);
            else {
                const knownProperties = new Set(Object.keys(properties !== null && properties !== void 0 ? properties : {}));
                for (const [key, value] of Object.entries(source))if (!knownProperties.has(key)) setProperty(key, addlSchema, value);
            }
        }
        // When propertyNames is present, the schema only constrains key names — all source keys are valid.
        if (propertyNames !== undefined) for (const [key, value] of Object.entries(source))// oxlint-disable-next-line no-param-reassign
        target[key] = value;
        return target;
    }
    /** Filters array elements from `source` into `target` according to `schema.items` and
     * `schema.additionalItems`. For tuple schemas (`items` is an array) each element is filtered by its
     * per-index schema; elements beyond the tuple length are covered by `additionalItems` when present.
     * For list schemas (`items` is a single schema) every element is filtered by that schema.
     *
     * @param childSchema - The array schema describing `items` and optionally `additionalItems`
     * @param source - The source array to read elements from
     * @param target - The accumulator array to push filtered elements into
     * @returns - `target` after all applicable source elements have been pushed
     */ function handleArray(childSchema, source, target) {
        const { items: items, additionalItems: additionalItems } = childSchema;
        if (items !== undefined) {
            if (Array.isArray(items)) for(let i = 0; i < items.length; i += 1)target.push(omit(items[i], source[i]));
            else for(let i = 0; i < source.length; i += 1)target.push(omit(items, source[i]));
        }
        // additionalItems covers tuple items beyond the items array length.
        if (additionalItems) for(let i = target.length; i < source.length; i += 1)target.push(omit(additionalItems, source[i]));
        return target;
    }
    /** Applies the `if/then/else` conditional keywords from `schema` to `target`. When `schema.if` is
     * absent the original `target` is returned unchanged. Otherwise the condition is evaluated — using
     * `validator.isValid` for schema conditions or the boolean value directly — and the matching branch
     * (`then` or `else`) is applied via `omit`. When the selected branch is absent, `target` is returned
     * unchanged.
     *
     * @param childSchema - The schema potentially containing `if`, `then`, and `else` keywords
     * @param source - The current form data value, passed to `validator.isValid` and the branch `omit`
     * @param target - The already-filtered value to merge the branch result into
     * @returns - The result of applying the matched branch, or `target` when no branch applies
     */ function handleConditions(childSchema, source, target) {
        const { if: condition, then: then, else: otherwise } = childSchema;
        if (condition === undefined) return target;
        // validator.isValid signature: (schema, formData, rootSchema)
        const isThenBranch = isSchemaObj(condition) ? validator.isValid(condition, source, rootSchema) : condition;
        const branch = isThenBranch ? then : otherwise;
        return branch === undefined ? target : omit(branch, source, target);
    }
    /** Applies the best-matching `oneOf` option to `source`, merging the result into `target`. When
     * `oneOf` is not an array or the schema represents a select widget (enum-driven), `target` is
     * returned unchanged. `additionalProperties: false` is relaxed on each option before scoring so that
     * `getClosestMatchingOption` can validate freely, but the original option schema is used for the
     * actual `omit` call.
     *
     * @param oneOf - The `oneOf` array from the schema, or `undefined`
     * @param childSchema - The parent schema containing the `oneOf` keyword
     * @param source - The current form data value used to score each option
     * @param target - The already-filtered value to merge the winning option's result into
     * @returns - The result of applying the best-matching option, or `target` when no matching applies
     */ function handleOneOf(oneOf, childSchema, source, target) {
        if (!Array.isArray(oneOf) || (0, $9d5b05a84f9ed2c6$export$2e2bcd8739ae039)(validator, childSchema, rootSchema, experimental_customMergeAllOf)) return target;
        // Resolve $refs and relax additionalProperties:false → true in one pass for scoring only.
        // The unrelaxed resolved schema is re-derived for the winning option so that omit() still
        // respects additionalProperties:false during filtering.
        const scoringOptions = (0, $9f63129bef70072a$export$5f3402ad64950ace)(oneOf, true, rootSchema);
        const bestIndex = (0, $3dd4655d2b27ee9e$export$2e2bcd8739ae039)(validator, rootSchema, source, scoringOptions, 0, (0, $9b9eddfbb66bfc4e$export$2e2bcd8739ae039)(childSchema), experimental_customMergeAllOf);
        const winning = oneOf[bestIndex];
        // For object options, re-resolve without relaxation so additionalProperties:false is respected.
        // For boolean options, scoringOptions already holds the converted schema (true→{}, false→{not:{}}).
        const resolved = (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(winning) ? (0, $9f63129bef70072a$export$b19f555e2de5b541)(winning, rootSchema, []) : scoringOptions[bestIndex];
        return omit(resolved, source, target);
    }
    /** Applies `anyOf` branches from `schema` to `source`, merging results into `target`. When `anyOf`
     * is absent or not an array, `target` is returned unchanged. For undefined or empty sources (so that
     * defaults can flow through all branches) every branch is applied in sequence. For non-empty sources
     * the best-matching branch is selected via `handleOneOf`.
     *
     * @param childSchema - The schema potentially containing an `anyOf` keyword
     * @param source - The current form data value; empty or undefined triggers all-branch application
     * @param target - The already-filtered value to merge branch results into
     * @returns - The result after applying the relevant `anyOf` branch(es), or `target` when inapplicable
     */ function handleAnyOf(childSchema, source, target) {
        const { anyOf: anyOf } = childSchema;
        if (!Array.isArray(anyOf)) return target;
        // For undefined or empty collections, apply every branch so defaults flow through.
        if (source === undefined || Array.isArray(source) && source.length === 0 || (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(source) && Object.keys(source).length === 0) {
            let result = target;
            for (const branch of anyOf)result = omit(branch, source, result);
            return result;
        }
        return handleOneOf(anyOf, childSchema, source, target);
    }
    /** Applies schema-based `dependencies` from `schema` to `source`, merging each active dependency's
     * schema into `target` via `omit`. Property dependencies (plain string arrays) are skipped — only
     * schema dependencies are processed. A dependency is considered active when its trigger key is
     * present on `source`.
     *
     * @param childSchema - The schema potentially containing a `dependencies` keyword
     * @param source - The current form data value; must be a plain object for dependencies to apply
     * @param target - The already-filtered value to merge dependency results into
     * @returns - The result after applying all active schema dependencies, or `target` when inapplicable
     */ function handleDependencies(childSchema, source, target) {
        const { dependencies: dependencies } = childSchema;
        if (dependencies === undefined || !isObjectValue(source)) return target;
        let result = target;
        for (const [key, deps] of Object.entries(dependencies))// Skip property dependencies (string arrays); only process schema dependencies.
        if (key in source && !Array.isArray(deps)) result = omit(deps, source, result);
        return result;
    }
    /** Core recursive filter. Resolves `$ref`s, merges `allOf`, then delegates to the type-specific
     * handlers (`handleObject`, `handleArray`) and keyword handlers (`handleAnyOf`, `handleOneOf`,
     * `handleConditions`, `handleDependencies`). Returns `undefined` when `source` is undefined or
     * `schemaDef` is `false`; returns `source` unchanged when `schemaDef` is `true` or empty.
     *
     * @param schemaDef - The schema (or boolean shorthand) to filter `source` against
     * @param source - The raw form data value to filter
     * @param [target] - An optional accumulator carrying results from prior oneOf/anyOf processing
     * @returns - The filtered value, or `undefined` when the schema rejects the value
     */ function omit(schemaDef, source, target) {
        if (source === undefined || schemaDef === false) return undefined;
        if (schemaDef === true || (0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(schemaDef)) return source;
        let localSchema = schemaDef;
        const { $ref: ref, allOf: allOf } = localSchema;
        if (ref !== undefined) return omit((0, $9bd5acf65f690f1a$export$2e2bcd8739ae039)(ref, rootSchema), source, target);
        if (allOf) localSchema = $e7d329486831c49a$var$doMergeAllOf(localSchema, experimental_customMergeAllOf);
        let filtered = handleAnyOf(localSchema, source, handleOneOf(localSchema.oneOf, localSchema, source, target));
        const type = (0, $624c3ff4310242dc$export$2e2bcd8739ae039)(localSchema);
        if (type === 'object') {
            if (!isObjectValue(source)) return undefined;
            filtered = handleObject(localSchema, source, isObjectValue(filtered) ? filtered : {});
        } else if (type === 'array') {
            if (!Array.isArray(source)) return undefined;
            filtered = handleArray(localSchema, source, Array.isArray(filtered) ? filtered : []);
        } else if (filtered === undefined) filtered = source;
        return handleDependencies(localSchema, source, handleConditions(localSchema, source, filtered));
    }
    return omit(schema, formData);
}








const $c112c26a1f6cb57a$var$NO_VALUE = Symbol('no Value');
function $c112c26a1f6cb57a$var$enumValuesForSchema(schema) {
    if (Array.isArray(schema.enum)) return schema.enum;
    const options = schema.oneOf || schema.anyOf;
    if (!Array.isArray(options)) return undefined;
    const values = options.map((option)=>{
        if ((0, $cd207018ee28cb28$export$532244974323b6ba) in option) return option[0, $cd207018ee28cb28$export$532244974323b6ba];
        return Array.isArray(option.enum) && option.enum.length === 1 ? option.enum[0] : $c112c26a1f6cb57a$var$NO_VALUE;
    }).filter((value)=>value !== $c112c26a1f6cb57a$var$NO_VALUE);
    return values.length > 0 ? values : undefined;
}
function $c112c26a1f6cb57a$var$replacementForInvalidEnumValue(schema, formValue) {
    const enumValues = $c112c26a1f6cb57a$var$enumValuesForSchema(schema);
    if (!enumValues || enumValues.some((value)=>(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(value, formValue))) return $c112c26a1f6cb57a$var$NO_VALUE;
    const defaultValue = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$729d352c37f0a7df), $c112c26a1f6cb57a$var$NO_VALUE);
    if (defaultValue !== $c112c26a1f6cb57a$var$NO_VALUE && enumValues.some((value)=>(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(value, defaultValue))) return defaultValue;
    return enumValues.length === 1 ? enumValues[0] : undefined;
}
function $c112c26a1f6cb57a$export$2e2bcd8739ae039(validator, rootSchema, newSchema, oldSchema, data = {}, experimental_customMergeAllOf) {
    // By default, we will clear the form data
    let newFormData;
    // If the new schema is of type object and that object contains a list of properties
    if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(newSchema, (0, $cd207018ee28cb28$export$dd550d4e98f939a4))) {
        // Create an object containing root-level keys in the old schema, setting each key to undefined to remove the data
        const removeOldSchemaData = {};
        if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(oldSchema, (0, $cd207018ee28cb28$export$dd550d4e98f939a4))) {
            const properties = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(oldSchema, (0, $cd207018ee28cb28$export$dd550d4e98f939a4), {});
            Object.keys(properties).forEach((key)=>{
                if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(data, key)) removeOldSchemaData[key] = undefined;
            });
        }
        const keys = Object.keys((0, $547524a1010b9f1e$export$2e2bcd8739ae039)(newSchema, (0, $cd207018ee28cb28$export$dd550d4e98f939a4), {}));
        // Create a place to store nested data that will be a side-effect of the filter
        const nestedData = {};
        keys.forEach((key)=>{
            const formValue = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(data, key);
            let oldKeyedSchema = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(oldSchema, [
                (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
                key
            ], {});
            let newKeyedSchema = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(newSchema, [
                (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
                key
            ], {});
            // Resolve the refs if they exist
            if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(oldKeyedSchema, (0, $cd207018ee28cb28$export$cf02ae06bf291db4))) oldKeyedSchema = (0, $9f63129bef70072a$export$2e2bcd8739ae039)(validator, oldKeyedSchema, rootSchema, formValue, experimental_customMergeAllOf);
            if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(newKeyedSchema, (0, $cd207018ee28cb28$export$cf02ae06bf291db4))) newKeyedSchema = (0, $9f63129bef70072a$export$2e2bcd8739ae039)(validator, newKeyedSchema, rootSchema, formValue, experimental_customMergeAllOf);
            // Now get types and see if they are the same
            const oldSchemaTypeForKey = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(oldKeyedSchema, 'type');
            const newSchemaTypeForKey = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(newKeyedSchema, 'type');
            // Check if the old option has the same key with the same type
            if (!oldSchemaTypeForKey || oldSchemaTypeForKey === newSchemaTypeForKey) {
                if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(removeOldSchemaData, key)) // SIDE-EFFECT: remove the undefined value for a key that has the same type between the old and new schemas
                delete removeOldSchemaData[key];
                // If it is an object, we'll recurse and store the resulting sanitized data for the key
                if (newSchemaTypeForKey === 'object' || newSchemaTypeForKey === 'array' && Array.isArray(formValue)) {
                    // SIDE-EFFECT: process the new schema type of object recursively to save iterations
                    const itemData = $c112c26a1f6cb57a$export$2e2bcd8739ae039(validator, rootSchema, newKeyedSchema, oldKeyedSchema, formValue, experimental_customMergeAllOf);
                    if (itemData !== undefined || newSchemaTypeForKey === 'array') // only put undefined values for the array type and not the object type
                    nestedData[key] = itemData;
                } else {
                    // Ok, the non-object types match, let's make sure that a default or a const of a different value is replaced
                    // with the new default or const. This allows the case where two schemas differ that only by the default/const
                    // value to be properly selected
                    const newOptionDefault = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(newKeyedSchema, (0, $cd207018ee28cb28$export$729d352c37f0a7df), $c112c26a1f6cb57a$var$NO_VALUE);
                    const oldOptionDefault = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(oldKeyedSchema, (0, $cd207018ee28cb28$export$729d352c37f0a7df), $c112c26a1f6cb57a$var$NO_VALUE);
                    if (newOptionDefault !== $c112c26a1f6cb57a$var$NO_VALUE && newOptionDefault !== formValue) {
                        if (oldOptionDefault === formValue) // If the old default matches the formValue, we'll update the new value to match the new default
                        removeOldSchemaData[key] = newOptionDefault;
                        else if ((0, $547524a1010b9f1e$export$2e2bcd8739ae039)(newKeyedSchema, 'readOnly') === true) // If the new schema has the default set to read-only, treat it like a const and remove the value
                        removeOldSchemaData[key] = undefined;
                    }
                    const newOptionConst = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(newKeyedSchema, (0, $cd207018ee28cb28$export$532244974323b6ba), $c112c26a1f6cb57a$var$NO_VALUE);
                    const oldOptionConst = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(oldKeyedSchema, (0, $cd207018ee28cb28$export$532244974323b6ba), $c112c26a1f6cb57a$var$NO_VALUE);
                    if (newOptionConst !== $c112c26a1f6cb57a$var$NO_VALUE && newOptionConst !== formValue) // Since this is a const, if the old value matches, replace the value with the new const otherwise clear it
                    removeOldSchemaData[key] = oldOptionConst === formValue ? newOptionConst : undefined;
                    if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(data, key)) {
                        const enumReplacement = $c112c26a1f6cb57a$var$replacementForInvalidEnumValue(newKeyedSchema, formValue);
                        if (enumReplacement !== $c112c26a1f6cb57a$var$NO_VALUE) removeOldSchemaData[key] = enumReplacement;
                    }
                }
            }
        });
        newFormData = {
            ...typeof data === 'string' || Array.isArray(data) ? undefined : data,
            ...removeOldSchemaData,
            ...nestedData
        };
    // First apply removing the old schema data, then apply the nested data, then apply the old data keys to keep
    } else if ((0, $547524a1010b9f1e$export$2e2bcd8739ae039)(oldSchema, 'type') === 'array' && (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(newSchema, 'type') === 'array' && Array.isArray(data)) {
        let oldSchemaItems = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(oldSchema, 'items');
        let newSchemaItems = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(newSchema, 'items');
        // If any of the array types `items` are arrays (remember arrays are objects) then we'll just drop the data
        // Eventually, we may want to deal with when either of the `items` are arrays since those tuple validations
        if (typeof oldSchemaItems === 'object' && typeof newSchemaItems === 'object' && !Array.isArray(oldSchemaItems) && !Array.isArray(newSchemaItems)) {
            if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(oldSchemaItems, (0, $cd207018ee28cb28$export$cf02ae06bf291db4))) oldSchemaItems = (0, $9f63129bef70072a$export$2e2bcd8739ae039)(validator, oldSchemaItems, rootSchema, data, experimental_customMergeAllOf);
            if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(newSchemaItems, (0, $cd207018ee28cb28$export$cf02ae06bf291db4))) newSchemaItems = (0, $9f63129bef70072a$export$2e2bcd8739ae039)(validator, newSchemaItems, rootSchema, data, experimental_customMergeAllOf);
            // Now get types and see if they are the same
            const oldSchemaType = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(oldSchemaItems, 'type');
            const newSchemaType = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(newSchemaItems, 'type');
            // Check if the old option has the same key with the same type
            if (!oldSchemaType || oldSchemaType === newSchemaType) {
                const maxItems = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(newSchema, 'maxItems', -1);
                if (newSchemaType === 'object') newFormData = data.reduce((newValue, aValue)=>{
                    const itemValue = $c112c26a1f6cb57a$export$2e2bcd8739ae039(validator, rootSchema, newSchemaItems, oldSchemaItems, aValue, experimental_customMergeAllOf);
                    if (itemValue !== undefined && (maxItems < 0 || newValue.length < maxItems)) newValue.push(itemValue);
                    return newValue;
                }, []);
                else {
                    // Filter out items that are no longer valid in the new items schema (e.g., enum values that changed)
                    const newItemEnumValues = $c112c26a1f6cb57a$var$enumValuesForSchema(newSchemaItems);
                    const filteredData = newItemEnumValues ? data.filter((item)=>newItemEnumValues.some((v)=>(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(v, item))) : data;
                    newFormData = maxItems > 0 && filteredData.length > maxItems ? filteredData.slice(0, maxItems) : filteredData;
                }
            }
        } else if (typeof oldSchemaItems === 'boolean' && typeof newSchemaItems === 'boolean' && oldSchemaItems === newSchemaItems) // If they are both booleans and have the same value just return the data as is otherwise fall-thru to undefined
        newFormData = data;
    // Also probably want to deal with `prefixItems` as tuples with the latest 2020 draft
    }
    return newFormData;
}


// oxlint-disable typescript/no-deprecated








/** An internal helper that generates an `PathSchema` object for the `schema`, recursively with protection against
 * infinite recursion
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be used when necessary
 * @param schema - The schema for which the `PathSchema` is desired
 * @param [name=''] - The base name for the schema
 * @param [rootSchema] - The root schema, used to primarily to look up `$ref`s
 * @param [formData] - The current formData, if any, to assist retrieving a schema
 * @param [_recurseList=[]] - The list of retrieved schemas currently being recursed, used to prevent infinite recursion
 * @param [experimental_customMergeAllOf] - Optional function that allows for custom merging of `allOf` schemas
 * @returns - The `PathSchema` object for the `schema`
 */ function $eac4e8b89251be3d$var$toPathSchemaInternal(validator, schema, name, rootSchema, formData, _recurseList = [], experimental_customMergeAllOf) {
    if ((0, $cd207018ee28cb28$export$cf02ae06bf291db4) in schema || (0, $cd207018ee28cb28$export$f2daf7b7d8cced48) in schema || (0, $cd207018ee28cb28$export$d2b65f1d256ab906) in schema || (0, $cd207018ee28cb28$export$fa01b0fcf30c8319) in schema) {
        const innerSchema = (0, $9f63129bef70072a$export$2e2bcd8739ae039)(validator, schema, rootSchema, formData, experimental_customMergeAllOf);
        const sameSchemaIndex = _recurseList.findIndex((item)=>(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(item, innerSchema));
        if (sameSchemaIndex === -1) return $eac4e8b89251be3d$var$toPathSchemaInternal(validator, innerSchema, name, rootSchema, formData, _recurseList.concat(innerSchema), experimental_customMergeAllOf);
    }
    let pathSchema = {
        [(0, $cd207018ee28cb28$export$299579ccbdd63cbc)]: name.replace(/^\./, '')
    };
    if ((0, $cd207018ee28cb28$export$c24c2c38af9a39c3) in schema || (0, $cd207018ee28cb28$export$2014f14bbe7357bd) in schema) {
        const xxxOf = (0, $cd207018ee28cb28$export$c24c2c38af9a39c3) in schema ? schema.oneOf : schema.anyOf;
        const discriminator = (0, $9b9eddfbb66bfc4e$export$2e2bcd8739ae039)(schema);
        const index = (0, $3dd4655d2b27ee9e$export$2e2bcd8739ae039)(validator, rootSchema, formData, xxxOf, 0, discriminator, experimental_customMergeAllOf);
        const innerSchema = xxxOf[index];
        pathSchema = {
            ...pathSchema,
            ...$eac4e8b89251be3d$var$toPathSchemaInternal(validator, innerSchema, name, rootSchema, formData, _recurseList, experimental_customMergeAllOf)
        };
    }
    if ((0, $cd207018ee28cb28$export$42410ea1a2a130d1) in schema && schema[0, $cd207018ee28cb28$export$42410ea1a2a130d1] !== false) {
        (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(pathSchema, (0, $cd207018ee28cb28$export$379f2e8c0717b331), true);
        const additionalSchema = (0, $d252d56fd76f41df$export$2e2bcd8739ae039)(schema[0, $cd207018ee28cb28$export$42410ea1a2a130d1]) ? schema[0, $cd207018ee28cb28$export$42410ea1a2a130d1] : {};
        const definedProperties = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$dd550d4e98f939a4), {});
        for (const key of Object.keys(formData !== null && formData !== void 0 ? formData : {}))if (!(key in definedProperties)) pathSchema[key] = $eac4e8b89251be3d$var$toPathSchemaInternal(validator, additionalSchema, `${name}.${key}`, rootSchema, (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, [
            key
        ]), _recurseList, experimental_customMergeAllOf);
    }
    if ((0, $cd207018ee28cb28$export$7a3255c70c8752d5) in schema && Array.isArray(formData)) {
        const { items: schemaItems, additionalItems: schemaAdditionalItems } = schema;
        if (Array.isArray(schemaItems)) formData.forEach((element, i)=>{
            if (schemaItems[i]) pathSchema[i] = $eac4e8b89251be3d$var$toPathSchemaInternal(validator, schemaItems[i], `${name}.${i}`, rootSchema, element, _recurseList, experimental_customMergeAllOf);
            else if (schemaAdditionalItems) pathSchema[i] = $eac4e8b89251be3d$var$toPathSchemaInternal(validator, schemaAdditionalItems, `${name}.${i}`, rootSchema, element, _recurseList, experimental_customMergeAllOf);
            else // oxlint-disable-next-line no-console
            console.warn(`Unable to generate path schema for "${name}.${i}". No schema defined for it`);
        });
        else formData.forEach((element, i)=>{
            pathSchema[i] = $eac4e8b89251be3d$var$toPathSchemaInternal(validator, schemaItems, `${name}.${i}`, rootSchema, element, _recurseList, experimental_customMergeAllOf);
        });
    } else if ((0, $cd207018ee28cb28$export$dd550d4e98f939a4) in schema) // This is a deprecated function that is no longer used by RJSF
    // oxlint-disable-next-line guard-for-in
    for(const property in schema.properties){
        const field = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(schema, [
            (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
            property
        ], {});
        pathSchema[property] = $eac4e8b89251be3d$var$toPathSchemaInternal(validator, field, `${name}.${property}`, rootSchema, // It's possible that formData is not an object -- this can happen if an
        // array item has just been added, but not populated with data yet
        (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, [
            property
        ]), _recurseList, experimental_customMergeAllOf);
    }
    return pathSchema;
}
function $eac4e8b89251be3d$export$2e2bcd8739ae039(validator, schema, name = '', rootSchema, formData, experimental_customMergeAllOf) {
    return $eac4e8b89251be3d$var$toPathSchemaInternal(validator, schema, name, rootSchema, formData, undefined, experimental_customMergeAllOf);
}




/** The `SchemaUtils` class provides a wrapper around the publicly exported APIs in the `utils/schema` directory such
 * that one does not have to explicitly pass the `validator`, `rootSchema`, `experimental_defaultFormStateBehavior` or
 * `experimental_customMergeAllOf` to each method. Since these generally do not change across a `Form`, this allows for
 * providing a simplified set of APIs to the `@rjsf/core` components and the various themes as well. This class
 * implements the `SchemaUtilsType` interface.
 */ class $d42360923ae67b3f$var$SchemaUtils {
    /** Constructs the `SchemaUtils` instance with the given `validator` and `rootSchema` stored as instance variables
     *
     * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
     * @param rootSchema - The root schema that will be forwarded to all the APIs
     * @param experimental_defaultFormStateBehavior - Configuration flags to allow users to override default form state behavior
     * @param [experimental_customMergeAllOf] - Optional function that allows for custom merging of `allOf` schemas
     */ constructor(validator, rootSchema, experimental_defaultFormStateBehavior, experimental_customMergeAllOf){
        if (rootSchema && rootSchema[0, $cd207018ee28cb28$export$8a468b2f7e566028] === (0, $cd207018ee28cb28$export$aea1c08d06ae9175)) this.rootSchema = (0, $9bd5acf65f690f1a$export$20de22aec449cb91)(rootSchema, (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(rootSchema, (0, $cd207018ee28cb28$export$f453fd324e92d331), '#'));
        else this.rootSchema = rootSchema;
        this.validator = validator;
        this.experimental_defaultFormStateBehavior = experimental_defaultFormStateBehavior;
        this.experimental_customMergeAllOf = experimental_customMergeAllOf;
    }
    /** Returns the `rootSchema` in the `SchemaUtilsType`
     *
     * @returns - The `rootSchema`
     */ getRootSchema() {
        return this.rootSchema;
    }
    /** Returns the `ValidatorType` in the `SchemaUtilsType`
     *
     * @returns - The `ValidatorType`
     */ getValidator() {
        return this.validator;
    }
    /** Determines whether either the `validator` and `rootSchema` differ from the ones associated with this instance of
     * the `SchemaUtilsType`. If either `validator` or `rootSchema` are falsy, then return false to prevent the creation
     * of a new `SchemaUtilsType` with incomplete properties.
     *
     * @param validator - An implementation of the `ValidatorType` interface that will be compared against the current one
     * @param rootSchema - The root schema that will be compared against the current one
     * @param [experimental_defaultFormStateBehavior] Optional configuration object, if provided, allows users to override default form state behavior
     * @param [experimental_customMergeAllOf] - Optional function that allows for custom merging of `allOf` schemas
     * @returns - True if the `SchemaUtilsType` differs from the given `validator` or `rootSchema`
     */ doesSchemaUtilsDiffer(validator, rootSchema, experimental_defaultFormStateBehavior = {}, experimental_customMergeAllOf) {
        // If either validator or rootSchema are falsy, return false to prevent the creation
        // of a new SchemaUtilsType with incomplete properties.
        if (!validator || !rootSchema) return false;
        return this.validator !== validator || !(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(this.rootSchema, rootSchema) || !(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(this.experimental_defaultFormStateBehavior, experimental_defaultFormStateBehavior) || this.experimental_customMergeAllOf !== experimental_customMergeAllOf;
    }
    /** Finds the field specified by the `path` within the root or recursed `schema`. If there is no field for the specified
     * `path`, then the default `{ field: undefined, isRequired: undefined }` is returned. It determines whether a leaf
     * field is in the `required` list for its parent and if so, it is marked as required on return.
     *
     * @param schema - The current node within the JSON schema
     * @param path - The remaining keys in the path to the desired field
     * @param [formData] - The form data that is used to determine which oneOf option
     * @returns - An object that contains the field and its required state. If no field can be found then
     *            `{ field: undefined, isRequired: undefined }` is returned.
     */ findFieldInSchema(schema, path, formData) {
        return (0, $80874c46ebba76fb$export$2e2bcd8739ae039)(this.validator, this.rootSchema, schema, path, formData, this.experimental_customMergeAllOf);
    }
    /** Finds the oneOf option inside the `schema['any/oneOf']` list which has the `properties[selectorField].default` that
     * matches the `formData[selectorField]` value. For the purposes of this function, `selectorField` is either
     * `schema.discriminator.propertyName` or `fallbackField`.
     *
     * @param schema - The schema element in which to search for the selected oneOf option
     * @param fallbackField - The field to use as a backup selector field if the schema does not have a required field
     * @param xxx - Either `oneOf` or `anyOf`, defines which value is being sought
     * @param [formData={}] - The form data that is used to determine which oneOf option
     * @returns - The anyOf/oneOf option that matches the selector field in the schema or undefined if nothing is selected
     */ findSelectedOptionInXxxOf(schema, fallbackField, xxx, formData) {
        return (0, $fd1332486306522a$export$2e2bcd8739ae039)(this.validator, this.rootSchema, schema, fallbackField, xxx, formData, this.experimental_customMergeAllOf);
    }
    /** Returns the superset of `formData` that includes the given set updated to include any missing fields that have
     * computed to have defaults provided in the `schema`.
     *
     * @param schema - The schema for which the default state is desired
     * @param [formData] - The current formData, if any, onto which to provide any missing defaults
     * @param [includeUndefinedValues=false] - Optional flag, if true, cause undefined values to be added as defaults.
     *          If "excludeObjectChildren", pass `includeUndefinedValues` as false when computing defaults for any nested
     *          object properties.
     * @param initialDefaultsGenerated - Indicates whether or not initial defaults have been generated
     * @returns - The resulting `formData` with all the defaults provided
     */ getDefaultFormState(schema, formData, includeUndefinedValues = false, initialDefaultsGenerated) {
        return (0, $cd95df1262c32dce$export$2e2bcd8739ae039)(this.validator, schema, formData, this.rootSchema, includeUndefinedValues, this.experimental_defaultFormStateBehavior, this.experimental_customMergeAllOf, initialDefaultsGenerated);
    }
    /** Determines whether the combination of `schema` and `uiSchema` properties indicates that the label for the `schema`
     * should be displayed in a UI.
     *
     * @param schema - The schema for which the display label flag is desired
     * @param [uiSchema] - The UI schema from which to derive potentially displayable information
     * @param [globalOptions={}] - The optional Global UI Schema from which to get any fallback `xxx` options
     * @returns - True if the label should be displayed or false if it should not
     */ getDisplayLabel(schema, uiSchema, globalOptions) {
        return (0, $3b3b81219ed47025$export$2e2bcd8739ae039)(this.validator, schema, uiSchema, this.rootSchema, globalOptions, this.experimental_customMergeAllOf);
    }
    /** Determines which of the given `options` provided most closely matches the `formData`.
     * Returns the index of the option that is valid and is the closest match, or 0 if there is no match.
     *
     * The closest match is determined using the number of matching properties, and more heavily favors options with
     * matching readOnly, default, or const values.
     *
     * @param formData - The form data associated with the schema
     * @param options - The list of options that can be selected from
     * @param [selectedOption] - The index of the currently selected option, defaulted to -1 if not specified
     * @param [discriminatorField] - The optional name of the field within the options object whose value is used to
     *          determine which option is selected
     * @returns - The index of the option that is the closest match to the `formData` or the `selectedOption` if no match
     */ getClosestMatchingOption(formData, options, selectedOption, discriminatorField) {
        return (0, $3dd4655d2b27ee9e$export$2e2bcd8739ae039)(this.validator, this.rootSchema, formData, options, selectedOption, discriminatorField, this.experimental_customMergeAllOf);
    }
    /** Given the `formData` and list of `options`, attempts to find the index of the first option that matches the data.
     * Always returns the first option if there is nothing that matches.
     *
     * @param formData - The current formData, if any, used to figure out a match
     * @param options - The list of options to find a matching options from
     * @param [discriminatorField] - The optional name of the field within the options object whose value is used to
     *          determine which option is selected
     * @returns - The firstindex of the matched option or 0 if none is available
     */ getFirstMatchingOption(formData, options, discriminatorField) {
        return (0, $e6fc247cc688da7a$export$2e2bcd8739ae039)(this.validator, formData, options, this.rootSchema, discriminatorField);
    }
    getFromSchema(schema, path, defaultValue) {
        return (0, $42243afd61ffaaea$export$2e2bcd8739ae039)(this.validator, this.rootSchema, schema, path, // @ts-expect-error TS2769: No overload matches this call
        defaultValue, this.experimental_customMergeAllOf);
    }
    /** Checks to see if the `schema` and `uiSchema` combination represents an array of files
     *
     * @param schema - The schema for which check for array of files flag is desired
     * @param [uiSchema] - The UI schema from which to check the widget
     * @returns - True if schema/uiSchema contains an array of files, otherwise false
     */ isFilesArray(schema, uiSchema) {
        return (0, $d7cb20ccb583218f$export$2e2bcd8739ae039)(this.validator, schema, uiSchema, this.rootSchema, this.experimental_customMergeAllOf);
    }
    /** Checks to see if the `schema` combination represents a multi-select
     *
     * @param schema - The schema for which check for a multi-select flag is desired
     * @returns - True if schema contains a multi-select, otherwise false
     */ isMultiSelect(schema) {
        return (0, $9e7b34d3201d4232$export$2e2bcd8739ae039)(this.validator, schema, this.rootSchema, this.experimental_customMergeAllOf);
    }
    /** Checks to see if the `schema` combination represents a select
     *
     * @param schema - The schema for which check for a select flag is desired
     * @returns - True if schema contains a select, otherwise false
     */ isSelect(schema) {
        return (0, $9d5b05a84f9ed2c6$export$2e2bcd8739ae039)(this.validator, schema, this.rootSchema, this.experimental_customMergeAllOf);
    }
    /**
     * The function takes a `schema` and `formData` and returns a copy of the formData with any fields not defined in the schema removed.
     * This is useful for ensuring that only data that is relevant to the schema is preserved. Objects with `additionalProperties`
     * keyword set to `true` will not have their extra fields removed.
     *
     * @param schema - The schema to use for filtering the `formData`
     * @param [formData] - The formData to filter
     * @returns The new form data, with any fields not defined in the schema removed
     */ omitExtraData(schema, formData) {
        return (0, $e7d329486831c49a$export$2e2bcd8739ae039)(this.validator, schema, this.rootSchema, formData);
    }
    /** Retrieves an expanded schema that has had all of its conditions, additional properties, references and
     * dependencies resolved and merged into the `schema` given a `rawFormData` that is used to do the potentially
     * recursive resolution.
     *
     * @param schema - The schema for which retrieving a schema is desired
     * @param [rawFormData] - The current formData, if any, to assist retrieving a schema
     * @param [resolveAnyOfOrOneOfRefs] - Optional flag indicating whether to resolved refs in anyOf/oneOf lists
     * @returns - The schema having its conditions, additional properties, references and dependencies resolved
     */ retrieveSchema(schema, rawFormData, resolveAnyOfOrOneOfRefs) {
        return (0, $9f63129bef70072a$export$2e2bcd8739ae039)(this.validator, schema, this.rootSchema, rawFormData, this.experimental_customMergeAllOf, resolveAnyOfOrOneOfRefs);
    }
    /** Sanitize the `data` associated with the `oldSchema` so it is considered appropriate for the `newSchema`. If the
     * new schema does not contain any properties, then `undefined` is returned to clear all the form data. Due to the
     * nature of schemas, this sanitization happens recursively for nested objects of data. Also, any properties in the
     * old schemas that are non-existent in the new schema are set to `undefined`.
     *
     * @param [newSchema] - The new schema for which the data is being sanitized
     * @param [oldSchema] - The old schema from which the data originated
     * @param [data={}] - The form data associated with the schema, defaulting to an empty object when undefined
     * @returns - The new form data, with all the fields uniquely associated with the old schema set
     *      to `undefined`. Will return `undefined` if the new schema is not an object containing properties.
     */ sanitizeDataForNewSchema(newSchema, oldSchema, data) {
        return (0, $c112c26a1f6cb57a$export$2e2bcd8739ae039)(this.validator, this.rootSchema, newSchema, oldSchema, data, this.experimental_customMergeAllOf);
    }
    /** Generates an `PathSchema` object for the `schema`, recursively
     *
     * @param schema - The schema for which the display label flag is desired
     * @param [name] - The base name for the schema
     * @param [formData] - The current formData, if any, onto which to provide any missing defaults
     * @returns - The `PathSchema` object for the `schema`
     */ // oxlint-disable-next-line typescript/no-deprecated
    toPathSchema(schema, name, formData) {
        // oxlint-disable-next-line typescript/no-deprecated
        return (0, $eac4e8b89251be3d$export$2e2bcd8739ae039)(this.validator, schema, name, this.rootSchema, formData, this.experimental_customMergeAllOf);
    }
}
function $d42360923ae67b3f$export$2e2bcd8739ae039(validator, rootSchema, experimental_defaultFormStateBehavior = {}, experimental_customMergeAllOf) {
    return new $d42360923ae67b3f$var$SchemaUtils(validator, rootSchema, experimental_defaultFormStateBehavior, experimental_customMergeAllOf);
}


/** Given the `FileReader.readAsDataURL()` based `dataURI` extracts that data into an actual Blob along with the name
 * of that Blob if provided in the URL. If no name is provided, then the name falls back to `unknown`.
 *
 * @param dataURI - The `DataUrl` potentially containing name and raw data to be converted to a Blob
 * @returns - an object containing a Blob and its name, extracted from the URI
 */ function $1dbd19e0a8f019c3$export$2e2bcd8739ae039(dataURILike) {
    var _a;
    // check if is dataURI
    if (!dataURILike.includes('data:')) throw new Error('File is invalid: URI must be a dataURI');
    const dataURI = dataURILike.slice(5);
    // split the dataURI into media and base64, with the base64 signature
    const splitted = dataURI.split(';base64,');
    // if the base64 signature is not present, the latter part will become empty
    if (splitted.length !== 2) throw new Error('File is invalid: dataURI must be base64');
    // extract the mime type, media parameters including the name, and the base64 string
    const [media, base64] = splitted;
    const [mime, ...mediaparams] = media.split(';');
    const type = mime || '';
    // extract the name from the parameters
    const name = decodeURI(// parse the parameters into key-value pairs, find a key, and extract a value
    // if no key is found, then the name is unknown
    ((_a = mediaparams.map((param)=>param.split('=')).find(([key])=>key === 'name')) === null || _a === void 0 ? void 0 : _a[1]) || 'unknown');
    // Built the Uint8Array Blob parameter from the base64 string.
    try {
        const binary = atob(base64);
        const array = new Array(binary.length);
        for(let i = 0; i < binary.length; i += 1)array[i] = binary.charCodeAt(i);
        // Create the blob object
        const blob = new window.Blob([
            new Uint8Array(array)
        ], {
            type: type
        });
        return {
            blob: blob,
            name: name
        };
    } catch (error) {
        throw new Error(`File is invalid: ${error.message}`);
    }
}


/** Returns a string representation of the `num` that is padded with leading "0"s if necessary
 *
 * @param num - The number to pad
 * @param width - The width of the string at which no lead padding is necessary
 * @returns - The number converted to a string with leading zero padding if the number of digits is less than `width`
 */ function $5a5e14ed9eaadffb$export$2e2bcd8739ae039(num, width) {
    let s = String(num);
    while(s.length < width)s = `0${s}`;
    return s;
}


function $725778898db16795$export$2e2bcd8739ae039(start, stop) {
    const bothRelative = start <= 0 && stop <= 0;
    const eitherNegative = start < 0 || stop < 0;
    if (!bothRelative && eitherNegative) throw new Error(`Both start (${start}) and stop (${stop}) must both be <= 0 or > 0, got one of each`);
    const currentYear = new Date().getFullYear();
    const resolvedStart = bothRelative ? currentYear + start : start;
    const resolvedStop = bothRelative ? currentYear + stop : stop;
    if (resolvedStart > resolvedStop) return $725778898db16795$export$2e2bcd8739ae039(stop, start).reverse();
    const options = [];
    for(let i = resolvedStart; i <= resolvedStop; i += 1)options.push({
        value: i,
        label: (0, $5a5e14ed9eaadffb$export$2e2bcd8739ae039)(i, 2)
    });
    return options;
}



/** Potentially substitutes all replaceable parameters with the associated value(s) from the `params` if available. When
 * a `params` array is provided, each value in the array is used to replace any of the replaceable parameters in the
 * `inputString` using the `%1`, `%2`, etc. replacement specifiers.
 *
 * @param inputString - The string which will be potentially updated with replacement parameters
 * @param params - The optional list of replaceable parameter values to substitute into the english string
 * @returns - The updated string with any replacement specifiers replaced
 */ function $493596decd7d3e91$export$2e2bcd8739ae039(inputString, params) {
    let output = inputString;
    if (Array.isArray(params)) {
        const parts = output.split(/(%\d)/);
        params.forEach((param, index)=>{
            const partIndex = parts.findIndex((part)=>part === `%${index + 1}`);
            if (partIndex >= 0) parts[partIndex] = param;
        });
        output = parts.join('');
    }
    return output;
}


function $29d931a0330c7ad7$export$2e2bcd8739ae039(stringToTranslate, params) {
    return (0, $493596decd7d3e91$export$2e2bcd8739ae039)(stringToTranslate, params);
}



/** Returns the value(s) from `allEnumOptions` at the index(es) provided by `valueIndex`. If `valueIndex` is not an
 * array AND the index is not valid for `allEnumOptions`, `emptyValue` is returned. If `valueIndex` is an array, AND it
 * contains an invalid index, the returned array will have the resulting undefined values filtered out, leaving only
 * valid values or in the worst case, an empty array.
 *
 * @param valueIndex - The index(es) of the value(s) that should be returned
 * @param [allEnumOptions=[]] - The list of all the known enumOptions
 * @param [emptyValue] - The value to return when the non-array `valueIndex` does not refer to a real option
 * @returns - The single or list of values specified by the single or list of indexes if they are valid. Otherwise,
 *        `emptyValue` or an empty list.
 */ function $405f4573bdf8d0cc$export$2e2bcd8739ae039(valueIndex, allEnumOptions = [], emptyValue) {
    if (Array.isArray(valueIndex)) return valueIndex.map((index)=>$405f4573bdf8d0cc$export$2e2bcd8739ae039(index, allEnumOptions))// The recursive call returns undefined for a bad option, filter those out
    .filter((val)=>val !== undefined);
    // So Number(null) and Number('') both return 0, so use emptyValue for those two values
    const index = valueIndex === '' || valueIndex === null ? -1 : Number(valueIndex);
    const option = allEnumOptions[index];
    return option ? option.value : emptyValue;
}


function $cd5aeb8c020db4af$export$2e2bcd8739ae039(valueIndex, selected, allEnumOptions = []) {
    const value = (0, $405f4573bdf8d0cc$export$2e2bcd8739ae039)(valueIndex, allEnumOptions);
    if (Array.isArray(selected)) return selected.filter((v)=>!(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(v, value));
    return (0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(value, selected) ? undefined : selected;
}



function $7f18f5e02c7e23b3$export$2e2bcd8739ae039(value, selected) {
    if (Array.isArray(selected)) return selected.some((sel)=>(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(sel, value));
    return (0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(selected, value);
}


function $5fc91394b8c8d757$export$2e2bcd8739ae039(value, allEnumOptions = [], multiple = false) {
    const selectedIndexes = allEnumOptions.map((opt, index)=>(0, $7f18f5e02c7e23b3$export$2e2bcd8739ae039)(opt.value, value) ? String(index) : undefined).filter((opt)=>typeof opt !== 'undefined');
    if (!multiple) return selectedIndexes[0];
    return selectedIndexes;
}


function $d9eabbfa9629bc80$export$2e2bcd8739ae039(value, enumOptions, multiple, format = 'indexed', emptyValue) {
    const isEmpty = typeof value === 'undefined' || multiple && Array.isArray(value) && value.length < 1 || !multiple && value === emptyValue;
    if (isEmpty) return emptyValue;
    if (format === 'realValue') return multiple ? value.map(String) : String(value);
    const indexes = (0, $5fc91394b8c8d757$export$2e2bcd8739ae039)(value, enumOptions, multiple);
    return typeof indexes === 'undefined' ? emptyValue : indexes;
}






function $4d503b5a876c5ffd$export$2e2bcd8739ae039(valueIndex, selected, allEnumOptions = []) {
    const value = (0, $405f4573bdf8d0cc$export$2e2bcd8739ae039)(valueIndex, allEnumOptions);
    if (!(0, $1f65e0187a0081bc$export$2e2bcd8739ae039)(value)) {
        const index = allEnumOptions.findIndex((opt)=>value === opt.value);
        const all = allEnumOptions.map(({ value: val })=>val);
        const updated = selected.slice(0, index).concat(value, selected.slice(index));
        // As inserting values at predefined index positions doesn't work with empty
        // arrays, we need to reorder the updated selection to match the initial order
        return updated.sort((a, b)=>Number(all.indexOf(a) > all.indexOf(b)));
    }
    return selected;
}




/** Resolves a single DOM value string back to its typed enum value in `'realValue'` mode.
 *
 * First attempts a reverse lookup by matching `String(opt.value)` against the input.
 * If no option matches and the input parses as a valid index, falls back to the
 * option at that index — this is how object/array enum values round-trip, since
 * they are encoded as indices by the encoder.
 *
 * @param value - A single string value from a DOM attribute
 * @param enumOptions - The available enum options
 * @param emptyValue - The value to return when the input is empty, options are missing, or no match is found
 * @returns The original typed enum value, or `emptyValue`
 */ function $d751b2609dc272ff$var$decodeSingle(value, enumOptions, emptyValue) {
    if (value === '' || !Array.isArray(enumOptions)) return emptyValue;
    const match = enumOptions.find((opt)=>String(opt.value) === value);
    if (match) return match.value;
    // Fallback: value might be an index (for object/array enum values)
    const index = Number(value);
    if (!Number.isNaN(index) && index >= 0 && index < enumOptions.length) return enumOptions[index].value;
    return emptyValue;
}
function $d751b2609dc272ff$export$2e2bcd8739ae039(value, enumOptions, format = 'indexed', emptyValue) {
    if (format !== 'realValue') return (0, $405f4573bdf8d0cc$export$2e2bcd8739ae039)(value, enumOptions, emptyValue);
    if (Array.isArray(value)) return value.map((v)=>$d751b2609dc272ff$var$decodeSingle(v, enumOptions, emptyValue));
    return $d751b2609dc272ff$var$decodeSingle(value, enumOptions, emptyValue);
}



function $36f1d7e65b39cdba$export$2e2bcd8739ae039(value, index, format = 'indexed') {
    if (format !== 'realValue') return String(index);
    if ((0, $1f65e0187a0081bc$export$2e2bcd8739ae039)(value)) return '';
    if (typeof value === 'object') return String(index);
    return String(value);
}



/** Used to compose bitmasks for cloning. */ var $7e874283d83390fb$var$CLONE_DEEP_FLAG = 1, $7e874283d83390fb$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $7e874283d83390fb$var$cloneDeep(value) {
    return (0, $dcdfe05415212eb9$export$2e2bcd8739ae039)(value, $7e874283d83390fb$var$CLONE_DEEP_FLAG | $7e874283d83390fb$var$CLONE_SYMBOLS_FLAG);
}
var $7e874283d83390fb$export$2e2bcd8739ae039 = $7e874283d83390fb$var$cloneDeep;





/**
 * This method is like `_.set` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.setWith(object, '[0][1]', 'a', Object);
 * // => { '0': { '1': 'a' } }
 */ function $c5cd72d8bf206c15$var$setWith(object, path, value, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return object == null ? object : (0, $07920a1e18250d4e$export$2e2bcd8739ae039)(object, path, value, customizer);
}
var $c5cd72d8bf206c15$export$2e2bcd8739ae039 = $c5cd72d8bf206c15$var$setWith;



class $ca490662d9a1e5b4$export$2e2bcd8739ae039 {
    /** Construct an `ErrorSchemaBuilder` with an optional initial set of errors in an `ErrorSchema`.
     *
     * @param [initialSchema] - The optional set of initial errors, that will be cloned into the class
     */ constructor(initialSchema){
        /** The error schema being built
         *
         * @private
         */ this.errorSchema = {};
        this.resetAllErrors(initialSchema);
    }
    /** Returns the `ErrorSchema` that has been updated by the methods of the `ErrorSchemaBuilder`
     */ get ErrorSchema() {
        return this.errorSchema;
    }
    /** Will get an existing `ErrorSchema` at the specified `pathOfError` or create and return one.
     *
     * @param [pathOfError] - The optional path into the `ErrorSchema` at which to add the error(s)
     * @returns - The error block for the given `pathOfError` or the root if not provided
     * @private
     */ getOrCreateErrorBlock(pathOfError) {
        const hasPath = Array.isArray(pathOfError) && pathOfError.length > 0 || typeof pathOfError === 'string';
        // @ts-expect-error TS2590 to avoid "Expression produces a union type that is too complex to represent" error
        let errorBlock = hasPath ? (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(this.errorSchema, pathOfError) : this.errorSchema;
        if (!errorBlock && pathOfError) {
            errorBlock = {};
            (0, $c5cd72d8bf206c15$export$2e2bcd8739ae039)(this.errorSchema, pathOfError, errorBlock, Object);
        }
        return errorBlock;
    }
    /** Resets all errors in the `ErrorSchemaBuilder` back to the `initialSchema` if provided, otherwise an empty set.
     *
     * @param [initialSchema] - The optional set of initial errors, that will be cloned into the class
     * @returns - The `ErrorSchemaBuilder` object for chaining purposes
     */ resetAllErrors(initialSchema) {
        this.errorSchema = initialSchema ? (0, $7e874283d83390fb$export$2e2bcd8739ae039)(initialSchema) : {};
        return this;
    }
    /** Adds the `errorOrList` to the list of errors in the `ErrorSchema` at either the root level or the location within
     * the schema described by the `pathOfError`. For more information about how to specify the path see the
     * [eslint lodash plugin docs](https://github.com/wix/eslint-plugin-lodash/blob/master/docs/rules/path-style.md).
     *
     * @param errorOrList - The error or list of errors to add into the `ErrorSchema`
     * @param [pathOfError] - The optional path into the `ErrorSchema` at which to add the error(s)
     * @returns - The `ErrorSchemaBuilder` object for chaining purposes
     */ addErrors(errorOrList, pathOfError) {
        const errorBlock = this.getOrCreateErrorBlock(pathOfError);
        let errorsList = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(errorBlock, (0, $cd207018ee28cb28$export$36fec1b8ab257149));
        if (!Array.isArray(errorsList)) {
            errorsList = [];
            errorBlock[0, $cd207018ee28cb28$export$36fec1b8ab257149] = errorsList;
        }
        if (Array.isArray(errorOrList)) (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(errorBlock, (0, $cd207018ee28cb28$export$36fec1b8ab257149), [
            ...new Set([
                ...errorsList,
                ...errorOrList
            ])
        ]);
        else (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(errorBlock, (0, $cd207018ee28cb28$export$36fec1b8ab257149), [
            ...new Set([
                ...errorsList,
                errorOrList
            ])
        ]);
        return this;
    }
    /** Sets/replaces the `errorOrList` as the error(s) in the `ErrorSchema` at either the root level or the location
     * within the schema described by the `pathOfError`. For more information about how to specify the path see the
     * [eslint lodash plugin docs](https://github.com/wix/eslint-plugin-lodash/blob/master/docs/rules/path-style.md).
     *
     * @param errorOrList - The error or list of errors to set into the `ErrorSchema`
     * @param [pathOfError] - The optional path into the `ErrorSchema` at which to set the error(s)
     * @returns - The `ErrorSchemaBuilder` object for chaining purposes
     */ setErrors(errorOrList, pathOfError) {
        const errorBlock = this.getOrCreateErrorBlock(pathOfError);
        // Effectively clone the array being given to prevent accidental outside manipulation of the given list
        const listToAdd = Array.isArray(errorOrList) ? [
            ...new Set([
                ...errorOrList
            ])
        ] : [
            errorOrList
        ];
        (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(errorBlock, (0, $cd207018ee28cb28$export$36fec1b8ab257149), listToAdd);
        return this;
    }
    /** Clears the error(s) in the `ErrorSchema` at either the root level or the location within the schema described by
     * the `pathOfError`. For more information about how to specify the path see the
     * [eslint lodash plugin docs](https://github.com/wix/eslint-plugin-lodash/blob/master/docs/rules/path-style.md).
     *
     * @param [pathOfError] - The optional path into the `ErrorSchema` at which to clear the error(s)
     * @returns - The `ErrorSchemaBuilder` object for chaining purposes
     */ clearErrors(pathOfError) {
        const errorBlock = this.getOrCreateErrorBlock(pathOfError);
        (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(errorBlock, (0, $cd207018ee28cb28$export$36fec1b8ab257149), []);
        return this;
    }
}









/** Used as the size to enable large array optimizations. */ var $2601b0a302f08d6f$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $2601b0a302f08d6f$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = (0, $5c89fabc27f935b9$export$2e2bcd8739ae039), isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = (0, $a8b30b77f2b6a1c4$export$2e2bcd8739ae039)(values, (0, $b5e34b5af2871f86$export$2e2bcd8739ae039)(iteratee));
    if (comparator) {
        includes = (0, $2f5198bd8bb7a519$export$2e2bcd8739ae039);
        isCommon = false;
    } else if (values.length >= $2601b0a302f08d6f$var$LARGE_ARRAY_SIZE) {
        includes = (0, $f4852737a03c39ca$export$2e2bcd8739ae039);
        isCommon = false;
        values = new (0, $ab54149517cb0b02$export$2e2bcd8739ae039)(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
var $2601b0a302f08d6f$export$2e2bcd8739ae039 = $2601b0a302f08d6f$var$baseDifference;





/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $630828b5764d16f9$var$difference = (0, $d3bee9049ca44be7$export$2e2bcd8739ae039)(function(array, values) {
    return (0, $1d95c744ae2c26f0$export$2e2bcd8739ae039)(array) ? (0, $2601b0a302f08d6f$export$2e2bcd8739ae039)(array, (0, $b2ff9fbe68cb378d$export$2e2bcd8739ae039)(values, 1, (0, $1d95c744ae2c26f0$export$2e2bcd8739ae039), true)) : [];
});
var $630828b5764d16f9$export$2e2bcd8739ae039 = $630828b5764d16f9$var$difference;









/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $a062099140fb6d87$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = (0, $a8b30b77f2b6a1c4$export$2e2bcd8739ae039)((0, $cb4411947b1bbccd$export$2e2bcd8739ae039)(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = (0, $bf4c4ea4610241c9$export$2e2bcd8739ae039)(predicate);
    return (0, $a3a758bec8a223c0$export$2e2bcd8739ae039)(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
var $a062099140fb6d87$export$2e2bcd8739ae039 = $a062099140fb6d87$var$pickBy;



function $da84398189b91d7b$export$2e2bcd8739ae039(a, b) {
    const aIsPlainObject = (0, $d6bfaab5809eb5e3$export$2e2bcd8739ae039)(a);
    const bIsPlainObject = (0, $d6bfaab5809eb5e3$export$2e2bcd8739ae039)(b);
    // If strictly equal or neither of them is a plainObject returns an empty array
    if (a === b || !aIsPlainObject && !bIsPlainObject) return [];
    if (aIsPlainObject && !bIsPlainObject) return (0, $39f39242faed4588$export$2e2bcd8739ae039)(a);
    if (!aIsPlainObject && bIsPlainObject) return (0, $39f39242faed4588$export$2e2bcd8739ae039)(b);
    const unequalFields = (0, $39f39242faed4588$export$2e2bcd8739ae039)((0, $a062099140fb6d87$export$2e2bcd8739ae039)(a, (value, key)=>!(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(value, (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(b, key))));
    const diffFields = (0, $630828b5764d16f9$export$2e2bcd8739ae039)((0, $39f39242faed4588$export$2e2bcd8739ae039)(b), (0, $39f39242faed4588$export$2e2bcd8739ae039)(a));
    return [
        ...unequalFields,
        ...diffFields
    ];
}


/** Given date & time information with optional yearRange & format, returns props for DateElement
 *
 * @param date - Object containing date with optional time information
 * @param time - Determines whether to include time or not
 * @param [yearRange=[1900, new Date().getFullYear() + 2]] - Controls the list of years to be displayed
 * @param [format='YMD'] - Controls the order in which day, month and year input element will be displayed
 * @returns Array of props for DateElement
 */ function $65151b6a7a69c4b2$export$2e2bcd8739ae039(date, time, yearRange = [
    1900,
    new Date().getFullYear() + 2
], format = 'YMD') {
    const { day: day, month: month, year: year, hour: hour, minute: minute, second: second } = date;
    const dayObj = {
        type: 'day',
        range: [
            1,
            31
        ],
        value: day
    };
    const monthObj = {
        type: 'month',
        range: [
            1,
            12
        ],
        value: month
    };
    const yearObj = {
        type: 'year',
        range: yearRange,
        value: year
    };
    const dateElementProp = [];
    switch(format){
        case 'MDY':
            dateElementProp.push(monthObj, dayObj, yearObj);
            break;
        case 'DMY':
            dateElementProp.push(dayObj, monthObj, yearObj);
            break;
        case 'YMD':
        default:
            dateElementProp.push(yearObj, monthObj, dayObj);
    }
    if (time) dateElementProp.push({
        type: 'hour',
        range: [
            0,
            23
        ],
        value: hour
    }, {
        type: 'minute',
        range: [
            0,
            59
        ],
        value: minute
    }, {
        type: 'second',
        range: [
            0,
            59
        ],
        value: second
    });
    return dateElementProp;
}



/** Extracts the range spec information `{ step?: number, min?: number, max?: number }` that can be spread onto an HTML
 * input from the range analog in the schema `{ multipleOf?: number, minimum?: number, maximum?: number }`.
 *
 * @param schema - The schema from which to extract the range spec
 * @returns - A range specification from the schema
 */ function $6a10f4d5ab83ec2e$export$2e2bcd8739ae039(schema) {
    const spec = {};
    if (schema.multipleOf) spec.step = schema.multipleOf;
    if (schema.minimum || schema.minimum === 0) spec.min = schema.minimum;
    if (schema.maximum || schema.maximum === 0) spec.max = schema.maximum;
    return spec;
}


function $44b30900be781098$export$2e2bcd8739ae039(schema, defaultType, options = {}, autoDefaultStepAny = true) {
    const inputProps = {
        type: defaultType || 'text',
        ...(0, $6a10f4d5ab83ec2e$export$2e2bcd8739ae039)(schema)
    };
    // If options.inputType is set use that as the input type
    if (options.inputType) inputProps.type = options.inputType;
    else if (!defaultType) {
        // If the schema is of type number or integer, set the input type to number
        if (schema.type === 'number') {
            inputProps.type = 'number';
            // Only add step if one isn't already defined and we are auto-defaulting the "any" step
            if (autoDefaultStepAny && inputProps.step === undefined) // Setting step to 'any' fixes a bug in Safari where decimals are not
            // allowed in number inputs
            inputProps.step = 'any';
        } else if (schema.type === 'integer') {
            inputProps.type = 'number';
            // Only add step if one isn't already defined
            if (inputProps.step === undefined) // Since this is integer, you always want to step up or down in multiples of 1
            inputProps.step = 1;
        }
    }
    // For date/time input types, propagate formatMinimum/formatMaximum to min/max
    if ([
        'date',
        'datetime-local',
        'time',
        'week',
        'month'
    ].includes(inputProps.type)) {
        if (schema.formatMinimum !== undefined) inputProps.min = schema.formatMinimum;
        if (schema.formatMaximum !== undefined) inputProps.max = schema.formatMaximum;
    }
    if (options.autocomplete) inputProps.autoComplete = options.autocomplete;
    if (options.accept) inputProps.accept = options.accept;
    return inputProps;
}



/** Resolves the effective `optionValueFormat` for enum-backed widgets.
 *
 * Provides a single source of truth for the default DOM encoding format
 * (`'indexed'`) used by `SelectWidget`, `RadioWidget`, and `CheckboxesWidget`.
 * Widgets should call this helper once and pass the result to
 * `enumOptionValueEncoder`, `enumOptionValueDecoder`, and `enumOptionSelectedValue`
 * rather than reading `options.optionValueFormat` directly.
 *
 * @param options - The widget options (typically from the `options` prop, already
 *   resolved from `ui:options` and `ui:globalOptions`)
 * @returns The resolved `OptionValueFormat`, defaulting to `'indexed'` when not set
 */ function $b28583320c2e364e$export$2e2bcd8739ae039(options) {
    var _a;
    return (_a = options === null || options === void 0 ? void 0 : options.optionValueFormat) !== null && _a !== void 0 ? _a : 'indexed';
}





const $3733f8d10e56b15e$export$93ca5d3f8675ae4c = {
    props: {
        disabled: false
    },
    submitText: 'Submit',
    norender: false
};
function $3733f8d10e56b15e$export$2e2bcd8739ae039(uiSchema = {}) {
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    if (uiOptions && uiOptions[0, $cd207018ee28cb28$export$a590c102372d2ff1]) {
        const options = uiOptions[0, $cd207018ee28cb28$export$a590c102372d2ff1];
        return {
            ...$3733f8d10e56b15e$export$93ca5d3f8675ae4c,
            ...options
        };
    }
    return $3733f8d10e56b15e$export$93ca5d3f8675ae4c;
}


/** Returns the template with the given `name` from either the `uiSchema` if it is defined or from the `registry`
 * otherwise. NOTE, since `ButtonTemplates` are not overridden in `uiSchema` only those in the `registry` are returned.
 *
 * @param name - The name of the template to fetch, restricted to the keys of `TemplatesType`
 * @param registry - The `Registry` from which to read the template
 * @param [uiOptions={}] - The `UIOptionsType` from which to read an alternate template
 * @returns - The template from either the `uiSchema` or `registry` for the `name`
 */ function $f037e3283241319d$export$2e2bcd8739ae039(name, registry, uiOptions = {}) {
    const { templates: templates } = registry;
    if (name === 'ButtonTemplates') return templates[name];
    // Allow templates to be customized per-field by using string keys from the registry
    if (Object.hasOwn(uiOptions, name) && typeof uiOptions[name] === 'string' && Object.hasOwn(templates, uiOptions[name])) {
        const key = uiOptions[name];
        // Evaluating templates[key] results in TS2590: Expression produces a union type that is too complex to represent
        // To avoid that, we cast templates to `any` before accessing the key field
        return templates[key];
    }
    return(// Evaluating uiOptions[name] results in TS2590: Expression produces a union type that is too complex to represent
    // To avoid that, we cast uiOptions to `any` before accessing the name field
    uiOptions[name] || templates[name]);
}




/** Used to generate unique IDs. */ var $c6ab635ea69d2b59$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $c6ab635ea69d2b59$var$uniqueId(prefix) {
    var id = ++$c6ab635ea69d2b59$var$idCounter;
    return (0, $26fb36591628d13f$export$2e2bcd8739ae039)(prefix) + id;
}
var $c6ab635ea69d2b59$export$2e2bcd8739ae039 = $c6ab635ea69d2b59$var$uniqueId;


function $55a2cf4e1bd3cf35$export$2e2bcd8739ae039() {
    // For some reason, even though process.env contains the value of `test` for NODE_ENV, accessing it directly returns
    // 'development'. Using `get()` does, in fact, return test so sticking with it.
    // Use globalThis to access process without requiring @types/node (TS6 compatibility).
    if ((0, $547524a1010b9f1e$export$2e2bcd8739ae039)(globalThis, 'process.env.NODE_ENV') !== 'test') return {};
    const ids = new Map();
    return new Proxy({}, {
        get (_obj, prop) {
            if (!ids.has(prop)) ids.set(prop, (0, $c6ab635ea69d2b59$export$2e2bcd8739ae039)('test-id-'));
            return ids.get(prop);
        }
    });
}





var $h4Bez = parcelRequire("h4Bez");




/** The map of schema types to widget type to widget name
 */ const $73d42cea7c965d69$var$widgetMap = {
    boolean: {
        checkbox: 'CheckboxWidget',
        radio: 'RadioWidget',
        select: 'SelectWidget',
        hidden: 'HiddenWidget'
    },
    string: {
        text: 'TextWidget',
        password: 'PasswordWidget',
        email: 'EmailWidget',
        hostname: 'TextWidget',
        ipv4: 'TextWidget',
        ipv6: 'TextWidget',
        uri: 'URLWidget',
        'data-url': 'FileWidget',
        radio: 'RadioWidget',
        select: 'SelectWidget',
        textarea: 'TextareaWidget',
        hidden: 'HiddenWidget',
        date: 'DateWidget',
        datetime: 'DateTimeWidget',
        'date-time': 'DateTimeWidget',
        'alt-date': 'AltDateWidget',
        'alt-datetime': 'AltDateTimeWidget',
        time: 'TimeWidget',
        color: 'ColorWidget',
        file: 'FileWidget'
    },
    number: {
        text: 'TextWidget',
        select: 'SelectWidget',
        updown: 'UpDownWidget',
        range: 'RangeWidget',
        radio: 'RadioWidget',
        hidden: 'HiddenWidget'
    },
    integer: {
        text: 'TextWidget',
        select: 'SelectWidget',
        updown: 'UpDownWidget',
        range: 'RangeWidget',
        radio: 'RadioWidget',
        hidden: 'HiddenWidget'
    },
    array: {
        select: 'SelectWidget',
        checkboxes: 'CheckboxesWidget',
        files: 'FileWidget',
        hidden: 'HiddenWidget'
    }
};
/** Wraps the given widget with stateless functional component that will merge any `defaultProps.options` with the
 * `options` that are provided in the props. It will add the wrapper component as a `MergedWidget` property onto the
 * `Widget` so that future attempts to wrap `AWidget` will return the already existing wrapper.
 *
 * @param AWidget - A widget that will be wrapped or one that is already wrapped
 * @returns - The wrapper widget
 */ function $73d42cea7c965d69$var$mergeWidgetOptions(AWidget) {
    let MergedWidget = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(AWidget, 'MergedWidget');
    // cache return value as property of widget for proper react reconciliation
    if (!MergedWidget) {
        // oxlint-disable-next-line typescript/no-deprecated
        const defaultOptions = AWidget.defaultProps && AWidget.defaultProps.options || {};
        MergedWidget = ({ options: options, ...props })=>(0, $2e41620b030ed79e$exports.jsx)(AWidget, {
                options: {
                    ...defaultOptions,
                    ...options
                },
                ...props
            });
        (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(AWidget, 'MergedWidget', MergedWidget);
    }
    return MergedWidget;
}
function $73d42cea7c965d69$export$2e2bcd8739ae039(schema, widget, registeredWidgets = {}) {
    const type = (0, $624c3ff4310242dc$export$2e2bcd8739ae039)(schema);
    if (typeof widget === 'function' || widget && (0, (/*@__PURE__*/$parcel$interopDefault($53a81ab81d62cb67$exports))).isForwardRef((0, $h4Bez.createElement)(widget)) || (0, (/*@__PURE__*/$parcel$interopDefault($53a81ab81d62cb67$exports))).isMemo(widget)) return $73d42cea7c965d69$var$mergeWidgetOptions(widget);
    if (typeof widget !== 'string') throw new Error(`Unsupported widget definition: ${typeof widget} in schema: ${JSON.stringify(schema)}`);
    if (widget in registeredWidgets) {
        const registeredWidget = registeredWidgets[widget];
        return $73d42cea7c965d69$export$2e2bcd8739ae039(schema, registeredWidget, registeredWidgets);
    }
    if (typeof type === 'string') {
        if (!(type in $73d42cea7c965d69$var$widgetMap)) throw new Error(`No widget for type '${type}' in schema: ${JSON.stringify(schema)}`);
        if (widget in $73d42cea7c965d69$var$widgetMap[type]) {
            const registeredWidget = registeredWidgets[$73d42cea7c965d69$var$widgetMap[type][widget]];
            return $73d42cea7c965d69$export$2e2bcd8739ae039(schema, registeredWidget, registeredWidgets);
        }
    }
    throw new Error(`No widget '${widget}' for type '${type}' in schema: ${JSON.stringify(schema)}`);
}



/** Hashes a string using the algorithm based on Java's hashing function.
 * JS has no built-in hashing function, so rolling our own
 *  based on Java's hashing fn:
 *  http://www.java2s.com/example/nodejs-utility-method/string-hash/hashcode-4dc2b.html
 *
 * @param string - The string for which to get the hash
 * @returns - The resulting hash of the string in hex format
 */ function $e3ea314528e97c6e$export$9169be2e06c9c165(string) {
    let hash = 0;
    for(let i = 0; i < string.length; i++){
        const chr = string.charCodeAt(i);
        // oxlint-disable-next-line no-bitwise
        hash = (hash << 5) - hash + chr;
        // oxlint-disable-next-line no-bitwise
        hash &= hash; // Convert to 32bit integer
    }
    return hash.toString(16);
}
function $e3ea314528e97c6e$export$74d3be2bcb0fb7c6(object) {
    const allKeys = new Set();
    // solution source: https://stackoverflow.com/questions/16167581/sort-object-properties-and-json-stringify/53593328#53593328
    JSON.stringify(object, (key, value)=>{
        allKeys.add(key);
        return value;
    });
    return JSON.stringify(object, Array.from(allKeys).sort());
}
function $e3ea314528e97c6e$export$3477f9615e12f61d(object) {
    return $e3ea314528e97c6e$export$9169be2e06c9c165($e3ea314528e97c6e$export$74d3be2bcb0fb7c6(object));
}
function $e3ea314528e97c6e$export$2e2bcd8739ae039(schema) {
    return $e3ea314528e97c6e$export$3477f9615e12f61d(schema);
}



function $9541cc75da9c98ca$export$2e2bcd8739ae039(schema, widget, registeredWidgets = {}) {
    try {
        (0, $73d42cea7c965d69$export$2e2bcd8739ae039)(schema, widget, registeredWidgets);
        return true;
    } catch (e) {
        const err = e;
        if (err.message && (err.message.startsWith('No widget') || err.message.startsWith('Unsupported widget'))) return false;
        throw e;
    }
}




/** Generates a consistent `id` pattern for a given `id` and a `suffix`
 *
 * @param id - Either simple string id or an FieldPathId from which to extract it
 * @param suffix - The suffix to append to the id
 */ function $8ce79fa261751f64$var$idGenerator(id, suffix) {
    const theId = (0, $e6fe0b0844d2a1c4$export$2e2bcd8739ae039)(id) ? id : id[0, $cd207018ee28cb28$export$f453fd324e92d331];
    return `${theId}__${suffix}`;
}
function $8ce79fa261751f64$export$fd4f3344107bd22c(id) {
    return $8ce79fa261751f64$var$idGenerator(id, 'description');
}
function $8ce79fa261751f64$export$8a072670fa7ceeee(id) {
    return $8ce79fa261751f64$var$idGenerator(id, 'error');
}
function $8ce79fa261751f64$export$64cb836579421d7e(id) {
    return $8ce79fa261751f64$var$idGenerator(id, 'examples');
}
function $8ce79fa261751f64$export$94c2e687214ec019(id) {
    return $8ce79fa261751f64$var$idGenerator(id, 'help');
}
function $8ce79fa261751f64$export$86b632e0125010d9(id) {
    return $8ce79fa261751f64$var$idGenerator(id, 'title');
}
function $8ce79fa261751f64$export$53c2204bb4091b57(id, includeExamples = false) {
    const examples = includeExamples ? ` ${$8ce79fa261751f64$export$64cb836579421d7e(id)}` : '';
    return `${$8ce79fa261751f64$export$8a072670fa7ceeee(id)} ${$8ce79fa261751f64$export$fd4f3344107bd22c(id)} ${$8ce79fa261751f64$export$94c2e687214ec019(id)}${examples}`;
}
function $8ce79fa261751f64$export$edf9b44aa62de7dd(id, optionIndex) {
    return `${id}-${optionIndex}`;
}
function $8ce79fa261751f64$export$6395da05030161a1(id, btn) {
    return $8ce79fa261751f64$var$idGenerator(id, btn);
}
function $8ce79fa261751f64$export$a20ab08e55ee75c3(id, element) {
    return $8ce79fa261751f64$var$idGenerator(id, `optional${element}`);
}








function $8df99a86d43a2e45$export$2e2bcd8739ae039(formData) {
    return !(0, $1f65e0187a0081bc$export$2e2bcd8739ae039)(formData) && (!(0, $d252d56fd76f41df$export$2e2bcd8739ae039)(formData) || Array.isArray(formData) || !(0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(formData));
}






function $8e492713fcf656be$export$2e2bcd8739ae039(registry, schemaToCompare) {
    const { rootSchema: rootSchema, schemaUtils: schemaUtils } = registry;
    if ((0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(schemaToCompare, rootSchema)) return true;
    if ((0, $cd207018ee28cb28$export$cf02ae06bf291db4) in rootSchema) {
        const resolvedSchema = schemaUtils.retrieveSchema(rootSchema);
        return (0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(schemaToCompare, (0, $56d3aa46749de9f1$export$2e2bcd8739ae039)(resolvedSchema, (0, $cd207018ee28cb28$export$2a59f05123189784)));
    }
    return false;
}


function $e15ee0fe5a70fe3e$export$2e2bcd8739ae039(label, hideLabel, fallback) {
    return hideLabel ? fallback : label;
}


/** Converts a local Date string into a UTC date string
 *
 * @param dateString - The string representation of a date as accepted by the `Date()` constructor
 * @returns - A UTC date string if `dateString` is truthy, otherwise undefined
 */ function $56d385d1e39964bc$export$2e2bcd8739ae039(dateString) {
    return dateString ? new Date(dateString).toJSON() : undefined;
}





function $52b7e1b185f3945e$export$2e2bcd8739ae039(regOrFc, toLookup, fallback) {
    const lookupPath = [
        (0, $cd207018ee28cb28$export$51524a5519b64d38)
    ];
    if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(regOrFc, (0, $cd207018ee28cb28$export$ca7529cc4a51f890))) lookupPath.unshift((0, $cd207018ee28cb28$export$ca7529cc4a51f890));
    return (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(regOrFc, [
        ...lookupPath,
        toLookup
    ], fallback);
}





/**
 * Generates bracketed names
 * Example: root[tasks][0][title]
 * For multi-value fields (checkboxes, multi-select): root[hobbies][]
 */ const $4f83f75c35be7419$export$70d3d17605b9c972 = (path, idPrefix, isMultiValue)=>{
    if (!path || path.length === 0) return idPrefix;
    const baseName = path.reduce((acc, pathUnit, index)=>{
        if (index === 0) return `${idPrefix}[${String(pathUnit)}]`;
        return `${acc}[${String(pathUnit)}]`;
    }, '');
    // For multi-value fields, append [] to allow multiple values with the same name
    return isMultiValue ? `${baseName}[]` : baseName;
};
const $4f83f75c35be7419$export$87c038118f2ec5cf = (path, idPrefix, _isMultiValue)=>{
    if (!path || path.length === 0) return idPrefix;
    return `${idPrefix}.${path.map(String).join('.')}`;
};



/** Given a list of `properties` and an `order` list, returns a list that contains the `properties` ordered correctly.
 * If `order` is not an array, then the untouched `properties` list is returned. Otherwise `properties` is ordered per
 * the `order` list. If `order` contains a '*' then any `properties` that are not mentioned explicity in `order` will be
 * places in the location of the `*`.
 *
 * @param properties - The list of property keys to be ordered
 * @param order - An array of property keys to be ordered first, with an optional '*' property
 * @returns - A list with the `properties` ordered
 * @throws - Error when the properties cannot be ordered correctly
 */ function $3235af65e5413a3a$export$2e2bcd8739ae039(properties, order) {
    if (!Array.isArray(order)) return properties;
    const arrayToHash = (arr)=>arr.reduce((acc, curr)=>{
            acc[curr] = true;
            return acc;
        }, {});
    const errorPropList = (arr)=>arr.length > 1 ? `properties '${arr.join("', '")}'` : `property '${arr[0]}'`;
    const propertyHash = arrayToHash(properties);
    const orderFiltered = order.filter((prop)=>prop === '*' || propertyHash[prop]);
    const orderHash = arrayToHash(orderFiltered);
    const rest = properties.filter((prop)=>!orderHash[prop]);
    const restIndex = orderFiltered.indexOf('*');
    if (restIndex === -1) {
        if (rest.length) throw new Error(`uiSchema order list does not contain ${errorPropList(rest)}`);
        return orderFiltered;
    }
    if (restIndex !== orderFiltered.lastIndexOf('*')) throw new Error('uiSchema order list contains more than one wildcard item');
    const complete = [
        ...orderFiltered
    ];
    complete.splice(restIndex, 1, ...rest);
    return complete;
}



/** Parses the `dateString` into a `DateObject`, including the time information when `includeTime` is true
 *
 * @param dateString - The date string to parse into a DateObject
 * @param [includeTime=true] - Optional flag, if false, will not include the time data into the object
 * @returns - The date string converted to a `DateObject`
 * @throws - Error when the date cannot be parsed from the string
 */ function $bc3379047b09edff$export$2e2bcd8739ae039(dateString, includeTime = true) {
    if (!dateString) return {
        year: -1,
        month: -1,
        day: -1,
        hour: includeTime ? -1 : 0,
        minute: includeTime ? -1 : 0,
        second: includeTime ? -1 : 0
    };
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) throw new Error(`Unable to parse date ${dateString}`);
    return {
        year: date.getUTCFullYear(),
        month: date.getUTCMonth() + 1,
        day: date.getUTCDate(),
        hour: includeTime ? date.getUTCHours() : 0,
        minute: includeTime ? date.getUTCMinutes() : 0,
        second: includeTime ? date.getUTCSeconds() : 0
    };
}





function $48c8bbdd2978f9e1$export$2e2bcd8739ae039(validator, schema, rootSchema, formData) {
    if (!(0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(schema)) return formData;
    const resolvedSchema = (0, $9f63129bef70072a$export$2e2bcd8739ae039)(validator, schema, rootSchema, formData);
    if (Array.isArray(formData)) {
        const itemsSchema = resolvedSchema.items;
        if (!itemsSchema) return formData;
        let hasChanges = false;
        const mapped = formData.map((item, index)=>{
            let itemSchema = itemsSchema;
            if (Array.isArray(itemsSchema)) itemSchema = itemsSchema[index] || resolvedSchema.additionalItems || {};
            // oxlint-disable-next-line @typescript-eslint/no-deprecated
            const cleaned = $48c8bbdd2978f9e1$export$2e2bcd8739ae039(validator, itemSchema, rootSchema, item);
            if (cleaned !== item) hasChanges = true;
            return cleaned === undefined ? {} : cleaned;
        });
        // Although T is an array type here, we still need to cast it back to T since TS
        // doesn't narrow the generic T automatically
        return hasChanges ? mapped : formData;
    }
    const { properties: properties, required: requiredFields = [] } = resolvedSchema;
    if (!(0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(formData) || !properties) return formData;
    const result = {};
    const data = formData;
    let hasAnyValue = false;
    for (const key of Object.keys(data)){
        const value = data[key];
        const propertySchema = properties[key] || {};
        const isRequired = requiredFields.includes(key);
        const isObj = (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(value);
        const isArr = Array.isArray(value);
        if ((isObj || isArr) && properties[key]) {
            // Recursively process nested objects and arrays
            // oxlint-disable-next-line @typescript-eslint/no-deprecated
            const cleaned = $48c8bbdd2978f9e1$export$2e2bcd8739ae039(validator, propertySchema, rootSchema, value);
            if (isRequired || !(0, $e7d329486831c49a$export$45ee1743c0763984)(cleaned)) {
                result[key] = cleaned;
                hasAnyValue = true;
            }
        } else if (isRequired || !(0, $e7d329486831c49a$export$45ee1743c0763984)(value) || !properties[key]) {
            // Keep: required, non-empty, or not schema-defined; skip optional empty scalars silently
            result[key] = value;
            if (!(0, $e7d329486831c49a$export$45ee1743c0763984)(value)) hasAnyValue = true;
        }
    }
    // If the entire object ended up empty after pruning, return undefined so that the
    // caller (which may itself be a recursive call) can decide whether to keep or drop it
    if (!hasAnyValue && Object.keys(result).length === 0) return undefined;
    return result;
}







function $6ae06bf6c4676d6a$export$2e2bcd8739ae039(schema, localUiSchema, registry) {
    var _a, _b;
    const ref = (_a = schema[0, $cd207018ee28cb28$export$2a59f05123189784]) !== null && _a !== void 0 ? _a : schema[0, $cd207018ee28cb28$export$cf02ae06bf291db4];
    const definitions = registry.uiSchemaDefinitions;
    const definitionUiSchema = ref && definitions ? definitions[ref] : undefined;
    let result;
    if (!definitionUiSchema) result = localUiSchema || {};
    else if (!localUiSchema || (0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(localUiSchema)) result = {
        ...definitionUiSchema
    };
    else result = (0, $4ab7d05f28605536$export$2e2bcd8739ae039)(definitionUiSchema, localUiSchema);
    // Walk oneOf/anyOf branches to populate uiSchema[keyword][i] so MultiSchemaField
    // can read dropdown option titles at the parent level.
    if (definitions) {
        let resolvedSchema = schema;
        if (ref && schema[0, $cd207018ee28cb28$export$cf02ae06bf291db4] && !schema[0, $cd207018ee28cb28$export$2a59f05123189784]) try {
            resolvedSchema = (0, $9bd5acf65f690f1a$export$2e2bcd8739ae039)(ref, registry.rootSchema);
        } catch (e) {
            // oxlint-disable-next-line no-console
            console.warn('could not resolve $ref in resolveUiSchema:\n', e);
            return result;
        }
        for (const keyword of [
            (0, $cd207018ee28cb28$export$c24c2c38af9a39c3),
            (0, $cd207018ee28cb28$export$2014f14bbe7357bd)
        ]){
            const schemaOptions = resolvedSchema[keyword];
            if (Array.isArray(schemaOptions) && schemaOptions.length > 0) {
                const currentUiSchemaArray = result[keyword];
                const uiSchemaArray = Array.isArray(currentUiSchemaArray) ? [
                    ...currentUiSchemaArray
                ] : [];
                let hasExpanded = false;
                for(let i = 0; i < schemaOptions.length; i++){
                    const option = schemaOptions[i];
                    const optionRef = (_b = option === null || option === void 0 ? void 0 : option[0, $cd207018ee28cb28$export$2a59f05123189784]) !== null && _b !== void 0 ? _b : option === null || option === void 0 ? void 0 : option[0, $cd207018ee28cb28$export$cf02ae06bf291db4];
                    if (optionRef && optionRef in definitions) {
                        const optionUiSchema = uiSchemaArray[i] || {};
                        uiSchemaArray[i] = (0, $4ab7d05f28605536$export$2e2bcd8739ae039)(definitions[optionRef], optionUiSchema);
                        hasExpanded = true;
                    }
                }
                if (hasExpanded) result[keyword] = uiSchemaArray;
            }
        }
    }
    return result;
}


/** Check to see if a `schema` specifies that a value must be true. This happens when:
 * - `schema.const` is truthy
 * - `schema.enum` == `[true]`
 * - `schema.anyOf` or `schema.oneOf` has a single value which recursively returns true
 * - `schema.allOf` has at least one value which recursively returns true
 *
 * @param schema - The schema to check
 * @returns - True if the schema specifies a value that must be true, false otherwise
 */ function $a2e0f2eb7f90d507$export$2e2bcd8739ae039(schema) {
    // Check if const is a truthy value
    if (schema.const) return true;
    // Check if an enum has a single value of true
    if (schema.enum && schema.enum.length === 1 && schema.enum[0] === true) return true;
    // If anyOf has a single value, evaluate the subschema
    if (schema.anyOf && schema.anyOf.length === 1) return $a2e0f2eb7f90d507$export$2e2bcd8739ae039(schema.anyOf[0]);
    // If oneOf has a single value, evaluate the subschema
    if (schema.oneOf && schema.oneOf.length === 1) return $a2e0f2eb7f90d507$export$2e2bcd8739ae039(schema.oneOf[0]);
    // Evaluate each subschema in allOf, to see if one of them requires a true value
    if (schema.allOf) {
        const schemaSome = (subSchema)=>$a2e0f2eb7f90d507$export$2e2bcd8739ae039(subSchema);
        return schema.allOf.some(schemaSome);
    }
    return false;
}


/** Implements a shallow equals comparison that uses Object.is() for comparing values.
 * This function compares objects by checking if all keys and their values are equal using Object.is().
 *
 * @param a - The first element to compare
 * @param b - The second element to compare
 * @returns - True if the `a` and `b` are shallow equal, false otherwise
 */ function $c20a488340bd8faf$export$2e2bcd8739ae039(a, b) {
    // If they're the same reference, they're equal
    if (Object.is(a, b)) return true;
    // If either is null or undefined, they're not equal (since we know they're not the same reference)
    if (a == null || b == null) return false;
    // If they're not objects, they're not equal (since Object.is already checked)
    if (typeof a !== 'object' || typeof b !== 'object') return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    // Different number of keys means not equal
    if (keysA.length !== keysB.length) return false;
    // Check if all keys and values are equal
    for(let i = 0; i < keysA.length; i += 1){
        const key = keysA[i];
        if (!Object.hasOwn(b, key) || !Object.is(a[key], b[key])) return false;
    }
    return true;
}




function $10381dd8d10816d4$export$2e2bcd8739ae039(component, nextProps, nextState, updateStrategy = 'customDeep') {
    if (updateStrategy === 'always') // Use React's default behavior: always update if state or props change (no shouldComponentUpdate optimization)
    return true;
    if (updateStrategy === 'shallow') {
        // Use shallow comparison for props and state
        const { props: props, state: state } = component;
        return !(0, $c20a488340bd8faf$export$2e2bcd8739ae039)(props, nextProps) || !(0, $c20a488340bd8faf$export$2e2bcd8739ae039)(state, nextState);
    }
    // Use custom deep equality checks (default 'customDeep' strategy)
    const { props: props, state: state } = component;
    return !(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(props, nextProps) || !(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(state, nextState);
}








function $87b2dc06d3aae4d2$export$ab3b4c708bbb2e6f(schemas) {
    const allTypes = (0, $773aceab9d457899$export$2e2bcd8739ae039)(schemas.map((s)=>(0, $d252d56fd76f41df$export$2e2bcd8739ae039)(s) ? (0, $624c3ff4310242dc$export$2e2bcd8739ae039)(s) : undefined).flat().filter((t)=>t !== undefined));
    return allTypes.length === 1 ? allTypes[0] : allTypes;
}
function $87b2dc06d3aae4d2$export$2e2bcd8739ae039(registry, schema, required, uiSchema) {
    const { enableOptionalDataFieldForType: enableOptionalDataFieldForType = [] } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, registry.globalUiOptions);
    let schemaType;
    if ((0, $cd207018ee28cb28$export$2014f14bbe7357bd) in schema && Array.isArray(schema[0, $cd207018ee28cb28$export$2014f14bbe7357bd])) schemaType = $87b2dc06d3aae4d2$export$ab3b4c708bbb2e6f(schema[0, $cd207018ee28cb28$export$2014f14bbe7357bd]);
    else if ((0, $cd207018ee28cb28$export$c24c2c38af9a39c3) in schema && Array.isArray(schema[0, $cd207018ee28cb28$export$c24c2c38af9a39c3])) schemaType = $87b2dc06d3aae4d2$export$ab3b4c708bbb2e6f(schema[0, $cd207018ee28cb28$export$c24c2c38af9a39c3]);
    else schemaType = (0, $624c3ff4310242dc$export$2e2bcd8739ae039)(schema);
    return !(0, $8e492713fcf656be$export$2e2bcd8739ae039)(registry, schema) && !required && !!schemaType && !Array.isArray(schemaType) && !!enableOptionalDataFieldForType.find((val)=>val === schemaType);
}



/** Returns a UTC date string for the given `dateObject`. If `time` is false, then the time portion of the string is
 * removed.
 *
 * @param dateObject - The `DateObject` to convert to a date string
 * @param [time=true] - Optional flag used to remove the time portion of the date string if false
 * @returns - The UTC date string
 */ function $0d05265d6546726b$export$2e2bcd8739ae039(dateObject, time = true) {
    const { year: year, month: month, day: day, hour: hour = 0, minute: minute = 0, second: second = 0 } = dateObject;
    const utcTime = Date.UTC(year, month - 1, day, hour, minute, second);
    const datetime = new Date(utcTime).toJSON();
    return time ? datetime : datetime.slice(0, 10);
}




function $23daf1e084ef378b$export$2e2bcd8739ae039(errorSchema, fieldPath = []) {
    if (!errorSchema) return [];
    let errorList = [];
    if ((0, $cd207018ee28cb28$export$36fec1b8ab257149) in errorSchema) errorList = errorList.concat(errorSchema[0, $cd207018ee28cb28$export$36fec1b8ab257149].map((message)=>{
        const property = `.${fieldPath.join('.')}`;
        return {
            property: property,
            message: message,
            stack: `${property} ${message}`
        };
    }));
    return Object.keys(errorSchema).reduce((currentList, key)=>{
        if (key !== (0, $cd207018ee28cb28$export$36fec1b8ab257149)) {
            const childSchema = errorSchema[key];
            if ((0, $d6bfaab5809eb5e3$export$2e2bcd8739ae039)(childSchema)) return currentList.concat($23daf1e084ef378b$export$2e2bcd8739ae039(childSchema, [
                ...fieldPath,
                key
            ]));
        }
        return currentList;
    }, errorList);
}









/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $e0a9f91a59ab06d5$var$toPath(value) {
    if ((0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(value)) return (0, $a8b30b77f2b6a1c4$export$2e2bcd8739ae039)(value, (0, $031a2cbe9b26e09a$export$2e2bcd8739ae039));
    return (0, $ab251a97c515dcdc$export$2e2bcd8739ae039)(value) ? [
        value
    ] : (0, $0888b9a44238f12f$export$2e2bcd8739ae039)((0, $89ea575de9e34a82$export$2e2bcd8739ae039)((0, $26fb36591628d13f$export$2e2bcd8739ae039)(value)));
}
var $e0a9f91a59ab06d5$export$2e2bcd8739ae039 = $e0a9f91a59ab06d5$var$toPath;



function $dcbb07faa7f8c34f$export$2e2bcd8739ae039(errors) {
    const builder = new (0, $ca490662d9a1e5b4$export$2e2bcd8739ae039)();
    if (errors.length) errors.forEach((error)=>{
        const { property: property, message: message } = error;
        // When the property is the root element, just use an empty array for the path
        const path = property === '.' ? [] : (0, $e0a9f91a59ab06d5$export$2e2bcd8739ae039)(property);
        // If the property is at the root (.level1) then toPath creates
        // an empty array element at the first index. Remove it.
        if (path.length > 0 && path[0] === '') path.splice(0, 1);
        if (message) builder.addErrors(message, path);
    });
    return builder.ErrorSchema;
}



function $99206247aba21705$export$2e2bcd8739ae039(fieldPath, globalFormOptions, parentPath, isMultiValue) {
    const basePath = Array.isArray(parentPath) ? parentPath : parentPath === null || parentPath === void 0 ? void 0 : parentPath.path;
    const childPath = fieldPath === '' ? [] : [
        fieldPath
    ];
    const path = basePath ? basePath.concat(...childPath) : childPath;
    const id = [
        globalFormOptions.idPrefix,
        ...path
    ].join(globalFormOptions.idSeparator);
    // Generate name attribute if nameGenerator is provided
    let name;
    if (globalFormOptions.nameGenerator && path.length > 0) name = globalFormOptions.nameGenerator(path, globalFormOptions.idPrefix, isMultiValue);
    return {
        path: path,
        [(0, $cd207018ee28cb28$export$f453fd324e92d331)]: id,
        ...name !== undefined && {
            name: name
        }
    };
}



function $7f535cbac56a74a1$export$2e2bcd8739ae039(errorHandler) {
    return Object.keys(errorHandler).reduce((acc, key)=>{
        if (key === 'addError') return acc;
        const childSchema = errorHandler[key];
        if ((0, $d6bfaab5809eb5e3$export$2e2bcd8739ae039)(childSchema)) return {
            ...acc,
            [key]: $7f535cbac56a74a1$export$2e2bcd8739ae039(childSchema)
        };
        return {
            ...acc,
            [key]: childSchema
        };
    }, {});
}




var $h4Bez = parcelRequire("h4Bez");





'use client';
/** Function that checks to see if a `DateObject` is ready for the onChange callback to be triggered
 *
 * @param state - The current `DateObject`
 * @returns - True if the `state` is ready to trigger an onChange
 */ function $89082e2af7bb7362$var$readyForChange(state) {
    return Object.values(state).every((value)=>value !== -1);
}
function $89082e2af7bb7362$export$1e68ee11416672d8(props) {
    const { className: className = 'form-control', type: type, range: range, value: value, select: select, rootId: rootId, name: name, disabled: disabled, readonly: readonly, autofocus: autofocus, registry: registry, onBlur: onBlur, onFocus: onFocus } = props;
    const id = `${rootId}_${type}`;
    const { SelectWidget: SelectWidget } = registry.widgets;
    const onChange = (0, $h4Bez.useCallback)((newValue)=>select(type, newValue), [
        select,
        type
    ]);
    return (0, $2e41620b030ed79e$exports.jsx)(SelectWidget, {
        schema: {
            type: 'integer'
        },
        id: id,
        name: name,
        className: className,
        options: {
            enumOptions: (0, $725778898db16795$export$2e2bcd8739ae039)(range[0], range[1])
        },
        placeholder: type,
        value: value,
        disabled: disabled,
        readonly: readonly,
        autofocus: autofocus,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        registry: registry,
        label: '',
        "aria-describedby": (0, $8ce79fa261751f64$export$53c2204bb4091b57)(rootId)
    });
}
function $89082e2af7bb7362$export$2e2bcd8739ae039(props) {
    const { time: time = false, disabled: disabled = false, readonly: readonly = false, options: options, onChange: onChange, value: value } = props;
    const [state, setState] = (0, $h4Bez.useState)((0, $bc3379047b09edff$export$2e2bcd8739ae039)(value, time));
    (0, $h4Bez.useEffect)(()=>{
        setState((0, $bc3379047b09edff$export$2e2bcd8739ae039)(value, time));
    }, [
        time,
        value
    ]);
    const handleChange = (0, $h4Bez.useCallback)((property, newValue)=>{
        const nextState = {
            ...state,
            [property]: typeof newValue === 'undefined' ? -1 : newValue
        };
        if ($89082e2af7bb7362$var$readyForChange(nextState)) onChange((0, $0d05265d6546726b$export$2e2bcd8739ae039)(nextState, time));
        else setState(nextState);
    }, [
        state,
        onChange,
        time
    ]);
    const handleClear = (0, $h4Bez.useCallback)((event)=>{
        event.preventDefault();
        if (disabled || readonly) return;
        onChange(undefined);
    }, [
        disabled,
        readonly,
        onChange
    ]);
    const handleSetNow = (0, $h4Bez.useCallback)((event)=>{
        event.preventDefault();
        if (disabled || readonly) return;
        const nextState = (0, $bc3379047b09edff$export$2e2bcd8739ae039)(new Date().toJSON(), time);
        onChange((0, $0d05265d6546726b$export$2e2bcd8739ae039)(nextState, time));
    }, [
        disabled,
        readonly,
        time,
        onChange
    ]);
    const elements = (0, $h4Bez.useMemo)(()=>(0, $65151b6a7a69c4b2$export$2e2bcd8739ae039)(state, time, options.yearsRange, options.format), [
        state,
        time,
        options.yearsRange,
        options.format
    ]);
    return {
        elements: elements,
        handleChange: handleChange,
        handleClear: handleClear,
        handleSetNow: handleSetNow
    };
}



var $h4Bez = parcelRequire("h4Bez");

'use client';
function $00773362d992a2a1$export$2e2bcd8739ae039(newValue) {
    const valueRef = (0, $h4Bez.useRef)(newValue);
    if (!(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(newValue, valueRef.current)) valueRef.current = newValue;
    return valueRef.current;
}



var $h4Bez = parcelRequire("h4Bez");

'use client';
/** Updated the given `dataUrl` to add the `name` to it
 *
 * @param dataURL - The url description string
 * @param name - The name of the file to add to the dataUrl
 * @returns - The `dataUrl` updated to include the name
 */ function $98812ea88cdc9445$var$addNameToDataURL(dataURL, name) {
    return dataURL.replace(';base64', `;name=${encodeURIComponent(name)};base64`);
}
/** Returns a promise that will read the file from the browser and return it as the result of the promise.
 *
 * @param file - The `File` information to read
 * @returns - A promise that resolves to the read file.
 */ function $98812ea88cdc9445$var$processFile(file) {
    const { name: name, size: size, type: type } = file;
    return new Promise((resolve, reject)=>{
        const reader = new window.FileReader();
        reader.onerror = reject;
        reader.onload = (event)=>{
            var _a;
            if (typeof ((_a = event.target) === null || _a === void 0 ? void 0 : _a.result) === 'string') resolve({
                dataURL: $98812ea88cdc9445$var$addNameToDataURL(event.target.result, name),
                name: name,
                size: size,
                type: type
            });
            else resolve({
                dataURL: null,
                name: name,
                size: size,
                type: type
            });
        };
        reader.readAsDataURL(file);
    });
}
/** Reads a list of files from the browser, returning the results of the promises of each individual file read.
 *
 * @param files - The list of files to read
 * @returns - The list of read files
 */ function $98812ea88cdc9445$var$processFiles(files) {
    return Promise.all(Array.from(files).map($98812ea88cdc9445$var$processFile));
}
/** Extracts the file information from the data URLs
 *
 * @param dataURLs - The information about the files
 * @returns - The list of `FileInfoType` objects extracted from the data urls
 */ function $98812ea88cdc9445$var$extractFileInfo(dataURLs) {
    return dataURLs.reduce((acc, dataURL)=>{
        if (!dataURL) return acc;
        try {
            const { blob: blob, name: name } = (0, $1dbd19e0a8f019c3$export$2e2bcd8739ae039)(dataURL);
            return [
                ...acc,
                {
                    dataURL: dataURL,
                    name: name,
                    size: blob.size,
                    type: blob.type
                }
            ];
        } catch (_a) {
            // Invalid dataURI, so just ignore it.
            return acc;
        }
    }, []);
}
function $98812ea88cdc9445$export$2e2bcd8739ae039(value, onChange, multiple = false) {
    const values = (0, $h4Bez.useMemo)(()=>{
        if (multiple && value) return Array.isArray(value) ? value : [
            value
        ];
        return [];
    }, [
        value,
        multiple
    ]);
    const filesInfo = (0, $h4Bez.useMemo)(()=>Array.isArray(value) ? $98812ea88cdc9445$var$extractFileInfo(value) : $98812ea88cdc9445$var$extractFileInfo([
            value || ''
        ]), [
        value
    ]);
    const handleChange = (0, $h4Bez.useCallback)(async (files)=>{
        const filesInfoEvent = await $98812ea88cdc9445$var$processFiles(files);
        const newValue = filesInfoEvent.map((fileInfo)=>fileInfo.dataURL || null);
        if (multiple) onChange(values.concat(...newValue));
        else onChange(newValue[0]);
    }, [
        values,
        multiple,
        onChange
    ]);
    const handleRemove = (0, $h4Bez.useCallback)((index)=>{
        if (multiple) {
            const newValue = values.filter((_, i)=>i !== index);
            onChange(newValue);
        } else onChange(undefined);
    }, [
        values,
        multiple,
        onChange
    ]);
    return {
        filesInfo: filesInfo,
        handleChange: handleChange,
        handleRemove: handleRemove
    };
}



function $e043d79250f08a55$export$2e2bcd8739ae039(jsonDate) {
    if (!jsonDate) return '';
    // required format of `'yyyy-MM-ddThh:mm' followed by optional ':ss' or ':ss.SSS'
    // https://html.spec.whatwg.org/multipage/input.html#local-date-and-time-state-(type%3Ddatetime-local)
    // > should be a _valid local date and time string_ (not GMT)
    // Note - date constructor passed local ISO-8601 does not correctly
    // change time to UTC in node pre-8
    const date = new Date(jsonDate);
    const yyyy = (0, $5a5e14ed9eaadffb$export$2e2bcd8739ae039)(date.getFullYear(), 4);
    const MM = (0, $5a5e14ed9eaadffb$export$2e2bcd8739ae039)(date.getMonth() + 1, 2);
    const dd = (0, $5a5e14ed9eaadffb$export$2e2bcd8739ae039)(date.getDate(), 2);
    const hh = (0, $5a5e14ed9eaadffb$export$2e2bcd8739ae039)(date.getHours(), 2);
    const mm = (0, $5a5e14ed9eaadffb$export$2e2bcd8739ae039)(date.getMinutes(), 2);
    const ss = (0, $5a5e14ed9eaadffb$export$2e2bcd8739ae039)(date.getSeconds(), 2);
    const SSS = (0, $5a5e14ed9eaadffb$export$2e2bcd8739ae039)(date.getMilliseconds(), 3);
    return `${yyyy}-${MM}-${dd}T${hh}:${mm}:${ss}.${SSS}`;
}





function $f4a48b11a54dcb84$export$2e2bcd8739ae039(validationData, additionalErrorSchema, preventDuplicates = false) {
    if (!additionalErrorSchema) return validationData;
    const { errors: oldErrors, errorSchema: oldErrorSchema } = validationData;
    let errors = (0, $23daf1e084ef378b$export$2e2bcd8739ae039)(additionalErrorSchema);
    let errorSchema = additionalErrorSchema;
    if (!(0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(oldErrorSchema)) {
        errorSchema = (0, $4ab7d05f28605536$export$2e2bcd8739ae039)(oldErrorSchema, additionalErrorSchema, preventDuplicates ? 'preventDuplicates' : true);
        errors = [
            ...oldErrors
        ].concat(errors);
    }
    return {
        errorSchema: errorSchema,
        errors: errors
    };
}




/** Takes a `node` object and transforms any contained `$ref` node variables with a prefix, recursively calling
 * `withIdRefPrefix` for any other elements.
 *
 * @param node - The object node to which a ROOT_SCHEMA_PREFIX is added when a REF_KEY is part of it
 */ function $5408a594667028d0$var$withIdRefPrefixObject(node) {
    const realObj = node;
    for(const key in realObj)/* v8 ignore next -- spread in caller guarantees only own properties reach this loop */ if (Object.hasOwn(realObj, key)) {
        const value = realObj[key];
        if (key === (0, $cd207018ee28cb28$export$cf02ae06bf291db4) && typeof value === 'string' && value.startsWith('#')) realObj[key] = (0, $cd207018ee28cb28$export$4f0f58ec8c545f3) + value;
        else realObj[key] = $5408a594667028d0$export$2e2bcd8739ae039(value);
    }
    return node;
}
/** Takes a `node` object list and transforms any contained `$ref` node variables with a prefix, recursively calling
 * `withIdRefPrefix` for any other elements.
 *
 * @param node - The list of object nodes to which a ROOT_SCHEMA_PREFIX is added when a REF_KEY is part of it
 */ function $5408a594667028d0$var$withIdRefPrefixArray(node) {
    return node.map((item)=>$5408a594667028d0$export$2e2bcd8739ae039(item));
}
function $5408a594667028d0$export$2e2bcd8739ae039(schemaNode) {
    if (Array.isArray(schemaNode)) return $5408a594667028d0$var$withIdRefPrefixArray([
        ...schemaNode
    ]);
    if ((0, $d252d56fd76f41df$export$2e2bcd8739ae039)(schemaNode)) return $5408a594667028d0$var$withIdRefPrefixObject({
        ...schemaNode
    });
    return schemaNode;
}


/** An enumeration of all the translatable strings used by `@rjsf/core` and its themes. The value of each of the
 * enumeration keys is expected to be the actual english string. Some strings contain replaceable parameter values
 * as indicated by `%1`, `%2`, etc. The number after the `%` indicates the order of the parameter. The ordering of
 * parameters is important because some languages may choose to put the second parameter before the first in its
 * translation. Also, some strings are rendered using `markdown-to-jsx` and thus support markdown and inline html.
 */ var $b63837cd47cf776b$export$e8ce1f619d132f5c;
(function(TranslatableString) {
    /** Fallback title of an array item, used by ArrayField */ TranslatableString["ArrayItemTitle"] = "Item";
    /** Missing items reason, used by ArrayField */ TranslatableString["MissingItems"] = "Missing items definition";
    /** Empty array message, used by ArrayField */ TranslatableString["EmptyArray"] = "No items yet. Use the button below to add some.";
    /** Yes label, used by BooleanField */ TranslatableString["YesLabel"] = "Yes";
    /** No label, used by BooleanField */ TranslatableString["NoLabel"] = "No";
    /** Close label, used by ErrorList */ TranslatableString["CloseLabel"] = "Close";
    /** Errors label, used by ErrorList */ TranslatableString["ErrorsLabel"] = "Errors";
    /** New additionalProperties string default value, used by ObjectField */ TranslatableString["NewStringDefault"] = "New Value";
    /** Add button title, used by AddButton */ TranslatableString["AddButton"] = "Add";
    /** Add button title, used by AddButton */ TranslatableString["AddItemButton"] = "Add Item";
    /** Copy button title, used by IconButton */ TranslatableString["CopyButton"] = "Copy";
    /** Move down button title, used by IconButton */ TranslatableString["MoveDownButton"] = "Move down";
    /** Move up button title, used by IconButton */ TranslatableString["MoveUpButton"] = "Move up";
    /** Remove button title, used by IconButton */ TranslatableString["RemoveButton"] = "Remove";
    /** Now label, used by AltDateWidget */ TranslatableString["NowLabel"] = "Now";
    /** Clear label, used by AltDateWidget */ TranslatableString["ClearLabel"] = "Clear";
    /** Aria date label, used by DateWidget */ TranslatableString["AriaDateLabel"] = "Select a date";
    /** File preview label, used by FileWidget */ TranslatableString["PreviewLabel"] = "Preview";
    /** Decrement button aria label, used by UpDownWidget */ TranslatableString["DecrementAriaLabel"] = "Decrease value by 1";
    /** Increment button aria label, used by UpDownWidget */ TranslatableString["IncrementAriaLabel"] = "Increase value by 1";
    /** The label for the Add button in for an optional object field */ TranslatableString["OptionalObjectAdd"] = "Add data for optional field";
    /** The label for the Remove button in for an optional object field */ TranslatableString["OptionalObjectRemove"] = "Remove data for optional field";
    /** The label for when displaying a non-editable form with missing optional field data */ TranslatableString["OptionalObjectEmptyMsg"] = "No data for optional field";
    /** Label for the schema type selector, used by FallbackField */ TranslatableString["Type"] = "Type";
    /** Label for the 'value' field, used by FallbackField */ TranslatableString["Value"] = "Value";
    /** Clear button title, used by IconButton */ TranslatableString["ClearButton"] = "clear input";
    // Strings with replaceable parameters
    /** Unknown field type reason, where %1 will be replaced with the type as provided by SchemaField */ TranslatableString["UnknownFieldType"] = "Unknown field type %1";
    /** Option prefix, where %1 will be replaced with the option index as provided by MultiSchemaField */ TranslatableString["OptionPrefix"] = "Option %1";
    /** Option prefix, where %1 and %2 will be replaced by the schema title and option index, respectively as provided by
     * MultiSchemaField
     */ TranslatableString["TitleOptionPrefix"] = "%1 option %2";
    /** Key label, where %1 will be replaced by the label as provided by WrapIfAdditionalTemplate */ TranslatableString["KeyLabel"] = "%1 Key";
    /** Deprecated label, where %1 will be replaced by the label as provided by SchemaField */ TranslatableString["DeprecatedLabel"] = "%1 (deprecated)";
    // Strings with replaceable parameters AND/OR that support markdown and html
    /** Invalid object field configuration as provided by the ObjectField.
     * NOTE: Use markdown notation rather than html tags.
     */ TranslatableString["InvalidObjectField"] = "Invalid \"%1\" object field configuration: _%2_.";
    /** Unsupported field schema, used by UnsupportedField */ TranslatableString["UnsupportedField"] = "Unsupported field schema.";
    /** Unsupported field schema, where %1 will be replaced by the FieldPathId.$id as provided by UnsupportedField.
     * NOTE: Use markdown notation rather than html tags.
     */ TranslatableString["UnsupportedFieldWithId"] = "Unsupported field schema for field `%1`.";
    /** Unsupported field schema, where %1 will be replaced by the reason string as provided by UnsupportedField.
     * NOTE: Use markdown notation rather than html tags.
     */ TranslatableString["UnsupportedFieldWithReason"] = "Unsupported field schema: _%1_.";
    /** Unsupported field schema, where %1 and %2 will be replaced by the FieldPathId.$id and reason strings,
     * respectively, as provided by UnsupportedField.
     * NOTE: Use markdown notation rather than html tags.
     */ TranslatableString["UnsupportedFieldWithIdAndReason"] = "Unsupported field schema for field `%1`: _%2_.";
    /** File name, type and size info, where %1, %2 and %3 will be replaced by the file name, file type and file size as
     * provided by FileWidget
     */ TranslatableString["FilesInfo"] = "**%1** (%2, %3 bytes)";
})($b63837cd47cf776b$export$e8ce1f619d132f5c || ($b63837cd47cf776b$export$e8ce1f619d132f5c = {}));







/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $1a51e4fa81bddb8c$var$forEach(collection, iteratee) {
    var func = (0, $44621b626b9ac4b3$export$2e2bcd8739ae039)(collection) ? (0, $d36a4232bf514589$export$2e2bcd8739ae039) : (0, $fa79510661ee2665$export$2e2bcd8739ae039);
    return func(collection, (0, $41725e7aae11058e$export$2e2bcd8739ae039)(iteratee));
}
var $1a51e4fa81bddb8c$export$2e2bcd8739ae039 = $1a51e4fa81bddb8c$var$forEach;









class $f1cd08243c9ebe92$export$2e2bcd8739ae039 {
    /** Construct the ParserValidator for the given `rootSchema`. This `rootSchema` will be stashed in the `schemaMap`
     * first.
     *
     * @param rootSchema - The root schema against which this validator will be executed
     */ constructor(rootSchema){
        /** The map of schemas encountered by the ParserValidator */ this.schemaMap = {};
        this.rootSchema = rootSchema;
        this.addSchema(rootSchema, (0, $e3ea314528e97c6e$export$2e2bcd8739ae039)(rootSchema));
    }
    /** Resets the internal AJV validator to clear schemas from it. Can be helpful for resetting the validator for tests.
     */ reset() {
        this.schemaMap = {};
    }
    /** Adds the given `schema` to the `schemaMap` keyed by the `hash` or `ID_KEY` if present on the `schema`. If the
     * schema does not have an `ID_KEY`, then the `hash` will be added as the `ID_KEY` to allow the schema to be
     * associated with it's `hash` for future use (by a schema compiler).
     *
     * @param schema - The schema which is to be added to the map
     * @param hash - The hash value at which to map the schema
     */ addSchema(schema, hash) {
        const key = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$f453fd324e92d331), hash);
        const identifiedSchema = {
            ...schema,
            [(0, $cd207018ee28cb28$export$f453fd324e92d331)]: key
        };
        const existing = this.schemaMap[key];
        if (!existing) this.schemaMap[key] = identifiedSchema;
        else if (!(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(existing, identifiedSchema)) {
            // oxlint-disable-next-line no-console
            console.error('existing schema:', JSON.stringify(existing, null, 2));
            // oxlint-disable-next-line no-console
            console.error('new schema:', JSON.stringify(identifiedSchema, null, 2));
            throw new Error(`Two different schemas exist with the same key ${key}! What a bad coincidence. If possible, try adding an $id to one of the schemas`);
        }
    }
    /** Returns the current `schemaMap` to the caller
     */ getSchemaMap() {
        return this.schemaMap;
    }
    /** Implements the `ValidatorType` `isValid()` method to capture the `schema` in the `schemaMap`. Throws an error when
     * the `rootSchema` is not the same as the root schema provided during construction.
     *
     * @param schema - The schema to record in the `schemaMap`
     * @param _formData - The formData parameter that is ignored
     * @param rootSchema - The root schema associated with the schema
     * @throws - Error when the given `rootSchema` differs from the root schema provided during construction
     */ isValid(schema, _formData, rootSchema) {
        if (!(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(rootSchema, this.rootSchema)) throw new Error('Unexpectedly calling isValid() with a rootSchema that differs from the construction rootSchema');
        this.addSchema(schema, (0, $e3ea314528e97c6e$export$2e2bcd8739ae039)(schema));
        return false;
    }
    /** Implements the `ValidatorType` `rawValidation()` method to throw an error since it is never supposed to be called
     *
     * @param _schema - The schema parameter that is ignored
     * @param _formData - The formData parameter that is ignored
     */ rawValidation(_schema, _formData) {
        throw new Error('Unexpectedly calling the `rawValidation()` method during schema parsing');
    }
    /** Implements the `ValidatorType` `toErrorList()` method to throw an error since it is never supposed to be called
     *
     * @param _errorSchema - The error schema parameter that is ignored
     * @param _fieldPath - The field path parameter that is ignored
     */ toErrorList(_errorSchema, _fieldPath) {
        throw new Error('Unexpectedly calling the `toErrorList()` method during schema parsing');
    }
    /** Implements the `ValidatorType` `validateFormData()` method to throw an error since it is never supposed to be
     * called
     *
     * @param _formData - The formData parameter that is ignored
     * @param _schema - The schema parameter that is ignored
     * @param _customValidate - The customValidate parameter that is ignored
     * @param _transformErrors - The transformErrors parameter that is ignored
     * @param _uiSchema - The uiSchema parameter that is ignored
     */ validateFormData(_formData, _schema, _customValidate, _transformErrors, _uiSchema) {
        throw new Error('Unexpectedly calling the `validateFormData()` method during schema parsing');
    }
}


/** Recursive function used to parse the given `schema` belonging to the `rootSchema`. The `validator` is used to
 * capture the sub-schemas that the `isValid()` function is called with. For each schema returned by the
 * `retrieveSchemaInternal()`, the `resolveAnyOrOneOfSchemas()` function is called. For each of the schemas returned
 * from THAT call have `properties`, then each of the sub-schema property objects are then recursively parsed.
 *
 * @param validator - The `ParserValidator` implementation used to capture `isValid()` calls during parsing
 * @param recurseList - The list of schemas returned from the `retrieveSchemaInternal`, preventing infinite recursion
 * @param rootSchema - The root schema from which the schema parsing began
 * @param schema - The current schema element being parsed
 */ function $df59d02f77352561$var$parseSchema(validator, recurseList, rootSchema, schema) {
    const schemas = (0, $9f63129bef70072a$export$af6cd1140514df83)(validator, schema, rootSchema, undefined, true);
    schemas.forEach((localSchema)=>{
        const sameSchemaIndex = recurseList.findIndex((item)=>(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(item, localSchema));
        if (sameSchemaIndex === -1) {
            recurseList.push(localSchema);
            const allOptions = (0, $9f63129bef70072a$export$6f91e104388b9afc)(validator, localSchema, rootSchema, true);
            allOptions.forEach((s)=>{
                if ((0, $cd207018ee28cb28$export$dd550d4e98f939a4) in s && s[0, $cd207018ee28cb28$export$dd550d4e98f939a4]) (0, $1a51e4fa81bddb8c$export$2e2bcd8739ae039)(localSchema[0, $cd207018ee28cb28$export$dd550d4e98f939a4], (value)=>{
                    $df59d02f77352561$var$parseSchema(validator, recurseList, rootSchema, value);
                });
            });
            if ((0, $cd207018ee28cb28$export$7a3255c70c8752d5) in localSchema && !Array.isArray(localSchema.items) && typeof localSchema.items !== 'boolean') $df59d02f77352561$var$parseSchema(validator, recurseList, rootSchema, localSchema.items);
        }
    });
}
function $df59d02f77352561$export$2e2bcd8739ae039(rootSchema) {
    const validator = new (0, $f1cd08243c9ebe92$export$2e2bcd8739ae039)(rootSchema);
    const recurseList = [];
    $df59d02f77352561$var$parseSchema(validator, recurseList, rootSchema, rootSchema);
    return validator.getSchemaMap();
}









var $h4Bez = parcelRequire("h4Bez");








/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */ function $de2a4d120b14799d$var$unset(object, path) {
    return object == null ? true : (0, $a124f80e43b8a96f$export$2e2bcd8739ae039)(object, path);
}
var $de2a4d120b14799d$export$2e2bcd8739ae039 = $de2a4d120b14799d$var$unset;





var $h4Bez = parcelRequire("h4Bez");





/** Used to generate a unique ID for an element in a row */ function $4a6ee14fdc94c86f$var$generateRowId() {
    return (0, $c6ab635ea69d2b59$export$2e2bcd8739ae039)('rjsf-array-item-');
}
/** Converts the `formData` into `KeyedFormDataType` data, using the `generateRowId()` function to create the key
 *
 * @param formData - The data for the form
 * @returns - The `formData` converted into a `KeyedFormDataType` element
 */ function $4a6ee14fdc94c86f$var$generateKeyedFormData(formData) {
    return !Array.isArray(formData) ? [] : formData.map((item)=>({
            key: $4a6ee14fdc94c86f$var$generateRowId(),
            item: item
        }));
}
/** Converts `KeyedFormDataType` data into the inner `formData`
 *
 * @param keyedFormData - The `KeyedFormDataType` to be converted
 * @returns - The inner `formData` item(s) in the `keyedFormData`
 */ function $4a6ee14fdc94c86f$var$keyedToPlainFormData(keyedFormData) {
    if (Array.isArray(keyedFormData)) return keyedFormData.map((keyedItem)=>keyedItem.item);
    return [];
}
/** Determines whether the item described in the schema is always required, which is determined by whether any item
 * may be null.
 *
 * @param itemSchema - The schema for the item
 * @return - True if the item schema type does not contain the "null" type
 */ function $4a6ee14fdc94c86f$var$isItemRequired(itemSchema) {
    if (Array.isArray(itemSchema.type)) // While we don't yet support composite/nullable jsonschema types, it's
    // future-proof to check for requirement against these.
    return !itemSchema.type.includes('null');
    // All non-null array item types are inherently required by design
    return itemSchema.type !== 'null';
}
/** Determines whether more items can be added to the array. If the uiSchema indicates the array doesn't allow adding
 * then false is returned. Otherwise, if the schema indicates that there are a maximum number of items and the
 * `formData` matches that value, then false is returned, otherwise true is returned.
 *
 * @param registry - The registry
 * @param schema - The schema for the field
 * @param formItems - The list of items in the form
 * @param [uiSchema] - The UiSchema for the field
 * @returns - True if the item is addable otherwise false
 */ function $4a6ee14fdc94c86f$var$canAddItem(registry, schema, formItems, uiSchema) {
    let { addable: addable } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, registry.globalUiOptions);
    if (addable !== false) {
        // if ui:options.addable was not explicitly set to false, we can add
        // another item if we have not exceeded maxItems yet
        if (schema.maxItems !== undefined) addable = formItems.length < schema.maxItems;
        else addable = true;
    }
    return addable;
}
/** Helper method to compute item UI schema for both normal and fixed arrays
 * Handles both static object and dynamic function cases
 *
 * @param uiSchema - The parent UI schema containing items definition
 * @param item - The item data
 * @param index - The index of the item
 * @param formContext - The form context
 * @returns The computed UI schema for the item
 */ function $4a6ee14fdc94c86f$var$computeItemUiSchema(uiSchema, item, index, formContext) {
    if (typeof uiSchema.items === 'function') try {
        // Call the function with item data, index, and form context
        // TypeScript now correctly infers the types thanks to the ArrayElement type in UiSchema
        const result = uiSchema.items(item, index, formContext);
        // Only use the result if it's truthy
        return result;
    } catch (e) {
        // oxlint-disable-next-line no-console
        console.error(`Error executing dynamic uiSchema.items function for item at index ${index}:`, e);
        // Fall back to undefined to allow the field to still render
        return undefined;
    }
    else // Static object case - preserve undefined to maintain backward compatibility
    return uiSchema.items;
}
/** Returns the default form information for an item based on the schema for that item. Deals with the possibility
 * that the schema is fixed and allows additional items.
 */ function $4a6ee14fdc94c86f$var$getNewFormDataRow(registry, schema) {
    const { schemaUtils: schemaUtils, globalFormOptions: globalFormOptions } = registry;
    let itemSchema = schema.items;
    if (globalFormOptions.useFallbackUiForUnsupportedType && !itemSchema) // If we don't have itemSchema and useFallbackUiForUnsupportedType is on, use an empty schema
    itemSchema = {};
    else if ((0, $dfc36f50ea093ef6$export$2e2bcd8739ae039)(schema) && (0, $abee29945f84e72d$export$2e2bcd8739ae039)(schema)) itemSchema = schema.additionalItems;
    // Cast this as a T to work around schema utils being for T[] caused by the FieldProps<T[], S, F> call on the class
    return schemaUtils.getDefaultFormState(itemSchema);
}
/** Renders an array as a set of checkboxes using the 'select' widget
 */ function $4a6ee14fdc94c86f$var$ArrayAsMultiSelect(props) {
    const { schema: schema, fieldPathId: fieldPathId, uiSchema: uiSchema, formData: items = [], disabled: disabled = false, readonly: readonly = false, autofocus: autofocus = false, required: required = false, placeholder: placeholder, onBlur: onBlur, onFocus: onFocus, registry: registry, rawErrors: rawErrors, name: name, onSelectChange: onSelectChange } = props;
    const { widgets: widgets, schemaUtils: schemaUtils, globalFormOptions: globalFormOptions, globalUiOptions: globalUiOptions } = registry;
    const itemsSchema = schemaUtils.retrieveSchema(schema.items, items);
    // For computing `enumOptions`, fallback to the array property's uiSchema if there is no `items` schema
    // Avoids a breaking change reported in https://github.com/rjsf-team/react-jsonschema-form/issues/4985
    const itemsUiSchema = uiSchema?.items ?? uiSchema;
    const enumOptions = (0, $01e18c537fba1f55$export$2e2bcd8739ae039)(itemsSchema, itemsUiSchema);
    const { widget: widget = 'select', title: uiTitle, ...options } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, globalUiOptions);
    const Widget = (0, $73d42cea7c965d69$export$2e2bcd8739ae039)(schema, widget, widgets);
    const label = uiTitle ?? schema.title ?? name;
    const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
    // For custom widgets with multiple=true, generate a fieldPathId with isMultiValue flag
    const multiValueFieldPathId = (0, $00773362d992a2a1$export$2e2bcd8739ae039)((0, $99206247aba21705$export$2e2bcd8739ae039)('', globalFormOptions, fieldPathId, true));
    return (0, $2e41620b030ed79e$exports.jsx)(Widget, {
        id: multiValueFieldPathId[0, $cd207018ee28cb28$export$f453fd324e92d331],
        name: name,
        multiple: true,
        onChange: onSelectChange,
        onBlur: onBlur,
        onFocus: onFocus,
        options: {
            ...options,
            enumOptions: enumOptions
        },
        schema: schema,
        uiSchema: uiSchema,
        registry: registry,
        value: items,
        disabled: disabled,
        readonly: readonly,
        required: required,
        label: label,
        hideLabel: !displayLabel,
        placeholder: placeholder,
        autofocus: autofocus,
        rawErrors: rawErrors,
        htmlName: multiValueFieldPathId.name
    });
}
/** Renders an array using the custom widget provided by the user in the `uiSchema`
 */ function $4a6ee14fdc94c86f$var$ArrayAsCustomWidget(props) {
    const { schema: schema, fieldPathId: fieldPathId, uiSchema: uiSchema, disabled: disabled = false, readonly: readonly = false, autofocus: autofocus = false, required: required = false, hideError: hideError, placeholder: placeholder, onBlur: onBlur, onFocus: onFocus, formData: items = [], registry: registry, rawErrors: rawErrors, name: name, onSelectChange: onSelectChange } = props;
    const { widgets: widgets, schemaUtils: schemaUtils, globalFormOptions: globalFormOptions, globalUiOptions: globalUiOptions } = registry;
    const { widget: widget, title: uiTitle, ...options } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, globalUiOptions);
    const Widget = (0, $73d42cea7c965d69$export$2e2bcd8739ae039)(schema, widget, widgets);
    const label = uiTitle ?? schema.title ?? name;
    const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
    // For custom widgets with multiple=true, generate a fieldPathId with isMultiValue flag
    const multiValueFieldPathId = (0, $00773362d992a2a1$export$2e2bcd8739ae039)((0, $99206247aba21705$export$2e2bcd8739ae039)('', globalFormOptions, fieldPathId, true));
    return (0, $2e41620b030ed79e$exports.jsx)(Widget, {
        id: multiValueFieldPathId[0, $cd207018ee28cb28$export$f453fd324e92d331],
        name: name,
        multiple: true,
        onChange: onSelectChange,
        onBlur: onBlur,
        onFocus: onFocus,
        options: options,
        schema: schema,
        uiSchema: uiSchema,
        registry: registry,
        value: items,
        disabled: disabled,
        readonly: readonly,
        hideError: hideError,
        required: required,
        label: label,
        hideLabel: !displayLabel,
        placeholder: placeholder,
        autofocus: autofocus,
        rawErrors: rawErrors,
        htmlName: multiValueFieldPathId.name
    });
}
/** Renders an array of files using the `FileWidget`
 */ function $4a6ee14fdc94c86f$var$ArrayAsFiles(props) {
    const { schema: schema, uiSchema: uiSchema, fieldPathId: fieldPathId, name: name, disabled: disabled = false, readonly: readonly = false, autofocus: autofocus = false, required: required = false, onBlur: onBlur, onFocus: onFocus, registry: registry, formData: items = [], rawErrors: rawErrors, onSelectChange: onSelectChange } = props;
    const { widgets: widgets, schemaUtils: schemaUtils, globalFormOptions: globalFormOptions, globalUiOptions: globalUiOptions } = registry;
    const { widget: widget = 'files', title: uiTitle, ...options } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, globalUiOptions);
    const Widget = (0, $73d42cea7c965d69$export$2e2bcd8739ae039)(schema, widget, widgets);
    const label = uiTitle ?? schema.title ?? name;
    const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
    // For custom widgets with multiple=true, generate a fieldPathId with isMultiValue flag
    const multiValueFieldPathId = (0, $00773362d992a2a1$export$2e2bcd8739ae039)((0, $99206247aba21705$export$2e2bcd8739ae039)('', globalFormOptions, fieldPathId, true));
    return (0, $2e41620b030ed79e$exports.jsx)(Widget, {
        options: options,
        id: multiValueFieldPathId[0, $cd207018ee28cb28$export$f453fd324e92d331],
        name: name,
        multiple: true,
        onChange: onSelectChange,
        onBlur: onBlur,
        onFocus: onFocus,
        schema: schema,
        uiSchema: uiSchema,
        value: items,
        disabled: disabled,
        readonly: readonly,
        required: required,
        registry: registry,
        autofocus: autofocus,
        rawErrors: rawErrors,
        label: label,
        hideLabel: !displayLabel,
        htmlName: multiValueFieldPathId.name
    });
}
/** Renders the individual array item using a `SchemaField` along with the additional properties that are needed to
 * render the whole of the `ArrayFieldItemTemplate`.
 */ function $4a6ee14fdc94c86f$var$ArrayFieldItemInner(props) {
    const { itemKey: itemKey, index: index, name: name, disabled: disabled, hideError: hideError, readonly: readonly, registry: registry, uiOptions: uiOptions, parentUiSchema: parentUiSchema, canAdd: canAdd, canRemove: canRemove = true, canMoveUp: canMoveUp, canMoveDown: canMoveDown, rawItemSchema: rawItemSchema, itemData: itemData, itemUiSchema: itemUiSchema, parentFieldPathId: parentFieldPathId, itemErrorSchema: itemErrorSchema, autofocus: autofocus, onBlur: onBlur, onFocus: onFocus, onChange: onChange, rawErrors: rawErrors, totalItems: totalItems, title: title, handleAddItem: handleAddItem, handleCopyItem: handleCopyItem, handleRemoveItem: handleRemoveItem, handleReorderItems: handleReorderItems } = props;
    const { schemaUtils: schemaUtils, fields: { ArraySchemaField: ArraySchemaField, SchemaField: SchemaField }, globalUiOptions: globalUiOptions, globalFormOptions: globalFormOptions } = registry;
    const itemSchema = (0, $h4Bez.useMemo)(()=>schemaUtils.retrieveSchema(rawItemSchema, itemData), [
        schemaUtils,
        rawItemSchema,
        itemData
    ]);
    // parentFieldPathId is the same stable reference for all items; index is a stable number.
    // useMemo avoids creating a new FieldPathId object on every render, letting React.memo bail out.
    const fieldPathId = (0, $h4Bez.useMemo)(()=>(0, $99206247aba21705$export$2e2bcd8739ae039)(index, globalFormOptions, parentFieldPathId), [
        index,
        globalFormOptions,
        parentFieldPathId
    ]);
    const ItemSchemaField = ArraySchemaField || SchemaField;
    const ArrayFieldItemTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('ArrayFieldItemTemplate', registry, uiOptions);
    const displayLabel = schemaUtils.getDisplayLabel(itemSchema, itemUiSchema, globalUiOptions);
    const { description: description } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(itemUiSchema);
    const hasDescription = !!description || !!itemSchema.description;
    const { orderable: orderable = true, removable: removable = true, copyable: copyable = false } = uiOptions;
    const has = {
        moveUp: orderable && canMoveUp,
        moveDown: orderable && canMoveDown,
        copy: copyable && canAdd,
        remove: removable && canRemove,
        toolbar: false
    };
    has.toolbar = Object.keys(has).some((key)=>has[key]);
    const onAddItem = (0, $h4Bez.useCallback)((event)=>{
        handleAddItem(event, index + 1);
    }, [
        handleAddItem,
        index
    ]);
    const onCopyItem = (0, $h4Bez.useCallback)((event)=>{
        handleCopyItem(event, index);
    }, [
        handleCopyItem,
        index
    ]);
    const onRemoveItem = (0, $h4Bez.useCallback)((event)=>{
        handleRemoveItem(event, index);
    }, [
        handleRemoveItem,
        index
    ]);
    const onMoveUpItem = (0, $h4Bez.useCallback)((event)=>{
        handleReorderItems(event, index, index - 1);
    }, [
        handleReorderItems,
        index
    ]);
    const onMoveDownItem = (0, $h4Bez.useCallback)((event)=>{
        handleReorderItems(event, index, index + 1);
    }, [
        handleReorderItems,
        index
    ]);
    const templateProps = {
        children: (0, $2e41620b030ed79e$exports.jsx)(ItemSchemaField, {
            name: name,
            title: title,
            index: index,
            schema: itemSchema,
            uiSchema: itemUiSchema,
            formData: itemData,
            errorSchema: itemErrorSchema,
            fieldPathId: fieldPathId,
            required: $4a6ee14fdc94c86f$var$isItemRequired(itemSchema),
            onChange: onChange,
            onBlur: onBlur,
            onFocus: onFocus,
            registry: registry,
            disabled: disabled,
            readonly: readonly,
            hideError: hideError,
            autofocus: autofocus,
            rawErrors: rawErrors
        }),
        buttonsProps: {
            fieldPathId: fieldPathId,
            disabled: disabled,
            readonly: readonly,
            canAdd: canAdd,
            hasCopy: has.copy,
            hasMoveUp: has.moveUp,
            hasMoveDown: has.moveDown,
            hasRemove: has.remove,
            index: index,
            totalItems: totalItems,
            onAddItem: onAddItem,
            onCopyItem: onCopyItem,
            onRemoveItem: onRemoveItem,
            onMoveUpItem: onMoveUpItem,
            onMoveDownItem: onMoveDownItem,
            registry: registry,
            schema: itemSchema,
            uiSchema: itemUiSchema
        },
        itemKey: itemKey,
        className: 'rjsf-array-item',
        disabled: disabled,
        hasToolbar: has.toolbar,
        index: index,
        totalItems: totalItems,
        readonly: readonly,
        registry: registry,
        schema: itemSchema,
        uiSchema: itemUiSchema,
        parentUiSchema: parentUiSchema,
        displayLabel: displayLabel,
        hasDescription: hasDescription
    };
    return (0, $2e41620b030ed79e$exports.jsx)(ArrayFieldItemTemplate, {
        ...templateProps
    });
}
const $4a6ee14fdc94c86f$var$ArrayFieldItem = (0, $h4Bez.memo)($4a6ee14fdc94c86f$var$ArrayFieldItemInner);
/** Renders a normal array without any limitations of length
 */ function $4a6ee14fdc94c86f$var$NormalArray(props) {
    const { schema: schema, uiSchema: uiSchema = {}, errorSchema: errorSchema, fieldPathId: fieldPathId, formData: formDataFromProps, name: name, title: title, disabled: disabled = false, readonly: readonly = false, autofocus: autofocus = false, required: required = false, hideError: hideError = false, registry: registry, onBlur: onBlur, onFocus: onFocus, rawErrors: rawErrors, onChange: onChange, keyedFormData: keyedFormData, handleAddItem: handleAddItem, handleCopyItem: handleCopyItem, handleRemoveItem: handleRemoveItem, handleReorderItems: handleReorderItems } = props;
    const fieldTitle = schema.title || title || name;
    const { schemaUtils: schemaUtils, fields: fields, formContext: formContext, globalUiOptions: globalUiOptions } = registry;
    const { OptionalDataControlsField: OptionalDataControlsField } = fields;
    const uiOptions = (0, $h4Bez.useMemo)(()=>(0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, globalUiOptions), [
        uiSchema,
        globalUiOptions
    ]);
    // Memoize schemaItems to avoid a new `{}` object identity on every render (which would bust retrieveSchema cache)
    const schemaItems = (0, $h4Bez.useMemo)(()=>(0, $d252d56fd76f41df$export$2e2bcd8739ae039)(schema.items) ? schema.items : {}, [
        schema.items
    ]);
    const itemsSchema = (0, $h4Bez.useMemo)(()=>schemaUtils.retrieveSchema(schemaItems), [
        schemaUtils,
        schemaItems
    ]);
    const formData = (0, $h4Bez.useMemo)(()=>$4a6ee14fdc94c86f$var$keyedToPlainFormData(keyedFormData), [
        keyedFormData
    ]);
    const renderOptionalField = (0, $87b2dc06d3aae4d2$export$2e2bcd8739ae039)(registry, schema, required, uiSchema);
    const hasFormData = (0, $8df99a86d43a2e45$export$2e2bcd8739ae039)(formDataFromProps);
    const canAdd = (0, $h4Bez.useMemo)(()=>$4a6ee14fdc94c86f$var$canAddItem(registry, schema, formData, uiSchema) && (!renderOptionalField || hasFormData), [
        registry,
        schema,
        formData,
        uiSchema,
        renderOptionalField,
        hasFormData
    ]);
    const actualFormData = hasFormData ? keyedFormData : [];
    const extraClass = renderOptionalField ? ' rjsf-optional-array-field' : '';
    // All the children will use childFieldPathId if present in the props, falling back to the fieldPathId
    const childFieldPathId = props.childFieldPathId ?? fieldPathId;
    const optionalDataControl = renderOptionalField ? (0, $2e41620b030ed79e$exports.jsx)(OptionalDataControlsField, {
        ...props,
        fieldPathId: childFieldPathId
    }) : undefined;
    const arrayProps = {
        canAdd: canAdd,
        items: actualFormData.map((keyedItem, index)=>{
            const { key: key, item: item } = keyedItem;
            // While we are actually dealing with a single item of type T, the types require a T[], so cast
            const itemCast = item;
            const itemErrorSchema = errorSchema ? errorSchema[index] : undefined;
            // Compute the item UI schema using the helper method
            const itemUiSchema = $4a6ee14fdc94c86f$var$computeItemUiSchema(uiSchema, item, index, formContext);
            const itemProps = {
                itemKey: key,
                index: index,
                name: name && `${name}-${index}`,
                registry: registry,
                uiOptions: uiOptions,
                parentUiSchema: uiSchema,
                hideError: hideError,
                readonly: readonly,
                disabled: disabled,
                required: required,
                title: fieldTitle ? `${fieldTitle}-${index + 1}` : undefined,
                canAdd: canAdd,
                canMoveUp: index > 0,
                canMoveDown: index < formData.length - 1,
                rawItemSchema: schemaItems,
                parentFieldPathId: childFieldPathId,
                itemErrorSchema: itemErrorSchema,
                itemData: itemCast,
                itemUiSchema: itemUiSchema,
                autofocus: autofocus && index === 0,
                onBlur: onBlur,
                onFocus: onFocus,
                rawErrors: rawErrors,
                totalItems: keyedFormData.length,
                handleAddItem: handleAddItem,
                handleCopyItem: handleCopyItem,
                handleRemoveItem: handleRemoveItem,
                handleReorderItems: handleReorderItems,
                onChange: onChange
            };
            return (0, $2e41620b030ed79e$exports.jsx)($4a6ee14fdc94c86f$var$ArrayFieldItem, {
                ...itemProps
            }, key);
        }),
        className: `rjsf-field rjsf-field-array rjsf-field-array-of-${itemsSchema.type}${extraClass}`,
        disabled: disabled,
        fieldPathId: fieldPathId,
        uiSchema: uiSchema,
        onAddClick: handleAddItem,
        readonly: readonly,
        required: required,
        schema: schema,
        title: fieldTitle,
        formData: formData,
        rawErrors: rawErrors,
        registry: registry,
        optionalDataControl: optionalDataControl
    };
    const Template = (0, $f037e3283241319d$export$2e2bcd8739ae039)('ArrayFieldTemplate', registry, uiOptions);
    return (0, $2e41620b030ed79e$exports.jsx)(Template, {
        ...arrayProps
    });
}
/** Renders an array that has a maximum limit of items
 */ function $4a6ee14fdc94c86f$var$FixedArray(props) {
    const { schema: schema, uiSchema: uiSchema = {}, formData: formData, errorSchema: errorSchema, fieldPathId: fieldPathId, name: name, title: title, disabled: disabled = false, readonly: readonly = false, autofocus: autofocus = false, required: required = false, hideError: hideError = false, registry: registry, onBlur: onBlur, onFocus: onFocus, rawErrors: rawErrors, keyedFormData: keyedFormData, onChange: onChange, handleAddItem: handleAddItem, handleCopyItem: handleCopyItem, handleRemoveItem: handleRemoveItem, handleReorderItems: handleReorderItems } = props;
    let { formData: items = [] } = props;
    const fieldTitle = schema.title || title || name;
    const { fields: fields, formContext: formContext, globalUiOptions: globalUiOptions } = registry;
    const uiOptions = (0, $h4Bez.useMemo)(()=>(0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, globalUiOptions), [
        uiSchema,
        globalUiOptions
    ]);
    const { OptionalDataControlsField: OptionalDataControlsField } = fields;
    const renderOptionalField = (0, $87b2dc06d3aae4d2$export$2e2bcd8739ae039)(registry, schema, required, uiSchema);
    const hasFormData = (0, $8df99a86d43a2e45$export$2e2bcd8739ae039)(formData);
    const schemaItems = (0, $h4Bez.useMemo)(()=>(0, $d252d56fd76f41df$export$2e2bcd8739ae039)(schema.items) ? schema.items : [], [
        schema.items
    ]);
    const hasAdditionalItems = (0, $d252d56fd76f41df$export$2e2bcd8739ae039)(schema.additionalItems);
    // All the children will use childFieldPathId if present in the props, falling back to the fieldPathId
    const childFieldPathId = props.childFieldPathId ?? fieldPathId;
    if (items.length < schemaItems.length) // to make sure at least all fixed items are generated
    items = items.concat(new Array(schemaItems.length - items.length));
    const actualFormData = hasFormData ? keyedFormData : [];
    const extraClass = renderOptionalField ? ' rjsf-optional-array-field' : '';
    const optionalDataControl = renderOptionalField ? (0, $2e41620b030ed79e$exports.jsx)(OptionalDataControlsField, {
        ...props,
        fieldPathId: childFieldPathId
    }) : undefined;
    // These are the props passed into the render function
    const canAdd = $4a6ee14fdc94c86f$var$canAddItem(registry, schema, items, uiSchema) && hasAdditionalItems && (!renderOptionalField || hasFormData);
    const arrayProps = {
        canAdd: canAdd,
        className: `rjsf-field rjsf-field-array rjsf-field-array-fixed-items${extraClass}`,
        disabled: disabled,
        fieldPathId: fieldPathId,
        formData: formData,
        items: actualFormData.map((keyedItem, index)=>{
            const { key: key, item: item } = keyedItem;
            // While we are actually dealing with a single item of type T, the types require a T[], so cast
            const itemCast = item;
            const additional = index >= schemaItems.length;
            const rawItemSchema = (additional && (0, $d252d56fd76f41df$export$2e2bcd8739ae039)(schema.additionalItems) ? schema.additionalItems : schemaItems[index]) || {};
            // Compute the item UI schema - handle both static and dynamic cases
            let itemUiSchema;
            if (additional) // For additional items, use additionalItems uiSchema
            itemUiSchema = uiSchema.additionalItems;
            else if (Array.isArray(uiSchema.items)) // For fixed items, uiSchema.items can be an array, a function, or a single object
            itemUiSchema = uiSchema.items[index];
            else // Use the helper method for function or static object cases
            itemUiSchema = $4a6ee14fdc94c86f$var$computeItemUiSchema(uiSchema, item, index, formContext);
            const itemErrorSchema = errorSchema ? errorSchema[index] : undefined;
            const itemProps = {
                index: index,
                itemKey: key,
                name: name && `${name}-${index}`,
                registry: registry,
                uiOptions: uiOptions,
                parentUiSchema: uiSchema,
                hideError: hideError,
                readonly: readonly,
                disabled: disabled,
                required: required,
                title: fieldTitle ? `${fieldTitle}-${index + 1}` : undefined,
                canAdd: canAdd,
                canRemove: additional,
                canMoveUp: index >= schemaItems.length + 1,
                canMoveDown: additional && index < items.length - 1,
                rawItemSchema: rawItemSchema,
                itemData: itemCast,
                itemUiSchema: itemUiSchema,
                parentFieldPathId: childFieldPathId,
                itemErrorSchema: itemErrorSchema,
                autofocus: autofocus && index === 0,
                onBlur: onBlur,
                onFocus: onFocus,
                rawErrors: rawErrors,
                totalItems: keyedFormData.length,
                onChange: onChange,
                handleAddItem: handleAddItem,
                handleCopyItem: handleCopyItem,
                handleRemoveItem: handleRemoveItem,
                handleReorderItems: handleReorderItems
            };
            return (0, $2e41620b030ed79e$exports.jsx)($4a6ee14fdc94c86f$var$ArrayFieldItem, {
                ...itemProps
            }, key);
        }),
        onAddClick: handleAddItem,
        readonly: readonly,
        required: required,
        registry: registry,
        schema: schema,
        uiSchema: uiSchema,
        title: fieldTitle,
        errorSchema: errorSchema,
        rawErrors: rawErrors,
        optionalDataControl: optionalDataControl
    };
    const Template = (0, $f037e3283241319d$export$2e2bcd8739ae039)('ArrayFieldTemplate', registry, uiOptions);
    return (0, $2e41620b030ed79e$exports.jsx)(Template, {
        ...arrayProps
    });
}
/** A custom hook that handles the updating of the keyedFormData from an external `formData` change as well as
 * internally by the `ArrayField`. If there was an external `formData` change, then the `keyedFormData` is recomputed
 * in order to preserve the unique keys from the old `keyedFormData` to the new `formData`. Along with the
 * `keyedFormData` this hook also returns an `updateKeyedFormData()` function for use by the `ArrayField`. The detection
 * of external `formData` are handled by storing the hash of that `formData` along with the `keyedFormData` associated
 * with it. The `updateKeyedFormData()` will update that hash whenever the `keyedFormData` is modified and as well as
 * returning the plain `formData` from the `keyedFormData`.
 */ function $4a6ee14fdc94c86f$var$useKeyedFormData(formData = []) {
    const newHash = (0, $h4Bez.useMemo)(()=>(0, $e3ea314528e97c6e$export$3477f9615e12f61d)(formData), [
        formData
    ]);
    const [state, setState] = (0, $h4Bez.useState)(()=>({
            formDataHash: newHash,
            keyedFormData: $4a6ee14fdc94c86f$var$generateKeyedFormData(formData)
        }));
    let { keyedFormData: keyedFormData, formDataHash: formDataHash } = state;
    if (newHash !== formDataHash) {
        const nextFormData = Array.isArray(formData) ? formData : [];
        const previousKeyedFormData = keyedFormData || [];
        keyedFormData = nextFormData.length === previousKeyedFormData.length ? previousKeyedFormData.map((previousKeyedFormDatum, index)=>({
                key: previousKeyedFormDatum.key,
                item: nextFormData[index]
            })) : $4a6ee14fdc94c86f$var$generateKeyedFormData(nextFormData);
        formDataHash = newHash;
        setState({
            formDataHash: formDataHash,
            keyedFormData: keyedFormData
        });
    }
    const updateKeyedFormData = (0, $h4Bez.useCallback)((newData)=>{
        const plainFormData = $4a6ee14fdc94c86f$var$keyedToPlainFormData(newData);
        const updatedHash = (0, $e3ea314528e97c6e$export$3477f9615e12f61d)(plainFormData);
        setState({
            formDataHash: updatedHash,
            keyedFormData: newData
        });
        return plainFormData;
    }, []);
    return {
        keyedFormData: keyedFormData,
        updateKeyedFormData: updateKeyedFormData
    };
}
function $4a6ee14fdc94c86f$export$2e2bcd8739ae039(props) {
    const { schema: schema, uiSchema: uiSchema, errorSchema: errorSchema, fieldPathId: fieldPathId, registry: registry, formData: formData, onChange: onChange } = props;
    const { globalFormOptions: globalFormOptions, schemaUtils: schemaUtils, translateString: translateString } = registry;
    const { keyedFormData: keyedFormData, updateKeyedFormData: updateKeyedFormData } = $4a6ee14fdc94c86f$var$useKeyedFormData(formData);
    // Refs keep the latest values accessible inside stable useCallback closures without being in the dep array,
    // so the four mutation handlers don't get new references on every keyedFormData / errorSchema change.
    const keyedFormDataRef = (0, $h4Bez.useRef)(keyedFormData);
    keyedFormDataRef.current = keyedFormData;
    const errorSchemaRef = (0, $h4Bez.useRef)(errorSchema);
    errorSchemaRef.current = errorSchema;
    // All the children will use childFieldPathId if present in the props, falling back to the fieldPathId
    const childFieldPathId = props.childFieldPathId ?? fieldPathId;
    /** Callback handler for when the user clicks on the add or add at index buttons. Creates a new row of keyed form data
     * either at the end of the list (when index is not specified) or inserted at the `index` when it is, adding it into
     * the state, and then returning `onChange()` with the plain form data converted from the keyed data
     *
     * @param event - The event for the click
     * @param [index] - The optional index at which to add the new data
     */ const handleAddItem = (0, $h4Bez.useCallback)((event, index)=>{
        if (event) event.preventDefault();
        let newErrorSchema;
        if (errorSchemaRef.current) {
            newErrorSchema = {};
            for (const idx of Object.keys(errorSchemaRef.current)){
                const i = parseInt(idx, 10);
                if (index === undefined || i < index) (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(newErrorSchema, [
                    i
                ], errorSchemaRef.current[i]);
                else if (i >= index) (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(newErrorSchema, [
                    i + 1
                ], errorSchemaRef.current[i]);
            }
        }
        const newKeyedFormDataRow = {
            key: $4a6ee14fdc94c86f$var$generateRowId(),
            item: $4a6ee14fdc94c86f$var$getNewFormDataRow(registry, schema)
        };
        const newKeyedFormData = [
            ...keyedFormDataRef.current
        ];
        if (index !== undefined) newKeyedFormData.splice(index, 0, newKeyedFormDataRow);
        else newKeyedFormData.push(newKeyedFormDataRow);
        onChange(updateKeyedFormData(newKeyedFormData), childFieldPathId.path, newErrorSchema);
    }, [
        registry,
        schema,
        onChange,
        updateKeyedFormData,
        childFieldPathId
    ]);
    /** Callback handler for when the user clicks on the copy button on an existing array element. Clones the row of
     * keyed form data at the `index` into the next position in the state, and then returning `onChange()` with the plain
     * form data converted from the keyed data
     *
     * @param index - The index at which the copy button is clicked
     */ const handleCopyItem = (0, $h4Bez.useCallback)((event, index)=>{
        if (event) event.preventDefault();
        let newErrorSchema;
        if (errorSchemaRef.current) {
            newErrorSchema = {};
            for (const idx of Object.keys(errorSchemaRef.current)){
                const i = parseInt(idx, 10);
                if (i <= index) (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(newErrorSchema, [
                    i
                ], errorSchemaRef.current[i]);
                else if (i > index) (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(newErrorSchema, [
                    i + 1
                ], errorSchemaRef.current[i]);
            }
        }
        const newKeyedFormDataRow = {
            key: $4a6ee14fdc94c86f$var$generateRowId(),
            item: (0, $7e874283d83390fb$export$2e2bcd8739ae039)(keyedFormDataRef.current[index].item)
        };
        const newKeyedFormData = [
            ...keyedFormDataRef.current
        ];
        if (index !== undefined) newKeyedFormData.splice(index + 1, 0, newKeyedFormDataRow);
        else newKeyedFormData.push(newKeyedFormDataRow);
        onChange(updateKeyedFormData(newKeyedFormData), childFieldPathId.path, newErrorSchema);
    }, [
        onChange,
        updateKeyedFormData,
        childFieldPathId
    ]);
    /** Callback handler for when the user clicks on the remove button on an existing array element. Removes the row of
     * keyed form data at the `index` in the state, and then returning `onChange()` with the plain form data converted
     * from the keyed data
     *
     * @param index - The index at which the remove button is clicked
     */ const handleRemoveItem = (0, $h4Bez.useCallback)((event, index)=>{
        if (event) event.preventDefault();
        // refs #195: revalidate to ensure properly reindexing errors
        let newErrorSchema;
        if (errorSchemaRef.current) {
            newErrorSchema = {};
            for (const idx of Object.keys(errorSchemaRef.current)){
                const i = parseInt(idx, 10);
                if (i < index) (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(newErrorSchema, [
                    i
                ], errorSchemaRef.current[i]);
                else if (i > index) (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(newErrorSchema, [
                    i - 1
                ], errorSchemaRef.current[i]);
            }
        }
        const newKeyedFormData = keyedFormDataRef.current.filter((_, i)=>i !== index);
        onChange(updateKeyedFormData(newKeyedFormData), childFieldPathId.path, newErrorSchema);
    }, [
        onChange,
        updateKeyedFormData,
        childFieldPathId
    ]);
    /** Callback handler for when the user clicks on one of the move item buttons on an existing array element. Moves the
     * row of keyed form data at the `index` to the `newIndex` in the state, and then returning `onChange()` with the
     * plain form data converted from the keyed data
     *
     * @param index - The index of the item to move
     * @param newIndex - The index to where the item is to be moved
     */ const handleReorderItems = (0, $h4Bez.useCallback)((event, index, newIndex)=>{
        if (event) {
            event.preventDefault();
            event.currentTarget.blur();
        }
        let newErrorSchema;
        if (errorSchemaRef.current) {
            newErrorSchema = {};
            for (const idx of Object.keys(errorSchemaRef.current)){
                const i = parseInt(idx, 10);
                if (i === index) (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(newErrorSchema, [
                    newIndex
                ], errorSchemaRef.current[index]);
                else if (i === newIndex) (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(newErrorSchema, [
                    index
                ], errorSchemaRef.current[newIndex]);
                else (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(newErrorSchema, [
                    idx
                ], errorSchemaRef.current[i]);
            }
        }
        function reOrderArray() {
            const newKeyedFormData = keyedFormDataRef.current.slice();
            newKeyedFormData.splice(index, 1);
            newKeyedFormData.splice(newIndex, 0, keyedFormDataRef.current[index]);
            return newKeyedFormData;
        }
        const newKeyedFormData = reOrderArray();
        onChange(updateKeyedFormData(newKeyedFormData), childFieldPathId.path, newErrorSchema);
    }, [
        onChange,
        updateKeyedFormData,
        childFieldPathId
    ]);
    /** Callback handler used to deal with changing the value of the data in the array at the `index`. Calls the
     * `onChange` callback with the updated form data
     *
     * @param index - The index of the item being changed
     */ const handleChange = (0, $h4Bez.useCallback)((value, path, newErrorSchema, id)=>{
        const lastPathIsItemIndex = typeof path.at(-1) === 'number';
        onChange(// We need to treat undefined items as nulls to have validation.
        // See https://github.com/tdegrunt/jsonschema/issues/206
        // Only set to null for array items, and not for object properties within array items
        lastPathIsItemIndex && value === undefined ? null : value, path, newErrorSchema, id);
    }, [
        onChange
    ]);
    /** Callback handler used to change the value for a checkbox */ const onSelectChange = (0, $h4Bez.useCallback)((value)=>{
        onChange(value, childFieldPathId.path, undefined, childFieldPathId?.[0, $cd207018ee28cb28$export$f453fd324e92d331]);
    }, [
        onChange,
        childFieldPathId
    ]);
    const arrayAsMultiProps = {
        ...props,
        formData: formData,
        fieldPathId: childFieldPathId,
        onSelectChange: onSelectChange
    };
    const arrayProps = {
        ...props,
        handleAddItem: handleAddItem,
        handleCopyItem: handleCopyItem,
        handleRemoveItem: handleRemoveItem,
        handleReorderItems: handleReorderItems,
        keyedFormData: keyedFormData,
        onChange: handleChange
    };
    if (!((0, $cd207018ee28cb28$export$7a3255c70c8752d5) in schema)) {
        if (!globalFormOptions.useFallbackUiForUnsupportedType) {
            const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
            const UnsupportedFieldTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('UnsupportedFieldTemplate', registry, uiOptions);
            return (0, $2e41620b030ed79e$exports.jsx)(UnsupportedFieldTemplate, {
                schema: schema,
                fieldPathId: fieldPathId,
                reason: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).MissingItems),
                registry: registry
            });
        }
        // Add an items schema with type as undefined so it triggers FallbackField later on
        const fallbackSchema = {
            ...schema,
            [(0, $cd207018ee28cb28$export$7a3255c70c8752d5)]: {
                type: undefined
            }
        };
        arrayAsMultiProps.schema = fallbackSchema;
        arrayProps.schema = fallbackSchema;
    }
    if (schemaUtils.isMultiSelect(arrayAsMultiProps.schema)) // If array has enum or uniqueItems set to true, call renderMultiSelect() to render the default multiselect widget or a custom widget, if specified.
    return (0, $2e41620b030ed79e$exports.jsx)($4a6ee14fdc94c86f$var$ArrayAsMultiSelect, {
        ...arrayAsMultiProps
    });
    if ((0, $2078450ae8c93797$export$2e2bcd8739ae039)(uiSchema)) return (0, $2e41620b030ed79e$exports.jsx)($4a6ee14fdc94c86f$var$ArrayAsCustomWidget, {
        ...arrayAsMultiProps
    });
    if ((0, $dfc36f50ea093ef6$export$2e2bcd8739ae039)(arrayAsMultiProps.schema)) return (0, $2e41620b030ed79e$exports.jsx)($4a6ee14fdc94c86f$var$FixedArray, {
        ...arrayProps
    });
    if (schemaUtils.isFilesArray(arrayAsMultiProps.schema, uiSchema)) return (0, $2e41620b030ed79e$exports.jsx)($4a6ee14fdc94c86f$var$ArrayAsFiles, {
        ...arrayAsMultiProps
    });
    return (0, $2e41620b030ed79e$exports.jsx)($4a6ee14fdc94c86f$var$NormalArray, {
        ...arrayProps
    });
}




var $h4Bez = parcelRequire("h4Bez");


/** The `BooleanField` component is used to render a field in the schema is boolean. It constructs `enumOptions` for the
 * two boolean values based on the various alternatives in the schema.
 *
 * @param props - The `FieldProps` for this template
 */ function $2ac93ad779ac971a$var$BooleanField(props) {
    const { schema: schema, name: name, uiSchema: uiSchema, fieldPathId: fieldPathId, formData: formData, registry: registry, required: required, disabled: disabled, readonly: readonly, hideError: hideError, autofocus: autofocus, title: title, onChange: onChange, onFocus: onFocus, onBlur: onBlur, rawErrors: rawErrors } = props;
    const { title: schemaTitle } = schema;
    const { widgets: widgets, translateString: translateString, globalUiOptions: globalUiOptions } = registry;
    const { widget: widget = 'checkbox', title: uiTitle, // Unlike the other fields, don't use `getDisplayLabel()` since it always returns false for the boolean type
    label: displayLabel = true, enumNames: enumNames, ...options } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, globalUiOptions);
    const Widget = (0, $73d42cea7c965d69$export$2e2bcd8739ae039)(schema, widget, widgets);
    const yes = translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).YesLabel);
    const no = translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).NoLabel);
    let enumOptions;
    const label = uiTitle ?? schemaTitle ?? title ?? name;
    if (Array.isArray(schema.oneOf)) enumOptions = (0, $01e18c537fba1f55$export$2e2bcd8739ae039)({
        oneOf: schema.oneOf.map((option)=>{
            if ((0, $d252d56fd76f41df$export$2e2bcd8739ae039)(option)) return {
                ...option,
                title: option.title || (option.const === true ? yes : no)
            };
            return undefined;
        }).filter((o)=>o)
    }, uiSchema);
    else {
        const enums = schema.enum ?? [
            true,
            false
        ];
        if (!enumNames && enums.length === 2 && enums.every((v)=>typeof v === 'boolean')) enumOptions = [
            {
                value: enums[0],
                label: enums[0] ? yes : no
            },
            {
                value: enums[1],
                label: enums[1] ? yes : no
            }
        ];
        else enumOptions = (0, $01e18c537fba1f55$export$2e2bcd8739ae039)({
            enum: enums
        }, uiSchema);
    }
    const onWidgetChange = (0, $h4Bez.useCallback)((value, errorSchema, id)=>onChange(value, fieldPathId.path, errorSchema, id), [
        onChange,
        fieldPathId
    ]);
    return (0, $2e41620b030ed79e$exports.jsx)(Widget, {
        options: {
            ...options,
            enumOptions: enumOptions
        },
        schema: schema,
        uiSchema: uiSchema,
        id: fieldPathId.$id,
        name: name,
        onChange: onWidgetChange,
        onFocus: onFocus,
        onBlur: onBlur,
        label: label,
        hideLabel: !displayLabel,
        value: formData,
        required: required,
        disabled: disabled,
        readonly: readonly,
        hideError: hideError,
        registry: registry,
        autofocus: autofocus,
        rawErrors: rawErrors,
        htmlName: fieldPathId.name
    });
}
var $2ac93ad779ac971a$export$2e2bcd8739ae039 = $2ac93ad779ac971a$var$BooleanField;




var $h4Bez = parcelRequire("h4Bez");

/**
 * Get the schema for the type selection component.
 * @param title - The translated title for the type selection schema.
 */ function $22e0d29b0a3403fd$var$getFallbackTypeSelectionSchema(title) {
    return {
        type: 'string',
        enum: [
            'string',
            'number',
            'boolean',
            'object',
            'array'
        ],
        default: 'string',
        title: title
    };
}
/**
 * Determines the JSON Schema type of the given formData.
 * @param formData - The form data whose type is to be determined.
 */ function $22e0d29b0a3403fd$var$getTypeOfFormData(formData) {
    const dataType = typeof formData;
    if (dataType === 'string' || dataType === 'number' || dataType === 'boolean') return dataType;
    if (dataType === 'object') return Array.isArray(formData) ? 'array' : 'object';
    // Treat everything else as a string
    return 'string';
}
/**
 * Casts the given formData to the specified type.
 * @param formData - The form data to be casted.
 * @param newType - The target type to which the form data should be casted.
 */ function $22e0d29b0a3403fd$var$castToNewType(formData, newType) {
    switch(newType){
        case 'string':
            return String(formData);
        case 'number':
            {
                const castedNumber = Number(formData);
                return Number.isNaN(castedNumber) ? 0 : castedNumber;
            }
        case 'boolean':
            return Boolean(formData);
        default:
            return formData;
    }
}
function $22e0d29b0a3403fd$export$2e2bcd8739ae039(props) {
    const { id: id, formData: formData, displayLabel: displayLabel = true, schema: schema, name: name, uiSchema: uiSchema, required: required, disabled: disabled = false, readonly: readonly = false, onBlur: onBlur, onFocus: onFocus, registry: registry, fieldPathId: fieldPathId, onChange: onChange, errorSchema: errorSchema } = props;
    const { translateString: translateString, fields: fields, globalFormOptions: globalFormOptions } = registry;
    const [type, setType] = (0, $h4Bez.useState)($22e0d29b0a3403fd$var$getTypeOfFormData(formData));
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const typeSelectorInnerFieldPathId = (0, $00773362d992a2a1$export$2e2bcd8739ae039)((0, $99206247aba21705$export$2e2bcd8739ae039)('__internal_type_selector', globalFormOptions, fieldPathId));
    const schemaTitle = translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).Type);
    const typesOptionSchema = (0, $h4Bez.useMemo)(()=>$22e0d29b0a3403fd$var$getFallbackTypeSelectionSchema(schemaTitle), [
        schemaTitle
    ]);
    const onTypeChange = (newType)=>{
        if (newType != null) {
            setType(newType);
            onChange($22e0d29b0a3403fd$var$castToNewType(formData, newType), fieldPathId.path, errorSchema, id);
        }
    };
    if (!globalFormOptions.useFallbackUiForUnsupportedType) {
        const { reason: reason = translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).UnknownFieldType, [
            String(schema.type)
        ]) } = props;
        const UnsupportedFieldTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('UnsupportedFieldTemplate', registry, uiOptions);
        return (0, $2e41620b030ed79e$exports.jsx)(UnsupportedFieldTemplate, {
            schema: schema,
            fieldPathId: fieldPathId,
            reason: reason,
            registry: registry
        });
    }
    const FallbackFieldTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('FallbackFieldTemplate', registry, uiOptions);
    const { SchemaField: SchemaField } = fields;
    return (0, $2e41620b030ed79e$exports.jsx)(FallbackFieldTemplate, {
        schema: schema,
        registry: registry,
        typeSelector: (0, $2e41620b030ed79e$exports.jsx)(SchemaField, {
            fieldPathId: typeSelectorInnerFieldPathId,
            name: `${name}__fallback_type`,
            schema: typesOptionSchema,
            formData: type,
            onChange: onTypeChange,
            onBlur: onBlur,
            onFocus: onFocus,
            registry: registry,
            hideLabel: !displayLabel,
            disabled: disabled,
            readonly: readonly,
            required: required
        }, formData ? (0, $e3ea314528e97c6e$export$3477f9615e12f61d)(formData) : '__empty__'),
        schemaField: (0, $2e41620b030ed79e$exports.jsx)(SchemaField, {
            ...props,
            schema: {
                type: type,
                title: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).Value),
                ...type === 'object' && {
                    additionalProperties: true
                }
            }
        })
    });
}



var $h4Bez = parcelRequire("h4Bez");











/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $7846524d39741ab6$var$baseValues(object, props) {
    return (0, $a8b30b77f2b6a1c4$export$2e2bcd8739ae039)(props, function(key) {
        return object[key];
    });
}
var $7846524d39741ab6$export$2e2bcd8739ae039 = $7846524d39741ab6$var$baseValues;



/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $25466a1eb4f32364$var$values(object) {
    return object == null ? [] : (0, $7846524d39741ab6$export$2e2bcd8739ae039)(object, (0, $39f39242faed4588$export$2e2bcd8739ae039)(object));
}
var $25466a1eb4f32364$export$2e2bcd8739ae039 = $25466a1eb4f32364$var$values;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $ec4aa1adf1f49a6c$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $ec4aa1adf1f49a6c$var$includes(collection, value, fromIndex, guard) {
    collection = (0, $baeea2f3638e715c$export$2e2bcd8739ae039)(collection) ? collection : (0, $25466a1eb4f32364$export$2e2bcd8739ae039)(collection);
    fromIndex = fromIndex && !guard ? (0, $29bba4b1e2a20523$export$2e2bcd8739ae039)(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $ec4aa1adf1f49a6c$var$nativeMax(length + fromIndex, 0);
    return (0, $e6fe0b0844d2a1c4$export$2e2bcd8739ae039)(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && (0, $64f5709d1e6fbd8c$export$2e2bcd8739ae039)(collection, value, fromIndex) > -1;
}
var $ec4aa1adf1f49a6c$export$2e2bcd8739ae039 = $ec4aa1adf1f49a6c$var$includes;









/* Built-in method references for those with the same name as other `lodash` methods. */ var $0a8c7ddfffa679e0$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $0a8c7ddfffa679e0$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? (0, $2f5198bd8bb7a519$export$2e2bcd8739ae039) : (0, $5c89fabc27f935b9$export$2e2bcd8739ae039), length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = (0, $a8b30b77f2b6a1c4$export$2e2bcd8739ae039)(array, (0, $b5e34b5af2871f86$export$2e2bcd8739ae039)(iteratee));
        maxLength = $0a8c7ddfffa679e0$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new (0, $ab54149517cb0b02$export$2e2bcd8739ae039)(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? (0, $f4852737a03c39ca$export$2e2bcd8739ae039)(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? (0, $f4852737a03c39ca$export$2e2bcd8739ae039)(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
var $0a8c7ddfffa679e0$export$2e2bcd8739ae039 = $0a8c7ddfffa679e0$var$baseIntersection;




/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $e307928544658a16$var$castArrayLikeObject(value) {
    return (0, $1d95c744ae2c26f0$export$2e2bcd8739ae039)(value) ? value : [];
}
var $e307928544658a16$export$2e2bcd8739ae039 = $e307928544658a16$var$castArrayLikeObject;


/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $1a83449a20fb6574$var$intersection = (0, $d3bee9049ca44be7$export$2e2bcd8739ae039)(function(arrays) {
    var mapped = (0, $a8b30b77f2b6a1c4$export$2e2bcd8739ae039)(arrays, (0, $e307928544658a16$export$2e2bcd8739ae039));
    return mapped.length && mapped[0] === arrays[0] ? (0, $0a8c7ddfffa679e0$export$2e2bcd8739ae039)(mapped) : [];
});
var $1a83449a20fb6574$export$2e2bcd8739ae039 = $1a83449a20fb6574$var$intersection;




/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $0f0a19fe76e11216$var$isEqual(value, other) {
    return (0, $7b155f1420b50f4a$export$2e2bcd8739ae039)(value, other);
}
var $0f0a19fe76e11216$export$2e2bcd8739ae039 = $0f0a19fe76e11216$var$isEqual;






/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $ba9e9f33b9a4d5a4$var$isUndefined(value) {
    return value === undefined;
}
var $ba9e9f33b9a4d5a4$export$2e2bcd8739ae039 = $ba9e9f33b9a4d5a4$var$isUndefined;




var $d7de6601dcd2dd2a$export$7a08e7f3b8ad12d8;
(function(GridType) {
    GridType["ROW"] = "ui:row";
    GridType["COLUMN"] = "ui:col";
    GridType["COLUMNS"] = "ui:columns";
    GridType["CONDITION"] = "ui:condition";
})($d7de6601dcd2dd2a$export$7a08e7f3b8ad12d8 || ($d7de6601dcd2dd2a$export$7a08e7f3b8ad12d8 = {}));
var $d7de6601dcd2dd2a$export$7fa100a28fbb5fe2;
(function(Operators) {
    Operators["ALL"] = "all";
    Operators["SOME"] = "some";
    Operators["NONE"] = "none";
})($d7de6601dcd2dd2a$export$7fa100a28fbb5fe2 || ($d7de6601dcd2dd2a$export$7fa100a28fbb5fe2 = {}));
const $d7de6601dcd2dd2a$export$c98ab8a721726884 = /^\$lookup=(.+)/;
const $d7de6601dcd2dd2a$export$93a5e8b801c11b44 = 'layoutGrid';
const $d7de6601dcd2dd2a$export$fc0b9c7939cd2c83 = `ui:${$d7de6601dcd2dd2a$export$93a5e8b801c11b44}`;
/** Returns either the `value` if it is non-nullish or the fallback
 *
 * @param [value] - The potential value to return if it is non-nullish
 * @param [fallback] - The fallback value to return if `value` is nullish
 * @returns - `value` if it is non-nullish otherwise `fallback`
 */ function $d7de6601dcd2dd2a$var$getNonNullishValue(value, fallback) {
    return value ?? fallback;
}
/** Detects if a `str` is made up entirely of numeric characters
 *
 * @param str - The string to check to see if it is a numeric index
 * @return - True if the string consists entirely of numeric characters
 */ function $d7de6601dcd2dd2a$var$isNumericIndex(str) {
    return /^\d+?$/.test(str); // Matches positive integers
}
const $d7de6601dcd2dd2a$var$LAYOUT_GRID_FIELD_TEST_IDS = (0, $55a2cf4e1bd3cf35$export$2e2bcd8739ae039)();
function $d7de6601dcd2dd2a$export$7db9ef730b950ba7(field, uiProps, uiSchema, schemaReadonly, forceReadonly) {
    const globalUiOptions = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(uiSchema, [
        (0, $cd207018ee28cb28$export$c777bab3d600699)
    ], {});
    const localUiSchema = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(uiSchema, field);
    const localUiOptions = {
        ...(0, $547524a1010b9f1e$export$2e2bcd8739ae039)(localUiSchema, [
            (0, $cd207018ee28cb28$export$61fb14aaf7aef60f)
        ], {}),
        ...uiProps,
        ...globalUiOptions
    };
    const fieldUiSchema = {
        ...localUiSchema
    };
    if (!(0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(localUiOptions)) (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(fieldUiSchema, [
        (0, $cd207018ee28cb28$export$61fb14aaf7aef60f)
    ], localUiOptions);
    if (!(0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(globalUiOptions)) // pass the global uiOptions down to the field uiSchema so that they can be applied to all nested fields
    (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(fieldUiSchema, [
        (0, $cd207018ee28cb28$export$c777bab3d600699)
    ], globalUiOptions);
    let { readonly: uiReadonly } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(fieldUiSchema);
    if (forceReadonly === true || (0, $ba9e9f33b9a4d5a4$export$2e2bcd8739ae039)(uiReadonly) && schemaReadonly === true) {
        // If we are forcing all widgets to be readonly, OR the schema indicates it is readonly AND the uiSchema does not
        // have an overriding value, then update the uiSchema to set readonly to true. Doing this will
        uiReadonly = true;
        if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(localUiOptions, (0, $cd207018ee28cb28$export$41fe6d5784a55183))) // If the local options has the key value provided in it, then set that one to true
        (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(fieldUiSchema, [
            (0, $cd207018ee28cb28$export$61fb14aaf7aef60f),
            (0, $cd207018ee28cb28$export$41fe6d5784a55183)
        ], true);
        else // otherwise set the `ui:` version
        (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(fieldUiSchema, `ui:${(0, $cd207018ee28cb28$export$41fe6d5784a55183)}`, true);
    }
    return {
        fieldUiSchema: fieldUiSchema,
        uiReadonly: uiReadonly
    };
}
function $d7de6601dcd2dd2a$export$539e352220387588(operator, datum, value = '$0m3tH1nG Un3xP3cT3d') {
    const data = (0, $6fcc5c625b7f5a28$export$2e2bcd8739ae039)([
        datum
    ]).sort();
    const values = (0, $6fcc5c625b7f5a28$export$2e2bcd8739ae039)([
        value
    ]).sort();
    switch(operator){
        case $d7de6601dcd2dd2a$export$7fa100a28fbb5fe2.ALL:
            return (0, $0f0a19fe76e11216$export$2e2bcd8739ae039)(data, values);
        case $d7de6601dcd2dd2a$export$7fa100a28fbb5fe2.SOME:
            return (0, $1a83449a20fb6574$export$2e2bcd8739ae039)(data, values).length > 0;
        case $d7de6601dcd2dd2a$export$7fa100a28fbb5fe2.NONE:
            return (0, $1a83449a20fb6574$export$2e2bcd8739ae039)(data, values).length === 0;
        default:
            return false;
    }
}
function $d7de6601dcd2dd2a$export$31aaed95059a7e51(layoutGridSchema, schemaKey, registry) {
    let gridProps = {};
    let children = layoutGridSchema[schemaKey];
    if ((0, $d6bfaab5809eb5e3$export$2e2bcd8739ae039)(children)) {
        const { children: elements, className: toMapClassNames, ...otherProps } = children;
        children = elements;
        if (toMapClassNames) {
            const classes = toMapClassNames.split(' ');
            const className = classes.map((ele)=>(0, $52b7e1b185f3945e$export$2e2bcd8739ae039)(registry, ele, ele)).join(' ');
            gridProps = {
                ...otherProps,
                className: className
            };
        } else gridProps = otherProps;
    }
    if (!Array.isArray(children)) throw new TypeError(`Expected array for "${schemaKey}" in ${JSON.stringify(layoutGridSchema)}`);
    return {
        children: children,
        gridProps: gridProps
    };
}
function $d7de6601dcd2dd2a$export$68c7625c85b483cd(schema, fieldPathId, potentialIndex) {
    let rawSchema;
    let resultPathId = fieldPathId;
    if ($d7de6601dcd2dd2a$var$isNumericIndex(potentialIndex) && schema && schema?.type === 'array' && (0, $52f1e6e82878153c$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$7a3255c70c8752d5))) {
        const index = Number(potentialIndex);
        const items = schema[0, $cd207018ee28cb28$export$7a3255c70c8752d5];
        if (Array.isArray(items)) {
            if (index > items.length) rawSchema = (0, $c366ba9e6f84292f$export$2e2bcd8739ae039)(items);
            else rawSchema = items[index];
        } else rawSchema = items;
        resultPathId = {
            [(0, $cd207018ee28cb28$export$f453fd324e92d331)]: fieldPathId[0, $cd207018ee28cb28$export$f453fd324e92d331],
            path: [
                ...fieldPathId.path.slice(0, fieldPathId.path.length - 1),
                index
            ]
        };
    }
    return {
        rawSchema: rawSchema,
        fieldPathId: resultPathId
    };
}
function $d7de6601dcd2dd2a$export$b8f9df01771870ae(registry, dottedPath, initialSchema, formData, initialFieldIdPath) {
    const { schemaUtils: schemaUtils, globalFormOptions: globalFormOptions } = registry;
    let rawSchema = initialSchema;
    let fieldPathId = initialFieldIdPath;
    const parts = dottedPath.split('.');
    const leafPath = parts.pop(); // pop off the last element in the list as the leaf
    let schema = schemaUtils.retrieveSchema(rawSchema, formData); // always returns an object
    let innerData = formData;
    let isReadonly = schema.readOnly;
    // For all the remaining path parts
    parts.forEach((part)=>{
        // dive into the properties of the current schema (when it exists) and get the schema for the next part
        fieldPathId = (0, $99206247aba21705$export$2e2bcd8739ae039)(part, globalFormOptions, fieldPathId);
        if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$dd550d4e98f939a4))) rawSchema = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(schema, [
            (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
            part
        ], {});
        else if (schema && ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$c24c2c38af9a39c3)) || (0, $52f1e6e82878153c$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$2014f14bbe7357bd)))) {
            const xxx = (0, $52f1e6e82878153c$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$c24c2c38af9a39c3)) ? (0, $cd207018ee28cb28$export$c24c2c38af9a39c3) : (0, $cd207018ee28cb28$export$2014f14bbe7357bd);
            // When the schema represents a oneOf/anyOf, find the selected schema for it and grab the inner part
            const selectedSchema = schemaUtils.findSelectedOptionInXxxOf(schema, part, xxx, innerData);
            rawSchema = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(selectedSchema, [
                (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
                part
            ], {});
        } else {
            const result = $d7de6601dcd2dd2a$export$68c7625c85b483cd(schema, fieldPathId, part);
            rawSchema = result.rawSchema ?? {};
            fieldPathId = result.fieldPathId;
        }
        // Now drill into the innerData for the part, returning an empty object by default if it doesn't exist
        innerData = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(innerData, part, {});
        // Resolve any `$ref`s for the current rawSchema
        schema = schemaUtils.retrieveSchema(rawSchema, innerData);
        isReadonly = $d7de6601dcd2dd2a$var$getNonNullishValue(schema.readOnly, isReadonly);
    });
    let optionsInfo;
    let isRequired = false;
    // retrieveSchema will return an empty schema in the worst case scenario, convert it to undefined
    if ((0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(schema)) schema = undefined;
    if (schema && leafPath) {
        // When we have both a schema and a leafPath...
        if (schema && ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$c24c2c38af9a39c3)) || (0, $52f1e6e82878153c$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$2014f14bbe7357bd)))) {
            const xxx = (0, $52f1e6e82878153c$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$c24c2c38af9a39c3)) ? (0, $cd207018ee28cb28$export$c24c2c38af9a39c3) : (0, $cd207018ee28cb28$export$2014f14bbe7357bd);
            // Grab the selected schema for the oneOf/anyOf value for the leafPath using the innerData
            schema = schemaUtils.findSelectedOptionInXxxOf(schema, leafPath, xxx, innerData);
        }
        fieldPathId = (0, $99206247aba21705$export$2e2bcd8739ae039)(leafPath, globalFormOptions, fieldPathId);
        isRequired = schema !== undefined && Array.isArray(schema.required) && (0, $ec4aa1adf1f49a6c$export$2e2bcd8739ae039)(schema.required, leafPath);
        const result = $d7de6601dcd2dd2a$export$68c7625c85b483cd(schema, fieldPathId, leafPath);
        if (result.rawSchema) {
            schema = result.rawSchema;
            fieldPathId = result.fieldPathId;
        } else {
            // Now grab the schema from the leafPath of the current schema properties
            schema = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(schema, [
                (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
                leafPath
            ]);
            // Resolve any `$ref`s for the current schema
            schema = schema ? schemaUtils.retrieveSchema(schema) : schema;
        }
        isReadonly = $d7de6601dcd2dd2a$var$getNonNullishValue(schema?.readOnly, isReadonly);
        if (schema && ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$c24c2c38af9a39c3)) || (0, $52f1e6e82878153c$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$2014f14bbe7357bd)))) {
            const xxx = (0, $52f1e6e82878153c$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$c24c2c38af9a39c3)) ? (0, $cd207018ee28cb28$export$c24c2c38af9a39c3) : (0, $cd207018ee28cb28$export$2014f14bbe7357bd);
            // Set the options if we have a schema with a oneOf/anyOf
            const discriminator = (0, $9b9eddfbb66bfc4e$export$2e2bcd8739ae039)(schema);
            optionsInfo = {
                options: schema[xxx],
                hasDiscriminator: !!discriminator
            };
        }
    }
    return {
        schema: schema,
        isRequired: isRequired,
        isReadonly: isReadonly,
        optionsInfo: optionsInfo,
        fieldPathId: fieldPathId
    };
}
function $d7de6601dcd2dd2a$export$6fb3134fb84a0dea(render, registry) {
    let customRenderer = render;
    if ((0, $e6fe0b0844d2a1c4$export$2e2bcd8739ae039)(customRenderer)) customRenderer = (0, $52b7e1b185f3945e$export$2e2bcd8739ae039)(registry, customRenderer);
    if ((0, $e8276fc8779dcffd$export$2e2bcd8739ae039)(customRenderer)) return customRenderer;
    return null;
}
function $d7de6601dcd2dd2a$export$4a8028092d18291a(registry, gridSchema) {
    let name;
    let UIComponent = null;
    let uiProps = {};
    let rendered;
    if ((0, $e6fe0b0844d2a1c4$export$2e2bcd8739ae039)(gridSchema) || (0, $ba9e9f33b9a4d5a4$export$2e2bcd8739ae039)(gridSchema)) name = gridSchema ?? '';
    else {
        const { name: innerName = '', render: render, ...innerProps } = gridSchema;
        name = innerName;
        uiProps = innerProps;
        if (!(0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(uiProps)) // Transform any `$lookup=` in the uiProps props with the appropriate value
        (0, $1a51e4fa81bddb8c$export$2e2bcd8739ae039)(uiProps, (prop, key)=>{
            if ((0, $e6fe0b0844d2a1c4$export$2e2bcd8739ae039)(prop)) {
                const match = $d7de6601dcd2dd2a$export$c98ab8a721726884.exec(prop);
                if (Array.isArray(match) && match.length > 1) {
                    const lookupName = match[1];
                    uiProps[key] = (0, $52b7e1b185f3945e$export$2e2bcd8739ae039)(registry, lookupName, lookupName);
                }
            }
        });
        UIComponent = $d7de6601dcd2dd2a$export$6fb3134fb84a0dea(render, registry);
        if (!innerName && UIComponent) rendered = (0, $2e41620b030ed79e$exports.jsx)(UIComponent, {
            ...innerProps,
            "data-testid": $d7de6601dcd2dd2a$var$LAYOUT_GRID_FIELD_TEST_IDS.uiComponent
        });
    }
    return {
        name: name,
        UIComponent: UIComponent,
        uiProps: uiProps,
        rendered: rendered
    };
}
/** Iterates through all the `childrenLayoutGridSchemaId`, rendering a nested `LayoutGridField` for each item in the
 * list, passing all the props for the current `LayoutGridField` along, updating the `schema` by calling
 * `retrieveSchema()` on it to resolve any `$ref`s. In addition to the updated `schema`, each item in
 * `childrenLayoutGridSchemaId` is passed as `layoutGridSchema`.
 *
 * @returns - The nested `LayoutGridField`s
 */ function $d7de6601dcd2dd2a$var$LayoutGridFieldChildren(props) {
    const { childrenLayoutGridSchemaId: childrenLayoutGridSchemaId, ...layoutGridFieldProps } = props;
    const { registry: registry, schema: rawSchema, formData: formData } = layoutGridFieldProps;
    const { schemaUtils: schemaUtils } = registry;
    const schema = schemaUtils.retrieveSchema(rawSchema, formData);
    return childrenLayoutGridSchemaId.map((layoutGridSchema)=>(0, $h4Bez.createElement)($d7de6601dcd2dd2a$export$2e2bcd8739ae039, {
            ...layoutGridFieldProps,
            key: `layoutGrid-${(0, $e3ea314528e97c6e$export$3477f9615e12f61d)(layoutGridSchema)}`,
            schema: schema,
            layoutGridSchema: layoutGridSchema
        }));
}
/** Renders the `children` of the `GridType.CONDITION` if it passes. The `layoutGridSchema` for the
 * `GridType.CONDITION` is separated into the `children` and other `gridProps`. The `gridProps` are used to extract
 * the `operator`, `field` and `value` of the condition. If the condition matches, then all of the `children` are
 * rendered, otherwise null is returned.
 *
 * @returns - The rendered the children for the `GridType.CONDITION` or null
 */ function $d7de6601dcd2dd2a$var$LayoutGridCondition(props) {
    const { layoutGridSchema: layoutGridSchema, ...layoutGridFieldProps } = props;
    const { formData: formData, registry: registry } = layoutGridFieldProps;
    const { children: children, gridProps: gridProps } = $d7de6601dcd2dd2a$export$31aaed95059a7e51(layoutGridSchema, $d7de6601dcd2dd2a$export$7a08e7f3b8ad12d8.CONDITION, registry);
    const { operator: operator, field: field = '', value: value } = gridProps;
    const fieldData = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, field, null);
    if ($d7de6601dcd2dd2a$export$539e352220387588(operator, fieldData, value)) return (0, $2e41620b030ed79e$exports.jsx)($d7de6601dcd2dd2a$var$LayoutGridFieldChildren, {
        ...layoutGridFieldProps,
        childrenLayoutGridSchemaId: children
    });
    return null;
}
/** Renders a `GridTemplate` as an item. The `layoutGridSchema` for the `GridType.COLUMN` is separated into the
 * `children` and other `gridProps`. The `gridProps` will be spread onto the outer `GridTemplate`. Inside the
 * `GridTemplate` all the `children` are rendered.
 *
 * @returns - The rendered `GridTemplate` containing the children for the `GridType.COLUMN`
 */ function $d7de6601dcd2dd2a$var$LayoutGridCol(props) {
    const { layoutGridSchema: layoutGridSchema, ...layoutGridFieldProps } = props;
    const { registry: registry, uiSchema: uiSchema } = layoutGridFieldProps;
    const { children: children, gridProps: gridProps } = $d7de6601dcd2dd2a$export$31aaed95059a7e51(layoutGridSchema, $d7de6601dcd2dd2a$export$7a08e7f3b8ad12d8.COLUMN, registry);
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const GridTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('GridTemplate', registry, uiOptions);
    return (0, $2e41620b030ed79e$exports.jsx)(GridTemplate, {
        column: true,
        "data-testid": $d7de6601dcd2dd2a$var$LAYOUT_GRID_FIELD_TEST_IDS.col,
        ...gridProps,
        children: (0, $2e41620b030ed79e$exports.jsx)($d7de6601dcd2dd2a$var$LayoutGridFieldChildren, {
            ...layoutGridFieldProps,
            childrenLayoutGridSchemaId: children
        })
    });
}
/** Renders a `GridTemplate` as an item. The `layoutGridSchema` for the `GridType.COLUMNS` is separated into the
 *  `children` and other `gridProps`. The `children` is iterated on and `gridProps` will be spread onto the outer
 *  `GridTemplate`. Each child will have their own rendered `GridTemplate`.
 *
 * @returns - The rendered `GridTemplate` containing the children for the `GridType.COLUMNS`
 */ function $d7de6601dcd2dd2a$var$LayoutGridColumns(props) {
    const { layoutGridSchema: layoutGridSchema, ...layoutGridFieldProps } = props;
    const { registry: registry, uiSchema: uiSchema } = layoutGridFieldProps;
    const { children: children, gridProps: gridProps } = $d7de6601dcd2dd2a$export$31aaed95059a7e51(layoutGridSchema, $d7de6601dcd2dd2a$export$7a08e7f3b8ad12d8.COLUMNS, registry);
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const GridTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('GridTemplate', registry, uiOptions);
    return children.map((child)=>(0, $2e41620b030ed79e$exports.jsx)(GridTemplate, {
            column: true,
            "data-testid": $d7de6601dcd2dd2a$var$LAYOUT_GRID_FIELD_TEST_IDS.col,
            ...gridProps,
            children: (0, $2e41620b030ed79e$exports.jsx)($d7de6601dcd2dd2a$var$LayoutGridFieldChildren, {
                ...layoutGridFieldProps,
                childrenLayoutGridSchemaId: [
                    child
                ]
            })
        }, `column-${(0, $e3ea314528e97c6e$export$3477f9615e12f61d)(child)}`));
}
/** Renders a `GridTemplate` as a container. The `layoutGridSchema` for the `GridType.ROW` is separated into the
 * `children` and other `gridProps`. The `gridProps` will be spread onto the outer `GridTemplate`. Inside of the
 * `GridTemplate` all of the `children` are rendered.
 *
 * @returns - The rendered `GridTemplate` containing the children for the `GridType.ROW`
 */ function $d7de6601dcd2dd2a$var$LayoutGridRow(props) {
    const { layoutGridSchema: layoutGridSchema, ...layoutGridFieldProps } = props;
    const { registry: registry, uiSchema: uiSchema } = layoutGridFieldProps;
    const { children: children, gridProps: gridProps } = $d7de6601dcd2dd2a$export$31aaed95059a7e51(layoutGridSchema, $d7de6601dcd2dd2a$export$7a08e7f3b8ad12d8.ROW, registry);
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const GridTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('GridTemplate', registry, uiOptions);
    return (0, $2e41620b030ed79e$exports.jsx)(GridTemplate, {
        ...gridProps,
        "data-testid": $d7de6601dcd2dd2a$var$LAYOUT_GRID_FIELD_TEST_IDS.row,
        children: (0, $2e41620b030ed79e$exports.jsx)($d7de6601dcd2dd2a$var$LayoutGridFieldChildren, {
            ...layoutGridFieldProps,
            childrenLayoutGridSchemaId: children
        })
    });
}
/** Renders the field described by `gridSchema`. If `gridSchema` is not an object, then is will be assumed
 * to be the dotted-path to the field in the schema. Otherwise, we extract the `name`, and optional `render` and all
 * other props. If `name` does not exist and there is an optional `render`, we return the `render` component with only
 * specified props for that component. If `name` exists, we take the name, the initial & root schemas and the formData
 * and get the destination schema, is required state and optional oneOf/anyOf options for it. If the destination
 * schema was located along with oneOf/anyOf options then a `LayoutMultiSchemaField` will be rendered with the
 * `uiSchema`, `errorSchema`, `fieldPathId` and `formData` drilled down to the dotted-path field, spreading any other
 * props from `gridSchema` into the `ui:options`. If the destination schema located without any oneOf/anyOf options,
 * then a `SchemaField` will be rendered with the same props as mentioned in the previous sentence. If no destination
 * schema was located, but a custom render component was found, then it will be rendered with many of the non-event
 * handling props. If none of the previous render paths are valid, then a null is returned.
 *
 * @returns - One of `LayoutMultiSchemaField`, `SchemaField`, a custom render component or null, depending
 */ function $d7de6601dcd2dd2a$var$LayoutGridFieldComponent(props) {
    const { gridSchema: gridSchema, schema: initialSchema, uiSchema: uiSchema, errorSchema: errorSchema, fieldPathId: fieldPathId, onBlur: onBlur, onFocus: onFocus, formData: formData, readonly: readonly, registry: registry, layoutGridSchema: layoutGridSchema, ...otherProps } = props;
    const { onChange: onChange } = otherProps;
    const { fields: fields } = registry;
    const { SchemaField: SchemaField, LayoutMultiSchemaField: LayoutMultiSchemaField } = fields;
    const uiComponentProps = $d7de6601dcd2dd2a$export$4a8028092d18291a(registry, gridSchema);
    const { name: name, UIComponent: UIComponent, uiProps: uiProps } = uiComponentProps;
    const { schema: schema, isRequired: isRequired, isReadonly: isReadonly, optionsInfo: optionsInfo, fieldPathId: fieldIdSchema } = $d7de6601dcd2dd2a$export$b8f9df01771870ae(registry, name, initialSchema, formData, fieldPathId);
    const memoFieldPathId = (0, $00773362d992a2a1$export$2e2bcd8739ae039)(fieldIdSchema);
    if (uiComponentProps.rendered) return uiComponentProps.rendered;
    if (schema) {
        const Field = optionsInfo?.hasDiscriminator ? LayoutMultiSchemaField : SchemaField;
        // Call this function to get the appropriate UISchema, which will always have its `readonly` state matching the
        // `uiReadonly` flag that it returns. This is done since the `SchemaField` will always defer to the `readonly`
        // state in the uiSchema over anything in the props or schema. Because we are implementing the "readonly" state of
        // the `Form` via the prop passed to `LayoutGridField` we need to make sure the uiSchema always has a true value
        // when it is needed
        const { fieldUiSchema: fieldUiSchema, uiReadonly: uiReadonly } = $d7de6601dcd2dd2a$export$7db9ef730b950ba7(name, uiProps, uiSchema, isReadonly, readonly);
        return (0, $2e41620b030ed79e$exports.jsx)(Field, {
            "data-testid": optionsInfo?.hasDiscriminator ? $d7de6601dcd2dd2a$var$LAYOUT_GRID_FIELD_TEST_IDS.layoutMultiSchemaField : $d7de6601dcd2dd2a$var$LAYOUT_GRID_FIELD_TEST_IDS.field,
            ...otherProps,
            name: name,
            required: isRequired,
            readonly: uiReadonly,
            schema: schema,
            uiSchema: fieldUiSchema,
            errorSchema: (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(errorSchema, name),
            fieldPathId: memoFieldPathId,
            formData: (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, name),
            onChange: onChange,
            onBlur: onBlur,
            onFocus: onFocus,
            options: optionsInfo?.options,
            registry: registry
        });
    }
    if (UIComponent) return (0, $2e41620b030ed79e$exports.jsx)(UIComponent, {
        "data-testid": $d7de6601dcd2dd2a$var$LAYOUT_GRID_FIELD_TEST_IDS.uiComponent,
        ...otherProps,
        name: name,
        required: isRequired,
        formData: formData,
        readOnly: !!isReadonly || readonly,
        errorSchema: errorSchema,
        uiSchema: uiSchema,
        schema: initialSchema,
        fieldPathId: fieldPathId,
        onBlur: onBlur,
        onFocus: onFocus,
        registry: registry,
        ...uiProps
    });
    return null;
}
function $d7de6601dcd2dd2a$export$2e2bcd8739ae039(props) {
    /** Render the `LayoutGridField`. If there isn't a `layoutGridSchema` prop defined, then try pulling it out of the
     * `uiSchema` via `ui:LayoutGridField`. If `layoutGridSchema` is an object, then check to see if any of the properties
     * match one of the `GridType`s. If so, call the appropriate render function for the type. Otherwise, just call the
     * generic `renderField()` function with the `layoutGridSchema`.
     */ const { uiSchema: uiSchema } = props;
    let { layoutGridSchema: layoutGridSchema } = props;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    if (!layoutGridSchema && $d7de6601dcd2dd2a$export$93a5e8b801c11b44 in uiOptions && (0, $d252d56fd76f41df$export$2e2bcd8739ae039)(uiOptions[$d7de6601dcd2dd2a$export$93a5e8b801c11b44])) layoutGridSchema = uiOptions[$d7de6601dcd2dd2a$export$93a5e8b801c11b44];
    if ((0, $d252d56fd76f41df$export$2e2bcd8739ae039)(layoutGridSchema)) {
        if ($d7de6601dcd2dd2a$export$7a08e7f3b8ad12d8.ROW in layoutGridSchema) return (0, $2e41620b030ed79e$exports.jsx)($d7de6601dcd2dd2a$var$LayoutGridRow, {
            ...props,
            layoutGridSchema: layoutGridSchema
        });
        if ($d7de6601dcd2dd2a$export$7a08e7f3b8ad12d8.COLUMN in layoutGridSchema) return (0, $2e41620b030ed79e$exports.jsx)($d7de6601dcd2dd2a$var$LayoutGridCol, {
            ...props,
            layoutGridSchema: layoutGridSchema
        });
        if ($d7de6601dcd2dd2a$export$7a08e7f3b8ad12d8.COLUMNS in layoutGridSchema) return (0, $2e41620b030ed79e$exports.jsx)($d7de6601dcd2dd2a$var$LayoutGridColumns, {
            ...props,
            layoutGridSchema: layoutGridSchema
        });
        if ($d7de6601dcd2dd2a$export$7a08e7f3b8ad12d8.CONDITION in layoutGridSchema) return (0, $2e41620b030ed79e$exports.jsx)($d7de6601dcd2dd2a$var$LayoutGridCondition, {
            ...props,
            layoutGridSchema: layoutGridSchema
        });
    }
    return (0, $2e41620b030ed79e$exports.jsx)($d7de6601dcd2dd2a$var$LayoutGridFieldComponent, {
        ...props,
        gridSchema: layoutGridSchema
    });
}
$d7de6601dcd2dd2a$export$2e2bcd8739ae039.TEST_IDS = $d7de6601dcd2dd2a$var$LAYOUT_GRID_FIELD_TEST_IDS;




function $f3bee05a861e9a3d$export$2e2bcd8739ae039(props) {
    const { fieldPathId: fieldPathId, title: title, schema: schema, uiSchema: uiSchema, required: required, registry: registry, name: name } = props;
    const options = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, registry.globalUiOptions);
    const { title: uiTitle } = options;
    const { title: schemaTitle } = schema;
    const fieldTitle = uiTitle || title || schemaTitle || name;
    if (!fieldTitle) return null;
    const TitleFieldTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('TitleFieldTemplate', registry, options);
    return (0, $2e41620b030ed79e$exports.jsx)(TitleFieldTemplate, {
        id: (0, $8ce79fa261751f64$export$86b632e0125010d9)(fieldPathId),
        title: fieldTitle,
        required: required,
        schema: schema,
        uiSchema: uiSchema,
        registry: registry
    });
}




var $h4Bez = parcelRequire("h4Bez");







function $892d067927d44d1b$export$52024dc0d58d35da(options, selectorField, value) {
    const defaultValue = '!@#!@$@#$!@$#';
    const schemaOptions = options.map(({ schema: schema })=>schema);
    return schemaOptions.find((option)=>{
        const selector = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(option, [
            (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
            selectorField
        ]);
        const result = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(selector, (0, $cd207018ee28cb28$export$729d352c37f0a7df), (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(selector, (0, $cd207018ee28cb28$export$532244974323b6ba), defaultValue));
        return result === value;
    });
}
function $892d067927d44d1b$export$cac04632ca234bfb(schema, options, schemaUtils, uiSchema, formData) {
    const realOptions = options.map((opt)=>schemaUtils.retrieveSchema(opt, formData));
    let tempSchema = schema;
    if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$c24c2c38af9a39c3))) tempSchema = {
        ...schema,
        [(0, $cd207018ee28cb28$export$c24c2c38af9a39c3)]: realOptions
    };
    else if ((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$2014f14bbe7357bd))) tempSchema = {
        ...schema,
        [(0, $cd207018ee28cb28$export$2014f14bbe7357bd)]: realOptions
    };
    const enumOptions = (0, $01e18c537fba1f55$export$2e2bcd8739ae039)(tempSchema, uiSchema);
    if (!enumOptions) throw new Error(`No enumOptions were computed from the schema ${JSON.stringify(tempSchema)}`);
    return enumOptions;
}
function $892d067927d44d1b$export$2e2bcd8739ae039(props) {
    const { name: name, baseType: baseType, disabled: disabled = false, formData: formData, fieldPathId: fieldPathId, onBlur: onBlur, onChange: onChange, options: options, onFocus: onFocus, registry: registry, uiSchema: uiSchema, schema: schema, autofocus: autofocus, readonly: readonly, required: required, errorSchema: errorSchema, hideError: hideError = false } = props;
    const { widgets: widgets, schemaUtils: schemaUtils, globalUiOptions: globalUiOptions } = registry;
    const [enumOptions, setEnumOptions] = (0, $h4Bez.useState)($892d067927d44d1b$export$cac04632ca234bfb(schema, options, schemaUtils, uiSchema, formData));
    const id = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(fieldPathId, (0, $cd207018ee28cb28$export$f453fd324e92d331));
    const discriminator = (0, $9b9eddfbb66bfc4e$export$2e2bcd8739ae039)(schema);
    const FieldErrorTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('FieldErrorTemplate', registry, options);
    const FieldTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('FieldTemplate', registry, options);
    const schemaHash = (0, $e3ea314528e97c6e$export$3477f9615e12f61d)(schema);
    const optionsHash = (0, $e3ea314528e97c6e$export$3477f9615e12f61d)(options);
    const uiSchemaHash = uiSchema ? (0, $e3ea314528e97c6e$export$3477f9615e12f61d)(uiSchema) : '';
    const formDataHash = formData ? (0, $e3ea314528e97c6e$export$3477f9615e12f61d)(formData) : '';
    (0, $h4Bez.useEffect)(()=>{
        setEnumOptions($892d067927d44d1b$export$cac04632ca234bfb(schema, options, schemaUtils, uiSchema, formData));
    // We are using hashes in place of the dependencies
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        schemaHash,
        optionsHash,
        schemaUtils,
        uiSchemaHash,
        formDataHash
    ]);
    const { widget: widget = discriminator ? 'radio' : 'select', title: title = '', placeholder: placeholder = '', optionsSchemaSelector: selectorField = discriminator, hideError: uiSchemaHideError, ...uiOptions } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    if (!selectorField) throw new Error('No selector field provided for the LayoutMultiSchemaField');
    const selectedOption = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, selectorField);
    let optionSchema = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(enumOptions[0]?.schema, [
        (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
        selectorField
    ], {});
    const option = $892d067927d44d1b$export$52024dc0d58d35da(enumOptions, selectorField, selectedOption);
    // If the subschema doesn't declare a type, infer the type from the parent schema
    optionSchema = optionSchema?.type ? optionSchema : {
        ...optionSchema,
        type: option?.type || baseType
    };
    const Widget = (0, $73d42cea7c965d69$export$2e2bcd8739ae039)(optionSchema, widget, widgets);
    // The following code was copied from `@rjsf`'s `SchemaField`
    // Set hideError to the value provided in the uiSchema, otherwise stick with the prop to propagate to children
    const hideFieldError = uiSchemaHideError === undefined ? hideError : Boolean(uiSchemaHideError);
    const rawErrors = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(errorSchema, [
        (0, $cd207018ee28cb28$export$36fec1b8ab257149)
    ], []);
    const fieldErrorSchema = (0, $56d3aa46749de9f1$export$2e2bcd8739ae039)(errorSchema, [
        (0, $cd207018ee28cb28$export$36fec1b8ab257149)
    ]);
    const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
    /** Callback function that updates the selected option and adjusts the form data based on the structure of the new
     * option, calling the `onChange` callback with the adjusted formData.
     *
     * @param opt - If the option is undefined, we are going to clear the selection otherwise we
     *      will use it as the index of the new option to select
     */ const onOptionChange = (opt)=>{
        if (disabled || readonly) return;
        const newOption = $892d067927d44d1b$export$52024dc0d58d35da(enumOptions, selectorField, opt);
        const oldOption = $892d067927d44d1b$export$52024dc0d58d35da(enumOptions, selectorField, selectedOption);
        let newFormData = schemaUtils.sanitizeDataForNewSchema(newOption, oldOption, formData);
        if (newFormData && newOption) // Call getDefaultFormState to make sure defaults are populated on change.
        newFormData = schemaUtils.getDefaultFormState(newOption, newFormData, 'excludeObjectChildren');
        if (newFormData) (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(newFormData, selectorField, opt);
        // Pass the component name in the path
        onChange(newFormData, fieldPathId.path, undefined, id);
    };
    // filtering the options based on the type of widget because `selectField` does not recognize the `convertOther` prop
    const widgetOptions = {
        enumOptions: enumOptions,
        ...uiOptions
    };
    const errors = !hideFieldError && rawErrors.length > 0 ? (0, $2e41620b030ed79e$exports.jsx)(FieldErrorTemplate, {
        fieldPathId: fieldPathId,
        schema: schema,
        errors: rawErrors,
        registry: registry
    }) : undefined;
    return (0, $2e41620b030ed79e$exports.jsx)(FieldTemplate, {
        fieldPathId: fieldPathId,
        id: id,
        schema: schema,
        label: (title || schema.title) ?? '',
        disabled: disabled || Array.isArray(enumOptions) && (0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(enumOptions),
        uiSchema: uiSchema,
        required: required,
        readonly: !!readonly,
        registry: registry,
        displayLabel: displayLabel,
        errors: errors,
        onChange: onChange,
        onKeyRename: (0, $46102801b81c7243$export$2e2bcd8739ae039),
        onKeyRenameBlur: (0, $46102801b81c7243$export$2e2bcd8739ae039),
        onRemoveProperty: (0, $46102801b81c7243$export$2e2bcd8739ae039),
        children: (0, $2e41620b030ed79e$exports.jsx)(Widget, {
            id: id,
            name: name,
            schema: schema,
            label: (title || schema.title) ?? '',
            disabled: disabled || Array.isArray(enumOptions) && (0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(enumOptions),
            uiSchema: uiSchema,
            autofocus: autofocus,
            readonly: readonly,
            required: required,
            registry: registry,
            multiple: false,
            rawErrors: rawErrors,
            hideError: hideFieldError,
            hideLabel: !displayLabel,
            errorSchema: fieldErrorSchema,
            placeholder: placeholder,
            onChange: onOptionChange,
            onBlur: onBlur,
            onFocus: onFocus,
            value: selectedOption,
            options: widgetOptions,
            htmlName: fieldPathId.name
        })
    });
}




var $h4Bez = parcelRequire("h4Bez");




/** The `AnyOfField` component is used to render a field in the schema that is an `anyOf`, `allOf` or `oneOf`. It tracks
 * the currently selected option and cleans up any irrelevant data in `formData`.
 *
 * @param props - The `FieldProps` for this template
 */ class $4ee6750ae9a60822$var$AnyOfField extends (0, $h4Bez.Component) {
    /** Flag to skip the formData-change-driven option recalculation when the user just selected an option.
     * Set to true in the setState callback of onOptionChange (after onChange is called), consumed and reset in
     * componentDidUpdate. This prevents the matching-option recalculation from overriding a user's explicit choice
     * when getDefaultFormState populates undefined properties that make deepEquals see a false formData change.
     */ skipNextOptionRecalculation = false;
    /** Constructs an `AnyOfField` with the given `props` to initialize the initially selected option in state
     *
     * @param props - The `FieldProps` for this template
     */ constructor(props){
        super(props);
        const { formData: formData, options: options, registry: { schemaUtils: schemaUtils } } = this.props;
        // cache the retrieved options in state in case they have $refs to save doing it later
        const retrievedOptions = options.map((opt)=>schemaUtils.retrieveSchema(opt, formData));
        this.state = {
            retrievedOptions: retrievedOptions,
            selectedOption: this.getMatchingOption(0, formData, retrievedOptions)
        };
    }
    /** React lifecycle method that is called when the props and/or state for this component is updated. It recomputes the
     * currently selected option based on the overall `formData`
     *
     * @param prevProps - The previous `FieldProps` for this template
     * @param prevState - The previous `AnyOfFieldState` for this template
     */ componentDidUpdate(prevProps, prevState) {
        const { formData: formData, options: options, fieldPathId: fieldPathId } = this.props;
        const { selectedOption: selectedOption } = this.state;
        let newState = this.state;
        if (!(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(prevProps.options, options)) {
            const { registry: { schemaUtils: schemaUtils } } = this.props;
            // re-cache the retrieved options in state in case they have $refs to save doing it later
            const retrievedOptions = options.map((opt)=>schemaUtils.retrieveSchema(opt, formData));
            newState = {
                selectedOption: selectedOption,
                retrievedOptions: retrievedOptions
            };
        }
        if (!(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(formData, prevProps.formData) && fieldPathId.$id === prevProps.fieldPathId.$id) {
            if (this.skipNextOptionRecalculation) this.skipNextOptionRecalculation = false;
            else {
                const { retrievedOptions: retrievedOptions } = newState;
                const matchingOption = this.getMatchingOption(selectedOption, formData, retrievedOptions);
                if (prevState && matchingOption !== selectedOption) newState = {
                    selectedOption: matchingOption,
                    retrievedOptions: retrievedOptions
                };
            }
        }
        if (newState !== this.state) // oxlint-disable-next-line react/no-did-update-set-state -- guarded to prevent infinite loop
        this.setState(newState);
    }
    /** Determines the best matching option for the given `formData` and `options`.
     *
     * @param formData - The new formData
     * @param options - The list of options to choose from
     * @return - The index of the `option` that best matches the `formData`
     */ getMatchingOption(selectedOption, formData, options) {
        const { schema: schema, registry: { schemaUtils: schemaUtils } } = this.props;
        const discriminator = (0, $9b9eddfbb66bfc4e$export$2e2bcd8739ae039)(schema);
        const option = schemaUtils.getClosestMatchingOption(formData, options, selectedOption, discriminator);
        return option;
    }
    /** Callback handler to remember what the currently selected option is. In addition to that the `formData` is updated
     * to remove properties that are not part of the newly selected option schema, and then the updated data is passed to
     * the `onChange` handler.
     *
     * @param option - The new option value being selected
     */ onOptionChange = (option)=>{
        const { selectedOption: selectedOption, retrievedOptions: retrievedOptions } = this.state;
        const { disabled: disabled = false, formData: formData, onChange: onChange, readonly: readonly = false, registry: registry, fieldPathId: fieldPathId } = this.props;
        if (disabled || readonly) return;
        const { schemaUtils: schemaUtils } = registry;
        const intOption = option !== undefined ? parseInt(option, 10) : -1;
        if (intOption === selectedOption) return;
        const newOption = intOption >= 0 ? retrievedOptions[intOption] : undefined;
        const oldOption = selectedOption >= 0 ? retrievedOptions[selectedOption] : undefined;
        let newFormData = schemaUtils.sanitizeDataForNewSchema(newOption, oldOption, formData);
        if (newOption) // Call getDefaultFormState to make sure defaults are populated on change. Pass "excludeObjectChildren"
        // so that only the root objects themselves are created without adding undefined children properties
        newFormData = schemaUtils.getDefaultFormState(newOption, newFormData, 'excludeObjectChildren');
        this.setState({
            selectedOption: intOption
        }, ()=>{
            this.skipNextOptionRecalculation = true;
            onChange(newFormData, fieldPathId.path, undefined, this.getFieldId());
        });
    };
    getFieldId() {
        const { fieldPathId: fieldPathId, schema: schema } = this.props;
        return `${fieldPathId.$id}${schema.oneOf ? '__oneof_select' : '__anyof_select'}`;
    }
    /** Renders the `AnyOfField` selector along with a `SchemaField` for the value of the `formData`
     */ render() {
        const { name: name, disabled: disabled = false, errorSchema: errorSchema = {}, formData: formData, onBlur: onBlur, onFocus: onFocus, readonly: readonly, required: required = false, registry: registry, schema: schema, uiSchema: uiSchema } = this.props;
        const { widgets: widgets, fields: fields, translateString: translateString, globalUiOptions: globalUiOptions, schemaUtils: schemaUtils } = registry;
        const { SchemaField: SchemaFieldComponent } = fields;
        const MultiSchemaFieldTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('MultiSchemaFieldTemplate', registry, globalUiOptions);
        const isOptionalRender = (0, $87b2dc06d3aae4d2$export$2e2bcd8739ae039)(registry, schema, required, uiSchema);
        const hasFormData = (0, $8df99a86d43a2e45$export$2e2bcd8739ae039)(formData);
        const { selectedOption: selectedOption, retrievedOptions: retrievedOptions } = this.state;
        const { widget: widget = 'select', placeholder: placeholder, autofocus: autofocus, autocomplete: autocomplete, title: title = schema.title, ...uiOptions } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, globalUiOptions);
        const Widget = (0, $73d42cea7c965d69$export$2e2bcd8739ae039)({
            type: 'number'
        }, widget, widgets);
        const rawErrors = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(errorSchema, (0, $cd207018ee28cb28$export$36fec1b8ab257149), []);
        const fieldErrorSchema = (0, $56d3aa46749de9f1$export$2e2bcd8739ae039)(errorSchema, [
            (0, $cd207018ee28cb28$export$36fec1b8ab257149)
        ]);
        const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
        const option = selectedOption >= 0 ? retrievedOptions[selectedOption] || null : null;
        let optionSchema;
        if (option) {
            // merge top level required field
            const { required: schemaRequired } = schema;
            // Merge in all the non-oneOf/anyOf properties and also skip the special ADDITIONAL_PROPERTY_FLAG property
            optionSchema = schemaRequired ? (0, $c56cbb46ed08f5c4$export$2e2bcd8739ae039)({
                required: schemaRequired
            }, option) : option;
        }
        // First we will check to see if there is an anyOf/oneOf override for the UI schema
        let optionsUiSchema = [];
        if ((0, $cd207018ee28cb28$export$c24c2c38af9a39c3) in schema && uiSchema && (0, $cd207018ee28cb28$export$c24c2c38af9a39c3) in uiSchema) {
            if (Array.isArray(uiSchema[0, $cd207018ee28cb28$export$c24c2c38af9a39c3])) optionsUiSchema = uiSchema[0, $cd207018ee28cb28$export$c24c2c38af9a39c3];
            else // oxlint-disable-next-line no-console
            console.warn(`uiSchema.oneOf is not an array for "${title || name}"`);
        } else if ((0, $cd207018ee28cb28$export$2014f14bbe7357bd) in schema && uiSchema && (0, $cd207018ee28cb28$export$2014f14bbe7357bd) in uiSchema) {
            if (Array.isArray(uiSchema[0, $cd207018ee28cb28$export$2014f14bbe7357bd])) optionsUiSchema = uiSchema[0, $cd207018ee28cb28$export$2014f14bbe7357bd];
            else // oxlint-disable-next-line no-console
            console.warn(`uiSchema.anyOf is not an array for "${title || name}"`);
        }
        // Then we pick the one that matches the selected option index, if one exists otherwise default to the main uiSchema
        let optionUiSchema = uiSchema;
        if (selectedOption >= 0 && optionsUiSchema.length > selectedOption) optionUiSchema = optionsUiSchema[selectedOption];
        const translateEnum = title ? (0, $b63837cd47cf776b$export$e8ce1f619d132f5c).TitleOptionPrefix : (0, $b63837cd47cf776b$export$e8ce1f619d132f5c).OptionPrefix;
        const translateParams = title ? [
            title
        ] : [];
        const enumOptions = retrievedOptions.map((opt, index)=>{
            // Also see if there is an override title in the uiSchema for each option, otherwise use the title from the option
            const { title: uiTitle = opt.title } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(optionsUiSchema[index]);
            return {
                label: uiTitle || translateString(translateEnum, translateParams.concat(String(index + 1))),
                value: index
            };
        });
        const selector = !isOptionalRender || hasFormData ? (0, $2e41620b030ed79e$exports.jsx)(Widget, {
            id: this.getFieldId(),
            name: `${name}${schema.oneOf ? '__oneof_select' : '__anyof_select'}`,
            schema: {
                type: 'number',
                default: 0
            },
            onChange: this.onOptionChange,
            onBlur: onBlur,
            onFocus: onFocus,
            disabled: disabled || (0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(enumOptions),
            multiple: false,
            rawErrors: rawErrors,
            errorSchema: fieldErrorSchema,
            value: selectedOption >= 0 ? selectedOption : undefined,
            options: {
                enumOptions: enumOptions,
                ...uiOptions
            },
            registry: registry,
            placeholder: placeholder,
            autocomplete: autocomplete,
            autofocus: autofocus,
            label: title ?? name,
            hideLabel: !displayLabel,
            readonly: readonly
        }) : undefined;
        const optionsSchemaField = optionSchema && optionSchema.type !== 'null' && (0, $2e41620b030ed79e$exports.jsx)(SchemaFieldComponent, {
            ...this.props,
            schema: optionSchema,
            uiSchema: optionUiSchema
        }) || null;
        return (0, $2e41620b030ed79e$exports.jsx)(MultiSchemaFieldTemplate, {
            schema: schema,
            registry: registry,
            uiSchema: uiSchema,
            selector: selector,
            optionSchemaField: optionsSchemaField
        });
    }
}
var $4ee6750ae9a60822$export$2e2bcd8739ae039 = $4ee6750ae9a60822$var$AnyOfField;



var $h4Bez = parcelRequire("h4Bez");
/** The `NullField` component is used to render a field in the schema is null. It also ensures that the `formData` is
 * also set to null if it has no value.
 *
 * @param props - The `FieldProps` for this template
 */ function $ae5ad5a7b6fb396d$var$NullField(props) {
    const { formData: formData, onChange: onChange, fieldPathId: fieldPathId } = props;
    (0, $h4Bez.useEffect)(()=>{
        if (formData === undefined) onChange(null, fieldPathId.path);
    }, [
        fieldPathId,
        formData,
        onChange
    ]);
    return null;
}
var $ae5ad5a7b6fb396d$export$2e2bcd8739ae039 = $ae5ad5a7b6fb396d$var$NullField;




var $h4Bez = parcelRequire("h4Bez");

// Matches a string that ends in a . character, optionally followed by a sequence of
// digits followed by any number of 0 characters up until the end of the line.
// Ensuring that there is at least one prefixed character is important so that
// you don't incorrectly match against "0".
const $5bc084228d353aa3$var$trailingCharMatcherWithPrefix = /\.([0-9]*0)*$/;
// This is used for trimming the trailing 0 and . characters without affecting
// the rest of the string. Its possible to use one RegEx with groups for this
// functionality, but it is fairly complex compared to simply defining two
// different matchers.
const $5bc084228d353aa3$var$trailingCharMatcher = /[0.]0*$/;
/**
 * The NumberField class has some special handling for dealing with trailing
 * decimal points and/or zeroes. This logic is designed to allow trailing values
 * to be visible in the input element, but not be represented in the
 * corresponding form data.
 *
 * The algorithm is as follows:
 *
 * 1. When the input value changes the value is cached in the component state
 *
 * 2. The value is then normalized, removing trailing decimal points and zeros,
 *    then passed to the "onChange" callback
 *
 * 3. When the component is rendered, the formData value is checked against the
 *    value cached in the state. If it matches the cached value, the cached
 *    value is passed to the input instead of the formData value
 */ function $5bc084228d353aa3$var$NumberField(props) {
    const { registry: registry, onChange: onChange, formData: formData, value: initialValue } = props;
    const [lastValue, setLastValue] = (0, $h4Bez.useState)(initialValue);
    const { StringField: StringField } = registry.fields;
    let value = formData;
    /** Handle the change from the `StringField` to properly convert to a number
     *
     * @param value - The current value for the change occurring
     */ const handleChange = (0, $h4Bez.useCallback)((newValue, path, errorSchema, id)=>{
        // Cache the original value in component state
        setLastValue(newValue);
        // Normalize decimals that don't start with a zero character in advance so
        // that the rest of the normalization logic is simpler
        const normalizedValue = `${newValue}`.startsWith('.') ? `0${newValue}` : newValue;
        // Check that the value is a string (this can happen if the widget used is a
        // <select>, due to an enum declaration etc) then, if the value ends in a
        // trailing decimal point or multiple zeroes, strip the trailing values
        const processed = typeof normalizedValue === 'string' && normalizedValue.match($5bc084228d353aa3$var$trailingCharMatcherWithPrefix) ? (0, $f85108defa353a72$export$2e2bcd8739ae039)(normalizedValue.replace($5bc084228d353aa3$var$trailingCharMatcher, '')) : (0, $f85108defa353a72$export$2e2bcd8739ae039)(normalizedValue);
        onChange(processed, path, errorSchema, id);
    }, [
        onChange
    ]);
    if (typeof lastValue === 'string' && typeof value === 'number') {
        // Construct a regular expression that checks for a string that consists
        // of the formData value suffixed with zero or one '.' characters and zero
        // or more '0' characters
        const re = new RegExp(`^(${String(value).replace('.', '\\.')})?\\.?0*$`);
        // If the cached "lastValue" is a match, use that instead of the formData
        // value to prevent the input value from changing in the UI
        if (lastValue.match(re)) value = lastValue;
    }
    return (0, $2e41620b030ed79e$exports.jsx)(StringField, {
        ...props,
        formData: value,
        onChange: handleChange
    });
}
var $5bc084228d353aa3$export$2e2bcd8739ae039 = $5bc084228d353aa3$var$NumberField;




var $h4Bez = parcelRequire("h4Bez");






var $h4Bez = parcelRequire("h4Bez");
var $9b68c0d72f01a4bc$var$j;
function $9b68c0d72f01a4bc$export$3fc0912547321ab3(z) {
    if (!$9b68c0d72f01a4bc$var$j) {
        if (typeof document < "u") $9b68c0d72f01a4bc$var$j = document.createElement("textarea");
        else return;
    }
    var q = "&" + z + ";";
    $9b68c0d72f01a4bc$var$j.innerHTML = q;
    var v = $9b68c0d72f01a4bc$var$j.value;
    return v !== q ? v : void 0;
}
var $9b68c0d72f01a4bc$export$d3e1a78cff21f600 = {};


var $0a39817bbf114bf6$var$v = 32, $0a39817bbf114bf6$var$b = 9, $0a39817bbf114bf6$var$_5 = 13, $0a39817bbf114bf6$var$E = 10, $0a39817bbf114bf6$var$$0 = 96, $0a39817bbf114bf6$var$N0 = 126, $0a39817bbf114bf6$var$A0 = 91, $0a39817bbf114bf6$var$U5 = 94, $0a39817bbf114bf6$var$o = 62, $0a39817bbf114bf6$var$Y5 = 35, $0a39817bbf114bf6$var$G9 = 37, $0a39817bbf114bf6$var$p = 45, $0a39817bbf114bf6$var$G5 = 61, $0a39817bbf114bf6$var$y0 = 92, $0a39817bbf114bf6$var$_0 = 42, $0a39817bbf114bf6$var$H0 = 95, $0a39817bbf114bf6$var$G0 = 60, $0a39817bbf114bf6$var$j9 = 64, $0a39817bbf114bf6$var$K5 = 93, $0a39817bbf114bf6$var$p0 = 33, $0a39817bbf114bf6$var$K9 = 38, $0a39817bbf114bf6$var$f0 = 58, $0a39817bbf114bf6$var$J9 = 70, $0a39817bbf114bf6$var$I5 = 102, $0a39817bbf114bf6$var$X9 = 104, $0a39817bbf114bf6$var$k5 = 119, $0a39817bbf114bf6$var$h5 = 116, $0a39817bbf114bf6$var$_9 = 112, $0a39817bbf114bf6$var$f9 = 115, $0a39817bbf114bf6$var$W$ = 160, $0a39817bbf114bf6$var$z$ = 12, $0a39817bbf114bf6$var$H$ = 44, $0a39817bbf114bf6$var$U9 = 59, $0a39817bbf114bf6$var$a5 = 63, $0a39817bbf114bf6$var$s0 = 46, $0a39817bbf114bf6$var$M0 = 47, $0a39817bbf114bf6$var$S5 = 39, $0a39817bbf114bf6$var$v5 = 34, $0a39817bbf114bf6$var$N5 = 43, $0a39817bbf114bf6$var$k0 = 124, $0a39817bbf114bf6$var$L5 = 123, $0a39817bbf114bf6$var$I9 = 125, $0a39817bbf114bf6$var$F5 = 40, $0a39817bbf114bf6$var$q5 = 41, $0a39817bbf114bf6$var$O$ = 120, $0a39817bbf114bf6$var$B$ = 88, $0a39817bbf114bf6$var$v9 = 30, $0a39817bbf114bf6$var$i = 48, $0a39817bbf114bf6$var$a = 57, $0a39817bbf114bf6$var$h = 65, $0a39817bbf114bf6$var$c = 90, $0a39817bbf114bf6$var$K0 = 97, $0a39817bbf114bf6$var$W0 = 122, $0a39817bbf114bf6$var$n5 = 128, $0a39817bbf114bf6$var$J5 = 32, $0a39817bbf114bf6$var$k4 = {
    blockQuote: 0,
    breakLine: 1,
    breakThematic: 2,
    codeBlock: 3,
    codeInline: 4,
    footnote: 5,
    footnoteReference: 6,
    frontmatter: 7,
    gfmTask: 8,
    heading: 9,
    htmlBlock: 10,
    htmlComment: 11,
    htmlSelfClosing: 12,
    image: 13,
    link: 14,
    orderedList: 15,
    paragraph: 16,
    ref: 17,
    refCollection: 18,
    table: 19,
    text: 20,
    textFormatted: 21,
    unorderedList: 22
}, $0a39817bbf114bf6$export$e0aa44767d8750d5 = $0a39817bbf114bf6$var$k4;
function $0a39817bbf114bf6$var$I$($) {
    if (!$0a39817bbf114bf6$var$A$($, "---")) return null;
    let Q = 3;
    for(; Q < $.length && ($[Q] === " " || $[Q] === "	");)Q++;
    if (Q < $.length && $[Q] === "\r" && Q++, Q >= $.length || $[Q] !== `
`) return null;
    Q++;
    let Z = !1;
    for(; Q < $.length;){
        let V = Q;
        for(; Q < $.length && $[Q] !== `
` && $[Q] !== "\r";)Q++;
        if (Q >= $.length) break;
        let Y = Q;
        if ($[Q] === "\r" && Q++, Q < $.length && $[Q] === `
` && Q++, $0a39817bbf114bf6$var$A$($, "---", V)) return {
            endPos: Q,
            hasValidYaml: Z
        };
        if (!Z) {
            let G = $0a39817bbf114bf6$var$x4($, V, Y);
            if (G < Y) {
                let K = $.charCodeAt(G);
                if (K >= $0a39817bbf114bf6$var$K0 && K <= $0a39817bbf114bf6$var$W0 || K >= $0a39817bbf114bf6$var$h && K <= $0a39817bbf114bf6$var$c || K >= $0a39817bbf114bf6$var$i && K <= $0a39817bbf114bf6$var$a || K === $0a39817bbf114bf6$var$H0) {
                    for(G++; G < Y && (K = $.charCodeAt(G), K >= $0a39817bbf114bf6$var$K0 && K <= $0a39817bbf114bf6$var$W0 || K >= $0a39817bbf114bf6$var$h && K <= $0a39817bbf114bf6$var$c || K >= $0a39817bbf114bf6$var$i && K <= $0a39817bbf114bf6$var$a || K === $0a39817bbf114bf6$var$H0 || K === $0a39817bbf114bf6$var$p || K === $0a39817bbf114bf6$var$s0);)G++;
                    G < Y && $.charCodeAt(G) === $0a39817bbf114bf6$var$f0 && (G++, G >= Y ? Z = !0 : (K = $.charCodeAt(G), (K === $0a39817bbf114bf6$var$v || K === $0a39817bbf114bf6$var$b) && (Z = !0)));
                }
            }
        }
    }
    return null;
}
var $0a39817bbf114bf6$var$L4 = /&([a-zA-Z0-9]+|#[0-9]{1,7}|#x[0-9a-fA-F]{1,6});/gi, $0a39817bbf114bf6$var$E4 = {
    class: "className",
    for: "htmlFor",
    allowfullscreen: "allowFullScreen",
    allowtransparency: "allowTransparency",
    autocomplete: "autoComplete",
    autofocus: "autoFocus",
    autoplay: "autoPlay",
    cellpadding: "cellPadding",
    cellspacing: "cellSpacing",
    charset: "charSet",
    classid: "classId",
    colspan: "colSpan",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    crossorigin: "crossOrigin",
    enctype: "encType",
    formaction: "formAction",
    formenctype: "formEncType",
    formmethod: "formMethod",
    formnovalidate: "formNoValidate",
    formtarget: "formTarget",
    frameborder: "frameBorder",
    hreflang: "hrefLang",
    inputmode: "inputMode",
    keyparams: "keyParams",
    keytype: "keyType",
    marginheight: "marginHeight",
    marginwidth: "marginWidth",
    maxlength: "maxLength",
    mediagroup: "mediaGroup",
    minlength: "minLength",
    novalidate: "noValidate",
    radiogroup: "radioGroup",
    readonly: "readOnly",
    rowspan: "rowSpan",
    spellcheck: "spellCheck",
    srcdoc: "srcDoc",
    srclang: "srcLang",
    srcset: "srcSet",
    tabindex: "tabIndex",
    usemap: "useMap",
    viewbox: "viewBox"
}, $0a39817bbf114bf6$var$g4 = {};
function $0a39817bbf114bf6$var$t0($) {
    if (!$) return $0a39817bbf114bf6$var$g4;
    var Q = {};
    for(var Z in $){
        var V = Z.toLowerCase(), Y = $0a39817bbf114bf6$var$E4[V];
        if (Y) Q[Y] = $[Z];
        else {
            var G = Z.indexOf(":");
            G !== -1 ? Q[Z.slice(0, G) + Z[G + 1].toUpperCase() + Z.slice(G + 2)] = $[Z] : Q[Z] = $[Z];
        }
    }
    return Q;
}
var $0a39817bbf114bf6$var$v$ = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s|^<(div|p|h[1-6]|ul|ol|li|blockquote|pre|table|thead|tbody|tr|td|th|dl|dt|dd|hr|address|article|aside|details|dialog|figure|figcaption|footer|form|header|main|menu|nav|section|summary|textarea|fieldset|legend|center|dir|hgroup|marquee|search|output|template)\b)/i;
function $0a39817bbf114bf6$var$s5($) {
    return $.indexOf("&") === -1 ? $ : $.replace($0a39817bbf114bf6$var$L4, (Q, Z)=>{
        var V = (0, $9b68c0d72f01a4bc$export$3fc0912547321ab3)(Z);
        if (V) return V;
        if (Z[0] === "#") {
            var Y = Z[1] === "x" || Z[1] === "X" ? parseInt(Z.slice(2), 16) : parseInt(Z.slice(1), 10);
            return Y === 0 || Y >= 55296 && Y <= 57343 || Y > 1114111 ? "\uFFFD" : Y <= 65535 ? String.fromCharCode(Y) : String.fromCharCode(55296 + (Y - 65536 >> 10), 56320 + (Y - 65536 & 1023));
        }
        return Q;
    });
}
var $0a39817bbf114bf6$var$D$ = /(javascript|vbscript|data(?!:image)):/i;
function $0a39817bbf114bf6$export$3e2338ea76b578c9($) {
    if ($0a39817bbf114bf6$var$D$.test($)) return null;
    if ($.indexOf("%") === -1) return $;
    try {
        let Q = decodeURIComponent($).replace(/[^A-Za-z0-9/:]/g, "");
        if ($0a39817bbf114bf6$var$D$.test(Q)) return null;
    } catch  {
        return null;
    }
    return $;
}
var $0a39817bbf114bf6$var$d0 = {}, $0a39817bbf114bf6$var$o0, $0a39817bbf114bf6$var$E0;
for($0a39817bbf114bf6$var$o0 = [
    192,
    193,
    194,
    195,
    196,
    197,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    198
], $0a39817bbf114bf6$var$E0 = 0; $0a39817bbf114bf6$var$E0 < $0a39817bbf114bf6$var$o0.length; $0a39817bbf114bf6$var$E0++)$0a39817bbf114bf6$var$d0[$0a39817bbf114bf6$var$o0[$0a39817bbf114bf6$var$E0]] = "a";
for($0a39817bbf114bf6$var$d0[231] = $0a39817bbf114bf6$var$d0[199] = "c", $0a39817bbf114bf6$var$d0[240] = $0a39817bbf114bf6$var$d0[208] = "d", $0a39817bbf114bf6$var$o0 = [
    200,
    201,
    202,
    203,
    233,
    232,
    234,
    235
], $0a39817bbf114bf6$var$E0 = 0; $0a39817bbf114bf6$var$E0 < $0a39817bbf114bf6$var$o0.length; $0a39817bbf114bf6$var$E0++)$0a39817bbf114bf6$var$d0[$0a39817bbf114bf6$var$o0[$0a39817bbf114bf6$var$E0]] = "e";
for($0a39817bbf114bf6$var$o0 = [
    207,
    239,
    206,
    238,
    205,
    237,
    204,
    236
], $0a39817bbf114bf6$var$E0 = 0; $0a39817bbf114bf6$var$E0 < $0a39817bbf114bf6$var$o0.length; $0a39817bbf114bf6$var$E0++)$0a39817bbf114bf6$var$d0[$0a39817bbf114bf6$var$o0[$0a39817bbf114bf6$var$E0]] = "i";
for($0a39817bbf114bf6$var$d0[209] = $0a39817bbf114bf6$var$d0[241] = "n", $0a39817bbf114bf6$var$o0 = [
    248,
    216,
    339,
    338,
    213,
    245,
    212,
    244,
    211,
    243,
    210,
    242
], $0a39817bbf114bf6$var$E0 = 0; $0a39817bbf114bf6$var$E0 < $0a39817bbf114bf6$var$o0.length; $0a39817bbf114bf6$var$E0++)$0a39817bbf114bf6$var$d0[$0a39817bbf114bf6$var$o0[$0a39817bbf114bf6$var$E0]] = "o";
for($0a39817bbf114bf6$var$o0 = [
    220,
    252,
    219,
    251,
    218,
    250,
    217,
    249
], $0a39817bbf114bf6$var$E0 = 0; $0a39817bbf114bf6$var$E0 < $0a39817bbf114bf6$var$o0.length; $0a39817bbf114bf6$var$E0++)$0a39817bbf114bf6$var$d0[$0a39817bbf114bf6$var$o0[$0a39817bbf114bf6$var$E0]] = "u";
$0a39817bbf114bf6$var$d0[376] = $0a39817bbf114bf6$var$d0[255] = $0a39817bbf114bf6$var$d0[221] = $0a39817bbf114bf6$var$d0[253] = "y";
function $0a39817bbf114bf6$export$c383cdd2a518017a($) {
    for(var Q = "", Z = -1, V = $.length, Y = 0; Y < V; Y++){
        var G = $.charCodeAt(Y);
        if (G >= $0a39817bbf114bf6$var$K0 && G <= $0a39817bbf114bf6$var$W0 || G >= $0a39817bbf114bf6$var$i && G <= $0a39817bbf114bf6$var$a) {
            Z < 0 && (Z = Y);
            continue;
        }
        if (G >= $0a39817bbf114bf6$var$h && G <= $0a39817bbf114bf6$var$c) {
            Z >= 0 && (Q += $.slice(Z, Y), Z = -1), Q += String.fromCharCode(G + $0a39817bbf114bf6$var$J5);
            continue;
        }
        if (G === $0a39817bbf114bf6$var$v || G === $0a39817bbf114bf6$var$p) {
            Z >= 0 && (Q += $.slice(Z, Y), Z = -1), Q += "-";
            continue;
        }
        Z >= 0 && (Q += $.slice(Z, Y), Z = -1);
        var K = $0a39817bbf114bf6$var$d0[G];
        K && (Q += K);
    }
    return Z >= 0 && (Q += $.slice(Z)), Q;
}
function $0a39817bbf114bf6$var$A$($, Q, Z) {
    return $.startsWith(Q, Z);
}
var $0a39817bbf114bf6$var$M$ = new Set([
    "area",
    "base",
    "br",
    "col",
    "embed",
    "hr",
    "img",
    "input",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr",
    "circle",
    "ellipse",
    "line",
    "path",
    "polygon",
    "polyline",
    "rect",
    "use",
    "stop",
    "animate",
    "set"
]);
function $0a39817bbf114bf6$var$l5($) {
    let Q = $.toLowerCase();
    if ($0a39817bbf114bf6$var$M$.has(Q)) return !0;
    let Z = Q.indexOf(":");
    return Z !== -1 ? (Q = Q.slice(Z + 1), $0a39817bbf114bf6$var$M$.has(Q)) : !1;
}
var $0a39817bbf114bf6$var$E5 = 1, $0a39817bbf114bf6$var$j$ = 2, $0a39817bbf114bf6$var$p5 = 4, $0a39817bbf114bf6$var$_$ = 8, $0a39817bbf114bf6$var$T4 = 16, $0a39817bbf114bf6$var$W5 = 32, $0a39817bbf114bf6$var$P5 = 64, $0a39817bbf114bf6$var$N$ = function() {
    var $ = new Uint8Array(128), Q;
    for($[$0a39817bbf114bf6$var$b] = $0a39817bbf114bf6$var$E5, $[$0a39817bbf114bf6$var$E] = $0a39817bbf114bf6$var$E5 | $0a39817bbf114bf6$var$j$, $[$0a39817bbf114bf6$var$z$] = $0a39817bbf114bf6$var$E5, $[$0a39817bbf114bf6$var$_5] = $0a39817bbf114bf6$var$E5 | $0a39817bbf114bf6$var$j$, $[$0a39817bbf114bf6$var$v] = $0a39817bbf114bf6$var$E5, Q = $0a39817bbf114bf6$var$p0; Q <= $0a39817bbf114bf6$var$M0; Q++)$[Q] = $0a39817bbf114bf6$var$p5;
    for(Q = $0a39817bbf114bf6$var$f0; Q <= $0a39817bbf114bf6$var$j9; Q++)$[Q] = $0a39817bbf114bf6$var$p5;
    for(Q = $0a39817bbf114bf6$var$A0; Q <= $0a39817bbf114bf6$var$$0; Q++)$[Q] = $0a39817bbf114bf6$var$p5;
    for(Q = $0a39817bbf114bf6$var$L5; Q <= $0a39817bbf114bf6$var$N0; Q++)$[Q] = $0a39817bbf114bf6$var$p5;
    for(Q = $0a39817bbf114bf6$var$i; Q <= $0a39817bbf114bf6$var$a; Q++)$[Q] = $0a39817bbf114bf6$var$T4;
    for(Q = $0a39817bbf114bf6$var$h; Q <= $0a39817bbf114bf6$var$c; Q++)$[Q] = $0a39817bbf114bf6$var$_$;
    for(Q = $0a39817bbf114bf6$var$K0; Q <= $0a39817bbf114bf6$var$W0; Q++)$[Q] = $0a39817bbf114bf6$var$_$;
    return $;
}(), $0a39817bbf114bf6$var$P$ = /[\p{P}\p{S}]/u, $0a39817bbf114bf6$var$b$ = /\p{Zs}/u, $0a39817bbf114bf6$var$u5 = [];
function $0a39817bbf114bf6$var$w$($) {
    var Q = $.indexOf("\r"), Z = $.indexOf("\0");
    if (Q === -1 && Z === -1) return $;
    var V = $.length;
    $0a39817bbf114bf6$var$u5.length = 0;
    var Y = 0, G = 0;
    for(Q === -1 ? G = Z : Z === -1 ? G = Q : G = Q < Z ? Q : Z; G < V; G++){
        var K = $.charCodeAt(G);
        K === $0a39817bbf114bf6$var$_5 ? (Y < G && $0a39817bbf114bf6$var$u5.push($.slice(Y, G)), G + 1 < V && $.charCodeAt(G + 1) === $0a39817bbf114bf6$var$E && G++, $0a39817bbf114bf6$var$u5.push(`
`), Y = G + 1) : K === 0 && (Y < G && $0a39817bbf114bf6$var$u5.push($.slice(Y, G)), $0a39817bbf114bf6$var$u5.push("\uFFFD"), Y = G + 1);
    }
    return Y < V && $0a39817bbf114bf6$var$u5.push($.slice(Y)), $0a39817bbf114bf6$var$u5.join("");
}
function $0a39817bbf114bf6$var$x4($, Q, Z) {
    let V = Z ?? $.length;
    for(; Q < V && ($[Q] === " " || $[Q] === "	");)Q++;
    return Q;
}
function $0a39817bbf114bf6$var$P9($) {
    if (!$) return !1;
    for(var Q in $)return !0;
    return !1;
}
function $0a39817bbf114bf6$var$R$($) {
    return {
        attrs: {},
        children: [
            {
                type: $0a39817bbf114bf6$export$e0aa44767d8750d5.text,
                text: $
            }
        ],
        d: !0,
        type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlBlock,
        tag: "header"
    };
}
var $0a39817bbf114bf6$var$f4 = /^\n+/;
function $0a39817bbf114bf6$var$y$($) {
    for(var Q = $.length; Q > 0 && ($[Q - 1] === `
` || $[Q - 1] === "\r");)Q--;
    return $.slice(0, Q).replace($0a39817bbf114bf6$var$f4, "") + `

`;
}
function $0a39817bbf114bf6$var$d5($) {
    if (($.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlSelfClosing || $.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlBlock) && $.b) return [];
    if ($.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.paragraph) {
        var Q = $.children;
        return Q ? Q.flatMap($0a39817bbf114bf6$var$d5) : [];
    }
    return $.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.text ? $.text?.trim() ? [
        $
    ] : [] : $.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlBlock && $.children ? [
        {
            ...$,
            children: $.children?.flatMap($0a39817bbf114bf6$var$d5)
        }
    ] : [
        $
    ];
}
function $0a39817bbf114bf6$var$v6($, Q) {
    return new RegExp(`^<${Q}(\\s|>)`, "i").test($) && $.toLowerCase().trimEnd().endsWith("</" + Q.toLowerCase() + ">");
}
function $0a39817bbf114bf6$var$m9($) {
    for(var Q = 0; Q < $.length; Q++){
        if ($[Q].type === $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlBlock) {
            var Z = $[Q], V = !1;
            if (Z.d && Z.a && Q === $.length - 1) {
                var Y = "</" + String(Z.tag).toLowerCase() + ">", G = Z.a.toLowerCase().indexOf(Y);
                if (G !== -1) {
                    var K = Z.a.slice(G + Y.length).replace(/<\/[a-z][a-z0-9-]*\s*>/gi, "");
                    K.trim() && (V = !0);
                }
            }
            V || (Z.d = !1);
        }
        "children" in $[Q] && $[Q].children && $0a39817bbf114bf6$var$m9($[Q].children);
    }
}
function $0a39817bbf114bf6$var$k$($, Q) {
    for(var Z = 0; Z < $.length; Z++){
        var V = $[Z];
        if (V.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.paragraph && V.children) for(var Y = V.children, G = 0; G < Y.length; G++){
            var K = Y[G];
            if (K.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlSelfClosing && K.b && K.tag.toLowerCase() === Q) {
                var J = $.slice(0, Z);
                G > 0 && J.push({
                    type: $0a39817bbf114bf6$export$e0aa44767d8750d5.paragraph,
                    children: Y.slice(0, G)
                });
                var X = [];
                if (G + 1 < Y.length) {
                    var U = Y.slice(G + 1).filter(function(q) {
                        return !(q.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlSelfClosing && q.b);
                    });
                    U.length > 0 && (X = U);
                }
                return X = X.concat($.slice(Z + 1)), {
                    found: !0,
                    beforeClose: J,
                    afterClose: X
                };
            }
        }
        if ((V.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlSelfClosing || V.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlBlock) && V.b && V.tag.toLowerCase() === Q) return {
            found: !0,
            beforeClose: $.slice(0, Z),
            afterClose: $.slice(Z + 1)
        };
    }
    return {
        found: !1,
        beforeClose: $,
        afterClose: []
    };
}
function $0a39817bbf114bf6$var$S$($, Q, Z) {
    var V = $.replace(new RegExp("\\s*</" + Q + ">\\s*$", "i"), "");
    return Z ? $0a39817bbf114bf6$var$p9(V) : V;
}
function $0a39817bbf114bf6$var$h9($) {
    var Q = "";
    for(var Z in $){
        var V = $[Z];
        V === !0 ? Q += " " + Z : V != null && V !== !1 && (Q += " " + Z + '="' + String(V) + '"');
    }
    return Q;
}
function $0a39817bbf114bf6$var$L$($) {
    var Q = [];
    if (!$) return Q;
    for(var Z in $)Z.charCodeAt(0) === 94 && Q.push({
        identifier: Z,
        footnote: $[Z].target
    });
    return Q;
}
function $0a39817bbf114bf6$var$t5($, Q, Z) {
    if (Q.indexOf(".") === -1) return $?.[Q] || Z;
    for(var V = $, Y = Q.split("."), G = 0; G < Y.length && (V = V?.[Y[G]], V !== void 0);)G++;
    return V || Z;
}
function $0a39817bbf114bf6$var$E$($) {
    for(var Q = !1, Z = 0; Z < $.length; Z++){
        var V = $.charCodeAt(Z);
        if (V <= $0a39817bbf114bf6$var$v || V === $0a39817bbf114bf6$var$v5 || V === $0a39817bbf114bf6$var$G9 || V === $0a39817bbf114bf6$var$G0 || V === $0a39817bbf114bf6$var$o || V === $0a39817bbf114bf6$var$A0 || V === $0a39817bbf114bf6$var$y0 || V === $0a39817bbf114bf6$var$K5 || V === $0a39817bbf114bf6$var$U5 || V === $0a39817bbf114bf6$var$$0 || V >= 123) {
            Q = !0;
            break;
        }
    }
    if (!Q) return $;
    for(var Y = "", Z = 0; Z < $.length; Z++){
        var V = $.charCodeAt(Z);
        if (V === $0a39817bbf114bf6$var$G9 && Z + 2 < $.length) {
            var G = $.charCodeAt(Z + 1), K = $.charCodeAt(Z + 2);
            if ((G >= $0a39817bbf114bf6$var$i && G <= $0a39817bbf114bf6$var$a || G >= $0a39817bbf114bf6$var$h && G <= $0a39817bbf114bf6$var$J9 || G >= $0a39817bbf114bf6$var$K0 && G <= $0a39817bbf114bf6$var$I5) && (K >= $0a39817bbf114bf6$var$i && K <= $0a39817bbf114bf6$var$a || K >= $0a39817bbf114bf6$var$h && K <= $0a39817bbf114bf6$var$J9 || K >= $0a39817bbf114bf6$var$K0 && K <= $0a39817bbf114bf6$var$I5)) {
                Y += $[Z] + $[Z + 1] + $[Z + 2], Z += 2;
                continue;
            }
        }
        Y += encodeURI($[Z]);
    }
    return Y;
}
function $0a39817bbf114bf6$var$g$(...$) {
    return $.filter(Boolean).join(" ");
}
function $0a39817bbf114bf6$var$N6($, Q) {
    if (!Q) return $;
    let Z = $0a39817bbf114bf6$var$t5(Q, $, void 0);
    return typeof Z == "string" ? Z : typeof Z == "object" && Z.component ? Z.component : $;
}
function $0a39817bbf114bf6$var$P6($, Q) {
    if (!Q) return {};
    let Z = $0a39817bbf114bf6$var$t5(Q, $, void 0);
    return typeof Z == "object" && Z.props ? Z.props : {};
}
var $0a39817bbf114bf6$var$C4 = new Set([
    "title",
    "textarea",
    "style",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "script",
    "plaintext"
]), $0a39817bbf114bf6$var$N9 = /<(\/?)(title|textarea|style|xmp|iframe|noembed|noframes|script|plaintext)(\s|>|\/)/gi;
function $0a39817bbf114bf6$var$u9($) {
    return $0a39817bbf114bf6$var$C4.has($.toLowerCase());
}
function $0a39817bbf114bf6$var$T$($) {
    return $0a39817bbf114bf6$var$N9.lastIndex = 0, $0a39817bbf114bf6$var$N9.test($);
}
function $0a39817bbf114bf6$var$p9($) {
    return $0a39817bbf114bf6$var$N9.lastIndex = 0, $.replace($0a39817bbf114bf6$var$N9, function(Q, Z, V, Y) {
        return "&lt;" + Z + V + Y;
    });
}
var $0a39817bbf114bf6$var$i$ = /^<([a-zA-Z][a-zA-Z0-9-]*)\s[^>]*>/, $0a39817bbf114bf6$var$a$ = /^<[A-Z]/, $0a39817bbf114bf6$var$c9 = [
    "script",
    "pre",
    "style",
    "textarea"
], $0a39817bbf114bf6$var$z9 = new Set($0a39817bbf114bf6$var$c9), $0a39817bbf114bf6$var$m4 = /<(?:pre|script|style|textarea)\b/i, $0a39817bbf114bf6$var$f$ = /<(?:pre|script|style|textarea)\b/iy, $0a39817bbf114bf6$var$d9 = /^(\s{0,3}#[#\s]|\s{0,3}[-*+]\s|\s{0,3}\d+\.\s|\s{0,3}>\s|\s{0,3}```)/m, $0a39817bbf114bf6$var$C$ = /^<([a-z][^ >/\n\r]*) ?([^>]*?)>/im, $0a39817bbf114bf6$var$n$ = new Uint8Array(128);
(function() {
    for(var $ = [
        $0a39817bbf114bf6$var$$0,
        $0a39817bbf114bf6$var$_0,
        $0a39817bbf114bf6$var$H0,
        $0a39817bbf114bf6$var$N0,
        $0a39817bbf114bf6$var$G5,
        $0a39817bbf114bf6$var$A0,
        $0a39817bbf114bf6$var$p0,
        $0a39817bbf114bf6$var$G0,
        $0a39817bbf114bf6$var$y0,
        $0a39817bbf114bf6$var$K9,
        $0a39817bbf114bf6$var$E,
        $0a39817bbf114bf6$var$X9,
        $0a39817bbf114bf6$var$k5,
        $0a39817bbf114bf6$var$I5
    ], Q = 0; Q < $.length; Q++)$0a39817bbf114bf6$var$n$[$[Q]] = 1;
})();
var $0a39817bbf114bf6$var$m$ = /([a-zA-Z_][a-zA-Z0-9_-]*)=(?:"([^"]*)"|'([^']*)')/g;
function $0a39817bbf114bf6$var$s$($) {
    return $0a39817bbf114bf6$var$z9.has($);
}
function $0a39817bbf114bf6$var$t$($) {
    return $0a39817bbf114bf6$var$m4.test($);
}
function $0a39817bbf114bf6$var$e$($, Q, Z) {
    for(var V = Q, Y = Z; V < Y && ($.charCodeAt(V) === $0a39817bbf114bf6$var$v || $.charCodeAt(V) === $0a39817bbf114bf6$var$b);)V++;
    if (V >= Y) return !1;
    $.charCodeAt(V) === $0a39817bbf114bf6$var$k0 && V++;
    for(var G = 0; V < Y;){
        for(; V < Y && ($.charCodeAt(V) === $0a39817bbf114bf6$var$v || $.charCodeAt(V) === $0a39817bbf114bf6$var$b);)V++;
        if (V >= Y) break;
        if ($.charCodeAt(V) === $0a39817bbf114bf6$var$k0 && G > 0) {
            for(var K = V + 1; K < Y && ($.charCodeAt(K) === $0a39817bbf114bf6$var$v || $.charCodeAt(K) === $0a39817bbf114bf6$var$b);)K++;
            if (K >= Y) return !0;
        }
        if ($.charCodeAt(V) === $0a39817bbf114bf6$var$f0 && V++, V >= Y || $.charCodeAt(V) !== $0a39817bbf114bf6$var$p) return !1;
        for(; V < Y && $.charCodeAt(V) === $0a39817bbf114bf6$var$p;)V++;
        for(V < Y && $.charCodeAt(V) === $0a39817bbf114bf6$var$f0 && V++, G++; V < Y && ($.charCodeAt(V) === $0a39817bbf114bf6$var$v || $.charCodeAt(V) === $0a39817bbf114bf6$var$b);)V++;
        if (V < Y) {
            if ($.charCodeAt(V) === $0a39817bbf114bf6$var$k0) V++;
            else return !1;
        }
    }
    return G > 0;
}
function $0a39817bbf114bf6$var$w5($, Q) {
    if ($.charCodeAt(Q) !== $0a39817bbf114bf6$var$G0) return null;
    let Z = Q + 1, V = $.length, Y = !1;
    $.charCodeAt(Z) === $0a39817bbf114bf6$var$M0 && (Z++, Y = !0);
    let G = Z, K = $.charCodeAt(Z);
    if (!(K >= $0a39817bbf114bf6$var$K0 && K <= $0a39817bbf114bf6$var$W0 || K >= $0a39817bbf114bf6$var$h && K <= $0a39817bbf114bf6$var$c)) return null;
    for(; Z < V && ($.charCodeAt(Z) >= $0a39817bbf114bf6$var$K0 && $.charCodeAt(Z) <= $0a39817bbf114bf6$var$W0 || $.charCodeAt(Z) >= $0a39817bbf114bf6$var$h && $.charCodeAt(Z) <= $0a39817bbf114bf6$var$c || $.charCodeAt(Z) >= $0a39817bbf114bf6$var$i && $.charCodeAt(Z) <= $0a39817bbf114bf6$var$a || $.charCodeAt(Z) === $0a39817bbf114bf6$var$p);)Z++;
    let J = $.slice(G, Z);
    if (!J) return null;
    let X = Z;
    for(; Z < V && ($.charCodeAt(Z) === $0a39817bbf114bf6$var$v || $.charCodeAt(Z) === $0a39817bbf114bf6$var$b || $.charCodeAt(Z) === $0a39817bbf114bf6$var$E);)Z++;
    let U = $.slice(X, Z);
    if (Z === X && Z < V) {
        var q = $.charCodeAt(Z);
        if (q !== $0a39817bbf114bf6$var$o && q !== $0a39817bbf114bf6$var$M0) return null;
    }
    let W = Z, z = {}, F = !1;
    for(; Z < V;){
        let k = $.charCodeAt(Z);
        if (k === $0a39817bbf114bf6$var$o) {
            let S = $.slice(W, Z);
            return {
                tag: J,
                attrs: z,
                selfClosing: !1,
                end: Z + 1,
                rawAttrs: S,
                whitespaceBeforeAttrs: U,
                isClosing: Y,
                hasSpaceBeforeSlash: F
            };
        }
        if (k === $0a39817bbf114bf6$var$v || k === $0a39817bbf114bf6$var$b || k === $0a39817bbf114bf6$var$E) {
            Z++;
            continue;
        }
        if (k === $0a39817bbf114bf6$var$M0 && Z + 1 < V && $.charCodeAt(Z + 1) === $0a39817bbf114bf6$var$o) {
            let S = $.slice(W, Z);
            return F = Z > W && $.charCodeAt(Z - 1) === $0a39817bbf114bf6$var$v, {
                tag: J,
                attrs: z,
                selfClosing: !0,
                end: Z + 2,
                rawAttrs: S,
                whitespaceBeforeAttrs: U,
                isClosing: Y,
                hasSpaceBeforeSlash: F
            };
        }
        var D = Z, O = $.charCodeAt(Z);
        if (!(O >= $0a39817bbf114bf6$var$K0 && O <= $0a39817bbf114bf6$var$W0 || O >= $0a39817bbf114bf6$var$h && O <= $0a39817bbf114bf6$var$c || O === $0a39817bbf114bf6$var$H0 || O === $0a39817bbf114bf6$var$f0)) return null;
        for(Z++; Z < V;){
            var H = $.charCodeAt(Z);
            if (H >= $0a39817bbf114bf6$var$K0 && H <= $0a39817bbf114bf6$var$W0 || H >= $0a39817bbf114bf6$var$h && H <= $0a39817bbf114bf6$var$c || H >= $0a39817bbf114bf6$var$i && H <= $0a39817bbf114bf6$var$a || H === $0a39817bbf114bf6$var$H0 || H === $0a39817bbf114bf6$var$s0 || H === $0a39817bbf114bf6$var$f0 || H === $0a39817bbf114bf6$var$p) Z++;
            else break;
        }
        for(var B = $.slice(D, Z); Z < V && ($.charCodeAt(Z) === $0a39817bbf114bf6$var$v || $.charCodeAt(Z) === $0a39817bbf114bf6$var$b);)Z++;
        if ($.charCodeAt(Z) !== $0a39817bbf114bf6$var$G5) {
            z[B] = "";
            continue;
        }
        for(Z++; Z < V && ($.charCodeAt(Z) === $0a39817bbf114bf6$var$v || $.charCodeAt(Z) === $0a39817bbf114bf6$var$b);)Z++;
        var M = $.charCodeAt(Z);
        if (M === $0a39817bbf114bf6$var$v5 || M === $0a39817bbf114bf6$var$S5) {
            Z++;
            for(var j = Z; Z < V && $.charCodeAt(Z) !== M;)Z++;
            if (Z >= V) return null;
            if (z[B] = $.slice(j, Z), Z++, Z < V) {
                var w = $.charCodeAt(Z);
                if (w !== $0a39817bbf114bf6$var$v && w !== $0a39817bbf114bf6$var$b && w !== $0a39817bbf114bf6$var$E && w !== $0a39817bbf114bf6$var$o && w !== $0a39817bbf114bf6$var$M0) return null;
            }
        } else if (M === $0a39817bbf114bf6$var$L5) {
            var I = 1, j = Z;
            for(Z++; Z < V && I > 0;){
                var H = $.charCodeAt(Z);
                H === $0a39817bbf114bf6$var$L5 ? I++ : H === $0a39817bbf114bf6$var$I9 && I--, Z++;
            }
            z[B] = $.slice(j, Z);
        } else {
            for(var j = Z; Z < V;){
                var A = $.charCodeAt(Z);
                if (A === $0a39817bbf114bf6$var$v || A === $0a39817bbf114bf6$var$b || A === $0a39817bbf114bf6$var$o || A === $0a39817bbf114bf6$var$E || A === $0a39817bbf114bf6$var$v5 || A === $0a39817bbf114bf6$var$S5 || A === $0a39817bbf114bf6$var$G5 || A === $0a39817bbf114bf6$var$G0 || A === $0a39817bbf114bf6$var$$0) break;
                Z++;
            }
            if (Z === j) return null;
            z[B] = $.slice(j, Z);
        }
    }
    return null;
}
function $0a39817bbf114bf6$var$h4($, Q, Z) {
    if (!Z.optimizeForStreaming && $.indexOf("[") === -1) return !1;
    for(var V = 0, Y = $.length, G = !1, K = !1; V < Y;){
        for(var J = $.indexOf(`
`, V), X = J < 0 ? Y : J, U = V, q = 0; U < X && q < 4;)if ($.charCodeAt(U) === $0a39817bbf114bf6$var$v) q++, U++;
        else if ($.charCodeAt(U) === $0a39817bbf114bf6$var$b) q += 4, U++;
        else break;
        if (U >= X) {
            G = !1, V = J < 0 ? Y : J + 1;
            continue;
        }
        if (q < 4) {
            var W = $.charCodeAt(U);
            if (W === $0a39817bbf114bf6$var$$0 || W === $0a39817bbf114bf6$var$N0) {
                for(var z = W, F = 0, D = U; D < X && $.charCodeAt(D) === z;)F++, D++;
                if (F >= 3) {
                    var O = !0;
                    if (z === $0a39817bbf114bf6$var$$0) {
                        for(var H = D; H < X; H++)if ($.charCodeAt(H) === $0a39817bbf114bf6$var$$0) {
                            O = !1;
                            break;
                        }
                    }
                    if (O) {
                        G = !1;
                        for(var B = J < 0 ? Y : J + 1; B < Y;){
                            for(var M = B, j = 0; M < Y && j < 4;){
                                var w = $.charCodeAt(M);
                                if (w === $0a39817bbf114bf6$var$v) j++, M++;
                                else if (w === $0a39817bbf114bf6$var$b) j += 4, M++;
                                else break;
                            }
                            if (j < 4 && M < Y && $.charCodeAt(M) === z) {
                                for(var I = 0; M < Y && $.charCodeAt(M) === z;)I++, M++;
                                if (I >= F) {
                                    for(; M < Y && ($.charCodeAt(M) === $0a39817bbf114bf6$var$v || $.charCodeAt(M) === $0a39817bbf114bf6$var$b);)M++;
                                    if (M >= Y || $.charCodeAt(M) === $0a39817bbf114bf6$var$E) {
                                        V = M >= Y ? Y : M + 1;
                                        break;
                                    }
                                }
                            }
                            for(; B < Y && $.charCodeAt(B) !== $0a39817bbf114bf6$var$E;)B++;
                            B < Y && B++;
                        }
                        B >= Y && (V = Y, K = !0);
                        continue;
                    }
                }
            }
        }
        for(var A = U; A < X && $.charCodeAt(A) === $0a39817bbf114bf6$var$o;){
            A++, A < X && $.charCodeAt(A) === $0a39817bbf114bf6$var$v && A++;
            for(var k = 0; A < X && k < 4;)if ($.charCodeAt(A) === $0a39817bbf114bf6$var$v) k++, A++;
            else if ($.charCodeAt(A) === $0a39817bbf114bf6$var$b) k += 4, A++;
            else break;
            if (k >= 4) break;
            G = !1;
        }
        if (!G && q < 4 && A < X && $.charCodeAt(A) === $0a39817bbf114bf6$var$A0 && !(A + 1 < Y && $.charCodeAt(A + 1) === $0a39817bbf114bf6$var$U5)) {
            var S = $0a39817bbf114bf6$var$$4($, A, Q);
            if (S) {
                V = S, G = !1;
                continue;
            }
        }
        var R = $.charCodeAt(U);
        if (R === $0a39817bbf114bf6$var$Y5 && q < 4) G = !1;
        else if (q < 4 && (R === $0a39817bbf114bf6$var$p || R === $0a39817bbf114bf6$var$_0 || R === $0a39817bbf114bf6$var$H0)) {
            for(var N = U, T = 0; N < X;){
                var L = $.charCodeAt(N);
                if (L === R) T++;
                else if (L !== $0a39817bbf114bf6$var$v && L !== $0a39817bbf114bf6$var$b) break;
                N++;
            }
            G = !(T >= 3 && N >= X);
        } else G = !0;
        V = J < 0 ? Y : J + 1;
    }
    return K;
}
function $0a39817bbf114bf6$var$$4($, Q, Z) {
    let V = $.length;
    if ($.charCodeAt(Q) !== $0a39817bbf114bf6$var$A0) return null;
    let Y = Q + 1 < V && $.charCodeAt(Q + 1) === $0a39817bbf114bf6$var$U5, G = Q + 1;
    for(; G < V;){
        var K = $.charCodeAt(G);
        if (K === $0a39817bbf114bf6$var$K5) {
            G++;
            break;
        }
        if (K === $0a39817bbf114bf6$var$A0) return null;
        K === $0a39817bbf114bf6$var$y0 && G + 1 < V && G++, G++;
    }
    if (G > V || $.charCodeAt(G - 1) !== $0a39817bbf114bf6$var$K5) return null;
    let J = $.slice(Q + 1, G - 1);
    if (J.length > 999) return null;
    let X = $0a39817bbf114bf6$var$b9(J);
    if (!X || G >= V || $.charCodeAt(G) !== $0a39817bbf114bf6$var$f0) return null;
    G++;
    let U = !1;
    for(; G < V;){
        let u = $.charCodeAt(G);
        if (u === $0a39817bbf114bf6$var$v || u === $0a39817bbf114bf6$var$b) G++;
        else if (u === $0a39817bbf114bf6$var$E && !U) U = !0, G++;
        else break;
    }
    if (Y) {
        let u = $.indexOf(`
`, G), x = u < 0 ? V : u, g = $.slice(G, x).trim();
        return Z[X] = {
            target: g,
            title: void 0
        }, u < 0 ? V : u + 1;
    }
    var q;
    if (G < V && $.charCodeAt(G) === $0a39817bbf114bf6$var$G0) {
        G++;
        for(var W = G; G < V && $.charCodeAt(G) !== $0a39817bbf114bf6$var$o && $.charCodeAt(G) !== $0a39817bbf114bf6$var$E;)$.charCodeAt(G) === $0a39817bbf114bf6$var$y0 && G + 1 < V && G++, G++;
        if (G >= V || $.charCodeAt(G) !== $0a39817bbf114bf6$var$o) return null;
        q = $.slice(W, G), G++;
        for(var z = $.indexOf(`
`, G), F = z < 0 ? V : z, D = G; D < F && ($.charCodeAt(D) === $0a39817bbf114bf6$var$v || $.charCodeAt(D) === $0a39817bbf114bf6$var$b);)D++;
        if (D < F) {
            if (D === G) return null;
            var O = $.charCodeAt(D);
            if (O !== $0a39817bbf114bf6$var$v5 && O !== $0a39817bbf114bf6$var$S5 && O !== $0a39817bbf114bf6$var$F5) return null;
        }
    } else {
        for(var W = G, H = 0; G < V;){
            var K = $.charCodeAt(G);
            if (K === $0a39817bbf114bf6$var$F5) H++;
            else if (K === $0a39817bbf114bf6$var$q5) {
                if (H === 0) break;
                H--;
            } else {
                if (K === $0a39817bbf114bf6$var$v || K === $0a39817bbf114bf6$var$b || K === $0a39817bbf114bf6$var$E) break;
                K === $0a39817bbf114bf6$var$y0 && G + 1 < V && G++;
            }
            G++;
        }
        if (q = $.slice(W, G), !q) return null;
    }
    for(; G < V && ($.charCodeAt(G) === $0a39817bbf114bf6$var$v || $.charCodeAt(G) === $0a39817bbf114bf6$var$b);)G++;
    var B = $.indexOf(`
`, G), M = B < 0 ? V : B, j, w = !1, I = G, A = G;
    if (G === M && G < V) for(A = G + 1; A < V && ($.charCodeAt(A) === $0a39817bbf114bf6$var$v || $.charCodeAt(A) === $0a39817bbf114bf6$var$b);)A++;
    if (A < V) {
        var k = $.charCodeAt(A);
        if (k === $0a39817bbf114bf6$var$v5 || k === $0a39817bbf114bf6$var$S5 || k === $0a39817bbf114bf6$var$F5) {
            for(var S = k === $0a39817bbf114bf6$var$F5 ? 41 : k, R = A + 1, N = R; R < V;){
                var T = $.charCodeAt(R);
                if (T === S) {
                    for(var L = R + 1; L < V && ($.charCodeAt(L) === $0a39817bbf114bf6$var$v || $.charCodeAt(L) === $0a39817bbf114bf6$var$b);)L++;
                    (L >= V || $.charCodeAt(L) === $0a39817bbf114bf6$var$E) && (j = $.slice(N, R), w = !0, I = L < V ? L + 1 : V);
                    break;
                }
                if (T === $0a39817bbf114bf6$var$y0 && R + 1 < V) {
                    R += 2;
                    continue;
                }
                if (T === $0a39817bbf114bf6$var$E && R + 1 < V && $.charCodeAt(R + 1) === $0a39817bbf114bf6$var$E) break;
                R++;
            }
            if (!w && A === G) return null;
        }
    }
    if (w) return Z[X] || (Z[X] = {
        target: $0a39817bbf114bf6$var$e5(q),
        title: j !== void 0 ? $0a39817bbf114bf6$var$s5($0a39817bbf114bf6$var$e5(j)) : j
    }), I;
    for(; G < M && ($.charCodeAt(G) === $0a39817bbf114bf6$var$v || $.charCodeAt(G) === $0a39817bbf114bf6$var$b);)G++;
    return G < M ? null : (Z[X] || (Z[X] = {
        target: $0a39817bbf114bf6$var$e5(q),
        title: j
    }), B < 0 ? V : B + 1);
}
var $0a39817bbf114bf6$var$$5 = new Uint8Array($0a39817bbf114bf6$var$N$);
for($0a39817bbf114bf6$var$$5[$0a39817bbf114bf6$var$Y5] |= $0a39817bbf114bf6$var$W5, $0a39817bbf114bf6$var$$5[$0a39817bbf114bf6$var$o] |= $0a39817bbf114bf6$var$W5, $0a39817bbf114bf6$var$$5[$0a39817bbf114bf6$var$p] |= $0a39817bbf114bf6$var$W5 | $0a39817bbf114bf6$var$P5, $0a39817bbf114bf6$var$$5[$0a39817bbf114bf6$var$N5] |= $0a39817bbf114bf6$var$W5, $0a39817bbf114bf6$var$$5[$0a39817bbf114bf6$var$_0] |= $0a39817bbf114bf6$var$W5 | $0a39817bbf114bf6$var$P5, $0a39817bbf114bf6$var$$5[$0a39817bbf114bf6$var$H0] |= $0a39817bbf114bf6$var$W5 | $0a39817bbf114bf6$var$P5, $0a39817bbf114bf6$var$$5[$0a39817bbf114bf6$var$$0] |= $0a39817bbf114bf6$var$W5 | $0a39817bbf114bf6$var$P5, $0a39817bbf114bf6$var$$5[$0a39817bbf114bf6$var$N0] |= $0a39817bbf114bf6$var$W5 | $0a39817bbf114bf6$var$P5, $0a39817bbf114bf6$var$$5[$0a39817bbf114bf6$var$G0] |= $0a39817bbf114bf6$var$W5 | $0a39817bbf114bf6$var$P5, $0a39817bbf114bf6$var$$5[$0a39817bbf114bf6$var$A0] |= $0a39817bbf114bf6$var$P5, $0a39817bbf114bf6$var$$5[$0a39817bbf114bf6$var$p0] |= $0a39817bbf114bf6$var$P5, $0a39817bbf114bf6$var$$5[$0a39817bbf114bf6$var$k0] |= $0a39817bbf114bf6$var$W5, $0a39817bbf114bf6$var$F9 = $0a39817bbf114bf6$var$i; $0a39817bbf114bf6$var$F9 <= $0a39817bbf114bf6$var$a; $0a39817bbf114bf6$var$F9++)$0a39817bbf114bf6$var$$5[$0a39817bbf114bf6$var$F9] |= $0a39817bbf114bf6$var$W5;
var $0a39817bbf114bf6$var$F9;
function $0a39817bbf114bf6$var$h$($) {
    if ($.indexOf("[") < 0 && $.indexOf("]") < 0) return !1;
    for(var Q = 0; Q < $.length; Q++){
        if ($.charCodeAt(Q) === $0a39817bbf114bf6$var$y0) {
            Q++;
            continue;
        }
        if ($.charCodeAt(Q) === $0a39817bbf114bf6$var$A0 || $.charCodeAt(Q) === $0a39817bbf114bf6$var$K5) return !0;
    }
    return !1;
}
function $0a39817bbf114bf6$var$b9($) {
    for(var Q = $.length, Z = !0, V = Q > 0, Y = 0; Y < Q; Y++){
        var G = $.charCodeAt(Y);
        if (G === $0a39817bbf114bf6$var$v) {
            if (Z) {
                V = !1;
                break;
            }
            Z = !0;
        } else if (G < 33 || G > 126 || G >= $0a39817bbf114bf6$var$h && G <= $0a39817bbf114bf6$var$c) {
            V = !1;
            break;
        } else Z = !1;
    }
    if (V && !Z) return $;
    var K = $.replace(/\s+/g, " ").trim();
    return K.indexOf("\u1E9E") !== -1 ? K.replace(/\u1E9E/g, "ss").toLowerCase() : K.toLowerCase();
}
function $0a39817bbf114bf6$var$n9($) {
    return $ < $0a39817bbf114bf6$var$n5 ? $0a39817bbf114bf6$var$$5[$] : $ === $0a39817bbf114bf6$var$W$ ? $0a39817bbf114bf6$var$E5 : 0;
}
function $0a39817bbf114bf6$var$e5($) {
    return $.indexOf("\\") === -1 ? $ : $.replace(/\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g, "$1");
}
var $0a39817bbf114bf6$var$l9 = null, $0a39817bbf114bf6$var$r9 = -1, $0a39817bbf114bf6$var$w9 = -1;
function $0a39817bbf114bf6$var$X0($, Q) {
    if (Q >= $0a39817bbf114bf6$var$r9 && Q <= $0a39817bbf114bf6$var$w9 && $ === $0a39817bbf114bf6$var$l9) return $0a39817bbf114bf6$var$w9;
    var Z = $.indexOf(`
`, Q), V = Z < 0 ? $.length : Z;
    return $0a39817bbf114bf6$var$l9 = $, $0a39817bbf114bf6$var$r9 = Q, $0a39817bbf114bf6$var$w9 = V, V;
}
function $0a39817bbf114bf6$var$s($, Q) {
    let Z = $0a39817bbf114bf6$var$X0($, Q);
    return Z < $.length ? Z + 1 : Z;
}
function $0a39817bbf114bf6$var$W9($, Q, Z) {
    for(; Q < Z;){
        let V = $.charCodeAt(Q);
        if (V !== $0a39817bbf114bf6$var$v && V !== $0a39817bbf114bf6$var$b) break;
        Q++;
    }
    return Q;
}
function $0a39817bbf114bf6$var$u$($, Q) {
    let Z = $0a39817bbf114bf6$var$s($, Q);
    for(; Z < $.length;){
        let V = $0a39817bbf114bf6$var$X0($, Z);
        if ($0a39817bbf114bf6$var$e0($, Z, V)) return Z;
        Z = $0a39817bbf114bf6$var$s($, Z);
    }
    return $.length;
}
function $0a39817bbf114bf6$var$C5($, Q, Z, V) {
    let Y = 0;
    for(; Q + Y < Z && $.charCodeAt(Q + Y) === V;)Y++;
    return Y;
}
var $0a39817bbf114bf6$var$J0 = 0, $0a39817bbf114bf6$var$Z0 = 0;
function $0a39817bbf114bf6$var$P0($, Q, Z) {
    for($0a39817bbf114bf6$var$J0 = 0, $0a39817bbf114bf6$var$Z0 = 0; Q + $0a39817bbf114bf6$var$Z0 < Z;){
        let V = $.charCodeAt(Q + $0a39817bbf114bf6$var$Z0);
        if (V === $0a39817bbf114bf6$var$b) $0a39817bbf114bf6$var$J0 += 4 - $0a39817bbf114bf6$var$J0 % 4;
        else if (V === $0a39817bbf114bf6$var$v) $0a39817bbf114bf6$var$J0++;
        else break;
        $0a39817bbf114bf6$var$Z0++;
    }
}
function $0a39817bbf114bf6$var$e0($, Q, Z) {
    return $0a39817bbf114bf6$var$W9($, Q, Z) >= Z;
}
function $0a39817bbf114bf6$var$u4($, Q, Z, V) {
    let Y = $0a39817bbf114bf6$var$X0($, Q);
    if ($0a39817bbf114bf6$var$P0($, Q, Y), $0a39817bbf114bf6$var$J0 > 3) return null;
    let G = Q + $0a39817bbf114bf6$var$Z0;
    if ($.charCodeAt(G) !== $0a39817bbf114bf6$var$Y5) return null;
    let K = $0a39817bbf114bf6$var$C5($, G, Y, 35);
    if (K < 1 || K > 6 || (G += K, G < Y && $.charCodeAt(G) !== $0a39817bbf114bf6$var$v && $.charCodeAt(G) !== $0a39817bbf114bf6$var$b)) return null;
    G = $0a39817bbf114bf6$var$W9($, G, Y);
    for(var J = Y; J > G && $.charCodeAt(J - 1) === $0a39817bbf114bf6$var$v;)J--;
    for(var X = J; J > G && $.charCodeAt(J - 1) === $0a39817bbf114bf6$var$Y5;)J--;
    if (J < X) {
        if (J === G || $.charCodeAt(J - 1) === $0a39817bbf114bf6$var$v) for(; J > G && $.charCodeAt(J - 1) === $0a39817bbf114bf6$var$v;)J--;
        else J = X;
    }
    let U = $.slice(G, J), q = $0a39817bbf114bf6$var$$9(U, !1, Z, V), z = (V?.slugify || $0a39817bbf114bf6$export$c383cdd2a518017a)(U);
    return {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.heading,
            level: K,
            children: q,
            id: z
        },
        end: $0a39817bbf114bf6$var$s($, Y)
    };
}
function $0a39817bbf114bf6$var$p4($, Q, Z) {
    var V = $.charCodeAt(Q);
    if (V !== $0a39817bbf114bf6$var$G5 && V !== $0a39817bbf114bf6$var$p) return !1;
    for(var Y = Q; Y < Z && $.charCodeAt(Y) === V;)Y++;
    for(; Y < Z && ($.charCodeAt(Y) === $0a39817bbf114bf6$var$v || $.charCodeAt(Y) === $0a39817bbf114bf6$var$b);)Y++;
    return Y >= Z;
}
function $0a39817bbf114bf6$var$x5($, Q) {
    let Z = $0a39817bbf114bf6$var$X0($, Q);
    if ($0a39817bbf114bf6$var$P0($, Q, Z), $0a39817bbf114bf6$var$J0 > 3) return null;
    let V = Q + $0a39817bbf114bf6$var$Z0, Y = $.charCodeAt(V);
    if (Y !== $0a39817bbf114bf6$var$p && Y !== $0a39817bbf114bf6$var$_0 && Y !== $0a39817bbf114bf6$var$H0) return null;
    let G = 0;
    for(; V < Z;){
        let K = $.charCodeAt(V);
        if (K === Y) G++;
        else if (K !== $0a39817bbf114bf6$var$v && K !== $0a39817bbf114bf6$var$b) return null;
        V++;
    }
    return G < 3 ? null : {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.breakThematic
        },
        end: $0a39817bbf114bf6$var$s($, Z)
    };
}
function $0a39817bbf114bf6$var$d4($, Q, Z) {
    let V = $0a39817bbf114bf6$var$X0($, Q);
    if ($0a39817bbf114bf6$var$P0($, Q, V), $0a39817bbf114bf6$var$J0 > 3) return null;
    let Y = $0a39817bbf114bf6$var$J0, G = $0a39817bbf114bf6$var$Z0, K = Q + $0a39817bbf114bf6$var$Z0, J = $.charCodeAt(K);
    if (J !== $0a39817bbf114bf6$var$$0 && J !== $0a39817bbf114bf6$var$N0) return null;
    let X = $0a39817bbf114bf6$var$C5($, K, V, J);
    if (X < 3) return null;
    K += X;
    let U = $0a39817bbf114bf6$var$W9($, K, V), q = V;
    if (J === $0a39817bbf114bf6$var$$0) {
        for(let g = U; g < V; g++)if ($.charCodeAt(g) === $0a39817bbf114bf6$var$$0) return null;
    }
    for(; q > U && ($.charCodeAt(q - 1) === $0a39817bbf114bf6$var$v || $.charCodeAt(q - 1) === $0a39817bbf114bf6$var$b);)q--;
    let W = $.slice(U, q), z = "", F = "", D = W.indexOf(" ");
    D === -1 ? z = W : (z = W.slice(0, D), F = W.slice(D + 1).trim()), z = $0a39817bbf114bf6$var$e5(z);
    var O = void 0;
    if (F) {
        $0a39817bbf114bf6$var$m$.lastIndex = 0;
        for(var H; (H = $0a39817bbf114bf6$var$m$.exec(F)) !== null;)O || (O = {}), O[H[1]] = H[2] !== void 0 ? H[2] : H[3];
    }
    let B = $0a39817bbf114bf6$var$s($, V), M = $.length, j = $.length;
    for(var w = String.fromCharCode(J).repeat(X), I = B; I < $.length;){
        var A = $.indexOf(w, I);
        if (A === -1) break;
        for(var k = A, S = 0; k > 0 && S < 4 && $.charCodeAt(k - 1) === $0a39817bbf114bf6$var$v;)k--, S++;
        if (S <= 3 && (k === 0 || $.charCodeAt(k - 1) === $0a39817bbf114bf6$var$E)) {
            for(var R = A + X; R < $.length && $.charCodeAt(R) === J;)R++;
            var N = $0a39817bbf114bf6$var$X0($, R);
            if ($0a39817bbf114bf6$var$e0($, R, N)) {
                M = k, j = $0a39817bbf114bf6$var$s($, N);
                break;
            }
        }
        I = A + 1;
    }
    var T;
    if (Y === 0) T = M > B && $.charCodeAt(M - 1) === $0a39817bbf114bf6$var$E ? $.slice(B, M - 1) : $.slice(B, M);
    else {
        T = "";
        for(var L = B; L < M;){
            var u = $0a39817bbf114bf6$var$X0($, L);
            $0a39817bbf114bf6$var$P0($, L, u);
            var x = Math.min($0a39817bbf114bf6$var$Z0, Y);
            T += $.slice(L + x, u) + `
`, L = $0a39817bbf114bf6$var$s($, u);
        }
        T.length > 0 && T.charCodeAt(T.length - 1) === $0a39817bbf114bf6$var$E && (T = T.slice(0, -1));
    }
    return {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.codeBlock,
            lang: z || void 0,
            text: T,
            infoString: F || void 0,
            attrs: O
        },
        end: j
    };
}
function $0a39817bbf114bf6$var$c4($, Q) {
    let Z = $0a39817bbf114bf6$var$X0($, Q);
    if ($0a39817bbf114bf6$var$P0($, Q, Z), $0a39817bbf114bf6$var$J0 < 4) return null;
    let V = "", Y = Q;
    for(; Y < $.length;){
        let F = $0a39817bbf114bf6$var$X0($, Y);
        if ($0a39817bbf114bf6$var$P0($, Y, F), $0a39817bbf114bf6$var$e0($, Y, F)) {
            for(var G = 0, K = $0a39817bbf114bf6$var$s($, F); K < $.length;){
                var J = $0a39817bbf114bf6$var$X0($, K);
                if ($0a39817bbf114bf6$var$e0($, K, J)) {
                    G++, K = $0a39817bbf114bf6$var$s($, J);
                    continue;
                }
                if ($0a39817bbf114bf6$var$P0($, K, J), $0a39817bbf114bf6$var$J0 >= 4) {
                    for(var X = 0; X <= G; X++)V += `
`;
                    Y = K;
                    break;
                }
                break;
            }
            if (Y !== K) break;
            continue;
        }
        if ($0a39817bbf114bf6$var$J0 < 4) break;
        let D = 0, O = 0;
        var U = 0;
        for(let H = Y; H < F && O < 4; H++){
            if ($.charCodeAt(H) === $0a39817bbf114bf6$var$b) {
                var q = 4 - O % 4;
                O + q > 4 && (U = O + q - 4), O += q;
            } else O++;
            D++;
        }
        var W = "";
        if (U > 0) for(var z = 0; z < U; z++)W += " ";
        W += $.slice(Y + D, F), V += W + `
`, Y = $0a39817bbf114bf6$var$s($, F);
    }
    for(; V.length > 0 && V.charCodeAt(V.length - 1) === $0a39817bbf114bf6$var$E;)V = V.slice(0, -1);
    return V ? {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.codeBlock,
            lang: void 0,
            text: V,
            infoString: void 0,
            attrs: void 0
        },
        end: Y
    } : null;
}
function $0a39817bbf114bf6$var$l4($, Q, Z, V) {
    let Y = $0a39817bbf114bf6$var$X0($, Q);
    if ($0a39817bbf114bf6$var$P0($, Q, Y), $0a39817bbf114bf6$var$J0 > 3) return null;
    let G = Q + $0a39817bbf114bf6$var$Z0;
    if ($.charCodeAt(G) !== $0a39817bbf114bf6$var$o) return null;
    let K = "", J = Q, X, U = !1, q = !1, W = !1;
    for(; J < $.length;){
        let P = $0a39817bbf114bf6$var$X0($, J);
        $0a39817bbf114bf6$var$P0($, J, P);
        let C = J + $0a39817bbf114bf6$var$Z0;
        if ($.charCodeAt(C) === $0a39817bbf114bf6$var$o) {
            let d = C + 1;
            var z = $0a39817bbf114bf6$var$J0 + 1, F = !1;
            if (d < P) {
                var D = $.charCodeAt(d);
                D === $0a39817bbf114bf6$var$v ? (d++, z++, F = !0) : D === $0a39817bbf114bf6$var$b && (F = !0);
            }
            for(var O = "", H = !1, B = d; B < P; B++)if ($.charCodeAt(B) === $0a39817bbf114bf6$var$b) {
                H = !0;
                break;
            }
            if (H) {
                var M = z;
                if (F && d < P && $.charCodeAt(d) === $0a39817bbf114bf6$var$b) {
                    for(var j = 4 - M % 4, w = 0; w < j - 1; w++)O += " ";
                    M += j, d++;
                }
                for(var I = d; I < P; I++)if ($.charCodeAt(I) === $0a39817bbf114bf6$var$b) {
                    for(var A = 4 - M % 4, k = 0; k < A; k++)O += " ";
                    M += A;
                } else O += $[I], M++;
            } else O = $.slice(d, P);
            if (!K && !X) {
                let f = O.match(/^\[!([A-Za-z]+)\]\s*$/);
                if (f) {
                    X = f[1].toUpperCase(), J = $0a39817bbf114bf6$var$s($, P);
                    continue;
                }
            }
            K += O + `
`;
            var S = O.trimStart();
            S.startsWith("```") || S.startsWith("~~~") ? W = !W : (O.startsWith("    ") || O.startsWith("	")) && (W = !0), q = S.length > 0, J = $0a39817bbf114bf6$var$s($, P);
        } else if (K && !$0a39817bbf114bf6$var$e0($, J, P) && q) {
            if ($0a39817bbf114bf6$var$J0 < 4) {
                var R = J + $0a39817bbf114bf6$var$Z0, N = R < P ? $.charCodeAt(R) : 0;
                if (N === $0a39817bbf114bf6$var$Y5 || N === $0a39817bbf114bf6$var$o || N === $0a39817bbf114bf6$var$$0 || N === $0a39817bbf114bf6$var$N0 || N === $0a39817bbf114bf6$var$G0 || (N === $0a39817bbf114bf6$var$p || N === $0a39817bbf114bf6$var$_0 || N === $0a39817bbf114bf6$var$H0) && $0a39817bbf114bf6$var$x5($, J) || (N === $0a39817bbf114bf6$var$p || N === $0a39817bbf114bf6$var$_0 || N === $0a39817bbf114bf6$var$N5) && R + 1 < P && ($.charCodeAt(R + 1) === $0a39817bbf114bf6$var$v || $.charCodeAt(R + 1) === $0a39817bbf114bf6$var$b)) break;
                if (N >= $0a39817bbf114bf6$var$i && N <= $0a39817bbf114bf6$var$a) {
                    for(var T = R; T < P && $.charCodeAt(T) >= $0a39817bbf114bf6$var$i && $.charCodeAt(T) <= $0a39817bbf114bf6$var$a;)T++;
                    if (T < P && ($.charCodeAt(T) === $0a39817bbf114bf6$var$s0 || $.charCodeAt(T) === $0a39817bbf114bf6$var$q5)) break;
                }
            }
            if (W) break;
            K += $.slice(J, P) + `
`, U = !0, J = $0a39817bbf114bf6$var$s($, P);
        } else break;
    }
    if (!K && !X) return null;
    var { inBlockQuote: L, f: u } = Z;
    Z.inBlockQuote = !0, U && (Z.f = !0);
    let x = $0a39817bbf114bf6$var$f5(K || "", Z, V);
    return Z.inBlockQuote = L, Z.f = u, {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.blockQuote,
            children: x,
            alert: X || void 0
        },
        end: J
    };
}
function $0a39817bbf114bf6$var$Z4($, Q, Z) {
    for(var V = 0, Y = Q; Y < Z; Y++)$.charCodeAt(Y) === $0a39817bbf114bf6$var$b ? V += 4 - V % 4 : V++;
    return V;
}
function $0a39817bbf114bf6$var$g5($, Q, Z) {
    if ($0a39817bbf114bf6$var$P0($, Q, Z), $0a39817bbf114bf6$var$J0 > 3) return null;
    var V = Q + $0a39817bbf114bf6$var$Z0;
    if (V >= Z) return null;
    var Y = $.charCodeAt(V), G = $0a39817bbf114bf6$var$J0, K = V;
    if (Y === $0a39817bbf114bf6$var$p || Y === $0a39817bbf114bf6$var$_0 || Y === $0a39817bbf114bf6$var$N5) {
        if (K = V + 1, K < Z && $.charCodeAt(K) !== $0a39817bbf114bf6$var$v && $.charCodeAt(K) !== $0a39817bbf114bf6$var$b && $.charCodeAt(K) !== $0a39817bbf114bf6$var$E) return null;
    } else if (Y >= $0a39817bbf114bf6$var$i && Y <= $0a39817bbf114bf6$var$a) {
        for(var J = V; J < Z && J - V < 9;){
            var X = $.charCodeAt(J);
            if (X < $0a39817bbf114bf6$var$i || X > $0a39817bbf114bf6$var$a) break;
            J++;
        }
        if (J > V && J < Z) {
            var U = $.charCodeAt(J);
            if (U === $0a39817bbf114bf6$var$s0 || U === $0a39817bbf114bf6$var$q5) {
                if (K = J + 1, K < Z && $.charCodeAt(K) !== $0a39817bbf114bf6$var$v && $.charCodeAt(K) !== $0a39817bbf114bf6$var$b && $.charCodeAt(K) !== $0a39817bbf114bf6$var$E) return null;
            } else return null;
        } else return null;
    } else return null;
    var q = K, W = $0a39817bbf114bf6$var$Z4($, Q, K), z = 0, F = q, D = W;
    if (q >= Z) return {
        ordered: Y >= $0a39817bbf114bf6$var$i && Y <= $0a39817bbf114bf6$var$a,
        marker: Y >= $0a39817bbf114bf6$var$i && Y <= $0a39817bbf114bf6$var$a ? $[J] : $[V],
        start: Y >= $0a39817bbf114bf6$var$i && Y <= $0a39817bbf114bf6$var$a ? parseInt($.slice(V, J), 10) : void 0,
        contentStart: q,
        contentCol: W + 1,
        markerCol: G,
        isEmpty: !0
    };
    for(; F < Z && ($.charCodeAt(F) === $0a39817bbf114bf6$var$v || $.charCodeAt(F) === $0a39817bbf114bf6$var$b);){
        if ($.charCodeAt(F) === $0a39817bbf114bf6$var$b) {
            var O = 4 - D % 4;
            D += O;
        } else D++;
        F++, z++;
    }
    var H = F >= Z, B = D - W;
    return H || B > 4 ? (D = W + 1, F = q + 1, z = 1) : z === 0 && (D = W + 1, F = q, z = 1), {
        ordered: Y >= $0a39817bbf114bf6$var$i && Y <= $0a39817bbf114bf6$var$a,
        marker: Y >= $0a39817bbf114bf6$var$i && Y <= $0a39817bbf114bf6$var$a ? $[J] : $[V],
        start: Y >= $0a39817bbf114bf6$var$i && Y <= $0a39817bbf114bf6$var$a ? parseInt($.slice(V, J), 10) : void 0,
        contentStart: F,
        contentCol: D,
        markerCol: G,
        isEmpty: H
    };
}
var $0a39817bbf114bf6$var$R9 = 0;
function $0a39817bbf114bf6$var$r4($, Q, Z, V) {
    var Y = 0, G = Q;
    for($0a39817bbf114bf6$var$R9 = 0; G < Z && Y < V;){
        var K = $.charCodeAt(G);
        if (K === $0a39817bbf114bf6$var$b) {
            var J = 4 - Y % 4;
            if (Y + J > V) {
                $0a39817bbf114bf6$var$R9 = Y + J - V, G++, Y = V;
                break;
            }
            Y += J;
        } else if (K === $0a39817bbf114bf6$var$v) Y++;
        else break;
        G++;
    }
    return G;
}
function $0a39817bbf114bf6$var$p$($, Q, Z, V) {
    var Y = $0a39817bbf114bf6$var$X0($, Q), G = $0a39817bbf114bf6$var$g5($, Q, Y);
    if (!G) return null;
    var K = [], J = Q, X = G.contentCol, U = "", q = G.isEmpty, W = !1, z = !1;
    if (!G.isEmpty) {
        for(var F = !1, D = G.contentStart; D < Y; D++)if ($.charCodeAt(D) === $0a39817bbf114bf6$var$b) {
            F = !0;
            break;
        }
        if (F) {
            var O = "", H = $0a39817bbf114bf6$var$Z4($, Q, G.contentStart), B = H - G.contentCol;
            if (B > 0) for(var M = 0; M < B; M++)O += " ";
            for(var j = G.contentStart; j < Y; j++)if ($.charCodeAt(j) === $0a39817bbf114bf6$var$b) {
                for(var w = 4 - H % 4, I = 0; I < w; I++)O += " ";
                H += w;
            } else O += $[j], H++;
            U = O + `
`;
        } else U = $.slice(G.contentStart, Y) + `
`;
    }
    for(J = $0a39817bbf114bf6$var$s($, Y); J < $.length;){
        var A = $0a39817bbf114bf6$var$X0($, J);
        $0a39817bbf114bf6$var$P0($, J, A);
        var k = $.charCodeAt(J + $0a39817bbf114bf6$var$Z0);
        if ($0a39817bbf114bf6$var$J0 < X && (k === $0a39817bbf114bf6$var$p || k === $0a39817bbf114bf6$var$_0 || k === $0a39817bbf114bf6$var$H0) && $0a39817bbf114bf6$var$J0 <= 3 && $0a39817bbf114bf6$var$x5($, J)) break;
        var S = $0a39817bbf114bf6$var$g5($, J, A);
        if (S && S.ordered === G.ordered && S.marker === G.marker && S.markerCol < X) {
            K.push({
                contentCol: X,
                raw: U,
                hasBlankAfter: W,
                isEmpty: q
            }), W && (z = !0), X = S.contentCol, q = S.isEmpty, W = !1, U = S.isEmpty ? "" : $.slice(S.contentStart, A) + `
`, J = $0a39817bbf114bf6$var$s($, A);
            continue;
        }
        if ($0a39817bbf114bf6$var$e0($, J, A)) {
            U += `
`, J = $0a39817bbf114bf6$var$s($, A);
            for(var R = !1, N = 0; N < U.length; N++){
                var T = U.charCodeAt(N);
                if (T !== $0a39817bbf114bf6$var$E && T !== $0a39817bbf114bf6$var$_5 && T !== $0a39817bbf114bf6$var$v && T !== $0a39817bbf114bf6$var$b) {
                    R = !0;
                    break;
                }
            }
            if (q && !R) {
                if (J < $.length) {
                    var L = $0a39817bbf114bf6$var$X0($, J), u = $0a39817bbf114bf6$var$g5($, J, L);
                    if (!u || u.ordered !== G.ordered || u.marker !== G.marker) break;
                    W = !0;
                } else break;
            }
            if (J < $.length) {
                var x = $0a39817bbf114bf6$var$X0($, J);
                $0a39817bbf114bf6$var$P0($, J, x);
                var g = $.charCodeAt(J + $0a39817bbf114bf6$var$Z0);
                if ((g === $0a39817bbf114bf6$var$p || g === $0a39817bbf114bf6$var$_0 || g === $0a39817bbf114bf6$var$H0) && $0a39817bbf114bf6$var$J0 <= 3 && $0a39817bbf114bf6$var$x5($, J)) break;
                var P = $0a39817bbf114bf6$var$g5($, J, x);
                if (P && P.ordered === G.ordered && P.marker === G.marker && P.markerCol < X) {
                    W = !0;
                    continue;
                }
                if (!$0a39817bbf114bf6$var$e0($, J, x) && $0a39817bbf114bf6$var$J0 < X) break;
            }
            continue;
        }
        if ($0a39817bbf114bf6$var$J0 >= X) {
            var C = $0a39817bbf114bf6$var$r4($, J, A, X);
            if ($0a39817bbf114bf6$var$R9 > 0) {
                for(var d = "", f = X, U0 = 0; U0 < $0a39817bbf114bf6$var$R9; U0++)d += " ", f++;
                for(var n = C; n < A; n++)if ($.charCodeAt(n) === $0a39817bbf114bf6$var$b) {
                    for(var m0 = 4 - f % 4, x0 = 0; x0 < m0; x0++)d += " ";
                    f += m0;
                } else d += $[n], f++;
                U += d + `
`;
            } else U += $.slice(C, A) + `
`;
            J = $0a39817bbf114bf6$var$s($, A);
            continue;
        }
        for(var v0 = !1, l = 0; l < U.length; l++){
            var t = U.charCodeAt(l);
            if (t !== $0a39817bbf114bf6$var$E && t !== $0a39817bbf114bf6$var$_5 && t !== $0a39817bbf114bf6$var$v && t !== $0a39817bbf114bf6$var$b) {
                v0 = !0;
                break;
            }
        }
        if (!W && v0 && !q) {
            var b0 = J + $0a39817bbf114bf6$var$Z0, r = $.charCodeAt(b0), z0 = r === $0a39817bbf114bf6$var$Y5 || r === $0a39817bbf114bf6$var$o || r === $0a39817bbf114bf6$var$G0 || r === $0a39817bbf114bf6$var$$0 || r === $0a39817bbf114bf6$var$N0 || (r === $0a39817bbf114bf6$var$p || r === $0a39817bbf114bf6$var$_0 || r === $0a39817bbf114bf6$var$H0 || r === $0a39817bbf114bf6$var$N5) && ($0a39817bbf114bf6$var$x5($, J) !== null || $0a39817bbf114bf6$var$g5($, J, A) !== null) || r >= $0a39817bbf114bf6$var$i && r <= $0a39817bbf114bf6$var$a && $0a39817bbf114bf6$var$g5($, J, A) !== null;
            if (!z0) {
                U += "" + $.slice(b0, A) + `
`, J = $0a39817bbf114bf6$var$s($, A);
                continue;
            }
        }
        break;
    }
    if (K.push({
        contentCol: X,
        raw: U,
        hasBlankAfter: W,
        isEmpty: q
    }), K.length === 0) return null;
    var Q0 = z;
    if (!Q0) for(var I0 = 0; I0 < K.length; I0++){
        if (K[I0].hasBlankAfter && I0 < K.length - 1) {
            Q0 = !0;
            break;
        }
        if (!K[I0].isEmpty) {
            for(var q0 = K[I0].raw, V0 = q0.length, O0 = 0, m = !1, w0 = !1, g0 = !1, R0 = !1, Z5 = 0, i0 = 0, T0 = -1; O0 < V0;){
                var e = q0.indexOf(`
`, O0);
                if (e < 0 && (e = V0), R0) {
                    $0a39817bbf114bf6$var$P0(q0, O0, e);
                    for(var Y0 = q0.slice(O0 + $0a39817bbf114bf6$var$Z0, e), a0 = 0; a0 < Y0.length && Y0.charCodeAt(a0) === Z5;)a0++;
                    a0 >= i0 && Y0.slice(a0).trim() === "" && (R0 = !1), O0 = e < V0 ? e + 1 : V0;
                    continue;
                }
                if ($0a39817bbf114bf6$var$e0(q0, O0, e)) {
                    T0 >= 0 ? g0 = !0 : m && (w0 = !0), O0 = e < V0 ? e + 1 : V0;
                    continue;
                }
                if ($0a39817bbf114bf6$var$P0(q0, O0, e), T0 >= 0) {
                    if ($0a39817bbf114bf6$var$J0 >= T0) {
                        O0 = e < V0 ? e + 1 : V0;
                        continue;
                    }
                    var B0 = $0a39817bbf114bf6$var$g5(q0, O0, e);
                    if (B0 && B0.markerCol < T0 && B0.contentCol <= T0) {
                        O0 = e < V0 ? e + 1 : V0;
                        continue;
                    }
                    if (B0) {
                        O0 = e < V0 ? e + 1 : V0;
                        continue;
                    }
                    T0 = -1, g0 && (w0 = !0, g0 = !1);
                }
                var A5 = q0.slice(O0 + $0a39817bbf114bf6$var$Z0, e), y = A5.charCodeAt(0);
                if ((y === $0a39817bbf114bf6$var$$0 || y === $0a39817bbf114bf6$var$N0) && $0a39817bbf114bf6$var$J0 <= 3) {
                    for(var F0 = 0; F0 < A5.length && A5.charCodeAt(F0) === y;)F0++;
                    if (F0 >= 3) {
                        if (w0 && m) {
                            Q0 = !0;
                            break;
                        }
                        R0 = !0, Z5 = y, i0 = F0, m = !0, O0 = e < V0 ? e + 1 : V0;
                        continue;
                    }
                }
                var l0 = $0a39817bbf114bf6$var$J0 <= 3 ? $0a39817bbf114bf6$var$g5(q0, O0, e) : null;
                if (l0 && m) {
                    if (w0) {
                        Q0 = !0;
                        break;
                    }
                    T0 = l0.contentCol, g0 = !1, O0 = e < V0 ? e + 1 : V0, m = !0;
                    continue;
                }
                if (w0) {
                    Q0 = !0;
                    break;
                }
                m = !0, O0 = e < V0 ? e + 1 : V0;
            }
            if (Q0) break;
        }
    }
    for(var X5 = [], M5 = 0; M5 < K.length; M5++){
        for(var r0 = K[M5], D0 = r0.raw, S0 = D0.length; S0 > 0 && D0.charCodeAt(S0 - 1) === $0a39817bbf114bf6$var$E;)S0--;
        var L0 = S0 < D0.length ? D0.slice(0, S0) : D0, h0 = null;
        if (L0.length >= 3 && L0.charCodeAt(0) === $0a39817bbf114bf6$var$A0) {
            var Q5 = L0[1];
            (Q5 === " " || Q5 === "x" || Q5 === "X") && L0.charCodeAt(2) === $0a39817bbf114bf6$var$K5 && (h0 = {
                type: $0a39817bbf114bf6$export$e0aa44767d8750d5.gfmTask,
                completed: Q5 === "x" || Q5 === "X"
            }, L0 = L0.slice(3));
        }
        var j0;
        if (r0.isEmpty && L0.trim() === "") j0 = [];
        else if (Q0) {
            var R5 = Z.inList;
            Z.inList = !0, j0 = $0a39817bbf114bf6$var$f5(L0, Z, V), Z.inList = R5;
        } else {
            var z5 = Z.inList;
            if (Z.inList = !0, j0 = $0a39817bbf114bf6$var$f5(L0, Z, V), Z.inList = z5, j0.length === 1 && j0[0].type === $0a39817bbf114bf6$export$e0aa44767d8750d5.paragraph) j0 = j0[0].children;
            else if (Z.h) {
                var H5 = [];
                Z.h.push({
                    src: j0,
                    dest: H5,
                    unwrap: !0
                }), j0 = H5;
            } else {
                for(var o5 = [], j5 = 0; j5 < j0.length; j5++)if (j0[j5].type === $0a39817bbf114bf6$export$e0aa44767d8750d5.paragraph) for(var O5 = j0[j5].children, Z9 = 0; Z9 < O5.length; Z9++)o5.push(O5[Z9]);
                else o5.push(j0[j5]);
                j0 = o5;
            }
        }
        if (h0) {
            var Q9 = [
                h0,
                {
                    type: $0a39817bbf114bf6$export$e0aa44767d8750d5.text,
                    text: " "
                }
            ];
            if (Z.h) Z.h.push({
                src: j0,
                dest: Q9,
                unwrap: !1
            });
            else for(var B5 = 0; B5 < j0.length; B5++)Q9.push(j0[B5]);
            X5.push(Q9);
        } else X5.push(j0);
    }
    return {
        node: {
            type: G.ordered ? $0a39817bbf114bf6$export$e0aa44767d8750d5.orderedList : $0a39817bbf114bf6$export$e0aa44767d8750d5.unorderedList,
            start: G.ordered ? G.start : void 0,
            items: X5
        },
        end: J
    };
}
var $0a39817bbf114bf6$var$y9 = new Set([
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
]);
function $0a39817bbf114bf6$var$b5($, Q, Z) {
    let V = {};
    for (let [K, J] of Object.entries($)){
        let X = K.toLowerCase();
        if (X === "style" && typeof J == "string") {
            let U = {}, q = [], W = 0, z = 0;
            for(let D = 0; D < J.length; D++){
                let O = J.charCodeAt(D);
                O === $0a39817bbf114bf6$var$F5 ? W++ : O === $0a39817bbf114bf6$var$q5 ? W-- : O === $0a39817bbf114bf6$var$U9 && W === 0 && (q.push(J.slice(z, D)), z = D + 1);
            }
            z < J.length && q.push(J.slice(z));
            let F = !1;
            q.forEach((D)=>{
                let O = D.indexOf(":");
                if (O === -1) return;
                let H = D.slice(0, O).trim(), B = D.slice(O + 1).trim();
                if (H && B) {
                    if (/url\s*\(\s*(javascript|vbscript|data:(?!image\/))/i.test(B)) {
                        F = !0;
                        return;
                    }
                    let M = H.indexOf("-") !== -1 ? H.replace(/-([a-z])/g, (j, w)=>w.toUpperCase()) : H;
                    U[M] = B;
                }
            }), !F && Object.keys(U).length > 0 && (V[K] = U);
        } else if ((X === "href" || X === "src") && Z?.sanitizer) {
            let U = Z.sanitizer(J, Q, X);
            U !== null && (V[K] = U);
        } else if (J === "") V[K] = !0;
        else if (J.length >= 2 && J.charCodeAt(0) === $0a39817bbf114bf6$var$L5 && J.charCodeAt(J.length - 1) === $0a39817bbf114bf6$var$I9) {
            var Y = J.slice(1, -1);
            if (Y.length > 0) {
                var G = Y.charCodeAt(0);
                if (G === $0a39817bbf114bf6$var$A0 || G === $0a39817bbf114bf6$var$L5) try {
                    V[K] = JSON.parse(Y);
                    continue;
                } catch  {}
            }
            if (Y === "true") {
                V[K] = !0;
                continue;
            }
            if (Y === "false") {
                V[K] = !1;
                continue;
            }
            if (Z?.evalUnserializableExpressions) try {
                V[K] = (0, eval)("(" + Y + ")");
                continue;
            } catch  {}
            V[K] = Y;
        } else V[K] = J;
    }
    return V;
}
function $0a39817bbf114bf6$var$T5($, Q, Z) {
    let V = Q.length;
    if (V === 0) return Z;
    var Y = Q.charCodeAt(0), G = Y >= $0a39817bbf114bf6$var$h && Y <= $0a39817bbf114bf6$var$c || Y >= $0a39817bbf114bf6$var$K0 && Y <= $0a39817bbf114bf6$var$W0;
    if (!G) {
        for(var K = String.fromCharCode(Y), J = $.length - V, X = Z; X <= J;){
            var U = $.indexOf(K, X);
            if (U === -1 || U > J) return -1;
            for(var q = !0, W = 1; W < V; W++){
                var z = $.charCodeAt(U + W), F = Q.charCodeAt(W);
                if (z >= $0a39817bbf114bf6$var$h && z <= $0a39817bbf114bf6$var$c && (z += $0a39817bbf114bf6$var$J5), F >= $0a39817bbf114bf6$var$h && F <= $0a39817bbf114bf6$var$c && (F += $0a39817bbf114bf6$var$J5), z !== F) {
                    q = !1;
                    break;
                }
            }
            if (q) return U;
            X = U + 1;
        }
        return -1;
    }
    Y >= $0a39817bbf114bf6$var$h && Y <= $0a39817bbf114bf6$var$c && (Y += $0a39817bbf114bf6$var$J5);
    for(let O = Z; O <= $.length - V; O++){
        var D = $.charCodeAt(O);
        if (D >= $0a39817bbf114bf6$var$h && D <= $0a39817bbf114bf6$var$c && (D += $0a39817bbf114bf6$var$J5), D !== Y) continue;
        let H = !0;
        for(let B = 1; B < V; B++){
            let M = $.charCodeAt(O + B), j = Q.charCodeAt(B);
            if (M >= $0a39817bbf114bf6$var$h && M <= $0a39817bbf114bf6$var$c && (M += $0a39817bbf114bf6$var$J5), j >= $0a39817bbf114bf6$var$h && j <= $0a39817bbf114bf6$var$c && (j += $0a39817bbf114bf6$var$J5), M !== j) {
                H = !1;
                break;
            }
        }
        if (H) return O;
    }
    return -1;
}
function $0a39817bbf114bf6$var$o4($, Q, Z) {
    let V = Q.length;
    var Y = Q.charCodeAt(0);
    Y >= $0a39817bbf114bf6$var$h && Y <= $0a39817bbf114bf6$var$c && (Y += $0a39817bbf114bf6$var$J5);
    for(let K = Math.min(Z, $.length - V); K >= 0; K--){
        var G = $.charCodeAt(K);
        if (G >= $0a39817bbf114bf6$var$h && G <= $0a39817bbf114bf6$var$c && (G += $0a39817bbf114bf6$var$J5), G !== Y) continue;
        let J = !0;
        for(let X = 1; X < V; X++){
            let U = $.charCodeAt(K + X), q = Q.charCodeAt(X);
            if (U >= $0a39817bbf114bf6$var$h && U <= $0a39817bbf114bf6$var$c && (U += $0a39817bbf114bf6$var$J5), q >= $0a39817bbf114bf6$var$h && q <= $0a39817bbf114bf6$var$c && (q += $0a39817bbf114bf6$var$J5), U !== q) {
                J = !1;
                break;
            }
        }
        if (J) return K;
    }
    return -1;
}
var $0a39817bbf114bf6$var$k9 = -1;
function $0a39817bbf114bf6$var$o9($, Q, Z) {
    let V = Z.toLowerCase(), Y = "<" + V, G = "</" + V, K = 1, J = Q, X = $.length;
    for($0a39817bbf114bf6$var$k9 = -1; J < X && K > 0;){
        let W = $0a39817bbf114bf6$var$T5($, Y, J), z = $0a39817bbf114bf6$var$T5($, G, J);
        if (z === -1) return -1;
        if (W !== -1 && W < z) {
            let F = $0a39817bbf114bf6$var$w5($, W);
            F ? (F.tag.toLowerCase() === V && !F.isClosing && !F.selfClosing && !$0a39817bbf114bf6$var$l5(F.tag) && K++, J = F.end) : J = W + 1;
        } else {
            var U = z + G.length, q = U < X ? $.charCodeAt(U) : 62;
            if ((q === $0a39817bbf114bf6$var$o || q === $0a39817bbf114bf6$var$v || q === $0a39817bbf114bf6$var$b || q === $0a39817bbf114bf6$var$E) && (K--, K === 0)) {
                $0a39817bbf114bf6$var$k9 = z;
                let F = z + G.length;
                for(; F < X && $.charCodeAt(F) !== $0a39817bbf114bf6$var$o;)F++;
                return F + 1;
            }
            J = z + 1;
        }
    }
    return -1;
}
function $0a39817bbf114bf6$var$Q4($, Q, Z, V) {
    if (V.ignoreHTMLBlocks || V.disableParsingRawHTML) return null;
    var Y = $0a39817bbf114bf6$var$X0($, Q);
    if ($0a39817bbf114bf6$var$P0($, Q, Y), $0a39817bbf114bf6$var$J0 > 3 && !Z.inHTML) return null;
    var G = Q + $0a39817bbf114bf6$var$Z0;
    if ($.charCodeAt(G) !== $0a39817bbf114bf6$var$G0) return null;
    var K = $.indexOf(">", G + 1);
    if (K !== -1 && K < Y) {
        var J = $.slice(G + 1, K);
        if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(J) || /^[^\s@]+@[^\s@]+$/.test(J)) return null;
    }
    var X = $0a39817bbf114bf6$var$i4($, G);
    if (X >= 1 && X <= 5) {
        var U = $.length;
        if (X === 1) {
            for(var q = $.length, W = 0; W < $0a39817bbf114bf6$var$c9.length; W++){
                var z = $0a39817bbf114bf6$var$T5($, "</" + $0a39817bbf114bf6$var$c9[W] + ">", G);
                z >= 0 && z < q && (q = z);
            }
            if (q < $.length) {
                var F = $.indexOf(">", q);
                U = F >= 0 ? $0a39817bbf114bf6$var$s($, F + 1) : $.length;
            }
        } else {
            var D = X === 2 ? "-->" : X === 3 ? "?>" : X === 4 ? ">" : "]]>", O = $.indexOf(D, G);
            O >= 0 && (U = $0a39817bbf114bf6$var$s($, O + D.length));
        }
        var H = $.slice(G, U);
        if (X >= 2) return {
            node: {
                type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlComment,
                text: H,
                l: !1,
                raw: !0
            },
            end: U
        };
        var B = "div", M = H.match(/^<\/?([a-zA-Z][a-zA-Z0-9-]*)/);
        M && (B = M[1]);
        var j = $0a39817bbf114bf6$var$w5($, G), w = {}, I;
        j && !j.isClosing && (w = $0a39817bbf114bf6$var$b5(j.attrs, B, V), I = j.whitespaceBeforeAttrs + j.rawAttrs);
        var A = [], k = B.toLowerCase(), S = "</" + k, R = $0a39817bbf114bf6$var$T5(H, S, 0), N = H, T = "";
        if (j && j.isClosing) for(N = H.slice(j.end - G); N.length > 0 && N.charCodeAt(N.length - 1) === $0a39817bbf114bf6$var$E;)N = N.slice(0, -1);
        else if (j && !j.isClosing) {
            var L = j.end - G;
            if (R !== -1) for(N = H.slice(L), N.charCodeAt(0) === $0a39817bbf114bf6$var$E && (N = N.slice(1)); N.length > 0 && N.charCodeAt(N.length - 1) === $0a39817bbf114bf6$var$E;)N = N.slice(0, -1);
            else for(N = H; N.length > 0 && N.charCodeAt(N.length - 1) === $0a39817bbf114bf6$var$E;)N = N.slice(0, -1);
            if (R !== -1) {
                var u = H.slice(L, R);
                T = u.trim();
            }
        }
        var x = j ? j.isClosing : !1;
        return {
            node: {
                type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlBlock,
                tag: B,
                attrs: w,
                i: I,
                children: A,
                a: N,
                text: T,
                d: !0,
                b: x
            },
            end: U
        };
    }
    if (X === 6 || X === 7) {
        var g = $0a39817bbf114bf6$var$u$($, Q), P = g < $.length ? g : $.length, C = $.slice(G, P), d = g < $.length ? $0a39817bbf114bf6$var$s($, g) : $.length, f = $0a39817bbf114bf6$var$w5($, G);
        if (f) {
            var U0 = f.tag, n = U0.toLowerCase(), m0 = f.isClosing;
            if (m0) {
                var x0 = $.slice(f.end, P);
                return {
                    node: {
                        type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlBlock,
                        tag: U0,
                        attrs: {},
                        children: [],
                        a: x0,
                        text: x0,
                        d: !0,
                        b: !0
                    },
                    end: d
                };
            }
            if (f.selfClosing || $0a39817bbf114bf6$var$l5(U0)) return {
                node: {
                    type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlBlock,
                    tag: U0,
                    attrs: $0a39817bbf114bf6$var$b5(f.attrs, U0, V),
                    i: f.whitespaceBeforeAttrs + f.rawAttrs,
                    children: [],
                    a: "",
                    text: "",
                    d: !1,
                    b: !1
                },
                end: f.end < $.length && $.charCodeAt(f.end) === $0a39817bbf114bf6$var$E ? f.end + 1 : f.end
            };
            var v0 = Z.c || 0, l = $.slice(G, P), t = -1, b0 = -1;
            if (v0 < 10) {
                for(var r = "</" + n, z0 = f.end - G, Q0 = 1, I0 = z0; I0 < l.length && Q0 > 0;){
                    var q0 = $0a39817bbf114bf6$var$T5(l, "<" + n, I0), V0 = $0a39817bbf114bf6$var$T5(l, r, I0);
                    if (V0 === -1) break;
                    if (q0 !== -1 && q0 < V0) {
                        var O0 = q0 + n.length + 1;
                        if (O0 < l.length) {
                            var m = l.charCodeAt(O0);
                            (m === $0a39817bbf114bf6$var$v || m === $0a39817bbf114bf6$var$b || m === $0a39817bbf114bf6$var$E || m === $0a39817bbf114bf6$var$o || m === $0a39817bbf114bf6$var$M0) && Q0++;
                        }
                        I0 = q0 + 1;
                    } else {
                        var w0 = V0 + r.length;
                        if (w0 < l.length) {
                            var g0 = l.charCodeAt(w0);
                            if ((g0 === $0a39817bbf114bf6$var$o || g0 === $0a39817bbf114bf6$var$v || g0 === $0a39817bbf114bf6$var$b || g0 === $0a39817bbf114bf6$var$E) && (Q0--, Q0 === 0)) {
                                t = V0;
                                for(var R0 = w0; R0 < l.length && l.charCodeAt(R0) !== $0a39817bbf114bf6$var$o;)R0++;
                                b0 = R0 + 1;
                                break;
                            }
                        } else if (Q0--, Q0 === 0) {
                            t = V0, b0 = l.length;
                            break;
                        }
                        I0 = V0 + 1;
                    }
                }
                var Z5 = !1;
                if (t === -1 && X === 6 && !f.isClosing) {
                    var i0 = $0a39817bbf114bf6$var$o9($, f.end, n);
                    if (i0 !== -1) {
                        for(var T0 = $0a39817bbf114bf6$var$k9, e = f.end, Y0 = !1, a0 = !1, B0 = !1, A5 = 0, y = !1, F0 = !1, l0 = e; l0 < T0;){
                            var X5 = $.charCodeAt(l0);
                            if (X5 === $0a39817bbf114bf6$var$E) F0 && (Y0 = !0), y || A5++, F0 = !0, l0++;
                            else if (X5 === $0a39817bbf114bf6$var$v || X5 === $0a39817bbf114bf6$var$b) l0++;
                            else {
                                if (!y && (y = !0, A5 >= 2 && X5 === $0a39817bbf114bf6$var$G0)) {
                                    B0 = !0;
                                    break;
                                }
                                if (F0 = !1, X5 === $0a39817bbf114bf6$var$G0) {
                                    var M5 = $.charCodeAt(l0 + 1) | 32;
                                    if ((M5 === $0a39817bbf114bf6$var$_9 || M5 === $0a39817bbf114bf6$var$f9 || M5 === $0a39817bbf114bf6$var$h5) && ($0a39817bbf114bf6$var$f$.lastIndex = l0, $0a39817bbf114bf6$var$f$.test($))) {
                                        a0 = !0;
                                        break;
                                    }
                                }
                                l0++;
                            }
                        }
                        if (Y0 && !B0 && !a0) {
                            var r0 = $0a39817bbf114bf6$var$X0($, i0);
                            P = r0, d = $0a39817bbf114bf6$var$s($, r0), l = $.slice(G, P), C = $.slice(G, P), t = T0 - G, b0 = i0 - G, Z5 = !0;
                        }
                    }
                }
            }
            var D0 = f.rawAttrs.indexOf(`
`) !== -1 || f.whitespaceBeforeAttrs.indexOf(`
`) !== -1, S0 = !1;
            if (t !== -1) {
                var L0 = l.slice(b0).trim();
                S0 = L0.length === 0;
            }
            var h0 = !1, Q5 = P, j0 = d;
            if (t !== -1) {
                var R5 = G + b0, z5 = $0a39817bbf114bf6$var$X0($, R5 - 1);
                if (R5 < z5) {
                    for(var H5 = R5; H5 < z5 && ($.charCodeAt(H5) === $0a39817bbf114bf6$var$v || $.charCodeAt(H5) === $0a39817bbf114bf6$var$b);)H5++;
                    if (H5 < z5 && $.charCodeAt(H5) === $0a39817bbf114bf6$var$G0) {
                        var o5 = $0a39817bbf114bf6$var$w5($, H5);
                        o5 && !o5.isClosing && (h0 = !0, Q5 = R5, j0 = R5, S0 = !0);
                    }
                }
                if (!h0) {
                    var j5 = $0a39817bbf114bf6$var$s($, z5);
                    if (j5 < P) {
                        for(var O5 = j5; O5 < P && ($.charCodeAt(O5) === $0a39817bbf114bf6$var$v || $.charCodeAt(O5) === $0a39817bbf114bf6$var$b);)O5++;
                        if (O5 < P && $.charCodeAt(O5) === $0a39817bbf114bf6$var$G0) {
                            var Z9 = $0a39817bbf114bf6$var$w5($, O5);
                            Z9 && (h0 = !0, Q5 = z5, j0 = j5, S0 = !0);
                        }
                    }
                }
                if (!h0 && Z.inHTML) {
                    h0 = !0, Q5 = z5, j0 = $0a39817bbf114bf6$var$s($, z5);
                    var Q9 = $.slice(R5, z5).trim();
                    S0 = Q9.length === 0;
                }
            }
            var B5 = [], n0 = "";
            if (t !== -1) {
                n0 = l.slice(f.end - G, t);
                var i5 = n0.trim();
                if (i5) {
                    var { inline: K4, inHTML: J4, c: X4 } = Z;
                    Z.inHTML = !0, Z.c = v0 + 1;
                    var U4 = n === "p";
                    if (U4) Z.inline = !0, B5 = $0a39817bbf114bf6$var$$9(i5, !1, Z, V);
                    else {
                        var Q$ = n0.indexOf(`

`) !== -1, V$ = $0a39817bbf114bf6$var$d9.test(i5), S9 = $0a39817bbf114bf6$var$C$.test(i5), F4 = Q$ || V$ || Z.inHTML && S9, q4 = n0.length >= 2 && n0.charCodeAt(0) === $0a39817bbf114bf6$var$E && n0.charCodeAt(n0.length - 1) === $0a39817bbf114bf6$var$E && !Q$;
                        q4 && !V$ && !S9 ? B5 = [
                            {
                                type: $0a39817bbf114bf6$export$e0aa44767d8750d5.text,
                                text: i5
                            }
                        ] : F4 || S9 ? (Z.inline = !1, B5 = $0a39817bbf114bf6$var$f5(n0, Z, V)) : (Z.inline = !0, B5 = $0a39817bbf114bf6$var$$9(i5, !1, Z, V));
                    }
                    Z.inline = K4, Z.inHTML = J4, Z.c = X4;
                }
            }
            var Y$ = !1;
            if (X === 6 && t !== -1 && !Z.inHTML && !D0) {
                var W4 = /<[a-zA-Z][^>]*>/.test(n0), z4 = n0.indexOf(`

`) !== -1 || $0a39817bbf114bf6$var$d9.test(n0);
                W4 && !z4 && (Y$ = !0);
            }
            var H4 = !Z5 && (Z.inHTML || X === 7 || D0 || !S0 || Y$);
            if (H4) {
                var V5, G$ = !1;
                if (t !== -1 && h0) {
                    var K$ = !1;
                    if (Z.inHTML && b0 < l.length) {
                        for(var O9 = b0; O9 < l.length && l.charCodeAt(O9) !== $0a39817bbf114bf6$var$E;)O9++;
                        var L9 = l.slice(b0, O9).trim();
                        K$ = L9.length > 1 && L9.charCodeAt(0) === $0a39817bbf114bf6$var$G0 && L9.charCodeAt(1) !== $0a39817bbf114bf6$var$M0;
                    }
                    V5 = K$ ? l.slice(f.end - G) : n0, G$ = !0;
                } else (X === 7 || Z.inHTML) && t !== -1 ? (V5 = l.slice(f.end - G), V5.charCodeAt(0) === $0a39817bbf114bf6$var$E && (V5 = V5.slice(1))) : h0 ? V5 = $.slice(G, Q5) : D0 ? V5 = C : (V5 = l.slice(f.end - G), V5.charCodeAt(0) === $0a39817bbf114bf6$var$E && (V5 = V5.slice(1)));
                var J$ = {
                    type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlBlock,
                    tag: U0,
                    attrs: $0a39817bbf114bf6$var$b5(f.attrs, U0, V),
                    i: f.whitespaceBeforeAttrs + f.rawAttrs,
                    children: B5,
                    a: V5,
                    text: V5,
                    d: !0,
                    b: !1
                };
                return G$ && (J$.n = !0), {
                    node: J$,
                    end: j0
                };
            }
            return {
                node: {
                    type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlBlock,
                    tag: U0,
                    attrs: $0a39817bbf114bf6$var$b5(f.attrs, U0, V),
                    i: f.whitespaceBeforeAttrs + f.rawAttrs,
                    children: B5,
                    a: Z5 ? "" : n0,
                    text: n0,
                    d: !1,
                    b: !1
                },
                end: j0
            };
        }
        var B9 = C.match(/^<(\/?)([a-zA-Z][a-zA-Z0-9-]*)/), O4 = B9 ? B9[2] : "div", X$ = B9 ? B9[1] === "/" : !1, E9 = C;
        if (X$) {
            var U$ = C.indexOf(">");
            U$ !== -1 && (E9 = C.slice(U$ + 1));
        }
        return {
            node: {
                type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlBlock,
                tag: O4,
                attrs: {},
                children: [],
                a: E9,
                text: E9,
                d: !0,
                b: X$
            },
            end: d
        };
    }
    var u0 = $0a39817bbf114bf6$var$w5($, G);
    if (!u0) return null;
    var y5 = u0.tag, g9 = y5.toLowerCase(), F$ = y5.charCodeAt(0), D9 = F$ >= $0a39817bbf114bf6$var$h && F$ <= $0a39817bbf114bf6$var$c;
    if (!D9 && !$0a39817bbf114bf6$var$y9.has(g9) && !$0a39817bbf114bf6$var$z9.has(g9) && !g9.includes("-")) return null;
    if (u0.isClosing) return {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlSelfClosing,
            tag: y5,
            attrs: {},
            a: $.slice(G, u0.end),
            b: !0
        },
        end: u0.end
    };
    var m5 = $0a39817bbf114bf6$var$o9($, u0.end, y5), V9 = [];
    if (m5 !== -1) {
        var B4 = $0a39817bbf114bf6$var$k9, A9 = $.slice(u0.end, B4), M9 = A9.trim();
        if (M9) {
            var D4 = A9.indexOf(`

`) !== -1, A4 = $0a39817bbf114bf6$var$d9.test(M9), M4 = $0a39817bbf114bf6$var$C$.test(M9), j4 = Z.inline, _4 = Z.inHTML, I4 = Z.c;
            Z.inHTML = !0, Z.c = (Z.c || 0) + 1, D4 || A4 || M4 ? (Z.inline = !1, V9 = $0a39817bbf114bf6$var$f5(A9, Z, V)) : (Z.inline = !0, V9 = $0a39817bbf114bf6$var$$9(M9, !1, Z, V)), Z.inline = j4, Z.inHTML = _4, Z.c = I4;
        }
        var v4 = $0a39817bbf114bf6$var$X0($, m5), N4 = $.slice(m5, v4).trim(), T9 = N4 ? m5 : $0a39817bbf114bf6$var$s($, m5), q$ = D9 ? $.slice(G, m5) : $.slice(G, T9), A6 = D9 ? m5 : T9;
        return {
            node: {
                type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlBlock,
                tag: y5,
                attrs: $0a39817bbf114bf6$var$b5(u0.attrs, y5, V),
                i: u0.whitespaceBeforeAttrs + u0.rawAttrs,
                children: V9,
                a: q$,
                text: D9 ? A9 : q$,
                d: !0,
                b: !1
            },
            end: T9
        };
    }
    var Y9 = $0a39817bbf114bf6$var$u$($, u0.end), P4 = Y9 < $.length ? $0a39817bbf114bf6$var$s($, Y9) : Y9, x9 = $.slice(u0.end, Y9);
    if (x9.trim()) {
        var { inline: b4, inHTML: w4, c: R4 } = Z;
        Z.inline = !1, Z.inHTML = !0, Z.c = (Z.c || 0) + 1, V9 = $0a39817bbf114bf6$var$f5(x9, Z, V), Z.inline = b4, Z.inHTML = w4, Z.c = R4;
    }
    var y4 = $.slice(u0.end, Y9);
    return {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlBlock,
            tag: y5,
            attrs: $0a39817bbf114bf6$var$b5(u0.attrs, y5, V),
            i: u0.whitespaceBeforeAttrs + u0.rawAttrs,
            children: V9,
            a: y4,
            text: x9,
            d: !0,
            b: !1
        },
        end: P4
    };
}
function $0a39817bbf114bf6$var$i4($, Q) {
    if ($.charCodeAt(Q) !== $0a39817bbf114bf6$var$G0) return 0;
    var Z = Q + 1, V = $.length;
    if ($.charCodeAt(Z) === $0a39817bbf114bf6$var$p0 && $.charCodeAt(Z + 1) === $0a39817bbf114bf6$var$p && $.charCodeAt(Z + 2) === $0a39817bbf114bf6$var$p) return 2;
    if ($.charCodeAt(Z) === $0a39817bbf114bf6$var$a5) return 3;
    if ($.charCodeAt(Z) === $0a39817bbf114bf6$var$p0) {
        var Y = $.charCodeAt(Z + 1);
        if (Y >= $0a39817bbf114bf6$var$h && Y <= $0a39817bbf114bf6$var$c) return 4;
        if ($.slice(Z + 1, Z + 8) === "[CDATA[") return 5;
    }
    for(var G = $.charCodeAt(Z) === $0a39817bbf114bf6$var$M0, K = G ? Z + 1 : Z, J = K; J < V;){
        var X = $.charCodeAt(J);
        if (X >= $0a39817bbf114bf6$var$h && X <= $0a39817bbf114bf6$var$c || X >= $0a39817bbf114bf6$var$K0 && X <= $0a39817bbf114bf6$var$W0 || X >= $0a39817bbf114bf6$var$i && X <= $0a39817bbf114bf6$var$a || X === $0a39817bbf114bf6$var$p) J++;
        else break;
    }
    if (J === K) return 0;
    var U = $.slice(K, J);
    if ($0a39817bbf114bf6$var$z9.has(U.toLowerCase())) {
        if (G) return 0;
        var q = $.charCodeAt(J);
        return q === $0a39817bbf114bf6$var$v || q === $0a39817bbf114bf6$var$b || q === $0a39817bbf114bf6$var$o || q === $0a39817bbf114bf6$var$E || J >= V ? 1 : 0;
    }
    if ($0a39817bbf114bf6$var$y9.has(U.toLowerCase())) {
        if (G) {
            for(var W = J; W < V && ($.charCodeAt(W) === $0a39817bbf114bf6$var$v || $.charCodeAt(W) === $0a39817bbf114bf6$var$b);)W++;
            return W < V && $.charCodeAt(W) === $0a39817bbf114bf6$var$o ? 6 : 0;
        }
        var z = J < V ? $.charCodeAt(J) : -1;
        return z === $0a39817bbf114bf6$var$v || z === $0a39817bbf114bf6$var$b || z === $0a39817bbf114bf6$var$o || z === $0a39817bbf114bf6$var$E || z === $0a39817bbf114bf6$var$M0 || z === -1 ? 6 : 0;
    }
    if (G) {
        for(var H = J; H < V && ($.charCodeAt(H) === $0a39817bbf114bf6$var$v || $.charCodeAt(H) === $0a39817bbf114bf6$var$b);)H++;
        if (H < V && $.charCodeAt(H) === $0a39817bbf114bf6$var$o) {
            var B = $0a39817bbf114bf6$var$X0($, Q), M = $.slice(H + 1, B).trim();
            if (M === "") return 7;
        }
    } else {
        var F = $0a39817bbf114bf6$var$X0($, Q), D = $0a39817bbf114bf6$var$w5($, Q);
        if (D && D.end <= F) {
            var O = $.slice(D.end, F).trim();
            if (O === "") return 7;
        }
    }
    return 0;
}
function $0a39817bbf114bf6$var$d$($, Q, Z) {
    for(var V = 0, Y = $.length; V < Y && ($.charCodeAt(V) === $0a39817bbf114bf6$var$v || $.charCodeAt(V) === $0a39817bbf114bf6$var$b);)V++;
    for(; Y > V && ($.charCodeAt(Y - 1) === $0a39817bbf114bf6$var$v || $.charCodeAt(Y - 1) === $0a39817bbf114bf6$var$b);)Y--;
    V < Y && $.charCodeAt(V) === $0a39817bbf114bf6$var$k0 && V++, Y > V && $.charCodeAt(Y - 1) === $0a39817bbf114bf6$var$k0 && (Y - 2 < V || $.charCodeAt(Y - 2) !== $0a39817bbf114bf6$var$y0) && Y--;
    for(var G = [], K = V, J = !1, X = [], U = V; U < Y;){
        var q = $.charCodeAt(U);
        if (q === $0a39817bbf114bf6$var$y0 && U + 1 < Y) {
            $.charCodeAt(U + 1) === $0a39817bbf114bf6$var$k0 ? (J || (J = !0, X = []), X.push($.slice(K, U)), X.push("|"), U += 2, K = U) : U += 2;
            continue;
        }
        if (q === $0a39817bbf114bf6$var$$0) {
            for(var W = 0; U < Y && $.charCodeAt(U) === $0a39817bbf114bf6$var$$0;)W++, U++;
            for(var z = !1; U < Y && !z;){
                for(var F = 0; U < Y && $.charCodeAt(U) === $0a39817bbf114bf6$var$$0;)F++, U++;
                F === W ? z = !0 : F === 0 && U++;
            }
            continue;
        }
        if (q === $0a39817bbf114bf6$var$k0) {
            var D = J ? (X.push($.slice(K, U)), X.join("")) : $.slice(K, U);
            G.push(D.trim()), U++, K = U, J = !1, X = [];
            continue;
        }
        U++;
    }
    var O = J ? (X.push($.slice(K, Y)), X.join("")) : $.slice(K, Y);
    return G.push(O.trim()), G.map(function(H) {
        var B = H.indexOf("\\|") !== -1 ? H.replace(/\\\|/g, "|") : H;
        return B ? $0a39817bbf114bf6$var$$9(B, !1, Q, Z) : [];
    });
}
function $0a39817bbf114bf6$var$c$($, Q, Z, V) {
    let Y = $0a39817bbf114bf6$var$X0($, Q);
    var G = $.indexOf("|", Q);
    if (G < 0 || G >= Y) return null;
    let K = $0a39817bbf114bf6$var$s($, Y);
    if (K >= $.length) return null;
    let J = $0a39817bbf114bf6$var$X0($, K);
    if (!$0a39817bbf114bf6$var$e$($, K, J)) return null;
    let X = $.slice(Q, Y), U = $.slice(K, J);
    for(var q = [], W = 0, z = U.length; W < z && (U.charCodeAt(W) === $0a39817bbf114bf6$var$v || U.charCodeAt(W) === $0a39817bbf114bf6$var$b);)W++;
    for(W < z && U.charCodeAt(W) === $0a39817bbf114bf6$var$k0 && W++; W < z;){
        for(; W < z && (U.charCodeAt(W) === $0a39817bbf114bf6$var$v || U.charCodeAt(W) === $0a39817bbf114bf6$var$b);)W++;
        if (W >= z || U.charCodeAt(W) === $0a39817bbf114bf6$var$k0) break;
        var F = U.charCodeAt(W) === $0a39817bbf114bf6$var$f0;
        for(F && W++; W < z && U.charCodeAt(W) === $0a39817bbf114bf6$var$p;)W++;
        var D = W < z && U.charCodeAt(W) === $0a39817bbf114bf6$var$f0;
        for(D && W++, q.push(F && D ? "center" : D ? "right" : F ? "left" : null); W < z && (U.charCodeAt(W) === $0a39817bbf114bf6$var$v || U.charCodeAt(W) === $0a39817bbf114bf6$var$b);)W++;
        W < z && U.charCodeAt(W) === $0a39817bbf114bf6$var$k0 && W++;
    }
    let O = $0a39817bbf114bf6$var$d$(X, Z, V);
    if (q.length !== O.length) return null;
    let H = [], B = $0a39817bbf114bf6$var$s($, J);
    for(; B < $.length;){
        let k = $0a39817bbf114bf6$var$X0($, B), S = $.slice(B, k);
        if ($0a39817bbf114bf6$var$e0($, B, k)) break;
        if ($0a39817bbf114bf6$var$P0($, B, k), $0a39817bbf114bf6$var$J0 < 4) {
            var M = $.charCodeAt(B + $0a39817bbf114bf6$var$Z0);
            if (M === $0a39817bbf114bf6$var$o || M === $0a39817bbf114bf6$var$Y5 || (M === $0a39817bbf114bf6$var$p || M === $0a39817bbf114bf6$var$_0 || M === $0a39817bbf114bf6$var$H0) && $0a39817bbf114bf6$var$x5($, B)) break;
            if (M === $0a39817bbf114bf6$var$$0 || M === $0a39817bbf114bf6$var$N0) {
                for(var j = B + $0a39817bbf114bf6$var$Z0, w = 0; j < k && $.charCodeAt(j) === M;)w++, j++;
                if (w >= 3) break;
            }
        }
        H.push($0a39817bbf114bf6$var$d$(S, Z, V)), B = $0a39817bbf114bf6$var$s($, k);
    }
    if (V.optimizeForStreaming && H.length === 0) return null;
    for(var I = O.length, A = 0; A < H.length; A++)if (H[A].length < I) for(; H[A].length < I;)H[A].push([]);
    else H[A].length > I && (H[A].length = I);
    return {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.table,
            header: O,
            cells: H,
            align: q
        },
        end: B
    };
}
function $0a39817bbf114bf6$var$a4($, Q, Z) {
    var V = $0a39817bbf114bf6$var$X0($, Q);
    if ($0a39817bbf114bf6$var$P0($, Q, V), $0a39817bbf114bf6$var$J0 > 3) return null;
    var Y = Q + $0a39817bbf114bf6$var$Z0;
    if ($.charCodeAt(Y) !== $0a39817bbf114bf6$var$A0) return null;
    if (Y + 1 < $.length && $.charCodeAt(Y + 1) === $0a39817bbf114bf6$var$U5) {
        var G = $0a39817bbf114bf6$var$n4($, Y, Z);
        return G || null;
    }
    Z.refs || (Z.refs = {});
    var K = $0a39817bbf114bf6$var$$4($, Y, Z.refs);
    return K === null ? null : {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.refCollection
        },
        end: K
    };
}
function $0a39817bbf114bf6$var$n4($, Q, Z) {
    var V = $.length;
    if ($.charCodeAt(Q) !== $0a39817bbf114bf6$var$A0 || Q + 1 >= V || $.charCodeAt(Q + 1) !== $0a39817bbf114bf6$var$U5) return null;
    for(var Y = Q + 2, G = Y; Y < V && $.charCodeAt(Y) !== $0a39817bbf114bf6$var$K5;){
        if ($.charCodeAt(Y) === $0a39817bbf114bf6$var$E) return null;
        Y++;
    }
    if (Y >= V) return null;
    var K = ("^" + $.slice(G, Y)).toLowerCase();
    if (Y++, Y >= V || $.charCodeAt(Y) !== $0a39817bbf114bf6$var$f0) return null;
    for(Y++; Y < V && ($.charCodeAt(Y) === $0a39817bbf114bf6$var$v || $.charCodeAt(Y) === $0a39817bbf114bf6$var$b);)Y++;
    if (Y < V && $.charCodeAt(Y) === $0a39817bbf114bf6$var$E) for(Y++; Y < V && ($.charCodeAt(Y) === $0a39817bbf114bf6$var$v || $.charCodeAt(Y) === $0a39817bbf114bf6$var$b);)Y++;
    var J = $.indexOf(`
`, Y);
    J < 0 && (J = V);
    for(var X = $.slice(Y, J).trim(), U = J < V ? J + 1 : V; U < V;){
        var q = $0a39817bbf114bf6$var$X0($, U);
        if ($0a39817bbf114bf6$var$P0($, U, q), $0a39817bbf114bf6$var$J0 >= 2 && !$0a39817bbf114bf6$var$e0($, U, q)) X += `
` + $.slice(U, q), U = $0a39817bbf114bf6$var$s($, q);
        else if ($0a39817bbf114bf6$var$e0($, U, q)) {
            var W = $0a39817bbf114bf6$var$s($, q);
            if (W < V) {
                var z = $0a39817bbf114bf6$var$X0($, W);
                if ($0a39817bbf114bf6$var$P0($, W, z), $0a39817bbf114bf6$var$J0 >= 2) {
                    X += `
`, U = $0a39817bbf114bf6$var$s($, q);
                    continue;
                }
            }
            break;
        } else break;
    }
    return Z.refs[K] || (Z.refs[K] = {
        target: X,
        title: void 0
    }), {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.footnote
        },
        end: U
    };
}
function $0a39817bbf114bf6$var$s4($, Q, Z, V) {
    let Y = Q, G = 0, K = 0, J = -1;
    for(; Y < $.length;){
        let u = J >= 0 ? J : $0a39817bbf114bf6$var$X0($, Y);
        if (J = -1, $0a39817bbf114bf6$var$e0($, Y, u)) break;
        if ($0a39817bbf114bf6$var$P0($, Y, u), $0a39817bbf114bf6$var$J0 < 4 && K > 0 && !Z.f) {
            let g = $.charCodeAt(Y + $0a39817bbf114bf6$var$Z0);
            if (g === $0a39817bbf114bf6$var$G5 || g === $0a39817bbf114bf6$var$p) {
                let P = Y + $0a39817bbf114bf6$var$Z0;
                for(; P < u && $.charCodeAt(P) === g;)P++;
                for(; P < u && ($.charCodeAt(P) === $0a39817bbf114bf6$var$v || $.charCodeAt(P) === $0a39817bbf114bf6$var$b);)P++;
                if (P >= u) {
                    G = g === $0a39817bbf114bf6$var$G5 ? 1 : 2, Y = $0a39817bbf114bf6$var$s($, u);
                    break;
                }
            }
        }
        K = u;
        let x = $0a39817bbf114bf6$var$s($, u);
        if (x < $.length) {
            if ($.charCodeAt(x) === $0a39817bbf114bf6$var$v9) {
                var X = $0a39817bbf114bf6$var$X0($, x);
                Y = $0a39817bbf114bf6$var$s($, X), K = X;
                continue;
            }
            let g = $0a39817bbf114bf6$var$X0($, x);
            if (J = g, $0a39817bbf114bf6$var$P0($, x, g), $0a39817bbf114bf6$var$J0 < 4) {
                let P = $.charCodeAt(x + $0a39817bbf114bf6$var$Z0);
                if (P === $0a39817bbf114bf6$var$o) {
                    Y = x;
                    break;
                }
                if (P === $0a39817bbf114bf6$var$Y5) {
                    for(var U = x + $0a39817bbf114bf6$var$Z0, q = 0; U < g && $.charCodeAt(U) === $0a39817bbf114bf6$var$Y5 && q <= 6;)q++, U++;
                    if (q >= 1 && q <= 6 && (U >= g || $.charCodeAt(U) === $0a39817bbf114bf6$var$v || $.charCodeAt(U) === $0a39817bbf114bf6$var$b)) {
                        Y = x;
                        break;
                    }
                }
                if (P === $0a39817bbf114bf6$var$$0 || P === $0a39817bbf114bf6$var$N0) {
                    for(var W = x + $0a39817bbf114bf6$var$Z0, z = 0; W < g && $.charCodeAt(W) === P;)z++, W++;
                    if (z >= 3) {
                        Y = x;
                        break;
                    }
                }
                if (P === $0a39817bbf114bf6$var$G0) {
                    var F = x + $0a39817bbf114bf6$var$Z0 + 1, D = F < g ? $.charCodeAt(F) : 0, O = D === $0a39817bbf114bf6$var$p0 || D === $0a39817bbf114bf6$var$a5;
                    if (!O && D === $0a39817bbf114bf6$var$M0) {
                        for(var H = F + 1, B = H; B < g && ($.charCodeAt(B) >= $0a39817bbf114bf6$var$h && $.charCodeAt(B) <= $0a39817bbf114bf6$var$c || $.charCodeAt(B) >= $0a39817bbf114bf6$var$K0 && $.charCodeAt(B) <= $0a39817bbf114bf6$var$W0 || $.charCodeAt(B) >= $0a39817bbf114bf6$var$i && $.charCodeAt(B) <= $0a39817bbf114bf6$var$a || $.charCodeAt(B) === $0a39817bbf114bf6$var$p);)B++;
                        B > H && (O = $0a39817bbf114bf6$var$y9.has($.slice(H, B).toLowerCase()));
                    } else if (!O) {
                        for(var M = F; M < g && ($.charCodeAt(M) >= $0a39817bbf114bf6$var$h && $.charCodeAt(M) <= $0a39817bbf114bf6$var$c || $.charCodeAt(M) >= $0a39817bbf114bf6$var$K0 && $.charCodeAt(M) <= $0a39817bbf114bf6$var$W0 || $.charCodeAt(M) >= $0a39817bbf114bf6$var$i && $.charCodeAt(M) <= $0a39817bbf114bf6$var$a || $.charCodeAt(M) === $0a39817bbf114bf6$var$p);)M++;
                        if (M > F) {
                            var j = $.slice(F, M).toLowerCase();
                            O = $0a39817bbf114bf6$var$y9.has(j) || $0a39817bbf114bf6$var$z9.has(j);
                        }
                    }
                    if (O && $0a39817bbf114bf6$var$Q4($, x, Z, V)) {
                        Y = x;
                        break;
                    }
                }
                if (P === $0a39817bbf114bf6$var$p || P === $0a39817bbf114bf6$var$_0 || P === $0a39817bbf114bf6$var$N5) {
                    let C = x + $0a39817bbf114bf6$var$Z0 + 1;
                    if (C < g && ($.charCodeAt(C) === $0a39817bbf114bf6$var$v || $.charCodeAt(C) === $0a39817bbf114bf6$var$b)) {
                        var w = $0a39817bbf114bf6$var$W9($, C, g);
                        if (w < g && !$0a39817bbf114bf6$var$x5($, x)) {
                            Y = x;
                            break;
                        }
                    }
                }
                if (P >= $0a39817bbf114bf6$var$i && P <= $0a39817bbf114bf6$var$a) {
                    let C = x + $0a39817bbf114bf6$var$Z0;
                    for(; C < g && $.charCodeAt(C) >= $0a39817bbf114bf6$var$i && $.charCodeAt(C) <= $0a39817bbf114bf6$var$a;)C++;
                    if (C < g && ($.charCodeAt(C) === $0a39817bbf114bf6$var$s0 || $.charCodeAt(C) === $0a39817bbf114bf6$var$q5) && C - (x + $0a39817bbf114bf6$var$Z0) === 1 && $.charCodeAt(x + $0a39817bbf114bf6$var$Z0) === 49) {
                        var I = C + 1;
                        if (I < g && ($.charCodeAt(I) === $0a39817bbf114bf6$var$v || $.charCodeAt(I) === $0a39817bbf114bf6$var$b)) {
                            var A = $0a39817bbf114bf6$var$W9($, I, g);
                            if (A < g) {
                                Y = x;
                                break;
                            }
                        }
                    }
                }
                if (P === $0a39817bbf114bf6$var$k0) {
                    let C = $0a39817bbf114bf6$var$s($, g);
                    if (C < $.length) {
                        let d = $0a39817bbf114bf6$var$X0($, C);
                        if ($0a39817bbf114bf6$var$e$($, C, d)) {
                            Y = x;
                            break;
                        }
                    }
                }
                if ((P === $0a39817bbf114bf6$var$p || P === $0a39817bbf114bf6$var$_0 || P === $0a39817bbf114bf6$var$H0) && $0a39817bbf114bf6$var$x5($, x)) {
                    if (P !== $0a39817bbf114bf6$var$p) {
                        Y = x;
                        break;
                    }
                    let C = 0, d = x + $0a39817bbf114bf6$var$Z0;
                    for(; d < g && $.charCodeAt(d) === $0a39817bbf114bf6$var$p;)C++, d++;
                    for(; d < g && ($.charCodeAt(d) === $0a39817bbf114bf6$var$v || $.charCodeAt(d) === $0a39817bbf114bf6$var$b);)d++;
                    if (d < g) {
                        Y = x;
                        break;
                    }
                }
            }
        }
        Y = $0a39817bbf114bf6$var$s($, u);
    }
    for(var k = G ? K : Y; k > Q && ($.charCodeAt(k - 1) === $0a39817bbf114bf6$var$E || $.charCodeAt(k - 1) === $0a39817bbf114bf6$var$_5 || $.charCodeAt(k - 1) === $0a39817bbf114bf6$var$v || $.charCodeAt(k - 1) === $0a39817bbf114bf6$var$b);)k--;
    for(var S = Q; S < k && ($.charCodeAt(S) === $0a39817bbf114bf6$var$v || $.charCodeAt(S) === $0a39817bbf114bf6$var$b);)S++;
    if (S >= k) return null;
    for(var R = !1, N = S; N < k; N++)if ($.charCodeAt(N) === $0a39817bbf114bf6$var$v9) {
        R = !0;
        break;
    }
    var T = R ? $.slice(S, k).replace(/\u001E/g, "") : $.slice(S, k);
    if (!T) return null;
    let L = $0a39817bbf114bf6$var$$9(T, !0, Z, V);
    if (G) {
        let x = (V?.slugify || $0a39817bbf114bf6$export$c383cdd2a518017a)(T);
        return {
            node: {
                type: $0a39817bbf114bf6$export$e0aa44767d8750d5.heading,
                level: G,
                children: L,
                id: x
            },
            end: Y
        };
    }
    return {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.paragraph,
            children: L
        },
        end: Y
    };
}
function $0a39817bbf114bf6$var$$9($, Q, Z, V) {
    var Y = Z.k;
    if (!Y) {
        var G = Z.e;
        Z.e = Q;
        var K = $0a39817bbf114bf6$var$D5($, 0, $.length, Z, V);
        return Z.e = G, K;
    }
    var J = [];
    return Y.push({
        dest: J,
        text: $,
        breaks: Q,
        inline: Z.inline,
        inAnchor: Z.inAnchor,
        inHTML: Z.inHTML,
        htmlDepth: Z.c,
        inList: Z.inList,
        inBlockQuote: Z.inBlockQuote,
        noSetext: Z.f,
        depth: Z.j
    }), J;
}
function $0a39817bbf114bf6$var$t4($, Q, Z) {
    if ($.charCodeAt(Q) !== $0a39817bbf114bf6$var$$0) return null;
    let V = $0a39817bbf114bf6$var$C5($, Q, Z, 96), Y = Q + V;
    for(; Y < Z;){
        let G = $.indexOf("`", Y);
        if (G < 0 || G >= Z) return null;
        let K = $0a39817bbf114bf6$var$C5($, G, Z, 96);
        if (K === V) {
            let J = $.slice(Q + V, G);
            return J.indexOf(`
`) !== -1 && (J = J.replace(/\n/g, " ")), J.length > 0 && J[0] === " " && J[J.length - 1] === " " && J.trim().length > 0 && (J = J.slice(1, -1)), {
                node: {
                    type: $0a39817bbf114bf6$export$e0aa44767d8750d5.codeInline,
                    text: J
                },
                end: G + K
            };
        }
        Y = G + K;
    }
    return null;
}
function $0a39817bbf114bf6$var$s9($, Q, Z) {
    if ($.charCodeAt(Q) !== $0a39817bbf114bf6$var$$0) return Q;
    let V = $0a39817bbf114bf6$var$C5($, Q, Z, 96), Y = Q + V;
    for(; Y < Z;){
        let G = $.indexOf("`", Y);
        if (G < 0 || G >= Z) return Q;
        let K = $0a39817bbf114bf6$var$C5($, G, Z, 96);
        if (K === V) return G + K;
        Y = G + K;
    }
    return Q;
}
function $0a39817bbf114bf6$var$e4($, Q, Z) {
    if ($.charCodeAt(Q) !== $0a39817bbf114bf6$var$G0) return Q;
    if (Q + 1 < Z && $.charCodeAt(Q + 1) === $0a39817bbf114bf6$var$M0) {
        let U = Q + 2;
        for(; U < Z && $.charCodeAt(U) !== $0a39817bbf114bf6$var$o;)U++;
        return U < Z ? U + 1 : Q;
    }
    if (Q + 3 < Z && $.charCodeAt(Q + 1) === $0a39817bbf114bf6$var$p0 && $.charCodeAt(Q + 2) === $0a39817bbf114bf6$var$p && $.charCodeAt(Q + 3) === $0a39817bbf114bf6$var$p) {
        let U = $.indexOf("-->", Q + 4);
        return U >= 0 ? U + 3 : Q;
    }
    let V = Q + 1, Y = V;
    for(; V < Z;){
        let U = $.charCodeAt(V);
        if (U >= $0a39817bbf114bf6$var$h && U <= $0a39817bbf114bf6$var$c || U >= $0a39817bbf114bf6$var$K0 && U <= $0a39817bbf114bf6$var$W0 || U >= $0a39817bbf114bf6$var$i && U <= $0a39817bbf114bf6$var$a || U === $0a39817bbf114bf6$var$p) V++;
        else break;
    }
    if (V === Y) return Q;
    let G = $.slice(Y, V).toLowerCase(), K = !1;
    for(; V < Z;){
        let U = $.charCodeAt(V);
        if (U === $0a39817bbf114bf6$var$o) {
            V++;
            break;
        }
        if (U === $0a39817bbf114bf6$var$M0 && V + 1 < Z && $.charCodeAt(V + 1) === $0a39817bbf114bf6$var$o) {
            V += 2, K = !0;
            break;
        }
        if (U === $0a39817bbf114bf6$var$v5 || U === $0a39817bbf114bf6$var$S5) {
            var J = U;
            for(V++; V < Z && $.charCodeAt(V) !== J;)V++;
            V < Z && V++;
            continue;
        }
        if (U === $0a39817bbf114bf6$var$E) return Q;
        V++;
    }
    if (K || $0a39817bbf114bf6$var$l5(G)) return V;
    let X = 1;
    for(; V < Z && X > 0;)if ($.charCodeAt(V) === $0a39817bbf114bf6$var$G0) {
        if (V + 1 < Z && $.charCodeAt(V + 1) === $0a39817bbf114bf6$var$M0) {
            let U = V + 2, q = U;
            for(; q < Z && ($.charCodeAt(q) >= $0a39817bbf114bf6$var$h && $.charCodeAt(q) <= $0a39817bbf114bf6$var$c || $.charCodeAt(q) >= $0a39817bbf114bf6$var$K0 && $.charCodeAt(q) <= $0a39817bbf114bf6$var$W0);)q++;
            if ($.slice(U, q).toLowerCase() === G) {
                for(; q < Z && $.charCodeAt(q) !== $0a39817bbf114bf6$var$o;)q++;
                if (q < Z && q++, X--, X === 0) return q;
            }
            V = q;
        } else {
            let U = V + 1, q = U;
            for(; q < Z && ($.charCodeAt(q) >= $0a39817bbf114bf6$var$h && $.charCodeAt(q) <= $0a39817bbf114bf6$var$c || $.charCodeAt(q) >= $0a39817bbf114bf6$var$K0 && $.charCodeAt(q) <= $0a39817bbf114bf6$var$W0);)q++;
            $.slice(U, q).toLowerCase() === G && X++, V++;
        }
    } else V++;
    return V;
}
function $0a39817bbf114bf6$var$$6($, Q, Z, V, Y) {
    if ($.charCodeAt(Q) !== $0a39817bbf114bf6$var$N0 || Q + 1 >= Z || $.charCodeAt(Q + 1) !== $0a39817bbf114bf6$var$N0) return null;
    let G = Q + 2;
    for(; G + 1 < Z;){
        let K = $.charCodeAt(G);
        if (K === $0a39817bbf114bf6$var$$0) {
            let J = $0a39817bbf114bf6$var$s9($, G, Z);
            if (J > G) {
                G = J;
                continue;
            }
        }
        if (K === $0a39817bbf114bf6$var$N0 && $.charCodeAt(G + 1) === $0a39817bbf114bf6$var$N0) {
            let J = $.slice(Q + 2, G), X = $0a39817bbf114bf6$var$D5(J, 0, J.length, V, Y);
            return {
                node: {
                    type: $0a39817bbf114bf6$export$e0aa44767d8750d5.textFormatted,
                    tag: "del",
                    children: X
                },
                end: G + 2
            };
        }
        K === $0a39817bbf114bf6$var$y0 && G + 1 < Z && G++, G++;
    }
    return null;
}
function $0a39817bbf114bf6$var$Z6($, Q, Z, V, Y) {
    if ($.charCodeAt(Q) !== $0a39817bbf114bf6$var$G5 || Q + 1 >= Z || $.charCodeAt(Q + 1) !== $0a39817bbf114bf6$var$G5) return null;
    let G = Q + 2;
    for(; G + 1 < Z;){
        let K = $.charCodeAt(G);
        if (K === $0a39817bbf114bf6$var$$0) {
            let J = $0a39817bbf114bf6$var$s9($, G, Z);
            if (J > G) {
                G = J;
                continue;
            }
        }
        if (K === $0a39817bbf114bf6$var$G5 && $.charCodeAt(G + 1) === $0a39817bbf114bf6$var$G5 && G > Q + 2) {
            let J = $.slice(Q + 2, G), X = $0a39817bbf114bf6$var$D5(J, 0, J.length, V, Y);
            return {
                node: {
                    type: $0a39817bbf114bf6$export$e0aa44767d8750d5.textFormatted,
                    tag: "mark",
                    children: X
                },
                end: G + 2
            };
        }
        K === $0a39817bbf114bf6$var$y0 && G + 1 < Z && G++, G++;
    }
    return null;
}
function $0a39817bbf114bf6$var$l$($, Q, Z) {
    return $ < $0a39817bbf114bf6$var$n5 ? !!($0a39817bbf114bf6$var$n9($) & $0a39817bbf114bf6$var$p5) : $0a39817bbf114bf6$var$P$.test(Q[Z]);
}
function $0a39817bbf114bf6$var$r$($, Q, Z) {
    return $ < $0a39817bbf114bf6$var$n5 ? !!($0a39817bbf114bf6$var$n9($) & $0a39817bbf114bf6$var$E5) : $0a39817bbf114bf6$var$b$.test(Q[Z]);
}
function $0a39817bbf114bf6$var$Q6($, Q, Z) {
    var V = $.charCodeAt(Q);
    if (V !== $0a39817bbf114bf6$var$_0 && V !== $0a39817bbf114bf6$var$H0) return null;
    var Y = $0a39817bbf114bf6$var$C5($, Q, Z, V);
    if (Y === 0) return null;
    var G = Q > 0 ? $.charCodeAt(Q - 1) : 32, K = Q + Y < Z ? $.charCodeAt(Q + Y) : 32, J = $0a39817bbf114bf6$var$r$(G, $, Q - 1), X = $0a39817bbf114bf6$var$r$(K, $, Q + Y), U = Q > 0 ? $0a39817bbf114bf6$var$l$(G, $, Q - 1) : !1, q = Q + Y < Z ? $0a39817bbf114bf6$var$l$(K, $, Q + Y) : !1, W = !X && (!q || J || U), z = !J && (!U || X || q), F, D;
    return V === $0a39817bbf114bf6$var$_0 ? (F = W, D = z) : (F = W && (!z || U), D = z && (!W || q)), {
        len: Y,
        canOpen: F,
        canClose: D
    };
}
function $0a39817bbf114bf6$var$V6($, Q, Z, V) {
    if (Q.length !== 0) {
        for(var Y = $.length, G = Array(Y), K = null, J = null, X = 0; X < Y; X++){
            var U = {
                node: $[X],
                prev: J,
                next: null
            };
            J ? J.next = U : K = U, G[X] = U, J = U;
        }
        for(var q = Array(Q.length), W = 0; W < Q.length; W++)q[W] = G[Q[W].idx];
        for(var z = [], F = 0; F < 12; F++)z[F] = -1;
        for(var D = 0; D < Q.length;){
            var O = Q[D];
            if (!O.active || !O.canClose) {
                D++;
                continue;
            }
            for(var H = O.ch === $0a39817bbf114bf6$var$_0 ? 0 : 1, B = H * 6 + O.len % 3 * 2 + (O.canOpen ? 1 : 0), M = z[B] !== void 0 ? z[B] : -1, j = -1, w = D - 1; w > M; w--){
                var I = Q[w];
                if (!(!I.active || I.ch !== O.ch || !I.canOpen) && !((O.canOpen || I.canClose) && (I.len + O.len) % 3 === 0 && I.len % 3 !== 0)) {
                    j = w;
                    break;
                }
            }
            if (j < 0) {
                z[B] = D - 1, !O.canOpen && (O.active = !1), D++;
                continue;
            }
            var A = Q[j], k = A.len >= 2 && O.len >= 2, S = k ? 2 : 1;
            A.len -= S, O.len -= S;
            var R = q[j], N = q[D], T = R.node, L = N.node;
            T.text = T.text.slice(0, T.text.length - S), L.text = L.text.slice(S);
            for(var u = [], x = R.next; x && x !== N;)u.push(x.node), x = x.next;
            var g = {
                type: $0a39817bbf114bf6$export$e0aa44767d8750d5.textFormatted,
                tag: k ? "strong" : "em",
                children: u
            }, P = {
                node: g,
                prev: R,
                next: N
            };
            R.next = P, N.prev = P;
            for(var C = j + 1; C < D; C++)Q[C].active = !1;
            if (A.len === 0 && (A.active = !1, T.text === "")) {
                var d = R.prev;
                P.prev = d, d ? d.next = P : K = P;
            }
            if (O.len === 0) {
                if (O.active = !1, L.text === "") {
                    var f = N.next;
                    P.next = f, f && (f.prev = P);
                }
            } else continue;
            D++;
        }
        for(var U0 = 0, n = K; n;){
            var m0 = n.node;
            if (m0.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.text) {
                var x0 = m0;
                if (x0.text === "") {
                    n = n.next;
                    continue;
                }
                if (U0 > 0 && $[U0 - 1].type === $0a39817bbf114bf6$export$e0aa44767d8750d5.text) {
                    $[U0 - 1].text += x0.text, n = n.next;
                    continue;
                }
            }
            $[U0++] = m0, n = n.next;
        }
        $.length = U0;
    }
}
function $0a39817bbf114bf6$var$o$($, Q, Z, V, Y) {
    let G = $.charCodeAt(Q) === $0a39817bbf114bf6$var$p0, K = G ? Q + 1 : Q;
    if ($.charCodeAt(K) !== $0a39817bbf114bf6$var$A0) return null;
    var J = $.indexOf("]", K + 1);
    if (J < 0 || J >= Z) return null;
    for(var X = K + 1, U = -1, q = 1; X < Z && q > 0;){
        var W = $.charCodeAt(X);
        if (W === $0a39817bbf114bf6$var$y0 && X + 1 < Z) {
            X += 2;
            continue;
        }
        if (W === $0a39817bbf114bf6$var$$0) {
            var z = $0a39817bbf114bf6$var$s9($, X, Z);
            if (z > X) {
                X = z;
                continue;
            }
        }
        if (W === $0a39817bbf114bf6$var$G0) {
            var F = $0a39817bbf114bf6$var$V4($, X, Z);
            if (F) {
                X = F.end;
                continue;
            }
            var D = $0a39817bbf114bf6$var$e4($, X, Z);
            if (D > X) {
                X = D;
                continue;
            }
        }
        W === $0a39817bbf114bf6$var$A0 ? q++ : W === $0a39817bbf114bf6$var$K5 && q--, X++;
    }
    if (q !== 0) return null;
    var O = X - 1, H = $.slice(K + 1, O), B = X < Z ? $.charCodeAt(X) : 0, M = !1;
    if (B === $0a39817bbf114bf6$var$F5) {
        var j = !0;
        for(X++; X < Z && ($.charCodeAt(X) === $0a39817bbf114bf6$var$v || $.charCodeAt(X) === $0a39817bbf114bf6$var$E);)X++;
        var w = "", I = X;
        if (X < Z && $.charCodeAt(X) === $0a39817bbf114bf6$var$G0) {
            for(X++, I = X; I < Z && $.charCodeAt(I) !== $0a39817bbf114bf6$var$o;){
                if ($.charCodeAt(I) === $0a39817bbf114bf6$var$y0 && I + 1 < Z) {
                    I += 2;
                    continue;
                }
                if ($.charCodeAt(I) === $0a39817bbf114bf6$var$E) {
                    j = !1;
                    break;
                }
                I++;
            }
            j && (I >= Z || $.charCodeAt(I) !== $0a39817bbf114bf6$var$o) && (j = !1), j && (w = $.slice(X, I), I++);
        } else if (j) {
            if (V.g !== void 0 && X >= V.g) j = !1;
            else {
                for(var A = 0, k = !1; I < Z;){
                    var S = $.charCodeAt(I);
                    if (S === $0a39817bbf114bf6$var$y0 && I + 1 < Z) {
                        I += 2;
                        continue;
                    }
                    if (S === $0a39817bbf114bf6$var$F5) A++;
                    else if (S === $0a39817bbf114bf6$var$q5) {
                        if (k = !0, A === 0) break;
                        A--;
                    } else if (S === $0a39817bbf114bf6$var$v || S === $0a39817bbf114bf6$var$E) break;
                    I++;
                }
                I >= Z && !k && (V.g === void 0 || X < V.g) && (V.g = X), w = $.slice(X, I);
            }
        }
        if (j) {
            for(X = I; X < Z && ($.charCodeAt(X) === $0a39817bbf114bf6$var$v || $.charCodeAt(X) === $0a39817bbf114bf6$var$E);)X++;
            var R;
            if (X < Z) {
                var N = $.charCodeAt(X);
                if (N === $0a39817bbf114bf6$var$v5 || N === $0a39817bbf114bf6$var$S5 || N === $0a39817bbf114bf6$var$F5) {
                    var T = N === $0a39817bbf114bf6$var$F5 ? 41 : N;
                    X++;
                    for(var L = X; X < Z && $.charCodeAt(X) !== T;)$.charCodeAt(X) === $0a39817bbf114bf6$var$y0 && X + 1 < Z && X++, X++;
                    X >= Z ? j = !1 : (R = $.slice(L, X), X++);
                }
            }
            if (j) {
                for(; X < Z && ($.charCodeAt(X) === $0a39817bbf114bf6$var$v || $.charCodeAt(X) === $0a39817bbf114bf6$var$E);)X++;
                (X >= Z || $.charCodeAt(X) !== $0a39817bbf114bf6$var$q5) && (j = !1);
            }
        }
        if (j) {
            X++, w = $0a39817bbf114bf6$var$e5(w), R !== void 0 && (R = $0a39817bbf114bf6$var$s5($0a39817bbf114bf6$var$e5(R)));
            var u = Y?.sanitizer || $0a39817bbf114bf6$export$3e2338ea76b578c9, x = u(w, G ? "img" : "a", G ? "src" : "href"), g = x === null ? null : w;
            if (G) {
                var P = $0a39817bbf114bf6$var$D5(H, 0, H.length, V, Y), C = $0a39817bbf114bf6$var$a9(P);
                return {
                    node: {
                        type: $0a39817bbf114bf6$export$e0aa44767d8750d5.image,
                        target: g,
                        alt: C,
                        title: R
                    },
                    end: X
                };
            } else {
                var d = V.inAnchor;
                V.inAnchor = !0;
                var f = d ? [
                    {
                        type: $0a39817bbf114bf6$export$e0aa44767d8750d5.text,
                        text: H
                    }
                ] : $0a39817bbf114bf6$var$D5(H, 0, H.length, V, Y);
                return V.inAnchor = d, !V.inAnchor && $0a39817bbf114bf6$var$i9(f) ? null : {
                    node: {
                        type: $0a39817bbf114bf6$export$e0aa44767d8750d5.link,
                        target: g,
                        title: R,
                        children: f
                    },
                    end: X
                };
            }
        } else X = O + 1, M = !0;
    }
    var U0 = "", n = X;
    if (!M && B === $0a39817bbf114bf6$var$A0) {
        var m0 = X + 1;
        n = m0;
        for(var x0 = !1; n < Z && $.charCodeAt(n) !== $0a39817bbf114bf6$var$K5;){
            if ($.charCodeAt(n) === $0a39817bbf114bf6$var$y0 && n + 1 < Z) {
                n += 2;
                continue;
            }
            if ($.charCodeAt(n) === $0a39817bbf114bf6$var$A0) {
                x0 = !0;
                break;
            }
            n++;
        }
        if (x0 || n >= Z) return null;
        var v0 = $.slice(m0, n);
        if (v0.trim()) U0 = $0a39817bbf114bf6$var$b9(v0);
        else {
            if ($0a39817bbf114bf6$var$h$(H)) return null;
            U0 = $0a39817bbf114bf6$var$b9(H);
        }
        n = n + 1;
    } else {
        if ($0a39817bbf114bf6$var$h$(H)) return null;
        U0 = $0a39817bbf114bf6$var$b9(H);
    }
    var l = V.refs[U0];
    if (!l) return null;
    if (G) return {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.image,
            target: l.target,
            alt: $0a39817bbf114bf6$var$a9($0a39817bbf114bf6$var$D5(H, 0, H.length, V, Y)),
            title: l.title
        },
        end: n
    };
    var t = V.inAnchor;
    V.inAnchor = !0;
    var f = t ? [
        {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.text,
            text: H
        }
    ] : $0a39817bbf114bf6$var$D5(H, 0, H.length, V, Y);
    return V.inAnchor = t, !V.inAnchor && $0a39817bbf114bf6$var$i9(f) ? null : {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.link,
            target: l.target,
            title: l.title,
            children: f
        },
        end: n
    };
}
function $0a39817bbf114bf6$var$V4($, Q, Z) {
    if ($.charCodeAt(Q) !== $0a39817bbf114bf6$var$G0) return null;
    for(var V = Q + 1; V < Z;){
        var Y = $.charCodeAt(V);
        if (Y === $0a39817bbf114bf6$var$o) break;
        if (Y === $0a39817bbf114bf6$var$v || Y === $0a39817bbf114bf6$var$E || Y === $0a39817bbf114bf6$var$_5 || Y === $0a39817bbf114bf6$var$G0) return null;
        V++;
    }
    if (V >= Z || $.charCodeAt(V) !== $0a39817bbf114bf6$var$o) return null;
    var G = $.slice(Q + 1, V), K = G.match(/^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^\x00-\x20]*)$/);
    return K ? {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.link,
            target: G,
            title: void 0,
            children: [
                {
                    type: $0a39817bbf114bf6$export$e0aa44767d8750d5.text,
                    text: G
                }
            ]
        },
        end: V + 1
    } : G.indexOf("@") !== -1 && /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(G) ? {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.link,
            target: "mailto:" + G,
            title: void 0,
            children: [
                {
                    type: $0a39817bbf114bf6$export$e0aa44767d8750d5.text,
                    text: G
                }
            ]
        },
        end: V + 1
    } : null;
}
function $0a39817bbf114bf6$var$Y6($, Q, Z, V) {
    if ($.charCodeAt(Q) !== $0a39817bbf114bf6$var$A0 || Q + 1 >= Z || $.charCodeAt(Q + 1) !== $0a39817bbf114bf6$var$U5) return null;
    let Y = Q + 2;
    for(; Y < Z && $.charCodeAt(Y) !== $0a39817bbf114bf6$var$K5 && $.charCodeAt(Y) !== $0a39817bbf114bf6$var$E;)Y++;
    if (Y >= Z || $.charCodeAt(Y) !== $0a39817bbf114bf6$var$K5) return null;
    let G = $.slice(Q + 2, Y);
    return G ? {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.footnoteReference,
            target: "#" + $0a39817bbf114bf6$export$c383cdd2a518017a(G),
            text: G
        },
        end: Y + 1
    } : null;
}
function $0a39817bbf114bf6$var$G6($, Q, Z, V) {
    if (V.disableBareUrls) return null;
    var Y = "", G = !1, K = $.charCodeAt(Q);
    if (K === $0a39817bbf114bf6$var$X9 || K === 72 ? Q + 8 <= Z && $.charCodeAt(Q + 1) === $0a39817bbf114bf6$var$h5 && $.charCodeAt(Q + 2) === $0a39817bbf114bf6$var$h5 && $.charCodeAt(Q + 3) === $0a39817bbf114bf6$var$_9 && ($.charCodeAt(Q + 4) === $0a39817bbf114bf6$var$f9 && $.charCodeAt(Q + 5) === $0a39817bbf114bf6$var$f0 && $.charCodeAt(Q + 6) === $0a39817bbf114bf6$var$M0 && $.charCodeAt(Q + 7) === $0a39817bbf114bf6$var$M0 ? Y = "https://" : $.charCodeAt(Q + 4) === $0a39817bbf114bf6$var$f0 && $.charCodeAt(Q + 5) === $0a39817bbf114bf6$var$M0 && $.charCodeAt(Q + 6) === $0a39817bbf114bf6$var$M0 && (Y = "http://")) : K === $0a39817bbf114bf6$var$I5 || K === 70 ? Q + 6 <= Z && $.charCodeAt(Q + 1) === $0a39817bbf114bf6$var$h5 && $.charCodeAt(Q + 2) === $0a39817bbf114bf6$var$_9 && $.charCodeAt(Q + 3) === $0a39817bbf114bf6$var$f0 && $.charCodeAt(Q + 4) === $0a39817bbf114bf6$var$M0 && $.charCodeAt(Q + 5) === $0a39817bbf114bf6$var$M0 && (Y = "ftp://") : (K === $0a39817bbf114bf6$var$k5 || K === 87) && Q + 4 <= Z && $.charCodeAt(Q + 1) === $0a39817bbf114bf6$var$k5 && $.charCodeAt(Q + 2) === $0a39817bbf114bf6$var$k5 && $.charCodeAt(Q + 3) === $0a39817bbf114bf6$var$s0 && (Y = "www.", G = !0), !Y) return null;
    let J = Q + Y.length;
    for(; J < Z;){
        let A = $.charCodeAt(J);
        if (A === $0a39817bbf114bf6$var$v || A === $0a39817bbf114bf6$var$E || A === $0a39817bbf114bf6$var$b || A === $0a39817bbf114bf6$var$_5 || A === $0a39817bbf114bf6$var$G0 || A === $0a39817bbf114bf6$var$o) break;
        J++;
    }
    for(var X = 0, U = 0, q = Q; q < J; q++){
        var W = $.charCodeAt(q);
        W === $0a39817bbf114bf6$var$F5 ? X++ : W === $0a39817bbf114bf6$var$q5 && U++;
    }
    let z = J;
    for(; z > Q + Y.length;){
        let A = $.charCodeAt(z - 1);
        if (A === $0a39817bbf114bf6$var$s0 || A === $0a39817bbf114bf6$var$H$ || A === $0a39817bbf114bf6$var$f0 || A === $0a39817bbf114bf6$var$p0 || A === $0a39817bbf114bf6$var$a5 || A === $0a39817bbf114bf6$var$q5 || A === $0a39817bbf114bf6$var$_0 || A === $0a39817bbf114bf6$var$H0 || A === $0a39817bbf114bf6$var$N0) {
            if (A === $0a39817bbf114bf6$var$q5) {
                if (X >= U) break;
                U--;
            }
            z--;
        } else if (A === $0a39817bbf114bf6$var$U9) {
            for(var F = z - 2; F > Q && ($.charCodeAt(F) >= $0a39817bbf114bf6$var$h && $.charCodeAt(F) <= $0a39817bbf114bf6$var$c || $.charCodeAt(F) >= $0a39817bbf114bf6$var$K0 && $.charCodeAt(F) <= $0a39817bbf114bf6$var$W0 || $.charCodeAt(F) >= $0a39817bbf114bf6$var$i && $.charCodeAt(F) <= $0a39817bbf114bf6$var$a);)F--;
            F >= Q && $.charCodeAt(F) === $0a39817bbf114bf6$var$K9 ? z = F : z--;
        } else break;
    }
    if (z <= Q + Y.length) return null;
    var D = Q + (G ? 4 : Y.length), O = $.indexOf("/", D);
    if ((O < 0 || O > z) && (O = z), G && $.indexOf(".", D) === -1) return null;
    for(var H = -1, B = -1, M = O - 1; M >= D; M--)if ($.charCodeAt(M) === $0a39817bbf114bf6$var$s0) {
        if (H < 0) H = M;
        else {
            B = M;
            break;
        }
    }
    for(var j = B >= 0 ? B + 1 : D, M = j; M < O; M++)if ($.charCodeAt(M) === $0a39817bbf114bf6$var$H0) return null;
    var w = $.slice(Q, z), I = G ? "http://" + w : w;
    return {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.link,
            target: I,
            title: void 0,
            children: [
                {
                    type: $0a39817bbf114bf6$export$e0aa44767d8750d5.text,
                    text: w
                }
            ]
        },
        end: z
    };
}
function $0a39817bbf114bf6$var$K6($, Q, Z, V) {
    if (V.disableBareUrls) return null;
    for(var Y = Q, G = Y; Y < Z;){
        var K = $.charCodeAt(Y);
        if (K >= $0a39817bbf114bf6$var$h && K <= $0a39817bbf114bf6$var$c || K >= $0a39817bbf114bf6$var$K0 && K <= $0a39817bbf114bf6$var$W0 || K >= $0a39817bbf114bf6$var$i && K <= $0a39817bbf114bf6$var$a || K === $0a39817bbf114bf6$var$s0 || K === $0a39817bbf114bf6$var$p0 || K === $0a39817bbf114bf6$var$Y5 || K === 36 || K === $0a39817bbf114bf6$var$G9 || K === $0a39817bbf114bf6$var$K9 || K === $0a39817bbf114bf6$var$S5 || K === $0a39817bbf114bf6$var$_0 || K === $0a39817bbf114bf6$var$N5 || K === $0a39817bbf114bf6$var$M0 || K === $0a39817bbf114bf6$var$G5 || K === $0a39817bbf114bf6$var$a5 || K === $0a39817bbf114bf6$var$U5 || K === $0a39817bbf114bf6$var$H0 || K === $0a39817bbf114bf6$var$$0 || K === $0a39817bbf114bf6$var$L5 || K === $0a39817bbf114bf6$var$k0 || K === $0a39817bbf114bf6$var$I9 || K === $0a39817bbf114bf6$var$N0 || K === $0a39817bbf114bf6$var$p) Y++;
        else break;
    }
    if (Y === G || Y >= Z || $.charCodeAt(Y) !== $0a39817bbf114bf6$var$j9) return null;
    Y++;
    for(var J = Y, X = -1, U = Y; Y < Z;){
        var K = $.charCodeAt(Y);
        if (K >= $0a39817bbf114bf6$var$h && K <= $0a39817bbf114bf6$var$c || K >= $0a39817bbf114bf6$var$K0 && K <= $0a39817bbf114bf6$var$W0 || K >= $0a39817bbf114bf6$var$i && K <= $0a39817bbf114bf6$var$a) Y++;
        else if ((K === $0a39817bbf114bf6$var$p || K === $0a39817bbf114bf6$var$H0) && Y > J) Y++;
        else if (K === $0a39817bbf114bf6$var$s0) {
            if (Y === J) break;
            var q = $.charCodeAt(Y - 1);
            if (q === $0a39817bbf114bf6$var$p || q === $0a39817bbf114bf6$var$H0 || Y - U > 63) break;
            if (Y + 1 < Z) {
                var W = $.charCodeAt(Y + 1);
                if (W >= $0a39817bbf114bf6$var$h && W <= $0a39817bbf114bf6$var$c || W >= $0a39817bbf114bf6$var$K0 && W <= $0a39817bbf114bf6$var$W0 || W >= $0a39817bbf114bf6$var$i && W <= $0a39817bbf114bf6$var$a) X = Y, U = Y + 1, Y++;
                else break;
            } else break;
        } else break;
    }
    if (Y - U > 63 || X < 0) return null;
    var z = $.charCodeAt(Y - 1);
    if (!(z >= $0a39817bbf114bf6$var$h && z <= $0a39817bbf114bf6$var$c || z >= $0a39817bbf114bf6$var$K0 && z <= $0a39817bbf114bf6$var$W0 || z >= $0a39817bbf114bf6$var$i && z <= $0a39817bbf114bf6$var$a) || Y <= X + 1) return null;
    for(var F = -1, D = X - 1; D >= J; D--)if ($.charCodeAt(D) === $0a39817bbf114bf6$var$s0) {
        F = D;
        break;
    }
    for(var O = F >= 0 ? F + 1 : J, D = O; D < Y; D++)if ($.charCodeAt(D) === $0a39817bbf114bf6$var$H0) return null;
    var H = $.slice(Q, Y);
    return {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.link,
            target: "mailto:" + H,
            title: void 0,
            children: [
                {
                    type: $0a39817bbf114bf6$export$e0aa44767d8750d5.text,
                    text: H
                }
            ]
        },
        end: Y
    };
}
function $0a39817bbf114bf6$var$i9($) {
    for(var Q = 0; Q < $.length; Q++)if ($[Q].type === $0a39817bbf114bf6$export$e0aa44767d8750d5.link || "children" in $[Q] && Array.isArray($[Q].children) && $0a39817bbf114bf6$var$i9($[Q].children)) return !0;
    return !1;
}
function $0a39817bbf114bf6$var$a9($) {
    for(var Q = "", Z = 0; Z < $.length; Z++){
        var V = $[Z];
        V.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.text ? Q += V.text : V.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.breakLine ? Q += " " : V.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.codeInline ? Q += V.text : "children" in V && Array.isArray(V.children) ? Q += $0a39817bbf114bf6$var$a9(V.children) : V.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.image && (Q += V.alt || "");
    }
    return Q;
}
function $0a39817bbf114bf6$var$r5($) {
    return {
        type: $0a39817bbf114bf6$export$e0aa44767d8750d5.text,
        text: $
    };
}
function $0a39817bbf114bf6$var$J6($, Q, Z) {
    var V = Q + 1;
    if (V >= Z) return -1;
    if ($.charCodeAt(V) === $0a39817bbf114bf6$var$Y5) {
        V++;
        var Y = V < Z && ($.charCodeAt(V) === $0a39817bbf114bf6$var$O$ || $.charCodeAt(V) === $0a39817bbf114bf6$var$B$);
        Y && V++;
        for(var G = V, K = Y ? 6 : 7; V < Z && V - G <= K;){
            var J = $.charCodeAt(V), X = J >= $0a39817bbf114bf6$var$i && J <= $0a39817bbf114bf6$var$a || Y && (J >= $0a39817bbf114bf6$var$h && J <= $0a39817bbf114bf6$var$J9 || J >= $0a39817bbf114bf6$var$K0 && J <= $0a39817bbf114bf6$var$I5);
            if (!X) break;
            V++;
        }
        return V === G || V - G > K ? -1 : V < Z && $.charCodeAt(V) === $0a39817bbf114bf6$var$U9 ? V + 1 : -1;
    }
    for(var U = V; V < Z && V - U < 48;){
        var q = $.charCodeAt(V);
        if (q >= $0a39817bbf114bf6$var$h && q <= $0a39817bbf114bf6$var$c || q >= $0a39817bbf114bf6$var$K0 && q <= $0a39817bbf114bf6$var$W0 || q >= $0a39817bbf114bf6$var$i && q <= $0a39817bbf114bf6$var$a) {
            V++;
            continue;
        }
        break;
    }
    return V === U ? -1 : V < Z && $.charCodeAt(V) === $0a39817bbf114bf6$var$U9 ? V + 1 : -1;
}
function $0a39817bbf114bf6$var$X6($, Q, Z, V, Y) {
    if ($.charCodeAt(Q) !== $0a39817bbf114bf6$var$G0) return null;
    var G = Q + 1;
    if (G >= Z) return null;
    var K = $.charCodeAt(G);
    if (K === $0a39817bbf114bf6$var$p0 && G + 1 < Z && $.charCodeAt(G + 1) === $0a39817bbf114bf6$var$p && G + 2 < Z && $.charCodeAt(G + 2) === $0a39817bbf114bf6$var$p) {
        var J = G + 3;
        if (J < Z && $.charCodeAt(J) === $0a39817bbf114bf6$var$o) return {
            node: {
                type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlComment,
                text: "",
                l: !0
            },
            end: J + 1
        };
        if (J + 1 < Z && $.charCodeAt(J) === $0a39817bbf114bf6$var$p && $.charCodeAt(J + 1) === $0a39817bbf114bf6$var$o) return {
            node: {
                type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlComment,
                text: "-",
                l: !0
            },
            end: J + 2
        };
        var X = $.indexOf("-->", J);
        return X !== -1 && X <= Z - 3 ? {
            node: {
                type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlComment,
                text: $.slice(Q + 4, X),
                l: !1
            },
            end: X + 3
        } : null;
    }
    if (K === $0a39817bbf114bf6$var$a5) {
        var U = $.indexOf("?>", G + 1);
        return U !== -1 && U < Z ? {
            node: {
                type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlSelfClosing,
                tag: "?",
                attrs: {},
                a: $.slice(Q, U + 2),
                b: !1
            },
            end: U + 2
        } : null;
    }
    if (K === $0a39817bbf114bf6$var$p0 && G + 1 < Z) {
        var q = $.charCodeAt(G + 1);
        if (q === $0a39817bbf114bf6$var$A0 && $.slice(G + 1, G + 8) === "[CDATA[") {
            var W = $.indexOf("]]>", G + 8);
            return W !== -1 && W < Z ? {
                node: {
                    type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlSelfClosing,
                    tag: "![CDATA[",
                    attrs: {},
                    a: $.slice(Q, W + 3),
                    b: !1
                },
                end: W + 3
            } : null;
        }
        if (q >= $0a39817bbf114bf6$var$h && q <= $0a39817bbf114bf6$var$c) {
            var z = $.indexOf(">", G + 2);
            return z !== -1 && z < Z ? {
                node: {
                    type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlSelfClosing,
                    tag: "!" + $.slice(G + 1, z),
                    attrs: {},
                    a: $.slice(Q, z + 1),
                    b: !1
                },
                end: z + 1
            } : null;
        }
    }
    if (K === $0a39817bbf114bf6$var$M0) {
        var F = G + 1;
        if (F >= Z) return null;
        var D = $.charCodeAt(F);
        if (!(D >= $0a39817bbf114bf6$var$h && D <= $0a39817bbf114bf6$var$c || D >= $0a39817bbf114bf6$var$K0 && D <= $0a39817bbf114bf6$var$W0)) return null;
        for(F++; F < Z;){
            var O = $.charCodeAt(F);
            if (O >= $0a39817bbf114bf6$var$h && O <= $0a39817bbf114bf6$var$c || O >= $0a39817bbf114bf6$var$K0 && O <= $0a39817bbf114bf6$var$W0 || O >= $0a39817bbf114bf6$var$i && O <= $0a39817bbf114bf6$var$a || O === $0a39817bbf114bf6$var$p) F++;
            else break;
        }
        for(; F < Z && ($.charCodeAt(F) === $0a39817bbf114bf6$var$v || $.charCodeAt(F) === $0a39817bbf114bf6$var$b || $.charCodeAt(F) === $0a39817bbf114bf6$var$E);)F++;
        if (F < Z && $.charCodeAt(F) === $0a39817bbf114bf6$var$o) {
            var H = $.slice(G + 1, F).trim();
            return {
                node: {
                    type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlSelfClosing,
                    tag: H,
                    attrs: {},
                    a: $.slice(Q, F + 1),
                    b: !0
                },
                end: F + 1
            };
        }
        return null;
    }
    if (!(K >= $0a39817bbf114bf6$var$h && K <= $0a39817bbf114bf6$var$c || K >= $0a39817bbf114bf6$var$K0 && K <= $0a39817bbf114bf6$var$W0)) return null;
    var B = $0a39817bbf114bf6$var$w5($, Q);
    if (!B) return null;
    var M = B.tag, j = M.toLowerCase(), w = B.selfClosing;
    if (w || $0a39817bbf114bf6$var$l5(M)) return {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlSelfClosing,
            tag: M,
            attrs: $0a39817bbf114bf6$var$b5(B.attrs, M, Y),
            a: $.slice(Q, B.end),
            b: !1
        },
        end: B.end
    };
    var I = $0a39817bbf114bf6$var$z9.has(j), A = $0a39817bbf114bf6$var$o9($.slice(0, Z), B.end, M);
    if (A === -1) return {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlSelfClosing,
            tag: M,
            attrs: $0a39817bbf114bf6$var$b5(B.attrs, M, Y),
            a: $.slice(Q, B.end),
            b: !1
        },
        end: B.end
    };
    var k = $0a39817bbf114bf6$var$o4($, "</" + j, A), S = $.slice(B.end, k), R = [];
    if (I) S.trim() && (R = [
        {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.text,
            text: S
        }
    ]);
    else {
        var N = S.trim();
        if (N) {
            var { inAnchor: T, inline: L, e: u } = V;
            j === "a" && (V.inAnchor = !0), V.e = !1;
            var x = N.indexOf(`

`) !== -1 || /^#{1,6}\s/.test(N);
            x ? (V.inline = !1, R = $0a39817bbf114bf6$var$f5(N, V, Y)) : R = $0a39817bbf114bf6$var$D5(N, 0, N.length, V, Y), V.inAnchor = T, V.inline = L, V.e = u;
        }
    }
    return {
        node: {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlBlock,
            tag: M,
            attrs: $0a39817bbf114bf6$var$b5(B.attrs, M, Y),
            i: B.rawAttrs,
            children: R,
            a: void 0,
            text: S,
            d: !1,
            b: !1
        },
        end: A
    };
}
var $0a39817bbf114bf6$var$U6 = 200, $0a39817bbf114bf6$var$q9 = 0;
function $0a39817bbf114bf6$var$D5($, Q, Z, V, Y) {
    if ($0a39817bbf114bf6$var$q9++, $0a39817bbf114bf6$var$q9 > $0a39817bbf114bf6$var$U6) return $0a39817bbf114bf6$var$q9--, [
        {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.text,
            text: $.slice(Q, Z)
        }
    ];
    var G = V.g;
    V.g = void 0;
    let K = V;
    if (Y.optimizeForStreaming) {
        let M5 = function(D0, S0) {
            for(var L0 = 1, h0 = S0 + 1; h0 < D0.length; h0++){
                var Q5 = D0.charCodeAt(h0);
                if (Q5 === $0a39817bbf114bf6$var$A0) L0++;
                else if (Q5 === $0a39817bbf114bf6$var$K5 && (L0--, L0 === 0)) return h0;
            }
            return -1;
        }, y = $.slice(Q, Z), F0 = y;
        for(var J = 0, X = 0, U = 0, q = 0, W = 0, z = -1, F = -1, D = -1, O = -1, H = -1, B = 0; B < y.length; B++){
            var M = y.charCodeAt(B);
            M === $0a39817bbf114bf6$var$_0 ? B + 1 < y.length && y.charCodeAt(B + 1) === $0a39817bbf114bf6$var$_0 ? (J++, z = B, B++) : (X++, F = B) : M === $0a39817bbf114bf6$var$H0 ? B + 1 < y.length && y.charCodeAt(B + 1) === $0a39817bbf114bf6$var$H0 ? (U++, D = B, B++) : (q++, O = B) : M === $0a39817bbf114bf6$var$N0 && B + 1 < y.length && y.charCodeAt(B + 1) === $0a39817bbf114bf6$var$N0 && (W++, H = B, B++);
        }
        var j = [];
        W % 2 === 1 && H >= 0 && j.push([
            H,
            2
        ]), U % 2 === 1 && D >= 0 && j.push([
            D,
            2
        ]), q % 2 === 1 && O >= 0 && j.push([
            O,
            1
        ]), J % 2 === 1 && z >= 0 && j.push([
            z,
            2
        ]), X % 2 === 1 && F >= 0 && j.push([
            F,
            1
        ]), j.sort(function(D0, S0) {
            return S0[0] - D0[0];
        });
        for(var w = 0; w < j.length; w++){
            var I = j[w][0], A = j[w][1];
            y = y.slice(0, I) + y.slice(I + A);
        }
        let l0 = 0, X5 = -1;
        for(let D0 = 0; D0 < y.length; D0++)y.charCodeAt(D0) === $0a39817bbf114bf6$var$$0 && (l0++, X5 = D0);
        if (l0 % 2 === 1 && X5 !== -1) {
            let D0 = !1, S0 = -1, L0 = 0;
            for(; L0 < y.length;)y.charCodeAt(L0) === $0a39817bbf114bf6$var$$0 && (D0 ? (D0 = !1, S0 = -1) : (S0 = L0, D0 = !0)), L0++;
            D0 && S0 !== -1 && (y = y.slice(0, S0));
        }
        for(var k = !0; k;){
            k = !1;
            for(var S = -1, R = -1, N = -1, T = !1, L = 0; L < y.length; L++){
                var u = y.charCodeAt(L);
                if (u === $0a39817bbf114bf6$var$A0 && (L === 0 || y.charCodeAt(L - 1) !== $0a39817bbf114bf6$var$y0)) {
                    var x = L > 0 && y.charCodeAt(L - 1) === $0a39817bbf114bf6$var$p0, g = x ? L - 1 : L, P = M5(y, L);
                    if (P === -1) S = g, T = x, R = L + 1, N = y.length;
                    else {
                        var C = P + 1;
                        if (C >= y.length) S = g, T = x, R = L + 1, N = P;
                        else if (y.charCodeAt(C) === $0a39817bbf114bf6$var$F5) {
                            var d = y.indexOf(")", C + 1);
                            d === -1 ? (S = g, T = x, R = L + 1, N = P, L = y.length) : L = d;
                        } else if (y.charCodeAt(C) === $0a39817bbf114bf6$var$A0) {
                            var f = y.indexOf("]", C + 1);
                            f === -1 ? (S = g, T = x, R = L + 1, N = P, L = y.length) : L = f;
                        } else L = P;
                    }
                }
            }
            if (S >= 0) {
                var U0 = T ? "" : y.slice(R, N);
                y = y.slice(0, S) + U0, k = !0;
            }
        }
        let r0 = y.match(/<([A-Z][A-Za-z0-9]*)(?:\s[^>]*)?>([^<]*)$/);
        if (r0 && r0.index !== void 0) {
            var n = r0[0].length - r0[2].length, m0 = n >= 2 && r0[0].charCodeAt(n - 2) === $0a39817bbf114bf6$var$M0;
            if (!m0) {
                for(var x0 = !1, v0 = 0, l = 0; l < r0.index; l++)y.charCodeAt(l) === $0a39817bbf114bf6$var$$0 && v0++;
                if (x0 = v0 % 2 === 1, !x0) {
                    let D0 = r0[1];
                    $0a39817bbf114bf6$var$T5(y, "</" + D0, 0) === -1 && (y = y.slice(0, r0.index) + r0[2]);
                }
            }
        }
        y !== F0 && ($ = $.slice(0, Q) + y, Z = Q + y.length);
    }
    let t = [];
    var b0 = [];
    let r = Q;
    var z0 = "", Q0 = Y.disableAutoLink || Y.disableBareUrls || K.inAnchor ? -1 : $.indexOf("@", Q);
    for(Q0 >= Z && (Q0 = -1); Q < Z;){
        let y = $.charCodeAt(Q), F0 = null;
        if (y === $0a39817bbf114bf6$var$$0) {
            if (F0 = $0a39817bbf114bf6$var$t4($, Q, Z), !F0) {
                var I0 = $0a39817bbf114bf6$var$C5($, Q, Z, $0a39817bbf114bf6$var$$0);
                Q += I0 - 1;
            }
        } else if (y === $0a39817bbf114bf6$var$_0 || y === $0a39817bbf114bf6$var$H0) {
            var q0 = $0a39817bbf114bf6$var$Q6($, Q, Z);
            if (q0) {
                if (q0.canOpen || q0.canClose) {
                    (z0 || Q > r) && (t.push($0a39817bbf114bf6$var$r5(z0 + $.slice(r, Q))), z0 = "");
                    var V0 = $.slice(Q, Q + q0.len), O0 = $0a39817bbf114bf6$var$r5(V0);
                    b0.push({
                        idx: t.length,
                        ch: y,
                        len: q0.len,
                        canOpen: q0.canOpen,
                        canClose: q0.canClose,
                        active: !0
                    }), t.push(O0), Q += q0.len, r = Q;
                    continue;
                }
                Q += q0.len - 1;
            }
        } else if (y === $0a39817bbf114bf6$var$N0) F0 = $0a39817bbf114bf6$var$$6($, Q, Z, K, Y);
        else if (y === $0a39817bbf114bf6$var$G5) F0 = $0a39817bbf114bf6$var$Z6($, Q, Z, K, Y);
        else if (y === $0a39817bbf114bf6$var$A0) Q + 1 < Z && $.charCodeAt(Q + 1) === $0a39817bbf114bf6$var$U5 && (F0 = $0a39817bbf114bf6$var$Y6($, Q, Z, K)), F0 || (F0 = $0a39817bbf114bf6$var$o$($, Q, Z, K, Y));
        else if (y === $0a39817bbf114bf6$var$p0 && Q + 1 < Z && $.charCodeAt(Q + 1) === $0a39817bbf114bf6$var$A0) F0 = $0a39817bbf114bf6$var$o$($, Q, Z, K, Y);
        else if (y === $0a39817bbf114bf6$var$G0) F0 = $0a39817bbf114bf6$var$V4($, Q, Z), !F0 && !Y.disableParsingRawHTML && !Y.ignoreHTMLBlocks && (F0 = $0a39817bbf114bf6$var$X6($, Q, Z, K, Y));
        else if (y === $0a39817bbf114bf6$var$K9) {
            var m = $0a39817bbf114bf6$var$J6($, Q, Z);
            if (m !== -1) {
                var w0 = $.slice(Q, m), g0 = $0a39817bbf114bf6$var$s5(w0);
                if (g0 !== w0) {
                    z0 = z0 + $.slice(r, Q) + g0, Q = m, r = m;
                    continue;
                }
            }
        } else if ((y === $0a39817bbf114bf6$var$X9 || y === $0a39817bbf114bf6$var$k5 || y === $0a39817bbf114bf6$var$I5) && !K.inAnchor && !Y.disableAutoLink && (Q === 0 || $.charCodeAt(Q - 1) !== $0a39817bbf114bf6$var$G0)) {
            var R0 = Q + 1 < Z ? $.charCodeAt(Q + 1) : 0;
            (y === $0a39817bbf114bf6$var$X9 && R0 === $0a39817bbf114bf6$var$h5 || y === $0a39817bbf114bf6$var$I5 && R0 === $0a39817bbf114bf6$var$h5 || y === $0a39817bbf114bf6$var$k5 && R0 === $0a39817bbf114bf6$var$k5) && (F0 = $0a39817bbf114bf6$var$G6($, Q, Z, Y));
        }
        if (!F0 && Q0 >= 0 && Q0 - Q <= 64 && !K.inAnchor && !Y.disableAutoLink && !Y.disableBareUrls && (y >= $0a39817bbf114bf6$var$h && y <= $0a39817bbf114bf6$var$c || y >= $0a39817bbf114bf6$var$K0 && y <= $0a39817bbf114bf6$var$W0 || y >= $0a39817bbf114bf6$var$i && y <= $0a39817bbf114bf6$var$a) && (F0 = $0a39817bbf114bf6$var$K6($, Q, Z, Y), !F0 && Q >= Q0 && (Q0 = $.indexOf("@", Q + 1), Q0 >= Z && (Q0 = -1))), y === $0a39817bbf114bf6$var$E && K.e) {
            var Z5 = !1, i0 = 0;
            if (Q > r && $.charCodeAt(Q - 1) === $0a39817bbf114bf6$var$y0) Z5 = !0, i0 = 1;
            else {
                for(var T0 = 0, e = Q - 1; e >= r && $.charCodeAt(e) === $0a39817bbf114bf6$var$v;)T0++, e--;
                T0 >= 2 && (Z5 = !0, i0 = T0);
            }
            if (Z5) {
                for((z0 || Q - i0 > r) && (t.push($0a39817bbf114bf6$var$r5(z0 + $.slice(r, Q - i0))), z0 = ""), t.push({
                    type: $0a39817bbf114bf6$export$e0aa44767d8750d5.breakLine
                }), Q++; Q < Z && $.charCodeAt(Q) === $0a39817bbf114bf6$var$v;)Q++;
                r = Q;
                continue;
            }
            var Y0 = Q > r && $.charCodeAt(Q - 1) === $0a39817bbf114bf6$var$v, a0 = Q + 1 < Z && $.charCodeAt(Q + 1) === $0a39817bbf114bf6$var$v;
            if (Y0 || a0) {
                for(var B0 = Q; B0 > r && $.charCodeAt(B0 - 1) === $0a39817bbf114bf6$var$v;)B0--;
                for(z0 += $.slice(r, B0) + `
`, Q++; Q < Z && $.charCodeAt(Q) === $0a39817bbf114bf6$var$v;)Q++;
                r = Q;
                continue;
            }
        }
        if (F0) (z0 || Q > r) && (t.push($0a39817bbf114bf6$var$r5(z0 + $.slice(r, Q))), z0 = ""), t.push(F0.node), Q = F0.end, r = Q;
        else {
            if (y === $0a39817bbf114bf6$var$y0 && Q + 1 < Z) {
                let l0 = $.charCodeAt(Q + 1);
                if ($0a39817bbf114bf6$var$n9(l0) & $0a39817bbf114bf6$var$p5) {
                    (z0 || Q > r) && (t.push($0a39817bbf114bf6$var$r5(z0 + $.slice(r, Q))), z0 = ""), t.push($0a39817bbf114bf6$var$r5($[Q + 1])), Q += 2, r = Q;
                    continue;
                }
            }
            if (Q++, Q0 < 0 || Q0 - Q > 64) for(; Q < Z && !(Q0 >= 0 && Q0 - Q <= 64);){
                var A5 = $.charCodeAt(Q);
                if (A5 < $0a39817bbf114bf6$var$n5 && !$0a39817bbf114bf6$var$n$[A5]) Q++;
                else break;
            }
        }
    }
    return (z0 || Z > r) && (t.push($0a39817bbf114bf6$var$r5(z0 + $.slice(r, Z))), z0 = ""), b0.length > 0 && $0a39817bbf114bf6$var$V6(t, b0, V, Y), V.g = G, $0a39817bbf114bf6$var$q9--, t;
}
var $0a39817bbf114bf6$var$F6 = 500;
function $0a39817bbf114bf6$var$f5($, Q, Z) {
    var V = Q.j || 0;
    if (V > $0a39817bbf114bf6$var$F6) return [
        {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.text,
            text: $
        }
    ];
    Q.j = V + 1;
    let Y = Q;
    if (Z.optimizeForStreaming && !Q.m) {
        var G = $.length;
        G > 0 && $.charCodeAt(G - 1) === $0a39817bbf114bf6$var$E && G--;
        for(var K = G; K > 0 && $.charCodeAt(K - 1) !== $0a39817bbf114bf6$var$E;)K--;
        if (K > 0 && $.charCodeAt(K) === $0a39817bbf114bf6$var$k0) {
            for(var J = !0, X = K; X < G; X++){
                var U = $.charCodeAt(X);
                if (U !== $0a39817bbf114bf6$var$v && U !== $0a39817bbf114bf6$var$b && U !== $0a39817bbf114bf6$var$p && U !== $0a39817bbf114bf6$var$f0 && U !== $0a39817bbf114bf6$var$k0) {
                    J = !1;
                    break;
                }
            }
            if (J) {
                for(var q = K - 1; q > 0 && $.charCodeAt(q - 1) !== $0a39817bbf114bf6$var$E;)q--;
                $.charCodeAt(q) === $0a39817bbf114bf6$var$k0 && ($ = $.slice(0, q).trimEnd());
            }
        }
        var W = $.trim(), z = W.lastIndexOf(`
`), F = z === -1 ? W : W.slice(z + 1);
        if (F.length > 0 && F.charCodeAt(0) === $0a39817bbf114bf6$var$k0) {
            for(var D = !1, O = !1, H = 1; H < F.length; H++){
                var B = F.charCodeAt(H);
                B === $0a39817bbf114bf6$var$k0 && (D = !0), B === $0a39817bbf114bf6$var$p && (O = !0);
            }
            D && O && ($ = z === -1 ? "" : $.slice(0, $.lastIndexOf(F)).trimEnd());
        }
        for(var M = -1, j = -1, w = -1, I = $.length - 1; I >= 0; I--)if ($.charCodeAt(I) === $0a39817bbf114bf6$var$G0) {
            var A = I + 1 < $.length ? $.charCodeAt(I + 1) : 0;
            if (A >= $0a39817bbf114bf6$var$h && A <= $0a39817bbf114bf6$var$c || A >= $0a39817bbf114bf6$var$K0 && A <= $0a39817bbf114bf6$var$W0) {
                for(var k = I + 2; k < $.length;){
                    var S = $.charCodeAt(k);
                    if (S >= $0a39817bbf114bf6$var$h && S <= $0a39817bbf114bf6$var$c || S >= $0a39817bbf114bf6$var$K0 && S <= $0a39817bbf114bf6$var$W0 || S >= $0a39817bbf114bf6$var$i && S <= $0a39817bbf114bf6$var$a) k++;
                    else break;
                }
                for(var R = k; R < $.length && $.charCodeAt(R) !== $0a39817bbf114bf6$var$o;)R++;
                if (R < $.length && $.charCodeAt(R - 1) !== $0a39817bbf114bf6$var$M0) {
                    for(var N = !1, T = R + 1; T < $.length; T++)if ($.charCodeAt(T) === $0a39817bbf114bf6$var$G0) {
                        N = !0;
                        break;
                    }
                    N || (M = I, j = k, w = R + 1);
                }
            }
            break;
        }
        if (M >= 0) {
            for(var L = 0, u = 0; u < M; u++)$.charCodeAt(u) === $0a39817bbf114bf6$var$$0 && L++;
            if (L % 2 === 0) {
                var x = $.slice(M + 1, j);
                $0a39817bbf114bf6$var$T5($, "</" + x, 0) === -1 && ($ = $.slice(0, M) + $.slice(w));
            }
        }
        for(var g = $.length; g > 0 && $.charCodeAt(g - 1) === $0a39817bbf114bf6$var$E;)g--;
        if (g > 0) {
            for(var P = g; P > 0 && $.charCodeAt(P - 1) !== $0a39817bbf114bf6$var$E;)P--;
            for(var C = P, d = 0; C < g && $.charCodeAt(C) === $0a39817bbf114bf6$var$v && d < 3;)C++, d++;
            if (P > 0 && C < g && $0a39817bbf114bf6$var$p4($, C, g)) {
                for(var f = P - 1, U0 = f; U0 > 0 && $.charCodeAt(U0 - 1) !== $0a39817bbf114bf6$var$E;)U0--;
                $0a39817bbf114bf6$var$e0($, U0, f) || ($ = $.slice(0, P).trimEnd());
            }
        }
        var n = $.length;
        if (n > 0) {
            for(var m0 = $.lastIndexOf(`
`), x0 = m0 === -1 ? 0 : m0 + 1, v0 = n, l = x0, t = 0; l < v0 && $.charCodeAt(l) === $0a39817bbf114bf6$var$v && t < 3;)l++, t++;
            if (l < v0) {
                var b0 = $.charCodeAt(l), r = !1;
                if (b0 === $0a39817bbf114bf6$var$_0 || b0 === $0a39817bbf114bf6$var$p || b0 === $0a39817bbf114bf6$var$N5) {
                    var z0 = l + 1;
                    if (z0 >= v0 || $.charCodeAt(z0) === $0a39817bbf114bf6$var$v || $.charCodeAt(z0) === $0a39817bbf114bf6$var$b) {
                        for(var Q0 = z0; Q0 < v0 && ($.charCodeAt(Q0) === $0a39817bbf114bf6$var$v || $.charCodeAt(Q0) === $0a39817bbf114bf6$var$b);)Q0++;
                        Q0 >= v0 && (r = !0);
                    }
                } else if (b0 >= $0a39817bbf114bf6$var$i && b0 <= $0a39817bbf114bf6$var$a) {
                    for(var I0 = l; I0 < v0 && $.charCodeAt(I0) >= $0a39817bbf114bf6$var$i && $.charCodeAt(I0) <= $0a39817bbf114bf6$var$a;)I0++;
                    if (I0 < v0 && ($.charCodeAt(I0) === $0a39817bbf114bf6$var$s0 || $.charCodeAt(I0) === $0a39817bbf114bf6$var$q5)) {
                        var q0 = I0 + 1;
                        if (q0 >= v0 || $.charCodeAt(q0) === $0a39817bbf114bf6$var$v || $.charCodeAt(q0) === $0a39817bbf114bf6$var$b) {
                            for(var V0 = q0; V0 < v0 && ($.charCodeAt(V0) === $0a39817bbf114bf6$var$v || $.charCodeAt(V0) === $0a39817bbf114bf6$var$b);)V0++;
                            V0 >= v0 && (r = !0);
                        }
                    }
                }
                r && ($ = $.slice(0, x0).trimEnd());
            }
        }
    }
    if (Q.inline) return $0a39817bbf114bf6$var$D5($, 0, $.length, Q, Z);
    let O0 = [], m = 0, w0 = $.length;
    if (m === 0 && !Z.disableFrontmatter && $.startsWith("---")) {
        let Y0 = $0a39817bbf114bf6$var$I$($);
        if (Y0 && Y0.hasValidYaml) {
            if (Z.preserveFrontmatter !== !1) {
                let a0 = $.slice(0, Y0.endPos).trimEnd();
                O0.push({
                    type: $0a39817bbf114bf6$export$e0aa44767d8750d5.frontmatter,
                    text: a0
                });
            }
            m = Y0.endPos;
        }
    }
    for(; m < w0;){
        for(var g0 = $.indexOf(`
`, m), R0 = g0 < 0 ? w0 : g0; m < w0 && $0a39817bbf114bf6$var$e0($, m, R0);)m = R0 < w0 ? R0 + 1 : R0, m < w0 && (g0 = $.indexOf(`
`, m), R0 = g0 < 0 ? w0 : g0);
        if (m >= w0) break;
        var Z5 = $.charCodeAt(m) === $0a39817bbf114bf6$var$v9;
        $0a39817bbf114bf6$var$P0($, m, R0);
        let Y0 = null;
        if ($0a39817bbf114bf6$var$l9 = $, $0a39817bbf114bf6$var$r9 = m, $0a39817bbf114bf6$var$w9 = R0, !Z5 && $0a39817bbf114bf6$var$J0 >= 4 && !Q.inHTML) Y0 = $0a39817bbf114bf6$var$c4($, m);
        else if (!Z5) {
            let a0 = m + $0a39817bbf114bf6$var$Z0, B0 = $.charCodeAt(a0);
            B0 === $0a39817bbf114bf6$var$Y5 ? Y0 = $0a39817bbf114bf6$var$u4($, m, Q, Z) : B0 === $0a39817bbf114bf6$var$o ? Y0 = $0a39817bbf114bf6$var$l4($, m, Q, Z) : B0 === $0a39817bbf114bf6$var$$0 || B0 === $0a39817bbf114bf6$var$N0 ? Y0 = $0a39817bbf114bf6$var$d4($, m, Q) : B0 === $0a39817bbf114bf6$var$p || B0 === $0a39817bbf114bf6$var$_0 || B0 === $0a39817bbf114bf6$var$H0 ? (Y0 = $0a39817bbf114bf6$var$x5($, m), !Y0 && (Y0 = $0a39817bbf114bf6$var$p$($, m, Q, Z))) : B0 === $0a39817bbf114bf6$var$N5 || B0 >= $0a39817bbf114bf6$var$i && B0 <= $0a39817bbf114bf6$var$a ? Y0 = $0a39817bbf114bf6$var$p$($, m, Q, Z) : B0 === $0a39817bbf114bf6$var$G0 ? Y0 = $0a39817bbf114bf6$var$Q4($, m, Q, Z) : B0 === $0a39817bbf114bf6$var$k0 ? Y0 = $0a39817bbf114bf6$var$c$($, m, Q, Z) : B0 === $0a39817bbf114bf6$var$A0 && (Y0 = $0a39817bbf114bf6$var$a4($, m, Q));
        }
        if (!Y0) {
            for(var i0 = !1, T0 = m; T0 < R0; T0++)if ($.charCodeAt(T0) === $0a39817bbf114bf6$var$k0) {
                i0 = !0;
                break;
            }
            i0 && (Y0 = $0a39817bbf114bf6$var$c$($, m, Q, Z));
        }
        if (Y0 || (Y0 = $0a39817bbf114bf6$var$s4($, m, Q, Z)), Y0) Y0.node.type !== $0a39817bbf114bf6$export$e0aa44767d8750d5.refCollection && O0.push(Y0.node), m = Y0.end;
        else {
            var e = $.indexOf(`
`, m);
            m = e < 0 ? w0 : e + 1;
        }
    }
    return Q.j = V, O0;
}
function $0a39817bbf114bf6$export$8f49e4af10703ce3($, Q) {
    $.charCodeAt(0) === 65279 && ($ = $.slice(1));
    let Z = {
        inline: !1,
        inAnchor: !1,
        inHTML: !1,
        inList: !1,
        inBlockQuote: !1,
        refs: {}
    }, V = {
        ...Q,
        slugify: Q?.slugify ? (Y)=>Q.slugify(Y, $0a39817bbf114bf6$export$c383cdd2a518017a) : $0a39817bbf114bf6$export$c383cdd2a518017a,
        sanitizer: Q?.sanitizer || $0a39817bbf114bf6$export$3e2338ea76b578c9,
        tagfilter: Q?.tagfilter !== !1
    };
    return $0a39817bbf114bf6$var$H9($, Z, V);
}
function $0a39817bbf114bf6$var$Y4($, Q, Z, V) {
    var Y = $0a39817bbf114bf6$var$w5($, Q);
    return Y ? {
        tagName: Y.tag,
        tagLower: Y.tag.toLowerCase(),
        attrs: Y.rawAttrs,
        whitespaceBeforeAttrs: Y.whitespaceBeforeAttrs,
        isSelfClosing: Y.selfClosing,
        hasSpaceBeforeSlash: Y.hasSpaceBeforeSlash,
        isClosing: Y.isClosing,
        hasNewline: Y.whitespaceBeforeAttrs.includes(`
`) || Y.rawAttrs.includes(`
`),
        endPos: Y.end
    } : null;
}
function $0a39817bbf114bf6$var$H9($, Q, Z) {
    $0a39817bbf114bf6$var$q9 = 0, $ = $0a39817bbf114bf6$var$w$($), !Q.refs && (Q.refs = {}), (Z.optimizeForStreaming || Q.inline) && (Q.m = $0a39817bbf114bf6$var$h4($, Q.refs, Z));
    var V = !Q.k;
    V && (Q.k = [], Q.h = []);
    let Y = $0a39817bbf114bf6$var$f5($, Q, Z);
    if (V) {
        for(var G = Q.k, K = {
            inline: Q.inline,
            inAnchor: Q.inAnchor,
            inHTML: Q.inHTML,
            htmlDepth: Q.c,
            inList: Q.inList,
            inBlockQuote: Q.inBlockQuote,
            noSetext: Q.f,
            depth: Q.j
        }, J = 0; J < G.length; J++){
            var X = G[J];
            Q.inline = X.inline, Q.inAnchor = X.inAnchor, Q.inHTML = X.inHTML, Q.c = X.htmlDepth, Q.inList = X.inList, Q.inBlockQuote = X.inBlockQuote, Q.f = X.noSetext, Q.j = X.depth, Q.e = X.breaks;
            var U = $0a39817bbf114bf6$var$D5(X.text, 0, X.text.length, Q, Z);
            Q.e = !1;
            for(var q = 0; q < U.length; q++)X.dest.push(U[q]);
        }
        Q.inline = K.inline, Q.inAnchor = K.inAnchor, Q.inHTML = K.inHTML, Q.c = K.htmlDepth, Q.inList = K.inList, Q.inBlockQuote = K.inBlockQuote, Q.f = K.noSetext, Q.j = K.depth;
        for(var W = Q.h, z = 0; z < W.length; z++)for(var F = W[z], D = 0; D < F.src.length; D++){
            var O = F.src[D];
            if (F.unwrap && O.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.paragraph) for(var H = O.children, B = 0; B < H.length; B++)F.dest.push(H[B]);
            else F.dest.push(O);
        }
        Q.k = void 0, Q.h = void 0;
    }
    return $0a39817bbf114bf6$var$P9(Q.refs) ? [
        {
            type: $0a39817bbf114bf6$export$e0aa44767d8750d5.refCollection,
            refs: Q.refs
        },
        ...Y
    ] : Y;
}
var $0a39817bbf114bf6$var$t9;
try {
    $0a39817bbf114bf6$var$t9 = $h4Bez.createElement("div").$$typeof;
} catch  {
    $0a39817bbf114bf6$var$t9 = Symbol.for("react.transitional.element");
}
function $0a39817bbf114bf6$var$e9($, Q, Z) {
    return {
        $$typeof: $0a39817bbf114bf6$var$t9,
        type: $,
        key: Z != null ? "" + Z : null,
        ref: null,
        props: Q,
        _owner: null,
        _store: {},
        _debugStack: null,
        _debugTask: null
    };
}
var $0a39817bbf114bf6$export$744f81673f21877c = typeof $h4Bez.createContext < "u" ? $h4Bez.createContext(void 0) : void 0;
function $0a39817bbf114bf6$var$G4($, Q, Z, V, Y, G, K, J, X) {
    switch($.type){
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.blockQuote:
            {
                let F = {
                    key: Z.key
                };
                return $.alert && (F.className = "markdown-alert-" + G($.alert.toLowerCase(), $0a39817bbf114bf6$export$c383cdd2a518017a), $.children.unshift($0a39817bbf114bf6$var$R$($.alert))), V("blockquote", F, Q($.children, Z));
            }
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.breakLine:
            return V("br", {
                key: Z.key
            });
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.breakThematic:
            return V("hr", {
                key: Z.key
            });
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.frontmatter:
            return J.preserveFrontmatter ? V("pre", {
                key: Z.key
            }, $.text) : null;
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.codeBlock:
            let z = $.lang ? $0a39817bbf114bf6$var$s5($.lang) : "";
            return V("pre", {
                key: Z.key
            }, V("code", {
                ...$0a39817bbf114bf6$var$t0($.attrs),
                className: z ? `language-${z} lang-${z}` : ""
            }, $.text));
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.codeInline:
            return V("code", {
                key: Z.key
            }, $.text);
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.footnoteReference:
            return V("a", {
                key: Z.key,
                href: Y($.target, "a", "href") || void 0
            }, V("sup", null, $.text));
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.gfmTask:
            return V("input", {
                checked: $.completed,
                key: Z.key,
                readOnly: !0,
                type: "checkbox"
            });
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.heading:
            return V(`h${$.level}`, {
                id: $.id,
                key: Z.key
            }, Q($.children, Z));
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlBlock:
            {
                let F = $;
                if (J.tagfilter && $0a39817bbf114bf6$var$u9(F.tag)) return V("span", {
                    key: Z.key
                }, "<" + F.tag + $0a39817bbf114bf6$var$h9(F.attrs) + ">");
                if (F.a && F.d) {
                    let D = F.tag.toLowerCase(), O = $0a39817bbf114bf6$var$s$(D), H = F.children && F.children.length > 0;
                    if (O) {
                        let L = $0a39817bbf114bf6$var$S$(F.a, D, J.tagfilter);
                        return /<[a-z][^>]{0,100}>/i.test(F.a) ? X($.tag, {
                            key: Z.key,
                            ...$0a39817bbf114bf6$var$t0($.attrs),
                            dangerouslySetInnerHTML: {
                                __html: L
                            }
                        }) : X($.tag, {
                            key: Z.key,
                            ...$0a39817bbf114bf6$var$t0($.attrs)
                        }, L);
                    }
                    let B = new RegExp(`^<${F.tag}(\\s|>)`, "i");
                    if (H && !B.test(F.a) && J.tagfilter && $0a39817bbf114bf6$var$T$(F.a)) return X($.tag, {
                        key: Z.key,
                        ...$0a39817bbf114bf6$var$t0($.attrs)
                    }, Q(F.children, Z));
                    if ($0a39817bbf114bf6$var$t$(F.a)) {
                        let L = J.tagfilter ? $0a39817bbf114bf6$var$p9(F.a) : F.a;
                        return X($.tag, {
                            key: Z.key,
                            ...$0a39817bbf114bf6$var$t0($.attrs),
                            dangerouslySetInnerHTML: {
                                __html: L
                            }
                        });
                    }
                    let j = {
                        slugify: (L)=>G(L, $0a39817bbf114bf6$export$c383cdd2a518017a),
                        sanitizer: Y,
                        tagfilter: !0
                    }, w = F.a.replace(/>\s+</g, "><").replace(/\n+/g, " ").trim();
                    if (new RegExp(`^<${F.tag}(\\s[^>]*)?>(\\s*</${F.tag}>)?$`, "i").test(w)) return F.children && F.children.length > 0 ? X($.tag, {
                        key: Z.key,
                        ...$0a39817bbf114bf6$var$t0($.attrs)
                    }, Q(F.children, Z)) : X($.tag, {
                        key: Z.key,
                        ...$0a39817bbf114bf6$var$t0($.attrs)
                    });
                    let A = $0a39817bbf114bf6$var$H9(w, {
                        inline: !1,
                        refs: K,
                        inHTML: !1
                    }, j);
                    $0a39817bbf114bf6$var$m9(A);
                    let k = F.tag.toLowerCase(), S = "</" + k + ">", R = B.test(w), N = w.toLowerCase().trimEnd().endsWith(S), T = R && N;
                    if (T && H) return X($.tag, {
                        key: Z.key,
                        ...$0a39817bbf114bf6$var$t0($.attrs)
                    }, Q(F.children, Z));
                    if (T) return Q(A.flatMap($0a39817bbf114bf6$var$d5), Z);
                    var U = $0a39817bbf114bf6$var$k$(A, k);
                    if (U.found && U.afterClose.length > 0) {
                        var q = U.beforeClose.flatMap($0a39817bbf114bf6$var$d5), W = U.afterClose.flatMap($0a39817bbf114bf6$var$d5);
                        return $0a39817bbf114bf6$var$e9($h4Bez.Fragment, {
                            children: [
                                X($.tag, {
                                    key: Z.key,
                                    ...$0a39817bbf114bf6$var$t0($.attrs)
                                }, Q(q, Z)),
                                Q(W, Z)
                            ]
                        }, Z.key);
                    }
                    return X($.tag, {
                        key: Z.key,
                        ...$0a39817bbf114bf6$var$t0($.attrs)
                    }, Q(A.flatMap($0a39817bbf114bf6$var$d5), Z));
                }
                return $0a39817bbf114bf6$var$l5($.tag) ? X($.tag, {
                    key: Z.key,
                    ...$0a39817bbf114bf6$var$t0($.attrs)
                }) : X($.tag, {
                    key: Z.key,
                    ...$0a39817bbf114bf6$var$t0($.attrs)
                }, $.children ? Q($.children, Z) : "");
            }
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.htmlSelfClosing:
            {
                let F = $;
                return J.tagfilter && $0a39817bbf114bf6$var$u9(F.tag) ? V("span", {
                    key: Z.key
                }, "<" + F.tag + $0a39817bbf114bf6$var$h9(F.attrs) + " />") : X($.tag, {
                    key: Z.key,
                    ...$0a39817bbf114bf6$var$t0($.attrs)
                });
            }
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.image:
            {
                let F = $.target != null ? Y($.target, "img", "src") : null;
                return V("img", {
                    key: Z.key,
                    alt: $.alt && $.alt.length > 0 ? $.alt : void 0,
                    title: $.title || void 0,
                    src: F || void 0
                });
            }
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.link:
            {
                let F = {
                    key: Z.key
                };
                return $.target != null && (F.href = $0a39817bbf114bf6$var$E$($.target)), $.title && (F.title = $.title), V("a", F, Q($.children, Z));
            }
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.table:
            {
                let F = $;
                return V("table", {
                    key: Z.key
                }, V("thead", {
                    key: "thead"
                }, V("tr", null, F.header.map(function(O, H) {
                    return V("th", {
                        key: H,
                        style: F.align[H] == null ? {} : {
                            textAlign: F.align[H]
                        }
                    }, Q(O, Z));
                }))), F.cells.length > 0 && V("tbody", {
                    key: "tbody"
                }, F.cells.map(function(O, H) {
                    return V("tr", {
                        key: H
                    }, O.map(function(M, j) {
                        return V("td", {
                            key: j,
                            style: F.align[j] == null ? {} : {
                                textAlign: F.align[j]
                            }
                        }, Q(M, Z));
                    }));
                })));
            }
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.text:
            return $.text;
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.textFormatted:
            return V($.tag, {
                key: Z.key
            }, Q($.children, Z));
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.orderedList:
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.unorderedList:
            {
                let F = $.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.orderedList ? "ol" : "ul";
                return V(F, {
                    key: Z.key,
                    start: $.type === $0a39817bbf114bf6$export$e0aa44767d8750d5.orderedList ? $.start : void 0
                }, $.items.map(function(O, H) {
                    return V("li", {
                        key: H
                    }, Q(O, Z));
                }));
            }
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.paragraph:
            return V("p", {
                key: Z.key
            }, Q($.children, Z));
        case $0a39817bbf114bf6$export$e0aa44767d8750d5.ref:
            return null;
        default:
            return null;
    }
}
var $0a39817bbf114bf6$var$z6 = ($, Q, Z, V, Y, G, K)=>{
    var J = (U)=>U.map(function(q) {
            return "text" in q ? q.text : "";
        }), X = (U, q = {})=>{
        var W = (q.renderDepth || 0) + 1;
        if (W > 2500) return J(U);
        q.renderDepth = W;
        for(var z = q.key, F = [], D = !1, O = 0; O < U.length; O++){
            q.key = O;
            var H;
            if ($) {
                var B = $0a39817bbf114bf6$var$G4.bind(null, U[O], X, q, Q, Z, V, Y, G, K);
                H = $(B, U[O], X, q);
            } else H = $0a39817bbf114bf6$var$G4(U[O], X, q, Q, Z, V, Y, G, K);
            var M = typeof H == "string";
            if (M && D) F[F.length - 1] += H;
            else if (H !== null) {
                if (Array.isArray(H)) for(var j = 0; j < H.length; j++)F.push(H[j]);
                else F.push(H);
            }
            D = M;
        }
        return q.key = z, q.renderDepth = W - 1, F;
    };
    return X;
}, $0a39817bbf114bf6$var$H6 = ($, Q)=>{
    let Z = $0a39817bbf114bf6$var$t5(Q, $, void 0);
    return Z ? typeof Z == "function" || typeof Z == "object" && "render" in Z ? Z : $0a39817bbf114bf6$var$t5(Q, `${$}.component`, $) : $;
};
function $0a39817bbf114bf6$export$bec156a8c5e29fb6($, Q) {
    let Z = {
        ...Q || {}
    };
    Z.overrides = Z.overrides || {};
    let V = Z.slugify || $0a39817bbf114bf6$export$c383cdd2a518017a, Y = Z.sanitizer || $0a39817bbf114bf6$export$3e2338ea76b578c9, G = Z.createElement, K = $0a39817bbf114bf6$var$P9(Z.overrides), J = (j)=>$0a39817bbf114bf6$export$69f434acfbdb0b32(j, {
            ...Z,
            wrapper: null
        });
    function X(j) {
        for(var w in j){
            var I = j[w];
            if (typeof I == "string" && I.length > 0 && I.charCodeAt(0) === $0a39817bbf114bf6$var$G0 && ($0a39817bbf114bf6$var$i$.test(I) || $0a39817bbf114bf6$var$a$.test(I) || $0a39817bbf114bf6$var$Y4(I, 0))) {
                var A = J(I.trim());
                j[w] = w === "innerHTML" && Array.isArray(A) ? A[0] : A;
            }
        }
    }
    function U(j, w, ...I) {
        var A = w || {}, k = j;
        if (K) {
            var S = $0a39817bbf114bf6$var$t5(Z.overrides, j + ".props", {});
            k = $0a39817bbf114bf6$var$H6(j, Z.overrides), A = {
                ...A,
                ...S,
                className: $0a39817bbf114bf6$var$g$(A.className, S.className) || void 0
            };
        }
        if (!G) {
            var R = A.key;
            return R != null && delete A.key, I.length === 1 ? A.children = I[0] : I.length > 1 && (A.children = I), $0a39817bbf114bf6$var$e9(k, A, R);
        }
        return G(k, A, ...I);
    }
    function q(j, w, ...I) {
        return w && X(w), U(j, w, ...I);
    }
    let W = {
        ...Z,
        slugify: Z.slugify ? (j)=>Z.slugify(j, $0a39817bbf114bf6$export$c383cdd2a518017a) : $0a39817bbf114bf6$export$c383cdd2a518017a,
        sanitizer: Y,
        tagfilter: Z.tagfilter !== !1
    }, z = $[0] && $[0].type === $0a39817bbf114bf6$export$e0aa44767d8750d5.refCollection ? $[0].refs : {}, F = $0a39817bbf114bf6$var$z6(Z.renderRule, U, Y, V, z, Z, q), D = F($, {
        inline: Z.forceInline,
        refs: z
    }), O = $0a39817bbf114bf6$var$L$(z);
    if (O.length && D.push(U("footer", {
        key: "footer"
    }, O.map(function(w) {
        let I = w.identifier.charCodeAt(0) === $0a39817bbf114bf6$var$U5 ? w.identifier.slice(1) : w.identifier, A = $0a39817bbf114bf6$var$H9(w.footnote, {
            inline: !0,
            refs: z
        }, W);
        return U("div", {
            id: V(I, $0a39817bbf114bf6$export$c383cdd2a518017a),
            key: w.identifier
        }, I + ": ", F(A, {
            inline: !0,
            refs: z
        }));
    }))), Z.wrapper === null) return D;
    let H = Z.wrapper || (Z.forceInline ? "span" : "div"), B;
    if (D.length > 1 || Z.forceWrapper) B = D;
    else return D.length === 1 ? D[0] : null;
    var M = Z.wrapperProps ? {
        ...Z.wrapperProps
    } : {};
    return M.children = B, $0a39817bbf114bf6$var$e9(H, M, "outer");
}
function $0a39817bbf114bf6$export$69f434acfbdb0b32($ = "", Q = {}) {
    let Z = {
        ...Q || {}
    };
    Z.overrides = Z.overrides || {};
    let V = Z.slugify || $0a39817bbf114bf6$export$c383cdd2a518017a, Y = Z.sanitizer || $0a39817bbf114bf6$export$3e2338ea76b578c9;
    function G(J) {
        let X = Z.forceInline || !Z.forceBlock && !$0a39817bbf114bf6$var$v$.test(J), U = {
            ...Z,
            slugify: Z.slugify ? (F)=>Z.slugify(F, $0a39817bbf114bf6$export$c383cdd2a518017a) : $0a39817bbf114bf6$export$c383cdd2a518017a,
            sanitizer: Y,
            tagfilter: Z.tagfilter !== !1
        }, q = X ? J : $0a39817bbf114bf6$var$y$(J);
        if (Z.optimizeForStreaming) {
            var W = q.lastIndexOf("<");
            W !== -1 && q.indexOf(">", W) === -1 && (q = q.slice(0, W));
        }
        let z = $0a39817bbf114bf6$var$H9(q, {
            inline: X,
            refs: K
        }, U);
        return $0a39817bbf114bf6$export$bec156a8c5e29fb6(z, {
            ...U,
            forceInline: X
        });
    }
    let K = {};
    return G($);
}
var $0a39817bbf114bf6$export$e4bfb950a582069c = ({ options: $, children: Q })=>$0a39817bbf114bf6$export$744f81673f21877c ? $h4Bez.createElement($0a39817bbf114bf6$export$744f81673f21877c.Provider, {
        value: $
    }, Q) : Q;
function $0a39817bbf114bf6$var$B6($) {
    let Q = $h4Bez.useRef($), Z = Q.current;
    if (Z !== $) {
        var V = !0, Y = 0;
        for(var G in $)if (Y++, !Object.is(Z[G], $[G])) {
            V = !1;
            break;
        }
        if (V) {
            var K = 0;
            for(var J in Z)K++;
            V = K === Y;
        }
        V || (Q.current = $);
    }
    return Q.current;
}
var $0a39817bbf114bf6$export$7460c8b7e4ce9582 = ({ children: $, options: Q, ...Z })=>{
    if (!(typeof $h4Bez.useContext < "u")) {
        let U = {
            ...Q,
            overrides: {
                ...Q?.overrides
            },
            wrapperProps: {
                ...Q?.wrapperProps,
                ...Z
            }
        };
        return $0a39817bbf114bf6$export$69f434acfbdb0b32($ ?? "", U);
    }
    let Y = $h4Bez.useContext($0a39817bbf114bf6$export$744f81673f21877c), G = $0a39817bbf114bf6$var$B6(Z), K = $h4Bez.useMemo(()=>({
            ...Y,
            ...Q,
            overrides: {
                ...Y?.overrides,
                ...Q?.overrides
            },
            wrapperProps: {
                ...Y?.wrapperProps,
                ...Q?.wrapperProps,
                ...G
            }
        }), [
        Y,
        Q,
        G
    ]), J = $ ?? "";
    return $h4Bez.useMemo(()=>$0a39817bbf114bf6$export$69f434acfbdb0b32(J, K), [
        J,
        K
    ]);
}, $0a39817bbf114bf6$export$2e2bcd8739ae039 = $0a39817bbf114bf6$export$7460c8b7e4ce9582;


/** Internal only symbol used by `Form` & `ObjectField` to mark an additional property element to be removed */ const $9c6fb2049cbb4fc1$export$bccc68d61c860794 = Symbol('remove-this-key');
const $9c6fb2049cbb4fc1$export$fad84d7d29d2c2bf = Symbol('reset');


/** Returns a flag indicating whether the `name` field is required in the object schema
 *
 * @param schema - The schema to check
 * @param name - The name of the field to check for required-ness
 * @returns - True if the field `name` is required, false otherwise
 */ function $0d904e6f36925ae3$var$isRequired(schema, name) {
    return Array.isArray(schema.required) && schema.required.includes(name);
}
/** Returns a default value to be used for a new additional schema property of the given `type`
 *
 * @param translateString - The string translation function from the registry
 * @param type - The type of the new additional schema property
 */ function $0d904e6f36925ae3$var$getDefaultValue(translateString, type) {
    switch(type){
        case 'array':
            return [];
        case 'boolean':
            return false;
        case 'null':
            return null;
        case 'number':
            return 0;
        case 'object':
            return {};
        case 'string':
        default:
            // We don't have a datatype for some reason (perhaps additionalProperties was true)
            return translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).NewStringDefault);
    }
}
/** The `ObjectFieldProperty` component is used to render the `SchemaField` for a child property of an object
 */ function $0d904e6f36925ae3$var$ObjectFieldPropertyFn(props) {
    const { fieldPathId: fieldPathId, schema: schema, registry: registry, uiSchema: uiSchema, errorSchema: errorSchema, formData: formData, onChange: onChange, onBlur: onBlur, onFocus: onFocus, disabled: disabled, readonly: readonly, required: required, hideError: hideError, propertyName: propertyName, handleKeyRename: handleKeyRename, handleRemoveProperty: handleRemoveProperty, addedByAdditionalProperties: addedByAdditionalProperties } = props;
    const [wasPropertyKeyModified, setWasPropertyKeyModified] = (0, $h4Bez.useState)(false);
    const { globalFormOptions: globalFormOptions, fields: fields } = registry;
    const { SchemaField: SchemaField } = fields;
    const innerFieldIdPathId = (0, $00773362d992a2a1$export$2e2bcd8739ae039)((0, $99206247aba21705$export$2e2bcd8739ae039)(propertyName, globalFormOptions, fieldPathId.path));
    /** Returns the `onPropertyChange` handler for the `name` field. Handles the special case where a user is attempting
     * to clear the data for a field added as an additional property. Calls the `onChange()` handler with the updated
     * formData.
     *
     * @param name - The name of the property
     * @param addedByAdditionalProperties - Flag indicating whether this property is an additional property
     * @returns - The onPropertyChange callback for the `name` property
     */ const onPropertyChange = (0, $h4Bez.useCallback)((value, path, newErrorSchema, id)=>{
        // Don't set value = undefined for fields added by additionalProperties. Doing so removes them from the
        // formData, which causes them to completely disappear (including the input field for the property name). Unlike
        // fields which are "mandated" by the schema, these fields can be set to undefined by clicking a "delete field"
        // button, so set empty values to the empty string.
        let normalizedValue = value;
        if (value === undefined && addedByAdditionalProperties) normalizedValue = '';
        onChange(normalizedValue, path, newErrorSchema, id);
    }, [
        onChange,
        addedByAdditionalProperties
    ]);
    /** The key change event handler; Called when the key associated with a field is changed for an additionalProperty.
     * simply returns a function that call the `handleKeyChange()` event with the value
     */ const onKeyRename = (0, $h4Bez.useCallback)((value)=>{
        if (propertyName !== value) setWasPropertyKeyModified(true);
        handleKeyRename(propertyName, value);
    }, [
        propertyName,
        handleKeyRename
    ]);
    /** Returns a callback the handle the blur event, getting the value from the target and passing that along to the
     * `handleKeyChange` function
     */ const onKeyRenameBlur = (0, $h4Bez.useCallback)((event)=>{
        const { target: { value: value } } = event;
        onKeyRename(value);
    }, [
        onKeyRename
    ]);
    /** The property drop/removal event handler; Called when a field is removed in an additionalProperty context
     */ const onRemoveProperty = (0, $h4Bez.useCallback)(()=>{
        handleRemoveProperty(propertyName);
    }, [
        propertyName,
        handleRemoveProperty
    ]);
    return (0, $2e41620b030ed79e$exports.jsx)(SchemaField, {
        name: propertyName,
        required: required,
        schema: schema,
        uiSchema: uiSchema,
        errorSchema: errorSchema,
        fieldPathId: innerFieldIdPathId,
        formData: formData,
        wasPropertyKeyModified: wasPropertyKeyModified,
        onKeyRename: onKeyRename,
        onKeyRenameBlur: onKeyRenameBlur,
        onRemoveProperty: onRemoveProperty,
        onChange: onPropertyChange,
        onBlur: onBlur,
        onFocus: onFocus,
        registry: registry,
        disabled: disabled,
        readonly: readonly,
        hideError: hideError
    });
}
const $0d904e6f36925ae3$var$ObjectFieldProperty = (0, $h4Bez.memo)($0d904e6f36925ae3$var$ObjectFieldPropertyFn);
function $0d904e6f36925ae3$export$2e2bcd8739ae039(props) {
    const { schema: rawSchema, uiSchema: uiSchema = {}, formData: formData, errorSchema: errorSchema, fieldPathId: fieldPathId, name: name, required: required = false, disabled: disabled, readonly: readonly, hideError: hideError, onBlur: onBlur, onFocus: onFocus, onChange: onChange, registry: registry, title: title } = props;
    const { fields: fields, schemaUtils: schemaUtils, translateString: translateString, globalUiOptions: globalUiOptions } = registry;
    const { OptionalDataControlsField: OptionalDataControlsField } = fields;
    const formDataRef = (0, $h4Bez.useRef)(formData);
    formDataRef.current = formData;
    const schema = (0, $h4Bez.useMemo)(()=>schemaUtils.retrieveSchema(rawSchema, formData, true), [
        schemaUtils,
        rawSchema,
        formData
    ]);
    const uiOptions = (0, $h4Bez.useMemo)(()=>(0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, globalUiOptions), [
        uiSchema,
        globalUiOptions
    ]);
    const { properties: schemaProperties = {} } = schema;
    // All the children will use childFieldPathId if present in the props, falling back to the fieldPathId
    const childFieldPathId = props.childFieldPathId ?? fieldPathId;
    const lastRenamedProperty = (0, $h4Bez.useRef)({
        previousKey: '',
        currentKey: undefined
    });
    const templateTitle = uiOptions.title ?? schema.title ?? title ?? name;
    const description = uiOptions.description ?? schema.description;
    const renderOptionalField = (0, $87b2dc06d3aae4d2$export$2e2bcd8739ae039)(registry, schema, required, uiSchema);
    const hasFormData = (0, $8df99a86d43a2e45$export$2e2bcd8739ae039)(formData);
    let orderedProperties = [];
    /** Computes the next available key name from the `preferredKey`, indexing through the already existing keys until one
     * that is already not assigned is found.
     *
     * @param preferredKey - The preferred name of a new key
     * @param [formData] - The form data in which to check if the desired key already exists
     * @returns - The name of the next available key from `preferredKey`
     */ const getAvailableKey = (0, $h4Bez.useCallback)((preferredKey, existingFormData)=>{
        const { duplicateKeySuffixSeparator: duplicateKeySuffixSeparator = '-' } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, globalUiOptions);
        let index = 0;
        let newKey = preferredKey;
        while((0, $52f1e6e82878153c$export$2e2bcd8739ae039)(existingFormData, newKey)){
            index += 1;
            newKey = `${preferredKey}${duplicateKeySuffixSeparator}${index}`;
        }
        return newKey;
    }, [
        uiSchema,
        globalUiOptions
    ]);
    /** Handles the adding of a new additional property on the given `schema`. Calls the `onChange` callback once the new
     * default data for that field has been added to the formData.
     */ const onAddProperty = (0, $h4Bez.useCallback)(()=>{
        if (!(schema.additionalProperties || schema.patternProperties)) return;
        const newFormData = {
            ...formData
        };
        const newKey = getAvailableKey('newKey', newFormData);
        if (schema.patternProperties) // Cast this to make the `set` work properly
        (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(newFormData, newKey, null);
        else {
            let type = undefined;
            let constValue = undefined;
            let defaultValue = undefined;
            if ((0, $d252d56fd76f41df$export$2e2bcd8739ae039)(schema.additionalProperties)) {
                type = schema.additionalProperties.type;
                constValue = schema.additionalProperties.const;
                defaultValue = schema.additionalProperties.default;
                let apSchema = schema.additionalProperties;
                if ((0, $cd207018ee28cb28$export$cf02ae06bf291db4) in apSchema) {
                    apSchema = schemaUtils.retrieveSchema({
                        [(0, $cd207018ee28cb28$export$cf02ae06bf291db4)]: apSchema[0, $cd207018ee28cb28$export$cf02ae06bf291db4]
                    }, formData);
                    type = apSchema.type;
                    constValue = apSchema.const;
                    defaultValue = apSchema.default;
                }
                if (!type && ((0, $cd207018ee28cb28$export$2014f14bbe7357bd) in apSchema || (0, $cd207018ee28cb28$export$c24c2c38af9a39c3) in apSchema)) type = 'object';
            }
            const newValue = constValue ?? defaultValue ?? $0d904e6f36925ae3$var$getDefaultValue(translateString, type);
            // Cast this to make the `set` work properly
            (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(newFormData, newKey, newValue);
        }
        if (lastRenamedProperty.current.previousKey === newKey) {
            lastRenamedProperty.current.currentKey = newKey;
            lastRenamedProperty.current.previousKey = getAvailableKey(newKey, newFormData);
        }
        onChange(newFormData, childFieldPathId.path);
    }, [
        formData,
        onChange,
        translateString,
        schemaUtils,
        childFieldPathId,
        getAvailableKey,
        schema
    ]);
    /** Returns a callback function that deals with the rename of a key for an additional property for a schema. That
     * callback will attempt to rename the key and move the existing data to that key, calling `onChange` when it does.
     *
     * @param oldKey - The old key for the field
     * @param newKey - The new key for the field
     * @returns - The key change callback function
     */ const handleKeyRename = (0, $h4Bez.useCallback)((oldKey, newKey)=>{
        if (oldKey !== newKey) {
            const currentFormData = formDataRef.current;
            const actualNewKey = getAvailableKey(newKey, currentFormData);
            const newFormData = {
                ...currentFormData
            };
            const newKeys = {
                [oldKey]: actualNewKey
            };
            const keyValues = Object.keys(newFormData).map((key)=>{
                // `Object.hasOwn` so a falsy rename target (e.g. `""`) isn't dropped.
                const mappedKey = Object.hasOwn(newKeys, key) ? newKeys[key] : key;
                return {
                    [mappedKey]: newFormData[key]
                };
            });
            const renamedObj = Object.assign({}, ...keyValues);
            formDataRef.current = renamedObj;
            if (oldKey !== lastRenamedProperty.current.currentKey) lastRenamedProperty.current.previousKey = oldKey;
            lastRenamedProperty.current.currentKey = actualNewKey;
            onChange(renamedObj, childFieldPathId.path);
        }
    }, [
        onChange,
        childFieldPathId,
        getAvailableKey
    ]);
    /** Handles the remove click which calls the `onChange` callback with the special ADDITIONAL_PROPERTY_FIELD_REMOVE
     * value for the path plus the key to be removed
     */ const handleRemoveProperty = (0, $h4Bez.useCallback)((key)=>{
        onChange((0, $9c6fb2049cbb4fc1$export$bccc68d61c860794), [
            ...childFieldPathId.path,
            key
        ]);
    }, [
        onChange,
        childFieldPathId
    ]);
    /** Returns the stable React key for a property. For the most recently renamed
     * additional property, returns the previous key so that React reuses the
     * existing component instance instead of unmounting/remounting it. This
     * preserves DOM focus naturally without manual focus management.
     */ const getStableKey = (0, $h4Bez.useCallback)((property)=>{
        if (lastRenamedProperty.current.currentKey === property) return lastRenamedProperty.current.previousKey;
        return property;
    }, []);
    if (!renderOptionalField || hasFormData) try {
        const properties = Object.keys(schemaProperties);
        orderedProperties = (0, $3235af65e5413a3a$export$2e2bcd8739ae039)(properties, uiOptions.order);
    } catch (err) {
        return (0, $2e41620b030ed79e$exports.jsxs)("div", {
            children: [
                (0, $2e41620b030ed79e$exports.jsx)("p", {
                    className: 'rjsf-config-error',
                    style: {
                        color: 'red'
                    },
                    children: (0, $2e41620b030ed79e$exports.jsx)((0, $0a39817bbf114bf6$export$7460c8b7e4ce9582), {
                        options: {
                            disableParsingRawHTML: true
                        },
                        children: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).InvalidObjectField, [
                            name || 'root',
                            err.message
                        ])
                    })
                }),
                (0, $2e41620b030ed79e$exports.jsx)("pre", {
                    children: JSON.stringify(schema)
                })
            ]
        });
    }
    const Template = (0, $f037e3283241319d$export$2e2bcd8739ae039)('ObjectFieldTemplate', registry, uiOptions);
    const optionalDataControl = renderOptionalField ? (0, $2e41620b030ed79e$exports.jsx)(OptionalDataControlsField, {
        ...props,
        fieldPathId: childFieldPathId,
        schema: schema
    }) : undefined;
    const templateProps = {
        // getDisplayLabel() always returns false for object types, so just check the `uiOptions.label`
        title: uiOptions.label === false ? '' : templateTitle,
        description: uiOptions.label === false ? undefined : description,
        properties: orderedProperties.map((propertyName)=>{
            const addedByAdditionalProperties = (0, $52f1e6e82878153c$export$2e2bcd8739ae039)(schema, [
                (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
                propertyName,
                (0, $cd207018ee28cb28$export$60d2d9c11642ddd6)
            ]);
            const fieldUiSchema = addedByAdditionalProperties ? uiSchema.additionalProperties : uiSchema[propertyName];
            const hidden = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(fieldUiSchema).widget === 'hidden';
            const content = (0, $2e41620b030ed79e$exports.jsx)($0d904e6f36925ae3$var$ObjectFieldProperty, {
                propertyName: propertyName,
                required: $0d904e6f36925ae3$var$isRequired(schema, propertyName),
                schema: (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(schema, [
                    (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
                    propertyName
                ], {}),
                uiSchema: fieldUiSchema,
                errorSchema: (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(errorSchema, [
                    propertyName
                ]),
                fieldPathId: childFieldPathId,
                formData: (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(formData, [
                    propertyName
                ]),
                handleKeyRename: handleKeyRename,
                handleRemoveProperty: handleRemoveProperty,
                addedByAdditionalProperties: addedByAdditionalProperties,
                onChange: onChange,
                onBlur: onBlur,
                onFocus: onFocus,
                registry: registry,
                disabled: disabled,
                readonly: readonly,
                hideError: hideError
            }, getStableKey(propertyName));
            return {
                content: content,
                name: propertyName,
                readonly: readonly,
                disabled: disabled,
                required: required,
                hidden: hidden
            };
        }),
        readonly: readonly,
        disabled: disabled,
        required: required,
        fieldPathId: fieldPathId,
        uiSchema: uiSchema,
        errorSchema: errorSchema,
        schema: schema,
        formData: formData,
        registry: registry,
        optionalDataControl: optionalDataControl,
        className: renderOptionalField ? 'rjsf-optional-object-field' : undefined
    };
    return (0, $2e41620b030ed79e$exports.jsx)(Template, {
        ...templateProps,
        onAddProperty: onAddProperty
    });
}




function $0cc021f0956fd77c$export$2e2bcd8739ae039(props) {
    const { schema: schema, uiSchema: uiSchema = {}, formData: formData, disabled: disabled = false, readonly: readonly = false, onChange: onChange, errorSchema: errorSchema, fieldPathId: fieldPathId, registry: registry } = props;
    const { globalUiOptions: globalUiOptions = {}, schemaUtils: schemaUtils, translateString: translateString } = registry;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, globalUiOptions);
    const OptionalDataControlsTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('OptionalDataControlsTemplate', registry, uiOptions);
    const hasFormData = (0, $8df99a86d43a2e45$export$2e2bcd8739ae039)(formData);
    let id;
    let label;
    let onAddClick;
    let onRemoveClick;
    if (disabled || readonly) {
        id = (0, $8ce79fa261751f64$export$a20ab08e55ee75c3)(fieldPathId, 'Msg');
        label = hasFormData ? undefined : translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).OptionalObjectEmptyMsg);
    } else {
        const labelEnum = hasFormData ? (0, $b63837cd47cf776b$export$e8ce1f619d132f5c).OptionalObjectRemove : (0, $b63837cd47cf776b$export$e8ce1f619d132f5c).OptionalObjectAdd;
        label = translateString(labelEnum);
        if (hasFormData) {
            id = (0, $8ce79fa261751f64$export$a20ab08e55ee75c3)(fieldPathId, 'Remove');
            onRemoveClick = ()=>onChange(undefined, fieldPathId.path, errorSchema);
        } else {
            id = (0, $8ce79fa261751f64$export$a20ab08e55ee75c3)(fieldPathId, 'Add');
            onAddClick = ()=>{
                // If it has form data, store an empty object, otherwise get the default form state and use it
                let newFormData = schemaUtils.getDefaultFormState(schema, formData, 'excludeObjectChildren');
                if (newFormData === undefined) // If new form data ended up being undefined, and we have pushed the add button we need to actually add data
                newFormData = (0, $624c3ff4310242dc$export$2e2bcd8739ae039)(schema) === 'array' ? [] : {};
                onChange(newFormData, fieldPathId.path, errorSchema);
            };
        }
    }
    return label && (0, $2e41620b030ed79e$exports.jsx)(OptionalDataControlsTemplate, {
        id: id,
        registry: registry,
        schema: schema,
        uiSchema: uiSchema,
        label: label,
        onAddClick: onAddClick,
        onRemoveClick: onRemoveClick
    });
}




var $h4Bez = parcelRequire("h4Bez");



/** The map of component type to FieldName */ const $62c54f1c940fcc54$var$COMPONENT_TYPES = {
    array: 'ArrayField',
    boolean: 'BooleanField',
    integer: 'NumberField',
    number: 'NumberField',
    object: 'ObjectField',
    string: 'StringField',
    null: 'NullField'
};
/** Computes and returns which `Field` implementation to return in order to render the field represented by the
 * `schema`. The `uiOptions` are used to alter what potential `Field` implementation is actually returned. If no
 * appropriate `Field` implementation can be found then a wrapper around `UnsupportedFieldTemplate` is used.
 *
 * @param schema - The schema from which to obtain the type
 * @param uiOptions - The UI Options that may affect the component decision
 * @param registry - The registry from which fields and templates are obtained
 * @returns - The `Field` component that is used to render the actual field data
 */ function $62c54f1c940fcc54$var$getFieldComponent(schema, uiOptions, registry) {
    const { field: field } = uiOptions;
    const { fields: fields } = registry;
    if (typeof field === 'function') return field;
    if (typeof field === 'string' && field in fields) return fields[field];
    const schemaType = (0, $624c3ff4310242dc$export$2e2bcd8739ae039)(schema);
    const type = Array.isArray(schemaType) ? schemaType[0] : schemaType || '';
    const schemaId = schema.$id;
    let componentName = $62c54f1c940fcc54$var$COMPONENT_TYPES[type];
    if (schemaId && schemaId in fields) componentName = schemaId;
    // If the type is not defined and the schema uses 'anyOf' or 'oneOf', don't
    // render a field and let the MultiSchemaField component handle the form display
    if (!componentName && (schema.anyOf || schema.oneOf)) return ()=>null;
    return componentName in fields ? fields[componentName] : fields.FallbackField;
}
/** The `SchemaFieldRender` component is the work-horse of react-jsonschema-form, determining what kind of real field to
 * render based on the `schema`, `uiSchema` and all the other props. It also deals with rendering the `anyOf` and
 * `oneOf` fields.
 *
 * @param props - The `FieldProps` for this component
 */ function $62c54f1c940fcc54$var$SchemaFieldRender(props) {
    const { schema: _schema, fieldPathId: fieldPathId, uiSchema: _uiSchema, formData: formData, errorSchema: errorSchema, name: name, onChange: onChange, onKeyRename: onKeyRename, onKeyRenameBlur: onKeyRenameBlur, onRemoveProperty: onRemoveProperty, required: required = false, registry: registry, wasPropertyKeyModified: wasPropertyKeyModified = false } = props;
    const { schemaUtils: schemaUtils, globalFormOptions: globalFormOptions, globalUiOptions: globalUiOptions, fields: fields } = registry;
    const { AnyOfField: _AnyOfField, OneOfField: _OneOfField } = fields;
    const uiSchema = (0, $6ae06bf6c4676d6a$export$2e2bcd8739ae039)(_schema, _uiSchema, registry);
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, globalUiOptions);
    const FieldTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('FieldTemplate', registry, uiOptions);
    const DescriptionFieldTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('DescriptionFieldTemplate', registry, uiOptions);
    const FieldHelpTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('FieldHelpTemplate', registry, uiOptions);
    const FieldErrorTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('FieldErrorTemplate', registry, uiOptions);
    const schema = schemaUtils.retrieveSchema(_schema, formData);
    const fieldId = fieldPathId[0, $cd207018ee28cb28$export$f453fd324e92d331];
    /** Intermediary `onChange` handler for field components that will inject the `id` of the current field into the
     * `onChange` chain if it is not already being provided from a deeper level in the hierarchy
     */ const handleFieldComponentChange = (0, $h4Bez.useCallback)((newFormData, path, newErrorSchema, id)=>{
        const theId = id || fieldId;
        return onChange(newFormData, path, newErrorSchema, theId);
    }, [
        fieldId,
        onChange
    ]);
    const FieldComponent = $62c54f1c940fcc54$var$getFieldComponent(schema, uiOptions, registry);
    const isDeprecated = Boolean(schema.deprecated);
    const deprecatedHandling = isDeprecated ? uiOptions.deprecatedHandling ?? 'label' : undefined;
    const disabled = Boolean(uiOptions.disabled ?? props.disabled) || deprecatedHandling === 'disable';
    const readonly = Boolean(uiOptions.readonly ?? (props.readonly || props.schema.readOnly || schema.readOnly));
    const uiSchemaHideError = uiOptions.hideError;
    // Set hideError to the value provided in the uiSchema, otherwise stick with the prop to propagate to children
    const hideError = uiSchemaHideError === undefined ? props.hideError : Boolean(uiSchemaHideError);
    const autofocus = Boolean(uiOptions.autofocus ?? props.autofocus);
    if (Object.keys(schema).length === 0) return null;
    let displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
    /** If the schema `anyOf` or 'oneOf' can be rendered as a select control, don't render the selection and let
     * `StringField` component handle rendering unless there is a field override and that field replaces the any or one of
     */ const isReplacingAnyOrOneOf = uiOptions.field && uiOptions.fieldReplacesAnyOrOneOf === true;
    let XxxOfField;
    let XxxOfOptions;
    // When rendering the `XxxOfField` we'll need to change the fieldPathId of the main component, remembering the
    // fieldPathId of the children for the ObjectField and ArrayField
    let fieldPathIdProps = {
        fieldPathId: fieldPathId
    };
    if (((0, $cd207018ee28cb28$export$2014f14bbe7357bd) in schema || (0, $cd207018ee28cb28$export$c24c2c38af9a39c3) in schema) && !isReplacingAnyOrOneOf && !schemaUtils.isSelect(schema)) {
        if (schema[0, $cd207018ee28cb28$export$2014f14bbe7357bd]) {
            XxxOfField = _AnyOfField;
            XxxOfOptions = schema[0, $cd207018ee28cb28$export$2014f14bbe7357bd].map((xxxOfSchema)=>schemaUtils.retrieveSchema((0, $d252d56fd76f41df$export$2e2bcd8739ae039)(xxxOfSchema) ? xxxOfSchema : {}, formData));
        } else if (schema[0, $cd207018ee28cb28$export$c24c2c38af9a39c3]) {
            XxxOfField = _OneOfField;
            XxxOfOptions = schema[0, $cd207018ee28cb28$export$c24c2c38af9a39c3].map((xxxOfSchema)=>schemaUtils.retrieveSchema((0, $d252d56fd76f41df$export$2e2bcd8739ae039)(xxxOfSchema) ? xxxOfSchema : {}, formData));
        }
        // When the anyOf/oneOf is an optional data control render AND it does not have form data, hide the label
        const isOptionalRender = (0, $87b2dc06d3aae4d2$export$2e2bcd8739ae039)(registry, schema, required, uiSchema);
        const hasFormData = (0, $8df99a86d43a2e45$export$2e2bcd8739ae039)(formData);
        displayLabel = displayLabel && (!isOptionalRender || hasFormData);
        fieldPathIdProps = {
            childFieldPathId: fieldPathId,
            // The main FieldComponent will add `XxxOf` onto the fieldPathId to avoid duplication with the rendering of the
            // same FieldComponent by the `XxxOfField`
            fieldPathId: (0, $99206247aba21705$export$2e2bcd8739ae039)('XxxOf', globalFormOptions, fieldPathId)
        };
    }
    const { __errors: __errors, ...fieldErrorSchema } = errorSchema || {};
    // See #439: uiSchema: Don't pass consumed class names or style to child components
    const fieldUiSchema = (0, $56d3aa46749de9f1$export$2e2bcd8739ae039)(uiSchema, [
        'ui:classNames',
        'classNames',
        'ui:style'
    ]);
    if ((0, $cd207018ee28cb28$export$61fb14aaf7aef60f) in fieldUiSchema) fieldUiSchema[0, $cd207018ee28cb28$export$61fb14aaf7aef60f] = (0, $56d3aa46749de9f1$export$2e2bcd8739ae039)(fieldUiSchema[0, $cd207018ee28cb28$export$61fb14aaf7aef60f], [
        'classNames',
        'style'
    ]);
    const field = (0, $2e41620b030ed79e$exports.jsx)(FieldComponent, {
        ...props,
        onChange: handleFieldComponentChange,
        ...fieldPathIdProps,
        schema: schema,
        uiSchema: fieldUiSchema,
        disabled: disabled,
        readonly: readonly,
        hideError: hideError,
        autofocus: autofocus,
        errorSchema: fieldErrorSchema,
        rawErrors: __errors
    });
    const id = fieldPathId[0, $cd207018ee28cb28$export$f453fd324e92d331];
    // If this schema has a title defined, but the user has set a new key/label, retain their input.
    let label;
    if (wasPropertyKeyModified) label = name;
    else label = (0, $cd207018ee28cb28$export$60d2d9c11642ddd6) in schema ? name : uiOptions.title || props.schema.title || schema.title || props.title || name;
    if (deprecatedHandling === 'label') label = registry.translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).DeprecatedLabel, [
        label
    ]);
    const description = uiOptions.description || props.schema.description || schema.description || '';
    const { help: help } = uiOptions;
    const hidden = uiOptions.widget === 'hidden' || deprecatedHandling === 'hide';
    const classNames = [
        'rjsf-field',
        `rjsf-field-${(0, $624c3ff4310242dc$export$2e2bcd8739ae039)(schema)}`
    ];
    if (!hideError && __errors && __errors.length > 0) classNames.push('rjsf-field-error');
    if (uiOptions.classNames) classNames.push(uiOptions.classNames);
    const helpComponent = (0, $2e41620b030ed79e$exports.jsx)(FieldHelpTemplate, {
        help: help,
        fieldPathId: fieldPathId,
        schema: schema,
        uiSchema: uiSchema,
        hasErrors: !hideError && __errors && __errors.length > 0,
        registry: registry
    });
    /*
     * AnyOf/OneOf errors handled by child schema
     * unless it can be rendered as select control
     */ const errorsComponent = hideError || XxxOfField && !schemaUtils.isSelect(schema) ? undefined : (0, $2e41620b030ed79e$exports.jsx)(FieldErrorTemplate, {
        errors: __errors,
        errorSchema: errorSchema,
        fieldPathId: fieldPathId,
        schema: schema,
        uiSchema: uiSchema,
        registry: registry
    });
    const fieldProps = {
        description: (0, $2e41620b030ed79e$exports.jsx)(DescriptionFieldTemplate, {
            id: (0, $8ce79fa261751f64$export$fd4f3344107bd22c)(id),
            description: description,
            schema: schema,
            uiSchema: uiSchema,
            registry: registry
        }),
        rawDescription: description,
        help: helpComponent,
        rawHelp: typeof help === 'string' ? help : undefined,
        errors: errorsComponent,
        rawErrors: hideError ? undefined : __errors,
        fieldPathId: fieldPathId,
        id: id,
        label: label,
        hidden: hidden,
        onChange: onChange,
        onKeyRename: onKeyRename,
        onKeyRenameBlur: onKeyRenameBlur,
        onRemoveProperty: onRemoveProperty,
        required: required,
        disabled: disabled,
        readonly: readonly,
        hideError: hideError,
        displayLabel: displayLabel,
        classNames: classNames.join(' ').trim(),
        style: uiOptions.style,
        formData: formData,
        schema: schema,
        uiSchema: uiSchema,
        registry: registry
    };
    return (0, $2e41620b030ed79e$exports.jsx)(FieldTemplate, {
        ...fieldProps,
        children: (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
            children: [
                field,
                XxxOfField && (0, $2e41620b030ed79e$exports.jsx)(XxxOfField, {
                    name: name,
                    disabled: disabled,
                    readonly: readonly,
                    hideError: hideError,
                    errorSchema: errorSchema,
                    formData: formData,
                    fieldPathId: fieldPathId,
                    onBlur: props.onBlur,
                    onChange: props.onChange,
                    onFocus: props.onFocus,
                    options: XxxOfOptions,
                    registry: registry,
                    required: required,
                    schema: schema,
                    uiSchema: uiSchema
                })
            ]
        })
    });
}
/** The `SchemaField` component determines whether it is necessary to rerender the component based on any props changes
 * and if so, calls the `SchemaFieldRender` component with the props.
 */ class $62c54f1c940fcc54$var$SchemaField extends (0, $h4Bez.Component) {
    shouldComponentUpdate(nextProps) {
        const { registry: { globalFormOptions: globalFormOptions } } = this.props;
        const { experimental_componentUpdateStrategy: experimental_componentUpdateStrategy = 'customDeep' } = globalFormOptions;
        return (0, $10381dd8d10816d4$export$2e2bcd8739ae039)(this, nextProps, this.state, experimental_componentUpdateStrategy);
    }
    render() {
        return (0, $2e41620b030ed79e$exports.jsx)($62c54f1c940fcc54$var$SchemaFieldRender, {
            ...this.props
        });
    }
}
var $62c54f1c940fcc54$export$2e2bcd8739ae039 = $62c54f1c940fcc54$var$SchemaField;




var $h4Bez = parcelRequire("h4Bez");

/** The `StringField` component is used to render a schema field that represents a string type
 *
 * @param props - The `FieldProps` for this template
 */ function $bd21f6e9d3ce9794$var$StringField(props) {
    const { schema: schema, name: name, uiSchema: uiSchema, fieldPathId: fieldPathId, formData: formData, required: required, disabled: disabled = false, readonly: readonly = false, autofocus: autofocus = false, onChange: onChange, onBlur: onBlur, onFocus: onFocus, registry: registry, rawErrors: rawErrors, hideError: hideError, title: title } = props;
    const { title: schemaTitle, format: format } = schema;
    const { widgets: widgets, schemaUtils: schemaUtils, globalUiOptions: globalUiOptions } = registry;
    const enumOptions = schemaUtils.isSelect(schema) ? (0, $01e18c537fba1f55$export$2e2bcd8739ae039)(schema, uiSchema) : undefined;
    let defaultWidget = enumOptions ? 'select' : 'text';
    if (format && (0, $9541cc75da9c98ca$export$2e2bcd8739ae039)(schema, format, widgets)) defaultWidget = format;
    const { widget: widget = defaultWidget, placeholder: placeholder = '', title: uiTitle, ...options } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
    const label = uiTitle ?? title ?? schemaTitle ?? name;
    const Widget = (0, $73d42cea7c965d69$export$2e2bcd8739ae039)(schema, widget, widgets);
    const onWidgetChange = (0, $h4Bez.useCallback)((value, errorSchema, id)=>onChange(value, fieldPathId.path, errorSchema, id), [
        onChange,
        fieldPathId
    ]);
    return (0, $2e41620b030ed79e$exports.jsx)(Widget, {
        options: {
            ...options,
            enumOptions: enumOptions
        },
        schema: schema,
        uiSchema: uiSchema,
        id: fieldPathId.$id,
        name: name,
        label: label,
        hideLabel: !displayLabel,
        hideError: hideError,
        value: formData,
        onChange: onWidgetChange,
        onBlur: onBlur,
        onFocus: onFocus,
        required: required,
        disabled: disabled,
        readonly: readonly,
        autofocus: autofocus,
        registry: registry,
        placeholder: placeholder,
        rawErrors: rawErrors,
        htmlName: fieldPathId.name
    });
}
var $bd21f6e9d3ce9794$export$2e2bcd8739ae039 = $bd21f6e9d3ce9794$var$StringField;


function $fe3e26d1c1c8ae84$var$fields() {
    return {
        AnyOfField: (0, $4ee6750ae9a60822$export$2e2bcd8739ae039),
        ArrayField: (0, $4a6ee14fdc94c86f$export$2e2bcd8739ae039),
        BooleanField: // ArrayField falls back to SchemaField if ArraySchemaField is not defined, which it isn't by default
        $2ac93ad779ac971a$export$2e2bcd8739ae039,
        FallbackField: $22e0d29b0a3403fd$export$2e2bcd8739ae039,
        LayoutGridField: $d7de6601dcd2dd2a$export$2e2bcd8739ae039,
        LayoutHeaderField: $f3bee05a861e9a3d$export$2e2bcd8739ae039,
        LayoutMultiSchemaField: $892d067927d44d1b$export$2e2bcd8739ae039,
        NumberField: $5bc084228d353aa3$export$2e2bcd8739ae039,
        ObjectField: $0d904e6f36925ae3$export$2e2bcd8739ae039,
        OneOfField: (0, $4ee6750ae9a60822$export$2e2bcd8739ae039),
        OptionalDataControlsField: $0cc021f0956fd77c$export$2e2bcd8739ae039,
        SchemaField: $62c54f1c940fcc54$export$2e2bcd8739ae039,
        StringField: $bd21f6e9d3ce9794$export$2e2bcd8739ae039,
        NullField: $ae5ad5a7b6fb396d$export$2e2bcd8739ae039
    };
}
var $fe3e26d1c1c8ae84$export$2e2bcd8739ae039 = $fe3e26d1c1c8ae84$var$fields;




function $830d495d75f01a96$export$2e2bcd8739ae039(props) {
    const { fieldPathId: fieldPathId, description: description, registry: registry, schema: schema, uiSchema: uiSchema } = props;
    const options = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, registry.globalUiOptions);
    const { label: displayLabel = true } = options;
    if (!description || !displayLabel) return null;
    const DescriptionFieldTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('DescriptionFieldTemplate', registry, options);
    return (0, $2e41620b030ed79e$exports.jsx)(DescriptionFieldTemplate, {
        id: (0, $8ce79fa261751f64$export$fd4f3344107bd22c)(fieldPathId),
        description: description,
        schema: schema,
        uiSchema: uiSchema,
        registry: registry
    });
}




function $c6ccb726a92368ca$export$2e2bcd8739ae039(props) {
    const { disabled: disabled, hasCopy: hasCopy, hasMoveDown: hasMoveDown, hasMoveUp: hasMoveUp, hasRemove: hasRemove, fieldPathId: fieldPathId, onCopyItem: onCopyItem, onRemoveItem: onRemoveItem, onMoveDownItem: onMoveDownItem, onMoveUpItem: onMoveUpItem, readonly: readonly, registry: registry, uiSchema: uiSchema } = props;
    const { CopyButton: CopyButton, MoveDownButton: MoveDownButton, MoveUpButton: MoveUpButton, RemoveButton: RemoveButton } = registry.templates.ButtonTemplates;
    return (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            (hasMoveUp || hasMoveDown) && (0, $2e41620b030ed79e$exports.jsx)(MoveUpButton, {
                id: (0, $8ce79fa261751f64$export$6395da05030161a1)(fieldPathId, 'moveUp'),
                className: 'rjsf-array-item-move-up',
                disabled: disabled || readonly || !hasMoveUp,
                onClick: onMoveUpItem,
                uiSchema: uiSchema,
                registry: registry
            }),
            (hasMoveUp || hasMoveDown) && (0, $2e41620b030ed79e$exports.jsx)(MoveDownButton, {
                id: (0, $8ce79fa261751f64$export$6395da05030161a1)(fieldPathId, 'moveDown'),
                className: 'rjsf-array-item-move-down',
                disabled: disabled || readonly || !hasMoveDown,
                onClick: onMoveDownItem,
                uiSchema: uiSchema,
                registry: registry
            }),
            hasCopy && (0, $2e41620b030ed79e$exports.jsx)(CopyButton, {
                id: (0, $8ce79fa261751f64$export$6395da05030161a1)(fieldPathId, 'copy'),
                className: 'rjsf-array-item-copy',
                disabled: disabled || readonly,
                onClick: onCopyItem,
                uiSchema: uiSchema,
                registry: registry
            }),
            hasRemove && (0, $2e41620b030ed79e$exports.jsx)(RemoveButton, {
                id: (0, $8ce79fa261751f64$export$6395da05030161a1)(fieldPathId, 'remove'),
                className: 'rjsf-array-item-remove',
                disabled: disabled || readonly,
                onClick: onRemoveItem,
                uiSchema: uiSchema,
                registry: registry
            })
        ]
    });
}




function $466b3892fedc584f$export$2e2bcd8739ae039(props) {
    const { children: children, className: className, buttonsProps: buttonsProps, displayLabel: displayLabel, hasDescription: hasDescription, hasToolbar: hasToolbar, registry: registry, uiSchema: uiSchema } = props;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const ArrayFieldItemButtonsTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('ArrayFieldItemButtonsTemplate', registry, uiOptions);
    const btnStyle = {
        flex: 1,
        paddingLeft: 6,
        paddingRight: 6,
        fontWeight: 'bold'
    };
    const margin = hasDescription ? 31 : 9;
    const containerStyle = {
        display: 'flex',
        alignItems: displayLabel ? 'center' : 'baseline'
    };
    const toolbarStyle = {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: displayLabel ? `${margin}px` : 0
    };
    return (0, $2e41620b030ed79e$exports.jsxs)("div", {
        className: className,
        style: containerStyle,
        children: [
            (0, $2e41620b030ed79e$exports.jsx)("div", {
                className: hasToolbar ? 'col-xs-9 col-md-10 col-xl-11' : 'col-xs-12',
                children: children
            }),
            hasToolbar && (0, $2e41620b030ed79e$exports.jsx)("div", {
                className: 'col-xs-3 col-md-2 col-xl-1 array-item-toolbox',
                children: (0, $2e41620b030ed79e$exports.jsx)("div", {
                    className: 'btn-group',
                    style: toolbarStyle,
                    children: (0, $2e41620b030ed79e$exports.jsx)(ArrayFieldItemButtonsTemplate, {
                        ...buttonsProps,
                        style: btnStyle
                    })
                })
            })
        ]
    });
}




function $23eee89a6fb31e81$export$2e2bcd8739ae039(props) {
    const { canAdd: canAdd, className: className, disabled: disabled, fieldPathId: fieldPathId, uiSchema: uiSchema, items: items, optionalDataControl: optionalDataControl, onAddClick: onAddClick, readonly: readonly, registry: registry, required: required, schema: schema, title: title } = props;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const ArrayFieldDescriptionTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('ArrayFieldDescriptionTemplate', registry, uiOptions);
    const ArrayFieldTitleTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('ArrayFieldTitleTemplate', registry, uiOptions);
    // Button templates are not overridden in the uiSchema
    const showOptionalDataControlInTitle = !readonly && !disabled;
    const { ButtonTemplates: { AddButton: AddButton } } = registry.templates;
    return (0, $2e41620b030ed79e$exports.jsxs)("fieldset", {
        className: className,
        id: fieldPathId.$id,
        children: [
            (0, $2e41620b030ed79e$exports.jsx)(ArrayFieldTitleTemplate, {
                fieldPathId: fieldPathId,
                title: uiOptions.title || title,
                required: required,
                schema: schema,
                uiSchema: uiSchema,
                registry: registry,
                optionalDataControl: showOptionalDataControlInTitle ? optionalDataControl : undefined
            }),
            (0, $2e41620b030ed79e$exports.jsx)(ArrayFieldDescriptionTemplate, {
                fieldPathId: fieldPathId,
                description: uiOptions.description || schema.description,
                schema: schema,
                uiSchema: uiSchema,
                registry: registry
            }),
            !showOptionalDataControlInTitle ? optionalDataControl : undefined,
            (0, $2e41620b030ed79e$exports.jsx)("div", {
                className: 'row array-item-list',
                children: items
            }),
            canAdd && (0, $2e41620b030ed79e$exports.jsx)(AddButton, {
                id: (0, $8ce79fa261751f64$export$6395da05030161a1)(fieldPathId, 'add'),
                className: 'rjsf-array-item-add',
                onClick: onAddClick,
                disabled: disabled || readonly,
                uiSchema: uiSchema,
                registry: registry
            })
        ]
    });
}




function $80c9a82d351eb2bd$export$2e2bcd8739ae039(props) {
    const { fieldPathId: fieldPathId, title: title, schema: schema, uiSchema: uiSchema, required: required, registry: registry, optionalDataControl: optionalDataControl } = props;
    const options = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, registry.globalUiOptions);
    const { label: displayLabel = true } = options;
    if (!title || !displayLabel) return null;
    const TitleFieldTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('TitleFieldTemplate', registry, options);
    return (0, $2e41620b030ed79e$exports.jsx)(TitleFieldTemplate, {
        id: (0, $8ce79fa261751f64$export$86b632e0125010d9)(fieldPathId),
        title: title,
        required: required,
        schema: schema,
        uiSchema: uiSchema,
        registry: registry,
        optionalDataControl: optionalDataControl
    });
}




var $h4Bez = parcelRequire("h4Bez");



function $2cf2dc76876a4f1b$export$2e2bcd8739ae039(props) {
    const { id: id, schema: schema } = props;
    const { examples: examples, default: schemaDefault } = schema;
    if (!Array.isArray(examples)) return null;
    return (0, $2e41620b030ed79e$exports.jsx)("datalist", {
        id: (0, $8ce79fa261751f64$export$64cb836579421d7e)(id),
        children: examples.concat(schemaDefault !== undefined && !examples.map(String).includes(String(schemaDefault)) ? [
            schemaDefault
        ] : []).map((example)=>(0, $2e41620b030ed79e$exports.jsx)("option", {
                value: example
            }, String(example)))
    }, `datalist_${id}`);
}


function $48e30663a9c02f1e$export$2e2bcd8739ae039(props) {
    const { id: id, name: name, htmlName: htmlName, value: value, readonly: readonly, disabled: disabled, autofocus: autofocus, onBlur: onBlur, onFocus: onFocus, onChange: onChange, onChangeOverride: onChangeOverride, options: options, schema: schema, uiSchema: uiSchema, registry: registry, rawErrors: rawErrors, type: type, hideLabel: hideLabel, hideError: hideError, ...rest } = props;
    const { ClearButton: ClearButton } = registry.templates.ButtonTemplates;
    // Note: since React 15.2.0 we can't forward unknown element attributes, so we
    // exclude the "options" and "schema" ones here.
    if (!id) {
        // oxlint-disable-next-line no-console
        console.log('No id for', props);
        throw new Error(`no id for props ${JSON.stringify(props)}`);
    }
    const inputProps = {
        ...rest,
        ...(0, $44b30900be781098$export$2e2bcd8739ae039)(schema, type, options)
    };
    let inputValue;
    if (inputProps.type === 'number' || inputProps.type === 'integer') inputValue = value || value === 0 ? value : '';
    else inputValue = value == null ? '' : value;
    const handleChange = (0, $h4Bez.useCallback)(({ target: { value: newValue } })=>onChange(newValue === '' ? options.emptyValue : newValue), [
        onChange,
        options
    ]);
    const handleBlur = (0, $h4Bez.useCallback)(({ target: target })=>onBlur(id, target && target.value), [
        onBlur,
        id
    ]);
    const handleFocus = (0, $h4Bez.useCallback)(({ target: target })=>onFocus(id, target && target.value), [
        onFocus,
        id
    ]);
    const handleClear = (0, $h4Bez.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        onChange(options.emptyValue ?? '');
    }, [
        onChange,
        options.emptyValue
    ]);
    return (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            (0, $2e41620b030ed79e$exports.jsx)("input", {
                id: id,
                name: htmlName || id,
                className: 'form-control',
                readOnly: readonly,
                disabled: disabled,
                autoFocus: autofocus,
                value: inputValue,
                ...inputProps,
                list: schema.examples ? (0, $8ce79fa261751f64$export$64cb836579421d7e)(id) : undefined,
                onChange: onChangeOverride || handleChange,
                onBlur: handleBlur,
                onFocus: handleFocus,
                "aria-describedby": (0, $8ce79fa261751f64$export$53c2204bb4091b57)(id, !!schema.examples)
            }),
            options.allowClearTextInputs && !readonly && !disabled && inputValue && (0, $2e41620b030ed79e$exports.jsx)(ClearButton, {
                registry: registry,
                onClick: handleClear
            }),
            (0, $2e41620b030ed79e$exports.jsx)((0, $2cf2dc76876a4f1b$export$2e2bcd8739ae039), {
                id: id,
                schema: schema
            })
        ]
    });
}






var $h4Bez = parcelRequire("h4Bez");

function $cfd0098bad4a1019$var$IconButtonFn(props) {
    const { iconType: iconType = 'default', icon: icon, className: className, uiSchema: uiSchema, registry: registry, ...otherProps } = props;
    return (0, $2e41620b030ed79e$exports.jsx)("button", {
        type: 'button',
        className: `btn btn-${iconType} ${className}`,
        ...otherProps,
        children: (0, $2e41620b030ed79e$exports.jsx)("i", {
            className: `glyphicon glyphicon-${icon}`
        })
    });
}
const $cfd0098bad4a1019$var$IconButton = (0, $h4Bez.memo)($cfd0098bad4a1019$var$IconButtonFn);
var $cfd0098bad4a1019$export$2e2bcd8739ae039 = $cfd0098bad4a1019$var$IconButton;
function $cfd0098bad4a1019$var$CopyButtonFn(props) {
    const { registry: { translateString: translateString } } = props;
    return (0, $2e41620b030ed79e$exports.jsx)($cfd0098bad4a1019$var$IconButton, {
        title: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).CopyButton),
        ...props,
        icon: 'copy'
    });
}
const $cfd0098bad4a1019$export$4f2558dd25106ae2 = (0, $h4Bez.memo)($cfd0098bad4a1019$var$CopyButtonFn);
function $cfd0098bad4a1019$var$MoveDownButtonFn(props) {
    const { registry: { translateString: translateString } } = props;
    return (0, $2e41620b030ed79e$exports.jsx)($cfd0098bad4a1019$var$IconButton, {
        title: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).MoveDownButton),
        ...props,
        icon: 'arrow-down'
    });
}
const $cfd0098bad4a1019$export$957adf6917d65946 = (0, $h4Bez.memo)($cfd0098bad4a1019$var$MoveDownButtonFn);
function $cfd0098bad4a1019$var$MoveUpButtonFn(props) {
    const { registry: { translateString: translateString } } = props;
    return (0, $2e41620b030ed79e$exports.jsx)($cfd0098bad4a1019$var$IconButton, {
        title: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).MoveUpButton),
        ...props,
        icon: 'arrow-up'
    });
}
const $cfd0098bad4a1019$export$c0d94cf7650e6bd8 = (0, $h4Bez.memo)($cfd0098bad4a1019$var$MoveUpButtonFn);
function $cfd0098bad4a1019$var$RemoveButtonFn(props) {
    const { registry: { translateString: translateString } } = props;
    return (0, $2e41620b030ed79e$exports.jsx)($cfd0098bad4a1019$var$IconButton, {
        title: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).RemoveButton),
        ...props,
        iconType: 'danger',
        icon: 'remove'
    });
}
const $cfd0098bad4a1019$export$4e9d5ce1e6c22a94 = (0, $h4Bez.memo)($cfd0098bad4a1019$var$RemoveButtonFn);
function $cfd0098bad4a1019$var$ClearButtonFn({ id: id, className: className, onClick: onClick, disabled: disabled, registry: registry, ...props }) {
    const { translateString: translateString } = registry;
    return (0, $2e41620b030ed79e$exports.jsx)($cfd0098bad4a1019$var$IconButton, {
        id: id,
        iconType: 'default',
        icon: 'remove',
        className: 'btn-clear col-xs-12',
        title: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).ClearButton),
        onClick: onClick,
        disabled: disabled,
        registry: registry,
        ...props
    });
}
const $cfd0098bad4a1019$export$13ec83e50bf04290 = (0, $h4Bez.memo)($cfd0098bad4a1019$var$ClearButtonFn);


function $ff6f29f3b53f45c3$export$2e2bcd8739ae039({ id: id, className: className, onClick: onClick, disabled: disabled, registry: registry }) {
    const { translateString: translateString } = registry;
    return (0, $2e41620b030ed79e$exports.jsx)("div", {
        className: 'row',
        children: (0, $2e41620b030ed79e$exports.jsx)("p", {
            className: `col-xs-4 col-sm-2 col-lg-1 col-xs-offset-8 col-sm-offset-10 col-lg-offset-11 text-right ${className}`,
            children: (0, $2e41620b030ed79e$exports.jsx)((0, $cfd0098bad4a1019$export$2e2bcd8739ae039), {
                id: id,
                iconType: 'info',
                icon: 'plus',
                className: 'btn-add col-xs-12',
                title: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).AddButton),
                onClick: onClick,
                disabled: disabled,
                registry: registry
            })
        })
    });
}





function $4492984c4770a221$export$2e2bcd8739ae039({ uiSchema: uiSchema }) {
    const { submitText: submitText, norender: norender, props: submitButtonProps = {} } = (0, $3733f8d10e56b15e$export$2e2bcd8739ae039)(uiSchema);
    if (norender) return null;
    return (0, $2e41620b030ed79e$exports.jsx)("div", {
        children: (0, $2e41620b030ed79e$exports.jsx)("button", {
            type: 'submit',
            ...submitButtonProps,
            className: `btn btn-info ${submitButtonProps.className || ''}`,
            children: submitText
        })
    });
}


function $8fbaa5cf8a3c5d88$var$buttonTemplates() {
    return {
        SubmitButton: $4492984c4770a221$export$2e2bcd8739ae039,
        AddButton: $ff6f29f3b53f45c3$export$2e2bcd8739ae039,
        CopyButton: $cfd0098bad4a1019$export$4f2558dd25106ae2,
        MoveDownButton: $cfd0098bad4a1019$export$957adf6917d65946,
        MoveUpButton: $cfd0098bad4a1019$export$c0d94cf7650e6bd8,
        RemoveButton: $cfd0098bad4a1019$export$4e9d5ce1e6c22a94,
        ClearButton: $cfd0098bad4a1019$export$13ec83e50bf04290
    };
}
var $8fbaa5cf8a3c5d88$export$2e2bcd8739ae039 = $8fbaa5cf8a3c5d88$var$buttonTemplates;






const $4c0b0a7e771589a9$var$TEST_IDS = (0, $55a2cf4e1bd3cf35$export$2e2bcd8739ae039)();
function $4c0b0a7e771589a9$export$2e2bcd8739ae039({ description: description, registry: registry, uiSchema: uiSchema = {} }) {
    const { globalUiOptions: globalUiOptions } = registry;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, globalUiOptions);
    if (uiOptions.enableMarkdownInDescription && typeof description === 'string') return (0, $2e41620b030ed79e$exports.jsx)((0, $0a39817bbf114bf6$export$7460c8b7e4ce9582), {
        options: {
            disableParsingRawHTML: true
        },
        "data-testid": $4c0b0a7e771589a9$var$TEST_IDS.markdown,
        children: description
    });
    return description;
}
$4c0b0a7e771589a9$export$2e2bcd8739ae039.TEST_IDS = $4c0b0a7e771589a9$var$TEST_IDS;


function $e953303bfb093df0$export$2e2bcd8739ae039(props) {
    const { id: id, description: description, registry: registry, uiSchema: uiSchema } = props;
    if (!description) return null;
    return (0, $2e41620b030ed79e$exports.jsx)("div", {
        id: id,
        className: 'field-description',
        children: (0, $2e41620b030ed79e$exports.jsx)((0, $4c0b0a7e771589a9$export$2e2bcd8739ae039), {
            description: description,
            registry: registry,
            uiSchema: uiSchema
        })
    });
}




function $1f064bbffc0713bc$export$2e2bcd8739ae039({ errors: errors, registry: registry }) {
    const { translateString: translateString } = registry;
    return (0, $2e41620b030ed79e$exports.jsxs)("div", {
        className: 'panel panel-danger errors',
        children: [
            (0, $2e41620b030ed79e$exports.jsx)("div", {
                className: 'panel-heading',
                children: (0, $2e41620b030ed79e$exports.jsx)("h3", {
                    className: 'panel-title',
                    children: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).ErrorsLabel)
                })
            }),
            (0, $2e41620b030ed79e$exports.jsx)("ul", {
                className: 'list-group',
                children: errors.map((error, i)=>(0, $2e41620b030ed79e$exports.jsx)("li", {
                        className: 'list-group-item text-danger',
                        children: error.stack
                    }, i))
            })
        ]
    });
}




function $39db94c52e3bd593$export$2e2bcd8739ae039(props) {
    const { schema: schema, registry: registry, typeSelector: typeSelector, schemaField: schemaField } = props;
    // By default, use the MultiSchemaFieldTemplate, which handles the same basic requirements.
    const MultiSchemaFieldTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('MultiSchemaFieldTemplate', registry);
    return (0, $2e41620b030ed79e$exports.jsx)(MultiSchemaFieldTemplate, {
        selector: typeSelector,
        optionSchemaField: schemaField,
        schema: schema,
        registry: registry
    });
}




function $03b1ea410418184b$export$2e2bcd8739ae039(props) {
    const { errors: errors = [], fieldPathId: fieldPathId } = props;
    if (errors.length === 0) return null;
    const id = (0, $8ce79fa261751f64$export$8a072670fa7ceeee)(fieldPathId);
    return (0, $2e41620b030ed79e$exports.jsx)("div", {
        children: (0, $2e41620b030ed79e$exports.jsx)("ul", {
            id: id,
            className: 'error-detail bs-callout bs-callout-info',
            children: errors.filter((elem)=>!!elem).map((error, index)=>(0, $2e41620b030ed79e$exports.jsx)("li", {
                    className: 'text-danger',
                    children: error
                }, index))
        })
    });
}







const $1bedc85ebf6b209e$var$TEST_IDS = (0, $55a2cf4e1bd3cf35$export$2e2bcd8739ae039)();
function $1bedc85ebf6b209e$export$2e2bcd8739ae039({ help: help, registry: registry, uiSchema: uiSchema = {} }) {
    const { globalUiOptions: globalUiOptions } = registry;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema, globalUiOptions);
    if (uiOptions.enableMarkdownInHelp && typeof help === 'string') return (0, $2e41620b030ed79e$exports.jsx)((0, $0a39817bbf114bf6$export$7460c8b7e4ce9582), {
        options: {
            disableParsingRawHTML: true
        },
        "data-testid": $1bedc85ebf6b209e$var$TEST_IDS.markdown,
        children: help
    });
    return help;
}
$1bedc85ebf6b209e$export$2e2bcd8739ae039.TEST_IDS = $1bedc85ebf6b209e$var$TEST_IDS;


function $24fd3e24430cabef$export$2e2bcd8739ae039(props) {
    const { fieldPathId: fieldPathId, help: help, uiSchema: uiSchema, registry: registry } = props;
    if (!help) return null;
    return (0, $2e41620b030ed79e$exports.jsx)("div", {
        id: (0, $8ce79fa261751f64$export$94c2e687214ec019)(fieldPathId),
        className: 'help-block',
        children: (0, $2e41620b030ed79e$exports.jsx)((0, $1bedc85ebf6b209e$export$2e2bcd8739ae039), {
            help: help,
            registry: registry,
            uiSchema: uiSchema
        })
    });
}





const $533a1a11728447f7$var$REQUIRED_FIELD_SYMBOL = '*';
function $533a1a11728447f7$export$2e2bcd8739ae039(props) {
    const { label: label, required: required, id: id } = props;
    if (!label) return null;
    return (0, $2e41620b030ed79e$exports.jsxs)("label", {
        className: 'control-label',
        htmlFor: id,
        children: [
            label,
            required && (0, $2e41620b030ed79e$exports.jsx)("span", {
                className: 'required',
                children: $533a1a11728447f7$var$REQUIRED_FIELD_SYMBOL
            })
        ]
    });
}


function $fb0be2ed911eaf28$export$2e2bcd8739ae039(props) {
    const { id: id, label: label, children: children, errors: errors, help: help, description: description, hidden: hidden, required: required, displayLabel: displayLabel, registry: registry, uiSchema: uiSchema } = props;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const WrapIfAdditionalTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('WrapIfAdditionalTemplate', registry, uiOptions);
    if (hidden) return (0, $2e41620b030ed79e$exports.jsx)("div", {
        className: 'hidden',
        children: children
    });
    const isCheckbox = uiOptions.widget === 'checkbox';
    return (0, $2e41620b030ed79e$exports.jsxs)(WrapIfAdditionalTemplate, {
        ...props,
        children: [
            displayLabel && !isCheckbox && (0, $2e41620b030ed79e$exports.jsx)((0, $533a1a11728447f7$export$2e2bcd8739ae039), {
                label: label,
                required: required,
                id: id
            }),
            displayLabel && description ? description : null,
            children,
            errors,
            help
        ]
    });
}


var $9d4efe679b883c17$export$2e2bcd8739ae039 = (0, $fb0be2ed911eaf28$export$2e2bcd8739ae039);



function $532450040288e46e$export$2e2bcd8739ae039(props) {
    const { children: children, column: column, className: className, ...rest } = props;
    return (0, $2e41620b030ed79e$exports.jsx)("div", {
        className: className,
        ...rest,
        children: children
    });
}



function $4d73e264f2501b29$export$2e2bcd8739ae039(props) {
    const { selector: selector, optionSchemaField: optionSchemaField } = props;
    return (0, $2e41620b030ed79e$exports.jsxs)("div", {
        className: 'panel panel-default panel-body',
        children: [
            (0, $2e41620b030ed79e$exports.jsx)("div", {
                className: 'form-group',
                children: selector
            }),
            optionSchemaField
        ]
    });
}




function $0107fd31ef56b56a$export$2e2bcd8739ae039(props) {
    const { className: className, description: description, disabled: disabled, formData: formData, fieldPathId: fieldPathId, onAddProperty: onAddProperty, optionalDataControl: optionalDataControl, properties: properties, readonly: readonly, registry: registry, required: required, schema: schema, title: title, uiSchema: uiSchema } = props;
    const options = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const TitleFieldTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('TitleFieldTemplate', registry, options);
    const DescriptionFieldTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('DescriptionFieldTemplate', registry, options);
    // For "pure union" schemas (oneOf/anyOf without properties), skip rendering the empty fieldset wrapper.
    // The AnyOfField/OneOfField will handle rendering the union selector and selected variant's content directly.
    const isPureUnionSchema = (schema.oneOf || schema.anyOf) && !schema.properties && properties.length === 0;
    if (isPureUnionSchema) return null;
    const showOptionalDataControlInTitle = !readonly && !disabled;
    // Button templates are not overridden in the uiSchema
    const { ButtonTemplates: { AddButton: AddButton } } = registry.templates;
    return (0, $2e41620b030ed79e$exports.jsxs)("fieldset", {
        className: className,
        id: fieldPathId.$id,
        children: [
            title && (0, $2e41620b030ed79e$exports.jsx)(TitleFieldTemplate, {
                id: (0, $8ce79fa261751f64$export$86b632e0125010d9)(fieldPathId),
                title: title,
                required: required,
                schema: schema,
                uiSchema: uiSchema,
                registry: registry,
                optionalDataControl: showOptionalDataControlInTitle ? optionalDataControl : undefined
            }),
            description && (0, $2e41620b030ed79e$exports.jsx)(DescriptionFieldTemplate, {
                id: (0, $8ce79fa261751f64$export$fd4f3344107bd22c)(fieldPathId),
                description: description,
                schema: schema,
                uiSchema: uiSchema,
                registry: registry
            }),
            !showOptionalDataControlInTitle ? optionalDataControl : undefined,
            properties.map((prop)=>prop.content),
            (0, $ec95fb101af801c1$export$2e2bcd8739ae039)(schema, uiSchema, formData) && (0, $2e41620b030ed79e$exports.jsx)(AddButton, {
                id: (0, $8ce79fa261751f64$export$6395da05030161a1)(fieldPathId, 'add'),
                className: 'rjsf-object-property-expand',
                onClick: onAddProperty,
                disabled: disabled || readonly,
                uiSchema: uiSchema,
                registry: registry
            })
        ]
    });
}




function $6800542ca69e27a2$export$2e2bcd8739ae039(props) {
    const { id: id, registry: registry, label: label, onAddClick: onAddClick, onRemoveClick: onRemoveClick } = props;
    if (onAddClick) return (0, $2e41620b030ed79e$exports.jsx)((0, $cfd0098bad4a1019$export$2e2bcd8739ae039), {
        id: id,
        registry: registry,
        icon: 'plus',
        className: 'rjsf-add-optional-data btn-sm',
        onClick: onAddClick,
        title: label
    });
    if (onRemoveClick) return (0, $2e41620b030ed79e$exports.jsx)((0, $cfd0098bad4a1019$export$2e2bcd8739ae039), {
        id: id,
        registry: registry,
        icon: 'remove',
        className: 'rjsf-remove-optional-data btn-sm',
        onClick: onRemoveClick,
        title: label
    });
    return (0, $2e41620b030ed79e$exports.jsx)("em", {
        id: id,
        children: label
    });
}



const $596d4b51716c75c4$var$REQUIRED_FIELD_SYMBOL = '*';
function $596d4b51716c75c4$export$2e2bcd8739ae039(props) {
    const { id: id, title: title, required: required, optionalDataControl: optionalDataControl } = props;
    return (0, $2e41620b030ed79e$exports.jsxs)("legend", {
        id: id,
        children: [
            title,
            required && (0, $2e41620b030ed79e$exports.jsx)("span", {
                className: 'required',
                children: $596d4b51716c75c4$var$REQUIRED_FIELD_SYMBOL
            }),
            optionalDataControl && (0, $2e41620b030ed79e$exports.jsx)("span", {
                className: 'pull-right',
                style: {
                    marginBottom: '2px'
                },
                children: optionalDataControl
            })
        ]
    });
}





/** The `UnsupportedField` component is used to render a field in the schema is one that is not supported by
 * react-jsonschema-form.
 *
 * @param props - The `FieldProps` for this template
 */ function $6ad8efcdb5299ffc$var$UnsupportedField(props) {
    const { schema: schema, fieldPathId: fieldPathId, reason: reason, registry: registry } = props;
    const { translateString: translateString } = registry;
    let translateEnum = (0, $b63837cd47cf776b$export$e8ce1f619d132f5c).UnsupportedField;
    const translateParams = [];
    if (fieldPathId && fieldPathId.$id) {
        translateEnum = (0, $b63837cd47cf776b$export$e8ce1f619d132f5c).UnsupportedFieldWithId;
        translateParams.push(fieldPathId.$id);
    }
    if (reason) {
        translateEnum = translateEnum === (0, $b63837cd47cf776b$export$e8ce1f619d132f5c).UnsupportedField ? (0, $b63837cd47cf776b$export$e8ce1f619d132f5c).UnsupportedFieldWithReason : (0, $b63837cd47cf776b$export$e8ce1f619d132f5c).UnsupportedFieldWithIdAndReason;
        translateParams.push(reason);
    }
    return (0, $2e41620b030ed79e$exports.jsxs)("div", {
        className: 'unsupported-field',
        children: [
            (0, $2e41620b030ed79e$exports.jsx)("p", {
                children: (0, $2e41620b030ed79e$exports.jsx)((0, $0a39817bbf114bf6$export$7460c8b7e4ce9582), {
                    options: {
                        disableParsingRawHTML: true
                    },
                    children: translateString(translateEnum, translateParams)
                })
            }),
            schema && (0, $2e41620b030ed79e$exports.jsx)("pre", {
                children: JSON.stringify(schema, null, 2)
            })
        ]
    });
}
var $6ad8efcdb5299ffc$export$2e2bcd8739ae039 = $6ad8efcdb5299ffc$var$UnsupportedField;





function $9873d9c7356eb18e$export$2e2bcd8739ae039(props) {
    const { id: id, classNames: classNames, style: style, disabled: disabled, displayLabel: displayLabel, label: label, onKeyRenameBlur: onKeyRenameBlur, onRemoveProperty: onRemoveProperty, rawDescription: rawDescription, readonly: readonly, required: required, schema: schema, hideError: hideError, rawErrors: rawErrors, children: children, uiSchema: uiSchema, registry: registry } = props;
    const { templates: templates, translateString: translateString } = registry;
    // Button templates are not overridden in the uiSchema
    const { RemoveButton: RemoveButton } = templates.ButtonTemplates;
    const keyLabel = translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).KeyLabel, [
        label
    ]);
    const additional = (0, $cd207018ee28cb28$export$60d2d9c11642ddd6) in schema;
    const hasDescription = !!rawDescription;
    const classNamesList = [
        'form-group',
        classNames
    ];
    if (!hideError && rawErrors && rawErrors.length > 0) classNamesList.push('has-error has-danger');
    const uiClassNames = classNamesList.join(' ').trim();
    if (!additional) return (0, $2e41620b030ed79e$exports.jsx)("div", {
        className: uiClassNames,
        style: style,
        children: children
    });
    const margin = hasDescription ? 46 : 26;
    return (0, $2e41620b030ed79e$exports.jsx)("div", {
        className: uiClassNames,
        style: style,
        children: (0, $2e41620b030ed79e$exports.jsxs)("div", {
            className: 'row',
            children: [
                (0, $2e41620b030ed79e$exports.jsx)("div", {
                    className: 'col-xs-5 form-additional',
                    children: (0, $2e41620b030ed79e$exports.jsxs)("div", {
                        className: 'form-group',
                        children: [
                            displayLabel && (0, $2e41620b030ed79e$exports.jsx)((0, $533a1a11728447f7$export$2e2bcd8739ae039), {
                                label: keyLabel,
                                required: required,
                                id: `${id}-key`
                            }),
                            displayLabel && rawDescription && (0, $2e41620b030ed79e$exports.jsx)("div", {
                                children: "\u00A0"
                            }),
                            (0, $2e41620b030ed79e$exports.jsx)("input", {
                                className: 'form-control',
                                type: 'text',
                                id: `${id}-key`,
                                onBlur: onKeyRenameBlur,
                                defaultValue: label
                            }, label)
                        ]
                    })
                }),
                (0, $2e41620b030ed79e$exports.jsx)("div", {
                    className: 'form-additional form-group col-xs-5',
                    children: children
                }),
                (0, $2e41620b030ed79e$exports.jsx)("div", {
                    className: 'col-xs-2',
                    style: {
                        marginTop: displayLabel ? `${margin}px` : undefined
                    },
                    children: (0, $2e41620b030ed79e$exports.jsx)(RemoveButton, {
                        id: (0, $8ce79fa261751f64$export$6395da05030161a1)(id, 'remove'),
                        className: 'rjsf-object-property-remove btn-block',
                        style: {
                            border: '0'
                        },
                        disabled: disabled || readonly,
                        onClick: onRemoveProperty,
                        uiSchema: uiSchema,
                        registry: registry
                    })
                })
            ]
        })
    });
}


function $71808b5e1d59b839$var$templates() {
    return {
        ArrayFieldDescriptionTemplate: $830d495d75f01a96$export$2e2bcd8739ae039,
        ArrayFieldItemTemplate: $466b3892fedc584f$export$2e2bcd8739ae039,
        ArrayFieldItemButtonsTemplate: $c6ccb726a92368ca$export$2e2bcd8739ae039,
        ArrayFieldTemplate: $23eee89a6fb31e81$export$2e2bcd8739ae039,
        ArrayFieldTitleTemplate: $80c9a82d351eb2bd$export$2e2bcd8739ae039,
        ButtonTemplates: (0, $8fbaa5cf8a3c5d88$export$2e2bcd8739ae039)(),
        BaseInputTemplate: $48e30663a9c02f1e$export$2e2bcd8739ae039,
        DescriptionFieldTemplate: (0, $e953303bfb093df0$export$2e2bcd8739ae039),
        ErrorListTemplate: (0, $1f064bbffc0713bc$export$2e2bcd8739ae039),
        FallbackFieldTemplate: $39db94c52e3bd593$export$2e2bcd8739ae039,
        FieldTemplate: $9d4efe679b883c17$export$2e2bcd8739ae039,
        FieldErrorTemplate: $03b1ea410418184b$export$2e2bcd8739ae039,
        FieldHelpTemplate: $24fd3e24430cabef$export$2e2bcd8739ae039,
        GridTemplate: $532450040288e46e$export$2e2bcd8739ae039,
        MultiSchemaFieldTemplate: $4d73e264f2501b29$export$2e2bcd8739ae039,
        ObjectFieldTemplate: $0107fd31ef56b56a$export$2e2bcd8739ae039,
        OptionalDataControlsTemplate: $6800542ca69e27a2$export$2e2bcd8739ae039,
        TitleFieldTemplate: (0, $596d4b51716c75c4$export$2e2bcd8739ae039),
        UnsupportedFieldTemplate: (0, $6ad8efcdb5299ffc$export$2e2bcd8739ae039),
        WrapIfAdditionalTemplate: $9873d9c7356eb18e$export$2e2bcd8739ae039
    };
}
var $71808b5e1d59b839$export$2e2bcd8739ae039 = $71808b5e1d59b839$var$templates;



/** The `AltDateTimeWidget` is an alternative widget for rendering datetime properties.
 *  It uses the AltDateWidget for rendering, with the `time` prop set to true by default.
 *
 * @param props - The `WidgetProps` for this component
 */ function $3cad7ff127556dae$var$AltDateTimeWidget({ time: time = true, ...props }) {
    const { AltDateWidget: AltDateWidget } = props.registry.widgets;
    return (0, $2e41620b030ed79e$exports.jsx)(AltDateWidget, {
        time: time,
        ...props
    });
}
var $3cad7ff127556dae$export$2e2bcd8739ae039 = $3cad7ff127556dae$var$AltDateTimeWidget;




/** The `AltDateWidget` is an alternative widget for rendering date properties.
 * @param props - The `WidgetProps` for this component
 */ function $6475173d251b700d$var$AltDateWidget(props) {
    const { disabled: disabled = false, readonly: readonly = false, autofocus: autofocus = false, options: options, id: id, name: name, registry: registry, onBlur: onBlur, onFocus: onFocus } = props;
    const { translateString: translateString } = registry;
    const { elements: elements, handleChange: handleChange, handleClear: handleClear, handleSetNow: handleSetNow } = (0, $89082e2af7bb7362$export$2e2bcd8739ae039)(props);
    return (0, $2e41620b030ed79e$exports.jsxs)("ul", {
        className: 'list-inline',
        children: [
            elements.map((elemProps, i)=>(0, $2e41620b030ed79e$exports.jsx)("li", {
                    className: 'list-inline-item',
                    children: (0, $2e41620b030ed79e$exports.jsx)((0, $89082e2af7bb7362$export$1e68ee11416672d8), {
                        rootId: id,
                        name: name,
                        select: handleChange,
                        ...elemProps,
                        disabled: disabled,
                        readonly: readonly,
                        registry: registry,
                        onBlur: onBlur,
                        onFocus: onFocus,
                        autofocus: autofocus && i === 0
                    })
                }, i)),
            (options.hideNowButton !== 'undefined' ? !options.hideNowButton : true) && (0, $2e41620b030ed79e$exports.jsx)("li", {
                className: 'list-inline-item',
                children: (0, $2e41620b030ed79e$exports.jsx)("button", {
                    type: 'button',
                    className: 'btn btn-info btn-now',
                    onClick: handleSetNow,
                    children: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).NowLabel)
                })
            }),
            (options.hideClearButton !== 'undefined' ? !options.hideClearButton : true) && (0, $2e41620b030ed79e$exports.jsx)("li", {
                className: 'list-inline-item',
                children: (0, $2e41620b030ed79e$exports.jsx)("button", {
                    type: 'button',
                    className: 'btn btn-warning btn-clear',
                    onClick: handleClear,
                    children: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).ClearLabel)
                })
            })
        ]
    });
}
var $6475173d251b700d$export$2e2bcd8739ae039 = $6475173d251b700d$var$AltDateWidget;




var $h4Bez = parcelRequire("h4Bez");

/** The `CheckboxesWidget` is a widget for rendering checkbox groups.
 *  It is typically used to represent an array of enums.
 *
 * @param props - The `WidgetProps` for this component
 */ function $b8f30aae66119ca0$var$CheckboxesWidget({ id: id, disabled: disabled, options: options, value: value, autofocus: autofocus = false, readonly: readonly, onChange: onChange, onBlur: onBlur, onFocus: onFocus, htmlName: htmlName }) {
    const { inline: inline = false, enumOptions: enumOptions, enumDisabled: enumDisabled, emptyValue: emptyValue } = options;
    const optionValueFormat = (0, $b28583320c2e364e$export$2e2bcd8739ae039)(options);
    const checkboxesValues = Array.isArray(value) ? value : [
        value
    ];
    const handleBlur = (0, $h4Bez.useCallback)(({ target: target })=>onBlur(id, (0, $d751b2609dc272ff$export$2e2bcd8739ae039)(target && target.value, enumOptions, optionValueFormat, emptyValue)), [
        onBlur,
        id,
        enumOptions,
        emptyValue,
        optionValueFormat
    ]);
    const handleFocus = (0, $h4Bez.useCallback)(({ target: target })=>onFocus(id, (0, $d751b2609dc272ff$export$2e2bcd8739ae039)(target && target.value, enumOptions, optionValueFormat, emptyValue)), [
        onFocus,
        id,
        enumOptions,
        emptyValue,
        optionValueFormat
    ]);
    return (0, $2e41620b030ed79e$exports.jsx)("div", {
        className: 'checkboxes',
        id: id,
        children: Array.isArray(enumOptions) && enumOptions.map((option, index)=>{
            const checked = (0, $7f18f5e02c7e23b3$export$2e2bcd8739ae039)(option.value, checkboxesValues);
            const itemDisabled = Array.isArray(enumDisabled) && enumDisabled.includes(option.value);
            const disabledCls = disabled || itemDisabled || readonly ? 'disabled' : '';
            const handleChange = (event)=>{
                if (event.target.checked) onChange((0, $4d503b5a876c5ffd$export$2e2bcd8739ae039)(index, checkboxesValues, enumOptions));
                else onChange((0, $cd5aeb8c020db4af$export$2e2bcd8739ae039)(index, checkboxesValues, enumOptions));
            };
            const checkbox = (0, $2e41620b030ed79e$exports.jsxs)("span", {
                children: [
                    (0, $2e41620b030ed79e$exports.jsx)("input", {
                        type: 'checkbox',
                        id: (0, $8ce79fa261751f64$export$edf9b44aa62de7dd)(id, index),
                        name: htmlName || id,
                        checked: checked,
                        value: (0, $36f1d7e65b39cdba$export$2e2bcd8739ae039)(option.value, index, optionValueFormat),
                        disabled: disabled || itemDisabled || readonly,
                        autoFocus: autofocus && index === 0,
                        onChange: handleChange,
                        onBlur: handleBlur,
                        onFocus: handleFocus,
                        "aria-describedby": (0, $8ce79fa261751f64$export$53c2204bb4091b57)(id)
                    }),
                    (0, $2e41620b030ed79e$exports.jsx)("span", {
                        children: option.label
                    })
                ]
            });
            return inline ? (0, $2e41620b030ed79e$exports.jsx)("label", {
                className: `checkbox-inline ${disabledCls}`,
                children: checkbox
            }, String(option.value)) : (0, $2e41620b030ed79e$exports.jsx)("div", {
                className: `checkbox ${disabledCls}`,
                children: (0, $2e41620b030ed79e$exports.jsx)("label", {
                    children: checkbox
                })
            }, String(option.value));
        })
    });
}
var $b8f30aae66119ca0$export$2e2bcd8739ae039 = $b8f30aae66119ca0$var$CheckboxesWidget;




var $h4Bez = parcelRequire("h4Bez");

/** The `CheckBoxWidget` is a widget for rendering boolean properties.
 *  It is typically used to represent a boolean.
 *
 * @param props - The `WidgetProps` for this component
 */ function $4ba64ba036e16b8c$var$CheckboxWidget({ schema: schema, uiSchema: uiSchema, options: options, id: id, value: value, disabled: disabled, readonly: readonly, label: label, hideLabel: hideLabel, autofocus: autofocus = false, onBlur: onBlur, onFocus: onFocus, onChange: onChange, registry: registry, htmlName: htmlName }) {
    const DescriptionFieldTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('DescriptionFieldTemplate', registry, options);
    // Because an unchecked checkbox will cause html5 validation to fail, only add
    // the "required" attribute if the field value must be "true", due to the
    // "const" or "enum" keywords
    const required = (0, $a2e0f2eb7f90d507$export$2e2bcd8739ae039)(schema);
    const handleChange = (0, $h4Bez.useCallback)((event)=>onChange(event.target.checked), [
        onChange
    ]);
    const handleBlur = (0, $h4Bez.useCallback)((event)=>onBlur(id, event.target.checked), [
        onBlur,
        id
    ]);
    const handleFocus = (0, $h4Bez.useCallback)((event)=>onFocus(id, event.target.checked), [
        onFocus,
        id
    ]);
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const isCheckboxWidget = uiOptions.widget === 'checkbox';
    const description = isCheckboxWidget ? undefined : options.description ?? schema.description;
    return (0, $2e41620b030ed79e$exports.jsxs)("div", {
        className: `checkbox ${disabled || readonly ? 'disabled' : ''}`,
        children: [
            !hideLabel && description && (0, $2e41620b030ed79e$exports.jsx)(DescriptionFieldTemplate, {
                id: (0, $8ce79fa261751f64$export$fd4f3344107bd22c)(id),
                description: description,
                schema: schema,
                uiSchema: uiSchema,
                registry: registry
            }),
            (0, $2e41620b030ed79e$exports.jsxs)("label", {
                children: [
                    (0, $2e41620b030ed79e$exports.jsx)("input", {
                        type: 'checkbox',
                        id: id,
                        name: htmlName || id,
                        checked: typeof value === 'undefined' ? false : value,
                        required: required,
                        disabled: disabled || readonly,
                        autoFocus: autofocus,
                        onChange: handleChange,
                        onBlur: handleBlur,
                        onFocus: handleFocus,
                        "aria-describedby": (0, $8ce79fa261751f64$export$53c2204bb4091b57)(id)
                    }),
                    (0, $e15ee0fe5a70fe3e$export$2e2bcd8739ae039)((0, $2e41620b030ed79e$exports.jsx)("span", {
                        children: label
                    }), hideLabel)
                ]
            })
        ]
    });
}
var $4ba64ba036e16b8c$export$2e2bcd8739ae039 = $4ba64ba036e16b8c$var$CheckboxWidget;




function $ccf4cbd368cd35ff$export$2e2bcd8739ae039(props) {
    const { disabled: disabled, readonly: readonly, options: options, registry: registry } = props;
    const BaseInputTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('BaseInputTemplate', registry, options);
    return (0, $2e41620b030ed79e$exports.jsx)(BaseInputTemplate, {
        type: 'color',
        ...props,
        disabled: disabled || readonly
    });
}




function $a0644ff5d968a759$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, value: value, options: options, registry: registry } = props;
    const BaseInputTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('BaseInputTemplate', registry, options);
    return (0, $2e41620b030ed79e$exports.jsx)(BaseInputTemplate, {
        type: 'datetime-local',
        ...props,
        value: (0, $e043d79250f08a55$export$2e2bcd8739ae039)(value),
        onChange: (newValue)=>onChange((0, $56d385d1e39964bc$export$2e2bcd8739ae039)(newValue))
    });
}




var $h4Bez = parcelRequire("h4Bez");

function $9d5c23c34a5ce3f9$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options, registry: registry } = props;
    const BaseInputTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('BaseInputTemplate', registry, options);
    const handleChange = (0, $h4Bez.useCallback)((value)=>onChange(value || undefined), [
        onChange
    ]);
    return (0, $2e41620b030ed79e$exports.jsx)(BaseInputTemplate, {
        type: 'date',
        ...props,
        onChange: handleChange
    });
}




function $c5f3cbec88e19083$export$2e2bcd8739ae039(props) {
    const { options: options, registry: registry } = props;
    const BaseInputTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('BaseInputTemplate', registry, options);
    return (0, $2e41620b030ed79e$exports.jsx)(BaseInputTemplate, {
        type: 'email',
        ...props
    });
}





function $40841fe23ff0ad4e$var$FileInfoPreview({ fileInfo: fileInfo, registry: registry }) {
    const { translateString: translateString } = registry;
    const { dataURL: dataURL, type: type, name: name } = fileInfo;
    if (!dataURL) return null;
    const previewLabel = translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).PreviewLabel);
    // If type is JPEG or PNG then show image preview.
    // Originally, any type of image was supported, but this was changed into a whitelist
    // since SVGs and animated GIFs are also images, which are generally considered a security risk.
    if ([
        'image/jpeg',
        'image/png'
    ].includes(type)) return (0, $2e41620b030ed79e$exports.jsx)("img", {
        src: dataURL,
        alt: previewLabel,
        style: {
            maxWidth: '100%'
        },
        className: 'file-preview'
    });
    // otherwise, let users download file
    return (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            ' ',
            (0, $2e41620b030ed79e$exports.jsx)("a", {
                download: `preview-${name}`,
                href: dataURL,
                className: 'file-download',
                children: previewLabel
            })
        ]
    });
}
function $40841fe23ff0ad4e$var$FilesInfo({ filesInfo: filesInfo, registry: registry, preview: preview, onRemove: onRemove, options: options }) {
    if (filesInfo.length === 0) return null;
    const { translateString: translateString } = registry;
    const { RemoveButton: RemoveButton } = (0, $f037e3283241319d$export$2e2bcd8739ae039)('ButtonTemplates', registry, options);
    return (0, $2e41620b030ed79e$exports.jsx)("ul", {
        className: 'file-info',
        children: filesInfo.map((fileInfo, key)=>{
            const { name: name, size: size, type: type } = fileInfo;
            const handleRemove = ()=>onRemove(key);
            return (0, $2e41620b030ed79e$exports.jsxs)("li", {
                children: [
                    (0, $2e41620b030ed79e$exports.jsx)((0, $0a39817bbf114bf6$export$7460c8b7e4ce9582), {
                        children: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).FilesInfo, [
                            name,
                            type,
                            String(size)
                        ])
                    }),
                    preview && (0, $2e41620b030ed79e$exports.jsx)($40841fe23ff0ad4e$var$FileInfoPreview, {
                        fileInfo: fileInfo,
                        registry: registry
                    }),
                    (0, $2e41620b030ed79e$exports.jsx)(RemoveButton, {
                        onClick: handleRemove,
                        registry: registry
                    })
                ]
            }, key);
        })
    });
}
/**
 *  The `FileWidget` is a widget for rendering file upload fields.
 *  It is typically used with a string property with data-url format.
 */ function $40841fe23ff0ad4e$var$FileWidget(props) {
    const { disabled: disabled, readonly: readonly, required: required, multiple: multiple, onChange: onChange, value: value, options: options, registry: registry } = props;
    const { filesInfo: filesInfo, handleChange: handleChange, handleRemove: handleRemove } = (0, $98812ea88cdc9445$export$2e2bcd8739ae039)(value, onChange, multiple);
    const BaseInputTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('BaseInputTemplate', registry, options);
    const handleOnChangeEvent = (event)=>{
        if (event.target.files) // handleChange is async; DOM event handlers are void-returning, so we intentionally don't await
        // oxlint-disable-next-line no-floating-promises, no-void
        handleChange(event.target.files);
    };
    return (0, $2e41620b030ed79e$exports.jsxs)("div", {
        children: [
            (0, $2e41620b030ed79e$exports.jsx)(BaseInputTemplate, {
                ...props,
                disabled: disabled || readonly,
                type: 'file',
                required: value ? false : required,
                onChangeOverride: handleOnChangeEvent,
                value: '',
                accept: options.accept ? String(options.accept) : undefined
            }),
            (0, $2e41620b030ed79e$exports.jsx)($40841fe23ff0ad4e$var$FilesInfo, {
                filesInfo: filesInfo,
                onRemove: handleRemove,
                registry: registry,
                preview: options.filePreview,
                options: options
            })
        ]
    });
}
var $40841fe23ff0ad4e$export$2e2bcd8739ae039 = $40841fe23ff0ad4e$var$FileWidget;



/** The `HiddenWidget` is a widget for rendering a hidden input field.
 *  It is typically used by setting type to "hidden".
 *
 * @param props - The `WidgetProps` for this component
 */ function $25cfa9d6d67cafd0$var$HiddenWidget({ id: id, value: value, htmlName: htmlName }) {
    return (0, $2e41620b030ed79e$exports.jsx)("input", {
        type: 'hidden',
        id: id,
        name: htmlName || id,
        value: typeof value === 'undefined' ? '' : value
    });
}
var $25cfa9d6d67cafd0$export$2e2bcd8739ae039 = $25cfa9d6d67cafd0$var$HiddenWidget;




function $12a02688d4ff5ed4$export$2e2bcd8739ae039(props) {
    const { options: options, registry: registry } = props;
    const BaseInputTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('BaseInputTemplate', registry, options);
    return (0, $2e41620b030ed79e$exports.jsx)(BaseInputTemplate, {
        type: 'password',
        ...props
    });
}




var $h4Bez = parcelRequire("h4Bez");

/** The `RadioWidget` is a widget for rendering a radio group.
 *  It is typically used with a string property constrained with enum options.
 *
 * @param props - The `WidgetProps` for this component
 */ function $42dc494a6bce48a6$var$RadioWidget({ options: options, value: value, required: required, disabled: disabled, readonly: readonly, autofocus: autofocus = false, onBlur: onBlur, onFocus: onFocus, onChange: onChange, id: id, htmlName: htmlName }) {
    const { enumOptions: enumOptions, enumDisabled: enumDisabled, inline: inline, emptyValue: emptyValue } = options;
    const optionValueFormat = (0, $b28583320c2e364e$export$2e2bcd8739ae039)(options);
    const handleBlur = (0, $h4Bez.useCallback)(({ target: target })=>onBlur(id, (0, $d751b2609dc272ff$export$2e2bcd8739ae039)(target && target.value, enumOptions, optionValueFormat, emptyValue)), [
        onBlur,
        enumOptions,
        emptyValue,
        id,
        optionValueFormat
    ]);
    const handleFocus = (0, $h4Bez.useCallback)(({ target: target })=>onFocus(id, (0, $d751b2609dc272ff$export$2e2bcd8739ae039)(target && target.value, enumOptions, optionValueFormat, emptyValue)), [
        onFocus,
        enumOptions,
        emptyValue,
        id,
        optionValueFormat
    ]);
    return (0, $2e41620b030ed79e$exports.jsx)("div", {
        className: 'field-radio-group',
        id: id,
        role: 'radiogroup',
        children: Array.isArray(enumOptions) && enumOptions.map((option, i)=>{
            const checked = (0, $7f18f5e02c7e23b3$export$2e2bcd8739ae039)(option.value, value);
            const itemDisabled = Array.isArray(enumDisabled) && enumDisabled.includes(option.value);
            const disabledCls = disabled || itemDisabled || readonly ? 'disabled' : '';
            const handleChange = ()=>onChange(option.value);
            const radio = (0, $2e41620b030ed79e$exports.jsxs)("span", {
                children: [
                    (0, $2e41620b030ed79e$exports.jsx)("input", {
                        type: 'radio',
                        id: (0, $8ce79fa261751f64$export$edf9b44aa62de7dd)(id, i),
                        checked: checked,
                        name: htmlName || id,
                        required: required,
                        value: (0, $36f1d7e65b39cdba$export$2e2bcd8739ae039)(option.value, i, optionValueFormat),
                        disabled: disabled || itemDisabled || readonly,
                        autoFocus: autofocus && i === 0,
                        onChange: handleChange,
                        onBlur: handleBlur,
                        onFocus: handleFocus,
                        "aria-describedby": (0, $8ce79fa261751f64$export$53c2204bb4091b57)(id)
                    }),
                    (0, $2e41620b030ed79e$exports.jsx)("span", {
                        children: option.label
                    })
                ]
            });
            return inline ? (0, $2e41620b030ed79e$exports.jsx)("label", {
                className: `radio-inline ${disabledCls}`,
                children: radio
            }, String(option.value)) : (0, $2e41620b030ed79e$exports.jsx)("div", {
                className: `radio ${disabledCls}`,
                children: (0, $2e41620b030ed79e$exports.jsx)("label", {
                    children: radio
                })
            }, String(option.value));
        })
    });
}
var $42dc494a6bce48a6$export$2e2bcd8739ae039 = $42dc494a6bce48a6$var$RadioWidget;



function $65f866dba3f0faef$export$2e2bcd8739ae039(props) {
    const { value: value, registry: { templates: { BaseInputTemplate: BaseInputTemplate } } } = props;
    return (0, $2e41620b030ed79e$exports.jsxs)("div", {
        className: 'field-range-wrapper',
        children: [
            (0, $2e41620b030ed79e$exports.jsx)(BaseInputTemplate, {
                type: 'range',
                ...props
            }),
            (0, $2e41620b030ed79e$exports.jsx)("span", {
                className: 'range-view',
                children: value
            })
        ]
    });
}




var $h4Bez = parcelRequire("h4Bez");
function $27877486123cb46a$export$2e2bcd8739ae039({ id: id, value: value, required: required, disabled: disabled, readonly: readonly, autofocus: autofocus, onChange: onChange, onFocus: onFocus, onBlur: onBlur, schema: schema, options: options, htmlName: htmlName }) {
    const { stars: stars = 5, shape: shape = 'star' } = options;
    // Use schema.maximum if provided, otherwise use stars option (limited to 1-5)
    const numStars = schema.maximum ? Math.min(schema.maximum, 5) : Math.min(Math.max(stars, 1), 5);
    const min = schema.minimum || 0;
    /** Handles clicking on a star to set the rating */ const handleStarClick = (0, $h4Bez.useCallback)((starValue)=>{
        if (!disabled && !readonly) onChange(starValue);
    }, [
        onChange,
        disabled,
        readonly
    ]);
    /** Handles focus events for accessibility */ const handleFocus = (0, $h4Bez.useCallback)((event)=>{
        if (onFocus) {
            // Get the star value from the data attribute
            const starValue = Number(event.target.dataset.value);
            onFocus(id, starValue);
        }
    }, [
        onFocus,
        id
    ]);
    /** Handles blur events for accessibility */ const handleBlur = (0, $h4Bez.useCallback)((event)=>{
        if (onBlur) {
            // Get the star value from the data attribute
            const starValue = Number(event.target.dataset.value);
            onBlur(id, starValue);
        }
    }, [
        onBlur,
        id
    ]);
    // Get the appropriate Unicode character based on shape option
    const getSymbol = (isFilled)=>{
        if (shape === 'heart') return isFilled ? "\u2665" : "\u2661";
        return isFilled ? "\u2605" : "\u2606";
    };
    return (0, $2e41620b030ed79e$exports.jsxs)("div", {
        className: 'rating-widget',
        style: {
            display: 'inline-flex',
            fontSize: '1.5rem',
            cursor: disabled || readonly ? 'default' : 'pointer'
        },
        children: [
            [
                ...Array(numStars)
            ].map((_, index)=>{
                const starValue = min + index;
                const isFilled = starValue <= value;
                return (0, $2e41620b030ed79e$exports.jsx)("span", {
                    onClick: ()=>handleStarClick(starValue),
                    onKeyDown: (e)=>(e.key === 'Enter' || e.key === ' ') && handleStarClick(starValue),
                    onFocus: handleFocus,
                    onBlur: handleBlur,
                    "data-value": starValue,
                    tabIndex: disabled || readonly ? -1 : 0,
                    role: 'radio',
                    "aria-checked": starValue === value,
                    "aria-label": `${starValue} ${shape === 'heart' ? 'heart' : 'star'}${starValue === 1 ? '' : 's'}`,
                    style: {
                        color: isFilled ? '#FFD700' : '#ccc',
                        padding: '0 0.2rem',
                        transition: 'color 0.2s',
                        userSelect: 'none'
                    },
                    children: getSymbol(isFilled)
                }, index);
            }),
            (0, $2e41620b030ed79e$exports.jsx)("input", {
                type: 'hidden',
                id: id,
                name: htmlName || id,
                value: value || '',
                required: required,
                disabled: disabled || readonly,
                "aria-hidden": 'true'
            })
        ]
    });
}




var $h4Bez = parcelRequire("h4Bez");

function $3e1ab0b73ee5b556$var$getValue(event, multiple) {
    if (multiple) return Array.from(event.target.options).slice().filter((o)=>o.selected).map((o)=>o.value);
    return event.target.value;
}
/** The `SelectWidget` is a widget for rendering dropdowns.
 *  It is typically used with string properties constrained with enum options.
 *
 * @param props - The `WidgetProps` for this component
 */ function $3e1ab0b73ee5b556$var$SelectWidget({ schema: schema, id: id, options: options, value: value, required: required, disabled: disabled, readonly: readonly, multiple: multiple = false, autofocus: autofocus = false, onChange: onChange, onBlur: onBlur, onFocus: onFocus, placeholder: placeholder, htmlName: htmlName }) {
    const { enumOptions: enumOptions, enumDisabled: enumDisabled, emptyValue: optEmptyVal } = options;
    const emptyValue = multiple ? [] : '';
    const optionValueFormat = (0, $b28583320c2e364e$export$2e2bcd8739ae039)(options);
    const handleFocus = (0, $h4Bez.useCallback)((event)=>{
        const newValue = $3e1ab0b73ee5b556$var$getValue(event, multiple);
        return onFocus(id, (0, $d751b2609dc272ff$export$2e2bcd8739ae039)(newValue, enumOptions, optionValueFormat, optEmptyVal));
    }, [
        onFocus,
        id,
        multiple,
        enumOptions,
        optEmptyVal,
        optionValueFormat
    ]);
    const handleBlur = (0, $h4Bez.useCallback)((event)=>{
        const newValue = $3e1ab0b73ee5b556$var$getValue(event, multiple);
        return onBlur(id, (0, $d751b2609dc272ff$export$2e2bcd8739ae039)(newValue, enumOptions, optionValueFormat, optEmptyVal));
    }, [
        onBlur,
        id,
        multiple,
        enumOptions,
        optEmptyVal,
        optionValueFormat
    ]);
    const handleChange = (0, $h4Bez.useCallback)((event)=>{
        const newValue = $3e1ab0b73ee5b556$var$getValue(event, multiple);
        return onChange((0, $d751b2609dc272ff$export$2e2bcd8739ae039)(newValue, enumOptions, optionValueFormat, optEmptyVal));
    }, [
        onChange,
        multiple,
        enumOptions,
        optEmptyVal,
        optionValueFormat
    ]);
    const selectValue = (0, $d9eabbfa9629bc80$export$2e2bcd8739ae039)(value, enumOptions, multiple, optionValueFormat, emptyValue);
    const showPlaceholderOption = !multiple && schema.default === undefined;
    return (0, $2e41620b030ed79e$exports.jsxs)("select", {
        id: id,
        name: htmlName || id,
        multiple: multiple,
        className: 'form-control',
        value: selectValue,
        required: required,
        disabled: disabled || readonly,
        autoFocus: autofocus,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onChange: handleChange,
        "aria-describedby": (0, $8ce79fa261751f64$export$53c2204bb4091b57)(id),
        children: [
            showPlaceholderOption && (0, $2e41620b030ed79e$exports.jsx)("option", {
                value: '',
                children: placeholder
            }),
            Array.isArray(enumOptions) && enumOptions.map(({ value: enumValue, label: enumLabel }, i)=>{
                const isDisabled = enumDisabled && enumDisabled.includes(enumValue);
                return (0, $2e41620b030ed79e$exports.jsx)("option", {
                    value: (0, $36f1d7e65b39cdba$export$2e2bcd8739ae039)(enumValue, i, optionValueFormat),
                    disabled: isDisabled,
                    children: enumLabel
                }, String(enumValue));
            })
        ]
    });
}
var $3e1ab0b73ee5b556$export$2e2bcd8739ae039 = $3e1ab0b73ee5b556$var$SelectWidget;




var $h4Bez = parcelRequire("h4Bez");

/** The `TextareaWidget` is a widget for rendering input fields as textarea.
 *
 * @param props - The `WidgetProps` for this component
 */ function $27b3f5f229671c61$var$TextareaWidget({ id: id, options: options = {}, placeholder: placeholder, value: value, required: required, disabled: disabled, readonly: readonly, autofocus: autofocus = false, onChange: onChange, onBlur: onBlur, onFocus: onFocus, htmlName: htmlName }) {
    const handleChange = (0, $h4Bez.useCallback)(({ target: { value: newValue } })=>onChange(newValue === '' ? options.emptyValue : newValue), [
        onChange,
        options.emptyValue
    ]);
    const handleBlur = (0, $h4Bez.useCallback)(({ target: target })=>onBlur(id, target && target.value), [
        onBlur,
        id
    ]);
    const handleFocus = (0, $h4Bez.useCallback)(({ target: target })=>onFocus(id, target && target.value), [
        id,
        onFocus
    ]);
    return (0, $2e41620b030ed79e$exports.jsx)("textarea", {
        id: id,
        name: htmlName || id,
        className: 'form-control',
        value: value || '',
        placeholder: placeholder,
        required: required,
        disabled: disabled,
        readOnly: readonly,
        autoFocus: autofocus,
        rows: options.rows,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onChange: handleChange,
        "aria-describedby": (0, $8ce79fa261751f64$export$53c2204bb4091b57)(id)
    });
}
var $27b3f5f229671c61$export$2e2bcd8739ae039 = $27b3f5f229671c61$var$TextareaWidget;




function $ece9f3aadd166ac6$export$2e2bcd8739ae039(props) {
    const { options: options, registry: registry } = props;
    const BaseInputTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('BaseInputTemplate', registry, options);
    return (0, $2e41620b030ed79e$exports.jsx)(BaseInputTemplate, {
        ...props
    });
}




var $h4Bez = parcelRequire("h4Bez");

function $6b5254fb3b6a1e77$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options, registry: registry } = props;
    const BaseInputTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('BaseInputTemplate', registry, options);
    const handleChange = (0, $h4Bez.useCallback)((value)=>onChange(value ? `${value}:00` : undefined), [
        onChange
    ]);
    return (0, $2e41620b030ed79e$exports.jsx)(BaseInputTemplate, {
        type: 'time',
        ...props,
        onChange: handleChange
    });
}




function $8ca0451e8e655fc7$export$2e2bcd8739ae039(props) {
    const { options: options, registry: registry } = props;
    const BaseInputTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('BaseInputTemplate', registry, options);
    return (0, $2e41620b030ed79e$exports.jsx)(BaseInputTemplate, {
        type: 'number',
        ...props
    });
}




function $2f44ae4636e8137a$export$2e2bcd8739ae039(props) {
    const { options: options, registry: registry } = props;
    const BaseInputTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('BaseInputTemplate', registry, options);
    return (0, $2e41620b030ed79e$exports.jsx)(BaseInputTemplate, {
        type: 'url',
        ...props
    });
}


function $72a6798ff56d1627$var$widgets() {
    return {
        AltDateWidget: $6475173d251b700d$export$2e2bcd8739ae039,
        AltDateTimeWidget: $3cad7ff127556dae$export$2e2bcd8739ae039,
        CheckboxWidget: $4ba64ba036e16b8c$export$2e2bcd8739ae039,
        CheckboxesWidget: $b8f30aae66119ca0$export$2e2bcd8739ae039,
        ColorWidget: $ccf4cbd368cd35ff$export$2e2bcd8739ae039,
        DateWidget: $9d5c23c34a5ce3f9$export$2e2bcd8739ae039,
        DateTimeWidget: $a0644ff5d968a759$export$2e2bcd8739ae039,
        EmailWidget: $c5f3cbec88e19083$export$2e2bcd8739ae039,
        FileWidget: $40841fe23ff0ad4e$export$2e2bcd8739ae039,
        HiddenWidget: $25cfa9d6d67cafd0$export$2e2bcd8739ae039,
        PasswordWidget: $12a02688d4ff5ed4$export$2e2bcd8739ae039,
        RadioWidget: $42dc494a6bce48a6$export$2e2bcd8739ae039,
        RangeWidget: $65f866dba3f0faef$export$2e2bcd8739ae039,
        RatingWidget: $27877486123cb46a$export$2e2bcd8739ae039,
        SelectWidget: $3e1ab0b73ee5b556$export$2e2bcd8739ae039,
        TextWidget: $ece9f3aadd166ac6$export$2e2bcd8739ae039,
        TextareaWidget: $27b3f5f229671c61$export$2e2bcd8739ae039,
        TimeWidget: $6b5254fb3b6a1e77$export$2e2bcd8739ae039,
        UpDownWidget: $8ca0451e8e655fc7$export$2e2bcd8739ae039,
        URLWidget: $2f44ae4636e8137a$export$2e2bcd8739ae039
    };
}
var $72a6798ff56d1627$export$2e2bcd8739ae039 = $72a6798ff56d1627$var$widgets;


function $6785543bf8584407$export$2e2bcd8739ae039() {
    return {
        fields: (0, $fe3e26d1c1c8ae84$export$2e2bcd8739ae039)(),
        templates: (0, $71808b5e1d59b839$export$2e2bcd8739ae039)(),
        widgets: (0, $72a6798ff56d1627$export$2e2bcd8739ae039)(),
        rootSchema: {},
        formContext: {},
        translateString: (0, $29d931a0330c7ad7$export$2e2bcd8739ae039),
        globalFormOptions: {
            idPrefix: (0, $cd207018ee28cb28$export$fc1a2685f60ab9ef),
            idSeparator: (0, $cd207018ee28cb28$export$cd88b6b1f03afce9),
            useFallbackUiForUnsupportedType: false
        }
    };
}



/** Converts the full `FormState` into the `IChangeEvent` version by picking out the public values
 *
 * @param state - The state of the form
 * @param status - The status provided by the onSubmit
 * @returns - The `IChangeEvent` for the state
 */ function $3a1888fa7e14f86a$var$toIChangeEvent(state, status) {
    return {
        ...(0, $ec25ad87a4fc6980$export$2e2bcd8739ae039)(state, [
            'schema',
            'uiSchema',
            'fieldPathId',
            'schemaUtils',
            'formData',
            'edit',
            'errors',
            'errorSchema'
        ]),
        ...status !== undefined && {
            status: status
        }
    };
}
class $3a1888fa7e14f86a$export$2e2bcd8739ae039 extends (0, $h4Bez.Component) {
    /** The ref used to hold the `form` element, this needs to be `any` because `tagName` or `_internalFormWrapper` can
     * provide any possible type here
     */ formElement;
    /** The list of pending changes
     */ pendingChanges = [];
    /** Flag to track when we're processing a user-initiated field change.
     * This prevents componentDidUpdate from reverting oneOf/anyOf option switches.
     */ isProcessingUserChange = false;
    /** When the `extraErrors` prop changes, re-merges `schemaValidationErrors` + `extraErrors` + `customErrors` into
     * state before render, ensuring the updated errors are visible immediately in a single render cycle.
     *
     * @param props - The current props
     * @param state - The current state
     * @returns Partial state with re-merged errors if `extraErrors` changed, or `null` if no update is needed
     */ static getDerivedStateFromProps(props, state) {
        if (props.extraErrors !== state.prevExtraErrors) {
            const baseErrors = {
                errors: state.schemaValidationErrors || [],
                errorSchema: state.schemaValidationErrorSchema || {}
            };
            let { errors: errors, errorSchema: errorSchema } = baseErrors;
            if (props.extraErrors) ({ errors: errors, errorSchema: errorSchema } = (0, $f4a48b11a54dcb84$export$2e2bcd8739ae039)(baseErrors, props.extraErrors));
            if (state.customErrors) ({ errors: errors, errorSchema: errorSchema } = (0, $f4a48b11a54dcb84$export$2e2bcd8739ae039)({
                errors: errors,
                errorSchema: errorSchema
            }, state.customErrors.ErrorSchema, true));
            return {
                prevExtraErrors: props.extraErrors,
                errors: errors,
                errorSchema: errorSchema
            };
        }
        return null;
    }
    /** Constructs the `Form` from the `props`. Will setup the initial state from the props. It will also call the
     * `onChange` handler if the initially provided `formData` is modified to add missing default values as part of the
     * state construction.
     *
     * @param props - The initial props for the `Form`
     */ constructor(props){
        super(props);
        if (!props.validator) throw new Error('A validator is required for Form functionality to work');
        const { formData: propsFormData, initialFormData: initialFormData, onChange: onChange } = props;
        const formData = propsFormData ?? initialFormData;
        this.state = {
            ...this.getStateFromProps(props, formData, undefined, undefined, undefined, true),
            prevExtraErrors: props.extraErrors
        };
        if (onChange && !(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(this.state.formData, formData)) onChange($3a1888fa7e14f86a$var$toIChangeEvent(this.state));
        this.formElement = (0, $h4Bez.createRef)();
    }
    /**
     * `getSnapshotBeforeUpdate` is a React lifecycle method that is invoked right before the most recently rendered
     * output is committed to the DOM. It enables your component to capture current values (e.g., scroll position) before
     * they are potentially changed.
     *
     * In this case, it checks if the props have changed since the last render. If they have, it computes the next state
     * of the component using `getStateFromProps` method and returns it along with a `shouldUpdate` flag set to `true` IF
     * the `nextState` and `prevState` are different, otherwise `false`. This ensures that we have the most up-to-date
     * state ready to be applied in `componentDidUpdate`.
     *
     * If `formData` hasn't changed, it simply returns an object with `shouldUpdate` set to `false`, indicating that a
     * state update is not necessary.
     *
     * @param prevProps - The previous set of props before the update.
     * @param prevState - The previous state before the update.
     * @returns Either an object containing the next state and a flag indicating that an update should occur, or an object
     *        with a flag indicating that an update is not necessary.
     */ getSnapshotBeforeUpdate(prevProps, prevState) {
        if (!(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(this.props, prevProps)) {
            // Compare the previous props formData against the current props formData
            const formDataChangedFields = (0, $da84398189b91d7b$export$2e2bcd8739ae039)(this.props.formData, prevProps.formData);
            // Compare the current props formData against the current state's formData to determine if the new props were the
            // result of the onChange from the existing state formData
            const stateDataChangedFields = (0, $da84398189b91d7b$export$2e2bcd8739ae039)(this.props.formData, this.state.formData);
            const isSchemaChanged = !(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(prevProps.schema, this.props.schema);
            // When formData is not an object, getChangedFields returns an empty array.
            // In this case, deepEquals is most needed to check again.
            const isFormDataChanged = formDataChangedFields.length > 0 || !(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(prevProps.formData, this.props.formData);
            const isStateDataChanged = stateDataChangedFields.length > 0 || !(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(this.state.formData, this.props.formData);
            const nextState = this.getStateFromProps(this.props, this.props.formData, // If the `schema` has changed, we need to update the retrieved schema.
            // Or if the `formData` changes, for example in the case of a schema with dependencies that need to
            //  match one of the subSchemas, the retrieved schema must be updated.
            isSchemaChanged || isFormDataChanged ? undefined : this.state.retrievedSchema, isSchemaChanged, formDataChangedFields, // Skip live validation for this request if no form data has changed from the last state
            !isStateDataChanged);
            const shouldUpdate = !(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(nextState, prevState);
            return {
                nextState: nextState,
                shouldUpdate: shouldUpdate
            };
        }
        return {
            shouldUpdate: false
        };
    }
    /**
     * `componentDidUpdate` is a React lifecycle method that is invoked immediately after updating occurs. This method is
     * not called for the initial render.
     *
     * Here, it checks if an update is necessary based on the `shouldUpdate` flag received from `getSnapshotBeforeUpdate`.
     * If an update is required, it applies the next state and, if needed, triggers the `onChange` handler to inform about
     * changes.
     *
     * @param _ - The previous set of props.
     * @param prevState - The previous state of the component before the update.
     * @param snapshot - The value returned from `getSnapshotBeforeUpdate`.
     */ componentDidUpdate(_, prevState, snapshot) {
        if (snapshot.shouldUpdate) {
            const { nextState: nextState } = snapshot;
            // Prevent oneOf/anyOf option switches from reverting when getStateFromProps
            // re-evaluates and produces stale formData.
            const nextStateDiffersFromProps = !(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(nextState.formData, this.props.formData);
            const wasProcessingUserChange = this.isProcessingUserChange;
            this.isProcessingUserChange = false;
            if (wasProcessingUserChange && nextStateDiffersFromProps) // Skip - the user's option switch is already applied via processPendingChange
            return;
            if (nextStateDiffersFromProps && !(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(nextState.formData, prevState.formData) && this.props.onChange) this.props.onChange($3a1888fa7e14f86a$var$toIChangeEvent(nextState));
            // oxlint-disable-next-line react/no-did-update-set-state -- guarded to prevent infinite loop
            this.setState(nextState);
        }
    }
    /** Extracts the updated state from the given `props` and `inputFormData`. As part of this process, the
     * `inputFormData` is first processed to add any missing required defaults. After that, the data is run through the
     * validation process IF required by the `props`.
     *
     * @param props - The props passed to the `Form`
     * @param inputFormData - The new or current data for the `Form`
     * @param retrievedSchema - An expanded schema, if not provided, it will be retrieved from the `schema` and `formData`.
     * @param [isSchemaChanged=false] - A flag indicating whether the schema has changed.
     * @param [formDataChangedFields=[]] - The changed fields of `formData`
     * @param [skipLiveValidate=false] - Optional flag, if true, means that we are not running live validation
     * @param [shouldSanitize=false] - Optional flag, if true, means that we should attempt to sanitize formData
     * @returns - The new state for the `Form`
     */ getStateFromProps(props, inputFormData, retrievedSchema, isSchemaChanged = false, formDataChangedFields = [], skipLiveValidate = false, shouldSanitize = false) {
        const state = this.state || {};
        const schema = 'schema' in props ? props.schema : this.props.schema;
        const validator = 'validator' in props ? props.validator : this.props.validator;
        const uiSchema = ('uiSchema' in props ? props.uiSchema : this.props.uiSchema) || {};
        const isUncontrolled = props.formData === undefined && this.props.formData === undefined;
        const edit = typeof inputFormData !== 'undefined';
        const liveValidate = 'liveValidate' in props ? props.liveValidate : this.props.liveValidate;
        // oxlint-disable-next-line typescript/no-deprecated
        const mustValidate = edit && !props.noValidate && liveValidate;
        const experimental_defaultFormStateBehavior = 'experimental_defaultFormStateBehavior' in props ? props.experimental_defaultFormStateBehavior : this.props.experimental_defaultFormStateBehavior;
        const experimental_customMergeAllOf = 'experimental_customMergeAllOf' in props ? props.experimental_customMergeAllOf : this.props.experimental_customMergeAllOf;
        let { schemaUtils: schemaUtils } = state;
        if (!schemaUtils || schemaUtils.doesSchemaUtilsDiffer(validator, schema, experimental_defaultFormStateBehavior, experimental_customMergeAllOf)) schemaUtils = (0, $d42360923ae67b3f$export$2e2bcd8739ae039)(validator, schema, experimental_defaultFormStateBehavior, experimental_customMergeAllOf);
        const rootSchema = schemaUtils.getRootSchema();
        // Compute the formData for getDefaultFormState() function based on the inputFormData, isUncontrolled and state
        let defaultsFormData = inputFormData;
        if (inputFormData === (0, $9c6fb2049cbb4fc1$export$fad84d7d29d2c2bf)) defaultsFormData = undefined;
        else if (inputFormData === undefined && isUncontrolled) defaultsFormData = state.formData;
        let formData;
        let computedRetrievedSchema;
        let wasSanitized = false;
        const preventInfiniteSanitize = [];
        do {
            formData = schemaUtils.getDefaultFormState(rootSchema, defaultsFormData, false, state.initialDefaultsGenerated);
            // Only hash when sanitizing, wrapping `formData` in an object to deal with a scalar/undefined value
            const formHash = shouldSanitize ? (0, $e3ea314528e97c6e$export$3477f9615e12f61d)({
                formData: formData
            }) : '';
            computedRetrievedSchema = this.updateRetrievedSchema(retrievedSchema ?? schemaUtils.retrieveSchema(rootSchema, formData));
            if (shouldSanitize && !preventInfiniteSanitize.includes(formHash) && !(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(computedRetrievedSchema, state.retrievedSchema)) {
                // Sanitize the form data if shouldSanitize is true, we haven't already processed this same formData AND
                // we have a different retrieved schema from when we last ran the state
                const sanitizedFormData = schemaUtils.sanitizeDataForNewSchema(computedRetrievedSchema, state.retrievedSchema, formData);
                wasSanitized = !(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(sanitizedFormData, formData);
                if (wasSanitized) {
                    // Update both the formData AND defaultsFormData due to the sanitize so the loop works with the new data
                    formData = sanitizedFormData;
                    defaultsFormData = sanitizedFormData;
                    const sanitizedFormHash = (0, $e3ea314528e97c6e$export$3477f9615e12f61d)({
                        formData: sanitizedFormData
                    });
                    // If we've seen the sanitized data before, we are done
                    wasSanitized = !preventInfiniteSanitize.includes(sanitizedFormHash);
                    preventInfiniteSanitize.push(sanitizedFormHash);
                }
                preventInfiniteSanitize.push(formHash);
            } else wasSanitized = false;
        }while (wasSanitized);
        const getCurrentErrors = ()=>{
            // If the `props.noValidate` option is set or the schema has changed, we reset the error state.
            // oxlint-disable-next-line typescript/no-deprecated
            if (props.noValidate || isSchemaChanged) return {
                errors: [],
                errorSchema: {}
            };
            if (!props.liveValidate) return {
                errors: state.schemaValidationErrors || [],
                errorSchema: state.schemaValidationErrorSchema || {}
            };
            return {
                errors: state.errors || [],
                errorSchema: state.errorSchema || {}
            };
        };
        let errors;
        let errorSchema;
        let { schemaValidationErrors: schemaValidationErrors, schemaValidationErrorSchema: schemaValidationErrorSchema } = state;
        // If we are skipping live validate, it means that the state has already been updated with live validation errors
        if (mustValidate && !skipLiveValidate) {
            const liveValidation = this.liveValidate(rootSchema, schemaUtils, state.errorSchema, formData, undefined, state.customErrors, retrievedSchema, // If retrievedSchema is undefined which means the schema or formData has changed, we do not merge state.
            // Else in the case where it hasn't changed,
            retrievedSchema !== undefined);
            errors = liveValidation.errors;
            errorSchema = liveValidation.errorSchema;
            schemaValidationErrors = liveValidation.schemaValidationErrors;
            schemaValidationErrorSchema = liveValidation.schemaValidationErrorSchema;
        } else {
            const currentErrors = getCurrentErrors();
            errors = currentErrors.errors;
            errorSchema = currentErrors.errorSchema;
            // We only update the error schema for changed fields if mustValidate is false
            if (formDataChangedFields.length > 0 && !mustValidate) {
                const newErrorSchema = formDataChangedFields.reduce((acc, key)=>{
                    acc[key] = undefined;
                    return acc;
                }, {});
                schemaValidationErrorSchema = (0, $4ab7d05f28605536$export$2e2bcd8739ae039)(currentErrors.errorSchema, newErrorSchema, 'preventDuplicates');
                errorSchema = schemaValidationErrorSchema;
            }
            const mergedErrors = $3a1888fa7e14f86a$export$2e2bcd8739ae039.mergeErrors({
                errorSchema: errorSchema,
                errors: errors
            }, props.extraErrors, state.customErrors);
            errors = mergedErrors.errors;
            errorSchema = mergedErrors.errorSchema;
        }
        // Only store a new registry when the props cause a different one to be created
        const newRegistry = $3a1888fa7e14f86a$export$2e2bcd8739ae039.getRegistry(props, rootSchema, schemaUtils);
        const registry = (0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(state.registry, newRegistry) ? state.registry : newRegistry;
        // Only compute a new `fieldPathId` when the `idPrefix` is different than the existing fieldPathId's ID_KEY
        const fieldPathId = state.fieldPathId && state.fieldPathId?.[0, $cd207018ee28cb28$export$f453fd324e92d331] === registry.globalFormOptions.idPrefix ? state.fieldPathId : (0, $99206247aba21705$export$2e2bcd8739ae039)('', registry.globalFormOptions);
        const nextState = {
            schemaUtils: schemaUtils,
            schema: rootSchema,
            uiSchema: uiSchema,
            fieldPathId: fieldPathId,
            formData: formData,
            edit: edit,
            errors: errors,
            errorSchema: errorSchema,
            schemaValidationErrors: schemaValidationErrors,
            schemaValidationErrorSchema: schemaValidationErrorSchema,
            retrievedSchema: computedRetrievedSchema,
            initialDefaultsGenerated: true,
            registry: registry
        };
        return nextState;
    }
    /** React lifecycle method that is used to determine whether component should be updated.
     *
     * @param nextProps - The next version of the props
     * @param nextState - The next version of the state
     * @returns - True if the component should be updated, false otherwise
     */ shouldComponentUpdate(nextProps, nextState) {
        const { experimental_componentUpdateStrategy: experimental_componentUpdateStrategy = 'customDeep' } = this.props;
        return (0, $10381dd8d10816d4$export$2e2bcd8739ae039)(this, nextProps, nextState, experimental_componentUpdateStrategy);
    }
    /** Validates the `formData` against the `schema` using the `altSchemaUtils` (if provided otherwise it uses the
     * `schemaUtils` in the state), returning the results.
     *
     * @param formData - The new form data to validate
     * @param schema - The schema used to validate against
     * @param [altSchemaUtils] - The alternate schemaUtils to use for validation
     * @param [retrievedSchema] - An optionally retrieved schema for per
     */ validate(formData, schema = this.state.schema, altSchemaUtils, retrievedSchema) {
        const schemaUtils = altSchemaUtils || this.state.schemaUtils;
        const { customValidate: customValidate, transformErrors: transformErrors, uiSchema: uiSchema } = this.props;
        // When a pre-resolved schema is provided (e.g., from live validation), use it directly.
        // Otherwise validate against the original schema so AJV sees the full constraint set.
        const validationSchema = retrievedSchema ?? schema;
        return schemaUtils.getValidator().validateFormData(formData, validationSchema, customValidate, transformErrors, uiSchema);
    }
    /** Renders any errors contained in the `state` in using the `ErrorList`, if not disabled by `showErrorList`. */ renderErrors(registry) {
        const { errors: errors, errorSchema: errorSchema, schema: schema, uiSchema: uiSchema } = this.state;
        const options = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
        const ErrorListTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('ErrorListTemplate', registry, options);
        if (errors && errors.length) return (0, $2e41620b030ed79e$exports.jsx)(ErrorListTemplate, {
            errors: errors,
            errorSchema: errorSchema || {},
            schema: schema,
            uiSchema: uiSchema,
            registry: registry
        });
        return null;
    }
    /** Merges any `extraErrors` or `customErrors` into the given `schemaValidation` object, returning the result
     *
     * @param schemaValidation - The `ValidationData` object into which additional errors are merged
     * @param [extraErrors] - The extra errors from the props
     * @param [customErrors] - The customErrors from custom components
     * @return - The `extraErrors` and `customErrors` merged into the `schemaValidation`
     * @private
     */ static mergeErrors(schemaValidation, extraErrors, customErrors) {
        let { errorSchema: errorSchema, errors: errors } = schemaValidation;
        if (extraErrors) {
            const merged = (0, $f4a48b11a54dcb84$export$2e2bcd8739ae039)(schemaValidation, extraErrors);
            errorSchema = merged.errorSchema;
            errors = merged.errors;
        }
        if (customErrors) {
            const merged = (0, $f4a48b11a54dcb84$export$2e2bcd8739ae039)({
                errors: errors,
                errorSchema: errorSchema
            }, customErrors.ErrorSchema, true);
            errorSchema = merged.errorSchema;
            errors = merged.errors;
        }
        return {
            errors: errors,
            errorSchema: errorSchema
        };
    }
    /** Performs live validation and then updates and returns the errors and error schemas by potentially merging in
     * `extraErrors` and `customErrors`.
     *
     * @param rootSchema - The `rootSchema` from the state
     * @param schemaUtils - The `SchemaUtilsType` from the state
     * @param originalErrorSchema - The original `ErrorSchema` from the state
     * @param [formData] - The new form data to validate
     * @param [extraErrors] - The extra errors from the props
     * @param [customErrors] - The customErrors from custom components
     * @param [retrievedSchema] - An expanded schema, if not provided, it will be retrieved from the `schema` and `formData`
     * @param [mergeIntoOriginalErrorSchema=false] - Optional flag indicating whether we merge into original schema
     * @returns - An object containing `errorSchema`, `errors`, `schemaValidationErrors` and `schemaValidationErrorSchema`
     * @private
     */ liveValidate(rootSchema, schemaUtils, originalErrorSchema, formData, extraErrors, customErrors, retrievedSchema, mergeIntoOriginalErrorSchema = false) {
        const schemaValidation = this.validate(formData, rootSchema, schemaUtils, retrievedSchema);
        const { errors: errors } = schemaValidation;
        let { errorSchema: errorSchema } = schemaValidation;
        // We merge 'originalErrorSchema' with 'schemaValidation.errorSchema.'; This done to display the raised field error.
        if (mergeIntoOriginalErrorSchema) errorSchema = (0, $4ab7d05f28605536$export$2e2bcd8739ae039)(originalErrorSchema, schemaValidation.errorSchema, 'preventDuplicates');
        const schemaValidationErrors = errors;
        const schemaValidationErrorSchema = errorSchema;
        const mergedErrors = $3a1888fa7e14f86a$export$2e2bcd8739ae039.mergeErrors({
            errorSchema: errorSchema,
            errors: errors
        }, extraErrors, customErrors);
        return {
            ...mergedErrors,
            schemaValidationErrors: schemaValidationErrors,
            schemaValidationErrorSchema: schemaValidationErrorSchema
        };
    }
    /** Returns the `formData` with only the elements specified in the `fields` list
     *
     * @param formData - The data for the `Form`
     * @param fields - The fields to keep while filtering
     * @deprecated - To be removed as an exported `Form` function in a future release; there isn't a planned replacement
     */ // oxlint-disable-next-line class-methods-use-this, typescript/no-deprecated
    getUsedFormData = (formData, fields)=>(0, $e7d329486831c49a$export$ac9347ddfe1a1735)(formData, fields);
    /** Returns the list of field names from inspecting the `pathSchema` as well as using the `formData`
     *
     * @param pathSchema - The `PathSchema` object for the form
     * @param [formData] - The form data to use while checking for empty objects/arrays
     * @deprecated - To be removed as an exported `Form` function in a future release; there isn't a planned replacement
     */ // oxlint-disable-next-line class-methods-use-this, typescript/no-deprecated
    getFieldNames = (pathSchema, formData)=>(0, $e7d329486831c49a$export$d814fe1c0e81ab0f)(pathSchema, formData);
    /** Returns the `formData` after filtering to remove any extra data not in a form field
     *
     * @param formData - The data for the `Form`
     * @returns The `formData` after omitting extra data
     * @deprecated - To be removed as an exported `Form` function in a future release, use `SchemaUtils.omitExtraData`
     *               instead.
     */ omitExtraData = (formData)=>{
        const { schema: schema, schemaUtils: schemaUtils } = this.state;
        return schemaUtils.omitExtraData(schema, formData);
    };
    /** Allows a user to set a value for the provided `fieldPath`, which must be either a dotted path to the field OR a
     * `FieldPathList`. To set the root element, used either `''` or `[]` for the path. Passing undefined will clear the
     * value in the field.
     *
     * @param fieldPath - Either a dotted path to the field or the `FieldPathList` to the field
     * @param [newValue] - The new value for the field
     */ setFieldValue = (fieldPath, newValue)=>{
        const { registry: registry } = this.state;
        const path = Array.isArray(fieldPath) ? fieldPath : fieldPath.split('.');
        const fieldPathId = (0, $99206247aba21705$export$2e2bcd8739ae039)('', registry.globalFormOptions, path);
        this.onChange(newValue, path, undefined, fieldPathId[0, $cd207018ee28cb28$export$f453fd324e92d331]);
    };
    /** Pushes the given change information into the `pendingChanges` array and then calls `processPendingChanges()` if
     * the array only contains a single pending change.
     *
     * @param newValue - The new form data from a change to a field
     * @param path - The path to the change into which to set the formData
     * @param [newErrorSchema] - The new `ErrorSchema` based on the field change
     * @param [id] - The id of the field that caused the change
     */ onChange = (newValue, path, newErrorSchema, id)=>{
        this.pendingChanges.push({
            newValue: newValue,
            path: path,
            newErrorSchema: newErrorSchema,
            id: id
        });
        if (this.pendingChanges.length === 1) this.processPendingChange();
    };
    /** Function to handle changes made to a field in the `Form`. This handler gets the first change from the
     * `pendingChanges` list, containing the `newValue` for the `formData` and the `path` at which the `newValue` is to be
     * updated, along with a new, optional `ErrorSchema` for that same `path` and potentially the `id` of the field being
     * changed. It will first update the `formData` with any missing default fields and then, if `omitExtraData` and
     * `liveOmit` are turned on, the `formData` will be filtered to remove any extra data not in a form field. Then, the
     * resulting `formData` will be validated if required. The state will be updated with the new updated (potentially
     * filtered) `formData`, any errors that resulted from validation. Finally the `onChange` callback will be called, if
     * specified, with the updated state and the `processPendingChange()` function is called again.
     */ processPendingChange() {
        if (this.pendingChanges.length === 0) return;
        // Mark that we're processing a user-initiated change.
        // This prevents componentDidUpdate from reverting oneOf/anyOf option switches.
        this.isProcessingUserChange = true;
        const { newValue: newValue, path: path, id: id } = this.pendingChanges[0];
        const { newErrorSchema: newErrorSchema } = this.pendingChanges[0];
        // oxlint-disable-next-line typescript/no-deprecated
        const { extraErrors: extraErrors, omitExtraData: omitExtraData, liveOmit: liveOmit, noValidate: noValidate, liveValidate: liveValidate, onChange: onChange, disabled: disabled, readonly: readonly } = this.props;
        const { formData: oldFormData, schemaUtils: schemaUtils, schema: schema, fieldPathId: fieldPathId, schemaValidationErrorSchema: schemaValidationErrorSchema, errors: errors } = this.state;
        let { customErrors: customErrors, retrievedSchema: retrievedSchema } = this.state;
        // Use the un-merged AJV-only schema as the base for re-merging extraErrors. Mirrors the
        // pattern in getStateFromProps/getDerivedStateFromProps and avoids the duplication that
        // happened when state.errorSchema (already containing merged extraErrors) was passed in.
        let mergeBaseErrorSchema = schemaValidationErrorSchema;
        const rootPathId = fieldPathId.path[0] || '';
        const isRootPath = !path || path.length === 0 || path.length === 1 && path[0] === rootPathId;
        let formData = isRootPath ? newValue : (0, $7e874283d83390fb$export$2e2bcd8739ae039)(oldFormData);
        // When switching from null to an object option in oneOf, MultiSchemaField sends
        // an object with property names but undefined values (e.g., {types: undefined, content: undefined}).
        // In this case, pass undefined to getStateFromProps to trigger fresh default computation.
        // Only do this when the previous formData was null/undefined (switching FROM null).
        const hasOnlyUndefinedValues = (0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(formData) && Object.keys(formData).length > 0 && Object.values(formData).every((v)=>v === undefined);
        const wasPreviouslyNull = oldFormData === null || oldFormData === undefined;
        const inputForDefaults = hasOnlyUndefinedValues && wasPreviouslyNull ? undefined : formData;
        if ((0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(formData) || Array.isArray(formData)) {
            if (newValue === (0, $9c6fb2049cbb4fc1$export$bccc68d61c860794)) // For additional properties, we were given the special remove this key value, so unset it
            (0, $de2a4d120b14799d$export$2e2bcd8739ae039)(formData, path);
            else if (!isRootPath) {
                // If the newValue is not on the root path, then set it into the form data
                let unsetPath = false;
                let valueForPath = newValue;
                if (newValue === undefined) {
                    const lastSegment = path[path.length - 1];
                    if (typeof lastSegment === 'number') // Array items: match ArrayField `handleChange` — AJV needs `null`, not undefined.
                    valueForPath = null;
                    else {
                        const { field: field } = schemaUtils.findFieldInSchema(schema, path, oldFormData);
                        const leaf = field;
                        const isOneOfOrAnyOfLeaf = leaf && ((0, $cd207018ee28cb28$export$c24c2c38af9a39c3) in leaf || (0, $cd207018ee28cb28$export$2014f14bbe7357bd) in leaf);
                        // Plain leaves: omit the key instead of `{ key: undefined }`, which breaks `type: "string"` validation in
                        // AJV after clearing a text input (https://github.com/rjsf-team/react-jsonschema-form/issues/4518).
                        // oneOf/anyOf leaves and unresolved leaves: keep `valueForPath === newValue` (already `undefined`) so
                        // mergeDefaults does not immediately re-apply a branch default when clearing those widgets.
                        if (!isOneOfOrAnyOfLeaf && leaf !== undefined) unsetPath = true;
                    }
                }
                if (unsetPath) (0, $de2a4d120b14799d$export$2e2bcd8739ae039)(formData, path);
                else (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(formData, path, valueForPath);
            }
            const shouldSanitize = retrievedSchema && !isRootPath && !(0, $a94aaa2913b539bc$export$2e2bcd8739ae039)(newValue) && !Array.isArray(newValue) && !disabled && !readonly;
            // Pass true to skip live validation in `getStateFromProps()` since we will do it a bit later
            const newState = this.getStateFromProps(this.props, inputForDefaults, undefined, undefined, undefined, true, shouldSanitize);
            formData = newState.formData;
            retrievedSchema = newState.retrievedSchema;
        }
        const mustValidate = !noValidate && (liveValidate === true || liveValidate === 'onChange');
        let state = {
            formData: formData,
            retrievedSchema: retrievedSchema
        };
        let newFormData = formData;
        if (omitExtraData === true && (liveOmit === true || liveOmit === 'onChange')) {
            // oxlint-disable-next-line typescript/no-deprecated
            newFormData = this.omitExtraData(formData);
            state = {
                ...state,
                formData: newFormData
            };
        }
        if (newErrorSchema) {
            // First check to see if there is an existing validation error on this path...
            // @ts-expect-error TS2590, because getting from the error schema is confusing TS
            const oldValidationError = !isRootPath ? (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(schemaValidationErrorSchema, path) : schemaValidationErrorSchema;
            // If there is an old validation error for this path, assume we are updating it directly
            if (!(0, $1fe6d5766df4f45f$export$2e2bcd8739ae039)(oldValidationError)) {
                // Apply the user-supplied newErrorSchema onto a clone of the AJV-only base, so that
                // mergeErrors below sees the user's error at this path without mutating shared state.
                if (!isRootPath) {
                    mergeBaseErrorSchema = (0, $7e874283d83390fb$export$2e2bcd8739ae039)(schemaValidationErrorSchema);
                    (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(mergeBaseErrorSchema, path, newErrorSchema);
                } else mergeBaseErrorSchema = newErrorSchema;
            } else {
                if (!customErrors) customErrors = new (0, $ca490662d9a1e5b4$export$2e2bcd8739ae039)();
                if (isRootPath) {
                    const pathErrors = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(newErrorSchema, (0, $cd207018ee28cb28$export$36fec1b8ab257149));
                    if (pathErrors) // only set errors when there are some
                    customErrors.setErrors(pathErrors);
                } else (0, $c78fa5e9588d54fe$export$2e2bcd8739ae039)(customErrors.ErrorSchema, path, newErrorSchema);
            }
        } else if (customErrors && (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(customErrors.ErrorSchema, [
            ...path,
            (0, $cd207018ee28cb28$export$36fec1b8ab257149)
        ])) // If we have custom errors and the path has an error, then we need to clear it
        customErrors.clearErrors(path);
        // If there are pending changes in the queue, skip live validation since it will happen with the last change
        if (mustValidate && this.pendingChanges.length === 1) {
            const liveValidation = this.liveValidate(schema, schemaUtils, mergeBaseErrorSchema, newFormData, extraErrors, customErrors, retrievedSchema);
            state = {
                ...state,
                formData: newFormData,
                ...liveValidation,
                customErrors: customErrors
            };
        } else if (!noValidate && newErrorSchema) {
            // Merging 'newErrorSchema' into 'errorSchema' to display the custom raised errors.
            const mergedErrors = $3a1888fa7e14f86a$export$2e2bcd8739ae039.mergeErrors({
                errorSchema: mergeBaseErrorSchema,
                errors: errors
            }, extraErrors, customErrors);
            state = {
                ...state,
                formData: newFormData,
                ...mergedErrors,
                customErrors: customErrors
            };
        }
        this.setState(state, ()=>{
            if (onChange) onChange($3a1888fa7e14f86a$var$toIChangeEvent({
                ...this.state,
                ...state
            }), id);
            // Now remove the change we just completed and call this again
            this.pendingChanges.shift();
            this.processPendingChange();
        });
    }
    /**
     * If the retrievedSchema has changed the new retrievedSchema is returned.
     * Otherwise, the old retrievedSchema is returned to persist reference.
     * -  This ensures that AJV retrieves the schema from the cache when it has not changed,
     *    avoiding the performance cost of recompiling the schema.
     *
     * @param retrievedSchema The new retrieved schema.
     * @returns The new retrieved schema if it has changed, else the old retrieved schema.
     */ updateRetrievedSchema(retrievedSchema) {
        const isTheSame = (0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(retrievedSchema, this.state?.retrievedSchema);
        return isTheSame ? this.state.retrievedSchema : retrievedSchema;
    }
    /**
     * Callback function to handle reset form data.
     * - Reset all fields with default values.
     * - Reset validations and errors
     *
     */ reset = ()=>{
        // Cast the IS_RESET symbol to T to avoid type issues, we use this symbol to detect reset mode
        const { formData: propsFormData, initialFormData: initialFormData = (0, $9c6fb2049cbb4fc1$export$fad84d7d29d2c2bf), onChange: onChange } = this.props;
        const newState = this.getStateFromProps(this.props, propsFormData ?? initialFormData, undefined, undefined, undefined, true);
        const newFormData = newState.formData;
        const state = {
            formData: newFormData,
            errorSchema: {},
            errors: [],
            schemaValidationErrors: [],
            schemaValidationErrorSchema: {},
            initialDefaultsGenerated: false,
            customErrors: undefined
        };
        this.setState(state, ()=>onChange && onChange($3a1888fa7e14f86a$var$toIChangeEvent({
                ...this.state,
                ...state
            })));
    };
    /** Callback function to handle when a field on the form is blurred. Calls the `onBlur` callback for the `Form` if it
     * was provided. Also runs any live validation and/or live omit operations if the flags indicate they should happen
     * during `onBlur`.
     *
     * @param id - The unique `id` of the field that was blurred
     * @param data - The data associated with the field that was blurred
     */ onBlur = (id, data)=>{
        const { onBlur: onBlur, omitExtraData: omitExtraData, liveOmit: liveOmit, liveValidate: liveValidate } = this.props;
        if (onBlur) onBlur(id, data);
        if (omitExtraData === true && liveOmit === 'onBlur' || liveValidate === 'onBlur') {
            const { onChange: onChange, extraErrors: extraErrors } = this.props;
            const { formData: formData } = this.state;
            let newFormData = formData;
            let state = {
                formData: newFormData
            };
            if (omitExtraData === true && liveOmit === 'onBlur') {
                // oxlint-disable-next-line typescript/no-deprecated
                newFormData = this.omitExtraData(formData);
                state = {
                    formData: newFormData
                };
            }
            if (liveValidate === 'onBlur') {
                const { schema: schema, schemaUtils: schemaUtils, errorSchema: errorSchema, customErrors: customErrors, retrievedSchema: retrievedSchema } = this.state;
                const liveValidation = this.liveValidate(schema, schemaUtils, errorSchema, newFormData, extraErrors, customErrors, retrievedSchema);
                state = {
                    formData: newFormData,
                    ...liveValidation,
                    customErrors: customErrors
                };
            }
            const hasChanges = Object.keys(state)// Filter out `schemaValidationErrors` and `schemaValidationErrorSchema` since they aren't IChangeEvent props
            .filter((key)=>!key.startsWith('schemaValidation')).some((key)=>{
                const oldData = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(this.state, key);
                const newData = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(state, key);
                return !(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(oldData, newData);
            });
            this.setState(state, ()=>{
                if (onChange && hasChanges) onChange($3a1888fa7e14f86a$var$toIChangeEvent({
                    ...this.state,
                    ...state
                }), id);
            });
        }
    };
    /** Callback function to handle when a field on the form is focused. Calls the `onFocus` callback for the `Form` if it
     * was provided.
     *
     * @param id - The unique `id` of the field that was focused
     * @param data - The data associated with the field that was focused
     */ onFocus = (id, data)=>{
        const { onFocus: onFocus } = this.props;
        if (onFocus) onFocus(id, data);
    };
    /** Callback function to handle when the form is submitted. First, it prevents the default event behavior. Nothing
     * happens if the target and currentTarget of the event are not the same. It will omit any extra data in the
     * `formData` in the state if `omitExtraData` is true. It will validate the resulting `formData`, reporting errors
     * via the `onError()` callback unless validation is disabled. Finally, it will add in any `extraErrors` and then call
     * back the `onSubmit` callback if it was provided.
     *
     * @param event - The submit HTML form event
     */ onSubmit = (event)=>{
        event.preventDefault();
        if (event.target !== event.currentTarget) return;
        event.persist();
        // oxlint-disable-next-line typescript/no-deprecated
        const { omitExtraData: omitExtraData, extraErrors: extraErrors, noValidate: noValidate, onSubmit: onSubmit } = this.props;
        let { formData: newFormData } = this.state;
        if (omitExtraData === true) // oxlint-disable-next-line typescript/no-deprecated
        newFormData = this.omitExtraData(newFormData);
        if (noValidate || this.validateFormWithFormData(newFormData)) {
            // There are no errors generated through schema validation.
            // Check for user provided errors and update state accordingly.
            const errorSchema = extraErrors || {};
            const errors = extraErrors ? (0, $23daf1e084ef378b$export$2e2bcd8739ae039)(extraErrors) : [];
            this.setState({
                formData: newFormData,
                errors: errors,
                errorSchema: errorSchema,
                schemaValidationErrors: [],
                schemaValidationErrorSchema: {}
            }, ()=>{
                if (onSubmit) onSubmit($3a1888fa7e14f86a$var$toIChangeEvent({
                    ...this.state,
                    formData: newFormData
                }, 'submitted'), event);
            });
        }
    };
    /** Extracts the `GlobalFormOptions` from the given Form `props`
     *
     * @param props - The form props to extract the global form options from
     * @returns - The `GlobalFormOptions` from the props
     * @private
     */ static getGlobalFormOptions(props) {
        const { uiSchema: uiSchema = {}, experimental_componentUpdateStrategy: experimental_componentUpdateStrategy, idSeparator: idSeparator = (0, $cd207018ee28cb28$export$cd88b6b1f03afce9), idPrefix: idPrefix = (0, $cd207018ee28cb28$export$fc1a2685f60ab9ef), nameGenerator: nameGenerator, useFallbackUiForUnsupportedType: useFallbackUiForUnsupportedType = false } = props;
        // oxlint-disable-next-line typescript/no-deprecated
        const rootFieldId = uiSchema['ui:rootFieldId'];
        // Omit any options that are undefined or null
        return {
            idPrefix: rootFieldId || idPrefix,
            idSeparator: idSeparator,
            useFallbackUiForUnsupportedType: useFallbackUiForUnsupportedType,
            ...experimental_componentUpdateStrategy !== undefined && {
                experimental_componentUpdateStrategy: experimental_componentUpdateStrategy
            },
            ...nameGenerator !== undefined && {
                nameGenerator: nameGenerator
            }
        };
    }
    /** Computed the registry for the form using the given `props`, `schema` and `schemaUtils` */ static getRegistry(props, schema, schemaUtils) {
        const { translateString: customTranslateString, uiSchema: uiSchema = {} } = props;
        const { fields: fields, templates: templates, widgets: widgets, formContext: formContext, translateString: translateString } = (0, $6785543bf8584407$export$2e2bcd8739ae039)();
        return {
            fields: {
                ...fields,
                ...props.fields
            },
            templates: {
                ...templates,
                ...props.templates,
                ButtonTemplates: {
                    ...templates.ButtonTemplates,
                    ...props.templates?.ButtonTemplates
                }
            },
            widgets: {
                ...widgets,
                ...props.widgets
            },
            rootSchema: schema,
            formContext: props.formContext || formContext,
            schemaUtils: schemaUtils,
            translateString: customTranslateString || translateString,
            globalUiOptions: uiSchema[0, $cd207018ee28cb28$export$c777bab3d600699],
            globalFormOptions: $3a1888fa7e14f86a$export$2e2bcd8739ae039.getGlobalFormOptions(props),
            uiSchemaDefinitions: uiSchema[0, $cd207018ee28cb28$export$22333fc592b2ecf6] ?? {}
        };
    }
    /** Provides a function that can be used to programmatically submit the `Form` */ submit = ()=>{
        if (this.formElement.current) {
            const submitCustomEvent = new CustomEvent('submit', {
                cancelable: true
            });
            submitCustomEvent.preventDefault();
            this.formElement.current.dispatchEvent(submitCustomEvent);
            this.formElement.current.requestSubmit();
        }
    };
    /** Attempts to focus on the field associated with the `error`. Uses the `property` field to compute path of the error
     * field, then, using the `idPrefix` and `idSeparator` converts that path into an id. Then the input element with that
     * id is attempted to be found using the `formElement` ref. If it is located, then it is focused.
     *
     * @param error - The error on which to focus
     */ focusOnError(error) {
        const { idPrefix: idPrefix = 'root', idSeparator: idSeparator = '_' } = this.props;
        const { property: property } = error;
        const path = (0, $e0a9f91a59ab06d5$export$2e2bcd8739ae039)(property);
        if (path[0] === '') // Most of the time the `.foo` property results in the first element being empty, so replace it with the idPrefix
        path[0] = idPrefix;
        else // Otherwise insert the idPrefix into the first location using unshift
        path.unshift(idPrefix);
        const elementId = path.join(idSeparator);
        let field = this.formElement.current.elements[elementId];
        if (!field) // if not an exact match, try finding a focusable element starting with the element id (like radio buttons or checkboxes)
        // some themes (e.g. shadcn) use button elements instead of native inputs for radio groups
        field = this.formElement.current.querySelector(`input[id^="${elementId}"], button[id^="${elementId}"]`);
        if (field && field.length) // If we got a list with length > 0
        // oxlint-disable-next-line prefer-destructuring
        field = field[0];
        if (field) field.focus();
    }
    /** Validates the form using the given `formData`. For use on form submission or on programmatic validation.
     * If `onError` is provided, then it will be called with the list of errors.
     *
     * @param formData - The form data to validate
     * @returns - True if the form is valid, false otherwise.
     */ validateFormWithFormData = (formData)=>{
        const { extraErrors: extraErrors, extraErrorsBlockSubmit: extraErrorsBlockSubmit, focusOnFirstError: focusOnFirstError, onError: onError } = this.props;
        const { errors: prevErrors } = this.state;
        const schemaValidation = this.validate(formData);
        // Always merge extraErrors so they remain visible in state regardless of extraErrorsBlockSubmit.
        const { errors: errors, errorSchema: errorSchema } = extraErrors ? $3a1888fa7e14f86a$export$2e2bcd8739ae039.mergeErrors(schemaValidation, extraErrors) : schemaValidation;
        // hasError gates submission: schema errors always block; extraErrors only block when
        // extraErrorsBlockSubmit is set (non-breaking default: extraErrors are informational only).
        const hasError = schemaValidation.errors.length > 0 || extraErrors && extraErrorsBlockSubmit;
        if (hasError) {
            if (focusOnFirstError) {
                if (typeof focusOnFirstError === 'function') focusOnFirstError(errors[0]);
                else this.focusOnError(errors[0]);
            }
            this.setState({
                errors: errors,
                errorSchema: errorSchema,
                schemaValidationErrors: schemaValidation.errors,
                schemaValidationErrorSchema: schemaValidation.errorSchema
            }, ()=>{
                if (onError) onError(errors);
                else // oxlint-disable-next-line no-console
                console.error('Form validation failed', errors);
            });
        } else if (errors.length > 0) // Non-blocking extraErrors are present — update display state without triggering onError.
        this.setState({
            errors: errors,
            errorSchema: errorSchema,
            schemaValidationErrors: [],
            schemaValidationErrorSchema: {}
        });
        else if (prevErrors.length > 0) this.setState({
            errors: [],
            errorSchema: {},
            schemaValidationErrors: [],
            schemaValidationErrorSchema: {}
        });
        return !hasError;
    };
    /** Programmatically validate the form.  If `omitExtraData` is true, the `formData` will first be filtered to remove
     * any extra data not in a form field. If `onError` is provided, then it will be called with the list of errors the
     * same way as would happen on form submission.
     *
     * @returns - True if the form is valid, false otherwise.
     */ validateForm() {
        const { omitExtraData: omitExtraData } = this.props;
        let { formData: newFormData } = this.state;
        if (omitExtraData === true) // oxlint-disable-next-line typescript/no-deprecated
        newFormData = this.omitExtraData(newFormData);
        return this.validateFormWithFormData(newFormData);
    }
    /** Renders the `Form` fields inside the <form> | `tagName` or `_internalFormWrapper`, rendering any errors if
     * needed along with the submit button or any children of the form.
     */ render() {
        const { children: children, id: id, className: className = '', tagName: tagName, name: name, method: method, target: target, action: action, autoComplete: autoComplete, enctype: enctype, acceptCharset: acceptCharset, noHtml5Validate: noHtml5Validate = false, disabled: disabled, readonly: readonly, showErrorList: showErrorList = 'top', _internalFormWrapper: _internalFormWrapper } = this.props;
        const { schema: schema, uiSchema: uiSchema, formData: formData, errorSchema: errorSchema, fieldPathId: fieldPathId, registry: registry } = this.state;
        const { SchemaField: SchemaFieldComponent } = registry.fields;
        const { SubmitButton: SubmitButton } = registry.templates.ButtonTemplates;
        // The `semantic-ui` and `material-ui` themes have `_internalFormWrapper`s that take an `as` prop that is the
        // PropTypes.elementType to use for the inner tag, so we'll need to pass `tagName` along if it is provided.
        // NOTE, the `as` prop is native to `semantic-ui` and is emulated in the `material-ui` theme
        const as = _internalFormWrapper ? tagName : undefined;
        const FormTag = _internalFormWrapper || tagName || 'form';
        let { [(0, $cd207018ee28cb28$export$a590c102372d2ff1)]: submitOptions = {} } = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
        if (disabled) submitOptions = {
            ...submitOptions,
            props: {
                ...submitOptions.props,
                disabled: true
            }
        };
        const submitUiSchema = {
            [(0, $cd207018ee28cb28$export$61fb14aaf7aef60f)]: {
                [(0, $cd207018ee28cb28$export$a590c102372d2ff1)]: submitOptions
            }
        };
        return (0, $2e41620b030ed79e$exports.jsxs)(FormTag, {
            className: className || 'rjsf',
            id: id,
            name: name,
            method: method,
            target: target,
            action: action,
            autoComplete: autoComplete,
            encType: enctype,
            acceptCharset: acceptCharset,
            noValidate: noHtml5Validate,
            onSubmit: this.onSubmit,
            as: as,
            ref: this.formElement,
            children: [
                showErrorList === 'top' && this.renderErrors(registry),
                (0, $2e41620b030ed79e$exports.jsx)(SchemaFieldComponent, {
                    name: '',
                    schema: schema,
                    uiSchema: uiSchema,
                    errorSchema: errorSchema,
                    fieldPathId: fieldPathId,
                    formData: formData,
                    onChange: this.onChange,
                    onBlur: this.onBlur,
                    onFocus: this.onFocus,
                    registry: registry,
                    disabled: disabled,
                    readonly: readonly
                }),
                children || (0, $2e41620b030ed79e$exports.jsx)(SubmitButton, {
                    uiSchema: submitUiSchema,
                    registry: registry
                }),
                showErrorList === 'bottom' && this.renderErrors(registry)
            ]
        });
    }
}











function $e621fbfa575ef4f2$export$95cb9b784786bd1c(errorList, suppressDuplicateFiltering = 'none') {
    if (suppressDuplicateFiltering === 'all') return errorList;
    return errorList.reduce((acc, err)=>{
        const { message: message, schemaPath: schemaPath } = err;
        // Compute the index only when filtering for that keyword is not suppressed.
        // 'all' is already handled above; within the reduce, only 'none', 'anyOf', and 'oneOf' are possible.
        const anyOfIndex = suppressDuplicateFiltering !== 'anyOf' ? schemaPath === null || schemaPath === void 0 ? void 0 : schemaPath.indexOf(`/${(0, $cd207018ee28cb28$export$2014f14bbe7357bd)}/`) : undefined;
        const oneOfIndex = suppressDuplicateFiltering !== 'oneOf' ? schemaPath === null || schemaPath === void 0 ? void 0 : schemaPath.indexOf(`/${(0, $cd207018ee28cb28$export$c24c2c38af9a39c3)}/`) : undefined;
        let schemaPrefix;
        if (anyOfIndex && anyOfIndex >= 0) schemaPrefix = schemaPath === null || schemaPath === void 0 ? void 0 : schemaPath.substring(0, anyOfIndex);
        else if (oneOfIndex && oneOfIndex >= 0) schemaPrefix = schemaPath === null || schemaPath === void 0 ? void 0 : schemaPath.substring(0, oneOfIndex);
        // If there is a schemaPrefix, then search for a duplicate message with the same prefix, otherwise undefined
        const dup = schemaPrefix ? acc.find((e)=>{
            var _a;
            return e.message === message && ((_a = e.schemaPath) === null || _a === void 0 ? void 0 : _a.startsWith(schemaPrefix));
        }) : undefined;
        if (!dup) acc.push(err);
        return acc;
    }, []);
}
function $e621fbfa575ef4f2$export$c251c0abfee1cfd(errors = [], uiSchema, suppressDuplicateFiltering) {
    const errorList = errors.map((e)=>{
        var _a;
        const { instancePath: instancePath, keyword: keyword, params: params, schemaPath: schemaPath, parentSchema: parentSchema, ...rest } = e;
        let { message: message = '' } = rest;
        let property = instancePath.replace(/\//g, '.');
        let stack = `${property} ${message}`.trim();
        let uiTitle = '';
        const rawPropertyNames = [
            ...((_a = params.deps) === null || _a === void 0 ? void 0 : _a.split(', ')) || [],
            params.missingProperty,
            params.property
        ].filter((item)=>item);
        if (rawPropertyNames.length > 0) {
            rawPropertyNames.forEach((currentProperty)=>{
                const path = property ? `${property}.${currentProperty}` : currentProperty;
                let uiSchemaTitle = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)((0, $547524a1010b9f1e$export$2e2bcd8739ae039)(uiSchema, path.replace(/^\./, ''))).title;
                if (uiSchemaTitle === undefined) {
                    // To retrieve a title from UI schema, construct a path to UI schema from `schemaPath` and `currentProperty`.
                    // For example, when `#/properties/A/properties/B/required` and `C` are given, they are converted into `['A', 'B', 'C']`.
                    const uiSchemaPath = schemaPath.replace(/\/properties\//g, '/').split('/').slice(1, -1).concat([
                        currentProperty
                    ]);
                    uiSchemaTitle = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)((0, $547524a1010b9f1e$export$2e2bcd8739ae039)(uiSchema, uiSchemaPath)).title;
                }
                if (uiSchemaTitle) {
                    message = message.replace(`'${currentProperty}'`, `'${uiSchemaTitle}'`);
                    uiTitle = uiSchemaTitle;
                } else {
                    const parentSchemaTitle = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(parentSchema, [
                        (0, $cd207018ee28cb28$export$dd550d4e98f939a4),
                        currentProperty,
                        'title'
                    ]);
                    if (parentSchemaTitle) {
                        message = message.replace(`'${currentProperty}'`, `'${parentSchemaTitle}'`);
                        uiTitle = parentSchemaTitle;
                    }
                }
            });
            stack = message;
        } else {
            const uiSchemaTitle = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)((0, $547524a1010b9f1e$export$2e2bcd8739ae039)(uiSchema, property.replace(/^\./, ''))).title;
            if (uiSchemaTitle) {
                stack = `'${uiSchemaTitle}' ${message}`.trim();
                uiTitle = uiSchemaTitle;
            } else {
                const parentSchemaTitle = parentSchema === null || parentSchema === void 0 ? void 0 : parentSchema.title;
                if (parentSchemaTitle) {
                    stack = `'${parentSchemaTitle}' ${message}`.trim();
                    uiTitle = parentSchemaTitle;
                }
            }
        }
        // If params.missingProperty is undefined, it is removed from rawPropertyNames by filter((item) => item).
        if ('missingProperty' in params) property = property ? `${property}.${params.missingProperty}` : params.missingProperty;
        // put data in expected format
        return {
            name: keyword,
            property: property,
            message: message,
            params: params,
            stack: stack,
            schemaPath: schemaPath,
            title: uiTitle
        };
    });
    return $e621fbfa575ef4f2$export$95cb9b784786bd1c(errorList, suppressDuplicateFiltering);
}
function $e621fbfa575ef4f2$export$2e2bcd8739ae039(validator, rawErrors, formData, schema, customValidate, transformErrors, uiSchema, suppressDuplicateFiltering) {
    const { validationError: invalidSchemaError } = rawErrors;
    let errors = $e621fbfa575ef4f2$export$c251c0abfee1cfd(rawErrors.errors, uiSchema, suppressDuplicateFiltering);
    if (invalidSchemaError) errors = [
        ...errors,
        {
            stack: invalidSchemaError.message
        }
    ];
    if (typeof transformErrors === 'function') errors = transformErrors(errors, uiSchema);
    let errorSchema = (0, $dcbb07faa7f8c34f$export$2e2bcd8739ae039)(errors);
    if (invalidSchemaError) errorSchema = {
        ...errorSchema,
        $schema: {
            __errors: [
                invalidSchemaError.message
            ]
        }
    };
    if (typeof customValidate !== 'function') return {
        errors: errors,
        errorSchema: errorSchema
    };
    // Include form data with undefined values, which is required for custom validation.
    const newFormData = (0, $cd95df1262c32dce$export$2e2bcd8739ae039)(validator, schema, formData, schema, true);
    const errorHandler = customValidate(newFormData, (0, $3d3c7c1156fce055$export$2e2bcd8739ae039)(newFormData), uiSchema, errorSchema);
    const userErrorSchema = (0, $7f535cbac56a74a1$export$2e2bcd8739ae039)(errorHandler);
    return (0, $f4a48b11a54dcb84$export$2e2bcd8739ae039)({
        errors: errors,
        errorSchema: errorSchema
    }, userErrorSchema);
}


class $d77f46b8a2213051$export$2e2bcd8739ae039 {
    /** Constructs an `AJV8PrecompiledValidator` instance using the `validateFns` and `rootSchema`
     *
     * @param validateFns - The map of the validation functions that are generated by the `schemaCompile()` function
     * @param rootSchema - The root schema that was used with the `compileSchema()` function
     * @param [localizer] - If provided, is used to localize a list of Ajv `ErrorObject`s
     * @param [suppressDuplicateFiltering] - Controls which duplicate filtering is suppressed; see `filterDuplicateErrors`
     * @throws - Error when the base schema of the precompiled validator does not have a matching validator function
     */ constructor(validateFns, rootSchema, localizer, suppressDuplicateFiltering){
        this.rootSchema = rootSchema;
        this.validateFns = validateFns;
        this.localizer = localizer;
        this.suppressDuplicateFiltering = suppressDuplicateFiltering;
        this.mainValidator = this.getValidator(rootSchema);
    }
    /** Returns the precompiled validator associated with the given `schema` from the map of precompiled validator
     * functions.
     *
     * @param schema - The schema for which a precompiled validator function is desired
     * @returns - The precompiled validator function associated with this schema
     */ getValidator(schema) {
        const key = (0, $547524a1010b9f1e$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$f453fd324e92d331)) || (0, $e3ea314528e97c6e$export$2e2bcd8739ae039)(schema);
        const validator = this.validateFns[key];
        if (!validator) throw new Error(`No precompiled validator function was found for the given schema for "${key}"`);
        return validator;
    }
    /** Ensures that the validator is using the same schema as the root schema used to construct the precompiled
     * validator. It first compares the given `schema` against the root schema and if they aren't the same, then it
     * checks against the resolved root schema, on the chance that a resolved version of the root schema was passed in
     * instead of the raw root schema.
     *
     * @param schema - The schema against which to validate the form data
     * @param [formData] - The form data to validate if any
     */ ensureSameRootSchema(schema, formData) {
        if (!(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(schema, this.rootSchema)) {
            // Resolve the root schema with the passed in form data since that may affect the resolution
            const resolvedRootSchema = (0, $9f63129bef70072a$export$2e2bcd8739ae039)(this, this.rootSchema, this.rootSchema, formData);
            if (!(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(schema, resolvedRootSchema)) throw new Error('The schema associated with the precompiled validator differs from the rootSchema provided for validation');
        }
        return true;
    }
    /** Runs the pure validation of the `schema` and `formData` without any of the RJSF functionality. Provided for use
     * by the playground. Returns the `errors` from the validation
     *
     * @param schema - The schema against which to validate the form data
     * @param [formData] - The form data to validate, if any
     * @throws - Error when the schema provided does not match the base schema of the precompiled validator
     */ rawValidation(schema, formData) {
        this.ensureSameRootSchema(schema, formData);
        this.mainValidator(formData);
        if (typeof this.localizer === 'function') this.localizer(this.mainValidator.errors);
        const errors = this.mainValidator.errors || undefined;
        // Clear errors to prevent persistent errors, see #1104
        this.mainValidator.errors = null;
        return {
            errors: errors
        };
    }
    /** This function processes the `formData` with an optional user contributed `customValidate` function, which receives
     * the form data and a `errorHandler` function that will be used to add custom validation errors for each field. Also
     * supports a `transformErrors` function that will take the raw AJV validation errors, prior to custom validation and
     * transform them in what ever way it chooses.
     *
     * @param formData - The form data to validate
     * @param schema - The schema against which to validate the form data
     * @param [customValidate] - An optional function that is used to perform custom validation
     * @param [transformErrors] - An optional function that is used to transform errors after AJV validation
     * @param [uiSchema] - An optional uiSchema that is passed to `transformErrors` and `customValidate`
     */ validateFormData(formData, schema, customValidate, transformErrors, uiSchema) {
        const rawErrors = this.rawValidation(schema, formData);
        return (0, $e621fbfa575ef4f2$export$2e2bcd8739ae039)(this, rawErrors, formData, schema, customValidate, transformErrors, uiSchema, this.suppressDuplicateFiltering);
    }
    /** Validates data against a schema, returning true if the data is valid, or false otherwise. If the schema is
     * invalid, then this function will return false.
     *
     * @param schema - The schema against which to validate the form data
     * @param formData - The form data to validate
     * @param rootSchema - The root schema used to provide $ref resolutions
     * @returns - true if the formData validates against the schema, false otherwise
     * @throws - Error when the schema provided does not match the base schema of the precompiled validator OR if there
     *        isn't a precompiled validator function associated with the schema
     */ isValid(schema, formData, rootSchema) {
        this.ensureSameRootSchema(rootSchema, formData);
        if ((0, $547524a1010b9f1e$export$2e2bcd8739ae039)(schema, (0, $cd207018ee28cb28$export$f453fd324e92d331)) === (0, $cd207018ee28cb28$export$9b4d24d10abfe212)) return false;
        const validator = this.getValidator(schema);
        return validator(formData);
    }
}


function $522f1de97a82723b$export$2e2bcd8739ae039(validateFns, rootSchema, localizer, suppressDuplicateFiltering) {
    return new (0, $d77f46b8a2213051$export$2e2bcd8739ae039)(validateFns, rootSchema, localizer, suppressDuplicateFiltering);
}





var $kKLhX = parcelRequire("kKLhX");

var $5G0y8 = parcelRequire("5G0y8");

const $63c8f593a820af5d$export$e72bf57877e9095c = {
    allErrors: true,
    multipleOfPrecision: 8,
    strict: false,
    verbose: true,
    discriminator: false
};
const $63c8f593a820af5d$export$2e139c34b82d8a72 = /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/;
const $63c8f593a820af5d$export$62e7b34a09801f97 = /^data:([a-z]+\/[a-z0-9-+.]+)?;(?:name=(.*);)?base64,(.*)$/;
function $63c8f593a820af5d$export$2e2bcd8739ae039(additionalMetaSchemas, customFormats, ajvOptionsOverrides = {}, ajvFormatOptions, AjvClass = (0, (/*@__PURE__*/$parcel$interopDefault($kKLhX))), extenderFn) {
    let ajv = new AjvClass({
        ...$63c8f593a820af5d$export$e72bf57877e9095c,
        ...ajvOptionsOverrides
    });
    if (ajvFormatOptions) (0, (/*@__PURE__*/$parcel$interopDefault($5G0y8)))(ajv, ajvFormatOptions);
    else if (ajvFormatOptions !== false) (0, (/*@__PURE__*/$parcel$interopDefault($5G0y8)))(ajv);
    // add custom formats
    ajv.addFormat('data-url', $63c8f593a820af5d$export$62e7b34a09801f97);
    ajv.addFormat('color', $63c8f593a820af5d$export$2e139c34b82d8a72);
    // Add RJSF-specific additional properties keywords so Ajv doesn't report errors if strict is enabled.
    ajv.addKeyword((0, $cd207018ee28cb28$export$60d2d9c11642ddd6));
    ajv.addKeyword((0, $cd207018ee28cb28$export$379f2e8c0717b331));
    // add more schemas to validate against
    if (Array.isArray(additionalMetaSchemas)) ajv.addMetaSchema(additionalMetaSchemas);
    // add more custom formats to validate against
    if ((0, $d252d56fd76f41df$export$2e2bcd8739ae039)(customFormats)) Object.keys(customFormats).forEach((formatName)=>{
        ajv.addFormat(formatName, customFormats[formatName]);
    });
    if (extenderFn) ajv = extenderFn(ajv);
    return ajv;
}



class $3b1816a3b8f4e45e$export$2e2bcd8739ae039 {
    /** Constructs an `AJV8Validator` instance using the `options`
     *
     * @param options - The `CustomValidatorOptionsType` options that are used to create the AJV instance
     * @param [localizer] - If provided, is used to localize a list of Ajv `ErrorObject`s
     */ constructor(options, localizer){
        /** True once a `rootSchema` has been registered with Ajv in this lifecycle.
         *
         * @private
         */ this.hasRegisteredRootSchema = false;
        const { additionalMetaSchemas: additionalMetaSchemas, customFormats: customFormats, ajvOptionsOverrides: ajvOptionsOverrides, ajvFormatOptions: ajvFormatOptions, AjvClass: AjvClass, extenderFn: extenderFn, suppressDuplicateFiltering: suppressDuplicateFiltering } = options;
        this.ajv = (0, $63c8f593a820af5d$export$2e2bcd8739ae039)(additionalMetaSchemas, customFormats, ajvOptionsOverrides, ajvFormatOptions, AjvClass, extenderFn);
        this.localizer = localizer;
        this.suppressDuplicateFiltering = suppressDuplicateFiltering;
    }
    /** Resets the internal AJV validator to clear schemas from it. Can be helpful for resetting the validator for tests.
     */ reset() {
        this.ajv.removeSchema();
        this.lastSeenRootSchema = undefined;
        this.hasRegisteredRootSchema = false;
    }
    /** Runs the pure validation of the `schema` and `formData` without any of the RJSF functionality. Provided for use
     * by the playground. Returns the `errors` from the validation
     *
     * @param schema - The schema against which to validate the form data   * @param schema
     * @param formData - The form data to validate
     */ rawValidation(schema, formData) {
        var _a, _b;
        let compilationError = undefined;
        let compiledValidator;
        try {
            if (schema[0, $cd207018ee28cb28$export$f453fd324e92d331]) compiledValidator = this.ajv.getSchema(schema[0, $cd207018ee28cb28$export$f453fd324e92d331]);
            if (compiledValidator === undefined) compiledValidator = this.ajv.compile(schema);
            compiledValidator(formData);
        } catch (err) {
            compilationError = err;
        }
        let errors;
        if (compiledValidator) {
            if (typeof this.localizer === 'function') {
                // Properties need to be enclosed with quotes so that
                // `AJV8Validator#transformRJSFValidationErrors` replaces property names
                // with `title` or `ui:title`. See #4348, #4349, #4387, and #4402.
                ((_a = compiledValidator.errors) !== null && _a !== void 0 ? _a : []).forEach((error)=>{
                    var _a;
                    [
                        'missingProperty',
                        'property'
                    ].forEach((key)=>{
                        var _a;
                        if ((_a = error.params) === null || _a === void 0 ? void 0 : _a[key]) // oxlint-disable-next-line no-param-reassign
                        error.params[key] = `'${error.params[key]}'`;
                    });
                    if ((_a = error.params) === null || _a === void 0 ? void 0 : _a.deps) // As `error.params.deps` is the comma+space separated list of missing dependencies, enclose each dependency separately.
                    // For example, `A, B` is converted into `'A', 'B'`.
                    // oxlint-disable-next-line no-param-reassign
                    error.params.deps = error.params.deps.split(', ').map((v)=>`'${v}'`).join(', ');
                });
                this.localizer(compiledValidator.errors);
                // Revert to originals
                ((_b = compiledValidator.errors) !== null && _b !== void 0 ? _b : []).forEach((error)=>{
                    var _a;
                    [
                        'missingProperty',
                        'property'
                    ].forEach((key)=>{
                        var _a;
                        if ((_a = error.params) === null || _a === void 0 ? void 0 : _a[key]) // oxlint-disable-next-line no-param-reassign
                        error.params[key] = error.params[key].slice(1, -1);
                    });
                    if ((_a = error.params) === null || _a === void 0 ? void 0 : _a.deps) // Remove surrounding quotes from each missing dependency. For example, `'A', 'B'` is reverted to `A, B`.
                    // oxlint-disable-next-line no-param-reassign
                    error.params.deps = error.params.deps.split(', ').map((v)=>v.slice(1, -1)).join(', ');
                });
            }
            errors = compiledValidator.errors || undefined;
            // Clear errors to prevent persistent errors, see #1104
            compiledValidator.errors = null;
        }
        return {
            errors: errors,
            validationError: compilationError
        };
    }
    /** This function processes the `formData` with an optional user contributed `customValidate` function, which receives
     * the form data and a `errorHandler` function that will be used to add custom validation errors for each field. Also
     * supports a `transformErrors` function that will take the raw AJV validation errors, prior to custom validation and
     * transform them in what ever way it chooses.
     *
     * @param formData - The form data to validate
     * @param schema - The schema against which to validate the form data
     * @param [customValidate] - An optional function that is used to perform custom validation
     * @param [transformErrors] - An optional function that is used to transform errors after AJV validation
     * @param [uiSchema] - An optional uiSchema that is passed to `transformErrors` and `customValidate`
     */ validateFormData(formData, schema, customValidate, transformErrors, uiSchema) {
        const rawErrors = this.rawValidation(schema, formData);
        return (0, $e621fbfa575ef4f2$export$2e2bcd8739ae039)(this, rawErrors, formData, schema, customValidate, transformErrors, uiSchema, this.suppressDuplicateFiltering);
    }
    /**
     * This function checks if a schema needs to be added and if the root schemas don't match it removes the old root schema from the ajv instance and adds the new one.
     * When called repeatedly with the same `rootSchema` reference the deep-equality check is skipped.
     *
     * @param rootSchema - The root schema used to provide $ref resolutions
     */ handleSchemaUpdate(rootSchema) {
        var _a, _b;
        if (this.lastSeenRootSchema === rootSchema && this.hasRegisteredRootSchema) return;
        const rootSchemaId = (_a = rootSchema[0, $cd207018ee28cb28$export$f453fd324e92d331]) !== null && _a !== void 0 ? _a : (0, $cd207018ee28cb28$export$4f0f58ec8c545f3);
        // add the rootSchema ROOT_SCHEMA_PREFIX as id.
        // if schema validator instance doesn't exist, add it.
        // else if the root schemas don't match, we should remove and add the root schema so we don't have to remove and recompile the schema every run.
        if (this.ajv.getSchema(rootSchemaId) === undefined) this.ajv.addSchema(rootSchema, rootSchemaId);
        else if (!(0, $d6d96b21f3c423a2$export$2e2bcd8739ae039)(rootSchema, (_b = this.ajv.getSchema(rootSchemaId)) === null || _b === void 0 ? void 0 : _b.schema)) {
            this.ajv.removeSchema(rootSchemaId);
            this.ajv.addSchema(rootSchema, rootSchemaId);
        }
        this.lastSeenRootSchema = rootSchema;
        this.hasRegisteredRootSchema = true;
    }
    /** Validates data against a schema, returning true if the data is valid, or
     * false otherwise. If the schema is invalid, then this function will return
     * false.
     *
     * @param schema - The schema against which to validate the form data
     * @param formData - The form data to validate
     * @param rootSchema - The root schema used to provide $ref resolutions
     */ isValid(schema, formData, rootSchema) {
        var _a;
        try {
            this.handleSchemaUpdate(rootSchema);
            // then rewrite the schema ref's to point to the rootSchema
            // this accounts for the case where schema have references to models
            // that lives in the rootSchema but not in the schema in question.
            const schemaWithIdRefPrefix = (0, $5408a594667028d0$export$2e2bcd8739ae039)(schema);
            const schemaId = (_a = schemaWithIdRefPrefix[0, $cd207018ee28cb28$export$f453fd324e92d331]) !== null && _a !== void 0 ? _a : (0, $e3ea314528e97c6e$export$2e2bcd8739ae039)(schemaWithIdRefPrefix);
            let compiledValidator;
            compiledValidator = this.ajv.getSchema(schemaId);
            if (compiledValidator === undefined) // Add schema by an explicit ID so it can be fetched later
            // Fall back to using compile if necessary
            // https://ajv.js.org/guide/managing-schemas.html#pre-adding-all-schemas-vs-adding-on-demand
            compiledValidator = this.ajv.addSchema(schemaWithIdRefPrefix, schemaId).getSchema(schemaId) || this.ajv.compile(schemaWithIdRefPrefix);
            const result = compiledValidator(formData);
            return result;
        } catch (e) {
            // oxlint-disable-next-line no-console
            console.warn('Error encountered compiling schema:', e);
            return false;
        }
    }
}


function $a666c083b1ae8fcf$export$2e2bcd8739ae039(options = {}, localizer) {
    return new (0, $3b1816a3b8f4e45e$export$2e2bcd8739ae039)(options, localizer);
}


var $0d25d32d97fe699f$export$2e2bcd8739ae039 = (0, $a666c083b1ae8fcf$export$2e2bcd8739ae039)();



function $9d73ba7268fd3607$export$2e2bcd8739ae039(rootSchema, fields = {}, templates = {}, widgets = {}, formContext = {}, globalFormOptions = {
    idPrefix: (0, $cd207018ee28cb28$export$fc1a2685f60ab9ef),
    idSeparator: (0, $cd207018ee28cb28$export$cd88b6b1f03afce9),
    useFallbackUiForUnsupportedType: false
}) {
    const defaults = (0, $6785543bf8584407$export$2e2bcd8739ae039)();
    const schemaUtils = (0, $d42360923ae67b3f$export$2e2bcd8739ae039)((0, $0d25d32d97fe699f$export$2e2bcd8739ae039), rootSchema);
    return {
        fields: {
            ...defaults.fields,
            ...fields
        },
        templates: {
            ...defaults.templates,
            ...templates
        },
        widgets: {
            ...defaults.widgets,
            ...widgets
        },
        formContext: formContext,
        rootSchema: rootSchema,
        schemaUtils: schemaUtils,
        translateString: (0, $29d931a0330c7ad7$export$2e2bcd8739ae039),
        globalFormOptions: globalFormOptions
    };
}




var $h4Bez = parcelRequire("h4Bez");

function $695e714327ae63c8$export$2e2bcd8739ae039(themeProps) {
    // @ts-expect-error TS2322 because the latest types complain about LegacyRef's string form not working with Form
    return (0, $h4Bez.forwardRef)(({ fields: propFields, widgets: propWidgets, templates: propTemplates, ...directProps }, ref)=>{
        const fields = {
            ...themeProps?.fields,
            ...propFields
        };
        const widgets = {
            ...themeProps?.widgets,
            ...propWidgets
        };
        const templates = {
            ...themeProps?.templates,
            ...propTemplates,
            ButtonTemplates: {
                ...themeProps?.templates?.ButtonTemplates,
                ...propTemplates?.ButtonTemplates
            }
        };
        return (0, $2e41620b030ed79e$exports.jsx)((0, $3a1888fa7e14f86a$export$2e2bcd8739ae039), {
            ...themeProps,
            ...directProps,
            fields: fields,
            widgets: widgets,
            templates: templates,
            ref: ref
        });
    });
}


var $56d86aa41dd9d81c$export$2e2bcd8739ae039 = (0, $3a1888fa7e14f86a$export$2e2bcd8739ae039);






"use client";
var $2510eecdad012f77$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');




/**
 * Extract props meant for MUI components from the `options` field of the `uiSchema`.
 * @param {UIOptionsType} options - The options from the uiSchema
 * @param {string[]} [propsToFilter] - An optional allowlist of props to return (used by button/icon components)
 * @param {boolean} [rjsfSlotPropsOnly] - If true, returns only `rjsfSlotProps`, preventing root-level prop bleeding
 * @returns {P}
 */ function $eba4f82aa8d01df6$export$aa0a393b09ccbcf1(options, propsToFilter, rjsfSlotPropsOnly) {
    const muiProps = (options === null || options === void 0 ? void 0 : options.mui) || {};
    if (rjsfSlotPropsOnly) {
        const { rjsfSlotProps: rjsfSlotProps } = muiProps;
        return {
            rjsfSlotProps: rjsfSlotProps
        };
    }
    if (propsToFilter) return Object.keys(muiProps).filter((key)=>propsToFilter.includes(key)).reduce((acc, key)=>{
        acc[key] = muiProps[key];
        return acc;
    }, {});
    return muiProps;
}
function $eba4f82aa8d01df6$export$ba9bd0d00fea4b3(sxProps, muiProps) {
    if (!muiProps) return sxProps;
    if (Array.isArray(muiProps === null || muiProps === void 0 ? void 0 : muiProps.sx)) return [
        sxProps,
        ...muiProps.sx
    ];
    return {
        ...sxProps,
        ...muiProps === null || muiProps === void 0 ? void 0 : muiProps.sx
    };
}


function $c8bbcd7ae4869560$export$2e2bcd8739ae039({ uiSchema: uiSchema, registry: registry, ...props }) {
    const { translateString: translateString } = registry;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const muiProps = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(uiOptions, [
        'color',
        'disableFocusRipple',
        'disableRipple',
        'edge',
        'size',
        'sx'
    ]);
    return (0, $2e41620b030ed79e$exports.jsx)((0, $8ccbf49a69947e95$export$2e2bcd8739ae039), {
        title: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).AddItemButton),
        ...props,
        color: 'primary',
        ...muiProps,
        children: (0, $2e41620b030ed79e$exports.jsx)((0, $2510eecdad012f77$export$2e2bcd8739ae039), {})
    });
}










function $db829dab7a3bc07a$export$2e2bcd8739ae039(props) {
    const { children: children, buttonsProps: buttonsProps, hasDescription: hasDescription, hasToolbar: hasToolbar, uiSchema: uiSchema, registry: registry } = props;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const ArrayFieldItemButtonsTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('ArrayFieldItemButtonsTemplate', registry, uiOptions);
    const btnStyle = {
        flex: 1,
        paddingLeft: 6,
        paddingRight: 6,
        fontWeight: 'bold',
        minWidth: 0
    };
    const { rjsfSlotProps: { arrayItemGridContainer: arrayItemGridContainer, arrayItemGridItem: arrayItemGridItem, arrayItemInnerBox: arrayItemInnerBox, arrayItemOuterBox: arrayItemOuterBox, arrayItemPaper: arrayItemPaper, arrayItemToolbarGrid: arrayItemToolbarGrid } = {} } = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(uiOptions);
    return (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: true,
        ...arrayItemGridContainer,
        sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
            alignItems: 'center'
        }, arrayItemGridContainer),
        children: [
            (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                size: {
                    xs: 8,
                    sm: 9,
                    md: 10,
                    lg: 11,
                    xl: 11.25
                },
                ...arrayItemGridItem,
                sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
                    overflow: 'auto'
                }, arrayItemGridItem),
                children: (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    ...arrayItemOuterBox,
                    sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
                        mb: 2
                    }, arrayItemOuterBox),
                    children: (0, $2e41620b030ed79e$exports.jsx)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
                        elevation: 2,
                        ...arrayItemPaper,
                        children: (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                            ...arrayItemInnerBox,
                            sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
                                p: 2
                            }, arrayItemInnerBox),
                            children: children
                        })
                    })
                })
            }),
            hasToolbar && (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                ...arrayItemToolbarGrid,
                sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
                    mt: hasDescription ? -5 : -1.5
                }, arrayItemToolbarGrid),
                children: (0, $2e41620b030ed79e$exports.jsx)(ArrayFieldItemButtonsTemplate, {
                    ...buttonsProps,
                    style: btnStyle
                })
            })
        ]
    });
}










function $aea77075ff712e84$export$2e2bcd8739ae039(props) {
    const { canAdd: canAdd, disabled: disabled, fieldPathId: fieldPathId, uiSchema: uiSchema, items: items, optionalDataControl: optionalDataControl, onAddClick: onAddClick, readonly: readonly, registry: registry, required: required, schema: schema, title: title } = props;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const ArrayFieldDescriptionTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('ArrayFieldDescriptionTemplate', registry, uiOptions);
    const ArrayFieldTitleTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('ArrayFieldTitleTemplate', registry, uiOptions);
    const showOptionalDataControlInTitle = !readonly && !disabled;
    // Button templates are not overridden in the uiSchema
    const { ButtonTemplates: { AddButton: AddButton } } = registry.templates;
    const { rjsfSlotProps: { arrayPaper: arrayPaper, arrayBox: arrayBox, arrayAddButtonGridContainer: arrayAddButtonGridContainer, arrayAddButtonGridItem: arrayAddButtonGridItem, arrayAddButtonBox: arrayAddButtonBox } = {} } = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(uiOptions);
    return (0, $2e41620b030ed79e$exports.jsx)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
        elevation: 2,
        ...arrayPaper,
        children: (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
            ...arrayBox,
            sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
                p: 2
            }, arrayBox),
            children: [
                (0, $2e41620b030ed79e$exports.jsx)(ArrayFieldTitleTemplate, {
                    fieldPathId: fieldPathId,
                    title: uiOptions.title || title,
                    schema: schema,
                    uiSchema: uiSchema,
                    required: required,
                    registry: registry,
                    optionalDataControl: showOptionalDataControlInTitle ? optionalDataControl : undefined
                }),
                (0, $2e41620b030ed79e$exports.jsx)(ArrayFieldDescriptionTemplate, {
                    fieldPathId: fieldPathId,
                    description: uiOptions.description || schema.description,
                    schema: schema,
                    uiSchema: uiSchema,
                    registry: registry
                }),
                !showOptionalDataControlInTitle ? optionalDataControl : undefined,
                items,
                canAdd && (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                    container: true,
                    ...arrayAddButtonGridContainer,
                    sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
                        justifyContent: 'flex-end'
                    }, arrayAddButtonGridContainer),
                    children: (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        ...arrayAddButtonGridItem,
                        children: (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                            ...arrayAddButtonBox,
                            sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
                                mt: 2
                            }, arrayAddButtonBox),
                            children: (0, $2e41620b030ed79e$exports.jsx)(AddButton, {
                                id: (0, $8ce79fa261751f64$export$6395da05030161a1)(fieldPathId, 'add'),
                                className: 'rjsf-array-item-add',
                                onClick: onAddClick,
                                disabled: disabled || readonly,
                                uiSchema: uiSchema,
                                registry: registry
                            })
                        })
                    })
                })
            ]
        })
    });
}






var $h4Bez = parcelRequire("h4Bez");





const $78ac921f933e01cb$var$TYPES_THAT_SHRINK_LABEL = [
    'date',
    'datetime-local',
    'file',
    'time'
];
function $78ac921f933e01cb$export$2e2bcd8739ae039(props) {
    const { id: id, name: name, htmlName: htmlName, placeholder: placeholder, required: required, readonly: readonly, disabled: disabled, type: type, label: label, hideLabel: hideLabel, hideError: hideError, value: value, onChange: onChange, onChangeOverride: onChangeOverride, onBlur: onBlur, onFocus: onFocus, autofocus: autofocus, options: options, schema: schema, uiSchema: uiSchema, rawErrors: rawErrors = [], errorSchema: errorSchema, registry: registry, InputLabelProps: InputLabelProps, InputProps: InputProps, slotProps: slotProps, ...textFieldProps } = props;
    const { ClearButton: ClearButton } = registry.templates.ButtonTemplates;
    // Now we need to pull out the step, min, max into an inner `inputProps` for material-ui
    const { step: step, min: min, max: max, accept: accept, ...rest } = (0, $44b30900be781098$export$2e2bcd8739ae039)(schema, type, options);
    const muiProps = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(options);
    const { slotProps: muiSlotProps, ...otherMuiProps } = muiProps;
    const htmlInputProps = {
        ...slotProps === null || slotProps === void 0 ? void 0 : slotProps.htmlInput,
        ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.htmlInput,
        step: step,
        min: min,
        max: max,
        accept: accept,
        ...schema.examples ? {
            list: (0, $8ce79fa261751f64$export$64cb836579421d7e)(id)
        } : undefined
    };
    const handleChange = ({ target: { value: newValue } })=>onChange(newValue === '' ? options.emptyValue : newValue);
    const handleBlur = ({ target: target })=>onBlur(id, target && target.value);
    const handleFocus = ({ target: target })=>onFocus(id, target && target.value);
    const DisplayInputLabelProps = $78ac921f933e01cb$var$TYPES_THAT_SHRINK_LABEL.includes(type) ? {
        ...slotProps === null || slotProps === void 0 ? void 0 : slotProps.inputLabel,
        ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.inputLabel,
        ...InputLabelProps,
        shrink: true
    } : {
        ...slotProps === null || slotProps === void 0 ? void 0 : slotProps.inputLabel,
        ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.inputLabel,
        ...InputLabelProps
    };
    const handleClear = (0, $h4Bez.useCallback)((e)=>{
        var _a;
        e.preventDefault();
        e.stopPropagation();
        onChange((_a = options.emptyValue) !== null && _a !== void 0 ? _a : '');
    }, [
        onChange,
        options.emptyValue
    ]);
    const inputProps = {
        ...InputProps,
        ...slotProps === null || slotProps === void 0 ? void 0 : slotProps.input,
        ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.input
    };
    if (options.allowClearTextInputs && value && !readonly && !disabled) {
        const clearAdornment = (0, $2e41620b030ed79e$exports.jsx)((0, $2aefb57dc041c2ec$export$2e2bcd8739ae039), {
            position: 'end',
            children: (0, $2e41620b030ed79e$exports.jsx)(ClearButton, {
                registry: registry,
                onClick: handleClear
            })
        });
        inputProps.endAdornment = !inputProps.endAdornment ? clearAdornment : (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
            children: [
                inputProps.endAdornment,
                clearAdornment
            ]
        });
    }
    return (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            (0, $2e41620b030ed79e$exports.jsx)((0, $556393662cf0f57c$export$2e2bcd8739ae039), {
                id: id,
                name: htmlName || id,
                placeholder: placeholder,
                label: (0, $e15ee0fe5a70fe3e$export$2e2bcd8739ae039)(label || undefined, hideLabel, undefined),
                autoFocus: autofocus,
                required: required,
                disabled: disabled || readonly,
                slotProps: {
                    ...slotProps,
                    ...muiSlotProps,
                    input: inputProps,
                    htmlInput: htmlInputProps,
                    inputLabel: DisplayInputLabelProps
                },
                ...rest,
                value: value || value === 0 ? value : '',
                error: rawErrors.length > 0,
                onChange: onChangeOverride || handleChange,
                onBlur: handleBlur,
                onFocus: handleFocus,
                ...{
                    ...otherMuiProps,
                    ...textFieldProps
                },
                "aria-describedby": (0, $8ce79fa261751f64$export$53c2204bb4091b57)(id, !!schema.examples)
            }),
            (0, $2e41620b030ed79e$exports.jsx)((0, $2cf2dc76876a4f1b$export$2e2bcd8739ae039), {
                id: id,
                schema: schema
            })
        ]
    });
}









function $0b966ba614a280b4$export$2e2bcd8739ae039(props) {
    const { id: id, description: description, registry: registry, uiSchema: uiSchema } = props;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const { rjsfSlotProps: { descTypography: descTypography } = {} } = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(uiOptions);
    if (description) return (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
        id: id,
        variant: 'subtitle2',
        ...descTypography,
        sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
            mt: 0.625
        }, descTypography),
        children: (0, $2e41620b030ed79e$exports.jsx)((0, $4c0b0a7e771589a9$export$2e2bcd8739ae039), {
            description: description,
            registry: registry,
            uiSchema: uiSchema
        })
    });
    return null;
}







"use client";
var $5582262ddbabf0cc$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), 'Error');






var $h4Bez = parcelRequire("h4Bez");









'use client';
const $e5132299f9f455f8$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $d01f67d02e170158$export$81478e24460c57f2), classes);
};
const $e5132299f9f455f8$var$ListItemIconRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex',
        variants: [
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    marginTop: 8
                }
            }
        ]
    })));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $e5132299f9f455f8$var$ListItemIcon = /*#__PURE__*/ $h4Bez.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className, ...other } = props;
    const context = $h4Bez.useContext((0, $4be71481ffac437a$export$2e2bcd8739ae039));
    const ownerState = {
        ...props,
        alignItems: context.alignItems
    };
    const classes = $e5132299f9f455f8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($e5132299f9f455f8$var$ListItemIconRoot, {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $e5132299f9f455f8$export$2e2bcd8739ae039 = $e5132299f9f455f8$var$ListItemIcon;



var $h4Bez = parcelRequire("h4Bez");










'use client';
const $68ec4db0d4ae6801$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $a7195a7c6f38083f$export$1061006a0db3aeb5), classes);
};
const $68ec4db0d4ae6801$var$ListItemTextRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $a7195a7c6f38083f$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $a7195a7c6f38083f$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    [`.${(0, $f9ef756b8f6a1b37$export$2e2bcd8739ae039).root}:where(& .${(0, $a7195a7c6f38083f$export$2e2bcd8739ae039).primary})`]: {
        display: 'block'
    },
    [`.${(0, $f9ef756b8f6a1b37$export$2e2bcd8739ae039).root}:where(& .${(0, $a7195a7c6f38083f$export$2e2bcd8739ae039).secondary})`]: {
        display: 'block'
    },
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.primary && ownerState.secondary,
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.inset,
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const $68ec4db0d4ae6801$var$ListItemText = /*#__PURE__*/ $h4Bez.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const { dense: dense } = $h4Bez.useContext((0, $4be71481ffac437a$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = {
        ...props,
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    };
    const classes = $68ec4db0d4ae6801$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            primary: primaryTypographyProps,
            secondary: secondaryTypographyProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('root', {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $68ec4db0d4ae6801$var$ListItemTextRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref
    });
    const [PrimarySlot, primarySlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('primary', {
        className: classes.primary,
        elementType: (0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('secondary', {
        className: classes.secondary,
        elementType: (0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    if (primary != null && primary.type !== (0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(PrimarySlot, {
        variant: dense ? 'body2' : 'body1',
        component: primarySlotProps?.variant ? undefined : 'span',
        ...primarySlotProps,
        children: primary
    });
    if (secondary != null && secondary.type !== (0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(SecondarySlot, {
        variant: "body2",
        color: "textSecondary",
        ...secondarySlotProps,
        children: secondary
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            primary,
            secondary
        ]
    });
});
var $68ec4db0d4ae6801$export$2e2bcd8739ae039 = $68ec4db0d4ae6801$var$ListItemText;






function $1dd724c10763e787$export$2e2bcd8739ae039({ errors: errors, registry: registry, uiSchema: uiSchema }) {
    const { translateString: translateString } = registry;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const { rjsfSlotProps: { errorPaper: errorPaper, errorBox: errorBox, errorTypography: errorTypography, errorList: errorList, errorListItem: errorListItem, errorListItemIcon: errorListItemIcon, errorListItemText: errorListItemText } = {} } = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(uiOptions);
    return (0, $2e41620b030ed79e$exports.jsx)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
        elevation: 2,
        ...errorPaper,
        children: (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
            ...errorBox,
            sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
                mb: 2,
                p: 2
            }, errorBox),
            children: [
                (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    variant: 'h6',
                    ...errorTypography,
                    children: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).ErrorsLabel)
                }),
                (0, $2e41620b030ed79e$exports.jsx)((0, $e38cb871010a9357$export$2e2bcd8739ae039), {
                    dense: true,
                    ...errorList,
                    children: errors.map((error, i)=>(0, $2e41620b030ed79e$exports.jsxs)((0, $4b454249f6da9127$export$2e2bcd8739ae039), {
                            ...errorListItem,
                            children: [
                                (0, $2e41620b030ed79e$exports.jsx)((0, $e5132299f9f455f8$export$2e2bcd8739ae039), {
                                    ...errorListItemIcon,
                                    children: (0, $2e41620b030ed79e$exports.jsx)((0, $5582262ddbabf0cc$export$2e2bcd8739ae039), {
                                        color: 'error'
                                    })
                                }),
                                (0, $2e41620b030ed79e$exports.jsx)((0, $68ec4db0d4ae6801$export$2e2bcd8739ae039), {
                                    primary: error.stack,
                                    ...errorListItemText
                                })
                            ]
                        }, i))
                })
            ]
        })
    });
}










function $3e76ac253881214b$export$2e2bcd8739ae039(props) {
    const { errors: errors = [], fieldPathId: fieldPathId, uiSchema: uiSchema } = props;
    if (errors.length === 0) return null;
    const id = (0, $8ce79fa261751f64$export$8a072670fa7ceeee)(fieldPathId);
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const muiProps = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(uiOptions);
    const { rjsfSlotProps: muiSlotProps } = muiProps;
    return (0, $2e41620b030ed79e$exports.jsx)((0, $e38cb871010a9357$export$2e2bcd8739ae039), {
        id: id,
        dense: true,
        disablePadding: true,
        ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.fieldErrorList,
        children: errors.map((error, i)=>(0, $2e41620b030ed79e$exports.jsx)((0, $4b454249f6da9127$export$2e2bcd8739ae039), {
                disableGutters: true,
                ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.fieldErrorListItem,
                children: (0, $2e41620b030ed79e$exports.jsx)((0, $c0f4202dc2b8182f$export$2e2bcd8739ae039), {
                    component: 'div',
                    id: `${id}-${i}`,
                    ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.fieldErrorFormHelperText,
                    children: error
                })
            }, i))
    });
}









function $1e96c3699fbc2ff2$export$2e2bcd8739ae039(props) {
    const { fieldPathId: fieldPathId, help: help, uiSchema: uiSchema, registry: registry } = props;
    if (!help) return null;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const { rjsfSlotProps: { helpFormHelperText: helpFormHelperText } = {} } = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(uiOptions);
    return (0, $2e41620b030ed79e$exports.jsx)((0, $c0f4202dc2b8182f$export$2e2bcd8739ae039), {
        component: 'div',
        id: (0, $8ce79fa261751f64$export$94c2e687214ec019)(fieldPathId),
        ...helpFormHelperText,
        sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
            mt: 0.625
        }, helpFormHelperText),
        children: (0, $2e41620b030ed79e$exports.jsx)((0, $1bedc85ebf6b209e$export$2e2bcd8739ae039), {
            help: help,
            registry: registry,
            uiSchema: uiSchema
        })
    });
}









function $97f70db3b0184db6$export$2e2bcd8739ae039(props) {
    const { id: id, children: children, classNames: classNames, style: style, disabled: disabled, displayLabel: displayLabel, hidden: hidden, label: label, onKeyRename: onKeyRename, onKeyRenameBlur: onKeyRenameBlur, onRemoveProperty: onRemoveProperty, readonly: readonly, required: required, rawErrors: rawErrors = [], errors: errors, help: help, description: description, rawDescription: rawDescription, schema: schema, uiSchema: uiSchema, registry: registry } = props;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const WrapIfAdditionalTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('WrapIfAdditionalTemplate', registry, uiOptions);
    if (hidden) return (0, $2e41620b030ed79e$exports.jsx)("div", {
        style: {
            display: 'none'
        },
        children: children
    });
    const isCheckbox = uiOptions.widget === 'checkbox';
    const { rjsfSlotProps: muiSlotProps, ...otherMuiProps } = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(uiOptions);
    return (0, $2e41620b030ed79e$exports.jsx)(WrapIfAdditionalTemplate, {
        classNames: classNames,
        style: style,
        disabled: disabled,
        id: id,
        label: label,
        displayLabel: displayLabel,
        rawDescription: rawDescription,
        onKeyRename: onKeyRename,
        onKeyRenameBlur: onKeyRenameBlur,
        onRemoveProperty: onRemoveProperty,
        readonly: readonly,
        required: required,
        schema: schema,
        uiSchema: uiSchema,
        registry: registry,
        children: (0, $2e41620b030ed79e$exports.jsxs)((0, $bd2f0ef06c4947fc$export$2e2bcd8739ae039), {
            fullWidth: true,
            error: !!rawErrors.length,
            required: required,
            ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.fieldFormControl,
            sx: otherMuiProps.sx,
            className: otherMuiProps.className,
            children: [
                children,
                displayLabel && !isCheckbox && rawDescription ? (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    variant: 'caption',
                    color: 'textSecondary',
                    ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.fieldTypography,
                    children: description
                }) : null,
                errors,
                help
            ]
        })
    });
}






function $742d0a00adbd801e$export$2e2bcd8739ae039(props) {
    const { children: children, column: column, ...rest } = props;
    return (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: !column,
        ...rest,
        children: children
    });
}






var $h4Bez = parcelRequire("h4Bez");



"use client";
var $59ec9e60abf4a1d7$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8z"
}), 'ArrowUpward');




"use client";
var $9bd9d7de34b4107b$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');




"use client";
var $b72fd961a8ebf9b4$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), 'ContentCopy');




"use client";
var $6366e850fefbe4dc$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M19 13H5v-2h14z"
}), 'Remove');





function $30d450e56a66a10b$var$MuiIconButtonFn(props) {
    const { icon: icon, color: color, uiSchema: uiSchema, registry: registry, ...otherProps } = props;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const muiProps = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(uiOptions, [
        'color',
        'disableFocusRipple',
        'disableRipple',
        'edge',
        'size',
        'sx'
    ]);
    return (0, $2e41620b030ed79e$exports.jsx)((0, $8ccbf49a69947e95$export$2e2bcd8739ae039), {
        ...muiProps,
        ...otherProps,
        size: 'small',
        color: color,
        children: icon
    });
}
const $30d450e56a66a10b$var$MuiIconButton = (0, $h4Bez.memo)($30d450e56a66a10b$var$MuiIconButtonFn);
var $30d450e56a66a10b$export$2e2bcd8739ae039 = $30d450e56a66a10b$var$MuiIconButton;
function $30d450e56a66a10b$var$CopyButtonFn(props) {
    const { registry: { translateString: translateString } } = props;
    return (0, $2e41620b030ed79e$exports.jsx)($30d450e56a66a10b$var$MuiIconButton, {
        title: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).CopyButton),
        ...props,
        icon: (0, $2e41620b030ed79e$exports.jsx)((0, $b72fd961a8ebf9b4$export$2e2bcd8739ae039), {
            fontSize: 'small'
        })
    });
}
const $30d450e56a66a10b$export$4f2558dd25106ae2 = (0, $h4Bez.memo)($30d450e56a66a10b$var$CopyButtonFn);
function $30d450e56a66a10b$var$MoveDownButtonFn(props) {
    const { registry: { translateString: translateString } } = props;
    return (0, $2e41620b030ed79e$exports.jsx)($30d450e56a66a10b$var$MuiIconButton, {
        title: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).MoveDownButton),
        ...props,
        icon: (0, $2e41620b030ed79e$exports.jsx)((0, $7c31c359ca9de8e7$export$2e2bcd8739ae039), {
            fontSize: 'small'
        })
    });
}
const $30d450e56a66a10b$export$957adf6917d65946 = (0, $h4Bez.memo)($30d450e56a66a10b$var$MoveDownButtonFn);
function $30d450e56a66a10b$var$MoveUpButtonFn(props) {
    const { registry: { translateString: translateString } } = props;
    return (0, $2e41620b030ed79e$exports.jsx)($30d450e56a66a10b$var$MuiIconButton, {
        title: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).MoveUpButton),
        ...props,
        icon: (0, $2e41620b030ed79e$exports.jsx)((0, $59ec9e60abf4a1d7$export$2e2bcd8739ae039), {
            fontSize: 'small'
        })
    });
}
const $30d450e56a66a10b$export$c0d94cf7650e6bd8 = (0, $h4Bez.memo)($30d450e56a66a10b$var$MoveUpButtonFn);
function $30d450e56a66a10b$var$RemoveButtonFn(props) {
    const { iconType: iconType, ...otherProps } = props;
    const { registry: { translateString: translateString } } = otherProps;
    return (0, $2e41620b030ed79e$exports.jsx)($30d450e56a66a10b$var$MuiIconButton, {
        title: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).RemoveButton),
        ...otherProps,
        color: 'error',
        icon: (0, $2e41620b030ed79e$exports.jsx)((0, $6366e850fefbe4dc$export$2e2bcd8739ae039), {
            fontSize: iconType === 'default' ? undefined : 'small'
        })
    });
}
const $30d450e56a66a10b$export$4e9d5ce1e6c22a94 = (0, $h4Bez.memo)($30d450e56a66a10b$var$RemoveButtonFn);
function $30d450e56a66a10b$var$ClearButtonFn(props) {
    const { iconType: iconType, ...otherProps } = props;
    const { registry: { translateString: translateString } } = otherProps;
    return (0, $2e41620b030ed79e$exports.jsx)($30d450e56a66a10b$var$MuiIconButton, {
        title: translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).ClearButton),
        ...otherProps,
        icon: (0, $2e41620b030ed79e$exports.jsx)((0, $9bd9d7de34b4107b$export$2e2bcd8739ae039), {
            fontSize: iconType === 'default' ? undefined : 'small'
        })
    });
}
const $30d450e56a66a10b$export$13ec83e50bf04290 = (0, $h4Bez.memo)($30d450e56a66a10b$var$ClearButtonFn);









function $6885ba8117940a32$export$2e2bcd8739ae039(props) {
    const { optionSchemaField: optionSchemaField, selector: selector, uiSchema: uiSchema } = props;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const { rjsfSlotProps: muiSlotProps } = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(uiOptions);
    return (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: {
            mb: 2
        },
        ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.multiBox,
        children: [
            (0, $2e41620b030ed79e$exports.jsx)((0, $bd2f0ef06c4947fc$export$2e2bcd8739ae039), {
                fullWidth: true,
                sx: {
                    mb: 2
                },
                ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.multiFormControl,
                children: selector
            }),
            optionSchemaField
        ]
    });
}








function $466c53bf7ee87785$export$2e2bcd8739ae039(props) {
    const { description: description, title: title, properties: properties, required: required, disabled: disabled, readonly: readonly, uiSchema: uiSchema, fieldPathId: fieldPathId, schema: schema, formData: formData, optionalDataControl: optionalDataControl, onAddProperty: onAddProperty, registry: registry } = props;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const TitleFieldTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('TitleFieldTemplate', registry, uiOptions);
    const DescriptionFieldTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('DescriptionFieldTemplate', registry, uiOptions);
    const showOptionalDataControlInTitle = !readonly && !disabled;
    // Button templates are not overridden in the uiSchema
    const { ButtonTemplates: { AddButton: AddButton } } = registry.templates;
    const { rjsfSlotProps: { objectGridContainer: objectGridContainer, objectGridItem: objectGridItem, objectAddButtonGridContainer: objectAddButtonGridContainer, objectAddButtonGridItem: objectAddButtonGridItem } = {} } = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(uiOptions);
    return (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            title && (0, $2e41620b030ed79e$exports.jsx)(TitleFieldTemplate, {
                id: (0, $8ce79fa261751f64$export$86b632e0125010d9)(fieldPathId),
                title: title,
                required: required,
                schema: schema,
                uiSchema: uiSchema,
                registry: registry,
                optionalDataControl: showOptionalDataControlInTitle ? optionalDataControl : undefined
            }),
            description && (0, $2e41620b030ed79e$exports.jsx)(DescriptionFieldTemplate, {
                id: (0, $8ce79fa261751f64$export$fd4f3344107bd22c)(fieldPathId),
                description: description,
                schema: schema,
                uiSchema: uiSchema,
                registry: registry
            }),
            (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                ...objectGridContainer,
                sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
                    mt: 1.25
                }, objectGridContainer),
                children: [
                    !showOptionalDataControlInTitle ? optionalDataControl : undefined,
                    properties.map((element)=>// Remove the <Grid> if the inner element is hidden as the <Grid>
                        // itself would otherwise still take up space.
                        element.hidden ? element.content : (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                            size: {
                                xs: 12
                            },
                            ...objectGridItem,
                            sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
                                mb: 1.25
                            }, objectGridItem),
                            children: element.content
                        }, element.name))
                ]
            }),
            (0, $ec95fb101af801c1$export$2e2bcd8739ae039)(schema, uiSchema, formData) && (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                container: true,
                ...objectAddButtonGridContainer,
                sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
                    justifyContent: 'flex-end'
                }, objectAddButtonGridContainer),
                children: (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                    ...objectAddButtonGridItem,
                    children: (0, $2e41620b030ed79e$exports.jsx)(AddButton, {
                        id: (0, $8ce79fa261751f64$export$6395da05030161a1)(fieldPathId, 'add'),
                        className: 'rjsf-object-property-expand',
                        onClick: onAddProperty,
                        disabled: disabled || readonly,
                        uiSchema: uiSchema,
                        registry: registry
                    })
                })
            })
        ]
    });
}







function $8b1b789c4398ebc0$export$2e2bcd8739ae039(props) {
    const { id: id, registry: registry, label: label, onAddClick: onAddClick, onRemoveClick: onRemoveClick, uiSchema: uiSchema } = props;
    if (onAddClick) return (0, $2e41620b030ed79e$exports.jsx)((0, $30d450e56a66a10b$export$2e2bcd8739ae039), {
        id: id,
        registry: registry,
        uiSchema: uiSchema,
        className: 'rjsf-add-optional-data',
        onClick: onAddClick,
        title: label,
        icon: (0, $2e41620b030ed79e$exports.jsx)((0, $2510eecdad012f77$export$2e2bcd8739ae039), {
            fontSize: 'small'
        })
    });
    if (onRemoveClick) return (0, $2e41620b030ed79e$exports.jsx)((0, $30d450e56a66a10b$export$4e9d5ce1e6c22a94), {
        id: id,
        registry: registry,
        uiSchema: uiSchema,
        className: 'rjsf-remove-optional-data',
        onClick: onRemoveClick,
        title: label
    });
    return (0, $2e41620b030ed79e$exports.jsx)("em", {
        id: id,
        children: label
    });
}









function $239aeda6d61e83a7$export$2e2bcd8739ae039({ uiSchema: uiSchema }) {
    const { submitText: submitText, norender: norender, props: submitButtonProps = {} } = (0, $3733f8d10e56b15e$export$2e2bcd8739ae039)(uiSchema);
    if (norender) return null;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const { rjsfSlotProps: { submitBox: submitBox, submitButton: submitButton } = {}, ...otherMuiProps } = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(uiOptions);
    return (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        ...submitBox,
        sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
            mt: 3
        }, submitBox),
        children: (0, $2e41620b030ed79e$exports.jsx)((0, $1e2141c588472150$export$2e2bcd8739ae039), {
            type: 'submit',
            variant: 'contained',
            color: 'primary',
            ...submitButtonProps,
            ...otherMuiProps,
            ...submitButton,
            children: submitText
        })
    });
}











function $ed3051de7c94ab0d$export$2e2bcd8739ae039(props) {
    const { id: id, title: title, optionalDataControl: optionalDataControl, uiSchema: uiSchema } = props;
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const { rjsfSlotProps: { titleBox: titleBox, titleDivider: titleDivider, titleTypography: titleTypography, titleGridContainer: titleGridContainer, titleGridItem: titleGridItem, titleOptionalDataGridItem: titleOptionalDataGridItem } = {} } = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(uiOptions);
    let heading = (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
        variant: 'h5',
        ...titleTypography,
        children: title
    });
    if (optionalDataControl) heading = (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: true,
        spacing: 0,
        ...titleGridContainer,
        children: [
            (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                size: 'grow',
                ...titleGridItem,
                children: heading
            }),
            (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                ...titleOptionalDataGridItem,
                sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
                    justifyContent: 'flex-end'
                }, titleOptionalDataGridItem),
                children: optionalDataControl
            })
        ]
    });
    return (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        id: id,
        ...titleBox,
        sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
            mb: 1,
            mt: 1
        }, titleBox),
        children: [
            heading,
            (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {
                ...titleDivider
            })
        ]
    });
}









function $c2e464a7f066247d$export$2e2bcd8739ae039(props) {
    const { children: children, classNames: classNames, style: style, disabled: disabled, id: id, label: label, displayLabel: displayLabel, onKeyRenameBlur: onKeyRenameBlur, onRemoveProperty: onRemoveProperty, readonly: readonly, required: required, schema: schema, uiSchema: uiSchema, registry: registry } = props;
    const { templates: templates, translateString: translateString } = registry;
    // Button templates are not overridden in the uiSchema
    const { RemoveButton: RemoveButton } = templates.ButtonTemplates;
    const keyLabel = translateString((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).KeyLabel, [
        label
    ]);
    const additional = (0, $cd207018ee28cb28$export$60d2d9c11642ddd6) in schema;
    const btnStyle = {
        flex: 1,
        paddingLeft: 6,
        paddingRight: 6,
        fontWeight: 'bold'
    };
    const uiOptions = (0, $ac37610e58ee493c$export$2e2bcd8739ae039)(uiSchema);
    const { rjsfSlotProps: { wrapGridContainer: wrapGridContainer, wrapKeyGridItem: wrapKeyGridItem, wrapChildrenGridItem: wrapChildrenGridItem, wrapRemoveButtonGridItem: wrapRemoveButtonGridItem } = {} } = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(uiOptions);
    if (!additional) return (0, $2e41620b030ed79e$exports.jsx)("div", {
        className: classNames,
        style: style,
        children: children
    });
    return (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        className: classNames,
        style: style,
        ...wrapGridContainer,
        sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
            alignItems: 'flex-start'
        }, wrapGridContainer),
        children: [
            (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                size: 5.5,
                ...wrapKeyGridItem,
                children: (0, $2e41620b030ed79e$exports.jsx)((0, $556393662cf0f57c$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    required: required,
                    label: displayLabel ? keyLabel : undefined,
                    defaultValue: label,
                    disabled: disabled || readonly,
                    id: `${id}-key`,
                    name: `${id}-key`,
                    onBlur: !readonly ? onKeyRenameBlur : undefined,
                    type: 'text'
                }, label)
            }),
            (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                size: 5.5,
                ...wrapChildrenGridItem,
                children: children
            }),
            (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                ...wrapRemoveButtonGridItem,
                sx: (0, $eba4f82aa8d01df6$export$ba9bd0d00fea4b3)({
                    mt: 1.5
                }, wrapRemoveButtonGridItem),
                children: (0, $2e41620b030ed79e$exports.jsx)(RemoveButton, {
                    id: (0, $8ce79fa261751f64$export$6395da05030161a1)(id, 'remove'),
                    className: 'rjsf-object-property-remove',
                    iconType: 'default',
                    style: btnStyle,
                    disabled: disabled || readonly,
                    onClick: onRemoveProperty,
                    uiSchema: uiSchema,
                    registry: registry
                })
            })
        ]
    }, `${id}-key`);
}




function $d2da634c97cf8a6e$export$a36e13f901c0a29c() {
    return {
        ArrayFieldItemTemplate: $db829dab7a3bc07a$export$2e2bcd8739ae039,
        ArrayFieldTemplate: $aea77075ff712e84$export$2e2bcd8739ae039,
        BaseInputTemplate: $78ac921f933e01cb$export$2e2bcd8739ae039,
        ButtonTemplates: {
            AddButton: $c8bbcd7ae4869560$export$2e2bcd8739ae039,
            CopyButton: $30d450e56a66a10b$export$4f2558dd25106ae2,
            MoveDownButton: $30d450e56a66a10b$export$957adf6917d65946,
            MoveUpButton: $30d450e56a66a10b$export$c0d94cf7650e6bd8,
            RemoveButton: $30d450e56a66a10b$export$4e9d5ce1e6c22a94,
            SubmitButton: $239aeda6d61e83a7$export$2e2bcd8739ae039,
            ClearButton: $30d450e56a66a10b$export$13ec83e50bf04290
        },
        DescriptionFieldTemplate: (0, $0b966ba614a280b4$export$2e2bcd8739ae039),
        ErrorListTemplate: (0, $1dd724c10763e787$export$2e2bcd8739ae039),
        FieldErrorTemplate: $3e76ac253881214b$export$2e2bcd8739ae039,
        FieldHelpTemplate: $1e96c3699fbc2ff2$export$2e2bcd8739ae039,
        FieldTemplate: $97f70db3b0184db6$export$2e2bcd8739ae039,
        GridTemplate: $742d0a00adbd801e$export$2e2bcd8739ae039,
        MultiSchemaFieldTemplate: $6885ba8117940a32$export$2e2bcd8739ae039,
        ObjectFieldTemplate: $466c53bf7ee87785$export$2e2bcd8739ae039,
        OptionalDataControlsTemplate: $8b1b789c4398ebc0$export$2e2bcd8739ae039,
        TitleFieldTemplate: (0, $ed3051de7c94ab0d$export$2e2bcd8739ae039),
        WrapIfAdditionalTemplate: $c2e464a7f066247d$export$2e2bcd8739ae039
    };
}
var $d2da634c97cf8a6e$export$2e2bcd8739ae039 = $d2da634c97cf8a6e$export$a36e13f901c0a29c();





var $h4Bez = parcelRequire("h4Bez");



var $h4Bez = parcelRequire("h4Bez");












function $d2d23ea1a15ff295$export$717666c39ec07e12(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiFormControlLabel', slot);
}
const $d2d23ea1a15ff295$var$formControlLabelClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $d2d23ea1a15ff295$export$2e2bcd8739ae039 = $d2d23ea1a15ff295$var$formControlLabelClasses;





'use client';
const $7ef9ef826e2d35ed$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $d2d23ea1a15ff295$export$717666c39ec07e12), classes);
};
const $7ef9ef826e2d35ed$export$1b479270917a5676 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $d2d23ea1a15ff295$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.labelPlacement)}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $d2d23ea1a15ff295$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        [`& .${(0, $d2d23ea1a15ff295$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $d2d23ea1a15ff295$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        },
        variants: [
            {
                props: {
                    labelPlacement: 'start'
                },
                style: {
                    flexDirection: 'row-reverse',
                    marginRight: -11
                }
            },
            {
                props: {
                    labelPlacement: 'top'
                },
                style: {
                    flexDirection: 'column-reverse'
                }
            },
            {
                props: {
                    labelPlacement: 'bottom'
                },
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ labelPlacement: labelPlacement })=>labelPlacement === 'start' || labelPlacement === 'top' || labelPlacement === 'bottom',
                style: {
                    marginLeft: 16 // used for row presentation of radio/checkbox
                }
            }
        ]
    })));
const $7ef9ef826e2d35ed$var$AsteriskComponent = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        [`&.${(0, $d2d23ea1a15ff295$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $7ef9ef826e2d35ed$var$FormControlLabel = /*#__PURE__*/ $h4Bez.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { checked: checked, className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, inputRef: inputRef, label: labelProp, labelPlacement: labelPlacement = 'end', name: name, onChange: onChange, required: requiredProp, slots: slots = {}, slotProps: slotProps = {}, value: value, ...other } = props;
    const muiFormControl = (0, $364d4e99dd433e44$export$2e2bcd8739ae039)();
    const disabled = disabledProp ?? control.props.disabled ?? muiFormControl?.disabled;
    const required = requiredProp ?? control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $51f4e256a7eeb494$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    };
    const classes = $7ef9ef826e2d35ed$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [TypographySlot, typographySlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('typography', {
        elementType: (0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    let label = labelProp;
    if (label != null && label.type !== (0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(TypographySlot, {
        component: "span",
        ...typographySlotProps,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.label, typographySlotProps?.className),
        children: label
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($7ef9ef826e2d35ed$export$1b479270917a5676, {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ $h4Bez.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($7ef9ef826e2d35ed$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    });
});
var $7ef9ef826e2d35ed$export$2e2bcd8739ae039 = $7ef9ef826e2d35ed$var$FormControlLabel;



var $h4Bez = parcelRequire("h4Bez");







function $aaaf1aeb07ee9f73$export$d72d4cbdc30b331f(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiFormGroup', slot);
}
const $aaaf1aeb07ee9f73$var$formGroupClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $aaaf1aeb07ee9f73$export$2e2bcd8739ae039 = $aaaf1aeb07ee9f73$var$formGroupClasses;





'use client';
const $81c4e0646fa4b7c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $aaaf1aeb07ee9f73$export$d72d4cbdc30b331f), classes);
};
const $81c4e0646fa4b7c0$var$FormGroupRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    variants: [
        {
            props: {
                row: true
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $81c4e0646fa4b7c0$var$FormGroup = /*#__PURE__*/ $h4Bez.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false, ...other } = props;
    const muiFormControl = (0, $364d4e99dd433e44$export$2e2bcd8739ae039)();
    const fcs = (0, $51f4e256a7eeb494$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        row: row,
        error: fcs.error
    };
    const classes = $81c4e0646fa4b7c0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($81c4e0646fa4b7c0$var$FormGroupRoot, {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $81c4e0646fa4b7c0$export$2e2bcd8739ae039 = $81c4e0646fa4b7c0$var$FormGroup;





function $23154cb84fb19534$export$2e2bcd8739ae039(props) {
    const { label: label, hideLabel: hideLabel, id: id, htmlName: htmlName, disabled: disabled, options: options, value: value, autofocus: autofocus, readonly: readonly, required: required, onChange: onChange, onBlur: onBlur, onFocus: onFocus } = props;
    const { enumOptions: enumOptions, enumDisabled: enumDisabled, inline: inline, emptyValue: emptyValue } = options;
    const optionValueFormat = (0, $b28583320c2e364e$export$2e2bcd8739ae039)(options);
    const checkboxesValues = Array.isArray(value) ? value : [
        value
    ];
    const handleChange = (index)=>({ target: { checked: checked } })=>{
            if (checked) onChange((0, $4d503b5a876c5ffd$export$2e2bcd8739ae039)(index, checkboxesValues, enumOptions));
            else onChange((0, $cd5aeb8c020db4af$export$2e2bcd8739ae039)(index, checkboxesValues, enumOptions));
        };
    const handleBlur = ({ target: target })=>onBlur(id, (0, $d751b2609dc272ff$export$2e2bcd8739ae039)(target && target.value, enumOptions, optionValueFormat, emptyValue));
    const handleFocus = ({ target: target })=>onFocus(id, (0, $d751b2609dc272ff$export$2e2bcd8739ae039)(target && target.value, enumOptions, optionValueFormat, emptyValue));
    const { rjsfSlotProps: muiSlotProps, ...otherMuiProps } = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(options);
    return (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            (0, $e15ee0fe5a70fe3e$export$2e2bcd8739ae039)((0, $2e41620b030ed79e$exports.jsx)((0, $f1635ddd0790fd36$export$2e2bcd8739ae039), {
                required: required,
                htmlFor: id,
                children: label || undefined
            }), hideLabel),
            (0, $2e41620b030ed79e$exports.jsx)((0, $81c4e0646fa4b7c0$export$2e2bcd8739ae039), {
                ...otherMuiProps,
                ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.formGroup,
                id: id,
                row: !!inline,
                children: Array.isArray(enumOptions) && enumOptions.map((option, index)=>{
                    const checked = (0, $7f18f5e02c7e23b3$export$2e2bcd8739ae039)(option.value, checkboxesValues);
                    const itemDisabled = Array.isArray(enumDisabled) && enumDisabled.includes(option.value);
                    const checkbox = (0, $2e41620b030ed79e$exports.jsx)((0, $96d9ff0232abe8ca$export$2e2bcd8739ae039), {
                        ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.checkbox,
                        id: (0, $8ce79fa261751f64$export$edf9b44aa62de7dd)(id, index),
                        name: htmlName || id,
                        checked: checked,
                        disabled: disabled || itemDisabled || readonly,
                        autoFocus: autofocus && index === 0,
                        onChange: handleChange(index),
                        onBlur: handleBlur,
                        onFocus: handleFocus,
                        "aria-describedby": (0, $8ce79fa261751f64$export$53c2204bb4091b57)(id)
                    });
                    return (0, $h4Bez.createElement)((0, $7ef9ef826e2d35ed$export$2e2bcd8739ae039), {
                        ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.formControlLabel,
                        control: checkbox,
                        key: String(option.value),
                        label: option.label
                    });
                })
            })
        ]
    });
}







function $7da58d609d1f1b04$export$2e2bcd8739ae039(props) {
    var _a;
    const { schema: schema, id: id, htmlName: htmlName, value: value, disabled: disabled, readonly: readonly, label: label = '', hideLabel: hideLabel, autofocus: autofocus, onChange: onChange, onBlur: onBlur, onFocus: onFocus, registry: registry, options: options, uiSchema: uiSchema } = props;
    const DescriptionFieldTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('DescriptionFieldTemplate', registry, options);
    // Because an unchecked checkbox will cause html5 validation to fail, only add
    // the "required" attribute if the field value must be "true", due to the
    // "const" or "enum" keywords
    const required = (0, $a2e0f2eb7f90d507$export$2e2bcd8739ae039)(schema);
    const handleChange = (_, checked)=>onChange(checked);
    const handleBlur = ()=>onBlur(id, value);
    const handleFocus = ()=>onFocus(id, value);
    const description = (_a = options.description) !== null && _a !== void 0 ? _a : schema.description;
    const { rjsfSlotProps: muiSlotProps, ...otherMuiProps } = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(options);
    return (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            !hideLabel && description && (0, $2e41620b030ed79e$exports.jsx)(DescriptionFieldTemplate, {
                id: (0, $8ce79fa261751f64$export$fd4f3344107bd22c)(id),
                description: description,
                schema: schema,
                uiSchema: uiSchema,
                registry: registry
            }),
            (0, $2e41620b030ed79e$exports.jsx)((0, $7ef9ef826e2d35ed$export$2e2bcd8739ae039), {
                ...otherMuiProps,
                ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.formControlLabel,
                control: (0, $2e41620b030ed79e$exports.jsx)((0, $96d9ff0232abe8ca$export$2e2bcd8739ae039), {
                    id: id,
                    name: htmlName || id,
                    checked: typeof value === 'undefined' ? false : Boolean(value),
                    required: required,
                    disabled: disabled || readonly,
                    autoFocus: autofocus,
                    onChange: handleChange,
                    onBlur: handleBlur,
                    onFocus: handleFocus,
                    "aria-describedby": (0, $8ce79fa261751f64$export$53c2204bb4091b57)(id),
                    ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.checkbox
                }),
                label: (0, $e15ee0fe5a70fe3e$export$2e2bcd8739ae039)(label, hideLabel, false)
            })
        ]
    });
}



var $h4Bez = parcelRequire("h4Bez");




var $h4Bez = parcelRequire("h4Bez");








'use client';
var $14423328fa681938$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');




'use client';
var $daf1f83ad5e916ae$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');






'use client';
const $d29fdaef8b7095d0$var$RadioButtonIconRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiRadioButtonIcon',
    shouldForwardProp: (0, $19087586f17e5d57$export$2e2bcd8739ae039)
})({
    position: 'relative',
    display: 'flex'
});
const $d29fdaef8b7095d0$var$RadioButtonIconBackground = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $14423328fa681938$export$2e2bcd8739ae039), {
    name: 'MuiRadioButtonIcon'
})({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $d29fdaef8b7095d0$var$RadioButtonIconDot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $daf1f83ad5e916ae$export$2e2bcd8739ae039), {
    name: 'MuiRadioButtonIcon'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    checked: true
                },
                style: {
                    transform: 'scale(1)',
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeOut,
                        duration: theme.transitions.duration.shortest
                    })
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ function $d29fdaef8b7095d0$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = {
        ...props,
        checked: checked
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($d29fdaef8b7095d0$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($d29fdaef8b7095d0$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($d29fdaef8b7095d0$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $d29fdaef8b7095d0$export$2e2bcd8739ae039 = $d29fdaef8b7095d0$var$RadioButtonIcon;




var $d87c921b374923d5$export$2e2bcd8739ae039 = (0, $f632681c6d4a0a8c$export$2e2bcd8739ae039);




var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");
'use client';
/**
 * @ignore - internal component.
 */ const $be1f739236f3addd$var$RadioGroupContext = /*#__PURE__*/ $h4Bez.createContext(undefined);
var $be1f739236f3addd$export$2e2bcd8739ae039 = $be1f739236f3addd$var$RadioGroupContext;


'use client';
function $02898097e8d53b05$export$2e2bcd8739ae039() {
    return $h4Bez.useContext((0, $be1f739236f3addd$export$2e2bcd8739ae039));
}




function $ded47eb8ba520f70$export$192f7b2363c77155(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiRadio', slot);
}
const $ded47eb8ba520f70$var$radioClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $ded47eb8ba520f70$export$2e2bcd8739ae039 = $ded47eb8ba520f70$var$radioClasses;









'use client';
const $a208f667fd31f221$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            size !== 'medium' && `size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return {
        ...classes,
        ...(0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $ded47eb8ba520f70$export$192f7b2363c77155), classes)
    };
};
const $a208f667fd31f221$var$RadioRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $3bb54a012d66bf14$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $19087586f17e5d57$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $ded47eb8ba520f70$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    color: 'default',
                    disabled: false,
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false
                    },
                    style: {
                        [`&.${(0, $ded47eb8ba520f70$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
function $a208f667fd31f221$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $a208f667fd31f221$var$defaultCheckedIcon = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d29fdaef8b7095d0$export$2e2bcd8739ae039), {
    checked: true
});
const $a208f667fd31f221$var$defaultIcon = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d29fdaef8b7095d0$export$2e2bcd8739ae039), {});
const $a208f667fd31f221$var$Radio = /*#__PURE__*/ $h4Bez.forwardRef(function Radio(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $a208f667fd31f221$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $a208f667fd31f221$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className, disabled: disabledProp, disableRipple: disableRipple = false, slots: slots = {}, slotProps: slotProps = {}, inputProps: inputProps, ...other } = props;
    const muiFormControl = (0, $364d4e99dd433e44$export$2e2bcd8739ae039)();
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    disabled ??= false;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableRipple: disableRipple,
        color: color,
        size: size
    };
    const classes = $a208f667fd31f221$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $02898097e8d53b05$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $d87c921b374923d5$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $a208f667fd31f221$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $a208f667fd31f221$var$RadioRoot,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event, ...args)=>{
                    handlers.onChange?.(event, ...args);
                    onChange(event, ...args);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            type: 'radio',
            icon: /*#__PURE__*/ $h4Bez.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $h4Bez.cloneElement(checkedIcon, {
                fontSize: checkedIcon.props.fontSize ?? size
            }),
            disabled: disabled,
            name: name,
            checked: checked,
            slots: slots,
            slotProps: {
                // Do not forward `slotProps.root` again because it's already handled by the `RootSlot` in this file.
                input: typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps
            }
        }
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $a208f667fd31f221$export$2e2bcd8739ae039 = $a208f667fd31f221$var$Radio;



var $h4Bez = parcelRequire("h4Bez");






function $1b0bb708659e312b$export$c4cff3a43f7cabb6(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiRadioGroup', slot);
}
const $1b0bb708659e312b$var$radioGroupClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiRadioGroup', [
    'root',
    'row',
    'error'
]);
var $1b0bb708659e312b$export$2e2bcd8739ae039 = $1b0bb708659e312b$var$radioGroupClasses;







'use client';
const $fdb54a60d37f95d9$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $1b0bb708659e312b$export$c4cff3a43f7cabb6), classes);
};
const $fdb54a60d37f95d9$var$RadioGroup = /*#__PURE__*/ $h4Bez.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp, ...other } = props;
    const rootRef = $h4Bez.useRef(null);
    const classes = $fdb54a60d37f95d9$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $7e1e510fcc288095$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    $h4Bez.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $6fa00ac7fde563d8$export$2e2bcd8739ae039)(ref, rootRef);
    const name = (0, $05678a2096742019$export$2e2bcd8739ae039)(nameProp);
    const contextValue = $h4Bez.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $be1f739236f3addd$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $81c4e0646fa4b7c0$export$2e2bcd8739ae039), {
            role: "radiogroup",
            ref: handleRef,
            className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
            ...other,
            children: children
        })
    });
});
var $fdb54a60d37f95d9$export$2e2bcd8739ae039 = $fdb54a60d37f95d9$var$RadioGroup;




function $bd560cf988b661f8$export$2e2bcd8739ae039(props) {
    const { id: id, htmlName: htmlName, options: options, value: value, required: required, disabled: disabled, readonly: readonly, label: label, hideLabel: hideLabel, onChange: onChange, onBlur: onBlur, onFocus: onFocus } = props;
    const { enumOptions: enumOptions, enumDisabled: enumDisabled, emptyValue: emptyValue } = options;
    const optionValueFormat = (0, $b28583320c2e364e$export$2e2bcd8739ae039)(options);
    const handleChange = (_, enumValue)=>onChange((0, $d751b2609dc272ff$export$2e2bcd8739ae039)(enumValue, enumOptions, optionValueFormat, emptyValue));
    const handleBlur = ({ target: target })=>onBlur(id, (0, $d751b2609dc272ff$export$2e2bcd8739ae039)(target && target.value, enumOptions, optionValueFormat, emptyValue));
    const handleFocus = ({ target: target })=>onFocus(id, (0, $d751b2609dc272ff$export$2e2bcd8739ae039)(target && target.value, enumOptions, optionValueFormat, emptyValue));
    const row = options ? options.inline : false;
    const selectValue = (0, $d9eabbfa9629bc80$export$2e2bcd8739ae039)(value, enumOptions, false, optionValueFormat, '');
    const { rjsfSlotProps: muiSlotProps, ...otherMuiProps } = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(options);
    return (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            (0, $e15ee0fe5a70fe3e$export$2e2bcd8739ae039)((0, $2e41620b030ed79e$exports.jsx)((0, $f1635ddd0790fd36$export$2e2bcd8739ae039), {
                required: required,
                htmlFor: id,
                children: label || undefined
            }), hideLabel),
            (0, $2e41620b030ed79e$exports.jsx)((0, $fdb54a60d37f95d9$export$2e2bcd8739ae039), {
                ...otherMuiProps,
                ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.radioGroup,
                id: id,
                name: htmlName || id,
                value: selectValue,
                row: row,
                onChange: handleChange,
                onBlur: handleBlur,
                onFocus: handleFocus,
                "aria-describedby": (0, $8ce79fa261751f64$export$53c2204bb4091b57)(id),
                children: Array.isArray(enumOptions) && enumOptions.map((option, index)=>{
                    const itemDisabled = Array.isArray(enumDisabled) && enumDisabled.includes(option.value);
                    const radio = (0, $h4Bez.createElement)((0, $7ef9ef826e2d35ed$export$2e2bcd8739ae039), {
                        ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.formControlLabel,
                        control: (0, $2e41620b030ed79e$exports.jsx)((0, $a208f667fd31f221$export$2e2bcd8739ae039), {
                            ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.radio,
                            name: htmlName || id,
                            id: (0, $8ce79fa261751f64$export$edf9b44aa62de7dd)(id, index),
                            color: 'primary'
                        }),
                        label: option.label,
                        value: (0, $36f1d7e65b39cdba$export$2e2bcd8739ae039)(option.value, index, optionValueFormat),
                        key: String(option.value),
                        disabled: disabled || itemDisabled || readonly
                    });
                    return radio;
                })
            })
        ]
    });
}





var $h4Bez = parcelRequire("h4Bez");








var $h4Bez = parcelRequire("h4Bez");









function $8ef3c232b918d431$var$areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var $8ef3c232b918d431$export$2e2bcd8739ae039 = $8ef3c232b918d431$var$areArraysEqual;


'use client';
const $8751db46a7cdfe08$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function $8751db46a7cdfe08$var$getNewValue(currentValue, step, direction, min, max) {
    return direction === 1 ? Math.min(currentValue + step, max) : Math.max(currentValue - step, min);
}
function $8751db46a7cdfe08$var$asc(a, b) {
    return a - b;
}
function $8751db46a7cdfe08$var$findClosest(values, currentValue) {
    const { index: closestIndex } = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null) ?? {};
    return closestIndex;
}
function $8751db46a7cdfe08$var$trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $8751db46a7cdfe08$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $8751db46a7cdfe08$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $8751db46a7cdfe08$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $8751db46a7cdfe08$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($8751db46a7cdfe08$var$getDecimalPrecision(step)));
}
function $8751db46a7cdfe08$var$setValueIndex({ values: values, newValue: newValue, index: index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($8751db46a7cdfe08$var$asc);
}
function $8751db46a7cdfe08$var$focusThumb({ sliderRef: sliderRef, activeIndex: activeIndex, setActive: setActive }) {
    const doc = (0, $2e2b971777d65c3c$export$2e2bcd8739ae039)(sliderRef.current);
    if (!sliderRef.current?.contains(doc.activeElement) || Number(doc?.activeElement?.getAttribute('data-index')) !== activeIndex) sliderRef.current?.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    if (setActive) setActive(activeIndex);
}
function $8751db46a7cdfe08$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, $8ef3c232b918d431$export$2e2bcd8739ae039)(newValue, oldValue);
    return false;
}
const $8751db46a7cdfe08$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $8751db46a7cdfe08$export$544bf02140fa9a77 = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let $8751db46a7cdfe08$var$cachedSupportsTouchActionNone;
function $8751db46a7cdfe08$var$doesSupportTouchActionNone() {
    if ($8751db46a7cdfe08$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') $8751db46a7cdfe08$var$cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else $8751db46a7cdfe08$var$cachedSupportsTouchActionNone = true;
    }
    return $8751db46a7cdfe08$var$cachedSupportsTouchActionNone;
}
function $8751db46a7cdfe08$export$56b2c08e277f365(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', rootRef: ref, scale: scale = $8751db46a7cdfe08$export$544bf02140fa9a77, step: step = 1, shiftStep: shiftStep = 10, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchId = $h4Bez.useRef(undefined);
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $h4Bez.useState(-1);
    const [open, setOpen] = $h4Bez.useState(-1);
    const [dragging, setDragging] = $h4Bez.useState(false);
    const moveCount = $h4Bez.useRef(0);
    // lastChangedValue is updated whenever onChange is triggered.
    const lastChangedValue = $h4Bez.useRef(null);
    const [valueDerived, setValueState] = (0, $1e812888fb3f7236$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue ?? min,
        name: 'Slider'
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        lastChangedValue.current = value;
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort($8751db46a7cdfe08$var$asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, $8ece3559f62aa728$export$2e2bcd8739ae039)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const [focusedThumbIndex, setFocusedThumbIndex] = $h4Bez.useState(-1);
    const sliderRef = $h4Bez.useRef(null);
    const handleRef = (0, $4fa58c431bc87919$export$2e2bcd8739ae039)(ref, sliderRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            const index = Number(event.currentTarget.getAttribute('data-index'));
            if ((0, $90a9a7d90476ac81$export$2e2bcd8739ae039)(event.target)) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers?.onFocus?.(event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            if (!(0, $90a9a7d90476ac81$export$2e2bcd8739ae039)(event.target)) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers?.onBlur?.(event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute('data-index'));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue >= maxMarksValue) newValue = maxMarksValue;
            else if (newValue <= marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, $8ece3559f62aa728$export$2e2bcd8739ae039)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $8ece3559f62aa728$export$2e2bcd8739ae039)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = $8751db46a7cdfe08$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: index
            });
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            $8751db46a7cdfe08$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex
            });
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (handleChange && !$8751db46a7cdfe08$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        if (onChangeCommitted) onChangeCommitted(event, lastChangedValue.current ?? newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            if ([
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight',
                'PageUp',
                'PageDown',
                'Home',
                'End'
            ].includes(event.key)) {
                event.preventDefault();
                const index = Number(event.currentTarget.getAttribute('data-index'));
                const value = values[index];
                let newValue = null;
                // Keys actions that change the value by more than the most granular `step`
                // value are only applied if the step not `null`.
                // When step is `null`, the `marks` prop is used instead to define valid values.
                if (step != null) {
                    const stepSize = event.shiftKey ? shiftStep : step;
                    switch(event.key){
                        case 'ArrowUp':
                            newValue = $8751db46a7cdfe08$var$getNewValue(value, stepSize, 1, min, max);
                            break;
                        case 'ArrowRight':
                            newValue = $8751db46a7cdfe08$var$getNewValue(value, stepSize, isRtl ? -1 : 1, min, max);
                            break;
                        case 'ArrowDown':
                            newValue = $8751db46a7cdfe08$var$getNewValue(value, stepSize, -1, min, max);
                            break;
                        case 'ArrowLeft':
                            newValue = $8751db46a7cdfe08$var$getNewValue(value, stepSize, isRtl ? 1 : -1, min, max);
                            break;
                        case 'PageUp':
                            newValue = $8751db46a7cdfe08$var$getNewValue(value, shiftStep, 1, min, max);
                            break;
                        case 'PageDown':
                            newValue = $8751db46a7cdfe08$var$getNewValue(value, shiftStep, -1, min, max);
                            break;
                        case 'Home':
                            newValue = min;
                            break;
                        case 'End':
                            newValue = max;
                            break;
                        default:
                            break;
                    }
                } else if (marks) {
                    const maxMarksValue = marksValues[marksValues.length - 1];
                    const currentMarkIndex = marksValues.indexOf(value);
                    const decrementKeys = [
                        isRtl ? 'ArrowRight' : 'ArrowLeft',
                        'ArrowDown',
                        'PageDown',
                        'Home'
                    ];
                    const incrementKeys = [
                        isRtl ? 'ArrowLeft' : 'ArrowRight',
                        'ArrowUp',
                        'PageUp',
                        'End'
                    ];
                    if (decrementKeys.includes(event.key)) {
                        if (currentMarkIndex === 0) newValue = marksValues[0];
                        else newValue = marksValues[currentMarkIndex - 1];
                    } else if (incrementKeys.includes(event.key)) {
                        if (currentMarkIndex === marksValues.length - 1) newValue = maxMarksValue;
                        else newValue = marksValues[currentMarkIndex + 1];
                    }
                }
                if (newValue != null) changeValue(event, newValue);
            }
            otherHandlers?.onKeyDown?.(event);
        };
    (0, $01a3a2b63fe8dafe$export$2e2bcd8739ae039)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) // This is necessary because Firefox and Safari will keep focus
        // on a disabled element:
        // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
        // @ts-ignore
        document.activeElement?.blur();
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            otherHandlers.onChange?.(event);
            // this handles value change by Pointer or Touch events
            // @ts-ignore
            changeValue(event, event.target.valueAsNumber);
        };
    const previousIndex = $h4Bez.useRef(undefined);
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    const getFingerNewValue = ({ finger: finger, move: move = false })=>{
        const { current: slider } = sliderRef;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.startsWith('vertical')) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.includes('-reverse')) percent = 1 - percent;
        let newValue;
        newValue = $8751db46a7cdfe08$var$percentToValue(percent, min, max);
        if (step) newValue = $8751db46a7cdfe08$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $8751db46a7cdfe08$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, $8ece3559f62aa728$export$2e2bcd8739ae039)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $8751db46a7cdfe08$var$findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $8ece3559f62aa728$export$2e2bcd8739ae039)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $8751db46a7cdfe08$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $8751db46a7cdfe08$var$trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
            finger: finger,
            move: true
        });
        $8751db46a7cdfe08$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > $8751db46a7cdfe08$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !$8751db46a7cdfe08$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $8751db46a7cdfe08$var$trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue: newValue } = getFingerNewValue({
            finger: finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, lastChangedValue.current ?? newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$8751db46a7cdfe08$var$doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = $8751db46a7cdfe08$var$trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                finger: finger
            });
            $8751db46a7cdfe08$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex,
                setActive: setActive
            });
            setValueState(newValue);
            if (handleChange && !$8751db46a7cdfe08$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, $2e2b971777d65c3c$export$2e2bcd8739ae039)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = $h4Bez.useCallback(()=>{
        const doc = (0, $2e2b971777d65c3c$export$2e2bcd8739ae039)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $h4Bez.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: $8751db46a7cdfe08$var$doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    $h4Bez.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseDown?.(event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = $8751db46a7cdfe08$var$trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                    finger: finger
                });
                $8751db46a7cdfe08$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex,
                    setActive: setActive
                });
                setValueState(newValue);
                if (handleChange && !$8751db46a7cdfe08$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, $2e2b971777d65c3c$export$2e2bcd8739ae039)(sliderRef.current);
            doc.addEventListener('mousemove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('mouseup', handleTouchEnd);
        };
    const trackOffset = $8751db46a7cdfe08$export$83ce4bc8280540e6(range ? values[0] : min, min, max);
    const trackLeap = $8751db46a7cdfe08$export$83ce4bc8280540e6(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, $6f1a7dc79a4af46c$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            ...externalProps,
            ref: handleRef,
            ...mergedEventHandlers
        };
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseOver?.(event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseLeave?.(event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, $6f1a7dc79a4af46c$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return {
            ...externalProps,
            ...externalHandlers,
            ...ownEventHandlers
        };
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined
        };
    };
    let cssWritingMode;
    if (orientation === 'vertical') cssWritingMode = isRtl ? 'vertical-rl' : 'vertical-lr';
    const getHiddenInputProps = (externalProps = {})=>{
        const externalHandlers = (0, $6f1a7dc79a4af46c$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            tabIndex: tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name: name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : parameters.step ?? undefined,
            disabled: disabled,
            ...externalProps,
            ...mergedEventHandlers,
            style: {
                ...(0, $7e4b04c742d6c9ba$export$2e2bcd8739ae039),
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%',
                writingMode: cssWritingMode
            }
        };
    };
    return {
        active: active,
        axis: axis,
        axisProps: $8751db46a7cdfe08$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}







const $bc72da5dfd73da92$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $4062a7b1f5a47416$export$2e2bcd8739ae039)(Slot);
};
var $bc72da5dfd73da92$export$2e2bcd8739ae039 = $bc72da5dfd73da92$var$shouldSpreadAdditionalProps;





var $h4Bez = parcelRequire("h4Bez");




function $21b17c7362c0e76c$export$9f59f2622d5cbc2a(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiSlider', slot);
}
const $21b17c7362c0e76c$var$sliderClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'thumbColorPrimary',
    'thumbColorSecondary',
    'thumbColorError',
    'thumbColorSuccess',
    'thumbColorInfo',
    'thumbColorWarning',
    'track',
    'trackInverted',
    'trackFalse',
    'thumbSizeSmall',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var $21b17c7362c0e76c$export$2e2bcd8739ae039 = $21b17c7362c0e76c$var$sliderClasses;



'use client';
const $688616bded2859b1$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(open && (0, $21b17c7362c0e76c$export$2e2bcd8739ae039).valueLabelOpen),
        circle: (0, $21b17c7362c0e76c$export$2e2bcd8739ae039).valueLabelCircle,
        label: (0, $21b17c7362c0e76c$export$2e2bcd8739ae039).valueLabelLabel
    };
    return utilityClasses;
};
function $688616bded2859b1$export$2e2bcd8739ae039(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $688616bded2859b1$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $h4Bez.cloneElement(children, {
        className: children.props.className
    }, /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($h4Bez.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
                className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}




'use client';
function $ff6b4308e8221bef$var$Identity(x) {
    return x;
}
const $ff6b4308e8221bef$export$c1a21b3b4da66aa1 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${(0, $21b17c7362c0e76c$export$2e2bcd8739ae039).disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${(0, $21b17c7362c0e76c$export$2e2bcd8739ae039).dragging}`]: {
            [`& .${(0, $21b17c7362c0e76c$export$2e2bcd8739ae039).thumb}, & .${(0, $21b17c7362c0e76c$export$2e2bcd8739ae039).track}`]: {
                transition: 'none'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 4,
                    width: '100%',
                    padding: '13px 0',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '20px 0'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    size: 'small'
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    width: 4,
                    padding: '0 13px',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '0 20px'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    })));
const $ff6b4308e8221bef$export$b02fde61a3559c2 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Rail'
})({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    backgroundColor: 'currentColor',
    opacity: 0.38,
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: '100%',
                height: 'inherit',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                height: '100%',
                width: 'inherit',
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        {
            props: {
                track: 'inverted'
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const $ff6b4308e8221bef$export$105594979f116971 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Track'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>{
    return {
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor',
        transition: theme.transitions.create([
            'left',
            'width',
            'bottom',
            'height'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    border: 'none'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'inherit',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    width: 'inherit',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: 'none'
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        track: 'inverted'
                    },
                    style: {
                        ...theme.vars ? {
                            backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                            borderColor: theme.vars.palette.Slider[`${color}Track`]
                        } : {
                            backgroundColor: theme.lighten(theme.palette[color].main, 0.62),
                            borderColor: theme.lighten(theme.palette[color].main, 0.62),
                            ...theme.applyStyles('dark', {
                                backgroundColor: theme.darken(theme.palette[color].main, 0.5)
                            }),
                            ...theme.applyStyles('dark', {
                                borderColor: theme.darken(theme.palette[color].main, 0.5)
                            })
                        }
                    }
                }))
        ]
    };
}));
const $ff6b4308e8221bef$export$2c1b491743890dec = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`thumbSize${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create([
            'box-shadow',
            'left',
            'bottom'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        '&::before': {
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&.${(0, $21b17c7362c0e76c$export$2e2bcd8739ae039).disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 12,
                    height: 12,
                    '&::before': {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 50%)'
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&:hover, &.${(0, $21b17c7362c0e76c$export$2e2bcd8739ae039).focusVisible}`]: {
                            boxShadow: `0px 0px 0px 8px ${theme.alpha((theme.vars || theme).palette[color].main, 0.16)}`,
                            '@media (hover: none)': {
                                boxShadow: 'none'
                            }
                        },
                        [`&.${(0, $21b17c7362c0e76c$export$2e2bcd8739ae039).active}`]: {
                            boxShadow: `0px 0px 0px 14px ${theme.alpha((theme.vars || theme).palette[color].main, 0.16)}`
                        }
                    }
                }))
        ]
    })));
const $ff6b4308e8221bef$export$6453176f504d54f0 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $688616bded2859b1$export$2e2bcd8739ae039), {
    name: 'MuiSlider',
    slot: 'ValueLabel'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: 1,
        whiteSpace: 'nowrap',
        ...theme.typography.body2,
        fontWeight: 500,
        transition: theme.transitions.create([
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    transform: 'translateY(-100%) scale(0)',
                    top: '-10px',
                    transformOrigin: 'bottom center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, 50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        bottom: 0,
                        left: '50%'
                    },
                    [`&.${(0, $21b17c7362c0e76c$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-100%) scale(1)'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    transform: 'translateY(-50%) scale(0)',
                    right: '30px',
                    top: '50%',
                    transformOrigin: 'right center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, -50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        right: -8,
                        top: '50%'
                    },
                    [`&.${(0, $21b17c7362c0e76c$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-50%) scale(1)'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: '0.25rem 0.5rem'
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    right: '20px'
                }
            }
        ]
    })));
const $ff6b4308e8221bef$export$6f85f6a3c5da6f62 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, $43f40a41b3374964$export$2e2bcd8739ae039)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-1px, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 1px)'
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    })));
const $ff6b4308e8221bef$export$e6cd369965e5aa95 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, $43f40a41b3374964$export$2e2bcd8739ae039)(prop) && prop !== 'markLabelActive'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body2,
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: 30,
                    transform: 'translateX(-50%)',
                    '@media (pointer: coarse)': {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: 36,
                    transform: 'translateY(50%)',
                    '@media (pointer: coarse)': {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    })));
const $ff6b4308e8221bef$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            size && `size${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled',
            size && `thumbSize${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(size)}`,
            color && `thumbColor${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $21b17c7362c0e76c$export$9f59f2622d5cbc2a), classes);
};
const $ff6b4308e8221bef$var$Forward = ({ children: children })=>children;
const $ff6b4308e8221bef$var$Slider = /*#__PURE__*/ $h4Bez.forwardRef(function Slider(inputProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inputProps,
        name: 'MuiSlider'
    });
    const isRtl = (0, $c12c19e2bf4d75c0$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, component: // eslint-disable-next-line react/prop-types
    component = 'span', components: components = {}, componentsProps: componentsProps = {}, color: color = 'primary', classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', shiftStep: shiftStep = 10, size: size = 'medium', step: step = 1, scale: scale = $ff6b4308e8221bef$var$Identity, slotProps: slotProps, slots: slots, tabIndex: tabIndex, track: track = 'normal', value: valueProp, valueLabelDisplay: valueLabelDisplay = 'off', valueLabelFormat: valueLabelFormat = $ff6b4308e8221bef$var$Identity, ...other } = props;
    const ownerState = {
        ...props,
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        shiftStep: shiftStep,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    };
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $8751db46a7cdfe08$export$56b2c08e277f365)({
        ...ownerState,
        rootRef: ref
    });
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $ff6b4308e8221bef$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = slots?.root ?? components.Root ?? $ff6b4308e8221bef$export$c1a21b3b4da66aa1;
    const RailSlot = slots?.rail ?? components.Rail ?? $ff6b4308e8221bef$export$b02fde61a3559c2;
    const TrackSlot = slots?.track ?? components.Track ?? $ff6b4308e8221bef$export$105594979f116971;
    const ThumbSlot = slots?.thumb ?? components.Thumb ?? $ff6b4308e8221bef$export$2c1b491743890dec;
    const ValueLabelSlot = slots?.valueLabel ?? components.ValueLabel ?? $ff6b4308e8221bef$export$6453176f504d54f0;
    const MarkSlot = slots?.mark ?? components.Mark ?? $ff6b4308e8221bef$export$6f85f6a3c5da6f62;
    const MarkLabelSlot = slots?.markLabel ?? components.MarkLabel ?? $ff6b4308e8221bef$export$e6cd369965e5aa95;
    const InputSlot = slots?.input ?? components.Input ?? 'input';
    const rootSlotProps = slotProps?.root ?? componentsProps.root;
    const railSlotProps = slotProps?.rail ?? componentsProps.rail;
    const trackSlotProps = slotProps?.track ?? componentsProps.track;
    const thumbSlotProps = slotProps?.thumb ?? componentsProps.thumb;
    const valueLabelSlotProps = slotProps?.valueLabel ?? componentsProps.valueLabel;
    const markSlotProps = slotProps?.mark ?? componentsProps.mark;
    const markLabelSlotProps = slotProps?.markLabel ?? componentsProps.markLabel;
    const inputSlotProps = slotProps?.input ?? componentsProps.input;
    const rootProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ...(0, $bc72da5dfd73da92$export$2e2bcd8739ae039)(RootSlot) && {
                as: component
            }
        },
        ownerState: {
            ...ownerState,
            ...rootSlotProps?.ownerState
        },
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const trackProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: {
                ...axisProps[axis].offset(trackOffset),
                ...axisProps[axis].leap(trackLeap)
            }
        },
        ownerState: {
            ...ownerState,
            ...trackSlotProps?.ownerState
        },
        className: classes.track
    });
    const thumbProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: {
            ...ownerState,
            ...thumbSlotProps?.ownerState
        },
        className: classes.thumb
    });
    const valueLabelProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: {
            ...ownerState,
            ...valueLabelSlotProps?.ownerState
        },
        className: classes.valueLabel
    });
    const markProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(RailSlot, {
                ...railProps
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(TrackSlot, {
                ...trackProps
            }),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $8751db46a7cdfe08$export$83ce4bc8280540e6)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.includes(mark.value);
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($h4Bez.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(MarkSlot, {
                            "data-index": index,
                            ...markProps,
                            ...!(0, $4062a7b1f5a47416$export$2e2bcd8739ae039)(MarkSlot) && {
                                markActive: markActive
                            },
                            style: {
                                ...style,
                                ...markProps.style
                            },
                            className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(markProps.className, markActive && classes.markActive)
                        }),
                        mark.label != null ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(MarkLabelSlot, {
                            "aria-hidden": true,
                            "data-index": index,
                            ...markLabelProps,
                            ...!(0, $4062a7b1f5a47416$export$2e2bcd8739ae039)(MarkLabelSlot) && {
                                markLabelActive: markActive
                            },
                            style: {
                                ...style,
                                ...markLabelProps.style
                            },
                            className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        }) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $8751db46a7cdfe08$export$83ce4bc8280540e6)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? $ff6b4308e8221bef$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $2e41620b030ed79e$exports.jsx)(ValueLabelComponent, {
                    ...!(0, $4062a7b1f5a47416$export$2e2bcd8739ae039)(ValueLabelComponent) && {
                        valueLabelFormat: valueLabelFormat,
                        valueLabelDisplay: valueLabelDisplay,
                        value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                        index: index,
                        open: open === index || active === index || valueLabelDisplay === 'on',
                        disabled: disabled
                    },
                    ...valueLabelProps,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(ThumbSlot, {
                        "data-index": index,
                        ...thumbProps,
                        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: {
                            ...style,
                            ...getThumbStyle(index),
                            ...thumbProps.style
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(InputSlot, {
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index],
                            ...inputSliderProps
                        })
                    })
                }, index);
            })
        ]
    });
});
var $ff6b4308e8221bef$export$2e2bcd8739ae039 = $ff6b4308e8221bef$var$Slider;




function $ac0af1fb1cf5313d$export$2e2bcd8739ae039(props) {
    const { value: value, readonly: readonly, disabled: disabled, onBlur: onBlur, onFocus: onFocus, options: options, schema: schema, onChange: onChange, required: required, label: label, hideLabel: hideLabel, id: id } = props;
    const sliderProps = {
        value: value,
        label: label,
        id: id,
        name: id,
        ...(0, $6a10f4d5ab83ec2e$export$2e2bcd8739ae039)(schema)
    };
    const handleChange = (_, newValue)=>{
        onChange(newValue !== null && newValue !== void 0 ? newValue : options.emptyValue);
    };
    const handleBlur = ({ target: target })=>onBlur(id, target && target.value);
    const handleFocus = ({ target: target })=>onFocus(id, target && target.value);
    const { rjsfSlotProps: muiSlotProps, ...otherMuiProps } = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(options);
    return (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            (0, $e15ee0fe5a70fe3e$export$2e2bcd8739ae039)((0, $2e41620b030ed79e$exports.jsx)((0, $f1635ddd0790fd36$export$2e2bcd8739ae039), {
                required: required,
                htmlFor: id,
                children: label || undefined
            }), hideLabel),
            (0, $2e41620b030ed79e$exports.jsx)((0, $ff6b4308e8221bef$export$2e2bcd8739ae039), {
                disabled: disabled || readonly,
                onChange: handleChange,
                onBlur: handleBlur,
                onFocus: handleFocus,
                valueLabelDisplay: 'auto',
                ...otherMuiProps,
                ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.slider,
                ...sliderProps,
                "aria-describedby": (0, $8ce79fa261751f64$export$53c2204bb4091b57)(id)
            })
        ]
    });
}







function $06d061900aba4222$export$2e2bcd8739ae039(props) {
    const { schema: schema, id: id, name: name, htmlName: htmlName, options: options, label: label, hideLabel: hideLabel, required: required, disabled: disabled, placeholder: placeholder, readonly: readonly, value: value, multiple: multiple, autofocus: autofocus, onChange: onChange, onBlur: onBlur, onFocus: onFocus, errorSchema: errorSchema, rawErrors: rawErrors = [], registry: registry, uiSchema: uiSchema, hideError: hideError, ...textFieldProps } = props;
    const { enumOptions: enumOptions, enumDisabled: enumDisabled, emptyValue: optEmptyVal } = options;
    const optionValueFormat = (0, $b28583320c2e364e$export$2e2bcd8739ae039)(options);
    const isMultiple = typeof multiple === 'undefined' ? false : !!multiple;
    const emptyValue = isMultiple ? [] : '';
    const isEmpty = typeof value === 'undefined' || isMultiple && value.length < 1 || !isMultiple && value === emptyValue;
    const handleChange = ({ target: { value: newValue } })=>onChange((0, $d751b2609dc272ff$export$2e2bcd8739ae039)(newValue, enumOptions, optionValueFormat, optEmptyVal));
    const handleBlur = ({ target: target })=>onBlur(id, (0, $d751b2609dc272ff$export$2e2bcd8739ae039)(target && target.value, enumOptions, optionValueFormat, optEmptyVal));
    const handleFocus = ({ target: target })=>onFocus(id, (0, $d751b2609dc272ff$export$2e2bcd8739ae039)(target && target.value, enumOptions, optionValueFormat, optEmptyVal));
    const { rjsfSlotProps: muiSlotProps, ...otherMuiProps } = (0, $eba4f82aa8d01df6$export$aa0a393b09ccbcf1)(options);
    const { InputLabelProps: InputLabelProps, SelectProps: SelectProps, autocomplete: autocomplete, ...textFieldRemainingProps } = textFieldProps;
    const showPlaceholderOption = !isMultiple && schema.default === undefined;
    return (0, $2e41620b030ed79e$exports.jsxs)((0, $556393662cf0f57c$export$2e2bcd8739ae039), {
        id: id,
        name: htmlName || id,
        label: (0, $e15ee0fe5a70fe3e$export$2e2bcd8739ae039)(label || undefined, hideLabel, undefined),
        value: (0, $d9eabbfa9629bc80$export$2e2bcd8739ae039)(value, enumOptions, isMultiple, optionValueFormat, emptyValue),
        required: required,
        disabled: disabled || readonly,
        autoFocus: autofocus,
        autoComplete: autocomplete,
        placeholder: placeholder,
        error: rawErrors.length > 0,
        onChange: handleChange,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ...{
            ...otherMuiProps,
            ...textFieldRemainingProps
        },
        select: true,
        slotProps: {
            ...muiSlotProps,
            inputLabel: {
                ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.inputLabel,
                shrink: !isEmpty
            },
            select: {
                ...muiSlotProps === null || muiSlotProps === void 0 ? void 0 : muiSlotProps.select,
                multiple: multiple
            }
        },
        "aria-describedby": (0, $8ce79fa261751f64$export$53c2204bb4091b57)(id),
        children: [
            showPlaceholderOption && (0, $2e41620b030ed79e$exports.jsx)((0, $b7bd066558465dcb$export$2e2bcd8739ae039), {
                value: '',
                children: placeholder
            }),
            Array.isArray(enumOptions) && enumOptions.map(({ value: enumValue, label: enumLabel }, i)=>{
                const isDisabled = Array.isArray(enumDisabled) && enumDisabled.includes(enumValue);
                return (0, $2e41620b030ed79e$exports.jsx)((0, $b7bd066558465dcb$export$2e2bcd8739ae039), {
                    value: (0, $36f1d7e65b39cdba$export$2e2bcd8739ae039)(enumValue, i, optionValueFormat),
                    disabled: isDisabled,
                    children: enumLabel
                }, String(enumValue));
            })
        ]
    });
}




function $5fb5ab383e691c98$export$2e2bcd8739ae039(props) {
    const { options: options, registry: registry } = props;
    const BaseInputTemplate = (0, $f037e3283241319d$export$2e2bcd8739ae039)('BaseInputTemplate', registry, options);
    let rows = 5;
    if (typeof options.rows === 'string' || typeof options.rows === 'number') rows = options.rows;
    return (0, $2e41620b030ed79e$exports.jsx)(BaseInputTemplate, {
        ...props,
        multiline: true,
        rows: rows
    });
}


function $334a2ab35f24aac0$export$1aecb682ab169b4b() {
    return {
        CheckboxWidget: $7da58d609d1f1b04$export$2e2bcd8739ae039,
        CheckboxesWidget: $23154cb84fb19534$export$2e2bcd8739ae039,
        RadioWidget: $bd560cf988b661f8$export$2e2bcd8739ae039,
        RangeWidget: $ac0af1fb1cf5313d$export$2e2bcd8739ae039,
        SelectWidget: $06d061900aba4222$export$2e2bcd8739ae039,
        TextareaWidget: $5fb5ab383e691c98$export$2e2bcd8739ae039
    };
}
var $334a2ab35f24aac0$export$2e2bcd8739ae039 = $334a2ab35f24aac0$export$1aecb682ab169b4b();




function $eaeb80f15ea90d9d$export$2e4ecffaca289a18() {
    return {
        templates: (0, $d2da634c97cf8a6e$export$a36e13f901c0a29c)(),
        widgets: (0, $334a2ab35f24aac0$export$1aecb682ab169b4b)()
    };
}
var $eaeb80f15ea90d9d$export$2e2bcd8739ae039 = $eaeb80f15ea90d9d$export$2e4ecffaca289a18();




function $4c4d5d59b3a948e5$export$ad970bc513b1e132() {
    return (0, $695e714327ae63c8$export$2e2bcd8739ae039)((0, $eaeb80f15ea90d9d$export$2e4ecffaca289a18)());
}
var $4c4d5d59b3a948e5$export$2e2bcd8739ae039 = $4c4d5d59b3a948e5$export$ad970bc513b1e132();








var $f7eb8ba66d2fccbf$export$2e2bcd8739ae039 = (0, $4c4d5d59b3a948e5$export$2e2bcd8739ae039);






const $56b3a9122bbdf87b$export$826692b3b4ae1423 = (componentName)=>(0, $beec4324cbd609ea$export$6b4e15ccdc547ae7)(()=>{
        throw new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Form component is not expected to be in use', {
            componentName: componentName
        });
    }, componentName);
const $56b3a9122bbdf87b$var$createButtonFormComponent = (label, Icon, variant)=>({ uiSchema: uiSchema, registry: registry, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
            ...props,
            title: registry.translateString(label),
            variant: variant,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Icon, {
                fontSize: "small"
            })
        });
const $56b3a9122bbdf87b$var$arrayFieldTitleTemplateDividerStyle = {
    mb: 2
};
const $56b3a9122bbdf87b$var$formTheme = {
    ...(0, $eaeb80f15ea90d9d$export$2e2bcd8739ae039),
    templates: {
        ...(0, $d2da634c97cf8a6e$export$2e2bcd8739ae039),
        ButtonTemplates: {
            ...(0, $d2da634c97cf8a6e$export$2e2bcd8739ae039).ButtonTemplates,
            /** Hides the submit button (and only the submit button) */ SubmitButton: ()=>null,
            AddButton: $56b3a9122bbdf87b$var$createButtonFormComponent((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).AddItemButton, (0, $ec5894a60f9e2c5f$export$a6b7c34d56975de0), 'ghost'),
            RemoveButton: $56b3a9122bbdf87b$var$createButtonFormComponent((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).RemoveButton, (0, $7e6e60d0b721be32$export$cb808a3c41736d8e), 'dangerGhost'),
            MoveDownButton: $56b3a9122bbdf87b$var$createButtonFormComponent((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).MoveDownButton, (0, $8918db21d3652fbb$export$1c939d3c9b6931b), 'ghost'),
            MoveUpButton: $56b3a9122bbdf87b$var$createButtonFormComponent((0, $b63837cd47cf776b$export$e8ce1f619d132f5c).MoveUpButton, (0, $1adece5071bb7b44$export$f1a507b991affc46), 'ghost'),
            CopyButton: $56b3a9122bbdf87b$export$826692b3b4ae1423('CopyButton'),
            ClearButton: $56b3a9122bbdf87b$export$826692b3b4ae1423('ClearButton')
        },
        ErrorListTemplate: $56b3a9122bbdf87b$export$826692b3b4ae1423('ErrorListTemplate'),
        OptionalDataControlsTemplate: $56b3a9122bbdf87b$export$826692b3b4ae1423('OptionalDataControlsTemplate'),
        DescriptionFieldTemplate: ({ description: description })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "body2",
                children: description
            }),
        ArrayFieldTitleTemplate: ({ title: title })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        variant: "h6",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {
                        sx: $56b3a9122bbdf87b$var$arrayFieldTitleTemplateDividerStyle
                    })
                ]
            })
    }
};
const $56b3a9122bbdf87b$var$primitiveRemaps = new Set([
    'string',
    'number',
    'integer',
    'boolean'
]);
/**
 * When a @rjsf form has one of its fields emptied, it falls back to use the default
 * That is, if someone removes all the characters in a field, the default value will pop in its place
 *
 * This function avoids the odd behaviour by, when emptied, marking the field as empty
 *
 * @see {primitiveRemaps}
 *
 * A `secret: true` property always has its default stripped too, regardless of type: a schema
 * default is never a value the user typed, and rjsf fills it into formData for any field missing
 * from the (already secret-stripped) parameters — see `getSecretParameterNames`
 */ const $56b3a9122bbdf87b$var$simplifyDefaults = (schema)=>{
    let out = schema;
    /** The schemas provided by the backend don´t come as boolean, so just ignore it */ (0, $14eddac5f20c576c$export$a7a9523472993e97)(typeof out !== 'boolean', new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Unexpected schema loaded in parameters form'));
    /** Step into object properties recursively */ if (out.properties) out = {
        ...out,
        properties: Object.fromEntries((0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(out.properties).map(([name, value])=>[
                name,
                $56b3a9122bbdf87b$var$simplifyDefaults(value)
            ]))
    };
    /** Step into array items recursively */ if ((0, $66f4d76e5f79376d$export$8afc0f4daad61937)(out.items)) out = {
        ...out,
        items: $56b3a9122bbdf87b$var$simplifyDefaults(out.items)
    };
    else if ((0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(out.items)) out = {
        ...out,
        items: out.items.map((v)=>$56b3a9122bbdf87b$var$simplifyDefaults(v))
    };
    if ((0, $e8356e494d58a419$export$596b4af045cf788a)(out) || typeof out.type === 'string' && $56b3a9122bbdf87b$var$primitiveRemaps.has(out.type)) /** Replace the value with absence */ out = (0, $2ae70427bab197d4$export$12b617052eb9d30e)(out, 'default');
    return out;
};
const $56b3a9122bbdf87b$export$a7fed597f4b8afd8 = ({ emptyForm: emptyForm, schema: schema, onChange: onChange, ...props })=>{
    const theme = (0, $cd99783e1cac2d84$export$2e2bcd8739ae039)();
    const ThemedForm = (0, $h4Bez.useMemo)(()=>(0, $695e714327ae63c8$export$2e2bcd8739ae039)($56b3a9122bbdf87b$var$formTheme), []);
    const validator = (0, $h4Bez.useMemo)(()=>(0, $a666c083b1ae8fcf$export$2e2bcd8739ae039)(), []);
    const simplifiedSchema = (0, $h4Bez.useMemo)(()=>$56b3a9122bbdf87b$var$simplifyDefaults(schema), [
        schema
    ]);
    if (!simplifiedSchema.properties || (0, $2ae70427bab197d4$export$dd1bc94b04021eeb)(simplifiedSchema.properties)) /** No properties? Just render the empty notice */ return emptyForm;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bed3dc7f03d1e028$export$2e2bcd8739ae039), {
        theme: {
            ...theme,
            components: {
                ...theme.components,
                /**
                     * Forces text fields to follow standard styling
                     * TODO Remove these components overrides,
                     * TODO RJSF form should use input fields defined in our theme.
                     * @see https://cybusio.atlassian.net/browse/CC-4594
                     */ MuiTextField: {
                    defaultProps: {
                        variant: 'standard'
                    }
                }
            }
        },
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(ThemedForm, {
            ...props,
            schema: simplifiedSchema,
            validator: validator,
            showErrorList: false,
            liveValidate: true,
            onChange: ({ formData: formData })=>{
                /**
                     * In @rjsf v6 the formData prop is marked as non-mandatory through its whole type system.
                     * We never pass an undefined value, so no undefined value should be expected
                     */ (0, $14eddac5f20c576c$export$a7a9523472993e97)(formData !== undefined, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Form is not expected to be undefined'));
                onChange(formData);
            }
        })
    });
};



var $h4Bez = parcelRequire("h4Bez");





const { Provider: $82193370bd77ac54$export$ff94dd2d732b0bd7, useExtendedState: $82193370bd77ac54$var$useExtendedState } = (0, $08b3e6ee09ecfd12$export$e50ad042342a539d)({
    ignorePropsChanges: true
});
const $82193370bd77ac54$export$ef72d83c692419e2 = (k)=>$82193370bd77ac54$var$useExtendedState((s)=>s[k]);


const $6a53eadc42eca0ef$var$useUsecase = ()=>(0, $be523f14267dcd17$export$b5eb5d2a4e80beed)((0, $82193370bd77ac54$export$ef72d83c692419e2)('usecase'));
const $6a53eadc42eca0ef$var$creatingByUsecase = {
    addServiceUsecase: true,
    updateServiceUsecase: false
};
/**
 * Only a form of this modal's own kind counts, so a creation modal and an update modal mounted together never both open
 */ const $6a53eadc42eca0ef$var$useServiceForm = (selector, defaultValue)=>{
    const creating = $6a53eadc42eca0ef$var$creatingByUsecase[(0, $82193370bd77ac54$export$ef72d83c692419e2)('usecase')];
    return (0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>{
        const form = (0, $d8a939fc8bdc4e6b$export$dc85b0c2a4f8ef64)(s);
        return form?.creating === creating ? selector(form) : defaultValue;
    });
};
const $6a53eadc42eca0ef$export$bc98e171e8c82a3d = ()=>(0, $82193370bd77ac54$export$ef72d83c692419e2)('title');
const $6a53eadc42eca0ef$export$80c95c9c90c9b494 = ()=>(0, $82193370bd77ac54$export$ef72d83c692419e2)('noConfigurationText');
const $6a53eadc42eca0ef$export$7ca3db485322a63a = ()=>(0, $82193370bd77ac54$export$ef72d83c692419e2)('configurationTitle');
const $6a53eadc42eca0ef$export$c95fe5f8f8b753c2 = ()=>(0, $82193370bd77ac54$export$ef72d83c692419e2)('confirmationButtonText');
const $6a53eadc42eca0ef$export$1e150b49a5cf5889 = ()=>(0, $82193370bd77ac54$export$ef72d83c692419e2)('dismissalButtonText');
const $6a53eadc42eca0ef$export$11095004166ed57e = ()=>(0, $82193370bd77ac54$export$ef72d83c692419e2)('hasNumberedSteps');
const $6a53eadc42eca0ef$export$2da7aef02c1d55c6 = ()=>(0, $82193370bd77ac54$export$ef72d83c692419e2)('isEditable');
const $6a53eadc42eca0ef$export$22404ef8e73ca1e3 = ()=>(0, $82193370bd77ac54$export$ef72d83c692419e2)('shouldShowUploadInstructions');
const $6a53eadc42eca0ef$export$f48224de87d33a65 = ()=>$6a53eadc42eca0ef$var$useServiceForm(()=>true, false);
const $6a53eadc42eca0ef$export$4b184e2ada51fe5f = ()=>$6a53eadc42eca0ef$var$useServiceForm((f)=>f.requesting, false);
const $6a53eadc42eca0ef$export$a7af614c0f08d4b7 = ()=>$6a53eadc42eca0ef$var$useServiceForm((f)=>typeof f.file === 'string' ? f.file : null, null);
const $6a53eadc42eca0ef$export$5027865de34f9ec6 = ()=>$6a53eadc42eca0ef$var$useServiceForm(({ requesting: requesting, file: file, schema: schema })=>[
            requesting,
            file,
            schema
        ].find((e)=>(0, $c3e1b746ad236797$export$8d524fb6540252df).is(e)) || null, null);
const $6a53eadc42eca0ef$export$aecd9c955413bc92 = ()=>$6a53eadc42eca0ef$var$useServiceForm((f)=>f.schema, null);
const $6a53eadc42eca0ef$export$96f5e8917642ff51 = ()=>$6a53eadc42eca0ef$var$useServiceForm((f)=>f.parameters, null);
const $6a53eadc42eca0ef$export$f718397ceab26c17 = ()=>$6a53eadc42eca0ef$var$useServiceForm((f)=>Boolean(f.parameters), false);
const $6a53eadc42eca0ef$export$f680877a34711e37 = ()=>$6a53eadc42eca0ef$var$useServiceForm((f)=>f.id, null);
const $6a53eadc42eca0ef$export$f7baf2d4328e611b = ()=>{
    const usecase = $6a53eadc42eca0ef$var$useUsecase();
    return ()=>usecase.cancel();
};
const $6a53eadc42eca0ef$export$bf4da147a5964edb = ()=>{
    const usecase = $6a53eadc42eca0ef$var$useUsecase();
    const onConfirmed = (0, $82193370bd77ac54$export$ef72d83c692419e2)('onConfirmed');
    const [confirm] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(async ()=>{
        const id = await usecase.confirm();
        if (id !== null && onConfirmed) onConfirmed(id);
    }, [
        onConfirmed,
        usecase
    ]);
    return confirm;
};
const $6a53eadc42eca0ef$export$55ffdddd106a1960 = ()=>{
    const usecase = $6a53eadc42eca0ef$var$useUsecase();
    return (0, $h4Bez.useMemo)(()=>usecase.getSupportedServiceCommissioningFileExtensions(), [
        usecase
    ]);
};
const $6a53eadc42eca0ef$export$424ae8d8e2ee85ac = ()=>{
    const usecase = $6a53eadc42eca0ef$var$useUsecase();
    const [onFileChange] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)((file)=>usecase.updateCommissioningFile(file));
    return onFileChange;
};
const $6a53eadc42eca0ef$export$529e27799c84ec42 = ()=>{
    const usecase = $6a53eadc42eca0ef$var$useUsecase();
    return (0, $h4Bez.useMemo)(()=>usecase.getServiceManagementMode() === (0, $703a0e0813d6ac75$export$9eafce13aba72038).CREATION, [
        usecase
    ]);
};
const $6a53eadc42eca0ef$export$6bd78af97f4a4340 = ()=>{
    const usecase = $6a53eadc42eca0ef$var$useUsecase();
    return (...params)=>usecase.updateServiceParameters(...params);
};
const $6a53eadc42eca0ef$export$1ad42cf9b00bda68 = ()=>{
    const [type] = $6a53eadc42eca0ef$export$55ffdddd106a1960();
    const id = $6a53eadc42eca0ef$export$f680877a34711e37();
    const content = $6a53eadc42eca0ef$export$a7af614c0f08d4b7();
    return (0, $h4Bez.useMemo)(()=>id && content ? new File([
            content
        ], `${id}.${type}`) : null, [
        type,
        id,
        content
    ]);
};
const $6a53eadc42eca0ef$export$8aea33bc635080c2 = ()=>{
    const usecase = $6a53eadc42eca0ef$var$useUsecase();
    const id = $6a53eadc42eca0ef$export$f680877a34711e37();
    const requesting = $6a53eadc42eca0ef$export$4b184e2ada51fe5f();
    const parameters = $6a53eadc42eca0ef$export$96f5e8917642ff51();
    const isEditable = $6a53eadc42eca0ef$export$2da7aef02c1d55c6();
    return (0, $h4Bez.useMemo)(()=>!isEditable || !usecase.isConfirmationRequestValid(), [
        usecase,
        isEditable,
        id,
        requesting,
        parameters
    ]);
};




var $h4Bez = parcelRequire("h4Bez");




const $ac596103cca5a04e$export$54e433fa95d6c8dd = ({ id: id, label: label, value: value, required: required, disabled: disabled, readonly: readonly, options: options, onChange: onChange })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    /** The read-only view dialog must not offer any interaction, same as disabled */ const inactive = Boolean(disabled) || Boolean(readonly);
    const creating = options?.creating === true;
    const [revealed, setRevealed] = (0, $h4Bez.useState)(creating);
    const [showValue, setShowValue] = (0, $h4Bez.useState)(false);
    if (!revealed) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $556393662cf0f57c$export$2e2bcd8739ae039), {
        id: id,
        label: label,
        variant: "standard",
        fullWidth: true,
        disabled: true,
        value: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
        helperText: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).SECRET_PARAMETER_CONCEALED_HELPER),
        InputProps: {
            endAdornment: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2aefb57dc041c2ec$export$2e2bcd8739ae039), {
                position: "end",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                    "data-testid": "secret-parameter-change",
                    variant: "primaryGhost",
                    size: "small",
                    disabled: inactive,
                    onClick: ()=>setRevealed(true),
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SECRET_PARAMETER_CHANGE
                    })
                })
            })
        }
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $556393662cf0f57c$export$2e2bcd8739ae039), {
        id: id,
        label: label,
        type: showValue ? 'text' : 'password',
        variant: "standard",
        fullWidth: true,
        required: creating && required,
        disabled: inactive,
        autoComplete: "new-password",
        value: typeof value === 'string' ? value : '',
        onChange: ({ target: target })=>onChange(target.value === '' ? undefined : target.value),
        helperText: creating ? undefined : translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).SECRET_PARAMETER_EDIT_HELPER),
        inputProps: {
            autoComplete: 'new-password'
        },
        InputProps: {
            endAdornment: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2aefb57dc041c2ec$export$2e2bcd8739ae039), {
                position: "end",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ce2f632502216d89$export$241ba0b938fcb9f), {
                        "data-testid": "secret-parameter-toggle-visibility",
                        visible: showValue,
                        disabled: inactive,
                        onToggle: ()=>setShowValue(!showValue),
                        showLabel: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).SECRET_PARAMETER_SHOW_VALUE),
                        hideLabel: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).SECRET_PARAMETER_HIDE_VALUE)
                    }),
                    !creating && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                        "data-testid": "secret-parameter-cancel",
                        variant: "primaryGhost",
                        size: "small",
                        disabled: inactive,
                        onClick: ()=>{
                            onChange(undefined);
                            setShowValue(false);
                            setRevealed(false);
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CANCEL
                        })
                    })
                ]
            })
        }
    });
};


const $11bf8e2742a7dec8$var$SchemaForm = ()=>{
    const updateParameters = (0, $6a53eadc42eca0ef$export$6bd78af97f4a4340)();
    const noConfigurationText = (0, $6a53eadc42eca0ef$export$80c95c9c90c9b494)();
    const isEditable = (0, $6a53eadc42eca0ef$export$2da7aef02c1d55c6)();
    const isIdEditable = (0, $6a53eadc42eca0ef$export$529e27799c84ec42)();
    const file = (0, $6a53eadc42eca0ef$export$a7af614c0f08d4b7)();
    const id = (0, $6a53eadc42eca0ef$export$f680877a34711e37)();
    const parameters = (0, $6a53eadc42eca0ef$export$96f5e8917642ff51)();
    const schema = (0, $6a53eadc42eca0ef$export$aecd9c955413bc92)();
    /**
     * Parameters flagged `secret: true` and declared `type: 'string'` — the only shape the
     * write-only widget can mask — are rendered by it; any other secret-flagged type falls through
     * to rjsf's normal rendering for its type — see `getMaskableSecretParameterNames`
     */ const uiSchema = (0, $h4Bez.useMemo)(()=>{
        if (schema === null || (0, $c3e1b746ad236797$export$8d524fb6540252df).is(schema)) return {};
        return (0, $e8356e494d58a419$export$5a4a14ee0306f811)(schema).reduce(/** `isIdEditable` is exactly "are we creating" here too — see useIsIdEditable's doc comment */ (r, name)=>({
                ...r,
                [name]: {
                    'ui:widget': (0, $ac596103cca5a04e$export$54e433fa95d6c8dd),
                    'ui:options': {
                        creating: isIdEditable
                    }
                }
            }), {});
    }, [
        schema,
        isIdEditable
    ]);
    if (file === null) /**
         * File has not been loaded, render nothing
         */ return null;
    if (schema === null) /**
         * File has been loaded but schema hasnt, show loader
         */ return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $95388f9578043f1e$export$2e2bcd8739ae039), {});
    if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(schema) || !parameters) /**
         * Errors get displayed elsewhere, no need to display anything here
         */ return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $56b3a9122bbdf87b$export$a7fed597f4b8afd8), {
        id: "serviceConfigurationForm",
        schema: schema,
        uiSchema: uiSchema,
        formData: isIdEditable && typeof id === 'string' ? {
            id: id,
            ...parameters
        } : parameters,
        readonly: !isEditable,
        onChange: ({ id: id, ...parameters })=>updateParameters(/**
                     * If the id is not present, then it is not relevant
                     * Thus a null value should be passed instead
                     */ id ?? null, parameters),
        emptyForm: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
            "data-testid": "nothing-to-configure-message",
            variant: "body2",
            align: "left",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: noConfigurationText
            })
        })
    });
};
const $11bf8e2742a7dec8$var$opaqueStyle = {
    opacity: 0.5
};
const $11bf8e2742a7dec8$var$formWrapperStyle = {
    maxHeight: 'calc(100vh - 250px)',
    overflowY: 'inherit',
    p: 2
};
const $11bf8e2742a7dec8$export$f78a3e1181806342 = ()=>{
    const configurationTitle = (0, $6a53eadc42eca0ef$export$7ca3db485322a63a)();
    const hasParameters = (0, $6a53eadc42eca0ef$export$f718397ceab26c17)();
    const hasSteps = (0, $6a53eadc42eca0ef$export$11095004166ed57e)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $0aa27c46708d7ed8$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "body1",
                align: "left",
                sx: hasParameters ? {} : $11bf8e2742a7dec8$var$opaqueStyle,
                children: [
                    hasSteps && '2. ',
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: configurationTitle
                    })
                ]
            }),
            !hasParameters && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "body2",
                align: "left",
                sx: $11bf8e2742a7dec8$var$opaqueStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_CONFIGURE_HINT
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $11bf8e2742a7dec8$var$formWrapperStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($11bf8e2742a7dec8$var$SchemaForm, {})
            })
        ]
    });
};





var $h4Bez = parcelRequire("h4Bez");





const $af5f68e0661fcf71$var$wrapperEntryStyle = {
    ml: 6
};
const $af5f68e0661fcf71$var$fileTitleStyle = {
    display: 'flex',
    justifyContent: 'space-between'
};
const $af5f68e0661fcf71$var$collapseStyle = {
    width: '100%'
};
const $af5f68e0661fcf71$var$codeStyle = {
    maxHeight: 'calc(100vh - 400px)',
    overflowY: 'scroll',
    p: 4,
    typography: 'body2',
    whiteSpace: 'pre-wrap',
    lineHeight: 1.25,
    backgroundColor: 'grey.100',
    borderRadius: '6px',
    overflowWrap: 'break-word',
    fontFamily: 'monospace'
};
const $af5f68e0661fcf71$var$Display = ({ children: children })=>{
    const [open, setOpen] = (0, $h4Bez.useState)(false);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $af5f68e0661fcf71$var$wrapperEntryStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                "data-testid": "file-content-display",
                sx: $af5f68e0661fcf71$var$fileTitleStyle,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        variant: "body2",
                        align: "left",
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_COMMISSIONING_FILE_LABEL
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a497eee141ca75b8$export$2e2bcd8739ae039), {
                        onClick: ()=>setOpen(!open),
                        children: open ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0c1414221f308967$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f0c56636e9fb6837$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7830414f6fe32da6$export$2e2bcd8739ae039), {
                sx: $af5f68e0661fcf71$var$collapseStyle,
                in: open,
                timeout: "auto",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    component: "pre",
                    sx: $af5f68e0661fcf71$var$codeStyle,
                    children: children
                })
            })
        ]
    });
};
const $af5f68e0661fcf71$export$5053f49f46dd8ad = ()=>{
    const file = (0, $6a53eadc42eca0ef$export$a7af614c0f08d4b7)();
    return file && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($af5f68e0661fcf71$var$Display, {
        children: file
    });
};



parcelRequire("h4Bez");



"use client";
var $ff09b306ff678920$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M14 13v4h-4v-4H7l5-5 5 5z"
}), 'CloudUpload');










const $94cfee58f7611a9a$var$uploadFormStyle = {
    textAlign: 'center'
};
const $94cfee58f7611a9a$var$uploadDialogContentStyle = {
    display: 'flex',
    flexDirection: 'column'
};
const $94cfee58f7611a9a$var$uploadDialogEntryStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    mt: 2
};
const $94cfee58f7611a9a$var$uploadIconStyle = {
    mr: 4,
    color: 'secondary.main'
};
const $94cfee58f7611a9a$var$SimpleFileUploadSection = ()=>{
    const file = (0, $6a53eadc42eca0ef$export$1ad42cf9b00bda68)();
    const types = (0, $6a53eadc42eca0ef$export$55ffdddd106a1960)();
    const onFileChange = (0, $6a53eadc42eca0ef$export$424ae8d8e2ee85ac)();
    const isEditable = (0, $6a53eadc42eca0ef$export$2da7aef02c1d55c6)();
    const [readFile] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(async (files)=>{
        const content = await (0, $2371d85f76b63637$export$925a4c3537ec7ca4)(files).catch((e)=>e);
        onFileChange(content);
    }, [
        onFileChange
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "file-upload-section",
        sx: $94cfee58f7611a9a$var$uploadDialogEntryStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ff09b306ff678920$export$2e2bcd8739ae039), {
                sx: $94cfee58f7611a9a$var$uploadIconStyle
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fec793432225fcda$export$d92f83d2e295fa99), {
                readOnly: !isEditable,
                initialValue: file ? [
                    file
                ] : undefined,
                accept: types,
                onChange: readFile
            })
        ]
    });
};
const $94cfee58f7611a9a$var$InstructionsSection = ()=>{
    const supportedCommissioningFileTypes = (0, $6a53eadc42eca0ef$export$55ffdddd106a1960)();
    const hasSteps = (0, $6a53eadc42eca0ef$export$11095004166ed57e)();
    const shouldShowUploadInstructions = (0, $6a53eadc42eca0ef$export$22404ef8e73ca1e3)();
    if (!shouldShowUploadInstructions) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$20b3b2f62cca41), {
        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).COMMISSIONING_FILE,
        align: "left"
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                "data-testid": "file-upload-summary-1",
                variant: "body1",
                align: "left",
                children: [
                    hasSteps && '1. ',
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_SELECT_COMMISSIONING_FILE,
                        values: {
                            types: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbba8fd6e98bab28$export$f52b44e459e6e71d), {
                                type: "disjunction",
                                value: supportedCommissioningFileTypes
                            })
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                "data-testid": "file-upload-summary-2",
                variant: "body2",
                align: "left",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_DOCUMENTATION_LINK,
                    values: {
                        documentationLink: (0, $4772774eee62bdcc$export$18fadbe56dfcb1a1)((0, $57ff7f54e54013be$export$6eb1e07b1de459cd), {
                            type: (0, $de76aa5bd91d062d$export$26609300e3bf37cf).SERVICES
                        })
                    }
                })
            })
        ]
    });
};
const $94cfee58f7611a9a$export$7c04dd339813e4f8 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $94cfee58f7611a9a$var$uploadFormStyle,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $0aa27c46708d7ed8$export$2e2bcd8739ae039), {
            sx: $94cfee58f7611a9a$var$uploadDialogContentStyle,
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($94cfee58f7611a9a$var$InstructionsSection, {}),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($94cfee58f7611a9a$var$SimpleFileUploadSection, {})
            ]
        })
    });



parcelRequire("h4Bez");



parcelRequire("h4Bez");



const $61d0b6a40c90c0f6$var$linkStyle = {
    cursor: 'pointer'
};
const $61d0b6a40c90c0f6$var$ErrorPopoverContent = ({ linkTranslation: linkTranslation, linkTranslationValues: linkTranslationValues, children: children })=>{
    const setOrigin = (0, $5c50dcf7e155ce8c$export$b13dce3af0135d87)();
    const close = (0, $5c50dcf7e155ce8c$export$89554eb4b4787636)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: linkTranslation,
                values: {
                    ...linkTranslationValues,
                    link: (0, $4772774eee62bdcc$export$18fadbe56dfcb1a1)((0, $a497eee141ca75b8$export$2e2bcd8739ae039), {
                        'data-testid': 'error-popover-link',
                        sx: $61d0b6a40c90c0f6$var$linkStyle,
                        onClick: (e)=>setOrigin(e.currentTarget)
                    })
                }
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $40650a35df6eb212$export$2e2bcd8739ae039), {
                onClose: close,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                transformOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                },
                children: children
            })
        ]
    });
};
const $61d0b6a40c90c0f6$export$8afccc1c0f0dfc45 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5c50dcf7e155ce8c$export$1d7e255c6105d39b), {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($61d0b6a40c90c0f6$var$ErrorPopoverContent, {
            ...props
        })
    });


const $39d5f51d5d586c33$var$errorStyle = {
    m: 2
};
const $39d5f51d5d586c33$export$7d465be8efa67280 = ({ error: error })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $61d0b6a40c90c0f6$export$8afccc1c0f0dfc45), {
        linkTranslation: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_INSTALL_OR_UPDATE_ERROR,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
            sx: $39d5f51d5d586c33$var$errorStyle,
            error: error,
            stack: true,
            extras: "section"
        })
    });




parcelRequire("h4Bez");



const $26f905ffcdd2c82e$var$alertStyle = {
    color: 'error.dark',
    display: 'flex',
    alignItems: 'center'
};
const $26f905ffcdd2c82e$var$errorStyle = {
    display: 'flex',
    alignItems: 'baseline'
};
const $26f905ffcdd2c82e$var$errorLabelStyle = {
    color: 'text.primary'
};
const $26f905ffcdd2c82e$var$nonFirstChildStyle = {
    ...$26f905ffcdd2c82e$var$errorStyle,
    mt: 1
};
const $26f905ffcdd2c82e$var$propertyPathStyle = {
    color: 'error.dark',
    mr: 0.5
};
const $26f905ffcdd2c82e$export$6b71bec05ba1a3c6 = ({ error: error })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $61d0b6a40c90c0f6$export$8afccc1c0f0dfc45), {
        linkTranslation: (0, $40a99dac858c1d75$export$b63289fbda65eed1).COMMISSIONING_FILE_PARSING_ERROR,
        linkTranslationValues: {
            count: error.parseErrors.size
        },
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bb140bd70ba0d464$export$2e2bcd8739ae039), {
            sx: $26f905ffcdd2c82e$var$alertStyle,
            severity: "error",
            variant: "outlined",
            children: Array.from(error.parseErrors).map(([propertyPath, error], k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: k > 0 ? $26f905ffcdd2c82e$var$nonFirstChildStyle : $26f905ffcdd2c82e$var$errorStyle,
                    children: [
                        propertyPath && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                            sx: $26f905ffcdd2c82e$var$propertyPathStyle,
                            variant: "body1",
                            children: [
                                propertyPath,
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                            sx: $26f905ffcdd2c82e$var$errorLabelStyle,
                            variant: "body1",
                            children: error
                        })
                    ]
                }, k))
        })
    });


const $3d764879150d5b13$var$footerStyle = {
    display: 'flex',
    pl: 6,
    '& > *': {
        my: 'auto'
    }
};
const $3d764879150d5b13$var$actionsStyle = {
    ml: 'auto'
};
const $3d764879150d5b13$var$InternalModal = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const open = (0, $6a53eadc42eca0ef$export$f48224de87d33a65)();
    const title = (0, $6a53eadc42eca0ef$export$bc98e171e8c82a3d)();
    const requesting = (0, $6a53eadc42eca0ef$export$4b184e2ada51fe5f)();
    const error = (0, $6a53eadc42eca0ef$export$5027865de34f9ec6)();
    const id = (0, $6a53eadc42eca0ef$export$f680877a34711e37)();
    const cancel = (0, $6a53eadc42eca0ef$export$f7baf2d4328e611b)();
    const isDisabled = (0, $6a53eadc42eca0ef$export$8aea33bc635080c2)();
    const confirm = (0, $6a53eadc42eca0ef$export$bf4da147a5964edb)();
    const confirmationButtonText = (0, $6a53eadc42eca0ef$export$c95fe5f8f8b753c2)();
    const reversalButtonText = (0, $6a53eadc42eca0ef$export$1e150b49a5cf5889)();
    if (!open) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $55a2a796d4e0875c$export$2e2bcd8739ae039), {
        "data-testid": "add-or-update-modal",
        maxWidth: "lg",
        fullWidth: true,
        disableEscapeKeyDown: true,
        open: true,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
            container: true,
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                    size: {
                        xs: 12
                    },
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dfd39f6bb0de9c2f$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: title
                            })
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2db76c9e9f88b3ff$export$2e2bcd8739ae039), {
                            variant: requesting === true ? 'indeterminate' : 'determinate',
                            value: 0
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                    size: {
                        xs: 5
                    },
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $94cfee58f7611a9a$export$7c04dd339813e4f8), {}),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $af5f68e0661fcf71$export$5053f49f46dd8ad), {})
                    ]
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                    size: {
                        xs: 7
                    },
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $11bf8e2742a7dec8$export$f78a3e1181806342), {})
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                    "data-testid": "modal-footer",
                    sx: $3d764879150d5b13$var$footerStyle,
                    size: {
                        xs: 12
                    },
                    children: [
                        error && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
                            "data-testid": "error-column",
                            error: error,
                            titleVariant: "body2",
                            customTitle: (e)=>(0, $2918297897f2f622$export$515a7b7930693557).is(e) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $26f905ffcdd2c82e$export$6b71bec05ba1a3c6), {
                                    error: e
                                }) : (0, $1ad670b228c881bd$export$8d7d121236284350).is(e) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                    id: e.translation,
                                    values: {
                                        id: id
                                    }
                                }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $39d5f51d5d586c33$export$7d465be8efa67280), {
                                    error: e
                                })
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $12b0eeebf4fed103$export$2e2bcd8739ae039), {
                            sx: $3d764879150d5b13$var$actionsStyle,
                            children: [
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                                    "data-testid": "add-or-update-modal-cancel",
                                    "aria-label": translator.formatTranslation(reversalButtonText),
                                    variant: "secondary",
                                    onClick: cancel,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                        id: reversalButtonText
                                    })
                                }),
                                confirmationButtonText && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                                    "data-testid": "add-or-update-modal-confirm",
                                    "aria-label": translator.formatTranslation(confirmationButtonText),
                                    variant: "primary",
                                    disabled: isDisabled,
                                    onClick: confirm,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                        id: confirmationButtonText
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $3d764879150d5b13$var$config = {
    CREATE: {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_INSTALL,
        configurationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_CONFIGURE_NEW,
        confirmationButtonText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).INSTALL,
        dismissalButtonText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CANCEL,
        noConfigurationText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NOTHING_TO_CONFIGURE,
        usecase: 'addServiceUsecase',
        shouldShowUploadInstructions: true,
        hasNumberedSteps: true,
        isEditable: true
    },
    EDIT: {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_UPDATE_RECONFIGURE,
        configurationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_CONFIGURE_CURRENT,
        confirmationButtonText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).UPDATE,
        dismissalButtonText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CANCEL,
        noConfigurationText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NOTHING_TO_CONFIGURE,
        usecase: 'updateServiceUsecase',
        shouldShowUploadInstructions: true,
        hasNumberedSteps: true,
        isEditable: true
    },
    VIEW: {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_CONFIGURATION,
        configurationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_CONFIGURATION,
        confirmationButtonText: null,
        dismissalButtonText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CLOSE,
        noConfigurationText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_CONFIGURATION,
        usecase: 'updateServiceUsecase',
        shouldShowUploadInstructions: false,
        hasNumberedSteps: false,
        isEditable: false
    }
};
const $3d764879150d5b13$export$f52144aa4b366b3d = ({ mode: mode, onConfirmed: onConfirmed })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $82193370bd77ac54$export$ff94dd2d732b0bd7), {
        value: {
            ...$3d764879150d5b13$var$config[mode],
            onConfirmed: onConfirmed
        },
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($3d764879150d5b13$var$InternalModal, {})
    });






var $h4Bez = parcelRequire("h4Bez");





const $9ff545051b739d4d$var$entriesStyle = {
    display: 'flex',
    alignItems: 'center',
    '& + &': {
        mt: 2
    }
};
const $9ff545051b739d4d$var$entryNameStyle = {
    mr: 'auto'
};
const $9ff545051b739d4d$var$ModalBody = ({ resource: resource })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $9ff545051b739d4d$var$entriesStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                sx: $9ff545051b739d4d$var$entryNameStyle,
                children: [
                    resource.name,
                    " (",
                    resource.id,
                    ")"
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
                status: resource.status
            })
        ]
    });
const $9ff545051b739d4d$export$326a1e94d7b3de05 = ({ resourceSelector: resourceSelector, onConfirmed: onConfirmed })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bulkDeleteServicesUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$54399887e057b4b7), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_SERVICES,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_SERVICES_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE,
        resourceSelector: resourceSelector,
        dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE,
        onRenderLine: (0, $h4Bez.Fragment),
        onRenderLineContent: $9ff545051b739d4d$var$ModalBody,
        onCancel: ()=>usecase.selectServices(null),
        onConfirm: async ()=>{
            await usecase.delete();
            onConfirmed();
        }
    });
};
const $9ff545051b739d4d$export$4d7b0c50709ac1f2 = ({ resourceSelector: resourceSelector, onConfirmed: onConfirmed })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bulkDisableServicesUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$f6737f912c21f59d), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE_SERVICES,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_DISABLE_SERVICES_CONFIRMATION,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE,
        resourceSelector: resourceSelector,
        dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE,
        onRenderLine: (0, $h4Bez.Fragment),
        onRenderLineContent: $9ff545051b739d4d$var$ModalBody,
        onCancel: ()=>usecase.selectServices(null),
        onConfirm: async ()=>{
            await usecase.disable();
            onConfirmed?.();
        }
    });
};




var $h4Bez = parcelRequire("h4Bez");



"use client";
var $28bfa9d60a1f2ed9$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');







const $ce25ccdc61350c12$var$translations = {
    connections: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTION,
    containers: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTAINER,
    endpoints: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENDPOINT,
    routes: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ROUTE,
    mappings: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MAPPING,
    roles: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ROLE,
    servers: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVER,
    nodes: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NODE,
    users: (0, $40a99dac858c1d75$export$b63289fbda65eed1).USER,
    volumes: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VOLUME
};
const $ce25ccdc61350c12$var$listItemStyle = {
    listStyle: 'outside'
};
const $ce25ccdc61350c12$var$noMarginStyle = {
    m: 0
};
const $ce25ccdc61350c12$var$Content = ({ resource: { configuredResources: configuredResources } })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e38cb871010a9357$export$2e2bcd8739ae039), {
        dense: true,
        disablePadding: true,
        sx: $ce25ccdc61350c12$var$listItemStyle,
        children: (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(configuredResources).map(([resource, count])=>{
            if (count === 0) return null;
            return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $4b454249f6da9127$export$2e2bcd8739ae039), {
                alignItems: "flex-start",
                sx: $ce25ccdc61350c12$var$listItemStyle,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e5132299f9f455f8$export$2e2bcd8739ae039), {
                        sx: $ce25ccdc61350c12$var$noMarginStyle,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $28bfa9d60a1f2ed9$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $68ec4db0d4ae6801$export$2e2bcd8739ae039), {
                        "data-testid": `service-${resource}`,
                        primaryTypographyProps: {
                            variant: 'body1'
                        },
                        sx: $ce25ccdc61350c12$var$noMarginStyle,
                        children: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).AUTHORIZATION_REQUIRED_DOCUMENTATION_BODY_ITEM, {
                            count: count,
                            name: translator.formatTranslation($ce25ccdc61350c12$var$translations[resource], {
                                count: count
                            })
                        })
                    })
                ]
            }, resource);
        })
    });
};
const $ce25ccdc61350c12$export$383cff20c61f17b4 = ()=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bulkEnableServiceUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$10f512a97cdb6733), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).AUTHORIZATION_REQUIRED,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).AUTHORIZE_SERVICE_REQUIREMENTS,
        infoBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).AUTHORIZATION_REQUIRED_DOCUMENTATION_BODY,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ALLOW,
        resourceSelector: (0, $d8a939fc8bdc4e6b$export$c8149c820c4d2e01),
        dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE,
        onRenderLine: (0, $h4Bez.Fragment),
        onRenderLineContent: $ce25ccdc61350c12$var$Content,
        onCancel: ()=>usecase.selectServices(null),
        onConfirm: ()=>usecase.enable(),
        showOnlyOnError: (service)=>!(0, $c091d3dc2d3f37db$export$2a4ae1ab14c1da18)(service)
    });
};



parcelRequire("h4Bez");



const $7e1109924581883e$export$18cac04f881ed063 = ({ id: id })=>{
    const customCellRender = (s)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
            status: s
        });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8aa67788985a70f6$export$b5d723e193e2be22), {
        subscriptionUsecase: "manageResourcesDeviationsUsecase",
        filter: {
            service: id
        },
        data: (0, $d8a939fc8bdc4e6b$export$91b6dafec275fd10),
        dataTableMapper: (deviations)=>deviations,
        columns: {
            resourceId: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LOGICAL_ID,
                sort: true
            },
            expected: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).EXPECTED,
                sort: true,
                customCellRender: customCellRender
            },
            actual: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ACTUAL,
                sort: true,
                customCellRender: customCellRender
            },
            reason: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).REASON
            }
        }
    });
};




var $h4Bez = parcelRequire("h4Bez");






const $21573ef84e5a4bb7$var$selectCanCreateOrUpdateServices = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_CREATE_OR_UPDATE);
const $21573ef84e5a4bb7$export$223875819fd7cf93 = ({ resource: service })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const translateStatus = (0, $cb95d5d6a1876bbb$export$dde6f3ba8f2fdee)();
    const canCreateOrUpdateServices = (0, $be523f14267dcd17$export$9973955de2bf96cf)($21573ef84e5a4bb7$var$selectCanCreateOrUpdateServices);
    const { bulkDisableServicesUsecase: bulkDisableServicesUsecase, bulkDeleteServicesUsecase: bulkDeleteServicesUsecase, bulkEnableServiceUsecase: bulkEnableServiceUsecase, downloadServiceUsecase: downloadServiceUsecase, updateServiceUsecase: updateServiceUsecase, toastUsecase: toastUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    const [startUpdate, updateLoading] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(()=>updateServiceUsecase.startUpdate(service), [
        updateServiceUsecase,
        service
    ]);
    const [startDownload, isDownloading, downloadError] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(()=>downloadServiceUsecase.invoke(service), [
        updateServiceUsecase,
        service
    ]);
    const handleServiceEnabledClick = ()=>{
        bulkEnableServiceUsecase.selectServices([
            service.id
        ]);
        if (!(0, $c091d3dc2d3f37db$export$2a4ae1ab14c1da18)(service)) bulkEnableServiceUsecase.enable();
    };
    (0, $h4Bez.useEffect)(()=>{
        if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(downloadError)) toastUsecase.show({
            severity: (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).ERROR,
            title: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).DOWNLOAD_COMMISSIONING_FILE_DESCRIPTION_ERROR)
        });
    }, [
        downloadError,
        toastUsecase,
        translator
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            (0, $c091d3dc2d3f37db$export$8883ec02c9ab9cac)(service) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                "data-testid": "enable-service",
                text: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENABLE,
                capabilities: [
                    (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_MANAGE
                ],
                onClick: handleServiceEnabledClick,
                startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $3294d981d8a1956f$export$aed5667c83867b85), {}),
                showText: true
            }) : (0, $c091d3dc2d3f37db$export$278c4671b9ea60a3)(service) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                "data-testid": "disable-service",
                text: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE,
                capabilities: [
                    (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_MANAGE
                ],
                onClick: ()=>bulkDisableServicesUsecase.selectServices([
                        service.id
                    ]),
                startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b9d7f820c3e6958b$export$9b47433640e5db3a), {}),
                showText: true
            }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                text: translateStatus(service.status),
                "data-testid": "service-status",
                disabled: true,
                startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b9d7f820c3e6958b$export$9b47433640e5db3a), {}),
                showText: true
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                "data-testid": canCreateOrUpdateServices ? 'update-or-reconfigure-service' : 'view-service-configuration',
                text: canCreateOrUpdateServices ? (0, $40a99dac858c1d75$export$b63289fbda65eed1).UPDATE : (0, $40a99dac858c1d75$export$b63289fbda65eed1).VIEW_CONFIGURATION,
                capabilities: [
                    (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_PARAMETERS_READ,
                    (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_COMMISSIONING_FILE_READ
                ],
                disabled: updateLoading,
                loading: updateLoading,
                onClick: startUpdate,
                startIcon: canCreateOrUpdateServices ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ce4e3ee315615fb1$export$35f5c3e250802cd1), {}) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f64707633c45c401$export$1aa86ab72c4a7023), {})
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                "data-testid": "download-service-commissioning-file",
                text: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DOWNLOAD_COMMISSIONING_FILE_DESCRIPTION,
                capabilities: [
                    (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_COMMISSIONING_FILE_READ
                ],
                onClick: startDownload,
                disabled: isDownloading,
                loading: isDownloading,
                startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6c4ecf59edd403be$export$4e54df4252b4a99c), {})
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                "data-testid": "delete-service",
                text: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE,
                capabilities: [
                    (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_MANAGE
                ],
                onClick: ()=>bulkDeleteServicesUsecase.selectServices([
                        service.id
                    ]),
                startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d917252aed0e3bef$export$1ae95d1a7411cb7b), {}),
                variant: "dangerOutline"
            })
        ]
    });
};




parcelRequire("h4Bez");






parcelRequire("h4Bez");









const $8dbb6bdfa2188f09$var$wrapperStyle = {
    mx: -0.5,
    display: 'flex'
};
/** On one line, like the table's other cells, which clip the links that don't fit */ const $8dbb6bdfa2188f09$var$tableWrapperStyle = {
    display: 'flex',
    columnGap: 2
};
const $8dbb6bdfa2188f09$var$buttonStyle = {
    color: 'primary.700',
    '&:hover': {
        backgroundColor: 'unset'
    }
};
/** Reads as a link cell: one 20px text line, so it doesn't make its row taller than the table's other rows */ const $8dbb6bdfa2188f09$var$tableButtonStyle = {
    ...$8dbb6bdfa2188f09$var$buttonStyle,
    typography: 'body2',
    minHeight: 0,
    p: 0,
    border: 0,
    '&:hover': {
        backgroundColor: 'unset',
        textDecoration: 'underline'
    }
};
const $8dbb6bdfa2188f09$var$onClick = (0, $1fdb53e1bec07519$export$5532d7f774835bb3)();
const $8dbb6bdfa2188f09$export$b4ea4bc51ca10b2a = ({ links: links, isDetailedView: isDetailedView = false })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "service-links",
        sx: isDetailedView ? $8dbb6bdfa2188f09$var$wrapperStyle : $8dbb6bdfa2188f09$var$tableWrapperStyle,
        children: links.map((link, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                sx: isDetailedView ? $8dbb6bdfa2188f09$var$buttonStyle : $8dbb6bdfa2188f09$var$tableButtonStyle,
                variant: "primaryGhost",
                href: link.href,
                target: "_blank",
                onClick: $8dbb6bdfa2188f09$var$onClick,
                children: link.name
            }, k))
    });
const $8dbb6bdfa2188f09$export$b2e089eb3692b073 = ()=>{
    const translation = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8aa67788985a70f6$export$b3c28590d63f6eca), {
        subscriptionUsecase: "manageServicesLinksUsecase",
        data: (0, $d8a939fc8bdc4e6b$export$df592b9413ed56f3),
        dataTableMapper: (r)=>r,
        columns: {
            id: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_ID,
                sort: true
            },
            name: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                sort: true
            },
            links: {
                label: translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).LINK, {
                    count: 2
                }),
                customCellRender: (links)=>(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(links) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($8dbb6bdfa2188f09$export$b4ea4bc51ca10b2a, {
                        links: links
                    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$3eec49f24c546686), {})
            }
        },
        redirectOnRowclick: (0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).SERVICE,
        translations: {
            emptyTable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_SERVICE_LINKS_AVAILABLE,
            paginationDataType: 'SERVICE_LINK'
        },
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $3d764879150d5b13$export$f52144aa4b366b3d), {
            mode: "CREATE"
        })
    });
};



parcelRequire("h4Bez");





const $c96e1cfe23f7395a$var$linkStyle = {
    '& > a': {
        color: 'primary.700',
        textDecoration: 'unset'
    }
};
const $c96e1cfe23f7395a$var$Links = ({ title: title, services: services })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
        title: title,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
            sx: $c96e1cfe23f7395a$var$linkStyle,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbba8fd6e98bab28$export$f52b44e459e6e71d), {
                type: "conjunction",
                style: "long",
                value: services.map((service, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7d5f64758ce3b1db$export$bf4bb1ff1ff62959), {
                        path: (0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).SERVICE,
                        id: service,
                        children: service
                    }, k))
            })
        })
    });
const $c96e1cfe23f7395a$export$13d1eb20012e1339 = ({ service: service })=>service ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($c96e1cfe23f7395a$var$Links, {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_ID,
        services: [
            service
        ]
    }) : null;
const $c96e1cfe23f7395a$export$bd19b47481599777 = ({ title: title, services: services, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("div", {
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($c96e1cfe23f7395a$var$Links, {
            title: title,
            services: services
        })
    });


const $cc54c4dfa3aa7e41$var$logoWrapperStyle = {
    my: 'auto',
    mr: 2,
    textAlign: 'center'
};
const $cc54c4dfa3aa7e41$var$logoStyle = {
    maxWidth: '100%'
};
const $cc54c4dfa3aa7e41$var$infoStyle = {
    px: 1,
    flexGrow: 1,
    mb: 2
};
const $cc54c4dfa3aa7e41$var$preformattedStyle = {
    whiteSpace: 'pre-wrap'
};
const $cc54c4dfa3aa7e41$export$de1f3500221e9400 = ({ resource: service })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: true,
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                "data-testid": "service-header-description",
                sx: $cc54c4dfa3aa7e41$var$infoStyle,
                size: {
                    xs: service.icon ? 7 : 9
                },
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_ID,
                        type: "text",
                        children: service.id
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                        type: "text",
                        children: service.name
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DESCRIPTION,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                            sx: $cc54c4dfa3aa7e41$var$preformattedStyle,
                            children: service.description
                        })
                    }),
                    service.provider && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).PROVIDER,
                        type: "text",
                        children: service.provider
                    }),
                    service.version && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VERSION,
                        children: service.version
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
                            status: service.status
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVIATION,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
                            status: service.deviation
                        })
                    }),
                    (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(service.links) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                        title: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).LINK, {
                            count: service.links.length
                        }),
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8dbb6bdfa2188f09$export$b4ea4bc51ca10b2a), {
                            links: service.links,
                            isDetailedView: true
                        })
                    }) : null,
                    (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(service.dependencies.dependent) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c96e1cfe23f7395a$export$bd19b47481599777), {
                        "data-testid": "dependent-services",
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).REQUIRED_BY,
                        services: service.dependencies.dependent
                    }),
                    (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(service.dependencies.dependsOn) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c96e1cfe23f7395a$export$bd19b47481599777), {
                        "data-testid": "depends-on-services",
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DEPENDS_ON_SERVICES,
                        services: service.dependencies.dependsOn
                    })
                ]
            }),
            service.icon && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                size: {
                    xs: 2
                },
                sx: $cc54c4dfa3aa7e41$var$logoWrapperStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    component: "img",
                    src: service.icon,
                    sx: $cc54c4dfa3aa7e41$var$logoStyle
                })
            })
        ]
    });
};




var $h4Bez = parcelRequire("h4Bez");








const $bdd5df90a2787f98$var$typeToLinkMap = {
    [(0, $d7e1ff559b364dab$export$b459d70d11da43d5).ENDPOINT]: (0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).ENDPOINT,
    [(0, $d7e1ff559b364dab$export$b459d70d11da43d5).MAPPING]: (0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).MAPPING,
    /** Nodes have no page */ [(0, $d7e1ff559b364dab$export$b459d70d11da43d5).NODE]: null
};
const $bdd5df90a2787f98$var$linkStyle = {
    [`&:hover > .${(0, $d11898bbe79f09e3$export$2e2bcd8739ae039).root}, &:focus-within > .${(0, $d11898bbe79f09e3$export$2e2bcd8739ae039).root}`]: {
        opacity: 1
    }
};
const $bdd5df90a2787f98$var$entriesStyle = {
    my: 'auto'
};
const $bdd5df90a2787f98$var$buttonStyle = {
    opacity: 0
};
const $bdd5df90a2787f98$var$Link = ({ id: id, type: type })=>{
    const path = $bdd5df90a2787f98$var$typeToLinkMap[type];
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
        direction: "row",
        gap: 1,
        sx: $bdd5df90a2787f98$var$linkStyle,
        children: [
            path ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7d5f64758ce3b1db$export$bf4bb1ff1ff62959), {
                sx: $bdd5df90a2787f98$var$entriesStyle,
                path: path,
                id: id,
                children: id
            }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $bdd5df90a2787f98$var$entriesStyle,
                children: id
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1ab636062450c95b$export$68054e84683f39b3), {
                sx: $bdd5df90a2787f98$var$buttonStyle,
                children: id
            })
        ]
    });
};
const $bdd5df90a2787f98$var$Topics = ({ topics: topics })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            topics.length === 0 && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$3eec49f24c546686), {}),
            topics.map((topic, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $h4Bez.Fragment), {
                    children: [
                        k > 0 && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("br", {}),
                        topic
                    ]
                }, k))
        ]
    });
const $bdd5df90a2787f98$var$useLastMessage = (topics)=>(0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>{
        const messages = (0, $d8a939fc8bdc4e6b$export$c73643a1640d8b9e)(s);
        return topics.reduce((lastMessage, topic)=>{
            const currentMessage = messages[topic] ?? null;
            if (lastMessage === null || (0, $c3e1b746ad236797$export$8d524fb6540252df).is(currentMessage) || currentMessage && lastMessage && !(0, $c3e1b746ad236797$export$8d524fb6540252df).is(lastMessage) && currentMessage.timestamp >= lastMessage.timestamp) /**
                     * If there was no message set,
                     * the new message is an error,
                     * or the new message more recent than the previous one
                     *
                     * Then use the new message
                     */ return currentMessage;
            return lastMessage;
        }, null);
    }, [
        topics
    ]);
const $bdd5df90a2787f98$var$Message = ({ topics: topics })=>{
    const message = $bdd5df90a2787f98$var$useLastMessage(topics);
    if (message === null) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_MESSAGES
    });
    if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(message)) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LIVE_DATA_SUBSCRIPTION_ERROR
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d700fad781a6ea93$export$bc337bf4c402f8eb), {
        buffer: message.payload,
        type: message.possibleTypes[0],
        minimized: true
    });
};
const $bdd5df90a2787f98$var$Time = ({ topics: topics })=>{
    const message = $bdd5df90a2787f98$var$useLastMessage(topics);
    if (message === null || (0, $c3e1b746ad236797$export$8d524fb6540252df).is(message)) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$3eec49f24c546686), {});
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$d275c5eeba29af75), {
        date: message.timestamp,
        format: "datetime"
    });
};
const $bdd5df90a2787f98$export$1a30d237349157ec = ({ id: id })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const loadUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('loadServiceDataUsecase');
    (0, $h4Bez.useEffect)(()=>loadUsecase.invoke(), [
        loadUsecase
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8aa67788985a70f6$export$b5d723e193e2be22), {
        subscriptionUsecase: "manageServicesTopicsUsecase",
        data: (0, $d8a939fc8bdc4e6b$export$240c9122a0549c0f),
        filter: {
            service: id
        },
        dataTableMapper: (resources)=>resources.map((r)=>({
                    ...r,
                    id: r,
                    message: r.topics,
                    time: r.topics
                })),
        columns: {
            id: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).RESOURCE_ID,
                sort: true,
                customCellRender: (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($bdd5df90a2787f98$var$Link, {
                        ...props
                    })
            },
            type: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).RESOURCE_TYPE,
                sort: true,
                customCellRender: (type)=>translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_RESOURCE_TYPE, {
                        type: type
                    })
            },
            topics: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).TOPIC, {
                    count: 0
                }),
                customCellRender: (topics)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($bdd5df90a2787f98$var$Topics, {
                        topics: topics
                    })
            },
            message: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MESSAGE,
                customCellRender: (topics)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($bdd5df90a2787f98$var$Message, {
                        topics: topics
                    })
            },
            time: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TIME,
                customCellRender: (topics)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($bdd5df90a2787f98$var$Time, {
                        topics: topics
                    }),
                type: 'datetime'
            }
        },
        translations: {
            noResults: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_LIVE_DATA_RESOURCES_FOUND,
            emptyTable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_LIVE_DATA_RESOURCES
        }
    });
};


const $cca0e2b81f68ec73$var$Content = ({ resource: resource })=>{
    const { id: id, availableResources: { servers: servers, nodes: nodes, containers: containers, volumes: volumes, connections: connections, endpoints: endpoints, mappings: mappings }, resourceDeviationsCount: resourceDeviationsCount } = resource;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b6b5ebbc4a51bb7b$export$fc34525e6b0d872d), {
        type: (0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).SERVICE,
        id: id,
        children: (available)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2bf638d791e22cc5$export$b2539bed5023c21c), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_LOGS,
                        disabled: !available,
                        requiredCapabilities: [
                            (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ
                        ],
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ac7334fad98808f5$export$54ec01a60f47d33d), {
                            id: id,
                            type: (0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).SERVICE,
                            reloadOn: resource
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_LIVE_DATA,
                        requiredCapabilities: [
                            (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_SUBSCRIPTION_METADATA,
                            (0, $78670ebe9381a713$export$790a66df9dc00390).TOPICS_SUBSCRIPTION
                        ],
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bdd5df90a2787f98$export$1a30d237349157ec), {
                            id: id
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVER,
                        count: servers,
                        disabled: servers === 0,
                        requiredCapabilities: [
                            (0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_READ
                        ],
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $91a76748a62a49cb$export$54ec01a60f47d33d), {
                            serviceId: id
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NODE,
                        count: nodes,
                        disabled: nodes === 0,
                        requiredCapabilities: [
                            (0, $78670ebe9381a713$export$790a66df9dc00390).NODES_READ
                        ],
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $77ad22a2e1029f2f$export$54ec01a60f47d33d), {
                            serviceId: id
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTAINER,
                        count: containers,
                        disabled: containers === 0,
                        requiredCapabilities: [
                            (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_READ
                        ],
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $10bd0f4559270f58$export$54ec01a60f47d33d), {
                            serviceId: id
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VOLUME,
                        count: volumes,
                        disabled: volumes === 0,
                        requiredCapabilities: [
                            (0, $78670ebe9381a713$export$790a66df9dc00390).VOLUMES_READ
                        ],
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4b9327e4a1d2954f$export$54ec01a60f47d33d), {
                            serviceId: id
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTION,
                        count: connections,
                        disabled: connections === 0,
                        requiredCapabilities: [
                            (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_READ
                        ],
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dc980d3784041744$export$54ec01a60f47d33d), {
                            serviceId: id
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENDPOINT,
                        count: endpoints,
                        disabled: endpoints === 0,
                        requiredCapabilities: [
                            (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_READ
                        ],
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b82f9b509446bc25$export$54ec01a60f47d33d), {
                            serviceId: id
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MAPPING,
                        count: mappings,
                        disabled: mappings === 0,
                        requiredCapabilities: [
                            (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_READ
                        ],
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $50bc70341a26085b$export$54ec01a60f47d33d), {
                            serviceId: id
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVIATION_TAB,
                        count: resourceDeviationsCount,
                        disabled: resourceDeviationsCount === 0,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7e1109924581883e$export$18cac04f881ed063), {
                            id: id
                        })
                    })
                ]
            })
    });
};
const $cca0e2b81f68ec73$var$selectCanCreateOrUpdateServices = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_CREATE_OR_UPDATE);
const $cca0e2b81f68ec73$var$Modals = ({ leave: leave })=>{
    const canUpdateServices = (0, $be523f14267dcd17$export$9973955de2bf96cf)($cca0e2b81f68ec73$var$selectCanCreateOrUpdateServices);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9ff545051b739d4d$export$4d7b0c50709ac1f2), {
                resourceSelector: (0, $d8a939fc8bdc4e6b$export$db7570957be2f41c)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9ff545051b739d4d$export$326a1e94d7b3de05), {
                resourceSelector: (0, $d8a939fc8bdc4e6b$export$cfcd7bbf606e399),
                onConfirmed: leave
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ce25ccdc61350c12$export$383cff20c61f17b4), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $3d764879150d5b13$export$f52144aa4b366b3d), {
                mode: canUpdateServices ? 'EDIT' : 'VIEW'
            })
        ]
    });
};
const $cca0e2b81f68ec73$export$3e8048d3cf2ba3fd = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $264fddb75d092ad2$export$2e9120d34faa9c1f), {
        subscriptionUsecase: "manageServiceUsecase",
        resourceSelector: (0, $d8a939fc8bdc4e6b$export$b1d3fd5cbfd0565e),
        notFoundTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_NOT_FOUND,
        content: $cca0e2b81f68ec73$var$Content,
        modals: $cca0e2b81f68ec73$var$Modals,
        headerResourceName: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_DETAILS,
        headerName: "name",
        headerActions: (0, $21573ef84e5a4bb7$export$223875819fd7cf93),
        infoTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_DETAILS_DOCUMENTATION_TITLE,
        infoBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_DETAILS_DOCUMENTATION_BODY,
        headerDetails: (0, $cc54c4dfa3aa7e41$export$de1f3500221e9400)
    });






var $h4Bez = parcelRequire("h4Bez");











parcelRequire("h4Bez");



const $993dcddc76c88064$var$buttonStyle = {
    ml: 2
};
const $993dcddc76c88064$export$94cf144a42a137cd = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
        "data-testid": "add-service",
        sx: $993dcddc76c88064$var$buttonStyle,
        variant: "primary",
        size: "large",
        startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5154eed3dac5502e$export$8df90684a752ef81), {}),
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).UPLOAD_SERVICE
        })
    });



const $959991498573f865$var$Modals = ()=>{
    const clear = (0, $365b0b4d68ac9bb9$export$d2838f462516652)();
    const { toastUsecase: toastUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    /**
     * `undefined` when the user isn't authorized to view a service's page - mirrors
     * `PermissionedLink`'s own fallback (rendering plain, non-clickable text) by simply omitting
     * the toast's action in that case, rather than offering a link that would go nowhere.
     */ const redirectToService = (0, $8e52a8f0c49c306f$export$50a08f8725efa458)((0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).SERVICE, (id)=>id);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9ff545051b739d4d$export$326a1e94d7b3de05), {
                resourceSelector: (0, $d8a939fc8bdc4e6b$export$f2983dcfc827a39c),
                onConfirmed: clear
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9ff545051b739d4d$export$4d7b0c50709ac1f2), {
                resourceSelector: (0, $d8a939fc8bdc4e6b$export$365b9a61b3676716),
                onConfirmed: clear
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $3d764879150d5b13$export$f52144aa4b366b3d), {
                mode: "CREATE",
                onConfirmed: (id)=>toastUsecase.show({
                        severity: (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).INFO,
                        title: id,
                        ...redirectToService && {
                            action: {
                                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).VIEW_SERVICE),
                                onClick: ()=>redirectToService(id)
                            }
                        }
                    })
            })
        ]
    });
};
const $959991498573f865$var$selectCanInstallServices = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_PARAMETERS_READ, (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_CREATE_OR_UPDATE, (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_COMMISSIONING_FILE_READ);
const $959991498573f865$var$selectCanManageServices = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_MANAGE);
const $959991498573f865$var$buttonStyle = {
    cursor: 'pointer'
};
const $959991498573f865$var$NoServicesMessage = ()=>{
    const canInstallServices = (0, $be523f14267dcd17$export$9973955de2bf96cf)($959991498573f865$var$selectCanInstallServices);
    const addServiceUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('addServiceUsecase');
    const link = (0, $4772774eee62bdcc$export$18fadbe56dfcb1a1)((0, $a497eee141ca75b8$export$2e2bcd8739ae039), {
        sx: $959991498573f865$var$buttonStyle,
        onClick: ()=>addServiceUsecase.startCreation()
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_SERVICES_INSTALLED,
        values: {
            canInstallServices: canInstallServices,
            link: link
        }
    });
};
const $959991498573f865$var$HeaderActions = ()=>{
    const addService = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('addServiceUsecase');
    const canInstallServices = (0, $be523f14267dcd17$export$9973955de2bf96cf)($959991498573f865$var$selectCanInstallServices);
    const startServiceUpload = (0, $h4Bez.useCallback)(()=>addService.startCreation(), [
        addService
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $993dcddc76c88064$export$94cf144a42a137cd), {
            onClick: startServiceUpload,
            disabled: !canInstallServices
        })
    });
};
const $959991498573f865$export$54ec01a60f47d33d = ()=>{
    const translation = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const customCellRender = (status)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
            status: status
        });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $be3703687194c6e0$export$56e2352e63353d99), {
                title: [
                    (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE,
                    {
                        count: 0
                    }
                ],
                titleActions: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($959991498573f865$var$HeaderActions, {}),
                description: [
                    (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICES_DETAILS_DOCUMENTATION_TITLE,
                    (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICES_DETAILS_DOCUMENTATION_BODY
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8aa67788985a70f6$export$b3c28590d63f6eca), {
                subscriptionUsecase: "manageServicesUsecase",
                data: (0, $d8a939fc8bdc4e6b$export$5accc1ee7a9a1dac),
                hasManagementCapabilitiesSelector: $959991498573f865$var$selectCanManageServices,
                dataTableMapper: (r)=>r,
                columns: {
                    id: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_ID,
                        sort: true
                    },
                    name: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                        sort: true
                    },
                    version: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VERSION,
                        sort: true
                    },
                    links: {
                        label: translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).LINK, {
                            count: 2
                        }),
                        customCellRender: (links)=>(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(links) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8dbb6bdfa2188f09$export$b4ea4bc51ca10b2a), {
                                links: links
                            }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$3eec49f24c546686), {})
                    },
                    status: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS,
                        customCellRender: customCellRender,
                        sort: true
                    },
                    deviation: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVIATION,
                        customCellRender: customCellRender
                    }
                },
                redirectOnRowclick: (0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).SERVICE,
                selection: {
                    DELETE: {
                        usecase: 'bulkDeleteServicesUsecase'
                    },
                    DISABLE: {
                        usecase: 'bulkDisableServicesUsecase',
                        filter: (0, $c091d3dc2d3f37db$export$278c4671b9ea60a3)
                    },
                    resource: 'id',
                    usecaseMethod: 'selectServices'
                },
                translations: {
                    emptyTable: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($959991498573f865$var$NoServicesMessage, {}),
                    paginationDataType: 'SERVICE'
                },
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($959991498573f865$var$Modals, {})
            })
        ]
    });
};



parcelRequire("h4Bez");




const $672619bd636a45c6$export$a3716a896367b27f = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $be3703687194c6e0$export$56e2352e63353d99), {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVIATED_SERVICES,
                description: [
                    (0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVIATED_SERVICES_DOCUMENTATION_TITLE,
                    (0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVIATED_SERVICES_DOCUMENTATION_BODY
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8aa67788985a70f6$export$b3c28590d63f6eca), {
                subscriptionUsecase: "manageDeviatedServicesUsecase",
                data: (0, $d8a939fc8bdc4e6b$export$8295a43c0a85c66f),
                dataTableMapper: (r)=>r,
                columns: {
                    id: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_ID,
                        sort: true
                    },
                    name: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME
                    },
                    version: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VERSION
                    },
                    resourceDeviationsCount: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVIATED_RESOURCES,
                        type: 'number'
                    }
                },
                redirectOnRowclick: (0, $0e5d1fb0e9c69012$export$a87513c3fea633a5).SERVICE,
                translations: {
                    emptyTable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_DEVIATED_SERVICES_AVAILABLE,
                    paginationDataType: 'SERVICE'
                }
            })
        ]
    });






const $33e80854d44c855b$var$copyButtonStyle = {
    ml: 1
};
const $33e80854d44c855b$var$topicsStyle = {
    mb: 0.5,
    p: 0
};
const $33e80854d44c855b$var$topicsEntryStyle = {
    alignItems: 'baseline'
};
const $33e80854d44c855b$var$topicsListStyle = {
    p: 0
};
const $33e80854d44c855b$export$de1f3500221e9400 = ({ resource: { id: id, service: service, status: status, protocol: protocol, operation: operation, topics: topics, agent: agent } })=>{
    const translation = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: true,
        alignItems: "center",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
            "data-testid": "endpoint-header-description",
            size: {
                xs: 7
            },
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                    type: "text",
                    children: id
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c96e1cfe23f7395a$export$13d1eb20012e1339), {
                    service: service
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).PROTOCOL, {
                        count: 1
                    }),
                    type: "text",
                    children: protocol
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).OPERATION, {
                        count: 1
                    }),
                    type: "text",
                    children: operation
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).AGENT, {
                        count: 1
                    }),
                    type: "text",
                    children: agent || translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_AGENTS_AVAILABLE)
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
                        status: status
                    })
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    sx: $33e80854d44c855b$var$topicsEntryStyle,
                    title: translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).TOPIC, {
                        count: 2
                    }),
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e38cb871010a9357$export$2e2bcd8739ae039), {
                        sx: $33e80854d44c855b$var$topicsListStyle,
                        children: topics.map((topic)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $4b454249f6da9127$export$2e2bcd8739ae039), {
                                sx: $33e80854d44c855b$var$topicsStyle,
                                children: [
                                    topic,
                                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1ab636062450c95b$export$92ce62e1201c4fc0), {
                                        sx: $33e80854d44c855b$var$copyButtonStyle,
                                        children: topic
                                    })
                                ]
                            }, topic))
                    })
                })
            ]
        })
    });
};


const $a8768b642b75109a$var$Modals = ({ leave: leave })=>{
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c8a68df80a38eb1f$export$e5607a3e105d74ac), {
                endpointsSelector: (0, $c18490461364b14c$export$6e6903955a758574)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c8a68df80a38eb1f$export$1fd910e39ac2d463), {
                endpointsSelector: (0, $c18490461364b14c$export$6b7af8c484ac5c0b)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c8a68df80a38eb1f$export$73392e09138fecd6), {
                endpointsSelector: (0, $c18490461364b14c$export$e3f71d2a191ab4b6),
                onConfirmed: leave
            })
        ]
    });
};
const $a8768b642b75109a$export$3e8048d3cf2ba3fd = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $264fddb75d092ad2$export$2e9120d34faa9c1f), {
        subscriptionUsecase: "manageEndpointUsecase",
        resourceSelector: (0, $c18490461364b14c$export$15c224e49a280ac2),
        notFoundTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENDPOINT_NOT_FOUND,
        modals: $a8768b642b75109a$var$Modals,
        content: (0, $51ba132a84c6c9cc$export$7c6e2c02157bb7d2),
        headerResourceName: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENDPOINT,
        headerName: "name",
        headerActions: (0, $71d4e03cc7ec3ac0$export$223875819fd7cf93),
        infoTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENDPOINT_DETAILS_DOCUMENTATION_TITLE,
        infoBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENDPOINT_DETAILS_DOCUMENTATION_BODY,
        headerDetails: (0, $33e80854d44c855b$export$de1f3500221e9400)
    });








const $58d871473d66b4fc$export$7c6e2c02157bb7d2 = ({ resource: resource })=>{
    const { id: id, extraConfiguration: extraConfiguration } = resource;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b6b5ebbc4a51bb7b$export$fc34525e6b0d872d), {
        type: (0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).CONNECTION,
        id: id,
        children: (available)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2bf638d791e22cc5$export$b2539bed5023c21c), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTION_LOGS,
                        disabled: !available,
                        requiredCapabilities: [
                            (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ
                        ],
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ac7334fad98808f5$export$54ec01a60f47d33d), {
                            id: id,
                            type: (0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).CONNECTION,
                            reloadOn: resource
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONFIGURATION,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
                            data: (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(extraConfiguration).map(([name, value])=>({
                                    name: name,
                                    value: value
                                })),
                            columns: {
                                name: {
                                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                                    sort: true
                                },
                                value: {
                                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VALUE
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2bf638d791e22cc5$export$3e41faf802a29e71), {
                        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENDPOINT,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b82f9b509446bc25$export$54ec01a60f47d33d), {
                            connectionId: id
                        })
                    })
                ]
            })
    });
};



parcelRequire("h4Bez");




const $44cb4499fdbc6608$export$223875819fd7cf93 = ({ resource: { id: id, status: status } })=>{
    const { bulkDeleteConnectionsUsecase: bulkDeleteConnectionsUsecase, bulkConnectConnectionsUsecase: bulkConnectConnectionsUsecase, bulkDisconnectConnectionsUsecase: bulkDisconnectConnectionsUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    const disabled = status !== (0, $1041b3cad55163d4$export$e35c1996c6f482ad).CONNECTED && status !== (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISCONNECTED;
    const statusTranslation = status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).CONNECTED ? (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISCONNECT : status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).CONNECTING ? (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTING : (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECT;
    const handleConnectDisconnect = status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).CONNECTED ? ()=>bulkDisconnectConnectionsUsecase.selectConnections([
            id
        ]) : ()=>bulkConnectConnectionsUsecase.selectConnections([
            id
        ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                "data-testid": "connection-action-button",
                disabled: disabled,
                text: statusTranslation,
                capabilities: [
                    (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_MANAGE
                ],
                onClick: handleConnectDisconnect,
                startIcon: status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).CONNECTED ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b218f37bf97f91b3$export$541a84723b7db0e9), {}) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c239af17472eae06$export$9fb3c4dc634c9b1), {}),
                showText: true
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $71845f7cb75dafe2$export$cfc7921d29ef7b80), {
                "data-testid": "delete-connection-button",
                text: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE,
                capabilities: [
                    (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_MANAGE
                ],
                onClick: ()=>bulkDeleteConnectionsUsecase.selectConnections([
                        id
                    ]),
                startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d917252aed0e3bef$export$1ae95d1a7411cb7b), {}),
                variant: "dangerOutline"
            })
        ]
    });
};




parcelRequire("h4Bez");





const $524a27b997c1961d$export$de1f3500221e9400 = ({ resource: { id: id, service: service, status: status, host: host, port: port, deviceAddress: deviceAddress, deviceInstance: deviceInstance, ipAddress: ipAddress, cncType: cncType, agent: agent, device: device, brokers: brokers } })=>{
    const translation = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: true,
        alignItems: "center",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
            "data-testid": "connection-header-description",
            size: {
                xs: 7
            },
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTION_ID,
                    type: "text",
                    children: id
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c96e1cfe23f7395a$export$13d1eb20012e1339), {
                    service: service
                }),
                host && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).HOST, {
                        count: 1
                    }),
                    type: "text",
                    children: host
                }),
                port && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).PORT, {
                        count: 1
                    }),
                    type: "text",
                    children: port
                }),
                deviceAddress && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVICE_ADDRESS,
                    type: "text",
                    children: deviceAddress
                }),
                deviceInstance && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVICE_INSTANCE,
                    type: "text",
                    children: deviceInstance
                }),
                ipAddress && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).IP_ADDRESS,
                    type: "text",
                    children: ipAddress
                }),
                cncType && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CNC_TYPE,
                    type: "text",
                    children: cncType
                }),
                device && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVICE, {
                        count: 1
                    }),
                    type: "text",
                    children: device
                }),
                brokers && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).BROKER, {
                        count: brokers.length
                    }),
                    children: brokers.join(', ')
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).AGENT, {
                        count: 1
                    }),
                    type: "text",
                    children: agent || translation.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_AGENTS_AVAILABLE)
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99f11348ec734ff0$export$3bb977b3ba9d3b59), {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
                        status: status
                    })
                })
            ]
        })
    });
};


const $23d5314ef0d7ad96$var$Modals = ({ leave: leave })=>{
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b4910e4fa91aa958$export$e5607a3e105d74ac), {
                connectionsSelector: (0, $e35c6a737caa74d7$export$a082b934f7cf7bd6)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b4910e4fa91aa958$export$1fd910e39ac2d463), {
                connectionsSelector: (0, $e35c6a737caa74d7$export$3a6d405424d5e9f2)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b4910e4fa91aa958$export$73392e09138fecd6), {
                connectionsSelector: (0, $e35c6a737caa74d7$export$26b8cd3b3cd99014),
                onConfirmed: leave
            })
        ]
    });
};
const $23d5314ef0d7ad96$export$3e8048d3cf2ba3fd = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $264fddb75d092ad2$export$2e9120d34faa9c1f), {
        subscriptionUsecase: "manageConnectionUsecase",
        resourceSelector: (0, $e35c6a737caa74d7$export$83d924e75142d198),
        notFoundTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTION_NOT_FOUND,
        modals: $23d5314ef0d7ad96$var$Modals,
        content: (0, $58d871473d66b4fc$export$7c6e2c02157bb7d2),
        headerResourceName: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTION,
        headerName: "name",
        headerActions: (0, $44cb4499fdbc6608$export$223875819fd7cf93),
        infoTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTION_DETAILS_DOCUMENTATION_TITLE,
        infoBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTION_DETAILS_DOCUMENTATION_BODY,
        headerDetails: (0, $524a27b997c1961d$export$de1f3500221e9400)
    });









var $h4Bez = parcelRequire("h4Bez");



var $h4Bez = parcelRequire("h4Bez");







var $h4Bez = parcelRequire("h4Bez");









parcelRequire("h4Bez");



const $e3218b91ef22a757$var$validationsStyle = {
    [`& .${(0, $fb671afc24ce07a1$export$f95a619b04479b7d).icon}`]: {
        my: 0,
        color: 'white'
    },
    [`& .${(0, $fb671afc24ce07a1$export$f95a619b04479b7d).root}`]: {
        mb: 4
    },
    [`& .${(0, $fb671afc24ce07a1$export$f95a619b04479b7d).label}`]: {
        color: 'grey.200',
        textAlign: 'start'
    }
};
const $e3218b91ef22a757$var$baseTextFieldProps = {
    slotProps: {
        inputLabel: {
            sx: {
                color: 'white !important'
            }
        }
    }
};
const $e3218b91ef22a757$export$389d4885dfc5ad06 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fb8050ff7801b6d6$export$389d4885dfc5ad06), {
        ...$e3218b91ef22a757$var$baseTextFieldProps,
        ...props
    });
const $e3218b91ef22a757$export$a455218a85c89869 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6f84d94c688eb85b$export$57753b0d185cad1a), {
        ...$e3218b91ef22a757$var$baseTextFieldProps,
        fullWidth: true,
        required: true,
        ...props
    });
const $e3218b91ef22a757$var$linkStyle = {
    cursor: 'pointer'
};
const $e3218b91ef22a757$export$a6c7ac8248d6e38a = ({ onClick: onClick, disabled: disabled, color: color = 'secondary', ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a497eee141ca75b8$export$2e2bcd8739ae039), {
        display: "block",
        underline: "none",
        fontSize: "small",
        sx: $e3218b91ef22a757$var$linkStyle,
        color: color,
        onClick: disabled ? undefined : onClick,
        ...props
    });
const $e3218b91ef22a757$var$formChildStyle = {
    mt: 4
};
const $e3218b91ef22a757$export$a7fed597f4b8afd8 = ({ title: title, children: children, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        ...props,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "h6",
                color: "white",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: title
                })
            }),
            children.map((child, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: $e3218b91ef22a757$var$formChildStyle,
                    children: child
                }, k))
        ]
    });
const $e3218b91ef22a757$var$loginValidationErrorStyle = {
    background: '#ED6C0280',
    borderRadius: 1,
    px: 3,
    py: 2,
    mb: 6
};
const $e3218b91ef22a757$export$47a71ce5fa63b253 = ({ children: children, sx: sx, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fb671afc24ce07a1$export$794e892580855985), {
        ...props,
        error: true,
        sx: {
            ...$e3218b91ef22a757$var$validationsStyle,
            ...$e3218b91ef22a757$var$loginValidationErrorStyle,
            ...sx
        },
        children: children
    });




var $h4Bez = parcelRequire("h4Bez");








const $19f089f2872f050e$var$useEntraIdSectionStyle = {
    my: 4
};
const $19f089f2872f050e$var$useUserNameStyle = {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    color: 'white',
    mt: 2
};
const $19f089f2872f050e$var$useUserNameLabelStyle = {
    mx: 4,
    textTransform: 'uppercase'
};
const $19f089f2872f050e$var$useUserNameLineStyle = {
    flexGrow: 1,
    height: '1px',
    backgroundColor: '#ffffff3b'
};
const $19f089f2872f050e$var$useSignInButtonStyle = {
    py: 2,
    mb: 2
};
const $19f089f2872f050e$var$useLoadingIndicatorStyle = {
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
};
const $19f089f2872f050e$var$useErrorStyle = {
    my: 4
};
const $19f089f2872f050e$var$ssoIconMap = {
    [(0, $eba4f0b13361fb3e$export$a0bf97755470bf0e).MICROSOFT_ENTRA_ID]: (0, $42132986531c4c1a$export$9feb27937f9de9ba)
};
const $19f089f2872f050e$export$1aebea2e8b3687d6 = ()=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('ssoLoginUsecase');
    const supportedSSOTypes = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $eba4f0b13361fb3e$export$88fff0225a6b2db));
    (0, $h4Bez.useEffect)(()=>void usecase.fetchSupported(), [
        usecase
    ]);
    const [redirect, isRedirecting, result] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)((type)=>usecase.redirectToAuthenticationUrl(type), [
        usecase
    ]);
    const isLoading = supportedSSOTypes === null;
    const hasError = (0, $c3e1b746ad236797$export$8d524fb6540252df).is(supportedSSOTypes);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            isLoading && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $19f089f2872f050e$var$useLoadingIndicatorStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $95388f9578043f1e$export$2e2bcd8739ae039), {
                    "data-testid": "sso-circular-loading",
                    size: 20,
                    color: "info"
                })
            }),
            hasError && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e3218b91ef22a757$export$47a71ce5fa63b253), {
                "data-testid": "sso-error-message",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SSO_STATUS_FETCHING_ERROR
                })
            }),
            (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(supportedSSOTypes) && supportedSSOTypes.map((method)=>{
                const Icon = $19f089f2872f050e$var$ssoIconMap[method];
                return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    "data-testid": `${method}-section`,
                    sx: $19f089f2872f050e$var$useEntraIdSectionStyle,
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                            "data-testid": `sign-in-with-${method}-button`,
                            sx: $19f089f2872f050e$var$useSignInButtonStyle,
                            startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Icon, {}),
                            onClick: ()=>redirect(method),
                            variant: "secondary",
                            size: "large",
                            disabled: isRedirecting,
                            fullWidth: true,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SIGN_IN_WITH_SSO,
                                values: {
                                    method: method
                                }
                            })
                        }),
                        !isRedirecting && (0, $c3e1b746ad236797$export$8d524fb6540252df).is(result) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e3218b91ef22a757$export$47a71ce5fa63b253), {
                            sx: $19f089f2872f050e$var$useErrorStyle,
                            "data-testid": "redirect-to-sso-error-message",
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SSO_REDIRECTING_ERROR,
                                values: {
                                    resultErrorType: result.type,
                                    method: method
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                            sx: $19f089f2872f050e$var$useUserNameStyle,
                            children: [
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                                    sx: $19f089f2872f050e$var$useUserNameLineStyle
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                                    sx: $19f089f2872f050e$var$useUserNameLabelStyle,
                                    variant: "body2",
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).OR_USE_USERNAME
                                    })
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                                    sx: $19f089f2872f050e$var$useUserNameLineStyle
                                })
                            ]
                        })
                    ]
                }, method);
            })
        ]
    });
};


const $4e21eef7ae5f85e1$var$linkStyle = {
    color: 'white',
    fontWeight: 'bold',
    cursor: 'pointer'
};
const $4e21eef7ae5f85e1$var$useOnLoginFormChange = (name)=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('loginFormUsecase');
    return (0, $h4Bez.useCallback)((value)=>usecase.updateLoginForm({
            [name]: value
        }), [
        usecase,
        name
    ]);
};
const $4e21eef7ae5f85e1$export$1f58f750f20f344b = ()=>{
    const form = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $bd157480915e9571$export$19d071bb1d74319));
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('loginFormUsecase');
    const canLogin = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $bd157480915e9571$export$8f992d7a4bbc5c24));
    const authentication = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $1c05f13022cf1480$export$d7186caa83d1ebde));
    const router = (0, $42efdbd12003f6a9$export$ddab236f5c469f6f)();
    const [login, isLoading] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(async ()=>{
        if (await usecase.login()) router.redirectHome();
    }, [
        usecase
    ]);
    const setUsername = $4e21eef7ae5f85e1$var$useOnLoginFormChange('username');
    const setPassword = $4e21eef7ae5f85e1$var$useOnLoginFormChange('password');
    const setBackup = $4e21eef7ae5f85e1$var$useOnLoginFormChange('backup');
    const setOtp = $4e21eef7ae5f85e1$var$useOnLoginFormChange('otp');
    const requiredMfa = (0, $bd157480915e9571$export$a1f60355a4099a0c)(form);
    const usingOtp = (0, $bd157480915e9571$export$aa571064e3c5dc86)(form);
    const usingBackup = (0, $bd157480915e9571$export$43a70886b2445563)(form);
    const authType = usingBackup && 'backupCodes' || usingOtp && 'otp' || null;
    const cantRequestLogin = !canLogin || isLoading;
    const loginOnKeyUp = cantRequestLogin ? undefined : (0, $1fdb53e1bec07519$export$d9ea00e8a3cf8cca)(login);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $e3218b91ef22a757$export$a7fed597f4b8afd8), {
        "data-testid": "login-form",
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LOGIN_FORM_TITLE,
        children: [
            (0, $c3e1b746ad236797$export$8d524fb6540252df).is(authentication) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e3218b91ef22a757$export$47a71ce5fa63b253), {
                children: (0, $ce07554ccb7fdbc8$export$8a25c189a0dc6a1b).is(authentication) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TOKEN_EXPIRED_ERROR
                }) : (0, $ce07554ccb7fdbc8$export$f4d656254be083ec).is(authentication) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MFA_TOKEN_EXPIRED_ERROR,
                    values: {
                        link: (0, $4772774eee62bdcc$export$18fadbe56dfcb1a1)((0, $a497eee141ca75b8$export$2e2bcd8739ae039), {
                            sx: $4e21eef7ae5f85e1$var$linkStyle,
                            'data-testid': 'login-page-link',
                            onClick: ()=>usecase.cancelMfa()
                        })
                    }
                }) : (0, $a477639c40078c3a$export$596874a932ac8047).is(authentication) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).INVALID_OTP,
                    values: {
                        minutesUntilRetry: authentication.extras.minutesUntilRetry,
                        triesLeft: authentication.extras.triesLeft,
                        banned: !authentication.extras.triesLeft
                    }
                }) : (0, $eba4f0b13361fb3e$export$d86854ef9821cdaf).is(authentication) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SSO_AUTHENTICATION_ERROR,
                    values: {
                        reason: authentication.extras.reason,
                        method: authentication.extras.method
                    }
                }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).AUTHENTICATION_ERROR,
                    values: {
                        error: authentication.type,
                        authType: authType
                    }
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $19f089f2872f050e$export$1aebea2e8b3687d6), {}),
            !requiredMfa && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e3218b91ef22a757$export$a455218a85c89869), {
                "data-testid": "login-form-username",
                name: "login-form-username",
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).USERNAME,
                type: "text",
                value: form.username,
                disabled: isLoading,
                autoComplete: "off",
                onChange: setUsername,
                autoFocus: true
            }),
            !requiredMfa && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e3218b91ef22a757$export$a455218a85c89869), {
                "data-testid": "login-form-password",
                name: "login-form-password",
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).PASSWORD,
                type: "password",
                value: form.password,
                disabled: isLoading,
                autoComplete: "one-time-code",
                onChange: setPassword,
                onKeyUp: loginOnKeyUp
            }),
            requiredMfa && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LOGIN_FORM_MFA_EXPLANATION,
                values: {
                    method: authType,
                    paragraph: (0, $4772774eee62bdcc$export$18fadbe56dfcb1a1)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        'data-testid': 'login-form-otp-explanation',
                        variant: 'body2',
                        color: 'white'
                    })
                }
            }),
            requiredMfa && usingBackup && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e3218b91ef22a757$export$a455218a85c89869), {
                "data-testid": "login-form-backupcodes",
                name: "backupcodes",
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LOGIN_FORM_BACKUP_CODE,
                type: "password",
                value: form.backup,
                disabled: isLoading,
                autoComplete: "one-time-code",
                onChange: setBackup,
                onKeyUp: loginOnKeyUp
            }),
            usingOtp && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e3218b91ef22a757$export$389d4885dfc5ad06), {
                "data-testid": "login-form-otp",
                type: "tel",
                disabled: isLoading,
                value: form.otp,
                onChange: (otp)=>{
                    setOtp(otp);
                    if ((0, $a477639c40078c3a$export$e3ec818eb1037b73)(otp)) login();
                },
                autoFocus: true
            }),
            !usingOtp && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                "data-testid": "login-form-sign-in-button",
                variant: "legacyAmber",
                size: "large",
                fullWidth: true,
                disabled: cantRequestLogin,
                onClick: login,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SIGN_IN
                })
            }),
            requiredMfa && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e3218b91ef22a757$export$a6c7ac8248d6e38a), {
                "data-testid": "login-form-toggle-mfa-button",
                disabled: isLoading,
                onClick: ()=>usecase.toggleMfaMethod(),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TOGGLE_AUTHENTICATION_METHOD,
                    values: {
                        method: authType
                    }
                })
            }),
            requiredMfa && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e3218b91ef22a757$export$a6c7ac8248d6e38a), {
                "data-testid": "login-form-cancel-mfa",
                color: "white",
                disabled: isLoading,
                onClick: ()=>usecase.cancelMfa(),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LOGIN_FORM_CANCEL_MFA
                })
            })
        ]
    });
};


const $a21d979fb8d57b20$var$Version = ()=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('versionUsecase');
    const version = (0, $h4Bez.useMemo)(()=>usecase.getUIVersion(), [
        usecase
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
        "data-testid": "connectware-version",
        variant: "body2",
        color: "white",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VERSION
            }),
            " ",
            version
        ]
    });
};
const $a21d979fb8d57b20$var$wrapperStyle = {
    height: '100vh'
};
const $a21d979fb8d57b20$var$leftSideStyle = {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 480,
    /**
     * The only leftover of legacyPrimary color
     * @see https://cybusio.atlassian.net/browse/CC-4512
     */ backgroundColor: '#0e507a',
    flexBasis: 'min-content'
};
const $a21d979fb8d57b20$var$logoWrapperStyle = {
    p: 6,
    px: 20
};
const $a21d979fb8d57b20$var$contentwrapperStyle = {
    px: 10,
    pb: 10,
    height: '100%'
};
const $a21d979fb8d57b20$var$backgroundStyle = {
    width: '100%'
};
const $a21d979fb8d57b20$export$e6dfd72ab29f8598 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
        direction: "row",
        sx: $a21d979fb8d57b20$var$wrapperStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
                sx: $a21d979fb8d57b20$var$leftSideStyle,
                square: true,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        sx: $a21d979fb8d57b20$var$logoWrapperStyle,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $85bb28abbe457e98$export$3b64d7c25f39d3f5), {})
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
                        sx: $a21d979fb8d57b20$var$contentwrapperStyle,
                        justifyContent: "space-between",
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                                "data-testid": "connectware-slogan",
                                variant: "h3",
                                color: "white",
                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTWARE_SLOGAN
                                })
                            }),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4e21eef7ae5f85e1$export$1f58f750f20f344b), {}),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($a21d979fb8d57b20$var$Version, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $a21d979fb8d57b20$var$backgroundStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9c5c25b8e801801f$export$668799e4797757a8), {})
            })
        ]
    });






parcelRequire("h4Bez");








parcelRequire("h4Bez");







parcelRequire("h4Bez");





const $64becf41a7b7c0c1$var$otpFieldStyle = {
    width: 400
};
const $64becf41a7b7c0c1$export$eaa75f57facd84cb = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $64becf41a7b7c0c1$var$otpFieldStyle,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fb8050ff7801b6d6$export$389d4885dfc5ad06), {
            ...props,
            type: "tel"
        })
    });
const $64becf41a7b7c0c1$var$actionButtonWrapperStyles = {
    regular: {
        mt: 6
    },
    dense: {
        mt: 2
    }
};
const $64becf41a7b7c0c1$export$cfc7921d29ef7b80 = ({ usecase: usecaseName, method: method, disabled: disabled = false, dense: dense = false, label: label, labelValues: labelValues, error: error = null, ...props })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)(usecaseName);
    const [confirm, confirming] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(()=>Promise.resolve(usecase[method]()), [
        usecase,
        method
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $64becf41a7b7c0c1$var$actionButtonWrapperStyles[dense ? 'dense' : 'regular'],
        ...props,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                variant: "primary",
                fullWidth: true,
                size: "large",
                disabled: confirming || disabled,
                onClick: confirm,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: label,
                    values: labelValues
                })
            }),
            error && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
                error: error,
                extras: "section"
            })
        ]
    });
};
const $64becf41a7b7c0c1$var$linkStyle = {
    cursor: 'pointer',
    mt: 2
};
const $64becf41a7b7c0c1$export$a6c7ac8248d6e38a = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $64becf41a7b7c0c1$var$linkStyle,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a497eee141ca75b8$export$2e2bcd8739ae039), {
            ...props
        })
    });
const $64becf41a7b7c0c1$var$blockStyle = {
    pt: 6
};
const $64becf41a7b7c0c1$export$d96a8827a60d6b69 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $64becf41a7b7c0c1$var$blockStyle,
        ...props
    });


const $dac5279bc19c0f84$var$gridWrapperStyle = {
    bgcolor: 'blue.50'
};
const $dac5279bc19c0f84$var$copyButtonWrapperStyle = {
    textAlign: 'right',
    my: 4,
    mx: 6
};
const $dac5279bc19c0f84$var$backupCodeStyle = {
    textAlign: 'center',
    mb: 8
};
const $dac5279bc19c0f84$export$92a03b21b232698f = ({ backupCodes: backupCodes })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('regenerateMfaBackupCodesUsecase');
    const link = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $64becf41a7b7c0c1$export$a6c7ac8248d6e38a), {
        "data-testid": "mfa-regenerate-backup-codes",
        onClick: ()=>usecase.start(),
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MFA_ENABLED_ACTION_CONFIRMATION,
            values: {
                action: 'regenerateBackupCodes'
            }
        })
    });
    if (backupCodes) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$f99233281efd08a0), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MFA_BACKUP_CODES_PRESENTATION_TITLE
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$2661e2422bcf54ba), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MFA_BACKUP_CODES_PRESENTATION_SUBTITLE
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $64becf41a7b7c0c1$export$d96a8827a60d6b69), {
                "data-testid": "mfa-backupcodes",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        container: true,
                        sx: $dac5279bc19c0f84$var$gridWrapperStyle,
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                                size: {
                                    xs: 12
                                },
                                sx: $dac5279bc19c0f84$var$copyButtonWrapperStyle,
                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1ab636062450c95b$export$92ce62e1201c4fc0), {
                                    children: backupCodes.join('\n')
                                })
                            }),
                            backupCodes.map((code, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                                    size: {
                                        xs: 4
                                    },
                                    sx: $dac5279bc19c0f84$var$backupCodeStyle,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                                        variant: "body2",
                                        children: code
                                    })
                                }, k))
                        ]
                    }),
                    link
                ]
            })
        ]
    });
    return link;
};




parcelRequire("h4Bez");





const $1fc73823694fe123$var$actions = {
    [(0, $37c2a8e29603f683$export$da170fbff8c5bb0c).REGENERATING_BACKUP_CODES]: 'regenerateBackupCodes',
    [(0, $37c2a8e29603f683$export$da170fbff8c5bb0c).DISABLING]: 'disable'
};
const $1fc73823694fe123$export$696b5a6a0bee3a6c = ({ idPrefix: idPrefix, usecase: usecaseName, ...settings })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)(usecaseName);
    const onChange = (value)=>usecase.updateInput(value);
    const authType = settings.backupCode !== null && 'backupCodes' || settings.otp !== null && 'otp';
    const action = $1fc73823694fe123$var$actions[settings.state];
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$2661e2422bcf54ba), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MFA_ENABLED_ACTION_DESCRIPTION,
                values: {
                    action: action,
                    method: authType
                }
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $64becf41a7b7c0c1$export$d96a8827a60d6b69), {
                children: [
                    settings.otp !== null && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $64becf41a7b7c0c1$export$eaa75f57facd84cb), {
                        "data-testid": `${idPrefix}-with-otp-input`,
                        value: settings.otp,
                        onChange: onChange
                    }),
                    settings.backupCode !== null && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6f84d94c688eb85b$export$57753b0d185cad1a), {
                        "data-testid": `${idPrefix}-with-backupcode-input`,
                        value: settings.backupCode,
                        onChange: onChange
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $64becf41a7b7c0c1$export$a6c7ac8248d6e38a), {
                        "data-testid": `${idPrefix}-toggle-link`,
                        onClick: ()=>usecase.toggle(),
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TOGGLE_AUTHENTICATION_METHOD,
                            values: {
                                method: authType
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $64becf41a7b7c0c1$export$a6c7ac8248d6e38a), {
                        "data-testid": `${idPrefix}-cancel-link`,
                        onClick: ()=>usecase.cancel(),
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CANCEL
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $64becf41a7b7c0c1$export$cfc7921d29ef7b80), {
                        "data-testid": `${idPrefix}-confirmation-button`,
                        usecase: usecaseName,
                        method: "confirm",
                        error: settings.error,
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MFA_ENABLED_ACTION_CONFIRMATION,
                        labelValues: {
                            action: action
                        },
                        disabled: (0, $37c2a8e29603f683$export$91e94d32412bafea)(settings) === null
                    })
                ]
            })
        ]
    });
};




var $h4Bez = parcelRequire("h4Bez");





var $h4Bez = parcelRequire("h4Bez");
'use client';
/**
 * Provides information about the current step in Stepper.
 */ const $309c52f736869993$var$StepperContext = /*#__PURE__*/ $h4Bez.createContext({});
function $309c52f736869993$export$1ff9b16b13b0447() {
    return $h4Bez.useContext($309c52f736869993$var$StepperContext);
}
var $309c52f736869993$export$2e2bcd8739ae039 = $309c52f736869993$var$StepperContext;



var $h4Bez = parcelRequire("h4Bez");
'use client';
/**
 * Provides information about the current step in Stepper.
 */ const $105f0f4c392ef9d0$var$StepContext = /*#__PURE__*/ $h4Bez.createContext({});
function $105f0f4c392ef9d0$export$90d5f24cfecec416() {
    return $h4Bez.useContext($105f0f4c392ef9d0$var$StepContext);
}
var $105f0f4c392ef9d0$export$2e2bcd8739ae039 = $105f0f4c392ef9d0$var$StepContext;






function $7d42b52082847414$export$8977e0f3c012cfac(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiStep', slot);
}
const $7d42b52082847414$var$stepClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiStep', [
    'root',
    'horizontal',
    'vertical',
    'alternativeLabel',
    'completed'
]);
var $7d42b52082847414$export$2e2bcd8739ae039 = $7d42b52082847414$var$stepClasses;



'use client';
const $7d06180d364748cc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, completed: completed } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            alternativeLabel && 'alternativeLabel',
            completed && 'completed'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $7d42b52082847414$export$8977e0f3c012cfac), classes);
};
const $7d06180d364748cc$var$StepRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiStep',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})({
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                alternativeLabel: true
            },
            style: {
                flex: 1,
                position: 'relative'
            }
        }
    ]
});
const $7d06180d364748cc$var$Step = /*#__PURE__*/ $h4Bez.forwardRef(function Step(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiStep'
    });
    const { active: activeProp, children: children, className: className, component: component = 'div', completed: completedProp, disabled: disabledProp, expanded: expanded = false, index: index, last: last, ...other } = props;
    const { activeStep: activeStep, connector: connector, alternativeLabel: alternativeLabel, orientation: orientation, nonLinear: nonLinear } = $h4Bez.useContext((0, $309c52f736869993$export$2e2bcd8739ae039));
    let [active = false, completed = false, disabled = false] = [
        activeProp,
        completedProp,
        disabledProp
    ];
    if (activeStep === index) active = activeProp !== undefined ? activeProp : true;
    else if (!nonLinear && activeStep > index) completed = completedProp !== undefined ? completedProp : true;
    else if (!nonLinear && activeStep < index) disabled = disabledProp !== undefined ? disabledProp : true;
    const contextValue = $h4Bez.useMemo(()=>({
            index: index,
            last: last,
            expanded: expanded,
            icon: index + 1,
            active: active,
            completed: completed,
            disabled: disabled
        }), [
        index,
        last,
        expanded,
        active,
        completed,
        disabled
    ]);
    const ownerState = {
        ...props,
        active: active,
        orientation: orientation,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        expanded: expanded,
        component: component
    };
    const classes = $7d06180d364748cc$var$useUtilityClasses(ownerState);
    const newChildren = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($7d06180d364748cc$var$StepRoot, {
        as: component,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: [
            connector && alternativeLabel && index !== 0 ? connector : null,
            children
        ]
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $105f0f4c392ef9d0$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: connector && !alternativeLabel && index !== 0 ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($h4Bez.Fragment, {
            children: [
                connector,
                newChildren
            ]
        }) : newChildren
    });
});
var $7d06180d364748cc$export$2e2bcd8739ae039 = $7d06180d364748cc$var$Step;


var $h4Bez = parcelRequire("h4Bez");











function $30774da2e814ff19$export$2a65e9f482ac3350(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiStepContent', slot);
}
const $30774da2e814ff19$var$stepContentClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiStepContent', [
    'root',
    'last',
    'transition'
]);
var $30774da2e814ff19$export$2e2bcd8739ae039 = $30774da2e814ff19$var$stepContentClasses;




'use client';
const $dbe886cb2698f0b1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, last: last } = ownerState;
    const slots = {
        root: [
            'root',
            last && 'last'
        ],
        transition: [
            'transition'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $30774da2e814ff19$export$2a65e9f482ac3350), classes);
};
const $dbe886cb2698f0b1$var$StepContentRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiStepContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.last && styles.last
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        marginLeft: 12,
        // half icon
        paddingLeft: 20,
        // margin + half icon
        paddingRight: 8,
        borderLeft: theme.vars ? `1px solid ${theme.vars.palette.StepContent.border}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]}`,
        variants: [
            {
                props: {
                    last: true
                },
                style: {
                    borderLeft: 'none'
                }
            }
        ]
    })));
const $dbe886cb2698f0b1$var$StepContentTransition = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $7830414f6fe32da6$export$2e2bcd8739ae039), {
    name: 'MuiStepContent',
    slot: 'Transition'
})({});
const $dbe886cb2698f0b1$var$StepContent = /*#__PURE__*/ $h4Bez.forwardRef(function StepContent(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiStepContent'
    });
    const { children: children, className: className, TransitionComponent: TransitionComponent = (0, $7830414f6fe32da6$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const { orientation: orientation } = $h4Bez.useContext((0, $309c52f736869993$export$2e2bcd8739ae039));
    const { active: active, last: last, expanded: expanded } = $h4Bez.useContext((0, $105f0f4c392ef9d0$export$2e2bcd8739ae039));
    const ownerState = {
        ...props,
        last: last
    };
    const classes = $dbe886cb2698f0b1$var$useUtilityClasses(ownerState);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            transition: TransitionProps,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('transition', {
        elementType: $dbe886cb2698f0b1$var$StepContentTransition,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.transition,
        additionalProps: {
            in: active || expanded,
            timeout: transitionDuration,
            unmountOnExit: true
        }
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($dbe886cb2698f0b1$var$StepContentRoot, {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(TransitionSlot, {
            as: TransitionComponent,
            ...transitionProps,
            children: children
        })
    });
});
var $dbe886cb2698f0b1$export$2e2bcd8739ae039 = $dbe886cb2698f0b1$var$StepContent;





var $h4Bez = parcelRequire("h4Bez");


var $h4Bez = parcelRequire("h4Bez");








'use client';
var $c2f2eace975f80e7$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), 'CheckCircle');




'use client';
var $8a0b9d5f846b6e59$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning');





function $003b36ed83731b21$export$62a6e0748bec9297(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiStepIcon', slot);
}
const $003b36ed83731b21$var$stepIconClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiStepIcon', [
    'root',
    'active',
    'completed',
    'error',
    'text'
]);
var $003b36ed83731b21$export$2e2bcd8739ae039 = $003b36ed83731b21$var$stepIconClasses;



'use client';
var $b5c48d835edd52a8$var$_circle;
const $b5c48d835edd52a8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, active: active, completed: completed, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active',
            completed && 'completed',
            error && 'error'
        ],
        text: [
            'text'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $003b36ed83731b21$export$62a6e0748bec9297), classes);
};
const $b5c48d835edd52a8$var$StepIconRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
    name: 'MuiStepIcon',
    slot: 'Root'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'block',
        transition: theme.transitions.create('color', {
            duration: theme.transitions.duration.shortest
        }),
        color: (theme.vars || theme).palette.text.disabled,
        [`&.${(0, $003b36ed83731b21$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $003b36ed83731b21$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $003b36ed83731b21$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $b5c48d835edd52a8$var$StepIconText = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('text', {
    name: 'MuiStepIcon',
    slot: 'Text'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        fill: (theme.vars || theme).palette.primary.contrastText,
        fontSize: theme.typography.caption.fontSize,
        fontFamily: theme.typography.fontFamily
    })));
const $b5c48d835edd52a8$var$StepIcon = /*#__PURE__*/ $h4Bez.forwardRef(function StepIcon(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiStepIcon'
    });
    const { active: active = false, className: classNameProp, completed: completed = false, error: error = false, icon: icon, ...other } = props;
    const ownerState = {
        ...props,
        active: active,
        completed: completed,
        error: error
    };
    const classes = $b5c48d835edd52a8$var$useUtilityClasses(ownerState);
    if (typeof icon === 'number' || typeof icon === 'string') {
        const className = (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classNameProp, classes.root);
        if (error) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b5c48d835edd52a8$var$StepIconRoot, {
            as: (0, $8a0b9d5f846b6e59$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState,
            ...other
        });
        if (completed) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b5c48d835edd52a8$var$StepIconRoot, {
            as: (0, $c2f2eace975f80e7$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState,
            ...other
        });
        return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($b5c48d835edd52a8$var$StepIconRoot, {
            className: className,
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                $b5c48d835edd52a8$var$_circle || ($b5c48d835edd52a8$var$_circle = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "12"
                })),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b5c48d835edd52a8$var$StepIconText, {
                    className: classes.text,
                    x: "12",
                    y: "12",
                    textAnchor: "middle",
                    dominantBaseline: "central",
                    ownerState: ownerState,
                    children: icon
                })
            ]
        });
    }
    return icon;
});
var $b5c48d835edd52a8$export$2e2bcd8739ae039 = $b5c48d835edd52a8$var$StepIcon;








function $5897e7656f711b4a$export$9625a725551d158a(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiStepLabel', slot);
}
const $5897e7656f711b4a$var$stepLabelClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiStepLabel', [
    'root',
    'horizontal',
    'vertical',
    'label',
    'active',
    'completed',
    'error',
    'disabled',
    'iconContainer',
    'alternativeLabel',
    'labelContainer'
]);
var $5897e7656f711b4a$export$2e2bcd8739ae039 = $5897e7656f711b4a$var$stepLabelClasses;




'use client';
const $7b16d38ffbc83c9f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, active: active, completed: completed, error: error, disabled: disabled, alternativeLabel: alternativeLabel } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        label: [
            'label',
            active && 'active',
            completed && 'completed',
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        iconContainer: [
            'iconContainer',
            active && 'active',
            completed && 'completed',
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        labelContainer: [
            'labelContainer',
            alternativeLabel && 'alternativeLabel'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $5897e7656f711b4a$export$9625a725551d158a), classes);
};
const $7b16d38ffbc83c9f$var$StepLabelRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiStepLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation]
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    [`&.${(0, $5897e7656f711b4a$export$2e2bcd8739ae039).alternativeLabel}`]: {
        flexDirection: 'column'
    },
    [`&.${(0, $5897e7656f711b4a$export$2e2bcd8739ae039).disabled}`]: {
        cursor: 'default'
    },
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                textAlign: 'left',
                padding: '8px 0'
            }
        }
    ]
});
const $7b16d38ffbc83c9f$var$StepLabelLabel = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiStepLabel',
    slot: 'Label'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body2,
        display: 'block',
        transition: theme.transitions.create('color', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $5897e7656f711b4a$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $5897e7656f711b4a$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $5897e7656f711b4a$export$2e2bcd8739ae039).alternativeLabel}`]: {
            marginTop: 16
        },
        [`&.${(0, $5897e7656f711b4a$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $7b16d38ffbc83c9f$var$StepLabelIconContainer = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiStepLabel',
    slot: 'IconContainer'
})({
    flexShrink: 0,
    display: 'flex',
    paddingRight: 8,
    [`&.${(0, $5897e7656f711b4a$export$2e2bcd8739ae039).alternativeLabel}`]: {
        paddingRight: 0
    }
});
const $7b16d38ffbc83c9f$var$StepLabelLabelContainer = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiStepLabel',
    slot: 'LabelContainer'
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        width: '100%',
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $5897e7656f711b4a$export$2e2bcd8739ae039).alternativeLabel}`]: {
            textAlign: 'center'
        }
    })));
const $7b16d38ffbc83c9f$var$StepLabel = /*#__PURE__*/ $h4Bez.forwardRef(function StepLabel(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiStepLabel'
    });
    const { children: children, className: className, componentsProps: componentsProps = {}, error: error = false, icon: iconProp, optional: optional, slots: slots = {}, slotProps: slotProps = {}, StepIconComponent: StepIconComponentProp, StepIconProps: StepIconProps, ...other } = props;
    const { alternativeLabel: alternativeLabel, orientation: orientation } = $h4Bez.useContext((0, $309c52f736869993$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed, icon: iconContext } = $h4Bez.useContext((0, $105f0f4c392ef9d0$export$2e2bcd8739ae039));
    const icon = iconProp || iconContext;
    let StepIconComponent = StepIconComponentProp;
    if (icon && !StepIconComponent) StepIconComponent = (0, $b5c48d835edd52a8$export$2e2bcd8739ae039);
    const ownerState = {
        ...props,
        active: active,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        error: error,
        orientation: orientation
    };
    const classes = $7b16d38ffbc83c9f$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            stepIcon: StepIconProps,
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('root', {
        elementType: $7b16d38ffbc83c9f$var$StepLabelRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref,
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className)
    });
    const [LabelSlot, labelProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('label', {
        elementType: $7b16d38ffbc83c9f$var$StepLabelLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [StepIconSlot, stepIconProps] = (0, $5f156b258c957bd7$export$2e2bcd8739ae039)('stepIcon', {
        elementType: StepIconComponent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            icon || StepIconSlot ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($7b16d38ffbc83c9f$var$StepLabelIconContainer, {
                className: classes.iconContainer,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(StepIconSlot, {
                    completed: completed,
                    active: active,
                    error: error,
                    icon: icon,
                    ...stepIconProps
                })
            }) : null,
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($7b16d38ffbc83c9f$var$StepLabelLabelContainer, {
                className: classes.labelContainer,
                ownerState: ownerState,
                children: [
                    children ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(LabelSlot, {
                        ...labelProps,
                        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.label, labelProps?.className),
                        children: children
                    }) : null,
                    optional
                ]
            })
        ]
    });
});
$7b16d38ffbc83c9f$var$StepLabel.muiName = 'StepLabel';
var $7b16d38ffbc83c9f$export$2e2bcd8739ae039 = $7b16d38ffbc83c9f$var$StepLabel;


var $h4Bez = parcelRequire("h4Bez");








function $7d24b195ab052c2f$export$797947b6292e28e1(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiStepper', slot);
}
const $7d24b195ab052c2f$var$stepperClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiStepper', [
    'root',
    'horizontal',
    'vertical',
    'nonLinear',
    'alternativeLabel'
]);
var $7d24b195ab052c2f$export$2e2bcd8739ae039 = $7d24b195ab052c2f$var$stepperClasses;



var $h4Bez = parcelRequire("h4Bez");











function $84c5921ed54b75f5$export$6fbaff484b0d9308(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiStepConnector', slot);
}
const $84c5921ed54b75f5$var$stepConnectorClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiStepConnector', [
    'root',
    'horizontal',
    'vertical',
    'alternativeLabel',
    'active',
    'completed',
    'disabled',
    'line',
    'lineHorizontal',
    'lineVertical'
]);
var $84c5921ed54b75f5$export$2e2bcd8739ae039 = $84c5921ed54b75f5$var$stepConnectorClasses;



'use client';
const $063eebffc8a41bd0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, active: active, completed: completed, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            alternativeLabel && 'alternativeLabel',
            active && 'active',
            completed && 'completed',
            disabled && 'disabled'
        ],
        line: [
            'line',
            `line${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(orientation)}`
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $84c5921ed54b75f5$export$6fbaff484b0d9308), classes);
};
const $063eebffc8a41bd0$var$StepConnectorRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiStepConnector',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})({
    flex: '1 1 auto',
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                marginLeft: 12 // half icon
            }
        },
        {
            props: {
                alternativeLabel: true
            },
            style: {
                position: 'absolute',
                top: 12,
                left: 'calc(-50% + 20px)',
                right: 'calc(50% + 20px)'
            }
        }
    ]
});
const $063eebffc8a41bd0$var$StepConnectorLine = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('span', {
    name: 'MuiStepConnector',
    slot: 'Line',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.line,
            styles[`line${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.orientation)}`]
        ];
    }
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600];
    return {
        display: 'block',
        borderColor: theme.vars ? theme.vars.palette.StepConnector.border : borderColor,
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    borderTopStyle: 'solid',
                    borderTopWidth: 1
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    borderLeftStyle: 'solid',
                    borderLeftWidth: 1,
                    minHeight: 24
                }
            }
        ]
    };
}));
const $063eebffc8a41bd0$var$StepConnector = /*#__PURE__*/ $h4Bez.forwardRef(function StepConnector(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiStepConnector'
    });
    const { className: className, ...other } = props;
    const { alternativeLabel: alternativeLabel, orientation: orientation = 'horizontal' } = $h4Bez.useContext((0, $309c52f736869993$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed } = $h4Bez.useContext((0, $105f0f4c392ef9d0$export$2e2bcd8739ae039));
    const ownerState = {
        ...props,
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        active: active,
        completed: completed,
        disabled: disabled
    };
    const classes = $063eebffc8a41bd0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($063eebffc8a41bd0$var$StepConnectorRoot, {
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($063eebffc8a41bd0$var$StepConnectorLine, {
            className: classes.line,
            ownerState: ownerState
        })
    });
});
var $063eebffc8a41bd0$export$2e2bcd8739ae039 = $063eebffc8a41bd0$var$StepConnector;




'use client';
const $1a4a9688a1e1352d$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, nonLinear: nonLinear, alternativeLabel: alternativeLabel, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            nonLinear && 'nonLinear',
            alternativeLabel && 'alternativeLabel'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $7d24b195ab052c2f$export$797947b6292e28e1), classes);
};
const $1a4a9688a1e1352d$var$StepperRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiStepper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.nonLinear && styles.nonLinear
        ];
    }
})({
    display: 'flex',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                flexDirection: 'row',
                alignItems: 'center'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: {
                alternativeLabel: true
            },
            style: {
                alignItems: 'flex-start'
            }
        }
    ]
});
const $1a4a9688a1e1352d$var$defaultConnector = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $063eebffc8a41bd0$export$2e2bcd8739ae039), {});
const $1a4a9688a1e1352d$var$Stepper = /*#__PURE__*/ $h4Bez.forwardRef(function Stepper(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiStepper'
    });
    const { activeStep: activeStep = 0, alternativeLabel: alternativeLabel = false, children: children, className: className, component: component = 'div', connector: connector = $1a4a9688a1e1352d$var$defaultConnector, nonLinear: nonLinear = false, orientation: orientation = 'horizontal', ...other } = props;
    const ownerState = {
        ...props,
        nonLinear: nonLinear,
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        component: component
    };
    const classes = $1a4a9688a1e1352d$var$useUtilityClasses(ownerState);
    const childrenArray = $h4Bez.Children.toArray(children).filter(Boolean);
    const steps = childrenArray.map((step, index)=>{
        return /*#__PURE__*/ $h4Bez.cloneElement(step, {
            index: index,
            last: index + 1 === childrenArray.length,
            ...step.props
        });
    });
    const contextValue = $h4Bez.useMemo(()=>({
            activeStep: activeStep,
            alternativeLabel: alternativeLabel,
            connector: connector,
            nonLinear: nonLinear,
            orientation: orientation
        }), [
        activeStep,
        alternativeLabel,
        connector,
        nonLinear,
        orientation
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $309c52f736869993$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($1a4a9688a1e1352d$var$StepperRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ...other,
            children: steps
        })
    });
});
var $1a4a9688a1e1352d$export$2e2bcd8739ae039 = $1a4a9688a1e1352d$var$Stepper;


parcelRequire("h4Bez");







const $73b6c4096578667a$var$dividerStyle = {
    my: 3
};
const $73b6c4096578667a$var$Steps = ({ title: title, subTitle: subTitle, children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a4a9688a1e1352d$export$2e2bcd8739ae039), {
        orientation: "vertical",
        connector: null,
        children: children.map((child, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7d06180d364748cc$export$2e2bcd8739ae039), {
                active: true,
                last: true,
                children: [
                    k > 0 && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {
                        variant: "fullWidth",
                        sx: $73b6c4096578667a$var$dividerStyle
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7b16d38ffbc83c9f$export$2e2bcd8739ae039), {
                        optional: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                            variant: "body2",
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: subTitle,
                                values: {
                                    step: k + 1
                                }
                            })
                        }),
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: title,
                            values: {
                                step: k + 1
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbe886cb2698f0b1$export$2e2bcd8739ae039), {
                        children: child
                    })
                ]
            }, k))
    });
const $73b6c4096578667a$var$secondStepTextTitleStyle = {
    mb: 1
};
const $73b6c4096578667a$var$copyFieldStyle = {
    [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
        verticalAlign: 'middle'
    },
    [`& .${(0, $0886a41ab9c710ef$export$2e2bcd8739ae039).input}`]: {
        textOverflow: 'ellipsis'
    }
};
const $73b6c4096578667a$var$FirstEnablingStep = ({ activation: activation })=>{
    if (activation === null) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $35e2f7ba0c5bb8e5$export$8b8493c40023057), {
        "data-testid": "mfa-activation-metadata-loader"
    });
    if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(activation)) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
        "data-testid": "mfa-activation-metadata-error",
        error: activation,
        extras: "section"
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
        direction: "row",
        spacing: 3,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8af41a648e2fa5a7$export$a77d98f00e648d58), {
                "data-testid": "mfa-activation-metadata-qrcode",
                value: activation.uri.toString()
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {
                orientation: "vertical",
                flexItem: true
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        sx: $73b6c4096578667a$var$secondStepTextTitleStyle,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MFA_SECRET_KEY_LABEL
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $556393662cf0f57c$export$2e2bcd8739ae039), {
                        "data-testid": "mfa-activation-metadata-secret-input",
                        sx: $73b6c4096578667a$var$copyFieldStyle,
                        variant: "outlined",
                        size: "small",
                        defaultValue: activation.secret,
                        InputProps: {
                            readOnly: true,
                            endAdornment: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2aefb57dc041c2ec$export$2e2bcd8739ae039), {
                                position: "end",
                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1ab636062450c95b$export$92ce62e1201c4fc0), {
                                    children: activation.secret
                                })
                            })
                        }
                    })
                ]
            })
        ]
    });
};
const $73b6c4096578667a$var$EnablingOtpField = ({ activation: activation, otp: otp })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('enableMfaUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $64becf41a7b7c0c1$export$eaa75f57facd84cb), {
        "data-testid": "mfa-enabling-otp-input",
        disabled: activation === null || (0, $c3e1b746ad236797$export$8d524fb6540252df).is(activation),
        value: otp,
        onChange: (value)=>usecase.setOtp(value)
    });
};
const $73b6c4096578667a$export$87b8e69b7e194c8 = ({ activation: activation, otp: otp, error: error })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($73b6c4096578667a$var$Steps, {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MFA_ENABLING_STEPS_TITLE,
                subTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MFA_ENABLING_STEPS_SUBTITLE,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($73b6c4096578667a$var$FirstEnablingStep, {
                        activation: activation
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($73b6c4096578667a$var$EnablingOtpField, {
                        activation: activation,
                        otp: otp
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $64becf41a7b7c0c1$export$cfc7921d29ef7b80), {
                "data-testid": "mfa-enabling-save-configuration",
                usecase: "enableMfaUsecase",
                method: "confirm",
                error: error,
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MFA_SAVE_CONFIGURATION,
                disabled: !(0, $a477639c40078c3a$export$e3ec818eb1037b73)(otp)
            })
        ]
    });


const $95d857ca97a10afd$export$bea8ebba691c5813 = ()=>{
    const { enableMfaUsecase: enableMfaUsecase, disableMfaUsecase: disableMfaUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    const state = (0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>(0, $37c2a8e29603f683$export$6d2c79465e542978)(s)?.state ?? null);
    const [enable, enabling] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(()=>enableMfaUsecase.start(), [
        enableMfaUsecase
    ]);
    const disable = ()=>disableMfaUsecase.start();
    let enabled = false;
    let onChange = null;
    switch(state){
        case (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).DISABLED:
            onChange = enable;
            break;
        case (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).REGENERATED_BACKUP_CODES:
        case (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).ENABLED:
            enabled = true;
            onChange = disable;
            break;
    }
    return onChange && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $64becf41a7b7c0c1$export$d96a8827a60d6b69), {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7ef9ef826e2d35ed$export$2e2bcd8739ae039), {
            "data-testid": "mfa-toggle",
            control: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $74886ba3288b8cfe$export$b5d5cf8927ab7262), {}),
            checked: enabled,
            label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MFA_TOGGLE
            }),
            disabled: enabling,
            onChange: onChange
        })
    });
};
const $95d857ca97a10afd$export$7c6e2c02157bb7d2 = ()=>{
    const state = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $37c2a8e29603f683$export$6d2c79465e542978));
    let content = null;
    switch(state?.state){
        case (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).LOADING:
            content = state.error ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
                error: state.error,
                extras: "section"
            }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $35e2f7ba0c5bb8e5$export$8b8493c40023057), {});
            break;
        case (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).ENABLING:
            content = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $73b6c4096578667a$export$87b8e69b7e194c8), {
                ...state
            });
            break;
        case (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).REGENERATED_BACKUP_CODES:
        case (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).ENABLED:
            content = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dac5279bc19c0f84$export$92a03b21b232698f), {
                ...state
            });
            break;
        case (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).REGENERATING_BACKUP_CODES:
            content = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1fc73823694fe123$export$696b5a6a0bee3a6c), {
                usecase: "regenerateMfaBackupCodesUsecase",
                idPrefix: "mfa-regenerating-backup-codes",
                ...state
            });
            break;
        case (0, $37c2a8e29603f683$export$da170fbff8c5bb0c).DISABLING:
            content = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1fc73823694fe123$export$696b5a6a0bee3a6c), {
                usecase: "disableMfaUsecase",
                idPrefix: "mfa-disabling",
                ...state
            });
            break;
    }
    return content && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $64becf41a7b7c0c1$export$d96a8827a60d6b69), {
        "data-testid": "mfa-content",
        children: content
    });
};



parcelRequire("h4Bez");


const $73502a1bea8699fe$export$393edc798c47379d = ({ required: required })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$f99233281efd08a0), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MULTI_FACTOR_AUTHENTICATION
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$2661e2422bcf54ba), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MFA_SETTINGS_SUBTITLE,
                values: {
                    required: required
                }
            })
        ]
    });



parcelRequire("h4Bez");


var $h4Bez = parcelRequire("h4Bez");









'use client';
const $20173740ad4bd1f2$var$defaultTheme = (0, $32d258d0759a439a$export$2e2bcd8739ae039)();
const $20173740ad4bd1f2$var$defaultCreateStyledComponent = (0, $93c004e5d2e4907b$export$2e2bcd8739ae039)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $00f59fafbaffc20f$export$2e2bcd8739ae039)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $20173740ad4bd1f2$var$useThemePropsDefault = (inProps)=>(0, $613bf551b55aae32$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $20173740ad4bd1f2$var$defaultTheme
    });
const $20173740ad4bd1f2$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $00f59fafbaffc20f$export$2e2bcd8739ae039)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, getContainerUtilityClass, classes);
};
function $20173740ad4bd1f2$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $20173740ad4bd1f2$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $20173740ad4bd1f2$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            ...!ownerState.disableGutters && {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('sm')]: {
                    paddingLeft: theme.spacing(3),
                    paddingRight: theme.spacing(3)
                }
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>({
            // @ts-ignore module augmentation fails if custom breakpoints are used
            ...ownerState.maxWidth === 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('xs')]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: Math.max(theme.breakpoints.values.xs, 444)
                }
            },
            ...ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
            ownerState.maxWidth !== 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up(ownerState.maxWidth)]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
                }
            }
        }));
    const Container = /*#__PURE__*/ $h4Bez.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg', classes: classesProp, ...other } = props;
        const ownerState = {
            ...props,
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        };
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $20173740ad4bd1f2$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $2e41620b030ed79e$exports.jsx)(ContainerRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $b4ceee382bf9d5af$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ...other
        }));
    });
    return Container;
}





'use client';
const $df7c41e965b231c6$var$Container = (0, $20173740ad4bd1f2$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $16527687018ae2c4$export$2440da353cedad43)({
            props: inProps,
            name: 'MuiContainer'
        })
});
var $df7c41e965b231c6$export$2e2bcd8739ae039 = $df7c41e965b231c6$var$Container;









const $02243fdf8043786e$var$backgroundStyle = {
    position: 'fixed',
    top: 0,
    height: '100vh',
    width: '100vw',
    zIndex: -1
};
const $02243fdf8043786e$var$backgroundImageShadowStyle = {
    ...$02243fdf8043786e$var$backgroundStyle,
    backgroundColor: 'grey.900'
};
const $02243fdf8043786e$var$backgroundImageStyle = {
    ...$02243fdf8043786e$var$backgroundStyle,
    filter: 'blur(1rem)'
};
const $02243fdf8043786e$var$logoWrapperStyle = {
    width: '400px',
    my: 3,
    mx: 'auto'
};
const $02243fdf8043786e$var$formWrapperStyle = {
    p: 2
};
const $02243fdf8043786e$var$validationStyle = {
    py: 2
};
const $02243fdf8043786e$var$selectCanManageMfa = (0, $37c2a8e29603f683$export$e7d5c70253994566)((0, $78670ebe9381a713$export$790a66df9dc00390).USE_MFA);
const $02243fdf8043786e$var$EnforceFormContent = ()=>{
    const canManageMfa = (0, $be523f14267dcd17$export$9973955de2bf96cf)($02243fdf8043786e$var$selectCanManageMfa);
    if (canManageMfa) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $95d857ca97a10afd$export$7c6e2c02157bb7d2), {});
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fb671afc24ce07a1$export$794e892580855985), {
        error: true,
        sx: $02243fdf8043786e$var$validationStyle,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MFA_MISSING_PERMISSIONS_ERROR,
            values: {
                b: (0, $4772774eee62bdcc$export$582aafb958f7fe50),
                br: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("br", {})
            }
        })
    });
};
const $02243fdf8043786e$export$13f63fa2a812df42 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $02243fdf8043786e$var$backgroundImageShadowStyle
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $02243fdf8043786e$var$backgroundImageStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9c5c25b8e801801f$export$668799e4797757a8), {})
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $df7c41e965b231c6$export$2e2bcd8739ae039), {
                maxWidth: "sm",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        sx: $02243fdf8043786e$var$logoWrapperStyle,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $85bb28abbe457e98$export$3b64d7c25f39d3f5), {})
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
                        "data-testid": "mfa-enforcement-form",
                        sx: $02243fdf8043786e$var$formWrapperStyle,
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $73502a1bea8699fe$export$393edc798c47379d), {
                                required: true
                            }),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($02243fdf8043786e$var$EnforceFormContent, {}),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $64becf41a7b7c0c1$export$cfc7921d29ef7b80), {
                                "data-testid": "mfa-cancel-enforcement",
                                usecase: "enforceMfaUsageUsecase",
                                method: "reset",
                                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BACK_TO_LOGIN,
                                dense: true
                            })
                        ]
                    })
                ]
            })
        ]
    });




var $h4Bez = parcelRequire("h4Bez");








const $da646cf922b19f26$var$wrapperStyle = {
    px: 4,
    pt: 3,
    pb: 1
};
const $da646cf922b19f26$var$dialogContentStyle = {
    ...$da646cf922b19f26$var$wrapperStyle,
    pb: 0
};
const $da646cf922b19f26$var$btnWrapperStyle = {
    px: 3,
    pt: 0
};
const $da646cf922b19f26$var$btnStyle = {
    fontSize: 'body1.fontSize'
};
/**
 * Stable id for the post-dismiss Toast (Step 9) - lets the cleanup below call `dismiss()` on it
 * directly, since `toastUsecase.show()` doesn't return the id it generated.
 */ const $da646cf922b19f26$var$TOAST_DEDUPE_KEY = 'permissions-reduced';
const $da646cf922b19f26$var$Title = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).REDUCED_PERMISSIONS_TITLE
    });
const $da646cf922b19f26$var$Warning = ({ onConfirm: onConfirm, actionName: actionName, children: children, isOpen: isOpen, onClose: onClose, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $55a2a796d4e0875c$export$2e2bcd8739ae039), {
        open: isOpen,
        fullWidth: true,
        maxWidth: "sm",
        sx: $da646cf922b19f26$var$wrapperStyle,
        "data-testid": "permissions-issues-modal",
        ...props,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dfd39f6bb0de9c2f$export$2e2bcd8739ae039), {
                sx: $da646cf922b19f26$var$wrapperStyle,
                variant: "subtitle1",
                align: "left",
                fontWeight: 700,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($da646cf922b19f26$var$Title, {})
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0aa27c46708d7ed8$export$2e2bcd8739ae039), {
                sx: $da646cf922b19f26$var$dialogContentStyle,
                children: children
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $12b0eeebf4fed103$export$2e2bcd8739ae039), {
                sx: $da646cf922b19f26$var$btnWrapperStyle,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                        onClick: onClose,
                        sx: $da646cf922b19f26$var$btnStyle,
                        variant: "primaryGhost",
                        "data-testid": "dismiss",
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISMISS
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                        disabled: !onConfirm,
                        onClick: onConfirm,
                        sx: $da646cf922b19f26$var$btnStyle,
                        variant: "primary",
                        "data-testid": "primary",
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: actionName
                        })
                    })
                ]
            })
        ]
    });
const $da646cf922b19f26$export$2f9366f48f137109 = ({ sessionObsolescenceStatus: { isMfaRequired: isMfaRequired, isMfaEnabled: isMfaEnabled } })=>{
    const { missingPermissionsUsecase: missingPermissionsUsecase, logoutUsecase: logoutUsecase, toastUsecase: toastUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    const router = (0, $42efdbd12003f6a9$export$ddab236f5c469f6f)();
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const [isDismissed, setDismissed] = (0, $h4Bez.useState)(false);
    /** Logout if MFA is enabled, otherwise it reloads the session */ const [reload, loading] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(async ()=>{
        await missingPermissionsUsecase.reload();
        router.redirectHome();
    }, [
        missingPermissionsUsecase
    ]);
    const isMfa = !isMfaEnabled && isMfaRequired;
    const actionName = isMfa ? (0, $40a99dac858c1d75$export$b63289fbda65eed1).LOGOUT : (0, $40a99dac858c1d75$export$b63289fbda65eed1).RELOAD_SESSION;
    const confirm = ()=>isMfa ? logoutUsecase.logout((0, $3f24850e5c974db2$export$55e75bec2b906c5e).MANUAL_LOGOUT) : reload();
    /**
     * Once dismissed, the Dialog is replaced by a persistent Toast carrying the same title/action -
     * deliberate: dismissing the dialog shouldn't let the user forget an unresolved MFA/session issue.
     * `persist: true` (Step 9) because this reflects an ongoing state the user hasn't resolved, not a
     * one-off event that should time out on its own.
     */ (0, $h4Bez.useEffect)(()=>{
        if (!isDismissed) return;
        toastUsecase.show({
            severity: (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).WARNING,
            title: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).REDUCED_PERMISSIONS_TITLE),
            action: {
                label: translator.formatTranslation(actionName),
                onClick: ()=>{
                    toastUsecase.dismiss($da646cf922b19f26$var$TOAST_DEDUPE_KEY);
                    confirm();
                }
            },
            persist: true,
            dedupeKey: $da646cf922b19f26$var$TOAST_DEDUPE_KEY
        });
        return ()=>toastUsecase.dismiss($da646cf922b19f26$var$TOAST_DEDUPE_KEY);
    }, [
        isDismissed
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($da646cf922b19f26$var$Warning, {
        actionName: actionName,
        onConfirm: !loading ? confirm : undefined,
        isOpen: !isDismissed,
        onClose: ()=>setDismissed(true),
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: isMfa ? (0, $40a99dac858c1d75$export$b63289fbda65eed1).MFA_ENFORCED_NOTIFICATION : (0, $40a99dac858c1d75$export$b63289fbda65eed1).PERMISSIONS_CHANGED_NOTIFICATION,
            values: {
                b: (0, $4772774eee62bdcc$export$582aafb958f7fe50)
            }
        })
    });
};






parcelRequire("h4Bez");







const $d32ed8d9a58d6793$var$selectCanManageCoreContainers = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINERS_MANAGE);
const $d32ed8d9a58d6793$var$Modals = ()=>{
    const clear = (0, $365b0b4d68ac9bb9$export$d2838f462516652)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a355bb70b0ba7fda$export$eef432f28cb72346), {
                dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CORE_CONTAINER,
                usecase: "bulkStopCoreContainersUsecase",
                containersSelector: (0, $b474aaee01cbac2d$export$4490d5230a68c9b7),
                onConfirmed: clear
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a355bb70b0ba7fda$export$5d9f3c571397c16e), {
                dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CORE_CONTAINER,
                usecase: "bulkStartCoreContainersUsecase",
                containersSelector: (0, $b474aaee01cbac2d$export$d81294bf4becdd38),
                onConfirmed: clear
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a355bb70b0ba7fda$export$ffd3ea9cd076cdb7), {
                dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CORE_CONTAINER,
                usecase: "bulkRestartCoreContainersUsecase",
                containersSelector: (0, $b474aaee01cbac2d$export$a2000d1471de8a91),
                onConfirmed: clear
            })
        ]
    });
};
const $d32ed8d9a58d6793$var$wrapperStyle = {
    py: 2
};
const $d32ed8d9a58d6793$export$4ff334d9a17b4fc3 = ()=>{
    const columns = (0, $b68825f1f040d8c8$export$2bb4647626d77979)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $d32ed8d9a58d6793$var$wrapperStyle,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8aa67788985a70f6$export$b3c28590d63f6eca), {
            subscriptionUsecase: "manageCoreContainersUsecase",
            data: (0, $b474aaee01cbac2d$export$cde74a8c249634b0),
            hasManagementCapabilitiesSelector: $d32ed8d9a58d6793$var$selectCanManageCoreContainers,
            dataTableMapper: (containers)=>containers,
            columns: columns,
            redirectOnRowclick: (0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SYSTEM_CONTAINER,
            selection: {
                DISABLE: {
                    usecase: 'bulkStopCoreContainersUsecase',
                    filter: (0, $dc261e1a4f8deea7$export$9dde073542957add),
                    filterAll: (0, $dc261e1a4f8deea7$export$e97c36b514061cac),
                    icon: (0, $17a5ddc134ac4f1f$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STOP
                },
                ENABLE: {
                    usecase: 'bulkStartCoreContainersUsecase',
                    filter: (0, $dc261e1a4f8deea7$export$e49c64d84076eb0e),
                    filterAll: (0, $dc261e1a4f8deea7$export$e97c36b514061cac),
                    icon: (0, $7323656293fbee06$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).START
                },
                RESTART: {
                    usecase: 'bulkRestartCoreContainersUsecase',
                    filter: (0, $dc261e1a4f8deea7$export$7f65084de65d53e5),
                    filterAll: (0, $dc261e1a4f8deea7$export$e97c36b514061cac)
                },
                resource: 'id',
                usecaseMethod: 'selectContainers'
            },
            translations: {
                emptyTable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_CONTAINERS_AVAILABLE
            },
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($d32ed8d9a58d6793$var$Modals, {})
        })
    });
};



parcelRequire("h4Bez");



const $8e812dfa8afe1563$var$Modals = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a355bb70b0ba7fda$export$eef432f28cb72346), {
                dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CORE_CONTAINER,
                usecase: "bulkStopCoreContainersUsecase",
                containersSelector: (0, $b474aaee01cbac2d$export$3dfc90c2e7090475)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a355bb70b0ba7fda$export$5d9f3c571397c16e), {
                dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CORE_CONTAINER,
                usecase: "bulkStartCoreContainersUsecase",
                containersSelector: (0, $b474aaee01cbac2d$export$41d946e31f4c5aaa)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a355bb70b0ba7fda$export$ffd3ea9cd076cdb7), {
                dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CORE_CONTAINER,
                usecase: "bulkRestartCoreContainersUsecase",
                containersSelector: (0, $b474aaee01cbac2d$export$6fffc264c584dcbf)
            })
        ]
    });
const $8e812dfa8afe1563$export$3e8048d3cf2ba3fd = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $264fddb75d092ad2$export$2e9120d34faa9c1f), {
        subscriptionUsecase: "manageCoreContainerUsecase",
        resourceSelector: (0, $b474aaee01cbac2d$export$679adc1bee7d9e67),
        notFoundTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTAINER_NOT_FOUND,
        modals: $8e812dfa8afe1563$var$Modals,
        headerDetails: (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $795aa440e4459e4e$export$de1f3500221e9400), {
                linkVolumes: false,
                ...props
            }),
        headerResourceName: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTAINER,
        headerName: "name",
        headerActions: (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2c099c4213d6e158$export$223875819fd7cf93), {
                restartUsecaseName: "bulkRestartCoreContainersUsecase",
                startUsecaseName: "bulkStartCoreContainersUsecase",
                stopUsecaseName: "bulkStopCoreContainersUsecase",
                managementCapability: (0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINERS_MANAGE,
                ...props
            }),
        infoTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CORE_CONTAINER_DETAILS_DOCUMENTATION_TITLE,
        infoBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CORE_CONTAINER_DETAILS_DOCUMENTATION_BODY,
        content: (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5eebd14190b74197$export$7c6e2c02157bb7d2), {
                logType: (0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).CORE_CONTAINER,
                ...props
            })
    });






var $h4Bez = parcelRequire("h4Bez");

var $fF3mG = parcelRequire("fF3mG");







const $35175334afe3bb1f$var$dateSort = (t)=>t.getTime();
const $35175334afe3bb1f$var$wrapperStyle = {
    py: 4
};
const $35175334afe3bb1f$var$toggleWrapperStyle = {
    mb: 3
};
const $35175334afe3bb1f$var$commonTableProps = {
    pagination: {
        pageSize: 10,
        pageSizeOptions: [
            10,
            25,
            50,
            100
        ]
    },
    translations: {
        noResultsOrEmptyTable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_METRICS
    },
    search: true
};
const $35175334afe3bb1f$export$ed9166ec0f465b5e = ()=>{
    const [metricsType, setMetricsType] = (0, $h4Bez.useState)('hourly');
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const systemMetricsUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('systemMetricsUsecase');
    const licenseID = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $ee9c60e7a5b417f7$export$bd5742f31bcdaad7));
    /** Retrying fetches the metrics again, as a new promise */ const [fetchAttempt, retryFetch] = (0, $9dfd779a84325298$export$aa7f9ebe4f644d13)();
    const metrics = (0, $fF3mG.usePromise)((0, $h4Bez.useMemo)(()=>systemMetricsUsecase.fetchMetrics(), [
        systemMetricsUsecase,
        fetchAttempt
    ]));
    const loaded = (0, $fF3mG.isResolved)(metrics) ? metrics.value : null;
    const loading = (0, $fF3mG.isPending)(metrics);
    const error = (0, $fF3mG.isRejected)(metrics) ? {
        error: metrics.value,
        onRetry: retryFetch
    } : undefined;
    const hourly = loaded?.hourly ?? [];
    const daily = loaded?.daily ?? [];
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $35175334afe3bb1f$var$wrapperStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $35175334afe3bb1f$var$toggleWrapperStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $14b4a2aa98aa8378$export$40258cc1d95ff477), {
                    "data-testid": "metrics-toggle",
                    value: metricsType,
                    exclusive: true,
                    /**
                     * When we click the same button again, MUI returns null (deselects it).
                     * We only accept a valid type, ignoring null to keep a selection active.
                     */ onChange: (_, newType)=>newType && setMetricsType(newType),
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a0c70995540c0264$export$d2b052e7b4be1756), {
                            value: "hourly",
                            "aria-label": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).MESSAGE_PER_HOUR),
                            "data-testid": "hourly-toggle",
                            children: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).MESSAGE_PER_HOUR)
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a0c70995540c0264$export$d2b052e7b4be1756), {
                            value: "daily",
                            "aria-label": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).MESSAGE_PER_DAY),
                            "data-testid": "daily-toggle",
                            children: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).MESSAGE_PER_DAY)
                        })
                    ]
                })
            }),
            metricsType === 'hourly' && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
                "data-testid": "metrics-per-hour",
                columns: {
                    timestamp: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TIME,
                        customCellRender: (date)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$d275c5eeba29af75), {
                                date: date,
                                format: "datetime"
                            }),
                        sort: $35175334afe3bb1f$var$dateSort,
                        type: 'datetime'
                    },
                    numberOfConnectedDatapoints: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NUMBER_OF_DATAPOINTS,
                        sort: true,
                        type: 'number'
                    },
                    numberOfReceivedMessages: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NUMBER_OF_MESSAGES_PER_HOUR,
                        customCellRender: (value)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbba8fd6e98bab28$export$db80edc1e6b2f63d), {
                                value: value,
                                style: "decimal"
                            }),
                        sort: true,
                        type: 'number'
                    }
                },
                sortOrder: {
                    name: 'timestamp',
                    direction: 'desc'
                },
                data: hourly,
                loading: loading,
                error: error,
                onDownloadCSV: loaded ? ()=>systemMetricsUsecase.downloadHourlyMetricCSV(hourly) : undefined,
                ...$35175334afe3bb1f$var$commonTableProps
            }),
            metricsType === 'daily' && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
                "data-testid": "metrics-per-day",
                columns: {
                    date: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DATE,
                        customCellRender: (date)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$d275c5eeba29af75), {
                                date: date,
                                format: "dateOnly"
                            }),
                        sort: $35175334afe3bb1f$var$dateSort,
                        type: 'datetime'
                    },
                    numberOfConnectedDatapoints: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NUMBER_OF_DATAPOINTS,
                        sort: true,
                        type: 'number'
                    },
                    numberOfReceivedMessages: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NUMBER_OF_MESSAGES_PER_DAY,
                        customCellRender: (value)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbba8fd6e98bab28$export$db80edc1e6b2f63d), {
                                value: value,
                                style: "decimal"
                            }),
                        sort: true,
                        type: 'number'
                    }
                },
                sortOrder: {
                    name: 'date',
                    direction: 'desc'
                },
                data: daily.map((d)=>({
                        licenseID: licenseID,
                        ...d
                    })),
                loading: loading,
                error: error,
                onDownloadCSV: loaded ? ()=>systemMetricsUsecase.downloadDailyMetricCSV(daily) : undefined,
                ...$35175334afe3bb1f$var$commonTableProps
            })
        ]
    });
};





parcelRequire("h4Bez");






const $766278ae845073fa$var$Modals = ()=>{
    const clear = (0, $365b0b4d68ac9bb9$export$d2838f462516652)();
    const bulkDelete = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bulkDeleteAgentsUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1340d16cad42623c$export$54399887e057b4b7), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_AGENTS,
        subtitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_AGENTS_SUBTITLE,
        confirm: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE,
        resourceSelector: (0, $9ede1dd6506a21d3$export$1135a0877e5140ce),
        dimension: (0, $5e13938500eec645$export$c6f9da6f70cfc2eb).AGENT,
        onRenderLineContent: "name",
        onCancel: ()=>bulkDelete.selectAgents(null),
        onConfirm: async ()=>{
            await bulkDelete.delete();
            clear();
        }
    });
};
const $766278ae845073fa$var$selectCanManageAgents = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).AGENTS_MANAGE);
const $766278ae845073fa$var$wrapperStyle = {
    py: 2
};
const $766278ae845073fa$export$6929ce49fce4ad0 = ()=>{
    const customCellRender = (status)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
            status: status
        });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $766278ae845073fa$var$wrapperStyle,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8aa67788985a70f6$export$b5d723e193e2be22), {
            subscriptionUsecase: "manageAgentsUsecase",
            data: (0, $9ede1dd6506a21d3$export$d4d8ee9ce1c82cec),
            hasManagementCapabilitiesSelector: $766278ae845073fa$var$selectCanManageAgents,
            dataTableMapper: (agents)=>agents.map(({ hostname: hostname, containerId: containerId, ...a })=>({
                        ...a,
                        hostnameOrContainer: {
                            hostname: hostname,
                            containerId: containerId
                        }
                    })),
            columns: {
                name: {
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                    sort: true
                },
                version: {
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VERSION,
                    sort: true
                },
                status: {
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS,
                    customCellRender: customCellRender,
                    sort: true
                },
                hostnameOrContainer: {
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).HOSTNAME,
                    customCellRender: ({ hostname: hostname, containerId: containerId })=>hostname || (containerId ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
                            children: [
                                containerId,
                                " (",
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTAINER_ID
                                }),
                                ")"
                            ]
                        }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$3eec49f24c546686), {}))
                }
            },
            selection: {
                DELETE: {
                    usecase: 'bulkDeleteAgentsUsecase',
                    filter: (0, $9ede1dd6506a21d3$export$f543d47ae073f806)
                },
                resource: 'name',
                usecaseMethod: 'selectAgents'
            },
            translations: {
                emptyTable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_AGENTS_RUNNING
            },
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($766278ae845073fa$var$Modals, {})
        })
    });
};






var $h4Bez = parcelRequire("h4Bez");




parcelRequire("h4Bez");



"use client";
var $b7257e986acaa6bb$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), 'Cancel');





var $h4Bez = parcelRequire("h4Bez");

var $fF3mG = parcelRequire("fF3mG");


const $eb0a4b0412d632c2$var$selectCanUpdateLicense = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_LICENSE_MANAGE);
const $eb0a4b0412d632c2$export$d897655ca7ef8c9 = ()=>(0, $be523f14267dcd17$export$9973955de2bf96cf)($eb0a4b0412d632c2$var$selectCanUpdateLicense);
const $eb0a4b0412d632c2$export$c906343a261af8da = ()=>{
    const licenseView = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('licenseViewUsecase');
    const promise = (0, $h4Bez.useMemo)(()=>licenseView.fetchPortalConnectivity(), [
        licenseView
    ]);
    return (0, $fF3mG.ifUnresolved)((0, $fF3mG.usePromise)(promise), null);
};


const $9e38aba0e3b21f71$var$portalStyle = {
    display: 'flex',
    mb: 2,
    px: 0,
    '& > *': {
        my: 'auto',
        mx: 0
    }
};
const $9e38aba0e3b21f71$var$portalIconStyle = {
    mr: 2,
    color: 'red.500'
};
const $9e38aba0e3b21f71$export$cc14f7e1d875899e = ()=>{
    const canUpdateLicense = (0, $eb0a4b0412d632c2$export$d897655ca7ef8c9)();
    const connectivity = (0, $eb0a4b0412d632c2$export$c906343a261af8da)();
    if (!canUpdateLicense || connectivity === null || connectivity?.reachable) /**
         * If its loaded, render nothing
         */ return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $9e38aba0e3b21f71$var$portalStyle,
        "data-testid": "portal-reachability-issues",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b7257e986acaa6bb$export$2e2bcd8739ae039), {
                sx: $9e38aba0e3b21f71$var$portalIconStyle
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        variant: "body2",
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).IS_URL_REACHABLE,
                            values: {
                                url: connectivity.url?.toString() || /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CYBUS_PORTAL
                                }),
                                reachable: false
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        variant: "body2",
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_REFRESH_REQUIRES_INTERNET
                        })
                    })
                ]
            })
        ]
    });
};


const $32877b473a860a7a$var$wrapperStyle = {
    py: 4
};
const $32877b473a860a7a$export$771fbc65b432e290 = ()=>{
    const infoUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('informationUsecase');
    (0, $h4Bez.useEffect)(()=>infoUsecase.loadInformation(), [
        infoUsecase
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $32877b473a860a7a$var$wrapperStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9e38aba0e3b21f71$export$cc14f7e1d875899e), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                "data-testid": "license-details",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a9cdbfbbdc2ac259$export$418b7f0dac0cde16), {})
            })
        ]
    });
};





parcelRequire("h4Bez");







parcelRequire("h4Bez");






var $h4Bez = parcelRequire("h4Bez");


const $0289cbce360eca55$var$emailTypes = {
    support: 'getSupportEmail',
    sales: 'getSalesEmail'
};
const $0289cbce360eca55$var$sendEmailTypes = {
    support: 'sendSupportEmail',
    sales: 'sendSalesEmail'
};
const $0289cbce360eca55$var$ContactEmailLink = ({ type: type, children: children, subject: subject, ...props })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('contactInformationUsecase');
    const actualChildren = (0, $h4Bez.useMemo)(()=>children || usecase[$0289cbce360eca55$var$emailTypes[type]](), [
        usecase,
        type,
        children
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a497eee141ca75b8$export$2e2bcd8739ae039), {
        ...props,
        onClick: ()=>usecase[$0289cbce360eca55$var$sendEmailTypes[type]](subject),
        children: actualChildren
    });
};
const $0289cbce360eca55$export$31064bb00d236518 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($0289cbce360eca55$var$ContactEmailLink, {
        ...props,
        type: "sales"
    });
const $0289cbce360eca55$export$728c7035f398155c = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($0289cbce360eca55$var$ContactEmailLink, {
        ...props,
        type: "support"
    });









const $6830a2d580bf7860$var$loaderStyle = {
    textAlign: 'center'
};
const $6830a2d580bf7860$var$contentStyle = {
    py: 1
};
const $6830a2d580bf7860$var$leftColumnContentStyle = {
    p: 1,
    pl: 0
};
const $6830a2d580bf7860$var$rightColumnsContentStyle = {
    p: 1,
    pr: 0
};
const $6830a2d580bf7860$var$buttonStyle = {
    textAlign: 'center',
    py: 1
};
const $6830a2d580bf7860$var$helpFooterStyle = {
    pt: 1
};
const $6830a2d580bf7860$var$formatting = {
    p: (0, $4772774eee62bdcc$export$18fadbe56dfcb1a1)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
        variant: 'body1',
        className: 'license-modal-paragraph'
    }),
    b: (0, $4772774eee62bdcc$export$582aafb958f7fe50)
};
const $6830a2d580bf7860$var$ErrorMessage = ({ error: error })=>{
    const reason = (0, $c3e1b746ad236797$export$8d524fb6540252df).isOfTypes(error, (0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION) ? 'permissions' : null;
    const permissions = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $1c05f13022cf1480$export$7326d92567ef4631));
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_VALIDATION_ERROR,
                values: {
                    reason: reason,
                    ...$6830a2d580bf7860$var$formatting
                }
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTACT_YOUR_ADMINISTRATOR,
                values: {
                    reason: reason,
                    permissions: permissions && (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(permissions) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbba8fd6e98bab28$export$f52b44e459e6e71d), {
                        value: permissions
                    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NONE
                    }),
                    ...$6830a2d580bf7860$var$formatting
                }
            })
        ]
    });
};
const $6830a2d580bf7860$var$OfflineCheck = ()=>{
    const connectivity = (0, $eb0a4b0412d632c2$export$c906343a261af8da)();
    const offlineActivationLink = (0, $4772774eee62bdcc$export$18fadbe56dfcb1a1)((0, $57ff7f54e54013be$export$6eb1e07b1de459cd), {
        className: 'offline-activation-link',
        type: (0, $de76aa5bd91d062d$export$26609300e3bf37cf).LICENSE_OFFLINE_ACTIVATION
    });
    if (!connectivity) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: true,
        columnSpacing: 2,
        alignItems: 'center',
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $95388f9578043f1e$export$2e2bcd8739ae039), {
                    size: 30
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_ONLINE_AVAILABILITY_CHECK,
                    values: {
                        ...$6830a2d580bf7860$var$formatting
                    }
                })
            })
        ]
    });
    if (connectivity?.reachable) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_EXPIRED_EXTENSION_NEEDED,
                values: {
                    ...$6830a2d580bf7860$var$formatting
                }
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $6830a2d580bf7860$var$buttonStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bc1031444e23636e$export$e572285f0daceeda), {})
            })
        ]
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_OFFLINE_ACTIVATION,
                values: {
                    offlineActivationLink: offlineActivationLink,
                    ...$6830a2d580bf7860$var$formatting
                }
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $6830a2d580bf7860$var$buttonStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bc1031444e23636e$export$30bf7edb81da41fe), {})
            })
        ]
    });
};
const $6830a2d580bf7860$export$7c6e2c02157bb7d2 = ({ license: license })=>{
    const canUpdateLicense = (0, $eb0a4b0412d632c2$export$d897655ca7ef8c9)();
    if (license === null) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $6830a2d580bf7860$var$loaderStyle,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $95388f9578043f1e$export$2e2bcd8739ae039), {})
    });
    if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(license)) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($6830a2d580bf7860$var$ErrorMessage, {
        error: license
    });
    const { name: name, id: id, activated: activated, expiration: expiration } = license;
    const documentationUrl = (0, $4772774eee62bdcc$export$18fadbe56dfcb1a1)((0, $57ff7f54e54013be$export$6eb1e07b1de459cd), {
        className: 'licensing-link',
        type: (0, $de76aa5bd91d062d$export$26609300e3bf37cf).LICENSING
    });
    const offlineActivationLink = (0, $4772774eee62bdcc$export$18fadbe56dfcb1a1)((0, $57ff7f54e54013be$export$6eb1e07b1de459cd), {
        className: 'offline-activation-link',
        type: (0, $de76aa5bd91d062d$export$26609300e3bf37cf).LICENSE_OFFLINE_ACTIVATION
    });
    const supportEmail = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0289cbce360eca55$export$728c7035f398155c), {});
    const salesEmailLink = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0289cbce360eca55$export$31064bb00d236518), {});
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_ERROR_SUMMARY,
                values: {
                    name: name,
                    id: id,
                    activatable: !activated && canUpdateLicense,
                    activated: activated,
                    expiration: expiration && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$d275c5eeba29af75), {
                        date: expiration,
                        format: "dateOnly"
                    }),
                    ...$6830a2d580bf7860$var$formatting
                }
            }),
            canUpdateLicense ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
                children: [
                    activated ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        sx: $6830a2d580bf7860$var$contentStyle,
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_EXPIRED_CONTACT_SALES,
                                values: {
                                    salesEmailLink: salesEmailLink,
                                    ...$6830a2d580bf7860$var$formatting
                                }
                            }),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($6830a2d580bf7860$var$OfflineCheck, {})
                        ]
                    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        container: true,
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                                size: {
                                    xs: 6
                                },
                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                                    sx: $6830a2d580bf7860$var$leftColumnContentStyle,
                                    children: [
                                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_ACTIVATION_TITLE,
                                            values: {
                                                type: 'online',
                                                ...$6830a2d580bf7860$var$formatting
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_ONLINE_ACTIVATION,
                                            values: {
                                                salesEmailLink: salesEmailLink,
                                                ...$6830a2d580bf7860$var$formatting
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                                size: {
                                    xs: 6
                                },
                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                                    sx: $6830a2d580bf7860$var$rightColumnsContentStyle,
                                    children: [
                                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_ACTIVATION_TITLE,
                                            values: {
                                                type: 'offline',
                                                ...$6830a2d580bf7860$var$formatting
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_OFFLINE_ACTIVATION,
                                            values: {
                                                offlineActivationLink: offlineActivationLink,
                                                ...$6830a2d580bf7860$var$formatting
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                                size: {
                                    xs: 6
                                },
                                sx: $6830a2d580bf7860$var$buttonStyle,
                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bc1031444e23636e$export$e572285f0daceeda), {})
                            }),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                                size: {
                                    xs: 6
                                },
                                sx: $6830a2d580bf7860$var$buttonStyle,
                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bc1031444e23636e$export$30bf7edb81da41fe), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        sx: $6830a2d580bf7860$var$helpFooterStyle,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_MODAL_FOOTER,
                            values: {
                                documentationUrl: documentationUrl,
                                supportEmail: supportEmail,
                                ...$6830a2d580bf7860$var$formatting
                            }
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTACT_YOUR_ADMINISTRATOR,
                values: {
                    reason: 'license',
                    ...$6830a2d580bf7860$var$formatting
                }
            })
        ]
    });
};



parcelRequire("h4Bez");




const $a311a47b8bb7a174$var$wrapperStyle = {
    display: 'flex'
};
const $a311a47b8bb7a174$var$iconStyle = {
    my: 'auto',
    mx: 0
};
const $a311a47b8bb7a174$var$titleStyle = {
    m: 'auto'
};
const $a311a47b8bb7a174$export$f99233281efd08a0 = ({ loading: loading })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $a311a47b8bb7a174$var$wrapperStyle,
        children: [
            !loading && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b3344c5f781513f7$export$2e2bcd8739ae039), {
                sx: $a311a47b8bb7a174$var$iconStyle,
                color: "error",
                fontSize: "large"
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                sx: $a311a47b8bb7a174$var$titleStyle,
                variant: "subtitle1",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_MODAL_TITLE,
                    values: {
                        loading: loading
                    }
                })
            })
        ]
    });


const $ddd083879c936398$export$2b77a92f1a5ad772 = ()=>{
    const license = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $ee9c60e7a5b417f7$export$f118100f1b195a18));
    const { logoutUsecase: logoutUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $55a2a796d4e0875c$export$2e2bcd8739ae039), {
        "data-testid": "license-issues-modal",
        disableEscapeKeyDown: true,
        open: true,
        fullWidth: true,
        maxWidth: "md",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dfd39f6bb0de9c2f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a311a47b8bb7a174$export$f99233281efd08a0), {
                    loading: !license
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0aa27c46708d7ed8$export$2e2bcd8739ae039), {
                dividers: true,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6830a2d580bf7860$export$7c6e2c02157bb7d2), {
                    license: license
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $12b0eeebf4fed103$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                    "data-testid": "license-check-modal-logout",
                    variant: "primary",
                    onClick: ()=>logoutUsecase.logout((0, $3f24850e5c974db2$export$55e75bec2b906c5e).MANUAL_LOGOUT),
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LOGOUT
                    })
                })
            })
        ]
    });
};





parcelRequire("h4Bez");








var $h4Bez = parcelRequire("h4Bez");






const $74635fd2e0dab00e$var$containerStyle = {
    justifyContent: 'flexStart',
    alignItems: 'center'
};
const $74635fd2e0dab00e$var$licenseIdStyle = {
    fontFamily: 'monospace',
    pr: 2
};
const $74635fd2e0dab00e$var$buttonStyle = {
    '&:hover': {
        opacity: 0.5,
        backgroundColor: 'transparent'
    },
    paddingY: 0
};
const $74635fd2e0dab00e$var$CHARS_TO_REVEAL = 4;
const $74635fd2e0dab00e$var$MASK_CHAR = '*';
const $74635fd2e0dab00e$export$6b198cb50a71655e = ({ id: id })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const [isIdHidden, toggleIdVisibility] = (0, $h4Bez.useState)(true);
    // mask license id with MASK_CHAR but show the last CHARS_TO_REVEAL characters (4 by default)
    const maskedId = id.slice(0, -$74635fd2e0dab00e$var$CHARS_TO_REVEAL).replaceAll(/[^-]/g, $74635fd2e0dab00e$var$MASK_CHAR) + id.slice(-$74635fd2e0dab00e$var$CHARS_TO_REVEAL);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d06d05d70ecd5bc3$export$2e2bcd8739ae039), {
        direction: "row",
        sx: $74635fd2e0dab00e$var$containerStyle,
        "data-testid": "license-id",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "body2",
                sx: $74635fd2e0dab00e$var$licenseIdStyle,
                children: isIdHidden ? maskedId : id
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
                onClick: ()=>toggleIdVisibility(!isIdHidden),
                "data-testid": isIdHidden ? 'show-license-btn' : 'hide-license-btn',
                variant: "ghost",
                sx: $74635fd2e0dab00e$var$buttonStyle,
                children: isIdHidden ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $369aad4adb4c0e5d$export$2e2bcd8739ae039), {
                    titleAccess: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).SHOW_LICENSE_ID)
                }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $308788bd9935f809$export$2e2bcd8739ae039), {
                    titleAccess: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).HIDE_LICENSE_ID)
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1ab636062450c95b$export$3907644cc4885eb4), {
                title: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).COPY_LICENSE_ID),
                sx: $74635fd2e0dab00e$var$buttonStyle,
                children: id
            })
        ]
    });
};



parcelRequire("h4Bez");



"use client";
var $24f0f0a5ab02a191$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), 'Launch');






const $fa19ff9a4845d867$var$actionNeededStyle = {
    my: '10px',
    mx: 0
};
const $fa19ff9a4845d867$var$openDocumentationLinkStyle = {
    height: '1rem',
    width: '1rem',
    verticalAlign: 'text-bottom'
};
const $fa19ff9a4845d867$export$f59564c1fc7a02c = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bb140bd70ba0d464$export$2e2bcd8739ae039), {
                "data-testid": "no-license-alert",
                sx: $fa19ff9a4845d867$var$actionNeededStyle,
                severity: "warning",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_ACTIVATION_NEEDED
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_ACTIVATION_NEEDED_DESCRIPTION,
                values: {
                    paragraph: (...content)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                            variant: "body1",
                            children: content
                        }),
                    link: (...content)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $57ff7f54e54013be$export$6eb1e07b1de459cd), {
                            "data-testid": "no-license-link",
                            title: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).OPEN_DOCUMENTATION),
                            type: (0, $de76aa5bd91d062d$export$26609300e3bf37cf).LICENSE_OFFLINE_ACTIVATION,
                            children: [
                                content,
                                " ",
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $24f0f0a5ab02a191$export$2e2bcd8739ae039), {
                                    sx: $fa19ff9a4845d867$var$openDocumentationLinkStyle
                                })
                            ]
                        })
                }
            })
        ]
    });
};


const $a9cdbfbbdc2ac259$var$errorStyle = {
    py: 2
};
const $a9cdbfbbdc2ac259$var$titleStyle = {
    width: 250
};
const $a9cdbfbbdc2ac259$export$418b7f0dac0cde16 = ()=>{
    const license = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $ee9c60e7a5b417f7$export$f118100f1b195a18));
    if (!license) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $35e2f7ba0c5bb8e5$export$8b8493c40023057), {});
    if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(license)) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
        sx: $a9cdbfbbdc2ac259$var$errorStyle,
        error: license,
        extras: "popover"
    });
    if (!license.activated) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fa19ff9a4845d867$export$f59564c1fc7a02c), {});
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        "data-testid": "license-table",
        hideHeader: true,
        columns: {
            title: {
                customCellRender: (value)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: value
                    }),
                sx: $a9cdbfbbdc2ac259$var$titleStyle
            },
            data: {
                customCellRender: (value, { title: title })=>{
                    if (typeof value === 'boolean') return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
                        status: value ? (0, $1041b3cad55163d4$export$e35c1996c6f482ad).VALID : (0, $1041b3cad55163d4$export$e35c1996c6f482ad).INVALID
                    });
                    if ((0, $091b76300838ede1$export$e470987fa2f20e6)(value)) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$d275c5eeba29af75), {
                        date: value,
                        format: "dateOnly"
                    });
                    if (title === (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_ID) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $74635fd2e0dab00e$export$6b198cb50a71655e), {
                        id: value
                    });
                    return value || /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NOT_AVAILABLE
                    });
                }
            }
        },
        data: [
            {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_NAME,
                data: license.name
            },
            {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_ACCOUNT,
                data: license.account
            },
            {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).EXPIRATION_DATE,
                data: license.expiration
            },
            {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_CLASS,
                data: license.class
            },
            {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_ID,
                data: license.id
            },
            {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LICENSE_STATUS,
                data: license.valid
            }
        ]
    });
};







var $h4Bez = parcelRequire("h4Bez");



"use client";
var $922c30674bbda6de$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8m0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4z"
}), 'Sync');









const $bc1031444e23636e$var$hiddenStyle = {
    display: 'none'
};
const $bc1031444e23636e$var$buttonStyle = {
    ml: 2
};
const $bc1031444e23636e$var$LicenseActionButton = ({ tooltip: tooltip, Hidden: Hidden, disabled: disabled, onClick: onClick, startIcon: startIcon, children: children })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const canUpdateLicense = (0, $eb0a4b0412d632c2$export$d897655ca7ef8c9)();
    const [load, loading, result] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)((promise)=>promise, []);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $69cdbe69cde47e02$export$2e2bcd8739ae039), {
        title: !loading && (0, $c3e1b746ad236797$export$8d524fb6540252df).is(result) ? result.message : translator.formatTranslation(tooltip),
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                variant: (0, $c3e1b746ad236797$export$8d524fb6540252df).is(result) ? 'dangerOutline' : 'secondary',
                size: "large",
                startIcon: startIcon,
                disabled: disabled || !canUpdateLicense || loading,
                onClick: ()=>{
                    const result = onClick();
                    if (result instanceof Promise) load(result);
                },
                sx: $bc1031444e23636e$var$buttonStyle,
                children: [
                    Hidden && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        sx: $bc1031444e23636e$var$hiddenStyle,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Hidden, {
                            setLoading: load
                        })
                    }),
                    children
                ]
            })
        })
    });
};
const $bc1031444e23636e$export$30bf7edb81da41fe = ()=>{
    const uploadLicenseFileUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('uploadLicenseFileUsecase');
    const supportedFileTypes = (0, $h4Bez.useMemo)(()=>uploadLicenseFileUsecase.getSupportedLicenseFileExtensions(), [
        uploadLicenseFileUsecase
    ]);
    const ref = /*#__PURE__*/ (0, $h4Bez.createRef)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($bc1031444e23636e$var$LicenseActionButton, {
        tooltip: (0, $40a99dac858c1d75$export$b63289fbda65eed1).UPLOAD_LICENSE_FILE,
        onClick: (0, $1fdb53e1bec07519$export$a5a34735bf65cdae)(ref),
        startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2510eecdad012f77$export$2e2bcd8739ae039), {
            fontSize: "small"
        }),
        /**
             * This button relies on a hidden file upload field
             * Whenever the user clicks on the button, the file input is triggered
             *
             * If there is a file upload, then attempt loading
             */ Hidden: ({ setLoading: setLoading })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f81bd50c14cd4ce4$export$f0b9a6b1089d086a), {
                ref: ref,
                accept: supportedFileTypes,
                onChange: (files)=>setLoading(/** Read the selected file and upload its content */ (0, $2371d85f76b63637$export$925a4c3537ec7ca4)(files).then((content)=>content ? uploadLicenseFileUsecase.upload(content) : Promise.resolve()))
            }),
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).UPLOAD_LICENSE_FILE
        })
    });
};
const $bc1031444e23636e$export$e572285f0daceeda = ()=>{
    const { refreshLicenseUsecase: refreshLicenseUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    const connectivity = (0, $eb0a4b0412d632c2$export$c906343a261af8da)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($bc1031444e23636e$var$LicenseActionButton, {
        tooltip: (0, $40a99dac858c1d75$export$b63289fbda65eed1).REFRESH_LICENSE_FILE_FROM_PORTAL,
        onClick: ()=>refreshLicenseUsecase.refresh(),
        startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $922c30674bbda6de$export$2e2bcd8739ae039), {
            fontSize: "small"
        }),
        disabled: connectivity === null || !connectivity.reachable,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).REFRESH_LICENSE
        })
    });
};





parcelRequire("h4Bez");







var $h4Bez = parcelRequire("h4Bez");


"use client";
var $e0801ff80ad4b464$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M2.01 21 23 12 2.01 3 2 10l15 2-15 2z"
}), 'Send');



var $fF3mG = parcelRequire("fF3mG");





const $2cc726f78ed79ca6$var$selectCanManageMetrics = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_METRICS_MANAGE);
const $2cc726f78ed79ca6$export$122036ed26cf85c3 = ()=>{
    const isAuthenticated = (0, $be523f14267dcd17$export$9973955de2bf96cf)($2cc726f78ed79ca6$var$selectCanManageMetrics);
    const { systemMetricsUsecase: systemMetricsUsecase, toastUsecase: toastUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const [sendMetricsToPortal, isLoading, result] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(()=>systemMetricsUsecase.sendMetricsToPortal(), [
        systemMetricsUsecase
    ]);
    const sentResponse = isLoading || result === null ? false : result;
    const metrics = (0, $fF3mG.usePromise)((0, $h4Bez.useMemo)(()=>systemMetricsUsecase.fetchMetrics(), [
        systemMetricsUsecase
    ]));
    (0, $h4Bez.useEffect)(()=>{
        if (sentResponse === false) /** Nothing has happened yet */ return;
        toastUsecase.show({
            severity: (0, $c3e1b746ad236797$export$8d524fb6540252df).is(result) ? (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).ERROR : (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).SUCCESS,
            title: (0, $c3e1b746ad236797$export$8d524fb6540252df).is(result) ? result.message : translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).SUCCESSFULLY_SENT_METRICS_TO_PORTAL)
        });
    }, [
        sentResponse,
        toastUsecase,
        translator
    ]);
    if ((0, $fF3mG.isResolved)(metrics) && !metrics.value.isPortalReachable) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
        "data-testid": "send-metrics-button",
        variant: "secondary",
        size: "large",
        onClick: sendMetricsToPortal,
        disabled: !isAuthenticated || isLoading,
        startIcon: isLoading ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $95388f9578043f1e$export$2e2bcd8739ae039), {
            size: "1rem"
        }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e0801ff80ad4b464$export$2e2bcd8739ae039), {}),
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SEND_METRICS_TO_PORTAL
        })
    });
};


const $a41f810df71af281$var$tabs = {
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_CONTAINERS]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CORE_CONTAINERS_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CORE_CONTAINERS_DOCUMENTATION_BODY
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_INTERNET_CONNECTIVITY]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).INTERNET_CONNECTIVITY_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).INTERNET_CONNECTIVITY_DOCUMENTATION_BODY
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_METRICS]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).METRICS_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).METRICS_DOCUMENTATION_BODY,
        titleActions: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2cc726f78ed79ca6$export$122036ed26cf85c3), {})
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_AGENTS]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).AGENT_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).AGENT_DOCUMENTATION_BODY
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_LICENSE]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).INFO_PAGE_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).INFO_PAGE_DOCUMENTATION_BODY,
        titleActions: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bc1031444e23636e$export$e572285f0daceeda), {}),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bc1031444e23636e$export$30bf7edb81da41fe), {})
            ]
        })
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_INFORMATION]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SYSTEM_INFORMATION_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SYSTEM_INFORMATION_DOCUMENTATION_BODY
    }
};
const $a41f810df71af281$export$444c7346aa399f17 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbf979062de799bc$export$7d4a22e995b7a67e), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SYSTEM_STATUS,
        tabs: $a41f810df71af281$var$tabs
    });




var $h4Bez = parcelRequire("h4Bez");






const $b02280fe32ee04dc$var$wrapperStyle = {
    py: 4
};
const $b02280fe32ee04dc$var$Wrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "info-preflight",
        sx: $b02280fe32ee04dc$var$wrapperStyle,
        children: children
    });
};
/** Plain text, so the table's search and sort work on what is shown */ const $b02280fe32ee04dc$var$useConnectivityLines = (endpoints)=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const toLine = (type, name, detail)=>{
        const { url: url, reachable: reachable } = endpoints[type];
        const reachability = translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).IS_URL_REACHABLE, {
            url: url.toString(),
            reachable: reachable
        });
        return {
            name: translator.formatTranslation(name),
            info: `${reachability} ${detail}`,
            status: reachable ? (0, $1041b3cad55163d4$export$e35c1996c6f482ad).REACHABLE : (0, $1041b3cad55163d4$export$e35c1996c6f482ad).UNREACHABLE
        };
    };
    return [
        toLine('cybusPortal', (0, $40a99dac858c1d75$export$b63289fbda65eed1).CYBUS_PORTAL, translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).CYBUS_PORTAL_STATUS, {
            updatesAutomatically: endpoints.cybusPortal.reachable
        })),
        toLine('cybusRegistry', (0, $40a99dac858c1d75$export$b63289fbda65eed1).CYBUS_REGISTRY, translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).CYBUS_REGISTRY_STATUS, {
            installable: endpoints.cybusRegistry.reachable
        })),
        toLine('dockerHub', (0, $40a99dac858c1d75$export$b63289fbda65eed1).DOCKER_HUB, translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).DOCKER_HUB_STATUS, {
            installable: endpoints.dockerHub.reachable
        }))
    ];
};
const $b02280fe32ee04dc$var$ConnectivityTable = ({ endpoints: endpoints })=>{
    const lines = $b02280fe32ee04dc$var$useConnectivityLines(endpoints);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        data: lines,
        columns: {
            name: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME,
                sort: true
            },
            info: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).INFO
            },
            status: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS,
                customCellRender: (status)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
                        status: status
                    })
            }
        }
    });
};
const $b02280fe32ee04dc$export$646b27bc07df3b98 = ()=>{
    const infoUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('informationUsecase');
    (0, $h4Bez.useEffect)(()=>infoUsecase.loadInformation(), []);
    const info = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $d5b2f7653d87e9de$export$236b6ad6452b27f9));
    if (info === null) return null;
    if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(info.connectivity)) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b02280fe32ee04dc$var$Wrapper, {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
            error: info.connectivity,
            extras: "popover"
        })
    });
    if (info.connectivity === null) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b02280fe32ee04dc$var$Wrapper, {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $35e2f7ba0c5bb8e5$export$8b8493c40023057), {})
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b02280fe32ee04dc$var$Wrapper, {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b02280fe32ee04dc$var$ConnectivityTable, {
            endpoints: info.connectivity.endpoints
        })
    });
};






var $h4Bez = parcelRequire("h4Bez");








const $ede68930367fa45e$var$wrapperStyle = {
    py: 4
};
const $ede68930367fa45e$var$titleStyle = {
    width: 250
};
const $ede68930367fa45e$var$linkStyle = {
    fontWeight: 500,
    textTransform: 'uppercase'
};
const $ede68930367fa45e$var$ServiceCountText = ({ count: count })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            count,
            " ",
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE,
                values: {
                    count: count
                }
            })
        ]
    });
const $ede68930367fa45e$export$1baf5169e987a757 = ()=>{
    const infoUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('informationUsecase');
    (0, $h4Bez.useEffect)(()=>infoUsecase.loadInformation(), []);
    const info = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $d5b2f7653d87e9de$export$236b6ad6452b27f9));
    if (info === null || info.servicesCount === null || !info.connectivity) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $35e2f7ba0c5bb8e5$export$8b8493c40023057), {});
    const { servicesCount: servicesCount, connectivity: connectivity, version: version } = info;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "info-details",
        sx: $ede68930367fa45e$var$wrapperStyle,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
            hideHeader: true,
            columns: {
                title: {
                    customCellRender: (title)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(title) ? title[0] : title,
                            values: (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(title) ? title[1] : undefined
                        }),
                    sx: $ede68930367fa45e$var$titleStyle
                },
                data: {
                    customCellRender: (value)=>(0, $c3e1b746ad236797$export$8d524fb6540252df).is(value) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
                            error: value,
                            extras: "popover"
                        }) : value
                }
            },
            data: [
                {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTWARE_VERSION,
                    data: (0, $c3e1b746ad236797$export$8d524fb6540252df).is(connectivity) ? connectivity : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTWARE_VERSION_INFORMATION,
                                values: {
                                    latest: version === connectivity.latest?.version ? true : connectivity.latest?.version ?? null,
                                    version: version
                                }
                            }),
                            Boolean(connectivity.latest?.version && version !== connectivity.latest.version) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
                                children: [
                                    ' ',
                                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTWARE_NEW_SELF_HOSTED_APPLIANCE_VERSION,
                                        values: {
                                            latestVersion: connectivity.latest?.version,
                                            InstallerLink: (...content)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a497eee141ca75b8$export$2e2bcd8739ae039), {
                                                    "data-testid": "installer-link",
                                                    href: connectivity.latest?.installerURL.toString(),
                                                    children: content
                                                }),
                                            ReleaseNotesLink: (...content)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a497eee141ca75b8$export$2e2bcd8739ae039), {
                                                    "data-testid": "release-notes-link",
                                                    href: connectivity.latest?.releaseNotes.toString(),
                                                    children: content
                                                })
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                },
                {
                    title: [
                        (0, $40a99dac858c1d75$export$b63289fbda65eed1).INSTALLED_SERVICES,
                        {
                            count: 0
                        }
                    ],
                    data: (0, $c3e1b746ad236797$export$8d524fb6540252df).is(servicesCount) ? (0, $c3e1b746ad236797$export$8d524fb6540252df).isOfTypes(servicesCount, (0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        color: "text.disabled",
                        children: "No permission to see the number of installed services"
                    }) : servicesCount : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7d5f64758ce3b1db$export$bf4bb1ff1ff62959), {
                        path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_OVERVIEW,
                        sx: $ede68930367fa45e$var$linkStyle,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($ede68930367fa45e$var$ServiceCountText, {
                            count: servicesCount
                        })
                    })
                }
            ]
        })
    });
};







parcelRequire("h4Bez");






const $d2a9ee956a31e0fe$export$cf6e4cc0a2e2da6 = ()=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('loginFromTokenUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $55a2a796d4e0875c$export$2e2bcd8739ae039), {
        disableEscapeKeyDown: true,
        open: true,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dfd39f6bb0de9c2f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TOKEN_ERROR_DIALOG_TITLE
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2db76c9e9f88b3ff$export$2e2bcd8739ae039), {
                variant: "determinate",
                value: 0
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0aa27c46708d7ed8$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fb671afc24ce07a1$export$794e892580855985), {
                    error: true,
                    labelVariant: "body1",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TOKEN_ERROR_DIALOG_CONTENT
                    })
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $12b0eeebf4fed103$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                    variant: "primary",
                    onClick: ()=>usecase.logout((0, $3f24850e5c974db2$export$55e75bec2b906c5e).MANUAL_LOGOUT),
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BACK_TO_LOGIN
                    })
                })
            })
        ]
    });
};




var $h4Bez = parcelRequire("h4Bez");






const $277271507132bb0a$var$iconStyle = {
    my: 'auto',
    mr: 1
};
const $277271507132bb0a$var$bodyStyle = {
    py: 1
};
const $277271507132bb0a$var$countdownStyle = {
    color: 'warning.main'
};
const $277271507132bb0a$export$9e1f4f03a12699f5 = ()=>{
    const nearExpiration = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $1c05f13022cf1480$export$97c945ddcfd5e726));
    const isNearExpiration = nearExpiration !== null;
    const [open, setOpen] = (0, $h4Bez.useState)(isNearExpiration);
    /** If the expiration state has changed, then reset the modal */ (0, $h4Bez.useEffect)(()=>setOpen(isNearExpiration), [
        isNearExpiration
    ]);
    if (nearExpiration === null) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $55a2a796d4e0875c$export$2e2bcd8739ae039), {
        "data-testid": "token-expiring-modal",
        open: open,
        disableEscapeKeyDown: true,
        fullWidth: true,
        maxWidth: "sm",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dfd39f6bb0de9c2f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    display: "flex",
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b3344c5f781513f7$export$2e2bcd8739ae039), {
                            color: "warning",
                            fontSize: "medium",
                            sx: $277271507132bb0a$var$iconStyle
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                            variant: "subtitle1",
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TOKEN_EXPIRING_MODAL_TITLE
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0aa27c46708d7ed8$export$2e2bcd8739ae039), {
                dividers: true,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    variant: "body1",
                    sx: $277271507132bb0a$var$bodyStyle,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TOKEN_EXPIRING_MODAL_BODY,
                        values: {
                            countdown: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                                component: "span",
                                sx: $277271507132bb0a$var$countdownStyle,
                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9007db43a2391fe5$export$53819c0e58f98d49), {
                                    value: nearExpiration
                                })
                            }),
                            br: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("br", {})
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $12b0eeebf4fed103$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                    variant: "secondary",
                    onClick: ()=>setOpen(false),
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISMISS
                    })
                })
            })
        ]
    });
};




const $2d0aa3751ae45f4c$export$a9627919734faa48 = ({ children: children })=>{
    const authenticated = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $1c05f13022cf1480$export$c75d7b8f071929fe));
    const requiresMfa = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $37c2a8e29603f683$export$ff9e49793420e555));
    const sessionObsolescenceStatus = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $1c05f13022cf1480$export$708b617202a3b032));
    const hasSessionError = (0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>(0, $ce07554ccb7fdbc8$export$49118b1f444502b4).is((0, $1c05f13022cf1480$export$d7186caa83d1ebde)(s)));
    const isLicenseValid = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $ee9c60e7a5b417f7$export$67c1501951d364c0));
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('loadLicenseUsecase');
    (0, $h4Bez.useEffect)(()=>usecase.loadLicense(), [
        usecase,
        authenticated
    ]);
    if (hasSessionError) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d2a9ee956a31e0fe$export$cf6e4cc0a2e2da6), {});
    if (requiresMfa) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $02243fdf8043786e$export$13f63fa2a812df42), {});
    if (!authenticated) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a21d979fb8d57b20$export$e6dfd72ab29f8598), {});
    if (!isLicenseValid) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ddd083879c936398$export$2b77a92f1a5ad772), {});
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            sessionObsolescenceStatus !== null && !(0, $c3e1b746ad236797$export$8d524fb6540252df).is(sessionObsolescenceStatus) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $da646cf922b19f26$export$2f9366f48f137109), {
                sessionObsolescenceStatus: sessionObsolescenceStatus
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $277271507132bb0a$export$9e1f4f03a12699f5), {}),
            children
        ]
    });
};





parcelRequire("h4Bez");





const $701d06218cd04dd6$var$linkStyle = {
    ml: 1
};
const $701d06218cd04dd6$export$2ea013db82b51c49 = ({ error: error })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
        error: error,
        customTitle: (e)=>e.message,
        extrasTitleSuffix: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $57ff7f54e54013be$export$6eb1e07b1de459cd), {
            type: (0, $de76aa5bd91d062d$export$26609300e3bf37cf).UI_ACCESS_PERMISSIONS,
            sx: $701d06218cd04dd6$var$linkStyle,
            "data-testid": "ui-access-documentation",
            variant: "body2",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).UI_ACCESS_PERMISSIONS_DOCUMENTATION
            })
        }),
        extras: "section"
    });






var $h4Bez = parcelRequire("h4Bez");




var $h4Bez = parcelRequire("h4Bez");











const $b3c972accded84b0$export$9adb4b796e113215 = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).DEVIATIONS_READ);
/** Always `warning` - deviations have no other severity. The darker amber keeps the white number readable. */ const $b3c972accded84b0$var$countBadgeStyle = {
    alignItems: 'center',
    bgcolor: 'warning.700',
    borderRadius: '50%',
    color: 'common.white',
    display: 'flex',
    fontSize: 8,
    fontWeight: 500,
    height: 12,
    justifyContent: 'center',
    lineHeight: 1,
    position: 'absolute',
    right: -1,
    top: -1,
    width: 12
};
/**
 * The icon is the side bar's icon size, matching the side bar's open/close toggle below it - not a leftover default.
 * The hover is the side bar's `grey.200`, because the ghost button's own hover grey is the side bar's background.
 * Sized via this nested selector, not directly on the icon: `MuiIconButton`'s theme override forces
 * default-size icons to 16x16 via the same selector shape, and MUI always appends `sx` after theme
 * `styleOverrides` for a given component, so matching that shape here reliably wins.
 */ const $b3c972accded84b0$var$triggerStyle = {
    height: 32,
    position: 'relative',
    width: 32,
    [`& .${(0, $2642ca6f3a461e10$export$2e2bcd8739ae039).root}`]: {
        height: (0, $833922d52afcf466$export$e34d2553ba553d7c),
        width: (0, $833922d52afcf466$export$e34d2553ba553d7c)
    },
    '&:hover': {
        backgroundColor: 'grey.200'
    },
    '&:active': {
        backgroundColor: 'grey.300'
    }
};
/** Fixed card width, not a spacing-scale value. */ const $b3c972accded84b0$var$POPOVER_WIDTH = 300;
/**
 * No arrow - the gap of the `side` placement, between the trigger and the popover to its right, bottom-aligned with it:
 * 6px past the side bar's edge, as the trigger sits 8px inside it.
 */ const $b3c972accded84b0$var$POPOVER_GAP = 14;
const $b3c972accded84b0$var$popoverOrigins = {
    side: {
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
        },
        transformOrigin: {
            vertical: 'bottom',
            horizontal: -$b3c972accded84b0$var$POPOVER_GAP
        }
    },
    below: {
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'right'
        }
    }
};
const $b3c972accded84b0$var$popoverPaperStyle = {
    bgcolor: 'common.white',
    border: '1px solid',
    borderColor: 'grey.200',
    borderRadius: 2
};
const $b3c972accded84b0$var$popoverContentStyle = {
    width: $b3c972accded84b0$var$POPOVER_WIDTH
};
/** gap: 2.5 = 10px, a fractional spacing step - same idiom as `ToastZone.tsx`'s `ZONE_GAP`. */ const $b3c972accded84b0$var$headerStyle = {
    alignItems: 'center',
    display: 'flex',
    gap: 2.5,
    px: 3,
    py: 2
};
/** Soft badge style - distinct from the trigger's solid `countBadgeStyle` above. */ const $b3c972accded84b0$var$headerCountBadgeStyle = {
    alignItems: 'center',
    bgcolor: 'warning.50',
    borderRadius: '50%',
    color: 'warning.600',
    display: 'flex',
    flexShrink: 0,
    height: 36,
    justifyContent: 'center',
    width: 36
};
/** Distinct from `grey.300` below (row separators) - two different border shades, deliberately not one reused value. */ const $b3c972accded84b0$var$dividerStyle = {
    borderColor: 'grey.200'
};
/** Bottom border between rows only, not after the last - the "+N more"/footer sections have their own, independent border logic below. */ const $b3c972accded84b0$var$rowStyle = {
    color: 'grey.700',
    px: 3,
    py: 1,
    '&:not(:last-of-type)': {
        borderBottom: '1px solid',
        borderColor: 'grey.300'
    }
};
/** `grey.400` matches the rest of this popover's muted text - not a separate shade. */ const $b3c972accded84b0$var$moreRowStyle = {
    borderBottom: '1px solid',
    borderColor: 'grey.300',
    color: 'grey.400',
    px: 3,
    py: 1
};
const $b3c972accded84b0$var$footerStyle = {
    alignItems: 'center',
    borderTop: '1px solid',
    borderColor: 'grey.200',
    display: 'flex',
    px: 3,
    py: 2
};
const $b3c972accded84b0$var$footerLinkStyle = {
    color: 'primary.700'
};
const $b3c972accded84b0$var$RECENT_DEVIATIONS_LIMIT = 5;
const $b3c972accded84b0$var$DeviationRow = ({ id: id })=>{
    const PermissionedServiceLink = (0, $7d5f64758ce3b1db$export$8c81d7b771b7392a)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "deviation-popover-row",
        sx: $b3c972accded84b0$var$rowStyle,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(PermissionedServiceLink, {
            path: (0, $0e5d1fb0e9c69012$export$91969d5ee4870de).SERVICES_OVERVIEW_SERVICE,
            id: id,
            sx: {
                color: 'inherit'
            },
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "caption",
                color: "inherit",
                children: id
            })
        })
    });
};
const $b3c972accded84b0$var$DeviationsPopoverContent = ()=>{
    const page = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $d8a939fc8bdc4e6b$export$d2a9b20bfb5db65f));
    /** Only ever rendered by `DeviationsBadgeContent` once it has already confirmed `count > 0`, which requires a loaded, non-null page. */ (0, $14eddac5f20c576c$export$a7a9523472993e97)(page !== null, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Deviations popover rendered without a loaded page'));
    const count = page.totalCount;
    const recent = page.current.slice(0, $b3c972accded84b0$var$RECENT_DEVIATIONS_LIMIT);
    const moreCount = count - recent.length;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "deviation-popover",
        sx: $b3c972accded84b0$var$popoverContentStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $b3c972accded84b0$var$headerStyle,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        sx: $b3c972accded84b0$var$headerCountBadgeStyle,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                            variant: "body2",
                            color: "inherit",
                            children: count
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        variant: "body2",
                        sx: {
                            color: 'grey.900'
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVIATION_DETECTED,
                            values: {
                                count: count
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {
                sx: $b3c972accded84b0$var$dividerStyle
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                children: recent.map(({ id: id })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b3c972accded84b0$var$DeviationRow, {
                        id: id
                    }, id))
            }),
            moreCount > 0 && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                "data-testid": "deviation-popover-more",
                sx: $b3c972accded84b0$var$moreRowStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    variant: "caption",
                    color: "inherit",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVIATION_POPOVER_MORE,
                        values: {
                            count: moreCount
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $b3c972accded84b0$var$footerStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7d5f64758ce3b1db$export$bf4bb1ff1ff62959), {
                    "data-testid": "deviation-popover-view-all",
                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).DEVIATED_SERVICES,
                    sx: $b3c972accded84b0$var$footerLinkStyle,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        variant: "caption",
                        color: "inherit",
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVIATION_VIEW_ALL
                        })
                    })
                })
            })
        ]
    });
};
const $b3c972accded84b0$var$DeviationsBadgeContent = ({ popoverPlacement: popoverPlacement })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const setAnchor = (0, $5c50dcf7e155ce8c$export$b13dce3af0135d87)();
    const close = (0, $5c50dcf7e155ce8c$export$89554eb4b4787636)();
    const currentPath = (0, $42efdbd12003f6a9$export$ddab236f5c469f6f)().getCurrentPath();
    /**
     * The badge lives in the frame and stays mounted across page changes, so the popover is closed whenever the page
     * changes - by one of its own links, or any other way - instead of staying open over the new page. The full path,
     * ids included, so moving from one service's page to another's (what the popover's rows do) closes it too.
     */ (0, $h4Bez.useEffect)(()=>close(), [
        currentPath
    ]);
    const page = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $d8a939fc8bdc4e6b$export$d2a9b20bfb5db65f));
    const count = page?.totalCount ?? 0;
    if (count === 0) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $0128221b0851485d$export$c25acd513dcc8062), {
                "data-testid": "deviation-badge",
                "aria-label": translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).DEVIATION_TOAST_COUNTER, {
                    count: count
                }),
                variant: "ghost",
                sx: $b3c972accded84b0$var$triggerStyle,
                onClick: (e)=>setAnchor(e.currentTarget),
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4d0c3371e4bf5696$export$794f4e1bebe11db5), {}),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        "data-testid": "deviation-badge-count",
                        sx: $b3c972accded84b0$var$countBadgeStyle,
                        children: count
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $40650a35df6eb212$export$2e2bcd8739ae039), {
                onClose: close,
                ...$b3c972accded84b0$var$popoverOrigins[popoverPlacement],
                elevation: 3,
                slotProps: {
                    paper: {
                        sx: $b3c972accded84b0$var$popoverPaperStyle
                    }
                },
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b3c972accded84b0$var$DeviationsPopoverContent, {})
            })
        ]
    });
};
const $b3c972accded84b0$export$32b83f3e4d46bc89 = ({ popoverPlacement: popoverPlacement = 'side' })=>{
    const canReadDeviations = (0, $be523f14267dcd17$export$9973955de2bf96cf)($b3c972accded84b0$export$9adb4b796e113215);
    if (!canReadDeviations) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5c50dcf7e155ce8c$export$1d7e255c6105d39b), {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b3c972accded84b0$var$DeviationsBadgeContent, {
            popoverPlacement: popoverPlacement
        })
    });
};



/**
 * Keeps the two existing subscriptions alive and feeds `DeviationToastsUsecase` from them - no
 * visible output of its own; `DeviationToastZone` (rendered by the parent) is what actually shows
 * anything, off the app state this usecase maintains.
 */ const $40adcaf4784cb817$var$DeviationsDetector = ()=>{
    const page = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $d8a939fc8bdc4e6b$export$d2a9b20bfb5db65f));
    const resolution = (0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>s.serviceDeviationResolution);
    const manageServicesDeviationsUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('manageServicesDeviationsUsecase');
    const manageResolvedDeviationsUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('manageResolvedDeviationsUsecase');
    const deviationToastsUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('deviationToastsUsecase');
    (0, $h4Bez.useEffect)(()=>manageServicesDeviationsUsecase.subscribe({
            short: true
        }), [
        manageServicesDeviationsUsecase
    ]);
    (0, $h4Bez.useEffect)(()=>manageResolvedDeviationsUsecase.subscribe(), [
        manageResolvedDeviationsUsecase
    ]);
    (0, $h4Bez.useEffect)(()=>{
        if (page) deviationToastsUsecase.syncDeviations(page.current, page.totalCount);
    }, [
        page,
        deviationToastsUsecase
    ]);
    /**
     * Skips (rather than falling back to 0) when `page` hasn't loaded yet - a resolution event can
     * arrive before the deviations-page subscription's first snapshot on an ordinary mount, and 0
     * would incorrectly read as "no deviations left" and clear the counter toast. Deliberately not
     * keyed on `page` in the dependency array - only a new resolution should trigger this at all;
     * `page` is only read as a guard against the value it happens to be at that moment.
     */ (0, $h4Bez.useEffect)(()=>{
        if (resolution && page) deviationToastsUsecase.notifyResolved(resolution, page.totalCount);
    }, [
        resolution,
        deviationToastsUsecase
    ]);
    return null;
};
const $40adcaf4784cb817$export$36ba2f559d49a8f6 = ()=>{
    const canReadDeviations = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $b3c972accded84b0$export$9adb4b796e113215));
    return canReadDeviations ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($40adcaf4784cb817$var$DeviationsDetector, {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bf73078eff32ce9f$export$37da67946f71df52), {})
        ]
    }) : null;
};









var $h4Bez = parcelRequire("h4Bez");








parcelRequire("h4Bez");



var $h4Bez = parcelRequire("h4Bez");



const $a883b2ca56cdda9a$var$wrapperStyle = {
    display: 'flex',
    my: 2,
    mx: 0
};
const $a883b2ca56cdda9a$var$sectionTitleStyle = {
    m: 'auto',
    ml: 0,
    lineHeight: 2
};
const $a883b2ca56cdda9a$var$arrowStyle = {
    cursor: 'pointer',
    my: 'auto',
    mr: 0,
    ml: 2
};
const $a883b2ca56cdda9a$var$SectionTitle = ({ title: title })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
        sx: $a883b2ca56cdda9a$var$sectionTitleStyle,
        className: "section-title",
        display: "inline",
        variant: "body1",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: title
        })
    });
const $a883b2ca56cdda9a$var$SectionTitleWrapper = ({ children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $a883b2ca56cdda9a$var$wrapperStyle,
        className: "section-title-wrapper",
        children: children
    });
const $a883b2ca56cdda9a$var$ExpandArrow = ({ open: open, onClick: onClick })=>{
    const Icon = open ? (0, $0c1414221f308967$export$2e2bcd8739ae039) : (0, $f0c56636e9fb6837$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Icon, {
        sx: $a883b2ca56cdda9a$var$arrowStyle,
        className: "expansion-arrow",
        onClick: onClick
    });
};
const $a883b2ca56cdda9a$export$6e2c8f0811a474ce = ({ title: title, controls: controls, collapsable: collapsable = true, children: children, ...props })=>{
    const [open, setOpen] = (0, $h4Bez.useState)(true);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("div", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($a883b2ca56cdda9a$var$SectionTitleWrapper, {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($a883b2ca56cdda9a$var$SectionTitle, {
                        title: title
                    }),
                    controls,
                    collapsable && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($a883b2ca56cdda9a$var$ExpandArrow, {
                        open: open,
                        onClick: ()=>setOpen(!open)
                    })
                ]
            }),
            collapsable ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7830414f6fe32da6$export$2e2bcd8739ae039), {
                in: open,
                timeout: "auto",
                unmountOnExit: true,
                children: children
            }) : children
        ]
    });
};




var $h4Bez = parcelRequire("h4Bez");








parcelRequire("h4Bez");




const $f0a42268059aa5d9$var$buttonStyle = {
    ml: 0.5,
    borderRadius: 2,
    borderColor: 'black',
    color: 'black',
    '&:hover': {
        borderColor: 'black',
        backgroundColor: 'unset'
    }
};
const $f0a42268059aa5d9$var$popoverStyle = {
    p: 1
};
const $f0a42268059aa5d9$var$InnerPopoverButton = ({ startIcon: startIcon, text: text, popover: popover, ...props })=>{
    const setOrigin = (0, $5c50dcf7e155ce8c$export$b13dce3af0135d87)();
    const close = (0, $5c50dcf7e155ce8c$export$89554eb4b4787636)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                startIcon: startIcon,
                "data-testid": (0, $3dd52092ec4fc8cb$export$eea0c9f46a8cc3f9)(props, 'Button'),
                variant: "secondary",
                sx: $f0a42268059aa5d9$var$buttonStyle,
                onClick: (e)=>setOrigin(e.currentTarget),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: text
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $40650a35df6eb212$export$2e2bcd8739ae039), {
                "data-testid": (0, $3dd52092ec4fc8cb$export$eea0c9f46a8cc3f9)(props, 'Popover'),
                onClose: close,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
                    sx: $f0a42268059aa5d9$var$popoverStyle,
                    children: popover
                })
            })
        ]
    });
};
const $f0a42268059aa5d9$export$c71dc08a6f474856 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5c50dcf7e155ce8c$export$1d7e255c6105d39b), {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($f0a42268059aa5d9$var$InnerPopoverButton, {
            ...props
        })
    });


const $0bb6513b74ecca8c$var$wrapperStlye = {
    display: 'flex'
};
const $0bb6513b74ecca8c$var$buttonStyle = {
    ml: 1
};
const $0bb6513b74ecca8c$var$AddTopicPopover = ()=>{
    const close = (0, $5c50dcf7e155ce8c$export$89554eb4b4787636)();
    const manage = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('explorerTopicManagementUsecase');
    const [[newTopic, error], setState] = (0, $h4Bez.useState)([
        '',
        null
    ]);
    const doesTopicExist = (0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>(0, $070c3c2fc0eda22c$export$75eb6fe331ae8a1a)(s, newTopic), [
        newTopic
    ]);
    const create = (0, $h4Bez.useCallback)(()=>{
        try {
            manage.addCustomTopic(newTopic);
            close();
        } catch (e) {
            setState(([topic])=>[
                    topic,
                    e
                ]);
        }
    }, [
        manage,
        newTopic
    ]);
    const dynamicProps = error ? {
        variant: 'danger',
        startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b3344c5f781513f7$export$2e2bcd8739ae039), {
            fontSize: "small"
        }),
        title: error.message
    } : {};
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $0bb6513b74ecca8c$var$wrapperStlye,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d887fad28e7ec96c$export$2c73285ae9390cec), {
                autoFocus: true,
                value: newTopic,
                onChange: ({ currentTarget: { value: value } })=>setState([
                        value,
                        null
                    ]),
                onKeyUp: !doesTopicExist ? (0, $1fdb53e1bec07519$export$d9ea00e8a3cf8cca)(create) : undefined
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                sx: $0bb6513b74ecca8c$var$buttonStyle,
                size: "small",
                variant: "primary",
                disabled: doesTopicExist,
                ...dynamicProps,
                onClick: create,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ADD_CUSTOM_TOPIC
                })
            })
        ]
    });
};
const $0bb6513b74ecca8c$export$d70ad15dfe54df4d = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f0a42268059aa5d9$export$c71dc08a6f474856), {
        "data-testid": "addTopic",
        startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2510eecdad012f77$export$2e2bcd8739ae039), {}),
        text: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ADD_CUSTOM_TOPIC,
        popover: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($0bb6513b74ecca8c$var$AddTopicPopover, {})
    });




var $h4Bez = parcelRequire("h4Bez");



var $h4Bez = parcelRequire("h4Bez");





function $c706d228957b23f0$export$ff8356348e0cc878(name) {
    return 0, $9058b9cdfb80ec1e$export$2e2bcd8739ae039;
}




function $a5bb530ccd239bbb$export$554faf16d1e10669(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiSimpleTreeView', slot);
}
const $a5bb530ccd239bbb$export$2351bf164300b361 = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiSimpleTreeView', [
    'root'
]);




var $h4Bez = parcelRequire("h4Bez");



var $h4Bez = parcelRequire("h4Bez");
const $bdaacd62da0606e1$export$d8d5655036da9a9f = (plugins, props)=>{
    const modelsRef = $h4Bez.useRef({});
    const [modelsState, setModelsState] = $h4Bez.useState(()=>{
        const initialState = {};
        plugins.forEach((plugin)=>{
            if (plugin.models) Object.entries(plugin.models).forEach(([modelName, modelInitializer])=>{
                modelsRef.current[modelName] = {
                    isControlled: props[modelName] !== undefined,
                    getDefaultValue: modelInitializer.getDefaultValue
                };
                initialState[modelName] = modelInitializer.getDefaultValue(props);
            });
        });
        return initialState;
    });
    const models = Object.fromEntries(Object.entries(modelsRef.current).map(([modelName, model])=>{
        const value = props[modelName] ?? modelsState[modelName];
        return [
            modelName,
            {
                value: value,
                setControlledValue: (newValue)=>{
                    if (!model.isControlled) setModelsState((prevState)=>(0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState, {
                            [modelName]: newValue
                        }));
                }
            }
        ];
    }));
    var modelName, model;
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ return models;
};



var $h4Bez = parcelRequire("h4Bez");
// Used https://gist.github.com/mudge/5830382 as a starting point.
// See https://github.com/browserify/events/blob/master/events.js for
// the Node.js (https://nodejs.org/api/events.html) polyfill used by webpack.
class $44b05d230829e1fc$export$cc74486daaaef499 {
    constructor(){
        this.maxListeners = 20;
        this.warnOnce = false;
        this.events = {};
    }
    on(eventName, listener, options = {}) {
        let collection = this.events[eventName];
        if (!collection) {
            collection = {
                highPriority: new Map(),
                regular: new Map()
            };
            this.events[eventName] = collection;
        }
        if (options.isFirst) collection.highPriority.set(listener, true);
        else collection.regular.set(listener, true);
    }
    removeListener(eventName, listener) {
        if (this.events[eventName]) {
            this.events[eventName].regular.delete(listener);
            this.events[eventName].highPriority.delete(listener);
        }
    }
    removeAllListeners() {
        this.events = {};
    }
    emit(eventName, ...args) {
        const collection = this.events[eventName];
        if (!collection) return;
        const highPriorityListeners = Array.from(collection.highPriority.keys());
        const regularListeners = Array.from(collection.regular.keys());
        for(let i = highPriorityListeners.length - 1; i >= 0; i -= 1){
            const listener = highPriorityListeners[i];
            if (collection.highPriority.has(listener)) listener.apply(this, args);
        }
        for(let i = 0; i < regularListeners.length; i += 1){
            const listener = regularListeners[i];
            if (collection.regular.has(listener)) listener.apply(this, args);
        }
    }
    once(eventName, listener) {
        // eslint-disable-next-line consistent-this
        const that = this;
        this.on(eventName, function oneTimeListener(...args) {
            that.removeListener(eventName, oneTimeListener);
            listener.apply(that, args);
        });
    }
}


const $7ccf2c8cb2e86c1a$var$isSyntheticEvent = (event)=>{
    return event.isPropagationStopped !== undefined;
};
const $7ccf2c8cb2e86c1a$export$93654c0b7fe1355a = ()=>{
    const [eventManager] = $h4Bez.useState(()=>new (0, $44b05d230829e1fc$export$cc74486daaaef499)());
    const publishEvent = $h4Bez.useCallback((...args)=>{
        const [name, params, event = {}] = args;
        event.defaultMuiPrevented = false;
        if ($7ccf2c8cb2e86c1a$var$isSyntheticEvent(event) && event.isPropagationStopped()) return;
        eventManager.emit(name, params, event);
    }, [
        eventManager
    ]);
    const subscribeEvent = $h4Bez.useCallback((event, handler)=>{
        eventManager.on(event, handler);
        return ()=>{
            eventManager.removeListener(event, handler);
        };
    }, [
        eventManager
    ]);
    return {
        instance: {
            $$publishEvent: publishEvent,
            $$subscribeEvent: subscribeEvent
        }
    };
};
$7ccf2c8cb2e86c1a$export$93654c0b7fe1355a.params = {};


const $a965c947fe3f5b7f$export$311bc548be6209ae = ({ plugins: plugins })=>{
    const pluginSet = new Set(plugins);
    const getAvailablePlugins = ()=>pluginSet;
    return {
        instance: {
            getAvailablePlugins: getAvailablePlugins
        }
    };
};
$a965c947fe3f5b7f$export$311bc548be6209ae.params = {};




var $h4Bez = parcelRequire("h4Bez");
let $aaffed941a94ef7c$var$globalTreeViewDefaultId = 0;
const $aaffed941a94ef7c$export$3a9d81458df729ff = ()=>{
    $aaffed941a94ef7c$var$globalTreeViewDefaultId += 1;
    return `mui-tree-view-${$aaffed941a94ef7c$var$globalTreeViewDefaultId}`;
};
const $aaffed941a94ef7c$export$6ce5f925ac04fad = ({ id: id, treeId: treeId = '', itemId: itemId })=>{
    if (id != null) return id;
    return `${treeId}-${itemId}`;
};


const $a2a9e30a3d8566ea$export$d0fc4c8c9a2461c8 = ({ params: params, state: state, setState: setState })=>{
    $h4Bez.useEffect(()=>{
        setState((prevState)=>{
            if (prevState.id.treeId === params.id && prevState.id.treeId !== undefined) return prevState;
            return (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState, {
                id: (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState.id, {
                    treeId: params.id ?? (0, $aaffed941a94ef7c$export$3a9d81458df729ff)()
                })
            });
        });
    }, [
        setState,
        params.id
    ]);
    const treeId = params.id ?? state.id.treeId;
    return {
        getRootProps: ()=>({
                id: treeId
            }),
        contextValue: {
            treeId: treeId
        }
    };
};
$a2a9e30a3d8566ea$export$d0fc4c8c9a2461c8.params = {
    id: true
};
$a2a9e30a3d8566ea$export$d0fc4c8c9a2461c8.getInitialState = ({ id: id })=>({
        id: {
            treeId: id ?? undefined
        }
    });


const $d5ce8dad63e75d33$export$bc5724d26f7fe1f8 = [
    (0, $7ccf2c8cb2e86c1a$export$93654c0b7fe1355a),
    (0, $a965c947fe3f5b7f$export$311bc548be6209ae),
    (0, $a2a9e30a3d8566ea$export$d0fc4c8c9a2461c8)
];



const $ad81c0752f8c72db$var$_excluded = [
    "slots",
    "slotProps",
    "apiRef",
    "experimentalFeatures"
];
const $ad81c0752f8c72db$export$542760ab6ddf59de = (_ref)=>{
    let { props: { slots: slots, slotProps: slotProps, apiRef: apiRef, experimentalFeatures: inExperimentalFeatures }, plugins: plugins } = _ref, props = (0, $4b23e67a53a2b954$export$2e2bcd8739ae039)(_ref.props, $ad81c0752f8c72db$var$_excluded);
    const paramsLookup = {};
    plugins.forEach((plugin)=>{
        Object.assign(paramsLookup, plugin.params);
    });
    const pluginParams = {};
    const forwardedProps = {};
    Object.keys(props).forEach((propName)=>{
        const prop = props[propName];
        if (paramsLookup[propName]) pluginParams[propName] = prop;
        else forwardedProps[propName] = prop;
    });
    const experimentalFeatures = inExperimentalFeatures ?? {};
    const defaultizedPluginParams = plugins.reduce((acc, plugin)=>{
        if (plugin.getDefaultizedParams) return plugin.getDefaultizedParams({
            params: acc,
            experimentalFeatures: experimentalFeatures
        });
        return acc;
    }, pluginParams);
    return {
        apiRef: apiRef,
        forwardedProps: forwardedProps,
        pluginParams: defaultizedPluginParams,
        slots: slots ?? {},
        slotProps: slotProps ?? {},
        experimentalFeatures: experimentalFeatures
    };
};


const $371d05d8d6c80dd7$export$ec3538484bf07ef4 = ({ plugins: plugins, instance: instance, publicAPI: publicAPI, rootRef: rootRef })=>{
    const runItemPlugins = (itemPluginProps)=>{
        let finalRootRef = null;
        let finalContentRef = null;
        const pluginPropEnhancers = [];
        const pluginPropEnhancersNames = {};
        plugins.forEach((plugin)=>{
            if (!plugin.itemPlugin) return;
            const itemPluginResponse = plugin.itemPlugin({
                props: itemPluginProps,
                rootRef: finalRootRef,
                contentRef: finalContentRef
            });
            if (itemPluginResponse?.rootRef) finalRootRef = itemPluginResponse.rootRef;
            if (itemPluginResponse?.contentRef) finalContentRef = itemPluginResponse.contentRef;
            if (itemPluginResponse?.propsEnhancers) {
                pluginPropEnhancers.push(itemPluginResponse.propsEnhancers);
                // Prepare a list of all the slots which are enhanced by at least one plugin
                Object.keys(itemPluginResponse.propsEnhancers).forEach((propsEnhancerName)=>{
                    pluginPropEnhancersNames[propsEnhancerName] = true;
                });
            }
        });
        const resolvePropsEnhancer = (currentSlotName)=>(currentSlotParams)=>{
                const enhancedProps = {};
                pluginPropEnhancers.forEach((propsEnhancersForCurrentPlugin)=>{
                    const propsEnhancerForCurrentPluginAndSlot = propsEnhancersForCurrentPlugin[currentSlotName];
                    if (propsEnhancerForCurrentPluginAndSlot != null) Object.assign(enhancedProps, propsEnhancerForCurrentPluginAndSlot(currentSlotParams));
                });
                return enhancedProps;
            };
        const propsEnhancers = Object.fromEntries(Object.keys(pluginPropEnhancersNames).map((propEnhancerName)=>[
                propEnhancerName,
                resolvePropsEnhancer(propEnhancerName)
            ]));
        return {
            contentRef: finalContentRef,
            rootRef: finalRootRef,
            propsEnhancers: propsEnhancers
        };
    };
    const wrapItem = ({ itemId: itemId, children: children })=>{
        let finalChildren = children;
        // The wrappers are reversed to ensure that the first wrapper is the outermost one.
        for(let i = plugins.length - 1; i >= 0; i -= 1){
            const plugin = plugins[i];
            if (plugin.wrapItem) finalChildren = plugin.wrapItem({
                itemId: itemId,
                children: finalChildren,
                instance: instance
            });
        }
        return finalChildren;
    };
    const wrapRoot = ({ children: children })=>{
        let finalChildren = children;
        // The wrappers are reversed to ensure that the first wrapper is the outermost one.
        for(let i = plugins.length - 1; i >= 0; i -= 1){
            const plugin = plugins[i];
            if (plugin.wrapRoot) finalChildren = plugin.wrapRoot({
                children: finalChildren,
                instance: instance
            });
        }
        return finalChildren;
    };
    return {
        runItemPlugins: runItemPlugins,
        wrapItem: wrapItem,
        wrapRoot: wrapRoot,
        instance: instance,
        rootRef: rootRef,
        publicAPI: publicAPI
    };
};


function $195b827f5c7da639$export$41b75bc3bfcd170b(inputApiRef) {
    const fallbackPublicApiRef = $h4Bez.useRef({});
    if (inputApiRef) {
        if (inputApiRef.current == null) inputApiRef.current = {};
        return inputApiRef.current;
    }
    return fallbackPublicApiRef.current;
}
const $195b827f5c7da639$export$1e79c2a653523352 = ({ plugins: inPlugins, rootRef: rootRef, props: props })=>{
    const plugins = [
        ...(0, $d5ce8dad63e75d33$export$bc5724d26f7fe1f8),
        ...inPlugins
    ];
    const { pluginParams: pluginParams, forwardedProps: forwardedProps, apiRef: apiRef, experimentalFeatures: experimentalFeatures, slots: slots, slotProps: slotProps } = (0, $ad81c0752f8c72db$export$542760ab6ddf59de)({
        plugins: plugins,
        props: props
    });
    const models = (0, $bdaacd62da0606e1$export$d8d5655036da9a9f)(plugins, pluginParams);
    const instanceRef = $h4Bez.useRef({});
    const instance = instanceRef.current;
    const publicAPI = $195b827f5c7da639$export$41b75bc3bfcd170b(apiRef);
    const innerRootRef = $h4Bez.useRef(null);
    const handleRootRef = (0, $4fa58c431bc87919$export$2e2bcd8739ae039)(innerRootRef, rootRef);
    const contextValue = (0, $371d05d8d6c80dd7$export$ec3538484bf07ef4)({
        plugins: plugins,
        instance: instance,
        publicAPI: publicAPI,
        rootRef: innerRootRef
    });
    const [state, setState] = $h4Bez.useState(()=>{
        const temp = {};
        plugins.forEach((plugin)=>{
            if (plugin.getInitialState) Object.assign(temp, plugin.getInitialState(pluginParams));
        });
        return temp;
    });
    const rootPropsGetters = [];
    const runPlugin = (plugin)=>{
        const pluginResponse = plugin({
            instance: instance,
            params: pluginParams,
            slots: slots,
            slotProps: slotProps,
            experimentalFeatures: experimentalFeatures,
            state: state,
            setState: setState,
            rootRef: innerRootRef,
            models: models,
            plugins: plugins
        });
        if (pluginResponse.getRootProps) rootPropsGetters.push(pluginResponse.getRootProps);
        if (pluginResponse.publicAPI) Object.assign(publicAPI, pluginResponse.publicAPI);
        if (pluginResponse.instance) Object.assign(instance, pluginResponse.instance);
        if (pluginResponse.contextValue) Object.assign(contextValue, pluginResponse.contextValue);
    };
    plugins.forEach(runPlugin);
    const getRootProps = (otherHandlers = {})=>{
        const rootProps = (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({
            role: 'tree'
        }, forwardedProps, otherHandlers, {
            ref: handleRootRef
        });
        rootPropsGetters.forEach((rootPropsGetter)=>{
            Object.assign(rootProps, rootPropsGetter(otherHandlers));
        });
        return rootProps;
    };
    return {
        getRootProps: getRootProps,
        rootRef: handleRootRef,
        contextValue: contextValue,
        instance: instance
    };
};


parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");
const $1ddd7f1f0448a2fb$export$5e4715462ac10946 = /*#__PURE__*/ $h4Bez.createContext(null);



function $352675bf6916099d$export$6a399b2f7f12632c(props) {
    const { value: value, children: children } = props;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1ddd7f1f0448a2fb$export$5e4715462ac10946).Provider, {
        value: value,
        children: value.wrapRoot({
            children: children,
            instance: value.instance
        })
    });
}





var $h4Bez = parcelRequire("h4Bez");
const $f1ba621fdcdf5d7f$export$d5c088e621d1d7a3 = (instance, eventName, params)=>{
    instance.$$publishEvent(eventName, params);
};


const $7a7e1d2e3fb0cf09$export$e7a9649b6cfa9944 = '__TREE_VIEW_ROOT_PARENT_ID__';
const $7a7e1d2e3fb0cf09$export$1d3868a1fe066660 = (siblings)=>{
    const siblingsIndexLookup = {};
    siblings.forEach((childId, index)=>{
        siblingsIndexLookup[childId] = index;
    });
    return siblingsIndexLookup;
};



var $h4Bez = parcelRequire("h4Bez");
const $593075cc412db2a8$export$8634277a87653494 = /*#__PURE__*/ $h4Bez.createContext(()=>-1);




const $afa7da3a2b267352$var$_excluded = [
    "children"
];
const $afa7da3a2b267352$var$updateItemsState = ({ items: items, isItemDisabled: isItemDisabled, getItemLabel: getItemLabel, getItemId: getItemId })=>{
    const itemMetaMap = {};
    const itemMap = {};
    const itemOrderedChildrenIds = {
        [(0, $7a7e1d2e3fb0cf09$export$e7a9649b6cfa9944)]: []
    };
    const processItem = (item, depth, parentId)=>{
        const id = getItemId ? getItemId(item) : item.id;
        if (id == null) throw new Error([
            'MUI X: The Tree View component requires all items to have a unique `id` property.',
            'Alternatively, you can use the `getItemId` prop to specify a custom id for each item.',
            'An item was provided without id in the `items` prop:',
            JSON.stringify(item)
        ].join('\n'));
        if (itemMetaMap[id] != null) throw new Error([
            'MUI X: The Tree View component requires all items to have a unique `id` property.',
            'Alternatively, you can use the `getItemId` prop to specify a custom id for each item.',
            `Two items were provided with the same id in the \`items\` prop: "${id}"`
        ].join('\n'));
        const label = getItemLabel ? getItemLabel(item) : item.label;
        if (label == null) throw new Error([
            'MUI X: The Tree View component requires all items to have a `label` property.',
            'Alternatively, you can use the `getItemLabel` prop to specify a custom label for each item.',
            'An item was provided without label in the `items` prop:',
            JSON.stringify(item)
        ].join('\n'));
        itemMetaMap[id] = {
            id: id,
            label: label,
            parentId: parentId,
            idAttribute: undefined,
            expandable: !!item.children?.length,
            disabled: isItemDisabled ? isItemDisabled(item) : false,
            depth: depth
        };
        itemMap[id] = item;
        const parentIdWithDefault = parentId ?? (0, $7a7e1d2e3fb0cf09$export$e7a9649b6cfa9944);
        if (!itemOrderedChildrenIds[parentIdWithDefault]) itemOrderedChildrenIds[parentIdWithDefault] = [];
        itemOrderedChildrenIds[parentIdWithDefault].push(id);
        item.children?.forEach((child)=>processItem(child, depth + 1, id));
    };
    items.forEach((item)=>processItem(item, 0, null));
    const itemChildrenIndexes = {};
    Object.keys(itemOrderedChildrenIds).forEach((parentId)=>{
        itemChildrenIndexes[parentId] = (0, $7a7e1d2e3fb0cf09$export$1d3868a1fe066660)(itemOrderedChildrenIds[parentId]);
    });
    return {
        itemMetaMap: itemMetaMap,
        itemMap: itemMap,
        itemOrderedChildrenIds: itemOrderedChildrenIds,
        itemChildrenIndexes: itemChildrenIndexes
    };
};
const $afa7da3a2b267352$export$eb09d9f2bbd20fb = ({ instance: instance, params: params, state: state, setState: setState, experimentalFeatures: experimentalFeatures })=>{
    const getItemMeta = $h4Bez.useCallback((itemId)=>state.items.itemMetaMap[itemId], [
        state.items.itemMetaMap
    ]);
    const getItem = $h4Bez.useCallback((itemId)=>state.items.itemMap[itemId], [
        state.items.itemMap
    ]);
    const getItemTree = $h4Bez.useCallback(()=>{
        const getItemFromItemId = (id)=>{
            const _state$items$itemMap$ = state.items.itemMap[id], item = (0, $4b23e67a53a2b954$export$2e2bcd8739ae039)(_state$items$itemMap$, $afa7da3a2b267352$var$_excluded);
            const newChildren = state.items.itemOrderedChildrenIds[id];
            if (newChildren) item.children = newChildren.map(getItemFromItemId);
            return item;
        };
        return state.items.itemOrderedChildrenIds[0, $7a7e1d2e3fb0cf09$export$e7a9649b6cfa9944].map(getItemFromItemId);
    }, [
        state.items.itemMap,
        state.items.itemOrderedChildrenIds
    ]);
    const isItemDisabled = $h4Bez.useCallback((itemId)=>{
        if (itemId == null) return false;
        let itemMeta = instance.getItemMeta(itemId);
        // This can be called before the item has been added to the item map.
        if (!itemMeta) return false;
        if (itemMeta.disabled) return true;
        while(itemMeta.parentId != null){
            itemMeta = instance.getItemMeta(itemMeta.parentId);
            if (itemMeta.disabled) return true;
        }
        return false;
    }, [
        instance
    ]);
    const getItemIndex = $h4Bez.useCallback((itemId)=>{
        const parentId = instance.getItemMeta(itemId).parentId ?? (0, $7a7e1d2e3fb0cf09$export$e7a9649b6cfa9944);
        return state.items.itemChildrenIndexes[parentId][itemId];
    }, [
        instance,
        state.items.itemChildrenIndexes
    ]);
    const getItemOrderedChildrenIds = $h4Bez.useCallback((itemId)=>state.items.itemOrderedChildrenIds[itemId ?? (0, $7a7e1d2e3fb0cf09$export$e7a9649b6cfa9944)] ?? [], [
        state.items.itemOrderedChildrenIds
    ]);
    const getItemDOMElement = (itemId)=>{
        const itemMeta = instance.getItemMeta(itemId);
        if (itemMeta == null) return null;
        return document.getElementById((0, $aaffed941a94ef7c$export$6ce5f925ac04fad)({
            treeId: state.id.treeId,
            itemId: itemId,
            id: itemMeta.idAttribute
        }));
    };
    const isItemNavigable = (itemId)=>{
        if (params.disabledItemsFocusable) return true;
        return !instance.isItemDisabled(itemId);
    };
    const areItemUpdatesPreventedRef = $h4Bez.useRef(false);
    const preventItemUpdates = $h4Bez.useCallback(()=>{
        areItemUpdatesPreventedRef.current = true;
    }, []);
    const areItemUpdatesPrevented = $h4Bez.useCallback(()=>areItemUpdatesPreventedRef.current, []);
    $h4Bez.useEffect(()=>{
        if (instance.areItemUpdatesPrevented()) return;
        setState((prevState)=>{
            const newState = $afa7da3a2b267352$var$updateItemsState({
                items: params.items,
                isItemDisabled: params.isItemDisabled,
                getItemId: params.getItemId,
                getItemLabel: params.getItemLabel
            });
            Object.values(prevState.items.itemMetaMap).forEach((item)=>{
                if (!newState.itemMetaMap[item.id]) (0, $f1ba621fdcdf5d7f$export$d5c088e621d1d7a3)(instance, 'removeItem', {
                    id: item.id
                });
            });
            return (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState, {
                items: newState
            });
        });
    }, [
        instance,
        setState,
        params.items,
        params.isItemDisabled,
        params.getItemId,
        params.getItemLabel
    ]);
    const getItemsToRender = ()=>{
        const getPropsFromItemId = (id)=>{
            const item = state.items.itemMetaMap[id];
            return {
                label: item.label,
                itemId: item.id,
                id: item.idAttribute,
                children: state.items.itemOrderedChildrenIds[id]?.map(getPropsFromItemId)
            };
        };
        return state.items.itemOrderedChildrenIds[0, $7a7e1d2e3fb0cf09$export$e7a9649b6cfa9944].map(getPropsFromItemId);
    };
    return {
        getRootProps: ()=>({
                style: {
                    '--TreeView-itemChildrenIndentation': typeof params.itemChildrenIndentation === 'number' ? `${params.itemChildrenIndentation}px` : params.itemChildrenIndentation
                }
            }),
        publicAPI: {
            getItem: getItem,
            getItemDOMElement: getItemDOMElement,
            getItemTree: getItemTree,
            getItemOrderedChildrenIds: getItemOrderedChildrenIds
        },
        instance: {
            getItemMeta: getItemMeta,
            getItem: getItem,
            getItemTree: getItemTree,
            getItemsToRender: getItemsToRender,
            getItemIndex: getItemIndex,
            getItemDOMElement: getItemDOMElement,
            getItemOrderedChildrenIds: getItemOrderedChildrenIds,
            isItemDisabled: isItemDisabled,
            isItemNavigable: isItemNavigable,
            preventItemUpdates: preventItemUpdates,
            areItemUpdatesPrevented: areItemUpdatesPrevented
        },
        contextValue: {
            items: {
                onItemClick: params.onItemClick,
                disabledItemsFocusable: params.disabledItemsFocusable,
                indentationAtItemLevel: experimentalFeatures.indentationAtItemLevel ?? false
            }
        }
    };
};
$afa7da3a2b267352$export$eb09d9f2bbd20fb.getInitialState = (params)=>({
        items: $afa7da3a2b267352$var$updateItemsState({
            items: params.items,
            isItemDisabled: params.isItemDisabled,
            getItemId: params.getItemId,
            getItemLabel: params.getItemLabel
        })
    });
$afa7da3a2b267352$export$eb09d9f2bbd20fb.getDefaultizedParams = ({ params: params })=>(0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, params, {
        disabledItemsFocusable: params.disabledItemsFocusable ?? false,
        itemChildrenIndentation: params.itemChildrenIndentation ?? '12px'
    });
$afa7da3a2b267352$export$eb09d9f2bbd20fb.wrapRoot = ({ children: children, instance: instance })=>{
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $593075cc412db2a8$export$8634277a87653494).Provider, {
        value: (itemId)=>instance.getItemMeta(itemId)?.depth ?? 0,
        children: children
    });
};
$afa7da3a2b267352$export$eb09d9f2bbd20fb.params = {
    disabledItemsFocusable: true,
    items: true,
    isItemDisabled: true,
    getItemLabel: true,
    getItemId: true,
    onItemClick: true,
    itemChildrenIndentation: true
};




var $h4Bez = parcelRequire("h4Bez");

const $627e7e22f8eaa481$export$f198a27ee171dd2b = ({ instance: instance, params: params, models: models })=>{
    const expandedItemsMap = $h4Bez.useMemo(()=>{
        const temp = new Map();
        models.expandedItems.value.forEach((id)=>{
            temp.set(id, true);
        });
        return temp;
    }, [
        models.expandedItems.value
    ]);
    const setExpandedItems = (event, value)=>{
        params.onExpandedItemsChange?.(event, value);
        models.expandedItems.setControlledValue(value);
    };
    const isItemExpanded = $h4Bez.useCallback((itemId)=>expandedItemsMap.has(itemId), [
        expandedItemsMap
    ]);
    const isItemExpandable = $h4Bez.useCallback((itemId)=>!!instance.getItemMeta(itemId)?.expandable, [
        instance
    ]);
    const toggleItemExpansion = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)((event, itemId)=>{
        const isExpandedBefore = instance.isItemExpanded(itemId);
        instance.setItemExpansion(event, itemId, !isExpandedBefore);
    });
    const setItemExpansion = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)((event, itemId, isExpanded)=>{
        const isExpandedBefore = instance.isItemExpanded(itemId);
        if (isExpandedBefore === isExpanded) return;
        let newExpanded;
        if (isExpanded) newExpanded = [
            itemId
        ].concat(models.expandedItems.value);
        else newExpanded = models.expandedItems.value.filter((id)=>id !== itemId);
        if (params.onItemExpansionToggle) params.onItemExpansionToggle(event, itemId, isExpanded);
        setExpandedItems(event, newExpanded);
    });
    const expandAllSiblings = (event, itemId)=>{
        const itemMeta = instance.getItemMeta(itemId);
        const siblings = instance.getItemOrderedChildrenIds(itemMeta.parentId);
        const diff = siblings.filter((child)=>instance.isItemExpandable(child) && !instance.isItemExpanded(child));
        const newExpanded = models.expandedItems.value.concat(diff);
        if (diff.length > 0) {
            if (params.onItemExpansionToggle) diff.forEach((newlyExpandedItemId)=>{
                params.onItemExpansionToggle(event, newlyExpandedItemId, true);
            });
            setExpandedItems(event, newExpanded);
        }
    };
    const expansionTrigger = $h4Bez.useMemo(()=>{
        if (params.expansionTrigger) return params.expansionTrigger;
        if (instance.isTreeViewEditable) return 'iconContainer';
        return 'content';
    }, [
        params.expansionTrigger,
        instance.isTreeViewEditable
    ]);
    return {
        publicAPI: {
            setItemExpansion: setItemExpansion
        },
        instance: {
            isItemExpanded: isItemExpanded,
            isItemExpandable: isItemExpandable,
            setItemExpansion: setItemExpansion,
            toggleItemExpansion: toggleItemExpansion,
            expandAllSiblings: expandAllSiblings
        },
        contextValue: {
            expansion: {
                expansionTrigger: expansionTrigger
            }
        }
    };
};
$627e7e22f8eaa481$export$f198a27ee171dd2b.models = {
    expandedItems: {
        getDefaultValue: (params)=>params.defaultExpandedItems
    }
};
const $627e7e22f8eaa481$var$DEFAULT_EXPANDED_ITEMS = [];
$627e7e22f8eaa481$export$f198a27ee171dd2b.getDefaultizedParams = ({ params: params })=>(0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, params, {
        defaultExpandedItems: params.defaultExpandedItems ?? $627e7e22f8eaa481$var$DEFAULT_EXPANDED_ITEMS
    });
$627e7e22f8eaa481$export$f198a27ee171dd2b.params = {
    expandedItems: true,
    defaultExpandedItems: true,
    onExpandedItemsChange: true,
    onItemExpansionToggle: true,
    expansionTrigger: true
};




var $h4Bez = parcelRequire("h4Bez");
const $a34ea5d243eb1c04$var$getLastNavigableItemInArray = (instance, items)=>{
    // Equivalent to Array.prototype.findLastIndex
    let itemIndex = items.length - 1;
    while(itemIndex >= 0 && !instance.isItemNavigable(items[itemIndex]))itemIndex -= 1;
    if (itemIndex === -1) return undefined;
    return items[itemIndex];
};
const $a34ea5d243eb1c04$export$c4f586d7c71ecf8d = (instance, itemId)=>{
    const itemMeta = instance.getItemMeta(itemId);
    const siblings = instance.getItemOrderedChildrenIds(itemMeta.parentId);
    const itemIndex = instance.getItemIndex(itemId);
    // TODO: What should we do if the parent is not navigable?
    if (itemIndex === 0) return itemMeta.parentId;
    // Finds the previous navigable sibling.
    let previousNavigableSiblingIndex = itemIndex - 1;
    while(!instance.isItemNavigable(siblings[previousNavigableSiblingIndex]) && previousNavigableSiblingIndex >= 0)previousNavigableSiblingIndex -= 1;
    if (previousNavigableSiblingIndex === -1) {
        // If we are at depth 0, then it means all the items above the current item are not navigable.
        if (itemMeta.parentId == null) return null;
        // Otherwise, we can try to go up a level and find the previous navigable item.
        return $a34ea5d243eb1c04$export$c4f586d7c71ecf8d(instance, itemMeta.parentId);
    }
    // Finds the last navigable ancestor of the previous navigable sibling.
    let currentItemId = siblings[previousNavigableSiblingIndex];
    let lastNavigableChild = $a34ea5d243eb1c04$var$getLastNavigableItemInArray(instance, instance.getItemOrderedChildrenIds(currentItemId));
    while(instance.isItemExpanded(currentItemId) && lastNavigableChild != null){
        currentItemId = lastNavigableChild;
        lastNavigableChild = instance.getItemOrderedChildrenIds(currentItemId).find(instance.isItemNavigable);
    }
    return currentItemId;
};
const $a34ea5d243eb1c04$export$b7da0064a5fd3c3b = (instance, itemId)=>{
    // If the item is expanded and has some navigable children, return the first of them.
    if (instance.isItemExpanded(itemId)) {
        const firstNavigableChild = instance.getItemOrderedChildrenIds(itemId).find(instance.isItemNavigable);
        if (firstNavigableChild != null) return firstNavigableChild;
    }
    let itemMeta = instance.getItemMeta(itemId);
    while(itemMeta != null){
        // Try to find the first navigable sibling after the current item.
        const siblings = instance.getItemOrderedChildrenIds(itemMeta.parentId);
        const currentItemIndex = instance.getItemIndex(itemMeta.id);
        if (currentItemIndex < siblings.length - 1) {
            let nextItemIndex = currentItemIndex + 1;
            while(!instance.isItemNavigable(siblings[nextItemIndex]) && nextItemIndex < siblings.length - 1)nextItemIndex += 1;
            if (instance.isItemNavigable(siblings[nextItemIndex])) return siblings[nextItemIndex];
        }
        // If the sibling does not exist, go up a level to the parent and try again.
        itemMeta = instance.getItemMeta(itemMeta.parentId);
    }
    return null;
};
const $a34ea5d243eb1c04$export$337064ce7a54bd6a = (instance)=>{
    let itemId = null;
    while(itemId == null || instance.isItemExpanded(itemId)){
        const children = instance.getItemOrderedChildrenIds(itemId);
        const lastNavigableChild = $a34ea5d243eb1c04$var$getLastNavigableItemInArray(instance, children);
        // The item has no navigable children.
        if (lastNavigableChild == null) return itemId;
        itemId = lastNavigableChild;
    }
    return itemId;
};
const $a34ea5d243eb1c04$export$2ca561ddc1785264 = (instance)=>instance.getItemOrderedChildrenIds(null).find(instance.isItemNavigable);
const $a34ea5d243eb1c04$export$17d19e2e752066c5 = (instance, itemAId, itemBId)=>{
    if (itemAId === itemBId) return [
        itemAId,
        itemBId
    ];
    const itemMetaA = instance.getItemMeta(itemAId);
    const itemMetaB = instance.getItemMeta(itemBId);
    if (itemMetaA.parentId === itemMetaB.id || itemMetaB.parentId === itemMetaA.id) return itemMetaB.parentId === itemMetaA.id ? [
        itemMetaA.id,
        itemMetaB.id
    ] : [
        itemMetaB.id,
        itemMetaA.id
    ];
    const aFamily = [
        itemMetaA.id
    ];
    const bFamily = [
        itemMetaB.id
    ];
    let aAncestor = itemMetaA.parentId;
    let bAncestor = itemMetaB.parentId;
    let aAncestorIsCommon = bFamily.indexOf(aAncestor) !== -1;
    let bAncestorIsCommon = aFamily.indexOf(bAncestor) !== -1;
    let continueA = true;
    let continueB = true;
    while(!bAncestorIsCommon && !aAncestorIsCommon){
        if (continueA) {
            aFamily.push(aAncestor);
            aAncestorIsCommon = bFamily.indexOf(aAncestor) !== -1;
            continueA = aAncestor !== null;
            if (!aAncestorIsCommon && continueA) aAncestor = instance.getItemMeta(aAncestor).parentId;
        }
        if (continueB && !aAncestorIsCommon) {
            bFamily.push(bAncestor);
            bAncestorIsCommon = aFamily.indexOf(bAncestor) !== -1;
            continueB = bAncestor !== null;
            if (!bAncestorIsCommon && continueB) bAncestor = instance.getItemMeta(bAncestor).parentId;
        }
    }
    const commonAncestor = aAncestorIsCommon ? aAncestor : bAncestor;
    const ancestorFamily = instance.getItemOrderedChildrenIds(commonAncestor);
    const aSide = aFamily[aFamily.indexOf(commonAncestor) - 1];
    const bSide = bFamily[bFamily.indexOf(commonAncestor) - 1];
    return ancestorFamily.indexOf(aSide) < ancestorFamily.indexOf(bSide) ? [
        itemAId,
        itemBId
    ] : [
        itemBId,
        itemAId
    ];
};
const $a34ea5d243eb1c04$export$4ce67059a83227bb = (instance, itemAId, itemBId)=>{
    const getNextItem = (itemId)=>{
        // If the item is expanded and has some children, return the first of them.
        if (instance.isItemExpandable(itemId) && instance.isItemExpanded(itemId)) return instance.getItemOrderedChildrenIds(itemId)[0];
        let itemMeta = instance.getItemMeta(itemId);
        while(itemMeta != null){
            // Try to find the first navigable sibling after the current item.
            const siblings = instance.getItemOrderedChildrenIds(itemMeta.parentId);
            const currentItemIndex = instance.getItemIndex(itemMeta.id);
            if (currentItemIndex < siblings.length - 1) return siblings[currentItemIndex + 1];
            // If the item is the last of its siblings, go up a level to the parent and try again.
            itemMeta = instance.getItemMeta(itemMeta.parentId);
        }
        throw new Error('Invalid range');
    };
    const [first, last] = $a34ea5d243eb1c04$export$17d19e2e752066c5(instance, itemAId, itemBId);
    const items = [
        first
    ];
    let current = first;
    while(current !== last){
        current = getNextItem(current);
        if (!instance.isItemDisabled(current)) items.push(current);
    }
    return items;
};
const $a34ea5d243eb1c04$export$136dabd28b10f053 = (instance)=>{
    let item = $a34ea5d243eb1c04$export$2ca561ddc1785264(instance);
    const navigableItems = [];
    while(item != null){
        navigableItems.push(item);
        item = $a34ea5d243eb1c04$export$b7da0064a5fd3c3b(instance, item);
    }
    return navigableItems;
};
const $a34ea5d243eb1c04$export$10ed5614bef54e9f = (target, itemRoot)=>{
    return itemRoot !== target.closest('*[role="treeitem"]');
};


/**
 * Transform the `selectedItems` model to be an array if it was a string or null.
 * @param {string[] | string | null} model The raw model.
 * @returns {string[]} The converted model.
 */ const $90c0d2c4fa906af0$export$558e92dce2b8b8ed = (model)=>{
    if (Array.isArray(model)) return model;
    if (model != null) return [
        model
    ];
    return [];
};
const $90c0d2c4fa906af0$export$1fcf80635ed482c = (array)=>{
    const lookup = {};
    array.forEach((itemId)=>{
        lookup[itemId] = true;
    });
    return lookup;
};


const $d68b8660f4a35f36$export$2e4c91cde61c8525 = ({ instance: instance, params: params, models: models })=>{
    const lastSelectedItem = $h4Bez.useRef(null);
    const lastSelectedRange = $h4Bez.useRef({});
    const selectedItemsMap = $h4Bez.useMemo(()=>{
        const temp = new Map();
        if (Array.isArray(models.selectedItems.value)) models.selectedItems.value.forEach((id)=>{
            temp.set(id, true);
        });
        else if (models.selectedItems.value != null) temp.set(models.selectedItems.value, true);
        return temp;
    }, [
        models.selectedItems.value
    ]);
    const setSelectedItems = (event, newSelectedItems)=>{
        if (params.onItemSelectionToggle) {
            if (params.multiSelect) {
                const addedItems = newSelectedItems.filter((itemId)=>!instance.isItemSelected(itemId));
                const removedItems = models.selectedItems.value.filter((itemId)=>!newSelectedItems.includes(itemId));
                addedItems.forEach((itemId)=>{
                    params.onItemSelectionToggle(event, itemId, true);
                });
                removedItems.forEach((itemId)=>{
                    params.onItemSelectionToggle(event, itemId, false);
                });
            } else if (newSelectedItems !== models.selectedItems.value) {
                if (models.selectedItems.value != null) params.onItemSelectionToggle(event, models.selectedItems.value, false);
                if (newSelectedItems != null) params.onItemSelectionToggle(event, newSelectedItems, true);
            }
        }
        if (params.onSelectedItemsChange) params.onSelectedItemsChange(event, newSelectedItems);
        models.selectedItems.setControlledValue(newSelectedItems);
    };
    const isItemSelected = (itemId)=>selectedItemsMap.has(itemId);
    const selectItem = ({ event: event, itemId: itemId, keepExistingSelection: keepExistingSelection = false, shouldBeSelected: shouldBeSelected })=>{
        if (params.disableSelection) return;
        let newSelected;
        if (keepExistingSelection) {
            const cleanSelectedItems = (0, $90c0d2c4fa906af0$export$558e92dce2b8b8ed)(models.selectedItems.value);
            const isSelectedBefore = instance.isItemSelected(itemId);
            if (isSelectedBefore && (shouldBeSelected === false || shouldBeSelected == null)) newSelected = cleanSelectedItems.filter((id)=>id !== itemId);
            else if (!isSelectedBefore && (shouldBeSelected === true || shouldBeSelected == null)) newSelected = [
                itemId
            ].concat(cleanSelectedItems);
            else newSelected = cleanSelectedItems;
        } else // eslint-disable-next-line no-lonely-if
        if (shouldBeSelected === false || shouldBeSelected == null && instance.isItemSelected(itemId)) newSelected = params.multiSelect ? [] : null;
        else newSelected = params.multiSelect ? [
            itemId
        ] : itemId;
        setSelectedItems(event, newSelected);
        lastSelectedItem.current = itemId;
        lastSelectedRange.current = {};
    };
    const selectRange = (event, [start, end])=>{
        if (params.disableSelection || !params.multiSelect) return;
        let newSelectedItems = (0, $90c0d2c4fa906af0$export$558e92dce2b8b8ed)(models.selectedItems.value).slice();
        // If the last selection was a range selection,
        // remove the items that were part of the last range from the model
        if (Object.keys(lastSelectedRange.current).length > 0) newSelectedItems = newSelectedItems.filter((id)=>!lastSelectedRange.current[id]);
        // Add to the model the items that are part of the new range and not already part of the model.
        const selectedItemsLookup = (0, $90c0d2c4fa906af0$export$1fcf80635ed482c)(newSelectedItems);
        const range = (0, $a34ea5d243eb1c04$export$4ce67059a83227bb)(instance, start, end);
        const itemsToAddToModel = range.filter((id)=>!selectedItemsLookup[id]);
        newSelectedItems = newSelectedItems.concat(itemsToAddToModel);
        setSelectedItems(event, newSelectedItems);
        lastSelectedRange.current = (0, $90c0d2c4fa906af0$export$1fcf80635ed482c)(range);
    };
    const expandSelectionRange = (event, itemId)=>{
        if (lastSelectedItem.current != null) {
            const [start, end] = (0, $a34ea5d243eb1c04$export$17d19e2e752066c5)(instance, itemId, lastSelectedItem.current);
            selectRange(event, [
                start,
                end
            ]);
        }
    };
    const selectRangeFromStartToItem = (event, itemId)=>{
        selectRange(event, [
            (0, $a34ea5d243eb1c04$export$2ca561ddc1785264)(instance),
            itemId
        ]);
    };
    const selectRangeFromItemToEnd = (event, itemId)=>{
        selectRange(event, [
            itemId,
            (0, $a34ea5d243eb1c04$export$337064ce7a54bd6a)(instance)
        ]);
    };
    const selectAllNavigableItems = (event)=>{
        if (params.disableSelection || !params.multiSelect) return;
        const navigableItems = (0, $a34ea5d243eb1c04$export$136dabd28b10f053)(instance);
        setSelectedItems(event, navigableItems);
        lastSelectedRange.current = (0, $90c0d2c4fa906af0$export$1fcf80635ed482c)(navigableItems);
    };
    const selectItemFromArrowNavigation = (event, currentItem, nextItem)=>{
        if (params.disableSelection || !params.multiSelect) return;
        let newSelectedItems = (0, $90c0d2c4fa906af0$export$558e92dce2b8b8ed)(models.selectedItems.value).slice();
        if (Object.keys(lastSelectedRange.current).length === 0) {
            newSelectedItems.push(nextItem);
            lastSelectedRange.current = {
                [currentItem]: true,
                [nextItem]: true
            };
        } else {
            if (!lastSelectedRange.current[currentItem]) lastSelectedRange.current = {};
            if (lastSelectedRange.current[nextItem]) {
                newSelectedItems = newSelectedItems.filter((id)=>id !== currentItem);
                delete lastSelectedRange.current[currentItem];
            } else {
                newSelectedItems.push(nextItem);
                lastSelectedRange.current[nextItem] = true;
            }
        }
        setSelectedItems(event, newSelectedItems);
    };
    return {
        getRootProps: ()=>({
                'aria-multiselectable': params.multiSelect
            }),
        publicAPI: {
            selectItem: selectItem
        },
        instance: {
            isItemSelected: isItemSelected,
            selectItem: selectItem,
            selectAllNavigableItems: selectAllNavigableItems,
            expandSelectionRange: expandSelectionRange,
            selectRangeFromStartToItem: selectRangeFromStartToItem,
            selectRangeFromItemToEnd: selectRangeFromItemToEnd,
            selectItemFromArrowNavigation: selectItemFromArrowNavigation
        },
        contextValue: {
            selection: {
                multiSelect: params.multiSelect,
                checkboxSelection: params.checkboxSelection,
                disableSelection: params.disableSelection
            }
        }
    };
};
$d68b8660f4a35f36$export$2e4c91cde61c8525.models = {
    selectedItems: {
        getDefaultValue: (params)=>params.defaultSelectedItems
    }
};
const $d68b8660f4a35f36$var$DEFAULT_SELECTED_ITEMS = [];
$d68b8660f4a35f36$export$2e4c91cde61c8525.getDefaultizedParams = ({ params: params })=>(0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, params, {
        disableSelection: params.disableSelection ?? false,
        multiSelect: params.multiSelect ?? false,
        checkboxSelection: params.checkboxSelection ?? false,
        defaultSelectedItems: params.defaultSelectedItems ?? (params.multiSelect ? $d68b8660f4a35f36$var$DEFAULT_SELECTED_ITEMS : null)
    });
$d68b8660f4a35f36$export$2e4c91cde61c8525.params = {
    disableSelection: true,
    multiSelect: true,
    checkboxSelection: true,
    defaultSelectedItems: true,
    selectedItems: true,
    onSelectedItemsChange: true,
    onItemSelectionToggle: true
};




var $h4Bez = parcelRequire("h4Bez");



var $h4Bez = parcelRequire("h4Bez");
// If no effect ran after this amount of time, we assume that the render was not committed by React
const $1bc681d88d4a0759$var$CLEANUP_TIMER_LOOP_MILLIS = 1000;
class $1bc681d88d4a0759$export$c16cf791cc6bf0c7 {
    constructor(timeout = $1bc681d88d4a0759$var$CLEANUP_TIMER_LOOP_MILLIS){
        this.timeouts = new Map();
        this.cleanupTimeout = $1bc681d88d4a0759$var$CLEANUP_TIMER_LOOP_MILLIS;
        this.cleanupTimeout = timeout;
    }
    register(object, unsubscribe, unregisterToken) {
        if (!this.timeouts) this.timeouts = new Map();
        const timeout = setTimeout(()=>{
            if (typeof unsubscribe === 'function') unsubscribe();
            this.timeouts.delete(unregisterToken.cleanupToken);
        }, this.cleanupTimeout);
        this.timeouts.set(unregisterToken.cleanupToken, timeout);
    }
    unregister(unregisterToken) {
        const timeout = this.timeouts.get(unregisterToken.cleanupToken);
        if (timeout) {
            this.timeouts.delete(unregisterToken.cleanupToken);
            clearTimeout(timeout);
        }
    }
    reset() {
        if (this.timeouts) {
            this.timeouts.forEach((value, key)=>{
                this.unregister({
                    cleanupToken: key
                });
            });
            this.timeouts = undefined;
        }
    }
}


class $96a124fe0d43775a$export$86b678dc9d8f7603 {
    constructor(){
        this.registry = new FinalizationRegistry((unsubscribe)=>{
            if (typeof unsubscribe === 'function') unsubscribe();
        });
    }
    register(object, unsubscribe, unregisterToken) {
        this.registry.register(object, unsubscribe, unregisterToken);
    }
    unregister(unregisterToken) {
        this.registry.unregister(unregisterToken);
    }
    // eslint-disable-next-line class-methods-use-this
    reset() {}
}


// We use class to make it easier to detect in heap snapshots by name
class $aa817e8d53e25df9$var$ObjectToBeRetainedByReact {
}
function $aa817e8d53e25df9$export$7539a8c1c0de7c55(registryContainer) {
    let cleanupTokensCounter = 0;
    return function useInstanceEventHandler(instance, eventName, handler) {
        if (registryContainer.registry === null) registryContainer.registry = typeof FinalizationRegistry !== 'undefined' ? new (0, $96a124fe0d43775a$export$86b678dc9d8f7603)() : new (0, $1bc681d88d4a0759$export$c16cf791cc6bf0c7)();
        const [objectRetainedByReact] = $h4Bez.useState(new $aa817e8d53e25df9$var$ObjectToBeRetainedByReact());
        const subscription = $h4Bez.useRef(null);
        const handlerRef = $h4Bez.useRef(undefined);
        handlerRef.current = handler;
        const cleanupTokenRef = $h4Bez.useRef(null);
        if (!subscription.current && handlerRef.current) {
            const enhancedHandler = (params, event)=>{
                if (!event.defaultMuiPrevented) handlerRef.current?.(params, event);
            };
            subscription.current = instance.$$subscribeEvent(eventName, enhancedHandler);
            cleanupTokensCounter += 1;
            cleanupTokenRef.current = {
                cleanupToken: cleanupTokensCounter
            };
            registryContainer.registry.register(objectRetainedByReact, // The callback below will be called once this reference stops being retained
            ()=>{
                subscription.current?.();
                subscription.current = null;
                cleanupTokenRef.current = null;
            }, cleanupTokenRef.current);
        } else if (!handlerRef.current && subscription.current) {
            subscription.current();
            subscription.current = null;
            if (cleanupTokenRef.current) {
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
        }
        $h4Bez.useEffect(()=>{
            if (!subscription.current && handlerRef.current) {
                const enhancedHandler = (params, event)=>{
                    if (!event.defaultMuiPrevented) handlerRef.current?.(params, event);
                };
                subscription.current = instance.$$subscribeEvent(eventName, enhancedHandler);
            }
            if (cleanupTokenRef.current && registryContainer.registry) {
                // If the effect was called, it means that this render was committed
                // so we can trust the cleanup function to remove the listener.
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
            return ()=>{
                subscription.current?.();
                subscription.current = null;
            };
        }, [
            instance,
            eventName
        ]);
    };
}
const $aa817e8d53e25df9$var$registryContainer = {
    registry: null
};
const $aa817e8d53e25df9$export$c5af18cc30c6146f = ()=>{
    $aa817e8d53e25df9$var$registryContainer.registry?.reset();
    $aa817e8d53e25df9$var$registryContainer.registry = null;
};
const $aa817e8d53e25df9$export$5f4a1ca5563acec2 = $aa817e8d53e25df9$export$7539a8c1c0de7c55($aa817e8d53e25df9$var$registryContainer);


// https://www.abeautifulsite.net/posts/finding-the-active-element-in-a-shadow-root/
const $89358f05b06e5e0d$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $89358f05b06e5e0d$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
function $89358f05b06e5e0d$export$77eab2954df72e62(operand) {
    return operand.replace(/["\\]/g, '\\$&');
}




const $6ea8d6311472c22e$var$useDefaultFocusableItemId = (instance, selectedItems)=>{
    let tabbableItemId = (0, $90c0d2c4fa906af0$export$558e92dce2b8b8ed)(selectedItems).find((itemId)=>{
        if (!instance.isItemNavigable(itemId)) return false;
        const itemMeta = instance.getItemMeta(itemId);
        return itemMeta && (itemMeta.parentId == null || instance.isItemExpanded(itemMeta.parentId));
    });
    if (tabbableItemId == null) tabbableItemId = (0, $a34ea5d243eb1c04$export$2ca561ddc1785264)(instance);
    return tabbableItemId;
};
const $6ea8d6311472c22e$export$b5793b1aef8945ff = ({ instance: instance, params: params, state: state, setState: setState, models: models, rootRef: rootRef })=>{
    const defaultFocusableItemId = $6ea8d6311472c22e$var$useDefaultFocusableItemId(instance, models.selectedItems.value);
    const setFocusedItemId = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)((itemId)=>{
        const cleanItemId = typeof itemId === 'function' ? itemId(state.focusedItemId) : itemId;
        if (state.focusedItemId !== cleanItemId) setState((prevState)=>(0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState, {
                focusedItemId: cleanItemId
            }));
    });
    const isTreeViewFocused = $h4Bez.useCallback(()=>!!rootRef.current && rootRef.current.contains((0, $89358f05b06e5e0d$export$cd4e5573fbe2b576)((0, $2e2b971777d65c3c$export$2e2bcd8739ae039)(rootRef.current))), [
        rootRef
    ]);
    const isItemFocused = $h4Bez.useCallback((itemId)=>state.focusedItemId === itemId && isTreeViewFocused(), [
        state.focusedItemId,
        isTreeViewFocused
    ]);
    const isItemVisible = (itemId)=>{
        const itemMeta = instance.getItemMeta(itemId);
        return itemMeta && (itemMeta.parentId == null || instance.isItemExpanded(itemMeta.parentId));
    };
    const innerFocusItem = (event, itemId)=>{
        const itemElement = instance.getItemDOMElement(itemId);
        if (itemElement) itemElement.focus();
        setFocusedItemId(itemId);
        if (params.onItemFocus) params.onItemFocus(event, itemId);
    };
    const focusItem = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)((event, itemId)=>{
        // If we receive an itemId, and it is visible, the focus will be set to it
        if (isItemVisible(itemId)) innerFocusItem(event, itemId);
    });
    const removeFocusedItem = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)(()=>{
        if (state.focusedItemId == null) return;
        const itemMeta = instance.getItemMeta(state.focusedItemId);
        if (itemMeta) {
            const itemElement = instance.getItemDOMElement(state.focusedItemId);
            if (itemElement) itemElement.blur();
        }
        setFocusedItemId(null);
    });
    const canItemBeTabbed = (itemId)=>itemId === defaultFocusableItemId;
    (0, $aa817e8d53e25df9$export$5f4a1ca5563acec2)(instance, 'removeItem', ({ id: id })=>{
        if (state.focusedItemId === id) innerFocusItem(null, defaultFocusableItemId);
    });
    const createRootHandleFocus = (otherHandlers)=>(event)=>{
            otherHandlers.onFocus?.(event);
            if (event.defaultMuiPrevented) return;
            // if the event bubbled (which is React specific) we don't want to steal focus
            if (event.target === event.currentTarget) innerFocusItem(event, defaultFocusableItemId);
        };
    return {
        getRootProps: (otherHandlers)=>({
                onFocus: createRootHandleFocus(otherHandlers)
            }),
        publicAPI: {
            focusItem: focusItem
        },
        instance: {
            isItemFocused: isItemFocused,
            canItemBeTabbed: canItemBeTabbed,
            focusItem: focusItem,
            removeFocusedItem: removeFocusedItem
        }
    };
};
$6ea8d6311472c22e$export$b5793b1aef8945ff.getInitialState = ()=>({
        focusedItemId: null
    });
$6ea8d6311472c22e$export$b5793b1aef8945ff.params = {
    onItemFocus: true
};



var $h4Bez = parcelRequire("h4Bez");



const $94197b3aa37c83cf$export$44524f2fb4958e20 = (instance, plugin)=>{
    const plugins = instance.getAvailablePlugins();
    return plugins.has(plugin);
};




var $h4Bez = parcelRequire("h4Bez");


var $h4Bez = parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");

const $297963f7a5ee1b8a$export$8a6a3e88e8e060e0 = ()=>{
    const context = $h4Bez.useContext((0, $1ddd7f1f0448a2fb$export$5e4715462ac10946));
    if (context == null) throw new Error([
        'MUI X: Could not find the Tree View context.',
        'It looks like you rendered your component outside of a SimpleTreeView or RichTreeView parent component.',
        'This can also happen if you are bundling multiple versions of the Tree View.'
    ].join('\n'));
    return context;
};


const $35f8724e90a3e5c6$export$3191224b92f3e03b = ({ props: props })=>{
    const { instance: instance } = (0, $297963f7a5ee1b8a$export$8a6a3e88e8e060e0)();
    const { label: label, itemId: itemId } = props;
    const [labelInputValue, setLabelInputValue] = $h4Bez.useState(label);
    const isItemBeingEdited = instance.isItemBeingEdited(itemId);
    $h4Bez.useEffect(()=>{
        if (!isItemBeingEdited) setLabelInputValue(label);
    }, [
        isItemBeingEdited,
        label
    ]);
    return {
        propsEnhancers: {
            labelInput: ({ externalEventHandlers: externalEventHandlers, interactions: interactions })=>{
                const editable = instance.isItemEditable(itemId);
                if (!editable) return {};
                const handleKeydown = (event)=>{
                    externalEventHandlers.onKeyDown?.(event);
                    if (event.defaultMuiPrevented) return;
                    const target = event.target;
                    if (event.key === 'Enter' && target.value) interactions.handleSaveItemLabel(event, target.value);
                    else if (event.key === 'Escape') interactions.handleCancelItemLabelEditing(event);
                };
                const handleBlur = (event)=>{
                    externalEventHandlers.onBlur?.(event);
                    if (event.defaultMuiPrevented) return;
                    if (event.target.value) interactions.handleSaveItemLabel(event, event.target.value);
                };
                const handleInputChange = (event)=>{
                    externalEventHandlers.onChange?.(event);
                    setLabelInputValue(event.target.value);
                };
                return {
                    value: labelInputValue ?? '',
                    'data-element': 'labelInput',
                    onChange: handleInputChange,
                    onKeyDown: handleKeydown,
                    onBlur: handleBlur,
                    autoFocus: true,
                    type: 'text'
                };
            }
        }
    };
};


const $97cf799452d994b0$export$c6ca8ef294703a19 = ({ instance: instance, state: state, setState: setState, params: params })=>{
    const editedItemRef = $h4Bez.useRef(state.editedItemId);
    const isItemBeingEditedRef = (itemId)=>editedItemRef.current === itemId;
    const setEditedItemId = (editedItemId)=>{
        setState((prevState)=>(0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState, {
                editedItemId: editedItemId
            }));
        editedItemRef.current = editedItemId;
    };
    const isItemBeingEdited = (itemId)=>itemId === state.editedItemId;
    const isTreeViewEditable = Boolean(params.isItemEditable);
    const isItemEditable = (itemId)=>{
        if (itemId == null || !isTreeViewEditable) return false;
        const item = instance.getItem(itemId);
        if (!item) return false;
        return typeof params.isItemEditable === 'function' ? params.isItemEditable(item) : Boolean(params.isItemEditable);
    };
    const updateItemLabel = (itemId, label)=>{
        if (!label) throw new Error([
            'MUI X: The Tree View component requires all items to have a `label` property.',
            'The label of an item cannot be empty.',
            itemId
        ].join('\n'));
        setState((prevState)=>{
            const item = prevState.items.itemMetaMap[itemId];
            if (item.label !== label) return (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState, {
                items: (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState.items, {
                    itemMetaMap: (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState.items.itemMetaMap, {
                        [itemId]: (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, item, {
                            label: label
                        })
                    })
                })
            });
            return prevState;
        });
        if (params.onItemLabelChange) params.onItemLabelChange(itemId, label);
    };
    return {
        instance: {
            setEditedItemId: setEditedItemId,
            isItemBeingEdited: isItemBeingEdited,
            updateItemLabel: updateItemLabel,
            isItemEditable: isItemEditable,
            isTreeViewEditable: isTreeViewEditable,
            isItemBeingEditedRef: isItemBeingEditedRef
        },
        publicAPI: {
            updateItemLabel: updateItemLabel
        }
    };
};
$97cf799452d994b0$export$c6ca8ef294703a19.itemPlugin = (0, $35f8724e90a3e5c6$export$3191224b92f3e03b);
$97cf799452d994b0$export$c6ca8ef294703a19.getDefaultizedParams = ({ params: params, experimentalFeatures: experimentalFeatures })=>{
    const canUseFeature = experimentalFeatures?.labelEditing;
    return (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, params, {
        isItemEditable: canUseFeature ? params.isItemEditable ?? false : false
    });
};
$97cf799452d994b0$export$c6ca8ef294703a19.getInitialState = ()=>({
        editedItemId: null
    });
$97cf799452d994b0$export$c6ca8ef294703a19.params = {
    onItemLabelChange: true,
    isItemEditable: true
};


function $0be0e67b96476b65$var$isPrintableKey(string) {
    return !!string && string.length === 1 && !!string.match(/\S/);
}
const $0be0e67b96476b65$export$70945545f32592c7 = ({ instance: instance, params: params, state: state })=>{
    const isRtl = (0, $c12c19e2bf4d75c0$export$b2dd014b6c321cb)();
    const firstCharMap = $h4Bez.useRef({});
    const updateFirstCharMap = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)((callback)=>{
        firstCharMap.current = callback(firstCharMap.current);
    });
    $h4Bez.useEffect(()=>{
        if (instance.areItemUpdatesPrevented()) return;
        const newFirstCharMap = {};
        const processItem = (item)=>{
            newFirstCharMap[item.id] = item.label.substring(0, 1).toLowerCase();
        };
        Object.values(state.items.itemMetaMap).forEach(processItem);
        firstCharMap.current = newFirstCharMap;
    }, [
        state.items.itemMetaMap,
        params.getItemId,
        instance
    ]);
    const getFirstMatchingItem = (itemId, query)=>{
        const cleanQuery = query.toLowerCase();
        const getNextItem = (itemIdToCheck)=>{
            const nextItemId = (0, $a34ea5d243eb1c04$export$b7da0064a5fd3c3b)(instance, itemIdToCheck);
            // We reached the end of the tree, check from the beginning
            if (nextItemId === null) return (0, $a34ea5d243eb1c04$export$2ca561ddc1785264)(instance);
            return nextItemId;
        };
        let matchingItemId = null;
        let currentItemId = getNextItem(itemId);
        const checkedItems = {};
        // The "!checkedItems[currentItemId]" condition avoids an infinite loop when there is no matching item.
        while(matchingItemId == null && !checkedItems[currentItemId])if (firstCharMap.current[currentItemId] === cleanQuery) matchingItemId = currentItemId;
        else {
            checkedItems[currentItemId] = true;
            currentItemId = getNextItem(currentItemId);
        }
        return matchingItemId;
    };
    const canToggleItemSelection = (itemId)=>!params.disableSelection && !instance.isItemDisabled(itemId);
    const canToggleItemExpansion = (itemId)=>{
        return !instance.isItemDisabled(itemId) && instance.isItemExpandable(itemId);
    };
    // ARIA specification: https://www.w3.org/WAI/ARIA/apg/patterns/treeview/#keyboardinteraction
    const handleItemKeyDown = (event, itemId)=>{
        if (event.defaultMuiPrevented) return;
        if (event.altKey || (0, $a34ea5d243eb1c04$export$10ed5614bef54e9f)(event.target, event.currentTarget)) return;
        const ctrlPressed = event.ctrlKey || event.metaKey;
        const key = event.key;
        // eslint-disable-next-line default-case
        switch(true){
            // Select the item when pressing "Space"
            case key === ' ' && canToggleItemSelection(itemId):
                event.preventDefault();
                if (params.multiSelect && event.shiftKey) instance.expandSelectionRange(event, itemId);
                else instance.selectItem({
                    event: event,
                    itemId: itemId,
                    keepExistingSelection: params.multiSelect,
                    shouldBeSelected: params.multiSelect ? undefined : true
                });
                break;
            // If the focused item has children, we expand it.
            // If the focused item has no children, we select it.
            case key === 'Enter':
                if ((0, $94197b3aa37c83cf$export$44524f2fb4958e20)(instance, (0, $97cf799452d994b0$export$c6ca8ef294703a19)) && instance.isItemEditable(itemId) && !instance.isItemBeingEdited(itemId)) instance.setEditedItemId(itemId);
                else if (canToggleItemExpansion(itemId)) {
                    instance.toggleItemExpansion(event, itemId);
                    event.preventDefault();
                } else if (canToggleItemSelection(itemId)) {
                    if (params.multiSelect) {
                        event.preventDefault();
                        instance.selectItem({
                            event: event,
                            itemId: itemId,
                            keepExistingSelection: true
                        });
                    } else if (!instance.isItemSelected(itemId)) {
                        instance.selectItem({
                            event: event,
                            itemId: itemId
                        });
                        event.preventDefault();
                    }
                }
                break;
            // Focus the next focusable item
            case key === 'ArrowDown':
                {
                    const nextItem = (0, $a34ea5d243eb1c04$export$b7da0064a5fd3c3b)(instance, itemId);
                    if (nextItem) {
                        event.preventDefault();
                        instance.focusItem(event, nextItem);
                        // Multi select behavior when pressing Shift + ArrowDown
                        // Toggles the selection state of the next item
                        if (params.multiSelect && event.shiftKey && canToggleItemSelection(nextItem)) instance.selectItemFromArrowNavigation(event, itemId, nextItem);
                    }
                    break;
                }
            // Focuses the previous focusable item
            case key === 'ArrowUp':
                {
                    const previousItem = (0, $a34ea5d243eb1c04$export$c4f586d7c71ecf8d)(instance, itemId);
                    if (previousItem) {
                        event.preventDefault();
                        instance.focusItem(event, previousItem);
                        // Multi select behavior when pressing Shift + ArrowUp
                        // Toggles the selection state of the previous item
                        if (params.multiSelect && event.shiftKey && canToggleItemSelection(previousItem)) instance.selectItemFromArrowNavigation(event, itemId, previousItem);
                    }
                    break;
                }
            // If the focused item is expanded, we move the focus to its first child
            // If the focused item is collapsed and has children, we expand it
            case key === 'ArrowRight' && !isRtl || key === 'ArrowLeft' && isRtl:
                if (ctrlPressed) return;
                if (instance.isItemExpanded(itemId)) {
                    const nextItemId = (0, $a34ea5d243eb1c04$export$b7da0064a5fd3c3b)(instance, itemId);
                    if (nextItemId) {
                        instance.focusItem(event, nextItemId);
                        event.preventDefault();
                    }
                } else if (canToggleItemExpansion(itemId)) {
                    instance.toggleItemExpansion(event, itemId);
                    event.preventDefault();
                }
                break;
            // If the focused item is expanded, we collapse it
            // If the focused item is collapsed and has a parent, we move the focus to this parent
            case key === 'ArrowLeft' && !isRtl || key === 'ArrowRight' && isRtl:
                if (ctrlPressed) return;
                if (canToggleItemExpansion(itemId) && instance.isItemExpanded(itemId)) {
                    instance.toggleItemExpansion(event, itemId);
                    event.preventDefault();
                } else {
                    const parent = instance.getItemMeta(itemId).parentId;
                    if (parent) {
                        instance.focusItem(event, parent);
                        event.preventDefault();
                    }
                }
                break;
            // Focuses the first item in the tree
            case key === 'Home':
                // Multi select behavior when pressing Ctrl + Shift + Home
                // Selects the focused item and all items up to the first item.
                if (canToggleItemSelection(itemId) && params.multiSelect && ctrlPressed && event.shiftKey) instance.selectRangeFromStartToItem(event, itemId);
                else instance.focusItem(event, (0, $a34ea5d243eb1c04$export$2ca561ddc1785264)(instance));
                event.preventDefault();
                break;
            // Focuses the last item in the tree
            case key === 'End':
                // Multi select behavior when pressing Ctrl + Shirt + End
                // Selects the focused item and all the items down to the last item.
                if (canToggleItemSelection(itemId) && params.multiSelect && ctrlPressed && event.shiftKey) instance.selectRangeFromItemToEnd(event, itemId);
                else instance.focusItem(event, (0, $a34ea5d243eb1c04$export$337064ce7a54bd6a)(instance));
                event.preventDefault();
                break;
            // Expand all siblings that are at the same level as the focused item
            case key === '*':
                instance.expandAllSiblings(event, itemId);
                event.preventDefault();
                break;
            // Multi select behavior when pressing Ctrl + a
            // Selects all the items
            case String.fromCharCode(event.keyCode) === 'A' && ctrlPressed && params.multiSelect && !params.disableSelection:
                instance.selectAllNavigableItems(event);
                event.preventDefault();
                break;
            // Type-ahead
            // TODO: Support typing multiple characters
            case !ctrlPressed && !event.shiftKey && $0be0e67b96476b65$var$isPrintableKey(key):
                {
                    const matchingItem = getFirstMatchingItem(itemId, key);
                    if (matchingItem != null) {
                        instance.focusItem(event, matchingItem);
                        event.preventDefault();
                    }
                    break;
                }
        }
    };
    return {
        instance: {
            updateFirstCharMap: updateFirstCharMap,
            handleItemKeyDown: handleItemKeyDown
        }
    };
};
$0be0e67b96476b65$export$70945545f32592c7.params = {};


const $92f59147f7160aa0$export$8ac952f111e42195 = ({ slots: slots, slotProps: slotProps })=>{
    return {
        contextValue: {
            icons: {
                slots: {
                    collapseIcon: slots.collapseIcon,
                    expandIcon: slots.expandIcon,
                    endIcon: slots.endIcon
                },
                slotProps: {
                    collapseIcon: slotProps.collapseIcon,
                    expandIcon: slotProps.expandIcon,
                    endIcon: slotProps.endIcon
                }
            }
        }
    };
};
$92f59147f7160aa0$export$8ac952f111e42195.params = {};




var $h4Bez = parcelRequire("h4Bez");






var $h4Bez = parcelRequire("h4Bez");





const $a3e108e9b3f64404$export$491c8391ac0d34b5 = /*#__PURE__*/ $h4Bez.createContext(null);
function $a3e108e9b3f64404$export$a6e95ced7983197f(props) {
    const { children: children, itemId: itemId = null } = props;
    const { instance: instance, treeId: treeId, rootRef: rootRef } = (0, $297963f7a5ee1b8a$export$8a6a3e88e8e060e0)();
    const childrenIdAttrToIdRef = $h4Bez.useRef(new Map());
    $h4Bez.useEffect(()=>{
        if (!rootRef.current) return;
        let idAttr = null;
        if (itemId == null) idAttr = rootRef.current.id;
        else {
            // Undefined during 1st render
            const itemMeta = instance.getItemMeta(itemId);
            if (itemMeta !== undefined) idAttr = (0, $aaffed941a94ef7c$export$6ce5f925ac04fad)({
                itemId: itemId,
                treeId: treeId,
                id: itemMeta.idAttribute
            });
        }
        if (idAttr == null) return;
        const previousChildrenIds = instance.getItemOrderedChildrenIds(itemId ?? null) ?? [];
        const escapedIdAttr = (0, $89358f05b06e5e0d$export$77eab2954df72e62)(idAttr);
        const childrenElements = rootRef.current.querySelectorAll(`${itemId == null ? '' : `*[id="${escapedIdAttr}"] `}[role="treeitem"]:not(*[id="${escapedIdAttr}"] [role="treeitem"] [role="treeitem"])`);
        const childrenIds = Array.from(childrenElements).map((child)=>childrenIdAttrToIdRef.current.get(child.id));
        const hasChanged = childrenIds.length !== previousChildrenIds.length || childrenIds.some((childId, index)=>childId !== previousChildrenIds[index]);
        if (hasChanged) instance.setJSXItemsOrderedChildrenIds(itemId ?? null, childrenIds);
    });
    const value = $h4Bez.useMemo(()=>({
            registerChild: (childIdAttribute, childItemId)=>childrenIdAttrToIdRef.current.set(childIdAttribute, childItemId),
            unregisterChild: (childIdAttribute)=>childrenIdAttrToIdRef.current.delete(childIdAttribute),
            parentId: itemId
        }), [
        itemId
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($a3e108e9b3f64404$export$491c8391ac0d34b5.Provider, {
        value: value,
        children: children
    });
}






const $8942cdee2bd5f17e$export$b6ba28714a5a40c7 = ({ instance: instance, setState: setState })=>{
    instance.preventItemUpdates();
    const insertJSXItem = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)((item)=>{
        setState((prevState)=>{
            if (prevState.items.itemMetaMap[item.id] != null) throw new Error([
                'MUI X: The Tree View component requires all items to have a unique `id` property.',
                'Alternatively, you can use the `getItemId` prop to specify a custom id for each item.',
                `Two items were provided with the same id in the \`items\` prop: "${item.id}"`
            ].join('\n'));
            return (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState, {
                items: (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState.items, {
                    itemMetaMap: (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState.items.itemMetaMap, {
                        [item.id]: item
                    }),
                    // For Simple Tree View, we don't have a proper `item` object, so we create a very basic one.
                    itemMap: (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState.items.itemMap, {
                        [item.id]: {
                            id: item.id,
                            label: item.label
                        }
                    })
                })
            });
        });
        return ()=>{
            setState((prevState)=>{
                const newItemMetaMap = (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState.items.itemMetaMap);
                const newItemMap = (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState.items.itemMap);
                delete newItemMetaMap[item.id];
                delete newItemMap[item.id];
                return (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState, {
                    items: (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState.items, {
                        itemMetaMap: newItemMetaMap,
                        itemMap: newItemMap
                    })
                });
            });
            (0, $f1ba621fdcdf5d7f$export$d5c088e621d1d7a3)(instance, 'removeItem', {
                id: item.id
            });
        };
    });
    const setJSXItemsOrderedChildrenIds = (parentId, orderedChildrenIds)=>{
        const parentIdWithDefault = parentId ?? (0, $7a7e1d2e3fb0cf09$export$e7a9649b6cfa9944);
        setState((prevState)=>(0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState, {
                items: (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState.items, {
                    itemOrderedChildrenIds: (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState.items.itemOrderedChildrenIds, {
                        [parentIdWithDefault]: orderedChildrenIds
                    }),
                    itemChildrenIndexes: (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, prevState.items.itemChildrenIndexes, {
                        [parentIdWithDefault]: (0, $7a7e1d2e3fb0cf09$export$1d3868a1fe066660)(orderedChildrenIds)
                    })
                })
            }));
    };
    const mapFirstCharFromJSX = (0, $8ff1dc7abf990699$export$2e2bcd8739ae039)((itemId, firstChar)=>{
        instance.updateFirstCharMap((firstCharMap)=>{
            firstCharMap[itemId] = firstChar;
            return firstCharMap;
        });
        return ()=>{
            instance.updateFirstCharMap((firstCharMap)=>{
                const newMap = (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, firstCharMap);
                delete newMap[itemId];
                return newMap;
            });
        };
    });
    return {
        instance: {
            insertJSXItem: insertJSXItem,
            setJSXItemsOrderedChildrenIds: setJSXItemsOrderedChildrenIds,
            mapFirstCharFromJSX: mapFirstCharFromJSX
        }
    };
};
const $8942cdee2bd5f17e$var$isItemExpandable = (reactChildren)=>{
    if (Array.isArray(reactChildren)) return reactChildren.length > 0 && reactChildren.some($8942cdee2bd5f17e$var$isItemExpandable);
    return Boolean(reactChildren);
};
const $8942cdee2bd5f17e$var$useTreeViewJSXItemsItemPlugin = ({ props: props, rootRef: rootRef, contentRef: contentRef })=>{
    const { instance: instance, treeId: treeId } = (0, $297963f7a5ee1b8a$export$8a6a3e88e8e060e0)();
    const { children: children, disabled: disabled = false, label: label, itemId: itemId, id: id } = props;
    const parentContext = $h4Bez.useContext((0, $a3e108e9b3f64404$export$491c8391ac0d34b5));
    if (parentContext == null) throw new Error([
        'MUI X: Could not find the Tree View Children Item context.',
        'It looks like you rendered your component outside of a SimpleTreeView parent component.',
        'This can also happen if you are bundling multiple versions of the Tree View.'
    ].join('\n'));
    const { registerChild: registerChild, unregisterChild: unregisterChild, parentId: parentId } = parentContext;
    const expandable = $8942cdee2bd5f17e$var$isItemExpandable(children);
    const pluginContentRef = $h4Bez.useRef(null);
    const handleContentRef = (0, $4fa58c431bc87919$export$2e2bcd8739ae039)(pluginContentRef, contentRef);
    // Prevent any flashing
    (0, $01a3a2b63fe8dafe$export$2e2bcd8739ae039)(()=>{
        const idAttribute = (0, $aaffed941a94ef7c$export$6ce5f925ac04fad)({
            itemId: itemId,
            treeId: treeId,
            id: id
        });
        registerChild(idAttribute, itemId);
        return ()=>{
            unregisterChild(idAttribute);
        };
    }, [
        registerChild,
        unregisterChild,
        itemId,
        id,
        treeId
    ]);
    $h4Bez.useEffect(()=>{
        return instance.insertJSXItem({
            id: itemId,
            idAttribute: id,
            parentId: parentId,
            expandable: expandable,
            disabled: disabled
        });
    }, [
        instance,
        parentId,
        itemId,
        expandable,
        disabled,
        id
    ]);
    $h4Bez.useEffect(()=>{
        if (label) return instance.mapFirstCharFromJSX(itemId, (pluginContentRef.current?.textContent ?? '').substring(0, 1).toLowerCase());
        return undefined;
    }, [
        instance,
        itemId,
        label
    ]);
    return {
        contentRef: handleContentRef,
        rootRef: rootRef
    };
};
$8942cdee2bd5f17e$export$b6ba28714a5a40c7.itemPlugin = $8942cdee2bd5f17e$var$useTreeViewJSXItemsItemPlugin;
$8942cdee2bd5f17e$export$b6ba28714a5a40c7.wrapItem = ({ children: children, itemId: itemId })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const depthContext = $h4Bez.useContext((0, $593075cc412db2a8$export$8634277a87653494));
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a3e108e9b3f64404$export$a6e95ced7983197f), {
        itemId: itemId,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $593075cc412db2a8$export$8634277a87653494).Provider, {
            value: depthContext + 1,
            children: children
        })
    });
};
$8942cdee2bd5f17e$export$b6ba28714a5a40c7.wrapRoot = ({ children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a3e108e9b3f64404$export$a6e95ced7983197f), {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $593075cc412db2a8$export$8634277a87653494).Provider, {
            value: 0,
            children: children
        })
    });
$8942cdee2bd5f17e$export$b6ba28714a5a40c7.params = {};


const $dab2e3aedf1ef27a$export$907ed5613121a25a = [
    (0, $afa7da3a2b267352$export$eb09d9f2bbd20fb),
    (0, $627e7e22f8eaa481$export$f198a27ee171dd2b),
    (0, $d68b8660f4a35f36$export$2e4c91cde61c8525),
    (0, $6ea8d6311472c22e$export$b5793b1aef8945ff),
    (0, $0be0e67b96476b65$export$70945545f32592c7),
    (0, $92f59147f7160aa0$export$8ac952f111e42195),
    (0, $8942cdee2bd5f17e$export$b6ba28714a5a40c7)
]; // We can't infer this type from the plugin, otherwise we would lose the generics.



'use client';
const $1e4b715c494d4376$var$useThemeProps = (0, $c706d228957b23f0$export$ff8356348e0cc878)('MuiSimpleTreeView');
const $1e4b715c494d4376$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $a5bb530ccd239bbb$export$554faf16d1e10669), classes);
};
const $1e4b715c494d4376$export$7a7ee2f8b6137163 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('ul', {
    name: 'MuiSimpleTreeView',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: 0,
    margin: 0,
    listStyle: 'none',
    outline: 0,
    position: 'relative'
});
const $1e4b715c494d4376$var$EMPTY_ITEMS = [];
/**
 *
 * Demos:
 *
 * - [Tree View](https://mui.com/x/react-tree-view/)
 *
 * API:
 *
 * - [SimpleTreeView API](https://mui.com/x/api/tree-view/simple-tree-view/)
 */ const $1e4b715c494d4376$export$d8982212e1ac7e50 = /*#__PURE__*/ $h4Bez.forwardRef(function SimpleTreeView(inProps, ref) {
    const props = $1e4b715c494d4376$var$useThemeProps({
        props: inProps,
        name: 'MuiSimpleTreeView'
    });
    const ownerState = props;
    const { getRootProps: getRootProps, contextValue: contextValue } = (0, $195b827f5c7da639$export$1e79c2a653523352)({
        plugins: (0, $dab2e3aedf1ef27a$export$907ed5613121a25a),
        rootRef: ref,
        props: (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, props, {
            items: $1e4b715c494d4376$var$EMPTY_ITEMS
        })
    });
    const { slots: slots, slotProps: slotProps } = props;
    const classes = $1e4b715c494d4376$var$useUtilityClasses(props);
    const Root = slots?.root ?? $1e4b715c494d4376$export$7a7ee2f8b6137163;
    const rootProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps?.root,
        className: classes.root,
        getSlotProps: getRootProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $352675bf6916099d$export$6a399b2f7f12632c), {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Root, (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, rootProps))
    });
});




var $h4Bez = parcelRequire("h4Bez");

function $2e68cc75bf086487$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $2e68cc75bf086487$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $2e68cc75bf086487$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $2e68cc75bf086487$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $2e68cc75bf086487$export$2e2bcd8739ae039 = $2e68cc75bf086487$export$4f5d2d50c9deca37;

















var $h4Bez = parcelRequire("h4Bez");






'use client';
function $98053d271e52c1c8$export$7d6b3b4a1b5ea514(itemId) {
    const { instance: instance, items: { onItemClick: onItemClick }, selection: { multiSelect: multiSelect, checkboxSelection: checkboxSelection, disableSelection: disableSelection }, expansion: { expansionTrigger: expansionTrigger } } = (0, $297963f7a5ee1b8a$export$8a6a3e88e8e060e0)();
    const expandable = instance.isItemExpandable(itemId);
    const expanded = instance.isItemExpanded(itemId);
    const focused = instance.isItemFocused(itemId);
    const selected = instance.isItemSelected(itemId);
    const disabled = instance.isItemDisabled(itemId);
    const editing = instance?.isItemBeingEdited ? instance?.isItemBeingEdited(itemId) : false;
    const editable = instance.isItemEditable ? instance.isItemEditable(itemId) : false;
    const handleExpansion = (event)=>{
        if (!disabled) {
            if (!focused) instance.focusItem(event, itemId);
            const multiple = multiSelect && (event.shiftKey || event.ctrlKey || event.metaKey);
            // If already expanded and trying to toggle selection don't close
            if (expandable && !(multiple && instance.isItemExpanded(itemId))) instance.toggleItemExpansion(event, itemId);
        }
    };
    const handleSelection = (event)=>{
        if (!disabled) {
            if (!focused && !editing) instance.focusItem(event, itemId);
            const multiple = multiSelect && (event.shiftKey || event.ctrlKey || event.metaKey);
            if (multiple) {
                if (event.shiftKey) instance.expandSelectionRange(event, itemId);
                else instance.selectItem({
                    event: event,
                    itemId: itemId,
                    keepExistingSelection: true
                });
            } else instance.selectItem({
                event: event,
                itemId: itemId,
                shouldBeSelected: true
            });
        }
    };
    const handleCheckboxSelection = (event)=>{
        if (disableSelection || disabled) return;
        const hasShift = event.nativeEvent.shiftKey;
        if (multiSelect && hasShift) instance.expandSelectionRange(event, itemId);
        else instance.selectItem({
            event: event,
            itemId: itemId,
            keepExistingSelection: multiSelect,
            shouldBeSelected: event.target.checked
        });
    };
    const preventSelection = (event)=>{
        if (event.shiftKey || event.ctrlKey || event.metaKey || disabled) // Prevent text selection
        event.preventDefault();
    };
    const toggleItemEditing = ()=>{
        if (!(0, $94197b3aa37c83cf$export$44524f2fb4958e20)(instance, (0, $97cf799452d994b0$export$c6ca8ef294703a19))) return;
        if (instance.isItemEditable(itemId)) {
            if (instance.isItemBeingEdited(itemId)) instance.setEditedItemId(null);
            else instance.setEditedItemId(itemId);
        }
    };
    const handleSaveItemLabel = (event, label)=>{
        if (!(0, $94197b3aa37c83cf$export$44524f2fb4958e20)(instance, (0, $97cf799452d994b0$export$c6ca8ef294703a19))) return;
        // As a side effect of `instance.focusItem` called here and in `handleCancelItemLabelEditing` the `labelInput` is blurred
        // The `onBlur` event is triggered, which calls `handleSaveItemLabel` again.
        // To avoid creating an unwanted behavior we need to check if the item is being edited before calling `updateItemLabel`
        // using `instance.isItemBeingEditedRef` instead of `instance.isItemBeingEdited` since the state is not yet updated in this point
        if (instance.isItemBeingEditedRef(itemId)) {
            instance.updateItemLabel(itemId, label);
            toggleItemEditing();
            instance.focusItem(event, itemId);
        }
    };
    const handleCancelItemLabelEditing = (event)=>{
        if (!(0, $94197b3aa37c83cf$export$44524f2fb4958e20)(instance, (0, $97cf799452d994b0$export$c6ca8ef294703a19))) return;
        if (instance.isItemBeingEditedRef(itemId)) {
            toggleItemEditing();
            instance.focusItem(event, itemId);
        }
    };
    return {
        disabled: disabled,
        expanded: expanded,
        selected: selected,
        focused: focused,
        editable: editable,
        editing: editing,
        disableSelection: disableSelection,
        checkboxSelection: checkboxSelection,
        handleExpansion: handleExpansion,
        handleSelection: handleSelection,
        handleCheckboxSelection: handleCheckboxSelection,
        handleContentClick: onItemClick,
        preventSelection: preventSelection,
        expansionTrigger: expansionTrigger,
        toggleItemEditing: toggleItemEditing,
        handleSaveItemLabel: handleSaveItemLabel,
        handleCancelItemLabelEditing: handleCancelItemLabelEditing
    };
}



parcelRequire("h4Bez");





const $8609dbc019b34ba9$var$TreeItem2DragAndDropOverlayRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiTreeItem2DragAndDropOverlay',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $323d09b5b142c3c9$export$3ba67b570e26eea0)(prop) && prop !== 'action'
})(({ theme: theme })=>({
        position: 'absolute',
        left: 0,
        display: 'flex',
        top: 0,
        bottom: 0,
        right: 0,
        pointerEvents: 'none',
        variants: [
            {
                props: {
                    action: 'make-child'
                },
                style: {
                    marginLeft: 'calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))',
                    borderRadius: theme.shape.borderRadius,
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.darkChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $3289d56f59a873c2$export$58f0f39f63f3cf42)(theme.palette.primary.dark, theme.palette.action.focusOpacity)
                }
            },
            {
                props: {
                    action: 'reorder-above'
                },
                style: {
                    marginLeft: 'calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))',
                    borderTop: `1px solid ${(theme.vars || theme).palette.action.active}`
                }
            },
            {
                props: {
                    action: 'reorder-below'
                },
                style: {
                    marginLeft: 'calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))',
                    borderBottom: `1px solid ${(theme.vars || theme).palette.action.active}`
                }
            },
            {
                props: {
                    action: 'move-to-parent'
                },
                style: {
                    marginLeft: 'calc(var(--TreeView-indentMultiplier) * calc(var(--TreeView-itemDepth) - 1))',
                    borderBottom: `1px solid ${(theme.vars || theme).palette.action.active}`
                }
            }
        ]
    }));
function $8609dbc019b34ba9$export$2cc9891a3e76ffb(props) {
    if (props.action == null) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($8609dbc019b34ba9$var$TreeItem2DragAndDropOverlayRoot, (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, props));
}




/**
 * @ignore - internal component.
 */ const $f50e6f8f293babeb$export$a8935372dfdf5419 = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('input', {
    name: 'MuiTreeItem2',
    slot: 'LabelInput',
    overridesResolver: (props, styles)=>styles.labelInput
})(({ theme: theme })=>(0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, theme.typography.body1, {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        border: 'none',
        padding: '0 2px',
        boxSizing: 'border-box',
        '&:focus': {
            outline: `1px solid ${theme.palette.primary.main}`
        }
    }));



const $6eda6d630144b2bc$var$_excluded = [
    "classes",
    "className",
    "displayIcon",
    "expansionIcon",
    "icon",
    "label",
    "itemId",
    "onClick",
    "onMouseDown",
    "dragAndDropOverlayProps",
    "labelInputProps"
];
/**
 * @ignore - internal component.
 */ const $6eda6d630144b2bc$export$4b687e3f663d618c = /*#__PURE__*/ $h4Bez.forwardRef(function TreeItemContent(props, ref) {
    const { classes: classes, className: className, displayIcon: displayIcon, expansionIcon: expansionIcon, icon: iconProp, label: label, itemId: itemId, onClick: onClick, onMouseDown: onMouseDown, dragAndDropOverlayProps: dragAndDropOverlayProps, labelInputProps: labelInputProps } = props, other = (0, $4b23e67a53a2b954$export$2e2bcd8739ae039)(props, $6eda6d630144b2bc$var$_excluded);
    const { disabled: disabled, expanded: expanded, selected: selected, focused: focused, editing: editing, editable: editable, disableSelection: disableSelection, checkboxSelection: checkboxSelection, handleExpansion: handleExpansion, handleSelection: handleSelection, handleCheckboxSelection: handleCheckboxSelection, handleContentClick: handleContentClick, preventSelection: preventSelection, expansionTrigger: expansionTrigger, toggleItemEditing: toggleItemEditing } = (0, $98053d271e52c1c8$export$7d6b3b4a1b5ea514)(itemId);
    const icon = iconProp || expansionIcon || displayIcon;
    const checkboxRef = $h4Bez.useRef(null);
    const handleMouseDown = (event)=>{
        preventSelection(event);
        if (onMouseDown) onMouseDown(event);
    };
    const handleClick = (event)=>{
        handleContentClick?.(event, itemId);
        if (checkboxRef.current?.contains(event.target)) return;
        if (expansionTrigger === 'content') handleExpansion(event);
        if (!checkboxSelection) handleSelection(event);
        if (onClick) onClick(event);
    };
    // If we click on the expansion icon and expansionTrigger is "iconContainer", we expand or collapse the tree item.
    const handleIconClick = expansionIcon != null && icon === expansionIcon && expansionTrigger === 'iconContainer' ? (event)=>{
        if (expansionIcon != null && icon === expansionIcon && expansionTrigger === 'iconContainer') handleExpansion(event);
    } : undefined;
    const handleLabelDoubleClick = (event)=>{
        if (event.defaultMuiPrevented) return;
        toggleItemEditing();
    };
    return /*#__PURE__*/ /* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Key event is handled by the TreeView */ (0, $2e41620b030ed79e$exports.jsxs)("div", (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, other, {
        className: (0, $2e68cc75bf086487$export$2e2bcd8739ae039)(classes.root, className, expanded && classes.expanded, selected && classes.selected, focused && classes.focused, disabled && classes.disabled, editing && classes.editing, editable && classes.editable),
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("div", {
                className: classes.iconContainer,
                onClick: handleIconClick,
                children: icon
            }),
            checkboxSelection && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $96d9ff0232abe8ca$export$2e2bcd8739ae039), {
                className: classes.checkbox,
                checked: selected,
                onChange: handleCheckboxSelection,
                disabled: disabled || disableSelection,
                ref: checkboxRef,
                tabIndex: -1
            }),
            editing ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f50e6f8f293babeb$export$a8935372dfdf5419), (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, labelInputProps, {
                className: classes.labelInput
            })) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("div", (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({
                className: classes.label
            }, editable && {
                onDoubleClick: handleLabelDoubleClick
            }, {
                children: label
            })),
            dragAndDropOverlayProps && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8609dbc019b34ba9$export$2cc9891a3e76ffb), (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, dragAndDropOverlayProps))
        ]
    }));
});




function $cac32f1a72939870$export$e06936b9af6d8f5b(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiTreeItem', slot);
}
const $cac32f1a72939870$export$1970fed62f74ee8d = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiTreeItem', [
    'root',
    'groupTransition',
    'content',
    'expanded',
    'selected',
    'focused',
    'disabled',
    'iconContainer',
    'label',
    'checkbox',
    'labelInput',
    'editable',
    'editing',
    'dragAndDropOverlay'
]);




parcelRequire("h4Bez");

const $5954af0b638ea7f3$export$6ea1314a242e98ca = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'TreeViewExpandIcon');
const $5954af0b638ea7f3$export$679a3c8913aa44c9 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'TreeViewCollapseIcon');




function $8740a6d70ffa4df9$export$b78e3b1e0c6ff1f(props) {
    const { children: children, itemId: itemId } = props;
    const { wrapItem: wrapItem, instance: instance } = (0, $297963f7a5ee1b8a$export$8a6a3e88e8e060e0)();
    return wrapItem({
        children: children,
        itemId: itemId,
        instance: instance
    });
}
$8740a6d70ffa4df9$export$b78e3b1e0c6ff1f.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    children: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).node,
    itemId: (0, (/*@__PURE__*/$parcel$interopDefault($297072211b4ec977$exports))).string.isRequired
};







'use client';
const $f8dd22fe5aadd407$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "ContentComponent",
    "ContentProps",
    "itemId",
    "id",
    "label",
    "onClick",
    "onMouseDown",
    "onFocus",
    "onBlur",
    "onKeyDown"
], $f8dd22fe5aadd407$var$_excluded2 = [
    "ownerState"
], $f8dd22fe5aadd407$var$_excluded3 = [
    "ownerState"
], $f8dd22fe5aadd407$var$_excluded4 = [
    "ownerState"
];
const $f8dd22fe5aadd407$var$useThemeProps = (0, $c706d228957b23f0$export$ff8356348e0cc878)('MuiTreeItem');
const $f8dd22fe5aadd407$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        content: [
            'content'
        ],
        expanded: [
            'expanded'
        ],
        selected: [
            'selected'
        ],
        focused: [
            'focused'
        ],
        disabled: [
            'disabled'
        ],
        iconContainer: [
            'iconContainer'
        ],
        checkbox: [
            'checkbox'
        ],
        label: [
            'label'
        ],
        labelInput: [
            'labelInput'
        ],
        editing: [
            'editing'
        ],
        editable: [
            'editable'
        ],
        groupTransition: [
            'groupTransition'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $cac32f1a72939870$export$e06936b9af6d8f5b), classes);
};
const $f8dd22fe5aadd407$var$TreeItemRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('li', {
    name: 'MuiTreeItem',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    outline: 0
});
const $f8dd22fe5aadd407$var$StyledTreeItemContent = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $6eda6d630144b2bc$export$4b687e3f663d618c), {
    name: 'MuiTreeItem',
    slot: 'Content',
    overridesResolver: (props, styles)=>{
        return [
            styles.content,
            styles.iconContainer && {
                [`& .${(0, $cac32f1a72939870$export$1970fed62f74ee8d).iconContainer}`]: styles.iconContainer
            },
            styles.label && {
                [`& .${(0, $cac32f1a72939870$export$1970fed62f74ee8d).label}`]: styles.label
            }
        ];
    },
    shouldForwardProp: (prop)=>(0, $323d09b5b142c3c9$export$3ba67b570e26eea0)(prop) && prop !== 'indentationAtItemLevel'
})(({ theme: theme })=>({
        padding: theme.spacing(0.5, 1),
        borderRadius: theme.shape.borderRadius,
        width: '100%',
        boxSizing: 'border-box',
        // prevent width + padding to overflow
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        cursor: 'pointer',
        WebkitTapHighlightColor: 'transparent',
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $cac32f1a72939870$export$1970fed62f74ee8d).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            backgroundColor: 'transparent'
        },
        [`&.${(0, $cac32f1a72939870$export$1970fed62f74ee8d).focused}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $cac32f1a72939870$export$1970fed62f74ee8d).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $3289d56f59a873c2$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $3289d56f59a873c2$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $3289d56f59a873c2$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
                }
            },
            [`&.${(0, $cac32f1a72939870$export$1970fed62f74ee8d).focused}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $3289d56f59a873c2$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`& .${(0, $cac32f1a72939870$export$1970fed62f74ee8d).iconContainer}`]: {
            width: 16,
            display: 'flex',
            flexShrink: 0,
            justifyContent: 'center',
            '& svg': {
                fontSize: 18
            }
        },
        [`& .${(0, $cac32f1a72939870$export$1970fed62f74ee8d).label}`]: (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({
            width: '100%',
            boxSizing: 'border-box',
            // prevent width + padding to overflow
            // fixes overflow - see https://github.com/mui/material-ui/issues/27372
            minWidth: 0,
            position: 'relative'
        }, theme.typography.body1),
        [`& .${(0, $cac32f1a72939870$export$1970fed62f74ee8d).checkbox}`]: {
            padding: 0
        },
        variants: [
            {
                props: {
                    indentationAtItemLevel: true
                },
                style: {
                    paddingLeft: `calc(${theme.spacing(1)} + var(--TreeView-itemChildrenIndentation) * var(--TreeView-itemDepth))`
                }
            }
        ]
    }));
const $f8dd22fe5aadd407$var$TreeItemGroup = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)((0, $7830414f6fe32da6$export$2e2bcd8739ae039), {
    name: 'MuiTreeItem',
    slot: 'GroupTransition',
    overridesResolver: (props, styles)=>styles.groupTransition,
    shouldForwardProp: (prop)=>(0, $323d09b5b142c3c9$export$3ba67b570e26eea0)(prop) && prop !== 'indentationAtItemLevel'
})({
    margin: 0,
    padding: 0,
    paddingLeft: 'var(--TreeView-itemChildrenIndentation)',
    variants: [
        {
            props: {
                indentationAtItemLevel: true
            },
            style: {
                paddingLeft: 0
            }
        }
    ]
});
const $f8dd22fe5aadd407$export$53d36ab85dc89436 = /*#__PURE__*/ $h4Bez.forwardRef(function TreeItem(inProps, inRef) {
    const { icons: contextIcons, runItemPlugins: runItemPlugins, items: { disabledItemsFocusable: disabledItemsFocusable, indentationAtItemLevel: indentationAtItemLevel }, selection: { disableSelection: disableSelection }, treeId: treeId, instance: instance } = (0, $297963f7a5ee1b8a$export$8a6a3e88e8e060e0)();
    const depthContext = $h4Bez.useContext((0, $593075cc412db2a8$export$8634277a87653494));
    const props = $f8dd22fe5aadd407$var$useThemeProps({
        props: inProps,
        name: 'MuiTreeItem'
    });
    const { children: children, className: className, slots: inSlots, slotProps: inSlotProps, ContentComponent: ContentComponent = (0, $6eda6d630144b2bc$export$4b687e3f663d618c), ContentProps: ContentProps, itemId: itemId, id: id, label: label, onClick: onClick, onMouseDown: onMouseDown, onBlur: onBlur, onKeyDown: onKeyDown } = props, other = (0, $4b23e67a53a2b954$export$2e2bcd8739ae039)(props, $f8dd22fe5aadd407$var$_excluded);
    const { expanded: expanded, focused: focused, selected: selected, disabled: disabled, editing: editing, handleCancelItemLabelEditing: handleCancelItemLabelEditing, handleSaveItemLabel: handleSaveItemLabel } = (0, $98053d271e52c1c8$export$7d6b3b4a1b5ea514)(itemId);
    const { contentRef: contentRef, rootRef: rootRef, propsEnhancers: propsEnhancers } = runItemPlugins(props);
    const rootRefObject = $h4Bez.useRef(null);
    const contentRefObject = $h4Bez.useRef(null);
    const handleRootRef = (0, $4fa58c431bc87919$export$2e2bcd8739ae039)(inRef, rootRef, rootRefObject);
    const handleContentRef = (0, $4fa58c431bc87919$export$2e2bcd8739ae039)(ContentProps?.ref, contentRef, contentRefObject);
    const slots = {
        expandIcon: inSlots?.expandIcon ?? contextIcons.slots.expandIcon ?? (0, $5954af0b638ea7f3$export$6ea1314a242e98ca),
        collapseIcon: inSlots?.collapseIcon ?? contextIcons.slots.collapseIcon ?? (0, $5954af0b638ea7f3$export$679a3c8913aa44c9),
        endIcon: inSlots?.endIcon ?? contextIcons.slots.endIcon,
        icon: inSlots?.icon,
        groupTransition: inSlots?.groupTransition
    };
    const isExpandable = (reactChildren)=>{
        if (Array.isArray(reactChildren)) return reactChildren.length > 0 && reactChildren.some(isExpandable);
        return Boolean(reactChildren);
    };
    const expandable = isExpandable(children);
    const ownerState = (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, props, {
        expanded: expanded,
        focused: focused,
        selected: selected,
        disabled: disabled,
        indentationAtItemLevel: indentationAtItemLevel
    });
    const classes = $f8dd22fe5aadd407$var$useUtilityClasses(ownerState);
    const GroupTransition = slots.groupTransition ?? undefined;
    const groupTransitionProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: GroupTransition,
        ownerState: {},
        externalSlotProps: inSlotProps?.groupTransition,
        additionalProps: (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({
            unmountOnExit: true,
            in: expanded,
            component: 'ul',
            role: 'group'
        }, indentationAtItemLevel ? {
            indentationAtItemLevel: true
        } : {}),
        className: classes.groupTransition
    });
    const ExpansionIcon = expanded ? slots.collapseIcon : slots.expandIcon;
    const _useSlotProps = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: ExpansionIcon,
        ownerState: {},
        externalSlotProps: (tempOwnerState)=>{
            if (expanded) return (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, (0, $aec1308c8f28d758$export$2e2bcd8739ae039)(contextIcons.slotProps.collapseIcon, tempOwnerState), (0, $aec1308c8f28d758$export$2e2bcd8739ae039)(inSlotProps?.collapseIcon, tempOwnerState));
            return (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, (0, $aec1308c8f28d758$export$2e2bcd8739ae039)(contextIcons.slotProps.expandIcon, tempOwnerState), (0, $aec1308c8f28d758$export$2e2bcd8739ae039)(inSlotProps?.expandIcon, tempOwnerState));
        }
    }), expansionIconProps = (0, $4b23e67a53a2b954$export$2e2bcd8739ae039)(_useSlotProps, $f8dd22fe5aadd407$var$_excluded2);
    const expansionIcon = expandable && !!ExpansionIcon ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(ExpansionIcon, (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, expansionIconProps)) : null;
    const DisplayIcon = expandable ? undefined : slots.endIcon;
    const _useSlotProps2 = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: DisplayIcon,
        ownerState: {},
        externalSlotProps: (tempOwnerState)=>{
            if (expandable) return {};
            return (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, (0, $aec1308c8f28d758$export$2e2bcd8739ae039)(contextIcons.slotProps.endIcon, tempOwnerState), (0, $aec1308c8f28d758$export$2e2bcd8739ae039)(inSlotProps?.endIcon, tempOwnerState));
        }
    }), displayIconProps = (0, $4b23e67a53a2b954$export$2e2bcd8739ae039)(_useSlotProps2, $f8dd22fe5aadd407$var$_excluded3);
    const displayIcon = DisplayIcon ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(DisplayIcon, (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, displayIconProps)) : null;
    const Icon = slots.icon;
    const _useSlotProps3 = (0, $538d4bbadaa2ab59$export$2e2bcd8739ae039)({
        elementType: Icon,
        ownerState: {},
        externalSlotProps: inSlotProps?.icon
    }), iconProps = (0, $4b23e67a53a2b954$export$2e2bcd8739ae039)(_useSlotProps3, $f8dd22fe5aadd407$var$_excluded4);
    const icon = Icon ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Icon, (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, iconProps)) : null;
    // https://www.w3.org/WAI/ARIA/apg/patterns/treeview/
    let ariaSelected;
    if (selected) // - each selected node has aria-selected set to true.
    ariaSelected = true;
    else if (disableSelection || disabled) // - if the tree contains nodes that are not selectable, aria-selected is not present on those nodes.
    ariaSelected = undefined;
    else // - all nodes that are selectable but not selected have aria-selected set to false.
    ariaSelected = false;
    function handleFocus(event) {
        const canBeFocused = !disabled || disabledItemsFocusable;
        if (!focused && canBeFocused && event.currentTarget === event.target) instance.focusItem(event, itemId);
    }
    function handleBlur(event) {
        onBlur?.(event);
        if (editing || // we can exit the editing state by clicking outside the input (within the Tree Item) or by pressing Enter or Escape -> we don't want to remove the focused item from the state in these cases
        // we can also exit the editing state by clicking on the root itself -> want to remove the focused item from the state in this case
        event.relatedTarget && (0, $a34ea5d243eb1c04$export$10ed5614bef54e9f)(event.relatedTarget, rootRefObject.current) && (event.target && event.target?.dataset?.element === 'labelInput' && (0, $a34ea5d243eb1c04$export$10ed5614bef54e9f)(event.target, rootRefObject.current) || event.relatedTarget?.dataset?.element === 'labelInput')) return;
        instance.removeFocusedItem();
    }
    const handleKeyDown = (event)=>{
        onKeyDown?.(event);
        if (event.target?.dataset?.element === 'labelInput') return;
        instance.handleItemKeyDown(event, itemId);
    };
    const idAttribute = (0, $aaffed941a94ef7c$export$6ce5f925ac04fad)({
        itemId: itemId,
        treeId: treeId,
        id: id
    });
    const tabIndex = instance.canItemBeTabbed(itemId) ? 0 : -1;
    const sharedPropsEnhancerParams = {
        rootRefObject: rootRefObject,
        contentRefObject: contentRefObject,
        interactions: {
            handleSaveItemLabel: handleSaveItemLabel,
            handleCancelItemLabelEditing: handleCancelItemLabelEditing
        }
    };
    const enhancedRootProps = propsEnhancers.root?.((0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, sharedPropsEnhancerParams, {
        externalEventHandlers: (0, $6f1a7dc79a4af46c$export$2e2bcd8739ae039)(other)
    })) ?? {};
    const enhancedContentProps = propsEnhancers.content?.((0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, sharedPropsEnhancerParams, {
        externalEventHandlers: (0, $6f1a7dc79a4af46c$export$2e2bcd8739ae039)(ContentProps)
    })) ?? {};
    const enhancedDragAndDropOverlayProps = propsEnhancers.dragAndDropOverlay?.((0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, sharedPropsEnhancerParams, {
        externalEventHandlers: {}
    })) ?? {};
    const enhancedLabelInputProps = propsEnhancers.labelInput?.((0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, sharedPropsEnhancerParams, {
        externalEventHandlers: {}
    })) ?? {};
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8740a6d70ffa4df9$export$b78e3b1e0c6ff1f), {
        itemId: itemId,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($f8dd22fe5aadd407$var$TreeItemRoot, (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({
            className: (0, $2e68cc75bf086487$export$2e2bcd8739ae039)(classes.root, className),
            role: "treeitem",
            "aria-expanded": expandable ? expanded : undefined,
            "aria-selected": ariaSelected,
            "aria-disabled": disabled || undefined,
            id: idAttribute,
            tabIndex: tabIndex
        }, other, {
            ownerState: ownerState,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            ref: handleRootRef,
            style: indentationAtItemLevel ? (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({}, other.style, {
                '--TreeView-itemDepth': typeof depthContext === 'function' ? depthContext(itemId) : depthContext
            }) : other.style
        }, enhancedRootProps, {
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($f8dd22fe5aadd407$var$StyledTreeItemContent, (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({
                    as: ContentComponent,
                    classes: {
                        root: classes.content,
                        expanded: classes.expanded,
                        selected: classes.selected,
                        focused: classes.focused,
                        disabled: classes.disabled,
                        editable: classes.editable,
                        editing: classes.editing,
                        iconContainer: classes.iconContainer,
                        label: classes.label,
                        labelInput: classes.labelInput,
                        checkbox: classes.checkbox
                    },
                    label: label,
                    itemId: itemId,
                    onClick: onClick,
                    onMouseDown: onMouseDown,
                    icon: icon,
                    expansionIcon: expansionIcon,
                    displayIcon: displayIcon,
                    ownerState: ownerState
                }, ContentProps, enhancedContentProps, enhancedDragAndDropOverlayProps.action == null ? {} : {
                    dragAndDropOverlayProps: enhancedDragAndDropOverlayProps
                }, enhancedLabelInputProps.value == null ? {} : {
                    labelInputProps: enhancedLabelInputProps
                }, {
                    ref: handleContentRef
                })),
                children && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($f8dd22fe5aadd407$var$TreeItemGroup, (0, $db9d35cbfb6cf715$export$2e2bcd8739ae039)({
                    as: GroupTransition
                }, groupTransitionProps, {
                    children: children
                }))
            ]
        }))
    });
});




"use client";
var $597901dca6087db0$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRight');












var $h4Bez = parcelRequire("h4Bez");




const $a25d1770563c0ccd$export$c3639e97caabff2c = ({ nextPageSize: count, onClick: onClick, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
        variant: "body2",
        align: "center",
        onClick: onClick,
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
            className: "explorer-pagination-button",
            variant: "primaryGhost",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SHOW_MORE,
                values: {
                    count: count
                }
            })
        })
    });
const $a25d1770563c0ccd$export$f80c710216eae131 = (list, pageSize)=>{
    const [limited, setLimited] = (0, $h4Bez.useState)(1);
    const totalSize = limited * pageSize;
    const nextPage = Math.min((limited + 1) * pageSize, list.length) - totalSize;
    return [
        list.slice(0, totalSize),
        nextPage > 0 ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($a25d1770563c0ccd$export$c3639e97caabff2c, {
            nextPageSize: nextPage,
            onClick: ()=>setLimited((limited)=>++limited)
        }) : null
    ];
};



parcelRequire("h4Bez");




const $bfe22c727959f120$export$9929d7d036421e24 = ({ fullPath: fullPath })=>{
    const manage = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('explorerTopicManagementUsecase');
    const errors = (0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>(0, $070c3c2fc0eda22c$export$a944664ab6756ac5)(s, fullPath), (0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6), [
        fullPath
    ]);
    if (!(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(errors)) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d36390f84a2ea7c3$export$79f270ed0b847a48), {
        "data-testid": fullPath,
        topics: [
            fullPath
        ],
        errors: new Set(errors),
        onRetry: ()=>manage.retryTopic(fullPath),
        onUnsub: ()=>manage.toggleTopics([
                fullPath
            ])
    });
};


const $cc44521138884a97$var$selectCanReadTopicsMetadata = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).TOPIC_CHUNKS_READ);
const $cc44521138884a97$var$useAddTopicsChunk = ()=>{
    const droppable = (0, $413f2a7a2fb550d0$export$ddc16e8131368fb8)();
    const loadUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('explorerChunksUsecase');
    const canReadDeviations = (0, $be523f14267dcd17$export$9973955de2bf96cf)($cc44521138884a97$var$selectCanReadTopicsMetadata);
    return canReadDeviations ? (fullPath)=>loadUsecase.load(fullPath, droppable) : null;
};
/**
 * This deals with topics with a name that is too long
 */ const $cc44521138884a97$var$wrapperStyle = {
    width: '100%',
    display: 'flex',
    alignItems: 'center'
};
const $cc44521138884a97$var$labelStyle = {
    minWidth: 'calc(100% - 54px)',
    maxWidth: 0,
    textOverflow: 'ellipsis',
    overflowX: 'hidden',
    whiteSpace: 'nowrap',
    color: 'text.primary',
    fontSize: 'body2.fontSize',
    lineHeight: '1.5rem'
};
const $cc44521138884a97$var$actionsWrapperStyle = {
    width: '100%'
};
const $cc44521138884a97$var$actionsStyle = {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    [`& > .${(0, $bef56d69afec4a03$export$2e2bcd8739ae039).root}`]: {
        p: 0
    }
};
const $cc44521138884a97$var$treeItemStyle = {
    [`& .${(0, $cac32f1a72939870$export$1970fed62f74ee8d).content}`]: {
        py: 0,
        borderRadius: 0
    }
};
const $cc44521138884a97$var$stopPropagation = (0, $1fdb53e1bec07519$export$5532d7f774835bb3)();
const $cc44521138884a97$var$Label = /*#__PURE__*/ (0, $h4Bez.memo)(({ fullPath: fullPath, name: name, valid: valid, selected: selected, custom: custom })=>{
    const manage = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('explorerTopicManagementUsecase');
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $cc44521138884a97$var$wrapperStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f1635ddd0790fd36$export$2e2bcd8739ae039), {
                sx: $cc44521138884a97$var$labelStyle,
                title: valid ? fullPath : translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).INVALID_TOPIC),
                disabled: !valid,
                children: name
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $cc44521138884a97$var$actionsWrapperStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: $cc44521138884a97$var$actionsStyle,
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bfe22c727959f120$export$9929d7d036421e24), {
                            fullPath: fullPath
                        }),
                        custom && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $06e9db9e3c921f60$export$2e2bcd8739ae039), {
                            color: "action",
                            className: "remove-custom-topic-icon",
                            fontSize: "medium",
                            onClick: (0, $1fdb53e1bec07519$export$5532d7f774835bb3)(()=>manage.removeCustomTopic(fullPath))
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2d1d930894f85d66$export$48513f6b9f8ce62d), {
                            title: fullPath,
                            disabled: !valid,
                            checked: selected,
                            size: "small",
                            onChange: ()=>manage.toggleTopics([
                                    fullPath
                                ]),
                            onClick: $cc44521138884a97$var$stopPropagation
                        })
                    ]
                })
            })
        ]
    });
}, (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
    fullPath: null,
    name: null,
    valid: null,
    selected: null,
    custom: null
}));
const $cc44521138884a97$var$Tree = /*#__PURE__*/ (0, $h4Bez.memo)(({ tree: { children: children, isLoadingSibling: isLoadingSibling, loadingSiblingError: loadingSiblingError, fullPath: fullPath, name: name, selected: selected, valid: valid, custom: custom, nextPageSize: nextPageSize, hasChildrenToLoad: hasChildrenToLoad } })=>{
    const addTopicsChunk = $cc44521138884a97$var$useAddTopicsChunk();
    const childTrees = [
        ...children.map((tree, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($cc44521138884a97$var$Tree, {
                tree: tree
            }, k))
    ];
    if (isLoadingSibling) childTrees.push(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $35e2f7ba0c5bb8e5$export$8b8493c40023057), {
        "data-testid": "topic-chunks-loader",
        size: "1rem",
        margin: "small"
    }, "loader"));
    if (loadingSiblingError) childTrees.push(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
        "data-testid": "topic-chunks-error",
        titleVariant: "body2",
        error: loadingSiblingError
    }, "error"));
    if (nextPageSize !== null && addTopicsChunk !== null) childTrees.push(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a25d1770563c0ccd$export$c3639e97caabff2c), {
        "data-testid": "topic-chunks-next-page",
        nextPageSize: nextPageSize,
        onClick: ()=>addTopicsChunk(fullPath)
    }, "addNext"));
    if (!childTrees.length && hasChildrenToLoad) /**
             * Just add a fake child, so the node becomes expandable if it can load children
             */ childTrees.push(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $h4Bez.Fragment), {}, "stub"));
    if (name === null || fullPath === null) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
        children: childTrees
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f8dd22fe5aadd407$export$53d36ab85dc89436), {
        "data-testid": fullPath,
        itemId: fullPath,
        title: name,
        label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($cc44521138884a97$var$Label, {
            name: name,
            fullPath: fullPath,
            valid: valid,
            selected: selected,
            custom: custom
        }),
        sx: $cc44521138884a97$var$treeItemStyle,
        children: childTrees
    });
}, (a, b)=>(0, $e7e4681c51bba9d2$export$a3ec7e7a39bb7dca)(a.tree, b.tree));
/**
 * Utility hook to help figure out what topic was just expanded
 */ const $cc44521138884a97$var$useTopicsList = ()=>{
    const visibleNodesRef = (0, $h4Bez.useRef)([]);
    return (update)=>{
        const [, , [lastAdded = null]] = (0, $9bfc602ec92faf4d$export$eabbe41f409ce55b)(visibleNodesRef.current, update);
        visibleNodesRef.current = update;
        return lastAdded;
    };
};
const $cc44521138884a97$export$9609655146145722 = ()=>{
    const allChunks = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $070c3c2fc0eda22c$export$580f92cfd492a3f6));
    const custom = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $070c3c2fc0eda22c$export$f470b43d5107165e));
    const selected = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $070c3c2fc0eda22c$export$9638cf3323a42fde));
    const available = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $070c3c2fc0eda22c$export$e05723afac562ff0));
    const chunksUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('explorerChunksUsecase');
    const rootTopic = (0, $h4Bez.useMemo)(()=>chunksUsecase.createRootTopic(), [
        chunksUsecase
    ]);
    const tree = (0, $h4Bez.useMemo)(()=>(0, $e7e4681c51bba9d2$export$8f4a36ff79636a0b)(rootTopic, selected, custom, allChunks), [
        rootTopic,
        selected,
        custom,
        allChunks
    ]);
    const updateExpanded = $cc44521138884a97$var$useTopicsList();
    const prefixes = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $070c3c2fc0eda22c$export$18a4d36a25eb0ba4));
    const addTopicsChunk = $cc44521138884a97$var$useAddTopicsChunk();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $1e4b715c494d4376$export$d8982212e1ac7e50), {
        "data-testid": "availableTopicsTree",
        slots: {
            collapseIcon: ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f0c56636e9fb6837$export$2e2bcd8739ae039), {
                    className: "collapseTree"
                }),
            expandIcon: ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $597901dca6087db0$export$2e2bcd8739ae039), {
                    className: "expandTree"
                })
        },
        onExpandedItemsChange: (_, nodeIds)=>{
            const lastAdded = updateExpanded(nodeIds);
            /**
                 * - Has permissions to add chunks
                 * - Node has been added
                 * - Prefix has not been added before
                 * - And it can load children
                 *
                 * Then add another chunk
                 */ if (addTopicsChunk && lastAdded && !prefixes.includes(lastAdded) && (0, $e7e4681c51bba9d2$export$cc23af0783e021c3)(tree, lastAdded)?.hasChildrenToLoad) addTopicsChunk(lastAdded);
        },
        children: [
            !available && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_TOPICS_AVAILABLE
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($cc44521138884a97$var$Tree, {
                tree: tree
            })
        ]
    });
};


const $071edfef2035673f$export$976c10b162a75bb1 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a883b2ca56cdda9a$export$6e2c8f0811a474ce), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).AVAILABLE_TOPICS,
        collapsable: false,
        controls: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0bb6513b74ecca8c$export$d70ad15dfe54df4d), {}),
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $cc44521138884a97$export$9609655146145722), {})
    });





parcelRequire("h4Bez");








parcelRequire("h4Bez");


"use client";
var $3bf8b6a000544bd1$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zm2.46-7.12 1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
}), 'DeleteForever');



"use client";
var $5e37e572272d9d71$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M6 19h4V5H6zm8-14v14h4V5z"
}), 'Pause');



"use client";
var $a086fa2f14f34278$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M8 5v14l11-7z"
}), 'PlayArrow');




const $c9b8d110357173d0$var$baseButtonStyle = {
    my: 'auto',
    mx: 2,
    cursor: 'pointer'
};
const $c9b8d110357173d0$var$playButtonStyle = {
    ...$c9b8d110357173d0$var$baseButtonStyle,
    color: 'green.600'
};
const $c9b8d110357173d0$var$clearButtonStyle = {
    ...$c9b8d110357173d0$var$baseButtonStyle,
    color: 'red.600'
};
const $c9b8d110357173d0$var$pauseButtonStyle = {
    ...$c9b8d110357173d0$var$baseButtonStyle,
    color: 'grey.600'
};
const $c9b8d110357173d0$export$c7c44baae9d9f25f = ()=>{
    const updateExplorerTail = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('updateExplorerTailUsecase');
    const isTailing = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $070c3c2fc0eda22c$export$88a8f23a49d6261e));
    if (isTailing === null) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            isTailing ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5e37e572272d9d71$export$2e2bcd8739ae039), {
                "data-testid": "pauseTailButton",
                sx: $c9b8d110357173d0$var$pauseButtonStyle,
                onClick: ()=>updateExplorerTail.toggleTailing()
            }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a086fa2f14f34278$export$2e2bcd8739ae039), {
                "data-testid": "playTailButton",
                sx: $c9b8d110357173d0$var$playButtonStyle,
                onClick: ()=>updateExplorerTail.toggleTailing()
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $3bf8b6a000544bd1$export$2e2bcd8739ae039), {
                "data-testid": "clearTailButton",
                sx: $c9b8d110357173d0$var$clearButtonStyle,
                onClick: ()=>updateExplorerTail.clearTail()
            })
        ]
    });
};



parcelRequire("h4Bez");



const $b7b5e4ad8eae2a76$var$headerStyle = {
    pt: 1,
    pb: 2
};
const $b7b5e4ad8eae2a76$export$8b251419efc915eb = ()=>{
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        sx: $b7b5e4ad8eae2a76$var$headerStyle,
        container: true,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                size: {
                    xs: 2
                },
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    variant: "body1",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TIME
                    })
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                size: {
                    xs: 5
                },
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    variant: "body1",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TOPIC,
                        values: {
                            count: 1
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                size: {
                    xs: 4
                },
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    variant: "body1",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DATA
                    })
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                size: {
                    xs: 1
                },
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    variant: "body1",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TYPE
                    })
                })
            })
        ]
    });
};



parcelRequire("h4Bez");




const $8e135d14a1355a48$var$wrapperStyle = {
    mb: 2,
    py: 1,
    px: 0,
    '& > * > :first-of-type': {
        pl: 2
    },
    '& > * > :last-of-type': {
        pr: 2
    }
};
const $8e135d14a1355a48$var$longTextStyle = {
    overflowX: 'hidden',
    pr: 2,
    display: 'flex',
    alignItems: 'center'
};
const $8e135d14a1355a48$var$verticalAlignedStyle = {
    display: 'flex',
    alignItems: 'center'
};
const $8e135d14a1355a48$export$a04a2d26dbb06c4 = ({ topic: topic, timestamp: timestamp, payload: payload, selectedType: selectedType })=>{
    const translate = (0, $e6cc39abef12fe2c$export$7b34e01a92f12324)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
        sx: $8e135d14a1355a48$var$wrapperStyle,
        variant: "outlined",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
            container: true,
            sx: $8e135d14a1355a48$var$verticalAlignedStyle,
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                    size: {
                        xs: 2
                    },
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$d275c5eeba29af75), {
                            date: timestamp,
                            format: "datetime"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                    size: {
                        xs: 5
                    },
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        sx: $8e135d14a1355a48$var$longTextStyle,
                        title: topic,
                        variant: "body1",
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$f51edccf37a41a2a), {
                            children: topic
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                    size: {
                        xs: 4
                    },
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d700fad781a6ea93$export$bc337bf4c402f8eb), {
                        sx: [
                            selectedType === (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).OBJECT ? {} : $8e135d14a1355a48$var$longTextStyle
                        ],
                        buffer: payload,
                        type: selectedType
                    })
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                    size: {
                        xs: 1
                    },
                    children: translate(selectedType)
                })
            ]
        })
    });
};



parcelRequire("h4Bez");





const $ec9570b77638bff9$var$titleStyle = {
    my: 'auto',
    mx: 2,
    lineHeight: 3
};
const $ec9570b77638bff9$var$fieldStyle = {
    width: 80,
    justifyContent: 'center'
};
const $ec9570b77638bff9$export$85376872214cd8e9 = ()=>{
    const tailSize = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $070c3c2fc0eda22c$export$c992ab88b8f649d));
    const updateTail = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('updateExplorerTailUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                sx: $ec9570b77638bff9$var$titleStyle,
                variant: "body1",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NUMBER_OF_ENTRIES
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d887fad28e7ec96c$export$2c73285ae9390cec), {
                "data-testid": "topicsTailSize",
                sx: $ec9570b77638bff9$var$fieldStyle,
                type: "number",
                value: tailSize,
                onChange: ({ target: { value: value } })=>updateTail.updateTailSize(Math.round(Number(value)))
            })
        ]
    });
};


const $b3a4fc2076ddf22a$var$Content = ()=>{
    const tail = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $070c3c2fc0eda22c$export$35fea1eb720660ae));
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $837dcb3f32a07e41$export$7419ff430885d61c), {
        delay: 300,
        children: (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(tail) ? tail.map((line, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8e135d14a1355a48$export$a04a2d26dbb06c4), {
                ...line
            }, k)) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
            variant: "body2",
            align: "center",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_MESSAGES
            })
        })
    });
};
const $b3a4fc2076ddf22a$export$84202caead5689ba = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $a883b2ca56cdda9a$export$6e2c8f0811a474ce), {
        "data-testid": "topicsHistory",
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).HISTORY,
        controls: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c9b8d110357173d0$export$c7c44baae9d9f25f), {}),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ec9570b77638bff9$export$85376872214cd8e9), {})
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b7b5e4ad8eae2a76$export$8b251419efc915eb), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                "data-testid": "topicsTail",
                size: {
                    xs: 12
                },
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b3a4fc2076ddf22a$var$Content, {})
            })
        ]
    });





parcelRequire("h4Bez");







parcelRequire("h4Bez");



const $24e503d01104c413$var$headerStyle = {
    pt: 1,
    pb: 2
};
const $24e503d01104c413$export$2f4a7be4f0dcc2 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: true,
        sx: $24e503d01104c413$var$headerStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                size: {
                    xs: 5
                },
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    variant: "body1",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TOPIC,
                        values: {
                            count: 0
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                size: {
                    xs: 7
                },
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    variant: "body1",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DATA
                    })
                })
            })
        ]
    });



parcelRequire("h4Bez");








const $a15fef9d64565e42$var$topicValueStyle = {
    '& > :first-of-type': {
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        pr: 2
    }
};
const $a15fef9d64565e42$var$Display = ({ topic: topic })=>{
    const formatting = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('explorerTopicsFormattingUsecase');
    const message = (0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>(0, $070c3c2fc0eda22c$export$d8794ef1e9f50e36)(s, topic), [
        topic
    ]);
    if (message === null) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_MESSAGES
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0ef57b6c25dc3e6b$export$76748c987176663a), {
        sx: $a15fef9d64565e42$var$topicValueStyle,
        className: `topic-payload-${message.selectedType.toLowerCase()}`,
        fullWidth: true,
        buffer: message.payload,
        types: message.possibleTypes,
        onChange: (type)=>formatting.selectLatestValueType(topic, type)
    });
};
const $a15fef9d64565e42$var$Unsub = ({ topic: topic })=>{
    const manage = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('explorerTopicManagementUsecase');
    const topicsToUnsub = (0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>(0, $070c3c2fc0eda22c$export$af9234b6c8bd1d81)(s, topic), [
        topic
    ], (0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6));
    return (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(topicsToUnsub) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
        className: "topic-unsub-button",
        variant: "secondary",
        size: "small",
        onClick: ()=>manage.toggleTopics(topicsToUnsub),
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).UNSUBSCRIBE
        })
    }) : null;
};
/** Wide enough for the widest topic action, the "Unsubscribe" button */ const $a15fef9d64565e42$var$TOPIC_ACTION_MAX_WIDTH = 96;
const $a15fef9d64565e42$var$noMessagesStyle = {
    p: 2
};
const $a15fef9d64565e42$var$wrapperStyle = {
    mb: 2,
    py: 1,
    px: 0
};
const $a15fef9d64565e42$var$valueWrapperStyle = {
    pr: 2,
    my: 'auto'
};
const $a15fef9d64565e42$var$topicWrapperStyle = {
    display: 'flex',
    my: 'auto',
    px: 2,
    '& > *': {
        my: 'auto'
    },
    [`& > *:not(.${(0, $f9ef756b8f6a1b37$export$2e2bcd8739ae039).root})`]: {
        maxWidth: 0,
        opacity: 0,
        overflow: 'hidden',
        transition: ({ transitions: { easing: easing } })=>[
                'max-width',
                'opacity'
            ].map((p)=>`${p} 100ms ${easing.easeInOut}`).join(', ')
    },
    [`&:hover > *:not(.${(0, $f9ef756b8f6a1b37$export$2e2bcd8739ae039).root}), &:focus-within > *:not(.${(0, $f9ef756b8f6a1b37$export$2e2bcd8739ae039).root})`]: {
        maxWidth: `${$a15fef9d64565e42$var$TOPIC_ACTION_MAX_WIDTH}px`,
        opacity: 1,
        overflow: 'initial'
    }
};
const $a15fef9d64565e42$var$topicStyle = {
    overflowX: 'hidden',
    mr: 'auto',
    display: 'flex',
    alignItems: 'center'
};
const $a15fef9d64565e42$var$topicActionStyle = {
    pl: 1
};
const $a15fef9d64565e42$export$16e6bfe2da06dee5 = ({ topics: topics })=>{
    /**
     * Why was this magical number chosen? Vibes
     */ const [loaded, button] = (0, $a25d1770563c0ccd$export$f80c710216eae131)(topics, 25);
    if (!(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(loaded)) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
        sx: $a15fef9d64565e42$var$noMessagesStyle,
        className: "no-messages",
        variant: "body2",
        align: "center",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_MESSAGES
        })
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            loaded.map((topic)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
                    sx: $a15fef9d64565e42$var$wrapperStyle,
                    variant: "outlined",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        container: true,
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                                sx: $a15fef9d64565e42$var$topicWrapperStyle,
                                title: topic,
                                size: {
                                    xs: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                                        sx: $a15fef9d64565e42$var$topicStyle,
                                        className: "topic-latest-label",
                                        variant: "body2",
                                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$f51edccf37a41a2a), {
                                            children: topic
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                                        sx: $a15fef9d64565e42$var$topicActionStyle,
                                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($a15fef9d64565e42$var$Unsub, {
                                            topic: topic
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                                        sx: $a15fef9d64565e42$var$topicActionStyle,
                                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1ab636062450c95b$export$92ce62e1201c4fc0), {
                                            children: topic
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                                className: "topic-latest-value",
                                size: {
                                    xs: 7
                                },
                                sx: $a15fef9d64565e42$var$valueWrapperStyle,
                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($a15fef9d64565e42$var$Display, {
                                    topic: topic
                                })
                            })
                        ]
                    })
                }, topic)),
            button
        ]
    });
};


const $89d3421ff4d9b749$var$Content = ()=>{
    const monitoredTopics = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $070c3c2fc0eda22c$export$84942bb2424aed3), (0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6));
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $837dcb3f32a07e41$export$7419ff430885d61c), {
        delay: 300,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a15fef9d64565e42$export$16e6bfe2da06dee5), {
            topics: monitoredTopics
        })
    });
};
const $89d3421ff4d9b749$export$c3d8a3d648569a64 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $a883b2ca56cdda9a$export$6e2c8f0811a474ce), {
        "data-testid": "monitoredTopics",
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MONITORED_TOPICS,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $24e503d01104c413$export$2f4a7be4f0dcc2), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($89d3421ff4d9b749$var$Content, {})
        ]
    });




const $3dbcce4b5c540ccc$var$spacing = 4;
const $3dbcce4b5c540ccc$var$leftColumnStyle = {
    p: $3dbcce4b5c540ccc$var$spacing,
    borderRight: '1px solid',
    borderColor: 'grey.300'
};
const $3dbcce4b5c540ccc$var$monitoredRowStyle = {
    p: $3dbcce4b5c540ccc$var$spacing,
    borderBottom: '1px solid',
    borderColor: 'grey.300'
};
const $3dbcce4b5c540ccc$var$historyRowStyle = {
    p: $3dbcce4b5c540ccc$var$spacing
};
const $3dbcce4b5c540ccc$var$missingReadTopicsPermissionStyle = {
    py: $3dbcce4b5c540ccc$var$spacing
};
const $3dbcce4b5c540ccc$var$linkStyle = {
    color: 'info.main'
};
const $3dbcce4b5c540ccc$var$selectHasPermissionToReadTopicsMetadata = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).TOPIC_CHUNKS_READ);
const $3dbcce4b5c540ccc$export$43584986cb77a794 = ()=>{
    const error = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $070c3c2fc0eda22c$export$dc0906d733d23e62));
    const hasPermissionToReadTopicsMetadata = (0, $be523f14267dcd17$export$9973955de2bf96cf)($3dbcce4b5c540ccc$var$selectHasPermissionToReadTopicsMetadata);
    const startExplorer = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('startExplorerSubscriptionUsecase');
    (0, $h4Bez.useEffect)(()=>startExplorer.invoke(), [
        startExplorer
    ]);
    if (error !== null) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
        "data-testid": "explorer-general-error",
        error: error,
        stack: true,
        extras: "section",
        customTitle: (e)=>(0, $40a99dac858c1d75$export$552cd99e43fa1085)(e.message) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: e.message
            }) : null
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: true,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                size: {
                    xs: 12
                },
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $be3703687194c6e0$export$56e2352e63353d99), {
                    title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DATA_EXPLORER,
                    description: [
                        (0, $40a99dac858c1d75$export$b63289fbda65eed1).DATA_EXPLORER_DOCUMENTATION_TITLE,
                        (0, $40a99dac858c1d75$export$b63289fbda65eed1).DATA_EXPLORER_DOCUMENTATION_BODY
                    ]
                })
            }),
            !hasPermissionToReadTopicsMetadata && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                size: {
                    xs: 12
                },
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: $3dbcce4b5c540ccc$var$missingReadTopicsPermissionStyle,
                    "data-testid": "missing-topics-read-permissions",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TOPICS_METADATA_PERMISSION_MISSING,
                        values: {
                            b: (0, $4772774eee62bdcc$export$582aafb958f7fe50),
                            link: (0, $4772774eee62bdcc$export$18fadbe56dfcb1a1)((0, $7d5f64758ce3b1db$export$bf4bb1ff1ff62959), {
                                path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES,
                                sx: $3dbcce4b5c540ccc$var$linkStyle
                            })
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                size: {
                    xs: 4
                },
                sx: $3dbcce4b5c540ccc$var$leftColumnStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $071edfef2035673f$export$976c10b162a75bb1), {})
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                size: {
                    xs: 8
                },
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                    container: true,
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                            size: {
                                xs: 12
                            },
                            sx: $3dbcce4b5c540ccc$var$monitoredRowStyle,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $89d3421ff4d9b749$export$c3d8a3d648569a64), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                            size: {
                                xs: 12
                            },
                            sx: $3dbcce4b5c540ccc$var$historyRowStyle,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b3a4fc2076ddf22a$export$84202caead5689ba), {})
                        })
                    ]
                })
            })
        ]
    });
};






var $h4Bez = parcelRequire("h4Bez");
var $55d2ce2bf73ae319$exports = {};
/*!
 * jsoneditor.js
 *
 * @brief
 * JSONEditor is a web-based tool to view, edit, format, and validate JSON.
 * It has various modes such as a tree editor, a code editor, and a plain text
 * editor.
 *
 * Supported browsers: Chrome, Firefox, Safari, Opera, Internet Explorer 8+
 *
 * @license
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy
 * of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 *
 * Copyright (c) 2011-2023 Jos de Jong, http://jsoneditoronline.org
 *
 * @author  Jos de Jong, <wjosdejong@gmail.com>
 * @version 9.10.2
 * @date    2023-05-15
 */ !function(e, t) {
    $55d2ce2bf73ae319$exports = t();
}(self, function() {
    var n, o;
    return n = {
        897: function(e, t, n) {
            "use strict";
            n.d(t, {
                x: function() {
                    return r;
                }
            });
            var c = n(2602), h = n(9791), d = n(7907);
            function o(e) {
                return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function i(e, t) {
                for(var n = 0; n < t.length; n++){
                    var i = t[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function(e) {
                        e = function(e, t) {
                            if ("object" !== o(e) || null === e) return e;
                            var n = e[Symbol.toPrimitive];
                            if (void 0 === n) return ("string" === t ? String : Number)(e);
                            n = n.call(e, t || "default");
                            if ("object" !== o(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }(e, "string");
                        return "symbol" === o(e) ? e : String(e);
                    }(i.key), i);
                }
            }
            var r = function() {
                function l(t, e) {
                    if (!(this instanceof l)) throw new TypeError("Cannot call a class as a function");
                    this.dom = {};
                    var h = this, n = this.dom, e = (this.anchor = void 0, this.items = t, this.eventListeners = {}, this.selection = void 0, this.onClose = e ? e.close : void 0, this.limitHeight = !!e && e.limitHeight, document.createElement("div")), i = (e.className = "jsoneditor-contextmenu-root", n.root = e, document.createElement("div")), e = (i.className = "jsoneditor-contextmenu", n.menu = i, e.appendChild(i), document.createElement("ul")), i = (e.className = "jsoneditor-menu", i.appendChild(e), n.list = e, n.items = [], document.createElement("button")), n = (i.type = "button", n.focusButton = i, document.createElement("li"));
                    n.style.overflow = "hidden", n.style.height = "0", n.appendChild(i), e.appendChild(n), function a(l, c, e) {
                        e.forEach(function(t) {
                            var n, e, i, o, r, s;
                            "separator" === t.type ? ((r = document.createElement("div")).className = "jsoneditor-separator", (e = document.createElement("li")).appendChild(r), l.appendChild(e)) : (n = {}, r = document.createElement("li"), l.appendChild(r), (e = document.createElement("button")).type = "button", e.className = t.className, n.button = e, t.title && (e.title = t.title), t.click && (e.onclick = function(e) {
                                e.preventDefault(), h.hide(), t.click();
                            }), r.appendChild(e), t.submenu ? ((o = document.createElement("div")).className = "jsoneditor-icon", e.appendChild(o), (o = document.createElement("div")).className = "jsoneditor-text" + (t.click ? "" : " jsoneditor-right-margin"), o.appendChild(document.createTextNode(t.text)), e.appendChild(o), (i = t.click ? (e.className += " jsoneditor-default", (o = document.createElement("button")).type = "button", (n.buttonExpand = o).className = "jsoneditor-expand", (s = document.createElement("div")).className = "jsoneditor-expand", o.appendChild(s), r.appendChild(o), t.submenuTitle && (o.title = t.submenuTitle), o) : ((s = document.createElement("div")).className = "jsoneditor-expand", e.appendChild(s), e)).onclick = function(e) {
                                e.preventDefault(), h._onExpandItem(n), i.focus();
                            }, n.subItems = o = [], s = document.createElement("ul"), (n.ul = s).className = "jsoneditor-menu", s.style.height = "0", r.appendChild(s), a(s, o, t.submenu)) : ((r = document.createElement("div")).className = "jsoneditor-icon", e.appendChild(r), (s = document.createElement("div")).className = "jsoneditor-text", s.appendChild(document.createTextNode((0, d.Iu)(t.text))), e.appendChild(s)), c.push(n));
                        });
                    }(e, this.dom.items, t), this.maxHeight = 0, t.forEach(function(e) {
                        e = 24 * (t.length + (e.submenu ? e.submenu.length : 0));
                        h.maxHeight = Math.max(h.maxHeight, e);
                    });
                }
                var e, t, n;
                return e = l, t = [
                    {
                        key: "_getVisibleButtons",
                        value: function() {
                            var t = [], n = this;
                            return this.dom.items.forEach(function(e) {
                                t.push(e.button), e.buttonExpand && t.push(e.buttonExpand), e.subItems && e === n.expandedItem && e.subItems.forEach(function(e) {
                                    t.push(e.button), e.buttonExpand && t.push(e.buttonExpand);
                                });
                            }), t;
                        }
                    },
                    {
                        key: "show",
                        value: function(e, t, n) {
                            this.hide();
                            var i = !0, o = e.parentNode, r = e.getBoundingClientRect(), o = o.getBoundingClientRect(), s = t.getBoundingClientRect(), a = this, t = (this.dom.absoluteAnchor = (0, c.w)(e, t, function() {
                                a.hide();
                            }), r.bottom + this.maxHeight < s.bottom || r.top - this.maxHeight > s.top && (i = !1), n ? 0 : r.top - o.top);
                            i ? (n = e.offsetHeight, this.dom.menu.style.left = "0", this.dom.menu.style.top = t + n + "px", this.dom.menu.style.bottom = "") : (this.dom.menu.style.left = "0", this.dom.menu.style.top = "", this.dom.menu.style.bottom = "0px"), this.limitHeight && (o = i ? s.bottom - r.bottom - 10 : r.top - s.top - 10, this.dom.list.style.maxHeight = o + "px", this.dom.list.style.overflowY = "auto"), this.dom.absoluteAnchor.appendChild(this.dom.root), this.selection = (0, h.getSelection)(), this.anchor = e, setTimeout(function() {
                                a.dom.focusButton.focus();
                            }, 0), l.visibleMenu && l.visibleMenu.hide(), l.visibleMenu = this;
                        }
                    },
                    {
                        key: "hide",
                        value: function() {
                            this.dom.absoluteAnchor && (this.dom.absoluteAnchor.destroy(), delete this.dom.absoluteAnchor), this.dom.root.parentNode && (this.dom.root.parentNode.removeChild(this.dom.root), this.onClose) && this.onClose(), l.visibleMenu === this && (l.visibleMenu = void 0);
                        }
                    },
                    {
                        key: "_onExpandItem",
                        value: function(n) {
                            var i, o = this, e = n === this.expandedItem, t = this.expandedItem;
                            t && (t.ul.style.height = "0", t.ul.style.padding = "", setTimeout(function() {
                                o.expandedItem !== t && (t.ul.style.display = "", h.removeClassName)(t.ul.parentNode, "jsoneditor-selected");
                            }, 300), this.expandedItem = void 0), e || ((i = n.ul).style.display = "block", i.clientHeight, setTimeout(function() {
                                if (o.expandedItem === n) {
                                    for(var e = 0, t = 0; t < i.childNodes.length; t++)e += i.childNodes[t].clientHeight;
                                    i.style.height = e + "px", i.style.padding = "5px 10px";
                                }
                            }, 0), (0, h.addClassName)(i.parentNode, "jsoneditor-selected"), this.expandedItem = n);
                        }
                    },
                    {
                        key: "_onKeyDown",
                        value: function(e) {
                            var t, n, i, o, r = e.target, s = e.which, a = !1;
                            27 === s ? (this.selection && (0, h.setSelection)(this.selection), this.anchor && this.anchor.focus(), this.hide(), a = !0) : 9 === s ? e.shiftKey ? 0 === (n = (t = this._getVisibleButtons()).indexOf(r)) && (t[t.length - 1].focus(), a = !0) : (n = (t = this._getVisibleButtons()).indexOf(r)) === t.length - 1 && (t[0].focus(), a = !0) : 37 === s ? ("jsoneditor-expand" === r.className && (n = (t = this._getVisibleButtons()).indexOf(r), i = t[n - 1]) && i.focus(), a = !0) : 38 === s ? (n = (t = this._getVisibleButtons()).indexOf(r), (i = (i = (i = t[n - 1]) && "jsoneditor-expand" === i.className ? t[n - 2] : i) || t[t.length - 1]) && i.focus(), a = !0) : 39 === s ? (n = (t = this._getVisibleButtons()).indexOf(r), (o = t[n + 1]) && "jsoneditor-expand" === o.className && o.focus(), a = !0) : 40 === s && (n = (t = this._getVisibleButtons()).indexOf(r), (o = (o = (o = t[n + 1]) && "jsoneditor-expand" === o.className ? t[n + 2] : o) || t[0]) && (o.focus(), a = !0), a = !0), a && (e.stopPropagation(), e.preventDefault());
                        }
                    }
                ], i(e.prototype, t), n && i(e, n), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), l;
            }();
            r.visibleMenu = void 0;
        },
        6436: function(e, t, n) {
            "use strict";
            function o(e) {
                return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function r(e, t) {
                for(var n = 0; n < t.length; n++){
                    var i = t[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function(e) {
                        e = function(e, t) {
                            if ("object" !== o(e) || null === e) return e;
                            var n = e[Symbol.toPrimitive];
                            if (void 0 === n) return ("string" === t ? String : Number)(e);
                            n = n.call(e, t || "default");
                            if ("object" !== o(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }(e, "string");
                        return "symbol" === o(e) ? e : String(e);
                    }(i.key), i);
                }
            }
            n.d(t, {
                Q: function() {
                    return i;
                }
            });
            var i = function() {
                function n(e) {
                    if (!(this instanceof n)) throw new TypeError("Cannot call a class as a function");
                    this.errorTableVisible = e.errorTableVisible, this.onToggleVisibility = e.onToggleVisibility, this.onFocusLine = e.onFocusLine || function() {}, this.onChangeHeight = e.onChangeHeight, this.dom = {};
                    var e = document.createElement("div"), t = (e.className = "jsoneditor-validation-errors-container", this.dom.validationErrorsContainer = e, document.createElement("div")), e = (t.style.display = "none", t.className = "jsoneditor-additional-errors fadein", t.textContent = "Scroll for more \u25BF", this.dom.additionalErrorsIndication = t, e.appendChild(t), document.createElement("span")), t = (e.className = "jsoneditor-validation-error-icon", e.style.display = "none", this.dom.validationErrorIcon = e, document.createElement("span"));
                    t.className = "jsoneditor-validation-error-count", t.style.display = "none", this.dom.validationErrorCount = t, this.dom.parseErrorIndication = document.createElement("span"), this.dom.parseErrorIndication.className = "jsoneditor-parse-error-icon", this.dom.parseErrorIndication.style.display = "none";
                }
                var e, t, i;
                return e = n, t = [
                    {
                        key: "getErrorTable",
                        value: function() {
                            return this.dom.validationErrorsContainer;
                        }
                    },
                    {
                        key: "getErrorCounter",
                        value: function() {
                            return this.dom.validationErrorCount;
                        }
                    },
                    {
                        key: "getWarningIcon",
                        value: function() {
                            return this.dom.validationErrorIcon;
                        }
                    },
                    {
                        key: "getErrorIcon",
                        value: function() {
                            return this.dom.parseErrorIndication;
                        }
                    },
                    {
                        key: "toggleTableVisibility",
                        value: function() {
                            this.errorTableVisible = !this.errorTableVisible, this.onToggleVisibility(this.errorTableVisible);
                        }
                    },
                    {
                        key: "setErrors",
                        value: function(e, r) {
                            var s, t, a = this, n = (this.dom.validationErrors && (this.dom.validationErrors.parentNode.removeChild(this.dom.validationErrors), this.dom.validationErrors = null, this.dom.additionalErrorsIndication.style.display = "none"), this.errorTableVisible && 0 < e.length ? ((n = document.createElement("div")).className = "jsoneditor-validation-errors", (t = document.createElement("table")).className = "jsoneditor-text-errors", n.appendChild(t), s = document.createElement("tbody"), t.appendChild(s), e.forEach(function(t) {
                                isNaN(t.line) ? t.dataPath && (n = r.find(function(e) {
                                    return e.path === t.dataPath;
                                })) && (e = n.line + 1) : e = t.line;
                                var e, n = document.createElement("tr"), i = (n.className = isNaN(e) ? "" : "jump-to-line", "error" === t.type ? n.className += " parse-error" : n.className += " validation-error", document.createElement("td")), o = document.createElement("button"), o = (o.className = "jsoneditor-schema-error", i.appendChild(o), n.appendChild(i), document.createElement("td"));
                                o.style = "white-space: nowrap;", o.textContent = isNaN(e) ? "" : "Ln " + e, n.appendChild(o), "string" == typeof t ? ((i = document.createElement("td")).colSpan = 2, (o = document.createElement("pre")).appendChild(document.createTextNode(t)), i.appendChild(o), n.appendChild(i)) : ((o = document.createElement("td")).appendChild(document.createTextNode(t.dataPath || "")), n.appendChild(o), i = document.createElement("td"), (o = document.createElement("pre")).appendChild(document.createTextNode(t.message.replace(/<br>/gi, "\n"))), i.appendChild(o), n.appendChild(i)), n.onclick = function() {
                                    a.onFocusLine(e);
                                }, s.appendChild(n);
                            }), this.dom.validationErrors = n, this.dom.validationErrorsContainer.appendChild(n), this.dom.additionalErrorsIndication.title = e.length + " errors total", this.dom.validationErrorsContainer.clientHeight < this.dom.validationErrorsContainer.scrollHeight ? (this.dom.additionalErrorsIndication.style.display = "block", this.dom.validationErrorsContainer.onscroll = function() {
                                a.dom.additionalErrorsIndication.style.display = 0 < a.dom.validationErrorsContainer.clientHeight && 0 === a.dom.validationErrorsContainer.scrollTop ? "block" : "none";
                            }) : this.dom.validationErrorsContainer.onscroll = void 0, t = this.dom.validationErrorsContainer.clientHeight + (this.dom.statusBar ? this.dom.statusBar.clientHeight : 0), this.onChangeHeight(t)) : this.onChangeHeight(0), e.filter(function(e) {
                                return "error" !== e.type;
                            }).length);
                            0 < n ? (this.dom.validationErrorCount.style.display = "inline", this.dom.validationErrorCount.innerText = n, this.dom.validationErrorCount.onclick = this.toggleTableVisibility.bind(this), this.dom.validationErrorIcon.style.display = "inline", this.dom.validationErrorIcon.title = n + " schema validation error(s) found", this.dom.validationErrorIcon.onclick = this.toggleTableVisibility.bind(this)) : (this.dom.validationErrorCount.style.display = "none", this.dom.validationErrorIcon.style.display = "none"), e.some(function(e) {
                                return "error" === e.type;
                            }) ? (t = e[0].line, this.dom.parseErrorIndication.style.display = "block", this.dom.parseErrorIndication.title = isNaN(t) ? "parse error - check that the json is valid" : "parse error on line " + t, this.dom.parseErrorIndication.onclick = this.toggleTableVisibility.bind(this)) : this.dom.parseErrorIndication.style.display = "none";
                        }
                    }
                ], r(e.prototype, t), i && r(e, i), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), n;
            }();
        },
        2474: function(e, t, n) {
            "use strict";
            function o(e) {
                return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function r(e, t) {
                for(var n = 0; n < t.length; n++){
                    var i = t[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function(e) {
                        e = function(e, t) {
                            if ("object" !== o(e) || null === e) return e;
                            var n = e[Symbol.toPrimitive];
                            if (void 0 === n) return ("string" === t ? String : Number)(e);
                            n = n.call(e, t || "default");
                            if ("object" !== o(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }(e, "string");
                        return "symbol" === o(e) ? e : String(e);
                    }(i.key), i);
                }
            }
            n.d(t, {
                R: function() {
                    return i;
                }
            });
            var i = function() {
                function t(e) {
                    if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function");
                    if (this.target = e.target || null, !this.target) throw new Error('FocusTracker constructor called without a "target" to track.');
                    this.onFocus = "function" == typeof e.onFocus ? e.onFocus : null, this.onBlur = "function" == typeof e.onBlur ? e.onBlur : null, this._onClick = this._onEvent.bind(this), this._onKeyUp = (function(e) {
                        9 !== e.which && 9 !== e.keyCode || this._onEvent(e);
                    }).bind(this), this._onBlur = this._onEvent.bind(this), this.focusFlag = !1, this.firstEventFlag = !0, (this.onFocus || this.onBlur) && (document.addEventListener("click", this._onClick), document.addEventListener("keyup", this._onKeyUp), document.addEventListener("blur", this._onBlur));
                }
                var e, n, i;
                return e = t, n = [
                    {
                        key: "destroy",
                        value: function() {
                            document.removeEventListener("click", this._onClick), document.removeEventListener("keyup", this._onKeyUp), document.removeEventListener("blur", this._onBlur), this._onEvent({
                                target: document.body
                            });
                        }
                    },
                    {
                        key: "_onEvent",
                        value: function(e) {
                            e = e.target, e = e === this.target || !(!this.target.contains(e) && !this.target.contains(document.activeElement));
                            e ? this.focusFlag || (this.onFocus && this.onFocus({
                                type: "focus",
                                target: this.target
                            }), this.focusFlag = !0) : (this.focusFlag || this.firstEventFlag) && (this.onBlur && this.onBlur({
                                type: "blur",
                                target: this.target
                            }), this.focusFlag = !1, this.firstEventFlag) && (this.firstEventFlag = !1);
                        }
                    }
                ], r(e.prototype, n), i && r(e, i), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t;
            }();
        },
        3161: function(e, t, o) {
            "use strict";
            var n = o(8170), i = o(8037), r = o(8038).treeModeMixins, s = o(8458).textModeMixins, a = o(341).previewModeMixins, l = o(9791), c = l.clear, h = l.extend, d = l.getInnerText, u = l.getInternetExplorerVersion, g = l.parse, l = o(2744).tryRequireAjv, p = o(2558).showTransformModal, m = o(6210).showSortModal, f = l();
            function C(e, t, n) {
                if (!(this instanceof C)) throw new Error('JSONEditor constructor called without "new".');
                var i = u();
                if (-1 !== i && i < 9) throw new Error("Unsupported browser, IE9 or newer required. Please install the newest version of your browser.");
                t && (t.error && (console.warn('Option "error" has been renamed to "onError"'), t.onError = t.error, delete t.error), t.change && (console.warn('Option "change" has been renamed to "onChange"'), t.onChange = t.change, delete t.change), t.editable && (console.warn('Option "editable" has been renamed to "onEditable"'), t.onEditable = t.editable, delete t.editable), t.onChangeJSON && ("text" === t.mode || "code" === t.mode || t.modes && (-1 !== t.modes.indexOf("text") || -1 !== t.modes.indexOf("code"))) && console.warn('Option "onChangeJSON" is not applicable to modes "text" and "code". Use "onChangeText" or "onChange" instead.'), t) && Object.keys(t).forEach(function(e) {
                    -1 === C.VALID_OPTIONS.indexOf(e) && console.warn('Unknown option "' + e + '". This option will be ignored');
                }), arguments.length && this._create(e, t, n);
            }
            "undefined" == typeof Promise && console.error("Promise undefined. Please load a Promise polyfill in the browser in order to use JSONEditor"), C.modes = {}, C.prototype.DEBOUNCE_INTERVAL = 150, C.VALID_OPTIONS = [
                "ajv",
                "schema",
                "schemaRefs",
                "templates",
                "ace",
                "theme",
                "autocomplete",
                "onChange",
                "onChangeJSON",
                "onChangeText",
                "onExpand",
                "onEditable",
                "onError",
                "onEvent",
                "onModeChange",
                "onNodeName",
                "onValidate",
                "onCreateMenu",
                "onSelectionChange",
                "onTextSelectionChange",
                "onClassName",
                "onFocus",
                "onBlur",
                "colorPicker",
                "onColorPicker",
                "timestampTag",
                "timestampFormat",
                "escapeUnicode",
                "history",
                "search",
                "mode",
                "modes",
                "name",
                "indentation",
                "sortObjectKeys",
                "navigationBar",
                "statusBar",
                "mainMenuBar",
                "languages",
                "language",
                "enableSort",
                "enableTransform",
                "limitDragging",
                "maxVisibleChilds",
                "onValidationError",
                "modalAnchor",
                "popupAnchor",
                "createQuery",
                "executeQuery",
                "queryDescription",
                "allowSchemaSuggestions",
                "showErrorTable"
            ], C.prototype._create = function(e, t, n) {
                this.container = e, this.options = t || {}, this.json = n || {};
                e = this.options.mode || this.options.modes && this.options.modes[0] || "tree";
                this.setMode(e);
            }, C.prototype.destroy = function() {}, C.prototype.set = function(e) {
                this.json = e;
            }, C.prototype.get = function() {
                return this.json;
            }, C.prototype.setText = function(e) {
                this.json = g(e);
            }, C.prototype.getText = function() {
                return JSON.stringify(this.json);
            }, C.prototype.setName = function(e) {
                this.options || (this.options = {}), this.options.name = e;
            }, C.prototype.getName = function() {
                return this.options && this.options.name;
            }, C.prototype.setMode = function(e) {
                if (e !== this.options.mode || !this.create) {
                    var t = this.container, n = h({}, this.options), i = n.mode, o = (n.mode = e, C.modes[e]);
                    if (!o) throw new Error('Unknown mode "' + n.mode + '"');
                    var r = "text" === o.data, s = this.getName(), a = this[r ? "getText" : "get"]();
                    if (this.destroy(), c(this), h(this, o.mixin), this.create(t, n), this.setName(s), this[r ? "setText" : "set"](a), "function" == typeof o.load) try {
                        o.load.call(this);
                    } catch (e) {
                        console.error(e);
                    }
                    if ("function" == typeof n.onModeChange && e !== i) try {
                        n.onModeChange(e, i);
                    } catch (e) {
                        console.error(e);
                    }
                }
            }, C.prototype.getMode = function() {
                return this.options.mode;
            }, C.prototype._onError = function(e) {
                this.options && "function" == typeof this.options.onError ? this.options.onError(e) : window.alert(e.toString());
            }, C.prototype.setSchema = function(e, t) {
                if (e) {
                    var n;
                    try {
                        this.options.ajv ? n = this.options.ajv : ((n = f({
                            allErrors: !0,
                            verbose: !0,
                            schemaId: "auto",
                            $data: !0
                        })).addMetaSchema(o(7171)), n.addMetaSchema(o(6273)));
                    } catch (e) {
                        console.warn("Failed to create an instance of Ajv, JSON Schema validation is not available. Please use a JSONEditor bundle including Ajv, or pass an instance of Ajv as via the configuration option `ajv`.");
                    }
                    if (n) {
                        if (t) {
                            for(var i in t)n.removeSchema(i), t[i] && n.addSchema(t[i], i);
                            this.options.schemaRefs = t;
                        }
                        this.validateSchema = n.compile(e), this.options.schema = e, this.options.schemaRefs = t, this.validate();
                    }
                } else this.validateSchema = null, this.options.schema = null, this.options.schemaRefs = null, this.validate();
                this.refresh(), "function" == typeof this._onSchemaChange && this._onSchemaChange(e, t);
            }, C.prototype.validate = function() {}, C.prototype.refresh = function() {}, (C.registerMode = function(e) {
                var t;
                if (Array.isArray(e)) for(o = 0; o < e.length; o++)C.registerMode(e[o]);
                else {
                    if (!("mode" in e)) throw new Error('Property "mode" missing');
                    if (!("mixin" in e)) throw new Error('Property "mixin" missing');
                    if (!("data" in e)) throw new Error('Property "data" missing');
                    var n = e.mode;
                    if (n in C.modes) throw new Error('Mode "' + n + '" already registered');
                    if ("function" != typeof e.mixin.create) throw new Error('Required function "create" missing on mixin');
                    for(var i = [
                        "setMode",
                        "registerMode",
                        "modes"
                    ], o = 0; o < i.length; o++)if ((t = i[o]) in e.mixin) throw new Error('Reserved property "' + t + '" not allowed in mixin');
                    C.modes[n] = e;
                }
            })(r), C.registerMode(s), C.registerMode(a), C.ace = n, C.Ajv = f, C.VanillaPicker = i, C.showTransformModal = p, C.showSortModal = m, C.getInnerText = d, e.exports = C.default = C;
        },
        6617: function(e, t, n) {
            "use strict";
            n.d(t, {
                x: function() {
                    return r;
                }
            });
            var u = n(897), g = n(7907);
            function o(e) {
                return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function i(e, t) {
                for(var n = 0; n < t.length; n++){
                    var i = t[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function(e) {
                        e = function(e, t) {
                            if ("object" !== o(e) || null === e) return e;
                            var n = e[Symbol.toPrimitive];
                            if (void 0 === n) return ("string" === t ? String : Number)(e);
                            n = n.call(e, t || "default");
                            if ("object" !== o(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }(e, "string");
                        return "symbol" === o(e) ? e : String(e);
                    }(i.key), i);
                }
            }
            var r = function() {
                function d(e, t, n, i) {
                    if (!(this instanceof d)) throw new TypeError("Cannot call a class as a function");
                    for(var o = {
                        code: {
                            text: (0, g.Iu)("modeCodeText"),
                            title: (0, g.Iu)("modeCodeTitle"),
                            click: function() {
                                i("code");
                            }
                        },
                        form: {
                            text: (0, g.Iu)("modeFormText"),
                            title: (0, g.Iu)("modeFormTitle"),
                            click: function() {
                                i("form");
                            }
                        },
                        text: {
                            text: (0, g.Iu)("modeTextText"),
                            title: (0, g.Iu)("modeTextTitle"),
                            click: function() {
                                i("text");
                            }
                        },
                        tree: {
                            text: (0, g.Iu)("modeTreeText"),
                            title: (0, g.Iu)("modeTreeTitle"),
                            click: function() {
                                i("tree");
                            }
                        },
                        view: {
                            text: (0, g.Iu)("modeViewText"),
                            title: (0, g.Iu)("modeViewTitle"),
                            click: function() {
                                i("view");
                            }
                        },
                        preview: {
                            text: (0, g.Iu)("modePreviewText"),
                            title: (0, g.Iu)("modePreviewTitle"),
                            click: function() {
                                i("preview");
                            }
                        }
                    }, r = [], s = 0; s < t.length; s++){
                        var a = t[s], l = o[a];
                        if (!l) throw new Error('Unknown mode "' + a + '"');
                        l.className = "jsoneditor-type-modes" + (n === a ? " jsoneditor-selected" : ""), r.push(l);
                    }
                    var c = o[n];
                    if (!c) throw new Error('Unknown mode "' + n + '"');
                    var c = c.text, h = document.createElement("button"), c = (h.type = "button", h.className = "jsoneditor-modes jsoneditor-separator", h.textContent = c + " \u25BE", h.title = (0, g.Iu)("modeEditorTitle"), h.onclick = function() {
                        new u.x(r).show(h, e);
                    }, document.createElement("div"));
                    c.className = "jsoneditor-modes", c.style.position = "relative", c.appendChild(h), e.appendChild(c), this.dom = {
                        container: e,
                        box: h,
                        frame: c
                    };
                }
                var e, t, n;
                return e = d, t = [
                    {
                        key: "focus",
                        value: function() {
                            this.dom.box.focus();
                        }
                    },
                    {
                        key: "destroy",
                        value: function() {
                            this.dom && this.dom.frame && this.dom.frame.parentNode && this.dom.frame.parentNode.removeChild(this.dom.frame), this.dom = null;
                        }
                    }
                ], i(e.prototype, t), n && i(e, n), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), d;
            }();
        },
        8170: function(e, t, n) {
            var i;
            if (window.ace) i = window.ace;
            else try {
                i = n(6225), n(4091), n(3330), n(4317);
                var o = n(7923);
                i.config.setModuleUrl("ace/mode/json_worker", o);
            } catch (e) {}
            e.exports = i;
        },
        4864: function() {
            window.ace.define("ace/theme/jsoneditor", [
                "require",
                "exports",
                "module",
                "ace/lib/dom"
            ], function(e, t, n) {
                t.isDark = !1, t.cssClass = "ace-jsoneditor", t.cssText = '.ace-jsoneditor .ace_gutter {\nbackground: #ebebeb;\ncolor: #333\n}\n\n.ace-jsoneditor.ace_editor {\nline-height: 1.3;\nbackground-color: #fff;\n}\n.ace-jsoneditor .ace_print-margin {\nwidth: 1px;\nbackground: #e8e8e8\n}\n.ace-jsoneditor .ace_scroller {\nbackground-color: #FFFFFF\n}\n.ace-jsoneditor .ace_text-layer {\ncolor: gray\n}\n.ace-jsoneditor .ace_variable {\ncolor: #1a1a1a\n}\n.ace-jsoneditor .ace_cursor {\nborder-left: 2px solid #000000\n}\n.ace-jsoneditor .ace_overwrite-cursors .ace_cursor {\nborder-left: 0px;\nborder-bottom: 1px solid #000000\n}\n.ace-jsoneditor .ace_marker-layer .ace_selection {\nbackground: lightgray\n}\n.ace-jsoneditor.ace_multiselect .ace_selection.ace_start {\nbox-shadow: 0 0 3px 0px #FFFFFF;\nborder-radius: 2px\n}\n.ace-jsoneditor .ace_marker-layer .ace_step {\nbackground: rgb(255, 255, 0)\n}\n.ace-jsoneditor .ace_marker-layer .ace_bracket {\nmargin: -1px 0 0 -1px;\nborder: 1px solid #BFBFBF\n}\n.ace-jsoneditor .ace_marker-layer .ace_active-line {\nbackground: #FFFBD1\n}\n.ace-jsoneditor .ace_gutter-active-line {\nbackground-color : #dcdcdc\n}\n.ace-jsoneditor .ace_marker-layer .ace_selected-word {\nborder: 1px solid lightgray\n}\n.ace-jsoneditor .ace_invisible {\ncolor: #BFBFBF\n}\n.ace-jsoneditor .ace_keyword,\n.ace-jsoneditor .ace_meta,\n.ace-jsoneditor .ace_support.ace_constant.ace_property-value {\ncolor: #AF956F\n}\n.ace-jsoneditor .ace_keyword.ace_operator {\ncolor: #484848\n}\n.ace-jsoneditor .ace_keyword.ace_other.ace_unit {\ncolor: #96DC5F\n}\n.ace-jsoneditor .ace_constant.ace_language {\ncolor: darkorange\n}\n.ace-jsoneditor .ace_constant.ace_numeric {\ncolor: red\n}\n.ace-jsoneditor .ace_constant.ace_character.ace_entity {\ncolor: #BF78CC\n}\n.ace-jsoneditor .ace_invalid {\ncolor: #FFFFFF;\nbackground-color: #FF002A;\n}\n.ace-jsoneditor .ace_fold {\nbackground-color: #AF956F;\nborder-color: #000000\n}\n.ace-jsoneditor .ace_storage,\n.ace-jsoneditor .ace_support.ace_class,\n.ace-jsoneditor .ace_support.ace_function,\n.ace-jsoneditor .ace_support.ace_other,\n.ace-jsoneditor .ace_support.ace_type {\ncolor: #C52727\n}\n.ace-jsoneditor .ace_string {\ncolor: green\n}\n.ace-jsoneditor .ace_comment {\ncolor: #BCC8BA\n}\n.ace-jsoneditor .ace_entity.ace_name.ace_tag,\n.ace-jsoneditor .ace_entity.ace_other.ace_attribute-name {\ncolor: #606060\n}\n.ace-jsoneditor .ace_markup.ace_underline {\ntext-decoration: underline\n}\n.ace-jsoneditor .ace_indent-guide {\nbackground: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==") right repeat-y\n}', e("../lib/dom").importCssString(t.cssText, t.cssClass);
            });
        },
        6589: function(e, t) {
            (n = {
                trace: function() {},
                yy: {},
                symbols_: {
                    error: 2,
                    JSONString: 3,
                    STRING: 4,
                    JSONNumber: 5,
                    NUMBER: 6,
                    JSONNullLiteral: 7,
                    NULL: 8,
                    JSONBooleanLiteral: 9,
                    TRUE: 10,
                    FALSE: 11,
                    JSONText: 12,
                    JSONValue: 13,
                    EOF: 14,
                    JSONObject: 15,
                    JSONArray: 16,
                    "{": 17,
                    "}": 18,
                    JSONMemberList: 19,
                    JSONMember: 20,
                    ":": 21,
                    ",": 22,
                    "[": 23,
                    "]": 24,
                    JSONElementList: 25,
                    $accept: 0,
                    $end: 1
                },
                terminals_: {
                    2: "error",
                    4: "STRING",
                    6: "NUMBER",
                    8: "NULL",
                    10: "TRUE",
                    11: "FALSE",
                    14: "EOF",
                    17: "{",
                    18: "}",
                    21: ":",
                    22: ",",
                    23: "[",
                    24: "]"
                },
                productions_: [
                    0,
                    [
                        3,
                        1
                    ],
                    [
                        5,
                        1
                    ],
                    [
                        7,
                        1
                    ],
                    [
                        9,
                        1
                    ],
                    [
                        9,
                        1
                    ],
                    [
                        12,
                        2
                    ],
                    [
                        13,
                        1
                    ],
                    [
                        13,
                        1
                    ],
                    [
                        13,
                        1
                    ],
                    [
                        13,
                        1
                    ],
                    [
                        13,
                        1
                    ],
                    [
                        13,
                        1
                    ],
                    [
                        15,
                        2
                    ],
                    [
                        15,
                        3
                    ],
                    [
                        20,
                        3
                    ],
                    [
                        19,
                        1
                    ],
                    [
                        19,
                        3
                    ],
                    [
                        16,
                        2
                    ],
                    [
                        16,
                        3
                    ],
                    [
                        25,
                        1
                    ],
                    [
                        25,
                        3
                    ]
                ],
                performAction: function(e, t, n, i, o, r, s) {
                    var a = r.length - 1;
                    switch(o){
                        case 1:
                            this.$ = e.replace(/\\(\\|")/g, "$1").replace(/\\n/g, "\n").replace(/\\r/g, "\r").replace(/\\t/g, "\t").replace(/\\v/g, "\v").replace(/\\f/g, "\f").replace(/\\b/g, "\b");
                            break;
                        case 2:
                            this.$ = Number(e);
                            break;
                        case 3:
                            this.$ = null;
                            break;
                        case 4:
                            this.$ = !0;
                            break;
                        case 5:
                            this.$ = !1;
                            break;
                        case 6:
                            return this.$ = r[a - 1];
                        case 13:
                            this.$ = {};
                            break;
                        case 14:
                            this.$ = r[a - 1];
                            break;
                        case 15:
                            this.$ = [
                                r[a - 2],
                                r[a]
                            ];
                            break;
                        case 16:
                            this.$ = {}, this.$[r[a][0]] = r[a][1];
                            break;
                        case 17:
                            this.$ = r[a - 2], r[a - 2][r[a][0]] = r[a][1];
                            break;
                        case 18:
                            this.$ = [];
                            break;
                        case 19:
                            this.$ = r[a - 1];
                            break;
                        case 20:
                            this.$ = [
                                r[a]
                            ];
                            break;
                        case 21:
                            this.$ = r[a - 2], r[a - 2].push(r[a]);
                    }
                },
                table: [
                    {
                        3: 5,
                        4: [
                            1,
                            12
                        ],
                        5: 6,
                        6: [
                            1,
                            13
                        ],
                        7: 3,
                        8: [
                            1,
                            9
                        ],
                        9: 4,
                        10: [
                            1,
                            10
                        ],
                        11: [
                            1,
                            11
                        ],
                        12: 1,
                        13: 2,
                        15: 7,
                        16: 8,
                        17: [
                            1,
                            14
                        ],
                        23: [
                            1,
                            15
                        ]
                    },
                    {
                        1: [
                            3
                        ]
                    },
                    {
                        14: [
                            1,
                            16
                        ]
                    },
                    {
                        14: [
                            2,
                            7
                        ],
                        18: [
                            2,
                            7
                        ],
                        22: [
                            2,
                            7
                        ],
                        24: [
                            2,
                            7
                        ]
                    },
                    {
                        14: [
                            2,
                            8
                        ],
                        18: [
                            2,
                            8
                        ],
                        22: [
                            2,
                            8
                        ],
                        24: [
                            2,
                            8
                        ]
                    },
                    {
                        14: [
                            2,
                            9
                        ],
                        18: [
                            2,
                            9
                        ],
                        22: [
                            2,
                            9
                        ],
                        24: [
                            2,
                            9
                        ]
                    },
                    {
                        14: [
                            2,
                            10
                        ],
                        18: [
                            2,
                            10
                        ],
                        22: [
                            2,
                            10
                        ],
                        24: [
                            2,
                            10
                        ]
                    },
                    {
                        14: [
                            2,
                            11
                        ],
                        18: [
                            2,
                            11
                        ],
                        22: [
                            2,
                            11
                        ],
                        24: [
                            2,
                            11
                        ]
                    },
                    {
                        14: [
                            2,
                            12
                        ],
                        18: [
                            2,
                            12
                        ],
                        22: [
                            2,
                            12
                        ],
                        24: [
                            2,
                            12
                        ]
                    },
                    {
                        14: [
                            2,
                            3
                        ],
                        18: [
                            2,
                            3
                        ],
                        22: [
                            2,
                            3
                        ],
                        24: [
                            2,
                            3
                        ]
                    },
                    {
                        14: [
                            2,
                            4
                        ],
                        18: [
                            2,
                            4
                        ],
                        22: [
                            2,
                            4
                        ],
                        24: [
                            2,
                            4
                        ]
                    },
                    {
                        14: [
                            2,
                            5
                        ],
                        18: [
                            2,
                            5
                        ],
                        22: [
                            2,
                            5
                        ],
                        24: [
                            2,
                            5
                        ]
                    },
                    {
                        14: [
                            2,
                            1
                        ],
                        18: [
                            2,
                            1
                        ],
                        21: [
                            2,
                            1
                        ],
                        22: [
                            2,
                            1
                        ],
                        24: [
                            2,
                            1
                        ]
                    },
                    {
                        14: [
                            2,
                            2
                        ],
                        18: [
                            2,
                            2
                        ],
                        22: [
                            2,
                            2
                        ],
                        24: [
                            2,
                            2
                        ]
                    },
                    {
                        3: 20,
                        4: [
                            1,
                            12
                        ],
                        18: [
                            1,
                            17
                        ],
                        19: 18,
                        20: 19
                    },
                    {
                        3: 5,
                        4: [
                            1,
                            12
                        ],
                        5: 6,
                        6: [
                            1,
                            13
                        ],
                        7: 3,
                        8: [
                            1,
                            9
                        ],
                        9: 4,
                        10: [
                            1,
                            10
                        ],
                        11: [
                            1,
                            11
                        ],
                        13: 23,
                        15: 7,
                        16: 8,
                        17: [
                            1,
                            14
                        ],
                        23: [
                            1,
                            15
                        ],
                        24: [
                            1,
                            21
                        ],
                        25: 22
                    },
                    {
                        1: [
                            2,
                            6
                        ]
                    },
                    {
                        14: [
                            2,
                            13
                        ],
                        18: [
                            2,
                            13
                        ],
                        22: [
                            2,
                            13
                        ],
                        24: [
                            2,
                            13
                        ]
                    },
                    {
                        18: [
                            1,
                            24
                        ],
                        22: [
                            1,
                            25
                        ]
                    },
                    {
                        18: [
                            2,
                            16
                        ],
                        22: [
                            2,
                            16
                        ]
                    },
                    {
                        21: [
                            1,
                            26
                        ]
                    },
                    {
                        14: [
                            2,
                            18
                        ],
                        18: [
                            2,
                            18
                        ],
                        22: [
                            2,
                            18
                        ],
                        24: [
                            2,
                            18
                        ]
                    },
                    {
                        22: [
                            1,
                            28
                        ],
                        24: [
                            1,
                            27
                        ]
                    },
                    {
                        22: [
                            2,
                            20
                        ],
                        24: [
                            2,
                            20
                        ]
                    },
                    {
                        14: [
                            2,
                            14
                        ],
                        18: [
                            2,
                            14
                        ],
                        22: [
                            2,
                            14
                        ],
                        24: [
                            2,
                            14
                        ]
                    },
                    {
                        3: 20,
                        4: [
                            1,
                            12
                        ],
                        20: 29
                    },
                    {
                        3: 5,
                        4: [
                            1,
                            12
                        ],
                        5: 6,
                        6: [
                            1,
                            13
                        ],
                        7: 3,
                        8: [
                            1,
                            9
                        ],
                        9: 4,
                        10: [
                            1,
                            10
                        ],
                        11: [
                            1,
                            11
                        ],
                        13: 30,
                        15: 7,
                        16: 8,
                        17: [
                            1,
                            14
                        ],
                        23: [
                            1,
                            15
                        ]
                    },
                    {
                        14: [
                            2,
                            19
                        ],
                        18: [
                            2,
                            19
                        ],
                        22: [
                            2,
                            19
                        ],
                        24: [
                            2,
                            19
                        ]
                    },
                    {
                        3: 5,
                        4: [
                            1,
                            12
                        ],
                        5: 6,
                        6: [
                            1,
                            13
                        ],
                        7: 3,
                        8: [
                            1,
                            9
                        ],
                        9: 4,
                        10: [
                            1,
                            10
                        ],
                        11: [
                            1,
                            11
                        ],
                        13: 31,
                        15: 7,
                        16: 8,
                        17: [
                            1,
                            14
                        ],
                        23: [
                            1,
                            15
                        ]
                    },
                    {
                        18: [
                            2,
                            17
                        ],
                        22: [
                            2,
                            17
                        ]
                    },
                    {
                        18: [
                            2,
                            15
                        ],
                        22: [
                            2,
                            15
                        ]
                    },
                    {
                        22: [
                            2,
                            21
                        ],
                        24: [
                            2,
                            21
                        ]
                    }
                ],
                defaultActions: {
                    16: [
                        2,
                        6
                    ]
                },
                parseError: function(e, t) {
                    throw new Error(e);
                },
                parse: function(e) {
                    var t = this, n = [
                        0
                    ], i = [
                        null
                    ], o = [], r = this.table, s = "", a = 0, l = 0, c = 0, h = (this.lexer.setInput(e), this.lexer.yy = this.yy, this.yy.lexer = this.lexer, void 0 === this.lexer.yylloc && (this.lexer.yylloc = {}), this.lexer.yylloc);
                    function d() {
                        var e = t.lexer.lex() || 1;
                        return e = "number" != typeof e ? t.symbols_[e] || e : e;
                    }
                    o.push(h), "function" == typeof this.yy.parseError && (this.parseError = this.yy.parseError);
                    for(var u, g, p, m, f, C, y, v, I, b = {};;){
                        if (p = n[n.length - 1], void 0 === (m = this.defaultActions[p] || (null == u && (u = d()), r[p] && r[p][u])) || !m.length || !m[0]) {
                            if (!c) {
                                for(f in v = [], r[p])this.terminals_[f] && 2 < f && v.push("'" + this.terminals_[f] + "'");
                                var A = "", A = this.lexer.showPosition ? "Parse error on line " + (a + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + v.join(", ") + ", got '" + this.terminals_[u] + "'" : "Parse error on line " + (a + 1) + ": Unexpected " + (1 == u ? "end of input" : "'" + (this.terminals_[u] || u) + "'");
                                this.parseError(A, {
                                    text: this.lexer.match,
                                    token: this.terminals_[u] || u,
                                    line: this.lexer.yylineno,
                                    loc: h,
                                    expected: v
                                });
                            }
                            if (3 == c) {
                                if (1 == u) throw new Error(A || "Parsing halted.");
                                l = this.lexer.yyleng, s = this.lexer.yytext, a = this.lexer.yylineno, h = this.lexer.yylloc, u = d();
                            }
                            for(;;){
                                if (2..toString() in r[p]) break;
                                if (0 == p) throw new Error(A || "Parsing halted.");
                                I = 1, n.length = n.length - 2 * I, i.length = i.length - I, o.length = o.length - I, p = n[n.length - 1];
                            }
                            g = u, u = 2, m = r[p = n[n.length - 1]] && r[p][2], c = 3;
                        }
                        if (m[0] instanceof Array && 1 < m.length) throw new Error("Parse Error: multiple actions possible at state: " + p + ", token: " + u);
                        switch(m[0]){
                            case 1:
                                n.push(u), i.push(this.lexer.yytext), o.push(this.lexer.yylloc), n.push(m[1]), u = null, g ? (u = g, g = null) : (l = this.lexer.yyleng, s = this.lexer.yytext, a = this.lexer.yylineno, h = this.lexer.yylloc, 0 < c && c--);
                                break;
                            case 2:
                                if (C = this.productions_[m[1]][1], b.$ = i[i.length - C], b._$ = {
                                    first_line: o[o.length - (C || 1)].first_line,
                                    last_line: o[o.length - 1].last_line,
                                    first_column: o[o.length - (C || 1)].first_column,
                                    last_column: o[o.length - 1].last_column
                                }, void 0 !== (y = this.performAction.call(b, s, l, a, this.yy, m[1], i, o))) return y;
                                C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), o = o.slice(0, -1 * C)), n.push(this.productions_[m[1]][0]), i.push(b.$), o.push(b._$), y = r[n[n.length - 2]][n[n.length - 1]], n.push(y);
                                break;
                            case 3:
                                return !0;
                        }
                    }
                    return !0;
                }
            }).lexer = {
                EOF: 1,
                parseError: function(e, t) {
                    if (!this.yy.parseError) throw new Error(e);
                    this.yy.parseError(e, t);
                },
                setInput: function(e) {
                    return this._input = e, this._more = this._less = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = [
                        "INITIAL"
                    ], this.yylloc = {
                        first_line: 1,
                        first_column: 0,
                        last_line: 1,
                        last_column: 0
                    }, this;
                },
                input: function() {
                    var e = this._input[0];
                    return this.yytext += e, this.yyleng++, this.match += e, this.matched += e, e.match(/\n/) && this.yylineno++, this._input = this._input.slice(1), e;
                },
                unput: function(e) {
                    return this._input = e + this._input, this;
                },
                more: function() {
                    return this._more = !0, this;
                },
                less: function(e) {
                    this._input = this.match.slice(e) + this._input;
                },
                pastInput: function() {
                    var e = this.matched.substr(0, this.matched.length - this.match.length);
                    return (20 < e.length ? "..." : "") + e.substr(-20).replace(/\n/g, "");
                },
                upcomingInput: function() {
                    var e = this.match;
                    return e.length < 20 && (e += this._input.substr(0, 20 - e.length)), (e.substr(0, 20) + (20 < e.length ? "..." : "")).replace(/\n/g, "");
                },
                showPosition: function() {
                    var e = this.pastInput(), t = new Array(e.length + 1).join("-");
                    return e + this.upcomingInput() + "\n" + t + "^";
                },
                next: function() {
                    if (this.done) return this.EOF;
                    this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");
                    for(var e, t, n, i, o = this._currentRules(), r = 0; r < o.length && (!(t = this._input.match(this.rules[o[r]])) || e && !(t[0].length > e[0].length) || (e = t, n = r, this.options.flex)); r++);
                    return e ? ((i = e[0].match(/\n.*/g)) && (this.yylineno += i.length), this.yylloc = {
                        first_line: this.yylloc.last_line,
                        last_line: this.yylineno + 1,
                        first_column: this.yylloc.last_column,
                        last_column: i ? i[i.length - 1].length - 1 : this.yylloc.last_column + e[0].length
                    }, this.yytext += e[0], this.match += e[0], this.yyleng = this.yytext.length, this._more = !1, this._input = this._input.slice(e[0].length), this.matched += e[0], i = this.performAction.call(this, this.yy, this, o[n], this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), i || void 0) : "" === this._input ? this.EOF : void this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                        text: "",
                        token: null,
                        line: this.yylineno
                    });
                },
                lex: function() {
                    var e = this.next();
                    return void 0 !== e ? e : this.lex();
                },
                begin: function(e) {
                    this.conditionStack.push(e);
                },
                popState: function() {
                    return this.conditionStack.pop();
                },
                _currentRules: function() {
                    return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                },
                topState: function() {
                    return this.conditionStack[this.conditionStack.length - 2];
                },
                pushState: function(e) {
                    this.begin(e);
                },
                options: {},
                performAction: function(e, t, n, i) {
                    switch(n){
                        case 0:
                            break;
                        case 1:
                            return 6;
                        case 2:
                            return t.yytext = t.yytext.substr(1, t.yyleng - 2), 4;
                        case 3:
                            return 17;
                        case 4:
                            return 18;
                        case 5:
                            return 23;
                        case 6:
                            return 24;
                        case 7:
                            return 22;
                        case 8:
                            return 21;
                        case 9:
                            return 10;
                        case 10:
                            return 11;
                        case 11:
                            return 8;
                        case 12:
                            return 14;
                        case 13:
                            return "INVALID";
                    }
                },
                rules: [
                    /^(?:\s+)/,
                    /^(?:(-?([0-9]|[1-9][0-9]+))(\.[0-9]+)?([eE][-+]?[0-9]+)?\b)/,
                    /^(?:"(?:\\[\\"bfnrt/]|\\u[a-fA-F0-9]{4}|[^\\\0-\x09\x0a-\x1f"])*")/,
                    /^(?:\{)/,
                    /^(?:\})/,
                    /^(?:\[)/,
                    /^(?:\])/,
                    /^(?:,)/,
                    /^(?::)/,
                    /^(?:true\b)/,
                    /^(?:false\b)/,
                    /^(?:null\b)/,
                    /^(?:$)/,
                    /^(?:.)/
                ],
                conditions: {
                    INITIAL: {
                        rules: [
                            0,
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13
                        ],
                        inclusive: !0
                    }
                }
            };
            var n;
            t.parser = n, t.parse = n.parse.bind(n);
        },
        3879: function(e) {
            "use strict";
            function i() {}
            i.prototype = {
                on: function(e, t) {
                    this._events = this._events || {}, this._events[e] = this._events[e] || [], this._events[e].push(t);
                },
                off: function(e, t) {
                    this._events = this._events || {}, e in this._events != !1 && this._events[e].splice(this._events[e].indexOf(t), 1);
                },
                emit: function(e) {
                    if (this._events = this._events || {}, e in this._events != !1) for(var t = 0; t < this._events[e].length; t++)this._events[e][t].apply(this, Array.prototype.slice.call(arguments, 1));
                }
            }, i.mixin = function(e) {
                for(var t = [
                    "on",
                    "off",
                    "emit"
                ], n = 0; n < t.length; n++)"function" == typeof e ? e.prototype[t[n]] = i.prototype[t[n]] : e[t[n]] = i.prototype[t[n]];
                return e;
            };
            var u = {
                escapeRegExp: function(e) {
                    var t = /[\\^$.*+?()[\]{}|]/g, n = new RegExp(t.source);
                    return e && n.test(e) ? e.replace(t, "\\$&") : e;
                },
                extend: function(e, t) {
                    for(var n in t){
                        var i;
                        t.hasOwnProperty(n) && ((i = t[n]) && "[object Object]" === Object.prototype.toString.call(i) ? (e[n] = e[n] || {}, u.extend(e[n], i)) : e[n] = i);
                    }
                    return e;
                },
                each: function(e, t, n) {
                    if ("[object Object]" === Object.prototype.toString.call(e)) for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && t.call(n, i, e[i], e);
                    else for(var o = 0, r = e.length; o < r; o++)t.call(n, o, e[o], e);
                },
                createElement: function(e, t) {
                    var n, i = document.createElement(e);
                    if (t && "[object Object]" === Object.prototype.toString.call(t)) for(n in t)n in i ? i[n] = t[n] : "html" === n ? i.innerHTML = t[n] : i.setAttribute(n, t[n]);
                    return i;
                },
                hasClass: function(e, t) {
                    if (e) return e.classList ? e.classList.contains(t) : !!e.className && !!e.className.match(new RegExp("(\\s|^)" + t + "(\\s|$)"));
                },
                addClass: function(e, t) {
                    u.hasClass(e, t) || (e.classList ? e.classList.add(t) : e.className = e.className.trim() + " " + t);
                },
                removeClass: function(e, t) {
                    u.hasClass(e, t) && (e.classList ? e.classList.remove(t) : e.className = e.className.replace(new RegExp("(^|\\s)" + t.split(" ").join("|") + "(\\s|$)", "gi"), " "));
                },
                closest: function(e, t) {
                    return e && e !== document.body && (t(e) ? e : u.closest(e.parentNode, t));
                },
                isInt: function(e) {
                    return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
                },
                debounce: function(i, o, r) {
                    var s;
                    return function() {
                        var e = this, t = arguments, n = r && !s;
                        clearTimeout(s), s = setTimeout(function() {
                            s = null, r || i.apply(e, t);
                        }, o), n && i.apply(e, t);
                    };
                },
                rect: function(e, t) {
                    var n = window, e = e.getBoundingClientRect(), i = t ? n.pageXOffset : 0, t = t ? n.pageYOffset : 0;
                    return {
                        bottom: e.bottom + t,
                        height: e.height,
                        left: e.left + i,
                        right: e.right + i,
                        top: e.top + t,
                        width: e.width
                    };
                },
                includes: function(e, t) {
                    return -1 < e.indexOf(t);
                },
                startsWith: function(e, t) {
                    return e.substr(0, t.length) === t;
                },
                truncate: function(e) {
                    for(; e.firstChild;)e.removeChild(e.firstChild);
                }
            };
            function h(e, t) {
                return e.hasOwnProperty(t) && (!0 === e[t] || e[t].length);
            }
            function g(e, t, n) {
                e.parentNode ? e.parentNode.parentNode || t.appendChild(e.parentNode) : t.appendChild(e), u.removeClass(e, "excluded"), n || (e.textContent = e.textContent);
            }
            function o() {
                var n, e;
                this.items.length && (n = document.createDocumentFragment(), this.config.pagination ? (e = this.pages.slice(0, this.pageIndex), u.each(e, function(e, t) {
                    u.each(t, function(e, t) {
                        g(t, n, this.customOption);
                    }, this);
                }, this)) : u.each(this.items, function(e, t) {
                    g(t, n, this.customOption);
                }, this), n.childElementCount && (u.removeClass(this.items[this.navIndex], "active"), this.navIndex = (n.querySelector(".selectr-option.selected") || n.querySelector(".selectr-option")).idx, u.addClass(this.items[this.navIndex], "active")), this.tree.appendChild(n));
            }
            function d(e, t) {
                t = t || e;
                var n = {
                    class: "selectr-option",
                    role: "treeitem",
                    "aria-selected": !1
                };
                return this.customOption ? n.html = this.config.renderOption(t) : n.textContent = e.textContent, (t = u.createElement("li", n)).idx = e.idx, this.items.push(t), e.defaultSelected && this.defaultSelected.push(e.idx), e.disabled && (t.disabled = !0, u.addClass(t, "disabled")), t;
            }
            function r() {
                var n, e = this.tree, t = e.scrollTop;
                e.scrollHeight - e.offsetHeight <= t && this.pageIndex < this.pages.length && (n = document.createDocumentFragment(), u.each(this.pages[this.pageIndex], function(e, t) {
                    g(t, n, this.customOption);
                }, this), e.appendChild(n), this.pageIndex++, this.emit("selectr.paginate", {
                    items: this.items.length,
                    total: this.data.length,
                    page: this.pageIndex,
                    pages: this.pages.length
                }));
            }
            function s() {
                (this.config.searchable || this.config.taggable) && (this.input.value = null, this.searching = !1, this.config.searchable && u.removeClass(this.inputContainer, "active"), u.hasClass(this.container, "notice") && (u.removeClass(this.container, "notice"), u.addClass(this.container, "open"), this.input.focus()), u.each(this.items, function(e, t) {
                    u.removeClass(t, "excluded"), this.customOption || (t.textContent = t.textContent);
                }, this));
            }
            function t(e, t) {
                if (!e) throw new Error("You must supply either a HTMLSelectElement or a CSS3 selector string.");
                if ("string" == typeof (this.el = e) && (this.el = document.querySelector(e)), null === this.el) throw new Error("The element you passed to Selectr can not be found.");
                if ("select" !== this.el.nodeName.toLowerCase()) throw new Error("The element you passed to Selectr is not a HTMLSelectElement.");
                this.render(t);
            }
            t.prototype.render = function(e) {
                var t;
                this.rendered || ((this.el.selectr = this).config = u.extend({
                    defaultSelected: !0,
                    width: "auto",
                    disabled: !1,
                    disabledMobile: !1,
                    searchable: !0,
                    clearable: !1,
                    sortSelected: !1,
                    allowDeselect: !1,
                    closeOnScroll: !1,
                    nativeDropdown: !1,
                    nativeKeyboard: !1,
                    placeholder: "Select an option...",
                    taggable: !1,
                    tagPlaceholder: "Enter a tag...",
                    messages: {
                        noResults: "No results.",
                        noOptions: "No options available.",
                        maxSelections: "A maximum of {max} items can be selected.",
                        tagDuplicate: "That tag is already in use.",
                        searchPlaceholder: "Search options..."
                    }
                }, e), this.originalType = this.el.type, this.originalIndex = this.el.tabIndex, this.defaultSelected = [], this.originalOptionCount = this.el.options.length, (this.config.multiple || this.config.taggable) && (this.el.multiple = !0), this.disabled = h(this.config, "disabled"), this.opened = !1, this.config.taggable && (this.config.searchable = !1), this.navigating = !1, this.mobileDevice = !1, !this.config.disabledMobile && /Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent) && (this.mobileDevice = !0), this.customOption = this.config.hasOwnProperty("renderOption") && "function" == typeof this.config.renderOption, this.customSelected = this.config.hasOwnProperty("renderSelection") && "function" == typeof this.config.renderSelection, this.supportsEventPassiveOption = this.detectEventPassiveOption(), i.mixin(this), (function() {
                    this.requiresPagination = this.config.pagination && 0 < this.config.pagination, h(this.config, "width") && (u.isInt(this.config.width) ? this.width = this.config.width + "px" : "auto" === this.config.width ? this.width = "100%" : u.includes(this.config.width, "%") && (this.width = this.config.width)), this.container = u.createElement("div", {
                        class: "selectr-container"
                    }), this.config.customClass && u.addClass(this.container, this.config.customClass), this.mobileDevice ? u.addClass(this.container, "selectr-mobile") : u.addClass(this.container, "selectr-desktop"), this.el.tabIndex = -1, this.config.nativeDropdown || this.mobileDevice ? u.addClass(this.el, "selectr-visible") : u.addClass(this.el, "selectr-hidden"), this.selected = u.createElement("div", {
                        class: "selectr-selected",
                        disabled: this.disabled,
                        tabIndex: 0,
                        "aria-expanded": !1
                    }), this.label = u.createElement(this.el.multiple ? "ul" : "span", {
                        class: "selectr-label"
                    });
                    var e = u.createElement("div", {
                        class: "selectr-options-container"
                    });
                    if (this.tree = u.createElement("ul", {
                        class: "selectr-options",
                        role: "tree",
                        "aria-hidden": !0,
                        "aria-expanded": !1
                    }), this.notice = u.createElement("div", {
                        class: "selectr-notice"
                    }), this.el.setAttribute("aria-hidden", !0), this.disabled && (this.el.disabled = !0), this.el.multiple ? (u.addClass(this.label, "selectr-tags"), u.addClass(this.container, "multiple"), this.tags = [], this.selectedValues = this.config.defaultSelected ? this.getSelectedProperties("value") : [], this.selectedIndexes = this.getSelectedProperties("idx")) : (this.selectedValue = null, this.selectedIndex = -1), this.selected.appendChild(this.label), this.config.clearable && (this.selectClear = u.createElement("button", {
                        class: "selectr-clear",
                        type: "button"
                    }), this.container.appendChild(this.selectClear), u.addClass(this.container, "clearable")), this.config.taggable) {
                        var t = u.createElement("li", {
                            class: "input-tag"
                        });
                        if (this.input = u.createElement("input", {
                            class: "selectr-tag-input",
                            placeholder: this.config.tagPlaceholder,
                            tagIndex: 0,
                            autocomplete: "off",
                            autocorrect: "off",
                            autocapitalize: "off",
                            spellcheck: "false",
                            role: "textbox",
                            type: "search"
                        }), t.appendChild(this.input), this.label.appendChild(t), u.addClass(this.container, "taggable"), this.tagSeperators = [
                            ","
                        ], this.config.tagSeperators) {
                            this.tagSeperators = this.tagSeperators.concat(this.config.tagSeperators);
                            for(var n = [], i = 0; i < this.tagSeperators.length; i++)n.push(u.escapeRegExp(this.tagSeperators[i]));
                            this.tagSeperatorsRegex = new RegExp(n.join("|"), "i");
                        } else this.tagSeperatorsRegex = new RegExp(",", "i");
                    }
                    this.config.searchable && (this.input = u.createElement("input", {
                        class: "selectr-input",
                        tagIndex: -1,
                        autocomplete: "off",
                        autocorrect: "off",
                        autocapitalize: "off",
                        spellcheck: "false",
                        role: "textbox",
                        type: "search",
                        placeholder: this.config.messages.searchPlaceholder
                    }), this.inputClear = u.createElement("button", {
                        class: "selectr-input-clear",
                        type: "button"
                    }), this.inputContainer = u.createElement("div", {
                        class: "selectr-input-container"
                    }), this.inputContainer.appendChild(this.input), this.inputContainer.appendChild(this.inputClear), e.appendChild(this.inputContainer)), e.appendChild(this.notice), e.appendChild(this.tree), this.items = [], this.options = [], this.el.options.length && (this.options = [].slice.call(this.el.options));
                    var o, r, s, a = !1, l = 0;
                    this.el.children.length && u.each(this.el.children, function(e, t) {
                        "OPTGROUP" === t.nodeName ? (a = u.createElement("ul", {
                            class: "selectr-optgroup",
                            role: "group",
                            html: "<li class='selectr-optgroup--label'>" + t.label + "</li>"
                        }), u.each(t.children, function(e, t) {
                            t.idx = l, a.appendChild(d.call(this, t, a)), l++;
                        }, this)) : (t.idx = l, d.call(this, t), l++);
                    }, this), this.config.data && Array.isArray(this.config.data) && (o = (this.data = [], false), a = !1, l = 0, u.each(this.config.data, function(e, t) {
                        h(t, "children") ? (o = u.createElement("optgroup", {
                            label: t.text
                        }), a = u.createElement("ul", {
                            class: "selectr-optgroup",
                            role: "group",
                            html: "<li class='selectr-optgroup--label'>" + t.text + "</li>"
                        }), u.each(t.children, function(e, t) {
                            (r = new Option(t.text, t.value, !1, t.hasOwnProperty("selected") && !0 === t.selected)).disabled = h(t, "disabled"), this.options.push(r), o.appendChild(r), r.idx = l, a.appendChild(d.call(this, r, t)), this.data[l] = t, l++;
                        }, this), this.el.appendChild(o)) : ((r = new Option(t.text, t.value, !1, t.hasOwnProperty("selected") && !0 === t.selected)).disabled = h(t, "disabled"), this.options.push(r), r.idx = l, d.call(this, r, t), this.data[l] = t, l++);
                    }, this)), this.setSelected(!0);
                    for(var c = this.navIndex = 0; c < this.items.length; c++)if (s = this.items[c], !u.hasClass(s, "disabled")) {
                        u.addClass(s, "active"), this.navIndex = c;
                        break;
                    }
                    this.requiresPagination && (this.pageIndex = 1, this.paginate()), this.container.appendChild(this.selected), this.container.appendChild(e), this.placeEl = u.createElement("div", {
                        class: "selectr-placeholder"
                    }), this.setPlaceholder(), this.selected.appendChild(this.placeEl), this.disabled && this.disable(), this.el.parentNode.insertBefore(this.container, this.el), this.container.appendChild(this.el);
                }).call(this), this.bindEvents(), this.update(), this.optsRect = u.rect(this.tree), this.rendered = !0, this.el.multiple || (this.el.selectedIndex = this.selectedIndex), t = this, setTimeout(function() {
                    t.emit("selectr.init");
                }, 20));
            }, t.prototype.getSelected = function() {
                return this.el.querySelectorAll("option:checked");
            }, t.prototype.getSelectedProperties = function(t) {
                var e = this.getSelected();
                return [].slice.call(e).map(function(e) {
                    return e[t];
                }).filter(function(e) {
                    return null != e;
                });
            }, t.prototype.detectEventPassiveOption = function() {
                var e = !1;
                try {
                    var t = Object.defineProperty({}, "passive", {
                        get: function() {
                            e = !0;
                        }
                    });
                    window.addEventListener("test", null, t);
                } catch (e) {}
                return e;
            }, t.prototype.bindEvents = function() {
                var n, i = this;
                this.events = {}, this.events.dismiss = (function(e) {
                    e = e.target;
                    this.container.contains(e) || !this.opened && !u.hasClass(this.container, "notice") || this.close();
                }).bind(this), this.events.navigate = (function(e) {
                    if (e = e || window.event, this.items.length && this.opened && u.includes([
                        13,
                        38,
                        40
                    ], e.which)) {
                        if (e.preventDefault(), 13 === e.which) return !(this.noResults || this.config.taggable && 0 < this.input.value.length) && this.change(this.navIndex);
                        var t, n = this.items[this.navIndex], i = this.navIndex;
                        switch(e.which){
                            case 38:
                                (t = 0) < this.navIndex && this.navIndex--;
                                break;
                            case 40:
                                this.navIndex < this.items.length - (t = 1) && this.navIndex++;
                        }
                        for(this.navigating = !0; u.hasClass(this.items[this.navIndex], "disabled") || u.hasClass(this.items[this.navIndex], "excluded");){
                            if (!(0 < this.navIndex && this.navIndex < this.items.length - 1)) {
                                this.navIndex = i;
                                break;
                            }
                            if (t ? this.navIndex++ : this.navIndex--, this.searching) {
                                if (this.navIndex > this.tree.lastElementChild.idx) {
                                    this.navIndex = this.tree.lastElementChild.idx;
                                    break;
                                }
                                if (this.navIndex < this.tree.firstElementChild.idx) {
                                    this.navIndex = this.tree.firstElementChild.idx;
                                    break;
                                }
                            }
                        }
                        e = u.rect(this.items[this.navIndex]);
                        t ? (0 === this.navIndex ? this.tree.scrollTop = 0 : e.top + e.height > this.optsRect.top + this.optsRect.height && (this.tree.scrollTop = this.tree.scrollTop + (e.top + e.height - (this.optsRect.top + this.optsRect.height))), this.navIndex === this.tree.childElementCount - 1 && this.requiresPagination && r.call(this)) : 0 === this.navIndex ? this.tree.scrollTop = 0 : e.top - this.optsRect.top < 0 && (this.tree.scrollTop = this.tree.scrollTop + (e.top - this.optsRect.top)), n && u.removeClass(n, "active"), u.addClass(this.items[this.navIndex], "active");
                    } else this.navigating = !1;
                }).bind(this), this.events.reset = this.reset.bind(this), (this.config.nativeDropdown || this.mobileDevice) && (this.container.addEventListener("touchstart", function(e) {
                    e.changedTouches[0].target === i.el && i.toggle();
                }, !!this.supportsEventPassiveOption && {
                    passive: !0
                }), this.container.addEventListener("click", function(e) {
                    e.target === i.el && i.toggle();
                }), this.el.addEventListener("change", function(e) {
                    e.__selfTriggered || (i.el.multiple ? (e = i.getSelectedProperties("idx"), e = function(e, t) {
                        for(var n, i = [], o = e.slice(0), r = 0; r < t.length; r++)-1 < (n = o.indexOf(t[r])) ? o.splice(n, 1) : i.push(t[r]);
                        return [
                            i,
                            o
                        ];
                    }(i.selectedIndexes, e), u.each(e[0], function(e, t) {
                        i.select(t);
                    }, i), u.each(e[1], function(e, t) {
                        i.deselect(t);
                    }, i)) : -1 < i.el.selectedIndex && i.select(i.el.selectedIndex));
                })), this.config.nativeDropdown && this.container.addEventListener("keydown", function(e) {
                    "Enter" === e.key && i.selected === document.activeElement && (i.toggle(), setTimeout(function() {
                        i.el.focus();
                    }, 200));
                }), this.selected.addEventListener("click", function(e) {
                    i.disabled || i.toggle(), e.preventDefault();
                }), this.config.nativeKeyboard && (n = "", this.selected.addEventListener("keydown", function(e) {
                    var t;
                    i.disabled || i.selected !== document.activeElement || e.altKey || e.ctrlKey || e.metaKey || (" " === e.key || !i.opened && -1 < [
                        "Enter",
                        "ArrowUp",
                        "ArrowDown"
                    ].indexOf(e.key) ? (i.toggle(), e.preventDefault(), e.stopPropagation()) : e.key.length <= 2 && String[String.fromCodePoint ? "fromCodePoint" : "fromCharCode"](e.key[String.codePointAt ? "codePointAt" : "charCodeAt"](0)) === e.key && (i.config.multiple ? (i.open(), i.config.searchable && (i.input.value = e.key, i.input.focus(), i.search(null, !0))) : (n += e.key, (t = i.search(n, !0)) && t.length && (i.clear(), i.setValue(t[0].value)), setTimeout(function() {
                        n = "";
                    }, 1e3)), e.preventDefault(), e.stopPropagation()));
                }), this.container.addEventListener("keyup", function(e) {
                    i.opened && "Escape" === e.key && (i.close(), e.stopPropagation(), i.selected.focus());
                })), this.label.addEventListener("click", function(e) {
                    u.hasClass(e.target, "selectr-tag-remove") && i.deselect(e.target.parentNode.idx);
                }), this.selectClear && this.selectClear.addEventListener("click", this.clear.bind(this)), this.tree.addEventListener("mousedown", function(e) {
                    e.preventDefault();
                }), this.tree.addEventListener("click", function(e) {
                    var t = u.closest(e.target, function(e) {
                        return e && u.hasClass(e, "selectr-option");
                    });
                    t && !u.hasClass(t, "disabled") && (u.hasClass(t, "selected") ? (i.el.multiple || !i.el.multiple && i.config.allowDeselect) && i.deselect(t.idx) : i.select(t.idx), i.opened && !i.el.multiple) && i.close(), e.preventDefault(), e.stopPropagation();
                }), this.tree.addEventListener("mouseover", function(e) {
                    !u.hasClass(e.target, "selectr-option") || u.hasClass(e.target, "disabled") || (u.removeClass(i.items[i.navIndex], "active"), u.addClass(e.target, "active"), i.navIndex = [].slice.call(i.items).indexOf(e.target));
                }), this.config.searchable && (this.input.addEventListener("focus", function(e) {
                    i.searching = !0;
                }), this.input.addEventListener("blur", function(e) {
                    i.searching = !1;
                }), this.input.addEventListener("keyup", function(e) {
                    i.search(), i.config.taggable || (this.value.length ? u.addClass(this.parentNode, "active") : u.removeClass(this.parentNode, "active"));
                }), this.inputClear.addEventListener("click", function(e) {
                    i.input.value = null, s.call(i), i.tree.childElementCount || o.call(i);
                })), this.config.taggable && this.input.addEventListener("keyup", function(e) {
                    var t, n;
                    i.search(), i.config.taggable && this.value.length && (t = this.value.trim()).length && (13 === e.which || i.tagSeperatorsRegex.test(t)) && (e = t.replace(i.tagSeperatorsRegex, ""), (n = (e = (e = u.escapeRegExp(e)).trim()).length ? i.add({
                        value: e,
                        textContent: e,
                        selected: !0
                    }, !0) : n) ? (i.close(), s.call(i)) : (this.value = "", i.setMessage(i.config.messages.tagDuplicate)));
                }), this.update = u.debounce(function() {
                    i.opened && i.config.closeOnScroll && i.close(), i.width && (i.container.style.width = i.width), i.invert();
                }, 50), this.requiresPagination && (this.paginateItems = u.debounce(function() {
                    r.call(this);
                }, 50), this.tree.addEventListener("scroll", this.paginateItems.bind(this))), document.addEventListener("click", this.events.dismiss), window.addEventListener("keydown", this.events.navigate), window.addEventListener("resize", this.update), window.addEventListener("scroll", this.update), this.on("selectr.destroy", function() {
                    document.removeEventListener("click", this.events.dismiss), window.removeEventListener("keydown", this.events.navigate), window.removeEventListener("resize", this.update), window.removeEventListener("scroll", this.update);
                }), this.el.form && (this.el.form.addEventListener("reset", this.events.reset), this.on("selectr.destroy", function() {
                    this.el.form.removeEventListener("reset", this.events.reset);
                }));
            }, t.prototype.setSelected = function(e) {
                var n;
                this.config.data || this.el.multiple || !this.el.options.length || (0 !== this.el.selectedIndex || this.el.options[0].defaultSelected || this.config.defaultSelected || (this.el.selectedIndex = -1), this.selectedIndex = this.el.selectedIndex, -1 < this.selectedIndex && this.select(this.selectedIndex)), this.config.multiple && "select-one" === this.originalType && !this.config.data && this.el.options[0].selected && !this.el.options[0].defaultSelected && (this.el.options[0].selected = !1), u.each(this.options, function(e, t) {
                    t.selected && t.defaultSelected && this.select(t.idx);
                }, this), this.config.selectedValue && this.setValue(this.config.selectedValue), this.config.data && (!this.el.multiple && this.config.defaultSelected && this.el.selectedIndex < 0 && 0 < this.config.data.length && this.select(0), n = 0, u.each(this.config.data, function(e, t) {
                    h(t, "children") ? u.each(t.children, function(e, t) {
                        t.hasOwnProperty("selected") && !0 === t.selected && this.select(n), n++;
                    }, this) : (t.hasOwnProperty("selected") && !0 === t.selected && this.select(n), n++);
                }, this));
            }, t.prototype.destroy = function() {
                this.rendered && (this.emit("selectr.destroy"), "select-one" === this.originalType && (this.el.multiple = !1), this.config.data && (this.el.innerHTML = ""), u.removeClass(this.el, "selectr-hidden"), this.container.parentNode.replaceChild(this.el, this.container), this.rendered = !1, delete this.el.selectr);
            }, t.prototype.change = function(e) {
                var t = this.items[e], n = this.options[e];
                n.disabled || (n.selected && u.hasClass(t, "selected") ? this.deselect(e) : this.select(e), this.opened && !this.el.multiple && this.close());
            }, t.prototype.select = function(i) {
                var e = this.items[i], t = [].slice.call(this.el.options), n = this.options[i];
                if (this.el.multiple) {
                    if (u.includes(this.selectedIndexes, i)) return !1;
                    if (this.config.maxSelections && this.tags.length === this.config.maxSelections) return this.setMessage(this.config.messages.maxSelections.replace("{max}", this.config.maxSelections), !0), !1;
                    this.selectedValues.push(n.value), this.selectedIndexes.push(i), (function(e) {
                        var l, c = this, n = document.createDocumentFragment(), t = this.options[e.idx], i = this.data ? this.data[e.idx] : t, o = {
                            class: "selectr-tag"
                        }, i = (this.customSelected ? o.html = this.config.renderSelection(i) : o.textContent = t.textContent, u.createElement("li", o)), o = u.createElement("button", {
                            class: "selectr-tag-remove",
                            type: "button"
                        });
                        i.appendChild(o), i.idx = e.idx, i.tag = t.value, this.tags.push(i), this.config.sortSelected ? (o = this.tags.slice(), l = function(e, i) {
                            e.replace(/(\d+)|(\D+)/g, function(e, t, n) {
                                i.push([
                                    t || 1 / 0,
                                    n || ""
                                ]);
                            });
                        }, o.sort(function(e, t) {
                            var n, i, o = [], r = [];
                            for(!0 === c.config.sortSelected ? (n = e.tag, i = t.tag) : "text" === c.config.sortSelected && (n = e.textContent, i = t.textContent), l(n, o), l(i, r); o.length && r.length;){
                                var s = o.shift(), a = r.shift(), s = s[0] - a[0] || s[1].localeCompare(a[1]);
                                if (s) return s;
                            }
                            return o.length - r.length;
                        }), u.each(o, function(e, t) {
                            n.appendChild(t);
                        }), this.label.innerHTML = "") : n.appendChild(i), this.config.taggable ? this.label.insertBefore(n, this.input.parentNode) : this.label.appendChild(n);
                    }).call(this, e);
                } else {
                    var o = this.data ? this.data[i] : n;
                    this.customSelected ? this.label.innerHTML = this.config.renderSelection(o) : this.label.textContent = n.textContent, this.selectedValue = n.value, this.selectedIndex = i, u.each(this.options, function(e, t) {
                        var n = this.items[e];
                        e !== i && (n && u.removeClass(n, "selected"), t.selected = !1, t.removeAttribute("selected"));
                    }, this);
                }
                u.includes(t, n) || this.el.add(n), e.setAttribute("aria-selected", !0), u.addClass(e, "selected"), u.addClass(this.container, "has-selected"), n.selected = !0, n.setAttribute("selected", ""), this.emit("selectr.change", n), this.emit("selectr.select", n), "createEvent" in document ? ((o = document.createEvent("HTMLEvents")).initEvent("change", !0, !0), o.__selfTriggered = !0, this.el.dispatchEvent(o)) : this.el.fireEvent("onchange");
            }, t.prototype.deselect = function(e, t) {
                var n = this.items[e], i = this.options[e];
                if (this.el.multiple) {
                    var o = this.selectedIndexes.indexOf(e), o = (this.selectedIndexes.splice(o, 1), this.selectedValues.indexOf(i.value));
                    this.selectedValues.splice(o, 1), (function(n) {
                        var i = !1;
                        u.each(this.tags, function(e, t) {
                            t.idx === n.idx && (i = t);
                        }, this), i && (this.label.removeChild(i), this.tags.splice(this.tags.indexOf(i), 1));
                    }).call(this, n), this.tags.length || u.removeClass(this.container, "has-selected");
                } else {
                    if (!t && !this.config.clearable && !this.config.allowDeselect) return !1;
                    this.label.innerHTML = "", this.selectedValue = null, this.el.selectedIndex = this.selectedIndex = -1, u.removeClass(this.container, "has-selected");
                }
                this.items[e].setAttribute("aria-selected", !1), u.removeClass(this.items[e], "selected"), i.selected = !1, i.removeAttribute("selected"), this.emit("selectr.change", null), this.emit("selectr.deselect", i), "createEvent" in document ? ((o = document.createEvent("HTMLEvents")).initEvent("change", !0, !0), o.__selfTriggered = !0, this.el.dispatchEvent(o)) : this.el.fireEvent("onchange");
            }, t.prototype.setValue = function(n) {
                var i = Array.isArray(n);
                if (i || (n = n.toString().trim()), !this.el.multiple && i) return !1;
                u.each(this.options, function(e, t) {
                    (i && -1 < n.indexOf(t.value) || t.value === n) && this.change(t.idx);
                }, this);
            }, t.prototype.getValue = function(e, t) {
                var n, i;
                return this.el.multiple ? e ? this.selectedIndexes.length && (i = {
                    values: []
                }, u.each(this.selectedIndexes, function(e, t) {
                    t = this.options[t];
                    i.values[e] = {
                        value: t.value,
                        text: t.textContent
                    };
                }, this)) : i = this.selectedValues.slice() : i = e ? {
                    value: (n = this.options[this.selectedIndex]).value,
                    text: n.textContent
                } : this.selectedValue, i = e && t ? JSON.stringify(i) : i;
            }, t.prototype.add = function(n, i) {
                if (n) {
                    if (this.data = this.data || [], this.items = this.items || [], this.options = this.options || [], Array.isArray(n)) u.each(n, function(e, t) {
                        this.add(t, i);
                    }, this);
                    else if ("[object Object]" === Object.prototype.toString.call(n)) {
                        if (i) {
                            var o = !1;
                            if (u.each(this.options, function(e, t) {
                                t.value.toLowerCase() === n.value.toLowerCase() && (o = !0);
                            }), o) return !1;
                        }
                        var e = u.createElement("option", n);
                        return this.data.push(n), this.mobileDevice && this.el.add(e), this.options.push(e), e.idx = 0 < this.options.length ? this.options.length - 1 : 0, d.call(this, e), n.selected && this.select(e.idx), this.setPlaceholder(), e;
                    }
                    return this.config.pagination && this.paginate(), !0;
                }
            }, t.prototype.remove = function(e) {
                var n, i = [];
                Array.isArray(e) ? u.each(e, function(e, t) {
                    u.isInt(t) ? i.push(this.getOptionByIndex(t)) : "string" == typeof t && i.push(this.getOptionByValue(t));
                }, this) : u.isInt(e) ? i.push(this.getOptionByIndex(e)) : "string" == typeof e && i.push(this.getOptionByValue(e)), i.length && (u.each(i, function(e, t) {
                    n = t.idx, this.el.remove(t), this.options.splice(n, 1);
                    t = this.items[n].parentNode;
                    t && t.removeChild(this.items[n]), this.items.splice(n, 1), u.each(this.options, function(e, t) {
                        t.idx = e, this.items[e].idx = e;
                    }, this);
                }, this), this.setPlaceholder(), this.config.pagination) && this.paginate();
            }, t.prototype.removeAll = function() {
                this.clear(!0), u.each(this.el.options, function(e, t) {
                    this.el.remove(t);
                }, this), u.truncate(this.tree), this.items = [], this.options = [], this.data = [], this.navIndex = 0, this.requiresPagination && (this.requiresPagination = !1, this.pageIndex = 1, this.pages = []), this.setPlaceholder();
            }, t.prototype.search = function(a, e) {
                var l, c, h, d, t;
                if (!this.navigating) return l = !1, a || (a = this.input.value, l = !0, this.removeMessage(), u.truncate(this.tree)), c = [], h = document.createDocumentFragment(), 0 < (a = a.trim().toLowerCase()).length ? (d = e ? u.startsWith : u.includes, u.each(this.options, function(e, t) {
                    var n, i, o, r, s = this.items[t.idx];
                    d(t.textContent.trim().toLowerCase(), a) && !t.disabled ? (c.push({
                        text: t.textContent,
                        value: t.value
                    }), l && (g(s, h, this.customOption), u.removeClass(s, "excluded"), !this.customOption) && (n = a, o = t.textContent, n = new RegExp(n, "ig"), r = n.exec(o)) && (t.innerHTML = "", (i = document.createElement("span")).classList.add("selectr-match"), i.textContent = r[0], t.appendChild(document.createTextNode(o.substring(0, r.index))), t.appendChild(i), t.appendChild(document.createTextNode(o.substring(n.lastIndex))))) : l && u.addClass(s, "excluded");
                }, this), l && (h.childElementCount ? (e = this.items[this.navIndex], t = h.querySelector(".selectr-option:not(.excluded)"), this.noResults = !1, u.removeClass(e, "active"), this.navIndex = t.idx, u.addClass(t, "active")) : this.config.taggable || (this.noResults = !0, this.setMessage(this.config.messages.noResults)), this.tree.appendChild(h))) : o.call(this), c;
            }, t.prototype.toggle = function() {
                this.disabled || (this.opened ? this.close() : this.open());
            }, t.prototype.open = function() {
                var e = this;
                if (!this.options.length) return !1;
                this.opened || this.emit("selectr.open"), this.opened = !0, this.mobileDevice || this.config.nativeDropdown ? (u.addClass(this.container, "native-open"), this.config.data && u.each(this.options, function(e, t) {
                    this.el.add(t);
                }, this)) : (u.addClass(this.container, "open"), o.call(this), this.invert(), this.tree.scrollTop = 0, u.removeClass(this.container, "notice"), this.selected.setAttribute("aria-expanded", !0), this.tree.setAttribute("aria-hidden", !1), this.tree.setAttribute("aria-expanded", !0), this.config.searchable && !this.config.taggable && setTimeout(function() {
                    e.input.focus(), e.input.tabIndex = 0;
                }, 10));
            }, t.prototype.close = function() {
                var e;
                this.opened && this.emit("selectr.close"), this.opened = !1, this.navigating = !1, this.mobileDevice || this.config.nativeDropdown ? u.removeClass(this.container, "native-open") : (e = u.hasClass(this.container, "notice"), this.config.searchable && !e && (this.input.blur(), this.input.tabIndex = -1, this.searching = !1), e && (u.removeClass(this.container, "notice"), this.notice.textContent = ""), u.removeClass(this.container, "open"), u.removeClass(this.container, "native-open"), this.selected.setAttribute("aria-expanded", !1), this.tree.setAttribute("aria-hidden", !0), this.tree.setAttribute("aria-expanded", !1), u.truncate(this.tree), s.call(this));
            }, t.prototype.enable = function() {
                this.disabled = !1, this.el.disabled = !1, this.selected.tabIndex = this.originalIndex, this.el.multiple && u.each(this.tags, function(e, t) {
                    t.lastElementChild.tabIndex = 0;
                }), u.removeClass(this.container, "selectr-disabled");
            }, t.prototype.disable = function(e) {
                e || (this.el.disabled = !0), this.selected.tabIndex = -1, this.el.multiple && u.each(this.tags, function(e, t) {
                    t.lastElementChild.tabIndex = -1;
                }), this.disabled = !0, u.addClass(this.container, "selectr-disabled");
            }, t.prototype.reset = function() {
                this.disabled || (this.clear(), this.setSelected(!0), u.each(this.defaultSelected, function(e, t) {
                    this.select(t);
                }, this), this.emit("selectr.reset"));
            }, t.prototype.clear = function(e, t) {
                var n;
                this.el.multiple ? this.selectedIndexes.length && (n = this.selectedIndexes.slice(), t ? this.deselect(n.slice(-1)[0]) : u.each(n, function(e, t) {
                    this.deselect(t);
                }, this)) : -1 < this.selectedIndex && this.deselect(this.selectedIndex, e), this.emit("selectr.clear");
            }, t.prototype.serialise = function(e) {
                var i = [];
                return u.each(this.options, function(e, t) {
                    var n = {
                        value: t.value,
                        text: t.textContent
                    };
                    t.selected && (n.selected = !0), t.disabled && (n.disabled = !0), i[e] = n;
                }), e ? JSON.stringify(i) : i;
            }, t.prototype.serialize = function(e) {
                return this.serialise(e);
            }, t.prototype.setPlaceholder = function(e) {
                e = e || this.config.placeholder || this.el.getAttribute("placeholder"), this.options.length || (e = this.config.messages.noOptions), this.placeEl.innerHTML = e;
            }, t.prototype.paginate = function() {
                var n;
                if (this.items.length) return (n = this).pages = this.items.map(function(e, t) {
                    return t % n.config.pagination == 0 ? n.items.slice(t, t + n.config.pagination) : null;
                }).filter(function(e) {
                    return e;
                }), this.pages;
            }, t.prototype.setMessage = function(e, t) {
                t && this.close(), u.addClass(this.container, "notice"), this.notice.textContent = e;
            }, t.prototype.removeMessage = function() {
                u.removeClass(this.container, "notice"), this.notice.innerHTML = "";
            }, t.prototype.invert = function() {
                var e = u.rect(this.selected), t = this.tree.parentNode.offsetHeight, n = window.innerHeight;
                e.top + e.height + t > n ? (u.addClass(this.container, "inverted"), this.isInverted = !0) : (u.removeClass(this.container, "inverted"), this.isInverted = !1), this.optsRect = u.rect(this.tree);
            }, t.prototype.getOptionByIndex = function(e) {
                return this.options[e];
            }, t.prototype.getOptionByValue = function(e) {
                for(var t = !1, n = 0, i = this.options.length; n < i; n++)if (this.options[n].value.trim() === e.toString().trim()) {
                    t = this.options[n];
                    break;
                }
                return t;
            }, e.exports = t;
        },
        4188: function(e, t, n) {
            "use strict";
            n.d(t, {
                EX: function() {
                    return o;
                },
                WF: function() {
                    return r;
                },
                oW: function() {
                    return s;
                },
                qD: function() {
                    return i;
                }
            });
            var i = document.body, o = 10485760, r = 2e4, s = 2147483648;
        },
        2602: function(e, t, n) {
            "use strict";
            n.d(t, {
                w: function() {
                    return i;
                }
            });
            var u = n(9791);
            function i(n, e, i) {
                var t, o = 3 < arguments.length && void 0 !== arguments[3] && arguments[3], r = "function" == typeof (a = n).getRootNode ? a.getRootNode() : window, s = {}, a = n.getBoundingClientRect(), l = e.getBoundingClientRect(), c = document.createElement("div");
                function h() {
                    if (c && c.parentNode) {
                        for(var e in c.parentNode.removeChild(c), s)t = e, Object.prototype.hasOwnProperty.call(s, t) && ((t = s[e]) && (0, u.removeEventListener)(r, e, t), delete s[e]);
                        "function" == typeof i && i(n);
                    }
                    var t;
                }
                function d(e) {
                    (e = e.target) === c || (0, u.isChildOf)(e, c) || h();
                }
                return c.className = "jsoneditor-anchor", c.style.position = "absolute", c.style.left = a.left - l.left + "px", c.style.top = a.top - l.top + "px", c.style.width = a.width - 2 + "px", c.style.height = a.height - 2 + "px", c.style.boxSizing = "border-box", e.appendChild(c), s.mousedown = (0, u.addEventListener)(r, "mousedown", d), s.mousewheel = (0, u.addEventListener)(r, "mousewheel", d), o && (t = null, c.onmouseover = function() {
                    clearTimeout(t), t = null;
                }, c.onmouseout = function() {
                    t = t || setTimeout(h, 200);
                }), c.destroy = h, c;
            }
        },
        7923: function(e) {
            e.exports = "data:application/javascript;base64,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";
        },
        7907: function(e, t, n) {
            "use strict";
            n.d(t, {
                Iu: function() {
                    return h;
                },
                cC: function() {
                    return c;
                },
                m0: function() {
                    return l;
                }
            });
            n(4987);
            var r = {
                en: {
                    array: "Array",
                    auto: "Auto",
                    appendText: "Append",
                    appendTitle: "Append a new field with type 'auto' after this field (Ctrl+Shift+Ins)",
                    appendSubmenuTitle: "Select the type of the field to be appended",
                    appendTitleAuto: "Append a new field with type 'auto' (Ctrl+Shift+Ins)",
                    ascending: "Ascending",
                    ascendingTitle: "Sort the childs of this ${type} in ascending order",
                    actionsMenu: "Click to open the actions menu (Ctrl+M)",
                    cannotParseFieldError: "Cannot parse field into JSON",
                    cannotParseValueError: "Cannot parse value into JSON",
                    collapseAll: "Collapse all fields",
                    compactTitle: "Compact JSON data, remove all whitespaces (Ctrl+Shift+I)",
                    descending: "Descending",
                    descendingTitle: "Sort the childs of this ${type} in descending order",
                    drag: "Drag to move this field (Alt+Shift+Arrows)",
                    duplicateKey: "duplicate key",
                    duplicateText: "Duplicate",
                    duplicateTitle: "Duplicate selected fields (Ctrl+D)",
                    duplicateField: "Duplicate this field (Ctrl+D)",
                    duplicateFieldError: "Duplicate field name",
                    empty: "empty",
                    expandAll: "Expand all fields",
                    expandTitle: "Click to expand/collapse this field (Ctrl+E). \nCtrl+Click to expand/collapse including all childs.",
                    formatTitle: "Format JSON data, with proper indentation and line feeds (Ctrl+I)",
                    insert: "Insert",
                    insertTitle: "Insert a new field with type 'auto' before this field (Ctrl+Ins)",
                    insertSub: "Select the type of the field to be inserted",
                    object: "Object",
                    ok: "Ok",
                    redo: "Redo (Ctrl+Shift+Z)",
                    removeText: "Remove",
                    removeTitle: "Remove selected fields (Ctrl+Del)",
                    removeField: "Remove this field (Ctrl+Del)",
                    repairTitle: "Repair JSON: fix quotes and escape characters, remove comments and JSONP notation, turn JavaScript objects into JSON.",
                    searchTitle: "Search fields and values",
                    searchNextResultTitle: "Next result (Enter)",
                    searchPreviousResultTitle: "Previous result (Shift + Enter)",
                    selectNode: "Select a node...",
                    showAll: "show all",
                    showMore: "show more",
                    showMoreStatus: "displaying ${visibleChilds} of ${totalChilds} items.",
                    sort: "Sort",
                    sortTitle: "Sort the childs of this ${type}",
                    sortTitleShort: "Sort contents",
                    sortFieldLabel: "Field:",
                    sortDirectionLabel: "Direction:",
                    sortFieldTitle: "Select the nested field by which to sort the array or object",
                    sortAscending: "Ascending",
                    sortAscendingTitle: "Sort the selected field in ascending order",
                    sortDescending: "Descending",
                    sortDescendingTitle: "Sort the selected field in descending order",
                    string: "String",
                    transform: "Transform",
                    transformTitle: "Filter, sort, or transform the childs of this ${type}",
                    transformTitleShort: "Filter, sort, or transform contents",
                    extract: "Extract",
                    extractTitle: "Extract this ${type}",
                    transformQueryTitle: "Enter a JMESPath query",
                    transformWizardLabel: "Wizard",
                    transformWizardFilter: "Filter",
                    transformWizardSortBy: "Sort by",
                    transformWizardSelectFields: "Select fields",
                    transformQueryLabel: "Query",
                    transformPreviewLabel: "Preview",
                    type: "Type",
                    typeTitle: "Change the type of this field",
                    openUrl: "Ctrl+Click or Ctrl+Enter to open url in new window",
                    undo: "Undo last action (Ctrl+Z)",
                    validationCannotMove: "Cannot move a field into a child of itself",
                    autoType: 'Field type "auto". The field type is automatically determined from the value and can be a string, number, boolean, or null.',
                    objectType: 'Field type "object". An object contains an unordered set of key/value pairs.',
                    arrayType: 'Field type "array". An array contains an ordered collection of values.',
                    stringType: 'Field type "string". Field type is not determined from the value, but always returned as string.',
                    modeEditorTitle: "Switch Editor Mode",
                    modeCodeText: "Code",
                    modeCodeTitle: "Switch to code highlighter",
                    modeFormText: "Form",
                    modeFormTitle: "Switch to form editor",
                    modeTextText: "Text",
                    modeTextTitle: "Switch to plain text editor",
                    modeTreeText: "Tree",
                    modeTreeTitle: "Switch to tree editor",
                    modeViewText: "View",
                    modeViewTitle: "Switch to tree view",
                    modePreviewText: "Preview",
                    modePreviewTitle: "Switch to preview mode",
                    examples: "Examples",
                    default: "Default",
                    containsInvalidProperties: "Contains invalid properties",
                    containsInvalidItems: "Contains invalid items"
                },
                es: {
                    array: "Matriz",
                    auto: "Auto",
                    appendText: "Agregar",
                    appendTitle: "Agregue un nuevo campo con el tipo 'auto' despu\xe9s de este campo (Ctrl + Shift + Ins)",
                    appendSubmenuTitle: "Seleccione el tipo de campo que se agregar\xe1",
                    appendTitleAuto: "Agregue un nuevo campo con el tipo 'auto' (Ctrl + Shift + Ins)",
                    ascending: "Ascendente",
                    ascendingTitle: "Ordene los elementos secundarios de este ${type} en orden ascendente",
                    actionsMenu: "Haga clic para abrir el men\xfa de acciones (Ctrl + M)",
                    cannotParseFieldError: "No se puede parsear el campo en JSON",
                    cannotParseValueError: "No se puede parsear el valor en JSON",
                    collapseAll: "Contraer todos los campos",
                    compactTitle: "Compactar datos JSON, eliminar todos los espacios en blanco (Ctrl + Shift + I)",
                    descending: "Descendente",
                    descendingTitle: "Ordene los hijos de este ${type} en orden descendente",
                    drag: "Arrastre para mover este campo (Alt + May\xfas + Flechas)",
                    duplicateKey: "llave duplicada",
                    duplicateText: "Duplicar",
                    duplicateTitle: "Duplicar campos seleccionados (Ctrl + D)",
                    duplicateField: "Duplicar este campo (Ctrl + D)",
                    duplicateFieldError: "Nombre de campo duplicado",
                    empty: "vacio",
                    expandAll: "Expandir todos los campos",
                    expandTitle: "Haga clic para expandir/contraer este campo (Ctrl + E). \n  Ctrl+Clic para expandir/contraer incluyendo todos los ni\xf1os.",
                    formatTitle: "Formatee los datos JSON, con la sangr\xeda y los avances de l\xednea adecuados (Ctrl + I)",
                    insert: "Insertar",
                    insertTitle: "Inserte un nuevo campo con el tipo 'auto' antes de este campo (Ctrl + Ins)",
                    insertSub: "Seleccione el tipo de campo a insertar",
                    object: "Objeto",
                    ok: "Ok",
                    redo: "Rehacer (Ctrl+May\xfas+Z)",
                    removeText: "Eliminar",
                    removeTitle: "Eliminar campos seleccionados (Ctrl+Supr)",
                    removeField: "Eliminar este campo (Ctrl+Supr)",
                    repairTitle: "Reparar JSON: corrija comillas y caracteres de escape, elimine comentarios y notaci\xf3n JSONP, convierta objetos JavaScript en JSON.",
                    searchTitle: "Campos de b\xfasqueda y valores",
                    searchNextResultTitle: "Siguiente resultado (Entrar)",
                    searchPreviousResultTitle: "Resultado anterior (Shift + Enter)",
                    selectNode: "Seleccione un nodo...",
                    showAll: "mostrar todo",
                    showMore: "mostrar m\xe1s",
                    showMoreStatus: "mostrando ${visibleChilds} de ${totalChilds} elementos.",
                    sort: "Ordenar",
                    sortTitle: "Ordene los hijos de este ${type}",
                    sortTitleShort: "Ordenar contenidos",
                    sortFieldLabel: "Campo:",
                    sortDirectionLabel: "Direcci\xf3n:",
                    sortFieldTitle: "Seleccione el campo anidado por el cual ordenar la matriz u objeto",
                    sortAscending: "Ascendente",
                    sortAscendingTitle: "Ordenar el campo seleccionado en orden ascendente",
                    sortDescending: "Descendente",
                    sortDescendingTitle: "Ordenar por el campo seleccionado, en orden descendente",
                    string: "Texto",
                    transform: "Transformar",
                    transformTitle: "Filtrar, ordenar o transformar los hijos de este ${type}",
                    transformTitleShort: "Filtrar, ordenar o transformar contenidos",
                    extract: "Extraer",
                    extractTitle: "Extrae este ${type}",
                    transformQueryTitle: "Ingrese una consulta JMESPath",
                    transformWizardLabel: "Wizard",
                    transformWizardFilter: "Filtro",
                    transformWizardSortBy: "Ordenar por",
                    transformWizardSelectFields: "Seleccione un campo",
                    transformQueryLabel: "Consulta",
                    transformPreviewLabel: "Vista Previa",
                    type: "Tipo",
                    typeTitle: "Cambiar el tipo de campo",
                    openUrl: "Ctrl+Click o Ctrl+Enter para abrir la URL en una nueva ventana",
                    undo: "Deshacer la \xfaltima acci\xf3n (Ctrl+Z)",
                    validationCannotMove: "No se puede mover un campo a un hijo de s\xed mismo.",
                    autoType: 'Field type "auto". The field type is automatically determined from the value and can be a string, number, boolean, or null.',
                    objectType: 'Tipo de campo "objeto".  Un objeto contiene un conjunto desordenado de pares clave/valor.',
                    arrayType: 'Tipo de campo "matriz".  Una matriz contiene una colecci\xf3n ordenada de valores.',
                    stringType: 'Tipo de campo "cadena".  El tipo de campo no se determina a partir del valor,  pero siempre se devuelve como una cadena.',
                    modeEditorTitle: "Cambiar modo de editor",
                    modeCodeText: "Codigo",
                    modeCodeTitle: "Cambiar al resaltador de c\xf3digo",
                    modeFormText: "Formulario",
                    modeFormTitle: "Cambiar al editor de formularios",
                    modeTextText: "Texto",
                    modeTextTitle: "Cambiar al editor de texto sin formato",
                    modeTreeText: "Arbol",
                    modeTreeTitle: "Cambiar al editor de \xe1rbol",
                    modeViewText: "Vista",
                    modeViewTitle: "Cambiar a la vista de \xe1rbol",
                    modePreviewText: "Vista Previa",
                    modePreviewTitle: "Cambiar al modo de vista previa",
                    examples: "Ejemplos",
                    default: "Predeterminado",
                    containsInvalidProperties: "Contiene propiedades no validas",
                    containsInvalidItems: "Contiene items no validos"
                },
                "zh-CN": {
                    array: "\u6570\u7EC4",
                    auto: "\u81EA\u52A8",
                    appendText: "\u8FFD\u52A0",
                    appendTitle: "\u5728\u6B64\u5B57\u6BB5\u540E\u8FFD\u52A0\u4E00\u4E2A\u7C7B\u578B\u4E3A\u201Cauto\u201D\u7684\u65B0\u5B57\u6BB5 (Ctrl+Shift+Ins)",
                    appendSubmenuTitle: "\u9009\u62E9\u8981\u8FFD\u52A0\u7684\u5B57\u6BB5\u7C7B\u578B",
                    appendTitleAuto: "\u8FFD\u52A0\u7C7B\u578B\u4E3A\u201Cauto\u201D\u7684\u65B0\u5B57\u6BB5 (Ctrl+Shift+Ins)",
                    ascending: "\u5347\u5E8F",
                    ascendingTitle: "\u5347\u5E8F\u6392\u5217${type}\u7684\u5B50\u8282\u70B9",
                    actionsMenu: "\u70B9\u51FB\u6253\u5F00\u52A8\u4F5C\u83DC\u5355(Ctrl+M)",
                    cannotParseFieldError: "\u65E0\u6CD5\u5C06\u5B57\u6BB5\u89E3\u6790\u4E3AJSON",
                    cannotParseValueError: "\u65E0\u6CD5\u5C06\u503C\u89E3\u6790\u4E3AJSON",
                    collapseAll: "\u7F29\u8FDB\u6240\u6709\u5B57\u6BB5",
                    compactTitle: "\u538B\u7F29JSON\u6570\u636E\uFF0C\u5220\u9664\u6240\u6709\u7A7A\u683C (Ctrl+Shift+I)",
                    descending: "\u964D\u5E8F",
                    descendingTitle: "\u964D\u5E8F\u6392\u5217${type}\u7684\u5B50\u8282\u70B9",
                    drag: "\u62D6\u62FD\u79FB\u52A8\u8BE5\u8282\u70B9(Alt+Shift+Arrows)",
                    duplicateKey: "\u91CD\u590D\u952E",
                    duplicateText: "\u590D\u5236",
                    duplicateTitle: "\u590D\u5236\u9009\u4E2D\u5B57\u6BB5(Ctrl+D)",
                    duplicateField: "\u590D\u5236\u8BE5\u5B57\u6BB5(Ctrl+D)",
                    duplicateFieldError: "\u91CD\u590D\u7684\u5B57\u6BB5\u540D\u79F0",
                    empty: "\u6E05\u7A7A",
                    expandAll: "\u5C55\u5F00\u6240\u6709\u5B57\u6BB5",
                    expandTitle: "\u70B9\u51FB \u5C55\u5F00/\u6536\u7F29 \u8BE5\u5B57\u6BB5(Ctrl+E). \nCtrl+Click \u5C55\u5F00/\u6536\u7F29 \u5305\u542B\u6240\u6709\u5B50\u8282\u70B9.",
                    formatTitle: "\u4F7F\u7528\u9002\u5F53\u7684\u7F29\u8FDB\u548C\u6362\u884C\u7B26\u683C\u5F0F\u5316JSON\u6570\u636E (Ctrl+I)",
                    insert: "\u63D2\u5165",
                    insertTitle: "\u5728\u6B64\u5B57\u6BB5\u524D\u63D2\u5165\u7C7B\u578B\u4E3A\u201Cauto\u201D\u7684\u65B0\u5B57\u6BB5 (Ctrl+Ins)",
                    insertSub: "\u9009\u62E9\u8981\u63D2\u5165\u7684\u5B57\u6BB5\u7C7B\u578B",
                    object: "\u5BF9\u8C61",
                    ok: "Ok",
                    redo: "\u91CD\u505A (Ctrl+Shift+Z)",
                    removeText: "\u79FB\u9664",
                    removeTitle: "\u79FB\u9664\u9009\u4E2D\u5B57\u6BB5 (Ctrl+Del)",
                    removeField: "\u79FB\u9664\u8BE5\u5B57\u6BB5 (Ctrl+Del)",
                    repairTitle: "\u4FEE\u590DJSON\uFF1A\u4FEE\u590D\u5F15\u53F7\u548C\u8F6C\u4E49\u7B26\uFF0C\u5220\u9664\u6CE8\u91CA\u548CJSONP\u8868\u793A\u6CD5\uFF0C\u5C06JavaScript\u5BF9\u8C61\u8F6C\u6362\u4E3AJSON\u3002",
                    selectNode: "\u9009\u62E9\u4E00\u4E2A\u8282\u70B9...",
                    showAll: "\u5C55\u793A\u5168\u90E8",
                    showMore: "\u5C55\u793A\u66F4\u591A",
                    showMoreStatus: "\u663E\u793A${totalChilds}\u7684${visibleChilds}\u9879\u76EE.",
                    sort: "\u6392\u5E8F",
                    sortTitle: "\u6392\u5E8F${type}\u7684\u5B50\u8282\u70B9",
                    sortTitleShort: "\u5185\u5BB9\u6392\u5E8F",
                    sortFieldLabel: "\u5B57\u6BB5\uFF1A",
                    sortDirectionLabel: "\u65B9\u5411\uFF1A",
                    sortFieldTitle: "\u9009\u62E9\u7528\u4E8E\u5BF9\u6570\u7EC4\u6216\u5BF9\u8C61\u6392\u5E8F\u7684\u5D4C\u5957\u5B57\u6BB5",
                    sortAscending: "\u5347\u5E8F\u6392\u5E8F",
                    sortAscendingTitle: "\u6309\u7167\u8BE5\u5B57\u6BB5\u5347\u5E8F\u6392\u5E8F",
                    sortDescending: "\u964D\u5E8F\u6392\u5E8F",
                    sortDescendingTitle: "\u6309\u7167\u8BE5\u5B57\u6BB5\u964D\u5E8F\u6392\u5E8F",
                    string: "\u5B57\u7B26\u4E32",
                    transform: "\u53D8\u6362",
                    transformTitle: "\u7B5B\u9009\uFF0C\u6392\u5E8F\uFF0C\u6216\u8005\u8F6C\u6362${type}\u7684\u5B50\u8282\u70B9",
                    transformTitleShort: "\u7B5B\u9009\uFF0C\u6392\u5E8F\uFF0C\u6216\u8005\u8F6C\u6362\u5185\u5BB9",
                    extract: "\u63D0\u53D6",
                    extractTitle: "\u63D0\u53D6\u8FD9\u4E2A ${type}",
                    transformQueryTitle: "\u8F93\u5165JMESPath\u67E5\u8BE2",
                    transformWizardLabel: "\u5411\u5BFC",
                    transformWizardFilter: "\u7B5B\u9009",
                    transformWizardSortBy: "\u6392\u5E8F",
                    transformWizardSelectFields: "\u9009\u62E9\u5B57\u6BB5",
                    transformQueryLabel: "\u67E5\u8BE2",
                    transformPreviewLabel: "\u9884\u89C8",
                    type: "\u7C7B\u578B",
                    typeTitle: "\u66F4\u6539\u5B57\u6BB5\u7C7B\u578B",
                    openUrl: "Ctrl+Click \u6216\u8005 Ctrl+Enter \u5728\u65B0\u7A97\u53E3\u6253\u5F00\u94FE\u63A5",
                    undo: "\u64A4\u9500\u4E0A\u6B21\u52A8\u4F5C (Ctrl+Z)",
                    validationCannotMove: "\u65E0\u6CD5\u5C06\u5B57\u6BB5\u79FB\u5165\u5176\u5B50\u8282\u70B9",
                    autoType: '\u5B57\u6BB5\u7C7B\u578B "auto". \u5B57\u6BB5\u7C7B\u578B\u7531\u503C\u81EA\u52A8\u786E\u5B9A \u53EF\u4EE5\u4E3A string\uFF0Cnumber\uFF0Cboolean\uFF0C\u6216\u8005 null.',
                    objectType: '\u5B57\u6BB5\u7C7B\u578B "object". \u5BF9\u8C61\u5305\u542B\u4E00\u7EC4\u65E0\u5E8F\u7684\u952E/\u503C\u5BF9.',
                    arrayType: '\u5B57\u6BB5\u7C7B\u578B "array". \u6570\u7EC4\u5305\u542B\u503C\u7684\u6709\u5E8F\u96C6\u5408.',
                    stringType: '\u5B57\u6BB5\u7C7B\u578B "string". \u5B57\u6BB5\u7C7B\u578B\u7531\u503C\u81EA\u52A8\u786E\u5B9A\uFF0C\u4F46\u59CB\u7EC8\u4F5C\u4E3A\u5B57\u7B26\u4E32\u8FD4\u56DE.',
                    modeCodeText: "\u4EE3\u7801",
                    modeCodeTitle: "\u5207\u6362\u81F3\u4EE3\u7801\u9AD8\u4EAE",
                    modeFormText: "\u8868\u5355",
                    modeFormTitle: "\u5207\u6362\u81F3\u8868\u5355\u7F16\u8F91",
                    modeTextText: "\u6587\u672C",
                    modeTextTitle: "\u5207\u6362\u81F3\u6587\u672C\u7F16\u8F91",
                    modeTreeText: "\u6811",
                    modeTreeTitle: "\u5207\u6362\u81F3\u6811\u7F16\u8F91",
                    modeViewText: "\u89C6\u56FE",
                    modeViewTitle: "\u5207\u6362\u81F3\u6811\u89C6\u56FE",
                    modePreviewText: "\u9884\u89C8",
                    modePreviewTitle: "\u5207\u6362\u81F3\u9884\u89C8\u6A21\u5F0F",
                    examples: "\u4F8B\u5B50",
                    default: "\u7F3A\u7701",
                    containsInvalidProperties: "\u5305\u542B\u65E0\u6548\u7684\u5C5E\u6027",
                    containsInvalidItems: "\u5305\u542B\u65E0\u6548\u9879\u76EE"
                },
                "pt-BR": {
                    array: "Lista",
                    auto: "Automatico",
                    appendText: "Adicionar",
                    appendTitle: "Adicionar novo campo com tipo 'auto' depois deste campo (Ctrl+Shift+Ins)",
                    appendSubmenuTitle: "Selecione o tipo do campo a ser adicionado",
                    appendTitleAuto: "Adicionar novo campo com tipo 'auto' (Ctrl+Shift+Ins)",
                    ascending: "Ascendente",
                    ascendingTitle: "Organizar filhor do tipo ${type} em crescente",
                    actionsMenu: "Clique para abrir o menu de a\xe7\xf5es (Ctrl+M)",
                    cannotParseFieldError: "N\xe3o \xe9 poss\xedvel analisar o campo no JSON",
                    cannotParseValueError: "N\xe3o \xe9 poss\xedvel analisar o valor em JSON",
                    collapseAll: "Fechar todos campos",
                    compactTitle: "Dados JSON compactos, remova todos os espa\xe7os em branco (Ctrl+Shift+I)",
                    descending: "Descendente",
                    descendingTitle: "Organizar o filhos do tipo ${type} em decrescente",
                    duplicateKey: "chave duplicada",
                    drag: "Arraste para mover este campo (Alt+Shift+Arrows)",
                    duplicateText: "Duplicar",
                    duplicateTitle: "Duplicar campos selecionados (Ctrl+D)",
                    duplicateField: "Duplicar este campo (Ctrl+D)",
                    duplicateFieldError: "Nome do campo duplicado",
                    empty: "vazio",
                    expandAll: "Expandir todos campos",
                    expandTitle: "Clique para expandir/encolher este campo (Ctrl+E). \nCtrl+Click para expandir/encolher incluindo todos os filhos.",
                    formatTitle: "Formate dados JSON, com recuo e feeds de linha adequados (Ctrl+I)",
                    insert: "Inserir",
                    insertTitle: "Inserir um novo campo do tipo 'auto' antes deste campo (Ctrl+Ins)",
                    insertSub: "Selecionar o tipo de campo a ser inserido",
                    object: "Objeto",
                    ok: "Ok",
                    redo: "Refazer (Ctrl+Shift+Z)",
                    removeText: "Remover",
                    removeTitle: "Remover campos selecionados (Ctrl+Del)",
                    removeField: "Remover este campo (Ctrl+Del)",
                    repairTitle: "Repare JSON: corrija aspas e caracteres de escape, remova coment\xe1rios e nota\xe7\xe3o JSONP, transforme objetos JavaScript em JSON.",
                    selectNode: "Selecione um n\xf3dulo...",
                    showAll: "mostrar todos",
                    showMore: "mostrar mais",
                    showMoreStatus: "exibindo ${visibleChilds} de ${totalChilds} itens.",
                    sort: "Organizar",
                    sortTitle: "Organizar os filhos deste ${type}",
                    sortTitleShort: "Organizar os filhos",
                    sortFieldLabel: "Campo:",
                    sortDirectionLabel: "Dire\xe7\xe3o:",
                    sortFieldTitle: "Selecione um campo filho pelo qual ordenar o array ou objeto",
                    sortAscending: "Ascendente",
                    sortAscendingTitle: "Ordenar o campo selecionado por ordem ascendente",
                    sortDescending: "Descendente",
                    sortDescendingTitle: "Ordenar o campo selecionado por ordem descendente",
                    string: "Texto",
                    transform: "Transformar",
                    transformTitle: "Filtrar, ordenar ou transformar os filhos deste ${type}",
                    transformTitleShort: "Filtrar, ordenar ou transformar conte\xfados",
                    transformQueryTitle: "Insira uma express\xe3o JMESPath",
                    transformWizardLabel: "Assistente",
                    transformWizardFilter: "Filtro",
                    transformWizardSortBy: "Ordenar por",
                    transformWizardSelectFields: "Selecionar campos",
                    transformQueryLabel: "Express\xe3o",
                    transformPreviewLabel: "Visualizar",
                    type: "Tipo",
                    typeTitle: "Mudar o tipo deste campo",
                    openUrl: "Ctrl+Click ou Ctrl+Enter para abrir link em nova janela",
                    undo: "Desfazer \xfaltimo a\xe7\xe3o (Ctrl+Z)",
                    validationCannotMove: "N\xe3o pode mover um campo como filho dele mesmo",
                    autoType: 'Campo do tipo "auto". O tipo do campo \xe9 determinao automaticamente a partir do seu valor e pode ser texto, n\xfamero, verdade/falso ou nulo.',
                    objectType: 'Campo do tipo "objeto". Um objeto cont\xe9m uma lista de pares com chave e valor.',
                    arrayType: 'Campo do tipo "lista". Uma lista contem uma cole\xe7\xe3o de valores ordenados.',
                    stringType: 'Campo do tipo "string". Campo do tipo nao \xe9 determinado atrav\xe9s do seu valor, mas sempre retornara um texto.',
                    examples: "Exemplos",
                    default: "Revelia",
                    containsInvalidProperties: "Cont\xe9m propriedades inv\xe1lidas",
                    containsInvalidItems: "Cont\xe9m itens inv\xe1lidos"
                },
                tr: {
                    array: "Dizin",
                    auto: "Otomatik",
                    appendText: "Ekle",
                    appendTitle: "Bu alan\u0131n alt\u0131na 'otomatik' tipinde yeni bir alan ekle (Ctrl+Shift+Ins)",
                    appendSubmenuTitle: "Eklenecek alan\u0131n tipini se\xe7",
                    appendTitleAuto: "'Otomatik' tipinde yeni bir alan ekle (Ctrl+Shift+Ins)",
                    ascending: "Artan",
                    ascendingTitle: "${type}'\u0131n alt tiplerini artan d\xfczende s\u0131rala",
                    actionsMenu: "Aksiyon men\xfcs\xfcn\xfc a\xe7mak i\xe7in t\u0131klay\u0131n (Ctrl+M)",
                    collapseAll: "T\xfcm alanlar\u0131 kapat",
                    descending: "Azalan",
                    descendingTitle: "${type}'\u0131n alt tiplerini azalan d\xfczende s\u0131rala",
                    drag: "Bu alan\u0131 ta\u015F\u0131mak i\xe7in s\xfcr\xfckleyin (Alt+Shift+Arrows)",
                    duplicateKey: "Var olan anahtar",
                    duplicateText: "A\u015Fa\u011F\u0131ya kopyala",
                    duplicateTitle: "Se\xe7ili alanlardan bir daha olu\u015Ftur (Ctrl+D)",
                    duplicateField: "Bu alandan bir daha olu\u015Ftur (Ctrl+D)",
                    duplicateFieldError: "Duplicate field name",
                    cannotParseFieldError: "Alan JSON'a ayr\u0131\u015Ft\u0131r\u0131lam\u0131yor",
                    cannotParseValueError: "JSON'a de\u011Fer ayr\u0131\u015Ft\u0131r\u0131lam\u0131yor",
                    empty: "bo\u015F",
                    expandAll: "T\xfcm alanlar\u0131 a\xe7",
                    expandTitle: "Bu alan\u0131 a\xe7mak/kapatmak i\xe7in t\u0131kla (Ctrl+E). \nAlt alanlarda dahil t\xfcm alanlar\u0131 a\xe7mak i\xe7in Ctrl+Click ",
                    insert: "Ekle",
                    insertTitle: "Bu alan\u0131n \xfcst\xfcne 'otomatik' tipinde yeni bir alan ekle (Ctrl+Ins)",
                    insertSub: "Araya eklenecek alan\u0131n tipini se\xe7",
                    object: "Nesne",
                    ok: "Tamam",
                    redo: "Yeniden yap (Ctrl+Shift+Z)",
                    removeText: "Kald\u0131r",
                    removeTitle: "Se\xe7ilen alanlar\u0131 kald\u0131r (Ctrl+Del)",
                    removeField: "Bu alan\u0131 kald\u0131r (Ctrl+Del)",
                    selectNode: "Bir nesne se\xe7...",
                    showAll: "t\xfcm\xfcn\xfc g\xf6ster",
                    showMore: "daha fazla g\xf6ster",
                    showMoreStatus: "${totalChilds} alan\u0131n ${visibleChilds} alt alanlar\u0131 g\xf6steriliyor",
                    sort: "S\u0131rala",
                    sortTitle: "${type}'\u0131n alt alanlar\u0131n\u0131 s\u0131rala",
                    sortTitleShort: "\u0130\xe7erikleri s\u0131rala",
                    sortFieldLabel: "Alan:",
                    sortDirectionLabel: "Y\xf6n:",
                    sortFieldTitle: "Diziyi veya nesneyi s\u0131ralamak i\xe7in i\xe7 i\xe7e ge\xe7mi\u015F alan\u0131 se\xe7in",
                    sortAscending: "Artan",
                    sortAscendingTitle: "Se\xe7ili alan\u0131 artan d\xfczende s\u0131rala",
                    sortDescending: "Azalan",
                    sortDescendingTitle: "Se\xe7ili alan\u0131 azalan d\xfczende s\u0131rala",
                    string: "Karakter Dizisi",
                    transform: "D\xf6n\xfc\u015Ft\xfcr",
                    transformTitle: "${type}'\u0131n alt alanlar\u0131n\u0131 filtrele, s\u0131rala veya d\xf6n\xfc\u015Ft\xfcr",
                    transformTitleShort: "\u0130\xe7erikleri filterele, s\u0131rala veya d\xf6n\xfc\u015Ft\xfcr",
                    transformQueryTitle: "JMESPath sorgusu gir",
                    transformWizardLabel: "Sihirbaz",
                    transformWizardFilter: "Filtre",
                    transformWizardSortBy: "S\u0131rala",
                    transformWizardSelectFields: "Alanlar\u0131 se\xe7",
                    transformQueryLabel: "Sorgu",
                    transformPreviewLabel: "\xd6nizleme",
                    type: "Tip",
                    typeTitle: "Bu alan\u0131n tipini de\u011Fi\u015Ftir",
                    openUrl: "URL'i yeni bir pencerede a\xe7mak i\xe7in Ctrl+Click veya Ctrl+Enter",
                    undo: "Son de\u011Fi\u015Fikli\u011Fi geri al (Ctrl+Z)",
                    validationCannotMove: "Alt alan olarak ta\u015F\u0131nam\u0131yor",
                    autoType: 'Alan tipi "otomatik". Alan t\xfcr\xfc otomatik olarak de\u011Ferden belirlenirve bir dize, say\u0131, boolean veya null olabilir.',
                    objectType: 'Alan tipi "nesne". Bir nesne, s\u0131ralanmam\u0131\u015F bir anahtar / de\u011Fer \xe7ifti k\xfcmesi i\xe7erir.',
                    arrayType: 'Alan tipi "dizi". Bir dizi, d\xfczenli de\u011Ferler koleksiyonu i\xe7erir.',
                    stringType: 'Alan tipi "karakter dizisi". Alan t\xfcr\xfc de\u011Ferden belirlenmez,ancak her zaman karakter dizisi olarak d\xf6nd\xfcr\xfcl\xfcr.',
                    modeCodeText: "Kod",
                    modeCodeTitle: "Kod vurgulay\u0131c\u0131ya ge\xe7",
                    modeFormText: "Form",
                    modeFormTitle: "Form d\xfczenleyiciye ge\xe7",
                    modeTextText: "Metin",
                    modeTextTitle: "D\xfcz metin d\xfczenleyiciye ge\xe7",
                    modeTreeText: "A\u011Fa\xe7",
                    modeTreeTitle: "A\u011Fa\xe7 d\xfczenleyiciye ge\xe7",
                    modeViewText: "G\xf6r\xfcn\xfcm",
                    modeViewTitle: "A\u011Fa\xe7 g\xf6r\xfcn\xfcm\xfcne ge\xe7",
                    examples: "\xd6rnekler",
                    default: "Varsay\u0131lan",
                    containsInvalidProperties: "Ge\xe7ersiz \xf6zellikler i\xe7eriyor",
                    containsInvalidItems: "Ge\xe7ersiz \xf6\u011Feler i\xe7eriyor"
                },
                ja: {
                    array: "\u914D\u5217",
                    auto: "\u30AA\u30FC\u30C8",
                    appendText: "\u8FFD\u52A0",
                    appendTitle: '\u6B21\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306B"\u30AA\u30FC\u30C8"\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8FFD\u52A0 (Ctrl+Shift+Ins)',
                    appendSubmenuTitle: "\u8FFD\u52A0\u3059\u308B\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
                    appendTitleAuto: '"\u30AA\u30FC\u30C8"\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8FFD\u52A0 (Ctrl+Shift+Ins)',
                    ascending: "\u6607\u9806",
                    ascendingTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u6607\u9806\u306B\u4E26\u3079\u66FF\u3048",
                    actionsMenu: "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30A2\u30AF\u30B7\u30E7\u30F3\u30E1\u30CB\u30E5\u30FC\u3092\u958B\u304F (Ctrl+M)",
                    collapseAll: "\u3059\u3079\u3066\u3092\u6298\u308A\u305F\u305F\u3080",
                    descending: "\u964D\u9806",
                    descendingTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u964D\u9806\u306B\u4E26\u3079\u66FF\u3048",
                    drag: "\u30C9\u30E9\u30C3\u30B0\u3057\u3066\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u79FB\u52D5 (Alt+Shift+Arrows)",
                    duplicateKey: "\u8907\u88FD\u30AD\u30FC",
                    duplicateText: "\u8907\u88FD",
                    duplicateTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8907\u88FD (Ctrl+D)",
                    duplicateField: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8907\u88FD (Ctrl+D)",
                    duplicateFieldError: "\u30D5\u30A3\u30FC\u30EB\u30C9\u540D\u304C\u91CD\u8907\u3057\u3066\u3044\u307E\u3059",
                    cannotParseFieldError: "JSON\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u89E3\u6790\u3067\u304D\u307E\u305B\u3093",
                    cannotParseValueError: "JSON\u306E\u5024\u3092\u89E3\u6790\u3067\u304D\u307E\u305B\u3093",
                    empty: "\u7A7A",
                    expandAll: "\u3059\u3079\u3066\u3092\u5C55\u958B",
                    expandTitle: "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u5C55\u958B/\u6298\u308A\u305F\u305F\u3080 (Ctrl+E). \nCtrl+Click \u3067\u3059\u3079\u3066\u306E\u5B50\u8981\u7D20\u3092\u5C55\u958B/\u6298\u308A\u305F\u305F\u3080",
                    insert: "\u633F\u5165",
                    insertTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u524D\u306B\u65B0\u3057\u3044\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u633F\u5165 (Ctrl+Ins)",
                    insertSub: "\u633F\u5165\u3059\u308B\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u3092\u9078\u629E",
                    object: "\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8",
                    ok: "\u5B9F\u884C",
                    redo: "\u3084\u308A\u76F4\u3059 (Ctrl+Shift+Z)",
                    removeText: "\u524A\u9664",
                    removeTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u524A\u9664 (Ctrl+Del)",
                    removeField: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u524A\u9664 (Ctrl+Del)",
                    selectNode: "\u30CE\u30FC\u30C9\u3092\u9078\u629E...",
                    showAll: "\u3059\u3079\u3066\u3092\u8868\u793A",
                    showMore: "\u3082\u3063\u3068\u898B\u308B",
                    showMoreStatus: "${totalChilds}\u500B\u306E\u30A2\u30A4\u30C6\u30E0\u306E\u3046\u3061 ${visibleChilds}\u500B\u3092\u8868\u793A\u3057\u3066\u3044\u307E\u3059\u3002",
                    sort: "\u4E26\u3079\u66FF\u3048",
                    sortTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u4E26\u3079\u66FF\u3048",
                    sortTitleShort: "\u4E26\u3079\u66FF\u3048",
                    sortFieldLabel: "\u30D5\u30A3\u30FC\u30EB\u30C9:",
                    sortDirectionLabel: "\u9806\u5E8F:",
                    sortFieldTitle: "\u914D\u5217\u307E\u305F\u306F\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u3092\u4E26\u3073\u66FF\u3048\u308B\u305F\u3081\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u9078\u629E",
                    sortAscending: "\u6607\u9806",
                    sortAscendingTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u6607\u9806\u306B\u4E26\u3073\u66FF\u3048",
                    sortDescending: "\u964D\u9806",
                    sortDescendingTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u964D\u9806\u306B\u4E26\u3073\u66FF\u3048",
                    string: "\u6587\u5B57\u5217",
                    transform: "\u5909\u63DB",
                    transformTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u30D5\u30A3\u30EB\u30BF\u30FC\u30FB\u4E26\u3073\u66FF\u3048\u30FB\u5909\u63DB\u3059\u308B",
                    transformTitleShort: "\u5185\u5BB9\u3092\u30D5\u30A3\u30EB\u30BF\u30FC\u30FB\u4E26\u3073\u66FF\u3048\u30FB\u5909\u63DB\u3059\u308B",
                    extract: "\u62BD\u51FA",
                    extractTitle: "${type}\u3092\u62BD\u51FA",
                    transformQueryTitle: "JMESPath\u30AF\u30A8\u30EA\u3092\u5165\u529B",
                    transformWizardLabel: "\u30A6\u30A3\u30B6\u30FC\u30C9",
                    transformWizardFilter: "\u30D5\u30A3\u30EB\u30BF\u30FC",
                    transformWizardSortBy: "\u4E26\u3073\u66FF\u3048",
                    transformWizardSelectFields: "\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u9078\u629E",
                    transformQueryLabel: "\u30AF\u30A8\u30EA",
                    transformPreviewLabel: "\u30D7\u30EC\u30D3\u30E5\u30FC",
                    type: "\u578B",
                    typeTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u3092\u5909\u66F4",
                    openUrl: "Ctrl+Click \u307E\u305F\u306F Ctrl+Enter \u3067 \u65B0\u898F\u30A6\u30A3\u30F3\u30C9\u30A6\u3067URL\u3092\u958B\u304F",
                    undo: "\u5143\u306B\u623B\u3059 (Ctrl+Z)",
                    validationCannotMove: "\u5B50\u8981\u7D20\u306B\u79FB\u52D5\u3067\u304D\u307E\u305B\u3093 ",
                    autoType: "\u30AA\u30FC\u30C8\uFF1A \u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u306F\u5024\u304B\u3089\u81EA\u52D5\u7684\u306B\u6C7A\u5B9A\u3055\u308C\u307E\u3059\u3002 (\u6587\u5B57\u5217\u30FB\u6570\u5024\u30FB\u30D6\u30FC\u30EB\u30FBnull)",
                    objectType: "\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\uFF1A \u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u306F\u9806\u5E8F\u304C\u6C7A\u307E\u3063\u3066\u3044\u306A\u3044\u30AD\u30FC\u3068\u5024\u306E\u30DA\u30A2\u7D44\u307F\u5408\u308F\u305B\u3067\u3059\u3002",
                    arrayType: "\u914D\u5217\uFF1A \u914D\u5217\u306F\u9806\u5E8F\u304C\u6C7A\u307E\u3063\u3066\u3044\u308B\u5024\u306E\u96C6\u5408\u4F53\u3067\u3059\u3002",
                    stringType: "\u6587\u5B57\u5217\uFF1A \u30D5\u30A3\u30FC\u30EB\u30C9\u578B\u306F\u5024\u304B\u3089\u6C7A\u5B9A\u3055\u308C\u307E\u305B\u3093\u304C\u3001\u5E38\u306B\u6587\u5B57\u5217\u3068\u3057\u3066\u8FD4\u3055\u308C\u307E\u3059\u3002",
                    modeCodeText: "\u30B3\u30FC\u30C9\u30E2\u30FC\u30C9",
                    modeCodeTitle: "\u30CF\u30A4\u30E9\u30A4\u30C8\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
                    modeFormText: "\u30D5\u30A9\u30FC\u30E0\u30E2\u30FC\u30C9",
                    modeFormTitle: "\u30D5\u30A9\u30FC\u30E0\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
                    modeTextText: "\u30C6\u30AD\u30B9\u30C8\u30E2\u30FC\u30C9",
                    modeTextTitle: "\u30C6\u30AD\u30B9\u30C8\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
                    modeTreeText: "\u30C4\u30EA\u30FC\u30E2\u30FC\u30C9",
                    modeTreeTitle: "\u30C4\u30EA\u30FC\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
                    modeViewText: "\u30D3\u30E5\u30FC\u30E2\u30FC\u30C9",
                    modeViewTitle: "\u30D3\u30E5\u30FC\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
                    modePreviewText: "\u30D7\u30EC\u30D3\u30E5\u30FC",
                    modePreviewTitle: "\u30D7\u30EC\u30D3\u30E5\u30FC\u306B\u5207\u308A\u66FF\u3048",
                    examples: "\u4F8B",
                    default: "\u30C7\u30D5\u30A9\u30EB\u30C8",
                    containsInvalidProperties: "\u7121\u52B9\u306A\u30D7\u30ED\u30D1\u30C6\u30A3\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059",
                    containsInvalidItems: "\u7121\u52B9\u306A\u30A2\u30A4\u30C6\u30E0\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059"
                },
                "fr-FR": {
                    array: "Liste",
                    auto: "Auto",
                    appendText: "Ajouter",
                    appendTitle: "Ajouter un champ de type 'auto' apr\xe8s ce champ (Ctrl+Shift+Ins)",
                    appendSubmenuTitle: "S\xe9lectionner le type du champ \xe0 ajouter",
                    appendTitleAuto: "Ajouter un champ de type 'auto' (Ctrl+Shift+Ins)",
                    ascending: "Ascendant",
                    ascendingTitle: "Trier les enfants de ce ${type} par ordre ascendant",
                    actionsMenu: "Ouvrir le menu des actions (Ctrl+M)",
                    collapseAll: "Regrouper",
                    descending: "Descendant",
                    descendingTitle: "Trier les enfants de ce ${type} par ordre descendant",
                    drag: "D\xe9placer (Alt+Shift+Arrows)",
                    duplicateKey: "Dupliquer la cl\xe9",
                    duplicateText: "Dupliquer",
                    duplicateTitle: "Dupliquer les champs s\xe9lectionn\xe9s (Ctrl+D)",
                    duplicateField: "Dupliquer ce champ (Ctrl+D)",
                    duplicateFieldError: "Dupliquer le nom de champ",
                    cannotParseFieldError: "Champ impossible \xe0 parser en JSON",
                    cannotParseValueError: "Valeur impossible \xe0 parser en JSON",
                    empty: "vide",
                    expandAll: "\xc9tendre",
                    expandTitle: "\xc9tendre/regrouper ce champ (Ctrl+E). \nCtrl+Click pour \xe9tendre/regrouper avec tous les champs.",
                    insert: "Ins\xe9rer",
                    insertTitle: "Ins\xe9rer un champ de type 'auto' avant ce champ (Ctrl+Ins)",
                    insertSub: "S\xe9lectionner le type de champ \xe0 ins\xe9rer",
                    object: "Objet",
                    ok: "Ok",
                    redo: "Rejouer (Ctrl+Shift+Z)",
                    removeText: "Supprimer",
                    removeTitle: "Supprimer les champs s\xe9lectionn\xe9s (Ctrl+Del)",
                    removeField: "Supprimer ce champ (Ctrl+Del)",
                    searchTitle: "Rechercher champs et valeurs",
                    searchNextResultTitle: "R\xe9sultat suivant (Enter)",
                    searchPreviousResultTitle: "R\xe9sultat pr\xe9c\xe9dent (Shift + Enter)",
                    selectNode: "S\xe9lectionner un n\u0153ud...",
                    showAll: "voir tout",
                    showMore: "voir plus",
                    showMoreStatus: "${visibleChilds} \xe9l\xe9ments affich\xe9s de ${totalChilds}.",
                    sort: "Trier",
                    sortTitle: "Trier les champs de ce ${type}",
                    sortTitleShort: "Trier",
                    sortFieldLabel: "Champ:",
                    sortDirectionLabel: "Direction:",
                    sortFieldTitle: "S\xe9lectionner les champs permettant de trier les listes et objet",
                    sortAscending: "Ascendant",
                    sortAscendingTitle: "Trier les champs s\xe9lectionn\xe9s par ordre ascendant",
                    sortDescending: "Descendant",
                    sortDescendingTitle: "Trier les champs s\xe9lectionn\xe9s par ordre descendant",
                    string: "Cha\xeene",
                    transform: "Transformer",
                    transformTitle: "Filtrer, trier, or transformer les enfants de ce ${type}",
                    transformTitleShort: "Filtrer, trier ou transformer le contenu",
                    extract: "Extraire",
                    extractTitle: "Extraire ce ${type}",
                    transformQueryTitle: "Saisir une requ\xeate JMESPath",
                    transformWizardLabel: "Assistant",
                    transformWizardFilter: "Filtrer",
                    transformWizardSortBy: "Trier par",
                    transformWizardSelectFields: "S\xe9lectionner les champs",
                    transformQueryLabel: "Requ\xeate",
                    transformPreviewLabel: "Pr\xe9visualisation",
                    type: "Type",
                    typeTitle: "Changer le type de ce champ",
                    openUrl: "Ctrl+Click ou Ctrl+Enter pour ouvrir l'url dans une autre fen\xeatre",
                    undo: "Annuler la derni\xe8re action (Ctrl+Z)",
                    validationCannotMove: "Cannot move a field into a child of itself",
                    autoType: 'Champe de type "auto". Ce type de champ est automatiquement d\xe9termin\xe9 en fonction de la valeur et peut \xeatre de type "cha\xeene", "nombre", "bool\xe9en" ou null.',
                    objectType: 'Champ de type "objet". Un objet contient un ensemble non ordonn\xe9 de paires cl\xe9/valeur.',
                    arrayType: 'Champ de type "liste". Une liste contient une collection ordonn\xe9e de valeurs.',
                    stringType: 'Champ de type "cha\xeene". Ce type de champ n\'est pas d\xe9termin\xe9 en fonction de la valeur, mais retourne syst\xe9matiquement une cha\xeene de caract\xe8res.',
                    modeEditorTitle: "Changer mode d'\xe9dition",
                    modeCodeText: "Code",
                    modeCodeTitle: "Activer surlignage code",
                    modeFormText: "Formulaire",
                    modeFormTitle: "Activer formulaire",
                    modeTextText: "Texte",
                    modeTextTitle: "Activer \xe9diteur texte",
                    modeTreeText: "Arbre",
                    modeTreeTitle: "Activer \xe9diteur arbre",
                    modeViewText: "Lecture seule",
                    modeViewTitle: "Activer vue arbre",
                    modePreviewText: "Pr\xe9visualisation",
                    modePreviewTitle: "Activer mode pr\xe9visualiser",
                    examples: "Exemples",
                    default: "D\xe9faut",
                    containsInvalidProperties: "Contient des propri\xe9t\xe9s non valides",
                    containsInvalidItems: "Contient des \xe9l\xe9ments invalides"
                },
                de: {
                    array: "Auflistung",
                    auto: "Auto",
                    appendText: "anh\xe4ngen",
                    appendTitle: "F\xfcgen Sie nach diesem Feld ein neues Feld mit dem Typ 'auto' ein (Strg+Umschalt+Ein)",
                    appendSubmenuTitle: "W\xe4hlen Sie den Typ des neuen Feldes",
                    appendTitleAuto: "Ein neues Feld vom Typ 'auto' hinzuf\xfcgen (Strg+Umschalt+Ein)",
                    ascending: "Aufsteigend",
                    ascendingTitle: "Sortieren Sie die Elemente dieses ${type} in aufsteigender Reihenfolge",
                    actionsMenu: "Klicken Sie zum \xd6ffnen des Aktionsmen\xfcs (Strg+M)",
                    cannotParseFieldError: "Feld kann nicht in JSON geparst werden",
                    cannotParseValueError: "Wert kann nicht in JSON geparst werden",
                    collapseAll: "Alle Felder zuklappen",
                    compactTitle: "JSON-Daten verdichten, alle Leerzeichen entfernen (Strg+Umschalt+\\)",
                    descending: "Absteigend",
                    descendingTitle: "Sortieren Sie die Elemente dieses ${type} in absteigender Reihenfolge",
                    drag: "Ziehen, um dieses Feld zu verschieben (Alt+Umschalt+Pfeile)",
                    duplicateKey: "Doppelter Schl\xfcssel",
                    duplicateText: "Duplikat",
                    duplicateTitle: "Ausgew\xe4hlte Felder duplizieren (Strg+D)",
                    duplicateField: "Dieses Feld duplizieren (Strg+D)",
                    duplicateFieldError: "Doppelter Feldname",
                    empty: "leer",
                    expandAll: "Alle Felder anzeigen",
                    expandTitle: "Klicken Sie, um dieses Feld zu erweitern/zu kollabieren (Strg+E). \nStrg+Klicken Sie, um dieses Feld einschlie\xdflich aller Elemente zu erweitern/zu kollabieren.",
                    formatTitle: "JSON-Daten mit korrekter Einr\xfcckung und Zeilenvorsch\xfcben formatieren (Strg+\\)",
                    insert: "einf\xfcgen",
                    insertTitle: "F\xfcgen Sie vor diesem Feld ein neues Feld mit dem Typ 'auto' ein (Strg+Einfg)",
                    insertSub: "W\xe4hlen Sie den Typ des neuen Feldes",
                    object: "Objekt",
                    ok: "Ok",
                    redo: "Wiederholen (Strg+Umschalt+Z)",
                    removeText: "entfernen",
                    removeTitle: "Ausgew\xe4hlte Felder entfernen (Strg+Entf)",
                    removeField: "Dieses Feld entfernen (Strg+Entf)",
                    repairTitle: "JSON reparieren: Anf\xfchrungszeichen und Escape-Zeichen korrigieren, Kommentare und JSONP-Notation entfernen, JavaScript-Objekte in JSON umwandeln.",
                    searchTitle: "Suchfelder und Werte",
                    searchNextResultTitle: "N\xe4chstes Ergebnis (Enter)",
                    searchPreviousResultTitle: "Vorheriges Ergebnis (Umschalt + Eingabe)",
                    selectNode: "W\xe4hlen Sie einen Knoten aus...",
                    showAll: "alle anzeigen",
                    showMore: "mehr anzeigen",
                    showMoreStatus: "Anzeige von ${visibleChilds} von ${totalChilds}-Elementen.",
                    sort: "Sortieren",
                    sortTitle: "Sortieren Sie die Elemente dieses ${type}",
                    sortTitleShort: "Inhalt sortieren",
                    sortFieldLabel: "Feld:",
                    sortDirectionLabel: "Richtung:",
                    sortFieldTitle: "W\xe4hlen Sie das verschachtelte Feld, nach dem das Array oder Objekt sortiert werden soll.",
                    sortAscending: "Aufsteigend",
                    sortAscendingTitle: "Sortieren Sie das ausgew\xe4hlte Feld in aufsteigender Reihenfolge",
                    sortDescending: "Absteigend",
                    sortDescendingTitle: "Sortieren Sie das ausgew\xe4hlte Feld in absteigender Reihenfolge",
                    string: "Zeichenfolge",
                    transform: "Verwandeln",
                    transformTitle: "Die Elemente dieses ${type} filtern, sortieren oder transformieren",
                    transformTitleShort: "Inhalte filtern, sortieren oder transformieren",
                    extract: "Auszug",
                    extractTitle: "Extrahieren Sie diesen ${type}",
                    transformQueryTitle: "Eine JMESPath-Abfrage eingeben",
                    transformWizardLabel: "Zauberer",
                    transformWizardFilter: "Filter",
                    transformWizardSortBy: "Sortieren nach",
                    transformWizardSelectFields: "Felder ausw\xe4hlen",
                    transformQueryLabel: "Anfrage",
                    transformPreviewLabel: "Vorschau",
                    type: "Geben Sie  ein.",
                    typeTitle: "\xc4ndern Sie den Typ dieses Feldes",
                    openUrl: "Strg+Klicken oder Strg+Eingabe, um die URL in einem neuen Fenster zu \xf6ffnen",
                    undo: "Letzte Aktion r\xfcckg\xe4ngig machen (Strg+Z)",
                    validationCannotMove: "Kann ein Feld nicht in ein Kind seiner selbst verschieben",
                    autoType: 'Feldtyp "auto". Der Feldtyp wird automatisch aus dem Wert bestimmt und kann ein String, eine Zahl, boolesch oder null sein.',
                    objectType: 'Feldtyp "Objekt". Ein Objekt enth\xe4lt eine ungeordnete Menge von Schl\xfcssel/Wert-Paaren.',
                    arrayType: 'Feldtyp "Array". Ein Array enth\xe4lt eine geordnete Sammlung von Werten.',
                    stringType: 'Feldtyp "Zeichenfolge". Der Feldtyp wird nicht aus dem Wert bestimmt, sondern immer als Zeichenfolge zur\xfcckgegeben.',
                    modeEditorTitle: "Editor-Modus umschalten",
                    modeCodeText: "Code",
                    modeCodeTitle: "Umschalten auf Code-Highlighter",
                    modeFormText: "Formular",
                    modeFormTitle: "Zum Formular-Editor wechseln",
                    modeTextText: "Text",
                    modeTextTitle: "Zum Editor f\xfcr einfachen Text wechseln",
                    modeTreeText: "Baum",
                    modeTreeTitle: "Zum Baum-Editor wechseln",
                    modeViewText: "Siehe",
                    modeViewTitle: "Zur Baumansicht wechseln",
                    modePreviewText: "Vorschau",
                    modePreviewTitle: "In den Vorschau-Modus wechseln",
                    examples: "Beispiele",
                    default: "Standardm\xe4\xdfig",
                    containsInvalidProperties: "Enth\xe4lt ung\xfcltige Eigenschaften",
                    containsInvalidItems: "Enth\xe4lt ung\xfcltige Elemente"
                },
                ru: {
                    array: "\u041C\u0430\u0441\u0441\u0438\u0432",
                    auto: "\u0410\u0432\u0442\u043E",
                    appendText: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C",
                    appendTitle: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043F\u043E\u043B\u0435 \u0441 \u0442\u0438\u043F\u043E\u043C '\u0430\u0432\u0442\u043E' \u043F\u043E\u0441\u043B\u0435 \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044F (Ctrl+Shift+Ins)",
                    appendSubmenuTitle: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0442\u0438\u043F \u043F\u043E\u043B\u044F \u0434\u043B\u044F \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u044F",
                    appendTitleAuto: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043F\u043E\u043B\u0435 \u0441 \u0442\u0438\u043F\u043E\u043C '\u0430\u0432\u0442\u043E' (Ctrl+Shift+Ins)",
                    ascending: "\u041F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
                    ascendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C ${type} \u043F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
                    actionsMenu: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F \u043C\u0435\u043D\u044E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 (Ctrl+M)",
                    cannotParseFieldError: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u043B\u0435 \u0432 JSON",
                    cannotParseValueError: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u0442\u044C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432 JSON",
                    collapseAll: "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0432\u0441\u0435",
                    compactTitle: "\u041C\u0438\u043D\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F JSON (Ctrl+Shift+I)",
                    descending: "\u041F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
                    descendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C ${type} \u043F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
                    drag: "\u041F\u043E\u0442\u044F\u043D\u0438\u0442\u0435 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044F (Alt+Shift+Arrows)",
                    duplicateKey: "\u043F\u043E\u0432\u0442\u043E\u0440\u044F\u044E\u0449\u0438\u0439\u0441\u044F \u043A\u043B\u044E\u0447",
                    duplicateText: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
                    duplicateTitle: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u043B\u0435\u0439 (Ctrl+D)",
                    duplicateField: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u043B\u0435 (Ctrl+D)",
                    duplicateFieldError: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043B\u044F",
                    empty: "\u043F\u0443\u0441\u0442\u043E\u0439",
                    expandAll: "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0432\u0441\u0435",
                    expandTitle: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u0440\u0430\u0441\u043A\u0440\u044B\u0442\u0438\u044F/\u0441\u043A\u0440\u044B\u0442\u0438\u044F \u043F\u043E\u043B\u044F (Ctrl+E)\n\u0438\u043B\u0438 Ctrl+Click \u0434\u043B\u044F \u0440\u0430\u0441\u043A\u0440\u044B\u0442\u0438\u044F/\u0441\u043A\u0440\u044B\u0442\u0438\u044F \u0432\u0441\u0435\u0445 \u043F\u043E\u0442\u043E\u043C\u043A\u043E\u0432.",
                    formatTitle: "\u0424\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 JSON (Ctrl+I)",
                    insert: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C",
                    insertTitle: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043F\u043E\u043B\u0435 \u0441 \u0442\u0438\u043F\u043E\u043C '\u0430\u0432\u0442\u043E' \u043F\u0435\u0440\u0435\u0434 \u044D\u0442\u0438\u043C \u043F\u043E\u043B\u0435\u043C (Ctrl+Ins)",
                    insertSub: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0442\u0438\u043F \u043F\u043E\u043B\u044F \u0434\u043B\u044F \u0432\u0441\u0442\u0430\u0432\u043A\u0438",
                    object: "\u041E\u0431\u044A\u0435\u043A\u0442",
                    ok: "\u041E\u041A",
                    redo: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C (Ctrl+Shift+Z)",
                    removeText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
                    removeTitle: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u044F (Ctrl+Del)",
                    removeField: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u043B\u0435 (Ctrl+Del)",
                    repairTitle: "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 JSON: \u0438\u0441\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u043A\u0430\u0432\u044B\u0447\u043A\u0438 \u0438 escape-\u0441\u0438\u043C\u0432\u043E\u043B\u044B, \u0443\u0434\u0430\u043B\u0438\u0442\u0435 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438 \u0438 \u043D\u043E\u0442\u0430\u0446\u0438\u044E JSONP, \u043C\u043E\u0434\u0438\u0444\u0438\u0446\u0438\u0440\u0443\u0439\u0442\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u044B JavaScript \u0432 JSON.",
                    searchTitle: "\u041F\u043E\u0438\u0441\u043A",
                    searchNextResultTitle: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 (Enter)",
                    searchPreviousResultTitle: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 (Shift + Enter)",
                    selectNode: "\u0412\u044B\u0431\u043E\u0440 \u0443\u0437\u043B\u0430...",
                    showAll: "\u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435",
                    showMore: "\u0431\u043E\u043B\u044C\u0448\u0435",
                    showMoreStatus: "${visibleChilds} \u0438\u0437 ${totalChilds}",
                    sort: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430",
                    sortTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u043F\u043E\u0442\u043E\u043C\u043A\u043E\u0432 \u0442\u0438\u043F\u0430 ${type}",
                    sortTitleShort: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0433\u043E",
                    sortFieldLabel: "\u041F\u043E\u043B\u0435:",
                    sortDirectionLabel: "\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435:",
                    sortFieldTitle: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043E\u043B\u0435 \u0434\u043B\u044F \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0438 \u043C\u0430\u0441\u0441\u0438\u0432\u0430 \u0438\u043B\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",
                    sortAscending: "\u041F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
                    sortAscendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u0440\u044F \u043F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
                    sortDescending: "\u041F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
                    sortDescendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u0440\u044F \u043F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
                    string: "\u0421\u0442\u0440\u043E\u043A\u0430",
                    transform: "\u041C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F",
                    transformTitle: "\u0424\u0438\u043B\u044C\u0442\u0440\u0430\u0446\u0438\u044F, \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0438\u043B\u0438 \u043C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0430 ${type}",
                    transformTitleShort: "\u0424\u0438\u043B\u044C\u0442\u0440\u0430\u0446\u0438\u044F, \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0438\u043B\u0438 \u043C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445",
                    extract: "\u0418\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435",
                    extractTitle: "\u0418\u0437\u0432\u043B\u0435\u0447\u044C \u0442\u0438\u043F ${type}",
                    transformQueryTitle: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 JMESpath \u0437\u0430\u043F\u0440\u043E\u0441",
                    transformWizardLabel: "\u041C\u0430\u0441\u0442\u0435\u0440",
                    transformWizardFilter: "\u0424\u0438\u043B\u044C\u0442\u0440",
                    transformWizardSortBy: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430",
                    transformWizardSelectFields: "\u041F\u043E\u043B\u044F",
                    transformQueryLabel: "\u0417\u0430\u043F\u0440\u043E\u0441",
                    transformPreviewLabel: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
                    type: "\u0422\u0438\u043F",
                    typeTitle: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0442\u0438\u043F \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044F",
                    openUrl: "Ctrl+Click \u0438\u043B\u0438 Ctrl+Enter \u0434\u043B\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F url \u0432 \u043D\u043E\u0432\u043E\u043C \u043E\u043A\u043D\u0435",
                    undo: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C (Ctrl+Z)",
                    validationCannotMove: "\u041F\u043E\u043B\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u043E \u0432 \u043F\u043E\u0442\u043E\u043C\u043A\u0430",
                    autoType: "\u0422\u0438\u043F \u043F\u043E\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044E \u0438 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u043E\u0439, \u0447\u0438\u0441\u043B\u043E\u043C, \u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u043C \u0438\u043B\u0438 null.",
                    objectType: "\u041E\u0431\u044A\u0435\u043A\u0442 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0443\u043F\u043E\u0440\u044F\u0434\u043E\u0447\u0435\u043D\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440 \u043F\u0430\u0440 \u043A\u043B\u044E\u0447/\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435.",
                    arrayType: "\u041C\u0430\u0441\u0441\u0438\u0432 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0443\u043F\u043E\u0440\u044F\u0434\u043E\u0447\u0435\u043D\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439.",
                    stringType: "\u0422\u0438\u043F \u043F\u043E\u043B\u044F \u043D\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u0438\u0437 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F, \u043D\u043E \u0432\u0441\u0435\u0433\u0434\u0430 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442\u0441\u044F \u043A\u0430\u043A \u0441\u0442\u0440\u043E\u043A\u0430.",
                    modeEditorTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0440\u0435\u0436\u0438\u043C\u0430 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430",
                    modeCodeText: "\u041A\u043E\u0434",
                    modeCodeTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 \u043A\u043E\u0434\u0430",
                    modeFormText: "\u0424\u043E\u0440\u043C\u0430",
                    modeFormTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0444\u043E\u0440\u043C\u044B",
                    modeTextText: "\u0422\u0435\u043A\u0441\u0442",
                    modeTextTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 \u0442\u0435\u043A\u0441\u0442\u0430",
                    modeTreeText: "\u0414\u0435\u0440\u0435\u0432\u043E",
                    modeTreeTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 \u0434\u0435\u0440\u0435\u0432\u0430",
                    modeViewText: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0434\u0435\u0440\u0435\u0432\u0430",
                    modeViewTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0434\u0435\u0440\u0435\u0432\u0430",
                    modePreviewText: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
                    modePreviewTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430",
                    examples: "\u041F\u0440\u0438\u043C\u0435\u0440\u044B",
                    default: "\u041F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E",
                    containsInvalidProperties: "\u0421\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430",
                    containsInvalidItems: "\u0421\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B"
                },
                ko: {
                    array: "\uBC30\uC5F4",
                    auto: "\uC790\uB3D9",
                    appendText: "\uCD94\uAC00",
                    appendTitle: '\uC120\uD0DD\uD55C \uC694\uC18C \uC544\uB798\uC5D0 "\uC790\uB3D9" \uC694\uC18C\uB97C \uCD94\uAC00\uD569\uB2C8\uB2E4. (Ctrl + Shift + Ins)',
                    appendSubmenuTitle: "\uCD94\uAC00\uD560 \uC694\uC18C\uC758 \uC720\uD615\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
                    appendTitleAuto: '"\uC790\uB3D9" \uC694\uC18C\uB97C \uCD94\uAC00\uD569\uB2C8\uB2E4. (Ctrl + Shift + Ins)',
                    ascending: "\uC624\uB984\uCC28\uC21C",
                    ascendingTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uC624\uB984\uCC28\uC21C \uC815\uB82C\uD569\uB2C8\uB2E4.",
                    actionsMenu: "\uBA54\uB274 \uC5F4\uAE30 (Ctrl + M)",
                    cannotParseFieldError: "JSON\uC758 \uC694\uC18C\uB97C \uD574\uC11D\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                    cannotParseValueError: "JSON\uC758 \uAC12\uC744 \uD574\uC11D\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                    collapseAll: "\uBAA8\uB450 \uC811\uAE30",
                    compactTitle: "\uBAA8\uB4E0 \uACF5\uBC31\uC744 \uC81C\uAC70\uD558\uC5EC JSON \uB370\uC774\uD130\uB97C \uC791\uAC8C \uB9CC\uB4ED\uB2C8\uB2E4. (Ctrl + Shift + I)",
                    descending: "\uB0B4\uB9BC\uCC28\uC21C",
                    descendingTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uB0B4\uB9BC\uCC28\uC21C\uC73C\uB85C \uC815\uB82C",
                    drag: "\uB4DC\uB798\uADF8\uD558\uC5EC \uC694\uC18C\uB97C \uC774\uB3D9\uD569\uB2C8\uB2E4. (Alt + Shift + Arrows)",
                    duplicateKey: "\uBCF5\uC81C\uD0A4",
                    duplicateText: "\uBCF5\uC81C",
                    duplicateTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uBCF5\uC81C\uD569\uB2C8\uB2E4. (Ctrl + D)",
                    duplicateField: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uBCF5\uC81C\uD569\uB2C8\uB2E4. (Ctrl + D)",
                    duplicateFieldError: "\uC694\uC18C \uC774\uB984\uC774 \uC911\uBCF5\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                    empty: "\uBE44\uC5B4\uC788\uC74C",
                    expandAll: "\uBAA8\uB450 \uC5F4\uAE30",
                    expandTitle: "\uD074\uB9AD\uD558\uC5EC \uC694\uC18C\uB97C \uC5F4\uAC70\uB098 \uB2EB\uC2B5\uB2C8\uB2E4. (Ctrl + E) \nCtrl + Click\uC73C\uB85C \uBAA8\uB4E0 \uD558\uC704 \uC694\uC18C\uB97C \uC5F4\uAC70\uB098 \uB2EB\uC2B5\uB2C8\uB2E4.",
                    formatTitle: "\uC801\uC808\uD55C \uB4E4\uC5EC\uC4F0\uAE30 \uBC0F \uC904\uBC14\uAFC8\uC73C\uB85C JSON \uB370\uC774\uD130\uB97C \uC815\uD615\uD654\uD569\uB2C8\uB2E4. (Ctrl + I)",
                    insert: "\uC0BD\uC785",
                    insertTitle: "\uC120\uD0DD\uD55C \uC694\uC18C \uC704\uC5D0 \uC0C8\uC694\uC18C\uB97C \uC0BD\uC785\uD569\uB2C8\uB2E4. (Ctrl + Ins)",
                    insertSub: "\uC0BD\uC785\uD560 \uC694\uC18C\uC758 \uC720\uD615\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
                    object: "\uAC1D\uCCB4",
                    ok: "\uD655\uC778",
                    redo: "\uB2E4\uC2DC \uC2E4\uD589 (Ctrl + Shift + Z)",
                    removeText: "\uC0AD\uC81C",
                    removeTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uC0AD\uC81C\uD569\uB2C8\uB2E4. (Ctrl + Del)",
                    removeField: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uC0AD\uC81C\uD569\uB2C8\uB2E4. (Ctrl + Del)",
                    repairTitle: "JSON \uAD50\uC815: JSON \uB0B4\uC758 \uC8FC\uC11D\uACFC JSONP \uD45C\uAE30\uBC95\uC744 \uC9C0\uC6B0\uACE0 \uB530\uC634\uD45C\uC640 \uC774\uC2A4\uCF00\uC774\uD504 \uBB38\uC790\uB97C \uC218\uC815\uD569\uB2C8\uB2E4.",
                    searchTitle: "\uC694\uC18C \uB610\uB294 \uAC12 \uCC3E\uAE30",
                    searchNextResultTitle: "\uB2E4\uC74C\uC73C\uB85C \uCC3E\uAE30 (Enter)",
                    searchPreviousResultTitle: "\uC774\uC804\uC73C\uB85C \uCC3E\uAE30 (Shift + Enter)",
                    selectNode: "\uC694\uC18C\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694...",
                    showAll: "\uBAA8\uB450\uBCF4\uAE30",
                    showMore: "\uB354\uBCF4\uAE30",
                    showMoreStatus: "${totalChilds} \uAC1C\uC758 \uD56D\uBAA9 \uC911 ${visibleChilds} \uAC1C\uB97C \uD45C\uC2DC\uD569\uB2C8\uB2E4.",
                    sort: "\uC815\uB82C",
                    sortTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uC815\uB82C\uD569\uB2C8\uB2E4.",
                    sortTitleShort: "\uC815\uB82C",
                    sortFieldLabel: "\uC694\uC18C:",
                    sortDirectionLabel: "\uC21C\uC11C:",
                    sortFieldTitle: "\uBC30\uC5F4\uC774\uB098 \uAC1D\uCCB4\uB97C \uC815\uB82C\uD558\uB294 \uC694\uC18C\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
                    sortAscending: "\uC624\uB984\uCC28\uC21C",
                    sortAscendingTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uC624\uB984\uCC28\uC21C\uC73C\uB85C \uC815\uB82C\uD569\uB2C8\uB2E4.",
                    sortDescending: "\uB0B4\uB9BC\uCC28\uC21C",
                    sortDescendingTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uB0B4\uB9BC\uCC28\uC21C\uC73C\uB85C \uC815\uB82C\uD569\uB2C8\uB2E4.",
                    string: "\uBB38\uC790",
                    transform: "\uBCC0\uD658",
                    transformTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uD544\uD130\uD558\uAC70\uB098 \uC815\uB82C \uB610\uB294 \uBCC0\uD658\uD569\uB2C8\uB2E4.",
                    transformTitleShort: "\uB0B4\uC6A9\uC744 \uD544\uD130\uD558\uAC70\uB098 \uC815\uB82C \uB610\uB294 \uBCC0\uD658\uD569\uB2C8\uB2E4.",
                    extract: "\uCD94\uCD9C",
                    extractTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uAC12\uC744 \uCD5C\uC0C1\uC704\uC5D0 \uC704\uCE58\uC2DC\uD0B5\uB2C8\uB2E4.",
                    transformQueryTitle: "JMESPath \uCFFC\uB9AC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.",
                    transformWizardLabel: "\uB9C8\uBC95\uC0AC",
                    transformWizardFilter: "\uD544\uD130",
                    transformWizardSortBy: "\uC815\uB82C",
                    transformWizardSelectFields: "\uC694\uC18C\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
                    transformQueryLabel: "\uCFFC\uB9AC",
                    transformPreviewLabel: "\uBBF8\uB9AC\uBCF4\uAE30",
                    type: "\uC720\uD615",
                    typeTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uC758 \uC720\uD615\uC744 \uBCC0\uACBD\uD569\uB2C8\uB2E4.",
                    openUrl: "Ctrl + Click \uB610\uB294 Ctrl + Enter\uB85C \uC0C8 \uCC3D\uC5D0\uC11C URL \uC5F4\uAE30",
                    undo: "\uC2E4\uD589 \uCDE8\uC18C (Ctrl + Z)",
                    validationCannotMove: "\uD558\uC704 \uC694\uC18C\uB85C \uC774\uB3D9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                    autoType: "\uC790\uB3D9: \uC694\uC18C\uC758 \uD615\uC2DD\uC774 \uAC12\uC758 \uC720\uD615\uC73C\uB85C \uACB0\uC815\uB429\uB2C8\uB2E4. \uBB38\uC790, \uC22B\uC790, \uBD80\uC6B8, \uB610\uB294 null\uB9CC \uD5C8\uC6A9\uB429\uB2C8\uB2E4.",
                    objectType: "\uAC1D\uCCB4: \uC21C\uC11C\uB300\uB85C \uB098\uC5F4\uB418\uC9C0 \uC54A\uC740 \uC774\uB984/\uAC12 \uC30D\uC73C\uB85C \uC774\uB8E8\uC5B4\uC9C4 \uC9D1\uD569\uC785\uB2C8\uB2E4.",
                    arrayType: "\uBC30\uC5F4: \uC21C\uC11C\uB300\uB85C \uB098\uC5F4\uB41C \uAC12\uC758 \uC9D1\uD569\uC785\uB2C8\uB2E4.",
                    stringType: "\uBB38\uC790: \uC694\uC18C\uC758 \uC720\uD615\uC774 \uAC12\uC5D0\uC11C \uACB0\uC815\uB418\uC9C0 \uC54A\uC9C0\uB9CC \uD56D\uC0C1 \uBB38\uC790\uB85C \uBC18\uD658\uB429\uB2C8\uB2E4.",
                    modeEditorTitle: "\uD3B8\uC9D1\uAE30 \uC720\uD615 \uBCC0\uACBD",
                    modeCodeText: "\uCF54\uB4DC",
                    modeCodeTitle: "\uD615\uC2DD \uAD50\uC815\uC744 \uB3C4\uC640\uC8FC\uB294 \uAE30\uB2A5\uC774 \uD3EC\uD568\uB41C \uBB38\uC790 \uD3B8\uC9D1\uAE30",
                    modeFormText: "\uC785\uB825 \uC591\uC2DD",
                    modeFormTitle: "\uC815\uD574\uC9C4 \uC694\uC18C\uC5D0 \uAC12\uC744 \uC785\uB825\uD558\uB294 \uD3B8\uC9D1\uAE30",
                    modeTextText: "\uBB38\uC790",
                    modeTextTitle: "\uB2E8\uC21C \uBB38\uC790 \uD3B8\uC9D1\uAE30",
                    modeTreeText: "\uD2B8\uB9AC",
                    modeTreeTitle: "\uD2B8\uB9AC \uAD6C\uC870\uB85C \uD45C\uC2DC\uB418\uB294 \uD3B8\uC9D1\uAE30",
                    modeViewText: "\uBCF4\uAE30",
                    modeViewTitle: "\uC77D\uAE30\uC804\uC6A9 \uD2B8\uB9AC \uAD6C\uC870\uB85C JSON\uC744 \uD45C\uC2DC",
                    modePreviewText: "\uBBF8\uB9AC\uBCF4\uAE30",
                    modePreviewTitle: "\uC77D\uAE30\uC804\uC6A9 \uBB38\uC790\uB85C JSON\uC744 \uD45C\uC2DC",
                    examples: "\uC608\uC81C",
                    default: "\uAE30\uBCF8\uAC12",
                    containsInvalidProperties: "\uC798\uBABB\uB41C \uC18D\uC131\uC774 \uD3EC\uD568\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4.",
                    containsInvalidItems: "\uC798\uBABB\uB41C \uD56D\uBAA9\uC774 \uD3EC\uD568\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4"
                }
            }, i = Object.keys(r), s = "en", o = "undefined" != typeof navigator ? navigator.language || navigator.userLanguage : void 0, a = i.find(function(e) {
                return e === o;
            }) || s;
            function l(t) {
                var e;
                t && ((e = i.find(function(e) {
                    return e === t;
                })) ? a = e : console.error("Language not found"));
            }
            function c(e) {
                if (e) for(var t in e)!function(t) {
                    i.find(function(e) {
                        return e === t;
                    }) || i.push(t), r[t] = Object.assign({}, r[s], r[t], e[t]);
                }(t);
            }
            function h(e, t, n) {
                var i = r[n = n || a][e] || r[s][e] || e;
                if (t) for(var o in t)i = i.replace("${" + o + "}", t[o]);
                return i;
            }
        },
        6056: function(e, t, n) {
            "use strict";
            n.d(t, {
                J: function() {
                    return r;
                },
                r: function() {
                    return o;
                }
            });
            var t = n(5156), i = n.n(t), s = n(9791);
            function o(e, t) {
                var n, i = t.sort, o = t.filter, t = t.projection, r = "";
                return o ? (n = "@" !== o.field ? [
                    "0"
                ].concat((0, s.parsePath)("." + o.field)) : [
                    "0"
                ], n = "string" == typeof (0, s.get)(e, n) ? o.value : (0, s.parseString)(o.value), r += "[? " + o.field + " " + o.relation + " `" + JSON.stringify(n) + "`]") : r += Array.isArray(e) ? "[*]" : "@", i && ("desc" === i.direction ? r += " | reverse(sort_by(@, &" + i.field + "))" : r += " | sort_by(@, &" + i.field + ")"), t && ("]" !== r[r.length - 1] && (r += " | [*]"), 1 === t.fields.length ? r += "." + t.fields[0] : 1 < t.fields.length && (r += ".{" + t.fields.map(function(e) {
                    var t = e.split(".");
                    return t[t.length - 1] + ": " + e;
                }).join(", ") + "}")), r;
            }
            function r(e, t) {
                return i().search(e, t);
            }
        },
        4987: function() {
            function e(e) {
                void 0 === e || "remove" in e || Object.defineProperty(e, "remove", {
                    configurable: !0,
                    enumerable: !0,
                    writable: !0,
                    value: function() {
                        void 0 !== this.parentNode && this.parentNode.removeChild(this);
                    }
                });
            }
            "undefined" != typeof Element && (void 0 !== window.Element && e(window.Element.prototype), void 0 !== window.CharacterData && e(window.CharacterData.prototype), void 0 !== window.DocumentType) && e(window.DocumentType.prototype), Array.prototype.findIndex || Object.defineProperty(Array.prototype, "findIndex", {
                value: function(e) {
                    for(var t = 0; t < this.length; t++){
                        var n = this[t];
                        if (e.call(this, n, t, this)) return t;
                    }
                    return -1;
                },
                configurable: !0,
                writable: !0
            }), Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
                value: function(e) {
                    e = this.findIndex(e);
                    return this[e];
                },
                configurable: !0,
                writable: !0
            }), String.prototype.trim || (String.prototype.trim = function() {
                return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
            });
        },
        341: function(e, t, n) {
            "use strict";
            n.r(t), n.d(t, {
                previewModeMixins: function() {
                    return f;
                }
            });
            var i = n(1262), s = n(4188), o = n(6436), r = n(2474);
            function a(e) {
                return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function l(e, t) {
                for(var n = 0; n < t.length; n++){
                    var i = t[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function(e) {
                        e = function(e, t) {
                            if ("object" !== a(e) || null === e) return e;
                            var n = e[Symbol.toPrimitive];
                            if (void 0 === n) return ("string" === t ? String : Number)(e);
                            n = n.call(e, t || "default");
                            if ("object" !== a(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }(e, "string");
                        return "symbol" === a(e) ? e : String(e);
                    }(i.key), i);
                }
            }
            var c = function() {
                function i(e, t, n) {
                    if (!(this instanceof i)) throw new TypeError("Cannot call a class as a function");
                    this.onChange = e, this.calculateItemSize = t || function() {
                        return 1;
                    }, this.limit = n, this.items = [], this.index = -1;
                }
                var e, t, n;
                return e = i, t = [
                    {
                        key: "add",
                        value: function(e) {
                            for(; this._calculateHistorySize() > this.limit && 1 < this.items.length;)this.items.shift(), this.index--;
                            this.items = this.items.slice(0, this.index + 1), this.items.push(e), this.index++, this.onChange();
                        }
                    },
                    {
                        key: "_calculateHistorySize",
                        value: function() {
                            var t = this.calculateItemSize, n = 0;
                            return this.items.forEach(function(e) {
                                n += t(e);
                            }), n;
                        }
                    },
                    {
                        key: "undo",
                        value: function() {
                            if (this.canUndo()) return this.index--, this.onChange(), this.items[this.index];
                        }
                    },
                    {
                        key: "redo",
                        value: function() {
                            if (this.canRedo()) return this.index++, this.onChange(), this.items[this.index];
                        }
                    },
                    {
                        key: "canUndo",
                        value: function() {
                            return 0 < this.index;
                        }
                    },
                    {
                        key: "canRedo",
                        value: function() {
                            return this.index < this.items.length - 1;
                        }
                    },
                    {
                        key: "clear",
                        value: function() {
                            this.items = [], this.index = -1, this.onChange();
                        }
                    }
                ], l(e.prototype, t), n && l(e, n), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), i;
            }(), h = n(7907), d = n(6056), u = n(6617), g = n(6210), p = n(2558), t = n(8458), m = n(9791), n = t.textModeMixins[0].mixin, t = {
                create: function(e) {
                    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, n = (void 0 === t.statusBar && (t.statusBar = !0), t.mainMenuBar = !1 !== t.mainMenuBar, t.enableSort = !1 !== t.enableSort, t.enableTransform = !1 !== t.enableTransform, t.createQuery = t.createQuery || d.r, t.executeQuery = t.executeQuery || d.J, "number" == typeof (this.options = t).indentation ? this.indentation = Number(t.indentation) : this.indentation = 2, (0, h.cC)(this.options.languages), (0, h.m0)(this.options.language), this.mode = "preview", this), e = (this.container = e, this.dom = {}, this.json = void 0, this.text = "", this._debouncedValidate = (0, m.debounce)(this.validate.bind(this), this.DEBOUNCE_INTERVAL), this.width = e.clientWidth, this.height = e.clientHeight, this.frame = document.createElement("div"), this.frame.className = "jsoneditor jsoneditor-mode-preview", this.frame.onclick = function(e) {
                        e.preventDefault();
                    }, {
                        target: this.frame,
                        onFocus: this.options.onFocus || null,
                        onBlur: this.options.onBlur || null
                    }), e = (this.frameFocusTracker = new r.R(e), this.content = document.createElement("div"), this.content.className = "jsoneditor-outer", this.dom.busy = document.createElement("div"), this.dom.busy.className = "jsoneditor-busy", this.dom.busyContent = document.createElement("span"), this.dom.busyContent.textContent = "busy...", this.dom.busy.appendChild(this.dom.busyContent), this.content.appendChild(this.dom.busy), this.dom.previewContent = document.createElement("pre"), this.dom.previewContent.className = "jsoneditor-preview", this.dom.previewText = document.createTextNode(""), this.dom.previewContent.appendChild(this.dom.previewText), this.content.appendChild(this.dom.previewContent), this.options.mainMenuBar && ((0, m.addClassName)(this.content, "has-main-menu-bar"), this.menu = document.createElement("div"), this.menu.className = "jsoneditor-menu", this.frame.appendChild(this.menu), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-format", e.title = (0, h.Iu)("formatTitle"), this.menu.appendChild(e), e.onclick = function() {
                        n.executeWithBusyMessage(function() {
                            try {
                                n.format();
                            } catch (e) {
                                n._onError(e);
                            }
                        }, "formatting...");
                    }, (e = document.createElement("button")).type = "button", e.className = "jsoneditor-compact", e.title = (0, h.Iu)("compactTitle"), this.menu.appendChild(e), e.onclick = function() {
                        n.executeWithBusyMessage(function() {
                            try {
                                n.compact();
                            } catch (e) {
                                n._onError(e);
                            }
                        }, "compacting...");
                    }, this.options.enableSort && ((e = document.createElement("button")).type = "button", e.className = "jsoneditor-sort", e.title = (0, h.Iu)("sortTitleShort"), e.onclick = function() {
                        n._showSortModal();
                    }, this.menu.appendChild(e)), this.options.enableTransform && ((e = document.createElement("button")).type = "button", e.title = (0, h.Iu)("transformTitleShort"), e.className = "jsoneditor-transform", e.onclick = function() {
                        n._showTransformModal();
                    }, this.dom.transform = e, this.menu.appendChild(e)), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-repair", e.title = (0, h.Iu)("repairTitle"), this.menu.appendChild(e), (e.onclick = function() {
                        void 0 === n.json && n.executeWithBusyMessage(function() {
                            try {
                                n.repair();
                            } catch (e) {
                                n._onError(e);
                            }
                        }, "repairing...");
                    }, false) !== this.options.history && (this.history = new c(function() {
                        n.dom.undo.disabled = !n.history.canUndo(), n.dom.redo.disabled = !n.history.canRedo();
                    }, function(e) {
                        return 2 * e.text.length;
                    }, s.oW), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-undo jsoneditor-separator", e.title = (0, h.Iu)("undo"), e.onclick = function() {
                        var e = n.history.undo();
                        e && n._applyHistory(e);
                    }, this.menu.appendChild(e), this.dom.undo = e, (e = document.createElement("button")).type = "button", e.className = "jsoneditor-redo", e.title = (0, h.Iu)("redo"), e.onclick = function() {
                        var e = n.history.redo();
                        e && n._applyHistory(e);
                    }, this.menu.appendChild(e), this.dom.redo = e, this.history.onChange()), this.options) && this.options.modes && this.options.modes.length && (this.modeSwitcher = new u.x(this.menu, this.options.modes, this.options.mode, function(e) {
                        try {
                            n.setMode(e), n.modeSwitcher.focus();
                        } catch (e) {
                            n._onError(e);
                        }
                    })), Array.isArray(this.options.showErrorTable) ? this.options.showErrorTable.includes(this.mode) : !0 === this.options.showErrorTable);
                    this.errorTable = new o.Q({
                        errorTableVisible: e,
                        onToggleVisibility: function() {
                            n.validate();
                        },
                        onFocusLine: null,
                        onChangeHeight: function(e) {
                            e = e + (n.dom.statusBar ? n.dom.statusBar.clientHeight : 0) + 1;
                            n.content.style.marginBottom = -e + "px", n.content.style.paddingBottom = e + "px";
                        }
                    }), this.frame.appendChild(this.content), this.frame.appendChild(this.errorTable.getErrorTable()), this.container.appendChild(this.frame), t.statusBar && ((0, m.addClassName)(this.content, "has-status-bar"), e = document.createElement("div"), (this.dom.statusBar = e).className = "jsoneditor-statusbar", this.frame.appendChild(e), this.dom.fileSizeInfo = document.createElement("span"), this.dom.fileSizeInfo.className = "jsoneditor-size-info", this.dom.fileSizeInfo.innerText = "", e.appendChild(this.dom.fileSizeInfo), this.dom.arrayInfo = document.createElement("span"), this.dom.arrayInfo.className = "jsoneditor-size-info", this.dom.arrayInfo.innerText = "", e.appendChild(this.dom.arrayInfo), e.appendChild(this.errorTable.getErrorCounter()), e.appendChild(this.errorTable.getWarningIcon()), e.appendChild(this.errorTable.getErrorIcon())), this._renderPreview(), this.setSchema(this.options.schema, this.options.schemaRefs);
                },
                _renderPreview: function() {
                    var e = this.getText();
                    this.dom.previewText.nodeValue = (0, m.limitCharacters)(e, s.WF), this.dom.fileSizeInfo && (this.dom.fileSizeInfo.innerText = "Size: " + (0, m.formatSize)(e.length)), this.dom.arrayInfo && (Array.isArray(this.json) ? this.dom.arrayInfo.innerText = "Array: " + this.json.length + " items" : this.dom.arrayInfo.innerText = "");
                },
                _onChange: function() {
                    if (this._debouncedValidate(), this.options.onChange) try {
                        this.options.onChange();
                    } catch (e) {
                        console.error("Error in onChange callback: ", e);
                    }
                    if (this.options.onChangeJSON) try {
                        this.options.onChangeJSON(this.get());
                    } catch (e) {
                        console.error("Error in onChangeJSON callback: ", e);
                    }
                    if (this.options.onChangeText) try {
                        this.options.onChangeText(this.getText());
                    } catch (e) {
                        console.error("Error in onChangeText callback: ", e);
                    }
                }
            }, f = (t._showSortModal = function() {
                var r = this;
                this.executeWithBusyMessage(function() {
                    var e = r.options.modalAnchor || s.qD, o = r.get();
                    r._renderPreview(), (0, g.showSortModal)(e, o, function(i) {
                        r.executeWithBusyMessage(function() {
                            var e, t, n;
                            e = o, t = i, Array.isArray(e) && (n = (0, m.sort)(e, t.path, t.direction), r.sortedBy = t, r._setAndFireOnChange(n)), (0, m.isObject)(e) && (n = (0, m.sortObjectKeys)(e, t.direction), r.sortedBy = t, r._setAndFireOnChange(n));
                        }, "sorting...");
                    }, r.sortedBy);
                }, "parsing...");
            }, t._showTransformModal = function() {
                var r = this;
                this.executeWithBusyMessage(function() {
                    var e = r.options, t = e.createQuery, n = e.executeQuery, i = e.modalAnchor, e = e.queryDescription, o = r.get();
                    r._renderPreview(), (0, p.showTransformModal)({
                        container: i || s.qD,
                        json: o,
                        queryDescription: e,
                        createQuery: t,
                        executeQuery: n,
                        onTransform: function(t) {
                            r.executeWithBusyMessage(function() {
                                var e = n(o, t);
                                r._setAndFireOnChange(e);
                            }, "transforming...");
                        }
                    });
                }, "parsing...");
            }, t.destroy = function() {
                this.frame && this.container && this.frame.parentNode === this.container && this.container.removeChild(this.frame), this.modeSwitcher && (this.modeSwitcher.destroy(), this.modeSwitcher = null), this._debouncedValidate = null, this.history && (this.history.clear(), this.history = null), this.frameFocusTracker.destroy();
            }, t.compact = function() {
                var e = this.get(), t = JSON.stringify(e);
                this._setTextAndFireOnChange(t, e);
            }, t.format = function() {
                var e = this.get(), t = JSON.stringify(e, null, this.indentation);
                this._setTextAndFireOnChange(t, e);
            }, t.repair = function() {
                var e = this.getText();
                try {
                    var t = (0, i.K)(e);
                    this._setTextAndFireOnChange(t);
                } catch (e) {}
            }, t.focus = function() {
                this.dom.transform.focus();
            }, t.set = function(e) {
                this.history && this.history.clear(), this._set(e);
            }, t.update = function(e) {
                this._set(e);
            }, t._set = function(e) {
                this.text = void 0, this.json = e, this._renderPreview(), this._pushHistory(), this._debouncedValidate();
            }, t._setAndFireOnChange = function(e) {
                this._set(e), this._onChange();
            }, t.get = function() {
                var e;
                return void 0 === this.json && (e = this.getText(), this.json = (0, m.parse)(e)), this.json;
            }, t.getText = function() {
                return void 0 === this.text && (this.text = JSON.stringify(this.json, null, this.indentation), !0 === this.options.escapeUnicode) && (this.text = (0, m.escapeUnicodeChars)(this.text)), this.text;
            }, t.setText = function(e) {
                this.history && this.history.clear(), this._setText(e);
            }, t.updateText = function(e) {
                this.getText() !== e && this._setText(e);
            }, t._setText = function(e, t) {
                var n;
                !0 === this.options.escapeUnicode ? this.text = (0, m.escapeUnicodeChars)(e) : this.text = e, this.json = t, this._renderPreview(), void 0 === this.json ? (n = this).executeWithBusyMessage(function() {
                    try {
                        n.json = n.get(), n._renderPreview(), n._pushHistory();
                    } catch (e) {}
                }, "parsing...") : this._pushHistory(), this._debouncedValidate();
            }, t._setTextAndFireOnChange = function(e, t) {
                this._setText(e, t), this._onChange();
            }, t._applyHistory = function(e) {
                this.json = e.json, this.text = e.text, this._renderPreview(), this._debouncedValidate();
            }, t._pushHistory = function() {
                var e;
                this.history && (e = {
                    text: this.text,
                    json: this.json
                }, this.history.add(e));
            }, t.executeWithBusyMessage = function(e, t) {
                var n;
                this.getText().length > s.EX ? ((0, m.addClassName)((n = this).frame, "busy"), n.dom.busyContent.innerText = t, setTimeout(function() {
                    e(), (0, m.removeClassName)(n.frame, "busy"), n.dom.busyContent.innerText = "";
                }, 100)) : e();
            }, t.validate = n.validate, t._renderErrors = n._renderErrors, [
                {
                    mode: "preview",
                    mixin: t,
                    data: "json"
                }
            ]);
        },
        6210: function(e, t, n) {
            "use strict";
            n.r(t), n.d(t, {
                showSortModal: function() {
                    return s;
                }
            });
            var t = n(483), i = n.n(t), o = n(7907), r = n(9791);
            function s(e, t, s, n) {
                var a = Array.isArray(t) ? (0, r.getChildPaths)(t) : [
                    ""
                ], l = n && n.path && (0, r.contains)(a, n.path) ? n.path : a[0], c = n && n.direction || "asc", t = '<div class="pico-modal-contents"><div class="pico-modal-header">' + (0, o.Iu)("sort") + "</div><form><table><tbody><tr>  <td>" + (0, o.Iu)("sortFieldLabel") + ' </td>  <td class="jsoneditor-modal-input">  <div class="jsoneditor-select-wrapper">    <select id="field" title="' + (0, o.Iu)("sortFieldTitle") + '">    </select>  </div>  </td></tr><tr>  <td>' + (0, o.Iu)("sortDirectionLabel") + ' </td>  <td class="jsoneditor-modal-input">  <div id="direction" class="jsoneditor-button-group"><input type="button" value="' + (0, o.Iu)("sortAscending") + '" title="' + (0, o.Iu)("sortAscendingTitle") + '" data-value="asc" class="jsoneditor-button-first jsoneditor-button-asc"/><input type="button" value="' + (0, o.Iu)("sortDescending") + '" title="' + (0, o.Iu)("sortDescendingTitle") + '" data-value="desc" class="jsoneditor-button-last jsoneditor-button-desc"/>  </div>  </td></tr><tr><td colspan="2" class="jsoneditor-modal-input jsoneditor-modal-actions">  <input type="submit" id="ok" value="' + (0, o.Iu)("ok") + '" /></td></tr></tbody></table></form></div>';
                i()({
                    parent: e,
                    content: t,
                    overlayClass: "jsoneditor-modal-overlay",
                    overlayStyles: {
                        backgroundColor: "rgb(1,1,1)",
                        opacity: .3
                    },
                    modalClass: "jsoneditor-modal jsoneditor-modal-sort"
                }).afterCreate(function(t) {
                    var e = t.modalElem().querySelector("form"), n = t.modalElem().querySelector("#ok"), i = t.modalElem().querySelector("#field"), o = t.modalElem().querySelector("#direction");
                    function r(e) {
                        o.value = e, o.className = "jsoneditor-button-group jsoneditor-button-group-value-" + o.value;
                    }
                    a.forEach(function(e) {
                        var t, n = document.createElement("option");
                        n.text = "" === (t = e) ? "@" : "." === t[0] ? t.slice(1) : t, n.value = e, i.appendChild(n);
                    }), i.value = l || a[0], r(c || "asc"), o.onclick = function(e) {
                        r(e.target.getAttribute("data-value"));
                    }, n.onclick = function(e) {
                        e.preventDefault(), e.stopPropagation(), t.close(), s({
                            path: i.value,
                            direction: o.value
                        });
                    }, e && (e.onsubmit = n.onclick);
                }).afterClose(function(e) {
                    e.destroy();
                }).show();
            }
        },
        2558: function(e, t, n) {
            "use strict";
            n.r(t), n.d(t, {
                showTransformModal: function() {
                    return s;
                }
            });
            var t = n(483), i = n.n(t), t = n(3879), x = n.n(t), o = n(7907);
            function I(e) {
                return (I = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function k(e, t, n, i) {
                if ("boolean" == typeof e || e instanceof Boolean || null === e || "number" == typeof e || e instanceof Number || "string" == typeof e || e instanceof String || e instanceof Date) return JSON.stringify(e);
                if (Array.isArray(e)) {
                    for(var o = e, r = t, s = n, a = i, l = r ? s + r : void 0, c = r ? "[\n" : "[", h = 0; h < o.length; h++){
                        var d = o[h];
                        if (r && (c += l), c += void 0 !== d && "function" != typeof d ? k(d, r, l, a) : "null", h < o.length - 1 && (c += r ? ",\n" : ","), c.length > a) return c + "...";
                    }
                    return c += r ? "\n" + s + "]" : "]";
                }
                if (e && "object" === I(e)) {
                    var u, g = e, p = t, s = n, m = i, f = p ? s + p : void 0, C = !0, y = p ? "{\n" : "{";
                    if ("function" == typeof g.toJSON) return k(g.toJSON(), p, s, m);
                    for(u in g)if (function(e, t) {
                        return Object.prototype.hasOwnProperty.call(e, t);
                    }(g, u)) {
                        var v = g[u];
                        if (C ? C = !1 : y += p ? ",\n" : ",", (y = (y += p ? f + '"' + u + '": ' : '"' + u + '":') + k(v, p, f, m)).length > m) return y + "...";
                    }
                    return y += p ? "\n" + s + "}" : "}";
                }
            }
            function E(e, t) {
                for(var n = ""; 0 < t--;)n += e;
                return n;
            }
            var T = n(9791), R = n(4188), r = 'Enter a <a href="http://jmespath.org" target="_blank">JMESPath</a> query to filter, sort, or transform the JSON data.<br/>To learn JMESPath, go to <a href="http://jmespath.org/tutorial.html" target="_blank">the interactive tutorial</a>.';
            function s(e) {
                var t = e.container, I = e.json, n = e.queryDescription, n = void 0 === n ? r : n, b = e.createQuery, A = e.executeQuery, w = e.onTransform, S = I, e = '<label class="pico-modal-contents"><div class="pico-modal-header">' + (0, o.Iu)("transform") + "</div><p>" + n + '</p><div class="jsoneditor-jmespath-label">' + (0, o.Iu)("transformWizardLabel") + ' </div><div id="wizard" class="jsoneditor-jmespath-block jsoneditor-jmespath-wizard">  <table class="jsoneditor-jmespath-wizard-table">    <tbody>      <tr>        <th>' + (0, o.Iu)("transformWizardFilter") + '</th>        <td class="jsoneditor-jmespath-filter">          <div class="jsoneditor-inline jsoneditor-jmespath-filter-field" >            <select id="filterField">            </select>          </div>          <div class="jsoneditor-inline jsoneditor-jmespath-filter-relation" >            <select id="filterRelation">              <option value="==">==</option>              <option value="!=">!=</option>              <option value="<">&lt;</option>              <option value="<=">&lt;=</option>              <option value=">">&gt;</option>              <option value=">=">&gt;=</option>            </select>          </div>          <div class="jsoneditor-inline jsoneditor-jmespath-filter-value" >            <input type="text" class="value" placeholder="value..." id="filterValue" />          </div>        </td>      </tr>      <tr>        <th>' + (0, o.Iu)("transformWizardSortBy") + '</th>        <td class="jsoneditor-jmespath-filter">          <div class="jsoneditor-inline jsoneditor-jmespath-sort-field">            <select id="sortField">            </select>          </div>          <div class="jsoneditor-inline jsoneditor-jmespath-sort-order" >            <select id="sortOrder">              <option value="asc">Ascending</option>              <option value="desc">Descending</option>            </select>          </div>        </td>      </tr>      <tr id="selectFieldsPart">        <th>' + (0, o.Iu)("transformWizardSelectFields") + '</th>        <td class="jsoneditor-jmespath-filter">          <select class="jsoneditor-jmespath-select-fields" id="selectFields" multiple></select>        </td>      </tr>    </tbody>  </table></div><div class="jsoneditor-jmespath-label">' + (0, o.Iu)("transformQueryLabel") + ' </div><div class="jsoneditor-jmespath-block">  <textarea id="query"             rows="4"             autocomplete="off"             autocorrect="off"             autocapitalize="off"             spellcheck="false"            title="' + (0, o.Iu)("transformQueryTitle") + '">[*]</textarea></div><div class="jsoneditor-jmespath-label">' + (0, o.Iu)("transformPreviewLabel") + ' </div><div class="jsoneditor-jmespath-block">  <textarea id="preview"       class="jsoneditor-transform-preview"      readonly> </textarea></div><div class="jsoneditor-jmespath-block jsoneditor-modal-actions">  <input type="submit" id="ok" value="' + (0, o.Iu)("ok") + '" autofocus /></div></div>';
                i()({
                    parent: t,
                    content: e,
                    overlayClass: "jsoneditor-modal-overlay",
                    overlayStyles: {
                        backgroundColor: "rgb(1,1,1)",
                        opacity: .3
                    },
                    modalClass: "jsoneditor-modal jsoneditor-modal-transform",
                    focus: !1
                }).afterCreate(function(t) {
                    var e = t.modalElem(), n = e.querySelector("#wizard"), r = e.querySelector("#ok"), o = e.querySelector("#filterField"), s = e.querySelector("#filterRelation"), a = e.querySelector("#filterValue"), l = e.querySelector("#sortField"), c = e.querySelector("#sortOrder"), h = e.querySelector("#selectFields"), d = e.querySelector("#query"), u = e.querySelector("#preview");
                    Array.isArray(S) || (n.style.fontStyle = "italic", n.textContent = "(wizard not available for objects, only for arrays)");
                    (0, T.getChildPaths)(I).forEach(function(e) {
                        var e = f(e), t = document.createElement("option"), t = (t.text = e, t.value = e, o.appendChild(t), document.createElement("option"));
                        t.text = e, t.value = e, l.appendChild(t);
                    });
                    var n = (0, T.getChildPaths)(I, !0).filter(function(e) {
                        return "" !== e;
                    }), n = (0 < n.length ? n.forEach(function(e) {
                        var e = f(e), t = document.createElement("option");
                        t.text = e, t.value = e, h.appendChild(t);
                    }) : (n = e.querySelector("#selectFieldsPart")) && (n.style.display = "none"), new (x())(o, {
                        defaultSelected: !1,
                        clearable: !0,
                        allowDeselect: !0,
                        placeholder: "field..."
                    })), i = new (x())(s, {
                        defaultSelected: !1,
                        clearable: !0,
                        allowDeselect: !0,
                        placeholder: "compare..."
                    }), g = new (x())(l, {
                        defaultSelected: !1,
                        clearable: !0,
                        allowDeselect: !0,
                        placeholder: "field..."
                    }), p = new (x())(c, {
                        defaultSelected: !1,
                        clearable: !0,
                        allowDeselect: !0,
                        placeholder: "order..."
                    }), m = new (x())(h, {
                        multiple: !0,
                        clearable: !0,
                        defaultSelected: !1,
                        placeholder: "select fields..."
                    });
                    function f(e) {
                        return "" === e ? "@" : "." === e[0] ? e.slice(1) : e;
                    }
                    n.on("selectr.change", v), i.on("selectr.change", v), a.oninput = v, g.on("selectr.change", v), p.on("selectr.change", v), m.on("selectr.change", v), e.querySelector(".pico-modal-contents").onclick = function(e) {
                        "A" !== e.target.nodeName && e.preventDefault();
                    };
                    var C = (0, T.debounce)(function() {
                        try {
                            var e = A(S, d.value);
                            u.className = "jsoneditor-transform-preview", u.value = (t = e, n = 2, i = R.WF, "number" == typeof n ? 10 < n ? o = E(" ", 10) : 1 <= n && (o = E(" ", n)) : "string" == typeof n && "" !== n && (o = n), (n = k(t, o, "", i)).length > i ? (t = n, ("number" == typeof (o = i) ? t.slice(0, o) : t) + "...") : n), r.disabled = !1;
                        } catch (e) {
                            u.className = "jsoneditor-transform-preview jsoneditor-error", u.value = e.toString(), r.disabled = !0;
                        }
                        var t, n, i, o;
                    }, 300);
                    function y(t, e) {
                        try {
                            d.value = b(t, e), r.disabled = !1, C();
                        } catch (e) {
                            t = 'Error: an error happened when executing "createQuery": ' + (e.message || e.toString());
                            d.value = "", r.disabled = !0, u.className = "jsoneditor-transform-preview jsoneditor-error", u.value = t;
                        }
                    }
                    function v() {
                        var e = {};
                        if (o.value && s.value && a.value && (e.filter = {
                            field: o.value,
                            relation: s.value,
                            value: a.value
                        }), l.value && c.value && (e.sort = {
                            field: l.value,
                            direction: c.value
                        }), h.value) {
                            for(var t, n = [], i = 0; i < h.options.length; i++)h.options[i].selected && (t = h.options[i].value, n.push(t));
                            e.projection = {
                                fields: n
                            };
                        }
                        y(I, e);
                    }
                    d.oninput = C, r.onclick = function(e) {
                        e.preventDefault(), e.stopPropagation(), t.close(), w(d.value);
                    }, y(I, {}), setTimeout(function() {
                        d.select(), d.focus(), d.selectionStart = 3, d.selectionEnd = 3;
                    });
                }).afterClose(function(e) {
                    e.destroy();
                }).show();
            }
        },
        8458: function(e, t, n) {
            "use strict";
            n.r(t), n.d(t, {
                textModeMixins: function() {
                    return A;
                }
            });
            var i = n(1262), t = n(8170), l = n.n(t), a = n(4188), c = n(6436), h = n(2474), d = n(7907), u = n(6056), g = n(6617), o = n(6210), p = n(2558), m = n(9125), f = n(7026), C = n(9791);
            function r(e) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function s(e, t) {
                for(var n = 0; n < t.length; n++){
                    var i = t[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function(e) {
                        e = function(e, t) {
                            if ("object" !== r(e) || null === e) return e;
                            var n = e[Symbol.toPrimitive];
                            if (void 0 === n) return ("string" === t ? String : Number)(e);
                            n = n.call(e, t || "default");
                            if ("object" !== r(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }(e, "string");
                        return "symbol" === r(e) ? e : String(e);
                    }(i.key), i);
                }
            }
            var y = function() {
                function n(e, t) {
                    if (!(this instanceof n)) throw new TypeError("Cannot call a class as a function");
                    this.schema = e, this.schemaRefs = t || {}, this.suggestions = {}, this.suggestionsRefs = {}, this._buildSuggestions();
                }
                var e, t, i;
                return e = n, t = [
                    {
                        key: "_buildSuggestions",
                        value: function() {
                            for(var e in this._handleSchemaEntry("", this.schema, this.suggestions), this.schemaRefs)this.suggestionsRefs[e] = {}, this._handleSchemaEntry("", this.schemaRefs[e], this.suggestionsRefs[e]);
                        }
                    },
                    {
                        key: "_handleRef",
                        value: function(e, t, n) {
                            n[e] = n[e] || {}, n[e].refs = n[e].refs || [], n[e].refs = (0, C.uniqueMergeArrays)(n[e].refs, [
                                t
                            ]);
                        }
                    },
                    {
                        key: "_handleSchemaEntry",
                        value: function(e, t, n) {
                            if (t) {
                                if (t.$ref) this._handleRef(e, t.$ref, n);
                                else {
                                    var i = this._checkOfConditon(t);
                                    if (i) this._handleOfCondition(e, t[i], n);
                                    else switch(t.type){
                                        case "object":
                                            this._handleObject(e, t, n);
                                            break;
                                        case "string":
                                        case "number":
                                        case "integer":
                                            this._handlePrimitive(e, t, n);
                                            break;
                                        case "boolean":
                                            this._handleBoolean(e, t, n);
                                            break;
                                        case "array":
                                            this._handleArray(e, t, n);
                                    }
                                }
                            } else console.error("SchemaTextCompleter: schema node is missing for path", e);
                        }
                    },
                    {
                        key: "_handleObject",
                        value: function(t, n, i) {
                            var e, o = this;
                            (0, C.isObject)(n.properties) && (e = Object.keys(n.properties), i[t] = i[t] || {}, i[t].props = i[t].props || [], i[t].props = (0, C.uniqueMergeArrays)(i[t].props, e), e.forEach(function(e) {
                                (0, C.asyncExec)(function() {
                                    o._handleSchemaEntry("".concat(t, "/").concat(e), n.properties[e], i);
                                });
                            }));
                        }
                    },
                    {
                        key: "_handlePrimitive",
                        value: function(e, t, n) {
                            n[e] = n[e] || {}, (0, C.isArray)(t.examples) && (n[e].examples = n[e].examples || [], n[e].examples = (0, C.uniqueMergeArrays)(n[e].examples, t.examples)), (0, C.isArray)(t.enum) && (n[e].enum = n[e].enum || [], n[e].enum = (0, C.uniqueMergeArrays)(n[e].enum, t.enum));
                        }
                    },
                    {
                        key: "_handleBoolean",
                        value: function(e, t, n) {
                            n[e] || (n[e] = {
                                bool: [
                                    !0,
                                    !1
                                ]
                            });
                        }
                    },
                    {
                        key: "_handleArray",
                        value: function(e, t, n) {
                            var i = this;
                            t.items && (0, C.asyncExec)(function() {
                                i._handleSchemaEntry("".concat(e, "/\\d+"), t.items, n);
                            });
                        }
                    },
                    {
                        key: "_handleOfCondition",
                        value: function(t, e, n) {
                            var i = this;
                            e && e.length && e.forEach(function(e) {
                                (0, C.asyncExec)(function() {
                                    i._handleSchemaEntry(t, e, n);
                                });
                            });
                        }
                    },
                    {
                        key: "_checkOfConditon",
                        value: function(e) {
                            if (e) return e.oneOf ? "oneOf" : e.anyOf ? "anyOf" : e.allOf ? "allOf" : void 0;
                        }
                    },
                    {
                        key: "getCompletions",
                        value: function(e, t, i, n, s) {
                            var c = this;
                            try {
                                var o = f.parse(t.getValue()).pointers || {}, r = function(i) {
                                    function e(t) {
                                        var e, n = {
                                            props: "property",
                                            enum: "enum",
                                            bool: "boolean",
                                            examples: "examples"
                                        };
                                        i && null != (e = i[t]) && e.length && (o = o.concat(i[t].map(function(e) {
                                            return {
                                                caption: e + "",
                                                meta: "schema [".concat(n[t], "]"),
                                                score: r++,
                                                value: e + ""
                                            };
                                        })));
                                    }
                                    var o = [], r = 0;
                                    e("props"), e("enum"), e("bool"), e("examples"), o.length && s(null, o);
                                };
                                Object.keys(o).forEach(function(n) {
                                    (0, C.asyncExec)(function() {
                                        function l(n, e, i) {
                                            var t, o = Object.keys(e).reduce(function(e, t) {
                                                return new RegExp("^".concat(i).concat(t)).test(n) && (!e || e.length < t.length) ? t : e;
                                            });
                                            if ("string" == typeof o) {
                                                if (null != (t = e[o]) && null != (t = t.refs) && t.length) {
                                                    var r, s = {};
                                                    for(r in e[o].refs){
                                                        var a = e[o].refs[r];
                                                        c.suggestionsRefs[a] && (null != (a = l(n, c.suggestionsRefs[a], "".concat(i).concat(o))) && a.enum && (s.enum = (0, C.uniqueMergeArrays)(s.enum, a.enum)), null != a && a.examples && (s.examples = (0, C.uniqueMergeArrays)(s.examples, a.examples)), null != a && a.bool && (s.bool = (0, C.uniqueMergeArrays)(s.bool, a.bool)), null != a) && a.props && (s.props = (0, C.uniqueMergeArrays)(s.props, a.props));
                                                    }
                                                    return s;
                                                }
                                                if (new RegExp("^".concat(i).concat(o, "$")).test(n)) return e[o];
                                            }
                                        }
                                        var e, t;
                                        (null == (t = o[n].key) ? void 0 : t.line) === i.row && i.column >= o[n].key.column && i.column <= o[n].keyEnd.column && (e = n.slice(0, n.lastIndexOf("/"))), (e = (null == (t = o[n].value) ? void 0 : t.line) === i.row && (null == (t = o[n].value) ? void 0 : t.line) === (null == (t = o[n].valueEnd) ? void 0 : t.line) && i.column >= o[n].value.column && i.column <= o[n].valueEnd.column ? n : e) && (t = l(e, c.suggestions, ""), r(t));
                                    });
                                });
                            } catch (e) {}
                        }
                    }
                ], s(e.prototype, t), i && s(e, i), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), n;
            }();
            function v(e) {
                return (v = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            var t = {}, I = "ace/theme/jsoneditor";
            function b() {
                try {
                    this.format();
                } catch (e) {}
            }
            t.create = function(e) {
                var t, n, i, o = this, r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, s = (void 0 === r.statusBar && (r.statusBar = !0), r.mainMenuBar = !1 !== r.mainMenuBar, r.enableSort = !1 !== r.enableSort, r.enableTransform = !1 !== r.enableTransform, r.createQuery = r.createQuery || u.r, r.executeQuery = r.executeQuery || u.J, r.showErrorTable = void 0 !== r.showErrorTable ? r.showErrorTable : [
                    "text",
                    "preview"
                ], "number" == typeof (this.options = r).indentation ? this.indentation = Number(r.indentation) : this.indentation = 2, (0, d.cC)(this.options.languages), (0, d.m0)(this.options.language), r.ace || l()), a = (this.mode = "code" === r.mode ? "code" : "text", "code" === this.mode && void 0 === s && (this.mode = "text", console.warn("Failed to load Ace editor, falling back to plain text mode. Please use a JSONEditor bundle including Ace, or pass Ace as via the configuration option `ace`.")), this.theme = r.theme || I, this.theme === I && s && (0, m.O)(), r.onTextSelectionChange && this.onTextSelectionChange(r.onTextSelectionChange), this), e = (this.container = e, this.dom = {}, this.aceEditor = void 0, this.textarea = void 0, this.validateSchema = null, this.annotations = [], this.lastSchemaErrors = void 0, this._debouncedValidate = (0, C.debounce)(this._validateAndCatch.bind(this), this.DEBOUNCE_INTERVAL), this.width = e.clientWidth, this.height = e.clientHeight, this.frame = document.createElement("div"), this.frame.className = "jsoneditor jsoneditor-mode-" + this.options.mode, this.frame.onclick = function(e) {
                    e.preventDefault();
                }, this.frame.onkeydown = function(e) {
                    a._onKeyDown(e);
                }, {
                    target: this.frame,
                    onFocus: this.options.onFocus || null,
                    onBlur: this.options.onBlur || null
                }), e = (this.frameFocusTracker = new h.R(e), this.content = document.createElement("div"), this.content.className = "jsoneditor-outer", this.options.mainMenuBar && ((0, C.addClassName)(this.content, "has-main-menu-bar"), this.menu = document.createElement("div"), this.menu.className = "jsoneditor-menu", this.frame.appendChild(this.menu), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-format", e.title = (0, d.Iu)("formatTitle"), this.menu.appendChild(e), e.onclick = function() {
                    try {
                        a.format(), a._onChange();
                    } catch (e) {
                        a._onError(e);
                    }
                }, (e = document.createElement("button")).type = "button", e.className = "jsoneditor-compact", e.title = (0, d.Iu)("compactTitle"), this.menu.appendChild(e), e.onclick = function() {
                    try {
                        a.compact(), a._onChange();
                    } catch (e) {
                        a._onError(e);
                    }
                }, this.options.enableSort && ((e = document.createElement("button")).type = "button", e.className = "jsoneditor-sort", e.title = (0, d.Iu)("sortTitleShort"), e.onclick = function() {
                    a._showSortModal();
                }, this.menu.appendChild(e)), this.options.enableTransform && ((e = document.createElement("button")).type = "button", e.title = (0, d.Iu)("transformTitleShort"), e.className = "jsoneditor-transform", e.onclick = function() {
                    a._showTransformModal();
                }, this.menu.appendChild(e)), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-repair", e.title = (0, d.Iu)("repairTitle"), this.menu.appendChild(e), e.onclick = function() {
                    try {
                        a.repair(), a._onChange();
                    } catch (e) {
                        a._onError(e);
                    }
                }, "code" === this.mode && ((e = document.createElement("button")).type = "button", e.className = "jsoneditor-undo jsoneditor-separator", e.title = (0, d.Iu)("undo"), e.onclick = function() {
                    o.aceEditor.getSession().getUndoManager().undo();
                }, this.menu.appendChild(e), this.dom.undo = e, (e = document.createElement("button")).type = "button", e.className = "jsoneditor-redo", e.title = (0, d.Iu)("redo"), e.onclick = function() {
                    o.aceEditor.getSession().getUndoManager().redo();
                }, this.menu.appendChild(e), this.dom.redo = e), this.options && this.options.modes && this.options.modes.length && (this.modeSwitcher = new g.x(this.menu, this.options.modes, this.options.mode, function(e) {
                    try {
                        a.setMode(e), a.modeSwitcher.focus();
                    } catch (e) {
                        a._onError(e);
                    }
                })), "code" === this.mode) && ((t = document.createElement("a")).appendChild(document.createTextNode("powered by ace")), t.href = "https://ace.c9.io/", t.target = "_blank", t.className = "jsoneditor-poweredBy", t.onclick = function() {
                    window.open(t.href, t.target, "noreferrer");
                }, this.menu.appendChild(t)), this.options.onEditable && v("function" === this.options.onEditable) && !this.options.onEditable({})), s = (this.frame.appendChild(this.content), this.container.appendChild(this.frame), "code" === this.mode ? (this.editorDom = document.createElement("div"), this.editorDom.style.height = "100%", this.editorDom.style.width = "100%", this.content.appendChild(this.editorDom), i = (s = s.edit(this.editorDom)).getSession(), s.$blockScrolling = 1 / 0, s.setTheme(this.theme), s.setOptions({
                    readOnly: e
                }), s.setShowPrintMargin(!1), s.setFontSize("14px"), i.setMode("ace/mode/json"), i.setTabSize(this.indentation), i.setUseSoftTabs(!0), i.setUseWrapMode(!0), n = i.setAnnotations, i.setAnnotations = function(e) {
                    n.call(this, e && e.length ? e : a.annotations);
                }, s.commands.bindKey("Ctrl-L", null), s.commands.bindKey("Command-L", null), s.commands.bindKey("Ctrl-\\", null), s.commands.bindKey("Command-\\", null), s.commands.bindKey("Ctrl-Shift-\\", null), s.commands.bindKey("Command-Shift-\\", null), (this.aceEditor = s).on("change", this._onChange.bind(this)), s.on("changeSelection", this._onSelect.bind(this))) : ((i = document.createElement("textarea")).className = "jsoneditor-text", i.spellcheck = !1, this.content.appendChild(i), this.textarea = i, this.textarea.readOnly = e, null === this.textarea.oninput ? this.textarea.oninput = this._onChange.bind(this) : this.textarea.onchange = this._onChange.bind(this), i.onselect = this._onSelect.bind(this), i.onmousedown = this._onMouseDown.bind(this), i.onblur = this._onBlur.bind(this)), this._updateHistoryButtons(), Array.isArray(this.options.showErrorTable) ? this.options.showErrorTable.includes(this.mode) : !0 === this.options.showErrorTable);
                this.errorTable = new c.Q({
                    errorTableVisible: s,
                    onToggleVisibility: function() {
                        a._validateAndCatch();
                    },
                    onFocusLine: function(e) {
                        a.isFocused = !0, isNaN(e) || a.setTextSelection({
                            row: e,
                            column: 1
                        }, {
                            row: e,
                            column: 1e3
                        });
                    },
                    onChangeHeight: function(e) {
                        e = e + (a.dom.statusBar ? a.dom.statusBar.clientHeight : 0) + 1;
                        a.content.style.marginBottom = -e + "px", a.content.style.paddingBottom = e + "px";
                    }
                }), this.frame.appendChild(this.errorTable.getErrorTable()), r.statusBar && ((0, C.addClassName)(this.content, "has-status-bar"), this.curserInfoElements = {}, e = document.createElement("div"), (this.dom.statusBar = e).className = "jsoneditor-statusbar", this.frame.appendChild(e), (i = document.createElement("span")).className = "jsoneditor-curserinfo-label", i.innerText = "Ln:", (s = document.createElement("span")).className = "jsoneditor-curserinfo-val", s.innerText = "1", e.appendChild(i), e.appendChild(s), (r = document.createElement("span")).className = "jsoneditor-curserinfo-label", r.innerText = "Col:", (i = document.createElement("span")).className = "jsoneditor-curserinfo-val", i.innerText = "1", e.appendChild(r), e.appendChild(i), this.curserInfoElements.colVal = i, this.curserInfoElements.lnVal = s, (r = document.createElement("span")).className = "jsoneditor-curserinfo-label", r.innerText = "characters selected", r.style.display = "none", (i = document.createElement("span")).className = "jsoneditor-curserinfo-count", i.innerText = "0", i.style.display = "none", this.curserInfoElements.countLabel = r, this.curserInfoElements.countVal = i, e.appendChild(i), e.appendChild(r), e.appendChild(this.errorTable.getErrorCounter()), e.appendChild(this.errorTable.getWarningIcon()), e.appendChild(this.errorTable.getErrorIcon())), this.setSchema(this.options.schema, this.options.schemaRefs);
            }, t._onSchemaChange = function(e, t) {
                this.aceEditor && (this.options.allowSchemaSuggestions && e ? (this.aceEditor.setOption("enableBasicAutocompletion", [
                    new y(e, t)
                ]), this.aceEditor.setOption("enableLiveAutocompletion", !0)) : (this.aceEditor.setOption("enableBasicAutocompletion", void 0), this.aceEditor.setOption("enableLiveAutocompletion", !1)));
            }, t._onChange = function() {
                var e = this;
                if (!this.onChangeDisabled) {
                    if (setTimeout(function() {
                        e._updateHistoryButtons && e._updateHistoryButtons();
                    }), this._debouncedValidate(), this.options.onChange) try {
                        this.options.onChange();
                    } catch (e) {
                        console.error("Error in onChange callback: ", e);
                    }
                    if (this.options.onChangeText) try {
                        this.options.onChangeText(this.getText());
                    } catch (e) {
                        console.error("Error in onChangeText callback: ", e);
                    }
                }
            }, t._updateHistoryButtons = function() {
                var e;
                this.aceEditor && this.dom.undo && this.dom.redo && (e = this.aceEditor.getSession().getUndoManager()) && e.hasUndo && e.hasRedo && (this.dom.undo.disabled = !e.hasUndo(), this.dom.redo.disabled = !e.hasRedo());
            }, t._showSortModal = function() {
                try {
                    var n = this, e = this.options.modalAnchor || a.qD, i = this.get();
                    (0, o.showSortModal)(e, i, function(e) {
                        var t;
                        Array.isArray(i) && (t = (0, C.sort)(i, e.path, e.direction), n.sortedBy = e, n.update(t)), (0, C.isObject)(i) && (t = (0, C.sortObjectKeys)(i, e.direction), n.sortedBy = e, n.update(t));
                    }, n.sortedBy);
                } catch (e) {
                    this._onError(e);
                }
            }, t._showTransformModal = function() {
                var t = this;
                try {
                    var e = this.options, n = e.modalAnchor, i = e.createQuery, o = e.executeQuery, r = e.queryDescription, s = this.get();
                    (0, p.showTransformModal)({
                        container: n || a.qD,
                        json: s,
                        queryDescription: r,
                        createQuery: i,
                        executeQuery: o,
                        onTransform: function(e) {
                            e = o(s, e);
                            t.update(e);
                        }
                    });
                } catch (e) {
                    this._onError(e);
                }
            }, t._onSelect = function() {
                this._updateCursorInfo(), this._emitSelectionChange();
            }, t._onKeyDown = function(e) {
                var t = !1;
                73 === (e.which || e.keyCode) && e.ctrlKey && (e.shiftKey ? this.compact() : this.format(), this._onChange(), t = !0), t && (e.preventDefault(), e.stopPropagation()), this._updateCursorInfo(), this._emitSelectionChange();
            }, t._onMouseDown = function() {
                this._updateCursorInfo(), this._emitSelectionChange();
            }, t._onBlur = function() {
                var e = this;
                setTimeout(function() {
                    e.isFocused || (e._updateCursorInfo(), e._emitSelectionChange()), e.isFocused = !1;
                });
            }, t._updateCursorInfo = function() {
                var e, t, n, i, o, r = this;
                function s() {
                    r.curserInfoElements.countVal.innerText !== o && (r.curserInfoElements.countVal.innerText = o, r.curserInfoElements.countVal.style.display = o ? "inline" : "none", r.curserInfoElements.countLabel.style.display = o ? "inline" : "none"), r.curserInfoElements.lnVal.innerText = n, r.curserInfoElements.colVal.innerText = i;
                }
                this.textarea ? setTimeout(function() {
                    var e = (0, C.getInputSelection)(r.textarea);
                    e.startIndex !== e.endIndex && (o = e.endIndex - e.startIndex), i = (o && r.cursorInfo && r.cursorInfo.line === e.end.row && r.cursorInfo.column === e.end.column ? (n = e.start.row, e.start) : (n = e.end.row, e.end)).column, r.cursorInfo = {
                        line: n,
                        column: i,
                        count: o
                    }, r.options.statusBar && s();
                }, 0) : this.aceEditor && this.curserInfoElements && (e = this.aceEditor.getCursorPosition(), t = this.aceEditor.getSelectedText(), n = e.row + 1, i = e.column + 1, o = t.length, r.cursorInfo = {
                    line: n,
                    column: i,
                    count: o
                }, this.options.statusBar) && s();
            }, t._emitSelectionChange = function() {
                var e;
                this._selectionChangedHandler && (e = this.getTextSelection(), this._selectionChangedHandler(e.start, e.end, e.text));
            }, t._refreshAnnotations = function() {
                var e, t = this.aceEditor && this.aceEditor.getSession();
                t && (e = t.getAnnotations().filter(function(e) {
                    return "error" === e.type;
                }), t.setAnnotations(e));
            }, t.destroy = function() {
                this.aceEditor && (this.aceEditor.destroy(), this.aceEditor = null), this.frame && this.container && this.frame.parentNode === this.container && this.container.removeChild(this.frame), this.modeSwitcher && (this.modeSwitcher.destroy(), this.modeSwitcher = null), this.textarea = null, this._debouncedValidate = null, this.frameFocusTracker.destroy();
            }, t.compact = function() {
                var e = this.get(), e = JSON.stringify(e);
                this.updateText(e);
            }, t.format = function() {
                var e = this.get(), e = JSON.stringify(e, null, this.indentation);
                this.updateText(e);
            }, t.repair = function() {
                var e = this.getText();
                try {
                    var t = (0, i.K)(e);
                    this.updateText(t);
                } catch (e) {}
            }, t.focus = function() {
                this.textarea && this.textarea.focus(), this.aceEditor && this.aceEditor.focus();
            }, t.resize = function() {
                this.aceEditor && this.aceEditor.resize(!1);
            }, t.set = function(e) {
                this.setText(JSON.stringify(e, null, this.indentation));
            }, t.update = function(e) {
                this.updateText(JSON.stringify(e, null, this.indentation));
            }, t.get = function() {
                var e = this.getText();
                return (0, C.parse)(e);
            }, t.getText = function() {
                return this.textarea ? this.textarea.value : this.aceEditor ? this.aceEditor.getValue() : "";
            }, t._setText = function(e, t) {
                var n, i = this, e = !0 === this.options.escapeUnicode ? (0, C.escapeUnicodeChars)(e) : e;
                this.textarea && (this.textarea.value = e), this.aceEditor && (this.onChangeDisabled = !0, this.aceEditor.setValue(e, -1), this.onChangeDisabled = !1, t && (n = this, setTimeout(function() {
                    n.aceEditor && n.aceEditor.session.getUndoManager().reset();
                })), setTimeout(function() {
                    i._updateHistoryButtons && i._updateHistoryButtons();
                })), this._debouncedValidate();
            }, t.setText = function(e) {
                this._setText(e, !0);
            }, t.updateText = function(e) {
                this.getText() !== e && this._setText(e, !1);
            }, t.validate = function() {
                var t, n = this, i = [], o = [];
                try {
                    var r = this.get(), s = (this.validateSchema && !this.validateSchema(r) && (i = this.validateSchema.errors.map(function(e) {
                        return e.type = "validation", (0, C.improveSchemaError)(e);
                    })), this.validationSequence = (this.validationSequence || 0) + 1, this), a = this.validationSequence;
                    return (function(e, t) {
                        if (!t) return Promise.resolve([]);
                        try {
                            var n = t(e);
                            return ((0, C.isPromise)(n) ? n : Promise.resolve(n)).then(function(e) {
                                return Array.isArray(e) ? e.filter(function(e) {
                                    var t = (0, C.isValidValidationError)(e);
                                    return t || console.warn('Ignoring a custom validation error with invalid structure. Expected structure: {path: [...], message: "..."}. Actual error:', e), t;
                                }).map(function(e) {
                                    return {
                                        dataPath: (0, C.stringifyPath)(e.path),
                                        message: e.message,
                                        type: "customValidation"
                                    };
                                }) : [];
                            });
                        } catch (e) {
                            return Promise.reject(e);
                        }
                    })(r, this.options.onValidate).then(function(e) {
                        return a === s.validationSequence && (e = i.concat(o).concat(e), s._renderErrors(e), "function" == typeof n.options.onValidationError && (0, C.isValidationErrorChanged)(e, n.lastSchemaErrors) && n.options.onValidationError.call(n, e), n.lastSchemaErrors = e), n.lastSchemaErrors;
                    });
                } catch (e) {
                    return this.getText() && ((r = /\w*line\s*(\d+)\w*/g.exec(e.message)) && (t = +r[1]), o = [
                        {
                            type: "error",
                            message: e.message.replace(/\n/g, "<br>"),
                            line: t
                        }
                    ]), this._renderErrors(o), "function" == typeof this.options.onValidationError && (0, C.isValidationErrorChanged)(o, this.lastSchemaErrors) && this.options.onValidationError.call(this, o), this.lastSchemaErrors = o, Promise.resolve(this.lastSchemaErrors);
                }
            }, t._validateAndCatch = function() {
                this.validate().catch(function(e) {
                    console.error("Error running validation:", e);
                });
            }, t._renderErrors = function(i) {
                var e = this.getText(), t = [], e = (i.reduce(function(e, t) {
                    return "string" == typeof t.dataPath && -1 === e.indexOf(t.dataPath) && e.push(t.dataPath), e;
                }, t), (0, C.getPositionForPath)(e, t));
                this.aceEditor && (this.annotations = e.map(function(t) {
                    var e = i.filter(function(e) {
                        return e.dataPath === t.path;
                    }), n = e.map(function(e) {
                        return e.message;
                    }).join("\n");
                    return n ? {
                        row: t.line,
                        column: t.column,
                        text: "Schema validation error" + (1 !== e.length ? "s" : "") + ": \n" + n,
                        type: "warning",
                        source: "jsoneditor"
                    } : {};
                }), this._refreshAnnotations()), this.errorTable.setErrors(i, e), this.aceEditor && this.aceEditor.resize(!1);
            }, t.getTextSelection = function() {
                var e, t, n, i = {};
                return this.textarea ? (n = (0, C.getInputSelection)(this.textarea), this.cursorInfo && this.cursorInfo.line === n.end.row && this.cursorInfo.column === n.end.column ? (i.start = n.end, i.end = n.start) : i = n, {
                    start: i.start,
                    end: i.end,
                    text: this.textarea.value.substring(n.startIndex, n.endIndex)
                }) : this.aceEditor ? (n = this.aceEditor.getSelection(), e = this.aceEditor.getSelectedText(), t = n.getRange(), (n = n.getSelectionLead()).row === t.end.row && n.column === t.end.column ? i = t : (i.start = t.end, i.end = t.start), {
                    start: {
                        row: i.start.row + 1,
                        column: i.start.column + 1
                    },
                    end: {
                        row: i.end.row + 1,
                        column: i.end.column + 1
                    },
                    text: e
                }) : void 0;
            }, t.onTextSelectionChange = function(e) {
                "function" == typeof e && (this._selectionChangedHandler = (0, C.debounce)(e, this.DEBOUNCE_INTERVAL));
            }, t.setTextSelection = function(e, t) {
                var n, i, o;
                e && t && (this.textarea ? (n = (0, C.getIndexForPosition)(this.textarea, e.row, e.column), o = (0, C.getIndexForPosition)(this.textarea, t.row, t.column), -1 < n && -1 < o && (this.textarea.setSelectionRange ? (this.textarea.focus(), this.textarea.setSelectionRange(n, o)) : this.textarea.createTextRange && ((i = this.textarea.createTextRange()).collapse(!0), i.moveEnd("character", o), i.moveStart("character", n), i.select()), o = (this.textarea.value.match(/\n/g) || []).length + 1, n = this.textarea.scrollHeight / o, i = e.row * n, this.textarea.scrollTop = i > this.textarea.clientHeight ? i - this.textarea.clientHeight / 2 : 0)) : this.aceEditor && (o = {
                    start: {
                        row: e.row - 1,
                        column: e.column - 1
                    },
                    end: {
                        row: t.row - 1,
                        column: t.column - 1
                    }
                }, this.aceEditor.selection.setRange(o), this.aceEditor.scrollToLine(e.row - 1, !0)));
            };
            var A = [
                {
                    mode: "text",
                    mixin: t,
                    data: "text",
                    load: b
                },
                {
                    mode: "code",
                    mixin: t,
                    data: "text",
                    load: b
                }
            ];
        },
        8038: function(W, e, t) {
            "use strict";
            t.r(e), t.d(e, {
                treeModeMixins: function() {
                    return D;
                }
            });
            var w = {
                start: function(e, t, n) {
                    return 0 === t.indexOf(e);
                },
                contain: function(e, t, n) {
                    return -1 < t.indexOf(e);
                }
            };
            var s = t(897), a = t(2474);
            function o(e) {
                return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function r(e, t) {
                for(var n = 0; n < t.length; n++){
                    var i = t[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function(e) {
                        e = function(e, t) {
                            if ("object" !== o(e) || null === e) return e;
                            var n = e[Symbol.toPrimitive];
                            if (void 0 === n) return ("string" === t ? String : Number)(e);
                            n = n.call(e, t || "default");
                            if ("object" !== o(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }(e, "string");
                        return "symbol" === o(e) ? e : String(e);
                    }(i.key), i);
                }
            }
            var S = function() {
                function e() {
                    if (!(this instanceof e)) throw new TypeError("Cannot call a class as a function");
                    this.locked = !1;
                }
                var t, n, i;
                return t = e, n = [
                    {
                        key: "highlight",
                        value: function(e) {
                            this.locked || (this.node !== e && (this.node && this.node.setHighlight(!1), this.node = e, this.node.setHighlight(!0)), this._cancelUnhighlight());
                        }
                    },
                    {
                        key: "unhighlight",
                        value: function() {
                            var e;
                            this.locked || (e = this).node && (this._cancelUnhighlight(), this.unhighlightTimer = setTimeout(function() {
                                e.node.setHighlight(!1), e.node = void 0, e.unhighlightTimer = void 0;
                            }, 0));
                        }
                    },
                    {
                        key: "_cancelUnhighlight",
                        value: function() {
                            this.unhighlightTimer && (clearTimeout(this.unhighlightTimer), this.unhighlightTimer = void 0);
                        }
                    },
                    {
                        key: "lock",
                        value: function() {
                            this.locked = !0;
                        }
                    },
                    {
                        key: "unlock",
                        value: function() {
                            this.locked = !1;
                        }
                    }
                ], r(t.prototype, n), i && r(t, i), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e;
            }(), l = t(7907), i = t(6056), c = t(6617), e = t(233), h = t.n(e), d = t(2602), k = t(9791);
            var u = t(6210), g = t(2558), p = t(4188);
            function H(e) {
                return function(e) {
                    if (Array.isArray(e)) return f(e);
                }(e) || function(e) {
                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                }(e) || m(e) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function G(e, t) {
                return function(e) {
                    if (Array.isArray(e)) return e;
                }(e) || function(e, t) {
                    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (null != n) {
                        var i, o, r, s, a = [], l = !0, c = !1;
                        try {
                            if (r = (n = n.call(e)).next, 0 === t) {
                                if (Object(n) !== n) return;
                                l = !1;
                            } else for(; !(l = (i = r.call(n)).done) && (a.push(i.value), a.length !== t); l = !0);
                        } catch (e) {
                            c = !0, o = e;
                        } finally{
                            try {
                                if (!l && null != n.return && (s = n.return(), Object(s) !== s)) return;
                            } finally{
                                if (c) throw o;
                            }
                        }
                        return a;
                    }
                }(e, t) || m(e, t) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function x(e, t) {
                var n, i, o, r, s = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (s) return i = (n = !0, false), {
                    s: function() {
                        s = s.call(e);
                    },
                    n: function() {
                        var e = s.next();
                        return n = e.done, e;
                    },
                    e: function(e) {
                        i = !0, o = e;
                    },
                    f: function() {
                        try {
                            n || null == s.return || s.return();
                        } finally{
                            if (i) throw o;
                        }
                    }
                };
                if (Array.isArray(e) || (s = m(e)) || t && e && "number" == typeof e.length) return s && (e = s), r = 0, {
                    s: t = function() {},
                    n: function() {
                        return r >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[r++]
                        };
                    },
                    e: function(e) {
                        throw e;
                    },
                    f: t
                };
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function m(e, t) {
                var n;
                if (e) return "string" == typeof e ? f(e, t) : "Map" === (n = "Object" === (n = Object.prototype.toString.call(e).slice(8, -1)) && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? f(e, t) : void 0;
            }
            function f(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var n = 0, i = new Array(t); n < t; n++)i[n] = e[n];
                return i;
            }
            function E(e) {
                return (E = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function C(e, t) {
                for(var n = 0; n < t.length; n++){
                    var i = t[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function(e) {
                        e = function(e, t) {
                            if ("object" !== E(e) || null === e) return e;
                            var n = e[Symbol.toPrimitive];
                            if (void 0 === n) return ("string" === t ? String : Number)(e);
                            n = n.call(e, t || "default");
                            if ("object" !== E(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }(e, "string");
                        return "symbol" === E(e) ? e : String(e);
                    }(i.key), i);
                }
            }
            var T = function() {
                function x(e, t) {
                    if (!(this instanceof x)) throw new TypeError("Cannot call a class as a function");
                    this.editor = e, this.dom = {}, this.expanded = !1, t && t instanceof Object ? (this.setField(t.field, t.fieldEditable), "value" in t && this.setValue(t.value, t.type), "internalValue" in t && this.setInternalValue(t.internalValue)) : (this.setField(""), this.setValue(null)), this._debouncedOnChangeValue = (0, k.debounce)(this._onChangeValue.bind(this), x.prototype.DEBOUNCE_INTERVAL), this._debouncedOnChangeField = (0, k.debounce)(this._onChangeField.bind(this), x.prototype.DEBOUNCE_INTERVAL), this.visibleChilds = this.getMaxVisibleChilds();
                }
                var e, t, n;
                return e = x, t = [
                    {
                        key: "getMaxVisibleChilds",
                        value: function() {
                            return this.editor && this.editor.options && this.editor.options.maxVisibleChilds ? this.editor.options.maxVisibleChilds : P;
                        }
                    },
                    {
                        key: "_updateEditability",
                        value: function() {
                            var e, t;
                            this.editable = {
                                field: !0,
                                value: !0
                            }, this.editor && (this.editable.field = "tree" === this.editor.options.mode, this.editable.value = "view" !== this.editor.options.mode, "tree" !== this.editor.options.mode && "form" !== this.editor.options.mode || "function" != typeof this.editor.options.onEditable || (e = this.getValue.bind(this), "boolean" == typeof (t = this.editor.options.onEditable({
                                field: this.field,
                                get value () {
                                    return e();
                                },
                                path: this.getPath()
                            })) ? (this.editable.field = t, this.editable.value = t) : "object" === E(t) && null !== t ? ("boolean" == typeof t.field && (this.editable.field = t.field), "boolean" == typeof t.value && (this.editable.value = t.value)) : (console.error("Invalid return value for function onEditable.", "Actual value:", t, ".", "Either a boolean or object { field: boolean, value: boolean } expected."), this.editable.field = !1, this.editable.value = !1)));
                        }
                    },
                    {
                        key: "getPath",
                        value: function() {
                            for(var e = this, t = []; e;){
                                var n = e.getName();
                                void 0 !== n && t.unshift(n), e = e.parent;
                            }
                            return t;
                        }
                    },
                    {
                        key: "getInternalPath",
                        value: function() {
                            for(var e = this, t = []; e;)e.parent && t.unshift(e.getIndex()), e = e.parent;
                            return t;
                        }
                    },
                    {
                        key: "getName",
                        value: function() {
                            return this.parent ? "array" !== this.parent.type ? this.field : this.index : void 0;
                        }
                    },
                    {
                        key: "findNodeByPath",
                        value: function(e) {
                            if (e) {
                                if (0 === e.length) return this;
                                if (e.length && this.childs && this.childs.length) {
                                    for(var t = 0; t < this.childs.length; ++t)if ("" + e[0] == "" + this.childs[t].getName()) return this.childs[t].findNodeByPath(e.slice(1));
                                }
                            }
                        }
                    },
                    {
                        key: "findNodeByInternalPath",
                        value: function(e) {
                            if (e) {
                                for(var t = this, n = 0; n < e.length && t; n++)var i = e[n], t = t.childs[i];
                                return t;
                            }
                        }
                    },
                    {
                        key: "serialize",
                        value: function() {
                            return {
                                value: this.getValue(),
                                path: this.getPath()
                            };
                        }
                    },
                    {
                        key: "findNode",
                        value: function(e) {
                            for(var n = (0, k.parsePath)(e), i = this; i && 0 < n.length;)!function() {
                                var t = n.shift();
                                if ("number" == typeof t) {
                                    if ("array" !== i.type) throw new Error("Cannot get child node at index " + t + ": node is no array");
                                    i = i.childs[t];
                                } else {
                                    if ("object" !== i.type) throw new Error("Cannot get child node " + t + ": node is no object");
                                    i = i.childs.filter(function(e) {
                                        return e.field === t;
                                    })[0];
                                }
                            }();
                            return i;
                        }
                    },
                    {
                        key: "findParents",
                        value: function() {
                            for(var e = [], t = this.parent; t;)e.unshift(t), t = t.parent;
                            return e;
                        }
                    },
                    {
                        key: "setError",
                        value: function(e, t) {
                            this.error = e, this.errorChild = t, this.dom && this.dom.tr && this.updateError();
                        }
                    },
                    {
                        key: "updateError",
                        value: function() {
                            var n = this, i = this.fieldError || this.valueError || this.error, e = this.dom.tdError;
                            if (i && this.dom && this.dom.tr) {
                                (0, k.addClassName)(this.dom.tr, "jsoneditor-validation-error"), e || (e = document.createElement("td"), this.dom.tdError = e, this.dom.tdValue.parentNode.appendChild(e));
                                var o = document.createElement("button"), t = (o.type = "button", o.className = "jsoneditor-button jsoneditor-schema-error", function() {
                                    n.dom.popupAnchor && n.dom.popupAnchor.destroy();
                                }), r = function() {
                                    delete n.dom.popupAnchor;
                                }, s = function(e) {
                                    var t = n.editor.frame, e = (n.dom.popupAnchor = (0, d.w)(o, n.editor.getPopupAnchor(), r, e), o.getBoundingClientRect()), t = 120 < t.getBoundingClientRect().width - e.x ? "jsoneditor-above" : "jsoneditor-left", e = document.createElement("div");
                                    e.className = "jsoneditor-popover " + t, e.appendChild(document.createTextNode(i.message)), n.dom.popupAnchor.appendChild(e);
                                }, a = (o.onmouseover = function() {
                                    n.dom.popupAnchor || s(!0);
                                }, o.onfocus = function() {
                                    t(), s(!1);
                                }, o.onblur = function() {
                                    t();
                                }, this.errorChild);
                                for(a && (o.onclick = function() {
                                    a.findParents().forEach(function(e) {
                                        e.expand(!1);
                                    }), a.scrollTo(function() {
                                        a.focus();
                                    });
                                }); e.firstChild;)e.removeChild(e.firstChild);
                                e.appendChild(o);
                            } else this.dom.tr && (0, k.removeClassName)(this.dom.tr, "jsoneditor-validation-error"), e && (this.dom.tdError.parentNode.removeChild(this.dom.tdError), delete this.dom.tdError);
                        }
                    },
                    {
                        key: "getIndex",
                        value: function() {
                            var e;
                            return this.parent ? -1 !== (e = this.parent.childs.indexOf(this)) ? e : null : -1;
                        }
                    },
                    {
                        key: "setParent",
                        value: function(e) {
                            this.parent = e;
                        }
                    },
                    {
                        key: "setField",
                        value: function(e, t) {
                            this.field = e, this.previousField = e, this.fieldEditable = !0 === t;
                        }
                    },
                    {
                        key: "getField",
                        value: function() {
                            return void 0 === this.field && this._getDomField(), this.field;
                        }
                    },
                    {
                        key: "setValue",
                        value: function(e, t) {
                            var n, i, o, r, s, a, l = this.childs;
                            if (this.type = this._getType(e), t && t !== this.type) {
                                if ("string" !== t || "auto" !== this.type) throw new Error('Type mismatch: cannot cast value of type "' + this.type + ' to the specified type "' + t + '"');
                                this.type = t;
                            }
                            if ("array" === this.type) {
                                for(this.childs || (this.childs = []), n = 0; n < e.length; n++)void 0 === (s = e[n]) || s instanceof Function || (n < this.childs.length ? ((o = this.childs[n]).fieldEditable = !1, o.index = n, o.setValue(s)) : (o = new x(this.editor, {
                                    value: s
                                }), r = n < this.getMaxVisibleChilds(), this.appendChild(o, r, !1)));
                                for(i = this.childs.length; i >= e.length; i--)this.removeChild(this.childs[i], !1);
                            } else if ("object" === this.type) {
                                for(this.childs || (this.childs = []), i = this.childs.length - 1; 0 <= i; i--)v(e, this.childs[i].field) || this.removeChild(this.childs[i], !1);
                                for(var c in n = 0, e)v(e, c) && (void 0 === (s = e[c]) || s instanceof Function || ((a = this.findChildByProperty(c)) ? (a.setField(c, !0), a.setValue(s)) : (a = new x(this.editor, {
                                    field: c,
                                    value: s
                                }), c = n < this.getMaxVisibleChilds(), this.appendChild(a, c, !1))), n++);
                                (this.value = "", true) === this.editor.options.sortObjectKeys && this.sort([], "asc", !1);
                            } else this.hideChilds(), delete this.append, delete this.showMore, delete this.expanded, delete this.childs, this.value = e;
                            Array.isArray(l) !== Array.isArray(this.childs) && this.recreateDom(), this.updateDom({
                                updateIndexes: !0
                            }), this.previousValue = this.value;
                        }
                    },
                    {
                        key: "setInternalValue",
                        value: function(e) {
                            var t, n, i, o, r, s = this.childs;
                            if (this.type = e.type, "array" === e.type) {
                                for(this.childs || (this.childs = []), o = 0; o < e.childs.length; o++)void 0 === (t = e.childs[o]) || t instanceof Function || (o < this.childs.length ? ((n = this.childs[o]).fieldEditable = !1, n.index = o, n.setInternalValue(t)) : (n = new x(this.editor, {
                                    internalValue: t
                                }), i = o < this.getMaxVisibleChilds(), this.appendChild(n, i, !1)));
                                for(r = this.childs.length; r >= e.childs.length; r--)this.removeChild(this.childs[r], !1);
                            } else if ("object" === e.type) {
                                for(this.childs || (this.childs = []), o = 0; o < e.childs.length; o++)void 0 === (t = e.childs[o]) || t instanceof Function || (o < this.childs.length ? (delete (n = this.childs[o]).index, n.setField(t.field, !0), n.setInternalValue(t.value)) : (n = new x(this.editor, {
                                    field: t.field,
                                    internalValue: t.value
                                }), i = o < this.getMaxVisibleChilds(), this.appendChild(n, i, !1)));
                                for(r = this.childs.length; r >= e.childs.length; r--)this.removeChild(this.childs[r], !1);
                            } else this.hideChilds(), delete this.append, delete this.showMore, delete this.expanded, delete this.childs, this.value = e.value;
                            Array.isArray(s) !== Array.isArray(this.childs) && this.recreateDom(), this.updateDom({
                                updateIndexes: !0
                            }), this.previousValue = this.value;
                        }
                    },
                    {
                        key: "recreateDom",
                        value: function() {
                            var e;
                            this.dom && this.dom.tr && this.dom.tr.parentNode ? (e = this._detachFromDom(), this.clearDom(), this._attachToDom(e)) : this.clearDom();
                        }
                    },
                    {
                        key: "getValue",
                        value: function() {
                            var t, n;
                            return "array" === this.type ? (t = [], this.childs.forEach(function(e) {
                                t.push(e.getValue());
                            }), t) : "object" === this.type ? (n = {}, this.childs.forEach(function(e) {
                                n[e.getField()] = e.getValue();
                            }), n) : (void 0 === this.value && this._getDomValue(), this.value);
                        }
                    },
                    {
                        key: "getInternalValue",
                        value: function() {
                            return "array" === this.type ? {
                                type: this.type,
                                childs: this.childs.map(function(e) {
                                    return e.getInternalValue();
                                })
                            } : "object" === this.type ? {
                                type: this.type,
                                childs: this.childs.map(function(e) {
                                    return {
                                        field: e.getField(),
                                        value: e.getInternalValue()
                                    };
                                })
                            } : (void 0 === this.value && this._getDomValue(), {
                                type: this.type,
                                value: this.value
                            });
                        }
                    },
                    {
                        key: "getLevel",
                        value: function() {
                            return this.parent ? this.parent.getLevel() + 1 : 0;
                        }
                    },
                    {
                        key: "getNodePath",
                        value: function() {
                            var e = this.parent ? this.parent.getNodePath() : [];
                            return e.push(this), e;
                        }
                    },
                    {
                        key: "clone",
                        value: function() {
                            var t, n;
                            return (t = new x(this.editor)).type = this.type, t.field = this.field, t.fieldInnerText = this.fieldInnerText, t.fieldEditable = this.fieldEditable, t.previousField = this.previousField, t.value = this.value, t.valueInnerText = this.valueInnerText, t.previousValue = this.previousValue, t.expanded = this.expanded, t.visibleChilds = this.visibleChilds, this.childs ? (n = [], this.childs.forEach(function(e) {
                                e = e.clone();
                                e.setParent(t), n.push(e);
                            }), t.childs = n) : t.childs = void 0, t;
                        }
                    },
                    {
                        key: "expand",
                        value: function(t) {
                            this.childs && (this.expanded = !0, this.dom.expand && (this.dom.expand.className = "jsoneditor-button jsoneditor-expanded"), this.showChilds(), !1 !== t && this.childs.forEach(function(e) {
                                e.expand(t);
                            }), this.updateDom({
                                recurse: !1
                            }));
                        }
                    },
                    {
                        key: "collapse",
                        value: function(t) {
                            this.childs && (this.hideChilds(), !1 !== t && this.childs.forEach(function(e) {
                                e.collapse(t);
                            }), this.dom.expand && (this.dom.expand.className = "jsoneditor-button jsoneditor-collapsed"), this.expanded = !1, this.updateDom({
                                recurse: !1
                            }));
                        }
                    },
                    {
                        key: "showChilds",
                        value: function() {
                            var e = this.childs;
                            if (e && this.expanded) {
                                var e = this.dom.tr, t = e ? e.parentNode : void 0;
                                if (t) {
                                    for(var n = this.getAppendDom(), i = (n.parentNode || ((o = e.nextSibling) ? t.insertBefore(n, o) : t.appendChild(n)), Math.min(this.childs.length, this.visibleChilds)), o = this._getNextTr(), r = 0; r < i; r++){
                                        var s = this.childs[r];
                                        s.getDom().parentNode || t.insertBefore(s.getDom(), o), s.showChilds();
                                    }
                                    e = this.getShowMoreDom();
                                    o = this._getNextTr(), e.parentNode || t.insertBefore(e, o), this.showMore.updateDom();
                                }
                            }
                        }
                    },
                    {
                        key: "_getNextTr",
                        value: function() {
                            return this.showMore && this.showMore.getDom().parentNode ? this.showMore.getDom() : this.append && this.append.getDom().parentNode ? this.append.getDom() : void 0;
                        }
                    },
                    {
                        key: "hide",
                        value: function(e) {
                            var t = this.dom.tr, n = t ? t.parentNode : void 0;
                            n && n.removeChild(t), this.dom.popupAnchor && this.dom.popupAnchor.destroy(), this.hideChilds(e);
                        }
                    },
                    {
                        key: "hideChilds",
                        value: function(e) {
                            var t;
                            this.childs && this.expanded && ((t = this.getAppendDom()).parentNode && t.parentNode.removeChild(t), this.childs.forEach(function(e) {
                                e.hide();
                            }), (t = this.getShowMoreDom()).parentNode && t.parentNode.removeChild(t), e && !e.resetVisibleChilds || (this.visibleChilds = this.getMaxVisibleChilds()));
                        }
                    },
                    {
                        key: "_updateCssClassName",
                        value: function() {
                            var e, t;
                            this.dom.field && this.editor && this.editor.options && "function" == typeof this.editor.options.onClassName && this.dom.tree && ((0, k.removeAllClassNames)(this.dom.tree), e = this.getValue.bind(this), t = this.editor.options.onClassName({
                                path: this.getPath(),
                                field: this.field,
                                get value () {
                                    return e();
                                }
                            }) || "", (0, k.addClassName)(this.dom.tree, "jsoneditor-values " + t));
                        }
                    },
                    {
                        key: "recursivelyUpdateCssClassesOnNodes",
                        value: function() {
                            if (this._updateCssClassName(), Array.isArray(this.childs)) for(var e = 0; e < this.childs.length; e++)this.childs[e].recursivelyUpdateCssClassesOnNodes();
                        }
                    },
                    {
                        key: "expandTo",
                        value: function() {
                            for(var e = this.parent; e;)e.expanded || e.expand(), e = e.parent;
                        }
                    },
                    {
                        key: "appendChild",
                        value: function(e, t, n) {
                            var i, o;
                            this._hasChilds() && (e.setParent(this), e.fieldEditable = "object" === this.type, "array" === this.type && (e.index = this.childs.length), "object" === this.type && void 0 === e.field && e.setField(""), this.childs.push(e), this.expanded && !1 !== t && (t = e.getDom(), o = (i = this._getNextTr()) ? i.parentNode : void 0, i && o && o.insertBefore(t, i), e.showChilds(), this.visibleChilds++), !1 !== n) && (this.updateDom({
                                updateIndexes: !0
                            }), e.updateDom({
                                recurse: !0
                            }));
                        }
                    },
                    {
                        key: "moveBefore",
                        value: function(e, t, n) {
                            var i, o, r;
                            this._hasChilds() && ((i = this.dom.tr ? this.dom.tr.parentNode : void 0) && ((o = document.createElement("tr")).style.height = i.clientHeight + "px", i.appendChild(o)), e.parent && e.parent.removeChild(e), t instanceof _ || !t ? this.childs.length + 1 > this.visibleChilds ? (r = this.childs[this.visibleChilds - 1], this.insertBefore(e, r, n)) : this.appendChild(e, !0, n) : this.insertBefore(e, t, n), i) && o && i.removeChild(o);
                        }
                    },
                    {
                        key: "insertBefore",
                        value: function(e, t, n) {
                            if (this._hasChilds()) {
                                if (this.visibleChilds++, "object" === this.type && void 0 === e.field && e.setField(""), t === this.append) e.setParent(this), e.fieldEditable = "object" === this.type, this.childs.push(e);
                                else {
                                    var i = this.childs.indexOf(t);
                                    if (-1 === i) throw new Error("Node not found");
                                    e.setParent(this), e.fieldEditable = "object" === this.type, this.childs.splice(i, 0, e);
                                }
                                var o;
                                this.expanded && (i = e.getDom(), o = (t = t.getDom()) ? t.parentNode : void 0, t && o && o.insertBefore(i, t), e.showChilds(), this.showChilds()), !1 !== n && (this.updateDom({
                                    updateIndexes: !0
                                }), e.updateDom({
                                    recurse: !0
                                }));
                            }
                        }
                    },
                    {
                        key: "insertAfter",
                        value: function(e, t) {
                            this._hasChilds() && (t = this.childs.indexOf(t), (t = this.childs[t + 1]) ? this.insertBefore(e, t) : this.appendChild(e));
                        }
                    },
                    {
                        key: "search",
                        value: function(t, n) {
                            Array.isArray(n) || (n = []);
                            var e = t ? t.toLowerCase() : void 0;
                            return delete this.searchField, delete this.searchValue, void 0 !== this.field && n.length <= this.MAX_SEARCH_RESULTS && (-1 !== String(this.field).toLowerCase().indexOf(e) && (this.searchField = !0, n.push({
                                node: this,
                                elem: "field"
                            })), this._updateDomField()), this._hasChilds() ? this.childs && this.childs.forEach(function(e) {
                                e.search(t, n);
                            }) : void 0 !== this.value && n.length <= this.MAX_SEARCH_RESULTS && (-1 !== String(this.value).toLowerCase().indexOf(e) && (this.searchValue = !0, n.push({
                                node: this,
                                elem: "value"
                            })), this._updateDomValue()), n;
                        }
                    },
                    {
                        key: "scrollTo",
                        value: function(e) {
                            this.expandPathToNode(), this.dom.tr && this.dom.tr.parentNode && this.editor.scrollTo(this.dom.tr.offsetTop, e);
                        }
                    },
                    {
                        key: "expandPathToNode",
                        value: function() {
                            for(var e = this; e && e.parent;){
                                for(var t = "array" === e.parent.type ? e.index : e.parent.childs.indexOf(e); e.parent.visibleChilds < t + 1;)e.parent.visibleChilds += this.getMaxVisibleChilds();
                                e.parent.expand(!1), e = e.parent;
                            }
                        }
                    },
                    {
                        key: "focus",
                        value: function(e) {
                            if (x.focusElement = e, this.dom.tr && this.dom.tr.parentNode) {
                                var t = this.dom;
                                switch(e){
                                    case "drag":
                                        (t.drag || t.menu).focus();
                                        break;
                                    case "menu":
                                        t.menu.focus();
                                        break;
                                    case "expand":
                                        this._hasChilds() ? t.expand.focus() : t.field && this.fieldEditable ? (t.field.focus(), (0, k.selectContentEditable)(t.field)) : t.value && !this._hasChilds() ? (t.value.focus(), (0, k.selectContentEditable)(t.value)) : t.menu.focus();
                                        break;
                                    case "field":
                                        t.field && this.fieldEditable ? (t.field.focus(), (0, k.selectContentEditable)(t.field)) : t.value && !this._hasChilds() ? (t.value.focus(), (0, k.selectContentEditable)(t.value)) : (this._hasChilds() ? t.expand : t.menu).focus();
                                        break;
                                    default:
                                        t.select ? t.select.focus() : t.value && !this._hasChilds() ? (t.value.focus(), (0, k.selectContentEditable)(t.value)) : t.field && this.fieldEditable ? (t.field.focus(), (0, k.selectContentEditable)(t.field)) : (this._hasChilds() ? t.expand : t.menu).focus();
                                }
                            }
                        }
                    },
                    {
                        key: "containsNode",
                        value: function(e) {
                            if (this === e) return !0;
                            var t = this.childs;
                            if (t) {
                                for(var n = 0, i = t.length; n < i; n++)if (t[n].containsNode(e)) return !0;
                            }
                            return !1;
                        }
                    },
                    {
                        key: "removeChild",
                        value: function(e, t) {
                            if (this.childs) {
                                var n = this.childs.indexOf(e);
                                if (-1 !== n) return n < this.visibleChilds && this.expanded && this.visibleChilds--, e.hide(), delete e.searchField, delete e.searchValue, (e = this.childs.splice(n, 1)[0]).parent = null, !1 !== t && this.updateDom({
                                    updateIndexes: !0
                                }), e;
                            }
                        }
                    },
                    {
                        key: "_remove",
                        value: function(e) {
                            this.removeChild(e);
                        }
                    },
                    {
                        key: "changeType",
                        value: function(e) {
                            var t, n = this.type;
                            n !== e && ("string" !== e && "auto" !== e || "string" !== n && "auto" !== n ? (t = this._detachFromDom(), this.clearDom(), "object" === (this.type = e) ? (this.childs || (this.childs = []), this.childs.forEach(function(e) {
                                e.clearDom(), delete e.index, e.fieldEditable = !0, void 0 === e.field && (e.field = "");
                            }), "string" !== n && "auto" !== n || (this.expanded = !0)) : "array" === e ? (this.childs || (this.childs = []), this.childs.forEach(function(e, t) {
                                e.clearDom(), e.fieldEditable = !1, e.index = t;
                            }), "string" !== n && "auto" !== n || (this.expanded = !0)) : this.expanded = !1, this._attachToDom(t)) : this.type = e, "auto" !== e && "string" !== e || (this.value = "string" === e ? String(this.value) : (0, k.parseString)(String(this.value)), this.focus()), this.updateDom({
                                updateIndexes: !0
                            }));
                        }
                    },
                    {
                        key: "deepEqual",
                        value: function(e) {
                            var t;
                            if ("array" === this.type) {
                                if (!Array.isArray(e)) return !1;
                                if (this.childs.length !== e.length) return !1;
                                for(t = 0; t < this.childs.length; t++)if (!this.childs[t].deepEqual(e[t])) return !1;
                            } else if ("object" === this.type) {
                                if ("object" !== E(e) || !e) return !1;
                                var n = Object.keys(e);
                                if (this.childs.length !== n.length) return !1;
                                for(t = 0; t < n.length; t++){
                                    var i = this.childs[t];
                                    if (i.field !== n[t] || !i.deepEqual(e[i.field])) return !1;
                                }
                            } else if (this.value !== e) return !1;
                            return !0;
                        }
                    },
                    {
                        key: "_getDomValue",
                        value: function() {
                            if (this._clearValueError(), this.dom.value && "array" !== this.type && "object" !== this.type && (this.valueInnerText = (0, k.getInnerText)(this.dom.value), "" === this.valueInnerText) && "" !== this.dom.value.innerHTML && (this.dom.value.textContent = ""), void 0 !== this.valueInnerText) try {
                                var e, t;
                                (t = "string" === this.type ? this._unescapeHTML(this.valueInnerText) : (e = this._unescapeHTML(this.valueInnerText), (0, k.parseString)(e))) !== this.value && (this.value = t, this._debouncedOnChangeValue());
                            } catch (e) {
                                this._setValueError((0, l.Iu)("cannotParseValueError"));
                            }
                        }
                    },
                    {
                        key: "_setValueError",
                        value: function(e) {
                            this.valueError = {
                                message: e
                            }, this.updateError();
                        }
                    },
                    {
                        key: "_clearValueError",
                        value: function() {
                            this.valueError && (this.valueError = null, this.updateError());
                        }
                    },
                    {
                        key: "_setFieldError",
                        value: function(e) {
                            this.fieldError = {
                                message: e
                            }, this.updateError();
                        }
                    },
                    {
                        key: "_clearFieldError",
                        value: function() {
                            this.fieldError && (this.fieldError = null, this.updateError());
                        }
                    },
                    {
                        key: "_onChangeValue",
                        value: function() {
                            var e, t = this.editor.getDomSelection(), n = (t.range && (n = (0, k.textDiff)(String(this.value), String(this.previousValue)), t.range.startOffset = n.start, t.range.endOffset = n.end), this.editor.getDomSelection());
                            n.range && (e = (0, k.textDiff)(String(this.previousValue), String(this.value)), n.range.startOffset = e.start, n.range.endOffset = e.end), this.editor._onAction("editValue", {
                                path: this.getInternalPath(),
                                oldValue: this.previousValue,
                                newValue: this.value,
                                oldSelection: t,
                                newSelection: n
                            }), this.previousValue = this.value;
                        }
                    },
                    {
                        key: "_onChangeField",
                        value: function() {
                            var e = this.editor.getDomSelection(), t = this.previousField || "", n = (e.range && (n = (0, k.textDiff)(this.field, t), e.range.startOffset = n.start, e.range.endOffset = n.end), this.editor.getDomSelection());
                            n.range && (t = (0, k.textDiff)(t, this.field), n.range.startOffset = t.start, n.range.endOffset = t.end), this.editor._onAction("editField", {
                                parentPath: this.parent.getInternalPath(),
                                index: this.getIndex(),
                                oldValue: this.previousField,
                                newValue: this.field,
                                oldSelection: e,
                                newSelection: n
                            }), this.previousField = this.field;
                        }
                    },
                    {
                        key: "_updateDomValue",
                        value: function() {
                            var e = this.dom.value;
                            if (e) {
                                var t = [
                                    "jsoneditor-value"
                                ], n = this.value, i = "auto" === this.type ? (0, k.getType)(n) : this.type, o = "string" === i && (0, k.isUrl)(n);
                                if (t.push("jsoneditor-" + i), o && t.push("jsoneditor-url"), "" === String(this.value) && "array" !== this.type && "object" !== this.type && t.push("jsoneditor-empty"), this.searchValueActive && t.push("jsoneditor-highlight-active"), this.searchValue && t.push("jsoneditor-highlight"), e.className = t.join(" "), "array" === i || "object" === i ? (t = this.childs ? this.childs.length : 0, e.title = this.type + " containing " + t + " items") : o && this.editable.value ? e.title = (0, l.Iu)("openUrl") : e.title = "", "boolean" === i && this.editable.value ? (this.dom.checkbox || (this.dom.checkbox = document.createElement("input"), this.dom.checkbox.type = "checkbox", this.dom.tdCheckbox = document.createElement("td"), this.dom.tdCheckbox.className = "jsoneditor-tree", this.dom.tdCheckbox.appendChild(this.dom.checkbox), this.dom.tdValue.parentNode.insertBefore(this.dom.tdCheckbox, this.dom.tdValue)), this.dom.checkbox.checked = this.value) : this.dom.tdCheckbox && (this.dom.tdCheckbox.parentNode.removeChild(this.dom.tdCheckbox), delete this.dom.tdCheckbox, delete this.dom.checkbox), this.enum && this.editable.value ? (this.dom.select || (this.dom.select = document.createElement("select"), this.id = this.field + "_" + (new Date).getUTCMilliseconds(), this.dom.select.id = this.id, this.dom.select.name = this.dom.select.id, (t = document.createElement("option")).value = "", t.textContent = "--", this.dom.select.appendChild(t), this._updateEnumOptions(), this.dom.tdSelect = document.createElement("td"), this.dom.tdSelect.className = "jsoneditor-tree", this.dom.tdSelect.appendChild(this.dom.select), this.dom.tdValue.parentNode.insertBefore(this.dom.tdSelect, this.dom.tdValue)), this.dom.select.value = -1 !== this.enum.indexOf(this.value) ? this.value : "", !this.schema || v(this.schema, "oneOf") || v(this.schema, "anyOf") || v(this.schema, "allOf") ? delete this.valueFieldHTML : (this.valueFieldHTML = this.dom.tdValue.innerHTML, this.dom.tdValue.style.visibility = "hidden", this.dom.tdValue.textContent = "")) : this.dom.tdSelect && (this.dom.tdSelect.parentNode.removeChild(this.dom.tdSelect), delete this.dom.tdSelect, delete this.dom.select, this.dom.tdValue.innerHTML = this.valueFieldHTML, this.dom.tdValue.style.visibility = "", delete this.valueFieldHTML, this.dom.tdValue.appendChild(this.dom.value)), this.editor.options.colorPicker && "string" == typeof n && (0, k.isValidColor)(n) ? (this.dom.color || (this.dom.color = document.createElement("div"), this.dom.color.className = "jsoneditor-color", this.dom.tdColor = document.createElement("td"), this.dom.tdColor.className = "jsoneditor-tree", this.dom.tdColor.appendChild(this.dom.color), this.dom.tdValue.parentNode.insertBefore(this.dom.tdColor, this.dom.tdValue)), (0, k.addClassName)(this.dom.value, "jsoneditor-color-value"), (this.editable.value ? (0, k.removeClassName) : (0, k.addClassName))(this.dom.color, "jsoneditor-color-readonly"), this.dom.color.style.backgroundColor = n) : this._deleteDomColor(), this._showTimestampTag()) {
                                    this.dom.date || (this.dom.date = document.createElement("div"), this.dom.date.className = "jsoneditor-date", this.dom.value.parentNode.appendChild(this.dom.date));
                                    o = null;
                                    if (o = "function" == typeof this.editor.options.timestampFormat ? this.editor.options.timestampFormat({
                                        field: this.field,
                                        value: this.value,
                                        path: this.getPath()
                                    }) : o) {
                                        for(; this.dom.date.firstChild;)this.dom.date.removeChild(this.dom.date.firstChild);
                                        this.dom.date.appendChild(document.createTextNode(o));
                                    } else this.dom.date.textContent = new Date(n).toISOString();
                                    this.dom.date.title = new Date(n).toString();
                                } else this.dom.date && (this.dom.date.parentNode.removeChild(this.dom.date), delete this.dom.date);
                                (0, k.stripFormatting)(e), this._updateDomDefault();
                            }
                        }
                    },
                    {
                        key: "_updateEnumOptions",
                        value: function() {
                            if (this.enum && this.dom.select) {
                                this.dom.select.innerHTML = "";
                                for(var e = 0; e < this.enum.length; e++){
                                    var t = document.createElement("option");
                                    t.value = this.enum[e], t.textContent = this.enum[e], this.dom.select.appendChild(t);
                                }
                            }
                        }
                    },
                    {
                        key: "_deleteDomColor",
                        value: function() {
                            this.dom.color && (this.dom.tdColor.parentNode.removeChild(this.dom.tdColor), delete this.dom.tdColor, delete this.dom.color, (0, k.removeClassName)(this.dom.value, "jsoneditor-color-value"));
                        }
                    },
                    {
                        key: "_updateDomField",
                        value: function() {
                            var e, t = this.dom.field;
                            t && ((e = (0, k.makeFieldTooltip)(this.schema, this.editor.options.language)) && (t.title = e), ("" === String(this.field) && this.parent && "array" !== this.parent.type ? (0, k.addClassName) : (0, k.removeClassName))(t, "jsoneditor-empty"), (this.searchFieldActive ? (0, k.addClassName) : (0, k.removeClassName))(t, "jsoneditor-highlight-active"), (this.searchField ? (0, k.addClassName) : (0, k.removeClassName))(t, "jsoneditor-highlight"), (0, k.stripFormatting)(t));
                        }
                    },
                    {
                        key: "_getDomField",
                        value: function(e) {
                            if (this._clearFieldError(), this.dom.field && this.fieldEditable && (this.fieldInnerText = (0, k.getInnerText)(this.dom.field), "" === this.fieldInnerText) && "" !== this.dom.field.innerHTML && (this.dom.field.textContent = ""), void 0 !== this.fieldInnerText) try {
                                var t = this._unescapeHTML(this.fieldInnerText), n = this.parent.getFieldNames(this);
                                -1 !== n.indexOf(t) ? e ? (t = (0, k.findUniqueName)(t, n)) !== this.field && (this.field = t, this._debouncedOnChangeField()) : this._setFieldError((0, l.Iu)("duplicateFieldError")) : t !== this.field && (this.field = t, this._debouncedOnChangeField());
                            } catch (e) {
                                this._setFieldError((0, l.Iu)("cannotParseFieldError"));
                            }
                        }
                    },
                    {
                        key: "_updateDomDefault",
                        value: function() {
                            var e;
                            this.schema && void 0 !== this.schema.default && !this._hasChilds() && (e = this.dom.select || this.dom.value) && (this.value === this.schema.default ? (e.title = (0, l.Iu)("default"), (0, k.addClassName)(e, "jsoneditor-is-default"), k.removeClassName) : (e.removeAttribute("title"), (0, k.removeClassName)(e, "jsoneditor-is-default"), k.addClassName))(e, "jsoneditor-is-not-default");
                        }
                    },
                    {
                        key: "_showTimestampTag",
                        value: function() {
                            var e, t;
                            return "number" == typeof this.value && ("function" == typeof (e = this.editor.options.timestampTag) ? "boolean" == typeof (t = e({
                                field: this.field,
                                value: this.value,
                                path: this.getPath()
                            })) ? t : (0, k.isTimestamp)(this.field, this.value) : !0 === e && (0, k.isTimestamp)(this.field, this.value));
                        }
                    },
                    {
                        key: "clearDom",
                        value: function() {
                            this.dom = {};
                        }
                    },
                    {
                        key: "getDom",
                        value: function() {
                            var e, t, n = this.dom;
                            return n.tr || (this._updateEditability(), n.tr = document.createElement("tr"), "tree" === (n.tr.node = this).editor.options.mode && (t = document.createElement("td"), this.editable.field && this.parent && ((e = document.createElement("button")).type = "button", (n.drag = e).className = "jsoneditor-button jsoneditor-dragarea", e.title = (0, l.Iu)("drag"), t.appendChild(e)), n.tr.appendChild(t), e = document.createElement("td"), (t = document.createElement("button")).type = "button", (n.menu = t).className = "jsoneditor-button jsoneditor-contextmenu-button", t.title = (0, l.Iu)("actionsMenu"), e.appendChild(n.menu), n.tr.appendChild(e)), t = document.createElement("td"), n.tr.appendChild(t), n.tree = this._createDomTree(), t.appendChild(n.tree), this.updateDom({
                                updateIndexes: !0
                            })), n.tr;
                        }
                    },
                    {
                        key: "isVisible",
                        value: function() {
                            return this.dom && this.dom.tr && this.dom.tr.parentNode || !1;
                        }
                    },
                    {
                        key: "isDescendantOf",
                        value: function(e) {
                            for(var t = this.parent; t;){
                                if (t === e) return !0;
                                t = t.parent;
                            }
                            return !1;
                        }
                    },
                    {
                        key: "_createDomField",
                        value: function() {
                            return document.createElement("div");
                        }
                    },
                    {
                        key: "setHighlight",
                        value: function(t) {
                            this.dom.tr && ((t ? (0, k.addClassName) : (0, k.removeClassName))(this.dom.tr, "jsoneditor-highlight"), this.append && this.append.setHighlight(t), this.childs) && this.childs.forEach(function(e) {
                                e.setHighlight(t);
                            });
                        }
                    },
                    {
                        key: "setSelected",
                        value: function(t, e) {
                            this.selected = t, this.dom.tr && ((t ? (0, k.addClassName) : (0, k.removeClassName))(this.dom.tr, "jsoneditor-selected"), (e ? (0, k.addClassName) : (0, k.removeClassName))(this.dom.tr, "jsoneditor-first"), this.append && this.append.setSelected(t), this.showMore && this.showMore.setSelected(t), this.childs) && this.childs.forEach(function(e) {
                                e.setSelected(t);
                            });
                        }
                    },
                    {
                        key: "updateValue",
                        value: function(e) {
                            this.value = e, this.previousValue = e, this.valueError = void 0, this.updateDom();
                        }
                    },
                    {
                        key: "updateField",
                        value: function(e) {
                            this.field = e, this.previousField = e, this.fieldError = void 0, this.updateDom();
                        }
                    },
                    {
                        key: "updateDom",
                        value: function(t) {
                            var e, n = this.dom.tree, n = (n && (n.style.marginLeft = 24 * this.getLevel() + "px"), this.dom.field), n = (n && (this.fieldEditable ? (n.contentEditable = this.editable.field, n.spellcheck = !1, n.className = "jsoneditor-field") : (n.contentEditable = !1, n.className = "jsoneditor-readonly"), e = void 0 !== this.index ? this.index : void 0 !== this.field ? this.field : (e = this.editor.options.schema ? x._findSchema(this.editor.options.schema, this.editor.options.schemaRefs || {}, this.getPath()) : void 0) && e.title ? e.title : this._hasChilds() ? this.type : "", e = this._escapeHTML(e), document.activeElement !== n && e !== this._unescapeHTML((0, k.getInnerText)(n)) && (n.innerHTML = e), this._updateSchema(), this._updateEnumOptions()), this.dom.value), n = (n && ("array" === this.type || "object" === this.type ? this.updateNodeName() : (e = this._escapeHTML(this.value), document.activeElement !== n && e !== this._unescapeHTML((0, k.getInnerText)(n)) && (n.innerHTML = e))), this.dom.tr);
                            n && ("array" === this.type || "object" === this.type ? ((0, k.addClassName)(n, "jsoneditor-expandable"), this.expanded ? ((0, k.addClassName)(n, "jsoneditor-expanded"), (0, k.removeClassName)(n, "jsoneditor-collapsed")) : ((0, k.addClassName)(n, "jsoneditor-collapsed"), (0, k.removeClassName)(n, "jsoneditor-expanded"))) : ((0, k.removeClassName)(n, "jsoneditor-expandable"), (0, k.removeClassName)(n, "jsoneditor-expanded"), (0, k.removeClassName)(n, "jsoneditor-collapsed"))), this._updateDomField(), this._updateDomValue(), t && !0 === t.updateIndexes && this._updateDomIndexes(), t && !0 === t.recurse && this.childs && this.childs.forEach(function(e) {
                                e.updateDom(t);
                            }), this.error && this.updateError(), this.append && this.append.updateDom(), this.showMore && this.showMore.updateDom(), this._updateCssClassName();
                        }
                    },
                    {
                        key: "_updateSchema",
                        value: function() {
                            this.editor && this.editor.options && (this.schema = this.editor.options.schema ? x._findSchema(this.editor.options.schema, this.editor.options.schemaRefs || {}, this.getPath()) : null, this.schema ? this.enum = x._findEnum(this.schema) : delete this.enum);
                        }
                    },
                    {
                        key: "_updateDomIndexes",
                        value: function() {
                            var e = this.dom.value, t = this.childs;
                            e && t && ("array" === this.type ? t.forEach(function(e, t) {
                                e.index = t;
                                e = e.dom.field;
                                e && (e.textContent = t);
                            }) : "object" === this.type && t.forEach(function(e) {
                                void 0 !== e.index && (delete e.index, void 0 === e.field) && (e.field = "");
                            }));
                        }
                    },
                    {
                        key: "_createDomValue",
                        value: function() {
                            var e;
                            return "array" === this.type ? (e = document.createElement("div")).textContent = "[...]" : "object" === this.type ? (e = document.createElement("div")).textContent = "{...}" : (!this.editable.value && (0, k.isUrl)(this.value) ? (e = document.createElement("a")).href = this.value : ((e = document.createElement("div")).contentEditable = this.editable.value, e.spellcheck = !1), e.innerHTML = this._escapeHTML(this.value)), e;
                        }
                    },
                    {
                        key: "_createDomExpandButton",
                        value: function() {
                            var e = document.createElement("button");
                            return e.type = "button", this._hasChilds() ? (e.className = this.expanded ? "jsoneditor-button jsoneditor-expanded" : "jsoneditor-button jsoneditor-collapsed", e.title = (0, l.Iu)("expandTitle")) : (e.className = "jsoneditor-button jsoneditor-invisible", e.title = ""), e;
                        }
                    },
                    {
                        key: "_createDomTree",
                        value: function() {
                            var e = this.dom, t = document.createElement("table"), n = document.createElement("tbody"), i = (t.style.borderCollapse = "collapse", t.className = "jsoneditor-values", t.appendChild(n), document.createElement("tr")), n = (n.appendChild(i), document.createElement("td")), n = (n.className = "jsoneditor-tree", i.appendChild(n), e.expand = this._createDomExpandButton(), n.appendChild(e.expand), e.tdExpand = n, document.createElement("td")), n = (n.className = "jsoneditor-tree", i.appendChild(n), e.field = this._createDomField(), n.appendChild(e.field), e.tdField = n, document.createElement("td")), n = (n.className = "jsoneditor-tree", i.appendChild(n), "object" !== this.type && "array" !== this.type && (n.appendChild(document.createTextNode(":")), n.className = "jsoneditor-separator"), e.tdSeparator = n, document.createElement("td"));
                            return n.className = "jsoneditor-tree", i.appendChild(n), e.value = this._createDomValue(), n.appendChild(e.value), e.tdValue = n, t;
                        }
                    },
                    {
                        key: "onEvent",
                        value: function(e) {
                            var t, n = e.type, i = e.target || e.srcElement, o = this.dom, r = this, s = this._hasChilds(), a = (i !== o.drag && i !== o.menu || ("mouseover" === n ? this.editor.highlighter.highlight(this) : "mouseout" === n && this.editor.highlighter.unhighlight()), "click" === n && i === o.menu && ((t = r.editor.highlighter).highlight(r), t.lock(), (0, k.addClassName)(o.menu, "jsoneditor-selected"), this.showContextMenu(o.menu, function() {
                                (0, k.removeClassName)(o.menu, "jsoneditor-selected"), t.unlock(), t.unhighlight();
                            })), "click" === n && i === o.expand && s && (d = e.ctrlKey, this._onExpand(d)), "click" !== n || e.target !== r.dom.tdColor && e.target !== r.dom.color || !this.editable.value || this._showColorPicker(), "change" === n && i === o.checkbox && (this.dom.value.textContent = String(!this.value), this._getDomValue(), this._updateDomDefault()), "change" === n && i === o.select && (this.dom.value.innerHTML = this._escapeHTML(o.select.value), this._getDomValue(), this._updateDomValue()), o.value);
                            if (i === a) switch(n){
                                case "blur":
                                case "change":
                                    this._getDomValue(), this._clearValueError(), this._updateDomValue();
                                    var l = this._escapeHTML(this.value);
                                    l !== this._unescapeHTML((0, k.getInnerText)(a)) && (a.innerHTML = l);
                                    break;
                                case "input":
                                    this._getDomValue(), this._updateDomValue();
                                    break;
                                case "keydown":
                                case "mousedown":
                                    this.editor.selection = this.editor.getDomSelection();
                                    break;
                                case "click":
                                    e.ctrlKey && this.editable.value && (0, k.isUrl)(this.value) && (e.preventDefault(), window.open(this.value, "_blank", "noreferrer"));
                                    break;
                                case "keyup":
                                    this._getDomValue(), this._updateDomValue();
                                    break;
                                case "cut":
                                case "paste":
                                    setTimeout(function() {
                                        r._getDomValue(), r._updateDomValue();
                                    }, 1);
                            }
                            var c = o.field;
                            if (i === c) switch(n){
                                case "blur":
                                    this._getDomField(!0), this._updateDomField();
                                    var h = this._escapeHTML(this.field);
                                    h !== this._unescapeHTML((0, k.getInnerText)(c)) && (c.innerHTML = h);
                                    break;
                                case "input":
                                    this._getDomField(), this._updateSchema(), this._updateDomField(), this._updateDomValue();
                                    break;
                                case "keydown":
                                case "mousedown":
                                    this.editor.selection = this.editor.getDomSelection();
                                    break;
                                case "keyup":
                                    this._getDomField(), this._updateDomField();
                                    break;
                                case "cut":
                                case "paste":
                                    setTimeout(function() {
                                        r._getDomField(), r._updateDomField();
                                    }, 1);
                            }
                            var d = o.tree;
                            d && i === d.parentNode && "click" === n && !e.hasMoved && ((void 0 !== e.offsetX ? e.offsetX < 24 * (this.getLevel() + 1) : e.pageX < (0, k.getAbsoluteLeft)(o.tdSeparator)) || s ? c && ((0, k.setEndOfContentEditable)(c), c.focus()) : a && !this.enum && ((0, k.setEndOfContentEditable)(a), a.focus())), (i !== o.tdExpand || s) && i !== o.tdField && i !== o.tdSeparator || "click" !== n || e.hasMoved || c && ((0, k.setEndOfContentEditable)(c), c.focus()), "keydown" === n && this.onKeyDown(e), "function" == typeof this.editor.options.onEvent && this._onEvent(e);
                        }
                    },
                    {
                        key: "_onEvent",
                        value: function(e) {
                            var t = e.target, n = t === this.dom.field, t = t === this.dom.value || t === this.dom.checkbox || t === this.dom.select;
                            (n || t) && (n = {
                                field: this.getField(),
                                path: this.getPath()
                            }, t && !this._hasChilds() && (n.value = this.getValue()), this.editor.options.onEvent(n, e));
                        }
                    },
                    {
                        key: "onKeyDown",
                        value: function(e) {
                            var t, n, i, o, r, s, a, l, c, h, d, u, g, p, m = e.which || e.keyCode, f = e.target || e.srcElement, C = e.ctrlKey, y = e.shiftKey, v = e.altKey, I = !1, b = "tree" === this.editor.options.mode, A = 0 < this.editor.multiselection.nodes.length ? this.editor.multiselection.nodes : [
                                this
                            ], w = A[0], S = A[A.length - 1];
                            13 === m ? f === this.dom.value ? this.editable.value && !e.ctrlKey || (0, k.isUrl)(this.value) && (window.open(this.value, "_blank", "noreferrer"), I = !0) : f === this.dom.expand && this._hasChilds() && (g = e.ctrlKey, this._onExpand(g), f.focus(), I = !0) : 68 === m ? C && b && (x.onDuplicate(A), I = !0) : 69 === m ? C && (this._onExpand(y), f.focus(), I = !0) : 77 === m && b ? C && (this.showContextMenu(f), I = !0) : 46 === m && b ? C && (x.onRemove(A), I = !0) : 45 === m && b ? C && !y ? (this._onInsertBefore(), I = !0) : C && y && (this._onInsertAfter(), I = !0) : 35 === m ? v && ((g = this._lastNode()) && g.focus(x.focusElement || this._getElementName(f)), I = !0) : 36 === m ? v && ((g = this._firstNode()) && g.focus(x.focusElement || this._getElementName(f)), I = !0) : 37 === m ? v && !y ? ((g = this._previousElement(f)) && this.focus(this._getElementName(g)), I = !0) : v && y && b && (g = S.expanded ? (g = S.getAppendDom()) ? g.nextSibling : void 0 : S.getDom().nextSibling) && (d = x.getNodeFromTarget(g), g = g.nextSibling, u = x.getNodeFromTarget(g), d) && d instanceof _ && 1 !== S.parent.childs.length && u && u.parent && (n = this.editor.getDomSelection(), i = (o = w.parent).childs[S.getIndex() + 1] || o.append, r = w.getIndex(), s = u.getIndex(), a = o.getInternalPath(), l = u.parent.getInternalPath(), A.forEach(function(e) {
                                u.parent.moveBefore(e, u);
                            }), this.focus(x.focusElement || this._getElementName(f)), this.editor._onAction("moveNodes", {
                                count: A.length,
                                fieldNames: A.map(R),
                                oldParentPath: o.getInternalPath(),
                                newParentPath: w.parent.getInternalPath(),
                                oldIndex: i.getIndex(),
                                newIndex: w.getIndex(),
                                oldIndexRedo: r,
                                newIndexRedo: s,
                                oldParentPathRedo: a,
                                newParentPathRedo: l,
                                oldSelection: n,
                                newSelection: this.editor.getDomSelection()
                            })) : 38 === m ? v && !y ? ((t = this._previousNode()) && (this.editor.deselect(!0), t.focus(x.focusElement || this._getElementName(f))), I = !0) : !v && C && y && b ? ((t = this._previousNode()) && ((h = this.editor.multiselection).start = h.start || this, h.end = t, c = this.editor._findTopLevelNodes(h.start, h.end), this.editor.select(c), t.focus("field")), I = !0) : v && y && b && ((t = w._previousNode()) && t.parent && (n = this.editor.getDomSelection(), i = (o = w.parent).childs[S.getIndex() + 1] || o.append, r = w.getIndex(), s = t.getIndex(), a = o.getInternalPath(), l = t.parent.getInternalPath(), A.forEach(function(e) {
                                t.parent.moveBefore(e, t);
                            }), this.focus(x.focusElement || this._getElementName(f)), this.editor._onAction("moveNodes", {
                                count: A.length,
                                fieldNames: A.map(R),
                                oldParentPath: o.getInternalPath(),
                                newParentPath: w.parent.getInternalPath(),
                                oldIndex: i.getIndex(),
                                newIndex: w.getIndex(),
                                oldIndexRedo: r,
                                newIndexRedo: s,
                                oldParentPathRedo: a,
                                newParentPathRedo: l,
                                oldSelection: n,
                                newSelection: this.editor.getDomSelection()
                            })), I = !0) : 39 === m ? v && !y ? ((g = this._nextElement(f)) && this.focus(this._getElementName(g)), I = !0) : v && y && b && (g = w.getDom().previousSibling) && (t = x.getNodeFromTarget(g)) && t.parent && !t.isVisible() && (n = this.editor.getDomSelection(), i = (o = w.parent).childs[S.getIndex() + 1] || o.append, r = w.getIndex(), s = t.getIndex(), a = o.getInternalPath(), l = t.parent.getInternalPath(), A.forEach(function(e) {
                                t.parent.moveBefore(e, t);
                            }), this.focus(x.focusElement || this._getElementName(f)), this.editor._onAction("moveNodes", {
                                count: A.length,
                                fieldNames: A.map(R),
                                oldParentPath: o.getInternalPath(),
                                newParentPath: w.parent.getInternalPath(),
                                oldIndex: i.getIndex(),
                                newIndex: w.getIndex(),
                                oldIndexRedo: r,
                                newIndexRedo: s,
                                oldParentPathRedo: a,
                                newParentPathRedo: l,
                                oldSelection: n,
                                newSelection: this.editor.getDomSelection()
                            })) : 40 === m && (v && !y ? ((d = this._nextNode()) && (this.editor.deselect(!0), d.focus(x.focusElement || this._getElementName(f))), I = !0) : !v && C && y && b ? ((d = this._nextNode()) && ((h = this.editor.multiselection).start = h.start || this, h.end = d, c = this.editor._findTopLevelNodes(h.start, h.end), this.editor.select(c), d.focus("field")), I = !0) : v && y && b && ((p = (d = (d = (d = S.expanded ? S.append ? S.append._nextNode() : void 0 : S._nextNode()) && !d.isVisible() ? d.parent.showMore : d) && d instanceof _ ? S : d) && (d._nextNode() || d.parent.append)) && p.parent && (n = this.editor.getDomSelection(), i = (o = w.parent).childs[S.getIndex() + 1] || o.append, r = w.getIndex(), s = p.getIndex(), a = o.getInternalPath(), l = p.parent.getInternalPath(), A.forEach(function(e) {
                                p.parent.moveBefore(e, p);
                            }), this.focus(x.focusElement || this._getElementName(f)), this.editor._onAction("moveNodes", {
                                count: A.length,
                                fieldNames: A.map(R),
                                oldParentPath: o.getInternalPath(),
                                newParentPath: w.parent.getInternalPath(),
                                oldParentPathRedo: a,
                                newParentPathRedo: l,
                                oldIndexRedo: r,
                                newIndexRedo: s,
                                oldIndex: i.getIndex(),
                                newIndex: w.getIndex(),
                                oldSelection: n,
                                newSelection: this.editor.getDomSelection()
                            })), I = !0)), I && (e.preventDefault(), e.stopPropagation());
                        }
                    },
                    {
                        key: "_onExpand",
                        value: function(e) {
                            var t, n, i;
                            e && (i = (n = (t = this.dom.tr.parentNode).parentNode).scrollTop, n.removeChild(t)), this.expanded ? this.collapse(e) : this.expand(e), e && (n.appendChild(t), n.scrollTop = i), "function" == typeof this.editor.options.onExpand && this.editor.options.onExpand({
                                path: this.getPath(),
                                isExpand: this.expanded,
                                recursive: e
                            });
                        }
                    },
                    {
                        key: "_showColorPicker",
                        value: function() {
                            var t, e;
                            "function" == typeof this.editor.options.onColorPicker && this.dom.color && ((t = this)._deleteDomColor(), t.updateDom(), e = (0, d.w)(this.dom.color, this.editor.getPopupAnchor()), this.editor.options.onColorPicker(e, this.value, function(e) {
                                "string" == typeof e && e !== t.value && (t._deleteDomColor(), t.value = e, t.updateDom(), t._debouncedOnChangeValue());
                            }));
                        }
                    },
                    {
                        key: "getFieldNames",
                        value: function(t) {
                            return "object" === this.type ? this.childs.filter(function(e) {
                                return e !== t;
                            }).map(function(e) {
                                return e.field;
                            }) : [];
                        }
                    },
                    {
                        key: "_onInsertBefore",
                        value: function(e, t, n) {
                            var i = this.editor.getDomSelection(), e = new x(this.editor, {
                                field: void 0 !== e ? e : "",
                                value: void 0 !== t ? t : "",
                                type: n
                            }), t = (e.expand(!0), this.getInternalPath()), n = (this.parent.insertBefore(e, this), this.editor.highlighter.unhighlight(), e.focus("field"), this.editor.getDomSelection());
                            this.editor._onAction("insertBeforeNodes", {
                                nodes: [
                                    e
                                ],
                                paths: [
                                    e.getInternalPath()
                                ],
                                beforePath: t,
                                parentPath: this.parent.getInternalPath(),
                                oldSelection: i,
                                newSelection: n
                            });
                        }
                    },
                    {
                        key: "_onInsertAfter",
                        value: function(e, t, n) {
                            var i = this.editor.getDomSelection(), e = new x(this.editor, {
                                field: void 0 !== e ? e : "",
                                value: void 0 !== t ? t : "",
                                type: n
                            }), t = (e.expand(!0), this.parent.insertAfter(e, this), this.editor.highlighter.unhighlight(), e.focus("field"), this.editor.getDomSelection());
                            this.editor._onAction("insertAfterNodes", {
                                nodes: [
                                    e
                                ],
                                paths: [
                                    e.getInternalPath()
                                ],
                                afterPath: this.getInternalPath(),
                                parentPath: this.parent.getInternalPath(),
                                oldSelection: i,
                                newSelection: t
                            });
                        }
                    },
                    {
                        key: "_onAppend",
                        value: function(e, t, n) {
                            var i = this.editor.getDomSelection(), e = new x(this.editor, {
                                field: void 0 !== e ? e : "",
                                value: void 0 !== t ? t : "",
                                type: n
                            }), t = (e.expand(!0), this.parent.appendChild(e), this.editor.highlighter.unhighlight(), e.focus("field"), this.editor.getDomSelection());
                            this.editor._onAction("appendNodes", {
                                nodes: [
                                    e
                                ],
                                paths: [
                                    e.getInternalPath()
                                ],
                                parentPath: this.parent.getInternalPath(),
                                oldSelection: i,
                                newSelection: t
                            });
                        }
                    },
                    {
                        key: "_onChangeType",
                        value: function(e) {
                            var t, n, i = this.type;
                            e !== i && (t = this.editor.getDomSelection(), this.changeType(e), n = this.editor.getDomSelection(), this.editor._onAction("changeType", {
                                path: this.getInternalPath(),
                                oldType: i,
                                newType: e,
                                oldSelection: t,
                                newSelection: n
                            }));
                        }
                    },
                    {
                        key: "sort",
                        value: function(n, e) {
                            var t, i, o = !(2 < arguments.length && void 0 !== arguments[2]) || arguments[2];
                            "string" == typeof n && (n = (0, k.parsePath)(n)), this._hasChilds() && (this.hideChilds(), t = this.childs, this.childs = this.childs.concat(), i = "desc" === e ? -1 : 1, "object" === this.type ? this.childs.sort(function(e, t) {
                                return i * h()(e.field, t.field);
                            }) : this.childs.sort(function(e, t) {
                                var e = e.getNestedChild(n), t = t.getNestedChild(n);
                                return e ? t ? (e = e.value, t = t.value, "string" != typeof e && "string" != typeof t ? t < e ? i : e < t ? -i : 0 : i * h()(e, t)) : -i : i;
                            }), this._updateDomIndexes(), this.showChilds(), !0 === o) && this.editor._onAction("sort", {
                                path: this.getInternalPath(),
                                oldChilds: t,
                                newChilds: this.childs
                            });
                        }
                    },
                    {
                        key: "update",
                        value: function(e) {
                            var t = this.getInternalValue();
                            this.setValue(e), this.editor._onAction("transform", {
                                path: this.getInternalPath(),
                                oldValue: t,
                                newValue: this.getInternalValue()
                            });
                        }
                    },
                    {
                        key: "_detachFromDom",
                        value: function() {
                            var e = this.dom.tr ? this.dom.tr.parentNode : void 0, t = this.expanded ? this.getAppendDom() : this.getDom(), t = t && t.parentNode ? t.nextSibling : void 0;
                            return this.hide({
                                resetVisibleChilds: !1
                            }), {
                                table: e,
                                nextTr: t
                            };
                        }
                    },
                    {
                        key: "_attachToDom",
                        value: function(e) {
                            e.table && (e.nextTr ? e.table.insertBefore(this.getDom(), e.nextTr) : e.table.appendChild(this.getDom())), this.expanded && this.showChilds();
                        }
                    },
                    {
                        key: "transform",
                        value: function(e) {
                            if (this._hasChilds()) {
                                this.hideChilds();
                                try {
                                    var t = this.getInternalValue(), n = this.getValue(), i = this.editor.options.executeQuery(n, e), o = (this.setValue(i), this.getInternalValue());
                                    this.editor._onAction("transform", {
                                        path: this.getInternalPath(),
                                        oldValue: t,
                                        newValue: o
                                    }), this.showChilds();
                                } catch (e) {
                                    this.showChilds(), this.editor._onError(e);
                                }
                            }
                        }
                    },
                    {
                        key: "extract",
                        value: function() {
                            this.editor.node.hideChilds(), this.hideChilds();
                            try {
                                var e = this.editor.node.getInternalValue(), t = (this.editor._setRoot(this), this.editor.node.getInternalValue());
                                this.editor._onAction("transform", {
                                    path: this.editor.node.getInternalPath(),
                                    oldValue: e,
                                    newValue: t
                                });
                            } catch (e) {
                                this.editor._onError(e);
                            } finally{
                                this.updateDom({
                                    recurse: !0
                                }), this.showChilds();
                            }
                        }
                    },
                    {
                        key: "getNestedChild",
                        value: function(e) {
                            for(var t = 0, n = this; n && t < e.length;)n = n.findChildByProperty(e[t]), t++;
                            return n;
                        }
                    },
                    {
                        key: "findChildByProperty",
                        value: function(t) {
                            if ("object" === this.type) return this.childs.find(function(e) {
                                return e.field === t;
                            });
                        }
                    },
                    {
                        key: "getAppendDom",
                        value: function() {
                            return this.append || (this.append = new _(this.editor), this.append.setParent(this)), this.append.getDom();
                        }
                    },
                    {
                        key: "getShowMoreDom",
                        value: function() {
                            return this.showMore || (this.showMore = new F(this.editor, this)), this.showMore.getDom();
                        }
                    },
                    {
                        key: "nextSibling",
                        value: function() {
                            var e = this.parent.childs.indexOf(this);
                            return this.parent.childs[e + 1] || this.parent.append;
                        }
                    },
                    {
                        key: "_previousNode",
                        value: function() {
                            var e = null, t = this.getDom();
                            if (t && t.parentNode) for(var n = t; n = n.previousSibling, e = x.getNodeFromTarget(n), n && e && e instanceof _ && !e.isVisible(););
                            return e;
                        }
                    },
                    {
                        key: "_nextNode",
                        value: function() {
                            var e = null, t = this.getDom();
                            if (t && t.parentNode) for(var n = t; n = n.nextSibling, e = x.getNodeFromTarget(n), n && e && e instanceof _ && !e.isVisible(););
                            return e;
                        }
                    },
                    {
                        key: "_firstNode",
                        value: function() {
                            var e = null, t = this.getDom();
                            return t && t.parentNode && (t = t.parentNode.firstChild, e = x.getNodeFromTarget(t)), e;
                        }
                    },
                    {
                        key: "_lastNode",
                        value: function() {
                            var e = null, t = this.getDom();
                            if (t && t.parentNode) for(var n = t.parentNode.lastChild, e = x.getNodeFromTarget(n); n && e && !e.isVisible();)n = n.previousSibling, e = x.getNodeFromTarget(n);
                            return e;
                        }
                    },
                    {
                        key: "_previousElement",
                        value: function(e) {
                            var t = this.dom;
                            switch(e){
                                case t.value:
                                    if (this.fieldEditable) return t.field;
                                case t.field:
                                    if (this._hasChilds()) return t.expand;
                                case t.expand:
                                    return t.menu;
                                case t.menu:
                                    if (t.drag) return t.drag;
                                default:
                                    return null;
                            }
                        }
                    },
                    {
                        key: "_nextElement",
                        value: function(e) {
                            var t = this.dom;
                            switch(e){
                                case t.drag:
                                    return t.menu;
                                case t.menu:
                                    if (this._hasChilds()) return t.expand;
                                case t.expand:
                                    if (this.fieldEditable) return t.field;
                                case t.field:
                                    if (!this._hasChilds()) return t.value;
                                default:
                                    return null;
                            }
                        }
                    },
                    {
                        key: "_getElementName",
                        value: function(t) {
                            var n = this;
                            return Object.keys(this.dom).find(function(e) {
                                return n.dom[e] === t;
                            });
                        }
                    },
                    {
                        key: "_hasChilds",
                        value: function() {
                            return "array" === this.type || "object" === this.type;
                        }
                    },
                    {
                        key: "addTemplates",
                        value: function(t, n) {
                            var i = this, e = i.editor.options.templates;
                            null != e && (e.length && t.push({
                                type: "separator"
                            }), e.forEach(function(e) {
                                t.push({
                                    text: e.text,
                                    className: e.className || "jsoneditor-type-object",
                                    title: e.title,
                                    click: (n ? function(e, t) {
                                        i._onAppend(e, t);
                                    } : function(e, t) {
                                        i._onInsertBefore(e, t);
                                    }).bind(this, e.field, e.value)
                                });
                            }));
                        }
                    },
                    {
                        key: "showContextMenu",
                        value: function(e, t) {
                            var n, i = this, o = [];
                            this.editable.value && o.push({
                                text: (0, l.Iu)("type"),
                                title: (0, l.Iu)("typeTitle"),
                                className: "jsoneditor-type-" + this.type,
                                submenu: [
                                    {
                                        text: (0, l.Iu)("auto"),
                                        className: "jsoneditor-type-auto" + ("auto" === this.type ? " jsoneditor-selected" : ""),
                                        title: (0, l.Iu)("autoType"),
                                        click: function() {
                                            i._onChangeType("auto");
                                        }
                                    },
                                    {
                                        text: (0, l.Iu)("array"),
                                        className: "jsoneditor-type-array" + ("array" === this.type ? " jsoneditor-selected" : ""),
                                        title: (0, l.Iu)("arrayType"),
                                        click: function() {
                                            i._onChangeType("array");
                                        }
                                    },
                                    {
                                        text: (0, l.Iu)("object"),
                                        className: "jsoneditor-type-object" + ("object" === this.type ? " jsoneditor-selected" : ""),
                                        title: (0, l.Iu)("objectType"),
                                        click: function() {
                                            i._onChangeType("object");
                                        }
                                    },
                                    {
                                        text: (0, l.Iu)("string"),
                                        className: "jsoneditor-type-string" + ("string" === this.type ? " jsoneditor-selected" : ""),
                                        title: (0, l.Iu)("stringType"),
                                        click: function() {
                                            i._onChangeType("string");
                                        }
                                    }
                                ]
                            }), this._hasChilds() && (this.editor.options.enableSort && o.push({
                                text: (0, l.Iu)("sort"),
                                title: (0, l.Iu)("sortTitle", {
                                    type: this.type
                                }),
                                className: "jsoneditor-sort-asc",
                                click: function() {
                                    i.showSortModal();
                                }
                            }), this.editor.options.enableTransform && o.push({
                                text: (0, l.Iu)("transform"),
                                title: (0, l.Iu)("transformTitle", {
                                    type: this.type
                                }),
                                className: "jsoneditor-transform",
                                click: function() {
                                    i.showTransformModal();
                                }
                            }), this.parent) && o.push({
                                text: (0, l.Iu)("extract"),
                                title: (0, l.Iu)("extractTitle", {
                                    type: this.type
                                }),
                                className: "jsoneditor-extract",
                                click: function() {
                                    i.extract();
                                }
                            }), this.parent && this.parent._hasChilds() && (o.length && o.push({
                                type: "separator"
                            }), n = i.parent.childs, i === n[n.length - 1] && (n = [
                                {
                                    text: (0, l.Iu)("auto"),
                                    className: "jsoneditor-type-auto",
                                    title: (0, l.Iu)("autoType"),
                                    click: function() {
                                        i._onAppend("", "", "auto");
                                    }
                                },
                                {
                                    text: (0, l.Iu)("array"),
                                    className: "jsoneditor-type-array",
                                    title: (0, l.Iu)("arrayType"),
                                    click: function() {
                                        i._onAppend("", []);
                                    }
                                },
                                {
                                    text: (0, l.Iu)("object"),
                                    className: "jsoneditor-type-object",
                                    title: (0, l.Iu)("objectType"),
                                    click: function() {
                                        i._onAppend("", {});
                                    }
                                },
                                {
                                    text: (0, l.Iu)("string"),
                                    className: "jsoneditor-type-string",
                                    title: (0, l.Iu)("stringType"),
                                    click: function() {
                                        i._onAppend("", "", "string");
                                    }
                                }
                            ], i.addTemplates(n, !0), o.push({
                                text: (0, l.Iu)("appendText"),
                                title: (0, l.Iu)("appendTitle"),
                                submenuTitle: (0, l.Iu)("appendSubmenuTitle"),
                                className: "jsoneditor-append",
                                click: function() {
                                    i._onAppend("", "", "auto");
                                },
                                submenu: n
                            })), n = [
                                {
                                    text: (0, l.Iu)("auto"),
                                    className: "jsoneditor-type-auto",
                                    title: (0, l.Iu)("autoType"),
                                    click: function() {
                                        i._onInsertBefore("", "", "auto");
                                    }
                                },
                                {
                                    text: (0, l.Iu)("array"),
                                    className: "jsoneditor-type-array",
                                    title: (0, l.Iu)("arrayType"),
                                    click: function() {
                                        i._onInsertBefore("", []);
                                    }
                                },
                                {
                                    text: (0, l.Iu)("object"),
                                    className: "jsoneditor-type-object",
                                    title: (0, l.Iu)("objectType"),
                                    click: function() {
                                        i._onInsertBefore("", {});
                                    }
                                },
                                {
                                    text: (0, l.Iu)("string"),
                                    className: "jsoneditor-type-string",
                                    title: (0, l.Iu)("stringType"),
                                    click: function() {
                                        i._onInsertBefore("", "", "string");
                                    }
                                }
                            ], i.addTemplates(n, !1), o.push({
                                text: (0, l.Iu)("insert"),
                                title: (0, l.Iu)("insertTitle"),
                                submenuTitle: (0, l.Iu)("insertSub"),
                                className: "jsoneditor-insert",
                                click: function() {
                                    i._onInsertBefore("", "", "auto");
                                },
                                submenu: n
                            }), this.editable.field) && (o.push({
                                text: (0, l.Iu)("duplicateText"),
                                title: (0, l.Iu)("duplicateField"),
                                className: "jsoneditor-duplicate",
                                click: function() {
                                    x.onDuplicate(i);
                                }
                            }), o.push({
                                text: (0, l.Iu)("removeText"),
                                title: (0, l.Iu)("removeField"),
                                className: "jsoneditor-remove",
                                click: function() {
                                    x.onRemove(i);
                                }
                            })), this.editor.options.onCreateMenu && (n = i.getPath(), o = this.editor.options.onCreateMenu(o, {
                                type: "single",
                                path: n,
                                paths: [
                                    n
                                ]
                            })), new s.x(o, {
                                close: t
                            }).show(e, this.editor.getPopupAnchor());
                        }
                    },
                    {
                        key: "showSortModal",
                        value: function() {
                            var n = this, e = this.editor.options.modalAnchor || p.qD, t = this.getValue();
                            (0, u.showSortModal)(e, t, function(e) {
                                var t = e.path, t = (0, k.parsePath)(t);
                                n.sortedBy = e, n.sort(t, e.direction);
                            }, n.sortedBy);
                        }
                    },
                    {
                        key: "showTransformModal",
                        value: function() {
                            var t = this, e = this.editor.options, n = e.modalAnchor, i = e.createQuery, o = e.executeQuery, e = e.queryDescription, r = this.getValue();
                            (0, g.showTransformModal)({
                                container: n || p.qD,
                                json: r,
                                queryDescription: e,
                                createQuery: i,
                                executeQuery: o,
                                onTransform: function(e) {
                                    t.transform(e);
                                }
                            });
                        }
                    },
                    {
                        key: "_getType",
                        value: function(e) {
                            return e instanceof Array ? "array" : e instanceof Object ? "object" : "string" == typeof e && "string" != typeof (0, k.parseString)(e) ? "string" : "auto";
                        }
                    },
                    {
                        key: "_escapeHTML",
                        value: function(e) {
                            return "string" != typeof e ? String(e) : (e = String(e).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/ {2}/g, " &nbsp;").replace(/^ /, "&nbsp;").replace(/ $/, "&nbsp;"), e = (e = JSON.stringify(e)).substring(1, e.length - 1), !0 === this.editor.options.escapeUnicode ? (0, k.escapeUnicodeChars)(e) : e);
                        }
                    },
                    {
                        key: "_unescapeHTML",
                        value: function(e) {
                            e = '"' + this._escapeJSON(e) + '"';
                            return (0, k.parse)(e).replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&nbsp;|\u00A0/g, " ").replace(/&amp;/g, "&");
                        }
                    },
                    {
                        key: "_escapeJSON",
                        value: function(e) {
                            for(var t = "", n = 0; n < e.length;){
                                var i = e.charAt(n);
                                "\n" === i ? t += "\\n" : "\\" === i ? (t += i, n++, "" !== (i = e.charAt(n)) && -1 !== '"\\/bfnrtu'.indexOf(i) || (t += "\\"), t += i) : t += '"' === i ? '\\"' : i, n++;
                            }
                            return t;
                        }
                    },
                    {
                        key: "updateNodeName",
                        value: function() {
                            var e = this.childs ? this.childs.length : 0;
                            if ("object" === this.type || "array" === this.type) {
                                if (this.editor.options.onNodeName) try {
                                    var t = this.getValue.bind(this), n = this.editor.options.onNodeName({
                                        path: this.getPath(),
                                        size: e,
                                        type: this.type,
                                        get value () {
                                            return t();
                                        }
                                    });
                                } catch (e) {
                                    console.error("Error in onNodeName callback: ", e);
                                }
                                this.dom.value.textContent = "object" === this.type ? "{" + (n || e) + "}" : "[" + (n || e) + "]";
                            }
                        }
                    },
                    {
                        key: "recursivelyUpdateNodeName",
                        value: function() {
                            if (this.expanded && (this.updateNodeName(), "undefined" !== this.childs)) for(var e in this.childs)this.childs[e].recursivelyUpdateNodeName();
                        }
                    }
                ], C(e.prototype, t), n && C(e, n), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), x;
            }(), P = (T.prototype.DEBOUNCE_INTERVAL = 150, T.prototype.MAX_SEARCH_RESULTS = 999, 100);
            function y(e) {
                return e.getInternalPath();
            }
            function R(e) {
                return e.getField();
            }
            function v(e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
            }
            T.focusElement = void 0, T.select = function(e) {
                setTimeout(function() {
                    (0, k.selectContentEditable)(e);
                }, 0);
            }, T.onDragStart = function(t, e) {
                if (!Array.isArray(t)) return T.onDragStart([
                    t
                ], e);
                var n, i, o, r, s;
                0 !== t.length && (n = t[0], i = t[t.length - 1], o = n.parent, s = T.getNodeFromTarget(e.target), r = n.editor, s = (0, k.getAbsoluteTop)(s.dom.tr) - (0, k.getAbsoluteTop)(n.dom.tr), r.mousemove || (r.mousemove = (0, k.addEventListener)(e.view, "mousemove", function(e) {
                    T.onDrag(t, e);
                })), r.mouseup || (r.mouseup = (0, k.addEventListener)(e.view, "mouseup", function(e) {
                    T.onDragEnd(t, e);
                })), r.highlighter.lock(), r.drag = {
                    oldCursor: document.body.style.cursor,
                    oldSelection: r.getDomSelection(),
                    oldPaths: t.map(y),
                    oldParent: o,
                    oldNextNode: o.childs[i.getIndex() + 1] || o.append,
                    oldParentPathRedo: o.getInternalPath(),
                    oldIndexRedo: n.getIndex(),
                    mouseX: e.pageX,
                    offsetY: s,
                    level: n.getLevel()
                }, document.body.style.cursor = "move", e.preventDefault());
            }, T.onDrag = function(e, t) {
                if (!Array.isArray(e)) return T.onDrag([
                    e
                ], t);
                if (0 !== e.length) {
                    var n, i, o, r, s, a = e[0].editor, l = t.pageY - a.drag.offsetY, c = t.pageX, h = !1, d = e[0], u = d.dom.tr, g = (0, k.getAbsoluteTop)(u), p = u.offsetHeight;
                    if (l < g) {
                        for(y = u; y = y.previousSibling, v = T.getNodeFromTarget(y), o = y ? (0, k.getAbsoluteTop)(y) : 0, y && l < o;);
                        (v = v && !v.parent ? void 0 : v) || (y = (u = u.parentNode.firstChild) ? u.nextSibling : void 0, (v = T.getNodeFromTarget(y)) === d && (v = void 0)), !(v = v && v.isVisible() && (o = (y = v.dom.tr) ? (0, k.getAbsoluteTop)(y) : 0) + p < l ? void 0 : v) || !1 !== a.options.limitDragging && v.parent !== e[0].parent || (e.forEach(function(e) {
                            v.parent.moveBefore(e, v);
                        }), h = !0);
                    } else {
                        var m = e[e.length - 1];
                        if (p = (u = m.expanded && m.append ? m.append.getDom() : m.dom.tr) ? u.nextSibling : void 0) {
                            for(r = (0, k.getAbsoluteTop)(p), n = p; i = T.getNodeFromTarget(n), n && (s = n.nextSibling ? (0, k.getAbsoluteTop)(n.nextSibling) : 0, s = n ? s - r : 0, i && i.parent.childs.length === e.length && i.parent.childs[e.length - 1] === m && (g += 27), n = n.nextSibling), n && g + s < l;);
                            if (i && i.parent) {
                                for(var p = c - a.drag.mouseX, p = Math.round(p / 24 / 2), f = a.drag.level + p, C = i.getLevel(), y = i.dom.tr && i.dom.tr.previousSibling; C < f && y;){
                                    var v = T.getNodeFromTarget(y), I = e.some(function(e) {
                                        return e === v || v.isDescendantOf(e);
                                    });
                                    if (!I) {
                                        if (!(v instanceof _)) break;
                                        I = v.parent.childs;
                                        if (I.length === e.length && I[e.length - 1] === m) break;
                                        C = (i = T.getNodeFromTarget(y)).getLevel();
                                    }
                                    y = y.previousSibling;
                                }
                                (i = i instanceof _ && !i.isVisible() && i.parent.showMore.isVisible() ? i._nextNode() : i) && (!1 === a.options.limitDragging || i.parent === e[0].parent) && i.dom.tr && i.dom.tr !== u.nextSibling && (e.forEach(function(e) {
                                    i.parent.moveBefore(e, i);
                                }), h = !0);
                            }
                        }
                    }
                    h && (a.drag.mouseX = c, a.drag.level = d.getLevel()), a.startAutoScroll(l), t.preventDefault();
                }
            }, T.onDragEnd = function(e, t) {
                if (!Array.isArray(e)) return T.onDrag([
                    e
                ], t);
                var n, i, o, r, s, a, l, c, h;
                0 !== e.length && (a = e[0], n = a.editor, a && a.dom.menu && a.dom.menu.focus(), i = n.drag.oldParent.getInternalPath(), o = a.parent.getInternalPath(), r = n.drag.oldParent === a.parent, s = n.drag.oldNextNode.getIndex(), a = a.getIndex(), l = n.drag.oldParentPathRedo, c = n.drag.oldIndexRedo, h = r && c < a ? a + e.length : a, r && c === a || n._onAction("moveNodes", {
                    count: e.length,
                    fieldNames: e.map(R),
                    oldParentPath: i,
                    newParentPath: o,
                    oldIndex: s,
                    newIndex: a,
                    oldIndexRedo: c,
                    newIndexRedo: h,
                    oldParentPathRedo: l,
                    newParentPathRedo: null,
                    oldSelection: n.drag.oldSelection,
                    newSelection: n.getDomSelection()
                }), document.body.style.cursor = n.drag.oldCursor, n.highlighter.unlock(), e.forEach(function(e) {
                    e.updateDom(), t.target !== e.dom.drag && t.target !== e.dom.menu && n.highlighter.unhighlight();
                }), delete n.drag, n.mousemove && ((0, k.removeEventListener)(t.view, "mousemove", n.mousemove), delete n.mousemove), n.mouseup && ((0, k.removeEventListener)(t.view, "mouseup", n.mouseup), delete n.mouseup), n.stopAutoScroll(), t.preventDefault());
            }, T._findEnum = function(e) {
                if (e.enum) return e.enum;
                e = e.oneOf || e.anyOf || e.allOf;
                if (e) {
                    e = e.filter(function(e) {
                        return e.enum;
                    });
                    if (0 < e.length) return e[0].enum;
                }
                return null;
            }, T._findSchema = function(e, t, n) {
                for(var i = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : e, o = n.slice(1, n.length), r = n[0], s = [
                    i
                ], a = 0, l = [
                    i.oneOf,
                    i.anyOf,
                    i.allOf
                ]; a < l.length; a++){
                    var c = l[a];
                    Array.isArray(c) && (s = s.concat(c));
                }
                var h, d = x(s);
                try {
                    for(d.s(); !(h = d.n()).done;){
                        if ("$ref" in (i = h.value) && "string" == typeof i.$ref) {
                            var u, g = i.$ref;
                            if (g in t) i = t[g];
                            else {
                                if (!g.startsWith("#/")) {
                                    if (1 === (null == (u = g.match(/#\//g)) ? void 0 : u.length)) {
                                        var p, m, f, C = G(g.split("#/"), 2), y = C[0], v = C[1];
                                        if (y in t) return p = t[y], m = {
                                            $ref: "#/".concat(v)
                                        }, (f = []).push(r), 0 < o.length && f.push.apply(f, H(o)), T._findSchema(p, t, f, m);
                                    }
                                    throw Error("Unable to resolve reference ".concat(g));
                                }
                                var I, b = g.substring(2).split("/"), i = e, A = x(b);
                                try {
                                    for(A.s(); !(I = A.n()).done;){
                                        var w = I.value;
                                        if (!(w in i)) throw Error("Unable to resolve reference ".concat(g));
                                        i = i[w];
                                    }
                                } catch (e) {
                                    A.e(e);
                                } finally{
                                    A.f();
                                }
                            }
                        }
                        if (void 0 === r) return i;
                        if ("string" == typeof r) {
                            if ("object" === E(i.properties) && null !== i.properties && r in i.properties) return i = i.properties[r], T._findSchema(e, t, o, i);
                            if ("object" === E(i.patternProperties) && null !== i.patternProperties) {
                                for(var S in i.patternProperties)if (r.match(S)) return i = i.patternProperties[S], T._findSchema(e, t, o, i);
                            }
                            if ("object" === E(i.additionalProperties)) return i = i.additionalProperties, T._findSchema(e, t, o, i);
                        } else if ("number" == typeof r && "object" === E(i.items) && null !== i.items) return i = i.items, T._findSchema(e, t, o, i);
                    }
                } catch (e) {
                    d.e(e);
                } finally{
                    d.f();
                }
                return null;
            }, T.onRemove = function(e) {
                if (!Array.isArray(e)) return T.onRemove([
                    e
                ]);
                var t, n, i, o, r, s;
                e && 0 < e.length && (t = (i = e[0]).parent, n = i.editor, i = i.getIndex(), n.highlighter.unhighlight(), o = n.getDomSelection(), T.blurNodes(e), r = n.getDomSelection(), s = e.map(y), e.forEach(function(e) {
                    e.parent._remove(e);
                }), n._onAction("removeNodes", {
                    nodes: e,
                    paths: s,
                    parentPath: t.getInternalPath(),
                    index: i,
                    oldSelection: o,
                    newSelection: r
                }));
            }, T.onDuplicate = function(e) {
                if (!Array.isArray(e)) return T.onDuplicate([
                    e
                ]);
                var t, i, n, o, r, s, a;
                e && 0 < e.length && (t = e[e.length - 1], i = t.parent, (n = t.editor).deselect(n.multiselection.nodes), o = n.getDomSelection(), r = t, s = e.map(function(e) {
                    var t, n = e.clone();
                    return "object" === e.parent.type && (t = e.parent.getFieldNames(), n.field = (0, k.findUniqueName)(e.field, t)), i.insertAfter(n, r), r = n;
                }), 1 === e.length ? "object" === s[0].parent.type ? (s[0].dom.field.innerHTML = e[0]._escapeHTML(e[0].field), s[0].focus("field")) : s[0].focus() : n.select(s), a = n.getDomSelection(), n._onAction("duplicateNodes", {
                    paths: e.map(y),
                    clonePaths: s.map(y),
                    afterPath: t.getInternalPath(),
                    parentPath: i.getInternalPath(),
                    oldSelection: o,
                    newSelection: a
                }));
            }, T.getNodeFromTarget = function(e) {
                for(; e;){
                    if (e.node) return e.node;
                    e = e.parentNode;
                }
            }, T.targetIsColorPicker = function(e) {
                var t = T.getNodeFromTarget(e);
                if (t) for(var n = e && e.parentNode; n;){
                    if (n === t.dom.color) return !0;
                    n = n.parentNode;
                }
                return !1;
            }, T.blurNodes = function(e) {
                var t, n;
                Array.isArray(e) ? (t = (n = e[0]).parent, n = n.getIndex(), (t.childs[n + e.length] ? t.childs[n + e.length] : t.childs[n - 1] || t).focus()) : T.blurNodes([
                    e
                ]);
            };
            (n.prototype = new T).getDom = function() {
                var e = this.dom;
                if (e.tr) return e.tr;
                this._updateEditability();
                var t = document.createElement("tr"), n = (t.className = "jsoneditor-append", t.node = this, e.tr = t, "tree" === this.editor.options.mode && (e.tdDrag = document.createElement("td"), i = document.createElement("td"), e.tdMenu = i, (n = document.createElement("button")).type = "button", n.className = "jsoneditor-button jsoneditor-contextmenu-button", n.title = "Click to open the actions menu (Ctrl+M)", e.menu = n, i.appendChild(e.menu)), document.createElement("td")), i = document.createElement("div");
                return i.appendChild(document.createTextNode("(" + (0, l.Iu)("empty") + ")")), i.className = "jsoneditor-readonly", n.appendChild(i), e.td = n, e.text = i, this.updateDom(), t;
            }, n.prototype.getPath = function() {
                return null;
            }, n.prototype.getIndex = function() {
                return null;
            }, n.prototype.updateDom = function(e) {
                var t = this.dom, n = t.td, i = (n && (n.style.paddingLeft = 24 * this.getLevel() + 26 + "px"), t.text), i = (i && (i.firstChild.nodeValue = "(" + (0, l.Iu)("empty") + " " + this.parent.type + ")"), t.tr);
                this.isVisible() ? t.tr.firstChild || (t.tdDrag && i.appendChild(t.tdDrag), t.tdMenu && i.appendChild(t.tdMenu), i.appendChild(n)) : t.tr.firstChild && (t.tdDrag && i.removeChild(t.tdDrag), t.tdMenu && i.removeChild(t.tdMenu), i.removeChild(n));
            }, n.prototype.isVisible = function() {
                return 0 === this.parent.childs.length;
            }, n.prototype.showContextMenu = function(e, t) {
                var n, i = this, o = [
                    {
                        text: (0, l.Iu)("auto"),
                        className: "jsoneditor-type-auto",
                        title: (0, l.Iu)("autoType"),
                        click: function() {
                            i._onAppend("", "", "auto");
                        }
                    },
                    {
                        text: (0, l.Iu)("array"),
                        className: "jsoneditor-type-array",
                        title: (0, l.Iu)("arrayType"),
                        click: function() {
                            i._onAppend("", []);
                        }
                    },
                    {
                        text: (0, l.Iu)("object"),
                        className: "jsoneditor-type-object",
                        title: (0, l.Iu)("objectType"),
                        click: function() {
                            i._onAppend("", {});
                        }
                    },
                    {
                        text: (0, l.Iu)("string"),
                        className: "jsoneditor-type-string",
                        title: (0, l.Iu)("stringType"),
                        click: function() {
                            i._onAppend("", "", "string");
                        }
                    }
                ], o = (i.addTemplates(o, !0), [
                    {
                        text: (0, l.Iu)("appendText"),
                        title: (0, l.Iu)("appendTitleAuto"),
                        submenuTitle: (0, l.Iu)("appendSubmenuTitle"),
                        className: "jsoneditor-insert",
                        click: function() {
                            i._onAppend("", "", "auto");
                        },
                        submenu: o
                    }
                ]);
                this.editor.options.onCreateMenu && (n = i.parent.getPath(), o = this.editor.options.onCreateMenu(o, {
                    type: "append",
                    path: n,
                    paths: [
                        n
                    ]
                })), new s.x(o, {
                    close: t
                }).show(e, this.editor.getPopupAnchor());
            }, n.prototype.onEvent = function(e) {
                var t, n = e.type, i = e.target || e.srcElement, o = this.dom;
                i === o.menu && ("mouseover" === n ? this.editor.highlighter.highlight(this.parent) : "mouseout" === n && this.editor.highlighter.unhighlight()), "click" === n && i === o.menu && ((t = this.editor.highlighter).highlight(this.parent), t.lock(), (0, k.addClassName)(o.menu, "jsoneditor-selected"), this.showContextMenu(o.menu, function() {
                    (0, k.removeClassName)(o.menu, "jsoneditor-selected"), t.unlock(), t.unhighlight();
                })), "keydown" === n && this.onKeyDown(e);
            };
            var _ = n;
            function n(e) {
                this.editor = e, this.dom = {};
            }
            (I.prototype = new T).getDom = function() {
                var t, n, e, i, o, r;
                return this.dom.tr || (this._updateEditability(), this.dom.tr || (n = (t = this).parent, (o = document.createElement("a")).appendChild(document.createTextNode((0, l.Iu)("showMore"))), o.href = "#", o.onclick = function(e) {
                    return n.visibleChilds = Math.floor(n.visibleChilds / n.getMaxVisibleChilds() + 1) * n.getMaxVisibleChilds(), t.updateDom(), n.showChilds(), e.preventDefault(), !1;
                }, (r = document.createElement("a")).appendChild(document.createTextNode((0, l.Iu)("showAll"))), r.href = "#", r.onclick = function(e) {
                    return n.visibleChilds = 1 / 0, t.updateDom(), n.showChilds(), e.preventDefault(), !1;
                }, e = document.createElement("div"), i = document.createTextNode(this._getShowMoreText()), e.className = "jsoneditor-show-more", e.appendChild(i), e.appendChild(o), e.appendChild(document.createTextNode(". ")), e.appendChild(r), e.appendChild(document.createTextNode(". ")), (o = document.createElement("td")).appendChild(e), r = document.createElement("tr"), "tree" === this.editor.options.mode && (r.appendChild(document.createElement("td")), r.appendChild(document.createElement("td"))), r.appendChild(o), r.className = "jsoneditor-show-more", this.dom.tr = r, this.dom.moreContents = e, this.dom.moreText = i), this.updateDom()), this.dom.tr;
            }, I.prototype.updateDom = function(e) {
                var t;
                this.isVisible() ? (this.dom.tr.node = this.parent.childs[this.parent.visibleChilds], this.dom.tr.parentNode || (t = this.parent._getNextTr()) && t.parentNode.insertBefore(this.dom.tr, t), this.dom.moreText.nodeValue = this._getShowMoreText(), this.dom.moreContents.style.marginLeft = 24 * (this.getLevel() + 1) + "px") : this.dom.tr && this.dom.tr.parentNode && this.dom.tr.parentNode.removeChild(this.dom.tr);
            }, I.prototype._getShowMoreText = function() {
                return (0, l.Iu)("showMoreStatus", {
                    visibleChilds: this.parent.visibleChilds,
                    totalChilds: this.parent.childs.length
                }) + " ";
            }, I.prototype.isVisible = function() {
                return this.parent.expanded && this.parent.childs.length > this.parent.visibleChilds;
            }, I.prototype.onEvent = function(e) {
                "keydown" === e.type && this.onKeyDown(e);
            };
            var F = I;
            function I(e, t) {
                this.editor = e, this.parent = t, this.dom = {};
            }
            function b(e) {
                return (b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function A(e, t) {
                for(var n = 0; n < t.length; n++){
                    var i = t[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function(e) {
                        e = function(e, t) {
                            if ("object" !== b(e) || null === e) return e;
                            var n = e[Symbol.toPrimitive];
                            if (void 0 === n) return ("string" === t ? String : Number)(e);
                            n = n.call(e, t || "default");
                            if ("object" !== b(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }(e, "string");
                        return "symbol" === b(e) ? e : String(e);
                    }(i.key), i);
                }
            }
            var V = function() {
                function e(t) {
                    if (!(this instanceof e)) throw new TypeError("Cannot call a class as a function");
                    function r(e) {
                        return t.node.findNodeByInternalPath(e);
                    }
                    this.editor = t, this.history = [], this.index = -1, this.clear(), this.actions = {
                        editField: {
                            undo: function(e) {
                                r(e.parentPath).childs[e.index].updateField(e.oldValue);
                            },
                            redo: function(e) {
                                r(e.parentPath).childs[e.index].updateField(e.newValue);
                            }
                        },
                        editValue: {
                            undo: function(e) {
                                r(e.path).updateValue(e.oldValue);
                            },
                            redo: function(e) {
                                r(e.path).updateValue(e.newValue);
                            }
                        },
                        changeType: {
                            undo: function(e) {
                                r(e.path).changeType(e.oldType);
                            },
                            redo: function(e) {
                                r(e.path).changeType(e.newType);
                            }
                        },
                        appendNodes: {
                            undo: function(e) {
                                var t = r(e.parentPath);
                                e.paths.map(r).forEach(function(e) {
                                    t.removeChild(e);
                                });
                            },
                            redo: function(e) {
                                var t = r(e.parentPath);
                                e.nodes.forEach(function(e) {
                                    t.appendChild(e);
                                });
                            }
                        },
                        insertBeforeNodes: {
                            undo: function(e) {
                                var t = r(e.parentPath);
                                e.paths.map(r).forEach(function(e) {
                                    t.removeChild(e);
                                });
                            },
                            redo: function(e) {
                                var t = r(e.parentPath), n = r(e.beforePath);
                                e.nodes.forEach(function(e) {
                                    t.insertBefore(e, n);
                                });
                            }
                        },
                        insertAfterNodes: {
                            undo: function(e) {
                                var t = r(e.parentPath);
                                e.paths.map(r).forEach(function(e) {
                                    t.removeChild(e);
                                });
                            },
                            redo: function(e) {
                                var t = r(e.parentPath), n = r(e.afterPath);
                                e.nodes.forEach(function(e) {
                                    t.insertAfter(e, n), n = e;
                                });
                            }
                        },
                        removeNodes: {
                            undo: function(e) {
                                var t = r(e.parentPath), n = t.childs[e.index] || t.append;
                                e.nodes.forEach(function(e) {
                                    t.insertBefore(e, n);
                                });
                            },
                            redo: function(e) {
                                var t = r(e.parentPath);
                                e.paths.map(r).forEach(function(e) {
                                    t.removeChild(e);
                                });
                            }
                        },
                        duplicateNodes: {
                            undo: function(e) {
                                var t = r(e.parentPath);
                                e.clonePaths.map(r).forEach(function(e) {
                                    t.removeChild(e);
                                });
                            },
                            redo: function(e) {
                                var i = r(e.parentPath), o = r(e.afterPath);
                                e.paths.map(r).forEach(function(e) {
                                    var t, n = e.clone();
                                    "object" === i.type && (t = i.getFieldNames(), n.field = (0, k.findUniqueName)(e.field, t)), i.insertAfter(n, o), o = n;
                                });
                            }
                        },
                        moveNodes: {
                            undo: function(n) {
                                var i = r(n.oldParentPath), e = r(n.newParentPath), o = i.childs[n.oldIndex] || i.append;
                                e.childs.slice(n.newIndex, n.newIndex + n.count).forEach(function(e, t) {
                                    e.field = n.fieldNames[t], i.moveBefore(e, o);
                                }), null === n.newParentPathRedo && (n.newParentPathRedo = e.getInternalPath());
                            },
                            redo: function(n) {
                                var e = r(n.oldParentPathRedo), i = r(n.newParentPathRedo), o = i.childs[n.newIndexRedo] || i.append;
                                e.childs.slice(n.oldIndexRedo, n.oldIndexRedo + n.count).forEach(function(e, t) {
                                    e.field = n.fieldNames[t], i.moveBefore(e, o);
                                });
                            }
                        },
                        sort: {
                            undo: function(e) {
                                var t = r(e.path);
                                t.hideChilds(), t.childs = e.oldChilds, t.updateDom({
                                    updateIndexes: !0
                                }), t.showChilds();
                            },
                            redo: function(e) {
                                var t = r(e.path);
                                t.hideChilds(), t.childs = e.newChilds, t.updateDom({
                                    updateIndexes: !0
                                }), t.showChilds();
                            }
                        },
                        transform: {
                            undo: function(e) {
                                r(e.path).setInternalValue(e.oldValue);
                            },
                            redo: function(e) {
                                r(e.path).setInternalValue(e.newValue);
                            }
                        }
                    };
                }
                var t, n, i;
                return t = e, n = [
                    {
                        key: "onChange",
                        value: function() {}
                    },
                    {
                        key: "add",
                        value: function(e, t) {
                            this.index++, this.history[this.index] = {
                                action: e,
                                params: t,
                                timestamp: new Date
                            }, this.index < this.history.length - 1 && this.history.splice(this.index + 1, this.history.length - this.index - 1), this.onChange();
                        }
                    },
                    {
                        key: "clear",
                        value: function() {
                            this.history = [], this.index = -1, this.onChange();
                        }
                    },
                    {
                        key: "canUndo",
                        value: function() {
                            return 0 <= this.index;
                        }
                    },
                    {
                        key: "canRedo",
                        value: function() {
                            return this.index < this.history.length - 1;
                        }
                    },
                    {
                        key: "undo",
                        value: function() {
                            if (this.canUndo()) {
                                var e = this.history[this.index];
                                if (e) {
                                    var t = this.actions[e.action];
                                    if (t && t.undo) {
                                        if (t.undo(e.params), e.params.oldSelection) try {
                                            this.editor.setDomSelection(e.params.oldSelection);
                                        } catch (e) {
                                            console.error(e);
                                        }
                                    } else console.error(new Error('unknown action "' + e.action + '"'));
                                }
                                this.index--, this.onChange();
                            }
                        }
                    },
                    {
                        key: "redo",
                        value: function() {
                            if (this.canRedo()) {
                                this.index++;
                                var e = this.history[this.index];
                                if (e) {
                                    var t = this.actions[e.action];
                                    if (t && t.redo) {
                                        if (t.redo(e.params), e.params.newSelection) try {
                                            this.editor.setDomSelection(e.params.newSelection);
                                        } catch (e) {
                                            console.error(e);
                                        }
                                    } else console.error(new Error('unknown action "' + e.action + '"'));
                                }
                                this.onChange();
                            }
                        }
                    },
                    {
                        key: "destroy",
                        value: function() {
                            this.editor = null, this.history = [], this.index = -1;
                        }
                    }
                ], A(t.prototype, n), i && A(t, i), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e;
            }();
            function $(e) {
                return ($ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function L(e, t) {
                for(var n = 0; n < t.length; n++){
                    var i = t[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function(e) {
                        e = function(e, t) {
                            if ("object" !== $(e) || null === e) return e;
                            var n = e[Symbol.toPrimitive];
                            if (void 0 === n) return ("string" === t ? String : Number)(e);
                            n = n.call(e, t || "default");
                            if ("object" !== $(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }(e, "string");
                        return "symbol" === $(e) ? e : String(e);
                    }(i.key), i);
                }
            }
            var Z = function() {
                function o(e, t) {
                    if (!(this instanceof o)) throw new TypeError("Cannot call a class as a function");
                    var n = this, e = (this.editor = e, this.timeout = void 0, this.delay = 200, this.lastText = void 0, this.results = null, this.dom = {}, this.dom.container = t, document.createElement("div")), t = ((this.dom.wrapper = e).className = "jsoneditor-search", t.appendChild(e), document.createElement("div")), t = ((this.dom.results = t).className = "jsoneditor-results", e.appendChild(t), document.createElement("div")), e = ((this.dom.input = t).className = "jsoneditor-frame", t.title = (0, l.Iu)("searchTitle"), e.appendChild(t), document.createElement("button")), i = (e.type = "button", e.className = "jsoneditor-refresh", t.appendChild(e), document.createElement("input")), e = (i.type = "text", (this.dom.search = i).oninput = function(e) {
                        n._onDelayedSearch(e);
                    }, i.onchange = function(e) {
                        n._onSearch();
                    }, i.onkeydown = function(e) {
                        n._onKeyDown(e);
                    }, i.onkeyup = function(e) {
                        n._onKeyUp(e);
                    }, e.onclick = function(e) {
                        i.select();
                    }, t.appendChild(i), document.createElement("button")), e = (e.type = "button", e.title = (0, l.Iu)("searchNextResultTitle"), e.className = "jsoneditor-next", e.onclick = function() {
                        n.next();
                    }, t.appendChild(e), document.createElement("button"));
                    e.type = "button", e.title = (0, l.Iu)("searchPreviousResultTitle"), e.className = "jsoneditor-previous", e.onclick = function() {
                        n.previous();
                    }, t.appendChild(e);
                }
                var e, t, n;
                return e = o, t = [
                    {
                        key: "next",
                        value: function(e) {
                            var t;
                            this.results && ((t = null !== this.resultIndex ? this.resultIndex + 1 : 0) > this.results.length - 1 && (t = 0), this._setActiveResult(t, e));
                        }
                    },
                    {
                        key: "previous",
                        value: function(e) {
                            var t, n;
                            this.results && (t = this.results.length - 1, n = null !== this.resultIndex ? this.resultIndex - 1 : t, this._setActiveResult(n = n < 0 ? t : n, e));
                        }
                    },
                    {
                        key: "_setActiveResult",
                        value: function(e, t) {
                            var n, i, o;
                            this.activeResult && (n = this.activeResult.node, "field" === this.activeResult.elem ? delete n.searchFieldActive : delete n.searchValueActive, n.updateDom()), this.results && this.results[e] ? (this.resultIndex = e, i = this.results[this.resultIndex].node, "field" === (o = this.results[this.resultIndex].elem) ? i.searchFieldActive = !0 : i.searchValueActive = !0, this.activeResult = this.results[this.resultIndex], i.updateDom(), i.scrollTo(function() {
                                t && i.focus(o);
                            })) : (this.resultIndex = void 0, this.activeResult = void 0);
                        }
                    },
                    {
                        key: "_clearDelay",
                        value: function() {
                            void 0 !== this.timeout && (clearTimeout(this.timeout), delete this.timeout);
                        }
                    },
                    {
                        key: "_onDelayedSearch",
                        value: function(e) {
                            this._clearDelay();
                            var t = this;
                            this.timeout = setTimeout(function(e) {
                                t._onSearch();
                            }, this.delay);
                        }
                    },
                    {
                        key: "_onSearch",
                        value: function(e) {
                            this._clearDelay();
                            var t = this.dom.search.value, t = 0 < t.length ? t : void 0;
                            if (t !== this.lastText || e) {
                                this.lastText = t, this.results = this.editor.search(t);
                                var e = this.results[0] ? this.results[0].node.MAX_SEARCH_RESULTS : 1 / 0, n = 0;
                                if (this.activeResult) {
                                    for(var i = 0; i < this.results.length; i++)if (this.results[i].node === this.activeResult.node) {
                                        n = i;
                                        break;
                                    }
                                }
                                this._setActiveResult(n, !1), void 0 !== t ? (t = this.results.length, this.dom.results.textContent = 0 === t ? "no\xa0results" : 1 === t ? "1\xa0result" : e < t ? e + "+\xa0results" : t + "\xa0results") : this.dom.results.textContent = "";
                            }
                        }
                    },
                    {
                        key: "_onKeyDown",
                        value: function(e) {
                            var t = e.which;
                            27 === t ? (this.dom.search.value = "", this._onSearch(), e.preventDefault(), e.stopPropagation()) : 13 === t && (e.ctrlKey ? this._onSearch(!0) : e.shiftKey ? this.previous() : this.next(), e.preventDefault(), e.stopPropagation());
                        }
                    },
                    {
                        key: "_onKeyUp",
                        value: function(e) {
                            var t = e.keyCode;
                            27 !== t && 13 !== t && this._onDelayedSearch(e);
                        }
                    },
                    {
                        key: "clear",
                        value: function() {
                            this.dom.search.value = "", this._onSearch();
                        }
                    },
                    {
                        key: "forceSearch",
                        value: function() {
                            this._onSearch(!0);
                        }
                    },
                    {
                        key: "isEmpty",
                        value: function() {
                            return "" === this.dom.search.value;
                        }
                    },
                    {
                        key: "destroy",
                        value: function() {
                            this.editor = null, this.dom.container.removeChild(this.dom.wrapper), this.dom = null, this.results = null, this.activeResult = null, this._clearDelay();
                        }
                    }
                ], L(e.prototype, t), n && L(e, n), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), o;
            }();
            function N(e) {
                return (N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function B(e, t) {
                for(var n = 0; n < t.length; n++){
                    var i = t[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function(e) {
                        e = function(e, t) {
                            if ("object" !== N(e) || null === e) return e;
                            var n = e[Symbol.toPrimitive];
                            if (void 0 === n) return ("string" === t ? String : Number)(e);
                            n = n.call(e, t || "default");
                            if ("object" !== N(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }(e, "string");
                        return "symbol" === N(e) ? e : String(e);
                    }(i.key), i);
                }
            }
            var O = function() {
                function n(e, t) {
                    if (!(this instanceof n)) throw new TypeError("Cannot call a class as a function");
                    e && (this.root = t, this.path = document.createElement("div"), this.path.className = "jsoneditor-treepath", this.path.setAttribute("tabindex", 0), this.contentMenuClicked = !1, e.appendChild(this.path), this.reset());
                }
                var e, t, i;
                return e = n, t = [
                    {
                        key: "reset",
                        value: function() {
                            this.path.textContent = (0, l.Iu)("selectNode");
                        }
                    },
                    {
                        key: "setPath",
                        value: function(o) {
                            var r = this;
                            this.path.textContent = "", o && o.length && o.forEach(function(n, i) {
                                var e, t = document.createElement("span");
                                t.className = "jsoneditor-treepath-element", t.innerText = n.name, t.onclick = (function(e) {
                                    this.selectionCallback && this.selectionCallback(e);
                                }).bind(r, n), r.path.appendChild(t), n.children.length && ((e = document.createElement("span")).className = "jsoneditor-treepath-seperator", e.textContent = "\u25BA", e.onclick = function() {
                                    r.contentMenuClicked = !0;
                                    var t = [];
                                    n.children.forEach(function(e) {
                                        t.push({
                                            text: e.name,
                                            className: "jsoneditor-type-modes" + (o[i + 1] + 1 && o[i + 1].name === e.name ? " jsoneditor-selected" : ""),
                                            click: (function(e, t) {
                                                this.contextMenuCallback && this.contextMenuCallback(e, t);
                                            }).bind(r, n, e.name)
                                        });
                                    }), new s.x(t, {
                                        limitHeight: !0
                                    }).show(e, r.root, !0);
                                }, r.path.appendChild(e)), i === o.length - 1 && (t = (e || t).getBoundingClientRect().right, r.path.offsetWidth < t && (r.path.scrollLeft = t), r.path.scrollLeft) && ((t = document.createElement("span")).className = "jsoneditor-treepath-show-all-btn", t.title = "show all path", t.textContent = "...", t.onclick = (function(e) {
                                    (r.contentMenuClicked = !1, k.addClassName)(r.path, "show-all"), r.path.style.width = r.path.parentNode.getBoundingClientRect().width - 10 + "px", r.path.onblur = function() {
                                        r.contentMenuClicked ? (r.contentMenuClicked = !1, r.path.focus()) : ((0, k.removeClassName)(r.path, "show-all"), r.path.onblur = void 0, r.path.style.width = "", r.setPath(e));
                                    };
                                }).bind(r, o), r.path.insertBefore(t, r.path.firstChild));
                            });
                        }
                    },
                    {
                        key: "onSectionSelected",
                        value: function(e) {
                            "function" == typeof e && (this.selectionCallback = e);
                        }
                    },
                    {
                        key: "onContextMenuItemSelected",
                        value: function(e) {
                            "function" == typeof e && (this.contextMenuCallback = e);
                        }
                    }
                ], B(e.prototype, t), i && B(e, i), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), n;
            }(), e = t(8037), M = t.n(e), t = {}, D = (t.create = function(e, t) {
                if (!e) throw new Error("No container element provided.");
                function r(e) {
                    var t, n;
                    document.createRange ? ((t = document.createRange()).selectNodeContents(e), t.collapse(!1), (n = window.getSelection()).removeAllRanges(), n.addRange(t)) : document.selection && ((t = document.body.createTextRange()).moveToElementText(e), t.collapse(!1), t.select());
                }
                function s(e) {
                    return void 0 === n && ((n = document.createElement("span")).style.visibility = "hidden", n.style.position = "fixed", n.style.outline = "0", n.style.margin = "0", n.style.padding = "0", n.style.border = "0", n.style.left = "0", n.style.whiteSpace = "pre", n.style.fontSize = o, n.style.fontFamily = u, n.style.fontWeight = "normal", document.body.appendChild(n)), n.textContent = e, n.getBoundingClientRect().right;
                }
                function a() {
                    this.style.backgroundColor = "#ddd";
                }
                function l() {
                    this.style.backgroundColor = "";
                }
                function c() {
                    y.hide(), y.onmouseselection(this.__hint, y.rs);
                }
                var h, n, d, o, u, g, p, m, f, C, i, y, v, I, b, A;
                this.container = e, this.dom = {}, this.highlighter = new S, this.selection = void 0, this.multiselection = {
                    nodes: []
                }, this.validateSchema = null, this.validationSequence = 0, this.errorNodes = [], this.lastSchemaErrors = void 0, this.node = null, this.focusTarget = null, this._setOptions(t), t.autocomplete && (this.autocomplete = ((h = (h = t.autocomplete) || {}).filter = h.filter || "start", h.trigger = h.trigger || "keydown", h.confirmKeys = h.confirmKeys || [
                    39,
                    35,
                    9
                ], h.caseSensitive = h.caseSensitive || !1, u = o = "", (g = document.createElement("div")).style.position = "relative", g.style.outline = "0", g.style.border = "0", g.style.margin = "0", g.style.padding = "0", (p = document.createElement("div")).className = "autocomplete dropdown", p.style.position = "absolute", p.style.visibility = "hidden", m = p, f = [], i = -1, I = y = {
                    rs: v = {
                        onArrowDown: function() {},
                        onArrowUp: function() {},
                        onEnter: function() {},
                        onTab: function() {},
                        startFrom: C = 0,
                        options: [],
                        element: null,
                        elementHint: null,
                        elementStyle: null,
                        wrapper: g,
                        show: function(e, t, n) {
                            var i = this;
                            this.startFrom = t, this.wrapper.remove(), this.elementHint && (this.elementHint.remove(), this.elementHint = null), "" === o && (o = window.getComputedStyle(e).getPropertyValue("font-size")), "" === u && (u = window.getComputedStyle(e).getPropertyValue("font-family")), p.style.marginLeft = "0", p.style.marginTop = e.getBoundingClientRect().height + "px", this.options = n.map(String), this.element !== e && (this.element = e, this.elementStyle = {
                                zIndex: this.element.style.zIndex,
                                position: this.element.style.position,
                                backgroundColor: this.element.style.backgroundColor,
                                borderColor: this.element.style.borderColor
                            }), this.element.style.zIndex = 3, this.element.style.position = "relative", this.element.style.backgroundColor = "transparent", this.element.style.borderColor = "transparent", this.elementHint = e.cloneNode(), this.elementHint.className = "autocomplete hint", this.elementHint.style.zIndex = 2, this.elementHint.style.position = "absolute", this.elementHint.onfocus = function() {
                                i.element.focus();
                            }, this.element.addEventListener && (this.element.removeEventListener("keydown", b), this.element.addEventListener("keydown", b, !1), this.element.removeEventListener("blur", A), this.element.addEventListener("blur", A, !1)), g.appendChild(this.elementHint), g.appendChild(p), e.parentElement.appendChild(g), this.repaint(e);
                        },
                        setText: function(e) {
                            this.element.innerText = e;
                        },
                        getText: function() {
                            return this.element.innerText;
                        },
                        hideDropDown: function() {
                            this.wrapper.remove(), this.elementHint && (this.elementHint.remove(), this.elementHint = null, I.hide(), this.element.style.zIndex = this.elementStyle.zIndex, this.element.style.position = this.elementStyle.position, this.element.style.backgroundColor = this.elementStyle.backgroundColor, this.element.style.borderColor = this.elementStyle.borderColor);
                        },
                        repaint: function(e) {
                            var e = (e = e.innerText).replace("\n", ""), t = this.options.length, n = e.substring(this.startFrom);
                            d = e.substring(0, this.startFrom);
                            for(var i = 0; i < t; i++){
                                var o = this.options[i];
                                if (!h.caseSensitive && 0 === o.toLowerCase().indexOf(n.toLowerCase()) || h.caseSensitive && 0 === o.indexOf(n)) {
                                    this.elementHint.innerText = d + n + o.substring(n.length), this.elementHint.realInnerText = d + o;
                                    break;
                                }
                            }
                            p.style.left = s(d) + "px", I.refresh(n, this.options), this.elementHint.style.width = s(this.elementHint.innerText) + 10 + "px", "hidden" !== p.style.visibility && (this.elementHint.style.width = s(this.elementHint.innerText) + p.clientWidth + "px");
                        }
                    },
                    hide: function() {
                        m.style.visibility = "hidden";
                    },
                    refresh: function(i, e) {
                        m.style.visibility = "hidden", C = 0, m.textContent = "";
                        var t = window.innerHeight || document.documentElement.clientHeight, n = m.parentNode.getBoundingClientRect(), o = n.top - 6, t = t - n.bottom - 6, r = (f = [], "function" == typeof h.filter ? h.filter : w[h.filter]), n = r ? e.filter(function(e) {
                            return r(h.caseSensitive ? i : i.toLowerCase(), h.caseSensitive ? e : e.toLowerCase(), h);
                        }) : [];
                        0 === (f = n.map(function(e) {
                            var t = document.createElement("div"), n = (t.className = "item", t.onmouseover = a, t.onmouseout = l, t.onmousedown = c, t.__hint = e, t.textContent = "", t.appendChild(document.createTextNode(e.substring(0, i.length))), document.createElement("b"));
                            return n.appendChild(document.createTextNode(e.substring(i.length))), t.appendChild(n), m.appendChild(t), t;
                        })).length || 1 === f.length && (i.toLowerCase() === f[0].__hint.toLowerCase() && !h.caseSensitive || i === f[0].__hint && h.caseSensitive) || f.length < 2 || (y.highlight(0), 3 * t < o ? (m.style.maxHeight = o + "px", m.style.top = "", m.style.bottom = "100%") : (m.style.top = "100%", m.style.bottom = "", m.style.maxHeight = t + "px"), m.style.visibility = "visible");
                    },
                    highlight: function(e) {
                        -1 !== i && f[i] && (f[i].className = "item"), f[e].className = "item hover", i = e;
                    },
                    move: function(e) {
                        return "hidden" === m.style.visibility ? "" : (C + e !== -1 && C + e !== f.length && (C += e, y.highlight(C)), f[C].__hint);
                    },
                    onmouseselection: function() {}
                }, b = (function(e) {
                    var t = (e = e || window.event).keyCode;
                    if (null != this.elementHint && 33 !== t && 34 !== t) {
                        if (27 === t) v.hideDropDown(), v.element.focus(), e.preventDefault(), e.stopPropagation();
                        else {
                            var n, i = (i = this.element.innerText).replace("\n", "");
                            if (0 <= h.confirmKeys.indexOf(t)) 9 === t && 0 === this.elementHint.innerText.length && v.onTab(), 0 < this.elementHint.innerText.length && this.element.innerText !== this.elementHint.realInnerText && (this.element.innerText = this.elementHint.realInnerText, v.hideDropDown(), r(this.element), 9 === t) && (v.element.focus(), e.preventDefault(), e.stopPropagation());
                            else if (13 === t) {
                                if (0 === this.elementHint.innerText.length) v.onEnter();
                                else {
                                    var o = "hidden" === p.style.visibility;
                                    if (I.hide(), o) return v.hideDropDown(), v.element.focus(), void v.onEnter();
                                    this.element.innerText = this.elementHint.realInnerText, v.hideDropDown(), r(this.element), e.preventDefault(), e.stopPropagation();
                                }
                            } else 40 === t ? (o = i.substring(this.startFrom), "" === (n = I.move(1)) && v.onArrowDown(), this.elementHint.innerText = d + o + n.substring(o.length), this.elementHint.realInnerText = d + n, e.preventDefault(), e.stopPropagation()) : 38 === t && (o = i.substring(this.startFrom), "" === (n = I.move(-1)) && v.onArrowUp(), this.elementHint.innerText = d + o + n.substring(o.length), this.elementHint.realInnerText = d + n, e.preventDefault(), e.stopPropagation());
                        }
                    }
                }).bind(v), A = function(e) {
                    v.hideDropDown();
                }, I.onmouseselection = function(e, t) {
                    t.element.innerText = t.elementHint.innerText = d + e, t.hideDropDown(), window.setTimeout(function() {
                        t.element.focus(), r(t.element);
                    }, 1);
                }, v)), this.options.history && "view" !== this.options.mode && (this.history = new V(this)), this._createFrame(), this._createTable();
            }, t.destroy = function() {
                this.frame && this.container && this.frame.parentNode === this.container && (this.container.removeChild(this.frame), this.frame = null), this.container = null, this.dom = null, this.clear(), this.node = null, this.focusTarget = null, this.selection = null, this.multiselection = null, this.errorNodes = null, this.validateSchema = null, this._debouncedValidate = null, this.history && (this.history.destroy(), this.history = null), this.searchBox && (this.searchBox.destroy(), this.searchBox = null), this.modeSwitcher && (this.modeSwitcher.destroy(), this.modeSwitcher = null), this.frameFocusTracker.destroy();
            }, t._setOptions = function(t) {
                var n = this;
                this.options = {
                    search: !0,
                    history: !0,
                    mode: "tree",
                    name: void 0,
                    schema: null,
                    schemaRefs: null,
                    autocomplete: null,
                    navigationBar: !0,
                    mainMenuBar: !0,
                    limitDragging: !1,
                    onSelectionChange: null,
                    colorPicker: !0,
                    onColorPicker: function(e, t, n) {
                        var i;
                        M() ? (i = e.getBoundingClientRect().top, i = (0, k.getWindow)(e).innerHeight - i < 300 && 300 < i, new (M())({
                            parent: e,
                            color: t,
                            popup: i ? "top" : "bottom",
                            onDone: function(e) {
                                e = 1 === e.rgba[3] ? e.hex.substr(0, 7) : e.hex;
                                n(e);
                            }
                        }).show()) : console.warn("Cannot open color picker: the `vanilla-picker` library is not included in the bundle. Either use the full bundle or implement your own color picker using `onColorPicker`.");
                    },
                    timestampTag: !0,
                    timestampFormat: null,
                    createQuery: i.r,
                    executeQuery: i.J,
                    onEvent: null,
                    enableSort: !0,
                    enableTransform: !0
                }, t && (Object.keys(t).forEach(function(e) {
                    n.options[e] = t[e];
                }), null == t.limitDragging) && null != t.schema && (this.options.limitDragging = !0), this.setSchema(this.options.schema, this.options.schemaRefs), this._debouncedValidate = (0, k.debounce)(this._validateAndCatch.bind(this), this.DEBOUNCE_INTERVAL), t.onSelectionChange && this.onSelectionChange(t.onSelectionChange), (0, l.cC)(this.options.languages), (0, l.m0)(this.options.language);
            }, t.set = function(e) {
                e instanceof Function || void 0 === e ? this.clear() : (this.content.removeChild(this.table), e = {
                    field: this.options.name,
                    value: e
                }, e = new T(this, e), this._setRoot(e), this._validateAndCatch(), this.node.expand(!1), this.content.appendChild(this.table)), this.history && this.history.clear(), this.searchBox && this.searchBox.clear();
            }, t.update = function(e) {
                var t, n;
                this.node.deepEqual(e) || (t = this.getSelection(), this.onChangeDisabled = !0, this.node.update(e), this.onChangeDisabled = !1, this._validateAndCatch(), this.searchBox && !this.searchBox.isEmpty() && this.searchBox.forceSearch(), t && t.start && t.end && (e = this.node.findNodeByPath(t.start.path), n = this.node.findNodeByPath(t.end.path), e) && n ? this.setSelection(t.start, t.end) : this.setSelection({}, {}));
            }, t.get = function() {
                if (this.node) return this.node.getValue();
            }, t.getText = function() {
                return JSON.stringify(this.get());
            }, t.setText = function(t) {
                try {
                    this.set((0, k.parse)(t));
                } catch (e) {
                    t = (0, k.tryJsonRepair)(t);
                    this.set((0, k.parse)(t));
                }
            }, t.updateText = function(t) {
                try {
                    this.update((0, k.parse)(t));
                } catch (e) {
                    t = (0, k.tryJsonRepair)(t);
                    this.update((0, k.parse)(t));
                }
            }, t.setName = function(e) {
                this.options.name = e, this.node && this.node.updateField(this.options.name);
            }, t.getName = function() {
                return this.options.name;
            }, t.focus = function() {
                var e = this.scrollableContent.querySelector("[contenteditable=true]");
                e ? e.focus() : this.node.dom.expand ? this.node.dom.expand.focus() : this.node.dom.menu ? this.node.dom.menu.focus() : (e = this.frame.querySelector("button")) && e.focus();
            }, t.clear = function() {
                this.node && (this.node.hide(), delete this.node), this.treePath && this.treePath.reset();
            }, t._setRoot = function(e) {
                this.clear(), (this.node = e).setParent(null), e.setField(this.getName(), !1), delete e.index, this.tbody.appendChild(e.getDom());
            }, t.search = function(e) {
                var t;
                return this.node ? (this.content.removeChild(this.table), t = this.node.search(e), this.content.appendChild(this.table)) : t = [], t;
            }, t.expandAll = function() {
                this.node && (this.content.removeChild(this.table), this.node.expand(), this.content.appendChild(this.table));
            }, t.collapseAll = function() {
                this.node && (this.content.removeChild(this.table), this.node.collapse(), this.content.appendChild(this.table));
            }, t.expand = function(e) {
                var t;
                e && (t = this.node ? this.node.findNodeByPath(e.path) : null) && (e.isExpand ? t.expand(e.recursive) : t.collapse(e.recursive));
            }, t._onAction = function(e, t) {
                this.history && this.history.add(e, t), this._onChange();
            }, t._onChange = function() {
                if (!this.onChangeDisabled) {
                    var e;
                    if (this.selection = this.getDomSelection(), this._debouncedValidate(), this.treePath && ((e = this.node && this.selection ? this.node.findNodeByInternalPath(this.selection.path) : this.multiselection ? this.multiselection.nodes[0] : void 0) ? this._updateTreePath(e.getNodePath()) : this.treePath.reset()), this.options.onChange) try {
                        this.options.onChange();
                    } catch (e) {
                        console.error("Error in onChange callback: ", e);
                    }
                    if (this.options.onChangeJSON) try {
                        this.options.onChangeJSON(this.get());
                    } catch (e) {
                        console.error("Error in onChangeJSON callback: ", e);
                    }
                    if (this.options.onChangeText) try {
                        this.options.onChangeText(this.getText());
                    } catch (e) {
                        console.error("Error in onChangeText callback: ", e);
                    }
                    if (this.options.onClassName && this.node.recursivelyUpdateCssClassesOnNodes(), this.options.onNodeName && this.node.childs) try {
                        this.node.recursivelyUpdateNodeName();
                    } catch (e) {
                        console.error("Error in onNodeName callback: ", e);
                    }
                }
            }, t.validate = function() {
                var t = this, n = this.node;
                if (n) {
                    var e = n.getValue(), i = [];
                    this.validateSchema && !this.validateSchema(e) && (i = this.validateSchema.errors.map(function(e) {
                        return (0, k.improveSchemaError)(e);
                    }).map(function(e) {
                        return {
                            node: n.findNode(e.dataPath),
                            error: e,
                            type: "validation"
                        };
                    }).filter(function(e) {
                        return null != e.node;
                    }));
                    try {
                        this.validationSequence++;
                        var o = this, r = this.validationSequence;
                        return this._validateCustom(e).then(function(e) {
                            return r === o.validationSequence && (e = [].concat(i, e || []), o._renderValidationErrors(e), "function" == typeof t.options.onValidationError && (0, k.isValidationErrorChanged)(e, t.lastSchemaErrors) && t.options.onValidationError.call(t, e), t.lastSchemaErrors = e), t.lastSchemaErrors;
                        });
                    } catch (e) {
                        return Promise.reject(e);
                    }
                }
            }, t._validateAndCatch = function() {
                this.validate().catch(function(e) {
                    console.error("Error running validation:", e);
                });
            }, t._renderValidationErrors = function(e) {
                this.errorNodes && this.errorNodes.forEach(function(e) {
                    e.setError(null);
                });
                var t = e.reduce(function(e, t) {
                    return t.node.findParents().filter(function(t) {
                        return !e.some(function(e) {
                            return e[0] === t;
                        });
                    }).map(function(e) {
                        return [
                            e,
                            t.node
                        ];
                    }).concat(e);
                }, []);
                this.errorNodes = t.map(function(e) {
                    return {
                        node: e[0],
                        child: e[1],
                        error: {
                            message: "object" === e[0].type ? (0, l.Iu)("containsInvalidProperties") : (0, l.Iu)("containsInvalidItems")
                        }
                    };
                }).concat(e).map(function(e) {
                    return e.node.setError(e.error, e.child), e.node;
                });
            }, t._validateCustom = function(e) {
                try {
                    var n, t;
                    if (this.options.onValidate) return n = this.node, t = this.options.onValidate(e), ((0, k.isPromise)(t) ? t : Promise.resolve(t)).then(function(e) {
                        return Array.isArray(e) ? e.filter(function(e) {
                            var t = (0, k.isValidValidationError)(e);
                            return t || console.warn('Ignoring a custom validation error with invalid structure. Expected structure: {path: [...], message: "..."}. Actual error:', e), t;
                        }).map(function(e) {
                            var t;
                            try {
                                t = e && e.path ? n.findNodeByPath(e.path) : null;
                            } catch (e) {}
                            return t || console.warn("Ignoring validation error: node not found. Path:", e.path, "Error:", e), {
                                node: t,
                                error: e,
                                type: "customValidation"
                            };
                        }).filter(function(e) {
                            return e && e.node && e.error && e.error.message;
                        }) : null;
                    });
                } catch (e) {
                    return Promise.reject(e);
                }
                return Promise.resolve(null);
            }, t.refresh = function() {
                this.node && this.node.updateDom({
                    recurse: !0
                });
            }, t.startAutoScroll = function(e) {
                var t = this, n = this.scrollableContent, i = (0, k.getAbsoluteTop)(n), o = n.clientHeight, r = i + o;
                e < i + 24 && 0 < n.scrollTop ? this.autoScrollStep = (i + 24 - e) / 3 : r - 24 < e && o + n.scrollTop < n.scrollHeight ? this.autoScrollStep = (r - 24 - e) / 3 : this.autoScrollStep = void 0, this.autoScrollStep ? this.autoScrollTimer || (this.autoScrollTimer = setInterval(function() {
                    t.autoScrollStep ? n.scrollTop -= t.autoScrollStep : t.stopAutoScroll();
                }, 50)) : this.stopAutoScroll();
            }, t.stopAutoScroll = function() {
                this.autoScrollTimer && (clearTimeout(this.autoScrollTimer), delete this.autoScrollTimer), this.autoScrollStep && delete this.autoScrollStep;
            }, t.setDomSelection = function(e) {
                var t, n, i;
                e && ("scrollTop" in e && this.scrollableContent && (this.scrollableContent.scrollTop = e.scrollTop), e.paths ? (t = this, n = e.paths.map(function(e) {
                    return t.node.findNodeByInternalPath(e);
                }), this.select(n)) : (i = (n = e.path ? this.node.findNodeByInternalPath(e.path) : null) && e.domName ? n.dom[e.domName] : null, e.range && i ? (e = Object.assign({}, e.range, {
                    container: i
                }), (0, k.setSelectionOffset)(e)) : n && n.focus()));
            }, t.getDomSelection = function() {
                var t = T.getNodeFromTarget(this.focusTarget), n = this.focusTarget, e = t ? Object.keys(t.dom).find(function(e) {
                    return t.dom[e] === n;
                }) : null, i = (0, k.getSelectionOffset)();
                return (i = (i = i && "DIV" !== i.container.nodeName ? null : i) && i.container !== n ? null : i) && delete i.container, {
                    path: t ? t.getInternalPath() : null,
                    domName: e,
                    range: i,
                    paths: 0 < this.multiselection.length ? this.multiselection.nodes.map(function(e) {
                        return e.getInternalPath();
                    }) : null,
                    scrollTop: this.scrollableContent ? this.scrollableContent.scrollTop : 0
                };
            }, t.scrollTo = function(e, n) {
                var i, t, o, r, s = this.scrollableContent;
                s ? ((i = this).animateTimeout && (clearTimeout(i.animateTimeout), delete i.animateTimeout), i.animateCallback && (i.animateCallback(!1), delete i.animateCallback), t = s.clientHeight, o = s.scrollHeight - t, r = Math.min(Math.max(e - t / 4, 0), o), function e() {
                    var t = s.scrollTop, t = r - t;
                    3 < Math.abs(t) ? (s.scrollTop += t / 3, i.animateCallback = n, i.animateTimeout = setTimeout(e, 50)) : (n && n(!0), s.scrollTop = r, delete i.animateTimeout, delete i.animateCallback);
                }()) : n && n(!1);
            }, t._createFrame = function() {
                var e = this, t = (this.frame = document.createElement("div"), this.frame.className = "jsoneditor jsoneditor-mode-" + this.options.mode, this.container.appendChild(this.frame), this.contentOuter = document.createElement("div"), this.contentOuter.className = "jsoneditor-outer", this);
                function n(e) {
                    t._onEvent && t._onEvent(e);
                }
                var i, o, r, s = {
                    target: this.frame,
                    onFocus: this.options.onFocus || null,
                    onBlur: this.options.onBlur || null
                };
                this.frameFocusTracker = new a.R(s), this.frame.onclick = function(e) {
                    var t = e.target;
                    n(e), "BUTTON" === t.nodeName && e.preventDefault();
                }, this.frame.oninput = n, this.frame.onchange = n, this.frame.onkeydown = n, this.frame.onkeyup = n, this.frame.oncut = n, this.frame.onpaste = n, this.frame.onmousedown = n, this.frame.onmouseup = n, this.frame.onmouseover = n, this.frame.onmouseout = n, (0, k.addEventListener)(this.frame, "focus", n, !0), (0, k.addEventListener)(this.frame, "blur", n, !0), this.frame.onfocusin = n, this.frame.onfocusout = n, this.options.mainMenuBar && ((0, k.addClassName)(this.contentOuter, "has-main-menu-bar"), this.menu = document.createElement("div"), this.menu.className = "jsoneditor-menu", this.frame.appendChild(this.menu), (s = document.createElement("button")).type = "button", s.className = "jsoneditor-expand-all", s.title = (0, l.Iu)("expandAll"), s.onclick = function() {
                    t.expandAll(), "function" == typeof e.options.onExpand && e.options.onExpand({
                        path: [],
                        isExpand: !0,
                        recursive: !0
                    });
                }, this.menu.appendChild(s), (s = document.createElement("button")).type = "button", s.title = (0, l.Iu)("collapseAll"), s.className = "jsoneditor-collapse-all", s.onclick = function() {
                    t.collapseAll(), "function" == typeof e.options.onExpand && e.options.onExpand({
                        path: [],
                        isExpand: !1,
                        recursive: !0
                    });
                }, this.menu.appendChild(s), this.options.enableSort && ((s = document.createElement("button")).type = "button", s.className = "jsoneditor-sort", s.title = (0, l.Iu)("sortTitleShort"), s.onclick = function() {
                    t.node.showSortModal();
                }, this.menu.appendChild(s)), this.options.enableTransform && ((s = document.createElement("button")).type = "button", s.title = (0, l.Iu)("transformTitleShort"), s.className = "jsoneditor-transform", s.onclick = function() {
                    t.node.showTransformModal();
                }, this.menu.appendChild(s)), this.history && ((i = document.createElement("button")).type = "button", i.className = "jsoneditor-undo jsoneditor-separator", i.title = (0, l.Iu)("undo"), i.onclick = function() {
                    t._onUndo();
                }, this.menu.appendChild(i), this.dom.undo = i, (o = document.createElement("button")).type = "button", o.className = "jsoneditor-redo", o.title = (0, l.Iu)("redo"), o.onclick = function() {
                    t._onRedo();
                }, this.menu.appendChild(o), this.dom.redo = o, this.history.onChange = function() {
                    i.disabled = !t.history.canUndo(), o.disabled = !t.history.canRedo();
                }, this.history.onChange()), this.options && this.options.modes && this.options.modes.length && ((r = this).modeSwitcher = new c.x(this.menu, this.options.modes, this.options.mode, function(e) {
                    try {
                        r.setMode(e), r.modeSwitcher.focus();
                    } catch (e) {
                        r._onError(e);
                    }
                })), this.options.search) && (this.searchBox = new Z(this, this.menu)), this.options.navigationBar && (this.navBar = document.createElement("div"), this.navBar.className = "jsoneditor-navigation-bar nav-bar-empty", this.frame.appendChild(this.navBar), this.treePath = new O(this.navBar, this.getPopupAnchor()), this.treePath.onSectionSelected(this._onTreePathSectionSelected.bind(this)), this.treePath.onContextMenuItemSelected(this._onTreePathMenuItemSelected.bind(this)));
            }, t._onUndo = function() {
                this.history && (this.history.undo(), this._onChange());
            }, t._onRedo = function() {
                this.history && (this.history.redo(), this._onChange());
            }, t._onEvent = function(e) {
                if (!T.targetIsColorPicker(e.target)) {
                    var t, n = T.getNodeFromTarget(e.target);
                    if ("keydown" === e.type && this._onKeyDown(e), n && "focus" === e.type && (this.focusTarget = e.target, this.options.autocomplete) && "focus" === this.options.autocomplete.trigger && this._showAutoComplete(e.target), "mousedown" === e.type && this._startDragDistance(e), "mousemove" !== e.type && "mouseup" !== e.type && "click" !== e.type || this._updateDragDistance(e), n && this.options && this.options.navigationBar && n && ("keydown" === e.type || "mousedown" === e.type) && (t = this, setTimeout(function() {
                        t._updateTreePath(n.getNodePath());
                    })), n && n.selected) {
                        if ("click" === e.type) {
                            if (e.target === n.dom.menu) return void this.showContextMenu(e.target);
                            e.hasMoved || this.deselect();
                        }
                        "mousedown" === e.type && T.onDragStart(this.multiselection.nodes, e);
                    } else "mousedown" === e.type && (0, k.hasParentNode)(e.target, this.content) && (this.deselect(), n && e.target === n.dom.drag ? T.onDragStart(n, e) : n && (e.target === n.dom.field || e.target === n.dom.value || e.target === n.dom.select) || this._onMultiSelectStart(e));
                    n && n.onEvent(e);
                }
            }, t._updateTreePath = function(e) {
                var n;
                function i(e) {
                    return e.parent ? "array" === e.parent.type ? e.index : e.field : e.field || e.type;
                }
                e && e.length ? ((0, k.removeClassName)(this.navBar, "nav-bar-empty"), n = [], e.forEach(function(e) {
                    var t = {
                        name: i(e),
                        node: e,
                        children: []
                    };
                    e.childs && e.childs.length && e.childs.forEach(function(e) {
                        t.children.push({
                            name: i(e),
                            node: e
                        });
                    }), n.push(t);
                }), this.treePath.setPath(n)) : (0, k.addClassName)(this.navBar, "nav-bar-empty");
            }, t._onTreePathSectionSelected = function(e) {
                e && e.node && (e.node.expandTo(), e.node.focus());
            }, t._onTreePathMenuItemSelected = function(e, t) {
                e && e.children.length && (e = e.children.find(function(e) {
                    return e.name === t;
                })) && e.node && (this._updateTreePath(e.node.getNodePath()), e.node.expandTo(), e.node.focus());
            }, t._startDragDistance = function(e) {
                this.dragDistanceEvent = {
                    initialTarget: e.target,
                    initialPageX: e.pageX,
                    initialPageY: e.pageY,
                    dragDistance: 0,
                    hasMoved: !1
                };
            }, t._updateDragDistance = function(e) {
                this.dragDistanceEvent || this._startDragDistance(e);
                var t = e.pageX - this.dragDistanceEvent.initialPageX, n = e.pageY - this.dragDistanceEvent.initialPageY;
                return this.dragDistanceEvent.dragDistance = Math.sqrt(t * t + n * n), this.dragDistanceEvent.hasMoved = this.dragDistanceEvent.hasMoved || 10 < this.dragDistanceEvent.dragDistance, e.dragDistance = this.dragDistanceEvent.dragDistance, e.hasMoved = this.dragDistanceEvent.hasMoved, e.dragDistance;
            }, t._onMultiSelectStart = function(e) {
                var t, n = T.getNodeFromTarget(e.target);
                "tree" === this.options.mode && void 0 === this.options.onEditable && (this.multiselection = {
                    start: n || null,
                    end: null,
                    nodes: []
                }, this._startDragDistance(e), (t = this).mousemove || (this.mousemove = (0, k.addEventListener)(e.view, "mousemove", function(e) {
                    t._onMultiSelect(e);
                })), this.mouseup || (this.mouseup = (0, k.addEventListener)(e.view, "mouseup", function(e) {
                    t._onMultiSelectEnd(e);
                })), e.preventDefault());
            }, t._onMultiSelect = function(e) {
                var t;
                e.preventDefault(), this._updateDragDistance(e), e.hasMoved && ((e = T.getNodeFromTarget(e.target)) && (null == this.multiselection.start && (this.multiselection.start = e), this.multiselection.end = e), this.deselect(), e = this.multiselection.start, t = this.multiselection.end || this.multiselection.start, e) && t && (this.multiselection.nodes = this._findTopLevelNodes(e, t), this.multiselection.nodes && this.multiselection.nodes.length && (e = this.multiselection.nodes[0], this.multiselection.start === e || this.multiselection.start.isDescendantOf(e) ? this.multiselection.direction = "down" : this.multiselection.direction = "up"), this.select(this.multiselection.nodes));
            }, t._onMultiSelectEnd = function(e) {
                var t = this.multiselection.nodes[0];
                t && t.dom.menu && t.dom.menu.focus(), this.multiselection.start = null, this.multiselection.end = null, this.mousemove && ((0, k.removeEventListener)(e.view, "mousemove", this.mousemove), delete this.mousemove), this.mouseup && ((0, k.removeEventListener)(e.view, "mouseup", this.mouseup), delete this.mouseup);
            }, t.deselect = function(e) {
                var t = !!this.multiselection.nodes.length;
                this.multiselection.nodes.forEach(function(e) {
                    e.setSelected(!1);
                }), this.multiselection.nodes = [], e && (this.multiselection.start = null, this.multiselection.end = null), t && this._selectionChangedHandler && this._selectionChangedHandler();
            }, t.select = function(e) {
                if (!Array.isArray(e)) return this.select([
                    e
                ]);
                var t;
                e && (this.deselect(), this.multiselection.nodes = e.slice(0), t = e[0], e.forEach(function(e) {
                    e.expandPathToNode(), e.setSelected(!0, e === t);
                }), this._selectionChangedHandler) && (e = this.getSelection(), this._selectionChangedHandler(e.start, e.end));
            }, t._findTopLevelNodes = function(e, t) {
                for(var n = e.getNodePath(), i = t.getNodePath(), o = 0; o < n.length && n[o] === i[o];)o++;
                var r, e = n[o - 1], t = n[o], s = i[o];
                return t && s || (e.parent ? e = (s = t = e).parent : (t = e.childs[0], s = e.childs[e.childs.length - 1])), e && t && s ? (t = e.childs.indexOf(t), s = e.childs.indexOf(s), r = Math.min(t, s), t = Math.max(t, s), e.childs.slice(r, t + 1)) : [];
            }, t._showAutoComplete = function(t) {
                var n, i = T.getNodeFromTarget(t), o = "";
                0 <= t.className.indexOf("jsoneditor-value") && (o = "value"), "" !== (o = 0 <= t.className.indexOf("jsoneditor-field") ? "field" : o) && (n = this, setTimeout(function() {
                    var e;
                    !i || !("focus" === n.options.autocomplete.trigger || 0 < t.innerText.length) || null === (e = n.options.autocomplete.getOptions(t.innerText, i.getPath(), o, i.editor)) ? n.autocomplete.hideDropDown() : "function" == typeof e.then ? e.then(function(e) {
                        null === e ? n.autocomplete.hideDropDown() : e.options ? n.autocomplete.show(t, e.startFrom, e.options) : n.autocomplete.show(t, 0, e);
                    }).catch(function(e) {
                        console.error(e);
                    }) : e.options ? n.autocomplete.show(t, e.startFrom, e.options) : n.autocomplete.show(t, 0, e);
                }, 50));
            }, t._onKeyDown = function(e) {
                var t, n = e.which || e.keyCode, i = e.altKey, o = e.ctrlKey, r = e.metaKey, s = e.shiftKey, a = !1, l = this.focusTarget;
                9 === n && (t = this, setTimeout(function() {
                    t.focusTarget !== l && (0, k.selectContentEditable)(t.focusTarget);
                }, 0)), this.searchBox && (o && 70 === n ? (this.searchBox.dom.search.focus(), this.searchBox.dom.search.select(), a = !0) : (114 === n || o && 71 === n) && (s ? this.searchBox.previous(!0) : this.searchBox.next(!0), a = !0)), this.history && (o && !s && 90 === n ? (this._onUndo(), a = !0) : o && s && 90 === n && (this._onRedo(), a = !0)), !this.options.autocomplete || a || o || i || r || 1 !== e.key.length && 8 !== n && 46 !== n || (a = !1, this._showAutoComplete(e.target)), a && (e.preventDefault(), e.stopPropagation());
            }, t._createTable = function() {
                var e;
                this.options.navigationBar && (0, k.addClassName)(this.contentOuter, "has-nav-bar"), this.scrollableContent = document.createElement("div"), this.scrollableContent.className = "jsoneditor-tree", this.contentOuter.appendChild(this.scrollableContent), this.content = document.createElement("div"), this.content.className = "jsoneditor-tree-inner", this.scrollableContent.appendChild(this.content), this.table = document.createElement("table"), this.table.className = "jsoneditor-tree", this.content.appendChild(this.table), this.colgroupContent = document.createElement("colgroup"), "tree" === this.options.mode && ((e = document.createElement("col")).width = "24px", this.colgroupContent.appendChild(e)), (e = document.createElement("col")).width = "24px", this.colgroupContent.appendChild(e), e = document.createElement("col"), this.colgroupContent.appendChild(e), this.table.appendChild(this.colgroupContent), this.tbody = document.createElement("tbody"), this.table.appendChild(this.tbody), this.frame.appendChild(this.contentOuter);
            }, t.showContextMenu = function(e, t) {
                var n, i = [], o = this.multiselection.nodes.slice();
                i.push({
                    text: (0, l.Iu)("duplicateText"),
                    title: (0, l.Iu)("duplicateTitle"),
                    className: "jsoneditor-duplicate",
                    click: function() {
                        T.onDuplicate(o);
                    }
                }), i.push({
                    text: (0, l.Iu)("remove"),
                    title: (0, l.Iu)("removeTitle"),
                    className: "jsoneditor-remove",
                    click: function() {
                        T.onRemove(o);
                    }
                }), this.options.onCreateMenu && (n = o.map(function(e) {
                    return e.getPath();
                }), i = this.options.onCreateMenu(i, {
                    type: "multiple",
                    path: n[0],
                    paths: n
                })), new s.x(i, {
                    close: t
                }).show(e, this.getPopupAnchor());
            }, t.getPopupAnchor = function() {
                return this.options.popupAnchor || this.frame;
            }, t.getSelection = function() {
                var e, t, n = {
                    start: null,
                    end: null
                };
                return this.multiselection.nodes && this.multiselection.nodes.length && this.multiselection.nodes.length && (e = this.multiselection.nodes[0], t = this.multiselection.nodes[this.multiselection.nodes.length - 1], "down" === this.multiselection.direction ? (n.start = e.serialize(), n.end = t.serialize()) : (n.start = t.serialize(), n.end = e.serialize())), n;
            }, t.onSelectionChange = function(e) {
                "function" == typeof e && (this._selectionChangedHandler = (0, k.debounce)(e, this.DEBOUNCE_INTERVAL));
            }, t.setSelection = function(e, t) {
                e && e.dom && e.range && (console.warn("setSelection/getSelection usage for text selection is deprecated and should not be used, see documentation for supported selection options"), this.setDomSelection(e));
                e = this._getNodeInstancesByRange(e, t);
                e.forEach(function(e) {
                    e.expandTo();
                }), this.select(e);
            }, t._getNodeInstancesByRange = function(e, t) {
                e && e.path && (n = this.node.findNodeByPath(e.path), t) && t.path && (i = this.node.findNodeByPath(t.path));
                var n, i, o = [];
                if (n instanceof T) {
                    if (i instanceof T && i !== n) {
                        if (n.parent === i.parent) {
                            t = n.getIndex() < i.getIndex() ? (e = n, i) : (e = i, n);
                            var r = e;
                            for(o.push(r); r = r.nextSibling(), o.push(r), r && r !== t;);
                        } else o = this._findTopLevelNodes(n, i);
                    } else o.push(n);
                }
                return o;
            }, t.getNodesByRange = function(e, t) {
                var e = this._getNodeInstancesByRange(e, t), n = [];
                return e.forEach(function(e) {
                    n.push(e.serialize());
                }), n;
            }, [
                {
                    mode: "tree",
                    mixin: t,
                    data: "json"
                },
                {
                    mode: "view",
                    mixin: t,
                    data: "json"
                },
                {
                    mode: "form",
                    mixin: t,
                    data: "json"
                }
            ]);
        },
        2744: function(e, t, n) {
            t.tryRequireAjv = function() {
                try {
                    return n(8903);
                } catch (e) {}
            };
        },
        9125: function(e, t, n) {
            t.O = function() {
                try {
                    n(4864);
                } catch (e) {
                    console.error(e);
                }
            };
        },
        9791: function(W, e, t) {
            "use strict";
            t.r(e), t.d(e, {
                addClassName: function() {
                    return P;
                },
                addEventListener: function() {
                    return X;
                },
                asyncExec: function() {
                    return Ie;
                },
                clear: function() {
                    return C;
                },
                compileJSONPointer: function() {
                    return $;
                },
                contains: function() {
                    return Ce;
                },
                debounce: function() {
                    return ne;
                },
                escapeUnicodeChars: function() {
                    return p;
                },
                extend: function() {
                    return f;
                },
                findUniqueName: function() {
                    return ce;
                },
                formatSize: function() {
                    return me;
                },
                get: function() {
                    return N;
                },
                getAbsoluteLeft: function() {
                    return H;
                },
                getAbsoluteTop: function() {
                    return G;
                },
                getChildPaths: function() {
                    return he;
                },
                getColorCSS: function() {
                    return L;
                },
                getIndexForPosition: function() {
                    return re;
                },
                getInnerText: function() {
                    return k;
                },
                getInputSelection: function() {
                    return oe;
                },
                getInternetExplorerVersion: function() {
                    return z;
                },
                getPositionForPath: function() {
                    return se;
                },
                getSelection: function() {
                    return S;
                },
                getSelectionOffset: function() {
                    return D;
                },
                getType: function() {
                    return y;
                },
                getWindow: function() {
                    return A;
                },
                hasParentNode: function() {
                    return j;
                },
                improveSchemaError: function() {
                    return Q;
                },
                insideRect: function() {
                    return te;
                },
                isArray: function() {
                    return b;
                },
                isChildOf: function() {
                    return J;
                },
                isFirefox: function() {
                    return R;
                },
                isObject: function() {
                    return B;
                },
                isPromise: function() {
                    return q;
                },
                isTimestamp: function() {
                    return pe;
                },
                isUrl: function() {
                    return I;
                },
                isValidColor: function() {
                    return ae;
                },
                isValidValidationError: function() {
                    return ee;
                },
                isValidationErrorChanged: function() {
                    return ye;
                },
                limitCharacters: function() {
                    return fe;
                },
                makeFieldTooltip: function() {
                    return le;
                },
                parse: function() {
                    return u;
                },
                parsePath: function() {
                    return _;
                },
                parseString: function() {
                    return ge;
                },
                removeAllClassNames: function() {
                    return F;
                },
                removeClassName: function() {
                    return V;
                },
                removeEventListener: function() {
                    return Y;
                },
                removeReturnsAndSurroundingWhitespace: function() {
                    return E;
                },
                selectContentEditable: function() {
                    return O;
                },
                setEndOfContentEditable: function() {
                    return Z;
                },
                setSelection: function() {
                    return x;
                },
                setSelectionOffset: function() {
                    return K;
                },
                sort: function() {
                    return de;
                },
                sortObjectKeys: function() {
                    return ue;
                },
                stringifyPath: function() {
                    return U;
                },
                stripFormatting: function() {
                    return w;
                },
                textDiff: function() {
                    return ie;
                },
                tryJsonRepair: function() {
                    return g;
                },
                uniqueMergeArrays: function() {
                    return ve;
                },
                validate: function() {
                    return m;
                }
            });
            t(4987);
            var e = t(233), o = t.n(e), n = t(1262), i = t(6589), r = t(7026), s = t(7907);
            function a(e) {
                return function(e) {
                    if (Array.isArray(e)) return l(e);
                }(e) || function(e) {
                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                }(e) || function(e, t) {
                    var n;
                    if (e) return "string" == typeof e ? l(e, t) : "Map" === (n = "Object" === (n = Object.prototype.toString.call(e).slice(8, -1)) && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? l(e, t) : void 0;
                }(e) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function l(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var n = 0, i = new Array(t); n < t; n++)i[n] = e[n];
                return i;
            }
            function c(e) {
                return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            var h = 1e4, d = 9466848e5;
            function u(t) {
                try {
                    return JSON.parse(t);
                } catch (e) {
                    throw m(t), e;
                }
            }
            function g(t) {
                try {
                    return (0, n.K)(t);
                } catch (e) {
                    return t;
                }
            }
            function p(e) {
                return e.replace(/[\u007F-\uFFFF]/g, function(e) {
                    return "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
                });
            }
            function m(e) {
                (void 0 !== i ? i : JSON).parse(e);
            }
            function f(e, t) {
                for(var n in t)M(t, n) && (e[n] = t[n]);
                return e;
            }
            function C(e) {
                for(var t in e)M(e, t) && delete e[t];
                return e;
            }
            function y(e) {
                return null === e ? "null" : void 0 === e ? "undefined" : e instanceof Number || "number" == typeof e ? "number" : e instanceof String || "string" == typeof e ? "string" : e instanceof Boolean || "boolean" == typeof e ? "boolean" : e instanceof RegExp ? "regexp" : b(e) ? "array" : "object";
            }
            var v = /^https?:\/\/\S+$/;
            function I(e) {
                return ("string" == typeof e || e instanceof String) && v.test(e);
            }
            function b(e) {
                return "[object Array]" === Object.prototype.toString.call(e);
            }
            function A(e) {
                return e.ownerDocument.defaultView;
            }
            function H(e) {
                return e.getBoundingClientRect().left + window.pageXOffset || document.scrollLeft || 0;
            }
            function G(e) {
                return e.getBoundingClientRect().top + window.pageYOffset || document.scrollTop || 0;
            }
            function P(e, t) {
                var n = e.className.split(" ");
                -1 === n.indexOf(t) && (n.push(t), e.className = n.join(" "));
            }
            function F(e) {
                e.className = "";
            }
            function V(e, t) {
                var n = e.className.split(" "), t = n.indexOf(t);
                -1 !== t && (n.splice(t, 1), e.className = n.join(" "));
            }
            function w(e) {
                for(var t = e.childNodes, n = 0, i = t.length; n < i; n++){
                    var o = t[n], r = (o.style && o.removeAttribute("style"), o.attributes);
                    if (r) for(var s = r.length - 1; 0 <= s; s--){
                        var a = r[s];
                        !0 === a.specified && o.removeAttribute(a.name);
                    }
                    w(o);
                }
            }
            function Z(e) {
                var t;
                document.createRange && ((t = document.createRange()).selectNodeContents(e), t.collapse(!1), (e = window.getSelection()).removeAllRanges(), e.addRange(t));
            }
            function O(e) {
                var t;
                e && "DIV" === e.nodeName && window.getSelection && document.createRange && ((t = document.createRange()).selectNodeContents(e), (e = window.getSelection()).removeAllRanges(), e.addRange(t));
            }
            function S() {
                if (window.getSelection) {
                    var e = window.getSelection();
                    if (e.getRangeAt && e.rangeCount) return e.getRangeAt(0);
                }
                return null;
            }
            function x(e) {
                var t;
                e && window.getSelection && ((t = window.getSelection()).removeAllRanges(), t.addRange(e));
            }
            function D() {
                var e = S();
                return e && "startOffset" in e && "endOffset" in e && e.startContainer && e.startContainer === e.endContainer ? {
                    startOffset: e.startOffset,
                    endOffset: e.endOffset,
                    container: e.startContainer.parentNode
                } : null;
            }
            function K(e) {
                var t;
                document.createRange && window.getSelection && window.getSelection() && (t = document.createRange(), e.container.firstChild || e.container.appendChild(document.createTextNode("")), t.setStart(e.container.firstChild, e.startOffset), t.setEnd(e.container.firstChild, e.endOffset), x(t));
            }
            function k(e, t) {
                var n;
                if (void 0 === t && (t = {
                    _text: "",
                    flush: function() {
                        var e = this._text;
                        return this._text = "", e;
                    },
                    set: function(e) {
                        this._text = e;
                    }
                }), e.nodeValue) return "" !== (n = E(e.nodeValue)) ? t.flush() + n : "";
                if (e.hasChildNodes()) {
                    for(var i = e.childNodes, o = "", r = 0, s = i.length; r < s; r++){
                        var a, l = i[r];
                        "DIV" === l.nodeName || "P" === l.nodeName ? ((a = (a = i[r - 1]) ? a.nodeName : void 0) && "DIV" !== a && "P" !== a && "BR" !== a && ("" !== o && (o += "\n"), t.flush()), o += k(l, t), t.set("\n")) : "BR" === l.nodeName ? (o += t.flush(), t.set("\n")) : o += k(l, t);
                    }
                    return o;
                }
                return "";
            }
            function E(e) {
                return e.replace(/(\b|^)\s*(\b|$)/g, function(e) {
                    return /\n/.exec(e) ? "" : e;
                });
            }
            function j(e, t) {
                for(var n = e ? e.parentNode : void 0; n;){
                    if (n === t) return !0;
                    n = n.parentNode;
                }
                return !1;
            }
            function z() {
                var e;
                return -1 === T && (e = -1, "undefined" != typeof navigator && "Microsoft Internet Explorer" === navigator.appName && null != /MSIE ([0-9]+[.0-9]+)/.exec(navigator.userAgent) && (e = parseFloat(RegExp.$1)), T = e), T;
            }
            var T = -1;
            function R() {
                return "undefined" != typeof navigator && -1 !== navigator.userAgent.indexOf("Firefox");
            }
            function X(e, t, n, i) {
                return e.addEventListener ? (void 0 === i && (i = !1), "mousewheel" === t && R() && (t = "DOMMouseScroll"), e.addEventListener(t, n, i), n) : e.attachEvent ? (e.attachEvent("on" + t, i = function() {
                    return n.call(e, window.event);
                }), i) : void 0;
            }
            function Y(e, t, n, i) {
                e.removeEventListener ? (void 0 === i && (i = !1), "mousewheel" === t && R() && (t = "DOMMouseScroll"), e.removeEventListener(t, n, i)) : e.detachEvent && e.detachEvent("on" + t, n);
            }
            function J(e, t) {
                for(var n = e.parentNode; n;){
                    if (n === t) return !0;
                    n = n.parentNode;
                }
                return !1;
            }
            function _(n) {
                var e = [], i = 0;
                function t(e) {
                    for(var t = ""; void 0 !== n[i] && n[i] !== e;)t += n[i], i++;
                    if (n[i] !== e) throw new Error("Invalid JSON path: unexpected end, character " + e + " expected");
                    return t;
                }
                for(; void 0 !== n[i];)if ("." === n[i]) i++, e.push(function() {
                    for(var e = ""; void 0 !== n[i] && /[\w$]/.test(n[i]);)e += n[i], i++;
                    if ("" === e) throw new Error("Invalid JSON path: property name expected at index " + i);
                    return e;
                }());
                else {
                    if ("[" !== n[i]) throw new Error('Invalid JSON path: unexpected character "' + n[i] + '" at index ' + i);
                    if ("'" === n[++i] || '"' === n[i]) {
                        var o = n[i];
                        if (i++, e.push(t(o)), n[i] !== o) throw new Error("Invalid JSON path: closing quote ' expected at index " + i);
                        i++;
                    } else {
                        o = t("]").trim();
                        if (0 === o.length) throw new Error("Invalid JSON path: array value expected at index " + i);
                        o = "*" === o ? o : JSON.parse(o), e.push(o);
                    }
                    if ("]" !== n[i]) throw new Error("Invalid JSON path: closing bracket ] expected at index " + i);
                    i++;
                }
                return e;
            }
            function U(e) {
                return e.map(function(e) {
                    return "number" == typeof e ? "[" + e + "]" : "string" == typeof e && e.match(/^[A-Za-z0-9_$]+$/) ? "." + e : '["' + e + '"]';
                }).join("");
            }
            function Q(e) {
                var t, n;
                return "enum" === e.keyword && Array.isArray(e.schema) && (n = e.schema) && (5 < (n = n.map(function(e) {
                    return JSON.stringify(e);
                })).length && (t = [
                    "(" + (n.length - 5) + " more...)"
                ], (n = n.slice(0, 5)).push(t)), e.message = "should be equal to one of: " + n.join(", ")), "additionalProperties" === e.keyword && (e.message = "should NOT have additional property: " + e.params.additionalProperty), e;
            }
            function q(e) {
                return e && "function" == typeof e.then && "function" == typeof e.catch;
            }
            function ee(e) {
                return "object" === c(e) && Array.isArray(e.path) && "string" == typeof e.message;
            }
            function te(e, t, n) {
                n = void 0 !== n ? n : 0;
                return t.left - n >= e.left && t.right + n <= e.right && t.top - n >= e.top && t.bottom + n <= e.bottom;
            }
            function ne(i, o, r) {
                var s;
                return function() {
                    var e = this, t = arguments, n = r && !s;
                    clearTimeout(s), s = setTimeout(function() {
                        s = null, r || i.apply(e, t);
                    }, o), n && i.apply(e, t);
                };
            }
            function ie(e, t) {
                for(var n = t.length, i = 0, o = e.length, r = t.length; t.charAt(i) === e.charAt(i) && i < n;)i++;
                for(; t.charAt(r - 1) === e.charAt(o - 1) && i < r && 0 < o;)r--, o--;
                return {
                    start: i,
                    end: r
                };
            }
            function oe(t) {
                var e, n, i, o, r = 0, s = 0;
                return "number" == typeof t.selectionStart && "number" == typeof t.selectionEnd ? (r = t.selectionStart, s = t.selectionEnd) : (o = document.selection.createRange()) && o.parentElement() === t && (i = t.value.length, e = t.value.replace(/\r\n/g, "\n"), (n = t.createTextRange()).moveToBookmark(o.getBookmark()), (o = t.createTextRange()).collapse(!1), -1 < n.compareEndPoints("StartToEnd", o) ? r = s = i : (r = -n.moveStart("character", -i), r += e.slice(0, r).split("\n").length - 1, -1 < n.compareEndPoints("EndToEnd", o) ? s = i : (s = -n.moveEnd("character", -i), s += e.slice(0, s).split("\n").length - 1))), {
                    startIndex: r,
                    endIndex: s,
                    start: a(r),
                    end: a(s)
                };
                function a(e) {
                    e = t.value.substring(0, e);
                    return {
                        row: (e.match(/\n/g) || []).length + 1,
                        column: e.length - e.lastIndexOf("\n")
                    };
                }
            }
            function re(e, t, n) {
                var e = e.value || "";
                return 0 < t && 0 < n ? (e = e.split("\n", t), t = Math.min(e.length, t), n = Math.min(e[t - 1].length, n - 1), n = 1 === t ? n : n + 1, e.slice(0, t - 1).join("\n").length + n) : -1;
            }
            function se(e, t) {
                var n, i = [];
                if (t && t.length) {
                    try {
                        n = r.parse(e);
                    } catch (e) {
                        return i;
                    }
                    t.forEach(function(e) {
                        var t = $(_(e)), t = n.pointers[t];
                        t && i.push({
                            path: e,
                            line: t.key ? t.key.line : t.value ? t.value.line : 0,
                            column: t.key ? t.key.column : t.value ? t.value.column : 0
                        });
                    });
                }
                return i;
            }
            function $(e) {
                return e.map(function(e) {
                    return "/" + String(e).replace(/~/g, "~0").replace(/\//g, "~1");
                }).join("");
            }
            function L(e) {
                var t = document.createElement("div");
                return t.style.color = e, t.style.color.split(/\s+/).join("").toLowerCase() || null;
            }
            function ae(e) {
                return !!L(e);
            }
            function le(n, e) {
                var i;
                return n ? (i = "", n.title && (i += n.title), n.description && (0 < i.length && (i += "\n"), i += n.description), n.default && (0 < i.length && (i += "\n\n"), i = (i += (0, s.Iu)("default", void 0, e) + "\n") + JSON.stringify(n.default, null, 2)), Array.isArray(n.examples) && 0 < n.examples.length && (0 < i.length && (i += "\n\n"), i += (0, s.Iu)("examples", void 0, e) + "\n", n.examples.forEach(function(e, t) {
                    i += JSON.stringify(e, null, 2), t !== n.examples.length - 1 && (i += "\n");
                })), i) : "";
            }
            function N(e, t) {
                for(var n = e, i = 0; i < t.length && null != n; i++)n = n[t[i]];
                return n;
            }
            function ce(e, t) {
                for(var n = e.replace(/ \(copy( \d+)?\)$/, ""), i = n, o = 1; -1 !== t.indexOf(i);){
                    i = n + " (" + ("copy" + (1 < o ? " " + o : "")) + ")";
                    o++;
                }
                return i;
            }
            function he(e, t) {
                var n = {};
                if (Array.isArray(e)) for(var i = Math.min(e.length, h), o = 0; o < i; o++)!function t(n, i, o, r) {
                    (Array.isArray(n) || B(n)) && !r || (i[o || ""] = !0), B(n) && Object.keys(n).forEach(function(e) {
                        t(n[e], i, o + "." + e, r);
                    });
                }(e[o], n, "", t);
                else n[""] = !0;
                return Object.keys(n).sort();
            }
            function de(e, t, n) {
                var i = t && "." !== t ? _(t) : [], o = "desc" === n ? -1 : 1, t = e.slice();
                return t.sort(function(e, t) {
                    e = N(e, i), t = N(t, i);
                    return o * (t < e ? 1 : e < t ? -1 : 0);
                }), t;
            }
            function ue(t, e) {
                var n = "desc" === e ? -1 : 1, e = Object.keys(t).sort(function(e, t) {
                    return n * o()(e, t);
                }), i = {};
                return e.forEach(function(e) {
                    i[e] = t[e];
                }), i;
            }
            function ge(e) {
                var t, n;
                return "" === e ? "" : "null" === (t = e.toLowerCase()) ? null : "true" === t || "false" !== t && (t = Number(e), n = parseFloat(e), isNaN(t) || isNaN(n) ? e : t);
            }
            function pe(e, t) {
                return "number" == typeof t && d < t && isFinite(t) && Math.floor(t) === t && !isNaN(new Date(t).valueOf());
            }
            function me(e) {
                return e < 900 ? e.toFixed() + " B" : (e = e / 1e3) < 900 ? e.toFixed(1) + " KB" : (e = e / 1e3) < 900 ? e.toFixed(1) + " MB" : (e = e / 1e3) < 900 ? e.toFixed(1) + " GB" : (e / 1e3).toFixed(1) + " TB";
            }
            function fe(e, t) {
                return e.length <= t ? e : e.slice(0, t) + "...";
            }
            function B(e) {
                return "object" === c(e) && null !== e && !Array.isArray(e);
            }
            function Ce(e, t) {
                return -1 !== e.indexOf(t);
            }
            function ye(n, i) {
                if (i || n) {
                    if (i && !n || !i && n) return !0;
                    if (i.length !== n.length) return !0;
                    for(var e = 0; e < n.length; ++e){
                        var t = function(t) {
                            var e = "error" === n[t].type ? i.find(function(e) {
                                return e.line === n[t].line;
                            }) : i.find(function(e) {
                                return e.dataPath === n[t].dataPath && e.schemaPath === n[t].schemaPath;
                            });
                            if (!e) return {
                                v: !0
                            };
                        }(e);
                        if ("object" === c(t)) return t.v;
                    }
                }
                return !1;
            }
            function ve(e, t) {
                e = null != e && e.length ? e : [], t = null != t && t.length ? t : [];
                return a(new Set(e.concat(t)));
            }
            function Ie(e) {
                setTimeout(e);
            }
            function M(e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
            }
        },
        8037: function(e, t, n) {
            var i;
            if (window.Picker) i = window.Picker;
            else try {
                i = n(4049);
            } catch (e) {}
            e.exports = i;
        },
        6225: function(n, e, C) {
            function l(e, n) {
                var t, i;
                return n = a(e, n), (e = r.modules[n]) || ("function" == typeof (e = r.payloads[n]) && (t = {
                    id: n,
                    uri: "",
                    exports: i = {},
                    packaged: !0
                }, i = e(function(e, t) {
                    return s(n, e, t);
                }, i, t) || t.exports, r.modules[n] = i, delete r.payloads[n]), e = r.modules[n] = i || e), e;
            }
            var t, i, o, r, s, c, a;
            n = C.nmd(n), (o = function() {
                return this;
            }()) || "undefined" == typeof window || (o = window), (r = function(e, t, n) {
                "string" != typeof e ? r.original ? r.original.apply(this, arguments) : (console.error("dropping module because define wasn't a string."), console.trace()) : (2 == arguments.length && (n = t), r.modules[e] || (r.payloads[e] = n, r.modules[e] = null));
            }).modules = {}, r.payloads = {}, s = function(e, t, n) {
                if ("string" == typeof t) {
                    var i = l(e, t);
                    if (null != i) return n && n(), i;
                } else if ("[object Array]" === Object.prototype.toString.call(t)) {
                    for(var o = [], r = 0, s = t.length; r < s; ++r){
                        var a = l(e, t[r]);
                        if (null == a && c.original) return;
                        o.push(a);
                    }
                    return n && n.apply(null, o) || !0;
                }
            }, c = function(e, t) {
                var n = s("", e, t);
                return null == n && c.original ? c.original.apply(this, arguments) : n;
            }, a = function(e, t) {
                var n;
                if (-1 !== t.indexOf("!")) return n = t.split("!"), a(e, n[0]) + "!" + a(e, n[1]);
                if ("." == t.charAt(0)) for(t = e.split("/").slice(0, -1).join("/") + "/" + t; -1 !== t.indexOf(".") && i != t;){
                    var i = t;
                    t = t.replace(/\/\.\//, "/").replace(/[^\/]+\/\.\.\//, "");
                }
                return t;
            }, i = o, t = "ace", o[t] || (o[t] = {}), i = o[t], i.define && i.define.packaged || (r.original = i.define, i.define = r, i.define.packaged = !0), i.require && i.require.packaged || (c.original = i.require, i.require = c, i.require.packaged = !0), ace.define("ace/lib/es6-shim", [
                "require",
                "exports",
                "module"
            ], function(e, t, n) {
                function i(e, t, n) {
                    Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    });
                }
                String.prototype.startsWith || i(String.prototype, "startsWith", function(e, t) {
                    return this.lastIndexOf(e, t = t || 0) === t;
                }), String.prototype.endsWith || i(String.prototype, "endsWith", function(e, t) {
                    (void 0 === t || t > this.length) && (t = this.length), t -= e.length;
                    e = this.indexOf(e, t);
                    return -1 !== e && e === t;
                }), String.prototype.repeat || i(String.prototype, "repeat", function(e) {
                    for(var t = "", n = this; 0 < e;)1 & e && (t += n), (e >>= 1) && (n += n);
                    return t;
                }), String.prototype.includes || i(String.prototype, "includes", function(e, t) {
                    return -1 != this.indexOf(e, t);
                }), Object.assign || (Object.assign = function(e) {
                    if (null == e) throw new TypeError("Cannot convert undefined or null to object");
                    for(var t = Object(e), n = 1; n < arguments.length; n++){
                        var i = arguments[n];
                        null != i && Object.keys(i).forEach(function(e) {
                            t[e] = i[e];
                        });
                    }
                    return t;
                }), Object.values || (Object.values = function(t) {
                    return Object.keys(t).map(function(e) {
                        return t[e];
                    });
                }), Array.prototype.find || i(Array.prototype, "find", function(e) {
                    for(var t = this.length, n = arguments[1], i = 0; i < t; i++){
                        var o = this[i];
                        if (e.call(n, o, i, this)) return o;
                    }
                }), Array.prototype.findIndex || i(Array.prototype, "findIndex", function(e) {
                    for(var t = this.length, n = arguments[1], i = 0; i < t; i++){
                        var o = this[i];
                        if (e.call(n, o, i, this)) return i;
                    }
                }), Array.prototype.includes || i(Array.prototype, "includes", function(e, t) {
                    return -1 != this.indexOf(e, t);
                }), Array.prototype.fill || i(Array.prototype, "fill", function(e) {
                    for(var t = this.length >>> 0, n = arguments[1] >> 0, i = n < 0 ? Math.max(t + n, 0) : Math.min(n, t), n = arguments[2], n = void 0 === n ? t : n >> 0, o = n < 0 ? Math.max(t + n, 0) : Math.min(n, t); i < o;)this[i] = e, i++;
                    return this;
                }), Array.of || i(Array, "of", function() {
                    return Array.prototype.slice.call(arguments);
                });
            }), ace.define("ace/lib/fixoldbrowsers", [
                "require",
                "exports",
                "module",
                "ace/lib/es6-shim"
            ], function(e, t, n) {
                "use strict";
                e("./es6-shim");
            }), ace.define("ace/lib/lang", [
                "require",
                "exports",
                "module"
            ], function(e, t, n) {
                "use strict";
                t.last = function(e) {
                    return e[e.length - 1];
                }, t.stringReverse = function(e) {
                    return e.split("").reverse().join("");
                }, t.stringRepeat = function(e, t) {
                    for(var n = ""; 0 < t;)1 & t && (n += e), (t >>= 1) && (e += e);
                    return n;
                };
                var i = /^\s\s*/, o = /\s\s*$/;
                t.stringTrimLeft = function(e) {
                    return e.replace(i, "");
                }, t.stringTrimRight = function(e) {
                    return e.replace(o, "");
                }, t.copyObject = function(e) {
                    var t, n = {};
                    for(t in e)n[t] = e[t];
                    return n;
                }, t.copyArray = function(e) {
                    for(var t = [], n = 0, i = e.length; n < i; n++)e[n] && "object" == typeof e[n] ? t[n] = this.copyObject(e[n]) : t[n] = e[n];
                    return t;
                }, t.deepCopy = function e(t) {
                    if ("object" != typeof t || !t) return t;
                    if (Array.isArray(t)) for(var n = [], i = 0; i < t.length; i++)n[i] = e(t[i]);
                    else {
                        if ("[object Object]" !== Object.prototype.toString.call(t)) return t;
                        for(var i in n = {}, t)n[i] = e(t[i]);
                    }
                    return n;
                }, t.arrayToMap = function(e) {
                    for(var t = {}, n = 0; n < e.length; n++)t[e[n]] = 1;
                    return t;
                }, t.createMap = function(e) {
                    var t, n = Object.create(null);
                    for(t in e)n[t] = e[t];
                    return n;
                }, t.arrayRemove = function(e, t) {
                    for(var n = 0; n <= e.length; n++)t === e[n] && e.splice(n, 1);
                }, t.escapeRegExp = function(e) {
                    return e.replace(/([.*+?^${}()|[\]\/\\])/g, "\\$1");
                }, t.escapeHTML = function(e) {
                    return ("" + e).replace(/&/g, "&#38;").replace(/"/g, "&#34;").replace(/'/g, "&#39;").replace(/</g, "&#60;");
                }, t.getMatchOffsets = function(e, t) {
                    var n = [];
                    return e.replace(t, function(e) {
                        n.push({
                            offset: arguments[arguments.length - 2],
                            length: e.length
                        });
                    }), n;
                }, t.deferredCall = function(e) {
                    function t() {
                        i = null, e();
                    }
                    function n(e) {
                        return n.cancel(), i = setTimeout(t, e || 0), n;
                    }
                    var i = null;
                    return (n.schedule = n).call = function() {
                        return this.cancel(), e(), n;
                    }, n.cancel = function() {
                        return clearTimeout(i), i = null, n;
                    }, n.isPending = function() {
                        return i;
                    }, n;
                }, t.delayedCall = function(e, t) {
                    function n() {
                        o = null, e();
                    }
                    function i(e) {
                        null == o && (o = setTimeout(n, e || t));
                    }
                    var o = null;
                    return i.delay = function(e) {
                        o && clearTimeout(o), o = setTimeout(n, e || t);
                    }, (i.schedule = i).call = function() {
                        this.cancel(), e();
                    }, i.cancel = function() {
                        o && clearTimeout(o), o = null;
                    }, i.isPending = function() {
                        return o;
                    }, i;
                };
            }), ace.define("ace/lib/useragent", [
                "require",
                "exports",
                "module"
            ], function(e, t, n) {
                "use strict";
                t.OS = {
                    LINUX: "LINUX",
                    MAC: "MAC",
                    WINDOWS: "WINDOWS"
                }, t.getOS = function() {
                    return t.isMac ? t.OS.MAC : t.isLinux ? t.OS.LINUX : t.OS.WINDOWS;
                };
                var i = "object" == typeof navigator ? navigator : {}, o = (/mac|win|linux/i.exec(i.platform) || [
                    "other"
                ])[0].toLowerCase(), r = i.userAgent || "", i = i.appName || "";
                t.isWin = "win" == o, t.isMac = "mac" == o, t.isLinux = "linux" == o, t.isIE = "Microsoft Internet Explorer" == i || 0 <= i.indexOf("MSAppHost") ? parseFloat((r.match(/(?:MSIE |Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/) || [])[1]) : parseFloat((r.match(/(?:Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/) || [])[1]), t.isOldIE = t.isIE && t.isIE < 9, t.isGecko = t.isMozilla = r.match(/ Gecko\/\d+/), t.isOpera = "object" == typeof opera && "[object Opera]" == Object.prototype.toString.call(window.opera), t.isWebKit = parseFloat(r.split("WebKit/")[1]) || void 0, t.isChrome = parseFloat(r.split(" Chrome/")[1]) || void 0, t.isEdge = parseFloat(r.split(" Edge/")[1]) || void 0, t.isAIR = 0 <= r.indexOf("AdobeAIR"), t.isAndroid = 0 <= r.indexOf("Android"), t.isChromeOS = 0 <= r.indexOf(" CrOS "), t.isIOS = /iPad|iPhone|iPod/.test(r) && !window.MSStream, t.isIOS && (t.isMac = !0), t.isMobile = t.isIOS || t.isAndroid;
            }), ace.define("ace/lib/dom", [
                "require",
                "exports",
                "module",
                "ace/lib/useragent"
            ], function(e, r, t) {
                "use strict";
                var s, n, e = e("./useragent"), a = (r.buildDom = function e(t, n, i) {
                    if ("string" == typeof t && t) return c = document.createTextNode(t), n && n.appendChild(c), c;
                    if (!Array.isArray(t)) return t && t.appendChild && n && n.appendChild(t), t;
                    if ("string" != typeof t[0] || !t[0]) {
                        for(var o = [], r = 0; r < t.length; r++){
                            var s = e(t[r], n, i);
                            s && o.push(s);
                        }
                        return o;
                    }
                    for(var a = document.createElement(t[0]), l = t[1], c = 1, r = c = l && "object" == typeof l && !Array.isArray(l) ? 2 : c; r < t.length; r++)e(t[r], a, i);
                    return 2 == c && Object.keys(l).forEach(function(e) {
                        var t = l[e];
                        "class" === e ? a.className = Array.isArray(t) ? t.join(" ") : t : "function" == typeof t || "value" == e || "$" == e[0] ? a[e] = t : "ref" === e ? i && (i[t] = a) : "style" === e ? "string" == typeof t && (a.style.cssText = t) : null != t && a.setAttribute(e, t);
                    }), n && n.appendChild(a), a;
                }, r.getDocumentHead = function(e) {
                    return (e = e || document).head || e.getElementsByTagName("head")[0] || e.documentElement;
                }, r.createElement = function(e, t) {
                    return document.createElementNS ? document.createElementNS(t || "http://www.w3.org/1999/xhtml", e) : document.createElement(e);
                }, r.removeChildren = function(e) {
                    e.innerHTML = "";
                }, r.createTextNode = function(e, t) {
                    return (t ? t.ownerDocument : document).createTextNode(e);
                }, r.createFragment = function(e) {
                    return (e ? e.ownerDocument : document).createDocumentFragment();
                }, r.hasCssClass = function(e, t) {
                    return -1 !== (e.className + "").split(/\s+/g).indexOf(t);
                }, r.addCssClass = function(e, t) {
                    r.hasCssClass(e, t) || (e.className += " " + t);
                }, r.removeCssClass = function(e, t) {
                    for(var n = e.className.split(/\s+/g);;){
                        var i = n.indexOf(t);
                        if (-1 == i) break;
                        n.splice(i, 1);
                    }
                    e.className = n.join(" ");
                }, r.toggleCssClass = function(e, t) {
                    for(var n = e.className.split(/\s+/g), i = !0;;){
                        var o = n.indexOf(t);
                        if (-1 == o) break;
                        i = !1, n.splice(o, 1);
                    }
                    return i && n.push(t), e.className = n.join(" "), i;
                }, r.setCssClass = function(e, t, n) {
                    n ? r.addCssClass(e, t) : r.removeCssClass(e, t);
                }, r.hasCssString = function(e, t) {
                    var n, i = 0;
                    if (n = (t = t || document).querySelectorAll("style")) {
                        for(; i < n.length;)if (n[i++].id === e) return !0;
                    }
                }, r.removeElementById = function(e, t) {
                    (t = t || document).getElementById(e) && t.getElementById(e).remove();
                }, []);
                function l() {
                    var e = a;
                    a = null, e && e.forEach(function(e) {
                        i(e[0], e[1]);
                    });
                }
                function i(e, t, n) {
                    if ("undefined" != typeof document) {
                        if (a) {
                            if (n) l();
                            else if (!1 === n) return a.push([
                                e,
                                t
                            ]);
                        }
                        if (!s) {
                            var i = n, n = (i = n && n.getRootNode && (i = n.getRootNode()) && i != n ? i : document).ownerDocument || i;
                            if (t && r.hasCssString(t, i)) return null;
                            t && (e += "\n/*# sourceURL=ace/css/" + t + " */");
                            var o = r.createElement("style");
                            o.appendChild(n.createTextNode(e)), t && (o.id = t), (i = i == n ? r.getDocumentHead(n) : i).insertBefore(o, i.firstChild);
                        }
                    }
                }
                r.useStrictCSP = function(e) {
                    0 == (s = e) ? l() : a = a || [];
                }, r.importCssString = i, r.importCssStylsheet = function(e, t) {
                    r.buildDom([
                        "link",
                        {
                            rel: "stylesheet",
                            href: e
                        }
                    ], r.getDocumentHead(t));
                }, r.scrollbarWidth = function(e) {
                    var t = r.createElement("ace_inner"), n = (t.style.width = "100%", t.style.minWidth = "0px", t.style.height = "200px", t.style.display = "block", r.createElement("ace_outer")), i = n.style, e = (i.position = "absolute", i.left = "-10000px", i.overflow = "hidden", i.width = "200px", i.minWidth = "0px", i.height = "150px", i.display = "block", n.appendChild(t), e && e.documentElement || document && document.documentElement);
                    if (!e) return 0;
                    e.appendChild(n);
                    var o = t.offsetWidth, i = (i.overflow = "scroll", t.offsetWidth);
                    return o === i && (i = n.clientWidth), e.removeChild(n), o - i;
                }, r.computedStyle = function(e, t) {
                    return window.getComputedStyle(e, "") || {};
                }, r.setStyle = function(e, t, n) {
                    e[t] !== n && (e[t] = n);
                }, r.HAS_CSS_ANIMATION = !1, r.HAS_CSS_TRANSFORMS = !1, r.HI_DPI = !e.isWin || "undefined" != typeof window && 1.5 <= window.devicePixelRatio, e.isChromeOS && (r.HI_DPI = !1), "undefined" != typeof document && (n = document.createElement("div"), r.HI_DPI && void 0 !== n.style.transform && (r.HAS_CSS_TRANSFORMS = !0), e.isEdge || void 0 === n.style.animationName || (r.HAS_CSS_ANIMATION = !0), n = null), r.HAS_CSS_TRANSFORMS ? r.translate = function(e, t, n) {
                    e.style.transform = "translate(" + Math.round(t) + "px, " + Math.round(n) + "px)";
                } : r.translate = function(e, t, n) {
                    e.style.top = Math.round(n) + "px", e.style.left = Math.round(t) + "px";
                };
            }), ace.define("ace/lib/net", [
                "require",
                "exports",
                "module",
                "ace/lib/dom"
            ], function(e, t, n) {
                /*
 * based on code from:
 *
 * @license RequireJS text 0.25.0 Copyright (c) 2010-2011, The Dojo Foundation All Rights Reserved.
 * Available via the MIT or new BSD license.
 * see: http://github.com/jrburke/requirejs for details
 */ "use strict";
                var o = e("./dom");
                t.get = function(e, t) {
                    var n = new XMLHttpRequest;
                    n.open("GET", e, !0), n.onreadystatechange = function() {
                        4 === n.readyState && t(n.responseText);
                    }, n.send(null);
                }, t.loadScript = function(e, n) {
                    var t = o.getDocumentHead(), i = document.createElement("script");
                    i.src = e, t.appendChild(i), i.onload = i.onreadystatechange = function(e, t) {
                        !t && i.readyState && "loaded" != i.readyState && "complete" != i.readyState || (i = i.onload = i.onreadystatechange = null, t) || n();
                    };
                }, t.qualifyURL = function(e) {
                    var t = document.createElement("a");
                    return t.href = e, t.href;
                };
            }), ace.define("ace/lib/oop", [
                "require",
                "exports",
                "module"
            ], function(e, n, t) {
                "use strict";
                n.inherits = function(e, t) {
                    e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    });
                }, n.mixin = function(e, t) {
                    for(var n in t)e[n] = t[n];
                    return e;
                }, n.implement = function(e, t) {
                    n.mixin(e, t);
                };
            }), ace.define("ace/lib/event_emitter", [
                "require",
                "exports",
                "module"
            ], function(e, t, n) {
                "use strict";
                function r() {
                    this.propagationStopped = !0;
                }
                function s() {
                    this.defaultPrevented = !0;
                }
                var i = {};
                i._emit = i._dispatchEvent = function(e, t) {
                    this._eventRegistry || (this._eventRegistry = {}), this._defaultHandlers || (this._defaultHandlers = {});
                    var n = this._eventRegistry[e] || [], i = this._defaultHandlers[e];
                    if (n.length || i) {
                        (t = "object" == typeof t && t ? t : {}).type || (t.type = e), t.stopPropagation || (t.stopPropagation = r), t.preventDefault || (t.preventDefault = s);
                        for(var n = n.slice(), o = 0; o < n.length && (n[o](t, this), !t.propagationStopped); o++);
                        return i && !t.defaultPrevented ? i(t, this) : void 0;
                    }
                }, i._signal = function(e, t) {
                    if (n = (this._eventRegistry || {})[e]) for(var n = n.slice(), i = 0; i < n.length; i++)n[i](t, this);
                }, i.once = function(t, n) {
                    var i = this;
                    if (this.on(t, function e() {
                        i.off(t, e), n.apply(null, arguments);
                    }), !n) return new Promise(function(e) {
                        n = e;
                    });
                }, i.setDefaultHandler = function(e, t) {
                    var n, i, o = this._defaultHandlers;
                    (o = o || (this._defaultHandlers = {
                        _disabled_: {}
                    }))[e] && (i = o[e], (n = o._disabled_[e]) || (o._disabled_[e] = n = []), n.push(i), -1 != (i = n.indexOf(t))) && n.splice(i, 1), o[e] = t;
                }, i.removeDefaultHandler = function(e, t) {
                    var n, i = this._defaultHandlers;
                    i && (n = i._disabled_[e], i[e] == t ? n && this.setDefaultHandler(e, n.pop()) : n && -1 != (i = n.indexOf(t)) && n.splice(i, 1));
                }, i.on = i.addEventListener = function(e, t, n) {
                    this._eventRegistry = this._eventRegistry || {};
                    var i = this._eventRegistry[e];
                    return -1 == (i = i || (this._eventRegistry[e] = [])).indexOf(t) && i[n ? "unshift" : "push"](t), t;
                }, i.off = i.removeListener = i.removeEventListener = function(e, t) {
                    this._eventRegistry = this._eventRegistry || {};
                    e = this._eventRegistry[e];
                    e && -1 !== (t = e.indexOf(t)) && e.splice(t, 1);
                }, i.removeAllListeners = function(e) {
                    e || (this._eventRegistry = this._defaultHandlers = void 0), this._eventRegistry && (this._eventRegistry[e] = void 0), this._defaultHandlers && (this._defaultHandlers[e] = void 0);
                }, t.EventEmitter = i;
            }), ace.define("ace/lib/app_config", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/event_emitter"
            ], function(e, t, n) {
                var i, o = e("./oop"), e = e("./event_emitter").EventEmitter, r = {
                    setOptions: function(t) {
                        Object.keys(t).forEach(function(e) {
                            this.setOption(e, t[e]);
                        }, this);
                    },
                    getOptions: function(e) {
                        var t, n = {};
                        return e ? Array.isArray(e) || (n = e, e = Object.keys(n)) : (t = this.$options, e = Object.keys(t).filter(function(e) {
                            return !t[e].hidden;
                        })), e.forEach(function(e) {
                            n[e] = this.getOption(e);
                        }, this), n;
                    },
                    setOption: function(e, t) {
                        var n;
                        if (this["$" + e] !== t) return (n = this.$options[e]) ? n.forwardTo ? this[n.forwardTo] && this[n.forwardTo].setOption(e, t) : (n.handlesSet || (this["$" + e] = t), void (n && n.set && n.set.call(this, t))) : s('misspelled option "' + e + '"');
                    },
                    getOption: function(e) {
                        var t = this.$options[e];
                        return t ? t.forwardTo ? this[t.forwardTo] && this[t.forwardTo].getOption(e) : t && t.get ? t.get.call(this) : this["$" + e] : s('misspelled option "' + e + '"');
                    }
                };
                function s(e) {
                    "undefined" != typeof console && console.warn && console.warn.apply(console, arguments);
                }
                l.prototype.defineOptions = function(n, e, i) {
                    return n.$options || (this.$defaultOptions[e] = n.$options = {}), Object.keys(i).forEach(function(e) {
                        var t = i[e];
                        (t = "string" == typeof t ? {
                            forwardTo: t
                        } : t).name || (t.name = e), "initialValue" in (n.$options[t.name] = t) && (n["$" + t.name] = t.initialValue);
                    }), o.implement(n, r), this;
                }, l.prototype.resetOptions = function(n) {
                    Object.keys(n.$options).forEach(function(e) {
                        var t = n.$options[e];
                        "value" in t && n.setOption(e, t.value);
                    });
                }, l.prototype.setDefaultValue = function(e, t, n) {
                    if (!e) {
                        for(e in this.$defaultOptions)if (this.$defaultOptions[e][t]) break;
                        if (!this.$defaultOptions[e][t]) return !1;
                    }
                    var i = this.$defaultOptions[e] || (this.$defaultOptions[e] = {});
                    i[t] && (i.forwardTo ? this.setDefaultValue(i.forwardTo, t, n) : i[t].value = n);
                }, l.prototype.setDefaultValues = function(t, n) {
                    Object.keys(n).forEach(function(e) {
                        this.setDefaultValue(t, e, n[e]);
                    }, this);
                }, l.prototype.setMessages = function(e) {
                    i = e;
                }, l.prototype.nls = function(e, n) {
                    e = i && i[e] || e;
                    return e = n ? e.replace(/\$(\$|[\d]+)/g, function(e, t) {
                        return "$" == t ? "$" : n[t];
                    }) : e;
                };
                var a = l;
                function l() {
                    this.$defaultOptions = {};
                }
                a.prototype.warn = s, a.prototype.reportError = function(e, t) {
                    var n = new Error(e);
                    n.data = t, "object" == typeof console && console.error && console.error(n), setTimeout(function() {
                        throw n;
                    });
                }, o.implement(a.prototype, e), t.AppConfig = a;
            }), ace.define("ace/theme/textmate.css", [
                "require",
                "exports",
                "module"
            ], function(e, t, n) {
                n.exports = '.ace-tm .ace_gutter {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.ace-tm .ace_print-margin {\n  width: 1px;\n  background: #e8e8e8;\n}\n\n.ace-tm .ace_fold {\n    background-color: #6B72E6;\n}\n\n.ace-tm {\n  background-color: #FFFFFF;\n  color: black;\n}\n\n.ace-tm .ace_cursor {\n  color: black;\n}\n        \n.ace-tm .ace_invisible {\n  color: rgb(191, 191, 191);\n}\n\n.ace-tm .ace_storage,\n.ace-tm .ace_keyword {\n  color: blue;\n}\n\n.ace-tm .ace_constant {\n  color: rgb(197, 6, 11);\n}\n\n.ace-tm .ace_constant.ace_buildin {\n  color: rgb(88, 72, 246);\n}\n\n.ace-tm .ace_constant.ace_language {\n  color: rgb(88, 92, 246);\n}\n\n.ace-tm .ace_constant.ace_library {\n  color: rgb(6, 150, 14);\n}\n\n.ace-tm .ace_invalid {\n  background-color: rgba(255, 0, 0, 0.1);\n  color: red;\n}\n\n.ace-tm .ace_support.ace_function {\n  color: rgb(60, 76, 114);\n}\n\n.ace-tm .ace_support.ace_constant {\n  color: rgb(6, 150, 14);\n}\n\n.ace-tm .ace_support.ace_type,\n.ace-tm .ace_support.ace_class {\n  color: rgb(109, 121, 222);\n}\n\n.ace-tm .ace_keyword.ace_operator {\n  color: rgb(104, 118, 135);\n}\n\n.ace-tm .ace_string {\n  color: rgb(3, 106, 7);\n}\n\n.ace-tm .ace_comment {\n  color: rgb(76, 136, 107);\n}\n\n.ace-tm .ace_comment.ace_doc {\n  color: rgb(0, 102, 255);\n}\n\n.ace-tm .ace_comment.ace_doc.ace_tag {\n  color: rgb(128, 159, 191);\n}\n\n.ace-tm .ace_constant.ace_numeric {\n  color: rgb(0, 0, 205);\n}\n\n.ace-tm .ace_variable {\n  color: rgb(49, 132, 149);\n}\n\n.ace-tm .ace_xml-pe {\n  color: rgb(104, 104, 91);\n}\n\n.ace-tm .ace_entity.ace_name.ace_function {\n  color: #0000A2;\n}\n\n\n.ace-tm .ace_heading {\n  color: rgb(12, 7, 255);\n}\n\n.ace-tm .ace_list {\n  color:rgb(185, 6, 144);\n}\n\n.ace-tm .ace_meta.ace_tag {\n  color:rgb(0, 22, 142);\n}\n\n.ace-tm .ace_string.ace_regex {\n  color: rgb(255, 0, 0)\n}\n\n.ace-tm .ace_marker-layer .ace_selection {\n  background: rgb(181, 213, 255);\n}\n.ace-tm.ace_multiselect .ace_selection.ace_start {\n  box-shadow: 0 0 3px 0px white;\n}\n.ace-tm .ace_marker-layer .ace_step {\n  background: rgb(252, 255, 0);\n}\n\n.ace-tm .ace_marker-layer .ace_stack {\n  background: rgb(164, 229, 101);\n}\n\n.ace-tm .ace_marker-layer .ace_bracket {\n  margin: -1px 0 0 -1px;\n  border: 1px solid rgb(192, 192, 192);\n}\n\n.ace-tm .ace_marker-layer .ace_active-line {\n  background: rgba(0, 0, 0, 0.07);\n}\n\n.ace-tm .ace_gutter-active-line {\n    background-color : #dcdcdc;\n}\n\n.ace-tm .ace_marker-layer .ace_selected-word {\n  background: rgb(250, 250, 255);\n  border: 1px solid rgb(200, 200, 250);\n}\n\n.ace-tm .ace_indent-guide {\n  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==") right repeat-y;\n}\n\n.ace-tm .ace_indent-guide-active {\n  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAZSURBVHjaYvj///9/hivKyv8BAAAA//8DACLqBhbvk+/eAAAAAElFTkSuQmCC") right repeat-y;\n}\n';
            }), ace.define("ace/theme/textmate", [
                "require",
                "exports",
                "module",
                "ace/theme/textmate.css",
                "ace/lib/dom"
            ], function(e, t, n) {
                "use strict";
                t.isDark = !1, t.cssClass = "ace-tm", t.cssText = e("./textmate.css"), t.$id = "ace/theme/textmate", e("../lib/dom").importCssString(t.cssText, t.cssClass, !1);
            }), ace.define("ace/config", [
                "require",
                "exports",
                "module",
                "ace/lib/lang",
                "ace/lib/net",
                "ace/lib/dom",
                "ace/lib/app_config",
                "ace/theme/textmate"
            ], function(r, s, e) {
                var t = r("./lib/lang"), a = r("./lib/net"), n = r("./lib/dom"), i = r("./lib/app_config").AppConfig, l = (e.exports = s = new i, {
                    packaged: !1,
                    workerPath: null,
                    modePath: null,
                    themePath: null,
                    basePath: "",
                    suffix: ".js",
                    $moduleUrls: {},
                    loadWorkerFromBlob: !0,
                    sharedPopups: !1,
                    useStrictCSP: null
                }), c = (s.get = function(e) {
                    if (l.hasOwnProperty(e)) return l[e];
                    throw new Error("Unknown config key: " + e);
                }, s.set = function(e, t) {
                    if (l.hasOwnProperty(e)) l[e] = t;
                    else if (0 == this.setDefaultValue("", e, t)) throw new Error("Unknown config key: " + e);
                    "useStrictCSP" == e && n.useStrictCSP(t);
                }, s.all = function() {
                    return t.copyObject(l);
                }, s.$modes = {}, s.moduleUrl = function(e, t) {
                    var n, i, o;
                    return l.$moduleUrls[e] || (e = e.split("/"), n = "snippets" == (t = t || e[e.length - 2] || "") ? "/" : "-", i = e[e.length - 1], "worker" == t && "-" == n && (o = new RegExp("^" + t + "[\\-_]|[\\-_]" + t + "$", "g"), i = i.replace(o, "")), (!i || i == t) && 1 < e.length && (i = e[e.length - 2]), null == (o = l[t + "Path"]) ? o = l.basePath : "/" == n && (t = n = ""), o && "/" != o.slice(-1) && (o += "/"), o + t + n + i + this.get("suffix"));
                }, s.setModuleUrl = function(e, t) {
                    return l.$moduleUrls[e] = t;
                }, function(e, t) {
                    return "ace/theme/textmate" === e || "./theme/textmate" === e ? t(null, r("./theme/textmate")) : console.error("loader is not configured");
                }), h = (s.setLoader = function(e) {
                    c = e;
                }, s.dynamicModules = Object.create(null), s.$loading = {}, s.loadModule = function(i, n) {
                    function t(e) {
                        if (e && !s.$loading[i]) return n && n(e);
                        if (s.$loading[i] || (s.$loading[i] = []), s.$loading[i].push(n), !(1 < s.$loading[i].length)) {
                            function t() {
                                c(i, function(e, t) {
                                    s._emit("load.module", {
                                        name: i,
                                        module: t
                                    });
                                    var n = s.$loading[i];
                                    s.$loading[i] = null, n.forEach(function(e) {
                                        e && e(t);
                                    });
                                });
                            }
                            if (!s.get("packaged")) return t();
                            a.loadScript(s.moduleUrl(i, o), t), h();
                        }
                    }
                    var e, o;
                    Array.isArray(i) && (o = i[0], i = i[1]);
                    if (s.dynamicModules[i]) s.dynamicModules[i]().then(function(e) {
                        e.default ? t(e.default) : t(e);
                    });
                    else {
                        try {
                            e = r(i);
                        } catch (e) {}
                        t(e);
                    }
                }, s.setModuleLoader = function(e, t) {
                    s.dynamicModules[e] = t;
                }, function() {
                    l.basePath || l.workerPath || l.modePath || l.themePath || Object.keys(l.$moduleUrls).length || (console.error("Unable to infer path to ace from script src,", "use ace.config.set('basePath', 'path') to enable dynamic loading of modes and themes", "or with webpack use ace/webpack-resolver"), h = function() {});
                });
                s.version = "1.20.0";
            }), ace.define("ace/loader_build", [
                "require",
                "exports",
                "module",
                "ace/lib/fixoldbrowsers",
                "ace/config"
            ], function(g, e, p) {
                "use strict";
                g("./lib/fixoldbrowsers");
                var m = g("./config"), f = (m.setLoader(function(e, t) {
                    g([
                        e
                    ], function(e) {
                        t(null, e);
                    });
                }), function() {
                    return this || "undefined" != typeof window && window;
                }());
                function t(e) {
                    if (f && f.document) {
                        m.set("packaged", e || g.packaged || p.packaged || f.define && C.amdD.packaged);
                        for(var t, n = {}, i = "", e = document.currentScript || document._currentScript, o = e && e.ownerDocument || document, r = (e && e.src && (i = e.src.split(/[?#]/)[0].split("/").slice(0, -1).join("/") || ""), o.getElementsByTagName("script")), s = 0; s < r.length; s++){
                            var a = r[s], l = a.src || a.getAttribute("src");
                            if (l) {
                                for(var c = a.attributes, h = 0, d = c.length; h < d; h++){
                                    var u = c[h];
                                    0 === u.name.indexOf("data-ace-") && (n[u.name.replace(/^data-ace-/, "").replace(/-(.)/g, function(e, t) {
                                        return t.toUpperCase();
                                    })] = u.value);
                                }
                                a = l.match(/^(.*)\/ace([\-.]\w+)?\.js(\?|$)/);
                                a && (i = a[1]);
                            }
                        }
                        for(t in i && (n.base = n.base || i, n.packaged = !0), n.basePath = n.base, n.workerPath = n.workerPath || n.base, n.modePath = n.modePath || n.base, n.themePath = n.themePath || n.base, delete n.base, n)void 0 !== n[t] && m.set(t, n[t]);
                    }
                }
                p.exports = function(e) {
                    m.init = t, e.require = g, e.define = C.amdD;
                }, t(!0);
            }), ace.define("ace/range", [
                "require",
                "exports",
                "module"
            ], function(e, t, n) {
                "use strict";
                r.prototype.isEqual = function(e) {
                    return this.start.row === e.start.row && this.end.row === e.end.row && this.start.column === e.start.column && this.end.column === e.end.column;
                }, r.prototype.toString = function() {
                    return "Range: [" + this.start.row + "/" + this.start.column + "] -> [" + this.end.row + "/" + this.end.column + "]";
                }, r.prototype.contains = function(e, t) {
                    return 0 == this.compare(e, t);
                }, r.prototype.compareRange = function(e) {
                    var t = e.end, e = e.start, t = this.compare(t.row, t.column);
                    return 1 == t ? 1 == (t = this.compare(e.row, e.column)) ? 2 : 0 == t ? 1 : 0 : -1 == t ? -2 : -1 == (t = this.compare(e.row, e.column)) ? -1 : 1 == t ? 42 : 0;
                }, r.prototype.comparePoint = function(e) {
                    return this.compare(e.row, e.column);
                }, r.prototype.containsRange = function(e) {
                    return 0 == this.comparePoint(e.start) && 0 == this.comparePoint(e.end);
                }, r.prototype.intersects = function(e) {
                    e = this.compareRange(e);
                    return -1 == e || 0 == e || 1 == e;
                }, r.prototype.isEnd = function(e, t) {
                    return this.end.row == e && this.end.column == t;
                }, r.prototype.isStart = function(e, t) {
                    return this.start.row == e && this.start.column == t;
                }, r.prototype.setStart = function(e, t) {
                    "object" == typeof e ? (this.start.column = e.column, this.start.row = e.row) : (this.start.row = e, this.start.column = t);
                }, r.prototype.setEnd = function(e, t) {
                    "object" == typeof e ? (this.end.column = e.column, this.end.row = e.row) : (this.end.row = e, this.end.column = t);
                }, r.prototype.inside = function(e, t) {
                    return 0 == this.compare(e, t) && !this.isEnd(e, t) && !this.isStart(e, t);
                }, r.prototype.insideStart = function(e, t) {
                    return 0 == this.compare(e, t) && !this.isEnd(e, t);
                }, r.prototype.insideEnd = function(e, t) {
                    return 0 == this.compare(e, t) && !this.isStart(e, t);
                }, r.prototype.compare = function(e, t) {
                    return this.isMultiLine() || e !== this.start.row ? e < this.start.row ? -1 : e > this.end.row ? 1 : this.start.row === e ? t >= this.start.column ? 0 : -1 : this.end.row !== e || t <= this.end.column ? 0 : 1 : t < this.start.column ? -1 : t > this.end.column ? 1 : 0;
                }, r.prototype.compareStart = function(e, t) {
                    return this.start.row == e && this.start.column == t ? -1 : this.compare(e, t);
                }, r.prototype.compareEnd = function(e, t) {
                    return this.end.row == e && this.end.column == t ? 1 : this.compare(e, t);
                }, r.prototype.compareInside = function(e, t) {
                    return this.end.row == e && this.end.column == t ? 1 : this.start.row == e && this.start.column == t ? -1 : this.compare(e, t);
                }, r.prototype.clipRows = function(e, t) {
                    var n, i;
                    return this.end.row > t ? n = {
                        row: t + 1,
                        column: 0
                    } : this.end.row < e && (n = {
                        row: e,
                        column: 0
                    }), this.start.row > t ? i = {
                        row: t + 1,
                        column: 0
                    } : this.start.row < e && (i = {
                        row: e,
                        column: 0
                    }), r.fromPoints(i || this.start, n || this.end);
                }, r.prototype.extend = function(e, t) {
                    var n, i, o = this.compare(e, t);
                    return 0 == o ? this : (-1 == o ? n = {
                        row: e,
                        column: t
                    } : i = {
                        row: e,
                        column: t
                    }, r.fromPoints(n || this.start, i || this.end));
                }, r.prototype.isEmpty = function() {
                    return this.start.row === this.end.row && this.start.column === this.end.column;
                }, r.prototype.isMultiLine = function() {
                    return this.start.row !== this.end.row;
                }, r.prototype.clone = function() {
                    return r.fromPoints(this.start, this.end);
                }, r.prototype.collapseRows = function() {
                    return 0 == this.end.column ? new r(this.start.row, 0, Math.max(this.start.row, this.end.row - 1), 0) : new r(this.start.row, 0, this.end.row, 0);
                }, r.prototype.toScreenRange = function(e) {
                    var t = e.documentToScreenPosition(this.start), e = e.documentToScreenPosition(this.end);
                    return new r(t.row, t.column, e.row, e.column);
                }, r.prototype.moveBy = function(e, t) {
                    this.start.row += e, this.start.column += t, this.end.row += e, this.end.column += t;
                };
                var i = r;
                function r(e, t, n, i) {
                    this.start = {
                        row: e,
                        column: t
                    }, this.end = {
                        row: n,
                        column: i
                    };
                }
                i.fromPoints = function(e, t) {
                    return new i(e.row, e.column, t.row, t.column);
                }, i.comparePoints = function(e, t) {
                    return e.row - t.row || e.column - t.column;
                }, i.comparePoints = function(e, t) {
                    return e.row - t.row || e.column - t.column;
                }, t.Range = i;
            }), ace.define("ace/lib/keys", [
                "require",
                "exports",
                "module",
                "ace/lib/oop"
            ], function(e, t, n) {
                /*! @license
==========================================================================
SproutCore -- JavaScript Application Framework
copyright 2006-2009, Sprout Systems Inc., Apple Inc. and contributors.

Permission is hereby granted, free of charge, to any person obtaining a
copy of this software and associated documentation files (the "Software"),
to deal in the Software without restriction, including without limitation
the rights to use, copy, modify, merge, publish, distribute, sublicense,
and/or sell copies of the Software, and to permit persons to whom the
Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
DEALINGS IN THE SOFTWARE.

SproutCore and the SproutCore logo are trademarks of Sprout Systems, Inc.

For more information about SproutCore, visit http://www.sproutcore.com


==========================================================================
@license */ "use strict";
                var r = e("./oop"), i = function() {
                    var e, t, n = {
                        MODIFIER_KEYS: {
                            16: "Shift",
                            17: "Ctrl",
                            18: "Alt",
                            224: "Meta",
                            91: "MetaLeft",
                            92: "MetaRight",
                            93: "ContextMenu"
                        },
                        KEY_MODS: {
                            ctrl: 1,
                            alt: 2,
                            option: 2,
                            shift: 4,
                            super: 8,
                            meta: 8,
                            command: 8,
                            cmd: 8,
                            control: 1
                        },
                        FUNCTION_KEYS: {
                            8: "Backspace",
                            9: "Tab",
                            13: "Return",
                            19: "Pause",
                            27: "Esc",
                            32: "Space",
                            33: "PageUp",
                            34: "PageDown",
                            35: "End",
                            36: "Home",
                            37: "Left",
                            38: "Up",
                            39: "Right",
                            40: "Down",
                            44: "Print",
                            45: "Insert",
                            46: "Delete",
                            96: "Numpad0",
                            97: "Numpad1",
                            98: "Numpad2",
                            99: "Numpad3",
                            100: "Numpad4",
                            101: "Numpad5",
                            102: "Numpad6",
                            103: "Numpad7",
                            104: "Numpad8",
                            105: "Numpad9",
                            "-13": "NumpadEnter",
                            112: "F1",
                            113: "F2",
                            114: "F3",
                            115: "F4",
                            116: "F5",
                            117: "F6",
                            118: "F7",
                            119: "F8",
                            120: "F9",
                            121: "F10",
                            122: "F11",
                            123: "F12",
                            144: "Numlock",
                            145: "Scrolllock"
                        },
                        PRINTABLE_KEYS: {
                            32: " ",
                            48: "0",
                            49: "1",
                            50: "2",
                            51: "3",
                            52: "4",
                            53: "5",
                            54: "6",
                            55: "7",
                            56: "8",
                            57: "9",
                            59: ";",
                            61: "=",
                            65: "a",
                            66: "b",
                            67: "c",
                            68: "d",
                            69: "e",
                            70: "f",
                            71: "g",
                            72: "h",
                            73: "i",
                            74: "j",
                            75: "k",
                            76: "l",
                            77: "m",
                            78: "n",
                            79: "o",
                            80: "p",
                            81: "q",
                            82: "r",
                            83: "s",
                            84: "t",
                            85: "u",
                            86: "v",
                            87: "w",
                            88: "x",
                            89: "y",
                            90: "z",
                            107: "+",
                            109: "-",
                            110: ".",
                            186: ";",
                            187: "=",
                            188: ",",
                            189: "-",
                            190: ".",
                            191: "/",
                            192: "`",
                            219: "[",
                            220: "\\",
                            221: "]",
                            222: "'",
                            111: "/",
                            106: "*"
                        }
                    };
                    for(t in n.PRINTABLE_KEYS[173] = "-", n.FUNCTION_KEYS)e = n.FUNCTION_KEYS[t].toLowerCase(), n[e] = parseInt(t, 10);
                    for(t in n.PRINTABLE_KEYS)e = n.PRINTABLE_KEYS[t].toLowerCase(), n[e] = parseInt(t, 10);
                    r.mixin(n, n.MODIFIER_KEYS), r.mixin(n, n.PRINTABLE_KEYS), r.mixin(n, n.FUNCTION_KEYS), n.enter = n.return, n.escape = n.esc, n.del = n.delete;
                    for(var i = [
                        "cmd",
                        "ctrl",
                        "alt",
                        "shift"
                    ], o = Math.pow(2, i.length); o--;)n.KEY_MODS[o] = i.filter(function(e) {
                        return o & n.KEY_MODS[e];
                    }).join("-") + "-";
                    return n.KEY_MODS[0] = "", n.KEY_MODS[-1] = "input-", n;
                }();
                r.mixin(t, i), t.keyCodeToString = function(e) {
                    var t = i[e];
                    return (t = "string" != typeof t ? String.fromCharCode(e) : t).toLowerCase();
                };
            }), ace.define("ace/lib/event", [
                "require",
                "exports",
                "module",
                "ace/lib/keys",
                "ace/lib/useragent"
            ], function(e, d, t) {
                "use strict";
                var n, r = e("./keys"), u = e("./useragent"), s = null, a = 0;
                function o() {
                    if (null == n) {
                        n = !1;
                        try {
                            document.createComment("").addEventListener("test", function() {}, {
                                get passive () {
                                    n = {
                                        passive: !1
                                    };
                                }
                            });
                        } catch (e) {}
                    }
                    return n;
                }
                function l(e, t, n) {
                    this.elem = e, this.type = t, this.callback = n;
                }
                l.prototype.destroy = function() {
                    p(this.elem, this.type, this.callback), this.elem = this.type = this.callback = void 0;
                };
                function c(e) {
                    return 0 | (e.ctrlKey ? 1 : 0) | (e.altKey ? 2 : 0) | (e.shiftKey ? 4 : 0) | (e.metaKey ? 8 : 0);
                }
                var h, g = d.addListener = function(e, t, n, i) {
                    e.addEventListener(t, n, o()), i && i.$toDestroy.push(new l(e, t, n));
                }, p = d.removeListener = function(e, t, n) {
                    e.removeEventListener(t, n, o());
                };
                d.stopEvent = function(e) {
                    return d.stopPropagation(e), d.preventDefault(e), !1;
                }, d.stopPropagation = function(e) {
                    e.stopPropagation && e.stopPropagation();
                }, d.preventDefault = function(e) {
                    e.preventDefault && e.preventDefault();
                }, d.getButton = function(e) {
                    return "dblclick" == e.type ? 0 : "contextmenu" == e.type || u.isMac && e.ctrlKey && !e.altKey && !e.shiftKey ? 2 : e.button;
                }, d.capture = function(e, t, n) {
                    var i = e && e.ownerDocument || document;
                    function o(e) {
                        t && t(e), n && n(e), p(i, "mousemove", t), p(i, "mouseup", o), p(i, "dragstart", o);
                    }
                    return g(i, "mousemove", t), g(i, "mouseup", o), g(i, "dragstart", o), o;
                }, d.addMouseWheelListener = function(e, i, t) {
                    g(e, "wheel", function(e) {
                        var t = e.deltaX || 0, n = e.deltaY || 0;
                        switch(e.deltaMode){
                            case e.DOM_DELTA_PIXEL:
                                e.wheelX = .15 * t, e.wheelY = .15 * n;
                                break;
                            case e.DOM_DELTA_LINE:
                                e.wheelX = 15 * t, e.wheelY = 15 * n;
                                break;
                            case e.DOM_DELTA_PAGE:
                                e.wheelX = 150 * t, e.wheelY = 150 * n;
                        }
                        i(e);
                    }, t);
                }, d.addMultiMouseDownListener = function(e, n, i, o, t) {
                    var r, s, a, l = 0, c = {
                        2: "dblclick",
                        3: "tripleclick",
                        4: "quadclick"
                    };
                    function h(e) {
                        var t;
                        if (0 !== d.getButton(e) ? l = 0 : 1 < e.detail && !(4 < ++l) || (l = 1), u.isIE && (t = 5 < Math.abs(e.clientX - r) || 5 < Math.abs(e.clientY - s), a && !t || (l = 1), a && clearTimeout(a), a = setTimeout(function() {
                            a = null;
                        }, n[l - 1] || 600), 1 == l) && (r = e.clientX, s = e.clientY), e._clicks = l, i[o]("mousedown", e), 4 < l) l = 0;
                        else if (1 < l) return i[o](c[l], e);
                    }
                    (e = Array.isArray(e) ? e : [
                        e
                    ]).forEach(function(e) {
                        g(e, "mousedown", h, t);
                    });
                };
                function m(e, t, n) {
                    var i = c(t);
                    if (!u.isMac && s) {
                        if (t.getModifierState && (t.getModifierState("OS") || t.getModifierState("Win")) && (i |= 8), s.altGr) {
                            if (3 == (3 & i)) return;
                            s.altGr = 0;
                        }
                        18 !== n && 17 !== n || (o = "location" in t ? t.location : t.keyLocation, 17 === n && 1 === o ? 1 == s[n] && (a = t.timeStamp) : 18 === n && 3 === i && 2 === o && t.timeStamp - a < 50 && (s.altGr = !0));
                    }
                    if (n in r.MODIFIER_KEYS && (n = -1), !i && 13 === n) {
                        var o = "location" in t ? t.location : t.keyLocation;
                        if (3 === o && (e(t, i, -n), t.defaultPrevented)) return;
                    }
                    if (u.isChromeOS && 8 & i) {
                        if (e(t, i, n), t.defaultPrevented) return;
                        i &= -9;
                    }
                    return !!(i || n in r.FUNCTION_KEYS || n in r.PRINTABLE_KEYS) && e(t, i, n);
                }
                function f() {
                    s = Object.create(null);
                }
                d.getModifierString = function(e) {
                    return r.KEY_MODS[c(e)];
                }, d.addCommandKeyListener = function(e, n, t) {
                    var i, o;
                    u.isOldGecko || u.isOpera && !("KeyboardEvent" in window) ? (i = null, g(e, "keydown", function(e) {
                        i = e.keyCode;
                    }, t), g(e, "keypress", function(e) {
                        return m(n, e, i);
                    }, t)) : (o = null, g(e, "keydown", function(e) {
                        s[e.keyCode] = (s[e.keyCode] || 0) + 1;
                        var t = m(n, e, e.keyCode);
                        return o = e.defaultPrevented, t;
                    }, t), g(e, "keypress", function(e) {
                        o && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey) && (d.stopEvent(e), o = null);
                    }, t), g(e, "keyup", function(e) {
                        s[e.keyCode] = null;
                    }, t), s || (f(), g(window, "focus", f)));
                }, "object" == typeof window && window.postMessage && !u.isOldIE && (h = 1, d.nextTick = function(t, n) {
                    n = n || window;
                    function i(e) {
                        e.data == o && (d.stopPropagation(e), p(n, "message", i), t());
                    }
                    var o = "zero-timeout-message-" + h++;
                    g(n, "message", i), n.postMessage(o, "*");
                }), d.$idleBlocked = !1, d.onIdle = function(t, e) {
                    return setTimeout(function e() {
                        d.$idleBlocked ? setTimeout(e, 100) : t();
                    }, e);
                }, d.$idleBlockId = null, d.blockIdle = function(e) {
                    d.$idleBlockId && clearTimeout(d.$idleBlockId), d.$idleBlocked = !0, d.$idleBlockId = setTimeout(function() {
                        d.$idleBlocked = !1;
                    }, e || 100);
                }, d.nextFrame = "object" == typeof window && (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame), d.nextFrame ? d.nextFrame = d.nextFrame.bind(window) : d.nextFrame = function(e) {
                    setTimeout(e, 17);
                };
            }), ace.define("ace/clipboard", [
                "require",
                "exports",
                "module"
            ], function(e, t, n) {
                "use strict";
                var i;
                n.exports = {
                    lineMode: !1,
                    pasteCancelled: function() {
                        return !!(i && i > Date.now() - 50) || (i = !1);
                    },
                    cancel: function() {
                        i = Date.now();
                    }
                };
            }), ace.define("ace/keyboard/textinput", [
                "require",
                "exports",
                "module",
                "ace/lib/event",
                "ace/config",
                "ace/lib/useragent",
                "ace/lib/dom",
                "ace/lib/lang",
                "ace/clipboard",
                "ace/lib/keys"
            ], function(e, t, n) {
                "use strict";
                var P = e("../lib/event"), F = e("../config").nls, V = e("../lib/useragent"), Z = e("../lib/dom"), O = e("../lib/lang"), D = e("../clipboard"), K = V.isChrome < 18, j = V.isIE, z = 63 < V.isChrome, X = e("../lib/keys"), Y = X.KEY_MODS, J = V.isIOS, U = J ? /\s/ : /\n/, Q = V.isMobile;
                t.TextInput = function(e, d) {
                    var u = Z.createElement("textarea"), r = (u.className = "ace_text-input", u.setAttribute("wrap", "off"), u.setAttribute("autocorrect", "off"), u.setAttribute("autocapitalize", "off"), u.setAttribute("spellcheck", !1), u.style.opacity = "0", e.insertBefore(u, e.firstChild), !1), g = !1, s = !1, p = !1, a = "", m = (Q || (u.style.fontSize = "1px"), !1), t = !1, f = "", C = 0, y = 0, v = 0;
                    try {
                        var l = document.activeElement === u;
                    } catch (e) {}
                    this.setAriaOptions = function(e) {
                        e.activeDescendant ? (u.setAttribute("aria-haspopup", "true"), u.setAttribute("aria-autocomplete", e.inline ? "both" : "list"), u.setAttribute("aria-activedescendant", e.activeDescendant)) : (u.setAttribute("aria-haspopup", "false"), u.setAttribute("aria-autocomplete", "both"), u.removeAttribute("aria-activedescendant")), e.role && u.setAttribute("role", e.role);
                    }, this.setAriaLabel = function() {
                        var e;
                        d.session && d.renderer.enableKeyboardAccessibility ? (e = d.session.selection.cursor.row, u.setAttribute("aria-roledescription", F("editor")), u.setAttribute("aria-label", F("Cursor at row $0", [
                            e + 1
                        ]))) : (u.removeAttribute("aria-roledescription"), u.removeAttribute("aria-label"));
                    }, this.setAriaOptions({
                        role: "textbox"
                    }), this.setAriaLabel(), P.addListener(u, "blur", function(e) {
                        t || (d.onBlur(e), l = !1, Q && !J && document.removeEventListener("selectionchange", c));
                    }, d), P.addListener(u, "focus", function(e) {
                        if (!t) {
                            if (l = !0, V.isEdge) try {
                                if (!document.hasFocus()) return;
                            } catch (e) {}
                            d.onFocus(e), V.isEdge ? setTimeout(I) : I(), Q && !J && document.addEventListener("selectionchange", c);
                        }
                    }, d), this.$focusScroll = !1, this.focus = function() {
                        if (this.setAriaLabel(), a || z || "browser" == this.$focusScroll) return u.focus({
                            preventScroll: !0
                        });
                        var e = u.style.top;
                        u.style.position = "fixed", u.style.top = "0px";
                        try {
                            var t = 0 != u.getBoundingClientRect().top;
                        } catch (e) {
                            return;
                        }
                        var n = [];
                        if (t) for(var i = u.parentElement; i && 1 == i.nodeType;)n.push(i), i.setAttribute("ace_nocontext", !0), i = !i.parentElement && i.getRootNode ? i.getRootNode().host : i.parentElement;
                        u.focus({
                            preventScroll: !0
                        }), t && n.forEach(function(e) {
                            e.removeAttribute("ace_nocontext");
                        }), setTimeout(function() {
                            u.style.position = "", "0px" == u.style.top && (u.style.top = e);
                        }, 0);
                    }, this.blur = function() {
                        u.blur();
                    }, this.isFocused = function() {
                        return l;
                    }, d.on("beforeEndOperation", function() {
                        var e = d.curOp, t = e && e.command && e.command.name;
                        "insertstring" != t && (t = t && (e.docChanged || e.selectionChanged), s && t && (f = u.value = "", E()), I());
                    });
                    var I = J ? function(e) {
                        var t;
                        !l || r && !e || p || ((t = "\n ab" + (e = e || "") + "cde fg\n") != u.value && (u.value = f = t), t = 4 + (e.length || (d.selection.isEmpty() ? 0 : 1)), 4 == C && y == t || u.setSelectionRange(4, t), C = 4, y = t);
                    } : function() {
                        if (!s && !p && (l || b)) {
                            s = !0;
                            var e, t, n = 0, i = 0, o = "", r = (d.session && (r = (e = d.selection).getRange(), e = e.cursor.row, n = r.start.column, i = r.end.column, o = d.session.getLine(e), r.start.row != e ? (t = d.session.getLine(e - 1), n = r.start.row < e - 1 ? 0 : n, i += t.length + 1, o = t + "\n" + o) : r.end.row != e ? (t = d.session.getLine(e + 1), i = r.end.row > e + 1 ? t.length : i, i += o.length + 1, o = o + "\n" + t) : Q && 0 < e && (o = "\n" + o, i += 1, n += 1), 400 < o.length) && (n < 400 && i < 400 ? o = o.slice(0, 400) : (o = "\n", n == i ? n = i = 0 : (n = 0, i = 1))), o + "\n\n");
                            if (r != f && (u.value = f = r, C = y = r.length), b && (C = u.selectionStart, y = u.selectionEnd), y != i || C != n || u.selectionEnd != y) try {
                                u.setSelectionRange(n, i), C = n, y = i;
                            } catch (e) {}
                            s = !1;
                        }
                    }, W = (this.resetSelection = I, l && d.onFocus(), function(e) {
                        return 0 === e.selectionStart && e.selectionEnd >= f.length && e.value === f && f && e.selectionEnd !== y;
                    });
                    function c(e) {
                        if (u && u.parentNode || document.removeEventListener("selectionchange", c), !s && u.selectionStart === u.selectionEnd) for(var t = u.selectionStart - C, n = y - C, i = (0 < t ? t = Math.max(t - n, 1) : 0 === t && n && (t = -1), Math.abs(t)), o = 0 < t ? X.right : X.left, r = 0; r < i; r++)d.onCommandKey({}, 0, o);
                    }
                    function n(e) {
                        x(e, !0);
                    }
                    function i(e) {
                        x(e, !1);
                    }
                    function o(e) {
                        var t = S(e);
                        D.pasteCancelled() || ("string" == typeof t ? (t && d.onPaste(t, e), V.isIE && setTimeout(I), P.preventDefault(e)) : (u.value = "", g = !0));
                    }
                    var h = null, b = (this.setInputHandler = function(e) {
                        h = e;
                    }, this.getInputHandler = function() {
                        return h;
                    }, false), A = function(e, t) {
                        if (b = b && !1, g) return I(), e && d.onPaste(e), g = !1, "";
                        for(var n = u.selectionStart, i = u.selectionEnd, o = C, r = f.length - y, s = e, a = e.length - n, l = e.length - i, c = 0; 0 < o && f[c] == e[c];)c++, o--;
                        for(s = s.slice(c), c = 1; 0 < r && f.length - c > C - 1 && f[f.length - c] == e[e.length - c];)c++, r--;
                        a -= c - 1, l -= c - 1;
                        var h = s.length - c + 1;
                        return h < 0 && (o = -h, h = 0), s = s.slice(0, h), t || s || a || o || r || l ? (h = (p = !0, false), V.isAndroid && ". " == s && (s = "  ", h = !0), s && !o && !r && !a && !l || m ? d.onTextInput(s) : d.onTextInput(s, {
                            extendLeft: o,
                            extendRight: r,
                            restoreStart: a,
                            restoreEnd: l
                        }), p = !1, f = e, C = n, y = i, v = l, h ? "\n" : s) : "";
                    }, w = function(e) {
                        if (s) return k();
                        if (e && e.inputType) {
                            if ("historyUndo" == e.inputType) return d.execCommand("undo");
                            if ("historyRedo" == e.inputType) return d.execCommand("redo");
                        }
                        var e = u.value, t = A(e, !0);
                        (500 < e.length || U.test(t) || Q && C < 1 && C == y) && I();
                    }, S = function(e, t, n) {
                        var i = e.clipboardData || window.clipboardData;
                        if (i && !K) {
                            var o = j || n ? "Text" : "text/plain";
                            try {
                                return t ? !1 !== i.setData(o, t) : i.getData(o);
                            } catch (e) {
                                if (!n) return S(e, t, !0);
                            }
                        }
                    }, x = function(e, t) {
                        var n = d.getCopyText();
                        if (!n) return P.preventDefault(e);
                        S(e, n) ? (J && (I(n), r = n, setTimeout(function() {
                            r = !1;
                        }, 10)), t ? d.onCut() : d.onCopy(), P.preventDefault(e)) : (r = !0, u.value = n, u.select(), setTimeout(function() {
                            r = !1, I(), t ? d.onCut() : d.onCopy();
                        }));
                    }, k = (P.addCommandKeyListener(u, d.onCommandKey.bind(d), d), P.addListener(u, "select", function(e) {
                        s || (r ? r = !1 : W(u) ? (d.selectAll(), I()) : Q && u.selectionStart != C && I());
                    }, d), P.addListener(u, "input", w, d), P.addListener(u, "cut", n, d), P.addListener(u, "copy", i, d), P.addListener(u, "paste", o, d), "oncut" in u && "oncopy" in u && "onpaste" in u || P.addListener(e, "keydown", function(e) {
                        if ((!V.isMac || e.metaKey) && e.ctrlKey) switch(e.keyCode){
                            case 67:
                                i(e);
                                break;
                            case 86:
                                o(e);
                                break;
                            case 88:
                                n(e);
                        }
                    }, d), function() {
                        var e;
                        if (s && d.onCompositionUpdate && !d.$readOnly) return m ? T() : void (s.useTextareaForIME ? d.onCompositionUpdate(u.value) : (e = u.value, A(e), s.markerRange && (s.context && (s.markerRange.start.column = s.selectionStart = s.context.compositionStartOffset), s.markerRange.end.column = s.markerRange.start.column + y - s.selectionStart + v)));
                    }), E = function(e) {
                        d.onCompositionEnd && !d.$readOnly && (s = !1, d.onCompositionEnd(), d.off("mousedown", T), e) && w();
                    };
                    function T() {
                        t = !0, u.blur(), u.focus(), t = !1;
                    }
                    var R, H = O.delayedCall(k, 50).schedule.bind(null, null);
                    function _() {
                        clearTimeout(R), R = setTimeout(function() {
                            a && (u.style.cssText = a, a = ""), d.renderer.$isMousePressed = !1, d.renderer.$keepTextAreaAtCursor && d.renderer.$moveTextAreaToCursor();
                        }, 0);
                    }
                    P.addListener(u, "compositionstart", function(e) {
                        s || !d.onCompositionStart || d.$readOnly || (s = {}, m) || (e.data && (s.useTextareaForIME = !1), setTimeout(k, 0), d._signal("compositionStart"), d.on("mousedown", T), (e = d.getSelectionRange()).end.row = e.start.row, e.end.column = e.start.column, s.markerRange = e, s.selectionStart = C, d.onCompositionStart(s), s.useTextareaForIME ? (f = u.value = "", y = C = 0) : (u.msGetInputContext && (s.context = u.msGetInputContext()), u.getInputContext && (s.context = u.getInputContext())));
                    }, d), P.addListener(u, "compositionupdate", k, d), P.addListener(u, "keyup", function(e) {
                        27 == e.keyCode && u.value.length < u.selectionStart && (s || (f = u.value), C = y = -1, I()), H();
                    }, d), P.addListener(u, "keydown", H, d), P.addListener(u, "compositionend", E, d), this.getElement = function() {
                        return u;
                    }, this.setCommandMode = function(e) {
                        m = e, u.readOnly = !1;
                    }, this.setReadOnly = function(e) {
                        m || (u.readOnly = e);
                    }, this.setCopyWithEmptySelection = function(e) {}, this.onContextMenu = function(e) {
                        b = !0, I(), d._emit("nativecontextmenu", {
                            target: d,
                            domEvent: e
                        }), this.moveToMouse(e, !0);
                    }, this.moveToMouse = function(e, t) {
                        a = a || u.style.cssText, u.style.cssText = (t ? "z-index:100000;" : "") + (V.isIE ? "opacity:0.1;" : "") + "text-indent: -" + (C + y) * d.renderer.characterWidth * .5 + "px;";
                        function n(e) {
                            Z.translate(u, e.clientX - r - 2, Math.min(e.clientY - o - 2, s));
                        }
                        var t = d.container.getBoundingClientRect(), i = Z.computedStyle(d.container), o = t.top + (parseInt(i.borderTopWidth) || 0), r = t.left + (parseInt(t.borderLeftWidth) || 0), s = t.bottom - o - u.clientHeight - 2;
                        n(e), "mousedown" == e.type && (d.renderer.$isMousePressed = !0, clearTimeout(R), V.isWin) && P.capture(d.container, n, _);
                    }, this.onContextMenuClose = _;
                    function $(e) {
                        d.textInput.onContextMenu(e), _();
                    }
                    if (P.addListener(u, "mouseup", $, d), P.addListener(u, "mousedown", function(e) {
                        e.preventDefault(), _();
                    }, d), P.addListener(d.renderer.scroller, "contextmenu", $, d), P.addListener(u, "contextmenu", $, d), J) {
                        var L = d, N = u;
                        function G(e) {
                            var t, n, i, o;
                            document.activeElement !== N || M || s || L.$mouseHandler.isMousePressed || r || (t = N.selectionStart, n = N.selectionEnd, i = null, (o = 0) == t ? i = X.up : 1 == t ? i = X.home : y < n && "\n" == f[n] ? i = X.end : t < C && " " == f[t - 1] ? (i = X.left, o = Y.option) : t < C || t == C && y != C && t == n ? i = X.left : y < n && 2 < f.slice(0, n).split("\n").length ? i = X.down : y < n && " " == f[n - 1] ? (i = X.right, o = Y.option) : (y < n || n == y && y != C && t == n) && (i = X.right), t !== n && (o |= Y.shift), i && (!L.onCommandKey({}, o, i) && L.commands && (i = X.keyCodeToString(i), o = L.commands.findKeyCommand(o, i)) && L.execCommand(o), C = t, y = n, I("")));
                        }
                        var B = null, M = !1;
                        N.addEventListener("keydown", function(e) {
                            B && clearTimeout(B), M = !0;
                        }, !0), N.addEventListener("keyup", function(e) {
                            B = setTimeout(function() {
                                M = !1;
                            }, 100);
                        }, !0), document.addEventListener("selectionchange", G), L.on("destroy", function() {
                            document.removeEventListener("selectionchange", G);
                        });
                    }
                    this.destroy = function() {
                        u.parentElement && u.parentElement.removeChild(u);
                    };
                }, t.$setUserAgentForTests = function(e, t) {
                    Q = e, J = t;
                };
            }), ace.define("ace/mouse/default_handlers", [
                "require",
                "exports",
                "module",
                "ace/lib/useragent"
            ], function(e, t, n) {
                "use strict";
                var r = e("../lib/useragent"), e = (i.prototype.onMouseDown = function(e) {
                    var t = e.inSelection(), n = e.getDocumentPosition(), i = (this.mousedownEvent = e, this.editor), o = e.getButton();
                    if (0 !== o) !i.getSelectionRange().isEmpty() && 1 != o || i.selection.moveToPosition(n), 2 == o && (i.textInput.onContextMenu(e.domEvent), r.isMozilla || e.preventDefault());
                    else {
                        if (this.mousedownEvent.time = Date.now(), !t || i.isFocused() || (i.focus(), !this.$focusTimeout) || this.$clickSelection || i.inMultiSelectMode) return this.captureMouse(e), this.startSelect(n, 1 < e.domEvent._clicks), e.preventDefault();
                        this.setState("focusWait"), this.captureMouse(e);
                    }
                }, i.prototype.startSelect = function(e, t) {
                    e = e || this.editor.renderer.screenToTextCoordinates(this.x, this.y);
                    var n = this.editor;
                    this.mousedownEvent && (this.mousedownEvent.getShiftKey() ? n.selection.selectToPosition(e) : t || n.selection.moveToPosition(e), t || this.select(), n.setStyle("ace_selecting"), this.setState("select"));
                }, i.prototype.select = function() {
                    var e, t = this.editor, n = t.renderer.screenToTextCoordinates(this.x, this.y);
                    this.$clickSelection && (e = -1 == (e = this.$clickSelection.comparePoint(n)) ? this.$clickSelection.end : 1 == e ? this.$clickSelection.start : (n = (e = s(this.$clickSelection, n)).cursor, e.anchor), t.selection.setSelectionAnchor(e.row, e.column)), t.selection.selectToPosition(n), t.renderer.scrollCursorIntoView();
                }, i.prototype.extendSelectionBy = function(e) {
                    var t, n, i, o = this.editor, r = o.renderer.screenToTextCoordinates(this.x, this.y), e = o.selection[e](r.row, r.column);
                    this.$clickSelection && (n = this.$clickSelection.comparePoint(e.start), t = this.$clickSelection.comparePoint(e.end), -1 == n && t <= 0 ? (i = this.$clickSelection.end, e.end.row == r.row && e.end.column == r.column || (r = e.start)) : 1 == t && 0 <= n ? (i = this.$clickSelection.start, e.start.row == r.row && e.start.column == r.column || (r = e.end)) : i = -1 == n && 1 == t ? (r = e.end, e.start) : (r = (n = s(this.$clickSelection, r)).cursor, n.anchor), o.selection.setSelectionAnchor(i.row, i.column)), o.selection.selectToPosition(r), o.renderer.scrollCursorIntoView();
                }, i.prototype.selectByLinesEnd = function() {
                    this.$clickSelection = null, this.editor.unsetStyle("ace_selecting");
                }, i.prototype.focusWait = function() {
                    i = this.mousedownEvent.x, e = this.mousedownEvent.y, n = this.x, t = this.y;
                    var e, t, n = Math.sqrt(Math.pow(n - i, 2) + Math.pow(t - e, 2)), i = Date.now();
                    (0 < n || i - this.mousedownEvent.time > this.$focusTimeout) && this.startSelect(this.mousedownEvent.getDocumentPosition());
                }, i.prototype.onDoubleClick = function(e) {
                    var e = e.getDocumentPosition(), t = this.editor, n = t.session.getBracketRange(e);
                    n ? (n.isEmpty() && (n.start.column--, n.end.column++), this.setState("select")) : (n = t.selection.getWordRange(e.row, e.column), this.setState("selectByWords")), this.$clickSelection = n, this.select();
                }, i.prototype.onTripleClick = function(e) {
                    var e = e.getDocumentPosition(), t = this.editor, n = (this.setState("selectByLines"), t.getSelectionRange());
                    n.isMultiLine() && n.contains(e.row, e.column) ? (this.$clickSelection = t.selection.getLineRange(n.start.row), this.$clickSelection.end = t.selection.getLineRange(n.end.row).end) : this.$clickSelection = t.selection.getLineRange(e.row), this.select();
                }, i.prototype.onQuadClick = function(e) {
                    var t = this.editor;
                    t.selectAll(), this.$clickSelection = t.getSelectionRange(), this.setState("selectAll");
                }, i.prototype.onMouseWheel = function(e) {
                    var t, n, i, o, r, s, a;
                    if (!e.getAccelKey()) return e.getShiftKey() && e.wheelY && !e.wheelX && (e.wheelX = e.wheelY, e.wheelY = 0), t = this.editor, this.$lastScroll || (this.$lastScroll = {
                        t: 0,
                        vx: 0,
                        vy: 0,
                        allowed: 0
                    }), n = this.$lastScroll, o = (a = (i = e.domEvent.timeStamp) - n.t) ? e.wheelX / a : n.vx, r = a ? e.wheelY / a : n.vy, a < 550 && (o = (o + n.vx) / 2, r = (r + n.vy) / 2), a = !1, 1 <= (s = Math.abs(o / r)) && t.renderer.isScrollableBy(e.wheelX * e.speed, 0) && (a = !0), (a = s <= 1 && t.renderer.isScrollableBy(0, e.wheelY * e.speed) ? !0 : a) ? n.allowed = i : i - n.allowed < 550 && (Math.abs(o) <= 1.5 * Math.abs(n.vx) && Math.abs(r) <= 1.5 * Math.abs(n.vy) ? (a = !0, n.allowed = i) : n.allowed = 0), n.t = i, n.vx = o, n.vy = r, a ? (t.renderer.scrollBy(e.wheelX * e.speed, e.wheelY * e.speed), e.stop()) : void 0;
                }, i);
                function i(t) {
                    t.$clickSelection = null;
                    var e = t.editor;
                    e.setDefaultHandler("mousedown", this.onMouseDown.bind(t)), e.setDefaultHandler("dblclick", this.onDoubleClick.bind(t)), e.setDefaultHandler("tripleclick", this.onTripleClick.bind(t)), e.setDefaultHandler("quadclick", this.onQuadClick.bind(t)), e.setDefaultHandler("mousewheel", this.onMouseWheel.bind(t));
                    [
                        "select",
                        "startSelect",
                        "selectEnd",
                        "selectAllEnd",
                        "selectByWordsEnd",
                        "selectByLinesEnd",
                        "dragWait",
                        "dragWaitEnd",
                        "focusWait"
                    ].forEach(function(e) {
                        t[e] = this[e];
                    }, this), t.selectByLines = this.extendSelectionBy.bind(t, "getLineRange"), t.selectByWords = this.extendSelectionBy.bind(t, "getWordRange");
                }
                function s(e, t) {
                    return (e.start.row == e.end.row ? 2 * t.column - e.start.column - e.end.column : e.start.row != e.end.row - 1 || e.start.column || e.end.column ? 2 * t.row - e.start.row - e.end.row : t.column - 4) < 0 ? {
                        cursor: e.start,
                        anchor: e.end
                    } : {
                        cursor: e.end,
                        anchor: e.start
                    };
                }
                e.prototype.selectEnd = e.prototype.selectByLinesEnd, e.prototype.selectAllEnd = e.prototype.selectByLinesEnd, e.prototype.selectByWordsEnd = e.prototype.selectByLinesEnd, t.DefaultHandlers = e;
            }), ace.define("ace/tooltip", [
                "require",
                "exports",
                "module",
                "ace/lib/dom",
                "ace/range"
            ], function(e, t, n) {
                "use strict";
                var i, o = this && this.__extends || (i = function(e, t) {
                    return (i = Object.setPrototypeOf || (({
                        __proto__: []
                    }) instanceof Array ? function(e, t) {
                        e.__proto__ = t;
                    } : function(e, t) {
                        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                    }))(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function n() {
                        this.constructor = e;
                    }
                    i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
                }), u = this && this.__values || function(e) {
                    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], i = 0;
                    if (n) return n.call(e);
                    if (e && "number" == typeof e.length) return {
                        next: function() {
                            return {
                                value: (e = e && i >= e.length ? void 0 : e) && e[i++],
                                done: !e
                            };
                        }
                    };
                    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                }, r = e("./lib/dom"), a = e("./range").Range, s = "ace_tooltip", e = (l.prototype.$init = function() {
                    return this.$element = r.createElement("div"), this.$element.className = s, this.$element.style.display = "none", this.$parentNode.appendChild(this.$element), this.$element;
                }, l.prototype.getElement = function() {
                    return this.$element || this.$init();
                }, l.prototype.setText = function(e) {
                    this.getElement().textContent = e;
                }, l.prototype.setHtml = function(e) {
                    this.getElement().innerHTML = e;
                }, l.prototype.setPosition = function(e, t) {
                    this.getElement().style.left = e + "px", this.getElement().style.top = t + "px";
                }, l.prototype.setClassName = function(e) {
                    r.addCssClass(this.getElement(), e);
                }, l.prototype.setTheme = function(e) {
                    this.$element.className = s + " " + (e.isDark ? "ace_dark " : "") + (e.cssClass || "");
                }, l.prototype.show = function(e, t, n) {
                    null != e && this.setText(e), null != t && null != n && this.setPosition(t, n), this.isOpen || (this.getElement().style.display = "block", this.isOpen = !0);
                }, l.prototype.hide = function() {
                    this.isOpen && (this.getElement().style.display = "none", this.getElement().className = s, this.isOpen = !1);
                }, l.prototype.getHeight = function() {
                    return this.getElement().offsetHeight;
                }, l.prototype.getWidth = function() {
                    return this.getElement().offsetWidth;
                }, l.prototype.destroy = function() {
                    this.isOpen = !1, this.$element && this.$element.parentNode && this.$element.parentNode.removeChild(this.$element);
                }, l);
                function l(e) {
                    this.isOpen = !1, this.$element = null, this.$parentNode = e;
                }
                function c() {
                    this.popups = [];
                }
                c.prototype.addPopup = function(e) {
                    this.popups.push(e), this.updatePopups();
                }, c.prototype.removePopup = function(e) {
                    e = this.popups.indexOf(e);
                    -1 !== e && (this.popups.splice(e, 1), this.updatePopups());
                }, c.prototype.updatePopups = function() {
                    this.popups.sort(function(e, t) {
                        return t.priority - e.priority;
                    });
                    var t, e, n, i, o = [];
                    try {
                        for(var r = u(this.popups), s = r.next(); !s.done; s = r.next()){
                            var a = s.value, l = !0;
                            try {
                                n = void 0;
                                for(var c = u(o), h = c.next(); !h.done; h = c.next()){
                                    var d = h.value;
                                    if (this.doPopupsOverlap(d, a)) {
                                        l = !1;
                                        break;
                                    }
                                }
                            } catch (e) {
                                n = {
                                    error: e
                                };
                            } finally{
                                try {
                                    h && !h.done && (i = c.return) && i.call(c);
                                } finally{
                                    if (n) throw n.error;
                                }
                            }
                            l ? o.push(a) : a.hide();
                        }
                    } catch (e) {
                        t = {
                            error: e
                        };
                    } finally{
                        try {
                            s && !s.done && (e = r.return) && e.call(r);
                        } finally{
                            if (t) throw t.error;
                        }
                    }
                }, c.prototype.doPopupsOverlap = function(e, t) {
                    e = e.getElement().getBoundingClientRect(), t = t.getElement().getBoundingClientRect();
                    return e.left < t.right && e.right > t.left && e.top < t.bottom && e.bottom > t.top;
                };
                var h, d = new c, o = (t.popupManager = d, t.Tooltip = e, o(g, h = e), g.prototype.addToEditor = function(e) {
                    e.on("mousemove", this.onMouseMove), e.on("mousedown", this.hide), e.renderer.getMouseEventTarget().addEventListener("mouseout", this.onMouseOut, !0);
                }, g.prototype.removeFromEditor = function(e) {
                    e.off("mousemove", this.onMouseMove), e.off("mousedown", this.hide), e.renderer.getMouseEventTarget().removeEventListener("mouseout", this.onMouseOut, !0), this.timeout && (clearTimeout(this.timeout), this.timeout = null);
                }, g.prototype.onMouseMove = function(e, t) {
                    this.lastEvent = e, this.lastT = Date.now();
                    var n, t = t.$mouseHandler.isMousePressed;
                    this.isOpen && (n = this.lastEvent && this.lastEvent.getDocumentPosition(), this.range && this.range.contains(n.row, n.column) && !t && !this.isOutsideOfText(this.lastEvent) || this.hide()), this.timeout || t || (this.lastEvent = e, this.timeout = setTimeout(this.waitForHover, this.idleTime));
                }, g.prototype.waitForHover = function() {
                    this.timeout && clearTimeout(this.timeout);
                    var e = Date.now() - this.lastT;
                    10 < this.idleTime - e ? this.timeout = setTimeout(this.waitForHover, this.idleTime - e) : (this.timeout = null, this.lastEvent && !this.isOutsideOfText(this.lastEvent) && this.$gatherData(this.lastEvent, this.lastEvent.editor));
                }, g.prototype.isOutsideOfText = function(e) {
                    var t = e.editor, n = e.getDocumentPosition(), i = t.session.getLine(n.row);
                    if (n.column == i.length) {
                        i = t.renderer.pixelToScreenCoordinates(e.clientX, e.clientY), e = t.session.documentToScreenPosition(n.row, n.column);
                        if (e.column != i.column || e.row != i.row) return !0;
                    }
                    return !1;
                }, g.prototype.setDataProvider = function(e) {
                    this.$gatherData = e;
                }, g.prototype.showForRange = function(e, t, n, i) {
                    var o, r, s;
                    i && i != this.lastEvent || this.isOpen && document.activeElement == this.getElement() || (i = e.renderer, this.isOpen || (d.addPopup(this), this.$registerCloseEvents(), this.setTheme(i.theme)), this.isOpen = !0, this.addMarker(t, e.session), this.range = a.fromPoints(t.start, t.end), (o = this.getElement()).innerHTML = "", o.appendChild(n), o.style.display = "block", n = i.textToScreenCoordinates(t.start.row, t.start.column), t = e.getCursorPosition(), e = o.clientHeight, r = i.scroller.getBoundingClientRect(), s = !0, this.row > t.row ? s = !0 : this.row < t.row && (s = !1), n.pageY - e + i.lineHeight < r.top ? s = !0 : n.pageY + e > r.bottom && (s = !1), s ? n.pageY += i.lineHeight : n.pageY -= e, o.style.maxWidth = r.width - (n.pageX - r.left) + "px", this.setPosition(n.pageX, n.pageY));
                }, g.prototype.addMarker = function(e, t) {
                    this.marker && this.$markerSession.removeMarker(this.marker), this.$markerSession = t, this.marker = t && t.addMarker(e, "ace_highlight-marker", "text");
                }, g.prototype.hide = function(e) {
                    !e && document.activeElement == this.getElement() || e && e.target && ("keydown" != e.type || e.ctrlKey || e.metaKey) && this.$element.contains(e.target) || (this.lastEvent = null, this.timeout && clearTimeout(this.timeout), this.timeout = null, this.addMarker(null), this.isOpen && (this.$removeCloseEvents(), this.getElement().style.display = "none", this.isOpen = !1, d.removePopup(this)));
                }, g.prototype.$registerCloseEvents = function() {
                    window.addEventListener("keydown", this.hide, !0), window.addEventListener("mousewheel", this.hide, !0), window.addEventListener("mousedown", this.hide, !0);
                }, g.prototype.$removeCloseEvents = function() {
                    window.removeEventListener("keydown", this.hide, !0), window.removeEventListener("mousewheel", this.hide, !0), window.removeEventListener("mousedown", this.hide, !0);
                }, g.prototype.onMouseOut = function(e) {
                    this.timeout && (clearTimeout(this.timeout), this.timeout = null), this.lastEvent = null, !this.isOpen || !e.relatedTarget || e.relatedTarget == this.getElement() || e && e.currentTarget.contains(e.relatedTarget) || e.relatedTarget.classList.contains("ace_content") || this.hide();
                }, g);
                function g(e) {
                    void 0 === e && (e = document.body);
                    var e = h.call(this, e) || this, t = (e.timeout = void 0, e.lastT = 0, e.idleTime = 350, e.lastEvent = void 0, e.onMouseOut = e.onMouseOut.bind(e), e.onMouseMove = e.onMouseMove.bind(e), e.waitForHover = e.waitForHover.bind(e), e.hide = e.hide.bind(e), e.getElement());
                    return t.style.whiteSpace = "pre-wrap", t.style.pointerEvents = "auto", t.addEventListener("mouseout", e.onMouseOut), t.tabIndex = -1, t.addEventListener("blur", (function() {
                        t.contains(document.activeElement) || this.hide();
                    }).bind(e)), e;
                }
                t.HoverTooltip = o;
            }), ace.define("ace/mouse/default_gutter_handler", [
                "require",
                "exports",
                "module",
                "ace/lib/dom",
                "ace/lib/event",
                "ace/tooltip",
                "ace/config"
            ], function(e, t, n) {
                "use strict";
                var i, o = this && this.__extends || (i = function(e, t) {
                    return (i = Object.setPrototypeOf || (({
                        __proto__: []
                    }) instanceof Array ? function(e, t) {
                        e.__proto__ = t;
                    } : function(e, t) {
                        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                    }))(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function n() {
                        this.constructor = e;
                    }
                    i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
                }), l = this && this.__values || function(e) {
                    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], i = 0;
                    if (n) return n.call(e);
                    if (e && "number" == typeof e.length) return {
                        next: function() {
                            return {
                                value: (e = e && i >= e.length ? void 0 : e) && e[i++],
                                done: !e
                            };
                        }
                    };
                    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                }, d = e("../lib/dom"), u = e("../lib/event"), s = e("../tooltip").Tooltip, r = e("../config").nls;
                t.GutterHandler = function(i) {
                    var o, r, s = i.editor, a = s.renderer.$gutterLayer, l = new g(s);
                    function c() {
                        o = o && clearTimeout(o), l.isOpen && (l.hide(), s._signal("hideGutterTooltip", l), s.off("mousewheel", c));
                    }
                    function h(e) {
                        l.setPosition(e.x, e.y);
                    }
                    i.editor.setDefaultHandler("guttermousedown", function(e) {
                        if (s.isFocused() && 0 == e.getButton()) {
                            var t = a.getRegion(e);
                            if ("foldWidgets" != t) {
                                var t = e.getDocumentPosition().row, n = s.session.selection;
                                if (e.getShiftKey()) n.selectTo(t, 0);
                                else {
                                    if (2 == e.domEvent.detail) return s.selectAll(), e.preventDefault();
                                    i.$clickSelection = s.selection.getLineRange(t);
                                }
                                return i.setState("selectByLines"), i.captureMouse(e), e.preventDefault();
                            }
                        }
                    }), i.editor.setDefaultHandler("guttermousemove", function(e) {
                        var t = e.domEvent.target || e.domEvent.srcElement;
                        if (d.hasCssClass(t, "ace_fold-widget")) return c();
                        l.isOpen && i.$tooltipFollowsMouse && h(e), r = e, o = o || setTimeout(function() {
                            if (o = null, r && !i.isMousePressed) {
                                var e = r.getDocumentPosition().row;
                                if (e == s.session.getLength()) {
                                    var t = s.renderer.pixelToScreenCoordinates(0, r.y).row, n = r.$pos;
                                    if (t > s.session.documentToScreenRow(n.row, n.column)) return void c();
                                }
                                l.showTooltip(e), s.on("mousewheel", c), i.$tooltipFollowsMouse ? h(r) : (t = a.$lines.cells[e].element.querySelector("[class*=ace_icon]").getBoundingClientRect(), (n = l.getElement().style).left = t.right + "px", n.top = t.bottom + "px");
                            } else c();
                        }, 50);
                    }), u.addListener(s.renderer.$gutter, "mouseout", function(e) {
                        r = null, l.isOpen && (o = o || setTimeout(function() {
                            o = null, c();
                        }, 50));
                    }, s), s.on("changeSession", c);
                };
                o(p, a = s), p.prototype.setPosition = function(e, t) {
                    var n = window.innerWidth || document.documentElement.clientWidth, i = window.innerHeight || document.documentElement.clientHeight, o = this.getWidth(), r = this.getHeight();
                    n < (e += 15) + o && (e -= e + o - n), i < (t += 15) + r && (t -= 20 + r), s.prototype.setPosition.call(this, e, t);
                }, Object.defineProperty(p, "annotationLabels", {
                    get: function() {
                        return {
                            error: {
                                singular: r("error"),
                                plural: r("errors")
                            },
                            warning: {
                                singular: r("warning"),
                                plural: r("warnings")
                            },
                            info: {
                                singular: r("information message"),
                                plural: r("information messages")
                            }
                        };
                    },
                    enumerable: !1,
                    configurable: !0
                }), p.prototype.showTooltip = function(e) {
                    var t = this.editor.renderer.$gutterLayer, n = t.$annotations[e], i = n ? {
                        text: Array.from(n.text),
                        type: Array.from(n.type)
                    } : {
                        text: [],
                        type: []
                    }, o = t.session.getFoldLine(e);
                    if (o && t.$showFoldedAnnotations) {
                        for(var r, s = {
                            error: [],
                            warning: [],
                            info: []
                        }, a = e + 1; a <= o.end.row; a++)if (t.$annotations[a]) for(var l = 0; l < t.$annotations[a].text.length; l++){
                            var c = t.$annotations[a].type[l];
                            s[c].push(t.$annotations[a].text[l]), "error" === c ? r = "error_fold" : "warning" === c && (r = "warning_fold");
                        }
                        "error_fold" !== r && "warning_fold" !== r || (n = "".concat(p.annotationsToSummaryString(s), " in folded code."), i.text.push(n), i.type.push(r));
                    }
                    if (0 === i.text.length) return this.hide();
                    for(var h = {
                        error: [],
                        warning: [],
                        info: []
                    }, d = t.$useSvgGutterIcons ? "ace_icon_svg" : "ace_icon", a = 0; a < i.text.length; a++){
                        var u = "<span class='ace_".concat(i.type[a], " ").concat(d, "' aria-label='").concat(p.annotationLabels[i.type[a].replace("_fold", "")].singular, "' role=img> </span> ").concat(i.text[a]);
                        h[i.type[a].replace("_fold", "")].push(u);
                    }
                    e = [].concat(h.error, h.warning, h.info).join("<br>");
                    this.setHtml(e), this.setClassName("ace_gutter-tooltip"), this.$element.setAttribute("aria-live", "polite"), this.isOpen || this.setTheme(this.editor.renderer.theme), this.editor._signal("showGutterTooltip", this), this.show();
                }, p.annotationsToSummaryString = function(e) {
                    var t, n, i = [];
                    try {
                        for(var o = l([
                            "error",
                            "warning",
                            "info"
                        ]), r = o.next(); !r.done; r = o.next()){
                            var s, a = r.value;
                            e[a].length && (s = 1 === e[a].length ? p.annotationLabels[a].singular : p.annotationLabels[a].plural, i.push("".concat(e[a].length, " ").concat(s)));
                        }
                    } catch (e) {
                        t = {
                            error: e
                        };
                    } finally{
                        try {
                            r && !r.done && (n = o.return) && n.call(o);
                        } finally{
                            if (t) throw t.error;
                        }
                    }
                    return i.join(", ");
                };
                var a, g = p;
                function p(e) {
                    var t = a.call(this, e.container) || this;
                    return t.editor = e, t;
                }
                t.GutterTooltip = g;
            }), ace.define("ace/mouse/mouse_event", [
                "require",
                "exports",
                "module",
                "ace/lib/event",
                "ace/lib/useragent"
            ], function(e, t, n) {
                "use strict";
                var i = e("../lib/event"), o = e("../lib/useragent");
                function r(e, t) {
                    this.domEvent = e, this.editor = t, this.x = this.clientX = e.clientX, this.y = this.clientY = e.clientY, this.$pos = null, this.$inSelection = null, this.propagationStopped = !1, this.defaultPrevented = !1;
                }
                r.prototype.stopPropagation = function() {
                    i.stopPropagation(this.domEvent), this.propagationStopped = !0;
                }, r.prototype.preventDefault = function() {
                    i.preventDefault(this.domEvent), this.defaultPrevented = !0;
                }, r.prototype.stop = function() {
                    this.stopPropagation(), this.preventDefault();
                }, r.prototype.getDocumentPosition = function() {
                    return this.$pos || (this.$pos = this.editor.renderer.screenToTextCoordinates(this.clientX, this.clientY)), this.$pos;
                }, r.prototype.inSelection = function() {
                    var e, t;
                    return null === this.$inSelection && ((e = this.editor.getSelectionRange()).isEmpty() ? this.$inSelection = !1 : (t = this.getDocumentPosition(), this.$inSelection = e.contains(t.row, t.column))), this.$inSelection;
                }, r.prototype.getButton = function() {
                    return i.getButton(this.domEvent);
                }, r.prototype.getShiftKey = function() {
                    return this.domEvent.shiftKey;
                }, r.prototype.getAccelKey = function() {
                    return o.isMac ? this.domEvent.metaKey : this.domEvent.ctrlKey;
                }, t.MouseEvent = r;
            }), ace.define("ace/mouse/dragdrop_handler", [
                "require",
                "exports",
                "module",
                "ace/lib/dom",
                "ace/lib/event",
                "ace/lib/useragent"
            ], function(e, t, n) {
                "use strict";
                var w = e("../lib/dom"), S = e("../lib/event"), x = e("../lib/useragent");
                function i(t) {
                    var n, c, h, e, i, d, o, r, u, g, p, m = t.editor, s = w.createElement("div"), a = (s.style.cssText = "top:-100px;position:absolute;z-index:2147483647;opacity:0.5", s.textContent = "\xa0", [
                        "dragWait",
                        "dragWaitEnd",
                        "startDrag",
                        "dragReadyEnd",
                        "onMouseDrag"
                    ].forEach(function(e) {
                        t[e] = this[e];
                    }, this), m.on("mousedown", this.onMouseDown.bind(t)), m.container), l = 0;
                    function f() {
                        var e, t, n, i, o, r, s, a, l = d;
                        d = m.renderer.screenToTextCoordinates(c, h), n = d, t = l, i = Date.now(), e = !t || n.row != t.row, t = !t || n.column != t.column, !g || e || t ? (m.moveCursorToPosition(n), g = i, p = {
                            x: c,
                            y: h
                        }) : 5 < k(p.x, p.y, c, h) ? g = null : 200 <= i - g && (m.renderer.scrollCursorIntoView(), g = null), e = d, t = l, n = Date.now(), i = m.renderer.layerConfig.lineHeight, l = m.renderer.layerConfig.characterWidth, o = m.renderer.scroller.getBoundingClientRect(), o = {
                            x: {
                                left: c - o.left,
                                right: o.right - c
                            },
                            y: {
                                top: h - o.top,
                                bottom: o.bottom - h
                            }
                        }, r = Math.min(o.x.left, o.x.right), s = Math.min(o.y.top, o.y.bottom), a = {
                            row: e.row,
                            column: e.column
                        }, r / l <= 2 && (a.column += o.x.left < o.x.right ? -3 : 2), s / i <= 1 && (a.row += o.y.top < o.y.bottom ? -1 : 1), r = e.row != a.row, l = e.column != a.column, s = !t || e.row != t.row, r || l && !s ? u ? 200 <= n - u && m.renderer.scrollCursorIntoView(a) : u = n : u = null;
                    }
                    function C() {
                        i = m.selection.toOrientedRange(), n = m.session.addMarker(i, "ace_selection", m.getSelectionStyle()), m.clearSelection(), m.isFocused() && m.renderer.$cursorLayer.setBlinking(!1), clearInterval(e), f(), e = setInterval(f, 20), l = 0, S.addListener(document, "mousemove", I);
                    }
                    function y() {
                        clearInterval(e), m.session.removeMarker(n), n = null, m.selection.fromOrientedRange(i), m.isFocused() && !r && m.$resetCursorStyle(), l = 0, g = u = d = i = null, S.removeListener(document, "mousemove", I);
                    }
                    this.onDragStart = function(e) {
                        var t;
                        if (this.cancelDrag || !a.draggable) return t = this, setTimeout(function() {
                            t.startSelect(), t.captureMouse(e);
                        }, 0), e.preventDefault();
                        i = m.getSelectionRange();
                        var n = e.dataTransfer;
                        n.effectAllowed = m.getReadOnly() ? "copy" : "copyMove", m.container.appendChild(s), n.setDragImage && n.setDragImage(s, 0, 0), setTimeout(function() {
                            m.container.removeChild(s);
                        }), n.clearData(), n.setData("Text", m.session.getTextRange()), r = !0, this.setState("drag");
                    }, this.onDragEnd = function(e) {
                        a.draggable = !1, r = !1, this.setState(null), m.getReadOnly() || (e = e.dataTransfer.dropEffect, o || "move" != e || m.session.remove(m.getSelectionRange()), m.$resetCursorStyle()), this.editor.unsetStyle("ace_dragging"), this.editor.renderer.setCursorStyle("");
                    }, this.onDragEnter = function(e) {
                        if (!m.getReadOnly() && b(e.dataTransfer)) return c = e.clientX, h = e.clientY, n || C(), l++, e.dataTransfer.dropEffect = o = A(e), S.preventDefault(e);
                    }, this.onDragOver = function(e) {
                        if (!m.getReadOnly() && b(e.dataTransfer)) return c = e.clientX, h = e.clientY, n || (C(), l++), null !== v && (v = null), e.dataTransfer.dropEffect = o = A(e), S.preventDefault(e);
                    }, this.onDragLeave = function(e) {
                        if (--l <= 0 && n) return y(), o = null, S.preventDefault(e);
                    }, this.onDrop = function(e) {
                        if (d) {
                            var t = e.dataTransfer;
                            if (r) switch(o){
                                case "move":
                                    i = i.contains(d.row, d.column) ? {
                                        start: d,
                                        end: d
                                    } : m.moveText(i, d);
                                    break;
                                case "copy":
                                    i = m.moveText(i, d, !0);
                            }
                            else {
                                t = t.getData("Text");
                                i = {
                                    start: d,
                                    end: m.session.insert(d, t)
                                }, m.focus(), o = null;
                            }
                            return y(), S.preventDefault(e);
                        }
                    }, S.addListener(a, "dragstart", this.onDragStart.bind(t), m), S.addListener(a, "dragend", this.onDragEnd.bind(t), m), S.addListener(a, "dragenter", this.onDragEnter.bind(t), m), S.addListener(a, "dragover", this.onDragOver.bind(t), m), S.addListener(a, "dragleave", this.onDragLeave.bind(t), m), S.addListener(a, "drop", this.onDrop.bind(t), m);
                    var v = null;
                    function I() {
                        null == v && (v = setTimeout(function() {
                            null != v && n && y();
                        }, 20));
                    }
                    function b(e) {
                        e = e.types;
                        return !e || Array.prototype.some.call(e, function(e) {
                            return "text/plain" == e || "Text" == e;
                        });
                    }
                    function A(e) {
                        var t = [
                            "copy",
                            "copymove",
                            "all",
                            "uninitialized"
                        ], n = x.isMac ? e.altKey : e.ctrlKey, i = "uninitialized";
                        try {
                            i = e.dataTransfer.effectAllowed.toLowerCase();
                        } catch (e) {}
                        var o = "none";
                        return n && 0 <= t.indexOf(i) ? o = "copy" : 0 <= [
                            "move",
                            "copymove",
                            "linkmove",
                            "all",
                            "uninitialized"
                        ].indexOf(i) ? o = "move" : 0 <= t.indexOf(i) && (o = "copy"), o;
                    }
                }
                function k(e, t, n, i) {
                    return Math.sqrt(Math.pow(n - e, 2) + Math.pow(i - t, 2));
                }
                (function() {
                    this.dragWait = function() {
                        Date.now() - this.mousedownEvent.time > this.editor.getDragDelay() && this.startDrag();
                    }, this.dragWaitEnd = function() {
                        this.editor.container.draggable = !1, this.startSelect(this.mousedownEvent.getDocumentPosition()), this.selectEnd();
                    }, this.dragReadyEnd = function(e) {
                        this.editor.$resetCursorStyle(), this.editor.unsetStyle("ace_dragging"), this.editor.renderer.setCursorStyle(""), this.dragWaitEnd();
                    }, this.startDrag = function() {
                        this.cancelDrag = !1;
                        var e = this.editor, t = (e.container.draggable = !0, e.renderer.$cursorLayer.setBlinking(!1), e.setStyle("ace_dragging"), x.isWin ? "default" : "move");
                        e.renderer.setCursorStyle(t), this.setState("dragReady");
                    }, this.onMouseDrag = function(e) {
                        var t = this.editor.container;
                        x.isIE && "dragReady" == this.state && 3 < k(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y) && t.dragDrop(), "dragWait" === this.state && 0 < k(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y) && (t.draggable = !1, this.startSelect(this.mousedownEvent.getDocumentPosition()));
                    }, this.onMouseDown = function(e) {
                        var t, n, i;
                        this.$dragEnabled && (this.mousedownEvent = e, t = this.editor, n = e.inSelection(), i = e.getButton(), 1 !== (e.domEvent.detail || 1) || 0 !== i || !n || e.editor.inMultiSelectMode && (e.getAccelKey() || e.getShiftKey()) || (this.mousedownEvent.time = Date.now(), "unselectable" in (i = e.domEvent.target || e.domEvent.srcElement) && (i.unselectable = "on"), t.getDragDelay() ? (x.isWebKit && (this.cancelDrag = !0, t.container.draggable = !0), this.setState("dragWait")) : this.startDrag(), this.captureMouse(e, this.onMouseDrag.bind(this)), e.defaultPrevented = !0));
                    };
                }).call(i.prototype), t.DragdropHandler = i;
            }), ace.define("ace/mouse/touch_handler", [
                "require",
                "exports",
                "module",
                "ace/mouse/mouse_event",
                "ace/lib/event",
                "ace/lib/dom"
            ], function(e, t, n) {
                "use strict";
                var S = e("./mouse_event").MouseEvent, i = e("../lib/event"), a = e("../lib/dom");
                t.addTouchListeners = function(e, h) {
                    var d, u, g, p, m, t, f, C, r, y = "scroll", v = 0, I = 0, b = 0, A = 0;
                    function o() {
                        function t(e) {
                            var t, n = e.target.getAttribute("action");
                            "more" != n && o ? ("paste" == n ? i.readText().then(function(e) {
                                h.execCommand(n, e);
                            }) : n && ("cut" != n && "copy" != n || (i ? i.writeText(h.getCopyText()) : document.execCommand("copy")), h.execCommand(n)), r.firstChild.style.display = "none", o = !1, "openCommandPallete" != n && h.focus()) : (o = !o, e = h.getCopyText(), t = h.session.getUndoManager().hasUndo(), r.replaceChild(a.buildDom(o ? [
                                "span",
                                !e && [
                                    "span",
                                    {
                                        class: "ace_mobile-button",
                                        action: "selectall"
                                    },
                                    "Select All"
                                ],
                                e && [
                                    "span",
                                    {
                                        class: "ace_mobile-button",
                                        action: "copy"
                                    },
                                    "Copy"
                                ],
                                e && [
                                    "span",
                                    {
                                        class: "ace_mobile-button",
                                        action: "cut"
                                    },
                                    "Cut"
                                ],
                                i && [
                                    "span",
                                    {
                                        class: "ace_mobile-button",
                                        action: "paste"
                                    },
                                    "Paste"
                                ],
                                t && [
                                    "span",
                                    {
                                        class: "ace_mobile-button",
                                        action: "undo"
                                    },
                                    "Undo"
                                ],
                                [
                                    "span",
                                    {
                                        class: "ace_mobile-button",
                                        action: "find"
                                    },
                                    "Find"
                                ],
                                [
                                    "span",
                                    {
                                        class: "ace_mobile-button",
                                        action: "openCommandPallete"
                                    },
                                    "Palette"
                                ]
                            ] : [
                                "span"
                            ]), r.firstChild));
                        }
                        var i = window.navigator && window.navigator.clipboard, o = !1;
                        r = a.buildDom([
                            "div",
                            {
                                class: "ace_mobile-menu",
                                ontouchstart: function(e) {
                                    y = "menu", e.stopPropagation(), e.preventDefault(), h.textInput.focus();
                                },
                                ontouchend: function(e) {
                                    e.stopPropagation(), e.preventDefault(), t(e);
                                },
                                onclick: t
                            },
                            [
                                "span"
                            ],
                            [
                                "span",
                                {
                                    class: "ace_mobile-button",
                                    action: "more"
                                },
                                "..."
                            ]
                        ], h.container);
                    }
                    function n() {
                        r || o();
                        var e = h.selection.cursor, e = h.renderer.textToScreenCoordinates(e.row, e.column), t = h.renderer.textToScreenCoordinates(0, 0).pageX, n = h.renderer.scrollLeft, i = h.container.getBoundingClientRect();
                        r.style.top = e.pageY - i.top - 3 + "px", e.pageX - i.left < i.width - 70 ? (r.style.left = "", r.style.right = "10px") : (r.style.right = "", r.style.left = t + n - i.left + "px"), r.style.display = "", r.firstChild.style.display = "none", h.on("input", s);
                    }
                    function s(e) {
                        r && (r.style.display = "none"), h.off("input", s);
                    }
                    function w() {
                        m = null, clearTimeout(m);
                        var e = h.selection.getRange(), t = e.contains(f.row, f.column);
                        !e.isEmpty() && t || (h.selection.moveToPosition(f), h.selection.selectWord()), y = "wait", n();
                    }
                    i.addListener(e, "contextmenu", function(e) {
                        C && h.textInput.getElement().focus();
                    }, h), i.addListener(e, "touchstart", function(e) {
                        var t = e.touches;
                        if (m || 1 < t.length) clearTimeout(m), m = null, g = -1, y = "zoom";
                        else {
                            C = h.$mouseHandler.isMousePressed = !0;
                            var n = h.renderer.layerConfig.lineHeight, i = h.renderer.layerConfig.lineHeight, o = e.timeStamp, r = (p = o, t[0]), s = r.clientX, r = r.clientY, s = (Math.abs(d - s) + Math.abs(u - r) > n && (g = -1), d = e.clientX = s, u = e.clientY = r, b = A = 0, new S(e, h));
                            if (f = s.getDocumentPosition(), o - g < 500 && 1 == t.length && !v) I++, e.preventDefault(), e.button = 0, m = null, clearTimeout(m), h.selection.moveToPosition(f), (r = 2 <= I ? h.selection.getLineRange(f.row) : h.session.getBracketRange(f)) && !r.isEmpty() ? h.selection.setRange(r) : h.selection.selectWord(), y = "wait";
                            else {
                                I = 0;
                                var s = h.selection.cursor, t = h.selection.isEmpty() ? s : h.selection.anchor, r = h.renderer.$cursorLayer.getPixelPosition(s, !0), s = h.renderer.$cursorLayer.getPixelPosition(t, !0), t = h.renderer.scroller.getBoundingClientRect(), a = h.renderer.layerConfig.offset, l = h.renderer.scrollLeft, c = function(e, t) {
                                    return (e /= i) * e + (t = t / n - .75) * t;
                                };
                                if (e.clientX < t.left) return void (y = "zoom");
                                r = c(e.clientX - t.left - r.left + l, e.clientY - t.top - r.top + a), c = c(e.clientX - t.left - s.left + l, e.clientY - t.top - s.top + a);
                                r < 3.5 && c < 3.5 && (y = c < r ? "cursor" : "anchor"), y = c < 3.5 ? "anchor" : r < 3.5 ? "cursor" : "scroll", m = setTimeout(w, 450);
                            }
                            g = o;
                        }
                    }, h), i.addListener(e, "touchend", function(e) {
                        C = h.$mouseHandler.isMousePressed = !1, t && clearInterval(t), "zoom" == y ? (y = "", v = 0) : (m ? (h.selection.moveToPosition(f), v = 0, n) : "scroll" == y ? (v += 60, t = setInterval(function() {
                            v-- <= 0 && (clearInterval(t), t = null), Math.abs(b) < .01 && (b = 0), Math.abs(A) < .01 && (A = 0), v < 20 && (b *= .9), v < 20 && (A *= .9);
                            var e = h.session.getScrollTop();
                            h.renderer.scrollBy(10 * b, 10 * A), e == h.session.getScrollTop() && (v = 0);
                        }, 10), s) : n)(), clearTimeout(m), m = null;
                    }, h), i.addListener(e, "touchmove", function(e) {
                        m && (clearTimeout(m), m = null);
                        var t = e.touches;
                        if (!(1 < t.length || "zoom" == y)) {
                            var t = t[0], n = d - t.clientX, i = u - t.clientY;
                            if ("wait" == y) {
                                if (!(4 < n * n + i * i)) return e.preventDefault();
                                y = "cursor";
                            }
                            d = t.clientX, u = t.clientY, e.clientX = t.clientX, e.clientY = t.clientY;
                            var t = e.timeStamp, o = t - p;
                            p = t, "scroll" == y ? ((t = new S(e, h)).speed = 1, t.wheelX = n, t.wheelY = i, 10 * Math.abs(n) < Math.abs(i) && (n = 0), 10 * Math.abs(i) < Math.abs(n) && (i = 0), 0 != o && (b = n / o, A = i / o), h._emit("mousewheel", t), t.propagationStopped || (b = A = 0)) : (n = new S(e, h).getDocumentPosition(), "cursor" == y ? h.selection.moveCursorToPosition(n) : "anchor" == y && h.selection.setSelectionAnchor(n.row, n.column), h.renderer.scrollCursorIntoView(n), e.preventDefault());
                        }
                    }, h);
                };
            }), ace.define("ace/mouse/mouse_handler", [
                "require",
                "exports",
                "module",
                "ace/lib/event",
                "ace/lib/useragent",
                "ace/mouse/default_handlers",
                "ace/mouse/default_gutter_handler",
                "ace/mouse/mouse_event",
                "ace/mouse/dragdrop_handler",
                "ace/mouse/touch_handler",
                "ace/config"
            ], function(e, t, n) {
                "use strict";
                var h = e("../lib/event"), d = e("../lib/useragent"), r = e("./default_handlers").DefaultHandlers, s = e("./default_gutter_handler").GutterHandler, u = e("./mouse_event").MouseEvent, a = e("./dragdrop_handler").DragdropHandler, l = e("./touch_handler").addTouchListeners, e = e("../config"), i = (o.prototype.onMouseEvent = function(e, t) {
                    this.editor.session && this.editor._emit(e, new u(t, this.editor));
                }, o.prototype.onMouseMove = function(e, t) {
                    var n = this.editor._eventRegistry && this.editor._eventRegistry.mousemove;
                    n && n.length && this.editor._emit(e, new u(t, this.editor));
                }, o.prototype.onMouseWheel = function(e, t) {
                    var n = new u(t, this.editor);
                    n.speed = 2 * this.$scrollSpeed, n.wheelX = t.wheelX, n.wheelY = t.wheelY, this.editor._emit(e, n);
                }, o.prototype.setState = function(e) {
                    this.state = e;
                }, o.prototype.captureMouse = function(e, t) {
                    this.x = e.x, this.y = e.y, this.isMousePressed = !0;
                    function n(e) {
                        if (e) {
                            if (d.isWebKit && !e.which && a.releaseMouse) return a.releaseMouse();
                            a.x = e.clientX, a.y = e.clientY, t && t(e), a.mouseEvent = new u(e, a.editor), a.$mouseMoved = !0;
                        }
                    }
                    function i(e) {
                        r.off("beforeEndOperation", l), clearInterval(c), r.session && o(), a[a.state + "End"] && a[a.state + "End"](e), a.state = "", a.isMousePressed = s.$isMousePressed = !1, s.$keepTextAreaAtCursor && s.$moveTextAreaToCursor(), a.$onCaptureMouseMove = a.releaseMouse = null, e && a.onMouseEvent("mouseup", e), r.endOperation();
                    }
                    function o() {
                        a[a.state] && a[a.state](), a.$mouseMoved = !1;
                    }
                    var r = this.editor, s = this.editor.renderer, a = (s.$isMousePressed = !0, this);
                    if (d.isOldIE && "dblclick" == e.domEvent.type) return setTimeout(function() {
                        i(e);
                    });
                    var l = function(e) {
                        a.releaseMouse && r.curOp.command.name && r.curOp.selectionChanged && (a[a.state + "End"] && a[a.state + "End"](), a.state = "", a.releaseMouse());
                    }, c = (r.on("beforeEndOperation", l), r.startOperation({
                        command: {
                            name: "mouse"
                        }
                    }), a.$onCaptureMouseMove = n, a.releaseMouse = h.capture(this.editor.container, n, i), setInterval(o, 20));
                }, o.prototype.cancelContextMenu = function() {
                    var t = (function(e) {
                        e && e.domEvent && "contextmenu" != e.domEvent.type || (this.editor.off("nativecontextmenu", t), e && e.domEvent && h.stopEvent(e.domEvent));
                    }).bind(this);
                    setTimeout(t, 10), this.editor.on("nativecontextmenu", t);
                }, o.prototype.destroy = function() {
                    this.releaseMouse && this.releaseMouse();
                }, o);
                function o(i) {
                    function e(e) {
                        document.hasFocus && document.hasFocus() && (i.isFocused() || document.activeElement != (i.textInput && i.textInput.getElement())) || window.focus(), i.focus(), setTimeout(function() {
                            i.isFocused() || i.focus();
                        });
                    }
                    var o = this, t = (this.editor = i, new r(this), new s(this), new a(this), i.renderer.getMouseEventTarget()), n = (h.addListener(t, "click", this.onMouseEvent.bind(this, "click"), i), h.addListener(t, "mousemove", this.onMouseMove.bind(this, "mousemove"), i), h.addMultiMouseDownListener([
                        t,
                        i.renderer.scrollBarV && i.renderer.scrollBarV.inner,
                        i.renderer.scrollBarH && i.renderer.scrollBarH.inner,
                        i.textInput && i.textInput.getElement()
                    ].filter(Boolean), [
                        400,
                        300,
                        250
                    ], this, "onMouseEvent", i), h.addMouseWheelListener(i.container, this.onMouseWheel.bind(this, "mousewheel"), i), l(i.container, i), i.renderer.$gutter);
                    h.addListener(n, "mousedown", this.onMouseEvent.bind(this, "guttermousedown"), i), h.addListener(n, "click", this.onMouseEvent.bind(this, "gutterclick"), i), h.addListener(n, "dblclick", this.onMouseEvent.bind(this, "gutterdblclick"), i), h.addListener(n, "mousemove", this.onMouseEvent.bind(this, "guttermousemove"), i), h.addListener(t, "mousedown", e, i), h.addListener(n, "mousedown", e, i), d.isIE && i.renderer.scrollBarV && (h.addListener(i.renderer.scrollBarV.element, "mousedown", e, i), h.addListener(i.renderer.scrollBarH.element, "mousedown", e, i)), i.on("mousemove", function(e) {
                        var t, n;
                        o.state || o.$dragDelay || !o.$dragEnabled || (e = i.renderer.screenToTextCoordinates(e.x, e.y), t = i.session.selection.getRange(), n = i.renderer, !t.isEmpty() && t.insideStart(e.row, e.column) ? n.setCursorStyle("default") : n.setCursorStyle(""));
                    }, i);
                }
                i.prototype.releaseMouse = null, e.defineOptions(i.prototype, "mouseHandler", {
                    scrollSpeed: {
                        initialValue: 2
                    },
                    dragDelay: {
                        initialValue: d.isMac ? 150 : 0
                    },
                    dragEnabled: {
                        initialValue: !0
                    },
                    focusTimeout: {
                        initialValue: 0
                    },
                    tooltipFollowsMouse: {
                        initialValue: !0
                    }
                }), t.MouseHandler = i;
            }), ace.define("ace/mouse/fold_handler", [
                "require",
                "exports",
                "module",
                "ace/lib/dom"
            ], function(e, t, n) {
                "use strict";
                var i = e("../lib/dom");
                t.FoldHandler = function(o) {
                    o.on("click", function(e) {
                        var t = e.getDocumentPosition(), n = o.session, t = n.getFoldAt(t.row, t.column, 1), t = (t && (e.getAccelKey() ? n.removeFold(t) : n.expandFold(t), e.stop()), e.domEvent && e.domEvent.target);
                        t && i.hasCssClass(t, "ace_inline_button") && i.hasCssClass(t, "ace_toggle_wrap") && (n.setOption("wrap", !n.getUseWrapMode()), o.renderer.scrollCursorIntoView());
                    }), o.on("gutterclick", function(e) {
                        var t, n;
                        "foldWidgets" == o.renderer.$gutterLayer.getRegion(e) && (t = e.getDocumentPosition().row, (n = o.session).foldWidgets && n.foldWidgets[t] && o.session.onFoldWidgetClick(t, e), o.isFocused() || o.focus(), e.stop());
                    }), o.on("gutterdblclick", function(e) {
                        var t, n, i;
                        "foldWidgets" == o.renderer.$gutterLayer.getRegion(e) && (i = e.getDocumentPosition().row, (n = (n = (t = o.session).getParentFoldRangeData(i, !0)).range || n.firstRange) && (i = n.start.row, (i = t.getFoldAt(i, t.getLine(i).length, 1)) ? t.removeFold(i) : (t.addFold("...", n), o.renderer.scrollCursorIntoView({
                            row: n.start.row,
                            column: 0
                        }))), e.stop());
                    });
                };
            }), ace.define("ace/keyboard/keybinding", [
                "require",
                "exports",
                "module",
                "ace/lib/keys",
                "ace/lib/event"
            ], function(e, t, n) {
                "use strict";
                var o = e("../lib/keys"), l = e("../lib/event");
                function i(e) {
                    this.$editor = e, this.$data = {
                        editor: e
                    }, this.$handlers = [], this.setDefaultHandler(e.commands);
                }
                i.prototype.setDefaultHandler = function(e) {
                    this.removeKeyboardHandler(this.$defaultHandler), this.$defaultHandler = e, this.addKeyboardHandler(e, 0);
                }, i.prototype.setKeyboardHandler = function(e) {
                    var t = this.$handlers;
                    if (t[t.length - 1] != e) {
                        for(; t[t.length - 1] && t[t.length - 1] != this.$defaultHandler;)this.removeKeyboardHandler(t[t.length - 1]);
                        this.addKeyboardHandler(e, 1);
                    }
                }, i.prototype.addKeyboardHandler = function(e, t) {
                    var n;
                    e && ("function" != typeof e || e.handleKeyboard || (e.handleKeyboard = e), -1 != (n = this.$handlers.indexOf(e)) && this.$handlers.splice(n, 1), null == t ? this.$handlers.push(e) : this.$handlers.splice(t, 0, e), -1 == n) && e.attach && e.attach(this.$editor);
                }, i.prototype.removeKeyboardHandler = function(e) {
                    var t = this.$handlers.indexOf(e);
                    return -1 != t && (this.$handlers.splice(t, 1), e.detach && e.detach(this.$editor), !0);
                }, i.prototype.getKeyboardHandler = function() {
                    return this.$handlers[this.$handlers.length - 1];
                }, i.prototype.getStatusText = function() {
                    var t = this.$data, n = t.editor;
                    return this.$handlers.map(function(e) {
                        return e.getStatusText && e.getStatusText(n, t) || "";
                    }).filter(Boolean).join(" ");
                }, i.prototype.$callKeyboardHandlers = function(e, t, n, i) {
                    for(var o, r = !1, s = this.$editor.commands, a = this.$handlers.length; a-- && !((o = this.$handlers[a].handleKeyboard(this.$data, e, t, n, i)) && o.command && ((r = "null" == o.command || s.exec(o.command, this.$editor, o.args, i)) && i && -1 != e && 1 != o.passEvent && 1 != o.command.passEvent && l.stopEvent(i), r)););
                    return r || -1 != e || (o = {
                        command: "insertstring"
                    }, r = s.exec("insertstring", this.$editor, t)), r && this.$editor._signal && this.$editor._signal("keyboardActivity", o), r;
                }, i.prototype.onCommandKey = function(e, t, n) {
                    var i = o.keyCodeToString(n);
                    return this.$callKeyboardHandlers(t, i, n, e);
                }, i.prototype.onTextInput = function(e) {
                    return this.$callKeyboardHandlers(-1, e);
                }, t.KeyBinding = i;
            }), ace.define("ace/lib/bidiutil", [
                "require",
                "exports",
                "module"
            ], function(e, l, t) {
                "use strict";
                var p = 0, m = 0, f = !1, C = !1, y = !1, v = [
                    [
                        0,
                        3,
                        0,
                        1,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        3,
                        0,
                        1,
                        2,
                        2,
                        0
                    ],
                    [
                        0,
                        3,
                        0,
                        17,
                        2,
                        0,
                        1
                    ],
                    [
                        0,
                        3,
                        5,
                        5,
                        4,
                        1,
                        0
                    ],
                    [
                        0,
                        3,
                        21,
                        21,
                        4,
                        0,
                        1
                    ],
                    [
                        0,
                        3,
                        5,
                        5,
                        4,
                        2,
                        0
                    ]
                ], I = [
                    [
                        2,
                        0,
                        1,
                        1,
                        0,
                        1,
                        0
                    ],
                    [
                        2,
                        0,
                        1,
                        1,
                        0,
                        2,
                        0
                    ],
                    [
                        2,
                        0,
                        2,
                        1,
                        3,
                        2,
                        0
                    ],
                    [
                        2,
                        0,
                        2,
                        33,
                        3,
                        1,
                        1
                    ]
                ], b = 0, A = 1, w = 2, S = 3, x = 4, k = 5, E = 6, T = 7, R = 8, _ = 9, $ = 10, L = 11, N = 12, B = 13, M = 14, W = 15, H = 16, G = 17, P = 18, i = [
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    E,
                    k,
                    E,
                    R,
                    k,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    k,
                    k,
                    k,
                    E,
                    R,
                    x,
                    x,
                    L,
                    L,
                    L,
                    x,
                    x,
                    x,
                    x,
                    x,
                    $,
                    _,
                    $,
                    _,
                    _,
                    w,
                    w,
                    w,
                    w,
                    w,
                    w,
                    w,
                    w,
                    w,
                    w,
                    _,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    x,
                    x,
                    x,
                    x,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    k,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    P,
                    _,
                    x,
                    L,
                    L,
                    L,
                    L,
                    x,
                    x,
                    x,
                    x,
                    b,
                    x,
                    x,
                    P,
                    x,
                    x,
                    L,
                    L,
                    w,
                    w,
                    x,
                    b,
                    x,
                    x,
                    x,
                    w,
                    b,
                    x,
                    x,
                    x,
                    x,
                    x
                ], o = [
                    R,
                    R,
                    R,
                    R,
                    R,
                    R,
                    R,
                    R,
                    R,
                    R,
                    R,
                    P,
                    P,
                    P,
                    b,
                    A,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    R,
                    k,
                    B,
                    M,
                    W,
                    H,
                    G,
                    _,
                    L,
                    L,
                    L,
                    L,
                    L,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    _,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    x,
                    R
                ];
                function c(e, t, n, i) {
                    var o, r, s, a = p ? I : v, l = 0, c = -1, h = null, d = null, u = [];
                    if (!i) for(h = 0, i = []; h < n; h++)i[h] = F(e[h]);
                    for(m = p, y = C = f = !1, d = 0; d < n; d++){
                        if (s = l, u[d] = o = function(e, t, n, i) {
                            var o, r, s, a = t[i];
                            switch(a){
                                case b:
                                case A:
                                    f = !1;
                                case x:
                                case S:
                                    return a;
                                case w:
                                    return f ? S : w;
                                case T:
                                    return f = !0, A;
                                case R:
                                    return x;
                                case _:
                                    return i < 1 || i + 1 >= t.length || (o = n[i - 1]) != w && o != S || (l = t[i + 1]) != w && l != S ? x : (l = f ? S : l) == o ? l : x;
                                case $:
                                    return (o = 0 < i ? n[i - 1] : k) == w && i + 1 < t.length && t[i + 1] == w ? w : x;
                                case L:
                                    if (0 < i && n[i - 1] == w) return w;
                                    if (f) return x;
                                    for(s = i + 1, r = t.length; s < r && t[s] == L;)s++;
                                    return s < r && t[s] == w ? w : x;
                                case N:
                                    for(r = t.length, s = i + 1; s < r && t[s] == N;)s++;
                                    if (s < r) {
                                        var l = e[i], l = 1425 <= l && l <= 2303 || 64286 == l;
                                        if (o = t[s], l && (o == A || o == T)) return A;
                                    }
                                    return i < 1 || (o = t[i - 1]) == k ? x : n[i - 1];
                                case k:
                                    return C = (f = !1, true), p;
                                case E:
                                    return y = !0, x;
                                case B:
                                case M:
                                case H:
                                case G:
                                case W:
                                    f = !1;
                                case P:
                                    return x;
                            }
                        }(e, i, u, d), s = 240 & (l = a[s][o]), l &= 15, t[d] = r = a[l][5], 0 < s) {
                            if (16 == s) for(h = c; h < d; h++)t[h] = 1;
                            c = -1;
                        }
                        if (a[l][6]) -1 == c && (c = d);
                        else if (-1 < c) {
                            for(h = c; h < d; h++)t[h] = r;
                            c = -1;
                        }
                        i[d] == k && (t[d] = 0), m |= r;
                    }
                    if (y) {
                        for(h = 0; h < n; h++)if (i[h] == E) {
                            t[h] = p;
                            for(var g = h - 1; 0 <= g && i[g] == R; g--)t[g] = p;
                        }
                    }
                }
                function h(e, t, n) {
                    if (!(m < e)) {
                        if (1 != e || 1 != p || C) for(var i, o, r, s, a = n.length, l = 0; l < a;){
                            if (t[l] >= e) {
                                for(i = l + 1; i < a && t[i] >= e;)i++;
                                for(o = l, r = i - 1; o < r; o++, r--)s = n[o], n[o] = n[r], n[r] = s;
                                l = i;
                            }
                            l++;
                        }
                        else n.reverse();
                    }
                }
                function F(e) {
                    var t = e.charCodeAt(0), n = t >> 8;
                    return 0 == n ? 191 < t ? b : i[t] : 5 == n ? /[\u0591-\u05f4]/.test(e) ? A : b : 6 == n ? /[\u0610-\u061a\u064b-\u065f\u06d6-\u06e4\u06e7-\u06ed]/.test(e) ? N : /[\u0660-\u0669\u066b-\u066c]/.test(e) ? S : 1642 == t ? L : /[\u06f0-\u06f9]/.test(e) ? w : T : 32 == n && t <= 8287 ? o[255 & t] : 254 == n && 65136 <= t ? T : x;
                }
                l.L = b, l.R = A, l.EN = w, l.ON_R = 3, l.AN = 4, l.R_H = 5, l.B = 6, l.RLE = 7, l.DOT = "\xb7", l.doBidiReorder = function(e, t, n) {
                    if (e.length < 2) return {};
                    var i = e.split(""), o = new Array(i.length), r = new Array(i.length), s = [];
                    p = n ? 1 : 0, c(i, s, i.length, t);
                    for(var a = 0; a < o.length; o[a] = a, a++);
                    h(2, s, o), h(1, s, o);
                    for(a = 0; a < o.length - 1; a++)t[a] === S ? s[a] = l.AN : s[a] === A && (t[a] > T && t[a] < B || t[a] === x || t[a] === P) ? s[a] = l.ON_R : 0 < a && "\u0644" === i[a - 1] && /\u0622|\u0623|\u0625|\u0627/.test(i[a]) && (s[a - 1] = s[a] = l.R_H, a++);
                    i[i.length - 1] === l.DOT && (s[i.length - 1] = l.B), "\u202B" === i[0] && (s[0] = l.RLE);
                    for(a = 0; a < o.length; a++)r[a] = s[o[a]];
                    return {
                        logicalFromVisual: o,
                        bidiLevels: r
                    };
                }, l.hasBidiCharacters = function(e, t) {
                    for(var n = !1, i = 0; i < e.length; i++)t[i] = F(e.charAt(i)), n || t[i] != A && t[i] != T && t[i] != S || (n = !0);
                    return n;
                }, l.getVisualFromLogicalIdx = function(e, t) {
                    for(var n = 0; n < t.logicalFromVisual.length; n++)if (t.logicalFromVisual[n] == e) return n;
                    return 0;
                };
            }), ace.define("ace/bidihandler", [
                "require",
                "exports",
                "module",
                "ace/lib/bidiutil",
                "ace/lib/lang"
            ], function(e, t, n) {
                "use strict";
                var a = e("./lib/bidiutil"), s = e("./lib/lang"), i = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\u202B]/;
                function o(e) {
                    this.session = e, this.bidiMap = {}, this.currentRow = null, this.bidiUtil = a, this.charWidths = [], this.EOL = "\xac", this.showInvisibles = !0, this.isRtlDir = !1, this.$isRtl = !1, this.line = "", this.wrapIndent = 0, this.EOF = "\xb6", this.RLE = "\u202B", this.contentWidth = 0, this.fontMetrics = null, this.rtlLineOffset = 0, this.wrapOffset = 0, this.isMoveLeftOperation = !1, this.seenBidi = i.test(e.getValue());
                }
                o.prototype.isBidiRow = function(e, t, n) {
                    return !!this.seenBidi && (e !== this.currentRow && (this.currentRow = e, this.updateRowLine(t, n), this.updateBidiMap()), this.bidiMap.bidiLevels);
                }, o.prototype.onChange = function(e) {
                    this.seenBidi ? this.currentRow = null : "insert" == e.action && i.test(e.lines.join("\n")) && (this.seenBidi = !0, this.currentRow = null);
                }, o.prototype.getDocumentRow = function() {
                    var e = 0, t = this.session.$screenRowCache;
                    return e = t.length && 0 <= (t = this.session.$getRowCacheIndex(t, this.currentRow)) ? this.session.$docRowCache[t] : e;
                }, o.prototype.getSplitIndex = function() {
                    var e = 0, t = this.session.$screenRowCache;
                    if (t.length) for(var n, i = this.session.$getRowCacheIndex(t, this.currentRow); 0 < this.currentRow - e && (n = this.session.$getRowCacheIndex(t, this.currentRow - e - 1)) === i;)i = n, e++;
                    else e = this.currentRow;
                    return e;
                }, o.prototype.updateRowLine = function(e, t) {
                    var n, i = (e = void 0 === e ? this.getDocumentRow() : e) === this.session.getLength() - 1 ? this.EOF : this.EOL, o = (this.wrapIndent = 0, this.line = this.session.getLine(e), this.isRtlDir = this.$isRtl || this.line.charAt(0) === this.RLE, (!this.session.$useWrapMode || (e = this.session.$wrapData[e]) && (0 < (t = void 0 === t ? this.getSplitIndex() : t) && e.length ? (this.wrapIndent = e.indent, this.wrapOffset = this.wrapIndent * this.charWidths[a.L], this.line = t < e.length ? this.line.substring(e[t - 1], e[t]) : this.line.substring(e[e.length - 1])) : this.line = this.line.substring(0, e[t]), t == e.length)) && (this.line += this.showInvisibles ? i : a.DOT), this.session), r = 0;
                    this.line = this.line.replace(/\t|[\u1100-\u2029, \u202F-\uFFE6]/g, function(e, t) {
                        return "\t" === e || o.isFullWidth(e.charCodeAt(0)) ? (n = "\t" === e ? o.getScreenTabSize(t + r) : 2, r += n - 1, s.stringRepeat(a.DOT, n)) : e;
                    }), this.isRtlDir && (this.fontMetrics.$main.textContent = this.line.charAt(this.line.length - 1) == a.DOT ? this.line.substr(0, this.line.length - 1) : this.line, this.rtlLineOffset = this.contentWidth - this.fontMetrics.$main.getBoundingClientRect().width);
                }, o.prototype.updateBidiMap = function() {
                    var e = [];
                    a.hasBidiCharacters(this.line, e) || this.isRtlDir ? this.bidiMap = a.doBidiReorder(this.line, e, this.isRtlDir) : this.bidiMap = {};
                }, o.prototype.markAsDirty = function() {
                    this.currentRow = null;
                }, o.prototype.updateCharacterWidths = function(e) {
                    var t;
                    this.characterWidth !== e.$characterSize.width && (this.fontMetrics = e, t = this.characterWidth = e.$characterSize.width, e = e.$measureCharWidth("\u05D4"), this.charWidths[a.L] = this.charWidths[a.EN] = this.charWidths[a.ON_R] = t, this.charWidths[a.R] = this.charWidths[a.AN] = e, this.charWidths[a.R_H] = .45 * e, this.charWidths[a.B] = this.charWidths[a.RLE] = 0, this.currentRow = null);
                }, o.prototype.setShowInvisibles = function(e) {
                    this.showInvisibles = e, this.currentRow = null;
                }, o.prototype.setEolChar = function(e) {
                    this.EOL = e;
                }, o.prototype.setContentWidth = function(e) {
                    this.contentWidth = e;
                }, o.prototype.isRtlLine = function(e) {
                    return !!this.$isRtl || (null != e ? this.session.getLine(e).charAt(0) == this.RLE : this.isRtlDir);
                }, o.prototype.setRtlDirection = function(e, t) {
                    for(var n = e.getCursorPosition(), i = e.selection.getSelectionAnchor().row; i <= n.row; i++)t || e.session.getLine(i).charAt(0) !== e.session.$bidiHandler.RLE ? t && e.session.getLine(i).charAt(0) !== e.session.$bidiHandler.RLE && e.session.doc.insert({
                        column: 0,
                        row: i
                    }, e.session.$bidiHandler.RLE) : e.session.doc.removeInLine(i, 0, 1);
                }, o.prototype.getPosLeft = function(e) {
                    e -= this.wrapIndent;
                    var t = this.line.charAt(0) === this.RLE ? 1 : 0, n = t < e ? this.session.getOverwrite() ? e : e - 1 : t, i = a.getVisualFromLogicalIdx(n, this.bidiMap), o = this.bidiMap.bidiLevels, r = 0;
                    !this.session.getOverwrite() && e <= t && o[i] % 2 != 0 && i++;
                    for(var s = 0; s < i; s++)r += this.charWidths[o[s]];
                    return !this.session.getOverwrite() && t < e && o[i] % 2 == 0 && (r += this.charWidths[o[i]]), this.wrapIndent && (r += this.isRtlDir ? -1 * this.wrapOffset : this.wrapOffset), this.isRtlDir && (r += this.rtlLineOffset), r;
                }, o.prototype.getSelections = function(e, t) {
                    var n, i = this.bidiMap, o = i.bidiLevels, r = [], s = 0, a = Math.min(e, t) - this.wrapIndent, l = Math.max(e, t) - this.wrapIndent, c = !1, h = !1, d = 0;
                    this.wrapIndent && (s += this.isRtlDir ? -1 * this.wrapOffset : this.wrapOffset);
                    for(var u, g = 0; g < o.length; g++)u = i.logicalFromVisual[g], n = o[g], (c = a <= u && u < l) && !h ? d = s : !c && h && r.push({
                        left: d,
                        width: s - d
                    }), s += this.charWidths[n], h = c;
                    if (c && g === o.length && r.push({
                        left: d,
                        width: s - d
                    }), this.isRtlDir) for(var p = 0; p < r.length; p++)r[p].left += this.rtlLineOffset;
                    return r;
                }, o.prototype.offsetToCol = function(e) {
                    this.isRtlDir && (e -= this.rtlLineOffset);
                    var t = 0, e = Math.max(e, 0), n = 0, i = 0, o = this.bidiMap.bidiLevels, r = this.charWidths[o[i]];
                    for(this.wrapIndent && (e -= this.isRtlDir ? -1 * this.wrapOffset : this.wrapOffset); n + r / 2 < e;){
                        if (n += r, i === o.length - 1) {
                            r = 0;
                            break;
                        }
                        r = this.charWidths[o[++i]];
                    }
                    return 0 === (t = 0 < i && o[i - 1] % 2 != 0 && o[i] % 2 == 0 ? (e < n && i--, this.bidiMap.logicalFromVisual[i]) : 0 < i && o[i - 1] % 2 == 0 && o[i] % 2 != 0 ? 1 + (n < e ? this.bidiMap.logicalFromVisual[i] : this.bidiMap.logicalFromVisual[i - 1]) : this.isRtlDir && i === o.length - 1 && 0 === r && o[i - 1] % 2 == 0 || !this.isRtlDir && 0 === i && o[i] % 2 != 0 ? 1 + this.bidiMap.logicalFromVisual[i] : (0 < i && o[i - 1] % 2 != 0 && 0 !== r && i--, this.bidiMap.logicalFromVisual[i])) && this.isRtlDir && t++, t + this.wrapIndent;
                }, t.BidiHandler = o;
            }), ace.define("ace/selection", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/lang",
                "ace/lib/event_emitter",
                "ace/range"
            ], function(e, t, n) {
                "use strict";
                function i(e) {
                    this.session = e, this.doc = e.getDocument(), this.clearSelection(), this.cursor = this.lead = this.doc.createAnchor(0, 0), this.anchor = this.doc.createAnchor(0, 0), this.$silent = !1;
                    var t = this;
                    this.cursor.on("change", function(e) {
                        t.$cursorChanged = !0, t.$silent || t._emit("changeCursor"), t.$isEmpty || t.$silent || t._emit("changeSelection"), t.$keepDesiredColumnOnChange || e.old.column == e.value.column || (t.$desiredColumn = null);
                    }), this.anchor.on("change", function() {
                        t.$anchorChanged = !0, t.$isEmpty || t.$silent || t._emit("changeSelection");
                    });
                }
                var o = e("./lib/oop"), r = e("./lib/lang"), s = e("./lib/event_emitter").EventEmitter, a = e("./range").Range;
                (function() {
                    o.implement(this, s), this.isEmpty = function() {
                        return this.$isEmpty || this.anchor.row == this.lead.row && this.anchor.column == this.lead.column;
                    }, this.isMultiLine = function() {
                        return !this.$isEmpty && this.anchor.row != this.cursor.row;
                    }, this.getCursor = function() {
                        return this.lead.getPosition();
                    }, this.setAnchor = function(e, t) {
                        this.$isEmpty = !1, this.anchor.setPosition(e, t);
                    }, this.setSelectionAnchor = this.setAnchor, this.getAnchor = function() {
                        return this.$isEmpty ? this.getSelectionLead() : this.anchor.getPosition();
                    }, this.getSelectionAnchor = this.getAnchor, this.getSelectionLead = function() {
                        return this.lead.getPosition();
                    }, this.isBackwards = function() {
                        var e = this.anchor, t = this.lead;
                        return e.row > t.row || e.row == t.row && e.column > t.column;
                    }, this.getRange = function() {
                        var e = this.anchor, t = this.lead;
                        return this.$isEmpty ? a.fromPoints(t, t) : this.isBackwards() ? a.fromPoints(t, e) : a.fromPoints(e, t);
                    }, this.clearSelection = function() {
                        this.$isEmpty || (this.$isEmpty = !0, this._emit("changeSelection"));
                    }, this.selectAll = function() {
                        this.$setSelection(0, 0, Number.MAX_VALUE, Number.MAX_VALUE);
                    }, this.setRange = this.setSelectionRange = function(e, t) {
                        var n = t ? e.end : e.start, t = t ? e.start : e.end;
                        this.$setSelection(n.row, n.column, t.row, t.column);
                    }, this.$setSelection = function(e, t, n, i) {
                        var o, r;
                        !this.$silent && (o = this.$isEmpty, r = this.inMultiSelectMode, this.$silent = !0, this.$cursorChanged = this.$anchorChanged = !1, this.anchor.setPosition(e, t), this.cursor.setPosition(n, i), this.$isEmpty = !a.comparePoints(this.anchor, this.cursor), this.$silent = !1, this.$cursorChanged && this._emit("changeCursor"), this.$cursorChanged || this.$anchorChanged || o != this.$isEmpty || r) && this._emit("changeSelection");
                    }, this.$moveSelection = function(e) {
                        var t = this.lead;
                        this.$isEmpty && this.setSelectionAnchor(t.row, t.column), e.call(this);
                    }, this.selectTo = function(e, t) {
                        this.$moveSelection(function() {
                            this.moveCursorTo(e, t);
                        });
                    }, this.selectToPosition = function(e) {
                        this.$moveSelection(function() {
                            this.moveCursorToPosition(e);
                        });
                    }, this.moveTo = function(e, t) {
                        this.clearSelection(), this.moveCursorTo(e, t);
                    }, this.moveToPosition = function(e) {
                        this.clearSelection(), this.moveCursorToPosition(e);
                    }, this.selectUp = function() {
                        this.$moveSelection(this.moveCursorUp);
                    }, this.selectDown = function() {
                        this.$moveSelection(this.moveCursorDown);
                    }, this.selectRight = function() {
                        this.$moveSelection(this.moveCursorRight);
                    }, this.selectLeft = function() {
                        this.$moveSelection(this.moveCursorLeft);
                    }, this.selectLineStart = function() {
                        this.$moveSelection(this.moveCursorLineStart);
                    }, this.selectLineEnd = function() {
                        this.$moveSelection(this.moveCursorLineEnd);
                    }, this.selectFileEnd = function() {
                        this.$moveSelection(this.moveCursorFileEnd);
                    }, this.selectFileStart = function() {
                        this.$moveSelection(this.moveCursorFileStart);
                    }, this.selectWordRight = function() {
                        this.$moveSelection(this.moveCursorWordRight);
                    }, this.selectWordLeft = function() {
                        this.$moveSelection(this.moveCursorWordLeft);
                    }, this.getWordRange = function(e, t) {
                        var n;
                        return void 0 === t && (e = (n = e || this.lead).row, t = n.column), this.session.getWordRange(e, t);
                    }, this.selectWord = function() {
                        this.setSelectionRange(this.getWordRange());
                    }, this.selectAWord = function() {
                        var e = this.getCursor(), e = this.session.getAWordRange(e.row, e.column);
                        this.setSelectionRange(e);
                    }, this.getLineRange = function(e, t) {
                        var e = "number" == typeof e ? e : this.lead.row, n = this.session.getFoldLine(e), n = n ? (e = n.start.row, n.end.row) : e;
                        return !0 === t ? new a(e, 0, n, this.session.getLine(n).length) : new a(e, 0, n + 1, 0);
                    }, this.selectLine = function() {
                        this.setSelectionRange(this.getLineRange());
                    }, this.moveCursorUp = function() {
                        this.moveCursorBy(-1, 0);
                    }, this.moveCursorDown = function() {
                        this.moveCursorBy(1, 0);
                    }, this.wouldMoveIntoSoftTab = function(e, t, n) {
                        var i = e.column, o = e.column + t;
                        return n < 0 && (i = e.column - t, o = e.column), this.session.isTabStop(e) && this.doc.getLine(e.row).slice(i, o).split(" ").length - 1 == t;
                    }, this.moveCursorLeft = function() {
                        var e, t = this.lead.getPosition();
                        (e = this.session.getFoldAt(t.row, t.column, -1)) ? this.moveCursorTo(e.start.row, e.start.column) : 0 === t.column ? 0 < t.row && this.moveCursorTo(t.row - 1, this.doc.getLine(t.row - 1).length) : (e = this.session.getTabSize(), this.wouldMoveIntoSoftTab(t, e, -1) && !this.session.getNavigateWithinSoftTabs() ? this.moveCursorBy(0, -e) : this.moveCursorBy(0, -1));
                    }, this.moveCursorRight = function() {
                        var e, t = this.lead.getPosition();
                        (e = this.session.getFoldAt(t.row, t.column, 1)) ? this.moveCursorTo(e.end.row, e.end.column) : this.lead.column == this.doc.getLine(this.lead.row).length ? this.lead.row < this.doc.getLength() - 1 && this.moveCursorTo(this.lead.row + 1, 0) : (e = this.session.getTabSize(), t = this.lead, this.wouldMoveIntoSoftTab(t, e, 1) && !this.session.getNavigateWithinSoftTabs() ? this.moveCursorBy(0, e) : this.moveCursorBy(0, 1));
                    }, this.moveCursorLineStart = function() {
                        var e = this.lead.row, t = this.lead.column, n = this.session.documentToScreenRow(e, t), n = this.session.screenToDocumentPosition(n, 0), e = this.session.getDisplayLine(e, null, n.row, n.column).match(/^\s*/);
                        e[0].length == t || this.session.$useEmacsStyleLineStart || (n.column += e[0].length), this.moveCursorToPosition(n);
                    }, this.moveCursorLineEnd = function() {
                        var e, t = this.lead, t = this.session.getDocumentLastRowColumnPosition(t.row, t.column);
                        this.lead.column == t.column && (e = this.session.getLine(t.row), t.column == e.length) && 0 < (e = e.search(/\s+$/)) && (t.column = e), this.moveCursorTo(t.row, t.column);
                    }, this.moveCursorFileEnd = function() {
                        var e = this.doc.getLength() - 1, t = this.doc.getLine(e).length;
                        this.moveCursorTo(e, t);
                    }, this.moveCursorFileStart = function() {
                        this.moveCursorTo(0, 0);
                    }, this.moveCursorLongWordRight = function() {
                        var e = this.lead.row, t = this.lead.column, n = this.doc.getLine(e), i = n.substring(t), o = (this.session.nonTokenRe.lastIndex = 0, this.session.tokenRe.lastIndex = 0, this.session.getFoldAt(e, t, 1));
                        o ? this.moveCursorTo(o.end.row, o.end.column) : (this.session.nonTokenRe.exec(i) && (t += this.session.nonTokenRe.lastIndex, this.session.nonTokenRe.lastIndex = 0, i = n.substring(t)), t >= n.length ? (this.moveCursorTo(e, n.length), this.moveCursorRight(), e < this.doc.getLength() - 1 && this.moveCursorWordRight()) : (this.session.tokenRe.exec(i) && (t += this.session.tokenRe.lastIndex, this.session.tokenRe.lastIndex = 0), this.moveCursorTo(e, t)));
                    }, this.moveCursorLongWordLeft = function() {
                        var e, t = this.lead.row, n = this.lead.column;
                        (e = this.session.getFoldAt(t, n, -1)) ? this.moveCursorTo(e.start.row, e.start.column) : (null == (e = this.session.getFoldStringAt(t, n, -1)) && (e = this.doc.getLine(t).substring(0, n)), e = r.stringReverse(e), this.session.nonTokenRe.lastIndex = 0, this.session.tokenRe.lastIndex = 0, this.session.nonTokenRe.exec(e) && (n -= this.session.nonTokenRe.lastIndex, e = e.slice(this.session.nonTokenRe.lastIndex), this.session.nonTokenRe.lastIndex = 0), n <= 0 ? (this.moveCursorTo(t, 0), this.moveCursorLeft(), 0 < t && this.moveCursorWordLeft()) : (this.session.tokenRe.exec(e) && (n -= this.session.tokenRe.lastIndex, this.session.tokenRe.lastIndex = 0), this.moveCursorTo(t, n)));
                    }, this.$shortWordEndIndex = function(e) {
                        var t, n = 0, i = /\s/, o = this.session.tokenRe;
                        if (o.lastIndex = 0, this.session.tokenRe.exec(e)) n = this.session.tokenRe.lastIndex;
                        else {
                            for(; (t = e[n]) && i.test(t);)n++;
                            if (n < 1) {
                                for(o.lastIndex = 0; (t = e[n]) && !o.test(t);)if (o.lastIndex = 0, n++, i.test(t)) {
                                    if (2 < n) {
                                        n--;
                                        break;
                                    }
                                    for(; (t = e[n]) && i.test(t);)n++;
                                    if (2 < n) break;
                                }
                            }
                        }
                        return o.lastIndex = 0, n;
                    }, this.moveCursorShortWordRight = function() {
                        var e = this.lead.row, t = this.lead.column, n = this.doc.getLine(e), i = n.substring(t), o = this.session.getFoldAt(e, t, 1);
                        if (o) return this.moveCursorTo(o.end.row, o.end.column);
                        if (t == n.length) {
                            for(var r = this.doc.getLength(); i = this.doc.getLine(++e), e < r && /^\s*$/.test(i););
                            /^\s+/.test(i) || (i = ""), t = 0;
                        }
                        o = this.$shortWordEndIndex(i);
                        this.moveCursorTo(e, t + o);
                    }, this.moveCursorShortWordLeft = function() {
                        var e = this.lead.row, t = this.lead.column;
                        if (i = this.session.getFoldAt(e, t, -1)) return this.moveCursorTo(i.start.row, i.start.column);
                        var n = this.session.getLine(e).substring(0, t);
                        if (0 === t) {
                            for(; n = this.doc.getLine(--e), 0 < e && /^\s*$/.test(n););
                            t = n.length, /\s+$/.test(n) || (n = "");
                        }
                        var i = r.stringReverse(n), i = this.$shortWordEndIndex(i);
                        return this.moveCursorTo(e, t - i);
                    }, this.moveCursorWordRight = function() {
                        this.session.$selectLongWords ? this.moveCursorLongWordRight() : this.moveCursorShortWordRight();
                    }, this.moveCursorWordLeft = function() {
                        this.session.$selectLongWords ? this.moveCursorLongWordLeft() : this.moveCursorShortWordLeft();
                    }, this.moveCursorBy = function(e, t) {
                        var n, i = this.session.documentToScreenPosition(this.lead.row, this.lead.column), o = (0 === t && (0 !== e && (this.session.$bidiHandler.isBidiRow(i.row, this.lead.row) ? (n = this.session.$bidiHandler.getPosLeft(i.column), i.column = Math.round(n / this.session.$bidiHandler.charWidths[0])) : n = i.column * this.session.$bidiHandler.charWidths[0]), this.$desiredColumn ? i.column = this.$desiredColumn : this.$desiredColumn = i.column), 0 != e && this.session.lineWidgets && this.session.lineWidgets[this.lead.row] && (o = this.session.lineWidgets[this.lead.row], e < 0 ? e -= o.rowsAbove || 0 : 0 < e && (e += o.rowCount - (o.rowsAbove || 0))), this.session.screenToDocumentPosition(i.row + e, i.column, n));
                        0 !== e && 0 === t && o.row === this.lead.row && (o.column, this.lead.column), this.moveCursorTo(o.row, o.column + t, 0 === t);
                    }, this.moveCursorToPosition = function(e) {
                        this.moveCursorTo(e.row, e.column);
                    }, this.moveCursorTo = function(e, t, n) {
                        var i = this.session.getFoldAt(e, t, 1), i = (i && (e = i.start.row, t = i.start.column), this.$keepDesiredColumnOnChange = !0, this.session.getLine(e));
                        /[\uDC00-\uDFFF]/.test(i.charAt(t)) && i.charAt(t - 1) && (this.lead.row == e && this.lead.column == t + 1 ? t -= 1 : t += 1), this.lead.setPosition(e, t), this.$keepDesiredColumnOnChange = !1, n || (this.$desiredColumn = null);
                    }, this.moveCursorToScreen = function(e, t, n) {
                        e = this.session.screenToDocumentPosition(e, t);
                        this.moveCursorTo(e.row, e.column, n);
                    }, this.detach = function() {
                        this.lead.detach(), this.anchor.detach();
                    }, this.fromOrientedRange = function(e) {
                        this.setSelectionRange(e, e.cursor == e.start), this.$desiredColumn = e.desiredColumn || this.$desiredColumn;
                    }, this.toOrientedRange = function(e) {
                        var t = this.getRange();
                        return e ? (e.start.column = t.start.column, e.start.row = t.start.row, e.end.column = t.end.column, e.end.row = t.end.row) : e = t, e.cursor = this.isBackwards() ? e.start : e.end, e.desiredColumn = this.$desiredColumn, e;
                    }, this.getRangeOfMovements = function(e) {
                        var t = this.getCursor();
                        try {
                            e(this);
                            var n = this.getCursor();
                            return a.fromPoints(t, n);
                        } catch (e) {
                            return a.fromPoints(t, t);
                        } finally{
                            this.moveCursorToPosition(t);
                        }
                    }, this.toJSON = function() {
                        var e;
                        return this.rangeCount ? e = this.ranges.map(function(e) {
                            var t = e.clone();
                            return t.isBackwards = e.cursor == e.start, t;
                        }) : (e = this.getRange()).isBackwards = this.isBackwards(), e;
                    }, this.fromJSON = function(e) {
                        if (null == e.start) {
                            if (this.rangeList && 1 < e.length) {
                                this.toSingleRange(e[0]);
                                for(var t = e.length; t--;){
                                    var n = a.fromPoints(e[t].start, e[t].end);
                                    e[t].isBackwards && (n.cursor = n.start), this.addRange(n, !0);
                                }
                                return;
                            }
                            e = e[0];
                        }
                        this.rangeList && this.toSingleRange(e), this.setSelectionRange(e, e.isBackwards);
                    }, this.isEqual = function(e) {
                        if ((e.length || this.rangeCount) && e.length != this.rangeCount) return !1;
                        if (!e.length || !this.ranges) return this.getRange().isEqual(e);
                        for(var t = this.ranges.length; t--;)if (!this.ranges[t].isEqual(e[t])) return !1;
                        return !0;
                    };
                }).call(i.prototype), t.Selection = i;
            }), ace.define("ace/tokenizer", [
                "require",
                "exports",
                "module",
                "ace/config"
            ], function(e, t, n) {
                "use strict";
                var e = e("./config"), y = 2e3, i = (o.prototype.$setMaxTokenCount = function(e) {
                    y = 0 | e;
                }, o.prototype.$applyToken = function(e) {
                    var t = this.splitRegex.exec(e).slice(1), n = this.token.apply(this, t);
                    if ("string" == typeof n) return [
                        {
                            type: n,
                            value: e
                        }
                    ];
                    for(var i = [], o = 0, r = n.length; o < r; o++)t[o] && (i[i.length] = {
                        type: n[o],
                        value: t[o]
                    });
                    return i;
                }, o.prototype.$arrayTokens = function(e) {
                    if (!e) return [];
                    var t = this.splitRegex.exec(e);
                    if (!t) return "text";
                    for(var n = [], i = this.tokenArray, o = 0, r = i.length; o < r; o++)t[o + 1] && (n[n.length] = {
                        type: i[o],
                        value: t[o + 1]
                    });
                    return n;
                }, o.prototype.removeCapturingGroups = function(e) {
                    return e.replace(/\\.|\[(?:\\.|[^\\\]])*|\(\?[:=!<]|(\()/g, function(e, t) {
                        return t ? "(?:" : e;
                    });
                }, o.prototype.createSplitterRegexp = function(e, t) {
                    var s, a, l;
                    return "$" != (e = "^" != (e = -1 != e.indexOf("(?=") && (s = 0, a = !1, l = {}, e.replace(/(\\.)|(\((?:\?[=!])?)|(\))|([\[\]])/g, function(e, t, n, i, o, r) {
                        return a ? a = "]" != o : o ? a = !0 : i ? (s == l.stack && (l.end = r + 1, l.stack = -1), s--) : n && (s++, 1 != n.length) && (l.stack = s, l.start = r), e;
                    }), null != l.end) && /^\)*$/.test(e.substr(l.end)) ? e.substring(0, l.start) + e.substr(l.end) : e).charAt(0) ? "^" + e : e).charAt(e.length - 1) && (e += "$"), new RegExp(e, (t || "").replace("g", ""));
                }, o.prototype.getLineTokens = function(e, t) {
                    t && "string" != typeof t ? "#tmp" === (t = (n = t.slice(0))[0]) && (n.shift(), t = n.shift()) : n = [];
                    for(var n, i, o = t || "start", r = (r = this.states[o]) || this.states[o = "start"], s = this.matchMappings[o], a = this.regExps[o], l = [], c = a.lastIndex = 0, h = 0, d = {
                        type: null,
                        value: ""
                    }; i = a.exec(e);){
                        var u, g = s.defaultToken, p = null, m = i[0], f = a.lastIndex;
                        f - m.length > c && (u = e.substring(c, f - m.length), d.type == g ? d.value += u : (d.type && l.push(d), d = {
                            type: g,
                            value: u
                        }));
                        for(var C = 0; C < i.length - 2; C++)if (void 0 !== i[C + 1]) {
                            g = (p = r[s[C]]).onMatch ? p.onMatch(m, o, n, e) : p.token, p.next && (o = "string" == typeof p.next ? p.next : p.next(o, n), (r = this.states[o]) || (this.reportError("state doesn't exist", o), r = this.states[o = "start"]), s = this.matchMappings[o], (a = this.regExps[o]).lastIndex = c = f), p.consumeLineEnd && (c = f);
                            break;
                        }
                        if (m) {
                            if ("string" == typeof g) p && !1 === p.merge || d.type !== g ? (d.type && l.push(d), d = {
                                type: g,
                                value: m
                            }) : d.value += m;
                            else if (g) {
                                d.type && l.push(d);
                                for(d = {
                                    type: null,
                                    value: ""
                                }, C = 0; C < g.length; C++)l.push(g[C]);
                            }
                        }
                        if (c == e.length) break;
                        if (c = f, h++ > y) {
                            for(h > 2 * e.length && this.reportError("infinite loop with in ace tokenizer", {
                                startState: t,
                                line: e
                            }); c < e.length;)d.type && l.push(d), d = {
                                value: e.substring(c, c += 500),
                                type: "overflow"
                            };
                            o = "start", n = [];
                            break;
                        }
                    }
                    return d.type && l.push(d), 1 < n.length && n[0] !== o && n.unshift("#tmp", o), {
                        tokens: l,
                        state: n.length ? n : o
                    };
                }, o);
                function o(e) {
                    for(var t in this.states = e, this.regExps = {}, this.matchMappings = {}, this.states){
                        for(var n = this.states[t], i = [], o = 0, r = this.matchMappings[t] = {
                            defaultToken: "text"
                        }, s = "g", a = [], l = 0; l < n.length; l++){
                            var c, h, d = n[l];
                            d.defaultToken && (r.defaultToken = d.defaultToken), d.caseInsensitive && -1 === s.indexOf("i") && (s += "i"), d.unicode && -1 === s.indexOf("u") && (s += "u"), null == d.regex || (d.regex instanceof RegExp && (d.regex = d.regex.toString().slice(1, -1)), c = d.regex, h = new RegExp("(?:(" + c + ")|(.))").exec("a").length - 2, Array.isArray(d.token) ? 1 == d.token.length || 1 == h ? d.token = d.token[0] : h - 1 != d.token.length ? (this.reportError("number of classes and regexp groups doesn't match", {
                                rule: d,
                                groupCount: h - 1
                            }), d.token = d.token[0]) : (d.tokenArray = d.token, d.token = null, d.onMatch = this.$arrayTokens) : "function" != typeof d.token || d.onMatch || (d.onMatch = 1 < h ? this.$applyToken : d.token), 1 < h && (c = /\\\d/.test(d.regex) ? d.regex.replace(/\\([0-9]+)/g, function(e, t) {
                                return "\\" + (parseInt(t, 10) + o + 1);
                            }) : (h = 1, this.removeCapturingGroups(d.regex)), d.splitRegex || "string" == typeof d.token || a.push(d)), r[o] = l, o += h, i.push(c), d.onMatch) || (d.onMatch = null);
                        }
                        i.length || (r[0] = 0, i.push("$")), a.forEach(function(e) {
                            e.splitRegex = this.createSplitterRegexp(e.regex, s);
                        }, this), this.regExps[t] = new RegExp("(" + i.join(")|(") + ")|($)", s);
                    }
                }
                i.prototype.reportError = e.reportError, t.Tokenizer = i;
            }), ace.define("ace/mode/text_highlight_rules", [
                "require",
                "exports",
                "module",
                "ace/lib/lang"
            ], function(e, t, n) {
                "use strict";
                function i() {
                    this.$rules = {
                        start: [
                            {
                                token: "empty_line",
                                regex: "^$"
                            },
                            {
                                defaultToken: "text"
                            }
                        ]
                    };
                }
                var l = e("../lib/lang");
                (function() {
                    this.addRules = function(e, t) {
                        if (t) for(var n in e){
                            for(var i = e[n], o = 0; o < i.length; o++){
                                var r = i[o];
                                (r.next || r.onMatch) && ("string" == typeof r.next && 0 !== r.next.indexOf(t) && (r.next = t + r.next), r.nextState) && 0 !== r.nextState.indexOf(t) && (r.nextState = t + r.nextState);
                            }
                            this.$rules[t + n] = i;
                        }
                        else for(var n in e)this.$rules[n] = e[n];
                    }, this.getRules = function() {
                        return this.$rules;
                    }, this.embedRules = function(e, t, n, i, o) {
                        e = "function" == typeof e ? (new e).getRules() : e;
                        if (i) for(var r = 0; r < i.length; r++)i[r] = t + i[r];
                        else for(var s in i = [], e)i.push(t + s);
                        if (this.addRules(e, t), n) for(var a = Array.prototype[o ? "push" : "unshift"], r = 0; r < i.length; r++)a.apply(this.$rules[i[r]], l.deepCopy(n));
                        this.$embeds || (this.$embeds = []), this.$embeds.push(t);
                    }, this.getEmbeds = function() {
                        return this.$embeds;
                    };
                    function d(e, t) {
                        return "start" == e && !t.length || t.unshift(this.nextState, e), this.nextState;
                    }
                    function u(e, t) {
                        return t.shift(), t.shift() || "start";
                    }
                    this.normalizeRules = function() {
                        var c = 0, h = this.$rules;
                        Object.keys(h).forEach(function e(t) {
                            var n = h[t];
                            n.processed = !0;
                            for(var i = 0; i < n.length; i++){
                                var o = n[i], r = null, s = (Array.isArray(o) && (r = o, o = {}), !o.regex && o.start && (o.regex = o.start, o.next || (o.next = []), o.next.push({
                                    defaultToken: o.token
                                }, {
                                    token: o.token + ".end",
                                    regex: o.end || o.start,
                                    next: "pop"
                                }), o.token = o.token + ".start", o.push = !0), o.next || o.push);
                                if (s && Array.isArray(s) ? ((l = o.stateName) || ("string" != typeof (l = o.token) && (l = l[0] || ""), h[l] && (l += c++)), h[l] = s, e(o.next = l)) : "pop" == s && (o.next = u), o.push && (o.nextState = o.next || o.push, o.next = d, delete o.push), o.rules) for(var a in o.rules)h[a] ? h[a].push && h[a].push.apply(h[a], o.rules[a]) : h[a] = o.rules[a];
                                var l = "string" == typeof o ? o : o.include;
                                l && ("$self" === l && (l = "start"), r = Array.isArray(l) ? l.map(function(e) {
                                    return h[e];
                                }) : h[l]), r && (s = [
                                    i,
                                    1
                                ].concat(r), o.noEscape && (s = s.filter(function(e) {
                                    return !e.next;
                                })), n.splice.apply(n, s), i--), o.keywordMap && (o.token = this.createKeywordMapper(o.keywordMap, o.defaultToken || "text", o.caseInsensitive), delete o.defaultToken);
                            }
                        }, this);
                    }, this.createKeywordMapper = function(o, t, r, s) {
                        var a = Object.create(null);
                        return this.$keywordList = [], Object.keys(o).forEach(function(e) {
                            for(var t = o[e].split(s || "|"), n = t.length; n--;){
                                var i = t[n];
                                this.$keywordList.push(i), r && (i = i.toLowerCase()), a[i] = e;
                            }
                        }, this), o = null, r ? function(e) {
                            return a[e.toLowerCase()] || t;
                        } : function(e) {
                            return a[e] || t;
                        };
                    }, this.getKeywords = function() {
                        return this.$keywords;
                    };
                }).call(i.prototype), t.TextHighlightRules = i;
            }), ace.define("ace/mode/behaviour", [
                "require",
                "exports",
                "module"
            ], function(e, t, n) {
                "use strict";
                function i() {
                    this.$behaviours = {};
                }
                (function() {
                    this.add = function(e, t, n) {
                        switch(void 0){
                            case this.$behaviours:
                                this.$behaviours = {};
                            case this.$behaviours[e]:
                                this.$behaviours[e] = {};
                        }
                        this.$behaviours[e][t] = n;
                    }, this.addBehaviours = function(e) {
                        for(var t in e)for(var n in e[t])this.add(t, n, e[t][n]);
                    }, this.remove = function(e) {
                        this.$behaviours && this.$behaviours[e] && delete this.$behaviours[e];
                    }, this.inherit = function(e, t) {
                        e = ("function" == typeof e ? new e : e).getBehaviours(t), this.addBehaviours(e);
                    }, this.getBehaviours = function(e) {
                        if (e) {
                            for(var t = {}, n = 0; n < e.length; n++)this.$behaviours[e[n]] && (t[e[n]] = this.$behaviours[e[n]]);
                            return t;
                        }
                        return this.$behaviours;
                    };
                }).call(i.prototype), t.Behaviour = i;
            }), ace.define("ace/token_iterator", [
                "require",
                "exports",
                "module",
                "ace/range"
            ], function(e, t, n) {
                "use strict";
                var i = e("./range").Range;
                function o(e, t, n) {
                    this.$session = e, this.$row = t, this.$rowTokens = e.getTokens(t);
                    e = e.getTokenAt(t, n);
                    this.$tokenIndex = e ? e.index : -1;
                }
                o.prototype.stepBackward = function() {
                    for(--this.$tokenIndex; this.$tokenIndex < 0;){
                        if (--this.$row, this.$row < 0) return this.$row = 0, null;
                        this.$rowTokens = this.$session.getTokens(this.$row), this.$tokenIndex = this.$rowTokens.length - 1;
                    }
                    return this.$rowTokens[this.$tokenIndex];
                }, o.prototype.stepForward = function() {
                    var e;
                    for(this.$tokenIndex += 1; this.$tokenIndex >= this.$rowTokens.length;){
                        if (this.$row += 1, e = e || this.$session.getLength(), this.$row >= e) return this.$row = e - 1, null;
                        this.$rowTokens = this.$session.getTokens(this.$row), this.$tokenIndex = 0;
                    }
                    return this.$rowTokens[this.$tokenIndex];
                }, o.prototype.getCurrentToken = function() {
                    return this.$rowTokens[this.$tokenIndex];
                }, o.prototype.getCurrentTokenRow = function() {
                    return this.$row;
                }, o.prototype.getCurrentTokenColumn = function() {
                    var e = this.$rowTokens, t = this.$tokenIndex, n = e[t].start;
                    if (void 0 === n) for(n = 0; 0 < t;)n += e[--t].value.length;
                    return n;
                }, o.prototype.getCurrentTokenPosition = function() {
                    return {
                        row: this.$row,
                        column: this.getCurrentTokenColumn()
                    };
                }, o.prototype.getCurrentTokenRange = function() {
                    var e = this.$rowTokens[this.$tokenIndex], t = this.getCurrentTokenColumn();
                    return new i(this.$row, t, this.$row, t + e.value.length);
                }, t.TokenIterator = o;
            }), ace.define("ace/mode/behaviour/cstyle", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/mode/behaviour",
                "ace/token_iterator",
                "ace/lib/lang"
            ], function(e, t, n) {
                "use strict";
                function u(e) {
                    var t = -1;
                    if ((l = e.multiSelect && (t = e.selection.index, l.rangeCount != e.multiSelect.rangeCount) ? {
                        rangeCount: e.multiSelect.rangeCount
                    } : l)[t]) return m = l[t];
                    m = l[t] = {
                        autoInsertedBrackets: 0,
                        autoInsertedRow: -1,
                        autoInsertedLineEnd: "",
                        maybeInsertedBrackets: 0,
                        maybeInsertedRow: -1,
                        maybeInsertedLineStart: "",
                        maybeInsertedLineEnd: ""
                    };
                }
                function g(e, t, n, i) {
                    var o = e.end.row - e.start.row;
                    return {
                        text: n + t + i,
                        selection: [
                            0,
                            e.start.column + 1,
                            o,
                            e.end.column + (o ? 0 : 1)
                        ]
                    };
                }
                function p(d) {
                    this.add("braces", "insertion", function(e, t, n, i, o) {
                        var r = n.getCursorPosition(), s = i.doc.getLine(r.row);
                        if ("{" == o) return u(n), l = n.getSelectionRange(), "" !== (c = i.doc.getTextRange(l)) && "{" !== c && n.getWrapBehavioursEnabled() ? g(l, c, "{", "}") : p.isSaneInsertion(n, i) ? /[\]\}\)]/.test(s[r.column]) || n.inMultiSelectMode || d && d.braces ? (p.recordAutoInsert(n, i, "}"), {
                            text: "{}",
                            selection: [
                                1,
                                1
                            ]
                        }) : (p.recordMaybeInsert(n, i, "{"), {
                            text: "{",
                            selection: [
                                1,
                                1
                            ]
                        }) : void 0;
                        if ("}" == o) {
                            u(n);
                            var a = s.substring(r.column, r.column + 1);
                            if ("}" == a) {
                                if (null !== i.$findOpeningBracket("}", {
                                    column: r.column + 1,
                                    row: r.row
                                }) && p.isAutoInsertedClosing(r, s, o)) return p.popAutoInsertedClosing(), {
                                    text: "",
                                    selection: [
                                        1,
                                        1
                                    ]
                                };
                            }
                        } else {
                            if ("\n" == o || "\r\n" == o) {
                                u(n);
                                var l = "";
                                if (p.isMaybeInsertedClosing(r, s) && (l = f.stringRepeat("}", m.maybeInsertedBrackets), p.clearMaybeInsertedClosing()), "}" === (a = s.substring(r.column, r.column + 1))) {
                                    var c = i.findMatchingBracket({
                                        row: r.row,
                                        column: r.column + 1
                                    }, "}");
                                    if (!c) return null;
                                    var h = this.$getIndent(i.getLine(c.row));
                                } else {
                                    if (!l) return void p.clearMaybeInsertedClosing();
                                    h = this.$getIndent(s);
                                }
                                o = h + i.getTabString();
                                return {
                                    text: "\n" + o + "\n" + h + l,
                                    selection: [
                                        1,
                                        o.length,
                                        1,
                                        o.length
                                    ]
                                };
                            }
                            p.clearMaybeInsertedClosing();
                        }
                    }), this.add("braces", "deletion", function(e, t, n, i, o) {
                        var r = i.doc.getTextRange(o);
                        if (!o.isMultiLine() && "{" == r) {
                            if (u(n), "}" == i.doc.getLine(o.start.row).substring(o.end.column, o.end.column + 1)) return o.end.column++, o;
                            m.maybeInsertedBrackets--;
                        }
                    }), this.add("parens", "insertion", function(e, t, n, i, o) {
                        if ("(" == o) return u(n), r = n.getSelectionRange(), "" !== (s = i.doc.getTextRange(r)) && n.getWrapBehavioursEnabled() ? g(r, s, "(", ")") : p.isSaneInsertion(n, i) ? (p.recordAutoInsert(n, i, ")"), {
                            text: "()",
                            selection: [
                                1,
                                1
                            ]
                        }) : void 0;
                        if (")" == o) {
                            u(n);
                            var r = n.getCursorPosition(), s = i.doc.getLine(r.row), n = s.substring(r.column, r.column + 1);
                            if (")" == n) {
                                if (null !== i.$findOpeningBracket(")", {
                                    column: r.column + 1,
                                    row: r.row
                                }) && p.isAutoInsertedClosing(r, s, o)) return p.popAutoInsertedClosing(), {
                                    text: "",
                                    selection: [
                                        1,
                                        1
                                    ]
                                };
                            }
                        }
                    }), this.add("parens", "deletion", function(e, t, n, i, o) {
                        var r = i.doc.getTextRange(o);
                        if (!o.isMultiLine() && "(" == r && (u(n), ")" == i.doc.getLine(o.start.row).substring(o.start.column + 1, o.start.column + 2))) return o.end.column++, o;
                    }), this.add("brackets", "insertion", function(e, t, n, i, o) {
                        if ("[" == o) return u(n), r = n.getSelectionRange(), "" !== (s = i.doc.getTextRange(r)) && n.getWrapBehavioursEnabled() ? g(r, s, "[", "]") : p.isSaneInsertion(n, i) ? (p.recordAutoInsert(n, i, "]"), {
                            text: "[]",
                            selection: [
                                1,
                                1
                            ]
                        }) : void 0;
                        if ("]" == o) {
                            u(n);
                            var r = n.getCursorPosition(), s = i.doc.getLine(r.row), n = s.substring(r.column, r.column + 1);
                            if ("]" == n) {
                                if (null !== i.$findOpeningBracket("]", {
                                    column: r.column + 1,
                                    row: r.row
                                }) && p.isAutoInsertedClosing(r, s, o)) return p.popAutoInsertedClosing(), {
                                    text: "",
                                    selection: [
                                        1,
                                        1
                                    ]
                                };
                            }
                        }
                    }), this.add("brackets", "deletion", function(e, t, n, i, o) {
                        var r = i.doc.getTextRange(o);
                        if (!o.isMultiLine() && "[" == r && (u(n), "]" == i.doc.getLine(o.start.row).substring(o.start.column + 1, o.start.column + 2))) return o.end.column++, o;
                    }), this.add("string_dquotes", "insertion", function(e, t, n, i, o) {
                        var r = i.$mode.$quotes || C;
                        if (1 == o.length && r[o] && (!this.lineCommentStart || -1 == this.lineCommentStart.indexOf(o))) {
                            u(n);
                            var s = n.getSelectionRange(), a = i.doc.getTextRange(s);
                            if (!("" === a || 1 == a.length && r[a]) && n.getWrapBehavioursEnabled()) return g(s, a, o, o);
                            if (!a) {
                                var r = n.getCursorPosition(), s = i.doc.getLine(r.row), a = s.substring(r.column - 1, r.column), n = s.substring(r.column, r.column + 1), l = i.getTokenAt(r.row, r.column), c = i.getTokenAt(r.row, r.column + 1);
                                if ("\\" == a && l && /escape/.test(l.type)) return null;
                                var h, l = l && /string|escape/.test(l.type), d = !c || /string|escape/.test(c.type);
                                if (n == o) (h = l !== d) && /string\.end/.test(c.type) && (h = !1);
                                else {
                                    if (l && !d) return null;
                                    if (l && d) return null;
                                    c = i.$mode.tokenRe, l = (c.lastIndex = 0, c.test(a)), d = (c.lastIndex = 0, c.test(n)), i = i.$mode.$pairQuotesAfter;
                                    if (!(i && i[o] && i[o].test(a)) && l || d) return null;
                                    if (n && !/[\s;,.})\]\\]/.test(n)) return null;
                                    i = s[r.column - 2];
                                    if (a == o && (i == o || c.test(i))) return null;
                                    h = !0;
                                }
                                return {
                                    text: h ? o + o : "",
                                    selection: [
                                        1,
                                        1
                                    ]
                                };
                            }
                        }
                    }), this.add("string_dquotes", "deletion", function(e, t, n, i, o) {
                        var r = i.$mode.$quotes || C, s = i.doc.getTextRange(o);
                        if (!o.isMultiLine() && r.hasOwnProperty(s) && (u(n), i.doc.getLine(o.start.row).substring(o.start.column + 1, o.start.column + 2) == s)) return o.end.column++, o;
                    });
                }
                var m, i = e("../../lib/oop"), o = e("../behaviour").Behaviour, r = e("../../token_iterator").TokenIterator, f = e("../../lib/lang"), s = [
                    "text",
                    "paren.rparen",
                    "rparen",
                    "paren",
                    "punctuation.operator"
                ], a = [
                    "text",
                    "paren.rparen",
                    "rparen",
                    "paren",
                    "punctuation.operator",
                    "comment"
                ], l = {}, C = {
                    '"': '"',
                    "'": "'"
                };
                p.isSaneInsertion = function(e, t) {
                    var n = e.getCursorPosition(), i = new r(t, n.row, n.column);
                    if (!this.$matchTokenType(i.getCurrentToken() || "text", s)) {
                        if (/[)}\]]/.test(e.session.getLine(n.row)[n.column])) return !0;
                        e = new r(t, n.row, n.column + 1);
                        if (!this.$matchTokenType(e.getCurrentToken() || "text", s)) return !1;
                    }
                    return i.stepForward(), i.getCurrentTokenRow() !== n.row || this.$matchTokenType(i.getCurrentToken() || "text", a);
                }, p.$matchTokenType = function(e, t) {
                    return -1 < t.indexOf(e.type || e);
                }, p.recordAutoInsert = function(e, t, n) {
                    e = e.getCursorPosition(), t = t.doc.getLine(e.row);
                    this.isAutoInsertedClosing(e, t, m.autoInsertedLineEnd[0]) || (m.autoInsertedBrackets = 0), m.autoInsertedRow = e.row, m.autoInsertedLineEnd = n + t.substr(e.column), m.autoInsertedBrackets++;
                }, p.recordMaybeInsert = function(e, t, n) {
                    e = e.getCursorPosition(), t = t.doc.getLine(e.row);
                    this.isMaybeInsertedClosing(e, t) || (m.maybeInsertedBrackets = 0), m.maybeInsertedRow = e.row, m.maybeInsertedLineStart = t.substr(0, e.column) + n, m.maybeInsertedLineEnd = t.substr(e.column), m.maybeInsertedBrackets++;
                }, p.isAutoInsertedClosing = function(e, t, n) {
                    return 0 < m.autoInsertedBrackets && e.row === m.autoInsertedRow && n === m.autoInsertedLineEnd[0] && t.substr(e.column) === m.autoInsertedLineEnd;
                }, p.isMaybeInsertedClosing = function(e, t) {
                    return 0 < m.maybeInsertedBrackets && e.row === m.maybeInsertedRow && t.substr(e.column) === m.maybeInsertedLineEnd && t.substr(0, e.column) == m.maybeInsertedLineStart;
                }, p.popAutoInsertedClosing = function() {
                    m.autoInsertedLineEnd = m.autoInsertedLineEnd.substr(1), m.autoInsertedBrackets--;
                }, p.clearMaybeInsertedClosing = function() {
                    m && (m.maybeInsertedBrackets = 0, m.maybeInsertedRow = -1);
                }, i.inherits(p, o), t.CstyleBehaviour = p;
            }), ace.define("ace/unicode", [
                "require",
                "exports",
                "module"
            ], function(e, t, n) {
                "use strict";
                for(var i = [
                    48,
                    9,
                    8,
                    25,
                    5,
                    0,
                    2,
                    25,
                    48,
                    0,
                    11,
                    0,
                    5,
                    0,
                    6,
                    22,
                    2,
                    30,
                    2,
                    457,
                    5,
                    11,
                    15,
                    4,
                    8,
                    0,
                    2,
                    0,
                    18,
                    116,
                    2,
                    1,
                    3,
                    3,
                    9,
                    0,
                    2,
                    2,
                    2,
                    0,
                    2,
                    19,
                    2,
                    82,
                    2,
                    138,
                    2,
                    4,
                    3,
                    155,
                    12,
                    37,
                    3,
                    0,
                    8,
                    38,
                    10,
                    44,
                    2,
                    0,
                    2,
                    1,
                    2,
                    1,
                    2,
                    0,
                    9,
                    26,
                    6,
                    2,
                    30,
                    10,
                    7,
                    61,
                    2,
                    9,
                    5,
                    101,
                    2,
                    7,
                    3,
                    9,
                    2,
                    18,
                    3,
                    0,
                    17,
                    58,
                    3,
                    100,
                    15,
                    53,
                    5,
                    0,
                    6,
                    45,
                    211,
                    57,
                    3,
                    18,
                    2,
                    5,
                    3,
                    11,
                    3,
                    9,
                    2,
                    1,
                    7,
                    6,
                    2,
                    2,
                    2,
                    7,
                    3,
                    1,
                    3,
                    21,
                    2,
                    6,
                    2,
                    0,
                    4,
                    3,
                    3,
                    8,
                    3,
                    1,
                    3,
                    3,
                    9,
                    0,
                    5,
                    1,
                    2,
                    4,
                    3,
                    11,
                    16,
                    2,
                    2,
                    5,
                    5,
                    1,
                    3,
                    21,
                    2,
                    6,
                    2,
                    1,
                    2,
                    1,
                    2,
                    1,
                    3,
                    0,
                    2,
                    4,
                    5,
                    1,
                    3,
                    2,
                    4,
                    0,
                    8,
                    3,
                    2,
                    0,
                    8,
                    15,
                    12,
                    2,
                    2,
                    8,
                    2,
                    2,
                    2,
                    21,
                    2,
                    6,
                    2,
                    1,
                    2,
                    4,
                    3,
                    9,
                    2,
                    2,
                    2,
                    2,
                    3,
                    0,
                    16,
                    3,
                    3,
                    9,
                    18,
                    2,
                    2,
                    7,
                    3,
                    1,
                    3,
                    21,
                    2,
                    6,
                    2,
                    1,
                    2,
                    4,
                    3,
                    8,
                    3,
                    1,
                    3,
                    2,
                    9,
                    1,
                    5,
                    1,
                    2,
                    4,
                    3,
                    9,
                    2,
                    0,
                    17,
                    1,
                    2,
                    5,
                    4,
                    2,
                    2,
                    3,
                    4,
                    1,
                    2,
                    0,
                    2,
                    1,
                    4,
                    1,
                    4,
                    2,
                    4,
                    11,
                    5,
                    4,
                    4,
                    2,
                    2,
                    3,
                    3,
                    0,
                    7,
                    0,
                    15,
                    9,
                    18,
                    2,
                    2,
                    7,
                    2,
                    2,
                    2,
                    22,
                    2,
                    9,
                    2,
                    4,
                    4,
                    7,
                    2,
                    2,
                    2,
                    3,
                    8,
                    1,
                    2,
                    1,
                    7,
                    3,
                    3,
                    9,
                    19,
                    1,
                    2,
                    7,
                    2,
                    2,
                    2,
                    22,
                    2,
                    9,
                    2,
                    4,
                    3,
                    8,
                    2,
                    2,
                    2,
                    3,
                    8,
                    1,
                    8,
                    0,
                    2,
                    3,
                    3,
                    9,
                    19,
                    1,
                    2,
                    7,
                    2,
                    2,
                    2,
                    22,
                    2,
                    15,
                    4,
                    7,
                    2,
                    2,
                    2,
                    3,
                    10,
                    0,
                    9,
                    3,
                    3,
                    9,
                    11,
                    5,
                    3,
                    1,
                    2,
                    17,
                    4,
                    23,
                    2,
                    8,
                    2,
                    0,
                    3,
                    6,
                    4,
                    0,
                    5,
                    5,
                    2,
                    0,
                    2,
                    7,
                    19,
                    1,
                    14,
                    57,
                    6,
                    14,
                    2,
                    9,
                    40,
                    1,
                    2,
                    0,
                    3,
                    1,
                    2,
                    0,
                    3,
                    0,
                    7,
                    3,
                    2,
                    6,
                    2,
                    2,
                    2,
                    0,
                    2,
                    0,
                    3,
                    1,
                    2,
                    12,
                    2,
                    2,
                    3,
                    4,
                    2,
                    0,
                    2,
                    5,
                    3,
                    9,
                    3,
                    1,
                    35,
                    0,
                    24,
                    1,
                    7,
                    9,
                    12,
                    0,
                    2,
                    0,
                    2,
                    0,
                    5,
                    9,
                    2,
                    35,
                    5,
                    19,
                    2,
                    5,
                    5,
                    7,
                    2,
                    35,
                    10,
                    0,
                    58,
                    73,
                    7,
                    77,
                    3,
                    37,
                    11,
                    42,
                    2,
                    0,
                    4,
                    328,
                    2,
                    3,
                    3,
                    6,
                    2,
                    0,
                    2,
                    3,
                    3,
                    40,
                    2,
                    3,
                    3,
                    32,
                    2,
                    3,
                    3,
                    6,
                    2,
                    0,
                    2,
                    3,
                    3,
                    14,
                    2,
                    56,
                    2,
                    3,
                    3,
                    66,
                    5,
                    0,
                    33,
                    15,
                    17,
                    84,
                    13,
                    619,
                    3,
                    16,
                    2,
                    25,
                    6,
                    74,
                    22,
                    12,
                    2,
                    6,
                    12,
                    20,
                    12,
                    19,
                    13,
                    12,
                    2,
                    2,
                    2,
                    1,
                    13,
                    51,
                    3,
                    29,
                    4,
                    0,
                    5,
                    1,
                    3,
                    9,
                    34,
                    2,
                    3,
                    9,
                    7,
                    87,
                    9,
                    42,
                    6,
                    69,
                    11,
                    28,
                    4,
                    11,
                    5,
                    11,
                    11,
                    39,
                    3,
                    4,
                    12,
                    43,
                    5,
                    25,
                    7,
                    10,
                    38,
                    27,
                    5,
                    62,
                    2,
                    28,
                    3,
                    10,
                    7,
                    9,
                    14,
                    0,
                    89,
                    75,
                    5,
                    9,
                    18,
                    8,
                    13,
                    42,
                    4,
                    11,
                    71,
                    55,
                    9,
                    9,
                    4,
                    48,
                    83,
                    2,
                    2,
                    30,
                    14,
                    230,
                    23,
                    280,
                    3,
                    5,
                    3,
                    37,
                    3,
                    5,
                    3,
                    7,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    30,
                    3,
                    52,
                    2,
                    6,
                    2,
                    0,
                    4,
                    2,
                    2,
                    6,
                    4,
                    3,
                    3,
                    5,
                    5,
                    12,
                    6,
                    2,
                    2,
                    6,
                    67,
                    1,
                    20,
                    0,
                    29,
                    0,
                    14,
                    0,
                    17,
                    4,
                    60,
                    12,
                    5,
                    0,
                    4,
                    11,
                    18,
                    0,
                    5,
                    0,
                    3,
                    9,
                    2,
                    0,
                    4,
                    4,
                    7,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    3,
                    2,
                    10,
                    3,
                    3,
                    6,
                    4,
                    5,
                    0,
                    53,
                    1,
                    2684,
                    46,
                    2,
                    46,
                    2,
                    132,
                    7,
                    6,
                    15,
                    37,
                    11,
                    53,
                    10,
                    0,
                    17,
                    22,
                    10,
                    6,
                    2,
                    6,
                    2,
                    6,
                    2,
                    6,
                    2,
                    6,
                    2,
                    6,
                    2,
                    6,
                    2,
                    6,
                    2,
                    31,
                    48,
                    0,
                    470,
                    1,
                    36,
                    5,
                    2,
                    4,
                    6,
                    1,
                    5,
                    85,
                    3,
                    1,
                    3,
                    2,
                    2,
                    89,
                    2,
                    3,
                    6,
                    40,
                    4,
                    93,
                    18,
                    23,
                    57,
                    15,
                    513,
                    6581,
                    75,
                    20939,
                    53,
                    1164,
                    68,
                    45,
                    3,
                    268,
                    4,
                    27,
                    21,
                    31,
                    3,
                    13,
                    13,
                    1,
                    2,
                    24,
                    9,
                    69,
                    11,
                    1,
                    38,
                    8,
                    3,
                    102,
                    3,
                    1,
                    111,
                    44,
                    25,
                    51,
                    13,
                    68,
                    12,
                    9,
                    7,
                    23,
                    4,
                    0,
                    5,
                    45,
                    3,
                    35,
                    13,
                    28,
                    4,
                    64,
                    15,
                    10,
                    39,
                    54,
                    10,
                    13,
                    3,
                    9,
                    7,
                    22,
                    4,
                    1,
                    5,
                    66,
                    25,
                    2,
                    227,
                    42,
                    2,
                    1,
                    3,
                    9,
                    7,
                    11171,
                    13,
                    22,
                    5,
                    48,
                    8453,
                    301,
                    3,
                    61,
                    3,
                    105,
                    39,
                    6,
                    13,
                    4,
                    6,
                    11,
                    2,
                    12,
                    2,
                    4,
                    2,
                    0,
                    2,
                    1,
                    2,
                    1,
                    2,
                    107,
                    34,
                    362,
                    19,
                    63,
                    3,
                    53,
                    41,
                    11,
                    5,
                    15,
                    17,
                    6,
                    13,
                    1,
                    25,
                    2,
                    33,
                    4,
                    2,
                    134,
                    20,
                    9,
                    8,
                    25,
                    5,
                    0,
                    2,
                    25,
                    12,
                    88,
                    4,
                    5,
                    3,
                    5,
                    3,
                    5,
                    3,
                    2
                ], o = 0, r = [], s = 0; s < i.length; s += 2)r.push(o += i[s]), i[s + 1] && r.push(45, o += i[s + 1]);
                t.wordChars = String.fromCharCode.apply(null, r);
            }), ace.define("ace/mode/text", [
                "require",
                "exports",
                "module",
                "ace/config",
                "ace/tokenizer",
                "ace/mode/text_highlight_rules",
                "ace/mode/behaviour/cstyle",
                "ace/unicode",
                "ace/lib/lang",
                "ace/token_iterator",
                "ace/range"
            ], function(e, t, n) {
                "use strict";
                function i() {
                    this.HighlightRules = r;
                }
                var s = e("../config"), o = e("../tokenizer").Tokenizer, r = e("./text_highlight_rules").TextHighlightRules, a = e("./behaviour/cstyle").CstyleBehaviour, l = e("../unicode"), b = e("../lib/lang"), m = e("../token_iterator").TokenIterator, f = e("../range").Range;
                (function() {
                    this.$defaultBehaviour = new a, this.tokenRe = new RegExp("^[" + l.wordChars + "\\$_]+", "g"), this.nonTokenRe = new RegExp("^(?:[^" + l.wordChars + "\\$_]|\\s])+", "g"), this.getTokenizer = function() {
                        return this.$tokenizer || (this.$highlightRules = this.$highlightRules || new this.HighlightRules(this.$highlightRuleConfig), this.$tokenizer = new o(this.$highlightRules.getRules())), this.$tokenizer;
                    }, this.lineCommentStart = "", this.blockComment = "", this.toggleCommentLines = function(e, o, n, i) {
                        var r = o.doc, s = !0, a = !0, l = 1 / 0, c = o.getTabSize(), t = !1;
                        if (this.lineCommentStart) {
                            m = Array.isArray(this.lineCommentStart) ? (C = this.lineCommentStart.map(b.escapeRegExp).join("|"), this.lineCommentStart[0]) : (C = b.escapeRegExp(this.lineCommentStart), this.lineCommentStart), C = new RegExp("^(\\s*)(?:" + C + ") ?"), t = o.getUseSoftTabs();
                            var h = function(e, t) {
                                var n, i, o = e.match(C);
                                o && (n = o[1].length, i = o[0].length, p(e, n, i) || " " != o[0][i - 1] || i--, r.removeInLine(t, n, i));
                            }, d = m + " ", u = function(e, t) {
                                s && !/\S/.test(e) || (p(e, l, l) ? r.insertInLine({
                                    row: t,
                                    column: l
                                }, d) : r.insertInLine({
                                    row: t,
                                    column: l
                                }, m));
                            }, g = function(e, t) {
                                return C.test(e);
                            }, p = function(e, t, n) {
                                for(var i = 0; t-- && " " == e.charAt(t);)i++;
                                if (i % c != 0) return !1;
                                for(i = 0; " " == e.charAt(n++);)i++;
                                return 2 < c ? i % c != c - 1 : i % c == 0;
                            };
                        } else {
                            if (!this.blockComment) return !1;
                            var m = this.blockComment.start, f = this.blockComment.end, C = new RegExp("^(\\s*)(?:" + b.escapeRegExp(m) + ")"), y = new RegExp("(?:" + b.escapeRegExp(f) + ")\\s*$"), u = function(e, t) {
                                g(e, t) || s && !/\S/.test(e) || (r.insertInLine({
                                    row: t,
                                    column: e.length
                                }, f), r.insertInLine({
                                    row: t,
                                    column: l
                                }, m));
                            }, h = function(e, t) {
                                var n;
                                (n = e.match(y)) && r.removeInLine(t, e.length - n[0].length, e.length), (n = e.match(C)) && r.removeInLine(t, n[1].length, n[0].length);
                            }, g = function(e, t) {
                                if (C.test(e)) return !0;
                                for(var n = o.getTokens(t), i = 0; i < n.length; i++)if ("comment" === n[i].type) return !0;
                            };
                        }
                        function v(e) {
                            for(var t = n; t <= i; t++)e(r.getLine(t), t);
                        }
                        var I = 1 / 0;
                        v(function(e, t) {
                            var n = e.search(/\S/);
                            -1 !== n ? (n < l && (l = n), a && !g(e, t) && (a = !1)) : I > e.length && (I = e.length);
                        }), l == 1 / 0 && (l = I, a = s = !1), t && l % c != 0 && (l = Math.floor(l / c) * c), v(a ? h : u);
                    }, this.toggleBlockComment = function(e, t, n, i) {
                        var o = this.blockComment;
                        if (o) {
                            !o.start && o[0] && (o = o[0]);
                            var r, s, a = (u = new m(t, i.row, i.column)).getCurrentToken(), l = (t.selection, t.selection.toOrientedRange());
                            if (a && /comment/.test(a.type)) {
                                for(; a && /comment/.test(a.type);){
                                    if (-1 != (g = a.value.indexOf(o.start))) {
                                        var c = u.getCurrentTokenRow(), h = u.getCurrentTokenColumn() + g, d = new f(c, h, c, h + o.start.length);
                                        break;
                                    }
                                    a = u.stepBackward();
                                }
                                for(var u, g, a = (u = new m(t, i.row, i.column)).getCurrentToken(); a && /comment/.test(a.type);){
                                    if (-1 != (g = a.value.indexOf(o.end))) {
                                        var c = u.getCurrentTokenRow(), h = u.getCurrentTokenColumn() + g, p = new f(c, h, c, h + o.end.length);
                                        break;
                                    }
                                    a = u.stepForward();
                                }
                                p && t.remove(p), d && (t.remove(d), r = d.start.row, s = -o.start.length);
                            } else s = o.start.length, r = n.start.row, t.insert(n.end, o.end), t.insert(n.start, o.start);
                            l.start.row == r && (l.start.column += s), l.end.row == r && (l.end.column += s), t.selection.fromOrientedRange(l);
                        }
                    }, this.getNextLineIndent = function(e, t, n) {
                        return this.$getIndent(t);
                    }, this.checkOutdent = function(e, t, n) {
                        return !1;
                    }, this.autoOutdent = function(e, t, n) {}, this.$getIndent = function(e) {
                        return e.match(/^\s*/)[0];
                    }, this.createWorker = function(e) {
                        return null;
                    }, this.createModeDelegates = function(e) {
                        for(var i in this.$embeds = [], this.$modes = {}, e){
                            var t, n, o;
                            e[i] && (n = (t = e[i]).prototype.$id, (o = s.$modes[n]) || (s.$modes[n] = o = new t), s.$modes[i] || (s.$modes[i] = o), this.$embeds.push(i), this.$modes[i] = o);
                        }
                        for(var r = [
                            "toggleBlockComment",
                            "toggleCommentLines",
                            "getNextLineIndent",
                            "checkOutdent",
                            "autoOutdent",
                            "transformAction",
                            "getCompletions"
                        ], i = 0; i < r.length; i++)!function(e) {
                            var t = r[i], n = e[t];
                            e[r[i]] = function() {
                                return this.$delegator(t, arguments, n);
                            };
                        }(this);
                    }, this.$delegator = function(e, t, n) {
                        var i = t[0] || "start";
                        if ("string" != typeof i) {
                            if (Array.isArray(i[2])) {
                                var o = i[2][i[2].length - 1];
                                if (s = this.$modes[o]) return s[e].apply(s, [
                                    i[1]
                                ].concat([].slice.call(t, 1)));
                            }
                            i = i[0] || "start";
                        }
                        for(var r = 0; r < this.$embeds.length; r++)if (this.$modes[this.$embeds[r]]) {
                            var s, a = i.split(this.$embeds[r]);
                            if (!a[0] && a[1]) return t[0] = a[1], (s = this.$modes[this.$embeds[r]])[e].apply(s, t);
                        }
                        o = n.apply(this, t);
                        return n ? o : void 0;
                    }, this.transformAction = function(e, t, n, i, o) {
                        if (this.$behaviour) {
                            var r, s = this.$behaviour.getBehaviours();
                            for(r in s)if (s[r][t]) {
                                var a = s[r][t].apply(this, arguments);
                                if (a) return a;
                            }
                        }
                    }, this.getKeywords = function(e) {
                        if (!this.completionKeywords) {
                            var t = this.$tokenizer.rules, n = [];
                            for(s in t)for(var i = t[s], o = 0, r = i.length; o < r; o++)if ("string" == typeof i[o].token) /keyword|support|storage/.test(i[o].token) && n.push(i[o].regex);
                            else if ("object" == typeof i[o].token) for(var s, a = 0, l = i[o].token.length; a < l; a++)/keyword|support|storage/.test(i[o].token[a]) && (s = i[o].regex.match(/\(.+?\)/g)[a], n.push(s.substr(1, s.length - 2)));
                            this.completionKeywords = n;
                        }
                        return e ? n.concat(this.$keywordList || []) : this.$keywordList;
                    }, this.$createKeywordList = function() {
                        return this.$highlightRules || this.getTokenizer(), this.$keywordList = this.$highlightRules.$keywordList || [];
                    }, this.getCompletions = function(e, t, n, i) {
                        return (this.$keywordList || this.$createKeywordList()).map(function(e) {
                            return {
                                name: e,
                                value: e,
                                score: 0,
                                meta: "keyword"
                            };
                        });
                    }, this.$id = "ace/mode/text";
                }).call(i.prototype), t.Mode = i;
            }), ace.define("ace/apply_delta", [
                "require",
                "exports",
                "module"
            ], function(e, t, n) {
                "use strict";
                t.applyDelta = function(e, t, n) {
                    var i = t.start.row, o = t.start.column, r = e[i] || "";
                    switch(t.action){
                        case "insert":
                            1 === t.lines.length ? e[i] = r.substring(0, o) + t.lines[0] + r.substring(o) : (s = [
                                i,
                                1
                            ].concat(t.lines), e.splice.apply(e, s), e[i] = r.substring(0, o) + e[i], e[i + t.lines.length - 1] += r.substring(o));
                            break;
                        case "remove":
                            var s = t.end.column, a = t.end.row;
                            i === a ? e[i] = r.substring(0, o) + r.substring(s) : e.splice(i, a - i + 1, r.substring(0, o) + e[a].substring(s));
                    }
                };
            }), ace.define("ace/anchor", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/event_emitter"
            ], function(e, t, n) {
                "use strict";
                var i = e("./lib/oop"), e = e("./lib/event_emitter").EventEmitter, o = (r.prototype.getPosition = function() {
                    return this.$clipPositionToDocument(this.row, this.column);
                }, r.prototype.getDocument = function() {
                    return this.document;
                }, r.prototype.onChange = function(e) {
                    e.start.row == e.end.row && e.start.row != this.row || e.start.row > this.row || (e = function(e, t, n) {
                        var i = "insert" == e.action, o = (i ? 1 : -1) * (e.end.row - e.start.row), r = (i ? 1 : -1) * (e.end.column - e.start.column), s = e.start, i = i ? s : e.end;
                        if (a(t, s, n)) return {
                            row: t.row,
                            column: t.column
                        };
                        if (a(i, t, !n)) return {
                            row: t.row + o,
                            column: t.column + (t.row == i.row ? r : 0)
                        };
                        return {
                            row: s.row,
                            column: s.column
                        };
                    }(e, {
                        row: this.row,
                        column: this.column
                    }, this.$insertRight), this.setPosition(e.row, e.column, !0));
                }, r.prototype.setPosition = function(e, t, n) {
                    n = n ? {
                        row: e,
                        column: t
                    } : this.$clipPositionToDocument(e, t);
                    this.row == n.row && this.column == n.column || (e = {
                        row: this.row,
                        column: this.column
                    }, this.row = n.row, this.column = n.column, this._signal("change", {
                        old: e,
                        value: n
                    }));
                }, r.prototype.detach = function() {
                    this.document.off("change", this.$onChange);
                }, r.prototype.attach = function(e) {
                    this.document = e || this.document, this.document.on("change", this.$onChange);
                }, r.prototype.$clipPositionToDocument = function(e, t) {
                    var n = {};
                    return e >= this.document.getLength() ? (n.row = Math.max(0, this.document.getLength() - 1), n.column = this.document.getLine(n.row).length) : e < 0 ? (n.row = 0, n.column = 0) : (n.row = e, n.column = Math.min(this.document.getLine(n.row).length, Math.max(0, t))), t < 0 && (n.column = 0), n;
                }, r);
                function r(e, t, n) {
                    this.$onChange = this.onChange.bind(this), this.attach(e), void 0 === n ? this.setPosition(t.row, t.column) : this.setPosition(t, n);
                }
                function a(e, t, n) {
                    n = n ? e.column <= t.column : e.column < t.column;
                    return e.row < t.row || e.row == t.row && n;
                }
                o.prototype.$insertRight = !1, i.implement(o.prototype, e), t.Anchor = o;
            }), ace.define("ace/document", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/apply_delta",
                "ace/lib/event_emitter",
                "ace/range",
                "ace/anchor"
            ], function(e, t, n) {
                "use strict";
                var i = e("./lib/oop"), o = e("./apply_delta").applyDelta, r = e("./lib/event_emitter").EventEmitter, s = e("./range").Range, a = e("./anchor").Anchor, e = (l.prototype.setValue = function(e) {
                    var t = this.getLength() - 1;
                    this.remove(new s(0, 0, t, this.getLine(t).length)), this.insert({
                        row: 0,
                        column: 0
                    }, e || "");
                }, l.prototype.getValue = function() {
                    return this.getAllLines().join(this.getNewLineCharacter());
                }, l.prototype.createAnchor = function(e, t) {
                    return new a(this, e, t);
                }, l.prototype.$detectNewLine = function(e) {
                    e = e.match(/^.*?(\r\n|\r|\n)/m);
                    this.$autoNewLine = e ? e[1] : "\n", this._signal("changeNewLineMode");
                }, l.prototype.getNewLineCharacter = function() {
                    switch(this.$newLineMode){
                        case "windows":
                            return "\r\n";
                        case "unix":
                            return "\n";
                        default:
                            return this.$autoNewLine || "\n";
                    }
                }, l.prototype.setNewLineMode = function(e) {
                    this.$newLineMode !== e && (this.$newLineMode = e, this._signal("changeNewLineMode"));
                }, l.prototype.getNewLineMode = function() {
                    return this.$newLineMode;
                }, l.prototype.isNewLine = function(e) {
                    return "\r\n" == e || "\r" == e || "\n" == e;
                }, l.prototype.getLine = function(e) {
                    return this.$lines[e] || "";
                }, l.prototype.getLines = function(e, t) {
                    return this.$lines.slice(e, t + 1);
                }, l.prototype.getAllLines = function() {
                    return this.getLines(0, this.getLength());
                }, l.prototype.getLength = function() {
                    return this.$lines.length;
                }, l.prototype.getTextRange = function(e) {
                    return this.getLinesForRange(e).join(this.getNewLineCharacter());
                }, l.prototype.getLinesForRange = function(e) {
                    var t, n;
                    return e.start.row === e.end.row ? t = [
                        this.getLine(e.start.row).substring(e.start.column, e.end.column)
                    ] : ((t = this.getLines(e.start.row, e.end.row))[0] = (t[0] || "").substring(e.start.column), n = t.length - 1, e.end.row - e.start.row == n && (t[n] = t[n].substring(0, e.end.column))), t;
                }, l.prototype.insertLines = function(e, t) {
                    return console.warn("Use of document.insertLines is deprecated. Use the insertFullLines method instead."), this.insertFullLines(e, t);
                }, l.prototype.removeLines = function(e, t) {
                    return console.warn("Use of document.removeLines is deprecated. Use the removeFullLines method instead."), this.removeFullLines(e, t);
                }, l.prototype.insertNewLine = function(e) {
                    return console.warn("Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead."), this.insertMergedLines(e, [
                        "",
                        ""
                    ]);
                }, l.prototype.insert = function(e, t) {
                    return this.getLength() <= 1 && this.$detectNewLine(t), this.insertMergedLines(e, this.$split(t));
                }, l.prototype.insertInLine = function(e, t) {
                    var n = this.clippedPos(e.row, e.column), e = this.pos(e.row, e.column + t.length);
                    return this.applyDelta({
                        start: n,
                        end: e,
                        action: "insert",
                        lines: [
                            t
                        ]
                    }, !0), this.clonePos(e);
                }, l.prototype.clippedPos = function(e, t) {
                    var n = this.getLength(), n = (void 0 === e ? e = n : e < 0 ? e = 0 : n <= e && (e = n - 1, t = void 0), this.getLine(e));
                    return null == t && (t = n.length), {
                        row: e,
                        column: t = Math.min(Math.max(t, 0), n.length)
                    };
                }, l.prototype.clonePos = function(e) {
                    return {
                        row: e.row,
                        column: e.column
                    };
                }, l.prototype.pos = function(e, t) {
                    return {
                        row: e,
                        column: t
                    };
                }, l.prototype.$clipPosition = function(e) {
                    var t = this.getLength();
                    return e.row >= t ? (e.row = Math.max(0, t - 1), e.column = this.getLine(t - 1).length) : (e.row = Math.max(0, e.row), e.column = Math.min(Math.max(e.column, 0), this.getLine(e.row).length)), e;
                }, l.prototype.insertFullLines = function(e, t) {
                    var n = 0, n = (e = Math.min(Math.max(e, 0), this.getLength())) < this.getLength() ? (t = t.concat([
                        ""
                    ]), 0) : (t = [
                        ""
                    ].concat(t), this.$lines[--e].length);
                    this.insertMergedLines({
                        row: e,
                        column: n
                    }, t);
                }, l.prototype.insertMergedLines = function(e, t) {
                    var e = this.clippedPos(e.row, e.column), n = {
                        row: e.row + t.length - 1,
                        column: (1 == t.length ? e.column : 0) + t[t.length - 1].length
                    };
                    return this.applyDelta({
                        start: e,
                        end: n,
                        action: "insert",
                        lines: t
                    }), this.clonePos(n);
                }, l.prototype.remove = function(e) {
                    var t = this.clippedPos(e.start.row, e.start.column), e = this.clippedPos(e.end.row, e.end.column);
                    return this.applyDelta({
                        start: t,
                        end: e,
                        action: "remove",
                        lines: this.getLinesForRange({
                            start: t,
                            end: e
                        })
                    }), this.clonePos(t);
                }, l.prototype.removeInLine = function(e, t, n) {
                    t = this.clippedPos(e, t), e = this.clippedPos(e, n);
                    return this.applyDelta({
                        start: t,
                        end: e,
                        action: "remove",
                        lines: this.getLinesForRange({
                            start: t,
                            end: e
                        })
                    }, !0), this.clonePos(t);
                }, l.prototype.removeFullLines = function(e, t) {
                    e = Math.min(Math.max(0, e), this.getLength() - 1);
                    var n = (t = Math.min(Math.max(0, t), this.getLength() - 1)) == this.getLength() - 1 && 0 < e, i = t < this.getLength() - 1, o = n ? e - 1 : e, n = n ? this.getLine(o).length : 0, r = i ? t + 1 : t, i = i ? 0 : this.getLine(r).length, o = new s(o, n, r, i), n = this.$lines.slice(e, t + 1);
                    return this.applyDelta({
                        start: o.start,
                        end: o.end,
                        action: "remove",
                        lines: this.getLinesForRange(o)
                    }), n;
                }, l.prototype.removeNewLine = function(e) {
                    e < this.getLength() - 1 && 0 <= e && this.applyDelta({
                        start: this.pos(e, this.getLine(e).length),
                        end: this.pos(e + 1, 0),
                        action: "remove",
                        lines: [
                            "",
                            ""
                        ]
                    });
                }, l.prototype.replace = function(e, t) {
                    return e instanceof s || (e = s.fromPoints(e.start, e.end)), 0 === t.length && e.isEmpty() ? e.start : t == this.getTextRange(e) ? e.end : (this.remove(e), t ? this.insert(e.start, t) : e.start);
                }, l.prototype.applyDeltas = function(e) {
                    for(var t = 0; t < e.length; t++)this.applyDelta(e[t]);
                }, l.prototype.revertDeltas = function(e) {
                    for(var t = e.length - 1; 0 <= t; t--)this.revertDelta(e[t]);
                }, l.prototype.applyDelta = function(e, t) {
                    var n = "insert" == e.action;
                    (n ? e.lines.length <= 1 && !e.lines[0] : !s.comparePoints(e.start, e.end)) || (n && 2e4 < e.lines.length ? this.$splitAndapplyLargeDelta(e, 2e4) : (o(this.$lines, e, t), this._signal("change", e)));
                }, l.prototype.$safeApplyDelta = function(e) {
                    var t = this.$lines.length;
                    ("remove" == e.action && e.start.row < t && e.end.row < t || "insert" == e.action && e.start.row <= t) && this.applyDelta(e);
                }, l.prototype.$splitAndapplyLargeDelta = function(e, t) {
                    for(var n = e.lines, i = n.length - t + 1, o = e.start.row, r = e.start.column, s = 0, a = 0; s < i; s = a){
                        a += t - 1;
                        var l = n.slice(s, a);
                        l.push(""), this.applyDelta({
                            start: this.pos(o + s, r),
                            end: this.pos(o + a, r = 0),
                            action: e.action,
                            lines: l
                        }, !0);
                    }
                    e.lines = n.slice(s), e.start.row = o + s, e.start.column = r, this.applyDelta(e, !0);
                }, l.prototype.revertDelta = function(e) {
                    this.$safeApplyDelta({
                        start: this.clonePos(e.start),
                        end: this.clonePos(e.end),
                        action: "insert" == e.action ? "remove" : "insert",
                        lines: e.lines.slice()
                    });
                }, l.prototype.indexToPosition = function(e, t) {
                    for(var n = this.$lines || this.getAllLines(), i = this.getNewLineCharacter().length, o = t || 0, r = n.length; o < r; o++)if ((e -= n[o].length + i) < 0) return {
                        row: o,
                        column: e + n[o].length + i
                    };
                    return {
                        row: r - 1,
                        column: e + n[r - 1].length + i
                    };
                }, l.prototype.positionToIndex = function(e, t) {
                    for(var n = this.$lines || this.getAllLines(), i = this.getNewLineCharacter().length, o = 0, r = Math.min(e.row, n.length), s = t || 0; s < r; ++s)o += n[s].length + i;
                    return o + e.column;
                }, l.prototype.$split = function(e) {
                    return e.split(/\r\n|\r|\n/);
                }, l);
                function l(e) {
                    this.$lines = [
                        ""
                    ], 0 === e.length ? this.$lines = [
                        ""
                    ] : Array.isArray(e) ? this.insertMergedLines({
                        row: 0,
                        column: 0
                    }, e) : this.insert({
                        row: 0,
                        column: 0
                    }, e);
                }
                e.prototype.$autoNewLine = "", e.prototype.$newLineMode = "auto", i.implement(e.prototype, r), t.Document = e;
            }), ace.define("ace/background_tokenizer", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/event_emitter"
            ], function(e, t, n) {
                "use strict";
                var i = e("./lib/oop"), e = e("./lib/event_emitter").EventEmitter, o = (r.prototype.setTokenizer = function(e) {
                    this.tokenizer = e, this.lines = [], this.states = [], this.start(0);
                }, r.prototype.setDocument = function(e) {
                    this.doc = e, this.lines = [], this.states = [], this.stop();
                }, r.prototype.fireUpdateEvent = function(e, t) {
                    this._signal("update", {
                        data: {
                            first: e,
                            last: t
                        }
                    });
                }, r.prototype.start = function(e) {
                    this.currentLine = Math.min(e || 0, this.currentLine, this.doc.getLength()), this.lines.splice(this.currentLine, this.lines.length), this.states.splice(this.currentLine, this.states.length), this.stop(), this.running = setTimeout(this.$worker, 700);
                }, r.prototype.scheduleStart = function() {
                    this.running || (this.running = setTimeout(this.$worker, 700));
                }, r.prototype.$updateOnChange = function(e) {
                    var t = e.start.row, n = e.end.row - t;
                    0 == n ? this.lines[t] = null : "remove" == e.action ? (this.lines.splice(t, 1 + n, null), this.states.splice(t, 1 + n, null)) : ((e = Array(1 + n)).unshift(t, 1), this.lines.splice.apply(this.lines, e), this.states.splice.apply(this.states, e)), this.currentLine = Math.min(t, this.currentLine, this.doc.getLength()), this.stop();
                }, r.prototype.stop = function() {
                    this.running && clearTimeout(this.running), this.running = !1;
                }, r.prototype.getTokens = function(e) {
                    return this.lines[e] || this.$tokenizeRow(e);
                }, r.prototype.getState = function(e) {
                    return this.currentLine == e && this.$tokenizeRow(e), this.states[e] || "start";
                }, r.prototype.$tokenizeRow = function(e) {
                    var t = this.doc.getLine(e), n = this.states[e - 1], t = this.tokenizer.getLineTokens(t, n, e);
                    return this.states[e] + "" != t.state + "" ? (this.states[e] = t.state, this.lines[e + 1] = null, this.currentLine > e + 1 && (this.currentLine = e + 1)) : this.currentLine == e && (this.currentLine = e + 1), this.lines[e] = t.tokens;
                }, r.prototype.cleanup = function() {
                    this.running = !1, this.lines = [], this.states = [], this.currentLine = 0, this.removeAllListeners();
                }, r);
                function r(e, t) {
                    this.running = !1, this.lines = [], this.states = [], this.currentLine = 0, this.tokenizer = e;
                    var a = this;
                    this.$worker = function() {
                        if (a.running) {
                            for(var e = new Date, t = a.currentLine, n = -1, i = a.doc, o = t; a.lines[t];)t++;
                            var r = i.getLength(), s = 0;
                            for(a.running = !1; t < r;){
                                for(a.$tokenizeRow(t), n = t; t++, a.lines[t];);
                                if (++s % 5 == 0 && 20 < new Date - e) {
                                    a.running = setTimeout(a.$worker, 20);
                                    break;
                                }
                            }
                            a.currentLine = t, o <= (n = -1 == n ? t : n) && a.fireUpdateEvent(o, n);
                        }
                    };
                }
                i.implement(o.prototype, e), t.BackgroundTokenizer = o;
            }), ace.define("ace/search_highlight", [
                "require",
                "exports",
                "module",
                "ace/lib/lang",
                "ace/range"
            ], function(e, t, n) {
                "use strict";
                var u = e("./lib/lang"), g = e("./range").Range, e = (i.prototype.setRegexp = function(e) {
                    this.regExp + "" != e + "" && (this.regExp = e, this.cache = []);
                }, i.prototype.update = function(e, t, n, i) {
                    if (this.regExp) for(var o = i.firstRow, r = i.lastRow, s = {}, a = o; a <= r; a++){
                        var l = this.cache[a];
                        null == l && (l = (l = (l = u.getMatchOffsets(n.getLine(a), this.regExp)).length > this.MAX_RANGES ? l.slice(0, this.MAX_RANGES) : l).map(function(e) {
                            return new g(a, e.offset, a, e.offset + e.length);
                        }), this.cache[a] = l.length ? l : "");
                        for(var c = l.length; c--;){
                            var h = l[c].toScreenRange(n), d = h.toString();
                            s[d] || (s[d] = !0, t.drawSingleLineMarker(e, h, this.clazz, i));
                        }
                    }
                }, i);
                function i(e, t, n) {
                    void 0 === n && (n = "text"), this.setRegexp(e), this.clazz = t, this.type = n;
                }
                e.prototype.MAX_RANGES = 500, t.SearchHighlight = e;
            }), ace.define("ace/edit_session/fold_line", [
                "require",
                "exports",
                "module",
                "ace/range"
            ], function(e, t, n) {
                "use strict";
                var i = e("../range").Range;
                function o(e, t) {
                    this.foldData = e, Array.isArray(t) ? this.folds = t : t = this.folds = [
                        t
                    ];
                    e = t[t.length - 1];
                    this.range = new i(t[0].start.row, t[0].start.column, e.end.row, e.end.column), this.start = this.range.start, this.end = this.range.end, this.folds.forEach(function(e) {
                        e.setFoldLine(this);
                    }, this);
                }
                o.prototype.shiftRow = function(t) {
                    this.start.row += t, this.end.row += t, this.folds.forEach(function(e) {
                        e.start.row += t, e.end.row += t;
                    });
                }, o.prototype.addFold = function(e) {
                    if (e.sameRow) {
                        if (e.start.row < this.startRow || e.endRow > this.endRow) throw new Error("Can't add a fold to this FoldLine as it has no connection");
                        this.folds.push(e), this.folds.sort(function(e, t) {
                            return -e.range.compareEnd(t.start.row, t.start.column);
                        }), 0 < this.range.compareEnd(e.start.row, e.start.column) ? (this.end.row = e.end.row, this.end.column = e.end.column) : this.range.compareStart(e.end.row, e.end.column) < 0 && (this.start.row = e.start.row, this.start.column = e.start.column);
                    } else if (e.start.row == this.end.row) this.folds.push(e), this.end.row = e.end.row, this.end.column = e.end.column;
                    else {
                        if (e.end.row != this.start.row) throw new Error("Trying to add fold to FoldRow that doesn't have a matching row");
                        this.folds.unshift(e), this.start.row = e.start.row, this.start.column = e.start.column;
                    }
                    e.foldLine = this;
                }, o.prototype.containsRow = function(e) {
                    return e >= this.start.row && e <= this.end.row;
                }, o.prototype.walk = function(e, t, n) {
                    var i, o, r = 0, s = this.folds, a = !0;
                    null == t && (t = this.end.row, n = this.end.column);
                    for(var l = 0; l < s.length; l++){
                        if (-1 == (o = (i = s[l]).range.compareStart(t, n))) return void e(null, t, n, r, a);
                        if (!e(null, i.start.row, i.start.column, r, a) && e(i.placeholder, i.start.row, i.start.column, r) || 0 === o) return;
                        a = !i.sameRow, r = i.end.column;
                    }
                    e(null, t, n, r, a);
                }, o.prototype.getNextFoldTo = function(e, t) {
                    for(var n, i, o = 0; o < this.folds.length; o++){
                        if (-1 == (i = (n = this.folds[o]).range.compareEnd(e, t))) return {
                            fold: n,
                            kind: "after"
                        };
                        if (0 === i) return {
                            fold: n,
                            kind: "inside"
                        };
                    }
                    return null;
                }, o.prototype.addRemoveChars = function(e, t, n) {
                    var i, o = this.getNextFoldTo(e, t);
                    if (o) {
                        if (i = o.fold, "inside" == o.kind && i.start.column != t && i.start.row != e) window.console && window.console.log(e, t, i);
                        else if (i.start.row == e) {
                            var r, s = (r = this.folds).indexOf(i);
                            for(0 === s && (this.start.column += n); s < r.length; s++){
                                if ((i = r[s]).start.column += n, !i.sameRow) return;
                                i.end.column += n;
                            }
                            this.end.column += n;
                        }
                    }
                }, o.prototype.split = function(e, t) {
                    var n, i, e = this.getNextFoldTo(e, t);
                    return e && "inside" != e.kind ? (t = e.fold, e = this.folds, n = this.foldData, t = e.indexOf(t), i = e[t - 1], this.end.row = i.end.row, this.end.column = i.end.column, i = new o(n, e = e.splice(t, e.length - t)), n.splice(n.indexOf(this) + 1, 0, i), i) : null;
                }, o.prototype.merge = function(e) {
                    for(var t = e.folds, n = 0; n < t.length; n++)this.addFold(t[n]);
                    var i = this.foldData;
                    i.splice(i.indexOf(e), 1);
                }, o.prototype.toString = function() {
                    var t = [
                        this.range.toString() + ": ["
                    ];
                    return this.folds.forEach(function(e) {
                        t.push("  " + e.toString());
                    }), t.push("]"), t.join("\n");
                }, o.prototype.idxToPosition = function(e) {
                    for(var t = 0, n = 0; n < this.folds.length; n++){
                        var i = this.folds[n];
                        if ((e -= i.start.column - t) < 0) return {
                            row: i.start.row,
                            column: i.start.column + e
                        };
                        if ((e -= i.placeholder.length) < 0) return i.start;
                        t = i.end.column;
                    }
                    return {
                        row: this.end.row,
                        column: this.end.column + e
                    };
                }, t.FoldLine = o;
            }), ace.define("ace/range_list", [
                "require",
                "exports",
                "module",
                "ace/range"
            ], function(e, t, n) {
                "use strict";
                var a = e("./range").Range.comparePoints, e = (i.prototype.pointIndex = function(e, t, n) {
                    for(var i = this.ranges, o = n || 0; o < i.length; o++){
                        var r = i[o], s = a(e, r.end);
                        if (!(0 < s)) return r = a(e, r.start), 0 === s ? t && 0 !== r ? -o - 2 : o : 0 < r || 0 === r && !t ? o : -o - 1;
                    }
                    return -o - 1;
                }, i.prototype.add = function(e) {
                    var t = !e.isEmpty(), n = this.pointIndex(e.start, t), t = this.pointIndex(e.end, t, n = n < 0 ? -n - 1 : n);
                    return t < 0 ? t = -t - 1 : t++, this.ranges.splice(n, t - n, e);
                }, i.prototype.addList = function(e) {
                    for(var t = [], n = e.length; n--;)t.push.apply(t, this.add(e[n]));
                    return t;
                }, i.prototype.substractPoint = function(e) {
                    e = this.pointIndex(e);
                    if (0 <= e) return this.ranges.splice(e, 1);
                }, i.prototype.merge = function() {
                    for(var e = [], t = this.ranges, n = (t = t.sort(function(e, t) {
                        return a(e.start, t.start);
                    }))[0], i = 1; i < t.length; i++){
                        var o = n, n = t[i], r = a(o.end, n.start);
                        r < 0 || (0 != r || o.isEmpty() || n.isEmpty()) && (a(o.end, n.end) < 0 && (o.end.row = n.end.row, o.end.column = n.end.column), t.splice(i, 1), e.push(n), n = o, i--);
                    }
                    return this.ranges = t, e;
                }, i.prototype.contains = function(e, t) {
                    return 0 <= this.pointIndex({
                        row: e,
                        column: t
                    });
                }, i.prototype.containsPoint = function(e) {
                    return 0 <= this.pointIndex(e);
                }, i.prototype.rangeAtPoint = function(e) {
                    e = this.pointIndex(e);
                    if (0 <= e) return this.ranges[e];
                }, i.prototype.clipRows = function(e, t) {
                    var n = this.ranges;
                    if (n[0].start.row > t || n[n.length - 1].start.row < e) return [];
                    for(var e = this.pointIndex({
                        row: e,
                        column: 0
                    }), i = this.pointIndex({
                        row: t,
                        column: 0
                    }, e = e < 0 ? -e - 1 : e), o = (i < 0 && (i = -i - 1), []), r = e; r < i; r++)o.push(n[r]);
                    return o;
                }, i.prototype.removeAll = function() {
                    return this.ranges.splice(0, this.ranges.length);
                }, i.prototype.attach = function(e) {
                    this.session && this.detach(), this.session = e, this.onChange = this.$onChange.bind(this), this.session.on("change", this.onChange);
                }, i.prototype.detach = function() {
                    this.session && (this.session.removeListener("change", this.onChange), this.session = null);
                }, i.prototype.$onChange = function(e) {
                    for(var t = e.start, n = e.end, i = t.row, o = n.row, r = this.ranges, s = 0, a = r.length; s < a && !((h = r[s]).end.row >= i); s++);
                    if ("insert" == e.action) for(var l = o - i, c = -t.column + n.column; s < a; s++){
                        if ((h = r[s]).start.row > i) break;
                        h.start.row == i && h.start.column >= t.column && (h.start.column == t.column && this.$bias <= 0 || (h.start.column += c, h.start.row += l)), h.end.row == i && h.end.column >= t.column && (h.end.column == t.column && this.$bias < 0 || (h.end.column == t.column && 0 < c && s < a - 1 && h.end.column > h.start.column && h.end.column == r[s + 1].start.column && (h.end.column -= c), h.end.column += c, h.end.row += l));
                    }
                    else for(var h, l = i - o, c = t.column - n.column; s < a; s++){
                        if ((h = r[s]).start.row > o) break;
                        h.end.row < o && (i < h.end.row || i == h.end.row && t.column < h.end.column) ? (h.end.row = i, h.end.column = t.column) : h.end.row == o ? h.end.column <= n.column ? (l || h.end.column > t.column) && (h.end.column = t.column, h.end.row = t.row) : (h.end.column += c, h.end.row += l) : h.end.row > o && (h.end.row += l), h.start.row < o && (i < h.start.row || i == h.start.row && t.column < h.start.column) ? (h.start.row = i, h.start.column = t.column) : h.start.row == o ? h.start.column <= n.column ? (l || h.start.column > t.column) && (h.start.column = t.column, h.start.row = t.row) : (h.start.column += c, h.start.row += l) : h.start.row > o && (h.start.row += l);
                    }
                    if (0 != l && s < a) for(; s < a; s++)(h = r[s]).start.row += l, h.end.row += l;
                }, i);
                function i() {
                    this.ranges = [], this.$bias = 1;
                }
                e.prototype.comparePoints = a, t.RangeList = e;
            }), ace.define("ace/edit_session/fold", [
                "require",
                "exports",
                "module",
                "ace/range_list"
            ], function(e, t, n) {
                "use strict";
                var i, o, r = this && this.__extends || (i = function(e, t) {
                    return (i = Object.setPrototypeOf || (({
                        __proto__: []
                    }) instanceof Array ? function(e, t) {
                        e.__proto__ = t;
                    } : function(e, t) {
                        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                    }))(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function n() {
                        this.constructor = e;
                    }
                    i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
                }), e = e("../range_list").RangeList, r = (r(s, o = e), s.prototype.toString = function() {
                    return '"' + this.placeholder + '" ' + this.range.toString();
                }, s.prototype.setFoldLine = function(t) {
                    this.foldLine = t, this.subFolds.forEach(function(e) {
                        e.setFoldLine(t);
                    });
                }, s.prototype.clone = function() {
                    var t = new s(this.range.clone(), this.placeholder);
                    return this.subFolds.forEach(function(e) {
                        t.subFolds.push(e.clone());
                    }), t.collapseChildren = this.collapseChildren, t;
                }, s.prototype.addSubFold = function(e) {
                    if (!this.range.isEqual(e)) {
                        r = e, s = this.start, d(r.start, s), d(r.end, s);
                        for(var t = e.start.row, n = e.start.column, i = 0, o = -1; i < this.subFolds.length && 1 == (o = this.subFolds[i].range.compare(t, n)); i++);
                        var r = this.subFolds[i], s = 0;
                        if (0 == o) {
                            if (r.range.containsRange(e)) return r.addSubFold(e);
                            s = 1;
                        }
                        for(var t = e.range.end.row, n = e.range.end.column, a = i, o = -1; a < this.subFolds.length && 1 == (o = this.subFolds[a].range.compare(t, n)); a++);
                        0 == o && a++;
                        for(var l = this.subFolds.splice(i, a - i, e), c = 0 == o ? l.length - 1 : l.length, h = s; h < c; h++)e.addSubFold(l[h]);
                        return e.setFoldLine(this.foldLine), e;
                    }
                }, s.prototype.restoreRange = function(e) {
                    var t;
                    return e, t = this.start, a(e.start, t), void a(e.end, t);
                }, s);
                function s(e, t) {
                    var n = o.call(this) || this;
                    return n.foldLine = null, n.placeholder = t, n.range = e, n.start = e.start, n.end = e.end, n.sameRow = e.start.row == e.end.row, n.subFolds = n.ranges = [], n;
                }
                function d(e, t) {
                    e.row -= t.row, 0 == e.row && (e.column -= t.column);
                }
                function a(e, t) {
                    0 == e.row && (e.column += t.column), e.row += t.row;
                }
                t.Fold = r;
            }), ace.define("ace/edit_session/folding", [
                "require",
                "exports",
                "module",
                "ace/range",
                "ace/edit_session/fold_line",
                "ace/edit_session/fold",
                "ace/token_iterator",
                "ace/mouse/mouse_event"
            ], function(e, t, n) {
                "use strict";
                var c = e("../range").Range, u = e("./fold_line").FoldLine, g = e("./fold").Fold, h = e("../token_iterator").TokenIterator, i = e("../mouse/mouse_event").MouseEvent;
                t.Folding = function() {
                    this.getFoldAt = function(e, t, n) {
                        var i = this.getFoldLine(e);
                        if (!i) return null;
                        for(var o = i.folds, r = 0; r < o.length; r++){
                            var s = o[r].range;
                            if (s.contains(e, t) && (1 != n || !s.isEnd(e, t) || s.isEmpty()) && (-1 != n || !s.isStart(e, t) || s.isEmpty())) return o[r];
                        }
                    }, this.getFoldsInRange = function(e) {
                        var t = e.start, n = e.end, i = this.$foldData, o = [];
                        t.column += 1, --n.column;
                        for(var r = 0; r < i.length; r++){
                            var s = i[r].range.compareRange(e);
                            if (2 != s) {
                                if (-2 == s) break;
                                for(var a = i[r].folds, l = 0; l < a.length; l++){
                                    var c = a[l];
                                    if (-2 == (s = c.range.compareRange(e))) break;
                                    if (2 != s) {
                                        if (42 == s) break;
                                        o.push(c);
                                    }
                                }
                            }
                        }
                        return --t.column, n.column += 1, o;
                    }, this.getFoldsInRangeList = function(e) {
                        var t;
                        return Array.isArray(e) ? (t = [], e.forEach(function(e) {
                            t = t.concat(this.getFoldsInRange(e));
                        }, this)) : t = this.getFoldsInRange(e), t;
                    }, this.getAllFolds = function() {
                        for(var e = [], t = this.$foldData, n = 0; n < t.length; n++)for(var i = 0; i < t[n].folds.length; i++)e.push(t[n].folds[i]);
                        return e;
                    }, this.getFoldStringAt = function(e, t, n, i) {
                        if (!(i = i || this.getFoldLine(e))) return null;
                        for(var o, r = {
                            end: {
                                column: 0
                            }
                        }, s = 0; s < i.folds.length; s++){
                            var a, l = (a = i.folds[s]).range.compareEnd(e, t);
                            if (-1 == l) {
                                o = this.getLine(a.start.row).substring(r.end.column, a.start.column);
                                break;
                            }
                            if (0 === l) return null;
                            r = a;
                        }
                        return o = o || this.getLine(a.start.row).substring(r.end.column), -1 == n ? o.substring(0, t - r.end.column) : 1 == n ? o.substring(t - r.end.column) : o;
                    }, this.getFoldLine = function(e, t) {
                        var n = this.$foldData, i = 0;
                        for(-1 == (i = t ? n.indexOf(t) : i) && (i = 0); i < n.length; i++){
                            var o = n[i];
                            if (o.start.row <= e && o.end.row >= e) return o;
                            if (o.end.row > e) return null;
                        }
                        return null;
                    }, this.getNextFoldLine = function(e, t) {
                        var n = this.$foldData, i = 0;
                        for(-1 == (i = t ? n.indexOf(t) : i) && (i = 0); i < n.length; i++){
                            var o = n[i];
                            if (o.end.row >= e) return o;
                        }
                        return null;
                    }, this.getFoldedRowCount = function(e, t) {
                        for(var n = this.$foldData, i = t - e + 1, o = 0; o < n.length; o++){
                            var r = n[o], s = r.end.row, r = r.start.row;
                            if (t <= s) {
                                r < t && (e <= r ? i -= t - r : i = 0);
                                break;
                            }
                            e <= s && (i -= e <= r ? s - r : s - e + 1);
                        }
                        return i;
                    }, this.$addFoldLine = function(e) {
                        return this.$foldData.push(e), this.$foldData.sort(function(e, t) {
                            return e.start.row - t.start.row;
                        }), e;
                    }, this.addFold = function(e, t) {
                        var n, i = this.$foldData, o = !1, r = (e instanceof g ? n = e : (n = new g(t, e)).collapseChildren = t.collapseChildren, this.$clipRangeToDocument(n.range), n.start.row), e = n.start.column, s = n.end.row, t = n.end.column, a = this.getFoldAt(r, e, 1), l = this.getFoldAt(s, t, -1);
                        if (a && l == a) return a.addSubFold(n);
                        a && !a.range.isStart(r, e) && this.removeFold(a), l && !l.range.isEnd(s, t) && this.removeFold(l);
                        e = this.getFoldsInRange(n.range);
                        0 < e.length && (this.removeFolds(e), n.collapseChildren || e.forEach(function(e) {
                            n.addSubFold(e);
                        }));
                        for(var c = 0; c < i.length; c++){
                            var h = i[c];
                            if (s == h.start.row) {
                                h.addFold(n), o = !0;
                                break;
                            }
                            if (r == h.end.row) {
                                if (h.addFold(n), o = !0, !n.sameRow) {
                                    var d = i[c + 1];
                                    if (d && d.start.row == s) {
                                        h.merge(d);
                                        break;
                                    }
                                }
                                break;
                            }
                            if (s <= h.start.row) break;
                        }
                        return o || (h = this.$addFoldLine(new u(this.$foldData, n))), this.$useWrapMode ? this.$updateWrapData(h.start.row, h.start.row) : this.$updateRowLengthCache(h.start.row, h.start.row), this.$modified = !0, this._signal("changeFold", {
                            data: n,
                            action: "add"
                        }), n;
                    }, this.addFolds = function(e) {
                        e.forEach(function(e) {
                            this.addFold(e);
                        }, this);
                    }, this.removeFold = function(e) {
                        var t = e.foldLine, n = t.start.row, i = t.end.row, o = this.$foldData, r = t.folds;
                        1 == r.length ? o.splice(o.indexOf(t), 1) : t.range.isEnd(e.end.row, e.end.column) ? (r.pop(), t.end.row = r[r.length - 1].end.row, t.end.column = r[r.length - 1].end.column) : t.range.isStart(e.start.row, e.start.column) ? (r.shift(), t.start.row = r[0].start.row, t.start.column = r[0].start.column) : e.sameRow ? r.splice(r.indexOf(e), 1) : ((r = (o = t.split(e.start.row, e.start.column)).folds).shift(), o.start.row = r[0].start.row, o.start.column = r[0].start.column), this.$updating || (this.$useWrapMode ? this.$updateWrapData(n, i) : this.$updateRowLengthCache(n, i)), this.$modified = !0, this._signal("changeFold", {
                            data: e,
                            action: "remove"
                        });
                    }, this.removeFolds = function(e) {
                        for(var t = [], n = 0; n < e.length; n++)t.push(e[n]);
                        t.forEach(function(e) {
                            this.removeFold(e);
                        }, this), this.$modified = !0;
                    }, this.expandFold = function(t) {
                        this.removeFold(t), t.subFolds.forEach(function(e) {
                            t.restoreRange(e), this.addFold(e);
                        }, this), 0 < t.collapseChildren && this.foldAll(t.start.row + 1, t.end.row, t.collapseChildren - 1), t.subFolds = [];
                    }, this.expandFolds = function(e) {
                        e.forEach(function(e) {
                            this.expandFold(e);
                        }, this);
                    }, this.unfold = function(e, t) {
                        var n;
                        if (null == e) n = new c(0, 0, this.getLength(), 0), null == t && (t = !0);
                        else if ("number" == typeof e) n = new c(e, 0, e, this.getLine(e).length);
                        else if ("row" in e) n = c.fromPoints(e, e);
                        else {
                            if (Array.isArray(e)) return i = [], e.forEach(function(e) {
                                i = i.concat(this.unfold(e));
                            }, this), i;
                            n = e;
                        }
                        for(var i, e = i = this.getFoldsInRangeList(n); 1 == i.length && c.comparePoints(i[0].start, n.start) < 0 && 0 < c.comparePoints(i[0].end, n.end);)this.expandFolds(i), i = this.getFoldsInRangeList(n);
                        if (0 != t ? this.removeFolds(i) : this.expandFolds(i), e.length) return e;
                    }, this.isRowFolded = function(e, t) {
                        return !!this.getFoldLine(e, t);
                    }, this.getRowFoldEnd = function(e, t) {
                        t = this.getFoldLine(e, t);
                        return t ? t.end.row : e;
                    }, this.getRowFoldStart = function(e, t) {
                        t = this.getFoldLine(e, t);
                        return t ? t.start.row : e;
                    }, this.getFoldDisplayLine = function(e, t, n, o, r) {
                        null == o && (o = e.start.row), null == r && (r = 0), null == t && (t = e.end.row), null == n && (n = this.getLine(t).length);
                        var s = this.doc, a = "";
                        return e.walk(function(e, t, n, i) {
                            if (!(t < o)) {
                                if (t == o) {
                                    if (n < r) return;
                                    i = Math.max(r, i);
                                }
                                a += null != e ? e : s.getLine(t).substring(i, n);
                            }
                        }, t, n), a;
                    }, this.getDisplayLine = function(e, t, n, i) {
                        var o = this.getFoldLine(e);
                        return o ? this.getFoldDisplayLine(o, e, t, n, i) : (o = this.doc.getLine(e)).substring(i || 0, t || o.length);
                    }, this.$cloneFoldData = function() {
                        var t = [];
                        return t = this.$foldData.map(function(e) {
                            e = e.folds.map(function(e) {
                                return e.clone();
                            });
                            return new u(t, e);
                        });
                    }, this.toggleFold = function(e) {
                        var t = this.selection.getRange();
                        if (t.isEmpty()) {
                            var n, i = t.start;
                            if (n = this.getFoldAt(i.row, i.column)) return void this.expandFold(n);
                            (o = this.findMatchingBracket(i)) ? 1 == t.comparePoint(o) ? t.end = o : (t.start = o, t.start.column++, t.end.column--) : (o = this.findMatchingBracket({
                                row: i.row,
                                column: i.column + 1
                            })) ? (1 == t.comparePoint(o) ? t.end = o : t.start = o, t.start.column++) : t = this.getCommentFoldRange(i.row, i.column) || t;
                        } else {
                            var o = this.getFoldsInRange(t);
                            if (e && o.length) return void this.expandFolds(o);
                            1 == o.length && (n = o[0]);
                        }
                        if ((n = n || this.getFoldAt(t.start.row, t.start.column)) && n.range.toString() == t.toString()) this.expandFold(n);
                        else {
                            i = "...";
                            if (!t.isMultiLine()) {
                                if ((i = this.getTextRange(t)).length < 4) return;
                                i = i.trim().substring(0, 2) + "..";
                            }
                            this.addFold(i, t);
                        }
                    }, this.getCommentFoldRange = function(e, t, n) {
                        var i = new h(this, e, t), o = i.getCurrentToken(), r = o && o.type;
                        if (o && /^comment|string/.test(r)) {
                            "comment" == (r = r.match(/comment|string/)[0]) && (r += "|doc-start");
                            var s = new RegExp(r), r = new c;
                            if (1 != n) {
                                for(; (o = i.stepBackward()) && s.test(o.type) && !/^comment.end/.test(o.type););
                                o = i.stepForward();
                            }
                            if (r.start.row = i.getCurrentTokenRow(), r.start.column = i.getCurrentTokenColumn() + (/^comment.start/.test(o.type) ? o.value.length : 2), i = new h(this, e, t), -1 != n) {
                                var a = -1;
                                do {
                                    if (o = i.stepForward(), -1 == a) {
                                        var l = this.getState(i.$row);
                                        s.test(l) || (a = i.$row);
                                    } else if (i.$row > a) break;
                                }while (o && s.test(o.type) && !/^comment.start/.test(o.type));
                                o = i.stepBackward();
                            } else o = i.getCurrentToken();
                            return r.end.row = i.getCurrentTokenRow(), r.end.column = i.getCurrentTokenColumn(), /^comment.end/.test(o.type) || (r.end.column += o.value.length - 2), r;
                        }
                    }, this.foldAll = function(e, t, n, i) {
                        null == n && (n = 1e5);
                        var o = this.foldWidgets;
                        if (o) {
                            t = t || this.getLength();
                            for(var r, s = e = e || 0; s < t; s++)null == o[s] && (o[s] = this.getFoldWidget(s)), "start" != o[s] || i && !i(s) || (r = this.getFoldWidgetRange(s)) && r.isMultiLine() && r.end.row <= t && r.start.row >= e && (s = r.end.row, r.collapseChildren = n, this.addFold("...", r));
                        }
                    }, this.foldToLevel = function(e) {
                        for(this.foldAll(); 0 < e--;)this.unfold(null, !1);
                    }, this.foldAllComments = function() {
                        var o = this;
                        this.foldAll(null, null, null, function(e) {
                            for(var t = o.getTokens(e), n = 0; n < t.length; n++){
                                var i = t[n];
                                if ("text" != i.type || !/^\s+$/.test(i.value)) return !!/comment/.test(i.type);
                            }
                        });
                    }, this.$foldStyles = {
                        manual: 1,
                        markbegin: 1,
                        markbeginend: 1
                    }, this.$foldStyle = "markbegin", this.setFoldStyle = function(e) {
                        if (!this.$foldStyles[e]) throw new Error("invalid fold style: " + e + "[" + Object.keys(this.$foldStyles).join(", ") + "]");
                        this.$foldStyle != e && ("manual" == (this.$foldStyle = e) && this.unfold(), e = this.$foldMode, this.$setFolding(null), this.$setFolding(e));
                    }, this.$setFolding = function(e) {
                        this.$foldMode != e && (this.$foldMode = e, this.off("change", this.$updateFoldWidgets), this.off("tokenizerUpdate", this.$tokenizerUpdateFoldWidgets), this._signal("changeAnnotation"), e && "manual" != this.$foldStyle ? (this.foldWidgets = [], this.getFoldWidget = e.getFoldWidget.bind(e, this, this.$foldStyle), this.getFoldWidgetRange = e.getFoldWidgetRange.bind(e, this, this.$foldStyle), this.$updateFoldWidgets = this.updateFoldWidgets.bind(this), this.$tokenizerUpdateFoldWidgets = this.tokenizerUpdateFoldWidgets.bind(this), this.on("change", this.$updateFoldWidgets), this.on("tokenizerUpdate", this.$tokenizerUpdateFoldWidgets)) : this.foldWidgets = null);
                    }, this.getParentFoldRangeData = function(e, t) {
                        var n = this.foldWidgets;
                        if (!n || t && n[e]) return {};
                        for(var i = e - 1; 0 <= i;){
                            var o = n[i];
                            if ("start" == (o = null == o ? n[i] = this.getFoldWidget(i) : o)) {
                                var r = this.getFoldWidgetRange(i), s = s || r;
                                if (r && r.end.row >= e) break;
                            }
                            i--;
                        }
                        return {
                            range: -1 !== i && r,
                            firstRange: s
                        };
                    }, this.onFoldWidgetClick = function(e, t) {
                        var n = {
                            children: (t = t instanceof i ? t.domEvent : t).shiftKey,
                            all: t.ctrlKey || t.metaKey,
                            siblings: t.altKey
                        };
                        this.$toggleFoldWidget(e, n) || (e = t.target || t.srcElement) && /ace_fold-widget/.test(e.className) && (e.className += " ace_invalid");
                    }, this.$toggleFoldWidget = function(e, t) {
                        var n, i, o, r;
                        if (this.getFoldWidget) return n = this.getFoldWidget(e), i = this.getLine(e), (i = this.getFoldAt(e, -1 == (n = "end" === n ? -1 : 1) ? 0 : i.length, n)) ? (t.children || t.all ? this.removeFold(i) : this.expandFold(i), i) : (n = this.getFoldWidgetRange(e, !0)) && !n.isMultiLine() && (i = this.getFoldAt(n.start.row, n.start.column, 1)) && n.isEqual(i.range) ? (this.removeFold(i), i) : (t.siblings ? ((i = this.getParentFoldRangeData(e)).range && (o = i.range.start.row + 1, r = i.range.end.row), this.foldAll(o, r, t.all ? 1e4 : 0)) : t.children ? (r = n ? n.end.row : this.getLength(), this.foldAll(e + 1, r, t.all ? 1e4 : 0)) : n && (t.all && (n.collapseChildren = 1e4), this.addFold("...", n)), n);
                    }, this.toggleFoldWidget = function(e) {
                        var t, n = this.selection.getCursor().row;
                        n = this.getRowFoldStart(n), !this.$toggleFoldWidget(n, {}) && (t = (t = this.getParentFoldRangeData(n, !0)).range || t.firstRange) && (n = t.start.row, (n = this.getFoldAt(n, this.getLine(n).length, 1)) ? this.removeFold(n) : this.addFold("...", t));
                    }, this.updateFoldWidgets = function(e) {
                        var t = e.start.row, n = e.end.row - t;
                        0 == n ? this.foldWidgets[t] = null : "remove" == e.action ? this.foldWidgets.splice(t, 1 + n, null) : ((e = Array(1 + n)).unshift(t, 1), this.foldWidgets.splice.apply(this.foldWidgets, e));
                    }, this.tokenizerUpdateFoldWidgets = function(e) {
                        e = e.data;
                        e.first != e.last && this.foldWidgets.length > e.first && this.foldWidgets.splice(e.first, this.foldWidgets.length);
                    };
                };
            }), ace.define("ace/edit_session/bracket_match", [
                "require",
                "exports",
                "module",
                "ace/token_iterator",
                "ace/range"
            ], function(e, t, n) {
                "use strict";
                var d = e("../token_iterator").TokenIterator, C = e("../range").Range;
                t.BracketMatch = function() {
                    this.findMatchingBracket = function(e, t) {
                        return 0 != e.column && "" != (t = t || this.getLine(e.row).charAt(e.column - 1)) && (t = t.match(/([\(\[\{])|([\)\]\}])/)) ? t[1] ? this.$findClosingBracket(t[1], e) : this.$findOpeningBracket(t[2], e) : null;
                    }, this.getBracketRange = function(e) {
                        var t, n, i = this.getLine(e.row), o = !0, r = i.charAt(e.column - 1), s = r && r.match(/([\(\[\{])|([\)\]\}])/);
                        if (s || (r = i.charAt(e.column), e = {
                            row: e.row,
                            column: e.column + 1
                        }, s = r && r.match(/([\(\[\{])|([\)\]\}])/), o = !1), !s) return null;
                        if (s[1]) {
                            if (!(n = this.$findClosingBracket(s[1], e))) return null;
                            t = C.fromPoints(e, n), o || (t.end.column++, t.start.column--), t.cursor = t.end;
                        } else {
                            if (!(n = this.$findOpeningBracket(s[2], e))) return null;
                            t = C.fromPoints(n, e), o || (t.start.column++, t.end.column--), t.cursor = t.start;
                        }
                        return t;
                    }, this.getMatchingBracketRanges = function(e, t) {
                        var n = this.getLine(e.row), i = /([\(\[\{])|([\)\]\}])/, o = !t && n.charAt(e.column - 1), r = o && o.match(i);
                        return r || (o = (void 0 === t || t) && n.charAt(e.column), e = {
                            row: e.row,
                            column: e.column + 1
                        }, r = o && o.match(i)), r ? (t = new C(e.row, e.column - 1, e.row, e.column), (n = r[1] ? this.$findClosingBracket(r[1], e) : this.$findOpeningBracket(r[2], e)) ? [
                            t,
                            new C(n.row, n.column, n.row, n.column + 1)
                        ] : [
                            t
                        ]) : null;
                    }, this.$brackets = {
                        ")": "(",
                        "(": ")",
                        "]": "[",
                        "[": "]",
                        "{": "}",
                        "}": "{",
                        "<": ">",
                        ">": "<"
                    }, this.$findOpeningBracket = function(e, t, n) {
                        var i = this.$brackets[e], o = 1, r = new d(this, t.row, t.column), s = r.getCurrentToken();
                        if (s = s || r.stepForward()) {
                            n = n || new RegExp("(\\.?" + s.type.replace(".", "\\.").replace("rparen", ".paren").replace(/\b(?:end)\b/, "(?:start|begin|end)").replace(/-close\b/, "-(close|open)") + ")+");
                            for(var a = t.column - r.getCurrentTokenColumn() - 2, l = s.value;;){
                                for(; 0 <= a;){
                                    var c = l.charAt(a);
                                    if (c == i) {
                                        if (0 == --o) return {
                                            row: r.getCurrentTokenRow(),
                                            column: a + r.getCurrentTokenColumn()
                                        };
                                    } else c == e && (o += 1);
                                    --a;
                                }
                                for(; (s = r.stepBackward()) && !n.test(s.type););
                                if (null == s) break;
                                a = (l = s.value).length - 1;
                            }
                            return null;
                        }
                    }, this.$findClosingBracket = function(e, t, n) {
                        var i = this.$brackets[e], o = 1, r = new d(this, t.row, t.column), s = r.getCurrentToken();
                        if (s = s || r.stepForward()) {
                            n = n || new RegExp("(\\.?" + s.type.replace(".", "\\.").replace("lparen", ".paren").replace(/\b(?:start|begin)\b/, "(?:start|begin|end)").replace(/-open\b/, "-(close|open)") + ")+");
                            for(var a = t.column - r.getCurrentTokenColumn();;){
                                for(var l = s.value, c = l.length; a < c;){
                                    var h = l.charAt(a);
                                    if (h == i) {
                                        if (0 == --o) return {
                                            row: r.getCurrentTokenRow(),
                                            column: a + r.getCurrentTokenColumn()
                                        };
                                    } else h == e && (o += 1);
                                    a += 1;
                                }
                                for(; (s = r.stepForward()) && !n.test(s.type););
                                if (null == s) break;
                                a = 0;
                            }
                            return null;
                        }
                    }, this.getMatchingTags = function(e) {
                        var e = new d(this, e.row, e.column), t = this.$findTagName(e);
                        if (t) return "<" === e.stepBackward().value ? this.$findClosingTag(e, t) : this.$findOpeningTag(e, t);
                    }, this.$findTagName = function(e) {
                        var t = e.getCurrentToken(), n = !1, i = !1;
                        if (t && -1 === t.type.indexOf("tag-name")) for(; (t = i ? e.stepBackward() : e.stepForward()) && ("/>" === t.value ? i = !0 : -1 !== t.type.indexOf("tag-name") && (n = !0)), t && !n;);
                        return t;
                    }, this.$findClosingTag = function(e, t) {
                        var n = t.value, i = t.value, o = 0, r = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1), s = (t = e.stepForward(), new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + t.value.length)), a = !1;
                        do {
                            var l, c = t;
                            if (t = e.stepForward()) {
                                if (">" !== t.value || a || (l = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1), a = !0), -1 !== t.type.indexOf("tag-name")) {
                                    if (i === (n = t.value)) {
                                        if ("<" === c.value) o++;
                                        else if ("</" === c.value && --o < 0) {
                                            e.stepBackward();
                                            var h = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 2), d = (t = e.stepForward(), new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + t.value.length));
                                            if (!(t = e.stepForward()) || ">" !== t.value) return;
                                            var u = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1);
                                        }
                                    }
                                } else i === n && "/>" === t.value && --o < 0 && (u = d = h = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 2), l = new C(s.end.row, s.end.column, s.end.row, s.end.column + 1));
                            }
                        }while (t && 0 <= o);
                        if (r && l && h && u && s && d) return {
                            openTag: new C(r.start.row, r.start.column, l.end.row, l.end.column),
                            closeTag: new C(h.start.row, h.start.column, u.end.row, u.end.column),
                            openTagName: s,
                            closeTagName: d
                        };
                    }, this.$findOpeningTag = function(e, t) {
                        var n, i = e.getCurrentToken(), o = t.value, r = 0, s = e.getCurrentTokenRow(), a = e.getCurrentTokenColumn(), l = new C(s, a, s, a + 2), c = (e.stepForward(), new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + t.value.length));
                        if ((t = e.stepForward()) && ">" === t.value) {
                            var h = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1);
                            e.stepBackward(), e.stepBackward();
                            do if (t = i, s = e.getCurrentTokenRow(), n = (a = e.getCurrentTokenColumn()) + t.value.length, i = e.stepBackward(), t) {
                                if (-1 !== t.type.indexOf("tag-name")) {
                                    if (o === t.value) {
                                        if ("<" === i.value) {
                                            if (0 < ++r) {
                                                for(var d = new C(s, a, s, n), u = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1); (t = e.stepForward()) && ">" !== t.value;);
                                                var g = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1);
                                            }
                                        } else "</" === i.value && r--;
                                    }
                                } else if ("/>" === t.value) {
                                    for(var p = 0, m = i; m;){
                                        if (-1 !== m.type.indexOf("tag-name") && m.value === o) {
                                            r--;
                                            break;
                                        }
                                        if ("<" === m.value) break;
                                        m = e.stepBackward(), p++;
                                    }
                                    for(var f = 0; f < p; f++)e.stepForward();
                                }
                            }
                            while (i && r <= 0);
                            return u && g && l && h && d && c ? {
                                openTag: new C(u.start.row, u.start.column, g.end.row, g.end.column),
                                closeTag: new C(l.start.row, l.start.column, h.end.row, h.end.column),
                                openTagName: d,
                                closeTagName: c
                            } : void 0;
                        }
                    };
                };
            }), ace.define("ace/edit_session", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/lang",
                "ace/bidihandler",
                "ace/config",
                "ace/lib/event_emitter",
                "ace/selection",
                "ace/mode/text",
                "ace/range",
                "ace/document",
                "ace/background_tokenizer",
                "ace/search_highlight",
                "ace/edit_session/folding",
                "ace/edit_session/bracket_match"
            ], function(e, t, n) {
                "use strict";
                var i = e("./lib/oop"), o = e("./lib/lang"), r = e("./bidihandler").BidiHandler, s = e("./config"), a = e("./lib/event_emitter").EventEmitter, l = e("./selection").Selection, c = e("./mode/text").Mode, h = e("./range").Range, d = e("./document").Document, u = e("./background_tokenizer").BackgroundTokenizer, g = e("./search_highlight").SearchHighlight, p = (m.prototype.setDocument = function(e) {
                    this.doc && this.doc.off("change", this.$onChange), (this.doc = e).on("change", this.$onChange, !0), this.bgTokenizer.setDocument(this.getDocument()), this.resetCaches();
                }, m.prototype.getDocument = function() {
                    return this.doc;
                }, m.prototype.$resetRowCache = function(e) {
                    var t;
                    e ? (t = this.$docRowCache.length, (e = this.$getRowCacheIndex(this.$docRowCache, e) + 1) < t && (this.$docRowCache.splice(e, t), this.$screenRowCache.splice(e, t))) : (this.$docRowCache = [], this.$screenRowCache = []);
                }, m.prototype.$getRowCacheIndex = function(e, t) {
                    for(var n = 0, i = e.length - 1; n <= i;){
                        var o = n + i >> 1, r = e[o];
                        if (r < t) n = 1 + o;
                        else {
                            if (!(t < r)) return o;
                            i = o - 1;
                        }
                    }
                    return n - 1;
                }, m.prototype.resetCaches = function() {
                    this.$modified = !0, this.$wrapData = [], this.$rowLengthCache = [], this.$resetRowCache(0), this.destroyed || this.bgTokenizer.start(0);
                }, m.prototype.onChangeFold = function(e) {
                    e = e.data;
                    this.$resetRowCache(e.start.row);
                }, m.prototype.onChange = function(e) {
                    this.$modified = !0, this.$bidiHandler.onChange(e), this.$resetRowCache(e.start.row);
                    var t = this.$updateInternalDataOnChange(e);
                    !this.$fromUndo && this.$undoManager && (t && t.length && (this.$undoManager.add({
                        action: "removeFolds",
                        folds: t
                    }, this.mergeUndoDeltas), this.mergeUndoDeltas = !0), this.$undoManager.add(e, this.mergeUndoDeltas), this.mergeUndoDeltas = !0, this.$informUndoManager.schedule()), this.bgTokenizer.$updateOnChange(e), this._signal("change", e);
                }, m.prototype.setValue = function(e) {
                    this.doc.setValue(e), this.selection.moveTo(0, 0), this.$resetRowCache(0), this.setUndoManager(this.$undoManager), this.getUndoManager().reset();
                }, m.prototype.toString = function() {
                    return this.doc.getValue();
                }, m.prototype.getSelection = function() {
                    return this.selection;
                }, m.prototype.getState = function(e) {
                    return this.bgTokenizer.getState(e);
                }, m.prototype.getTokens = function(e) {
                    return this.bgTokenizer.getTokens(e);
                }, m.prototype.getTokenAt = function(e, t) {
                    var n = this.bgTokenizer.getTokens(e), i = 0;
                    if (null == t) var o = n.length - 1, i = this.getLine(e).length;
                    else for(o = 0; o < n.length && !(t <= (i += n[o].value.length)); o++);
                    return (e = n[o]) ? (e.index = o, e.start = i - e.value.length, e) : null;
                }, m.prototype.setUndoManager = function(e) {
                    var t;
                    this.$undoManager = e, this.$informUndoManager && this.$informUndoManager.cancel(), e ? (e.addSession(t = this), this.$syncInformUndoManager = function() {
                        t.$informUndoManager.cancel(), t.mergeUndoDeltas = !1;
                    }, this.$informUndoManager = o.delayedCall(this.$syncInformUndoManager)) : this.$syncInformUndoManager = function() {};
                }, m.prototype.markUndoGroup = function() {
                    this.$syncInformUndoManager && this.$syncInformUndoManager();
                }, m.prototype.getUndoManager = function() {
                    return this.$undoManager || this.$defaultUndoManager;
                }, m.prototype.getTabString = function() {
                    return this.getUseSoftTabs() ? o.stringRepeat(" ", this.getTabSize()) : "\t";
                }, m.prototype.setUseSoftTabs = function(e) {
                    this.setOption("useSoftTabs", e);
                }, m.prototype.getUseSoftTabs = function() {
                    return this.$useSoftTabs && !this.$mode.$indentWithTabs;
                }, m.prototype.setTabSize = function(e) {
                    this.setOption("tabSize", e);
                }, m.prototype.getTabSize = function() {
                    return this.$tabSize;
                }, m.prototype.isTabStop = function(e) {
                    return this.$useSoftTabs && e.column % this.$tabSize == 0;
                }, m.prototype.setNavigateWithinSoftTabs = function(e) {
                    this.setOption("navigateWithinSoftTabs", e);
                }, m.prototype.getNavigateWithinSoftTabs = function() {
                    return this.$navigateWithinSoftTabs;
                }, m.prototype.setOverwrite = function(e) {
                    this.setOption("overwrite", e);
                }, m.prototype.getOverwrite = function() {
                    return this.$overwrite;
                }, m.prototype.toggleOverwrite = function() {
                    this.setOverwrite(!this.$overwrite);
                }, m.prototype.addGutterDecoration = function(e, t) {
                    this.$decorations[e] || (this.$decorations[e] = ""), this.$decorations[e] += " " + t, this._signal("changeBreakpoint", {});
                }, m.prototype.removeGutterDecoration = function(e, t) {
                    this.$decorations[e] = (this.$decorations[e] || "").replace(" " + t, ""), this._signal("changeBreakpoint", {});
                }, m.prototype.getBreakpoints = function() {
                    return this.$breakpoints;
                }, m.prototype.setBreakpoints = function(e) {
                    this.$breakpoints = [];
                    for(var t = 0; t < e.length; t++)this.$breakpoints[e[t]] = "ace_breakpoint";
                    this._signal("changeBreakpoint", {});
                }, m.prototype.clearBreakpoints = function() {
                    this.$breakpoints = [], this._signal("changeBreakpoint", {});
                }, m.prototype.setBreakpoint = function(e, t) {
                    (t = void 0 === t ? "ace_breakpoint" : t) ? this.$breakpoints[e] = t : delete this.$breakpoints[e], this._signal("changeBreakpoint", {});
                }, m.prototype.clearBreakpoint = function(e) {
                    delete this.$breakpoints[e], this._signal("changeBreakpoint", {});
                }, m.prototype.addMarker = function(e, t, n, i) {
                    var o = this.$markerId++, e = {
                        range: e,
                        type: n || "line",
                        renderer: "function" == typeof n ? n : null,
                        clazz: t,
                        inFront: !!i,
                        id: o
                    };
                    return i ? (this.$frontMarkers[o] = e, this._signal("changeFrontMarker")) : (this.$backMarkers[o] = e, this._signal("changeBackMarker")), o;
                }, m.prototype.addDynamicMarker = function(e, t) {
                    var n;
                    if (e.update) return n = this.$markerId++, e.id = n, e.inFront = !!t, t ? (this.$frontMarkers[n] = e, this._signal("changeFrontMarker")) : (this.$backMarkers[n] = e, this._signal("changeBackMarker")), e;
                }, m.prototype.removeMarker = function(e) {
                    var t = this.$frontMarkers[e] || this.$backMarkers[e];
                    t && (delete (t.inFront ? this.$frontMarkers : this.$backMarkers)[e], this._signal(t.inFront ? "changeFrontMarker" : "changeBackMarker"));
                }, m.prototype.getMarkers = function(e) {
                    return e ? this.$frontMarkers : this.$backMarkers;
                }, m.prototype.highlight = function(e) {
                    var t;
                    this.$searchHighlight || (t = new g(null, "ace_selected-word", "text"), this.$searchHighlight = this.addDynamicMarker(t)), this.$searchHighlight.setRegexp(e);
                }, m.prototype.highlightLines = function(e, t, n, i) {
                    "number" != typeof t && (n = t, t = e), n = n || "ace_step";
                    e = new h(e, 0, t, 1 / 0);
                    return e.id = this.addMarker(e, n, "fullLine", i), e;
                }, m.prototype.setAnnotations = function(e) {
                    this.$annotations = e, this._signal("changeAnnotation", {});
                }, m.prototype.getAnnotations = function() {
                    return this.$annotations || [];
                }, m.prototype.clearAnnotations = function() {
                    this.setAnnotations([]);
                }, m.prototype.$detectNewLine = function(e) {
                    e = e.match(/^.*?(\r?\n)/m);
                    this.$autoNewLine = e ? e[1] : "\n";
                }, m.prototype.getWordRange = function(e, t) {
                    var n, i = this.getLine(e), o = !1, r = (n = (o = (o = 0 < t ? !!i.charAt(t - 1).match(this.tokenRe) : o) || !!i.charAt(t).match(this.tokenRe)) ? this.tokenRe : /^\s+$/.test(i.slice(t - 1, t + 1)) ? /\s/ : this.nonTokenRe, t);
                    if (0 < r) {
                        for(; 0 <= --r && i.charAt(r).match(n););
                        r++;
                    }
                    for(var s = t; s < i.length && i.charAt(s).match(n);)s++;
                    return new h(e, r, e, s);
                }, m.prototype.getAWordRange = function(e, t) {
                    for(var n = this.getWordRange(e, t), i = this.getLine(n.end.row); i.charAt(n.end.column).match(/[ \t]/);)n.end.column += 1;
                    return n;
                }, m.prototype.setNewLineMode = function(e) {
                    this.doc.setNewLineMode(e);
                }, m.prototype.getNewLineMode = function() {
                    return this.doc.getNewLineMode();
                }, m.prototype.setUseWorker = function(e) {
                    this.setOption("useWorker", e);
                }, m.prototype.getUseWorker = function() {
                    return this.$useWorker;
                }, m.prototype.onReloadTokenizer = function(e) {
                    var t = e.data;
                    this.bgTokenizer.start(t.first), this._signal("tokenizerUpdate", e);
                }, m.prototype.setMode = function(e, t) {
                    if (e && "object" == typeof e) {
                        if (e.getTokenizer) return this.$onChangeMode(e);
                        var n = e, i = n.path;
                    } else i = e || "ace/mode/text";
                    this.$modes["ace/mode/text"] || (this.$modes["ace/mode/text"] = new c), this.$modes[i] && !n ? (this.$onChangeMode(this.$modes[i]), t && t()) : (this.$modeId = i, s.loadModule([
                        "mode",
                        i
                    ], (function(e) {
                        if (this.$modeId !== i) return t && t();
                        this.$modes[i] && !n ? this.$onChangeMode(this.$modes[i]) : e && e.Mode && (e = new e.Mode(n), n || ((this.$modes[i] = e).$id = i), this.$onChangeMode(e)), t && t();
                    }).bind(this)), this.$mode || this.$onChangeMode(this.$modes["ace/mode/text"], !0));
                }, m.prototype.$onChangeMode = function(e, t) {
                    var n, i, o;
                    t || (this.$modeId = e.$id), this.$mode === e || (n = this.$mode, this.$mode = e, this.$stopWorker(), this.$useWorker && this.$startWorker(), void 0 !== (i = e.getTokenizer()).on && (o = this.onReloadTokenizer.bind(this), i.on("update", o)), this.bgTokenizer.setTokenizer(i), this.bgTokenizer.setDocument(this.getDocument()), this.tokenRe = e.tokenRe, this.nonTokenRe = e.nonTokenRe, t) || (e.attachToSession && e.attachToSession(this), this.$options.wrapMethod.set.call(this, this.$wrapMethod), this.$setFolding(e.foldingRules), this.bgTokenizer.start(0), this._emit("changeMode", {
                        oldMode: n,
                        mode: e
                    }));
                }, m.prototype.$stopWorker = function() {
                    this.$worker && (this.$worker.terminate(), this.$worker = null);
                }, m.prototype.$startWorker = function() {
                    try {
                        this.$worker = this.$mode.createWorker(this);
                    } catch (e) {
                        s.warn("Could not load worker", e), this.$worker = null;
                    }
                }, m.prototype.getMode = function() {
                    return this.$mode;
                }, m.prototype.setScrollTop = function(e) {
                    this.$scrollTop === e || isNaN(e) || (this.$scrollTop = e, this._signal("changeScrollTop", e));
                }, m.prototype.getScrollTop = function() {
                    return this.$scrollTop;
                }, m.prototype.setScrollLeft = function(e) {
                    this.$scrollLeft === e || isNaN(e) || (this.$scrollLeft = e, this._signal("changeScrollLeft", e));
                }, m.prototype.getScrollLeft = function() {
                    return this.$scrollLeft;
                }, m.prototype.getScreenWidth = function() {
                    return this.$computeWidth(), this.lineWidgets ? Math.max(this.getLineWidgetMaxWidth(), this.screenWidth) : this.screenWidth;
                }, m.prototype.getLineWidgetMaxWidth = function() {
                    var t;
                    return null != this.lineWidgetsWidth ? this.lineWidgetsWidth : (t = 0, this.lineWidgets.forEach(function(e) {
                        e && e.screenWidth > t && (t = e.screenWidth);
                    }), this.lineWidgetWidth = t);
                }, m.prototype.$computeWidth = function(e) {
                    if (this.$modified || e) {
                        if (this.$modified = !1, this.$useWrapMode) return this.screenWidth = this.$wrapLimit;
                        for(var t = this.doc.getAllLines(), n = this.$rowLengthCache, i = 0, o = 0, r = this.$foldData[o], s = r ? r.start.row : 1 / 0, a = t.length, l = 0; l < a; l++){
                            if (s < l) {
                                if (a <= (l = r.end.row + 1)) break;
                                s = (r = this.$foldData[o++]) ? r.start.row : 1 / 0;
                            }
                            null == n[l] && (n[l] = this.$getStringScreenWidth(t[l])[0]), n[l] > i && (i = n[l]);
                        }
                        this.screenWidth = i;
                    }
                }, m.prototype.getLine = function(e) {
                    return this.doc.getLine(e);
                }, m.prototype.getLines = function(e, t) {
                    return this.doc.getLines(e, t);
                }, m.prototype.getLength = function() {
                    return this.doc.getLength();
                }, m.prototype.getTextRange = function(e) {
                    return this.doc.getTextRange(e || this.selection.getRange());
                }, m.prototype.insert = function(e, t) {
                    return this.doc.insert(e, t);
                }, m.prototype.remove = function(e) {
                    return this.doc.remove(e);
                }, m.prototype.removeFullLines = function(e, t) {
                    return this.doc.removeFullLines(e, t);
                }, m.prototype.undoChanges = function(e, t) {
                    if (e.length) {
                        this.$fromUndo = !0;
                        for(var n = e.length - 1; -1 != n; n--){
                            var i = e[n];
                            "insert" == i.action || "remove" == i.action ? this.doc.revertDelta(i) : i.folds && this.addFolds(i.folds);
                        }
                        !t && this.$undoSelect && (e.selectionBefore ? this.selection.fromJSON(e.selectionBefore) : this.selection.setRange(this.$getUndoSelection(e, !0))), this.$fromUndo = !1;
                    }
                }, m.prototype.redoChanges = function(e, t) {
                    if (e.length) {
                        this.$fromUndo = !0;
                        for(var n = 0; n < e.length; n++){
                            var i = e[n];
                            "insert" != i.action && "remove" != i.action || this.doc.$safeApplyDelta(i);
                        }
                        !t && this.$undoSelect && (e.selectionAfter ? this.selection.fromJSON(e.selectionAfter) : this.selection.setRange(this.$getUndoSelection(e, !1))), this.$fromUndo = !1;
                    }
                }, m.prototype.setUndoSelect = function(e) {
                    this.$undoSelect = e;
                }, m.prototype.$getUndoSelection = function(e, t) {
                    function n(e) {
                        return t ? "insert" !== e.action : "insert" === e.action;
                    }
                    for(var i, o, r = 0; r < e.length; r++){
                        var s = e[r];
                        s.start && (i ? n(s) ? (o = s.start, -1 == i.compare(o.row, o.column) && i.setStart(o), o = s.end, 1 == i.compare(o.row, o.column) && i.setEnd(o)) : (o = s.start, -1 == i.compare(o.row, o.column) && (i = h.fromPoints(s.start, s.start))) : i = n(s) ? h.fromPoints(s.start, s.end) : h.fromPoints(s.start, s.start));
                    }
                    return i;
                }, m.prototype.replace = function(e, t) {
                    return this.doc.replace(e, t);
                }, m.prototype.moveText = function(e, t, n) {
                    var i, o, r, s = this.getTextRange(e), a = this.getFoldsInRange(e), t = h.fromPoints(t, t);
                    return n || (this.remove(e), o = e.start.row - e.end.row, (r = o ? -e.end.column : e.start.column - e.end.column) && (t.start.row == e.end.row && t.start.column > e.end.column && (t.start.column += r), t.end.row == e.end.row) && t.end.column > e.end.column && (t.end.column += r), o && t.start.row >= e.end.row && (t.start.row += o, t.end.row += o)), t.end = this.insert(t.start, s), a.length && (i = e.start, n = t.start, o = n.row - i.row, r = n.column - i.column, this.addFolds(a.map(function(e) {
                        return (e = e.clone()).start.row == i.row && (e.start.column += r), e.end.row == i.row && (e.end.column += r), e.start.row += o, e.end.row += o, e;
                    }))), t;
                }, m.prototype.indentRows = function(e, t, n) {
                    n = n.replace(/\t/g, this.getTabString());
                    for(var i = e; i <= t; i++)this.doc.insertInLine({
                        row: i,
                        column: 0
                    }, n);
                }, m.prototype.outdentRows = function(e) {
                    for(var t = e.collapseRows(), n = new h(0, 0, 0, 0), i = this.getTabSize(), o = t.start.row; o <= t.end.row; ++o){
                        var r = this.getLine(o);
                        n.start.row = o, n.end.row = o;
                        for(var s = 0; s < i && " " == r.charAt(s); ++s);
                        s < i && "\t" == r.charAt(s) ? (n.start.column = s, n.end.column = s + 1) : (n.start.column = 0, n.end.column = s), this.remove(n);
                    }
                }, m.prototype.$moveLines = function(e, t, n) {
                    if (e = this.getRowFoldStart(e), t = this.getRowFoldEnd(t), n < 0) {
                        if ((o = this.getRowFoldStart(e + n)) < 0) return 0;
                        var i = o - e;
                    } else if (0 < n) {
                        if ((o = this.getRowFoldEnd(t + n)) > this.doc.getLength() - 1) return 0;
                        i = o - t;
                    } else {
                        e = this.$clipRowToDocument(e);
                        i = (t = this.$clipRowToDocument(t)) - e + 1;
                    }
                    var o = new h(e, 0, t, Number.MAX_VALUE), o = this.getFoldsInRange(o).map(function(e) {
                        return (e = e.clone()).start.row += i, e.end.row += i, e;
                    }), n = 0 == n ? this.doc.getLines(e, t) : this.doc.removeFullLines(e, t);
                    return this.doc.insertFullLines(e + i, n), o.length && this.addFolds(o), i;
                }, m.prototype.moveLinesUp = function(e, t) {
                    return this.$moveLines(e, t, -1);
                }, m.prototype.moveLinesDown = function(e, t) {
                    return this.$moveLines(e, t, 1);
                }, m.prototype.duplicateLines = function(e, t) {
                    return this.$moveLines(e, t, 0);
                }, m.prototype.$clipRowToDocument = function(e) {
                    return Math.max(0, Math.min(e, this.doc.getLength() - 1));
                }, m.prototype.$clipColumnToRow = function(e, t) {
                    return t < 0 ? 0 : Math.min(this.doc.getLine(e).length, t);
                }, m.prototype.$clipPositionToDocument = function(e, t) {
                    var n;
                    return t = Math.max(0, t), t = e < 0 ? e = 0 : (n = this.doc.getLength()) <= e ? this.doc.getLine(e = n - 1).length : Math.min(this.doc.getLine(e).length, t), {
                        row: e,
                        column: t
                    };
                }, m.prototype.$clipRangeToDocument = function(e) {
                    e.start.row < 0 ? (e.start.row = 0, e.start.column = 0) : e.start.column = this.$clipColumnToRow(e.start.row, e.start.column);
                    var t = this.doc.getLength() - 1;
                    return e.end.row > t ? (e.end.row = t, e.end.column = this.doc.getLine(t).length) : e.end.column = this.$clipColumnToRow(e.end.row, e.end.column), e;
                }, m.prototype.setUseWrapMode = function(e) {
                    e != this.$useWrapMode && (this.$useWrapMode = e, this.$modified = !0, this.$resetRowCache(0), e && (e = this.getLength(), this.$wrapData = Array(e), this.$updateWrapData(0, e - 1)), this._signal("changeWrapMode"));
                }, m.prototype.getUseWrapMode = function() {
                    return this.$useWrapMode;
                }, m.prototype.setWrapLimitRange = function(e, t) {
                    this.$wrapLimitRange.min === e && this.$wrapLimitRange.max === t || (this.$wrapLimitRange = {
                        min: e,
                        max: t
                    }, this.$modified = !0, this.$bidiHandler.markAsDirty(), this.$useWrapMode && this._signal("changeWrapMode"));
                }, m.prototype.adjustWrapLimit = function(e, t) {
                    var n = this.$wrapLimitRange, t = (n.max < 0 && (n = {
                        min: t,
                        max: t
                    }), this.$constrainWrapLimit(e, n.min, n.max));
                    return t != this.$wrapLimit && 1 < t && (this.$wrapLimit = t, this.$modified = !0, this.$useWrapMode && (this.$updateWrapData(0, this.getLength() - 1), this.$resetRowCache(0), this._signal("changeWrapLimit")), !0);
                }, m.prototype.$constrainWrapLimit = function(e, t, n) {
                    return t && (e = Math.max(t, e)), e = n ? Math.min(n, e) : e;
                }, m.prototype.getWrapLimit = function() {
                    return this.$wrapLimit;
                }, m.prototype.setWrapLimit = function(e) {
                    this.setWrapLimitRange(e, e);
                }, m.prototype.getWrapLimitRange = function() {
                    return {
                        min: this.$wrapLimitRange.min,
                        max: this.$wrapLimitRange.max
                    };
                }, m.prototype.$updateInternalDataOnChange = function(e) {
                    var t = this.$useWrapMode, n = e.action, i = e.start, o = e.end, r = i.row, s = o.row, a = s - r, l = null;
                    if (this.$updating = !0, 0 != a) {
                        if ("remove" === n) {
                            this[t ? "$wrapData" : "$rowLengthCache"].splice(r, a);
                            var c = this.$foldData, l = this.getFoldsInRange(e);
                            this.removeFolds(l);
                            var h = 0;
                            for((g = this.getFoldLine(o.row)) && (g.addRemoveChars(o.row, o.column, i.column - o.column), g.shiftRow(-a), (d = this.getFoldLine(r)) && d !== g && (d.merge(g), g = d), h = c.indexOf(g) + 1); h < c.length; h++)(g = c[h]).start.row >= o.row && g.shiftRow(-a);
                            s = r;
                        } else {
                            var d = Array(a), u = (d.unshift(r, 0), t ? this.$wrapData : this.$rowLengthCache), c = (u.splice.apply(u, d), this.$foldData), h = 0;
                            for((g = this.getFoldLine(r)) && (0 == (u = g.range.compareInside(i.row, i.column)) ? (g = g.split(i.row, i.column)) && (g.shiftRow(a), g.addRemoveChars(s, 0, o.column - i.column)) : -1 == u && (g.addRemoveChars(r, 0, o.column - i.column), g.shiftRow(a)), h = c.indexOf(g) + 1); h < c.length; h++)(g = c[h]).start.row >= r && g.shiftRow(a);
                        }
                    } else {
                        var g, a = Math.abs(e.start.column - e.end.column);
                        "remove" === n && (l = this.getFoldsInRange(e), this.removeFolds(l), a = -a), (g = this.getFoldLine(r)) && g.addRemoveChars(r, i.column, a);
                    }
                    return t && this.$wrapData.length != this.doc.getLength() && console.error("doc.getLength() and $wrapData.length have to be the same!"), this.$updating = !1, t ? this.$updateWrapData(r, s) : this.$updateRowLengthCache(r, s), l;
                }, m.prototype.$updateRowLengthCache = function(e, t, n) {
                    this.$rowLengthCache[e] = null, this.$rowLengthCache[t] = null;
                }, m.prototype.$updateWrapData = function(e, t) {
                    var s, n, a = this.doc.getAllLines(), i = this.getTabSize(), o = this.$wrapData, r = this.$wrapLimit, l = e;
                    for(t = Math.min(t, a.length - 1); l <= t;)(n = this.getFoldLine(l, n)) ? (s = [], n.walk((function(e, t, n, i) {
                        var o;
                        if (null != e) {
                            (o = this.$getDisplayTokens(e, s.length))[0] = y;
                            for(var r = 1; r < o.length; r++)o[r] = v;
                        } else o = this.$getDisplayTokens(a[t].substring(i, n), s.length);
                        s = s.concat(o);
                    }).bind(this), n.end.row, a[n.end.row].length + 1), o[n.start.row] = this.$computeWrapSplits(s, r, i), l = n.end.row + 1) : (s = this.$getDisplayTokens(a[l]), o[l] = this.$computeWrapSplits(s, r, i), l++);
                }, m.prototype.$computeWrapSplits = function(o, e, r) {
                    if (0 == o.length) return [];
                    var s = [], t = o.length, a = 0, l = 0, c = this.$wrapAsCode, h = this.$indentedSoftWrap, d = e <= Math.max(2 * r, 8) || !1 === h ? 0 : Math.floor(e / 2);
                    function n(e) {
                        for(var t = e - a, n = a; n < e; n++){
                            var i = o[n];
                            12 !== i && 2 !== i || --t;
                        }
                        s.length || (u = function() {
                            var e = 0;
                            if (0 === d) return e;
                            if (h) for(var t = 0; t < o.length; t++){
                                var n = o[t];
                                if (n == b) e += 1;
                                else if (n == A) e += r;
                                else if (n != w) break;
                            }
                            return c && !1 !== h && (e += r), Math.min(e, d);
                        }(), s.indent = u), l += t, s.push(l), a = e;
                    }
                    for(var u = 0; e - u < t - a;){
                        var i = a + e - u;
                        if (o[i - 1] >= b && o[i] >= b) n(i);
                        else if (o[i] == y || o[i] == v) {
                            for(; i != a - 1 && o[i] != y; i--);
                            if (a < i) ;
                            else {
                                for(i = a + e; i < o.length && o[i] == v; i++);
                                if (i == o.length) break;
                            }
                            n(i);
                        } else {
                            for(var g = Math.max(i - (e - (e >> 2)), a - 1); g < i && o[i] < y;)i--;
                            if (c) {
                                for(; g < i && o[i] < y;)i--;
                                for(; g < i && o[i] == I;)i--;
                            } else for(; g < i && o[i] < b;)i--;
                            g < i ? n(++i) : (o[i = a + e] == C && i--, n(i - u));
                        }
                    }
                    return s;
                }, m.prototype.$getDisplayTokens = function(e, t) {
                    var n, i = [];
                    t = t || 0;
                    for(var o = 0; o < e.length; o++){
                        var r = e.charCodeAt(o);
                        if (9 == r) {
                            n = this.getScreenTabSize(i.length + t), i.push(A);
                            for(var s = 1; s < n; s++)i.push(w);
                        } else 32 == r ? i.push(b) : 39 < r && r < 48 || 57 < r && r < 64 ? i.push(I) : 4352 <= r && S(r) ? i.push(f, C) : i.push(f);
                    }
                    return i;
                }, m.prototype.$getStringScreenWidth = function(e, t, n) {
                    if (0 == t) return [
                        0,
                        0
                    ];
                    var i, o;
                    for(null == t && (t = 1 / 0), n = n || 0, o = 0; o < e.length && (9 == (i = e.charCodeAt(o)) ? n += this.getScreenTabSize(n) : 4352 <= i && S(i) ? n += 2 : n += 1, !(t < n)); o++);
                    return [
                        n,
                        o
                    ];
                }, m.prototype.getRowLength = function(e) {
                    var t = 1;
                    return this.lineWidgets && (t += this.lineWidgets[e] && this.lineWidgets[e].rowCount || 0), this.$useWrapMode && this.$wrapData[e] ? this.$wrapData[e].length + t : t;
                }, m.prototype.getRowLineCount = function(e) {
                    return this.$useWrapMode && this.$wrapData[e] ? this.$wrapData[e].length + 1 : 1;
                }, m.prototype.getRowWrapIndent = function(e) {
                    var t;
                    return this.$useWrapMode && (e = this.screenToDocumentPosition(e, Number.MAX_VALUE), (t = this.$wrapData[e.row]).length) && t[0] < e.column ? t.indent : 0;
                }, m.prototype.getScreenLastRowColumn = function(e) {
                    e = this.screenToDocumentPosition(e, Number.MAX_VALUE);
                    return this.documentToScreenColumn(e.row, e.column);
                }, m.prototype.getDocumentLastRowColumn = function(e, t) {
                    e = this.documentToScreenRow(e, t);
                    return this.getScreenLastRowColumn(e);
                }, m.prototype.getDocumentLastRowColumnPosition = function(e, t) {
                    e = this.documentToScreenRow(e, t);
                    return this.screenToDocumentPosition(e, Number.MAX_VALUE / 10);
                }, m.prototype.getRowSplitData = function(e) {
                    if (this.$useWrapMode) return this.$wrapData[e];
                }, m.prototype.getScreenTabSize = function(e) {
                    return this.$tabSize - (e % this.$tabSize | 0);
                }, m.prototype.screenToDocumentRow = function(e, t) {
                    return this.screenToDocumentPosition(e, t).row;
                }, m.prototype.screenToDocumentColumn = function(e, t) {
                    return this.screenToDocumentPosition(e, t).column;
                }, m.prototype.screenToDocumentPosition = function(e, t, n) {
                    if (e < 0) return {
                        row: 0,
                        column: 0
                    };
                    for(var i, o, r, s = 0, a = 0, l = 0, c = 0, h = this.$screenRowCache, d = this.$getRowCacheIndex(h, e), u = h.length, g = (r = u && 0 <= d ? (l = h[d], s = this.$docRowCache[d], e > h[u - 1]) : !u, this.getLength() - 1), p = this.getNextFoldLine(s), m = p ? p.start.row : 1 / 0; l <= e && !(e < l + (c = this.getRowLength(s)) || g <= s);)l += c, m < ++s && (s = p.end.row + 1, m = (p = this.getNextFoldLine(s, p)) ? p.start.row : 1 / 0), r && (this.$docRowCache.push(s), this.$screenRowCache.push(l));
                    if (p && p.start.row <= s) i = this.getFoldDisplayLine(p), s = p.start.row;
                    else {
                        if (l + c <= e || g < s) return {
                            row: g,
                            column: this.getLine(g).length
                        };
                        i = this.getLine(s), p = null;
                    }
                    d = 0, h = Math.floor(e - l);
                    return this.$useWrapMode && (u = this.$wrapData[s]) && (o = u[h], 0 < h) && u.length && (d = u.indent, a = u[h - 1] || u[u.length - 1], i = i.substring(a)), void 0 !== n && this.$bidiHandler.isBidiRow(l + h, s, h) && (t = this.$bidiHandler.offsetToCol(n)), a += this.$getStringScreenWidth(i, t - d)[1], this.$useWrapMode && o <= a && (a = o - 1), p ? p.idxToPosition(a) : {
                        row: s,
                        column: a
                    };
                }, m.prototype.documentToScreenPosition = function(e, t) {
                    var n = void 0 === t ? this.$clipPositionToDocument(e.row, e.column) : this.$clipPositionToDocument(e, t), i = (e = n.row, t = n.column, 0), n = null;
                    (a = this.getFoldAt(e, t, 1)) && (e = a.start.row, t = a.start.column);
                    for(var o, r, s = 0, a = this.$docRowCache, l = this.$getRowCacheIndex(a, e), c = a.length, h = (r = c && 0 <= l ? (s = a[l], i = this.$screenRowCache[l], e > a[c - 1]) : !c, this.getNextFoldLine(s)), d = h ? h.start.row : 1 / 0; s < e;){
                        if (d <= s) {
                            if (e < (o = h.end.row + 1)) break;
                            d = (h = this.getNextFoldLine(o, h)) ? h.start.row : 1 / 0;
                        } else o = s + 1;
                        i += this.getRowLength(s), s = o, r && (this.$docRowCache.push(s), this.$screenRowCache.push(i));
                    }
                    var u = "", n = h && d <= s ? (u = this.getFoldDisplayLine(h, e, t), h.start.row) : (u = this.getLine(e).substring(0, t), e), l = 0;
                    if (this.$useWrapMode) {
                        var g = this.$wrapData[n];
                        if (g) {
                            for(var p = 0; u.length >= g[p];)i++, p++;
                            u = u.substring(g[p - 1] || 0, u.length), l = 0 < p ? g.indent : 0;
                        }
                    }
                    return this.lineWidgets && this.lineWidgets[s] && this.lineWidgets[s].rowsAbove && (i += this.lineWidgets[s].rowsAbove), {
                        row: i,
                        column: l + this.$getStringScreenWidth(u)[0]
                    };
                }, m.prototype.documentToScreenColumn = function(e, t) {
                    return this.documentToScreenPosition(e, t).column;
                }, m.prototype.documentToScreenRow = function(e, t) {
                    return this.documentToScreenPosition(e, t).row;
                }, m.prototype.getScreenLength = function() {
                    var e = 0, t = null;
                    if (this.$useWrapMode) for(var n = this.$wrapData.length, i = 0, o = 0, r = (t = this.$foldData[o++]) ? t.start.row : 1 / 0; i < n;){
                        var s = this.$wrapData[i];
                        e += s ? s.length + 1 : 1, r < ++i && (i = t.end.row + 1, r = (t = this.$foldData[o++]) ? t.start.row : 1 / 0);
                    }
                    else for(var e = this.getLength(), a = this.$foldData, o = 0; o < a.length; o++)e -= (t = a[o]).end.row - t.start.row;
                    return this.lineWidgets && (e += this.$getWidgetScreenLength()), e;
                }, m.prototype.$setFontMetrics = function(r) {
                    this.$enableVarChar && (this.$getStringScreenWidth = function(e, t, n) {
                        if (0 === t) return [
                            0,
                            0
                        ];
                        var i, o;
                        for(t = t || 1 / 0, n = n || 0, o = 0; o < e.length && !(t < (n += "\t" === (i = e.charAt(o)) ? this.getScreenTabSize(n) : r.getCharacterWidth(i))); o++);
                        return [
                            n,
                            o
                        ];
                    });
                }, m.prototype.destroy = function() {
                    this.destroyed || (this.bgTokenizer.setDocument(null), this.bgTokenizer.cleanup(), this.destroyed = !0), this.$stopWorker(), this.removeAllListeners(), this.doc && this.doc.off("change", this.$onChange), this.selection.detach();
                }, m);
                function m(e, t) {
                    this.$breakpoints = [], this.$decorations = [], this.$frontMarkers = {}, this.$backMarkers = {}, this.$markerId = 1, this.$undoSelect = !0, this.$foldData = [], this.id = "session" + ++m.$uid, this.$foldData.toString = function() {
                        return this.join("\n");
                    }, this.bgTokenizer = new u((new c).getTokenizer(), this);
                    var n = this;
                    this.bgTokenizer.on("update", function(e) {
                        n._signal("tokenizerUpdate", e);
                    }), this.on("changeFold", this.onChangeFold.bind(this)), this.$onChange = this.onChange.bind(this), "object" == typeof e && e.getLine || (e = new d(e)), this.setDocument(e), this.selection = new l(this), this.$bidiHandler = new r(this), s.resetOptions(this), this.setMode(t), s._signal("session", this), this.destroyed = !1;
                }
                p.$uid = 0, p.prototype.$modes = s.$modes, p.prototype.getValue = p.prototype.toString, p.prototype.$defaultUndoManager = {
                    undo: function() {},
                    redo: function() {},
                    hasUndo: function() {},
                    hasRedo: function() {},
                    reset: function() {},
                    add: function() {},
                    addSelection: function() {},
                    startNewGroup: function() {},
                    addSession: function() {}
                }, p.prototype.$overwrite = !1, p.prototype.$mode = null, p.prototype.$modeId = null, p.prototype.$scrollTop = 0, p.prototype.$scrollLeft = 0, p.prototype.$wrapLimit = 80, p.prototype.$useWrapMode = !1, p.prototype.$wrapLimitRange = {
                    min: null,
                    max: null
                }, p.prototype.lineWidgets = null, p.prototype.isFullWidth = S, i.implement(p.prototype, a);
                var f = 1, C = 2, y = 3, v = 4, I = 9, b = 10, A = 11, w = 12;
                function S(e) {
                    return !(e < 4352) && (4352 <= e && e <= 4447 || 4515 <= e && e <= 4519 || 4602 <= e && e <= 4607 || 9001 <= e && e <= 9002 || 11904 <= e && e <= 11929 || 11931 <= e && e <= 12019 || 12032 <= e && e <= 12245 || 12272 <= e && e <= 12283 || 12288 <= e && e <= 12350 || 12353 <= e && e <= 12438 || 12441 <= e && e <= 12543 || 12549 <= e && e <= 12589 || 12593 <= e && e <= 12686 || 12688 <= e && e <= 12730 || 12736 <= e && e <= 12771 || 12784 <= e && e <= 12830 || 12832 <= e && e <= 12871 || 12880 <= e && e <= 13054 || 13056 <= e && e <= 19903 || 19968 <= e && e <= 42124 || 42128 <= e && e <= 42182 || 43360 <= e && e <= 43388 || 44032 <= e && e <= 55203 || 55216 <= e && e <= 55238 || 55243 <= e && e <= 55291 || 63744 <= e && e <= 64255 || 65040 <= e && e <= 65049 || 65072 <= e && e <= 65106 || 65108 <= e && e <= 65126 || 65128 <= e && e <= 65131 || 65281 <= e && e <= 65376 || 65504 <= e && e <= 65510);
                }
                e("./edit_session/folding").Folding.call(p.prototype), e("./edit_session/bracket_match").BracketMatch.call(p.prototype), s.defineOptions(p.prototype, "session", {
                    wrap: {
                        set: function(e) {
                            e && "off" != e ? "free" == e ? e = !0 : "printMargin" == e ? e = -1 : "string" == typeof e && (e = parseInt(e, 10) || !1) : e = !1, this.$wrap != e && ((this.$wrap = e) ? (this.setWrapLimitRange(e = "number" == typeof e ? e : null, e), this.setUseWrapMode(!0)) : this.setUseWrapMode(!1));
                        },
                        get: function() {
                            return this.getUseWrapMode() ? -1 == this.$wrap ? "printMargin" : this.getWrapLimitRange().min ? this.$wrap : "free" : "off";
                        },
                        handlesSet: !0
                    },
                    wrapMethod: {
                        set: function(e) {
                            (e = "auto" == e ? "text" != this.$mode.type : "text" != e) != this.$wrapAsCode && (this.$wrapAsCode = e, this.$useWrapMode) && (this.$useWrapMode = !1, this.setUseWrapMode(!0));
                        },
                        initialValue: "auto"
                    },
                    indentedSoftWrap: {
                        set: function() {
                            this.$useWrapMode && (this.$useWrapMode = !1, this.setUseWrapMode(!0));
                        },
                        initialValue: !0
                    },
                    firstLineNumber: {
                        set: function() {
                            this._signal("changeBreakpoint");
                        },
                        initialValue: 1
                    },
                    useWorker: {
                        set: function(e) {
                            this.$useWorker = e, this.$stopWorker(), e && this.$startWorker();
                        },
                        initialValue: !0
                    },
                    useSoftTabs: {
                        initialValue: !0
                    },
                    tabSize: {
                        set: function(e) {
                            0 < (e = parseInt(e)) && this.$tabSize !== e && (this.$modified = !0, this.$rowLengthCache = [], this.$tabSize = e, this._signal("changeTabSize"));
                        },
                        initialValue: 4,
                        handlesSet: !0
                    },
                    navigateWithinSoftTabs: {
                        initialValue: !1
                    },
                    foldStyle: {
                        set: function(e) {
                            this.setFoldStyle(e);
                        },
                        handlesSet: !0
                    },
                    overwrite: {
                        set: function(e) {
                            this._signal("changeOverwrite");
                        },
                        initialValue: !1
                    },
                    newLineMode: {
                        set: function(e) {
                            this.doc.setNewLineMode(e);
                        },
                        get: function() {
                            return this.doc.getNewLineMode();
                        },
                        handlesSet: !0
                    },
                    mode: {
                        set: function(e) {
                            this.setMode(e);
                        },
                        get: function() {
                            return this.$modeId;
                        },
                        handlesSet: !0
                    }
                }), t.EditSession = p;
            }), ace.define("ace/search", [
                "require",
                "exports",
                "module",
                "ace/lib/lang",
                "ace/lib/oop",
                "ace/range"
            ], function(e, t, n) {
                "use strict";
                var v = e("./lib/lang"), i = e("./lib/oop"), I = e("./range").Range;
                function o() {
                    this.$options = {};
                }
                o.prototype.set = function(e) {
                    return i.mixin(this.$options, e), this;
                }, o.prototype.getOptions = function() {
                    return v.copyObject(this.$options);
                }, o.prototype.setOptions = function(e) {
                    this.$options = e;
                }, o.prototype.find = function(e) {
                    var o, r = this.$options, e = this.$matchIterator(e, r);
                    return !!e && (o = null, e.forEach(function(e, t, n, i) {
                        return o = new I(e, t, n, i), !(t == i && r.start && r.start.start && 0 != r.skipCurrent && o.isEqual(r.start) && (o = null, 1));
                    }), o);
                }, o.prototype.findAll = function(e) {
                    var t = this.$options;
                    if (!t.needle) return [];
                    this.$assembleRegExp(t);
                    var n = t.range, i = n ? e.getLines(n.start.row, n.end.row) : e.doc.getAllLines(), o = [], r = t.re;
                    if (t.$isMultiLine) {
                        var s, a = r.length, l = i.length - a;
                        e: for(var c = r.offset || 0; c <= l; c++){
                            for(var h = 0; h < a; h++)if (-1 == i[c + h].search(r[h])) continue e;
                            var d = i[c], u = i[c + a - 1], d = d.length - d.match(r[0])[0].length, u = u.match(r[a - 1])[0].length;
                            s && s.end.row === c && s.end.column > d || (o.push(s = new I(c, d, c + a - 1, u)), 2 < a && (c = c + a - 2));
                        }
                    } else for(var g = 0; g < i.length; g++)for(var p = v.getMatchOffsets(i[g], r), h = 0; h < p.length; h++){
                        var m = p[h];
                        o.push(new I(g, m.offset, g, m.offset + m.length));
                    }
                    if (n) {
                        for(var f = n.start.column, C = n.end.column, g = 0, h = o.length - 1; g < h && o[g].start.column < f && 0 == o[g].start.row;)g++;
                        for(var y = n.end.row - n.start.row; g < h && o[h].end.column > C && o[h].end.row == y;)h--;
                        for(o = o.slice(g, h + 1), g = 0, h = o.length; g < h; g++)o[g].start.row += n.start.row, o[g].end.row += n.start.row;
                    }
                    return o;
                }, o.prototype.replace = function(e, t) {
                    var n = this.$options, i = this.$assembleRegExp(n);
                    if (n.$isMultiLine) return t;
                    if (i) {
                        var o = i.exec(e);
                        if (!o || o[0].length != e.length) return null;
                        if (t = e.replace(i, t), n.preserveCase) {
                            t = t.split("");
                            for(var r = Math.min(e.length, e.length); r--;){
                                var s = e[r];
                                s && s.toLowerCase() != s ? t[r] = t[r].toUpperCase() : t[r] = t[r].toLowerCase();
                            }
                            t = t.join("");
                        }
                        return t;
                    }
                }, o.prototype.$assembleRegExp = function(e, t) {
                    if (e.needle instanceof RegExp) return e.re = e.needle;
                    var n, i = e.needle;
                    if (!e.needle) return e.re = !1;
                    function o(e) {
                        return /\w/.test(e) || n.regExp ? "\\b" : "";
                    }
                    e.regExp || (i = v.escapeRegExp(i)), e.wholeWord && (n = e, i = o((r = i)[0]) + r + o(r[r.length - 1]));
                    var r = e.caseSensitive ? "gm" : "gmi";
                    if (e.$isMultiLine = !t && /[\n\r]/.test(i), e.$isMultiLine) return e.re = this.$assembleMultilineRegExp(i, r);
                    try {
                        var s = new RegExp(i, r);
                    } catch (e) {
                        s = !1;
                    }
                    return e.re = s;
                }, o.prototype.$assembleMultilineRegExp = function(e, t) {
                    for(var n = e.replace(/\r\n|\r|\n/g, "$\n^").split("\n"), i = [], o = 0; o < n.length; o++)try {
                        i.push(new RegExp(n[o], t));
                    } catch (e) {
                        return !1;
                    }
                    return i;
                }, o.prototype.$matchIterator = function(h, n) {
                    var a, e, t, i, o, r, l, s, d = this.$assembleRegExp(n);
                    return !!d && (a = 1 == n.backwards, e = 0 != n.skipCurrent, t = n.range, (i = (i = n.start) || (t ? t[a ? "end" : "start"] : h.selection.getRange())).start && (i = i[e != a ? "end" : "start"]), o = t ? t.start.row : 0, r = t ? t.end.row : h.getLength() - 1, s = n.$isMultiLine ? (l = d.length, function(e, t, n) {
                        var i = a ? e - l + 1 : e;
                        if (!(i < 0 || i + l > h.getLength())) {
                            var o = h.getLine(i), e = o.search(d[0]);
                            if (!(!a && e < t || -1 === e)) {
                                for(var r = 1; r < l; r++)if (-1 == (o = h.getLine(i + r)).search(d[r])) return;
                                var s = o.match(d[l - 1])[0].length;
                                if (!(a && t < s)) return !!n(i, e, i + l - 1, s) || void 0;
                            }
                        }
                    }) : a ? function(e, t, n) {
                        var i, o = h.getLine(e), r = [];
                        for(d.lastIndex = 0; i = d.exec(o);){
                            var s = i[0].length, a = i.index;
                            if (!s) {
                                if (a >= o.length) break;
                                d.lastIndex = a += 1;
                            }
                            if (i.index + s > t) break;
                            r.push(i.index, s);
                        }
                        for(var l = r.length - 1; 0 <= l; l -= 2){
                            var c = r[l - 1];
                            if (n(e, c, e, c + (s = r[l]))) return !0;
                        }
                    } : function(e, t, n) {
                        var i = h.getLine(e);
                        for(d.lastIndex = t; o = d.exec(i);){
                            var o, r = o[0].length;
                            if (n(e, o = o.index, e, o + r)) return !0;
                            if (!r && (d.lastIndex = o += 1, o >= i.length)) return !1;
                        }
                    }, {
                        forEach: a ? function(e) {
                            var t = i.row;
                            if (!s(t, i.column, e)) {
                                for(t--; o <= t; t--)if (s(t, Number.MAX_VALUE, e)) return;
                                if (0 != n.wrap) {
                                    for(t = r, o = i.row; o <= t; t--)if (s(t, Number.MAX_VALUE, e)) return;
                                }
                            }
                        } : function(e) {
                            var t = i.row;
                            if (!s(t, i.column, e)) {
                                for(t += 1; t <= r; t++)if (s(t, 0, e)) return;
                                if (0 != n.wrap) {
                                    for(t = o, r = i.row; t <= r; t++)if (s(t, 0, e)) return;
                                }
                            }
                        }
                    });
                }, t.Search = o;
            }), ace.define("ace/keyboard/hash_handler", [
                "require",
                "exports",
                "module",
                "ace/lib/keys",
                "ace/lib/useragent"
            ], function(e, t, n) {
                "use strict";
                var a = e("../lib/keys"), i = e("../lib/useragent"), l = a.KEY_MODS;
                function o(e, t) {
                    this.platform = t || (i.isMac ? "mac" : "win"), this.commands = {}, this.commandKeyBinding = {}, this.addCommands(e), this.$singleCommand = !0;
                }
                function r(e, t) {
                    o.call(this, e, t), this.$singleCommand = !1;
                }
                r.prototype = o.prototype, (function() {
                    function s(e) {
                        return "object" == typeof e && e.bindKey && e.bindKey.position || (e.isDefault ? -100 : 0);
                    }
                    this.addCommand = function(e) {
                        this.commands[e.name] && this.removeCommand(e), (this.commands[e.name] = e).bindKey && this._buildKeyHash(e);
                    }, this.removeCommand = function(e, t) {
                        var n, i = e && ("string" == typeof e ? e : e.name), o = (e = this.commands[i], t || delete this.commands[i], this.commandKeyBinding);
                        for(n in o){
                            var r, s = o[n];
                            s == e ? delete o[n] : Array.isArray(s) && -1 != (r = s.indexOf(e)) && (s.splice(r, 1), 1 == s.length) && (o[n] = s[0]);
                        }
                    }, this.bindKey = function(e, i, o) {
                        if ("object" == typeof e && e && (null == o && (o = e.position), e = e[this.platform]), e) return "function" == typeof i ? this.addCommand({
                            exec: i,
                            bindKey: e,
                            name: i.name || e
                        }) : void e.split("|").forEach(function(e) {
                            var t = "", n = (-1 != e.indexOf(" ") && (e = (n = e.split(/\s+/)).pop(), n.forEach(function(e) {
                                e = this.parseKeys(e), e = l[e.hashId] + e.key;
                                t += (t ? " " : "") + e, this._addCommandToBinding(t, "chainKeys");
                            }, this), t += " "), this.parseKeys(e)), e = l[n.hashId] + n.key;
                            this._addCommandToBinding(t + e, i, o);
                        }, this);
                    }, this._addCommandToBinding = function(e, t, n) {
                        var i = this.commandKeyBinding;
                        if (t) {
                            if (!i[e] || this.$singleCommand) i[e] = t;
                            else {
                                Array.isArray(i[e]) ? -1 != (r = i[e].indexOf(t)) && i[e].splice(r, 1) : i[e] = [
                                    i[e]
                                ], "number" != typeof n && (n = s(t));
                                for(var o = i[e], r = 0; r < o.length; r++)if (n < s(o[r])) break;
                                o.splice(r, 0, t);
                            }
                        } else delete i[e];
                    }, this.addCommands = function(n) {
                        n && Object.keys(n).forEach(function(e) {
                            var t = n[e];
                            if (t) {
                                if ("string" == typeof t) return this.bindKey(t, e);
                                "object" == typeof (t = "function" == typeof t ? {
                                    exec: t
                                } : t) && (t.name || (t.name = e), this.addCommand(t));
                            }
                        }, this);
                    }, this.removeCommands = function(t) {
                        Object.keys(t).forEach(function(e) {
                            this.removeCommand(t[e]);
                        }, this);
                    }, this.bindKeys = function(t) {
                        Object.keys(t).forEach(function(e) {
                            this.bindKey(e, t[e]);
                        }, this);
                    }, this._buildKeyHash = function(e) {
                        this.bindKey(e.bindKey, e);
                    }, this.parseKeys = function(e) {
                        var t = e.toLowerCase().split(/[\-\+]([\-\+])?/).filter(function(e) {
                            return e;
                        }), n = t.pop(), i = a[n];
                        if (a.FUNCTION_KEYS[i]) n = a.FUNCTION_KEYS[i].toLowerCase();
                        else {
                            if (!t.length) return {
                                key: n,
                                hashId: -1
                            };
                            if (1 == t.length && "shift" == t[0]) return {
                                key: n.toUpperCase(),
                                hashId: -1
                            };
                        }
                        for(var o = 0, r = t.length; r--;){
                            var s = a.KEY_MODS[t[r]];
                            if (null == s) return "undefined" != typeof console && console.error("invalid modifier " + t[r] + " in " + e), !1;
                            o |= s;
                        }
                        return {
                            key: n,
                            hashId: o
                        };
                    }, this.findKeyCommand = function(e, t) {
                        e = l[e] + t;
                        return this.commandKeyBinding[e];
                    }, this.handleKeyboard = function(e, t, n, i) {
                        var o, r;
                        if (!(i < 0)) return o = l[t] + n, r = this.commandKeyBinding[o], e.$keyChain && (e.$keyChain += " " + o, r = this.commandKeyBinding[e.$keyChain] || r), !r || "chainKeys" != r && "chainKeys" != r[r.length - 1] ? (e.$keyChain && (t && 4 != t || 1 != n.length ? (-1 == t || 0 < i) && (e.$keyChain = "") : e.$keyChain = e.$keyChain.slice(0, -o.length - 1)), {
                            command: r
                        }) : (e.$keyChain = e.$keyChain || o, {
                            command: "null"
                        });
                    }, this.getStatusText = function(e, t) {
                        return t.$keyChain || "";
                    };
                }).call(o.prototype), t.HashHandler = o, t.MultiHashHandler = r;
            }), ace.define("ace/commands/command_manager", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/keyboard/hash_handler",
                "ace/lib/event_emitter"
            ], function(e, t, n) {
                "use strict";
                var i, o, r = this && this.__extends || (i = function(e, t) {
                    return (i = Object.setPrototypeOf || (({
                        __proto__: []
                    }) instanceof Array ? function(e, t) {
                        e.__proto__ = t;
                    } : function(e, t) {
                        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                    }))(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function n() {
                        this.constructor = e;
                    }
                    i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
                }), s = e("../lib/oop"), a = e("../keyboard/hash_handler").MultiHashHandler, e = e("../lib/event_emitter").EventEmitter, r = (r(l, o = a), l.prototype.exec = function(e, t, n) {
                    if (Array.isArray(e)) {
                        for(var i = e.length; i--;)if (this.exec(e[i], t, n)) return !0;
                        return !1;
                    }
                    var o;
                    return !!(e = "string" == typeof e ? this.commands[e] : e) && !(t && t.$readOnly && !e.readOnly || 0 != this.$checkCommandState && e.isAvailable && !e.isAvailable(t) || ((o = {
                        editor: t,
                        command: e,
                        args: n
                    }).returnValue = this._emit("exec", o), this._signal("afterExec", o), !1 === o.returnValue));
                }, l.prototype.toggleRecording = function(e) {
                    if (!this.$inReplay) return e && e._emit("changeStatus"), this.recording ? (this.macro.pop(), this.off("exec", this.$addCommandToMacro), this.macro.length || (this.macro = this.oldMacro), this.recording = !1) : (this.$addCommandToMacro || (this.$addCommandToMacro = (function(e) {
                        this.macro.push([
                            e.command,
                            e.args
                        ]);
                    }).bind(this)), this.oldMacro = this.macro, this.macro = [], this.on("exec", this.$addCommandToMacro), this.recording = !0);
                }, l.prototype.replay = function(t) {
                    if (!this.$inReplay && this.macro) {
                        if (this.recording) return this.toggleRecording(t);
                        try {
                            this.$inReplay = !0, this.macro.forEach(function(e) {
                                "string" == typeof e ? this.exec(e, t) : this.exec(e[0], t, e[1]);
                            }, this);
                        } finally{
                            this.$inReplay = !1;
                        }
                    }
                }, l.prototype.trimMacro = function(e) {
                    return e.map(function(e) {
                        return "string" != typeof e[0] && (e[0] = e[0].name), e = e[1] ? e : e[0];
                    });
                }, l);
                function l(e, t) {
                    t = o.call(this, t, e) || this;
                    return t.byName = t.commands, t.setDefaultHandler("exec", function(e) {
                        return e.args ? e.command.exec(e.editor, e.args, e.event, !1) : e.command.exec(e.editor, {}, e.event, !0);
                    }), t;
                }
                s.implement(r.prototype, e), t.CommandManager = r;
            }), ace.define("ace/commands/default_commands", [
                "require",
                "exports",
                "module",
                "ace/lib/lang",
                "ace/config",
                "ace/range"
            ], function(e, t, n) {
                "use strict";
                var l = e("../lib/lang"), i = e("../config"), c = e("../range").Range;
                function o(e, t) {
                    return {
                        win: e,
                        mac: t
                    };
                }
                t.commands = [
                    {
                        name: "showSettingsMenu",
                        description: "Show settings menu",
                        bindKey: o("Ctrl-,", "Command-,"),
                        exec: function(t) {
                            i.loadModule("ace/ext/settings_menu", function(e) {
                                e.init(t), t.showSettingsMenu();
                            });
                        },
                        readOnly: !0
                    },
                    {
                        name: "goToNextError",
                        description: "Go to next error",
                        bindKey: o("Alt-E", "F4"),
                        exec: function(t) {
                            i.loadModule("ace/ext/error_marker", function(e) {
                                e.showErrorMarker(t, 1);
                            });
                        },
                        scrollIntoView: "animate",
                        readOnly: !0
                    },
                    {
                        name: "goToPreviousError",
                        description: "Go to previous error",
                        bindKey: o("Alt-Shift-E", "Shift-F4"),
                        exec: function(t) {
                            i.loadModule("ace/ext/error_marker", function(e) {
                                e.showErrorMarker(t, -1);
                            });
                        },
                        scrollIntoView: "animate",
                        readOnly: !0
                    },
                    {
                        name: "selectall",
                        description: "Select all",
                        bindKey: o("Ctrl-A", "Command-A"),
                        exec: function(e) {
                            e.selectAll();
                        },
                        readOnly: !0
                    },
                    {
                        name: "centerselection",
                        description: "Center selection",
                        bindKey: o(null, "Ctrl-L"),
                        exec: function(e) {
                            e.centerSelection();
                        },
                        readOnly: !0
                    },
                    {
                        name: "gotoline",
                        description: "Go to line...",
                        bindKey: o("Ctrl-L", "Command-L"),
                        exec: function(e, t) {
                            "number" != typeof t || isNaN(t) || e.gotoLine(t), e.prompt({
                                $type: "gotoLine"
                            });
                        },
                        readOnly: !0
                    },
                    {
                        name: "fold",
                        bindKey: o("Alt-L|Ctrl-F1", "Command-Alt-L|Command-F1"),
                        exec: function(e) {
                            e.session.toggleFold(!1);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "unfold",
                        bindKey: o("Alt-Shift-L|Ctrl-Shift-F1", "Command-Alt-Shift-L|Command-Shift-F1"),
                        exec: function(e) {
                            e.session.toggleFold(!0);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "toggleFoldWidget",
                        description: "Toggle fold widget",
                        bindKey: o("F2", "F2"),
                        exec: function(e) {
                            e.session.toggleFoldWidget();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "toggleParentFoldWidget",
                        description: "Toggle parent fold widget",
                        bindKey: o("Alt-F2", "Alt-F2"),
                        exec: function(e) {
                            e.session.toggleFoldWidget(!0);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "foldall",
                        description: "Fold all",
                        bindKey: o(null, "Ctrl-Command-Option-0"),
                        exec: function(e) {
                            e.session.foldAll();
                        },
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "foldAllComments",
                        description: "Fold all comments",
                        bindKey: o(null, "Ctrl-Command-Option-0"),
                        exec: function(e) {
                            e.session.foldAllComments();
                        },
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "foldOther",
                        description: "Fold other",
                        bindKey: o("Alt-0", "Command-Option-0"),
                        exec: function(e) {
                            e.session.foldAll(), e.session.unfold(e.selection.getAllRanges());
                        },
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "unfoldall",
                        description: "Unfold all",
                        bindKey: o("Alt-Shift-0", "Command-Option-Shift-0"),
                        exec: function(e) {
                            e.session.unfold();
                        },
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "findnext",
                        description: "Find next",
                        bindKey: o("Ctrl-K", "Command-G"),
                        exec: function(e) {
                            e.findNext();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "findprevious",
                        description: "Find previous",
                        bindKey: o("Ctrl-Shift-K", "Command-Shift-G"),
                        exec: function(e) {
                            e.findPrevious();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "center",
                        readOnly: !0
                    },
                    {
                        name: "selectOrFindNext",
                        description: "Select or find next",
                        bindKey: o("Alt-K", "Ctrl-G"),
                        exec: function(e) {
                            e.selection.isEmpty() ? e.selection.selectWord() : e.findNext();
                        },
                        readOnly: !0
                    },
                    {
                        name: "selectOrFindPrevious",
                        description: "Select or find previous",
                        bindKey: o("Alt-Shift-K", "Ctrl-Shift-G"),
                        exec: function(e) {
                            e.selection.isEmpty() ? e.selection.selectWord() : e.findPrevious();
                        },
                        readOnly: !0
                    },
                    {
                        name: "find",
                        description: "Find",
                        bindKey: o("Ctrl-F", "Command-F"),
                        exec: function(t) {
                            i.loadModule("ace/ext/searchbox", function(e) {
                                e.Search(t);
                            });
                        },
                        readOnly: !0
                    },
                    {
                        name: "overwrite",
                        description: "Overwrite",
                        bindKey: "Insert",
                        exec: function(e) {
                            e.toggleOverwrite();
                        },
                        readOnly: !0
                    },
                    {
                        name: "selecttostart",
                        description: "Select to start",
                        bindKey: o("Ctrl-Shift-Home", "Command-Shift-Home|Command-Shift-Up"),
                        exec: function(e) {
                            e.getSelection().selectFileStart();
                        },
                        multiSelectAction: "forEach",
                        readOnly: !0,
                        scrollIntoView: "animate",
                        aceCommandGroup: "fileJump"
                    },
                    {
                        name: "gotostart",
                        description: "Go to start",
                        bindKey: o("Ctrl-Home", "Command-Home|Command-Up"),
                        exec: function(e) {
                            e.navigateFileStart();
                        },
                        multiSelectAction: "forEach",
                        readOnly: !0,
                        scrollIntoView: "animate",
                        aceCommandGroup: "fileJump"
                    },
                    {
                        name: "selectup",
                        description: "Select up",
                        bindKey: o("Shift-Up", "Shift-Up|Ctrl-Shift-P"),
                        exec: function(e) {
                            e.getSelection().selectUp();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "golineup",
                        description: "Go line up",
                        bindKey: o("Up", "Up|Ctrl-P"),
                        exec: function(e, t) {
                            e.navigateUp(t.times);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selecttoend",
                        description: "Select to end",
                        bindKey: o("Ctrl-Shift-End", "Command-Shift-End|Command-Shift-Down"),
                        exec: function(e) {
                            e.getSelection().selectFileEnd();
                        },
                        multiSelectAction: "forEach",
                        readOnly: !0,
                        scrollIntoView: "animate",
                        aceCommandGroup: "fileJump"
                    },
                    {
                        name: "gotoend",
                        description: "Go to end",
                        bindKey: o("Ctrl-End", "Command-End|Command-Down"),
                        exec: function(e) {
                            e.navigateFileEnd();
                        },
                        multiSelectAction: "forEach",
                        readOnly: !0,
                        scrollIntoView: "animate",
                        aceCommandGroup: "fileJump"
                    },
                    {
                        name: "selectdown",
                        description: "Select down",
                        bindKey: o("Shift-Down", "Shift-Down|Ctrl-Shift-N"),
                        exec: function(e) {
                            e.getSelection().selectDown();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "golinedown",
                        description: "Go line down",
                        bindKey: o("Down", "Down|Ctrl-N"),
                        exec: function(e, t) {
                            e.navigateDown(t.times);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectwordleft",
                        description: "Select word left",
                        bindKey: o("Ctrl-Shift-Left", "Option-Shift-Left"),
                        exec: function(e) {
                            e.getSelection().selectWordLeft();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "gotowordleft",
                        description: "Go to word left",
                        bindKey: o("Ctrl-Left", "Option-Left"),
                        exec: function(e) {
                            e.navigateWordLeft();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selecttolinestart",
                        description: "Select to line start",
                        bindKey: o("Alt-Shift-Left", "Command-Shift-Left|Ctrl-Shift-A"),
                        exec: function(e) {
                            e.getSelection().selectLineStart();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "gotolinestart",
                        description: "Go to line start",
                        bindKey: o("Alt-Left|Home", "Command-Left|Home|Ctrl-A"),
                        exec: function(e) {
                            e.navigateLineStart();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectleft",
                        description: "Select left",
                        bindKey: o("Shift-Left", "Shift-Left|Ctrl-Shift-B"),
                        exec: function(e) {
                            e.getSelection().selectLeft();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "gotoleft",
                        description: "Go to left",
                        bindKey: o("Left", "Left|Ctrl-B"),
                        exec: function(e, t) {
                            e.navigateLeft(t.times);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectwordright",
                        description: "Select word right",
                        bindKey: o("Ctrl-Shift-Right", "Option-Shift-Right"),
                        exec: function(e) {
                            e.getSelection().selectWordRight();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "gotowordright",
                        description: "Go to word right",
                        bindKey: o("Ctrl-Right", "Option-Right"),
                        exec: function(e) {
                            e.navigateWordRight();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selecttolineend",
                        description: "Select to line end",
                        bindKey: o("Alt-Shift-Right", "Command-Shift-Right|Shift-End|Ctrl-Shift-E"),
                        exec: function(e) {
                            e.getSelection().selectLineEnd();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "gotolineend",
                        description: "Go to line end",
                        bindKey: o("Alt-Right|End", "Command-Right|End|Ctrl-E"),
                        exec: function(e) {
                            e.navigateLineEnd();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectright",
                        description: "Select right",
                        bindKey: o("Shift-Right", "Shift-Right"),
                        exec: function(e) {
                            e.getSelection().selectRight();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "gotoright",
                        description: "Go to right",
                        bindKey: o("Right", "Right|Ctrl-F"),
                        exec: function(e, t) {
                            e.navigateRight(t.times);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectpagedown",
                        description: "Select page down",
                        bindKey: "Shift-PageDown",
                        exec: function(e) {
                            e.selectPageDown();
                        },
                        readOnly: !0
                    },
                    {
                        name: "pagedown",
                        description: "Page down",
                        bindKey: o(null, "Option-PageDown"),
                        exec: function(e) {
                            e.scrollPageDown();
                        },
                        readOnly: !0
                    },
                    {
                        name: "gotopagedown",
                        description: "Go to page down",
                        bindKey: o("PageDown", "PageDown|Ctrl-V"),
                        exec: function(e) {
                            e.gotoPageDown();
                        },
                        readOnly: !0
                    },
                    {
                        name: "selectpageup",
                        description: "Select page up",
                        bindKey: "Shift-PageUp",
                        exec: function(e) {
                            e.selectPageUp();
                        },
                        readOnly: !0
                    },
                    {
                        name: "pageup",
                        description: "Page up",
                        bindKey: o(null, "Option-PageUp"),
                        exec: function(e) {
                            e.scrollPageUp();
                        },
                        readOnly: !0
                    },
                    {
                        name: "gotopageup",
                        description: "Go to page up",
                        bindKey: "PageUp",
                        exec: function(e) {
                            e.gotoPageUp();
                        },
                        readOnly: !0
                    },
                    {
                        name: "scrollup",
                        description: "Scroll up",
                        bindKey: o("Ctrl-Up", null),
                        exec: function(e) {
                            e.renderer.scrollBy(0, -2 * e.renderer.layerConfig.lineHeight);
                        },
                        readOnly: !0
                    },
                    {
                        name: "scrolldown",
                        description: "Scroll down",
                        bindKey: o("Ctrl-Down", null),
                        exec: function(e) {
                            e.renderer.scrollBy(0, 2 * e.renderer.layerConfig.lineHeight);
                        },
                        readOnly: !0
                    },
                    {
                        name: "selectlinestart",
                        description: "Select line start",
                        bindKey: "Shift-Home",
                        exec: function(e) {
                            e.getSelection().selectLineStart();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectlineend",
                        description: "Select line end",
                        bindKey: "Shift-End",
                        exec: function(e) {
                            e.getSelection().selectLineEnd();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "togglerecording",
                        description: "Toggle recording",
                        bindKey: o("Ctrl-Alt-E", "Command-Option-E"),
                        exec: function(e) {
                            e.commands.toggleRecording(e);
                        },
                        readOnly: !0
                    },
                    {
                        name: "replaymacro",
                        description: "Replay macro",
                        bindKey: o("Ctrl-Shift-E", "Command-Shift-E"),
                        exec: function(e) {
                            e.commands.replay(e);
                        },
                        readOnly: !0
                    },
                    {
                        name: "jumptomatching",
                        description: "Jump to matching",
                        bindKey: o("Ctrl-\\|Ctrl-P", "Command-\\"),
                        exec: function(e) {
                            e.jumpToMatching();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "animate",
                        readOnly: !0
                    },
                    {
                        name: "selecttomatching",
                        description: "Select to matching",
                        bindKey: o("Ctrl-Shift-\\|Ctrl-Shift-P", "Command-Shift-\\"),
                        exec: function(e) {
                            e.jumpToMatching(!0);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "animate",
                        readOnly: !0
                    },
                    {
                        name: "expandToMatching",
                        description: "Expand to matching",
                        bindKey: o("Ctrl-Shift-M", "Ctrl-Shift-M"),
                        exec: function(e) {
                            e.jumpToMatching(!0, !0);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "animate",
                        readOnly: !0
                    },
                    {
                        name: "passKeysToBrowser",
                        description: "Pass keys to browser",
                        bindKey: o(null, null),
                        exec: function() {},
                        passEvent: !0,
                        readOnly: !0
                    },
                    {
                        name: "copy",
                        description: "Copy",
                        exec: function(e) {},
                        readOnly: !0
                    },
                    {
                        name: "cut",
                        description: "Cut",
                        exec: function(e) {
                            var t = e.$copyWithEmptySelection && e.selection.isEmpty() ? e.selection.getLineRange() : e.selection.getRange();
                            e._emit("cut", t), t.isEmpty() || e.session.remove(t), e.clearSelection();
                        },
                        scrollIntoView: "cursor",
                        multiSelectAction: "forEach"
                    },
                    {
                        name: "paste",
                        description: "Paste",
                        exec: function(e, t) {
                            e.$handlePaste(t);
                        },
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "removeline",
                        description: "Remove line",
                        bindKey: o("Ctrl-D", "Command-D"),
                        exec: function(e) {
                            e.removeLines();
                        },
                        scrollIntoView: "cursor",
                        multiSelectAction: "forEachLine"
                    },
                    {
                        name: "duplicateSelection",
                        description: "Duplicate selection",
                        bindKey: o("Ctrl-Shift-D", "Command-Shift-D"),
                        exec: function(e) {
                            e.duplicateSelection();
                        },
                        scrollIntoView: "cursor",
                        multiSelectAction: "forEach"
                    },
                    {
                        name: "sortlines",
                        description: "Sort lines",
                        bindKey: o("Ctrl-Alt-S", "Command-Alt-S"),
                        exec: function(e) {
                            e.sortLines();
                        },
                        scrollIntoView: "selection",
                        multiSelectAction: "forEachLine"
                    },
                    {
                        name: "togglecomment",
                        description: "Toggle comment",
                        bindKey: o("Ctrl-/", "Command-/"),
                        exec: function(e) {
                            e.toggleCommentLines();
                        },
                        multiSelectAction: "forEachLine",
                        scrollIntoView: "selectionPart"
                    },
                    {
                        name: "toggleBlockComment",
                        description: "Toggle block comment",
                        bindKey: o("Ctrl-Shift-/", "Command-Shift-/"),
                        exec: function(e) {
                            e.toggleBlockComment();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "selectionPart"
                    },
                    {
                        name: "modifyNumberUp",
                        description: "Modify number up",
                        bindKey: o("Ctrl-Shift-Up", "Alt-Shift-Up"),
                        exec: function(e) {
                            e.modifyNumber(1);
                        },
                        scrollIntoView: "cursor",
                        multiSelectAction: "forEach"
                    },
                    {
                        name: "modifyNumberDown",
                        description: "Modify number down",
                        bindKey: o("Ctrl-Shift-Down", "Alt-Shift-Down"),
                        exec: function(e) {
                            e.modifyNumber(-1);
                        },
                        scrollIntoView: "cursor",
                        multiSelectAction: "forEach"
                    },
                    {
                        name: "replace",
                        description: "Replace",
                        bindKey: o("Ctrl-H", "Command-Option-F"),
                        exec: function(t) {
                            i.loadModule("ace/ext/searchbox", function(e) {
                                e.Search(t, !0);
                            });
                        }
                    },
                    {
                        name: "undo",
                        description: "Undo",
                        bindKey: o("Ctrl-Z", "Command-Z"),
                        exec: function(e) {
                            e.undo();
                        }
                    },
                    {
                        name: "redo",
                        description: "Redo",
                        bindKey: o("Ctrl-Shift-Z|Ctrl-Y", "Command-Shift-Z|Command-Y"),
                        exec: function(e) {
                            e.redo();
                        }
                    },
                    {
                        name: "copylinesup",
                        description: "Copy lines up",
                        bindKey: o("Alt-Shift-Up", "Command-Option-Up"),
                        exec: function(e) {
                            e.copyLinesUp();
                        },
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "movelinesup",
                        description: "Move lines up",
                        bindKey: o("Alt-Up", "Option-Up"),
                        exec: function(e) {
                            e.moveLinesUp();
                        },
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "copylinesdown",
                        description: "Copy lines down",
                        bindKey: o("Alt-Shift-Down", "Command-Option-Down"),
                        exec: function(e) {
                            e.copyLinesDown();
                        },
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "movelinesdown",
                        description: "Move lines down",
                        bindKey: o("Alt-Down", "Option-Down"),
                        exec: function(e) {
                            e.moveLinesDown();
                        },
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "del",
                        description: "Delete",
                        bindKey: o("Delete", "Delete|Ctrl-D|Shift-Delete"),
                        exec: function(e) {
                            e.remove("right");
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "backspace",
                        description: "Backspace",
                        bindKey: o("Shift-Backspace|Backspace", "Ctrl-Backspace|Shift-Backspace|Backspace|Ctrl-H"),
                        exec: function(e) {
                            e.remove("left");
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "cut_or_delete",
                        description: "Cut or delete",
                        bindKey: o("Shift-Delete", null),
                        exec: function(e) {
                            if (!e.selection.isEmpty()) return !1;
                            e.remove("left");
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "removetolinestart",
                        description: "Remove to line start",
                        bindKey: o("Alt-Backspace", "Command-Backspace"),
                        exec: function(e) {
                            e.removeToLineStart();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "removetolineend",
                        description: "Remove to line end",
                        bindKey: o("Alt-Delete", "Ctrl-K|Command-Delete"),
                        exec: function(e) {
                            e.removeToLineEnd();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "removetolinestarthard",
                        description: "Remove to line start hard",
                        bindKey: o("Ctrl-Shift-Backspace", null),
                        exec: function(e) {
                            var t = e.selection.getRange();
                            t.start.column = 0, e.session.remove(t);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "removetolineendhard",
                        description: "Remove to line end hard",
                        bindKey: o("Ctrl-Shift-Delete", null),
                        exec: function(e) {
                            var t = e.selection.getRange();
                            t.end.column = Number.MAX_VALUE, e.session.remove(t);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "removewordleft",
                        description: "Remove word left",
                        bindKey: o("Ctrl-Backspace", "Alt-Backspace|Ctrl-Alt-Backspace"),
                        exec: function(e) {
                            e.removeWordLeft();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "removewordright",
                        description: "Remove word right",
                        bindKey: o("Ctrl-Delete", "Alt-Delete"),
                        exec: function(e) {
                            e.removeWordRight();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "outdent",
                        description: "Outdent",
                        bindKey: o("Shift-Tab", "Shift-Tab"),
                        exec: function(e) {
                            e.blockOutdent();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "selectionPart"
                    },
                    {
                        name: "indent",
                        description: "Indent",
                        bindKey: o("Tab", "Tab"),
                        exec: function(e) {
                            e.indent();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "selectionPart"
                    },
                    {
                        name: "blockoutdent",
                        description: "Block outdent",
                        bindKey: o("Ctrl-[", "Ctrl-["),
                        exec: function(e) {
                            e.blockOutdent();
                        },
                        multiSelectAction: "forEachLine",
                        scrollIntoView: "selectionPart"
                    },
                    {
                        name: "blockindent",
                        description: "Block indent",
                        bindKey: o("Ctrl-]", "Ctrl-]"),
                        exec: function(e) {
                            e.blockIndent();
                        },
                        multiSelectAction: "forEachLine",
                        scrollIntoView: "selectionPart"
                    },
                    {
                        name: "insertstring",
                        description: "Insert string",
                        exec: function(e, t) {
                            e.insert(t);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "inserttext",
                        description: "Insert text",
                        exec: function(e, t) {
                            e.insert(l.stringRepeat(t.text || "", t.times || 1));
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "splitline",
                        description: "Split line",
                        bindKey: o(null, "Ctrl-O"),
                        exec: function(e) {
                            e.splitLine();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "transposeletters",
                        description: "Transpose letters",
                        bindKey: o("Alt-Shift-X", "Ctrl-T"),
                        exec: function(e) {
                            e.transposeLetters();
                        },
                        multiSelectAction: function(e) {
                            e.transposeSelections(1);
                        },
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "touppercase",
                        description: "To uppercase",
                        bindKey: o("Ctrl-U", "Ctrl-U"),
                        exec: function(e) {
                            e.toUpperCase();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "tolowercase",
                        description: "To lowercase",
                        bindKey: o("Ctrl-Shift-U", "Ctrl-Shift-U"),
                        exec: function(e) {
                            e.toLowerCase();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "autoindent",
                        description: "Auto Indent",
                        bindKey: o(null, null),
                        exec: function(e) {
                            e.autoIndent();
                        },
                        multiSelectAction: "forEachLine",
                        scrollIntoView: "animate"
                    },
                    {
                        name: "expandtoline",
                        description: "Expand to line",
                        bindKey: o("Ctrl-Shift-L", "Command-Shift-L"),
                        exec: function(e) {
                            var t = e.selection.getRange();
                            t.start.column = t.end.column = 0, t.end.row++, e.selection.setRange(t, !1);
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "openlink",
                        bindKey: o("Ctrl+F3", "F3"),
                        exec: function(e) {
                            e.openLink();
                        }
                    },
                    {
                        name: "joinlines",
                        description: "Join lines",
                        bindKey: o(null, null),
                        exec: function(e) {
                            for(var t = e.selection.isBackwards(), n = t ? e.selection.getSelectionLead() : e.selection.getSelectionAnchor(), i = t ? e.selection.getSelectionAnchor() : e.selection.getSelectionLead(), t = e.session.doc.getLine(n.row).length, o = e.session.doc.getTextRange(e.selection.getRange()).replace(/\n\s*/, " ").length, r = e.session.doc.getLine(n.row), s = n.row + 1; s <= i.row + 1; s++){
                                var a = l.stringTrimLeft(l.stringTrimRight(e.session.doc.getLine(s)));
                                r += a = 0 !== a.length ? " " + a : a;
                            }
                            i.row + 1 < e.session.doc.getLength() - 1 && (r += e.session.doc.getNewLineCharacter()), e.clearSelection(), e.session.doc.replace(new c(n.row, 0, i.row + 2, 0), r), 0 < o ? (e.selection.moveCursorTo(n.row, n.column), e.selection.selectTo(n.row, n.column + o)) : (t = e.session.doc.getLine(n.row).length > t ? t + 1 : t, e.selection.moveCursorTo(n.row, t));
                        },
                        multiSelectAction: "forEach",
                        readOnly: !0
                    },
                    {
                        name: "invertSelection",
                        description: "Invert selection",
                        bindKey: o(null, null),
                        exec: function(e) {
                            var t = e.session.doc.getLength() - 1, n = e.session.doc.getLine(t).length, i = e.selection.rangeList.ranges, o = [];
                            i.length < 1 && (i = [
                                e.selection.getRange()
                            ]);
                            for(var r = 0; r < i.length; r++)r != i.length - 1 || i[r].end.row === t && i[r].end.column === n || o.push(new c(i[r].end.row, i[r].end.column, t, n)), 0 === r ? 0 === i[r].start.row && 0 === i[r].start.column || o.push(new c(0, 0, i[r].start.row, i[r].start.column)) : o.push(new c(i[r - 1].end.row, i[r - 1].end.column, i[r].start.row, i[r].start.column));
                            e.exitMultiSelectMode(), e.clearSelection();
                            for(r = 0; r < o.length; r++)e.selection.addRange(o[r], !1);
                        },
                        readOnly: !0,
                        scrollIntoView: "none"
                    },
                    {
                        name: "addLineAfter",
                        description: "Add new line after the current line",
                        exec: function(e) {
                            e.selection.clearSelection(), e.navigateLineEnd(), e.insert("\n");
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "addLineBefore",
                        description: "Add new line before the current line",
                        exec: function(e) {
                            e.selection.clearSelection();
                            var t = e.getCursorPosition();
                            e.selection.moveTo(t.row - 1, Number.MAX_VALUE), e.insert("\n"), 0 === t.row && e.navigateUp();
                        },
                        multiSelectAction: "forEach",
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "openCommandPallete",
                        description: "Open command palette",
                        bindKey: o("F1", "F1"),
                        exec: function(e) {
                            e.prompt({
                                $type: "commands"
                            });
                        },
                        readOnly: !0
                    },
                    {
                        name: "modeSelect",
                        description: "Change language mode...",
                        bindKey: o(null, null),
                        exec: function(e) {
                            e.prompt({
                                $type: "modes"
                            });
                        },
                        readOnly: !0
                    }
                ];
                for(var r = 1; r < 9; r++)t.commands.push({
                    name: "foldToLevel" + r,
                    description: "Fold To Level " + r,
                    level: r,
                    exec: function(e) {
                        e.session.foldToLevel(this.level);
                    },
                    scrollIntoView: "center",
                    readOnly: !0
                });
            }), ace.define("ace/line_widgets", [
                "require",
                "exports",
                "module",
                "ace/lib/dom"
            ], function(e, t, n) {
                "use strict";
                var o = e("./lib/dom");
                function i(e) {
                    this.session = e, (this.session.widgetManager = this).session.getRowLength = this.getRowLength, this.session.$getWidgetScreenLength = this.$getWidgetScreenLength, this.updateOnChange = this.updateOnChange.bind(this), this.renderWidgets = this.renderWidgets.bind(this), this.measureWidgets = this.measureWidgets.bind(this), this.session._changedWidgets = [], this.$onChangeEditor = this.$onChangeEditor.bind(this), this.session.on("change", this.updateOnChange), this.session.on("changeFold", this.updateOnFold), this.session.on("changeEditor", this.$onChangeEditor);
                }
                i.prototype.getRowLength = function(e) {
                    var t = this.lineWidgets && this.lineWidgets[e] && this.lineWidgets[e].rowCount || 0;
                    return this.$useWrapMode && this.$wrapData[e] ? this.$wrapData[e].length + 1 + t : 1 + t;
                }, i.prototype.$getWidgetScreenLength = function() {
                    var t = 0;
                    return this.lineWidgets.forEach(function(e) {
                        e && e.rowCount && !e.hidden && (t += e.rowCount);
                    }), t;
                }, i.prototype.$onChangeEditor = function(e) {
                    this.attach(e.editor);
                }, i.prototype.attach = function(e) {
                    e && e.widgetManager && e.widgetManager != this && e.widgetManager.detach(), this.editor != e && (this.detach(), this.editor = e) && (e.widgetManager = this, e.renderer.on("beforeRender", this.measureWidgets), e.renderer.on("afterRender", this.renderWidgets));
                }, i.prototype.detach = function(e) {
                    var t = this.editor;
                    t && (this.editor = null, t.widgetManager = null, t.renderer.off("beforeRender", this.measureWidgets), t.renderer.off("afterRender", this.renderWidgets), t = this.session.lineWidgets) && t.forEach(function(e) {
                        e && e.el && e.el.parentNode && (e._inDocument = !1, e.el.parentNode.removeChild(e.el));
                    });
                }, i.prototype.updateOnFold = function(e, t) {
                    var n = t.lineWidgets;
                    if (n && e.action) {
                        for(var t = e.data, i = t.start.row, o = t.end.row, r = "add" == e.action, s = i + 1; s < o; s++)n[s] && (n[s].hidden = r);
                        n[o] && (r ? n[i] ? n[o].hidden = r : n[i] = n[o] : (n[i] == n[o] && (n[i] = void 0), n[o].hidden = r));
                    }
                }, i.prototype.updateOnChange = function(e) {
                    var t, n, i, o = this.session.lineWidgets;
                    o && (t = e.start.row, 0 != (n = e.end.row - t)) && ("remove" == e.action ? (i = o.splice(t + 1, n), !o[t] && i[i.length - 1] && (o[t] = i.pop()), i.forEach(function(e) {
                        e && this.removeLineWidget(e);
                    }, this)) : (i = new Array(n), o[t] && null != o[t].column && e.start.column > o[t].column && t++, i.unshift(t, 0), o.splice.apply(o, i)), this.$updateRows());
                }, i.prototype.$updateRows = function() {
                    var n, e = this.session.lineWidgets;
                    e && (n = !0, e.forEach(function(e, t) {
                        if (e) for(n = !1, e.row = t; e.$oldWidget;)e.$oldWidget.row = t, e = e.$oldWidget;
                    }), n) && (this.session.lineWidgets = null);
                }, i.prototype.$registerLineWidget = function(e) {
                    this.session.lineWidgets || (this.session.lineWidgets = new Array(this.session.getLength()));
                    var t = this.session.lineWidgets[e.row];
                    return t && (e.$oldWidget = t).el && t.el.parentNode && (t.el.parentNode.removeChild(t.el), t._inDocument = !1), this.session.lineWidgets[e.row] = e;
                }, i.prototype.addLineWidget = function(e) {
                    var t, n, i;
                    return this.$registerLineWidget(e), e.session = this.session, this.editor && (t = this.editor.renderer, e.html && !e.el && (e.el = o.createElement("div"), e.el.innerHTML = e.html), e.text && !e.el && (e.el = o.createElement("div"), e.el.textContent = e.text), e.el && (o.addCssClass(e.el, "ace_lineWidgetContainer"), e.className && o.addCssClass(e.el, e.className), e.el.style.position = "absolute", e.el.style.zIndex = 5, t.container.appendChild(e.el), e._inDocument = !0, e.coverGutter || (e.el.style.zIndex = 3), null == e.pixelHeight) && (e.pixelHeight = e.el.offsetHeight), null == e.rowCount && (e.rowCount = e.pixelHeight / t.layerConfig.lineHeight), n = this.session.getFoldAt(e.row, 0), (e.$fold = n) && (i = this.session.lineWidgets, e.row != n.end.row || i[n.start.row] ? e.hidden = !0 : i[n.start.row] = e), this.session._emit("changeFold", {
                        data: {
                            start: {
                                row: e.row
                            }
                        }
                    }), this.$updateRows(), this.renderWidgets(null, t), this.onWidgetChanged(e)), e;
                }, i.prototype.removeLineWidget = function(e) {
                    if (e._inDocument = !1, e.session = null, e.el && e.el.parentNode && e.el.parentNode.removeChild(e.el), e.editor && e.editor.destroy) try {
                        e.editor.destroy();
                    } catch (e) {}
                    if (this.session.lineWidgets) {
                        var t = this.session.lineWidgets[e.row];
                        if (t == e) this.session.lineWidgets[e.row] = e.$oldWidget, e.$oldWidget && this.onWidgetChanged(e.$oldWidget);
                        else for(; t;){
                            if (t.$oldWidget == e) {
                                t.$oldWidget = e.$oldWidget;
                                break;
                            }
                            t = t.$oldWidget;
                        }
                    }
                    this.session._emit("changeFold", {
                        data: {
                            start: {
                                row: e.row
                            }
                        }
                    }), this.$updateRows();
                }, i.prototype.getWidgetsAtRow = function(e) {
                    for(var t = this.session.lineWidgets, n = t && t[e], i = []; n;)i.push(n), n = n.$oldWidget;
                    return i;
                }, i.prototype.onWidgetChanged = function(e) {
                    this.session._changedWidgets.push(e), this.editor && this.editor.renderer.updateFull();
                }, i.prototype.measureWidgets = function(e, t) {
                    var n = this.session._changedWidgets, i = t.layerConfig;
                    if (n && n.length) {
                        for(var o = 1 / 0, r = 0; r < n.length; r++){
                            var s = n[r];
                            if (s && s.el && s.session == this.session) {
                                if (!s._inDocument) {
                                    if (this.session.lineWidgets[s.row] != s) continue;
                                    s._inDocument = !0, t.container.appendChild(s.el);
                                }
                                s.h = s.el.offsetHeight, s.fixedWidth || (s.w = s.el.offsetWidth, s.screenWidth = Math.ceil(s.w / i.characterWidth));
                                var a = s.h / i.lineHeight;
                                s.coverLine && (a -= this.session.getRowLineCount(s.row)) < 0 && (a = 0), s.rowCount != a && (s.rowCount = a, s.row < o) && (o = s.row);
                            }
                        }
                        o != 1 / 0 && (this.session._emit("changeFold", {
                            data: {
                                start: {
                                    row: o
                                }
                            }
                        }), this.session.lineWidgetWidth = null), this.session._changedWidgets = [];
                    }
                }, i.prototype.renderWidgets = function(e, t) {
                    var n = t.layerConfig, i = this.session.lineWidgets;
                    if (i) {
                        for(var o = Math.min(this.firstRow, n.firstRow), r = Math.max(this.lastRow, n.lastRow, i.length); 0 < o && !i[o];)o--;
                        this.firstRow = n.firstRow, this.lastRow = n.lastRow, t.$cursorLayer.config = n;
                        for(var s = o; s <= r; s++){
                            var a, l = i[s];
                            l && l.el && (l.hidden ? l.el.style.top = -100 - (l.pixelHeight || 0) + "px" : (l._inDocument || (l._inDocument = !0, t.container.appendChild(l.el)), a = t.$cursorLayer.getPixelPosition({
                                row: s,
                                column: 0
                            }, !0).top, l.coverLine || (a += n.lineHeight * this.session.getRowLineCount(l.row)), l.el.style.top = a - n.offset + "px", a = l.coverGutter ? 0 : t.gutterWidth, l.fixedWidth || (a -= t.scrollLeft), l.el.style.left = a + "px", l.fullWidth && l.screenWidth && (l.el.style.minWidth = n.width + 2 * n.padding + "px"), l.fixedWidth ? l.el.style.right = t.scrollBar.getWidth() + "px" : l.el.style.right = ""));
                        }
                    }
                }, t.LineWidgets = i;
            }), ace.define("ace/keyboard/gutter_handler", [
                "require",
                "exports",
                "module",
                "ace/lib/keys",
                "ace/mouse/default_gutter_handler"
            ], function(e, t, n) {
                "use strict";
                var r = e("../lib/keys"), i = e("../mouse/default_gutter_handler").GutterTooltip;
                function o(e) {
                    this.editor = e, this.gutterLayer = e.renderer.$gutterLayer, this.element = e.renderer.$gutter, this.lines = e.renderer.$gutterLayer.$lines, this.activeRowIndex = null, this.activeLane = null, this.annotationTooltip = new i(this.editor);
                }
                o.prototype.addListener = function() {
                    this.element.addEventListener("keydown", this.$onGutterKeyDown.bind(this)), this.element.addEventListener("focusout", this.$blurGutter.bind(this)), this.editor.on("mousewheel", this.$blurGutter.bind(this));
                }, o.prototype.removeListener = function() {
                    this.element.removeEventListener("keydown", this.$onGutterKeyDown.bind(this)), this.element.removeEventListener("focusout", this.$blurGutter.bind(this)), this.editor.off("mousewheel", this.$blurGutter.bind(this));
                }, o.prototype.$onGutterKeyDown = function(e) {
                    var t;
                    if (this.annotationTooltip.isOpen) e.preventDefault(), e.keyCode === r.escape && this.annotationTooltip.hide();
                    else if (e.target === this.element) e.keyCode == r.enter && (e.preventDefault(), t = this.editor.getCursorPosition().row, this.editor.isRowVisible(t) || this.editor.scrollToLine(t, !0, !0), setTimeout((function() {
                        var e = this.$rowToRowIndex(this.gutterLayer.$cursorCell.row), t = this.$findNearestFoldWidget(e), n = this.$findNearestAnnotation(e);
                        null === t && null === n || (null === t && null !== n || (null === t || null !== n) && Math.abs(n - e) < Math.abs(t - e) ? (this.activeRowIndex = n, this.activeLane = "annotation", this.$focusAnnotation(this.activeRowIndex)) : (this.activeRowIndex = t, this.activeLane = "fold", this.$focusFoldWidget(this.activeRowIndex)));
                    }).bind(this), 10));
                    else if (e.keyCode === r.tab) e.preventDefault();
                    else if (e.keyCode === r.escape) e.preventDefault(), this.$blurGutter(), this.element.focus(), this.lane = null;
                    else if (e.keyCode === r.up) switch(e.preventDefault(), this.activeLane){
                        case "fold":
                            this.$moveFoldWidgetUp();
                            break;
                        case "annotation":
                            this.$moveAnnotationUp();
                    }
                    else if (e.keyCode === r.down) switch(e.preventDefault(), this.activeLane){
                        case "fold":
                            this.$moveFoldWidgetDown();
                            break;
                        case "annotation":
                            this.$moveAnnotationDown();
                    }
                    else if (e.keyCode === r.left && (e.preventDefault(), this.$switchLane("annotation")), e.keyCode === r.right && (e.preventDefault(), this.$switchLane("fold")), e.keyCode === r.enter || e.keyCode === r.space) switch(e.preventDefault(), this.activeLane){
                        case "fold":
                            if ("start" === this.gutterLayer.session.foldWidgets[this.$rowIndexToRow(this.activeRowIndex)]) {
                                var n = this.$rowIndexToRow(this.activeRowIndex);
                                this.editor.session.onFoldWidgetClick(this.$rowIndexToRow(this.activeRowIndex), e), setTimeout((function() {
                                    this.$rowIndexToRow(this.activeRowIndex) !== n && (this.$blurFoldWidget(this.activeRowIndex), this.activeRowIndex = this.$rowToRowIndex(n), this.$focusFoldWidget(this.activeRowIndex));
                                }).bind(this), 10);
                                break;
                            }
                            if ("end" === this.gutterLayer.session.foldWidgets[this.$rowIndexToRow(this.activeRowIndex)]) break;
                            return;
                        case "annotation":
                            var i = this.lines.cells[this.activeRowIndex].element.childNodes[2].getBoundingClientRect(), o = this.annotationTooltip.getElement().style;
                            o.left = i.right + "px", o.top = i.bottom + "px", this.annotationTooltip.showTooltip(this.$rowIndexToRow(this.activeRowIndex));
                    }
                }, o.prototype.$blurGutter = function() {
                    if (null !== this.activeRowIndex) switch(this.activeLane){
                        case "fold":
                            this.$blurFoldWidget(this.activeRowIndex);
                            break;
                        case "annotation":
                            this.$blurAnnotation(this.activeRowIndex);
                    }
                    this.annotationTooltip.isOpen && this.annotationTooltip.hide();
                }, o.prototype.$isFoldWidgetVisible = function(e) {
                    var t = this.editor.isRowFullyVisible(this.$rowIndexToRow(e)), e = "none" !== this.$getFoldWidget(e).style.display;
                    return t && e;
                }, o.prototype.$isAnnotationVisible = function(e) {
                    var t = this.editor.isRowFullyVisible(this.$rowIndexToRow(e)), e = "none" !== this.$getAnnotation(e).style.display;
                    return t && e;
                }, o.prototype.$getFoldWidget = function(e) {
                    return this.lines.get(e).element.childNodes[1];
                }, o.prototype.$getAnnotation = function(e) {
                    return this.lines.get(e).element.childNodes[2];
                }, o.prototype.$findNearestFoldWidget = function(e) {
                    if (this.$isFoldWidgetVisible(e)) return e;
                    for(var t = 0; 0 < e - t || e + t < this.lines.getLength() - 1;){
                        if (0 <= e - ++t && this.$isFoldWidgetVisible(e - t)) return e - t;
                        if (e + t <= this.lines.getLength() - 1 && this.$isFoldWidgetVisible(e + t)) return e + t;
                    }
                    return null;
                }, o.prototype.$findNearestAnnotation = function(e) {
                    if (this.$isAnnotationVisible(e)) return e;
                    for(var t = 0; 0 < e - t || e + t < this.lines.getLength() - 1;){
                        if (0 <= e - ++t && this.$isAnnotationVisible(e - t)) return e - t;
                        if (e + t <= this.lines.getLength() - 1 && this.$isAnnotationVisible(e + t)) return e + t;
                    }
                    return null;
                }, o.prototype.$focusFoldWidget = function(e) {
                    null != e && ((e = this.$getFoldWidget(e)).classList.add(this.editor.renderer.keyboardFocusClassName), e.focus());
                }, o.prototype.$focusAnnotation = function(e) {
                    null != e && ((e = this.$getAnnotation(e)).classList.add(this.editor.renderer.keyboardFocusClassName), e.setAttribute("role", "button"), e.focus());
                }, o.prototype.$blurFoldWidget = function(e) {
                    e = this.$getFoldWidget(e);
                    e.classList.remove(this.editor.renderer.keyboardFocusClassName), e.blur();
                }, o.prototype.$blurAnnotation = function(e) {
                    e = this.$getAnnotation(e);
                    e.classList.remove(this.editor.renderer.keyboardFocusClassName), e.removeAttribute("role"), e.blur();
                }, o.prototype.$moveFoldWidgetUp = function() {
                    for(var e = this.activeRowIndex; 0 < e;)if (this.$isFoldWidgetVisible(--e)) return this.$blurFoldWidget(this.activeRowIndex), this.activeRowIndex = e, void this.$focusFoldWidget(this.activeRowIndex);
                }, o.prototype.$moveFoldWidgetDown = function() {
                    for(var e = this.activeRowIndex; e < this.lines.getLength() - 1;)if (this.$isFoldWidgetVisible(++e)) return this.$blurFoldWidget(this.activeRowIndex), this.activeRowIndex = e, void this.$focusFoldWidget(this.activeRowIndex);
                }, o.prototype.$moveAnnotationUp = function() {
                    for(var e = this.activeRowIndex; 0 < e;)if (this.$isAnnotationVisible(--e)) return this.$blurAnnotation(this.activeRowIndex), this.activeRowIndex = e, void this.$focusAnnotation(this.activeRowIndex);
                }, o.prototype.$moveAnnotationDown = function() {
                    for(var e = this.activeRowIndex; e < this.lines.getLength() - 1;)if (this.$isAnnotationVisible(++e)) return this.$blurAnnotation(this.activeRowIndex), this.activeRowIndex = e, void this.$focusAnnotation(this.activeRowIndex);
                }, o.prototype.$switchLane = function(e) {
                    switch(e){
                        case "annotation":
                            "annotation" !== this.activeLane && null != (t = this.$findNearestAnnotation(this.activeRowIndex)) && (this.activeLane = "annotation", this.$blurFoldWidget(this.activeRowIndex), this.activeRowIndex = t, this.$focusAnnotation(this.activeRowIndex));
                            break;
                        case "fold":
                            var t;
                            "fold" !== this.activeLane && null != (t = this.$findNearestFoldWidget(this.activeRowIndex)) && (this.activeLane = "fold", this.$blurAnnotation(this.activeRowIndex), this.activeRowIndex = t, this.$focusFoldWidget(this.activeRowIndex));
                    }
                }, o.prototype.$rowIndexToRow = function(e) {
                    e = this.lines.get(e);
                    return e ? e.row : null;
                }, o.prototype.$rowToRowIndex = function(e) {
                    for(var t = 0; t < this.lines.getLength(); t++)if (this.lines.get(t).row == e) return t;
                    return null;
                }, t.GutterKeyboardHandler = o;
            }), ace.define("ace/editor", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/dom",
                "ace/lib/lang",
                "ace/lib/useragent",
                "ace/keyboard/textinput",
                "ace/mouse/mouse_handler",
                "ace/mouse/fold_handler",
                "ace/keyboard/keybinding",
                "ace/edit_session",
                "ace/search",
                "ace/range",
                "ace/lib/event_emitter",
                "ace/commands/command_manager",
                "ace/commands/default_commands",
                "ace/config",
                "ace/token_iterator",
                "ace/line_widgets",
                "ace/keyboard/gutter_handler",
                "ace/config",
                "ace/clipboard",
                "ace/lib/keys"
            ], function(e, t, n) {
                "use strict";
                var d = this && this.__values || function(e) {
                    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], i = 0;
                    if (n) return n.call(e);
                    if (e && "number" == typeof e.length) return {
                        next: function() {
                            return {
                                value: (e = e && i >= e.length ? void 0 : e) && e[i++],
                                done: !e
                            };
                        }
                    };
                    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                }, o = e("./lib/oop"), i = e("./lib/dom"), m = e("./lib/lang"), r = e("./lib/useragent"), s = e("./keyboard/textinput").TextInput, a = e("./mouse/mouse_handler").MouseHandler, l = e("./mouse/fold_handler").FoldHandler, c = e("./keyboard/keybinding").KeyBinding, h = e("./edit_session").EditSession, u = e("./search").Search, f = e("./range").Range, g = e("./lib/event_emitter").EventEmitter, p = e("./commands/command_manager").CommandManager, C = e("./commands/default_commands").commands, y = e("./config"), v = e("./token_iterator").TokenIterator, I = e("./line_widgets").LineWidgets, b = e("./keyboard/gutter_handler").GutterKeyboardHandler, A = e("./config").nls, w = e("./clipboard"), S = e("./lib/keys"), e = (x.prototype.$initOperationListeners = function() {
                    this.commands.on("exec", this.startOperation.bind(this), !0), this.commands.on("afterExec", this.endOperation.bind(this), !0), this.$opResetTimer = m.delayedCall(this.endOperation.bind(this, !0)), this.on("change", (function() {
                        this.curOp || (this.startOperation(), this.curOp.selectionBefore = this.$lastSel), this.curOp.docChanged = !0;
                    }).bind(this), !0), this.on("changeSelection", (function() {
                        this.curOp || (this.startOperation(), this.curOp.selectionBefore = this.$lastSel), this.curOp.selectionChanged = !0;
                    }).bind(this), !0);
                }, x.prototype.startOperation = function(e) {
                    if (this.curOp) {
                        if (!e || this.curOp.command) return;
                        this.prevOp = this.curOp;
                    }
                    e || (this.previousCommand = null, e = {}), this.$opResetTimer.schedule(), this.curOp = this.session.curOp = {
                        command: e.command || {},
                        args: e.args,
                        scrollTop: this.renderer.scrollTop
                    }, this.curOp.selectionBefore = this.selection.toJSON();
                }, x.prototype.endOperation = function(e) {
                    if (this.curOp && this.session) {
                        if (e && !1 === e.returnValue || !this.session) return this.curOp = null;
                        if ((1 != e || !this.curOp.command || "mouse" != this.curOp.command.name) && (this._signal("beforeEndOperation"), this.curOp)) {
                            var e = this.curOp.command, t = e && e.scrollIntoView;
                            if (t) {
                                switch(t){
                                    case "center-animate":
                                        t = "animate";
                                    case "center":
                                        this.renderer.scrollCursorIntoView(null, .5);
                                        break;
                                    case "animate":
                                    case "cursor":
                                        this.renderer.scrollCursorIntoView();
                                        break;
                                    case "selectionPart":
                                        var n = this.selection.getRange(), i = this.renderer.layerConfig;
                                        (n.start.row >= i.lastRow || n.end.row <= i.firstRow) && this.renderer.scrollSelectionIntoView(this.selection.anchor, this.selection.lead);
                                }
                                "animate" == t && this.renderer.animateScrolling(this.curOp.scrollTop);
                            }
                            e = this.selection.toJSON();
                            this.curOp.selectionAfter = e, this.$lastSel = this.selection.toJSON(), this.session.getUndoManager().addSelection(e), this.prevOp = this.curOp, this.curOp = null;
                        }
                    }
                }, x.prototype.$historyTracker = function(e) {
                    var t, n, i, o;
                    this.$mergeUndoDeltas && (t = this.prevOp, n = this.$mergeableCommands, i = t.command && e.command.name == t.command.name, "insertstring" == e.command.name ? (o = e.args, void 0 === this.mergeNextCommand && (this.mergeNextCommand = !0), i = i && this.mergeNextCommand && (!/\s/.test(o) || /\s/.test(t.args)), this.mergeNextCommand = !0) : i = i && -1 !== n.indexOf(e.command.name), (i = "always" != this.$mergeUndoDeltas && 2e3 < Date.now() - this.sequenceStartTime ? !1 : i) ? this.session.mergeUndoDeltas = !0 : -1 !== n.indexOf(e.command.name) && (this.sequenceStartTime = Date.now()));
                }, x.prototype.setKeyboardHandler = function(t, n) {
                    var i;
                    t && "string" == typeof t && "ace" != t ? (this.$keybindingId = t, i = this, y.loadModule([
                        "keybinding",
                        t
                    ], function(e) {
                        i.$keybindingId == t && i.keyBinding.setKeyboardHandler(e && e.handler), n && n();
                    })) : (this.$keybindingId = null, this.keyBinding.setKeyboardHandler(t), n && n());
                }, x.prototype.getKeyboardHandler = function() {
                    return this.keyBinding.getKeyboardHandler();
                }, x.prototype.setSession = function(e) {
                    var t, n;
                    this.session != e && (this.curOp && this.endOperation(), this.curOp = {}, (t = this.session) && (this.session.off("change", this.$onDocumentChange), this.session.off("changeMode", this.$onChangeMode), this.session.off("tokenizerUpdate", this.$onTokenizerUpdate), this.session.off("changeTabSize", this.$onChangeTabSize), this.session.off("changeWrapLimit", this.$onChangeWrapLimit), this.session.off("changeWrapMode", this.$onChangeWrapMode), this.session.off("changeFold", this.$onChangeFold), this.session.off("changeFrontMarker", this.$onChangeFrontMarker), this.session.off("changeBackMarker", this.$onChangeBackMarker), this.session.off("changeBreakpoint", this.$onChangeBreakpoint), this.session.off("changeAnnotation", this.$onChangeAnnotation), this.session.off("changeOverwrite", this.$onCursorChange), this.session.off("changeScrollTop", this.$onScrollTopChange), this.session.off("changeScrollLeft", this.$onScrollLeftChange), (n = this.session.getSelection()).off("changeCursor", this.$onCursorChange), n.off("changeSelection", this.$onSelectionChange)), (this.session = e) ? (this.$onDocumentChange = this.onDocumentChange.bind(this), e.on("change", this.$onDocumentChange), this.renderer.setSession(e), this.$onChangeMode = this.onChangeMode.bind(this), e.on("changeMode", this.$onChangeMode), this.$onTokenizerUpdate = this.onTokenizerUpdate.bind(this), e.on("tokenizerUpdate", this.$onTokenizerUpdate), this.$onChangeTabSize = this.renderer.onChangeTabSize.bind(this.renderer), e.on("changeTabSize", this.$onChangeTabSize), this.$onChangeWrapLimit = this.onChangeWrapLimit.bind(this), e.on("changeWrapLimit", this.$onChangeWrapLimit), this.$onChangeWrapMode = this.onChangeWrapMode.bind(this), e.on("changeWrapMode", this.$onChangeWrapMode), this.$onChangeFold = this.onChangeFold.bind(this), e.on("changeFold", this.$onChangeFold), this.$onChangeFrontMarker = this.onChangeFrontMarker.bind(this), this.session.on("changeFrontMarker", this.$onChangeFrontMarker), this.$onChangeBackMarker = this.onChangeBackMarker.bind(this), this.session.on("changeBackMarker", this.$onChangeBackMarker), this.$onChangeBreakpoint = this.onChangeBreakpoint.bind(this), this.session.on("changeBreakpoint", this.$onChangeBreakpoint), this.$onChangeAnnotation = this.onChangeAnnotation.bind(this), this.session.on("changeAnnotation", this.$onChangeAnnotation), this.$onCursorChange = this.onCursorChange.bind(this), this.session.on("changeOverwrite", this.$onCursorChange), this.$onScrollTopChange = this.onScrollTopChange.bind(this), this.session.on("changeScrollTop", this.$onScrollTopChange), this.$onScrollLeftChange = this.onScrollLeftChange.bind(this), this.session.on("changeScrollLeft", this.$onScrollLeftChange), this.selection = e.getSelection(), this.selection.on("changeCursor", this.$onCursorChange), this.$onSelectionChange = this.onSelectionChange.bind(this), this.selection.on("changeSelection", this.$onSelectionChange), this.onChangeMode(), this.onCursorChange(), this.onScrollTopChange(), this.onScrollLeftChange(), this.onSelectionChange(), this.onChangeFrontMarker(), this.onChangeBackMarker(), this.onChangeBreakpoint(), this.onChangeAnnotation(), this.session.getUseWrapMode() && this.renderer.adjustWrapLimit(), this.renderer.updateFull()) : (this.selection = null, this.renderer.setSession(e)), this._signal("changeSession", {
                        session: e,
                        oldSession: t
                    }), this.curOp = null, t && t._signal("changeEditor", {
                        oldEditor: this
                    }), e && e._signal("changeEditor", {
                        editor: this
                    }), e) && !e.destroyed && e.bgTokenizer.scheduleStart();
                }, x.prototype.getSession = function() {
                    return this.session;
                }, x.prototype.setValue = function(e, t) {
                    return this.session.doc.setValue(e), t ? 1 == t ? this.navigateFileEnd() : -1 == t && this.navigateFileStart() : this.selectAll(), e;
                }, x.prototype.getValue = function() {
                    return this.session.getValue();
                }, x.prototype.getSelection = function() {
                    return this.selection;
                }, x.prototype.resize = function(e) {
                    this.renderer.onResize(e);
                }, x.prototype.setTheme = function(e, t) {
                    this.renderer.setTheme(e, t);
                }, x.prototype.getTheme = function() {
                    return this.renderer.getTheme();
                }, x.prototype.setStyle = function(e) {
                    this.renderer.setStyle(e);
                }, x.prototype.unsetStyle = function(e) {
                    this.renderer.unsetStyle(e);
                }, x.prototype.getFontSize = function() {
                    return this.getOption("fontSize") || i.computedStyle(this.container).fontSize;
                }, x.prototype.setFontSize = function(e) {
                    this.setOption("fontSize", e);
                }, x.prototype.$highlightBrackets = function() {
                    var r;
                    this.$highlightPending || ((r = this).$highlightPending = !0, setTimeout(function() {
                        r.$highlightPending = !1;
                        var e, t, n, i, o = r.session;
                        o && !o.destroyed && (o.$bracketHighlight && (o.$bracketHighlight.markerIds.forEach(function(e) {
                            o.removeMarker(e);
                        }), o.$bracketHighlight = null), e = r.getCursorPosition(), t = (t = r.getKeyboardHandler()) && t.$getDirectionForHighlight && t.$getDirectionForHighlight(r), (t = o.getMatchingBracketRanges(e, t)) || (n = new v(o, e.row, e.column).getCurrentToken()) && /\b(?:tag-open|tag-name)/.test(n.type) && (n = o.getMatchingTags(e)) && (t = [
                            n.openTagName,
                            n.closeTagName
                        ]), (t = !t && o.$mode.getMatching ? o.$mode.getMatching(r.session) : t) && (i = "ace_bracket", Array.isArray(t) ? 1 == t.length && (i = "ace_error_bracket") : t = [
                            t
                        ], 2 == t.length && (0 == f.comparePoints(t[0].end, t[1].start) ? t = [
                            f.fromPoints(t[0].start, t[1].end)
                        ] : 0 == f.comparePoints(t[0].start, t[1].end) && (t = [
                            f.fromPoints(t[1].start, t[0].end)
                        ])), o.$bracketHighlight = {
                            ranges: t,
                            markerIds: t.map(function(e) {
                                return o.addMarker(e, i, "text");
                            })
                        }), r.getHighlightIndentGuides()) && r.renderer.$textLayer.$highlightIndentGuide();
                    }, 50));
                }, x.prototype.focus = function() {
                    this.textInput.focus();
                }, x.prototype.isFocused = function() {
                    return this.textInput.isFocused();
                }, x.prototype.blur = function() {
                    this.textInput.blur();
                }, x.prototype.onFocus = function(e) {
                    this.$isFocused || (this.$isFocused = !0, this.renderer.showCursor(), this.renderer.visualizeFocus(), this._emit("focus", e));
                }, x.prototype.onBlur = function(e) {
                    this.$isFocused && (this.$isFocused = !1, this.renderer.hideCursor(), this.renderer.visualizeBlur(), this._emit("blur", e));
                }, x.prototype.$cursorChange = function() {
                    this.renderer.updateCursor(), this.$highlightBrackets(), this.$updateHighlightActiveLine();
                }, x.prototype.onDocumentChange = function(e) {
                    var t = this.session.$useWrapMode, n = e.start.row == e.end.row ? e.end.row : 1 / 0;
                    this.renderer.updateLines(e.start.row, n, t), this._signal("change", e), this.$cursorChange();
                }, x.prototype.onTokenizerUpdate = function(e) {
                    e = e.data;
                    this.renderer.updateLines(e.first, e.last);
                }, x.prototype.onScrollTopChange = function() {
                    this.renderer.scrollToY(this.session.getScrollTop());
                }, x.prototype.onScrollLeftChange = function() {
                    this.renderer.scrollToX(this.session.getScrollLeft());
                }, x.prototype.onCursorChange = function() {
                    this.$cursorChange(), this._signal("changeSelection");
                }, x.prototype.$updateHighlightActiveLine = function() {
                    var e, t, n = this.getSession();
                    this.$highlightActiveLine && ("line" == this.$selectionStyle && this.selection.isMultiLine() || (e = this.getCursorPosition()), this.renderer.theme && this.renderer.theme.$selectionColorConflict && !this.selection.isEmpty() && (e = !1), !this.renderer.$maxLines || 1 !== this.session.getLength() || 1 < this.renderer.$minLines || (e = !1)), n.$highlightLineMarker && !e ? (n.removeMarker(n.$highlightLineMarker.id), n.$highlightLineMarker = null) : !n.$highlightLineMarker && e ? ((t = new f(e.row, e.column, e.row, 1 / 0)).id = n.addMarker(t, "ace_active-line", "screenLine"), n.$highlightLineMarker = t) : e && (n.$highlightLineMarker.start.row = e.row, n.$highlightLineMarker.end.row = e.row, n.$highlightLineMarker.start.column = e.column, n._signal("changeBackMarker"));
                }, x.prototype.onSelectionChange = function(e) {
                    var t, n, i = this.session, i = (i.$selectionMarker && i.removeMarker(i.$selectionMarker), i.$selectionMarker = null, this.selection.isEmpty() ? this.$updateHighlightActiveLine() : (t = this.selection.getRange(), n = this.getSelectionStyle(), i.$selectionMarker = i.addMarker(t, "ace_selection", n)), this.$highlightSelectedWord && this.$getSelectionHighLightRegexp());
                    this.session.highlight(i), this._signal("changeSelection");
                }, x.prototype.$getSelectionHighLightRegexp = function() {
                    var e = this.session, t = this.getSelectionRange();
                    if (!t.isEmpty() && !t.isMultiLine()) {
                        var n = t.start.column, i = t.end.column, e = e.getLine(t.start.row), t = e.substring(n, i);
                        if (!(5e3 < t.length) && /[\w\d]/.test(t)) {
                            t = this.$search.$assembleRegExp({
                                wholeWord: !0,
                                caseSensitive: !0,
                                needle: t
                            }), e = e.substring(n - 1, i + 1);
                            if (t.test(e)) return t;
                        }
                    }
                }, x.prototype.onChangeFrontMarker = function() {
                    this.renderer.updateFrontMarkers();
                }, x.prototype.onChangeBackMarker = function() {
                    this.renderer.updateBackMarkers();
                }, x.prototype.onChangeBreakpoint = function() {
                    this.renderer.updateBreakpoints();
                }, x.prototype.onChangeAnnotation = function() {
                    this.renderer.setAnnotations(this.session.getAnnotations());
                }, x.prototype.onChangeMode = function(e) {
                    this.renderer.updateText(), this._emit("changeMode", e);
                }, x.prototype.onChangeWrapLimit = function() {
                    this.renderer.updateFull();
                }, x.prototype.onChangeWrapMode = function() {
                    this.renderer.onResize(!0);
                }, x.prototype.onChangeFold = function() {
                    this.$updateHighlightActiveLine(), this.renderer.updateFull();
                }, x.prototype.getSelectedText = function() {
                    return this.session.getTextRange(this.getSelectionRange());
                }, x.prototype.getCopyText = function() {
                    var e = this.getSelectedText(), t = this.session.doc.getNewLineCharacter(), n = !1;
                    if (!e && this.$copyWithEmptySelection) for(var n = !0, i = this.selection.getAllRanges(), o = 0; o < i.length; o++){
                        var r = i[o];
                        o && i[o - 1].start.row == r.start.row || (e += this.session.getLine(r.start.row) + t);
                    }
                    var s = {
                        text: e
                    };
                    return this._signal("copy", s), w.lineMode = !!n && s.text, s.text;
                }, x.prototype.onCopy = function() {
                    this.commands.exec("copy", this);
                }, x.prototype.onCut = function() {
                    this.commands.exec("cut", this);
                }, x.prototype.onPaste = function(e, t) {
                    this.commands.exec("paste", this, {
                        text: e,
                        event: t
                    });
                }, x.prototype.$handlePaste = function(e) {
                    this._signal("paste", e = "string" == typeof e ? {
                        text: e
                    } : e);
                    var t = e.text, e = t === w.lineMode, n = this.session;
                    if (!this.inMultiSelectMode || this.inVirtualSelectionMode) e ? n.insert({
                        row: this.selection.lead.row,
                        column: 0
                    }, t) : this.insert(t);
                    else if (e) this.selection.rangeList.ranges.forEach(function(e) {
                        n.insert({
                            row: e.start.row,
                            column: 0
                        }, t);
                    });
                    else {
                        var i = t.split(/\r\n|\r|\n/), o = this.selection.rangeList.ranges, e = !(2 != i.length || i[0] && i[1]);
                        if (i.length != o.length || e) return this.commands.exec("insertstring", this, t);
                        for(var r = o.length; r--;){
                            var s = o[r];
                            s.isEmpty() || n.remove(s), n.insert(s.start, i[r]);
                        }
                    }
                }, x.prototype.execCommand = function(e, t) {
                    return this.commands.exec(e, this, t);
                }, x.prototype.insert = function(e, t) {
                    var n, i = this.session, o = i.getMode(), r = this.getCursorPosition(), s = (this.getBehavioursEnabled() && !t && (n = o.transformAction(i.getState(r.row), "insertion", this, i, e)) && (e === n.text || this.inVirtualSelectionMode || (this.session.mergeUndoDeltas = !1, this.mergeNextCommand = !1), e = n.text), "\t" == e && (e = this.session.getTabString()), this.selection.isEmpty() ? this.session.getOverwrite() && -1 == e.indexOf("\n") && ((s = new f.fromPoints(r, r)).end.column += e.length, this.session.remove(s)) : (s = this.getSelectionRange(), r = this.session.remove(s), this.clearSelection()), "\n" != e && "\r\n" != e || (a = i.getLine(r.row), r.column > a.search(/\S|$/) && (t = a.substr(r.column).search(/\S|$/), i.doc.removeInLine(r.row, r.column, r.column + t))), this.clearSelection(), r.column), t = i.getState(r.row), a = i.getLine(r.row), l = o.checkOutdent(t, a, e);
                    i.insert(r, e), n && n.selection && (2 == n.selection.length ? this.selection.setSelectionRange(new f(r.row, s + n.selection[0], r.row, s + n.selection[1])) : this.selection.setSelectionRange(new f(r.row + n.selection[0], n.selection[1], r.row + n.selection[2], n.selection[3]))), this.$enableAutoIndent && (i.getDocument().isNewLine(e) && (s = o.getNextLineIndent(t, a.slice(0, r.column), i.getTabString()), i.insert({
                        row: r.row + 1,
                        column: 0
                    }, s)), l) && o.autoOutdent(t, i, r.row);
                }, x.prototype.autoIndent = function() {
                    for(var e, t, n, i, o, r = this.session, s = r.getMode(), a = (n = this.selection.isEmpty() ? (t = 0, r.doc.getLength() - 1) : (t = (e = this.getSelectionRange()).start.row, e.end.row), ""), l = "", c = r.getTabString(), h = t; h <= n; h++)0 < h && (a = r.getState(h - 1), i = r.getLine(h - 1), l = s.getNextLineIndent(a, i, c)), i = r.getLine(h), l !== (o = s.$getIndent(i)) && (0 < o.length && (o = new f(h, 0, h, o.length), r.remove(o)), 0 < l.length) && r.insert({
                        row: h,
                        column: 0
                    }, l), s.autoOutdent(a, r, h);
                }, x.prototype.onTextInput = function(e, t) {
                    if (!t) return this.keyBinding.onTextInput(e);
                    this.startOperation({
                        command: {
                            name: "insertstring"
                        }
                    });
                    e = this.applyComposition.bind(this, e, t);
                    this.selection.rangeCount ? this.forEachSelection(e) : e(), this.endOperation();
                }, x.prototype.applyComposition = function(e, t) {
                    var n;
                    (t.extendLeft || t.extendRight) && ((n = this.selection.getRange()).start.column -= t.extendLeft, n.end.column += t.extendRight, n.start.column < 0 && (n.start.row--, n.start.column += this.session.getLine(n.start.row).length + 1), this.selection.setRange(n), e || n.isEmpty() || this.remove()), !e && this.selection.isEmpty() || this.insert(e, !0), (t.restoreStart || t.restoreEnd) && ((n = this.selection.getRange()).start.column -= t.restoreStart, n.end.column -= t.restoreEnd, this.selection.setRange(n));
                }, x.prototype.onCommandKey = function(e, t, n) {
                    return this.keyBinding.onCommandKey(e, t, n);
                }, x.prototype.setOverwrite = function(e) {
                    this.session.setOverwrite(e);
                }, x.prototype.getOverwrite = function() {
                    return this.session.getOverwrite();
                }, x.prototype.toggleOverwrite = function() {
                    this.session.toggleOverwrite();
                }, x.prototype.setScrollSpeed = function(e) {
                    this.setOption("scrollSpeed", e);
                }, x.prototype.getScrollSpeed = function() {
                    return this.getOption("scrollSpeed");
                }, x.prototype.setDragDelay = function(e) {
                    this.setOption("dragDelay", e);
                }, x.prototype.getDragDelay = function() {
                    return this.getOption("dragDelay");
                }, x.prototype.setSelectionStyle = function(e) {
                    this.setOption("selectionStyle", e);
                }, x.prototype.getSelectionStyle = function() {
                    return this.getOption("selectionStyle");
                }, x.prototype.setHighlightActiveLine = function(e) {
                    this.setOption("highlightActiveLine", e);
                }, x.prototype.getHighlightActiveLine = function() {
                    return this.getOption("highlightActiveLine");
                }, x.prototype.setHighlightGutterLine = function(e) {
                    this.setOption("highlightGutterLine", e);
                }, x.prototype.getHighlightGutterLine = function() {
                    return this.getOption("highlightGutterLine");
                }, x.prototype.setHighlightSelectedWord = function(e) {
                    this.setOption("highlightSelectedWord", e);
                }, x.prototype.getHighlightSelectedWord = function() {
                    return this.$highlightSelectedWord;
                }, x.prototype.setAnimatedScroll = function(e) {
                    this.renderer.setAnimatedScroll(e);
                }, x.prototype.getAnimatedScroll = function() {
                    return this.renderer.getAnimatedScroll();
                }, x.prototype.setShowInvisibles = function(e) {
                    this.renderer.setShowInvisibles(e);
                }, x.prototype.getShowInvisibles = function() {
                    return this.renderer.getShowInvisibles();
                }, x.prototype.setDisplayIndentGuides = function(e) {
                    this.renderer.setDisplayIndentGuides(e);
                }, x.prototype.getDisplayIndentGuides = function() {
                    return this.renderer.getDisplayIndentGuides();
                }, x.prototype.setHighlightIndentGuides = function(e) {
                    this.renderer.setHighlightIndentGuides(e);
                }, x.prototype.getHighlightIndentGuides = function() {
                    return this.renderer.getHighlightIndentGuides();
                }, x.prototype.setShowPrintMargin = function(e) {
                    this.renderer.setShowPrintMargin(e);
                }, x.prototype.getShowPrintMargin = function() {
                    return this.renderer.getShowPrintMargin();
                }, x.prototype.setPrintMarginColumn = function(e) {
                    this.renderer.setPrintMarginColumn(e);
                }, x.prototype.getPrintMarginColumn = function() {
                    return this.renderer.getPrintMarginColumn();
                }, x.prototype.setReadOnly = function(e) {
                    this.setOption("readOnly", e);
                }, x.prototype.getReadOnly = function() {
                    return this.getOption("readOnly");
                }, x.prototype.setBehavioursEnabled = function(e) {
                    this.setOption("behavioursEnabled", e);
                }, x.prototype.getBehavioursEnabled = function() {
                    return this.getOption("behavioursEnabled");
                }, x.prototype.setWrapBehavioursEnabled = function(e) {
                    this.setOption("wrapBehavioursEnabled", e);
                }, x.prototype.getWrapBehavioursEnabled = function() {
                    return this.getOption("wrapBehavioursEnabled");
                }, x.prototype.setShowFoldWidgets = function(e) {
                    this.setOption("showFoldWidgets", e);
                }, x.prototype.getShowFoldWidgets = function() {
                    return this.getOption("showFoldWidgets");
                }, x.prototype.setFadeFoldWidgets = function(e) {
                    this.setOption("fadeFoldWidgets", e);
                }, x.prototype.getFadeFoldWidgets = function() {
                    return this.getOption("fadeFoldWidgets");
                }, x.prototype.remove = function(e) {
                    this.selection.isEmpty() && ("left" == e ? this.selection.selectLeft() : this.selection.selectRight());
                    var t, n, i, e = this.getSelectionRange();
                    this.getBehavioursEnabled() && (n = (t = this.session).getState(e.start.row), n = t.getMode().transformAction(n, "deletion", this, t, e), 0 === e.end.column && "\n" == (i = t.getTextRange(e))[i.length - 1] && (i = t.getLine(e.end.row), /^\s+$/.test(i)) && (e.end.column = i.length), n) && (e = n), this.session.remove(e), this.clearSelection();
                }, x.prototype.removeWordRight = function() {
                    this.selection.isEmpty() && this.selection.selectWordRight(), this.session.remove(this.getSelectionRange()), this.clearSelection();
                }, x.prototype.removeWordLeft = function() {
                    this.selection.isEmpty() && this.selection.selectWordLeft(), this.session.remove(this.getSelectionRange()), this.clearSelection();
                }, x.prototype.removeToLineStart = function() {
                    this.selection.isEmpty() && this.selection.selectLineStart(), this.selection.isEmpty() && this.selection.selectLeft(), this.session.remove(this.getSelectionRange()), this.clearSelection();
                }, x.prototype.removeToLineEnd = function() {
                    this.selection.isEmpty() && this.selection.selectLineEnd();
                    var e = this.getSelectionRange();
                    e.start.column == e.end.column && e.start.row == e.end.row && (e.end.column = 0, e.end.row++), this.session.remove(e), this.clearSelection();
                }, x.prototype.splitLine = function() {
                    this.selection.isEmpty() || (this.session.remove(this.getSelectionRange()), this.clearSelection());
                    var e = this.getCursorPosition();
                    this.insert("\n"), this.moveCursorToPosition(e);
                }, x.prototype.setGhostText = function(e, t) {
                    this.session.widgetManager || (this.session.widgetManager = new I(this.session), this.session.widgetManager.attach(this)), this.renderer.setGhostText(e, t);
                }, x.prototype.removeGhostText = function() {
                    this.session.widgetManager && this.renderer.removeGhostText();
                }, x.prototype.transposeLetters = function() {
                    var e, t, n, i;
                    this.selection.isEmpty() && 0 !== (t = (e = this.getCursorPosition()).column) && (i = t < (i = this.session.getLine(e.row)).length ? (n = i.charAt(t) + i.charAt(t - 1), new f(e.row, t - 1, e.row, t + 1)) : (n = i.charAt(t - 1) + i.charAt(t - 2), new f(e.row, t - 2, e.row, t)), this.session.replace(i, n), this.session.selection.moveToPosition(i.end));
                }, x.prototype.toLowerCase = function() {
                    var e = this.getSelectionRange(), t = (this.selection.isEmpty() && this.selection.selectWord(), this.getSelectionRange()), n = this.session.getTextRange(t);
                    this.session.replace(t, n.toLowerCase()), this.selection.setSelectionRange(e);
                }, x.prototype.toUpperCase = function() {
                    var e = this.getSelectionRange(), t = (this.selection.isEmpty() && this.selection.selectWord(), this.getSelectionRange()), n = this.session.getTextRange(t);
                    this.session.replace(t, n.toUpperCase()), this.selection.setSelectionRange(e);
                }, x.prototype.indent = function() {
                    var e = this.session, t = this.getSelectionRange();
                    if (!(t.start.row < t.end.row)) {
                        if (t.start.column < t.end.column) {
                            var n, i = e.getTextRange(t);
                            if (!/^\s+$/.test(i)) return n = this.$getSelectedRows(), void e.indentRows(n.first, n.last, "\t");
                        }
                        var o = e.getLine(t.start.row), i = t.start, r = e.getTabSize(), i = e.documentToScreenColumn(i.row, i.column);
                        if (this.session.getUseSoftTabs()) var s = r - i % r, a = m.stringRepeat(" ", s);
                        else {
                            for(s = i % r; " " == o[t.start.column - 1] && s;)t.start.column--, s--;
                            this.selection.setSelectionRange(t), a = "\t";
                        }
                        return this.insert(a);
                    }
                    n = this.$getSelectedRows(), e.indentRows(n.first, n.last, "\t");
                }, x.prototype.blockIndent = function() {
                    var e = this.$getSelectedRows();
                    this.session.indentRows(e.first, e.last, "\t");
                }, x.prototype.blockOutdent = function() {
                    var e = this.session.getSelection();
                    this.session.outdentRows(e.getRange());
                }, x.prototype.sortLines = function() {
                    for(var e = this.$getSelectedRows(), t = this.session, n = [], i = e.first; i <= e.last; i++)n.push(t.getLine(i));
                    n.sort(function(e, t) {
                        return e.toLowerCase() < t.toLowerCase() ? -1 : e.toLowerCase() > t.toLowerCase() ? 1 : 0;
                    });
                    for(var o = new f(0, 0, 0, 0), i = e.first; i <= e.last; i++){
                        var r = t.getLine(i);
                        o.start.row = i, o.end.row = i, o.end.column = r.length, t.replace(o, n[i - e.first]);
                    }
                }, x.prototype.toggleCommentLines = function() {
                    var e = this.session.getState(this.getCursorPosition().row), t = this.$getSelectedRows();
                    this.session.getMode().toggleCommentLines(e, this.session, t.first, t.last);
                }, x.prototype.toggleBlockComment = function() {
                    var e = this.getCursorPosition(), t = this.session.getState(e.row), n = this.getSelectionRange();
                    this.session.getMode().toggleBlockComment(t, this.session, n, e);
                }, x.prototype.getNumberAt = function(e, t) {
                    for(var n = /[\-]?[0-9]+(?:\.[0-9]+)?/g, i = (n.lastIndex = 0, this.session.getLine(e)); n.lastIndex < t;){
                        var o = n.exec(i);
                        if (o.index <= t && o.index + o[0].length >= t) return {
                            value: o[0],
                            start: o.index,
                            end: o.index + o[0].length
                        };
                    }
                    return null;
                }, x.prototype.modifyNumber = function(e) {
                    var t, n, i, o = this.selection.getCursor().row, r = this.selection.getCursor().column, s = new f(o, r - 1, o, r), s = this.session.getTextRange(s);
                    !isNaN(parseFloat(s)) && isFinite(s) ? (s = this.getNumberAt(o, r)) && (i = 0 <= s.value.indexOf(".") ? s.start + s.value.indexOf(".") + 1 : s.end, t = s.start + s.value.length - i, n = parseFloat(s.value), n *= Math.pow(10, t), i !== s.end && r < i ? e *= Math.pow(10, s.end - r - 1) : e *= Math.pow(10, s.end - r), i = (n = (n += e) / Math.pow(10, t)).toFixed(t), e = new f(o, s.start, o, s.end), this.session.replace(e, i), this.moveCursorTo(o, Math.max(s.start + 1, r + i.length - s.value.length))) : this.toggleWord();
                }, x.prototype.toggleWord = function() {
                    for(var n, i = this.selection.getCursor().row, e = this.selection.getCursor().column, o = (this.selection.selectWord(), this.getSelectedText()), r = this.selection.getWordRange().start.column, t = o.replace(/([a-z]+|[A-Z]+)(?=[A-Z_]|$)/g, "$1 ").split(/\s/), s = e - r - 1, a = (s < 0 && (s = 0), 0), l = this, c = (o.match(/[A-Za-z0-9_]+/) && t.forEach(function(e, t) {
                        n = a + e.length, a <= s && s <= n && (o = e, l.selection.clearSelection(), l.moveCursorTo(i, a + r), l.selection.selectTo(i, n + r)), a = n;
                    }), this.$toggleWordPairs), h = 0; h < c.length; h++)for(var d = c[h], u = 0; u <= 1; u++){
                        var g = +!u, p = o.match(new RegExp("^\\s?_?(" + m.escapeRegExp(d[u]) + ")\\s?$", "i"));
                        p && o.match(new RegExp("([_]|^|\\s)(" + m.escapeRegExp(p[1]) + ")($|\\s)", "g")) && (p = o.replace(new RegExp(m.escapeRegExp(d[u]), "i"), function(e) {
                            var t = d[g];
                            return e.toUpperCase() == e ? t = t.toUpperCase() : e.charAt(0).toUpperCase() == e.charAt(0) && (t = t.substr(0, 0) + d[g].charAt(0).toUpperCase() + t.substr(1)), t;
                        }), this.insert(p));
                    }
                }, x.prototype.findLinkAt = function(e, t) {
                    var n, i, o, e = this.session.getLine(e).split(/((?:https?|ftp):\/\/[\S]+)/), r = t, s = (r < 0 && (r = 0), 0);
                    try {
                        for(var a = d(e), l = a.next(); !l.done; l = a.next()){
                            var c = l.value, h = s + c.length;
                            if (s <= r && r <= h && c.match(/((?:https?|ftp):\/\/[\S]+)/)) {
                                o = c.replace(/[\s:.,'";}\]]+$/, "");
                                break;
                            }
                            s = h;
                        }
                    } catch (e) {
                        n = {
                            error: e
                        };
                    } finally{
                        try {
                            l && !l.done && (i = a.return) && i.call(a);
                        } finally{
                            if (n) throw n.error;
                        }
                    }
                    return o;
                }, x.prototype.openLink = function() {
                    var e = this.selection.getCursor(), e = this.findLinkAt(e.row, e.column);
                    return e && window.open(e, "_blank"), null != e;
                }, x.prototype.removeLines = function() {
                    var e = this.$getSelectedRows();
                    this.session.removeFullLines(e.first, e.last), this.clearSelection();
                }, x.prototype.duplicateSelection = function() {
                    var e, t = this.selection, n = this.session, i = t.getRange(), o = t.isBackwards();
                    i.isEmpty() ? (e = i.start.row, n.duplicateLines(e, e)) : (e = o ? i.start : i.end, n = n.insert(e, n.getTextRange(i), !1), i.start = e, i.end = n, t.setSelectionRange(i, o));
                }, x.prototype.moveLinesDown = function() {
                    this.$moveLines(1, !1);
                }, x.prototype.moveLinesUp = function() {
                    this.$moveLines(-1, !1);
                }, x.prototype.moveText = function(e, t, n) {
                    return this.session.moveText(e, t, n);
                }, x.prototype.copyLinesUp = function() {
                    this.$moveLines(-1, !0);
                }, x.prototype.copyLinesDown = function() {
                    this.$moveLines(1, !0);
                }, x.prototype.$moveLines = function(e, t) {
                    var n = this.selection;
                    if (!n.inMultiSelectMode || this.inVirtualSelectionMode) {
                        var i = n.toOrientedRange(), o = this.$getSelectedRows(i), r = this.session.$moveLines(o.first, o.last, t ? 0 : e);
                        i.moveBy(r = t && -1 == e ? 0 : r, 0), n.fromOrientedRange(i);
                    } else {
                        for(var s = n.rangeList.ranges, a = (n.rangeList.detach(this.session), this.inVirtualSelectionMode = !0, 0), l = 0, c = s.length, h = 0; h < c; h++){
                            for(var d = h, u = (s[h].moveBy(a, 0), (o = this.$getSelectedRows(s[h])).first), g = o.last; ++h < c;){
                                l && s[h].moveBy(l, 0);
                                var p = this.$getSelectedRows(s[h]);
                                if (t && p.first != g) break;
                                if (!t && p.first > g + 1) break;
                                g = p.last;
                            }
                            for(h--, a = this.session.$moveLines(u, g, t ? 0 : e), t && -1 == e && (d = h + 1); d <= h;)s[d].moveBy(a, 0), d++;
                            l += a = t ? a : 0;
                        }
                        n.fromOrientedRange(n.ranges[0]), n.rangeList.attach(this.session), this.inVirtualSelectionMode = !1;
                    }
                }, x.prototype.$getSelectedRows = function(e) {
                    return e = (e || this.getSelectionRange()).collapseRows(), {
                        first: this.session.getRowFoldStart(e.start.row),
                        last: this.session.getRowFoldEnd(e.end.row)
                    };
                }, x.prototype.onCompositionStart = function(e) {
                    this.renderer.showComposition(e);
                }, x.prototype.onCompositionUpdate = function(e) {
                    this.renderer.setCompositionText(e);
                }, x.prototype.onCompositionEnd = function() {
                    this.renderer.hideComposition();
                }, x.prototype.getFirstVisibleRow = function() {
                    return this.renderer.getFirstVisibleRow();
                }, x.prototype.getLastVisibleRow = function() {
                    return this.renderer.getLastVisibleRow();
                }, x.prototype.isRowVisible = function(e) {
                    return e >= this.getFirstVisibleRow() && e <= this.getLastVisibleRow();
                }, x.prototype.isRowFullyVisible = function(e) {
                    return e >= this.renderer.getFirstFullyVisibleRow() && e <= this.renderer.getLastFullyVisibleRow();
                }, x.prototype.$getVisibleRowCount = function() {
                    return this.renderer.getScrollBottomRow() - this.renderer.getScrollTopRow() + 1;
                }, x.prototype.$moveByPage = function(e, t) {
                    var n = this.renderer, i = this.renderer.layerConfig, o = e * Math.floor(i.height / i.lineHeight), e = (!0 === t ? this.selection.$moveSelection(function() {
                        this.moveCursorBy(o, 0);
                    }) : !1 === t && (this.selection.moveCursorBy(o, 0), this.selection.clearSelection()), n.scrollTop);
                    n.scrollBy(0, o * i.lineHeight), null != t && n.scrollCursorIntoView(null, .5), n.animateScrolling(e);
                }, x.prototype.selectPageDown = function() {
                    this.$moveByPage(1, !0);
                }, x.prototype.selectPageUp = function() {
                    this.$moveByPage(-1, !0);
                }, x.prototype.gotoPageDown = function() {
                    this.$moveByPage(1, !1);
                }, x.prototype.gotoPageUp = function() {
                    this.$moveByPage(-1, !1);
                }, x.prototype.scrollPageDown = function() {
                    this.$moveByPage(1);
                }, x.prototype.scrollPageUp = function() {
                    this.$moveByPage(-1);
                }, x.prototype.scrollToRow = function(e) {
                    this.renderer.scrollToRow(e);
                }, x.prototype.scrollToLine = function(e, t, n, i) {
                    this.renderer.scrollToLine(e, t, n, i);
                }, x.prototype.centerSelection = function() {
                    var e = this.getSelectionRange(), e = {
                        row: Math.floor(e.start.row + (e.end.row - e.start.row) / 2),
                        column: Math.floor(e.start.column + (e.end.column - e.start.column) / 2)
                    };
                    this.renderer.alignCursor(e, .5);
                }, x.prototype.getCursorPosition = function() {
                    return this.selection.getCursor();
                }, x.prototype.getCursorPositionScreen = function() {
                    return this.session.documentToScreenPosition(this.getCursorPosition());
                }, x.prototype.getSelectionRange = function() {
                    return this.selection.getRange();
                }, x.prototype.selectAll = function() {
                    this.selection.selectAll();
                }, x.prototype.clearSelection = function() {
                    this.selection.clearSelection();
                }, x.prototype.moveCursorTo = function(e, t) {
                    this.selection.moveCursorTo(e, t);
                }, x.prototype.moveCursorToPosition = function(e) {
                    this.selection.moveCursorToPosition(e);
                }, x.prototype.jumpToMatching = function(e, t) {
                    var n = this.getCursorPosition(), i = new v(this.session, n.row, n.column), o = i.getCurrentToken(), r = 0, s = (o = o && -1 !== o.type.indexOf("tag-name") ? i.stepBackward() : o) || i.stepForward();
                    if (s) {
                        var a, l, c = !1, h = {}, d = n.column - s.start, u = {
                            ")": "(",
                            "(": "(",
                            "]": "[",
                            "[": "[",
                            "{": "{",
                            "}": "{"
                        };
                        do if (s.value.match(/[{}()\[\]]/g)) {
                            for(; d < s.value.length && !c; d++)if (u[s.value[d]]) switch(l = u[s.value[d]] + "." + s.type.replace("rparen", "lparen"), isNaN(h[l]) && (h[l] = 0), s.value[d]){
                                case "(":
                                case "[":
                                case "{":
                                    h[l]++;
                                    break;
                                case ")":
                                case "]":
                                case "}":
                                    h[l]--, -1 === h[l] && (a = "bracket", c = !0);
                            }
                        } else -1 !== s.type.indexOf("tag-name") && (isNaN(h[s.value]) && (h[s.value] = 0), "<" === o.value && 1 < r ? h[s.value]++ : "</" === o.value && h[s.value]--, -1 === h[s.value]) && (a = "tag", c = !0);
                        while (c || (o = s, r++, s = i.stepForward(), d = 0), s && !c);
                        if (a) {
                            if ("bracket" === a) !(p = this.session.getBracketRange(n)) && (m = (p = new f(i.getCurrentTokenRow(), i.getCurrentTokenColumn() + d - 1, i.getCurrentTokenRow(), i.getCurrentTokenColumn() + d - 1)).start, t || m.row === n.row && Math.abs(m.column - n.column) < 2) && (p = this.session.getBracketRange(m));
                            else if ("tag" === a) {
                                if (!s || -1 === s.type.indexOf("tag-name")) return;
                                var g, p, m = (m = 0 === (p = new f(i.getCurrentTokenRow(), i.getCurrentTokenColumn() - 2, i.getCurrentTokenRow(), i.getCurrentTokenColumn() - 2)).compare(n.row, n.column) && (g = this.session.getMatchingTags(n)) ? g.openTag.contains(n.row, n.column) ? (p = g.closeTag).start : (p = g.openTag, g.closeTag.start.row === n.row && g.closeTag.start.column === n.column ? p.end : p.start) : m) || p.start;
                            }
                            (m = p && p.cursor || m) && (e ? p && t ? this.selection.setRange(p) : p && p.isEqual(this.getSelectionRange()) ? this.clearSelection() : this.selection.selectTo(m.row, m.column) : this.selection.moveTo(m.row, m.column));
                        }
                    }
                }, x.prototype.gotoLine = function(e, t, n) {
                    this.selection.clearSelection(), this.session.unfold({
                        row: e - 1,
                        column: t || 0
                    }), this.exitMultiSelectMode && this.exitMultiSelectMode(), this.moveCursorTo(e - 1, t || 0), this.isRowFullyVisible(e - 1) || this.scrollToLine(e - 1, !0, n);
                }, x.prototype.navigateTo = function(e, t) {
                    this.selection.moveTo(e, t);
                }, x.prototype.navigateUp = function(e) {
                    var t;
                    if (this.selection.isMultiLine() && !this.selection.isBackwards()) return t = this.selection.anchor.getPosition(), this.moveCursorToPosition(t);
                    this.selection.clearSelection(), this.selection.moveCursorBy(-e || -1, 0);
                }, x.prototype.navigateDown = function(e) {
                    var t;
                    if (this.selection.isMultiLine() && this.selection.isBackwards()) return t = this.selection.anchor.getPosition(), this.moveCursorToPosition(t);
                    this.selection.clearSelection(), this.selection.moveCursorBy(e || 1, 0);
                }, x.prototype.navigateLeft = function(e) {
                    if (this.selection.isEmpty()) for(e = e || 1; e--;)this.selection.moveCursorLeft();
                    else {
                        var t = this.getSelectionRange().start;
                        this.moveCursorToPosition(t);
                    }
                    this.clearSelection();
                }, x.prototype.navigateRight = function(e) {
                    if (this.selection.isEmpty()) for(e = e || 1; e--;)this.selection.moveCursorRight();
                    else {
                        var t = this.getSelectionRange().end;
                        this.moveCursorToPosition(t);
                    }
                    this.clearSelection();
                }, x.prototype.navigateLineStart = function() {
                    this.selection.moveCursorLineStart(), this.clearSelection();
                }, x.prototype.navigateLineEnd = function() {
                    this.selection.moveCursorLineEnd(), this.clearSelection();
                }, x.prototype.navigateFileEnd = function() {
                    this.selection.moveCursorFileEnd(), this.clearSelection();
                }, x.prototype.navigateFileStart = function() {
                    this.selection.moveCursorFileStart(), this.clearSelection();
                }, x.prototype.navigateWordRight = function() {
                    this.selection.moveCursorWordRight(), this.clearSelection();
                }, x.prototype.navigateWordLeft = function() {
                    this.selection.moveCursorWordLeft(), this.clearSelection();
                }, x.prototype.replace = function(e, t) {
                    t && this.$search.set(t);
                    var t = this.$search.find(this.session), n = 0;
                    return t && (this.$tryReplace(t, e) && (n = 1), this.selection.setSelectionRange(t), this.renderer.scrollSelectionIntoView(t.start, t.end)), n;
                }, x.prototype.replaceAll = function(e, t) {
                    t && this.$search.set(t);
                    var n = this.$search.findAll(this.session), i = 0;
                    if (n.length) {
                        t = this.getSelectionRange();
                        this.selection.moveTo(0, 0);
                        for(var o = n.length - 1; 0 <= o; --o)this.$tryReplace(n[o], e) && i++;
                        this.selection.setSelectionRange(t);
                    }
                    return i;
                }, x.prototype.$tryReplace = function(e, t) {
                    var n = this.session.getTextRange(e);
                    return null !== (t = this.$search.replace(n, t)) ? (e.end = this.session.replace(e, t), e) : null;
                }, x.prototype.getLastSearchOptions = function() {
                    return this.$search.getOptions();
                }, x.prototype.find = function(e, t, n) {
                    t = t || {}, "string" == typeof e || e instanceof RegExp ? t.needle = e : "object" == typeof e && o.mixin(t, e);
                    var i = this.selection.getRange(), e = (null == t.needle && ((e = this.session.getTextRange(i) || this.$search.$options.needle) || (i = this.session.getWordRange(i.start.row, i.start.column), e = this.session.getTextRange(i)), this.$search.set({
                        needle: e
                    })), this.$search.set(t), t.start || this.$search.set({
                        start: i
                    }), this.$search.find(this.session));
                    return t.preventScroll ? e : e ? (this.revealRange(e, n), e) : (t.backwards ? i.start = i.end : i.end = i.start, void this.selection.setRange(i));
                }, x.prototype.findNext = function(e, t) {
                    this.find({
                        skipCurrent: !0,
                        backwards: !1
                    }, e, t);
                }, x.prototype.findPrevious = function(e, t) {
                    this.find(e, {
                        skipCurrent: !0,
                        backwards: !0
                    }, t);
                }, x.prototype.revealRange = function(e, t) {
                    this.session.unfold(e), this.selection.setSelectionRange(e);
                    var n = this.renderer.scrollTop;
                    this.renderer.scrollSelectionIntoView(e.start, e.end, .5), !1 !== t && this.renderer.animateScrolling(n);
                }, x.prototype.undo = function() {
                    this.session.getUndoManager().undo(this.session), this.renderer.scrollCursorIntoView(null, .5);
                }, x.prototype.redo = function() {
                    this.session.getUndoManager().redo(this.session), this.renderer.scrollCursorIntoView(null, .5);
                }, x.prototype.destroy = function() {
                    this.$toDestroy && (this.$toDestroy.forEach(function(e) {
                        e.destroy();
                    }), this.$toDestroy = null), this.$mouseHandler && this.$mouseHandler.destroy(), this.renderer.destroy(), this._signal("destroy", this), this.session && this.session.destroy(), this._$emitInputEvent && this._$emitInputEvent.cancel(), this.removeAllListeners();
                }, x.prototype.setAutoScrollEditorIntoView = function(e) {
                    var i, o, r, s, t, n, a;
                    e && (r = !1, (o = this).$scrollAnchor || (this.$scrollAnchor = document.createElement("div")), (s = this.$scrollAnchor).style.cssText = "position:absolute", this.container.insertBefore(s, this.container.firstChild), t = this.on("changeSelection", function() {
                        r = !0;
                    }), n = this.renderer.on("beforeRender", function() {
                        r && (i = o.renderer.container.getBoundingClientRect());
                    }), a = this.renderer.on("afterRender", function() {
                        var e, t, n;
                        r && i && (o.isFocused() || o.searchBox && o.searchBox.isFocused()) && (e = (t = o.renderer).$cursorLayer.$pixelPos, t = t.layerConfig, n = e.top - t.offset, null != (r = 0 <= e.top && n + i.top < 0 || !(e.top < t.height && e.top + i.top + t.lineHeight > window.innerHeight) && null) && (s.style.top = n + "px", s.style.left = e.left + "px", s.style.height = t.lineHeight + "px", s.scrollIntoView(r)), r = i = null);
                    }), this.setAutoScrollEditorIntoView = function(e) {
                        e || (delete this.setAutoScrollEditorIntoView, this.off("changeSelection", t), this.renderer.off("afterRender", a), this.renderer.off("beforeRender", n));
                    });
                }, x.prototype.$resetCursorStyle = function() {
                    var e = this.$cursorStyle || "ace", t = this.renderer.$cursorLayer;
                    t && (t.setSmoothBlinking(/smooth/.test(e)), t.isBlinking = !this.$readOnly && "wide" != e, i.setCssClass(t.element, "ace_slim-cursors", /slim/.test(e)));
                }, x.prototype.prompt = function(t, n, i) {
                    var o = this;
                    y.loadModule("ace/ext/prompt", function(e) {
                        e.prompt(o, t, n, i);
                    });
                }, x);
                function x(e, t, n) {
                    this.$toDestroy = [];
                    var i = e.getContainerElement();
                    this.container = i, this.renderer = e, this.id = "editor" + ++x.$uid, this.commands = new p(r.isMac ? "mac" : "win", C), "object" == typeof document && (this.textInput = new s(e.getTextAreaContainer(), this), this.renderer.textarea = this.textInput.getElement(), this.$mouseHandler = new a(this), new l(this)), this.keyBinding = new c(this), this.$search = (new u).set({
                        wrap: !0
                    }), this.$historyTracker = this.$historyTracker.bind(this), this.commands.on("exec", this.$historyTracker), this.$initOperationListeners(), this._$emitInputEvent = m.delayedCall((function() {
                        this._signal("input", {}), this.session && !this.session.destroyed && this.session.bgTokenizer.scheduleStart();
                    }).bind(this)), this.on("change", function(e, t) {
                        t._$emitInputEvent.schedule(31);
                    }), this.setSession(t || n && n.session || new h("")), y.resetOptions(this), n && this.setOptions(n), y._signal("editor", this);
                }
                e.$uid = 0, e.prototype.curOp = null, e.prototype.prevOp = {}, e.prototype.$mergeableCommands = [
                    "backspace",
                    "del",
                    "insertstring"
                ], e.prototype.$toggleWordPairs = [
                    [
                        "first",
                        "last"
                    ],
                    [
                        "true",
                        "false"
                    ],
                    [
                        "yes",
                        "no"
                    ],
                    [
                        "width",
                        "height"
                    ],
                    [
                        "top",
                        "bottom"
                    ],
                    [
                        "right",
                        "left"
                    ],
                    [
                        "on",
                        "off"
                    ],
                    [
                        "x",
                        "y"
                    ],
                    [
                        "get",
                        "set"
                    ],
                    [
                        "max",
                        "min"
                    ],
                    [
                        "horizontal",
                        "vertical"
                    ],
                    [
                        "show",
                        "hide"
                    ],
                    [
                        "add",
                        "remove"
                    ],
                    [
                        "up",
                        "down"
                    ],
                    [
                        "before",
                        "after"
                    ],
                    [
                        "even",
                        "odd"
                    ],
                    [
                        "in",
                        "out"
                    ],
                    [
                        "inside",
                        "outside"
                    ],
                    [
                        "next",
                        "previous"
                    ],
                    [
                        "increase",
                        "decrease"
                    ],
                    [
                        "attach",
                        "detach"
                    ],
                    [
                        "&&",
                        "||"
                    ],
                    [
                        "==",
                        "!="
                    ]
                ], o.implement(e.prototype, g), y.defineOptions(e.prototype, "editor", {
                    selectionStyle: {
                        set: function(e) {
                            this.onSelectionChange(), this._signal("changeSelectionStyle", {
                                data: e
                            });
                        },
                        initialValue: "line"
                    },
                    highlightActiveLine: {
                        set: function() {
                            this.$updateHighlightActiveLine();
                        },
                        initialValue: !0
                    },
                    highlightSelectedWord: {
                        set: function(e) {
                            this.$onSelectionChange();
                        },
                        initialValue: !0
                    },
                    readOnly: {
                        set: function(e) {
                            this.textInput.setReadOnly(e), this.$resetCursorStyle();
                        },
                        initialValue: !1
                    },
                    copyWithEmptySelection: {
                        set: function(e) {
                            this.textInput.setCopyWithEmptySelection(e);
                        },
                        initialValue: !1
                    },
                    cursorStyle: {
                        set: function(e) {
                            this.$resetCursorStyle();
                        },
                        values: [
                            "ace",
                            "slim",
                            "smooth",
                            "wide"
                        ],
                        initialValue: "ace"
                    },
                    mergeUndoDeltas: {
                        values: [
                            !1,
                            !0,
                            "always"
                        ],
                        initialValue: !0
                    },
                    behavioursEnabled: {
                        initialValue: !0
                    },
                    wrapBehavioursEnabled: {
                        initialValue: !0
                    },
                    enableAutoIndent: {
                        initialValue: !0
                    },
                    autoScrollEditorIntoView: {
                        set: function(e) {
                            this.setAutoScrollEditorIntoView(e);
                        }
                    },
                    keyboardHandler: {
                        set: function(e) {
                            this.setKeyboardHandler(e);
                        },
                        get: function() {
                            return this.$keybindingId;
                        },
                        handlesSet: !0
                    },
                    value: {
                        set: function(e) {
                            this.session.setValue(e);
                        },
                        get: function() {
                            return this.getValue();
                        },
                        handlesSet: !0,
                        hidden: !0
                    },
                    session: {
                        set: function(e) {
                            this.setSession(e);
                        },
                        get: function() {
                            return this.session;
                        },
                        handlesSet: !0,
                        hidden: !0
                    },
                    showLineNumbers: {
                        set: function(e) {
                            this.renderer.$gutterLayer.setShowLineNumbers(e), this.renderer.$loop.schedule(this.renderer.CHANGE_GUTTER), e && this.$relativeLineNumbers ? k.attach(this) : k.detach(this);
                        },
                        initialValue: !0
                    },
                    relativeLineNumbers: {
                        set: function(e) {
                            this.$showLineNumbers && e ? k.attach(this) : k.detach(this);
                        }
                    },
                    placeholder: {
                        set: function(e) {
                            this.$updatePlaceholder || (this.$updatePlaceholder = (function() {
                                var e = this.session && (this.renderer.$composition || this.getValue());
                                e && this.renderer.placeholderNode ? (this.renderer.off("afterRender", this.$updatePlaceholder), i.removeCssClass(this.container, "ace_hasPlaceholder"), this.renderer.placeholderNode.remove(), this.renderer.placeholderNode = null) : e || this.renderer.placeholderNode ? !e && this.renderer.placeholderNode && (this.renderer.placeholderNode.textContent = this.$placeholder || "") : (this.renderer.on("afterRender", this.$updatePlaceholder), i.addCssClass(this.container, "ace_hasPlaceholder"), (e = i.createElement("div")).className = "ace_placeholder", e.textContent = this.$placeholder || "", this.renderer.placeholderNode = e, this.renderer.content.appendChild(this.renderer.placeholderNode));
                            }).bind(this), this.on("input", this.$updatePlaceholder)), this.$updatePlaceholder();
                        }
                    },
                    enableKeyboardAccessibility: {
                        set: function(e) {
                            function t(e) {
                                e.target == this.renderer.scroller && e.keyCode === S.enter && (e.preventDefault(), e = this.getCursorPosition().row, this.isRowVisible(e) || this.scrollToLine(e, !0, !0), this.focus());
                            }
                            var n, i = {
                                name: "blurTextInput",
                                description: "Set focus to the editor content div to allow tabbing through the page",
                                bindKey: "Esc",
                                exec: function(e) {
                                    e.blur(), e.renderer.scroller.focus();
                                },
                                readOnly: !0
                            };
                            e ? (this.renderer.enableKeyboardAccessibility = !0, this.renderer.keyboardFocusClassName = "ace_keyboard-focus", this.textInput.getElement().setAttribute("tabindex", -1), this.renderer.scroller.setAttribute("tabindex", 0), this.renderer.scroller.setAttribute("role", "group"), this.renderer.scroller.setAttribute("aria-roledescription", A("editor")), this.renderer.scroller.classList.add(this.renderer.keyboardFocusClassName), this.renderer.scroller.setAttribute("aria-label", A("Editor content, press Enter to start editing, press Escape to exit")), this.renderer.scroller.addEventListener("keyup", t.bind(this)), this.commands.addCommand(i), this.renderer.$gutter.setAttribute("tabindex", 0), this.renderer.$gutter.setAttribute("aria-hidden", !1), this.renderer.$gutter.setAttribute("role", "group"), this.renderer.$gutter.setAttribute("aria-roledescription", A("editor")), this.renderer.$gutter.setAttribute("aria-label", A("Editor gutter, press Enter to interact with controls using arrow keys, press Escape to exit")), this.renderer.$gutter.classList.add(this.renderer.keyboardFocusClassName), this.renderer.content.setAttribute("aria-hidden", !0), (n = n || new b(this)).addListener()) : (this.renderer.enableKeyboardAccessibility = !1, this.textInput.getElement().setAttribute("tabindex", 0), this.renderer.scroller.setAttribute("tabindex", -1), this.renderer.scroller.removeAttribute("role"), this.renderer.scroller.removeAttribute("aria-roledescription"), this.renderer.scroller.classList.remove(this.renderer.keyboardFocusClassName), this.renderer.scroller.removeAttribute("aria-label"), this.renderer.scroller.removeEventListener("keyup", t.bind(this)), this.commands.removeCommand(i), this.renderer.content.removeAttribute("aria-hidden"), this.renderer.$gutter.setAttribute("tabindex", -1), this.renderer.$gutter.setAttribute("aria-hidden", !0), this.renderer.$gutter.removeAttribute("role"), this.renderer.$gutter.removeAttribute("aria-roledescription"), this.renderer.$gutter.removeAttribute("aria-label"), this.renderer.$gutter.classList.remove(this.renderer.keyboardFocusClassName), n && n.removeListener());
                        },
                        initialValue: !1
                    },
                    customScrollbar: "renderer",
                    hScrollBarAlwaysVisible: "renderer",
                    vScrollBarAlwaysVisible: "renderer",
                    highlightGutterLine: "renderer",
                    animatedScroll: "renderer",
                    showInvisibles: "renderer",
                    showPrintMargin: "renderer",
                    printMarginColumn: "renderer",
                    printMargin: "renderer",
                    fadeFoldWidgets: "renderer",
                    showFoldWidgets: "renderer",
                    displayIndentGuides: "renderer",
                    highlightIndentGuides: "renderer",
                    showGutter: "renderer",
                    fontSize: "renderer",
                    fontFamily: "renderer",
                    maxLines: "renderer",
                    minLines: "renderer",
                    scrollPastEnd: "renderer",
                    fixedWidthGutter: "renderer",
                    theme: "renderer",
                    hasCssTransforms: "renderer",
                    maxPixelHeight: "renderer",
                    useTextareaForIME: "renderer",
                    useResizeObserver: "renderer",
                    useSvgGutterIcons: "renderer",
                    showFoldedAnnotations: "renderer",
                    scrollSpeed: "$mouseHandler",
                    dragDelay: "$mouseHandler",
                    dragEnabled: "$mouseHandler",
                    focusTimeout: "$mouseHandler",
                    tooltipFollowsMouse: "$mouseHandler",
                    firstLineNumber: "session",
                    overwrite: "session",
                    newLineMode: "session",
                    useWorker: "session",
                    useSoftTabs: "session",
                    navigateWithinSoftTabs: "session",
                    tabSize: "session",
                    wrap: "session",
                    indentedSoftWrap: "session",
                    foldStyle: "session",
                    mode: "session"
                });
                var k = {
                    getText: function(e, t) {
                        return (Math.abs(e.selection.lead.row - t) || t + 1 + (t < 9 ? "\xb7" : "")) + "";
                    },
                    getWidth: function(e, t, n) {
                        return Math.max(t.toString().length, (n.lastRow + 1).toString().length, 2) * n.characterWidth;
                    },
                    update: function(e, t) {
                        t.renderer.$loop.schedule(t.renderer.CHANGE_GUTTER);
                    },
                    attach: function(e) {
                        e.renderer.$gutterLayer.$renderer = this, e.on("changeSelection", this.update), this.update(null, e);
                    },
                    detach: function(e) {
                        e.renderer.$gutterLayer.$renderer == this && (e.renderer.$gutterLayer.$renderer = null), e.off("changeSelection", this.update), this.update(null, e);
                    }
                };
                t.Editor = e;
            }), ace.define("ace/undomanager", [
                "require",
                "exports",
                "module",
                "ace/range"
            ], function(e, t, n) {
                "use strict";
                o.prototype.addSession = function(e) {
                    this.$session = e;
                }, o.prototype.add = function(e, t, n) {
                    this.$fromUndo || e != this.$lastDelta && (this.$keepRedoStack || (this.$redoStack.length = 0), !1 !== t && this.lastDeltas || (this.lastDeltas = [], (t = this.$undoStack.length) > this.$undoDepth - 1 && this.$undoStack.splice(0, t - this.$undoDepth + 1), this.$undoStack.push(this.lastDeltas), e.id = this.$rev = ++this.$maxRev), "remove" != e.action && "insert" != e.action || (this.$lastDelta = e), this.lastDeltas.push(e));
                }, o.prototype.addSelection = function(e, t) {
                    this.selections.push({
                        value: e,
                        rev: t || this.$rev
                    });
                }, o.prototype.startNewGroup = function() {
                    return this.lastDeltas = null, this.$rev;
                }, o.prototype.markIgnored = function(e, t) {
                    null == t && (t = this.$rev + 1);
                    for(var n = this.$undoStack, i = n.length; i--;){
                        var o = n[i][0];
                        if (o.id <= e) break;
                        o.id < t && (o.ignore = !0);
                    }
                    this.lastDeltas = null;
                }, o.prototype.getSelection = function(e, t) {
                    for(var n = this.selections, i = n.length; i--;){
                        var o = n[i];
                        if (o.rev < e) return o = t ? n[i + 1] : o;
                    }
                }, o.prototype.getRevision = function() {
                    return this.$rev;
                }, o.prototype.getDeltas = function(e, t) {
                    null == t && (t = this.$rev + 1);
                    for(var n = this.$undoStack, i = null, o = 0, r = n.length; r--;){
                        var s = n[r][0];
                        if (s.id < t && !i && (i = r + 1), s.id <= e) {
                            o = r + 1;
                            break;
                        }
                    }
                    return n.slice(o, i);
                }, o.prototype.getChangedRanges = function(e, t) {
                    null == t && this.$rev;
                }, o.prototype.getChangedLines = function(e, t) {
                    null == t && this.$rev;
                }, o.prototype.undo = function(e, t) {
                    this.lastDeltas = null;
                    var n, i = this.$undoStack;
                    if (function(e, t) {
                        for(var n = t; n--;){
                            var i = e[n];
                            if (i && !i[0].ignore) {
                                for(; n < t - 1;){
                                    var o = function(e, t) {
                                        for(var n = e.length; n--;)for(var i = 0; i < t.length; i++)if (!a(e[n], t[i])) {
                                            for(; n < e.length;){
                                                for(; i--;)a(t[i], e[n]);
                                                i = t.length, n++;
                                            }
                                            return [
                                                e,
                                                t
                                            ];
                                        }
                                        return e.selectionBefore = t.selectionBefore = e.selectionAfter = t.selectionAfter = null, [
                                            t,
                                            e
                                        ];
                                    }(e[n], e[n + 1]);
                                    e[n] = o[0], e[n + 1] = o[1], n++;
                                }
                                return 1;
                            }
                        }
                    }(i, i.length)) return e = e || this.$session, this.$redoStackBaseRev !== this.$rev && this.$redoStack.length && (this.$redoStack = []), this.$fromUndo = !0, n = null, (i = i.pop()) && (n = e.undoChanges(i, t), this.$redoStack.push(i), this.$syncRev()), this.$fromUndo = !1, n;
                }, o.prototype.redo = function(e, t) {
                    if (this.lastDeltas = null, e = e || this.$session, this.$fromUndo = !0, this.$redoStackBaseRev != this.$rev) {
                        for(var n = this.getDeltas(this.$redoStackBaseRev, this.$rev + 1), i = this.$redoStack, o = n, r = 0; r < o.length; r++)for(var s = o[r], a = 0; a < s.length; a++){
                            l = void 0;
                            c = void 0;
                            h = void 0;
                            d = void 0;
                            u = void 0;
                            g = void 0;
                            var l = i;
                            var c = s[a];
                            c = function(e) {
                                return {
                                    start: C(e.start),
                                    end: C(e.end),
                                    action: e.action,
                                    lines: e.lines.slice()
                                };
                            }(c);
                            for(var h = l.length; h--;){
                                for(var d = l[h], u = 0; u < d.length; u++){
                                    var g = function(e, t) {
                                        var n, i, o = "insert" == e.action, r = "insert" == t.action;
                                        if (o && r) f(e.start, t.start) < 0 ? y(t, e, 1) : y(e, t, 1);
                                        else if (o && !r) 0 <= f(e.start, t.end) ? y(e, t, -1) : (f(e.start, t.start) <= 0 || y(e, m.fromPoints(t.start, e.start), -1), y(t, e, 1));
                                        else if (!o && r) 0 <= f(t.start, e.end) ? y(t, e, -1) : (f(t.start, e.start) <= 0 || y(t, m.fromPoints(e.start, t.start), -1), y(e, t, 1));
                                        else if (!o && !r) {
                                            if (0 <= f(t.start, e.end)) y(t, e, -1);
                                            else {
                                                if (!(f(t.end, e.start) <= 0)) return f(e.start, t.start) < 0 && (e = I(n = e, t.start)), 0 < f(e.end, t.end) && (i = I(e, t.end)), v(t.end, e.start, e.end, -1), i && !n && (e.lines = i.lines, e.start = i.start, e.end = i.end, i = e), [
                                                    t,
                                                    n,
                                                    i
                                                ].filter(Boolean);
                                                y(e, t, -1);
                                            }
                                        }
                                        return [
                                            t,
                                            e
                                        ];
                                    }(d[u], c);
                                    c = g[0], 2 != g.length && (g[2] ? (d.splice(u + 1, 1, g[1], g[2]), u++) : g[1] || (d.splice(u, 1), u--));
                                }
                                d.length || l.splice(h, 1);
                            }
                        }
                        this.$redoStackBaseRev = this.$rev, this.$redoStack.forEach(function(e) {
                            e[0].id = ++this.$maxRev;
                        }, this);
                    }
                    var n = this.$redoStack.pop(), p = null;
                    return n && (p = e.redoChanges(n, t), this.$undoStack.push(n), this.$syncRev()), this.$fromUndo = !1, p;
                }, o.prototype.$syncRev = function() {
                    var e = this.$undoStack, e = e[e.length - 1], e = e && e[0].id || 0;
                    this.$redoStackBaseRev = e, this.$rev = e;
                }, o.prototype.reset = function() {
                    this.lastDeltas = null, this.$lastDelta = null, this.$undoStack = [], this.$redoStack = [], this.$rev = 0, this.mark = 0, this.$redoStackBaseRev = this.$rev, this.selections = [];
                }, o.prototype.canUndo = function() {
                    return 0 < this.$undoStack.length;
                }, o.prototype.canRedo = function() {
                    return 0 < this.$redoStack.length;
                }, o.prototype.bookmark = function(e) {
                    null == e && (e = this.$rev), this.mark = e;
                }, o.prototype.isAtBookmark = function() {
                    return this.$rev === this.mark;
                }, o.prototype.toJSON = function() {}, o.prototype.fromJSON = function() {}, o.prototype.$prettyPrint = function(e) {
                    return e ? r(e) : r(this.$undoStack) + "\n---\n" + r(this.$redoStack);
                };
                var i = o;
                function o() {
                    this.$maxRev = 0, this.$fromUndo = !1, this.$undoDepth = 1 / 0, this.reset();
                }
                i.prototype.hasUndo = i.prototype.canUndo, i.prototype.hasRedo = i.prototype.canRedo, i.prototype.isClean = i.prototype.isAtBookmark, i.prototype.markClean = i.prototype.bookmark;
                var m = e("./range").Range, f = m.comparePoints;
                m.comparePoints;
                function C(e) {
                    return {
                        row: e.row,
                        column: e.column
                    };
                }
                function r(e) {
                    var t;
                    return e = e || this, Array.isArray(e) ? e.map(r).join("\n") : (t = "", e.action ? (t = "insert" == e.action ? "+" : "-", t += "[" + e.lines + "]") : e.value && (t = Array.isArray(e.value) ? e.value.map(s).join("\n") : s(e.value)), e.start && (t += s(e)), (e.id || e.rev) && (t += "\t(" + (e.id || e.rev) + ")"), t);
                }
                function s(e) {
                    return e.start.row + ":" + e.start.column + "=>" + e.end.row + ":" + e.end.column;
                }
                function a(e, t) {
                    var n = "insert" == e.action, i = "insert" == t.action;
                    if (n && i) {
                        if (0 <= f(t.start, e.end)) y(t, e, -1);
                        else {
                            if (!(f(t.start, e.start) <= 0)) return;
                            y(e, t, 1);
                        }
                    } else if (n && !i) {
                        if (0 <= f(t.start, e.end)) y(t, e, -1);
                        else {
                            if (!(f(t.end, e.start) <= 0)) return;
                            y(e, t, -1);
                        }
                    } else if (!n && i) {
                        if (0 <= f(t.start, e.start)) y(t, e, 1);
                        else {
                            if (!(f(t.start, e.start) <= 0)) return;
                            y(e, t, 1);
                        }
                    } else if (!n && !i) {
                        if (0 <= f(t.start, e.start)) y(t, e, 1);
                        else {
                            if (!(f(t.end, e.start) <= 0)) return;
                            y(e, t, -1);
                        }
                    }
                    return 1;
                }
                function y(e, t, n) {
                    v(e.start, t.start, t.end, n), v(e.end, t.start, t.end, n);
                }
                function v(e, t, n, i) {
                    e.row == (1 == i ? t : n).row && (e.column += i * (n.column - t.column)), e.row += i * (n.row - t.row);
                }
                function I(e, t) {
                    var n = e.lines, i = e.end, o = (e.end = C(t), e.end.row - e.start.row), r = n.splice(o, n.length), o = o ? t.column : t.column - e.start.column;
                    return n.push(r[0].substring(0, o)), r[0] = r[0].substr(o), {
                        start: C(t),
                        end: i,
                        lines: r,
                        action: e.action
                    };
                }
                t.UndoManager = i;
            }), ace.define("ace/layer/lines", [
                "require",
                "exports",
                "module",
                "ace/lib/dom"
            ], function(e, t, n) {
                "use strict";
                var s = e("../lib/dom");
                function i(e, t) {
                    this.element = e, this.canvasHeight = t || 5e5, this.element.style.height = 2 * this.canvasHeight + "px", this.cells = [], this.cellCache = [], this.$offsetCoefficient = 0;
                }
                i.prototype.moveContainer = function(e) {
                    s.translate(this.element, 0, -(e.firstRowScreen * e.lineHeight % this.canvasHeight) - e.offset * this.$offsetCoefficient);
                }, i.prototype.pageChanged = function(e, t) {
                    return Math.floor(e.firstRowScreen * e.lineHeight / this.canvasHeight) !== Math.floor(t.firstRowScreen * t.lineHeight / this.canvasHeight);
                }, i.prototype.computeLineTop = function(e, t, n) {
                    var i = t.firstRowScreen * t.lineHeight, i = Math.floor(i / this.canvasHeight);
                    return n.documentToScreenRow(e, 0) * t.lineHeight - i * this.canvasHeight;
                }, i.prototype.computeLineHeight = function(e, t, n) {
                    return t.lineHeight * n.getRowLineCount(e);
                }, i.prototype.getLength = function() {
                    return this.cells.length;
                }, i.prototype.get = function(e) {
                    return this.cells[e];
                }, i.prototype.shift = function() {
                    this.$cacheCell(this.cells.shift());
                }, i.prototype.pop = function() {
                    this.$cacheCell(this.cells.pop());
                }, i.prototype.push = function(e) {
                    if (Array.isArray(e)) {
                        this.cells.push.apply(this.cells, e);
                        for(var t = s.createFragment(this.element), n = 0; n < e.length; n++)t.appendChild(e[n].element);
                        this.element.appendChild(t);
                    } else this.cells.push(e), this.element.appendChild(e.element);
                }, i.prototype.unshift = function(e) {
                    if (Array.isArray(e)) {
                        this.cells.unshift.apply(this.cells, e);
                        for(var t = s.createFragment(this.element), n = 0; n < e.length; n++)t.appendChild(e[n].element);
                        this.element.firstChild ? this.element.insertBefore(t, this.element.firstChild) : this.element.appendChild(t);
                    } else this.cells.unshift(e), this.element.insertAdjacentElement("afterbegin", e.element);
                }, i.prototype.last = function() {
                    return this.cells.length ? this.cells[this.cells.length - 1] : null;
                }, i.prototype.$cacheCell = function(e) {
                    e && (e.element.remove(), this.cellCache.push(e));
                }, i.prototype.createCell = function(e, t, n, i) {
                    var o, r = this.cellCache.pop();
                    return r || (o = s.createElement("div"), i && i(o), this.element.appendChild(o), r = {
                        element: o,
                        text: "",
                        row: e
                    }), r.row = e, r;
                }, t.Lines = i;
            }), ace.define("ace/layer/gutter", [
                "require",
                "exports",
                "module",
                "ace/lib/dom",
                "ace/lib/oop",
                "ace/lib/lang",
                "ace/lib/event_emitter",
                "ace/layer/lines",
                "ace/config"
            ], function(e, t, n) {
                "use strict";
                var w = e("../lib/dom"), i = e("../lib/oop"), s = e("../lib/lang"), o = e("../lib/event_emitter").EventEmitter, r = e("./lines").Lines, S = e("../config").nls, e = (a.prototype.setSession = function(e) {
                    this.session && this.session.off("change", this.$updateAnnotations), (this.session = e) && e.on("change", this.$updateAnnotations);
                }, a.prototype.addGutterDecoration = function(e, t) {
                    window.console && console.warn && console.warn("deprecated use session.addGutterDecoration"), this.session.addGutterDecoration(e, t);
                }, a.prototype.removeGutterDecoration = function(e, t) {
                    window.console && console.warn && console.warn("deprecated use session.removeGutterDecoration"), this.session.removeGutterDecoration(e, t);
                }, a.prototype.setAnnotations = function(e) {
                    this.$annotations = [];
                    for(var t = 0; t < e.length; t++){
                        var n = e[t], i = n.row, o = (o = this.$annotations[i]) || (this.$annotations[i] = {
                            text: [],
                            type: []
                        }), i = n.text, r = n.type, i = i ? s.escapeHTML(i) : n.html || "", i = (-1 === o.text.indexOf(i) && (o.text.push(i), o.type.push(r)), n.className);
                        i ? o.className = i : "error" == r ? o.className = " ace_error" : "warning" == r && " ace_error" != o.className ? o.className = " ace_warning" : "info" != r || o.className || (o.className = " ace_info");
                    }
                }, a.prototype.$updateAnnotations = function(e) {
                    var t, n;
                    this.$annotations.length && (t = e.start.row, 0 != (n = e.end.row - t)) && ("remove" == e.action ? this.$annotations.splice(t, 1 + n, null) : ((e = new Array(1 + n)).unshift(t, 1), this.$annotations.splice.apply(this.$annotations, e)));
                }, a.prototype.update = function(e) {
                    this.config = e;
                    for(var t = this.session, n = e.firstRow, i = Math.min(e.lastRow + e.gutterOffset, t.getLength() - 1), o = (this.oldLastRow = i, this.config = e, this.$lines.moveContainer(e), this.$updateCursorRow(), t.getNextFoldLine(n)), r = o ? o.start.row : 1 / 0, s = null, a = -1, l = n;;){
                        if (r < l && (l = o.end.row + 1, r = (o = t.getNextFoldLine(l, o)) ? o.start.row : 1 / 0), i < l) {
                            for(; this.$lines.getLength() > a + 1;)this.$lines.pop();
                            break;
                        }
                        (s = this.$lines.get(++a)) ? s.row = l : (s = this.$lines.createCell(l, e, this.session, c), this.$lines.push(s)), this.$renderCell(s, e, o, l), l++;
                    }
                    this._signal("afterRender"), this.$updateGutterWidth(e);
                }, a.prototype.$updateGutterWidth = function(e) {
                    var t = this.session, n = t.gutterRenderer || this.$renderer, i = t.$firstLineNumber, o = this.$lines.last() ? this.$lines.last().text : "", i = ((this.$fixedWidth || t.$useWrapMode) && (o = t.getLength() + i - 1), n ? n.getWidth(t, o, e) : o.toString().length * e.characterWidth), n = this.$padding || this.$computePadding();
                    (i += n.left + n.right) === this.gutterWidth || isNaN(i) || (this.gutterWidth = i, this.element.parentNode.style.width = this.element.style.width = Math.ceil(this.gutterWidth) + "px", this._signal("changeGutterWidth", i));
                }, a.prototype.$updateCursorRow = function() {
                    var e;
                    this.$highlightGutterLine && (e = this.session.selection.getCursor(), this.$cursorRow !== e.row) && (this.$cursorRow = e.row);
                }, a.prototype.updateLineHighlight = function() {
                    if (this.$highlightGutterLine) {
                        var e = this.session.selection.cursor.row;
                        if (this.$cursorRow = e, !this.$cursorCell || this.$cursorCell.row != e) {
                            this.$cursorCell && (this.$cursorCell.element.className = this.$cursorCell.element.className.replace("ace_gutter-active-line ", ""));
                            var t = this.$lines.cells;
                            this.$cursorCell = null;
                            for(var n = 0; n < t.length; n++){
                                var i = t[n];
                                if (i.row >= this.$cursorRow) {
                                    if (i.row > this.$cursorRow) {
                                        var o = this.session.getFoldLine(this.$cursorRow);
                                        if (!(0 < n && o && o.start.row == t[n - 1].row)) break;
                                        i = t[n - 1];
                                    }
                                    i.element.className = "ace_gutter-active-line " + i.element.className, this.$cursorCell = i;
                                    break;
                                }
                            }
                        }
                    }
                }, a.prototype.scrollLines = function(e) {
                    var t = this.config;
                    if (this.config = e, this.$updateCursorRow(), this.$lines.pageChanged(t, e)) return this.update(e);
                    this.$lines.moveContainer(e);
                    var n = Math.min(e.lastRow + e.gutterOffset, this.session.getLength() - 1), i = this.oldLastRow;
                    if (this.oldLastRow = n, !t || i < e.firstRow) return this.update(e);
                    if (n < t.firstRow) return this.update(e);
                    if (t.firstRow < e.firstRow) for(var o = this.session.getFoldedRowCount(t.firstRow, e.firstRow - 1); 0 < o; o--)this.$lines.shift();
                    if (n < i) for(o = this.session.getFoldedRowCount(n + 1, i); 0 < o; o--)this.$lines.pop();
                    e.firstRow < t.firstRow && this.$lines.unshift(this.$renderLines(e, e.firstRow, t.firstRow - 1)), i < n && this.$lines.push(this.$renderLines(e, i + 1, n)), this.updateLineHighlight(), this._signal("afterRender"), this.$updateGutterWidth(e);
                }, a.prototype.$renderLines = function(e, t, n) {
                    for(var i = [], o = t, r = this.session.getNextFoldLine(o), s = r ? r.start.row : 1 / 0; s < o && (o = r.end.row + 1, s = (r = this.session.getNextFoldLine(o, r)) ? r.start.row : 1 / 0), !(n < o);){
                        var a = this.$lines.createCell(o, e, this.session, c);
                        this.$renderCell(a, e, r, o), i.push(a), o++;
                    }
                    return i;
                }, a.prototype.$renderCell = function(e, t, n, i) {
                    var o, r = e.element, s = this.session, a = r.childNodes[0], l = r.childNodes[1], c = r.childNodes[2], h = c.firstChild, d = s.$firstLineNumber, u = s.$breakpoints, g = s.$decorations, p = s.gutterRenderer || this.$renderer, m = this.$showFoldWidgets && s.foldWidgets, f = n ? n.start.row : Number.MAX_VALUE, C = t.lineHeight + "px", y = this.$useSvgGutterIcons ? "ace_gutter-cell_svg-icons " : "ace_gutter-cell ", v = this.$useSvgGutterIcons ? "ace_icon_svg" : "ace_icon", p = (p ? p.getText(s, i) : i + d).toString();
                    if (this.$highlightGutterLine && (i == this.$cursorRow || n && i < this.$cursorRow && f <= i && this.$cursorRow <= n.end.row) && (y += "ace_gutter-active-line ", this.$cursorCell != e) && (this.$cursorCell && (this.$cursorCell.element.className = this.$cursorCell.element.className.replace("ace_gutter-active-line ", "")), this.$cursorCell = e), u[i] && (y += u[i]), g[i] && (y += g[i]), this.$annotations[i] && i !== f && (y += this.$annotations[i].className), r.className != y && (r.className = y), o = m && null == (o = m[i]) ? m[i] = s.getFoldWidget(i) : o) {
                        y = "ace_fold-widget ace_" + o;
                        if ("start" == o && i == f && i < n.end.row) {
                            y += " ace_closed";
                            for(var I, b = !1, A = i + 1; A <= n.end.row; A++)if (this.$annotations[A]) {
                                if (" ace_error" === this.$annotations[A].className) {
                                    b = !0, I = " ace_error_fold";
                                    break;
                                }
                                " ace_warning" === this.$annotations[A].className && (b = !0, I = " ace_warning_fold");
                            }
                            r.className += I;
                        } else y += " ace_open";
                        l.className != y && (l.className = y), w.setStyle(l.style, "height", C), w.setStyle(l.style, "display", "inline-block"), l.setAttribute("role", "button"), l.setAttribute("tabindex", "-1"), (n = s.getFoldLine(p - 1)) ? (l.setAttribute("aria-label", S("Unfold rows $0 to $1", [
                            p,
                            n.end.row + 1
                        ])), l.setAttribute("title", S("Unfold code"))) : (l.setAttribute("aria-label", S("Fold at row $0", [
                            p
                        ])), l.setAttribute("title", S("Fold code")));
                    } else l && (w.setStyle(l.style, "display", "none"), l.setAttribute("tabindex", "0"), l.removeAttribute("role"), l.removeAttribute("aria-label"));
                    return b && this.$showFoldedAnnotations ? (c.className = "ace_gutter_annotation", h.className = v, h.className += I, w.setStyle(h.style, "height", C), w.setStyle(c.style, "display", "block"), w.setStyle(c.style, "height", C), c.setAttribute("aria-label", S("Read annotations row $0", [
                        p
                    ])), c.setAttribute("tabindex", "-1")) : this.$annotations[i] ? (c.className = "ace_gutter_annotation", h.className = v, this.$useSvgGutterIcons ? h.className += this.$annotations[i].className : r.classList.add(this.$annotations[i].className.replace(" ", "")), w.setStyle(h.style, "height", C), w.setStyle(c.style, "display", "block"), w.setStyle(c.style, "height", C), c.setAttribute("aria-label", S("Read annotations row $0", [
                        p
                    ])), c.setAttribute("tabindex", "-1")) : (w.setStyle(c.style, "display", "none"), c.removeAttribute("aria-label"), c.setAttribute("tabindex", "0")), p !== a.data && (a.data = p), w.setStyle(e.element.style, "height", this.$lines.computeLineHeight(i, t, s) + "px"), w.setStyle(e.element.style, "top", this.$lines.computeLineTop(i, t, s) + "px"), e.text = p, "none" === c.style.display && "none" === l.style.display ? e.element.setAttribute("aria-hidden", !0) : e.element.setAttribute("aria-hidden", !1), e;
                }, a.prototype.setHighlightGutterLine = function(e) {
                    this.$highlightGutterLine = e;
                }, a.prototype.setShowLineNumbers = function(e) {
                    this.$renderer = !e && {
                        getWidth: function() {
                            return 0;
                        },
                        getText: function() {
                            return "";
                        }
                    };
                }, a.prototype.getShowLineNumbers = function() {
                    return this.$showLineNumbers;
                }, a.prototype.setShowFoldWidgets = function(e) {
                    e ? w.addCssClass(this.element, "ace_folding-enabled") : w.removeCssClass(this.element, "ace_folding-enabled"), this.$showFoldWidgets = e, this.$padding = null;
                }, a.prototype.getShowFoldWidgets = function() {
                    return this.$showFoldWidgets;
                }, a.prototype.$computePadding = function() {
                    var e;
                    return this.element.firstChild ? (e = w.computedStyle(this.element.firstChild), this.$padding = {}, this.$padding.left = (parseInt(e.borderLeftWidth) || 0) + (parseInt(e.paddingLeft) || 0) + 1, this.$padding.right = (parseInt(e.borderRightWidth) || 0) + (parseInt(e.paddingRight) || 0), this.$padding) : {
                        left: 0,
                        right: 0
                    };
                }, a.prototype.getRegion = function(e) {
                    var t = this.$padding || this.$computePadding(), n = this.element.getBoundingClientRect();
                    return e.x < t.left + n.left ? "markers" : this.$showFoldWidgets && e.x > n.right - t.right ? "foldWidgets" : void 0;
                }, a);
                function a(e) {
                    this.element = w.createElement("div"), this.element.className = "ace_layer ace_gutter-layer", e.appendChild(this.element), this.setShowFoldWidgets(this.$showFoldWidgets), this.gutterWidth = 0, this.$annotations = [], this.$updateAnnotations = this.$updateAnnotations.bind(this), this.$lines = new r(this.element), this.$lines.$offsetCoefficient = 1;
                }
                function c(e) {
                    var t = document.createTextNode(""), t = (e.appendChild(t), w.createElement("span")), t = (e.appendChild(t), w.createElement("span")), n = (e.appendChild(t), w.createElement("span"));
                    return t.appendChild(n), e;
                }
                e.prototype.$fixedWidth = !1, e.prototype.$highlightGutterLine = !0, e.prototype.$renderer = "", e.prototype.$showLineNumbers = !0, e.prototype.$showFoldWidgets = !0, i.implement(e.prototype, o), t.Gutter = e;
            }), ace.define("ace/layer/marker", [
                "require",
                "exports",
                "module",
                "ace/range",
                "ace/lib/dom"
            ], function(e, t, n) {
                "use strict";
                var g = e("../range").Range, i = e("../lib/dom"), e = (o.prototype.setPadding = function(e) {
                    this.$padding = e;
                }, o.prototype.setSession = function(e) {
                    this.session = e;
                }, o.prototype.setMarkers = function(e) {
                    this.markers = e;
                }, o.prototype.elt = function(e, t) {
                    var n = -1 != this.i && this.element.childNodes[this.i];
                    n ? this.i++ : (n = document.createElement("div"), this.element.appendChild(n), this.i = -1), n.style.cssText = t, n.className = e;
                }, o.prototype.update = function(e) {
                    if (e) {
                        var t, n;
                        for(n in this.config = e, this.i = 0, this.markers){
                            var i, o, r, s = this.markers[n];
                            s.range ? (r = s.range.clipRows(e.firstRow, e.lastRow)).isEmpty() || (r = r.toScreenRange(this.session), s.renderer ? (i = this.$getTop(r.start.row, e), o = this.$padding + r.start.column * e.characterWidth, s.renderer(t, r, o, i, e)) : "fullLine" == s.type ? this.drawFullLineMarker(t, r, s.clazz, e) : "screenLine" == s.type ? this.drawScreenLineMarker(t, r, s.clazz, e) : r.isMultiLine() ? "text" == s.type ? this.drawTextMarker(t, r, s.clazz, e) : this.drawMultiLineMarker(t, r, s.clazz, e) : this.drawSingleLineMarker(t, r, s.clazz + " ace_start ace_br15", e)) : s.update(t, this, this.session, e);
                        }
                        if (-1 != this.i) for(; this.i < this.element.childElementCount;)this.element.removeChild(this.element.lastChild);
                    }
                }, o.prototype.$getTop = function(e, t) {
                    return (e - t.firstRowScreen) * t.lineHeight;
                }, o.prototype.drawTextMarker = function(e, t, n, i, o) {
                    for(var r, s = this.session, a = t.start.row, l = t.end.row, c = a, h = 0, d = s.getScreenLastRowColumn(c), u = new g(c, t.start.column, c, h); c <= l; c++)u.start.row = u.end.row = c, u.start.column = c == a ? t.start.column : s.getRowWrapIndent(c), u.end.column = d, r = h, h = d, d = c + 1 < l ? s.getScreenLastRowColumn(c + 1) : c == l ? 0 : t.end.column, this.drawSingleLineMarker(e, u, n + (c == a ? " ace_start" : "") + " ace_br" + ((c == a || c == a + 1 && t.start.column ? 1 : 0) | (r < h ? 2 : 0) | (d < h ? 4 : 0) | (c == l ? 8 : 0)), i, c == l ? 0 : 1, o);
                }, o.prototype.drawMultiLineMarker = function(e, t, n, i, o) {
                    var r, s = this.$padding, a = i.lineHeight, l = this.$getTop(t.start.row, i), c = s + t.start.column * i.characterWidth;
                    o = o || "", this.session.$bidiHandler.isBidiRow(t.start.row) ? ((r = t.clone()).end.row = r.start.row, r.end.column = this.session.getLine(r.start.row).length, this.drawBidiSingleLineMarker(e, r, n + " ace_br1 ace_start", i, null, o)) : this.elt(n + " ace_br1 ace_start", "height:" + a + "px;right:0;top:" + l + "px;left:" + c + "px;" + (o || "")), this.session.$bidiHandler.isBidiRow(t.end.row) ? ((r = t.clone()).start.row = r.end.row, r.start.column = 0, this.drawBidiSingleLineMarker(e, r, n + " ace_br12", i, null, o)) : (l = this.$getTop(t.end.row, i), c = t.end.column * i.characterWidth, this.elt(n + " ace_br12", "height:" + a + "px;width:" + c + "px;top:" + l + "px;left:" + s + "px;" + (o || ""))), (a = (t.end.row - t.start.row - 1) * i.lineHeight) <= 0 || (l = this.$getTop(t.start.row + 1, i), e = (t.start.column ? 1 : 0) | (t.end.column ? 0 : 8), this.elt(n + (e ? " ace_br" + e : ""), "height:" + a + "px;right:0;top:" + l + "px;left:" + s + "px;" + (o || "")));
                }, o.prototype.drawSingleLineMarker = function(e, t, n, i, o, r) {
                    if (this.session.$bidiHandler.isBidiRow(t.start.row)) return this.drawBidiSingleLineMarker(e, t, n, i, o, r);
                    var e = i.lineHeight, o = (t.end.column + (o || 0) - t.start.column) * i.characterWidth, s = this.$getTop(t.start.row, i), t = this.$padding + t.start.column * i.characterWidth;
                    this.elt(n, "height:" + e + "px;width:" + o + "px;top:" + s + "px;left:" + t + "px;" + (r || ""));
                }, o.prototype.drawBidiSingleLineMarker = function(e, t, n, i, o, r) {
                    var s = i.lineHeight, a = this.$getTop(t.start.row, i), l = this.$padding;
                    this.session.$bidiHandler.getSelections(t.start.column, t.end.column).forEach(function(e) {
                        this.elt(n, "height:" + s + "px;width:" + (e.width + (o || 0)) + "px;top:" + a + "px;left:" + (l + e.left) + "px;" + (r || ""));
                    }, this);
                }, o.prototype.drawFullLineMarker = function(e, t, n, i, o) {
                    var r = this.$getTop(t.start.row, i), s = i.lineHeight;
                    t.start.row != t.end.row && (s += this.$getTop(t.end.row, i) - r), this.elt(n, "height:" + s + "px;top:" + r + "px;left:0;right:0;" + (o || ""));
                }, o.prototype.drawScreenLineMarker = function(e, t, n, i, o) {
                    t = this.$getTop(t.start.row, i), i = i.lineHeight;
                    this.elt(n, "height:" + i + "px;top:" + t + "px;left:0;right:0;" + (o || ""));
                }, o);
                function o(e) {
                    this.element = i.createElement("div"), this.element.className = "ace_layer ace_marker-layer", e.appendChild(this.element);
                }
                e.prototype.$padding = 0, t.Marker = e;
            }), ace.define("ace/layer/text", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/dom",
                "ace/lib/lang",
                "ace/layer/lines",
                "ace/lib/event_emitter"
            ], function(e, t, n) {
                "use strict";
                var i = e("../lib/oop"), c = e("../lib/dom"), C = e("../lib/lang"), o = e("./lines").Lines, e = e("../lib/event_emitter").EventEmitter, r = (s.prototype.$updateEolChar = function() {
                    var e = this.session.doc, e = "\n" == e.getNewLineCharacter() && "windows" != e.getNewLineMode() ? this.EOL_CHAR_LF : this.EOL_CHAR_CRLF;
                    if (this.EOL_CHAR != e) return this.EOL_CHAR = e, !0;
                }, s.prototype.setPadding = function(e) {
                    this.$padding = e, this.element.style.margin = "0 " + e + "px";
                }, s.prototype.getLineHeight = function() {
                    return this.$fontMetrics.$characterSize.height || 0;
                }, s.prototype.getCharacterWidth = function() {
                    return this.$fontMetrics.$characterSize.width || 0;
                }, s.prototype.$setFontMetrics = function(e) {
                    this.$fontMetrics = e, this.$fontMetrics.on("changeCharacterSize", (function(e) {
                        this._signal("changeCharacterSize", e);
                    }).bind(this)), this.$pollSizeChanges();
                }, s.prototype.checkForSizeChanges = function() {
                    this.$fontMetrics.checkForSizeChanges();
                }, s.prototype.$pollSizeChanges = function() {
                    return this.$pollSizeChangesTimer = this.$fontMetrics.$pollSizeChanges();
                }, s.prototype.setSession = function(e) {
                    (this.session = e) && this.$computeTabString();
                }, s.prototype.setShowInvisibles = function(e) {
                    return this.showInvisibles != e && ("string" == typeof (this.showInvisibles = e) ? (this.showSpaces = /tab/i.test(e), this.showTabs = /space/i.test(e), this.showEOL = /eol/i.test(e)) : this.showSpaces = this.showTabs = this.showEOL = e, this.$computeTabString(), !0);
                }, s.prototype.setDisplayIndentGuides = function(e) {
                    return this.displayIndentGuides != e && (this.displayIndentGuides = e, this.$computeTabString(), !0);
                }, s.prototype.setHighlightIndentGuides = function(e) {
                    return this.$highlightIndentGuides !== e && (this.$highlightIndentGuides = e);
                }, s.prototype.$computeTabString = function() {
                    for(var e, t, n, i, o, r, s = this.session.getTabSize(), a = (this.tabSize = s, this.$tabStrings = [
                        0
                    ]), l = 1; l < s + 1; l++)this.showTabs ? ((r = this.dom.createElement("span")).className = "ace_invisible ace_invisible_tab", r.textContent = C.stringRepeat(this.TAB_CHAR, l), a.push(r)) : a.push(this.dom.createTextNode(C.stringRepeat(" ", l), this.element));
                    this.displayIndentGuides && (this.$indentGuideRe = /\s\S| \t|\t |\s$/, e = "ace_indent-guide", t = this.showSpaces ? " ace_invisible ace_invisible_space" : "", n = this.showSpaces ? C.stringRepeat(this.SPACE_CHAR, this.tabSize) : C.stringRepeat(" ", this.tabSize), i = this.showTabs ? " ace_invisible ace_invisible_tab" : "", o = this.showTabs ? C.stringRepeat(this.TAB_CHAR, this.tabSize) : n, (r = this.dom.createElement("span")).className = e + t, r.textContent = n, this.$tabStrings[" "] = r, (r = this.dom.createElement("span")).className = e + i, r.textContent = o, this.$tabStrings["\t"] = r);
                }, s.prototype.updateLines = function(e, t, n) {
                    if (this.config.lastRow != e.lastRow || this.config.firstRow != e.firstRow) return this.update(e);
                    this.config = e;
                    for(var i = Math.max(t, e.firstRow), o = Math.min(n, e.lastRow), r = this.element.childNodes, s = 0, a = e.firstRow; a < i; a++){
                        if (l = this.session.getFoldLine(a)) {
                            if (l.containsRow(i)) {
                                i = l.start.row;
                                break;
                            }
                            a = l.end.row;
                        }
                        s++;
                    }
                    for(var l, c = !1, a = i, h = (l = this.session.getNextFoldLine(a)) ? l.start.row : 1 / 0; h < a && (a = l.end.row + 1, h = (l = this.session.getNextFoldLine(a, l)) ? l.start.row : 1 / 0), !(o < a);){
                        var d, u = r[s++];
                        u && (this.dom.removeChildren(u), this.$renderLine(u, a, a == h && l), c && (u.style.top = this.$lines.computeLineTop(a, e, this.session) + "px"), d = e.lineHeight * this.session.getRowLength(a) + "px", u.style.height != d) && (c = !0, u.style.height = d), a++;
                    }
                    if (c) for(; s < this.$lines.cells.length;){
                        var g = this.$lines.cells[s++];
                        g.element.style.top = this.$lines.computeLineTop(g.row, e, this.session) + "px";
                    }
                }, s.prototype.scrollLines = function(e) {
                    var t = this.config;
                    if (this.config = e, this.$lines.pageChanged(t, e)) return this.update(e);
                    this.$lines.moveContainer(e);
                    var n = e.lastRow, i = t ? t.lastRow : -1;
                    if (!t || i < e.firstRow) return this.update(e);
                    if (n < t.firstRow) return this.update(e);
                    if (!t || t.lastRow < e.firstRow) return this.update(e);
                    if (e.lastRow < t.firstRow) return this.update(e);
                    if (t.firstRow < e.firstRow) for(var o = this.session.getFoldedRowCount(t.firstRow, e.firstRow - 1); 0 < o; o--)this.$lines.shift();
                    if (t.lastRow > e.lastRow) for(o = this.session.getFoldedRowCount(e.lastRow + 1, t.lastRow); 0 < o; o--)this.$lines.pop();
                    e.firstRow < t.firstRow && this.$lines.unshift(this.$renderLinesFragment(e, e.firstRow, t.firstRow - 1)), e.lastRow > t.lastRow && this.$lines.push(this.$renderLinesFragment(e, t.lastRow + 1, e.lastRow)), this.$highlightIndentGuide();
                }, s.prototype.$renderLinesFragment = function(e, t, n) {
                    for(var i = [], o = t, r = this.session.getNextFoldLine(o), s = r ? r.start.row : 1 / 0; s < o && (o = r.end.row + 1, s = (r = this.session.getNextFoldLine(o, r)) ? r.start.row : 1 / 0), !(n < o);){
                        var a = this.$lines.createCell(o, e, this.session), l = a.element;
                        this.dom.removeChildren(l), c.setStyle(l.style, "height", this.$lines.computeLineHeight(o, e, this.session) + "px"), c.setStyle(l.style, "top", this.$lines.computeLineTop(o, e, this.session) + "px"), this.$renderLine(l, o, o == s && r), this.$useLineGroups() ? l.className = "ace_line_group" : l.className = "ace_line", i.push(a), o++;
                    }
                    return i;
                }, s.prototype.update = function(e) {
                    this.$lines.moveContainer(e);
                    for(var t = (this.config = e).firstRow, n = e.lastRow, i = this.$lines; i.getLength();)i.pop();
                    i.push(this.$renderLinesFragment(e, t, n));
                }, s.prototype.$renderToken = function(e, t, n, i) {
                    for(var o, r, s = this, a = /(\t)|( +)|([\x00-\x1f\x80-\xa0\xad\u1680\u180E\u2000-\u200f\u2028\u2029\u202F\u205F\uFEFF\uFFF9-\uFFFC\u2066\u2067\u2068\u202A\u202B\u202D\u202E\u202C\u2069]+)|(\u3000)|([\u1100-\u115F\u11A3-\u11A7\u11FA-\u11FF\u2329-\u232A\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3001-\u303E\u3041-\u3096\u3099-\u30FF\u3105-\u312D\u3131-\u318E\u3190-\u31BA\u31C0-\u31E3\u31F0-\u321E\u3220-\u3247\u3250-\u32FE\u3300-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFAFF\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFF01-\uFF60\uFFE0-\uFFE6]|[\uD800-\uDBFF][\uDC00-\uDFFF])/g, l = this.dom.createFragment(this.element), c = 0; o = a.exec(i);){
                        var h, d, u = o[1], g = o[2], p = o[3], m = o[4], f = o[5];
                        !s.showSpaces && g || (h = c != o.index ? i.slice(c, o.index) : "", c = o.index + o[0].length, h && l.appendChild(this.dom.createTextNode(h, this.element)), u ? (h = s.session.getScreenTabSize(t + o.index), l.appendChild(s.$tabStrings[h].cloneNode(!0)), t += h - 1) : g ? s.showSpaces ? ((d = this.dom.createElement("span")).className = "ace_invisible ace_invisible_space", d.textContent = C.stringRepeat(s.SPACE_CHAR, g.length), l.appendChild(d)) : l.appendChild(this.com.createTextNode(g, this.element)) : p ? ((d = this.dom.createElement("span")).className = "ace_invisible ace_invisible_space ace_invalid", d.textContent = C.stringRepeat(s.SPACE_CHAR, p.length), l.appendChild(d)) : m ? (t += 1, (d = this.dom.createElement("span")).style.width = 2 * s.config.characterWidth + "px", d.className = s.showSpaces ? "ace_cjk ace_invisible ace_invisible_space" : "ace_cjk", d.textContent = s.showSpaces ? s.SPACE_CHAR : m, l.appendChild(d)) : f && (t += 1, (d = this.dom.createElement("span")).style.width = 2 * s.config.characterWidth + "px", d.className = "ace_cjk", d.textContent = f, l.appendChild(d)));
                    }
                    return l.appendChild(this.dom.createTextNode(c ? i.slice(c) : i, this.element)), this.$textToken[n.type] ? e.appendChild(l) : (r = "ace_" + n.type.replace(/\./g, " ace_"), d = this.dom.createElement("span"), "fold" == n.type && (d.style.width = n.value.length * this.config.characterWidth + "px", d.setAttribute("title", "Unfold code")), d.className = r, d.appendChild(l), e.appendChild(d)), t + i.length;
                }, s.prototype.renderIndentGuide = function(e, t, n) {
                    var i = t.search(this.$indentGuideRe);
                    if (!(i <= 0 || n <= i)) {
                        if (" " == t[0]) {
                            for(var o = (i -= i % this.tabSize) / this.tabSize, r = 0; r < o; r++)e.appendChild(this.$tabStrings[" "].cloneNode(!0));
                            return this.$highlightIndentGuide(), t.substr(i);
                        }
                        if ("\t" == t[0]) {
                            for(r = 0; r < i; r++)e.appendChild(this.$tabStrings["\t"].cloneNode(!0));
                            return this.$highlightIndentGuide(), t.substr(i);
                        }
                        this.$highlightIndentGuide();
                    }
                    return t;
                }, s.prototype.$highlightIndentGuide = function() {
                    if (this.$highlightIndentGuides && this.displayIndentGuides) {
                        this.$highlightIndentGuideMarker = {
                            indentLevel: void 0,
                            start: void 0,
                            end: void 0,
                            dir: void 0
                        };
                        var e = this.session.doc.$lines;
                        if (e) {
                            var t = this.session.selection.getCursor(), n = /^\s*/.exec(this.session.doc.getLine(t.row))[0].length, i = Math.floor(n / this.tabSize);
                            if (this.$highlightIndentGuideMarker = {
                                indentLevel: i,
                                start: t.row
                            }, this.session.$bracketHighlight) {
                                for(var o = this.session.$bracketHighlight.ranges, r = 0; r < o.length; r++)if (t.row !== o[r].start.row) {
                                    this.$highlightIndentGuideMarker.end = o[r].start.row, t.row > o[r].start.row ? this.$highlightIndentGuideMarker.dir = -1 : this.$highlightIndentGuideMarker.dir = 1;
                                    break;
                                }
                            }
                            if (!this.$highlightIndentGuideMarker.end && "" !== e[t.row] && t.column === e[t.row].length) {
                                this.$highlightIndentGuideMarker.dir = 1;
                                for(r = t.row + 1; r < e.length; r++){
                                    var s = e[r], a = /^\s*/.exec(s)[0].length;
                                    if ("" !== s && (this.$highlightIndentGuideMarker.end = r, a <= n)) break;
                                }
                            }
                            this.$renderHighlightIndentGuide();
                        }
                    }
                }, s.prototype.$clearActiveIndentGuide = function() {
                    for(var e = this.$lines.cells, t = 0; t < e.length; t++){
                        var n = e[t].element.childNodes;
                        if (0 < n.length) {
                            for(var i = 0; i < n.length; i++)if (n[i].classList && n[i].classList.contains("ace_indent-guide-active")) {
                                n[i].classList.remove("ace_indent-guide-active");
                                break;
                            }
                        }
                    }
                }, s.prototype.$setIndentGuideActive = function(e, t) {
                    "" !== this.session.doc.getLine(e.row) && (e = e.element.childNodes) && (e = e[t - 1]) && e.classList && e.classList.contains("ace_indent-guide") && e.classList.add("ace_indent-guide-active");
                }, s.prototype.$renderHighlightIndentGuide = function() {
                    if (this.$lines) {
                        var e = this.$lines.cells, t = (this.$clearActiveIndentGuide(), this.$highlightIndentGuideMarker.indentLevel);
                        if (0 !== t) {
                            if (1 === this.$highlightIndentGuideMarker.dir) for(var n = 0; n < e.length; n++){
                                var i = e[n];
                                if (this.$highlightIndentGuideMarker.end && i.row >= this.$highlightIndentGuideMarker.start + 1) {
                                    if (i.row >= this.$highlightIndentGuideMarker.end) break;
                                    this.$setIndentGuideActive(i, t);
                                }
                            }
                            else for(n = e.length - 1; 0 <= n; n--){
                                i = e[n];
                                if (this.$highlightIndentGuideMarker.end && i.row < this.$highlightIndentGuideMarker.start) {
                                    if (i.row <= this.$highlightIndentGuideMarker.end) break;
                                    this.$setIndentGuideActive(i, t);
                                }
                            }
                        }
                    }
                }, s.prototype.$createLineElement = function(e) {
                    var t = this.dom.createElement("div");
                    return t.className = "ace_line", t.style.height = this.config.lineHeight + "px", t;
                }, s.prototype.$renderWrappedLine = function(e, t, n) {
                    var i = 0, o = 0, r = n[0], s = 0, a = this.$createLineElement();
                    e.appendChild(a);
                    for(var l = 0; l < t.length; l++){
                        var c = t[l], h = c.value;
                        if (0 == l && this.displayIndentGuides) {
                            if (i = h.length, !(h = this.renderIndentGuide(a, h, r))) continue;
                            i -= h.length;
                        }
                        if (i + h.length < r) s = this.$renderToken(a, s, c, h), i += h.length;
                        else {
                            for(; i + h.length >= r;)s = this.$renderToken(a, s, c, h.substring(0, r - i)), h = h.substring(r - i), i = r, a = this.$createLineElement(), e.appendChild(a), a.appendChild(this.dom.createTextNode(C.stringRepeat("\xa0", n.indent), this.element)), s = 0, r = n[++o] || Number.MAX_VALUE;
                            0 != h.length && (i += h.length, s = this.$renderToken(a, s, c, h));
                        }
                    }
                    n[n.length - 1] > this.MAX_LINE_LENGTH && this.$renderOverflowMessage(a, s, null, "", !0);
                }, s.prototype.$renderSimpleLine = function(e, t) {
                    for(var n = 0, i = 0; i < t.length; i++){
                        var o = t[i], r = o.value;
                        if (0 != i || !this.displayIndentGuides || (r = this.renderIndentGuide(e, r))) {
                            if (n + r.length > this.MAX_LINE_LENGTH) return this.$renderOverflowMessage(e, n, o, r);
                            n = this.$renderToken(e, n, o, r);
                        }
                    }
                }, s.prototype.$renderOverflowMessage = function(e, t, n, i, o) {
                    n && this.$renderToken(e, t, n, i.slice(0, this.MAX_LINE_LENGTH - t));
                    n = this.dom.createElement("span");
                    n.className = "ace_inline_button ace_keyword ace_toggle_wrap", n.textContent = o ? "<hide>" : "<click to see more...>", e.appendChild(n);
                }, s.prototype.$renderLine = function(e, t, n) {
                    var i, o, r = e;
                    (i = (n = n || 0 == n ? n : this.session.getFoldLine(t)) ? this.$getFoldLineTokens(t, n) : this.session.getTokens(t)).length ? (o = this.session.getRowSplitData(t)) && o.length ? (this.$renderWrappedLine(e, i, o), r = e.lastChild) : (r = e, this.$useLineGroups() && (r = this.$createLineElement(), e.appendChild(r)), this.$renderSimpleLine(r, i)) : this.$useLineGroups() && (r = this.$createLineElement(), e.appendChild(r)), this.showEOL && r && (n && (t = n.end.row), (o = this.dom.createElement("span")).className = "ace_invisible ace_invisible_eol", o.textContent = t == this.session.getLength() - 1 ? this.EOF_CHAR : this.EOL_CHAR, r.appendChild(o));
                }, s.prototype.$getFoldLineTokens = function(e, t) {
                    var d = this.session, u = [];
                    var g = d.getTokens(e);
                    return t.walk(function(e, t, n, i, o) {
                        if (null != e) u.push({
                            type: "fold",
                            value: e
                        });
                        else if ((g = o ? d.getTokens(t) : g).length) {
                            for(var r, s = g, a = i, l = n, c = 0, h = 0; h + s[c].value.length < a;)if (h += s[c].value.length, ++c == s.length) return void 0;
                            for(h != a && ((r = s[c].value.substring(a - h)).length > l - a && (r = r.substring(0, l - a)), u.push({
                                type: s[c].type,
                                value: r
                            }), h = a + r.length, c += 1); h < l && c < s.length;)(r = s[c].value).length + h > l ? u.push({
                                type: s[c].type,
                                value: r.substring(0, l - h)
                            }) : u.push(s[c]), h += r.length, c += 1;
                        }
                    }, t.end.row, this.session.getLine(t.end.row).length), u;
                }, s.prototype.$useLineGroups = function() {
                    return this.session.getUseWrapMode();
                }, s);
                function s(e) {
                    this.dom = c, this.element = this.dom.createElement("div"), this.element.className = "ace_layer ace_text-layer", e.appendChild(this.element), this.$updateEolChar = this.$updateEolChar.bind(this), this.$lines = new o(this.element);
                }
                r.prototype.$textToken = {
                    text: !0,
                    rparen: !0,
                    lparen: !0
                }, r.prototype.EOF_CHAR = "\xb6", r.prototype.EOL_CHAR_LF = "\xac", r.prototype.EOL_CHAR_CRLF = "\xa4", r.prototype.EOL_CHAR = r.prototype.EOL_CHAR_LF, r.prototype.TAB_CHAR = "\u2014", r.prototype.SPACE_CHAR = "\xb7", r.prototype.$padding = 0, r.prototype.MAX_LINE_LENGTH = 1e4, r.prototype.showInvisibles = !1, r.prototype.showSpaces = !1, r.prototype.showTabs = !1, r.prototype.showEOL = !1, r.prototype.displayIndentGuides = !0, r.prototype.$highlightIndentGuides = !0, r.prototype.$tabStrings = [], r.prototype.destroy = {}, r.prototype.onChangeTabSize = r.prototype.$computeTabString, i.implement(r.prototype, e), t.Text = r;
            }), ace.define("ace/layer/cursor", [
                "require",
                "exports",
                "module",
                "ace/lib/dom"
            ], function(e, t, n) {
                "use strict";
                var c = e("../lib/dom"), e = (i.prototype.$updateOpacity = function(e) {
                    for(var t = this.cursors, n = t.length; n--;)c.setStyle(t[n].style, "opacity", e ? "" : "0");
                }, i.prototype.$startCssAnimation = function() {
                    for(var e = this.cursors, t = e.length; t--;)e[t].style.animationDuration = this.blinkInterval + "ms";
                    this.$isAnimating = !0, setTimeout((function() {
                        this.$isAnimating && c.addCssClass(this.element, "ace_animate-blinking");
                    }).bind(this));
                }, i.prototype.$stopCssAnimation = function() {
                    this.$isAnimating = !1, c.removeCssClass(this.element, "ace_animate-blinking");
                }, i.prototype.setPadding = function(e) {
                    this.$padding = e;
                }, i.prototype.setSession = function(e) {
                    this.session = e;
                }, i.prototype.setBlinking = function(e) {
                    e != this.isBlinking && (this.isBlinking = e, this.restartTimer());
                }, i.prototype.setBlinkInterval = function(e) {
                    e != this.blinkInterval && (this.blinkInterval = e, this.restartTimer());
                }, i.prototype.setSmoothBlinking = function(e) {
                    e != this.smoothBlinking && (this.smoothBlinking = e, c.setCssClass(this.element, "ace_smooth-blinking", e), this.$updateCursors(!0), this.restartTimer());
                }, i.prototype.addCursor = function() {
                    var e = c.createElement("div");
                    return e.className = "ace_cursor", this.element.appendChild(e), this.cursors.push(e), e;
                }, i.prototype.removeCursor = function() {
                    var e;
                    if (1 < this.cursors.length) return (e = this.cursors.pop()).parentNode.removeChild(e), e;
                }, i.prototype.hideCursor = function() {
                    this.isVisible = !1, c.addCssClass(this.element, "ace_hidden-cursors"), this.restartTimer();
                }, i.prototype.showCursor = function() {
                    this.isVisible = !0, c.removeCssClass(this.element, "ace_hidden-cursors"), this.restartTimer();
                }, i.prototype.restartTimer = function() {
                    var e, t = this.$updateCursors;
                    clearInterval(this.intervalId), clearTimeout(this.timeoutId), this.$stopCssAnimation(), this.smoothBlinking && (this.$isSmoothBlinking = !1, c.removeCssClass(this.element, "ace_smooth-blinking")), t(!0), this.isBlinking && this.blinkInterval && this.isVisible ? (this.smoothBlinking && (this.$isSmoothBlinking = !0, setTimeout((function() {
                        this.$isSmoothBlinking && c.addCssClass(this.element, "ace_smooth-blinking");
                    }).bind(this))), c.HAS_CSS_ANIMATION ? this.$startCssAnimation() : (e = (function() {
                        this.timeoutId = setTimeout(function() {
                            t(!1);
                        }, .6 * this.blinkInterval);
                    }).bind(this), this.intervalId = setInterval(function() {
                        t(!0), e();
                    }, this.blinkInterval), e())) : this.$stopCssAnimation();
                }, i.prototype.getPixelPosition = function(e, t) {
                    if (!this.config || !this.session) return {
                        left: 0,
                        top: 0
                    };
                    e = e || this.session.selection.getCursor();
                    var n = this.session.documentToScreenPosition(e);
                    return {
                        left: this.$padding + (this.session.$bidiHandler.isBidiRow(n.row, e.row) ? this.session.$bidiHandler.getPosLeft(n.column) : n.column * this.config.characterWidth),
                        top: (n.row - (t ? this.config.firstRowScreen : 0)) * this.config.lineHeight
                    };
                }, i.prototype.isCursorInView = function(e, t) {
                    return 0 <= e.top && e.top < t.maxHeight;
                }, i.prototype.update = function(e) {
                    this.config = e;
                    for(var t = this.session.$selectionMarkers, n = 0, i = 0, n = 0, o = (t = void 0 !== t && 0 !== t.length ? t : [
                        {
                            cursor: null
                        }
                    ]).length; n < o; n++){
                        var r, s, a = this.getPixelPosition(t[n].cursor, !0);
                        (a.top > e.height + e.offset || a.top < 0) && 1 < n || (s = (r = this.cursors[i++] || this.addCursor()).style, this.drawCursor ? this.drawCursor(r, a, e, t[n], this.session) : this.isCursorInView(a, e) ? (c.setStyle(s, "display", "block"), c.translate(r, a.left, a.top), c.setStyle(s, "width", Math.round(e.characterWidth) + "px"), c.setStyle(s, "height", e.lineHeight + "px")) : c.setStyle(s, "display", "none"));
                    }
                    for(; this.cursors.length > i;)this.removeCursor();
                    var l = this.session.getOverwrite();
                    this.$setOverwrite(l), this.$pixelPos = a, this.restartTimer();
                }, i.prototype.$setOverwrite = function(e) {
                    e != this.overwrite && ((this.overwrite = e) ? c.addCssClass(this.element, "ace_overwrite-cursors") : c.removeCssClass(this.element, "ace_overwrite-cursors"));
                }, i.prototype.destroy = function() {
                    clearInterval(this.intervalId), clearTimeout(this.timeoutId);
                }, i);
                function i(e) {
                    this.element = c.createElement("div"), this.element.className = "ace_layer ace_cursor-layer", e.appendChild(this.element), this.isVisible = !1, this.isBlinking = !0, this.blinkInterval = 1e3, this.smoothBlinking = !1, this.cursors = [], this.cursor = this.addCursor(), c.addCssClass(this.element, "ace_hidden-cursors"), this.$updateCursors = this.$updateOpacity.bind(this);
                }
                e.prototype.$padding = 0, e.prototype.drawCursor = null, t.Cursor = e;
            }), ace.define("ace/scrollbar", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/dom",
                "ace/lib/event",
                "ace/lib/event_emitter"
            ], function(e, t, n) {
                "use strict";
                var i, o = this && this.__extends || (i = function(e, t) {
                    return (i = Object.setPrototypeOf || (({
                        __proto__: []
                    }) instanceof Array ? function(e, t) {
                        e.__proto__ = t;
                    } : function(e, t) {
                        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                    }))(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function n() {
                        this.constructor = e;
                    }
                    i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
                }), r = e("./lib/oop"), s = e("./lib/dom"), a = e("./lib/event"), e = e("./lib/event_emitter").EventEmitter, l = (c.prototype.setVisible = function(e) {
                    this.element.style.display = e ? "" : "none", this.isVisible = e, this.coeff = 1;
                }, c);
                function c(e, t) {
                    this.element = s.createElement("div"), this.element.className = "ace_scrollbar ace_scrollbar" + t, this.inner = s.createElement("div"), this.inner.className = "ace_scrollbar-inner", this.inner.textContent = "\xa0", this.element.appendChild(this.inner), e.appendChild(this.element), this.setVisible(!1), this.skipEvent = !1, a.addListener(this.element, "scroll", this.onScroll.bind(this)), a.addListener(this.element, "mousedown", a.preventDefault);
                }
                r.implement(l.prototype, e);
                o(d, h = l), d.prototype.onScroll = function() {
                    var e;
                    this.skipEvent || (this.scrollTop = this.element.scrollTop, 1 != this.coeff && (e = this.element.clientHeight / this.scrollHeight, this.scrollTop = this.scrollTop * (1 - e) / (this.coeff - e)), this._emit("scroll", {
                        data: this.scrollTop
                    })), this.skipEvent = !1;
                }, d.prototype.getWidth = function() {
                    return Math.max(this.isVisible ? this.width : 0, this.$minWidth || 0);
                }, d.prototype.setHeight = function(e) {
                    this.element.style.height = e + "px";
                }, d.prototype.setScrollHeight = function(e) {
                    32768 < (this.scrollHeight = e) ? (this.coeff = 32768 / e, e = 32768) : 1 != this.coeff && (this.coeff = 1), this.inner.style.height = e + "px";
                }, d.prototype.setScrollTop = function(e) {
                    this.scrollTop != e && (this.skipEvent = !0, this.scrollTop = e, this.element.scrollTop = e * this.coeff);
                };
                var h, r = d;
                function d(e, t) {
                    var n = h.call(this, e, "-v") || this;
                    return n.scrollTop = 0, n.scrollHeight = 0, t.$scrollbarWidth = n.width = s.scrollbarWidth(e.ownerDocument), n.inner.style.width = n.element.style.width = (n.width || 15) + 5 + "px", n.$minWidth = 0, n;
                }
                r.prototype.setInnerHeight = r.prototype.setScrollHeight;
                o(g, u = l), g.prototype.onScroll = function() {
                    this.skipEvent || (this.scrollLeft = this.element.scrollLeft, this._emit("scroll", {
                        data: this.scrollLeft
                    })), this.skipEvent = !1;
                }, g.prototype.getHeight = function() {
                    return this.isVisible ? this.height : 0;
                }, g.prototype.setWidth = function(e) {
                    this.element.style.width = e + "px";
                }, g.prototype.setInnerWidth = function(e) {
                    this.inner.style.width = e + "px";
                }, g.prototype.setScrollWidth = function(e) {
                    this.inner.style.width = e + "px";
                }, g.prototype.setScrollLeft = function(e) {
                    this.scrollLeft != e && (this.skipEvent = !0, this.scrollLeft = this.element.scrollLeft = e);
                };
                var u, e = g;
                function g(e, t) {
                    e = u.call(this, e, "-h") || this;
                    return e.scrollLeft = 0, e.height = t.$scrollbarWidth, e.inner.style.height = e.element.style.height = (e.height || 15) + 5 + "px", e;
                }
                t.ScrollBar = r, t.ScrollBarV = r, t.ScrollBarH = e, t.VScrollBar = r, t.HScrollBar = e;
            }), ace.define("ace/scrollbar_custom", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/dom",
                "ace/lib/event",
                "ace/lib/event_emitter"
            ], function(e, t, n) {
                "use strict";
                var i, o = this && this.__extends || (i = function(e, t) {
                    return (i = Object.setPrototypeOf || (({
                        __proto__: []
                    }) instanceof Array ? function(e, t) {
                        e.__proto__ = t;
                    } : function(e, t) {
                        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                    }))(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function n() {
                        this.constructor = e;
                    }
                    i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
                }), r = e("./lib/oop"), s = e("./lib/dom"), a = e("./lib/event"), e = e("./lib/event_emitter").EventEmitter, l = (s.importCssString(".ace_editor>.ace_sb-v div, .ace_editor>.ace_sb-h div{\n  position: absolute;\n  background: rgba(128, 128, 128, 0.6);\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  border: 1px solid #bbb;\n  border-radius: 2px;\n  z-index: 8;\n}\n.ace_editor>.ace_sb-v, .ace_editor>.ace_sb-h {\n  position: absolute;\n  z-index: 6;\n  background: none;\n  overflow: hidden!important;\n}\n.ace_editor>.ace_sb-v {\n  z-index: 6;\n  right: 0;\n  top: 0;\n  width: 12px;\n}\n.ace_editor>.ace_sb-v div {\n  z-index: 8;\n  right: 0;\n  width: 100%;\n}\n.ace_editor>.ace_sb-h {\n  bottom: 0;\n  left: 0;\n  height: 12px;\n}\n.ace_editor>.ace_sb-h div {\n  bottom: 0;\n  height: 100%;\n}\n.ace_editor>.ace_sb_grabbed {\n  z-index: 8;\n  background: #000;\n}", "ace_scrollbar.css", !1), c.prototype.setVisible = function(e) {
                    this.element.style.display = e ? "" : "none", this.isVisible = e, this.coeff = 1;
                }, c);
                function c(e, t) {
                    this.element = s.createElement("div"), this.element.className = "ace_sb" + t, this.inner = s.createElement("div"), this.inner.className = "", this.element.appendChild(this.inner), this.VScrollWidth = 12, this.HScrollHeight = 12, e.appendChild(this.element), this.setVisible(!1), this.skipEvent = !1, a.addMultiMouseDownListener(this.element, [
                        500,
                        300,
                        300
                    ], this, "onMouseDown");
                }
                r.implement(l.prototype, e);
                o(d, h = l), d.prototype.onMouseDown = function(e, t) {
                    var n, i, o, r, s;
                    if ("mousedown" === e && 0 === a.getButton(t) && 2 !== t.detail) return t.target === this.inner ? (n = this, i = t.clientY, o = t.clientY, r = this.thumbTop, a.capture(this.inner, function(e) {
                        i = e.clientY;
                    }, function() {
                        clearInterval(s);
                    }), s = setInterval(function() {
                        var e;
                        void 0 !== i && (e = n.scrollTopFromThumbTop(r + i - o)) !== n.scrollTop && n._emit("scroll", {
                            data: e
                        });
                    }, 20)) : (e = t.clientY - this.element.getBoundingClientRect().top - this.thumbHeight / 2, this._emit("scroll", {
                        data: this.scrollTopFromThumbTop(e)
                    })), a.preventDefault(t);
                }, d.prototype.getHeight = function() {
                    return this.height;
                }, d.prototype.scrollTopFromThumbTop = function(e) {
                    e = e * (this.pageHeight - this.viewHeight) / (this.slideHeight - this.thumbHeight);
                    return (e >>= 0) < 0 ? e = 0 : e > this.pageHeight - this.viewHeight && (e = this.pageHeight - this.viewHeight), e;
                }, d.prototype.getWidth = function() {
                    return Math.max(this.isVisible ? this.width : 0, this.$minWidth || 0);
                }, d.prototype.setHeight = function(e) {
                    this.height = Math.max(0, e), this.slideHeight = this.height, this.viewHeight = this.height, this.setScrollHeight(this.pageHeight, !0);
                }, d.prototype.setScrollHeight = function(e, t) {
                    (this.pageHeight !== e || t) && (this.pageHeight = e, this.thumbHeight = this.slideHeight * this.viewHeight / this.pageHeight, this.thumbHeight > this.slideHeight && (this.thumbHeight = this.slideHeight), this.thumbHeight < 15 && (this.thumbHeight = 15), this.inner.style.height = this.thumbHeight + "px", this.scrollTop > this.pageHeight - this.viewHeight) && (this.scrollTop = this.pageHeight - this.viewHeight, this.scrollTop < 0 && (this.scrollTop = 0), this._emit("scroll", {
                        data: this.scrollTop
                    }));
                }, d.prototype.setScrollTop = function(e) {
                    this.scrollTop = e, this.thumbTop = (e = e < 0 ? 0 : e) * (this.slideHeight - this.thumbHeight) / (this.pageHeight - this.viewHeight), this.inner.style.top = this.thumbTop + "px";
                };
                var h, r = d;
                function d(e, t) {
                    var n = h.call(this, e, "-v") || this;
                    return n.scrollTop = 0, n.scrollHeight = 0, n.parent = e, n.width = n.VScrollWidth, n.renderer = t, n.inner.style.width = n.element.style.width = (n.width || 15) + "px", n.$minWidth = 0, n;
                }
                r.prototype.setInnerHeight = r.prototype.setScrollHeight;
                o(g, u = l), g.prototype.onMouseDown = function(e, t) {
                    var n, i, o, r, s;
                    if ("mousedown" === e && 0 === a.getButton(t) && 2 !== t.detail) return t.target === this.inner ? (n = this, i = t.clientX, o = t.clientX, r = this.thumbLeft, a.capture(this.inner, function(e) {
                        i = e.clientX;
                    }, function() {
                        clearInterval(s);
                    }), s = setInterval(function() {
                        var e;
                        void 0 !== i && (e = n.scrollLeftFromThumbLeft(r + i - o)) !== n.scrollLeft && n._emit("scroll", {
                            data: e
                        });
                    }, 20)) : (e = t.clientX - this.element.getBoundingClientRect().left - this.thumbWidth / 2, this._emit("scroll", {
                        data: this.scrollLeftFromThumbLeft(e)
                    })), a.preventDefault(t);
                }, g.prototype.getHeight = function() {
                    return this.isVisible ? this.height : 0;
                }, g.prototype.scrollLeftFromThumbLeft = function(e) {
                    e = e * (this.pageWidth - this.viewWidth) / (this.slideWidth - this.thumbWidth);
                    return (e >>= 0) < 0 ? e = 0 : e > this.pageWidth - this.viewWidth && (e = this.pageWidth - this.viewWidth), e;
                }, g.prototype.setWidth = function(e) {
                    this.width = Math.max(0, e), this.element.style.width = this.width + "px", this.slideWidth = this.width, this.viewWidth = this.width, this.setScrollWidth(this.pageWidth, !0);
                }, g.prototype.setScrollWidth = function(e, t) {
                    (this.pageWidth !== e || t) && (this.pageWidth = e, this.thumbWidth = this.slideWidth * this.viewWidth / this.pageWidth, this.thumbWidth > this.slideWidth && (this.thumbWidth = this.slideWidth), this.thumbWidth < 15 && (this.thumbWidth = 15), this.inner.style.width = this.thumbWidth + "px", this.scrollLeft > this.pageWidth - this.viewWidth) && (this.scrollLeft = this.pageWidth - this.viewWidth, this.scrollLeft < 0 && (this.scrollLeft = 0), this._emit("scroll", {
                        data: this.scrollLeft
                    }));
                }, g.prototype.setScrollLeft = function(e) {
                    this.scrollLeft = e, this.thumbLeft = (e = e < 0 ? 0 : e) * (this.slideWidth - this.thumbWidth) / (this.pageWidth - this.viewWidth), this.inner.style.left = this.thumbLeft + "px";
                };
                var u, e = g;
                function g(e, t) {
                    e = u.call(this, e, "-h") || this;
                    return e.scrollLeft = 0, e.scrollWidth = 0, e.height = e.HScrollHeight, e.inner.style.height = e.element.style.height = (e.height || 12) + "px", e.renderer = t, e;
                }
                e.prototype.setInnerWidth = e.prototype.setScrollWidth, t.ScrollBar = r, t.ScrollBarV = r, t.ScrollBarH = e, t.VScrollBar = r, t.HScrollBar = e;
            }), ace.define("ace/renderloop", [
                "require",
                "exports",
                "module",
                "ace/lib/event"
            ], function(e, t, n) {
                "use strict";
                var i = e("./lib/event");
                function o(e, t) {
                    this.onRender = e, this.pending = !1, this.changes = 0, this.$recursionLimit = 2, this.window = t || window;
                    var n = this;
                    this._flush = function(e) {
                        n.pending = !1;
                        var t = n.changes;
                        t && (i.blockIdle(100), n.changes = 0, n.onRender(t)), n.changes ? n.$recursionLimit-- < 0 || n.schedule() : n.$recursionLimit = 2;
                    };
                }
                o.prototype.schedule = function(e) {
                    this.changes = this.changes | e, this.changes && !this.pending && (i.nextFrame(this._flush), this.pending = !0);
                }, o.prototype.clear = function(e) {
                    var t = this.changes;
                    return this.changes = 0, t;
                }, t.RenderLoop = o;
            }), ace.define("ace/layer/font_metrics", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/dom",
                "ace/lib/lang",
                "ace/lib/event",
                "ace/lib/useragent",
                "ace/lib/event_emitter"
            ], function(e, t, n) {
                var i = e("../lib/oop"), o = e("../lib/dom"), r = e("../lib/lang"), s = e("../lib/event"), a = e("../lib/useragent"), e = e("../lib/event_emitter").EventEmitter, l = "function" == typeof ResizeObserver, c = (h.prototype.$setMeasureNodeStyles = function(e, t) {
                    e.width = e.height = "auto", e.left = e.top = "0px", e.visibility = "hidden", e.position = "absolute", e.whiteSpace = "pre", a.isIE < 8 ? e["font-family"] = "inherit" : e.font = "inherit", e.overflow = t ? "hidden" : "visible";
                }, h.prototype.checkForSizeChanges = function(e) {
                    var t;
                    !(e = void 0 === e ? this.$measureSizes() : e) || this.$characterSize.width === e.width && this.$characterSize.height === e.height || (this.$measureNode.style.fontWeight = "bold", t = this.$measureSizes(), this.$measureNode.style.fontWeight = "", this.$characterSize = e, this.charSizes = Object.create(null), this.allowBoldFonts = t && t.width === e.width && t.height === e.height, this._emit("changeCharacterSize", {
                        data: e
                    }));
                }, h.prototype.$addObserver = function() {
                    var t = this;
                    this.$observer = new window.ResizeObserver(function(e) {
                        t.checkForSizeChanges();
                    }), this.$observer.observe(this.$measureNode);
                }, h.prototype.$pollSizeChanges = function() {
                    var t;
                    return this.$pollSizeChangesTimer || this.$observer ? this.$pollSizeChangesTimer : (t = this).$pollSizeChangesTimer = s.onIdle(function e() {
                        t.checkForSizeChanges(), s.onIdle(e, 500);
                    }, 500);
                }, h.prototype.setPolling = function(e) {
                    e ? this.$pollSizeChanges() : this.$pollSizeChangesTimer && (clearInterval(this.$pollSizeChangesTimer), this.$pollSizeChangesTimer = 0);
                }, h.prototype.$measureSizes = function(e) {
                    e = {
                        height: (e || this.$measureNode).clientHeight,
                        width: (e || this.$measureNode).clientWidth / 512
                    };
                    return 0 === e.width || 0 === e.height ? null : e;
                }, h.prototype.$measureCharWidth = function(e) {
                    return this.$main.textContent = r.stringRepeat(e, 512), this.$main.getBoundingClientRect().width / 512;
                }, h.prototype.getCharacterWidth = function(e) {
                    var t = this.charSizes[e];
                    return t = void 0 === t ? this.charSizes[e] = this.$measureCharWidth(e) / this.$characterSize.width : t;
                }, h.prototype.destroy = function() {
                    clearInterval(this.$pollSizeChangesTimer), this.$observer && this.$observer.disconnect(), this.el && this.el.parentNode && this.el.parentNode.removeChild(this.el);
                }, h.prototype.$getZoom = function(e) {
                    return e && e.parentElement ? (window.getComputedStyle(e).zoom || 1) * this.$getZoom(e.parentElement) : 1;
                }, h.prototype.$initTransformMeasureNodes = function() {
                    function e(e, t) {
                        return [
                            "div",
                            {
                                style: "position: absolute;top:" + e + "px;left:" + t + "px;"
                            }
                        ];
                    }
                    this.els = o.buildDom([
                        e(0, 0),
                        e(200, 0),
                        e(0, 200),
                        e(200, 200)
                    ], this.el);
                }, h.prototype.transformCoordinates = function(e, t) {
                    function n(e, t, n) {
                        var i = e[1] * t[0] - e[0] * t[1];
                        return [
                            (-t[1] * n[0] + t[0] * n[1]) / i,
                            (+e[1] * n[0] - e[0] * n[1]) / i
                        ];
                    }
                    function i(e, t) {
                        return [
                            e[0] - t[0],
                            e[1] - t[1]
                        ];
                    }
                    function o(e, t) {
                        return [
                            e[0] + t[0],
                            e[1] + t[1]
                        ];
                    }
                    function r(e, t) {
                        return [
                            e * t[0],
                            e * t[1]
                        ];
                    }
                    function s(e) {
                        e = e.getBoundingClientRect();
                        return [
                            e.left,
                            e.top
                        ];
                    }
                    e = e && r(1 / this.$getZoom(this.el), e), this.els || this.$initTransformMeasureNodes();
                    var a, l = s(this.els[0]), c = s(this.els[1]), h = s(this.els[2]), d = s(this.els[3]), d = n(i(d, c), i(d, h), i(o(c, h), o(d, l))), c = r(1 + d[0], i(c, l)), h = r(1 + d[1], i(h, l));
                    return t ? (a = d[0] * t[0] / 200 + d[1] * t[1] / 200 + 1, t = o(r(t[0], c), r(t[1], h)), o(r(1 / a / 200, t), l)) : (a = i(e, l), t = n(i(c, r(d[0], a)), i(h, r(d[1], a)), a), r(200, t));
                }, h);
                function h(e) {
                    this.el = o.createElement("div"), this.$setMeasureNodeStyles(this.el.style, !0), this.$main = o.createElement("div"), this.$setMeasureNodeStyles(this.$main.style), this.$measureNode = o.createElement("div"), this.$setMeasureNodeStyles(this.$measureNode.style), this.el.appendChild(this.$main), this.el.appendChild(this.$measureNode), e.appendChild(this.el), this.$measureNode.textContent = r.stringRepeat("X", 512), this.$characterSize = {
                        width: 0,
                        height: 0
                    }, l ? this.$addObserver() : this.checkForSizeChanges();
                }
                c.prototype.$characterSize = {
                    width: 0,
                    height: 0
                }, i.implement(c.prototype, e), t.FontMetrics = c;
            }), ace.define("ace/css/editor.css", [
                "require",
                "exports",
                "module"
            ], function(e, t, n) {
                n.exports = '\n.ace_br1 {border-top-left-radius    : 3px;}\n.ace_br2 {border-top-right-radius   : 3px;}\n.ace_br3 {border-top-left-radius    : 3px; border-top-right-radius:    3px;}\n.ace_br4 {border-bottom-right-radius: 3px;}\n.ace_br5 {border-top-left-radius    : 3px; border-bottom-right-radius: 3px;}\n.ace_br6 {border-top-right-radius   : 3px; border-bottom-right-radius: 3px;}\n.ace_br7 {border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px;}\n.ace_br8 {border-bottom-left-radius : 3px;}\n.ace_br9 {border-top-left-radius    : 3px; border-bottom-left-radius:  3px;}\n.ace_br10{border-top-right-radius   : 3px; border-bottom-left-radius:  3px;}\n.ace_br11{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-left-radius:  3px;}\n.ace_br12{border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br13{border-top-left-radius    : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br14{border-top-right-radius   : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br15{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px; border-bottom-left-radius: 3px;}\n\n\n.ace_editor {\n    position: relative;\n    overflow: hidden;\n    padding: 0;\n    font: 12px/normal \'Monaco\', \'Menlo\', \'Ubuntu Mono\', \'Consolas\', \'Source Code Pro\', \'source-code-pro\', monospace;\n    direction: ltr;\n    text-align: left;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.ace_scroller {\n    position: absolute;\n    overflow: hidden;\n    top: 0;\n    bottom: 0;\n    background-color: inherit;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    cursor: text;\n}\n\n.ace_content {\n    position: absolute;\n    box-sizing: border-box;\n    min-width: 100%;\n    contain: style size layout;\n    font-variant-ligatures: no-common-ligatures;\n}\n\n.ace_keyboard-focus:focus {\n    box-shadow: inset 0 0 0 2px #5E9ED6;\n    outline: none;\n}\n\n.ace_dragging .ace_scroller:before{\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    content: \'\';\n    background: rgba(250, 250, 250, 0.01);\n    z-index: 1000;\n}\n.ace_dragging.ace_dark .ace_scroller:before{\n    background: rgba(0, 0, 0, 0.01);\n}\n\n.ace_gutter {\n    position: absolute;\n    overflow : hidden;\n    width: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    cursor: default;\n    z-index: 4;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    contain: style size layout;\n}\n\n.ace_gutter-active-line {\n    position: absolute;\n    left: 0;\n    right: 0;\n}\n\n.ace_scroller.ace_scroll-left:after {\n    content: "";\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    box-shadow: 17px 0 16px -16px rgba(0, 0, 0, 0.4) inset;\n    pointer-events: none;\n}\n\n.ace_gutter-cell, .ace_gutter-cell_svg-icons {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    padding-left: 19px;\n    padding-right: 6px;\n    background-repeat: no-repeat;\n}\n\n.ace_gutter-cell_svg-icons .ace_gutter_annotation {\n    margin-left: -14px;\n    float: left;\n}\n\n.ace_gutter-cell .ace_gutter_annotation {\n    margin-left: -19px;\n    float: left;\n}\n\n.ace_gutter-cell.ace_error, .ace_icon.ace_error, .ace_icon.ace_error_fold {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAABOFBMVEX/////////QRswFAb/Ui4wFAYwFAYwFAaWGAfDRymzOSH/PxswFAb/SiUwFAYwFAbUPRvjQiDllog5HhHdRybsTi3/Tyv9Tir+Syj/UC3////XurebMBIwFAb/RSHbPx/gUzfdwL3kzMivKBAwFAbbvbnhPx66NhowFAYwFAaZJg8wFAaxKBDZurf/RB6mMxb/SCMwFAYwFAbxQB3+RB4wFAb/Qhy4Oh+4QifbNRcwFAYwFAYwFAb/QRzdNhgwFAYwFAbav7v/Uy7oaE68MBK5LxLewr/r2NXewLswFAaxJw4wFAbkPRy2PyYwFAaxKhLm1tMwFAazPiQwFAaUGAb/QBrfOx3bvrv/VC/maE4wFAbRPBq6MRO8Qynew8Dp2tjfwb0wFAbx6eju5+by6uns4uH9/f36+vr/GkHjAAAAYnRSTlMAGt+64rnWu/bo8eAA4InH3+DwoN7j4eLi4xP99Nfg4+b+/u9B/eDs1MD1mO7+4PHg2MXa347g7vDizMLN4eG+Pv7i5evs/v79yu7S3/DV7/498Yv24eH+4ufQ3Ozu/v7+y13sRqwAAADLSURBVHjaZc/XDsFgGIBhtDrshlitmk2IrbHFqL2pvXf/+78DPokj7+Fz9qpU/9UXJIlhmPaTaQ6QPaz0mm+5gwkgovcV6GZzd5JtCQwgsxoHOvJO15kleRLAnMgHFIESUEPmawB9ngmelTtipwwfASilxOLyiV5UVUyVAfbG0cCPHig+GBkzAENHS0AstVF6bacZIOzgLmxsHbt2OecNgJC83JERmePUYq8ARGkJx6XtFsdddBQgZE2nPR6CICZhawjA4Fb/chv+399kfR+MMMDGOQAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n\n.ace_gutter-cell.ace_warning, .ace_icon.ace_warning, .ace_icon.ace_warning_fold {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAmVBMVEX///8AAAD///8AAAAAAABPSzb/5sAAAAB/blH/73z/ulkAAAAAAAD85pkAAAAAAAACAgP/vGz/rkDerGbGrV7/pkQICAf////e0IsAAAD/oED/qTvhrnUAAAD/yHD/njcAAADuv2r/nz//oTj/p064oGf/zHAAAAA9Nir/tFIAAAD/tlTiuWf/tkIAAACynXEAAAAAAAAtIRW7zBpBAAAAM3RSTlMAABR1m7RXO8Ln31Z36zT+neXe5OzooRDfn+TZ4p3h2hTf4t3k3ucyrN1K5+Xaks52Sfs9CXgrAAAAjklEQVR42o3PbQ+CIBQFYEwboPhSYgoYunIqqLn6/z8uYdH8Vmdnu9vz4WwXgN/xTPRD2+sgOcZjsge/whXZgUaYYvT8QnuJaUrjrHUQreGczuEafQCO/SJTufTbroWsPgsllVhq3wJEk2jUSzX3CUEDJC84707djRc5MTAQxoLgupWRwW6UB5fS++NV8AbOZgnsC7BpEAAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n\n.ace_gutter-cell.ace_info, .ace_icon.ace_info {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAAAAAA6mKC9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAJ0Uk5TAAB2k804AAAAPklEQVQY02NgIB68QuO3tiLznjAwpKTgNyDbMegwisCHZUETUZV0ZqOquBpXj2rtnpSJT1AEnnRmL2OgGgAAIKkRQap2htgAAAAASUVORK5CYII=");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n.ace_dark .ace_gutter-cell.ace_info, .ace_dark .ace_icon.ace_info {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAAChoaGAgIAqKiq+vr6tra1ZWVmUlJSbm5s8PDxubm56enrdgzg3AAAAAXRSTlMAQObYZgAAAClJREFUeNpjYMAPdsMYHegyJZFQBlsUlMFVCWUYKkAZMxZAGdxlDMQBAG+TBP4B6RyJAAAAAElFTkSuQmCC");\n}\n\n.ace_icon_svg.ace_error {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJyZWQiIHNoYXBlLXJlbmRlcmluZz0iZ2VvbWV0cmljUHJlY2lzaW9uIj4KPGNpcmNsZSBmaWxsPSJub25lIiBjeD0iOCIgY3k9IjgiIHI9IjciIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGxpbmUgeDE9IjExIiB5MT0iNSIgeDI9IjUiIHkyPSIxMSIvPgo8bGluZSB4MT0iMTEiIHkxPSIxMSIgeDI9IjUiIHkyPSI1Ii8+CjwvZz4KPC9zdmc+");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_warning {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJkYXJrb3JhbmdlIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiI+Cjxwb2x5Z29uIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGZpbGw9Im5vbmUiIHBvaW50cz0iOCAxIDE1IDE1IDEgMTUgOCAxIi8+CjxyZWN0IHg9IjgiIHk9IjEyIiB3aWR0aD0iMC4wMSIgaGVpZ2h0PSIwLjAxIi8+CjxsaW5lIHgxPSI4IiB5MT0iNiIgeDI9IjgiIHkyPSIxMCIvPgo8L2c+Cjwvc3ZnPg==");\n    background-color: darkorange;\n}\n.ace_icon_svg.ace_info {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJibHVlIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiI+CjxjaXJjbGUgZmlsbD0ibm9uZSIgY3g9IjgiIGN5PSI4IiByPSI3IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjxwb2x5bGluZSBwb2ludHM9IjggMTEgOCA4Ii8+Cjxwb2x5bGluZSBwb2ludHM9IjkgOCA2IDgiLz4KPGxpbmUgeDE9IjEwIiB5MT0iMTEiIHgyPSI2IiB5Mj0iMTEiLz4KPHJlY3QgeD0iOCIgeT0iNSIgd2lkdGg9IjAuMDEiIGhlaWdodD0iMC4wMSIvPgo8L2c+Cjwvc3ZnPg==");\n    background-color: royalblue;\n}\n\n.ace_icon_svg.ace_error_fold {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSI+CiAgPHBhdGggZD0ibSAxOC45Mjk4NTEsNy44Mjk4MDc2IGMgMC4xNDYzNTMsNi4zMzc0NjA0IC02LjMyMzE0Nyw3Ljc3Nzg0NDQgLTcuNDc3OTEyLDcuNzc3ODQ0NCAtMi4xMDcyNzI2LC0wLjEyODc1IDUuMTE3Njc4LDAuMzU2MjQ5IDUuMDUxNjk4LC03Ljg3MDA2MTggLTAuNjA0NjcyLC04LjAwMzk3MzQ5IC03LjA3NzI3MDYsLTcuNTYzMTE4OSAtNC44NTczLC03LjQzMDM5NTU2IDEuNjA2LC0wLjExNTE0MjI1IDYuODk3NDg1LDEuMjYyNTQ1OTYgNy4yODM1MTQsNy41MjI2MTI5NiB6IiBmaWxsPSJjcmltc29uIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0ibSA4LjExNDc1NjIsMi4wNTI5ODI4IGMgMy4zNDkxNjk4LDAgNi4wNjQxMzI4LDIuNjc2ODYyNyA2LjA2NDEzMjgsNS45Nzg5NTMgMCwzLjMwMjExMjIgLTIuNzE0OTYzLDUuOTc4OTIwMiAtNi4wNjQxMzI4LDUuOTc4OTIwMiAtMy4zNDkxNDczLDAgLTYuMDY0MTc3MiwtMi42NzY4MDggLTYuMDY0MTc3MiwtNS45Nzg5MjAyIDAuMDA1MzksLTMuMjk5ODg2MSAyLjcxNzI2NTYsLTUuOTczNjQwOCA2LjA2NDE3NzIsLTUuOTc4OTUzIHogbSAwLC0xLjczNTgyNzE5IGMgLTQuMzIxNDgzNiwwIC03LjgyNDc0MDM4LDMuNDU0MDE4NDkgLTcuODI0NzQwMzgsNy43MTQ3ODAxOSAwLDQuMjYwNzI4MiAzLjUwMzI1Njc4LDcuNzE0NzQ1MiA3LjgyNDc0MDM4LDcuNzE0NzQ1MiA0LjMyMTQ0OTgsMCA3LjgyNDY5OTgsLTMuNDU0MDE3IDcuODI0Njk5OCwtNy43MTQ3NDUyIDAsLTIuMDQ2MDkxNCAtMC44MjQzOTIsLTQuMDA4MzY3MiAtMi4yOTE3NTYsLTUuNDU1MTc0NiBDIDEyLjE4MDIyNSwxLjEyOTk2NDggMTAuMTkwMDEzLDAuMzE3MTU1NjEgOC4xMTQ3NTYyLDAuMzE3MTU1NjEgWiBNIDYuOTM3NDU2Myw4LjI0MDU5ODUgNC42NzE4Njg1LDEwLjQ4NTg1MiA2LjAwODY4MTQsMTEuODc2NzI4IDguMzE3MDAzNSw5LjYwMDc5MTEgMTAuNjI1MzM3LDExLjg3NjcyOCAxMS45NjIxMzgsMTAuNDg1ODUyIDkuNjk2NTUwOCw4LjI0MDU5ODUgMTEuOTYyMTM4LDYuMDA2ODA2NiAxMC41NzMyNDYsNC42Mzc0MzM1IDguMzE3MDAzNSw2Ljg3MzQyOTcgNi4wNjA3NjA3LDQuNjM3NDMzNSA0LjY3MTg2ODUsNi4wMDY4MDY2IFoiIGZpbGw9ImNyaW1zb24iIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4=");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_warning_fold {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC43NzY5IDE0LjczMzdMOC42NTE5MiAyLjQ4MzY5QzguMzI5NDYgMS44Mzg3NyA3LjQwOTEzIDEuODM4NzcgNy4wODY2NyAyLjQ4MzY5TDAuOTYxNjY5IDE0LjczMzdDMC42NzA3NzUgMTUuMzE1NSAxLjA5MzgzIDE2IDEuNzQ0MjkgMTZIMTMuOTk0M0MxNC42NDQ4IDE2IDE1LjA2NzggMTUuMzE1NSAxNC43NzY5IDE0LjczMzdaTTMuMTYwMDcgMTQuMjVMNy44NjkyOSA0LjgzMTU2TDEyLjU3ODUgMTQuMjVIMy4xNjAwN1pNOC43NDQyOSAxMS42MjVWMTMuMzc1SDYuOTk0MjlWMTEuNjI1SDguNzQ0MjlaTTYuOTk0MjkgMTAuNzVWNy4yNUg4Ljc0NDI5VjEwLjc1SDYuOTk0MjlaIiBmaWxsPSIjRUM3MjExIi8+CjxwYXRoIGQ9Ik0xMS4xOTkxIDIuOTUyMzhDMTAuODgwOSAyLjMxNDY3IDEwLjM1MzcgMS44MDUyNiA5LjcwNTUgMS41MDlMMTEuMDQxIDEuMDY5NzhDMTEuNjg4MyAwLjk0OTgxNCAxMi4zMzcgMS4yNzI2MyAxMi42MzE3IDEuODYxNDFMMTcuNjEzNiAxMS44MTYxQzE4LjM1MjcgMTMuMjkyOSAxNy41OTM4IDE1LjA4MDQgMTYuMDE4IDE1LjU3NDVDMTYuNDA0NCAxNC40NTA3IDE2LjMyMzEgMTMuMjE4OCAxNS43OTI0IDEyLjE1NTVMMTEuMTk5MSAyLjk1MjM4WiIgZmlsbD0iI0VDNzIxMSIvPgo8L3N2Zz4=");\n    background-color: darkorange;\n}\n\n.ace_scrollbar {\n    contain: strict;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    z-index: 6;\n}\n\n.ace_scrollbar-inner {\n    position: absolute;\n    cursor: text;\n    left: 0;\n    top: 0;\n}\n\n.ace_scrollbar-v{\n    overflow-x: hidden;\n    overflow-y: scroll;\n    top: 0;\n}\n\n.ace_scrollbar-h {\n    overflow-x: scroll;\n    overflow-y: hidden;\n    left: 0;\n}\n\n.ace_print-margin {\n    position: absolute;\n    height: 100%;\n}\n\n.ace_text-input {\n    position: absolute;\n    z-index: 0;\n    width: 0.5em;\n    height: 1em;\n    opacity: 0;\n    background: transparent;\n    -moz-appearance: none;\n    appearance: none;\n    border: none;\n    resize: none;\n    outline: none;\n    overflow: hidden;\n    font: inherit;\n    padding: 0 1px;\n    margin: 0 -1px;\n    contain: strict;\n    -ms-user-select: text;\n    -moz-user-select: text;\n    -webkit-user-select: text;\n    user-select: text;\n    /*with `pre-line` chrome inserts &nbsp; instead of space*/\n    white-space: pre!important;\n}\n.ace_text-input.ace_composition {\n    background: transparent;\n    color: inherit;\n    z-index: 1000;\n    opacity: 1;\n}\n.ace_composition_placeholder { color: transparent }\n.ace_composition_marker { \n    border-bottom: 1px solid;\n    position: absolute;\n    border-radius: 0;\n    margin-top: 1px;\n}\n\n[ace_nocontext=true] {\n    transform: none!important;\n    filter: none!important;\n    clip-path: none!important;\n    mask : none!important;\n    contain: none!important;\n    perspective: none!important;\n    mix-blend-mode: initial!important;\n    z-index: auto;\n}\n\n.ace_layer {\n    z-index: 1;\n    position: absolute;\n    overflow: hidden;\n    /* workaround for chrome bug https://github.com/ajaxorg/ace/issues/2312*/\n    word-wrap: normal;\n    white-space: pre;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    /* setting pointer-events: auto; on node under the mouse, which changes\n        during scroll, will break mouse wheel scrolling in Safari */\n    pointer-events: none;\n}\n\n.ace_gutter-layer {\n    position: relative;\n    width: auto;\n    text-align: right;\n    pointer-events: auto;\n    height: 1000000px;\n    contain: style size layout;\n}\n\n.ace_text-layer {\n    font: inherit !important;\n    position: absolute;\n    height: 1000000px;\n    width: 1000000px;\n    contain: style size layout;\n}\n\n.ace_text-layer > .ace_line, .ace_text-layer > .ace_line_group {\n    contain: style size layout;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n}\n\n.ace_hidpi .ace_text-layer,\n.ace_hidpi .ace_gutter-layer,\n.ace_hidpi .ace_content,\n.ace_hidpi .ace_gutter {\n    contain: strict;\n}\n.ace_hidpi .ace_text-layer > .ace_line, \n.ace_hidpi .ace_text-layer > .ace_line_group {\n    contain: strict;\n}\n\n.ace_cjk {\n    display: inline-block;\n    text-align: center;\n}\n\n.ace_cursor-layer {\n    z-index: 4;\n}\n\n.ace_cursor {\n    z-index: 4;\n    position: absolute;\n    box-sizing: border-box;\n    border-left: 2px solid;\n    /* workaround for smooth cursor repaintng whole screen in chrome */\n    transform: translatez(0);\n}\n\n.ace_multiselect .ace_cursor {\n    border-left-width: 1px;\n}\n\n.ace_slim-cursors .ace_cursor {\n    border-left-width: 1px;\n}\n\n.ace_overwrite-cursors .ace_cursor {\n    border-left-width: 0;\n    border-bottom: 1px solid;\n}\n\n.ace_hidden-cursors .ace_cursor {\n    opacity: 0.2;\n}\n\n.ace_hasPlaceholder .ace_hidden-cursors .ace_cursor {\n    opacity: 0;\n}\n\n.ace_smooth-blinking .ace_cursor {\n    transition: opacity 0.18s;\n}\n\n.ace_animate-blinking .ace_cursor {\n    animation-duration: 1000ms;\n    animation-timing-function: step-end;\n    animation-name: blink-ace-animate;\n    animation-iteration-count: infinite;\n}\n\n.ace_animate-blinking.ace_smooth-blinking .ace_cursor {\n    animation-duration: 1000ms;\n    animation-timing-function: ease-in-out;\n    animation-name: blink-ace-animate-smooth;\n}\n    \n@keyframes blink-ace-animate {\n    from, to { opacity: 1; }\n    60% { opacity: 0; }\n}\n\n@keyframes blink-ace-animate-smooth {\n    from, to { opacity: 1; }\n    45% { opacity: 1; }\n    60% { opacity: 0; }\n    85% { opacity: 0; }\n}\n\n.ace_marker-layer .ace_step, .ace_marker-layer .ace_stack {\n    position: absolute;\n    z-index: 3;\n}\n\n.ace_marker-layer .ace_selection {\n    position: absolute;\n    z-index: 5;\n}\n\n.ace_marker-layer .ace_bracket {\n    position: absolute;\n    z-index: 6;\n}\n\n.ace_marker-layer .ace_error_bracket {\n    position: absolute;\n    border-bottom: 1px solid #DE5555;\n    border-radius: 0;\n}\n\n.ace_marker-layer .ace_active-line {\n    position: absolute;\n    z-index: 2;\n}\n\n.ace_marker-layer .ace_selected-word {\n    position: absolute;\n    z-index: 4;\n    box-sizing: border-box;\n}\n\n.ace_line .ace_fold {\n    box-sizing: border-box;\n\n    display: inline-block;\n    height: 11px;\n    margin-top: -2px;\n    vertical-align: middle;\n\n    background-image:\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACJJREFUeNpi+P//fxgTAwPDBxDxD078RSX+YeEyDFMCIMAAI3INmXiwf2YAAAAASUVORK5CYII=");\n    background-repeat: no-repeat, repeat-x;\n    background-position: center center, top left;\n    color: transparent;\n\n    border: 1px solid black;\n    border-radius: 2px;\n\n    cursor: pointer;\n    pointer-events: auto;\n}\n\n.ace_dark .ace_fold {\n}\n\n.ace_fold:hover{\n    background-image:\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACBJREFUeNpi+P//fz4TAwPDZxDxD5X4i5fLMEwJgAADAEPVDbjNw87ZAAAAAElFTkSuQmCC");\n}\n\n.ace_tooltip {\n    background-color: #f5f5f5;\n    border: 1px solid gray;\n    border-radius: 1px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n    color: black;\n    max-width: 100%;\n    padding: 3px 4px;\n    position: fixed;\n    z-index: 999999;\n    box-sizing: border-box;\n    cursor: default;\n    white-space: pre;\n    word-wrap: break-word;\n    line-height: normal;\n    font-style: normal;\n    font-weight: normal;\n    letter-spacing: normal;\n    pointer-events: none;\n}\n\n.ace_tooltip.ace_dark {\n    background-color: #636363;\n    color: #fff;\n}\n\n.ace_tooltip:focus {\n    outline: 1px solid #5E9ED6;\n}\n\n.ace_icon {\n    display: inline-block;\n    width: 18px;\n    vertical-align: top;\n}\n\n.ace_icon_svg {\n    display: inline-block;\n    width: 12px;\n    vertical-align: top;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-size: 12px;\n    -webkit-mask-position: center;\n}\n\n.ace_folding-enabled > .ace_gutter-cell, .ace_folding-enabled > .ace_gutter-cell_svg-icons {\n    padding-right: 13px;\n}\n\n.ace_fold-widget {\n    box-sizing: border-box;\n\n    margin: 0 -12px 0 1px;\n    display: none;\n    width: 11px;\n    vertical-align: top;\n\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42mWKsQ0AMAzC8ixLlrzQjzmBiEjp0A6WwBCSPgKAXoLkqSot7nN3yMwR7pZ32NzpKkVoDBUxKAAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: center;\n\n    border-radius: 3px;\n    \n    border: 1px solid transparent;\n    cursor: pointer;\n}\n\n.ace_folding-enabled .ace_fold-widget {\n    display: inline-block;   \n}\n\n.ace_fold-widget.ace_end {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42m3HwQkAMAhD0YzsRchFKI7sAikeWkrxwScEB0nh5e7KTPWimZki4tYfVbX+MNl4pyZXejUO1QAAAABJRU5ErkJggg==");\n}\n\n.ace_fold-widget.ace_closed {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAAOUlEQVR42jXKwQkAMAgDwKwqKD4EwQ26sSOkVWjgIIHAzPiCgaqiqnJHZnKICBERHN194O5b9vbLuAVRL+l0YWnZAAAAAElFTkSuQmCCXA==");\n}\n\n.ace_fold-widget:hover {\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: rgba(255, 255, 255, 0.2);\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);\n}\n\n.ace_fold-widget:active {\n    border: 1px solid rgba(0, 0, 0, 0.4);\n    background-color: rgba(0, 0, 0, 0.05);\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.8);\n}\n/**\n * Dark version for fold widgets\n */\n.ace_dark .ace_fold-widget {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHklEQVQIW2P4//8/AzoGEQ7oGCaLLAhWiSwB146BAQCSTPYocqT0AAAAAElFTkSuQmCC");\n}\n.ace_dark .ace_fold-widget.ace_end {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAH0lEQVQIW2P4//8/AxQ7wNjIAjDMgC4AxjCVKBirIAAF0kz2rlhxpAAAAABJRU5ErkJggg==");\n}\n.ace_dark .ace_fold-widget.ace_closed {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAAHElEQVQIW2P4//+/AxAzgDADlOOAznHAKgPWAwARji8UIDTfQQAAAABJRU5ErkJggg==");\n}\n.ace_dark .ace_fold-widget:hover {\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\n    background-color: rgba(255, 255, 255, 0.1);\n}\n.ace_dark .ace_fold-widget:active {\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\n}\n\n.ace_inline_button {\n    border: 1px solid lightgray;\n    display: inline-block;\n    margin: -1px 8px;\n    padding: 0 5px;\n    pointer-events: auto;\n    cursor: pointer;\n}\n.ace_inline_button:hover {\n    border-color: gray;\n    background: rgba(200,200,200,0.2);\n    display: inline-block;\n    pointer-events: auto;\n}\n\n.ace_fold-widget.ace_invalid {\n    background-color: #FFB4B4;\n    border-color: #DE5555;\n}\n\n.ace_fade-fold-widgets .ace_fold-widget {\n    transition: opacity 0.4s ease 0.05s;\n    opacity: 0;\n}\n\n.ace_fade-fold-widgets:hover .ace_fold-widget {\n    transition: opacity 0.05s ease 0.05s;\n    opacity:1;\n}\n\n.ace_underline {\n    text-decoration: underline;\n}\n\n.ace_bold {\n    font-weight: bold;\n}\n\n.ace_nobold .ace_bold {\n    font-weight: normal;\n}\n\n.ace_italic {\n    font-style: italic;\n}\n\n\n.ace_error-marker {\n    background-color: rgba(255, 0, 0,0.2);\n    position: absolute;\n    z-index: 9;\n}\n\n.ace_highlight-marker {\n    background-color: rgba(255, 255, 0,0.2);\n    position: absolute;\n    z-index: 8;\n}\n\n.ace_mobile-menu {\n    position: absolute;\n    line-height: 1.5;\n    border-radius: 4px;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    background: white;\n    box-shadow: 1px 3px 2px grey;\n    border: 1px solid #dcdcdc;\n    color: black;\n}\n.ace_dark > .ace_mobile-menu {\n    background: #333;\n    color: #ccc;\n    box-shadow: 1px 3px 2px grey;\n    border: 1px solid #444;\n\n}\n.ace_mobile-button {\n    padding: 2px;\n    cursor: pointer;\n    overflow: hidden;\n}\n.ace_mobile-button:hover {\n    background-color: #eee;\n    opacity:1;\n}\n.ace_mobile-button:active {\n    background-color: #ddd;\n}\n\n.ace_placeholder {\n    font-family: arial;\n    transform: scale(0.9);\n    transform-origin: left;\n    white-space: pre;\n    opacity: 0.7;\n    margin: 0 10px;\n}\n\n.ace_ghost_text {\n    opacity: 0.5;\n    font-style: italic;\n    white-space: pre;\n}';
            }), ace.define("ace/layer/decorators", [
                "require",
                "exports",
                "module",
                "ace/lib/dom",
                "ace/lib/oop",
                "ace/lib/event_emitter"
            ], function(e, t, n) {
                "use strict";
                var i = e("../lib/dom"), o = e("../lib/oop"), e = e("../lib/event_emitter").EventEmitter, r = (s.prototype.$updateDecorators = function(e) {
                    var t = !0 === this.renderer.theme.isDark ? this.colors.dark : this.colors.light, n = (e && (this.maxHeight = e.maxHeight, this.lineHeight = e.lineHeight, this.canvasHeight = e.height, (e.lastRow + 1) * this.lineHeight < this.canvasHeight ? this.heightRatio = 1 : this.heightRatio = this.canvasHeight / this.maxHeight), this.canvas.getContext("2d"));
                    var i = this.renderer.session.$annotations;
                    if (n.clearRect(0, 0, this.canvas.width, this.canvas.height), i) for(var o = {
                        info: 1,
                        warning: 2,
                        error: 3
                    }, r = (i.forEach(function(e) {
                        e.priority = o[e.type] || null;
                    }), i = i.sort(function(e, t) {
                        return e.priority < t.priority ? -1 : e.priority > t.priority ? 1 : 0;
                    }), this.renderer.session.$foldData), s = 0; s < i.length; s++){
                        var a, l = i[s].row, c = this.compensateFoldRows(l, r), h = Math.round((l - c) * this.lineHeight * this.heightRatio), d = Math.round((l - c) * this.lineHeight * this.heightRatio), l = Math.round(((l - c) * this.lineHeight + this.lineHeight) * this.heightRatio);
                        l - d < this.minDecorationHeight && ((a = (d + l) / 2 | 0) < this.halfMinDecorationHeight ? a = this.halfMinDecorationHeight : a + this.halfMinDecorationHeight > this.canvasHeight && (a = this.canvasHeight - this.halfMinDecorationHeight), d = Math.round(a - this.halfMinDecorationHeight), l = Math.round(a + this.halfMinDecorationHeight)), n.fillStyle = t[i[s].type] || null, n.fillRect(0, h, this.canvasWidth, l - d);
                    }
                    e = this.renderer.session.selection.getCursor();
                    e && (c = this.compensateFoldRows(e.row, r), h = Math.round((e.row - c) * this.lineHeight * this.heightRatio), n.fillStyle = "rgba(0, 0, 0, 0.5)", n.fillRect(0, h, this.canvasWidth, 2));
                }, s.prototype.compensateFoldRows = function(e, t) {
                    var n = 0;
                    if (t && 0 < t.length) for(var i = 0; i < t.length; i++)e > t[i].start.row && e < t[i].end.row ? n += e - t[i].start.row : e >= t[i].end.row && (n += t[i].end.row - t[i].start.row);
                    return n;
                }, s);
                function s(e, t) {
                    this.canvas = i.createElement("canvas"), this.renderer = t, this.pixelRatio = 1, this.maxHeight = t.layerConfig.maxHeight, this.lineHeight = t.layerConfig.lineHeight, this.canvasHeight = e.parent.scrollHeight, this.heightRatio = this.canvasHeight / this.maxHeight, this.canvasWidth = e.width, this.minDecorationHeight = 2 * this.pixelRatio | 0, this.halfMinDecorationHeight = this.minDecorationHeight / 2 | 0, this.canvas.width = this.canvasWidth, this.canvas.height = this.canvasHeight, this.canvas.style.top = "0px", this.canvas.style.right = "0px", this.canvas.style.zIndex = "7px", this.canvas.style.position = "absolute", this.colors = {}, this.colors.dark = {
                        error: "rgba(255, 18, 18, 1)",
                        warning: "rgba(18, 136, 18, 1)",
                        info: "rgba(18, 18, 136, 1)"
                    }, this.colors.light = {
                        error: "rgb(255,51,51)",
                        warning: "rgb(32,133,72)",
                        info: "rgb(35,68,138)"
                    }, e.element.appendChild(this.canvas);
                }
                o.implement(r.prototype, e), t.Decorator = r;
            }), ace.define("ace/virtual_renderer", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/dom",
                "ace/lib/lang",
                "ace/config",
                "ace/layer/gutter",
                "ace/layer/marker",
                "ace/layer/text",
                "ace/layer/cursor",
                "ace/scrollbar",
                "ace/scrollbar",
                "ace/scrollbar_custom",
                "ace/scrollbar_custom",
                "ace/renderloop",
                "ace/layer/font_metrics",
                "ace/lib/event_emitter",
                "ace/css/editor.css",
                "ace/layer/decorators",
                "ace/lib/useragent"
            ], function(e, t, n) {
                "use strict";
                var i = e("./lib/oop"), a = e("./lib/dom"), o = e("./lib/lang"), r = e("./config"), s = e("./layer/gutter").Gutter, l = e("./layer/marker").Marker, c = e("./layer/text").Text, h = e("./layer/cursor").Cursor, d = e("./scrollbar").HScrollBar, u = e("./scrollbar").VScrollBar, g = e("./scrollbar_custom").HScrollBar, p = e("./scrollbar_custom").VScrollBar, m = e("./renderloop").RenderLoop, f = e("./layer/font_metrics").FontMetrics, C = e("./lib/event_emitter").EventEmitter, y = e("./css/editor.css"), v = e("./layer/decorators").Decorator, I = e("./lib/useragent"), e = (a.importCssString(y, "ace_editor.css", !1), b.prototype.updateCharacterSize = function() {
                    this.$textLayer.allowBoldFonts != this.$allowBoldFonts && (this.$allowBoldFonts = this.$textLayer.allowBoldFonts, this.setStyle("ace_nobold", !this.$allowBoldFonts)), this.layerConfig.characterWidth = this.characterWidth = this.$textLayer.getCharacterWidth(), this.layerConfig.lineHeight = this.lineHeight = this.$textLayer.getLineHeight(), this.$updatePrintMargin(), a.setStyle(this.scroller.style, "line-height", this.lineHeight + "px");
                }, b.prototype.setSession = function(e) {
                    this.session && this.session.doc.off("changeNewLineMode", this.onChangeNewLineMode), (this.session = e) && this.scrollMargin.top && e.getScrollTop() <= 0 && e.setScrollTop(-this.scrollMargin.top), this.$cursorLayer.setSession(e), this.$markerBack.setSession(e), this.$markerFront.setSession(e), this.$gutterLayer.setSession(e), this.$textLayer.setSession(e), e && (this.$loop.schedule(this.CHANGE_FULL), this.session.$setFontMetrics(this.$fontMetrics), this.scrollBarH.scrollLeft = this.scrollBarV.scrollTop = null, this.onChangeNewLineMode = this.onChangeNewLineMode.bind(this), this.onChangeNewLineMode(), this.session.doc.on("changeNewLineMode", this.onChangeNewLineMode));
                }, b.prototype.updateLines = function(e, t, n) {
                    if (void 0 === t && (t = 1 / 0), this.$changedLines ? (this.$changedLines.firstRow > e && (this.$changedLines.firstRow = e), this.$changedLines.lastRow < t && (this.$changedLines.lastRow = t)) : this.$changedLines = {
                        firstRow: e,
                        lastRow: t
                    }, this.$changedLines.lastRow < this.layerConfig.firstRow) {
                        if (!n) return;
                        this.$changedLines.lastRow = this.layerConfig.lastRow;
                    }
                    this.$changedLines.firstRow > this.layerConfig.lastRow || this.$loop.schedule(this.CHANGE_LINES);
                }, b.prototype.onChangeNewLineMode = function() {
                    this.$loop.schedule(this.CHANGE_TEXT), this.$textLayer.$updateEolChar(), this.session.$bidiHandler.setEolChar(this.$textLayer.EOL_CHAR);
                }, b.prototype.onChangeTabSize = function() {
                    this.$loop.schedule(this.CHANGE_TEXT | this.CHANGE_MARKER), this.$textLayer.onChangeTabSize();
                }, b.prototype.updateText = function() {
                    this.$loop.schedule(this.CHANGE_TEXT);
                }, b.prototype.updateFull = function(e) {
                    e ? this.$renderChanges(this.CHANGE_FULL, !0) : this.$loop.schedule(this.CHANGE_FULL);
                }, b.prototype.updateFontSize = function() {
                    this.$textLayer.checkForSizeChanges();
                }, b.prototype.$updateSizeAsync = function() {
                    this.$loop.pending ? this.$size.$dirty = !0 : this.onResize();
                }, b.prototype.onResize = function(e, t, n, i) {
                    if (!(2 < this.resizing)) {
                        0 < this.resizing ? this.resizing++ : this.resizing = e ? 1 : 0;
                        var o = this.container, o = (i = i || o.clientHeight || o.scrollHeight, n = n || o.clientWidth || o.scrollWidth, this.$updateCachedSize(e, t, n, i));
                        if (this.$resizeTimer && this.$resizeTimer.cancel(), !this.$size.scrollerHeight || !n && !i) return this.resizing = 0;
                        e && (this.$gutterLayer.$padding = null), e ? this.$renderChanges(o | this.$changes, !0) : this.$loop.schedule(o | this.$changes), this.resizing && (this.resizing = 0), this.scrollBarH.scrollLeft = this.scrollBarV.scrollTop = null, this.$customScrollbar && this.$updateCustomScrollbar(!0);
                    }
                }, b.prototype.$updateCachedSize = function(e, t, n, i) {
                    i -= this.$extraHeight || 0;
                    var o = 0, r = this.$size, s = {
                        width: r.width,
                        height: r.height,
                        scrollerHeight: r.scrollerHeight,
                        scrollerWidth: r.scrollerWidth
                    };
                    return i && (e || r.height != i) && (r.height = i, o |= this.CHANGE_SIZE, r.scrollerHeight = r.height, this.$horizScroll && (r.scrollerHeight -= this.scrollBarH.getHeight()), this.scrollBarV.setHeight(r.scrollerHeight), this.scrollBarV.element.style.bottom = this.scrollBarH.getHeight() + "px", o |= this.CHANGE_SCROLL), n && (e || r.width != n) && (o |= this.CHANGE_SIZE, r.width = n, null == t && (t = this.$showGutter ? this.$gutter.offsetWidth : 0), this.gutterWidth = t, a.setStyle(this.scrollBarH.element.style, "left", t + "px"), a.setStyle(this.scroller.style, "left", t + this.margin.left + "px"), r.scrollerWidth = Math.max(0, n - t - this.scrollBarV.getWidth() - this.margin.h), a.setStyle(this.$gutter.style, "left", this.margin.left + "px"), t = this.scrollBarV.getWidth() + "px", a.setStyle(this.scrollBarH.element.style, "right", t), a.setStyle(this.scroller.style, "right", t), a.setStyle(this.scroller.style, "bottom", this.scrollBarH.getHeight()), this.scrollBarH.setWidth(r.scrollerWidth), this.session && this.session.getUseWrapMode() && this.adjustWrapLimit() || e) && (o |= this.CHANGE_FULL), r.$dirty = !n || !i, o && this._signal("resize", s), o;
                }, b.prototype.onGutterResize = function(e) {
                    e = this.$showGutter ? e : 0;
                    e != this.gutterWidth && (this.$changes |= this.$updateCachedSize(!0, e, this.$size.width, this.$size.height)), this.session.getUseWrapMode() && this.adjustWrapLimit() || this.$size.$dirty ? this.$loop.schedule(this.CHANGE_FULL) : this.$computeLayerConfig();
                }, b.prototype.adjustWrapLimit = function() {
                    var e = this.$size.scrollerWidth - 2 * this.$padding, e = Math.floor(e / this.characterWidth);
                    return this.session.adjustWrapLimit(e, this.$showPrintMargin && this.$printMarginColumn);
                }, b.prototype.setAnimatedScroll = function(e) {
                    this.setOption("animatedScroll", e);
                }, b.prototype.getAnimatedScroll = function() {
                    return this.$animatedScroll;
                }, b.prototype.setShowInvisibles = function(e) {
                    this.setOption("showInvisibles", e), this.session.$bidiHandler.setShowInvisibles(e);
                }, b.prototype.getShowInvisibles = function() {
                    return this.getOption("showInvisibles");
                }, b.prototype.getDisplayIndentGuide = function() {
                    return this.getOption("displayIndentGuides");
                }, b.prototype.setDisplayIndentGuides = function(e) {
                    this.setOption("displayIndentGuides", e);
                }, b.prototype.getHighlightIndentGuides = function() {
                    return this.getOption("highlightIndentGuides");
                }, b.prototype.setHighlightIndentGuides = function(e) {
                    this.setOption("highlightIndentGuides", e);
                }, b.prototype.setShowPrintMargin = function(e) {
                    this.setOption("showPrintMargin", e);
                }, b.prototype.getShowPrintMargin = function() {
                    return this.getOption("showPrintMargin");
                }, b.prototype.setPrintMarginColumn = function(e) {
                    this.setOption("printMarginColumn", e);
                }, b.prototype.getPrintMarginColumn = function() {
                    return this.getOption("printMarginColumn");
                }, b.prototype.getShowGutter = function() {
                    return this.getOption("showGutter");
                }, b.prototype.setShowGutter = function(e) {
                    return this.setOption("showGutter", e);
                }, b.prototype.getFadeFoldWidgets = function() {
                    return this.getOption("fadeFoldWidgets");
                }, b.prototype.setFadeFoldWidgets = function(e) {
                    this.setOption("fadeFoldWidgets", e);
                }, b.prototype.setHighlightGutterLine = function(e) {
                    this.setOption("highlightGutterLine", e);
                }, b.prototype.getHighlightGutterLine = function() {
                    return this.getOption("highlightGutterLine");
                }, b.prototype.$updatePrintMargin = function() {
                    var e;
                    (this.$showPrintMargin || this.$printMarginEl) && (this.$printMarginEl || ((e = a.createElement("div")).className = "ace_layer ace_print-margin-layer", this.$printMarginEl = a.createElement("div"), this.$printMarginEl.className = "ace_print-margin", e.appendChild(this.$printMarginEl), this.content.insertBefore(e, this.content.firstChild)), (e = this.$printMarginEl.style).left = Math.round(this.characterWidth * this.$printMarginColumn + this.$padding) + "px", e.visibility = this.$showPrintMargin ? "visible" : "hidden", this.session) && -1 == this.session.$wrap && this.adjustWrapLimit();
                }, b.prototype.getContainerElement = function() {
                    return this.container;
                }, b.prototype.getMouseEventTarget = function() {
                    return this.scroller;
                }, b.prototype.getTextAreaContainer = function() {
                    return this.container;
                }, b.prototype.$moveTextAreaToCursor = function() {
                    var e, t, n, i, o, r, s;
                    this.$isMousePressed || (e = this.textarea.style, r = this.$composition, this.$keepTextAreaAtCursor || r ? (n = this.$cursorLayer.$pixelPos) && (r && r.markerRange && (n = this.$cursorLayer.getPixelPosition(r.markerRange.start, !0)), s = this.layerConfig, t = n.top, n = n.left, t -= s.offset, i = r && r.useTextareaForIME || I.isMobile ? this.lineHeight : 1, t < 0 || t > s.height - i ? a.translate(this.textarea, 0, 0) : (s = 1, o = this.$size.height - i, r ? r.useTextareaForIME ? (r = this.textarea.value, s = this.characterWidth * this.session.$getStringScreenWidth(r)[0]) : t += this.lineHeight + 2 : t += this.lineHeight, (n -= this.scrollLeft) > this.$size.scrollerWidth - s && (n = this.$size.scrollerWidth - s), n += this.gutterWidth + this.margin.left, a.setStyle(e, "height", i + "px"), a.setStyle(e, "width", s + "px"), a.translate(this.textarea, Math.min(n, this.$size.scrollerWidth - s), Math.min(t, o)))) : a.translate(this.textarea, -100, 0));
                }, b.prototype.getFirstVisibleRow = function() {
                    return this.layerConfig.firstRow;
                }, b.prototype.getFirstFullyVisibleRow = function() {
                    return this.layerConfig.firstRow + (0 === this.layerConfig.offset ? 0 : 1);
                }, b.prototype.getLastFullyVisibleRow = function() {
                    var e = this.layerConfig, t = e.lastRow;
                    return this.session.documentToScreenRow(t, 0) * e.lineHeight - this.session.getScrollTop() > e.height - e.lineHeight ? t - 1 : t;
                }, b.prototype.getLastVisibleRow = function() {
                    return this.layerConfig.lastRow;
                }, b.prototype.setPadding = function(e) {
                    this.$padding = e, this.$textLayer.setPadding(e), this.$cursorLayer.setPadding(e), this.$markerFront.setPadding(e), this.$markerBack.setPadding(e), this.$loop.schedule(this.CHANGE_FULL), this.$updatePrintMargin();
                }, b.prototype.setScrollMargin = function(e, t, n, i) {
                    var o = this.scrollMargin;
                    o.top = 0 | e, o.bottom = 0 | t, o.right = 0 | i, o.left = 0 | n, o.v = o.top + o.bottom, o.h = o.left + o.right, o.top && this.scrollTop <= 0 && this.session && this.session.setScrollTop(-o.top), this.updateFull();
                }, b.prototype.setMargin = function(e, t, n, i) {
                    var o = this.margin;
                    o.top = 0 | e, o.bottom = 0 | t, o.right = 0 | i, o.left = 0 | n, o.v = o.top + o.bottom, o.h = o.left + o.right, this.$updateCachedSize(!0, this.gutterWidth, this.$size.width, this.$size.height), this.updateFull();
                }, b.prototype.getHScrollBarAlwaysVisible = function() {
                    return this.$hScrollBarAlwaysVisible;
                }, b.prototype.setHScrollBarAlwaysVisible = function(e) {
                    this.setOption("hScrollBarAlwaysVisible", e);
                }, b.prototype.getVScrollBarAlwaysVisible = function() {
                    return this.$vScrollBarAlwaysVisible;
                }, b.prototype.setVScrollBarAlwaysVisible = function(e) {
                    this.setOption("vScrollBarAlwaysVisible", e);
                }, b.prototype.$updateScrollBarV = function() {
                    var e = this.layerConfig.maxHeight, t = this.$size.scrollerHeight;
                    !this.$maxLines && this.$scrollPastEnd && (e -= (t - this.lineHeight) * this.$scrollPastEnd, this.scrollTop > e - t) && (e = this.scrollTop + t, this.scrollBarV.scrollTop = null), this.scrollBarV.setScrollHeight(e + this.scrollMargin.v), this.scrollBarV.setScrollTop(this.scrollTop + this.scrollMargin.top);
                }, b.prototype.$updateScrollBarH = function() {
                    this.scrollBarH.setScrollWidth(this.layerConfig.width + 2 * this.$padding + this.scrollMargin.h), this.scrollBarH.setScrollLeft(this.scrollLeft + this.scrollMargin.left);
                }, b.prototype.freeze = function() {
                    this.$frozen = !0;
                }, b.prototype.unfreeze = function() {
                    this.$frozen = !1;
                }, b.prototype.$renderChanges = function(e, t) {
                    if (this.$changes && (e |= this.$changes, this.$changes = 0), this.session && this.container.offsetWidth && !this.$frozen && (e || t)) {
                        if (this.$size.$dirty) return this.$changes |= e, this.onResize(!0);
                        this.lineHeight || this.$textLayer.checkForSizeChanges(), this._signal("beforeRender", e), this.session && this.session.$bidiHandler && this.session.$bidiHandler.updateCharacterWidths(this.$fontMetrics);
                        var n, i, t = this.layerConfig;
                        (e & this.CHANGE_FULL || e & this.CHANGE_SIZE || e & this.CHANGE_TEXT || e & this.CHANGE_LINES || e & this.CHANGE_SCROLL || e & this.CHANGE_H_SCROLL) && (e |= this.$computeLayerConfig() | this.$loop.clear(), t.firstRow != this.layerConfig.firstRow && t.firstRowScreen == this.layerConfig.firstRowScreen && 0 < (n = this.scrollTop + (t.firstRow - Math.max(this.layerConfig.firstRow, 0)) * this.lineHeight) && (this.scrollTop = n, e = (e |= this.CHANGE_SCROLL) | (this.$computeLayerConfig() | this.$loop.clear())), t = this.layerConfig, this.$updateScrollBarV(), e & this.CHANGE_H_SCROLL && this.$updateScrollBarH(), a.translate(this.content, -this.scrollLeft, -t.offset), n = t.width + 2 * this.$padding + "px", i = t.minHeight + "px", a.setStyle(this.content.style, "width", n), a.setStyle(this.content.style, "height", i)), e & this.CHANGE_H_SCROLL && (a.translate(this.content, -this.scrollLeft, -t.offset), this.scroller.className = this.scrollLeft <= 0 ? "ace_scroller " : "ace_scroller ace_scroll-left ", this.enableKeyboardAccessibility) && (this.scroller.className += this.keyboardFocusClassName), e & this.CHANGE_FULL ? (this.$changedLines = null, this.$textLayer.update(t), this.$showGutter && this.$gutterLayer.update(t), this.$customScrollbar && this.$scrollDecorator.$updateDecorators(t), this.$markerBack.update(t), this.$markerFront.update(t), this.$cursorLayer.update(t), this.$moveTextAreaToCursor()) : e & this.CHANGE_SCROLL ? (this.$changedLines = null, e & this.CHANGE_TEXT || e & this.CHANGE_LINES ? this.$textLayer.update(t) : this.$textLayer.scrollLines(t), this.$showGutter && (e & this.CHANGE_GUTTER || e & this.CHANGE_LINES ? this.$gutterLayer.update(t) : this.$gutterLayer.scrollLines(t)), this.$customScrollbar && this.$scrollDecorator.$updateDecorators(t), this.$markerBack.update(t), this.$markerFront.update(t), this.$cursorLayer.update(t), this.$moveTextAreaToCursor()) : (e & this.CHANGE_TEXT ? (this.$changedLines = null, this.$textLayer.update(t), this.$showGutter && this.$gutterLayer.update(t), this.$customScrollbar && this.$scrollDecorator.$updateDecorators(t)) : e & this.CHANGE_LINES ? ((this.$updateLines() || e & this.CHANGE_GUTTER && this.$showGutter) && this.$gutterLayer.update(t), this.$customScrollbar && this.$scrollDecorator.$updateDecorators(t)) : e & this.CHANGE_TEXT || e & this.CHANGE_GUTTER ? (this.$showGutter && this.$gutterLayer.update(t), this.$customScrollbar && this.$scrollDecorator.$updateDecorators(t)) : e & this.CHANGE_CURSOR && (this.$highlightGutterLine && this.$gutterLayer.updateLineHighlight(t), this.$customScrollbar) && this.$scrollDecorator.$updateDecorators(t), e & this.CHANGE_CURSOR && (this.$cursorLayer.update(t), this.$moveTextAreaToCursor()), e & (this.CHANGE_MARKER | this.CHANGE_MARKER_FRONT) && this.$markerFront.update(t), e & (this.CHANGE_MARKER | this.CHANGE_MARKER_BACK) && this.$markerBack.update(t)), this._signal("afterRender", e);
                    } else this.$changes |= e;
                }, b.prototype.$autosize = function() {
                    var e = this.session.getScreenLength() * this.lineHeight, t = this.$maxLines * this.lineHeight, n = Math.min(t, Math.max((this.$minLines || 1) * this.lineHeight, e)) + this.scrollMargin.v + (this.$extraHeight || 0);
                    this.$horizScroll && (n += this.scrollBarH.getHeight());
                    t = !((n = this.$maxPixelHeight && n > this.$maxPixelHeight ? this.$maxPixelHeight : n) <= 2 * this.lineHeight) && t < e;
                    n == this.desiredHeight && this.$size.height == this.desiredHeight && t == this.$vScroll || (t != this.$vScroll && (this.$vScroll = t, this.scrollBarV.setVisible(t)), e = this.container.clientWidth, this.container.style.height = n + "px", this.$updateCachedSize(!0, this.$gutterWidth, e, n), this.desiredHeight = n, this._signal("autosize"));
                }, b.prototype.$computeLayerConfig = function() {
                    var e, t = this.session, n = this.$size, i = n.height <= 2 * this.lineHeight, o = this.session.getScreenLength() * this.lineHeight, r = this.$getLongestLine(), s = !i && (this.$hScrollBarAlwaysVisible || n.scrollerWidth - r - 2 * this.$padding < 0), a = this.$horizScroll !== s, s = (a && (this.$horizScroll = s, this.scrollBarH.setVisible(s)), this.$vScroll), l = (this.$maxLines && 1 < this.lineHeight && this.$autosize(), n.scrollerHeight + this.lineHeight), c = !this.$maxLines && this.$scrollPastEnd ? (n.scrollerHeight - this.lineHeight) * this.$scrollPastEnd : 0, h = (o += c, this.scrollMargin), i = (this.session.setScrollTop(Math.max(-h.top, Math.min(this.scrollTop, o - n.scrollerHeight + h.bottom))), this.session.setScrollLeft(Math.max(-h.left, Math.min(this.scrollLeft, r + 2 * this.$padding - n.scrollerWidth + h.right))), !i && (this.$vScrollBarAlwaysVisible || n.scrollerHeight - o + c < 0 || this.scrollTop > h.top)), c = s !== i, h = (c && (this.$vScroll = i, this.scrollBarV.setVisible(i)), this.scrollTop % this.lineHeight), s = Math.ceil(l / this.lineHeight) - 1, s = (i = Math.max(0, Math.round((this.scrollTop - h) / this.lineHeight))) + s, d = this.lineHeight, i = t.screenToDocumentRow(i, 0), u = t.getFoldLine(i), t = (u && (i = u.start.row), u = t.documentToScreenRow(i, 0), e = t.getRowLength(i) * d, s = Math.min(t.screenToDocumentRow(s, 0), t.getLength() - 1), l = n.scrollerHeight + t.getRowLength(s) * d + e, h = this.scrollTop - u * d, 0);
                    return this.layerConfig.width == r && !a || (t = this.CHANGE_H_SCROLL), (a || c) && (t |= this.$updateCachedSize(!0, this.gutterWidth, n.width, n.height), this._signal("scrollbarVisibilityChanged"), c) && (r = this.$getLongestLine()), this.layerConfig = {
                        width: r,
                        padding: this.$padding,
                        firstRow: i,
                        firstRowScreen: u,
                        lastRow: s,
                        lineHeight: d,
                        characterWidth: this.characterWidth,
                        minHeight: l,
                        maxHeight: o,
                        offset: h,
                        gutterOffset: d ? Math.max(0, Math.ceil((h + n.height - n.scrollerHeight) / d)) : 0,
                        height: this.$size.scrollerHeight
                    }, this.session.$bidiHandler && this.session.$bidiHandler.setContentWidth(r - this.$padding), t;
                }, b.prototype.$updateLines = function() {
                    if (this.$changedLines) {
                        var e = this.$changedLines.firstRow, t = this.$changedLines.lastRow, n = (this.$changedLines = null, this.layerConfig);
                        if (!(e > n.lastRow + 1 || t < n.firstRow)) {
                            if (t !== 1 / 0) return this.$textLayer.updateLines(n, e, t), !0;
                            this.$showGutter && this.$gutterLayer.update(n), this.$textLayer.update(n);
                        }
                    }
                }, b.prototype.$getLongestLine = function() {
                    var e = this.session.getScreenWidth();
                    return this.showInvisibles && !this.session.$useWrapMode && (e += 1), this.$textLayer && e > this.$textLayer.MAX_LINE_LENGTH && (e = this.$textLayer.MAX_LINE_LENGTH + 30), Math.max(this.$size.scrollerWidth - 2 * this.$padding, Math.round(e * this.characterWidth));
                }, b.prototype.updateFrontMarkers = function() {
                    this.$markerFront.setMarkers(this.session.getMarkers(!0)), this.$loop.schedule(this.CHANGE_MARKER_FRONT);
                }, b.prototype.updateBackMarkers = function() {
                    this.$markerBack.setMarkers(this.session.getMarkers()), this.$loop.schedule(this.CHANGE_MARKER_BACK);
                }, b.prototype.addGutterDecoration = function(e, t) {
                    this.$gutterLayer.addGutterDecoration(e, t);
                }, b.prototype.removeGutterDecoration = function(e, t) {
                    this.$gutterLayer.removeGutterDecoration(e, t);
                }, b.prototype.updateBreakpoints = function(e) {
                    this.$loop.schedule(this.CHANGE_GUTTER);
                }, b.prototype.setAnnotations = function(e) {
                    this.$gutterLayer.setAnnotations(e), this.$loop.schedule(this.CHANGE_GUTTER);
                }, b.prototype.updateCursor = function() {
                    this.$loop.schedule(this.CHANGE_CURSOR);
                }, b.prototype.hideCursor = function() {
                    this.$cursorLayer.hideCursor();
                }, b.prototype.showCursor = function() {
                    this.$cursorLayer.showCursor();
                }, b.prototype.scrollSelectionIntoView = function(e, t, n) {
                    this.scrollCursorIntoView(e, n), this.scrollCursorIntoView(t, n);
                }, b.prototype.scrollCursorIntoView = function(e, t, n) {
                    var i, o, r;
                    0 !== this.$size.scrollerHeight && (i = (e = this.$cursorLayer.getPixelPosition(e)).left, e = e.top, o = n && n.top || 0, n = n && n.bottom || 0, this.$scrollAnimation && (this.$stopAnimation = !0), e < (r = this.$scrollAnimation ? this.session.getScrollTop() : this.scrollTop) + o ? (t && r + o > e + this.lineHeight && (e -= t * this.$size.scrollerHeight), 0 === e && (e = -this.scrollMargin.top), this.session.setScrollTop(e)) : r + this.$size.scrollerHeight - n < e + this.lineHeight && (t && r + this.$size.scrollerHeight - n < e - this.lineHeight && (e += t * this.$size.scrollerHeight), this.session.setScrollTop(e + this.lineHeight + n - this.$size.scrollerHeight)), o = this.scrollLeft, i - (r = 2 * this.layerConfig.characterWidth) < o ? ((i -= r) < this.$padding + r && (i = -this.scrollMargin.left), this.session.setScrollLeft(i)) : o + this.$size.scrollerWidth < (i += r) + this.characterWidth ? this.session.setScrollLeft(Math.round(i + this.characterWidth - this.$size.scrollerWidth)) : o <= this.$padding && i - o < this.characterWidth && this.session.setScrollLeft(0));
                }, b.prototype.getScrollTop = function() {
                    return this.session.getScrollTop();
                }, b.prototype.getScrollLeft = function() {
                    return this.session.getScrollLeft();
                }, b.prototype.getScrollTopRow = function() {
                    return this.scrollTop / this.lineHeight;
                }, b.prototype.getScrollBottomRow = function() {
                    return Math.max(0, Math.floor((this.scrollTop + this.$size.scrollerHeight) / this.lineHeight) - 1);
                }, b.prototype.scrollToRow = function(e) {
                    this.session.setScrollTop(e * this.lineHeight);
                }, b.prototype.alignCursor = function(e, t) {
                    var e = this.$cursorLayer.getPixelPosition(e = "number" == typeof e ? {
                        row: e,
                        column: 0
                    } : e), n = this.$size.scrollerHeight - this.lineHeight, e = e.top - n * (t || 0);
                    return this.session.setScrollTop(e), e;
                }, b.prototype.$calcSteps = function(e, t) {
                    for(var n, i, o = 0, r = this.STEPS, s = [], o = 0; o < r; ++o)s.push((n = o / this.STEPS, (t - (i = e)) * (Math.pow(n - 1, 3) + 1) + i));
                    return s;
                }, b.prototype.scrollToLine = function(e, t, n, i) {
                    e = this.$cursorLayer.getPixelPosition({
                        row: e,
                        column: 0
                    }).top, t && (e -= this.$size.scrollerHeight / 2), t = this.scrollTop;
                    this.session.setScrollTop(e), !1 !== n && this.animateScrolling(t, i);
                }, b.prototype.animateScrolling = function(e, t) {
                    var n = this.scrollTop;
                    if (this.$animatedScroll) {
                        var i = this;
                        if (e != n) {
                            if (this.$scrollAnimation) {
                                var o = this.$scrollAnimation.steps;
                                if (o.length && (e = o[0]) == n) return;
                            }
                            var r = i.$calcSteps(e, n);
                            this.$scrollAnimation = {
                                from: e,
                                to: n,
                                steps: r
                            }, clearInterval(this.$timer), i.session.setScrollTop(r.shift()), i.session.$scrollTop = n, this.$timer = setInterval(function() {
                                if (!i.$stopAnimation) return i.session ? void (r.length ? (i.session.setScrollTop(r.shift()), i.session.$scrollTop = n) : null != n ? (i.session.$scrollTop = -1, i.session.setScrollTop(n), n = null) : s()) : clearInterval(i.$timer);
                                s();
                            }, 10);
                        }
                    }
                    function s() {
                        i.$timer = clearInterval(i.$timer), i.$scrollAnimation = null, i.$stopAnimation = !1, t && t();
                    }
                }, b.prototype.scrollToY = function(e) {
                    this.scrollTop !== e && (this.$loop.schedule(this.CHANGE_SCROLL), this.scrollTop = e);
                }, b.prototype.scrollToX = function(e) {
                    this.scrollLeft !== e && (this.scrollLeft = e), this.$loop.schedule(this.CHANGE_H_SCROLL);
                }, b.prototype.scrollTo = function(e, t) {
                    this.session.setScrollTop(t), this.session.setScrollLeft(e);
                }, b.prototype.scrollBy = function(e, t) {
                    t && this.session.setScrollTop(this.session.getScrollTop() + t), e && this.session.setScrollLeft(this.session.getScrollLeft() + e);
                }, b.prototype.isScrollableBy = function(e, t) {
                    return t < 0 && this.session.getScrollTop() >= 1 - this.scrollMargin.top || 0 < t && this.session.getScrollTop() + this.$size.scrollerHeight - this.layerConfig.maxHeight < -1 + this.scrollMargin.bottom || e < 0 && this.session.getScrollLeft() >= 1 - this.scrollMargin.left || 0 < e && this.session.getScrollLeft() + this.$size.scrollerWidth - this.layerConfig.width < -1 + this.scrollMargin.right || void 0;
                }, b.prototype.pixelToScreenCoordinates = function(e, t) {
                    this.$hasCssTransforms ? (i = {
                        top: 0,
                        left: 0
                    }, e = (n = this.$fontMetrics.transformCoordinates([
                        e,
                        t
                    ]))[1] - this.gutterWidth - this.margin.left, t = n[0]) : i = this.scroller.getBoundingClientRect();
                    var n = e + this.scrollLeft - i.left - this.$padding, e = n / this.characterWidth, t = Math.floor((t + this.scrollTop - i.top) / this.lineHeight), i = this.$blockCursor ? Math.floor(e) : Math.round(e);
                    return {
                        row: t,
                        column: i,
                        side: 0 < e - i ? 1 : -1,
                        offsetX: n
                    };
                }, b.prototype.screenToTextCoordinates = function(e, t) {
                    this.$hasCssTransforms ? (n = {
                        top: 0,
                        left: 0
                    }, e = (i = this.$fontMetrics.transformCoordinates([
                        e,
                        t
                    ]))[1] - this.gutterWidth - this.margin.left, t = i[0]) : n = this.scroller.getBoundingClientRect();
                    var n, i = e + this.scrollLeft - n.left - this.$padding, e = i / this.characterWidth, e = this.$blockCursor ? Math.floor(e) : Math.round(e), t = Math.floor((t + this.scrollTop - n.top) / this.lineHeight);
                    return this.session.screenToDocumentPosition(t, Math.max(e, 0), i);
                }, b.prototype.textToScreenCoordinates = function(e, t) {
                    var n = this.scroller.getBoundingClientRect(), t = this.session.documentToScreenPosition(e, t), e = this.$padding + (this.session.$bidiHandler.isBidiRow(t.row, e) ? this.session.$bidiHandler.getPosLeft(t.column) : Math.round(t.column * this.characterWidth)), t = t.row * this.lineHeight;
                    return {
                        pageX: n.left + e - this.scrollLeft,
                        pageY: n.top + t - this.scrollTop
                    };
                }, b.prototype.visualizeFocus = function() {
                    a.addCssClass(this.container, "ace_focus");
                }, b.prototype.visualizeBlur = function() {
                    a.removeCssClass(this.container, "ace_focus");
                }, b.prototype.showComposition = function(e) {
                    (this.$composition = e).cssText || (e.cssText = this.textarea.style.cssText), null == e.useTextareaForIME && (e.useTextareaForIME = this.$useTextareaForIME), this.$useTextareaForIME ? (a.addCssClass(this.textarea, "ace_composition"), this.textarea.style.cssText = "", this.$moveTextAreaToCursor(), this.$cursorLayer.element.style.display = "none") : e.markerId = this.session.addMarker(e.markerRange, "ace_composition_marker", "text");
                }, b.prototype.setCompositionText = function(e) {
                    var t = this.session.selection.cursor;
                    this.addToken(e, "composition_placeholder", t.row, t.column), this.$moveTextAreaToCursor();
                }, b.prototype.hideComposition = function() {
                    var e;
                    this.$composition && (this.$composition.markerId && this.session.removeMarker(this.$composition.markerId), a.removeCssClass(this.textarea, "ace_composition"), this.textarea.style.cssText = this.$composition.cssText, e = this.session.selection.cursor, this.removeExtraToken(e.row, e.column), this.$composition = null, this.$cursorLayer.element.style.display = "");
                }, b.prototype.setGhostText = function(e, t) {
                    var n = this.session.selection.cursor, t = t || {
                        row: n.row,
                        column: n.column
                    }, n = (this.removeGhostText(), e.split("\n"));
                    this.addToken(n[0], "ghost_text", t.row, t.column), this.$ghostText = {
                        text: e,
                        position: {
                            row: t.row,
                            column: t.column
                        }
                    }, 1 < n.length && (this.$ghostTextWidget = {
                        text: n.slice(1).join("\n"),
                        row: t.row,
                        column: t.column,
                        className: "ace_ghost_text"
                    }, this.session.widgetManager.addLineWidget(this.$ghostTextWidget));
                }, b.prototype.removeGhostText = function() {
                    var e;
                    this.$ghostText && (e = this.$ghostText.position, this.removeExtraToken(e.row, e.column), this.$ghostTextWidget && (this.session.widgetManager.removeLineWidget(this.$ghostTextWidget), this.$ghostTextWidget = null), this.$ghostText = null);
                }, b.prototype.addToken = function(e, t, n, i) {
                    var o = this.session, r = (o.bgTokenizer.lines[n] = null, {
                        type: t,
                        value: e
                    }), s = o.getTokens(n);
                    if (null != i && s.length) for(var a = 0, l = 0; l < s.length; l++){
                        var c = s[l];
                        if (i <= (a += c.value.length)) {
                            var h = c.value.length - (a - i), d = c.value.slice(0, h), h = c.value.slice(h);
                            s.splice(l, 1, {
                                type: c.type,
                                value: d
                            }, r, {
                                type: c.type,
                                value: h
                            });
                            break;
                        }
                    }
                    else s.push(r);
                    this.updateLines(n, n);
                }, b.prototype.removeExtraToken = function(e, t) {
                    this.session.bgTokenizer.lines[e] = null, this.updateLines(e, e);
                }, b.prototype.setTheme = function(n, i) {
                    var e, o = this;
                    function t(e) {
                        if (o.$themeId != n) return i && i();
                        if (!e || !e.cssClass) throw new Error("couldn't load module " + n + " or it didn't call define");
                        e.$id && (o.$themeId = e.$id), a.importCssString(e.cssText, e.cssClass, o.container), o.theme && a.removeCssClass(o.container, o.theme.cssClass);
                        var t = "padding" in e ? e.padding : "padding" in (o.theme || {}) ? 4 : o.$padding;
                        o.$padding && t != o.$padding && o.setPadding(t), o.$theme = e.cssClass, o.theme = e, a.addCssClass(o.container, e.cssClass), a.setCssClass(o.container, "ace_dark", e.isDark), o.$size && (o.$size.width = 0, o.$updateSizeAsync()), o._dispatchEvent("themeLoaded", {
                            theme: e
                        }), i && i();
                    }
                    this.$themeId = n, o._dispatchEvent("themeChange", {
                        theme: n
                    }), n && "string" != typeof n ? t(n) : (e = n || this.$options.theme.initialValue, r.loadModule([
                        "theme",
                        e
                    ], t));
                }, b.prototype.getTheme = function() {
                    return this.$themeId;
                }, b.prototype.setStyle = function(e, t) {
                    a.setCssClass(this.container, e, !1 !== t);
                }, b.prototype.unsetStyle = function(e) {
                    a.removeCssClass(this.container, e);
                }, b.prototype.setCursorStyle = function(e) {
                    a.setStyle(this.scroller.style, "cursor", e);
                }, b.prototype.setMouseCursor = function(e) {
                    a.setStyle(this.scroller.style, "cursor", e);
                }, b.prototype.attachToShadowRoot = function() {
                    a.importCssString(y, "ace_editor.css", this.container);
                }, b.prototype.destroy = function() {
                    this.freeze(), this.$fontMetrics.destroy(), this.$cursorLayer.destroy(), this.removeAllListeners(), this.container.textContent = "", this.setOption("useResizeObserver", !1);
                }, b.prototype.$updateCustomScrollbar = function(e) {
                    var t = this;
                    this.$horizScroll = this.$vScroll = null, this.scrollBarV.element.remove(), this.scrollBarH.element.remove(), this.$scrollDecorator && delete this.$scrollDecorator, !0 === e ? (this.scrollBarV = new p(this.container, this), this.scrollBarH = new g(this.container, this), this.scrollBarV.setHeight(this.$size.scrollerHeight), this.scrollBarH.setWidth(this.$size.scrollerWidth), this.scrollBarV.addEventListener("scroll", function(e) {
                        t.$scrollAnimation || t.session.setScrollTop(e.data - t.scrollMargin.top);
                    }), this.scrollBarH.addEventListener("scroll", function(e) {
                        t.$scrollAnimation || t.session.setScrollLeft(e.data - t.scrollMargin.left);
                    }), this.$scrollDecorator = new v(this.scrollBarV, this), this.$scrollDecorator.$updateDecorators()) : (this.scrollBarV = new u(this.container, this), this.scrollBarH = new d(this.container, this), this.scrollBarV.addEventListener("scroll", function(e) {
                        t.$scrollAnimation || t.session.setScrollTop(e.data - t.scrollMargin.top);
                    }), this.scrollBarH.addEventListener("scroll", function(e) {
                        t.$scrollAnimation || t.session.setScrollLeft(e.data - t.scrollMargin.left);
                    }));
                }, b.prototype.$addResizeObserver = function() {
                    var n;
                    window.ResizeObserver && !this.$resizeObserver && ((n = this).$resizeTimer = o.delayedCall(function() {
                        n.destroyed || n.onResize();
                    }, 50), this.$resizeObserver = new window.ResizeObserver(function(e) {
                        var t = e[0].contentRect.width, e = e[0].contentRect.height;
                        1 < Math.abs(n.$size.width - t) || 1 < Math.abs(n.$size.height - e) ? n.$resizeTimer.delay() : n.$resizeTimer.cancel();
                    }), this.$resizeObserver.observe(this.container));
                }, b);
                function b(e, t) {
                    var n = this, e = (this.container = e || a.createElement("div"), a.addCssClass(this.container, "ace_editor"), a.HI_DPI && a.addCssClass(this.container, "ace_hidpi"), this.setTheme(t), null == r.get("useStrictCSP") && r.set("useStrictCSP", !1), this.$gutter = a.createElement("div"), this.$gutter.className = "ace_gutter", this.container.appendChild(this.$gutter), this.$gutter.setAttribute("aria-hidden", !0), this.scroller = a.createElement("div"), this.scroller.className = "ace_scroller", this.container.appendChild(this.scroller), this.content = a.createElement("div"), this.content.className = "ace_content", this.scroller.appendChild(this.content), this.$gutterLayer = new s(this.$gutter), this.$gutterLayer.on("changeGutterWidth", this.onGutterResize.bind(this)), this.$markerBack = new l(this.content), this.$textLayer = new c(this.content));
                    this.canvas = e.element, this.$markerFront = new l(this.content), this.$cursorLayer = new h(this.content), this.$horizScroll = !1, this.$vScroll = !1, this.scrollBar = this.scrollBarV = new u(this.container, this), this.scrollBarH = new d(this.container, this), this.scrollBarV.on("scroll", function(e) {
                        n.$scrollAnimation || n.session.setScrollTop(e.data - n.scrollMargin.top);
                    }), this.scrollBarH.on("scroll", function(e) {
                        n.$scrollAnimation || n.session.setScrollLeft(e.data - n.scrollMargin.left);
                    }), this.scrollTop = 0, this.scrollLeft = 0, this.cursorPos = {
                        row: 0,
                        column: 0
                    }, this.$fontMetrics = new f(this.container), this.$textLayer.$setFontMetrics(this.$fontMetrics), this.$textLayer.on("changeCharacterSize", function(e) {
                        n.updateCharacterSize(), n.onResize(!0, n.gutterWidth, n.$size.width, n.$size.height), n._signal("changeCharacterSize", e);
                    }), this.$size = {
                        width: 0,
                        height: 0,
                        scrollerHeight: 0,
                        scrollerWidth: 0,
                        $dirty: !0
                    }, this.layerConfig = {
                        width: 1,
                        padding: 0,
                        firstRow: 0,
                        firstRowScreen: 0,
                        lastRow: 0,
                        lineHeight: 0,
                        characterWidth: 0,
                        minHeight: 1,
                        maxHeight: 1,
                        offset: 0,
                        height: 1,
                        gutterOffset: 1
                    }, this.scrollMargin = {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        v: 0,
                        h: 0
                    }, this.margin = {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        v: 0,
                        h: 0
                    }, this.$keepTextAreaAtCursor = !I.isIOS, this.$loop = new m(this.$renderChanges.bind(this), this.container.ownerDocument.defaultView), this.$loop.schedule(this.CHANGE_FULL), this.updateCharacterSize(), this.setPadding(4), this.$addResizeObserver(), r.resetOptions(this), r._signal("renderer", this);
                }
                e.prototype.CHANGE_CURSOR = 1, e.prototype.CHANGE_MARKER = 2, e.prototype.CHANGE_GUTTER = 4, e.prototype.CHANGE_SCROLL = 8, e.prototype.CHANGE_LINES = 16, e.prototype.CHANGE_TEXT = 32, e.prototype.CHANGE_SIZE = 64, e.prototype.CHANGE_MARKER_BACK = 128, e.prototype.CHANGE_MARKER_FRONT = 256, e.prototype.CHANGE_FULL = 512, e.prototype.CHANGE_H_SCROLL = 1024, e.prototype.$changes = 0, e.prototype.$padding = null, e.prototype.$frozen = !1, e.prototype.STEPS = 8, i.implement(e.prototype, C), r.defineOptions(e.prototype, "renderer", {
                    useResizeObserver: {
                        set: function(e) {
                            !e && this.$resizeObserver ? (this.$resizeObserver.disconnect(), this.$resizeTimer.cancel(), this.$resizeTimer = this.$resizeObserver = null) : e && !this.$resizeObserver && this.$addResizeObserver();
                        }
                    },
                    animatedScroll: {
                        initialValue: !1
                    },
                    showInvisibles: {
                        set: function(e) {
                            this.$textLayer.setShowInvisibles(e) && this.$loop.schedule(this.CHANGE_TEXT);
                        },
                        initialValue: !1
                    },
                    showPrintMargin: {
                        set: function() {
                            this.$updatePrintMargin();
                        },
                        initialValue: !0
                    },
                    printMarginColumn: {
                        set: function() {
                            this.$updatePrintMargin();
                        },
                        initialValue: 80
                    },
                    printMargin: {
                        set: function(e) {
                            "number" == typeof e && (this.$printMarginColumn = e), this.$showPrintMargin = !!e, this.$updatePrintMargin();
                        },
                        get: function() {
                            return this.$showPrintMargin && this.$printMarginColumn;
                        }
                    },
                    showGutter: {
                        set: function(e) {
                            this.$gutter.style.display = e ? "block" : "none", this.$loop.schedule(this.CHANGE_FULL), this.onGutterResize();
                        },
                        initialValue: !0
                    },
                    useSvgGutterIcons: {
                        set: function(e) {
                            this.$gutterLayer.$useSvgGutterIcons = e;
                        },
                        initialValue: !1
                    },
                    showFoldedAnnotations: {
                        set: function(e) {
                            this.$gutterLayer.$showFoldedAnnotations = e;
                        },
                        initialValue: !1
                    },
                    fadeFoldWidgets: {
                        set: function(e) {
                            a.setCssClass(this.$gutter, "ace_fade-fold-widgets", e);
                        },
                        initialValue: !1
                    },
                    showFoldWidgets: {
                        set: function(e) {
                            this.$gutterLayer.setShowFoldWidgets(e), this.$loop.schedule(this.CHANGE_GUTTER);
                        },
                        initialValue: !0
                    },
                    displayIndentGuides: {
                        set: function(e) {
                            this.$textLayer.setDisplayIndentGuides(e) && this.$loop.schedule(this.CHANGE_TEXT);
                        },
                        initialValue: !0
                    },
                    highlightIndentGuides: {
                        set: function(e) {
                            1 == this.$textLayer.setHighlightIndentGuides(e) ? this.$textLayer.$highlightIndentGuide() : this.$textLayer.$clearActiveIndentGuide(this.$textLayer.$lines.cells);
                        },
                        initialValue: !0
                    },
                    highlightGutterLine: {
                        set: function(e) {
                            this.$gutterLayer.setHighlightGutterLine(e), this.$loop.schedule(this.CHANGE_GUTTER);
                        },
                        initialValue: !0
                    },
                    hScrollBarAlwaysVisible: {
                        set: function(e) {
                            this.$hScrollBarAlwaysVisible && this.$horizScroll || this.$loop.schedule(this.CHANGE_SCROLL);
                        },
                        initialValue: !1
                    },
                    vScrollBarAlwaysVisible: {
                        set: function(e) {
                            this.$vScrollBarAlwaysVisible && this.$vScroll || this.$loop.schedule(this.CHANGE_SCROLL);
                        },
                        initialValue: !1
                    },
                    fontSize: {
                        set: function(e) {
                            "number" == typeof e && (e += "px"), this.container.style.fontSize = e, this.updateFontSize();
                        },
                        initialValue: 12
                    },
                    fontFamily: {
                        set: function(e) {
                            this.container.style.fontFamily = e, this.updateFontSize();
                        }
                    },
                    maxLines: {
                        set: function(e) {
                            this.updateFull();
                        }
                    },
                    minLines: {
                        set: function(e) {
                            this.$minLines < 562949953421311 || (this.$minLines = 0), this.updateFull();
                        }
                    },
                    maxPixelHeight: {
                        set: function(e) {
                            this.updateFull();
                        },
                        initialValue: 0
                    },
                    scrollPastEnd: {
                        set: function(e) {
                            this.$scrollPastEnd != (e = +e || 0) && (this.$scrollPastEnd = e, this.$loop.schedule(this.CHANGE_SCROLL));
                        },
                        initialValue: 0,
                        handlesSet: !0
                    },
                    fixedWidthGutter: {
                        set: function(e) {
                            this.$gutterLayer.$fixedWidth = !!e, this.$loop.schedule(this.CHANGE_GUTTER);
                        }
                    },
                    customScrollbar: {
                        set: function(e) {
                            this.$updateCustomScrollbar(e);
                        },
                        initialValue: !1
                    },
                    theme: {
                        set: function(e) {
                            this.setTheme(e);
                        },
                        get: function() {
                            return this.$themeId || this.theme;
                        },
                        initialValue: "./theme/textmate",
                        handlesSet: !0
                    },
                    hasCssTransforms: {},
                    useTextareaForIME: {
                        initialValue: !I.isMobile && !I.isIE
                    }
                }), t.VirtualRenderer = e;
            }), ace.define("ace/worker/worker_client", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/lib/net",
                "ace/lib/event_emitter",
                "ace/config"
            ], function(a, e, t) {
                "use strict";
                var n = a("../lib/oop"), i = a("../lib/net"), c = a("../lib/event_emitter").EventEmitter, h = a("../config");
                function l(e) {
                    var t;
                    return "undefined" == typeof Worker ? {
                        postMessage: function() {},
                        terminate: function() {}
                    } : h.get("loadWorkerFromBlob") ? (t = function(t) {
                        t = "importScripts('" + i.qualifyURL(t) + "');";
                        try {
                            return new Blob([
                                t
                            ], {
                                type: "application/javascript"
                            });
                        } catch (e) {
                            var n = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder);
                            return n.append(t), n.getBlob("application/javascript");
                        }
                    }(e), t = (window.URL || window.webkitURL).createObjectURL(t), new Worker(t)) : new Worker(e);
                }
                function d(e) {
                    e.postMessage || (e = this.$createWorkerFromOldConfig.apply(this, arguments)), this.$worker = e, this.$sendDeltaQueue = this.$sendDeltaQueue.bind(this), this.changeListener = this.changeListener.bind(this), this.onMessage = this.onMessage.bind(this), this.callbackId = 1, this.callbacks = {}, this.$worker.onmessage = this.onMessage;
                }
                (function() {
                    n.implement(this, c), this.$createWorkerFromOldConfig = function(e, t, n, i, o) {
                        var r, s;
                        return a.nameToUrl && !a.toUrl && (a.toUrl = a.nameToUrl), h.get("packaged") || !a.toUrl ? i = i || h.moduleUrl(t, "worker") : (r = this.$normalizePath, i = i || r(a.toUrl("ace/worker/worker.js", null, "_")), s = {}, e.forEach(function(e) {
                            s[e] = r(a.toUrl(e, null, "_").replace(/(\.js)?(\?.*)?$/, ""));
                        })), this.$worker = l(i), o && this.send("importScripts", o), this.$worker.postMessage({
                            init: !0,
                            tlns: s,
                            module: t,
                            classname: n
                        }), this.$worker;
                    }, this.onMessage = function(e) {
                        var t = e.data;
                        switch(t.type){
                            case "event":
                                this._signal(t.name, {
                                    data: t.data
                                });
                                break;
                            case "call":
                                var n = this.callbacks[t.id];
                                n && (n(t.data), delete this.callbacks[t.id]);
                                break;
                            case "error":
                                this.reportError(t.data);
                                break;
                            case "log":
                                window.console && console.log && console.log.apply(console, t.data);
                        }
                    }, this.reportError = function(e) {
                        window.console && console.error && console.error(e);
                    }, this.$normalizePath = function(e) {
                        return i.qualifyURL(e);
                    }, this.terminate = function() {
                        this._signal("terminate", {}), this.deltaQueue = null, this.$worker.terminate(), this.$worker = null, this.$doc && this.$doc.off("change", this.changeListener), this.$doc = null;
                    }, this.send = function(e, t) {
                        this.$worker.postMessage({
                            command: e,
                            args: t
                        });
                    }, this.call = function(e, t, n) {
                        var i;
                        n && (i = this.callbackId++, this.callbacks[i] = n, t.push(i)), this.send(e, t);
                    }, this.emit = function(e, t) {
                        try {
                            t.data && t.data.err && (t.data.err = {
                                message: t.data.err.message,
                                stack: t.data.err.stack,
                                code: t.data.err.code
                            }), this.$worker && this.$worker.postMessage({
                                event: e,
                                data: {
                                    data: t.data
                                }
                            });
                        } catch (e) {
                            console.error(e.stack);
                        }
                    }, this.attachToDocument = function(e) {
                        this.$doc && this.terminate(), this.$doc = e, this.call("setValue", [
                            e.getValue()
                        ]), e.on("change", this.changeListener, !0);
                    }, this.changeListener = function(e) {
                        this.deltaQueue || (this.deltaQueue = [], setTimeout(this.$sendDeltaQueue, 0)), "insert" == e.action ? this.deltaQueue.push(e.start, e.lines) : this.deltaQueue.push(e.start, e.end);
                    }, this.$sendDeltaQueue = function() {
                        var e = this.deltaQueue;
                        e && (this.deltaQueue = null, 50 < e.length && e.length > this.$doc.getLength() >> 1 ? this.call("setValue", [
                            this.$doc.getValue()
                        ]) : this.emit("change", {
                            data: e
                        }));
                    };
                }).call(d.prototype);
                e.UIWorkerClient = function(e, t, n) {
                    var i = null, o = !1, r = Object.create(c), s = [], a = new d({
                        messageBuffer: s,
                        terminate: function() {},
                        postMessage: function(e) {
                            s.push(e), i && (o ? setTimeout(l) : l());
                        }
                    }), l = (a.setEmitSync = function(e) {
                        o = e;
                    }, function() {
                        var e = s.shift();
                        e.command ? i[e.command].apply(i, e.args) : e.event && r._signal(e.event, e.data);
                    });
                    return r.postMessage = function(e) {
                        a.onMessage({
                            data: e
                        });
                    }, r.callback = function(e, t) {
                        this.postMessage({
                            type: "call",
                            id: t,
                            data: e
                        });
                    }, r.emit = function(e, t) {
                        this.postMessage({
                            type: "event",
                            name: e,
                            data: t
                        });
                    }, h.loadModule([
                        "worker",
                        t
                    ], function(e) {
                        for(i = new e[n](r); s.length;)l();
                    }), a;
                }, e.WorkerClient = d, e.createWorker = l;
            }), ace.define("ace/placeholder", [
                "require",
                "exports",
                "module",
                "ace/range",
                "ace/lib/event_emitter",
                "ace/lib/oop"
            ], function(e, t, n) {
                "use strict";
                var l = e("./range").Range, i = e("./lib/event_emitter").EventEmitter, e = e("./lib/oop"), o = (r.prototype.setup = function() {
                    var t = this, n = this.doc, e = this.session, i = (this.selectionBefore = e.selection.toJSON(), e.selection.inMultiSelectMode && e.selection.toSingleRange(), this.pos = n.createAnchor(this.$pos.row, this.$pos.column), this.pos);
                    i.$insertRight = !0, i.detach(), i.markerId = e.addMarker(new l(i.row, i.column, i.row, i.column + this.length), this.mainClass, null, !1), this.others = [], this.$others.forEach(function(e) {
                        e = n.createAnchor(e.row, e.column);
                        e.$insertRight = !0, e.detach(), t.others.push(e);
                    }), e.setUndoSelect(!1);
                }, r.prototype.showOtherMarkers = function() {
                    var t, n;
                    this.othersActive || (t = this.session, (n = this).othersActive = !0, this.others.forEach(function(e) {
                        e.markerId = t.addMarker(new l(e.row, e.column, e.row, e.column + n.length), n.othersClass, null, !1);
                    }));
                }, r.prototype.hideOtherMarkers = function() {
                    if (this.othersActive) {
                        this.othersActive = !1;
                        for(var e = 0; e < this.others.length; e++)this.session.removeMarker(this.others[e].markerId);
                    }
                }, r.prototype.onUpdate = function(e) {
                    if (this.$updating) return this.updateAnchors(e);
                    var t = e;
                    if (t.start.row === t.end.row && t.start.row === this.pos.row) {
                        this.$updating = !0;
                        var n = "insert" === e.action ? t.end.column - t.start.column : t.start.column - t.end.column, i = t.start.column >= this.pos.column && t.start.column <= this.pos.column + this.length + 1, o = t.start.column - this.pos.column;
                        if (this.updateAnchors(e), i && (this.length += n), i && !this.session.$fromUndo) {
                            if ("insert" === e.action) for(var r = this.others.length - 1; 0 <= r; r--){
                                var s = {
                                    row: (a = this.others[r]).row,
                                    column: a.column + o
                                };
                                this.doc.insertMergedLines(s, e.lines);
                            }
                            else if ("remove" === e.action) for(r = this.others.length - 1; 0 <= r; r--){
                                var a, s = {
                                    row: (a = this.others[r]).row,
                                    column: a.column + o
                                };
                                this.doc.remove(new l(s.row, s.column, s.row, s.column - n));
                            }
                        }
                        this.$updating = !1, this.updateMarkers();
                    }
                }, r.prototype.updateAnchors = function(e) {
                    this.pos.onChange(e);
                    for(var t = this.others.length; t--;)this.others[t].onChange(e);
                    this.updateMarkers();
                }, r.prototype.updateMarkers = function() {
                    if (!this.$updating) {
                        var n = this, i = this.session, e = function(e, t) {
                            i.removeMarker(e.markerId), e.markerId = i.addMarker(new l(e.row, e.column, e.row, e.column + n.length), t, null, !1);
                        };
                        e(this.pos, this.mainClass);
                        for(var t = this.others.length; t--;)e(this.others[t], this.othersClass);
                    }
                }, r.prototype.onCursorChange = function(e) {
                    var t;
                    !this.$updating && this.session && ((t = this.session.selection.getCursor()).row === this.pos.row && t.column >= this.pos.column && t.column <= this.pos.column + this.length ? (this.showOtherMarkers(), this._emit("cursorEnter", e)) : (this.hideOtherMarkers(), this._emit("cursorLeave", e)));
                }, r.prototype.detach = function() {
                    this.session.removeMarker(this.pos && this.pos.markerId), this.hideOtherMarkers(), this.doc.off("change", this.$onUpdate), this.session.selection.off("changeCursor", this.$onCursorChange), this.session.setUndoSelect(!0), this.session = null;
                }, r.prototype.cancel = function() {
                    if (-1 !== this.$undoStackDepth) {
                        for(var e = this.session.getUndoManager(), t = (e.$undoStack || e.$undostack).length - this.$undoStackDepth, n = 0; n < t; n++)e.undo(this.session, !0);
                        this.selectionBefore && this.session.selection.fromJSON(this.selectionBefore);
                    }
                }, r);
                function r(e, t, n, i, o, r) {
                    var s = this, t = (this.length = t, this.session = e, this.doc = e.getDocument(), this.mainClass = o, this.othersClass = r, this.$onUpdate = this.onUpdate.bind(this), this.doc.on("change", this.$onUpdate, !0), this.$others = i, this.$onCursorChange = function() {
                        setTimeout(function() {
                            s.onCursorChange();
                        });
                    }, this.$pos = n, e.getUndoManager().$undoStack || e.getUndoManager().$undostack || {
                        length: -1
                    });
                    this.$undoStackDepth = t.length, this.setup(), e.selection.on("changeCursor", this.$onCursorChange);
                }
                e.implement(o.prototype, i), t.PlaceHolder = o;
            }), ace.define("ace/mouse/multi_select_handler", [
                "require",
                "exports",
                "module",
                "ace/lib/event",
                "ace/lib/useragent"
            ], function(e, t, n) {
                var x = e("../lib/event"), k = e("../lib/useragent");
                function E(e, t) {
                    return e.row == t.row && e.column == t.column;
                }
                t.onMouseDown = function(e) {
                    var t = e.domEvent, n = t.altKey, i = t.shiftKey, o = t.ctrlKey, r = e.getAccelKey(), s = e.getButton();
                    if (o && k.isMac && (s = t.button), e.editor.inMultiSelectMode && 2 == s) e.editor.textInput.onContextMenu(e.domEvent);
                    else if (o || n || r) {
                        if (0 === s) {
                            var a, l, c, h, d, u, g, p, m = e.editor, f = m.selection, C = m.inMultiSelectMode, y = e.getDocumentPosition(), v = f.getCursor(), v = e.inSelection() || f.isEmpty() && E(y, v), I = e.x, b = e.y, A = m.session, w = m.renderer.pixelToScreenCoordinates(I, b), S = w;
                            if (m.$mouseHandler.$enableJumpToDef) o && n || r && n ? a = i ? "block" : "add" : n && m.$blockSelectEnabled && (a = "block");
                            else if (r && !n) {
                                if (a = "add", !C && i) return;
                            } else n && m.$blockSelectEnabled && (a = "block");
                            if (a && k.isMac && t.ctrlKey && m.$mouseHandler.cancelContextMenu(), "add" == a) !C && v || (C || (l = f.toOrientedRange(), m.addSelectionMarker(l)), c = f.rangeList.rangeAtPoint(y), m.inVirtualSelectionMode = !0, i && (c = null, l = f.ranges[0] || l, m.removeSelectionMarker(l)), m.once("mouseup", function() {
                                var e = f.toOrientedRange();
                                c && e.isEmpty() && E(c.cursor, e.cursor) ? f.substractPoint(e.cursor) : (i ? f.substractPoint(l.cursor) : l && (m.removeSelectionMarker(l), f.addRange(l)), f.addRange(e)), m.inVirtualSelectionMode = !1;
                            }));
                            else if ("block" == a) return e.stop(), m.inVirtualSelectionMode = !0, d = [], u = function() {
                                var e = m.renderer.pixelToScreenCoordinates(I, b), t = A.screenToDocumentPosition(e.row, e.column, e.offsetX);
                                E(S, e) && E(t, f.lead) || (S = e, m.selection.moveToPosition(t), m.renderer.scrollCursorIntoView(), m.removeSelectionMarkers(d), d = f.rectangularRangeBlock(S, w), m.$mouseHandler.$clickSelection && 1 == d.length && d[0].isEmpty() && (d[0] = m.$mouseHandler.$clickSelection.clone()), d.forEach(m.addSelectionMarker, m), m.updateSelectionMarkers());
                            }, C && !r ? f.toSingleRange() : !C && r && (h = f.toOrientedRange(), m.addSelectionMarker(h)), i ? w = A.documentToScreenPosition(f.lead) : f.moveToPosition(y), S = {
                                row: -1,
                                column: -1
                            }, g = u, x.capture(m.container, function(e) {
                                I = e.clientX, b = e.clientY;
                            }, function(e) {
                                u(), clearInterval(p), m.removeSelectionMarkers(d), d.length || (d = [
                                    f.toOrientedRange()
                                ]), h && (m.removeSelectionMarker(h), f.toSingleRange(h));
                                for(var t = 0; t < d.length; t++)f.addRange(d[t]);
                                m.inVirtualSelectionMode = !1, m.$mouseHandler.$clickSelection = null;
                            }), p = setInterval(function() {
                                g();
                            }, 20), e.preventDefault();
                        }
                    } else 0 === s && e.editor.inMultiSelectMode && e.editor.exitMultiSelectMode();
                };
            }), ace.define("ace/commands/multi_select_commands", [
                "require",
                "exports",
                "module",
                "ace/keyboard/hash_handler"
            ], function(e, t, n) {
                t.defaultCommands = [
                    {
                        name: "addCursorAbove",
                        description: "Add cursor above",
                        exec: function(e) {
                            e.selectMoreLines(-1);
                        },
                        bindKey: {
                            win: "Ctrl-Alt-Up",
                            mac: "Ctrl-Alt-Up"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "addCursorBelow",
                        description: "Add cursor below",
                        exec: function(e) {
                            e.selectMoreLines(1);
                        },
                        bindKey: {
                            win: "Ctrl-Alt-Down",
                            mac: "Ctrl-Alt-Down"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "addCursorAboveSkipCurrent",
                        description: "Add cursor above (skip current)",
                        exec: function(e) {
                            e.selectMoreLines(-1, !0);
                        },
                        bindKey: {
                            win: "Ctrl-Alt-Shift-Up",
                            mac: "Ctrl-Alt-Shift-Up"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "addCursorBelowSkipCurrent",
                        description: "Add cursor below (skip current)",
                        exec: function(e) {
                            e.selectMoreLines(1, !0);
                        },
                        bindKey: {
                            win: "Ctrl-Alt-Shift-Down",
                            mac: "Ctrl-Alt-Shift-Down"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectMoreBefore",
                        description: "Select more before",
                        exec: function(e) {
                            e.selectMore(-1);
                        },
                        bindKey: {
                            win: "Ctrl-Alt-Left",
                            mac: "Ctrl-Alt-Left"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectMoreAfter",
                        description: "Select more after",
                        exec: function(e) {
                            e.selectMore(1);
                        },
                        bindKey: {
                            win: "Ctrl-Alt-Right",
                            mac: "Ctrl-Alt-Right"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectNextBefore",
                        description: "Select next before",
                        exec: function(e) {
                            e.selectMore(-1, !0);
                        },
                        bindKey: {
                            win: "Ctrl-Alt-Shift-Left",
                            mac: "Ctrl-Alt-Shift-Left"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "selectNextAfter",
                        description: "Select next after",
                        exec: function(e) {
                            e.selectMore(1, !0);
                        },
                        bindKey: {
                            win: "Ctrl-Alt-Shift-Right",
                            mac: "Ctrl-Alt-Shift-Right"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    },
                    {
                        name: "toggleSplitSelectionIntoLines",
                        description: "Split selection into lines",
                        exec: function(e) {
                            1 < e.multiSelect.rangeCount ? e.multiSelect.joinSelections() : e.multiSelect.splitIntoLines();
                        },
                        bindKey: {
                            win: "Ctrl-Alt-L",
                            mac: "Ctrl-Alt-L"
                        },
                        readOnly: !0
                    },
                    {
                        name: "splitSelectionIntoLines",
                        description: "Split into lines",
                        exec: function(e) {
                            e.multiSelect.splitIntoLines();
                        },
                        readOnly: !0
                    },
                    {
                        name: "alignCursors",
                        description: "Align cursors",
                        exec: function(e) {
                            e.alignCursors();
                        },
                        bindKey: {
                            win: "Ctrl-Alt-A",
                            mac: "Ctrl-Alt-A"
                        },
                        scrollIntoView: "cursor"
                    },
                    {
                        name: "findAll",
                        description: "Find all",
                        exec: function(e) {
                            e.findAll();
                        },
                        bindKey: {
                            win: "Ctrl-Alt-K",
                            mac: "Ctrl-Alt-G"
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0
                    }
                ], t.multiSelectCommands = [
                    {
                        name: "singleSelection",
                        description: "Single selection",
                        bindKey: "esc",
                        exec: function(e) {
                            e.exitMultiSelectMode();
                        },
                        scrollIntoView: "cursor",
                        readOnly: !0,
                        isAvailable: function(e) {
                            return e && e.inMultiSelectMode;
                        }
                    }
                ];
                e = e("../keyboard/hash_handler").HashHandler;
                t.keyboardHandler = new e(t.multiSelectCommands);
            }), ace.define("ace/multi_select", [
                "require",
                "exports",
                "module",
                "ace/range_list",
                "ace/range",
                "ace/selection",
                "ace/mouse/multi_select_handler",
                "ace/lib/event",
                "ace/lib/lang",
                "ace/commands/multi_select_commands",
                "ace/search",
                "ace/edit_session",
                "ace/editor",
                "ace/config"
            ], function(e, o, t) {
                var n = e("./range_list").RangeList, I = e("./range").Range, u = e("./selection").Selection, r = e("./mouse/multi_select_handler").onMouseDown, s = e("./lib/event"), g = e("./lib/lang"), a = e("./commands/multi_select_commands");
                o.commands = a.defaultCommands.concat(a.multiSelectCommands);
                var l = new (e("./search")).Search;
                var i = e("./edit_session").EditSession, i = (!(function() {
                    this.getSelectionMarkers = function() {
                        return this.$selectionMarkers;
                    };
                }).call(i.prototype), (function() {
                    this.ranges = null, this.rangeList = null, this.addRange = function(e, t) {
                        if (e) {
                            if (!this.inMultiSelectMode && 0 === this.rangeCount) {
                                var n = this.toOrientedRange();
                                if (this.rangeList.add(n), this.rangeList.add(e), 2 != this.rangeList.ranges.length) return this.rangeList.removeAll(), t || this.fromOrientedRange(e);
                                this.rangeList.removeAll(), this.rangeList.add(n), this.$onAddRange(n);
                            }
                            e.cursor || (e.cursor = e.end);
                            n = this.rangeList.add(e);
                            return this.$onAddRange(e), n.length && this.$onRemoveRange(n), 1 < this.rangeCount && !this.inMultiSelectMode && (this._signal("multiSelect"), this.inMultiSelectMode = !0, this.session.$undoSelect = !1, this.rangeList.attach(this.session)), t || this.fromOrientedRange(e);
                        }
                    }, this.toSingleRange = function(e) {
                        e = e || this.ranges[0];
                        var t = this.rangeList.removeAll();
                        t.length && this.$onRemoveRange(t), e && this.fromOrientedRange(e);
                    }, this.substractPoint = function(e) {
                        e = this.rangeList.substractPoint(e);
                        if (e) return this.$onRemoveRange(e), e[0];
                    }, this.mergeOverlappingRanges = function() {
                        var e = this.rangeList.merge();
                        e.length && this.$onRemoveRange(e);
                    }, this.$onAddRange = function(e) {
                        this.rangeCount = this.rangeList.ranges.length, this.ranges.unshift(e), this._signal("addRange", {
                            range: e
                        });
                    }, this.$onRemoveRange = function(e) {
                        var t;
                        this.rangeCount = this.rangeList.ranges.length, 1 == this.rangeCount && this.inMultiSelectMode && (t = this.rangeList.ranges.pop(), e.push(t), this.rangeCount = 0);
                        for(var n = e.length; n--;){
                            var i = this.ranges.indexOf(e[n]);
                            this.ranges.splice(i, 1);
                        }
                        this._signal("removeRange", {
                            ranges: e
                        }), 0 === this.rangeCount && this.inMultiSelectMode && (this.inMultiSelectMode = !1, this._signal("singleSelect"), this.session.$undoSelect = !0, this.rangeList.detach(this.session)), (t = t || this.ranges[0]) && !t.isEqual(this.getRange()) && this.fromOrientedRange(t);
                    }, this.$initRangeList = function() {
                        this.rangeList || (this.rangeList = new n, this.ranges = [], this.rangeCount = 0);
                    }, this.getAllRanges = function() {
                        return this.rangeCount ? this.rangeList.ranges.concat() : [
                            this.getRange()
                        ];
                    }, this.splitIntoLines = function() {
                        for(var e = this.ranges.length ? this.ranges : [
                            this.getRange()
                        ], t = [], n = 0; n < e.length; n++){
                            var i = e[n], o = i.start.row, r = i.end.row;
                            if (o === r) t.push(i.clone());
                            else {
                                for(t.push(new I(o, i.start.column, o, this.session.getLine(o).length)); ++o < r;)t.push(this.getLineRange(o, !0));
                                t.push(new I(r, 0, r, i.end.column));
                            }
                            0 != n || this.isBackwards() || (t = t.reverse());
                        }
                        this.toSingleRange();
                        for(n = t.length; n--;)this.addRange(t[n]);
                    }, this.joinSelections = function() {
                        var e = this.rangeList.ranges, t = e[e.length - 1], e = I.fromPoints(e[0].start, t.end);
                        this.toSingleRange(), this.setSelectionRange(e, t.cursor == t.start);
                    }, this.toggleBlockSelection = function() {
                        var e, t;
                        1 < this.rangeCount ? (t = (e = this.rangeList.ranges)[e.length - 1], e = I.fromPoints(e[0].start, t.end), this.toSingleRange(), this.setSelectionRange(e, t.cursor == t.start)) : (e = this.session.documentToScreenPosition(this.cursor), t = this.session.documentToScreenPosition(this.anchor), this.rectangularRangeBlock(e, t).forEach(this.addRange, this));
                    }, this.rectangularRangeBlock = function(e, t, n) {
                        var i, o, r, s, a, l, c, h = [], d = e.column < t.column, u = (s = (d ? (i = e.column, o = t.column, r = e.offsetX, t) : (i = t.column, o = e.column, r = t.offsetX, e)).offsetX, e.row < t.row);
                        l = (u ? (a = e.row, t) : (a = t.row, e)).row, i < 0 && (i = 0), (a = a < 0 ? 0 : a) == l && (n = !0);
                        for(var g, p, m = a; m <= l; m++){
                            var f = I.fromPoints(this.session.screenToDocumentPosition(m, i, r), this.session.screenToDocumentPosition(m, o, s));
                            if (f.isEmpty()) {
                                if (c && (g = f.end, p = c, g.row == p.row) && g.column == p.column) break;
                                c = f.end;
                            }
                            f.cursor = d ? f.start : f.end, h.push(f);
                        }
                        if (u && h.reverse(), !n) {
                            for(var C = h.length - 1; h[C].isEmpty() && 0 < C;)C--;
                            if (0 < C) for(var y = 0; h[y].isEmpty();)y++;
                            for(var v = C; y <= v; v--)h[v].isEmpty() && h.splice(v, 1);
                        }
                        return h;
                    };
                }).call(u.prototype), e("./editor").Editor);
                function c(e) {
                    var t, n;
                    function i(e) {
                        n && (t.renderer.setMouseCursor(""), n = !1);
                    }
                    e.$multiselectOnSessionChange || (e.$onAddRange = e.$onAddRange.bind(e), e.$onRemoveRange = e.$onRemoveRange.bind(e), e.$onMultiSelect = e.$onMultiSelect.bind(e), e.$onSingleSelect = e.$onSingleSelect.bind(e), e.$multiselectOnSessionChange = o.onSessionChange.bind(e), e.$checkMultiselectChange = e.$checkMultiselectChange.bind(e), e.$multiselectOnSessionChange(e), e.on("changeSession", e.$multiselectOnSessionChange), e.on("mousedown", r), e.commands.addCommands(a.defaultCommands), (t = e).textInput && (e = t.textInput.getElement(), n = !1, s.addListener(e, "keydown", function(e) {
                        e = 18 == e.keyCode && !(e.ctrlKey || e.shiftKey || e.metaKey);
                        t.$blockSelectEnabled && e ? n || (t.renderer.setMouseCursor("crosshair"), n = !0) : n && i();
                    }, t), s.addListener(e, "keyup", i, t), s.addListener(e, "blur", i, t)));
                }
                (function() {
                    this.updateSelectionMarkers = function() {
                        this.renderer.updateCursor(), this.renderer.updateBackMarkers();
                    }, this.addSelectionMarker = function(e) {
                        e.cursor || (e.cursor = e.end);
                        var t = this.getSelectionStyle();
                        return e.marker = this.session.addMarker(e, "ace_selection", t), this.session.$selectionMarkers.push(e), this.session.selectionMarkerCount = this.session.$selectionMarkers.length, e;
                    }, this.removeSelectionMarker = function(e) {
                        e.marker && (this.session.removeMarker(e.marker), -1 != (e = this.session.$selectionMarkers.indexOf(e)) && this.session.$selectionMarkers.splice(e, 1), this.session.selectionMarkerCount = this.session.$selectionMarkers.length);
                    }, this.removeSelectionMarkers = function(e) {
                        for(var t = this.session.$selectionMarkers, n = e.length; n--;){
                            var i = e[n];
                            i.marker && (this.session.removeMarker(i.marker), -1 != (i = t.indexOf(i))) && t.splice(i, 1);
                        }
                        this.session.selectionMarkerCount = t.length;
                    }, this.$onAddRange = function(e) {
                        this.addSelectionMarker(e.range), this.renderer.updateCursor(), this.renderer.updateBackMarkers();
                    }, this.$onRemoveRange = function(e) {
                        this.removeSelectionMarkers(e.ranges), this.renderer.updateCursor(), this.renderer.updateBackMarkers();
                    }, this.$onMultiSelect = function(e) {
                        this.inMultiSelectMode || (this.inMultiSelectMode = !0, this.setStyle("ace_multiselect"), this.keyBinding.addKeyboardHandler(a.keyboardHandler), this.commands.setDefaultHandler("exec", this.$onMultiSelectExec), this.renderer.updateCursor(), this.renderer.updateBackMarkers());
                    }, this.$onSingleSelect = function(e) {
                        this.session.multiSelect.inVirtualMode || (this.inMultiSelectMode = !1, this.unsetStyle("ace_multiselect"), this.keyBinding.removeKeyboardHandler(a.keyboardHandler), this.commands.removeDefaultHandler("exec", this.$onMultiSelectExec), this.renderer.updateCursor(), this.renderer.updateBackMarkers(), this._emit("changeSelection"));
                    }, this.$onMultiSelectExec = function(e) {
                        var t, n = e.command, i = e.editor;
                        if (i.multiSelect) return n.multiSelectAction ? t = "forEach" == n.multiSelectAction ? i.forEachSelection(n, e.args) : "forEachLine" == n.multiSelectAction ? i.forEachSelection(n, e.args, !0) : "single" == n.multiSelectAction ? (i.exitMultiSelectMode(), n.exec(i, e.args || {})) : n.multiSelectAction(i, e.args || {}) : (t = n.exec(i, e.args || {}), i.multiSelect.addRange(i.multiSelect.toOrientedRange()), i.multiSelect.mergeOverlappingRanges()), t;
                    }, this.forEachSelection = function(e, t, n) {
                        if (!this.inVirtualSelectionMode) {
                            var i, o = n && n.keepOrder, r = 1 == n || n && n.$byLines, s = this.session, n = this.selection, a = n.rangeList, l = (o ? n : a).ranges;
                            if (!l.length) return e.exec ? e.exec(this, t || {}) : e(this, t || {});
                            var o = n._eventRegistry, c = (n._eventRegistry = {}, new u(s));
                            this.inVirtualSelectionMode = !0;
                            for(var h = l.length; h--;){
                                if (r) for(; 0 < h && l[h].start.row == l[h - 1].end.row;)h--;
                                c.fromOrientedRange(l[h]), c.index = h, this.selection = s.selection = c;
                                var d = e.exec ? e.exec(this, t || {}) : e(this, t || {});
                                i || void 0 === d || (i = d), c.toOrientedRange(l[h]);
                            }
                            c.detach(), this.selection = s.selection = n, this.inVirtualSelectionMode = !1, n._eventRegistry = o, n.mergeOverlappingRanges(), n.ranges[0] && n.fromOrientedRange(n.ranges[0]);
                            a = this.renderer.$scrollAnimation;
                            return this.onCursorChange(), this.onSelectionChange(), a && a.from == a.to && this.renderer.animateScrolling(a.from), i;
                        }
                    }, this.exitMultiSelectMode = function() {
                        this.inMultiSelectMode && !this.inVirtualSelectionMode && this.multiSelect.toSingleRange();
                    }, this.getSelectedText = function() {
                        var e = "";
                        if (this.inMultiSelectMode && !this.inVirtualSelectionMode) {
                            for(var t = this.multiSelect.rangeList.ranges, n = [], i = 0; i < t.length; i++)n.push(this.session.getTextRange(t[i]));
                            var o = this.session.getDocument().getNewLineCharacter();
                            (e = n.join(o)).length == (n.length - 1) * o.length && (e = "");
                        } else this.selection.isEmpty() || (e = this.session.getTextRange(this.getSelectionRange()));
                        return e;
                    }, this.$checkMultiselectChange = function(e, t) {
                        var n;
                        this.inMultiSelectMode && !this.inVirtualSelectionMode && (n = this.multiSelect.ranges[0], this.multiSelect.isEmpty() && t == this.multiSelect.anchor || ((n = t == this.multiSelect.anchor ? n.cursor == n.start ? n.end : n.start : n.cursor).row != t.row || this.session.$clipPositionToDocument(n.row, n.column).column != t.column ? this.multiSelect.toSingleRange(this.multiSelect.toOrientedRange()) : this.multiSelect.mergeOverlappingRanges()));
                    }, this.findAll = function(e, t, n) {
                        (t = t || {}).needle = e || t.needle, null == t.needle && (i = this.selection.isEmpty() ? this.selection.getWordRange() : this.selection.getRange(), t.needle = this.session.getTextRange(i)), this.$search.set(t);
                        var i, o = this.$search.findAll(this.session);
                        if (!o.length) return 0;
                        var r = this.multiSelect;
                        n || r.toSingleRange(o[0]);
                        for(var s = o.length; s--;)r.addRange(o[s], !0);
                        return i && r.rangeList.rangeAtPoint(i.start) && r.addRange(i, !0), o.length;
                    }, this.selectMoreLines = function(e, t) {
                        var n, i, o, r = this.selection.toOrientedRange(), s = r.cursor == r.end, a = this.session.documentToScreenPosition(r.cursor), l = (this.selection.$desiredColumn && (a.column = this.selection.$desiredColumn), this.session.screenToDocumentPosition(a.row + e, a.column));
                        e = r.isEmpty() ? l : (n = this.session.documentToScreenPosition(s ? r.end : r.start), this.session.screenToDocumentPosition(n.row + e, n.column)), s ? (i = I.fromPoints(l, e)).cursor = i.start : (i = I.fromPoints(e, l)).cursor = i.end, i.desiredColumn = a.column, this.selection.inMultiSelectMode ? t && (o = r.cursor) : this.selection.addRange(r), this.selection.addRange(i), o && this.selection.substractPoint(o);
                    }, this.transposeSelections = function(e) {
                        for(var t = this.session, n = t.multiSelect, i = n.ranges, o = i.length; o--;)(s = i[o]).isEmpty() && (a = t.getWordRange(s.start.row, s.start.column), s.start.row = a.start.row, s.start.column = a.start.column, s.end.row = a.end.row, s.end.column = a.end.column);
                        n.mergeOverlappingRanges();
                        for(var r = [], o = i.length; o--;){
                            var s = i[o];
                            r.unshift(t.getTextRange(s));
                        }
                        e < 0 ? r.unshift(r.pop()) : r.push(r.shift());
                        for(o = i.length; o--;){
                            var a = (s = i[o]).clone();
                            t.replace(s, r[o]), s.start.row = a.start.row, s.start.column = a.start.column;
                        }
                        n.fromOrientedRange(n.ranges[0]);
                    }, this.selectMore = function(e, t, n) {
                        var i, o = this.session, r = o.multiSelect.toOrientedRange();
                        r.isEmpty() && ((r = o.getWordRange(r.start.row, r.start.column)).cursor = -1 == e ? r.start : r.end, this.multiSelect.addRange(r), n) || (n = o.getTextRange(r), o, n, i = e, l.$options.wrap = !0, l.$options.needle = n, l.$options.backwards = -1 == i, (n = l.find(o)) && (n.cursor = -1 == e ? n.start : n.end, this.session.unfold(n), this.multiSelect.addRange(n), this.renderer.scrollCursorIntoView(null, .5)), t && this.multiSelect.substractPoint(r.cursor));
                    }, this.alignCursors = function() {
                        var o = this.session, t = o.multiSelect, e = t.ranges, n = -1, i = e.filter(function(e) {
                            if (e.cursor.row == n) return !0;
                            n = e.cursor.row;
                        });
                        if (e.length && i.length != e.length - 1) {
                            i.forEach(function(e) {
                                t.substractPoint(e.cursor);
                            });
                            var r = 0, s = 1 / 0, a = e.map(function(e) {
                                var e = e.cursor, t = o.getLine(e.row).substr(e.column).search(/\S/g);
                                return e.column > r && (r = e.column), (t = -1 == t ? 0 : t) < s && (s = t), t;
                            });
                            e.forEach(function(e, t) {
                                var n = e.cursor, i = r - n.column, t = a[t] - s;
                                t < i ? o.insert(n, g.stringRepeat(" ", i - t)) : o.remove(new I(n.row, n.column, n.row, n.column - i + t)), e.start.column = e.end.column = r, e.start.row = e.end.row = n.row, e.cursor = e.end;
                            }), t.fromOrientedRange(e[0]), this.renderer.updateCursor(), this.renderer.updateBackMarkers();
                        } else {
                            var i = this.selection.getRange(), l = i.start.row, c = i.end.row, e = l == c;
                            if (e) {
                                for(var h, d = this.session.getLength(); h = this.session.getLine(c), /[=:]/.test(h) && ++c < d;);
                                for(; h = this.session.getLine(l), /[=:]/.test(h) && 0 < --l;);
                                l < 0 && (l = 0), d <= c && (c = d - 1);
                            }
                            var u = this.session.removeFullLines(l, c), u = this.$reAlignText(u, e);
                            this.session.insert({
                                row: l,
                                column: 0
                            }, u.join("\n") + "\n"), e || (i.start.column = 0, i.end.column = u[u.length - 1].length), this.selection.setRange(i);
                        }
                    }, this.$reAlignText = function(e, t) {
                        var n, i, o, r = !0, s = !0;
                        return e.map(function(e) {
                            var t = e.match(/(\s*)(.*?)(\s*)([=:].*)/);
                            return t ? (null == n ? (n = t[1].length, i = t[2].length, o = t[3].length) : (n + i + o != t[1].length + t[2].length + t[3].length && (s = !1), n != t[1].length && (r = !1), n > t[1].length && (n = t[1].length), i < t[2].length && (i = t[2].length), o > t[3].length && (o = t[3].length)), t) : [
                                e
                            ];
                        }).map(t ? l : r ? s ? function(e) {
                            return e[2] ? a(n + i - e[2].length) + e[2] + a(o) + e[4].replace(/^([=:])\s+/, "$1 ") : e[0];
                        } : l : function(e) {
                            return e[2] ? a(n) + e[2] + a(o) + e[4].replace(/^([=:])\s+/, "$1 ") : e[0];
                        });
                        function a(e) {
                            return g.stringRepeat(" ", e);
                        }
                        function l(e) {
                            return e[2] ? a(n) + e[2] + a(i - e[2].length + o) + e[4].replace(/^([=:])\s+/, "$1 ") : e[0];
                        }
                    };
                }).call(i.prototype), o.onSessionChange = function(e) {
                    var t = e.session, e = (t && !t.multiSelect && (t.$selectionMarkers = [], t.selection.$initRangeList(), t.multiSelect = t.selection), this.multiSelect = t && t.multiSelect, e.oldSession);
                    e && (e.multiSelect.off("addRange", this.$onAddRange), e.multiSelect.off("removeRange", this.$onRemoveRange), e.multiSelect.off("multiSelect", this.$onMultiSelect), e.multiSelect.off("singleSelect", this.$onSingleSelect), e.multiSelect.lead.off("change", this.$checkMultiselectChange), e.multiSelect.anchor.off("change", this.$checkMultiselectChange)), t && (t.multiSelect.on("addRange", this.$onAddRange), t.multiSelect.on("removeRange", this.$onRemoveRange), t.multiSelect.on("multiSelect", this.$onMultiSelect), t.multiSelect.on("singleSelect", this.$onSingleSelect), t.multiSelect.lead.on("change", this.$checkMultiselectChange), t.multiSelect.anchor.on("change", this.$checkMultiselectChange)), t && this.inMultiSelectMode != t.selection.inMultiSelectMode && (t.selection.inMultiSelectMode ? this.$onMultiSelect() : this.$onSingleSelect());
                }, o.MultiSelect = c, e("./config").defineOptions(i.prototype, "editor", {
                    enableMultiselect: {
                        set: function(e) {
                            c(this), e ? (this.on("changeSession", this.$multiselectOnSessionChange), this.on("mousedown", r)) : (this.off("changeSession", this.$multiselectOnSessionChange), this.off("mousedown", r));
                        },
                        value: !0
                    },
                    enableBlockSelect: {
                        set: function(e) {
                            this.$blockSelectEnabled = e;
                        },
                        value: !0
                    }
                });
            }), ace.define("ace/mode/folding/fold_mode", [
                "require",
                "exports",
                "module",
                "ace/range"
            ], function(e, t, n) {
                "use strict";
                var h = e("../../range").Range, e = t.FoldMode = function() {};
                (function() {
                    this.foldingStartMarker = null, this.foldingStopMarker = null, this.getFoldWidget = function(e, t, n) {
                        e = e.getLine(n);
                        return this.foldingStartMarker.test(e) ? "start" : "markbeginend" == t && this.foldingStopMarker && this.foldingStopMarker.test(e) ? "end" : "";
                    }, this.getFoldWidgetRange = function(e, t, n) {
                        return null;
                    }, this.indentationBlock = function(e, t, n) {
                        var i = /\S/, o = e.getLine(t), r = o.search(i);
                        if (-1 != r) {
                            for(var s, n = n || o.length, a = e.getLength(), o = t, l = t; ++t < a;){
                                var c = e.getLine(t).search(i);
                                if (-1 != c) {
                                    if (c <= r) {
                                        c = e.getTokenAt(t, 0);
                                        if (!c || "string" !== c.type) break;
                                    }
                                    l = t;
                                }
                            }
                            return o < l ? (s = e.getLine(l).length, new h(o, n, l, s)) : void 0;
                        }
                    }, this.openingBracketBlock = function(e, t, n, i, o) {
                        n = {
                            row: n,
                            column: i + 1
                        }, i = e.$findClosingBracket(t, n, o);
                        if (i) return "start" == (t = null == (t = e.foldWidgets[i.row]) ? e.getFoldWidget(i.row) : t) && i.row > n.row && (i.row--, i.column = e.getLine(i.row).length), h.fromPoints(n, i);
                    }, this.closingBracketBlock = function(e, t, n, i, o) {
                        n = {
                            row: n,
                            column: i
                        }, i = e.$findOpeningBracket(t, n);
                        if (i) return i.column++, n.column--, h.fromPoints(i, n);
                    };
                }).call(e.prototype);
            }), ace.define("ace/ext/error_marker", [
                "require",
                "exports",
                "module",
                "ace/line_widgets",
                "ace/lib/dom",
                "ace/range",
                "ace/config"
            ], function(e, t, n) {
                "use strict";
                var c = e("../line_widgets").LineWidgets, h = e("../lib/dom"), a = e("../range").Range, d = e("../config").nls;
                function u(e, t, n) {
                    var i = e.getAnnotations().sort(a.comparePoints);
                    if (i.length) {
                        var o = function(e, t, n) {
                            for(var i = 0, o = e.length - 1; i <= o;){
                                var r = i + o >> 1, s = n(t, e[r]);
                                if (0 < s) i = 1 + r;
                                else {
                                    if (!(s < 0)) return r;
                                    o = r - 1;
                                }
                            }
                            return -(i + 1);
                        }(i, {
                            row: t,
                            column: -1
                        }, a.comparePoints), r = ((o = o < 0 ? -o - 1 : o) >= i.length ? o = 0 < n ? 0 : i.length - 1 : 0 === o && n < 0 && (o = i.length - 1), i[o]);
                        if (r && n) {
                            if (r.row === t) {
                                for(; (r = i[o += n]) && r.row === t;);
                                if (!r) return i.slice();
                            }
                            var s = [];
                            for(t = r.row; s[n < 0 ? "unshift" : "push"](r), (r = i[o += n]) && r.row == t;);
                            return s.length && s;
                        }
                    }
                }
                t.showErrorMarker = function(e, t) {
                    var n, i = e.session, o = (i.widgetManager || (i.widgetManager = new c(i), i.widgetManager.attach(e)), e.getCursorPosition()), r = o.row, s = i.widgetManager.getWidgetsAtRow(r).filter(function(e) {
                        return "errorMarker" == e.type;
                    })[0], r = (s ? s.destroy() : r -= t, u(i, r, t));
                    if (r) {
                        t = r[0];
                        o.column = (t.pos && "number" != typeof t.column ? t.pos.sc : t.column) || 0, o.row = t.row, n = e.renderer.$gutterLayer.$annotations[o.row];
                    } else {
                        if (s) return;
                        n = {
                            text: [
                                d("Looks good!")
                            ],
                            className: "ace_ok"
                        };
                    }
                    e.session.unfold(o.row), e.selection.moveToPosition(o);
                    function a(e, t, n) {
                        if (0 === t && ("esc" === n || "return" === n)) return l.destroy(), {
                            command: "null"
                        };
                    }
                    var l = {
                        row: o.row,
                        fixedWidth: !0,
                        coverGutter: !0,
                        el: h.createElement("div"),
                        type: "errorMarker"
                    }, r = l.el.appendChild(h.createElement("div")), t = l.el.appendChild(h.createElement("div")), s = (t.className = "error_widget_arrow " + n.className, e.renderer.$cursorLayer.getPixelPosition(o).left);
                    t.style.left = s + e.renderer.gutterWidth - 5 + "px", l.el.className = "error_widget_wrapper", r.className = "error_widget " + n.className, r.innerHTML = n.text.join("<br>"), r.appendChild(h.createElement("div"));
                    l.destroy = function() {
                        e.$mouseHandler.isMousePressed || (e.keyBinding.removeKeyboardHandler(a), i.widgetManager.removeLineWidget(l), e.off("changeSelection", l.destroy), e.off("changeSession", l.destroy), e.off("mouseup", l.destroy), e.off("change", l.destroy));
                    }, e.keyBinding.addKeyboardHandler(a), e.on("changeSelection", l.destroy), e.on("changeSession", l.destroy), e.on("mouseup", l.destroy), e.on("change", l.destroy), e.session.widgetManager.addLineWidget(l), l.el.onmousedown = e.focus.bind(e), e.renderer.scrollCursorIntoView(null, .5, {
                        bottom: l.el.offsetHeight
                    });
                }, h.importCssString("\n    .error_widget_wrapper {\n        background: inherit;\n        color: inherit;\n        border:none\n    }\n    .error_widget {\n        border-top: solid 2px;\n        border-bottom: solid 2px;\n        margin: 5px 0;\n        padding: 10px 40px;\n        white-space: pre-wrap;\n    }\n    .error_widget.ace_error, .error_widget_arrow.ace_error{\n        border-color: #ff5a5a\n    }\n    .error_widget.ace_warning, .error_widget_arrow.ace_warning{\n        border-color: #F1D817\n    }\n    .error_widget.ace_info, .error_widget_arrow.ace_info{\n        border-color: #5a5a5a\n    }\n    .error_widget.ace_ok, .error_widget_arrow.ace_ok{\n        border-color: #5aaa5a\n    }\n    .error_widget_arrow {\n        position: absolute;\n        border: solid 5px;\n        border-top-color: transparent!important;\n        border-right-color: transparent!important;\n        border-left-color: transparent!important;\n        top: -5px;\n    }\n", "error_marker.css", !1);
            }), ace.define("ace/ace", [
                "require",
                "exports",
                "module",
                "ace/lib/dom",
                "ace/range",
                "ace/editor",
                "ace/edit_session",
                "ace/undomanager",
                "ace/virtual_renderer",
                "ace/worker/worker_client",
                "ace/keyboard/hash_handler",
                "ace/placeholder",
                "ace/multi_select",
                "ace/mode/folding/fold_mode",
                "ace/theme/textmate",
                "ace/ext/error_marker",
                "ace/config",
                "ace/loader_build"
            ], function(e, r, t) {
                "use strict";
                e("./loader_build")(r);
                var s = e("./lib/dom"), n = e("./range").Range, a = e("./editor").Editor, i = e("./edit_session").EditSession, o = e("./undomanager").UndoManager, l = e("./virtual_renderer").VirtualRenderer;
                e("./worker/worker_client"), e("./keyboard/hash_handler"), e("./placeholder"), e("./multi_select"), e("./mode/folding/fold_mode"), e("./theme/textmate"), e("./ext/error_marker"), r.config = e("./config"), r.edit = function(e, t) {
                    if ("string" == typeof e) {
                        var n = e;
                        if (!(e = document.getElementById(n))) throw new Error("ace.edit can't find div #" + n);
                    }
                    var i, o;
                    return e && e.env && e.env.editor instanceof a ? e.env.editor : (n = "", e && /input|textarea/i.test(e.tagName) ? (n = (i = e).value, e = s.createElement("pre"), i.parentNode.replaceChild(e, i)) : e && (n = e.textContent, e.innerHTML = ""), n = r.createEditSession(n), e = new a(new l(e), n, t), o = {
                        document: n,
                        editor: e,
                        onResize: e.resize.bind(e, null)
                    }, i && (o.textarea = i), e.on("destroy", function() {
                        o.editor.container.env = null;
                    }), e.container.env = e.env = o, e);
                }, r.createEditSession = function(e, t) {
                    e = new i(e, t);
                    return e.setUndoManager(new o), e;
                }, r.Range = n, r.Editor = a, r.EditSession = i, r.UndoManager = o, r.VirtualRenderer = l, r.version = r.config.version;
            }), ace.require([
                "ace/ace"
            ], function(e) {
                for(var t in e && (e.config.init(!0), e.define = ace.define), window.ace || (window.ace = e), e)e.hasOwnProperty(t) && (window.ace[t] = e[t]);
                window.ace.default = window.ace, n && (n.exports = window.ace);
            });
        },
        4317: function(t, e, n) {
            t = n.nmd(t), ace.define("ace/snippets", [
                "require",
                "exports",
                "module",
                "ace/lib/dom",
                "ace/lib/oop",
                "ace/lib/event_emitter",
                "ace/lib/lang",
                "ace/range",
                "ace/range_list",
                "ace/keyboard/hash_handler",
                "ace/tokenizer",
                "ace/clipboard",
                "ace/editor"
            ], function(e, s, t) {
                "use strict";
                var n = e("./lib/dom"), i = e("./lib/oop"), o = e("./lib/event_emitter").EventEmitter, c = e("./lib/lang"), h = e("./range").Range, d = e("./range_list").RangeList, r = e("./keyboard/hash_handler").HashHandler, a = e("./tokenizer").Tokenizer, l = e("./clipboard"), u = {
                    CURRENT_WORD: function(e) {
                        return e.session.getTextRange(e.session.getWordRange());
                    },
                    SELECTION: function(e, t, n) {
                        e = e.session.getTextRange();
                        return n ? e.replace(/\n\r?([ \t]*\S)/g, "\n" + n + "$1") : e;
                    },
                    CURRENT_LINE: function(e) {
                        return e.session.getLine(e.getCursorPosition().row);
                    },
                    PREV_LINE: function(e) {
                        return e.session.getLine(e.getCursorPosition().row - 1);
                    },
                    LINE_INDEX: function(e) {
                        return e.getCursorPosition().row;
                    },
                    LINE_NUMBER: function(e) {
                        return e.getCursorPosition().row + 1;
                    },
                    SOFT_TABS: function(e) {
                        return e.session.getUseSoftTabs() ? "YES" : "NO";
                    },
                    TAB_SIZE: function(e) {
                        return e.session.getTabSize();
                    },
                    CLIPBOARD: function(e) {
                        return l.getText && l.getText();
                    },
                    FILENAME: function(e) {
                        return /[^/\\]*$/.exec(this.FILEPATH(e))[0];
                    },
                    FILENAME_BASE: function(e) {
                        return /[^/\\]*$/.exec(this.FILEPATH(e))[0].replace(/\.[^.]*$/, "");
                    },
                    DIRECTORY: function(e) {
                        return this.FILEPATH(e).replace(/[^/\\]*$/, "");
                    },
                    FILEPATH: function(e) {
                        return "/not implemented.txt";
                    },
                    WORKSPACE_NAME: function() {
                        return "Unknown";
                    },
                    FULLNAME: function() {
                        return "Unknown";
                    },
                    BLOCK_COMMENT_START: function(e) {
                        e = e.session.$mode || {};
                        return e.blockComment && e.blockComment.start || "";
                    },
                    BLOCK_COMMENT_END: function(e) {
                        e = e.session.$mode || {};
                        return e.blockComment && e.blockComment.end || "";
                    },
                    LINE_COMMENT: function(e) {
                        return (e.session.$mode || {}).lineCommentStart || "";
                    },
                    CURRENT_YEAR: g.bind(null, {
                        year: "numeric"
                    }),
                    CURRENT_YEAR_SHORT: g.bind(null, {
                        year: "2-digit"
                    }),
                    CURRENT_MONTH: g.bind(null, {
                        month: "numeric"
                    }),
                    CURRENT_MONTH_NAME: g.bind(null, {
                        month: "long"
                    }),
                    CURRENT_MONTH_NAME_SHORT: g.bind(null, {
                        month: "short"
                    }),
                    CURRENT_DATE: g.bind(null, {
                        day: "2-digit"
                    }),
                    CURRENT_DAY_NAME: g.bind(null, {
                        weekday: "long"
                    }),
                    CURRENT_DAY_NAME_SHORT: g.bind(null, {
                        weekday: "short"
                    }),
                    CURRENT_HOUR: g.bind(null, {
                        hour: "2-digit",
                        hour12: !1
                    }),
                    CURRENT_MINUTE: g.bind(null, {
                        minute: "2-digit"
                    }),
                    CURRENT_SECOND: g.bind(null, {
                        second: "2-digit"
                    })
                };
                function g(e) {
                    e = (new Date).toLocaleString("en-us", e);
                    return 1 == e.length ? "0" + e : e;
                }
                u.SELECTED_TEXT = u.SELECTION;
                function p() {
                    this.snippetMap = {}, this.snippetNameMap = {};
                }
                (function() {
                    i.implement(this, o), this.getTokenizer = function() {
                        return p.$tokenizer || this.createTokenizer();
                    }, this.createTokenizer = function() {
                        function i(e) {
                            return e = e.substr(1), /^\d+$/.test(e) ? [
                                {
                                    tabstopId: parseInt(e, 10)
                                }
                            ] : [
                                {
                                    text: e
                                }
                            ];
                        }
                        function e(e) {
                            return "(?:[^\\\\" + e + "]|\\\\.)";
                        }
                        var t = {
                            regex: "/(" + e("/") + "+)/",
                            onMatch: function(e, t, n) {
                                n = n[0];
                                return n.fmtString = !0, n.guard = e.slice(1, -1), n.flag = "";
                            },
                            next: "formatString"
                        };
                        return p.$tokenizer = new a({
                            start: [
                                {
                                    regex: /\\./,
                                    onMatch: function(e, t, n) {
                                        var i = e[1];
                                        return [
                                            e = "}" == i && n.length || -1 != "`$\\".indexOf(i) ? i : e
                                        ];
                                    }
                                },
                                {
                                    regex: /}/,
                                    onMatch: function(e, t, n) {
                                        return [
                                            n.length ? n.shift() : e
                                        ];
                                    }
                                },
                                {
                                    regex: /\$(?:\d+|\w+)/,
                                    onMatch: i
                                },
                                {
                                    regex: /\$\{[\dA-Z_a-z]+/,
                                    onMatch: function(e, t, n) {
                                        e = i(e.substr(1));
                                        return n.unshift(e[0]), e;
                                    },
                                    next: "snippetVar"
                                },
                                {
                                    regex: /\n/,
                                    token: "newline",
                                    merge: !1
                                }
                            ],
                            snippetVar: [
                                {
                                    regex: "\\|" + e("\\|") + "*\\|",
                                    onMatch: function(e, t, n) {
                                        e = e.slice(1, -1).replace(/\\[,|\\]|,/g, function(e) {
                                            return 2 == e.length ? e[1] : "\0";
                                        }).split("\0").map(function(e) {
                                            return {
                                                value: e
                                            };
                                        });
                                        return [
                                            (n[0].choices = e)[0]
                                        ];
                                    },
                                    next: "start"
                                },
                                t,
                                {
                                    regex: "([^:}\\\\]|\\\\.)*:?",
                                    token: "",
                                    next: "start"
                                }
                            ],
                            formatString: [
                                {
                                    regex: /:/,
                                    onMatch: function(e, t, n) {
                                        return n.length && n[0].expectElse ? (n[0].expectElse = !1, n[0].ifEnd = {
                                            elseEnd: n[0]
                                        }, [
                                            n[0].ifEnd
                                        ]) : ":";
                                    }
                                },
                                {
                                    regex: /\\./,
                                    onMatch: function(e, t, n) {
                                        var i = e[1];
                                        return "}" == i && n.length || -1 != "`$\\".indexOf(i) ? e = i : "n" == i ? e = "\n" : "t" == i ? e = "\t" : -1 != "ulULE".indexOf(i) && (e = {
                                            changeCase: i,
                                            local: "a" < i
                                        }), [
                                            e
                                        ];
                                    }
                                },
                                {
                                    regex: "/\\w*}",
                                    onMatch: function(e, t, n) {
                                        n = n.shift();
                                        return n && (n.flag = e.slice(1, -1)), this.next = n && n.tabstopId ? "start" : "", [
                                            n || e
                                        ];
                                    },
                                    next: "start"
                                },
                                {
                                    regex: /\$(?:\d+|\w+)/,
                                    onMatch: function(e, t, n) {
                                        return [
                                            {
                                                text: e.slice(1)
                                            }
                                        ];
                                    }
                                },
                                {
                                    regex: /\${\w+/,
                                    onMatch: function(e, t, n) {
                                        e = {
                                            text: e.slice(2)
                                        };
                                        return n.unshift(e), [
                                            e
                                        ];
                                    },
                                    next: "formatStringVar"
                                },
                                {
                                    regex: /\n/,
                                    token: "newline",
                                    merge: !1
                                },
                                {
                                    regex: /}/,
                                    onMatch: function(e, t, n) {
                                        n = n.shift();
                                        return this.next = n && n.tabstopId ? "start" : "", [
                                            n || e
                                        ];
                                    },
                                    next: "start"
                                }
                            ],
                            formatStringVar: [
                                {
                                    regex: /:\/\w+}/,
                                    onMatch: function(e, t, n) {
                                        return n[0].formatFunction = e.slice(2, -1), [
                                            n.shift()
                                        ];
                                    },
                                    next: "formatString"
                                },
                                t,
                                {
                                    regex: /:[\?\-+]?/,
                                    onMatch: function(e, t, n) {
                                        "+" == e[1] && (n[0].ifEnd = n[0]), "?" == e[1] && (n[0].expectElse = !0);
                                    },
                                    next: "formatString"
                                },
                                {
                                    regex: "([^:}\\\\]|\\\\.)*:?",
                                    token: "",
                                    next: "formatString"
                                }
                            ]
                        });
                    }, this.tokenizeTmSnippet = function(e, t) {
                        return this.getTokenizer().getLineTokens(e, t).tokens.map(function(e) {
                            return e.value || e;
                        });
                    }, this.getVariableValue = function(e, t, n) {
                        var i;
                        return /^\d+$/.test(t) ? (this.variables.__ || {})[t] || "" : /^[A-Z]\d+$/.test(t) ? (this.variables[t[0] + "__"] || {})[t.substr(1)] || "" : (t = t.replace(/^TM_/, ""), !this.variables.hasOwnProperty(t) || null == (i = "function" == typeof (i = this.variables[t]) ? this.variables[t](e, t, n) : i) ? "" : i);
                    }, this.variables = u, this.tmStrFormat = function(e, t, s) {
                        var n, i, a, l;
                        return t.fmt ? (n = t.flag || "", i = t.guard, i = new RegExp(i, n.replace(/[^gim]/g, "")), a = "string" == typeof t.fmt ? this.tokenizeTmSnippet(t.fmt, "formatString") : t.fmt, l = this, e.replace(i, function() {
                            for(var e = l.variables.__, t = (l.variables.__ = [].slice.call(arguments), l.resolveVariables(a, s)), n = "E", i = 0; i < t.length; i++){
                                var o, r = t[i];
                                "object" == typeof r ? (t[i] = "", r.changeCase && r.local ? (o = t[i + 1]) && "string" == typeof o && ("u" == r.changeCase ? t[i] = o[0].toUpperCase() : t[i] = o[0].toLowerCase(), t[i + 1] = o.substr(1)) : r.changeCase && (n = r.changeCase)) : "U" == n ? t[i] = r.toUpperCase() : "L" == n && (t[i] = r.toLowerCase());
                            }
                            return l.variables.__ = e, t.join("");
                        })) : e;
                    }, this.tmFormatFunction = function(e, t, n) {
                        return "upcase" == t.formatFunction ? e.toUpperCase() : "downcase" == t.formatFunction ? e.toLowerCase() : e;
                    }, this.resolveVariables = function(t, e) {
                        for(var n = [], i = "", o = !0, r = 0; r < t.length; r++){
                            var s, a = t[r];
                            "string" == typeof a ? (n.push(a), "\n" == a ? (o = !0, i = "") : o && (i = /^\t*/.exec(a)[0], o = /\S/.test(a))) : a && (o = !1, a.fmtString && (-1 == (s = t.indexOf(a, r + 1)) && (s = t.length), a.fmt = t.slice(r + 1, s), r = s), a.text ? (s = this.getVariableValue(e, a.text, i) + "", a.fmtString && (s = this.tmStrFormat(s, a, e)), (s = a.formatFunction ? this.tmFormatFunction(s, a, e) : s) && !a.ifEnd ? (n.push(s), l(a)) : !s && a.ifEnd && l(a.ifEnd)) : a.elseEnd ? l(a.elseEnd) : null == a.tabstopId && null == a.changeCase || n.push(a));
                        }
                        function l(e) {
                            e = t.indexOf(e, r + 1);
                            -1 != e && (r = e);
                        }
                        return n;
                    };
                    function r(e, t, n) {
                        void 0 === n && (n = {});
                        for(var i = e.getCursorPosition(), o = e.session.getLine(i.row), r = e.session.getTabString(), s = o.match(/^\s*/)[0], a = (i.column < s.length && (s = s.slice(0, i.column)), t = t.replace(/\r/g, ""), this.tokenizeTmSnippet(t)), l = (a = (a = this.resolveVariables(a, e)).map(function(e) {
                            return "\n" != e || n.excludeExtraIndent ? "string" == typeof e ? e.replace(/\t/g, r) : e : e + s;
                        }), []), c = (a.forEach(function(e, t) {
                            var n, i, o;
                            "object" == typeof e && (o = e.tabstopId, (n = l[o]) || ((n = l[o] = []).index = o, n.value = "", n.parents = {}), -1 === n.indexOf(e)) && (e.choices && !n.choices && (n.choices = e.choices), n.push(e), -1 !== (i = a.indexOf(e, t + 1))) && ((o = a.slice(t + 1, i)).some(function(e) {
                                return "object" == typeof e;
                            }) && !n.value ? n.value = o : !o.length || n.value && "string" == typeof n.value || (n.value = o.join("")));
                        }), l.forEach(function(e) {
                            e.length = 0;
                        }), {}), h = 0; h < a.length; h++){
                            var d, u, g, p = a[h];
                            "object" == typeof p && (g = p.tabstopId, d = l[g], u = a.indexOf(p, h + 1), c[g] ? c[g] === p && (delete c[g], Object.keys(c).forEach(function(e) {
                                d.parents[e] = !0;
                            })) : (c[g] = p, "string" != typeof (g = d.value) ? g = function(e) {
                                for(var t = [], n = 0; n < e.length; n++){
                                    if ("object" == typeof (i = e[n])) {
                                        if (c[i.tabstopId]) continue;
                                        var i = t[e.lastIndexOf(i, n - 1)] || {
                                            tabstopId: i.tabstopId
                                        };
                                    }
                                    t[n] = i;
                                }
                                return t;
                            }(g) : p.fmt && (g = this.tmStrFormat(g, p, e)), a.splice.apply(a, [
                                h + 1,
                                Math.max(0, u - h)
                            ].concat(g, p)), -1 === d.indexOf(p) && d.push(p)));
                        }
                        var m = 0, f = 0, C = "";
                        return a.forEach(function(e) {
                            var t;
                            "string" == typeof e ? (1 < (t = e.split("\n")).length ? (f = t[t.length - 1].length, m += t.length - 1) : f += e.length, C += e) : e && (e.start ? e.end = {
                                row: m,
                                column: f
                            } : e.start = {
                                row: m,
                                column: f
                            });
                        }), {
                            text: C,
                            tabstops: l,
                            tokens: a
                        };
                    }
                    this.getDisplayTextForSnippet = function(e, t) {
                        return r.call(this, e, t).text;
                    }, this.insertSnippetForSelection = function(e, t, n) {
                        var t = r.call(this, e, t, n = void 0 === n ? {} : n), i = e.getSelectionRange(), n = (n.range && 0 === n.range.compareRange(i) && (i = n.range), e.session.replace(i, t.text)), o = new m(e), e = e.inVirtualSelectionMode && e.selection.index;
                        o.addTabstops(t.tabstops, i.start, n, e);
                    }, this.insertSnippet = function(e, t, n) {
                        var i = this;
                        if (!(n = void 0 === n ? {} : n).range || n.range instanceof h || (n.range = h.fromPoints(n.range.start, n.range.end)), e.inVirtualSelectionMode) return i.insertSnippetForSelection(e, t, n);
                        e.forEachSelection(function() {
                            i.insertSnippetForSelection(e, t, n);
                        }, null, {
                            keepOrder: !0
                        }), e.tabstopManager && e.tabstopManager.tabNext();
                    }, this.$getScope = function(e) {
                        var t, n = e.session.$mode.$id || "";
                        return "html" !== (n = n.split("/").pop()) && "php" !== n || ("php" !== n || e.session.$mode.inlinePhp || (n = "html"), t = e.getCursorPosition(), (e = "object" == typeof (e = e.session.getState(t.row)) ? e[0] : e).substring && ("js-" == e.substring(0, 3) ? n = "javascript" : "css-" == e.substring(0, 4) ? n = "css" : "php-" == e.substring(0, 4) && (n = "php"))), n;
                    }, this.getActiveScopes = function(e) {
                        var e = this.$getScope(e), t = [
                            e
                        ], n = this.snippetMap;
                        return n[e] && n[e].includeScopes && t.push.apply(t, n[e].includeScopes), t.push("_"), t;
                    }, this.expandWithTab = function(e, t) {
                        var n = this, i = e.forEachSelection(function() {
                            return n.expandSnippetForSelection(e, t);
                        }, null, {
                            keepOrder: !0
                        });
                        return i && e.tabstopManager && e.tabstopManager.tabNext(), i;
                    }, this.expandSnippetForSelection = function(e, t) {
                        var n, i = e.getCursorPosition(), o = e.session.getLine(i.row), r = o.substring(0, i.column), s = o.substr(i.column), a = this.snippetMap;
                        return this.getActiveScopes(e).some(function(e) {
                            e = a[e];
                            return !!(n = e ? this.findMatchingSnippet(e, r, s) : n);
                        }, this), !!n && (t && t.dryRun || (e.session.doc.removeInLine(i.row, i.column - n.replaceBefore.length, i.column + n.replaceAfter.length), this.variables.M__ = n.matchBefore, this.variables.T__ = n.matchAfter, this.insertSnippetForSelection(e, n.content), this.variables.M__ = this.variables.T__ = null), !0);
                    }, this.findMatchingSnippet = function(e, t, n) {
                        for(var i = e.length; i--;){
                            var o = e[i];
                            if ((!o.startRe || o.startRe.test(t)) && (!o.endRe || o.endRe.test(n)) && (o.startRe || o.endRe)) return o.matchBefore = o.startRe ? o.startRe.exec(t) : [
                                ""
                            ], o.matchAfter = o.endRe ? o.endRe.exec(n) : [
                                ""
                            ], o.replaceBefore = o.triggerRe ? o.triggerRe.exec(t)[0] : "", o.replaceAfter = o.endTriggerRe ? o.endTriggerRe.exec(n)[0] : "", o;
                        }
                    }, this.snippetMap = {}, this.snippetNameMap = {}, this.register = function(t, i) {
                        var o = this.snippetMap, r = this.snippetNameMap, s = this;
                        function a(e) {
                            return (e = e && !/^\^?\(.*\)\$?$|^\\b$/.test(e) ? "(?:" + e + ")" : e) || "";
                        }
                        function l(e, t, n) {
                            return e = a(e), t = a(t), n ? (e = t + e) && "$" != e[e.length - 1] && (e += "$") : (e += t) && "^" != e[0] && (e = "^" + e), new RegExp(e);
                        }
                        function n(e) {
                            e.scope || (e.scope = i || "_"), i = e.scope, o[i] || (o[i] = [], r[i] = {});
                            var t, n = r[i];
                            e.name && ((t = n[e.name]) && s.unregister(t), n[e.name] = e), o[i].push(e), e.prefix && (e.tabTrigger = e.prefix), !e.content && e.body && (e.content = Array.isArray(e.body) ? e.body.join("\n") : e.body), e.tabTrigger && !e.trigger && (!e.guard && /^\w/.test(e.tabTrigger) && (e.guard = "\\b"), e.trigger = c.escapeRegExp(e.tabTrigger)), (e.trigger || e.guard || e.endTrigger || e.endGuard) && (e.startRe = l(e.trigger, e.guard, !0), e.triggerRe = new RegExp(e.trigger), e.endRe = l(e.endTrigger, e.endGuard, !0), e.endTriggerRe = new RegExp(e.endTrigger));
                        }
                        t = t || [], Array.isArray(t) ? t.forEach(n) : Object.keys(t).forEach(function(e) {
                            n(t[e]);
                        }), this._signal("registerSnippets", {
                            scope: i
                        });
                    }, this.unregister = function(e, n) {
                        var i = this.snippetMap, o = this.snippetNameMap;
                        function t(e) {
                            var t = o[e.scope || n];
                            t && t[e.name] && (delete t[e.name], 0 <= (e = (t = i[e.scope || n]) && t.indexOf(e))) && t.splice(e, 1);
                        }
                        e.content ? t(e) : Array.isArray(e) && e.forEach(t);
                    }, this.parseSnippetFile = function(e) {
                        e = e.replace(/\r/g, "");
                        for(var t, n, i, o = [], r = {}, s = /^#.*|^({[\s\S]*})\s*$|^(\S+) (.*)$|^((?:\n*\t.*)+)/gm; n = s.exec(e);){
                            if (n[1]) try {
                                r = JSON.parse(n[1]), o.push(r);
                            } catch (e) {}
                            n[4] ? (r.content = n[4].replace(/^\t/gm, ""), o.push(r), r = {}) : (t = n[2], n = n[3], "regex" == t ? (r.guard = (i = /\/((?:[^\/\\]|\\.)*)|$/g).exec(n)[1], r.trigger = i.exec(n)[1], r.endTrigger = i.exec(n)[1], r.endGuard = i.exec(n)[1]) : "snippet" == t ? (r.tabTrigger = n.match(/^\S*/)[0], r.name || (r.name = n)) : t && (r[t] = n));
                        }
                        return o;
                    }, this.getSnippetByName = function(t, e) {
                        var n, i = this.snippetNameMap;
                        return this.getActiveScopes(e).some(function(e) {
                            e = i[e];
                            return !!(n = e ? e[t] : n);
                        }, this), n;
                    };
                }).call(p.prototype);
                var m = function(e) {
                    if (e.tabstopManager) return e.tabstopManager;
                    (e.tabstopManager = this).$onChange = this.onChange.bind(this), this.$onChangeSelection = c.delayedCall(this.onChangeSelection.bind(this)).schedule, this.$onChangeSession = this.onChangeSession.bind(this), this.$onAfterExec = this.onAfterExec.bind(this), this.attach(e);
                }, f = ((function() {
                    this.attach = function(e) {
                        this.index = 0, this.ranges = [], this.tabstops = [], this.$openTabstops = null, this.selectedTabstop = null, this.editor = e, this.editor.on("change", this.$onChange), this.editor.on("changeSelection", this.$onChangeSelection), this.editor.on("changeSession", this.$onChangeSession), this.editor.commands.on("afterExec", this.$onAfterExec), this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
                    }, this.detach = function() {
                        this.tabstops.forEach(this.removeTabstopMarkers, this), this.ranges = null, this.tabstops = null, this.selectedTabstop = null, this.editor.removeListener("change", this.$onChange), this.editor.removeListener("changeSelection", this.$onChangeSelection), this.editor.removeListener("changeSession", this.$onChangeSession), this.editor.commands.removeListener("afterExec", this.$onAfterExec), this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler), this.editor.tabstopManager = null, this.editor = null;
                    }, this.onChange = function(e) {
                        for(var t = "r" == e.action[0], n = this.selectedTabstop || {}, i = n.parents || {}, o = (this.tabstops || []).slice(), r = 0; r < o.length; r++){
                            var s = o[r], a = s == n || i[s.index];
                            if (s.rangeList.$bias = a ? 0 : 1, "remove" == e.action && s !== n) for(var a = s.parents && s.parents[n.index], l = (l = s.rangeList.pointIndex(e.start, a)) < 0 ? -l - 1 : l + 1, a = s.rangeList.pointIndex(e.end, a), c = s.rangeList.ranges.slice(l, a < 0 ? -a - 1 : a - 1), h = 0; h < c.length; h++)this.removeRange(c[h]);
                            s.rangeList.$onChange(e);
                        }
                        var d = this.editor.session;
                        this.$inChange || !t || 1 != d.getLength() || d.getValue() || this.detach();
                    }, this.updateLinkedFields = function() {
                        var e = this.selectedTabstop;
                        if (e && e.hasLinkedRanges && e.firstNonLinked) {
                            this.$inChange = !0;
                            for(var t = this.editor.session, n = t.getTextRange(e.firstNonLinked), i = 0; i < e.length; i++){
                                var o, r = e[i];
                                r.linked && (o = r.original, o = s.snippetManager.tmStrFormat(n, o, this.editor), t.replace(r, o));
                            }
                            this.$inChange = !1;
                        }
                    }, this.onAfterExec = function(e) {
                        e.command && !e.command.readOnly && this.updateLinkedFields();
                    }, this.onChangeSelection = function() {
                        if (this.editor) {
                            for(var e = this.editor.selection.lead, t = this.editor.selection.anchor, n = this.editor.selection.isEmpty(), i = 0; i < this.ranges.length; i++)if (!this.ranges[i].linked) {
                                var o = this.ranges[i].contains(e.row, e.column), r = n || this.ranges[i].contains(t.row, t.column);
                                if (o && r) return;
                            }
                            this.detach();
                        }
                    }, this.onChangeSession = function() {
                        this.detach();
                    }, this.tabNext = function(e) {
                        var t = this.tabstops.length, e = this.index + (e || 1), e = Math.min(Math.max(e, 1), t);
                        this.selectTabstop(e = e == t ? 0 : e), 0 === e && this.detach();
                    }, this.selectTabstop = function(e) {
                        this.$openTabstops = null;
                        var t = this.tabstops[this.index];
                        if (t && this.addTabstopMarkers(t), this.index = e, (t = this.tabstops[this.index]) && t.length) {
                            e = (this.selectedTabstop = t).firstNonLinked || t;
                            if (t.choices && (e.cursor = e.start), this.editor.inVirtualSelectionMode) this.editor.selection.fromOrientedRange(e);
                            else {
                                var n = this.editor.multiSelect;
                                n.toSingleRange(e);
                                for(var i = 0; i < t.length; i++)t.hasLinkedRanges && t[i].linked || n.addRange(t[i].clone(), !0);
                            }
                            this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler), this.selectedTabstop && this.selectedTabstop.choices && this.editor.execCommand("startAutocomplete", {
                                matches: this.selectedTabstop.choices
                            });
                        }
                    }, this.addTabstops = function(e, s, t) {
                        var a = this.useLink || !this.editor.getOption("enableMultiselect");
                        this.$openTabstops || (this.$openTabstops = []), e[0] || (t = h.fromPoints(t, t), C(t.start, s), C(t.end, s), e[0] = [
                            t
                        ], e[0].index = 0);
                        var l = [
                            this.index + 1,
                            0
                        ], c = this.ranges;
                        e.forEach(function(e, t) {
                            for(var n = this.$openTabstops[t] || e, i = 0; i < e.length; i++){
                                var o = e[i], r = h.fromPoints(o.start, o.end || o.start);
                                f(r.start, s), f(r.end, s), r.original = o, r.tabstop = n, c.push(r), n != e ? n.unshift(r) : n[i] = r, o.fmtString || n.firstNonLinked && a ? (r.linked = !0, n.hasLinkedRanges = !0) : n.firstNonLinked || (n.firstNonLinked = r);
                            }
                            n.firstNonLinked || (n.hasLinkedRanges = !1), n === e && (l.push(n), this.$openTabstops[t] = n), this.addTabstopMarkers(n), n.rangeList = n.rangeList || new d, n.rangeList.$bias = 0, n.rangeList.addList(n);
                        }, this), 2 < l.length && (this.tabstops.length && l.push(l.splice(2, 1)[0]), this.tabstops.splice.apply(this.tabstops, l));
                    }, this.addTabstopMarkers = function(e) {
                        var t = this.editor.session;
                        e.forEach(function(e) {
                            e.markerId || (e.markerId = t.addMarker(e, "ace_snippet-marker", "text"));
                        });
                    }, this.removeTabstopMarkers = function(e) {
                        var t = this.editor.session;
                        e.forEach(function(e) {
                            t.removeMarker(e.markerId), e.markerId = null;
                        });
                    }, this.removeRange = function(e) {
                        var t = e.tabstop.indexOf(e);
                        -1 != t && e.tabstop.splice(t, 1), -1 != (t = this.ranges.indexOf(e)) && this.ranges.splice(t, 1), -1 != (t = e.tabstop.rangeList.ranges.indexOf(e)) && e.tabstop.splice(t, 1), this.editor.session.removeMarker(e.markerId), e.tabstop.length || (-1 != (t = this.tabstops.indexOf(e.tabstop)) && this.tabstops.splice(t, 1), this.tabstops.length) || this.detach();
                    }, this.keyboardHandler = new r, this.keyboardHandler.bindKeys({
                        Tab: function(e) {
                            s.snippetManager && s.snippetManager.expandWithTab(e) || (e.tabstopManager.tabNext(1), e.renderer.scrollCursorIntoView());
                        },
                        "Shift-Tab": function(e) {
                            e.tabstopManager.tabNext(-1), e.renderer.scrollCursorIntoView();
                        },
                        Esc: function(e) {
                            e.tabstopManager.detach();
                        }
                    });
                }).call(m.prototype), function(e, t) {
                    0 == e.row && (e.column += t.column), e.row += t.row;
                }), C = function(e, t) {
                    e.row == t.row && (e.column -= t.column), e.row -= t.row;
                }, n = (n.importCssString("\n.ace_snippet-marker {\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n    background: rgba(194, 193, 208, 0.09);\n    border: 1px dotted rgba(211, 208, 235, 0.62);\n    position: absolute;\n}", "snippets.css", !1), s.snippetManager = new p, e("./editor").Editor);
                (function() {
                    this.insertSnippet = function(e, t) {
                        return s.snippetManager.insertSnippet(this, e, t);
                    }, this.expandSnippet = function(e) {
                        return s.snippetManager.expandWithTab(this, e);
                    };
                }).call(n.prototype);
            }), ace.define("ace/autocomplete/popup", [
                "require",
                "exports",
                "module",
                "ace/virtual_renderer",
                "ace/editor",
                "ace/range",
                "ace/lib/event",
                "ace/lib/lang",
                "ace/lib/dom",
                "ace/config"
            ], function(e, t, n) {
                "use strict";
                function a(e) {
                    return "suggest-aria-id:".concat(e);
                }
                function l(e) {
                    return (e = new o(e)).$maxLines = 4, (e = new r(e)).setHighlightActiveLine(!1), e.setShowPrintMargin(!1), e.renderer.setShowGutter(!1), e.renderer.setHighlightGutterLine(!1), e.$mouseHandler.$focusTimeout = 0, e.$highlightTagPending = !0, e;
                }
                function i(e) {
                    function t() {}
                    function n() {
                        s(-1);
                    }
                    var u, i = p.createElement("div"), g = new l(i), o = (e && e.appendChild(i), i.style.display = "none", g.renderer.content.style.cursor = "default", g.renderer.setStyle("ace_autocomplete"), g.renderer.container.setAttribute("role", "listbox"), g.renderer.container.setAttribute("aria-label", m("Autocomplete suggestions")), g.setOption("displayIndentGuides", !1), g.setOption("dragDelay", 150), g.focus = t, g.$isFocused = !0, g.renderer.$cursorLayer.restartTimer = t, g.renderer.$cursorLayer.element.style.opacity = 0, g.renderer.$maxLines = 8, g.renderer.$keepTextAreaAtCursor = !1, g.setHighlightActiveLine(!1), g.session.highlight(""), g.session.$searchHighlight.clazz = "ace_highlight-marker", g.on("mousedown", function(e) {
                        var t = e.getDocumentPosition();
                        g.selection.moveToPosition(t), r.start.row = r.end.row = t.row, e.stop();
                    }), new c(-1, 0, -1, 1 / 0)), r = new c(-1, 0, -1, 1 / 0), s = (r.id = g.session.addMarker(r, "ace_active-line", "fullLine"), g.setSelectOnHover = function(e) {
                        e ? o.id && (g.session.removeMarker(o.id), o.id = null) : o.id = g.session.addMarker(o, "ace_line-hover", "fullLine");
                    }, g.setSelectOnHover(!1), g.on("mousemove", function(e) {
                        var t;
                        u ? u.x == e.x && u.y == e.y || ((u = e).scrollTop = g.renderer.scrollTop, t = u.getDocumentPosition().row, o.start.row != t && (o.id || g.setRow(t), s(t))) : u = e;
                    }), g.renderer.on("beforeRender", function() {
                        var e;
                        u && -1 != o.start.row && (u.$pos = null, e = u.getDocumentPosition().row, o.id || g.setRow(e), s(e, !0));
                    }), g.renderer.on("afterRender", function() {
                        var e = g.getRow(), t = g.renderer.$textLayer, n = t.element.childNodes[e - t.config.firstRow], i = document.activeElement;
                        n !== t.selectedNode && t.selectedNode && (p.removeCssClass(t.selectedNode, "ace_selected"), i.removeAttribute("aria-activedescendant"), t.selectedNode.removeAttribute("id")), (t.selectedNode = n) && (p.addCssClass(n, "ace_selected"), t = a(e), n.id = t, g.renderer.container.setAttribute("aria-activedescendant", t), i.setAttribute("aria-activedescendant", t), n.setAttribute("role", "option"), n.setAttribute("aria-label", g.getData(e).value), n.setAttribute("aria-setsize", g.data.length), n.setAttribute("aria-posinset", e));
                    }), function(e, t) {
                        e !== o.start.row && (o.start.row = o.end.row = e, t || g.session._emit("changeBackMarker"), g._emit("changeHoverMarker"));
                    });
                    return g.getHoveredRow = function() {
                        return o.start.row;
                    }, h.addListener(g.container, "mouseout", n), g.on("hide", n), g.on("changeSelection", n), g.session.doc.getLength = function() {
                        return g.data.length;
                    }, g.session.doc.getLine = function(e) {
                        e = g.data[e];
                        return "string" == typeof e ? e : e && e.value || "";
                    }, (e = g.session.bgTokenizer).$tokenizeRow = function(e) {
                        var n = g.data[e], i = [];
                        if (n) {
                            for(var t, o, r = (n = "string" == typeof n ? {
                                value: n
                            } : n).caption || n.value || n.name, s = r.toLowerCase(), a = (g.filterText || "").toLowerCase(), l = 0, c = 0, h = 0; h <= a.length; h++)h != c && (n.matchMask & 1 << h || h == a.length) && (t = a.slice(c, h), c = h, -1 != (o = s.indexOf(t, l))) && (d(r.slice(l, o), ""), l = o + t.length, d(r.slice(o, l), "completion-highlight"));
                            d(r.slice(l, r.length), ""), n.meta && i.push({
                                type: "completion-meta",
                                value: n.meta
                            }), n.message && i.push({
                                type: "completion-message",
                                value: n.message
                            });
                        }
                        return i;
                        function d(e, t) {
                            e && i.push({
                                type: (n.className || "") + (t || ""),
                                value: e
                            });
                        }
                    }, e.$updateOnChange = t, e.start = t, g.session.$computeWidth = function() {
                        return this.screenWidth = 0;
                    }, g.isOpen = !1, g.isTopdown = !1, g.autoSelect = !0, g.filterText = "", g.data = [], g.setData = function(e, t) {
                        g.filterText = t || "", g.setValue(d.stringRepeat("\n", e.length), -1), g.data = e || [], g.setRow(0);
                    }, g.getData = function(e) {
                        return g.data[e];
                    }, g.getRow = function() {
                        return r.start.row;
                    }, g.setRow = function(e) {
                        e = Math.max(this.autoSelect ? 0 : -1, Math.min(this.data.length, e)), r.start.row != e && (g.selection.clearSelection(), r.start.row = r.end.row = e || 0, g.session._emit("changeBackMarker"), g.moveCursorTo(e || 0, 0), g.isOpen) && g._signal("select");
                    }, g.on("changeSelection", function() {
                        g.isOpen && g.setRow(g.selection.lead.row), g.renderer.scrollCursorIntoView();
                    }), g.hide = function() {
                        this.container.style.display = "none", g.anchorPos = null, g.anchor = null, g.isOpen && (g.isOpen = !1, this._signal("hide"));
                    }, g.tryShow = function(e, t, n, i) {
                        if (i || !g.isOpen || !g.anchorPos || !g.anchor || g.anchorPos.top !== e.top || g.anchorPos.left !== e.left || g.anchor !== n) {
                            var o = this.container, r = window.innerHeight, s = window.innerWidth, a = this.renderer, l = a.$maxLines * t * 1.4, c = {
                                top: 0,
                                bottom: 0,
                                left: 0
                            }, h = r - e.top - 3 * this.$borderSize - t, d = e.top - 3 * this.$borderSize, t = ("top" === (n = n || (d <= h || l <= h ? "bottom" : "top")) ? (c.bottom = e.top - this.$borderSize, c.top = c.bottom - l) : "bottom" === n && (c.top = e.top + t + this.$borderSize, c.bottom = c.top + l), 0 <= c.top && c.bottom <= r);
                            if (!i && !t) return !1;
                            a.$maxPixelHeight = t ? null : "top" === n ? d : h, "top" === n ? (o.style.top = "", o.style.bottom = r - c.bottom + "px", g.isTopdown = !1) : (o.style.top = c.top + "px", o.style.bottom = "", g.isTopdown = !0), o.style.display = "";
                            l = e.left;
                            l + o.offsetWidth > s && (l = s - o.offsetWidth), o.style.left = l + "px", o.style.right = "", g.isOpen || (g.isOpen = !0, this._signal("show"), u = null), g.anchorPos = e, g.anchor = n;
                        }
                        return !0;
                    }, g.show = function(e, t, n) {
                        this.tryShow(e, t, n ? "bottom" : void 0, !0);
                    }, g.goTo = function(e) {
                        var t = this.getRow(), n = this.session.getLength() - 1;
                        switch(e){
                            case "up":
                                t = t <= 0 ? n : t - 1;
                                break;
                            case "down":
                                t = n <= t ? -1 : t + 1;
                                break;
                            case "start":
                                t = 0;
                                break;
                            case "end":
                                t = n;
                        }
                        this.setRow(t);
                    }, g.getTextLeftOffset = function() {
                        return this.$borderSize + this.renderer.$padding + this.$imageSize;
                    }, g.$imageSize = 0, g.$borderSize = 1, g;
                }
                var o = e("../virtual_renderer").VirtualRenderer, r = e("../editor").Editor, c = e("../range").Range, h = e("../lib/event"), d = e("../lib/lang"), p = e("../lib/dom"), m = e("../config").nls;
                p.importCssString("\n.ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {\n    background-color: #CAD6FA;\n    z-index: 1;\n}\n.ace_dark.ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {\n    background-color: #3a674e;\n}\n.ace_editor.ace_autocomplete .ace_line-hover {\n    border: 1px solid #abbffe;\n    margin-top: -1px;\n    background: rgba(233,233,253,0.4);\n    position: absolute;\n    z-index: 2;\n}\n.ace_dark.ace_editor.ace_autocomplete .ace_line-hover {\n    border: 1px solid rgba(109, 150, 13, 0.8);\n    background: rgba(58, 103, 78, 0.62);\n}\n.ace_completion-meta {\n    opacity: 0.5;\n    margin: 0 0.9em;\n}\n.ace_completion-message {\n    color: blue;\n}\n.ace_editor.ace_autocomplete .ace_completion-highlight{\n    color: #2d69c7;\n}\n.ace_dark.ace_editor.ace_autocomplete .ace_completion-highlight{\n    color: #93ca12;\n}\n.ace_editor.ace_autocomplete {\n    width: 300px;\n    z-index: 200000;\n    border: 1px lightgray solid;\n    position: fixed;\n    box-shadow: 2px 3px 5px rgba(0,0,0,.2);\n    line-height: 1.4;\n    background: #fefefe;\n    color: #111;\n}\n.ace_dark.ace_editor.ace_autocomplete {\n    border: 1px #484747 solid;\n    box-shadow: 2px 3px 5px rgba(0, 0, 0, 0.51);\n    line-height: 1.4;\n    background: #25282c;\n    color: #c1c1c1;\n}\n.ace_autocomplete_right .ace_text-layer  {\n    width: calc(100% - 8px);\n}\n.ace_autocomplete_right .ace_line {\n    display: flex;\n}\n.ace_autocomplete_right .ace_completion-meta {\n    flex: 1;\n    text-align: right;\n}\n", "autocompletion.css", !1), t.AcePopup = i, t.$singleLineEditor = l, t.getAriaId = a;
            }), ace.define("ace/autocomplete/inline", [
                "require",
                "exports",
                "module",
                "ace/snippets"
            ], function(e, t, n) {
                "use strict";
                var i = e("../snippets").snippetManager;
                function o() {
                    this.editor = null;
                }
                o.prototype.show = function(e, t, n) {
                    return n = n || "", e && this.editor && this.editor !== e && (this.hide(), this.editor = null), !(!e || !t || !(t = t.snippet ? i.getDisplayTextForSnippet(e, t.snippet) : t.value) || !t.startsWith(n) || (this.editor = e, "" === (t = t.slice(n.length)) ? e.removeGhostText() : e.setGhostText(t), 0));
                }, o.prototype.isOpen = function() {
                    return !!this.editor && !!this.editor.renderer.$ghostText;
                }, o.prototype.hide = function() {
                    return !!this.editor && (this.editor.removeGhostText(), !0);
                }, o.prototype.destroy = function() {
                    this.hide(), this.editor = null;
                }, t.AceInline = o;
            }), ace.define("ace/autocomplete/util", [
                "require",
                "exports",
                "module"
            ], function(e, t, n) {
                "use strict";
                t.parForEach = function(e, t, n) {
                    var i = 0, o = e.length;
                    0 === o && n();
                    for(var r = 0; r < o; r++)t(e[r], function(e, t) {
                        ++i === o && n(e, t);
                    });
                };
                var r = /[a-zA-Z_0-9\$\-\u00A2-\u2000\u2070-\uFFFF]/;
                t.retrievePrecedingIdentifier = function(e, t, n) {
                    n = n || r;
                    for(var i = [], o = t - 1; 0 <= o && n.test(e[o]); o--)i.push(e[o]);
                    return i.reverse().join("");
                }, t.retrieveFollowingIdentifier = function(e, t, n) {
                    n = n || r;
                    for(var i = [], o = t; o < e.length && n.test(e[o]); o++)i.push(e[o]);
                    return i;
                }, t.getCompletionPrefix = function(e) {
                    var t, n = e.getCursorPosition(), i = e.session.getLine(n.row);
                    return e.completers.forEach((function(e) {
                        e.identifierRegexps && e.identifierRegexps.forEach((function(e) {
                            !t && e && (t = this.retrievePrecedingIdentifier(i, n.column, e));
                        }).bind(this));
                    }).bind(this)), t || this.retrievePrecedingIdentifier(i, n.column);
                };
            }), ace.define("ace/autocomplete", [
                "require",
                "exports",
                "module",
                "ace/keyboard/hash_handler",
                "ace/autocomplete/popup",
                "ace/autocomplete/inline",
                "ace/autocomplete/popup",
                "ace/autocomplete/util",
                "ace/lib/lang",
                "ace/lib/dom",
                "ace/snippets",
                "ace/config"
            ], function(e, t, n) {
                "use strict";
                function i(e, t) {
                    t.completer && t.completer.destroy();
                }
                var o = e("./keyboard/hash_handler").HashHandler, r = e("./autocomplete/popup").AcePopup, s = e("./autocomplete/inline").AceInline, a = e("./autocomplete/popup").getAriaId, c = e("./autocomplete/util"), l = e("./lib/lang"), h = e("./lib/dom"), d = e("./snippets").snippetManager, u = e("./config"), g = (p.prototype.$init = function() {
                    return this.popup = new r(document.body || document.documentElement), this.popup.on("click", (function(e) {
                        this.insertMatch(), e.stop();
                    }).bind(this)), this.popup.focus = this.editor.focus.bind(this.editor), this.popup.on("show", this.$onPopupChange.bind(this)), this.popup.on("hide", this.$onHidePopup.bind(this)), this.popup.on("select", this.$onPopupChange.bind(this)), this.popup.on("changeHoverMarker", this.tooltipTimer.bind(null, null)), this.popup;
                }, p.prototype.$initInline = function() {
                    if (this.inlineEnabled && !this.inlineRenderer) return this.inlineRenderer = new s, this.inlineRenderer;
                }, p.prototype.getPopup = function() {
                    return this.popup || this.$init();
                }, p.prototype.$onHidePopup = function() {
                    this.inlineRenderer && this.inlineRenderer.hide(), this.hideDocTooltip();
                }, p.prototype.$onPopupChange = function(e) {
                    var t;
                    this.inlineRenderer && this.inlineEnabled && (e = e ? null : this.popup.getData(this.popup.getRow()), t = c.getCompletionPrefix(this.editor), this.inlineRenderer.show(this.editor, e, t) || this.inlineRenderer.hide(), this.$updatePopupPosition()), this.tooltipTimer.call(null, null);
                }, p.prototype.$updatePopupPosition = function() {
                    var e = this.editor, t = e.renderer, n = t.layerConfig.lineHeight, i = t.$cursorLayer.getPixelPosition(this.base, !0), o = (i.left -= this.popup.getTextLeftOffset(), e.container.getBoundingClientRect()), o = (i.top += o.top - t.layerConfig.offset, i.left += o.left - e.renderer.scrollLeft, i.left += t.gutterWidth, {
                        top: i.top,
                        left: i.left
                    });
                    t.$ghostText && t.$ghostTextWidget && this.base.row === t.$ghostText.position.row && (o.top += t.$ghostTextWidget.el.offsetHeight), this.popup.tryShow(o, n, "bottom") || this.popup.tryShow(i, n, "top") || this.popup.show(i, n);
                }, p.prototype.openPopup = function(e, t, n) {
                    this.popup || this.$init(), this.inlineEnabled && !this.inlineRenderer && this.$initInline(), this.popup.autoSelect = this.autoSelect, this.popup.setData(this.completions.filtered, this.completions.filterText), this.editor.textInput.setAriaOptions && this.editor.textInput.setAriaOptions({
                        activeDescendant: a(this.popup.getRow()),
                        inline: this.inlineEnabled
                    }), e.keyBinding.addKeyboardHandler(this.keyboardHandler), this.popup.setRow(this.autoSelect ? 0 : -1), n ? t || this.detach() : (this.popup.setTheme(e.getTheme()), this.popup.setFontSize(e.getFontSize()), this.$updatePopupPosition(), this.tooltipNode && this.updateDocTooltip()), this.changeTimer.cancel();
                }, p.prototype.detach = function() {
                    this.editor && (this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler), this.editor.off("changeSelection", this.changeListener), this.editor.off("blur", this.blurListener), this.editor.off("mousedown", this.mousedownListener), this.editor.off("mousewheel", this.mousewheelListener)), this.changeTimer.cancel(), this.hideDocTooltip(), this.completionProvider && this.completionProvider.detach(), this.popup && this.popup.isOpen && this.popup.hide(), this.base && this.base.detach(), this.activated = !1, this.completionProvider = this.completions = this.base = null;
                }, p.prototype.changeListener = function(e) {
                    var t = this.editor.selection.lead;
                    (t.row != this.base.row || t.column < this.base.column) && this.detach(), this.activated ? this.changeTimer.schedule() : this.detach();
                }, p.prototype.blurListener = function(e) {
                    var t = document.activeElement, n = this.editor.textInput.getElement(), i = e.relatedTarget && this.tooltipNode && this.tooltipNode.contains(e.relatedTarget), o = this.popup && this.popup.container;
                    t == n || t.parentNode == o || i || t == this.tooltipNode || e.relatedTarget == n || this.detach();
                }, p.prototype.mousedownListener = function(e) {
                    this.detach();
                }, p.prototype.mousewheelListener = function(e) {
                    this.detach();
                }, p.prototype.goTo = function(e) {
                    this.popup.goTo(e);
                }, p.prototype.insertMatch = function(e, t) {
                    var n;
                    return !!(e = e || this.popup.getData(this.popup.getRow())) && (n = this.completions, e = this.getCompletionProvider().insertMatch(this.editor, e, n.filterText, t), this.completions == n && this.detach(), e);
                }, p.prototype.showPopup = function(e, t) {
                    this.editor && this.detach(), this.activated = !0, (this.editor = e).completer != this && (e.completer && e.completer.detach(), e.completer = this), e.on("changeSelection", this.changeListener), e.on("blur", this.blurListener), e.on("mousedown", this.mousedownListener), e.on("mousewheel", this.mousewheelListener), this.updateCompletions(!1, t);
                }, p.prototype.getCompletionProvider = function() {
                    return this.completionProvider || (this.completionProvider = new m), this.completionProvider;
                }, p.prototype.gatherCompletions = function(e, t) {
                    return this.getCompletionProvider().gatherCompletions(e, t);
                }, p.prototype.updateCompletions = function(r, e) {
                    var t, n;
                    return r && this.base && this.completions ? (t = this.editor.getCursorPosition(), (n = this.editor.session.getTextRange({
                        start: this.base,
                        end: t
                    })) == this.completions.filterText ? void 0 : (this.completions.setFilter(n), this.completions.filtered.length && (1 != this.completions.filtered.length || this.completions.filtered[0].value != n || this.completions.filtered[0].snippet) ? void this.openPopup(this.editor, n, r) : this.detach())) : e && e.matches ? (t = this.editor.getSelectionRange().start, this.base = this.editor.session.doc.createAnchor(t.row, t.column), this.base.$insertRight = !0, this.completions = new C(e.matches), this.openPopup(this.editor, "", r)) : (e = this.editor.getSession(), t = this.editor.getCursorPosition(), n = c.getCompletionPrefix(this.editor), this.base = e.doc.createAnchor(t.row, t.column - n.length), this.base.$insertRight = !0, e = {
                        exactMatch: this.exactMatch
                    }, void this.getCompletionProvider().provideCompletions(this.editor, e, (function(e, t, n) {
                        var i = t.filtered, o = c.getCompletionPrefix(this.editor);
                        if (n) {
                            if (!i.length) return this.detach();
                            if (1 == i.length && i[0].value == o && !i[0].snippet) return this.detach();
                            if (this.autoInsert && 1 == i.length) return this.insertMatch(i[0]);
                        }
                        this.completions = t, this.openPopup(this.editor, o, r);
                    }).bind(this)));
                }, p.prototype.cancelContextMenu = function() {
                    this.editor.$mouseHandler.cancelContextMenu();
                }, p.prototype.updateDocTooltip = function() {
                    var e = this.popup, t = e.data, n = t && (t[e.getHoveredRow()] || t[e.getRow()]), i = null;
                    if (!n || !this.editor || !this.popup.isOpen) return this.hideDocTooltip();
                    for(var o = this.editor.completers.length, r = 0; r < o; r++){
                        var s = this.editor.completers[r];
                        if (s.getDocTooltip && n.completerId === s.id) {
                            i = s.getDocTooltip(n);
                            break;
                        }
                    }
                    if (!(i = "string" == typeof (i = i || "string" == typeof n ? i : n) ? {
                        docText: i
                    } : i) || !i.docHTML && !i.docText) return this.hideDocTooltip();
                    this.showDocTooltip(i);
                }, p.prototype.showDocTooltip = function(e) {
                    this.tooltipNode || (this.tooltipNode = h.createElement("div"), this.tooltipNode.style.margin = 0, this.tooltipNode.style.pointerEvents = "auto", this.tooltipNode.tabIndex = -1, this.tooltipNode.onblur = this.blurListener.bind(this), this.tooltipNode.onclick = this.onTooltipClick.bind(this));
                    var t = this.editor.renderer.theme, t = (this.tooltipNode.className = "ace_tooltip ace_doc-tooltip " + (t.isDark ? "ace_dark " : "") + (t.cssClass || ""), this.tooltipNode), e = (e.docHTML ? t.innerHTML = e.docHTML : e.docText && (t.textContent = e.docText), t.parentNode || document.body.appendChild(t), this.popup), n = e.container.getBoundingClientRect();
                    t.style.top = e.container.style.top, t.style.bottom = e.container.style.bottom, t.style.display = "block", window.innerWidth - n.right < 320 ? n.left < 320 ? (e.isTopdown ? t.style.top = n.bottom + "px" : t.style.top = e.container.offsetTop - t.offsetHeight + "px", t.style.left = n.left + "px", t.style.right = "", t.style.bottom = "") : (t.style.right = window.innerWidth - n.left + "px", t.style.left = "") : (t.style.left = n.right + 1 + "px", t.style.right = "");
                }, p.prototype.hideDocTooltip = function() {
                    var e;
                    this.tooltipTimer.cancel(), this.tooltipNode && (e = this.tooltipNode, this.editor.isFocused() || document.activeElement != e || this.editor.focus(), this.tooltipNode = null, e.parentNode) && e.parentNode.removeChild(e);
                }, p.prototype.onTooltipClick = function(e) {
                    for(var t = e.target; t && t != this.tooltipNode;){
                        if ("A" == t.nodeName && t.href) {
                            t.rel = "noreferrer", t.target = "_blank";
                            break;
                        }
                        t = t.parentNode;
                    }
                }, p.prototype.destroy = function() {
                    var e;
                    this.detach(), this.popup && (this.popup.destroy(), e = this.popup.container) && e.parentNode && e.parentNode.removeChild(e), this.editor && this.editor.completer == this && (this.editor.off("destroy", i), this.editor.completer = null), this.inlineRenderer = this.popup = this.editor = null;
                }, p);
                function p() {
                    this.autoInsert = !1, this.autoSelect = !0, this.exactMatch = !1, this.inlineEnabled = !1, this.keyboardHandler = new o, this.keyboardHandler.bindKeys(this.commands), this.blurListener = this.blurListener.bind(this), this.changeListener = this.changeListener.bind(this), this.mousedownListener = this.mousedownListener.bind(this), this.mousewheelListener = this.mousewheelListener.bind(this), this.changeTimer = l.delayedCall((function() {
                        this.updateCompletions(!0);
                    }).bind(this)), this.tooltipTimer = l.delayedCall(this.updateDocTooltip.bind(this), 50);
                }
                g.prototype.commands = {
                    Up: function(e) {
                        e.completer.goTo("up");
                    },
                    Down: function(e) {
                        e.completer.goTo("down");
                    },
                    "Ctrl-Up|Ctrl-Home": function(e) {
                        e.completer.goTo("start");
                    },
                    "Ctrl-Down|Ctrl-End": function(e) {
                        e.completer.goTo("end");
                    },
                    Esc: function(e) {
                        e.completer.detach();
                    },
                    Return: function(e) {
                        return e.completer.insertMatch();
                    },
                    "Shift-Return": function(e) {
                        e.completer.insertMatch(null, {
                            deleteSuffix: !0
                        });
                    },
                    Tab: function(e) {
                        var t = e.completer.insertMatch();
                        if (t || e.tabstopManager) return t;
                        e.completer.goTo("down");
                    },
                    PageUp: function(e) {
                        e.completer.popup.gotoPageUp();
                    },
                    PageDown: function(e) {
                        e.completer.popup.gotoPageDown();
                    }
                }, g.for = function(e) {
                    return e.completer instanceof g || (e.completer && (e.completer.destroy(), e.completer = null), u.get("sharedPopups") ? (g.$sharedInstance || (g.$sharedInstance = new g), e.completer = g.$sharedInstance) : (e.completer = new g, e.once("destroy", i))), e.completer;
                }, g.startCommand = {
                    name: "startAutocomplete",
                    exec: function(e, t) {
                        var n = g.for(e);
                        n.autoInsert = !1, n.autoSelect = !0, n.showPopup(e, t), n.cancelContextMenu();
                    },
                    bindKey: "Ctrl-Space|Ctrl-Shift-Space|Alt-Space"
                };
                f.prototype.insertByIndex = function(e, t, n) {
                    return !(!this.completions || !this.completions.filtered) && this.insertMatch(e, this.completions.filtered[t], n);
                }, f.prototype.insertMatch = function(e, t, n) {
                    if (!t) return !1;
                    if (e.startOperation({
                        command: {
                            name: "insertMatch"
                        }
                    }), t.completer && t.completer.insertMatch) t.completer.insertMatch(e, t);
                    else {
                        if (!this.completions) return !1;
                        if (this.completions.filterText) for(var i, o = e.selection.getAllRanges ? e.selection.getAllRanges() : [
                            e.getSelectionRange()
                        ], r = 0; i = o[r]; r++)i.start.column -= this.completions.filterText.length, e.session.remove(i);
                        t.snippet ? d.insertSnippet(e, t.snippet, {
                            range: t.range
                        }) : this.$insertString(e, t), t.command && "startAutocomplete" === t.command && e.execCommand(t.command);
                    }
                    return e.endOperation(), !0;
                }, f.prototype.$insertString = function(t, n) {
                    var i = n.value || n;
                    if (n.range) {
                        if (t.inVirtualSelectionMode) return t.session.replace(n.range, i);
                        t.forEachSelection(function() {
                            var e = t.getSelectionRange();
                            0 === n.range.compareRange(e) ? t.session.replace(n.range, i) : t.insert(i);
                        }, null, {
                            keepOrder: !0
                        });
                    } else t.execCommand("insertstring", i);
                }, f.prototype.gatherCompletions = function(n, i) {
                    var o = n.getSession(), r = n.getCursorPosition(), s = c.getCompletionPrefix(n), a = [], l = n.completers.length;
                    return n.completers.forEach(function(e, t) {
                        e.getCompletions(n, o, r, s, function(e, t) {
                            !e && t && (a = a.concat(t)), i(null, {
                                prefix: c.getCompletionPrefix(n),
                                matches: a,
                                finished: 0 == --l
                            });
                        });
                    }), !0;
                }, f.prototype.provideCompletions = function(e, i, o) {
                    var n = (function(e) {
                        var t = e.prefix, n = e.matches;
                        this.completions = new C(n), i.exactMatch && (this.completions.exactMatch = !0), i.ignoreCaption && (this.completions.ignoreCaption = !0), this.completions.setFilter(t), (e.finished || this.completions.filtered.length) && o(null, this.completions, e.finished);
                    }).bind(this), r = !0, s = null;
                    this.gatherCompletions(e, (function(e, t) {
                        this.active && (e && (o(e, [], !0), this.detach()), 0 === t.prefix.indexOf(t.prefix)) && (r ? s = t : n(t));
                    }).bind(this)), r = !1, s && (e = s, s = null, n(e));
                }, f.prototype.detach = function() {
                    this.active = !1;
                };
                var m = f;
                function f() {
                    this.active = !0;
                }
                y.prototype.setFilter = function(e) {
                    t = e.length > this.filterText && 0 === e.lastIndexOf(this.filterText, 0) ? this.filtered : this.all, this.filterText = e, t = (t = this.filterCompletions(t, this.filterText)).sort(function(e, t) {
                        return t.exactMatch - e.exactMatch || t.$score - e.$score || (e.caption || e.value).localeCompare(t.caption || t.value);
                    });
                    var t, n = null;
                    t = t.filter(function(e) {
                        e = e.snippet || e.caption || e.value;
                        return e !== n && (n = e, !0);
                    }), this.filtered = t;
                }, y.prototype.filterCompletions = function(e, t) {
                    var n = [], i = t.toUpperCase(), o = t.toLowerCase();
                    e: for(var r, s = 0; r = e[s]; s++){
                        var a = !this.ignoreCaption && r.caption || r.value || r.snippet;
                        if (a) {
                            var l = -1, c = 0, h = 0;
                            if (this.exactMatch) {
                                if (t !== a.substr(0, t.length)) continue;
                            } else {
                                var d = a.toLowerCase().indexOf(o);
                                if (-1 < d) h = d;
                                else for(var u = 0; u < t.length; u++){
                                    var g = a.indexOf(o[u], l + 1), p = a.indexOf(i[u], l + 1);
                                    if ((g = 0 <= g && (p < 0 || g < p) ? g : p) < 0) continue e;
                                    0 < (p = g - l - 1) && (-1 === l && (h += 10), h += p, c |= 1 << u), l = g;
                                }
                            }
                            r.matchMask = c, r.exactMatch = h ? 0 : 1, r.$score = (r.score || 0) - h, n.push(r);
                        }
                    }
                    return n;
                };
                var C = y;
                function y(e, t) {
                    this.all = e, this.filtered = e, this.filterText = t || "", this.exactMatch = !1, this.ignoreCaption = !1;
                }
                t.Autocomplete = g, t.CompletionProvider = m, t.FilteredList = C;
            }), ace.define("ace/autocomplete/text_completer", [
                "require",
                "exports",
                "module",
                "ace/range"
            ], function(e, t, n) {
                var s = e("../range").Range, a = /[^a-zA-Z_0-9\$\-\u00C0-\u1FFF\u2C00-\uD7FF\w]+/;
                function l(e, t) {
                    var n = e.getTextRange(s.fromPoints({
                        row: 0,
                        column: 0
                    }, t)).split(a).length - 1, i = e.getValue().split(a), o = Object.create(null), r = i[n];
                    return i.forEach(function(e, t) {
                        e && e !== r && (t = Math.abs(n - t), t = i.length - t, o[e] ? o[e] = Math.max(t, o[e]) : o[e] = t);
                    }), o;
                }
                t.getCompletions = function(e, t, n, i, o) {
                    var r = l(t, n);
                    o(null, Object.keys(r).map(function(e) {
                        return {
                            caption: e,
                            value: e,
                            score: r[e],
                            meta: "local"
                        };
                    }));
                };
            }), ace.define("ace/ext/language_tools", [
                "require",
                "exports",
                "module",
                "ace/snippets",
                "ace/autocomplete",
                "ace/config",
                "ace/lib/lang",
                "ace/autocomplete/util",
                "ace/autocomplete/text_completer",
                "ace/editor",
                "ace/config"
            ], function(e, t, n) {
                "use strict";
                function i(e, t) {
                    m(t.session.$mode);
                }
                function o(e) {
                    var t = e.editor, n = t.completer && t.completer.activated;
                    "backspace" === e.command.name ? n && !c.getCompletionPrefix(t) && t.completer.detach() : "insertstring" === e.command.name && c.getCompletionPrefix(t) && !n && ((e = r.for(t)).autoInsert = !1, e.showPopup(t));
                }
                var l = e("../snippets").snippetManager, r = e("../autocomplete").Autocomplete, s = e("../config"), a = e("../lib/lang"), c = e("../autocomplete/util"), h = e("../autocomplete/text_completer"), d = {
                    getCompletions: function(e, t, n, i, o) {
                        if (t.$mode.completer) return t.$mode.completer.getCompletions(e, t, n, i, o);
                        e = e.session.getState(n.row);
                        o(null, t.$mode.getCompletions(e, t, n, i).map(function(e) {
                            return e.completerId = d.id, e;
                        }));
                    },
                    id: "keywordCompleter"
                }, u = {
                    getCompletions: function(e, t, n, i, o) {
                        var r = [], t = t.getTokenAt(n.row, n.column), s = (t && t.type.match(/(tag-name|tag-open|tag-whitespace|attribute-name|attribute-value)\.xml$/) ? r.push("html-tag") : r = l.getActiveScopes(e), l.snippetMap), a = [];
                        r.forEach(function(e) {
                            for(var t = s[e] || [], n = t.length; n--;){
                                var i = t[n], o = i.name || i.tabTrigger;
                                o && a.push({
                                    caption: o,
                                    snippet: i.content,
                                    meta: i.tabTrigger && !i.name ? i.tabTrigger + "\u21E5 " : "snippet",
                                    completerId: u.id
                                });
                            }
                        }, this), o(null, a);
                    },
                    getDocTooltip: function(e) {
                        var o;
                        e.snippet && !e.docHTML && (e.docHTML = [
                            "<b>",
                            a.escapeHTML(e.caption),
                            "</b>",
                            "<hr></hr>",
                            a.escapeHTML((e = e.snippet, o = {}, e.replace(/\${(\d+)(:(.*?))?}/g, function(e, t, n, i) {
                                return o[t] = i || "";
                            }).replace(/\$(\d+?)/g, function(e, t) {
                                return o[t];
                            })))
                        ].join(""));
                    },
                    id: "snippetCompleter"
                }, g = [
                    u,
                    h,
                    d
                ], p = (t.setCompleters = function(e) {
                    g.length = 0, e && g.push.apply(g, e);
                }, t.addCompleter = function(e) {
                    g.push(e);
                }, t.textCompleter = h, t.keyWordCompleter = d, t.snippetCompleter = u, {
                    name: "expandSnippet",
                    exec: function(e) {
                        return l.expandWithTab(e);
                    },
                    bindKey: "Tab"
                }), m = function(e) {
                    (e = "string" == typeof e ? s.$modes[e] : e) && (l.files || (l.files = {}), f(e.$id, e.snippetFileId), e.modes) && e.modes.forEach(m);
                }, f = function(t, e) {
                    e && t && !l.files[t] && (l.files[t] = {}, s.loadModule(e, function(e) {
                        e && (!(l.files[t] = e).snippets && e.snippetText && (e.snippets = l.parseSnippetFile(e.snippetText)), l.register(e.snippets || [], e.scope), e.includeScopes) && (l.snippetMap[e.scope].includeScopes = e.includeScopes, e.includeScopes.forEach(function(e) {
                            m("ace/mode/" + e);
                        }));
                    }));
                }, h = e("../editor").Editor;
                e("../config").defineOptions(h.prototype, "editor", {
                    enableBasicAutocompletion: {
                        set: function(e) {
                            e ? (this.completers || (this.completers = Array.isArray(e) ? e : g), this.commands.addCommand(r.startCommand)) : this.commands.removeCommand(r.startCommand);
                        },
                        value: !1
                    },
                    enableLiveAutocompletion: {
                        set: function(e) {
                            e ? (this.completers || (this.completers = Array.isArray(e) ? e : g), this.commands.on("afterExec", o)) : this.commands.removeListener("afterExec", o);
                        },
                        value: !1
                    },
                    enableSnippets: {
                        set: function(e) {
                            e ? (this.commands.addCommand(p), this.on("changeMode", i), i(0, this)) : (this.commands.removeCommand(p), this.off("changeMode", i));
                        },
                        value: !1
                    }
                });
            }), ace.require([
                "ace/ext/language_tools"
            ], function(e) {
                t && (t.exports = e);
            });
        },
        3330: function(t, e, n) {
            t = n.nmd(t), ace.define("ace/ext/searchbox.css", [
                "require",
                "exports",
                "module"
            ], function(e, t, n) {
                n.exports = '\n\n/* ------------------------------------------------------------------------------------------\n * Editor Search Form\n * --------------------------------------------------------------------------------------- */\n.ace_search {\n    background-color: #ddd;\n    color: #666;\n    border: 1px solid #cbcbcb;\n    border-top: 0 none;\n    overflow: hidden;\n    margin: 0;\n    padding: 4px 6px 0 4px;\n    position: absolute;\n    top: 0;\n    z-index: 99;\n    white-space: normal;\n}\n.ace_search.left {\n    border-left: 0 none;\n    border-radius: 0px 0px 5px 0px;\n    left: 0;\n}\n.ace_search.right {\n    border-radius: 0px 0px 0px 5px;\n    border-right: 0 none;\n    right: 0;\n}\n\n.ace_search_form, .ace_replace_form {\n    margin: 0 20px 4px 0;\n    overflow: hidden;\n    line-height: 1.9;\n}\n.ace_replace_form {\n    margin-right: 0;\n}\n.ace_search_form.ace_nomatch {\n    outline: 1px solid red;\n}\n\n.ace_search_field {\n    border-radius: 3px 0 0 3px;\n    background-color: white;\n    color: black;\n    border: 1px solid #cbcbcb;\n    border-right: 0 none;\n    outline: 0;\n    padding: 0;\n    font-size: inherit;\n    margin: 0;\n    line-height: inherit;\n    padding: 0 6px;\n    min-width: 17em;\n    vertical-align: top;\n    min-height: 1.8em;\n    box-sizing: content-box;\n}\n.ace_searchbtn {\n    border: 1px solid #cbcbcb;\n    line-height: inherit;\n    display: inline-block;\n    padding: 0 6px;\n    background: #fff;\n    border-right: 0 none;\n    border-left: 1px solid #dcdcdc;\n    cursor: pointer;\n    margin: 0;\n    position: relative;\n    color: #666;\n}\n.ace_searchbtn:last-child {\n    border-radius: 0 3px 3px 0;\n    border-right: 1px solid #cbcbcb;\n}\n.ace_searchbtn:disabled {\n    background: none;\n    cursor: default;\n}\n.ace_searchbtn:hover {\n    background-color: #eef1f6;\n}\n.ace_searchbtn.prev, .ace_searchbtn.next {\n     padding: 0px 0.7em\n}\n.ace_searchbtn.prev:after, .ace_searchbtn.next:after {\n     content: "";\n     border: solid 2px #888;\n     width: 0.5em;\n     height: 0.5em;\n     border-width:  2px 0 0 2px;\n     display:inline-block;\n     transform: rotate(-45deg);\n}\n.ace_searchbtn.next:after {\n     border-width: 0 2px 2px 0 ;\n}\n.ace_searchbtn_close {\n    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAcCAYAAABRVo5BAAAAZ0lEQVR42u2SUQrAMAhDvazn8OjZBilCkYVVxiis8H4CT0VrAJb4WHT3C5xU2a2IQZXJjiQIRMdkEoJ5Q2yMqpfDIo+XY4k6h+YXOyKqTIj5REaxloNAd0xiKmAtsTHqW8sR2W5f7gCu5nWFUpVjZwAAAABJRU5ErkJggg==) no-repeat 50% 0;\n    border-radius: 50%;\n    border: 0 none;\n    color: #656565;\n    cursor: pointer;\n    font: 16px/16px Arial;\n    padding: 0;\n    height: 14px;\n    width: 14px;\n    top: 9px;\n    right: 7px;\n    position: absolute;\n}\n.ace_searchbtn_close:hover {\n    background-color: #656565;\n    background-position: 50% 100%;\n    color: white;\n}\n\n.ace_button {\n    margin-left: 2px;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -o-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    overflow: hidden;\n    opacity: 0.7;\n    border: 1px solid rgba(100,100,100,0.23);\n    padding: 1px;\n    box-sizing:    border-box!important;\n    color: black;\n}\n\n.ace_button:hover {\n    background-color: #eee;\n    opacity:1;\n}\n.ace_button:active {\n    background-color: #ddd;\n}\n\n.ace_button.checked {\n    border-color: #3399ff;\n    opacity:1;\n}\n\n.ace_search_options{\n    margin-bottom: 3px;\n    text-align: right;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -o-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    clear: both;\n}\n\n.ace_search_counter {\n    float: left;\n    font-family: arial;\n    padding: 0 8px;\n}';
            }), ace.define("ace/ext/searchbox", [
                "require",
                "exports",
                "module",
                "ace/lib/dom",
                "ace/lib/lang",
                "ace/lib/event",
                "ace/ext/searchbox.css",
                "ace/keyboard/hash_handler",
                "ace/lib/keys",
                "ace/config"
            ], function(e, t, n) {
                "use strict";
                var o = e("../lib/dom"), r = e("../lib/lang"), s = e("../lib/event"), a = e("./searchbox.css"), i = e("../keyboard/hash_handler").HashHandler, l = e("../lib/keys"), c = e("../config").nls, h = (o.importCssString(a, "ace_searchbox", !1), d.prototype.setEditor = function(e) {
                    e.searchBox = this, e.renderer.scroller.appendChild(this.element), this.editor = e;
                }, d.prototype.setSession = function(e) {
                    this.searchRange = null, this.$syncOptions(!0);
                }, d.prototype.$initElements = function(e) {
                    this.searchBox = e.querySelector(".ace_search_form"), this.replaceBox = e.querySelector(".ace_replace_form"), this.searchOption = e.querySelector("[action=searchInSelection]"), this.replaceOption = e.querySelector("[action=toggleReplace]"), this.regExpOption = e.querySelector("[action=toggleRegexpMode]"), this.caseSensitiveOption = e.querySelector("[action=toggleCaseSensitive]"), this.wholeWordOption = e.querySelector("[action=toggleWholeWords]"), this.searchInput = this.searchBox.querySelector(".ace_search_field"), this.replaceInput = this.replaceBox.querySelector(".ace_search_field"), this.searchCounter = e.querySelector(".ace_search_counter");
                }, d.prototype.$init = function() {
                    var e = this.element, i = (this.$initElements(e), this);
                    s.addListener(e, "mousedown", function(e) {
                        setTimeout(function() {
                            i.activeInput.focus();
                        }, 0), s.stopPropagation(e);
                    }), s.addListener(e, "click", function(e) {
                        var t = (e.target || e.srcElement).getAttribute("action");
                        t && i[t] ? i[t]() : i.$searchBarKb.commands[t] && i.$searchBarKb.commands[t].exec(i), s.stopPropagation(e);
                    }), s.addCommandKeyListener(e, function(e, t, n) {
                        n = l.keyCodeToString(n), t = i.$searchBarKb.findKeyCommand(t, n);
                        t && t.exec && (t.exec(i), s.stopEvent(e));
                    }), this.$onChange = r.delayedCall(function() {
                        i.find(!1, !1);
                    }), s.addListener(this.searchInput, "input", function() {
                        i.$onChange.schedule(20);
                    }), s.addListener(this.searchInput, "focus", function() {
                        i.activeInput = i.searchInput, i.searchInput.value && i.highlight();
                    }), s.addListener(this.replaceInput, "focus", function() {
                        i.activeInput = i.replaceInput, i.searchInput.value && i.highlight();
                    });
                }, d.prototype.setSearchRange = function(e) {
                    (this.searchRange = e) ? this.searchRangeMarker = this.editor.session.addMarker(e, "ace_active-line") : this.searchRangeMarker && (this.editor.session.removeMarker(this.searchRangeMarker), this.searchRangeMarker = null);
                }, d.prototype.$syncOptions = function(e) {
                    o.setCssClass(this.replaceOption, "checked", this.searchRange), o.setCssClass(this.searchOption, "checked", this.searchOption.checked), this.replaceOption.textContent = this.replaceOption.checked ? "-" : "+", o.setCssClass(this.regExpOption, "checked", this.regExpOption.checked), o.setCssClass(this.wholeWordOption, "checked", this.wholeWordOption.checked), o.setCssClass(this.caseSensitiveOption, "checked", this.caseSensitiveOption.checked);
                    var t = this.editor.getReadOnly();
                    this.replaceOption.style.display = t ? "none" : "", this.replaceBox.style.display = this.replaceOption.checked && !t ? "" : "none", this.find(!1, !1, e);
                }, d.prototype.highlight = function(e) {
                    this.editor.session.highlight(e || this.editor.$search.$options.re), this.editor.renderer.updateBackMarkers();
                }, d.prototype.find = function(e, t, n) {
                    e = !this.editor.find(this.searchInput.value, {
                        skipCurrent: e,
                        backwards: t,
                        wrap: !0,
                        regExp: this.regExpOption.checked,
                        caseSensitive: this.caseSensitiveOption.checked,
                        wholeWord: this.wholeWordOption.checked,
                        preventScroll: n,
                        range: this.searchRange
                    }) && this.searchInput.value;
                    o.setCssClass(this.searchBox, "ace_nomatch", e), this.editor._emit("findSearchBox", {
                        match: !e
                    }), this.highlight(), this.updateCounter();
                }, d.prototype.updateCounter = function() {
                    var e = this.editor, t = e.$search.$options.re, n = 0, i = 0;
                    if (t) {
                        var o, r, s = this.searchRange ? e.session.getTextRange(this.searchRange) : e.getValue(), a = e.session.doc.positionToIndex(e.selection.anchor);
                        for(this.searchRange && (a -= e.session.doc.positionToIndex(this.searchRange.start)), t.lastIndex = 0; (r = t.exec(s)) && ((o = r.index) <= a && i++, !(999 < ++n)) && (r[0] || (t.lastIndex = o += 1, !(o >= s.length))););
                    }
                    this.searchCounter.textContent = c("$0 of $1", [
                        i,
                        999 < n ? "999+" : n
                    ]);
                }, d.prototype.findNext = function() {
                    this.find(!0, !1);
                }, d.prototype.findPrev = function() {
                    this.find(!0, !0);
                }, d.prototype.findAll = function() {
                    var e = !this.editor.findAll(this.searchInput.value, {
                        regExp: this.regExpOption.checked,
                        caseSensitive: this.caseSensitiveOption.checked,
                        wholeWord: this.wholeWordOption.checked
                    }) && this.searchInput.value;
                    o.setCssClass(this.searchBox, "ace_nomatch", e), this.editor._emit("findSearchBox", {
                        match: !e
                    }), this.highlight(), this.hide();
                }, d.prototype.replace = function() {
                    this.editor.getReadOnly() || this.editor.replace(this.replaceInput.value);
                }, d.prototype.replaceAndFindNext = function() {
                    this.editor.getReadOnly() || (this.editor.replace(this.replaceInput.value), this.findNext());
                }, d.prototype.replaceAll = function() {
                    this.editor.getReadOnly() || this.editor.replaceAll(this.replaceInput.value);
                }, d.prototype.hide = function() {
                    this.active = !1, this.setSearchRange(null), this.editor.off("changeSession", this.setSession), this.element.style.display = "none", this.editor.keyBinding.removeKeyboardHandler(this.$closeSearchBarKb), this.editor.focus();
                }, d.prototype.show = function(e, t) {
                    this.active = !0, this.editor.on("changeSession", this.setSession), this.element.style.display = "", this.replaceOption.checked = t, e && (this.searchInput.value = e), this.searchInput.focus(), this.searchInput.select(), this.editor.keyBinding.addKeyboardHandler(this.$closeSearchBarKb), this.$syncOptions(!0);
                }, d.prototype.isFocused = function() {
                    var e = document.activeElement;
                    return e == this.searchInput || e == this.replaceInput;
                }, d);
                function d(e, t, n) {
                    var i = o.createElement("div");
                    o.buildDom([
                        "div",
                        {
                            class: "ace_search right"
                        },
                        [
                            "span",
                            {
                                action: "hide",
                                class: "ace_searchbtn_close"
                            }
                        ],
                        [
                            "div",
                            {
                                class: "ace_search_form"
                            },
                            [
                                "input",
                                {
                                    class: "ace_search_field",
                                    placeholder: c("Search for"),
                                    spellcheck: "false"
                                }
                            ],
                            [
                                "span",
                                {
                                    action: "findPrev",
                                    class: "ace_searchbtn prev"
                                },
                                "\u200B"
                            ],
                            [
                                "span",
                                {
                                    action: "findNext",
                                    class: "ace_searchbtn next"
                                },
                                "\u200B"
                            ],
                            [
                                "span",
                                {
                                    action: "findAll",
                                    class: "ace_searchbtn",
                                    title: "Alt-Enter"
                                },
                                c("All")
                            ]
                        ],
                        [
                            "div",
                            {
                                class: "ace_replace_form"
                            },
                            [
                                "input",
                                {
                                    class: "ace_search_field",
                                    placeholder: c("Replace with"),
                                    spellcheck: "false"
                                }
                            ],
                            [
                                "span",
                                {
                                    action: "replaceAndFindNext",
                                    class: "ace_searchbtn"
                                },
                                c("Replace")
                            ],
                            [
                                "span",
                                {
                                    action: "replaceAll",
                                    class: "ace_searchbtn"
                                },
                                c("All")
                            ]
                        ],
                        [
                            "div",
                            {
                                class: "ace_search_options"
                            },
                            [
                                "span",
                                {
                                    action: "toggleReplace",
                                    class: "ace_button",
                                    title: c("Toggle Replace mode"),
                                    style: "float:left;margin-top:-2px;padding:0 5px;"
                                },
                                "+"
                            ],
                            [
                                "span",
                                {
                                    class: "ace_search_counter"
                                }
                            ],
                            [
                                "span",
                                {
                                    action: "toggleRegexpMode",
                                    class: "ace_button",
                                    title: c("RegExp Search")
                                },
                                ".*"
                            ],
                            [
                                "span",
                                {
                                    action: "toggleCaseSensitive",
                                    class: "ace_button",
                                    title: c("CaseSensitive Search")
                                },
                                "Aa"
                            ],
                            [
                                "span",
                                {
                                    action: "toggleWholeWords",
                                    class: "ace_button",
                                    title: c("Whole Word Search")
                                },
                                "\\b"
                            ],
                            [
                                "span",
                                {
                                    action: "searchInSelection",
                                    class: "ace_button",
                                    title: c("Search In Selection")
                                },
                                "S"
                            ]
                        ]
                    ], i), this.element = i.firstChild, this.setSession = this.setSession.bind(this), this.$init(), this.setEditor(e), o.importCssString(a, "ace_searchbox", e.container);
                }
                e = new i, e.bindKeys({
                    "Ctrl-f|Command-f": function(e) {
                        var t = e.isReplace = !e.isReplace;
                        e.replaceBox.style.display = t ? "" : "none", e.replaceOption.checked = !1, e.$syncOptions(), e.searchInput.focus();
                    },
                    "Ctrl-H|Command-Option-F": function(e) {
                        e.editor.getReadOnly() || (e.replaceOption.checked = !0, e.$syncOptions(), e.replaceInput.focus());
                    },
                    "Ctrl-G|Command-G": function(e) {
                        e.findNext();
                    },
                    "Ctrl-Shift-G|Command-Shift-G": function(e) {
                        e.findPrev();
                    },
                    esc: function(e) {
                        setTimeout(function() {
                            e.hide();
                        });
                    },
                    Return: function(e) {
                        e.activeInput == e.replaceInput && e.replace(), e.findNext();
                    },
                    "Shift-Return": function(e) {
                        e.activeInput == e.replaceInput && e.replace(), e.findPrev();
                    },
                    "Alt-Return": function(e) {
                        e.activeInput == e.replaceInput && e.replaceAll(), e.findAll();
                    },
                    Tab: function(e) {
                        (e.activeInput == e.replaceInput ? e.searchInput : e.replaceInput).focus();
                    }
                }), e.addCommands([
                    {
                        name: "toggleRegexpMode",
                        bindKey: {
                            win: "Alt-R|Alt-/",
                            mac: "Ctrl-Alt-R|Ctrl-Alt-/"
                        },
                        exec: function(e) {
                            e.regExpOption.checked = !e.regExpOption.checked, e.$syncOptions();
                        }
                    },
                    {
                        name: "toggleCaseSensitive",
                        bindKey: {
                            win: "Alt-C|Alt-I",
                            mac: "Ctrl-Alt-R|Ctrl-Alt-I"
                        },
                        exec: function(e) {
                            e.caseSensitiveOption.checked = !e.caseSensitiveOption.checked, e.$syncOptions();
                        }
                    },
                    {
                        name: "toggleWholeWords",
                        bindKey: {
                            win: "Alt-B|Alt-W",
                            mac: "Ctrl-Alt-B|Ctrl-Alt-W"
                        },
                        exec: function(e) {
                            e.wholeWordOption.checked = !e.wholeWordOption.checked, e.$syncOptions();
                        }
                    },
                    {
                        name: "toggleReplace",
                        exec: function(e) {
                            e.replaceOption.checked = !e.replaceOption.checked, e.$syncOptions();
                        }
                    },
                    {
                        name: "searchInSelection",
                        exec: function(e) {
                            e.searchOption.checked = !e.searchRange, e.setSearchRange(e.searchOption.checked && e.editor.getSelectionRange()), e.$syncOptions();
                        }
                    }
                ]), i = new i([
                    {
                        bindKey: "Esc",
                        name: "closeSearchBar",
                        exec: function(e) {
                            e.searchBox.hide();
                        }
                    }
                ]);
                h.prototype.$searchBarKb = e, h.prototype.$closeSearchBarKb = i, t.SearchBox = h, t.Search = function(e, t) {
                    (e.searchBox || new h(e)).show(e.session.getTextRange(), t);
                };
            }), ace.require([
                "ace/ext/searchbox"
            ], function(e) {
                t && (t.exports = e);
            });
        },
        4091: function(t, e, n) {
            t = n.nmd(t), ace.define("ace/mode/json_highlight_rules", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/mode/text_highlight_rules"
            ], function(e, t, n) {
                "use strict";
                function i() {
                    this.$rules = {
                        start: [
                            {
                                token: "variable",
                                regex: '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]\\s*(?=:)'
                            },
                            {
                                token: "string",
                                regex: '"',
                                next: "string"
                            },
                            {
                                token: "constant.numeric",
                                regex: "0[xX][0-9a-fA-F]+\\b"
                            },
                            {
                                token: "constant.numeric",
                                regex: "[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"
                            },
                            {
                                token: "constant.language.boolean",
                                regex: "(?:true|false)\\b"
                            },
                            {
                                token: "text",
                                regex: "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
                            },
                            {
                                token: "comment",
                                regex: "\\/\\/.*$"
                            },
                            {
                                token: "comment.start",
                                regex: "\\/\\*",
                                next: "comment"
                            },
                            {
                                token: "paren.lparen",
                                regex: "[[({]"
                            },
                            {
                                token: "paren.rparen",
                                regex: "[\\])}]"
                            },
                            {
                                token: "punctuation.operator",
                                regex: /[,]/
                            },
                            {
                                token: "text",
                                regex: "\\s+"
                            }
                        ],
                        string: [
                            {
                                token: "constant.language.escape",
                                regex: /\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\\\/bfnrt])/
                            },
                            {
                                token: "string",
                                regex: '"|$',
                                next: "start"
                            },
                            {
                                defaultToken: "string"
                            }
                        ],
                        comment: [
                            {
                                token: "comment.end",
                                regex: "\\*\\/",
                                next: "start"
                            },
                            {
                                defaultToken: "comment"
                            }
                        ]
                    };
                }
                var o = e("../lib/oop"), e = e("./text_highlight_rules").TextHighlightRules;
                o.inherits(i, e), t.JsonHighlightRules = i;
            }), ace.define("ace/mode/matching_brace_outdent", [
                "require",
                "exports",
                "module",
                "ace/range"
            ], function(e, t, n) {
                "use strict";
                function i() {}
                var o = e("../range").Range;
                (function() {
                    this.checkOutdent = function(e, t) {
                        return !!/^\s+$/.test(e) && /^\s*\}/.test(t);
                    }, this.autoOutdent = function(e, t) {
                        var n, i = e.getLine(t).match(/^(\s*\})/);
                        return i && (i = i[1].length, n = e.findMatchingBracket({
                            row: t,
                            column: i
                        })) && n.row != t ? (n = this.$getIndent(e.getLine(n.row)), void e.replace(new o(t, 0, t, i - 1), n)) : 0;
                    }, this.$getIndent = function(e) {
                        return e.match(/^\s*/)[0];
                    };
                }).call(i.prototype), t.MatchingBraceOutdent = i;
            }), ace.define("ace/mode/folding/cstyle", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/range",
                "ace/mode/folding/fold_mode"
            ], function(e, t, n) {
                "use strict";
                var i = e("../../lib/oop"), h = e("../../range").Range, e = e("./fold_mode").FoldMode, t = t.FoldMode = function(e) {
                    e && (this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + e.start)), this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + e.end)));
                };
                i.inherits(t, e), (function() {
                    this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/, this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/, this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/, this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/, this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/, this._getFoldWidgetBase = this.getFoldWidget, this.getFoldWidget = function(e, t, n) {
                        var i = e.getLine(n);
                        return !this.singleLineBlockCommentRe.test(i) || this.startRegionRe.test(i) || this.tripleStarBlockCommentRe.test(i) ? !(e = this._getFoldWidgetBase(e, t, n)) && this.startRegionRe.test(i) ? "start" : e : "";
                    }, this.getFoldWidgetRange = function(e, t, n, i) {
                        var o, r, s, a = e.getLine(n);
                        return this.startRegionRe.test(a) ? this.getCommentRegionBlock(e, a, n) : (r = a.match(this.foldingStartMarker)) ? (s = r.index, r[1] ? this.openingBracketBlock(e, r[1], n, s) : ((o = e.getCommentFoldRange(n, s + r[0].length, 1)) && !o.isMultiLine() && (i ? o = this.getSectionRange(e, n) : "all" != t && (o = null)), o)) : "markbegin" !== t && (r = a.match(this.foldingStopMarker)) ? (s = r.index + r[0].length, r[1] ? this.closingBracketBlock(e, r[1], n, s) : e.getCommentFoldRange(n, s, -1)) : void 0;
                    }, this.getSectionRange = function(e, t) {
                        for(var n = (a = e.getLine(t)).search(/\S/), i = t, o = a.length, r = t += 1, s = e.getLength(); ++t < s;){
                            var a, l = (a = e.getLine(t)).search(/\S/);
                            if (-1 !== l) {
                                if (l < n) break;
                                var c = this.getFoldWidgetRange(e, "all", t);
                                if (c) {
                                    if (c.start.row <= i) break;
                                    if (c.isMultiLine()) t = c.end.row;
                                    else if (n == l) break;
                                }
                                r = t;
                            }
                        }
                        return new h(i, o, r, e.getLine(r).length);
                    }, this.getCommentRegionBlock = function(e, t, n) {
                        for(var i = t.search(/\s*$/), o = e.getLength(), r = n, s = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/, a = 1; ++n < o;){
                            t = e.getLine(n);
                            var l = s.exec(t);
                            if (l && (l[1] ? a-- : a++, !a)) break;
                        }
                        if (r < n) return new h(r, i, n, t.length);
                    };
                }).call(t.prototype);
            }), ace.define("ace/mode/json", [
                "require",
                "exports",
                "module",
                "ace/lib/oop",
                "ace/mode/text",
                "ace/mode/json_highlight_rules",
                "ace/mode/matching_brace_outdent",
                "ace/mode/behaviour/cstyle",
                "ace/mode/folding/cstyle",
                "ace/worker/worker_client"
            ], function(e, t, n) {
                "use strict";
                function i() {
                    this.HighlightRules = s, this.$outdent = new a, this.$behaviour = new l, this.foldingRules = new c;
                }
                var o = e("../lib/oop"), r = e("./text").Mode, s = e("./json_highlight_rules").JsonHighlightRules, a = e("./matching_brace_outdent").MatchingBraceOutdent, l = e("./behaviour/cstyle").CstyleBehaviour, c = e("./folding/cstyle").FoldMode, h = e("../worker/worker_client").WorkerClient;
                o.inherits(i, r), (function() {
                    this.lineCommentStart = "//", this.blockComment = {
                        start: "/*",
                        end: "*/"
                    }, this.getNextLineIndent = function(e, t, n) {
                        var i = this.$getIndent(t);
                        return "start" == e && t.match(/^.*[\{\(\[]\s*$/) && (i += n), i;
                    }, this.checkOutdent = function(e, t, n) {
                        return this.$outdent.checkOutdent(t, n);
                    }, this.autoOutdent = function(e, t, n) {
                        this.$outdent.autoOutdent(t, n);
                    }, this.createWorker = function(t) {
                        var e = new h([
                            "ace"
                        ], "ace/mode/json_worker", "JsonWorker");
                        return e.attachToDocument(t.getDocument()), e.on("annotate", function(e) {
                            t.setAnnotations(e.data);
                        }), e.on("terminate", function() {
                            t.clearAnnotations();
                        }), e;
                    }, this.$id = "ace/mode/json";
                }).call(i.prototype), t.Mode = i;
            }), ace.require([
                "ace/mode/json"
            ], function(e) {
                t && (t.exports = e);
            });
        },
        8903: function(e, t, g) {
            "use strict";
            var s = g(5689), l = g(3969), p = g(5255), c = g(4293), m = g(3508), f = g(3368), C = g(742), y = g(9394), v = g(3724), e = ((e.exports = w).prototype.validate = function(e, t) {
                var n;
                if ("string" == typeof e) {
                    if (!(n = this.getSchema(e))) throw new Error('no schema with key or ref "' + e + '"');
                } else {
                    e = this._addSchema(e);
                    n = e.validate || this._compile(e);
                }
                e = n(t);
                !0 !== n.$async && (this.errors = n.errors);
                return e;
            }, w.prototype.compile = function(e, t) {
                e = this._addSchema(e, void 0, t);
                return e.validate || this._compile(e);
            }, w.prototype.addSchema = function(e, t, n, i) {
                if (Array.isArray(e)) for(var o = 0; o < e.length; o++)this.addSchema(e[o], void 0, n, i);
                else {
                    var r = this._getId(e);
                    if (void 0 !== r && "string" != typeof r) throw new Error("schema id must be string");
                    h(this, t = l.normalizeId(t || r)), this._schemas[t] = this._addSchema(e, n, i, !0);
                }
                return this;
            }, w.prototype.addMetaSchema = function(e, t, n) {
                return this.addSchema(e, t, n, !0), this;
            }, w.prototype.validateSchema = function(e, t) {
                var n = e.$schema;
                if (void 0 !== n && "string" != typeof n) throw new Error("$schema must be a string");
                if (!(n = n || this._opts.defaultMeta || function(e) {
                    var t = e._opts.meta;
                    return e._opts.defaultMeta = "object" == typeof t ? e._getId(t) || t : e.getSchema(I) ? I : void 0, e._opts.defaultMeta;
                }(this))) return this.logger.warn("meta-schema not available"), this.errors = null, true;
                n = this.validate(n, e);
                if (!n && t) {
                    e = "schema is invalid: " + this.errorsText();
                    if ("log" != this._opts.validateSchema) throw new Error(e);
                    this.logger.error(e);
                }
                return n;
            }, w.prototype.getSchema = function(e) {
                var t = n(this, e);
                switch(typeof t){
                    case "object":
                        return t.validate || this._compile(t);
                    case "string":
                        return this.getSchema(t);
                    case "undefined":
                        return function(e, t) {
                            var n = l.schema.call(e, {
                                schema: {}
                            }, t);
                            var i, o, r;
                            if (n) return i = n.schema, o = n.root, n = n.baseId, r = s.call(e, i, o, void 0, n), e._fragments[t] = new c({
                                ref: t,
                                fragment: !0,
                                schema: i,
                                root: o,
                                baseId: n,
                                validate: r
                            }), r;
                        }(this, e);
                }
            }, w.prototype.removeSchema = function(e) {
                if (e instanceof RegExp) i(this, this._schemas, e), i(this, this._refs, e);
                else switch(typeof e){
                    case "undefined":
                        return i(this, this._schemas), i(this, this._refs), this._cache.clear(), this;
                    case "string":
                        var t = n(this, e);
                        return t && this._cache.del(t.cacheKey), delete this._schemas[e], delete this._refs[e], this;
                    case "object":
                        t = this._opts.serialize, t = t ? t(e) : e, t = (this._cache.del(t), this._getId(e));
                        t && (t = l.normalizeId(t), delete this._schemas[t], delete this._refs[t]);
                }
                return this;
            }, w.prototype.addFormat = function(e, t) {
                "string" == typeof t && (t = new RegExp(t));
                return this._formats[e] = t, this;
            }, w.prototype.errorsText = function(e, t) {
                if (!(e = e || this.errors)) return "No errors";
                for(var n = void 0 === (t = t || {}).separator ? ", " : t.separator, i = void 0 === t.dataVar ? "data" : t.dataVar, o = "", r = 0; r < e.length; r++){
                    var s = e[r];
                    s && (o += i + s.dataPath + " " + s.message + n);
                }
                return o.slice(0, -n.length);
            }, w.prototype._addSchema = function(e, t, n, i) {
                if ("object" != typeof e && "boolean" != typeof e) throw new Error("schema should be object or boolean");
                var o = this._opts.serialize, o = o ? o(e) : e, r = this._cache.get(o);
                if (r) return r;
                i = i || !1 !== this._opts.addUsedSchema;
                r = l.normalizeId(this._getId(e));
                r && i && h(this, r);
                var s, t = !1 !== this._opts.validateSchema && !t;
                t && !(s = r && r == l.normalizeId(e.$schema)) && this.validateSchema(e, !0);
                var a = l.ids.call(this, e), a = new c({
                    id: r,
                    schema: e,
                    localRefs: a,
                    cacheKey: o,
                    meta: n
                });
                "#" != r[0] && i && (this._refs[r] = a);
                this._cache.put(o, a), t && s && this.validateSchema(e, !0);
                return a;
            }, w.prototype._compile = function(n, e) {
                if (n.compiling) return (n.validate = o).schema = n.schema, o.errors = null, o.root = e || o, !0 === n.schema.$async && (o.$async = !0), o;
                var t, i;
                n.compiling = !0, n.meta && (t = this._opts, this._opts = this._metaOpts);
                try {
                    i = s.call(this, n.schema, e, n.localRefs);
                } catch (e) {
                    throw delete n.validate, e;
                } finally{
                    n.compiling = !1, n.meta && (this._opts = t);
                }
                return n.validate = i, n.refs = i.refs, n.refVal = i.refVal, n.root = i.root, i;
                function o() {
                    var e = n.validate, t = e.apply(this, arguments);
                    return o.errors = e.errors, t;
                }
            }, w.prototype.compileAsync = g(9677), g(7931)), e = (w.prototype.addKeyword = e.add, w.prototype.getKeyword = e.get, w.prototype.removeKeyword = e.remove, w.prototype.validateKeyword = e.validate, g(5359)), I = (w.ValidationError = e.Validation, w.MissingRefError = e.MissingRef, w.$dataMetaSchema = y, "http://json-schema.org/draft-07/schema"), b = [
                "removeAdditional",
                "useDefaults",
                "coerceTypes",
                "strictDefaults"
            ], A = [
                "/properties"
            ];
            function w(e) {
                if (!(this instanceof w)) return new w(e);
                e = this._opts = v.copy(e) || {};
                var t = this, n = t._opts.logger;
                if (!1 === n) t.logger = {
                    log: E,
                    warn: E,
                    error: E
                };
                else {
                    if (!("object" == typeof (n = void 0 === n ? console : n) && n.log && n.warn && n.error)) throw new Error("logger must implement log, warn and error methods");
                    t.logger = n;
                }
                if (this._schemas = {}, this._refs = {}, this._fragments = {}, this._formats = f(e.format), this._cache = e.cache || new p, this._loadingSchemas = {}, this._compilations = [], this.RULES = C(), this._getId = function(e) {
                    switch(e.schemaId){
                        case "auto":
                            return k;
                        case "id":
                            return S;
                        default:
                            return x;
                    }
                }(e), e.loopRequired = e.loopRequired || 1 / 0, "property" == e.errorDataPath && (e._errorDataPathProperty = !0), void 0 === e.serialize && (e.serialize = m), this._metaOpts = function(e) {
                    for(var t = v.copy(e._opts), n = 0; n < b.length; n++)delete t[b[n]];
                    return t;
                }(this), e.formats) {
                    var i, o = this;
                    for(i in o._opts.formats){
                        var r = o._opts.formats[i];
                        o.addFormat(i, r);
                    }
                }
                if (e.keywords) {
                    var s, a = this;
                    for(s in a._opts.keywords){
                        var l = a._opts.keywords[s];
                        a.addKeyword(s, l);
                    }
                }
                var c, t = this, h = (t._opts.$data && (c = g(894), t.addMetaSchema(c, c.$id, !0)), !1 !== t._opts.meta && (c = g(6680), t._opts.$data && (c = y(c, A)), t.addMetaSchema(c, I, !0), t._refs["http://json-schema.org/schema"] = I), "object" == typeof e.meta && this.addMetaSchema(e.meta), e.nullable && this.addKeyword("nullable", {
                    metaSchema: {
                        type: "boolean"
                    }
                }), this), d = h._opts.schemas;
                if (d) {
                    if (Array.isArray(d)) h.addSchema(d);
                    else for(var u in d)h.addSchema(d[u], u);
                }
            }
            function n(e, t) {
                return t = l.normalizeId(t), e._schemas[t] || e._refs[t] || e._fragments[t];
            }
            function i(e, t, n) {
                for(var i in t){
                    var o = t[i];
                    o.meta || n && !n.test(i) || (e._cache.del(o.cacheKey), delete t[i]);
                }
            }
            function S(e) {
                return e.$id && this.logger.warn("schema $id ignored", e.$id), e.id;
            }
            function x(e) {
                return e.id && this.logger.warn("schema id ignored", e.id), e.$id;
            }
            function k(e) {
                if (e.$id && e.id && e.$id != e.id) throw new Error("schema $id is different from id");
                return e.$id || e.id;
            }
            function h(e, t) {
                if (e._schemas[t] || e._refs[t]) throw new Error('schema with key or id "' + t + '" already exists');
            }
            function E() {}
        },
        5255: function(e) {
            "use strict";
            e = e.exports = function() {
                this._cache = {};
            };
            e.prototype.put = function(e, t) {
                this._cache[e] = t;
            }, e.prototype.get = function(e) {
                return this._cache[e];
            }, e.prototype.del = function(e) {
                delete this._cache[e];
            }, e.prototype.clear = function() {
                this._cache = {};
            };
        },
        9677: function(e, t, n) {
            "use strict";
            var i = n(5359).MissingRef;
            function o(t, s, n) {
                var a = this;
                if ("function" != typeof this._opts.loadSchema) throw new Error("options.loadSchema should be a function");
                "function" == typeof s && (n = s, s = void 0);
                var e = l(t).then(function() {
                    var e = a._addSchema(t, void 0, s);
                    return e.validate || function o(r) {
                        try {
                            return a._compile(r);
                        } catch (e) {
                            if (e instanceof i) return t(e);
                            throw e;
                        }
                        function t(e) {
                            var t = e.missingSchema;
                            if (i(t)) throw new Error("Schema " + t + " is loaded but " + e.missingRef + " cannot be resolved");
                            e = a._loadingSchemas[t];
                            return e || (e = a._loadingSchemas[t] = a._opts.loadSchema(t)).then(n, n), e.then(function(e) {
                                if (!i(t)) return l(e).then(function() {
                                    i(t) || a.addSchema(e, t, void 0, s);
                                });
                            }).then(function() {
                                return o(r);
                            });
                            function n() {
                                delete a._loadingSchemas[t];
                            }
                            function i(e) {
                                return a._refs[e] || a._schemas[e];
                            }
                        }
                    }(e);
                });
                return n && e.then(function(e) {
                    n(null, e);
                }, n), e;
                function l(e) {
                    e = e.$schema;
                    return e && !a.getSchema(e) ? o.call(a, {
                        $ref: e
                    }, !0) : Promise.resolve();
                }
            }
            e.exports = o;
        },
        5359: function(e, t, n) {
            "use strict";
            var i = n(3969);
            function o(e, t, n) {
                this.message = n || o.message(e, t), this.missingRef = i.url(e, t), this.missingSchema = i.normalizeId(i.fullPath(this.missingRef));
            }
            function r(e) {
                return e.prototype = Object.create(Error.prototype), e.prototype.constructor = e;
            }
            e.exports = {
                Validation: r(function(e) {
                    this.message = "validation failed", this.errors = e, this.ajv = this.validation = !0;
                }),
                MissingRef: r(o)
            }, o.message = function(e, t) {
                return "can't resolve reference " + t + " from id " + e;
            };
        },
        3368: function(e, t, n) {
            "use strict";
            var i = n(3724), o = /^(\d\d\d\d)-(\d\d)-(\d\d)$/, r = [
                0,
                31,
                28,
                31,
                30,
                31,
                30,
                31,
                31,
                30,
                31,
                30,
                31
            ], s = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i, n = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i, a = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i, l = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i, c = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i, h = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i, d = /^(?:\/(?:[^~/]|~0|~1)*)*$/, u = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i, g = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
            function p(e) {
                return i.copy(p[e = "full" == e ? "full" : "fast"]);
            }
            function m(e) {
                var t, n, e = e.match(o);
                return !!e && (t = +e[1], n = +e[2], e = +e[3], 1 <= n) && n <= 12 && 1 <= e && e <= (2 != n || (e = t) % 4 != 0 || e % 100 == 0 && e % 400 != 0 ? r[n] : 29);
            }
            function f(e, t) {
                var n, i, o, e = e.match(s);
                return !!e && (n = e[1], i = e[2], o = e[3], e = e[5], n <= 23 && i <= 59 && o <= 59 || 23 == n && 59 == i && 60 == o) && (!t || e);
            }
            (e.exports = p).fast = {
                date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
                time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
                "date-time": /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
                uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
                "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
                "uri-template": l,
                url: c,
                email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
                hostname: n,
                ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
                ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
                regex: I,
                uuid: h,
                "json-pointer": d,
                "json-pointer-uri-fragment": u,
                "relative-json-pointer": g
            }, p.full = {
                date: m,
                time: f,
                "date-time": function(e) {
                    e = e.split(C);
                    return 2 == e.length && m(e[0]) && f(e[1], !0);
                },
                uri: function(e) {
                    return y.test(e) && a.test(e);
                },
                "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
                "uri-template": l,
                url: c,
                email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
                hostname: n,
                ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
                ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
                regex: I,
                uuid: h,
                "json-pointer": d,
                "json-pointer-uri-fragment": u,
                "relative-json-pointer": g
            };
            var C = /t|\s/i;
            var y = /\/|:/;
            var v = /[^\\]\\Z/;
            function I(e) {
                if (v.test(e)) return !1;
                try {
                    return new RegExp(e), !0;
                } catch (e) {
                    return !1;
                }
            }
        },
        5689: function(e, t, n) {
            "use strict";
            var E = n(3969), T = n(3724), R = n(5359), _ = n(3508), $ = n(1869), L = T.ucs2length, N = n(2303), B = R.Validation;
            function M(e, s, a, t) {
                var l = this, c = this._opts, h = [
                    void 0
                ], d = {}, u = [], n = {}, g = [], i = {}, p = [], o = (s = s || {
                    schema: e,
                    refVal: h,
                    refs: d
                }, (function(e, t, n) {
                    var i = W.call(this, e, t, n);
                    return 0 <= i ? {
                        index: i,
                        compiling: !0
                    } : (i = this._compilations.length, this._compilations[i] = {
                        schema: e,
                        root: t,
                        baseId: n
                    }, {
                        index: i,
                        compiling: !1
                    });
                }).call(this, e, s, t)), r = this._compilations[o.index];
                if (o.compiling) return r.callValidate = v;
                var m = this._formats, f = this.RULES;
                try {
                    var C = I(e, s, a, t), y = (r.validate = C, r.callValidate);
                    return y && (y.schema = C.schema, y.errors = null, y.refs = C.refs, y.refVal = C.refVal, y.root = C.root, y.$async = C.$async, c.sourceCode) && (y.source = C.source), C;
                } finally{
                    (function(e, t, n) {
                        e = W.call(this, e, t, n);
                        0 <= e && this._compilations.splice(e, 1);
                    }).call(this, e, s, t);
                }
                function v() {
                    var e = r.validate, t = e.apply(this, arguments);
                    return v.errors = e.errors, t;
                }
                function I(e, t, n, i) {
                    var o = !t || t.schema == e;
                    if (t.schema != s.schema) return M.call(l, e, t, n, i);
                    n = !0 === e.$async, i = $({
                        isTop: !0,
                        schema: e,
                        isRoot: o,
                        baseId: i,
                        root: t,
                        schemaPath: "",
                        errSchemaPath: "#",
                        errorPath: '""',
                        MissingRefError: R.MissingRef,
                        RULES: f,
                        validate: $,
                        util: T,
                        resolve: E,
                        resolveRef: b,
                        usePattern: S,
                        useDefault: x,
                        useCustomRule: k,
                        opts: c,
                        formats: m,
                        logger: l.logger,
                        self: l
                    }), i = V(h, P) + V(u, H) + V(g, G) + V(p, F) + i;
                    c.processCode && (i = c.processCode(i, e));
                    try {
                        var r = new Function("self", "RULES", "formats", "root", "refVal", "defaults", "customRules", "equal", "ucs2length", "ValidationError", i)(l, f, m, s, h, g, p, N, L, B);
                        h[0] = r;
                    } catch (e) {
                        throw l.logger.error("Error compiling schema, function code:", i), e;
                    }
                    return r.schema = e, r.errors = null, r.refs = d, r.refVal = h, r.root = o ? r : t, n && (r.$async = !0), !0 === c.sourceCode && (r.source = {
                        code: i,
                        patterns: u,
                        defaults: g
                    }), r;
                }
                function b(e, t, n) {
                    t = E.url(e, t);
                    var i = d[t];
                    if (void 0 !== i) return w(o = h[i], r = "refVal[" + i + "]");
                    if (!n && s.refs) {
                        i = s.refs[t];
                        if (void 0 !== i) return w(o = s.refVal[i], r = A(t, o));
                    }
                    var o, r = A(t), n = E.call(l, I, s, t);
                    if (void 0 !== (n = void 0 === n && (i = a && a[t]) ? E.inlineRef(i, c.inlineRefs) ? i : M.call(l, i, s, a, e) : n)) return o = n, i = d[i = t], h[i] = o, w(n, r);
                    delete d[t];
                }
                function A(e, t) {
                    var n = h.length;
                    return h[n] = t, "refVal" + (d[e] = n);
                }
                function w(e, t) {
                    return "object" == typeof e || "boolean" == typeof e ? {
                        code: t,
                        schema: e,
                        inline: !0
                    } : {
                        code: t,
                        $async: e && !!e.$async
                    };
                }
                function S(e) {
                    var t = n[e];
                    return void 0 === t && (t = n[e] = u.length, u[t] = e), "pattern" + t;
                }
                function x(e) {
                    switch(typeof e){
                        case "boolean":
                        case "number":
                            return "" + e;
                        case "string":
                            return T.toQuotedString(e);
                        case "object":
                            var t, n;
                            return null === e ? "null" : (t = _(e), void 0 === (n = i[t]) && (n = i[t] = g.length, g[n] = e), "default" + n);
                    }
                }
                function k(e, t, n, i) {
                    if (!1 !== l._opts.validateSchema) {
                        var o = e.definition.dependencies;
                        if (o && !o.every(function(e) {
                            return Object.prototype.hasOwnProperty.call(n, e);
                        })) throw new Error("parent schema must have all required keywords: " + o.join(","));
                        o = e.definition.validateSchema;
                        if (o) {
                            if (!o(t)) {
                                o = "keyword schema is invalid: " + l.errorsText(o.errors);
                                if ("log" != l._opts.validateSchema) throw new Error(o);
                                l.logger.error(o);
                            }
                        }
                    }
                    var r, o = e.definition.compile, s = e.definition.inline, a = e.definition.macro;
                    if (o) r = o.call(l, t, n, i);
                    else if (a) r = a.call(l, t, n, i), !1 !== c.validateSchema && l.validateSchema(r, !0);
                    else if (s) r = s.call(l, i, e.keyword, t, n);
                    else if (!(r = e.definition.validate)) return;
                    if (void 0 === r) throw new Error('custom keyword "' + e.keyword + '"failed to compile');
                    o = p.length;
                    return {
                        code: "customRule" + o,
                        validate: p[o] = r
                    };
                }
            }
            function W(e, t, n) {
                for(var i = 0; i < this._compilations.length; i++){
                    var o = this._compilations[i];
                    if (o.schema == e && o.root == t && o.baseId == n) return i;
                }
                return -1;
            }
            function H(e, t) {
                return "var pattern" + e + " = new RegExp(" + T.toQuotedString(t[e]) + ");";
            }
            function G(e) {
                return "var default" + e + " = defaults[" + e + "];";
            }
            function P(e, t) {
                return void 0 === t[e] ? "" : "var refVal" + e + " = refVal[" + e + "];";
            }
            function F(e) {
                return "var customRule" + e + " = customRules[" + e + "];";
            }
            function V(e, t) {
                if (!e.length) return "";
                for(var n = "", i = 0; i < e.length; i++)n += t(i, e);
                return n;
            }
            e.exports = M;
        },
        3969: function(e, t, n) {
            "use strict";
            var g = n(7533), p = n(2303), m = n(3724), a = n(4293), i = n(500);
            function l(e, t, n) {
                var i, o, r, s = this._refs[n];
                if ("string" == typeof s) {
                    if (!this._refs[s]) return l.call(this, e, t, s);
                    s = this._refs[s];
                }
                return (s = s || this._schemas[n]) instanceof a ? u(s.schema, this._opts.inlineRefs) ? s.schema : s.validate || this._compile(s) : ((s = c.call(this, t, n)) && (i = s.schema, t = s.root, r = s.baseId), i instanceof a ? o = i.validate || e.call(this, i.schema, t, void 0, r) : void 0 !== i && (o = u(i, this._opts.inlineRefs) ? i : e.call(this, i, t, void 0, r)), o);
            }
            function c(e, t) {
                var n = g.parse(t), i = C(n), o = f(this._getId(e.schema));
                if (0 === Object.keys(e.schema).length || i !== o) {
                    var i = y(i), r = this._refs[i];
                    if ("string" == typeof r) return (function(e, t, n) {
                        t = c.call(this, e, t);
                        var i, o;
                        if (t) return i = t.schema, o = t.baseId, e = t.root, (t = this._getId(i)) && (o = v(o, t)), s.call(this, n, o, i, e);
                    }).call(this, e, r, n);
                    if (r instanceof a) r.validate || this._compile(r);
                    else {
                        if (!((r = this._schemas[i]) instanceof a)) return;
                        if (r.validate || this._compile(r), i == y(t)) return {
                            schema: r,
                            root: e,
                            baseId: o
                        };
                    }
                    if (!(e = r).schema) return;
                    o = f(this._getId(e.schema));
                }
                return s.call(this, n, o, e.schema, e);
            }
            (e.exports = l).normalizeId = y, l.fullPath = f, l.url = v, l.ids = function(e) {
                var t = y(this._getId(e)), c = {
                    "": t
                }, h = {
                    "": f(t, !1)
                }, d = {}, u = this;
                return i(e, {
                    allKeys: !0
                }, function(e, t, n, i, o, r, s) {
                    if ("" !== t) {
                        var a = u._getId(e), l = c[i], i = h[i] + "/" + o;
                        if (void 0 !== s && (i += "/" + ("number" == typeof s ? s : m.escapeFragment(s))), "string" == typeof a) {
                            a = l = y(l ? g.resolve(l, a) : a), o = u._refs[a];
                            if ((o = "string" == typeof o ? u._refs[o] : o) && o.schema) {
                                if (!p(e, o.schema)) throw new Error('id "' + a + '" resolves to more than one schema');
                            } else if (a != y(i)) {
                                if ("#" == a[0]) {
                                    if (d[a] && !p(e, d[a])) throw new Error('id "' + a + '" resolves to more than one schema');
                                    d[a] = e;
                                } else u._refs[a] = i;
                            }
                        }
                        c[t] = l, h[t] = i;
                    }
                }), d;
            }, l.inlineRef = u, l.schema = c;
            var h = m.toHash([
                "properties",
                "patternProperties",
                "enum",
                "dependencies",
                "definitions"
            ]);
            function s(e, t, n, i) {
                if (e.fragment = e.fragment || "", "/" == e.fragment.slice(0, 1)) {
                    for(var o = e.fragment.split("/"), r = 1; r < o.length; r++){
                        var s = o[r];
                        if (s) {
                            if (void 0 === (n = n[s = m.unescapeFragment(s)])) break;
                            h[s] || ((s = this._getId(n)) && (t = v(t, s)), n.$ref && (s = v(t, n.$ref), s = c.call(this, i, s)) && (n = s.schema, i = s.root, t = s.baseId));
                        }
                    }
                    return void 0 !== n && n !== i.schema ? {
                        schema: n,
                        root: i,
                        baseId: t
                    } : void 0;
                }
            }
            var d = m.toHash([
                "type",
                "format",
                "pattern",
                "maxLength",
                "minLength",
                "maxProperties",
                "minProperties",
                "maxItems",
                "minItems",
                "maximum",
                "minimum",
                "uniqueItems",
                "multipleOf",
                "required",
                "enum"
            ]);
            function u(e, t) {
                return !1 !== t && (void 0 === t || !0 === t ? function e(t) {
                    var n;
                    if (Array.isArray(t)) {
                        for(var i = 0; i < t.length; i++)if ("object" == typeof (n = t[i]) && !e(n)) return !1;
                    } else for(var o in t){
                        if ("$ref" == o) return !1;
                        if ("object" == typeof (n = t[o]) && !e(n)) return !1;
                    }
                    return !0;
                }(e) : t ? function e(t) {
                    var n, i = 0;
                    if (Array.isArray(t)) {
                        for(var o = 0; o < t.length; o++)if ("object" == typeof (n = t[o]) && (i += e(n)), i == 1 / 0) return 1 / 0;
                    } else for(var r in t){
                        if ("$ref" == r) return 1 / 0;
                        if (d[r]) i++;
                        else if ("object" == typeof (n = t[r]) && (i += e(n) + 1), i == 1 / 0) return 1 / 0;
                    }
                    return i;
                }(e) <= t : void 0);
            }
            function f(e, t) {
                return !1 !== t && (e = y(e)), C(g.parse(e));
            }
            function C(e) {
                return g.serialize(e).split("#")[0] + "#";
            }
            var o = /#\/?$/;
            function y(e) {
                return e ? e.replace(o, "") : "";
            }
            function v(e, t) {
                return t = y(t), g.resolve(e, t);
            }
        },
        742: function(e, t, n) {
            "use strict";
            var r = n(9646), s = n(3724).toHash;
            e.exports = function() {
                var i = [
                    {
                        type: "number",
                        rules: [
                            {
                                maximum: [
                                    "exclusiveMaximum"
                                ]
                            },
                            {
                                minimum: [
                                    "exclusiveMinimum"
                                ]
                            },
                            "multipleOf",
                            "format"
                        ]
                    },
                    {
                        type: "string",
                        rules: [
                            "maxLength",
                            "minLength",
                            "pattern",
                            "format"
                        ]
                    },
                    {
                        type: "array",
                        rules: [
                            "maxItems",
                            "minItems",
                            "items",
                            "contains",
                            "uniqueItems"
                        ]
                    },
                    {
                        type: "object",
                        rules: [
                            "maxProperties",
                            "minProperties",
                            "required",
                            "dependencies",
                            "propertyNames",
                            {
                                properties: [
                                    "additionalProperties",
                                    "patternProperties"
                                ]
                            }
                        ]
                    },
                    {
                        rules: [
                            "$ref",
                            "const",
                            "enum",
                            "not",
                            "anyOf",
                            "oneOf",
                            "allOf",
                            "if"
                        ]
                    }
                ], o = [
                    "type",
                    "$comment"
                ];
                return i.all = s(o), i.types = s([
                    "number",
                    "integer",
                    "string",
                    "array",
                    "object",
                    "boolean",
                    "null"
                ]), i.forEach(function(e) {
                    e.rules = e.rules.map(function(e) {
                        var t, n;
                        return "object" == typeof e && (n = e[t = Object.keys(e)[0]], e = t, n.forEach(function(e) {
                            o.push(e), i.all[e] = !0;
                        })), o.push(e), i.all[e] = {
                            keyword: e,
                            code: r[e],
                            implements: n
                        };
                    }), i.all.$comment = {
                        keyword: "$comment",
                        code: r.$comment
                    }, e.type && (i.types[e.type] = e);
                }), i.keywords = s(o.concat([
                    "$schema",
                    "$id",
                    "id",
                    "$data",
                    "$async",
                    "title",
                    "description",
                    "default",
                    "definitions",
                    "examples",
                    "readOnly",
                    "writeOnly",
                    "contentMediaType",
                    "contentEncoding",
                    "additionalItems",
                    "then",
                    "else"
                ])), i.custom = {}, i;
            };
        },
        4293: function(e, t, n) {
            "use strict";
            var i = n(3724);
            e.exports = function(e) {
                i.copy(e, this);
            };
        },
        6887: function(e) {
            "use strict";
            e.exports = function(e) {
                for(var t, n = 0, i = e.length, o = 0; o < i;)n++, 55296 <= (t = e.charCodeAt(o++)) && t <= 56319 && o < i && 56320 == (64512 & e.charCodeAt(o)) && o++;
                return n;
            };
        },
        3724: function(e, t, n) {
            "use strict";
            function r(e, t, n, i) {
                var o = i ? " !== " : " === ", r = i ? " || " : " && ", s = i ? "!" : "", a = i ? "" : "!";
                switch(e){
                    case "null":
                        return t + o + "null";
                    case "array":
                        return s + "Array.isArray(" + t + ")";
                    case "object":
                        return "(" + s + t + r + "typeof " + t + o + '"object"' + r + a + "Array.isArray(" + t + "))";
                    case "integer":
                        return "(typeof " + t + o + '"number"' + r + a + "(" + t + " % 1)" + r + t + o + t + (n ? r + s + "isFinite(" + t + ")" : "") + ")";
                    case "number":
                        return "(typeof " + t + o + '"' + e + '"' + (n ? r + s + "isFinite(" + t + ")" : "") + ")";
                    default:
                        return "typeof " + t + o + '"' + e + '"';
                }
            }
            e.exports = {
                copy: function(e, t) {
                    for(var n in t = t || {}, e)t[n] = e[n];
                    return t;
                },
                checkDataType: r,
                checkDataTypes: function(e, t, n) {
                    if (1 === e.length) return r(e[0], t, n, !0);
                    var i, o = "", e = a(e);
                    for(i in e.array && e.object && (o = e.null ? "(" : "(!" + t + " || ", o += "typeof " + t + ' !== "object")', delete e.null, delete e.array, delete e.object), e.number && delete e.integer, e)o += (o ? " && " : "") + r(i, t, n, !0);
                    return o;
                },
                coerceToTypes: function(e, t) {
                    if (!Array.isArray(t)) return s[t] ? [
                        t
                    ] : "array" === e && "array" === t ? [
                        "array"
                    ] : void 0;
                    for(var n = [], i = 0; i < t.length; i++){
                        var o = t[i];
                        (s[o] || "array" === e && "array" === o) && (n[n.length] = o);
                    }
                    return n.length ? n : void 0;
                },
                toHash: a,
                getProperty: h,
                escapeQuotes: l,
                equal: n(2303),
                ucs2length: n(6887),
                varOccurences: function(e, t) {
                    t += "[^0-9]";
                    e = e.match(new RegExp(t, "g"));
                    return e ? e.length : 0;
                },
                varReplace: function(e, t, n) {
                    return t += "([^0-9])", n = n.replace(/\$/g, "$$$$"), e.replace(new RegExp(t, "g"), n + "$1");
                },
                schemaHasRules: function(e, t) {
                    if ("boolean" == typeof e) return !e;
                    for(var n in e)if (t[n]) return !0;
                },
                schemaHasRulesExcept: function(e, t, n) {
                    if ("boolean" == typeof e) return !e && "not" != n;
                    for(var i in e)if (i != n && t[i]) return !0;
                },
                schemaUnknownRules: function(e, t) {
                    if ("boolean" != typeof e) {
                        for(var n in e)if (!t[n]) return n;
                    }
                },
                toQuotedString: c,
                getPathExpr: function(e, t, n, i) {
                    return g(e, n ? "'/' + " + t + (i ? "" : ".replace(/~/g, '~0').replace(/\\//g, '~1')") : i ? "'[' + " + t + " + ']'" : "'[\\'' + " + t + " + '\\']'");
                },
                getPath: function(e, t, n) {
                    n = c(n ? "/" + p(t) : h(t));
                    return g(e, n);
                },
                getData: function(e, t, n) {
                    var i, o, r;
                    if ("" === e) return "rootData";
                    if ("/" == e[0]) {
                        if (!d.test(e)) throw new Error("Invalid JSON-pointer: " + e);
                        i = e, o = "rootData";
                    } else {
                        if (!(r = e.match(u))) throw new Error("Invalid JSON-pointer: " + e);
                        if (e = +r[1], "#" == (i = r[2])) {
                            if (t <= e) throw new Error("Cannot access property/index " + e + " levels up, current level is " + t);
                            return n[t - e];
                        }
                        if (t < e) throw new Error("Cannot access data " + e + " levels up, current level is " + t);
                        if (o = "data" + (t - e || ""), !i) return o;
                    }
                    for(var s = o, a = i.split("/"), l = 0; l < a.length; l++){
                        var c = a[l];
                        c && (o += h(m(c)), s += " && " + o);
                    }
                    return s;
                },
                unescapeFragment: function(e) {
                    return m(decodeURIComponent(e));
                },
                unescapeJsonPointer: m,
                escapeFragment: function(e) {
                    return encodeURIComponent(p(e));
                },
                escapeJsonPointer: p
            };
            var s = a([
                "string",
                "number",
                "integer",
                "boolean",
                "null"
            ]);
            function a(e) {
                for(var t = {}, n = 0; n < e.length; n++)t[e[n]] = !0;
                return t;
            }
            var i = /^[a-z$_][a-z$_0-9]*$/i, o = /'|\\/g;
            function h(e) {
                return "number" == typeof e ? "[" + e + "]" : i.test(e) ? "." + e : "['" + l(e) + "']";
            }
            function l(e) {
                return e.replace(o, "\\$&").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\f/g, "\\f").replace(/\t/g, "\\t");
            }
            function c(e) {
                return "'" + l(e) + "'";
            }
            var d = /^\/(?:[^~]|~0|~1)*$/, u = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
            function g(e, t) {
                return '""' == e ? t : (e + " + " + t).replace(/([^\\])' \+ '/g, "$1");
            }
            function p(e) {
                return e.replace(/~/g, "~0").replace(/\//g, "~1");
            }
            function m(e) {
                return e.replace(/~1/g, "/").replace(/~0/g, "~");
            }
        },
        9394: function(e) {
            "use strict";
            var l = [
                "multipleOf",
                "maximum",
                "exclusiveMaximum",
                "minimum",
                "exclusiveMinimum",
                "maxLength",
                "minLength",
                "pattern",
                "additionalItems",
                "maxItems",
                "minItems",
                "uniqueItems",
                "maxProperties",
                "minProperties",
                "required",
                "additionalProperties",
                "enum",
                "format",
                "const"
            ];
            e.exports = function(e, t) {
                for(var n = 0; n < t.length; n++){
                    e = JSON.parse(JSON.stringify(e));
                    for(var i = t[n].split("/"), o = e, r = 1; r < i.length; r++)o = o[i[r]];
                    for(r = 0; r < l.length; r++){
                        var s = l[r], a = o[s];
                        a && (o[s] = {
                            anyOf: [
                                a,
                                {
                                    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
                                }
                            ]
                        });
                    }
                }
                return e;
            };
        },
        5868: function(e, t, n) {
            "use strict";
            n = n(6680);
            e.exports = {
                $id: "https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js",
                definitions: {
                    simpleTypes: n.definitions.simpleTypes
                },
                type: "object",
                dependencies: {
                    schema: [
                        "validate"
                    ],
                    $data: [
                        "validate"
                    ],
                    statements: [
                        "inline"
                    ],
                    valid: {
                        not: {
                            required: [
                                "macro"
                            ]
                        }
                    }
                },
                properties: {
                    type: n.properties.type,
                    schema: {
                        type: "boolean"
                    },
                    statements: {
                        type: "boolean"
                    },
                    dependencies: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    },
                    metaSchema: {
                        type: "object"
                    },
                    modifying: {
                        type: "boolean"
                    },
                    valid: {
                        type: "boolean"
                    },
                    $data: {
                        type: "boolean"
                    },
                    async: {
                        type: "boolean"
                    },
                    errors: {
                        anyOf: [
                            {
                                type: "boolean"
                            },
                            {
                                const: "full"
                            }
                        ]
                    }
                }
            };
        },
        1796: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i, o, r, s, a, l = " ", c = e.level, h = e.dataLevel, d = e.schema[t], u = e.schemaPath + e.util.getProperty(t), g = e.errSchemaPath + "/" + t, p = !e.opts.allErrors, m = "data" + (h || ""), f = e.opts.$data && d && d.$data, C = f ? (l += " var schema" + c + " = " + e.util.getData(d.$data, h, e.dataPathArr) + "; ", "schema" + c) : d, y = "maximum" == t, v = y ? "exclusiveMaximum" : "exclusiveMinimum", I = e.schema[v], b = e.opts.$data && I && I.$data, A = y ? "<" : ">", w = y ? ">" : "<", S = void 0;
                if (!f && "number" != typeof d && void 0 !== d) throw new Error(t + " must be number");
                if (!b && void 0 !== I && "number" != typeof I && "boolean" != typeof I) throw new Error(v + " must be number or boolean");
                b ? (h = e.util.getData(I.$data, h, e.dataPathArr), r = "exclIsNumber" + c, s = "' + " + (a = "op" + c) + " + '", S = v, (x = x || []).push(l = l + (" var schemaExcl" + c + " = " + h + "; ") + (" var " + (i = "exclusive" + c) + "; var " + (o = "exclType" + c) + " = typeof " + (h = "schemaExcl" + c) + "; if (" + o + " != 'boolean' && " + o + " != 'undefined' && " + o + " != 'number') { ")), l = "", !1 !== e.createErrors ? (l += " { keyword: '" + (S || "_exclusiveLimit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(g) + " , params: {} ", !1 !== e.opts.messages && (l += " , message: '" + v + " should be boolean' "), e.opts.verbose && (l += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + m + " "), l += " } ") : l += " {} ", k = l, l = x.pop(), !e.compositeRule && p ? e.async ? l += " throw new ValidationError([" + k + "]); " : l += " validate.errors = [" + k + "]; return false; " : l += " var err = " + k + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", l += " } else if ( ", f && (l += " (" + C + " !== undefined && typeof " + C + " != 'number') || "), l += " " + o + " == 'number' ? ( (" + i + " = " + C + " === undefined || " + h + " " + A + "= " + C + ") ? " + m + " " + w + "= " + h + " : " + m + " " + w + " " + C + " ) : ( (" + i + " = " + h + " === true) ? " + m + " " + w + "= " + C + " : " + m + " " + w + " " + C + " ) || " + m + " !== " + m + ") { var op" + c + " = " + i + " ? '" + A + "' : '" + A + "='; ", void 0 === d && (g = e.errSchemaPath + "/" + (S = v), C = h, f = b)) : (s = A, (r = "number" == typeof I) && f ? (a = "'" + s + "'", l += " if ( ", f && (l += " (" + C + " !== undefined && typeof " + C + " != 'number') || "), l += " ( " + C + " === undefined || " + I + " " + A + "= " + C + " ? " + m + " " + w + "= " + I + " : " + m + " " + w + " " + C + " ) || " + m + " !== " + m + ") { ") : (r && void 0 === d ? (i = !0, g = e.errSchemaPath + "/" + (S = v), C = I, w += "=") : (r && (C = Math[y ? "min" : "max"](I, d)), I === (!r || C) ? (i = !0, g = e.errSchemaPath + "/" + (S = v), w += "=") : (i = !1, s += "=")), a = "'" + s + "'", l += " if ( ", f && (l += " (" + C + " !== undefined && typeof " + C + " != 'number') || "), l += " " + m + " " + w + " " + C + " || " + m + " !== " + m + ") { ")), S = S || t;
                (x = x || []).push(l), l = "", !1 !== e.createErrors ? (l += " { keyword: '" + (S || "_limit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(g) + " , params: { comparison: " + a + ", limit: " + C + ", exclusive: " + i + " } ", !1 !== e.opts.messages && (l = l + " , message: 'should be " + s + " " + (f ? "' + " + C : C + "'")), e.opts.verbose && (l = (l += " , schema:  ") + (f ? "validate.schema" + u : "" + d) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + m + " "), l += " } ") : l += " {} ";
                var x, k = l;
                return l = x.pop(), !e.compositeRule && p ? e.async ? l += " throw new ValidationError([" + k + "]); " : l += " validate.errors = [" + k + "]; return false; " : l += " var err = " + k + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", l += " } ", p && (l += " else { "), l;
            };
        },
        2407: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i, o = " ", r = e.level, s = e.dataLevel, a = e.schema[t], l = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, h = !e.opts.allErrors, d = "data" + (s || ""), u = e.opts.$data && a && a.$data, s = u ? (o += " var schema" + r + " = " + e.util.getData(a.$data, s, e.dataPathArr) + "; ", "schema" + r) : a;
                if (u || "number" == typeof a) return o += "if ( ", u && (o += " (" + s + " !== undefined && typeof " + s + " != 'number') || "), (r = []).push(o += " " + d + ".length " + ("maxItems" == (i = t) ? ">" : "<") + " " + s + ") { "), o = "", !1 !== e.createErrors ? (o += " { keyword: '" + (i || "_limitItems") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { limit: " + s + " } ", !1 !== e.opts.messages && (o = (o = (o += " , message: 'should NOT have ") + ("maxItems" == t ? "more" : "fewer") + " than ") + (u ? "' + " + s + " + '" : "" + a) + " items' "), e.opts.verbose && (o = (o += " , schema:  ") + (u ? "validate.schema" + l : "" + a) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), o += " } ") : o += " {} ", i = o, o = r.pop(), !e.compositeRule && h ? e.async ? o += " throw new ValidationError([" + i + "]); " : o += " validate.errors = [" + i + "]; return false; " : o += " var err = " + i + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += "} ", h && (o += " else { "), o;
                throw new Error(t + " must be number");
            };
        },
        1250: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i, o = " ", r = e.level, s = e.dataLevel, a = e.schema[t], l = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, h = !e.opts.allErrors, d = "data" + (s || ""), u = e.opts.$data && a && a.$data, s = u ? (o += " var schema" + r + " = " + e.util.getData(a.$data, s, e.dataPathArr) + "; ", "schema" + r) : a;
                if (u || "number" == typeof a) return o += "if ( ", u && (o += " (" + s + " !== undefined && typeof " + s + " != 'number') || "), !1 === e.opts.unicode ? o += " " + d + ".length " : o += " ucs2length(" + d + ") ", (r = []).push(o += " " + ("maxLength" == (i = t) ? ">" : "<") + " " + s + ") { "), o = "", !1 !== e.createErrors ? (o += " { keyword: '" + (i || "_limitLength") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { limit: " + s + " } ", !1 !== e.opts.messages && (o = (o = (o += " , message: 'should NOT be ") + ("maxLength" == t ? "longer" : "shorter") + " than ") + (u ? "' + " + s + " + '" : "" + a) + " characters' "), e.opts.verbose && (o = (o += " , schema:  ") + (u ? "validate.schema" + l : "" + a) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), o += " } ") : o += " {} ", i = o, o = r.pop(), !e.compositeRule && h ? e.async ? o += " throw new ValidationError([" + i + "]); " : o += " validate.errors = [" + i + "]; return false; " : o += " var err = " + i + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += "} ", h && (o += " else { "), o;
                throw new Error(t + " must be number");
            };
        },
        2596: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i, o = " ", r = e.level, s = e.dataLevel, a = e.schema[t], l = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, h = !e.opts.allErrors, d = "data" + (s || ""), u = e.opts.$data && a && a.$data, s = u ? (o += " var schema" + r + " = " + e.util.getData(a.$data, s, e.dataPathArr) + "; ", "schema" + r) : a;
                if (u || "number" == typeof a) return o += "if ( ", u && (o += " (" + s + " !== undefined && typeof " + s + " != 'number') || "), (r = []).push(o += " Object.keys(" + d + ").length " + ("maxProperties" == (i = t) ? ">" : "<") + " " + s + ") { "), o = "", !1 !== e.createErrors ? (o += " { keyword: '" + (i || "_limitProperties") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { limit: " + s + " } ", !1 !== e.opts.messages && (o = (o = (o += " , message: 'should NOT have ") + ("maxProperties" == t ? "more" : "fewer") + " than ") + (u ? "' + " + s + " + '" : "" + a) + " properties' "), e.opts.verbose && (o = (o += " , schema:  ") + (u ? "validate.schema" + l : "" + a) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), o += " } ") : o += " {} ", i = o, o = r.pop(), !e.compositeRule && h ? e.async ? o += " throw new ValidationError([" + i + "]); " : o += " validate.errors = [" + i + "]; return false; " : o += " var err = " + i + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += "} ", h && (o += " else { "), o;
                throw new Error(t + " must be number");
            };
        },
        9486: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i = " ", o = e.schema[t], r = e.schemaPath + e.util.getProperty(t), s = e.errSchemaPath + "/" + t, a = !e.opts.allErrors, l = e.util.copy(e), c = "", h = (l.level++, "valid" + l.level), d = l.baseId, u = !0, g = o;
                if (g) for(var p, m = -1, f = g.length - 1; m < f;)p = g[m += 1], (e.opts.strictKeywords ? "object" == typeof p && 0 < Object.keys(p).length || !1 === p : e.util.schemaHasRules(p, e.RULES.all)) && (u = !1, l.schema = p, l.schemaPath = r + "[" + m + "]", l.errSchemaPath = s + "/" + m, i += "  " + e.validate(l) + " ", l.baseId = d, a) && (i += " if (" + h + ") { ", c += "}");
                return a && (i += u ? " if (true) { " : " " + c.slice(0, -1) + " "), i;
            };
        },
        5347: function(e) {
            "use strict";
            e.exports = function(t, e, n) {
                var i = " ", o = t.level, r = t.dataLevel, s = t.schema[e], a = t.schemaPath + t.util.getProperty(e), l = t.errSchemaPath + "/" + e, e = !t.opts.allErrors, r = "data" + (r || ""), c = "valid" + o, o = "errs__" + o, h = t.util.copy(t), d = "", u = (h.level++, "valid" + h.level);
                if (s.every(function(e) {
                    return t.opts.strictKeywords ? "object" == typeof e && 0 < Object.keys(e).length || !1 === e : t.util.schemaHasRules(e, t.RULES.all);
                })) {
                    var g = h.baseId, p = (i += " var " + o + " = errors; var " + c + " = false;  ", t.compositeRule), m = (t.compositeRule = h.compositeRule = !0, s);
                    if (m) for(var f, C = -1, y = m.length - 1; C < y;)f = m[C += 1], h.schema = f, h.schemaPath = a + "[" + C + "]", h.errSchemaPath = l + "/" + C, i += "  " + t.validate(h) + " ", h.baseId = g, i += " " + c + " = " + c + " || " + u + "; if (!" + c + ") { ", d += "}";
                    t.compositeRule = h.compositeRule = p, i += " " + d + " if (!" + c + ") {   var err =   ", !1 !== t.createErrors ? (i += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(l) + " , params: {} ", !1 !== t.opts.messages && (i += " , message: 'should match some schema in anyOf' "), t.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + r + " "), i += " } ") : i += " {} ", i += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !t.compositeRule && e && (t.async ? i += " throw new ValidationError(vErrors); " : i += " validate.errors = vErrors; return false; "), i += " } else {  errors = " + o + "; if (vErrors !== null) { if (" + o + ") vErrors.length = " + o + "; else vErrors = null; } ", t.opts.allErrors && (i += " } ");
                } else e && (i += " if (true) { ");
                return i;
            };
        },
        923: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i = " ", o = e.schema[t], t = e.errSchemaPath + "/" + t, o = (e.opts.allErrors, e.util.toQuotedString(o));
                return !0 === e.opts.$comment ? i += " console.log(" + o + ");" : "function" == typeof e.opts.$comment && (i += " self._opts.$comment(" + o + ", " + e.util.toQuotedString(t) + ", validate.root.schema);"), i;
            };
        },
        2617: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, c = "data" + (r || ""), h = "valid" + o, d = e.opts.$data && s && s.$data, s = (d && (i += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; "), d || (i += " var schema" + o + " = validate.schema" + a + ";"), []), r = (s.push(i += "var " + h + " = equal(" + c + ", schema" + o + "); if (!" + h + ") {   "), i = "", !1 !== e.createErrors ? (i += " { keyword: 'const' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { allowedValue: schema" + o + " } ", !1 !== e.opts.messages && (i += " , message: 'should be equal to constant' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", i), i = s.pop();
                return !e.compositeRule && l ? e.async ? i += " throw new ValidationError([" + r + "]); " : i += " validate.errors = [" + r + "]; return false; " : i += " var err = " + r + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " }", l && (i += " else { "), i;
            };
        },
        2119: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, r = "data" + (r || ""), c = "valid" + o, h = "errs__" + o, d = e.util.copy(e), u = (d.level++, "valid" + d.level), o = "i" + o, g = d.dataLevel = e.dataLevel + 1, p = "data" + g, m = e.baseId, f = e.opts.strictKeywords ? "object" == typeof s && 0 < Object.keys(s).length || !1 === s : e.util.schemaHasRules(s, e.RULES.all), o = (i += "var " + h + " = errors;var " + c + ";", f ? (c = e.compositeRule, e.compositeRule = d.compositeRule = !0, d.schema = s, d.schemaPath = a, d.errSchemaPath = t, i += " var " + u + " = false; for (var " + o + " = 0; " + o + " < " + r + ".length; " + o + "++) { ", d.errorPath = e.util.getPathExpr(e.errorPath, o, e.opts.jsonPointers, !0), s = r + "[" + o + "]", d.dataPathArr[g] = o, g = e.validate(d), d.baseId = m, e.util.varOccurences(g, p) < 2 ? i += " " + e.util.varReplace(g, p, s) + " " : i += " var " + p + " = " + s + "; " + g + " ", i += " if (" + u + ") break; }  ", e.compositeRule = d.compositeRule = c, i += "  if (!" + u + ") {") : i += " if (" + r + ".length == 0) {", []), m = (o.push(i), i = "", !1 !== e.createErrors ? (i += " { keyword: 'contains' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: {} ", !1 !== e.opts.messages && (i += " , message: 'should contain a valid item' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + r + " "), i += " } ") : i += " {} ", i), i = o.pop();
                return !e.compositeRule && l ? e.async ? i += " throw new ValidationError([" + m + "]); " : i += " validate.errors = [" + m + "]; return false; " : i += " var err = " + m + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " } else { ", f && (i += "  errors = " + h + "; if (vErrors !== null) { if (" + h + ") vErrors.length = " + h + "; else vErrors = null; } "), e.opts.allErrors && (i += " } "), i;
            };
        },
        1793: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i, o, r, s = " ", a = e.level, l = e.dataLevel, c = e.schema[t], h = e.schemaPath + e.util.getProperty(t), d = e.errSchemaPath + "/" + t, u = !e.opts.allErrors, g = "data" + (l || ""), p = "valid" + a, m = "errs__" + a, f = e.opts.$data && c && c.$data, C = f ? (s += " var schema" + a + " = " + e.util.getData(c.$data, l, e.dataPathArr) + "; ", "schema" + a) : c, y = "definition" + a, v = this.definition, I = "";
                if (f && v.$data) {
                    var b = "keywordValidate" + a, A = v.validateSchema;
                    s += " var " + y + " = RULES.custom['" + t + "'].definition; var " + b + " = " + y + ".validate;";
                } else {
                    if (!(k = e.useCustomRule(this, c, e.schema, e))) return;
                    C = "validate.schema" + h, b = k.code, i = v.compile, o = v.inline, r = v.macro;
                }
                var w, S, x, k, E, t = b + ".errors", c = "i" + a, T = "ruleErr" + a, R = v.async;
                if (R && !e.async) throw new Error("async keyword in sync schema");
                return o || r || (s += t + " = null;"), s += "var " + m + " = errors;var " + p + ";", f && v.$data && (I += "}", s += " if (" + C + " === undefined) { " + p + " = true; } else { ", A) && (I += "}", s += " " + p + " = " + y + ".validateSchema(" + C + "); if (" + p + ") { "), o ? v.statements ? s += " " + k.validate + " " : s += " " + p + " = " + k.validate + "; " : r ? (I = "", (f = e.util.copy(e)).level++, w = "valid" + f.level, f.schema = k.validate, f.schemaPath = "", A = e.compositeRule, e.compositeRule = f.compositeRule = !0, y = e.validate(f).replace(/validate\.schema/g, b), e.compositeRule = f.compositeRule = A, s += " " + y) : ((E = E || []).push(s), s = "", s += "  " + b + ".call( ", e.opts.passContext ? s += "this" : s += "self", i || !1 === v.schema ? s += " , " + g + " " : s += " , " + C + " , " + g + " , validate.schema" + e.schemaPath + " ", s += " , (dataPath || '')", '""' != e.errorPath && (s += " + " + e.errorPath), k = s += " , " + (S = l ? "data" + (l - 1 || "") : "parentData") + " , " + (x = l ? e.dataPathArr[l] : "parentDataProperty") + " , rootData )  ", s = E.pop(), !1 === v.errors ? (s += " " + p + " = ", R && (s += "await "), s += k + "; ") : s += R ? " var " + (t = "customErrors" + a) + " = null; try { " + p + " = await " + k + "; } catch (e) { " + p + " = false; if (e instanceof ValidationError) " + t + " = e.errors; else throw e; } " : " " + t + " = null; " + p + " = " + k + "; "), v.modifying && (s += " if (" + S + ") " + g + " = " + S + "[" + x + "];"), s += "" + I, v.valid ? u && (s += " if (true) { ") : (s += " if ( ", void 0 === v.valid ? s = s + " !" + (r ? "" + w : p) : s += " " + !v.valid + " ", f = this.keyword, (E = E || []).push(s += ") { "), (E = E || []).push(s = ""), s = "", !1 !== e.createErrors ? (s += " { keyword: '" + (f || "custom") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(d) + " , params: { keyword: '" + this.keyword + "' } ", !1 !== e.opts.messages && (s += " , message: 'should pass \"" + this.keyword + "\" keyword validation' "), e.opts.verbose && (s += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + g + " "), s += " } ") : s += " {} ", A = s, s = E.pop(), !e.compositeRule && u ? e.async ? s += " throw new ValidationError([" + A + "]); " : s += " validate.errors = [" + A + "]; return false; " : s += " var err = " + A + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", y = s, s = E.pop(), o ? v.errors ? "full" != v.errors && (s += "  for (var " + c + "=" + m + "; " + c + "<errors; " + c + "++) { var " + T + " = vErrors[" + c + "]; if (" + T + ".dataPath === undefined) " + T + ".dataPath = (dataPath || '') + " + e.errorPath + "; if (" + T + ".schemaPath === undefined) { " + T + '.schemaPath = "' + d + '"; } ', e.opts.verbose && (s += " " + T + ".schema = " + C + "; " + T + ".data = " + g + "; "), s += " } ") : !1 === v.errors ? s += " " + y + " " : (s += " if (" + m + " == errors) { " + y + " } else {  for (var " + c + "=" + m + "; " + c + "<errors; " + c + "++) { var " + T + " = vErrors[" + c + "]; if (" + T + ".dataPath === undefined) " + T + ".dataPath = (dataPath || '') + " + e.errorPath + "; if (" + T + ".schemaPath === undefined) { " + T + '.schemaPath = "' + d + '"; } ', e.opts.verbose && (s += " " + T + ".schema = " + C + "; " + T + ".data = " + g + "; "), s += " } } ") : r ? (s += "   var err =   ", !1 !== e.createErrors ? (s += " { keyword: '" + (f || "custom") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(d) + " , params: { keyword: '" + this.keyword + "' } ", !1 !== e.opts.messages && (s += " , message: 'should pass \"" + this.keyword + "\" keyword validation' "), e.opts.verbose && (s += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + g + " "), s += " } ") : s += " {} ", s += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && u && (e.async ? s += " throw new ValidationError(vErrors); " : s += " validate.errors = vErrors; return false; ")) : !1 === v.errors ? s += " " + y + " " : (s += " if (Array.isArray(" + t + ")) { if (vErrors === null) vErrors = " + t + "; else vErrors = vErrors.concat(" + t + "); errors = vErrors.length;  for (var " + c + "=" + m + "; " + c + "<errors; " + c + "++) { var " + T + " = vErrors[" + c + "]; if (" + T + ".dataPath === undefined) " + T + ".dataPath = (dataPath || '') + " + e.errorPath + ";  " + T + '.schemaPath = "' + d + '";  ', e.opts.verbose && (s += " " + T + ".schema = " + C + "; " + T + ".data = " + g + "; "), s += " } } else { " + y + " } "), s += " } ", u && (s += " else { ")), s;
            };
        },
        9115: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i, o = " ", r = e.level, s = e.dataLevel, a = e.schema[t], l = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, h = !e.opts.allErrors, d = "data" + (s || ""), t = "errs__" + r, u = e.util.copy(e), g = "", p = (u.level++, "valid" + u.level), m = {}, f = {}, C = e.opts.ownProperties;
                for($ in a)"__proto__" != $ && (N = a[$], (i = Array.isArray(N) ? f : m)[$] = N);
                var y = e.errorPath;
                for($ in o = o + ("var " + t + " = errors;") + ("var missing" + r + ";"), f)if ((i = f[$]).length) {
                    if (o += " if ( " + d + e.util.getProperty($) + " !== undefined ", C && (o += " && Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes($) + "') "), h) {
                        o += " && ( ";
                        var v = i;
                        if (v) for(var I = -1, b = v.length - 1; I < b;)k = v[I += 1], I && (o += " || "), o += " ( ( " + (_ = d + (R = e.util.getProperty(k))) + " === undefined ", C && (o += " || ! Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes(k) + "') "), o += ") && (missing" + r + " = " + e.util.toQuotedString(e.opts.jsonPointers ? k : R) + ") ) ";
                        o += ")) {  ";
                        var A = "missing" + r, w = "' + " + A + " + '", S = (e.opts._errorDataPathProperty && (e.errorPath = e.opts.jsonPointers ? e.util.getPathExpr(y, A, !0) : y + " + " + A), S || []), A = (S.push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { property: '" + e.util.escapeQuotes($) + "', missingProperty: '" + w + "', depsCount: " + i.length + ", deps: '" + e.util.escapeQuotes(1 == i.length ? i[0] : i.join(", ")) + "' } ", !1 !== e.opts.messages && (o += " , message: 'should have ", 1 == i.length ? o += "property " + e.util.escapeQuotes(i[0]) : o += "properties " + e.util.escapeQuotes(i.join(", ")), o += " when property " + e.util.escapeQuotes($) + " is present' "), e.opts.verbose && (o += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), o += " } ") : o += " {} ", o), o = S.pop();
                        !e.compositeRule && h ? e.async ? o += " throw new ValidationError([" + A + "]); " : o += " validate.errors = [" + A + "]; return false; " : o += " var err = " + A + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                    } else {
                        o += " ) { ";
                        var x = i;
                        if (x) for(var k, E = -1, T = x.length - 1; E < T;){
                            k = x[E += 1];
                            var R = e.util.getProperty(k), w = e.util.escapeQuotes(k), _ = d + R;
                            e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(y, k, e.opts.jsonPointers)), o += " if ( " + _ + " === undefined ", C && (o += " || ! Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes(k) + "') "), o += ") {  var err =   ", !1 !== e.createErrors ? (o += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { property: '" + e.util.escapeQuotes($) + "', missingProperty: '" + w + "', depsCount: " + i.length + ", deps: '" + e.util.escapeQuotes(1 == i.length ? i[0] : i.join(", ")) + "' } ", !1 !== e.opts.messages && (o += " , message: 'should have ", 1 == i.length ? o += "property " + e.util.escapeQuotes(i[0]) : o += "properties " + e.util.escapeQuotes(i.join(", ")), o += " when property " + e.util.escapeQuotes($) + " is present' "), e.opts.verbose && (o += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), o += " } ") : o += " {} ", o += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
                        }
                    }
                    o += " }   ", h && (g += "}", o += " else { ");
                }
                e.errorPath = y;
                var $, L = u.baseId;
                for($ in m){
                    var N = m[$];
                    (e.opts.strictKeywords ? "object" == typeof N && 0 < Object.keys(N).length || !1 === N : e.util.schemaHasRules(N, e.RULES.all)) && (o += " " + p + " = true; if ( " + d + e.util.getProperty($) + " !== undefined ", C && (o += " && Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes($) + "') "), o += ") { ", u.schema = N, u.schemaPath = l + e.util.getProperty($), u.errSchemaPath = c + "/" + e.util.escapeFragment($), o += "  " + e.validate(u) + " ", u.baseId = L, o += " }  ", h) && (o += " if (" + p + ") { ", g += "}");
                }
                return h && (o += "   " + g + " if (" + t + " == errors) {"), o;
            };
        },
        9317: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, c = "data" + (r || ""), h = "valid" + o, d = e.opts.$data && s && s.$data, s = (d && (i += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; "), "i" + o), r = "schema" + o, r = (d || (i += " var " + r + " = validate.schema" + a + ";"), i += "var " + h + ";", d && (i += " if (schema" + o + " === undefined) " + h + " = true; else if (!Array.isArray(schema" + o + ")) " + h + " = false; else {"), i += h + " = false;for (var " + s + "=0; " + s + "<" + r + ".length; " + s + "++) if (equal(" + c + ", " + r + "[" + s + "])) { " + h + " = true; break; }", d && (i += "  }  "), []), s = (r.push(i += " if (!" + h + ") {   "), i = "", !1 !== e.createErrors ? (i += " { keyword: 'enum' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { allowedValues: schema" + o + " } ", !1 !== e.opts.messages && (i += " , message: 'should be equal to one of the allowed values' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", i), i = r.pop();
                return !e.compositeRule && l ? e.async ? i += " throw new ValidationError([" + s + "]); " : i += " validate.errors = [" + s + "]; return false; " : i += " var err = " + s + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " }", l && (i += " else { "), i;
            };
        },
        8327: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, c = "data" + (r || "");
                if (!1 === e.opts.format) l && (i += " if (true) { ");
                else {
                    var h, d = e.opts.$data && s && s.$data, r = d ? (i += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; ", "schema" + o) : s, u = e.opts.unknownFormats, g = Array.isArray(u);
                    if (d) i += " var " + (h = "format" + o) + " = formats[" + r + "]; var " + (p = "isObject" + o) + " = typeof " + h + " == 'object' && !(" + h + " instanceof RegExp) && " + h + ".validate; var " + (f = "formatType" + o) + " = " + p + " && " + h + ".type || 'string'; if (" + p + ") { ", e.async && (i += " var async" + o + " = " + h + ".async; "), i += " " + h + " = " + h + ".validate; } if (  ", d && (i += " (" + r + " !== undefined && typeof " + r + " != 'string') || "), i += " (", "ignore" != u && (i += " (" + r + " && !" + h + " ", g && (i += " && self._opts.unknownFormats.indexOf(" + r + ") == -1 "), i += ") || "), i += " (" + h + " && " + f + " == '" + n + "' && !(typeof " + h + " == 'function' ? ", e.async ? i += " (async" + o + " ? await " + h + "(" + c + ") : " + h + "(" + c + ")) " : i += " " + h + "(" + c + ") ", i += " : " + h + ".test(" + c + "))))) {";
                    else {
                        if (!(h = e.formats[s])) {
                            if ("ignore" == u) return e.logger.warn('unknown format "' + s + '" ignored in schema at path "' + e.errSchemaPath + '"'), l && (i += " if (true) { "), i;
                            if (g && 0 <= u.indexOf(s)) return l && (i += " if (true) { "), i;
                            throw new Error('unknown format "' + s + '" is used in schema at path "' + e.errSchemaPath + '"');
                        }
                        var p, m, f = (p = "object" == typeof h && !(h instanceof RegExp) && h.validate) && h.type || "string";
                        if (p && (m = !0 === h.async, h = h.validate), f != n) return l && (i += " if (true) { "), i;
                        if (m) {
                            if (!e.async) throw new Error("async format in sync schema");
                            i += " if (!(await " + (C = "formats" + e.util.getProperty(s) + ".validate") + "(" + c + "))) { ";
                        } else {
                            i += " if (! ";
                            var C = "formats" + e.util.getProperty(s);
                            p && (C += ".validate"), i = i + ("function" == typeof h ? " " + C + "(" + c + ") " : " " + C + ".test(" + c + ") ") + ") { ";
                        }
                    }
                    o = [], g = (o.push(i), i = "", !1 !== e.createErrors ? (i = (i += " { keyword: 'format' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { format:  ") + (d ? "" + r : "" + e.util.toQuotedString(s)) + "  } ", !1 !== e.opts.messages && (i = (i += " , message: 'should match format \"") + (d ? "' + " + r + " + '" : "" + e.util.escapeQuotes(s)) + "\"' "), e.opts.verbose && (i = (i = (i += " , schema:  ") + (d ? "validate.schema" + a : "" + e.util.toQuotedString(s))) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", i), i = o.pop();
                    !e.compositeRule && l ? e.async ? i += " throw new ValidationError([" + g + "]); " : i += " validate.errors = [" + g + "]; return false; " : i += " var err = " + g + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " } ", l && (i += " else { ");
                }
                return i;
            };
        },
        5926: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i, o = " ", r = e.level, s = e.dataLevel, a = e.schema[t], l = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, s = "data" + (s || ""), h = "valid" + r, d = "errs__" + r, u = e.util.copy(e), g = (u.level++, "valid" + u.level), p = e.schema.then, m = e.schema.else, p = void 0 !== p && (e.opts.strictKeywords ? "object" == typeof p && 0 < Object.keys(p).length || !1 === p : e.util.schemaHasRules(p, e.RULES.all)), m = void 0 !== m && (e.opts.strictKeywords ? "object" == typeof m && 0 < Object.keys(m).length || !1 === m : e.util.schemaHasRules(m, e.RULES.all)), f = u.baseId;
                return p || m ? (u.createErrors = !1, u.schema = a, u.schemaPath = l, u.errSchemaPath = t, o += " var " + d + " = errors; var " + h + " = true;  ", a = e.compositeRule, e.compositeRule = u.compositeRule = !0, o += "  " + e.validate(u) + " ", u.baseId = f, u.createErrors = !0, o += "  errors = " + d + "; if (vErrors !== null) { if (" + d + ") vErrors.length = " + d + "; else vErrors = null; }  ", e.compositeRule = u.compositeRule = a, p ? (o += " if (" + g + ") {  ", u.schema = e.schema.then, u.schemaPath = e.schemaPath + ".then", u.errSchemaPath = e.errSchemaPath + "/then", o += "  " + e.validate(u) + " ", u.baseId = f, o += " " + h + " = " + g + "; ", p && m ? o += " var " + (i = "ifClause" + r) + " = 'then'; " : i = "'then'", o += " } ", m && (o += " else { ")) : o += " if (!" + g + ") { ", m && (u.schema = e.schema.else, u.schemaPath = e.schemaPath + ".else", u.errSchemaPath = e.errSchemaPath + "/else", o += "  " + e.validate(u) + " ", u.baseId = f, o += " " + h + " = " + g + "; ", p && m ? o += " var " + (i = "ifClause" + r) + " = 'else'; " : i = "'else'", o += " } "), o += " if (!" + h + ") {   var err =   ", !1 !== e.createErrors ? (o += " { keyword: 'if' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { failingKeyword: " + i + " } ", !1 !== e.opts.messages && (o += " , message: 'should match \"' + " + i + " + '\" schema' "), e.opts.verbose && (o += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + s + " "), o += " } ") : o += " {} ", o += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && c && (e.async ? o += " throw new ValidationError(vErrors); " : o += " validate.errors = vErrors; return false; "), o += " }   ", c && (o += " else { ")) : c && (o += " if (true) { "), o;
            };
        },
        9646: function(e, t, n) {
            "use strict";
            e.exports = {
                $ref: n(2331),
                allOf: n(9486),
                anyOf: n(5347),
                $comment: n(923),
                const: n(2617),
                contains: n(2119),
                dependencies: n(9115),
                enum: n(9317),
                format: n(8327),
                if: n(5926),
                items: n(392),
                maximum: n(1796),
                minimum: n(1796),
                maxItems: n(2407),
                minItems: n(2407),
                maxLength: n(1250),
                minLength: n(1250),
                maxProperties: n(2596),
                minProperties: n(2596),
                multipleOf: n(6039),
                not: n(7946),
                oneOf: n(9344),
                pattern: n(9737),
                properties: n(2537),
                propertyNames: n(2127),
                required: n(1204),
                uniqueItems: n(1985),
                validate: n(1869)
            };
        },
        392: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), l = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, h = "data" + (r || ""), t = "valid" + o, r = "errs__" + o, d = e.util.copy(e), u = "", g = (d.level++, "valid" + d.level), o = "i" + o, p = d.dataLevel = e.dataLevel + 1, m = "data" + p, f = e.baseId;
                if (i += "var " + r + " = errors;var " + t + ";", Array.isArray(s)) {
                    var C, y, v = e.schema.additionalItems, I = (!1 === v && (i += " " + t + " = " + h + ".length <= " + s.length + "; ", C = l, l = e.errSchemaPath + "/additionalItems", (y = y || []).push(i += "  if (!" + t + ") {   "), i = "", !1 !== e.createErrors ? (i += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { limit: " + s.length + " } ", !1 !== e.opts.messages && (i += " , message: 'should NOT have more than " + s.length + " items' "), e.opts.verbose && (i += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), i += " } ") : i += " {} ", t = i, i = y.pop(), !e.compositeRule && c ? e.async ? i += " throw new ValidationError([" + t + "]); " : i += " validate.errors = [" + t + "]; return false; " : i += " var err = " + t + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " } ", l = C, c) && (u += "}", i += " else { "), s);
                    if (I) for(var b = -1, A = I.length - 1; b < A;){
                        var w, S, x = I[b += 1];
                        (e.opts.strictKeywords ? "object" == typeof x && 0 < Object.keys(x).length || !1 === x : e.util.schemaHasRules(x, e.RULES.all)) && (i += " " + g + " = true; if (" + h + ".length > " + b + ") { ", w = h + "[" + b + "]", d.schema = x, d.schemaPath = a + "[" + b + "]", d.errSchemaPath = l + "/" + b, d.errorPath = e.util.getPathExpr(e.errorPath, b, e.opts.jsonPointers, !0), d.dataPathArr[p] = b, S = e.validate(d), d.baseId = f, e.util.varOccurences(S, m) < 2 ? i += " " + e.util.varReplace(S, m, w) + " " : i += " var " + m + " = " + w + "; " + S + " ", i += " }  ", c) && (i += " if (" + g + ") { ", u += "}");
                    }
                    "object" == typeof v && (e.opts.strictKeywords ? "object" == typeof v && 0 < Object.keys(v).length || !1 === v : e.util.schemaHasRules(v, e.RULES.all)) && (d.schema = v, d.schemaPath = e.schemaPath + ".additionalItems", d.errSchemaPath = e.errSchemaPath + "/additionalItems", i += " " + g + " = true; if (" + h + ".length > " + s.length + ") {  for (var " + o + " = " + s.length + "; " + o + " < " + h + ".length; " + o + "++) { ", d.errorPath = e.util.getPathExpr(e.errorPath, o, e.opts.jsonPointers, !0), w = h + "[" + o + "]", d.dataPathArr[p] = o, S = e.validate(d), d.baseId = f, e.util.varOccurences(S, m) < 2 ? i += " " + e.util.varReplace(S, m, w) + " " : i += " var " + m + " = " + w + "; " + S + " ", c && (i += " if (!" + g + ") break; "), i += " } }  ", c) && (i += " if (" + g + ") { ", u += "}");
                } else (e.opts.strictKeywords ? "object" == typeof s && 0 < Object.keys(s).length || !1 === s : e.util.schemaHasRules(s, e.RULES.all)) && (d.schema = s, d.schemaPath = a, d.errSchemaPath = l, i += "  for (var " + o + " = 0; " + o + " < " + h + ".length; " + o + "++) { ", d.errorPath = e.util.getPathExpr(e.errorPath, o, e.opts.jsonPointers, !0), w = h + "[" + o + "]", d.dataPathArr[p] = o, S = e.validate(d), d.baseId = f, e.util.varOccurences(S, m) < 2 ? i += " " + e.util.varReplace(S, m, w) + " " : i += " var " + m + " = " + w + "; " + S + " ", c && (i += " if (!" + g + ") break; "), i += " }");
                return c && (i += " " + u + " if (" + r + " == errors) {"), i;
            };
        },
        6039: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), l = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, h = "data" + (r || ""), d = e.opts.$data && s && s.$data, r = d ? (i += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; ", "schema" + o) : s;
                if (!d && "number" != typeof s) throw new Error(t + " must be number");
                i += "var division" + o + ";if (", d && (i += " " + r + " !== undefined && ( typeof " + r + " != 'number' || "), i += " (division" + o + " = " + h + " / " + r + ", ", e.opts.multipleOfPrecision ? i += " Math.abs(Math.round(division" + o + ") - division" + o + ") > 1e-" + e.opts.multipleOfPrecision + " " : i += " division" + o + " !== parseInt(division" + o + ") ", i += " ) ", d && (i += "  )  ");
                t = [], t.push(i += " ) {   "), i = "", !1 !== e.createErrors ? (i += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { multipleOf: " + r + " } ", !1 !== e.opts.messages && (i = i + " , message: 'should be multiple of " + (d ? "' + " + r : r + "'")), e.opts.verbose && (i = (i += " , schema:  ") + (d ? "validate.schema" + a : "" + s) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), i += " } ") : i += " {} ", o = i, i = t.pop();
                return !e.compositeRule && c ? e.async ? i += " throw new ValidationError([" + o + "]); " : i += " validate.errors = [" + o + "]; return false; " : i += " var err = " + o + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += "} ", c && (i += " else { "), i;
            };
        },
        7946: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i, o, r = " ", s = e.level, a = e.dataLevel, l = e.schema[t], c = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, h = !e.opts.allErrors, a = "data" + (a || ""), s = "errs__" + s, d = e.util.copy(e), u = (d.level++, "valid" + d.level);
                return (e.opts.strictKeywords ? "object" == typeof l && 0 < Object.keys(l).length || !1 === l : e.util.schemaHasRules(l, e.RULES.all)) ? (d.schema = l, d.schemaPath = c, d.errSchemaPath = t, r += " var " + s + " = errors;  ", l = e.compositeRule, e.compositeRule = d.compositeRule = !0, d.createErrors = !1, d.opts.allErrors && (o = d.opts.allErrors, d.opts.allErrors = !1), r += " " + e.validate(d) + " ", d.createErrors = !0, o && (d.opts.allErrors = o), e.compositeRule = d.compositeRule = l, (i = i || []).push(r += " if (" + u + ") {   "), r = "", !1 !== e.createErrors ? (r += " { keyword: 'not' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: {} ", !1 !== e.opts.messages && (r += " , message: 'should NOT be valid' "), e.opts.verbose && (r += " , schema: validate.schema" + c + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + a + " "), r += " } ") : r += " {} ", o = r, r = i.pop(), !e.compositeRule && h ? e.async ? r += " throw new ValidationError([" + o + "]); " : r += " validate.errors = [" + o + "]; return false; " : r += " var err = " + o + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else {  errors = " + s + "; if (vErrors !== null) { if (" + s + ") vErrors.length = " + s + "; else vErrors = null; } ", e.opts.allErrors && (r += " } ")) : (r += "  var err =   ", !1 !== e.createErrors ? (r += " { keyword: 'not' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: {} ", !1 !== e.opts.messages && (r += " , message: 'should NOT be valid' "), e.opts.verbose && (r += " , schema: validate.schema" + c + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + a + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", h && (r += " if (false) { ")), r;
            };
        },
        9344: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), l = e.errSchemaPath + "/" + t, t = !e.opts.allErrors, r = "data" + (r || ""), c = "valid" + o, h = "errs__" + o, d = e.util.copy(e), u = "", g = (d.level++, "valid" + d.level), p = d.baseId, m = "prevValid" + o, f = "passingSchemas" + o, o = (i += "var " + h + " = errors , " + m + " = false , " + c + " = false , " + f + " = null; ", e.compositeRule), C = (e.compositeRule = d.compositeRule = !0, s);
                if (C) for(var y, v = -1, I = C.length - 1; v < I;)y = C[v += 1], (e.opts.strictKeywords ? "object" == typeof y && 0 < Object.keys(y).length || !1 === y : e.util.schemaHasRules(y, e.RULES.all)) ? (d.schema = y, d.schemaPath = a + "[" + v + "]", d.errSchemaPath = l + "/" + v, i += "  " + e.validate(d) + " ", d.baseId = p) : i += " var " + g + " = true; ", v && (i += " if (" + g + " && " + m + ") { " + c + " = false; " + f + " = [" + f + ", " + v + "]; } else { ", u += "}"), i += " if (" + g + ") { " + c + " = " + m + " = true; " + f + " = " + v + "; }";
                return e.compositeRule = d.compositeRule = o, i += u + "if (!" + c + ") {   var err =   ", !1 !== e.createErrors ? (i += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { passingSchemas: " + f + " } ", !1 !== e.opts.messages && (i += " , message: 'should match exactly one schema in oneOf' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + r + " "), i += " } ") : i += " {} ", i += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && t && (e.async ? i += " throw new ValidationError(vErrors); " : i += " validate.errors = vErrors; return false; "), i += "} else {  errors = " + h + "; if (vErrors !== null) { if (" + h + ") vErrors.length = " + h + "; else vErrors = null; }", e.opts.allErrors && (i += " } "), i;
            };
        },
        9737: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, c = "data" + (r || ""), h = e.opts.$data && s && s.$data, r = h ? (i += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; ", "schema" + o) : s, o = h ? "(new RegExp(" + r + "))" : e.usePattern(s), d = (i += "if ( ", h && (i += " (" + r + " !== undefined && typeof " + r + " != 'string') || "), []), o = (d.push(i += " !" + o + ".test(" + c + ") ) {   "), i = "", !1 !== e.createErrors ? (i = (i += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { pattern:  ") + (h ? "" + r : "" + e.util.toQuotedString(s)) + "  } ", !1 !== e.opts.messages && (i = (i += " , message: 'should match pattern \"") + (h ? "' + " + r + " + '" : "" + e.util.escapeQuotes(s)) + "\"' "), e.opts.verbose && (i = (i = (i += " , schema:  ") + (h ? "validate.schema" + a : "" + e.util.toQuotedString(s))) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", i), i = d.pop();
                return !e.compositeRule && l ? e.async ? i += " throw new ValidationError([" + o + "]); " : i += " validate.errors = [" + o + "]; return false; " : i += " var err = " + o + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += "} ", l && (i += " else { "), i;
            };
        },
        2537: function(e) {
            "use strict";
            e.exports = function(e, t, W) {
                var n, i = " ", o = e.level, r = e.dataLevel, H = e.schema[t], s = e.schemaPath + e.util.getProperty(t), a = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, c = "data" + (r || ""), t = "errs__" + o, h = e.util.copy(e), d = "", u = (h.level++, "valid" + h.level), g = "key" + o, p = "idx" + o, m = h.dataLevel = e.dataLevel + 1, f = "data" + m, C = "dataProperties" + o, r = Object.keys(H || {}).filter(Z), G = e.schema.patternProperties || {}, y = Object.keys(G).filter(Z), v = e.schema.additionalProperties, P = r.length || y.length, F = !1 === v, V = "object" == typeof v && Object.keys(v).length, I = e.opts.removeAdditional, b = F || V || I, A = e.opts.ownProperties, w = e.baseId, S = e.schema.required;
                function Z(e) {
                    return "__proto__" !== e;
                }
                if (S && (!e.opts.$data || !S.$data) && S.length < e.opts.loopRequired && (n = e.util.toHash(S)), i += "var " + t + " = errors;var " + u + " = true;", A && (i += " var " + C + " = undefined;"), b) {
                    if (i += A ? " " + C + " = " + C + " || Object.keys(" + c + "); for (var " + p + "=0; " + p + "<" + C + ".length; " + p + "++) { var " + g + " = " + C + "[" + p + "]; " : " for (var " + g + " in " + c + ") { ", P) {
                        if (i += " var isAdditional" + o + " = !(false ", r.length) {
                            if (8 < r.length) i += " || validate.schema" + s + ".hasOwnProperty(" + g + ") ";
                            else {
                                var O = r;
                                if (O) for(var D = -1, K = O.length - 1; D < K;)x = O[D += 1], i += " || " + g + " == " + e.util.toQuotedString(x) + " ";
                            }
                        }
                        if (y.length) {
                            var j = y;
                            if (j) for(var z = -1, X = j.length - 1; z < X;)N = j[z += 1], i += " || " + e.usePattern(N) + ".test(" + g + ") ";
                        }
                        i += " ); if (isAdditional" + o + ") { ";
                    }
                    "all" == I ? i += " delete " + c + "[" + g + "]; " : (E = e.errorPath, S = "' + " + g + " + '", e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers)), F ? I ? i += " delete " + c + "[" + g + "]; " : (T = a, a = e.errSchemaPath + "/additionalProperties", (_ = _ || []).push(i += " " + u + " = false; "), i = "", !1 !== e.createErrors ? (i += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(a) + " , params: { additionalProperty: '" + S + "' } ", !1 !== e.opts.messages && (i += " , message: '", e.opts._errorDataPathProperty ? i += "is an invalid additional property" : i += "should NOT have additional properties", i += "' "), e.opts.verbose && (i += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", $ = i, i = _.pop(), !e.compositeRule && l ? e.async ? i += " throw new ValidationError([" + $ + "]); " : i += " validate.errors = [" + $ + "]; return false; " : i += " var err = " + $ + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", a = T, l && (i += " break; ")) : V && ("failing" == I ? (i += " var " + t + " = errors;  ", b = e.compositeRule, e.compositeRule = h.compositeRule = !0, h.schema = v, h.schemaPath = e.schemaPath + ".additionalProperties", h.errSchemaPath = e.errSchemaPath + "/additionalProperties", h.errorPath = e.opts._errorDataPathProperty ? e.errorPath : e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers), B = c + "[" + g + "]", h.dataPathArr[m] = g, M = e.validate(h), h.baseId = w, e.util.varOccurences(M, f) < 2 ? i += " " + e.util.varReplace(M, f, B) + " " : i += " var " + f + " = " + B + "; " + M + " ", i += " if (!" + u + ") { errors = " + t + "; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete " + c + "[" + g + "]; }  ", e.compositeRule = h.compositeRule = b) : (h.schema = v, h.schemaPath = e.schemaPath + ".additionalProperties", h.errSchemaPath = e.errSchemaPath + "/additionalProperties", h.errorPath = e.opts._errorDataPathProperty ? e.errorPath : e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers), B = c + "[" + g + "]", h.dataPathArr[m] = g, M = e.validate(h), h.baseId = w, e.util.varOccurences(M, f) < 2 ? i += " " + e.util.varReplace(M, f, B) + " " : i += " var " + f + " = " + B + "; " + M + " ", l && (i += " if (!" + u + ") break; "))), e.errorPath = E), P && (i += " } "), i += " }  ", l && (i += " if (" + u + ") { ", d += "}");
                }
                var Y = e.opts.useDefaults && !e.compositeRule;
                if (r.length) {
                    var J = r;
                    if (J) for(var x, U = -1, Q = J.length - 1; U < Q;){
                        var q, k, E, T, R, _, $, L = H[x = J[U += 1]];
                        (e.opts.strictKeywords ? "object" == typeof L && 0 < Object.keys(L).length || !1 === L : e.util.schemaHasRules(L, e.RULES.all)) && (B = c + (R = e.util.getProperty(x)), q = Y && void 0 !== L.default, h.schema = L, h.schemaPath = s + R, h.errSchemaPath = a + "/" + e.util.escapeFragment(x), h.errorPath = e.util.getPath(e.errorPath, x, e.opts.jsonPointers), h.dataPathArr[m] = e.util.toQuotedString(x), M = e.validate(h), h.baseId = w, e.util.varOccurences(M, f) < 2 ? (M = e.util.varReplace(M, f, B), k = B) : i += " var " + (k = f) + " = " + B + "; ", q ? i += " " + M + " " : (n && n[x] ? (i += " if ( " + k + " === undefined ", A && (i += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(x) + "') "), i += ") { " + u + " = false; ", E = e.errorPath, T = a, R = e.util.escapeQuotes(x), e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(E, x, e.opts.jsonPointers)), a = e.errSchemaPath + "/required", (_ = _ || []).push(i), i = "", !1 !== e.createErrors ? (i += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(a) + " , params: { missingProperty: '" + R + "' } ", !1 !== e.opts.messages && (i += " , message: '", e.opts._errorDataPathProperty ? i += "is a required property" : i += "should have required property \\'" + R + "\\'", i += "' "), e.opts.verbose && (i += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", $ = i, i = _.pop(), !e.compositeRule && l ? e.async ? i += " throw new ValidationError([" + $ + "]); " : i += " validate.errors = [" + $ + "]; return false; " : i += " var err = " + $ + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", a = T, e.errorPath = E, i += " } else { ") : l ? (i += " if ( " + k + " === undefined ", A && (i += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(x) + "') "), i += ") { " + u + " = true; } else { ") : (i += " if (" + k + " !== undefined ", A && (i += " &&   Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(x) + "') "), i += " ) { "), i += " " + M + " } ")), l && (i += " if (" + u + ") { ", d += "}");
                    }
                }
                if (y.length) {
                    var ee = y;
                    if (ee) for(var N, te = -1, ne = ee.length - 1; te < ne;){
                        var B, M, L = G[N = ee[te += 1]];
                        (e.opts.strictKeywords ? "object" == typeof L && 0 < Object.keys(L).length || !1 === L : e.util.schemaHasRules(L, e.RULES.all)) && (h.schema = L, h.schemaPath = e.schemaPath + ".patternProperties" + e.util.getProperty(N), h.errSchemaPath = e.errSchemaPath + "/patternProperties/" + e.util.escapeFragment(N), i = (i += A ? " " + C + " = " + C + " || Object.keys(" + c + "); for (var " + p + "=0; " + p + "<" + C + ".length; " + p + "++) { var " + g + " = " + C + "[" + p + "]; " : " for (var " + g + " in " + c + ") { ") + " if (" + e.usePattern(N) + ".test(" + g + ")) { ", h.errorPath = e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers), B = c + "[" + g + "]", h.dataPathArr[m] = g, M = e.validate(h), h.baseId = w, e.util.varOccurences(M, f) < 2 ? i += " " + e.util.varReplace(M, f, B) + " " : i += " var " + f + " = " + B + "; " + M + " ", l && (i += " if (!" + u + ") break; "), i += " } ", l && (i += " else " + u + " = true; "), i += " }  ", l) && (i += " if (" + u + ") { ", d += "}");
                    }
                }
                return l && (i += " " + d + " if (" + t + " == errors) {"), i;
            };
        },
        2127: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i, o, r, s, a, l, c, h = " ", d = e.level, u = e.dataLevel, g = e.schema[t], p = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, m = !e.opts.allErrors, u = "data" + (u || ""), f = "errs__" + d, C = e.util.copy(e), y = (C.level++, "valid" + C.level);
                return h += "var " + f + " = errors;", (e.opts.strictKeywords ? "object" == typeof g && 0 < Object.keys(g).length || !1 === g : e.util.schemaHasRules(g, e.RULES.all)) && (C.schema = g, C.schemaPath = p, C.errSchemaPath = t, g = "idx" + d, o = "i" + d, r = "' + " + (i = "key" + d) + " + '", s = "data" + (C.dataLevel = e.dataLevel + 1), c = "dataProperties" + d, l = e.opts.ownProperties, a = e.baseId, l && (h += " var " + c + " = undefined; "), h = h + (l ? " " + c + " = " + c + " || Object.keys(" + u + "); for (var " + g + "=0; " + g + "<" + c + ".length; " + g + "++) { var " + i + " = " + c + "[" + g + "]; " : " for (var " + i + " in " + u + ") { ") + " var startErrs" + d + " = errors; ", l = i, c = e.compositeRule, e.compositeRule = C.compositeRule = !0, g = e.validate(C), C.baseId = a, e.util.varOccurences(g, s) < 2 ? h += " " + e.util.varReplace(g, s, l) + " " : h += " var " + s + " = " + l + "; " + g + " ", e.compositeRule = C.compositeRule = c, h += " if (!" + y + ") { for (var " + o + "=startErrs" + d + "; " + o + "<errors; " + o + "++) { vErrors[" + o + "].propertyName = " + i + "; }   var err =   ", !1 !== e.createErrors ? (h += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { propertyName: '" + r + "' } ", !1 !== e.opts.messages && (h += " , message: 'property name \\'" + r + "\\' is invalid' "), e.opts.verbose && (h += " , schema: validate.schema" + p + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), h += " } ") : h += " {} ", h += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && m && (e.async ? h += " throw new ValidationError(vErrors); " : h += " validate.errors = vErrors; return false; "), m && (h += " break; "), h += " } }"), m && (h += "  if (" + f + " == errors) {"), h;
            };
        },
        2331: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i, o, r = " ", s = e.level, a = e.dataLevel, l = e.schema[t], t = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, h = "data" + (a || ""), s = "valid" + s;
                if ("#" == l || "#/" == l) o = e.isRoot ? (i = e.async, "validate") : (i = !0 === e.root.schema.$async, "root.refVal[0]");
                else {
                    var d = e.resolveRef(e.baseId, l, e.isRoot);
                    if (void 0 === d) {
                        var u = e.MissingRefError.message(e.baseId, l);
                        if ("fail" == e.opts.missingRefs) {
                            e.logger.error(u);
                            (g = g || []).push(r), r = "", !1 !== e.createErrors ? (r += " { keyword: '$ref' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { ref: '" + e.util.escapeQuotes(l) + "' } ", !1 !== e.opts.messages && (r += " , message: 'can\\'t resolve reference " + e.util.escapeQuotes(l) + "' "), e.opts.verbose && (r += " , schema: " + e.util.toQuotedString(l) + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), r += " } ") : r += " {} ";
                            t = r, r = g.pop();
                            !e.compositeRule && c ? e.async ? r += " throw new ValidationError([" + t + "]); " : r += " validate.errors = [" + t + "]; return false; " : r += " var err = " + t + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", c && (r += " if (false) { ");
                        } else {
                            if ("ignore" != e.opts.missingRefs) throw new e.MissingRefError(e.baseId, l, u);
                            e.logger.warn(u), c && (r += " if (true) { ");
                        }
                    } else d.inline ? ((t = e.util.copy(e)).level++, u = "valid" + t.level, t.schema = d.schema, t.schemaPath = "", t.errSchemaPath = l, r += " " + e.validate(t).replace(/validate\.schema/g, d.code) + " ", c && (r += " if (" + u + ") { ")) : (i = !0 === d.$async || e.async && !1 !== d.$async, o = d.code);
                }
                if (o) {
                    (g = g || []).push(r), r = "", e.opts.passContext ? r += " " + o + ".call(this, " : r += " " + o + "( ", r += " " + h + ", (dataPath || '')", '""' != e.errorPath && (r += " + " + e.errorPath);
                    var g, l = a ? "data" + (a - 1 || "") : "parentData", t = r += " , " + l + " , " + (a ? e.dataPathArr[a] : "parentDataProperty") + ", rootData)  ";
                    if (r = g.pop(), i) {
                        if (!e.async) throw new Error("async schema referenced by sync schema");
                        c && (r += " var " + s + "; "), r += " try { await " + t + "; ", c && (r += " " + s + " = true; "), r += " } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ", c && (r += " " + s + " = false; "), r += " } ", c && (r += " if (" + s + ") { ");
                    } else r += " if (!" + t + ") { if (vErrors === null) vErrors = " + o + ".errors; else vErrors = vErrors.concat(" + o + ".errors); errors = vErrors.length; } ", c && (r += " else { ");
                }
                return r;
            };
        },
        1204: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i = " ", o = e.level, r = e.dataLevel, s = e.schema[t], a = e.schemaPath + e.util.getProperty(t), l = e.errSchemaPath + "/" + t, t = !e.opts.allErrors, c = "data" + (r || ""), h = "valid" + o, d = e.opts.$data && s && s.$data, r = (d && (i += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; "), "schema" + o);
                if (!d) {
                    if (s.length < e.opts.loopRequired && e.schema.properties && Object.keys(e.schema.properties).length) {
                        var u = [], g = s;
                        if (g) for(var p = -1, m = g.length - 1; p < m;){
                            var f = g[p += 1], C = e.schema.properties[f];
                            C && (e.opts.strictKeywords ? "object" == typeof C && 0 < Object.keys(C).length || !1 === C : e.util.schemaHasRules(C, e.RULES.all)) || (u[u.length] = f);
                        }
                    } else u = s;
                }
                if (d || u.length) {
                    var y = e.errorPath, s = d || u.length >= e.opts.loopRequired, v = e.opts.ownProperties;
                    if (t) {
                        if (i += " var missing" + o + "; ", s) {
                            d || (i += " var " + r + " = validate.schema" + a + "; ");
                            var I = "' + " + (k = "schema" + o + "[" + (w = "i" + o) + "]") + " + '";
                            e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(y, k, e.opts.jsonPointers)), i += " var " + h + " = true; ", d && (i += " if (schema" + o + " === undefined) " + h + " = true; else if (!Array.isArray(schema" + o + ")) " + h + " = false; else {"), i += " for (var " + w + " = 0; " + w + " < " + r + ".length; " + w + "++) { " + h + " = " + c + "[" + r + "[" + w + "]] !== undefined ", v && (i += " &&   Object.prototype.hasOwnProperty.call(" + c + ", " + r + "[" + w + "]) "), i += "; if (!" + h + ") break; } ", d && (i += "  }  ");
                            (x = x || []).push(i += "  if (!" + h + ") {   "), i = "", !1 !== e.createErrors ? (i += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + I + "' } ", !1 !== e.opts.messages && (i += " , message: '", e.opts._errorDataPathProperty ? i += "is a required property" : i += "should have required property \\'" + I + "\\'", i += "' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ";
                            var b = i, i = x.pop();
                        } else {
                            i += " if ( ";
                            var A = u;
                            if (A) for(var w = -1, S = A.length - 1; w < S;)T = A[w += 1], w && (i += " || "), i += " ( ( " + (L = c + ($ = e.util.getProperty(T))) + " === undefined ", v && (i += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(T) + "') "), i += ") && (missing" + o + " = " + e.util.toQuotedString(e.opts.jsonPointers ? T : $) + ") ) ";
                            i += ") {  ";
                            I = "' + " + (k = "missing" + o) + " + '";
                            e.opts._errorDataPathProperty && (e.errorPath = e.opts.jsonPointers ? e.util.getPathExpr(y, k, !0) : y + " + " + k);
                            (x = x || []).push(i), i = "", !1 !== e.createErrors ? (i += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + I + "' } ", !1 !== e.opts.messages && (i += " , message: '", e.opts._errorDataPathProperty ? i += "is a required property" : i += "should have required property \\'" + I + "\\'", i += "' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ";
                            var x, b = i;
                            i = x.pop();
                        }
                        !e.compositeRule && t ? e.async ? i += " throw new ValidationError([" + b + "]); " : i += " validate.errors = [" + b + "]; return false; " : i += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " } else { ";
                    } else if (s) {
                        d || (i += " var " + r + " = validate.schema" + a + "; ");
                        var k, I = "' + " + (k = "schema" + o + "[" + (w = "i" + o) + "]") + " + '";
                        e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(y, k, e.opts.jsonPointers)), d && (i += " if (" + r + " && !Array.isArray(" + r + ")) {  var err =   ", !1 !== e.createErrors ? (i += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + I + "' } ", !1 !== e.opts.messages && (i += " , message: '", e.opts._errorDataPathProperty ? i += "is a required property" : i += "should have required property \\'" + I + "\\'", i += "' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", i += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (" + r + " !== undefined) { "), i += " for (var " + w + " = 0; " + w + " < " + r + ".length; " + w + "++) { if (" + c + "[" + r + "[" + w + "]] === undefined ", v && (i += " || ! Object.prototype.hasOwnProperty.call(" + c + ", " + r + "[" + w + "]) "), i += ") {  var err =   ", !1 !== e.createErrors ? (i += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + I + "' } ", !1 !== e.opts.messages && (i += " , message: '", e.opts._errorDataPathProperty ? i += "is a required property" : i += "should have required property \\'" + I + "\\'", i += "' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", i += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ", d && (i += "  }  ");
                    } else {
                        var E = u;
                        if (E) for(var T, R = -1, _ = E.length - 1; R < _;){
                            T = E[R += 1];
                            var $ = e.util.getProperty(T), I = e.util.escapeQuotes(T), L = c + $;
                            e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(y, T, e.opts.jsonPointers)), i += " if ( " + L + " === undefined ", v && (i += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(T) + "') "), i += ") {  var err =   ", !1 !== e.createErrors ? (i += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + I + "' } ", !1 !== e.opts.messages && (i += " , message: '", e.opts._errorDataPathProperty ? i += "is a required property" : i += "should have required property \\'" + I + "\\'", i += "' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", i += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
                        }
                    }
                    e.errorPath = y;
                } else t && (i += " if (true) {");
                return i;
            };
        },
        1985: function(e) {
            "use strict";
            e.exports = function(e, t, n) {
                var i, o = " ", r = e.level, s = e.dataLevel, a = e.schema[t], l = e.schemaPath + e.util.getProperty(t), t = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, h = "data" + (s || ""), d = "valid" + r, u = e.opts.$data && a && a.$data, s = u ? (o += " var schema" + r + " = " + e.util.getData(a.$data, s, e.dataPathArr) + "; ", "schema" + r) : a;
                return (a || u) && !1 !== e.opts.uniqueItems ? (u && (o += " var " + d + "; if (" + s + " === false || " + s + " === undefined) " + d + " = true; else if (typeof " + s + " != 'boolean') " + d + " = false; else { "), o += " var i = " + h + ".length , " + d + " = true , j; if (i > 1) { ", r = e.schema.items && e.schema.items.type, s = Array.isArray(r), !r || "object" == r || "array" == r || s && (0 <= r.indexOf("object") || 0 <= r.indexOf("array")) ? o += " outer: for (;i--;) { for (j = i; j--;) { if (equal(" + h + "[i], " + h + "[j])) { " + d + " = false; break outer; } } } " : (o = (o += " var itemIndices = {}, item; for (;i--;) { var item = " + h + "[i]; ") + " if (" + e.util["checkDataType" + (s ? "s" : "")](r, "item", e.opts.strictNumbers, !0) + ") continue; ", s && (o += " if (typeof item == 'string') item = '\"' + item; "), o += " if (typeof itemIndices[item] == 'number') { " + d + " = false; j = itemIndices[item]; break; } itemIndices[item] = i; } "), o += " } ", u && (o += "  }  "), (i = i || []).push(o += " if (!" + d + ") {   "), o = "", !1 !== e.createErrors ? (o += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { i: i, j: j } ", !1 !== e.opts.messages && (o += " , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' "), e.opts.verbose && (o = (o += " , schema:  ") + (u ? "validate.schema" + l : "" + a) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), o += " } ") : o += " {} ", r = o, o = i.pop(), !e.compositeRule && c ? e.async ? o += " throw new ValidationError([" + r + "]); " : o += " validate.errors = [" + r + "]; return false; " : o += " var err = " + r + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += " } ", c && (o += " else { ")) : c && (o += " if (true) { "), o;
            };
        },
        1869: function(e) {
            "use strict";
            e.exports = function(i, e, W) {
                var t = "", n = !0 === i.schema.$async, o = i.util.schemaHasRulesExcept(i.schema, i.RULES.all, "$ref"), r = i.self._getId(i.schema);
                if (i.opts.strictKeywords) {
                    var s = i.util.schemaUnknownRules(i.schema, i.RULES.keywords);
                    if (s) {
                        s = "unknown keyword: " + s;
                        if ("log" !== i.opts.strictKeywords) throw new Error(s);
                        i.logger.warn(s);
                    }
                }
                if (i.isTop && (t += " var validate = ", n && (i.async = !0, t += "async "), t += "function(data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ", r) && (i.opts.sourceCode || i.opts.processCode) && (t += " /*# sourceURL=" + r + " */ "), "boolean" == typeof i.schema || !o && !i.schema.$ref) l = i.level, c = i.dataLevel, R = i.schema[e = "false schema"], I = i.schemaPath + i.util.getProperty(e), b = i.errSchemaPath + "/" + e, g = !i.opts.allErrors, h = "data" + (c || ""), u = "valid" + l, !1 === i.schema ? (i.isTop ? g = !0 : t += " var " + u + " = false; ", (B = B || []).push(t), t = "", !1 !== i.createErrors ? (t += " { keyword: 'false schema' , dataPath: (dataPath || '') + " + i.errorPath + " , schemaPath: " + i.util.toQuotedString(b) + " , params: {} ", !1 !== i.opts.messages && (t += " , message: 'boolean schema is false' "), i.opts.verbose && (t += " , schema: false , parentSchema: validate.schema" + i.schemaPath + " , data: " + h + " "), t += " } ") : t += " {} ", E = t, t = B.pop(), !i.compositeRule && g ? i.async ? t += " throw new ValidationError([" + E + "]); " : t += " validate.errors = [" + E + "]; return false; " : t += " var err = " + E + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ") : i.isTop ? t += n ? " return data; " : " validate.errors = null; return true; " : t += " var " + u + " = true; ", i.isTop && (t += " }; return validate; ");
                else {
                    if (i.isTop) {
                        var a = i.isTop, l = i.level = 0, c = i.dataLevel = 0, h = "data";
                        if (i.rootId = i.resolve.fullPath(i.self._getId(i.root.schema)), i.baseId = i.baseId || i.rootId, delete i.isTop, i.dataPathArr = [
                            ""
                        ], void 0 !== i.schema.default && i.opts.useDefaults && i.opts.strictDefaults) {
                            var d = "default is ignored in the schema root";
                            if ("log" !== i.opts.strictDefaults) throw new Error(d);
                            i.logger.warn(d);
                        }
                        t = (t += " var vErrors = null; ") + " var errors = 0;     " + " if (rootData === undefined) rootData = data; ";
                    } else {
                        l = i.level, h = "data" + ((c = i.dataLevel) || "");
                        if (r && (i.baseId = i.resolve.url(i.baseId, r)), n && !i.async) throw new Error("async schema in sync schema");
                        t += " var errs_" + l + " = errors;";
                    }
                    var u = "valid" + l, g = !i.opts.allErrors, p = "", m = "", f = i.schema.type, C = Array.isArray(f);
                    if (f && i.opts.nullable && !0 === i.schema.nullable && (C ? -1 == f.indexOf("null") && (f = f.concat("null")) : "null" != f && (f = [
                        f,
                        "null"
                    ], C = !0)), C && 1 == f.length && (f = f[0], C = !1), i.schema.$ref && o) {
                        if ("fail" == i.opts.extendRefs) throw new Error('$ref: validation keywords used in schema at path "' + i.errSchemaPath + '" (see option extendRefs)');
                        !0 !== i.opts.extendRefs && (o = !1, i.logger.warn('$ref: keywords ignored in schema at path "' + i.errSchemaPath + '"'));
                    }
                    if (i.schema.$comment && i.opts.$comment && (t += " " + i.RULES.all.$comment.code(i, "$comment")), f) {
                        i.opts.coerceTypes && (y = i.util.coerceToTypes(i.opts.coerceTypes, f));
                        var y, v = i.RULES.types[f];
                        if (y || C || !0 === v || v && !z(v)) {
                            var I = i.schemaPath + ".type", b = i.errSchemaPath + "/type", I = i.schemaPath + ".type", b = i.errSchemaPath + "/type";
                            if (t += " if (" + i.util[C ? "checkDataTypes" : "checkDataType"](f, h, i.opts.strictNumbers, !0) + ") { ", y) {
                                var A = "dataType" + l, w = "coerced" + l, S = (t += " var " + A + " = typeof " + h + "; var " + w + " = undefined; ", "array" == i.opts.coerceTypes && (t += " if (" + A + " == 'object' && Array.isArray(" + h + ") && " + h + ".length == 1) { " + h + " = " + h + "[0]; " + A + " = typeof " + h + "; if (" + i.util.checkDataType(i.schema.type, h, i.opts.strictNumbers) + ") " + w + " = " + h + "; } "), t += " if (" + w + " !== undefined) ; ", y);
                                if (S) for(var x, k = -1, H = S.length - 1; k < H;)"string" == (x = S[k += 1]) ? t += " else if (" + A + " == 'number' || " + A + " == 'boolean') " + w + " = '' + " + h + "; else if (" + h + " === null) " + w + " = ''; " : "number" == x || "integer" == x ? (t += " else if (" + A + " == 'boolean' || " + h + " === null || (" + A + " == 'string' && " + h + " && " + h + " == +" + h + " ", "integer" == x && (t += " && !(" + h + " % 1)"), t += ")) " + w + " = +" + h + "; ") : "boolean" == x ? t += " else if (" + h + " === 'false' || " + h + " === 0 || " + h + " === null) " + w + " = false; else if (" + h + " === 'true' || " + h + " === 1) " + w + " = true; " : "null" == x ? t += " else if (" + h + " === '' || " + h + " === 0 || " + h + " === false) " + w + " = null; " : "array" == i.opts.coerceTypes && "array" == x && (t += " else if (" + A + " == 'string' || " + A + " == 'number' || " + A + " == 'boolean' || " + h + " == null) " + w + " = [" + h + "]; ");
                                (B = B || []).push(t += " else {   "), t = "", !1 !== i.createErrors ? (t = (t += " { keyword: 'type' , dataPath: (dataPath || '') + " + i.errorPath + " , schemaPath: " + i.util.toQuotedString(b) + " , params: { type: '") + (C ? "" + f.join(",") : "" + f) + "' } ", !1 !== i.opts.messages && (t = (t += " , message: 'should be ") + (C ? "" + f.join(",") : "" + f) + "' "), i.opts.verbose && (t += " , schema: validate.schema" + I + " , parentSchema: validate.schema" + i.schemaPath + " , data: " + h + " "), t += " } ") : t += " {} ";
                                var E = t, s = (t = B.pop(), !i.compositeRule && g ? i.async ? t += " throw new ValidationError([" + E + "]); " : t += " validate.errors = [" + E + "]; return false; " : t += " var err = " + E + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", c ? "data" + (c - 1 || "") : "parentData");
                                t = t + (" } if (" + w + " !== undefined) {  ") + (" " + h + " = " + w + "; "), c || (t += "if (" + s + " !== undefined)"), t += " " + s + "[" + (c ? i.dataPathArr[c] : "parentDataProperty") + "] = " + w + "; } ";
                            } else {
                                E = ((B = B || []).push(t), t = "", !1 !== i.createErrors ? (t = (t += " { keyword: 'type' , dataPath: (dataPath || '') + " + i.errorPath + " , schemaPath: " + i.util.toQuotedString(b) + " , params: { type: '") + (C ? "" + f.join(",") : "" + f) + "' } ", !1 !== i.opts.messages && (t = (t += " , message: 'should be ") + (C ? "" + f.join(",") : "" + f) + "' "), i.opts.verbose && (t += " , schema: validate.schema" + I + " , parentSchema: validate.schema" + i.schemaPath + " , data: " + h + " "), t += " } ") : t += " {} ", t);
                                t = B.pop(), !i.compositeRule && g ? i.async ? t += " throw new ValidationError([" + E + "]); " : t += " validate.errors = [" + E + "]; return false; " : t += " var err = " + E + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                            }
                            t += " } ";
                        }
                    }
                    if (i.schema.$ref && !o) t += " " + i.RULES.all.$ref.code(i, "$ref") + " ", g && (t = (t += " } if (errors === ") + (a ? "0" : "errs_" + l) + ") { ", m += "}");
                    else {
                        var T = i.RULES;
                        if (T) {
                            for(var G = -1, P = T.length - 1; G < P;)if (z(v = T[G += 1])) {
                                if (v.type && (t += " if (" + i.util.checkDataType(v.type, h, i.opts.strictNumbers) + ") { "), i.opts.useDefaults) {
                                    if ("object" == v.type && i.schema.properties) {
                                        var R = i.schema.properties, _ = Object.keys(R);
                                        if (_) {
                                            for(var F, V = -1, Z = _.length - 1; V < Z;)if (void 0 !== (N = R[F = _[V += 1]]).default) {
                                                var $ = h + i.util.getProperty(F);
                                                if (i.compositeRule) {
                                                    if (i.opts.strictDefaults) {
                                                        d = "default is ignored for: " + $;
                                                        if ("log" !== i.opts.strictDefaults) throw new Error(d);
                                                        i.logger.warn(d);
                                                    }
                                                } else t += " if (" + $ + " === undefined ", "empty" == i.opts.useDefaults && (t += " || " + $ + " === null || " + $ + " === '' "), t += " ) " + $ + " = ", "shared" == i.opts.useDefaults ? t += " " + i.useDefault(N.default) + " " : t += " " + JSON.stringify(N.default) + " ", t += "; ";
                                            }
                                        }
                                    } else if ("array" == v.type && Array.isArray(i.schema.items)) {
                                        var L = i.schema.items;
                                        if (L) {
                                            for(var N, k = -1, O = L.length - 1; k < O;)if (void 0 !== (N = L[k += 1]).default) {
                                                $ = h + "[" + k + "]";
                                                if (i.compositeRule) {
                                                    if (i.opts.strictDefaults) {
                                                        d = "default is ignored for: " + $;
                                                        if ("log" !== i.opts.strictDefaults) throw new Error(d);
                                                        i.logger.warn(d);
                                                    }
                                                } else t += " if (" + $ + " === undefined ", "empty" == i.opts.useDefaults && (t += " || " + $ + " === null || " + $ + " === '' "), t += " ) " + $ + " = ", "shared" == i.opts.useDefaults ? t += " " + i.useDefault(N.default) + " " : t += " " + JSON.stringify(N.default) + " ", t += "; ";
                                            }
                                        }
                                    }
                                }
                                var B, D = v.rules;
                                if (D) for(var M, K = -1, j = D.length - 1; K < j;)X(M = D[K += 1]) && (M = M.code(i, M.keyword, v.type)) && (t += " " + M + " ", g) && (p += "}");
                                g && (t += " " + p + " ", p = ""), v.type && (t += " } ", f) && f === v.type && !y && (t += " else { ", I = i.schemaPath + ".type", b = i.errSchemaPath + "/type", (B = B || []).push(t), t = "", !1 !== i.createErrors ? (t = (t += " { keyword: 'type' , dataPath: (dataPath || '') + " + i.errorPath + " , schemaPath: " + i.util.toQuotedString(b) + " , params: { type: '") + (C ? "" + f.join(",") : "" + f) + "' } ", !1 !== i.opts.messages && (t = (t += " , message: 'should be ") + (C ? "" + f.join(",") : "" + f) + "' "), i.opts.verbose && (t += " , schema: validate.schema" + I + " , parentSchema: validate.schema" + i.schemaPath + " , data: " + h + " "), t += " } ") : t += " {} ", E = t, t = B.pop(), !i.compositeRule && g ? i.async ? t += " throw new ValidationError([" + E + "]); " : t += " validate.errors = [" + E + "]; return false; " : t += " var err = " + E + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", t += " } "), g && (t = (t += " if (errors === ") + (a ? "0" : "errs_" + l) + ") { ", m += "}");
                            }
                        }
                    }
                    g && (t += " " + m + " "), a ? t = t + (n ? " if (errors === 0) return data;            else throw new ValidationError(vErrors); " : " validate.errors = vErrors;  return errors === 0;       ") + " }; return validate;" : t += " var " + u + " = errors === errs_" + l + ";";
                }
                return t;
                function z(e) {
                    for(var t = e.rules, n = 0; n < t.length; n++)if (X(t[n])) return 1;
                }
                function X(e) {
                    return void 0 !== i.schema[e.keyword] || e.implements && function(e) {
                        for(var t = e.implements, n = 0; n < t.length; n++)if (void 0 !== i.schema[t[n]]) return 1;
                    }(e);
                }
            };
        },
        7931: function(e, t, n) {
            "use strict";
            var a = /^[a-z_$][a-z0-9_$-]*$/i, l = n(1793), i = n(5868);
            function o(e, t) {
                o.errors = null;
                var n = this._validateKeyword = this._validateKeyword || this.compile(i, !0);
                if (n(e)) return !0;
                if (o.errors = n.errors, t) throw new Error("custom keyword definition is invalid: " + this.errorsText(n.errors));
                return !1;
            }
            e.exports = {
                add: function(e, t) {
                    var s = this.RULES;
                    if (s.keywords[e]) throw new Error("Keyword " + e + " is already defined");
                    if (!a.test(e)) throw new Error("Keyword " + e + " is not a valid identifier");
                    if (t) {
                        this.validateKeyword(t, !0);
                        var n = t.type;
                        if (Array.isArray(n)) for(var i = 0; i < n.length; i++)r(e, n[i], t);
                        else r(e, n, t);
                        var o = t.metaSchema;
                        o && (t.$data && this._opts.$data && (o = {
                            anyOf: [
                                o,
                                {
                                    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
                                }
                            ]
                        }), t.validateSchema = this.compile(o, !0));
                    }
                    function r(e, t, n) {
                        for(var i, o = 0; o < s.length; o++){
                            var r = s[o];
                            if (r.type == t) {
                                i = r;
                                break;
                            }
                        }
                        i || s.push(i = {
                            type: t,
                            rules: []
                        });
                        n = {
                            keyword: e,
                            definition: n,
                            custom: !0,
                            code: l,
                            implements: n.implements
                        };
                        i.rules.push(n), s.custom[e] = n;
                    }
                    return s.keywords[e] = s.all[e] = !0, this;
                },
                get: function(e) {
                    var t = this.RULES.custom[e];
                    return t ? t.definition : this.RULES.keywords[e] || !1;
                },
                remove: function(e) {
                    var t = this.RULES;
                    delete t.keywords[e], delete t.all[e], delete t.custom[e];
                    for(var n = 0; n < t.length; n++)for(var i = t[n].rules, o = 0; o < i.length; o++)if (i[o].keyword == e) {
                        i.splice(o, 1);
                        break;
                    }
                    return this;
                },
                validate: o
            };
        },
        2303: function(e) {
            "use strict";
            e.exports = function e(t, n) {
                if (t === n) return !0;
                if (t && n && "object" == typeof t && "object" == typeof n) {
                    if (t.constructor !== n.constructor) return !1;
                    var i, o, r;
                    if (Array.isArray(t)) {
                        if ((i = t.length) != n.length) return !1;
                        for(o = i; 0 != o--;)if (!e(t[o], n[o])) return !1;
                    } else {
                        if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
                        if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
                        if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
                        if ((i = (r = Object.keys(t)).length) !== Object.keys(n).length) return !1;
                        for(o = i; 0 != o--;)if (!Object.prototype.hasOwnProperty.call(n, r[o])) return !1;
                        for(o = i; 0 != o--;){
                            var s = r[o];
                            if (!e(t[s], n[s])) return !1;
                        }
                    }
                    return !0;
                }
                return t != t && n != n;
            };
        },
        3508: function(e) {
            "use strict";
            e.exports = function(e, t) {
                var i, l = "boolean" == typeof (t = "function" == typeof (t = t || {}) ? {
                    cmp: t
                } : t).cycles && t.cycles, c = t.cmp && (i = t.cmp, function(n) {
                    return function(e, t) {
                        e = {
                            key: e,
                            value: n[e]
                        }, t = {
                            key: t,
                            value: n[t]
                        };
                        return i(e, t);
                    };
                }), h = [];
                return function e(t) {
                    if (void 0 !== (t = t && t.toJSON && "function" == typeof t.toJSON ? t.toJSON() : t)) {
                        if ("number" == typeof t) return isFinite(t) ? "" + t : "null";
                        if ("object" != typeof t) return JSON.stringify(t);
                        if (Array.isArray(t)) {
                            for(o = "[", r = 0; r < t.length; r++)r && (o += ","), o += e(t[r]) || "null";
                            return o + "]";
                        }
                        if (null === t) return "null";
                        if (-1 !== h.indexOf(t)) {
                            if (l) return JSON.stringify("__cycle__");
                            throw new TypeError("Converting circular structure to JSON");
                        }
                        for(var n = h.push(t) - 1, i = Object.keys(t).sort(c && c(t)), o = "", r = 0; r < i.length; r++){
                            var s = i[r], a = e(t[s]);
                            a && (o && (o += ","), o += JSON.stringify(s) + ":" + a);
                        }
                        return h.splice(n, 1), "{" + o + "}";
                    }
                }(e);
            };
        },
        233: function(e) {
            e.exports = function t(e, n) {
                "use strict";
                function i(e) {
                    return t.insensitive && ("" + e).toLowerCase() || "" + e;
                }
                var o, r, s = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, a = /(^[ ]*|[ ]*$)/g, l = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, c = /^0x[0-9a-f]+$/i, h = /^0/, e = i(e).replace(a, "") || "", n = i(n).replace(a, "") || "", d = e.replace(s, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), u = n.replace(s, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), a = parseInt(e.match(c), 16) || 1 !== d.length && e.match(l) && Date.parse(e), s = parseInt(n.match(c), 16) || a && n.match(l) && Date.parse(n) || null;
                if (s) {
                    if (a < s) return -1;
                    if (s < a) return 1;
                }
                for(var g = 0, p = Math.max(d.length, u.length); g < p; g++){
                    if (o = !(d[g] || "").match(h) && parseFloat(d[g]) || d[g] || 0, r = !(u[g] || "").match(h) && parseFloat(u[g]) || u[g] || 0, isNaN(o) !== isNaN(r)) return isNaN(o) ? 1 : -1;
                    if (typeof o != typeof r && (o += "", r += ""), o < r) return -1;
                    if (r < o) return 1;
                }
                return 0;
            };
        },
        5156: function(e, t) {
            !function(e) {
                "use strict";
                function w(e) {
                    return null !== e && "[object Array]" === Object.prototype.toString.call(e);
                }
                function S(e) {
                    return null !== e && "[object Object]" === Object.prototype.toString.call(e);
                }
                function x(e, t) {
                    if (e !== t) {
                        if (Object.prototype.toString.call(e) !== Object.prototype.toString.call(t)) return !1;
                        if (!0 === w(e)) {
                            if (e.length !== t.length) return !1;
                            for(var n = 0; n < e.length; n++)if (!1 === x(e[n], t[n])) return !1;
                        } else {
                            if (!0 !== S(e)) return !1;
                            var i, o, r = {};
                            for(i in e)if (hasOwnProperty.call(e, i)) {
                                if (!1 === x(e[i], t[i])) return !1;
                                r[i] = !0;
                            }
                            for(o in t)if (hasOwnProperty.call(t, o) && !0 !== r[o]) return !1;
                        }
                    }
                    return !0;
                }
                function k(e) {
                    if ("" === e || !1 === e || null === e) return !0;
                    if (w(e) && 0 === e.length) return !0;
                    if (S(e)) {
                        for(var t in e)if (e.hasOwnProperty(t)) return !1;
                        return !0;
                    }
                    return !1;
                }
                var o = "function" == typeof String.prototype.trimLeft ? function(e) {
                    return e.trimLeft();
                } : function(e) {
                    return e.match(/^\s*(.*)/)[1];
                }, h = {
                    0: "number",
                    1: "any",
                    2: "string",
                    3: "array",
                    4: "object",
                    5: "boolean",
                    6: "expression",
                    7: "null",
                    8: "Array<number>",
                    9: "Array<string>"
                }, s = "UnquotedIdentifier", a = "QuotedIdentifier", l = "Rbracket", c = "Rparen", d = "Comma", u = "Colon", r = "Rbrace", g = "Number", E = "Current", T = "Expref", R = "Pipe", _ = "Flatten", p = "Star", m = "Filter", f = "Lbrace", C = "Lbracket", y = "Lparen", v = "Literal", I = {
                    ".": "Dot",
                    "*": p,
                    ",": d,
                    ":": u,
                    "{": f,
                    "}": r,
                    "]": l,
                    "(": y,
                    ")": c,
                    "@": E
                }, b = {
                    "<": !0,
                    ">": !0,
                    "=": !0,
                    "!": !0
                }, A = {
                    " ": !0,
                    "\t": !0,
                    "\n": !0
                };
                function $(e) {
                    return "0" <= e && e <= "9" || "-" === e;
                }
                function n() {}
                n.prototype = {
                    tokenize: function(e) {
                        var t, n, i = [];
                        for(this._current = 0; this._current < e.length;)if ("a" <= (r = e[this._current]) && r <= "z" || "A" <= r && r <= "Z" || "_" === r) o = this._current, t = this._consumeUnquotedIdentifier(e), i.push({
                            type: s,
                            value: t,
                            start: o
                        });
                        else if (void 0 !== I[e[this._current]]) i.push({
                            type: I[e[this._current]],
                            value: e[this._current],
                            start: this._current
                        }), this._current++;
                        else if ($(e[this._current])) n = this._consumeNumber(e), i.push(n);
                        else if ("[" === e[this._current]) n = this._consumeLBracket(e), i.push(n);
                        else if ('"' === e[this._current]) o = this._current, t = this._consumeQuotedIdentifier(e), i.push({
                            type: a,
                            value: t,
                            start: o
                        });
                        else if ("'" === e[this._current]) o = this._current, t = this._consumeRawStringLiteral(e), i.push({
                            type: v,
                            value: t,
                            start: o
                        });
                        else if ("`" === e[this._current]) {
                            var o = this._current, r = this._consumeLiteral(e);
                            i.push({
                                type: v,
                                value: r,
                                start: o
                            });
                        } else if (void 0 !== b[e[this._current]]) i.push(this._consumeOperator(e));
                        else if (void 0 !== A[e[this._current]]) this._current++;
                        else if ("&" === e[this._current]) o = this._current, this._current++, "&" === e[this._current] ? (this._current++, i.push({
                            type: "And",
                            value: "&&",
                            start: o
                        })) : i.push({
                            type: T,
                            value: "&",
                            start: o
                        });
                        else {
                            if ("|" !== e[this._current]) throw (r = new Error("Unknown character:" + e[this._current])).name = "LexerError", r;
                            o = this._current, this._current++, "|" === e[this._current] ? (this._current++, i.push({
                                type: "Or",
                                value: "||",
                                start: o
                            })) : i.push({
                                type: R,
                                value: "|",
                                start: o
                            });
                        }
                        return i;
                    },
                    _consumeUnquotedIdentifier: function(e) {
                        var t, n = this._current;
                        for(this._current++; this._current < e.length && ("a" <= (t = e[this._current]) && t <= "z" || "A" <= t && t <= "Z" || "0" <= t && t <= "9" || "_" === t);)this._current++;
                        return e.slice(n, this._current);
                    },
                    _consumeQuotedIdentifier: function(e) {
                        for(var t = this._current, n = (this._current++, e.length); '"' !== e[this._current] && this._current < n;){
                            var i = this._current;
                            "\\" !== e[i] || "\\" !== e[i + 1] && '"' !== e[i + 1] ? i++ : i += 2, this._current = i;
                        }
                        return this._current++, JSON.parse(e.slice(t, this._current));
                    },
                    _consumeRawStringLiteral: function(e) {
                        for(var t = this._current, n = (this._current++, e.length); "'" !== e[this._current] && this._current < n;){
                            var i = this._current;
                            "\\" !== e[i] || "\\" !== e[i + 1] && "'" !== e[i + 1] ? i++ : i += 2, this._current = i;
                        }
                        return this._current++, e.slice(t + 1, this._current - 1).replace("\\'", "'");
                    },
                    _consumeNumber: function(e) {
                        for(var t = this._current, n = (this._current++, e.length); $(e[this._current]) && this._current < n;)this._current++;
                        var i = parseInt(e.slice(t, this._current));
                        return {
                            type: g,
                            value: i,
                            start: t
                        };
                    },
                    _consumeLBracket: function(e) {
                        var t = this._current;
                        return this._current++, "?" === e[this._current] ? (this._current++, {
                            type: m,
                            value: "[?",
                            start: t
                        }) : "]" === e[this._current] ? (this._current++, {
                            type: _,
                            value: "[]",
                            start: t
                        }) : {
                            type: C,
                            value: "[",
                            start: t
                        };
                    },
                    _consumeOperator: function(e) {
                        var t = this._current, n = e[t];
                        return this._current++, "!" === n ? "=" === e[this._current] ? (this._current++, {
                            type: "NE",
                            value: "!=",
                            start: t
                        }) : {
                            type: "Not",
                            value: "!",
                            start: t
                        } : "<" === n ? "=" === e[this._current] ? (this._current++, {
                            type: "LTE",
                            value: "<=",
                            start: t
                        }) : {
                            type: "LT",
                            value: "<",
                            start: t
                        } : ">" === n ? "=" === e[this._current] ? (this._current++, {
                            type: "GTE",
                            value: ">=",
                            start: t
                        }) : {
                            type: "GT",
                            value: ">",
                            start: t
                        } : "=" === n && "=" === e[this._current] ? (this._current++, {
                            type: "EQ",
                            value: "==",
                            start: t
                        }) : void 0;
                    },
                    _consumeLiteral: function(e) {
                        this._current++;
                        for(var t = this._current, n = e.length; "`" !== e[this._current] && this._current < n;){
                            var i = this._current;
                            "\\" !== e[i] || "\\" !== e[i + 1] && "`" !== e[i + 1] ? i++ : i += 2, this._current = i;
                        }
                        t = (t = o(e.slice(t, this._current))).replace("\\`", "`"), t = this._looksLikeJSON(t) ? JSON.parse(t) : JSON.parse('"' + t + '"');
                        return this._current++, t;
                    },
                    _looksLikeJSON: function(e) {
                        if ("" === e) return !1;
                        if (0 <= '[{"'.indexOf(e[0])) return !0;
                        if (0 <= [
                            "true",
                            "false",
                            "null"
                        ].indexOf(e)) return !0;
                        if (!(0 <= "-0123456789".indexOf(e[0]))) return !1;
                        try {
                            return JSON.parse(e), !0;
                        } catch (e) {
                            return !1;
                        }
                    }
                };
                var L = {};
                function N() {}
                function B(e) {
                    this.runtime = e;
                }
                function M(e) {
                    this._interpreter = e, this.functionTable = {
                        abs: {
                            _func: this._functionAbs,
                            _signature: [
                                {
                                    types: [
                                        0
                                    ]
                                }
                            ]
                        },
                        avg: {
                            _func: this._functionAvg,
                            _signature: [
                                {
                                    types: [
                                        8
                                    ]
                                }
                            ]
                        },
                        ceil: {
                            _func: this._functionCeil,
                            _signature: [
                                {
                                    types: [
                                        0
                                    ]
                                }
                            ]
                        },
                        contains: {
                            _func: this._functionContains,
                            _signature: [
                                {
                                    types: [
                                        2,
                                        3
                                    ]
                                },
                                {
                                    types: [
                                        1
                                    ]
                                }
                            ]
                        },
                        ends_with: {
                            _func: this._functionEndsWith,
                            _signature: [
                                {
                                    types: [
                                        2
                                    ]
                                },
                                {
                                    types: [
                                        2
                                    ]
                                }
                            ]
                        },
                        floor: {
                            _func: this._functionFloor,
                            _signature: [
                                {
                                    types: [
                                        0
                                    ]
                                }
                            ]
                        },
                        length: {
                            _func: this._functionLength,
                            _signature: [
                                {
                                    types: [
                                        2,
                                        3,
                                        4
                                    ]
                                }
                            ]
                        },
                        map: {
                            _func: this._functionMap,
                            _signature: [
                                {
                                    types: [
                                        6
                                    ]
                                },
                                {
                                    types: [
                                        3
                                    ]
                                }
                            ]
                        },
                        max: {
                            _func: this._functionMax,
                            _signature: [
                                {
                                    types: [
                                        8,
                                        9
                                    ]
                                }
                            ]
                        },
                        merge: {
                            _func: this._functionMerge,
                            _signature: [
                                {
                                    types: [
                                        4
                                    ],
                                    variadic: !0
                                }
                            ]
                        },
                        max_by: {
                            _func: this._functionMaxBy,
                            _signature: [
                                {
                                    types: [
                                        3
                                    ]
                                },
                                {
                                    types: [
                                        6
                                    ]
                                }
                            ]
                        },
                        sum: {
                            _func: this._functionSum,
                            _signature: [
                                {
                                    types: [
                                        8
                                    ]
                                }
                            ]
                        },
                        starts_with: {
                            _func: this._functionStartsWith,
                            _signature: [
                                {
                                    types: [
                                        2
                                    ]
                                },
                                {
                                    types: [
                                        2
                                    ]
                                }
                            ]
                        },
                        min: {
                            _func: this._functionMin,
                            _signature: [
                                {
                                    types: [
                                        8,
                                        9
                                    ]
                                }
                            ]
                        },
                        min_by: {
                            _func: this._functionMinBy,
                            _signature: [
                                {
                                    types: [
                                        3
                                    ]
                                },
                                {
                                    types: [
                                        6
                                    ]
                                }
                            ]
                        },
                        type: {
                            _func: this._functionType,
                            _signature: [
                                {
                                    types: [
                                        1
                                    ]
                                }
                            ]
                        },
                        keys: {
                            _func: this._functionKeys,
                            _signature: [
                                {
                                    types: [
                                        4
                                    ]
                                }
                            ]
                        },
                        values: {
                            _func: this._functionValues,
                            _signature: [
                                {
                                    types: [
                                        4
                                    ]
                                }
                            ]
                        },
                        sort: {
                            _func: this._functionSort,
                            _signature: [
                                {
                                    types: [
                                        9,
                                        8
                                    ]
                                }
                            ]
                        },
                        sort_by: {
                            _func: this._functionSortBy,
                            _signature: [
                                {
                                    types: [
                                        3
                                    ]
                                },
                                {
                                    types: [
                                        6
                                    ]
                                }
                            ]
                        },
                        join: {
                            _func: this._functionJoin,
                            _signature: [
                                {
                                    types: [
                                        2
                                    ]
                                },
                                {
                                    types: [
                                        9
                                    ]
                                }
                            ]
                        },
                        reverse: {
                            _func: this._functionReverse,
                            _signature: [
                                {
                                    types: [
                                        2,
                                        3
                                    ]
                                }
                            ]
                        },
                        to_array: {
                            _func: this._functionToArray,
                            _signature: [
                                {
                                    types: [
                                        1
                                    ]
                                }
                            ]
                        },
                        to_string: {
                            _func: this._functionToString,
                            _signature: [
                                {
                                    types: [
                                        1
                                    ]
                                }
                            ]
                        },
                        to_number: {
                            _func: this._functionToNumber,
                            _signature: [
                                {
                                    types: [
                                        1
                                    ]
                                }
                            ]
                        },
                        not_null: {
                            _func: this._functionNotNull,
                            _signature: [
                                {
                                    types: [
                                        1
                                    ],
                                    variadic: !0
                                }
                            ]
                        }
                    };
                }
                L.EOF = 0, L[s] = 0, L[a] = 0, L[l] = 0, L[c] = 0, L[d] = 0, L[r] = 0, L[g] = 0, L[E] = 0, L[T] = 0, L.Pipe = 1, L.Or = 2, L.And = 3, L.EQ = 5, L.GT = 5, L.LT = 5, L.GTE = 5, L.LTE = 5, L.NE = 5, L[_] = 9, L.Star = 20, L[m] = 21, L.Dot = 40, L.Not = 45, L[f] = 50, L[C] = 55, L[y] = 60, N.prototype = {
                    parse: function(e) {
                        this._loadTokens(e), this.index = 0;
                        var t, e = this.expression(0);
                        if ("EOF" !== this._lookahead(0)) throw t = this._lookaheadToken(0), (t = new Error("Unexpected token type: " + t.type + ", value: " + t.value)).name = "ParserError", t;
                        return e;
                    },
                    _loadTokens: function(e) {
                        var t = (new n).tokenize(e);
                        t.push({
                            type: "EOF",
                            value: "",
                            start: e.length
                        }), this.tokens = t;
                    },
                    expression: function(e) {
                        for(var t = this._lookaheadToken(0), n = (this._advance(), this.nud(t)), i = this._lookahead(0); e < L[i];)this._advance(), n = this.led(i, n), i = this._lookahead(0);
                        return n;
                    },
                    _lookahead: function(e) {
                        return this.tokens[this.index + e].type;
                    },
                    _lookaheadToken: function(e) {
                        return this.tokens[this.index + e];
                    },
                    _advance: function() {
                        this.index++;
                    },
                    nud: function(e) {
                        var t, n;
                        switch(e.type){
                            case v:
                                return {
                                    type: "Literal",
                                    value: e.value
                                };
                            case s:
                                return {
                                    type: "Field",
                                    name: e.value
                                };
                            case a:
                                var i = {
                                    type: "Field",
                                    name: e.value
                                };
                                if (this._lookahead(0) === y) throw new Error("Quoted identifier not allowed for function names.");
                                return i;
                            case "Not":
                                return {
                                    type: "NotExpression",
                                    children: [
                                        t = this.expression(L.Not)
                                    ]
                                };
                            case p:
                                return t = null, {
                                    type: "ValueProjection",
                                    children: [
                                        {
                                            type: "Identity"
                                        },
                                        t = this._lookahead(0) === l ? {
                                            type: "Identity"
                                        } : this._parseProjectionRHS(L.Star)
                                    ]
                                };
                            case m:
                                return this.led(e.type, {
                                    type: "Identity"
                                });
                            case f:
                                return this._parseMultiselectHash();
                            case _:
                                return {
                                    type: "Projection",
                                    children: [
                                        {
                                            type: _,
                                            children: [
                                                {
                                                    type: "Identity"
                                                }
                                            ]
                                        },
                                        t = this._parseProjectionRHS(L.Flatten)
                                    ]
                                };
                            case C:
                                return this._lookahead(0) === g || this._lookahead(0) === u ? (t = this._parseIndexExpression(), this._projectIfSlice({
                                    type: "Identity"
                                }, t)) : this._lookahead(0) === p && this._lookahead(1) === l ? (this._advance(), this._advance(), {
                                    type: "Projection",
                                    children: [
                                        {
                                            type: "Identity"
                                        },
                                        t = this._parseProjectionRHS(L.Star)
                                    ]
                                }) : this._parseMultiselectList();
                            case E:
                                return {
                                    type: E
                                };
                            case T:
                                return {
                                    type: "ExpressionReference",
                                    children: [
                                        n = this.expression(L.Expref)
                                    ]
                                };
                            case y:
                                for(var o = []; this._lookahead(0) !== c;)this._lookahead(0) === E ? (n = {
                                    type: E
                                }, this._advance()) : n = this.expression(0), o.push(n);
                                return this._match(c), o[0];
                            default:
                                this._errorToken(e);
                        }
                    },
                    led: function(e, t) {
                        var n;
                        switch(e){
                            case "Dot":
                                var i = L.Dot;
                                return this._lookahead(0) !== p ? {
                                    type: "Subexpression",
                                    children: [
                                        t,
                                        n = this._parseDotRHS(i)
                                    ]
                                } : (this._advance(), {
                                    type: "ValueProjection",
                                    children: [
                                        t,
                                        n = this._parseProjectionRHS(i)
                                    ]
                                });
                            case R:
                                return n = this.expression(L.Pipe), {
                                    type: R,
                                    children: [
                                        t,
                                        n
                                    ]
                                };
                            case "Or":
                                return {
                                    type: "OrExpression",
                                    children: [
                                        t,
                                        n = this.expression(L.Or)
                                    ]
                                };
                            case "And":
                                return {
                                    type: "AndExpression",
                                    children: [
                                        t,
                                        n = this.expression(L.And)
                                    ]
                                };
                            case y:
                                for(var o, i = t.name, r = []; this._lookahead(0) !== c;)this._lookahead(0) === E ? (o = {
                                    type: E
                                }, this._advance()) : o = this.expression(0), this._lookahead(0) === d && this._match(d), r.push(o);
                                return this._match(c), {
                                    type: "Function",
                                    name: i,
                                    children: r
                                };
                            case m:
                                i = this.expression(0);
                                return this._match(l), {
                                    type: "FilterProjection",
                                    children: [
                                        t,
                                        n = this._lookahead(0) === _ ? {
                                            type: "Identity"
                                        } : this._parseProjectionRHS(L.Filter),
                                        i
                                    ]
                                };
                            case _:
                                return {
                                    type: "Projection",
                                    children: [
                                        {
                                            type: _,
                                            children: [
                                                t
                                            ]
                                        },
                                        this._parseProjectionRHS(L.Flatten)
                                    ]
                                };
                            case "EQ":
                            case "NE":
                            case "GT":
                            case "GTE":
                            case "LT":
                            case "LTE":
                                return this._parseComparator(t, e);
                            case C:
                                i = this._lookaheadToken(0);
                                return i.type === g || i.type === u ? (n = this._parseIndexExpression(), this._projectIfSlice(t, n)) : (this._match(p), this._match(l), {
                                    type: "Projection",
                                    children: [
                                        t,
                                        n = this._parseProjectionRHS(L.Star)
                                    ]
                                });
                            default:
                                this._errorToken(this._lookaheadToken(0));
                        }
                    },
                    _match: function(e) {
                        var t;
                        if (this._lookahead(0) !== e) throw t = this._lookaheadToken(0), (e = new Error("Expected " + e + ", got: " + t.type)).name = "ParserError", e;
                        this._advance();
                    },
                    _errorToken: function(e) {
                        e = new Error("Invalid token (" + e.type + '): "' + e.value + '"');
                        throw e.name = "ParserError", e;
                    },
                    _parseIndexExpression: function() {
                        var e;
                        return this._lookahead(0) === u || this._lookahead(1) === u ? this._parseSliceExpression() : (e = {
                            type: "Index",
                            value: this._lookaheadToken(0).value
                        }, this._advance(), this._match(l), e);
                    },
                    _projectIfSlice: function(e, t) {
                        e = {
                            type: "IndexExpression",
                            children: [
                                e,
                                t
                            ]
                        };
                        return "Slice" === t.type ? {
                            type: "Projection",
                            children: [
                                e,
                                this._parseProjectionRHS(L.Star)
                            ]
                        } : e;
                    },
                    _parseSliceExpression: function() {
                        for(var e, t = [
                            null,
                            null,
                            null
                        ], n = 0, i = this._lookahead(0); i !== l && n < 3;){
                            if (i === u) n++;
                            else {
                                if (i !== g) throw e = this._lookahead(0), (e = new Error("Syntax error, unexpected token: " + e.value + "(" + e.type + ")")).name = "Parsererror", e;
                                t[n] = this._lookaheadToken(0).value;
                            }
                            this._advance(), i = this._lookahead(0);
                        }
                        return this._match(l), {
                            type: "Slice",
                            children: t
                        };
                    },
                    _parseComparator: function(e, t) {
                        return {
                            type: "Comparator",
                            name: t,
                            children: [
                                e,
                                this.expression(L[t])
                            ]
                        };
                    },
                    _parseDotRHS: function(e) {
                        var t = this._lookahead(0);
                        return 0 <= [
                            s,
                            a,
                            p
                        ].indexOf(t) ? this.expression(e) : t === C ? (this._match(C), this._parseMultiselectList()) : t === f ? (this._match(f), this._parseMultiselectHash()) : void 0;
                    },
                    _parseProjectionRHS: function(e) {
                        var t, n;
                        if (L[this._lookahead(0)] < 10) t = {
                            type: "Identity"
                        };
                        else if (this._lookahead(0) === C) t = this.expression(e);
                        else if (this._lookahead(0) === m) t = this.expression(e);
                        else {
                            if ("Dot" !== this._lookahead(0)) throw n = this._lookaheadToken(0), (n = new Error("Sytanx error, unexpected token: " + n.value + "(" + n.type + ")")).name = "ParserError", n;
                            this._match("Dot"), t = this._parseDotRHS(e);
                        }
                        return t;
                    },
                    _parseMultiselectList: function() {
                        for(var e = []; this._lookahead(0) !== l;){
                            var t = this.expression(0);
                            if (e.push(t), this._lookahead(0) === d && (this._match(d), this._lookahead(0) === l)) throw new Error("Unexpected token Rbracket");
                        }
                        return this._match(l), {
                            type: "MultiSelectList",
                            children: e
                        };
                    },
                    _parseMultiselectHash: function() {
                        for(var e, t, n = [], i = [
                            s,
                            a
                        ];;){
                            if (e = this._lookaheadToken(0), i.indexOf(e.type) < 0) throw new Error("Expecting an identifier token, got: " + e.type);
                            if (e = e.value, this._advance(), this._match(u), t = this.expression(0), n.push({
                                type: "KeyValuePair",
                                name: e,
                                value: t
                            }), this._lookahead(0) === d) this._match(d);
                            else if (this._lookahead(0) === r) {
                                this._match(r);
                                break;
                            }
                        }
                        return {
                            type: "MultiSelectHash",
                            children: n
                        };
                    }
                }, B.prototype = {
                    search: function(e, t) {
                        return this.visit(e, t);
                    },
                    visit: function(e, t) {
                        var n, i, o, r, s, a;
                        switch(e.type){
                            case "Field":
                                return null !== t && S(t) ? void 0 === (l = t[e.name]) ? null : l : null;
                            case "Subexpression":
                                for(u = this.visit(e.children[0], t), f = 1; f < e.children.length; f++)if (null === (u = this.visit(e.children[1], u))) return null;
                                return u;
                            case "IndexExpression":
                                return s = this.visit(e.children[0], t), this.visit(e.children[1], s);
                            case "Index":
                                return w(t) ? void 0 === (u = t[l = (l = e.value) < 0 ? t.length + l : l]) ? null : u : null;
                            case "Slice":
                                if (!w(t)) return null;
                                var l = e.children.slice(0), l = this.computeSliceParams(t.length, l), c = l[0], h = l[1], d = l[2], u = [];
                                if (0 < d) for(f = c; f < h; f += d)u.push(t[f]);
                                else for(f = c; h < f; f += d)u.push(t[f]);
                                return u;
                            case "Projection":
                                var g = this.visit(e.children[0], t);
                                if (!w(g)) return null;
                                for(p = [], f = 0; f < g.length; f++)null !== (i = this.visit(e.children[1], g[f])) && p.push(i);
                                return p;
                            case "ValueProjection":
                                if (!S(g = this.visit(e.children[0], t))) return null;
                                for(var p = [], m = function(e) {
                                    for(var t = Object.keys(e), n = [], i = 0; i < t.length; i++)n.push(e[t[i]]);
                                    return n;
                                }(g), f = 0; f < m.length; f++)null !== (i = this.visit(e.children[1], m[f])) && p.push(i);
                                return p;
                            case "FilterProjection":
                                if (!w(g = this.visit(e.children[0], t))) return null;
                                var C = [], y = [];
                                for(f = 0; f < g.length; f++)k(n = this.visit(e.children[2], g[f])) || C.push(g[f]);
                                for(var v = 0; v < C.length; v++)null !== (i = this.visit(e.children[1], C[v])) && y.push(i);
                                return y;
                            case "Comparator":
                                switch(o = this.visit(e.children[0], t), r = this.visit(e.children[1], t), e.name){
                                    case "EQ":
                                        u = x(o, r);
                                        break;
                                    case "NE":
                                        u = !x(o, r);
                                        break;
                                    case "GT":
                                        u = r < o;
                                        break;
                                    case "GTE":
                                        u = r <= o;
                                        break;
                                    case "LT":
                                        u = o < r;
                                        break;
                                    case "LTE":
                                        u = o <= r;
                                        break;
                                    default:
                                        throw new Error("Unknown comparator: " + e.name);
                                }
                                return u;
                            case _:
                                var I = this.visit(e.children[0], t);
                                if (!w(I)) return null;
                                var b = [];
                                for(f = 0; f < I.length; f++)w(i = I[f]) ? b.push.apply(b, i) : b.push(i);
                                return b;
                            case "Identity":
                                return t;
                            case "MultiSelectList":
                                if (null === t) return null;
                                for(p = [], f = 0; f < e.children.length; f++)p.push(this.visit(e.children[f], t));
                                return p;
                            case "MultiSelectHash":
                                if (null === t) return null;
                                for(p = {}, f = 0; f < e.children.length; f++)p[(a = e.children[f]).name] = this.visit(a.value, t);
                                return p;
                            case "OrExpression":
                                return n = k(n = this.visit(e.children[0], t)) ? this.visit(e.children[1], t) : n;
                            case "AndExpression":
                                return !0 === k(o = this.visit(e.children[0], t)) ? o : this.visit(e.children[1], t);
                            case "NotExpression":
                                return k(o = this.visit(e.children[0], t));
                            case "Literal":
                                return e.value;
                            case R:
                                return s = this.visit(e.children[0], t), this.visit(e.children[1], s);
                            case E:
                                return t;
                            case "Function":
                                var A = [];
                                for(f = 0; f < e.children.length; f++)A.push(this.visit(e.children[f], t));
                                return this.runtime.callFunction(e.name, A);
                            case "ExpressionReference":
                                l = e.children[0];
                                return l.jmespathType = T, l;
                            default:
                                throw new Error("Unknown node type: " + e.type);
                        }
                    },
                    computeSliceParams: function(e, t) {
                        var n = t[0], i = t[1], t = t[2], o = [
                            null,
                            null,
                            null
                        ];
                        if (null === t) t = 1;
                        else if (0 === t) throw (r = new Error("Invalid slice, step cannot be 0")).name = "RuntimeError", r;
                        var r = t < 0, n = null === n ? r ? e - 1 : 0 : this.capSliceRange(e, n, t), i = null === i ? r ? -1 : e : this.capSliceRange(e, i, t);
                        return o[0] = n, o[1] = i, o[2] = t, o;
                    },
                    capSliceRange: function(e, t, n) {
                        return t < 0 ? (t += e) < 0 && (t = n < 0 ? -1 : 0) : e <= t && (t = n < 0 ? e - 1 : e), t;
                    }
                }, M.prototype = {
                    callFunction: function(e, t) {
                        var n = this.functionTable[e];
                        if (void 0 === n) throw new Error("Unknown function: " + e + "()");
                        return this._validateArgs(e, t, n._signature), n._func.call(this, t);
                    },
                    _validateArgs: function(e, t, n) {
                        var i;
                        if (n[n.length - 1].variadic) {
                            if (t.length < n.length) throw i = 1 === n.length ? " argument" : " arguments", new Error("ArgumentError: " + e + "() takes at least" + n.length + i + " but received " + t.length);
                        } else if (t.length !== n.length) throw i = 1 === n.length ? " argument" : " arguments", new Error("ArgumentError: " + e + "() takes " + n.length + i + " but received " + t.length);
                        for(var o = 0; o < n.length; o++){
                            for(var r, s = !1, a = n[o].types, l = this._getTypeName(t[o]), c = 0; c < a.length; c++)if (this._typeMatches(l, a[c], t[o])) {
                                s = !0;
                                break;
                            }
                            if (!s) throw r = a.map(function(e) {
                                return h[e];
                            }).join(","), new Error("TypeError: " + e + "() expected argument " + (o + 1) + " to be type " + r + " but received type " + h[l] + " instead.");
                        }
                    },
                    _typeMatches: function(e, t, n) {
                        if (1 === t) return !0;
                        if (9 !== t && 8 !== t && 3 !== t) return e === t;
                        if (3 === t) return 3 === e;
                        if (3 === e) {
                            var i;
                            8 === t ? i = 0 : 9 === t && (i = 2);
                            for(var o = 0; o < n.length; o++)if (!this._typeMatches(this._getTypeName(n[o]), i, n[o])) return !1;
                            return !0;
                        }
                    },
                    _getTypeName: function(e) {
                        switch(Object.prototype.toString.call(e)){
                            case "[object String]":
                                return 2;
                            case "[object Number]":
                                return 0;
                            case "[object Array]":
                                return 3;
                            case "[object Boolean]":
                                return 5;
                            case "[object Null]":
                                return 7;
                            case "[object Object]":
                                return e.jmespathType === T ? 6 : 4;
                        }
                    },
                    _functionStartsWith: function(e) {
                        return 0 === e[0].lastIndexOf(e[1]);
                    },
                    _functionEndsWith: function(e) {
                        var t = e[0], e = e[1];
                        return -1 !== t.indexOf(e, t.length - e.length);
                    },
                    _functionReverse: function(e) {
                        var t;
                        if (2 !== this._getTypeName(e[0])) return (t = e[0].slice(0)).reverse(), t;
                        for(var n = e[0], i = "", o = n.length - 1; 0 <= o; o--)i += n[o];
                        return i;
                    },
                    _functionAbs: function(e) {
                        return Math.abs(e[0]);
                    },
                    _functionCeil: function(e) {
                        return Math.ceil(e[0]);
                    },
                    _functionAvg: function(e) {
                        for(var t = 0, n = e[0], i = 0; i < n.length; i++)t += n[i];
                        return t / n.length;
                    },
                    _functionContains: function(e) {
                        return 0 <= e[0].indexOf(e[1]);
                    },
                    _functionFloor: function(e) {
                        return Math.floor(e[0]);
                    },
                    _functionLength: function(e) {
                        return (S(e[0]) ? Object.keys(e[0]) : e[0]).length;
                    },
                    _functionMap: function(e) {
                        for(var t = [], n = this._interpreter, i = e[0], o = e[1], r = 0; r < o.length; r++)t.push(n.visit(i, o[r]));
                        return t;
                    },
                    _functionMerge: function(e) {
                        for(var t = {}, n = 0; n < e.length; n++){
                            var i, o = e[n];
                            for(i in o)t[i] = o[i];
                        }
                        return t;
                    },
                    _functionMax: function(e) {
                        if (0 < e[0].length) {
                            if (0 === this._getTypeName(e[0][0])) return Math.max.apply(Math, e[0]);
                            for(var t = e[0], n = t[0], i = 1; i < t.length; i++)n.localeCompare(t[i]) < 0 && (n = t[i]);
                            return n;
                        }
                        return null;
                    },
                    _functionMin: function(e) {
                        if (0 < e[0].length) {
                            if (0 === this._getTypeName(e[0][0])) return Math.min.apply(Math, e[0]);
                            for(var t = e[0], n = t[0], i = 1; i < t.length; i++)t[i].localeCompare(n) < 0 && (n = t[i]);
                            return n;
                        }
                        return null;
                    },
                    _functionSum: function(e) {
                        for(var t = 0, n = e[0], i = 0; i < n.length; i++)t += n[i];
                        return t;
                    },
                    _functionType: function(e) {
                        switch(this._getTypeName(e[0])){
                            case 0:
                                return "number";
                            case 2:
                                return "string";
                            case 3:
                                return "array";
                            case 4:
                                return "object";
                            case 5:
                                return "boolean";
                            case 6:
                                return "expref";
                            case 7:
                                return "null";
                        }
                    },
                    _functionKeys: function(e) {
                        return Object.keys(e[0]);
                    },
                    _functionValues: function(e) {
                        for(var t = e[0], n = Object.keys(t), i = [], o = 0; o < n.length; o++)i.push(t[n[o]]);
                        return i;
                    },
                    _functionJoin: function(e) {
                        var t = e[0];
                        return e[1].join(t);
                    },
                    _functionToArray: function(e) {
                        return 3 === this._getTypeName(e[0]) ? e[0] : [
                            e[0]
                        ];
                    },
                    _functionToString: function(e) {
                        return 2 === this._getTypeName(e[0]) ? e[0] : JSON.stringify(e[0]);
                    },
                    _functionToNumber: function(e) {
                        var t = this._getTypeName(e[0]);
                        return 0 === t ? e[0] : 2 !== t || (t = +e[0], isNaN(t)) ? null : t;
                    },
                    _functionNotNull: function(e) {
                        for(var t = 0; t < e.length; t++)if (7 !== this._getTypeName(e[t])) return e[t];
                        return null;
                    },
                    _functionSort: function(e) {
                        e = e[0].slice(0);
                        return e.sort(), e;
                    },
                    _functionSortBy: function(e) {
                        var t = e[0].slice(0);
                        if (0 !== t.length) {
                            var o = this._interpreter, r = e[1], s = this._getTypeName(o.visit(r, t[0]));
                            if ([
                                0,
                                2
                            ].indexOf(s) < 0) throw new Error("TypeError");
                            for(var a = this, n = [], i = 0; i < t.length; i++)n.push([
                                i,
                                t[i]
                            ]);
                            n.sort(function(e, t) {
                                var n = o.visit(r, e[1]), i = o.visit(r, t[1]);
                                if (a._getTypeName(n) !== s) throw new Error("TypeError: expected " + s + ", received " + a._getTypeName(n));
                                if (a._getTypeName(i) !== s) throw new Error("TypeError: expected " + s + ", received " + a._getTypeName(i));
                                return i < n ? 1 : n < i ? -1 : e[0] - t[0];
                            });
                            for(var l = 0; l < n.length; l++)t[l] = n[l][1];
                        }
                        return t;
                    },
                    _functionMaxBy: function(e) {
                        for(var t, n, i = e[1], o = e[0], r = this.createKeyFunction(i, [
                            0,
                            2
                        ]), s = -1 / 0, a = 0; a < o.length; a++)s < (n = r(o[a])) && (s = n, t = o[a]);
                        return t;
                    },
                    _functionMinBy: function(e) {
                        for(var t, n, i = e[1], o = e[0], r = this.createKeyFunction(i, [
                            0,
                            2
                        ]), s = 1 / 0, a = 0; a < o.length; a++)(n = r(o[a])) < s && (s = n, t = o[a]);
                        return t;
                    },
                    createKeyFunction: function(n, i) {
                        var o = this, r = this._interpreter;
                        return function(e) {
                            var t, e = r.visit(n, e);
                            if (i.indexOf(o._getTypeName(e)) < 0) throw t = "TypeError: expected one of " + i + ", received " + o._getTypeName(e), new Error(t);
                            return e;
                        };
                    }
                }, e.tokenize = function(e) {
                    return (new n).tokenize(e);
                }, e.compile = function(e) {
                    return (new N).parse(e);
                }, e.search = function(e, t) {
                    var n = new N, i = new B(o = new M), o = (o._interpreter = i, n.parse(t));
                    return i.search(o, e);
                }, e.strictDeepEqual = x;
            }(t);
        },
        500: function(e) {
            "use strict";
            var m = e.exports = function(e, t, n) {
                "function" == typeof t && (n = t, t = {}), function e(t, n, i, o, r, s, a, l, c, h) {
                    if (o && "object" == typeof o && !Array.isArray(o)) {
                        for(var d in n(o, r, s, a, l, c, h), o){
                            var u = o[d];
                            if (Array.isArray(u)) {
                                if (d in m.arrayKeywords) for(var g = 0; g < u.length; g++)e(t, n, i, u[g], r + "/" + d + "/" + g, s, r, d, o, g);
                            } else if (d in m.propsKeywords) {
                                if (u && "object" == typeof u) for(var p in u)e(t, n, i, u[p], r + "/" + d + "/" + f(p), s, r, d, o, p);
                            } else (d in m.keywords || t.allKeys && !(d in m.skipKeywords)) && e(t, n, i, u, r + "/" + d, s, r, d, o);
                        }
                        i(o, r, s, a, l, c, h);
                    }
                }(t, "function" == typeof (n = t.cb || n) ? n : n.pre || function() {}, n.post || function() {}, e, "", e);
            };
            function f(e) {
                return e.replace(/~/g, "~0").replace(/\//g, "~1");
            }
            m.keywords = {
                additionalItems: !0,
                items: !0,
                contains: !0,
                additionalProperties: !0,
                propertyNames: !0,
                not: !0
            }, m.arrayKeywords = {
                items: !0,
                allOf: !0,
                anyOf: !0,
                oneOf: !0
            }, m.propsKeywords = {
                definitions: !0,
                properties: !0,
                patternProperties: !0,
                dependencies: !0
            }, m.skipKeywords = {
                default: !0,
                enum: !0,
                const: !0,
                required: !0,
                maximum: !0,
                minimum: !0,
                exclusiveMaximum: !0,
                exclusiveMinimum: !0,
                multipleOf: !0,
                maxLength: !0,
                minLength: !0,
                pattern: !0,
                format: !0,
                maxItems: !0,
                minItems: !0,
                uniqueItems: !0,
                maxProperties: !0,
                minProperties: !0
            };
        },
        7026: function(e, t) {
            "use strict";
            var b = {
                b: "\b",
                f: "\f",
                n: "\n",
                r: "\r",
                t: "\t",
                '"': '"',
                "/": "/",
                "\\": "\\"
            }, A = "a".charCodeAt(), n = (t.parse = function(o, e, t) {
                var i = {}, n = 0, r = 0, s = 0, a = t && t.bigint && "undefined" != typeof BigInt;
                return {
                    data: l("", !0),
                    pointers: i
                };
                function l(e, t) {
                    c(), m(e, "value");
                    var n, i = u();
                    switch(i){
                        case "t":
                            d("rue"), n = !0;
                            break;
                        case "f":
                            d("alse"), n = !1;
                            break;
                        case "n":
                            d("ull"), n = null;
                            break;
                        case '"':
                            n = h();
                            break;
                        case "[":
                            n = function(e) {
                                c();
                                var t = [], n = 0;
                                if ("]" != u()) for(g();;){
                                    t.push(l(e + "/" + n)), c();
                                    var i = u();
                                    if ("]" == i) break;
                                    "," != i && v(), c(), n++;
                                }
                                return t;
                            }(e);
                            break;
                        case "{":
                            n = function(e) {
                                c();
                                var t = {};
                                if ("}" != u()) for(g();;){
                                    var n = C(), i = ('"' != u() && v(), h()), o = e + "/" + w(i), n = (f(o, "key", n), m(o, "keyEnd"), c(), ":" != u() && v(), c(), t[i] = l(o), c(), u());
                                    if ("}" == n) break;
                                    "," != n && v(), c();
                                }
                                return t;
                            }(e);
                            break;
                        default:
                            g(), 0 <= "-0123456789".indexOf(i) ? n = function() {
                                var e = "", t = !0;
                                "-" == o[s] && (e += u());
                                e += ("0" == o[s] ? u : p)(), "." == o[s] && (e += u() + p(), t = !1);
                                "e" != o[s] && "E" != o[s] || (e += u(), "+" != o[s] && "-" != o[s] || (e += u()), e += p(), t = !1);
                                var n = +e;
                                return a && t && (n > Number.MAX_SAFE_INTEGER || n < Number.MIN_SAFE_INTEGER) ? BigInt(e) : n;
                            }() : y();
                    }
                    return m(e, "valueEnd"), c(), t && s < o.length && y(), n;
                }
                function c() {
                    e: for(; s < o.length;){
                        switch(o[s]){
                            case " ":
                                r++;
                                break;
                            case "\t":
                                r += 4;
                                break;
                            case "\r":
                                r = 0;
                                break;
                            case "\n":
                                r = 0, n++;
                                break;
                            default:
                                break e;
                        }
                        s++;
                    }
                }
                function h() {
                    for(var e, t = ""; '"' != (e = u());)"\\" == e ? (e = u()) in b ? t += b[e] : "u" == e ? t += function() {
                        var e = 4, t = 0;
                        for(; e--;){
                            t <<= 4;
                            var n = u().toLowerCase();
                            "a" <= n && n <= "f" ? t += n.charCodeAt() - A + 10 : "0" <= n && n <= "9" ? t += +n : v();
                        }
                        return String.fromCharCode(t);
                    }() : v() : t += e;
                    return t;
                }
                function d(e) {
                    for(var t = 0; t < e.length; t++)u() !== e[t] && v();
                }
                function u() {
                    I();
                    var e = o[s];
                    return s++, r++, e;
                }
                function g() {
                    s--, r--;
                }
                function p() {
                    for(var e = ""; "0" <= o[s] && o[s] <= "9";)e += u();
                    if (e.length) return e;
                    I(), y();
                }
                function m(e, t) {
                    f(e, t, C());
                }
                function f(e, t, n) {
                    i[e] = i[e] || {}, i[e][t] = n;
                }
                function C() {
                    return {
                        line: n,
                        column: r,
                        pos: s
                    };
                }
                function y() {
                    throw new SyntaxError("Unexpected token " + o[s] + " in JSON at position " + s);
                }
                function v() {
                    g(), y();
                }
                function I() {
                    if (s >= o.length) throw new SyntaxError("Unexpected end of JSON input");
                }
            }, t.stringify = function(e, t, n) {
                if (v(e)) {
                    var i = 0;
                    switch(typeof (u = "object" == typeof n ? n.space : n)){
                        case "number":
                            var o = 10 < u ? 10 : u < 0 ? 0 : Math.floor(u), u = o && y(o, " "), r = o, s = o;
                            break;
                        case "string":
                            u = u.slice(0, 10);
                            for(var a = s = r = 0; a < u.length; a++){
                                switch(u[a]){
                                    case " ":
                                        s++;
                                        break;
                                    case "\t":
                                        s += 4;
                                        break;
                                    case "\r":
                                        s = 0;
                                        break;
                                    case "\n":
                                        s = 0, i++;
                                        break;
                                    default:
                                        throw new Error("whitespace characters not allowed in JSON");
                                }
                                r++;
                            }
                            break;
                        default:
                            u = void 0;
                    }
                    var l = "", c = {}, h = 0, d = 0, g = 0, p = n && n.es6 && "function" == typeof Map;
                    return function l(c, h, d) {
                        C(d, "value");
                        switch(typeof c){
                            case "number":
                            case "bigint":
                            case "boolean":
                                m("" + c);
                                break;
                            case "string":
                                m(I(c));
                                break;
                            case "object":
                                null === c ? m("null") : "function" == typeof c.toJSON ? m(I(c.toJSON())) : Array.isArray(c) ? e() : p ? c.constructor.BYTES_PER_ELEMENT ? e() : c instanceof Map ? n() : c instanceof Set ? n(!0) : t() : t();
                        }
                        C(d, "valueEnd");
                        function e() {
                            if (c.length) {
                                m("[");
                                for(var e = h + 1, t = 0; t < c.length; t++){
                                    t && m(","), f(e);
                                    var n = v(c[t]) ? c[t] : null, i = d + "/" + t;
                                    l(n, e, i);
                                }
                                f(h), m("]");
                            } else m("[]");
                        }
                        function t() {
                            var e = Object.keys(c);
                            if (e.length) {
                                m("{");
                                for(var t = h + 1, n = 0; n < e.length; n++){
                                    var i, o = e[n], r = c[o];
                                    v(r) && (n && m(","), i = d + "/" + w(o), f(t), C(i, "key"), m(I(o)), C(i, "keyEnd"), m(":"), u && m(" "), l(r, t, i));
                                }
                                f(h), m("}");
                            } else m("{}");
                        }
                        function n(e) {
                            if (c.size) {
                                m("{");
                                for(var t = h + 1, n = !0, i = c.entries(), o = i.next(); !o.done;){
                                    var r, s = o.value, a = s[0], s = !!e || s[1];
                                    v(s) && (n || m(","), n = !1, r = d + "/" + w(a), f(t), C(r, "key"), m(I(a)), C(r, "keyEnd"), m(":"), u && m(" "), l(s, t, r)), o = i.next();
                                }
                                f(h), m("}");
                            } else m("{}");
                        }
                    }(e, 0, ""), {
                        json: l,
                        pointers: c
                    };
                }
                function m(e) {
                    d += e.length, g += e.length, l += e;
                }
                function f(e) {
                    if (u) {
                        for(l += "\n" + y(e, u), h++, d = 0; e--;)i ? (h += i, d = s) : d += s, g += r;
                        g += 1;
                    }
                }
                function C(e, t) {
                    c[e] = c[e] || {}, c[e][t] = {
                        line: h,
                        column: d,
                        pos: g
                    };
                }
                function y(e, t) {
                    return Array(e + 1).join(t);
                }
            }, [
                "number",
                "bigint",
                "boolean",
                "string",
                "object"
            ]);
            function v(e) {
                return 0 <= n.indexOf(typeof e);
            }
            var i = /"|\\/g, o = /[\b]/g, r = /\f/g, s = /\n/g, a = /\r/g, l = /\t/g;
            function I(e) {
                return '"' + (e = e.replace(i, "\\$&").replace(r, "\\f").replace(o, "\\b").replace(s, "\\n").replace(a, "\\r").replace(l, "\\t")) + '"';
            }
            var c = /~/g, h = /\//g;
            function w(e) {
                return e.replace(c, "~0").replace(h, "~1");
            }
        },
        483: function(e, t) {
            var n, i;
            !function() {
                "use strict";
                i = [], void 0 !== (i = "function" == typeof (n = function() {
                    "use strict";
                    function C(e) {
                        if (typeof Node === "object") return e instanceof Node;
                        else return e && typeof e === "object" && typeof e.nodeType === "number";
                    }
                    function y(e) {
                        return typeof e === "string";
                    }
                    function v() {
                        var r = [];
                        return {
                            watch: r.push.bind(r),
                            trigger: function(e, t) {
                                var n = true;
                                var i = {
                                    detail: t,
                                    preventDefault: function e() {
                                        n = false;
                                    }
                                };
                                for(var o = 0; o < r.length; o++)r[o](e, i);
                                return n;
                            }
                        };
                    }
                    function o(e) {
                        return window.getComputedStyle(e).display === "none";
                    }
                    function r(e) {
                        this.elem = e;
                    }
                    function I(e, t) {
                        return r.make(e("parent")).clazz("pico-overlay").clazz(e("overlayClass", "")).stylize({
                            display: "none",
                            position: "fixed",
                            top: "0px",
                            left: "0px",
                            height: "100%",
                            width: "100%",
                            zIndex: 1e4
                        }).stylize(e("overlayStyles", {
                            opacity: .5,
                            background: "#000"
                        })).onClick(function() {
                            if (e("overlayClose", true)) t();
                        });
                    }
                    r.make = function(e, t) {
                        if (typeof e === "string") e = document.querySelector(e);
                        var n = document.createElement(t || "div");
                        (e || document.body).appendChild(n);
                        return new r(n);
                    }, r.prototype = {
                        child: function(e) {
                            return r.make(this.elem, e);
                        },
                        stylize: function(e) {
                            e = e || {};
                            if (typeof e.opacity !== "undefined") e.filter = "alpha(opacity=" + e.opacity * 100 + ")";
                            for(var t in e)if (e.hasOwnProperty(t)) this.elem.style[t] = e[t];
                            return this;
                        },
                        clazz: function(e) {
                            this.elem.className += " " + e;
                            return this;
                        },
                        html: function(e) {
                            if (C(e)) this.elem.appendChild(e);
                            else this.elem.innerHTML = e;
                            return this;
                        },
                        onClick: function(e) {
                            this.elem.addEventListener("click", e);
                            return this;
                        },
                        destroy: function() {
                            this.elem.parentNode.removeChild(this.elem);
                        },
                        hide: function() {
                            this.elem.style.display = "none";
                        },
                        show: function() {
                            this.elem.style.display = "block";
                        },
                        attr: function(e, t) {
                            if (t !== undefined) this.elem.setAttribute(e, t);
                            return this;
                        },
                        anyAncestor: function(e) {
                            var t = this.elem;
                            while(t)if (e(new r(t))) return true;
                            else t = t.parentNode;
                            return false;
                        },
                        isVisible: function() {
                            return !o(this.elem);
                        }
                    };
                    var s = 1;
                    function b(e, n) {
                        var t = e("width", "auto");
                        if (typeof t === "number") t = "" + t + "px";
                        var i = e("modalId", "pico-" + s++);
                        var o = r.make(e("parent")).clazz("pico-content").clazz(e("modalClass", "")).stylize({
                            display: "none",
                            position: "fixed",
                            zIndex: 10001,
                            left: "50%",
                            top: "38.1966%",
                            maxHeight: "90%",
                            boxSizing: "border-box",
                            width: t,
                            "-ms-transform": "translate(-50%,-38.1966%)",
                            "-moz-transform": "translate(-50%,-38.1966%)",
                            "-webkit-transform": "translate(-50%,-38.1966%)",
                            "-o-transform": "translate(-50%,-38.1966%)",
                            transform: "translate(-50%,-38.1966%)"
                        }).stylize(e("modalStyles", {
                            overflow: "auto",
                            backgroundColor: "white",
                            padding: "20px",
                            borderRadius: "5px"
                        })).html(e("content")).attr("id", i).attr("role", "dialog").attr("aria-labelledby", e("ariaLabelledBy")).attr("aria-describedby", e("ariaDescribedBy", i)).onClick(function(e) {
                            var t = new r(e.target).anyAncestor(function(e) {
                                return /\bpico-close\b/.test(e.elem.className);
                            });
                            if (t) n();
                        });
                        return o;
                    }
                    function A(e, t) {
                        if (t("closeButton", true)) return e.child("button").html(t("closeHtml", "&#xD7;")).clazz("pico-close").clazz(t("closeClass", "")).stylize(t("closeStyles", {
                            borderRadius: "2px",
                            border: 0,
                            padding: 0,
                            cursor: "pointer",
                            height: "15px",
                            width: "15px",
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            fontSize: "16px",
                            textAlign: "center",
                            lineHeight: "15px",
                            background: "#CCC"
                        })).attr("aria-label", t("close-label", "Close"));
                    }
                    function w(e) {
                        return function() {
                            return e().elem;
                        };
                    }
                    var S = v(), c = v();
                    function x(r, s) {
                        function t(e, t) {
                            var n = e.msMatchesSelector || e.webkitMatchesSelector || e.matches;
                            return n.call(e, t);
                        }
                        function i(e) {
                            if (o(e) || t(e, ":disabled") || e.hasAttribute("contenteditable")) return false;
                            else return e.hasAttribute("tabindex") || t(e, "input,select,textarea,button,a[href],area[href],iframe");
                        }
                        function a(e) {
                            var t = e.getElementsByTagName("*");
                            for(var n = 0; n < t.length; n++)if (i(t[n])) return t[n];
                        }
                        function l(e) {
                            var t = e.getElementsByTagName("*");
                            for(var n = t.length; n--;)if (i(t[n])) return t[n];
                        }
                        var n;
                        r.beforeShow(function e() {
                            n = document.activeElement;
                        });
                        r.afterShow(function e() {
                            if (s()) {
                                var t = a(r.modalElem());
                                if (t) t.focus();
                            }
                        });
                        r.afterClose(function e() {
                            if (s() && n) n.focus();
                            n = null;
                        });
                        c.watch(function e(t) {
                            if (s() && r.isVisible()) {
                                var n = a(r.modalElem());
                                var i = l(r.modalElem());
                                var o = t.shiftKey ? n : i;
                                if (o === document.activeElement) {
                                    (t.shiftKey ? i : n).focus();
                                    t.preventDefault();
                                }
                            }
                        });
                    }
                    function k(e, t) {
                        var n;
                        var i = new r(document.body);
                        e.beforeShow(function() {
                            n = i.elem.style.overflow;
                            if (t()) i.stylize({
                                overflow: "hidden"
                            });
                        });
                        e.afterClose(function() {
                            i.stylize({
                                overflow: n
                            });
                        });
                    }
                    return document.documentElement.addEventListener("keydown", function e(t) {
                        var n = t.which || t.keyCode;
                        if (n === 27) S.trigger();
                        else if (n === 9) c.trigger(t);
                    }), function e(i) {
                        if (y(i) || C(i)) i = {
                            content: i
                        };
                        var o = v();
                        var t = v();
                        var n = v();
                        var r = v();
                        var s = v();
                        function a(e, t) {
                            var n = i[e];
                            if (typeof n === "function") n = n(t);
                            return n === undefined ? t : n;
                        }
                        var l = f.bind(window, "modal");
                        var c = f.bind(window, "overlay");
                        var h = f.bind(window, "close");
                        var d;
                        function u(e) {
                            c().hide();
                            l().hide();
                            s.trigger(d, e);
                        }
                        function g(e) {
                            if (r.trigger(d, e)) u(e);
                        }
                        function p(e) {
                            return function() {
                                e.apply(this, arguments);
                                return d;
                            };
                        }
                        var m;
                        function f(e, t) {
                            if (!m) {
                                var n = b(a, g);
                                m = {
                                    modal: n,
                                    overlay: I(a, g),
                                    close: A(n, a)
                                };
                                o.trigger(d, t);
                            }
                            return m[e];
                        }
                        d = {
                            modalElem: w(l),
                            closeElem: w(h),
                            overlayElem: w(c),
                            buildDom: p(f.bind(null, null)),
                            isVisible: function() {
                                return !!(m && l && l().isVisible());
                            },
                            show: function(e) {
                                if (t.trigger(d, e)) {
                                    c().show();
                                    h();
                                    l().show();
                                    n.trigger(d, e);
                                }
                                return this;
                            },
                            close: p(g),
                            forceClose: p(u),
                            destroy: function() {
                                l().destroy();
                                c().destroy();
                                c = l = h = undefined;
                            },
                            options: function(t) {
                                Object.keys(t).map(function(e) {
                                    i[e] = t[e];
                                });
                            },
                            afterCreate: p(o.watch),
                            beforeShow: p(t.watch),
                            afterShow: p(n.watch),
                            beforeClose: p(r.watch),
                            afterClose: p(s.watch)
                        };
                        x(d, a.bind(null, "focus", true));
                        k(d, a.bind(null, "bodyOverflow", true));
                        S.watch(function e() {
                            if (a("escCloses", true) && d.isVisible()) d.close();
                        });
                        return d;
                    };
                }) ? n.apply(t, i) : n) && (e.exports = i);
            }();
        },
        7533: function(e, t) {
            /** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */ !function(e) {
                "use strict";
                function he() {
                    for(var e = arguments.length, t = Array(e), n = 0; n < e; n++)t[n] = arguments[n];
                    if (t.length > 1) {
                        t[0] = t[0].slice(0, -1);
                        var i = t.length - 1;
                        for(var o = 1; o < i; ++o)t[o] = t[o].slice(1, -1);
                        t[i] = t[i].slice(1);
                        return t.join("");
                    } else return t[0];
                }
                function de(e) {
                    return "(?:" + e + ")";
                }
                function i(e) {
                    return e === undefined ? "undefined" : e === null ? "null" : Object.prototype.toString.call(e).split(" ").pop().split("]").shift().toLowerCase();
                }
                function p(e) {
                    return e.toUpperCase();
                }
                function b(e) {
                    return e !== undefined && e !== null ? e instanceof Array ? e : typeof e.length !== "number" || e.split || e.setInterval || e.call ? [
                        e
                    ] : Array.prototype.slice.call(e) : [];
                }
                function x(e, t) {
                    var n = e;
                    if (t) for(var i in t)n[i] = t[i];
                    return n;
                }
                function t(e) {
                    var t = "[A-Za-z]", W = "[\\x0D]", n = "[0-9]", H = "[\\x22]", i = he(n, "[A-Fa-f]"), G = "[\\x0A]", P = "[\\x20]", o = de(de("%[EFef]" + i + "%" + i + i + "%" + i + i) + "|" + de("%[89A-Fa-f]" + i + "%" + i + i) + "|" + de("%" + i + i)), r = "[\\:\\/\\?\\#\\[\\]\\@]", s = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", a = he(r, s), l = e ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", c = e ? "[\\uE000-\\uF8FF]" : "[]", h = he(t, n, "[\\-\\.\\_\\~]", l), d = de(t + he(t, n, "[\\+\\-\\.]") + "*"), u = de(de(o + "|" + he(h, s, "[\\:]")) + "*"), F = de(de("25[0-5]") + "|" + de("2[0-4]" + n) + "|" + de("1" + n + n) + "|" + de("[1-9]" + n) + "|" + n), g = de(de("25[0-5]") + "|" + de("2[0-4]" + n) + "|" + de("1" + n + n) + "|" + de("0?[1-9]" + n) + "|0?0?" + n), p = de(g + "\\." + g + "\\." + g + "\\." + g), m = de(i + "{1,4}"), f = de(de(m + "\\:" + m) + "|" + p), C = de(de(m + "\\:") + "{6}" + f), y = de("\\:\\:" + de(m + "\\:") + "{5}" + f), v = de(de(m) + "?\\:\\:" + de(m + "\\:") + "{4}" + f), V = de(de(de(m + "\\:") + "{0,1}" + m) + "?\\:\\:" + de(m + "\\:") + "{3}" + f), Z = de(de(de(m + "\\:") + "{0,2}" + m) + "?\\:\\:" + de(m + "\\:") + "{2}" + f), O = de(de(de(m + "\\:") + "{0,3}" + m) + "?\\:\\:" + m + "\\:" + f), D = de(de(de(m + "\\:") + "{0,4}" + m) + "?\\:\\:" + f), K = de(de(de(m + "\\:") + "{0,5}" + m) + "?\\:\\:" + m), j = de(de(de(m + "\\:") + "{0,6}" + m) + "?\\:\\:"), I = de([
                        C,
                        y,
                        v,
                        V,
                        Z,
                        O,
                        D,
                        K,
                        j
                    ].join("|")), b = de(de(h + "|" + o) + "+"), z = de(I + "\\%25" + b), X = de(I + de("\\%25|\\%(?!" + i + "{2})") + b), Y = de("[vV]" + i + "+\\." + he(h, s, "[\\:]") + "+"), J = de("\\[" + de(X + "|" + I + "|" + Y) + "\\]"), A = de(de(o + "|" + he(h, s)) + "*"), w = de(J + "|" + p + "(?!" + A + ")" + "|" + A), S = de(n + "*"), x = de(de(u + "@") + "?" + w + de("\\:" + S) + "?"), k = de(o + "|" + he(h, s, "[\\:\\@]")), U = de(k + "*"), E = de(k + "+"), Q = de(de(o + "|" + he(h, s, "[\\@]")) + "+"), T = de(de("\\/" + U) + "*"), R = de("\\/" + de(E + T) + "?"), _ = de(Q + T), $ = de(E + T), L = "(?!" + k + ")", q = de(T + "|" + R + "|" + _ + "|" + $ + "|" + L), N = de(de(k + "|" + he("[\\/\\?]", c)) + "*"), B = de(de(k + "|[\\/\\?]") + "*"), M = de(de("\\/\\/" + x + T) + "|" + R + "|" + $ + "|" + L), ee = de(d + "\\:" + M + de("\\?" + N) + "?" + de("\\#" + B) + "?"), te = de(de("\\/\\/" + x + T) + "|" + R + "|" + _ + "|" + L), ne = de(te + de("\\?" + N) + "?" + de("\\#" + B) + "?"), ie = de(ee + "|" + ne), oe = de(d + "\\:" + M + de("\\?" + N) + "?"), re = "^(" + d + ")\\:" + de(de("\\/\\/(" + de("(" + u + ")@") + "?(" + w + ")" + de("\\:(" + S + ")") + "?)") + "?(" + T + "|" + R + "|" + $ + "|" + L + ")") + de("\\?(" + N + ")") + "?" + de("\\#(" + B + ")") + "?$", se = "^(){0}" + de(de("\\/\\/(" + de("(" + u + ")@") + "?(" + w + ")" + de("\\:(" + S + ")") + "?)") + "?(" + T + "|" + R + "|" + _ + "|" + L + ")") + de("\\?(" + N + ")") + "?" + de("\\#(" + B + ")") + "?$", ae = "^(" + d + ")\\:" + de(de("\\/\\/(" + de("(" + u + ")@") + "?(" + w + ")" + de("\\:(" + S + ")") + "?)") + "?(" + T + "|" + R + "|" + $ + "|" + L + ")") + de("\\?(" + N + ")") + "?$", le = "^" + de("\\#(" + B + ")") + "?$", ce = "^" + de("(" + u + ")@") + "?(" + w + ")" + de("\\:(" + S + ")") + "?$";
                    return {
                        NOT_SCHEME: new RegExp(he("[^]", t, n, "[\\+\\-\\.]"), "g"),
                        NOT_USERINFO: new RegExp(he("[^\\%\\:]", h, s), "g"),
                        NOT_HOST: new RegExp(he("[^\\%\\[\\]\\:]", h, s), "g"),
                        NOT_PATH: new RegExp(he("[^\\%\\/\\:\\@]", h, s), "g"),
                        NOT_PATH_NOSCHEME: new RegExp(he("[^\\%\\/\\@]", h, s), "g"),
                        NOT_QUERY: new RegExp(he("[^\\%]", h, s, "[\\:\\@\\/\\?]", c), "g"),
                        NOT_FRAGMENT: new RegExp(he("[^\\%]", h, s, "[\\:\\@\\/\\?]"), "g"),
                        ESCAPE: new RegExp(he("[^]", h, s), "g"),
                        UNRESERVED: new RegExp(h, "g"),
                        OTHER_CHARS: new RegExp(he("[^\\%]", h, a), "g"),
                        PCT_ENCODED: new RegExp(o, "g"),
                        IPV4ADDRESS: new RegExp("^(" + p + ")$"),
                        IPV6ADDRESS: new RegExp("^\\[?(" + I + ")" + de(de("\\%25|\\%(?!" + i + "{2})") + "(" + b + ")") + "?\\]?$")
                    };
                }
                var a = t(false), l = t(true), A = function() {
                    function n(e, t) {
                        var n = [];
                        var i = true;
                        var o = false;
                        var r = undefined;
                        try {
                            for(var s = e[Symbol.iterator](), a; !(i = (a = s.next()).done); i = true){
                                n.push(a.value);
                                if (t && n.length === t) break;
                            }
                        } catch (e) {
                            o = true;
                            r = e;
                        } finally{
                            try {
                                if (!i && s["return"]) s["return"]();
                            } finally{
                                if (o) throw r;
                            }
                        }
                        return n;
                    }
                    return function(e, t) {
                        if (Array.isArray(e)) return e;
                        else if (Symbol.iterator in Object(e)) return n(e, t);
                        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    };
                }(), k = function(e) {
                    if (Array.isArray(e)) {
                        for(var t = 0, n = Array(e.length); t < e.length; t++)n[t] = e[t];
                        return n;
                    } else return Array.from(e);
                }, B = 2147483647, M = 36, W = 1, H = 26, E = 38, T = 700, G = 72, P = 128, F = "-", R = /^xn--/, _ = /[^\0-\x7E]/, $ = /[\x2E\u3002\uFF0E\uFF61]/g, L = {
                    overflow: "Overflow: input needs wider integers to process",
                    "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                    "invalid-input": "Invalid input"
                }, r = M - W, V = Math.floor, Z = String.fromCharCode;
                function O(e) {
                    throw new RangeError(L[e]);
                }
                function N(e, t) {
                    var n = [];
                    var i = e.length;
                    while(i--)n[i] = t(e[i]);
                    return n;
                }
                function D(e, t) {
                    var n = e.split("@");
                    var i = "";
                    if (n.length > 1) {
                        i = n[0] + "@";
                        e = n[1];
                    }
                    e = e.replace($, ".");
                    var o = e.split(".");
                    var r = N(o, t).join(".");
                    return i + r;
                }
                function K(e) {
                    var t = [];
                    var n = 0;
                    var i = e.length;
                    while(n < i){
                        var o = e.charCodeAt(n++);
                        if (o >= 55296 && o <= 56319 && n < i) {
                            var r = e.charCodeAt(n++);
                            if ((r & 64512) == 56320) t.push(((o & 1023) << 10) + (r & 1023) + 65536);
                            else {
                                t.push(o);
                                n--;
                            }
                        } else t.push(o);
                    }
                    return t;
                }
                var j, z = function e(t) {
                    if (t - 48 < 10) return t - 22;
                    if (t - 65 < 26) return t - 65;
                    if (t - 97 < 26) return t - 97;
                    return M;
                }, X = function e(t, n) {
                    return t + 22 + 75 * (t < 26) - ((n != 0) << 5);
                }, Y = function e(t, n, i) {
                    var o = 0;
                    t = i ? V(t / T) : t >> 1;
                    t += V(t / n);
                    for(; t > r * H >> 1; o += M)t = V(t / r);
                    return V(o + (r + 1) * t / (t + E));
                }, J = function e(t) {
                    var n = [];
                    var i = t.length;
                    var o = 0;
                    var r = P;
                    var s = G;
                    var a = t.lastIndexOf(F);
                    if (a < 0) a = 0;
                    for(var l = 0; l < a; ++l){
                        if (t.charCodeAt(l) >= 128) O("not-basic");
                        n.push(t.charCodeAt(l));
                    }
                    for(var c = a > 0 ? a + 1 : 0; c < i;){
                        var h = o;
                        for(var d = 1, u = M;; u += M){
                            if (c >= i) O("invalid-input");
                            var g = z(t.charCodeAt(c++));
                            if (g >= M || g > V((B - o) / d)) O("overflow");
                            o += g * d;
                            var p = u <= s ? W : u >= s + H ? H : u - s;
                            if (g < p) break;
                            var m = M - p;
                            if (d > V(B / m)) O("overflow");
                            d *= m;
                        }
                        var f = n.length + 1;
                        s = Y(o - h, f, h == 0);
                        if (V(o / f) > B - r) O("overflow");
                        r += V(o / f);
                        o %= f;
                        n.splice(o++, 0, r);
                    }
                    return String.fromCodePoint.apply(String, n);
                }, U = function e(t) {
                    var n = [];
                    t = K(t);
                    var i = t.length;
                    var o = P;
                    var r = 0;
                    var s = G;
                    var a = true;
                    var l = false;
                    var c = undefined;
                    try {
                        for(var h = t[Symbol.iterator](), d; !(a = (d = h.next()).done); a = true){
                            var u = d.value;
                            if (u < 128) n.push(Z(u));
                        }
                    } catch (e) {
                        l = true;
                        c = e;
                    } finally{
                        try {
                            if (!a && h.return) h.return();
                        } finally{
                            if (l) throw c;
                        }
                    }
                    var g = n.length;
                    var p = g;
                    if (g) n.push(F);
                    while(p < i){
                        var m = B;
                        var f = true;
                        var C = false;
                        var y = undefined;
                        try {
                            for(var v = t[Symbol.iterator](), I; !(f = (I = v.next()).done); f = true){
                                var b = I.value;
                                if (b >= o && b < m) m = b;
                            }
                        } catch (e) {
                            C = true;
                            y = e;
                        } finally{
                            try {
                                if (!f && v.return) v.return();
                            } finally{
                                if (C) throw y;
                            }
                        }
                        var A = p + 1;
                        if (m - o > V((B - r) / A)) O("overflow");
                        r += (m - o) * A;
                        o = m;
                        var w = true;
                        var S = false;
                        var x = undefined;
                        try {
                            for(var k = t[Symbol.iterator](), E; !(w = (E = k.next()).done); w = true){
                                var T = E.value;
                                if (T < o && ++r > B) O("overflow");
                                if (T == o) {
                                    var R = r;
                                    for(var _ = M;; _ += M){
                                        var $ = _ <= s ? W : _ >= s + H ? H : _ - s;
                                        if (R < $) break;
                                        var L = R - $;
                                        var N = M - $;
                                        n.push(Z(X($ + L % N, 0)));
                                        R = V(L / N);
                                    }
                                    n.push(Z(X(R, 0)));
                                    s = Y(r, A, p == g);
                                    r = 0;
                                    ++p;
                                }
                            }
                        } catch (e) {
                            S = true;
                            x = e;
                        } finally{
                            try {
                                if (!w && k.return) k.return();
                            } finally{
                                if (S) throw x;
                            }
                        }
                        ++r;
                        ++o;
                    }
                    return n.join("");
                }, Q, q, C = {
                    version: "2.1.0",
                    ucs2: {
                        decode: K,
                        encode: function e(t) {
                            return String.fromCodePoint.apply(String, k(t));
                        }
                    },
                    decode: J,
                    encode: U,
                    toASCII: function e(t) {
                        return D(t, function(e) {
                            return _.test(e) ? "xn--" + U(e) : e;
                        });
                    },
                    toUnicode: function e(t) {
                        return D(t, function(e) {
                            return R.test(e) ? J(e.slice(4).toLowerCase()) : e;
                        });
                    }
                }, h = {};
                function m(e) {
                    var t = e.charCodeAt(0);
                    var n = void 0;
                    if (t < 16) n = "%0" + t.toString(16).toUpperCase();
                    else if (t < 128) n = "%" + t.toString(16).toUpperCase();
                    else if (t < 2048) n = "%" + (t >> 6 | 192).toString(16).toUpperCase() + "%" + (t & 63 | 128).toString(16).toUpperCase();
                    else n = "%" + (t >> 12 | 224).toString(16).toUpperCase() + "%" + (t >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (t & 63 | 128).toString(16).toUpperCase();
                    return n;
                }
                function c(e) {
                    var t = "";
                    var n = 0;
                    var i = e.length;
                    while(n < i){
                        var o = parseInt(e.substr(n + 1, 2), 16);
                        if (o < 128) {
                            t += String.fromCharCode(o);
                            n += 3;
                        } else if (o >= 194 && o < 224) {
                            if (i - n >= 6) {
                                var r = parseInt(e.substr(n + 4, 2), 16);
                                t += String.fromCharCode((o & 31) << 6 | r & 63);
                            } else t += e.substr(n, 6);
                            n += 6;
                        } else if (o >= 224) {
                            if (i - n >= 9) {
                                var s = parseInt(e.substr(n + 4, 2), 16);
                                var a = parseInt(e.substr(n + 7, 2), 16);
                                t += String.fromCharCode((o & 15) << 12 | (s & 63) << 6 | a & 63);
                            } else t += e.substr(n, 9);
                            n += 9;
                        } else {
                            t += e.substr(n, 3);
                            n += 3;
                        }
                    }
                    return t;
                }
                function d(e, n) {
                    function t(e) {
                        var t = c(e);
                        return !t.match(n.UNRESERVED) ? e : t;
                    }
                    if (e.scheme) e.scheme = String(e.scheme).replace(n.PCT_ENCODED, t).toLowerCase().replace(n.NOT_SCHEME, "");
                    if (e.userinfo !== undefined) e.userinfo = String(e.userinfo).replace(n.PCT_ENCODED, t).replace(n.NOT_USERINFO, m).replace(n.PCT_ENCODED, p);
                    if (e.host !== undefined) e.host = String(e.host).replace(n.PCT_ENCODED, t).toLowerCase().replace(n.NOT_HOST, m).replace(n.PCT_ENCODED, p);
                    if (e.path !== undefined) e.path = String(e.path).replace(n.PCT_ENCODED, t).replace(e.scheme ? n.NOT_PATH : n.NOT_PATH_NOSCHEME, m).replace(n.PCT_ENCODED, p);
                    if (e.query !== undefined) e.query = String(e.query).replace(n.PCT_ENCODED, t).replace(n.NOT_QUERY, m).replace(n.PCT_ENCODED, p);
                    if (e.fragment !== undefined) e.fragment = String(e.fragment).replace(n.PCT_ENCODED, t).replace(n.NOT_FRAGMENT, m).replace(n.PCT_ENCODED, p);
                    return e;
                }
                function w(e) {
                    return e.replace(/^0*(.*)/, "$1") || "0";
                }
                function S(e, t) {
                    var n = e.match(t.IPV4ADDRESS) || [];
                    var i = A(n, 2), o = i[1];
                    if (o) return o.split(".").map(w).join(".");
                    else return e;
                }
                function ee(e, t) {
                    var n = e.match(t.IPV6ADDRESS) || [];
                    var i = A(n, 3), o = i[1], r = i[2];
                    if (o) {
                        var s = o.toLowerCase().split("::").reverse(), a = A(s, 2), l = a[0], c = a[1];
                        var h = c ? c.split(":").map(w) : [];
                        var d = l.split(":").map(w);
                        var u = t.IPV4ADDRESS.test(d[d.length - 1]);
                        var g = u ? 7 : 8;
                        var p = d.length - g;
                        var m = Array(g);
                        for(var f = 0; f < g; ++f)m[f] = h[f] || d[p + f] || "";
                        if (u) m[g - 1] = S(m[g - 1], t);
                        var C = m.reduce(function(e, t, n) {
                            if (!t || t === "0") {
                                var i = e[e.length - 1];
                                if (i && i.index + i.length === n) i.length++;
                                else e.push({
                                    index: n,
                                    length: 1
                                });
                            }
                            return e;
                        }, []);
                        var y = C.sort(function(e, t) {
                            return t.length - e.length;
                        })[0];
                        var v = void 0;
                        if (y && y.length > 1) {
                            var I = m.slice(0, y.index);
                            var b = m.slice(y.index + y.length);
                            v = I.join(":") + "::" + b.join(":");
                        } else v = m.join(":");
                        if (r) v += "%" + r;
                        return v;
                    } else return e;
                }
                var te = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i, ne = "".match(/(){0}/)[1] === undefined;
                function s(e) {
                    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    var n = {};
                    var i = t.iri !== false ? l : a;
                    if (t.reference === "suffix") e = (t.scheme ? t.scheme + ":" : "") + "//" + e;
                    var o = e.match(te);
                    if (o) {
                        if (ne) {
                            n.scheme = o[1];
                            n.userinfo = o[3];
                            n.host = o[4];
                            n.port = parseInt(o[5], 10);
                            n.path = o[6] || "";
                            n.query = o[7];
                            n.fragment = o[8];
                            if (isNaN(n.port)) n.port = o[5];
                        } else {
                            n.scheme = o[1] || undefined;
                            n.userinfo = e.indexOf("@") !== -1 ? o[3] : undefined;
                            n.host = e.indexOf("//") !== -1 ? o[4] : undefined;
                            n.port = parseInt(o[5], 10);
                            n.path = o[6] || "";
                            n.query = e.indexOf("?") !== -1 ? o[7] : undefined;
                            n.fragment = e.indexOf("#") !== -1 ? o[8] : undefined;
                            if (isNaN(n.port)) n.port = e.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? o[4] : undefined;
                        }
                        if (n.host) n.host = ee(S(n.host, i), i);
                        if (n.scheme === undefined && n.userinfo === undefined && n.host === undefined && n.port === undefined && !n.path && n.query === undefined) n.reference = "same-document";
                        else if (n.scheme === undefined) n.reference = "relative";
                        else if (n.fragment === undefined) n.reference = "absolute";
                        else n.reference = "uri";
                        if (t.reference && t.reference !== "suffix" && t.reference !== n.reference) n.error = n.error || "URI is not a " + t.reference + " reference.";
                        var r = h[(t.scheme || n.scheme || "").toLowerCase()];
                        if (!t.unicodeSupport && (!r || !r.unicodeSupport)) {
                            if (n.host && (t.domainHost || r && r.domainHost)) try {
                                n.host = C.toASCII(n.host.replace(i.PCT_ENCODED, c).toLowerCase());
                            } catch (e) {
                                n.error = n.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                            }
                            d(n, a);
                        } else d(n, i);
                        if (r && r.parse) r.parse(n, t);
                    } else n.error = n.error || "URI can not be parsed.";
                    return n;
                }
                function ie(e, t) {
                    var n = t.iri !== false ? l : a;
                    var i = [];
                    if (e.userinfo !== undefined) {
                        i.push(e.userinfo);
                        i.push("@");
                    }
                    if (e.host !== undefined) i.push(ee(S(String(e.host), n), n).replace(n.IPV6ADDRESS, function(e, t, n) {
                        return "[" + t + (n ? "%25" + n : "") + "]";
                    }));
                    if (typeof e.port === "number" || typeof e.port === "string") {
                        i.push(":");
                        i.push(String(e.port));
                    }
                    return i.length ? i.join("") : undefined;
                }
                var oe = /^\.\.?\//, re = /^\/\.(\/|$)/, se = /^\/\.\.(\/|$)/, ae = /^\/?(?:.|\n)*?(?=\/|$)/;
                function u(e) {
                    var t = [];
                    while(e.length)if (e.match(oe)) e = e.replace(oe, "");
                    else if (e.match(re)) e = e.replace(re, "/");
                    else if (e.match(se)) {
                        e = e.replace(se, "/");
                        t.pop();
                    } else if (e === "." || e === "..") e = "";
                    else {
                        var n = e.match(ae);
                        if (n) {
                            var i = n[0];
                            e = e.slice(i.length);
                            t.push(i);
                        } else throw new Error("Unexpected dot segment condition");
                    }
                    return t.join("");
                }
                function g(t) {
                    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    var e = n.iri ? l : a;
                    var i = [];
                    var o = h[(n.scheme || t.scheme || "").toLowerCase()];
                    if (o && o.serialize) o.serialize(t, n);
                    if (t.host) {
                        if (e.IPV6ADDRESS.test(t.host)) ;
                        else if (n.domainHost || o && o.domainHost) try {
                            t.host = !n.iri ? C.toASCII(t.host.replace(e.PCT_ENCODED, c).toLowerCase()) : C.toUnicode(t.host);
                        } catch (e) {
                            t.error = t.error || "Host's domain name can not be converted to " + (!n.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                        }
                    }
                    d(t, e);
                    if (n.reference !== "suffix" && t.scheme) {
                        i.push(t.scheme);
                        i.push(":");
                    }
                    var r = ie(t, n);
                    if (r !== undefined) {
                        if (n.reference !== "suffix") i.push("//");
                        i.push(r);
                        if (t.path && t.path.charAt(0) !== "/") i.push("/");
                    }
                    if (t.path !== undefined) {
                        var s = t.path;
                        if (!n.absolutePath && (!o || !o.absolutePath)) s = u(s);
                        if (r === undefined) s = s.replace(/^\/\//, "/%2F");
                        i.push(s);
                    }
                    if (t.query !== undefined) {
                        i.push("?");
                        i.push(t.query);
                    }
                    if (t.fragment !== undefined) {
                        i.push("#");
                        i.push(t.fragment);
                    }
                    return i.join("");
                }
                function le(e, t) {
                    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                    var i = arguments[3];
                    var o = {};
                    if (!i) {
                        e = s(g(e, n), n);
                        t = s(g(t, n), n);
                    }
                    n = n || {};
                    if (!n.tolerant && t.scheme) {
                        o.scheme = t.scheme;
                        o.userinfo = t.userinfo;
                        o.host = t.host;
                        o.port = t.port;
                        o.path = u(t.path || "");
                        o.query = t.query;
                    } else {
                        if (t.userinfo !== undefined || t.host !== undefined || t.port !== undefined) {
                            o.userinfo = t.userinfo;
                            o.host = t.host;
                            o.port = t.port;
                            o.path = u(t.path || "");
                            o.query = t.query;
                        } else {
                            if (!t.path) {
                                o.path = e.path;
                                if (t.query !== undefined) o.query = t.query;
                                else o.query = e.query;
                            } else {
                                if (t.path.charAt(0) === "/") o.path = u(t.path);
                                else {
                                    if ((e.userinfo !== undefined || e.host !== undefined || e.port !== undefined) && !e.path) o.path = "/" + t.path;
                                    else if (!e.path) o.path = t.path;
                                    else o.path = e.path.slice(0, e.path.lastIndexOf("/") + 1) + t.path;
                                    o.path = u(o.path);
                                }
                                o.query = t.query;
                            }
                            o.userinfo = e.userinfo;
                            o.host = e.host;
                            o.port = e.port;
                        }
                        o.scheme = e.scheme;
                    }
                    o.fragment = t.fragment;
                    return o;
                }
                function ce(e, t, n) {
                    var i = x({
                        scheme: "null"
                    }, n);
                    return g(le(s(e, i), s(t, i), i, true), i);
                }
                function ue(e, t) {
                    if (typeof e === "string") e = g(s(e, t), t);
                    else if (i(e) === "object") e = s(g(e, t), t);
                    return e;
                }
                function ge(e, t, n) {
                    if (typeof e === "string") e = g(s(e, n), n);
                    else if (i(e) === "object") e = g(e, n);
                    if (typeof t === "string") t = g(s(t, n), n);
                    else if (i(t) === "object") t = g(t, n);
                    return e === t;
                }
                function pe(e, t) {
                    return e && e.toString().replace(!t || !t.iri ? a.ESCAPE : l.ESCAPE, m);
                }
                function y(e, t) {
                    return e && e.toString().replace(!t || !t.iri ? a.PCT_ENCODED : l.PCT_ENCODED, c);
                }
                var n = {
                    scheme: "http",
                    domainHost: true,
                    parse: function e(t, n) {
                        if (!t.host) t.error = t.error || "HTTP URIs must have a host.";
                        return t;
                    },
                    serialize: function e(t, n) {
                        var i = String(t.scheme).toLowerCase() === "https";
                        if (t.port === (i ? 443 : 80) || t.port === "") t.port = undefined;
                        if (!t.path) t.path = "/";
                        return t;
                    }
                }, me = {
                    scheme: "https",
                    domainHost: n.domainHost,
                    parse: n.parse,
                    serialize: n.serialize
                };
                function fe(e) {
                    return typeof e.secure === "boolean" ? e.secure : String(e.scheme).toLowerCase() === "wss";
                }
                var o = {
                    scheme: "ws",
                    domainHost: true,
                    parse: function e(t, n) {
                        var i = t;
                        i.secure = fe(i);
                        i.resourceName = (i.path || "/") + (i.query ? "?" + i.query : "");
                        i.path = undefined;
                        i.query = undefined;
                        return i;
                    },
                    serialize: function e(t, n) {
                        if (t.port === (fe(t) ? 443 : 80) || t.port === "") t.port = undefined;
                        if (typeof t.secure === "boolean") {
                            t.scheme = t.secure ? "wss" : "ws";
                            t.secure = undefined;
                        }
                        if (t.resourceName) {
                            var i = t.resourceName.split("?"), o = A(i, 2), r = o[0], s = o[1];
                            t.path = r && r !== "/" ? r : undefined;
                            t.query = s;
                            t.resourceName = undefined;
                        }
                        t.fragment = undefined;
                        return t;
                    }
                }, Ce = {
                    scheme: "wss",
                    domainHost: o.domainHost,
                    parse: o.parse,
                    serialize: o.serialize
                }, ye = {}, ve, Ie = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]", f = "[0-9A-Fa-f]", be = de(de("%[EFef]" + f + "%" + f + f + "%" + f + f) + "|" + de("%[89A-Fa-f]" + f + "%" + f + f) + "|" + de("%" + f + f)), Ae = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]", we, Se = he("[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]", '[\\"\\\\]'), xe = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]", ke = new RegExp(Ie, "g"), v = new RegExp(be, "g"), Ee = new RegExp(he("[^]", Ae, "[\\.]", '[\\"]', Se), "g"), Te = new RegExp(he("[^]", Ie, xe), "g"), Re = Te;
                function I(e) {
                    var t = c(e);
                    return !t.match(ke) ? e : t;
                }
                var _e = {
                    scheme: "mailto",
                    parse: function e(t, n) {
                        var i = t;
                        var o = i.to = i.path ? i.path.split(",") : [];
                        i.path = undefined;
                        if (i.query) {
                            var r = false;
                            var s = {};
                            var a = i.query.split("&");
                            for(var l = 0, c = a.length; l < c; ++l){
                                var h = a[l].split("=");
                                switch(h[0]){
                                    case "to":
                                        var d = h[1].split(",");
                                        for(var u = 0, g = d.length; u < g; ++u)o.push(d[u]);
                                        break;
                                    case "subject":
                                        i.subject = y(h[1], n);
                                        break;
                                    case "body":
                                        i.body = y(h[1], n);
                                        break;
                                    default:
                                        r = true;
                                        s[y(h[0], n)] = y(h[1], n);
                                        break;
                                }
                            }
                            if (r) i.headers = s;
                        }
                        i.query = undefined;
                        for(var p = 0, m = o.length; p < m; ++p){
                            var f = o[p].split("@");
                            f[0] = y(f[0]);
                            if (!n.unicodeSupport) try {
                                f[1] = C.toASCII(y(f[1], n).toLowerCase());
                            } catch (e) {
                                i.error = i.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                            }
                            else f[1] = y(f[1], n).toLowerCase();
                            o[p] = f.join("@");
                        }
                        return i;
                    },
                    serialize: function e(t, n) {
                        var i = t;
                        var o = b(t.to);
                        if (o) {
                            for(var r = 0, s = o.length; r < s; ++r){
                                var a = String(o[r]);
                                var l = a.lastIndexOf("@");
                                var c = a.slice(0, l).replace(v, I).replace(v, p).replace(Ee, m);
                                var h = a.slice(l + 1);
                                try {
                                    h = !n.iri ? C.toASCII(y(h, n).toLowerCase()) : C.toUnicode(h);
                                } catch (e) {
                                    i.error = i.error || "Email address's domain name can not be converted to " + (!n.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                                }
                                o[r] = c + "@" + h;
                            }
                            i.path = o.join(",");
                        }
                        var d = t.headers = t.headers || {};
                        if (t.subject) d["subject"] = t.subject;
                        if (t.body) d["body"] = t.body;
                        var u = [];
                        for(var g in d)if (d[g] !== ye[g]) u.push(g.replace(v, I).replace(v, p).replace(Te, m) + "=" + d[g].replace(v, I).replace(v, p).replace(Re, m));
                        if (u.length) i.query = u.join("&");
                        return i;
                    }
                }, $e = /^([^\:]+)\:(.*)/, Le = {
                    scheme: "urn",
                    parse: function e(t, n) {
                        var i = t.path && t.path.match($e);
                        var o = t;
                        if (i) {
                            var r = n.scheme || o.scheme || "urn";
                            var s = i[1].toLowerCase();
                            var a = i[2];
                            var l = r + ":" + (n.nid || s);
                            var c = h[l];
                            o.nid = s;
                            o.nss = a;
                            o.path = undefined;
                            if (c) o = c.parse(o, n);
                        } else o.error = o.error || "URN can not be parsed.";
                        return o;
                    },
                    serialize: function e(t, n) {
                        var i = n.scheme || t.scheme || "urn";
                        var o = t.nid;
                        var r = i + ":" + (n.nid || o);
                        var s = h[r];
                        if (s) t = s.serialize(t, n);
                        var a = t;
                        var l = t.nss;
                        a.path = (o || n.nid) + ":" + l;
                        return a;
                    }
                }, Ne = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/, Be = {
                    scheme: "urn:uuid",
                    parse: function e(t, n) {
                        var i = t;
                        i.uuid = i.nss;
                        i.nss = undefined;
                        if (!n.tolerant && (!i.uuid || !i.uuid.match(Ne))) i.error = i.error || "UUID is not valid.";
                        return i;
                    },
                    serialize: function e(t, n) {
                        var i = t;
                        i.nss = (t.uuid || "").toLowerCase();
                        return i;
                    }
                };
                h[n.scheme] = n, h[me.scheme] = me, h[o.scheme] = o, h[Ce.scheme] = Ce, h[_e.scheme] = _e, h[Le.scheme] = Le, h[Be.scheme] = Be, e.SCHEMES = h, e.pctEncChar = m, e.pctDecChars = c, e.parse = s, e.removeDotSegments = u, e.serialize = g, e.resolveComponents = le, e.resolve = ce, e.normalize = ue, e.equal = ge, e.escapeComponent = pe, e.unescapeComponent = y, Object.defineProperty(e, "__esModule", {
                    value: true
                });
            }(t);
        },
        4049: function(e) {
            e.exports = function() {
                "use strict";
                var s = function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }, e = function() {
                    function i(e, t) {
                        for(var n = 0; n < t.length; n++){
                            var i = t[n];
                            i.enumerable = i.enumerable || false;
                            i.configurable = true;
                            if ("value" in i) i.writable = true;
                            Object.defineProperty(e, i.key, i);
                        }
                    }
                    return function(e, t, n) {
                        if (t) i(e.prototype, t);
                        if (n) i(e, n);
                        return e;
                    };
                }(), m = function() {
                    function n(e, t) {
                        var n = [];
                        var i = true;
                        var o = false;
                        var r = undefined;
                        try {
                            for(var s = e[Symbol.iterator](), a; !(i = (a = s.next()).done); i = true){
                                n.push(a.value);
                                if (t && n.length === t) break;
                            }
                        } catch (e) {
                            o = true;
                            r = e;
                        } finally{
                            try {
                                if (!i && s["return"]) s["return"]();
                            } finally{
                                if (o) throw r;
                            }
                        }
                        return n;
                    }
                    return function(e, t) {
                        if (Array.isArray(e)) return e;
                        else if (Symbol.iterator in Object(e)) return n(e, t);
                        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    };
                }(), o = (String.prototype.startsWith = String.prototype.startsWith || function(e) {
                    return this.indexOf(e) === 0;
                }, String.prototype.padStart = String.prototype.padStart || function(e, t) {
                    var n = this;
                    while(n.length < e)n = t + n;
                    return n;
                }, {
                    cb: "0f8ff",
                    tqw: "aebd7",
                    q: "-ffff",
                    qmrn: "7fffd4",
                    zr: "0ffff",
                    bg: "5f5dc",
                    bsq: "e4c4",
                    bck: "---",
                    nch: "ebcd",
                    b: "--ff",
                    bvt: "8a2be2",
                    brwn: "a52a2a",
                    brw: "deb887",
                    ctb: "5f9ea0",
                    hrt: "7fff-",
                    chcT: "d2691e",
                    cr: "7f50",
                    rnw: "6495ed",
                    crns: "8dc",
                    crms: "dc143c",
                    cn: "-ffff",
                    Db: "--8b",
                    Dcn: "-8b8b",
                    Dgnr: "b8860b",
                    Dgr: "a9a9a9",
                    Dgrn: "-64-",
                    Dkhk: "bdb76b",
                    Dmgn: "8b-8b",
                    Dvgr: "556b2f",
                    Drng: "8c-",
                    Drch: "9932cc",
                    Dr: "8b--",
                    Dsmn: "e9967a",
                    Dsgr: "8fbc8f",
                    DsTb: "483d8b",
                    DsTg: "2f4f4f",
                    Dtrq: "-ced1",
                    Dvt: "94-d3",
                    ppnk: "1493",
                    pskb: "-bfff",
                    mgr: "696969",
                    grb: "1e90ff",
                    rbrc: "b22222",
                    rwht: "af0",
                    stg: "228b22",
                    chs: "-ff",
                    gnsb: "dcdcdc",
                    st: "8f8ff",
                    g: "d7-",
                    gnr: "daa520",
                    gr: "808080",
                    grn: "-8-0",
                    grnw: "adff2f",
                    hnw: "0fff0",
                    htpn: "69b4",
                    nnr: "cd5c5c",
                    ng: "4b-82",
                    vr: "0",
                    khk: "0e68c",
                    vnr: "e6e6fa",
                    nrb: "0f5",
                    wngr: "7cfc-",
                    mnch: "acd",
                    Lb: "add8e6",
                    Lcr: "08080",
                    Lcn: "e0ffff",
                    Lgnr: "afad2",
                    Lgr: "d3d3d3",
                    Lgrn: "90ee90",
                    Lpnk: "b6c1",
                    Lsmn: "a07a",
                    Lsgr: "20b2aa",
                    Lskb: "87cefa",
                    LsTg: "778899",
                    Lstb: "b0c4de",
                    Lw: "e0",
                    m: "-ff-",
                    mgrn: "32cd32",
                    nn: "af0e6",
                    mgnt: "-ff",
                    mrn: "8--0",
                    mqm: "66cdaa",
                    mmb: "--cd",
                    mmrc: "ba55d3",
                    mmpr: "9370db",
                    msg: "3cb371",
                    mmsT: "7b68ee",
                    "": "-fa9a",
                    mtr: "48d1cc",
                    mmvt: "c71585",
                    mnLb: "191970",
                    ntc: "5fffa",
                    mstr: "e4e1",
                    mccs: "e4b5",
                    vjw: "dead",
                    nv: "--80",
                    c: "df5e6",
                    v: "808-0",
                    vrb: "6b8e23",
                    rng: "a5-",
                    rngr: "45-",
                    rch: "da70d6",
                    pgnr: "eee8aa",
                    pgrn: "98fb98",
                    ptrq: "afeeee",
                    pvtr: "db7093",
                    ppwh: "efd5",
                    pchp: "dab9",
                    pr: "cd853f",
                    pnk: "c0cb",
                    pm: "dda0dd",
                    pwrb: "b0e0e6",
                    prp: "8-080",
                    cc: "663399",
                    r: "--",
                    sbr: "bc8f8f",
                    rb: "4169e1",
                    sbrw: "8b4513",
                    smn: "a8072",
                    nbr: "4a460",
                    sgrn: "2e8b57",
                    ssh: "5ee",
                    snn: "a0522d",
                    svr: "c0c0c0",
                    skb: "87ceeb",
                    sTb: "6a5acd",
                    sTgr: "708090",
                    snw: "afa",
                    n: "-ff7f",
                    stb: "4682b4",
                    tn: "d2b48c",
                    t: "-8080",
                    thst: "d8bfd8",
                    tmT: "6347",
                    trqs: "40e0d0",
                    vt: "ee82ee",
                    whT: "5deb3",
                    wht: "",
                    hts: "5f5f5",
                    w: "-",
                    wgrn: "9acd32"
                });
                function a(e) {
                    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
                    var n = t > 0 ? e.toFixed(t).replace(/0+$/, "").replace(/\.$/, "") : e.toString();
                    return n || "0";
                }
                var r = function() {
                    function p(e, t, n, i) {
                        s(this, p);
                        var g = this;
                        function o(e) {
                            if (e.startsWith("hsl")) {
                                var t = e.match(/([\-\d\.e]+)/g).map(Number), n = m(t, 4), i = n[0], o = n[1], r = n[2], s = n[3];
                                if (s === undefined) s = 1;
                                i /= 360;
                                o /= 100;
                                r /= 100;
                                g.hsla = [
                                    i,
                                    o,
                                    r,
                                    s
                                ];
                            } else if (e.startsWith("rgb")) {
                                var a = e.match(/([\-\d\.e]+)/g).map(Number), l = m(a, 4), c = l[0], h = l[1], d = l[2], u = l[3];
                                if (u === undefined) u = 1;
                                g.rgba = [
                                    c,
                                    h,
                                    d,
                                    u
                                ];
                            } else if (e.startsWith("#")) g.rgba = p.hexToRgb(e);
                            else g.rgba = p.nameToRgb(e) || p.hexToRgb(e);
                        }
                        if (e === undefined) ;
                        else if (Array.isArray(e)) this.rgba = e;
                        else if (n === undefined) {
                            var r = e && "" + e;
                            if (r) o(r.toLowerCase());
                        } else this.rgba = [
                            e,
                            t,
                            n,
                            i === undefined ? 1 : i
                        ];
                    }
                    e(p, [
                        {
                            key: "printRGB",
                            value: function e(t) {
                                var n = t ? this.rgba : this.rgba.slice(0, 3), i = n.map(function(e, t) {
                                    return a(e, t === 3 ? 3 : 0);
                                });
                                return t ? "rgba(" + i + ")" : "rgb(" + i + ")";
                            }
                        },
                        {
                            key: "printHSL",
                            value: function e(t) {
                                var n = [
                                    360,
                                    100,
                                    100,
                                    1
                                ], i = [
                                    "",
                                    "%",
                                    "%",
                                    ""
                                ];
                                var o = t ? this.hsla : this.hsla.slice(0, 3), r = o.map(function(e, t) {
                                    return a(e * n[t], t === 3 ? 3 : 1) + i[t];
                                });
                                return t ? "hsla(" + r + ")" : "hsl(" + r + ")";
                            }
                        },
                        {
                            key: "printHex",
                            value: function e(t) {
                                var n = this.hex;
                                return t ? n : n.substring(0, 7);
                            }
                        },
                        {
                            key: "rgba",
                            get: function e() {
                                if (this._rgba) return this._rgba;
                                if (!this._hsla) throw new Error("No color is set");
                                return this._rgba = p.hslToRgb(this._hsla);
                            },
                            set: function e(t) {
                                if (t.length === 3) t[3] = 1;
                                this._rgba = t;
                                this._hsla = null;
                            }
                        },
                        {
                            key: "rgbString",
                            get: function e() {
                                return this.printRGB();
                            }
                        },
                        {
                            key: "rgbaString",
                            get: function e() {
                                return this.printRGB(true);
                            }
                        },
                        {
                            key: "hsla",
                            get: function e() {
                                if (this._hsla) return this._hsla;
                                if (!this._rgba) throw new Error("No color is set");
                                return this._hsla = p.rgbToHsl(this._rgba);
                            },
                            set: function e(t) {
                                if (t.length === 3) t[3] = 1;
                                this._hsla = t;
                                this._rgba = null;
                            }
                        },
                        {
                            key: "hslString",
                            get: function e() {
                                return this.printHSL();
                            }
                        },
                        {
                            key: "hslaString",
                            get: function e() {
                                return this.printHSL(true);
                            }
                        },
                        {
                            key: "hex",
                            get: function e() {
                                var t = this.rgba, n = t.map(function(e, t) {
                                    return t < 3 ? e.toString(16) : Math.round(e * 255).toString(16);
                                });
                                return "#" + n.map(function(e) {
                                    return e.padStart(2, "0");
                                }).join("");
                            },
                            set: function e(t) {
                                this.rgba = p.hexToRgb(t);
                            }
                        }
                    ], [
                        {
                            key: "hexToRgb",
                            value: function e(t) {
                                var n = (t.startsWith("#") ? t.slice(1) : t).replace(/^(\w{3})$/, "$1F").replace(/^(\w)(\w)(\w)(\w)$/, "$1$1$2$2$3$3$4$4").replace(/^(\w{6})$/, "$1FF");
                                if (!n.match(/^([0-9a-fA-F]{8})$/)) throw new Error("Unknown hex color; " + t);
                                var i = n.match(/^(\w\w)(\w\w)(\w\w)(\w\w)$/).slice(1).map(function(e) {
                                    return parseInt(e, 16);
                                });
                                i[3] = i[3] / 255;
                                return i;
                            }
                        },
                        {
                            key: "nameToRgb",
                            value: function e(t) {
                                var n = t.toLowerCase().replace("at", "T").replace(/[aeiouyldf]/g, "").replace("ght", "L").replace("rk", "D").slice(-5, 4), i = o[n];
                                return i === undefined ? i : p.hexToRgb(i.replace(/\-/g, "00").padStart(6, "f"));
                            }
                        },
                        {
                            key: "rgbToHsl",
                            value: function e(t) {
                                var n = m(t, 4), i = n[0], o = n[1], r = n[2], s = n[3];
                                i /= 255;
                                o /= 255;
                                r /= 255;
                                var a = Math.max(i, o, r), l = Math.min(i, o, r);
                                var c = void 0, h = void 0, d = (a + l) / 2;
                                if (a === l) c = h = 0;
                                else {
                                    var u = a - l;
                                    h = d > .5 ? u / (2 - a - l) : u / (a + l);
                                    switch(a){
                                        case i:
                                            c = (o - r) / u + (o < r ? 6 : 0);
                                            break;
                                        case o:
                                            c = (r - i) / u + 2;
                                            break;
                                        case r:
                                            c = (i - o) / u + 4;
                                            break;
                                    }
                                    c /= 6;
                                }
                                return [
                                    c,
                                    h,
                                    d,
                                    s
                                ];
                            }
                        },
                        {
                            key: "hslToRgb",
                            value: function e(t) {
                                var n = m(t, 4), i = n[0], o = n[1], r = n[2], s = n[3];
                                var a = void 0, l = void 0, c = void 0;
                                if (o === 0) a = l = c = r;
                                else {
                                    var h = function e(t, n, i) {
                                        if (i < 0) i += 1;
                                        if (i > 1) i -= 1;
                                        if (i < 1 / 6) return t + (n - t) * 6 * i;
                                        if (i < 0.5) return n;
                                        if (i < 2 / 3) return t + (n - t) * (2 / 3 - i) * 6;
                                        return t;
                                    };
                                    var d = r < .5 ? r * (1 + o) : r + o - r * o, u = 2 * r - d;
                                    a = h(u, d, i + 1 / 3);
                                    l = h(u, d, i);
                                    c = h(u, d, i - 1 / 3);
                                }
                                var g = [
                                    a * 255,
                                    l * 255,
                                    c * 255
                                ].map(Math.round);
                                g[3] = s;
                                return g;
                            }
                        }
                    ]);
                    return p;
                }(), n = function() {
                    function r() {
                        s(this, r);
                        this._events = [];
                    }
                    e(r, [
                        {
                            key: "add",
                            value: function e(t, n, i) {
                                t.addEventListener(n, i, false);
                                this._events.push({
                                    target: t,
                                    type: n,
                                    handler: i
                                });
                            }
                        },
                        {
                            key: "remove",
                            value: function e(n, i, o) {
                                this._events = this._events.filter(function(e) {
                                    var t = true;
                                    if (n && n !== e.target) t = false;
                                    if (i && i !== e.type) t = false;
                                    if (o && o !== e.handler) t = false;
                                    if (t) r._doRemove(e.target, e.type, e.handler);
                                    return !t;
                                });
                            }
                        },
                        {
                            key: "destroy",
                            value: function e() {
                                this._events.forEach(function(e) {
                                    return r._doRemove(e.target, e.type, e.handler);
                                });
                                this._events = [];
                            }
                        }
                    ], [
                        {
                            key: "_doRemove",
                            value: function e(t, n, i) {
                                t.removeEventListener(n, i, false);
                            }
                        }
                    ]);
                    return r;
                }();
                function l(e) {
                    var t = document.createElement("div");
                    t.innerHTML = e;
                    return t.firstElementChild;
                }
                function c(e, h, d) {
                    var u = false;
                    function g(e, t, n) {
                        return Math.max(t, Math.min(e, n));
                    }
                    function i(e, t, n) {
                        if (n) u = true;
                        if (!u) return;
                        e.preventDefault();
                        var i = h.getBoundingClientRect(), o = i.width, r = i.height, s = t.clientX, a = t.clientY;
                        var l = g(s - i.left, 0, o), c = g(a - i.top, 0, r);
                        d(l / o, c / r);
                    }
                    function t(e, t) {
                        var n = e.buttons === undefined ? e.which : e.buttons;
                        if (n === 1) i(e, e, t);
                        else u = false;
                    }
                    function n(e, t) {
                        if (e.touches.length === 1) i(e, e.touches[0], t);
                        else u = false;
                    }
                    e.add(h, "mousedown", function(e) {
                        t(e, true);
                    });
                    e.add(h, "touchstart", function(e) {
                        n(e, true);
                    });
                    e.add(window, "mousemove", t);
                    e.add(h, "touchmove", n);
                    e.add(window, "mouseup", function(e) {
                        u = false;
                    });
                    e.add(h, "touchend", function(e) {
                        u = false;
                    });
                    e.add(h, "touchcancel", function(e) {
                        u = false;
                    });
                }
                var b = "linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%) 0 0 / 2em 2em,\n                   linear-gradient(45deg, lightgrey 25%,       white 25%,       white 75%, lightgrey 75%) 1em 1em / 2em 2em", A = 360, h = "keydown", d = "mousedown", u = "focusin";
                function w(e, t) {
                    return (t || document).querySelector(e);
                }
                function g(e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                function p(e, t, n, i, o) {
                    e.add(t, h, function(e) {
                        if (n.indexOf(e.key) >= 0) {
                            if (o) g(e);
                            i(e);
                        }
                    });
                }
                var t = function() {
                    function t(e) {
                        s(this, t);
                        this.settings = {
                            popup: "right",
                            layout: "default",
                            alpha: true,
                            editor: true,
                            editorFormat: "hex",
                            cancelButton: false,
                            defaultColor: "#0cf"
                        };
                        this._events = new n;
                        this.onChange = null;
                        this.onDone = null;
                        this.onOpen = null;
                        this.onClose = null;
                        this.setOptions(e);
                    }
                    e(t, [
                        {
                            key: "setOptions",
                            value: function e(t) {
                                var n = this;
                                if (!t) return;
                                var i = this.settings;
                                function o(e, t, n) {
                                    for(var i in e){
                                        if (n && n.indexOf(i) >= 0) continue;
                                        t[i] = e[i];
                                    }
                                }
                                if (t instanceof HTMLElement) i.parent = t;
                                else {
                                    if (i.parent && t.parent && i.parent !== t.parent) {
                                        this._events.remove(i.parent);
                                        this._popupInited = false;
                                    }
                                    o(t, i);
                                    if (t.onChange) this.onChange = t.onChange;
                                    if (t.onDone) this.onDone = t.onDone;
                                    if (t.onOpen) this.onOpen = t.onOpen;
                                    if (t.onClose) this.onClose = t.onClose;
                                    var r = t.color || t.colour;
                                    if (r) this._setColor(r);
                                }
                                var s = i.parent;
                                if (s && i.popup && !this._popupInited) {
                                    var a = function e(t) {
                                        return n.openHandler(t);
                                    };
                                    this._events.add(s, "click", a);
                                    p(this._events, s, [
                                        " ",
                                        "Spacebar",
                                        "Enter"
                                    ], a);
                                    this._popupInited = true;
                                } else if (t.parent && !i.popup) this.show();
                            }
                        },
                        {
                            key: "openHandler",
                            value: function e(t) {
                                if (this.show()) {
                                    t && t.preventDefault();
                                    this.settings.parent.style.pointerEvents = "none";
                                    var n = t && t.type === h ? this._domEdit : this.domElement;
                                    setTimeout(function() {
                                        return n.focus();
                                    }, 100);
                                    if (this.onOpen) this.onOpen(this.colour);
                                }
                            }
                        },
                        {
                            key: "closeHandler",
                            value: function e(t) {
                                var n = t && t.type;
                                var i = false;
                                if (!t) i = true;
                                else if (n === d || n === u) {
                                    var o = (this.__containedEvent || 0) + 100;
                                    if (t.timeStamp > o) i = true;
                                } else {
                                    g(t);
                                    i = true;
                                }
                                if (i && this.hide()) {
                                    this.settings.parent.style.pointerEvents = "";
                                    if (n !== d) this.settings.parent.focus();
                                    if (this.onClose) this.onClose(this.colour);
                                }
                            }
                        },
                        {
                            key: "movePopup",
                            value: function e(t, n) {
                                this.closeHandler();
                                this.setOptions(t);
                                if (n) this.openHandler();
                            }
                        },
                        {
                            key: "setColor",
                            value: function e(t, n) {
                                this._setColor(t, {
                                    silent: n
                                });
                            }
                        },
                        {
                            key: "_setColor",
                            value: function e(t, n) {
                                if (typeof t === "string") t = t.trim();
                                if (!t) return;
                                n = n || {};
                                var i = void 0;
                                try {
                                    i = new r(t);
                                } catch (e) {
                                    if (n.failSilently) return;
                                    throw e;
                                }
                                if (!this.settings.alpha) {
                                    var o = i.hsla;
                                    o[3] = 1;
                                    i.hsla = o;
                                }
                                this.colour = this.color = i;
                                this._setHSLA(null, null, null, null, n);
                            }
                        },
                        {
                            key: "setColour",
                            value: function e(t, n) {
                                this.setColor(t, n);
                            }
                        },
                        {
                            key: "show",
                            value: function e() {
                                var t = this.settings.parent;
                                if (!t) return false;
                                if (this.domElement) {
                                    var n = this._toggleDOM(true);
                                    this._setPosition();
                                    return n;
                                }
                                var i = this.settings.template || '<div class="picker_wrapper" tabindex="-1"><div class="picker_arrow"></div><div class="picker_hue picker_slider"><div class="picker_selector"></div></div><div class="picker_sl"><div class="picker_selector"></div></div><div class="picker_alpha picker_slider"><div class="picker_selector"></div></div><div class="picker_editor"><input aria-label="Type a color name or hex value"/></div><div class="picker_sample"></div><div class="picker_done"><button>Ok</button></div><div class="picker_cancel"><button>Cancel</button></div></div>';
                                var o = l(i);
                                this.domElement = o;
                                this._domH = w(".picker_hue", o);
                                this._domSL = w(".picker_sl", o);
                                this._domA = w(".picker_alpha", o);
                                this._domEdit = w(".picker_editor input", o);
                                this._domSample = w(".picker_sample", o);
                                this._domOkay = w(".picker_done button", o);
                                this._domCancel = w(".picker_cancel button", o);
                                o.classList.add("layout_" + this.settings.layout);
                                if (!this.settings.alpha) o.classList.add("no_alpha");
                                if (!this.settings.editor) o.classList.add("no_editor");
                                if (!this.settings.cancelButton) o.classList.add("no_cancel");
                                this._ifPopup(function() {
                                    return o.classList.add("popup");
                                });
                                this._setPosition();
                                if (this.colour) this._updateUI();
                                else this._setColor(this.settings.defaultColor);
                                this._bindEvents();
                                return true;
                            }
                        },
                        {
                            key: "hide",
                            value: function e() {
                                return this._toggleDOM(false);
                            }
                        },
                        {
                            key: "destroy",
                            value: function e() {
                                this._events.destroy();
                                if (this.domElement) this.settings.parent.removeChild(this.domElement);
                            }
                        },
                        {
                            key: "_bindEvents",
                            value: function e() {
                                var n = this;
                                var i = this, o = this.domElement, r = this._events;
                                function s(e, t, n) {
                                    r.add(e, t, n);
                                }
                                s(o, "click", function(e) {
                                    return e.preventDefault();
                                });
                                c(r, this._domH, function(e, t) {
                                    return i._setHSLA(e);
                                });
                                c(r, this._domSL, function(e, t) {
                                    return i._setHSLA(null, e, 1 - t);
                                });
                                if (this.settings.alpha) c(r, this._domA, function(e, t) {
                                    return i._setHSLA(null, null, null, 1 - t);
                                });
                                var t = this._domEdit;
                                s(t, "input", function(e) {
                                    i._setColor(this.value, {
                                        fromEditor: true,
                                        failSilently: true
                                    });
                                });
                                s(t, "focus", function(e) {
                                    var t = this;
                                    if (t.selectionStart === t.selectionEnd) t.select();
                                });
                                this._ifPopup(function() {
                                    var e = function e(t) {
                                        return n.closeHandler(t);
                                    };
                                    s(window, d, e);
                                    s(window, u, e);
                                    p(r, o, [
                                        "Esc",
                                        "Escape"
                                    ], e);
                                    var t = function e(t) {
                                        n.__containedEvent = t.timeStamp;
                                    };
                                    s(o, d, t);
                                    s(o, u, t);
                                    s(n._domCancel, "click", e);
                                });
                                var a = function e(t) {
                                    n._ifPopup(function() {
                                        return n.closeHandler(t);
                                    });
                                    if (n.onDone) n.onDone(n.colour);
                                };
                                s(this._domOkay, "click", a);
                                p(r, o, [
                                    "Enter"
                                ], a);
                            }
                        },
                        {
                            key: "_setPosition",
                            value: function e() {
                                var n = this.settings.parent, i = this.domElement;
                                if (n !== i.parentNode) n.appendChild(i);
                                this._ifPopup(function(e) {
                                    if (getComputedStyle(n).position === "static") n.style.position = "relative";
                                    var t = e === true ? "popup_right" : "popup_" + e;
                                    [
                                        "popup_top",
                                        "popup_bottom",
                                        "popup_left",
                                        "popup_right"
                                    ].forEach(function(e) {
                                        if (e === t) i.classList.add(e);
                                        else i.classList.remove(e);
                                    });
                                    i.classList.add(t);
                                });
                            }
                        },
                        {
                            key: "_setHSLA",
                            value: function e(t, n, i, o, r) {
                                r = r || {};
                                var s = this.colour, a = s.hsla;
                                [
                                    t,
                                    n,
                                    i,
                                    o
                                ].forEach(function(e, t) {
                                    if (e || e === 0) a[t] = e;
                                });
                                s.hsla = a;
                                this._updateUI(r);
                                if (this.onChange && !r.silent) this.onChange(s);
                            }
                        },
                        {
                            key: "_updateUI",
                            value: function e(t) {
                                if (!this.domElement) return;
                                t = t || {};
                                var n = this.colour, i = n.hsla, o = "hsl(" + i[0] * A + ", 100%, 50%)", r = n.hslString, s = n.hslaString;
                                var a = this._domH, l = this._domSL, c = this._domA, h = w(".picker_selector", a), d = w(".picker_selector", l), u = w(".picker_selector", c);
                                function g(e, t, n) {
                                    t.style.left = n * 100 + "%";
                                }
                                function p(e, t, n) {
                                    t.style.top = n * 100 + "%";
                                }
                                g(a, h, i[0]);
                                this._domSL.style.backgroundColor = this._domH.style.color = o;
                                g(l, d, i[1]);
                                p(l, d, 1 - i[2]);
                                l.style.color = r;
                                p(c, u, 1 - i[3]);
                                var m = r, f = m.replace("hsl", "hsla").replace(")", ", 0)"), C = "linear-gradient(" + [
                                    m,
                                    f
                                ] + ")";
                                this._domA.style.background = C + ", " + b;
                                if (!t.fromEditor) {
                                    var y = this.settings.editorFormat, v = this.settings.alpha;
                                    var I = void 0;
                                    switch(y){
                                        case "rgb":
                                            I = n.printRGB(v);
                                            break;
                                        case "hsl":
                                            I = n.printHSL(v);
                                            break;
                                        default:
                                            I = n.printHex(v);
                                    }
                                    this._domEdit.value = I;
                                }
                                this._domSample.style.color = s;
                            }
                        },
                        {
                            key: "_ifPopup",
                            value: function e(t, n) {
                                if (this.settings.parent && this.settings.popup) t && t(this.settings.popup);
                                else n && n();
                            }
                        },
                        {
                            key: "_toggleDOM",
                            value: function e(t) {
                                var n = this.domElement;
                                if (!n) return false;
                                var i = t ? "" : "none", o = n.style.display !== i;
                                if (o) n.style.display = i;
                                return o;
                            }
                        }
                    ]);
                    return t;
                }(), i = document.createElement("style");
                return i.textContent = '.picker_wrapper.no_alpha .picker_alpha{display:none}.picker_wrapper.no_editor .picker_editor{position:absolute;z-index:-1;opacity:0}.picker_wrapper.no_cancel .picker_cancel{display:none}.layout_default.picker_wrapper{display:flex;flex-flow:row wrap;justify-content:space-between;align-items:stretch;font-size:10px;width:25em;padding:.5em}.layout_default.picker_wrapper input,.layout_default.picker_wrapper button{font-size:1rem}.layout_default.picker_wrapper>*{margin:.5em}.layout_default.picker_wrapper::before{content:"";display:block;width:100%;height:0;order:1}.layout_default .picker_slider,.layout_default .picker_selector{padding:1em}.layout_default .picker_hue{width:100%}.layout_default .picker_sl{flex:1 1 auto}.layout_default .picker_sl::before{content:"";display:block;padding-bottom:100%}.layout_default .picker_editor{order:1;width:6.5rem}.layout_default .picker_editor input{width:100%;height:100%}.layout_default .picker_sample{order:1;flex:1 1 auto}.layout_default .picker_done,.layout_default .picker_cancel{order:1}.picker_wrapper{box-sizing:border-box;background:#f2f2f2;box-shadow:0 0 0 1px silver;cursor:default;font-family:sans-serif;color:#444;pointer-events:auto}.picker_wrapper:focus{outline:none}.picker_wrapper button,.picker_wrapper input{box-sizing:border-box;border:none;box-shadow:0 0 0 1px silver;outline:none}.picker_wrapper button:focus,.picker_wrapper button:active,.picker_wrapper input:focus,.picker_wrapper input:active{box-shadow:0 0 2px 1px #1e90ff}.picker_wrapper button{padding:.4em .6em;cursor:pointer;background-color:#f5f5f5;background-image:linear-gradient(0deg, gainsboro, transparent)}.picker_wrapper button:active{background-image:linear-gradient(0deg, transparent, gainsboro)}.picker_wrapper button:hover{background-color:#fff}.picker_selector{position:absolute;z-index:1;display:block;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);border:2px solid #fff;border-radius:100%;box-shadow:0 0 3px 1px #67b9ff;background:currentColor;cursor:pointer}.picker_slider .picker_selector{border-radius:2px}.picker_hue{position:relative;background-image:linear-gradient(90deg, red, yellow, lime, cyan, blue, magenta, red);box-shadow:0 0 0 1px silver}.picker_sl{position:relative;box-shadow:0 0 0 1px silver;background-image:linear-gradient(180deg, white, rgba(255, 255, 255, 0) 50%),linear-gradient(0deg, black, rgba(0, 0, 0, 0) 50%),linear-gradient(90deg, #808080, rgba(128, 128, 128, 0))}.picker_alpha,.picker_sample{position:relative;background:linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%) 0 0/2em 2em,linear-gradient(45deg, lightgrey 25%, white 25%, white 75%, lightgrey 75%) 1em 1em/2em 2em;box-shadow:0 0 0 1px silver}.picker_alpha .picker_selector,.picker_sample .picker_selector{background:none}.picker_editor input{font-family:monospace;padding:.2em .4em}.picker_sample::before{content:"";position:absolute;display:block;width:100%;height:100%;background:currentColor}.picker_arrow{position:absolute;z-index:-1}.picker_wrapper.popup{position:absolute;z-index:2;margin:1.5em}.picker_wrapper.popup,.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{background:#f2f2f2;box-shadow:0 0 10px 1px rgba(0,0,0,.4)}.picker_wrapper.popup .picker_arrow{width:3em;height:3em;margin:0}.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{content:"";display:block;position:absolute;top:0;left:0;z-index:-99}.picker_wrapper.popup .picker_arrow::before{width:100%;height:100%;-webkit-transform:skew(45deg);transform:skew(45deg);-webkit-transform-origin:0 100%;transform-origin:0 100%}.picker_wrapper.popup .picker_arrow::after{width:150%;height:150%;box-shadow:none}.popup.popup_top{bottom:100%;left:0}.popup.popup_top .picker_arrow{bottom:0;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.popup.popup_bottom{top:100%;left:0}.popup.popup_bottom .picker_arrow{top:0;left:0;-webkit-transform:rotate(90deg) scale(1, -1);transform:rotate(90deg) scale(1, -1)}.popup.popup_left{top:0;right:100%}.popup.popup_left .picker_arrow{top:0;right:0;-webkit-transform:scale(-1, 1);transform:scale(-1, 1)}.popup.popup_right{top:0;left:100%}.popup.popup_right .picker_arrow{top:0;left:0}', document.documentElement.firstElementChild.appendChild(i), t.StyleElement = i, t;
            }();
        },
        1262: function(h, e, t) {
            "use strict";
            function o(e) {
                return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function s(e, t) {
                for(var n = 0; n < t.length; n++){
                    var i = t[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function(e) {
                        e = function(e, t) {
                            if ("object" !== o(e) || null === e) return e;
                            var n = e[Symbol.toPrimitive];
                            if (void 0 === n) return ("string" === t ? String : Number)(e);
                            n = n.call(e, t || "default");
                            if ("object" !== o(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }(e, "string");
                        return "symbol" === o(e) ? e : String(e);
                    }(i.key), i);
                }
            }
            function a(n) {
                var i = r();
                return function() {
                    var e, t = c(n), t = (e = i ? (e = c(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments), this);
                    if (e && ("object" === o(e) || "function" == typeof e)) return e;
                    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                    if (void 0 !== t) return t;
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                };
            }
            function n(e) {
                var n = "function" == typeof Map ? new Map : void 0;
                return function(e) {
                    if (null === e || -1 === Function.toString.call(e).indexOf("[native code]")) return e;
                    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                    if (void 0 !== n) {
                        if (n.has(e)) return n.get(e);
                        n.set(e, t);
                    }
                    function t() {
                        return i(e, arguments, c(this).constructor);
                    }
                    return t.prototype = Object.create(e.prototype, {
                        constructor: {
                            value: t,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), l(t, e);
                }(e);
            }
            function i(e, t, n) {
                return (i = r() ? Reflect.construct.bind() : function(e, t, n) {
                    var i = [
                        null
                    ];
                    i.push.apply(i, t);
                    t = new (Function.bind.apply(e, i));
                    return n && l(t, n.prototype), t;
                }).apply(null, arguments);
            }
            function r() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }
            function l(e, t) {
                return (l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                    return e.__proto__ = t, e;
                })(e, t);
            }
            function c(e) {
                return (c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
            }
            t.d(e, {
                K: function() {
                    return fe;
                }
            });
            var C = function(e) {
                var t = r;
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e && l(t, e);
                var n, i, o = a(r);
                function r(e, t) {
                    if (this instanceof r) return (e = o.call(this, e + " at position " + t)).position = t, e;
                    throw new TypeError("Cannot call a class as a function");
                }
                return t = r, n && s(t.prototype, n), i && s(t, i), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), t;
            }(n(Error)), y = 92, v = 47, O = 42, I = 123, b = 125, A = 91, w = 93, D = 40, K = 41, d = 32, S = 10, x = 9, k = 13, j = 8, z = 12, E = 34, T = 43, R = 45, u = 39, _ = 48, X = 49, $ = 57, L = 44, Y = 46, J = 58, U = 59, g = 65, p = 97, Q = 69, q = 101, m = 70, f = 102, ee = 160, te = 8192, ne = 8202, ie = 8239, oe = 8287, re = 12288, se = 8220, ae = 8221, le = 8216, ce = 8217, he = 96, de = 180;
            function N(e) {
                return _ <= e && e <= $ || g <= e && e <= m || p <= e && e <= f;
            }
            function B(e) {
                return _ <= e && e <= $;
            }
            var ue = /^[,:[\]{}()\n]$/;
            function M(e) {
                return ge.test(e) || e && H(e.charCodeAt(0));
            }
            var ge = /^[[{\w-]$/;
            function W(e) {
                return e === d || e === S || e === x || e === k;
            }
            function H(e) {
                return G(e) || F(e);
            }
            function G(e) {
                return e === E || e === se || e === ae;
            }
            function P(e) {
                return e === E;
            }
            function F(e) {
                return e === u || e === le || e === ce || e === he || e === de;
            }
            function V(e, t, n) {
                n = 2 < arguments.length && void 0 !== n && n, t = e.lastIndexOf(t);
                return -1 !== t ? e.substring(0, t) + (n ? "" : e.substring(t + 1)) : e;
            }
            function Z(e, t) {
                var n = e.length;
                if (!W(e.charCodeAt(n - 1))) return e + t;
                for(; W(e.charCodeAt(n - 1));)n--;
                return e.substring(0, n) + t + e.substring(n);
            }
            var pe = {
                "\b": "\\b",
                "\f": "\\f",
                "\n": "\\n",
                "\r": "\\r",
                "\t": "\\t"
            }, me = {
                '"': '"',
                "\\": "\\",
                "/": "/",
                b: "\b",
                f: "\f",
                n: "\n",
                r: "\r",
                t: "\t"
            };
            function fe(a) {
                var l = 0, c = "";
                if (!i()) throw new C("Unexpected end of json string", a.length);
                var e = r(L);
                if (e && h(), M(a[l]) && /[,\n][ \t\r]*$/.test(c)) {
                    e || (c = Z(c, ","));
                    for(var t = !0, n = !0; n;)t ? t = !1 : r(L) || (c = Z(c, ",")), n = i();
                    n || (c = V(c, ",")), c = "[\n".concat(c, "\n]");
                } else e && (c = V(c, ","));
                if (l >= a.length) return c;
                throw new C("Unexpected character " + JSON.stringify(a[l]), l);
                function i() {
                    h();
                    var e = function() {
                        if (a.charCodeAt(l) !== I) return !1;
                        c += "{", l++, h();
                        var e = !0;
                        for(; l < a.length && a.charCodeAt(l) !== b;){
                            if (e ? e = false : (r(L) || (c = Z(c, ",")), h()), !(u() || g())) {
                                a.charCodeAt(l) === b || a.charCodeAt(l) === I || a.charCodeAt(l) === w || a.charCodeAt(l) === A || void 0 === a[l] ? c = V(c, ",") : function() {
                                    throw new C("Object key expected", l);
                                }();
                                break;
                            }
                            h();
                            var t = r(J);
                            t || (M(a[l]) ? c = Z(c, ":") : f()), i() || (t ? function() {
                                throw new C("Object value expected", l);
                            } : f)();
                        }
                        a.charCodeAt(l) === b ? (c += "}", l++) : c = Z(c, "}");
                        return !0;
                    }() || function() {
                        if (a.charCodeAt(l) !== A) return !1;
                        c += "[", l++, h();
                        var e = !0;
                        for(; l < a.length && a.charCodeAt(l) !== w;)if (e ? e = !1 : r(L) || (c = Z(c, ",")), !i()) {
                            c = V(c, ",");
                            break;
                        }
                        a.charCodeAt(l) === w ? (c += "]", l++) : c = Z(c, "]");
                        return !0;
                    }() || u() || function() {
                        var e = l;
                        if (a.charCodeAt(l) === R && (l++, m(e))) return !0;
                        if (a.charCodeAt(l) === _) l++;
                        else if (function(e) {
                            return X <= e && e <= $;
                        }(a.charCodeAt(l))) for(l++; B(a.charCodeAt(l));)l++;
                        if (a.charCodeAt(l) === Y) {
                            if (l++, m(e)) return !0;
                            for(; B(a.charCodeAt(l));)l++;
                        }
                        if (a.charCodeAt(l) === q || a.charCodeAt(l) === Q) {
                            if (l++, a.charCodeAt(l) !== R && a.charCodeAt(l) !== T || l++, m(e)) return !0;
                            for(; B(a.charCodeAt(l));)l++;
                        }
                        if (e < l) return c += a.slice(e, l), !0;
                        return !1;
                    }() || s("true", "true") || s("false", "false") || s("null", "null") || s("True", "true") || s("False", "false") || s("None", "null") || g();
                    return h(), e;
                }
                function h() {
                    for(o(); function() {
                        if (a.charCodeAt(l) === v && a.charCodeAt(l + 1) === O) {
                            for(; l < a.length && !function(e, t) {
                                return "*" === e[t] && "/" === e[t + 1];
                            }(a, l);)l++;
                            l += 2;
                        } else {
                            if (a.charCodeAt(l) !== v || a.charCodeAt(l + 1) !== v) return !1;
                            for(; l < a.length && a.charCodeAt(l) !== S;)l++;
                        }
                        return !0;
                    }() && o(););
                }
                function o() {
                    for(var e, t, n = ""; (e = W(a.charCodeAt(l))) || (t = a.charCodeAt(l)) === ee || te <= t && t <= ne || t === ie || t === oe || t === re;)n += e ? a[l] : " ", l++;
                    return 0 < n.length && (c += n, !0);
                }
                function r(e) {
                    return a.charCodeAt(l) === e && (c += a[l], l++, !0);
                }
                function d() {
                    var e;
                    return e = y, a.charCodeAt(l) === e && (l++, !0);
                }
                function u() {
                    var e, t = a.charCodeAt(l) === y;
                    if (t && (l++, t = !0), H(a.charCodeAt(l))) {
                        var n = F(a.charCodeAt(l)) ? F : P(a.charCodeAt(l)) ? P : G;
                        for(c += '"', l++; l < a.length && !n(a.charCodeAt(l));){
                            if (a.charCodeAt(l) === y) {
                                var i = a[l + 1];
                                if (void 0 !== me[i]) c += a.slice(l, l + 2), l += 2;
                                else if ("u" === i) {
                                    if (!(N(a.charCodeAt(l + 2)) && N(a.charCodeAt(l + 3)) && N(a.charCodeAt(l + 4)) && N(a.charCodeAt(l + 5)))) {
                                        r = o = void 0;
                                        for(var o = l, r = o + 2; /\w/.test(a[r]);)r++;
                                        throw o = a.slice(o, r), new C('Invalid unicode character "'.concat(o, '"'), l);
                                    }
                                    c += a.slice(l, l + 6), l += 6;
                                } else c += i, l += 2;
                            } else {
                                o = a[l], i = a.charCodeAt(l);
                                if (i === E && a.charCodeAt(l - 1) !== y) c += "\\" + o;
                                else if ((e = i) === S || e === k || e === x || e === j || e === z) c += pe[o];
                                else {
                                    if (!(32 <= (e = i) && e <= 1114111)) throw new C("Invalid character " + JSON.stringify(o), l);
                                    c += o;
                                }
                                l++;
                            }
                            t && d();
                        }
                        H(a.charCodeAt(l)) ? (a.charCodeAt(l), c += '"', l++) : c += '"';
                        for(h(); a.charCodeAt(l) === T;){
                            l++, h();
                            var s = (c = V(c, '"', !0)).length;
                            u(), c = function(e, t, n) {
                                return e.substring(0, t) + e.substring(t + n);
                            }(c, s, 1);
                        }
                        return !0;
                    }
                    return !1;
                }
                function s(e, t) {
                    return a.slice(l, l + e.length) === e && (c += t, l += e.length, !0);
                }
                function g() {
                    for(var e, t = l; l < a.length && (e = a[l], !(ue.test(e) || e && H(e.charCodeAt(0))));)l++;
                    if (t < l) {
                        if (a.charCodeAt(l) === D) l++, i(), a.charCodeAt(l) === K && (l++, a.charCodeAt(l) === U) && l++;
                        else {
                            for(; W(a.charCodeAt(l - 1)) && 0 < l;)l--;
                            t = a.slice(t, l);
                            c += JSON.stringify(t);
                        }
                        return !0;
                    }
                }
                function p(e) {
                    if (!B(a.charCodeAt(l))) throw e = a.slice(e, l), new C("Invalid number '".concat(e, "', expecting a digit ").concat(a[l] ? "but got '".concat(a[l], "'") : "but reached end of input"), 2);
                }
                function m(e) {
                    if (l >= a.length) return c += a.slice(e, l) + "0", 1;
                    p(e);
                }
                function f() {
                    throw new C("Colon expected", l);
                }
            }
        },
        894: function(e) {
            "use strict";
            e.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#","description":"Meta-schema for $data reference (JSON Schema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}');
        },
        7171: function(e) {
            "use strict";
            e.exports = JSON.parse('{"id":"http://json-schema.org/draft-04/schema#","$schema":"http://json-schema.org/draft-04/schema#","description":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"positiveInteger":{"type":"integer","minimum":0},"positiveIntegerDefault0":{"allOf":[{"$ref":"#/definitions/positiveInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"minItems":1,"uniqueItems":true}},"type":"object","properties":{"id":{"type":"string"},"$schema":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":{},"multipleOf":{"type":"number","minimum":0,"exclusiveMinimum":true},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"boolean","default":false},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"boolean","default":false},"maxLength":{"$ref":"#/definitions/positiveInteger"},"minLength":{"$ref":"#/definitions/positiveIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"anyOf":[{"type":"boolean"},{"$ref":"#"}],"default":{}},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":{}},"maxItems":{"$ref":"#/definitions/positiveInteger"},"minItems":{"$ref":"#/definitions/positiveIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"maxProperties":{"$ref":"#/definitions/positiveInteger"},"minProperties":{"$ref":"#/definitions/positiveIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"anyOf":[{"type":"boolean"},{"$ref":"#"}],"default":{}},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"enum":{"type":"array","minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"dependencies":{"exclusiveMaximum":["maximum"],"exclusiveMinimum":["minimum"]},"default":{}}');
        },
        6273: function(e) {
            "use strict";
            e.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-06/schema#","$id":"http://json-schema.org/draft-06/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"title":{"type":"string"},"description":{"type":"string"},"default":{},"examples":{"type":"array","items":{}},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":{}},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":{},"enum":{"type":"array","minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":{}}');
        },
        6680: function(e) {
            "use strict";
            e.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"http://json-schema.org/draft-07/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"$comment":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":true,"readOnly":{"type":"boolean","default":false},"examples":{"type":"array","items":true},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":true},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"propertyNames":{"format":"regex"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":true,"enum":{"type":"array","items":true,"minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"contentMediaType":{"type":"string"},"contentEncoding":{"type":"string"},"if":{"$ref":"#"},"then":{"$ref":"#"},"else":{"$ref":"#"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":true}');
        }
    }, o = {}, i.amdD = function() {
        throw new Error("define cannot be used indirect");
    }, i.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return i.d(t, {
            a: t
        }), t;
    }, i.d = function(e, t) {
        for(var n in t)i.o(t, n) && !i.o(e, n) && Object.defineProperty(e, n, {
            enumerable: !0,
            get: t[n]
        });
    }, i.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, i.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }, i.nmd = function(e) {
        return e.paths = [], e.children || (e.children = []), e;
    }, i(3161);
    function i(e) {
        var t = o[e];
        return void 0 !== t || (t = o[e] = {
            id: e,
            loaded: !1,
            exports: {}
        }, n[e].call(t.exports, t, t.exports, i), t.loaded = !0), t.exports;
    }
}); //# sourceMappingURL=jsoneditor.map





parcelRequire("gV9qD");

const $949bfb63ec3d8bd4$var$wrapperStyle = {
    height: 300,
    '& > *': {
        borderColor: 'grey.500'
    }
};
const $949bfb63ec3d8bd4$var$locale = 'en';
const $949bfb63ec3d8bd4$export$7105d214197992e9 = ({ initialJson: initialJson, onChange: onChange })=>{
    const ref = /*#__PURE__*/ (0, $h4Bez.createRef)();
    const eventListener = (0, $h4Bez.useMemo)(()=>new (0, $9fc21cc786388d5a$export$3291343375ee8b92)(), []);
    const [editor, setEditor] = (0, $h4Bez.useState)(null);
    (0, $h4Bez.useEffect)(()=>{
        if (!ref.current) return;
        const editor = new (0, (/*@__PURE__*/$parcel$interopDefault($55d2ce2bf73ae319$exports)))(ref.current, {
            mode: 'code',
            onChange: ()=>eventListener.trigger(),
            onError: ()=>eventListener.trigger(),
            language: $949bfb63ec3d8bd4$var$locale,
            enableSort: false,
            enableTransform: false,
            navigationBar: false,
            statusBar: false,
            mainMenuBar: false,
            theme: 'ace/theme/dawn'
        }, initialJson);
        setEditor(editor);
        return ()=>{
            setEditor(null);
            editor.destroy();
        };
    }, [
        ref.current,
        eventListener
    ]);
    (0, $h4Bez.useEffect)(()=>{
        if (!editor) return;
        return eventListener.on(()=>{
            try {
                onChange(editor.get());
            } catch (e) {
                onChange(new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Bad json input', {
                    message: e.message
                }));
            }
        });
    }, [
        editor,
        eventListener
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $949bfb63ec3d8bd4$var$wrapperStyle,
        ref: ref
    });
};
















parcelRequire("h4Bez");




const $9470f199663bdb4a$var$logsWrapperStyle = {
    pt: 1
};
const $9470f199663bdb4a$export$22ef66d3c161d6a7 = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $be3703687194c6e0$export$56e2352e63353d99), {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_LOGS,
                description: [
                    (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_LOGS_DOCUMENTATION_TITLE,
                    (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_LOGS_DOCUMENTATION_BODY
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $9470f199663bdb4a$var$logsWrapperStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ac7334fad98808f5$export$54ec01a60f47d33d), {
                    type: (0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).SERVICE,
                    lines: "all",
                    showDownloadRawLogs: true,
                    showServiceId: true,
                    downloadSuffix: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_LOGS)
                })
            })
        ]
    });
};






parcelRequire("h4Bez");




parcelRequire("h4Bez");







var $h4Bez = parcelRequire("h4Bez");

const $5267ceb3ec78b05a$export$6e2c8f0811a474ce = ({ width: width, children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: {
            width: width
        },
        children: children
    });
const $5267ceb3ec78b05a$var$dividerStyle = {
    my: 4,
    borderWidth: 2
};
const $5267ceb3ec78b05a$export$285cbcdb788689a9 = ({ children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
        children: children.map((child, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $h4Bez.Fragment), {
                children: [
                    k > 0 && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {
                        variant: "fullWidth",
                        sx: $5267ceb3ec78b05a$var$dividerStyle
                    }),
                    child
                ]
            }, k))
    });




var $h4Bez = parcelRequire("h4Bez");








const $99615e8d8d695a3a$var$wrapperStyle = {
    [[
        '& > *',
        `& > .${(0, $fb671afc24ce07a1$export$ac0218a70844ff2).root} > .${(0, $fb671afc24ce07a1$export$f95a619b04479b7d).root}`,
        `& > .${(0, $ef73307de6008871$export$2e2bcd8739ae039).root}`
    ].join(', ')]: {
        mb: 4
    }
};
const $99615e8d8d695a3a$var$textFieldProps = {
    type: 'password',
    required: true,
    fullWidth: true
};
const $99615e8d8d695a3a$var$Response = ({ response: response })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    /** General error is displayed by default */ let translation = (0, $40a99dac858c1d75$export$b63289fbda65eed1).PROBLEM_CHANGING_PASSWORD;
    let values = {};
    if (response === undefined) /** All good, password changed */ translation = (0, $40a99dac858c1d75$export$b63289fbda65eed1).PASSWORD_SUCCESSFULLY_CHANGED;
    else if ((0, $c3e1b746ad236797$export$8d524fb6540252df).isOfTypes(response, (0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION)) {
        /** Could not authenticate for whatever reason */ translation = (0, $40a99dac858c1d75$export$b63289fbda65eed1).AUTHENTICATION_ERROR;
        values = {
            error: (0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION,
            authType: null
        };
    }
    const message = translator.formatTranslation(translation, values);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fb671afc24ce07a1$export$d0473d205c8ede55), {
        "data-testid": "change-password-response",
        validations: [
            response ? new (0, $c3e1b746ad236797$export$8d524fb6540252df)(response, message) : message
        ]
    });
};
const $99615e8d8d695a3a$var$useOnPasswordFormChange = (name)=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('changePasswordUsecase');
    return (0, $h4Bez.useCallback)((value)=>usecase.updateForm({
            [name]: value
        }), [
        usecase,
        name
    ]);
};
const $99615e8d8d695a3a$export$ef0ae802e3ecfb1 = ({ form: form })=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('changePasswordUsecase');
    const [changePassword, isLoading, response] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(()=>usecase.invoke(), [
        usecase
    ]);
    const canChange = (0, $65e38d2a650b506d$export$19b083a30e6dacea)(form);
    const cantRequestChange = !canChange || isLoading;
    const setPassword = $99615e8d8d695a3a$var$useOnPasswordFormChange('password');
    const setNewPassword = $99615e8d8d695a3a$var$useOnPasswordFormChange('newPassword');
    const setConfirmPassword = $99615e8d8d695a3a$var$useOnPasswordFormChange('confirmPassword');
    const passwordValidation = form.newPassword || form.confirmPassword ? form.passwordValidation === null ? [] : (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(form.passwordValidation) ? form.passwordValidation : [
        form.passwordValidation
    ] : null;
    (0, $h4Bez.useEffect)(()=>{
        /** When leaving, reset the form, so other people don't see it */ return ()=>usecase.toggle();
    }, [
        usecase
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $99615e8d8d695a3a$var$wrapperStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6f84d94c688eb85b$export$57753b0d185cad1a), {
                ...$99615e8d8d695a3a$var$textFieldProps,
                "data-testid": "change-password-password",
                name: "password",
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CURRENT_PASSWORD,
                value: form.password,
                disabled: isLoading,
                onChange: setPassword
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6f84d94c688eb85b$export$57753b0d185cad1a), {
                ...$99615e8d8d695a3a$var$textFieldProps,
                "data-testid": "change-password-new-password",
                name: "new-password",
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NEW_PASSWORD,
                value: form.newPassword,
                disabled: isLoading,
                onChange: setNewPassword
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $6f84d94c688eb85b$export$57753b0d185cad1a), {
                ...$99615e8d8d695a3a$var$textFieldProps,
                "data-testid": "change-password-new-confirm-password",
                name: "confirm-password",
                placeholder: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONFIRM_PASSWORD,
                value: form.confirmPassword,
                disabled: isLoading,
                onChange: setConfirmPassword,
                onKeyUp: cantRequestChange ? undefined : (0, $1fdb53e1bec07519$export$d9ea00e8a3cf8cca)(changePassword)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                "data-testid": "change-password-confirm-new-password",
                variant: "primary",
                size: "large",
                fullWidth: true,
                disabled: cantRequestChange,
                onClick: changePassword,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SAVE_NEW_PASSWORD
                })
            }),
            passwordValidation && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fb671afc24ce07a1$export$d0473d205c8ede55), {
                "data-testid": "change-password-form-validation",
                validations: passwordValidation
            }),
            response !== null && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($99615e8d8d695a3a$var$Response, {
                response: response
            })
        ]
    });
};


const $f4b7b2227693782a$var$openPasswordLink = {
    cursor: 'pointer'
};
const $f4b7b2227693782a$var$disablePasswordLink = {
    color: 'gray'
};
const $f4b7b2227693782a$var$selectUserCanChangePassword = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_OWN_PASSWORD, (0, $78670ebe9381a713$export$790a66df9dc00390).RETRIEVE_PASSWORD_POLICY);
const $f4b7b2227693782a$var$ShowChangePasswordFormLink = ()=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('changePasswordUsecase');
    const canChangePassword = (0, $be523f14267dcd17$export$9973955de2bf96cf)($f4b7b2227693782a$var$selectUserCanChangePassword);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a497eee141ca75b8$export$2e2bcd8739ae039), {
        "data-testid": canChangePassword ? 'change-password-link' : 'disabled-change-password-link',
        sx: canChangePassword ? $f4b7b2227693782a$var$openPasswordLink : $f4b7b2227693782a$var$disablePasswordLink,
        onClick: ()=>canChangePassword ? usecase.toggle() : undefined,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CHANGE_PASSWORD
        })
    });
};
const $f4b7b2227693782a$var$settingsStyle = {
    pt: 6
};
const $f4b7b2227693782a$export$cde6a8e3bdfc6895 = ()=>{
    const form = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $65e38d2a650b506d$export$7035a9f02825a4ad));
    const canChangePassword = (0, $be523f14267dcd17$export$9973955de2bf96cf)($f4b7b2227693782a$var$selectUserCanChangePassword);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $5267ceb3ec78b05a$export$6e2c8f0811a474ce), {
        width: 600,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$f99233281efd08a0), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CHANGE_PASSWORD
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $617663da3bdf6296$export$2661e2422bcf54ba), {
                id: canChangePassword ? (0, $40a99dac858c1d75$export$b63289fbda65eed1).CHANGE_PASSWORD_DESCRIPTION : (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_CHANGE_PASSWORD_PERMISSION_DESCRIPTION
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                "data-testid": "change-password-settings",
                sx: $f4b7b2227693782a$var$settingsStyle,
                children: form ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $99615e8d8d695a3a$export$ef0ae802e3ecfb1), {
                    form: form
                }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($f4b7b2227693782a$var$ShowChangePasswordFormLink, {})
            })
        ]
    });
};






var $h4Bez = parcelRequire("h4Bez");




const $5c6ec7806420d742$export$5d373514132a77af = ()=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('loadMfaSettingsUsecase');
    (0, $h4Bez.useEffect)(()=>usecase.load(), [
        usecase
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $5267ceb3ec78b05a$export$6e2c8f0811a474ce), {
        width: 600,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $73502a1bea8699fe$export$393edc798c47379d), {
                required: false
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                "data-testid": "mfa-settings",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $95d857ca97a10afd$export$bea8ebba691c5813), {}),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $95d857ca97a10afd$export$7c6e2c02157bb7d2), {})
                ]
            })
        ]
    });
};



const $093786e8d7b00ac6$var$selectCanManageMfa = (0, $1c05f13022cf1480$export$718d52259ef5bb58)((0, $78670ebe9381a713$export$790a66df9dc00390).USE_MFA);
const $093786e8d7b00ac6$export$f7ec98692e4afe96 = ()=>{
    const canUseMfa = (0, $be523f14267dcd17$export$9973955de2bf96cf)($093786e8d7b00ac6$var$selectCanManageMfa);
    const elements = [];
    elements.push(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f4b7b2227693782a$export$cde6a8e3bdfc6895), {}, elements.length));
    if (canUseMfa) elements.push(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5c6ec7806420d742$export$5d373514132a77af), {}, elements.length));
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $be3703687194c6e0$export$56e2352e63353d99), {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LOGIN_SETTINGS,
                description: [
                    (0, $40a99dac858c1d75$export$b63289fbda65eed1).LOGIN_SETTINGS_DOCUMENTATION_TITLE,
                    (0, $40a99dac858c1d75$export$b63289fbda65eed1).LOGIN_SETTINGS_DOCUMENTATION_BODY
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5267ceb3ec78b05a$export$285cbcdb788689a9), {
                children: elements
            })
        ]
    });
};






parcelRequire("h4Bez");

/* istanbul ignore file */ 

var $h4Bez = parcelRequire("h4Bez");




parcelRequire("h4Bez");

const $a938fa6ecb213d00$export$d206ce4c12e8ddf6 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $09dab4bc1b3aad02$export$2e2bcd8739ae039), {
        "data-testid": "AgentsOutlineIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("g", {
            id: "icon/agents/outline",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)("g", {
                id: "Vector",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M15.5357 11.2932C15.3482 11.4807 15.2429 11.735 15.2429 12.0002C15.2429 12.2653 15.3482 12.5197 15.5357 12.7072L17.9117 15.0842C18.0992 15.2717 18.3535 15.377 18.6187 15.377C18.8839 15.377 19.1382 15.2717 19.3257 15.0842L21.7027 12.7072C21.8902 12.5197 21.9955 12.2653 21.9955 12.0002C21.9955 11.735 21.8902 11.4807 21.7027 11.2932L19.3257 8.91618C19.1382 8.72871 18.8839 8.62339 18.6187 8.62339C18.3535 8.62339 18.0992 8.72871 17.9117 8.91618L15.5357 11.2932Z",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        fill: "none"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M2.29669 11.2932C2.10922 11.4807 2.00391 11.735 2.00391 12.0002C2.00391 12.2653 2.10922 12.5197 2.29669 12.7072L4.67369 15.0842C4.86122 15.2717 5.11553 15.377 5.38069 15.377C5.64586 15.377 5.90016 15.2717 6.08769 15.0842L8.46469 12.7072C8.65216 12.5197 8.75748 12.2653 8.75748 12.0002C8.75748 11.735 8.65216 11.4807 8.46469 11.2932L6.08769 8.91618C5.90016 8.72871 5.64586 8.62339 5.38069 8.62339C5.11553 8.62339 4.86122 8.72871 4.67369 8.91618L2.29669 11.2932Z",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        fill: "none"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M8.91569 17.9122C8.82272 18.0051 8.74896 18.1153 8.69863 18.2367C8.64831 18.3581 8.62241 18.4883 8.62241 18.6197C8.62241 18.7511 8.64831 18.8812 8.69863 19.0026C8.74896 19.124 8.82272 19.2343 8.91569 19.3272L11.2927 21.7032C11.4802 21.8907 11.7345 21.996 11.9997 21.996C12.2649 21.996 12.5192 21.8907 12.7067 21.7032L15.0837 19.3272C15.1767 19.2343 15.2504 19.124 15.3008 19.0026C15.3511 18.8812 15.377 18.7511 15.377 18.6197C15.377 18.4883 15.3511 18.3581 15.3008 18.2367C15.2504 18.1153 15.1767 18.0051 15.0837 17.9122L12.7067 15.5362C12.5192 15.3487 12.2649 15.2434 11.9997 15.2434C11.7345 15.2434 11.4802 15.3487 11.2927 15.5362L8.91569 17.9122Z",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        fill: "none"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
                        d: "M8.91569 4.67418C8.72822 4.86171 8.62291 5.11602 8.62291 5.38118C8.62291 5.64635 8.72822 5.90065 8.91569 6.08818L11.2927 8.46418C11.4802 8.65165 11.7345 8.75697 11.9997 8.75697C12.2649 8.75697 12.5192 8.65165 12.7067 8.46418L15.0837 6.08818C15.2712 5.90065 15.3765 5.64635 15.3765 5.38118C15.3765 5.11602 15.2712 4.86171 15.0837 4.67418L12.7067 2.29718C12.5192 2.10971 12.2649 2.00439 11.9997 2.00439C11.7345 2.00439 11.4802 2.10971 11.2927 2.29718L8.91569 4.67418Z",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        fill: "none"
                    })
                ]
            })
        })
    });



parcelRequire("h4Bez");

var $h4Bez = parcelRequire("h4Bez");











function $d6187503ff92e286$export$b85c003f960b1f3a(slot) {
    return (0, $6b55eb7835363b92$export$2e2bcd8739ae039)('MuiButtonGroup', slot);
}
const $d6187503ff92e286$var$buttonGroupClasses = (0, $1980a9eb8f5fa46b$export$2e2bcd8739ae039)('MuiButtonGroup', [
    'root',
    'contained',
    'outlined',
    'text',
    'disableElevation',
    'disabled',
    'firstButton',
    'fullWidth',
    'horizontal',
    'vertical',
    'colorPrimary',
    'colorSecondary',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'groupedText',
    'groupedTextHorizontal',
    'groupedTextVertical',
    'groupedTextPrimary',
    'groupedTextSecondary',
    'groupedOutlined',
    'groupedOutlinedHorizontal',
    'groupedOutlinedVertical',
    'groupedOutlinedPrimary',
    'groupedOutlinedSecondary',
    'groupedContained',
    'groupedContainedHorizontal',
    'groupedContainedVertical',
    'groupedContainedPrimary',
    'groupedContainedSecondary',
    'lastButton',
    'middleButton'
]);
var $d6187503ff92e286$export$2e2bcd8739ae039 = $d6187503ff92e286$var$buttonGroupClasses;





'use client';
const $bc1ccf1459239df9$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.variant)}`]
        },
        {
            [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.variant)}${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.variant)}${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(ownerState.color)}`]
        },
        {
            [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === 'vertical' && styles.vertical
    ];
};
const $bc1ccf1459239df9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            orientation,
            fullWidth && 'fullWidth',
            disableElevation && 'disableElevation',
            `color${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`
        ],
        grouped: [
            'grouped',
            `grouped${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(orientation)}`,
            `grouped${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(variant)}`,
            `grouped${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(variant)}${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(orientation)}`,
            `grouped${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(variant)}${(0, $48502cfd5e4ee8e9$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $15645634511fd40c$export$2e2bcd8739ae039)(slots, (0, $d6187503ff92e286$export$b85c003f960b1f3a), classes);
};
const $bc1ccf1459239df9$var$ButtonGroupRoot = (0, $0a84fcab91d2b818$export$2e2bcd8739ae039)('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver: $bc1ccf1459239df9$var$overridesResolver
})((0, $6f5ab2b368d2d9fb$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    boxShadow: (theme.vars || theme).shadows[2],
                    [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).grouped}`]: {
                        boxShadow: 'none',
                        '&:hover': {
                            boxShadow: 'none'
                        }
                    }
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none'
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).lastButton},& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0
                    },
                    [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).firstButton},& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).firstButton},& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).lastButton},& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).firstButton},& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRight: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $d6187503ff92e286$export$2e2bcd8739ae039).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).firstButton},& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottom: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $d6187503ff92e286$export$2e2bcd8739ae039).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)()).flatMap(([color])=>[
                    {
                        props: {
                            variant: 'text',
                            color: color
                        },
                        style: {
                            [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).firstButton},& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).middleButton}`]: {
                                borderColor: theme.alpha((theme.vars || theme).palette[color].main, 0.5)
                            }
                        }
                    }
                ]),
            {
                props: {
                    variant: 'outlined',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).firstButton},& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRightColor: 'transparent',
                        '&:hover': {
                            borderRightColor: 'currentColor'
                        }
                    },
                    [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).lastButton},& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).middleButton}`]: {
                        marginLeft: -1
                    }
                }
            },
            {
                props: {
                    variant: 'outlined',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).firstButton},& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomColor: 'transparent',
                        '&:hover': {
                            borderBottomColor: 'currentColor'
                        }
                    },
                    [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).lastButton},& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).middleButton}`]: {
                        marginTop: -1
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).firstButton},& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $d6187503ff92e286$export$2e2bcd8739ae039).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).firstButton},& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $d6187503ff92e286$export$2e2bcd8739ae039).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $0276aff9d37c91bd$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        variant: 'contained',
                        color: color
                    },
                    style: {
                        [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).firstButton},& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).middleButton}`]: {
                            borderColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                }))
        ],
        [`& .${(0, $d6187503ff92e286$export$2e2bcd8739ae039).grouped}`]: {
            minWidth: 40
        }
    })));
const $bc1ccf1459239df9$var$ButtonGroup = /*#__PURE__*/ $h4Bez.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $16527687018ae2c4$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonGroup'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = 'horizontal', size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    };
    const classes = $bc1ccf1459239df9$var$useUtilityClasses(ownerState);
    const context = $h4Bez.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $48607cded6ebfb4f$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($bc1ccf1459239df9$var$ButtonGroupRoot, {
        as: component,
        role: "group",
        className: (0, $234b0b3cb485132a$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $656d3071cfbb944f$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $441e40d1ba2980c5$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
var $bc1ccf1459239df9$export$2e2bcd8739ae039 = $bc1ccf1459239df9$var$ButtonGroup;



const $9c45a956b05a0709$export$f16ddc42dd2d184c = ({ ariaLabel: ariaLabel, testIdPrefix: testIdPrefix, option: option, options: options, onChange: onChange })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bc1ccf1459239df9$export$2e2bcd8739ae039), {
        "aria-label": ariaLabel,
        sx: {
            mb: 4,
            textTransform: 'capitalize'
        },
        children: options.map((candidate)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                "data-testid": `${testIdPrefix}-${candidate}`,
                variant: candidate === option ? 'primary' : 'primaryOutline',
                onClick: ()=>onChange(candidate),
                children: candidate
            }, candidate))
    });


const $103e5506ee7c55f7$var$options = [
    {
        id: 'apple',
        label: 'Apple'
    },
    {
        id: 'banana',
        label: 'Banana'
    },
    {
        id: 'cherry',
        label: 'Cherry'
    },
    {
        id: 'date',
        label: 'Date'
    },
    {
        id: 'elderberry',
        label: 'Elderberry'
    },
    {
        id: 'fig',
        label: 'Fig'
    },
    {
        id: 'grape',
        label: 'Grape'
    }
];
const $103e5506ee7c55f7$var$getOptionLabel = (option)=>option.label;
const $103e5506ee7c55f7$var$isOptionEqualToValue = (a, b)=>a.id === b.id;
const $103e5506ee7c55f7$var$isOptionDisabled = (option)=>option.id === 'banana';
const $103e5506ee7c55f7$var$iconOptions = $103e5506ee7c55f7$var$options.map((option)=>({
        ...option,
        icon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a938fa6ecb213d00$export$d206ce4c12e8ddf6), {})
    }));
const $103e5506ee7c55f7$var$iconMetaOptions = $103e5506ee7c55f7$var$options.map((option)=>({
        ...option,
        icon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a938fa6ecb213d00$export$d206ce4c12e8ddf6), {}),
        meta: `${option.label} is a fruit`
    }));
const $103e5506ee7c55f7$var$metaLabeledOptions = $103e5506ee7c55f7$var$options.map((option)=>({
        ...option,
        meta: `${option.label} is a fruit`
    }));
const $103e5506ee7c55f7$var$statuses = [
    'success',
    'warning',
    'error'
];
const $103e5506ee7c55f7$var$statusOptions = $103e5506ee7c55f7$var$options.map((option, index)=>({
        ...option,
        status: $103e5506ee7c55f7$var$statuses[index % $103e5506ee7c55f7$var$statuses.length],
        meta: [
            'Online',
            'Degraded',
            'Offline'
        ][index % $103e5506ee7c55f7$var$statuses.length]
    }));
const $103e5506ee7c55f7$var$metaOptions = $103e5506ee7c55f7$var$options.map((option, index)=>({
        ...option,
        meta: `#${index + 1}`
    }));
const $103e5506ee7c55f7$var$loadingError = new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Something went wrong while loading the options.');
const $103e5506ee7c55f7$var$sizeOptions = [
    'small',
    'medium'
];
const $103e5506ee7c55f7$var$exampleStyle = {
    width: 280,
    maxWidth: '100%'
};
const $103e5506ee7c55f7$var$SingleSelect = ({ size: size })=>{
    const [value, setValue] = (0, $h4Bez.useState)(null);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e878dbad11e3bdcd$export$2f2b9559550c7bbc), {
        size: size,
        options: $103e5506ee7c55f7$var$metaLabeledOptions,
        noOptionsText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ENTRIES_AVAILABLE,
        getOptionLabel: $103e5506ee7c55f7$var$getOptionLabel,
        isOptionEqualToValue: $103e5506ee7c55f7$var$isOptionEqualToValue,
        value: value,
        onSelect: setValue
    });
};
const $103e5506ee7c55f7$var$MultiSelect = ({ size: size })=>{
    const [value, setValue] = (0, $h4Bez.useState)([]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e878dbad11e3bdcd$export$2f2b9559550c7bbc), {
        multiple: true,
        size: size,
        options: $103e5506ee7c55f7$var$options,
        noOptionsText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ENTRIES_AVAILABLE,
        getOptionLabel: $103e5506ee7c55f7$var$getOptionLabel,
        isOptionEqualToValue: $103e5506ee7c55f7$var$isOptionEqualToValue,
        value: [
            ...value
        ],
        onSelect: setValue
    });
};
const $103e5506ee7c55f7$var$MultiSelectWithIcon = ({ size: size })=>{
    const [value, setValue] = (0, $h4Bez.useState)([]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e878dbad11e3bdcd$export$2f2b9559550c7bbc), {
        multiple: true,
        size: size,
        options: $103e5506ee7c55f7$var$iconOptions,
        noOptionsText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ENTRIES_AVAILABLE,
        getOptionLabel: $103e5506ee7c55f7$var$getOptionLabel,
        isOptionEqualToValue: $103e5506ee7c55f7$var$isOptionEqualToValue,
        value: [
            ...value
        ],
        onSelect: setValue
    });
};
const $103e5506ee7c55f7$var$MultiSelectWithIconAndMeta = ({ size: size })=>{
    const [value, setValue] = (0, $h4Bez.useState)([
        $103e5506ee7c55f7$var$iconMetaOptions[0]
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e878dbad11e3bdcd$export$2f2b9559550c7bbc), {
        multiple: true,
        size: size,
        options: $103e5506ee7c55f7$var$iconMetaOptions,
        noOptionsText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ENTRIES_AVAILABLE,
        getOptionLabel: $103e5506ee7c55f7$var$getOptionLabel,
        isOptionEqualToValue: $103e5506ee7c55f7$var$isOptionEqualToValue,
        value: [
            ...value
        ],
        onSelect: setValue
    });
};
const $103e5506ee7c55f7$var$SingleSelectWithStatus = ({ size: size })=>{
    const [value, setValue] = (0, $h4Bez.useState)(null);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e878dbad11e3bdcd$export$2f2b9559550c7bbc), {
        size: size,
        options: $103e5506ee7c55f7$var$statusOptions,
        noOptionsText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ENTRIES_AVAILABLE,
        getOptionLabel: $103e5506ee7c55f7$var$getOptionLabel,
        isOptionEqualToValue: $103e5506ee7c55f7$var$isOptionEqualToValue,
        value: value,
        onSelect: setValue
    });
};
const $103e5506ee7c55f7$var$SingleSelectWithMeta = ({ size: size })=>{
    const [value, setValue] = (0, $h4Bez.useState)(null);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e878dbad11e3bdcd$export$2f2b9559550c7bbc), {
        size: size,
        options: $103e5506ee7c55f7$var$metaOptions,
        noOptionsText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ENTRIES_AVAILABLE,
        getOptionLabel: $103e5506ee7c55f7$var$getOptionLabel,
        isOptionEqualToValue: $103e5506ee7c55f7$var$isOptionEqualToValue,
        value: value,
        onSelect: setValue
    });
};
const $103e5506ee7c55f7$var$WithDisabledOption = ({ size: size })=>{
    const [value, setValue] = (0, $h4Bez.useState)(null);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e878dbad11e3bdcd$export$2f2b9559550c7bbc), {
        size: size,
        options: $103e5506ee7c55f7$var$options,
        noOptionsText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ENTRIES_AVAILABLE,
        getOptionLabel: $103e5506ee7c55f7$var$getOptionLabel,
        isOptionEqualToValue: $103e5506ee7c55f7$var$isOptionEqualToValue,
        getOptionDisabled: $103e5506ee7c55f7$var$isOptionDisabled,
        value: value,
        onSelect: setValue
    });
};
const $103e5506ee7c55f7$var$FreeSolo = ({ size: size })=>{
    const [value, setValue] = (0, $h4Bez.useState)(null);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e878dbad11e3bdcd$export$2f2b9559550c7bbc), {
        freeSolo: true,
        size: size,
        options: $103e5506ee7c55f7$var$options,
        noOptionsText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ENTRIES_AVAILABLE,
        getOptionLabel: (option)=>typeof option === 'string' ? option : option.label,
        isOptionEqualToValue: $103e5506ee7c55f7$var$isOptionEqualToValue,
        value: value,
        onSelect: setValue
    });
};
const $103e5506ee7c55f7$var$MultiFreeSolo = ({ size: size })=>{
    const [value, setValue] = (0, $h4Bez.useState)([]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e878dbad11e3bdcd$export$2f2b9559550c7bbc), {
        multiple: true,
        freeSolo: true,
        size: size,
        options: [],
        noOptionsText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ENTRIES_AVAILABLE,
        value: [
            ...value
        ],
        onSelect: setValue
    });
};
const $103e5506ee7c55f7$var$DisableClearable = ({ size: size })=>{
    const [value, setValue] = (0, $h4Bez.useState)($103e5506ee7c55f7$var$options[0]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e878dbad11e3bdcd$export$2f2b9559550c7bbc), {
        disableClearable: true,
        size: size,
        options: $103e5506ee7c55f7$var$options,
        noOptionsText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ENTRIES_AVAILABLE,
        getOptionLabel: $103e5506ee7c55f7$var$getOptionLabel,
        isOptionEqualToValue: $103e5506ee7c55f7$var$isOptionEqualToValue,
        value: value,
        onSelect: setValue
    });
};
const $103e5506ee7c55f7$var$Loading = ({ size: size })=>{
    const [value, setValue] = (0, $h4Bez.useState)(null);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e878dbad11e3bdcd$export$2f2b9559550c7bbc), {
        size: size,
        options: null,
        noOptionsText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ENTRIES_AVAILABLE,
        getOptionLabel: $103e5506ee7c55f7$var$getOptionLabel,
        isOptionEqualToValue: $103e5506ee7c55f7$var$isOptionEqualToValue,
        value: value,
        onSelect: setValue
    });
};
const $103e5506ee7c55f7$var$ErrorState = ({ size: size })=>{
    const [value, setValue] = (0, $h4Bez.useState)(null);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e878dbad11e3bdcd$export$2f2b9559550c7bbc), {
        size: size,
        options: $103e5506ee7c55f7$var$loadingError,
        noOptionsText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ENTRIES_AVAILABLE,
        getOptionLabel: $103e5506ee7c55f7$var$getOptionLabel,
        isOptionEqualToValue: $103e5506ee7c55f7$var$isOptionEqualToValue,
        value: value,
        onSelect: setValue
    });
};
const $103e5506ee7c55f7$var$examples = [
    {
        label: 'Single select',
        Example: $103e5506ee7c55f7$var$SingleSelect
    },
    {
        label: 'Multi select',
        Example: $103e5506ee7c55f7$var$MultiSelect
    },
    {
        label: 'Multi select with icon',
        Example: $103e5506ee7c55f7$var$MultiSelectWithIcon
    },
    {
        label: 'Multi select with icon and meta',
        Example: $103e5506ee7c55f7$var$MultiSelectWithIconAndMeta
    },
    {
        label: 'Single select with status dot',
        Example: $103e5506ee7c55f7$var$SingleSelectWithStatus
    },
    {
        label: 'Single select with meta',
        Example: $103e5506ee7c55f7$var$SingleSelectWithMeta
    },
    {
        label: 'With a disabled option',
        Example: $103e5506ee7c55f7$var$WithDisabledOption
    },
    {
        label: 'Free solo',
        Example: $103e5506ee7c55f7$var$FreeSolo
    },
    {
        label: 'Multi select + Free solo',
        Example: $103e5506ee7c55f7$var$MultiFreeSolo
    },
    {
        label: 'Disable clearable',
        Example: $103e5506ee7c55f7$var$DisableClearable
    },
    {
        label: 'Loading',
        Example: $103e5506ee7c55f7$var$Loading
    },
    {
        label: 'Error',
        Example: $103e5506ee7c55f7$var$ErrorState
    }
];
const $103e5506ee7c55f7$export$11b2ac0b0559e17 = ()=>{
    const [size, setSize] = (0, $h4Bez.useState)('medium');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                sx: {
                    display: 'block',
                    mb: 4
                },
                children: "Autocomplete"
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9c45a956b05a0709$export$f16ddc42dd2d184c), {
                ariaLabel: "Autocomplete size",
                testIdPrefix: "autocomplete-storybook-size",
                option: size,
                options: $103e5506ee7c55f7$var$sizeOptions,
                onChange: setSize
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                container: true,
                spacing: 6,
                children: $103e5506ee7c55f7$var$examples.map(({ label: label, Example: Example })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12,
                            sm: 6,
                            md: 4
                        },
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                                variant: "subtitle2",
                                sx: {
                                    mb: 2
                                },
                                children: label
                            }),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                                sx: $103e5506ee7c55f7$var$exampleStyle,
                                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Example, {
                                    size: size
                                })
                            })
                        ]
                    }, label))
            })
        ]
    });
};




var $h4Bez = parcelRequire("h4Bez");


const $0a26dbdfba44e827$var$variants = [
    'primary',
    'secondary',
    'primaryOutline',
    'primaryGhost',
    'ghost',
    'danger',
    'dangerOutline',
    'dangerGhost',
    'legacyAmber'
];
const $0a26dbdfba44e827$var$sizes = [
    'small',
    'medium',
    'large'
];
const $0a26dbdfba44e827$export$665d5a662b7213f3 = ()=>{
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {
        children: $0a26dbdfba44e827$var$variants.map((variant)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $h4Bez.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 2,
                        sx: {
                            my: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                                size: 6,
                                children: $0a26dbdfba44e827$var$sizes.map((size)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1e2141c588472150$export$2e2bcd8739ae039), {
                                        variant: variant,
                                        size: size,
                                        sx: {
                                            mr: 4
                                        },
                                        children: "Button"
                                    }, size))
                            }),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                                size: 6,
                                children: $0a26dbdfba44e827$var$sizes.map((size)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
                                        variant: variant,
                                        size: size,
                                        sx: {
                                            mr: 4
                                        },
                                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $db5721617f0596ac$export$58a57064519df6a0), {})
                                    }, size))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 2,
                        sx: {
                            my: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                                size: 6,
                                children: $0a26dbdfba44e827$var$sizes.map((size)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1e2141c588472150$export$2e2bcd8739ae039), {
                                        disabled: true,
                                        variant: variant,
                                        size: size,
                                        sx: {
                                            mr: 4
                                        },
                                        children: "Button"
                                    }, size))
                            }),
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                                size: 6,
                                children: $0a26dbdfba44e827$var$sizes.map((size)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
                                        disabled: true,
                                        variant: variant,
                                        size: size,
                                        sx: {
                                            mr: 4
                                        },
                                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $db5721617f0596ac$export$58a57064519df6a0), {})
                                    }, size))
                            })
                        ]
                    })
                ]
            }, variant))
    });
};




var $h4Bez = parcelRequire("h4Bez");



const $21a4fd398397de4e$var$variants = [
    'neutral',
    'primary'
];
const $21a4fd398397de4e$var$sizes = [
    'small',
    'medium'
];
const $21a4fd398397de4e$var$statusVariants = [
    'success',
    'warning',
    'danger',
    'grey'
];
const $21a4fd398397de4e$export$ca60b63eaa3c28aa = ()=>{
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            $21a4fd398397de4e$var$variants.map((variant)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $h4Bez.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            sx: {
                                my: 6
                            },
                            children: $21a4fd398397de4e$var$sizes.map((size)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5c72e4be84329d1d$export$2e2bcd8739ae039), {
                                    label: "Chip",
                                    variant: variant,
                                    size: size,
                                    onDelete: ()=>{},
                                    sx: {
                                        mr: 4
                                    }
                                }, size))
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            sx: {
                                my: 6
                            },
                            children: $21a4fd398397de4e$var$sizes.map((size)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5c72e4be84329d1d$export$2e2bcd8739ae039), {
                                    label: "Chip",
                                    variant: variant,
                                    size: size,
                                    icon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a938fa6ecb213d00$export$d206ce4c12e8ddf6), {}),
                                    onDelete: ()=>{},
                                    sx: {
                                        mr: 4
                                    }
                                }, size))
                        })
                    ]
                }, variant)),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                sx: {
                    my: 6
                },
                children: $21a4fd398397de4e$var$statusVariants.map((variant)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5c72e4be84329d1d$export$2e2bcd8739ae039), {
                        label: variant,
                        variant: variant,
                        size: "medium",
                        icon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $544912f84b2ee288$export$eaa9dcd62e0d5ec6), {}),
                        sx: {
                            mr: 4
                        }
                    }, variant))
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                sx: {
                    my: 6
                },
                children: $21a4fd398397de4e$var$statusVariants.map((variant)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5c72e4be84329d1d$export$2e2bcd8739ae039), {
                        label: variant,
                        variant: variant,
                        size: "medium",
                        sx: {
                            mr: 4
                        }
                    }, variant))
            })
        ]
    });
};




var $h4Bez = parcelRequire("h4Bez");



const $9195a8fc51eb0dd7$var$options = [
    {
        value: 'apple',
        label: 'Apple'
    },
    {
        value: 'banana',
        label: 'Banana'
    },
    {
        value: 'cherry',
        label: 'Cherry'
    }
];
const $9195a8fc51eb0dd7$var$sizes = [
    'small',
    'medium'
];
const $9195a8fc51eb0dd7$var$playgroundStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
};
const $9195a8fc51eb0dd7$var$exampleStyle = {
    width: 200,
    maxWidth: '100%'
};
const $9195a8fc51eb0dd7$var$DropdownPlayground = ()=>{
    const [size, setSize] = (0, $h4Bez.useState)('medium');
    const [value, setValue] = (0, $h4Bez.useState)('apple');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $9195a8fc51eb0dd7$var$playgroundStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9c45a956b05a0709$export$f16ddc42dd2d184c), {
                ariaLabel: "Dropdown size",
                testIdPrefix: "dropdown-storybook-size",
                option: size,
                options: $9195a8fc51eb0dd7$var$sizes,
                onChange: setSize
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $9195a8fc51eb0dd7$var$exampleStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d85f7a63a75c527f$export$931cbfb6bfb85fc), {
                    "data-testid": "dropdown-storybook",
                    buttonLabel: $9195a8fc51eb0dd7$var$options.find((option)=>option.value === value)?.label,
                    options: $9195a8fc51eb0dd7$var$options,
                    size: size,
                    value: value,
                    onChange: setValue
                })
            })
        ]
    });
};
const $9195a8fc51eb0dd7$export$764e74833824089b = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                sx: {
                    display: 'block',
                    mb: 4
                },
                children: "Dropdown"
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($9195a8fc51eb0dd7$var$DropdownPlayground, {})
        ]
    });




var $h4Bez = parcelRequire("h4Bez");



"use client";
var $0b2a79293d3de21c$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), 'Visibility');





const $df7e1ff1b4c6b015$var$inputExampleStyle = {
    width: 320,
    maxWidth: '100%'
};
const $df7e1ff1b4c6b015$var$stateOptions = [
    'DEFAULT',
    'DISABLED',
    'ERROR'
];
const $df7e1ff1b4c6b015$var$sizeOptions = [
    'small',
    'medium'
];
const $df7e1ff1b4c6b015$var$playgroundStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
    alignItems: 'flex-start'
};
const $df7e1ff1b4c6b015$var$playgroundControlsStyle = {
    display: 'flex',
    flexDirection: 'column'
};
const $df7e1ff1b4c6b015$var$PlaygroundControls = ({ toggles: toggles })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $df7e1ff1b4c6b015$var$playgroundControlsStyle,
        children: toggles.map(({ label: label, checked: checked, onChange: onChange })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7ef9ef826e2d35ed$export$2e2bcd8739ae039), {
                label: label,
                control: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2d1d930894f85d66$export$48513f6b9f8ce62d), {
                    checked: checked,
                    onChange: (_, value)=>onChange(value)
                })
            }, label))
    });
const $df7e1ff1b4c6b015$var$PlaygroundStateControl = ({ state: state, onChange: onChange })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bc1ccf1459239df9$export$2e2bcd8739ae039), {
        "aria-label": "state",
        sx: {
            mb: 4
        },
        children: $df7e1ff1b4c6b015$var$stateOptions.map((option)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                variant: option === state ? 'primary' : 'primaryOutline',
                onClick: ()=>onChange(option),
                children: option
            }, option))
    });
const $df7e1ff1b4c6b015$export$42ce93d1a224e3f9 = ()=>{
    const [state, setState] = (0, $h4Bez.useState)('DEFAULT');
    const [size, setSize] = (0, $h4Bez.useState)('medium');
    const [showLabel, setShowLabel] = (0, $h4Bez.useState)(true);
    const [showRequired, setShowRequired] = (0, $h4Bez.useState)(true);
    const [showOptional, setShowOptional] = (0, $h4Bez.useState)(true);
    const [showHelpIcon, setShowHelpIcon] = (0, $h4Bez.useState)(true);
    const [showMessage, setShowMessage] = (0, $h4Bez.useState)(true);
    const [showLeadingIcon, setShowLeadingIcon] = (0, $h4Bez.useState)(true);
    const [showEndIcon, setShowEndIcon] = (0, $h4Bez.useState)(true);
    const toggles = [
        {
            label: 'showLabel',
            checked: showLabel,
            onChange: setShowLabel
        },
        {
            label: 'showRequired',
            checked: showRequired,
            onChange: setShowRequired
        },
        {
            label: 'showOptional',
            checked: showOptional,
            onChange: setShowOptional
        },
        {
            label: 'showHelpIcon',
            checked: showHelpIcon,
            onChange: setShowHelpIcon
        },
        {
            label: 'showMessage',
            checked: showMessage,
            onChange: setShowMessage
        },
        {
            label: 'showLeadingIcon',
            checked: showLeadingIcon,
            onChange: setShowLeadingIcon
        },
        {
            label: 'showEndIcon',
            checked: showEndIcon,
            onChange: setShowEndIcon
        }
    ];
    const disabled = state === 'DISABLED';
    const error = state === 'ERROR';
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $df7e1ff1b4c6b015$var$playgroundStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $df7e1ff1b4c6b015$var$inputExampleStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d887fad28e7ec96c$export$2c73285ae9390cec), {
                    label: showLabel ? 'Label' : undefined,
                    placeholder: "Type to search...",
                    helperText: showMessage || error ? 'This is a hint text to help user.' : undefined,
                    helperTextIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a938fa6ecb213d00$export$d206ce4c12e8ddf6), {}),
                    required: showRequired,
                    optional: showOptional,
                    helpTooltip: showHelpIcon ? 'Helpful description' : undefined,
                    startIcon: showLeadingIcon ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a938fa6ecb213d00$export$d206ce4c12e8ddf6), {}) : undefined,
                    endIcon: showEndIcon ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0b2a79293d3de21c$export$2e2bcd8739ae039), {}) : undefined,
                    disabled: disabled,
                    error: error,
                    defaultValue: disabled ? 'Disabled value' : undefined,
                    size: size,
                    fullWidth: true
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $df7e1ff1b4c6b015$var$playgroundControlsStyle,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($df7e1ff1b4c6b015$var$PlaygroundStateControl, {
                        state: state,
                        onChange: setState
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9c45a956b05a0709$export$f16ddc42dd2d184c), {
                        ariaLabel: "Input size",
                        testIdPrefix: "inputs-storybook-size",
                        option: size,
                        options: $df7e1ff1b4c6b015$var$sizeOptions,
                        onChange: setSize
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($df7e1ff1b4c6b015$var$PlaygroundControls, {
                        toggles: toggles
                    })
                ]
            })
        ]
    });
};




var $h4Bez = parcelRequire("h4Bez");





const $57795c3ffd69fbdd$var$severities = [
    (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).ERROR,
    (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).WARNING,
    (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).INFO,
    (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).SUCCESS
];
const $57795c3ffd69fbdd$var$bannerSeverities = [
    (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).ERROR,
    (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).WARNING,
    (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).INFO
];
const $57795c3ffd69fbdd$var$inlineAlertContentKinds = [
    'title',
    'titleAndDescription',
    'descriptionOnly',
    'errorList'
];
const $57795c3ffd69fbdd$var$inlineAlertContentByKind = {
    title: {
        kind: 'title',
        title: 'Title only inline alert'
    },
    titleAndDescription: {
        kind: 'titleAndDescription',
        title: 'Title and description',
        description: 'Additional context for the alert.'
    },
    descriptionOnly: {
        kind: 'descriptionOnly',
        description: 'Description-only inline alert, no title.'
    },
    errorList: {
        kind: 'errorList',
        title: 'Multiple errors',
        errors: [
            'First error',
            'Second error'
        ]
    }
};
const $57795c3ffd69fbdd$var$TOAST_PLAYGROUND_DEDUPE_KEY = 'notifications-storybook-toast-playground';
const $57795c3ffd69fbdd$var$BANNER_PLAYGROUND_DISMISS_KEY = 'notifications-storybook-banner-playground';
const $57795c3ffd69fbdd$var$sectionTitleStyle = {
    display: 'block',
    mb: 4
};
const $57795c3ffd69fbdd$var$playgroundStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
    alignItems: 'flex-start',
    mb: 10
};
const $57795c3ffd69fbdd$var$playgroundControlsStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    mb: 10,
    minWidth: 240
};
const $57795c3ffd69fbdd$var$previewStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    minHeight: 64
};
const $57795c3ffd69fbdd$var$fixedBannerPreviewStyle = {
    ...$57795c3ffd69fbdd$var$previewStyle,
    flexGrow: 1
};
const $57795c3ffd69fbdd$var$Toggle = ({ testId: testId, label: label, checked: checked, onChange: onChange })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7ef9ef826e2d35ed$export$2e2bcd8739ae039), {
        label: label,
        control: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2d1d930894f85d66$export$48513f6b9f8ce62d), {
            "data-testid": testId,
            checked: checked,
            onChange: (_, value)=>onChange(value)
        })
    });
/** Triggers the real `toastUsecase`, rendered by the global `<ToastPortal/>` - not a local preview. */ const $57795c3ffd69fbdd$var$ToastPlayground = ()=>{
    const toastUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('toastUsecase');
    const [severity, setSeverity] = (0, $h4Bez.useState)((0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).INFO);
    const [showDescription, setShowDescription] = (0, $h4Bez.useState)(true);
    const [showAction, setShowAction] = (0, $h4Bez.useState)(false);
    const [aggregate, setAggregate] = (0, $h4Bez.useState)(false);
    const [persist, setPersist] = (0, $h4Bez.useState)(false);
    const handleShow = ()=>{
        toastUsecase.show({
            severity: severity,
            title: 'Toast title',
            persist: persist,
            ...aggregate && {
                dedupeKey: $57795c3ffd69fbdd$var$TOAST_PLAYGROUND_DEDUPE_KEY
            },
            ...showDescription && {
                description: 'Optional description text'
            },
            ...showAction && {
                action: {
                    label: 'Undo',
                    onClick: ()=>{}
                }
            }
        });
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $57795c3ffd69fbdd$var$playgroundControlsStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9c45a956b05a0709$export$f16ddc42dd2d184c), {
                ariaLabel: "Toast severity",
                testIdPrefix: "notifications-storybook-toast-severity",
                option: severity,
                options: $57795c3ffd69fbdd$var$severities,
                onChange: setSeverity
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($57795c3ffd69fbdd$var$Toggle, {
                testId: "notifications-storybook-toast-toggle-description",
                label: "Show description",
                checked: showDescription,
                onChange: setShowDescription
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($57795c3ffd69fbdd$var$Toggle, {
                testId: "notifications-storybook-toast-toggle-action",
                label: "Show action",
                checked: showAction,
                onChange: setShowAction
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($57795c3ffd69fbdd$var$Toggle, {
                testId: "notifications-storybook-toast-toggle-aggregate",
                label: "Aggregate repeat clicks (counter)",
                checked: aggregate,
                onChange: setAggregate
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($57795c3ffd69fbdd$var$Toggle, {
                testId: "notifications-storybook-toast-toggle-persist",
                label: "Persist (no auto-dismiss)",
                checked: persist,
                onChange: setPersist
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                "data-testid": "notifications-storybook-toast-show",
                variant: "primary",
                onClick: handleShow,
                sx: {
                    mt: 4
                },
                children: "Show"
            })
        ]
    });
};
/**
 * Triggers the real `bannerUsecase`, rendered by the global `<BannerRenderer/>` - not a local preview.
 * `clear`s the fixed `dismissKey` before every `show`, or dismissing it once would silently no-op every later click.
 */ const $57795c3ffd69fbdd$var$BannerPlayground = ()=>{
    const bannerUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('bannerUsecase');
    const [severity, setSeverity] = (0, $h4Bez.useState)((0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).INFO);
    const [showDescription, setShowDescription] = (0, $h4Bez.useState)(true);
    const [showAction, setShowAction] = (0, $h4Bez.useState)(false);
    const handleShow = ()=>{
        bannerUsecase.clear($57795c3ffd69fbdd$var$BANNER_PLAYGROUND_DISMISS_KEY);
        bannerUsecase.show({
            severity: severity,
            title: 'Banner title',
            dismissKey: $57795c3ffd69fbdd$var$BANNER_PLAYGROUND_DISMISS_KEY,
            ...showDescription && {
                description: 'Full-width, session-scoped, dismissible until the condition it represents resolves.'
            },
            ...showAction && {
                action: {
                    label: 'Resolve',
                    onClick: ()=>{}
                }
            }
        });
    };
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $57795c3ffd69fbdd$var$playgroundControlsStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9c45a956b05a0709$export$f16ddc42dd2d184c), {
                ariaLabel: "Banner severity",
                testIdPrefix: "notifications-storybook-banner-severity",
                option: severity,
                options: $57795c3ffd69fbdd$var$bannerSeverities,
                onChange: setSeverity
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($57795c3ffd69fbdd$var$Toggle, {
                testId: "notifications-storybook-banner-toggle-description",
                label: "Show description",
                checked: showDescription,
                onChange: setShowDescription
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($57795c3ffd69fbdd$var$Toggle, {
                testId: "notifications-storybook-banner-toggle-action",
                label: "Show action",
                checked: showAction,
                onChange: setShowAction
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                "data-testid": "notifications-storybook-banner-show",
                variant: "primary",
                onClick: handleShow,
                sx: {
                    mt: 4
                },
                children: "Show"
            })
        ]
    });
};
/** Renders directly, outside `bannerUsecase`, the way a page shows a banner it owns: no close button and not a live region, like the session banner on phones */ const $57795c3ffd69fbdd$var$FixedBannerPreview = ()=>{
    const [severity, setSeverity] = (0, $h4Bez.useState)((0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).WARNING);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $57795c3ffd69fbdd$var$playgroundStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $57795c3ffd69fbdd$var$playgroundControlsStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9c45a956b05a0709$export$f16ddc42dd2d184c), {
                    ariaLabel: "Fixed banner severity",
                    testIdPrefix: "notifications-storybook-fixed-banner-severity",
                    option: severity,
                    options: $57795c3ffd69fbdd$var$bannerSeverities,
                    onChange: setSeverity
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $57795c3ffd69fbdd$var$fixedBannerPreviewStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e2c4c4ee1e8614f4$export$3b4e64e77073e307), {
                    "data-testid": "notifications-storybook-fixed-banner",
                    severity: severity,
                    live: false,
                    title: "Banner title, no close button"
                })
            })
        ]
    });
};
/** Renders directly, no trigger - unlike Toast/Banner, InlineAlert is "not a system notification" per Figma and is meant to render as normal, static page content. */ const $57795c3ffd69fbdd$var$InlineAlertPlayground = ()=>{
    const [severity, setSeverity] = (0, $h4Bez.useState)((0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).INFO);
    const [contentKind, setContentKind] = (0, $h4Bez.useState)('titleAndDescription');
    const [dismissible, setDismissible] = (0, $h4Bez.useState)(false);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $57795c3ffd69fbdd$var$playgroundStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $57795c3ffd69fbdd$var$playgroundControlsStyle,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9c45a956b05a0709$export$f16ddc42dd2d184c), {
                        ariaLabel: "Inline alert severity",
                        testIdPrefix: "notifications-storybook-inline-alert-severity",
                        option: severity,
                        options: $57795c3ffd69fbdd$var$severities,
                        onChange: setSeverity
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9c45a956b05a0709$export$f16ddc42dd2d184c), {
                        ariaLabel: "Inline alert content",
                        testIdPrefix: "notifications-storybook-inline-alert-content",
                        option: contentKind,
                        options: $57795c3ffd69fbdd$var$inlineAlertContentKinds,
                        onChange: setContentKind
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($57795c3ffd69fbdd$var$Toggle, {
                        testId: "notifications-storybook-inline-alert-toggle-dismissible",
                        label: "Dismissible",
                        checked: dismissible,
                        onChange: setDismissible
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $57795c3ffd69fbdd$var$previewStyle,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2a12619a779dd8d7$export$a3b2c96db9b0eb71), {
                    severity: severity,
                    content: $57795c3ffd69fbdd$var$inlineAlertContentByKind[contentKind],
                    onClose: dismissible ? ()=>{} : undefined
                })
            })
        ]
    });
};
const $57795c3ffd69fbdd$export$36ba2f559d49a8f6 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                sx: $57795c3ffd69fbdd$var$sectionTitleStyle,
                children: "Toast"
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($57795c3ffd69fbdd$var$ToastPlayground, {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                sx: $57795c3ffd69fbdd$var$sectionTitleStyle,
                children: "Banner"
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($57795c3ffd69fbdd$var$BannerPlayground, {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($57795c3ffd69fbdd$var$FixedBannerPreview, {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                sx: $57795c3ffd69fbdd$var$sectionTitleStyle,
                children: "Inline Alert"
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($57795c3ffd69fbdd$var$InlineAlertPlayground, {})
        ]
    });



parcelRequire("h4Bez");

const $7bdd3ed6ff1fc3eb$var$boxSx = {
    display: 'flex',
    gap: 16,
    p: 16,
    maxWidth: '100%',
    overflowX: 'auto',
    backgroundColor: 'white'
};
const $7bdd3ed6ff1fc3eb$var$paperSx = {
    backgroundColor: 'white',
    minWidth: 256,
    height: 240,
    flex: 1,
    my: 3,
    p: 6,
    textAlign: 'center',
    borderRadius: 3,
    borderWidth: 1,
    borderColor: 'grey.300',
    borderStyle: 'solid'
};
const $7bdd3ed6ff1fc3eb$var$shadowsElevationMap = {
    xs: 1,
    sm: 2,
    md: 3,
    lg: 4,
    xl: 5,
    '2xl': 6,
    '3xl': 7
};
const $7bdd3ed6ff1fc3eb$export$4bd077ec7c23f6d3 = ()=>{
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $7bdd3ed6ff1fc3eb$var$boxSx,
        children: Object.entries($7bdd3ed6ff1fc3eb$var$shadowsElevationMap).map(([label, elevation])=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d6020d3fa35703e9$export$2e2bcd8739ae039), {
                elevation: elevation,
                sx: $7bdd3ed6ff1fc3eb$var$paperSx,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    variant: "subtitle2",
                    fontWeight: 500,
                    children: [
                        "shadow-",
                        label
                    ]
                })
            }, elevation))
    });
};



parcelRequire("h4Bez");



const $0e82906113d7d836$var$wrapperStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 2
};
const $0e82906113d7d836$export$edbc6635a693bcff = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                sx: {
                    display: 'block',
                    mb: 4
                },
                children: "Status"
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $0e82906113d7d836$var$wrapperStyle,
                children: Object.values((0, $1041b3cad55163d4$export$e35c1996c6f482ad)).map((status)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
                        status: status
                    }, status))
            })
        ]
    });




var $h4Bez = parcelRequire("h4Bez");



const $352318722b031741$var$lines = [
    {
        id: 'opcua',
        name: 'opcua-plant-floor',
        status: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLED,
        endpoints: 12,
        updated: '2026-09-24 14:02'
    },
    {
        id: 'modbus',
        name: 'modbus-line-3',
        status: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DEVIATED,
        endpoints: 4,
        updated: '2026-09-23 09:41'
    },
    {
        id: 'mqtt',
        name: 'mqtt-bridge-with-a-rather-long-name-that-has-to-wrap-inside-its-cell/and/a/topic/like/path',
        status: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISABLED,
        endpoints: 0,
        updated: '2026-09-20 17:15'
    },
    {
        id: 's7',
        name: 's7-press-hall',
        status: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLED,
        endpoints: 31,
        updated: '2026-09-19 08:00'
    },
    {
        id: 'influx',
        name: 'influxdb-writer',
        status: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).UNREACHABLE,
        endpoints: 2,
        updated: null
    }
];
const $352318722b031741$var$PAGED_LINE_COUNT = 120;
const $352318722b031741$var$pagedLines = Array.from({
    length: $352318722b031741$var$PAGED_LINE_COUNT
}, (_, index)=>({
        id: `service-${index}`,
        name: `service-${String(index + 1).padStart(String($352318722b031741$var$PAGED_LINE_COUNT).length, '0')}`,
        status: index % 3 === 0 ? (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISABLED : (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLED,
        endpoints: index,
        updated: '2026-09-24 14:02'
    }));
const $352318722b031741$var$keyValueLines = [
    {
        key: 'Version',
        value: '2.0.0'
    },
    {
        key: 'Uptime',
        value: '12 days'
    },
    {
        key: 'Host',
        value: 'connectware.local'
    }
];
const $352318722b031741$var$columns = {
    name: {
        label: 'Name',
        sort: true
    },
    status: {
        label: 'Status',
        sort: true,
        customCellRender: (status)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
                status: status
            })
    },
    endpoints: {
        label: 'Endpoints',
        sort: true,
        type: 'number'
    },
    updated: {
        label: 'Last updated',
        type: 'datetime'
    }
};
const $352318722b031741$var$keyValueColumns = {
    key: {},
    value: {}
};
const $352318722b031741$var$noop = ()=>{};
/** As a resource list would: each action only for the rows it applies to, and none at all for a deviated row */ const $352318722b031741$var$selectActions = (selected)=>({
        ...selected.every(({ status: status })=>status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISABLED) ? {
            ENABLE: $352318722b031741$var$noop
        } : {},
        ...selected.every(({ status: status })=>status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLED) ? {
            DISABLE: $352318722b031741$var$noop
        } : {},
        ...selected.some(({ status: status })=>status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DEVIATED) ? {} : {
            DELETE: $352318722b031741$var$noop
        }
    });
const $352318722b031741$var$Sortable = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        columns: $352318722b031741$var$columns,
        data: $352318722b031741$var$lines,
        sortOrder: {
            name: 'name',
            direction: 'asc'
        }
    });
const $352318722b031741$var$Clickable = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        columns: $352318722b031741$var$columns,
        data: $352318722b031741$var$lines,
        onRowClick: $352318722b031741$var$noop
    });
const $352318722b031741$var$Selectable = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        "data-testid": "storybook-tables-selectable",
        columns: $352318722b031741$var$columns,
        data: $352318722b031741$var$lines,
        selection: {
            idField: 'id',
            icons: {},
            labels: {},
            onSelect: $352318722b031741$var$selectActions
        }
    });
const $352318722b031741$var$arrangedColumnView = {
    order: [
        'name',
        'endpoints',
        'status',
        'updated'
    ],
    hidden: [
        'status'
    ],
    pinned: [
        'updated'
    ],
    widths: {
        name: 240
    }
};
const $352318722b031741$var$WithColumnView = ()=>{
    const [columnView, setColumnView] = (0, $h4Bez.useState)($352318722b031741$var$arrangedColumnView);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        columns: $352318722b031741$var$columns,
        data: $352318722b031741$var$lines,
        columnView: columnView,
        onColumnViewChange: setColumnView
    });
};
const $352318722b031741$var$PaginatedWithTotalCount = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        columns: $352318722b031741$var$columns,
        data: $352318722b031741$var$pagedLines,
        pagination: {
            pageSize: 10,
            pageSizeOptions: [
                10,
                25,
                50
            ],
            showTotalCount: true,
            totalCount: $352318722b031741$var$pagedLines.length
        },
        translations: {
            paginationDataType: 'SERVICE'
        }
    });
const $352318722b031741$var$PaginatedWithJumpToPage = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        columns: $352318722b031741$var$columns,
        data: $352318722b031741$var$pagedLines,
        pagination: {
            pageSize: 10,
            pageSizeOptions: [
                10,
                25,
                50
            ]
        }
    });
const $352318722b031741$var$WithToolbar = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        columns: $352318722b031741$var$columns,
        data: $352318722b031741$var$lines,
        filters: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
            variant: "secondary",
            size: "medium",
            onClick: $352318722b031741$var$noop,
            children: "Filter"
        }),
        utilities: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
            variant: "secondary",
            size: "medium",
            onClick: $352318722b031741$var$noop,
            children: "Refresh"
        }),
        onDownloadCSV: $352318722b031741$var$noop
    });
const $352318722b031741$var$Empty = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        columns: $352318722b031741$var$columns,
        data: [],
        translations: {
            emptyTable: 'No services installed'
        }
    });
const $352318722b031741$var$NoMatch = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        columns: $352318722b031741$var$columns,
        data: $352318722b031741$var$lines,
        search: "no-such-service",
        translations: {
            noResults: 'No service matches this search'
        }
    });
const $352318722b031741$var$Loading = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        columns: $352318722b031741$var$columns,
        data: [],
        loading: true
    });
const $352318722b031741$var$Reloading = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        columns: $352318722b031741$var$columns,
        data: $352318722b031741$var$lines,
        loading: true
    });
const $352318722b031741$var$SearchTooShort = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        columns: $352318722b031741$var$columns,
        data: $352318722b031741$var$lines,
        search: "ab",
        searchThreshold: 3
    });
const $352318722b031741$var$loadError = new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, 'The server did not answer', {
    status: 503
});
const $352318722b031741$var$ErrorWithTryAgain = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        columns: $352318722b031741$var$columns,
        data: [],
        error: {
            error: $352318722b031741$var$loadError,
            onRetry: $352318722b031741$var$noop
        }
    });
const $352318722b031741$var$KeyValue = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        columns: $352318722b031741$var$keyValueColumns,
        data: $352318722b031741$var$keyValueLines,
        hideHeader: true
    });
const $352318722b031741$var$ACTIVE_LINE_ID = 'modbus';
const $352318722b031741$var$ActiveRow = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        columns: $352318722b031741$var$columns,
        data: $352318722b031741$var$lines,
        onRowClick: $352318722b031741$var$noop,
        isRowActive: ({ id: id })=>id === $352318722b031741$var$ACTIVE_LINE_ID
    });
const $352318722b031741$var$RECORD_PANEL_HEIGHT = 360;
const $352318722b031741$var$recordPanelAreaStyle = {
    position: 'relative',
    height: $352318722b031741$var$RECORD_PANEL_HEIGHT,
    overflow: 'hidden'
};
/** Its own outlet, so the panel stays over this example rather than the page */ const $352318722b031741$var$WithRecordPanel = ()=>{
    const [outlet, setOutlet] = (0, $h4Bez.useState)(null);
    const [open, setOpen] = (0, $h4Bez.useState)(false);
    const [index, setIndex] = (0, $h4Bez.useState)(0);
    const [width, setWidth] = (0, $h4Bez.useState)(null);
    const line = $352318722b031741$var$lines[index];
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "storybook-tables-record-panel",
        ref: setOutlet,
        sx: $352318722b031741$var$recordPanelAreaStyle,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $4cbbdab39f07fc39$export$6fdd3966acfaf7f2), {
            outlet: outlet,
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
                    columns: $352318722b031741$var$columns,
                    data: $352318722b031741$var$lines,
                    onRowClick: (clicked)=>{
                        setIndex($352318722b031741$var$lines.indexOf(clicked));
                        setOpen(true);
                    },
                    isRowActive: (candidate)=>open && candidate === line
                }),
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2dbb652f558165cf$export$ab5c4b9e4514633f), {
                    open: open,
                    title: line?.name,
                    position: {
                        index: index,
                        total: $352318722b031741$var$lines.length
                    },
                    onPrevious: index > 0 ? ()=>setIndex(index - 1) : undefined,
                    onNext: index < $352318722b031741$var$lines.length - 1 ? ()=>setIndex(index + 1) : undefined,
                    onExpand: $352318722b031741$var$noop,
                    onClose: ()=>setOpen(false),
                    width: width,
                    onWidthChange: setWidth,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        variant: "body2",
                        children: [
                            "Endpoints: ",
                            line?.endpoints
                        ]
                    })
                })
            ]
        })
    });
};
const $352318722b031741$var$examples = [
    {
        label: 'Sortable',
        Example: $352318722b031741$var$Sortable
    },
    {
        label: 'Clickable rows',
        Example: $352318722b031741$var$Clickable
    },
    {
        label: 'Selectable rows, with row actions',
        Example: $352318722b031741$var$Selectable
    },
    {
        label: 'Active row',
        Example: $352318722b031741$var$ActiveRow
    },
    {
        label: 'Column view: reordered, pinned, hidden, sized and resizable columns',
        Example: $352318722b031741$var$WithColumnView
    },
    {
        label: 'Paginated, with total count',
        Example: $352318722b031741$var$PaginatedWithTotalCount
    },
    {
        label: 'Paginated, with jump to page',
        Example: $352318722b031741$var$PaginatedWithJumpToPage
    },
    {
        label: 'Toolbar: search, filters and utilities',
        Example: $352318722b031741$var$WithToolbar
    },
    {
        label: 'Empty, first run',
        Example: $352318722b031741$var$Empty
    },
    {
        label: 'Empty, no match',
        Example: $352318722b031741$var$NoMatch
    },
    {
        label: 'Loading',
        Example: $352318722b031741$var$Loading
    },
    {
        label: 'Loading, over existing rows',
        Example: $352318722b031741$var$Reloading
    },
    {
        label: 'Search too short',
        Example: $352318722b031741$var$SearchTooShort
    },
    {
        label: 'Error, with Try again',
        Example: $352318722b031741$var$ErrorWithTryAgain
    },
    {
        label: 'Key/value, no header',
        Example: $352318722b031741$var$KeyValue
    },
    {
        label: 'Record panel, over its list',
        Example: $352318722b031741$var$WithRecordPanel
    }
];
const $352318722b031741$export$a17a6870a08b950e = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                sx: {
                    display: 'block',
                    mb: 4
                },
                children: "Table"
            }),
            $352318722b031741$var$examples.map(({ label: label, Example: Example })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: {
                        mb: 8
                    },
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                            variant: "subtitle2",
                            sx: {
                                mb: 2
                            },
                            children: label
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Example, {})
                    ]
                }, label))
        ]
    });




var $h4Bez = parcelRequire("h4Bez");

const $393281ab0cc069d6$var$typographyVariants = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'caption'
];
const $393281ab0cc069d6$var$fontWeights = [
    300,
    400,
    500,
    600,
    700
];
const $393281ab0cc069d6$export$1c6175f3aa4394b7 = ()=>{
    const [weight, setWeight] = (0, $h4Bez.useState)(400);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: {
                    my: 2
                },
                children: $393281ab0cc069d6$var$fontWeights.map((w)=>{
                    const variant = w === weight ? 'primary' : 'neutral';
                    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5c72e4be84329d1d$export$2e2bcd8739ae039), {
                        label: w,
                        onClick: ()=>setWeight(w),
                        variant: variant,
                        sx: {
                            mr: 1
                        }
                    }, w);
                })
            }),
            $393281ab0cc069d6$var$typographyVariants.map((variant)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    variant: variant,
                    fontWeight: weight,
                    sx: {
                        display: 'block',
                        mb: 2
                    },
                    children: [
                        "Typography - ",
                        variant
                    ]
                }, variant))
        ]
    });
};


const $b0013faaed75a5c3$var$dividerStyle = {
    my: 10
};
const $b0013faaed75a5c3$var$subpageStyle = {
    py: 4
};
const $b0013faaed75a5c3$var$Subpage = ({ children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $b0013faaed75a5c3$var$subpageStyle,
        children: children
    });
const $b0013faaed75a5c3$export$6ffe8cefce25fbcc = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($b0013faaed75a5c3$var$Subpage, {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $393281ab0cc069d6$export$1c6175f3aa4394b7), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {
                sx: $b0013faaed75a5c3$var$dividerStyle
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7bdd3ed6ff1fc3eb$export$4bd077ec7c23f6d3), {})
        ]
    });
const $b0013faaed75a5c3$export$62e7ff8df4bc3eb0 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($b0013faaed75a5c3$var$Subpage, {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $df7e1ff1b4c6b015$export$42ce93d1a224e3f9), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {
                sx: $b0013faaed75a5c3$var$dividerStyle
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $103e5506ee7c55f7$export$11b2ac0b0559e17), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {
                sx: $b0013faaed75a5c3$var$dividerStyle
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9195a8fc51eb0dd7$export$764e74833824089b), {})
        ]
    });
const $b0013faaed75a5c3$export$88fa59bfe77db40e = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b0013faaed75a5c3$var$Subpage, {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0a26dbdfba44e827$export$665d5a662b7213f3), {})
    });
const $b0013faaed75a5c3$export$4d797e6241882bba = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)($b0013faaed75a5c3$var$Subpage, {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $21a4fd398397de4e$export$ca60b63eaa3c28aa), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {
                sx: $b0013faaed75a5c3$var$dividerStyle
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0e82906113d7d836$export$edbc6635a693bcff), {})
        ]
    });
const $b0013faaed75a5c3$export$957c89a7c7c21b8f = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b0013faaed75a5c3$var$Subpage, {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $352318722b031741$export$a17a6870a08b950e), {})
    });
const $b0013faaed75a5c3$export$d142753ac0f33041 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($b0013faaed75a5c3$var$Subpage, {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $57795c3ffd69fbdd$export$36ba2f559d49a8f6), {})
    });



parcelRequire("h4Bez");



const $f0a053eb113cb8dd$var$tabs = {
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_FOUNDATIONS]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_FOUNDATIONS_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_FOUNDATIONS_DOCUMENTATION_BODY
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_INPUTS]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_INPUTS_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_INPUTS_DOCUMENTATION_BODY
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_BUTTONS]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_BUTTONS_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_BUTTONS_DOCUMENTATION_BODY
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_CHIPS_AND_STATUSES]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_CHIPS_AND_STATUSES_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_CHIPS_AND_STATUSES_DOCUMENTATION_BODY
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_TABLES]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_TABLES_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_TABLES_DOCUMENTATION_BODY
    },
    [(0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_NOTIFICATIONS]: {
        documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_NOTIFICATIONS_DOCUMENTATION_TITLE,
        documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK_NOTIFICATIONS_DOCUMENTATION_BODY
    }
};
const $f0a053eb113cb8dd$export$4313a588b5244577 = ()=>{
    const hasCapabilities = (0, $ed3a79aec495d063$export$95fa16a10fc41701)();
    return hasCapabilities((0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbf979062de799bc$export$7d4a22e995b7a67e), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).STORYBOOK,
        tabs: $f0a053eb113cb8dd$var$tabs
    }) : null;
};






parcelRequire("h4Bez");




parcelRequire("h4Bez");


"use client";
var $97c3b0add0c320c4$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1"
}), 'AddRounded');







const $4bede4de0b535d49$var$buttonStyle = {
    ml: 2
};
const $4bede4de0b535d49$var$NewButton = ({ label: label, onClick: onClick })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
        "data-testid": "add-button",
        sx: $4bede4de0b535d49$var$buttonStyle,
        variant: "primary",
        size: "large",
        startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $97c3b0add0c320c4$export$2e2bcd8739ae039), {}),
        onClick: onClick,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: label
        })
    });
const $4bede4de0b535d49$export$61fa0366a0ac91f3 = ()=>{
    const { createUserUsecase: createUserUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    const [onClick] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(()=>createUserUsecase.start(), [
        createUserUsecase
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($4bede4de0b535d49$var$NewButton, {
        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NEW_USER,
        onClick: onClick
    });
};
const $4bede4de0b535d49$export$451d0d68df5df3bb = ()=>{
    const { createRoleUsecase: createRoleUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    const [onClick] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(()=>createRoleUsecase.start(), [
        createRoleUsecase
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($4bede4de0b535d49$var$NewButton, {
        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NEW_ROLE,
        onClick: onClick
    });
};



const $93c082e950f74dd2$export$39f5674517ec0000 = {
    users: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_MANAGEMENT_USERS,
    roles: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_MANAGEMENT_ROLES,
    permissions: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_MANAGEMENT_PERMISSIONS
};




var $h4Bez = parcelRequire("h4Bez");








const $2f4754c4f5639c44$var$useSelectedTab = ()=>{
    const routing = (0, $42efdbd12003f6a9$export$ddab236f5c469f6f)();
    return (0, $h4Bez.useMemo)(()=>{
        let selected = null;
        for (const [tab, route] of (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)((0, $93c082e950f74dd2$export$39f5674517ec0000)))if (routing.isAtRoute(route)) {
            selected = tab;
            break;
        }
        return selected;
    }, [
        routing
    ]);
};
const $2f4754c4f5639c44$export$ec91da630f36d5ea = ()=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('filterUserManagementUsecase');
    const selected = $2f4754c4f5639c44$var$useSelectedTab();
    const isShow = (0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>selected && (0, $55a8cd2d1e96ead3$export$3d204d54547967c0)(s, selected), [
        selected
    ]);
    return selected !== null && isShow !== null && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7ef9ef826e2d35ed$export$2e2bcd8739ae039), {
        control: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $74886ba3288b8cfe$export$b5d5cf8927ab7262), {
            "data-testid": "show-internal",
            checked: isShow,
            onChange: ()=>usecase.toggleShowInternal(selected)
        }),
        label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SHOW_USER_MANAGEMENT_RESULTS,
            values: {
                type: selected
            }
        })
    });
};


const $e0b39ccf4bfabd30$var$documentation = {
    documentationTitle: (0, $40a99dac858c1d75$export$b63289fbda65eed1).USERS_AND_ROLES_DOCUMENTATION_TITLE,
    documentationBody: (0, $40a99dac858c1d75$export$b63289fbda65eed1).USERS_AND_ROLES_DOCUMENTATION_BODY
};
const $e0b39ccf4bfabd30$var$titleActions = {
    users: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2f4754c4f5639c44$export$ec91da630f36d5ea), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4bede4de0b535d49$export$61fa0366a0ac91f3), {})
        ]
    }),
    roles: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2f4754c4f5639c44$export$ec91da630f36d5ea), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4bede4de0b535d49$export$451d0d68df5df3bb), {})
        ]
    }),
    permissions: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2f4754c4f5639c44$export$ec91da630f36d5ea), {})
};
const $e0b39ccf4bfabd30$var$routeTabs = (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)((0, $93c082e950f74dd2$export$39f5674517ec0000)).reduce((r, [tab, path])=>({
        ...r,
        [path]: {
            ...$e0b39ccf4bfabd30$var$documentation,
            titleActions: $e0b39ccf4bfabd30$var$titleActions[tab]
        }
    }), {});
const $e0b39ccf4bfabd30$export$e0d644dad7ff53ec = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbf979062de799bc$export$7d4a22e995b7a67e), {
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).USERS_AND_ROLES,
        tabs: $e0b39ccf4bfabd30$var$routeTabs
    });



parcelRequire("h4Bez");





const $50694286d7ef95bc$export$cefc6f6f70a83003 = ({ method: method })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).USER_AUTHENTICATION_METHOD,
        values: {
            method: method
        }
    });
const $50694286d7ef95bc$var$checkboxesWrapperStyle = {
    justifyContent: 'space-evenly'
};
const $50694286d7ef95bc$var$checkboxStyle = {
    p: 0.5
};
const $50694286d7ef95bc$export$2c3b0a793974d321 = ({ disabled: disabled, authenticationMethods: authenticationMethods, required: required, usecase: usecase })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $81c4e0646fa4b7c0$export$2e2bcd8739ae039), {
        "data-testid": "authentication-methods",
        sx: $50694286d7ef95bc$var$checkboxesWrapperStyle,
        row: true,
        children: Object.values((0, $80ed8557cc0425cc$export$766a2ded12a6f943)).map((method)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7ef9ef826e2d35ed$export$2e2bcd8739ae039), {
                control: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2d1d930894f85d66$export$48513f6b9f8ce62d), {
                    "data-testid": method,
                    sx: $50694286d7ef95bc$var$checkboxStyle,
                    size: "small",
                    checked: authenticationMethods.includes(method),
                    disabled: disabled || required?.includes(method),
                    onChange: ()=>usecase.update({
                            authenticationMethods: Array.from((0, $bf45460f43a51d1f$export$25015dbcee3d4fb2)(new Set(authenticationMethods), method))
                        })
                }),
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($50694286d7ef95bc$export$cefc6f6f70a83003, {
                    method: method
                })
            }, method))
    });



parcelRequire("h4Bez");








parcelRequire("h4Bez");




const $08fef8d50b17090d$var$itemCollapsedStyle = {
    display: 'none'
};
const $08fef8d50b17090d$export$9f5504f85fa57068 = ({ expand: expand, size: size, children: children })=>{
    if (expand !== null) children = /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7830414f6fe32da6$export$2e2bcd8739ae039), {
        in: expand,
        unmountOnExit: true,
        children: children
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        sx: expand === false ? $08fef8d50b17090d$var$itemCollapsedStyle : undefined,
        size: {
            xs: size
        },
        children: children
    });
};
const $08fef8d50b17090d$var$labelWrapperStyle = {
    display: 'flex',
    alignItems: 'center'
};
const $08fef8d50b17090d$export$759d8cc6ccaa0b61 = ({ label: label, labelSize: labelSize = 3, endAdornmentSize: endAdornmentSize = 2, endAdornment: endAdornment = null, expand: expand = null, children: children })=>{
    const inputSize = 12 - labelSize - (endAdornment ? endAdornmentSize : 0);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($08fef8d50b17090d$export$9f5504f85fa57068, {
                expand: expand,
                size: labelSize,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: $08fef8d50b17090d$var$labelWrapperStyle,
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($08fef8d50b17090d$export$9f5504f85fa57068, {
                expand: expand,
                size: inputSize,
                children: children
            }),
            endAdornment !== null && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($08fef8d50b17090d$export$9f5504f85fa57068, {
                expand: expand,
                size: endAdornmentSize,
                children: endAdornment
            })
        ]
    });
};
const $08fef8d50b17090d$var$labelIconStyle = {
    color: 'secondary.main',
    mr: 1
};
const $08fef8d50b17090d$var$labelStyle = {
    mb: 0,
    lineHeight: '1.5rem'
};
const $08fef8d50b17090d$var$EntryLabel = ({ icon: Icon, children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            Icon && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Icon, {
                sx: $08fef8d50b17090d$var$labelIconStyle
            }),
            children
        ]
    });
const $08fef8d50b17090d$export$7209d3766a34ba = ({ label: label, values: values, icon: icon })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($08fef8d50b17090d$var$EntryLabel, {
        icon: icon,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $401b148a65fd432a$export$2e2bcd8739ae039), {
            sx: $08fef8d50b17090d$var$labelStyle,
            children: (0, $40a99dac858c1d75$export$552cd99e43fa1085)(label) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: label,
                values: values
            }) : label
        })
    });
const $08fef8d50b17090d$export$8fdd15abb0b1f9d8 = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d887fad28e7ec96c$export$2c73285ae9390cec), {
        fullWidth: true,
        ...props
    });
const $08fef8d50b17090d$export$77dbc7d5bbc061a0 = ({ type: type, canEditAll: canEditAll, canUpdateMfa: canUpdateMfa = false })=>{
    if (canEditAll) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($08fef8d50b17090d$export$759d8cc6ccaa0b61, {
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
            "data-testid": `${type}-not-editable`,
            variant: "body1",
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NOT_EDITABLE,
                values: {
                    canUpdateMfa: canUpdateMfa,
                    type: type
                }
            })
        })
    });
};



parcelRequire("h4Bez");





const $d7db1d79ae4ada44$var$titleStyle = {
    display: 'flex',
    '& > *': {
        margin: 'auto 0'
    },
    '& > h2': {
        marginRight: 'auto'
    },
    '& > button': {
        marginLeft: 1
    }
};
const $d7db1d79ae4ada44$var$errorStyle = {
    mr: 'auto'
};
const $d7db1d79ae4ada44$export$3ddf2d174ce01153 = ({ maxWidth: maxWidth, title: title, headerSuffix: headerSuffix, loading: loading, easyClose: easyClose = true, onClose: onClose, children: children, error: error, actionsSuffix: actionsSuffix })=>{
    const close = !loading ? onClose : undefined;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $55a2a796d4e0875c$export$2e2bcd8739ae039), {
        maxWidth: maxWidth,
        fullWidth: true,
        open: true,
        onClose: easyClose && close || undefined,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $dfd39f6bb0de9c2f$export$2e2bcd8739ae039), {
                sx: $d7db1d79ae4ada44$var$titleStyle,
                component: "div",
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                        variant: "subtitle1",
                        component: "h2",
                        children: title
                    }),
                    headerSuffix
                ]
            }),
            loading !== null && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2db76c9e9f88b3ff$export$2e2bcd8739ae039), {
                variant: loading ? 'indeterminate' : 'determinate',
                value: 0
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0aa27c46708d7ed8$export$2e2bcd8739ae039), {
                children: children
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $12b0eeebf4fed103$export$2e2bcd8739ae039), {
                children: [
                    (0, $c3e1b746ad236797$export$8d524fb6540252df).is(error) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
                        "data-testid": "confirmation-error",
                        sx: $d7db1d79ae4ada44$var$errorStyle,
                        error: error,
                        titleVariant: "subtitle1"
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                        "data-testid": "close",
                        variant: "secondary",
                        disabled: !close,
                        onClick: close,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CLOSE
                        })
                    }),
                    actionsSuffix
                ]
            })
        ]
    });
};




var $h4Bez = parcelRequire("h4Bez");








parcelRequire("h4Bez");





const $ca4b5d40ce97bd6a$var$paddedStyle = {
    p: 1
};
const $ca4b5d40ce97bd6a$var$deleteIconStyle = {
    ml: 1
};
const $ca4b5d40ce97bd6a$export$d6f68d0fe29f8050 = ({ loading: loading, error: error, ...props })=>{
    const setOrigin = (0, $5c50dcf7e155ce8c$export$b13dce3af0135d87)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
        ...props,
        variant: "dangerOutline",
        onClick: (e)=>setOrigin(e.currentTarget),
        children: loading ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $95388f9578043f1e$export$2e2bcd8739ae039), {
            size: "1.375rem"
        }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE
                }),
                (0, $c3e1b746ad236797$export$8d524fb6540252df).is(error) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $69cdbe69cde47e02$export$2e2bcd8739ae039), {
                    "data-testid": "delete-error-tooltip",
                    "data-title": error.message,
                    title: error.message,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5582262ddbabf0cc$export$2e2bcd8739ae039), {
                        sx: $ca4b5d40ce97bd6a$var$deleteIconStyle,
                        fontSize: "small",
                        color: "error"
                    })
                })
            ]
        })
    });
};
const $ca4b5d40ce97bd6a$export$d51a89a16810b11f = ({ onConfirm: onConfirm, children: children })=>{
    const setOrigin = (0, $5c50dcf7e155ce8c$export$b13dce3af0135d87)();
    const close = ()=>setOrigin(null);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $40650a35df6eb212$export$2e2bcd8739ae039), {
        onClose: close,
        anchorOrigin: {
            vertical: 'center',
            horizontal: 'center'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
        },
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
            sx: $ca4b5d40ce97bd6a$var$paddedStyle,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                container: true,
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                            variant: "body1",
                            align: "center",
                            children: children
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        size: {
                            xs: 6
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                            fullWidth: true,
                            variant: "secondary",
                            onClick: close,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CANCEL
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        size: {
                            xs: 6
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                            "data-testid": "deletion-confirmation",
                            fullWidth: true,
                            variant: "danger",
                            onClick: ()=>{
                                close();
                                onConfirm();
                            },
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE
                            })
                        })
                    })
                ]
            })
        })
    });
};


const $f92bd9e0f788f2a0$var$InternalManagedDialog = ({ title: title, confirmation: confirmation, deleteConfirmation: deleteConfirmation, usecase: usecaseName, forms: forms, advanced: initiallyAdvanced = null, resetable: resetable = 'id' in (0, $fbdaead6b0d14feb$export$4904853904034fa9)(forms), isRemovable: isRemovable, areEquals: areEquals, isConfirmable: isConfirmable, children: children, ...props })=>{
    const form = (0, $fbdaead6b0d14feb$export$4904853904034fa9)(forms);
    const initialForm = (0, $fbdaead6b0d14feb$export$c44b060058cf5112)(forms);
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)(usecaseName);
    const isLoading = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $da778fcb2b39c6da$export$62d55b06c6965c86));
    const id = 'id' in form ? form.id : null;
    const removable = (0, $h4Bez.useMemo)(()=>Boolean(id && isRemovable && isRemovable(form)), [
        id,
        form,
        isRemovable
    ]);
    const onClose = (0, $h4Bez.useCallback)(()=>usecase.close(), [
        usecase
    ]);
    const [confirm, confirming, confirmationResult] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(()=>usecase.confirm(), [
        usecase
    ]);
    const [remove, removing, removalResult] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(async ()=>{
        if ('delete' in usecase && id) await usecase.delete(id);
    }, [
        usecase,
        id
    ]);
    const reset = (0, $h4Bez.useCallback)(()=>usecase.update(initialForm), [
        usecase,
        initialForm
    ]);
    const [advanced, setAdvanced] = (0, $h4Bez.useState)(initiallyAdvanced);
    const equals = (0, $h4Bez.useMemo)(()=>areEquals(initialForm, form), [
        areEquals,
        initialForm,
        form
    ]);
    const loading = confirming || removing || isLoading;
    /**
     * Modal cannot confirm action if
     *
     * - It is already updating
     * - Form has id and current and initial form are the same
     * - Custom confirmation cannot be achieved
     */ const confirmable = (0, $h4Bez.useMemo)(()=>!(loading || id && equals) && isConfirmable(form), [
        form,
        isConfirmable,
        id,
        equals,
        loading
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d7db1d79ae4ada44$export$3ddf2d174ce01153), {
        ...props,
        title: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: title
        }),
        loading: loading,
        error: !confirming && confirmationResult || null,
        easyClose: equals,
        headerSuffix: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
            children: [
                advanced !== null && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $81c4e0646fa4b7c0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7ef9ef826e2d35ed$export$2e2bcd8739ae039), {
                        control: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $74886ba3288b8cfe$export$b5d5cf8927ab7262), {
                            "data-testid": "advanced-mode-switch",
                            checked: advanced,
                            onClick: ()=>setAdvanced(!advanced)
                        }),
                        label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ADVANCED_MODE
                        })
                    })
                }),
                resetable && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                    "data-testid": "reset",
                    variant: "secondary",
                    disabled: equals || loading,
                    onClick: reset,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).RESET
                    })
                }),
                deleteConfirmation && id && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $5c50dcf7e155ce8c$export$1d7e255c6105d39b), {
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca4b5d40ce97bd6a$export$d6f68d0fe29f8050), {
                            "data-testid": "delete",
                            loading: removing,
                            error: removalResult || null,
                            disabled: loading || !removable
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca4b5d40ce97bd6a$export$d51a89a16810b11f), {
                            onConfirm: remove,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                                id: deleteConfirmation,
                                values: form
                            })
                        })
                    ]
                })
            ]
        }),
        actionsSuffix: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
            "data-testid": "confirm",
            variant: "legacyAmber",
            disabled: !confirmable || loading,
            onClick: confirm,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: confirmation || (id ? (0, $40a99dac858c1d75$export$b63289fbda65eed1).UPDATE : (0, $40a99dac858c1d75$export$b63289fbda65eed1).CREATE)
            })
        }),
        onClose: onClose,
        children: children({
            loading: loading,
            advanced: advanced === true,
            equals: equals,
            form: form,
            usecase: usecase
        })
    });
};
const $f92bd9e0f788f2a0$export$3b6cdcdae5ebaf08 = ({ formSelector: formSelector, ...props })=>{
    const forms = (0, $be523f14267dcd17$export$9973955de2bf96cf)(formSelector, [
        formSelector
    ]);
    return forms && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($f92bd9e0f788f2a0$var$InternalManagedDialog, {
        forms: forms,
        ...props
    });
};




const $25f5cc2ef000fbb7$export$2f377d9a5f25589a = ({ mqttPublishPrefix: mqttPublishPrefix, disabled: disabled, usecase: usecase })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$8fdd15abb0b1f9d8), {
                "data-testid": "mqtt-publish-prefix",
                value: mqttPublishPrefix || '',
                disabled: disabled,
                onChange: ({ target: target })=>usecase.update({
                        mqttPublishPrefix: target.value.trim() || null
                    }),
                placeholder: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).MQTT_PUBLISH_PREFIX),
                startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $69cdbe69cde47e02$export$2e2bcd8739ae039), {
                    title: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MQTT_PUBLISH_PREFIX_WARNING
                    }),
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("span", {
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b535488bb7f5202c$export$25c6e96bbb971c7c), {
                            color: "error"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $57ff7f54e54013be$export$6eb1e07b1de459cd), {
                type: (0, $de76aa5bd91d062d$export$26609300e3bf37cf).MQTT_PREFIX,
                "data-testid": "mqtt-prefix-documentation",
                variant: "body2",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MQTT_PUBLISH_PREFIX_DOCUMENTATION
                })
            })
        ]
    });
};
const $25f5cc2ef000fbb7$export$4f56783c905d52d4 = ({ mqttPublishPrefixValidation: mqttPublishPrefixValidation })=>{
    if (mqttPublishPrefixValidation === null) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
        "data-testid": "mqtt-publish-prefix-validation",
        titleVariant: "body2",
        error: mqttPublishPrefixValidation,
        customTitle: (e)=>e.message
    });
};



parcelRequire("h4Bez");



"use client";
var $698b4657af2c6728$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "m22.7 19-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4"
}), 'Build');



"use client";
var $00d7719ae46a3aea$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 2 4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5zm-1.06 13.54L7.4 12l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41z"
}), 'GppGood');



"use client";
var $19a1064292bc130c$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2M9 8V6c0-1.66 1.34-3 3-3s3 1.34 3 3v2z"
}), 'LockRounded');



"use client";
var $6e48bab767ad5ab2$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4"
}), 'PersonRounded');



"use client";
var $fbced3b7dee1602a$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11z"
}), 'Security');



"use client";
var $7ba6276d18ac7d2d$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M20 10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4zm-6 4h-4v-4h4z"
}), 'Tag');



"use client";
var $7240b6b8d00435a6$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"
}), 'VpnKey');









parcelRequire("h4Bez");






var $h4Bez = parcelRequire("h4Bez");






parcelRequire("h4Bez");



"use client";
var $4d9778f7d6e46d3b$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3m-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3m0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5m8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5"
}), 'People');



"use client";
var $78ad74b2ada38b15$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2m-6 0h-4V4h4z"
}), 'Work');











const $f476f90a8693286f$var$RoleModalContent = ({ loading: loading, equals: equals, form: form, usecase: usecase })=>{
    const users = 'users' in form ? form.users : [];
    const id = 'id' in form ? form.id : null;
    const editUserUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('editUserUsecase');
    const [onUserClick] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)((u)=>editUserUsecase.load(u));
    const disabled = !form.canEditOthers || loading;
    const disabledEditName = !form.canEditName || loading;
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        alignContent: "center",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$77dbc7d5bbc061a0), {
                canEditAll: form.canEditOthers,
                type: "role"
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $78ad74b2ada38b15$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME
                }),
                endAdornmentSize: 1,
                endAdornment: id && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1ab636062450c95b$export$2414c4478e2423d7), {
                    button: (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                            variant: "legacyAmber",
                            fullWidth: true,
                            ...props
                        }),
                    children: form.name
                }),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$8fdd15abb0b1f9d8), {
                    "data-testid": "name",
                    value: form.name,
                    placeholder: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).ROLE_NAME),
                    disabled: disabledEditName,
                    onChange: ({ target: target })=>usecase.update({
                            name: target.value.trim()
                        })
                })
            }),
            form.ldapGroupDn !== null && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $78ad74b2ada38b15$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DN_OF_AD_GROUP
                }),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$8fdd15abb0b1f9d8), {
                    "data-testid": "ldapGroupDn",
                    value: form.ldapGroupDn,
                    placeholder: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).DN_OF_AD_GROUP),
                    disabled: disabled,
                    onChange: ({ target: target })=>usecase.update({
                            ldapGroupDn: target.value.trim()
                        })
                })
            }),
            form.msEntraIdGroupIds !== null && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $78ad74b2ada38b15$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENTRA_OBJECT_ID
                }),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e878dbad11e3bdcd$export$2f2b9559550c7bbc), {
                    "data-testid": "msEntraIdGroupIds",
                    multiple: true,
                    freeSolo: true,
                    disabled: disabled,
                    noOptionsText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ENTRIES_AVAILABLE,
                    value: [
                        ...form.msEntraIdGroupIds
                    ],
                    options: form.msEntraIdGroupIds,
                    onSelect: (data)=>usecase.update({
                            msEntraIdGroupIds: data
                        })
                })
            }),
            id && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $4d9778f7d6e46d3b$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).USER,
                    values: {
                        count: 2
                    }
                }),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    "data-testid": "users-list",
                    variant: "body2",
                    children: (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(users) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbba8fd6e98bab28$export$f52b44e459e6e71d), {
                        type: "conjunction",
                        value: equals && !disabled ? users.map((u)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a497eee141ca75b8$export$2e2bcd8739ae039), {
                                onClick: ()=>onUserClick(u),
                                children: u
                            }, u)) : users
                    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ACTIVE_USER,
                        values: {
                            count: users.length
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b6b11ac99fe9fc6c$export$aaa6e5e85f82e21d), {
                endAdornmentSize: 2,
                disabled: disabled,
                usecase: usecase,
                templateInput: form.templateInput,
                templates: form.templates,
                selectedTemplate: form.selectedTemplate
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                size: {
                    xs: 12
                },
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e9633f7d9e8a644a$export$7404dd6296ff0bad), {
                    disabled: disabled,
                    permissions: form.permissions,
                    usecase: usecase
                })
            })
        ]
    });
};
const $f476f90a8693286f$export$c218948993d85407 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f92bd9e0f788f2a0$export$3b6cdcdae5ebaf08), {
        maxWidth: "md",
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).EDIT_ROLE,
        deleteConfirmation: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_ROLE_CONFIRMATION,
        usecase: "editRoleUsecase",
        formSelector: (0, $fbdaead6b0d14feb$export$8c529c986e442e67),
        isRemovable: (0, $beeea5165e6b24a4$export$26dd36dca303eb23),
        areEquals: (0, $beeea5165e6b24a4$export$188c5a575d2c4e15),
        isConfirmable: (0, $beeea5165e6b24a4$export$173f0af7fce5fab1),
        children: $f476f90a8693286f$var$RoleModalContent
    });
const $f476f90a8693286f$export$e4784f42244bd9c6 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f92bd9e0f788f2a0$export$3b6cdcdae5ebaf08), {
        maxWidth: "md",
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CREATE_ROLE,
        usecase: "createRoleUsecase",
        formSelector: (0, $fbdaead6b0d14feb$export$bf7fc1d8540b77ce),
        areEquals: (0, $beeea5165e6b24a4$export$188c5a575d2c4e15),
        isConfirmable: (0, $beeea5165e6b24a4$export$5b8009ded575d6f),
        children: $f476f90a8693286f$var$RoleModalContent
    });




var $h4Bez = parcelRequire("h4Bez");





/** Shared, so the default keeps its identity between renders: a new array would change `value` and clear the typed search */ const $d6d37e6e615d71c1$var$NO_REQUIRED_ROLES = [];
const $d6d37e6e615d71c1$var$withOptionContent = (role)=>({
        ...role,
        icon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fbced3b7dee1602a$export$2e2bcd8739ae039), {}),
        meta: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TOTAL_PERMISSIONS,
            values: {
                count: role.permissions.length
            }
        })
    });
const $d6d37e6e615d71c1$export$92019fa6ff21f991 = ({ disabled: disabled, roles: roles, required: required = $d6d37e6e615d71c1$var$NO_REQUIRED_ROLES, allRoles: allRoles, usecase: usecase })=>{
    const value = (0, $h4Bez.useMemo)(()=>roles.map((role)=>({
                ...role,
                required: required.includes(role.name)
            })), [
        roles,
        required
    ]);
    const options = (0, $h4Bez.useMemo)(()=>(0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(allRoles) ? allRoles.map($d6d37e6e615d71c1$var$withOptionContent) : allRoles, [
        allRoles
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e878dbad11e3bdcd$export$2f2b9559550c7bbc), {
        "data-testid": "roles",
        multiple: true,
        options: options,
        getOptionLabel: (option)=>option.name,
        onSearch: (term)=>usecase.searchRoles(term),
        isOptionEqualToValue: (a, b)=>a.id === b.id,
        noOptionsText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ROLES_FOUND,
        value: value,
        disabled: disabled,
        onOpen: ()=>usecase.searchRoles(''),
        onClose: ()=>usecase.searchRoles(null),
        /** Strips the render-only `required`/`icon`/`meta` fields back off before it reaches app state, which should only ever hold real `CybusRole`s */ onSelect: (roles)=>usecase.selectRoles(roles.map((role)=>(0, $2ae70427bab197d4$export$12b617052eb9d30e)(role, 'required', 'icon', 'meta'))),
        // If only the required items are selected, than they auto clearing is not available
        disableClearable: required.length >= roles.length
    });
};



parcelRequire("h4Bez");





const $13d31098dcc3bfaf$export$7a5b979a220f477c = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const { editRoleUsecase: editRoleUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    const [onRowClick] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)((role)=>editRoleUsecase.start(role), [
        editRoleUsecase
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e03d152544a7d78a$export$6955bcca4cd3539f), {
        selected: "roles",
        columns: {
            name: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NAME
            },
            users: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).USER, {
                    count: 2
                }),
                customCellRender: (users)=>translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).ACTIVE_USER, {
                        count: users.length
                    })
            },
            permissions: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).PERMISSION, {
                    count: 0
                }),
                customCellRender: (permissions)=>`${permissions.length} ${translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).PERMISSION, {
                        count: permissions.length
                    }).toLowerCase()}`
            }
        },
        notFound: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ROLES_FOUND,
        onRowClick: onRowClick
    });
};





const $e03d152544a7d78a$var$Table = ({ selected: selected, notFound: notFound, columns: columns, onRetry: onRetry, ...props })=>{
    const data = (0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>(0, $55a8cd2d1e96ead3$export$4f3303962d683d6e)(s, selected), [
        selected
    ]);
    const search = (0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>(0, $55a8cd2d1e96ead3$export$9c7c2de2b1a0c08a)(s, selected), [
        selected
    ]);
    const page = (0, $be523f14267dcd17$export$9973955de2bf96cf)((s)=>(0, $55a8cd2d1e96ead3$export$723849c1426bff71)(s, selected), [
        selected
    ]);
    const isLoading = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $da778fcb2b39c6da$export$62d55b06c6965c86));
    const loaded = data === null || (0, $c3e1b746ad236797$export$8d524fb6540252df).is(data) ? null : data;
    const filterUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('filterUserManagementUsecase');
    const onCustomized = (0, $h4Bez.useCallback)((s)=>{
        if (isLoading) return;
        if ('page' in s) filterUsecase.setPage(selected, s.page + 1);
        if ('search' in s) filterUsecase.search(selected, s.search);
    }, [
        filterUsecase,
        selected,
        isLoading
    ]);
    const onRowClick = isLoading ? undefined : props.onRowClick;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
        columns: columns,
        data: loaded ? loaded.current : [],
        translations: {
            emptyTable: notFound
        },
        pagination: loaded ? {
            pageSize: loaded.pageSize,
            pageSizeOptions: [
                loaded.pageSize
            ],
            page: page - 1,
            totalCount: loaded.totalCount
        } : undefined,
        onRowClick: onRowClick,
        search: search === null || search,
        loading: data === null,
        error: (0, $c3e1b746ad236797$export$8d524fb6540252df).is(data) ? {
            error: data,
            onRetry: onRetry
        } : undefined,
        onCustomized: onCustomized
    });
};
const $e03d152544a7d78a$export$6955bcca4cd3539f = ({ children: children, ...props })=>{
    const loadUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('loadUserManagementDataUsecase');
    (0, $h4Bez.useEffect)(()=>loadUsecase.invoke(props.selected), [
        loadUsecase,
        props.selected
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "management-table",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($e03d152544a7d78a$var$Table, {
                ...props,
                onRetry: ()=>loadUsecase.retry(props.selected)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $673459177d13f346$export$d30ff6429dddb17), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $673459177d13f346$export$f64a2c436625a5c6), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f476f90a8693286f$export$c218948993d85407), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f476f90a8693286f$export$e4784f42244bd9c6), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7e741d82e58e9f43$export$3a55d3077442c540), {})
        ]
    });
};



var $h4Bez = parcelRequire("h4Bez");


"use client";
var $d357a45fa74402c6$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95M12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19"
}), 'DataUsage');




const $3a570dbf347700b3$var$contextValues = {
    /**
     * It is of the interest of backend to not have the control plane permissions be editable right now
     * Once and if that changes, this config object ought to be revised
     */ [(0, $10784336063bfb60$export$25544a24f1dbb74).CONTROL_PLANE]: {
        name: 'Control Plane',
        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SUBJECT,
        icon: (0, $h4Bez.Fragment),
        editable: false
    },
    [(0, $10784336063bfb60$export$25544a24f1dbb74).HTTP]: {
        name: 'Http',
        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENDPOINT,
        icon: (0, $d357a45fa74402c6$export$2e2bcd8739ae039),
        editable: true
    },
    [(0, $10784336063bfb60$export$25544a24f1dbb74).MQTT]: {
        name: 'Mqtt',
        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TOPIC,
        icon: (0, $7ba6276d18ac7d2d$export$2e2bcd8739ae039),
        editable: true
    }
};
const $3a570dbf347700b3$var$getContextValue = (prop, context)=>$3a570dbf347700b3$var$contextValues[context][prop];
const $3a570dbf347700b3$export$9af838fb5fa73c6e = ()=>(context)=>$3a570dbf347700b3$var$getContextValue('name', context);
const $3a570dbf347700b3$export$c2e773de6d9a98ea = (context)=>$3a570dbf347700b3$var$getContextValue('icon', context);
const $3a570dbf347700b3$export$83281b50e63abf2b = ()=>(context)=>$3a570dbf347700b3$var$getContextValue('editable', context);
const $3a570dbf347700b3$export$3c33102af7ea6193 = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return (0, $h4Bez.useCallback)((context, count = 1)=>translator.formatTranslation($3a570dbf347700b3$var$getContextValue('label', context), {
            count: count
        }), [
        translator
    ]);
};


const $55dafa8f5f1c7509$export$4c3b35afc6ca85c4 = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const translateName = (0, $3a570dbf347700b3$export$9af838fb5fa73c6e)();
    const viewPermissionUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('viewPermissionUsecase');
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e03d152544a7d78a$export$6955bcca4cd3539f), {
        selected: "permissions",
        columns: {
            resource: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).RESOURCE, {
                    count: 0
                })
            },
            context: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTEXT,
                customCellRender: translateName
            },
            users: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).USER, {
                    count: 2
                }),
                customCellRender: (users)=>translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).ACTIVE_USER, {
                        count: (0, $2ae70427bab197d4$export$ed97f33186d4b816)(users).length
                    })
            },
            roles: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).ROLE, {
                    count: 2
                }),
                customCellRender: (roles)=>translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).ACTIVE_ROLE, {
                        count: (0, $2ae70427bab197d4$export$ed97f33186d4b816)(roles).length
                    })
            }
        },
        notFound: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_PERMISSIONS_FOUND,
        onRowClick: (permission)=>viewPermissionUsecase.show(permission)
    });
};



parcelRequire("h4Bez");



var $h4Bez = parcelRequire("h4Bez");




const { Provider: $44e9d58a23dde7a9$var$Provider, useExtendedState: $44e9d58a23dde7a9$var$useExtendedState, useExtendedStateDispatcher: $44e9d58a23dde7a9$var$useExtendedStateDispatcher } = (0, $08b3e6ee09ecfd12$export$e50ad042342a539d)({
    ignorePropsChanges: true
});
const $44e9d58a23dde7a9$var$createValidateNewPermission = (usecase)=>(p)=>usecase.validateNewPermission(p);
const $44e9d58a23dde7a9$export$d961beac85047dd9 = ({ disabled: disabled, canLink: canLink = true, permissions: permissions, required: required = [], inherited: inherited = [], usecase: usecase, children: children })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const [merger, listener, manager] = (0, $h4Bez.useMemo)(()=>{
        const merger = new (0, $5fd4acf82e6163f5$export$97499fa49333a4d1)(permissions, required, inherited);
        const listener = new (0, $9fc21cc786388d5a$export$3291343375ee8b92)();
        const manager = new (0, $08b3e6ee09ecfd12$export$b20e70bc564b1116)({
            disabled: disabled,
            canLink: canLink,
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            search: '',
            permissions: permissions,
            required: required,
            inherited: inherited,
            merged: merger.getPermissions(),
            validateNewPermission: $44e9d58a23dde7a9$var$createValidateNewPermission(usecase),
            onClear: ()=>listener.trigger(manager.getState().required),
            onChange: (p, { read: read, write: write })=>{
                if (p.permission === null) // There was no permission there, so we are actually creating one from the inherented permissions
                listener.trigger([
                    ...manager.getState().permissions,
                    {
                        id: null,
                        context: p.context,
                        resource: p.resource,
                        read: read,
                        write: write
                    }
                ]);
                else if ((0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(p.inheritanceRoles) && p.inheritancesRead >= read && p.inheritancesWrite >= write) // New version of persistence is useless so remove it
                listener.trigger(manager.getState().permissions.filter((i)=>i !== p.permission));
                else // There is a permission, so update it
                listener.trigger(manager.getState().permissions.map((i)=>i === p.permission ? {
                        ...p.permission,
                        read: read,
                        write: write
                    } : i));
            },
            // New version of persistence is useless so remove it
            onRemove: (p)=>listener.trigger(manager.getState().permissions.filter((i)=>i !== p)),
            onAdd: (a)=>listener.trigger([
                    ...manager.getState().permissions,
                    a
                ])
        });
        return [
            merger,
            listener,
            manager
        ];
    }, [
        translator
    ]);
    /**
     * Handle listener changes without re setting all other state props
     */ (0, $h4Bez.useEffect)(()=>listener.on((permissions)=>usecase.update({
                permissions: permissions
            })), [
        listener,
        usecase
    ]);
    (0, $h4Bez.useEffect)(()=>manager.setState({
            validateNewPermission: $44e9d58a23dde7a9$var$createValidateNewPermission(usecase)
        }), [
        manager,
        usecase
    ]);
    /**
     * This takes care of updating the permissions internally
     */ (0, $h4Bez.useEffect)(()=>{
        const addedContext = merger.setAll(permissions, required, inherited);
        const state = {
            merged: merger.getPermissions(),
            inherited: inherited,
            required: required,
            permissions: permissions
        };
        if ((0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(addedContext) && !addedContext.includes(manager.getState().context)) state.context = addedContext[0];
        manager.setState(state);
    }, [
        merger,
        permissions,
        inherited,
        manager
    ]);
    (0, $h4Bez.useEffect)(()=>manager.setState({
            disabled: disabled,
            canLink: canLink
        }), [
        disabled,
        canLink,
        manager
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($44e9d58a23dde7a9$var$Provider, {
        manager: manager,
        children: children
    });
};
const $44e9d58a23dde7a9$export$e972580e5852a7ea = ()=>$44e9d58a23dde7a9$var$useExtendedState((s)=>s.canLink);
const $44e9d58a23dde7a9$export$c763bb7a184a0f11 = ()=>$44e9d58a23dde7a9$var$useExtendedState((s)=>s.disabled);
const $44e9d58a23dde7a9$export$bd221a7c56b93941 = ()=>$44e9d58a23dde7a9$var$useExtendedState((s)=>s.search);
const $44e9d58a23dde7a9$export$fae74005e78b1a27 = ()=>$44e9d58a23dde7a9$var$useExtendedState((s)=>s.context);
const $44e9d58a23dde7a9$export$6c45abf6e9c1270c = ()=>$44e9d58a23dde7a9$var$useExtendedState((s)=>!(0, $10784336063bfb60$export$2e83e407cf76af40)(s.permissions, s.required) ? s.onClear : null);
const $44e9d58a23dde7a9$export$7ad05cbce2a27fae = ()=>$44e9d58a23dde7a9$var$useExtendedState((s)=>s.onChange);
const $44e9d58a23dde7a9$export$cd5f353976a7168 = ()=>$44e9d58a23dde7a9$var$useExtendedState((s)=>s.onAdd);
const $44e9d58a23dde7a9$export$461189bbfd63cb62 = ()=>$44e9d58a23dde7a9$var$useExtendedState((s)=>s.onRemove);
const $44e9d58a23dde7a9$export$ea58f63775c61373 = ()=>$44e9d58a23dde7a9$var$useExtendedState((s)=>s.validateNewPermission);
const $44e9d58a23dde7a9$export$dde803638a7db51f = ()=>{
    const permissions = $44e9d58a23dde7a9$var$useExtendedState((s)=>s.merged[s.context], (a, b)=>(0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(a, b, {
            sort: false
        }));
    const search = $44e9d58a23dde7a9$export$bd221a7c56b93941();
    return (0, $h4Bez.useMemo)(()=>{
        const normalized = (0, $1e2b62fb1507b421$export$a3295358bff77e)(search.trim());
        const isSearching = Boolean(normalized.length);
        return [
            isSearching,
            !isSearching ? permissions : permissions.filter((p)=>(0, $d54af89b52a0b804$export$d76128d007d19019)((0, $1e2b62fb1507b421$export$a3295358bff77e)(p.resource), [
                    normalized
                ]))
        ];
    }, [
        permissions,
        search
    ]);
};
const $44e9d58a23dde7a9$export$7225806b637dcb3 = ()=>{
    const dispatch = $44e9d58a23dde7a9$var$useExtendedStateDispatcher();
    return (0, $h4Bez.useCallback)((context)=>dispatch({
            context: context
        }), [
        dispatch
    ]);
};
const $44e9d58a23dde7a9$export$7768d9cbb1ba6f45 = ()=>{
    const dispatch = $44e9d58a23dde7a9$var$useExtendedStateDispatcher();
    return (0, $h4Bez.useCallback)((search)=>dispatch({
            search: search
        }), [
        dispatch
    ]);
};




var $h4Bez = parcelRequire("h4Bez");











var $h4Bez = parcelRequire("h4Bez");



var $h4Bez = parcelRequire("h4Bez");


const $790f2bee43f1f591$export$262c15453f02e198 = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    return (0, $h4Bez.useMemo)(()=>({ read: read, write: write })=>translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).OPERATION_PERMISSION, {
                read: read,
                write: write
            }), [
        translator
    ]);
};


const $21b71e0e15b4f825$var$checkboxStyle = {
    py: 0
};
const $21b71e0e15b4f825$var$OperationCheckbox = ({ disabled: disabled, checked: checked, onChange: onChange, ...props })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7ef9ef826e2d35ed$export$2e2bcd8739ae039), {
        ...props,
        slotProps: {
            typography: {
                variant: 'body2'
            }
        },
        control: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2d1d930894f85d66$export$48513f6b9f8ce62d), {
            sx: $21b71e0e15b4f825$var$checkboxStyle,
            size: "small",
            disabled: disabled,
            checked: checked,
            onClick: onChange
        })
    });
const $21b71e0e15b4f825$export$2fad8251dd0330a8 = ({ readTitle: readTitle, writeTitle: writeTitle, disabled: disabled, disabledRead: disabledRead, disabledWrite: disabledWrite, read: read, write: write, onChange: onChange })=>{
    const translate = (0, $790f2bee43f1f591$export$262c15453f02e198)();
    const [readLabel, writeLabel] = (0, $h4Bez.useMemo)(()=>[
            translate({
                read: true,
                write: false
            }),
            translate({
                read: false,
                write: true
            })
        ], [
        translate
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($21b71e0e15b4f825$var$OperationCheckbox, {
                "data-testid": "read-input",
                title: readTitle,
                disabled: disabled || disabledRead,
                checked: read,
                label: readLabel,
                onChange: ()=>onChange({
                        read: !read,
                        write: write
                    })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($21b71e0e15b4f825$var$OperationCheckbox, {
                "data-testid": "write-input",
                title: writeTitle,
                disabled: disabled || disabledWrite,
                checked: write,
                label: writeLabel,
                onChange: ()=>onChange({
                        read: read,
                        write: !write
                    })
            })
        ]
    });
};



const $e67bf6a4ae06979e$var$wrapperStyle = {
    display: 'flex',
    alignItems: 'center'
};
const $e67bf6a4ae06979e$var$resourseStyle = {
    mr: 2
};
const $e67bf6a4ae06979e$var$PermissionLabel = /*#__PURE__*/ (0, $h4Bez.memo)(({ resource: resource })=>{
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": `permission-${resource}`,
        sx: $e67bf6a4ae06979e$var$wrapperStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $e67bf6a4ae06979e$var$resourseStyle,
                children: resource
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1ab636062450c95b$export$68054e84683f39b3), {
                children: resource
            })
        ]
    });
});
/**
 * @todo add tests for when a permission is required but without inheritance
 */ const $e67bf6a4ae06979e$var$PermissionOperationsList = /*#__PURE__*/ (0, $h4Bez.memo)(({ permission: permission })=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const disabled = (0, $44e9d58a23dde7a9$export$c763bb7a184a0f11)();
    const change = (0, $44e9d58a23dde7a9$export$7ad05cbce2a27fae)();
    const onChange = (0, $h4Bez.useCallback)(({ read: read, write: write })=>change(permission, {
            read: read,
            write: write
        }), [
        permission,
        change
    ]);
    const { inheritanceRoles: inheritanceRoles, inheritancesRead: inheritancesRead, inheritancesWrite: inheritancesWrite, read: read, write: write, required: required } = permission;
    const title = (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(inheritanceRoles) ? translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).INHERITED_FROM, {
        value: translator.formatList(inheritanceRoles)
    }) : undefined;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $21b71e0e15b4f825$export$2fad8251dd0330a8), {
        readTitle: title,
        writeTitle: title,
        disabled: disabled,
        disabledRead: inheritancesRead || required?.read,
        disabledWrite: inheritancesWrite || required?.write,
        read: read,
        write: write,
        onChange: onChange
    });
});
/** Pulled 2px into the cell padding above and below, so the 24px buttons centre on the cell's 20px text line without making the row taller */ const $e67bf6a4ae06979e$var$actionsWrapperStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1,
    my: -0.5
};
const $e67bf6a4ae06979e$var$roleIconStyle = {
    height: '0.75rem',
    width: '0.75rem',
    color: 'secondary.main',
    verticalAlign: 'middle'
};
const $e67bf6a4ae06979e$var$Actions = /*#__PURE__*/ (0, $h4Bez.memo)(({ permission: { permission: permission, required: required, inheritancesRead: inheritancesRead, inheritancesWrite: inheritancesWrite, inheritanceRoles: inheritanceRoles } })=>{
    const canLink = (0, $44e9d58a23dde7a9$export$e972580e5852a7ea)();
    const disabled = (0, $44e9d58a23dde7a9$export$c763bb7a184a0f11)();
    const remove = (0, $44e9d58a23dde7a9$export$461189bbfd63cb62)();
    const editRoleUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('editRoleUsecase');
    const tupples = [];
    if (permission && !required && (!(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(inheritanceRoles) || permission.read > inheritancesRead || permission.write > inheritancesWrite)) tupples.push([
        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: inheritanceRoles.length ? (0, $40a99dac858c1d75$export$b63289fbda65eed1).REMOVE_CUSTOMIZATION : (0, $40a99dac858c1d75$export$b63289fbda65eed1).REMOVE
        }, tupples.length),
        ()=>remove(permission)
    ]);
    if (!disabled && canLink) inheritanceRoles.forEach((role)=>tupples.push([
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).GO_TO,
                values: {
                    destination: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fbced3b7dee1602a$export$2e2bcd8739ae039), {
                                sx: $e67bf6a4ae06979e$var$roleIconStyle
                            }),
                            " ",
                            role
                        ]
                    })
                }
            }, tupples.length),
            ()=>editRoleUsecase.load(role)
        ]));
    if (!(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(tupples)) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NOT_AVAILABLE
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        sx: $e67bf6a4ae06979e$var$actionsWrapperStyle,
        children: tupples.map(([label, onClick], k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $h4Bez.Fragment), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                    "data-testid": "permissions-table-action",
                    variant: "secondary",
                    size: "small",
                    disabled: disabled,
                    onClick: onClick,
                    children: label
                })
            }, k))
    });
});
const $e67bf6a4ae06979e$export$f611c7256ad9c3ea = /*#__PURE__*/ (0, $h4Bez.memo)(()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const translateContextResource = (0, $3a570dbf347700b3$export$3c33102af7ea6193)();
    const context = (0, $44e9d58a23dde7a9$export$fae74005e78b1a27)();
    const [searching, permissions] = (0, $44e9d58a23dde7a9$export$dde803638a7db51f)();
    const displayed = (0, $h4Bez.useMemo)(()=>permissions.map((p)=>({
                resource: p.resource,
                operations: p,
                actions: p
            })).sort((a, b)=>a.resource > b.resource ? 1 : -1), [
        permissions
    ]);
    const columns = (0, $h4Bez.useMemo)(()=>({
            resource: {
                label: translateContextResource(context, 0),
                customCellRender: (p)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($e67bf6a4ae06979e$var$PermissionLabel, {
                        resource: p
                    })
            },
            operations: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).OPERATION, {
                    count: 0
                }),
                customCellRender: (p)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($e67bf6a4ae06979e$var$PermissionOperationsList, {
                        permission: p
                    })
            },
            actions: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).ACTION, {
                    count: 0
                }),
                customCellRender: (p)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($e67bf6a4ae06979e$var$Actions, {
                        permission: p
                    })
            }
        }), [
        translator,
        translateContextResource,
        context
    ]);
    const translations = (0, $h4Bez.useMemo)(()=>({
            noResultsOrEmptyTable: translator.formatTranslation(searching ? (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_PERMISSIONS_FOUND : (0, $40a99dac858c1d75$export$b63289fbda65eed1).TOTAL_PERMISSIONS, {
                count: 0
            })
        }), [
        translator,
        searching
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "permissions-table",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
            columns: columns,
            data: displayed,
            translations: translations,
            height: 200,
            search: false
        })
    });
});




var $h4Bez = parcelRequire("h4Bez");



"use client";
var $ca7eff70ce0f87f2$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M14.12 10.47 12 12.59l-2.13-2.12-1.41 1.41L10.59 14l-2.12 2.12 1.41 1.41L12 15.41l2.12 2.12 1.41-1.41L13.41 14l2.12-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8z"
}), 'DeleteForeverOutlined');







var $h4Bez = parcelRequire("h4Bez");



"use client";
var $165ee829a79d2b8e$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M18.99 11.5c.34 0 .67.03 1 .07L20 0 0 20h11.56c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5m3.71 7.99c.02-.16.04-.32.04-.49s-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49s.01.33.03.49l-1.06.83c-.09.08-.12.21-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32zm-3.71 1.01c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5"
}), 'PermDataSetting');









const $d497c10fdc931569$var$rootStyle = {
    '& > *': {
        mb: 1
    }
};
const $d497c10fdc931569$var$labelWrapperStyle = {
    display: 'flex',
    '& > *': {
        my: 'auto',
        mx: 0
    }
};
const $d497c10fdc931569$var$labelIconStyle = {
    color: 'secondary.main',
    mr: 1
};
const $d497c10fdc931569$var$contextButtonStyle = {
    color: 'secondary.main',
    textTransform: 'uppercase'
};
const $d497c10fdc931569$var$contextButtonsStyle = {
    width: '100%',
    '& > *': {
        flexGrow: 1
    }
};
const $d497c10fdc931569$var$contextSelectedStyle = {
    [`&.${(0, $62bfdfa4f6c0c890$export$2e2bcd8739ae039).selected}`]: {
        color: 'secondary.dark'
    }
};
const $d497c10fdc931569$var$operationsStyle = {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-around'
};
const $d497c10fdc931569$var$confirmationButtonStyle = {
    mb: 0
};
const $d497c10fdc931569$export$ab0e39137d02dea6 = ({ disabled: disabled, context: context, onAdd: onAdd })=>{
    const translateName = (0, $3a570dbf347700b3$export$9af838fb5fa73c6e)();
    const translateContextResource = (0, $3a570dbf347700b3$export$3c33102af7ea6193)();
    const isEditable = (0, $3a570dbf347700b3$export$83281b50e63abf2b)();
    const [permission, setPermission] = (0, $h4Bez.useState)(()=>({
            id: null,
            context: context,
            resource: '',
            read: true,
            write: false
        }));
    const Icon = (0, $3a570dbf347700b3$export$c2e773de6d9a98ea)(permission.context);
    const [add, loading, result] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(()=>onAdd(permission), [
        onAdd,
        permission
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "permission-creation-form",
        sx: $d497c10fdc931569$var$rootStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                variant: "body2",
                align: "center",
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ADD_PERMISSION
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $d497c10fdc931569$var$labelWrapperStyle,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $698b4657af2c6728$export$2e2bcd8739ae039), {
                        color: "secondary",
                        sx: $d497c10fdc931569$var$labelIconStyle
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $14b4a2aa98aa8378$export$40258cc1d95ff477), {
                        sx: $d497c10fdc931569$var$contextButtonsStyle,
                        exclusive: true,
                        children: Object.values((0, $10784336063bfb60$export$25544a24f1dbb74)).map((context)=>{
                            const selected = permission.context === context;
                            return isEditable(context) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a0c70995540c0264$export$d2b052e7b4be1756), {
                                sx: [
                                    $d497c10fdc931569$var$contextButtonStyle,
                                    selected && $d497c10fdc931569$var$contextSelectedStyle
                                ],
                                "data-testid": `permission-context-${context.toLowerCase()}`,
                                value: context,
                                selected: selected,
                                onClick: ()=>setPermission((p)=>({
                                            ...p,
                                            context: context
                                        })),
                                children: translateName(context)
                            }, context) : null;
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $d497c10fdc931569$var$labelWrapperStyle,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)(Icon, {
                        sx: $d497c10fdc931569$var$labelIconStyle
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d887fad28e7ec96c$export$2c73285ae9390cec), {
                        "data-testid": "permission-resource",
                        placeholder: translateContextResource(permission.context),
                        fullWidth: true,
                        value: permission.resource,
                        onChange: ({ target: { value: value } })=>setPermission((p)=>({
                                    ...p,
                                    resource: value.trim()
                                }))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                sx: $d497c10fdc931569$var$labelWrapperStyle,
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $165ee829a79d2b8e$export$2e2bcd8739ae039), {
                        sx: $d497c10fdc931569$var$labelIconStyle
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        sx: $d497c10fdc931569$var$operationsStyle,
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $21b71e0e15b4f825$export$2fad8251dd0330a8), {
                            read: permission.read,
                            write: permission.write,
                            onChange: (operations)=>setPermission((p)=>({
                                        ...p,
                                        ...operations
                                    }))
                        })
                    })
                ]
            }),
            !loading && (0, $c3e1b746ad236797$export$8d524fb6540252df).is(result) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
                "data-testid": "permission-creation-error",
                error: result,
                titleVariant: "body2",
                customTitle: (e)=>e.message
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                "data-testid": "permission-creation-confirmation",
                fullWidth: true,
                variant: "legacyAmber",
                disabled: disabled,
                onClick: add,
                sx: $d497c10fdc931569$var$confirmationButtonStyle,
                children: loading ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $95388f9578043f1e$export$2e2bcd8739ae039), {
                    size: "1.375rem"
                }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                    id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ADD
                })
            })
        ]
    });
};




parcelRequire("h4Bez");




const $697b5954dc7089f7$var$buttonStyle = {
    p: 0,
    cursor: 'pointer'
};
const $697b5954dc7089f7$export$cfc7921d29ef7b80 = ({ disabled: customDisabled, tooltip: tooltip, children: children, ...props })=>{
    const disabled = (0, $44e9d58a23dde7a9$export$c763bb7a184a0f11)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $69cdbe69cde47e02$export$2e2bcd8739ae039), {
        title: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: tooltip
        }),
        placement: "bottom",
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
            component: 'span',
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0128221b0851485d$export$c25acd513dcc8062), {
                ...props,
                variant: "ghost",
                disabled: customDisabled || disabled,
                sx: $697b5954dc7089f7$var$buttonStyle,
                children: children
            })
        })
    });
};



const $2e2600e6de4c3167$var$searchStyle = {
    mb: 1,
    mr: 1
};
const $2e2600e6de4c3167$var$searchIconStyle = {
    cursor: 'pointer'
};
const $2e2600e6de4c3167$var$SearchInput = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const disabled = (0, $44e9d58a23dde7a9$export$c763bb7a184a0f11)();
    const search = (0, $44e9d58a23dde7a9$export$bd221a7c56b93941)();
    const onChange = (0, $44e9d58a23dde7a9$export$7768d9cbb1ba6f45)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d887fad28e7ec96c$export$2c73285ae9390cec), {
        "data-testid": "search-input",
        placeholder: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).SEARCH_PLACEHOLDER, {
            count: 0
        }),
        sx: $2e2600e6de4c3167$var$searchStyle,
        startIcon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5844aca28da17e19$export$2e2bcd8739ae039), {
            sx: $2e2600e6de4c3167$var$searchIconStyle
        }),
        disabled: disabled,
        value: search,
        onChange: ({ target: target })=>onChange(target.value),
        onClick: (e)=>e.currentTarget.querySelector('input').focus()
    });
};
const $2e2600e6de4c3167$var$wrapperStyle = {
    display: 'flex'
};
const $2e2600e6de4c3167$var$tabRootStyle = {
    minHeight: 32,
    height: 32,
    marginRight: 'auto'
};
const $2e2600e6de4c3167$var$tabIndicatorStyle = {
    backgroundColor: 'secondary.main'
};
const $2e2600e6de4c3167$var$addFormWrapperStyle = {
    p: 1,
    minWidth: 300
};
const $2e2600e6de4c3167$export$eebe949f9efaf8f8 = /*#__PURE__*/ (0, $h4Bez.memo)(()=>{
    const disabled = (0, $44e9d58a23dde7a9$export$c763bb7a184a0f11)();
    const context = (0, $44e9d58a23dde7a9$export$fae74005e78b1a27)();
    const dispatchContext = (0, $44e9d58a23dde7a9$export$7225806b637dcb3)();
    const add = (0, $44e9d58a23dde7a9$export$cd5f353976a7168)();
    const clear = (0, $44e9d58a23dde7a9$export$6c45abf6e9c1270c)();
    const validate = (0, $44e9d58a23dde7a9$export$ea58f63775c61373)();
    const translateName = (0, $3a570dbf347700b3$export$9af838fb5fa73c6e)();
    const isEditable = (0, $3a570dbf347700b3$export$83281b50e63abf2b)();
    const anchor = (0, $5c50dcf7e155ce8c$export$718dfabee0fc16f8)();
    const setOrigin = (0, $5c50dcf7e155ce8c$export$b13dce3af0135d87)();
    const close = ()=>setOrigin(null);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
        "data-testid": "permissions-tabs",
        sx: $2e2600e6de4c3167$var$wrapperStyle,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f113645bdb4030ab$export$2e2bcd8739ae039), {
                TabIndicatorProps: {
                    sx: $2e2600e6de4c3167$var$tabIndicatorStyle
                },
                sx: $2e2600e6de4c3167$var$tabRootStyle,
                value: context,
                onChange: (_, newContext)=>dispatchContext(newContext),
                children: Object.values((0, $10784336063bfb60$export$25544a24f1dbb74)).map((context)=>isEditable(context) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca50fd7418c7c1d3$export$2e2bcd8739ae039), {
                        "data-testid": `permissions-tab-${context.toLowerCase()}`,
                        sx: $2e2600e6de4c3167$var$tabRootStyle,
                        value: context,
                        label: translateName(context)
                    }, context) : null)
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($2e2600e6de4c3167$var$SearchInput, {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $697b5954dc7089f7$export$cfc7921d29ef7b80), {
                "data-testid": "clear-permissions-button",
                disabled: !clear,
                tooltip: (0, $40a99dac858c1d75$export$b63289fbda65eed1).REMOVE_ALL_PERMISSIONS,
                onClick: clear || undefined,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca7eff70ce0f87f2$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $697b5954dc7089f7$export$cfc7921d29ef7b80), {
                "data-testid": "add-permission-button",
                tooltip: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ADD_PERMISSION,
                onClick: (e)=>setOrigin(e.currentTarget),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $97c3b0add0c320c4$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $40650a35df6eb212$export$2e2bcd8739ae039), {
                onClose: close,
                anchorOrigin: {
                    vertical: 'center',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                children: anchor && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: $2e2600e6de4c3167$var$addFormWrapperStyle,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d497c10fdc931569$export$ab0e39137d02dea6), {
                        disabled: disabled,
                        context: context,
                        onAdd: (permission)=>{
                            try {
                                validate(permission);
                                add(permission);
                            } catch (e) {
                                return Promise.reject(e);
                            }
                            close();
                            dispatchContext(permission.context);
                            return Promise.resolve();
                        }
                    })
                })
            })
        ]
    });
});


const $e9633f7d9e8a644a$export$7404dd6296ff0bad = (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $44e9d58a23dde7a9$export$d961beac85047dd9), {
        ...props,
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5c50dcf7e155ce8c$export$1d7e255c6105d39b), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e2600e6de4c3167$export$eebe949f9efaf8f8), {})
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e67bf6a4ae06979e$export$f611c7256ad9c3ea), {})
        ]
    });




var $h4Bez = parcelRequire("h4Bez");


"use client";
var $cc98e237c703dbbd$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm-1 4 6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2zm-1 7h5.5L14 6.5z"
}), 'FileCopy');



"use client";
var $4ed078b09dd442d9$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"
}), 'Person');







const $b6b11ac99fe9fc6c$var$withOptionContent = (option)=>{
    const { icon: icon, permissions: permissions } = 'username' in option ? {
        icon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4ed078b09dd442d9$export$2e2bcd8739ae039), {}),
        permissions: option.allPermissions
    } : {
        icon: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fbced3b7dee1602a$export$2e2bcd8739ae039), {}),
        permissions: option.permissions
    };
    return {
        ...option,
        icon: icon,
        meta: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TOTAL_PERMISSIONS,
            values: {
                count: permissions.length
            }
        })
    };
};
const $b6b11ac99fe9fc6c$export$aaa6e5e85f82e21d = ({ expand: expand, endAdornmentSize: endAdornmentSize = 1, disabled: disabled, usecase: usecase, templateInput: templateInput, templates: templates, selectedTemplate: selectedTemplate })=>{
    const options = (0, $h4Bez.useMemo)(()=>(0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(templates) ? templates.map($b6b11ac99fe9fc6c$var$withOptionContent) : templates, [
        templates
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
        expand: expand,
        labelSize: 3,
        endAdornmentSize: endAdornmentSize,
        label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
            icon: (0, $cc98e237c703dbbd$export$2e2bcd8739ae039),
            label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).COPY_PERMISSIONS
        }),
        endAdornment: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
            "data-testid": "apply-template-button",
            variant: "legacyAmber",
            fullWidth: true,
            disabled: disabled || !selectedTemplate || !('username' in selectedTemplate ? selectedTemplate.allPermissions.length : selectedTemplate.permissions.length),
            onClick: selectedTemplate ? ()=>usecase.applyTemplate(selectedTemplate) : undefined,
            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ADD
            })
        }),
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e878dbad11e3bdcd$export$2f2b9559550c7bbc), {
            "data-testid": "template",
            options: options,
            getOptionLabel: (option)=>'username' in option ? option.username : option.name,
            isOptionEqualToValue: (a, b)=>a === b || a.id === b.id,
            onSearch: (term)=>usecase.searchTemplates(term),
            noOptionsText: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_TEMPLATES_AVAILABLE,
            value: selectedTemplate,
            disabled: disabled,
            // strips the render-only icon/meta fields; destructuring (not Omit) since Omit doesn't distribute over this union
            onSelect: (data)=>{
                if (!data) {
                    usecase.selectTemplate(null);
                    return;
                }
                const { icon: icon, meta: meta, ...userOrRole } = data;
                usecase.selectTemplate(userOrRole);
            },
            onOpen: ()=>usecase.searchTemplates(templateInput || '')
        })
    });
};



parcelRequire("h4Bez");










const $7e741d82e58e9f43$var$resourceWrapperStyle = {
    display: 'flex',
    '& > *': {
        my: 'auto',
        mx: 0
    }
};
const $7e741d82e58e9f43$var$resourceStyle = {
    typography: 'body2',
    background: 'grey.100',
    borderRadius: 3,
    color: 'grey.800',
    py: 0.25,
    px: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
};
const $7e741d82e58e9f43$var$copyWrapperStyle = {
    display: 'flex'
};
const $7e741d82e58e9f43$var$copyStyle = {
    ml: 'auto'
};
const $7e741d82e58e9f43$var$OperationsTable = ({ data: data, onClick: onClick })=>{
    const translate = (0, $790f2bee43f1f591$export$262c15453f02e198)();
    const isLoading = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $da778fcb2b39c6da$export$62d55b06c6965c86));
    const [onAsyncClick] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)((name)=>onClick(name), [
        onClick
    ]);
    const grouped = (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(data).reduce((r, [name, { read: read, write: write }])=>{
        const label = translate({
            read: read,
            write: write
        });
        return {
            ...r,
            [label]: [
                ...r[label] || [],
                name
            ]
        };
    }, {});
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: true,
        alignContent: "center",
        alignItems: "center",
        children: (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(grouped).map(([label, values], k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    variant: "body2",
                    children: [
                        '- ',
                        label
                    ]
                }),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    variant: "body2",
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbba8fd6e98bab28$export$f52b44e459e6e71d), {
                        value: isLoading ? values : values.sort().map((name, k)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a497eee141ca75b8$export$2e2bcd8739ae039), {
                                onClick: ()=>onAsyncClick(name),
                                children: name
                            }, k)),
                        style: "narrow"
                    })
                })
            }, k))
    });
};
const $7e741d82e58e9f43$var$ViewModalContent = ({ permission: info })=>{
    const { editUserUsecase: editUserUsecase, editRoleUsecase: editRoleUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    const translateContext = (0, $3a570dbf347700b3$export$9af838fb5fa73c6e)();
    const translateContextResource = (0, $3a570dbf347700b3$export$3c33102af7ea6193)();
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        alignContent: "center",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    label: translateContextResource(info.context)
                }),
                endAdornment: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: $7e741d82e58e9f43$var$copyWrapperStyle,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1ab636062450c95b$export$92ce62e1201c4fc0), {
                        sx: $7e741d82e58e9f43$var$copyStyle,
                        children: info.resource
                    })
                }),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                    sx: $7e741d82e58e9f43$var$resourceWrapperStyle,
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $7f71da25a1486af3$export$2e2bcd8739ae039), {
                        component: 'span',
                        sx: $7e741d82e58e9f43$var$resourceStyle,
                        children: info.resource
                    })
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTEXT
                }),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d3cc2294f10b2d1f$export$2e2bcd8739ae039), {
                    variant: "body2",
                    children: translateContext(info.context)
                })
            }),
            !(0, $2ae70427bab197d4$export$dd1bc94b04021eeb)(info.users) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                        label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                            label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).USER,
                            values: {
                                count: 2
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        "data-testid": "users",
                        size: {
                            xs: 12
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($7e741d82e58e9f43$var$OperationsTable, {
                            data: info.users,
                            onClick: (name)=>editUserUsecase.load(name)
                        })
                    })
                ]
            }),
            !(0, $2ae70427bab197d4$export$dd1bc94b04021eeb)(info.roles) && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                        label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                            label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ROLE,
                            values: {
                                count: 2
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
                        "data-testid": "roles",
                        size: {
                            xs: 12
                        },
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($7e741d82e58e9f43$var$OperationsTable, {
                            data: info.roles,
                            onClick: (name)=>editRoleUsecase.load(name)
                        })
                    })
                ]
            })
        ]
    });
};
const $7e741d82e58e9f43$export$3a55d3077442c540 = ()=>{
    const viewPermissionUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('viewPermissionUsecase');
    const permission = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $fbdaead6b0d14feb$export$8c76e358ba74451b));
    const isTransfering = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $da778fcb2b39c6da$export$62d55b06c6965c86));
    return permission && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d7db1d79ae4ada44$export$3ddf2d174ce01153), {
        maxWidth: "sm",
        title: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).PERMISSION,
            values: {
                count: 1
            }
        }),
        onClose: !isTransfering ? ()=>viewPermissionUsecase.close() : undefined,
        loading: isTransfering ? true : null,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($7e741d82e58e9f43$var$ViewModalContent, {
            permission: permission
        })
    });
};






const $673459177d13f346$var$UserModalContent = ({ advanced: advanced, loading: loading, equals: equals, form: form, usecase: usecase })=>{
    const id = 'id' in form ? form.id : null;
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const disabledUserNameField = !form.canEditName || loading;
    const disabledOtherField = !form.canEditOthers || loading;
    const disabledMFAField = !form.canUpdateMFA || loading;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        alignContent: "center",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$77dbc7d5bbc061a0), {
                canEditAll: form.canEditOthers,
                canUpdateMfa: form.canUpdateMFA,
                type: "user"
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $6e48bab767ad5ab2$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).USERNAME
                }),
                endAdornmentSize: 1,
                endAdornment: id && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1ab636062450c95b$export$2414c4478e2423d7), {
                    button: (props)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                            "data-testid": "username-copy-button",
                            variant: "legacyAmber",
                            fullWidth: true,
                            ...props
                        }),
                    children: form.username
                }),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$8fdd15abb0b1f9d8), {
                    "data-testid": "username",
                    placeholder: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).USERNAME),
                    value: form.username,
                    autoComplete: "off",
                    disabled: disabledUserNameField,
                    onChange: ({ target: target })=>usecase.update({
                            username: target.value.trim()
                        })
                })
            }),
            form.usernameValidation !== null && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fb671afc24ce07a1$export$d0473d205c8ede55), {
                    validations: (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(form.usernameValidation) ? form.usernameValidation : [
                        form.usernameValidation
                    ],
                    "data-testid": "username-validation"
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $19a1064292bc130c$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).PASSWORD
                }),
                children: [
                    form.password === null && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                        "data-testid": "change-password-button",
                        variant: "legacyAmber",
                        disabled: disabledOtherField,
                        onClick: ()=>usecase.update({
                                password: '',
                                passwordConfirmation: ''
                            }),
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                            id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CHANGE_PASSWORD
                        })
                    }),
                    form.password !== null && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$8fdd15abb0b1f9d8), {
                        "data-testid": "password",
                        type: form.passwordConfirmation === null ? 'text' : 'password',
                        placeholder: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).PASSWORD),
                        value: form.password,
                        autoComplete: "new-password",
                        disabled: disabledOtherField,
                        onChange: ({ target: target })=>usecase.update({
                                password: target.value
                            }),
                        slotProps: {
                            input: {
                                endAdornment: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2aefb57dc041c2ec$export$2e2bcd8739ae039), {
                                    position: "end",
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ce2f632502216d89$export$241ba0b938fcb9f), {
                                        "data-testid": form.passwordConfirmation === null ? 'toggle-password-visible' : 'toggle-password-hidden',
                                        visible: form.passwordConfirmation === null,
                                        disabled: disabledOtherField,
                                        onToggle: ()=>usecase.togglePasswordMode(),
                                        showLabel: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).SHOW_PASSWORD),
                                        hideLabel: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).HIDE_PASSWORD)
                                    })
                                })
                            }
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                expand: form.passwordConfirmation !== null,
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $09dab4bc1b3aad02$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONFIRM_PASSWORD
                }),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$8fdd15abb0b1f9d8), {
                    "data-testid": "password-confirmation",
                    type: "password",
                    value: form.passwordConfirmation || '',
                    disabled: disabledOtherField,
                    placeholder: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).CONFIRM_PASSWORD),
                    onChange: ({ target: target })=>usecase.update({
                            passwordConfirmation: target.value
                        }),
                    autoComplete: "new-password"
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                expand: form.password !== null,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fb671afc24ce07a1$export$d0473d205c8ede55), {
                    validations: form.passwordValidation === null ? [] : (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(form.passwordValidation) ? form.passwordValidation : [
                        form.passwordValidation
                    ],
                    "data-testid": "password-validation"
                })
            }),
            'mfaStatus' in form && form.mfaStatus !== (0, $37c2a8e29603f683$export$5e93ec1eb1a0effa).NOT_SETUP && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $00d7719ae46a3aea$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MULTI_FACTOR_AUTHENTICATION_ACRONYM
                }),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                    "data-testid": "disable-mfa-button",
                    variant: "legacyAmber",
                    disabled: disabledMFAField || form.mfaStatus === (0, $37c2a8e29603f683$export$5e93ec1eb1a0effa).DISABLED,
                    onClick: ()=>usecase.update({
                            mfaStatus: (0, $37c2a8e29603f683$export$5e93ec1eb1a0effa).DISABLED
                        }),
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: form.mfaStatus === (0, $37c2a8e29603f683$export$5e93ec1eb1a0effa).ENABLED ? (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE : (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLED
                    })
                })
            }),
            form.isMfaEnforced !== null && /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $b3344c5f781513f7$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENFORCE_MFA_USAGE
                }),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
                    "data-testid": "enforce-usage-button",
                    variant: "legacyAmber",
                    disabled: disabledMFAField,
                    onClick: ()=>usecase.update({
                            isMfaEnforced: !form.isMfaEnforced
                        }),
                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
                        id: form.isMfaEnforced ? (0, $40a99dac858c1d75$export$b63289fbda65eed1).DISABLE : (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENABLE
                    })
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $fbced3b7dee1602a$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ROLE,
                    values: {
                        count: 2
                    }
                }),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d6d37e6e615d71c1$export$92019fa6ff21f991), {
                    disabled: disabledOtherField,
                    roles: form.roles,
                    allRoles: form.allRoles,
                    usecase: usecase
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$9f5504f85fa57068), {
                expand: advanced,
                size: 12,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                expand: advanced,
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $698b4657af2c6728$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ADDITIONAL_PERMISSION,
                    values: {
                        count: 0
                    }
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b6b11ac99fe9fc6c$export$aaa6e5e85f82e21d), {
                expand: advanced,
                disabled: disabledOtherField,
                usecase: usecase,
                templateInput: form.templateInput,
                templates: form.templates,
                selectedTemplate: form.selectedTemplate
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$9f5504f85fa57068), {
                expand: advanced,
                size: 12,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e9633f7d9e8a644a$export$7404dd6296ff0bad), {
                    disabled: disabledOtherField,
                    canLink: equals,
                    permissions: form.permissions,
                    inherited: form.rolesPermissions,
                    usecase: usecase
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                labelSize: 4,
                expand: advanced,
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $7240b6b8d00435a6$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).AUTHENTICATION_METHODS
                }),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $50694286d7ef95bc$export$2c3b0a793974d321), {
                    authenticationMethods: form.authenticationMethods,
                    disabled: disabledOtherField,
                    usecase: usecase
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                expand: advanced,
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $7ba6276d18ac7d2d$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MQTT_PUBLISH_PREFIX
                }),
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $25f5cc2ef000fbb7$export$2f377d9a5f25589a), {
                        mqttPublishPrefix: form.mqttPublishPrefix,
                        disabled: disabledOtherField,
                        usecase: usecase
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $25f5cc2ef000fbb7$export$4f56783c905d52d4), {
                        mqttPublishPrefixValidation: form.mqttPublishPrefixValidation
                    })
                ]
            })
        ]
    });
};
const $673459177d13f346$export$d30ff6429dddb17 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f92bd9e0f788f2a0$export$3b6cdcdae5ebaf08), {
        maxWidth: "md",
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).EDIT_USER,
        deleteConfirmation: (0, $40a99dac858c1d75$export$b63289fbda65eed1).DELETE_USER_CONFIRMATION,
        usecase: "editUserUsecase",
        formSelector: (0, $fbdaead6b0d14feb$export$cf1548ec5e235d39),
        isRemovable: (0, $80ed8557cc0425cc$export$8dde6ee29d5a3169),
        areEquals: (0, $80ed8557cc0425cc$export$97e30f316783ac5b),
        isConfirmable: (0, $80ed8557cc0425cc$export$d458ae297c13a3ff),
        advanced: false,
        children: $673459177d13f346$var$UserModalContent
    });
const $673459177d13f346$export$f64a2c436625a5c6 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f92bd9e0f788f2a0$export$3b6cdcdae5ebaf08), {
        maxWidth: "md",
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CREATE_USER,
        usecase: "createUserUsecase",
        formSelector: (0, $fbdaead6b0d14feb$export$c3255b8cef0af79),
        areEquals: (0, $80ed8557cc0425cc$export$9c1a922921014239),
        isConfirmable: (0, $80ed8557cc0425cc$export$967824c71a20c40b),
        advanced: false,
        children: $673459177d13f346$var$UserModalContent
    });



parcelRequire("h4Bez");







const $34616985b8e54725$var$MFAStatusLabel = ({ mfaStatus: mfaStatus })=>mfaStatus === (0, $37c2a8e29603f683$export$5e93ec1eb1a0effa).NOT_APPLICABLE || mfaStatus === (0, $37c2a8e29603f683$export$5e93ec1eb1a0effa).NOT_SETUP ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NOT_AVAILABLE
    }) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b38816d2b66de72f$export$2e2bcd8739ae039), {
        status: mfaStatus === (0, $37c2a8e29603f683$export$5e93ec1eb1a0effa).ENABLED ? (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLED : (0, $1041b3cad55163d4$export$e35c1996c6f482ad).NOT_ENABLED
    });
const $34616985b8e54725$export$107317390f5aa598 = ()=>{
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const { editUserUsecase: editUserUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    const [onUserClick] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)((u)=>editUserUsecase.load(u));
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e03d152544a7d78a$export$6955bcca4cd3539f), {
        selected: "users",
        columns: {
            username: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).USERNAME
            },
            roles: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).ROLE, {
                    count: 2
                }),
                customCellRender: (roles)=>(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(roles) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbba8fd6e98bab28$export$f52b44e459e6e71d), {
                        value: roles,
                        style: "narrow"
                    }) : translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_ROLES)
            },
            allPermissions: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).PERMISSION, {
                    count: 0
                }),
                customCellRender: (permissions)=>translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).TOTAL_PERMISSIONS, {
                        count: new Set(permissions.map((p)=>p.resource)).size
                    })
            },
            authenticationMethods: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).AUTHENTICATION_METHODS,
                customCellRender: (methods)=>(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(methods) ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dbba8fd6e98bab28$export$f52b44e459e6e71d), {
                        value: methods.map((method)=>translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).USER_AUTHENTICATION_METHOD, {
                                method: method
                            })).sort(),
                        style: "narrow"
                    }) : translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).CANNOT_AUTHENTICATE)
            },
            mfaStatus: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MULTI_FACTOR_AUTHENTICATION,
                customCellRender: (mfaStatus)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($34616985b8e54725$var$MFAStatusLabel, {
                        mfaStatus: mfaStatus
                    })
            },
            lastSeen: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).LAST_SEEN,
                type: 'datetime',
                customCellRender: (lastSeen)=>lastSeen === null ? translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).NOT_AVAILABLE) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$1b17df352e43d1d3), {
                        value: lastSeen
                    })
            },
            provider: {
                label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).PROVIDER,
                customCellRender: (provider)=>translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).USER_PROVIDER, {
                        provider: provider
                    })
            }
        },
        notFound: (0, $40a99dac858c1d75$export$b63289fbda65eed1).NO_USERS_FOUND,
        onRowClick: onUserClick
    });
};








var $h4Bez = parcelRequire("h4Bez");






var $h4Bez = parcelRequire("h4Bez");





const $dcec8314b4d243cd$var$COUNTDOWN_TICK_MS = 1000;
const $dcec8314b4d243cd$export$d0084a769a8b06c0 = ()=>{
    const locked = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $823726049107e73f$export$624c20a5b74bddc6));
    const unlockedUntil = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $823726049107e73f$export$404928cf445cfb00));
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    /**
     * The original rendered a self-updating `<FormattedRelativeTime>` (ticks every second).
     * `InlineAlert`'s content is a plain string, so this re-renders on the same cadence instead,
     * recomputing the formatted string fresh each time.
     */ const [, forceTick] = (0, $h4Bez.useState)(0);
    (0, $076f55b7ca6ba74a$export$ede2eb47b82c13a2)(()=>forceTick((tick)=>tick + 1), $dcec8314b4d243cd$var$COUNTDOWN_TICK_MS);
    /** Hidden once the time is up, before the registry is relocked */ if (unlockedUntil === null || locked || unlockedUntil.getTime() <= Date.now()) return null;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2a12619a779dd8d7$export$a3b2c96db9b0eb71), {
        severity: (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).INFO,
        content: {
            kind: 'descriptionOnly',
            description: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).CLIENT_REGISTRY_SELF_REGISTRATION, {
                formattedTimeLeft: translator.formatTimeLeft(unlockedUntil)
            })
        }
    });
};



parcelRequire("h4Bez");



"use client";
var $4e51ddb2ddbe604d$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm2 16H8v-2h8zm0-4H8v-2h8zm-3-5V3.5L18.5 9z"
}), 'Description');







const $334cdd9836856e9e$var$RegistryModalContent = ({ loading: loading, usecase: usecase, advanced: advanced, form: { username: username, roles: roles, authenticationMethods: authenticationMethods, permissions: permissions, rolesPermissions: rolesPermissions, mqttPublishPrefix: mqttPublishPrefix, request: request, mqttPublishPrefixValidation: mqttPublishPrefixValidation, templateInput: templateInput, templates: templates, selectedTemplate: selectedTemplate, allRoles: allRoles } })=>{
    const disabled = loading;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $98bfbe695b65cf7e$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        alignContent: "center",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                labelSize: 3,
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $6e48bab767ad5ab2$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).USERNAME
                }),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$8fdd15abb0b1f9d8), {
                    "data-testid": "username",
                    value: username,
                    disabled: true
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                labelSize: 3,
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $4e51ddb2ddbe604d$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTEXT
                }),
                children: request.description
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                labelSize: 3,
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $fbced3b7dee1602a$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ROLE,
                    values: {
                        count: 2
                    }
                }),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d6d37e6e615d71c1$export$92019fa6ff21f991), {
                    disabled: disabled,
                    required: request.roles,
                    roles: roles,
                    allRoles: allRoles,
                    usecase: usecase
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$9f5504f85fa57068), {
                expand: advanced,
                size: 12,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9f72024c38d1931c$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                expand: advanced,
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $698b4657af2c6728$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ADDITIONAL_PERMISSION,
                    values: {
                        count: 0
                    }
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b6b11ac99fe9fc6c$export$aaa6e5e85f82e21d), {
                expand: advanced,
                disabled: disabled,
                usecase: usecase,
                templateInput: templateInput,
                templates: templates,
                selectedTemplate: selectedTemplate
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$9f5504f85fa57068), {
                expand: advanced,
                size: 12,
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e9633f7d9e8a644a$export$7404dd6296ff0bad), {
                    disabled: disabled,
                    permissions: permissions,
                    required: request.permissions,
                    inherited: rolesPermissions,
                    usecase: usecase
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                expand: advanced,
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $7240b6b8d00435a6$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).AUTHENTICATION_METHODS
                }),
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $50694286d7ef95bc$export$2c3b0a793974d321), {
                    authenticationMethods: authenticationMethods,
                    required: [
                        request.authenticationMethod
                    ],
                    disabled: disabled,
                    usecase: usecase
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $08fef8d50b17090d$export$759d8cc6ccaa0b61), {
                expand: advanced,
                label: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08fef8d50b17090d$export$7209d3766a34ba), {
                    icon: (0, $7ba6276d18ac7d2d$export$2e2bcd8739ae039),
                    label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MQTT_PUBLISH_PREFIX
                }),
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $25f5cc2ef000fbb7$export$2f377d9a5f25589a), {
                        mqttPublishPrefix: mqttPublishPrefix,
                        disabled: disabled,
                        usecase: usecase
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $25f5cc2ef000fbb7$export$4f56783c905d52d4), {
                        mqttPublishPrefixValidation: mqttPublishPrefixValidation
                    })
                ]
            })
        ]
    });
};
const $334cdd9836856e9e$export$9f6a42df38a5a663 = ()=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f92bd9e0f788f2a0$export$3b6cdcdae5ebaf08), {
        maxWidth: "md",
        title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).GRANT_ACCESS,
        usecase: "allowClientRegistryRequestUsecase",
        formSelector: (0, $fbdaead6b0d14feb$export$830f6d06818aa34),
        areEquals: (0, $6d780693ef9ac26e$export$c07d35a8c9093be8),
        isConfirmable: (0, $6d780693ef9ac26e$export$3018d73bcedee4fa),
        advanced: false,
        resetable: true,
        confirmation: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ALLOW,
        children: $334cdd9836856e9e$var$RegistryModalContent
    });



parcelRequire("h4Bez");







parcelRequire("h4Bez");


"use client";
var $651ab939076e6a3f$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1z"
}), 'Lock');



"use client";
var $cc1876d677128aa4$export$2e2bcd8739ae039 = (0, $88f728827016eaaa$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)("path", {
    d: "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m0 12H6V10h12z"
}), 'LockOpen');







const $52d1d0460077c131$export$5ed0484c8fc12e8a = ()=>{
    const locked = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $823726049107e73f$export$624c20a5b74bddc6));
    const isLoading = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $da778fcb2b39c6da$export$62d55b06c6965c86));
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('toggleLockClientRegistryUsecase');
    const [toggle, toggling, toggleError] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(()=>usecase.invoke(), [
        usecase
    ]);
    const showError = (0, $c3e1b746ad236797$export$8d524fb6540252df).is(toggleError) && !toggling;
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ca1ea2b88c04430e$export$353f5b6fc5456de1), {
        "data-testid": "registry-lock-toggle-button",
        title: showError ? toggleError.message : undefined,
        startIcon: showError ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $08c9290ca718566e$export$2e2bcd8739ae039), {}) : locked ? /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $cc1876d677128aa4$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $651ab939076e6a3f$export$2e2bcd8739ae039), {}),
        variant: showError ? 'danger' : 'primary',
        disabled: toggling,
        onClick: isLoading ? undefined : toggle,
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
            id: locked ? (0, $40a99dac858c1d75$export$b63289fbda65eed1).UNLOCK : (0, $40a99dac858c1d75$export$b63289fbda65eed1).LOCK
        })
    });
};


const $0cd132894ff306e6$var$NoRequests = ()=>{
    const locked = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $823726049107e73f$export$624c20a5b74bddc6));
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$5bc2e2836f7b63ab), {
        id: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CLIENT_REGISTRY_NO_REQUESTS,
        values: {
            locked: locked
        }
    });
};
const $0cd132894ff306e6$export$8be7c40b825f85b9 = ()=>{
    const locked = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $823726049107e73f$export$624c20a5b74bddc6));
    const requests = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $823726049107e73f$export$cbf35af70ae0b3a9));
    const isLoading = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $da778fcb2b39c6da$export$62d55b06c6965c86));
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('allowClientRegistryRequestUsecase');
    const [onRowClick] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)((request)=>usecase.load(request));
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $be3703687194c6e0$export$56e2352e63353d99), {
                title: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CLIENT_REGISTRY,
                titleActions: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $52d1d0460077c131$export$5ed0484c8fc12e8a), {}),
                description: [
                    (0, $40a99dac858c1d75$export$b63289fbda65eed1).CLIENT_REGISTRY_DOCUMENTATION_TITLE,
                    (0, $40a99dac858c1d75$export$b63289fbda65eed1).CLIENT_REGISTRY_DOCUMENTATION_BODY
                ]
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1a719df2b816a6fd$export$54ec01a60f47d33d), {
                columns: {
                    username: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).USERNAME
                    },
                    description: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTEXT
                    },
                    timestamp: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).TIMESTAMP,
                        customCellRender: (date)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcd310acfec43287$export$d275c5eeba29af75), {
                                date: date,
                                format: "datetime"
                            }),
                        type: 'datetime'
                    },
                    authenticationMethod: {
                        label: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CREDENTIALS,
                        customCellRender: (method)=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $50694286d7ef95bc$export$cefc6f6f70a83003), {
                                method: method
                            })
                    }
                },
                pagination: {
                    pageSize: 15,
                    pageSizeOptions: [
                        15
                    ]
                },
                data: requests,
                search: !locked,
                onRowClick: isLoading ? undefined : onRowClick,
                translations: {
                    noResultsOrEmptyTable: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)($0cd132894ff306e6$var$NoRequests, {})
                }
            })
        ]
    });
};


const $c62ce75de6cab1a2$export$4d9facee29974f3 = ()=>{
    const loadClientRegistryUsecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('loadClientRegistryUsecase');
    (0, $h4Bez.useEffect)(()=>loadClientRegistryUsecase.invoke(), [
        loadClientRegistryUsecase
    ]);
    const loading = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $823726049107e73f$export$bd49409b92fc83cc));
    const error = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $823726049107e73f$export$23d7982a2b8920cd));
    if (loading) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $35e2f7ba0c5bb8e5$export$8b8493c40023057), {});
    if (error) return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b39283bccca0350b$export$915e9e7bd4f0f96d), {
        error: error,
        stack: true,
        extras: "section"
    });
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $0cd132894ff306e6$export$8be7c40b825f85b9), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dcec8314b4d243cd$export$d0084a769a8b06c0), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $334cdd9836856e9e$export$9f6a42df38a5a663), {})
        ]
    });
};








var $h4Bez = parcelRequire("h4Bez");





const $440c6989d538dffe$var$VERSION_MISMATCH_DISMISS_KEY = 'version-mismatch';
const $440c6989d538dffe$export$c962982833242e24 = ()=>{
    const differingVersions = (0, $be523f14267dcd17$export$9973955de2bf96cf)((0, $d5b2f7653d87e9de$export$45f532a7dd683b77), (v)=>`${v?.ui || ''}_${v?.connectware || ''}`);
    const translator = (0, $dcd310acfec43287$export$e6df4a75350b1cee)();
    const { bannerUsecase: bannerUsecase, fixVersionUsecase: fixVersionUsecase, versionUsecase: versionUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    /** Verify the version from the backend every couple of seconds */ const [loadVersions] = (0, $13b0dee6e916241c$export$fbeb804c371ac8d)(()=>versionUsecase.loadVersions(), [
        versionUsecase
    ]);
    (0, $076f55b7ca6ba74a$export$ede2eb47b82c13a2)(loadVersions, 20000, [
        versionUsecase
    ]);
    (0, $h4Bez.useEffect)(()=>{
        if (!differingVersions) {
            /** Lets the banner reappear if a mismatch recurs after having been dismissed. */ bannerUsecase.clear($440c6989d538dffe$var$VERSION_MISMATCH_DISMISS_KEY);
            return;
        }
        bannerUsecase.show({
            severity: (0, $92fb5cdf920c06d4$export$a794f5b0ae8fc3c2).ERROR,
            title: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).VERSION_MISMATCH_TITLE),
            description: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).VERSION_MISMATCH_BODY, {
                backend: differingVersions.connectware,
                frontend: differingVersions.ui
            }),
            action: {
                label: translator.formatTranslation((0, $40a99dac858c1d75$export$b63289fbda65eed1).VERSION_MISMATCH_ACTION),
                onClick: ()=>fixVersionUsecase.invoke()
            },
            dismissKey: $440c6989d538dffe$var$VERSION_MISMATCH_DISMISS_KEY
        });
    }, [
        differingVersions,
        bannerUsecase,
        fixVersionUsecase,
        translator
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {});
};







var $h4Bez = parcelRequire("h4Bez");


const $bfd16e469e7be595$export$7ba78694d320932f = ()=>{
    const usecase = (0, $be523f14267dcd17$export$b5eb5d2a4e80beed)('workbenchUsecase');
    const routing = (0, $42efdbd12003f6a9$export$ddab236f5c469f6f)();
    (0, $h4Bez.useLayoutEffect)(()=>{
        /** Open the workbench on the first render */ usecase.open();
        /** Go back to the previous */ routing.goBack();
    }, []);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2e41620b030ed79e$exports.Fragment), {});
};




/**
 * What a table's row opens in a record panel: the details each route renders below, by route
 *
 * Built on first use, as the modules of the details can still be loading when this one is evaluated
 */ const $5a1cbe913fab6236$var$getRecordPanelDetails = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>({
        [(0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SYSTEM_CONTAINER]: (0, $8e812dfa8afe1563$export$3e8048d3cf2ba3fd),
        [(0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_SERVER]: (0, $d7661f3b06033a4b$export$3e8048d3cf2ba3fd),
        [(0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_SERVER]: (0, $d7661f3b06033a4b$export$3e8048d3cf2ba3fd),
        [(0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_CONTAINER]: (0, $becc98231f066a19$export$3e8048d3cf2ba3fd),
        [(0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_CONTAINER]: (0, $becc98231f066a19$export$3e8048d3cf2ba3fd),
        [(0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_VOLUME]: (0, $c6ea7bd2008464e0$export$3e8048d3cf2ba3fd),
        [(0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_VOLUME]: (0, $c6ea7bd2008464e0$export$3e8048d3cf2ba3fd),
        [(0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_CONNECTION]: (0, $23d5314ef0d7ad96$export$3e8048d3cf2ba3fd),
        [(0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_CONNECTION]: (0, $23d5314ef0d7ad96$export$3e8048d3cf2ba3fd),
        [(0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_ENDPOINT]: (0, $a8768b642b75109a$export$3e8048d3cf2ba3fd),
        [(0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_ENDPOINT]: (0, $a8768b642b75109a$export$3e8048d3cf2ba3fd),
        [(0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_MAPPING]: (0, $fb3f6e672e265b77$export$3e8048d3cf2ba3fd),
        [(0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_MAPPING]: (0, $fb3f6e672e265b77$export$3e8048d3cf2ba3fd),
        [(0, $0e5d1fb0e9c69012$export$91969d5ee4870de).SERVICES_OVERVIEW_SERVICE]: (0, $cca0e2b81f68ec73$export$3e8048d3cf2ba3fd),
        [(0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_SERVICE]: (0, $cca0e2b81f68ec73$export$3e8048d3cf2ba3fd)
    }));
const $5a1cbe913fab6236$var$RouterAppNavigation = ({ children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $1944c28923ef9414$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2d0aa3751ae45f4c$export$a9627919734faa48), {
                children: [
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $cf0025d93820ff7a$export$140c5c8fcbe43661), {
                        deviationsBadge: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b3c972accded84b0$export$32b83f3e4d46bc89), {}),
                        mobileDeviationsBadge: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b3c972accded84b0$export$32b83f3e4d46bc89), {
                            popoverPlacement: "below"
                        }),
                        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $663c2020f609bbba$export$6cb0eff68b40b60a), {
                            details: $5a1cbe913fab6236$var$getRecordPanelDetails(),
                            children: children
                        })
                    }),
                    /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $40adcaf4784cb817$export$36ba2f559d49a8f6), {})
                ]
            })
        ]
    });
/**
 * `RouteNavigation`'s own `banner` prop can't be supplied through `CybusRouter`'s `routeNavigation`
 * API (it only accepts a plain `FC<PropsWithChildren>`, re-instantiated per route match) - so this
 * wrapper closes over `<BannerRenderer/>` here at the composition root instead, the same way
 * `RouterAppNavigation` above wires up feature-level cross-cutting concerns.
 */ const $5a1cbe913fab6236$var$AppRouteNavigation = ({ children: children })=>/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $2f937a6adf26c73c$export$fff6fad3c74051f6), {
        banner: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fd33ca2436f16cce$export$809c310d187fd9ec), {}),
        children: children
    });
const $5a1cbe913fab6236$export$86fbec116b87613f = ()=>{
    const { loginFromTokenUsecase: loginFromTokenUsecase, loginFromPersistenceUsecase: loginFromPersistenceUsecase, debugApplicationUsecase: debugApplicationUsecase } = (0, $be523f14267dcd17$export$9c9c809bfed75cbf)();
    (0, $h4Bez.useLayoutEffect)(()=>{
        /**
         * Attempt to login from either the token on the url
         * or the persisted information from local storage
         */ loginFromTokenUsecase.loginBrowserFromToken() || loginFromPersistenceUsecase.loginWithPersistedInformation();
        /**
         * Activate debugging of the application
         */ debugApplicationUsecase.activate();
    }, [
        loginFromTokenUsecase,
        loginFromPersistenceUsecase,
        debugApplicationUsecase
    ]);
    return /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $2e41620b030ed79e$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a3412fd06c064a0d$export$e93312b7773dfcac), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $194709df1d74eb82$export$7221d69dcfc8e36b), {
                children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $e20170eea887eb89$export$3c670f8556d976af), {
                    initial: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM,
                    onNotFound: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM,
                    appNavigation: $5a1cbe913fab6236$var$RouterAppNavigation,
                    routeNavigation: $5a1cbe913fab6236$var$AppRouteNavigation,
                    deniedAccess: (0, $701d06218cd04dd6$export$2ea013db82b51c49),
                    children: [
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$2d8d895a0a0f636e), {
                                to: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_STATUS
                            })
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_STATUS,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$2d8d895a0a0f636e), {
                                to: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_LICENSE,
                                fallbackToSiblings: true
                            })
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $e20170eea887eb89$export$3b0b963b9c1f6f6c), {
                            prefix: (0, $a41f810df71af281$export$444c7346aa399f17),
                            children: [
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_CONTAINERS,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d32ed8d9a58d6793$export$4ff334d9a17b4fc3), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_INTERNET_CONNECTIVITY,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b02280fe32ee04dc$export$646b27bc07df3b98), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_METRICS,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $35175334afe3bb1f$export$ed9166ec0f465b5e), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_AGENTS,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $766278ae845073fa$export$6929ce49fce4ad0), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_LICENSE,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $32877b473a860a7a$export$771fbc65b432e290), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SYSTEM_INFORMATION,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $ede68930367fa45e$export$1baf5169e987a757), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SYSTEM_CONTAINER,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8e812dfa8afe1563$export$3e8048d3cf2ba3fd), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).DATA,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$2d8d895a0a0f636e), {
                                to: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).DATA_EXPLORER
                            })
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).DATA_EXPLORER,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $3dbcce4b5c540ccc$export$43584986cb77a794), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$2d8d895a0a0f636e), {
                                to: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_OVERVIEW,
                                fallbackToSiblings: true
                            })
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_OVERVIEW,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $959991498573f865$export$54ec01a60f47d33d), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).DEVIATED_SERVICES,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $672619bd636a45c6$export$a3716a896367b27f), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            paths: [
                                (0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_SERVER,
                                (0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_SERVER
                            ],
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $d7661f3b06033a4b$export$3e8048d3cf2ba3fd), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            paths: [
                                (0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_CONTAINER,
                                (0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_CONTAINER
                            ],
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $becc98231f066a19$export$3e8048d3cf2ba3fd), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            paths: [
                                (0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_VOLUME,
                                (0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_VOLUME
                            ],
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c6ea7bd2008464e0$export$3e8048d3cf2ba3fd), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            paths: [
                                (0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_CONNECTION,
                                (0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_CONNECTION
                            ],
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $23d5314ef0d7ad96$export$3e8048d3cf2ba3fd), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            paths: [
                                (0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_ENDPOINT,
                                (0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_ENDPOINT
                            ],
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $a8768b642b75109a$export$3e8048d3cf2ba3fd), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            paths: [
                                (0, $0e5d1fb0e9c69012$export$6bdb9064cdfd6775).SERVICE_MAPPING,
                                (0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_MAPPING
                            ],
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $fb3f6e672e265b77$export$3e8048d3cf2ba3fd), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            paths: [
                                (0, $0e5d1fb0e9c69012$export$91969d5ee4870de).SERVICES_OVERVIEW_SERVICE,
                                (0, $0e5d1fb0e9c69012$export$4aab3fd492e2cb26).SERVICES_RESOURCES_SERVICE
                            ],
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $cca0e2b81f68ec73$export$3e8048d3cf2ba3fd), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_LOGS,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $9470f199663bdb4a$export$22ef66d3c161d6a7), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$2d8d895a0a0f636e), {
                                to: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_LINKS,
                                fallbackToSiblings: true
                            })
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $e20170eea887eb89$export$3b0b963b9c1f6f6c), {
                            prefix: (0, $f034751aa3113dc8$export$c567de8874d31a3a),
                            children: [
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_LINKS,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $8dbb6bdfa2188f09$export$b2e089eb3692b073), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_SERVERS,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $91a76748a62a49cb$export$54ec01a60f47d33d), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_NODES,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $77ad22a2e1029f2f$export$54ec01a60f47d33d), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_CONTAINERS,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $10bd0f4559270f58$export$54ec01a60f47d33d), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_VOLUMES,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $4b9327e4a1d2954f$export$54ec01a60f47d33d), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_CONNECTIONS,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $dc980d3784041744$export$54ec01a60f47d33d), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_ENDPOINTS,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b82f9b509446bc25$export$54ec01a60f47d33d), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RESOURCES_MAPPINGS,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $50bc70341a26085b$export$54ec01a60f47d33d), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_RULE_ENGINE_SANDBOX,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $52f46374fd68acb2$export$aaaea0ead6b8e811), {
                                Editor: (0, $949bfb63ec3d8bd4$export$7105d214197992e9)
                            })
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SERVICES_WORKBENCH,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $bfd16e469e7be595$export$7ba78694d320932f), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$2d8d895a0a0f636e), {
                                to: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_MANAGEMENT
                            })
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_MANAGEMENT,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$2d8d895a0a0f636e), {
                                to: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_MANAGEMENT_USERS,
                                fallbackToSiblings: true
                            })
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $e20170eea887eb89$export$3b0b963b9c1f6f6c), {
                            prefix: (0, $e0b39ccf4bfabd30$export$e0d644dad7ff53ec),
                            children: [
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_MANAGEMENT_USERS,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $34616985b8e54725$export$107317390f5aa598), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_MANAGEMENT_ROLES,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $13d31098dcc3bfaf$export$7a5b979a220f477c), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_MANAGEMENT_PERMISSIONS,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $55dafa8f5f1c7509$export$4c3b35afc6ca85c4), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_CLIENT_REGISTRY,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $c62ce75de6cab1a2$export$4d9facee29974f3), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).USER_CERTIFICATES,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $97384466d51b2d56$export$c39d74429c80a86b), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SETTINGS,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$2d8d895a0a0f636e), {
                                to: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SETTINGS_LOGIN
                            })
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).SETTINGS_LOGIN,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $093786e8d7b00ac6$export$f7ec98692e4afe96), {})
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                            path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK,
                            children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$2d8d895a0a0f636e), {
                                to: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_FOUNDATIONS,
                                fallbackToSiblings: true
                            })
                        }),
                        /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsxs)((0, $e20170eea887eb89$export$3b0b963b9c1f6f6c), {
                            prefix: (0, $f0a053eb113cb8dd$export$4313a588b5244577),
                            children: [
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_FOUNDATIONS,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b0013faaed75a5c3$export$6ffe8cefce25fbcc), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_INPUTS,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b0013faaed75a5c3$export$62e7ff8df4bc3eb0), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_BUTTONS,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b0013faaed75a5c3$export$88fa59bfe77db40e), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_CHIPS_AND_STATUSES,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b0013faaed75a5c3$export$4d797e6241882bba), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_TABLES,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b0013faaed75a5c3$export$957c89a7c7c21b8f), {})
                                }),
                                /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $e20170eea887eb89$export$e7b0ac011bb776c6), {
                                    path: (0, $0e5d1fb0e9c69012$export$94983032f3209e0b).STORYBOOK_NOTIFICATIONS,
                                    children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $b0013faaed75a5c3$export$d142753ac0f33041), {})
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $440c6989d538dffe$export$c962982833242e24), {}),
            /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $23912206cef801f2$export$7a1b3d78151ab510), {})
        ]
    });
};






var $a23a8864dbec8e80$exports = {};
$a23a8864dbec8e80$exports = $parcel$resolve("8Bxrl");



var $cab2c0e2a736d626$exports = {};
$cab2c0e2a736d626$exports = JSON.parse("{\"CYBUS_ADMIN_UI_BACKEND_HOST\":{\"path\":[\"backendHost\"],\"schema\":{\"type\":[\"string\",\"null\"],\"examples\":[null],\"description\":\"The backend base url host. Defaults to the browser's host (location.host)\",\"minLength\":1}},\"CYBUS_ADMIN_UI_CONTACT_SALES_EMAIL\":{\"path\":[\"contact\",\"salesEmail\"],\"schema\":{\"type\":[\"string\"],\"examples\":[\"sales@cybus.io\"],\"description\":\"Cybus sales email\",\"format\":\"email\"}},\"CYBUS_ADMIN_UI_CONTACT_SUPPORT_EMAIL\":{\"path\":[\"contact\",\"supportEmail\"],\"schema\":{\"type\":[\"string\"],\"examples\":[\"support@cybus.io\"],\"description\":\"Cybus support email\",\"format\":\"email\"}},\"CYBUS_ADMIN_UI_DISPLAY_VERSION\":{\"path\":[\"displayVersion\"],\"schema\":{\"type\":[\"string\"],\"description\":\"The version of the application\",\"minLength\":1}},\"CYBUS_ADMIN_UI_DOCUMENTATION\":{\"path\":[\"documentation\"],\"schema\":{\"type\":[\"string\"],\"examples\":[\"https://docs.cybus.io\"],\"description\":\"The URL to Connectware documentation\",\"format\":\"uri\"}},\"CYBUS_ADMIN_UI_ENABLE_STORYBOOK\":{\"path\":[\"enableStorybook\"],\"schema\":{\"type\":[\"boolean\"],\"examples\":[false],\"description\":\"Whether the internal component Storybook page is reachable. Meant for development/demo environments only\"}},\"CYBUS_ADMIN_UI_INFO_PAGE_REFRESH_RATE\":{\"path\":[\"infoPageRefreshRate\"],\"schema\":{\"type\":[\"integer\"],\"examples\":[20000],\"description\":\"How often the info page will update (in milliseconds)\",\"minimum\":1,\"maximum\":600000}},\"CYBUS_ADMIN_UI_INTERACTION_THROTTLE\":{\"path\":[\"interactionThrottle\"],\"schema\":{\"type\":[\"integer\"],\"examples\":[500],\"description\":\"How long user inactivity is required on service, resources and user management pages before executing a search/sort/page change (in milliseconds)\",\"minimum\":1,\"maximum\":600000}},\"CYBUS_ADMIN_UI_LICENSE_FILE_EXTENSION\":{\"path\":[\"licenseFileExtension\"],\"schema\":{\"type\":[\"string\"],\"examples\":[\"lic\"],\"description\":\"The license file extension\",\"pattern\":\"^\\\\w+$\",\"minLength\":1}},\"CYBUS_ADMIN_UI_LOGOUT_WARNING_PERIOD\":{\"path\":[\"logoutWarningPeriod\"],\"schema\":{\"type\":[\"integer\"],\"description\":\"How early users will be warned before being logged out\",\"minimum\":0}},\"CYBUS_ADMIN_UI_MQTT_CYCLE\":{\"path\":[\"mqtt\",\"cycle\"],\"schema\":{\"type\":[\"integer\"],\"examples\":[500],\"description\":\"The refresh rate in milliseconds of the mqtt clients\",\"minimum\":1,\"maximum\":600000}},\"CYBUS_ADMIN_UI_MQTT_MAX_TOPIC_DEPTH\":{\"path\":[\"mqtt\",\"maxTopicDepth\"],\"schema\":{\"type\":[\"integer\"],\"examples\":[20],\"description\":\"The maximum topic depth the mqtt clients support\",\"minimum\":1}},\"CYBUS_ADMIN_UI_MQTT_PATH\":{\"path\":[\"mqtt\",\"path\"],\"schema\":{\"type\":[\"string\"],\"examples\":[\"/mqtt\"],\"description\":\"The path the mqtt clients will use to connect\",\"minLength\":1}},\"CYBUS_ADMIN_UI_MQTT_TIMEOUT\":{\"path\":[\"mqtt\",\"timeout\"],\"schema\":{\"type\":[\"integer\"],\"examples\":[6000],\"description\":\"The time the mqtt client will wait before throwing timeout errors (in milliseconds)\",\"minimum\":0,\"maximum\":600000}},\"CYBUS_ADMIN_UI_PAGE_SIZES_DEFAULT\":{\"path\":[\"pageSizes\",\"default\"],\"schema\":{\"type\":[\"integer\"],\"examples\":[25],\"description\":\"Used when the table is the main part of the page being displayed\",\"minimum\":2,\"maximum\":100}},\"CYBUS_ADMIN_UI_PAGE_SIZES_LARGE\":{\"path\":[\"pageSizes\",\"large\"],\"schema\":{\"type\":[\"integer\"],\"examples\":[50],\"description\":\"Offered between the default and the max size of a table\",\"minimum\":3,\"maximum\":100}},\"CYBUS_ADMIN_UI_PAGE_SIZES_MAX\":{\"path\":[\"pageSizes\",\"max\"],\"schema\":{\"type\":[\"integer\"],\"examples\":[100],\"description\":\"Max size of a table\",\"minimum\":3,\"maximum\":100}},\"CYBUS_ADMIN_UI_PAGE_SIZES_SHORT\":{\"path\":[\"pageSizes\",\"short\"],\"schema\":{\"type\":[\"integer\"],\"examples\":[10],\"description\":\"Used when the table is not the main part of the page being displayed\",\"minimum\":1,\"maximum\":100}},\"CYBUS_ADMIN_UI_RESOURCES_REFRESH_RATE\":{\"path\":[\"resourcesRefreshRate\"],\"schema\":{\"type\":[\"integer\"],\"description\":\"How often the page will wait before fetching results again (in milliseconds)\",\"minimum\":1,\"maximum\":600000}},\"CYBUS_ADMIN_UI_RESOURCES_REFRESH_THROTTLE\":{\"path\":[\"resourcesRefreshThrottle\"],\"schema\":{\"type\":[\"integer\"],\"examples\":[5000],\"description\":\"Sets a limit to how often resources can be refreshed (in milliseconds)\",\"minimum\":0,\"maximum\":60000}},\"CYBUS_ADMIN_UI_RST_CACHE_LIFESPAN\":{\"path\":[\"rst\",\"cacheLifespan\"],\"schema\":{\"type\":[\"integer\"],\"examples\":[500],\"description\":\"How long (in milliseconds) the data retrieved from the websockets can be used internally across the RSTAdapter\",\"minimum\":0,\"maximum\":600000}},\"CYBUS_ADMIN_UI_RST_MAX_PAGE_SIZE\":{\"path\":[\"rst\",\"maxPageSize\"],\"schema\":{\"type\":[\"integer\"],\"examples\":[25],\"description\":\"The max page size supported on RST\",\"minimum\":1,\"maximum\":100}},\"CYBUS_ADMIN_UI_RST_RECONNECT_TIMEOUT\":{\"path\":[\"rst\",\"reconnectTimeout\"],\"schema\":{\"type\":[\"integer\"],\"examples\":[5000],\"description\":\"How long Connectware should wait before it reconnects its sockets\",\"minimum\":0,\"maximum\":600000}},\"CYBUS_ADMIN_UI_SEARCH_MINIMUM\":{\"path\":[\"searchMinimum\"],\"schema\":{\"type\":[\"integer\"],\"examples\":[3],\"description\":\"A search made below this threshold will not be used to load data onto the application in certain pages (EG Services, Endpoints, Mappings and ETC)\",\"minimum\":0}},\"CYBUS_ADMIN_UI_SERVICES_COMMISSIONING_FILE_DOWNLOAD_MIME_TYPE\":{\"path\":[\"services\",\"commissioningFile\",\"downloadMimeType\"],\"schema\":{\"type\":[\"string\"],\"examples\":[\"text/yaml;charset=utf-8\"],\"description\":\"The MIME type of the commissioning files\",\"minLength\":1}},\"CYBUS_ADMIN_UI_SERVICES_COMMISSIONING_FILE_EXTENSIONS\":{\"path\":[\"services\",\"commissioningFile\",\"extensions\"],\"schema\":{\"type\":[\"array\"],\"items\":{\"type\":[\"string\"],\"pattern\":\"^\\\\w+$\"},\"examples\":[[\"yml\",\"yaml\"]],\"description\":\"Supported commissioning file extensions\",\"minItems\":1}},\"CYBUS_ADMIN_UI_SERVICES_EXTERNAL_URL_BASE_PATH\":{\"path\":[\"services\",\"externalUrlBasePath\"],\"schema\":{\"type\":[\"string\"],\"examples\":[\"/services\"],\"description\":\"The path to external services\",\"minLength\":1}},\"CYBUS_ADMIN_UI_USER_MANAGEMENT_CERTIFICATE_FILE_EXTENSION\":{\"path\":[\"userManagement\",\"certificateFileExtension\"],\"schema\":{\"type\":[\"string\"],\"examples\":[\"pem\"],\"description\":\"Supported certificate file extension\",\"pattern\":\"^\\\\w+$\",\"minLength\":1}},\"CYBUS_ADMIN_UI_USER_MANAGEMENT_CLIENT_REGISTRY_REFRESH_RATE\":{\"path\":[\"userManagement\",\"clientRegistryRefreshRate\"],\"schema\":{\"type\":[\"integer\"],\"examples\":[5000],\"description\":\"How often the client registry should update (in milliseconds)\",\"minimum\":1,\"maximum\":600000}},\"CYBUS_ADMIN_UI_USER_MANAGEMENT_INDEXES_CACHE\":{\"path\":[\"userManagement\",\"indexesCache\"],\"schema\":{\"type\":[\"integer\"],\"description\":\"How long User Management's indexed results will be kept on the Admin UI (in milliseconds)\",\"minimum\":0,\"maximum\":600000}},\"CYBUS_ADMIN_UI_USER_MANAGEMENT_PAGE_SIZE\":{\"path\":[\"userManagement\",\"pageSize\"],\"schema\":{\"type\":[\"integer\"],\"examples\":[20],\"description\":\"Page size on the user management tables (users, roles, permissions)\",\"minimum\":1,\"maximum\":100}},\"CYBUS_ADMIN_UI_USER_MANAGEMENT_PROTECTED_ROLES\":{\"path\":[\"userManagement\",\"protectedRoles\"],\"schema\":{\"type\":[\"array\"],\"items\":{\"type\":[\"string\"],\"minLength\":1},\"examples\":[[\"connectware-admin\",\"minimum-access\",\"protocol-mapper-agent\"]],\"description\":\"Roles that cannot be deleted or have their name edited\"}},\"CYBUS_ADMIN_UI_USER_MANAGEMENT_PROTECTED_USERS\":{\"path\":[\"userManagement\",\"protectedUsers\"],\"schema\":{\"type\":[\"array\"],\"items\":{\"type\":[\"string\"],\"minLength\":1},\"examples\":[[\"admin\"]],\"description\":\"Users that cannot be deleted or have their username edited\"}},\"CYBUS_ADMIN_UI_USER_MANAGEMENT_SEARCH_SIZE\":{\"path\":[\"userManagement\",\"searchSize\"],\"schema\":{\"type\":[\"integer\"],\"examples\":[5],\"description\":\"Amount of items suggested when searching for a single user/permission/role\",\"minimum\":1,\"maximum\":100}},\"CYBUS_ADMIN_UI_WORKBENCH_PATH\":{\"path\":[\"workbenchPath\"],\"schema\":{\"type\":[\"string\"],\"examples\":[\"/workbench\"],\"description\":\"Relative path to the external workbench\",\"minLength\":1}}}");


var $3cb20e33f4cfb802$exports = {};
$3cb20e33f4cfb802$exports = JSON.parse('{"ACTION":"{count, plural, =1 {Action} other {Actions}}","ACTIVE_ROLE":"{count} active {count, plural, =1 {role} other {roles}}","ACTIVE_USER":"{count} active {count, plural, =1 {user} other {users}}","ACTUAL":"Actual state","ADD_CERTIFICATE":"Add certificate","ADD_CUSTOM_TOPIC":"Add custom topic","ADD_PERMISSION":"Add permission","ADD":"Add","ADDITIONAL_PERMISSION":"Additional {count, plural, =1 {permission} other {permissions}}","ADDRESS":"Address","ADVANCED_MODE":"Advanced mode","AGENT_DOCUMENTATION_BODY":"Agents are components of Connectware that enable data processing on the edge and can be deployed outside the central Connectware installation. They allow workload partitioning and secure MQTT communication at the machine. The <b>Agents</b> view allows you to monitor the name, version, status, and hostname of all active agents, and to remove agents from the list.","AGENT_DOCUMENTATION_TITLE":"Monitor and manage agents","AGENT":"{count, plural, =1 {Agent} other {Agents}}","ALL_RAW_LOGS":"All {type} raw logs","ALLOW":"Allow","ALTERNATIVE_NAME":"{count, plural, =1 {Alternative name} other {Alternative names}}","APPLICATION_TITLE":"Cybus Connectware","APPLY":"Apply","ASK_YOUR_ADMIN_TO_GAIN_ACCESS":"Ask your administrator for access","AUTHENTICATION_ERROR_TITLE":"You are not authorized to see this page","AUTHENTICATION_ERROR":"{error, select, AUTHENTICATION {{authType, select, backupCodes {Incorrect backup code. Check the code and try again.} other {Incorrect password. Check your credentials and try again.}}} SERVER_NOT_AVAILABLE {The server is not available. Try again later.} SERVER_ERROR {Server error. Contact the Cybus support desk.} other {Unexpected error. Contact the Cybus support desk.}}","AUTHENTICATION_METHODS":"Authentication methods","AUTHORIZATION_REQUIRED_DOCUMENTATION_BODY_ITEM":"{count} {name} will be created","AUTHORIZATION_REQUIRED_DOCUMENTATION_BODY":"Enabling the service creates the following resources. Review them, then click <b>Allow</b>.","AUTHORIZATION_REQUIRED":"Authorization required","AUTHORIZE_SERVICE_REQUIREMENTS":"This service contains resources that require your authorization.","AUTO_FIT_COLUMNS":"Auto-fit columns","AVAILABLE_TOPICS":"Available topics","BACK_TO_LOGIN":"Back to sign-in","BASIC_CONSTRAINT":"{count, plural, =1 {Basic constraint} other {Basic constraints}}","BOOLEAN":"{value,select, true {Yes} other {No}}","BROKER":"{count, plural, =1 {Broker} other {Brokers}}","BUFFER_TOO_LARGE_TO_BE_DISPLAYED":"the rest of this message was hidden as it is too large to be displayed","BULK_ACTION_CONNECT_CONNECTIONS_ERROR":"Could not connect {count} {count, plural, =1 {connection} other {connections}}","BULK_ACTION_DELETE_AGENTS_ERROR":"Could not delete {count} {count, plural, =1 {agent} other {agents}}","BULK_ACTION_DELETE_SERVICES_ERROR":"Could not delete {count} {count, plural, =1 {service} other {services}}","BULK_ACTION_DISABLE_CONTAINERS_ERROR":"Could not stop {count} {count, plural, =1 {container} other {containers}}","BULK_ACTION_DISABLE_ENDPOINTS_ERROR":"Could not disable {count} {count, plural, =1 {endpoint} other {endpoints}}","BULK_ACTION_DISABLE_MAPPINGS_ERROR":"Could not disable {count} {count, plural, =1 {mapping} other {mappings}}","BULK_ACTION_DISABLE_SERVERS_ERROR":"Could not disable {count} {count, plural, =1 {server} other {servers}}","BULK_ACTION_DISABLE_SERVICES_ERROR":"Could not disable {count} {count, plural, =1 {service} other {services}}","BULK_ACTION_DISCONNECT_CONNECTIONS_ERROR":"Could not disconnect {count} {count, plural, =1 {connection} other {connections}}","BULK_ACTION_ENABLE_CONTAINERS_ERROR":"Could not start {count} {count, plural, =1 {container} other {containers}}","BULK_ACTION_ENABLE_ENDPOINTS_ERROR":"Could not enable {count} {count, plural, =1 {endpoint} other {endpoints}}","BULK_ACTION_ENABLE_MAPPINGS_ERROR":"Could not enable {count} {count, plural, =1 {mapping} other {mappings}}","BULK_ACTION_ENABLE_SERVERS_ERROR":"Could not enable {count} {count, plural, =1 {server} other {servers}}","BULK_ACTION_ENABLE_SERVICES_ERROR":"Could not enable {count} {count, plural, =1 {service} other {services}}","BULK_ACTION_RE_ENABLE_CONTAINERS_ERROR":"Could not restart {count} {count, plural, =1 {container} other {containers}}","BULK_DISABLE_SERVICES_CONFIRMATION":"<p>Disabling stops all running containers, connections, endpoints and mappings. Volumes keep their data and reattach when you enable {count, plural, =1 {the service} other {the services}} again.</p><p>Are you sure you want to disable the following {count, plural, =1 {service} other {services}}?</p>","CANCEL":"Cancel","CANNOT_AUTHENTICATE":"Cannot authenticate","CERTIFICATE_AUTHORITY":"Certificate authority","CERTIFICATE_PROPERTY_NOT_PROVIDED":"Not part of the certificate","CERTIFICATE_VIEWER_TITLE":"Certificate viewer: {title}","CERTIFICATES_DETAILS_DOCUMENTATION_BODY":"Certificates are used to verify the authenticity of a digital entity and to establish a secure communication channel. The <b>Certificates</b> view allows you to add custom CA certificates to the certs volume. Click the dots next to the certificate name for more information and the options to download or delete the certificate.","CERTIFICATES_DETAILS_DOCUMENTATION_TITLE":"Add and manage certificates","CERTIFICATES":"{count, plural, =1 {Certificate} other {Certificates}}","CHANGE_PASSWORD_DESCRIPTION":"Choose a strong password that you do not use for other accounts.","CHANGE_PASSWORD":"Change password","CLASS_NAME":"Class name","CLEAR":"Clear","CLIENT_REGISTRATION_FAILED":"Registration failed","CLIENT_REGISTRY_DOCUMENTATION_BODY":"External clients can request credentials through self-registration. If an administrator enables self-registration, unauthenticated connection attempts of MQTT and HTTP clients are treated as access requests. The <b>Client registry</b> view allows Connectware administrators to securely register and monitor new clients and users for data access and manage their permissions.","CLIENT_REGISTRY_DOCUMENTATION_TITLE":"Review and grant access requests from clients","CLIENT_REGISTRY_NO_REQUESTS":"No pending requests.{locked,select, true { To open self-registration for clients, click Unlock.} other {}}","CLIENT_REGISTRY_SELF_REGISTRATION":"Self-registration is open. It closes {formattedTimeLeft}.","CLIENT_REGISTRY":"Client registry","CLOSE":"Close","CNC_TYPE":"CNC type","COLLECTED_DAILY_METRICS_TITLE":"Daily collected metrics","COLLECTED_HOURLY_METRICS_TITLE":"Hourly collected metrics","COLUMN_DRAG_CANCEL":"Moving {column} was canceled","COLUMN_DRAG_END":"{column} was dropped in the place of {target}","COLUMN_DRAG_INSTRUCTIONS":"To reorder a column, press space or enter on its handle, move it with the up and down arrow keys, then press space or enter to drop it, or escape to cancel","COLUMN_DRAG_OVER":"{column} is over the place of {target}","COLUMN_DRAG_START":"Picked up {column}","COLUMNS":"Columns","COMMISSIONING_FILE_PARSING_ERROR":"There {count, plural, =1 {was an issue} other {were issues}} while parsing the service commissioning file. <link>Show details</link>.","COMMISSIONING_FILE":"Service commissioning file","COMMON_NAME":"Common name","CONFIGURATION":"Configuration","CONFIGURE_COLUMNS":"Configure columns","CONFIRM_PASSWORD":"Confirm password","CONNECT_CONNECTIONS_SUBTITLE":"<p>Are you sure you want to connect the following {count, plural, =1 {connection} other {connections}}?</p>","CONNECT_CONNECTIONS":"Connect {count, plural, =1 {connection} other {connections}}","CONNECT":"Connect","CONNECTING":"Connecting","CONNECTION_DETAILS_DOCUMENTATION_BODY":"The tabs show the logs, configuration, and endpoints of this connection.","CONNECTION_DETAILS_DOCUMENTATION_TITLE":"Monitor a connection","CONNECTION_ID":"Connection ID","CONNECTION_LOGS":"Connection logs","CONNECTION_NOT_FOUND":"The connection \\"{id}\\" does not exist","CONNECTION":"{count, plural, =1 {Connection} other {Connections}}","CONNECTIONS_DOCUMENTATION_BODY":"Connections are resources that allow you to connect to devices over protocols. The <b>Connections</b> view displays all available protocol connections, including their service ID, connection ID, host, and port. Click a connection for more information about its configuration.","CONNECTIONS_DOCUMENTATION_TITLE":"Monitor connections","CONNECTWARE_NEW_SELF_HOSTED_APPLIANCE_VERSION":"<ReleaseNotesLink>See what\'s new</ReleaseNotesLink>. <InstallerLink>Download the {latestVersion} installer</InstallerLink>.","CONNECTWARE_SLOGAN":"Your factory data hub.","CONNECTWARE_VERSION_INFORMATION":"{version} ({latest, select, null {Could not check for updates online} true {Latest} other {Latest version: {latest}}})","CONNECTWARE_VERSION":"Connectware version","CONTACT_YOUR_ADMINISTRATOR":"<p>Contact your Connectware administrator{reason,select, license { about your license} permissions { about your permissions} other {}}.</p>{reason,select, permissions {<p>Current permissions: <b>{permissions}</b></p>} other {}}","CONTAINER_DETAILS_DOCUMENTATION_BODY":"You can start, stop, restart, or delete this container. The tabs show its logs, configuration, and environment variables.","CONTAINER_DETAILS_DOCUMENTATION_TITLE":"Monitor and manage a container","CONTAINER_ID":"Container ID","CONTAINER_LOGS":"Container logs","CONTAINER_NOT_FOUND":"Container not found","CONTAINER":"{count, plural, =1 {Container} other {Containers}}","CONTAINERS_DOCUMENTATION_BODY":"Using Docker containers, you can add applications such as Grafana or InfluxDB from the Docker Registry or the Cybus Registry to Connectware. The <b>Containers</b> view displays all available containers, including their service ID, creation date, update time and date, volume count, and status. You can select one or multiple containers to start, stop, restart, and delete them. Click a specific container for more information about its configuration, environment variables, and logs.","CONTAINERS_DOCUMENTATION_TITLE":"Monitor and manage containers","CONTEXT":"Context","COPIED_TO_CLIPBOARD":"Copied to clipboard","COPY_LICENSE_ID":"Copy license ID","COPY_PERMISSIONS":"Copy permissions","COPY_TO_CLIPBOARD":"Copy to clipboard","CORE_CONTAINER_DETAILS_DOCUMENTATION_BODY":"You can start, stop, or restart this container. The tabs show its logs, configuration, and environment variables.","CORE_CONTAINER_DETAILS_DOCUMENTATION_TITLE":"Monitor and manage a system container","CORE_CONTAINERS_DOCUMENTATION_BODY":"This tab shows the status of the containers that Connectware runs in. Select a container to start, stop, or restart it. Click a container to see its logs, configuration, and environment variables.","CORE_CONTAINERS_DOCUMENTATION_TITLE":"Monitor and manage Connectware\'s system containers","CREATE_ROLE":"Create role","CREATE_USER":"Create user","CREATE":"Create","CREATED_AT":"Created at","CREDENTIALS":"Credentials","CSR_COMMON_NAME_ISSUE":"The common name of the certificate signing request does not match the username from the payload","CURRENT_PASSWORD":"Current password","CYBUS_PORTAL_STATUS":"{updatesAutomatically, select, true {The Connectware license can be updated automatically.} other {The Connectware license cannot be updated automatically. If it changes, upload the license file manually.}}","CYBUS_PORTAL":"Cybus Portal","CYBUS_REGISTRY_STATUS":"{installable, select, true {New services that use Docker images from Cybus can be installed.} other {Services that use Docker images from Cybus can only be enabled if their images are already on this system.}}","CYBUS_REGISTRY":"Cybus Registry","DATA_EXPLORER_DOCUMENTATION_BODY":"In <b>Available topics</b>, select the MQTT topics you want to monitor, or add a custom topic. <b>Monitored topics</b> shows the latest value of each topic, and <b>History</b> lists the latest updates. For the data of a single service, use the <b>Live data</b> tab of that service.","DATA_EXPLORER_DOCUMENTATION_TITLE":"Browse MQTT topics and monitor their data","DATA_EXPLORER":"Data explorer","DATA":"Data","DATE":"Date","DATETIME":"{type, select, dateOnly {{date, date, ::yyyyMMdd}} timeOnly {{date, date, ::HHmmss}} datetime {{date, date, ::yyyyMMdd} {date, date, ::HHmmss}} dateRangeChip {{date, date, ::dd/MM/yyyy} {date, time, ::HHmm}} other {{date, date, ::yyyyMMddHHmmssz}}}","DELETE_AGENTS_SUBTITLE":"<p>Are you sure you want to delete the following {count, plural, =1 {agent} other {agents}}?</p>","DELETE_AGENTS":"Delete {count, plural, =1 {agent} other {agents}}","DELETE_CERTIFICATE_CONFIRMATION":"Are you sure you want to delete this certificate?{br}To confirm, enter \\"{confirmation}\\" in the field below.","DELETE_CONNECTIONS_SUBTITLE":"<p>Are you sure you want to delete the following {count, plural, =1 {connection} other {connections}}?</p>","DELETE_CONNECTIONS":"Delete {count, plural, =1 {connection} other {connections}}","DELETE_CONTAINERS_SUBTITLE":"<p>Deleted containers are permanently removed from Connectware. You can re-create them only by re-enabling their service.</p><p>Are you sure you want to delete the following {count, plural, =1 {container} other {containers}}?</p>","DELETE_CONTAINERS":"Delete {count, plural, =1 {container} other {containers}}","DELETE_ENDPOINTS_SUBTITLE":"<p>Are you sure you want to delete the following {count, plural, =1 {endpoint} other {endpoints}}?</p>","DELETE_ENDPOINTS":"Delete {count, plural, =1 {endpoint} other {endpoints}}","DELETE_MAPPINGS_SUBTITLE":"<p>Are you sure you want to delete the following {count, plural, =1 {mapping} other {mappings}}?</p>","DELETE_MAPPINGS":"Delete {count, plural, =1 {mapping} other {mappings}}","DELETE_ROLE_CONFIRMATION":"Are you sure you want to delete the role \\"{name}\\"?","DELETE_SERVERS_SUBTITLE":"<p>Are you sure you want to delete the following {count, plural, =1 {server} other {servers}}?</p>","DELETE_SERVERS":"Delete {count, plural, =1 {server} other {servers}}","DELETE_SERVICES_SUBTITLE":"<p>Are you sure you want to delete the following {count, plural, =1 {service} other {services}}?</p>","DELETE_SERVICES":"Delete {count, plural, =1 {service} other {services}}","DELETE_USER_CONFIRMATION":"Are you sure you want to delete the user \\"{username}\\"?","DELETE_VOLUMES_SUBTITLE":"<p>Deleted volumes cannot be restored, and the data stored in them is permanently lost.</p><p>Are you sure you want to delete the following {count, plural, =1 {volume} other {volumes}}?</p>","DELETE_VOLUMES":"Delete {count, plural, =1 {volume} other {volumes}}","DELETE":"Delete","DEPENDS_ON_SERVICES":"Depends on","DESCRIPTION":"Description","DEVIATED_RESOURCES":"Deviated resources","DEVIATED_SERVICES_DOCUMENTATION_BODY":"A service is deviated when at least one of its resources does not reach its target state, for example because of a network outage or a misconfiguration. To see which resources deviate, click a service and open its <b>Deviations</b> tab.","DEVIATED_SERVICES_DOCUMENTATION_TITLE":"Monitor services with deviated resources","DEVIATED_SERVICES":"Deviated services","DEVIATION_DETECTED":"{count} {count, plural, =1 {deviation} other {deviations}}","DEVIATION_NEW_TOAST":"Deviation detected for {id}","DEVIATION_POPOVER_MORE":"+{count} more {count, plural, =1 {service} other {services}}","DEVIATION_RESOLVED":"Deviation resolved for {id}","DEVIATION_TAB":"{count, plural, =1 {Deviation} other {Deviations}}","DEVIATION_TOAST_COUNTER":"{count} {count, plural, =1 {deviation} other {deviations}}","DEVIATION_VIEW_ALL":"\u2192 View all deviated services","DEVIATION":"Deviation","DEVICE_ADDRESS":"Device address","DEVICE_INSTANCE":"Device instance","DEVICE":"{count, plural, =1 {Device} other {Devices}}","DISABLE_ENDPOINTS_SUBTITLE":"<p>Are you sure you want to disable the following {count, plural, =1 {endpoint} other {endpoints}}?</p>","DISABLE_ENDPOINTS":"Disable {count, plural, =1 {endpoint} other {endpoints}}","DISABLE_MAPPINGS_SUBTITLE":"<p>Data will no longer be forwarded to the mapped topics.</p><p>Are you sure you want to disable the following {count, plural, =1 {mapping} other {mappings}}?</p>","DISABLE_MAPPINGS":"Disable {count, plural, =1 {mapping} other {mappings}}","DISABLE_SERVERS_SUBTITLE":"<p>External clients connected to {count, plural, =1 {this server} other {these servers}} can no longer read or write data through {count, plural, =1 {it} other {them}}.</p><p>Are you sure you want to disable the following {count, plural, =1 {server} other {servers}}?</p>","DISABLE_SERVERS":"Disable {count, plural, =1 {server} other {servers}}","DISABLE_SERVICES":"Disable {count, plural, =1 {service} other {services}}","DISABLE":"Disable","DISABLED":"Disabled","DISCONNECT_CONNECTIONS_SUBTITLE":"<p>Are you sure you want to disconnect the following {count, plural, =1 {connection} other {connections}}?</p>","DISCONNECT_CONNECTIONS":"Disconnect {count, plural, =1 {connection} other {connections}}","DISCONNECT":"Disconnect","DISMISS":"Dismiss","DN_OF_AD_GROUP":"DN of AD group","DOCKER_HUB_STATUS":"{installable, select, true {New services that use public Docker images can be installed.} other {Services that use public Docker images can only be enabled if their images are already on this system.}}","DOCKER_HUB":"Docker Hub","DOCUMENTATION":"Documentation","DOWNLOAD_COMMISSIONING_FILE_DESCRIPTION_ERROR":"Could not download the service commissioning file","DOWNLOAD_COMMISSIONING_FILE_DESCRIPTION":"Download service commissioning file","DOWNLOAD_CSV":"Download CSV","DOWNLOAD_RAW_LOGS":"Download raw logs","DOWNLOAD":"{count, plural, =1 {Download} other {Downloads}}","EDIT_ROLE":"Edit role","EDIT_USER":"Edit user","ENABLE_ENDPOINTS_SUBTITLE":"<p>Are you sure you want to enable the following {count, plural, =1 {endpoint} other {endpoints}}?</p>","ENABLE_ENDPOINTS":"Enable {count, plural, =1 {endpoint} other {endpoints}}","ENABLE_MAPPINGS_SUBTITLE":"<p>Are you sure you want to enable the following {count, plural, =1 {mapping} other {mappings}}?</p>","ENABLE_MAPPINGS":"Enable {count, plural, =1 {mapping} other {mappings}}","ENABLE_SERVERS_SUBTITLE":"<p>Are you sure you want to enable the following {count, plural, =1 {server} other {servers}}?</p>","ENABLE_SERVERS":"Enable {count, plural, =1 {server} other {servers}}","ENABLE":"Enable","ENABLING":"Enabling","END_DATE":"End date","END":"End","ENDPOINT_DETAILS_DOCUMENTATION_BODY":"The tabs show the logs, protocol address, and rules of this endpoint.","ENDPOINT_DETAILS_DOCUMENTATION_TITLE":"Monitor an endpoint","ENDPOINT_LOGS":"Endpoint logs","ENDPOINT_NOT_FOUND":"The endpoint \\"{id}\\" does not exist","ENDPOINT":"{count, plural, =1 {Endpoint} other {Endpoints}}","ENDPOINTS_DOCUMENTATION_BODY":"An endpoint is a single data point on a connection that Connectware reads from or writes to. Click an endpoint to see its logs, address, and rules.","ENDPOINTS_DOCUMENTATION_TITLE":"Monitor endpoints","ENFORCE_MFA_USAGE":"MFA requirement","ENTRA_OBJECT_ID":"Object ID (Entra ID)","ENTRY":"{count, plural, =1 {Entry} other {Entries}}","ENVIRONMENT_VARIABLE":"{count, plural, =1 {Environment variable} other {Environment variables}}","ERROR_COUNT":"{count} {count, plural, =1 {error} other {errors}}","ERROR_DETAILS_TYPE":"Error type: {type}","ERROR_DETAILS":"Details","ERROR_EXTRA_INFORMATION":"Extra error information","ERROR_TITLE":"An error occurred: {message}","ERROR":"{count, plural, =1 {Error} other {Errors}}","EXPECTED":"Expected state","EXPIRATION_DATE":"Expiration date","EXPIRES_ON":"Expires on","EXTENDED_KEY_USAGE_TYPE":"{usage, select, CLIENT_AUTH {SSL/TLS WWW client authentication} CODE_SIGNING {Code signing} CRITICAL {Critical} EMAIL_PROTECTION {E-mail protection (S/MIME)} IPSEC_IKE {IPsec Internet Key Exchange} MS_CODE_COM {Microsoft commercial code signing (Authenticode)} MS_CODE_IND {Microsoft individual code signing (Authenticode)} MS_CTL_SIGN {Microsoft trust list signing} MS_EFS {Microsoft Encrypted File System} OCSP_SIGNING {OCSP signing} SERVER_AUTH {SSL/TLS WWW server authentication} TIME_STAMPING {Trusted timestamping} other {Unknown}}","EXTENDED_KEY_USAGE":"{count, plural, =1 {Extended key usage} other {Extended key usages}}","EXTENSIONS":"Extensions","EXTERNAL":"External","FILE_UPLOAD_LABEL":"Choose file","FILE_UPLOAD":"{length, select, 0 {No file chosen} 1 {{firstFileName}} other {{length} files}}","FILTER":"Filter","FINGERPRINT":"Fingerprints","GO_TO":"Go to {destination}","GRANT_ACCESS":"Grant access","HIDE_LICENSE_ID":"Hide license ID","HIDE_PASSWORD":"Hide password","HISTORY":"History","HOST":"{count, plural, =1 {Host} other {Hosts}}","HOSTNAME":"Hostname","INFO_PAGE_DOCUMENTATION_BODY":"The Connectware license defines which features you can use and until when. Connectware checks it online at every start. If your license changed in the Cybus Portal, click <b>Refresh license</b>. Without Internet access, click <b>Upload license file</b>.","INFO_PAGE_DOCUMENTATION_TITLE":"Monitor and manage the Connectware license","INFO":"Info","INHERITED_FROM":"Inherited from {value}","INPUT_MQTT_TOPIC":"Enter an MQTT topic","INPUT_TRANSFORMATION_RULE":"Enter your transformation rule","INPUT":"Input","INSTALL":"Install","INSTALLED_SERVICES":"{count, plural, =1 {Service} other {Services}} installed","INTERNAL":"Internal","INTERNET_CONNECTIVITY_DOCUMENTATION_BODY":"Connectware uses these online services to check its license and to download the container images that services need. Services without containers can be installed and enabled without Internet access.","INTERNET_CONNECTIVITY_DOCUMENTATION_TITLE":"Check which online services Connectware can reach","INTERNET_CONNECTIVITY":"Internet connectivity","INVALID_CSR":"The certificate signing request is invalid","INVALID_OTP":"{banned, select, true {Too many sign-in attempts. Wait {minutesUntilRetry} {minutesUntilRetry, plural, =1 {minute} other {minutes}} and try again.} other {Incorrect authentication code. {triesLeft} {triesLeft, plural, =1 {attempt} other {attempts}} left before sign-in is blocked for {minutesUntilRetry} {minutesUntilRetry, plural, =1 {minute} other {minutes}}.}}","INVALID_SERVICE_ID":"The service ID is invalid","INVALID_TOPIC":"Topic is invalid","IP_ADDRESS":"IP address","IS_URL_REACHABLE":"{url} {reachable, select, true {is reachable} other {is not reachable}}.","IS_USED_BY":"{used} is used by {user}","ISSUED_BY":"Issued by","ISSUED_ON":"Issued on","ISSUED_TO":"Issued to","JSON":"JSON","JUMP_TO_PAGE":"Jump to page","KEY_USAGE_TYPE":"{usage, select, CRITICAL {Critical} CRL_SIGN {cRLSign} DATA_ENCIPHERMENT {dataEncipherment} DECIPHER_ONLY {decipherOnly} DIGITAL_SIGNATURE {digitalSignature} ENCIPHER_ONLY {encipherOnly} KEY_AGREEMENT {keyAgreement} KEY_CERTSIGN {keyCertSign} KEY_ENCIPHERMENT {keyEncipherment} NON_REPUDIATION {nonRepudiation} other {Unknown}}","KEY_USAGE":"{count, plural, =1 {Key usage} other {Key usages}}","LABEL":"{count, plural, =1 {Label} other {Labels}}","LAST_SEEN":"Last seen","LAST_UPDATED":"Last updated","LEVEL":"Level","LICENSE_ACCOUNT":"License account","LICENSE_ACTIVATION_NEEDED_DESCRIPTION":"<paragraph>Your license information is not available.</paragraph><paragraph>Make sure that Connectware has Internet access.</paragraph><paragraph>If Connectware cannot access the Internet from your location, follow the steps in the <link>offline activation documentation</link> to activate it.</paragraph>","LICENSE_ACTIVATION_NEEDED":"Connectware activation needed","LICENSE_ACTIVATION_TITLE":"<p><b>{type,select, online {Online activation} offline {Offline activation} other {Unknown}}</b></p>","LICENSE_CLASS":"License class","LICENSE_ERROR_SUMMARY":"<p>The Connectware license{name,select, null {} other { \\"<b>{name}</b>\\" (ID: {id})}} is invalid because it has {activated,select, false {<b>not</b> been activated} other {{expiration,select, null {expired} other {expired on <b>{expiration}</b>}}}}.</p>{activatable, select, true {<p>To activate the Connectware license, follow these instructions:</p>} other {}}","LICENSE_EXPIRED_CONTACT_SALES":"<p>To extend your license period and continue working with Connectware, contact our sales team at {salesEmailLink}.</p>","LICENSE_EXPIRED_EXTENSION_NEEDED":"<p>Once your license period has been extended, click <b>Refresh license</b> to refresh your license from the Cybus Portal:</p>","LICENSE_ID":"License ID","LICENSE_MODAL_FOOTER":"<p>For more information, see the <documentationUrl>Connectware license documentation</documentationUrl>.</p><p>If you need further help, contact our support team at {supportEmail}.</p>","LICENSE_MODAL_TITLE":"{loading,select, true {Checking Connectware license} other {Connectware license check}}","LICENSE_NAME":"License name","LICENSE_OFFLINE_ACTIVATION":"<p>Connectware seems to run offline and cannot reach the Cybus Portal from your location. To activate Connectware, follow the steps in the <offlineActivationLink>offline activation documentation</offlineActivationLink> to get a license file, then upload it with the following button:</p>","LICENSE_ONLINE_ACTIVATION":"<p>To activate your license and use Connectware, contact our sales team at {salesEmailLink}.</p><p>Once your license is activated, refresh it with the following button:</p>","LICENSE_ONLINE_AVAILABILITY_CHECK":"<p>Checking for online availability\u2026</p>","LICENSE_REFRESH_REQUIRES_INTERNET":"To refresh the license from the Admin UI, Connectware needs Internet access.","LICENSE_STATUS":"License status","LICENSE_STILL_INVALID":"The Connectware license is still expired or invalid","LICENSE_VALIDATION_ERROR":"<p>{reason,select, permissions {You do not have permission to validate the Connectware license} other {Could not validate the Connectware license}}.</p>","LICENSE":"License","LINK":"{count, plural, =0 {No links} =1 {Link} other {Links}}","LIVE_DATA_SUBSCRIPTION_ERROR":"Live data cannot be displayed","LOCK":"Lock","LOG_DETAILS":"Log details","LOG_LEVEL":"{level,select, DEBUG {Debug} INFO {Info} WARN {Warn} ERROR {Error} FATAL {Fatal} TRACE {Trace} other {Other}}","LOGICAL_ID":"Logical ID","LOGIN_FORM_BACKUP_CODE":"Backup code","LOGIN_FORM_CANCEL_MFA":"Cancel sign-in","LOGIN_FORM_MFA_EXPLANATION":"<paragraph>{method, select, otp {Enter your 6-digit code from your authenticator app} backupCodes {Enter your backup code} other {}}</paragraph>","LOGIN_FORM_TITLE":"Sign in to Connectware","LOGIN_SETTINGS_DOCUMENTATION_BODY":"Choose a strong password that you do not use for other accounts.{br}If available, turn on multi-factor authentication, so that a password alone is not enough to sign in.","LOGIN_SETTINGS_DOCUMENTATION_TITLE":"Account security","LOGIN_SETTINGS":"Sign-in","LOGOUT":"Sign out","MAPPING_DETAILS_DOCUMENTATION_BODY":"The tabs show the logs and entries of this mapping, with their topics and rules.","MAPPING_DETAILS_DOCUMENTATION_TITLE":"Monitor a mapping","MAPPING_ID":"Mapping ID","MAPPING_LOGS":"Mapping logs","MAPPING_NOT_FOUND":"The mapping \\"{id}\\" does not exist","MAPPING":"{count, plural, =1 {Mapping} other {Mappings}}","MAPPINGS_DOCUMENTATION_BODY":"Mappings forward data from one MQTT topic to another and can transform it with rules. Click a mapping to see its entries and logs.","MAPPINGS_DOCUMENTATION_TITLE":"Monitor mappings","MENU":"Menu","MESSAGE_PER_DAY":"Day","MESSAGE_PER_HOUR":"Hour","MESSAGE":"Message","METRICS_DOCUMENTATION_BODY":"Connectware counts its data points (connected endpoints) and the MQTT messages its broker transfers. Switch between <b>Hour</b> and <b>Day</b> to change the interval.","METRICS_DOCUMENTATION_TITLE":"Monitor data points and message volume","METRICS":"Metrics","MFA_ALREADY_ENABLED_ERROR":"Multi-factor authentication is already enabled","MFA_BACKUP_CODES_PRESENTATION_SUBTITLE":"Copy the backup codes and store them in a safe place.","MFA_BACKUP_CODES_PRESENTATION_TITLE":"Backup codes","MFA_ENABLED_ACTION_CONFIRMATION":"{action, select, regenerateBackupCodes {Regenerate backup codes} disable {Disable multi-factor authentication} other {}}","MFA_ENABLED_ACTION_DESCRIPTION":"To {action, select, regenerateBackupCodes {regenerate your MFA backup codes} disable {disable MFA} other {}}, enter {method, select, backupCodes {a backup code} otp {the authentication code} other {}} below.","MFA_ENABLING_STEPS_SUBTITLE":"{step, select, 1 {Scan the QR code with your authenticator app, or copy the secret key into your authenticator app.} 2 {Generate an authentication code in your authenticator app and enter it below.} other {}}","MFA_ENABLING_STEPS_TITLE":"{step, select, 1 {Scan QR code} 2 {Register device} other {}}","MFA_ENFORCED_NOTIFICATION":"To enhance security, your organization now requires multi-factor authentication (MFA) when signing in. To continue your work, set up MFA. Click <b>Dismiss</b> and save your changes before you sign out. If you have no unsaved changes, click <b>Sign out</b>.","MFA_MISSING_PERMISSIONS_ERROR":"You do <b>not</b> have permission to manage your multi-factor authentication.{br}Contact your administrator.","MFA_SAVE_CONFIGURATION":"Enable multi-factor authentication","MFA_SECRET_KEY_LABEL":"Your secret key","MFA_SETTINGS_SUBTITLE":"Multi-factor authentication adds an extra layer of security to your Connectware account.{required, select, true {{br}Your organization <b>requires</b> you to enable multi-factor authentication.} other {}}","MFA_TOGGLE":"Multi-factor authentication","MFA_TOKEN_EXPIRED_ERROR":"Your session has expired. Go to the <link>sign-in page</link>.","MISSING_READ_OR_WRITE_PERMISSION":"A permission needs read access, write access, or both","MONITORED_TOPICS":"Monitored topics","MORE_TAGS_COUNT":"+{count} more","MQTT_COULD_NOT_CONNECT_ERROR":"Could not connect to the MQTT broker","MQTT_GENERIC_ERROR":"There was an error with the MQTT client","MQTT_PUBLISH_PREFIX_DOCUMENTATION":"MQTT publish prefix documentation","MQTT_PUBLISH_PREFIX_VALIDATION":"{type, select, NO_PERMISSIONS {{username} does not have MQTT write permissions that start with {prefix}} NOT_EXACT {The MQTT publish prefix cannot contain wildcards} other {}}","MQTT_PUBLISH_PREFIX_WARNING":"Connectware adds this prefix to the topic of every MQTT message this user publishes. Make sure that it is configured correctly.","MQTT_PUBLISH_PREFIX":"MQTT publish prefix","MQTT_TOPIC":"MQTT topic","MULTI_FACTOR_AUTHENTICATION_ACRONYM":"MFA","MULTI_FACTOR_AUTHENTICATION":"Multi-factor authentication","NAME":"Name","NAVIGATION_BRAND_HOME":"Cybus Connectware home","NAVIGATION_BRAND":"<b>Cybus</b> Connectware","NAVIGATION_CERTIFICATES_DESCRIPTION":"Manage certificates","NAVIGATION_CLIENT_REGISTRY_DESCRIPTION":"Register clients that request access","NAVIGATION_CONNECTIONS_DESCRIPTION":"Show all connections of enabled services","NAVIGATION_CONTAINERS_DESCRIPTION":"Show all Docker containers of all services","NAVIGATION_ENDPOINTS_DESCRIPTION":"Show all endpoints and their connections","NAVIGATION_EXPLORER_DESCRIPTION":"Browse MQTT topics and monitor their data","NAVIGATION_MAPPINGS_DESCRIPTION":"Manage containers, volumes, connections, endpoints and mappings","NAVIGATION_NODES_DESCRIPTION":"Show all enabled nodes of all services","NAVIGATION_PHONE_MENU_CLOSE":"Close menu","NAVIGATION_PHONE_SIGNED_IN_AS":"Signed in as {username}","NAVIGATION_RULE_ENGINE_SANDBOX_DESCRIPTION":"Subscribe to MQTT topics and test JSONata rules","NAVIGATION_SERVERS_DESCRIPTION":"Show all enabled servers of all services","NAVIGATION_SERVICES_DESCRIPTION":"Install, configure and monitor services","NAVIGATION_SERVICES_LINKS_DESCRIPTION":"Show all links of all services","NAVIGATION_SIDE_COLLAPSE":"Collapse side bar","NAVIGATION_SIDE_EXPAND":"Expand side bar","NAVIGATION_SIDE_LABEL":"Section pages","NAVIGATION_SYSTEM_AGENTS_DESCRIPTION":"Show all agents","NAVIGATION_SYSTEM_LICENSE_DESCRIPTION":"Show the Connectware license","NAVIGATION_SYSTEM_METRICS_DESCRIPTION":"Show Connectware metrics","NAVIGATION_SYSTEM_STATUSES_DESCRIPTION":"Check the status of Connectware","NAVIGATION_TOP_LABEL":"Sections","NAVIGATION_VOLUMES_DESCRIPTION":"Show all available Docker volumes","NEW_PASSWORD":"New password","NEW_ROLE":"New role","NEW_USER":"New user","NO_AGENTS_AVAILABLE":"No agents available","NO_AGENTS_RUNNING":"No agents running","NO_CERTIFICATES":"No certificates","NO_CHANGE_PASSWORD_PERMISSION_DESCRIPTION":"You do not have permission to change your password (api/policy/password permission).{br}To change it, contact your administrator.","NO_CONFIGURATION":"No configuration","NO_CONNECTIONS_AVAILABLE":"No connections available","NO_CONTAINERS_AVAILABLE":"No containers available","NO_DEVIATED_SERVICES_AVAILABLE":"No deviated services available","NO_ENDPOINTS_AVAILABLE":"No endpoints available","NO_ENTRIES_AVAILABLE":"No entries available","NO_LIVE_DATA_RESOURCES_FOUND":"No resources found","NO_LIVE_DATA_RESOURCES":"This service has no resources with live data","NO_LOGS_FOUND":"No logs found","NO_MAPPINGS_AVAILABLE":"No mappings available","NO_MESSAGES":"No messages","NO_METRICS":"No metrics collected","NO_NODES_AVAILABLE":"No nodes available","NO_PERMISSIONS_FOUND":"No permissions found","NO_RESULTS_FOUND":"No results found","NO_ROLES_FOUND":"No roles found","NO_ROLES":"No roles","NO_SERVERS_AVAILABLE":"No servers available","NO_SERVICE_LINKS_AVAILABLE":"No services with Cybus::Link resources enabled","NO_SERVICES_INSTALLED":"No services installed.{canInstallServices,select, true { To install one, <link>upload a service</link>.} other {}}","NO_TEMPLATES_AVAILABLE":"No templates available","NO_TOPICS_AVAILABLE":"No topics available","NO_TOPICS_SELECTED":"No topics selected","NO_USERS_FOUND":"No users found","NO_VOLUMES_AVAILABLE":"No volumes linked to this service or container","NODE":"{count, plural, =1 {Node} other {Nodes}}","NODES_DOCUMENTATION_BODY":"A node is a single data point that a server offers. External clients can read from it or write to it. This tab lists the nodes of all servers.","NODES_DOCUMENTATION_TITLE":"Monitor nodes","NONE":"None","NOT_AVAILABLE":"Not available","NOT_EDITABLE":"You {canUpdateMfa, select, true {can only manage MFA on} other {cannot edit}} this {type, select, user {user} role {role} other {unknown entity}}","NOTHING_TO_CONFIGURE":"Nothing to configure","NOTIFICATION_TOAST_COUNT":"{count}","NUMBER_OF_DATAPOINTS":"Number of data points","NUMBER_OF_ENTRIES":"Number of entries","NUMBER_OF_MESSAGES_PER_DAY":"Messages per day","NUMBER_OF_MESSAGES_PER_HOUR":"Messages per hour","NUMBER_OF_VOLUMES":"Number of volumes","OPEN_DOCUMENTATION":"Open documentation","OPERATION_PERMISSION":"{read,select, true {{write,select, true {Read and write} false {Read} other {Unknown}}} false {{write,select, true {Write} false {No access} other {Unknown}}} other {Unknown}}","OPERATION":"{count, plural, =1 {Operation} other {Operations}}","OPTIONAL":"Optional","OR_USE_USERNAME":"Or use your username","ORGANIZATION":"Organization","ORGANIZATIONAL_UNIT":"Organizational unit","PARENT":"Parent","PASSWORD_SUCCESSFULLY_CHANGED":"Password successfully changed","PASSWORD_VALIDATION":"{type, select, match {Password and confirmation must match} minLength {At least {count} {count, plural, =1 {character} other {characters}}} lower {Contains at least {count} lowercase {count, plural, =1 {letter} other {letters}}} upper {Contains at least {count} uppercase {count, plural, =1 {letter} other {letters}}} numeric {Contains at least {count} {count, plural, =1 {number} other {numbers}}} symbol {Contains at least {count} {count, plural, =1 {symbol or punctuation mark} other {symbols or punctuation marks}}} other {Unknown}}","PASSWORD":"Password","PATH_LENGTH":"Path length","PERMISSION_ALREADY_EXISTS":"Permission already exists","PERMISSION":"{count, plural, =1 {Permission} other {Permissions}}","PERMISSIONS_CHANGED_NOTIFICATION":"An administrator changed your account permissions. Click <b>Dismiss</b> and save your changes before you reload the page. If you have no unsaved changes, click <b>Reload session</b>.","PID":"PID","PIN_COLUMN":"Pin {column}","PINNED":"Pinned","PORT":"{count, plural, =1 {Port} other {Ports}}","PROBLEM_CHANGING_PASSWORD":"Could not change the password","PROTOCOL":"{count, plural, =1 {Protocol} other {Protocols}}","PROVIDER":"Provider","PUBLISH_BROKER":"Publish broker","PUBLISH":"Publish","REASON":"Reason","RECORD_PANEL_ACTION_TOOLTIP":"{action, select, previous {Previous (\u2191)} next {Next (\u2193)} expand {Expand (Shift+Enter)} close {Close (Esc)} other {}}","RECORD_PANEL_ACTION":"{action, select, previous {Previous} next {Next} expand {Expand} close {Close} other {}}","RECORD_PANEL_POSITION":"{index, number} of {total, number}","RECORD_PANEL_SNAP":"Let go to open as a page","RECORD_PANEL_WIDTH_VALUE":"{width, number} px","RECORD_PANEL_WIDTH":"Panel width","RECORD_PANEL":"record panel","REDUCED_PERMISSIONS_TITLE":"Your permissions have changed","REFRESH_LICENSE_FILE_FROM_PORTAL":"Refresh license file from Cybus Portal","REFRESH_LICENSE":"Refresh license","REFRESH_LOGS":"Refresh logs","RELOAD_SESSION":"Reload session","REMOVE_ALL_PERMISSIONS":"Remove all permissions","REMOVE_CUSTOMIZATION":"Remove customization","REMOVE":"Remove","REORDER_COLUMN":"Reorder {column}","REQUIRED_BY":"Required by","RESET_VIEW":"Reset view","RESET":"Reset","RESOURCE_ID":"Resource ID","RESOURCE_IS_MISSING":"Enter a resource","RESOURCE_TYPE":"Resource type","RESOURCE":"{count, plural, =1 {Resource} other {Resources}}","RESOURCES_AND_SERVICE_LINK_DOCUMENTATION_BODY":"<b>Service resources</b> lists the resources of all services, with one tab per resource type.{br}{br}The <b>Service links</b> tab lists the links that services provide, for example to a dashboard that a service runs.","RESOURCES_AND_SERVICE_LINK_DOCUMENTATION_TITLE":"Monitor and manage the resources of all services","RESTART_CONTAINERS_SUBTITLE":"<p>Any manual changes to {count, plural, =1 {this container} other {these containers}} will be removed and cannot be restored.</p><p>Are you sure you want to restart the following {count, plural, =1 {container} other {containers}}?</p>","RESTART_CONTAINERS":"Restart {count, plural, =1 {container} other {containers}}","RESTART":"Restart","ROLE_NAME_ALREADY_USED":"A role named \\"{name}\\" already exists. Enter a different name.","ROLE_NAME":"Role name","ROLE":"{count, plural, =1 {Role} other {Roles}}","ROUTE":"{count, plural, =1 {Route} other {Routes}}","ROW_ACTIONS":"Actions for {name}","ROWS_PER_PAGE":"Rows per page","RULE_ENGINE_DOCUMENTATION":"Rule engine documentation","RULE_ENGINE_SANDBOX_DOCUMENTATION_BODY":"Test JSONata transformation rules without affecting your services. As input, enter your own JSON or use the latest data of an endpoint or MQTT topic. Then enter a rule under <b>Transformation rule expression</b> to see the result.","RULE_ENGINE_SANDBOX_DOCUMENTATION_TITLE":"Test transformation rules on sample or live data","RULE_ENGINE_SANDBOX_TRANSFORMATION_PLACEHOLDER":"$.value","RULE_ENGINE_SANDBOX":"Rule sandbox","RULE_ERROR":"The rule <b>{ruleName}</b> failed","RULE":"{count, plural, =1 {Rule} other {Rules}}","SANDBOX_SUBSCRIPTION_ISSUE":"Could not subscribe to the {endpoints, select, null {entered topic} other {selected {endpoints, plural, =1 {endpoint} other {endpoints}}}}","SAVE_NEW_PASSWORD":"Save new password","SEARCH_CHARACTERS_LEFT":"{count, plural, one {# more character} other {# more characters}}","SEARCH_PLACEHOLDER":"{count, plural, =0 {Search} =1 {Min. {count} character} other {Min. {count} characters}}","SEARCH_THRESHOLD_EXPLANATION":"Enter at least {threshold} {threshold, plural, =1 {character} other {characters}} to start searching","SECRET_PARAMETER_CHANGE":"Change","SECRET_PARAMETER_CONCEALED_HELPER":"Secret: the stored value is never shown","SECRET_PARAMETER_EDIT_HELPER":"Saved only when you click Update. To keep the current value, leave this field empty or cancel.","SECRET_PARAMETER_HIDE_VALUE":"Hide value","SECRET_PARAMETER_SHOW_VALUE":"Show value","SELECT_ENDPOINT":"Select an endpoint","SELECT_TRANSFORMATION_SOURCE":"Select the transformation source","SELECTED_COUNT":"{count} selected","SEND_METRICS_TO_PORTAL":"Send metrics to Cybus Portal","SERVER_DETAILS_DOCUMENTATION_BODY":"The tabs show the logs of this server and the nodes it offers.","SERVER_DETAILS_DOCUMENTATION_TITLE":"Monitor a server","SERVER_ERROR":"Server error. Contact the Cybus support desk.","SERVER_LOGS":"Server logs","SERVER_NOT_AVAILABLE":"The server is not available. Try again later.","SERVER_NOT_FOUND":"The server \\"{id}\\" does not exist","SERVER":"{count, plural, =1 {Server} other {Servers}}","SERVERS_DOCUMENTATION_BODY":"Servers let external clients read data from Connectware or write data to it over protocols such as OPC UA or HTTP. Nodes define which data points a server offers. Click a server to see its logs and nodes.","SERVERS_DOCUMENTATION_TITLE":"Monitor servers","SERVICE_COMMISSIONING_FILE_LABEL":"Click to view the service commissioning file","SERVICE_CONFIGURATION":"Service configuration","SERVICE_CONFIGURE_CURRENT":"Reconfigure service","SERVICE_CONFIGURE_HINT":"To configure the service, upload a valid service commissioning file.","SERVICE_CONFIGURE_NEW":"Configure the new service","SERVICE_DETAILS_DOCUMENTATION_BODY":"You can enable, disable, or delete this service, and download its service commissioning file. To upload a new service commissioning file or change its parameters, click <b>Update</b>. The tabs show the service\'s logs, live data, resources, and deviations.","SERVICE_DETAILS_DOCUMENTATION_TITLE":"Monitor and manage a service","SERVICE_DETAILS":"Service details","SERVICE_DOCUMENTATION_LINK":"Learn more in the <documentationLink>services documentation</documentationLink>.","SERVICE_ID_ALREADY_USED":"This service ID is already in use. Enter a different service ID or delete the existing service.","SERVICE_ID":"Service ID","SERVICE_INSTALL_OR_UPDATE_ERROR":"Could not install or update the service. <link>Show details</link>.","SERVICE_INSTALL":"Install service","SERVICE_LINK":"{count, plural, =1 {Service link} other {Service links}}","SERVICE_LIVE_DATA":"Live data","SERVICE_LOGS_DOCUMENTATION_BODY":"This page shows the log entries of all services. <b>Download CSV</b> saves the entries shown. For the complete log, click <b>Download raw logs</b>. Click an entry to see its details.","SERVICE_LOGS_DOCUMENTATION_TITLE":"Monitor the logs of all services","SERVICE_LOGS":"Service logs","SERVICE_NOT_FOUND":"The service \\"{id}\\" does not exist","SERVICE_OVERVIEW":"Service overview","SERVICE_RESOURCE_TYPE":"{type, select, ENDPOINT {Endpoint} MAPPING {Mapping} NODE {Node} other {Unexpected type}}","SERVICE_RESOURCES":"Service resources","SERVICE_SELECT_COMMISSIONING_FILE":"Select a service commissioning file ({types})","SERVICE_UPDATE_RECONFIGURE":"Update or reconfigure service","SERVICE_WITH_ID_STILL_BEING_DELETED":"A service with this ID is still being deleted. Wait until it is deleted, then try again.","SERVICE":"{count, plural, =1 {Service} other {Services}}","SERVICES_DETAILS_DOCUMENTATION_BODY":"A service bundles resources, such as connections to your machines, mappings, and users. You define it in a service commissioning file, written in YAML. To install a service, click <b>Upload service</b>. To create its resources, open the service and click <b>Enable</b>.","SERVICES_DETAILS_DOCUMENTATION_TITLE":"Install and manage services","SESSION_BANNER":"Session ends in {countdown}. Save your work.","SESSION_COUNTDOWN":"Session ends in {countdown}","SETTINGS":"Settings","SHOW_LICENSE_ID":"Show license ID","SHOW_MORE":"Show {count} more\u2026","SHOW_PASSWORD":"Show password","SHOW_USER_MANAGEMENT_RESULTS":"{type, select, users {Show auto-generated users} roles {Show auto-generated roles} permissions {Show internal permissions} other {Unknown}}","SIGN_IN_WITH_SSO":"Sign in with {method, select, MICROSOFT_ENTRA_ID {Entra ID} other {unknown SSO authenticator}}","SIGN_IN":"Sign in","SSO_AUTHENTICATION_ERROR":"{reason, select, user_already_exists {A Connectware account already exists with this username. To sign in with {method, select, MICROSOFT_ENTRA_ID {Entra ID} other {unknown SSO authenticator}}, ask your administrator to configure a different username} invalid_client {Unable to sign in: Invalid client secret. Contact your administrator to verify the {method, select, MICROSOFT_ENTRA_ID {Entra ID} other {unknown SSO authenticator}} configuration} failed_login_redirect {Unable to sign in: Could not redirect to the {method, select, MICROSOFT_ENTRA_ID {Entra ID} other {unknown SSO authenticator}} sign-in page. Contact your administrator} other {Unable to sign in: Unexpected {method, select, MICROSOFT_ENTRA_ID {Entra ID} other {unknown SSO authenticator}} error. Contact your administrator}}.","SSO_REDIRECTING_ERROR":"Unable to load the {method, select, MICROSOFT_ENTRA_ID {Entra ID} other {unknown SSO authenticator}} sign-in page. Try again. If the problem persists, contact your administrator.","SSO_STATUS_FETCHING_ERROR":"Unable to verify the SSO status. Reload the page to try again. If the problem persists, contact your administrator to verify the SSO configuration.","START_CONTAINERS_SUBTITLE":"<p>Started containers can potentially transmit data outside of your local network.</p><p>Are you sure you want to start the following {count, plural, =1 {container} other {containers}}?</p>","START_CONTAINERS":"Start {count, plural, =1 {container} other {containers}}","START_DATE":"Start date","START":"Start","STATUS_LABEL":"{\\n    status,\\n    select,\\n\\n    ACTIVE {Active}\\n    AVAILABLE {Available}\\n    CONNECTED {Connected}\\n    CONNECTING {Connecting}\\n    CREATED {Created}\\n    DEAD {Dead}\\n    DEVIATED {Deviated}\\n    DISABLED {Disabled}\\n    DISABLING {Disabling}\\n    DISCONNECTED {Disconnected}\\n    DISCONNECTING {Disconnecting}\\n    ENABLED {Enabled}\\n    ENABLING {Enabling}\\n    EXITED {Exited}\\n    INACTIVE {Inactive}\\n    INVALID {Invalid}\\n    NO_DEVIATION {No deviation}\\n    NOT_ENABLED {Not enabled}\\n    OFFLINE {Offline}\\n    ONLINE {Online}\\n    PAUSED {Paused}\\n    REACHABLE {Reachable}\\n    RECONNECTING {Reconnecting}\\n    REENABLING {Reenabling}\\n    RESTARTING {Restarting}\\n    ROLLING_BACK {Rolling back}\\n    RUNNING {Running}\\n    STARTING {Starting}\\n    STOPPING {Stopping}\\n    TERMINATED {Terminated}\\n    UNAVAILABLE {Unavailable}\\n    UNKNOWN {Unknown}\\n    UNREACHABLE {Unreachable}\\n    UPDATING {Updating}\\n    VALID {Valid}\\n    WAITING {Waiting}\\n\\n    other {Unexpected}\\n}","STATUS":"Status","STOP_CONTAINERS_SUBTITLE":"<p>Stopped containers are unavailable and stop running their internal processes. You can restart them later.</p><p>Are you sure you want to stop the following {count, plural, =1 {container} other {containers}}?</p>","STOP_CONTAINERS":"Stop {count, plural, =1 {container} other {containers}}","STOP":"Stop","STORYBOOK_BUTTONS_DOCUMENTATION_BODY":"Every button variant, size and state.","STORYBOOK_BUTTONS_DOCUMENTATION_TITLE":"Button variants and sizes","STORYBOOK_BUTTONS":"Buttons","STORYBOOK_CHIPS_AND_STATUSES_DOCUMENTATION_BODY":"Chip variants and status indicators.","STORYBOOK_CHIPS_AND_STATUSES_DOCUMENTATION_TITLE":"Chips and statuses","STORYBOOK_CHIPS_AND_STATUSES":"Chips and statuses","STORYBOOK_FOUNDATIONS_DOCUMENTATION_BODY":"The typography variants and font weights, and the elevation shadows.","STORYBOOK_FOUNDATIONS_DOCUMENTATION_TITLE":"Typography and shadows","STORYBOOK_FOUNDATIONS":"Foundations","STORYBOOK_INPUTS_DOCUMENTATION_BODY":"Text inputs, autocompletes and dropdowns in every size.","STORYBOOK_INPUTS_DOCUMENTATION_TITLE":"Inputs, autocompletes and dropdowns","STORYBOOK_INPUTS":"Inputs","STORYBOOK_NOTIFICATIONS_DOCUMENTATION_BODY":"Playgrounds that trigger real toasts and banners, and every inline alert variant.","STORYBOOK_NOTIFICATIONS_DOCUMENTATION_TITLE":"Toasts, banners and inline alerts","STORYBOOK_NOTIFICATIONS":"Notifications","STORYBOOK_TABLES_DOCUMENTATION_BODY":"Example tables and their selection toolbar.","STORYBOOK_TABLES_DOCUMENTATION_TITLE":"Table examples","STORYBOOK_TABLES":"Tables","STORYBOOK":"Storybook","SUBJECT":"Subject","SUBSCRIBE_BROKER":"Subscribe broker","SUBSCRIBE":"Subscribe","SUCCESSFULLY_SENT_METRICS_TO_PORTAL":"Metrics sent to Cybus Portal","SYSTEM_CONTAINER":"System container","SYSTEM_INFORMATION_DOCUMENTATION_BODY":"This tab shows your Connectware version, whether a newer version is available, and how many services are installed. The check for a newer version needs Internet access.","SYSTEM_INFORMATION_DOCUMENTATION_TITLE":"Connectware version and number of installed services","SYSTEM_INFORMATION":"System information","SYSTEM_STATUS":"System status","SYSTEM":"System","TABLE_LOAD_ERROR":"Could not load the data","TABLE_LOADING":"Loading\u2026","TABLE_PAGINATION_DISPLAYED_ROWS":"{showShort, select, true {{totalCount, number}} other {{startNum, number}\u2013{endNum, number}}} of {totalCount, number}","TIME":"Time","TIMEOUT_ERROR":"The network connection is slow or unstable. <link>Reload the page</link> and try again.","TIMESTAMP":"Timestamp","TOGGLE_AUTHENTICATION_METHOD":"Use {method,select, otp {backup code} backupCodes {authentication code} other {}}","TOKEN_ERROR_DIALOG_CONTENT":"Could not sign in with this token","TOKEN_ERROR_DIALOG_TITLE":"Token authentication","TOKEN_EXPIRED_ERROR":"Your session has expired. Sign in again.","TOKEN_EXPIRING_MODAL_BODY":"You will be signed out automatically in {countdown}.{br}Save your changes now.","TOKEN_EXPIRING_MODAL_TITLE":"Session ends soon","TOPIC_PLACEHOLDER":"foo/bar/+","TOPIC_SUBSCRIPTION_ERROR":"<paragraph>{error, select, shared {{topicsCount, plural, =1 {Subscription to the shared topic {topics} is} other {Subscriptions to the shared topics {topics} are}} not supported.} noPermissions {You do not have permission to subscribe to {topics}.} invalid {The {topicsCount, plural, =1 {topic {topics} is} other {topics {topics} are}} invalid.} other {There was an issue while subscribing to the {topicsCount, plural, =1 {topic} other {topics}} {topics}.}}</paragraph><paragraph>{retry, select, true {<retryButton>Retry</retryButton>} other {}}{unsub, select, true {<unsubButton>Unsubscribe</unsubButton>} other {}}</paragraph>","TOPIC_TYPE":"{type,select, BOOLEAN {Boolean} EMPTY {Empty} HEX {Hex} NULL {Null} NUMBER {Number} OBJECT {Object} STRING {String} LARGE_BUFFER {Large message} other {Unknown}}","TOPIC":"{count, plural, =1 {Topic} other {Topics}}","TOPICS_METADATA_PERMISSION_MISSING":"<b>Note</b>: Your permissions limit this view to adding and filtering custom topics. To see the live data of a service, open the service in <link>Services</link>.","TOTAL_PERMISSIONS":"{count, plural, =0 {No permissions} =1 {# total permission} other {# total permissions}}","TRANSFORMATION_INPUT_HELPER_TEXT":"When you copy the transformation rule above, check whether you need an additional buffer-to-string conversion (see the <link>rule engine documentation</link>).","TRANSFORMATION_INPUT":"{last, select, true {Last transformation input{hasSource, select, true { (from \\"{source}\\" {copy})} other {}}} other {Custom transformation input}}","TRANSFORMATION_RESULT":"Transformation result","TRANSFORMATION_RULE":"Transformation rule expression {copy}","TRY_AGAIN":"Try again","TYPE":"Type","UI_ACCESS_PERMISSIONS_DOCUMENTATION":"UI access permissions documentation","UNLOCK":"Unlock","UNSUBSCRIBE":"Unsubscribe","UPDATE":"Update","UPLOAD_LICENSE_FILE":"Upload license file","UPLOAD_SERVICE":"Upload service","USER_AUTHENTICATION_METHOD":"{method,select, TOKEN {Token} PASSWORD {Password} CERTIFICATE {Certificate} other {Unknown}}","USER_CERTIFICATES":"User {count, plural, =1 {certificate} other {certificates}}","USER_MANAGEMENT":"User management","USER_PROVIDER":"{provider, select, CONNECTWARE {Local} LDAP {LDAP} SERVICE {Local (by service)} MICROSOFT_ENTRA_ID {Entra ID} other {Unknown}}","USER_UPDATE_ERROR_PROTECTED_USER":"Cannot remove authentication method {method} from user {username}","USER":"{count, plural, =1 {User} other {Users}}","USERNAME_ALREADY_USED":"A user named \\"{username}\\" already exists. Enter a different username.","USERNAME_VALIDATION":"{type, select, minLength {At least {count} {count, plural, =1 {character} other {characters}}} other {Unknown}}","USERNAME":"Username","USERS_AND_ROLES_DOCUMENTATION_BODY":"Users are people or software clients that access Connectware. Roles bundle permissions so that several users can share the same access. A permission grants read access, write access, or both to an MQTT topic or an HTTP endpoint. To add a user or role, click <b>New user</b> or <b>New role</b>.","USERS_AND_ROLES_DOCUMENTATION_TITLE":"Add and manage users, roles, and permissions","USERS_AND_ROLES":"Users and roles","VALIDITY_PERIOD":"Validity period","VALUE":"Value","VERSION_MISMATCH_ACTION":"Sign out and reload","VERSION_MISMATCH_BODY":"Connectware now runs version {backend}, but this page was loaded with Admin UI version {frontend}. To continue, sign out and reload.","VERSION_MISMATCH_TITLE":"Connectware version changed","VERSION":"Version","VIEW_CONFIGURATION":"View configuration","VIEW_SERVICE":"View service","VOLUME_DETAILS_DOCUMENTATION_BODY":"Volumes are persistent storage resources that can be linked to containers. The <b>Volume</b> view displays the name of the volume, service ID, creation date and time, and status. Additionally, you can see information about its labels and logs.","VOLUME_DETAILS_DOCUMENTATION_TITLE":"Monitor a volume","VOLUME_LOGS":"Volume logs","VOLUME_NOT_FOUND":"Volume not found","VOLUME":"{count, plural, =1 {Volume} other {Volumes}}","VOLUMES_DOCUMENTATION_BODY":"Volumes are persistent storage resources that can be linked to containers. The <b>Volumes</b> view displays all available volumes, including their service ID, creation date and time, and status. Click a volume for more information about its labels and logs.","VOLUMES_DOCUMENTATION_TITLE":"Monitor volumes","WORKBENCH_TITLE":"Node-RED workbench","WRONG_MFA_CREDENTIALS":"{type, select, otp {Incorrect authentication code. Check the code and try again.} backupCode {Incorrect backup code. Check the code and try again.} other {Unknown issue.}}","YOU_NEED_PERMISSION_TO_VIEW_THIS_DATA":"You need permission to view this data"}');


const $673d627cd9ac1812$export$41c018714c8ddef3 = (0, (/*@__PURE__*/$parcel$interopDefault($3cb20e33f4cfb802$exports)));


var $fe5237a1f36d497c$exports = {};
$fe5237a1f36d497c$exports = JSON.parse("{\"browser\":{\"./node_modules/jsoneditor/dist/jsoneditor.min.js\":\"./node_modules/jsoneditor/dist/jsoneditor.js\"},\"name\":\"admin-web-app\",\"version\":\"2.6.2\",\"private\":true,\"dependencies\":{\"@cybusio/policy-validator\":\"1.0.4\",\"@cybusio/rule-engine\":\"1.1.6\",\"@dnd-kit/core\":\"6.3.1\",\"@dnd-kit/sortable\":\"10.0.0\",\"@emotion/react\":\"11.11.0\",\"@emotion/styled\":\"11.11.0\",\"@fontsource/roboto\":\"5.2.9\",\"@fontsource/roboto-mono\":\"5.2.8\",\"@formatjs/intl\":\"2.7.2\",\"@microlink/react-json-view\":\"1.27.0\",\"@mui/icons-material\":\"7.3.7\",\"@mui/lab\":\"7.0.1-beta.21\",\"@mui/material\":\"7.3.7\",\"@mui/system\":\"7.3.7\",\"@mui/utils\":\"7.3.7\",\"@mui/x-tree-view\":\"7.29.10\",\"@rjsf/core\":\"6.6.2\",\"@rjsf/mui\":\"6.6.2\",\"@rjsf/utils\":\"6.6.2\",\"@rjsf/validator-ajv8\":\"6.6.2\",\"ace-builds\":\"1.22.0\",\"ajv\":\"6.12.6\",\"classnames\":\"2.5.1\",\"csv-stringify\":\"6.4.6\",\"diacritics\":\"1.3.0\",\"js-yaml\":\"4.1.1\",\"json-schema\":\"0.4.0\",\"jsoneditor\":\"9.10.2\",\"jsonschema\":\"1.4.1\",\"mqtt\":\"5.15.0\",\"notistack\":\"3.0.1\",\"object-hash\":\"3.0.0\",\"promise-file-reader\":\"1.0.3\",\"qrcode.react\":\"3.1.0\",\"react\":\"18.2.0\",\"react-day-picker\":\"10.0.1\",\"react-dom\":\"18.2.0\",\"react-error-boundary\":\"3.1.4\",\"react-helmet\":\"6.1.0\",\"react-intl\":\"6.4.2\",\"react-is\":\"18.2.0\",\"react-router-dom\":\"5.3.4\",\"react-sync-promise\":\"1.0.9\",\"use-sync-external-store\":\"1.7.0\",\"zustand\":\"5.0.15\"},\"devDependencies\":{\"@babel/preset-react\":\"7.22.5\",\"@babel/preset-typescript\":\"7.22.5\",\"@cypress/code-coverage\":\"3.14.7\",\"@dprint/json\":\"0.25.1\",\"@dprint/markdown\":\"0.25.0\",\"@dprint/typescript\":\"0.96.1\",\"@formatjs/icu-messageformat-parser\":\"2.4.0\",\"@formatjs/intl-numberformat\":\"8.5.0\",\"@inquirer/prompts\":\"8.3.2\",\"@parcel/packager-raw-url\":\"2.16.3\",\"@parcel/transformer-webmanifest\":\"2.16.3\",\"@testing-library/react\":\"16.3.1\",\"@types/diacritics\":\"1.3.1\",\"@types/jest\":\"30.0.0\",\"@types/js-yaml\":\"4.0.9\",\"@types/jsoneditor\":\"9.9.6\",\"@types/object-hash\":\"3.0.2\",\"@types/react\":\"18.3.27\",\"@types/react-dom\":\"18.2.4\",\"@types/react-helmet\":\"6.1.6\",\"@types/react-router-dom\":\"5.3.3\",\"@types/strip-color\":\"0.1.0\",\"@typescript-eslint/eslint-plugin\":\"6.21.0\",\"babel-jest\":\"30.2.0\",\"babel-plugin-istanbul\":\"6.1.1\",\"buffer\":\"5.7.1\",\"chalk\":\"4.1.2\",\"core-js\":\"3.30.2\",\"cypress\":\"15.9.0\",\"depcheck\":\"1.4.3\",\"dockerfile-ast\":\"0.7.1\",\"dprint\":\"0.58.0\",\"eslint\":\"8.57.1\",\"eslint-config-standard-with-typescript\":\"43.0.1\",\"eslint-plugin-ferramentas\":\"2.0.1\",\"eslint-plugin-import\":\"2.32.0\",\"eslint-plugin-n\":\"16.6.2\",\"eslint-plugin-promise\":\"6.6.0\",\"eslint-plugin-react\":\"7.37.5\",\"eslint-plugin-typescript-sort-keys\":\"3.3.0\",\"events\":\"3.3.0\",\"history\":\"4.10.1\",\"jest\":\"30.2.0\",\"jest-environment-jsdom\":\"30.2.0\",\"jest-file-matcher\":\"1.0.2\",\"nyc\":\"15.1.0\",\"openapi-typescript\":\"7.4.3\",\"parcel\":\"2.16.3\",\"process\":\"0.11.10\",\"punycode\":\"2.3.1\",\"querystring-es3\":\"0.2.1\",\"strip-color\":\"0.1.0\",\"ts-json-schema-generator\":\"1.1.0\",\"ts-morph\":\"18.0.0\",\"tsx\":\"4.21.0\",\"typescript\":\"5.3.3\",\"url\":\"0.11.4\",\"utility-types\":\"3.10.0\"},\"scripts\":{\"fix:format\":\"eslint --fix '**/**/*.ts' '**/**/*.tsx' '**/**/*.js'; eslint_status=$?; dprint fmt && exit $eslint_status\",\"fix:format:unmerged\":\"tsx ./src/infrastructure/scripts/executables/format-unmerged.ts\",\"fix:format:ci\":\"npm run generate:env-config-metadata-file && npm run generate:schema-validators && npm run generate:capabilities && npm run fix:mark-unneeded-exports && npm run fix:format\",\"fix:mark-unneeded-exports\":\"tsx ./src/infrastructure/scripts/executables/mark-unneeded-exports.ts\",\"generate:build\":\"npm run generate:parcel-config && rm -rf build && parcel build src/infrastructure/parcel/index.html --config=./src/infrastructure/parcel/.parcelrc --no-autoinstall --log-level=info --public-url=/admin --dist-dir=build\",\"generate:env-config-metadata-file\":\"tsx ./src/infrastructure/scripts/executables/generate-env-config-metadata-file.ts\",\"generate:parcel-config\":\"tsx ./src/infrastructure/scripts/executables/generate-parcel-config.ts\",\"generate:capabilities\":\"tsx ./src/infrastructure/scripts/executables/generate-capabilities.ts\",\"generate:routes-config-file\":\"tsx ./src/infrastructure/scripts/executables/generate-routes-config-file.ts\",\"generate:env-file\":\"tsx ./src/infrastructure/scripts/executables/generate-env-file.ts\",\"generate:backend-schema-types\":\"tsx ./src/infrastructure/scripts/executables/backend-schema-types.ts --generate\",\"generate:schema-validators\":\"tsx ./src/infrastructure/scripts/executables/generate-schema-validators.ts\",\"generate:packages-file\":\"tsx ./src/infrastructure/scripts/executables/packages-file.ts --generate\",\"parcel:serve\":\"npm run generate:parcel-config && parcel serve src/infrastructure/parcel/index.html --config=./src/infrastructure/parcel/.parcelrc --no-autoinstall --log-level=info --public-url=/admin --dist-dir=build\",\"start:demo\":\"CYBUS_ADMIN_UI_BACKEND_HOST=demo.cybus.io npm run parcel:serve -- --https --port=8080\",\"start:docker\":\"npm run parcel:serve -- --host=0.0.0.0 --port=${CYBUS_ADMIN_UI_PORT} --hmr-port=${PARCEL_HMR_PORT} --lazy\",\"validate:coverage\":\"tsx ./src/infrastructure/scripts/executables/validate-coverage.ts\",\"test:e2e:coverage\":\"COVERAGE=true npm run test:e2e\",\"test:e2e\":\"cypress run --config-file=cypress.config.ts --browser chrome\",\"test:e2e:coverage:files\":\"tsx ./src/infrastructure/scripts/executables/generate-e2e-coverage-files.ts\",\"test:unit:coverage\":\"npm run test:unit -- --coverage\",\"test:unit\":\"jest --config test/jest/config.ts\",\"validate:backend-schema-types\":\"tsx ./src/infrastructure/scripts/executables/backend-schema-types.ts --validate\",\"validate:dependencies\":\"tsx ./src/infrastructure/scripts/executables/validate-dependencies.ts\",\"validate:translations\":\"tsx ./src/infrastructure/scripts/executables/validate-translations.ts\",\"validate:packages-file\":\"tsx ./src/infrastructure/scripts/executables/packages-file.ts --validate\",\"validate:pr-deleted-specs\":\"tsx ./src/infrastructure/scripts/executables/validate-pr-deleted-specs.ts\",\"validate:pr-size\":\"tsx ./src/infrastructure/scripts/executables/validate-pr-size.ts\",\"validate:circular-imports\":\"npx tsx src/infrastructure/scripts/executables/validate-circular-imports.ts\",\"validate:lint\":\"eslint --report-unused-disable-directives --max-warnings 33 '**/**/*.ts' '**/**/*.tsx' '**/**/*.js'\",\"validate:typescript\":\"tsc --noEmit\",\"postinstall\":\"tsx ./src/infrastructure/scripts/executables/post-install.ts\",\"prepare\":\"git config core.hooksPath .githooks || true\",\"update:docker-images\":\"tsx src/infrastructure/scripts/executables/update-docker-images.ts\"},\"browserslist\":{\"production\":[\">0.2%\",\"not dead\",\"not op_mini all\"],\"development\":[\"last 1 chrome version\",\"last 1 firefox version\",\"last 1 safari version\"]},\"engines\":{\"node\":\"26.12.0\"},\"overrides\":{\"react-is\":\"18.2.0\"},\"@parcel/resolver-default\":{\"packageExports\":true},\"coverageThreshold\":{\"global\":{\"statements\":99.99,\"branches\":99.83,\"lines\":99.99,\"functions\":100},\"src/infrastructure/\":{\"statements\":99.98,\"branches\":99.84,\"lines\":99.98,\"functions\":100},\"src/infrastructure/types/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/infrastructure/react/\":{\"statements\":99.98,\"branches\":99.78,\"lines\":99.98,\"functions\":100},\"src/infrastructure/schema/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/infrastructure/http/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/infrastructure/RSTWebSocket/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/infrastructure/Connectware/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/infrastructure/CybusConfiguration/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/infrastructure/webstorage/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/infrastructure/assets/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/infrastructure/HTML5/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/infrastructure/file/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/infrastructure/mqtt/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/infrastructure/scripts/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/infrastructure/config/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/infrastructure/parcel/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/infrastructure/workers/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/infrastructure/FileService/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/infrastructure/FormatJS/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/infrastructure/RuleEngine/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/utils/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100},\"src/domain/\":{\"statements\":100,\"branches\":99.32,\"lines\":100,\"functions\":100},\"src/application/\":{\"statements\":100,\"branches\":100,\"lines\":100,\"functions\":100}}}");


const $298e6f3f5d24d393$export$e506a1d27d1eaa20 = {
    translations: (0, $673d627cd9ac1812$export$41c018714c8ddef3),
    displayVersion: (0, $fe5237a1f36d497c$exports.version),
    backendHost: null,
    contact: {
        salesEmail: 'sales@cybus.io',
        supportEmail: 'support@cybus.io'
    },
    userManagement: {
        protectedRoles: [
            'connectware-admin',
            'minimum-access',
            'protocol-mapper-agent'
        ],
        protectedUsers: [
            'admin'
        ],
        pageSize: 20,
        searchSize: 5,
        indexesCache: 300000,
        clientRegistryRefreshRate: 5000,
        certificateFileExtension: 'pem'
    },
    workbenchPath: '/workbench',
    mqtt: {
        path: '/mqtt',
        timeout: 6000,
        cycle: 500,
        maxTopicDepth: 20
    },
    rst: {
        cacheLifespan: 500,
        maxPageSize: 25,
        reconnectTimeout: 5000
    },
    pageSizes: {
        short: 10,
        default: 25,
        large: 50,
        max: 100
    },
    services: {
        commissioningFile: {
            extensions: [
                'yml',
                'yaml'
            ],
            downloadMimeType: 'text/yaml;charset=utf-8'
        },
        externalUrlBasePath: '/services'
    },
    licenseFileExtension: 'lic',
    infoPageRefreshRate: 20000,
    interactionThrottle: 500,
    resourcesRefreshThrottle: 5000,
    resourcesRefreshRate: 300000,
    documentation: 'https://docs.cybus.io',
    searchMinimum: 3,
    logoutWarningPeriod: 600000,
    enableStorybook: false
};


const $bdb9ab46d84b7713$export$a71a2d67788c0bd8 = (0, (/*@__PURE__*/$parcel$interopDefault($cab2c0e2a736d626$exports)));






var $10b0ba2520986fb8$exports = {};
'use strict';
var $5199d6ec1105cd7c$exports = {};
'use strict';

var $edhTp = parcelRequire("edhTp");

var $4tGD1 = parcelRequire("4tGD1");

var $fhgGC = parcelRequire("fhgGC");
var $19c7ef91d507f423$exports = {};
'use strict';
$19c7ef91d507f423$exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};



var $amAeJ = parcelRequire("amAeJ");
/**
 * Functions below are used inside compiled validations function
 */ var $5199d6ec1105cd7c$var$ucs2length = $4tGD1.ucs2length;

var $5jHra = parcelRequire("5jHra");
// this error is thrown by async schemas to return validation errors via exception
var $5199d6ec1105cd7c$var$ValidationError = $fhgGC.Validation;
$5199d6ec1105cd7c$exports = $5199d6ec1105cd7c$var$compile;
/**
 * Compiles schema to validation function
 * @this   Ajv
 * @param  {Object} schema schema object
 * @param  {Object} root object with information about the root schema for this schema
 * @param  {Object} localRefs the hash of local references inside the schema (created by resolve.id), used for inline resolution
 * @param  {String} baseId base ID for IDs in the schema
 * @return {Function} validation function
 */ function $5199d6ec1105cd7c$var$compile(schema, root, localRefs, baseId) {
    /* jshint validthis: true, evil: true */ /* eslint no-shadow: 0 */ var self = this, opts = this._opts, refVal = [
        undefined
    ], refs = {}, patterns = [], patternsHash = {}, defaults = [], defaultsHash = {}, customRules = [];
    root = root || {
        schema: schema,
        refVal: refVal,
        refs: refs
    };
    var c = $5199d6ec1105cd7c$var$checkCompiling.call(this, schema, root, baseId);
    var compilation = this._compilations[c.index];
    if (c.compiling) return compilation.callValidate = callValidate;
    var formats = this._formats;
    var RULES = this.RULES;
    try {
        var v = localCompile(schema, root, localRefs, baseId);
        compilation.validate = v;
        var cv = compilation.callValidate;
        if (cv) {
            cv.schema = v.schema;
            cv.errors = null;
            cv.refs = v.refs;
            cv.refVal = v.refVal;
            cv.root = v.root;
            cv.$async = v.$async;
            if (opts.sourceCode) cv.source = v.source;
        }
        return v;
    } finally{
        $5199d6ec1105cd7c$var$endCompiling.call(this, schema, root, baseId);
    }
    /* @this   {*} - custom context, see passContext option */ function callValidate() {
        /* jshint validthis: true */ var validate = compilation.validate;
        var result = validate.apply(this, arguments);
        callValidate.errors = validate.errors;
        return result;
    }
    function localCompile(_schema, _root, localRefs, baseId) {
        var isRoot = !_root || _root && _root.schema == _schema;
        if (_root.schema != root.schema) return $5199d6ec1105cd7c$var$compile.call(self, _schema, _root, localRefs, baseId);
        var $async = _schema.$async === true;
        var sourceCode = $amAeJ({
            isTop: true,
            schema: _schema,
            isRoot: isRoot,
            baseId: baseId,
            root: _root,
            schemaPath: '',
            errSchemaPath: '#',
            errorPath: '""',
            MissingRefError: $fhgGC.MissingRef,
            RULES: RULES,
            validate: $amAeJ,
            util: $4tGD1,
            resolve: $edhTp,
            resolveRef: resolveRef,
            usePattern: usePattern,
            useDefault: useDefault,
            useCustomRule: useCustomRule,
            opts: opts,
            formats: formats,
            logger: self.logger,
            self: self
        });
        sourceCode = $5199d6ec1105cd7c$var$vars(refVal, $5199d6ec1105cd7c$var$refValCode) + $5199d6ec1105cd7c$var$vars(patterns, $5199d6ec1105cd7c$var$patternCode) + $5199d6ec1105cd7c$var$vars(defaults, $5199d6ec1105cd7c$var$defaultCode) + $5199d6ec1105cd7c$var$vars(customRules, $5199d6ec1105cd7c$var$customRuleCode) + sourceCode;
        if (opts.processCode) sourceCode = opts.processCode(sourceCode, _schema);
        // console.log('\n\n\n *** \n', JSON.stringify(sourceCode));
        var validate;
        try {
            var makeValidate = new Function('self', 'RULES', 'formats', 'root', 'refVal', 'defaults', 'customRules', 'equal', 'ucs2length', 'ValidationError', sourceCode);
            validate = makeValidate(self, RULES, formats, root, refVal, defaults, customRules, $5jHra, $5199d6ec1105cd7c$var$ucs2length, $5199d6ec1105cd7c$var$ValidationError);
            refVal[0] = validate;
        } catch (e) {
            self.logger.error('Error compiling schema, function code:', sourceCode);
            throw e;
        }
        validate.schema = _schema;
        validate.errors = null;
        validate.refs = refs;
        validate.refVal = refVal;
        validate.root = isRoot ? validate : _root;
        if ($async) validate.$async = true;
        if (opts.sourceCode === true) validate.source = {
            code: sourceCode,
            patterns: patterns,
            defaults: defaults
        };
        return validate;
    }
    function resolveRef(baseId, ref, isRoot) {
        ref = $edhTp.url(baseId, ref);
        var refIndex = refs[ref];
        var _refVal, refCode;
        if (refIndex !== undefined) {
            _refVal = refVal[refIndex];
            refCode = 'refVal[' + refIndex + ']';
            return resolvedRef(_refVal, refCode);
        }
        if (!isRoot && root.refs) {
            var rootRefId = root.refs[ref];
            if (rootRefId !== undefined) {
                _refVal = root.refVal[rootRefId];
                refCode = addLocalRef(ref, _refVal);
                return resolvedRef(_refVal, refCode);
            }
        }
        refCode = addLocalRef(ref);
        var v = $edhTp.call(self, localCompile, root, ref);
        if (v === undefined) {
            var localSchema = localRefs && localRefs[ref];
            if (localSchema) v = $edhTp.inlineRef(localSchema, opts.inlineRefs) ? localSchema : $5199d6ec1105cd7c$var$compile.call(self, localSchema, root, localRefs, baseId);
        }
        if (v === undefined) removeLocalRef(ref);
        else {
            replaceLocalRef(ref, v);
            return resolvedRef(v, refCode);
        }
    }
    function addLocalRef(ref, v) {
        var refId = refVal.length;
        refVal[refId] = v;
        refs[ref] = refId;
        return 'refVal' + refId;
    }
    function removeLocalRef(ref) {
        delete refs[ref];
    }
    function replaceLocalRef(ref, v) {
        var refId = refs[ref];
        refVal[refId] = v;
    }
    function resolvedRef(refVal, code) {
        return typeof refVal == 'object' || typeof refVal == 'boolean' ? {
            code: code,
            schema: refVal,
            inline: true
        } : {
            code: code,
            $async: refVal && !!refVal.$async
        };
    }
    function usePattern(regexStr) {
        var index = patternsHash[regexStr];
        if (index === undefined) {
            index = patternsHash[regexStr] = patterns.length;
            patterns[index] = regexStr;
        }
        return 'pattern' + index;
    }
    function useDefault(value) {
        switch(typeof value){
            case 'boolean':
            case 'number':
                return '' + value;
            case 'string':
                return $4tGD1.toQuotedString(value);
            case 'object':
                if (value === null) return 'null';
                var valueStr = $19c7ef91d507f423$exports(value);
                var index = defaultsHash[valueStr];
                if (index === undefined) {
                    index = defaultsHash[valueStr] = defaults.length;
                    defaults[index] = value;
                }
                return 'default' + index;
        }
    }
    function useCustomRule(rule, schema, parentSchema, it) {
        if (self._opts.validateSchema !== false) {
            var deps = rule.definition.dependencies;
            if (deps && !deps.every(function(keyword) {
                return Object.prototype.hasOwnProperty.call(parentSchema, keyword);
            })) throw new Error('parent schema must have all required keywords: ' + deps.join(','));
            var validateSchema = rule.definition.validateSchema;
            if (validateSchema) {
                var valid = validateSchema(schema);
                if (!valid) {
                    var message = 'keyword schema is invalid: ' + self.errorsText(validateSchema.errors);
                    if (self._opts.validateSchema == 'log') self.logger.error(message);
                    else throw new Error(message);
                }
            }
        }
        var compile = rule.definition.compile, inline = rule.definition.inline, macro = rule.definition.macro;
        var validate;
        if (compile) validate = compile.call(self, schema, parentSchema, it);
        else if (macro) {
            validate = macro.call(self, schema, parentSchema, it);
            if (opts.validateSchema !== false) self.validateSchema(validate, true);
        } else if (inline) validate = inline.call(self, it, rule.keyword, schema, parentSchema);
        else {
            validate = rule.definition.validate;
            if (!validate) return;
        }
        if (validate === undefined) throw new Error('custom keyword "' + rule.keyword + '"failed to compile');
        var index = customRules.length;
        customRules[index] = validate;
        return {
            code: 'customRule' + index,
            validate: validate
        };
    }
}
/**
 * Checks if the schema is currently compiled
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 * @return {Object} object with properties "index" (compilation index) and "compiling" (boolean)
 */ function $5199d6ec1105cd7c$var$checkCompiling(schema, root, baseId) {
    /* jshint validthis: true */ var index = $5199d6ec1105cd7c$var$compIndex.call(this, schema, root, baseId);
    if (index >= 0) return {
        index: index,
        compiling: true
    };
    index = this._compilations.length;
    this._compilations[index] = {
        schema: schema,
        root: root,
        baseId: baseId
    };
    return {
        index: index,
        compiling: false
    };
}
/**
 * Removes the schema from the currently compiled list
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 */ function $5199d6ec1105cd7c$var$endCompiling(schema, root, baseId) {
    /* jshint validthis: true */ var i = $5199d6ec1105cd7c$var$compIndex.call(this, schema, root, baseId);
    if (i >= 0) this._compilations.splice(i, 1);
}
/**
 * Index of schema compilation in the currently compiled list
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 * @return {Integer} compilation index
 */ function $5199d6ec1105cd7c$var$compIndex(schema, root, baseId) {
    /* jshint validthis: true */ for(var i = 0; i < this._compilations.length; i++){
        var c = this._compilations[i];
        if (c.schema == schema && c.root == root && c.baseId == baseId) return i;
    }
    return -1;
}
function $5199d6ec1105cd7c$var$patternCode(i, patterns) {
    return 'var pattern' + i + ' = new RegExp(' + $4tGD1.toQuotedString(patterns[i]) + ');';
}
function $5199d6ec1105cd7c$var$defaultCode(i) {
    return 'var default' + i + ' = defaults[' + i + '];';
}
function $5199d6ec1105cd7c$var$refValCode(i, refVal) {
    return refVal[i] === undefined ? '' : 'var refVal' + i + ' = refVal[' + i + '];';
}
function $5199d6ec1105cd7c$var$customRuleCode(i) {
    return 'var customRule' + i + ' = customRules[' + i + '];';
}
function $5199d6ec1105cd7c$var$vars(arr, statement) {
    if (!arr.length) return '';
    var code = '';
    for(var i = 0; i < arr.length; i++)code += statement(i, arr);
    return code;
}



var $edhTp = parcelRequire("edhTp");
var $a62c74eb5c21bfa2$exports = {};
'use strict';
var $a62c74eb5c21bfa2$var$Cache = $a62c74eb5c21bfa2$exports = function Cache() {
    this._cache = {};
};
$a62c74eb5c21bfa2$var$Cache.prototype.put = function Cache_put(key, value) {
    this._cache[key] = value;
};
$a62c74eb5c21bfa2$var$Cache.prototype.get = function Cache_get(key) {
    return this._cache[key];
};
$a62c74eb5c21bfa2$var$Cache.prototype.del = function Cache_del(key) {
    delete this._cache[key];
};
$a62c74eb5c21bfa2$var$Cache.prototype.clear = function Cache_clear() {
    this._cache = {};
};



var $8D9VW = parcelRequire("8D9VW");

var $7e6655d19abd89bd$exports = {};
'use strict';

var $4tGD1 = parcelRequire("4tGD1");
var $7e6655d19abd89bd$var$DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
var $7e6655d19abd89bd$var$DAYS = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $7e6655d19abd89bd$var$TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
var $7e6655d19abd89bd$var$HOSTNAME = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i;
var $7e6655d19abd89bd$var$URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
var $7e6655d19abd89bd$var$URIREF = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
// uri-template: https://tools.ietf.org/html/rfc6570
var $7e6655d19abd89bd$var$URITEMPLATE = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i;
// For the source: https://gist.github.com/dperini/729294
// For test cases: https://mathiasbynens.be/demo/url-regex
// @todo Delete current URL in favour of the commented out URL rule when this issue is fixed https://github.com/eslint/eslint/issues/7983.
// var URL = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u{00a1}-\u{ffff}0-9]+-)*[a-z\u{00a1}-\u{ffff}0-9]+)(?:\.(?:[a-z\u{00a1}-\u{ffff}0-9]+-)*[a-z\u{00a1}-\u{ffff}0-9]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu;
var $7e6655d19abd89bd$var$URL = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i;
var $7e6655d19abd89bd$var$UUID = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
var $7e6655d19abd89bd$var$JSON_POINTER = /^(?:\/(?:[^~/]|~0|~1)*)*$/;
var $7e6655d19abd89bd$var$JSON_POINTER_URI_FRAGMENT = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i;
var $7e6655d19abd89bd$var$RELATIVE_JSON_POINTER = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
$7e6655d19abd89bd$exports = $7e6655d19abd89bd$var$formats;
function $7e6655d19abd89bd$var$formats(mode) {
    mode = mode == 'full' ? 'full' : 'fast';
    return $4tGD1.copy($7e6655d19abd89bd$var$formats[mode]);
}
$7e6655d19abd89bd$var$formats.fast = {
    // date: http://tools.ietf.org/html/rfc3339#section-5.6
    date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
    // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
    time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
    'date-time': /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
    // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
    uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
    'uri-reference': /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
    'uri-template': $7e6655d19abd89bd$var$URITEMPLATE,
    url: $7e6655d19abd89bd$var$URL,
    // email (sources from jsen validator):
    // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
    // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'willful violation')
    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
    hostname: $7e6655d19abd89bd$var$HOSTNAME,
    // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    // optimized http://stackoverflow.com/questions/53497/regular-expression-that-matches-valid-ipv6-addresses
    ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
    regex: $7e6655d19abd89bd$var$regex,
    // uuid: http://tools.ietf.org/html/rfc4122
    uuid: $7e6655d19abd89bd$var$UUID,
    // JSON-pointer: https://tools.ietf.org/html/rfc6901
    // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
    'json-pointer': $7e6655d19abd89bd$var$JSON_POINTER,
    'json-pointer-uri-fragment': $7e6655d19abd89bd$var$JSON_POINTER_URI_FRAGMENT,
    // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
    'relative-json-pointer': $7e6655d19abd89bd$var$RELATIVE_JSON_POINTER
};
$7e6655d19abd89bd$var$formats.full = {
    date: $7e6655d19abd89bd$var$date,
    time: $7e6655d19abd89bd$var$time,
    'date-time': $7e6655d19abd89bd$var$date_time,
    uri: $7e6655d19abd89bd$var$uri,
    'uri-reference': $7e6655d19abd89bd$var$URIREF,
    'uri-template': $7e6655d19abd89bd$var$URITEMPLATE,
    url: $7e6655d19abd89bd$var$URL,
    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    hostname: $7e6655d19abd89bd$var$HOSTNAME,
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
    regex: $7e6655d19abd89bd$var$regex,
    uuid: $7e6655d19abd89bd$var$UUID,
    'json-pointer': $7e6655d19abd89bd$var$JSON_POINTER,
    'json-pointer-uri-fragment': $7e6655d19abd89bd$var$JSON_POINTER_URI_FRAGMENT,
    'relative-json-pointer': $7e6655d19abd89bd$var$RELATIVE_JSON_POINTER
};
function $7e6655d19abd89bd$var$isLeapYear(year) {
    // https://tools.ietf.org/html/rfc3339#appendix-C
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $7e6655d19abd89bd$var$date(str) {
    // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
    var matches = str.match($7e6655d19abd89bd$var$DATE);
    if (!matches) return false;
    var year = +matches[1];
    var month = +matches[2];
    var day = +matches[3];
    return month >= 1 && month <= 12 && day >= 1 && day <= (month == 2 && $7e6655d19abd89bd$var$isLeapYear(year) ? 29 : $7e6655d19abd89bd$var$DAYS[month]);
}
function $7e6655d19abd89bd$var$time(str, full) {
    var matches = str.match($7e6655d19abd89bd$var$TIME);
    if (!matches) return false;
    var hour = matches[1];
    var minute = matches[2];
    var second = matches[3];
    var timeZone = matches[5];
    return (hour <= 23 && minute <= 59 && second <= 59 || hour == 23 && minute == 59 && second == 60) && (!full || timeZone);
}
var $7e6655d19abd89bd$var$DATE_TIME_SEPARATOR = /t|\s/i;
function $7e6655d19abd89bd$var$date_time(str) {
    // http://tools.ietf.org/html/rfc3339#section-5.6
    var dateTime = str.split($7e6655d19abd89bd$var$DATE_TIME_SEPARATOR);
    return dateTime.length == 2 && $7e6655d19abd89bd$var$date(dateTime[0]) && $7e6655d19abd89bd$var$time(dateTime[1], true);
}
var $7e6655d19abd89bd$var$NOT_URI_FRAGMENT = /\/|:/;
function $7e6655d19abd89bd$var$uri(str) {
    // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
    return $7e6655d19abd89bd$var$NOT_URI_FRAGMENT.test(str) && $7e6655d19abd89bd$var$URI.test(str);
}
var $7e6655d19abd89bd$var$Z_ANCHOR = /[^\\]\\Z/;
function $7e6655d19abd89bd$var$regex(str) {
    if ($7e6655d19abd89bd$var$Z_ANCHOR.test(str)) return false;
    try {
        new RegExp(str);
        return true;
    } catch (e) {
        return false;
    }
}


var $d571a6d2ed6eddb5$exports = {};
'use strict';
var $137a5a588b44bc4d$exports = {};
'use strict';




























//all requires must be explicit because browserify won't work with dynamic requires
$137a5a588b44bc4d$exports = {
    '$ref': (parcelRequire("0f208")),
    allOf: (parcelRequire("2aXQw")),
    anyOf: (parcelRequire("ka2ZD")),
    '$comment': (parcelRequire("dxVE0")),
    const: (parcelRequire("61YI5")),
    contains: (parcelRequire("daBSX")),
    dependencies: (parcelRequire("bOv4z")),
    'enum': (parcelRequire("cWg6Q")),
    format: (parcelRequire("bP8w5")),
    'if': (parcelRequire("3TaSd")),
    items: (parcelRequire("ejmK1")),
    maximum: (parcelRequire("ci4jj")),
    minimum: (parcelRequire("ci4jj")),
    maxItems: (parcelRequire("6Z7ie")),
    minItems: (parcelRequire("6Z7ie")),
    maxLength: (parcelRequire("hy8Bk")),
    minLength: (parcelRequire("hy8Bk")),
    maxProperties: (parcelRequire("fa2pn")),
    minProperties: (parcelRequire("fa2pn")),
    multipleOf: (parcelRequire("cNhcR")),
    not: (parcelRequire("2XE4Y")),
    oneOf: (parcelRequire("dBpqw")),
    pattern: (parcelRequire("Og1VF")),
    properties: (parcelRequire("jMG7B")),
    propertyNames: (parcelRequire("5XltN")),
    required: (parcelRequire("ghbYr")),
    uniqueItems: (parcelRequire("92UPI")),
    validate: (parcelRequire("amAeJ"))
};



var $4tGD1 = parcelRequire("4tGD1");
var $d571a6d2ed6eddb5$require$toHash = $4tGD1.toHash;
$d571a6d2ed6eddb5$exports = function rules() {
    var RULES = [
        {
            type: 'number',
            rules: [
                {
                    'maximum': [
                        'exclusiveMaximum'
                    ]
                },
                {
                    'minimum': [
                        'exclusiveMinimum'
                    ]
                },
                'multipleOf',
                'format'
            ]
        },
        {
            type: 'string',
            rules: [
                'maxLength',
                'minLength',
                'pattern',
                'format'
            ]
        },
        {
            type: 'array',
            rules: [
                'maxItems',
                'minItems',
                'items',
                'contains',
                'uniqueItems'
            ]
        },
        {
            type: 'object',
            rules: [
                'maxProperties',
                'minProperties',
                'required',
                'dependencies',
                'propertyNames',
                {
                    'properties': [
                        'additionalProperties',
                        'patternProperties'
                    ]
                }
            ]
        },
        {
            rules: [
                '$ref',
                'const',
                'enum',
                'not',
                'anyOf',
                'oneOf',
                'allOf',
                'if'
            ]
        }
    ];
    var ALL = [
        'type',
        '$comment'
    ];
    var KEYWORDS = [
        '$schema',
        '$id',
        'id',
        '$data',
        '$async',
        'title',
        'description',
        'default',
        'definitions',
        'examples',
        'readOnly',
        'writeOnly',
        'contentMediaType',
        'contentEncoding',
        'additionalItems',
        'then',
        'else'
    ];
    var TYPES = [
        'number',
        'integer',
        'string',
        'array',
        'object',
        'boolean',
        'null'
    ];
    RULES.all = $d571a6d2ed6eddb5$require$toHash(ALL);
    RULES.types = $d571a6d2ed6eddb5$require$toHash(TYPES);
    RULES.forEach(function(group) {
        group.rules = group.rules.map(function(keyword) {
            var implKeywords;
            if (typeof keyword == 'object') {
                var key = Object.keys(keyword)[0];
                implKeywords = keyword[key];
                keyword = key;
                implKeywords.forEach(function(k) {
                    ALL.push(k);
                    RULES.all[k] = true;
                });
            }
            ALL.push(keyword);
            var rule = RULES.all[keyword] = {
                keyword: keyword,
                code: $137a5a588b44bc4d$exports[keyword],
                implements: implKeywords
            };
            return rule;
        });
        RULES.all.$comment = {
            keyword: '$comment',
            code: $137a5a588b44bc4d$exports.$comment
        };
        if (group.type) RULES.types[group.type] = group;
    });
    RULES.keywords = $d571a6d2ed6eddb5$require$toHash(ALL.concat(KEYWORDS));
    RULES.custom = {};
    return RULES;
};


var $7765e9c730434949$exports = {};
'use strict';
var $7765e9c730434949$var$KEYWORDS = [
    'multipleOf',
    'maximum',
    'exclusiveMaximum',
    'minimum',
    'exclusiveMinimum',
    'maxLength',
    'minLength',
    'pattern',
    'additionalItems',
    'maxItems',
    'minItems',
    'uniqueItems',
    'maxProperties',
    'minProperties',
    'required',
    'additionalProperties',
    'enum',
    'format',
    'const'
];
$7765e9c730434949$exports = function(metaSchema, keywordsJsonPointers) {
    for(var i = 0; i < keywordsJsonPointers.length; i++){
        metaSchema = JSON.parse(JSON.stringify(metaSchema));
        var segments = keywordsJsonPointers[i].split('/');
        var keywords = metaSchema;
        var j;
        for(j = 1; j < segments.length; j++)keywords = keywords[segments[j]];
        for(j = 0; j < $7765e9c730434949$var$KEYWORDS.length; j++){
            var key = $7765e9c730434949$var$KEYWORDS[j];
            var schema = keywords[key];
            if (schema) keywords[key] = {
                anyOf: [
                    schema,
                    {
                        $ref: 'https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#'
                    }
                ]
            };
        }
    }
    return metaSchema;
};



var $4tGD1 = parcelRequire("4tGD1");
$10b0ba2520986fb8$exports = $10b0ba2520986fb8$var$Ajv;
$10b0ba2520986fb8$var$Ajv.prototype.validate = $10b0ba2520986fb8$var$validate;
$10b0ba2520986fb8$var$Ajv.prototype.compile = $10b0ba2520986fb8$var$compile;
$10b0ba2520986fb8$var$Ajv.prototype.addSchema = $10b0ba2520986fb8$var$addSchema;
$10b0ba2520986fb8$var$Ajv.prototype.addMetaSchema = $10b0ba2520986fb8$var$addMetaSchema;
$10b0ba2520986fb8$var$Ajv.prototype.validateSchema = $10b0ba2520986fb8$var$validateSchema;
$10b0ba2520986fb8$var$Ajv.prototype.getSchema = $10b0ba2520986fb8$var$getSchema;
$10b0ba2520986fb8$var$Ajv.prototype.removeSchema = $10b0ba2520986fb8$var$removeSchema;
$10b0ba2520986fb8$var$Ajv.prototype.addFormat = $10b0ba2520986fb8$var$addFormat;
$10b0ba2520986fb8$var$Ajv.prototype.errorsText = $10b0ba2520986fb8$var$errorsText;
$10b0ba2520986fb8$var$Ajv.prototype._addSchema = $10b0ba2520986fb8$var$_addSchema;
$10b0ba2520986fb8$var$Ajv.prototype._compile = $10b0ba2520986fb8$var$_compile;

$10b0ba2520986fb8$var$Ajv.prototype.compileAsync = (parcelRequire("3reCO"));
var $d04f201d6e6f66b9$exports = {};
'use strict';
var $d04f201d6e6f66b9$var$IDENTIFIER = /^[a-z_$][a-z0-9_$-]*$/i;
var $dd393b3580925099$exports = {};
'use strict';
$dd393b3580925099$exports = function generate_custom(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $errs = 'errs__' + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    var $rule = this, $definition = 'definition' + $lvl, $rDef = $rule.definition, $closingBraces = '';
    var $compile, $inline, $macro, $ruleValidate, $validateCode;
    if ($isData && $rDef.$data) {
        $validateCode = 'keywordValidate' + $lvl;
        var $validateSchema = $rDef.validateSchema;
        out += ' var ' + $definition + ' = RULES.custom[\'' + $keyword + '\'].definition; var ' + $validateCode + ' = ' + $definition + '.validate;';
    } else {
        $ruleValidate = it.useCustomRule($rule, $schema, it.schema, it);
        if (!$ruleValidate) return;
        $schemaValue = 'validate.schema' + $schemaPath;
        $validateCode = $ruleValidate.code;
        $compile = $rDef.compile;
        $inline = $rDef.inline;
        $macro = $rDef.macro;
    }
    var $ruleErrs = $validateCode + '.errors', $i = 'i' + $lvl, $ruleErr = 'ruleErr' + $lvl, $asyncKeyword = $rDef.async;
    if ($asyncKeyword && !it.async) throw new Error('async keyword in sync schema');
    if (!($inline || $macro)) out += '' + $ruleErrs + ' = null;';
    out += 'var ' + $errs + ' = errors;var ' + $valid + ';';
    if ($isData && $rDef.$data) {
        $closingBraces += '}';
        out += ' if (' + $schemaValue + ' === undefined) { ' + $valid + ' = true; } else { ';
        if ($validateSchema) {
            $closingBraces += '}';
            out += ' ' + $valid + ' = ' + $definition + '.validateSchema(' + $schemaValue + '); if (' + $valid + ') { ';
        }
    }
    if ($inline) {
        if ($rDef.statements) out += ' ' + $ruleValidate.validate + ' ';
        else out += ' ' + $valid + ' = ' + $ruleValidate.validate + '; ';
    } else if ($macro) {
        var $it = it.util.copy(it);
        var $closingBraces = '';
        $it.level++;
        var $nextValid = 'valid' + $it.level;
        $it.schema = $ruleValidate.validate;
        $it.schemaPath = '';
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        var $code = it.validate($it).replace(/validate\.schema/g, $validateCode);
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += ' ' + $code;
    } else {
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = '';
        out += '  ' + $validateCode + '.call( ';
        if (it.opts.passContext) out += 'this';
        else out += 'self';
        if ($compile || $rDef.schema === false) out += ' , ' + $data + ' ';
        else out += ' , ' + $schemaValue + ' , ' + $data + ' , validate.schema' + it.schemaPath + ' ';
        out += ' , (dataPath || \'\')';
        if (it.errorPath != '""') out += ' + ' + it.errorPath;
        var $parentData = $dataLvl ? 'data' + ($dataLvl - 1 || '') : 'parentData', $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
        out += ' , ' + $parentData + ' , ' + $parentDataProperty + ' , rootData )  ';
        var def_callRuleValidate = out;
        out = $$outStack.pop();
        if ($rDef.errors === false) {
            out += ' ' + $valid + ' = ';
            if ($asyncKeyword) out += 'await ';
            out += '' + def_callRuleValidate + '; ';
        } else if ($asyncKeyword) {
            $ruleErrs = 'customErrors' + $lvl;
            out += ' var ' + $ruleErrs + ' = null; try { ' + $valid + ' = await ' + def_callRuleValidate + '; } catch (e) { ' + $valid + ' = false; if (e instanceof ValidationError) ' + $ruleErrs + ' = e.errors; else throw e; } ';
        } else out += ' ' + $ruleErrs + ' = null; ' + $valid + ' = ' + def_callRuleValidate + '; ';
    }
    if ($rDef.modifying) out += ' if (' + $parentData + ') ' + $data + ' = ' + $parentData + '[' + $parentDataProperty + '];';
    out += '' + $closingBraces;
    if ($rDef.valid) {
        if ($breakOnError) out += ' if (true) { ';
    } else {
        out += ' if ( ';
        if ($rDef.valid === undefined) {
            out += ' !';
            if ($macro) out += '' + $nextValid;
            else out += '' + $valid;
        } else out += ' ' + !$rDef.valid + ' ';
        out += ') { ';
        $errorKeyword = $rule.keyword;
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = '';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += ' { keyword: \'' + ($errorKeyword || 'custom') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { keyword: \'' + $rule.keyword + '\' } ';
            if (it.opts.messages !== false) out += ' , message: \'should pass "' + $rule.keyword + '" keyword validation\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        var def_customError = out;
        out = $$outStack.pop();
        if ($inline) {
            if ($rDef.errors) {
                if ($rDef.errors != 'full') {
                    out += '  for (var ' + $i + '=' + $errs + '; ' + $i + '<errors; ' + $i + '++) { var ' + $ruleErr + ' = vErrors[' + $i + ']; if (' + $ruleErr + '.dataPath === undefined) ' + $ruleErr + '.dataPath = (dataPath || \'\') + ' + it.errorPath + '; if (' + $ruleErr + '.schemaPath === undefined) { ' + $ruleErr + '.schemaPath = "' + $errSchemaPath + '"; } ';
                    if (it.opts.verbose) out += ' ' + $ruleErr + '.schema = ' + $schemaValue + '; ' + $ruleErr + '.data = ' + $data + '; ';
                    out += ' } ';
                }
            } else if ($rDef.errors === false) out += ' ' + def_customError + ' ';
            else {
                out += ' if (' + $errs + ' == errors) { ' + def_customError + ' } else {  for (var ' + $i + '=' + $errs + '; ' + $i + '<errors; ' + $i + '++) { var ' + $ruleErr + ' = vErrors[' + $i + ']; if (' + $ruleErr + '.dataPath === undefined) ' + $ruleErr + '.dataPath = (dataPath || \'\') + ' + it.errorPath + '; if (' + $ruleErr + '.schemaPath === undefined) { ' + $ruleErr + '.schemaPath = "' + $errSchemaPath + '"; } ';
                if (it.opts.verbose) out += ' ' + $ruleErr + '.schema = ' + $schemaValue + '; ' + $ruleErr + '.data = ' + $data + '; ';
                out += ' } } ';
            }
        } else if ($macro) {
            out += '   var err =   '; /* istanbul ignore else */ 
            if (it.createErrors !== false) {
                out += ' { keyword: \'' + ($errorKeyword || 'custom') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { keyword: \'' + $rule.keyword + '\' } ';
                if (it.opts.messages !== false) out += ' , message: \'should pass "' + $rule.keyword + '" keyword validation\' ';
                if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                out += ' } ';
            } else out += ' {} ';
            out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError(vErrors); ';
                else out += ' validate.errors = vErrors; return false; ';
            }
        } else if ($rDef.errors === false) out += ' ' + def_customError + ' ';
        else {
            out += ' if (Array.isArray(' + $ruleErrs + ')) { if (vErrors === null) vErrors = ' + $ruleErrs + '; else vErrors = vErrors.concat(' + $ruleErrs + '); errors = vErrors.length;  for (var ' + $i + '=' + $errs + '; ' + $i + '<errors; ' + $i + '++) { var ' + $ruleErr + ' = vErrors[' + $i + ']; if (' + $ruleErr + '.dataPath === undefined) ' + $ruleErr + '.dataPath = (dataPath || \'\') + ' + it.errorPath + ';  ' + $ruleErr + '.schemaPath = "' + $errSchemaPath + '";  ';
            if (it.opts.verbose) out += ' ' + $ruleErr + '.schema = ' + $schemaValue + '; ' + $ruleErr + '.data = ' + $data + '; ';
            out += ' } } else { ' + def_customError + ' } ';
        }
        out += ' } ';
        if ($breakOnError) out += ' else { ';
    }
    return out;
};


var $7ed8771154ba9545$exports = {};
'use strict';

var $jQknV = parcelRequire("jQknV");
$7ed8771154ba9545$exports = {
    $id: 'https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js',
    definitions: {
        simpleTypes: $jQknV.definitions.simpleTypes
    },
    type: 'object',
    dependencies: {
        schema: [
            'validate'
        ],
        $data: [
            'validate'
        ],
        statements: [
            'inline'
        ],
        valid: {
            not: {
                required: [
                    'macro'
                ]
            }
        }
    },
    properties: {
        type: $jQknV.properties.type,
        schema: {
            type: 'boolean'
        },
        statements: {
            type: 'boolean'
        },
        dependencies: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        metaSchema: {
            type: 'object'
        },
        modifying: {
            type: 'boolean'
        },
        valid: {
            type: 'boolean'
        },
        $data: {
            type: 'boolean'
        },
        async: {
            type: 'boolean'
        },
        errors: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    const: 'full'
                }
            ]
        }
    }
};


$d04f201d6e6f66b9$exports = {
    add: $d04f201d6e6f66b9$var$addKeyword,
    get: $d04f201d6e6f66b9$var$getKeyword,
    remove: $d04f201d6e6f66b9$var$removeKeyword,
    validate: $d04f201d6e6f66b9$var$validateKeyword
};
/**
 * Define custom keyword
 * @this  Ajv
 * @param {String} keyword custom keyword, should be unique (including different from all standard, custom and macro keywords).
 * @param {Object} definition keyword definition object with properties `type` (type(s) which the keyword applies to), `validate` or `compile`.
 * @return {Ajv} this for method chaining
 */ function $d04f201d6e6f66b9$var$addKeyword(keyword, definition) {
    /* jshint validthis: true */ /* eslint no-shadow: 0 */ var RULES = this.RULES;
    if (RULES.keywords[keyword]) throw new Error('Keyword ' + keyword + ' is already defined');
    if (!$d04f201d6e6f66b9$var$IDENTIFIER.test(keyword)) throw new Error('Keyword ' + keyword + ' is not a valid identifier');
    if (definition) {
        this.validateKeyword(definition, true);
        var dataType = definition.type;
        if (Array.isArray(dataType)) for(var i = 0; i < dataType.length; i++)_addRule(keyword, dataType[i], definition);
        else _addRule(keyword, dataType, definition);
        var metaSchema = definition.metaSchema;
        if (metaSchema) {
            if (definition.$data && this._opts.$data) metaSchema = {
                anyOf: [
                    metaSchema,
                    {
                        '$ref': 'https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#'
                    }
                ]
            };
            definition.validateSchema = this.compile(metaSchema, true);
        }
    }
    RULES.keywords[keyword] = RULES.all[keyword] = true;
    function _addRule(keyword, dataType, definition) {
        var ruleGroup;
        for(var i = 0; i < RULES.length; i++){
            var rg = RULES[i];
            if (rg.type == dataType) {
                ruleGroup = rg;
                break;
            }
        }
        if (!ruleGroup) {
            ruleGroup = {
                type: dataType,
                rules: []
            };
            RULES.push(ruleGroup);
        }
        var rule = {
            keyword: keyword,
            definition: definition,
            custom: true,
            code: $dd393b3580925099$exports,
            implements: definition.implements
        };
        ruleGroup.rules.push(rule);
        RULES.custom[keyword] = rule;
    }
    return this;
}
/**
 * Get keyword
 * @this  Ajv
 * @param {String} keyword pre-defined or custom keyword.
 * @return {Object|Boolean} custom keyword definition, `true` if it is a predefined keyword, `false` otherwise.
 */ function $d04f201d6e6f66b9$var$getKeyword(keyword) {
    /* jshint validthis: true */ var rule = this.RULES.custom[keyword];
    return rule ? rule.definition : this.RULES.keywords[keyword] || false;
}
/**
 * Remove keyword
 * @this  Ajv
 * @param {String} keyword pre-defined or custom keyword.
 * @return {Ajv} this for method chaining
 */ function $d04f201d6e6f66b9$var$removeKeyword(keyword) {
    /* jshint validthis: true */ var RULES = this.RULES;
    delete RULES.keywords[keyword];
    delete RULES.all[keyword];
    delete RULES.custom[keyword];
    for(var i = 0; i < RULES.length; i++){
        var rules = RULES[i].rules;
        for(var j = 0; j < rules.length; j++)if (rules[j].keyword == keyword) {
            rules.splice(j, 1);
            break;
        }
    }
    return this;
}
/**
 * Validate keyword definition
 * @this  Ajv
 * @param {Object} definition keyword definition object.
 * @param {Boolean} throwError true to throw exception if definition is invalid
 * @return {boolean} validation result
 */ function $d04f201d6e6f66b9$var$validateKeyword(definition, throwError) {
    $d04f201d6e6f66b9$var$validateKeyword.errors = null;
    var v = this._validateKeyword = this._validateKeyword || this.compile($7ed8771154ba9545$exports, true);
    if (v(definition)) return true;
    $d04f201d6e6f66b9$var$validateKeyword.errors = v.errors;
    if (throwError) throw new Error('custom keyword definition is invalid: ' + this.errorsText(v.errors));
    else return false;
}


$10b0ba2520986fb8$var$Ajv.prototype.addKeyword = $d04f201d6e6f66b9$exports.add;
$10b0ba2520986fb8$var$Ajv.prototype.getKeyword = $d04f201d6e6f66b9$exports.get;
$10b0ba2520986fb8$var$Ajv.prototype.removeKeyword = $d04f201d6e6f66b9$exports.remove;
$10b0ba2520986fb8$var$Ajv.prototype.validateKeyword = $d04f201d6e6f66b9$exports.validate;

var $fhgGC = parcelRequire("fhgGC");
$10b0ba2520986fb8$var$Ajv.ValidationError = $fhgGC.Validation;
$10b0ba2520986fb8$var$Ajv.MissingRefError = $fhgGC.MissingRef;
$10b0ba2520986fb8$var$Ajv.$dataMetaSchema = $7765e9c730434949$exports;
var $10b0ba2520986fb8$var$META_SCHEMA_ID = 'http://json-schema.org/draft-07/schema';
var $10b0ba2520986fb8$var$META_IGNORE_OPTIONS = [
    'removeAdditional',
    'useDefaults',
    'coerceTypes',
    'strictDefaults'
];
var $10b0ba2520986fb8$var$META_SUPPORT_DATA = [
    '/properties'
];
/**
 * Creates validator instance.
 * Usage: `Ajv(opts)`
 * @param {Object} opts optional options
 * @return {Object} ajv instance
 */ function $10b0ba2520986fb8$var$Ajv(opts) {
    if (!(this instanceof $10b0ba2520986fb8$var$Ajv)) return new $10b0ba2520986fb8$var$Ajv(opts);
    opts = this._opts = $4tGD1.copy(opts) || {};
    $10b0ba2520986fb8$var$setLogger(this);
    this._schemas = {};
    this._refs = {};
    this._fragments = {};
    this._formats = $7e6655d19abd89bd$exports(opts.format);
    this._cache = opts.cache || new $a62c74eb5c21bfa2$exports;
    this._loadingSchemas = {};
    this._compilations = [];
    this.RULES = $d571a6d2ed6eddb5$exports();
    this._getId = $10b0ba2520986fb8$var$chooseGetId(opts);
    opts.loopRequired = opts.loopRequired || Infinity;
    if (opts.errorDataPath == 'property') opts._errorDataPathProperty = true;
    if (opts.serialize === undefined) opts.serialize = $19c7ef91d507f423$exports;
    this._metaOpts = $10b0ba2520986fb8$var$getMetaSchemaOptions(this);
    if (opts.formats) $10b0ba2520986fb8$var$addInitialFormats(this);
    if (opts.keywords) $10b0ba2520986fb8$var$addInitialKeywords(this);
    $10b0ba2520986fb8$var$addDefaultMetaSchema(this);
    if (typeof opts.meta == 'object') this.addMetaSchema(opts.meta);
    if (opts.nullable) this.addKeyword('nullable', {
        metaSchema: {
            type: 'boolean'
        }
    });
    $10b0ba2520986fb8$var$addInitialSchemas(this);
}
/**
 * Validate data using schema
 * Schema will be compiled and cached (using serialized JSON as key. [fast-json-stable-stringify](https://github.com/epoberezkin/fast-json-stable-stringify) is used to serialize.
 * @this   Ajv
 * @param  {String|Object} schemaKeyRef key, ref or schema object
 * @param  {Any} data to be validated
 * @return {Boolean} validation result. Errors from the last validation will be available in `ajv.errors` (and also in compiled schema: `schema.errors`).
 */ function $10b0ba2520986fb8$var$validate(schemaKeyRef, data) {
    var v;
    if (typeof schemaKeyRef == 'string') {
        v = this.getSchema(schemaKeyRef);
        if (!v) throw new Error('no schema with key or ref "' + schemaKeyRef + '"');
    } else {
        var schemaObj = this._addSchema(schemaKeyRef);
        v = schemaObj.validate || this._compile(schemaObj);
    }
    var valid = v(data);
    if (v.$async !== true) this.errors = v.errors;
    return valid;
}
/**
 * Create validating function for passed schema.
 * @this   Ajv
 * @param  {Object} schema schema object
 * @param  {Boolean} _meta true if schema is a meta-schema. Used internally to compile meta schemas of custom keywords.
 * @return {Function} validating function
 */ function $10b0ba2520986fb8$var$compile(schema, _meta) {
    var schemaObj = this._addSchema(schema, undefined, _meta);
    return schemaObj.validate || this._compile(schemaObj);
}
/**
 * Adds schema to the instance.
 * @this   Ajv
 * @param {Object|Array} schema schema or array of schemas. If array is passed, `key` and other parameters will be ignored.
 * @param {String} key Optional schema key. Can be passed to `validate` method instead of schema object or id/ref. One schema per instance can have empty `id` and `key`.
 * @param {Boolean} _skipValidation true to skip schema validation. Used internally, option validateSchema should be used instead.
 * @param {Boolean} _meta true if schema is a meta-schema. Used internally, addMetaSchema should be used instead.
 * @return {Ajv} this for method chaining
 */ function $10b0ba2520986fb8$var$addSchema(schema, key, _skipValidation, _meta) {
    if (Array.isArray(schema)) {
        for(var i = 0; i < schema.length; i++)this.addSchema(schema[i], undefined, _skipValidation, _meta);
        return this;
    }
    var id = this._getId(schema);
    if (id !== undefined && typeof id != 'string') throw new Error('schema id must be string');
    key = $edhTp.normalizeId(key || id);
    $10b0ba2520986fb8$var$checkUnique(this, key);
    this._schemas[key] = this._addSchema(schema, _skipValidation, _meta, true);
    return this;
}
/**
 * Add schema that will be used to validate other schemas
 * options in META_IGNORE_OPTIONS are alway set to false
 * @this   Ajv
 * @param {Object} schema schema object
 * @param {String} key optional schema key
 * @param {Boolean} skipValidation true to skip schema validation, can be used to override validateSchema option for meta-schema
 * @return {Ajv} this for method chaining
 */ function $10b0ba2520986fb8$var$addMetaSchema(schema, key, skipValidation) {
    this.addSchema(schema, key, skipValidation, true);
    return this;
}
/**
 * Validate schema
 * @this   Ajv
 * @param {Object} schema schema to validate
 * @param {Boolean} throwOrLogError pass true to throw (or log) an error if invalid
 * @return {Boolean} true if schema is valid
 */ function $10b0ba2520986fb8$var$validateSchema(schema, throwOrLogError) {
    var $schema = schema.$schema;
    if ($schema !== undefined && typeof $schema != 'string') throw new Error('$schema must be a string');
    $schema = $schema || this._opts.defaultMeta || $10b0ba2520986fb8$var$defaultMeta(this);
    if (!$schema) {
        this.logger.warn('meta-schema not available');
        this.errors = null;
        return true;
    }
    var valid = this.validate($schema, schema);
    if (!valid && throwOrLogError) {
        var message = 'schema is invalid: ' + this.errorsText();
        if (this._opts.validateSchema == 'log') this.logger.error(message);
        else throw new Error(message);
    }
    return valid;
}
function $10b0ba2520986fb8$var$defaultMeta(self) {
    var meta = self._opts.meta;
    self._opts.defaultMeta = typeof meta == 'object' ? self._getId(meta) || meta : self.getSchema($10b0ba2520986fb8$var$META_SCHEMA_ID) ? $10b0ba2520986fb8$var$META_SCHEMA_ID : undefined;
    return self._opts.defaultMeta;
}
/**
 * Get compiled schema from the instance by `key` or `ref`.
 * @this   Ajv
 * @param  {String} keyRef `key` that was passed to `addSchema` or full schema reference (`schema.id` or resolved id).
 * @return {Function} schema validating function (with property `schema`).
 */ function $10b0ba2520986fb8$var$getSchema(keyRef) {
    var schemaObj = $10b0ba2520986fb8$var$_getSchemaObj(this, keyRef);
    switch(typeof schemaObj){
        case 'object':
            return schemaObj.validate || this._compile(schemaObj);
        case 'string':
            return this.getSchema(schemaObj);
        case 'undefined':
            return $10b0ba2520986fb8$var$_getSchemaFragment(this, keyRef);
    }
}
function $10b0ba2520986fb8$var$_getSchemaFragment(self, ref) {
    var res = $edhTp.schema.call(self, {
        schema: {}
    }, ref);
    if (res) {
        var schema = res.schema, root = res.root, baseId = res.baseId;
        var v = $5199d6ec1105cd7c$exports.call(self, schema, root, undefined, baseId);
        self._fragments[ref] = new $8D9VW({
            ref: ref,
            fragment: true,
            schema: schema,
            root: root,
            baseId: baseId,
            validate: v
        });
        return v;
    }
}
function $10b0ba2520986fb8$var$_getSchemaObj(self, keyRef) {
    keyRef = $edhTp.normalizeId(keyRef);
    return self._schemas[keyRef] || self._refs[keyRef] || self._fragments[keyRef];
}
/**
 * Remove cached schema(s).
 * If no parameter is passed all schemas but meta-schemas are removed.
 * If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
 * Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
 * @this   Ajv
 * @param  {String|Object|RegExp} schemaKeyRef key, ref, pattern to match key/ref or schema object
 * @return {Ajv} this for method chaining
 */ function $10b0ba2520986fb8$var$removeSchema(schemaKeyRef) {
    if (schemaKeyRef instanceof RegExp) {
        $10b0ba2520986fb8$var$_removeAllSchemas(this, this._schemas, schemaKeyRef);
        $10b0ba2520986fb8$var$_removeAllSchemas(this, this._refs, schemaKeyRef);
        return this;
    }
    switch(typeof schemaKeyRef){
        case 'undefined':
            $10b0ba2520986fb8$var$_removeAllSchemas(this, this._schemas);
            $10b0ba2520986fb8$var$_removeAllSchemas(this, this._refs);
            this._cache.clear();
            return this;
        case 'string':
            var schemaObj = $10b0ba2520986fb8$var$_getSchemaObj(this, schemaKeyRef);
            if (schemaObj) this._cache.del(schemaObj.cacheKey);
            delete this._schemas[schemaKeyRef];
            delete this._refs[schemaKeyRef];
            return this;
        case 'object':
            var serialize = this._opts.serialize;
            var cacheKey = serialize ? serialize(schemaKeyRef) : schemaKeyRef;
            this._cache.del(cacheKey);
            var id = this._getId(schemaKeyRef);
            if (id) {
                id = $edhTp.normalizeId(id);
                delete this._schemas[id];
                delete this._refs[id];
            }
    }
    return this;
}
function $10b0ba2520986fb8$var$_removeAllSchemas(self, schemas, regex) {
    for(var keyRef in schemas){
        var schemaObj = schemas[keyRef];
        if (!schemaObj.meta && (!regex || regex.test(keyRef))) {
            self._cache.del(schemaObj.cacheKey);
            delete schemas[keyRef];
        }
    }
}
/* @this   Ajv */ function $10b0ba2520986fb8$var$_addSchema(schema, skipValidation, meta, shouldAddSchema) {
    if (typeof schema != 'object' && typeof schema != 'boolean') throw new Error('schema should be object or boolean');
    var serialize = this._opts.serialize;
    var cacheKey = serialize ? serialize(schema) : schema;
    var cached = this._cache.get(cacheKey);
    if (cached) return cached;
    shouldAddSchema = shouldAddSchema || this._opts.addUsedSchema !== false;
    var id = $edhTp.normalizeId(this._getId(schema));
    if (id && shouldAddSchema) $10b0ba2520986fb8$var$checkUnique(this, id);
    var willValidate = this._opts.validateSchema !== false && !skipValidation;
    var recursiveMeta;
    if (willValidate && !(recursiveMeta = id && id == $edhTp.normalizeId(schema.$schema))) this.validateSchema(schema, true);
    var localRefs = $edhTp.ids.call(this, schema);
    var schemaObj = new $8D9VW({
        id: id,
        schema: schema,
        localRefs: localRefs,
        cacheKey: cacheKey,
        meta: meta
    });
    if (id[0] != '#' && shouldAddSchema) this._refs[id] = schemaObj;
    this._cache.put(cacheKey, schemaObj);
    if (willValidate && recursiveMeta) this.validateSchema(schema, true);
    return schemaObj;
}
/* @this   Ajv */ function $10b0ba2520986fb8$var$_compile(schemaObj, root) {
    if (schemaObj.compiling) {
        schemaObj.validate = callValidate;
        callValidate.schema = schemaObj.schema;
        callValidate.errors = null;
        callValidate.root = root ? root : callValidate;
        if (schemaObj.schema.$async === true) callValidate.$async = true;
        return callValidate;
    }
    schemaObj.compiling = true;
    var currentOpts;
    if (schemaObj.meta) {
        currentOpts = this._opts;
        this._opts = this._metaOpts;
    }
    var v;
    try {
        v = $5199d6ec1105cd7c$exports.call(this, schemaObj.schema, root, schemaObj.localRefs);
    } catch (e) {
        delete schemaObj.validate;
        throw e;
    } finally{
        schemaObj.compiling = false;
        if (schemaObj.meta) this._opts = currentOpts;
    }
    schemaObj.validate = v;
    schemaObj.refs = v.refs;
    schemaObj.refVal = v.refVal;
    schemaObj.root = v.root;
    return v;
    /* @this   {*} - custom context, see passContext option */ function callValidate() {
        /* jshint validthis: true */ var _validate = schemaObj.validate;
        var result = _validate.apply(this, arguments);
        callValidate.errors = _validate.errors;
        return result;
    }
}
function $10b0ba2520986fb8$var$chooseGetId(opts) {
    switch(opts.schemaId){
        case 'auto':
            return $10b0ba2520986fb8$var$_get$IdOrId;
        case 'id':
            return $10b0ba2520986fb8$var$_getId;
        default:
            return $10b0ba2520986fb8$var$_get$Id;
    }
}
/* @this   Ajv */ function $10b0ba2520986fb8$var$_getId(schema) {
    if (schema.$id) this.logger.warn('schema $id ignored', schema.$id);
    return schema.id;
}
/* @this   Ajv */ function $10b0ba2520986fb8$var$_get$Id(schema) {
    if (schema.id) this.logger.warn('schema id ignored', schema.id);
    return schema.$id;
}
function $10b0ba2520986fb8$var$_get$IdOrId(schema) {
    if (schema.$id && schema.id && schema.$id != schema.id) throw new Error('schema $id is different from id');
    return schema.$id || schema.id;
}
/**
 * Convert array of error message objects to string
 * @this   Ajv
 * @param  {Array<Object>} errors optional array of validation errors, if not passed errors from the instance are used.
 * @param  {Object} options optional options with properties `separator` and `dataVar`.
 * @return {String} human readable string with all errors descriptions
 */ function $10b0ba2520986fb8$var$errorsText(errors, options) {
    errors = errors || this.errors;
    if (!errors) return 'No errors';
    options = options || {};
    var separator = options.separator === undefined ? ', ' : options.separator;
    var dataVar = options.dataVar === undefined ? 'data' : options.dataVar;
    var text = '';
    for(var i = 0; i < errors.length; i++){
        var e = errors[i];
        if (e) text += dataVar + e.dataPath + ' ' + e.message + separator;
    }
    return text.slice(0, -separator.length);
}
/**
 * Add custom format
 * @this   Ajv
 * @param {String} name format name
 * @param {String|RegExp|Function} format string is converted to RegExp; function should return boolean (true when valid)
 * @return {Ajv} this for method chaining
 */ function $10b0ba2520986fb8$var$addFormat(name, format) {
    if (typeof format == 'string') format = new RegExp(format);
    this._formats[name] = format;
    return this;
}


function $10b0ba2520986fb8$var$addDefaultMetaSchema(self) {
    var $dataSchema;
    if (self._opts.$data) {
        $dataSchema = (parcelRequire("2d1Zg"));
        self.addMetaSchema($dataSchema, $dataSchema.$id, true);
    }
    if (self._opts.meta === false) return;
    var metaSchema = (parcelRequire("jQknV"));
    if (self._opts.$data) metaSchema = $7765e9c730434949$exports(metaSchema, $10b0ba2520986fb8$var$META_SUPPORT_DATA);
    self.addMetaSchema(metaSchema, $10b0ba2520986fb8$var$META_SCHEMA_ID, true);
    self._refs['http://json-schema.org/schema'] = $10b0ba2520986fb8$var$META_SCHEMA_ID;
}
function $10b0ba2520986fb8$var$addInitialSchemas(self) {
    var optsSchemas = self._opts.schemas;
    if (!optsSchemas) return;
    if (Array.isArray(optsSchemas)) self.addSchema(optsSchemas);
    else for(var key in optsSchemas)self.addSchema(optsSchemas[key], key);
}
function $10b0ba2520986fb8$var$addInitialFormats(self) {
    for(var name in self._opts.formats){
        var format = self._opts.formats[name];
        self.addFormat(name, format);
    }
}
function $10b0ba2520986fb8$var$addInitialKeywords(self) {
    for(var name in self._opts.keywords){
        var keyword = self._opts.keywords[name];
        self.addKeyword(name, keyword);
    }
}
function $10b0ba2520986fb8$var$checkUnique(self, id) {
    if (self._schemas[id] || self._refs[id]) throw new Error('schema with key or id "' + id + '" already exists');
}
function $10b0ba2520986fb8$var$getMetaSchemaOptions(self) {
    var metaOpts = $4tGD1.copy(self._opts);
    for(var i = 0; i < $10b0ba2520986fb8$var$META_IGNORE_OPTIONS.length; i++)delete metaOpts[$10b0ba2520986fb8$var$META_IGNORE_OPTIONS[i]];
    return metaOpts;
}
function $10b0ba2520986fb8$var$setLogger(self) {
    var logger = self._opts.logger;
    if (logger === false) self.logger = {
        log: $10b0ba2520986fb8$var$noop,
        warn: $10b0ba2520986fb8$var$noop,
        error: $10b0ba2520986fb8$var$noop
    };
    else {
        if (logger === undefined) logger = console;
        if (!(typeof logger == 'object' && logger.log && logger.warn && logger.error)) throw new Error('logger must implement log, warn and error methods');
        self.logger = logger;
    }
}
function $10b0ba2520986fb8$var$noop() {}



const $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002 = (schema, name)=>{
    const createInternalValidator = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>{
        /** Unique reference to name of the schema */ const name = Math.random().toString();
        return [
            name,
            new (0, (/*@__PURE__*/$parcel$interopDefault($10b0ba2520986fb8$exports)))({
                useDefaults: true,
                allErrors: true
            }).addSchema(schema, name)
        ];
    });
    return (0, $beec4324cbd609ea$export$6b4e15ccdc547ae7)((obj)=>{
        const [name, ajv] = createInternalValidator();
        return ajv.validate(name, obj) === true;
    }, name);
};




const $686f0e5918a12fb6$var$deserializers = {
    integer: (value)=>{
        const number = Number(value);
        return Number.isInteger(number) ? {
            value: number,
            valid: true
        } : {
            valid: false
        };
    },
    null: (value)=>value === '' ? {
            value: null,
            valid: true
        } : {
            valid: false
        },
    boolean: (value)=>value === 'true' || value === 'false' ? {
            value: value === 'true',
            valid: true
        } : {
            valid: false
        },
    number: (value)=>{
        const number = Number(value);
        return !isNaN(number) ? {
            value: number,
            valid: true
        } : {
            valid: false
        };
    },
    string: (value)=>({
            value: value,
            valid: true
        }),
    array: (value)=>{
        try {
            return {
                value: JSON.parse(value),
                valid: true
            };
        } catch (e) {
            return {
                valid: false
            };
        }
    }
};
class $686f0e5918a12fb6$export$4f829dfa1482aa1f {
    static isValid(config) {
        return typeof config === 'object' && config !== null && (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(config).every((entries)=>entries.every((v)=>typeof v === 'string'));
    }
    static resolveCustomization({ path: path, schema: schema }, env, override) {
        const isValid = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)(schema, 'isValid');
        for (const possibleType of schema.type){
            /** With the given type, attempt to convert it from a string to the target type */ const deserialize = possibleType in $686f0e5918a12fb6$var$deserializers && $686f0e5918a12fb6$var$deserializers[possibleType];
            if (!deserialize) /**
                 * Deserialization errors are not expected,
                 * this means there is a missing deserializer in the codebase. Stop trying
                 */ return new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Can not de-serialize to the expected type', {
                type: possibleType
            });
            const result = deserialize(override);
            if (!result.valid || !isValid(result.value)) continue;
            return result.value;
        }
        return new (0, $592bbc806a799909$export$aa6a1792a9d987d)(path, env, override);
    }
    constructor(/** Base configuration */ config, /** What can be customized */ customizationInstructions){
        this.config = config;
        this.customizationInstructions = customizationInstructions;
        this.unexpectedErrors = [];
    }
    get errors() {
        return this.unexpectedErrors;
    }
    get customizedConfig() {
        return this.config;
    }
    replaceConfiguration(customization, env, override) {
        this.config = new (0, $50ef090cac933bbc$export$979fbf2cce3f8587)((oldConfig, parents)=>{
            if (!(0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(parents, customization.path)) /** Not relevant to the current configurable entry */ return oldConfig;
            const result = $686f0e5918a12fb6$export$4f829dfa1482aa1f.resolveCustomization(customization, env, override);
            if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(result)) {
                this.addError(result);
                return oldConfig;
            }
            return result;
        }).traverse(this.config);
    }
    addError(error) {
        this.unexpectedErrors.push(error);
        return this;
    }
    addCustomConfig(customization) {
        if (!$686f0e5918a12fb6$export$4f829dfa1482aa1f.isValid(customization)) return this.addError(new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Custom config is invalid', {
            config: customization
        }));
        for (const [env, value] of (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(customization)){
            const configurable = this.customizationInstructions[env];
            if (!configurable) {
                this.addError(new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Unexpected customization entry', {
                    env: env
                }));
                continue;
            }
            this.replaceConfiguration(configurable, env, value);
        }
        return this;
    }
}


const $f30b7b49cc16b3fd$var$customizer = new (0, $686f0e5918a12fb6$export$4f829dfa1482aa1f)((0, $298e6f3f5d24d393$export$e506a1d27d1eaa20), (0, (/*@__PURE__*/$parcel$interopDefault($cab2c0e2a736d626$exports))));
const $f30b7b49cc16b3fd$var$configPromise = fetch((0, (/*@__PURE__*/$parcel$interopDefault($a23a8864dbec8e80$exports)))).then((response)=>response.json()).then((customConfig)=>$f30b7b49cc16b3fd$var$customizer.addCustomConfig(customConfig)).catch((error)=>$f30b7b49cc16b3fd$var$customizer.addError(new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Could not load or parse custom config file', {
        file: (0, (/*@__PURE__*/$parcel$interopDefault($a23a8864dbec8e80$exports))),
        error: error.message
    })));
var $f30b7b49cc16b3fd$export$2e2bcd8739ae039 = $f30b7b49cc16b3fd$var$configPromise;




/** This file was generated by src/infrastructure/scripts/executables/backend-schema-types.ts */ const $32b2d45ce2f365c3$export$80260f1566bbea51 = [
    '/api/auth/ldap',
    '/api/auth/mfa',
    '/api/auth/msEntraId',
    '/api/authenticate',
    '/api/authorize',
    '/api/broker/auth/check-updates',
    '/api/broker/auth/enhanced',
    '/api/broker/auth/publish',
    '/api/broker/auth/register',
    '/api/broker/auth/subscribe',
    '/api/broker/auth/subscribeMQTT5',
    '/api/certificates',
    '/api/certificates/content',
    '/api/client-registry',
    '/api/client-registry/confirm',
    '/api/client-registry/lock',
    '/api/client-registry/open',
    '/api/client-registry/register',
    '/api/client-registry/runners/+',
    '/api/client-registry/status',
    '/api/healthz',
    '/api/listUsers',
    '/api/login',
    '/api/logout',
    '/api/maintenance/db',
    '/api/maintenance/db/backup',
    '/api/maintenance/db/restore',
    '/api/mfa/disable',
    '/api/mfa/enable',
    '/api/mfa/isenrolled',
    '/api/mfa/login',
    '/api/mfa/regenerate/backupcodes',
    '/api/mfa/validate',
    '/api/msEntraId/login',
    '/api/msEntraId/redirect',
    '/api/permissions',
    '/api/permissions/ids',
    '/api/permissions/page',
    '/api/policy/password',
    '/api/policy/username',
    '/api/roles',
    '/api/roles/+',
    '/api/roles/+/permissions',
    '/api/roles/+/permissions/+',
    '/api/roles/names',
    '/api/roles/page',
    '/api/session',
    '/api/users',
    '/api/users/+',
    '/api/users/+/certificates',
    '/api/users/+/roles',
    '/api/users/+/tokens',
    '/api/users/batch',
    '/api/users/batch/delete',
    '/api/users/change-password',
    '/api/users/ids',
    '/api/users/usernames',
    '/api/v1/certs/list/approved'
];


/** This file was generated by src/infrastructure/scripts/executables/backend-schema-types.ts */ const $2ed4558337805bfa$export$80260f1566bbea51 = [
    '/api/containers',
    '/api/containers/+/inspect',
    '/api/containers/+/logs',
    '/api/containers/+/operation',
    '/api/containers/+/state',
    '/api/containers/orchestrator',
    '/api/core-containers',
    '/api/core-containers/+/inspect',
    '/api/core-containers/+/logs',
    '/api/core-containers/+/operation',
    '/api/core-containers/+/state',
    '/api/core-containers/orchestrator',
    '/api/healthz',
    '/api/images',
    '/api/images/+/inspect',
    '/api/networks',
    '/api/networks/+/inspect',
    '/api/volumes',
    '/api/volumes/+/inspect'
];


/** This file was generated by src/infrastructure/scripts/executables/backend-schema-types.ts */ const $a1b06cc4ad4ace18$export$80260f1566bbea51 = [
    '/api/v2/resource-runners',
    '/api/v2/resources/rst/httpschemas',
    '/api/v2/resources/states',
    '/api/v2/resources/states/deviations',
    '/api/v2/resources/states/deviations/count',
    '/api/v2/resources/states/deviations/services'
];


/** This file was generated by src/infrastructure/scripts/executables/backend-schema-types.ts */ const $1c65910951f6f8aa$export$80260f1566bbea51 = [
    '/api/healthz',
    '/api/resources/runners/+',
    '/api/resources/schemas',
    '/api/services',
    '/api/services/+',
    '/api/services/+/deletion-status',
    '/api/services/+/dependencies',
    '/api/services/+/operation',
    '/api/services/+/status',
    '/api/services/all-links',
    '/api/services/info',
    '/api/services/ingress-routes',
    '/api/services/instances',
    '/api/services/links',
    '/api/services/parametersSchema',
    '/api/services/status',
    '/api/v2/resources',
    '/api/v2/resources/+',
    '/api/v2/resources/+/operation',
    '/api/v2/resources/count/+',
    '/api/v2/service-graph/adjacency-matrix',
    '/api/v2/service-graph/dependencies',
    '/api/v2/service-graph/dependencies/count',
    '/api/v2/service-graph/dependents',
    '/api/v2/service-graph/dependents/count',
    '/api/v2/service-graph/root-nodes',
    '/api/v2/services',
    '/api/v2/services/+',
    '/api/v2/services/+/resources',
    '/api/v2/services/+/serviceCommissioningFile',
    '/api/v2/services/+/topics',
    '/api/v2/services/ids',
    '/api/v2/services/stats/count',
    '/api/v2/topics/resources',
    '/api/validate/service'
];


/** This file was generated by src/infrastructure/scripts/executables/backend-schema-types.ts */ const $6649433eec9e195c$export$80260f1566bbea51 = [
    '/api/healthz',
    '/api/system/agents',
    '/api/system/health',
    '/api/system/info',
    '/api/system/licensefile',
    '/api/system/metrics',
    '/api/system/preflight',
    '/api/system/refresh',
    '/api/system/vrpcHealth'
];


/** This file was generated by src/infrastructure/scripts/executables/backend-schema-types.ts */ const $69a8a268a8c82883$export$80260f1566bbea51 = [
    '/api/v2/mqtt/topics/levels',
    '/api/v2/mqtt/topics/search'
];


const $42451c28db270589$export$a343d875f0ac2ee6 = {
    'auth-server': $32b2d45ce2f365c3$export$80260f1566bbea51,
    'container-manager': $2ed4558337805bfa$export$80260f1566bbea51,
    'resource-status-tracking': $a1b06cc4ad4ace18$export$80260f1566bbea51,
    'service-manager': $1c65910951f6f8aa$export$80260f1566bbea51,
    'system-control-server': $6649433eec9e195c$export$80260f1566bbea51,
    'topic-explorer': $69a8a268a8c82883$export$80260f1566bbea51
};



const $f8e1ae5c3f1d25ae$var$valuesMap = {
    active: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ACTIVE,
    available: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).AVAILABLE,
    connected: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).CONNECTED,
    connecting: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).CONNECTING,
    created: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).CREATED,
    dead: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DEAD,
    deviated: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DEVIATED,
    disabled: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISABLED,
    disabling: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISABLING,
    disconnected: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISCONNECTED,
    disconnecting: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISCONNECTING,
    enabled: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLED,
    enabling: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ENABLING,
    exited: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).EXITED,
    inactive: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).INACTIVE,
    invalid: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).INVALID,
    no_deviation: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).NO_DEVIATION,
    not_enabled: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).NOT_ENABLED,
    offline: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).OFFLINE,
    online: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ONLINE,
    paused: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).PAUSED,
    reachable: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).REACHABLE,
    reconnecting: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).RECONNECTING,
    reenabling: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).REENABLING,
    restarting: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).RESTARTING,
    rollingBack: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ROLLING_BACK,
    running: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).RUNNING,
    starting: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).STARTING,
    stopping: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).STOPPING,
    terminated: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).TERMINATED,
    unavailable: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).UNAVAILABLE,
    /** k8s only @see https://bitbucket.org/cybusio/cybus/src/12c5735defa9b9c83b66feae2e720a51024e92ad/container-manager/src/Kubernetes.js#lines-453 */ unknown: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).UNKNOWN,
    unreachable: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).UNREACHABLE,
    updating: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).UPDATING,
    valid: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).VALID,
    waiting: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).WAITING
};
const $f8e1ae5c3f1d25ae$export$eb25faf9da40860f = (value)=>$f8e1ae5c3f1d25ae$var$valuesMap[String(value)] ?? (0, $1041b3cad55163d4$export$e35c1996c6f482ad).UNEXPECTED;



const $f5c5bae2ca26f1d7$var$contextsBackendMap = {
    control_plane: (0, $10784336063bfb60$export$25544a24f1dbb74).CONTROL_PLANE,
    http: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
    mqtt: (0, $10784336063bfb60$export$25544a24f1dbb74).MQTT
};
const $f5c5bae2ca26f1d7$var$contextsFrontendMap = {
    [(0, $10784336063bfb60$export$25544a24f1dbb74).CONTROL_PLANE]: 'control_plane',
    [(0, $10784336063bfb60$export$25544a24f1dbb74).HTTP]: 'http',
    [(0, $10784336063bfb60$export$25544a24f1dbb74).MQTT]: 'mqtt'
};
const $f5c5bae2ca26f1d7$export$1cd392a9150fe66f = (context)=>$f5c5bae2ca26f1d7$var$contextsBackendMap[context];
const $f5c5bae2ca26f1d7$export$b9feafe2e5ed80eb = (context)=>$f5c5bae2ca26f1d7$var$contextsFrontendMap[context];




const $524c99de33c5950a$var$operationsMap = {
    read: {
        read: true,
        write: false
    },
    write: {
        read: false,
        write: true
    },
    readWrite: {
        read: true,
        write: true
    }
};
const $524c99de33c5950a$export$ba4f1fbd74946892 = (operation)=>$524c99de33c5950a$var$operationsMap[operation];
const $524c99de33c5950a$export$446ab98052b611bd = ({ read: read, write: write })=>{
    (0, $14eddac5f20c576c$export$a7a9523472993e97)(read || write, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).MAPPING_ERROR, 'Can not map operations as it is invalid'));
    return read && write ? 'readWrite' : read ? 'read' : 'write';
};






const $abbed5ec1ae0f4ff$var$httpCapabilities = {
    [(0, $78670ebe9381a713$export$790a66df9dc00390).AGENTS_MANAGE]: [
        {
            resource: '/api/resources/runners/+',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).AGENTS_READ]: [
        {
            resource: '/api/v2/resource-runners',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTION_READ]: [
        {
            resource: '/api/v2/resources/+',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_MANAGE]: [
        {
            resource: '/api/v2/resources/+/operation',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_READ]: [
        {
            resource: '/api/v2/resources',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states/deviations/count',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/services/+/resources',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINER_READ]: [
        {
            resource: '/api/core-containers/+/inspect',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINERS_MANAGE]: [
        {
            resource: '/api/core-containers/+/operation',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINERS_READ]: [
        {
            resource: '/api/core-containers',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/core-containers/+/inspect',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/core-containers/orchestrator',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINER_READ]: [
        {
            resource: '/api/containers/+/inspect',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_MANAGE]: [
        {
            resource: '/api/containers/+/operation',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_READ]: [
        {
            resource: '/api/containers',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/containers/+/inspect',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/containers/orchestrator',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINT_READ]: [
        {
            resource: '/api/v2/resources/+',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_MANAGE]: [
        {
            resource: '/api/v2/resources/+/operation',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_READ]: [
        {
            resource: '/api/v2/resources',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states/deviations/count',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/services/+/resources',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MAPPING_READ]: [
        {
            resource: '/api/v2/resources/+',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_MANAGE]: [
        {
            resource: '/api/v2/resources/+/operation',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_READ]: [
        {
            resource: '/api/v2/resources',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states/deviations/count',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/services/+/resources',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).NODES_READ]: [
        {
            resource: '/api/v2/resources',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states/deviations/count',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/services/+/resources',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVER_READ]: [
        {
            resource: '/api/v2/resources/+',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_MANAGE]: [
        {
            resource: '/api/v2/resources/+/operation',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_READ]: [
        {
            resource: '/api/v2/resources',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states/deviations/count',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/services/+/resources',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ]: [
        {
            resource: '/api/services/+/dependencies',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/services/all-links',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states/deviations/count',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/services/+',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_COMMISSIONING_FILE_READ]: [
        {
            resource: '/api/v2/services/+/serviceCommissioningFile',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_MANAGE]: [
        {
            resource: '/api/services/+',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        },
        {
            resource: '/api/services/+/operation',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_PARAMETERS_READ]: [
        {
            resource: '/api/services/parametersSchema',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_CREATE_OR_UPDATE]: [
        {
            resource: '/api/services',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        },
        {
            resource: '/api/v2/services/+',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_READ]: [
        {
            resource: '/api/services/all-links',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states/deviations/count',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/services',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/services/stats/count',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).DEVIATIONS_READ]: [
        {
            resource: '/api/v2/resources/states/deviations',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states/deviations/count',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/states/deviations/services',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/services/+',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_SUBSCRIPTION_METADATA]: [
        {
            resource: '/api/v2/services/+/resources',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).VOLUME_READ]: [
        {
            resource: '/api/volumes/+/inspect',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).VOLUMES_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).VOLUMES_READ]: [
        {
            resource: '/api/volumes',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).RETRIEVE_PASSWORD_POLICY]: [
        {
            resource: '/api/policy/password',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).RETRIEVE_USERNAME_POLICY]: [
        {
            resource: '/api/policy/username',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_USERS]: [
        {
            resource: '/api/listUsers',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/users/+',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        },
        {
            resource: '/api/users/batch',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        },
        {
            resource: '/api/users/batch/delete',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        },
        {
            resource: '/api/users/usernames',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_ROLES]: [
        {
            resource: '/api/roles',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        },
        {
            resource: '/api/roles/+',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        },
        {
            resource: '/api/roles/names',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/roles/page',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).USER_MANAGEMENT_CONFIGURATION]: [
        {
            resource: '/api/auth/ldap',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/auth/mfa',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_PERMISSIONS]: [
        {
            resource: '/api/permissions/ids',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/permissions/page',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CLIENT_REGISTRY_MANAGE]: [
        {
            resource: '/api/client-registry',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/client-registry/confirm',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        },
        {
            resource: '/api/client-registry/lock',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        },
        {
            resource: '/api/client-registry/open',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        },
        {
            resource: '/api/client-registry/status',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CERTIFICATES_MANAGE]: [
        {
            resource: '/api/certificates',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: true
        },
        {
            resource: '/api/certificates/content',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).TOPICS_SUBSCRIPTION]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).TOPIC_CHUNKS_READ]: [
        {
            resource: '/api/v2/mqtt/topics/levels',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).RULE_ENGINE_RESOURCES]: [
        {
            resource: '/api/v2/resources',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).WORKBENCH]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ]: [
        {
            resource: '/api/core-containers',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/core-containers/+/logs',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/core-containers/orchestrator',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/v2/resources/+',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_LICENSE_MANAGE]: [
        {
            resource: '/api/system/licensefile',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        },
        {
            resource: '/api/system/refresh',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_OWN_PASSWORD]: [
        {
            resource: '/api/users/change-password',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MINIMUM]: [
        {
            resource: '/api/system/info',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/system/preflight',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_METRICS_MANAGE]: [
        {
            resource: '/api/system/metrics',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_METRICS_READ]: [
        {
            resource: '/api/system/metrics',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/system/preflight',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).USE_MFA]: [
        {
            resource: '/api/mfa/disable',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        },
        {
            resource: '/api/mfa/enable',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        },
        {
            resource: '/api/mfa/isenrolled',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: false
        },
        {
            resource: '/api/mfa/regenerate/backupcodes',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        },
        {
            resource: '/api/mfa/validate',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: false,
            write: true
        }
    ]
};
const $abbed5ec1ae0f4ff$var$mqttCapabilities = {
    [(0, $78670ebe9381a713$export$790a66df9dc00390).AGENTS_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).AGENTS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTION_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINER_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINERS_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINERS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINER_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINT_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MAPPING_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).NODES_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVER_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_COMMISSIONING_FILE_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_PARAMETERS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_CREATE_OR_UPDATE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).DEVIATIONS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_SUBSCRIPTION_METADATA]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).VOLUME_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).VOLUMES_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).VOLUMES_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).RETRIEVE_PASSWORD_POLICY]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).RETRIEVE_USERNAME_POLICY]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_USERS]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_ROLES]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_PERMISSIONS]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CLIENT_REGISTRY_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CERTIFICATES_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).USER_MANAGEMENT_CONFIGURATION]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).TOPICS_SUBSCRIPTION]: [
        {
            resource: null,
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).MQTT,
            read: true,
            write: false
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).TOPIC_CHUNKS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).RULE_ENGINE_RESOURCES]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).WORKBENCH]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_LICENSE_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MINIMUM]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_METRICS_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_METRICS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).USE_MFA]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_OWN_PASSWORD]: []
};
const $abbed5ec1ae0f4ff$var$externalhttp = {
    [(0, $78670ebe9381a713$export$790a66df9dc00390).AGENTS_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).AGENTS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTION_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINER_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINERS_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINERS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINER_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINT_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MAPPING_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).NODES_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVER_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_COMMISSIONING_FILE_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_PARAMETERS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_CREATE_OR_UPDATE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).DEVIATIONS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_SUBSCRIPTION_METADATA]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).VOLUME_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).VOLUMES_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).VOLUMES_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).RETRIEVE_PASSWORD_POLICY]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).RETRIEVE_USERNAME_POLICY]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_USERS]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_ROLES]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_PERMISSIONS]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CLIENT_REGISTRY_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).CERTIFICATES_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).USER_MANAGEMENT_CONFIGURATION]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).TOPICS_SUBSCRIPTION]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).TOPIC_CHUNKS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).RULE_ENGINE_RESOURCES]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).WORKBENCH]: [
        {
            resource: '/workbench',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: true
        },
        {
            resource: '/workbench/#',
            context: (0, $10784336063bfb60$export$25544a24f1dbb74).HTTP,
            read: true,
            write: true
        }
    ],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_LICENSE_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MINIMUM]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_METRICS_MANAGE]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_METRICS_READ]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).USE_MFA]: [],
    [(0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_OWN_PASSWORD]: []
};
const $abbed5ec1ae0f4ff$export$8e76ac9f37578d1b = Object.values((0, $78670ebe9381a713$export$790a66df9dc00390)).reduce((r, capability)=>({
        ...r,
        /** Only keep alternatives that actually have permission requirements */ [capability]: [
            $abbed5ec1ae0f4ff$var$httpCapabilities,
            $abbed5ec1ae0f4ff$var$externalhttp,
            $abbed5ec1ae0f4ff$var$mqttCapabilities
        ].flatMap(({ [capability]: alternative })=>(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(alternative) ? [
                alternative
            ] : [])
    }), {});
const $abbed5ec1ae0f4ff$export$fe006fd1a05ee554 = new (0, $f0cbf013be9038ef$export$c3f30dbb97e8bc91)([
    [
        'Kubernetes',
        [
            /** No capability to interact with volumes */ (0, $78670ebe9381a713$export$790a66df9dc00390).VOLUMES_MANAGE,
            (0, $78670ebe9381a713$export$790a66df9dc00390).VOLUMES_READ,
            (0, $78670ebe9381a713$export$790a66df9dc00390).VOLUME_READ,
            /** No capability to interact with service containers */ (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_MANAGE,
            (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_READ,
            (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINER_READ,
            /** No capability to manage core containers */ (0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINERS_MANAGE
        ]
    ],
    [
        'Docker',
        []
    ]
]);
const $abbed5ec1ae0f4ff$export$cce005330a510b30 = new (0, $f0cbf013be9038ef$export$c3f30dbb97e8bc91)([
    [
        false,
        [
            (0, $78670ebe9381a713$export$790a66df9dc00390).USE_MFA
        ]
    ],
    [
        true,
        []
    ]
]);





const $1ce286d293747584$export$9c5ea5a6c0d1312b = (resource)=>resource.id;
const $1ce286d293747584$export$3442ac9bfe667688 = (state)=>(0, $f8e1ae5c3f1d25ae$export$eb25faf9da40860f)(state.current);
const $1ce286d293747584$export$7e41c8195d072605 = (mapper)=>(maybeCount)=>{
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(typeof maybeCount !== 'number', new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).MAPPING_ERROR, 'Server did not respond with service specific deviations count'));
        return mapper(maybeCount);
    };






const $aec3232385138720$var$fetchCached = (retrieveCached, fetchData)=>{
    const value = retrieveCached() ?? fetchData();
    return (0, $c3e1b746ad236797$export$8d524fb6540252df).is(value) ? Promise.reject(value) : Promise.resolve(value);
};
const $aec3232385138720$export$ef727a9a1ed6cd67 = (statusTypeFetcher, deviationFetcher, statusTypeSubscription, deviationsSubscription)=>(0, $c9e988a9208a6bbc$export$755b96d9572a8e9e)({
        fetchServiceDeviationsCount: (...args)=>$aec3232385138720$var$fetchCached(()=>deviationsSubscription.useCachedServiceDeviationsCount(...args), ()=>deviationFetcher.fetchServiceDeviationsCount(...args)),
        subscribeToServiceDeviationsCount: deviationsSubscription,
        subscribeToServicesDeviationsCount: deviationsSubscription,
        subscribeToResolvedDeviations: deviationsSubscription,
        fetchStatusType: (...args)=>$aec3232385138720$var$fetchCached(()=>statusTypeSubscription.useCachedStatusType(...args), ()=>statusTypeFetcher.fetchStatusType(...args)),
        subscribeToStatusType: statusTypeSubscription
    });









var $56b495ac5bf7028c$exports = {};
$56b495ac5bf7028c$exports = JSON.parse("{\"CYBUS_DOCS\":\"/\",\"LICENSE_OFFLINE_ACTIVATION\":\"/documentation/installation-and-upgrades/licensing#offline-license-activation\",\"LICENSING\":\"/documentation/installation-and-upgrades/licensing\",\"MQTT_PREFIX\":\"/documentation/user-management/adding-an-mqtt-publish-prefix-for-users\",\"RULE_ENGINE_PARSE_RULE\":\"/documentation/services/rule-engine/data-processing-rules#parse\",\"SERVICES\":\"/documentation/services\",\"SERVICES_COMMISSIONING_FILE\":\"/documentation/services/service-commissioning-files\",\"UI_ACCESS_PERMISSIONS\":\"/documentation/user-management/access-permissions-for-admin-ui/ui-access\"}");


class $75bfa09ac5354192$export$9183fa87787f525f {
    static #_ = this.documentationLinks = (0, (/*@__PURE__*/$parcel$interopDefault($56b495ac5bf7028c$exports)));
    static getDocumentationURL(type, args) {
        return new URL(`/${args.version.replaceAll('.', '-')}${this.documentationLinks[type]}`, args.documentation);
    }
    constructor(config){
        this.config = config;
        this.extensionsGetters = {
            [(0, $de76aa5bd91d062d$export$431c833e82f9ca90).CERTIFICATE]: ()=>this.config.certificateFileExtension,
            [(0, $de76aa5bd91d062d$export$431c833e82f9ca90).LICENSE]: ()=>this.config.licenseFileExtension,
            [(0, $de76aa5bd91d062d$export$431c833e82f9ca90).SERVICE_COMMISSIONING]: ()=>this.config.commissioningFile.uploadExtensions
        };
    }
    getResourcesPaginationSizes() {
        return this.config.pageSizes;
    }
    getClientRegistryRefreshRate() {
        return this.config.clientRegistryRefreshRate;
    }
    getApplicationMetadata() {
        const entries = [
            'connect-src',
            "'self'",
            /**
             * HTTP and WSS urls are passed as is, so communication with them is whitelisted
             */ this.config.httpsURL.href,
            this.config.wssURL.href,
            /**
             * Due to MQTT running on top of WSS, its paths need to be remapped and passed along too
             */ ...this.config.mqttPaths.map((path)=>new URL(path, this.config.wssURL).href)
        ];
        return {
            'Content-Security-Policy': Array.from(new Set(entries)).join(' ')
        };
    }
    getDocumentationURL(type) {
        return $75bfa09ac5354192$export$9183fa87787f525f.getDocumentationURL(type, this.config);
    }
    getWorkbenchURL() {
        const { httpsURL: httpsURL, workbenchPath: workbenchPath } = this.config;
        return new URL(workbenchPath, httpsURL.origin);
    }
    getSupportedFileExtensions(type) {
        const value = this.extensionsGetters[type]();
        const valueArray = (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(value) ? value : [
            value
        ];
        (0, $14eddac5f20c576c$export$a7a9523472993e97)((0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(valueArray), new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).CONFIGURATION_ERROR, 'File extensions are missconfigured', {
            type: type
        }));
        return valueArray;
    }
    getServiceCommissioningFileDownloadMimeType() {
        return this.config.commissioningFile.downloadMimeType;
    }
    getSalesEmail() {
        return this.config.salesEmail;
    }
    getSupportEmail() {
        return this.config.supportEmail;
    }
    getInfoPageRefreshRate() {
        return this.config.infoPageRefreshRate;
    }
    getInteractionThrottle() {
        return this.config.interactionThrottle;
    }
    getResourcesSearchThreshold() {
        return this.config.searchMinimum;
    }
    getLogoutWarningPeriod() {
        return this.config.logoutWarningPeriod;
    }
    isStorybookEnabled() {
        return this.config.enableStorybook;
    }
}




// Lodash implementation of `get`
const $309ddf884e8891c7$var$charCodeOfDot = '.'.charCodeAt(0);
const $309ddf884e8891c7$var$reEscapeChar = /\\(\\)?/g;
const $309ddf884e8891c7$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", 'g');
const $309ddf884e8891c7$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
const $309ddf884e8891c7$var$reIsPlainProp = /^\w*$/;
const $309ddf884e8891c7$var$getTag = function(value) {
    value;
    return Object.prototype.toString.call(value);
};
const $309ddf884e8891c7$var$isSymbol = function(value) {
    const type = typeof value;
    return type === 'symbol' || type === 'object' && value && $309ddf884e8891c7$var$getTag(value) === '[object Symbol]';
};
const $309ddf884e8891c7$var$isKey = function(value, object) {
    if (Array.isArray(value)) return false;
    const type = typeof value;
    if (type === 'number' || type === 'symbol' || type === 'boolean' || !value || $309ddf884e8891c7$var$isSymbol(value)) return true;
    return $309ddf884e8891c7$var$reIsPlainProp.test(value) || !$309ddf884e8891c7$var$reIsDeepProp.test(value) || object != null && value in Object(object);
};
const $309ddf884e8891c7$var$stringToPath = function(string) {
    const result = [];
    if (string.charCodeAt(0) === $309ddf884e8891c7$var$charCodeOfDot) result.push('');
    string.replace($309ddf884e8891c7$var$rePropName, function(match, expression, quote, subString) {
        let key = match;
        if (quote) key = subString.replace($309ddf884e8891c7$var$reEscapeChar, '$1');
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
const $309ddf884e8891c7$var$castPath = function(value, object) {
    if (Array.isArray(value)) return value;
    else return $309ddf884e8891c7$var$isKey(value, object) ? [
        value
    ] : $309ddf884e8891c7$var$stringToPath(value);
};
const $309ddf884e8891c7$var$toKey = function(value) {
    if (typeof value === 'string' || $309ddf884e8891c7$var$isSymbol(value)) return value;
    const result = `${value}`;
    // eslint-disable-next-line
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
};
const $309ddf884e8891c7$export$3988ae62b71be9a3 = function(object, path) {
    path = $309ddf884e8891c7$var$castPath(path, object);
    let index = 0;
    const length = path.length;
    while(object != null && index < length)object = object[$309ddf884e8891c7$var$toKey(path[index++])];
    return index && index === length ? object : undefined;
};


const $b5ae3fea1ac5c11b$export$167528a9b5133c2f = function(obj) {
    return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
};


const $cf6c7323a205cc12$export$d617f0f1420b0a22 = function(columns) {
    if (columns === undefined || columns === null) return [
        undefined,
        undefined
    ];
    if (typeof columns !== 'object') return [
        Error('Invalid option "columns": expect an array or an object')
    ];
    if (!Array.isArray(columns)) {
        const newcolumns = [];
        for(const k in columns)newcolumns.push({
            key: k,
            header: columns[k]
        });
        columns = newcolumns;
    } else {
        const newcolumns = [];
        for (const column of columns){
            if (typeof column === 'string') newcolumns.push({
                key: column,
                header: column
            });
            else if (typeof column === 'object' && column !== null && !Array.isArray(column)) {
                if (!column.key) return [
                    Error('Invalid column definition: property "key" is required')
                ];
                if (column.header === undefined) column.header = column.key;
                newcolumns.push(column);
            } else return [
                Error('Invalid column definition: expect a string or an object')
            ];
        }
        columns = newcolumns;
    }
    return [
        undefined,
        columns
    ];
};



var $8fJ0j = parcelRequire("8fJ0j");
var $943c512e1d8c1de3$require$Buffer = $8fJ0j.Buffer;
class $943c512e1d8c1de3$export$d9d08b09962b4c23 extends Error {
    constructor(code, message, ...contexts){
        if (Array.isArray(message)) message = message.join(' ');
        super(message);
        if (Error.captureStackTrace !== undefined) Error.captureStackTrace(this, $943c512e1d8c1de3$export$d9d08b09962b4c23);
        this.code = code;
        for (const context of contexts)for(const key in context){
            const value = context[key];
            this[key] = $943c512e1d8c1de3$require$Buffer.isBuffer(value) ? value.toString() : value == null ? value : JSON.parse(JSON.stringify(value));
        }
    }
}



const $c9902ca37b8d61e6$export$730f2a930033e8f0 = function(str) {
    return str.replace(/([A-Z])/g, function(_, match) {
        return '_' + match.toLowerCase();
    });
};



var $8fJ0j = parcelRequire("8fJ0j");
var $f15788b92f99e8b2$require$Buffer = $8fJ0j.Buffer;
const $f15788b92f99e8b2$export$ccfebcb248d28a57 = function(opts) {
    const options = {};
    // Merge with user options
    for(const opt in opts)options[(0, $c9902ca37b8d61e6$export$730f2a930033e8f0)(opt)] = opts[opt];
    // Normalize option `bom`
    if (options.bom === undefined || options.bom === null || options.bom === false) options.bom = false;
    else if (options.bom !== true) return [
        new (0, $943c512e1d8c1de3$export$d9d08b09962b4c23)('CSV_OPTION_BOOLEAN_INVALID_TYPE', [
            'option `bom` is optional and must be a boolean value,',
            `got ${JSON.stringify(options.bom)}`
        ])
    ];
    // Normalize option `delimiter`
    if (options.delimiter === undefined || options.delimiter === null) options.delimiter = ',';
    else if ($f15788b92f99e8b2$require$Buffer.isBuffer(options.delimiter)) options.delimiter = options.delimiter.toString();
    else if (typeof options.delimiter !== 'string') return [
        new (0, $943c512e1d8c1de3$export$d9d08b09962b4c23)('CSV_OPTION_DELIMITER_INVALID_TYPE', [
            'option `delimiter` must be a buffer or a string,',
            `got ${JSON.stringify(options.delimiter)}`
        ])
    ];
    // Normalize option `quote`
    if (options.quote === undefined || options.quote === null) options.quote = '"';
    else if (options.quote === true) options.quote = '"';
    else if (options.quote === false) options.quote = '';
    else if ($f15788b92f99e8b2$require$Buffer.isBuffer(options.quote)) options.quote = options.quote.toString();
    else if (typeof options.quote !== 'string') return [
        new (0, $943c512e1d8c1de3$export$d9d08b09962b4c23)('CSV_OPTION_QUOTE_INVALID_TYPE', [
            'option `quote` must be a boolean, a buffer or a string,',
            `got ${JSON.stringify(options.quote)}`
        ])
    ];
    // Normalize option `quoted`
    if (options.quoted === undefined || options.quoted === null) options.quoted = false;
    // Normalize option `escape_formulas`
    if (options.escape_formulas === undefined || options.escape_formulas === null) options.escape_formulas = false;
    else if (typeof options.escape_formulas !== 'boolean') return [
        new (0, $943c512e1d8c1de3$export$d9d08b09962b4c23)('CSV_OPTION_ESCAPE_FORMULAS_INVALID_TYPE', [
            'option `escape_formulas` must be a boolean,',
            `got ${JSON.stringify(options.escape_formulas)}`
        ])
    ];
    // Normalize option `quoted_empty`
    if (options.quoted_empty === undefined || options.quoted_empty === null) options.quoted_empty = undefined;
    // Normalize option `quoted_match`
    if (options.quoted_match === undefined || options.quoted_match === null || options.quoted_match === false) options.quoted_match = null;
    else if (!Array.isArray(options.quoted_match)) options.quoted_match = [
        options.quoted_match
    ];
    if (options.quoted_match) for (const quoted_match of options.quoted_match){
        const isString = typeof quoted_match === 'string';
        const isRegExp = quoted_match instanceof RegExp;
        if (!isString && !isRegExp) return [
            Error(`Invalid Option: quoted_match must be a string or a regex, got ${JSON.stringify(quoted_match)}`)
        ];
    }
    // Normalize option `quoted_string`
    if (options.quoted_string === undefined || options.quoted_string === null) options.quoted_string = false;
    // Normalize option `eof`
    if (options.eof === undefined || options.eof === null) options.eof = true;
    // Normalize option `escape`
    if (options.escape === undefined || options.escape === null) options.escape = '"';
    else if ($f15788b92f99e8b2$require$Buffer.isBuffer(options.escape)) options.escape = options.escape.toString();
    else if (typeof options.escape !== 'string') return [
        Error(`Invalid Option: escape must be a buffer or a string, got ${JSON.stringify(options.escape)}`)
    ];
    if (options.escape.length > 1) return [
        Error(`Invalid Option: escape must be one character, got ${options.escape.length} characters`)
    ];
    // Normalize option `header`
    if (options.header === undefined || options.header === null) options.header = false;
    // Normalize option `columns`
    const [errColumns, columns] = (0, $cf6c7323a205cc12$export$d617f0f1420b0a22)(options.columns);
    if (errColumns !== undefined) return [
        errColumns
    ];
    options.columns = columns;
    // Normalize option `quoted`
    if (options.quoted === undefined || options.quoted === null) options.quoted = false;
    // Normalize option `cast`
    if (options.cast === undefined || options.cast === null) options.cast = {};
    // Normalize option cast.bigint
    if (options.cast.bigint === undefined || options.cast.bigint === null) // Cast boolean to string by default
    options.cast.bigint = (value)=>'' + value;
    // Normalize option cast.boolean
    if (options.cast.boolean === undefined || options.cast.boolean === null) // Cast boolean to string by default
    options.cast.boolean = (value)=>value ? '1' : '';
    // Normalize option cast.date
    if (options.cast.date === undefined || options.cast.date === null) // Cast date to timestamp string by default
    options.cast.date = (value)=>'' + value.getTime();
    // Normalize option cast.number
    if (options.cast.number === undefined || options.cast.number === null) // Cast number to string using native casting by default
    options.cast.number = (value)=>'' + value;
    // Normalize option cast.object
    if (options.cast.object === undefined || options.cast.object === null) // Stringify object as JSON by default
    options.cast.object = (value)=>JSON.stringify(value);
    // Normalize option cast.string
    if (options.cast.string === undefined || options.cast.string === null) // Leave string untouched
    options.cast.string = function(value) {
        return value;
    };
    // Normalize option `on_record`
    if (options.on_record !== undefined && typeof options.on_record !== 'function') return [
        Error(`Invalid Option: "on_record" must be a function.`)
    ];
    // Normalize option `record_delimiter`
    if (options.record_delimiter === undefined || options.record_delimiter === null) options.record_delimiter = '\n';
    else if ($f15788b92f99e8b2$require$Buffer.isBuffer(options.record_delimiter)) options.record_delimiter = options.record_delimiter.toString();
    else if (typeof options.record_delimiter !== 'string') return [
        Error(`Invalid Option: record_delimiter must be a buffer or a string, got ${JSON.stringify(options.record_delimiter)}`)
    ];
    switch(options.record_delimiter){
        case 'unix':
            options.record_delimiter = "\n";
            break;
        case 'mac':
            options.record_delimiter = "\r";
            break;
        case 'windows':
            options.record_delimiter = "\r\n";
            break;
        case 'ascii':
            options.record_delimiter = "\u001e";
            break;
        case 'unicode':
            options.record_delimiter = "\u2028";
            break;
    }
    return [
        undefined,
        options
    ];
};



var $8fJ0j = parcelRequire("8fJ0j");
var $e95a0d5590995c3e$require$Buffer = $8fJ0j.Buffer;
const $e95a0d5590995c3e$var$bom_utf8 = $e95a0d5590995c3e$require$Buffer.from([
    239,
    187,
    191
]);
const $e95a0d5590995c3e$export$c7ae173922416539 = function(options, state, info) {
    return {
        options: options,
        state: state,
        info: info,
        __transform: function(chunk, push) {
            // Chunk validation
            if (!Array.isArray(chunk) && typeof chunk !== 'object') return Error(`Invalid Record: expect an array or an object, got ${JSON.stringify(chunk)}`);
            // Detect columns from the first record
            if (this.info.records === 0) {
                if (Array.isArray(chunk)) {
                    if (this.options.header === true && this.options.columns === undefined) return Error('Undiscoverable Columns: header option requires column option or object records');
                } else if (this.options.columns === undefined) {
                    const [err, columns] = (0, $cf6c7323a205cc12$export$d617f0f1420b0a22)(Object.keys(chunk));
                    if (err) return;
                    this.options.columns = columns;
                }
            }
            // Emit the header
            if (this.info.records === 0) {
                this.bom(push);
                const err = this.headers(push);
                if (err) return err;
            }
            // Emit and stringify the record if an object or an array
            try {
                // this.emit('record', chunk, this.info.records);
                if (this.options.on_record) this.options.on_record(chunk, this.info.records);
            } catch (err) {
                return err;
            }
            // Convert the record into a string
            let err, chunk_string;
            if (this.options.eof) {
                [err, chunk_string] = this.stringify(chunk);
                if (err) return err;
                if (chunk_string === undefined) return;
                else chunk_string = chunk_string + this.options.record_delimiter;
            } else {
                [err, chunk_string] = this.stringify(chunk);
                if (err) return err;
                if (chunk_string === undefined) return;
                else if (this.options.header || this.info.records) chunk_string = this.options.record_delimiter + chunk_string;
            }
            // Emit the csv
            this.info.records++;
            push(chunk_string);
        },
        stringify: function(chunk, chunkIsHeader = false) {
            if (typeof chunk !== 'object') return [
                undefined,
                chunk
            ];
            const { columns: columns } = this.options;
            const record = [];
            // Record is an array
            if (Array.isArray(chunk)) {
                // We are getting an array but the user has specified output columns. In
                // this case, we respect the columns indexes
                if (columns) chunk.splice(columns.length);
                // Cast record elements
                for(let i = 0; i < chunk.length; i++){
                    const field = chunk[i];
                    const [err, value] = this.__cast(field, {
                        index: i,
                        column: i,
                        records: this.info.records,
                        header: chunkIsHeader
                    });
                    if (err) return [
                        err
                    ];
                    record[i] = [
                        value,
                        field
                    ];
                }
            // Record is a literal object
            // `columns` is always defined: it is either provided or discovered.
            } else for(let i = 0; i < columns.length; i++){
                const field = (0, $309ddf884e8891c7$export$3988ae62b71be9a3)(chunk, columns[i].key);
                const [err, value] = this.__cast(field, {
                    index: i,
                    column: columns[i].key,
                    records: this.info.records,
                    header: chunkIsHeader
                });
                if (err) return [
                    err
                ];
                record[i] = [
                    value,
                    field
                ];
            }
            let csvrecord = '';
            for(let i = 0; i < record.length; i++){
                let options, err;
                // eslint-disable-next-line
                let [value, field] = record[i];
                if (typeof value === "string") options = this.options;
                else if ((0, $b5ae3fea1ac5c11b$export$167528a9b5133c2f)(value)) {
                    options = value;
                    value = options.value;
                    delete options.value;
                    if (typeof value !== "string" && value !== undefined && value !== null) {
                        if (err) return [
                            Error(`Invalid Casting Value: returned value must return a string, null or undefined, got ${JSON.stringify(value)}`)
                        ];
                    }
                    options = {
                        ...this.options,
                        ...options
                    };
                    [err, options] = (0, $f15788b92f99e8b2$export$ccfebcb248d28a57)(options);
                    if (err !== undefined) return [
                        err
                    ];
                } else if (value === undefined || value === null) options = this.options;
                else return [
                    Error(`Invalid Casting Value: returned value must return a string, an object, null or undefined, got ${JSON.stringify(value)}`)
                ];
                const { delimiter: delimiter, escape: escape, quote: quote, quoted: quoted, quoted_empty: quoted_empty, quoted_string: quoted_string, quoted_match: quoted_match, record_delimiter: record_delimiter, escape_formulas: escape_formulas } = options;
                if ('' === value && '' === field) {
                    let quotedMatch = quoted_match && quoted_match.filter((quoted_match)=>{
                        if (typeof quoted_match === 'string') return value.indexOf(quoted_match) !== -1;
                        else return quoted_match.test(value);
                    });
                    quotedMatch = quotedMatch && quotedMatch.length > 0;
                    const shouldQuote = quotedMatch || true === quoted_empty || true === quoted_string && false !== quoted_empty;
                    if (shouldQuote === true) value = quote + value + quote;
                    csvrecord += value;
                } else if (value) {
                    if (typeof value !== 'string') return [
                        Error(`Formatter must return a string, null or undefined, got ${JSON.stringify(value)}`)
                    ];
                    const containsdelimiter = delimiter.length && value.indexOf(delimiter) >= 0;
                    const containsQuote = quote !== '' && value.indexOf(quote) >= 0;
                    const containsEscape = value.indexOf(escape) >= 0 && escape !== quote;
                    const containsRecordDelimiter = value.indexOf(record_delimiter) >= 0;
                    const quotedString = quoted_string && typeof field === 'string';
                    let quotedMatch = quoted_match && quoted_match.filter((quoted_match)=>{
                        if (typeof quoted_match === 'string') return value.indexOf(quoted_match) !== -1;
                        else return quoted_match.test(value);
                    });
                    quotedMatch = quotedMatch && quotedMatch.length > 0;
                    // See https://github.com/adaltas/node-csv/pull/387
                    // More about CSV injection or formula injection, when websites embed
                    // untrusted input inside CSV files:
                    // https://owasp.org/www-community/attacks/CSV_Injection
                    // http://georgemauer.net/2017/10/07/csv-injection.html
                    // Apple Numbers unicode normalization is empirical from testing
                    if (escape_formulas) switch(value[0]){
                        case '=':
                        case '+':
                        case '-':
                        case '@':
                        case '\t':
                        case '\r':
                        case '\uFF1D':
                        case '\uFF0B':
                        case '\uFF0D':
                        case '\uFF20':
                            value = `'${value}`;
                            break;
                    }
                    const shouldQuote = containsQuote === true || containsdelimiter || containsRecordDelimiter || quoted || quotedString || quotedMatch;
                    if (shouldQuote === true && containsEscape === true) {
                        const regexp = escape === '\\' ? new RegExp(escape + escape, 'g') : new RegExp(escape, 'g');
                        value = value.replace(regexp, escape + escape);
                    }
                    if (containsQuote === true) {
                        const regexp = new RegExp(quote, 'g');
                        value = value.replace(regexp, escape + quote);
                    }
                    if (shouldQuote === true) value = quote + value + quote;
                    csvrecord += value;
                } else if (quoted_empty === true || field === '' && quoted_string === true && quoted_empty !== false) csvrecord += quote + quote;
                if (i !== record.length - 1) csvrecord += delimiter;
            }
            return [
                undefined,
                csvrecord
            ];
        },
        bom: function(push) {
            if (this.options.bom !== true) return;
            push($e95a0d5590995c3e$var$bom_utf8);
        },
        headers: function(push) {
            if (this.options.header === false) return;
            if (this.options.columns === undefined) return;
            let err;
            let headers = this.options.columns.map((column)=>column.header);
            if (this.options.eof) {
                [err, headers] = this.stringify(headers, true);
                headers += this.options.record_delimiter;
            } else [err, headers] = this.stringify(headers);
            if (err) return err;
            push(headers);
        },
        __cast: function(value, context) {
            const type = typeof value;
            try {
                if (type === 'string') return [
                    undefined,
                    this.options.cast.string(value, context)
                ];
                else if (type === 'bigint') return [
                    undefined,
                    this.options.cast.bigint(value, context)
                ];
                else if (type === 'number') return [
                    undefined,
                    this.options.cast.number(value, context)
                ];
                else if (type === 'boolean') return [
                    undefined,
                    this.options.cast.boolean(value, context)
                ];
                else if (value instanceof Date) return [
                    undefined,
                    this.options.cast.date(value, context)
                ];
                else if (type === 'object' && value !== null) return [
                    undefined,
                    this.options.cast.object(value, context)
                ];
                else return [
                    undefined,
                    value,
                    value
                ];
            } catch (err) {
                return [
                    err
                ];
            }
        }
    };
};



const $13e457b15ad3efd0$export$fac44ee5b035f737 = function(records, opts = {}) {
    const data = [];
    const [err, options] = (0, $f15788b92f99e8b2$export$ccfebcb248d28a57)(opts);
    if (err !== undefined) throw err;
    const state = {
        stop: false
    };
    // Information
    const info = {
        records: 0
    };
    const api = (0, $e95a0d5590995c3e$export$c7ae173922416539)(options, state, info);
    for (const record of records){
        const err = api.__transform(record, function(record) {
            data.push(record);
        });
        if (err !== undefined) throw err;
    }
    if (data.length === 0) {
        api.bom((d)=>{
            data.push(d);
        });
        const err = api.headers((headers)=>{
            data.push(headers);
        });
        if (err !== undefined) throw err;
    }
    return data.join('');
};


class $2b079fbc1cb22ff5$export$7f7c7a3367841dd1 {
    download(file) {
        const link = document.createElement('a');
        link.download = file.name;
        /**
         * Makes blob fetchable through url
         */ link.href = URL.createObjectURL(file);
        /**
         * Attach to document
         */ document.body.appendChild(link);
        /**
         * Opens it (effectively downloads it)
         */ link.click();
        /**
         * Drops garbage
         */ document.body.removeChild(link);
        /**
         * Tells the browser they don't have to reference the object anymore
         */ URL.revokeObjectURL(link.href);
    }
    generateCSV(fileName, head, data) {
        const csvContent = (0, $13e457b15ad3efd0$export$fac44ee5b035f737)([
            head,
            ...data
        ], {
            cast: {
                date: (date)=>date.toISOString(),
                string: (value)=>value.trim()
            }
        });
        return new File([
            new Blob([
                csvContent
            ], {
                type: 'text/csv'
            })
        ], `${fileName}.csv`, {
            type: 'text/csv'
        });
    }
}






const $3595aa224dad6f35$var$locale = 'en-de';
const $3595aa224dad6f35$export$a208c2a8af89b1d9 = (translation, logger)=>{
    const onError = (e)=>logger.error(new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).TRANSLATIONS, e.message.trim(), {
            code: e.code,
            descriptor: 'descriptor' in e && e.descriptor || null
        }));
    return (0, $e64c92d637c5ac09$export$7e4cbedfdd7b4c0d)({
        messages: translation,
        locale: $3595aa224dad6f35$var$locale,
        onError: onError
    });
};
const $3595aa224dad6f35$var$listOptionsMap = {
    list: 'conjunction',
    options: 'disjunction'
};
class $3595aa224dad6f35$export$50f8b6f81dec1abd {
    constructor(intls){
        this.intls = intls;
    }
    get intl() {
        return this.intls;
    }
    list(values, option = 'list') {
        return this.intl.formatList(values, {
            type: $3595aa224dad6f35$var$listOptionsMap[option]
        });
    }
    translate(id, values) {
        return this.intl.formatMessage({
            id: id
        }, values);
    }
}






class $897ee296cd9b4196$export$95af61d43eab0f10 {
    constructor(logger, origin, hostsWhitelist, cookiePaths){
        this.logger = logger;
        this.origin = origin;
        this.hostsWhitelist = hostsWhitelist;
        this.cookiePaths = cookiePaths;
        this.targetDocument = document;
        this.targetWindow = window;
        this.targetLocation = window.location;
        this.targetHistory = window.history;
        this.targetClipboard = navigator.clipboard;
    }
    setAuthCookie(token, expiresAt, path) {
        const values = [
            [
                'X-Auth-Token',
                encodeURIComponent(token ?? '')
            ],
            [
                'path',
                path
            ],
            [
                'SameSite',
                'strict'
            ],
            [
                'Secure'
            ],
            [
                'Host',
                this.origin
            ]
        ];
        if (expiresAt) values.push([
            'expires',
            expiresAt.toUTCString()
        ]);
        this.targetDocument.cookie = values.map((pair)=>pair.join('=')).join('; ');
    }
    getUrlParameters() {
        return new URLSearchParams(this.targetLocation.search);
    }
    getUrlParameter(name) {
        return this.getUrlParameters().get(name);
    }
    openWithoutValidation(url, name) {
        const ref = url.toString();
        this.targetWindow.open(ref, name || ref);
    }
    /**
     * Checks if the given url is safe to be loaded onto the browser
     *
     * @throws {ConnectwareError}
     */ validateUrl(targetUrl) {
        const { href: redirectUrl, protocol: targetProtocol, host: targetHost } = targetUrl;
        const { href: currentUrl, protocol: currentProtocol } = new URL(this.targetLocation.href);
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(currentProtocol === targetProtocol, /**
             * If the browser is running on https, the new redirection must also target https
             * Otherwise it will fail
             *
             * It also prevents javascript execution
             * @see https://developer.mozilla.org/en-US/docs/Web/URI/Schemes/javascript
             */ new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).GENERAL_BUSINESS_RULE_INFRACTION, 'Only redirection to the same protocol is allowed', {
            currentUrl: currentUrl,
            redirectUrl: redirectUrl
        }));
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(this.hostsWhitelist.has(targetHost), new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).GENERAL_BUSINESS_RULE_INFRACTION, 'Redirection to given host not allowed', {
            targetHost: targetHost,
            hostsWhitelist: Array.from(this.hostsWhitelist)
        }));
    }
    isInspecting() {
        return this.getUrlParameter('inspection') !== null;
    }
    redirect(redirectUrl) {
        this.validateUrl(redirectUrl);
        this.targetLocation.replace(redirectUrl.toString());
    }
    getRedirectionURL() {
        const redirectParameter = this.getUrlParameter('redirect');
        return redirectParameter ? new URL(redirectParameter, this.origin) : null;
    }
    extractURLAuthentication() {
        const parameters = this.getUrlParameters();
        const apiToken = parameters.get('apiToken');
        if (apiToken) return apiToken;
        const { ssoError: ssoError, ...otherParameters } = Object.fromEntries(parameters);
        if (ssoError === String(true)) {
            const { ssoCallbackRedirect: ssoCallbackRedirect, ssoLoginRedirect: ssoLoginRedirect, ...otherEntraErrorParameters } = otherParameters;
            let reason = 'unknown';
            if (ssoCallbackRedirect === String(true) && otherEntraErrorParameters.error === 'invalid_client') reason = 'invalid_client';
            if (ssoCallbackRedirect === String(true) && otherParameters.statusCode === '409') /** A 409 status code indicates that the user already exists in CW with a different provider */ reason = 'user_already_exists';
            if (ssoLoginRedirect === String(true)) reason = 'failed_login_redirect';
            return new (0, $eba4f0b13361fb3e$export$d86854ef9821cdaf)({
                ...otherEntraErrorParameters,
                method: (0, $eba4f0b13361fb3e$export$a0bf97755470bf0e).MICROSOFT_ENTRA_ID,
                reason: reason
            });
        }
        return null;
    }
    removeURLAuthentication() {
        const url = new URL(this.targetLocation.href);
        url.search = '';
        this.validateUrl(url);
        this.targetHistory.pushState({}, '', url);
    }
    authenticate(info) {
        const token = info?.token ?? null;
        const expiresAt = info?.expiresAt ?? null;
        for (const path of this.cookiePaths)this.setAuthCookie(token, expiresAt, path);
    }
    reload() {
        this.targetLocation.reload();
    }
    open(url, name) {
        this.validateUrl(url);
        this.openWithoutValidation(url, name);
    }
    sendEmail(target, subject) {
        const url = new URL(`mailto:${target}`);
        if (subject) url.searchParams.append('subject', subject);
        this.openWithoutValidation(url, null);
    }
    copy(value) {
        let data = null;
        switch(typeof value){
            case 'string':
                data = value;
                break;
            default:
                /** Just quietly log the issue */ this.logger.error(new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Only string values are supported to be copied', {
                    value: value
                }));
        }
        if (data === null) return null;
        this.targetClipboard.writeText(data).catch(({ message: message, code: code })=>{
            /** Just quietly log the issue */ this.logger.error(new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Could not write to clipboard', {
                message: message,
                code: code,
                value: value
            }));
        });
        return data;
    }
}




const $133af03133e6eca3$export$e05d433ecc078c7e = (response)=>response.getStatus() === 403 && response.getHeaders().some(([name, value])=>name === 'x-missing-permissions' && value === 'authorization failed');








const $773d9142ff567164$export$b1a19a9e61b09890 = async (response, isValid)=>{
    const json = await response.getJson();
    if (isValid(json)) return json;
    const error = new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Response had unexpected json', {
        json: json,
        validator: isValid.name
    });
    return (0, $ea3ab9f98af64a6e$export$7914be4505ea8cc6)(error, $773d9142ff567164$export$b1a19a9e61b09890);
};







const $1db8082f299753fb$var$replacecementSymbol = '+';
const $1db8082f299753fb$export$5cc7f731b5937e99 = (permissionPathTemplate, ...params)=>{
    const parts = permissionPathTemplate.split($1db8082f299753fb$var$replacecementSymbol);
    (0, $14eddac5f20c576c$export$a7a9523472993e97)(parts.length === params.length + 1, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'There is a mismatching number of replacement symbols and params', {
        replacecementSymbol: $1db8082f299753fb$var$replacecementSymbol,
        params: params,
        permissionPathTemplate: permissionPathTemplate
    }));
    return parts.reduce((out, part, k)=>`${out}${part}${encodeURIComponent(params[k] ?? '')}`, '');
};


class $b67c109910decc95$export$709863c817f6e91 {
    static createRequestBodySection(body) {
        if (body === undefined) return [
            null,
            {}
        ];
        return [
            JSON.stringify(body),
            {
                'Content-Type': 'application/json'
            }
        ];
    }
    static async createOutput(args, fetchArgs, response) {
        const responseStatus = response.getStatus();
        const handler = responseStatus in args.handlers && args.handlers[responseStatus];
        if (!handler) /**
             * Default error should **not** happen in production scenarios
             */ return new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Unexpected status code in response', {
            url: fetchArgs.url,
            status: responseStatus,
            supportedStatuses: (0, $2ae70427bab197d4$export$ed97f33186d4b816)(args.handlers),
            headers: response.getHeaders()
        });
        return await handler(response);
    }
    constructor(options){
        this.options = options;
    }
    createAuthenticationHeaders(args) {
        let token = null;
        if (typeof args.authenticate === 'string') token = args.authenticate;
        else if (args.authenticate) {
            token = this.options.getToken?.() ?? null;
            (0, $14eddac5f20c576c$export$a7a9523472993e97)(token, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, 'Token could not be found'));
        }
        return token === null ? {} : {
            Authorization: `Bearer ${token}`
        };
    }
    createRequestUrl(args) {
        const url = new URL(args.pathParams ? (0, $1db8082f299753fb$export$5cc7f731b5937e99)(args.path, ...args.pathParams) : args.path, this.options.baseURL);
        if (args.queryParams) /**
             * This is needed because URLSearchParams doesn't support array values directly,
             * as described in their documentation
             */ for (const [key, valueOrValues] of (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(args.queryParams)){
            const values = (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(valueOrValues) ? valueOrValues : [
                valueOrValues
            ];
            values.forEach((value)=>url.searchParams.append(key, value));
        }
        return url.toString();
    }
    createHttpFetchArgs(args) {
        const [body, bodyHeaders] = $b67c109910decc95$export$709863c817f6e91.createRequestBodySection(args.body);
        return {
            url: this.createRequestUrl(args),
            method: args.method,
            headers: {
                ...this.createAuthenticationHeaders(args),
                ...bodyHeaders
            },
            body: body
        };
    }
    async request(args) {
        try {
            const fetchArgs = this.createHttpFetchArgs(args);
            const response = await this.fetch(fetchArgs);
            /** Notify the middleware */ this.options.responseHandler?.trigger(response);
            const output = await $b67c109910decc95$export$709863c817f6e91.createOutput(args, fetchArgs, response);
            if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(output)) throw output;
            return output;
        } catch (e) {
            let error;
            if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(e)) error = e;
            else if (e instanceof Error) /** Should **not** happen in production scenarios */ error = new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Unexpected error', {
                originalMessage: e.message
            });
            else /** Should **not** happen in production scenarios */ error = new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Unknown object thrown', {
                error: e
            });
            // eslint-disable-next-line @typescript-eslint/unbound-method
            return (0, $ea3ab9f98af64a6e$export$7914be4505ea8cc6)(error, this.request);
        }
    }
}


const $82373d578b14a603$var$mapError = (error)=>{
    if (error instanceof TypeError) switch(error.message){
        case 'Failed to fetch':
            /** Should happen in production, you will get a lot of problems here due to cors issues */ return new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_NOT_AVAILABLE, 'Could not fetch information from server');
        case "Failed to execute 'blob' on 'Response': body stream already read":
        case "Failed to execute 'json' on 'Response': body stream already read":
        case "Failed to execute 'text' on 'Response': body stream already read":
            /** Should not happen in production */ return new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Body stream was already closed');
    }
    if (error instanceof SyntaxError && /Unexpected token .+ is not valid JSON/g.test(error.message)) /** Should not happen in production */ return new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Could not parse json');
    /** Should only happen with node-fetch when running tests */ if (/connect ECONNREFUSED 127.0.0.1:443/g.test(error.message)) return new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_NOT_AVAILABLE, 'Could not fetch information from server', {
        fetchError: error.message
    });
    /**
     * Should not happen in production
     * if the code has reached this place in a real world scenario
     * it means it needs revision
     */ return new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Unexpected fetch error', {
        fetchError: error.message
    });
};
const $82373d578b14a603$var$wrapResponseError = async (response, executor)=>executor(response).catch((e)=>Promise.reject($82373d578b14a603$var$mapError(e)));
class $82373d578b14a603$var$FetchHttpResponse {
    constructor(response){
        this.response = response;
    }
    getStatus() {
        return this.response.status;
    }
    getHeaders() {
        return Array.from(this.response.headers);
    }
    getBlob() {
        return $82373d578b14a603$var$wrapResponseError(this.response, (r)=>r.blob());
    }
    getText() {
        return $82373d578b14a603$var$wrapResponseError(this.response, (r)=>r.text());
    }
    getJson() {
        return $82373d578b14a603$var$wrapResponseError(this.response, (r)=>r.json());
    }
}
class $82373d578b14a603$export$f6f3d54ed66158a2 extends (0, $b67c109910decc95$export$709863c817f6e91) {
    async fetch({ url: url, ...args }) {
        return fetch(url, args).catch((e)=>Promise.reject($82373d578b14a603$var$mapError(e))).then((r)=>new $82373d578b14a603$var$FetchHttpResponse(r));
    }
}




/** This script was auto generated by 'TypeValidatorCreator' at 'src/infrastructure/scripts/Typescript/TypeValidator.ts' **/ 
const $54d6da920dd2f791$var$MinimalCertificatesResponseSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalCertificatesResponse',
    definitions: {
        MinimalCertificatesResponse: {
            type: 'array',
            items: {
                $ref: '#/definitions/CertificateResponse'
            },
            deprecated: true
        },
        CertificateResponse: {
            type: 'object',
            properties: {
                id: {
                    type: 'string'
                },
                issuedBy: {
                    type: 'object',
                    properties: {
                        commonName: {
                            type: [
                                'string',
                                'null'
                            ]
                        },
                        organization: {
                            type: 'string'
                        },
                        organizationalUnit: {
                            type: [
                                'string',
                                'null'
                            ]
                        }
                    },
                    required: [
                        'commonName',
                        'organization',
                        'organizationalUnit'
                    ]
                },
                issuedTo: {
                    type: 'object',
                    properties: {
                        commonName: {
                            type: [
                                'string',
                                'null'
                            ]
                        },
                        organization: {
                            type: [
                                'string',
                                'null'
                            ]
                        },
                        organizationalUnit: {
                            type: [
                                'string',
                                'null'
                            ]
                        },
                        alternativeNames: {
                            type: 'array',
                            items: {
                                type: 'string'
                            }
                        }
                    },
                    required: [
                        'commonName',
                        'organization',
                        'organizationalUnit',
                        'alternativeNames'
                    ]
                },
                keyUsage: {
                    type: 'array',
                    items: {
                        type: 'string'
                    }
                },
                extendedKeyUsage: {
                    type: 'array',
                    items: {
                        type: 'string'
                    }
                },
                basicConstraints: {
                    type: 'object',
                    properties: {
                        isCA: {
                            type: 'boolean'
                        },
                        pathLength: {
                            type: 'number'
                        }
                    },
                    required: [
                        'isCA',
                        'pathLength'
                    ]
                },
                issuedOn: {
                    type: 'number'
                },
                expiresOn: {
                    type: 'number'
                },
                fingerprints: {
                    $ref: '#/definitions/ReadonlyRecord%3C(%22sha1%22%7C%22sha256%22)%2Cstring%3E'
                },
                removable: {
                    type: 'boolean'
                }
            },
            required: [
                'id',
                'issuedBy',
                'issuedTo',
                'keyUsage',
                'extendedKeyUsage',
                'basicConstraints',
                'issuedOn',
                'expiresOn',
                'fingerprints',
                'removable'
            ],
            deprecated: true
        },
        'ReadonlyRecord<("sha1"|"sha256"),string>': {
            type: 'object',
            properties: {
                sha1: {
                    type: 'string'
                },
                sha256: {
                    type: 'string'
                }
            },
            required: [
                'sha1',
                'sha256'
            ]
        }
    }
};
const $54d6da920dd2f791$export$6714e7f2e24be6a1 = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($54d6da920dd2f791$var$MinimalCertificatesResponseSchema, 'isMinimalCertificatesResponse');
const $54d6da920dd2f791$var$MinimalNonEmptyCertificatesResponseSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalNonEmptyCertificatesResponse',
    definitions: {
        MinimalNonEmptyCertificatesResponse: {
            $ref: '#/definitions/ReadonlyNonEmptyArray%3CCertificateResponse%3E',
            deprecated: true
        },
        'ReadonlyNonEmptyArray<CertificateResponse>': {
            anyOf: [
                {
                    allOf: [
                        {
                            type: 'array',
                            items: {
                                $ref: '#/definitions/CertificateResponse'
                            },
                            minItems: 1
                        },
                        {
                            type: 'array',
                            items: {
                                $ref: '#/definitions/CertificateResponse'
                            }
                        }
                    ]
                },
                {
                    allOf: [
                        {
                            type: 'array',
                            items: {
                                $ref: '#/definitions/CertificateResponse'
                            },
                            minItems: 1
                        },
                        {
                            type: 'array',
                            items: {
                                $ref: '#/definitions/CertificateResponse'
                            }
                        }
                    ]
                }
            ]
        },
        CertificateResponse: {
            type: 'object',
            properties: {
                id: {
                    type: 'string'
                },
                issuedBy: {
                    type: 'object',
                    properties: {
                        commonName: {
                            type: [
                                'string',
                                'null'
                            ]
                        },
                        organization: {
                            type: 'string'
                        },
                        organizationalUnit: {
                            type: [
                                'string',
                                'null'
                            ]
                        }
                    },
                    required: [
                        'commonName',
                        'organization',
                        'organizationalUnit'
                    ]
                },
                issuedTo: {
                    type: 'object',
                    properties: {
                        commonName: {
                            type: [
                                'string',
                                'null'
                            ]
                        },
                        organization: {
                            type: [
                                'string',
                                'null'
                            ]
                        },
                        organizationalUnit: {
                            type: [
                                'string',
                                'null'
                            ]
                        },
                        alternativeNames: {
                            type: 'array',
                            items: {
                                type: 'string'
                            }
                        }
                    },
                    required: [
                        'commonName',
                        'organization',
                        'organizationalUnit',
                        'alternativeNames'
                    ]
                },
                keyUsage: {
                    type: 'array',
                    items: {
                        type: 'string'
                    }
                },
                extendedKeyUsage: {
                    type: 'array',
                    items: {
                        type: 'string'
                    }
                },
                basicConstraints: {
                    type: 'object',
                    properties: {
                        isCA: {
                            type: 'boolean'
                        },
                        pathLength: {
                            type: 'number'
                        }
                    },
                    required: [
                        'isCA',
                        'pathLength'
                    ]
                },
                issuedOn: {
                    type: 'number'
                },
                expiresOn: {
                    type: 'number'
                },
                fingerprints: {
                    $ref: '#/definitions/ReadonlyRecord%3C(%22sha1%22%7C%22sha256%22)%2Cstring%3E'
                },
                removable: {
                    type: 'boolean'
                }
            },
            required: [
                'id',
                'issuedBy',
                'issuedTo',
                'keyUsage',
                'extendedKeyUsage',
                'basicConstraints',
                'issuedOn',
                'expiresOn',
                'fingerprints',
                'removable'
            ],
            deprecated: true
        },
        'ReadonlyRecord<("sha1"|"sha256"),string>': {
            type: 'object',
            properties: {
                sha1: {
                    type: 'string'
                },
                sha256: {
                    type: 'string'
                }
            },
            required: [
                'sha1',
                'sha256'
            ]
        }
    }
};
const $54d6da920dd2f791$export$a8f1eaf4da2ad9c5 = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($54d6da920dd2f791$var$MinimalNonEmptyCertificatesResponseSchema, 'isMinimalNonEmptyCertificatesResponse');


/**
 * @see https://github.com/fidm/x509/blob/4acca1b2919832178fd52c88f2f1ecb12a14088f/src/x509.ts#L449
 */ const $3965c8d2141fedcb$var$keyUsageMap = {
    critical: (0, $aadfb82b994af9ea$export$ef2ab10c315d4157).CRITICAL,
    cRLSign: (0, $aadfb82b994af9ea$export$ef2ab10c315d4157).CRL_SIGN,
    dataEncipherment: (0, $aadfb82b994af9ea$export$ef2ab10c315d4157).DATA_ENCIPHERMENT,
    decipherOnly: (0, $aadfb82b994af9ea$export$ef2ab10c315d4157).DECIPHER_ONLY,
    digitalSignature: (0, $aadfb82b994af9ea$export$ef2ab10c315d4157).DIGITAL_SIGNATURE,
    encipherOnly: (0, $aadfb82b994af9ea$export$ef2ab10c315d4157).ENCIPHER_ONLY,
    keyAgreement: (0, $aadfb82b994af9ea$export$ef2ab10c315d4157).KEY_AGREEMENT,
    keyCertSign: (0, $aadfb82b994af9ea$export$ef2ab10c315d4157).KEY_CERTSIGN,
    keyEncipherment: (0, $aadfb82b994af9ea$export$ef2ab10c315d4157).KEY_ENCIPHERMENT,
    nonRepudiation: (0, $aadfb82b994af9ea$export$ef2ab10c315d4157).NON_REPUDIATION
};
/**
 * @see https://github.com/fidm/x509/blob/4acca1b2919832178fd52c88f2f1ecb12a14088f/src/x509.ts#L449
 */ const $3965c8d2141fedcb$var$extendedKeyUsageMap = {
    critical: (0, $aadfb82b994af9ea$export$c89c6493e376b766).CRITICAL,
    clientAuth: (0, $aadfb82b994af9ea$export$c89c6493e376b766).CLIENT_AUTH,
    codeSigning: (0, $aadfb82b994af9ea$export$c89c6493e376b766).CODE_SIGNING,
    emailProtection: (0, $aadfb82b994af9ea$export$c89c6493e376b766).EMAIL_PROTECTION,
    OCSPSigning: (0, $aadfb82b994af9ea$export$c89c6493e376b766).OCSP_SIGNING,
    serverAuth: (0, $aadfb82b994af9ea$export$c89c6493e376b766).SERVER_AUTH,
    timeStamping: (0, $aadfb82b994af9ea$export$c89c6493e376b766).TIME_STAMPING
};
const $3965c8d2141fedcb$var$mapUsageResponse = (usagesResponse, map)=>(0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(map).reduce((usages, [name, usage])=>usagesResponse.includes(name) ? [
            ...usages,
            usage
        ] : usages, []);
const $3965c8d2141fedcb$var$mapReponse = ({ id: id, issuedBy: issuedBy, issuedTo: issuedTo, keyUsage: keyUsage, extendedKeyUsage: extendedKeyUsage, basicConstraints: basicConstraints, fingerprints: fingerprints, issuedOn: issuedOn, expiresOn: expiresOn, removable: removable })=>({
        id: id,
        issuedBy: {
            ...issuedBy,
            commonName: issuedBy.commonName || null
        },
        issuedTo: {
            ...issuedTo,
            commonName: issuedTo.commonName || null
        },
        keyUsage: $3965c8d2141fedcb$var$mapUsageResponse(keyUsage, $3965c8d2141fedcb$var$keyUsageMap),
        extendedKeyUsage: $3965c8d2141fedcb$var$mapUsageResponse(extendedKeyUsage, $3965c8d2141fedcb$var$extendedKeyUsageMap),
        basicConstraints: basicConstraints.isCA ? {
            authority: true,
            pathLength: basicConstraints.pathLength
        } : {
            authority: false
        },
        issuedOn: new Date(issuedOn),
        expiresOn: new Date(expiresOn),
        fingerprints: {
            sha1: (0, $ce8b0bc4475e8e40$export$7a32dd8b629a0529)(fingerprints.sha1, 2).join(':'),
            sha256: (0, $ce8b0bc4475e8e40$export$7a32dd8b629a0529)(fingerprints.sha256, 2).join(':')
        },
        removable: removable
    });
class $3965c8d2141fedcb$export$a8f8641209eb2f6 extends (0, $82373d578b14a603$export$f6f3d54ed66158a2) {
    fetchCertificates() {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CERTIFICATES_MANAGE,
            method: 'GET',
            path: '/api/certificates',
            authenticate: true,
            handlers: {
                200: (response)=>(0, $773d9142ff567164$export$b1a19a9e61b09890)(response, (0, $54d6da920dd2f791$export$6714e7f2e24be6a1)).then((data)=>data.map($3965c8d2141fedcb$var$mapReponse)),
                500: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, 'Could not load certificates')
            }
        });
    }
    delete({ id: id }) {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CERTIFICATES_MANAGE,
            method: 'DELETE',
            path: '/api/certificates',
            authenticate: true,
            queryParams: {
                id: id
            },
            handlers: {
                200: ()=>Promise.resolve(),
                400: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST, 'Unexpected bad request detected while deleting certificates', {
                        id: id
                    }),
                404: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).NOT_FOUND, 'Could not find certificate for deletion', {
                        id: id
                    }),
                500: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, 'Could not delete certificates', {
                        id: id
                    })
            }
        });
    }
    upload(certificateFile) {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CERTIFICATES_MANAGE,
            method: 'POST',
            path: '/api/certificates',
            authenticate: true,
            body: certificateFile,
            handlers: {
                201: (response)=>(0, $773d9142ff567164$export$b1a19a9e61b09890)(response, (0, $54d6da920dd2f791$export$a8f1eaf4da2ad9c5)).then(([cert])=>$3965c8d2141fedcb$var$mapReponse(cert)),
                400: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST, 'Unexpected bad request detected while uploading certificate')
            }
        });
    }
    fetchCertificateFileContent({ id: id }) {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CERTIFICATES_MANAGE,
            method: 'GET',
            path: '/api/certificates/content',
            authenticate: true,
            queryParams: {
                id: id
            },
            handlers: {
                200: (response)=>response.getJson(),
                400: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST, 'Unexpected bad request detected while fetching certificate file content', {
                        id: id
                    }),
                404: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).NOT_FOUND, 'Could not find certificate', {
                        id: id
                    }),
                500: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, 'Could not delete certificates', {
                        id: id
                    })
            }
        });
    }
}








class $2cb4bacd541d7c51$export$eac7a0bed07572f7 {
    /**
     * @description the utility class that assists with subscribing to Connectware HTTP endpoints
     *
     * @param retrieve the function that will retrieve the async resources
     * @param comparator the function that will compare the current and previous results
     */ constructor(retrieve, comparator){
        this.retrieve = retrieve;
        this.comparator = comparator;
        this.listeners = new (0, $9fc21cc786388d5a$export$3291343375ee8b92)();
        this.droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        this.current = null;
    }
    trigger(data) {
        this.listeners.trigger(data);
    }
    async run(trigger) {
        try {
            const data = await this.retrieve();
            /**
             * Swap previous with new value
             */ const previous = this.current || data;
            this.current = data;
            if (trigger || !this.comparator(previous, data)) this.trigger(this.current);
        } catch (e) {
            this.current = e;
            this.trigger(this.current);
        }
    }
    /**
     * Makes another fetch request
     */ update(trigger = false) {
        this.run(trigger);
    }
    /**
     * Starts the timed pulling of resources
     *
     * Do **not** call this twice without stopping it first
     *
     * @param interval in milliseconds, needs to be less than 32-bit integer
     * @see https://developer.mozilla.org/en-US/docs/Web/API/setInterval#sect1
     */ start(interval) {
        this.update(true);
        this.droppable.onDrop((0, $ad06b61c4606f6df$export$5fe74ec28e3a5524)(()=>this.update(), interval));
    }
    /**
     * Stops the previously started fetcher
     */ stop() {
        this.droppable.drop();
    }
    /**
     * @param handler will be called whenever changes are detected
     */ onChange(handler) {
        return this.listeners.on(handler);
    }
}




class $ff65752276e0ae0b$var$Filter {
    constructor(translationService){
        this.translationService = translationService;
        this.statusCache = new (0, $39a8095e56de6b13$export$94affb487e701bf2)();
        this.dateCache = new (0, $39a8095e56de6b13$export$94affb487e701bf2)();
    }
    isValueRelevant(value, search) {
        if ((0, $1041b3cad55163d4$export$a6a94a1c8dcbbdf8)(value)) {
            /**
             * Known issue:
             * If a value is supposed to be a string but happens to match a StatusType value,
             * a false positive will occur and the StatusType strategy will be used instead
             */ const label = this.statusCache.get(()=>(0, $1e2b62fb1507b421$export$a3295358bff77e)(this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).STATUS_LABEL, {
                    status: value
                })), value);
            return label.includes(search);
        }
        if (typeof value === 'number' || typeof value === 'bigint' || typeof value === 'string') return (0, $1e2b62fb1507b421$export$a3295358bff77e)(String(value)).includes(search);
        if (value instanceof Date) return this.dateCache.get(()=>(0, $1e2b62fb1507b421$export$a3295358bff77e)(this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).DATETIME, {
                type: 'datetime',
                date: value
            })), value.getTime()).includes(search);
        /** Other values should be ignored and not used for search */ return false;
    }
    isSearched(entry, search) {
        if (!search) /** No search made, then everything is relevant */ return true;
        for (const value of Object.values(entry)){
            if (this.isValueRelevant(value, search)) return true;
        }
        return false;
    }
}
class $ff65752276e0ae0b$var$AdaptedPageSubscription {
    constructor(filter, /** The current filtering options */ options, /** The actual subscription */ eventSource, /** Called when wanting to unhook */ cancel, /** By how much throttle should changes be taken */ throttle){
        this.filter = filter;
        this.options = options;
        this.cancel = cancel;
        this.rawData = null;
        this.listener = new (0, $9fc21cc786388d5a$export$3291343375ee8b92)();
        this.throttler = new (0, $2accc4d3fee5c026$export$1a6b7111629cfd6e)(throttle);
        this.off = eventSource.on((events)=>{
            this.rawData = events;
            this.scheduleRefresh();
        });
    }
    mapPage() {
        if (!this.rawData) /** No data has loaded yet, so don't do anything */ return null;
        if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(this.rawData)) return this.rawData;
        const { sort: sort, pagination: pagination, search: search } = this.options;
        const entries = [];
        const normalizedSearch = search && (0, $1e2b62fb1507b421$export$a3295358bff77e)(search);
        for (const entry of this.rawData){
            if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(entry)) /** If a single error is found, just give up */ return entry;
            if (this.filter.isSearched(entry, normalizedSearch)) entries.push(entry);
        }
        entries.sort((a, b)=>{
            let invert = a[sort.column] > b[sort.column] ? -1 : 1;
            if (sort.asc) invert *= -1;
            return invert;
        });
        return {
            page: pagination.page,
            pageSize: pagination.pageSize,
            totalCount: entries.length,
            /** Limit results to just the current page */ current: entries.slice(pagination.page * pagination.pageSize, (pagination.page + 1) * pagination.pageSize)
        };
    }
    scheduleRefresh() {
        this.throttler.run(()=>{
            const page = this.mapPage();
            if (page !== null) this.listener.trigger(page);
        });
    }
    update(options) {
        this.options = {
            ...this.options,
            ...options
        };
        this.scheduleRefresh();
    }
    onData(handler) {
        return this.listener.on(handler);
    }
    stop() {
        /** Stop internal listener */ this.off();
        /** Cancel subscription */ this.cancel();
    }
}
class $ff65752276e0ae0b$export$d1cb0a5186eff557 {
    constructor(/**
         * @deprecated This `subscribeToAll` method is considered temporary and is likely to be removed in future.
         * This method is now restricted to use here and is no longer supported for general application use
         */ subscribeToAll, translationService){
        this.subscribeToAll = subscribeToAll;
        this.translationService = translationService;
        this.throttle = 50;
    }
    async subscribeToPage(eventName, { search: search, sort: sort, pagination: pagination, ...filter }) {
        const eventLister = new (0, $9fc21cc786388d5a$export$3291343375ee8b92)();
        const entityFilter = new $ff65752276e0ae0b$var$Filter(this.translationService);
        const cancel = await this.subscribeToAll(eventName, filter, (event)=>eventLister.trigger(event));
        return new $ff65752276e0ae0b$var$AdaptedPageSubscription(entityFilter, {
            search: search,
            sort: sort,
            pagination: pagination
        }, eventLister, cancel, this.throttle);
    }
}






class $6892139a4b7aecff$export$dbc446747bfb99a8 {
    /**
     * Comparison helper to deal with possible errors being in the results
     */ static compare(oldResult, newResult, comparator) {
        return (0, $c3e1b746ad236797$export$8d524fb6540252df).is(oldResult) || (0, $c3e1b746ad236797$export$8d524fb6540252df).is(newResult) ? oldResult === newResult : comparator(oldResult, newResult);
    }
    static createErrorHandler(error) {
        return ()=>Promise.reject(error);
    }
    static createServerErrorHandler(message, extras) {
        return this.createErrorHandler(new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, message, extras));
    }
    static createServerNotAvailableHandler(message, extras) {
        return this.createErrorHandler(new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_NOT_AVAILABLE, message, extras));
    }
    static createBadRequestHandler(action) {
        return this.createErrorHandler(new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST, `Bad request detected while ${action}`));
    }
    static createJsonHandler() {
        return (response)=>response.getJson();
    }
    static createNotFoundErrorHandler(path, id) {
        return (response)=>response.getText().then((text)=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).NOT_FOUND, 'The endpoint yielded a 404 result', {
                    path: path,
                    pathParams: [
                        id
                    ],
                    text: text
                }));
    }
    constructor(request, rstAdapter){
        this.request = request;
        this.rstAdapter = rstAdapter;
        this.supportedFilters = null;
        this.supportsPagination = false;
    }
    areArrayEquals(aArr, bArr) {
        return (0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(aArr, bArr, {
            sort: false,
            equals: (a, b)=>this.areEquals(a, b)
        });
    }
    supportsFilters(filter) {
        const { supportedFilters: supportedFilters } = this;
        const presentFilters = (0, $2ae70427bab197d4$export$ed97f33186d4b816)(filter);
        return !(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(presentFilters) || Boolean(supportedFilters && presentFilters.every((f)=>supportedFilters.includes(f)));
    }
    retrieveAll(filter) {
        throw new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Method not implemented', {
            method: 'retrieveAll',
            filter: filter
        });
    }
    retrievePage(options) {
        throw new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Method not implemented', {
            method: 'retrievePage',
            options: options
        });
    }
    retrieveOne(id) {
        throw new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Method not implemented', {
            method: 'retrieveOne',
            id: id
        });
    }
    retrieveCount() {
        throw new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Method not implemented', {
            method: 'retrieveCount'
        });
    }
    compareOne(oldResult, newResult) {
        return $6892139a4b7aecff$export$dbc446747bfb99a8.compare(oldResult, newResult, (a, b)=>this.areEquals(a, b));
    }
    compareAll(oldResults, newResults) {
        return $6892139a4b7aecff$export$dbc446747bfb99a8.compare(oldResults, newResults, (a, b)=>this.areArrayEquals(a, b));
    }
    comparePage(oldPage, newPage) {
        const arePageDataEquals = (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
            totalCount: null,
            pageSize: null,
            page: null,
            current: (a, b)=>this.areArrayEquals(a, b)
        });
        return $6892139a4b7aecff$export$dbc446747bfb99a8.compare(oldPage, newPage, (a, b)=>arePageDataEquals(a, b));
    }
}


class $d08c8abe1a0e2a63$export$770394053f04d2f4 extends (0, $6892139a4b7aecff$export$dbc446747bfb99a8) {
    retrieveAll() {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_READ,
            method: 'GET',
            path: '/api/services/all-links',
            queryParams: {
                onlyFromEnabledServices: 'true'
            },
            authenticate: true,
            handlers: {
                200: (response)=>response.getJson().then((data)=>data.reduce((r, { id: id, name: name, links: links })=>(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(links) ? [
                                ...r,
                                {
                                    id: id,
                                    name: name,
                                    links: [
                                        ...links
                                    ]
                                }
                            ] : r, []))
            }
        });
    }
    constructor(...args){
        super(...args), this.areEquals = (0, $c091d3dc2d3f37db$export$4a083955540172bd), this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_READ
        ];
    }
}




const $cc2dbd258f70f429$export$ad614e9c36e65e21 = (search)=>/**
     * The backend supports regex pattern matching
     * However, it does not support all patterns and will throw errors depending on the sent string
     *
     * This replacement disables any pattern matching that a user may inadvertently activate
     * by turning non word characters into escaped chars
     */ search ? {
        searchText: search.replaceAll(/\W{1,1}/g, (match)=>`\\${match}`)
    } : {};


const $0345488ca28093f7$export$132575760c330adc = (resource, ...categories)=>categories.some((c)=>resource.category === c);
const $0345488ca28093f7$export$bc6e1b22295b1fbe = (resource, category, protocol)=>$0345488ca28093f7$export$132575760c330adc(resource, category) && resource.protocol === protocol;


/**
 * Pattern to split the first and only first hyphen
 */ const $738b86ad1f26c727$var$resourceNamePattern = /-(.*)/s;
const $738b86ad1f26c727$export$90d271a960b100ce = (id)=>{
    const [first, second] = id.split($738b86ad1f26c727$var$resourceNamePattern);
    if (first && second) /**
         * Has both, expected scenario
         */ return [
        first,
        second
    ];
    if (first && !second) /**
         * No hyphen, or a hyphen without a follow-up resource name, unexpected scenario
         */ return [
        null,
        first
    ];
    if (!first && second) /**
         * No service id
         */ return [
        null,
        second
    ];
    /**
     * Nothing, just fallback
     */ return [
        null,
        id
    ];
};
const $738b86ad1f26c727$export$451246252aec50a8 = (id)=>{
    const [, second] = $738b86ad1f26c727$export$90d271a960b100ce(id);
    return second;
};




/**
 * This is the configuration of the mapping of all topics.
 */ const $e995f059f5d1fc30$var$topicsMappingConfiguration = {
    Mapping: {
        /**
         * Topics may need to be stripped of their non MQTT standard markups
         *
         * Mappings already have their suffix, so there is no need to do anything except drop contextual information
         *
         * The topics from a mapping may come with 'foo/+bar/other/#bar'
         * And it needs to be converted to 'foo/+/other/#' so it becomes a valid mqtt topic
         *
         * The pattern below matches any MQTT topic level that starts with # or + sign, omitting from the level the non matched part
         * Turning '+foo' into '+'
         */ replacement: '(\\+|#)[^/]+',
        /** There is no suffixing that needs to happen */ suffixes: []
    },
    Node: {
        suffixes: [
            {
                operation: null,
                mode: 'in',
                level: null
            },
            {
                operation: null,
                mode: 'out',
                level: null
            },
            {
                operation: 'serverReceives',
                mode: 'in',
                level: 'read'
            },
            {
                operation: 'serverProvides',
                mode: 'out',
                level: 'write'
            },
            {
                operation: 'serverProvidesAndReceives',
                mode: 'in',
                level: 'read'
            },
            {
                operation: 'serverProvidesAndReceives',
                mode: 'out',
                level: 'write'
            },
            {
                operation: 'transaction',
                mode: 'in',
                level: 'treq'
            },
            {
                operation: 'transaction',
                mode: 'out',
                level: 'tres'
            }
        ]
    },
    Endpoint: {
        suffixes: [
            {
                operation: 'subscribe',
                mode: 'in',
                level: null
            },
            {
                operation: 'write',
                mode: 'in',
                level: 'set'
            },
            {
                operation: 'write',
                mode: 'out',
                level: 'res'
            },
            {
                operation: 'read',
                mode: 'in',
                level: 'req'
            },
            {
                operation: 'read',
                mode: 'out',
                level: 'res'
            }
        ]
    }
};
class $e995f059f5d1fc30$export$ed05c84a2e8a2f13 {
    static getSupportedCategories() {
        return (0, $2ae70427bab197d4$export$ed97f33186d4b816)($e995f059f5d1fc30$var$topicsMappingConfiguration);
    }
    static create(category) {
        return new $e995f059f5d1fc30$export$ed05c84a2e8a2f13(category, undefined, undefined);
    }
    constructor(category, operation, mode){
        this.category = category;
        this.operation = operation;
        this.mode = mode;
    }
    get configuration() {
        return $e995f059f5d1fc30$var$topicsMappingConfiguration[this.category];
    }
    processTopic(topic) {
        return 'replacement' in this.configuration ? topic.replaceAll(new RegExp(this.configuration.replacement, 'g'), '$1') : topic;
    }
    /**
     * Yields the given array while ensuring it has not exceeded the max size
     */ createTopicsWithMaxSize(topics, maxSize) {
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(topics.length <= maxSize, /**
             * Yielded topics are already over the expected limit
             */ new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).MAPPING_ERROR, 'Unexpected amount of topics was mapped', {
            category: this.category,
            operation: this.operation,
            mode: this.mode,
            expectedSize: maxSize,
            topics: topics
        }));
        return topics;
    }
    createTopicsWithSuffixes(topic, maxSize) {
        let out = [];
        for (const { operation: operation, mode: mode, level: level } of this.configuration.suffixes){
            if (this.operation !== undefined && this.operation !== operation || this.mode !== undefined && this.mode !== mode) continue;
            /** Null level, means no suffix to add */ const finalTopic = level === null ? topic : `${topic}/${level}`;
            if (!out.includes(finalTopic)) out = this.createTopicsWithMaxSize([
                ...out,
                finalTopic
            ], maxSize);
        }
        return out;
    }
    mapTopics(topic, maxSize, capture) {
        try {
            const processedTopic = this.processTopic(topic);
            return this.configuration.suffixes.length === 0 ? this.createTopicsWithMaxSize([
                processedTopic
            ], maxSize) : this.createTopicsWithSuffixes(processedTopic, maxSize);
        } catch (e) {
            return (0, $ea3ab9f98af64a6e$export$7914be4505ea8cc6)(e, capture);
        }
    }
    withOperation(operation) {
        return new $e995f059f5d1fc30$export$ed05c84a2e8a2f13(this.category, operation, undefined);
    }
    withMode(mode) {
        return new $e995f059f5d1fc30$export$ed05c84a2e8a2f13(this.category, this.operation, mode);
    }
    mapAll(topic) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        return this.mapTopics(topic, Infinity, this.mapAll);
    }
    /**
     * @throws if more than or less than one topic was yielded
     */ mapSingle(topic) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const [firstTopic] = this.mapTopics(topic, 1, this.mapSingle);
        return firstTopic;
    }
}








const $21d8aee6197898f1$var$recursivelyMapPlainProperties = (props, parts = [])=>(0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(props).reduce((r, [name, value])=>{
        const newParts = [
            ...parts,
            name
        ];
        return {
            ...r,
            ...(0, $66f4d76e5f79376d$export$8afc0f4daad61937)(value) ? $21d8aee6197898f1$var$recursivelyMapPlainProperties(value, newParts) : {
                [newParts.join('.')]: String(value)
            }
        };
    }, {});
const $21d8aee6197898f1$export$26b0f3afe296e7bb = (props)=>$21d8aee6197898f1$var$recursivelyMapPlainProperties(props);


const $fb6b2c79c0cbfdb7$export$59545aa1378f3baa = (pagination)=>pagination.nextPage <= pagination.pageNumber;
/**
 * Since backend starts counting pages at one,
 * an offset needs to be calculated both before it's sent to the BE and when received from the backend
 */ const $fb6b2c79c0cbfdb7$var$pageOffset = 1;
const $fb6b2c79c0cbfdb7$export$14c1d8d9259bdf0d = ({ page: page, pageSize: pageSize })=>({
        page: `${page + $fb6b2c79c0cbfdb7$var$pageOffset}`,
        itemsPerPage: `${pageSize}`
    });
const $fb6b2c79c0cbfdb7$export$7db51cb9b83d25e6 = (pagination)=>({
        totalCount: pagination.totalRows,
        page: pagination.pageNumber - $fb6b2c79c0cbfdb7$var$pageOffset,
        pageSize: pagination.rowsPerPage
    });




const $dc10c690fa4fdaca$export$6df6db801c9b3f10 = (sortableColumns)=>{
    const getSupportedColumns = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>(0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(sortableColumns).reduce((m, [domainColumn, backendColumn])=>backendColumn ? m.set(domainColumn, backendColumn) : m, new Map()));
    return (sort)=>{
        const supportedColumns = getSupportedColumns();
        const orderBy = supportedColumns.get(sort.column);
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(orderBy, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Sorting by this column is not supported', {
            sort: sort.column,
            sortable: Array.from(supportedColumns.keys()).sort()
        }));
        return {
            order: sort.asc ? 'ASC' : 'DESC',
            orderBy: orderBy
        };
    };
};


/**
 * Helper class to address the need to fetch async information
 * in order to map domain entities
 */ class $195c58f1baeb0d9e$export$e27f484a92d28d12 {
    constructor(fetchAux){
        this.fetchAux = fetchAux;
        this.promises = [];
    }
    get values() {
        return Promise.all(this.promises).then((results)=>results.filter((r)=>r !== null));
    }
    push(resource) {
        this.promises.push(Promise.resolve(this.map(resource)));
    }
}





class $c359a5294871e0ba$export$b1e5a060881bf246 extends (0, $6892139a4b7aecff$export$dbc446747bfb99a8) {
    async retrieveOne(id) {
        return Promise.all([
            this.request({
                ...this.baseRequest,
                pathParams: [
                    id
                ],
                authenticate: true,
                handlers: {
                    200: (r)=>r.getJson().then(({ data: data })=>{
                            (0, $14eddac5f20c576c$export$a7a9523472993e97)((0, $0345488ca28093f7$export$132575760c330adc)(data, this.resourceCategory), new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).MAPPING_ERROR, 'Unexpected resource category', {
                                expected: this.resourceCategory,
                                actual: data.category
                            }));
                            return data;
                        }),
                    404: $c359a5294871e0ba$export$b1e5a060881bf246.createNotFoundErrorHandler('/api/v2/resources/+', id),
                    500: $c359a5294871e0ba$export$b1e5a060881bf246.createServerErrorHandler(this.notFoundMessage)
                }
            }),
            this.rstAdapter.fetchStatusType(this.resourceStatusType, id)
        ]).then(([resource, status])=>this.mapResource(resource, status));
    }
    createSingleChangeListener(id, handler) {
        return this.rstAdapter.subscribeToStatusType(this.resourceStatusType, id, handler);
    }
}
class $c359a5294871e0ba$var$ResourceMapper extends (0, $195c58f1baeb0d9e$export$e27f484a92d28d12) {
    constructor(mapResource, ...args){
        super(...args), this.mapResource = mapResource;
    }
    map(resource) {
        return this.fetchAux(resource.resourceId).then((aux)=>this.mapResource(resource, aux));
    }
}
class $c359a5294871e0ba$export$46344bfd0e39f75d extends (0, $6892139a4b7aecff$export$dbc446747bfb99a8) {
    retrievePage({ search: search, sort: sort, pagination: pagination, ...filter }) {
        const mapSort = (0, $dc10c690fa4fdaca$export$6df6db801c9b3f10)(this.sortingColumns);
        const args = {
            authenticate: true,
            queryParams: {
                categories: this.resourceCategories,
                ...(0, $fb6b2c79c0cbfdb7$export$14c1d8d9259bdf0d)(pagination),
                ...mapSort(sort),
                ...this.createCustomQueryParameters?.(filter),
                ...(0, $cc2dbd258f70f429$export$ad614e9c36e65e21)(search),
                /**
                 * Only enabled resources are wanted
                 * Disabled resources should be ignored by the UI
                 */ onlyFromEnabledServices: 'true'
            },
            handlers: {
                200: async (response)=>{
                    const { data: data, meta: meta } = await response.getJson();
                    const mapper = new $c359a5294871e0ba$var$ResourceMapper((resource, aux)=>this.mapResource(resource, aux), (resourceId)=>this.fetchAux(resourceId));
                    for (const resource of data){
                        (0, $14eddac5f20c576c$export$a7a9523472993e97)((0, $0345488ca28093f7$export$132575760c330adc)(resource, ...this.resourceCategories), new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).MAPPING_ERROR, 'Unexpected resource category', {
                            category: resource.category,
                            expected: this.resourceCategories
                        }));
                        mapper.push(resource);
                    }
                    return {
                        current: await mapper.values,
                        ...(0, $fb6b2c79c0cbfdb7$export$7db51cb9b83d25e6)(meta.pagination)
                    };
                },
                400: $c359a5294871e0ba$export$46344bfd0e39f75d.createBadRequestHandler('fetching resources'),
                500: $c359a5294871e0ba$export$46344bfd0e39f75d.createServerErrorHandler(this.serverErrorMessage)
            }
        };
        return filter.service ? this.request({
            ...this.serviceResourcesRequestConfig,
            pathParams: [
                filter.service
            ],
            ...args
        }) : this.request({
            ...this.allResourcesRequestConfig,
            ...args
        });
    }
    constructor(...args){
        super(...args), this.supportsPagination = true;
    }
}
class $c359a5294871e0ba$export$3a0e060fb015fbe5 extends $c359a5294871e0ba$export$46344bfd0e39f75d {
    fetchAux(resourceId) {
        return this.rstAdapter.fetchStatusType(this.resourceStatusType, resourceId);
    }
    createAllChangeListener({ service: service }, handler) {
        const [allServices, specificService] = this.serviceDeviationsType;
        if (!service) /** Subscribe to deviations across all services */ return this.rstAdapter.subscribeToServicesDeviationsCount(allServices, handler);
        /** Subscribe to deviations on the service used as filter for this listing of resources */ return this.rstAdapter.subscribeToServiceDeviationsCount(specificService, service, handler);
    }
}


const $9cccffcb19469fd8$var$resourceTypesMap = {
    Endpoint: (0, $d7e1ff559b364dab$export$b459d70d11da43d5).ENDPOINT,
    Mapping: (0, $d7e1ff559b364dab$export$b459d70d11da43d5).MAPPING,
    Node: (0, $d7e1ff559b364dab$export$b459d70d11da43d5).NODE
};
class $9cccffcb19469fd8$export$fd2c8d6d31302c92 extends (0, $c359a5294871e0ba$export$46344bfd0e39f75d) {
    get allResourcesRequestConfig() {
        throw new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Fetching service resources without a service is not supported');
    }
    fetchAux() {
        return Promise.resolve();
    }
    mapResource(resource) {
        const topicsMapper = (0, $e995f059f5d1fc30$export$ed05c84a2e8a2f13).create(resource.category);
        let topics;
        switch(resource.category){
            case 'Endpoint':
            case 'Node':
                topics = topicsMapper.withOperation(resource.resourceConfig.args.operation).mapAll(resource.resourceConfig.args.topic);
                break;
            case 'Mapping':
                topics = resource.resourceConfig.args.mappings.flatMap(({ subscribe: subscribe, publish: publish })=>[
                        ...subscribe,
                        publish
                    ].map((ps)=>topicsMapper.mapSingle(ps.topic)));
                break;
        }
        return {
            id: resource.resourceId,
            type: $9cccffcb19469fd8$var$resourceTypesMap[resource.category],
            topics: [
                ...topics
            ].sort()
        };
    }
    constructor(...args){
        super(...args), this.areEquals = (0, $d7e1ff559b364dab$export$a6d965fc5a510a2a), this.supportedFilters = [
            'service'
        ], this.serviceResourcesRequestConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_SUBSCRIPTION_METADATA,
            path: '/api/v2/services/+/resources',
            method: 'GET'
        }, this.resourceCategories = (0, $2ae70427bab197d4$export$ed97f33186d4b816)($9cccffcb19469fd8$var$resourceTypesMap), this.serverErrorMessage = 'There was an issue while fetching data resources', this.sortingColumns = {
            id: 'resourceId',
            type: 'category'
        }, this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_SUBSCRIPTION_METADATA
        ];
    }
}








const $e5a647afcb2f396b$export$81c07208ffa80459 = ({ serviceId: serviceId, name: name, currentState: currentState, version: version }, isDeviated)=>{
    const status = (0, $f8e1ae5c3f1d25ae$export$eb25faf9da40860f)(currentState);
    return {
        id: serviceId,
        name: name,
        version: version || null,
        status: status,
        deviation: isDeviated ? (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DEVIATED : status === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISABLED ? (0, $1041b3cad55163d4$export$e35c1996c6f482ad).NOT_ENABLED : (0, $1041b3cad55163d4$export$e35c1996c6f482ad).NO_DEVIATION
    };
};





/**
 * Return 0 if service is disabled (no resources available), otherwise return count
 */ const $c1f6edddb12bf729$var$getAvailableResourceCount = (currentState, count)=>currentState === (0, $1041b3cad55163d4$export$e35c1996c6f482ad).DISABLED ? 0 : count;
const $c1f6edddb12bf729$export$ef558886d570d928 = ({ serviceId: serviceId, name: name, version: version, currentState: currentState, description: description, icon: icon, provider: provider, parameters: parameters, mappingCount: mappingCount, volumeCount: volumeCount, serverCount: serverCount, nodeCount: nodeCount, containerCount: containerCount, connectionCount: connectionCount, endpointCount: endpointCount, roleCount: roleCount, userCount: userCount, ingressRouteCount: ingressRouteCount }, links, { dependent: dependent, dependsOn: dependsOn }, resourceDeviationsCount)=>{
    const domainService = {
        ...(0, $e5a647afcb2f396b$export$81c07208ffa80459)({
            serviceId: serviceId,
            name: name,
            version: version,
            currentState: currentState
        }, resourceDeviationsCount > 0),
        links: [
            ...links
        ]
    };
    return {
        ...domainService,
        version: domainService.version || null,
        description: description.trim(),
        icon: icon || null,
        provider: provider || null,
        configuredResources: {
            connections: connectionCount,
            containers: containerCount,
            endpoints: endpointCount,
            mappings: mappingCount,
            roles: roleCount,
            routes: ingressRouteCount,
            servers: serverCount,
            nodes: nodeCount,
            users: userCount,
            volumes: volumeCount
        },
        availableResources: {
            mappings: $c1f6edddb12bf729$var$getAvailableResourceCount(domainService.status, mappingCount),
            volumes: $c1f6edddb12bf729$var$getAvailableResourceCount(domainService.status, volumeCount),
            servers: $c1f6edddb12bf729$var$getAvailableResourceCount(domainService.status, serverCount),
            nodes: $c1f6edddb12bf729$var$getAvailableResourceCount(domainService.status, nodeCount),
            containers: $c1f6edddb12bf729$var$getAvailableResourceCount(domainService.status, containerCount),
            connections: $c1f6edddb12bf729$var$getAvailableResourceCount(domainService.status, connectionCount),
            endpoints: $c1f6edddb12bf729$var$getAvailableResourceCount(domainService.status, endpointCount)
        },
        /** Id should not be passed on the parameters */ parameters: (0, $2ae70427bab197d4$export$12b617052eb9d30e)(parameters, 'id'),
        resourceDeviationsCount: resourceDeviationsCount,
        dependencies: {
            dependent: [
                ...dependent
            ],
            dependsOn: [
                ...dependsOn
            ]
        }
    };
};




const $6322825ce5cae19a$var$mapSort = (0, $dc10c690fa4fdaca$export$6df6db801c9b3f10)({
    deviation: null,
    id: 'serviceId',
    name: 'name',
    status: 'currentState',
    version: 'version'
});
class $6322825ce5cae19a$export$2eba23c0268d20ef extends (0, $6892139a4b7aecff$export$dbc446747bfb99a8) {
    async retrievePage({ pagination: pagination, search: search, sort: sort }) {
        const queryParams = {
            ...(0, $fb6b2c79c0cbfdb7$export$14c1d8d9259bdf0d)(pagination),
            ...$6322825ce5cae19a$var$mapSort(sort),
            ...(0, $cc2dbd258f70f429$export$ad614e9c36e65e21)(search)
        };
        const [linksByService, { data: data, meta: meta }] = await Promise.all([
            this.request({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_READ,
                method: 'GET',
                path: '/api/services/all-links',
                queryParams: {
                    onlyFromEnabledServices: 'true'
                },
                authenticate: true,
                handlers: {
                    200: (response)=>response.getJson().then((data)=>data.reduce((r, linkedService)=>({
                                    ...r,
                                    [linkedService.id]: [
                                        ...linkedService.links
                                    ]
                                }), {}))
                }
            }),
            this.request({
                path: '/api/v2/services',
                method: 'GET',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_READ,
                authenticate: true,
                queryParams: queryParams,
                handlers: {
                    200: $6322825ce5cae19a$export$2eba23c0268d20ef.createJsonHandler(),
                    500: $6322825ce5cae19a$export$2eba23c0268d20ef.createServerErrorHandler('Could not fetch services')
                }
            })
        ]);
        return {
            current: await Promise.all(data.map(async (service)=>({
                    ...(0, $e5a647afcb2f396b$export$81c07208ffa80459)(service, Boolean(await this.rstAdapter.fetchServiceDeviationsCount('services', service.serviceId))),
                    links: linksByService[service.serviceId] ?? []
                }))),
            ...(0, $fb6b2c79c0cbfdb7$export$7db51cb9b83d25e6)(meta.pagination)
        };
    }
    async retrieveCount() {
        return this.request({
            path: '/api/v2/services/stats/count',
            method: 'GET',
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_READ,
            authenticate: true,
            handlers: {
                200: (response)=>response.getJson().then((j)=>j.data.servicesCount),
                500: $6322825ce5cae19a$export$2eba23c0268d20ef.createServerErrorHandler('Could not fetch services count')
            }
        });
    }
    createAllChangeListener(_, handler) {
        /**
         * Deviation changes should be detected so the state is as up to date as it can
         */ return this.rstAdapter.subscribeToServicesDeviationsCount('services', handler);
    }
    constructor(...args){
        super(...args), this.areEquals = (0, $c091d3dc2d3f37db$export$23b70a04b71a1733), this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_READ
        ], this.supportsPagination = true;
    }
}





class $4037f67af812c539$export$4ba77de14e305898 extends (0, $6892139a4b7aecff$export$dbc446747bfb99a8) {
    async retrieveOne(id) {
        const service = this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ,
            method: 'GET',
            path: '/api/v2/services/+',
            authenticate: true,
            pathParams: [
                id
            ],
            handlers: {
                200: (r)=>r.getJson().then(({ data: data })=>data),
                404: $4037f67af812c539$export$4ba77de14e305898.createNotFoundErrorHandler('/api/v2/services/+', id),
                500: $4037f67af812c539$export$4ba77de14e305898.createServerErrorHandler('Could not fetch service', {
                    id: id
                })
            }
        });
        const others = Promise.all([
            this.request({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ,
                method: 'GET',
                path: '/api/services/all-links',
                queryParams: {
                    onlyFromEnabledServices: 'true'
                },
                authenticate: true,
                handlers: {
                    200: (r)=>r.getJson().then((data)=>data.find((s)=>s.id === id)?.links ?? [])
                }
            }),
            this.request({
                path: '/api/services/+/dependencies',
                method: 'GET',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ,
                pathParams: [
                    id
                ],
                authenticate: true,
                handlers: {
                    200: (r)=>r.getJson(),
                    404: $4037f67af812c539$export$4ba77de14e305898.createNotFoundErrorHandler('/api/services/+/dependencies', id)
                }
            }),
            this.rstAdapter.fetchServiceDeviationsCount('service', id)
        ]).then((value)=>({
                value: value
            }), (error)=>({
                error: error
            }));
        /**
         * The service's own request is awaited first, so its error wins over the others':
         * a missing service's dependencies fail with a server error, which can arrive before the service's not found
         */ const params = await service;
        const result = await others;
        if ('error' in result) throw result.error;
        const [links, dependencies, resourceDeviationsCount] = result.value;
        return (0, $c1f6edddb12bf729$export$ef558886d570d928)(params, links, dependencies, resourceDeviationsCount);
    }
    createSingleChangeListener(id, handler) {
        return this.rstAdapter.subscribeToServiceDeviationsCount('service', id, handler);
    }
    constructor(...args){
        super(...args), this.areEquals = (0, $c091d3dc2d3f37db$export$956c8f416cd2f31a), this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ
        ];
    }
}







class $24b75f212abeefca$export$e964147f43078eba extends (0, $6892139a4b7aecff$export$dbc446747bfb99a8) {
    retrievePage({ pagination: pagination, search: search, sort: sort }) {
        const mapSort = (0, $dc10c690fa4fdaca$export$6df6db801c9b3f10)(this.sortingColumns);
        return this.request({
            path: '/api/v2/resources/states/deviations/services',
            method: 'GET',
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).DEVIATIONS_READ,
            authenticate: true,
            queryParams: {
                ...(0, $fb6b2c79c0cbfdb7$export$14c1d8d9259bdf0d)(pagination),
                ...mapSort(sort),
                ...(0, $cc2dbd258f70f429$export$ad614e9c36e65e21)(search)
            },
            handlers: {
                200: async (response)=>{
                    const { data: data, meta: meta } = await response.getJson();
                    const deviated = [];
                    for (const response of data)deviated.push(await this.mapToDomain(response));
                    return {
                        current: deviated,
                        ...(0, $fb6b2c79c0cbfdb7$export$7db51cb9b83d25e6)(meta.pagination)
                    };
                },
                400: $24b75f212abeefca$export$e964147f43078eba.createBadRequestHandler('fetching deviated services'),
                500: $24b75f212abeefca$export$e964147f43078eba.createServerErrorHandler(this.errorMessage),
                503: $24b75f212abeefca$export$e964147f43078eba.createServerNotAvailableHandler('Resources Status Tracking is not running as expected')
            }
        });
    }
    createAllChangeListener(_, handler) {
        /**
         * Subscribes to deviations popping up and going away
         */ return this.rstAdapter.subscribeToServicesDeviationsCount(this.deviationsSupportedType, handler);
    }
    constructor(...args){
        super(...args), this.supportsPagination = true, this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).DEVIATIONS_READ
        ];
    }
}


class $11b21f10e4a2062a$export$18926fcd1ea1157d extends (0, $24b75f212abeefca$export$e964147f43078eba) {
    mapToDomain({ serviceId: serviceId }) {
        return Promise.resolve({
            id: serviceId
        });
    }
    constructor(...args){
        super(...args), this.deviationsSupportedType = 'serviceDeviations', this.errorMessage = 'Could not fetch service deviations', this.sortingColumns = {
            id: 'serviceId'
        }, this.areEquals = (0, $940a6604ef0427ec$export$6105be03e969654c);
    }
}






class $b72f066ddb1efe4d$export$46de32891fbf03f0 extends (0, $6892139a4b7aecff$export$dbc446747bfb99a8) {
    async retrieveAll({ service: service }) {
        const deviations = [];
        let isDone = false;
        let page = 0;
        while(!isDone){
            const queryParams = {
                page: `${page + 1}`
            };
            if (service) queryParams.serviceIds = [
                service
            ];
            const [additions, isLast] = await this.request({
                path: '/api/v2/resources/states/deviations',
                method: 'GET',
                authenticate: true,
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).DEVIATIONS_READ,
                queryParams: queryParams,
                handlers: {
                    200: async (response)=>{
                        const { data: data, meta: meta } = await response.getJson();
                        return [
                            data.map(({ resource: { id: id }, info: info, state: { current: current, desired: desired } })=>({
                                    actual: (0, $f8e1ae5c3f1d25ae$export$eb25faf9da40860f)(current),
                                    expected: (0, $f8e1ae5c3f1d25ae$export$eb25faf9da40860f)(desired),
                                    resourceId: id,
                                    reason: info || null
                                })),
                            (0, $fb6b2c79c0cbfdb7$export$59545aa1378f3baa)(meta.pagination)
                        ];
                    },
                    503: $b72f066ddb1efe4d$export$46de32891fbf03f0.createServerNotAvailableHandler('Resources Status Tracking is not running as expected')
                }
            });
            deviations.push(...additions);
            isDone = isLast;
            page++;
        }
        return deviations;
    }
    createAllChangeListener({ service: service }, handler) {
        if (!service) /** Subscribe to deviations across all services */ return this.rstAdapter.subscribeToServicesDeviationsCount('resourceDeviation', handler);
        /** Subscribe to deviations on the service used as filter for this listing of resources */ return this.rstAdapter.subscribeToServiceDeviationsCount('resourceDeviation', service, handler);
    }
    constructor(...args){
        super(...args), this.supportedFilters = [
            'service'
        ], this.areEquals = (0, $940a6604ef0427ec$export$17ec1c9b9eabc75c), this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).DEVIATIONS_READ
        ];
    }
}




class $cc9fc14d78211249$export$2f57934c05a8f6b6 extends (0, $24b75f212abeefca$export$e964147f43078eba) {
    mapToDomain({ serviceId: serviceId, count: count }) {
        return this.request({
            path: '/api/v2/services/+',
            method: 'GET',
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).DEVIATIONS_READ,
            authenticate: true,
            pathParams: [
                serviceId
            ],
            handlers: {
                200: (response)=>response.getJson().then(({ data: { name: name, version: version } })=>({
                            id: serviceId,
                            name: name,
                            version: version,
                            resourceDeviationsCount: count
                        })),
                404: $cc9fc14d78211249$export$2f57934c05a8f6b6.createNotFoundErrorHandler('/api/v2/services/+', serviceId),
                500: $cc9fc14d78211249$export$2f57934c05a8f6b6.createServerErrorHandler(this.errorMessage, {
                    serviceId: serviceId
                })
            }
        });
    }
    constructor(...args){
        super(...args), this.deviationsSupportedType = 'deviatedServices', this.errorMessage = 'Could not fetch deviated services', this.sortingColumns = {
            id: 'serviceId',
            name: null,
            version: null,
            resourceDeviationsCount: null
        }, this.areEquals = (0, $c091d3dc2d3f37db$export$29e593b5864265d1);
    }
}







const $4e4412e6627f9b6a$export$34df5378ff4a1a2d = ({ resourceId: resourceId, serviceId: serviceId, resourceConfig: { args: args }, protocol: protocol, runnerName: runnerName })=>({
        id: resourceId,
        name: (0, $738b86ad1f26c727$export$451246252aec50a8)(resourceId),
        service: serviceId,
        operation: args.operation,
        protocol: protocol,
        agent: runnerName || null
    });


class $024fc8c98834131b$export$b757d1d01dc76ad7 extends (0, $c359a5294871e0ba$export$3a0e060fb015fbe5) {
    mapResource(resource, status) {
        return {
            ...(0, $4e4412e6627f9b6a$export$34df5378ff4a1a2d)(resource),
            connection: resource.parentResourceId,
            status: status
        };
    }
    createCustomQueryParameters({ connection: connection }) {
        return connection ? {
            parentResourceId: connection
        } : {};
    }
    constructor(...args){
        super(...args), this.supportedFilters = [
            'service',
            'connection'
        ], this.areEquals = (0, $20a95c68bb34987c$export$20395fc2f5195912), this.serviceResourcesRequestConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_READ,
            path: '/api/v2/services/+/resources',
            method: 'GET'
        }, this.allResourcesRequestConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_READ,
            path: '/api/v2/resources',
            method: 'GET'
        }, this.resourceCategories = [
            'Endpoint'
        ], this.resourceStatusType = 'endpoints', this.serviceDeviationsType = [
            'endpoints',
            'endpoints'
        ], this.serverErrorMessage = 'Could not fetch endpoints', this.sortingColumns = {
            agent: 'runnerName',
            connection: 'parentResourceId',
            id: 'resourceId',
            name: 'resourceName',
            operation: null,
            protocol: 'protocol',
            service: 'serviceId',
            status: null
        }, this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_READ
        ];
    }
}







const $7871154e241a8a99$var$isExpectedAddressValueType = (value)=>Boolean(typeof value === 'number' || typeof value === 'boolean' || typeof value === 'string' || value && typeof value === 'object' && Object.values(value).every((v)=>typeof v === 'string'));
const $7871154e241a8a99$var$isExpectedAddressType = (address)=>typeof address === 'object' && (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(address).every(([key, value])=>typeof key === 'string' && $7871154e241a8a99$var$isExpectedAddressValueType(value));
const $7871154e241a8a99$var$mapToAddress = (address)=>{
    (0, $14eddac5f20c576c$export$a7a9523472993e97)($7871154e241a8a99$var$isExpectedAddressType(address), new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).MAPPING_ERROR, 'Unexpected address type', address));
    return address;
};
class $7871154e241a8a99$export$ee5a2870e5efd7a2 extends (0, $c359a5294871e0ba$export$b1e5a060881bf246) {
    mapResource(endpoint, status) {
        return {
            ...(0, $4e4412e6627f9b6a$export$34df5378ff4a1a2d)(endpoint),
            address: $7871154e241a8a99$var$mapToAddress(endpoint.resourceConfig.args.address),
            rules: endpoint.resourceConfig.args.rules || null,
            topics: (0, $e995f059f5d1fc30$export$ed05c84a2e8a2f13).create(endpoint.category).withOperation(endpoint.resourceConfig.args.operation).mapAll(endpoint.resourceConfig.args.topic),
            status: status
        };
    }
    constructor(...args){
        super(...args), this.areEquals = (0, $20a95c68bb34987c$export$dd7dae8c7d9140f3), this.resourceCategory = 'Endpoint', this.notFoundMessage = 'Could not fetch endpoint', this.resourceStatusType = 'endpoint', this.baseRequest = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINT_READ,
            method: 'GET',
            path: '/api/v2/resources/+'
        }, this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINT_READ
        ];
    }
}








const $46e354e45dd87302$export$c1a6921bf3ecd5ac = ({ CreatedAt: CreatedAt, Name: Name })=>{
    const [service, name] = (0, $738b86ad1f26c727$export$90d271a960b100ce)(Name);
    return {
        name: name,
        id: Name,
        service: service,
        created: new Date(CreatedAt),
        status: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ONLINE
    };
};


class $c8a3318494e4c1c3$export$133ea2c73f5c795b extends (0, $6892139a4b7aecff$export$dbc446747bfb99a8) {
    retrieveAll({ service: service }) {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).VOLUMES_READ,
            method: 'GET',
            path: '/api/volumes',
            authenticate: true,
            handlers: {
                200: (response)=>response.getJson().then(({ Volumes: [...Volumes] })=>Volumes.reduce((r, volume)=>{
                            const cybusVolume = (0, $46e354e45dd87302$export$c1a6921bf3ecd5ac)(volume);
                            return service && service !== cybusVolume.service ? r : [
                                ...r,
                                cybusVolume
                            ];
                        }, []))
            }
        });
    }
    constructor(...args){
        super(...args), this.supportedFilters = [
            'service'
        ], this.areEquals = (0, $73c1dcd3ec66dcf5$export$3b5e9855d93c8fe), this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).VOLUMES_READ
        ];
    }
}





class $a1e0baf9d31b829e$export$e409388fee521255 extends (0, $6892139a4b7aecff$export$dbc446747bfb99a8) {
    retrieveOne(id) {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).VOLUME_READ,
            method: 'GET',
            path: '/api/volumes/+/inspect',
            pathParams: [
                id
            ],
            authenticate: true,
            handlers: {
                200: (response)=>response.getJson().then((data)=>({
                            ...(0, $46e354e45dd87302$export$c1a6921bf3ecd5ac)(data),
                            labels: data.Labels
                        })),
                404: $a1e0baf9d31b829e$export$e409388fee521255.createNotFoundErrorHandler('/api/volumes/+/inspect', id)
            }
        });
    }
    constructor(...args){
        super(...args), this.areEquals = (0, $73c1dcd3ec66dcf5$export$aa42524e4e8e2e63), this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).VOLUME_READ
        ];
    }
}












const $fc7dac50f79bad84$export$18ad9e9eacde88d1 = ({ Running: Running, Paused: Paused, Restarting: Restarting, Dead: Dead, StartedAt: StartedAt, FinishedAt: FinishedAt, Status: Status })=>{
    if (Running) {
        if (Paused) return {
            status: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).PAUSED,
            lastUpdate: new Date(StartedAt)
        };
        if (Restarting) return {
            status: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).RESTARTING,
            lastUpdate: new Date(FinishedAt)
        };
        return {
            status: (0, $1041b3cad55163d4$export$e35c1996c6f482ad).RUNNING,
            lastUpdate: new Date(StartedAt)
        };
    }
    if (Dead || !StartedAt || !FinishedAt) /**
         * https://i.imgur.com/MPbX6OD.jpg
         */ return {
        status: (0, $f8e1ae5c3f1d25ae$export$eb25faf9da40860f)(Status),
        lastUpdate: null
    };
    return {
        status: (0, $f8e1ae5c3f1d25ae$export$eb25faf9da40860f)(Status),
        lastUpdate: new Date(FinishedAt)
    };
};


class $e3f7c4c7f88621ec$export$442559cb67187a55 extends (0, $6892139a4b7aecff$export$dbc446747bfb99a8) {
    retrieveAll(filter) {
        const { mapIdAux: mapIdAux, mapListContainer: mapListContainer, containersOrchestratorConfig: containersOrchestratorConfig, containersConfig: containersConfig, containerMetadataConfig: containerMetadataConfig } = this;
        if (!mapIdAux || !mapListContainer || !containersOrchestratorConfig || !containersConfig || !containerMetadataConfig) /** Not operating in fetch all mode */ return super.retrieveAll(filter);
        /** Lazily fetch and cache whether the orchestrator is Docker */ this.isDocker = this.isDocker ?? this.request({
            ...containersOrchestratorConfig,
            authenticate: true,
            handlers: {
                200: (response)=>response.getJson().then((data)=>data.orchestrator === 'Docker'),
                503: $e3f7c4c7f88621ec$export$442559cb67187a55.createServerErrorHandler('Could not fetch container metadata')
            }
        });
        return this.request({
            ...containersConfig,
            authenticate: true,
            handlers: {
                200: $e3f7c4c7f88621ec$export$442559cb67187a55.createJsonHandler()
            }
        }).then((containers)=>Promise.all(containers.map(async ({ Names: Names, Names: [firstName], State: State })=>{
                (0, $14eddac5f20c576c$export$a7a9523472993e97)(firstName, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).MAPPING_ERROR, 'Names in container not in expected format', {
                    Names: Names
                }));
                // Name starts with a slash, this removes it
                const id = firstName.slice(1);
                const idAux = mapIdAux(id, filter);
                if (idAux === null) // Can give up on this container as it is not relevant for this search
                return null;
                const [inspectionMetadata, isDocker] = await Promise.all([
                    this.request({
                        ...containerMetadataConfig,
                        pathParams: [
                            id
                        ],
                        authenticate: true,
                        handlers: {
                            200: $e3f7c4c7f88621ec$export$442559cb67187a55.createJsonHandler(),
                            404: $e3f7c4c7f88621ec$export$442559cb67187a55.createNotFoundErrorHandler(containerMetadataConfig.path, id)
                        }
                    }),
                    this.isDocker
                ]);
                return mapListContainer({
                    id: id,
                    created: inspectionMetadata.Created ? new Date(inspectionMetadata.Created) : null,
                    ...!isDocker ? {
                        status: (0, $f8e1ae5c3f1d25ae$export$eb25faf9da40860f)(State?.toLowerCase()),
                        lastUpdate: null
                    } : (0, $fc7dac50f79bad84$export$18ad9e9eacde88d1)(inspectionMetadata.State)
                }, idAux, inspectionMetadata);
            }))).then((containers)=>containers.filter((c)=>c !== null));
    }
    retrieveOne(id) {
        const { mapSingleRetrieval: mapSingleRetrieval, singleContainerConfig: singleContainerConfig } = this;
        if (!mapSingleRetrieval || !singleContainerConfig) /** Not operating in fetch single mode */ return super.retrieveOne(id);
        return this.request({
            ...singleContainerConfig,
            pathParams: [
                id
            ],
            authenticate: true,
            handlers: {
                200: (response)=>response.getJson().then((data)=>mapSingleRetrieval(id, data)),
                404: $e3f7c4c7f88621ec$export$442559cb67187a55.createNotFoundErrorHandler(singleContainerConfig.path, id)
            }
        });
    }
    constructor(...args){
        super(...args), /** Cache of the orchestrator */ this.isDocker = null;
    }
}






const $01bb05b8237dc7d5$export$23237ea46daa77ea = (id, name, container)=>{
    const { Created: Created, Mounts: Mounts, Config: Config, HostConfig: HostConfig } = container;
    const { Image: Image, WorkingDir: WorkingDir, Labels: Labels, ExposedPorts: ExposedPorts = {}, Env: Env } = Config;
    return {
        id: id,
        name: name,
        created: Created ? new Date(Created) : null,
        volumes: [
            ...Mounts
        ].reduce((volumes, v)=>v.Name ? [
                ...volumes,
                v.Name
            ] : volumes, []),
        status: (0, $f8e1ae5c3f1d25ae$export$eb25faf9da40860f)(container.State.Status?.toLowerCase()),
        config: {
            image: Image,
            workingDir: WorkingDir,
            author: Labels.author || null,
            vendor: Labels.vendor || null,
            capAdd: (0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(HostConfig.CapAdd) ? HostConfig.CapAdd.map(String) : HostConfig.CapAdd ? String(HostConfig.CapAdd) : null,
            exposedPorts: (0, $2ae70427bab197d4$export$ed97f33186d4b816)(ExposedPorts),
            privileged: HostConfig.Privileged || false
        },
        variables: (0, $21d8aee6197898f1$export$26b0f3afe296e7bb)(Env.reduce((r, variable)=>{
            const [name, stringValue] = variable.split('=');
            return name === undefined || stringValue === undefined ? r : {
                ...r,
                [name]: stringValue
            };
        }, {}))
    };
};
const $01bb05b8237dc7d5$export$263a9b8df4d9876c = (id, container)=>{
    const [service, name] = (0, $738b86ad1f26c727$export$90d271a960b100ce)(id);
    return {
        ...$01bb05b8237dc7d5$export$23237ea46daa77ea(id, name, container),
        service: service
    };
};


class $19ecb10bb136f1d3$export$41b66755048fc92b extends (0, $e3f7c4c7f88621ec$export$442559cb67187a55) {
    constructor(...args){
        super(...args), this.supportedFilters = [
            'service'
        ], this.areEquals = (0, $dc261e1a4f8deea7$export$ba06f365668c46b9), this.containerMetadataConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_READ,
            method: 'GET',
            path: '/api/containers/+/inspect'
        }, this.containersOrchestratorConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_READ,
            method: 'GET',
            path: '/api/containers/orchestrator'
        }, this.containersConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_READ,
            method: 'GET',
            path: '/api/containers'
        }, this.singleContainerConfig = null, this.mapSingleRetrieval = null, this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_READ
        ], this.mapIdAux = (id, { service: serviceFilter })=>{
            const [service, name] = (0, $738b86ad1f26c727$export$90d271a960b100ce)(id);
            if (serviceFilter && serviceFilter !== service) return null;
            return {
                name: name,
                service: service
            };
        }, this.mapListContainer = (base, idMetadata, { Mounts: Mounts })=>{
            return {
                ...base,
                ...idMetadata,
                volumesCount: Mounts.length
            };
        };
    }
}
class $19ecb10bb136f1d3$export$acbeda9f0b87aec2 extends (0, $e3f7c4c7f88621ec$export$442559cb67187a55) {
    constructor(...args){
        super(...args), this.areEquals = (0, $dc261e1a4f8deea7$export$96e6b69c5483e739), this.singleContainerConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINER_READ,
            method: 'GET',
            path: '/api/containers/+/inspect'
        }, this.containerMetadataConfig = null, this.containersOrchestratorConfig = null, this.containersConfig = null, this.mapIdAux = null, this.mapListContainer = null, this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINER_READ
        ], this.mapSingleRetrieval = (id, data)=>(0, $01bb05b8237dc7d5$export$263a9b8df4d9876c)(id, data);
    }
}





class $dc0f03d0683c7f89$export$41acb0423dfda1fe extends (0, $e3f7c4c7f88621ec$export$442559cb67187a55) {
    constructor(...args){
        super(...args), this.areEquals = (0, $dc261e1a4f8deea7$export$f2958c16b60896ae), this.containerMetadataConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINERS_READ,
            method: 'GET',
            path: '/api/core-containers/+/inspect'
        }, this.containersOrchestratorConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINERS_READ,
            method: 'GET',
            path: '/api/core-containers/orchestrator'
        }, this.containersConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINERS_READ,
            method: 'GET',
            path: '/api/core-containers'
        }, this.singleContainerConfig = null, this.mapSingleRetrieval = null, this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINERS_READ
        ], this.mapIdAux = (id)=>{
            return {
                name: id
            };
        }, this.mapListContainer = (base, idMetadata)=>{
            return {
                ...base,
                ...idMetadata
            };
        };
    }
}
class $dc0f03d0683c7f89$export$7fc0a9f464d97112 extends (0, $e3f7c4c7f88621ec$export$442559cb67187a55) {
    constructor(...args){
        super(...args), this.areEquals = (0, $dc261e1a4f8deea7$export$f62d527a0ab80f09), this.mapIdAux = null, this.mapListContainer = null, this.containerMetadataConfig = null, this.containersOrchestratorConfig = null, this.containersConfig = null, this.singleContainerConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINER_READ,
            method: 'GET',
            path: '/api/core-containers/+/inspect'
        }, this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINER_READ
        ], this.mapSingleRetrieval = (id, data)=>(0, $01bb05b8237dc7d5$export$23237ea46daa77ea)(id, id, data);
    }
}







const $15ad21481495de40$export$a220e1fe39b51efd = (resource)=>{
    const { connection: connection } = resource.resourceConfig.args;
    const baseConnection = {
        id: resource.resourceId,
        name: (0, $738b86ad1f26c727$export$451246252aec50a8)(resource.resourceId),
        service: resource.serviceId,
        deviceAddress: null,
        deviceInstance: null,
        ipAddress: null,
        cncType: null,
        device: null,
        brokers: null,
        agent: resource.runnerName || null,
        host: 'host' in connection && connection.host && typeof connection.host === 'string' ? connection.host : null,
        port: 'port' in connection && connection.port && (typeof connection.port === 'string' || typeof connection.port === 'number') ? String(connection.port) : null
    };
    if ((0, $0345488ca28093f7$export$bc6e1b22295b1fbe)(resource, 'Connection', 'ads')) {
        const { routerTcpPort: routerTcpPort } = resource.resourceConfig.args.connection;
        return {
            ...baseConnection,
            port: typeof routerTcpPort === 'number' ? String(routerTcpPort) : null
        };
    }
    if ((0, $0345488ca28093f7$export$bc6e1b22295b1fbe)(resource, 'Connection', 'kafka')) {
        const { brokers: brokers } = resource.resourceConfig.args.connection;
        return {
            ...baseConnection,
            brokers: [
                ...brokers
            ]
        };
    }
    if ((0, $0345488ca28093f7$export$bc6e1b22295b1fbe)(resource, 'Connection', 'heidenhain')) {
        const { ipAddress: ipAddress, cncType: cncType } = resource.resourceConfig.args.connection;
        return {
            ...baseConnection,
            ipAddress: ipAddress || null,
            cncType: cncType || null
        };
    }
    if ((0, $0345488ca28093f7$export$bc6e1b22295b1fbe)(resource, 'Connection', 'bacnet')) {
        const { deviceAddress: deviceAddress, deviceInstance: deviceInstance } = resource.resourceConfig.args.connection;
        const { host: host = null, port: port = null } = /^(?<host>.+):(?<port>[0-9]{2,5})$/.exec(deviceAddress)?.groups ?? {};
        return {
            ...baseConnection,
            deviceAddress: deviceAddress,
            deviceInstance: String(deviceInstance),
            host: host,
            port: port
        };
    }
    return baseConnection;
};


class $3030af7848a8b21b$export$7ca20fa49a86bfb6 extends (0, $c359a5294871e0ba$export$3a0e060fb015fbe5) {
    mapResource(resource, status) {
        return {
            ...(0, $15ad21481495de40$export$a220e1fe39b51efd)(resource),
            protocol: resource.protocol,
            status: status
        };
    }
    constructor(...args){
        super(...args), this.supportedFilters = [
            'service'
        ], this.areEquals = (0, $b3e7a2ab0fd4d9ed$export$fcb75d03e736f6ea), this.serviceResourcesRequestConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_READ,
            path: '/api/v2/services/+/resources',
            method: 'GET'
        }, this.allResourcesRequestConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_READ,
            path: '/api/v2/resources',
            method: 'GET'
        }, this.resourceCategories = [
            'Connection'
        ], this.resourceStatusType = 'connections', this.serviceDeviationsType = [
            'connections',
            'connections'
        ], this.serverErrorMessage = 'Could not fetch connections', this.sortingColumns = {
            agent: 'runnerName',
            cncType: null,
            device: null,
            deviceAddress: null,
            deviceInstance: null,
            host: null,
            id: 'resourceId',
            ipAddress: null,
            name: 'resourceName',
            port: null,
            protocol: 'protocol',
            service: 'serviceId',
            status: null
        }, this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_READ
        ];
    }
}






class $acbbb64d8fbe2c2e$export$d428d2c5a3f963d7 extends (0, $c359a5294871e0ba$export$b1e5a060881bf246) {
    mapResource(connection, status) {
        return {
            ...(0, $15ad21481495de40$export$a220e1fe39b51efd)(connection),
            extraConfiguration: (0, $21d8aee6197898f1$export$26b0f3afe296e7bb)(connection.resourceConfig.args.connection),
            status: status
        };
    }
    constructor(...args){
        super(...args), this.areEquals = (0, $b3e7a2ab0fd4d9ed$export$482c904bf2d3b316), this.resourceCategory = 'Connection', this.notFoundMessage = 'Could not fetch connection', this.resourceStatusType = 'connection', this.baseRequest = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTION_READ,
            method: 'GET',
            path: '/api/v2/resources/+'
        }, this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTION_READ
        ];
    }
}







const $5c55a97880065832$export$3e82f88f8112550 = ({ resourceId: resourceId, runnerName: runnerName, serviceId: serviceId })=>({
        id: resourceId,
        name: (0, $738b86ad1f26c727$export$451246252aec50a8)(resourceId),
        service: serviceId,
        agent: runnerName
    });


class $fb29f52a88f959cb$export$2fc7f2dc6f16e7a0 extends (0, $c359a5294871e0ba$export$3a0e060fb015fbe5) {
    mapResource(resource, status) {
        return {
            ...(0, $5c55a97880065832$export$3e82f88f8112550)(resource),
            entriesCount: resource.resourceConfig.args.mappings.length,
            status: status
        };
    }
    constructor(...args){
        super(...args), this.supportedFilters = [
            'service'
        ], this.areEquals = (0, $bc868e3ec3b72477$export$67c0d73e73b217bc), this.serviceResourcesRequestConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_READ,
            path: '/api/v2/services/+/resources',
            method: 'GET'
        }, this.allResourcesRequestConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_READ,
            path: '/api/v2/resources',
            method: 'GET'
        }, this.resourceCategories = [
            'Mapping'
        ], this.resourceStatusType = 'mappings', this.serviceDeviationsType = [
            'mappings',
            'mappings'
        ], this.serverErrorMessage = 'Could not fetch mappings', this.sortingColumns = {
            service: 'serviceId',
            id: 'resourceId',
            name: 'resourceName',
            status: null,
            agent: 'runnerName',
            entriesCount: null
        }, this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_READ
        ];
    }
}






const $cff3fbb995ea91c4$var$mapPubSub = ({ topic: topic, connection: connection, endpoint: endpoint }, topicMapper)=>({
        type: endpoint ? (0, $bc868e3ec3b72477$export$5c8c128443e404df).ENDPOINT : (0, $bc868e3ec3b72477$export$5c8c128443e404df).TOPIC,
        id: endpoint || topic,
        topics: topicMapper.mapAll(topic),
        externalBroker: connection || null,
        subscriptionErrors: new Set()
    });
class $cff3fbb995ea91c4$export$41c1ded364558dd9 extends (0, $c359a5294871e0ba$export$b1e5a060881bf246) {
    mapResource(mapping, status) {
        const topicMapper = (0, $e995f059f5d1fc30$export$ed05c84a2e8a2f13).create(mapping.category);
        return {
            ...(0, $5c55a97880065832$export$3e82f88f8112550)(mapping),
            entries: mapping.resourceConfig.args.mappings.map(({ publish: publish, subscribe: subscribe, rules: rules })=>({
                    subscribe: subscribe.map((s)=>$cff3fbb995ea91c4$var$mapPubSub(s, topicMapper)),
                    publish: $cff3fbb995ea91c4$var$mapPubSub(publish, topicMapper),
                    rules: rules ? [
                        ...rules
                    ] : null,
                    /**
                 * @todo map execution errors
                 * @see https://cybusio.atlassian.net/browse/CC-3231
                 */ executionError: null
                })),
            status: status
        };
    }
    constructor(...args){
        super(...args), this.areEquals = (0, $bc868e3ec3b72477$export$73104380e5218bec), this.resourceCategory = 'Mapping', this.notFoundMessage = 'Could not fetch mapping', this.resourceStatusType = 'mapping', this.baseRequest = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPING_READ,
            method: 'GET',
            path: '/api/v2/resources/+'
        }, this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPING_READ
        ];
    }
}







class $0993c3d1f94e9090$export$471d9c99c56ed292 extends (0, $6892139a4b7aecff$export$dbc446747bfb99a8) {
    static #_ = /**
     * Agents that should not be considered for listing
     */ this.rejectAgents = new Set([
        'auth-server',
        'service-manager',
        'system-control-server',
        'container-manager'
    ]);
    static mapAgentData({ name: name, version: version, hostname: hostname, healthy: healthy }) {
        if (this.rejectAgents.has(name)) return null;
        const nullifiedHostname = hostname || null;
        // If agent container was started without hostname argument, we get
        // just the Docker container ID here, which is somewhat confusing.
        const isHostnameContainerId = nullifiedHostname && /^[0-9a-f]{12}$/.exec(nullifiedHostname);
        return {
            name: name,
            version: version,
            hostname: isHostnameContainerId ? null : nullifiedHostname,
            containerId: isHostnameContainerId ? nullifiedHostname : null,
            status: healthy ? (0, $1041b3cad55163d4$export$e35c1996c6f482ad).ONLINE : (0, $1041b3cad55163d4$export$e35c1996c6f482ad).OFFLINE
        };
    }
    async retrieveAll() {
        const agents = [];
        let isDone = false;
        let page = 1;
        while(!isDone){
            isDone = await this.request({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).AGENTS_READ,
                method: 'GET',
                path: '/api/v2/resource-runners',
                authenticate: true,
                queryParams: {
                    page: `${page}`
                },
                handlers: {
                    200: (response)=>response.getJson().then(({ data: data, meta: meta })=>{
                            for (const info of data){
                                const agent = $0993c3d1f94e9090$export$471d9c99c56ed292.mapAgentData(info);
                                if (agent) agents.push(agent);
                            }
                            return (0, $fb6b2c79c0cbfdb7$export$59545aa1378f3baa)(meta.pagination);
                        }),
                    503: $0993c3d1f94e9090$export$471d9c99c56ed292.createServerNotAvailableHandler('Resources Status Tracking is not running as expected')
                }
            });
            page++;
        }
        return agents;
    }
    constructor(...args){
        super(...args), this.areEquals = (0, $9ede1dd6506a21d3$export$bccffce87b0d7a69), this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).AGENTS_READ
        ];
    }
}







class $c8cf7dbeda76af91$export$6a8ae1b3edcf9889 extends (0, $c359a5294871e0ba$export$3a0e060fb015fbe5) {
    mapResource(resource, status) {
        return {
            id: resource.resourceId,
            service: resource.serviceId,
            name: (0, $738b86ad1f26c727$export$451246252aec50a8)(resource.resourceId),
            parent: resource.parentResourceId,
            operation: resource.resourceConfig.args.operation || null,
            protocol: resource.protocol,
            status: status
        };
    }
    createCustomQueryParameters({ server: server }) {
        return server ? {
            parentResourceId: server
        } : {};
    }
    constructor(...args){
        super(...args), this.supportedFilters = [
            'server',
            'service'
        ], this.areEquals = (0, $b6a480063e26497c$export$fef17a864338ee23), this.allResourcesRequestConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).NODES_READ,
            path: '/api/v2/resources',
            method: 'GET'
        }, this.resourceCategories = [
            'Node'
        ], this.resourceStatusType = 'nodes', this.serviceDeviationsType = [
            'nodes',
            'nodes'
        ], this.serverErrorMessage = 'Could not fetch nodes', this.sortingColumns = {
            id: 'resourceId',
            name: 'resourceName',
            operation: null,
            parent: 'parentResourceId',
            protocol: 'protocol',
            service: 'serviceId',
            status: null
        }, this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).NODES_READ
        ], this.serviceResourcesRequestConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).NODES_READ,
            path: '/api/v2/services/+/resources',
            method: 'GET'
        };
    }
}







const $fb6c701353b0dc96$var$mapCybusServer = (resource, status)=>({
        id: resource.resourceId,
        service: resource.serviceId,
        name: (0, $738b86ad1f26c727$export$451246252aec50a8)(resource.resourceId),
        protocol: resource.protocol,
        status: status
    });
class $fb6c701353b0dc96$export$b3b64713a1d2409e extends (0, $c359a5294871e0ba$export$3a0e060fb015fbe5) {
    constructor(...args){
        super(...args), this.supportedFilters = [
            'service'
        ], this.areEquals = (0, $a79b5916972014a8$export$a18a2f875e4f96c4), this.serviceResourcesRequestConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_READ,
            path: '/api/v2/services/+/resources',
            method: 'GET'
        }, this.allResourcesRequestConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_READ,
            path: '/api/v2/resources',
            method: 'GET'
        }, this.resourceCategories = [
            'Server'
        ], this.resourceStatusType = 'servers', this.serviceDeviationsType = [
            'servers',
            'servers'
        ], this.serverErrorMessage = 'Could not fetch servers', this.sortingColumns = {
            id: 'resourceId',
            name: 'resourceName',
            protocol: 'protocol',
            service: 'serviceId',
            status: null
        }, this.mapResource = $fb6c701353b0dc96$var$mapCybusServer, this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_READ
        ];
    }
}
class $fb6c701353b0dc96$export$b155c77635696e92 extends (0, $c359a5294871e0ba$export$b1e5a060881bf246) {
    constructor(...args){
        super(...args), this.supportedFilters = [], this.areEquals = (0, $a79b5916972014a8$export$a18a2f875e4f96c4), this.resourceCategory = 'Server', this.notFoundMessage = 'Could not fetch server', this.resourceStatusType = 'server', this.baseRequest = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVER_READ,
            method: 'GET',
            path: '/api/v2/resources/+'
        }, this.mapResource = $fb6c701353b0dc96$var$mapCybusServer, this.requiredPermissions = [
            (0, $78670ebe9381a713$export$790a66df9dc00390).SERVER_READ
        ];
    }
}






const $0620c2d93c950f5a$var$strategyCreators = {
    services: (0, $6322825ce5cae19a$export$2eba23c0268d20ef),
    deviatedServices: (0, $cc9fc14d78211249$export$2f57934c05a8f6b6),
    service: (0, $4037f67af812c539$export$4ba77de14e305898),
    servicesLinks: (0, $d08c8abe1a0e2a63$export$770394053f04d2f4),
    serviceResources: (0, $9cccffcb19469fd8$export$fd2c8d6d31302c92),
    endpoints: (0, $024fc8c98834131b$export$b757d1d01dc76ad7),
    endpoint: (0, $7871154e241a8a99$export$ee5a2870e5efd7a2),
    serviceDeviations: (0, $11b21f10e4a2062a$export$18926fcd1ea1157d),
    resourceDeviation: (0, $b72f066ddb1efe4d$export$46de32891fbf03f0),
    volumes: (0, $c8a3318494e4c1c3$export$133ea2c73f5c795b),
    volume: (0, $a1e0baf9d31b829e$export$e409388fee521255),
    serviceContainers: (0, $19ecb10bb136f1d3$export$41b66755048fc92b),
    serviceContainer: (0, $19ecb10bb136f1d3$export$acbeda9f0b87aec2),
    coreContainers: (0, $dc0f03d0683c7f89$export$41acb0423dfda1fe),
    coreContainer: (0, $dc0f03d0683c7f89$export$7fc0a9f464d97112),
    connections: (0, $3030af7848a8b21b$export$7ca20fa49a86bfb6),
    connection: (0, $acbbb64d8fbe2c2e$export$d428d2c5a3f963d7),
    mappings: (0, $fb29f52a88f959cb$export$2fc7f2dc6f16e7a0),
    mapping: (0, $cff3fbb995ea91c4$export$41c1ded364558dd9),
    agents: (0, $0993c3d1f94e9090$export$471d9c99c56ed292),
    nodes: (0, $c8cf7dbeda76af91$export$6a8ae1b3edcf9889),
    servers: (0, $fb6c701353b0dc96$export$b3b64713a1d2409e),
    server: (0, $fb6c701353b0dc96$export$b155c77635696e92)
};
const $0620c2d93c950f5a$export$7e6302c5328971f5 = (type)=>$0620c2d93c950f5a$var$strategyCreators[type];






class $bab5d7f1d0ba91e5$export$d07c633948128403 extends (0, $82373d578b14a603$export$f6f3d54ed66158a2) {
    static validateFilters(strategy, filter) {
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(strategy.supportsFilters(filter), new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'This strategy does NOT support this filter', {
            filter: filter
        }));
    }
    constructor({ resourceChangeListeners: resourceChangeListeners, getCapabilities: getCapabilities, translationService: translationService, rstAdapter: rstAdapter, pollingInterval: pollingInterval, updateThrottle: updateThrottle, ...options }){
        super(options);
        this.getCapabilities = getCapabilities;
        this.resourceChangeListeners = resourceChangeListeners;
        this.rstAdapter = rstAdapter;
        this.pollingInterval = pollingInterval;
        this.updateThrottle = updateThrottle;
        this.pageSubscriptionAdapter = new (0, $ff65752276e0ae0b$export$d1cb0a5186eff557)((eventName, filter, listener)=>{
            const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
            const strategy = this.createStrategy(eventName);
            const fetcher = new (0, $2cb4bacd541d7c51$export$eac7a0bed07572f7)(()=>{
                $bab5d7f1d0ba91e5$export$d07c633948128403.validateFilters(strategy, filter);
                return strategy.retrieveAll(filter);
            }, (...args)=>strategy.compareAll(...args));
            droppable.onDrop(fetcher.onChange(listener));
            droppable.onDrop(this.createFetcherUnsubber((handler)=>strategy.createAllChangeListener?.(filter, handler), fetcher));
            this.scheduleFetcherStart(fetcher);
            return Promise.resolve(()=>droppable.drop());
        }, translationService);
    }
    createStrategy(eventName) {
        const Strategy = (0, $0620c2d93c950f5a$export$7e6302c5328971f5)(eventName);
        const strategy = new Strategy((args)=>this.request(args), this.rstAdapter);
        const userPermissions = new Set(this.getCapabilities());
        const { requiredPermissions: requiredPermissions } = strategy;
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(requiredPermissions.every((p)=>userPermissions.has(p)), new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, "Can't subscribe to this type due to permissioning issues", {
            userPermissions: Array.from(userPermissions),
            requiredPermissions: requiredPermissions,
            eventName: eventName
        }));
        return strategy;
    }
    createFetcherUnsubber(createChangeListener, fetcher) {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        const throttler = new (0, $2accc4d3fee5c026$export$badd29bfd2c3923d)(this.updateThrottle);
        const update = ()=>fetcher.update();
        /**
         * Set up listener for any changes made by the current user
         * Since this was done by the user, simply update things straight away
         */ droppable.onDrop(this.resourceChangeListeners.on(update));
        /**
         * Set up listener for any changes detected by the strategy
         * This can potentially be spammy (in case a lot of changes are detected)
         *
         * Thus, an initial attempt to update is made
         * If it's blocked, another one after the current timeout is also done
         *
         * If both get denied, it means there are other calls being made,
         * which can simply be waited on
         */ const unsubToChanges = createChangeListener(()=>{
            const executed = throttler.run(update);
            if (!executed) throttler.runAfter(update);
        });
        if (unsubToChanges) unsubToChanges.then((unsub)=>droppable.onDrop(unsub));
        droppable.onDrop(()=>fetcher.stop());
        return ()=>droppable.drop();
    }
    scheduleFetcherStart(fetcher) {
        /**
         * Start fetcher after object has been returned
         */ (0, $48cf5ef53a480c1f$export$1391212d75b2ee65)(0).then(()=>fetcher.start(this.pollingInterval));
    }
    subscribeToPage(eventName, initialOptions) {
        const strategy = this.createStrategy(eventName);
        if (!strategy.supportsPagination) /**
             * Since not supported, use the fake pagination
             */ return this.pageSubscriptionAdapter.subscribeToPage(eventName, initialOptions);
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        const listener = new (0, $9fc21cc786388d5a$export$3291343375ee8b92)();
        const optionsListener = new (0, $9fc21cc786388d5a$export$668230531b0abb74)(initialOptions, true);
        const fetcher = new (0, $2cb4bacd541d7c51$export$eac7a0bed07572f7)(()=>{
            $bab5d7f1d0ba91e5$export$d07c633948128403.validateFilters(strategy, /**
                     * Why is an object being copied here?
                     * The idea behind this is: if the object is extended, errors will be detected
                     */ (0, $2ae70427bab197d4$export$12b617052eb9d30e)(optionsListener.value, 'search', 'sort', 'pagination'));
            return strategy.retrievePage(optionsListener.value);
        }, (...args)=>strategy.comparePage(...args));
        /**
         * Whenever there is a change in filters
         * Update the data and trigger a new change
         */ droppable.onDrop(optionsListener.onChange(()=>fetcher.update(true)));
        /**
         * When fetcher loads new data
         * Trigger handler so everything is updated
         */ droppable.onDrop(fetcher.onChange((page)=>listener.trigger(page)));
        /**
         * Deal with unsubbing to fetcher internals
         */ droppable.onDrop(this.createFetcherUnsubber((handler)=>strategy.createAllChangeListener?.(initialOptions, handler), fetcher));
        /**
         * Finally, schedule the start of the fetcher
         */ this.scheduleFetcherStart(fetcher);
        return Promise.resolve({
            update: (options)=>optionsListener.change({
                    ...optionsListener.value,
                    ...options
                }),
            onData: (handler)=>listener.on(handler),
            stop: ()=>droppable.drop()
        });
    }
    subscribeToAll(eventName, listener) {
        return this.rstAdapter.subscribeToResolvedDeviations(eventName, listener);
    }
    subscribeToOne(eventName, id, listener) {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        const strategy = this.createStrategy(eventName);
        const fetcher = new (0, $2cb4bacd541d7c51$export$eac7a0bed07572f7)(()=>strategy.retrieveOne(id), (...args)=>strategy.compareOne(...args));
        droppable.onDrop(fetcher.onChange(listener));
        droppable.onDrop(this.createFetcherUnsubber((handler)=>strategy.createSingleChangeListener?.(id, handler), fetcher));
        this.scheduleFetcherStart(fetcher);
        return Promise.resolve(()=>droppable.drop());
    }
    subscribeToCount(eventName, listener) {
        const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        const strategy = this.createStrategy(eventName);
        const fetcher = new (0, $2cb4bacd541d7c51$export$eac7a0bed07572f7)(()=>strategy.retrieveCount(), (a, b)=>a === b);
        droppable.onDrop(fetcher.onChange(listener));
        droppable.onDrop(this.createFetcherUnsubber((handler)=>strategy.createCountChangeListener?.(handler), fetcher));
        this.scheduleFetcherStart(fetcher);
        return Promise.resolve(()=>droppable.drop());
    }
}







class $165c25270f704fd4$export$e9b5b258b34f61ee extends (0, $82373d578b14a603$export$f6f3d54ed66158a2) {
    static mapTopics(childrenSlice, prefix) {
        return childrenSlice.map(({ has_more: hasChildren, name: name })=>({
                hasChildren: hasChildren,
                fullPath: prefix ? [
                    prefix,
                    name
                ].join('/') : name,
                name: name
            }));
    }
    constructor(options, translationService){
        super(options), this.translationService = translationService, this.maxChildrenPerTopic = 100;
    }
    mapNextChunk(children, childrenSlice) {
        const isSliceNotAtLastChunk = (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(children) && (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(childrenSlice) && (0, $9f70c141ac08ef9a$export$109d9d261d61ca16)(childrenSlice) !== (0, $9f70c141ac08ef9a$export$109d9d261d61ca16)(children);
        if (isSliceNotAtLastChunk) return {
            reference: (0, $9f70c141ac08ef9a$export$109d9d261d61ca16)(childrenSlice).name,
            pageSize: this.maxChildrenPerTopic
        };
        return null;
    }
    fetchTopicsChunk(prefix, reference) {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).TOPIC_CHUNKS_READ,
            path: '/api/v2/mqtt/topics/levels',
            method: 'GET',
            authenticate: true,
            queryParams: prefix ? {
                prefix: prefix
            } : {},
            handlers: {
                200: async (response)=>{
                    const { data: data } = await response.getJson();
                    const start = reference ? data.children.findIndex((c)=>c.name === reference) + 1 : 0;
                    const end = start + this.maxChildrenPerTopic;
                    const childrenSlice = data.children.slice(start, end);
                    return {
                        topics: $165c25270f704fd4$export$e9b5b258b34f61ee.mapTopics(childrenSlice, prefix),
                        nextChunk: this.mapNextChunk(data.children, childrenSlice)
                    };
                },
                500: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVER_ERROR), {
                        prefix: prefix
                    }),
                503: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_NOT_AVAILABLE, this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVER_NOT_AVAILABLE), {
                        prefix: prefix
                    })
            }
        });
    }
}









class $213eb4f80b1949e4$export$43987bf911e030a5 extends (0, $82373d578b14a603$export$f6f3d54ed66158a2) {
    constructor(...args){
        super(...args), this.fetchEntraStatus = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.request({
                /**
             * This endpoint does not require authentication
             */ capability: null,
                method: 'GET',
                path: '/api/auth/msEntraId',
                handlers: {
                    200: (response)=>response.getJson().then((r)=>r.enabled)
                }
            }));
    }
}







const $f2fb95f29536f564$var$mapPermissionPutRequest = (permission)=>{
    (0, $14eddac5f20c576c$export$a7a9523472993e97)(permission.id, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).MAPPING_ERROR, 'Could not map PermissionPutRequest', permission));
    return {
        id: permission.id,
        operation: (0, $524c99de33c5950a$export$446ab98052b611bd)(permission)
    };
};
const $f2fb95f29536f564$export$317b1a0b2887369e = (permission)=>{
    (0, $14eddac5f20c576c$export$a7a9523472993e97)(permission.id === null, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).MAPPING_ERROR, 'Could not map PermissionPostRequest', permission));
    return {
        context: (0, $f5c5bae2ca26f1d7$export$b9feafe2e5ed80eb)(permission.context),
        resource: permission.resource,
        operation: (0, $524c99de33c5950a$export$446ab98052b611bd)(permission)
    };
};
const $f2fb95f29536f564$export$c3d342751d02bf94 = (permission)=>permission.id ? $f2fb95f29536f564$var$mapPermissionPutRequest(permission) : $f2fb95f29536f564$export$317b1a0b2887369e(permission);
const $f2fb95f29536f564$var$mapPermission = ({ id: id, context: context, resource: resource, operation: operation })=>({
        id: id || null,
        context: (0, $f5c5bae2ca26f1d7$export$1cd392a9150fe66f)(context),
        resource: resource,
        ...(0, $524c99de33c5950a$export$ba4f1fbd74946892)(operation)
    });
const $f2fb95f29536f564$var$isCybusPersistedPermission = (permission)=>typeof permission.id === 'string';
const $f2fb95f29536f564$export$439cc3d4f6f085b3 = (permissions)=>permissions.map($f2fb95f29536f564$var$mapPermission);
const $f2fb95f29536f564$export$3eb4f8a3e3e31fa9 = (permissions)=>permissions.map((p)=>{
        const out = $f2fb95f29536f564$var$mapPermission(p);
        (0, $14eddac5f20c576c$export$a7a9523472993e97)($f2fb95f29536f564$var$isCybusPersistedPermission(out), new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).MAPPING_ERROR, 'Id should be present', p));
        return out;
    });


class $212117f309d44a12$var$Alternative {
    static #_ = this.permissionPatternCache = new Map();
    /**
     * Yields whether a given permission access covers the given requirment
     *
     * @example /api/v2/resources/#, /api/v2/resources/states/deviations/count -> true
     * @example /api/v2/services/#, /api/v2/resources/states/deviations/count -> false
     * @example /api/v2/services/+, /api/v2/services/+ -> true
     */ static doesResourceMatchRequirement(resource, requirement) {
        let resourcePattern = this.permissionPatternCache.get(resource);
        if (!resourcePattern) {
            /**
             * + signs are replaced with a "grab everything before the next slash"
             * /# segments are replaced with a "grab everything and empty path afterward"
             */ resourcePattern = new RegExp(`^${resource.replaceAll('+', '[^/]+').replaceAll('/#', '.*')}$`);
            this.permissionPatternCache.set(resource, resourcePattern);
        }
        return resourcePattern.test(requirement);
    }
    static matches(permission, requirement) {
        return requirement.context === permission.context && // Has read permission superior or equal to the required
        permission.read >= requirement.read && // Has write permission superior or equal to the required
        permission.write >= requirement.write && (requirement.resource === null || requirement.resource === permission.resource || this.doesResourceMatchRequirement(permission.resource, requirement.resource));
    }
    constructor(requirements){
        this.requirements = requirements;
    }
    collect(permission) {
        this.requirements = this.requirements.filter((requirement)=>!$212117f309d44a12$var$Alternative.matches(permission, requirement));
        return !(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(this.requirements);
    }
}
class $212117f309d44a12$var$PermissionCollector {
    constructor(capability, requirements){
        this.capability = capability;
        this.alternatives = requirements.map((alternative)=>new $212117f309d44a12$var$Alternative(alternative));
    }
    /**
     * @returns if it's done collecting
     */ collect(permission) {
        return this.alternatives.some((a)=>a.collect(permission));
    }
}
const $212117f309d44a12$var$mapPermissionsRequirements = (inputPermissions)=>{
    const foundCapabilities = [];
    let permissionsCollectors = (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)((0, $abbed5ec1ae0f4ff$export$8e76ac9f37578d1b)).map(([permission, requirements])=>new $212117f309d44a12$var$PermissionCollector(permission, requirements));
    inputPermissions.every((permission)=>{
        permissionsCollectors = permissionsCollectors.filter((collector)=>{
            if (!collector.collect(permission)) /**
                 * Not done collecting
                 */ return true;
            /**
             * Collector has matched all rules
             * So add them and remove this from the next iteration
             */ foundCapabilities.push(collector.capability);
            return false;
        });
        return Boolean(permissionsCollectors.length);
    });
    return Array.from(new Set(foundCapabilities));
};
const $212117f309d44a12$var$constraints = {
    orchestrator: (0, $abbed5ec1ae0f4ff$export$fe006fd1a05ee554),
    isMfaActive: (0, $abbed5ec1ae0f4ff$export$cce005330a510b30)
};
const $212117f309d44a12$var$hasCapabilitiesToCheck = (indexedCapabilities, mayBeRemovedMap)=>{
    for (const capabilities of mayBeRemovedMap.values()){
        if (capabilities.some((capability)=>indexedCapabilities.has(capability))) /** There are capabilities present that require to check if backend can perform them  */ return true;
    }
    return false;
};
const $212117f309d44a12$var$resolveCapabilities = (capabilities, checkers)=>{
    /** Can be used for multiple checks without performance degradation */ const indexedCapabilities = new Set(capabilities);
    return Promise.all((0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)($212117f309d44a12$var$constraints).map(([promiseGetterName, mayBeRemovedMap])=>{
        if (!$212117f309d44a12$var$hasCapabilitiesToCheck(indexedCapabilities, mayBeRemovedMap)) /** There is nothing to remove, so don't perform checks */ return Promise.resolve();
        /**
                 * With the key it is possible to retrieve
                 * which capabilities need to be dropped
                 * as the backend cannot support them
                 */ const keyPromise = checkers[promiseGetterName]();
        return keyPromise.then((key)=>{
            const castMap = mayBeRemovedMap;
            /** Finally drop them */ castMap.getDefault(key, []).forEach((c)=>indexedCapabilities.delete(c));
        });
    }))/** Wait for everyone to resolve, then return capabilities that are left */ .then(()=>Array.from(indexedCapabilities));
};
const $212117f309d44a12$var$mapAuthentication = ({ permissions: permissions, expiresAt: expiresAt }, checkers)=>{
    const capabilities = $212117f309d44a12$var$mapPermissionsRequirements((0, $f2fb95f29536f564$export$3eb4f8a3e3e31fa9)(permissions));
    return $212117f309d44a12$var$resolveCapabilities(capabilities, checkers).then((capabilities)=>({
            capabilities: capabilities,
            expiresAt: new Date(expiresAt)
        }));
};
const $212117f309d44a12$export$54f12192840496b1 = ({ token: token, ...args }, checkers)=>$212117f309d44a12$var$mapAuthentication(args, checkers).then((response)=>({
            ...response,
            token: token
        }));
const $212117f309d44a12$export$a9f28f1e898d769b = ({ username: username, ...args }, checkers)=>$212117f309d44a12$var$mapAuthentication(args, checkers).then((response)=>({
            ...response,
            username: username
        }));


const $ab33a7b7001a2cff$export$397cfe51d4da1529 = (value, defaultValue)=>value ?? defaultValue;






const $00c873ed0924df12$var$grantTypesMap = {
    password: (0, $80ed8557cc0425cc$export$766a2ded12a6f943).PASSWORD,
    token: (0, $80ed8557cc0425cc$export$766a2ded12a6f943).TOKEN,
    certificate: (0, $80ed8557cc0425cc$export$766a2ded12a6f943).CERTIFICATE
};
const $00c873ed0924df12$var$getAuthenticationMethodMap = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>Object.fromEntries((0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)($00c873ed0924df12$var$grantTypesMap).map(([grantType, method])=>[
            method,
            grantType
        ])));
const $00c873ed0924df12$export$76f4e35c8f605837 = (method)=>$00c873ed0924df12$var$grantTypesMap[method];
const $00c873ed0924df12$export$e85e3679545f50f9 = ({ method: method })=>$00c873ed0924df12$export$76f4e35c8f605837(method);
const $00c873ed0924df12$export$726b337719677769 = (method)=>({
        method: $00c873ed0924df12$var$getAuthenticationMethodMap()[method],
        isRequired: false
    });


class $5cc19b8729791d7b$export$76813e3732faaa02 {
    constructor(protectedEntities){
        this.protectedEntities = protectedEntities;
    }
    mapMutability(identityProvider, entityName) {
        const isProtected = this.protectedEntities.has(entityName);
        const isLocal = identityProvider === 'local';
        const isMSEntraId = identityProvider === 'msentraid';
        return {
            canDelete: !isProtected,
            canEditOthers: isLocal,
            canEditName: isLocal && !isProtected,
            canUpdateMFA: !isMSEntraId
        };
    }
}


const $1310fcd8620c6d10$var$userProviderMapping = {
    ldap: (0, $80ed8557cc0425cc$export$d41318922d055bfc).LDAP,
    local: (0, $80ed8557cc0425cc$export$d41318922d055bfc).CONNECTWARE,
    msentraid: (0, $80ed8557cc0425cc$export$d41318922d055bfc).MICROSOFT_ENTRA_ID
};
const $1310fcd8620c6d10$var$mapMfaStatus = (isMfaSetup, isMFAEnrolled, identityProvider)=>{
    if (!isMfaSetup) return (0, $37c2a8e29603f683$export$5e93ec1eb1a0effa).NOT_SETUP;
    if (identityProvider === 'msentraid') return (0, $37c2a8e29603f683$export$5e93ec1eb1a0effa).NOT_APPLICABLE;
    return isMFAEnrolled ? (0, $37c2a8e29603f683$export$5e93ec1eb1a0effa).ENABLED : (0, $37c2a8e29603f683$export$5e93ec1eb1a0effa).DISABLED;
};
class $1310fcd8620c6d10$export$63cf01fca918449e {
    static mapPage(current, { rowsPerPage: rowsPerPage, pageNumber: pageNumber, totalRows: totalRows }) {
        return {
            current: current,
            totalCount: totalRows,
            pageSize: rowsPerPage,
            page: pageNumber
        };
    }
    static mapCybusPersistedPermission({ id: id, ...rawPermission }) {
        return {
            id: id,
            context: (0, $f5c5bae2ca26f1d7$export$1cd392a9150fe66f)(rawPermission.context),
            resource: rawPermission.resource,
            ...(0, $524c99de33c5950a$export$ba4f1fbd74946892)(rawPermission.operation)
        };
    }
    static mapPermission({ context: context, resource: resource, usage: usage }) {
        const users = {};
        const roles = {};
        usage.forEach(({ isRoleShared: isRoleShared, operation: operation, roleName: roleName, username: username })=>{
            const operations = (0, $524c99de33c5950a$export$ba4f1fbd74946892)(operation);
            if (isRoleShared) roles[roleName] = operations;
            if (username) users[username] = operations;
        });
        return {
            context: (0, $f5c5bae2ca26f1d7$export$1cd392a9150fe66f)(context),
            resource: resource,
            users: users,
            roles: roles
        };
    }
    constructor(config){
        this.roleMutabilityMapper = new (0, $5cc19b8729791d7b$export$76813e3732faaa02)(config.protectedRoles);
        this.userMutabilityMapper = new (0, $5cc19b8729791d7b$export$76813e3732faaa02)(config.protectedUsers);
    }
    mapUser({ id: id, username: username, grantTypes: grantTypes, tokens: tokens, identityProvider: identityProvider, roles: roles, mqttPublishPrefix: mqttPublishPrefix, mfa_is_enrolled: isMFAEnrolled, enforceMFAEnrollment: enforceMFAEnrollment }, isMfaSetup) {
        const user = {
            permissions: [],
            allPermissions: [],
            roles: [],
            mfaStatus: $1310fcd8620c6d10$var$mapMfaStatus(isMfaSetup, isMFAEnrolled, identityProvider),
            isMfaEnforced: isMfaSetup ? enforceMFAEnrollment : null,
            id: id,
            username: username,
            provider: $1310fcd8620c6d10$var$userProviderMapping[identityProvider],
            authenticationMethods: grantTypes.map((0, $00c873ed0924df12$export$e85e3679545f50f9)),
            /**
             * @todo actually map this properly
             * @see https://cybusio.atlassian.net/browse/CYB-3609
             */ lastSeen: tokens.reduce((r, t)=>{
                const created = new Date(t.created_at);
                return r === null || r.getTime() < created.getTime() ? created : r;
            }, null),
            mqttPublishPrefix: mqttPublishPrefix,
            ...this.userMutabilityMapper.mapMutability(identityProvider, username)
        };
        roles.forEach(({ isShared: isShared, name: name, permissions: permissions })=>{
            if (isShared) // This is actually a role, so add it
            user.roles = [
                ...user.roles,
                name
            ];
            permissions.forEach((rawPermission)=>{
                const userPermission = $1310fcd8620c6d10$export$63cf01fca918449e.mapCybusPersistedPermission(rawPermission);
                if (!isShared) user.permissions = [
                    ...user.permissions,
                    userPermission
                ];
                user.allPermissions = [
                    ...user.allPermissions,
                    userPermission
                ];
            });
        });
        return user;
    }
    mapRole({ id: id, name: name, permissions: permissions, users: users, ldapgroupdn: ldapgroupdn, msEntraIdGroupIds: msEntraIdGroupIds }, isEntraEnabled) {
        const { canDelete: canDelete, canEditOthers: canEditOthers, canEditName: canEditName } = this.roleMutabilityMapper.mapMutability('local', name);
        return {
            id: id,
            name: name,
            permissions: Array.from(permissions.reduce((m, p)=>p.context && p.resource && p.id && p.operation ? m.set(p.id, $1310fcd8620c6d10$export$63cf01fca918449e.mapCybusPersistedPermission(p)) : m, new Map()).values()),
            users: users.flatMap((u)=>u.username ? [
                    u.username
                ] : []),
            ldapGroupDn: ldapgroupdn,
            canDelete: canDelete,
            canEditOthers: canEditOthers,
            canEditName: canEditName,
            msEntraIdGroupIds: isEntraEnabled ? msEntraIdGroupIds ? msEntraIdGroupIds.split(',') : [] : null
        };
    }
    mapUsersPage({ users: users, pagination: pagination }, isMfaSetup) {
        return $1310fcd8620c6d10$export$63cf01fca918449e.mapPage(users.map((user)=>this.mapUser(user, isMfaSetup)), pagination);
    }
    mapRolesPage({ roles: roles, pagination: pagination }, isEntraEnabled) {
        return $1310fcd8620c6d10$export$63cf01fca918449e.mapPage(roles.map((role)=>this.mapRole(role, isEntraEnabled)), pagination);
    }
    mapPermissionsPage({ permissions: permissions, pagination: pagination }) {
        return $1310fcd8620c6d10$export$63cf01fca918449e.mapPage(permissions.map((permission)=>$1310fcd8620c6d10$export$63cf01fca918449e.mapPermission(permission)), pagination);
    }
}



const $e3e007a8c1000cbf$export$86bc19431a0aa06c = (otp)=>({
        otp: otp.join('')
    });
const $e3e007a8c1000cbf$export$87cc10034f209096 = (backupCode)=>({
        backupCode: backupCode
    });





const $5f60db03862c79b6$var$mapMSEntraIdGroupIds = (msEntraIdGroupIds)=>(0, $ab33a7b7001a2cff$export$397cfe51d4da1529)(msEntraIdGroupIds?.join(','), undefined);
const $5f60db03862c79b6$export$514cc1eaa0fc70dd = ({ name: name, permissions: permissions, ldapGroupDn: ldapGroupDn, msEntraIdGroupIds: msEntraIdGroupIds })=>({
        name: name,
        isShared: true,
        autoGenerated: false,
        permissions: permissions.map((0, $f2fb95f29536f564$export$317b1a0b2887369e)),
        ldapGroupDn: (0, $ab33a7b7001a2cff$export$397cfe51d4da1529)(ldapGroupDn, undefined),
        msEntraIdGroupIds: $5f60db03862c79b6$var$mapMSEntraIdGroupIds(msEntraIdGroupIds)
    });
const $5f60db03862c79b6$export$9d45d804e02b5125 = ({ name: name, permissions: permissions, ldapGroupDn: ldapGroupDn, msEntraIdGroupIds: msEntraIdGroupIds })=>({
        name: name,
        isShared: true,
        permissions: permissions.map((0, $f2fb95f29536f564$export$c3d342751d02bf94)),
        ldapGroupDn: (0, $ab33a7b7001a2cff$export$397cfe51d4da1529)(ldapGroupDn, undefined),
        msEntraIdGroupIds: $5f60db03862c79b6$var$mapMSEntraIdGroupIds(msEntraIdGroupIds)
    });






const $656af6a2b7258de8$var$mapRoles = (roles)=>roles.map(({ id: id })=>id);
const $656af6a2b7258de8$var$createBasicMapper = (map)=>(prop)=>map(prop);
const $656af6a2b7258de8$var$mapMqttPublishPrefix = $656af6a2b7258de8$var$createBasicMapper((v)=>v === null ? '' : (0, $ab33a7b7001a2cff$export$397cfe51d4da1529)(v, undefined));
const $656af6a2b7258de8$var$mapPassword = $656af6a2b7258de8$var$createBasicMapper((v)=>(0, $ab33a7b7001a2cff$export$397cfe51d4da1529)(v, undefined));
const $656af6a2b7258de8$export$b16d1d84d85c9892 = ({ authenticationMethods: authenticationMethods, mfaStatus: mfaStatus, username: username, permissions: permissions, roles: roles, password: password, mqttPublishPrefix: mqttPublishPrefix, isMfaEnforced: isMfaEnforced })=>({
        roles: roles && $656af6a2b7258de8$var$mapRoles(roles),
        password: $656af6a2b7258de8$var$mapPassword(password),
        mqttPublishPrefix: $656af6a2b7258de8$var$mapMqttPublishPrefix(mqttPublishPrefix),
        enforceMFAEnrollment: (0, $ab33a7b7001a2cff$export$397cfe51d4da1529)(isMfaEnforced, undefined),
        grantTypes: authenticationMethods?.map((0, $00c873ed0924df12$export$726b337719677769)),
        // Set "disableMfa" to true for the user if request.mfaStatus is DISABLED, otherwise keep MFA enabled if request.mfa is ENABLED
        disableMfa: mfaStatus && mfaStatus === (0, $37c2a8e29603f683$export$5e93ec1eb1a0effa).DISABLED,
        username: username,
        permissions: permissions?.map((0, $f2fb95f29536f564$export$c3d342751d02bf94))
    });
const $656af6a2b7258de8$export$232225f9e38944cd = ({ username: username, permissions: permissions, authenticationMethods: authenticationMethods, roles: roles, password: password, mqttPublishPrefix: mqttPublishPrefix, isMfaEnforced: isMfaEnforced })=>({
        roles: $656af6a2b7258de8$var$mapRoles(roles),
        password: $656af6a2b7258de8$var$mapPassword(password),
        mqttPublishPrefix: $656af6a2b7258de8$var$mapMqttPublishPrefix(mqttPublishPrefix),
        enforceMFAEnrollment: isMfaEnforced === true,
        grantTypes: authenticationMethods.map((0, $00c873ed0924df12$export$726b337719677769)),
        username: username,
        initialPermissions: permissions.map((0, $f2fb95f29536f564$export$c3d342751d02bf94)),
        identityProvider: 'local',
        autoGenerated: false
    });




/** This script was auto generated by 'TypeValidatorCreator' at 'src/infrastructure/scripts/Typescript/TypeValidator.ts' **/ 
const $2ac96a8f7ee1f7e0$var$MinimalInvalidOTPResponseSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalInvalidOTPResponse',
    definitions: {
        MinimalInvalidOTPResponse: {
            anyOf: [
                {
                    type: 'object',
                    properties: {
                        error: {
                            type: 'string',
                            const: 'invalid'
                        },
                        msg: {
                            type: 'string'
                        }
                    },
                    required: [
                        'error',
                        'msg'
                    ]
                },
                {
                    type: 'object',
                    properties: {
                        error: {
                            type: 'string',
                            const: 'wrong OTP'
                        },
                        triesLeft: {
                            type: 'number'
                        },
                        banDurationMinutes: {
                            type: 'number'
                        },
                        msg: {
                            type: 'string'
                        }
                    },
                    required: [
                        'error',
                        'triesLeft',
                        'banDurationMinutes',
                        'msg'
                    ]
                },
                {
                    $ref: '#/definitions/ReadonlyRecord%3Cstring%2Cnever%3E'
                }
            ],
            deprecated: true
        },
        'ReadonlyRecord<string,never>': {
            type: 'object',
            additionalProperties: {
                not: {}
            }
        }
    }
};
const $2ac96a8f7ee1f7e0$export$630ca1ad7a8ec15b = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($2ac96a8f7ee1f7e0$var$MinimalInvalidOTPResponseSchema, 'isMinimalInvalidOTPResponse');
const $2ac96a8f7ee1f7e0$var$MinimalLoginResponseSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalLoginResponse',
    definitions: {
        MinimalLoginResponse: {
            anyOf: [
                {
                    type: 'object',
                    properties: {
                        expiresAt: {
                            type: 'string',
                            description: 'ISO Format'
                        },
                        permissions: {
                            type: 'array',
                            items: {
                                $ref: '#/definitions/Permission'
                            }
                        },
                        token: {
                            type: 'string'
                        }
                    },
                    required: [
                        'expiresAt',
                        'permissions',
                        'token'
                    ]
                },
                {
                    type: 'object',
                    properties: {
                        enforceMFAEnrollment: {
                            type: 'boolean',
                            const: true
                        },
                        expiresAt: {
                            type: 'string',
                            description: 'ISO Format'
                        },
                        permissions: {
                            type: 'array',
                            items: {
                                $ref: '#/definitions/Permission'
                            }
                        },
                        token: {
                            type: 'string'
                        }
                    },
                    required: [
                        'enforceMFAEnrollment',
                        'expiresAt',
                        'permissions',
                        'token'
                    ]
                },
                {
                    type: 'object',
                    properties: {
                        expiresAt: {
                            type: 'string',
                            description: 'ISO Format'
                        },
                        needsMfa: {
                            type: 'boolean',
                            const: true
                        },
                        secret: {
                            type: 'string'
                        }
                    },
                    required: [
                        'expiresAt',
                        'needsMfa',
                        'secret'
                    ]
                }
            ],
            deprecated: true
        },
        Permission: {
            type: 'object',
            properties: {
                id: {
                    type: 'string'
                },
                context: {
                    type: 'string',
                    enum: [
                        'control_plane',
                        'http',
                        'mqtt'
                    ]
                },
                operation: {
                    type: 'string',
                    enum: [
                        'read',
                        'write',
                        'readWrite'
                    ]
                },
                resource: {
                    type: 'string'
                }
            },
            required: [
                'id',
                'context',
                'operation',
                'resource'
            ],
            deprecated: true
        }
    }
};
const $2ac96a8f7ee1f7e0$export$abbe07dbddb41c30 = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($2ac96a8f7ee1f7e0$var$MinimalLoginResponseSchema, 'isMinimalLoginResponse');
const $2ac96a8f7ee1f7e0$var$MinimalPaginatedPermissionsResponseSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalPaginatedPermissionsResponse',
    definitions: {
        MinimalPaginatedPermissionsResponse: {
            type: 'object',
            properties: {
                permissions: {
                    type: 'array',
                    items: {
                        $ref: '#/definitions/PermissionWithUsage'
                    }
                },
                pagination: {
                    $ref: '#/definitions/Pagination'
                }
            },
            required: [
                'permissions',
                'pagination'
            ],
            deprecated: true
        },
        PermissionWithUsage: {
            type: 'object',
            properties: {
                usage: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            operation: {
                                type: 'string',
                                enum: [
                                    'read',
                                    'write',
                                    'readWrite'
                                ]
                            },
                            roleId: {
                                type: 'string'
                            },
                            roleName: {
                                type: 'string'
                            },
                            isRoleShared: {
                                type: 'boolean'
                            },
                            userId: {
                                type: [
                                    'string',
                                    'null'
                                ]
                            },
                            username: {
                                type: [
                                    'string',
                                    'null'
                                ]
                            }
                        },
                        required: [
                            'operation',
                            'roleId',
                            'roleName',
                            'isRoleShared',
                            'userId',
                            'username'
                        ]
                    }
                },
                resource: {
                    type: 'string'
                },
                context: {
                    type: 'string',
                    enum: [
                        'control_plane',
                        'http',
                        'mqtt'
                    ]
                }
            },
            required: [
                'context',
                'resource',
                'usage'
            ],
            deprecated: true
        },
        Pagination: {
            type: 'object',
            properties: {
                totalPages: {
                    type: 'number'
                },
                nextPage: {
                    type: 'number'
                },
                pageNumber: {
                    type: 'number'
                },
                rowsPerPage: {
                    type: 'number'
                },
                totalRows: {
                    type: 'number'
                },
                totalRowsInPage: {
                    type: 'number'
                }
            },
            required: [
                'totalPages',
                'nextPage',
                'pageNumber',
                'rowsPerPage',
                'totalRows',
                'totalRowsInPage'
            ],
            deprecated: true
        }
    }
};
const $2ac96a8f7ee1f7e0$export$e7411a746fe2a7f2 = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($2ac96a8f7ee1f7e0$var$MinimalPaginatedPermissionsResponseSchema, 'isMinimalPaginatedPermissionsResponse');
const $2ac96a8f7ee1f7e0$var$MinimalPaginatedRolesSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalPaginatedRoles',
    definitions: {
        MinimalPaginatedRoles: {
            type: 'object',
            properties: {
                roles: {
                    type: 'array',
                    items: {
                        $ref: '#/definitions/PaginatedRole'
                    }
                },
                pagination: {
                    $ref: '#/definitions/Pagination'
                }
            },
            required: [
                'roles',
                'pagination'
            ],
            deprecated: true
        },
        PaginatedRole: {
            type: 'object',
            properties: {
                id: {
                    type: 'string'
                },
                name: {
                    type: 'string'
                },
                isshared: {
                    type: 'boolean'
                },
                autogenerated: {
                    type: 'boolean'
                },
                permissions: {
                    anyOf: [
                        {
                            type: 'array',
                            items: {
                                $ref: '#/definitions/Permission'
                            }
                        },
                        {
                            type: 'array',
                            items: {
                                $ref: '#/definitions/ReadonlyRecord%3C(%22id%22%7C%22context%22%7C%22operation%22%7C%22resource%22%7Cstring)%2Cnull%3E'
                            },
                            minItems: 1,
                            maxItems: 1
                        }
                    ]
                },
                users: {
                    anyOf: [
                        {
                            type: 'array',
                            items: {
                                type: 'object',
                                properties: {
                                    id: {
                                        type: 'string'
                                    },
                                    username: {
                                        type: 'string'
                                    }
                                },
                                required: [
                                    'id',
                                    'username'
                                ]
                            }
                        },
                        {
                            type: 'array',
                            items: {
                                type: 'object',
                                properties: {
                                    id: {
                                        type: 'null'
                                    },
                                    username: {
                                        type: 'null'
                                    }
                                },
                                required: [
                                    'id',
                                    'username'
                                ]
                            },
                            minItems: 1,
                            maxItems: 1
                        }
                    ]
                },
                ldapgroupdn: {
                    type: 'string'
                },
                msEntraIdGroupIds: {
                    type: 'string'
                }
            },
            required: [
                'id',
                'name',
                'isshared',
                'autogenerated',
                'permissions',
                'users',
                'ldapgroupdn'
            ],
            deprecated: true
        },
        Permission: {
            type: 'object',
            properties: {
                id: {
                    type: 'string'
                },
                context: {
                    type: 'string',
                    enum: [
                        'control_plane',
                        'http',
                        'mqtt'
                    ]
                },
                operation: {
                    type: 'string',
                    enum: [
                        'read',
                        'write',
                        'readWrite'
                    ]
                },
                resource: {
                    type: 'string'
                }
            },
            required: [
                'id',
                'context',
                'operation',
                'resource'
            ],
            deprecated: true
        },
        'ReadonlyRecord<("id"|"context"|"operation"|"resource"|string),null>': {
            type: 'object',
            properties: {
                id: {
                    type: 'null'
                },
                context: {
                    type: 'null'
                },
                operation: {
                    type: 'null'
                },
                resource: {
                    type: 'null'
                }
            },
            required: [
                'id',
                'context',
                'operation',
                'resource'
            ],
            additionalProperties: {
                type: 'null'
            }
        },
        Pagination: {
            type: 'object',
            properties: {
                totalPages: {
                    type: 'number'
                },
                nextPage: {
                    type: 'number'
                },
                pageNumber: {
                    type: 'number'
                },
                rowsPerPage: {
                    type: 'number'
                },
                totalRows: {
                    type: 'number'
                },
                totalRowsInPage: {
                    type: 'number'
                }
            },
            required: [
                'totalPages',
                'nextPage',
                'pageNumber',
                'rowsPerPage',
                'totalRows',
                'totalRowsInPage'
            ],
            deprecated: true
        }
    }
};
const $2ac96a8f7ee1f7e0$export$a236aa769d30c97e = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($2ac96a8f7ee1f7e0$var$MinimalPaginatedRolesSchema, 'isMinimalPaginatedRoles');
const $2ac96a8f7ee1f7e0$var$MinimalPaginatedUsersSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalPaginatedUsers',
    definitions: {
        MinimalPaginatedUsers: {
            type: 'object',
            properties: {
                users: {
                    type: 'array',
                    items: {
                        $ref: '#/definitions/User'
                    }
                },
                pagination: {
                    $ref: '#/definitions/Pagination'
                }
            },
            required: [
                'users',
                'pagination'
            ],
            deprecated: true
        },
        User: {
            type: 'object',
            properties: {
                id: {
                    type: 'string'
                },
                autoGenerated: {
                    type: 'boolean'
                },
                username: {
                    type: 'string'
                },
                identityProvider: {
                    type: 'string',
                    enum: [
                        'local',
                        'ldap',
                        'msentraid'
                    ]
                },
                grantTypes: {
                    type: 'array',
                    items: {
                        $ref: '#/definitions/GrantType'
                    }
                },
                tokens: {
                    type: 'array',
                    items: {
                        $ref: '#/definitions/ReadonlyRecord%3C(%22fingerprint%22%7C%22created_at%22%7C%22expires_at%22)%2Cstring%3E'
                    }
                },
                roles: {
                    type: 'array',
                    items: {
                        $ref: '#/definitions/Role'
                    }
                },
                mqttPublishPrefix: {
                    type: [
                        'string',
                        'null'
                    ]
                },
                mfa_is_enrolled: {
                    type: 'boolean'
                },
                enforceMFAEnrollment: {
                    type: 'boolean'
                }
            },
            required: [
                'id',
                'autoGenerated',
                'username',
                'identityProvider',
                'grantTypes',
                'tokens',
                'roles',
                'mqttPublishPrefix',
                'mfa_is_enrolled',
                'enforceMFAEnrollment'
            ],
            deprecated: true
        },
        GrantType: {
            type: 'object',
            properties: {
                method: {
                    $ref: '#/definitions/Method'
                },
                isRequired: {
                    type: 'boolean'
                }
            },
            required: [
                'method',
                'isRequired'
            ],
            deprecated: true
        },
        Method: {
            type: 'string',
            enum: [
                'password',
                'token',
                'certificate'
            ],
            deprecated: true
        },
        'ReadonlyRecord<("fingerprint"|"created_at"|"expires_at"),string>': {
            type: 'object',
            properties: {
                fingerprint: {
                    type: 'string'
                },
                created_at: {
                    type: 'string'
                },
                expires_at: {
                    type: 'string'
                }
            },
            required: [
                'fingerprint',
                'created_at',
                'expires_at'
            ]
        },
        Role: {
            type: 'object',
            properties: {
                id: {
                    type: 'string'
                },
                name: {
                    type: 'string'
                },
                isShared: {
                    type: 'boolean'
                },
                autoGenerated: {
                    type: 'boolean'
                },
                ldapGroupDn: {
                    type: 'string'
                },
                permissions: {
                    type: 'array',
                    items: {
                        $ref: '#/definitions/Permission'
                    }
                }
            },
            required: [
                'id',
                'name',
                'isShared',
                'autoGenerated',
                'permissions'
            ],
            deprecated: true
        },
        Permission: {
            type: 'object',
            properties: {
                id: {
                    type: 'string'
                },
                context: {
                    type: 'string',
                    enum: [
                        'control_plane',
                        'http',
                        'mqtt'
                    ]
                },
                operation: {
                    type: 'string',
                    enum: [
                        'read',
                        'write',
                        'readWrite'
                    ]
                },
                resource: {
                    type: 'string'
                }
            },
            required: [
                'id',
                'context',
                'operation',
                'resource'
            ],
            deprecated: true
        },
        Pagination: {
            type: 'object',
            properties: {
                totalPages: {
                    type: 'number'
                },
                nextPage: {
                    type: 'number'
                },
                pageNumber: {
                    type: 'number'
                },
                rowsPerPage: {
                    type: 'number'
                },
                totalRows: {
                    type: 'number'
                },
                totalRowsInPage: {
                    type: 'number'
                }
            },
            required: [
                'totalPages',
                'nextPage',
                'pageNumber',
                'rowsPerPage',
                'totalRows',
                'totalRowsInPage'
            ],
            deprecated: true
        }
    }
};
const $2ac96a8f7ee1f7e0$export$46d84700cabff15c = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($2ac96a8f7ee1f7e0$var$MinimalPaginatedUsersSchema, 'isMinimalPaginatedUsers');
const $2ac96a8f7ee1f7e0$var$MinimalPermissionIndexSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalPermissionIndex',
    definitions: {
        MinimalPermissionIndex: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    ids: {
                        type: 'array',
                        items: {
                            type: 'string'
                        }
                    },
                    context: {
                        type: 'string',
                        enum: [
                            'control_plane',
                            'http',
                            'mqtt'
                        ]
                    },
                    operation: {
                        type: 'string',
                        enum: [
                            'read',
                            'write',
                            'readWrite'
                        ]
                    },
                    resource: {
                        type: 'string'
                    }
                },
                required: [
                    'context',
                    'ids',
                    'operation',
                    'resource'
                ]
            },
            deprecated: true
        }
    }
};
const $2ac96a8f7ee1f7e0$export$48790baae9c4b9fb = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($2ac96a8f7ee1f7e0$var$MinimalPermissionIndexSchema, 'isMinimalPermissionIndex');
const $2ac96a8f7ee1f7e0$var$MinimalRoleIndexSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalRoleIndex',
    definitions: {
        MinimalRoleIndex: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: [
                    'id',
                    'name'
                ]
            },
            deprecated: true
        }
    }
};
const $2ac96a8f7ee1f7e0$export$1a6f26674b9f5253 = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($2ac96a8f7ee1f7e0$var$MinimalRoleIndexSchema, 'isMinimalRoleIndex');
const $2ac96a8f7ee1f7e0$var$MinimalSessionResponseSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalSessionResponse',
    definitions: {
        MinimalSessionResponse: {
            type: 'object',
            properties: {
                username: {
                    type: 'string'
                },
                expiresAt: {
                    type: 'string',
                    description: 'ISO Format'
                },
                permissions: {
                    type: 'array',
                    items: {
                        $ref: '#/definitions/Permission'
                    }
                },
                mfa: {
                    $ref: '#/definitions/ReadonlyRecord%3C(%22enabled%22%7C%22enforced%22)%2Cboolean%3E'
                }
            },
            required: [
                'username',
                'expiresAt',
                'permissions',
                'mfa'
            ],
            deprecated: true
        },
        Permission: {
            type: 'object',
            properties: {
                id: {
                    type: 'string'
                },
                context: {
                    type: 'string',
                    enum: [
                        'control_plane',
                        'http',
                        'mqtt'
                    ]
                },
                operation: {
                    type: 'string',
                    enum: [
                        'read',
                        'write',
                        'readWrite'
                    ]
                },
                resource: {
                    type: 'string'
                }
            },
            required: [
                'id',
                'context',
                'operation',
                'resource'
            ],
            deprecated: true
        },
        'ReadonlyRecord<("enabled"|"enforced"),boolean>': {
            type: 'object',
            properties: {
                enabled: {
                    type: 'boolean'
                },
                enforced: {
                    type: 'boolean'
                }
            },
            required: [
                'enabled',
                'enforced'
            ]
        }
    }
};
const $2ac96a8f7ee1f7e0$export$789d333a25e72e4 = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($2ac96a8f7ee1f7e0$var$MinimalSessionResponseSchema, 'isMinimalSessionResponse');
const $2ac96a8f7ee1f7e0$var$MinimalUserBannedResponseSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalUserBannedResponse',
    definitions: {
        MinimalUserBannedResponse: {
            type: 'object',
            properties: {
                error: {
                    type: 'string',
                    const: 'banned'
                },
                minutesUntilBanEnd: {
                    type: 'number'
                },
                msg: {
                    type: 'string'
                }
            },
            required: [
                'error',
                'minutesUntilBanEnd',
                'msg'
            ],
            deprecated: true
        }
    }
};
const $2ac96a8f7ee1f7e0$export$ff533d9ecafcc6ac = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($2ac96a8f7ee1f7e0$var$MinimalUserBannedResponseSchema, 'isMinimalUserBannedResponse');
const $2ac96a8f7ee1f7e0$var$MinimalUserIndexSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalUserIndex',
    definitions: {
        MinimalUserIndex: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    username: {
                        type: 'string'
                    }
                },
                required: [
                    'id',
                    'username'
                ]
            },
            deprecated: true
        }
    }
};
const $2ac96a8f7ee1f7e0$export$5385b1c35192ddfa = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($2ac96a8f7ee1f7e0$var$MinimalUserIndexSchema, 'isMinimalUserIndex');


const $864836966eac5047$var$createIgnorer = (value)=>()=>value;
const $864836966eac5047$var$ignoreOrchestratorError = $864836966eac5047$var$createIgnorer(null);
const $864836966eac5047$var$ignoreMfaError = $864836966eac5047$var$createIgnorer(false);
class $864836966eac5047$export$57eaa77631f4ce6e extends (0, $213eb4f80b1949e4$export$43987bf911e030a5) {
    constructor(...[options]){
        super(options), this.ssoUrlLoginPaths = {
            [(0, $eba4f0b13361fb3e$export$a0bf97755470bf0e).MICROSOFT_ENTRA_ID]: '/api/msEntraId/login'
        }, this.ssoFetchers = {
            [(0, $eba4f0b13361fb3e$export$a0bf97755470bf0e).MICROSOFT_ENTRA_ID]: ()=>this.fetchEntraStatus()
        }, /**
     * These are preflight checks to validate how Connectware is running
     * They assist the service implementation mappers to drop certain capabilities in case the system can not
     * provide them
     */ this.capabilitiesCheckers = {
            orchestrator: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)((token)=>this.request({
                    capability: null,
                    method: 'GET',
                    path: '/api/containers/orchestrator',
                    authenticate: token,
                    handlers: {
                        200: (response)=>response.getJson().then(({ orchestrator: orchestrator })=>orchestrator),
                        403: $864836966eac5047$var$ignoreOrchestratorError,
                        503: $864836966eac5047$var$ignoreOrchestratorError
                    }
                })),
            mfa: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)((token)=>this.request({
                    capability: null,
                    method: 'GET',
                    path: '/api/auth/mfa',
                    authenticate: token,
                    handlers: {
                        /**
                     * It should return a boolean because
                     * 'unavailableMfaConfiguration' in src/infrastructure/Connectware/Capabilities.ts
                     * handles only two cases (true/false).
                     * If, for some reason, 'enabled' returns something other than a Boolean (e.g., null or undefined),
                     * then MFA could mistakenly be activated.
                     */ 200: (response)=>response.getJson().then(({ enabled: enabled })=>Boolean(enabled)),
                        403: $864836966eac5047$var$ignoreMfaError,
                        503: $864836966eac5047$var$ignoreMfaError
                    }
                }))
        };
        this.baseURL = options.baseURL;
    }
    createAuthenticationCapabilityCheckers(token) {
        return {
            orchestrator: ()=>this.capabilitiesCheckers.orchestrator(token),
            isMfaActive: ()=>this.capabilitiesCheckers.mfa(token)
        };
    }
    mfaLogin({ secret: secret, username: username, ...request }) {
        return this.request({
            capability: null,
            method: 'POST',
            path: '/api/mfa/login',
            body: {
                secret: secret,
                username: username,
                ...'backupCode' in request ? (0, $e3e007a8c1000cbf$export$87cc10034f209096)(request.backupCode) : (0, $e3e007a8c1000cbf$export$86bc19431a0aa06c)(request.otp)
            },
            handlers: {
                200: (response)=>(0, $773d9142ff567164$export$b1a19a9e61b09890)(response, (0, $2ac96a8f7ee1f7e0$export$abbe07dbddb41c30)),
                400: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, 'There were issues while authenticating the user'),
                401: async (response)=>{
                    const json = await (0, $773d9142ff567164$export$b1a19a9e61b09890)(response, (0, $2ac96a8f7ee1f7e0$export$630ca1ad7a8ec15b));
                    if (json.error === 'invalid') return new (0, $ce07554ccb7fdbc8$export$f4d656254be083ec)();
                    if (json.error === 'wrong OTP') return new (0, $a477639c40078c3a$export$596874a932ac8047)({
                        minutesUntilRetry: json.banDurationMinutes,
                        triesLeft: json.triesLeft
                    });
                    return new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, 'Invalid backupCode');
                },
                403: async (response)=>{
                    const { minutesUntilBanEnd: minutesUntilBanEnd } = await (0, $773d9142ff567164$export$b1a19a9e61b09890)(response, (0, $2ac96a8f7ee1f7e0$export$ff533d9ecafcc6ac));
                    return new (0, $a477639c40078c3a$export$596874a932ac8047)({
                        minutesUntilRetry: minutesUntilBanEnd,
                        triesLeft: null
                    });
                },
                500: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, '500 Internal Server Error')
            }
        });
    }
    login(request) {
        return this.request({
            capability: null,
            method: 'POST',
            path: '/api/login',
            body: request,
            handlers: {
                200: (response)=>(0, $773d9142ff567164$export$b1a19a9e61b09890)(response, (0, $2ac96a8f7ee1f7e0$export$abbe07dbddb41c30)),
                400: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST, 'Unexpected bad request detected while attempting to login'),
                401: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, 'There were issues while authenticating the user'),
                403: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, 'There were issues while authenticating the user'),
                500: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, '500 Internal Server Error')
            }
        });
    }
    fetchBackendSession(token) {
        return this.request({
            capability: null,
            method: 'GET',
            path: '/api/session',
            authenticate: token,
            handlers: {
                200: (response)=>(0, $773d9142ff567164$export$b1a19a9e61b09890)(response, (0, $2ac96a8f7ee1f7e0$export$789d333a25e72e4)),
                401: ()=>new (0, $ce07554ccb7fdbc8$export$49118b1f444502b4)(),
                403: ()=>new (0, $ce07554ccb7fdbc8$export$49118b1f444502b4)(),
                500: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, '500 Internal Server Error')
            }
        });
    }
    async authenticate(request) {
        const backendResponse = await ('secret' in request ? this.mfaLogin(request) : this.login(request));
        if ('needsMfa' in backendResponse) throw new (0, $37c2a8e29603f683$export$c59494f4dae44ada)(backendResponse.secret);
        const loginResponse = await (0, $212117f309d44a12$export$54f12192840496b1)(backendResponse, this.createAuthenticationCapabilityCheckers(backendResponse.token));
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(!('enforceMFAEnrollment' in backendResponse), new (0, $37c2a8e29603f683$export$a3dab68f7f8fa48c)(loginResponse));
        return loginResponse;
    }
    fetchSession(token) {
        return this.fetchBackendSession(token).then((response)=>(0, $212117f309d44a12$export$a9f28f1e898d769b)(response, this.createAuthenticationCapabilityCheckers(token)));
    }
    fetchAuthenticationStatus(token) {
        return this.fetchBackendSession(token).then(({ mfa: { enabled: enabled, enforced: enforced } })=>({
                isMfaEnabled: enabled,
                isMfaRequired: enforced
            }));
    }
    async fetchActiveSSOAuthenticationMethods() {
        const enabledSSOTypes = await Promise.all((0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(this.ssoFetchers).map(([type, fetchIsEnabled])=>fetchIsEnabled().then((enabled)=>enabled ? [
                    type
                ] : [])));
        return enabledSSOTypes.flat();
    }
    fetchSSOAuthenticationUrl(type) {
        return Promise.resolve(new URL(this.ssoUrlLoginPaths[type], this.baseURL));
    }
    flushAuthentication(token) {
        return this.request({
            capability: null,
            method: 'POST',
            path: '/api/logout',
            body: {
                token: token
            },
            handlers: {
                200: ()=>Promise.resolve(),
                400: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST, 'Bad request while logging out detected'),
                404: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).NOT_FOUND, 'User for logout not found')
            }
        });
    }
}







var $de9ff110c4fb8f3e$export$8fca665bf5e4360e;
var $de9ff110c4fb8f3e$export$ee7e0197905d8275;
var $2fcf4cee4236d1d6$export$8fca665bf5e4360e;
var $d72f3010f4e0fe29$export$1b18610ae7fc0469;
class $d72f3010f4e0fe29$var$PolicyValidator {
    constructor(args){
        this._args = args;
    }
    validate(value) {
        const { thresholds: thresholds, createCollector: createCollector } = this._args;
        const collector = createCollector();
        for (const [name, scoreExtractor] of Object.entries(this._scoreExtractors)){
            /**
             * Thresholds are optional, if none is passed, then use the requirement of zero
             */ const threshold = thresholds[name] ?? 0;
            /**
             * Then extract the score from the input
             */ const score = value.match(scoreExtractor)?.length ?? 0;
            collector.add({
                name: name,
                score: score,
                threshold: threshold,
                valid: score >= threshold
            });
        }
        return collector.values;
    }
}
$d72f3010f4e0fe29$export$1b18610ae7fc0469 = $d72f3010f4e0fe29$var$PolicyValidator;


var $2fcf4cee4236d1d6$require$PolicyValidator = $d72f3010f4e0fe29$export$1b18610ae7fc0469;
class $2fcf4cee4236d1d6$var$PasswordPolicyValidator extends $2fcf4cee4236d1d6$require$PolicyValidator {
    _scoreExtractors = {
        minLength: /./gu,
        symbol: /\p{Symbol}|\p{Punctuation}/gu,
        lower: /\p{Lowercase_Letter}/gu,
        upper: /\p{Uppercase_Letter}/gu,
        numeric: /\p{Number}/gu
    };
}
$2fcf4cee4236d1d6$export$8fca665bf5e4360e = $2fcf4cee4236d1d6$var$PasswordPolicyValidator;


var $de9ff110c4fb8f3e$require$PasswordPolicyValidator = $2fcf4cee4236d1d6$export$8fca665bf5e4360e;
var $d4a9043f81dd3e34$export$ee7e0197905d8275;

var $d4a9043f81dd3e34$require$PolicyValidator = $d72f3010f4e0fe29$export$1b18610ae7fc0469;
class $d4a9043f81dd3e34$var$UsernamePolicyValidator extends $d4a9043f81dd3e34$require$PolicyValidator {
    _scoreExtractors = {
        minLength: /./gu
    };
}
$d4a9043f81dd3e34$export$ee7e0197905d8275 = $d4a9043f81dd3e34$var$UsernamePolicyValidator;


var $de9ff110c4fb8f3e$require$UsernamePolicyValidator = $d4a9043f81dd3e34$export$ee7e0197905d8275;
$de9ff110c4fb8f3e$export$8fca665bf5e4360e = $de9ff110c4fb8f3e$require$PasswordPolicyValidator;
$de9ff110c4fb8f3e$export$ee7e0197905d8275 = $de9ff110c4fb8f3e$require$UsernamePolicyValidator;



class $70a28598c522e07a$var$PolicyValidator {
    constructor(ValidatorConstructor, translationService, translation){
        this.ValidatorConstructor = ValidatorConstructor;
        this.translationService = translationService;
        this.translation = translation;
    }
    createCollector() {
        const values = [];
        return {
            add: ({ name: name, threshold: threshold, valid: valid })=>{
                if (threshold === 0) /** We don't care about these scenarios */ return;
                const message = this.translationService.translate(this.translation, {
                    type: name,
                    count: threshold
                });
                values.push(valid ? message : new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).GENERAL_BUSINESS_RULE_INFRACTION, message));
            },
            values: values
        };
    }
    async validate(policyPromise, input) {
        return new this.ValidatorConstructor({
            thresholds: await policyPromise,
            createCollector: ()=>this.createCollector()
        }).validate(input);
    }
}
const $70a28598c522e07a$var$policyPromiseTransformer = ({ min: min, ...value })=>({
        ...value,
        minLength: min
    });
class $70a28598c522e07a$export$2fcdcbdb51067c1b {
    constructor(translationService){
        this.usernameValidator = new $70a28598c522e07a$var$PolicyValidator((0, $de9ff110c4fb8f3e$export$ee7e0197905d8275), translationService, (0, $40a99dac858c1d75$export$b63289fbda65eed1).USERNAME_VALIDATION);
        this.passwordValidator = new $70a28598c522e07a$var$PolicyValidator((0, $de9ff110c4fb8f3e$export$8fca665bf5e4360e), translationService, (0, $40a99dac858c1d75$export$b63289fbda65eed1).PASSWORD_VALIDATION);
    }
    validatePassword(policy, password) {
        return this.passwordValidator.validate(policy.then($70a28598c522e07a$var$policyPromiseTransformer), password);
    }
    validateUsername(policy, username) {
        return this.usernameValidator.validate(policy.then($70a28598c522e07a$var$policyPromiseTransformer), username);
    }
}




class $aa4392e9b05870a9$export$87d57c8fe3c44227 {
    constructor(config){
        this.config = config;
    }
    async requestMatches(args) {
        const { requestIndex: requestIndex, doesIndexMatch: isBeingSearched } = this.config;
        const index = await requestIndex();
        return index.filter((index)=>isBeingSearched(index, args));
    }
    async requestPage(args) {
        const { requestMetadata: requestMetadata, requestPage: requestPage, mapDataToPage: mapDataToPage } = this.config;
        const [metadata, data] = await Promise.all([
            requestMetadata(),
            requestPage(args)
        ]);
        return mapDataToPage(data, metadata);
    }
    async fetchInternalPage(args) {
        const { shouldRequestIndex: shouldRequestIndex } = this.config;
        const { search: search, isSearchExact: isSearchExact, pageNumber: pageNumber, pageSize: pageSize, showInternal: showInternal } = args;
        const normalized = (0, $1e2b62fb1507b421$export$a3295358bff77e)(search.trim());
        let matches = null;
        /**
         * If there is an item to be searched, or if the match needs to be 100%
         * Then fetch the index and retrieve the matches
         *
         * If there are no matches already, then simply give up
         */ if (normalized || isSearchExact || shouldRequestIndex?.(args)) {
            const matchingIndexes = await this.requestMatches({
                normalized: normalized,
                raw: search,
                isExact: isSearchExact,
                showInternal: showInternal
            });
            if (!(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(matchingIndexes)) return {
                current: [],
                totalCount: 0,
                pageSize: pageSize,
                page: 1
            };
            matches = matchingIndexes;
        }
        return this.requestPage({
            pageNumber: pageNumber,
            pageSize: pageSize,
            showInternal: showInternal,
            matches: matches
        });
    }
    async fetchPage(search, showInternal, pageNumber) {
        return this.fetchInternalPage({
            search: search,
            isSearchExact: false,
            pageNumber: pageNumber,
            pageSize: this.config.pagination.pageSize,
            showInternal: showInternal
        });
    }
    async fetch(rawSearch) {
        const { current: current } = await this.fetchInternalPage({
            search: rawSearch,
            isSearchExact: false,
            pageNumber: 1,
            pageSize: this.config.pagination.searchSize,
            showInternal: false
        });
        return current;
    }
    async fetchOne(name) {
        const { current: current } = await this.fetchInternalPage({
            search: name,
            isSearchExact: true,
            pageNumber: 1,
            pageSize: 1,
            showInternal: null
        });
        (0, $14eddac5f20c576c$export$a7a9523472993e97)((0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(current), new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).NOT_FOUND, 'Entity not found', {
            name: name
        }));
        return current[0];
    }
}



const $5ffa9b3caa9d9b5d$export$84879ab3e22cc10d = 'GROUP';
class $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5 extends (0, $213eb4f80b1949e4$export$43987bf911e030a5) {
    static createErrorHandler(...params) {
        return ()=>Promise.reject(new (0, $c3e1b746ad236797$export$8d524fb6540252df)(...params));
    }
    static createBadRequestHandler(action, extras) {
        return this.createErrorHandler((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST, `Unexpected bad request detected while ${action}`, extras);
    }
    static createAuthenticationErrorHandler(message) {
        return this.createErrorHandler((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, message);
    }
    static createNotFoundHandler(message, extras) {
        return this.createErrorHandler((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).NOT_FOUND, message, extras);
    }
    constructor(options, config, translationService){
        super(options), this.config = config, this.translationService = translationService, this.fetchUsernamePolicy = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.request({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).RETRIEVE_USERNAME_POLICY,
                method: 'GET',
                path: '/api/policy/username',
                authenticate: true,
                handlers: {
                    200: (r)=>r.getJson(),
                    503: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_NOT_AVAILABLE, 'Network error when reaching server')
                }
            }), true), this.fetchPasswordPolicy = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.request({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).RETRIEVE_PASSWORD_POLICY,
                method: 'GET',
                path: '/api/policy/password',
                authenticate: true,
                handlers: {
                    200: (r)=>r.getJson(),
                    503: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_NOT_AVAILABLE, 'Network error when reaching server')
                }
            }), true), this.fetchUsernamesIndex = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.request({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_USERS,
                method: 'GET',
                path: '/api/users/usernames',
                authenticate: true,
                handlers: {
                    200: (r)=>(0, $773d9142ff567164$export$b1a19a9e61b09890)(r, (0, $2ac96a8f7ee1f7e0$export$5385b1c35192ddfa)).then((data)=>data.map((u)=>u.username))
                }
            }), true), this.fetchRoleNamesIndex = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.request({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_ROLES,
                method: 'GET',
                path: '/api/roles/names',
                authenticate: true,
                /** Filters out auto generated names which are internal roles */ handlers: {
                    200: (r)=>(0, $773d9142ff567164$export$b1a19a9e61b09890)(r, (0, $2ac96a8f7ee1f7e0$export$1a6f26674b9f5253)).then((roles)=>roles.filter((r)=>!/^\w{8}-\w{4}-\w{4}-\w{4}-\w{12}$/.test(r.name))),
                    401: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createAuthenticationErrorHandler('Authentication Error while fetching roles index'),
                    403: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createAuthenticationErrorHandler('Authorization Error while fetching roles index')
                }
            }), true), this.fetchPermissionsIndex = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.request({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_PERMISSIONS,
                method: 'GET',
                path: '/api/permissions/ids',
                authenticate: true,
                handlers: {
                    200: (r)=>(0, $773d9142ff567164$export$b1a19a9e61b09890)(r, (0, $2ac96a8f7ee1f7e0$export$48790baae9c4b9fb)),
                    401: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createAuthenticationErrorHandler('Authentication Error while fetching permissions index')
                }
            }), true), this.fetchMfaSetupStatus = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.request({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).USER_MANAGEMENT_CONFIGURATION,
                method: 'GET',
                path: '/api/auth/mfa',
                authenticate: true,
                handlers: {
                    200: (response)=>response.getJson().then(({ enabled: enabled })=>enabled),
                    403: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createAuthenticationErrorHandler('Could not fetch MFA status due to bad authentication'),
                    503: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, 'Could not fetch MFA status due to server error')
                }
            })), this./**
     * Fetches configuration which might affect user and role setup:
     * - LDAP
     * - MS Entra ID
     * - MFA
     */ fetchManagementConfiguration = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(async ()=>{
            const [isLdapEnabled, isEntraEnabled, isMfaEnabled] = await Promise.all([
                this.request({
                    capability: (0, $78670ebe9381a713$export$790a66df9dc00390).USER_MANAGEMENT_CONFIGURATION,
                    method: 'GET',
                    path: '/api/auth/ldap',
                    authenticate: true,
                    handlers: {
                        200: async (response)=>{
                            const { enabled: enabled, mode: mode } = await response.getJson();
                            return enabled && mode === $5ffa9b3caa9d9b5d$export$84879ab3e22cc10d;
                        }
                    }
                }),
                this.fetchEntraStatus(),
                this.fetchMfaSetupStatus()
            ]);
            return {
                isLdapEnabled: isLdapEnabled,
                isEntraEnabled: isEntraEnabled,
                isMfaEnabled: isMfaEnabled
            };
        }, true);
        const { usersConfig: usersConfig, pagination: pagination, cacheInterval: cacheInterval } = config;
        this.validator = new (0, $70a28598c522e07a$export$2fcdcbdb51067c1b)(translationService);
        const responseMapper = new (0, $1310fcd8620c6d10$export$63cf01fca918449e)(usersConfig);
        this.roleFetcher = new (0, $aa4392e9b05870a9$export$87d57c8fe3c44227)({
            pagination: pagination,
            requestIndex: ()=>this.fetchRoleNamesIndex(),
            requestPage: ({ pageNumber: pageNumber, pageSize: pageSize, showInternal: showInternal, matches: matches })=>this.request({
                    capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_ROLES,
                    method: 'GET',
                    path: '/api/roles/page',
                    authenticate: true,
                    queryParams: {
                        isShared: 'true',
                        rowsPerPage: `${pageSize}`,
                        pageNumber: `${pageNumber}`,
                        ...showInternal === null || showInternal ? {} : {
                            autoGenerated: 'false'
                        },
                        ...matches ? {
                            names: matches.map((m)=>m.name)
                        } : {}
                    },
                    handlers: {
                        200: (r)=>(0, $773d9142ff567164$export$b1a19a9e61b09890)(r, (0, $2ac96a8f7ee1f7e0$export$a236aa769d30c97e)),
                        400: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createBadRequestHandler('loading roles page', {
                            pageNumber: pageNumber,
                            pageSize: pageSize,
                            showInternal: showInternal,
                            matches: matches
                        }),
                        401: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createAuthenticationErrorHandler('Authentication Error while fetching roles page'),
                        403: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createAuthenticationErrorHandler('Authorization Error while fetching roles page')
                    }
                }),
            requestMetadata: ()=>this.fetchEntraStatus(),
            mapDataToPage: (response, isEntraEnabled)=>responseMapper.mapRolesPage(response, isEntraEnabled),
            doesIndexMatch: ({ name: name }, { isExact: isExact, raw: raw, normalized: normalized })=>isExact ? name === raw : (0, $1e2b62fb1507b421$export$a3295358bff77e)(name).includes(normalized)
        });
        this.userFetcher = new (0, $aa4392e9b05870a9$export$87d57c8fe3c44227)({
            pagination: pagination,
            requestIndex: ()=>this.fetchUsernamesIndex(),
            requestPage: ({ pageNumber: pageNumber, pageSize: pageSize, showInternal: showInternal, matches: matches })=>this.request({
                    capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_USERS,
                    method: 'GET',
                    path: '/api/listUsers',
                    queryParams: {
                        ...showInternal === null ? {} : {
                            excludeAutoGenerated: showInternal ? 'false' : 'true'
                        },
                        ...matches ? {
                            usernameEq: [
                                ...matches
                            ]
                        } : {},
                        rowsPerPage: `${pageSize}`,
                        pageNumber: `${pageNumber}`
                    },
                    authenticate: true,
                    handlers: {
                        200: (r)=>(0, $773d9142ff567164$export$b1a19a9e61b09890)(r, (0, $2ac96a8f7ee1f7e0$export$46d84700cabff15c)),
                        400: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createBadRequestHandler('loading users page', {
                            pageNumber: pageNumber,
                            pageSize: pageSize,
                            showInternal: showInternal,
                            matches: matches
                        }),
                        401: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createAuthenticationErrorHandler('Authentication Error while fetching users page'),
                        500: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createErrorHandler((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, 'Could not fetch users page', {
                            pageNumber: pageNumber,
                            pageSize: pageSize,
                            showInternal: showInternal,
                            matches: matches
                        })
                    }
                }),
            requestMetadata: ()=>this.fetchMfaSetupStatus(),
            mapDataToPage: (response, isMfaSetup)=>responseMapper.mapUsersPage(response, isMfaSetup),
            doesIndexMatch: (index, { isExact: isExact, raw: raw, normalized: normalized })=>isExact ? index === raw : (0, $1e2b62fb1507b421$export$a3295358bff77e)(index).includes(normalized)
        });
        this.permissionFetcher = new (0, $aa4392e9b05870a9$export$87d57c8fe3c44227)({
            pagination: pagination,
            requestIndex: ()=>this.fetchPermissionsIndex(),
            shouldRequestIndex: ({ showInternal: showInternal })=>showInternal === false,
            requestPage: ({ pageNumber: pageNumber, pageSize: pageSize, matches: matches })=>{
                return this.request({
                    capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_PERMISSIONS,
                    method: 'GET',
                    path: '/api/permissions/page',
                    queryParams: {
                        rowsPerPage: `${pageSize}`,
                        pageNumber: `${pageNumber}`,
                        ids: matches ? matches.flatMap(({ ids: ids })=>ids) : []
                    },
                    authenticate: true,
                    handlers: {
                        200: (r)=>(0, $773d9142ff567164$export$b1a19a9e61b09890)(r, (0, $2ac96a8f7ee1f7e0$export$e7411a746fe2a7f2)),
                        400: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createBadRequestHandler('loading permissions page', {
                            pageNumber: pageNumber,
                            pageSize: pageSize,
                            matches: matches
                        }),
                        401: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createAuthenticationErrorHandler('Authorization issues encountered while fetching permissions')
                    }
                });
            },
            requestMetadata: ()=>Promise.resolve(),
            mapDataToPage: (response)=>responseMapper.mapPermissionsPage(response),
            doesIndexMatch: ({ context: context, operation: operation, resource: resource }, { normalized: normalized, showInternal: showInternal })=>{
                if (!showInternal && (context === 'control_plane' || resource.startsWith('/api/'))) /**
                     * Does not wants to show internal but it's an internal API, drop it
                     */ return false;
                if (normalized && !(0, $1e2b62fb1507b421$export$a3295358bff77e)(context).includes(normalized) && !(0, $1e2b62fb1507b421$export$a3295358bff77e)(operation).includes(normalized) && !(0, $1e2b62fb1507b421$export$a3295358bff77e)(resource).includes(normalized)) /**
                     * Has search but no match
                     */ return false;
                return true;
            }
        });
        (0, $ad06b61c4606f6df$export$5fe74ec28e3a5524)(()=>this.clearUsersCache(), cacheInterval);
    }
    async ensureNameUsage(entityByNamePromise, id, ...translate) {
        const entityByNameOrError = await entityByNamePromise.catch((e)=>e);
        if (/** The entity should not exist while updating or creating, and the BE error dictates so, all good */ (0, $c3e1b746ad236797$export$8d524fb6540252df).isOfTypes(entityByNameOrError, (0, $c3e1b746ad236797$export$13cd8ea82c82bf53).NOT_FOUND) || /** The entity should exist, and its id equals the current one, all good */ id !== null && !(0, $c3e1b746ad236797$export$8d524fb6540252df).is(entityByNameOrError) && entityByNameOrError.id === id) return;
        /** Either propagate issues with the current promise or throw the usage error we found */ throw (0, $c3e1b746ad236797$export$8d524fb6540252df).is(entityByNameOrError) ? entityByNameOrError : new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).GENERAL_BUSINESS_RULE_INFRACTION, this.translationService.translate(...translate));
    }
    ensureUsernameUsage(id, username) {
        return this.ensureNameUsage(this.fetchUser(username), id, (0, $40a99dac858c1d75$export$b63289fbda65eed1).USERNAME_ALREADY_USED, {
            username: username
        });
    }
    ensureRoleNameUsage(id, name) {
        return this.ensureNameUsage(this.fetchRole(name), id, (0, $40a99dac858c1d75$export$b63289fbda65eed1).ROLE_NAME_ALREADY_USED, {
            name: name
        });
    }
    clearUsersCache() {
        this.fetchUsernamesIndex.clear();
        this.fetchRoleNamesIndex.clear();
        this.fetchPermissionsIndex.clear();
    }
    changePassword(body) {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_OWN_PASSWORD,
            method: 'PUT',
            path: '/api/users/change-password',
            authenticate: true,
            body: body,
            handlers: {
                204: ()=>Promise.resolve(),
                400: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createBadRequestHandler('changing password'),
                403: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createAuthenticationErrorHandler('There were issues while authenticating the user')
            }
        });
    }
    validatePassword(password) {
        return this.validator.validatePassword(this.fetchPasswordPolicy(), password);
    }
    validateUsername(username) {
        return this.validator.validateUsername(this.fetchUsernamePolicy(), username);
    }
    fetchRoles(search) {
        return this.roleFetcher.fetch(search);
    }
    fetchRolesPage(search, showInternal, pageNumber) {
        return this.roleFetcher.fetchPage(search, showInternal, pageNumber);
    }
    fetchRole(roleName) {
        return this.roleFetcher.fetchOne(roleName);
    }
    fetchUsers(search) {
        return this.userFetcher.fetch(search);
    }
    fetchUsersPage(search, showInternal, pageNumber) {
        return this.userFetcher.fetchPage(search, showInternal, pageNumber);
    }
    fetchUser(username) {
        return this.userFetcher.fetchOne(username);
    }
    fetchPermissionsPage(search, showInternal, pageNumber) {
        return this.permissionFetcher.fetchPage(search, showInternal, pageNumber);
    }
    async createUser(request) {
        await this.ensureUsernameUsage(null, request.username);
        await this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_USERS,
            method: 'POST',
            path: '/api/users/batch',
            authenticate: true,
            body: [
                (0, $656af6a2b7258de8$export$232225f9e38944cd)(request)
            ],
            handlers: {
                201: ()=>Promise.resolve(),
                400: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createBadRequestHandler('creating user', {
                    username: request.username
                })
            }
        });
        this.clearUsersCache();
    }
    async updateUser({ id: id, ...request }) {
        // check if the user is protected and if the authentication method "TOKEN" is part of the request
        if (request.username && this.config.usersConfig.protectedUsers.has(request.username) && !request.authenticationMethods?.includes((0, $80ed8557cc0425cc$export$766a2ded12a6f943).TOKEN)) throw new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST, this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).USER_UPDATE_ERROR_PROTECTED_USER, {
            method: this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).USER_AUTHENTICATION_METHOD, {
                method: (0, $80ed8557cc0425cc$export$766a2ded12a6f943).TOKEN
            }),
            username: request.username
        }));
        if (request.username !== undefined) await this.ensureUsernameUsage(id, request.username);
        await this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_USERS,
            method: 'PUT',
            path: '/api/users/+',
            pathParams: [
                id
            ],
            authenticate: true,
            body: (0, $656af6a2b7258de8$export$b16d1d84d85c9892)(request),
            handlers: {
                200: ()=>Promise.resolve(),
                400: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createBadRequestHandler('updating user', {
                    id: id
                }),
                404: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createNotFoundHandler('User not found', {
                    id: id
                })
            }
        });
        this.clearUsersCache();
    }
    async deleteUser(id) {
        await this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_USERS,
            method: 'POST',
            path: '/api/users/batch/delete',
            authenticate: true,
            body: [
                id
            ],
            handlers: {
                200: ()=>Promise.resolve(),
                400: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createBadRequestHandler('deleting user', {
                    id: id
                })
            }
        });
        this.clearUsersCache();
    }
    async createRole(request) {
        await this.ensureRoleNameUsage(null, request.name);
        await this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_ROLES,
            method: 'POST',
            path: '/api/roles',
            authenticate: true,
            body: (0, $5f60db03862c79b6$export$514cc1eaa0fc70dd)(request),
            handlers: {
                201: ()=>Promise.resolve(),
                400: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createBadRequestHandler('creating role', {
                    request: request
                })
            }
        });
        this.clearUsersCache();
    }
    async updateRole({ id: id, ...request }) {
        const body = (0, $5f60db03862c79b6$export$9d45d804e02b5125)(request);
        await this.ensureRoleNameUsage(id, request.name);
        await this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_ROLES,
            method: 'PUT',
            path: '/api/roles/+',
            pathParams: [
                id
            ],
            authenticate: true,
            body: body,
            handlers: {
                200: ()=>Promise.resolve(),
                400: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createBadRequestHandler('updating role', {
                    id: id,
                    body: body
                }),
                404: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createNotFoundHandler('Role not found', {
                    id: id
                })
            }
        });
        this.clearUsersCache();
    }
    async deleteRole(id) {
        const name = await this.fetchRoleNamesIndex().then((roles)=>roles.find((r)=>r.id === id)?.name);
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(name, /** Should only happen in inconsistent scenarios where the role is somehow gone from the BE */ new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Could not find role by name', {
            id: id
        }));
        const { users: users } = await this.roleFetcher.fetchOne(name);
        if ((0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(users)) /** There are users with this role still */ throw new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).GENERAL_BUSINESS_RULE_INFRACTION, this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).IS_USED_BY, {
            used: this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).ROLE, {
                count: 1
            }),
            user: this.translationService.list(users)
        }));
        await this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MANAGE_ROLES,
            method: 'DELETE',
            path: '/api/roles/+',
            pathParams: [
                id
            ],
            authenticate: true,
            handlers: {
                200: ()=>Promise.resolve(),
                404: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createNotFoundHandler('Role not found', {
                    id: id
                }),
                409: $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5.createErrorHandler((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).GENERAL_BUSINESS_RULE_INFRACTION, 'Role is protected', {
                    id: id
                })
            }
        });
        this.clearUsersCache();
    }
}





class $05095b563b5e5262$export$3456ba167f053528 extends (0, $82373d578b14a603$export$f6f3d54ed66158a2) {
    constructor(options, translationService){
        super(options), this.translationService = translationService;
    }
    async lock() {
        await this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CLIENT_REGISTRY_MANAGE,
            path: '/api/client-registry/lock',
            authenticate: true,
            method: 'POST',
            handlers: {
                204: ()=>Promise.resolve(),
                401: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, 'User not authenticated to lock the client registry')
            }
        });
    }
    async unlock() {
        await this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CLIENT_REGISTRY_MANAGE,
            path: '/api/client-registry/open',
            authenticate: true,
            method: 'POST',
            body: {},
            handlers: {
                204: ()=>Promise.resolve(),
                401: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, 'User not authenticated to open the client registry')
            }
        });
    }
    async fetchData() {
        return Promise.all([
            this.request({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CLIENT_REGISTRY_MANAGE,
                path: '/api/client-registry/status',
                authenticate: true,
                method: 'GET',
                handlers: {
                    200: (response)=>response.getJson()
                }
            }),
            this.request({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CLIENT_REGISTRY_MANAGE,
                path: '/api/client-registry',
                authenticate: true,
                method: 'GET',
                handlers: {
                    200: (response)=>response.getJson(),
                    401: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, 'User not authenticated to fetch client registry data'),
                    500: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, 'Could not fetch client registry data')
                }
            })
        ]).then(([{ unlockedUntil: unlockedUntil }, requests])=>({
                unlockedUntil: unlockedUntil ? new Date(unlockedUntil) : null,
                requests: requests.filter((r)=>!r.granted).map(({ timestamp: timestamp, username: username, credentialType: credentialType, roles: roles, context: context, permissions: permissions })=>({
                        username: username,
                        timestamp: new Date(timestamp),
                        authenticationMethod: (0, $00c873ed0924df12$export$76f4e35c8f605837)(credentialType),
                        roles: roles,
                        description: context,
                        permissions: (0, $f2fb95f29536f564$export$439cc3d4f6f085b3)(permissions)
                    }))
            }));
    }
    authorize(request) {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CLIENT_REGISTRY_MANAGE,
            path: '/api/client-registry/confirm',
            authenticate: true,
            method: 'POST',
            body: {
                username: request.username,
                roles: request.roles.map(({ name: name })=>name),
                mqttPublishPrefix: (0, $ab33a7b7001a2cff$export$397cfe51d4da1529)(request.mqttPublishPrefix, ''),
                initialPermissions: request.permissions.map((0, $f2fb95f29536f564$export$317b1a0b2887369e)),
                grantTypes: request.authenticationMethods.map((0, $00c873ed0924df12$export$726b337719677769))
            },
            handlers: {
                204: ()=>Promise.resolve(),
                400: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST, 'Unexpected bad request detected while processing authorization request', request),
                401: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, 'User not authenticated to confirm client registry registration'),
                404: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).NOT_FOUND, 'Could not find user to register', {
                        username: request.username
                    }),
                409: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'User already confirmed', {
                        username: request.username
                    }),
                500: async (response)=>{
                    const json = await response.getJson();
                    switch(json.message){
                        case 'Invalid CSR':
                            return new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).GENERAL_BUSINESS_RULE_INFRACTION, this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).INVALID_CSR));
                        case 'CSR uses empty Common Name or the Common Name does not match the username from the payload.':
                            return new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).GENERAL_BUSINESS_RULE_INFRACTION, this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).CSR_COMMON_NAME_ISSUE));
                        case undefined:
                            return new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, '500 Internal Server Error', {
                                data: json
                            });
                        default:
                            return new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).GENERAL_BUSINESS_RULE_INFRACTION, this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).CLIENT_REGISTRATION_FAILED));
                    }
                }
            }
        });
    }
}






class $53b9a477a5bda966$export$93b1926a5eec64ea extends (0, $82373d578b14a603$export$f6f3d54ed66158a2) {
    constructor(options, translationService){
        super(options), this.translationService = translationService, this.errorHandlers = {
            500: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVER_ERROR)),
            400: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST, 'Unexpected bad request error detected')
        };
    }
    mapInvalidCredentials(credentials) {
        return new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).WRONG_MFA_CREDENTIALS, {
            type: (0, $37c2a8e29603f683$export$727c08e3007b47ec)(credentials) ? 'otp' : 'backupCode'
        }));
    }
    isEnabled() {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).USE_MFA,
            method: 'GET',
            path: '/api/mfa/isenrolled',
            authenticate: true,
            handlers: {
                ...this.errorHandlers,
                200: (response)=>response.getJson().then(({ isEnrolled: isEnrolled })=>isEnrolled)
            }
        });
    }
    enable() {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).USE_MFA,
            method: 'POST',
            path: '/api/mfa/enable',
            authenticate: true,
            handlers: {
                ...this.errorHandlers,
                200: async (response)=>{
                    const { uri: uri } = await response.getJson();
                    const url = new URL(uri);
                    const secret = url.searchParams.get('secret');
                    (0, $14eddac5f20c576c$export$a7a9523472993e97)(secret, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).MAPPING_ERROR, 'Could not find secret in uri', {
                        uri: uri
                    }));
                    return {
                        uri: url,
                        secret: secret
                    };
                },
                409: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).GENERAL_BUSINESS_RULE_INFRACTION, this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).MFA_ALREADY_ENABLED_ERROR))
            }
        });
    }
    disable(credentials) {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).USE_MFA,
            method: 'POST',
            path: '/api/mfa/disable',
            authenticate: true,
            body: (0, $37c2a8e29603f683$export$727c08e3007b47ec)(credentials) ? (0, $e3e007a8c1000cbf$export$86bc19431a0aa06c)(credentials.otp) : (0, $e3e007a8c1000cbf$export$87cc10034f209096)(credentials.backupCode),
            handlers: {
                ...this.errorHandlers,
                401: ()=>this.mapInvalidCredentials(credentials),
                200: ()=>Promise.resolve()
            }
        });
    }
    confirmEnabling(otp) {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).USE_MFA,
            method: 'POST',
            path: '/api/mfa/validate',
            authenticate: true,
            body: (0, $e3e007a8c1000cbf$export$86bc19431a0aa06c)(otp),
            handlers: {
                ...this.errorHandlers,
                200: (response)=>response.getJson().then(({ backupCodes: backupCodes })=>backupCodes),
                401: ()=>this.mapInvalidCredentials({
                        otp: otp,
                        backupCode: null
                    })
            }
        });
    }
    regenerateBackupCodes(credentials) {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).USE_MFA,
            method: 'POST',
            path: '/api/mfa/regenerate/backupcodes',
            authenticate: true,
            body: (0, $37c2a8e29603f683$export$727c08e3007b47ec)(credentials) ? (0, $e3e007a8c1000cbf$export$86bc19431a0aa06c)(credentials.otp) : (0, $e3e007a8c1000cbf$export$87cc10034f209096)(credentials.backupCode),
            handlers: {
                ...this.errorHandlers,
                401: ()=>this.mapInvalidCredentials(credentials),
                200: (response)=>response.getJson().then(({ backupCodes: backupCodes })=>backupCodes)
            }
        });
    }
}









class $aa7430284bf44852$var$IgnoreSignal extends (0, $c3e1b746ad236797$export$8d524fb6540252df) {
    constructor(){
        super((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED);
    }
}
class $aa7430284bf44852$export$63558a44860fb924 {
    static #_ = this.logLevelMap = {
        fatal: (0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).FATAL,
        60: (0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).FATAL,
        error: (0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).ERROR,
        50: (0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).ERROR,
        warn: (0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).WARN,
        40: (0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).WARN,
        info: (0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).INFO,
        30: (0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).INFO,
        debug: (0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).DEBUG,
        20: (0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).DEBUG,
        trace: (0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).TRACE,
        10: (0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).TRACE
    };
    static parseTimestamp(source) {
        const date = typeof source === 'string' || typeof source === 'number' ? new Date(source) : null;
        return date && !Number.isNaN(date.getTime()) ? date : null;
    }
    static parse(line) {
        const firstSpaceIndex = line.indexOf(' ');
        /** Position of the timestamp */ const rawTimestamp = line.substring(0, firstSpaceIndex);
        /** Position of the actual data */ const rawData = line.substring(firstSpaceIndex + 1);
        let parsed;
        try {
            parsed = JSON.parse(rawData);
        } catch (e) {
            parsed = {
                msg: rawData
            };
        }
        return [
            rawTimestamp,
            parsed
        ];
    }
    constructor(search, levels, end){
        this.end = end;
        this.collectors = {
            timestamp: ({ parsed: { time: time }, rawTimestamp: rawTimestamp })=>{
                const timestamp = $aa7430284bf44852$export$63558a44860fb924.parseTimestamp(rawTimestamp) || $aa7430284bf44852$export$63558a44860fb924.parseTimestamp(time) || null;
                (0, $14eddac5f20c576c$export$a7a9523472993e97)(timestamp, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).MAPPING_ERROR, 'Could not map log', {
                    rawTimestamp: rawTimestamp,
                    time: time
                }));
                (0, $14eddac5f20c576c$export$a7a9523472993e97)(!this.end || this.end >= timestamp, new $aa7430284bf44852$var$IgnoreSignal());
                return timestamp;
            },
            level: ({ parsed: { level: level } })=>{
                const mappedLevel = (typeof level === 'string' || typeof level === 'number') && $aa7430284bf44852$export$63558a44860fb924.logLevelMap[level] || (0, $0065e6ee17ac2c80$export$4c17dd9bae91ff0d).INFO;
                (0, $14eddac5f20c576c$export$a7a9523472993e97)(!this.levels || this.levels.has(mappedLevel), new $aa7430284bf44852$var$IgnoreSignal());
                return mappedLevel;
            },
            message: ({ parsed: { msg: msg }, rawMessage: rawMessage })=>typeof msg === 'string' ? msg : rawMessage,
            className: ({ parsed: { className: className } })=>typeof className === 'string' ? className : null,
            pid: ({ parsed: { pid: pid } })=>typeof pid === 'number' ? pid : null,
            hostname: ({ parsed: { hostname: hostname } })=>typeof hostname === 'string' ? hostname : null,
            serviceId: ({ parsed: { id: id } })=>typeof id === 'string' ? id : null
        };
        this.search = (0, $1e2b62fb1507b421$export$a3295358bff77e)(search?.trim() ?? '');
        this.levels = levels && new Set(levels);
        this.collectionsNames = (0, $2ae70427bab197d4$export$ed97f33186d4b816)(this.collectors);
    }
    /**
     * @returns if the log is relevant for search
     */ isLogRelevant(log) {
        if (!this.search) return true;
        return Object.values(log).some((value)=>/**
                 * Value is searchable
                 */ (typeof value === 'string' || typeof value === 'number') && /**
                 * Value matches
                 */ (0, $1e2b62fb1507b421$export$a3295358bff77e)(String(value)).includes(this.search));
    }
    process(text) {
        return text.split('\n').reduce((logs, rawMessage)=>{
            if (!rawMessage) return logs;
            const [rawTimestamp, parsed] = $aa7430284bf44852$export$63558a44860fb924.parse(rawMessage);
            try {
                const data = {
                    parsed: parsed,
                    rawTimestamp: rawTimestamp,
                    rawMessage: rawMessage
                };
                const log = this.collectionsNames.reduce((log, field)=>({
                        ...log,
                        [field]: this.collectors[field](data)
                    }), {});
                if (this.isLogRelevant(log)) return [
                    ...logs,
                    log
                ];
            } catch (e) {
                if (e instanceof $aa7430284bf44852$var$IgnoreSignal) return logs;
                throw e;
            }
            return logs;
        }, []);
    }
}


const $660ed0109cd6c8c5$var$PROTOCOL_MAPPER_AGENT = 'protocol-mapper';
const $660ed0109cd6c8c5$var$isInternallyLogSourceConfiguration = (config)=>'isLoggingSource' in config;
class $660ed0109cd6c8c5$export$105230d55709e392 extends (0, $82373d578b14a603$export$f6f3d54ed66158a2) {
    constructor(options, translationService){
        super(options), this.translationService = translationService, this.supportsUntil = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>this.request({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ,
                method: 'GET',
                path: '/api/core-containers/orchestrator',
                authenticate: true,
                handlers: {
                    200: (r)=>r.getJson().then((value)=>value.orchestrator === 'Docker'),
                    503: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_NOT_AVAILABLE, 'Unexpected network error while fetching containers metadata')
                }
            })), this.logSourceConfiguration = {
            [(0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).SERVER]: this.createResourceLogConfiguration({
                fileName: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVER,
                externalLoggerName: $660ed0109cd6c8c5$var$PROTOCOL_MAPPER_AGENT
            }),
            [(0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).CONNECTION]: this.createResourceLogConfiguration({
                fileName: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONNECTION,
                externalLoggerName: $660ed0109cd6c8c5$var$PROTOCOL_MAPPER_AGENT
            }),
            [(0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).SERVICE_CONTAINER]: {
                isLoggingSource: true,
                fileName: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTAINER
            },
            [(0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).CORE_CONTAINER]: {
                isLoggingSource: true,
                fileName: (0, $40a99dac858c1d75$export$b63289fbda65eed1).CONTAINER
            },
            [(0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).ENDPOINT]: this.createResourceLogConfiguration({
                fileName: (0, $40a99dac858c1d75$export$b63289fbda65eed1).ENDPOINT,
                externalLoggerName: $660ed0109cd6c8c5$var$PROTOCOL_MAPPER_AGENT
            }),
            [(0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).MAPPING]: this.createResourceLogConfiguration({
                fileName: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MAPPING,
                externalLoggerName: $660ed0109cd6c8c5$var$PROTOCOL_MAPPER_AGENT
            }),
            /** Services can always log, so have an easier implementation */ [(0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).SERVICE]: {
                externalLoggerName: 'service-manager',
                canLog: ()=>Promise.resolve(true),
                fileName: (0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE
            },
            [(0, $0065e6ee17ac2c80$export$b1c5b8150a1a3cec).VOLUME]: this.createResourceLogConfiguration({
                fileName: (0, $40a99dac858c1d75$export$b63289fbda65eed1).VOLUME,
                externalLoggerName: 'container-manager'
            })
        };
    }
    createResourceLogConfiguration(base) {
        return {
            ...base,
            canLog: (id)=>this.request({
                    capability: (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ,
                    path: '/api/v2/resources/+',
                    pathParams: [
                        id
                    ],
                    method: 'GET',
                    authenticate: true,
                    handlers: {
                        /**
                         * Only Cybus resource instances within a certain list of agents can have logs
                         */ 200: (r)=>r.getJson().then((j)=>j.data.runnerName === base.externalLoggerName),
                        404: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).NOT_FOUND, 'Could not find resource to assert log availability', {
                                id: id
                            }),
                        500: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, 'There was an issue while fetching log availability', {
                                id: id
                            })
                    }
                })
        };
    }
    async fetchRelevantContainerNames(containerNameFilter) {
        const containers = await this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ,
            path: '/api/core-containers',
            method: 'GET',
            authenticate: true,
            handlers: {
                200: (response)=>response.getJson()
            }
        });
        /**
         * Filter relevant containers
         *
         * For each container
         *  Check if it is the `containerNameFilter`
         *  then add it to the list with some light transforming
         */ return containers.flatMap(({ Names: Names })=>Names.flatMap((containerName)=>containerName && (containerName.includes(`_${containerNameFilter}`) || containerName.includes(`${containerNameFilter}-`)) ? [
                    containerName.startsWith('/') ? containerName.slice(1) : containerName
                ] : []));
    }
    async fetchLoggingContainers(type, container) {
        const config = this.logSourceConfiguration[type];
        const externalLoggerName = 'externalLoggerName' in config ? config.externalLoggerName : null;
        const filteredContainerNames = externalLoggerName ? await this.fetchRelevantContainerNames(externalLoggerName) : [
            container
        ];
        (0, $14eddac5f20c576c$export$a7a9523472993e97)((0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(filteredContainerNames) && !filteredContainerNames.includes(null), new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'No valid containers found', {
            type: type,
            container: container
        }));
        return filteredContainerNames;
    }
    async fetchContainerLogs({ type: type, container: container, lines: lines, start: start, end: end, mapper: mapper }) {
        const filteredContainerNames = await this.fetchLoggingContainers(type, container);
        const queryParams = {
            timestamps: 'true',
            tail: lines === 'all' ? lines : String(500)
        };
        if (start) queryParams.since = String(start.getTime());
        if (end && await this.supportsUntil()) queryParams.until = String(end.getTime());
        return Promise.all(filteredContainerNames.map((loggerContainer)=>this.request({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).LOGS_READ,
                path: '/api/core-containers/+/logs',
                pathParams: [
                    loggerContainer
                ],
                method: 'GET',
                authenticate: true,
                queryParams: queryParams,
                handlers: {
                    200: (r)=>r.getText().then(mapper),
                    404: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).NOT_FOUND, 'Container not found', {
                            loggerContainer: loggerContainer
                        })
                }
            }))).then((allLines)=>allLines.flat());
    }
    getFileName(type, id) {
        const config = this.logSourceConfiguration[type];
        /**
         * To figure out the file name
         * We either check if the resource itself does the logging
         * In which case, use it as the name of the file
         * Or use the general translation name
         */ const name = $660ed0109cd6c8c5$var$isInternallyLogSourceConfiguration(config) && id ? `${this.getTimestamp().toISOString().split(/\D+/g).filter((v)=>v).join('-')}-${id}` : this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).ALL_RAW_LOGS, {
            type: this.translationService.translate(config.fileName, {
                count: 0
            })
        }).toLowerCase().replaceAll(' ', '-');
        return `${name}.log`;
    }
    getTimestamp() {
        return new Date();
    }
    doesCollectLogs(type, id) {
        const config = this.logSourceConfiguration[type];
        return Promise.resolve($660ed0109cd6c8c5$var$isInternallyLogSourceConfiguration(config) || config.canLog(id));
    }
    async fetchLogs(type, { resource: resource, levels: levels, start: start, end: end, lines: lines }) {
        const processor = new (0, $aa7430284bf44852$export$63558a44860fb924)(/**
             * If the resource is a logging source itself, then a search should be done inside it
             * Therefore, no need to pass any parameters
             */ $660ed0109cd6c8c5$var$isInternallyLogSourceConfiguration(this.logSourceConfiguration[type]) ? null : resource, levels, /** If setting the until is not supported on the BE, it needs to be done on the FE */ end !== null && !await this.supportsUntil() ? end : null);
        return this.fetchContainerLogs({
            type: type,
            start: start,
            end: end,
            container: resource,
            lines: lines,
            mapper: (logs)=>processor.process(logs)
        });
    }
    async fetchAllRawLogs(type, { resource: resource, lines: lines }) {
        const logs = await this.fetchContainerLogs({
            type: type,
            container: resource,
            lines: lines,
            start: null,
            end: null,
            mapper: (content)=>[
                    content
                ]
        });
        return new File([
            logs.join('')
        ], this.getFileName(type, resource), {
            type: 'data:text/plain;charset=utf-8'
        });
    }
}







class $02fb8a8821e3573f$export$f6ec0e511e9f3aeb extends (0, $82373d578b14a603$export$f6f3d54ed66158a2) {
    static createSuccessHandler() {
        return ()=>Promise.resolve();
    }
    constructor(options, translationService, changeDoneListeners){
        super(options), this.translationService = translationService, this.changeDoneListeners = changeDoneListeners, this.strategies = {
            [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE]: (action, ids)=>{
                const errorTranslations = {
                    enable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_ENABLE_SERVICES_ERROR,
                    disable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_DISABLE_SERVICES_ERROR,
                    delete: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_DELETE_SERVICES_ERROR
                };
                switch(action){
                    case 'disable':
                    case 'enable':
                        return ids.map((id)=>this.request({
                                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_MANAGE,
                                method: 'PUT',
                                path: '/api/services/+/operation',
                                pathParams: [
                                    id
                                ],
                                body: {
                                    operation: action === 'enable' ? 'enable' : 'disable'
                                },
                                authenticate: true,
                                handlers: {
                                    200: $02fb8a8821e3573f$export$f6ec0e511e9f3aeb.createSuccessHandler(),
                                    400: this.createErrorHandler(errorTranslations[action], ids, action),
                                    404: this.createErrorHandler(errorTranslations[action], ids, action)
                                }
                            }));
                    case 'delete':
                        return ids.map((id)=>this.request({
                                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_MANAGE,
                                method: 'DELETE',
                                path: '/api/services/+',
                                pathParams: [
                                    id
                                ],
                                authenticate: true,
                                handlers: {
                                    200: $02fb8a8821e3573f$export$f6ec0e511e9f3aeb.createSuccessHandler(),
                                    400: this.createErrorHandler(errorTranslations[action], ids, action)
                                }
                            }));
                    default:
                        return null;
                }
            },
            [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).ENDPOINT]: this.createResourcesStrategy({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_MANAGE,
                method: 'PUT',
                path: '/api/v2/resources/+/operation'
            }, {
                enable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_ENABLE_ENDPOINTS_ERROR,
                disable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_DISABLE_ENDPOINTS_ERROR
            }),
            [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CONNECTION]: this.createResourcesStrategy({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_MANAGE,
                method: 'PUT',
                path: '/api/v2/resources/+/operation'
            }, {
                enable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_CONNECT_CONNECTIONS_ERROR,
                disable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_DISCONNECT_CONNECTIONS_ERROR
            }),
            [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).MAPPING]: this.createResourcesStrategy({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_MANAGE,
                method: 'PUT',
                path: '/api/v2/resources/+/operation'
            }, {
                enable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_ENABLE_MAPPINGS_ERROR,
                disable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_DISABLE_MAPPINGS_ERROR
            }),
            [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).CORE_CONTAINER]: (action, ids)=>{
                const errorTranslations = {
                    enable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_ENABLE_CONTAINERS_ERROR,
                    disable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_DISABLE_CONTAINERS_ERROR,
                    reenable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_RE_ENABLE_CONTAINERS_ERROR
                };
                switch(action){
                    case 'enable':
                    case 'disable':
                    case 'reenable':
                        return ids.map((id)=>this.request({
                                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CORE_CONTAINERS_MANAGE,
                                method: 'PUT',
                                path: '/api/core-containers/+/operation',
                                pathParams: [
                                    id
                                ],
                                authenticate: true,
                                body: {
                                    operation: action === 'enable' ? 'start' : action === 'disable' ? 'stop' : 'restart'
                                },
                                handlers: {
                                    200: $02fb8a8821e3573f$export$f6ec0e511e9f3aeb.createSuccessHandler(),
                                    400: this.createErrorHandler(errorTranslations[action], ids, action),
                                    404: this.createErrorHandler(errorTranslations[action], ids, action)
                                }
                            }));
                    default:
                        return null;
                }
            },
            [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVICE_CONTAINER]: (action, ids)=>{
                const errorTranslations = {
                    enable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_ENABLE_CONTAINERS_ERROR,
                    disable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_DISABLE_CONTAINERS_ERROR,
                    reenable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_RE_ENABLE_CONTAINERS_ERROR
                };
                switch(action){
                    case 'enable':
                    case 'disable':
                    case 'reenable':
                        return ids.map((id)=>this.request({
                                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_CONTAINERS_MANAGE,
                                method: 'PUT',
                                path: '/api/containers/+/operation',
                                pathParams: [
                                    id
                                ],
                                authenticate: true,
                                body: {
                                    operation: action === 'enable' ? 'start' : action === 'disable' ? 'stop' : 'restart'
                                },
                                handlers: {
                                    200: $02fb8a8821e3573f$export$f6ec0e511e9f3aeb.createSuccessHandler(),
                                    400: this.createErrorHandler(errorTranslations[action], ids, action),
                                    404: this.createErrorHandler(errorTranslations[action], ids, action)
                                }
                            }));
                    default:
                        return null;
                }
            },
            [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).SERVER]: this.createResourcesStrategy({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_MANAGE,
                method: 'PUT',
                path: '/api/v2/resources/+/operation'
            }, {
                enable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_ENABLE_SERVERS_ERROR,
                disable: (0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_DISABLE_SERVERS_ERROR
            }),
            [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).AGENT]: (action, ids)=>{
                switch(action){
                    case 'delete':
                        return ids.map((id)=>this.request({
                                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).AGENTS_MANAGE,
                                method: 'DELETE',
                                path: '/api/resources/runners/+',
                                pathParams: [
                                    id
                                ],
                                authenticate: true,
                                handlers: {
                                    200: $02fb8a8821e3573f$export$f6ec0e511e9f3aeb.createSuccessHandler(),
                                    400: this.createErrorHandler((0, $40a99dac858c1d75$export$b63289fbda65eed1).BULK_ACTION_DELETE_AGENTS_ERROR, ids, action)
                                }
                            }));
                    default:
                        return null;
                }
            },
            [(0, $5e13938500eec645$export$c6f9da6f70cfc2eb).VOLUME]: ()=>null
        };
    }
    createResourcesStrategy(requestArgs, errorTranslations) {
        return (action, ids)=>{
            switch(action){
                case 'enable':
                case 'disable':
                    return ids.map((id)=>this.request({
                            ...requestArgs,
                            pathParams: [
                                id
                            ],
                            body: {
                                operation: action
                            },
                            authenticate: true,
                            handlers: {
                                200: $02fb8a8821e3573f$export$f6ec0e511e9f3aeb.createSuccessHandler(),
                                400: this.createErrorHandler(errorTranslations[action], ids, action),
                                500: this.createErrorHandler(errorTranslations[action], ids, action)
                            }
                        }));
                default:
                    return null;
            }
        };
    }
    createErrorHandler(translation, ids, action) {
        return ()=>{
            const translatedError = new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, this.translationService.translate(translation, {
                count: ids.length
            }));
            (0, $ea3ab9f98af64a6e$export$6f6534ba0edb1cf4)(translatedError, this[action]);
            return Promise.reject(translatedError);
        };
    }
    async makeRequest(type, action, ids) {
        const promises = this.strategies[type]?.(action, ids);
        if (promises === null) return Promise.reject(new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Not implemented.', {
            type: type,
            action: action,
            ids: ids
        }));
        await Promise.all(promises);
        /**
         * Signal to listeners that the changes are done
         */ this.changeDoneListeners.trigger();
    }
    delete(type, ids) {
        return this.makeRequest(type, 'delete', ids);
    }
    disable(type, ids) {
        return this.makeRequest(type, 'disable', ids);
    }
    enable(type, ids) {
        return this.makeRequest(type, 'enable', ids);
    }
    reenable(type, ids) {
        return this.makeRequest(type, 'reenable', ids);
    }
}




var $761e13972e912a92$export$9eeb22c0bba4ed5e;
var $761e13972e912a92$export$b0184c04dbb75cbd;
var $761e13972e912a92$export$93b9911b232b246c;
var $761e13972e912a92$export$2191b9da168c6cf0;
var $761e13972e912a92$export$44dde8d2b17fc96a;
var $761e13972e912a92$export$fa2f6d6458e494ac;
var $761e13972e912a92$export$c87d910e63d22ed6;
var $761e13972e912a92$export$a22775fa5e2eebd9;
'use strict';

var $761e13972e912a92$var$Validator = $761e13972e912a92$export$9eeb22c0bba4ed5e = (parcelRequire("7FL16"));

$761e13972e912a92$export$b0184c04dbb75cbd = (parcelRequire("frSVn")).ValidatorResult;

$761e13972e912a92$export$93b9911b232b246c = (parcelRequire("frSVn")).ValidatorResultError;

$761e13972e912a92$export$2191b9da168c6cf0 = (parcelRequire("frSVn")).ValidationError;

$761e13972e912a92$export$44dde8d2b17fc96a = (parcelRequire("frSVn")).SchemaError;

$761e13972e912a92$export$fa2f6d6458e494ac = (parcelRequire("gUSYn")).SchemaScanResult;

$761e13972e912a92$export$c87d910e63d22ed6 = (parcelRequire("gUSYn")).scan;
$761e13972e912a92$export$a22775fa5e2eebd9 = function(instance, schema, options) {
    var v = new $761e13972e912a92$var$Validator();
    return v.validate(instance, schema, options);
};






const $082473a5126e38a6$export$ca3de6e649261490 = ({ message: message })=>{
    const errors = /^Error in commissioning file: (?<errors>.{2,})$/.exec(message)?.groups?.errors;
    if (typeof errors !== 'string') return null;
    try {
        return JSON.parse(errors);
    } catch  {
        return null;
    }
};
const $082473a5126e38a6$export$d9da8ee9c6ad2980 = ({ message: message })=>/^Provided service id .+ already exists$/.test(message);
const $082473a5126e38a6$export$2c8ca3d902b0498e = ({ message: message })=>{
    const error = /^Error on creating service .+: (?<error>.+)$/.exec(message)?.groups?.error;
    return typeof error === 'string' ? error : null;
};


const $0324af2ac979fdd8$var$mapParserErrorContent = (error)=>{
    if (typeof error.params === 'string') return error.params || null;
    if (error.params && 'additionalProperty' in error.params) return error.params.additionalProperty || null;
    if (error.params && 'allowedValues' in error.params) return error.params.allowedValues?.join(', ') || null;
    return null;
};
const $0324af2ac979fdd8$var$mapParserErrorInformation = (error)=>({
        dataPath: error.dataPath || null,
        content: $0324af2ac979fdd8$var$mapParserErrorContent(error),
        message: error.message || null
    });
const $0324af2ac979fdd8$export$f6f40815f430789 = (errors)=>errors.reduce((m, error)=>{
        const { dataPath: dataPath, message: message, content: content } = $0324af2ac979fdd8$var$mapParserErrorInformation(error);
        const finalContent = [
            message,
            content
        ].filter((m)=>m).join(': ');
        return !finalContent && !dataPath ? m : m.set(dataPath, finalContent);
    }, new Map([]));




/** This script was auto generated by 'TypeValidatorCreator' at 'src/infrastructure/scripts/Typescript/TypeValidator.ts' **/ 
const $d52ac2e76724d894$var$MinimalValidationErrorSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalValidationError',
    definitions: {
        MinimalValidationError: {
            type: 'object',
            properties: {
                message: {
                    type: 'string'
                }
            },
            required: [
                'message'
            ],
            deprecated: true
        }
    }
};
const $d52ac2e76724d894$export$9368badc5d916ea4 = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($d52ac2e76724d894$var$MinimalValidationErrorSchema, 'isMinimalValidationError');
const $d52ac2e76724d894$var$MinimalSchemasResponseSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalSchemasResponse',
    definitions: {
        MinimalSchemasResponse: {
            type: 'object',
            properties: {
                schemas: {
                    $ref: '#/definitions/ReadonlyRecord%3Cstring%2Cunknown%3E'
                }
            },
            required: [
                'schemas'
            ],
            deprecated: true
        },
        'ReadonlyRecord<string,unknown>': {
            type: 'object',
            additionalProperties: {}
        }
    }
};
const $d52ac2e76724d894$export$ab279f8651ba72d5 = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($d52ac2e76724d894$var$MinimalSchemasResponseSchema, 'isMinimalSchemasResponse');




const $bbb341a67553f14f$var$mapSchemaParameters = (properties)=>(0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(properties).reduce((r, [name, prop])=>{
        /**
         * If possible, retrieve the default value, otherwise, just declare that the value is there
         */ let defaultValue = typeof prop === 'boolean' || !('default' in prop) || prop.default === undefined ? undefined : prop.default;
        if (typeof defaultValue !== 'string' && typeof defaultValue !== 'number' && typeof defaultValue !== 'boolean' && !(0, $36fb5ff0bd6498d5$export$2dabafa86f11ed64)(defaultValue, (v)=>typeof v === 'string' || typeof v === 'number')) defaultValue = null;
        return {
            ...r,
            [name]: defaultValue
        };
    }, {});
const $bbb341a67553f14f$var$validationErrorHandler = async (response)=>{
    const { message: message } = await (0, $773d9142ff567164$export$b1a19a9e61b09890)(response, (0, $d52ac2e76724d894$export$9368badc5d916ea4));
    return new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, message);
};
class $bbb341a67553f14f$export$a641772aca945bae extends (0, $82373d578b14a603$export$f6f3d54ed66158a2) {
    constructor(options, changeDoneListeners){
        super(options), this.changeDoneListeners = changeDoneListeners, this.schemaCache = new (0, $39a8095e56de6b13$export$94affb487e701bf2)(), this.updateBreathingRoom = 5000;
    }
    async parseCommissioningFile(content, mode) {
        let schema = await this.schemaCache.get(()=>this.request({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_PARAMETERS_READ,
                method: 'POST',
                path: '/api/services/parametersSchema',
                authenticate: true,
                body: {
                    commissioningFile: (0, $eaf49e34dc778a74$export$373f4c3083978ffd)(content)
                },
                handlers: {
                    201: async (response)=>{
                        const data = await (0, $773d9142ff567164$export$b1a19a9e61b09890)(response, (0, $d52ac2e76724d894$export$ab279f8651ba72d5));
                        return data.schemas;
                    },
                    400: $bbb341a67553f14f$var$validationErrorHandler,
                    406: async (response)=>{
                        const { message: message } = await (0, $773d9142ff567164$export$b1a19a9e61b09890)(response, (0, $d52ac2e76724d894$export$9368badc5d916ea4));
                        const errors = (0, $082473a5126e38a6$export$ca3de6e649261490)({
                            message: message
                        });
                        return errors ? new (0, $2918297897f2f622$export$515a7b7930693557)((0, $0324af2ac979fdd8$export$f6f40815f430789)(errors)) : new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, message);
                    },
                    500: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, 'There was an issue parsing the commissioning file')
                }
            }), content);
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(schema.properties && schema.required, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).MAPPING_ERROR, 'Schema has missing properties or required fields', {
            content: content,
            schema: schema
        }));
        /**
         * The schema is a very complex json, see `json-schema`
         * But for what is relevant for the admin UI, only `ServiceSchema` is enough
         */ const { id: id, ...values } = $bbb341a67553f14f$var$mapSchemaParameters(schema.properties);
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(typeof id === 'string', new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).MAPPING_ERROR, 'Service default id generated from file is not the expected string', {
            content: content,
            schema: schema
        }));
        /**
         * If the parsing is in update mode
         * Then delete the id field from the output schema
         *
         * Secret (write-only) parameters are also optional on update:
         * an omitted value means "keep the stored one"
         */ if (mode === (0, $703a0e0813d6ac75$export$9eafce13aba72038).UPDATE) {
            const secretNames = new Set((0, $e8356e494d58a419$export$67ede92ee8549a68)(schema));
            schema = {
                ...schema,
                properties: (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(schema.properties).reduce((r, [f, v])=>f === 'id' ? r : {
                        ...r,
                        [f]: v
                    }, {}),
                required: schema.required.filter((r)=>r !== 'id' && !secretNames.has(r))
            };
        }
        return [
            schema,
            id,
            values
        ];
    }
    async manage({ commissioningFile: commissioningFile, id: id, parameters: parameters }, mode) {
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(id, new (0, $1ad670b228c881bd$export$8d7d121236284350)((0, $40a99dac858c1d75$export$b63289fbda65eed1).INVALID_SERVICE_ID));
        const body = {
            commissioningFile: (0, $eaf49e34dc778a74$export$373f4c3083978ffd)(commissioningFile),
            parameters: parameters
        };
        switch(mode){
            case (0, $703a0e0813d6ac75$export$9eafce13aba72038).CREATION:
                await this.request({
                    capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_CREATE_OR_UPDATE,
                    method: 'POST',
                    path: '/api/services',
                    authenticate: true,
                    body: {
                        id: id,
                        ...body
                    },
                    handlers: {
                        201: ()=>Promise.resolve(),
                        400: $bbb341a67553f14f$var$validationErrorHandler,
                        406: async (response)=>{
                            const data = await response.getJson();
                            if ((0, $082473a5126e38a6$export$d9da8ee9c6ad2980)(data)) return new (0, $1ad670b228c881bd$export$8d7d121236284350)((0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_ID_ALREADY_USED);
                            const creationErrorMessage = (0, $082473a5126e38a6$export$2c8ca3d902b0498e)(data);
                            if (creationErrorMessage !== null) return new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, creationErrorMessage);
                            return new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, data.message);
                        },
                        409: ()=>new (0, $1ad670b228c881bd$export$8d7d121236284350)((0, $40a99dac858c1d75$export$b63289fbda65eed1).SERVICE_WITH_ID_STILL_BEING_DELETED),
                        500: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, 'There was an issue creating the service')
                    }
                });
                break;
            case (0, $703a0e0813d6ac75$export$9eafce13aba72038).UPDATE:
                await this.request({
                    capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_CREATE_OR_UPDATE,
                    method: 'PUT',
                    path: '/api/v2/services/+',
                    pathParams: [
                        id
                    ],
                    authenticate: true,
                    body: body,
                    handlers: {
                        202: ()=>Promise.resolve(),
                        400: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST, 'Unexpected bad request detected'),
                        406: async (response)=>{
                            const { errors: errors } = await response.getJson();
                            return new (0, $2918297897f2f622$export$515a7b7930693557)((0, $0324af2ac979fdd8$export$f6f40815f430789)(errors.flatMap((e)=>e.parserErrors)));
                        },
                        500: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, 'There was an issue updating the service')
                    }
                });
                /**
                 * Due to updating being done asynchronously
                 * This makes sure the UI waits a bit before fetching information
                 */ await (0, $48cf5ef53a480c1f$export$1391212d75b2ee65)(this.updateBreathingRoom);
                break;
        }
        this.changeDoneListeners.trigger();
    }
    validate({ schema: schema, id: id, parameters: parameters }, mode) {
        const result = (0, $761e13972e912a92$export$a22775fa5e2eebd9)(mode === (0, $703a0e0813d6ac75$export$9eafce13aba72038).CREATION ? {
            ...parameters,
            id: id
        } : parameters, schema);
        return !(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(result.errors);
    }
    fetchCommissioningFile(id) {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_COMMISSIONING_FILE_READ,
            method: 'GET',
            path: '/api/v2/services/+/serviceCommissioningFile',
            authenticate: true,
            pathParams: [
                id
            ],
            handlers: {
                200: async (response)=>{
                    const { data: data } = await response.getJson();
                    return (0, $eaf49e34dc778a74$export$83edfd8fcc66ec17)(data.scf);
                },
                400: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST, 'Unexpected bad request detected', {
                        id: id
                    }),
                404: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).NOT_FOUND, 'Service not found', {
                        id: id
                    }),
                500: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, 'Internal Server Error')
            }
        });
    }
}








const $5467254772da97b1$export$7a7789eb357fb37 = (latestVersion, currentVersion)=>{
    return latestVersion.localeCompare(currentVersion, undefined, {
        numeric: true
    }) === 1;
};
const $5467254772da97b1$var$licenseErrorPatterns = {
    unableToRefresh: /^Unable to refresh license: .*$/gm,
    unableToUpdate: /^Unable to update license file: .*$/gm
};
const $5467254772da97b1$export$ca4d35cfde0f013e = async (response, errorPattern)=>{
    const data = await response.getJson();
    if (data && typeof data === 'object' && 'message' in data && typeof data.message === 'string' && $5467254772da97b1$var$licenseErrorPatterns[errorPattern].test(data.message)) /**
         * There was an issue with the license itself
         *
         * Either it is still expired or not active
         *
         * Can not be of type ConnectwareErrorType.CONFIGURATION_ERROR,
         * because it will be ignored then by https://bitbucket.org/cybusio/cybus/src/eb7e2227a7d679659cb6d6f3aa01d1e0b4631bc7/admin-web-app/src/application/usecases/License/Reload.ts
         */ return new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST, data.message);
    return undefined;
};


class $e0d11f8dfe649973$export$c299242ad2e6dfd5 extends (0, $82373d578b14a603$export$f6f3d54ed66158a2) {
    constructor(options, uiVersion){
        super(options), this.uiVersion = uiVersion, this.systemReadConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MINIMUM,
            method: 'GET',
            path: '/api/system/preflight'
        }, this.metricsReadConfig = {
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_METRICS_READ,
            method: 'GET',
            path: '/api/system/preflight'
        };
    }
    fetchSystemInfo(mapper) {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MINIMUM,
            method: 'GET',
            path: '/api/system/info',
            authenticate: true,
            handlers: {
                200: (response)=>response.getJson().then(mapper)
            }
        });
    }
    fetchInternalConnectivity(config) {
        return this.request({
            ...this[config],
            authenticate: true,
            handlers: {
                200: (response)=>response.getJson().then(({ currentVersions: currentVersions, cybusPortal: cybusPortal, cybusRegistry: cybusRegistry, dockerHub: dockerHub })=>{
                        const latest = currentVersions?.series?.active?.latest;
                        const endpoints = {
                            cybusPortal: cybusPortal,
                            cybusRegistry: cybusRegistry,
                            dockerHub: dockerHub
                        };
                        return {
                            endpoints: (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(endpoints).reduce((r, [name, { status: status, url: url }])=>({
                                    ...r,
                                    [name]: {
                                        url: new URL(url),
                                        reachable: status
                                    }
                                }), {}),
                            latest: latest ? {
                                version: latest.version,
                                releaseNotes: new URL(latest.urlReleaseNotes),
                                installerURL: new URL(latest.installerUrl)
                            } : null
                        };
                    })
            }
        });
    }
    getUIVersion() {
        return this.uiVersion;
    }
    async fetchConnectivity() {
        const connectivity = await this.fetchInternalConnectivity('systemReadConfig');
        if (!connectivity.latest?.version) return connectivity;
        const currentVersion = this.getUIVersion();
        if (currentVersion === connectivity.latest.version) return connectivity;
        const isCurrentVersionOutdated = (0, $5467254772da97b1$export$7a7789eb357fb37)(connectivity.latest.version, currentVersion);
        if (isCurrentVersionOutdated) /**
             * Current connectware is out of date
             * And that is ok
             */ return connectivity;
        /**
         * Current version is ahead, so just say the latest is the current
         */ return {
            ...connectivity,
            latest: {
                ...connectivity.latest,
                version: currentVersion
            }
        };
    }
    fetchLicense() {
        return this.fetchSystemInfo(({ license: { file: { id: id, associatedAccount: associatedAccount, connectwareLicenseClass: connectwareLicenseClass, expiration: expiration } = {}, name: name, valid: valid } })=>{
            const parsedExpiration = (expiration && new Date(expiration)) ?? null;
            if (!id || !associatedAccount || !name || !connectwareLicenseClass || !parsedExpiration || isNaN(parsedExpiration.getTime())) return {
                id: null,
                activated: false,
                account: null,
                name: null,
                class: null,
                expiration: null,
                valid: false
            };
            return {
                id: id,
                activated: true,
                account: associatedAccount,
                name: name,
                class: connectwareLicenseClass,
                expiration: parsedExpiration,
                valid: Boolean(valid)
            };
        });
    }
    refreshLicense() {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_LICENSE_MANAGE,
            method: 'GET',
            path: '/api/system/refresh',
            authenticate: true,
            handlers: {
                200: ()=>Promise.resolve(),
                400: (response)=>(0, $5467254772da97b1$export$ca4d35cfde0f013e)(response, 'unableToRefresh')
            }
        });
    }
    uploadLicenseFile(payload) {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_LICENSE_MANAGE,
            method: 'PUT',
            path: '/api/system/licensefile',
            authenticate: true,
            body: {
                payload: payload
            },
            handlers: {
                200: ()=>Promise.resolve(),
                400: (response)=>(0, $5467254772da97b1$export$ca4d35cfde0f013e)(response, 'unableToUpdate')
            }
        });
    }
    async fetchVersions() {
        return {
            ui: this.getUIVersion(),
            connectware: await this.fetchSystemInfo((data)=>data.version)
        };
    }
    fetchMetrics() {
        return Promise.all([
            this.request({
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_METRICS_READ,
                method: 'GET',
                path: '/api/system/metrics',
                authenticate: true,
                queryParams: {
                    daily: 'true',
                    hourly: 'true'
                },
                handlers: {
                    200: (response)=>response.getJson(),
                    400: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, 'Unable to fetch metrics')
                }
            }),
            this.fetchInternalConnectivity('metricsReadConfig')
        ]).then(([metrics, connectivity])=>{
            const { hourly: hourly, daily: daily } = {
                ...metrics
            };
            return {
                isPortalReachable: connectivity.endpoints.cybusPortal.reachable,
                hourly: (hourly || []).filter((h)=>h.numberOfConnectedDatapoints !== 0 || h.numberOfReceivedMessages !== 0).map(({ numberOfConnectedDatapoints: numberOfConnectedDatapoints, numberOfReceivedMessages: numberOfReceivedMessages, timestamp: timestamp })=>({
                        numberOfConnectedDatapoints: numberOfConnectedDatapoints,
                        numberOfReceivedMessages: numberOfReceivedMessages,
                        timestamp: new Date(timestamp)
                    })),
                daily: (daily || []).map(({ numberOfConnectedDatapoints: numberOfConnectedDatapoints, numberOfReceivedMessages: numberOfReceivedMessages, date: date })=>({
                        date: new Date(date),
                        numberOfConnectedDatapoints: numberOfConnectedDatapoints,
                        numberOfReceivedMessages: numberOfReceivedMessages
                    }))
            };
        });
    }
    sendMetricsToPortal() {
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SYSTEM_METRICS_MANAGE,
            method: 'PUT',
            path: '/api/system/metrics',
            authenticate: true,
            handlers: {
                200: ()=>Promise.resolve(),
                400: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, 'Unable to send metrics to portal')
            }
        });
    }
}








class $b8daf9334d524508$export$9be0b709dd3f09be extends (0, $82373d578b14a603$export$f6f3d54ed66158a2) {
    constructor(...[baseOptions, translationService, engineOptions]){
        super(baseOptions);
        this.translationService = translationService;
        this.engineOptions = engineOptions;
    }
    fetchEndpoints(search) {
        if (search && search.length < this.engineOptions.searchMinimum) return Promise.reject(new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST, this.translationService.translate((0, $40a99dac858c1d75$export$b63289fbda65eed1).SEARCH_THRESHOLD_EXPLANATION, {
            threshold: this.engineOptions.searchMinimum
        })));
        return this.request({
            capability: (0, $78670ebe9381a713$export$790a66df9dc00390).RULE_ENGINE_RESOURCES,
            path: '/api/v2/resources',
            method: 'GET',
            authenticate: true,
            queryParams: {
                ...(0, $cc2dbd258f70f429$export$ad614e9c36e65e21)(search),
                categories: [
                    'Endpoint'
                ],
                orderBy: 'resourceName',
                order: 'ASC',
                /**
                 * We don't want inactive endpoints to be listed
                 */ onlyFromEnabledServices: 'true',
                /**
                 * Reasonable amount of items to find for an autocomplete search
                 */ itemsPerPage: `${this.engineOptions.maxPageSize}`
            },
            handlers: {
                200: (response)=>response.getJson().then(({ data: data })=>data.map((resource)=>{
                            (0, $14eddac5f20c576c$export$a7a9523472993e97)((0, $0345488ca28093f7$export$132575760c330adc)(resource, 'Endpoint'), new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).MAPPING_ERROR, 'Unexpected non endpoint resource category', {
                                category: resource.category
                            }));
                            return {
                                id: resource.resourceId,
                                name: (0, $738b86ad1f26c727$export$451246252aec50a8)(resource.resourceId),
                                connection: resource.parentResourceId,
                                service: resource.serviceId,
                                topics: (0, $e995f059f5d1fc30$export$ed05c84a2e8a2f13).create(resource.category).withOperation(resource.resourceConfig.args.operation).mapAll(resource.resourceConfig.args.topic)
                            };
                        })),
                400: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).BAD_REQUEST, 'Bad request detected while searching endpoints'),
                500: ()=>new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR, 'Could not fetch searched endpoints')
            }
        });
    }
}









const $890b8a2862dffd73$var$doBatchStrategiesMatch = (0, $1f8efbeda4be7f45$export$1fcb4cba5d8f1ae4)({
    /** Capability has no comparison value */ capability: ()=>true,
    method: null,
    path: null,
    buildQueryParams: null
});
class $890b8a2862dffd73$export$5178188cc1ee9604 extends (0, $82373d578b14a603$export$f6f3d54ed66158a2) {
    static createServerNotAvailableHandler() {
        return ()=>Promise.reject(new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_NOT_AVAILABLE, 'Resources Status Tracking is not running as expected'));
    }
    constructor(options, pageSize){
        super(options), this.pageSize = pageSize, this.queue = new (0, $85a96cf722827591$export$3dc07afe418952bc)(), this.pendingRequests = [];
    }
    /**
     * @returns a batch of requests from the queue, grouped according to batch/page size limits
     */ extractNextBatch() {
        const [first, ...rest] = this.pendingRequests.splice(0, this.pendingRequests.length);
        if (!first) /** Everything is empty, so no need to do anything */ return null;
        const strategy = this.resolveBatchFetchingStrategy(first.args);
        const requests = [
            first
        ];
        for (const next of rest)if (requests.length < this.pageSize && $890b8a2862dffd73$var$doBatchStrategiesMatch(strategy, this.resolveBatchFetchingStrategy(next.args))) /** Add request because it both fits and the strategies align */ requests.push(next);
        else /** Skip it for this batch and put it back in the pending requests */ this.pendingRequests.push(next);
        return {
            strategy: strategy,
            requests: requests
        };
    }
    /**
     * Executes the batched API call and resolves each request based on the response
     */ async resolveRequests() {
        const batch = this.extractNextBatch();
        if (batch === null) return;
        const request = this.createRequestArgs(batch);
        const result = await this.request(request).catch((e)=>e);
        batch.requests.forEach(({ args: args, promise: promise })=>{
            const match = (0, $c3e1b746ad236797$export$8d524fb6540252df).is(result) ? result : this.resolveBatchResponse(result, args);
            if (!(0, $c3e1b746ad236797$export$8d524fb6540252df).is(match)) promise.resolve(match);
            else promise.reject(match);
        });
    }
    fetchBatched(args) {
        const promise = new (0, $4b4d116d11b9cad5$export$63804c02d20d1c30)();
        /** Add new request and queue a new fetching for it (in case it's needed) */ this.pendingRequests.push({
            args: args,
            promise: promise
        });
        this.queue.push(()=>this.resolveRequests());
        return promise.promise;
    }
}


class $9cbed1cedac192a6$export$6404d3f3f4d7534b extends (0, $890b8a2862dffd73$export$5178188cc1ee9604) {
    resolveBatchFetchingStrategy(args) {
        return this.statesStrategies[args.type];
    }
    createRequestArgs({ strategy: { buildQueryParams: buildQueryParams, ...strategy }, requests: requests }) {
        return {
            ...strategy,
            authenticate: true,
            queryParams: buildQueryParams(requests.map((r)=>r.args)),
            handlers: {
                200: async (response)=>{
                    const batch = {};
                    const { data: data } = await response.getJson();
                    for (const { resource: resource, state: state } of data)batch[(0, $1ce286d293747584$export$9c5ea5a6c0d1312b)(resource)] = (0, $1ce286d293747584$export$3442ac9bfe667688)(state);
                    return batch;
                },
                503: $9cbed1cedac192a6$export$6404d3f3f4d7534b.createServerNotAvailableHandler()
            }
        };
    }
    resolveBatchResponse(result, { resourceId: resourceId }) {
        return result[resourceId] ?? new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).NOT_FOUND, 'Could not find status in batch', {
            resourceId: resourceId
        });
    }
    fetchStatusType(type, resourceId) {
        return this.fetchBatched({
            type: type,
            resourceId: resourceId
        });
    }
    constructor(...args){
        super(...args), this.resourcesStrategy = {
            buildQueryParams: (args)=>({
                    itemsPerPage: `${this.pageSize}`,
                    resourceIds: args.map((args)=>args.resourceId)
                })
        }, /**
     * These strategies here serve two purposes
     * - Allow for the extraction of statuses to be possible by many means
     * - Enables the scripts that check for endpoint usage (and associate them with capabilities) to detect these endpoints' usage properly
     */ this.statesStrategies = {
            connection: {
                method: 'GET',
                path: '/api/v2/resources/states',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTION_READ,
                ...this.resourcesStrategy
            },
            connections: {
                method: 'GET',
                path: '/api/v2/resources/states',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_READ,
                ...this.resourcesStrategy
            },
            endpoint: {
                method: 'GET',
                path: '/api/v2/resources/states',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINT_READ,
                ...this.resourcesStrategy
            },
            endpoints: {
                method: 'GET',
                path: '/api/v2/resources/states',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_READ,
                ...this.resourcesStrategy
            },
            mapping: {
                method: 'GET',
                path: '/api/v2/resources/states',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPING_READ,
                ...this.resourcesStrategy
            },
            mappings: {
                method: 'GET',
                path: '/api/v2/resources/states',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_READ,
                ...this.resourcesStrategy
            },
            nodes: {
                method: 'GET',
                path: '/api/v2/resources/states',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).NODES_READ,
                ...this.resourcesStrategy
            },
            server: {
                method: 'GET',
                path: '/api/v2/resources/states',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVER_READ,
                ...this.resourcesStrategy
            },
            servers: {
                method: 'GET',
                path: '/api/v2/resources/states',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_READ,
                ...this.resourcesStrategy
            }
        };
    }
}





class $774df96d885f273e$export$e039aea709dd4ff5 extends (0, $890b8a2862dffd73$export$5178188cc1ee9604) {
    resolveBatchFetchingStrategy(args) {
        return {
            ...this.isDeviatedStrategies[args.type],
            ...this.isDeviatedInteraction
        };
    }
    createRequestArgs({ strategy: { buildQueryParams: buildQueryParams, ...strategy }, requests: requests }) {
        return {
            ...strategy,
            authenticate: true,
            queryParams: buildQueryParams(requests.map((r)=>r.args)),
            handlers: {
                200: (response)=>response.getJson().then(({ data: data })=>this.mapDeviationsCountData(data)),
                503: $774df96d885f273e$export$e039aea709dd4ff5.createServerNotAvailableHandler()
            }
        };
    }
    resolveBatchResponse(result, { serviceId: serviceId }) {
        return result[serviceId] ?? 0;
    }
    fetchServiceDeviationsCount(type, serviceId) {
        return this.fetchBatched({
            type: type,
            serviceId: serviceId
        });
    }
    constructor(...args){
        super(...args), this.mapDeviationsCountData = (0, $1ce286d293747584$export$7e41c8195d072605)((data)=>data.reduce((r, { serviceId: serviceId, count: count })=>({
                    ...r,
                    [serviceId]: count
                }), {})), this.isDeviatedInteraction = {
            buildQueryParams: (args)=>({
                    ids: args.map(({ serviceId: serviceId })=>serviceId),
                    itemsPerPage: `${this.pageSize}`
                })
        }, /**
     * These strategies here serve two purposes
     * - Allow for the extraction of deviations count to be possible by many means
     * - Enables the scripts that check for endpoint usage (and associate them with capabilities) to detect these endpoints' usage properly
     */ this.isDeviatedStrategies = {
            connections: {
                method: 'GET',
                path: '/api/v2/resources/states/deviations/count',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_READ
            },
            endpoints: {
                method: 'GET',
                path: '/api/v2/resources/states/deviations/count',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_READ
            },
            mappings: {
                method: 'GET',
                path: '/api/v2/resources/states/deviations/count',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_READ
            },
            nodes: {
                method: 'GET',
                path: '/api/v2/resources/states/deviations/count',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).NODES_READ
            },
            resourceDeviation: {
                method: 'GET',
                path: '/api/v2/resources/states/deviations/count',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).DEVIATIONS_READ
            },
            servers: {
                method: 'GET',
                path: '/api/v2/resources/states/deviations/count',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_READ
            },
            service: {
                method: 'GET',
                path: '/api/v2/resources/states/deviations/count',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ
            },
            services: {
                method: 'GET',
                path: '/api/v2/resources/states/deviations/count',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_READ
            }
        };
    }
}








var $4c2dd1b68d143d96$var$as = Object.defineProperty;
var $4c2dd1b68d143d96$var$Yb = Object.getOwnPropertyDescriptor;
var $4c2dd1b68d143d96$var$Jb = Object.getOwnPropertyNames;
var $4c2dd1b68d143d96$var$Xb = Object.prototype.hasOwnProperty;
var $4c2dd1b68d143d96$var$ze = (t, e)=>()=>(t && (e = t(t = 0)), e);
var $4c2dd1b68d143d96$var$D = (t, e)=>()=>(e || t((e = {
            exports: {}
        }).exports, e), e.exports), $4c2dd1b68d143d96$var$Kr = (t, e)=>{
    for(var r in e)$4c2dd1b68d143d96$var$as(t, r, {
        get: e[r],
        enumerable: !0
    });
}, $4c2dd1b68d143d96$var$Zb = (t, e, r, n)=>{
    if (e && typeof e == "object" || typeof e == "function") for (let i of $4c2dd1b68d143d96$var$Jb(e))!$4c2dd1b68d143d96$var$Xb.call(t, i) && i !== r && $4c2dd1b68d143d96$var$as(t, i, {
        get: ()=>e[i],
        enumerable: !(n = $4c2dd1b68d143d96$var$Yb(e, i)) || n.enumerable
    });
    return t;
};
var $4c2dd1b68d143d96$var$me = (t)=>$4c2dd1b68d143d96$var$Zb($4c2dd1b68d143d96$var$as({}, "__esModule", {
        value: !0
    }), t);
var $4c2dd1b68d143d96$var$A = $4c2dd1b68d143d96$var$ze(()=>{});
var $4c2dd1b68d143d96$var$M = {};
$4c2dd1b68d143d96$var$Kr($4c2dd1b68d143d96$var$M, {
    _debugEnd: ()=>$4c2dd1b68d143d96$var$Kc,
    _debugProcess: ()=>$4c2dd1b68d143d96$var$zc,
    _events: ()=>$4c2dd1b68d143d96$var$ff,
    _eventsCount: ()=>$4c2dd1b68d143d96$var$hf,
    _exiting: ()=>$4c2dd1b68d143d96$var$Pc,
    _fatalExceptions: ()=>$4c2dd1b68d143d96$var$$c,
    _getActiveHandles: ()=>$4c2dd1b68d143d96$var$Cc,
    _getActiveRequests: ()=>$4c2dd1b68d143d96$var$kc,
    _kill: ()=>$4c2dd1b68d143d96$var$Mc,
    _linkedBinding: ()=>$4c2dd1b68d143d96$var$xc,
    _maxListeners: ()=>$4c2dd1b68d143d96$var$cf,
    _preload_modules: ()=>$4c2dd1b68d143d96$var$af,
    _rawDebug: ()=>$4c2dd1b68d143d96$var$Ac,
    _startProfilerIdleNotifier: ()=>$4c2dd1b68d143d96$var$Qc,
    _stopProfilerIdleNotifier: ()=>$4c2dd1b68d143d96$var$Yc,
    _tickCallback: ()=>$4c2dd1b68d143d96$var$Gc,
    abort: ()=>$4c2dd1b68d143d96$var$ef,
    addListener: ()=>$4c2dd1b68d143d96$var$df,
    allowedNodeEnvironmentFlags: ()=>$4c2dd1b68d143d96$var$jc,
    arch: ()=>$4c2dd1b68d143d96$var$cc,
    argv: ()=>$4c2dd1b68d143d96$var$dc,
    argv0: ()=>$4c2dd1b68d143d96$var$sf,
    assert: ()=>$4c2dd1b68d143d96$var$Fc,
    binding: ()=>$4c2dd1b68d143d96$var$wc,
    browser: ()=>$4c2dd1b68d143d96$var$Ec,
    chdir: ()=>$4c2dd1b68d143d96$var$vc,
    config: ()=>$4c2dd1b68d143d96$var$Oc,
    cpuUsage: ()=>$4c2dd1b68d143d96$var$Ri,
    cwd: ()=>$4c2dd1b68d143d96$var$_c,
    debugPort: ()=>$4c2dd1b68d143d96$var$of,
    default: ()=>$4c2dd1b68d143d96$var$Sf,
    dlopen: ()=>$4c2dd1b68d143d96$var$Rc,
    domain: ()=>$4c2dd1b68d143d96$var$Tc,
    emit: ()=>$4c2dd1b68d143d96$var$wf,
    emitWarning: ()=>$4c2dd1b68d143d96$var$bc,
    env: ()=>$4c2dd1b68d143d96$var$hc,
    execArgv: ()=>$4c2dd1b68d143d96$var$pc,
    execPath: ()=>$4c2dd1b68d143d96$var$nf,
    exit: ()=>$4c2dd1b68d143d96$var$Uc,
    features: ()=>$4c2dd1b68d143d96$var$Wc,
    hasUncaughtExceptionCaptureCallback: ()=>$4c2dd1b68d143d96$var$Vc,
    hrtime: ()=>$4c2dd1b68d143d96$var$Oi,
    kill: ()=>$4c2dd1b68d143d96$var$Lc,
    listeners: ()=>$4c2dd1b68d143d96$var$vf,
    memoryUsage: ()=>$4c2dd1b68d143d96$var$qc,
    moduleLoadList: ()=>$4c2dd1b68d143d96$var$Ic,
    nextTick: ()=>$4c2dd1b68d143d96$var$ac,
    off: ()=>$4c2dd1b68d143d96$var$yf,
    on: ()=>$4c2dd1b68d143d96$var$Nt,
    once: ()=>$4c2dd1b68d143d96$var$pf,
    openStdin: ()=>$4c2dd1b68d143d96$var$Dc,
    pid: ()=>$4c2dd1b68d143d96$var$tf,
    platform: ()=>$4c2dd1b68d143d96$var$fc,
    ppid: ()=>$4c2dd1b68d143d96$var$rf,
    prependListener: ()=>$4c2dd1b68d143d96$var$mf,
    prependOnceListener: ()=>$4c2dd1b68d143d96$var$_f,
    reallyExit: ()=>$4c2dd1b68d143d96$var$Bc,
    release: ()=>$4c2dd1b68d143d96$var$Sc,
    removeAllListeners: ()=>$4c2dd1b68d143d96$var$bf,
    removeListener: ()=>$4c2dd1b68d143d96$var$gf,
    resourceUsage: ()=>$4c2dd1b68d143d96$var$Nc,
    setSourceMapsEnabled: ()=>$4c2dd1b68d143d96$var$uf,
    setUncaughtExceptionCaptureCallback: ()=>$4c2dd1b68d143d96$var$Hc,
    stderr: ()=>$4c2dd1b68d143d96$var$Xc,
    stdin: ()=>$4c2dd1b68d143d96$var$Zc,
    stdout: ()=>$4c2dd1b68d143d96$var$Jc,
    title: ()=>$4c2dd1b68d143d96$var$lc,
    umask: ()=>$4c2dd1b68d143d96$var$mc,
    uptime: ()=>$4c2dd1b68d143d96$var$lf,
    version: ()=>$4c2dd1b68d143d96$var$yc,
    versions: ()=>$4c2dd1b68d143d96$var$gc
});
function $4c2dd1b68d143d96$var$cs(t) {
    throw new Error("Node.js process " + t + " is not supported by JSPM core outside of Node.js");
}
function $4c2dd1b68d143d96$var$ew() {
    !$4c2dd1b68d143d96$var$Qr || !$4c2dd1b68d143d96$var$wr || ($4c2dd1b68d143d96$var$Qr = !1, $4c2dd1b68d143d96$var$wr.length ? $4c2dd1b68d143d96$var$Mt = $4c2dd1b68d143d96$var$wr.concat($4c2dd1b68d143d96$var$Mt) : $4c2dd1b68d143d96$var$Pi = -1, $4c2dd1b68d143d96$var$Mt.length && $4c2dd1b68d143d96$var$sc());
}
function $4c2dd1b68d143d96$var$sc() {
    if (!$4c2dd1b68d143d96$var$Qr) {
        var t = setTimeout($4c2dd1b68d143d96$var$ew, 0);
        $4c2dd1b68d143d96$var$Qr = !0;
        for(var e = $4c2dd1b68d143d96$var$Mt.length; e;){
            for($4c2dd1b68d143d96$var$wr = $4c2dd1b68d143d96$var$Mt, $4c2dd1b68d143d96$var$Mt = []; ++$4c2dd1b68d143d96$var$Pi < e;)$4c2dd1b68d143d96$var$wr && $4c2dd1b68d143d96$var$wr[$4c2dd1b68d143d96$var$Pi].run();
            $4c2dd1b68d143d96$var$Pi = -1, e = $4c2dd1b68d143d96$var$Mt.length;
        }
        $4c2dd1b68d143d96$var$wr = null, $4c2dd1b68d143d96$var$Qr = !1, clearTimeout(t);
    }
}
function $4c2dd1b68d143d96$var$ac(t) {
    var e = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
    $4c2dd1b68d143d96$var$Mt.push(new $4c2dd1b68d143d96$var$uc(t, e)), $4c2dd1b68d143d96$var$Mt.length === 1 && !$4c2dd1b68d143d96$var$Qr && setTimeout($4c2dd1b68d143d96$var$sc, 0);
}
function $4c2dd1b68d143d96$var$uc(t, e) {
    this.fun = t, this.array = e;
}
function $4c2dd1b68d143d96$var$Ue() {}
function $4c2dd1b68d143d96$var$xc(t) {
    $4c2dd1b68d143d96$var$cs("_linkedBinding");
}
function $4c2dd1b68d143d96$var$Rc(t) {
    $4c2dd1b68d143d96$var$cs("dlopen");
}
function $4c2dd1b68d143d96$var$kc() {
    return [];
}
function $4c2dd1b68d143d96$var$Cc() {
    return [];
}
function $4c2dd1b68d143d96$var$Fc(t, e) {
    if (!t) throw new Error(e || "assertion error");
}
function $4c2dd1b68d143d96$var$Vc() {
    return !1;
}
function $4c2dd1b68d143d96$var$lf() {
    return $4c2dd1b68d143d96$var$Jt.now() / 1e3;
}
function $4c2dd1b68d143d96$var$Oi(t) {
    var e = Math.floor((Date.now() - $4c2dd1b68d143d96$var$Jt.now()) * .001), r = $4c2dd1b68d143d96$var$Jt.now() * .001, n = Math.floor(r) + e, i = Math.floor(r % 1 * 1e9);
    return t && (n = n - t[0], i = i - t[1], i < 0 && (n--, i += $4c2dd1b68d143d96$var$ls)), [
        n,
        i
    ];
}
function $4c2dd1b68d143d96$var$Nt() {
    return $4c2dd1b68d143d96$var$Sf;
}
function $4c2dd1b68d143d96$var$vf(t) {
    return [];
}
var $4c2dd1b68d143d96$var$Mt, $4c2dd1b68d143d96$var$Qr, $4c2dd1b68d143d96$var$wr, $4c2dd1b68d143d96$var$Pi, $4c2dd1b68d143d96$var$lc, $4c2dd1b68d143d96$var$cc, $4c2dd1b68d143d96$var$fc, $4c2dd1b68d143d96$var$hc, $4c2dd1b68d143d96$var$dc, $4c2dd1b68d143d96$var$pc, $4c2dd1b68d143d96$var$yc, $4c2dd1b68d143d96$var$gc, $4c2dd1b68d143d96$var$bc, $4c2dd1b68d143d96$var$wc, $4c2dd1b68d143d96$var$mc, $4c2dd1b68d143d96$var$_c, $4c2dd1b68d143d96$var$vc, $4c2dd1b68d143d96$var$Sc, $4c2dd1b68d143d96$var$Ec, $4c2dd1b68d143d96$var$Ac, $4c2dd1b68d143d96$var$Ic, $4c2dd1b68d143d96$var$Tc, $4c2dd1b68d143d96$var$Pc, $4c2dd1b68d143d96$var$Oc, $4c2dd1b68d143d96$var$Bc, $4c2dd1b68d143d96$var$Mc, $4c2dd1b68d143d96$var$Ri, $4c2dd1b68d143d96$var$Nc, $4c2dd1b68d143d96$var$qc, $4c2dd1b68d143d96$var$Lc, $4c2dd1b68d143d96$var$Uc, $4c2dd1b68d143d96$var$Dc, $4c2dd1b68d143d96$var$jc, $4c2dd1b68d143d96$var$Wc, $4c2dd1b68d143d96$var$$c, $4c2dd1b68d143d96$var$Hc, $4c2dd1b68d143d96$var$Gc, $4c2dd1b68d143d96$var$zc, $4c2dd1b68d143d96$var$Kc, $4c2dd1b68d143d96$var$Qc, $4c2dd1b68d143d96$var$Yc, $4c2dd1b68d143d96$var$Jc, $4c2dd1b68d143d96$var$Xc, $4c2dd1b68d143d96$var$Zc, $4c2dd1b68d143d96$var$ef, $4c2dd1b68d143d96$var$tf, $4c2dd1b68d143d96$var$rf, $4c2dd1b68d143d96$var$nf, $4c2dd1b68d143d96$var$of, $4c2dd1b68d143d96$var$sf, $4c2dd1b68d143d96$var$af, $4c2dd1b68d143d96$var$uf, $4c2dd1b68d143d96$var$Jt, $4c2dd1b68d143d96$var$us, $4c2dd1b68d143d96$var$ls, $4c2dd1b68d143d96$var$cf, $4c2dd1b68d143d96$var$ff, $4c2dd1b68d143d96$var$hf, $4c2dd1b68d143d96$var$df, $4c2dd1b68d143d96$var$pf, $4c2dd1b68d143d96$var$yf, $4c2dd1b68d143d96$var$gf, $4c2dd1b68d143d96$var$bf, $4c2dd1b68d143d96$var$wf, $4c2dd1b68d143d96$var$mf, $4c2dd1b68d143d96$var$_f, $4c2dd1b68d143d96$var$Sf, $4c2dd1b68d143d96$var$Ef = $4c2dd1b68d143d96$var$ze(()=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    $4c2dd1b68d143d96$var$Mt = [], $4c2dd1b68d143d96$var$Qr = !1, $4c2dd1b68d143d96$var$Pi = -1;
    $4c2dd1b68d143d96$var$uc.prototype.run = function() {
        this.fun.apply(null, this.array);
    };
    $4c2dd1b68d143d96$var$lc = "browser", $4c2dd1b68d143d96$var$cc = "x64", $4c2dd1b68d143d96$var$fc = "browser", $4c2dd1b68d143d96$var$hc = {
        PATH: "/usr/bin",
        LANG: typeof navigator < "u" ? navigator.language + ".UTF-8" : void 0,
        PWD: "/",
        HOME: "/home",
        TMP: "/tmp"
    }, $4c2dd1b68d143d96$var$dc = [
        "/usr/bin/node"
    ], $4c2dd1b68d143d96$var$pc = [], $4c2dd1b68d143d96$var$yc = "v16.8.0", $4c2dd1b68d143d96$var$gc = {}, $4c2dd1b68d143d96$var$bc = function(t, e) {
        console.warn((e ? e + ": " : "") + t);
    }, $4c2dd1b68d143d96$var$wc = function(t) {
        $4c2dd1b68d143d96$var$cs("binding");
    }, $4c2dd1b68d143d96$var$mc = function(t) {
        return 0;
    }, $4c2dd1b68d143d96$var$_c = function() {
        return "/";
    }, $4c2dd1b68d143d96$var$vc = function(t) {}, $4c2dd1b68d143d96$var$Sc = {
        name: "node",
        sourceUrl: "",
        headersUrl: "",
        libUrl: ""
    };
    $4c2dd1b68d143d96$var$Ec = !0, $4c2dd1b68d143d96$var$Ac = $4c2dd1b68d143d96$var$Ue, $4c2dd1b68d143d96$var$Ic = [];
    $4c2dd1b68d143d96$var$Tc = {}, $4c2dd1b68d143d96$var$Pc = !1, $4c2dd1b68d143d96$var$Oc = {};
    $4c2dd1b68d143d96$var$Bc = $4c2dd1b68d143d96$var$Ue, $4c2dd1b68d143d96$var$Mc = $4c2dd1b68d143d96$var$Ue, $4c2dd1b68d143d96$var$Ri = function() {
        return {};
    }, $4c2dd1b68d143d96$var$Nc = $4c2dd1b68d143d96$var$Ri, $4c2dd1b68d143d96$var$qc = $4c2dd1b68d143d96$var$Ri, $4c2dd1b68d143d96$var$Lc = $4c2dd1b68d143d96$var$Ue, $4c2dd1b68d143d96$var$Uc = $4c2dd1b68d143d96$var$Ue, $4c2dd1b68d143d96$var$Dc = $4c2dd1b68d143d96$var$Ue, $4c2dd1b68d143d96$var$jc = {};
    $4c2dd1b68d143d96$var$Wc = {
        inspector: !1,
        debug: !1,
        uv: !1,
        ipv6: !1,
        tls_alpn: !1,
        tls_sni: !1,
        tls_ocsp: !1,
        tls: !1,
        cached_builtins: !0
    }, $4c2dd1b68d143d96$var$$c = $4c2dd1b68d143d96$var$Ue, $4c2dd1b68d143d96$var$Hc = $4c2dd1b68d143d96$var$Ue;
    $4c2dd1b68d143d96$var$Gc = $4c2dd1b68d143d96$var$Ue, $4c2dd1b68d143d96$var$zc = $4c2dd1b68d143d96$var$Ue, $4c2dd1b68d143d96$var$Kc = $4c2dd1b68d143d96$var$Ue, $4c2dd1b68d143d96$var$Qc = $4c2dd1b68d143d96$var$Ue, $4c2dd1b68d143d96$var$Yc = $4c2dd1b68d143d96$var$Ue, $4c2dd1b68d143d96$var$Jc = void 0, $4c2dd1b68d143d96$var$Xc = void 0, $4c2dd1b68d143d96$var$Zc = void 0, $4c2dd1b68d143d96$var$ef = $4c2dd1b68d143d96$var$Ue, $4c2dd1b68d143d96$var$tf = 2, $4c2dd1b68d143d96$var$rf = 1, $4c2dd1b68d143d96$var$nf = "/bin/usr/node", $4c2dd1b68d143d96$var$of = 9229, $4c2dd1b68d143d96$var$sf = "node", $4c2dd1b68d143d96$var$af = [], $4c2dd1b68d143d96$var$uf = $4c2dd1b68d143d96$var$Ue, $4c2dd1b68d143d96$var$Jt = {
        now: typeof performance < "u" ? performance.now.bind(performance) : void 0,
        timing: typeof performance < "u" ? performance.timing : void 0
    };
    $4c2dd1b68d143d96$var$Jt.now === void 0 && ($4c2dd1b68d143d96$var$us = Date.now(), $4c2dd1b68d143d96$var$Jt.timing && $4c2dd1b68d143d96$var$Jt.timing.navigationStart && ($4c2dd1b68d143d96$var$us = $4c2dd1b68d143d96$var$Jt.timing.navigationStart), $4c2dd1b68d143d96$var$Jt.now = ()=>Date.now() - $4c2dd1b68d143d96$var$us);
    $4c2dd1b68d143d96$var$ls = 1e9;
    $4c2dd1b68d143d96$var$Oi.bigint = function(t) {
        var e = $4c2dd1b68d143d96$var$Oi(t);
        return typeof BigInt > "u" ? e[0] * $4c2dd1b68d143d96$var$ls + e[1] : BigInt(e[0] * $4c2dd1b68d143d96$var$ls) + BigInt(e[1]);
    };
    $4c2dd1b68d143d96$var$cf = 10, $4c2dd1b68d143d96$var$ff = {}, $4c2dd1b68d143d96$var$hf = 0;
    $4c2dd1b68d143d96$var$df = $4c2dd1b68d143d96$var$Nt, $4c2dd1b68d143d96$var$pf = $4c2dd1b68d143d96$var$Nt, $4c2dd1b68d143d96$var$yf = $4c2dd1b68d143d96$var$Nt, $4c2dd1b68d143d96$var$gf = $4c2dd1b68d143d96$var$Nt, $4c2dd1b68d143d96$var$bf = $4c2dd1b68d143d96$var$Nt, $4c2dd1b68d143d96$var$wf = $4c2dd1b68d143d96$var$Ue, $4c2dd1b68d143d96$var$mf = $4c2dd1b68d143d96$var$Nt, $4c2dd1b68d143d96$var$_f = $4c2dd1b68d143d96$var$Nt;
    $4c2dd1b68d143d96$var$Sf = {
        version: $4c2dd1b68d143d96$var$yc,
        versions: $4c2dd1b68d143d96$var$gc,
        arch: $4c2dd1b68d143d96$var$cc,
        platform: $4c2dd1b68d143d96$var$fc,
        browser: $4c2dd1b68d143d96$var$Ec,
        release: $4c2dd1b68d143d96$var$Sc,
        _rawDebug: $4c2dd1b68d143d96$var$Ac,
        moduleLoadList: $4c2dd1b68d143d96$var$Ic,
        binding: $4c2dd1b68d143d96$var$wc,
        _linkedBinding: $4c2dd1b68d143d96$var$xc,
        _events: $4c2dd1b68d143d96$var$ff,
        _eventsCount: $4c2dd1b68d143d96$var$hf,
        _maxListeners: $4c2dd1b68d143d96$var$cf,
        on: $4c2dd1b68d143d96$var$Nt,
        addListener: $4c2dd1b68d143d96$var$df,
        once: $4c2dd1b68d143d96$var$pf,
        off: $4c2dd1b68d143d96$var$yf,
        removeListener: $4c2dd1b68d143d96$var$gf,
        removeAllListeners: $4c2dd1b68d143d96$var$bf,
        emit: $4c2dd1b68d143d96$var$wf,
        prependListener: $4c2dd1b68d143d96$var$mf,
        prependOnceListener: $4c2dd1b68d143d96$var$_f,
        listeners: $4c2dd1b68d143d96$var$vf,
        domain: $4c2dd1b68d143d96$var$Tc,
        _exiting: $4c2dd1b68d143d96$var$Pc,
        config: $4c2dd1b68d143d96$var$Oc,
        dlopen: $4c2dd1b68d143d96$var$Rc,
        uptime: $4c2dd1b68d143d96$var$lf,
        _getActiveRequests: $4c2dd1b68d143d96$var$kc,
        _getActiveHandles: $4c2dd1b68d143d96$var$Cc,
        reallyExit: $4c2dd1b68d143d96$var$Bc,
        _kill: $4c2dd1b68d143d96$var$Mc,
        cpuUsage: $4c2dd1b68d143d96$var$Ri,
        resourceUsage: $4c2dd1b68d143d96$var$Nc,
        memoryUsage: $4c2dd1b68d143d96$var$qc,
        kill: $4c2dd1b68d143d96$var$Lc,
        exit: $4c2dd1b68d143d96$var$Uc,
        openStdin: $4c2dd1b68d143d96$var$Dc,
        allowedNodeEnvironmentFlags: $4c2dd1b68d143d96$var$jc,
        assert: $4c2dd1b68d143d96$var$Fc,
        features: $4c2dd1b68d143d96$var$Wc,
        _fatalExceptions: $4c2dd1b68d143d96$var$$c,
        setUncaughtExceptionCaptureCallback: $4c2dd1b68d143d96$var$Hc,
        hasUncaughtExceptionCaptureCallback: $4c2dd1b68d143d96$var$Vc,
        emitWarning: $4c2dd1b68d143d96$var$bc,
        nextTick: $4c2dd1b68d143d96$var$ac,
        _tickCallback: $4c2dd1b68d143d96$var$Gc,
        _debugProcess: $4c2dd1b68d143d96$var$zc,
        _debugEnd: $4c2dd1b68d143d96$var$Kc,
        _startProfilerIdleNotifier: $4c2dd1b68d143d96$var$Qc,
        _stopProfilerIdleNotifier: $4c2dd1b68d143d96$var$Yc,
        stdout: $4c2dd1b68d143d96$var$Jc,
        stdin: $4c2dd1b68d143d96$var$Zc,
        stderr: $4c2dd1b68d143d96$var$Xc,
        abort: $4c2dd1b68d143d96$var$ef,
        umask: $4c2dd1b68d143d96$var$mc,
        chdir: $4c2dd1b68d143d96$var$vc,
        cwd: $4c2dd1b68d143d96$var$_c,
        env: $4c2dd1b68d143d96$var$hc,
        title: $4c2dd1b68d143d96$var$lc,
        argv: $4c2dd1b68d143d96$var$dc,
        execArgv: $4c2dd1b68d143d96$var$pc,
        pid: $4c2dd1b68d143d96$var$tf,
        ppid: $4c2dd1b68d143d96$var$rf,
        execPath: $4c2dd1b68d143d96$var$nf,
        debugPort: $4c2dd1b68d143d96$var$of,
        hrtime: $4c2dd1b68d143d96$var$Oi,
        argv0: $4c2dd1b68d143d96$var$sf,
        _preload_modules: $4c2dd1b68d143d96$var$af,
        setSourceMapsEnabled: $4c2dd1b68d143d96$var$uf
    };
});
var $4c2dd1b68d143d96$var$I = $4c2dd1b68d143d96$var$ze(()=>{
    $4c2dd1b68d143d96$var$Ef();
});
function $4c2dd1b68d143d96$var$tw() {
    if ($4c2dd1b68d143d96$var$Af) return $4c2dd1b68d143d96$var$On;
    $4c2dd1b68d143d96$var$Af = !0, $4c2dd1b68d143d96$var$On.byteLength = a, $4c2dd1b68d143d96$var$On.toByteArray = f, $4c2dd1b68d143d96$var$On.fromByteArray = w;
    for(var t = [], e = [], r = typeof Uint8Array < "u" ? Uint8Array : Array, n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = 0, s = n.length; i < s; ++i)t[i] = n[i], e[n.charCodeAt(i)] = i;
    e[45] = 62, e[95] = 63;
    function o(y) {
        var P = y.length;
        if (P % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        var E = y.indexOf("=");
        E === -1 && (E = P);
        var b = E === P ? 0 : 4 - E % 4;
        return [
            E,
            b
        ];
    }
    function a(y) {
        var P = o(y), E = P[0], b = P[1];
        return (E + b) * 3 / 4 - b;
    }
    function c(y, P, E) {
        return (P + E) * 3 / 4 - E;
    }
    function f(y) {
        var P, E = o(y), b = E[0], m = E[1], v = new r(c(y, b, m)), R = 0, T = m > 0 ? b - 4 : b, g;
        for(g = 0; g < T; g += 4)P = e[y.charCodeAt(g)] << 18 | e[y.charCodeAt(g + 1)] << 12 | e[y.charCodeAt(g + 2)] << 6 | e[y.charCodeAt(g + 3)], v[R++] = P >> 16 & 255, v[R++] = P >> 8 & 255, v[R++] = P & 255;
        return m === 2 && (P = e[y.charCodeAt(g)] << 2 | e[y.charCodeAt(g + 1)] >> 4, v[R++] = P & 255), m === 1 && (P = e[y.charCodeAt(g)] << 10 | e[y.charCodeAt(g + 1)] << 4 | e[y.charCodeAt(g + 2)] >> 2, v[R++] = P >> 8 & 255, v[R++] = P & 255), v;
    }
    function h(y) {
        return t[y >> 18 & 63] + t[y >> 12 & 63] + t[y >> 6 & 63] + t[y & 63];
    }
    function d(y, P, E) {
        for(var b, m = [], v = P; v < E; v += 3)b = (y[v] << 16 & 16711680) + (y[v + 1] << 8 & 65280) + (y[v + 2] & 255), m.push(h(b));
        return m.join("");
    }
    function w(y) {
        for(var P, E = y.length, b = E % 3, m = [], v = 16383, R = 0, T = E - b; R < T; R += v)m.push(d(y, R, R + v > T ? T : R + v));
        return b === 1 ? (P = y[E - 1], m.push(t[P >> 2] + t[P << 4 & 63] + "==")) : b === 2 && (P = (y[E - 2] << 8) + y[E - 1], m.push(t[P >> 10] + t[P >> 4 & 63] + t[P << 2 & 63] + "=")), m.join("");
    }
    return $4c2dd1b68d143d96$var$On;
}
function $4c2dd1b68d143d96$var$rw() {
    if ($4c2dd1b68d143d96$var$If) return $4c2dd1b68d143d96$var$ki;
    $4c2dd1b68d143d96$var$If = !0;
    return $4c2dd1b68d143d96$var$ki.read = function(t, e, r, n, i) {
        var s, o, a = i * 8 - n - 1, c = (1 << a) - 1, f = c >> 1, h = -7, d = r ? i - 1 : 0, w = r ? -1 : 1, y = t[e + d];
        for(d += w, s = y & (1 << -h) - 1, y >>= -h, h += a; h > 0; s = s * 256 + t[e + d], d += w, h -= 8);
        for(o = s & (1 << -h) - 1, s >>= -h, h += n; h > 0; o = o * 256 + t[e + d], d += w, h -= 8);
        if (s === 0) s = 1 - f;
        else {
            if (s === c) return o ? NaN : (y ? -1 : 1) * (1 / 0);
            o = o + Math.pow(2, n), s = s - f;
        }
        return (y ? -1 : 1) * o * Math.pow(2, s - n);
    }, $4c2dd1b68d143d96$var$ki.write = function(t, e, r, n, i, s) {
        var o, a, c, f = s * 8 - i - 1, h = (1 << f) - 1, d = h >> 1, w = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, y = n ? 0 : s - 1, P = n ? 1 : -1, E = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
        for(e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, o = h) : (o = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -o)) < 1 && (o--, c *= 2), o + d >= 1 ? e += w / c : e += w * Math.pow(2, 1 - d), e * c >= 2 && (o++, c /= 2), o + d >= h ? (a = 0, o = h) : o + d >= 1 ? (a = (e * c - 1) * Math.pow(2, i), o = o + d) : (a = e * Math.pow(2, d - 1) * Math.pow(2, i), o = 0)); i >= 8; t[r + y] = a & 255, y += P, a /= 256, i -= 8);
        for(o = o << i | a, f += i; f > 0; t[r + y] = o & 255, y += P, o /= 256, f -= 8);
        t[r + y - P] |= E * 128;
    }, $4c2dd1b68d143d96$var$ki;
}
function $4c2dd1b68d143d96$var$Tf() {
    if ($4c2dd1b68d143d96$var$xf) return $4c2dd1b68d143d96$var$mr;
    $4c2dd1b68d143d96$var$xf = !0;
    let t = $4c2dd1b68d143d96$var$tw(), e = $4c2dd1b68d143d96$var$rw(), r = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    $4c2dd1b68d143d96$var$mr.Buffer = o, $4c2dd1b68d143d96$var$mr.SlowBuffer = m, $4c2dd1b68d143d96$var$mr.INSPECT_MAX_BYTES = 50;
    let n = 2147483647;
    $4c2dd1b68d143d96$var$mr.kMaxLength = n, o.TYPED_ARRAY_SUPPORT = i(), !o.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
    function i() {
        try {
            let p = new Uint8Array(1), u = {
                foo: function() {
                    return 42;
                }
            };
            return Object.setPrototypeOf(u, Uint8Array.prototype), Object.setPrototypeOf(p, u), p.foo() === 42;
        } catch  {
            return !1;
        }
    }
    Object.defineProperty(o.prototype, "parent", {
        enumerable: !0,
        get: function() {
            if (o.isBuffer(this)) return this.buffer;
        }
    }), Object.defineProperty(o.prototype, "offset", {
        enumerable: !0,
        get: function() {
            if (o.isBuffer(this)) return this.byteOffset;
        }
    });
    function s(p) {
        if (p > n) throw new RangeError('The value "' + p + '" is invalid for option "size"');
        let u = new Uint8Array(p);
        return Object.setPrototypeOf(u, o.prototype), u;
    }
    function o(p, u, l) {
        if (typeof p == "number") {
            if (typeof u == "string") throw new TypeError('The "string" argument must be of type string. Received type number');
            return h(p);
        }
        return a(p, u, l);
    }
    o.poolSize = 8192;
    function a(p, u, l) {
        if (typeof p == "string") return d(p, u);
        if (ArrayBuffer.isView(p)) return y(p);
        if (p == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof p);
        if (Ze(p, ArrayBuffer) || p && Ze(p.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Ze(p, SharedArrayBuffer) || p && Ze(p.buffer, SharedArrayBuffer))) return P(p, u, l);
        if (typeof p == "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
        let S = p.valueOf && p.valueOf();
        if (S != null && S !== p) return o.from(S, u, l);
        let C = E(p);
        if (C) return C;
        if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof p[Symbol.toPrimitive] == "function") return o.from(p[Symbol.toPrimitive]("string"), u, l);
        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof p);
    }
    o.from = function(p, u, l) {
        return a(p, u, l);
    }, Object.setPrototypeOf(o.prototype, Uint8Array.prototype), Object.setPrototypeOf(o, Uint8Array);
    function c(p) {
        if (typeof p != "number") throw new TypeError('"size" argument must be of type number');
        if (p < 0) throw new RangeError('The value "' + p + '" is invalid for option "size"');
    }
    function f(p, u, l) {
        return c(p), p <= 0 ? s(p) : u !== void 0 ? typeof l == "string" ? s(p).fill(u, l) : s(p).fill(u) : s(p);
    }
    o.alloc = function(p, u, l) {
        return f(p, u, l);
    };
    function h(p) {
        return c(p), s(p < 0 ? 0 : b(p) | 0);
    }
    o.allocUnsafe = function(p) {
        return h(p);
    }, o.allocUnsafeSlow = function(p) {
        return h(p);
    };
    function d(p, u) {
        if ((typeof u != "string" || u === "") && (u = "utf8"), !o.isEncoding(u)) throw new TypeError("Unknown encoding: " + u);
        let l = v(p, u) | 0, S = s(l), C = S.write(p, u);
        return C !== l && (S = S.slice(0, C)), S;
    }
    function w(p) {
        let u = p.length < 0 ? 0 : b(p.length) | 0, l = s(u);
        for(let S = 0; S < u; S += 1)l[S] = p[S] & 255;
        return l;
    }
    function y(p) {
        if (Ze(p, Uint8Array)) {
            let u = new Uint8Array(p);
            return P(u.buffer, u.byteOffset, u.byteLength);
        }
        return w(p);
    }
    function P(p, u, l) {
        if (u < 0 || p.byteLength < u) throw new RangeError('"offset" is outside of buffer bounds');
        if (p.byteLength < u + (l || 0)) throw new RangeError('"length" is outside of buffer bounds');
        let S;
        return u === void 0 && l === void 0 ? S = new Uint8Array(p) : l === void 0 ? S = new Uint8Array(p, u) : S = new Uint8Array(p, u, l), Object.setPrototypeOf(S, o.prototype), S;
    }
    function E(p) {
        if (o.isBuffer(p)) {
            let u = b(p.length) | 0, l = s(u);
            return l.length === 0 || p.copy(l, 0, 0, u), l;
        }
        if (p.length !== void 0) return typeof p.length != "number" || Tn(p.length) ? s(0) : w(p);
        if (p.type === "Buffer" && Array.isArray(p.data)) return w(p.data);
    }
    function b(p) {
        if (p >= n) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + n.toString(16) + " bytes");
        return p | 0;
    }
    function m(p) {
        return +p != p && (p = 0), o.alloc(+p);
    }
    o.isBuffer = function(u) {
        return u != null && u._isBuffer === !0 && u !== o.prototype;
    }, o.compare = function(u, l) {
        if (Ze(u, Uint8Array) && (u = o.from(u, u.offset, u.byteLength)), Ze(l, Uint8Array) && (l = o.from(l, l.offset, l.byteLength)), !o.isBuffer(u) || !o.isBuffer(l)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
        if (u === l) return 0;
        let S = u.length, C = l.length;
        for(let N = 0, F = Math.min(S, C); N < F; ++N)if (u[N] !== l[N]) {
            S = u[N], C = l[N];
            break;
        }
        return S < C ? -1 : C < S ? 1 : 0;
    }, o.isEncoding = function(u) {
        switch(String(u).toLowerCase()){
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return !0;
            default:
                return !1;
        }
    }, o.concat = function(u, l) {
        if (!Array.isArray(u)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (u.length === 0) return o.alloc(0);
        let S;
        if (l === void 0) for(l = 0, S = 0; S < u.length; ++S)l += u[S].length;
        let C = o.allocUnsafe(l), N = 0;
        for(S = 0; S < u.length; ++S){
            let F = u[S];
            if (Ze(F, Uint8Array)) N + F.length > C.length ? (o.isBuffer(F) || (F = o.from(F)), F.copy(C, N)) : Uint8Array.prototype.set.call(C, F, N);
            else if (o.isBuffer(F)) F.copy(C, N);
            else throw new TypeError('"list" argument must be an Array of Buffers');
            N += F.length;
        }
        return C;
    };
    function v(p, u) {
        if (o.isBuffer(p)) return p.length;
        if (ArrayBuffer.isView(p) || Ze(p, ArrayBuffer)) return p.byteLength;
        if (typeof p != "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof p);
        let l = p.length, S = arguments.length > 2 && arguments[2] === !0;
        if (!S && l === 0) return 0;
        let C = !1;
        for(;;)switch(u){
            case "ascii":
            case "latin1":
            case "binary":
                return l;
            case "utf8":
            case "utf-8":
                return Ct(p).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return l * 2;
            case "hex":
                return l >>> 1;
            case "base64":
                return Ii(p).length;
            default:
                if (C) return S ? -1 : Ct(p).length;
                u = ("" + u).toLowerCase(), C = !0;
        }
    }
    o.byteLength = v;
    function R(p, u, l) {
        let S = !1;
        if ((u === void 0 || u < 0) && (u = 0), u > this.length || ((l === void 0 || l > this.length) && (l = this.length), l <= 0) || (l >>>= 0, u >>>= 0, l <= u)) return "";
        for(p || (p = "utf8");;)switch(p){
            case "hex":
                return V(this, u, l);
            case "utf8":
            case "utf-8":
                return H(this, u, l);
            case "ascii":
                return X(this, u, l);
            case "latin1":
            case "binary":
                return Q(this, u, l);
            case "base64":
                return W(this, u, l);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return te(this, u, l);
            default:
                if (S) throw new TypeError("Unknown encoding: " + p);
                p = (p + "").toLowerCase(), S = !0;
        }
    }
    o.prototype._isBuffer = !0;
    function T(p, u, l) {
        let S = p[u];
        p[u] = p[l], p[l] = S;
    }
    o.prototype.swap16 = function() {
        let u = this.length;
        if (u % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
        for(let l = 0; l < u; l += 2)T(this, l, l + 1);
        return this;
    }, o.prototype.swap32 = function() {
        let u = this.length;
        if (u % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
        for(let l = 0; l < u; l += 4)T(this, l, l + 3), T(this, l + 1, l + 2);
        return this;
    }, o.prototype.swap64 = function() {
        let u = this.length;
        if (u % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
        for(let l = 0; l < u; l += 8)T(this, l, l + 7), T(this, l + 1, l + 6), T(this, l + 2, l + 5), T(this, l + 3, l + 4);
        return this;
    }, o.prototype.toString = function() {
        let u = this.length;
        return u === 0 ? "" : arguments.length === 0 ? H(this, 0, u) : R.apply(this, arguments);
    }, o.prototype.toLocaleString = o.prototype.toString, o.prototype.equals = function(u) {
        if (!o.isBuffer(u)) throw new TypeError("Argument must be a Buffer");
        return this === u ? !0 : o.compare(this, u) === 0;
    }, o.prototype.inspect = function() {
        let u = "", l = $4c2dd1b68d143d96$var$mr.INSPECT_MAX_BYTES;
        return u = this.toString("hex", 0, l).replace(/(.{2})/g, "$1 ").trim(), this.length > l && (u += " ... "), "<Buffer " + u + ">";
    }, r && (o.prototype[r] = o.prototype.inspect), o.prototype.compare = function(u, l, S, C, N) {
        if (Ze(u, Uint8Array) && (u = o.from(u, u.offset, u.byteLength)), !o.isBuffer(u)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof u);
        if (l === void 0 && (l = 0), S === void 0 && (S = u ? u.length : 0), C === void 0 && (C = 0), N === void 0 && (N = this.length), l < 0 || S > u.length || C < 0 || N > this.length) throw new RangeError("out of range index");
        if (C >= N && l >= S) return 0;
        if (C >= N) return -1;
        if (l >= S) return 1;
        if (l >>>= 0, S >>>= 0, C >>>= 0, N >>>= 0, this === u) return 0;
        let F = N - C, k = S - l, B = Math.min(F, k), re = this.slice(C, N), ie = u.slice(l, S);
        for(let oe = 0; oe < B; ++oe)if (re[oe] !== ie[oe]) {
            F = re[oe], k = ie[oe];
            break;
        }
        return F < k ? -1 : k < F ? 1 : 0;
    };
    function g(p, u, l, S, C) {
        if (p.length === 0) return -1;
        if (typeof l == "string" ? (S = l, l = 0) : l > 2147483647 ? l = 2147483647 : l < -2147483648 && (l = -2147483648), l = +l, Tn(l) && (l = C ? 0 : p.length - 1), l < 0 && (l = p.length + l), l >= p.length) {
            if (C) return -1;
            l = p.length - 1;
        } else if (l < 0) {
            if (C) l = 0;
            else return -1;
        }
        if (typeof u == "string" && (u = o.from(u, S)), o.isBuffer(u)) return u.length === 0 ? -1 : O(p, u, l, S, C);
        if (typeof u == "number") return u = u & 255, typeof Uint8Array.prototype.indexOf == "function" ? C ? Uint8Array.prototype.indexOf.call(p, u, l) : Uint8Array.prototype.lastIndexOf.call(p, u, l) : O(p, [
            u
        ], l, S, C);
        throw new TypeError("val must be string, number or Buffer");
    }
    function O(p, u, l, S, C) {
        let N = 1, F = p.length, k = u.length;
        if (S !== void 0 && (S = String(S).toLowerCase(), S === "ucs2" || S === "ucs-2" || S === "utf16le" || S === "utf-16le")) {
            if (p.length < 2 || u.length < 2) return -1;
            N = 2, F /= 2, k /= 2, l /= 2;
        }
        function B(ie, oe) {
            return N === 1 ? ie[oe] : ie.readUInt16BE(oe * N);
        }
        let re;
        if (C) {
            let ie = -1;
            for(re = l; re < F; re++)if (B(p, re) === B(u, ie === -1 ? 0 : re - ie)) {
                if (ie === -1 && (ie = re), re - ie + 1 === k) return ie * N;
            } else ie !== -1 && (re -= re - ie), ie = -1;
        } else for(l + k > F && (l = F - k), re = l; re >= 0; re--){
            let ie = !0;
            for(let oe = 0; oe < k; oe++)if (B(p, re + oe) !== B(u, oe)) {
                ie = !1;
                break;
            }
            if (ie) return re;
        }
        return -1;
    }
    o.prototype.includes = function(u, l, S) {
        return this.indexOf(u, l, S) !== -1;
    }, o.prototype.indexOf = function(u, l, S) {
        return g(this, u, l, S, !0);
    }, o.prototype.lastIndexOf = function(u, l, S) {
        return g(this, u, l, S, !1);
    };
    function _(p, u, l, S) {
        l = Number(l) || 0;
        let C = p.length - l;
        S ? (S = Number(S), S > C && (S = C)) : S = C;
        let N = u.length;
        S > N / 2 && (S = N / 2);
        let F;
        for(F = 0; F < S; ++F){
            let k = parseInt(u.substr(F * 2, 2), 16);
            if (Tn(k)) return F;
            p[l + F] = k;
        }
        return F;
    }
    function q(p, u, l, S) {
        return Vr(Ct(u, p.length - l), p, l, S);
    }
    function $(p, u, l, S) {
        return Vr(Bt(u), p, l, S);
    }
    function j(p, u, l, S) {
        return Vr(Ii(u), p, l, S);
    }
    function J(p, u, l, S) {
        return Vr(xn(u, p.length - l), p, l, S);
    }
    o.prototype.write = function(u, l, S, C) {
        if (l === void 0) C = "utf8", S = this.length, l = 0;
        else if (S === void 0 && typeof l == "string") C = l, S = this.length, l = 0;
        else if (isFinite(l)) l = l >>> 0, isFinite(S) ? (S = S >>> 0, C === void 0 && (C = "utf8")) : (C = S, S = void 0);
        else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
        let N = this.length - l;
        if ((S === void 0 || S > N) && (S = N), u.length > 0 && (S < 0 || l < 0) || l > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        C || (C = "utf8");
        let F = !1;
        for(;;)switch(C){
            case "hex":
                return _(this, u, l, S);
            case "utf8":
            case "utf-8":
                return q(this, u, l, S);
            case "ascii":
            case "latin1":
            case "binary":
                return $(this, u, l, S);
            case "base64":
                return j(this, u, l, S);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return J(this, u, l, S);
            default:
                if (F) throw new TypeError("Unknown encoding: " + C);
                C = ("" + C).toLowerCase(), F = !0;
        }
    }, o.prototype.toJSON = function() {
        return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
        };
    };
    function W(p, u, l) {
        return u === 0 && l === p.length ? t.fromByteArray(p) : t.fromByteArray(p.slice(u, l));
    }
    function H(p, u, l) {
        l = Math.min(p.length, l);
        let S = [], C = u;
        for(; C < l;){
            let N = p[C], F = null, k = N > 239 ? 4 : N > 223 ? 3 : N > 191 ? 2 : 1;
            if (C + k <= l) {
                let B, re, ie, oe;
                switch(k){
                    case 1:
                        N < 128 && (F = N);
                        break;
                    case 2:
                        B = p[C + 1], (B & 192) === 128 && (oe = (N & 31) << 6 | B & 63, oe > 127 && (F = oe));
                        break;
                    case 3:
                        B = p[C + 1], re = p[C + 2], (B & 192) === 128 && (re & 192) === 128 && (oe = (N & 15) << 12 | (B & 63) << 6 | re & 63, oe > 2047 && (oe < 55296 || oe > 57343) && (F = oe));
                        break;
                    case 4:
                        B = p[C + 1], re = p[C + 2], ie = p[C + 3], (B & 192) === 128 && (re & 192) === 128 && (ie & 192) === 128 && (oe = (N & 15) << 18 | (B & 63) << 12 | (re & 63) << 6 | ie & 63, oe > 65535 && oe < 1114112 && (F = oe));
                }
            }
            F === null ? (F = 65533, k = 1) : F > 65535 && (F -= 65536, S.push(F >>> 10 & 1023 | 55296), F = 56320 | F & 1023), S.push(F), C += k;
        }
        return K(S);
    }
    let G = 4096;
    function K(p) {
        let u = p.length;
        if (u <= G) return String.fromCharCode.apply(String, p);
        let l = "", S = 0;
        for(; S < u;)l += String.fromCharCode.apply(String, p.slice(S, S += G));
        return l;
    }
    function X(p, u, l) {
        let S = "";
        l = Math.min(p.length, l);
        for(let C = u; C < l; ++C)S += String.fromCharCode(p[C] & 127);
        return S;
    }
    function Q(p, u, l) {
        let S = "";
        l = Math.min(p.length, l);
        for(let C = u; C < l; ++C)S += String.fromCharCode(p[C]);
        return S;
    }
    function V(p, u, l) {
        let S = p.length;
        (!u || u < 0) && (u = 0), (!l || l < 0 || l > S) && (l = S);
        let C = "";
        for(let N = u; N < l; ++N)C += Xo[p[N]];
        return C;
    }
    function te(p, u, l) {
        let S = p.slice(u, l), C = "";
        for(let N = 0; N < S.length - 1; N += 2)C += String.fromCharCode(S[N] + S[N + 1] * 256);
        return C;
    }
    o.prototype.slice = function(u, l) {
        let S = this.length;
        u = ~~u, l = l === void 0 ? S : ~~l, u < 0 ? (u += S, u < 0 && (u = 0)) : u > S && (u = S), l < 0 ? (l += S, l < 0 && (l = 0)) : l > S && (l = S), l < u && (l = u);
        let C = this.subarray(u, l);
        return Object.setPrototypeOf(C, o.prototype), C;
    };
    function Y(p, u, l) {
        if (p % 1 !== 0 || p < 0) throw new RangeError("offset is not uint");
        if (p + u > l) throw new RangeError("Trying to access beyond buffer length");
    }
    o.prototype.readUintLE = o.prototype.readUIntLE = function(u, l, S) {
        u = u >>> 0, l = l >>> 0, S || Y(u, l, this.length);
        let C = this[u], N = 1, F = 0;
        for(; ++F < l && (N *= 256);)C += this[u + F] * N;
        return C;
    }, o.prototype.readUintBE = o.prototype.readUIntBE = function(u, l, S) {
        u = u >>> 0, l = l >>> 0, S || Y(u, l, this.length);
        let C = this[u + --l], N = 1;
        for(; l > 0 && (N *= 256);)C += this[u + --l] * N;
        return C;
    }, o.prototype.readUint8 = o.prototype.readUInt8 = function(u, l) {
        return u = u >>> 0, l || Y(u, 1, this.length), this[u];
    }, o.prototype.readUint16LE = o.prototype.readUInt16LE = function(u, l) {
        return u = u >>> 0, l || Y(u, 2, this.length), this[u] | this[u + 1] << 8;
    }, o.prototype.readUint16BE = o.prototype.readUInt16BE = function(u, l) {
        return u = u >>> 0, l || Y(u, 2, this.length), this[u] << 8 | this[u + 1];
    }, o.prototype.readUint32LE = o.prototype.readUInt32LE = function(u, l) {
        return u = u >>> 0, l || Y(u, 4, this.length), (this[u] | this[u + 1] << 8 | this[u + 2] << 16) + this[u + 3] * 16777216;
    }, o.prototype.readUint32BE = o.prototype.readUInt32BE = function(u, l) {
        return u = u >>> 0, l || Y(u, 4, this.length), this[u] * 16777216 + (this[u + 1] << 16 | this[u + 2] << 8 | this[u + 3]);
    }, o.prototype.readBigUInt64LE = at(function(u) {
        u = u >>> 0, xe(u, "offset");
        let l = this[u], S = this[u + 7];
        (l === void 0 || S === void 0) && st(u, this.length - 8);
        let C = l + this[++u] * 256 + this[++u] * 2 ** 16 + this[++u] * 2 ** 24, N = this[++u] + this[++u] * 256 + this[++u] * 2 ** 16 + S * 2 ** 24;
        return BigInt(C) + (BigInt(N) << BigInt(32));
    }), o.prototype.readBigUInt64BE = at(function(u) {
        u = u >>> 0, xe(u, "offset");
        let l = this[u], S = this[u + 7];
        (l === void 0 || S === void 0) && st(u, this.length - 8);
        let C = l * 2 ** 24 + this[++u] * 2 ** 16 + this[++u] * 256 + this[++u], N = this[++u] * 2 ** 24 + this[++u] * 2 ** 16 + this[++u] * 256 + S;
        return (BigInt(C) << BigInt(32)) + BigInt(N);
    }), o.prototype.readIntLE = function(u, l, S) {
        u = u >>> 0, l = l >>> 0, S || Y(u, l, this.length);
        let C = this[u], N = 1, F = 0;
        for(; ++F < l && (N *= 256);)C += this[u + F] * N;
        return N *= 128, C >= N && (C -= Math.pow(2, 8 * l)), C;
    }, o.prototype.readIntBE = function(u, l, S) {
        u = u >>> 0, l = l >>> 0, S || Y(u, l, this.length);
        let C = l, N = 1, F = this[u + --C];
        for(; C > 0 && (N *= 256);)F += this[u + --C] * N;
        return N *= 128, F >= N && (F -= Math.pow(2, 8 * l)), F;
    }, o.prototype.readInt8 = function(u, l) {
        return u = u >>> 0, l || Y(u, 1, this.length), this[u] & 128 ? (255 - this[u] + 1) * -1 : this[u];
    }, o.prototype.readInt16LE = function(u, l) {
        u = u >>> 0, l || Y(u, 2, this.length);
        let S = this[u] | this[u + 1] << 8;
        return S & 32768 ? S | 4294901760 : S;
    }, o.prototype.readInt16BE = function(u, l) {
        u = u >>> 0, l || Y(u, 2, this.length);
        let S = this[u + 1] | this[u] << 8;
        return S & 32768 ? S | 4294901760 : S;
    }, o.prototype.readInt32LE = function(u, l) {
        return u = u >>> 0, l || Y(u, 4, this.length), this[u] | this[u + 1] << 8 | this[u + 2] << 16 | this[u + 3] << 24;
    }, o.prototype.readInt32BE = function(u, l) {
        return u = u >>> 0, l || Y(u, 4, this.length), this[u] << 24 | this[u + 1] << 16 | this[u + 2] << 8 | this[u + 3];
    }, o.prototype.readBigInt64LE = at(function(u) {
        u = u >>> 0, xe(u, "offset");
        let l = this[u], S = this[u + 7];
        (l === void 0 || S === void 0) && st(u, this.length - 8);
        let C = this[u + 4] + this[u + 5] * 256 + this[u + 6] * 2 ** 16 + (S << 24);
        return (BigInt(C) << BigInt(32)) + BigInt(l + this[++u] * 256 + this[++u] * 2 ** 16 + this[++u] * 2 ** 24);
    }), o.prototype.readBigInt64BE = at(function(u) {
        u = u >>> 0, xe(u, "offset");
        let l = this[u], S = this[u + 7];
        (l === void 0 || S === void 0) && st(u, this.length - 8);
        let C = (l << 24) + this[++u] * 2 ** 16 + this[++u] * 256 + this[++u];
        return (BigInt(C) << BigInt(32)) + BigInt(this[++u] * 2 ** 24 + this[++u] * 2 ** 16 + this[++u] * 256 + S);
    }), o.prototype.readFloatLE = function(u, l) {
        return u = u >>> 0, l || Y(u, 4, this.length), e.read(this, u, !0, 23, 4);
    }, o.prototype.readFloatBE = function(u, l) {
        return u = u >>> 0, l || Y(u, 4, this.length), e.read(this, u, !1, 23, 4);
    }, o.prototype.readDoubleLE = function(u, l) {
        return u = u >>> 0, l || Y(u, 8, this.length), e.read(this, u, !0, 52, 8);
    }, o.prototype.readDoubleBE = function(u, l) {
        return u = u >>> 0, l || Y(u, 8, this.length), e.read(this, u, !1, 52, 8);
    };
    function ee(p, u, l, S, C, N) {
        if (!o.isBuffer(p)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (u > C || u < N) throw new RangeError('"value" argument is out of bounds');
        if (l + S > p.length) throw new RangeError("Index out of range");
    }
    o.prototype.writeUintLE = o.prototype.writeUIntLE = function(u, l, S, C) {
        if (u = +u, l = l >>> 0, S = S >>> 0, !C) {
            let k = Math.pow(2, 8 * S) - 1;
            ee(this, u, l, S, k, 0);
        }
        let N = 1, F = 0;
        for(this[l] = u & 255; ++F < S && (N *= 256);)this[l + F] = u / N & 255;
        return l + S;
    }, o.prototype.writeUintBE = o.prototype.writeUIntBE = function(u, l, S, C) {
        if (u = +u, l = l >>> 0, S = S >>> 0, !C) {
            let k = Math.pow(2, 8 * S) - 1;
            ee(this, u, l, S, k, 0);
        }
        let N = S - 1, F = 1;
        for(this[l + N] = u & 255; --N >= 0 && (F *= 256);)this[l + N] = u / F & 255;
        return l + S;
    }, o.prototype.writeUint8 = o.prototype.writeUInt8 = function(u, l, S) {
        return u = +u, l = l >>> 0, S || ee(this, u, l, 1, 255, 0), this[l] = u & 255, l + 1;
    }, o.prototype.writeUint16LE = o.prototype.writeUInt16LE = function(u, l, S) {
        return u = +u, l = l >>> 0, S || ee(this, u, l, 2, 65535, 0), this[l] = u & 255, this[l + 1] = u >>> 8, l + 2;
    }, o.prototype.writeUint16BE = o.prototype.writeUInt16BE = function(u, l, S) {
        return u = +u, l = l >>> 0, S || ee(this, u, l, 2, 65535, 0), this[l] = u >>> 8, this[l + 1] = u & 255, l + 2;
    }, o.prototype.writeUint32LE = o.prototype.writeUInt32LE = function(u, l, S) {
        return u = +u, l = l >>> 0, S || ee(this, u, l, 4, 4294967295, 0), this[l + 3] = u >>> 24, this[l + 2] = u >>> 16, this[l + 1] = u >>> 8, this[l] = u & 255, l + 4;
    }, o.prototype.writeUint32BE = o.prototype.writeUInt32BE = function(u, l, S) {
        return u = +u, l = l >>> 0, S || ee(this, u, l, 4, 4294967295, 0), this[l] = u >>> 24, this[l + 1] = u >>> 16, this[l + 2] = u >>> 8, this[l + 3] = u & 255, l + 4;
    };
    function pe(p, u, l, S, C) {
        Oe(u, S, C, p, l, 7);
        let N = Number(u & BigInt(4294967295));
        p[l++] = N, N = N >> 8, p[l++] = N, N = N >> 8, p[l++] = N, N = N >> 8, p[l++] = N;
        let F = Number(u >> BigInt(32) & BigInt(4294967295));
        return p[l++] = F, F = F >> 8, p[l++] = F, F = F >> 8, p[l++] = F, F = F >> 8, p[l++] = F, l;
    }
    function Z(p, u, l, S, C) {
        Oe(u, S, C, p, l, 7);
        let N = Number(u & BigInt(4294967295));
        p[l + 7] = N, N = N >> 8, p[l + 6] = N, N = N >> 8, p[l + 5] = N, N = N >> 8, p[l + 4] = N;
        let F = Number(u >> BigInt(32) & BigInt(4294967295));
        return p[l + 3] = F, F = F >> 8, p[l + 2] = F, F = F >> 8, p[l + 1] = F, F = F >> 8, p[l] = F, l + 8;
    }
    o.prototype.writeBigUInt64LE = at(function(u, l = 0) {
        return pe(this, u, l, BigInt(0), BigInt("0xffffffffffffffff"));
    }), o.prototype.writeBigUInt64BE = at(function(u, l = 0) {
        return Z(this, u, l, BigInt(0), BigInt("0xffffffffffffffff"));
    }), o.prototype.writeIntLE = function(u, l, S, C) {
        if (u = +u, l = l >>> 0, !C) {
            let B = Math.pow(2, 8 * S - 1);
            ee(this, u, l, S, B - 1, -B);
        }
        let N = 0, F = 1, k = 0;
        for(this[l] = u & 255; ++N < S && (F *= 256);)u < 0 && k === 0 && this[l + N - 1] !== 0 && (k = 1), this[l + N] = (u / F >> 0) - k & 255;
        return l + S;
    }, o.prototype.writeIntBE = function(u, l, S, C) {
        if (u = +u, l = l >>> 0, !C) {
            let B = Math.pow(2, 8 * S - 1);
            ee(this, u, l, S, B - 1, -B);
        }
        let N = S - 1, F = 1, k = 0;
        for(this[l + N] = u & 255; --N >= 0 && (F *= 256);)u < 0 && k === 0 && this[l + N + 1] !== 0 && (k = 1), this[l + N] = (u / F >> 0) - k & 255;
        return l + S;
    }, o.prototype.writeInt8 = function(u, l, S) {
        return u = +u, l = l >>> 0, S || ee(this, u, l, 1, 127, -128), u < 0 && (u = 255 + u + 1), this[l] = u & 255, l + 1;
    }, o.prototype.writeInt16LE = function(u, l, S) {
        return u = +u, l = l >>> 0, S || ee(this, u, l, 2, 32767, -32768), this[l] = u & 255, this[l + 1] = u >>> 8, l + 2;
    }, o.prototype.writeInt16BE = function(u, l, S) {
        return u = +u, l = l >>> 0, S || ee(this, u, l, 2, 32767, -32768), this[l] = u >>> 8, this[l + 1] = u & 255, l + 2;
    }, o.prototype.writeInt32LE = function(u, l, S) {
        return u = +u, l = l >>> 0, S || ee(this, u, l, 4, 2147483647, -2147483648), this[l] = u & 255, this[l + 1] = u >>> 8, this[l + 2] = u >>> 16, this[l + 3] = u >>> 24, l + 4;
    }, o.prototype.writeInt32BE = function(u, l, S) {
        return u = +u, l = l >>> 0, S || ee(this, u, l, 4, 2147483647, -2147483648), u < 0 && (u = 4294967295 + u + 1), this[l] = u >>> 24, this[l + 1] = u >>> 16, this[l + 2] = u >>> 8, this[l + 3] = u & 255, l + 4;
    }, o.prototype.writeBigInt64LE = at(function(u, l = 0) {
        return pe(this, u, l, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    }), o.prototype.writeBigInt64BE = at(function(u, l = 0) {
        return Z(this, u, l, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function ne(p, u, l, S, C, N) {
        if (l + S > p.length) throw new RangeError("Index out of range");
        if (l < 0) throw new RangeError("Index out of range");
    }
    function fe(p, u, l, S, C) {
        return u = +u, l = l >>> 0, C || ne(p, u, l, 4), e.write(p, u, l, S, 23, 4), l + 4;
    }
    o.prototype.writeFloatLE = function(u, l, S) {
        return fe(this, u, l, !0, S);
    }, o.prototype.writeFloatBE = function(u, l, S) {
        return fe(this, u, l, !1, S);
    };
    function be(p, u, l, S, C) {
        return u = +u, l = l >>> 0, C || ne(p, u, l, 8), e.write(p, u, l, S, 52, 8), l + 8;
    }
    o.prototype.writeDoubleLE = function(u, l, S) {
        return be(this, u, l, !0, S);
    }, o.prototype.writeDoubleBE = function(u, l, S) {
        return be(this, u, l, !1, S);
    }, o.prototype.copy = function(u, l, S, C) {
        if (!o.isBuffer(u)) throw new TypeError("argument should be a Buffer");
        if (S || (S = 0), !C && C !== 0 && (C = this.length), l >= u.length && (l = u.length), l || (l = 0), C > 0 && C < S && (C = S), C === S || u.length === 0 || this.length === 0) return 0;
        if (l < 0) throw new RangeError("targetStart out of bounds");
        if (S < 0 || S >= this.length) throw new RangeError("Index out of range");
        if (C < 0) throw new RangeError("sourceEnd out of bounds");
        C > this.length && (C = this.length), u.length - l < C - S && (C = u.length - l + S);
        let N = C - S;
        return this === u && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(l, S, C) : Uint8Array.prototype.set.call(u, this.subarray(S, C), l), N;
    }, o.prototype.fill = function(u, l, S, C) {
        if (typeof u == "string") {
            if (typeof l == "string" ? (C = l, l = 0, S = this.length) : typeof S == "string" && (C = S, S = this.length), C !== void 0 && typeof C != "string") throw new TypeError("encoding must be a string");
            if (typeof C == "string" && !o.isEncoding(C)) throw new TypeError("Unknown encoding: " + C);
            if (u.length === 1) {
                let F = u.charCodeAt(0);
                (C === "utf8" && F < 128 || C === "latin1") && (u = F);
            }
        } else typeof u == "number" ? u = u & 255 : typeof u == "boolean" && (u = Number(u));
        if (l < 0 || this.length < l || this.length < S) throw new RangeError("Out of range index");
        if (S <= l) return this;
        l = l >>> 0, S = S === void 0 ? this.length : S >>> 0, u || (u = 0);
        let N;
        if (typeof u == "number") for(N = l; N < S; ++N)this[N] = u;
        else {
            let F = o.isBuffer(u) ? u : o.from(u, C), k = F.length;
            if (k === 0) throw new TypeError('The value "' + u + '" is invalid for argument "value"');
            for(N = 0; N < S - l; ++N)this[N + l] = F[N % k];
        }
        return this;
    };
    let ye = {};
    function Ae(p, u, l) {
        ye[p] = class extends l {
            constructor(){
                super(), Object.defineProperty(this, "message", {
                    value: u.apply(this, arguments),
                    writable: !0,
                    configurable: !0
                }), this.name = `${this.name} [${p}]`, this.stack, delete this.name;
            }
            get code() {
                return p;
            }
            set code(C) {
                Object.defineProperty(this, "code", {
                    configurable: !0,
                    enumerable: !0,
                    value: C,
                    writable: !0
                });
            }
            toString() {
                return `${this.name} [${p}]: ${this.message}`;
            }
        };
    }
    Ae("ERR_BUFFER_OUT_OF_BOUNDS", function(p) {
        return p ? `${p} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    }, RangeError), Ae("ERR_INVALID_ARG_TYPE", function(p, u) {
        return `The "${p}" argument must be of type number. Received type ${typeof u}`;
    }, TypeError), Ae("ERR_OUT_OF_RANGE", function(p, u, l) {
        let S = `The value of "${p}" is out of range.`, C = l;
        return Number.isInteger(l) && Math.abs(l) > 2 ** 32 ? C = _e(String(l)) : typeof l == "bigint" && (C = String(l), (l > BigInt(2) ** BigInt(32) || l < -(BigInt(2) ** BigInt(32))) && (C = _e(C)), C += "n"), S += ` It must be ${u}. Received ${C}`, S;
    }, RangeError);
    function _e(p) {
        let u = "", l = p.length, S = p[0] === "-" ? 1 : 0;
        for(; l >= S + 4; l -= 3)u = `_${p.slice(l - 3, l)}${u}`;
        return `${p.slice(0, l)}${u}`;
    }
    function ve(p, u, l) {
        xe(u, "offset"), (p[u] === void 0 || p[u + l] === void 0) && st(u, p.length - (l + 1));
    }
    function Oe(p, u, l, S, C, N) {
        if (p > l || p < u) {
            let F = typeof u == "bigint" ? "n" : "", k;
            throw u === 0 || u === BigInt(0) ? k = `>= 0${F} and < 2${F} ** ${(N + 1) * 8}${F}` : k = `>= -(2${F} ** ${(N + 1) * 8 - 1}${F}) and < 2 ** ${(N + 1) * 8 - 1}${F}`, new ye.ERR_OUT_OF_RANGE("value", k, p);
        }
        ve(S, C, N);
    }
    function xe(p, u) {
        if (typeof p != "number") throw new ye.ERR_INVALID_ARG_TYPE(u, "number", p);
    }
    function st(p, u, l) {
        throw Math.floor(p) !== p ? (xe(p, l), new ye.ERR_OUT_OF_RANGE("offset", "an integer", p)) : u < 0 ? new ye.ERR_BUFFER_OUT_OF_BOUNDS : new ye.ERR_OUT_OF_RANGE("offset", `>= 0 and <= ${u}`, p);
    }
    let Re = /[^+/0-9A-Za-z-_]/g;
    function Ne(p) {
        if (p = p.split("=")[0], p = p.trim().replace(Re, ""), p.length < 2) return "";
        for(; p.length % 4 !== 0;)p = p + "=";
        return p;
    }
    function Ct(p, u) {
        u = u || 1 / 0;
        let l, S = p.length, C = null, N = [];
        for(let F = 0; F < S; ++F){
            if (l = p.charCodeAt(F), l > 55295 && l < 57344) {
                if (!C) {
                    if (l > 56319) {
                        (u -= 3) > -1 && N.push(239, 191, 189);
                        continue;
                    } else if (F + 1 === S) {
                        (u -= 3) > -1 && N.push(239, 191, 189);
                        continue;
                    }
                    C = l;
                    continue;
                }
                if (l < 56320) {
                    (u -= 3) > -1 && N.push(239, 191, 189), C = l;
                    continue;
                }
                l = (C - 55296 << 10 | l - 56320) + 65536;
            } else C && (u -= 3) > -1 && N.push(239, 191, 189);
            if (C = null, l < 128) {
                if ((u -= 1) < 0) break;
                N.push(l);
            } else if (l < 2048) {
                if ((u -= 2) < 0) break;
                N.push(l >> 6 | 192, l & 63 | 128);
            } else if (l < 65536) {
                if ((u -= 3) < 0) break;
                N.push(l >> 12 | 224, l >> 6 & 63 | 128, l & 63 | 128);
            } else if (l < 1114112) {
                if ((u -= 4) < 0) break;
                N.push(l >> 18 | 240, l >> 12 & 63 | 128, l >> 6 & 63 | 128, l & 63 | 128);
            } else throw new Error("Invalid code point");
        }
        return N;
    }
    function Bt(p) {
        let u = [];
        for(let l = 0; l < p.length; ++l)u.push(p.charCodeAt(l) & 255);
        return u;
    }
    function xn(p, u) {
        let l, S, C, N = [];
        for(let F = 0; F < p.length && !((u -= 2) < 0); ++F)l = p.charCodeAt(F), S = l >> 8, C = l % 256, N.push(C), N.push(S);
        return N;
    }
    function Ii(p) {
        return t.toByteArray(Ne(p));
    }
    function Vr(p, u, l, S) {
        let C;
        for(C = 0; C < S && !(C + l >= u.length || C >= p.length); ++C)u[C + l] = p[C];
        return C;
    }
    function Ze(p, u) {
        return p instanceof u || p != null && p.constructor != null && p.constructor.name != null && p.constructor.name === u.name;
    }
    function Tn(p) {
        return p !== p;
    }
    let Xo = function() {
        let p = "0123456789abcdef", u = new Array(256);
        for(let l = 0; l < 16; ++l){
            let S = l * 16;
            for(let C = 0; C < 16; ++C)u[S + C] = p[l] + p[C];
        }
        return u;
    }();
    function at(p) {
        return typeof BigInt > "u" ? Zo : p;
    }
    function Zo() {
        throw new Error("BigInt not supported");
    }
    return $4c2dd1b68d143d96$var$mr;
}
var $4c2dd1b68d143d96$var$On, $4c2dd1b68d143d96$var$Af, $4c2dd1b68d143d96$var$ki, $4c2dd1b68d143d96$var$If, $4c2dd1b68d143d96$var$mr, $4c2dd1b68d143d96$var$xf, $4c2dd1b68d143d96$var$Pf = $4c2dd1b68d143d96$var$ze(()=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    $4c2dd1b68d143d96$var$On = {}, $4c2dd1b68d143d96$var$Af = !1;
    $4c2dd1b68d143d96$var$ki = {}, $4c2dd1b68d143d96$var$If = !1;
    $4c2dd1b68d143d96$var$mr = {}, $4c2dd1b68d143d96$var$xf = !1;
});
var $4c2dd1b68d143d96$var$qe = {};
$4c2dd1b68d143d96$var$Kr($4c2dd1b68d143d96$var$qe, {
    Buffer: ()=>$4c2dd1b68d143d96$var$U,
    INSPECT_MAX_BYTES: ()=>$4c2dd1b68d143d96$var$nw,
    default: ()=>$4c2dd1b68d143d96$var$Xt,
    kMaxLength: ()=>$4c2dd1b68d143d96$var$iw
});
var $4c2dd1b68d143d96$var$Xt, $4c2dd1b68d143d96$var$U, $4c2dd1b68d143d96$var$nw, $4c2dd1b68d143d96$var$iw, $4c2dd1b68d143d96$var$ke = $4c2dd1b68d143d96$var$ze(()=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    $4c2dd1b68d143d96$var$Pf();
    $4c2dd1b68d143d96$var$Xt = $4c2dd1b68d143d96$var$Tf();
    $4c2dd1b68d143d96$var$Xt.Buffer;
    $4c2dd1b68d143d96$var$Xt.SlowBuffer;
    $4c2dd1b68d143d96$var$Xt.INSPECT_MAX_BYTES;
    $4c2dd1b68d143d96$var$Xt.kMaxLength;
    $4c2dd1b68d143d96$var$U = $4c2dd1b68d143d96$var$Xt.Buffer, $4c2dd1b68d143d96$var$nw = $4c2dd1b68d143d96$var$Xt.INSPECT_MAX_BYTES, $4c2dd1b68d143d96$var$iw = $4c2dd1b68d143d96$var$Xt.kMaxLength;
});
var $4c2dd1b68d143d96$var$x = $4c2dd1b68d143d96$var$ze(()=>{
    $4c2dd1b68d143d96$var$ke();
});
var $4c2dd1b68d143d96$var$Ee = $4c2dd1b68d143d96$var$D((MP, Of)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var fs = class extends Error {
        constructor(e){
            if (!Array.isArray(e)) throw new TypeError(`Expected input to be an Array, got ${typeof e}`);
            let r = "";
            for(let n = 0; n < e.length; n++)r += `    ${e[n].stack}
`;
            super(r), this.name = "AggregateError", this.errors = e;
        }
    };
    Of.exports = {
        AggregateError: fs,
        ArrayIsArray (t) {
            return Array.isArray(t);
        },
        ArrayPrototypeIncludes (t, e) {
            return t.includes(e);
        },
        ArrayPrototypeIndexOf (t, e) {
            return t.indexOf(e);
        },
        ArrayPrototypeJoin (t, e) {
            return t.join(e);
        },
        ArrayPrototypeMap (t, e) {
            return t.map(e);
        },
        ArrayPrototypePop (t, e) {
            return t.pop(e);
        },
        ArrayPrototypePush (t, e) {
            return t.push(e);
        },
        ArrayPrototypeSlice (t, e, r) {
            return t.slice(e, r);
        },
        Error: Error,
        FunctionPrototypeCall (t, e, ...r) {
            return t.call(e, ...r);
        },
        FunctionPrototypeSymbolHasInstance (t, e) {
            return Function.prototype[Symbol.hasInstance].call(t, e);
        },
        MathFloor: Math.floor,
        Number: Number,
        NumberIsInteger: Number.isInteger,
        NumberIsNaN: Number.isNaN,
        NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
        NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
        NumberParseInt: Number.parseInt,
        ObjectDefineProperties (t, e) {
            return Object.defineProperties(t, e);
        },
        ObjectDefineProperty (t, e, r) {
            return Object.defineProperty(t, e, r);
        },
        ObjectGetOwnPropertyDescriptor (t, e) {
            return Object.getOwnPropertyDescriptor(t, e);
        },
        ObjectKeys (t) {
            return Object.keys(t);
        },
        ObjectSetPrototypeOf (t, e) {
            return Object.setPrototypeOf(t, e);
        },
        Promise: Promise,
        PromisePrototypeCatch (t, e) {
            return t.catch(e);
        },
        PromisePrototypeThen (t, e, r) {
            return t.then(e, r);
        },
        PromiseReject (t) {
            return Promise.reject(t);
        },
        PromiseResolve (t) {
            return Promise.resolve(t);
        },
        ReflectApply: Reflect.apply,
        RegExpPrototypeTest (t, e) {
            return t.test(e);
        },
        SafeSet: Set,
        String: String,
        StringPrototypeSlice (t, e, r) {
            return t.slice(e, r);
        },
        StringPrototypeToLowerCase (t) {
            return t.toLowerCase();
        },
        StringPrototypeToUpperCase (t) {
            return t.toUpperCase();
        },
        StringPrototypeTrim (t) {
            return t.trim();
        },
        Symbol: Symbol,
        SymbolFor: Symbol.for,
        SymbolAsyncIterator: Symbol.asyncIterator,
        SymbolHasInstance: Symbol.hasInstance,
        SymbolIterator: Symbol.iterator,
        SymbolDispose: Symbol.dispose || Symbol("Symbol.dispose"),
        SymbolAsyncDispose: Symbol.asyncDispose || Symbol("Symbol.asyncDispose"),
        TypedArrayPrototypeSet (t, e, r) {
            return t.set(e, r);
        },
        Boolean: Boolean,
        Uint8Array: Uint8Array
    };
});
var $4c2dd1b68d143d96$var$hs = $4c2dd1b68d143d96$var$D((HP, Rf)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Rf.exports = {
        format (t, ...e) {
            return t.replace(/%([sdifj])/g, function(...[r, n]) {
                let i = e.shift();
                return n === "f" ? i.toFixed(6) : n === "j" ? JSON.stringify(i) : n === "s" && typeof i == "object" ? `${i.constructor !== Object ? i.constructor.name : ""} {}`.trim() : i.toString();
            });
        },
        inspect (t) {
            switch(typeof t){
                case "string":
                    if (t.includes("'")) {
                        if (t.includes('"')) {
                            if (!t.includes("`") && !t.includes("${")) return `\`${t}\``;
                        } else return `"${t}"`;
                    }
                    return `'${t}'`;
                case "number":
                    return isNaN(t) ? "NaN" : Object.is(t, -0) ? String(t) : t;
                case "bigint":
                    return `${String(t)}n`;
                case "boolean":
                case "undefined":
                    return String(t);
                case "object":
                    return "{}";
            }
        }
    };
});
var $4c2dd1b68d143d96$var$De = $4c2dd1b68d143d96$var$D((eO, Bf)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var { format: ow, inspect: Ci } = $4c2dd1b68d143d96$var$hs(), { AggregateError: sw } = $4c2dd1b68d143d96$var$Ee(), aw = globalThis.AggregateError || sw, uw = Symbol("kIsNodeError"), lw = [
        "string",
        "function",
        "number",
        "object",
        "Function",
        "Object",
        "boolean",
        "bigint",
        "symbol"
    ], cw = /^([A-Z][a-z0-9]*)+$/, fw = "__node_internal_", Bi = {};
    function _r(t, e) {
        if (!t) throw new Bi.ERR_INTERNAL_ASSERTION(e);
    }
    function kf(t) {
        let e = "", r = t.length, n = t[0] === "-" ? 1 : 0;
        for(; r >= n + 4; r -= 3)e = `_${t.slice(r - 3, r)}${e}`;
        return `${t.slice(0, r)}${e}`;
    }
    function hw(t, e, r) {
        if (typeof e == "function") return _r(e.length <= r.length, `Code: ${t}; The provided arguments length (${r.length}) does not match the required ones (${e.length}).`), e(...r);
        let n = (e.match(/%[dfijoOs]/g) || []).length;
        return _r(n === r.length, `Code: ${t}; The provided arguments length (${r.length}) does not match the required ones (${n}).`), r.length === 0 ? e : ow(e, ...r);
    }
    function Le(t, e, r) {
        r || (r = Error);
        class n extends r {
            constructor(...s){
                super(hw(t, e, s));
            }
            toString() {
                return `${this.name} [${t}]: ${this.message}`;
            }
        }
        Object.defineProperties(n.prototype, {
            name: {
                value: r.name,
                writable: !0,
                enumerable: !1,
                configurable: !0
            },
            toString: {
                value () {
                    return `${this.name} [${t}]: ${this.message}`;
                },
                writable: !0,
                enumerable: !1,
                configurable: !0
            }
        }), n.prototype.code = t, n.prototype[uw] = !0, Bi[t] = n;
    }
    function Cf(t) {
        let e = fw + t.name;
        return Object.defineProperty(t, "name", {
            value: e
        }), t;
    }
    function dw(t, e) {
        if (t && e && t !== e) {
            if (Array.isArray(e.errors)) return e.errors.push(t), e;
            let r = new aw([
                e,
                t
            ], e.message);
            return r.code = e.code, r;
        }
        return t || e;
    }
    var ds = class extends Error {
        constructor(e = "The operation was aborted", r){
            if (r !== void 0 && typeof r != "object") throw new Bi.ERR_INVALID_ARG_TYPE("options", "Object", r);
            super(e, r), this.code = "ABORT_ERR", this.name = "AbortError";
        }
    };
    Le("ERR_ASSERTION", "%s", Error);
    Le("ERR_INVALID_ARG_TYPE", (t, e, r)=>{
        _r(typeof t == "string", "'name' must be a string"), Array.isArray(e) || (e = [
            e
        ]);
        let n = "The ";
        t.endsWith(" argument") ? n += `${t} ` : n += `"${t}" ${t.includes(".") ? "property" : "argument"} `, n += "must be ";
        let i = [], s = [], o = [];
        for (let c of e)_r(typeof c == "string", "All expected entries have to be of type string"), lw.includes(c) ? i.push(c.toLowerCase()) : cw.test(c) ? s.push(c) : (_r(c !== "object", 'The value "object" should be written as "Object"'), o.push(c));
        if (s.length > 0) {
            let c = i.indexOf("object");
            c !== -1 && (i.splice(i, c, 1), s.push("Object"));
        }
        if (i.length > 0) {
            switch(i.length){
                case 1:
                    n += `of type ${i[0]}`;
                    break;
                case 2:
                    n += `one of type ${i[0]} or ${i[1]}`;
                    break;
                default:
                    {
                        let c = i.pop();
                        n += `one of type ${i.join(", ")}, or ${c}`;
                    }
            }
            (s.length > 0 || o.length > 0) && (n += " or ");
        }
        if (s.length > 0) {
            switch(s.length){
                case 1:
                    n += `an instance of ${s[0]}`;
                    break;
                case 2:
                    n += `an instance of ${s[0]} or ${s[1]}`;
                    break;
                default:
                    {
                        let c = s.pop();
                        n += `an instance of ${s.join(", ")}, or ${c}`;
                    }
            }
            o.length > 0 && (n += " or ");
        }
        switch(o.length){
            case 0:
                break;
            case 1:
                o[0].toLowerCase() !== o[0] && (n += "an "), n += `${o[0]}`;
                break;
            case 2:
                n += `one of ${o[0]} or ${o[1]}`;
                break;
            default:
                {
                    let c = o.pop();
                    n += `one of ${o.join(", ")}, or ${c}`;
                }
        }
        if (r == null) n += `. Received ${r}`;
        else if (typeof r == "function" && r.name) n += `. Received function ${r.name}`;
        else if (typeof r == "object") {
            var a;
            if ((a = r.constructor) !== null && a !== void 0 && a.name) n += `. Received an instance of ${r.constructor.name}`;
            else {
                let c = Ci(r, {
                    depth: -1
                });
                n += `. Received ${c}`;
            }
        } else {
            let c = Ci(r, {
                colors: !1
            });
            c.length > 25 && (c = `${c.slice(0, 25)}...`), n += `. Received type ${typeof r} (${c})`;
        }
        return n;
    }, TypeError);
    Le("ERR_INVALID_ARG_VALUE", (t, e, r = "is invalid")=>{
        let n = Ci(e);
        return n.length > 128 && (n = n.slice(0, 128) + "..."), `The ${t.includes(".") ? "property" : "argument"} '${t}' ${r}. Received ${n}`;
    }, TypeError);
    Le("ERR_INVALID_RETURN_VALUE", (t, e, r)=>{
        var n;
        let i = r != null && (n = r.constructor) !== null && n !== void 0 && n.name ? `instance of ${r.constructor.name}` : `type ${typeof r}`;
        return `Expected ${t} to be returned from the "${e}" function but got ${i}.`;
    }, TypeError);
    Le("ERR_MISSING_ARGS", (...t)=>{
        _r(t.length > 0, "At least one arg needs to be specified");
        let e, r = t.length;
        switch(t = (Array.isArray(t) ? t : [
            t
        ]).map((n)=>`"${n}"`).join(" or "), r){
            case 1:
                e += `The ${t[0]} argument`;
                break;
            case 2:
                e += `The ${t[0]} and ${t[1]} arguments`;
                break;
            default:
                {
                    let n = t.pop();
                    e += `The ${t.join(", ")}, and ${n} arguments`;
                }
                break;
        }
        return `${e} must be specified`;
    }, TypeError);
    Le("ERR_OUT_OF_RANGE", (t, e, r)=>{
        _r(e, 'Missing "range" argument');
        let n;
        if (Number.isInteger(r) && Math.abs(r) > 2 ** 32) n = kf(String(r));
        else if (typeof r == "bigint") {
            n = String(r);
            let i = BigInt(2) ** BigInt(32);
            (r > i || r < -i) && (n = kf(n)), n += "n";
        } else n = Ci(r);
        return `The value of "${t}" is out of range. It must be ${e}. Received ${n}`;
    }, RangeError);
    Le("ERR_MULTIPLE_CALLBACK", "Callback called multiple times", Error);
    Le("ERR_METHOD_NOT_IMPLEMENTED", "The %s method is not implemented", Error);
    Le("ERR_STREAM_ALREADY_FINISHED", "Cannot call %s after a stream was finished", Error);
    Le("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable", Error);
    Le("ERR_STREAM_DESTROYED", "Cannot call %s after a stream was destroyed", Error);
    Le("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
    Le("ERR_STREAM_PREMATURE_CLOSE", "Premature close", Error);
    Le("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF", Error);
    Le("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event", Error);
    Le("ERR_STREAM_WRITE_AFTER_END", "write after end", Error);
    Le("ERR_UNKNOWN_ENCODING", "Unknown encoding: %s", TypeError);
    Bf.exports = {
        AbortError: ds,
        aggregateTwoErrors: Cf(dw),
        hideStackFrames: Cf,
        codes: Bi
    };
});
var $4c2dd1b68d143d96$var$Yr = $4c2dd1b68d143d96$var$D((cO, Mi)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var { AbortController: Mf, AbortSignal: pw } = typeof self < "u" ? self : typeof window < "u" ? window : void 0;
    Mi.exports = Mf;
    Mi.exports.AbortSignal = pw;
    Mi.exports.default = Mf;
});
var $4c2dd1b68d143d96$var$Zt = {};
$4c2dd1b68d143d96$var$Kr($4c2dd1b68d143d96$var$Zt, {
    EventEmitter: ()=>$4c2dd1b68d143d96$var$gw,
    default: ()=>$4c2dd1b68d143d96$var$Rn,
    defaultMaxListeners: ()=>$4c2dd1b68d143d96$var$bw,
    init: ()=>$4c2dd1b68d143d96$var$ww,
    listenerCount: ()=>$4c2dd1b68d143d96$var$mw,
    on: ()=>$4c2dd1b68d143d96$var$_w,
    once: ()=>$4c2dd1b68d143d96$var$vw
});
function $4c2dd1b68d143d96$var$yw() {
    if ($4c2dd1b68d143d96$var$Nf) return $4c2dd1b68d143d96$var$Ni;
    $4c2dd1b68d143d96$var$Nf = !0;
    var t = typeof Reflect == "object" ? Reflect : null, e = t && typeof t.apply == "function" ? t.apply : function(g, O, _) {
        return Function.prototype.apply.call(g, O, _);
    }, r;
    t && typeof t.ownKeys == "function" ? r = t.ownKeys : Object.getOwnPropertySymbols ? r = function(g) {
        return Object.getOwnPropertyNames(g).concat(Object.getOwnPropertySymbols(g));
    } : r = function(g) {
        return Object.getOwnPropertyNames(g);
    };
    function n(T) {
        console && console.warn && console.warn(T);
    }
    var i = Number.isNaN || function(g) {
        return g !== g;
    };
    function s() {
        s.init.call(this);
    }
    $4c2dd1b68d143d96$var$Ni = s, $4c2dd1b68d143d96$var$Ni.once = m, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
    var o = 10;
    function a(T) {
        if (typeof T != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof T);
    }
    Object.defineProperty(s, "defaultMaxListeners", {
        enumerable: !0,
        get: function() {
            return o;
        },
        set: function(T) {
            if (typeof T != "number" || T < 0 || i(T)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + T + ".");
            o = T;
        }
    }), s.init = function() {
        (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, s.prototype.setMaxListeners = function(g) {
        if (typeof g != "number" || g < 0 || i(g)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + g + ".");
        return this._maxListeners = g, this;
    };
    function c(T) {
        return T._maxListeners === void 0 ? s.defaultMaxListeners : T._maxListeners;
    }
    s.prototype.getMaxListeners = function() {
        return c(this);
    }, s.prototype.emit = function(g) {
        for(var O = [], _ = 1; _ < arguments.length; _++)O.push(arguments[_]);
        var q = g === "error", $ = this._events;
        if ($ !== void 0) q = q && $.error === void 0;
        else if (!q) return !1;
        if (q) {
            var j;
            if (O.length > 0 && (j = O[0]), j instanceof Error) throw j;
            var J = new Error("Unhandled error." + (j ? " (" + j.message + ")" : ""));
            throw J.context = j, J;
        }
        var W = $[g];
        if (W === void 0) return !1;
        if (typeof W == "function") e(W, this, O);
        else for(var H = W.length, G = P(W, H), _ = 0; _ < H; ++_)e(G[_], this, O);
        return !0;
    };
    function f(T, g, O, _) {
        var q, $, j;
        if (a(O), $ = T._events, $ === void 0 ? ($ = T._events = Object.create(null), T._eventsCount = 0) : ($.newListener !== void 0 && (T.emit("newListener", g, O.listener ? O.listener : O), $ = T._events), j = $[g]), j === void 0) j = $[g] = O, ++T._eventsCount;
        else if (typeof j == "function" ? j = $[g] = _ ? [
            O,
            j
        ] : [
            j,
            O
        ] : _ ? j.unshift(O) : j.push(O), q = c(T), q > 0 && j.length > q && !j.warned) {
            j.warned = !0;
            var J = new Error("Possible EventEmitter memory leak detected. " + j.length + " " + String(g) + " listeners added. Use emitter.setMaxListeners() to increase limit");
            J.name = "MaxListenersExceededWarning", J.emitter = T, J.type = g, J.count = j.length, n(J);
        }
        return T;
    }
    s.prototype.addListener = function(g, O) {
        return f(this, g, O, !1);
    }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function(g, O) {
        return f(this, g, O, !0);
    };
    function h() {
        if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
    }
    function d(T, g, O) {
        var _ = {
            fired: !1,
            wrapFn: void 0,
            target: T,
            type: g,
            listener: O
        }, q = h.bind(_);
        return q.listener = O, _.wrapFn = q, q;
    }
    s.prototype.once = function(g, O) {
        return a(O), this.on(g, d(this, g, O)), this;
    }, s.prototype.prependOnceListener = function(g, O) {
        return a(O), this.prependListener(g, d(this, g, O)), this;
    }, s.prototype.removeListener = function(g, O) {
        var _, q, $, j, J;
        if (a(O), q = this._events, q === void 0) return this;
        if (_ = q[g], _ === void 0) return this;
        if (_ === O || _.listener === O) --this._eventsCount === 0 ? this._events = Object.create(null) : (delete q[g], q.removeListener && this.emit("removeListener", g, _.listener || O));
        else if (typeof _ != "function") {
            for($ = -1, j = _.length - 1; j >= 0; j--)if (_[j] === O || _[j].listener === O) {
                J = _[j].listener, $ = j;
                break;
            }
            if ($ < 0) return this;
            $ === 0 ? _.shift() : E(_, $), _.length === 1 && (q[g] = _[0]), q.removeListener !== void 0 && this.emit("removeListener", g, J || O);
        }
        return this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function(g) {
        var O, _, q;
        if (_ = this._events, _ === void 0) return this;
        if (_.removeListener === void 0) return arguments.length === 0 ? (this._events = Object.create(null), this._eventsCount = 0) : _[g] !== void 0 && (--this._eventsCount === 0 ? this._events = Object.create(null) : delete _[g]), this;
        if (arguments.length === 0) {
            var $ = Object.keys(_), j;
            for(q = 0; q < $.length; ++q)j = $[q], j !== "removeListener" && this.removeAllListeners(j);
            return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
        }
        if (O = _[g], typeof O == "function") this.removeListener(g, O);
        else if (O !== void 0) for(q = O.length - 1; q >= 0; q--)this.removeListener(g, O[q]);
        return this;
    };
    function w(T, g, O) {
        var _ = T._events;
        if (_ === void 0) return [];
        var q = _[g];
        return q === void 0 ? [] : typeof q == "function" ? O ? [
            q.listener || q
        ] : [
            q
        ] : O ? b(q) : P(q, q.length);
    }
    s.prototype.listeners = function(g) {
        return w(this, g, !0);
    }, s.prototype.rawListeners = function(g) {
        return w(this, g, !1);
    }, s.listenerCount = function(T, g) {
        return typeof T.listenerCount == "function" ? T.listenerCount(g) : y.call(T, g);
    }, s.prototype.listenerCount = y;
    function y(T) {
        var g = this._events;
        if (g !== void 0) {
            var O = g[T];
            if (typeof O == "function") return 1;
            if (O !== void 0) return O.length;
        }
        return 0;
    }
    s.prototype.eventNames = function() {
        return this._eventsCount > 0 ? r(this._events) : [];
    };
    function P(T, g) {
        for(var O = new Array(g), _ = 0; _ < g; ++_)O[_] = T[_];
        return O;
    }
    function E(T, g) {
        for(; g + 1 < T.length; g++)T[g] = T[g + 1];
        T.pop();
    }
    function b(T) {
        for(var g = new Array(T.length), O = 0; O < g.length; ++O)g[O] = T[O].listener || T[O];
        return g;
    }
    function m(T, g) {
        return new Promise(function(O, _) {
            function q(j) {
                T.removeListener(g, $), _(j);
            }
            function $() {
                typeof T.removeListener == "function" && T.removeListener("error", q), O([].slice.call(arguments));
            }
            R(T, g, $, {
                once: !0
            }), g !== "error" && v(T, q, {
                once: !0
            });
        });
    }
    function v(T, g, O) {
        typeof T.on == "function" && R(T, "error", g, O);
    }
    function R(T, g, O, _) {
        if (typeof T.on == "function") _.once ? T.once(g, O) : T.on(g, O);
        else if (typeof T.addEventListener == "function") T.addEventListener(g, function q($) {
            _.once && T.removeEventListener(g, q), O($);
        });
        else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof T);
    }
    return $4c2dd1b68d143d96$var$Ni;
}
var $4c2dd1b68d143d96$var$Ni, $4c2dd1b68d143d96$var$Nf, $4c2dd1b68d143d96$var$Rn, $4c2dd1b68d143d96$var$gw, $4c2dd1b68d143d96$var$bw, $4c2dd1b68d143d96$var$ww, $4c2dd1b68d143d96$var$mw, $4c2dd1b68d143d96$var$_w, $4c2dd1b68d143d96$var$vw, $4c2dd1b68d143d96$var$er = $4c2dd1b68d143d96$var$ze(()=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    $4c2dd1b68d143d96$var$Ni = {}, $4c2dd1b68d143d96$var$Nf = !1;
    $4c2dd1b68d143d96$var$Rn = $4c2dd1b68d143d96$var$yw();
    $4c2dd1b68d143d96$var$Rn.once;
    $4c2dd1b68d143d96$var$Rn.once = function(t, e) {
        return new Promise((r, n)=>{
            function i(...o) {
                s !== void 0 && t.removeListener("error", s), r(o);
            }
            let s;
            e !== "error" && (s = (o)=>{
                t.removeListener(name, i), n(o);
            }, t.once("error", s)), t.once(e, i);
        });
    };
    $4c2dd1b68d143d96$var$Rn.on = function(t, e) {
        let r = [], n = [], i = null, s = !1, o = {
            async next () {
                let f = r.shift();
                if (f) return createIterResult(f, !1);
                if (i) {
                    let h = Promise.reject(i);
                    return i = null, h;
                }
                return s ? createIterResult(void 0, !0) : new Promise((h, d)=>n.push({
                        resolve: h,
                        reject: d
                    }));
            },
            async return () {
                t.removeListener(e, a), t.removeListener("error", c), s = !0;
                for (let f of n)f.resolve(createIterResult(void 0, !0));
                return createIterResult(void 0, !0);
            },
            throw (f) {
                i = f, t.removeListener(e, a), t.removeListener("error", c);
            },
            [Symbol.asyncIterator] () {
                return this;
            }
        };
        return t.on(e, a), t.on("error", c), o;
        function a(...f) {
            let h = n.shift();
            h ? h.resolve(createIterResult(f, !1)) : r.push(f);
        }
        function c(f) {
            s = !0;
            let h = n.shift();
            h ? h.reject(f) : i = f, o.return();
        }
    };
    ({ EventEmitter: $4c2dd1b68d143d96$var$gw, defaultMaxListeners: $4c2dd1b68d143d96$var$bw, init: $4c2dd1b68d143d96$var$ww, listenerCount: $4c2dd1b68d143d96$var$mw, on: $4c2dd1b68d143d96$var$_w, once: $4c2dd1b68d143d96$var$vw } = $4c2dd1b68d143d96$var$Rn);
});
var $4c2dd1b68d143d96$var$$e = $4c2dd1b68d143d96$var$D((OO, ys)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var Sw = ($4c2dd1b68d143d96$var$ke(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$qe)), { format: Ew, inspect: Aw } = $4c2dd1b68d143d96$var$hs(), { codes: { ERR_INVALID_ARG_TYPE: ps } } = $4c2dd1b68d143d96$var$De(), { kResistStopPropagation: Iw, AggregateError: xw, SymbolDispose: Tw } = $4c2dd1b68d143d96$var$Ee(), Pw = globalThis.AbortSignal || $4c2dd1b68d143d96$var$Yr().AbortSignal, Ow = globalThis.AbortController || $4c2dd1b68d143d96$var$Yr().AbortController, Rw = Object.getPrototypeOf(async function() {}).constructor, qf = globalThis.Blob || Sw.Blob, kw = typeof qf < "u" ? function(e) {
        return e instanceof qf;
    } : function(e) {
        return !1;
    }, Lf = (t, e)=>{
        if (t !== void 0 && (t === null || typeof t != "object" || !("aborted" in t))) throw new ps(e, "AbortSignal", t);
    }, Cw = (t, e)=>{
        if (typeof t != "function") throw new ps(e, "Function", t);
    };
    ys.exports = {
        AggregateError: xw,
        kEmptyObject: Object.freeze({}),
        once (t) {
            let e = !1;
            return function(...r) {
                e || (e = !0, t.apply(this, r));
            };
        },
        createDeferredPromise: function() {
            let t, e;
            return {
                promise: new Promise((n, i)=>{
                    t = n, e = i;
                }),
                resolve: t,
                reject: e
            };
        },
        promisify (t) {
            return new Promise((e, r)=>{
                t((n, ...i)=>n ? r(n) : e(...i));
            });
        },
        debuglog () {
            return function() {};
        },
        format: Ew,
        inspect: Aw,
        types: {
            isAsyncFunction (t) {
                return t instanceof Rw;
            },
            isArrayBufferView (t) {
                return ArrayBuffer.isView(t);
            }
        },
        isBlob: kw,
        deprecate (t, e) {
            return t;
        },
        addAbortListener: ($4c2dd1b68d143d96$var$er(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$Zt)).addAbortListener || function(e, r) {
            if (e === void 0) throw new ps("signal", "AbortSignal", e);
            Lf(e, "signal"), Cw(r, "listener");
            let n;
            return e.aborted ? queueMicrotask(()=>r()) : (e.addEventListener("abort", r, {
                __proto__: null,
                once: !0,
                [Iw]: !0
            }), n = ()=>{
                e.removeEventListener("abort", r);
            }), {
                __proto__: null,
                [Tw] () {
                    var i;
                    (i = n) === null || i === void 0 || i();
                }
            };
        },
        AbortSignalAny: Pw.any || function(e) {
            if (e.length === 1) return e[0];
            let r = new Ow, n = ()=>r.abort();
            return e.forEach((i)=>{
                Lf(i, "signals"), i.addEventListener("abort", n, {
                    once: !0
                });
            }), r.signal.addEventListener("abort", ()=>{
                e.forEach((i)=>i.removeEventListener("abort", n));
            }, {
                once: !0
            }), r.signal;
        }
    };
    ys.exports.promisify.custom = Symbol.for("nodejs.util.promisify.custom");
});
var $4c2dd1b68d143d96$var$Xr = $4c2dd1b68d143d96$var$D((DO, zf)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var { ArrayIsArray: bs, ArrayPrototypeIncludes: Ff, ArrayPrototypeJoin: Wf, ArrayPrototypeMap: Bw, NumberIsInteger: ws, NumberIsNaN: Mw, NumberMAX_SAFE_INTEGER: Nw, NumberMIN_SAFE_INTEGER: qw, NumberParseInt: Lw, ObjectPrototypeHasOwnProperty: Uw, RegExpPrototypeExec: $f, String: Dw, StringPrototypeToUpperCase: jw, StringPrototypeTrim: Fw } = $4c2dd1b68d143d96$var$Ee(), { hideStackFrames: et, codes: { ERR_SOCKET_BAD_PORT: Ww, ERR_INVALID_ARG_TYPE: je, ERR_INVALID_ARG_VALUE: Jr, ERR_OUT_OF_RANGE: vr, ERR_UNKNOWN_SIGNAL: Uf } } = $4c2dd1b68d143d96$var$De(), { normalizeEncoding: $w } = $4c2dd1b68d143d96$var$$e(), { isAsyncFunction: Hw, isArrayBufferView: Vw } = $4c2dd1b68d143d96$var$$e().types, Df = {};
    function Gw(t) {
        return t === (t | 0);
    }
    function zw(t) {
        return t === t >>> 0;
    }
    var Kw = /^[0-7]+$/, Qw = "must be a 32-bit unsigned integer or an octal string";
    function Yw(t, e, r) {
        if (typeof t > "u" && (t = r), typeof t == "string") {
            if ($f(Kw, t) === null) throw new Jr(e, t, Qw);
            t = Lw(t, 8);
        }
        return Hf(t, e), t;
    }
    var Jw = et((t, e, r = qw, n = Nw)=>{
        if (typeof t != "number") throw new je(e, "number", t);
        if (!ws(t)) throw new vr(e, "an integer", t);
        if (t < r || t > n) throw new vr(e, `>= ${r} && <= ${n}`, t);
    }), Xw = et((t, e, r = -2147483648, n = 2147483647)=>{
        if (typeof t != "number") throw new je(e, "number", t);
        if (!ws(t)) throw new vr(e, "an integer", t);
        if (t < r || t > n) throw new vr(e, `>= ${r} && <= ${n}`, t);
    }), Hf = et((t, e, r = !1)=>{
        if (typeof t != "number") throw new je(e, "number", t);
        if (!ws(t)) throw new vr(e, "an integer", t);
        let n = r ? 1 : 0, i = 4294967295;
        if (t < n || t > i) throw new vr(e, `>= ${n} && <= ${i}`, t);
    });
    function ms(t, e) {
        if (typeof t != "string") throw new je(e, "string", t);
    }
    function Zw(t, e, r, n) {
        if (typeof t != "number") throw new je(e, "number", t);
        if (r != null && t < r || n != null && t > n || (r != null || n != null) && Mw(t)) throw new vr(e, `${r != null ? `>= ${r}` : ""}${r != null && n != null ? " && " : ""}${n != null ? `<= ${n}` : ""}`, t);
    }
    var em = et((t, e, r)=>{
        if (!Ff(r, t)) {
            let i = "must be one of: " + Wf(Bw(r, (s)=>typeof s == "string" ? `'${s}'` : Dw(s)), ", ");
            throw new Jr(e, t, i);
        }
    });
    function Vf(t, e) {
        if (typeof t != "boolean") throw new je(e, "boolean", t);
    }
    function gs(t, e, r) {
        return t == null || !Uw(t, e) ? r : t[e];
    }
    var tm = et((t, e, r = null)=>{
        let n = gs(r, "allowArray", !1), i = gs(r, "allowFunction", !1);
        if (!gs(r, "nullable", !1) && t === null || !n && bs(t) || typeof t != "object" && (!i || typeof t != "function")) throw new je(e, "Object", t);
    }), rm = et((t, e)=>{
        if (t != null && typeof t != "object" && typeof t != "function") throw new je(e, "a dictionary", t);
    }), qi = et((t, e, r = 0)=>{
        if (!bs(t)) throw new je(e, "Array", t);
        if (t.length < r) {
            let n = `must be longer than ${r}`;
            throw new Jr(e, t, n);
        }
    });
    function nm(t, e) {
        qi(t, e);
        for(let r = 0; r < t.length; r++)ms(t[r], `${e}[${r}]`);
    }
    function im(t, e) {
        qi(t, e);
        for(let r = 0; r < t.length; r++)Vf(t[r], `${e}[${r}]`);
    }
    function om(t, e) {
        qi(t, e);
        for(let r = 0; r < t.length; r++){
            let n = t[r], i = `${e}[${r}]`;
            if (n == null) throw new je(i, "AbortSignal", n);
            Gf(n, i);
        }
    }
    function sm(t, e = "signal") {
        if (ms(t, e), Df[t] === void 0) throw Df[jw(t)] !== void 0 ? new Uf(t + " (signals must use all capital letters)") : new Uf(t);
    }
    var am = et((t, e = "buffer")=>{
        if (!Vw(t)) throw new je(e, [
            "Buffer",
            "TypedArray",
            "DataView"
        ], t);
    });
    function um(t, e) {
        let r = $w(e), n = t.length;
        if (r === "hex" && n % 2 !== 0) throw new Jr("encoding", e, `is invalid for data of length ${n}`);
    }
    function lm(t, e = "Port", r = !0) {
        if (typeof t != "number" && typeof t != "string" || typeof t == "string" && Fw(t).length === 0 || +t !== +t >>> 0 || t > 65535 || t === 0 && !r) throw new Ww(e, t, r);
        return t | 0;
    }
    var Gf = et((t, e)=>{
        if (t !== void 0 && (t === null || typeof t != "object" || !("aborted" in t))) throw new je(e, "AbortSignal", t);
    }), cm = et((t, e)=>{
        if (typeof t != "function") throw new je(e, "Function", t);
    }), fm = et((t, e)=>{
        if (typeof t != "function" || Hw(t)) throw new je(e, "Function", t);
    }), hm = et((t, e)=>{
        if (t !== void 0) throw new je(e, "undefined", t);
    });
    function dm(t, e, r) {
        if (!Ff(r, t)) throw new je(e, `('${Wf(r, "|")}')`, t);
    }
    var pm = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
    function jf(t, e) {
        if (typeof t > "u" || !$f(pm, t)) throw new Jr(e, t, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
    }
    function ym(t) {
        if (typeof t == "string") return jf(t, "hints"), t;
        if (bs(t)) {
            let e = t.length, r = "";
            if (e === 0) return r;
            for(let n = 0; n < e; n++){
                let i = t[n];
                jf(i, "hints"), r += i, n !== e - 1 && (r += ", ");
            }
            return r;
        }
        throw new Jr("hints", t, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
    }
    zf.exports = {
        isInt32: Gw,
        isUint32: zw,
        parseFileMode: Yw,
        validateArray: qi,
        validateStringArray: nm,
        validateBooleanArray: im,
        validateAbortSignalArray: om,
        validateBoolean: Vf,
        validateBuffer: am,
        validateDictionary: rm,
        validateEncoding: um,
        validateFunction: cm,
        validateInt32: Xw,
        validateInteger: Jw,
        validateNumber: Zw,
        validateObject: tm,
        validateOneOf: em,
        validatePlainFunction: fm,
        validatePort: lm,
        validateSignalName: sm,
        validateString: ms,
        validateUint32: Hf,
        validateUndefined: hm,
        validateUnion: dm,
        validateAbortSignal: Gf,
        validateLinkHeaderValue: ym
    };
});
var $4c2dd1b68d143d96$var$tr = $4c2dd1b68d143d96$var$D((QO, Jf)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var Te = Jf.exports = {}, gt, bt;
    function _s() {
        throw new Error("setTimeout has not been defined");
    }
    function vs() {
        throw new Error("clearTimeout has not been defined");
    }
    (function() {
        try {
            typeof setTimeout == "function" ? gt = setTimeout : gt = _s;
        } catch  {
            gt = _s;
        }
        try {
            typeof clearTimeout == "function" ? bt = clearTimeout : bt = vs;
        } catch  {
            bt = vs;
        }
    })();
    function Kf(t) {
        if (gt === setTimeout) return setTimeout(t, 0);
        if ((gt === _s || !gt) && setTimeout) return gt = setTimeout, setTimeout(t, 0);
        try {
            return gt(t, 0);
        } catch  {
            try {
                return gt.call(null, t, 0);
            } catch  {
                return gt.call(this, t, 0);
            }
        }
    }
    function gm(t) {
        if (bt === clearTimeout) return clearTimeout(t);
        if ((bt === vs || !bt) && clearTimeout) return bt = clearTimeout, clearTimeout(t);
        try {
            return bt(t);
        } catch  {
            try {
                return bt.call(null, t);
            } catch  {
                return bt.call(this, t);
            }
        }
    }
    var qt = [], Zr = !1, Sr, Li = -1;
    function bm() {
        !Zr || !Sr || (Zr = !1, Sr.length ? qt = Sr.concat(qt) : Li = -1, qt.length && Qf());
    }
    function Qf() {
        if (!Zr) {
            var t = Kf(bm);
            Zr = !0;
            for(var e = qt.length; e;){
                for(Sr = qt, qt = []; ++Li < e;)Sr && Sr[Li].run();
                Li = -1, e = qt.length;
            }
            Sr = null, Zr = !1, gm(t);
        }
    }
    Te.nextTick = function(t) {
        var e = new Array(arguments.length - 1);
        if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
        qt.push(new Yf(t, e)), qt.length === 1 && !Zr && Kf(Qf);
    };
    function Yf(t, e) {
        this.fun = t, this.array = e;
    }
    Yf.prototype.run = function() {
        this.fun.apply(null, this.array);
    };
    Te.title = "browser";
    Te.browser = !0;
    Te.env = {};
    Te.argv = [];
    Te.version = "";
    Te.versions = {};
    function Lt() {}
    Te.on = Lt;
    Te.addListener = Lt;
    Te.once = Lt;
    Te.off = Lt;
    Te.removeListener = Lt;
    Te.removeAllListeners = Lt;
    Te.emit = Lt;
    Te.prependListener = Lt;
    Te.prependOnceListener = Lt;
    Te.listeners = function(t) {
        return [];
    };
    Te.binding = function(t) {
        throw new Error("process.binding is not supported");
    };
    Te.cwd = function() {
        return "/";
    };
    Te.chdir = function(t) {
        throw new Error("process.chdir is not supported");
    };
    Te.umask = function() {
        return 0;
    };
});
var $4c2dd1b68d143d96$var$mt = $4c2dd1b68d143d96$var$D((oR, hh)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var { SymbolAsyncIterator: Xf, SymbolIterator: Zf, SymbolFor: Er } = $4c2dd1b68d143d96$var$Ee(), eh = Er("nodejs.stream.destroyed"), th = Er("nodejs.stream.errored"), Ss = Er("nodejs.stream.readable"), Es = Er("nodejs.stream.writable"), rh = Er("nodejs.stream.disturbed"), wm = Er("nodejs.webstream.isClosedPromise"), mm = Er("nodejs.webstream.controllerErrorFunction");
    function Ui(t, e = !1) {
        var r;
        return !!(t && typeof t.pipe == "function" && typeof t.on == "function" && (!e || typeof t.pause == "function" && typeof t.resume == "function") && (!t._writableState || ((r = t._readableState) === null || r === void 0 ? void 0 : r.readable) !== !1) && (!t._writableState || t._readableState));
    }
    function Di(t) {
        var e;
        return !!(t && typeof t.write == "function" && typeof t.on == "function" && (!t._readableState || ((e = t._writableState) === null || e === void 0 ? void 0 : e.writable) !== !1));
    }
    function _m(t) {
        return !!(t && typeof t.pipe == "function" && t._readableState && typeof t.on == "function" && typeof t.write == "function");
    }
    function wt(t) {
        return t && (t._readableState || t._writableState || typeof t.write == "function" && typeof t.on == "function" || typeof t.pipe == "function" && typeof t.on == "function");
    }
    function nh(t) {
        return !!(t && !wt(t) && typeof t.pipeThrough == "function" && typeof t.getReader == "function" && typeof t.cancel == "function");
    }
    function ih(t) {
        return !!(t && !wt(t) && typeof t.getWriter == "function" && typeof t.abort == "function");
    }
    function oh(t) {
        return !!(t && !wt(t) && typeof t.readable == "object" && typeof t.writable == "object");
    }
    function vm(t) {
        return nh(t) || ih(t) || oh(t);
    }
    function Sm(t, e) {
        return t == null ? !1 : e === !0 ? typeof t[Xf] == "function" : e === !1 ? typeof t[Zf] == "function" : typeof t[Xf] == "function" || typeof t[Zf] == "function";
    }
    function ji(t) {
        if (!wt(t)) return null;
        let e = t._writableState, r = t._readableState, n = e || r;
        return !!(t.destroyed || t[eh] || n != null && n.destroyed);
    }
    function sh(t) {
        if (!Di(t)) return null;
        if (t.writableEnded === !0) return !0;
        let e = t._writableState;
        return e != null && e.errored ? !1 : typeof e?.ended != "boolean" ? null : e.ended;
    }
    function Em(t, e) {
        if (!Di(t)) return null;
        if (t.writableFinished === !0) return !0;
        let r = t._writableState;
        return r != null && r.errored ? !1 : typeof r?.finished != "boolean" ? null : !!(r.finished || e === !1 && r.ended === !0 && r.length === 0);
    }
    function Am(t) {
        if (!Ui(t)) return null;
        if (t.readableEnded === !0) return !0;
        let e = t._readableState;
        return !e || e.errored ? !1 : typeof e?.ended != "boolean" ? null : e.ended;
    }
    function ah(t, e) {
        if (!Ui(t)) return null;
        let r = t._readableState;
        return r != null && r.errored ? !1 : typeof r?.endEmitted != "boolean" ? null : !!(r.endEmitted || e === !1 && r.ended === !0 && r.length === 0);
    }
    function uh(t) {
        return t && t[Ss] != null ? t[Ss] : typeof t?.readable != "boolean" ? null : ji(t) ? !1 : Ui(t) && t.readable && !ah(t);
    }
    function lh(t) {
        return t && t[Es] != null ? t[Es] : typeof t?.writable != "boolean" ? null : ji(t) ? !1 : Di(t) && t.writable && !sh(t);
    }
    function Im(t, e) {
        return wt(t) ? ji(t) ? !0 : !(e?.readable !== !1 && uh(t) || e?.writable !== !1 && lh(t)) : null;
    }
    function xm(t) {
        var e, r;
        return wt(t) ? t.writableErrored ? t.writableErrored : (e = (r = t._writableState) === null || r === void 0 ? void 0 : r.errored) !== null && e !== void 0 ? e : null : null;
    }
    function Tm(t) {
        var e, r;
        return wt(t) ? t.readableErrored ? t.readableErrored : (e = (r = t._readableState) === null || r === void 0 ? void 0 : r.errored) !== null && e !== void 0 ? e : null : null;
    }
    function Pm(t) {
        if (!wt(t)) return null;
        if (typeof t.closed == "boolean") return t.closed;
        let e = t._writableState, r = t._readableState;
        return typeof e?.closed == "boolean" || typeof r?.closed == "boolean" ? e?.closed || r?.closed : typeof t._closed == "boolean" && ch(t) ? t._closed : null;
    }
    function ch(t) {
        return typeof t._closed == "boolean" && typeof t._defaultKeepAlive == "boolean" && typeof t._removedConnection == "boolean" && typeof t._removedContLen == "boolean";
    }
    function fh(t) {
        return typeof t._sent100 == "boolean" && ch(t);
    }
    function Om(t) {
        var e;
        return typeof t._consuming == "boolean" && typeof t._dumped == "boolean" && ((e = t.req) === null || e === void 0 ? void 0 : e.upgradeOrConnect) === void 0;
    }
    function Rm(t) {
        if (!wt(t)) return null;
        let e = t._writableState, r = t._readableState, n = e || r;
        return !n && fh(t) || !!(n && n.autoDestroy && n.emitClose && n.closed === !1);
    }
    function km(t) {
        var e;
        return !!(t && ((e = t[rh]) !== null && e !== void 0 ? e : t.readableDidRead || t.readableAborted));
    }
    function Cm(t) {
        var e, r, n, i, s, o, a, c, f, h;
        return !!(t && ((e = (r = (n = (i = (s = (o = t[th]) !== null && o !== void 0 ? o : t.readableErrored) !== null && s !== void 0 ? s : t.writableErrored) !== null && i !== void 0 ? i : (a = t._readableState) === null || a === void 0 ? void 0 : a.errorEmitted) !== null && n !== void 0 ? n : (c = t._writableState) === null || c === void 0 ? void 0 : c.errorEmitted) !== null && r !== void 0 ? r : (f = t._readableState) === null || f === void 0 ? void 0 : f.errored) !== null && e !== void 0 ? e : !((h = t._writableState) === null || h === void 0) && h.errored));
    }
    hh.exports = {
        isDestroyed: ji,
        kIsDestroyed: eh,
        isDisturbed: km,
        kIsDisturbed: rh,
        isErrored: Cm,
        kIsErrored: th,
        isReadable: uh,
        kIsReadable: Ss,
        kIsClosedPromise: wm,
        kControllerErrorFunction: mm,
        kIsWritable: Es,
        isClosed: Pm,
        isDuplexNodeStream: _m,
        isFinished: Im,
        isIterable: Sm,
        isReadableNodeStream: Ui,
        isReadableStream: nh,
        isReadableEnded: Am,
        isReadableFinished: ah,
        isReadableErrored: Tm,
        isNodeStream: wt,
        isWebStream: vm,
        isWritable: lh,
        isWritableNodeStream: Di,
        isWritableStream: ih,
        isWritableEnded: sh,
        isWritableFinished: Em,
        isWritableErrored: xm,
        isServerRequest: Om,
        isServerResponse: fh,
        willEmitClose: Rm,
        isTransformStream: oh
    };
});
var $4c2dd1b68d143d96$var$Ut = $4c2dd1b68d143d96$var$D((yR, Ps)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var rr = $4c2dd1b68d143d96$var$tr(), { AbortError: vh, codes: Bm } = $4c2dd1b68d143d96$var$De(), { ERR_INVALID_ARG_TYPE: Mm, ERR_STREAM_PREMATURE_CLOSE: dh } = Bm, { kEmptyObject: Is, once: xs } = $4c2dd1b68d143d96$var$$e(), { validateAbortSignal: Nm, validateFunction: qm, validateObject: Lm, validateBoolean: Um } = $4c2dd1b68d143d96$var$Xr(), { Promise: Dm, PromisePrototypeThen: jm, SymbolDispose: Sh } = $4c2dd1b68d143d96$var$Ee(), { isClosed: Fm, isReadable: ph, isReadableNodeStream: As, isReadableStream: Wm, isReadableFinished: yh, isReadableErrored: gh, isWritable: bh, isWritableNodeStream: wh, isWritableStream: $m, isWritableFinished: mh, isWritableErrored: _h, isNodeStream: Hm, willEmitClose: Vm, kIsClosedPromise: Gm } = $4c2dd1b68d143d96$var$mt(), en;
    function zm(t) {
        return t.setHeader && typeof t.abort == "function";
    }
    var Ts = ()=>{};
    function Eh(t, e, r) {
        var n, i;
        if (arguments.length === 2 ? (r = e, e = Is) : e == null ? e = Is : Lm(e, "options"), qm(r, "callback"), Nm(e.signal, "options.signal"), r = xs(r), Wm(t) || $m(t)) return Km(t, e, r);
        if (!Hm(t)) throw new Mm("stream", [
            "ReadableStream",
            "WritableStream",
            "Stream"
        ], t);
        let s = (n = e.readable) !== null && n !== void 0 ? n : As(t), o = (i = e.writable) !== null && i !== void 0 ? i : wh(t), a = t._writableState, c = t._readableState, f = ()=>{
            t.writable || w();
        }, h = Vm(t) && As(t) === s && wh(t) === o, d = mh(t, !1), w = ()=>{
            d = !0, t.destroyed && (h = !1), !(h && (!t.readable || s)) && (!s || y) && r.call(t);
        }, y = yh(t, !1), P = ()=>{
            y = !0, t.destroyed && (h = !1), !(h && (!t.writable || o)) && (!o || d) && r.call(t);
        }, E = (g)=>{
            r.call(t, g);
        }, b = Fm(t), m = ()=>{
            b = !0;
            let g = _h(t) || gh(t);
            if (g && typeof g != "boolean") return r.call(t, g);
            if (s && !y && As(t, !0) && !yh(t, !1)) return r.call(t, new dh);
            if (o && !d && !mh(t, !1)) return r.call(t, new dh);
            r.call(t);
        }, v = ()=>{
            b = !0;
            let g = _h(t) || gh(t);
            if (g && typeof g != "boolean") return r.call(t, g);
            r.call(t);
        }, R = ()=>{
            t.req.on("finish", w);
        };
        zm(t) ? (t.on("complete", w), h || t.on("abort", m), t.req ? R() : t.on("request", R)) : o && !a && (t.on("end", f), t.on("close", f)), !h && typeof t.aborted == "boolean" && t.on("aborted", m), t.on("end", P), t.on("finish", w), e.error !== !1 && t.on("error", E), t.on("close", m), b ? rr.nextTick(m) : a != null && a.errorEmitted || c != null && c.errorEmitted ? h || rr.nextTick(v) : (!s && (!h || ph(t)) && (d || bh(t) === !1) || !o && (!h || bh(t)) && (y || ph(t) === !1) || c && t.req && t.aborted) && rr.nextTick(v);
        let T = ()=>{
            r = Ts, t.removeListener("aborted", m), t.removeListener("complete", w), t.removeListener("abort", m), t.removeListener("request", R), t.req && t.req.removeListener("finish", w), t.removeListener("end", f), t.removeListener("close", f), t.removeListener("finish", w), t.removeListener("end", P), t.removeListener("error", E), t.removeListener("close", m);
        };
        if (e.signal && !b) {
            let g = ()=>{
                let O = r;
                T(), O.call(t, new vh(void 0, {
                    cause: e.signal.reason
                }));
            };
            if (e.signal.aborted) rr.nextTick(g);
            else {
                en = en || $4c2dd1b68d143d96$var$$e().addAbortListener;
                let O = en(e.signal, g), _ = r;
                r = xs((...q)=>{
                    O[Sh](), _.apply(t, q);
                });
            }
        }
        return T;
    }
    function Km(t, e, r) {
        let n = !1, i = Ts;
        if (e.signal) {
            if (i = ()=>{
                n = !0, r.call(t, new vh(void 0, {
                    cause: e.signal.reason
                }));
            }, e.signal.aborted) rr.nextTick(i);
            else {
                en = en || $4c2dd1b68d143d96$var$$e().addAbortListener;
                let o = en(e.signal, i), a = r;
                r = xs((...c)=>{
                    o[Sh](), a.apply(t, c);
                });
            }
        }
        let s = (...o)=>{
            n || rr.nextTick(()=>r.apply(t, o));
        };
        return jm(t[Gm].promise, s, s), Ts;
    }
    function Qm(t, e) {
        var r;
        let n = !1;
        return e === null && (e = Is), (r = e) !== null && r !== void 0 && r.cleanup && (Um(e.cleanup, "cleanup"), n = e.cleanup), new Dm((i, s)=>{
            let o = Eh(t, e, (a)=>{
                n && o(), a ? s(a) : i();
            });
        });
    }
    Ps.exports = Eh;
    Ps.exports.finished = Qm;
});
var $4c2dd1b68d143d96$var$Ar = $4c2dd1b68d143d96$var$D((IR, kh)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var _t = $4c2dd1b68d143d96$var$tr(), { aggregateTwoErrors: Ym, codes: { ERR_MULTIPLE_CALLBACK: Jm }, AbortError: Xm } = $4c2dd1b68d143d96$var$De(), { Symbol: xh } = $4c2dd1b68d143d96$var$Ee(), { kIsDestroyed: Zm, isDestroyed: e_, isFinished: t_, isServerRequest: r_ } = $4c2dd1b68d143d96$var$mt(), Th = xh("kDestroy"), Os = xh("kConstruct");
    function Ph(t, e, r) {
        t && (t.stack, e && !e.errored && (e.errored = t), r && !r.errored && (r.errored = t));
    }
    function n_(t, e) {
        let r = this._readableState, n = this._writableState, i = n || r;
        return n != null && n.destroyed || r != null && r.destroyed ? (typeof e == "function" && e(), this) : (Ph(t, n, r), n && (n.destroyed = !0), r && (r.destroyed = !0), i.constructed ? Ah(this, t, e) : this.once(Th, function(s) {
            Ah(this, Ym(s, t), e);
        }), this);
    }
    function Ah(t, e, r) {
        let n = !1;
        function i(s) {
            if (n) return;
            n = !0;
            let o = t._readableState, a = t._writableState;
            Ph(s, a, o), a && (a.closed = !0), o && (o.closed = !0), typeof r == "function" && r(s), s ? _t.nextTick(i_, t, s) : _t.nextTick(Oh, t);
        }
        try {
            t._destroy(e || null, i);
        } catch (s) {
            i(s);
        }
    }
    function i_(t, e) {
        Rs(t, e), Oh(t);
    }
    function Oh(t) {
        let e = t._readableState, r = t._writableState;
        r && (r.closeEmitted = !0), e && (e.closeEmitted = !0), (r != null && r.emitClose || e != null && e.emitClose) && t.emit("close");
    }
    function Rs(t, e) {
        let r = t._readableState, n = t._writableState;
        n != null && n.errorEmitted || r != null && r.errorEmitted || (n && (n.errorEmitted = !0), r && (r.errorEmitted = !0), t.emit("error", e));
    }
    function o_() {
        let t = this._readableState, e = this._writableState;
        t && (t.constructed = !0, t.closed = !1, t.closeEmitted = !1, t.destroyed = !1, t.errored = null, t.errorEmitted = !1, t.reading = !1, t.ended = t.readable === !1, t.endEmitted = t.readable === !1), e && (e.constructed = !0, e.destroyed = !1, e.closed = !1, e.closeEmitted = !1, e.errored = null, e.errorEmitted = !1, e.finalCalled = !1, e.prefinished = !1, e.ended = e.writable === !1, e.ending = e.writable === !1, e.finished = e.writable === !1);
    }
    function ks(t, e, r) {
        let n = t._readableState, i = t._writableState;
        if (i != null && i.destroyed || n != null && n.destroyed) return this;
        n != null && n.autoDestroy || i != null && i.autoDestroy ? t.destroy(e) : e && (e.stack, i && !i.errored && (i.errored = e), n && !n.errored && (n.errored = e), r ? _t.nextTick(Rs, t, e) : Rs(t, e));
    }
    function s_(t, e) {
        if (typeof t._construct != "function") return;
        let r = t._readableState, n = t._writableState;
        r && (r.constructed = !1), n && (n.constructed = !1), t.once(Os, e), !(t.listenerCount(Os) > 1) && _t.nextTick(a_, t);
    }
    function a_(t) {
        let e = !1;
        function r(n) {
            if (e) {
                ks(t, n ?? new Jm);
                return;
            }
            e = !0;
            let i = t._readableState, s = t._writableState, o = s || i;
            i && (i.constructed = !0), s && (s.constructed = !0), o.destroyed ? t.emit(Th, n) : n ? ks(t, n, !0) : _t.nextTick(u_, t);
        }
        try {
            t._construct((n)=>{
                _t.nextTick(r, n);
            });
        } catch (n) {
            _t.nextTick(r, n);
        }
    }
    function u_(t) {
        t.emit(Os);
    }
    function Ih(t) {
        return t?.setHeader && typeof t.abort == "function";
    }
    function Rh(t) {
        t.emit("close");
    }
    function l_(t, e) {
        t.emit("error", e), _t.nextTick(Rh, t);
    }
    function c_(t, e) {
        !t || e_(t) || (!e && !t_(t) && (e = new Xm), r_(t) ? (t.socket = null, t.destroy(e)) : Ih(t) ? t.abort() : Ih(t.req) ? t.req.abort() : typeof t.destroy == "function" ? t.destroy(e) : typeof t.close == "function" ? t.close() : e ? _t.nextTick(l_, t, e) : _t.nextTick(Rh, t), t.destroyed || (t[Zm] = !0));
    }
    kh.exports = {
        construct: s_,
        destroyer: c_,
        destroy: n_,
        undestroy: o_,
        errorOrDestroy: ks
    };
});
var $4c2dd1b68d143d96$var$$i = $4c2dd1b68d143d96$var$D((NR, Bh)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var { ArrayIsArray: f_, ObjectSetPrototypeOf: Ch } = $4c2dd1b68d143d96$var$Ee(), { EventEmitter: Fi } = ($4c2dd1b68d143d96$var$er(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$Zt));
    function Wi(t) {
        Fi.call(this, t);
    }
    Ch(Wi.prototype, Fi.prototype);
    Ch(Wi, Fi);
    Wi.prototype.pipe = function(t, e) {
        let r = this;
        function n(h) {
            t.writable && t.write(h) === !1 && r.pause && r.pause();
        }
        r.on("data", n);
        function i() {
            r.readable && r.resume && r.resume();
        }
        t.on("drain", i), !t._isStdio && (!e || e.end !== !1) && (r.on("end", o), r.on("close", a));
        let s = !1;
        function o() {
            s || (s = !0, t.end());
        }
        function a() {
            s || (s = !0, typeof t.destroy == "function" && t.destroy());
        }
        function c(h) {
            f(), Fi.listenerCount(this, "error") === 0 && this.emit("error", h);
        }
        Cs(r, "error", c), Cs(t, "error", c);
        function f() {
            r.removeListener("data", n), t.removeListener("drain", i), r.removeListener("end", o), r.removeListener("close", a), r.removeListener("error", c), t.removeListener("error", c), r.removeListener("end", f), r.removeListener("close", f), t.removeListener("close", f);
        }
        return r.on("end", f), r.on("close", f), t.on("close", f), t.emit("pipe", r), t;
    };
    function Cs(t, e, r) {
        if (typeof t.prependListener == "function") return t.prependListener(e, r);
        !t._events || !t._events[e] ? t.on(e, r) : f_(t._events[e]) ? t._events[e].unshift(r) : t._events[e] = [
            r,
            t._events[e]
        ];
    }
    Bh.exports = {
        Stream: Wi,
        prependListener: Cs
    };
});
var $4c2dd1b68d143d96$var$kn = $4c2dd1b68d143d96$var$D((VR, Hi)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var { SymbolDispose: h_ } = $4c2dd1b68d143d96$var$Ee(), { AbortError: Mh, codes: d_ } = $4c2dd1b68d143d96$var$De(), { isNodeStream: Nh, isWebStream: p_, kControllerErrorFunction: y_ } = $4c2dd1b68d143d96$var$mt(), g_ = $4c2dd1b68d143d96$var$Ut(), { ERR_INVALID_ARG_TYPE: qh } = d_, Bs, b_ = (t, e)=>{
        if (typeof t != "object" || !("aborted" in t)) throw new qh(e, "AbortSignal", t);
    };
    Hi.exports.addAbortSignal = function(e, r) {
        if (b_(e, "signal"), !Nh(r) && !p_(r)) throw new qh("stream", [
            "ReadableStream",
            "WritableStream",
            "Stream"
        ], r);
        return Hi.exports.addAbortSignalNoValidate(e, r);
    };
    Hi.exports.addAbortSignalNoValidate = function(t, e) {
        if (typeof t != "object" || !("aborted" in t)) return e;
        let r = Nh(e) ? ()=>{
            e.destroy(new Mh(void 0, {
                cause: t.reason
            }));
        } : ()=>{
            e[y_](new Mh(void 0, {
                cause: t.reason
            }));
        };
        if (t.aborted) r();
        else {
            Bs = Bs || $4c2dd1b68d143d96$var$$e().addAbortListener;
            let n = Bs(t, r);
            g_(e, n[h_]);
        }
        return e;
    };
});
var $4c2dd1b68d143d96$var$Dh = $4c2dd1b68d143d96$var$D((rk, Uh)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var { StringPrototypeSlice: Lh, SymbolIterator: w_, TypedArrayPrototypeSet: Vi, Uint8Array: m_ } = $4c2dd1b68d143d96$var$Ee(), { Buffer: Ms } = ($4c2dd1b68d143d96$var$ke(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$qe)), { inspect: __ } = $4c2dd1b68d143d96$var$$e();
    Uh.exports = class {
        constructor(){
            this.head = null, this.tail = null, this.length = 0;
        }
        push(e) {
            let r = {
                data: e,
                next: null
            };
            this.length > 0 ? this.tail.next = r : this.head = r, this.tail = r, ++this.length;
        }
        unshift(e) {
            let r = {
                data: e,
                next: this.head
            };
            this.length === 0 && (this.tail = r), this.head = r, ++this.length;
        }
        shift() {
            if (this.length === 0) return;
            let e = this.head.data;
            return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
        }
        clear() {
            this.head = this.tail = null, this.length = 0;
        }
        join(e) {
            if (this.length === 0) return "";
            let r = this.head, n = "" + r.data;
            for(; (r = r.next) !== null;)n += e + r.data;
            return n;
        }
        concat(e) {
            if (this.length === 0) return Ms.alloc(0);
            let r = Ms.allocUnsafe(e >>> 0), n = this.head, i = 0;
            for(; n;)Vi(r, n.data, i), i += n.data.length, n = n.next;
            return r;
        }
        consume(e, r) {
            let n = this.head.data;
            if (e < n.length) {
                let i = n.slice(0, e);
                return this.head.data = n.slice(e), i;
            }
            return e === n.length ? this.shift() : r ? this._getString(e) : this._getBuffer(e);
        }
        first() {
            return this.head.data;
        }
        *[w_]() {
            for(let e = this.head; e; e = e.next)yield e.data;
        }
        _getString(e) {
            let r = "", n = this.head, i = 0;
            do {
                let s = n.data;
                if (e > s.length) r += s, e -= s.length;
                else {
                    e === s.length ? (r += s, ++i, n.next ? this.head = n.next : this.head = this.tail = null) : (r += Lh(s, 0, e), this.head = n, n.data = Lh(s, e));
                    break;
                }
                ++i;
            }while ((n = n.next) !== null);
            return this.length -= i, r;
        }
        _getBuffer(e) {
            let r = Ms.allocUnsafe(e), n = e, i = this.head, s = 0;
            do {
                let o = i.data;
                if (e > o.length) Vi(r, o, n - e), e -= o.length;
                else {
                    e === o.length ? (Vi(r, o, n - e), ++s, i.next ? this.head = i.next : this.head = this.tail = null) : (Vi(r, new m_(o.buffer, o.byteOffset, e), n - e), this.head = i, i.data = o.slice(e));
                    break;
                }
                ++s;
            }while ((i = i.next) !== null);
            return this.length -= s, r;
        }
        [Symbol.for("nodejs.util.inspect.custom")](e, r) {
            return __(this, {
                ...r,
                depth: 0,
                customInspect: !1
            });
        }
    };
});
var $4c2dd1b68d143d96$var$Cn = $4c2dd1b68d143d96$var$D((hk, $h)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var { MathFloor: v_, NumberIsInteger: S_ } = $4c2dd1b68d143d96$var$Ee(), { validateInteger: E_ } = $4c2dd1b68d143d96$var$Xr(), { ERR_INVALID_ARG_VALUE: A_ } = $4c2dd1b68d143d96$var$De().codes, jh = 16384, Fh = 16;
    function I_(t, e, r) {
        return t.highWaterMark != null ? t.highWaterMark : e ? t[r] : null;
    }
    function Wh(t) {
        return t ? Fh : jh;
    }
    function x_(t, e) {
        E_(e, "value", 0), t ? Fh = e : jh = e;
    }
    function T_(t, e, r, n) {
        let i = I_(e, n, r);
        if (i != null) {
            if (!S_(i) || i < 0) {
                let s = n ? `options.${r}` : "options.highWaterMark";
                throw new A_(s, i);
            }
            return v_(i);
        }
        return Wh(t.objectMode);
    }
    $h.exports = {
        getHighWaterMark: T_,
        getDefaultHighWaterMark: Wh,
        setDefaultHighWaterMark: x_
    };
});
var $4c2dd1b68d143d96$var$Gh = $4c2dd1b68d143d96$var$D((Ns, Vh)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var Gi = ($4c2dd1b68d143d96$var$ke(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$qe)), vt = Gi.Buffer;
    function Hh(t, e) {
        for(var r in t)e[r] = t[r];
    }
    vt.from && vt.alloc && vt.allocUnsafe && vt.allocUnsafeSlow ? Vh.exports = Gi : (Hh(Gi, Ns), Ns.Buffer = Ir);
    function Ir(t, e, r) {
        return vt(t, e, r);
    }
    Ir.prototype = Object.create(vt.prototype);
    Hh(vt, Ir);
    Ir.from = function(t, e, r) {
        if (typeof t == "number") throw new TypeError("Argument must not be a number");
        return vt(t, e, r);
    };
    Ir.alloc = function(t, e, r) {
        if (typeof t != "number") throw new TypeError("Argument must be a number");
        var n = vt(t);
        return e !== void 0 ? typeof r == "string" ? n.fill(e, r) : n.fill(e) : n.fill(0), n;
    };
    Ir.allocUnsafe = function(t) {
        if (typeof t != "number") throw new TypeError("Argument must be a number");
        return vt(t);
    };
    Ir.allocUnsafeSlow = function(t) {
        if (typeof t != "number") throw new TypeError("Argument must be a number");
        return Gi.SlowBuffer(t);
    };
});
var $4c2dd1b68d143d96$var$Qh = $4c2dd1b68d143d96$var$D((Kh)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var Ls = $4c2dd1b68d143d96$var$Gh().Buffer, zh = Ls.isEncoding || function(t) {
        switch(t = "" + t, t && t.toLowerCase()){
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
            case "raw":
                return !0;
            default:
                return !1;
        }
    };
    function P_(t) {
        if (!t) return "utf8";
        for(var e;;)switch(t){
            case "utf8":
            case "utf-8":
                return "utf8";
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return "utf16le";
            case "latin1":
            case "binary":
                return "latin1";
            case "base64":
            case "ascii":
            case "hex":
                return t;
            default:
                if (e) return;
                t = ("" + t).toLowerCase(), e = !0;
        }
    }
    function O_(t) {
        var e = P_(t);
        if (typeof e != "string" && (Ls.isEncoding === zh || !zh(t))) throw new Error("Unknown encoding: " + t);
        return e || t;
    }
    Kh.StringDecoder = Bn;
    function Bn(t) {
        this.encoding = O_(t);
        var e;
        switch(this.encoding){
            case "utf16le":
                this.text = N_, this.end = q_, e = 4;
                break;
            case "utf8":
                this.fillLast = C_, e = 4;
                break;
            case "base64":
                this.text = L_, this.end = U_, e = 3;
                break;
            default:
                this.write = D_, this.end = j_;
                return;
        }
        this.lastNeed = 0, this.lastTotal = 0, this.lastChar = Ls.allocUnsafe(e);
    }
    Bn.prototype.write = function(t) {
        if (t.length === 0) return "";
        var e, r;
        if (this.lastNeed) {
            if (e = this.fillLast(t), e === void 0) return "";
            r = this.lastNeed, this.lastNeed = 0;
        } else r = 0;
        return r < t.length ? e ? e + this.text(t, r) : this.text(t, r) : e || "";
    };
    Bn.prototype.end = M_;
    Bn.prototype.text = B_;
    Bn.prototype.fillLast = function(t) {
        if (this.lastNeed <= t.length) return t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
        t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length), this.lastNeed -= t.length;
    };
    function qs(t) {
        return t <= 127 ? 0 : t >> 5 === 6 ? 2 : t >> 4 === 14 ? 3 : t >> 3 === 30 ? 4 : t >> 6 === 2 ? -1 : -2;
    }
    function R_(t, e, r) {
        var n = e.length - 1;
        if (n < r) return 0;
        var i = qs(e[n]);
        return i >= 0 ? (i > 0 && (t.lastNeed = i - 1), i) : --n < r || i === -2 ? 0 : (i = qs(e[n]), i >= 0 ? (i > 0 && (t.lastNeed = i - 2), i) : --n < r || i === -2 ? 0 : (i = qs(e[n]), i >= 0 ? (i > 0 && (i === 2 ? i = 0 : t.lastNeed = i - 3), i) : 0));
    }
    function k_(t, e, r) {
        if ((e[0] & 192) !== 128) return t.lastNeed = 0, "\uFFFD";
        if (t.lastNeed > 1 && e.length > 1) {
            if ((e[1] & 192) !== 128) return t.lastNeed = 1, "\uFFFD";
            if (t.lastNeed > 2 && e.length > 2 && (e[2] & 192) !== 128) return t.lastNeed = 2, "\uFFFD";
        }
    }
    function C_(t) {
        var e = this.lastTotal - this.lastNeed, r = k_(this, t, e);
        if (r !== void 0) return r;
        if (this.lastNeed <= t.length) return t.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
        t.copy(this.lastChar, e, 0, t.length), this.lastNeed -= t.length;
    }
    function B_(t, e) {
        var r = R_(this, t, e);
        if (!this.lastNeed) return t.toString("utf8", e);
        this.lastTotal = r;
        var n = t.length - (r - this.lastNeed);
        return t.copy(this.lastChar, 0, n), t.toString("utf8", e, n);
    }
    function M_(t) {
        var e = t && t.length ? this.write(t) : "";
        return this.lastNeed ? e + "\uFFFD" : e;
    }
    function N_(t, e) {
        if ((t.length - e) % 2 === 0) {
            var r = t.toString("utf16le", e);
            if (r) {
                var n = r.charCodeAt(r.length - 1);
                if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1], r.slice(0, -1);
            }
            return r;
        }
        return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t[t.length - 1], t.toString("utf16le", e, t.length - 1);
    }
    function q_(t) {
        var e = t && t.length ? this.write(t) : "";
        if (this.lastNeed) {
            var r = this.lastTotal - this.lastNeed;
            return e + this.lastChar.toString("utf16le", 0, r);
        }
        return e;
    }
    function L_(t, e) {
        var r = (t.length - e) % 3;
        return r === 0 ? t.toString("base64", e) : (this.lastNeed = 3 - r, this.lastTotal = 3, r === 1 ? this.lastChar[0] = t[t.length - 1] : (this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1]), t.toString("base64", e, t.length - r));
    }
    function U_(t) {
        var e = t && t.length ? this.write(t) : "";
        return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e;
    }
    function D_(t) {
        return t.toString(this.encoding);
    }
    function j_(t) {
        return t && t.length ? this.write(t) : "";
    }
});
var $4c2dd1b68d143d96$var$Us = $4c2dd1b68d143d96$var$D((Fk, Zh)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var Yh = $4c2dd1b68d143d96$var$tr(), { PromisePrototypeThen: F_, SymbolAsyncIterator: Jh, SymbolIterator: Xh } = $4c2dd1b68d143d96$var$Ee(), { Buffer: W_ } = ($4c2dd1b68d143d96$var$ke(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$qe)), { ERR_INVALID_ARG_TYPE: $_, ERR_STREAM_NULL_VALUES: H_ } = $4c2dd1b68d143d96$var$De().codes;
    function V_(t, e, r) {
        let n;
        if (typeof e == "string" || e instanceof W_) return new t({
            objectMode: !0,
            ...r,
            read () {
                this.push(e), this.push(null);
            }
        });
        let i;
        if (e && e[Jh]) i = !0, n = e[Jh]();
        else if (e && e[Xh]) i = !1, n = e[Xh]();
        else throw new $_("iterable", [
            "Iterable"
        ], e);
        let s = new t({
            objectMode: !0,
            highWaterMark: 1,
            ...r
        }), o = !1;
        s._read = function() {
            o || (o = !0, c());
        }, s._destroy = function(f, h) {
            F_(a(f), ()=>Yh.nextTick(h, f), (d)=>Yh.nextTick(h, d || f));
        };
        async function a(f) {
            let h = f != null, d = typeof n.throw == "function";
            if (h && d) {
                let { value: w, done: y } = await n.throw(f);
                if (await w, y) return;
            }
            if (typeof n.return == "function") {
                let { value: w } = await n.return();
                await w;
            }
        }
        async function c() {
            for(;;){
                try {
                    let { value: f, done: h } = i ? await n.next() : n.next();
                    if (h) s.push(null);
                    else {
                        let d = f && typeof f.then == "function" ? await f : f;
                        if (d === null) throw o = !1, new H_;
                        if (s.push(d)) continue;
                        o = !1;
                    }
                } catch (f) {
                    s.destroy(f);
                }
                break;
            }
        }
        return s;
    }
    Zh.exports = V_;
});
var $4c2dd1b68d143d96$var$Nn = $4c2dd1b68d143d96$var$D((Jk, bd)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var lt = $4c2dd1b68d143d96$var$tr(), { ArrayPrototypeIndexOf: G_, NumberIsInteger: z_, NumberIsNaN: K_, NumberParseInt: Q_, ObjectDefineProperties: Gs, ObjectKeys: Y_, ObjectSetPrototypeOf: rd, Promise: nd, SafeSet: J_, SymbolAsyncDispose: X_, SymbolAsyncIterator: Z_, Symbol: ev } = $4c2dd1b68d143d96$var$Ee();
    bd.exports = le;
    le.ReadableState = Yi;
    var { EventEmitter: tv } = ($4c2dd1b68d143d96$var$er(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$Zt)), { Stream: nr, prependListener: rv } = $4c2dd1b68d143d96$var$$i(), { Buffer: Ds } = ($4c2dd1b68d143d96$var$ke(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$qe)), { addAbortSignal: nv } = $4c2dd1b68d143d96$var$kn(), id = $4c2dd1b68d143d96$var$Ut(), he = $4c2dd1b68d143d96$var$$e().debuglog("stream", (t)=>{
        he = t;
    }), iv = $4c2dd1b68d143d96$var$Dh(), nn = $4c2dd1b68d143d96$var$Ar(), { getHighWaterMark: ov, getDefaultHighWaterMark: sv } = $4c2dd1b68d143d96$var$Cn(), { aggregateTwoErrors: ed, codes: { ERR_INVALID_ARG_TYPE: av, ERR_METHOD_NOT_IMPLEMENTED: uv, ERR_OUT_OF_RANGE: lv, ERR_STREAM_PUSH_AFTER_EOF: cv, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: fv }, AbortError: hv } = $4c2dd1b68d143d96$var$De(), { validateObject: dv } = $4c2dd1b68d143d96$var$Xr(), xr = ev("kPaused"), { StringDecoder: od } = $4c2dd1b68d143d96$var$Qh(), pv = $4c2dd1b68d143d96$var$Us();
    rd(le.prototype, nr.prototype);
    rd(le, nr);
    var js = ()=>{}, { errorOrDestroy: tn } = nn, rn = 1, yv = 2, sd = 4, Mn = 8, ad = 16, zi = 32, Ki = 64, ud = 128, gv = 256, bv = 512, wv = 1024, Hs = 2048, Vs = 4096, mv = 8192, _v = 16384, vv = 32768, ld = 65536, Sv = 131072, Ev = 262144;
    function Ce(t) {
        return {
            enumerable: !1,
            get () {
                return (this.state & t) !== 0;
            },
            set (e) {
                e ? this.state |= t : this.state &= ~t;
            }
        };
    }
    Gs(Yi.prototype, {
        objectMode: Ce(rn),
        ended: Ce(yv),
        endEmitted: Ce(sd),
        reading: Ce(Mn),
        constructed: Ce(ad),
        sync: Ce(zi),
        needReadable: Ce(Ki),
        emittedReadable: Ce(ud),
        readableListening: Ce(gv),
        resumeScheduled: Ce(bv),
        errorEmitted: Ce(wv),
        emitClose: Ce(Hs),
        autoDestroy: Ce(Vs),
        destroyed: Ce(mv),
        closed: Ce(_v),
        closeEmitted: Ce(vv),
        multiAwaitDrain: Ce(ld),
        readingMore: Ce(Sv),
        dataEmitted: Ce(Ev)
    });
    function Yi(t, e, r) {
        typeof r != "boolean" && (r = e instanceof $4c2dd1b68d143d96$var$St()), this.state = Hs | Vs | ad | zi, t && t.objectMode && (this.state |= rn), r && t && t.readableObjectMode && (this.state |= rn), this.highWaterMark = t ? ov(this, t, "readableHighWaterMark", r) : sv(!1), this.buffer = new iv, this.length = 0, this.pipes = [], this.flowing = null, this[xr] = null, t && t.emitClose === !1 && (this.state &= ~Hs), t && t.autoDestroy === !1 && (this.state &= ~Vs), this.errored = null, this.defaultEncoding = t && t.defaultEncoding || "utf8", this.awaitDrainWriters = null, this.decoder = null, this.encoding = null, t && t.encoding && (this.decoder = new od(t.encoding), this.encoding = t.encoding);
    }
    function le(t) {
        if (!(this instanceof le)) return new le(t);
        let e = this instanceof $4c2dd1b68d143d96$var$St();
        this._readableState = new Yi(t, this, e), t && (typeof t.read == "function" && (this._read = t.read), typeof t.destroy == "function" && (this._destroy = t.destroy), typeof t.construct == "function" && (this._construct = t.construct), t.signal && !e && nv(t.signal, this)), nr.call(this, t), nn.construct(this, ()=>{
            this._readableState.needReadable && Qi(this, this._readableState);
        });
    }
    le.prototype.destroy = nn.destroy;
    le.prototype._undestroy = nn.undestroy;
    le.prototype._destroy = function(t, e) {
        e(t);
    };
    le.prototype[tv.captureRejectionSymbol] = function(t) {
        this.destroy(t);
    };
    le.prototype[X_] = function() {
        let t;
        return this.destroyed || (t = this.readableEnded ? null : new hv, this.destroy(t)), new nd((e, r)=>id(this, (n)=>n && n !== t ? r(n) : e(null)));
    };
    le.prototype.push = function(t, e) {
        return cd(this, t, e, !1);
    };
    le.prototype.unshift = function(t, e) {
        return cd(this, t, e, !0);
    };
    function cd(t, e, r, n) {
        he("readableAddChunk", e);
        let i = t._readableState, s;
        if ((i.state & rn) === 0 && (typeof e == "string" ? (r = r || i.defaultEncoding, i.encoding !== r && (n && i.encoding ? e = Ds.from(e, r).toString(i.encoding) : (e = Ds.from(e, r), r = ""))) : e instanceof Ds ? r = "" : nr._isUint8Array(e) ? (e = nr._uint8ArrayToBuffer(e), r = "") : e != null && (s = new av("chunk", [
            "string",
            "Buffer",
            "Uint8Array"
        ], e))), s) tn(t, s);
        else if (e === null) i.state &= ~Mn, xv(t, i);
        else if ((i.state & rn) !== 0 || e && e.length > 0) {
            if (n) {
                if ((i.state & sd) !== 0) tn(t, new fv);
                else {
                    if (i.destroyed || i.errored) return !1;
                    Fs(t, i, e, !0);
                }
            } else if (i.ended) tn(t, new cv);
            else {
                if (i.destroyed || i.errored) return !1;
                i.state &= ~Mn, i.decoder && !r ? (e = i.decoder.write(e), i.objectMode || e.length !== 0 ? Fs(t, i, e, !1) : Qi(t, i)) : Fs(t, i, e, !1);
            }
        } else n || (i.state &= ~Mn, Qi(t, i));
        return !i.ended && (i.length < i.highWaterMark || i.length === 0);
    }
    function Fs(t, e, r, n) {
        e.flowing && e.length === 0 && !e.sync && t.listenerCount("data") > 0 ? ((e.state & ld) !== 0 ? e.awaitDrainWriters.clear() : e.awaitDrainWriters = null, e.dataEmitted = !0, t.emit("data", r)) : (e.length += e.objectMode ? 1 : r.length, n ? e.buffer.unshift(r) : e.buffer.push(r), (e.state & Ki) !== 0 && Ji(t)), Qi(t, e);
    }
    le.prototype.isPaused = function() {
        let t = this._readableState;
        return t[xr] === !0 || t.flowing === !1;
    };
    le.prototype.setEncoding = function(t) {
        let e = new od(t);
        this._readableState.decoder = e, this._readableState.encoding = this._readableState.decoder.encoding;
        let r = this._readableState.buffer, n = "";
        for (let i of r)n += e.write(i);
        return r.clear(), n !== "" && r.push(n), this._readableState.length = n.length, this;
    };
    var Av = 1073741824;
    function Iv(t) {
        if (t > Av) throw new lv("size", "<= 1GiB", t);
        return t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++, t;
    }
    function td(t, e) {
        return t <= 0 || e.length === 0 && e.ended ? 0 : (e.state & rn) !== 0 ? 1 : K_(t) ? e.flowing && e.length ? e.buffer.first().length : e.length : t <= e.length ? t : e.ended ? e.length : 0;
    }
    le.prototype.read = function(t) {
        he("read", t), t === void 0 ? t = NaN : z_(t) || (t = Q_(t, 10));
        let e = this._readableState, r = t;
        if (t > e.highWaterMark && (e.highWaterMark = Iv(t)), t !== 0 && (e.state &= ~ud), t === 0 && e.needReadable && ((e.highWaterMark !== 0 ? e.length >= e.highWaterMark : e.length > 0) || e.ended)) return he("read: emitReadable", e.length, e.ended), e.length === 0 && e.ended ? Ws(this) : Ji(this), null;
        if (t = td(t, e), t === 0 && e.ended) return e.length === 0 && Ws(this), null;
        let n = (e.state & Ki) !== 0;
        if (he("need readable", n), (e.length === 0 || e.length - t < e.highWaterMark) && (n = !0, he("length less than watermark", n)), e.ended || e.reading || e.destroyed || e.errored || !e.constructed) n = !1, he("reading, ended or constructing", n);
        else if (n) {
            he("do read"), e.state |= Mn | zi, e.length === 0 && (e.state |= Ki);
            try {
                this._read(e.highWaterMark);
            } catch (s) {
                tn(this, s);
            }
            e.state &= ~zi, e.reading || (t = td(r, e));
        }
        let i;
        return t > 0 ? i = yd(t, e) : i = null, i === null ? (e.needReadable = e.length <= e.highWaterMark, t = 0) : (e.length -= t, e.multiAwaitDrain ? e.awaitDrainWriters.clear() : e.awaitDrainWriters = null), e.length === 0 && (e.ended || (e.needReadable = !0), r !== t && e.ended && Ws(this)), i !== null && !e.errorEmitted && !e.closeEmitted && (e.dataEmitted = !0, this.emit("data", i)), i;
    };
    function xv(t, e) {
        if (he("onEofChunk"), !e.ended) {
            if (e.decoder) {
                let r = e.decoder.end();
                r && r.length && (e.buffer.push(r), e.length += e.objectMode ? 1 : r.length);
            }
            e.ended = !0, e.sync ? Ji(t) : (e.needReadable = !1, e.emittedReadable = !0, fd(t));
        }
    }
    function Ji(t) {
        let e = t._readableState;
        he("emitReadable", e.needReadable, e.emittedReadable), e.needReadable = !1, e.emittedReadable || (he("emitReadable", e.flowing), e.emittedReadable = !0, lt.nextTick(fd, t));
    }
    function fd(t) {
        let e = t._readableState;
        he("emitReadable_", e.destroyed, e.length, e.ended), !e.destroyed && !e.errored && (e.length || e.ended) && (t.emit("readable"), e.emittedReadable = !1), e.needReadable = !e.flowing && !e.ended && e.length <= e.highWaterMark, dd(t);
    }
    function Qi(t, e) {
        !e.readingMore && e.constructed && (e.readingMore = !0, lt.nextTick(Tv, t, e));
    }
    function Tv(t, e) {
        for(; !e.reading && !e.ended && (e.length < e.highWaterMark || e.flowing && e.length === 0);){
            let r = e.length;
            if (he("maybeReadMore read 0"), t.read(0), r === e.length) break;
        }
        e.readingMore = !1;
    }
    le.prototype._read = function(t) {
        throw new uv("_read()");
    };
    le.prototype.pipe = function(t, e) {
        let r = this, n = this._readableState;
        n.pipes.length === 1 && (n.multiAwaitDrain || (n.multiAwaitDrain = !0, n.awaitDrainWriters = new J_(n.awaitDrainWriters ? [
            n.awaitDrainWriters
        ] : []))), n.pipes.push(t), he("pipe count=%d opts=%j", n.pipes.length, e);
        let s = (!e || e.end !== !1) && t !== lt.stdout && t !== lt.stderr ? a : b;
        n.endEmitted ? lt.nextTick(s) : r.once("end", s), t.on("unpipe", o);
        function o(m, v) {
            he("onunpipe"), m === r && v && v.hasUnpiped === !1 && (v.hasUnpiped = !0, h());
        }
        function a() {
            he("onend"), t.end();
        }
        let c, f = !1;
        function h() {
            he("cleanup"), t.removeListener("close", P), t.removeListener("finish", E), c && t.removeListener("drain", c), t.removeListener("error", y), t.removeListener("unpipe", o), r.removeListener("end", a), r.removeListener("end", b), r.removeListener("data", w), f = !0, c && n.awaitDrainWriters && (!t._writableState || t._writableState.needDrain) && c();
        }
        function d() {
            f || (n.pipes.length === 1 && n.pipes[0] === t ? (he("false write response, pause", 0), n.awaitDrainWriters = t, n.multiAwaitDrain = !1) : n.pipes.length > 1 && n.pipes.includes(t) && (he("false write response, pause", n.awaitDrainWriters.size), n.awaitDrainWriters.add(t)), r.pause()), c || (c = Pv(r, t), t.on("drain", c));
        }
        r.on("data", w);
        function w(m) {
            he("ondata");
            let v = t.write(m);
            he("dest.write", v), v === !1 && d();
        }
        function y(m) {
            if (he("onerror", m), b(), t.removeListener("error", y), t.listenerCount("error") === 0) {
                let v = t._writableState || t._readableState;
                v && !v.errorEmitted ? tn(t, m) : t.emit("error", m);
            }
        }
        rv(t, "error", y);
        function P() {
            t.removeListener("finish", E), b();
        }
        t.once("close", P);
        function E() {
            he("onfinish"), t.removeListener("close", P), b();
        }
        t.once("finish", E);
        function b() {
            he("unpipe"), r.unpipe(t);
        }
        return t.emit("pipe", r), t.writableNeedDrain === !0 ? d() : n.flowing || (he("pipe resume"), r.resume()), t;
    };
    function Pv(t, e) {
        return function() {
            let n = t._readableState;
            n.awaitDrainWriters === e ? (he("pipeOnDrain", 1), n.awaitDrainWriters = null) : n.multiAwaitDrain && (he("pipeOnDrain", n.awaitDrainWriters.size), n.awaitDrainWriters.delete(e)), (!n.awaitDrainWriters || n.awaitDrainWriters.size === 0) && t.listenerCount("data") && t.resume();
        };
    }
    le.prototype.unpipe = function(t) {
        let e = this._readableState, r = {
            hasUnpiped: !1
        };
        if (e.pipes.length === 0) return this;
        if (!t) {
            let i = e.pipes;
            e.pipes = [], this.pause();
            for(let s = 0; s < i.length; s++)i[s].emit("unpipe", this, {
                hasUnpiped: !1
            });
            return this;
        }
        let n = G_(e.pipes, t);
        return n === -1 ? this : (e.pipes.splice(n, 1), e.pipes.length === 0 && this.pause(), t.emit("unpipe", this, r), this);
    };
    le.prototype.on = function(t, e) {
        let r = nr.prototype.on.call(this, t, e), n = this._readableState;
        return t === "data" ? (n.readableListening = this.listenerCount("readable") > 0, n.flowing !== !1 && this.resume()) : t === "readable" && !n.endEmitted && !n.readableListening && (n.readableListening = n.needReadable = !0, n.flowing = !1, n.emittedReadable = !1, he("on readable", n.length, n.reading), n.length ? Ji(this) : n.reading || lt.nextTick(Ov, this)), r;
    };
    le.prototype.addListener = le.prototype.on;
    le.prototype.removeListener = function(t, e) {
        let r = nr.prototype.removeListener.call(this, t, e);
        return t === "readable" && lt.nextTick(hd, this), r;
    };
    le.prototype.off = le.prototype.removeListener;
    le.prototype.removeAllListeners = function(t) {
        let e = nr.prototype.removeAllListeners.apply(this, arguments);
        return (t === "readable" || t === void 0) && lt.nextTick(hd, this), e;
    };
    function hd(t) {
        let e = t._readableState;
        e.readableListening = t.listenerCount("readable") > 0, e.resumeScheduled && e[xr] === !1 ? e.flowing = !0 : t.listenerCount("data") > 0 ? t.resume() : e.readableListening || (e.flowing = null);
    }
    function Ov(t) {
        he("readable nexttick read 0"), t.read(0);
    }
    le.prototype.resume = function() {
        let t = this._readableState;
        return t.flowing || (he("resume"), t.flowing = !t.readableListening, Rv(this, t)), t[xr] = !1, this;
    };
    function Rv(t, e) {
        e.resumeScheduled || (e.resumeScheduled = !0, lt.nextTick(kv, t, e));
    }
    function kv(t, e) {
        he("resume", e.reading), e.reading || t.read(0), e.resumeScheduled = !1, t.emit("resume"), dd(t), e.flowing && !e.reading && t.read(0);
    }
    le.prototype.pause = function() {
        return he("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (he("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState[xr] = !0, this;
    };
    function dd(t) {
        let e = t._readableState;
        for(he("flow", e.flowing); e.flowing && t.read() !== null;);
    }
    le.prototype.wrap = function(t) {
        let e = !1;
        t.on("data", (n)=>{
            !this.push(n) && t.pause && (e = !0, t.pause());
        }), t.on("end", ()=>{
            this.push(null);
        }), t.on("error", (n)=>{
            tn(this, n);
        }), t.on("close", ()=>{
            this.destroy();
        }), t.on("destroy", ()=>{
            this.destroy();
        }), this._read = ()=>{
            e && t.resume && (e = !1, t.resume());
        };
        let r = Y_(t);
        for(let n = 1; n < r.length; n++){
            let i = r[n];
            this[i] === void 0 && typeof t[i] == "function" && (this[i] = t[i].bind(t));
        }
        return this;
    };
    le.prototype[Z_] = function() {
        return pd(this);
    };
    le.prototype.iterator = function(t) {
        return t !== void 0 && dv(t, "options"), pd(this, t);
    };
    function pd(t, e) {
        typeof t.read != "function" && (t = le.wrap(t, {
            objectMode: !0
        }));
        let r = Cv(t, e);
        return r.stream = t, r;
    }
    async function* Cv(t, e) {
        let r = js;
        function n(o) {
            this === t ? (r(), r = js) : r = o;
        }
        t.on("readable", n);
        let i, s = id(t, {
            writable: !1
        }, (o)=>{
            i = o ? ed(i, o) : null, r(), r = js;
        });
        try {
            for(;;){
                let o = t.destroyed ? null : t.read();
                if (o !== null) yield o;
                else {
                    if (i) throw i;
                    if (i === null) return;
                    await new nd(n);
                }
            }
        } catch (o) {
            throw i = ed(i, o), i;
        } finally{
            (i || e?.destroyOnReturn !== !1) && (i === void 0 || t._readableState.autoDestroy) ? nn.destroyer(t, null) : (t.off("readable", n), s());
        }
    }
    Gs(le.prototype, {
        readable: {
            __proto__: null,
            get () {
                let t = this._readableState;
                return !!t && t.readable !== !1 && !t.destroyed && !t.errorEmitted && !t.endEmitted;
            },
            set (t) {
                this._readableState && (this._readableState.readable = !!t);
            }
        },
        readableDidRead: {
            __proto__: null,
            enumerable: !1,
            get: function() {
                return this._readableState.dataEmitted;
            }
        },
        readableAborted: {
            __proto__: null,
            enumerable: !1,
            get: function() {
                return !!(this._readableState.readable !== !1 && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
            }
        },
        readableHighWaterMark: {
            __proto__: null,
            enumerable: !1,
            get: function() {
                return this._readableState.highWaterMark;
            }
        },
        readableBuffer: {
            __proto__: null,
            enumerable: !1,
            get: function() {
                return this._readableState && this._readableState.buffer;
            }
        },
        readableFlowing: {
            __proto__: null,
            enumerable: !1,
            get: function() {
                return this._readableState.flowing;
            },
            set: function(t) {
                this._readableState && (this._readableState.flowing = t);
            }
        },
        readableLength: {
            __proto__: null,
            enumerable: !1,
            get () {
                return this._readableState.length;
            }
        },
        readableObjectMode: {
            __proto__: null,
            enumerable: !1,
            get () {
                return this._readableState ? this._readableState.objectMode : !1;
            }
        },
        readableEncoding: {
            __proto__: null,
            enumerable: !1,
            get () {
                return this._readableState ? this._readableState.encoding : null;
            }
        },
        errored: {
            __proto__: null,
            enumerable: !1,
            get () {
                return this._readableState ? this._readableState.errored : null;
            }
        },
        closed: {
            __proto__: null,
            get () {
                return this._readableState ? this._readableState.closed : !1;
            }
        },
        destroyed: {
            __proto__: null,
            enumerable: !1,
            get () {
                return this._readableState ? this._readableState.destroyed : !1;
            },
            set (t) {
                this._readableState && (this._readableState.destroyed = t);
            }
        },
        readableEnded: {
            __proto__: null,
            enumerable: !1,
            get () {
                return this._readableState ? this._readableState.endEmitted : !1;
            }
        }
    });
    Gs(Yi.prototype, {
        pipesCount: {
            __proto__: null,
            get () {
                return this.pipes.length;
            }
        },
        paused: {
            __proto__: null,
            get () {
                return this[xr] !== !1;
            },
            set (t) {
                this[xr] = !!t;
            }
        }
    });
    le._fromList = yd;
    function yd(t, e) {
        if (e.length === 0) return null;
        let r;
        return e.objectMode ? r = e.buffer.shift() : !t || t >= e.length ? (e.decoder ? r = e.buffer.join("") : e.buffer.length === 1 ? r = e.buffer.first() : r = e.buffer.concat(e.length), e.buffer.clear()) : r = e.buffer.consume(t, e.decoder), r;
    }
    function Ws(t) {
        let e = t._readableState;
        he("endReadable", e.endEmitted), e.endEmitted || (e.ended = !0, lt.nextTick(Bv, e, t));
    }
    function Bv(t, e) {
        if (he("endReadableNT", t.endEmitted, t.length), !t.errored && !t.closeEmitted && !t.endEmitted && t.length === 0) {
            if (t.endEmitted = !0, e.emit("end"), e.writable && e.allowHalfOpen === !1) lt.nextTick(Mv, e);
            else if (t.autoDestroy) {
                let r = e._writableState;
                (!r || r.autoDestroy && (r.finished || r.writable === !1)) && e.destroy();
            }
        }
    }
    function Mv(t) {
        t.writable && !t.writableEnded && !t.destroyed && t.end();
    }
    le.from = function(t, e) {
        return pv(le, t, e);
    };
    var $s;
    function gd() {
        return $s === void 0 && ($s = {}), $s;
    }
    le.fromWeb = function(t, e) {
        return gd().newStreamReadableFromReadableStream(t, e);
    };
    le.toWeb = function(t, e) {
        return gd().newReadableStreamFromStreamReadable(t, e);
    };
    le.wrap = function(t, e) {
        var r, n;
        return new le({
            objectMode: (r = (n = t.readableObjectMode) !== null && n !== void 0 ? n : t.objectMode) !== null && r !== void 0 ? r : !0,
            ...e,
            destroy (i, s) {
                nn.destroyer(t, i), s(i);
            }
        }).wrap(t);
    };
});
var $4c2dd1b68d143d96$var$ro = $4c2dd1b68d143d96$var$D((aC, Od)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var Tr = $4c2dd1b68d143d96$var$tr(), { ArrayPrototypeSlice: _d, Error: Nv, FunctionPrototypeSymbolHasInstance: vd, ObjectDefineProperty: Sd, ObjectDefineProperties: qv, ObjectSetPrototypeOf: Ed, StringPrototypeToLowerCase: Lv, Symbol: Uv, SymbolHasInstance: Dv } = $4c2dd1b68d143d96$var$Ee();
    Od.exports = Ie;
    Ie.WritableState = Un;
    var { EventEmitter: jv } = ($4c2dd1b68d143d96$var$er(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$Zt)), qn = $4c2dd1b68d143d96$var$$i().Stream, { Buffer: Xi } = ($4c2dd1b68d143d96$var$ke(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$qe)), to = $4c2dd1b68d143d96$var$Ar(), { addAbortSignal: Fv } = $4c2dd1b68d143d96$var$kn(), { getHighWaterMark: Wv, getDefaultHighWaterMark: $v } = $4c2dd1b68d143d96$var$Cn(), { ERR_INVALID_ARG_TYPE: Hv, ERR_METHOD_NOT_IMPLEMENTED: Vv, ERR_MULTIPLE_CALLBACK: Ad, ERR_STREAM_CANNOT_PIPE: Gv, ERR_STREAM_DESTROYED: Ln, ERR_STREAM_ALREADY_FINISHED: zv, ERR_STREAM_NULL_VALUES: Kv, ERR_STREAM_WRITE_AFTER_END: Qv, ERR_UNKNOWN_ENCODING: Id } = $4c2dd1b68d143d96$var$De().codes, { errorOrDestroy: on } = to;
    Ed(Ie.prototype, qn.prototype);
    Ed(Ie, qn);
    function Qs() {}
    var sn = Uv("kOnFinished");
    function Un(t, e, r) {
        typeof r != "boolean" && (r = e instanceof $4c2dd1b68d143d96$var$St()), this.objectMode = !!(t && t.objectMode), r && (this.objectMode = this.objectMode || !!(t && t.writableObjectMode)), this.highWaterMark = t ? Wv(this, t, "writableHighWaterMark", r) : $v(!1), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
        let n = !!(t && t.decodeStrings === !1);
        this.decodeStrings = !n, this.defaultEncoding = t && t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = Jv.bind(void 0, e), this.writecb = null, this.writelen = 0, this.afterWriteTickInfo = null, eo(this), this.pendingcb = 0, this.constructed = !0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = !t || t.emitClose !== !1, this.autoDestroy = !t || t.autoDestroy !== !1, this.errored = null, this.closed = !1, this.closeEmitted = !1, this[sn] = [];
    }
    function eo(t) {
        t.buffered = [], t.bufferedIndex = 0, t.allBuffers = !0, t.allNoop = !0;
    }
    Un.prototype.getBuffer = function() {
        return _d(this.buffered, this.bufferedIndex);
    };
    Sd(Un.prototype, "bufferedRequestCount", {
        __proto__: null,
        get () {
            return this.buffered.length - this.bufferedIndex;
        }
    });
    function Ie(t) {
        let e = this instanceof $4c2dd1b68d143d96$var$St();
        if (!e && !vd(Ie, this)) return new Ie(t);
        this._writableState = new Un(t, this, e), t && (typeof t.write == "function" && (this._write = t.write), typeof t.writev == "function" && (this._writev = t.writev), typeof t.destroy == "function" && (this._destroy = t.destroy), typeof t.final == "function" && (this._final = t.final), typeof t.construct == "function" && (this._construct = t.construct), t.signal && Fv(t.signal, this)), qn.call(this, t), to.construct(this, ()=>{
            let r = this._writableState;
            r.writing || Js(this, r), Xs(this, r);
        });
    }
    Sd(Ie, Dv, {
        __proto__: null,
        value: function(t) {
            return vd(this, t) ? !0 : this !== Ie ? !1 : t && t._writableState instanceof Un;
        }
    });
    Ie.prototype.pipe = function() {
        on(this, new Gv);
    };
    function xd(t, e, r, n) {
        let i = t._writableState;
        if (typeof r == "function") n = r, r = i.defaultEncoding;
        else {
            if (!r) r = i.defaultEncoding;
            else if (r !== "buffer" && !Xi.isEncoding(r)) throw new Id(r);
            typeof n != "function" && (n = Qs);
        }
        if (e === null) throw new Kv;
        if (!i.objectMode) {
            if (typeof e == "string") i.decodeStrings !== !1 && (e = Xi.from(e, r), r = "buffer");
            else if (e instanceof Xi) r = "buffer";
            else if (qn._isUint8Array(e)) e = qn._uint8ArrayToBuffer(e), r = "buffer";
            else throw new Hv("chunk", [
                "string",
                "Buffer",
                "Uint8Array"
            ], e);
        }
        let s;
        return i.ending ? s = new Qv : i.destroyed && (s = new Ln("write")), s ? (Tr.nextTick(n, s), on(t, s, !0), s) : (i.pendingcb++, Yv(t, i, e, r, n));
    }
    Ie.prototype.write = function(t, e, r) {
        return xd(this, t, e, r) === !0;
    };
    Ie.prototype.cork = function() {
        this._writableState.corked++;
    };
    Ie.prototype.uncork = function() {
        let t = this._writableState;
        t.corked && (t.corked--, t.writing || Js(this, t));
    };
    Ie.prototype.setDefaultEncoding = function(e) {
        if (typeof e == "string" && (e = Lv(e)), !Xi.isEncoding(e)) throw new Id(e);
        return this._writableState.defaultEncoding = e, this;
    };
    function Yv(t, e, r, n, i) {
        let s = e.objectMode ? 1 : r.length;
        e.length += s;
        let o = e.length < e.highWaterMark;
        return o || (e.needDrain = !0), e.writing || e.corked || e.errored || !e.constructed ? (e.buffered.push({
            chunk: r,
            encoding: n,
            callback: i
        }), e.allBuffers && n !== "buffer" && (e.allBuffers = !1), e.allNoop && i !== Qs && (e.allNoop = !1)) : (e.writelen = s, e.writecb = i, e.writing = !0, e.sync = !0, t._write(r, n, e.onwrite), e.sync = !1), o && !e.errored && !e.destroyed;
    }
    function wd(t, e, r, n, i, s, o) {
        e.writelen = n, e.writecb = o, e.writing = !0, e.sync = !0, e.destroyed ? e.onwrite(new Ln("write")) : r ? t._writev(i, e.onwrite) : t._write(i, s, e.onwrite), e.sync = !1;
    }
    function md(t, e, r, n) {
        --e.pendingcb, n(r), Ys(e), on(t, r);
    }
    function Jv(t, e) {
        let r = t._writableState, n = r.sync, i = r.writecb;
        if (typeof i != "function") {
            on(t, new Ad);
            return;
        }
        r.writing = !1, r.writecb = null, r.length -= r.writelen, r.writelen = 0, e ? (e.stack, r.errored || (r.errored = e), t._readableState && !t._readableState.errored && (t._readableState.errored = e), n ? Tr.nextTick(md, t, r, e, i) : md(t, r, e, i)) : (r.buffered.length > r.bufferedIndex && Js(t, r), n ? r.afterWriteTickInfo !== null && r.afterWriteTickInfo.cb === i ? r.afterWriteTickInfo.count++ : (r.afterWriteTickInfo = {
            count: 1,
            cb: i,
            stream: t,
            state: r
        }, Tr.nextTick(Xv, r.afterWriteTickInfo)) : Td(t, r, 1, i));
    }
    function Xv({ stream: t, state: e, count: r, cb: n }) {
        return e.afterWriteTickInfo = null, Td(t, e, r, n);
    }
    function Td(t, e, r, n) {
        for(!e.ending && !t.destroyed && e.length === 0 && e.needDrain && (e.needDrain = !1, t.emit("drain")); r-- > 0;)e.pendingcb--, n();
        e.destroyed && Ys(e), Xs(t, e);
    }
    function Ys(t) {
        if (t.writing) return;
        for(let i = t.bufferedIndex; i < t.buffered.length; ++i){
            var e;
            let { chunk: s, callback: o } = t.buffered[i], a = t.objectMode ? 1 : s.length;
            t.length -= a, o((e = t.errored) !== null && e !== void 0 ? e : new Ln("write"));
        }
        let r = t[sn].splice(0);
        for(let i = 0; i < r.length; i++){
            var n;
            r[i]((n = t.errored) !== null && n !== void 0 ? n : new Ln("end"));
        }
        eo(t);
    }
    function Js(t, e) {
        if (e.corked || e.bufferProcessing || e.destroyed || !e.constructed) return;
        let { buffered: r, bufferedIndex: n, objectMode: i } = e, s = r.length - n;
        if (!s) return;
        let o = n;
        if (e.bufferProcessing = !0, s > 1 && t._writev) {
            e.pendingcb -= s - 1;
            let a = e.allNoop ? Qs : (f)=>{
                for(let h = o; h < r.length; ++h)r[h].callback(f);
            }, c = e.allNoop && o === 0 ? r : _d(r, o);
            c.allBuffers = e.allBuffers, wd(t, e, !0, e.length, c, "", a), eo(e);
        } else {
            do {
                let { chunk: a, encoding: c, callback: f } = r[o];
                r[o++] = null;
                let h = i ? 1 : a.length;
                wd(t, e, !1, h, a, c, f);
            }while (o < r.length && !e.writing);
            o === r.length ? eo(e) : o > 256 ? (r.splice(0, o), e.bufferedIndex = 0) : e.bufferedIndex = o;
        }
        e.bufferProcessing = !1;
    }
    Ie.prototype._write = function(t, e, r) {
        if (this._writev) this._writev([
            {
                chunk: t,
                encoding: e
            }
        ], r);
        else throw new Vv("_write()");
    };
    Ie.prototype._writev = null;
    Ie.prototype.end = function(t, e, r) {
        let n = this._writableState;
        typeof t == "function" ? (r = t, t = null, e = null) : typeof e == "function" && (r = e, e = null);
        let i;
        if (t != null) {
            let s = xd(this, t, e);
            s instanceof Nv && (i = s);
        }
        return n.corked && (n.corked = 1, this.uncork()), i || (!n.errored && !n.ending ? (n.ending = !0, Xs(this, n, !0), n.ended = !0) : n.finished ? i = new zv("end") : n.destroyed && (i = new Ln("end"))), typeof r == "function" && (i || n.finished ? Tr.nextTick(r, i) : n[sn].push(r)), this;
    };
    function Zi(t) {
        return t.ending && !t.destroyed && t.constructed && t.length === 0 && !t.errored && t.buffered.length === 0 && !t.finished && !t.writing && !t.errorEmitted && !t.closeEmitted;
    }
    function Zv(t, e) {
        let r = !1;
        function n(i) {
            if (r) {
                on(t, i ?? Ad());
                return;
            }
            if (r = !0, e.pendingcb--, i) {
                let s = e[sn].splice(0);
                for(let o = 0; o < s.length; o++)s[o](i);
                on(t, i, e.sync);
            } else Zi(e) && (e.prefinished = !0, t.emit("prefinish"), e.pendingcb++, Tr.nextTick(Ks, t, e));
        }
        e.sync = !0, e.pendingcb++;
        try {
            t._final(n);
        } catch (i) {
            n(i);
        }
        e.sync = !1;
    }
    function e0(t, e) {
        !e.prefinished && !e.finalCalled && (typeof t._final == "function" && !e.destroyed ? (e.finalCalled = !0, Zv(t, e)) : (e.prefinished = !0, t.emit("prefinish")));
    }
    function Xs(t, e, r) {
        Zi(e) && (e0(t, e), e.pendingcb === 0 && (r ? (e.pendingcb++, Tr.nextTick((n, i)=>{
            Zi(i) ? Ks(n, i) : i.pendingcb--;
        }, t, e)) : Zi(e) && (e.pendingcb++, Ks(t, e))));
    }
    function Ks(t, e) {
        e.pendingcb--, e.finished = !0;
        let r = e[sn].splice(0);
        for(let n = 0; n < r.length; n++)r[n]();
        if (t.emit("finish"), e.autoDestroy) {
            let n = t._readableState;
            (!n || n.autoDestroy && (n.endEmitted || n.readable === !1)) && t.destroy();
        }
    }
    qv(Ie.prototype, {
        closed: {
            __proto__: null,
            get () {
                return this._writableState ? this._writableState.closed : !1;
            }
        },
        destroyed: {
            __proto__: null,
            get () {
                return this._writableState ? this._writableState.destroyed : !1;
            },
            set (t) {
                this._writableState && (this._writableState.destroyed = t);
            }
        },
        writable: {
            __proto__: null,
            get () {
                let t = this._writableState;
                return !!t && t.writable !== !1 && !t.destroyed && !t.errored && !t.ending && !t.ended;
            },
            set (t) {
                this._writableState && (this._writableState.writable = !!t);
            }
        },
        writableFinished: {
            __proto__: null,
            get () {
                return this._writableState ? this._writableState.finished : !1;
            }
        },
        writableObjectMode: {
            __proto__: null,
            get () {
                return this._writableState ? this._writableState.objectMode : !1;
            }
        },
        writableBuffer: {
            __proto__: null,
            get () {
                return this._writableState && this._writableState.getBuffer();
            }
        },
        writableEnded: {
            __proto__: null,
            get () {
                return this._writableState ? this._writableState.ending : !1;
            }
        },
        writableNeedDrain: {
            __proto__: null,
            get () {
                let t = this._writableState;
                return t ? !t.destroyed && !t.ending && t.needDrain : !1;
            }
        },
        writableHighWaterMark: {
            __proto__: null,
            get () {
                return this._writableState && this._writableState.highWaterMark;
            }
        },
        writableCorked: {
            __proto__: null,
            get () {
                return this._writableState ? this._writableState.corked : 0;
            }
        },
        writableLength: {
            __proto__: null,
            get () {
                return this._writableState && this._writableState.length;
            }
        },
        errored: {
            __proto__: null,
            enumerable: !1,
            get () {
                return this._writableState ? this._writableState.errored : null;
            }
        },
        writableAborted: {
            __proto__: null,
            enumerable: !1,
            get: function() {
                return !!(this._writableState.writable !== !1 && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
            }
        }
    });
    var t0 = to.destroy;
    Ie.prototype.destroy = function(t, e) {
        let r = this._writableState;
        return !r.destroyed && (r.bufferedIndex < r.buffered.length || r[sn].length) && Tr.nextTick(Ys, r), t0.call(this, t, e), this;
    };
    Ie.prototype._undestroy = to.undestroy;
    Ie.prototype._destroy = function(t, e) {
        e(t);
    };
    Ie.prototype[jv.captureRejectionSymbol] = function(t) {
        this.destroy(t);
    };
    var zs;
    function Pd() {
        return zs === void 0 && (zs = {}), zs;
    }
    Ie.fromWeb = function(t, e) {
        return Pd().newStreamWritableFromWritableStream(t, e);
    };
    Ie.toWeb = function(t) {
        return Pd().newWritableStreamFromStreamWritable(t);
    };
});
var $4c2dd1b68d143d96$var$Hd = $4c2dd1b68d143d96$var$D((bC, $d)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var Zs = $4c2dd1b68d143d96$var$tr(), r0 = ($4c2dd1b68d143d96$var$ke(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$qe)), { isReadable: n0, isWritable: i0, isIterable: Rd, isNodeStream: o0, isReadableNodeStream: kd, isWritableNodeStream: Cd, isDuplexNodeStream: s0, isReadableStream: Bd, isWritableStream: Md } = $4c2dd1b68d143d96$var$mt(), Nd = $4c2dd1b68d143d96$var$Ut(), { AbortError: Fd, codes: { ERR_INVALID_ARG_TYPE: a0, ERR_INVALID_RETURN_VALUE: qd } } = $4c2dd1b68d143d96$var$De(), { destroyer: un } = $4c2dd1b68d143d96$var$Ar(), u0 = $4c2dd1b68d143d96$var$St(), Wd = $4c2dd1b68d143d96$var$Nn(), l0 = $4c2dd1b68d143d96$var$ro(), { createDeferredPromise: Ld } = $4c2dd1b68d143d96$var$$e(), Ud = $4c2dd1b68d143d96$var$Us(), Dd = globalThis.Blob || r0.Blob, c0 = typeof Dd < "u" ? function(e) {
        return e instanceof Dd;
    } : function(e) {
        return !1;
    }, f0 = globalThis.AbortController || $4c2dd1b68d143d96$var$Yr().AbortController, { FunctionPrototypeCall: jd } = $4c2dd1b68d143d96$var$Ee(), ir = class extends u0 {
        constructor(e){
            super(e), e?.readable === !1 && (this._readableState.readable = !1, this._readableState.ended = !0, this._readableState.endEmitted = !0), e?.writable === !1 && (this._writableState.writable = !1, this._writableState.ending = !0, this._writableState.ended = !0, this._writableState.finished = !0);
        }
    };
    $d.exports = function t(e, r) {
        if (s0(e)) return e;
        if (kd(e)) return an({
            readable: e
        });
        if (Cd(e)) return an({
            writable: e
        });
        if (o0(e)) return an({
            writable: !1,
            readable: !1
        });
        if (Bd(e)) return an({
            readable: Wd.fromWeb(e)
        });
        if (Md(e)) return an({
            writable: l0.fromWeb(e)
        });
        if (typeof e == "function") {
            let { value: i, write: s, final: o, destroy: a } = h0(e);
            if (Rd(i)) return Ud(ir, i, {
                objectMode: !0,
                write: s,
                final: o,
                destroy: a
            });
            let c = i?.then;
            if (typeof c == "function") {
                let f, h = jd(c, i, (d)=>{
                    if (d != null) throw new qd("nully", "body", d);
                }, (d)=>{
                    un(f, d);
                });
                return f = new ir({
                    objectMode: !0,
                    readable: !1,
                    write: s,
                    final (d) {
                        o(async ()=>{
                            try {
                                await h, Zs.nextTick(d, null);
                            } catch (w) {
                                Zs.nextTick(d, w);
                            }
                        });
                    },
                    destroy: a
                });
            }
            throw new qd("Iterable, AsyncIterable or AsyncFunction", r, i);
        }
        if (c0(e)) return t(e.arrayBuffer());
        if (Rd(e)) return Ud(ir, e, {
            objectMode: !0,
            writable: !1
        });
        if (Bd(e?.readable) && Md(e?.writable)) return ir.fromWeb(e);
        if (typeof e?.writable == "object" || typeof e?.readable == "object") {
            let i = e != null && e.readable ? kd(e?.readable) ? e?.readable : t(e.readable) : void 0, s = e != null && e.writable ? Cd(e?.writable) ? e?.writable : t(e.writable) : void 0;
            return an({
                readable: i,
                writable: s
            });
        }
        let n = e?.then;
        if (typeof n == "function") {
            let i;
            return jd(n, e, (s)=>{
                s != null && i.push(s), i.push(null);
            }, (s)=>{
                un(i, s);
            }), i = new ir({
                objectMode: !0,
                writable: !1,
                read () {}
            });
        }
        throw new a0(r, [
            "Blob",
            "ReadableStream",
            "WritableStream",
            "Stream",
            "Iterable",
            "AsyncIterable",
            "Function",
            "{ readable, writable } pair",
            "Promise"
        ], e);
    };
    function h0(t) {
        let { promise: e, resolve: r } = Ld(), n = new f0, i = n.signal;
        return {
            value: t(async function*() {
                for(;;){
                    let o = e;
                    e = null;
                    let { chunk: a, done: c, cb: f } = await o;
                    if (Zs.nextTick(f), c) return;
                    if (i.aborted) throw new Fd(void 0, {
                        cause: i.reason
                    });
                    ({ promise: e, resolve: r } = Ld()), yield a;
                }
            }(), {
                signal: i
            }),
            write (o, a, c) {
                let f = r;
                r = null, f({
                    chunk: o,
                    done: !1,
                    cb: c
                });
            },
            final (o) {
                let a = r;
                r = null, a({
                    done: !0,
                    cb: o
                });
            },
            destroy (o, a) {
                n.abort(), a(o);
            }
        };
    }
    function an(t) {
        let e = t.readable && typeof t.readable.read != "function" ? Wd.wrap(t.readable) : t.readable, r = t.writable, n = !!n0(e), i = !!i0(r), s, o, a, c, f;
        function h(d) {
            let w = c;
            c = null, w ? w(d) : d && f.destroy(d);
        }
        return f = new ir({
            readableObjectMode: !!(e != null && e.readableObjectMode),
            writableObjectMode: !!(r != null && r.writableObjectMode),
            readable: n,
            writable: i
        }), i && (Nd(r, (d)=>{
            i = !1, d && un(e, d), h(d);
        }), f._write = function(d, w, y) {
            r.write(d, w) ? y() : s = y;
        }, f._final = function(d) {
            r.end(), o = d;
        }, r.on("drain", function() {
            if (s) {
                let d = s;
                s = null, d();
            }
        }), r.on("finish", function() {
            if (o) {
                let d = o;
                o = null, d();
            }
        })), n && (Nd(e, (d)=>{
            n = !1, d && un(e, d), h(d);
        }), e.on("readable", function() {
            if (a) {
                let d = a;
                a = null, d();
            }
        }), e.on("end", function() {
            f.push(null);
        }), f._read = function() {
            for(;;){
                let d = e.read();
                if (d === null) {
                    a = f._read;
                    return;
                }
                if (!f.push(d)) return;
            }
        }), f._destroy = function(d, w) {
            !d && c !== null && (d = new Fd), a = null, s = null, o = null, c === null ? w(d) : (c = w, un(r, d), un(e, d));
        }, f;
    }
});
var $4c2dd1b68d143d96$var$St = $4c2dd1b68d143d96$var$D((TC, zd)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var { ObjectDefineProperties: d0, ObjectGetOwnPropertyDescriptor: Dt, ObjectKeys: p0, ObjectSetPrototypeOf: Vd } = $4c2dd1b68d143d96$var$Ee();
    zd.exports = ct;
    var ra = $4c2dd1b68d143d96$var$Nn(), tt = $4c2dd1b68d143d96$var$ro();
    Vd(ct.prototype, ra.prototype);
    Vd(ct, ra);
    {
        let t = p0(tt.prototype);
        for(let e = 0; e < t.length; e++){
            let r = t[e];
            ct.prototype[r] || (ct.prototype[r] = tt.prototype[r]);
        }
    }
    function ct(t) {
        if (!(this instanceof ct)) return new ct(t);
        ra.call(this, t), tt.call(this, t), t ? (this.allowHalfOpen = t.allowHalfOpen !== !1, t.readable === !1 && (this._readableState.readable = !1, this._readableState.ended = !0, this._readableState.endEmitted = !0), t.writable === !1 && (this._writableState.writable = !1, this._writableState.ending = !0, this._writableState.ended = !0, this._writableState.finished = !0)) : this.allowHalfOpen = !0;
    }
    d0(ct.prototype, {
        writable: {
            __proto__: null,
            ...Dt(tt.prototype, "writable")
        },
        writableHighWaterMark: {
            __proto__: null,
            ...Dt(tt.prototype, "writableHighWaterMark")
        },
        writableObjectMode: {
            __proto__: null,
            ...Dt(tt.prototype, "writableObjectMode")
        },
        writableBuffer: {
            __proto__: null,
            ...Dt(tt.prototype, "writableBuffer")
        },
        writableLength: {
            __proto__: null,
            ...Dt(tt.prototype, "writableLength")
        },
        writableFinished: {
            __proto__: null,
            ...Dt(tt.prototype, "writableFinished")
        },
        writableCorked: {
            __proto__: null,
            ...Dt(tt.prototype, "writableCorked")
        },
        writableEnded: {
            __proto__: null,
            ...Dt(tt.prototype, "writableEnded")
        },
        writableNeedDrain: {
            __proto__: null,
            ...Dt(tt.prototype, "writableNeedDrain")
        },
        destroyed: {
            __proto__: null,
            get () {
                return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
            },
            set (t) {
                this._readableState && this._writableState && (this._readableState.destroyed = t, this._writableState.destroyed = t);
            }
        }
    });
    var ea;
    function Gd() {
        return ea === void 0 && (ea = {}), ea;
    }
    ct.fromWeb = function(t, e) {
        return Gd().newStreamDuplexFromReadableWritablePair(t, e);
    };
    ct.toWeb = function(t) {
        return Gd().newReadableWritablePairFromDuplex(t);
    };
    var ta;
    ct.from = function(t) {
        return ta || (ta = $4c2dd1b68d143d96$var$Hd()), ta(t, "body");
    };
});
var $4c2dd1b68d143d96$var$oa = $4c2dd1b68d143d96$var$D((LC, Qd)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var { ObjectSetPrototypeOf: Kd, Symbol: y0 } = $4c2dd1b68d143d96$var$Ee();
    Qd.exports = jt;
    var { ERR_METHOD_NOT_IMPLEMENTED: g0 } = $4c2dd1b68d143d96$var$De().codes, ia = $4c2dd1b68d143d96$var$St(), { getHighWaterMark: b0 } = $4c2dd1b68d143d96$var$Cn();
    Kd(jt.prototype, ia.prototype);
    Kd(jt, ia);
    var Dn = y0("kCallback");
    function jt(t) {
        if (!(this instanceof jt)) return new jt(t);
        let e = t ? b0(this, t, "readableHighWaterMark", !0) : null;
        e === 0 && (t = {
            ...t,
            highWaterMark: null,
            readableHighWaterMark: e,
            writableHighWaterMark: t.writableHighWaterMark || 0
        }), ia.call(this, t), this._readableState.sync = !1, this[Dn] = null, t && (typeof t.transform == "function" && (this._transform = t.transform), typeof t.flush == "function" && (this._flush = t.flush)), this.on("prefinish", w0);
    }
    function na(t) {
        typeof this._flush == "function" && !this.destroyed ? this._flush((e, r)=>{
            if (e) {
                t ? t(e) : this.destroy(e);
                return;
            }
            r != null && this.push(r), this.push(null), t && t();
        }) : (this.push(null), t && t());
    }
    function w0() {
        this._final !== na && na.call(this);
    }
    jt.prototype._final = na;
    jt.prototype._transform = function(t, e, r) {
        throw new g0("_transform()");
    };
    jt.prototype._write = function(t, e, r) {
        let n = this._readableState, i = this._writableState, s = n.length;
        this._transform(t, e, (o, a)=>{
            if (o) {
                r(o);
                return;
            }
            a != null && this.push(a), i.ended || s === n.length || n.length < n.highWaterMark ? r() : this[Dn] = r;
        });
    };
    jt.prototype._read = function() {
        if (this[Dn]) {
            let t = this[Dn];
            this[Dn] = null, t();
        }
    };
});
var $4c2dd1b68d143d96$var$aa = $4c2dd1b68d143d96$var$D((zC, Jd)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var { ObjectSetPrototypeOf: Yd } = $4c2dd1b68d143d96$var$Ee();
    Jd.exports = ln;
    var sa = $4c2dd1b68d143d96$var$oa();
    Yd(ln.prototype, sa.prototype);
    Yd(ln, sa);
    function ln(t) {
        if (!(this instanceof ln)) return new ln(t);
        sa.call(this, t);
    }
    ln.prototype._transform = function(t, e, r) {
        r(null, t);
    };
});
var $4c2dd1b68d143d96$var$so = $4c2dd1b68d143d96$var$D((nB, rp)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var jn = $4c2dd1b68d143d96$var$tr(), { ArrayIsArray: m0, Promise: _0, SymbolAsyncIterator: v0, SymbolDispose: S0 } = $4c2dd1b68d143d96$var$Ee(), oo = $4c2dd1b68d143d96$var$Ut(), { once: E0 } = $4c2dd1b68d143d96$var$$e(), A0 = $4c2dd1b68d143d96$var$Ar(), Xd = $4c2dd1b68d143d96$var$St(), { aggregateTwoErrors: I0, codes: { ERR_INVALID_ARG_TYPE: ga, ERR_INVALID_RETURN_VALUE: ua, ERR_MISSING_ARGS: x0, ERR_STREAM_DESTROYED: T0, ERR_STREAM_PREMATURE_CLOSE: P0 }, AbortError: O0 } = $4c2dd1b68d143d96$var$De(), { validateFunction: R0, validateAbortSignal: k0 } = $4c2dd1b68d143d96$var$Xr(), { isIterable: Pr, isReadable: la, isReadableNodeStream: io, isNodeStream: Zd, isTransformStream: cn, isWebStream: C0, isReadableStream: ca, isReadableFinished: B0 } = $4c2dd1b68d143d96$var$mt(), M0 = globalThis.AbortController || $4c2dd1b68d143d96$var$Yr().AbortController, fa, ha, da;
    function ep(t, e, r) {
        let n = !1;
        t.on("close", ()=>{
            n = !0;
        });
        let i = oo(t, {
            readable: e,
            writable: r
        }, (s)=>{
            n = !s;
        });
        return {
            destroy: (s)=>{
                n || (n = !0, A0.destroyer(t, s || new T0("pipe")));
            },
            cleanup: i
        };
    }
    function N0(t) {
        return R0(t[t.length - 1], "streams[stream.length - 1]"), t.pop();
    }
    function pa(t) {
        if (Pr(t)) return t;
        if (io(t)) return q0(t);
        throw new ga("val", [
            "Readable",
            "Iterable",
            "AsyncIterable"
        ], t);
    }
    async function* q0(t) {
        ha || (ha = $4c2dd1b68d143d96$var$Nn()), yield* ha.prototype[v0].call(t);
    }
    async function no(t, e, r, { end: n }) {
        let i, s = null, o = (f)=>{
            if (f && (i = f), s) {
                let h = s;
                s = null, h();
            }
        }, a = ()=>new _0((f, h)=>{
                i ? h(i) : s = ()=>{
                    i ? h(i) : f();
                };
            });
        e.on("drain", o);
        let c = oo(e, {
            readable: !1
        }, o);
        try {
            e.writableNeedDrain && await a();
            for await (let f of t)e.write(f) || await a();
            n && (e.end(), await a()), r();
        } catch (f) {
            r(i !== f ? I0(i, f) : f);
        } finally{
            c(), e.off("drain", o);
        }
    }
    async function ya(t, e, r, { end: n }) {
        cn(e) && (e = e.writable);
        let i = e.getWriter();
        try {
            for await (let s of t)await i.ready, i.write(s).catch(()=>{});
            await i.ready, n && await i.close(), r();
        } catch (s) {
            try {
                await i.abort(s), r(s);
            } catch (o) {
                r(o);
            }
        }
    }
    function L0(...t) {
        return tp(t, E0(N0(t)));
    }
    function tp(t, e, r) {
        if (t.length === 1 && m0(t[0]) && (t = t[0]), t.length < 2) throw new x0("streams");
        let n = new M0, i = n.signal, s = r?.signal, o = [];
        k0(s, "options.signal");
        function a() {
            P(new O0);
        }
        da = da || $4c2dd1b68d143d96$var$$e().addAbortListener;
        let c;
        s && (c = da(s, a));
        let f, h, d = [], w = 0;
        function y(R) {
            P(R, --w === 0);
        }
        function P(R, T) {
            var g;
            if (R && (!f || f.code === "ERR_STREAM_PREMATURE_CLOSE") && (f = R), !(!f && !T)) {
                for(; d.length;)d.shift()(f);
                (g = c) === null || g === void 0 || g[S0](), n.abort(), T && (f || o.forEach((O)=>O()), jn.nextTick(e, f, h));
            }
        }
        let E;
        for(let R = 0; R < t.length; R++){
            let T = t[R], g = R < t.length - 1, O = R > 0, _ = g || r?.end !== !1, q = R === t.length - 1;
            if (Zd(T)) {
                let $ = function(j) {
                    j && j.name !== "AbortError" && j.code !== "ERR_STREAM_PREMATURE_CLOSE" && y(j);
                };
                var v = $;
                if (_) {
                    let { destroy: j, cleanup: J } = ep(T, g, O);
                    d.push(j), la(T) && q && o.push(J);
                }
                T.on("error", $), la(T) && q && o.push(()=>{
                    T.removeListener("error", $);
                });
            }
            if (R === 0) {
                if (typeof T == "function") {
                    if (E = T({
                        signal: i
                    }), !Pr(E)) throw new ua("Iterable, AsyncIterable or Stream", "source", E);
                } else Pr(T) || io(T) || cn(T) ? E = T : E = Xd.from(T);
            } else if (typeof T == "function") {
                if (cn(E)) {
                    var b;
                    E = pa((b = E) === null || b === void 0 ? void 0 : b.readable);
                } else E = pa(E);
                if (E = T(E, {
                    signal: i
                }), g) {
                    if (!Pr(E, !0)) throw new ua("AsyncIterable", `transform[${R - 1}]`, E);
                } else {
                    var m;
                    fa || (fa = $4c2dd1b68d143d96$var$aa());
                    let $ = new fa({
                        objectMode: !0
                    }), j = (m = E) === null || m === void 0 ? void 0 : m.then;
                    if (typeof j == "function") w++, j.call(E, (H)=>{
                        h = H, H != null && $.write(H), _ && $.end(), jn.nextTick(y);
                    }, (H)=>{
                        $.destroy(H), jn.nextTick(y, H);
                    });
                    else if (Pr(E, !0)) w++, no(E, $, y, {
                        end: _
                    });
                    else if (ca(E) || cn(E)) {
                        let H = E.readable || E;
                        w++, no(H, $, y, {
                            end: _
                        });
                    } else throw new ua("AsyncIterable or Promise", "destination", E);
                    E = $;
                    let { destroy: J, cleanup: W } = ep(E, !1, !0);
                    d.push(J), q && o.push(W);
                }
            } else if (Zd(T)) {
                if (io(E)) {
                    w += 2;
                    let $ = U0(E, T, y, {
                        end: _
                    });
                    la(T) && q && o.push($);
                } else if (cn(E) || ca(E)) {
                    let $ = E.readable || E;
                    w++, no($, T, y, {
                        end: _
                    });
                } else if (Pr(E)) w++, no(E, T, y, {
                    end: _
                });
                else throw new ga("val", [
                    "Readable",
                    "Iterable",
                    "AsyncIterable",
                    "ReadableStream",
                    "TransformStream"
                ], E);
                E = T;
            } else if (C0(T)) {
                if (io(E)) w++, ya(pa(E), T, y, {
                    end: _
                });
                else if (ca(E) || Pr(E)) w++, ya(E, T, y, {
                    end: _
                });
                else if (cn(E)) w++, ya(E.readable, T, y, {
                    end: _
                });
                else throw new ga("val", [
                    "Readable",
                    "Iterable",
                    "AsyncIterable",
                    "ReadableStream",
                    "TransformStream"
                ], E);
                E = T;
            } else E = Xd.from(T);
        }
        return (i != null && i.aborted || s != null && s.aborted) && jn.nextTick(a), E;
    }
    function U0(t, e, r, { end: n }) {
        let i = !1;
        if (e.on("close", ()=>{
            i || r(new P0);
        }), t.pipe(e, {
            end: !1
        }), n) {
            let o = function() {
                i = !0, e.end();
            };
            var s = o;
            B0(t) ? jn.nextTick(o) : t.once("end", o);
        } else r();
        return oo(t, {
            readable: !0,
            writable: !1
        }, (o)=>{
            let a = t._readableState;
            o && o.code === "ERR_STREAM_PREMATURE_CLOSE" && a && a.ended && !a.errored && !a.errorEmitted ? t.once("end", r).once("error", r) : r(o);
        }), oo(e, {
            readable: !1,
            writable: !0
        }, r);
    }
    rp.exports = {
        pipelineImpl: tp,
        pipeline: L0
    };
});
var $4c2dd1b68d143d96$var$wa = $4c2dd1b68d143d96$var$D((dB, up)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var { pipeline: D0 } = $4c2dd1b68d143d96$var$so(), ao = $4c2dd1b68d143d96$var$St(), { destroyer: j0 } = $4c2dd1b68d143d96$var$Ar(), { isNodeStream: uo, isReadable: np, isWritable: ip, isWebStream: ba, isTransformStream: Or, isWritableStream: op, isReadableStream: sp } = $4c2dd1b68d143d96$var$mt(), { AbortError: F0, codes: { ERR_INVALID_ARG_VALUE: ap, ERR_MISSING_ARGS: W0 } } = $4c2dd1b68d143d96$var$De(), $0 = $4c2dd1b68d143d96$var$Ut();
    up.exports = function(...e) {
        if (e.length === 0) throw new W0("streams");
        if (e.length === 1) return ao.from(e[0]);
        let r = [
            ...e
        ];
        if (typeof e[0] == "function" && (e[0] = ao.from(e[0])), typeof e[e.length - 1] == "function") {
            let y = e.length - 1;
            e[y] = ao.from(e[y]);
        }
        for(let y = 0; y < e.length; ++y)if (!(!uo(e[y]) && !ba(e[y]))) {
            if (y < e.length - 1 && !(np(e[y]) || sp(e[y]) || Or(e[y]))) throw new ap(`streams[${y}]`, r[y], "must be readable");
            if (y > 0 && !(ip(e[y]) || op(e[y]) || Or(e[y]))) throw new ap(`streams[${y}]`, r[y], "must be writable");
        }
        let n, i, s, o, a;
        function c(y) {
            let P = o;
            o = null, P ? P(y) : y ? a.destroy(y) : !w && !d && a.destroy();
        }
        let f = e[0], h = D0(e, c), d = !!(ip(f) || op(f) || Or(f)), w = !!(np(h) || sp(h) || Or(h));
        if (a = new ao({
            writableObjectMode: !!(f != null && f.writableObjectMode),
            readableObjectMode: !!(h != null && h.readableObjectMode),
            writable: d,
            readable: w
        }), d) {
            if (uo(f)) a._write = function(P, E, b) {
                f.write(P, E) ? b() : n = b;
            }, a._final = function(P) {
                f.end(), i = P;
            }, f.on("drain", function() {
                if (n) {
                    let P = n;
                    n = null, P();
                }
            });
            else if (ba(f)) {
                let E = (Or(f) ? f.writable : f).getWriter();
                a._write = async function(b, m, v) {
                    try {
                        await E.ready, E.write(b).catch(()=>{}), v();
                    } catch (R) {
                        v(R);
                    }
                }, a._final = async function(b) {
                    try {
                        await E.ready, E.close().catch(()=>{}), i = b;
                    } catch (m) {
                        b(m);
                    }
                };
            }
            let y = Or(h) ? h.readable : h;
            $0(y, ()=>{
                if (i) {
                    let P = i;
                    i = null, P();
                }
            });
        }
        if (w) {
            if (uo(h)) h.on("readable", function() {
                if (s) {
                    let y = s;
                    s = null, y();
                }
            }), h.on("end", function() {
                a.push(null);
            }), a._read = function() {
                for(;;){
                    let y = h.read();
                    if (y === null) {
                        s = a._read;
                        return;
                    }
                    if (!a.push(y)) return;
                }
            };
            else if (ba(h)) {
                let P = (Or(h) ? h.readable : h).getReader();
                a._read = async function() {
                    for(;;)try {
                        let { value: E, done: b } = await P.read();
                        if (!a.push(E)) return;
                        if (b) {
                            a.push(null);
                            return;
                        }
                    } catch  {
                        return;
                    }
                };
            }
        }
        return a._destroy = function(y, P) {
            !y && o !== null && (y = new F0), s = null, n = null, i = null, o === null ? P(y) : (o = P, uo(h) && j0(h, y));
        }, a;
    };
});
var $4c2dd1b68d143d96$var$wp = $4c2dd1b68d143d96$var$D((EB, va)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var H0 = globalThis.AbortController || $4c2dd1b68d143d96$var$Yr().AbortController, { codes: { ERR_INVALID_ARG_VALUE: V0, ERR_INVALID_ARG_TYPE: Fn, ERR_MISSING_ARGS: G0, ERR_OUT_OF_RANGE: z0 }, AbortError: Et } = $4c2dd1b68d143d96$var$De(), { validateAbortSignal: Rr, validateInteger: lp, validateObject: kr } = $4c2dd1b68d143d96$var$Xr(), K0 = $4c2dd1b68d143d96$var$Ee().Symbol("kWeak"), Q0 = $4c2dd1b68d143d96$var$Ee().Symbol("kResistStopPropagation"), { finished: Y0 } = $4c2dd1b68d143d96$var$Ut(), J0 = $4c2dd1b68d143d96$var$wa(), { addAbortSignalNoValidate: X0 } = $4c2dd1b68d143d96$var$kn(), { isWritable: Z0, isNodeStream: eS } = $4c2dd1b68d143d96$var$mt(), { deprecate: tS } = $4c2dd1b68d143d96$var$$e(), { ArrayPrototypePush: rS, Boolean: nS, MathFloor: cp, Number: iS, NumberIsNaN: oS, Promise: fp, PromiseReject: hp, PromiseResolve: sS, PromisePrototypeThen: dp, Symbol: yp } = $4c2dd1b68d143d96$var$Ee(), lo = yp("kEmpty"), pp = yp("kEof");
    function aS(t, e) {
        if (e != null && kr(e, "options"), e?.signal != null && Rr(e.signal, "options.signal"), eS(t) && !Z0(t)) throw new V0("stream", t, "must be writable");
        let r = J0(this, t);
        return e != null && e.signal && X0(e.signal, r), r;
    }
    function co(t, e) {
        if (typeof t != "function") throw new Fn("fn", [
            "Function",
            "AsyncFunction"
        ], t);
        e != null && kr(e, "options"), e?.signal != null && Rr(e.signal, "options.signal");
        let r = 1;
        e?.concurrency != null && (r = cp(e.concurrency));
        let n = r - 1;
        return e?.highWaterMark != null && (n = cp(e.highWaterMark)), lp(r, "options.concurrency", 1), lp(n, "options.highWaterMark", 0), n += r, (async function*() {
            let s = $4c2dd1b68d143d96$var$$e().AbortSignalAny([
                e?.signal
            ].filter(nS)), o = this, a = [], c = {
                signal: s
            }, f, h, d = !1, w = 0;
            function y() {
                d = !0, P();
            }
            function P() {
                w -= 1, E();
            }
            function E() {
                h && !d && w < r && a.length < n && (h(), h = null);
            }
            async function b() {
                try {
                    for await (let m of o){
                        if (d) return;
                        if (s.aborted) throw new Et;
                        try {
                            if (m = t(m, c), m === lo) continue;
                            m = sS(m);
                        } catch (v) {
                            m = hp(v);
                        }
                        w += 1, dp(m, P, y), a.push(m), f && (f(), f = null), !d && (a.length >= n || w >= r) && await new fp((v)=>{
                            h = v;
                        });
                    }
                    a.push(pp);
                } catch (m) {
                    let v = hp(m);
                    dp(v, P, y), a.push(v);
                } finally{
                    d = !0, f && (f(), f = null);
                }
            }
            b();
            try {
                for(;;){
                    for(; a.length > 0;){
                        let m = await a[0];
                        if (m === pp) return;
                        if (s.aborted) throw new Et;
                        m !== lo && (yield m), a.shift(), E();
                    }
                    await new fp((m)=>{
                        f = m;
                    });
                }
            } finally{
                d = !0, h && (h(), h = null);
            }
        }).call(this);
    }
    function uS(t) {
        return t != null && kr(t, "options"), t?.signal != null && Rr(t.signal, "options.signal"), (async function*() {
            let r = 0;
            for await (let i of this){
                var n;
                if (t != null && (n = t.signal) !== null && n !== void 0 && n.aborted) throw new Et({
                    cause: t.signal.reason
                });
                yield [
                    r++,
                    i
                ];
            }
        }).call(this);
    }
    async function gp(t, e) {
        for await (let r of _a.call(this, t, e))return !0;
        return !1;
    }
    async function lS(t, e) {
        if (typeof t != "function") throw new Fn("fn", [
            "Function",
            "AsyncFunction"
        ], t);
        return !await gp.call(this, async (...r)=>!await t(...r), e);
    }
    async function cS(t, e) {
        for await (let r of _a.call(this, t, e))return r;
    }
    async function fS(t, e) {
        if (typeof t != "function") throw new Fn("fn", [
            "Function",
            "AsyncFunction"
        ], t);
        async function r(n, i) {
            return await t(n, i), lo;
        }
        for await (let n of co.call(this, r, e));
    }
    function _a(t, e) {
        if (typeof t != "function") throw new Fn("fn", [
            "Function",
            "AsyncFunction"
        ], t);
        async function r(n, i) {
            return await t(n, i) ? n : lo;
        }
        return co.call(this, r, e);
    }
    var ma = class extends G0 {
        constructor(){
            super("reduce"), this.message = "Reduce of an empty stream requires an initial value";
        }
    };
    async function hS(t, e, r) {
        var n;
        if (typeof t != "function") throw new Fn("reducer", [
            "Function",
            "AsyncFunction"
        ], t);
        r != null && kr(r, "options"), r?.signal != null && Rr(r.signal, "options.signal");
        let i = arguments.length > 1;
        if (r != null && (n = r.signal) !== null && n !== void 0 && n.aborted) {
            let f = new Et(void 0, {
                cause: r.signal.reason
            });
            throw this.once("error", ()=>{}), await Y0(this.destroy(f)), f;
        }
        let s = new H0, o = s.signal;
        if (r != null && r.signal) {
            let f = {
                once: !0,
                [K0]: this,
                [Q0]: !0
            };
            r.signal.addEventListener("abort", ()=>s.abort(), f);
        }
        let a = !1;
        try {
            for await (let f of this){
                var c;
                if (a = !0, r != null && (c = r.signal) !== null && c !== void 0 && c.aborted) throw new Et;
                i ? e = await t(e, f, {
                    signal: o
                }) : (e = f, i = !0);
            }
            if (!a && !i) throw new ma;
        } finally{
            s.abort();
        }
        return e;
    }
    async function dS(t) {
        t != null && kr(t, "options"), t?.signal != null && Rr(t.signal, "options.signal");
        let e = [];
        for await (let n of this){
            var r;
            if (t != null && (r = t.signal) !== null && r !== void 0 && r.aborted) throw new Et(void 0, {
                cause: t.signal.reason
            });
            rS(e, n);
        }
        return e;
    }
    function pS(t, e) {
        let r = co.call(this, t, e);
        return (async function*() {
            for await (let i of r)yield* i;
        }).call(this);
    }
    function bp(t) {
        if (t = iS(t), oS(t)) return 0;
        if (t < 0) throw new z0("number", ">= 0", t);
        return t;
    }
    function yS(t, e) {
        return e != null && kr(e, "options"), e?.signal != null && Rr(e.signal, "options.signal"), t = bp(t), (async function*() {
            var n;
            if (e != null && (n = e.signal) !== null && n !== void 0 && n.aborted) throw new Et;
            for await (let s of this){
                var i;
                if (e != null && (i = e.signal) !== null && i !== void 0 && i.aborted) throw new Et;
                t-- <= 0 && (yield s);
            }
        }).call(this);
    }
    function gS(t, e) {
        return e != null && kr(e, "options"), e?.signal != null && Rr(e.signal, "options.signal"), t = bp(t), (async function*() {
            var n;
            if (e != null && (n = e.signal) !== null && n !== void 0 && n.aborted) throw new Et;
            for await (let s of this){
                var i;
                if (e != null && (i = e.signal) !== null && i !== void 0 && i.aborted) throw new Et;
                if (t-- > 0 && (yield s), t <= 0) return;
            }
        }).call(this);
    }
    va.exports.streamReturningOperators = {
        asIndexedPairs: tS(uS, "readable.asIndexedPairs will be removed in a future version."),
        drop: yS,
        filter: _a,
        flatMap: pS,
        map: co,
        take: gS,
        compose: aS
    };
    va.exports.promiseReturningOperators = {
        every: lS,
        forEach: fS,
        reduce: hS,
        toArray: dS,
        some: gp,
        find: cS
    };
});
var $4c2dd1b68d143d96$var$Sa = $4c2dd1b68d143d96$var$D((BB, mp)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var { ArrayPrototypePop: bS, Promise: wS } = $4c2dd1b68d143d96$var$Ee(), { isIterable: mS, isNodeStream: _S, isWebStream: vS } = $4c2dd1b68d143d96$var$mt(), { pipelineImpl: SS } = $4c2dd1b68d143d96$var$so(), { finished: ES } = $4c2dd1b68d143d96$var$Ut();
    $4c2dd1b68d143d96$var$Ea();
    function AS(...t) {
        return new wS((e, r)=>{
            let n, i, s = t[t.length - 1];
            if (s && typeof s == "object" && !_S(s) && !mS(s) && !vS(s)) {
                let o = bS(t);
                n = o.signal, i = o.end;
            }
            SS(t, (o, a)=>{
                o ? r(o) : e(a);
            }, {
                signal: n,
                end: i
            });
        });
    }
    mp.exports = {
        finished: ES,
        pipeline: AS
    };
});
var $4c2dd1b68d143d96$var$Ea = $4c2dd1b68d143d96$var$D(($B, Pp)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var { Buffer: IS } = ($4c2dd1b68d143d96$var$ke(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$qe)), { ObjectDefineProperty: Ft, ObjectKeys: Sp, ReflectApply: Ep } = $4c2dd1b68d143d96$var$Ee(), { promisify: { custom: Ap } } = $4c2dd1b68d143d96$var$$e(), { streamReturningOperators: _p, promiseReturningOperators: vp } = $4c2dd1b68d143d96$var$wp(), { codes: { ERR_ILLEGAL_CONSTRUCTOR: Ip } } = $4c2dd1b68d143d96$var$De(), xS = $4c2dd1b68d143d96$var$wa(), { setDefaultHighWaterMark: TS, getDefaultHighWaterMark: PS } = $4c2dd1b68d143d96$var$Cn(), { pipeline: xp } = $4c2dd1b68d143d96$var$so(), { destroyer: OS } = $4c2dd1b68d143d96$var$Ar(), Tp = $4c2dd1b68d143d96$var$Ut(), Aa = $4c2dd1b68d143d96$var$Sa(), Wn = $4c2dd1b68d143d96$var$mt(), Se = Pp.exports = $4c2dd1b68d143d96$var$$i().Stream;
    Se.isDestroyed = Wn.isDestroyed;
    Se.isDisturbed = Wn.isDisturbed;
    Se.isErrored = Wn.isErrored;
    Se.isReadable = Wn.isReadable;
    Se.isWritable = Wn.isWritable;
    Se.Readable = $4c2dd1b68d143d96$var$Nn();
    for (let t of Sp(_p)){
        let r = function(...n) {
            if (new.target) throw Ip();
            return Se.Readable.from(Ep(e, this, n));
        }, e = _p[t];
        Ft(r, "name", {
            __proto__: null,
            value: e.name
        }), Ft(r, "length", {
            __proto__: null,
            value: e.length
        }), Ft(Se.Readable.prototype, t, {
            __proto__: null,
            value: r,
            enumerable: !1,
            configurable: !0,
            writable: !0
        });
    }
    for (let t of Sp(vp)){
        let r = function(...n) {
            if (new.target) throw Ip();
            return Ep(e, this, n);
        }, e = vp[t];
        Ft(r, "name", {
            __proto__: null,
            value: e.name
        }), Ft(r, "length", {
            __proto__: null,
            value: e.length
        }), Ft(Se.Readable.prototype, t, {
            __proto__: null,
            value: r,
            enumerable: !1,
            configurable: !0,
            writable: !0
        });
    }
    Se.Writable = $4c2dd1b68d143d96$var$ro();
    Se.Duplex = $4c2dd1b68d143d96$var$St();
    Se.Transform = $4c2dd1b68d143d96$var$oa();
    Se.PassThrough = $4c2dd1b68d143d96$var$aa();
    Se.pipeline = xp;
    var { addAbortSignal: RS } = $4c2dd1b68d143d96$var$kn();
    Se.addAbortSignal = RS;
    Se.finished = Tp;
    Se.destroy = OS;
    Se.compose = xS;
    Se.setDefaultHighWaterMark = TS;
    Se.getDefaultHighWaterMark = PS;
    Ft(Se, "promises", {
        __proto__: null,
        configurable: !0,
        enumerable: !0,
        get () {
            return Aa;
        }
    });
    Ft(xp, Ap, {
        __proto__: null,
        enumerable: !0,
        get () {
            return Aa.pipeline;
        }
    });
    Ft(Tp, Ap, {
        __proto__: null,
        enumerable: !0,
        get () {
            return Aa.finished;
        }
    });
    Se.Stream = Se;
    Se._isUint8Array = function(e) {
        return e instanceof Uint8Array;
    };
    Se._uint8ArrayToBuffer = function(e) {
        return IS.from(e.buffer, e.byteOffset, e.byteLength);
    };
});
var $4c2dd1b68d143d96$var$or = $4c2dd1b68d143d96$var$D((ZB, Pe)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var Be = $4c2dd1b68d143d96$var$Ea(), kS = $4c2dd1b68d143d96$var$Sa(), CS = Be.Readable.destroy;
    Pe.exports = Be.Readable;
    Pe.exports._uint8ArrayToBuffer = Be._uint8ArrayToBuffer;
    Pe.exports._isUint8Array = Be._isUint8Array;
    Pe.exports.isDisturbed = Be.isDisturbed;
    Pe.exports.isErrored = Be.isErrored;
    Pe.exports.isReadable = Be.isReadable;
    Pe.exports.Readable = Be.Readable;
    Pe.exports.Writable = Be.Writable;
    Pe.exports.Duplex = Be.Duplex;
    Pe.exports.Transform = Be.Transform;
    Pe.exports.PassThrough = Be.PassThrough;
    Pe.exports.addAbortSignal = Be.addAbortSignal;
    Pe.exports.finished = Be.finished;
    Pe.exports.destroy = Be.destroy;
    Pe.exports.destroy = CS;
    Pe.exports.pipeline = Be.pipeline;
    Pe.exports.compose = Be.compose;
    Object.defineProperty(Be, "promises", {
        configurable: !0,
        enumerable: !0,
        get () {
            return kS;
        }
    });
    Pe.exports.Stream = Be.Stream;
    Pe.exports.default = Pe.exports;
});
var $4c2dd1b68d143d96$var$Op = $4c2dd1b68d143d96$var$D((lM, Ia)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    typeof Object.create == "function" ? Ia.exports = function(e, r) {
        r && (e.super_ = r, e.prototype = Object.create(r.prototype, {
            constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }));
    } : Ia.exports = function(e, r) {
        if (r) {
            e.super_ = r;
            var n = function() {};
            n.prototype = r.prototype, e.prototype = new n, e.prototype.constructor = e;
        }
    };
});
var $4c2dd1b68d143d96$var$Cp = $4c2dd1b68d143d96$var$D((mM, kp)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var { Buffer: ft } = ($4c2dd1b68d143d96$var$ke(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$qe)), Rp = Symbol.for("BufferList");
    function we(t) {
        if (!(this instanceof we)) return new we(t);
        we._init.call(this, t);
    }
    we._init = function(e) {
        Object.defineProperty(this, Rp, {
            value: !0
        }), this._bufs = [], this.length = 0, e && this.append(e);
    };
    we.prototype._new = function(e) {
        return new we(e);
    };
    we.prototype._offset = function(e) {
        if (e === 0) return [
            0,
            0
        ];
        let r = 0;
        for(let n = 0; n < this._bufs.length; n++){
            let i = r + this._bufs[n].length;
            if (e < i || n === this._bufs.length - 1) return [
                n,
                e - r
            ];
            r = i;
        }
    };
    we.prototype._reverseOffset = function(t) {
        let e = t[0], r = t[1];
        for(let n = 0; n < e; n++)r += this._bufs[n].length;
        return r;
    };
    we.prototype.getBuffers = function() {
        return this._bufs;
    };
    we.prototype.get = function(e) {
        if (e > this.length || e < 0) return;
        let r = this._offset(e);
        return this._bufs[r[0]][r[1]];
    };
    we.prototype.slice = function(e, r) {
        return typeof e == "number" && e < 0 && (e += this.length), typeof r == "number" && r < 0 && (r += this.length), this.copy(null, 0, e, r);
    };
    we.prototype.copy = function(e, r, n, i) {
        if ((typeof n != "number" || n < 0) && (n = 0), (typeof i != "number" || i > this.length) && (i = this.length), n >= this.length || i <= 0) return e || ft.alloc(0);
        let s = !!e, o = this._offset(n), a = i - n, c = a, f = s && r || 0, h = o[1];
        if (n === 0 && i === this.length) {
            if (!s) return this._bufs.length === 1 ? this._bufs[0] : ft.concat(this._bufs, this.length);
            for(let d = 0; d < this._bufs.length; d++)this._bufs[d].copy(e, f), f += this._bufs[d].length;
            return e;
        }
        if (c <= this._bufs[o[0]].length - h) return s ? this._bufs[o[0]].copy(e, r, h, h + c) : this._bufs[o[0]].slice(h, h + c);
        s || (e = ft.allocUnsafe(a));
        for(let d = o[0]; d < this._bufs.length; d++){
            let w = this._bufs[d].length - h;
            if (c > w) this._bufs[d].copy(e, f, h), f += w;
            else {
                this._bufs[d].copy(e, f, h, h + c), f += w;
                break;
            }
            c -= w, h && (h = 0);
        }
        return e.length > f ? e.slice(0, f) : e;
    };
    we.prototype.shallowSlice = function(e, r) {
        if (e = e || 0, r = typeof r != "number" ? this.length : r, e < 0 && (e += this.length), r < 0 && (r += this.length), e === r) return this._new();
        let n = this._offset(e), i = this._offset(r), s = this._bufs.slice(n[0], i[0] + 1);
        return i[1] === 0 ? s.pop() : s[s.length - 1] = s[s.length - 1].slice(0, i[1]), n[1] !== 0 && (s[0] = s[0].slice(n[1])), this._new(s);
    };
    we.prototype.toString = function(e, r, n) {
        return this.slice(r, n).toString(e);
    };
    we.prototype.consume = function(e) {
        if (e = Math.trunc(e), Number.isNaN(e) || e <= 0) return this;
        for(; this._bufs.length;)if (e >= this._bufs[0].length) e -= this._bufs[0].length, this.length -= this._bufs[0].length, this._bufs.shift();
        else {
            this._bufs[0] = this._bufs[0].slice(e), this.length -= e;
            break;
        }
        return this;
    };
    we.prototype.duplicate = function() {
        let e = this._new();
        for(let r = 0; r < this._bufs.length; r++)e.append(this._bufs[r]);
        return e;
    };
    we.prototype.append = function(e) {
        return this._attach(e, we.prototype._appendBuffer);
    };
    we.prototype.prepend = function(e) {
        return this._attach(e, we.prototype._prependBuffer, !0);
    };
    we.prototype._attach = function(e, r, n) {
        if (e == null) return this;
        if (e.buffer) r.call(this, ft.from(e.buffer, e.byteOffset, e.byteLength));
        else if (Array.isArray(e)) {
            let [i, s] = n ? [
                e.length - 1,
                -1
            ] : [
                0,
                1
            ];
            for(let o = i; o >= 0 && o < e.length; o += s)this._attach(e[o], r, n);
        } else if (this._isBufferList(e)) {
            let [i, s] = n ? [
                e._bufs.length - 1,
                -1
            ] : [
                0,
                1
            ];
            for(let o = i; o >= 0 && o < e._bufs.length; o += s)this._attach(e._bufs[o], r, n);
        } else typeof e == "number" && (e = e.toString()), r.call(this, ft.from(e));
        return this;
    };
    we.prototype._appendBuffer = function(e) {
        this._bufs.push(e), this.length += e.length;
    };
    we.prototype._prependBuffer = function(e) {
        this._bufs.unshift(e), this.length += e.length;
    };
    we.prototype.indexOf = function(t, e, r) {
        if (r === void 0 && typeof e == "string" && (r = e, e = void 0), typeof t == "function" || Array.isArray(t)) throw new TypeError('The "value" argument must be one of type string, Buffer, BufferList, or Uint8Array.');
        if (typeof t == "number" ? t = ft.from([
            t
        ]) : typeof t == "string" ? t = ft.from(t, r) : this._isBufferList(t) ? t = t.slice() : Array.isArray(t.buffer) ? t = ft.from(t.buffer, t.byteOffset, t.byteLength) : ft.isBuffer(t) || (t = ft.from(t)), e = Number(e || 0), isNaN(e) && (e = 0), e < 0 && (e = this.length + e), e < 0 && (e = 0), t.length === 0) return e > this.length ? this.length : e;
        let n = this._offset(e), i = n[0], s = n[1];
        for(; i < this._bufs.length; i++){
            let o = this._bufs[i];
            for(; s < o.length;)if (o.length - s >= t.length) {
                let c = o.indexOf(t, s);
                if (c !== -1) return this._reverseOffset([
                    i,
                    c
                ]);
                s = o.length - t.length + 1;
            } else {
                let c = this._reverseOffset([
                    i,
                    s
                ]);
                if (this._match(c, t)) return c;
                s++;
            }
            s = 0;
        }
        return -1;
    };
    we.prototype._match = function(t, e) {
        if (this.length - t < e.length) return !1;
        for(let r = 0; r < e.length; r++)if (this.get(t + r) !== e[r]) return !1;
        return !0;
    };
    (function() {
        let t = {
            readDoubleBE: 8,
            readDoubleLE: 8,
            readFloatBE: 4,
            readFloatLE: 4,
            readBigInt64BE: 8,
            readBigInt64LE: 8,
            readBigUInt64BE: 8,
            readBigUInt64LE: 8,
            readInt32BE: 4,
            readInt32LE: 4,
            readUInt32BE: 4,
            readUInt32LE: 4,
            readInt16BE: 2,
            readInt16LE: 2,
            readUInt16BE: 2,
            readUInt16LE: 2,
            readInt8: 1,
            readUInt8: 1,
            readIntBE: null,
            readIntLE: null,
            readUIntBE: null,
            readUIntLE: null
        };
        for(let e in t)(function(r) {
            t[r] === null ? we.prototype[r] = function(n, i) {
                return this.slice(n, n + i)[r](0, i);
            } : we.prototype[r] = function(n = 0) {
                return this.slice(n, n + t[r])[r](0);
            };
        })(e);
    })();
    we.prototype._isBufferList = function(e) {
        return e instanceof we || we.isBufferList(e);
    };
    we.isBufferList = function(e) {
        return e != null && e[Rp];
    };
    kp.exports = we;
});
var $4c2dd1b68d143d96$var$Bp = $4c2dd1b68d143d96$var$D((OM, fo)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var xa = $4c2dd1b68d143d96$var$or().Duplex, BS = $4c2dd1b68d143d96$var$Op(), $n = $4c2dd1b68d143d96$var$Cp();
    function Fe(t) {
        if (!(this instanceof Fe)) return new Fe(t);
        if (typeof t == "function") {
            this._callback = t;
            let e = (function(n) {
                this._callback && (this._callback(n), this._callback = null);
            }).bind(this);
            this.on("pipe", function(n) {
                n.on("error", e);
            }), this.on("unpipe", function(n) {
                n.removeListener("error", e);
            }), t = null;
        }
        $n._init.call(this, t), xa.call(this);
    }
    BS(Fe, xa);
    Object.assign(Fe.prototype, $n.prototype);
    Fe.prototype._new = function(e) {
        return new Fe(e);
    };
    Fe.prototype._write = function(e, r, n) {
        this._appendBuffer(e), typeof n == "function" && n();
    };
    Fe.prototype._read = function(e) {
        if (!this.length) return this.push(null);
        e = Math.min(e, this.length), this.push(this.slice(0, e)), this.consume(e);
    };
    Fe.prototype.end = function(e) {
        xa.prototype.end.call(this, e), this._callback && (this._callback(null, this.slice()), this._callback = null);
    };
    Fe.prototype._destroy = function(e, r) {
        this._bufs.length = 0, this.length = 0, r(e);
    };
    Fe.prototype._isBufferList = function(e) {
        return e instanceof Fe || e instanceof $n || Fe.isBufferList(e);
    };
    Fe.isBufferList = $n.isBufferList;
    fo.exports = Fe;
    fo.exports.BufferListStream = Fe;
    fo.exports.BufferList = $n;
});
var $4c2dd1b68d143d96$var$Np = $4c2dd1b68d143d96$var$D((DM, Mp)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var Ta = class {
        constructor(){
            this.cmd = null, this.retain = !1, this.qos = 0, this.dup = !1, this.length = -1, this.topic = null, this.payload = null;
        }
    };
    Mp.exports = Ta;
});
var $4c2dd1b68d143d96$var$Pa = $4c2dd1b68d143d96$var$D((QM, qp)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var z = qp.exports, { Buffer: Ke } = ($4c2dd1b68d143d96$var$ke(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$qe));
    z.types = {
        0: "reserved",
        1: "connect",
        2: "connack",
        3: "publish",
        4: "puback",
        5: "pubrec",
        6: "pubrel",
        7: "pubcomp",
        8: "subscribe",
        9: "suback",
        10: "unsubscribe",
        11: "unsuback",
        12: "pingreq",
        13: "pingresp",
        14: "disconnect",
        15: "auth"
    };
    z.requiredHeaderFlags = {
        1: 0,
        2: 0,
        4: 0,
        5: 0,
        6: 2,
        7: 0,
        8: 2,
        9: 0,
        10: 2,
        11: 0,
        12: 0,
        13: 0,
        14: 0,
        15: 0
    };
    z.requiredHeaderFlagsErrors = {};
    for(let t in z.requiredHeaderFlags){
        let e = z.requiredHeaderFlags[t];
        z.requiredHeaderFlagsErrors[t] = "Invalid header flag bits, must be 0x" + e.toString(16) + " for " + z.types[t] + " packet";
    }
    z.codes = {};
    for(let t in z.types){
        let e = z.types[t];
        z.codes[e] = t;
    }
    z.CMD_SHIFT = 4;
    z.CMD_MASK = 240;
    z.DUP_MASK = 8;
    z.QOS_MASK = 3;
    z.QOS_SHIFT = 1;
    z.RETAIN_MASK = 1;
    z.VARBYTEINT_MASK = 127;
    z.VARBYTEINT_FIN_MASK = 128;
    z.VARBYTEINT_MAX = 268435455;
    z.SESSIONPRESENT_MASK = 1;
    z.SESSIONPRESENT_HEADER = Ke.from([
        z.SESSIONPRESENT_MASK
    ]);
    z.CONNACK_HEADER = Ke.from([
        z.codes.connack << z.CMD_SHIFT
    ]);
    z.USERNAME_MASK = 128;
    z.PASSWORD_MASK = 64;
    z.WILL_RETAIN_MASK = 32;
    z.WILL_QOS_MASK = 24;
    z.WILL_QOS_SHIFT = 3;
    z.WILL_FLAG_MASK = 4;
    z.CLEAN_SESSION_MASK = 2;
    z.CONNECT_HEADER = Ke.from([
        z.codes.connect << z.CMD_SHIFT
    ]);
    z.properties = {
        sessionExpiryInterval: 17,
        willDelayInterval: 24,
        receiveMaximum: 33,
        maximumPacketSize: 39,
        topicAliasMaximum: 34,
        requestResponseInformation: 25,
        requestProblemInformation: 23,
        userProperties: 38,
        authenticationMethod: 21,
        authenticationData: 22,
        payloadFormatIndicator: 1,
        messageExpiryInterval: 2,
        contentType: 3,
        responseTopic: 8,
        correlationData: 9,
        maximumQoS: 36,
        retainAvailable: 37,
        assignedClientIdentifier: 18,
        reasonString: 31,
        wildcardSubscriptionAvailable: 40,
        subscriptionIdentifiersAvailable: 41,
        sharedSubscriptionAvailable: 42,
        serverKeepAlive: 19,
        responseInformation: 26,
        serverReference: 28,
        topicAlias: 35,
        subscriptionIdentifier: 11
    };
    z.propertiesCodes = {};
    for(let t in z.properties){
        let e = z.properties[t];
        z.propertiesCodes[e] = t;
    }
    z.propertiesTypes = {
        sessionExpiryInterval: "int32",
        willDelayInterval: "int32",
        receiveMaximum: "int16",
        maximumPacketSize: "int32",
        topicAliasMaximum: "int16",
        requestResponseInformation: "byte",
        requestProblemInformation: "byte",
        userProperties: "pair",
        authenticationMethod: "string",
        authenticationData: "binary",
        payloadFormatIndicator: "byte",
        messageExpiryInterval: "int32",
        contentType: "string",
        responseTopic: "string",
        correlationData: "binary",
        maximumQoS: "int8",
        retainAvailable: "byte",
        assignedClientIdentifier: "string",
        reasonString: "string",
        wildcardSubscriptionAvailable: "byte",
        subscriptionIdentifiersAvailable: "byte",
        sharedSubscriptionAvailable: "byte",
        serverKeepAlive: "int16",
        responseInformation: "string",
        serverReference: "string",
        topicAlias: "int16",
        subscriptionIdentifier: "var"
    };
    function sr(t) {
        return [
            0,
            1,
            2
        ].map((e)=>[
                0,
                1
            ].map((r)=>[
                    0,
                    1
                ].map((n)=>{
                    let i = Ke.alloc(1);
                    return i.writeUInt8(z.codes[t] << z.CMD_SHIFT | (r ? z.DUP_MASK : 0) | e << z.QOS_SHIFT | n, 0, !0), i;
                })));
    }
    z.PUBLISH_HEADER = sr("publish");
    z.SUBSCRIBE_HEADER = sr("subscribe");
    z.SUBSCRIBE_OPTIONS_QOS_MASK = 3;
    z.SUBSCRIBE_OPTIONS_NL_MASK = 1;
    z.SUBSCRIBE_OPTIONS_NL_SHIFT = 2;
    z.SUBSCRIBE_OPTIONS_RAP_MASK = 1;
    z.SUBSCRIBE_OPTIONS_RAP_SHIFT = 3;
    z.SUBSCRIBE_OPTIONS_RH_MASK = 3;
    z.SUBSCRIBE_OPTIONS_RH_SHIFT = 4;
    z.SUBSCRIBE_OPTIONS_RH = [
        0,
        16,
        32
    ];
    z.SUBSCRIBE_OPTIONS_NL = 4;
    z.SUBSCRIBE_OPTIONS_RAP = 8;
    z.SUBSCRIBE_OPTIONS_QOS = [
        0,
        1,
        2
    ];
    z.UNSUBSCRIBE_HEADER = sr("unsubscribe");
    z.ACKS = {
        unsuback: sr("unsuback"),
        puback: sr("puback"),
        pubcomp: sr("pubcomp"),
        pubrel: sr("pubrel"),
        pubrec: sr("pubrec")
    };
    z.SUBACK_HEADER = Ke.from([
        z.codes.suback << z.CMD_SHIFT
    ]);
    z.VERSION3 = Ke.from([
        3
    ]);
    z.VERSION4 = Ke.from([
        4
    ]);
    z.VERSION5 = Ke.from([
        5
    ]);
    z.VERSION131 = Ke.from([
        131
    ]);
    z.VERSION132 = Ke.from([
        132
    ]);
    z.QOS = [
        0,
        1,
        2
    ].map((t)=>Ke.from([
            t
        ]));
    z.EMPTY = {
        pingreq: Ke.from([
            z.codes.pingreq << 4,
            0
        ]),
        pingresp: Ke.from([
            z.codes.pingresp << 4,
            0
        ]),
        disconnect: Ke.from([
            z.codes.disconnect << 4,
            0
        ])
    };
    z.MQTT5_PUBACK_PUBREC_CODES = {
        0: "Success",
        16: "No matching subscribers",
        128: "Unspecified error",
        131: "Implementation specific error",
        135: "Not authorized",
        144: "Topic Name invalid",
        145: "Packet identifier in use",
        151: "Quota exceeded",
        153: "Payload format invalid"
    };
    z.MQTT5_PUBREL_PUBCOMP_CODES = {
        0: "Success",
        146: "Packet Identifier not found"
    };
    z.MQTT5_SUBACK_CODES = {
        0: "Granted QoS 0",
        1: "Granted QoS 1",
        2: "Granted QoS 2",
        128: "Unspecified error",
        131: "Implementation specific error",
        135: "Not authorized",
        143: "Topic Filter invalid",
        145: "Packet Identifier in use",
        151: "Quota exceeded",
        158: "Shared Subscriptions not supported",
        161: "Subscription Identifiers not supported",
        162: "Wildcard Subscriptions not supported"
    };
    z.MQTT5_UNSUBACK_CODES = {
        0: "Success",
        17: "No subscription existed",
        128: "Unspecified error",
        131: "Implementation specific error",
        135: "Not authorized",
        143: "Topic Filter invalid",
        145: "Packet Identifier in use"
    };
    z.MQTT5_DISCONNECT_CODES = {
        0: "Normal disconnection",
        4: "Disconnect with Will Message",
        128: "Unspecified error",
        129: "Malformed Packet",
        130: "Protocol Error",
        131: "Implementation specific error",
        135: "Not authorized",
        137: "Server busy",
        139: "Server shutting down",
        141: "Keep Alive timeout",
        142: "Session taken over",
        143: "Topic Filter invalid",
        144: "Topic Name invalid",
        147: "Receive Maximum exceeded",
        148: "Topic Alias invalid",
        149: "Packet too large",
        150: "Message rate too high",
        151: "Quota exceeded",
        152: "Administrative action",
        153: "Payload format invalid",
        154: "Retain not supported",
        155: "QoS not supported",
        156: "Use another server",
        157: "Server moved",
        158: "Shared Subscriptions not supported",
        159: "Connection rate exceeded",
        160: "Maximum connect time",
        161: "Subscription Identifiers not supported",
        162: "Wildcard Subscriptions not supported"
    };
    z.MQTT5_AUTH_CODES = {
        0: "Success",
        24: "Continue authentication",
        25: "Re-authenticate"
    };
});
var $4c2dd1b68d143d96$var$Up = $4c2dd1b68d143d96$var$D((o2, Lp)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var fn = 1e3, hn = fn * 60, dn = hn * 60, Cr = dn * 24, MS = Cr * 7, NS = Cr * 365.25;
    Lp.exports = function(t, e) {
        e = e || {};
        var r = typeof t;
        if (r === "string" && t.length > 0) return qS(t);
        if (r === "number" && isFinite(t)) return e.long ? US(t) : LS(t);
        throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(t));
    };
    function qS(t) {
        if (t = String(t), !(t.length > 100)) {
            var e = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(t);
            if (e) {
                var r = parseFloat(e[1]), n = (e[2] || "ms").toLowerCase();
                switch(n){
                    case "years":
                    case "year":
                    case "yrs":
                    case "yr":
                    case "y":
                        return r * NS;
                    case "weeks":
                    case "week":
                    case "w":
                        return r * MS;
                    case "days":
                    case "day":
                    case "d":
                        return r * Cr;
                    case "hours":
                    case "hour":
                    case "hrs":
                    case "hr":
                    case "h":
                        return r * dn;
                    case "minutes":
                    case "minute":
                    case "mins":
                    case "min":
                    case "m":
                        return r * hn;
                    case "seconds":
                    case "second":
                    case "secs":
                    case "sec":
                    case "s":
                        return r * fn;
                    case "milliseconds":
                    case "millisecond":
                    case "msecs":
                    case "msec":
                    case "ms":
                        return r;
                    default:
                        return;
                }
            }
        }
    }
    function LS(t) {
        var e = Math.abs(t);
        return e >= Cr ? Math.round(t / Cr) + "d" : e >= dn ? Math.round(t / dn) + "h" : e >= hn ? Math.round(t / hn) + "m" : e >= fn ? Math.round(t / fn) + "s" : t + "ms";
    }
    function US(t) {
        var e = Math.abs(t);
        return e >= Cr ? ho(t, e, Cr, "day") : e >= dn ? ho(t, e, dn, "hour") : e >= hn ? ho(t, e, hn, "minute") : e >= fn ? ho(t, e, fn, "second") : t + " ms";
    }
    function ho(t, e, r, n) {
        var i = e >= r * 1.5;
        return Math.round(t / r) + " " + n + (i ? "s" : "");
    }
});
var $4c2dd1b68d143d96$var$jp = $4c2dd1b68d143d96$var$D((y2, Dp)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    function DS(t) {
        r.debug = r, r.default = r, r.coerce = c, r.disable = o, r.enable = i, r.enabled = a, r.humanize = $4c2dd1b68d143d96$var$Up(), r.destroy = f, Object.keys(t).forEach((h)=>{
            r[h] = t[h];
        }), r.names = [], r.skips = [], r.formatters = {};
        function e(h) {
            let d = 0;
            for(let w = 0; w < h.length; w++)d = (d << 5) - d + h.charCodeAt(w), d |= 0;
            return r.colors[Math.abs(d) % r.colors.length];
        }
        r.selectColor = e;
        function r(h) {
            let d, w = null, y, P;
            function E(...b) {
                if (!E.enabled) return;
                let m = E, v = Number(new Date), R = v - (d || v);
                m.diff = R, m.prev = d, m.curr = v, d = v, b[0] = r.coerce(b[0]), typeof b[0] != "string" && b.unshift("%O");
                let T = 0;
                b[0] = b[0].replace(/%([a-zA-Z%])/g, (O, _)=>{
                    if (O === "%%") return "%";
                    T++;
                    let q = r.formatters[_];
                    if (typeof q == "function") {
                        let $ = b[T];
                        O = q.call(m, $), b.splice(T, 1), T--;
                    }
                    return O;
                }), r.formatArgs.call(m, b), (m.log || r.log).apply(m, b);
            }
            return E.namespace = h, E.useColors = r.useColors(), E.color = r.selectColor(h), E.extend = n, E.destroy = r.destroy, Object.defineProperty(E, "enabled", {
                enumerable: !0,
                configurable: !1,
                get: ()=>w !== null ? w : (y !== r.namespaces && (y = r.namespaces, P = r.enabled(h)), P),
                set: (b)=>{
                    w = b;
                }
            }), typeof r.init == "function" && r.init(E), E;
        }
        function n(h, d) {
            let w = r(this.namespace + (typeof d > "u" ? ":" : d) + h);
            return w.log = this.log, w;
        }
        function i(h) {
            r.save(h), r.namespaces = h, r.names = [], r.skips = [];
            let d = (typeof h == "string" ? h : "").trim().replace(/\s+/g, ",").split(",").filter(Boolean);
            for (let w of d)w[0] === "-" ? r.skips.push(w.slice(1)) : r.names.push(w);
        }
        function s(h, d) {
            let w = 0, y = 0, P = -1, E = 0;
            for(; w < h.length;)if (y < d.length && (d[y] === h[w] || d[y] === "*")) d[y] === "*" ? (P = y, E = w, y++) : (w++, y++);
            else if (P !== -1) y = P + 1, E++, w = E;
            else return !1;
            for(; y < d.length && d[y] === "*";)y++;
            return y === d.length;
        }
        function o() {
            let h = [
                ...r.names,
                ...r.skips.map((d)=>"-" + d)
            ].join(",");
            return r.enable(""), h;
        }
        function a(h) {
            for (let d of r.skips)if (s(h, d)) return !1;
            for (let d of r.names)if (s(h, d)) return !0;
            return !1;
        }
        function c(h) {
            return h instanceof Error ? h.stack || h.message : h;
        }
        function f() {
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
        return r.enable(r.load()), r;
    }
    Dp.exports = DS;
});
var $4c2dd1b68d143d96$var$At = $4c2dd1b68d143d96$var$D((Qe, po)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Qe.formatArgs = FS;
    Qe.save = WS;
    Qe.load = $S;
    Qe.useColors = jS;
    Qe.storage = HS();
    Qe.destroy = (()=>{
        let t = !1;
        return ()=>{
            t || (t = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
        };
    })();
    Qe.colors = [
        "#0000CC",
        "#0000FF",
        "#0033CC",
        "#0033FF",
        "#0066CC",
        "#0066FF",
        "#0099CC",
        "#0099FF",
        "#00CC00",
        "#00CC33",
        "#00CC66",
        "#00CC99",
        "#00CCCC",
        "#00CCFF",
        "#3300CC",
        "#3300FF",
        "#3333CC",
        "#3333FF",
        "#3366CC",
        "#3366FF",
        "#3399CC",
        "#3399FF",
        "#33CC00",
        "#33CC33",
        "#33CC66",
        "#33CC99",
        "#33CCCC",
        "#33CCFF",
        "#6600CC",
        "#6600FF",
        "#6633CC",
        "#6633FF",
        "#66CC00",
        "#66CC33",
        "#9900CC",
        "#9900FF",
        "#9933CC",
        "#9933FF",
        "#99CC00",
        "#99CC33",
        "#CC0000",
        "#CC0033",
        "#CC0066",
        "#CC0099",
        "#CC00CC",
        "#CC00FF",
        "#CC3300",
        "#CC3333",
        "#CC3366",
        "#CC3399",
        "#CC33CC",
        "#CC33FF",
        "#CC6600",
        "#CC6633",
        "#CC9900",
        "#CC9933",
        "#CCCC00",
        "#CCCC33",
        "#FF0000",
        "#FF0033",
        "#FF0066",
        "#FF0099",
        "#FF00CC",
        "#FF00FF",
        "#FF3300",
        "#FF3333",
        "#FF3366",
        "#FF3399",
        "#FF33CC",
        "#FF33FF",
        "#FF6600",
        "#FF6633",
        "#FF9900",
        "#FF9933",
        "#FFCC00",
        "#FFCC33"
    ];
    function jS() {
        if (typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return !0;
        if (typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return !1;
        let t;
        return typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && (t = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(t[1], 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    function FS(t) {
        if (t[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + t[0] + (this.useColors ? "%c " : " ") + "+" + po.exports.humanize(this.diff), !this.useColors) return;
        let e = "color: " + this.color;
        t.splice(1, 0, e, "color: inherit");
        let r = 0, n = 0;
        t[0].replace(/%[a-zA-Z%]/g, (i)=>{
            i !== "%%" && (r++, i === "%c" && (n = r));
        }), t.splice(n, 0, e);
    }
    Qe.log = console.debug || console.log || (()=>{});
    function WS(t) {
        try {
            t ? Qe.storage.setItem("debug", t) : Qe.storage.removeItem("debug");
        } catch  {}
    }
    function $S() {
        let t;
        try {
            t = Qe.storage.getItem("debug") || Qe.storage.getItem("DEBUG");
        } catch  {}
        return !t && typeof $4c2dd1b68d143d96$var$M < "u" && "env" in $4c2dd1b68d143d96$var$M && (t = $4c2dd1b68d143d96$var$M.env.DEBUG), t;
    }
    function HS() {
        try {
            return localStorage;
        } catch  {}
    }
    po.exports = $4c2dd1b68d143d96$var$jp()(Qe);
    var { formatters: VS } = po.exports;
    VS.j = function(t) {
        try {
            return JSON.stringify(t);
        } catch (e) {
            return "[UnexpectedJSONParseError]: " + e.message;
        }
    };
});
var $4c2dd1b68d143d96$var$$p = $4c2dd1b68d143d96$var$D((M2, Wp)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var GS = $4c2dd1b68d143d96$var$Bp(), { EventEmitter: zS } = ($4c2dd1b68d143d96$var$er(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$Zt)), Fp = $4c2dd1b68d143d96$var$Np(), de = $4c2dd1b68d143d96$var$Pa(), ae = $4c2dd1b68d143d96$var$At()("mqtt-packet:parser"), Oa = class t extends zS {
        constructor(){
            super(), this.parser = this.constructor.parser;
        }
        static parser(e) {
            return this instanceof t ? (this.settings = e || {}, this._states = [
                "_parseHeader",
                "_parseLength",
                "_parsePayload",
                "_newPacket"
            ], this._resetState(), this) : new t().parser(e);
        }
        _resetState() {
            ae("_resetState: resetting packet, error, _list, and _stateCounter"), this.packet = new Fp, this.error = null, this._list = GS(), this._stateCounter = 0;
        }
        parse(e) {
            for(this.error && this._resetState(), this._list.append(e), ae("parse: current state: %s", this._states[this._stateCounter]); (this.packet.length !== -1 || this._list.length > 0) && this[this._states[this._stateCounter]]() && !this.error;)this._stateCounter++, ae("parse: state complete. _stateCounter is now: %d", this._stateCounter), ae("parse: packet.length: %d, buffer list length: %d", this.packet.length, this._list.length), this._stateCounter >= this._states.length && (this._stateCounter = 0);
            return ae("parse: exited while loop. packet: %d, buffer list length: %d", this.packet.length, this._list.length), this._list.length;
        }
        _parseHeader() {
            let e = this._list.readUInt8(0), r = e >> de.CMD_SHIFT;
            this.packet.cmd = de.types[r];
            let n = e & 15, i = de.requiredHeaderFlags[r];
            return i != null && n !== i ? this._emitError(new Error(de.requiredHeaderFlagsErrors[r])) : (this.packet.retain = (e & de.RETAIN_MASK) !== 0, this.packet.qos = e >> de.QOS_SHIFT & de.QOS_MASK, this.packet.qos > 2 ? this._emitError(new Error("Packet must not have both QoS bits set to 1")) : (this.packet.dup = (e & de.DUP_MASK) !== 0, ae("_parseHeader: packet: %o", this.packet), this._list.consume(1), !0));
        }
        _parseLength() {
            let e = this._parseVarByteNum(!0);
            return e && (this.packet.length = e.value, this._list.consume(e.bytes)), ae("_parseLength %d", e.value), !!e;
        }
        _parsePayload() {
            ae("_parsePayload: payload %O", this._list);
            let e = !1;
            if (this.packet.length === 0 || this._list.length >= this.packet.length) {
                switch(this._pos = 0, this.packet.cmd){
                    case "connect":
                        this._parseConnect();
                        break;
                    case "connack":
                        this._parseConnack();
                        break;
                    case "publish":
                        this._parsePublish();
                        break;
                    case "puback":
                    case "pubrec":
                    case "pubrel":
                    case "pubcomp":
                        this._parseConfirmation();
                        break;
                    case "subscribe":
                        this._parseSubscribe();
                        break;
                    case "suback":
                        this._parseSuback();
                        break;
                    case "unsubscribe":
                        this._parseUnsubscribe();
                        break;
                    case "unsuback":
                        this._parseUnsuback();
                        break;
                    case "pingreq":
                    case "pingresp":
                        break;
                    case "disconnect":
                        this._parseDisconnect();
                        break;
                    case "auth":
                        this._parseAuth();
                        break;
                    default:
                        this._emitError(new Error("Not supported"));
                }
                e = !0;
            }
            return ae("_parsePayload complete result: %s", e), e;
        }
        _parseConnect() {
            ae("_parseConnect");
            let e, r, n, i, s = {}, o = this.packet, a = this._parseString();
            if (a === null) return this._emitError(new Error("Cannot parse protocolId"));
            if (a !== "MQTT" && a !== "MQIsdp") return this._emitError(new Error("Invalid protocolId"));
            if (o.protocolId = a, this._pos >= this._list.length) return this._emitError(new Error("Packet too short"));
            if (o.protocolVersion = this._list.readUInt8(this._pos), o.protocolVersion >= 128 && (o.bridgeMode = !0, o.protocolVersion = o.protocolVersion - 128), o.protocolVersion !== 3 && o.protocolVersion !== 4 && o.protocolVersion !== 5) return this._emitError(new Error("Invalid protocol version"));
            if (this._pos++, this._pos >= this._list.length) return this._emitError(new Error("Packet too short"));
            if (this._list.readUInt8(this._pos) & 1) return this._emitError(new Error("Connect flag bit 0 must be 0, but got 1"));
            s.username = this._list.readUInt8(this._pos) & de.USERNAME_MASK, s.password = this._list.readUInt8(this._pos) & de.PASSWORD_MASK, s.will = this._list.readUInt8(this._pos) & de.WILL_FLAG_MASK;
            let c = !!(this._list.readUInt8(this._pos) & de.WILL_RETAIN_MASK), f = (this._list.readUInt8(this._pos) & de.WILL_QOS_MASK) >> de.WILL_QOS_SHIFT;
            if (s.will) o.will = {}, o.will.retain = c, o.will.qos = f;
            else {
                if (c) return this._emitError(new Error("Will Retain Flag must be set to zero when Will Flag is set to 0"));
                if (f) return this._emitError(new Error("Will QoS must be set to zero when Will Flag is set to 0"));
            }
            if (o.clean = (this._list.readUInt8(this._pos) & de.CLEAN_SESSION_MASK) !== 0, this._pos++, o.keepalive = this._parseNum(), o.keepalive === -1) return this._emitError(new Error("Packet too short"));
            if (o.protocolVersion === 5) {
                let d = this._parseProperties();
                Object.getOwnPropertyNames(d).length && (o.properties = d);
            }
            let h = this._parseString();
            if (h === null) return this._emitError(new Error("Packet too short"));
            if (o.clientId = h, ae("_parseConnect: packet.clientId: %s", o.clientId), s.will) {
                if (o.protocolVersion === 5) {
                    let d = this._parseProperties();
                    Object.getOwnPropertyNames(d).length && (o.will.properties = d);
                }
                if (e = this._parseString(), e === null) return this._emitError(new Error("Cannot parse will topic"));
                if (o.will.topic = e, ae("_parseConnect: packet.will.topic: %s", o.will.topic), r = this._parseBuffer(), r === null) return this._emitError(new Error("Cannot parse will payload"));
                o.will.payload = r, ae("_parseConnect: packet.will.paylaod: %s", o.will.payload);
            }
            if (s.username) {
                if (i = this._parseString(), i === null) return this._emitError(new Error("Cannot parse username"));
                o.username = i, ae("_parseConnect: packet.username: %s", o.username);
            }
            if (s.password) {
                if (n = this._parseBuffer(), n === null) return this._emitError(new Error("Cannot parse password"));
                o.password = n;
            }
            return this.settings = o, ae("_parseConnect: complete"), o;
        }
        _parseConnack() {
            ae("_parseConnack");
            let e = this.packet;
            if (this._list.length < 1) return null;
            let r = this._list.readUInt8(this._pos++);
            if (r > 1) return this._emitError(new Error("Invalid connack flags, bits 7-1 must be set to 0"));
            if (e.sessionPresent = !!(r & de.SESSIONPRESENT_MASK), this.settings.protocolVersion === 5) this._list.length >= 2 ? e.reasonCode = this._list.readUInt8(this._pos++) : e.reasonCode = 0;
            else {
                if (this._list.length < 2) return null;
                e.returnCode = this._list.readUInt8(this._pos++);
            }
            if (e.returnCode === -1 || e.reasonCode === -1) return this._emitError(new Error("Cannot parse return code"));
            if (this.settings.protocolVersion === 5) {
                let n = this._parseProperties();
                Object.getOwnPropertyNames(n).length && (e.properties = n);
            }
            ae("_parseConnack: complete");
        }
        _parsePublish() {
            ae("_parsePublish");
            let e = this.packet;
            if (e.topic = this._parseString(), e.topic === null) return this._emitError(new Error("Cannot parse topic"));
            if (!(e.qos > 0 && !this._parseMessageId())) {
                if (this.settings.protocolVersion === 5) {
                    let r = this._parseProperties();
                    Object.getOwnPropertyNames(r).length && (e.properties = r);
                }
                e.payload = this._list.slice(this._pos, e.length), ae("_parsePublish: payload from buffer list: %o", e.payload);
            }
        }
        _parseSubscribe() {
            ae("_parseSubscribe");
            let e = this.packet, r, n, i, s, o, a, c;
            if (e.subscriptions = [], !!this._parseMessageId()) {
                if (this.settings.protocolVersion === 5) {
                    let f = this._parseProperties();
                    Object.getOwnPropertyNames(f).length && (e.properties = f);
                }
                if (e.length <= 0) return this._emitError(new Error("Malformed subscribe, no payload specified"));
                for(; this._pos < e.length;){
                    if (r = this._parseString(), r === null) return this._emitError(new Error("Cannot parse topic"));
                    if (this._pos >= e.length) return this._emitError(new Error("Malformed Subscribe Payload"));
                    if (n = this._parseByte(), this.settings.protocolVersion === 5) {
                        if (n & 192) return this._emitError(new Error("Invalid subscribe topic flag bits, bits 7-6 must be 0"));
                    } else if (n & 252) return this._emitError(new Error("Invalid subscribe topic flag bits, bits 7-2 must be 0"));
                    if (i = n & de.SUBSCRIBE_OPTIONS_QOS_MASK, i > 2) return this._emitError(new Error("Invalid subscribe QoS, must be <= 2"));
                    if (a = (n >> de.SUBSCRIBE_OPTIONS_NL_SHIFT & de.SUBSCRIBE_OPTIONS_NL_MASK) !== 0, o = (n >> de.SUBSCRIBE_OPTIONS_RAP_SHIFT & de.SUBSCRIBE_OPTIONS_RAP_MASK) !== 0, s = n >> de.SUBSCRIBE_OPTIONS_RH_SHIFT & de.SUBSCRIBE_OPTIONS_RH_MASK, s > 2) return this._emitError(new Error("Invalid retain handling, must be <= 2"));
                    c = {
                        topic: r,
                        qos: i
                    }, this.settings.protocolVersion === 5 ? (c.nl = a, c.rap = o, c.rh = s) : this.settings.bridgeMode && (c.rh = 0, c.rap = !0, c.nl = !0), ae("_parseSubscribe: push subscription `%s` to subscription", c), e.subscriptions.push(c);
                }
            }
        }
        _parseSuback() {
            ae("_parseSuback");
            let e = this.packet;
            if (this.packet.granted = [], !!this._parseMessageId()) {
                if (this.settings.protocolVersion === 5) {
                    let r = this._parseProperties();
                    Object.getOwnPropertyNames(r).length && (e.properties = r);
                }
                if (e.length <= 0) return this._emitError(new Error("Malformed suback, no payload specified"));
                for(; this._pos < this.packet.length;){
                    let r = this._list.readUInt8(this._pos++);
                    if (this.settings.protocolVersion === 5) {
                        if (!de.MQTT5_SUBACK_CODES[r]) return this._emitError(new Error("Invalid suback code"));
                    } else if (r > 2 && r !== 128) return this._emitError(new Error("Invalid suback QoS, must be 0, 1, 2 or 128"));
                    this.packet.granted.push(r);
                }
            }
        }
        _parseUnsubscribe() {
            ae("_parseUnsubscribe");
            let e = this.packet;
            if (e.unsubscriptions = [], !!this._parseMessageId()) {
                if (this.settings.protocolVersion === 5) {
                    let r = this._parseProperties();
                    Object.getOwnPropertyNames(r).length && (e.properties = r);
                }
                if (e.length <= 0) return this._emitError(new Error("Malformed unsubscribe, no payload specified"));
                for(; this._pos < e.length;){
                    let r = this._parseString();
                    if (r === null) return this._emitError(new Error("Cannot parse topic"));
                    ae("_parseUnsubscribe: push topic `%s` to unsubscriptions", r), e.unsubscriptions.push(r);
                }
            }
        }
        _parseUnsuback() {
            ae("_parseUnsuback");
            let e = this.packet;
            if (!this._parseMessageId()) return this._emitError(new Error("Cannot parse messageId"));
            if ((this.settings.protocolVersion === 3 || this.settings.protocolVersion === 4) && e.length !== 2) return this._emitError(new Error("Malformed unsuback, payload length must be 2"));
            if (e.length <= 0) return this._emitError(new Error("Malformed unsuback, no payload specified"));
            if (this.settings.protocolVersion === 5) {
                let r = this._parseProperties();
                for(Object.getOwnPropertyNames(r).length && (e.properties = r), e.granted = []; this._pos < this.packet.length;){
                    let n = this._list.readUInt8(this._pos++);
                    if (!de.MQTT5_UNSUBACK_CODES[n]) return this._emitError(new Error("Invalid unsuback code"));
                    this.packet.granted.push(n);
                }
            }
        }
        _parseConfirmation() {
            ae("_parseConfirmation: packet.cmd: `%s`", this.packet.cmd);
            let e = this.packet;
            if (this._parseMessageId(), this.settings.protocolVersion === 5) {
                if (e.length > 2) {
                    switch(e.reasonCode = this._parseByte(), this.packet.cmd){
                        case "puback":
                        case "pubrec":
                            if (!de.MQTT5_PUBACK_PUBREC_CODES[e.reasonCode]) return this._emitError(new Error("Invalid " + this.packet.cmd + " reason code"));
                            break;
                        case "pubrel":
                        case "pubcomp":
                            if (!de.MQTT5_PUBREL_PUBCOMP_CODES[e.reasonCode]) return this._emitError(new Error("Invalid " + this.packet.cmd + " reason code"));
                            break;
                    }
                    ae("_parseConfirmation: packet.reasonCode `%d`", e.reasonCode);
                } else e.reasonCode = 0;
                if (e.length > 3) {
                    let r = this._parseProperties();
                    Object.getOwnPropertyNames(r).length && (e.properties = r);
                }
            }
            return !0;
        }
        _parseDisconnect() {
            let e = this.packet;
            if (ae("_parseDisconnect"), this.settings.protocolVersion === 5) {
                this._list.length > 0 ? (e.reasonCode = this._parseByte(), de.MQTT5_DISCONNECT_CODES[e.reasonCode] || this._emitError(new Error("Invalid disconnect reason code"))) : e.reasonCode = 0;
                let r = this._parseProperties();
                Object.getOwnPropertyNames(r).length && (e.properties = r);
            }
            return ae("_parseDisconnect result: true"), !0;
        }
        _parseAuth() {
            ae("_parseAuth");
            let e = this.packet;
            if (this.settings.protocolVersion !== 5) return this._emitError(new Error("Not supported auth packet for this version MQTT"));
            if (e.reasonCode = this._parseByte(), !de.MQTT5_AUTH_CODES[e.reasonCode]) return this._emitError(new Error("Invalid auth reason code"));
            let r = this._parseProperties();
            return Object.getOwnPropertyNames(r).length && (e.properties = r), ae("_parseAuth: result: true"), !0;
        }
        _parseMessageId() {
            let e = this.packet;
            return e.messageId = this._parseNum(), e.messageId === null ? (this._emitError(new Error("Cannot parse messageId")), !1) : (ae("_parseMessageId: packet.messageId %d", e.messageId), !0);
        }
        _parseString(e) {
            let r = this._parseNum(), n = r + this._pos;
            if (r === -1 || n > this._list.length || n > this.packet.length) return null;
            let i = this._list.toString("utf8", this._pos, n);
            return this._pos += r, ae("_parseString: result: %s", i), i;
        }
        _parseStringPair() {
            return ae("_parseStringPair"), {
                name: this._parseString(),
                value: this._parseString()
            };
        }
        _parseBuffer() {
            let e = this._parseNum(), r = e + this._pos;
            if (e === -1 || r > this._list.length || r > this.packet.length) return null;
            let n = this._list.slice(this._pos, r);
            return this._pos += e, ae("_parseBuffer: result: %o", n), n;
        }
        _parseNum() {
            if (this._list.length - this._pos < 2) return -1;
            let e = this._list.readUInt16BE(this._pos);
            return this._pos += 2, ae("_parseNum: result: %s", e), e;
        }
        _parse4ByteNum() {
            if (this._list.length - this._pos < 4) return -1;
            let e = this._list.readUInt32BE(this._pos);
            return this._pos += 4, ae("_parse4ByteNum: result: %s", e), e;
        }
        _parseVarByteNum(e) {
            ae("_parseVarByteNum");
            let r = 4, n = 0, i = 1, s = 0, o = !1, a, c = this._pos ? this._pos : 0;
            for(; n < r && c + n < this._list.length;){
                if (a = this._list.readUInt8(c + n++), s += i * (a & de.VARBYTEINT_MASK), i *= 128, (a & de.VARBYTEINT_FIN_MASK) === 0) {
                    o = !0;
                    break;
                }
                if (this._list.length <= n) break;
            }
            return !o && n === r && this._list.length >= n && this._emitError(new Error("Invalid variable byte integer")), c && (this._pos += n), o ? e ? o = {
                bytes: n,
                value: s
            } : o = s : o = !1, ae("_parseVarByteNum: result: %o", o), o;
        }
        _parseByte() {
            let e;
            return this._pos < this._list.length && (e = this._list.readUInt8(this._pos), this._pos++), ae("_parseByte: result: %o", e), e;
        }
        _parseByType(e) {
            switch(ae("_parseByType: type: %s", e), e){
                case "byte":
                    return this._parseByte() !== 0;
                case "int8":
                    return this._parseByte();
                case "int16":
                    return this._parseNum();
                case "int32":
                    return this._parse4ByteNum();
                case "var":
                    return this._parseVarByteNum();
                case "string":
                    return this._parseString();
                case "pair":
                    return this._parseStringPair();
                case "binary":
                    return this._parseBuffer();
            }
        }
        _parseProperties() {
            ae("_parseProperties");
            let e = this._parseVarByteNum(), n = this._pos + e, i = {};
            for(; this._pos < n;){
                let s = this._parseByte();
                if (!s) return this._emitError(new Error("Cannot parse property code type")), !1;
                let o = de.propertiesCodes[s];
                if (!o) return this._emitError(new Error("Unknown property")), !1;
                if (o === "userProperties") {
                    i[o] || (i[o] = Object.create(null));
                    let a = this._parseByType(de.propertiesTypes[o]);
                    if (i[o][a.name]) {
                        if (Array.isArray(i[o][a.name])) i[o][a.name].push(a.value);
                        else {
                            let c = i[o][a.name];
                            i[o][a.name] = [
                                c
                            ], i[o][a.name].push(a.value);
                        }
                    } else i[o][a.name] = a.value;
                    continue;
                }
                i[o] ? Array.isArray(i[o]) ? i[o].push(this._parseByType(de.propertiesTypes[o])) : (i[o] = [
                    i[o]
                ], i[o].push(this._parseByType(de.propertiesTypes[o]))) : i[o] = this._parseByType(de.propertiesTypes[o]);
            }
            return i;
        }
        _newPacket() {
            return ae("_newPacket"), this.packet && (this._list.consume(this.packet.length), ae("_newPacket: parser emit packet: packet.cmd: %s, packet.payload: %s, packet.length: %d", this.packet.cmd, this.packet.payload, this.packet.length), this.emit("packet", this.packet)), ae("_newPacket: new packet"), this.packet = new Fp, this._pos = 0, !0;
        }
        _emitError(e) {
            ae("_emitError", e), this.error = e, this.emit("error", e);
        }
    };
    Wp.exports = Oa;
});
var $4c2dd1b68d143d96$var$zp = $4c2dd1b68d143d96$var$D((H2, Gp)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var { Buffer: Hn } = ($4c2dd1b68d143d96$var$ke(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$qe)), KS = 65536, Hp = {}, QS = Hn.isBuffer(Hn.from([
        1,
        2
    ]).subarray(0, 1));
    function Vp(t) {
        let e = Hn.allocUnsafe(2);
        return e.writeUInt8(t >> 8, 0), e.writeUInt8(t & 255, 1), e;
    }
    function YS() {
        for(let t = 0; t < KS; t++)Hp[t] = Vp(t);
    }
    function JS(t) {
        let r = 0, n = 0, i = Hn.allocUnsafe(4);
        do r = t % 128 | 0, t = t / 128 | 0, t > 0 && (r = r | 128), i.writeUInt8(r, n++);
        while (t > 0 && n < 4);
        return t > 0 && (n = 0), QS ? i.subarray(0, n) : i.slice(0, n);
    }
    function XS(t) {
        let e = Hn.allocUnsafe(4);
        return e.writeUInt32BE(t, 0), e;
    }
    Gp.exports = {
        cache: Hp,
        generateCache: YS,
        generateNumber: Vp,
        genBufVariableByteInt: JS,
        generate4ByteBuffer: XS
    };
});
var $4c2dd1b68d143d96$var$Kp = $4c2dd1b68d143d96$var$D((eN, Ra)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    typeof $4c2dd1b68d143d96$var$M > "u" || !$4c2dd1b68d143d96$var$M.version || $4c2dd1b68d143d96$var$M.version.indexOf("v0.") === 0 || $4c2dd1b68d143d96$var$M.version.indexOf("v1.") === 0 && $4c2dd1b68d143d96$var$M.version.indexOf("v1.8.") !== 0 ? Ra.exports = {
        nextTick: ZS
    } : Ra.exports = $4c2dd1b68d143d96$var$M;
    function ZS(t, e, r, n) {
        if (typeof t != "function") throw new TypeError('"callback" argument must be a function');
        var i = arguments.length, s, o;
        switch(i){
            case 0:
            case 1:
                return $4c2dd1b68d143d96$var$M.nextTick(t);
            case 2:
                return $4c2dd1b68d143d96$var$M.nextTick(function() {
                    t.call(null, e);
                });
            case 3:
                return $4c2dd1b68d143d96$var$M.nextTick(function() {
                    t.call(null, e, r);
                });
            case 4:
                return $4c2dd1b68d143d96$var$M.nextTick(function() {
                    t.call(null, e, r, n);
                });
            default:
                for(s = new Array(i - 1), o = 0; o < s.length;)s[o++] = arguments[o];
                return $4c2dd1b68d143d96$var$M.nextTick(function() {
                    t.apply(null, s);
                });
        }
    }
});
var $4c2dd1b68d143d96$var$Ba = $4c2dd1b68d143d96$var$D((cN, ry)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var ue = $4c2dd1b68d143d96$var$Pa(), { Buffer: se } = ($4c2dd1b68d143d96$var$ke(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$qe)), eE = se.allocUnsafe(0), tE = se.from([
        0
    ]), Vn = $4c2dd1b68d143d96$var$zp(), rE = $4c2dd1b68d143d96$var$Kp().nextTick, rt = $4c2dd1b68d143d96$var$At()("mqtt-packet:writeToStream"), yo = Vn.cache, nE = Vn.generateNumber, iE = Vn.generateCache, ka = Vn.genBufVariableByteInt, oE = Vn.generate4ByteBuffer, He = Ca, go = !0;
    function ey(t, e, r) {
        switch(rt("generate called"), e.cork && (e.cork(), rE(sE, e)), go && (go = !1, iE()), rt("generate: packet.cmd: %s", t.cmd), t.cmd){
            case "connect":
                return aE(t, e, r);
            case "connack":
                return uE(t, e, r);
            case "publish":
                return lE(t, e, r);
            case "puback":
            case "pubrec":
            case "pubrel":
            case "pubcomp":
                return cE(t, e, r);
            case "subscribe":
                return fE(t, e, r);
            case "suback":
                return hE(t, e, r);
            case "unsubscribe":
                return dE(t, e, r);
            case "unsuback":
                return pE(t, e, r);
            case "pingreq":
            case "pingresp":
                return yE(t, e, r);
            case "disconnect":
                return gE(t, e, r);
            case "auth":
                return bE(t, e, r);
            default:
                return e.destroy(new Error("Unknown command")), !1;
        }
    }
    Object.defineProperty(ey, "cacheNumbers", {
        get () {
            return He === Ca;
        },
        set (t) {
            t ? ((!yo || Object.keys(yo).length === 0) && (go = !0), He = Ca) : (go = !1, He = wE);
        }
    });
    function sE(t) {
        t.uncork();
    }
    function aE(t, e, r) {
        let n = t || {}, i = n.protocolId || "MQTT", s = n.protocolVersion || 4, o = n.will, a = n.clean, c = n.keepalive || 0, f = n.clientId || "", h = n.username, d = n.password, w = n.properties;
        a === void 0 && (a = !0);
        let y = 0;
        if (!i || typeof i != "string" && !se.isBuffer(i)) return e.destroy(new Error("Invalid protocolId")), !1;
        if (y += i.length + 2, s !== 3 && s !== 4 && s !== 5) return e.destroy(new Error("Invalid protocol version")), !1;
        if (y += 1, (typeof f == "string" || se.isBuffer(f)) && (f || s >= 4) && (f || a)) y += se.byteLength(f) + 2;
        else {
            if (s < 4) return e.destroy(new Error("clientId must be supplied before 3.1.1")), !1;
            if (a * 1 === 0) return e.destroy(new Error("clientId must be given if cleanSession set to 0")), !1;
        }
        if (typeof c != "number" || c < 0 || c > 65535 || c % 1 !== 0) return e.destroy(new Error("Invalid keepalive")), !1;
        y += 2, y += 1;
        let P, E;
        if (s === 5) {
            if (P = ar(e, w), !P) return !1;
            y += P.length;
        }
        if (o) {
            if (typeof o != "object") return e.destroy(new Error("Invalid will")), !1;
            if (!o.topic || typeof o.topic != "string") return e.destroy(new Error("Invalid will topic")), !1;
            if (y += se.byteLength(o.topic) + 2, y += 2, o.payload) {
                if (o.payload.length >= 0) typeof o.payload == "string" ? y += se.byteLength(o.payload) : y += o.payload.length;
                else return e.destroy(new Error("Invalid will payload")), !1;
            }
            if (E = {}, s === 5) {
                if (E = ar(e, o.properties), !E) return !1;
                y += E.length;
            }
        }
        let b = !1;
        if (h != null) {
            if (Zp(h)) b = !0, y += se.byteLength(h) + 2;
            else return e.destroy(new Error("Invalid username")), !1;
        }
        if (d != null) {
            if (!b) return e.destroy(new Error("Username is required to use password")), !1;
            if (Zp(d)) y += ty(d) + 2;
            else return e.destroy(new Error("Invalid password")), !1;
        }
        e.write(ue.CONNECT_HEADER), nt(e, y), pn(e, i), n.bridgeMode && (s += 128), e.write(s === 131 ? ue.VERSION131 : s === 132 ? ue.VERSION132 : s === 4 ? ue.VERSION4 : s === 5 ? ue.VERSION5 : ue.VERSION3);
        let m = 0;
        return m |= h != null ? ue.USERNAME_MASK : 0, m |= d != null ? ue.PASSWORD_MASK : 0, m |= o && o.retain ? ue.WILL_RETAIN_MASK : 0, m |= o && o.qos ? o.qos << ue.WILL_QOS_SHIFT : 0, m |= o ? ue.WILL_FLAG_MASK : 0, m |= a ? ue.CLEAN_SESSION_MASK : 0, e.write(se.from([
            m
        ])), He(e, c), s === 5 && P.write(), pn(e, f), o && (s === 5 && E.write(), Br(e, o.topic), pn(e, o.payload)), h != null && pn(e, h), d != null && pn(e, d), !0;
    }
    function uE(t, e, r) {
        let n = r ? r.protocolVersion : 4, i = t || {}, s = n === 5 ? i.reasonCode : i.returnCode, o = i.properties, a = 2;
        if (typeof s != "number") return e.destroy(new Error("Invalid return code")), !1;
        let c = null;
        if (n === 5) {
            if (c = ar(e, o), !c) return !1;
            a += c.length;
        }
        return e.write(ue.CONNACK_HEADER), nt(e, a), e.write(i.sessionPresent ? ue.SESSIONPRESENT_HEADER : tE), e.write(se.from([
            s
        ])), c?.write(), !0;
    }
    function lE(t, e, r) {
        rt("publish: packet: %o", t);
        let n = r ? r.protocolVersion : 4, i = t || {}, s = i.qos || 0, o = i.retain ? ue.RETAIN_MASK : 0, a = i.topic, c = i.payload || eE, f = i.messageId, h = i.properties, d = 0;
        if (typeof a == "string") d += se.byteLength(a) + 2;
        else if (se.isBuffer(a)) d += a.length + 2;
        else return e.destroy(new Error("Invalid topic")), !1;
        if (se.isBuffer(c) ? d += c.length : d += se.byteLength(c), s && typeof f != "number") return e.destroy(new Error("Invalid messageId")), !1;
        s && (d += 2);
        let w = null;
        if (n === 5) {
            if (w = ar(e, h), !w) return !1;
            d += w.length;
        }
        return e.write(ue.PUBLISH_HEADER[s][i.dup ? 1 : 0][o ? 1 : 0]), nt(e, d), He(e, ty(a)), e.write(a), s > 0 && He(e, f), w?.write(), rt("publish: payload: %o", c), e.write(c);
    }
    function cE(t, e, r) {
        let n = r ? r.protocolVersion : 4, i = t || {}, s = i.cmd || "puback", o = i.messageId, a = i.dup && s === "pubrel" ? ue.DUP_MASK : 0, c = 0, f = i.reasonCode, h = i.properties, d = n === 5 ? 3 : 2;
        if (s === "pubrel" && (c = 1), typeof o != "number") return e.destroy(new Error("Invalid messageId")), !1;
        let w = null;
        if (n === 5 && typeof h == "object") {
            if (w = Gn(e, h, r, d), !w) return !1;
            d += w.length;
        }
        return e.write(ue.ACKS[s][c][a][0]), d === 3 && (d += f !== 0 ? 1 : -1), nt(e, d), He(e, o), n === 5 && d !== 2 && e.write(se.from([
            f
        ])), w !== null ? w.write() : d === 4 && e.write(se.from([
            0
        ])), !0;
    }
    function fE(t, e, r) {
        rt("subscribe: packet: ");
        let n = r ? r.protocolVersion : 4, i = t || {}, s = i.dup ? ue.DUP_MASK : 0, o = i.messageId, a = i.subscriptions, c = i.properties, f = 0;
        if (typeof o != "number") return e.destroy(new Error("Invalid messageId")), !1;
        f += 2;
        let h = null;
        if (n === 5) {
            if (h = ar(e, c), !h) return !1;
            f += h.length;
        }
        if (typeof a == "object" && a.length) for(let w = 0; w < a.length; w += 1){
            let y = a[w].topic, P = a[w].qos;
            if (typeof y != "string") return e.destroy(new Error("Invalid subscriptions - invalid topic")), !1;
            if (typeof P != "number") return e.destroy(new Error("Invalid subscriptions - invalid qos")), !1;
            if (n === 5) {
                if (typeof (a[w].nl || !1) != "boolean") return e.destroy(new Error("Invalid subscriptions - invalid No Local")), !1;
                if (typeof (a[w].rap || !1) != "boolean") return e.destroy(new Error("Invalid subscriptions - invalid Retain as Published")), !1;
                let m = a[w].rh || 0;
                if (typeof m != "number" || m > 2) return e.destroy(new Error("Invalid subscriptions - invalid Retain Handling")), !1;
            }
            f += se.byteLength(y) + 2 + 1;
        }
        else return e.destroy(new Error("Invalid subscriptions")), !1;
        rt("subscribe: writing to stream: %o", ue.SUBSCRIBE_HEADER), e.write(ue.SUBSCRIBE_HEADER[1][s ? 1 : 0][0]), nt(e, f), He(e, o), h !== null && h.write();
        let d = !0;
        for (let w of a){
            let y = w.topic, P = w.qos, E = +w.nl, b = +w.rap, m = w.rh, v;
            Br(e, y), v = ue.SUBSCRIBE_OPTIONS_QOS[P], n === 5 && (v |= E ? ue.SUBSCRIBE_OPTIONS_NL : 0, v |= b ? ue.SUBSCRIBE_OPTIONS_RAP : 0, v |= m ? ue.SUBSCRIBE_OPTIONS_RH[m] : 0), d = e.write(se.from([
                v
            ]));
        }
        return d;
    }
    function hE(t, e, r) {
        let n = r ? r.protocolVersion : 4, i = t || {}, s = i.messageId, o = i.granted, a = i.properties, c = 0;
        if (typeof s != "number") return e.destroy(new Error("Invalid messageId")), !1;
        if (c += 2, typeof o == "object" && o.length) for(let h = 0; h < o.length; h += 1){
            if (typeof o[h] != "number") return e.destroy(new Error("Invalid qos vector")), !1;
            c += 1;
        }
        else return e.destroy(new Error("Invalid qos vector")), !1;
        let f = null;
        if (n === 5) {
            if (f = Gn(e, a, r, c), !f) return !1;
            c += f.length;
        }
        return e.write(ue.SUBACK_HEADER), nt(e, c), He(e, s), f !== null && f.write(), e.write(se.from(o));
    }
    function dE(t, e, r) {
        let n = r ? r.protocolVersion : 4, i = t || {}, s = i.messageId, o = i.dup ? ue.DUP_MASK : 0, a = i.unsubscriptions, c = i.properties, f = 0;
        if (typeof s != "number") return e.destroy(new Error("Invalid messageId")), !1;
        if (f += 2, typeof a == "object" && a.length) for(let w = 0; w < a.length; w += 1){
            if (typeof a[w] != "string") return e.destroy(new Error("Invalid unsubscriptions")), !1;
            f += se.byteLength(a[w]) + 2;
        }
        else return e.destroy(new Error("Invalid unsubscriptions")), !1;
        let h = null;
        if (n === 5) {
            if (h = ar(e, c), !h) return !1;
            f += h.length;
        }
        e.write(ue.UNSUBSCRIBE_HEADER[1][o ? 1 : 0][0]), nt(e, f), He(e, s), h !== null && h.write();
        let d = !0;
        for(let w = 0; w < a.length; w++)d = Br(e, a[w]);
        return d;
    }
    function pE(t, e, r) {
        let n = r ? r.protocolVersion : 4, i = t || {}, s = i.messageId, o = i.dup ? ue.DUP_MASK : 0, a = i.granted, c = i.properties, f = i.cmd, h = 0, d = 2;
        if (typeof s != "number") return e.destroy(new Error("Invalid messageId")), !1;
        if (n === 5) {
            if (typeof a == "object" && a.length) for(let y = 0; y < a.length; y += 1){
                if (typeof a[y] != "number") return e.destroy(new Error("Invalid qos vector")), !1;
                d += 1;
            }
            else return e.destroy(new Error("Invalid qos vector")), !1;
        }
        let w = null;
        if (n === 5) {
            if (w = Gn(e, c, r, d), !w) return !1;
            d += w.length;
        }
        return e.write(ue.ACKS[f][h][o][0]), nt(e, d), He(e, s), w !== null && w.write(), n === 5 && e.write(se.from(a)), !0;
    }
    function yE(t, e, r) {
        return e.write(ue.EMPTY[t.cmd]);
    }
    function gE(t, e, r) {
        let n = r ? r.protocolVersion : 4, i = t || {}, s = i.reasonCode, o = i.properties, a = n === 5 ? 1 : 0, c = null;
        if (n === 5) {
            if (c = Gn(e, o, r, a), !c) return !1;
            a += c.length;
        }
        return e.write(se.from([
            ue.codes.disconnect << 4
        ])), nt(e, a), n === 5 && e.write(se.from([
            s
        ])), c !== null && c.write(), !0;
    }
    function bE(t, e, r) {
        let n = r ? r.protocolVersion : 4, i = t || {}, s = i.reasonCode, o = i.properties, a = n === 5 ? 1 : 0;
        n !== 5 && e.destroy(new Error("Invalid mqtt version for auth packet"));
        let c = Gn(e, o, r, a);
        return c ? (a += c.length, e.write(se.from([
            ue.codes.auth << 4
        ])), nt(e, a), e.write(se.from([
            s
        ])), c !== null && c.write(), !0) : !1;
    }
    var Qp = {};
    function nt(t, e) {
        if (e > ue.VARBYTEINT_MAX) return t.destroy(new Error(`Invalid variable byte integer: ${e}`)), !1;
        let r = Qp[e];
        return r || (r = ka(e), e < 16384 && (Qp[e] = r)), rt("writeVarByteInt: writing to stream: %o", r), t.write(r);
    }
    function Br(t, e) {
        let r = se.byteLength(e);
        return He(t, r), rt("writeString: %s", e), t.write(e, "utf8");
    }
    function Yp(t, e, r) {
        Br(t, e), Br(t, r);
    }
    function Ca(t, e) {
        return rt("writeNumberCached: number: %d", e), rt("writeNumberCached: %o", yo[e]), t.write(yo[e]);
    }
    function wE(t, e) {
        let r = nE(e);
        return rt("writeNumberGenerated: %o", r), t.write(r);
    }
    function mE(t, e) {
        let r = oE(e);
        return rt("write4ByteNumber: %o", r), t.write(r);
    }
    function pn(t, e) {
        typeof e == "string" ? Br(t, e) : e ? (He(t, e.length), t.write(e)) : He(t, 0);
    }
    function ar(t, e) {
        if (typeof e != "object" || e.length != null) return {
            length: 1,
            write () {
                Xp(t, {}, 0);
            }
        };
        let r = 0;
        function n(s, o) {
            let a = ue.propertiesTypes[s], c = 0;
            switch(a){
                case "byte":
                    if (typeof o != "boolean") return t.destroy(new Error(`Invalid ${s}: ${o}`)), !1;
                    c += 2;
                    break;
                case "int8":
                    if (typeof o != "number" || o < 0 || o > 255) return t.destroy(new Error(`Invalid ${s}: ${o}`)), !1;
                    c += 2;
                    break;
                case "binary":
                    if (o && o === null) return t.destroy(new Error(`Invalid ${s}: ${o}`)), !1;
                    c += 1 + se.byteLength(o) + 2;
                    break;
                case "int16":
                    if (typeof o != "number" || o < 0 || o > 65535) return t.destroy(new Error(`Invalid ${s}: ${o}`)), !1;
                    c += 3;
                    break;
                case "int32":
                    if (typeof o != "number" || o < 0 || o > 4294967295) return t.destroy(new Error(`Invalid ${s}: ${o}`)), !1;
                    c += 5;
                    break;
                case "var":
                    if (typeof o != "number" || o < 0 || o > 268435455) return t.destroy(new Error(`Invalid ${s}: ${o}`)), !1;
                    c += 1 + se.byteLength(ka(o));
                    break;
                case "string":
                    if (typeof o != "string") return t.destroy(new Error(`Invalid ${s}: ${o}`)), !1;
                    c += 3 + se.byteLength(o.toString());
                    break;
                case "pair":
                    if (typeof o != "object") return t.destroy(new Error(`Invalid ${s}: ${o}`)), !1;
                    c += Object.getOwnPropertyNames(o).reduce((f, h)=>{
                        let d = o[h];
                        return Array.isArray(d) ? f += d.reduce((w, y)=>(w += 3 + se.byteLength(h.toString()) + 2 + se.byteLength(y.toString()), w), 0) : f += 3 + se.byteLength(h.toString()) + 2 + se.byteLength(o[h].toString()), f;
                    }, 0);
                    break;
                default:
                    return t.destroy(new Error(`Invalid property ${s}: ${o}`)), !1;
            }
            return c;
        }
        if (e) for(let s in e){
            let o = 0, a = 0, c = e[s];
            if (c !== void 0) {
                if (Array.isArray(c)) for(let f = 0; f < c.length; f++){
                    if (a = n(s, c[f]), !a) return !1;
                    o += a;
                }
                else {
                    if (a = n(s, c), !a) return !1;
                    o = a;
                }
                if (!o) return !1;
                r += o;
            }
        }
        return {
            length: se.byteLength(ka(r)) + r,
            write () {
                Xp(t, e, r);
            }
        };
    }
    function Gn(t, e, r, n) {
        let i = [
            "reasonString",
            "userProperties"
        ], s = r && r.properties && r.properties.maximumPacketSize ? r.properties.maximumPacketSize : 0, o = ar(t, e);
        if (s) for(; n + o.length > s;){
            let a = i.shift();
            if (a && e[a]) delete e[a], o = ar(t, e);
            else return !1;
        }
        return o;
    }
    function Jp(t, e, r) {
        switch(ue.propertiesTypes[e]){
            case "byte":
                t.write(se.from([
                    ue.properties[e]
                ])), t.write(se.from([
                    +r
                ]));
                break;
            case "int8":
                t.write(se.from([
                    ue.properties[e]
                ])), t.write(se.from([
                    r
                ]));
                break;
            case "binary":
                t.write(se.from([
                    ue.properties[e]
                ])), pn(t, r);
                break;
            case "int16":
                t.write(se.from([
                    ue.properties[e]
                ])), He(t, r);
                break;
            case "int32":
                t.write(se.from([
                    ue.properties[e]
                ])), mE(t, r);
                break;
            case "var":
                t.write(se.from([
                    ue.properties[e]
                ])), nt(t, r);
                break;
            case "string":
                t.write(se.from([
                    ue.properties[e]
                ])), Br(t, r);
                break;
            case "pair":
                Object.getOwnPropertyNames(r).forEach((i)=>{
                    let s = r[i];
                    Array.isArray(s) ? s.forEach((o)=>{
                        t.write(se.from([
                            ue.properties[e]
                        ])), Yp(t, i.toString(), o.toString());
                    }) : (t.write(se.from([
                        ue.properties[e]
                    ])), Yp(t, i.toString(), s.toString()));
                });
                break;
            default:
                return t.destroy(new Error(`Invalid property ${e} value: ${r}`)), !1;
        }
    }
    function Xp(t, e, r) {
        nt(t, r);
        for(let n in e)if (Object.prototype.hasOwnProperty.call(e, n) && e[n] != null) {
            let i = e[n];
            if (Array.isArray(i)) for(let s = 0; s < i.length; s++)Jp(t, n, i[s]);
            else Jp(t, n, i);
        }
    }
    function ty(t) {
        return t ? t instanceof se ? t.length : se.byteLength(t) : 0;
    }
    function Zp(t) {
        return typeof t == "string" || t instanceof se;
    }
    ry.exports = ey;
});
var $4c2dd1b68d143d96$var$oy = $4c2dd1b68d143d96$var$D((_N, iy)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var _E = $4c2dd1b68d143d96$var$Ba(), { EventEmitter: vE } = ($4c2dd1b68d143d96$var$er(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$Zt)), { Buffer: ny } = ($4c2dd1b68d143d96$var$ke(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$qe));
    function SE(t, e) {
        let r = new Ma;
        return _E(t, r, e), r.concat();
    }
    var Ma = class extends vE {
        constructor(){
            super(), this._array = new Array(20), this._i = 0;
        }
        write(e) {
            return this._array[this._i++] = e, !0;
        }
        concat() {
            let e = 0, r = new Array(this._array.length), n = this._array, i = 0, s;
            for(s = 0; s < n.length && n[s] !== void 0; s++)typeof n[s] != "string" ? r[s] = n[s].length : r[s] = ny.byteLength(n[s]), e += r[s];
            let o = ny.allocUnsafe(e);
            for(s = 0; s < n.length && n[s] !== void 0; s++)typeof n[s] != "string" ? (n[s].copy(o, i), i += r[s]) : (o.write(n[s], i), i += r[s]);
            return o;
        }
        destroy(e) {
            e && this.emit("error", e);
        }
    };
    iy.exports = SE;
});
var $4c2dd1b68d143d96$var$sy = $4c2dd1b68d143d96$var$D((bo)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    bo.parser = $4c2dd1b68d143d96$var$$p().parser;
    bo.generate = $4c2dd1b68d143d96$var$oy();
    bo.writeToStream = $4c2dd1b68d143d96$var$Ba();
});
var $4c2dd1b68d143d96$var$uy = $4c2dd1b68d143d96$var$D((jN, ay)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    ay.exports = EE;
    function yn(t) {
        return t instanceof $4c2dd1b68d143d96$var$U ? $4c2dd1b68d143d96$var$U.from(t) : new t.constructor(t.buffer.slice(), t.byteOffset, t.length);
    }
    function EE(t) {
        if (t = t || {}, t.circles) return AE(t);
        let e = new Map;
        if (e.set(Date, (o)=>new Date(o)), e.set(Map, (o, a)=>new Map(n(Array.from(o), a))), e.set(Set, (o, a)=>new Set(n(Array.from(o), a))), t.constructorHandlers) for (let o of t.constructorHandlers)e.set(o[0], o[1]);
        let r = null;
        return t.proto ? s : i;
        function n(o, a) {
            let c = Object.keys(o), f = new Array(c.length);
            for(let h = 0; h < c.length; h++){
                let d = c[h], w = o[d];
                typeof w != "object" || w === null ? f[d] = w : w.constructor !== Object && (r = e.get(w.constructor)) ? f[d] = r(w, a) : ArrayBuffer.isView(w) ? f[d] = yn(w) : f[d] = a(w);
            }
            return f;
        }
        function i(o) {
            if (typeof o != "object" || o === null) return o;
            if (Array.isArray(o)) return n(o, i);
            if (o.constructor !== Object && (r = e.get(o.constructor))) return r(o, i);
            let a = {};
            for(let c in o){
                if (Object.hasOwnProperty.call(o, c) === !1) continue;
                let f = o[c];
                typeof f != "object" || f === null ? a[c] = f : f.constructor !== Object && (r = e.get(f.constructor)) ? a[c] = r(f, i) : ArrayBuffer.isView(f) ? a[c] = yn(f) : a[c] = i(f);
            }
            return a;
        }
        function s(o) {
            if (typeof o != "object" || o === null) return o;
            if (Array.isArray(o)) return n(o, s);
            if (o.constructor !== Object && (r = e.get(o.constructor))) return r(o, s);
            let a = {};
            for(let c in o){
                let f = o[c];
                typeof f != "object" || f === null ? a[c] = f : f.constructor !== Object && (r = e.get(f.constructor)) ? a[c] = r(f, s) : ArrayBuffer.isView(f) ? a[c] = yn(f) : a[c] = s(f);
            }
            return a;
        }
    }
    function AE(t) {
        let e = [], r = [], n = new Map;
        if (n.set(Date, (c)=>new Date(c)), n.set(Map, (c, f)=>new Map(s(Array.from(c), f))), n.set(Set, (c, f)=>new Set(s(Array.from(c), f))), t.constructorHandlers) for (let c of t.constructorHandlers)n.set(c[0], c[1]);
        let i = null;
        return t.proto ? a : o;
        function s(c, f) {
            let h = Object.keys(c), d = new Array(h.length);
            for(let w = 0; w < h.length; w++){
                let y = h[w], P = c[y];
                if (typeof P != "object" || P === null) d[y] = P;
                else if (P.constructor !== Object && (i = n.get(P.constructor))) d[y] = i(P, f);
                else if (ArrayBuffer.isView(P)) d[y] = yn(P);
                else {
                    let E = e.indexOf(P);
                    E !== -1 ? d[y] = r[E] : d[y] = f(P);
                }
            }
            return d;
        }
        function o(c) {
            if (typeof c != "object" || c === null) return c;
            if (Array.isArray(c)) return s(c, o);
            if (c.constructor !== Object && (i = n.get(c.constructor))) return i(c, o);
            let f = {};
            e.push(c), r.push(f);
            for(let h in c){
                if (Object.hasOwnProperty.call(c, h) === !1) continue;
                let d = c[h];
                if (typeof d != "object" || d === null) f[h] = d;
                else if (d.constructor !== Object && (i = n.get(d.constructor))) f[h] = i(d, o);
                else if (ArrayBuffer.isView(d)) f[h] = yn(d);
                else {
                    let w = e.indexOf(d);
                    w !== -1 ? f[h] = r[w] : f[h] = o(d);
                }
            }
            return e.pop(), r.pop(), f;
        }
        function a(c) {
            if (typeof c != "object" || c === null) return c;
            if (Array.isArray(c)) return s(c, a);
            if (c.constructor !== Object && (i = n.get(c.constructor))) return i(c, a);
            let f = {};
            e.push(c), r.push(f);
            for(let h in c){
                let d = c[h];
                if (typeof d != "object" || d === null) f[h] = d;
                else if (d.constructor !== Object && (i = n.get(d.constructor))) f[h] = i(d, a);
                else if (ArrayBuffer.isView(d)) f[h] = yn(d);
                else {
                    let w = e.indexOf(d);
                    w !== -1 ? f[h] = r[w] : f[h] = a(d);
                }
            }
            return e.pop(), r.pop(), f;
        }
    }
});
var $4c2dd1b68d143d96$var$cy = $4c2dd1b68d143d96$var$D((YN, ly)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    ly.exports = $4c2dd1b68d143d96$var$uy()();
});
var $4c2dd1b68d143d96$var$Na = $4c2dd1b68d143d96$var$D((wo)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(wo, "__esModule", {
        value: !0
    });
    wo.validateTopic = fy;
    wo.validateTopics = IE;
    function fy(t) {
        let e = t.split("/");
        for(let r = 0; r < e.length; r++)if (e[r] !== "+") {
            if (e[r] === "#") return r === e.length - 1;
            if (e[r].indexOf("+") !== -1 || e[r].indexOf("#") !== -1) return !1;
        }
        return !0;
    }
    function IE(t) {
        if (t.length === 0) return "empty_topic_list";
        for(let e = 0; e < t.length; e++)if (!fy(t[e])) return t[e];
        return null;
    }
});
var $4c2dd1b68d143d96$var$Ua = $4c2dd1b68d143d96$var$D((La)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(La, "__esModule", {
        value: !0
    });
    var xE = $4c2dd1b68d143d96$var$or(), TE = {
        objectMode: !0
    }, PE = {
        clean: !0
    }, qa = class {
        options;
        _inflights;
        constructor(e){
            this.options = e || {}, this.options = {
                ...PE,
                ...e
            }, this._inflights = new Map;
        }
        put(e, r) {
            return this._inflights.set(e.messageId, e), r && r(), this;
        }
        createStream() {
            let e = new xE.Readable(TE), r = [], n = !1, i = 0;
            return this._inflights.forEach((s, o)=>{
                r.push(s);
            }), e._read = ()=>{
                !n && i < r.length ? e.push(r[i++]) : e.push(null);
            }, e.destroy = (s)=>{
                if (!n) return n = !0, setTimeout(()=>{
                    e.emit("close");
                }, 0), e;
            }, e;
        }
        del(e, r) {
            let n = this._inflights.get(e.messageId);
            return n ? (this._inflights.delete(e.messageId), r(null, n)) : r && r(new Error("missing packet")), this;
        }
        get(e, r) {
            let n = this._inflights.get(e.messageId);
            return n ? r(null, n) : r && r(new Error("missing packet")), this;
        }
        close(e) {
            this.options.clean && (this._inflights = null), e && e();
        }
    };
    La.default = qa;
});
var $4c2dd1b68d143d96$var$dy = $4c2dd1b68d143d96$var$D((Da)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Da, "__esModule", {
        value: !0
    });
    var hy = [
        0,
        16,
        128,
        131,
        135,
        144,
        145,
        151,
        153
    ], OE = (t, e, r)=>{
        t.log("handlePublish: packet %o", e), r = typeof r < "u" ? r : t.noop;
        let n = e.topic.toString(), i = e.payload, { qos: s } = e, { messageId: o } = e, { options: a } = t;
        if (t.options.protocolVersion === 5) {
            let c;
            if (e.properties && (c = e.properties.topicAlias), typeof c < "u") {
                if (n.length === 0) {
                    if (c > 0 && c <= 65535) {
                        let f = t.topicAliasRecv.getTopicByAlias(c);
                        if (f) n = f, t.log("handlePublish :: topic complemented by alias. topic: %s - alias: %d", n, c);
                        else {
                            t.log("handlePublish :: unregistered topic alias. alias: %d", c), t.emit("error", new Error("Received unregistered Topic Alias"));
                            return;
                        }
                    } else {
                        t.log("handlePublish :: topic alias out of range. alias: %d", c), t.emit("error", new Error("Received Topic Alias is out of range"));
                        return;
                    }
                } else if (t.topicAliasRecv.put(n, c)) t.log("handlePublish :: registered topic: %s - alias: %d", n, c);
                else {
                    t.log("handlePublish :: topic alias out of range. alias: %d", c), t.emit("error", new Error("Received Topic Alias is out of range"));
                    return;
                }
            }
        }
        switch(t.log("handlePublish: qos %d", s), s){
            case 2:
                a.customHandleAcks(n, i, e, (c, f)=>{
                    if (typeof c == "number" && (f = c, c = null), c) return t.emit("error", c);
                    if (hy.indexOf(f) === -1) return t.emit("error", new Error("Wrong reason code for pubrec"));
                    f ? t._sendPacket({
                        cmd: "pubrec",
                        messageId: o,
                        reasonCode: f
                    }, r) : t.incomingStore.put(e, ()=>{
                        t._sendPacket({
                            cmd: "pubrec",
                            messageId: o
                        }, r);
                    });
                });
                break;
            case 1:
                a.customHandleAcks(n, i, e, (c, f)=>{
                    if (typeof c == "number" && (f = c, c = null), c) return t.emit("error", c);
                    if (hy.indexOf(f) === -1) return t.emit("error", new Error("Wrong reason code for puback"));
                    f || t.emit("message", n, i, e), t.handleMessage(e, (h)=>{
                        if (h) return r && r(h);
                        t._sendPacket({
                            cmd: "puback",
                            messageId: o,
                            reasonCode: f
                        }, r);
                    });
                });
                break;
            case 0:
                t.emit("message", n, i, e), t.handleMessage(e, r);
                break;
            default:
                t.log("handlePublish: unknown QoS. Doing nothing.");
                break;
        }
    };
    Da.default = OE;
});
var $4c2dd1b68d143d96$var$py = $4c2dd1b68d143d96$var$D((qq, RE)=>{
    RE.exports = {
        version: "5.15.0"
    };
});
var $4c2dd1b68d143d96$var$Mr = $4c2dd1b68d143d96$var$D((ht)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(ht, "__esModule", {
        value: !0
    });
    ht.MQTTJS_VERSION = ht.nextTick = ht.ErrorWithSubackPacket = ht.ErrorWithReasonCode = void 0;
    ht.applyMixin = kE;
    var ja = class t extends Error {
        code;
        constructor(e, r){
            super(e), this.code = r, Object.setPrototypeOf(this, t.prototype), Object.getPrototypeOf(this).name = "ErrorWithReasonCode";
        }
    };
    ht.ErrorWithReasonCode = ja;
    var Fa = class t extends Error {
        packet;
        constructor(e, r){
            super(e), this.packet = r, Object.setPrototypeOf(this, t.prototype), Object.getPrototypeOf(this).name = "ErrorWithSubackPacket";
        }
    };
    ht.ErrorWithSubackPacket = Fa;
    function kE(t, e, r = !1) {
        let n = [
            e
        ];
        for(;;){
            let i = n[0], s = Object.getPrototypeOf(i);
            if (s?.prototype) n.unshift(s);
            else break;
        }
        for (let i of n)for (let s of Object.getOwnPropertyNames(i.prototype))(r || s !== "constructor") && Object.defineProperty(t.prototype, s, Object.getOwnPropertyDescriptor(i.prototype, s) ?? Object.create(null));
    }
    ht.nextTick = typeof $4c2dd1b68d143d96$var$M?.nextTick == "function" ? $4c2dd1b68d143d96$var$M.nextTick : (t)=>{
        setTimeout(t, 0);
    };
    ht.MQTTJS_VERSION = $4c2dd1b68d143d96$var$py().version;
});
var $4c2dd1b68d143d96$var$zn = $4c2dd1b68d143d96$var$D((ur)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(ur, "__esModule", {
        value: !0
    });
    ur.ReasonCodes = void 0;
    var yy = $4c2dd1b68d143d96$var$Mr();
    ur.ReasonCodes = {
        0: "",
        1: "Unacceptable protocol version",
        2: "Identifier rejected",
        3: "Server unavailable",
        4: "Bad username or password",
        5: "Not authorized",
        16: "No matching subscribers",
        17: "No subscription existed",
        128: "Unspecified error",
        129: "Malformed Packet",
        130: "Protocol Error",
        131: "Implementation specific error",
        132: "Unsupported Protocol Version",
        133: "Client Identifier not valid",
        134: "Bad User Name or Password",
        135: "Not authorized",
        136: "Server unavailable",
        137: "Server busy",
        138: "Banned",
        139: "Server shutting down",
        140: "Bad authentication method",
        141: "Keep Alive timeout",
        142: "Session taken over",
        143: "Topic Filter invalid",
        144: "Topic Name invalid",
        145: "Packet identifier in use",
        146: "Packet Identifier not found",
        147: "Receive Maximum exceeded",
        148: "Topic Alias invalid",
        149: "Packet too large",
        150: "Message rate too high",
        151: "Quota exceeded",
        152: "Administrative action",
        153: "Payload format invalid",
        154: "Retain not supported",
        155: "QoS not supported",
        156: "Use another server",
        157: "Server moved",
        158: "Shared Subscriptions not supported",
        159: "Connection rate exceeded",
        160: "Maximum connect time",
        161: "Subscription Identifiers not supported",
        162: "Wildcard Subscriptions not supported"
    };
    var CE = (t, e)=>{
        let { messageId: r } = e, n = e.cmd, i = null, s = t.outgoing[r] ? t.outgoing[r].cb : null, o = null;
        if (!s) {
            t.log("_handleAck :: Server sent an ack in error. Ignoring.");
            return;
        }
        switch(t.log("_handleAck :: packet type", n), n){
            case "pubcomp":
            case "puback":
                {
                    let a = e.reasonCode;
                    a && a > 0 && a !== 16 ? (o = new yy.ErrorWithReasonCode(`Publish error: ${ur.ReasonCodes[a]}`, a), t._removeOutgoingAndStoreMessage(r, ()=>{
                        s(o, e);
                    })) : t._removeOutgoingAndStoreMessage(r, s);
                    break;
                }
            case "pubrec":
                {
                    i = {
                        cmd: "pubrel",
                        qos: 2,
                        messageId: r
                    };
                    let a = e.reasonCode;
                    a && a > 0 && a !== 16 ? (o = new yy.ErrorWithReasonCode(`Publish error: ${ur.ReasonCodes[a]}`, a), t._removeOutgoingAndStoreMessage(r, ()=>{
                        s(o, e);
                    })) : t._sendPacket(i);
                    break;
                }
            case "suback":
                {
                    delete t.outgoing[r], t.messageIdProvider.deallocate(r);
                    let a = e.granted;
                    for(let c = 0; c < a.length; c++){
                        let f = a[c];
                        if ((f & 128) !== 0) {
                            o = new Error(`Subscribe error: ${ur.ReasonCodes[f]}`), o.code = f;
                            let h = t.messageIdToTopic[r];
                            h && h.forEach((d)=>{
                                delete t._resubscribeTopics[d];
                            });
                        }
                    }
                    delete t.messageIdToTopic[r], t._invokeStoreProcessingQueue(), s(o, e);
                    break;
                }
            case "unsuback":
                delete t.outgoing[r], t.messageIdProvider.deallocate(r), t._invokeStoreProcessingQueue(), s(null, e);
                break;
            default:
                t.emit("error", new Error("unrecognized packet type"));
        }
        t.disconnecting && Object.keys(t.outgoing).length === 0 && t.emit("outgoingEmpty");
    };
    ur.default = CE;
});
var $4c2dd1b68d143d96$var$by = $4c2dd1b68d143d96$var$D((Wa)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Wa, "__esModule", {
        value: !0
    });
    var gy = $4c2dd1b68d143d96$var$Mr(), BE = $4c2dd1b68d143d96$var$zn(), ME = (t, e)=>{
        let { options: r } = t, n = r.protocolVersion, i = n === 5 ? e.reasonCode : e.returnCode;
        if (n !== 5) {
            let s = new gy.ErrorWithReasonCode(`Protocol error: Auth packets are only supported in MQTT 5. Your version:${n}`, i);
            t.emit("error", s);
            return;
        }
        t.handleAuth(e, (s, o)=>{
            if (s) {
                t.emit("error", s);
                return;
            }
            if (i === 24) t.reconnecting = !1, t._sendPacket(o);
            else {
                let a = new gy.ErrorWithReasonCode(`Connection refused: ${BE.ReasonCodes[i]}`, i);
                t.emit("error", a);
            }
        });
    };
    Wa.default = ME;
});
var $4c2dd1b68d143d96$var$Sy = $4c2dd1b68d143d96$var$D((_o)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(_o, "__esModule", {
        value: !0
    });
    _o.LRUCache = void 0;
    var gn = typeof performance == "object" && performance && typeof performance.now == "function" ? performance : Date, my = new Set, $a = typeof $4c2dd1b68d143d96$var$M == "object" && $4c2dd1b68d143d96$var$M ? $4c2dd1b68d143d96$var$M : {}, _y = (t, e, r, n)=>{
        typeof $a.emitWarning == "function" ? $a.emitWarning(t, e, r, n) : console.error(`[${r}] ${e}: ${t}`);
    }, mo = globalThis.AbortController, wy = globalThis.AbortSignal;
    if (typeof mo > "u") {
        wy = class {
            onabort;
            _onabort = [];
            reason;
            aborted = !1;
            addEventListener(n, i) {
                this._onabort.push(i);
            }
        }, mo = class {
            constructor(){
                e();
            }
            signal = new wy;
            abort(n) {
                if (!this.signal.aborted) {
                    this.signal.reason = n, this.signal.aborted = !0;
                    for (let i of this.signal._onabort)i(n);
                    this.signal.onabort?.(n);
                }
            }
        };
        let t = $a.env?.LRU_CACHE_IGNORE_AC_WARNING !== "1", e = ()=>{
            t && (t = !1, _y("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", "NO_ABORT_CONTROLLER", "ENOTSUP", e));
        };
    }
    var NE = (t)=>!my.has(t), yL = Symbol("type"), lr = (t)=>t && t === Math.floor(t) && t > 0 && isFinite(t), vy = (t)=>lr(t) ? t <= Math.pow(2, 8) ? Uint8Array : t <= Math.pow(2, 16) ? Uint16Array : t <= Math.pow(2, 32) ? Uint32Array : t <= Number.MAX_SAFE_INTEGER ? bn : null : null, bn = class extends Array {
        constructor(e){
            super(e), this.fill(0);
        }
    }, Ha = class t {
        heap;
        length;
        static #u = !1;
        static create(e) {
            let r = vy(e);
            if (!r) return [];
            t.#u = !0;
            let n = new t(e, r);
            return t.#u = !1, n;
        }
        constructor(e, r){
            if (!t.#u) throw new TypeError("instantiate Stack using Stack.create(n)");
            this.heap = new r(e), this.length = 0;
        }
        push(e) {
            this.heap[this.length++] = e;
        }
        pop() {
            return this.heap[--this.length];
        }
    }, Va = class t {
        #u;
        #f;
        #y;
        #g;
        #R;
        #k;
        ttl;
        ttlResolution;
        ttlAutopurge;
        updateAgeOnGet;
        updateAgeOnHas;
        allowStale;
        noDisposeOnSet;
        noUpdateTTL;
        maxEntrySize;
        sizeCalculation;
        noDeleteOnFetchRejection;
        noDeleteOnStaleGet;
        allowStaleOnFetchAbort;
        allowStaleOnFetchRejection;
        ignoreFetchAbort;
        #i;
        #b;
        #n;
        #r;
        #e;
        #l;
        #h;
        #a;
        #o;
        #w;
        #s;
        #m;
        #_;
        #d;
        #v;
        #x;
        #c;
        static unsafeExposeInternals(e) {
            return {
                starts: e.#_,
                ttls: e.#d,
                sizes: e.#m,
                keyMap: e.#n,
                keyList: e.#r,
                valList: e.#e,
                next: e.#l,
                prev: e.#h,
                get head () {
                    return e.#a;
                },
                get tail () {
                    return e.#o;
                },
                free: e.#w,
                isBackgroundFetch: (r)=>e.#t(r),
                backgroundFetch: (r, n, i, s)=>e.#M(r, n, i, s),
                moveToTail: (r)=>e.#O(r),
                indexes: (r)=>e.#S(r),
                rindexes: (r)=>e.#E(r),
                isStale: (r)=>e.#p(r)
            };
        }
        get max() {
            return this.#u;
        }
        get maxSize() {
            return this.#f;
        }
        get calculatedSize() {
            return this.#b;
        }
        get size() {
            return this.#i;
        }
        get fetchMethod() {
            return this.#R;
        }
        get memoMethod() {
            return this.#k;
        }
        get dispose() {
            return this.#y;
        }
        get disposeAfter() {
            return this.#g;
        }
        constructor(e){
            let { max: r = 0, ttl: n, ttlResolution: i = 1, ttlAutopurge: s, updateAgeOnGet: o, updateAgeOnHas: a, allowStale: c, dispose: f, disposeAfter: h, noDisposeOnSet: d, noUpdateTTL: w, maxSize: y = 0, maxEntrySize: P = 0, sizeCalculation: E, fetchMethod: b, memoMethod: m, noDeleteOnFetchRejection: v, noDeleteOnStaleGet: R, allowStaleOnFetchRejection: T, allowStaleOnFetchAbort: g, ignoreFetchAbort: O } = e;
            if (r !== 0 && !lr(r)) throw new TypeError("max option must be a nonnegative integer");
            let _ = r ? vy(r) : Array;
            if (!_) throw new Error("invalid max value: " + r);
            if (this.#u = r, this.#f = y, this.maxEntrySize = P || this.#f, this.sizeCalculation = E, this.sizeCalculation) {
                if (!this.#f && !this.maxEntrySize) throw new TypeError("cannot set sizeCalculation without setting maxSize or maxEntrySize");
                if (typeof this.sizeCalculation != "function") throw new TypeError("sizeCalculation set to non-function");
            }
            if (m !== void 0 && typeof m != "function") throw new TypeError("memoMethod must be a function if defined");
            if (this.#k = m, b !== void 0 && typeof b != "function") throw new TypeError("fetchMethod must be a function if specified");
            if (this.#R = b, this.#x = !!b, this.#n = new Map, this.#r = new Array(r).fill(void 0), this.#e = new Array(r).fill(void 0), this.#l = new _(r), this.#h = new _(r), this.#a = 0, this.#o = 0, this.#w = Ha.create(r), this.#i = 0, this.#b = 0, typeof f == "function" && (this.#y = f), typeof h == "function" ? (this.#g = h, this.#s = []) : (this.#g = void 0, this.#s = void 0), this.#v = !!this.#y, this.#c = !!this.#g, this.noDisposeOnSet = !!d, this.noUpdateTTL = !!w, this.noDeleteOnFetchRejection = !!v, this.allowStaleOnFetchRejection = !!T, this.allowStaleOnFetchAbort = !!g, this.ignoreFetchAbort = !!O, this.maxEntrySize !== 0) {
                if (this.#f !== 0 && !lr(this.#f)) throw new TypeError("maxSize must be a positive integer if specified");
                if (!lr(this.maxEntrySize)) throw new TypeError("maxEntrySize must be a positive integer if specified");
                this.#F();
            }
            if (this.allowStale = !!c, this.noDeleteOnStaleGet = !!R, this.updateAgeOnGet = !!o, this.updateAgeOnHas = !!a, this.ttlResolution = lr(i) || i === 0 ? i : 1, this.ttlAutopurge = !!s, this.ttl = n || 0, this.ttl) {
                if (!lr(this.ttl)) throw new TypeError("ttl must be a positive integer if specified");
                this.#N();
            }
            if (this.#u === 0 && this.ttl === 0 && this.#f === 0) throw new TypeError("At least one of max, maxSize, or ttl is required");
            if (!this.ttlAutopurge && !this.#u && !this.#f) {
                let q = "LRU_CACHE_UNBOUNDED";
                NE(q) && (my.add(q), _y("TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.", "UnboundedCacheWarning", q, t));
            }
        }
        getRemainingTTL(e) {
            return this.#n.has(e) ? 1 / 0 : 0;
        }
        #N() {
            let e = new bn(this.#u), r = new bn(this.#u);
            this.#d = e, this.#_ = r, this.#q = (s, o, a = gn.now())=>{
                if (r[s] = o !== 0 ? a : 0, e[s] = o, o !== 0 && this.ttlAutopurge) {
                    let c = setTimeout(()=>{
                        this.#p(s) && this.#A(this.#r[s], "expire");
                    }, o + 1);
                    c.unref && c.unref();
                }
            }, this.#T = (s)=>{
                r[s] = e[s] !== 0 ? gn.now() : 0;
            }, this.#I = (s, o)=>{
                if (e[o]) {
                    let a = e[o], c = r[o];
                    if (!a || !c) return;
                    s.ttl = a, s.start = c, s.now = n || i();
                    let f = s.now - c;
                    s.remainingTTL = a - f;
                }
            };
            let n = 0, i = ()=>{
                let s = gn.now();
                if (this.ttlResolution > 0) {
                    n = s;
                    let o = setTimeout(()=>n = 0, this.ttlResolution);
                    o.unref && o.unref();
                }
                return s;
            };
            this.getRemainingTTL = (s)=>{
                let o = this.#n.get(s);
                if (o === void 0) return 0;
                let a = e[o], c = r[o];
                if (!a || !c) return 1 / 0;
                let f = (n || i()) - c;
                return a - f;
            }, this.#p = (s)=>{
                let o = r[s], a = e[s];
                return !!a && !!o && (n || i()) - o > a;
            };
        }
        #T = ()=>{};
        #I = ()=>{};
        #q = ()=>{};
        #p = ()=>!1;
        #F() {
            let e = new bn(this.#u);
            this.#b = 0, this.#m = e, this.#P = (r)=>{
                this.#b -= e[r], e[r] = 0;
            }, this.#L = (r, n, i, s)=>{
                if (this.#t(n)) return 0;
                if (!lr(i)) {
                    if (s) {
                        if (typeof s != "function") throw new TypeError("sizeCalculation must be a function");
                        if (i = s(n, r), !lr(i)) throw new TypeError("sizeCalculation return invalid (expect positive integer)");
                    } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
                }
                return i;
            }, this.#C = (r, n, i)=>{
                if (e[r] = n, this.#f) {
                    let s = this.#f - e[r];
                    for(; this.#b > s;)this.#B(!0);
                }
                this.#b += e[r], i && (i.entrySize = n, i.totalCalculatedSize = this.#b);
            };
        }
        #P = (e)=>{};
        #C = (e, r, n)=>{};
        #L = (e, r, n, i)=>{
            if (n || i) throw new TypeError("cannot set size without setting maxSize or maxEntrySize on cache");
            return 0;
        };
        *#S({ allowStale: e = this.allowStale } = {}) {
            if (this.#i) for(let r = this.#o; !(!this.#U(r) || ((e || !this.#p(r)) && (yield r), r === this.#a));)r = this.#h[r];
        }
        *#E({ allowStale: e = this.allowStale } = {}) {
            if (this.#i) for(let r = this.#a; !(!this.#U(r) || ((e || !this.#p(r)) && (yield r), r === this.#o));)r = this.#l[r];
        }
        #U(e) {
            return e !== void 0 && this.#n.get(this.#r[e]) === e;
        }
        *entries() {
            for (let e of this.#S())this.#e[e] !== void 0 && this.#r[e] !== void 0 && !this.#t(this.#e[e]) && (yield [
                this.#r[e],
                this.#e[e]
            ]);
        }
        *rentries() {
            for (let e of this.#E())this.#e[e] !== void 0 && this.#r[e] !== void 0 && !this.#t(this.#e[e]) && (yield [
                this.#r[e],
                this.#e[e]
            ]);
        }
        *keys() {
            for (let e of this.#S()){
                let r = this.#r[e];
                r !== void 0 && !this.#t(this.#e[e]) && (yield r);
            }
        }
        *rkeys() {
            for (let e of this.#E()){
                let r = this.#r[e];
                r !== void 0 && !this.#t(this.#e[e]) && (yield r);
            }
        }
        *values() {
            for (let e of this.#S())this.#e[e] !== void 0 && !this.#t(this.#e[e]) && (yield this.#e[e]);
        }
        *rvalues() {
            for (let e of this.#E())this.#e[e] !== void 0 && !this.#t(this.#e[e]) && (yield this.#e[e]);
        }
        [Symbol.iterator]() {
            return this.entries();
        }
        [Symbol.toStringTag] = "LRUCache";
        find(e, r = {}) {
            for (let n of this.#S()){
                let i = this.#e[n], s = this.#t(i) ? i.__staleWhileFetching : i;
                if (s !== void 0 && e(s, this.#r[n], this)) return this.get(this.#r[n], r);
            }
        }
        forEach(e, r = this) {
            for (let n of this.#S()){
                let i = this.#e[n], s = this.#t(i) ? i.__staleWhileFetching : i;
                s !== void 0 && e.call(r, s, this.#r[n], this);
            }
        }
        rforEach(e, r = this) {
            for (let n of this.#E()){
                let i = this.#e[n], s = this.#t(i) ? i.__staleWhileFetching : i;
                s !== void 0 && e.call(r, s, this.#r[n], this);
            }
        }
        purgeStale() {
            let e = !1;
            for (let r of this.#E({
                allowStale: !0
            }))this.#p(r) && (this.#A(this.#r[r], "expire"), e = !0);
            return e;
        }
        info(e) {
            let r = this.#n.get(e);
            if (r === void 0) return;
            let n = this.#e[r], i = this.#t(n) ? n.__staleWhileFetching : n;
            if (i === void 0) return;
            let s = {
                value: i
            };
            if (this.#d && this.#_) {
                let o = this.#d[r], a = this.#_[r];
                if (o && a) {
                    let c = o - (gn.now() - a);
                    s.ttl = c, s.start = Date.now();
                }
            }
            return this.#m && (s.size = this.#m[r]), s;
        }
        dump() {
            let e = [];
            for (let r of this.#S({
                allowStale: !0
            })){
                let n = this.#r[r], i = this.#e[r], s = this.#t(i) ? i.__staleWhileFetching : i;
                if (s === void 0 || n === void 0) continue;
                let o = {
                    value: s
                };
                if (this.#d && this.#_) {
                    o.ttl = this.#d[r];
                    let a = gn.now() - this.#_[r];
                    o.start = Math.floor(Date.now() - a);
                }
                this.#m && (o.size = this.#m[r]), e.unshift([
                    n,
                    o
                ]);
            }
            return e;
        }
        load(e) {
            this.clear();
            for (let [r, n] of e){
                if (n.start) {
                    let i = Date.now() - n.start;
                    n.start = gn.now() - i;
                }
                this.set(r, n.value, n);
            }
        }
        set(e, r, n = {}) {
            if (r === void 0) return this.delete(e), this;
            let { ttl: i = this.ttl, start: s, noDisposeOnSet: o = this.noDisposeOnSet, sizeCalculation: a = this.sizeCalculation, status: c } = n, { noUpdateTTL: f = this.noUpdateTTL } = n, h = this.#L(e, r, n.size || 0, a);
            if (this.maxEntrySize && h > this.maxEntrySize) return c && (c.set = "miss", c.maxEntrySizeExceeded = !0), this.#A(e, "set"), this;
            let d = this.#i === 0 ? void 0 : this.#n.get(e);
            if (d === void 0) d = this.#i === 0 ? this.#o : this.#w.length !== 0 ? this.#w.pop() : this.#i === this.#u ? this.#B(!1) : this.#i, this.#r[d] = e, this.#e[d] = r, this.#n.set(e, d), this.#l[this.#o] = d, this.#h[d] = this.#o, this.#o = d, this.#i++, this.#C(d, h, c), c && (c.set = "add"), f = !1;
            else {
                this.#O(d);
                let w = this.#e[d];
                if (r !== w) {
                    if (this.#x && this.#t(w)) {
                        w.__abortController.abort(new Error("replaced"));
                        let { __staleWhileFetching: y } = w;
                        y !== void 0 && !o && (this.#v && this.#y?.(y, e, "set"), this.#c && this.#s?.push([
                            y,
                            e,
                            "set"
                        ]));
                    } else o || (this.#v && this.#y?.(w, e, "set"), this.#c && this.#s?.push([
                        w,
                        e,
                        "set"
                    ]));
                    if (this.#P(d), this.#C(d, h, c), this.#e[d] = r, c) {
                        c.set = "replace";
                        let y = w && this.#t(w) ? w.__staleWhileFetching : w;
                        y !== void 0 && (c.oldValue = y);
                    }
                } else c && (c.set = "update");
            }
            if (i !== 0 && !this.#d && this.#N(), this.#d && (f || this.#q(d, i, s), c && this.#I(c, d)), !o && this.#c && this.#s) {
                let w = this.#s, y;
                for(; y = w?.shift();)this.#g?.(...y);
            }
            return this;
        }
        pop() {
            try {
                for(; this.#i;){
                    let e = this.#e[this.#a];
                    if (this.#B(!0), this.#t(e)) {
                        if (e.__staleWhileFetching) return e.__staleWhileFetching;
                    } else if (e !== void 0) return e;
                }
            } finally{
                if (this.#c && this.#s) {
                    let e = this.#s, r;
                    for(; r = e?.shift();)this.#g?.(...r);
                }
            }
        }
        #B(e) {
            let r = this.#a, n = this.#r[r], i = this.#e[r];
            return this.#x && this.#t(i) ? i.__abortController.abort(new Error("evicted")) : (this.#v || this.#c) && (this.#v && this.#y?.(i, n, "evict"), this.#c && this.#s?.push([
                i,
                n,
                "evict"
            ])), this.#P(r), e && (this.#r[r] = void 0, this.#e[r] = void 0, this.#w.push(r)), this.#i === 1 ? (this.#a = this.#o = 0, this.#w.length = 0) : this.#a = this.#l[r], this.#n.delete(n), this.#i--, r;
        }
        has(e, r = {}) {
            let { updateAgeOnHas: n = this.updateAgeOnHas, status: i } = r, s = this.#n.get(e);
            if (s !== void 0) {
                let o = this.#e[s];
                if (this.#t(o) && o.__staleWhileFetching === void 0) return !1;
                if (this.#p(s)) i && (i.has = "stale", this.#I(i, s));
                else return n && this.#T(s), i && (i.has = "hit", this.#I(i, s)), !0;
            } else i && (i.has = "miss");
            return !1;
        }
        peek(e, r = {}) {
            let { allowStale: n = this.allowStale } = r, i = this.#n.get(e);
            if (i === void 0 || !n && this.#p(i)) return;
            let s = this.#e[i];
            return this.#t(s) ? s.__staleWhileFetching : s;
        }
        #M(e, r, n, i) {
            let s = r === void 0 ? void 0 : this.#e[r];
            if (this.#t(s)) return s;
            let o = new mo, { signal: a } = n;
            a?.addEventListener("abort", ()=>o.abort(a.reason), {
                signal: o.signal
            });
            let c = {
                signal: o.signal,
                options: n,
                context: i
            }, f = (E, b = !1)=>{
                let { aborted: m } = o.signal, v = n.ignoreFetchAbort && E !== void 0;
                if (n.status && (m && !b ? (n.status.fetchAborted = !0, n.status.fetchError = o.signal.reason, v && (n.status.fetchAbortIgnored = !0)) : n.status.fetchResolved = !0), m && !v && !b) return d(o.signal.reason);
                let R = y;
                return this.#e[r] === y && (E === void 0 ? R.__staleWhileFetching ? this.#e[r] = R.__staleWhileFetching : this.#A(e, "fetch") : (n.status && (n.status.fetchUpdated = !0), this.set(e, E, c.options))), E;
            }, h = (E)=>(n.status && (n.status.fetchRejected = !0, n.status.fetchError = E), d(E)), d = (E)=>{
                let { aborted: b } = o.signal, m = b && n.allowStaleOnFetchAbort, v = m || n.allowStaleOnFetchRejection, R = v || n.noDeleteOnFetchRejection, T = y;
                if (this.#e[r] === y && (!R || T.__staleWhileFetching === void 0 ? this.#A(e, "fetch") : m || (this.#e[r] = T.__staleWhileFetching)), v) return n.status && T.__staleWhileFetching !== void 0 && (n.status.returnedStale = !0), T.__staleWhileFetching;
                if (T.__returned === T) throw E;
            }, w = (E, b)=>{
                let m = this.#R?.(e, s, c);
                m && m instanceof Promise && m.then((v)=>E(v === void 0 ? void 0 : v), b), o.signal.addEventListener("abort", ()=>{
                    (!n.ignoreFetchAbort || n.allowStaleOnFetchAbort) && (E(void 0), n.allowStaleOnFetchAbort && (E = (v)=>f(v, !0)));
                });
            };
            n.status && (n.status.fetchDispatched = !0);
            let y = new Promise(w).then(f, h), P = Object.assign(y, {
                __abortController: o,
                __staleWhileFetching: s,
                __returned: void 0
            });
            return r === void 0 ? (this.set(e, P, {
                ...c.options,
                status: void 0
            }), r = this.#n.get(e)) : this.#e[r] = P, P;
        }
        #t(e) {
            if (!this.#x) return !1;
            let r = e;
            return !!r && r instanceof Promise && r.hasOwnProperty("__staleWhileFetching") && r.__abortController instanceof mo;
        }
        async fetch(e, r = {}) {
            let { allowStale: n = this.allowStale, updateAgeOnGet: i = this.updateAgeOnGet, noDeleteOnStaleGet: s = this.noDeleteOnStaleGet, ttl: o = this.ttl, noDisposeOnSet: a = this.noDisposeOnSet, size: c = 0, sizeCalculation: f = this.sizeCalculation, noUpdateTTL: h = this.noUpdateTTL, noDeleteOnFetchRejection: d = this.noDeleteOnFetchRejection, allowStaleOnFetchRejection: w = this.allowStaleOnFetchRejection, ignoreFetchAbort: y = this.ignoreFetchAbort, allowStaleOnFetchAbort: P = this.allowStaleOnFetchAbort, context: E, forceRefresh: b = !1, status: m, signal: v } = r;
            if (!this.#x) return m && (m.fetch = "get"), this.get(e, {
                allowStale: n,
                updateAgeOnGet: i,
                noDeleteOnStaleGet: s,
                status: m
            });
            let R = {
                allowStale: n,
                updateAgeOnGet: i,
                noDeleteOnStaleGet: s,
                ttl: o,
                noDisposeOnSet: a,
                size: c,
                sizeCalculation: f,
                noUpdateTTL: h,
                noDeleteOnFetchRejection: d,
                allowStaleOnFetchRejection: w,
                allowStaleOnFetchAbort: P,
                ignoreFetchAbort: y,
                status: m,
                signal: v
            }, T = this.#n.get(e);
            if (T === void 0) {
                m && (m.fetch = "miss");
                let g = this.#M(e, T, R, E);
                return g.__returned = g;
            } else {
                let g = this.#e[T];
                if (this.#t(g)) {
                    let j = n && g.__staleWhileFetching !== void 0;
                    return m && (m.fetch = "inflight", j && (m.returnedStale = !0)), j ? g.__staleWhileFetching : g.__returned = g;
                }
                let O = this.#p(T);
                if (!b && !O) return m && (m.fetch = "hit"), this.#O(T), i && this.#T(T), m && this.#I(m, T), g;
                let _ = this.#M(e, T, R, E), $ = _.__staleWhileFetching !== void 0 && n;
                return m && (m.fetch = O ? "stale" : "refresh", $ && O && (m.returnedStale = !0)), $ ? _.__staleWhileFetching : _.__returned = _;
            }
        }
        async forceFetch(e, r = {}) {
            let n = await this.fetch(e, r);
            if (n === void 0) throw new Error("fetch() returned undefined");
            return n;
        }
        memo(e, r = {}) {
            let n = this.#k;
            if (!n) throw new Error("no memoMethod provided to constructor");
            let { context: i, forceRefresh: s, ...o } = r, a = this.get(e, o);
            if (!s && a !== void 0) return a;
            let c = n(e, a, {
                options: o,
                context: i
            });
            return this.set(e, c, o), c;
        }
        get(e, r = {}) {
            let { allowStale: n = this.allowStale, updateAgeOnGet: i = this.updateAgeOnGet, noDeleteOnStaleGet: s = this.noDeleteOnStaleGet, status: o } = r, a = this.#n.get(e);
            if (a !== void 0) {
                let c = this.#e[a], f = this.#t(c);
                return o && this.#I(o, a), this.#p(a) ? (o && (o.get = "stale"), f ? (o && n && c.__staleWhileFetching !== void 0 && (o.returnedStale = !0), n ? c.__staleWhileFetching : void 0) : (s || this.#A(e, "expire"), o && n && (o.returnedStale = !0), n ? c : void 0)) : (o && (o.get = "hit"), f ? c.__staleWhileFetching : (this.#O(a), i && this.#T(a), c));
            } else o && (o.get = "miss");
        }
        #D(e, r) {
            this.#h[r] = e, this.#l[e] = r;
        }
        #O(e) {
            e !== this.#o && (e === this.#a ? this.#a = this.#l[e] : this.#D(this.#h[e], this.#l[e]), this.#D(this.#o, e), this.#o = e);
        }
        delete(e) {
            return this.#A(e, "delete");
        }
        #A(e, r) {
            let n = !1;
            if (this.#i !== 0) {
                let i = this.#n.get(e);
                if (i !== void 0) {
                    if (n = !0, this.#i === 1) this.#j(r);
                    else {
                        this.#P(i);
                        let s = this.#e[i];
                        if (this.#t(s) ? s.__abortController.abort(new Error("deleted")) : (this.#v || this.#c) && (this.#v && this.#y?.(s, e, r), this.#c && this.#s?.push([
                            s,
                            e,
                            r
                        ])), this.#n.delete(e), this.#r[i] = void 0, this.#e[i] = void 0, i === this.#o) this.#o = this.#h[i];
                        else if (i === this.#a) this.#a = this.#l[i];
                        else {
                            let o = this.#h[i];
                            this.#l[o] = this.#l[i];
                            let a = this.#l[i];
                            this.#h[a] = this.#h[i];
                        }
                        this.#i--, this.#w.push(i);
                    }
                }
            }
            if (this.#c && this.#s?.length) {
                let i = this.#s, s;
                for(; s = i?.shift();)this.#g?.(...s);
            }
            return n;
        }
        clear() {
            return this.#j("delete");
        }
        #j(e) {
            for (let r of this.#E({
                allowStale: !0
            })){
                let n = this.#e[r];
                if (this.#t(n)) n.__abortController.abort(new Error("deleted"));
                else {
                    let i = this.#r[r];
                    this.#v && this.#y?.(n, i, e), this.#c && this.#s?.push([
                        n,
                        i,
                        e
                    ]);
                }
            }
            if (this.#n.clear(), this.#e.fill(void 0), this.#r.fill(void 0), this.#d && this.#_ && (this.#d.fill(0), this.#_.fill(0)), this.#m && this.#m.fill(0), this.#a = 0, this.#o = 0, this.#w.length = 0, this.#b = 0, this.#i = 0, this.#c && this.#s) {
                let r = this.#s, n;
                for(; n = r?.shift();)this.#g?.(...n);
            }
        }
    };
    _o.LRUCache = Va;
});
var $4c2dd1b68d143d96$var$It = $4c2dd1b68d143d96$var$D((cr)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(cr, "t", {
        value: !0
    });
    cr.ContainerIterator = cr.Container = cr.Base = void 0;
    var Ga = class {
        constructor(e = 0){
            this.iteratorType = e;
        }
        equals(e) {
            return this.o === e.o;
        }
    };
    cr.ContainerIterator = Ga;
    var vo = class {
        constructor(){
            this.i = 0;
        }
        get length() {
            return this.i;
        }
        size() {
            return this.i;
        }
        empty() {
            return this.i === 0;
        }
    };
    cr.Base = vo;
    var za = class extends vo {
    };
    cr.Container = za;
});
var $4c2dd1b68d143d96$var$Ey = $4c2dd1b68d143d96$var$D((So)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(So, "t", {
        value: !0
    });
    So.default = void 0;
    var qE = $4c2dd1b68d143d96$var$It(), Ka = class extends qE.Base {
        constructor(e = []){
            super(), this.S = [];
            let r = this;
            e.forEach(function(n) {
                r.push(n);
            });
        }
        clear() {
            this.i = 0, this.S = [];
        }
        push(e) {
            return this.S.push(e), this.i += 1, this.i;
        }
        pop() {
            if (this.i !== 0) return this.i -= 1, this.S.pop();
        }
        top() {
            return this.S[this.i - 1];
        }
    }, LE = Ka;
    So.default = LE;
});
var $4c2dd1b68d143d96$var$Ay = $4c2dd1b68d143d96$var$D((Eo)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Eo, "t", {
        value: !0
    });
    Eo.default = void 0;
    var UE = $4c2dd1b68d143d96$var$It(), Qa = class extends UE.Base {
        constructor(e = []){
            super(), this.j = 0, this.q = [];
            let r = this;
            e.forEach(function(n) {
                r.push(n);
            });
        }
        clear() {
            this.q = [], this.i = this.j = 0;
        }
        push(e) {
            let r = this.q.length;
            if (this.j / r > .5 && this.j + this.i >= r && r > 4096) {
                let n = this.i;
                for(let i = 0; i < n; ++i)this.q[i] = this.q[this.j + i];
                this.j = 0, this.q[this.i] = e;
            } else this.q[this.j + this.i] = e;
            return ++this.i;
        }
        pop() {
            if (this.i === 0) return;
            let e = this.q[this.j++];
            return this.i -= 1, e;
        }
        front() {
            if (this.i !== 0) return this.q[this.j];
        }
    }, DE = Qa;
    Eo.default = DE;
});
var $4c2dd1b68d143d96$var$Iy = $4c2dd1b68d143d96$var$D((Ao)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Ao, "t", {
        value: !0
    });
    Ao.default = void 0;
    var jE = $4c2dd1b68d143d96$var$It(), Ya = class extends jE.Base {
        constructor(e = [], r = function(i, s) {
            return i > s ? -1 : i < s ? 1 : 0;
        }, n = !0){
            if (super(), this.v = r, Array.isArray(e)) this.C = n ? [
                ...e
            ] : e;
            else {
                this.C = [];
                let s = this;
                e.forEach(function(o) {
                    s.C.push(o);
                });
            }
            this.i = this.C.length;
            let i = this.i >> 1;
            for(let s = this.i - 1 >> 1; s >= 0; --s)this.k(s, i);
        }
        m(e) {
            let r = this.C[e];
            for(; e > 0;){
                let n = e - 1 >> 1, i = this.C[n];
                if (this.v(i, r) <= 0) break;
                this.C[e] = i, e = n;
            }
            this.C[e] = r;
        }
        k(e, r) {
            let n = this.C[e];
            for(; e < r;){
                let i = e << 1 | 1, s = i + 1, o = this.C[i];
                if (s < this.i && this.v(o, this.C[s]) > 0 && (i = s, o = this.C[s]), this.v(o, n) >= 0) break;
                this.C[e] = o, e = i;
            }
            this.C[e] = n;
        }
        clear() {
            this.i = 0, this.C.length = 0;
        }
        push(e) {
            this.C.push(e), this.m(this.i), this.i += 1;
        }
        pop() {
            if (this.i === 0) return;
            let e = this.C[0], r = this.C.pop();
            return this.i -= 1, this.i && (this.C[0] = r, this.k(0, this.i >> 1)), e;
        }
        top() {
            return this.C[0];
        }
        find(e) {
            return this.C.indexOf(e) >= 0;
        }
        remove(e) {
            let r = this.C.indexOf(e);
            return r < 0 ? !1 : (r === 0 ? this.pop() : r === this.i - 1 ? (this.C.pop(), this.i -= 1) : (this.C.splice(r, 1, this.C.pop()), this.i -= 1, this.m(r), this.k(r, this.i >> 1)), !0);
        }
        updateItem(e) {
            let r = this.C.indexOf(e);
            return r < 0 ? !1 : (this.m(r), this.k(r, this.i >> 1), !0);
        }
        toArray() {
            return [
                ...this.C
            ];
        }
    }, FE = Ya;
    Ao.default = FE;
});
var $4c2dd1b68d143d96$var$xo = $4c2dd1b68d143d96$var$D((Io)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Io, "t", {
        value: !0
    });
    Io.default = void 0;
    var WE = $4c2dd1b68d143d96$var$It(), Ja = class extends WE.Container {
    }, $E = Ja;
    Io.default = $E;
});
var $4c2dd1b68d143d96$var$xt = $4c2dd1b68d143d96$var$D((Xa)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Xa, "t", {
        value: !0
    });
    Xa.throwIteratorAccessError = HE;
    function HE() {
        throw new RangeError("Iterator access denied!");
    }
});
var $4c2dd1b68d143d96$var$eu = $4c2dd1b68d143d96$var$D((Po)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Po, "t", {
        value: !0
    });
    Po.RandomIterator = void 0;
    var VE = $4c2dd1b68d143d96$var$It(), To = $4c2dd1b68d143d96$var$xt(), Za = class extends VE.ContainerIterator {
        constructor(e, r){
            super(r), this.o = e, this.iteratorType === 0 ? (this.pre = function() {
                return this.o === 0 && (0, To.throwIteratorAccessError)(), this.o -= 1, this;
            }, this.next = function() {
                return this.o === this.container.size() && (0, To.throwIteratorAccessError)(), this.o += 1, this;
            }) : (this.pre = function() {
                return this.o === this.container.size() - 1 && (0, To.throwIteratorAccessError)(), this.o += 1, this;
            }, this.next = function() {
                return this.o === -1 && (0, To.throwIteratorAccessError)(), this.o -= 1, this;
            });
        }
        get pointer() {
            return this.container.getElementByPos(this.o);
        }
        set pointer(e) {
            this.container.setElementByPos(this.o, e);
        }
    };
    Po.RandomIterator = Za;
});
var $4c2dd1b68d143d96$var$xy = $4c2dd1b68d143d96$var$D((Oo)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Oo, "t", {
        value: !0
    });
    Oo.default = void 0;
    var GE = KE($4c2dd1b68d143d96$var$xo()), zE = $4c2dd1b68d143d96$var$eu();
    function KE(t) {
        return t && t.t ? t : {
            default: t
        };
    }
    var Nr = class t extends zE.RandomIterator {
        constructor(e, r, n){
            super(e, n), this.container = r;
        }
        copy() {
            return new t(this.o, this.container, this.iteratorType);
        }
    }, tu = class extends GE.default {
        constructor(e = [], r = !0){
            if (super(), Array.isArray(e)) this.J = r ? [
                ...e
            ] : e, this.i = e.length;
            else {
                this.J = [];
                let n = this;
                e.forEach(function(i) {
                    n.pushBack(i);
                });
            }
        }
        clear() {
            this.i = 0, this.J.length = 0;
        }
        begin() {
            return new Nr(0, this);
        }
        end() {
            return new Nr(this.i, this);
        }
        rBegin() {
            return new Nr(this.i - 1, this, 1);
        }
        rEnd() {
            return new Nr(-1, this, 1);
        }
        front() {
            return this.J[0];
        }
        back() {
            return this.J[this.i - 1];
        }
        getElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            return this.J[e];
        }
        eraseElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            return this.J.splice(e, 1), this.i -= 1, this.i;
        }
        eraseElementByValue(e) {
            let r = 0;
            for(let n = 0; n < this.i; ++n)this.J[n] !== e && (this.J[r++] = this.J[n]);
            return this.i = this.J.length = r, this.i;
        }
        eraseElementByIterator(e) {
            let r = e.o;
            return e = e.next(), this.eraseElementByPos(r), e;
        }
        pushBack(e) {
            return this.J.push(e), this.i += 1, this.i;
        }
        popBack() {
            if (this.i !== 0) return this.i -= 1, this.J.pop();
        }
        setElementByPos(e, r) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            this.J[e] = r;
        }
        insert(e, r, n = 1) {
            if (e < 0 || e > this.i) throw new RangeError;
            return this.J.splice(e, 0, ...new Array(n).fill(r)), this.i += n, this.i;
        }
        find(e) {
            for(let r = 0; r < this.i; ++r)if (this.J[r] === e) return new Nr(r, this);
            return this.end();
        }
        reverse() {
            this.J.reverse();
        }
        unique() {
            let e = 1;
            for(let r = 1; r < this.i; ++r)this.J[r] !== this.J[r - 1] && (this.J[e++] = this.J[r]);
            return this.i = this.J.length = e, this.i;
        }
        sort(e) {
            this.J.sort(e);
        }
        forEach(e) {
            for(let r = 0; r < this.i; ++r)e(this.J[r], r, this);
        }
        [Symbol.iterator]() {
            return (function*() {
                yield* this.J;
            }).bind(this)();
        }
    }, QE = tu;
    Oo.default = QE;
});
var $4c2dd1b68d143d96$var$Ty = $4c2dd1b68d143d96$var$D((Ro)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Ro, "t", {
        value: !0
    });
    Ro.default = void 0;
    var YE = XE($4c2dd1b68d143d96$var$xo()), JE = $4c2dd1b68d143d96$var$It(), qr = $4c2dd1b68d143d96$var$xt();
    function XE(t) {
        return t && t.t ? t : {
            default: t
        };
    }
    var Lr = class t extends JE.ContainerIterator {
        constructor(e, r, n, i){
            super(i), this.o = e, this.h = r, this.container = n, this.iteratorType === 0 ? (this.pre = function() {
                return this.o.L === this.h && (0, qr.throwIteratorAccessError)(), this.o = this.o.L, this;
            }, this.next = function() {
                return this.o === this.h && (0, qr.throwIteratorAccessError)(), this.o = this.o.B, this;
            }) : (this.pre = function() {
                return this.o.B === this.h && (0, qr.throwIteratorAccessError)(), this.o = this.o.B, this;
            }, this.next = function() {
                return this.o === this.h && (0, qr.throwIteratorAccessError)(), this.o = this.o.L, this;
            });
        }
        get pointer() {
            return this.o === this.h && (0, qr.throwIteratorAccessError)(), this.o.l;
        }
        set pointer(e) {
            this.o === this.h && (0, qr.throwIteratorAccessError)(), this.o.l = e;
        }
        copy() {
            return new t(this.o, this.h, this.container, this.iteratorType);
        }
    }, ru = class extends YE.default {
        constructor(e = []){
            super(), this.h = {}, this.p = this._ = this.h.L = this.h.B = this.h;
            let r = this;
            e.forEach(function(n) {
                r.pushBack(n);
            });
        }
        V(e) {
            let { L: r, B: n } = e;
            r.B = n, n.L = r, e === this.p && (this.p = n), e === this._ && (this._ = r), this.i -= 1;
        }
        G(e, r) {
            let n = r.B, i = {
                l: e,
                L: r,
                B: n
            };
            r.B = i, n.L = i, r === this.h && (this.p = i), n === this.h && (this._ = i), this.i += 1;
        }
        clear() {
            this.i = 0, this.p = this._ = this.h.L = this.h.B = this.h;
        }
        begin() {
            return new Lr(this.p, this.h, this);
        }
        end() {
            return new Lr(this.h, this.h, this);
        }
        rBegin() {
            return new Lr(this._, this.h, this, 1);
        }
        rEnd() {
            return new Lr(this.h, this.h, this, 1);
        }
        front() {
            return this.p.l;
        }
        back() {
            return this._.l;
        }
        getElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let r = this.p;
            for(; e--;)r = r.B;
            return r.l;
        }
        eraseElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let r = this.p;
            for(; e--;)r = r.B;
            return this.V(r), this.i;
        }
        eraseElementByValue(e) {
            let r = this.p;
            for(; r !== this.h;)r.l === e && this.V(r), r = r.B;
            return this.i;
        }
        eraseElementByIterator(e) {
            let r = e.o;
            return r === this.h && (0, qr.throwIteratorAccessError)(), e = e.next(), this.V(r), e;
        }
        pushBack(e) {
            return this.G(e, this._), this.i;
        }
        popBack() {
            if (this.i === 0) return;
            let e = this._.l;
            return this.V(this._), e;
        }
        pushFront(e) {
            return this.G(e, this.h), this.i;
        }
        popFront() {
            if (this.i === 0) return;
            let e = this.p.l;
            return this.V(this.p), e;
        }
        setElementByPos(e, r) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let n = this.p;
            for(; e--;)n = n.B;
            n.l = r;
        }
        insert(e, r, n = 1) {
            if (e < 0 || e > this.i) throw new RangeError;
            if (n <= 0) return this.i;
            if (e === 0) for(; n--;)this.pushFront(r);
            else if (e === this.i) for(; n--;)this.pushBack(r);
            else {
                let i = this.p;
                for(let o = 1; o < e; ++o)i = i.B;
                let s = i.B;
                for(this.i += n; n--;)i.B = {
                    l: r,
                    L: i
                }, i.B.L = i, i = i.B;
                i.B = s, s.L = i;
            }
            return this.i;
        }
        find(e) {
            let r = this.p;
            for(; r !== this.h;){
                if (r.l === e) return new Lr(r, this.h, this);
                r = r.B;
            }
            return this.end();
        }
        reverse() {
            if (this.i <= 1) return;
            let e = this.p, r = this._, n = 0;
            for(; n << 1 < this.i;){
                let i = e.l;
                e.l = r.l, r.l = i, e = e.B, r = r.L, n += 1;
            }
        }
        unique() {
            if (this.i <= 1) return this.i;
            let e = this.p;
            for(; e !== this.h;){
                let r = e;
                for(; r.B !== this.h && r.l === r.B.l;)r = r.B, this.i -= 1;
                e.B = r.B, e.B.L = e, e = e.B;
            }
            return this.i;
        }
        sort(e) {
            if (this.i <= 1) return;
            let r = [];
            this.forEach(function(i) {
                r.push(i);
            }), r.sort(e);
            let n = this.p;
            r.forEach(function(i) {
                n.l = i, n = n.B;
            });
        }
        merge(e) {
            let r = this;
            if (this.i === 0) e.forEach(function(n) {
                r.pushBack(n);
            });
            else {
                let n = this.p;
                e.forEach(function(i) {
                    for(; n !== r.h && n.l <= i;)n = n.B;
                    r.G(i, n.L);
                });
            }
            return this.i;
        }
        forEach(e) {
            let r = this.p, n = 0;
            for(; r !== this.h;)e(r.l, n++, this), r = r.B;
        }
        [Symbol.iterator]() {
            return (function*() {
                if (this.i === 0) return;
                let e = this.p;
                for(; e !== this.h;)yield e.l, e = e.B;
            }).bind(this)();
        }
    }, ZE = ru;
    Ro.default = ZE;
});
var $4c2dd1b68d143d96$var$Py = $4c2dd1b68d143d96$var$D((ko)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(ko, "t", {
        value: !0
    });
    ko.default = void 0;
    var e1 = r1($4c2dd1b68d143d96$var$xo()), t1 = $4c2dd1b68d143d96$var$eu();
    function r1(t) {
        return t && t.t ? t : {
            default: t
        };
    }
    var Ur = class t extends t1.RandomIterator {
        constructor(e, r, n){
            super(e, n), this.container = r;
        }
        copy() {
            return new t(this.o, this.container, this.iteratorType);
        }
    }, nu = class extends e1.default {
        constructor(e = [], r = 4096){
            super(), this.j = 0, this.D = 0, this.R = 0, this.N = 0, this.P = 0, this.A = [];
            let n = (()=>{
                if (typeof e.length == "number") return e.length;
                if (typeof e.size == "number") return e.size;
                if (typeof e.size == "function") return e.size();
                throw new TypeError("Cannot get the length or size of the container");
            })();
            this.F = r, this.P = Math.max(Math.ceil(n / this.F), 1);
            for(let o = 0; o < this.P; ++o)this.A.push(new Array(this.F));
            let i = Math.ceil(n / this.F);
            this.j = this.R = (this.P >> 1) - (i >> 1), this.D = this.N = this.F - n % this.F >> 1;
            let s = this;
            e.forEach(function(o) {
                s.pushBack(o);
            });
        }
        T() {
            let e = [], r = Math.max(this.P >> 1, 1);
            for(let n = 0; n < r; ++n)e[n] = new Array(this.F);
            for(let n = this.j; n < this.P; ++n)e[e.length] = this.A[n];
            for(let n = 0; n < this.R; ++n)e[e.length] = this.A[n];
            e[e.length] = [
                ...this.A[this.R]
            ], this.j = r, this.R = e.length - 1;
            for(let n = 0; n < r; ++n)e[e.length] = new Array(this.F);
            this.A = e, this.P = e.length;
        }
        O(e) {
            let r = this.D + e + 1, n = r % this.F, i = n - 1, s = this.j + (r - n) / this.F;
            return n === 0 && (s -= 1), s %= this.P, i < 0 && (i += this.F), {
                curNodeBucketIndex: s,
                curNodePointerIndex: i
            };
        }
        clear() {
            this.A = [
                new Array(this.F)
            ], this.P = 1, this.j = this.R = this.i = 0, this.D = this.N = this.F >> 1;
        }
        begin() {
            return new Ur(0, this);
        }
        end() {
            return new Ur(this.i, this);
        }
        rBegin() {
            return new Ur(this.i - 1, this, 1);
        }
        rEnd() {
            return new Ur(-1, this, 1);
        }
        front() {
            if (this.i !== 0) return this.A[this.j][this.D];
        }
        back() {
            if (this.i !== 0) return this.A[this.R][this.N];
        }
        pushBack(e) {
            return this.i && (this.N < this.F - 1 ? this.N += 1 : this.R < this.P - 1 ? (this.R += 1, this.N = 0) : (this.R = 0, this.N = 0), this.R === this.j && this.N === this.D && this.T()), this.i += 1, this.A[this.R][this.N] = e, this.i;
        }
        popBack() {
            if (this.i === 0) return;
            let e = this.A[this.R][this.N];
            return this.i !== 1 && (this.N > 0 ? this.N -= 1 : this.R > 0 ? (this.R -= 1, this.N = this.F - 1) : (this.R = this.P - 1, this.N = this.F - 1)), this.i -= 1, e;
        }
        pushFront(e) {
            return this.i && (this.D > 0 ? this.D -= 1 : this.j > 0 ? (this.j -= 1, this.D = this.F - 1) : (this.j = this.P - 1, this.D = this.F - 1), this.j === this.R && this.D === this.N && this.T()), this.i += 1, this.A[this.j][this.D] = e, this.i;
        }
        popFront() {
            if (this.i === 0) return;
            let e = this.A[this.j][this.D];
            return this.i !== 1 && (this.D < this.F - 1 ? this.D += 1 : this.j < this.P - 1 ? (this.j += 1, this.D = 0) : (this.j = 0, this.D = 0)), this.i -= 1, e;
        }
        getElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let { curNodeBucketIndex: r, curNodePointerIndex: n } = this.O(e);
            return this.A[r][n];
        }
        setElementByPos(e, r) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let { curNodeBucketIndex: n, curNodePointerIndex: i } = this.O(e);
            this.A[n][i] = r;
        }
        insert(e, r, n = 1) {
            if (e < 0 || e > this.i) throw new RangeError;
            if (e === 0) for(; n--;)this.pushFront(r);
            else if (e === this.i) for(; n--;)this.pushBack(r);
            else {
                let i = [];
                for(let s = e; s < this.i; ++s)i.push(this.getElementByPos(s));
                this.cut(e - 1);
                for(let s = 0; s < n; ++s)this.pushBack(r);
                for(let s = 0; s < i.length; ++s)this.pushBack(i[s]);
            }
            return this.i;
        }
        cut(e) {
            if (e < 0) return this.clear(), 0;
            let { curNodeBucketIndex: r, curNodePointerIndex: n } = this.O(e);
            return this.R = r, this.N = n, this.i = e + 1, this.i;
        }
        eraseElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            if (e === 0) this.popFront();
            else if (e === this.i - 1) this.popBack();
            else {
                let r = [];
                for(let i = e + 1; i < this.i; ++i)r.push(this.getElementByPos(i));
                this.cut(e), this.popBack();
                let n = this;
                r.forEach(function(i) {
                    n.pushBack(i);
                });
            }
            return this.i;
        }
        eraseElementByValue(e) {
            if (this.i === 0) return 0;
            let r = [];
            for(let i = 0; i < this.i; ++i){
                let s = this.getElementByPos(i);
                s !== e && r.push(s);
            }
            let n = r.length;
            for(let i = 0; i < n; ++i)this.setElementByPos(i, r[i]);
            return this.cut(n - 1);
        }
        eraseElementByIterator(e) {
            let r = e.o;
            return this.eraseElementByPos(r), e = e.next(), e;
        }
        find(e) {
            for(let r = 0; r < this.i; ++r)if (this.getElementByPos(r) === e) return new Ur(r, this);
            return this.end();
        }
        reverse() {
            let e = 0, r = this.i - 1;
            for(; e < r;){
                let n = this.getElementByPos(e);
                this.setElementByPos(e, this.getElementByPos(r)), this.setElementByPos(r, n), e += 1, r -= 1;
            }
        }
        unique() {
            if (this.i <= 1) return this.i;
            let e = 1, r = this.getElementByPos(0);
            for(let n = 1; n < this.i; ++n){
                let i = this.getElementByPos(n);
                i !== r && (r = i, this.setElementByPos(e++, i));
            }
            for(; this.i > e;)this.popBack();
            return this.i;
        }
        sort(e) {
            let r = [];
            for(let n = 0; n < this.i; ++n)r.push(this.getElementByPos(n));
            r.sort(e);
            for(let n = 0; n < this.i; ++n)this.setElementByPos(n, r[n]);
        }
        shrinkToFit() {
            if (this.i === 0) return;
            let e = [];
            this.forEach(function(r) {
                e.push(r);
            }), this.P = Math.max(Math.ceil(this.i / this.F), 1), this.i = this.j = this.R = this.D = this.N = 0, this.A = [];
            for(let r = 0; r < this.P; ++r)this.A.push(new Array(this.F));
            for(let r = 0; r < e.length; ++r)this.pushBack(e[r]);
        }
        forEach(e) {
            for(let r = 0; r < this.i; ++r)e(this.getElementByPos(r), r, this);
        }
        [Symbol.iterator]() {
            return (function*() {
                for(let e = 0; e < this.i; ++e)yield this.getElementByPos(e);
            }).bind(this)();
        }
    }, n1 = nu;
    ko.default = n1;
});
var $4c2dd1b68d143d96$var$Oy = $4c2dd1b68d143d96$var$D((wn)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(wn, "t", {
        value: !0
    });
    wn.TreeNodeEnableIndex = wn.TreeNode = void 0;
    var Co = class {
        constructor(e, r){
            this.ee = 1, this.u = void 0, this.l = void 0, this.U = void 0, this.W = void 0, this.tt = void 0, this.u = e, this.l = r;
        }
        L() {
            let e = this;
            if (e.ee === 1 && e.tt.tt === e) e = e.W;
            else if (e.U) for(e = e.U; e.W;)e = e.W;
            else {
                let r = e.tt;
                for(; r.U === e;)e = r, r = e.tt;
                e = r;
            }
            return e;
        }
        B() {
            let e = this;
            if (e.W) {
                for(e = e.W; e.U;)e = e.U;
                return e;
            } else {
                let r = e.tt;
                for(; r.W === e;)e = r, r = e.tt;
                return e.W !== r ? r : e;
            }
        }
        te() {
            let e = this.tt, r = this.W, n = r.U;
            return e.tt === this ? e.tt = r : e.U === this ? e.U = r : e.W = r, r.tt = e, r.U = this, this.tt = r, this.W = n, n && (n.tt = this), r;
        }
        se() {
            let e = this.tt, r = this.U, n = r.W;
            return e.tt === this ? e.tt = r : e.U === this ? e.U = r : e.W = r, r.tt = e, r.W = this, this.tt = r, this.U = n, n && (n.tt = this), r;
        }
    };
    wn.TreeNode = Co;
    var iu = class extends Co {
        constructor(){
            super(...arguments), this.rt = 1;
        }
        te() {
            let e = super.te();
            return this.ie(), e.ie(), e;
        }
        se() {
            let e = super.se();
            return this.ie(), e.ie(), e;
        }
        ie() {
            this.rt = 1, this.U && (this.rt += this.U.rt), this.W && (this.rt += this.W.rt);
        }
    };
    wn.TreeNodeEnableIndex = iu;
});
var $4c2dd1b68d143d96$var$su = $4c2dd1b68d143d96$var$D((Bo)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Bo, "t", {
        value: !0
    });
    Bo.default = void 0;
    var Ry = $4c2dd1b68d143d96$var$Oy(), i1 = $4c2dd1b68d143d96$var$It(), ky = $4c2dd1b68d143d96$var$xt(), ou = class extends i1.Container {
        constructor(e = function(n, i) {
            return n < i ? -1 : n > i ? 1 : 0;
        }, r = !1){
            super(), this.Y = void 0, this.v = e, r ? (this.re = Ry.TreeNodeEnableIndex, this.M = function(n, i, s) {
                let o = this.ne(n, i, s);
                if (o) {
                    let a = o.tt;
                    for(; a !== this.h;)a.rt += 1, a = a.tt;
                    let c = this.he(o);
                    if (c) {
                        let { parentNode: f, grandParent: h, curNode: d } = c;
                        f.ie(), h.ie(), d.ie();
                    }
                }
                return this.i;
            }, this.V = function(n) {
                let i = this.fe(n);
                for(; i !== this.h;)i.rt -= 1, i = i.tt;
            }) : (this.re = Ry.TreeNode, this.M = function(n, i, s) {
                let o = this.ne(n, i, s);
                return o && this.he(o), this.i;
            }, this.V = this.fe), this.h = new this.re;
        }
        X(e, r) {
            let n = this.h;
            for(; e;){
                let i = this.v(e.u, r);
                if (i < 0) e = e.W;
                else if (i > 0) n = e, e = e.U;
                else return e;
            }
            return n;
        }
        Z(e, r) {
            let n = this.h;
            for(; e;)this.v(e.u, r) <= 0 ? e = e.W : (n = e, e = e.U);
            return n;
        }
        $(e, r) {
            let n = this.h;
            for(; e;){
                let i = this.v(e.u, r);
                if (i < 0) n = e, e = e.W;
                else if (i > 0) e = e.U;
                else return e;
            }
            return n;
        }
        rr(e, r) {
            let n = this.h;
            for(; e;)this.v(e.u, r) < 0 ? (n = e, e = e.W) : e = e.U;
            return n;
        }
        ue(e) {
            for(;;){
                let r = e.tt;
                if (r === this.h) return;
                if (e.ee === 1) {
                    e.ee = 0;
                    return;
                }
                if (e === r.U) {
                    let n = r.W;
                    if (n.ee === 1) n.ee = 0, r.ee = 1, r === this.Y ? this.Y = r.te() : r.te();
                    else if (n.W && n.W.ee === 1) {
                        n.ee = r.ee, r.ee = 0, n.W.ee = 0, r === this.Y ? this.Y = r.te() : r.te();
                        return;
                    } else n.U && n.U.ee === 1 ? (n.ee = 1, n.U.ee = 0, n.se()) : (n.ee = 1, e = r);
                } else {
                    let n = r.U;
                    if (n.ee === 1) n.ee = 0, r.ee = 1, r === this.Y ? this.Y = r.se() : r.se();
                    else if (n.U && n.U.ee === 1) {
                        n.ee = r.ee, r.ee = 0, n.U.ee = 0, r === this.Y ? this.Y = r.se() : r.se();
                        return;
                    } else n.W && n.W.ee === 1 ? (n.ee = 1, n.W.ee = 0, n.te()) : (n.ee = 1, e = r);
                }
            }
        }
        fe(e) {
            if (this.i === 1) return this.clear(), this.h;
            let r = e;
            for(; r.U || r.W;){
                if (r.W) for(r = r.W; r.U;)r = r.U;
                else r = r.U;
                [e.u, r.u] = [
                    r.u,
                    e.u
                ], [e.l, r.l] = [
                    r.l,
                    e.l
                ], e = r;
            }
            this.h.U === r ? this.h.U = r.tt : this.h.W === r && (this.h.W = r.tt), this.ue(r);
            let n = r.tt;
            return r === n.U ? n.U = void 0 : n.W = void 0, this.i -= 1, this.Y.ee = 0, n;
        }
        oe(e, r) {
            return e === void 0 ? !1 : this.oe(e.U, r) || r(e) ? !0 : this.oe(e.W, r);
        }
        he(e) {
            for(;;){
                let r = e.tt;
                if (r.ee === 0) return;
                let n = r.tt;
                if (r === n.U) {
                    let i = n.W;
                    if (i && i.ee === 1) {
                        if (i.ee = r.ee = 0, n === this.Y) return;
                        n.ee = 1, e = n;
                        continue;
                    } else if (e === r.W) {
                        if (e.ee = 0, e.U && (e.U.tt = r), e.W && (e.W.tt = n), r.W = e.U, n.U = e.W, e.U = r, e.W = n, n === this.Y) this.Y = e, this.h.tt = e;
                        else {
                            let s = n.tt;
                            s.U === n ? s.U = e : s.W = e;
                        }
                        return e.tt = n.tt, r.tt = e, n.tt = e, n.ee = 1, {
                            parentNode: r,
                            grandParent: n,
                            curNode: e
                        };
                    } else r.ee = 0, n === this.Y ? this.Y = n.se() : n.se(), n.ee = 1;
                } else {
                    let i = n.U;
                    if (i && i.ee === 1) {
                        if (i.ee = r.ee = 0, n === this.Y) return;
                        n.ee = 1, e = n;
                        continue;
                    } else if (e === r.U) {
                        if (e.ee = 0, e.U && (e.U.tt = n), e.W && (e.W.tt = r), n.W = e.U, r.U = e.W, e.U = n, e.W = r, n === this.Y) this.Y = e, this.h.tt = e;
                        else {
                            let s = n.tt;
                            s.U === n ? s.U = e : s.W = e;
                        }
                        return e.tt = n.tt, r.tt = e, n.tt = e, n.ee = 1, {
                            parentNode: r,
                            grandParent: n,
                            curNode: e
                        };
                    } else r.ee = 0, n === this.Y ? this.Y = n.te() : n.te(), n.ee = 1;
                }
                return;
            }
        }
        ne(e, r, n) {
            if (this.Y === void 0) {
                this.i += 1, this.Y = new this.re(e, r), this.Y.ee = 0, this.Y.tt = this.h, this.h.tt = this.Y, this.h.U = this.Y, this.h.W = this.Y;
                return;
            }
            let i, s = this.h.U, o = this.v(s.u, e);
            if (o === 0) {
                s.l = r;
                return;
            } else if (o > 0) s.U = new this.re(e, r), s.U.tt = s, i = s.U, this.h.U = i;
            else {
                let a = this.h.W, c = this.v(a.u, e);
                if (c === 0) {
                    a.l = r;
                    return;
                } else if (c < 0) a.W = new this.re(e, r), a.W.tt = a, i = a.W, this.h.W = i;
                else {
                    if (n !== void 0) {
                        let f = n.o;
                        if (f !== this.h) {
                            let h = this.v(f.u, e);
                            if (h === 0) {
                                f.l = r;
                                return;
                            } else if (h > 0) {
                                let d = f.L(), w = this.v(d.u, e);
                                if (w === 0) {
                                    d.l = r;
                                    return;
                                } else w < 0 && (i = new this.re(e, r), d.W === void 0 ? (d.W = i, i.tt = d) : (f.U = i, i.tt = f));
                            }
                        }
                    }
                    if (i === void 0) for(i = this.Y;;){
                        let f = this.v(i.u, e);
                        if (f > 0) {
                            if (i.U === void 0) {
                                i.U = new this.re(e, r), i.U.tt = i, i = i.U;
                                break;
                            }
                            i = i.U;
                        } else if (f < 0) {
                            if (i.W === void 0) {
                                i.W = new this.re(e, r), i.W.tt = i, i = i.W;
                                break;
                            }
                            i = i.W;
                        } else {
                            i.l = r;
                            return;
                        }
                    }
                }
            }
            return this.i += 1, i;
        }
        I(e, r) {
            for(; e;){
                let n = this.v(e.u, r);
                if (n < 0) e = e.W;
                else if (n > 0) e = e.U;
                else return e;
            }
            return e || this.h;
        }
        clear() {
            this.i = 0, this.Y = void 0, this.h.tt = void 0, this.h.U = this.h.W = void 0;
        }
        updateKeyByIterator(e, r) {
            let n = e.o;
            if (n === this.h && (0, ky.throwIteratorAccessError)(), this.i === 1) return n.u = r, !0;
            if (n === this.h.U) return this.v(n.B().u, r) > 0 ? (n.u = r, !0) : !1;
            if (n === this.h.W) return this.v(n.L().u, r) < 0 ? (n.u = r, !0) : !1;
            let i = n.L().u;
            if (this.v(i, r) >= 0) return !1;
            let s = n.B().u;
            return this.v(s, r) <= 0 ? !1 : (n.u = r, !0);
        }
        eraseElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let r = 0, n = this;
            return this.oe(this.Y, function(i) {
                return e === r ? (n.V(i), !0) : (r += 1, !1);
            }), this.i;
        }
        eraseElementByKey(e) {
            if (this.i === 0) return !1;
            let r = this.I(this.Y, e);
            return r === this.h ? !1 : (this.V(r), !0);
        }
        eraseElementByIterator(e) {
            let r = e.o;
            r === this.h && (0, ky.throwIteratorAccessError)();
            let n = r.W === void 0;
            return e.iteratorType === 0 ? n && e.next() : (!n || r.U === void 0) && e.next(), this.V(r), e;
        }
        forEach(e) {
            let r = 0;
            for (let n of this)e(n, r++, this);
        }
        getElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let r, n = 0;
            for (let i of this){
                if (n === e) {
                    r = i;
                    break;
                }
                n += 1;
            }
            return r;
        }
        getHeight() {
            if (this.i === 0) return 0;
            let e = function(r) {
                return r ? Math.max(e(r.U), e(r.W)) + 1 : 0;
            };
            return e(this.Y);
        }
    }, o1 = ou;
    Bo.default = o1;
});
var $4c2dd1b68d143d96$var$uu = $4c2dd1b68d143d96$var$D((No)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(No, "t", {
        value: !0
    });
    No.default = void 0;
    var s1 = $4c2dd1b68d143d96$var$It(), Mo = $4c2dd1b68d143d96$var$xt(), au = class extends s1.ContainerIterator {
        constructor(e, r, n){
            super(n), this.o = e, this.h = r, this.iteratorType === 0 ? (this.pre = function() {
                return this.o === this.h.U && (0, Mo.throwIteratorAccessError)(), this.o = this.o.L(), this;
            }, this.next = function() {
                return this.o === this.h && (0, Mo.throwIteratorAccessError)(), this.o = this.o.B(), this;
            }) : (this.pre = function() {
                return this.o === this.h.W && (0, Mo.throwIteratorAccessError)(), this.o = this.o.B(), this;
            }, this.next = function() {
                return this.o === this.h && (0, Mo.throwIteratorAccessError)(), this.o = this.o.L(), this;
            });
        }
        get index() {
            let e = this.o, r = this.h.tt;
            if (e === this.h) return r ? r.rt - 1 : 0;
            let n = 0;
            for(e.U && (n += e.U.rt); e !== r;){
                let i = e.tt;
                e === i.W && (n += 1, i.U && (n += i.U.rt)), e = i;
            }
            return n;
        }
    }, a1 = au;
    No.default = a1;
});
var $4c2dd1b68d143d96$var$By = $4c2dd1b68d143d96$var$D((qo)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(qo, "t", {
        value: !0
    });
    qo.default = void 0;
    var u1 = Cy($4c2dd1b68d143d96$var$su()), l1 = Cy($4c2dd1b68d143d96$var$uu()), c1 = $4c2dd1b68d143d96$var$xt();
    function Cy(t) {
        return t && t.t ? t : {
            default: t
        };
    }
    var dt = class t extends l1.default {
        constructor(e, r, n, i){
            super(e, r, i), this.container = n;
        }
        get pointer() {
            return this.o === this.h && (0, c1.throwIteratorAccessError)(), this.o.u;
        }
        copy() {
            return new t(this.o, this.h, this.container, this.iteratorType);
        }
    }, lu = class extends u1.default {
        constructor(e = [], r, n){
            super(r, n);
            let i = this;
            e.forEach(function(s) {
                i.insert(s);
            });
        }
        *K(e) {
            e !== void 0 && (yield* this.K(e.U), yield e.u, yield* this.K(e.W));
        }
        begin() {
            return new dt(this.h.U || this.h, this.h, this);
        }
        end() {
            return new dt(this.h, this.h, this);
        }
        rBegin() {
            return new dt(this.h.W || this.h, this.h, this, 1);
        }
        rEnd() {
            return new dt(this.h, this.h, this, 1);
        }
        front() {
            return this.h.U ? this.h.U.u : void 0;
        }
        back() {
            return this.h.W ? this.h.W.u : void 0;
        }
        insert(e, r) {
            return this.M(e, void 0, r);
        }
        find(e) {
            let r = this.I(this.Y, e);
            return new dt(r, this.h, this);
        }
        lowerBound(e) {
            let r = this.X(this.Y, e);
            return new dt(r, this.h, this);
        }
        upperBound(e) {
            let r = this.Z(this.Y, e);
            return new dt(r, this.h, this);
        }
        reverseLowerBound(e) {
            let r = this.$(this.Y, e);
            return new dt(r, this.h, this);
        }
        reverseUpperBound(e) {
            let r = this.rr(this.Y, e);
            return new dt(r, this.h, this);
        }
        union(e) {
            let r = this;
            return e.forEach(function(n) {
                r.insert(n);
            }), this.i;
        }
        [Symbol.iterator]() {
            return this.K(this.Y);
        }
    }, f1 = lu;
    qo.default = f1;
});
var $4c2dd1b68d143d96$var$Ny = $4c2dd1b68d143d96$var$D((Lo)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Lo, "t", {
        value: !0
    });
    Lo.default = void 0;
    var h1 = My($4c2dd1b68d143d96$var$su()), d1 = My($4c2dd1b68d143d96$var$uu()), p1 = $4c2dd1b68d143d96$var$xt();
    function My(t) {
        return t && t.t ? t : {
            default: t
        };
    }
    var pt = class t extends d1.default {
        constructor(e, r, n, i){
            super(e, r, i), this.container = n;
        }
        get pointer() {
            this.o === this.h && (0, p1.throwIteratorAccessError)();
            let e = this;
            return new Proxy([], {
                get (r, n) {
                    if (n === "0") return e.o.u;
                    if (n === "1") return e.o.l;
                },
                set (r, n, i) {
                    if (n !== "1") throw new TypeError("props must be 1");
                    return e.o.l = i, !0;
                }
            });
        }
        copy() {
            return new t(this.o, this.h, this.container, this.iteratorType);
        }
    }, cu = class extends h1.default {
        constructor(e = [], r, n){
            super(r, n);
            let i = this;
            e.forEach(function(s) {
                i.setElement(s[0], s[1]);
            });
        }
        *K(e) {
            e !== void 0 && (yield* this.K(e.U), yield [
                e.u,
                e.l
            ], yield* this.K(e.W));
        }
        begin() {
            return new pt(this.h.U || this.h, this.h, this);
        }
        end() {
            return new pt(this.h, this.h, this);
        }
        rBegin() {
            return new pt(this.h.W || this.h, this.h, this, 1);
        }
        rEnd() {
            return new pt(this.h, this.h, this, 1);
        }
        front() {
            if (this.i === 0) return;
            let e = this.h.U;
            return [
                e.u,
                e.l
            ];
        }
        back() {
            if (this.i === 0) return;
            let e = this.h.W;
            return [
                e.u,
                e.l
            ];
        }
        lowerBound(e) {
            let r = this.X(this.Y, e);
            return new pt(r, this.h, this);
        }
        upperBound(e) {
            let r = this.Z(this.Y, e);
            return new pt(r, this.h, this);
        }
        reverseLowerBound(e) {
            let r = this.$(this.Y, e);
            return new pt(r, this.h, this);
        }
        reverseUpperBound(e) {
            let r = this.rr(this.Y, e);
            return new pt(r, this.h, this);
        }
        setElement(e, r, n) {
            return this.M(e, r, n);
        }
        find(e) {
            let r = this.I(this.Y, e);
            return new pt(r, this.h, this);
        }
        getElementByKey(e) {
            return this.I(this.Y, e).l;
        }
        union(e) {
            let r = this;
            return e.forEach(function(n) {
                r.setElement(n[0], n[1]);
            }), this.i;
        }
        [Symbol.iterator]() {
            return this.K(this.Y);
        }
    }, y1 = cu;
    Lo.default = y1;
});
var $4c2dd1b68d143d96$var$hu = $4c2dd1b68d143d96$var$D((fu)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(fu, "t", {
        value: !0
    });
    fu.default = g1;
    function g1(t) {
        let e = typeof t;
        return e === "object" && t !== null || e === "function";
    }
});
var $4c2dd1b68d143d96$var$gu = $4c2dd1b68d143d96$var$D((mn)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(mn, "t", {
        value: !0
    });
    mn.HashContainerIterator = mn.HashContainer = void 0;
    var qy = $4c2dd1b68d143d96$var$It(), du = b1($4c2dd1b68d143d96$var$hu()), Kn = $4c2dd1b68d143d96$var$xt();
    function b1(t) {
        return t && t.t ? t : {
            default: t
        };
    }
    var pu = class extends qy.ContainerIterator {
        constructor(e, r, n){
            super(n), this.o = e, this.h = r, this.iteratorType === 0 ? (this.pre = function() {
                return this.o.L === this.h && (0, Kn.throwIteratorAccessError)(), this.o = this.o.L, this;
            }, this.next = function() {
                return this.o === this.h && (0, Kn.throwIteratorAccessError)(), this.o = this.o.B, this;
            }) : (this.pre = function() {
                return this.o.B === this.h && (0, Kn.throwIteratorAccessError)(), this.o = this.o.B, this;
            }, this.next = function() {
                return this.o === this.h && (0, Kn.throwIteratorAccessError)(), this.o = this.o.L, this;
            });
        }
    };
    mn.HashContainerIterator = pu;
    var yu = class extends qy.Container {
        constructor(){
            super(), this.H = [], this.g = {}, this.HASH_TAG = Symbol("@@HASH_TAG"), Object.setPrototypeOf(this.g, null), this.h = {}, this.h.L = this.h.B = this.p = this._ = this.h;
        }
        V(e) {
            let { L: r, B: n } = e;
            r.B = n, n.L = r, e === this.p && (this.p = n), e === this._ && (this._ = r), this.i -= 1;
        }
        M(e, r, n) {
            n === void 0 && (n = (0, du.default)(e));
            let i;
            if (n) {
                let s = e[this.HASH_TAG];
                if (s !== void 0) return this.H[s].l = r, this.i;
                Object.defineProperty(e, this.HASH_TAG, {
                    value: this.H.length,
                    configurable: !0
                }), i = {
                    u: e,
                    l: r,
                    L: this._,
                    B: this.h
                }, this.H.push(i);
            } else {
                let s = this.g[e];
                if (s) return s.l = r, this.i;
                i = {
                    u: e,
                    l: r,
                    L: this._,
                    B: this.h
                }, this.g[e] = i;
            }
            return this.i === 0 ? (this.p = i, this.h.B = i) : this._.B = i, this._ = i, this.h.L = i, ++this.i;
        }
        I(e, r) {
            if (r === void 0 && (r = (0, du.default)(e)), r) {
                let n = e[this.HASH_TAG];
                return n === void 0 ? this.h : this.H[n];
            } else return this.g[e] || this.h;
        }
        clear() {
            let e = this.HASH_TAG;
            this.H.forEach(function(r) {
                delete r.u[e];
            }), this.H = [], this.g = {}, Object.setPrototypeOf(this.g, null), this.i = 0, this.p = this._ = this.h.L = this.h.B = this.h;
        }
        eraseElementByKey(e, r) {
            let n;
            if (r === void 0 && (r = (0, du.default)(e)), r) {
                let i = e[this.HASH_TAG];
                if (i === void 0) return !1;
                delete e[this.HASH_TAG], n = this.H[i], delete this.H[i];
            } else {
                if (n = this.g[e], n === void 0) return !1;
                delete this.g[e];
            }
            return this.V(n), !0;
        }
        eraseElementByIterator(e) {
            let r = e.o;
            return r === this.h && (0, Kn.throwIteratorAccessError)(), this.V(r), e.next();
        }
        eraseElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let r = this.p;
            for(; e--;)r = r.B;
            return this.V(r), this.i;
        }
    };
    mn.HashContainer = yu;
});
var $4c2dd1b68d143d96$var$Uy = $4c2dd1b68d143d96$var$D((Uo)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Uo, "t", {
        value: !0
    });
    Uo.default = void 0;
    var Ly = $4c2dd1b68d143d96$var$gu(), w1 = $4c2dd1b68d143d96$var$xt(), Dr = class t extends Ly.HashContainerIterator {
        constructor(e, r, n, i){
            super(e, r, i), this.container = n;
        }
        get pointer() {
            return this.o === this.h && (0, w1.throwIteratorAccessError)(), this.o.u;
        }
        copy() {
            return new t(this.o, this.h, this.container, this.iteratorType);
        }
    }, bu = class extends Ly.HashContainer {
        constructor(e = []){
            super();
            let r = this;
            e.forEach(function(n) {
                r.insert(n);
            });
        }
        begin() {
            return new Dr(this.p, this.h, this);
        }
        end() {
            return new Dr(this.h, this.h, this);
        }
        rBegin() {
            return new Dr(this._, this.h, this, 1);
        }
        rEnd() {
            return new Dr(this.h, this.h, this, 1);
        }
        front() {
            return this.p.u;
        }
        back() {
            return this._.u;
        }
        insert(e, r) {
            return this.M(e, void 0, r);
        }
        getElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let r = this.p;
            for(; e--;)r = r.B;
            return r.u;
        }
        find(e, r) {
            let n = this.I(e, r);
            return new Dr(n, this.h, this);
        }
        forEach(e) {
            let r = 0, n = this.p;
            for(; n !== this.h;)e(n.u, r++, this), n = n.B;
        }
        [Symbol.iterator]() {
            return (function*() {
                let e = this.p;
                for(; e !== this.h;)yield e.u, e = e.B;
            }).bind(this)();
        }
    }, m1 = bu;
    Uo.default = m1;
});
var $4c2dd1b68d143d96$var$jy = $4c2dd1b68d143d96$var$D((Do)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Do, "t", {
        value: !0
    });
    Do.default = void 0;
    var Dy = $4c2dd1b68d143d96$var$gu(), _1 = S1($4c2dd1b68d143d96$var$hu()), v1 = $4c2dd1b68d143d96$var$xt();
    function S1(t) {
        return t && t.t ? t : {
            default: t
        };
    }
    var jr = class t extends Dy.HashContainerIterator {
        constructor(e, r, n, i){
            super(e, r, i), this.container = n;
        }
        get pointer() {
            this.o === this.h && (0, v1.throwIteratorAccessError)();
            let e = this;
            return new Proxy([], {
                get (r, n) {
                    if (n === "0") return e.o.u;
                    if (n === "1") return e.o.l;
                },
                set (r, n, i) {
                    if (n !== "1") throw new TypeError("props must be 1");
                    return e.o.l = i, !0;
                }
            });
        }
        copy() {
            return new t(this.o, this.h, this.container, this.iteratorType);
        }
    }, wu = class extends Dy.HashContainer {
        constructor(e = []){
            super();
            let r = this;
            e.forEach(function(n) {
                r.setElement(n[0], n[1]);
            });
        }
        begin() {
            return new jr(this.p, this.h, this);
        }
        end() {
            return new jr(this.h, this.h, this);
        }
        rBegin() {
            return new jr(this._, this.h, this, 1);
        }
        rEnd() {
            return new jr(this.h, this.h, this, 1);
        }
        front() {
            if (this.i !== 0) return [
                this.p.u,
                this.p.l
            ];
        }
        back() {
            if (this.i !== 0) return [
                this._.u,
                this._.l
            ];
        }
        setElement(e, r, n) {
            return this.M(e, r, n);
        }
        getElementByKey(e, r) {
            if (r === void 0 && (r = (0, _1.default)(e)), r) {
                let i = e[this.HASH_TAG];
                return i !== void 0 ? this.H[i].l : void 0;
            }
            let n = this.g[e];
            return n ? n.l : void 0;
        }
        getElementByPos(e) {
            if (e < 0 || e > this.i - 1) throw new RangeError;
            let r = this.p;
            for(; e--;)r = r.B;
            return [
                r.u,
                r.l
            ];
        }
        find(e, r) {
            let n = this.I(e, r);
            return new jr(n, this.h, this);
        }
        forEach(e) {
            let r = 0, n = this.p;
            for(; n !== this.h;)e([
                n.u,
                n.l
            ], r++, this), n = n.B;
        }
        [Symbol.iterator]() {
            return (function*() {
                let e = this.p;
                for(; e !== this.h;)yield [
                    e.u,
                    e.l
                ], e = e.B;
            }).bind(this)();
        }
    }, E1 = wu;
    Do.default = E1;
});
var $4c2dd1b68d143d96$var$Fy = $4c2dd1b68d143d96$var$D((it)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(it, "t", {
        value: !0
    });
    Object.defineProperty(it, "Deque", {
        enumerable: !0,
        get: function() {
            return O1.default;
        }
    });
    Object.defineProperty(it, "HashMap", {
        enumerable: !0,
        get: function() {
            return B1.default;
        }
    });
    Object.defineProperty(it, "HashSet", {
        enumerable: !0,
        get: function() {
            return C1.default;
        }
    });
    Object.defineProperty(it, "LinkList", {
        enumerable: !0,
        get: function() {
            return P1.default;
        }
    });
    Object.defineProperty(it, "OrderedMap", {
        enumerable: !0,
        get: function() {
            return k1.default;
        }
    });
    Object.defineProperty(it, "OrderedSet", {
        enumerable: !0,
        get: function() {
            return R1.default;
        }
    });
    Object.defineProperty(it, "PriorityQueue", {
        enumerable: !0,
        get: function() {
            return x1.default;
        }
    });
    Object.defineProperty(it, "Queue", {
        enumerable: !0,
        get: function() {
            return I1.default;
        }
    });
    Object.defineProperty(it, "Stack", {
        enumerable: !0,
        get: function() {
            return A1.default;
        }
    });
    Object.defineProperty(it, "Vector", {
        enumerable: !0,
        get: function() {
            return T1.default;
        }
    });
    var A1 = Tt($4c2dd1b68d143d96$var$Ey()), I1 = Tt($4c2dd1b68d143d96$var$Ay()), x1 = Tt($4c2dd1b68d143d96$var$Iy()), T1 = Tt($4c2dd1b68d143d96$var$xy()), P1 = Tt($4c2dd1b68d143d96$var$Ty()), O1 = Tt($4c2dd1b68d143d96$var$Py()), R1 = Tt($4c2dd1b68d143d96$var$By()), k1 = Tt($4c2dd1b68d143d96$var$Ny()), C1 = Tt($4c2dd1b68d143d96$var$Uy()), B1 = Tt($4c2dd1b68d143d96$var$jy());
    function Tt(t) {
        return t && t.t ? t : {
            default: t
        };
    }
});
var $4c2dd1b68d143d96$var$$y = $4c2dd1b68d143d96$var$D((cj, Wy)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var M1 = $4c2dd1b68d143d96$var$Fy().OrderedSet, Pt = $4c2dd1b68d143d96$var$At()("number-allocator:trace"), N1 = $4c2dd1b68d143d96$var$At()("number-allocator:error");
    function Ve(t, e) {
        this.low = t, this.high = e;
    }
    Ve.prototype.equals = function(t) {
        return this.low === t.low && this.high === t.high;
    };
    Ve.prototype.compare = function(t) {
        return this.low < t.low && this.high < t.low ? -1 : t.low < this.low && t.high < this.low ? 1 : 0;
    };
    function Ot(t, e) {
        if (!(this instanceof Ot)) return new Ot(t, e);
        this.min = t, this.max = e, this.ss = new M1([], (r, n)=>r.compare(n)), Pt("Create"), this.clear();
    }
    Ot.prototype.firstVacant = function() {
        return this.ss.size() === 0 ? null : this.ss.front().low;
    };
    Ot.prototype.alloc = function() {
        if (this.ss.size() === 0) return Pt("alloc():empty"), null;
        let t = this.ss.begin(), e = t.pointer.low, r = t.pointer.high, n = e;
        return n + 1 <= r ? this.ss.updateKeyByIterator(t, new Ve(e + 1, r)) : this.ss.eraseElementByPos(0), Pt("alloc():" + n), n;
    };
    Ot.prototype.use = function(t) {
        let e = new Ve(t, t), r = this.ss.lowerBound(e);
        if (!r.equals(this.ss.end())) {
            let n = r.pointer.low, i = r.pointer.high;
            return r.pointer.equals(e) ? (this.ss.eraseElementByIterator(r), Pt("use():" + t), !0) : n > t ? !1 : n === t ? (this.ss.updateKeyByIterator(r, new Ve(n + 1, i)), Pt("use():" + t), !0) : i === t ? (this.ss.updateKeyByIterator(r, new Ve(n, i - 1)), Pt("use():" + t), !0) : (this.ss.updateKeyByIterator(r, new Ve(t + 1, i)), this.ss.insert(new Ve(n, t - 1)), Pt("use():" + t), !0);
        }
        return Pt("use():failed"), !1;
    };
    Ot.prototype.free = function(t) {
        if (t < this.min || t > this.max) {
            N1("free():" + t + " is out of range");
            return;
        }
        let e = new Ve(t, t), r = this.ss.upperBound(e);
        if (r.equals(this.ss.end())) {
            if (r.equals(this.ss.begin())) {
                this.ss.insert(e);
                return;
            }
            r.pre();
            let n = r.pointer.high;
            r.pointer.high + 1 === t ? this.ss.updateKeyByIterator(r, new Ve(n, t)) : this.ss.insert(e);
        } else if (r.equals(this.ss.begin())) {
            if (t + 1 === r.pointer.low) {
                let n = r.pointer.high;
                this.ss.updateKeyByIterator(r, new Ve(t, n));
            } else this.ss.insert(e);
        } else {
            let n = r.pointer.low, i = r.pointer.high;
            r.pre();
            let s = r.pointer.low;
            r.pointer.high + 1 === t ? t + 1 === n ? (this.ss.eraseElementByIterator(r), this.ss.updateKeyByIterator(r, new Ve(s, i))) : this.ss.updateKeyByIterator(r, new Ve(s, t)) : t + 1 === n ? (this.ss.eraseElementByIterator(r.next()), this.ss.insert(new Ve(t, i))) : this.ss.insert(e);
        }
        Pt("free():" + t);
    };
    Ot.prototype.clear = function() {
        Pt("clear()"), this.ss.clear(), this.ss.insert(new Ve(this.min, this.max));
    };
    Ot.prototype.intervalCount = function() {
        return this.ss.size();
    };
    Ot.prototype.dump = function() {
        console.log("length:" + this.ss.size());
        for (let t of this.ss)console.log(t);
    };
    Wy.exports = Ot;
});
var $4c2dd1b68d143d96$var$mu = $4c2dd1b68d143d96$var$D((_j, Hy)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var q1 = $4c2dd1b68d143d96$var$$y();
    Hy.exports.NumberAllocator = q1;
});
var $4c2dd1b68d143d96$var$Vy = $4c2dd1b68d143d96$var$D((vu)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(vu, "__esModule", {
        value: !0
    });
    var L1 = $4c2dd1b68d143d96$var$Sy(), U1 = $4c2dd1b68d143d96$var$mu(), _u = class {
        aliasToTopic;
        topicToAlias;
        max;
        numberAllocator;
        length;
        constructor(e){
            e > 0 && (this.aliasToTopic = new L1.LRUCache({
                max: e
            }), this.topicToAlias = {}, this.numberAllocator = new U1.NumberAllocator(1, e), this.max = e, this.length = 0);
        }
        put(e, r) {
            if (r === 0 || r > this.max) return !1;
            let n = this.aliasToTopic.get(r);
            return n && delete this.topicToAlias[n], this.aliasToTopic.set(r, e), this.topicToAlias[e] = r, this.numberAllocator.use(r), this.length = this.aliasToTopic.size, !0;
        }
        getTopicByAlias(e) {
            return this.aliasToTopic.get(e);
        }
        getAliasByTopic(e) {
            let r = this.topicToAlias[e];
            return typeof r < "u" && this.aliasToTopic.get(r), r;
        }
        clear() {
            this.aliasToTopic.clear(), this.topicToAlias = {}, this.numberAllocator.clear(), this.length = 0;
        }
        getLruAlias() {
            let e = this.numberAllocator.firstVacant();
            return e || [
                ...this.aliasToTopic.keys()
            ][this.aliasToTopic.size - 1];
        }
    };
    vu.default = _u;
});
var $4c2dd1b68d143d96$var$Gy = $4c2dd1b68d143d96$var$D((Qn)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var D1 = Qn && Qn.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(Qn, "__esModule", {
        value: !0
    });
    var j1 = $4c2dd1b68d143d96$var$zn(), F1 = D1($4c2dd1b68d143d96$var$Vy()), W1 = $4c2dd1b68d143d96$var$Mr(), $1 = (t, e)=>{
        t.log("_handleConnack");
        let { options: r } = t, i = r.protocolVersion === 5 ? e.reasonCode : e.returnCode;
        if (clearTimeout(t.connackTimer), delete t.topicAliasSend, e.properties) {
            if (e.properties.topicAliasMaximum) {
                if (e.properties.topicAliasMaximum > 65535) {
                    t.emit("error", new Error("topicAliasMaximum from broker is out of range"));
                    return;
                }
                e.properties.topicAliasMaximum > 0 && (t.topicAliasSend = new F1.default(e.properties.topicAliasMaximum));
            }
            e.properties.serverKeepAlive && r.keepalive && (r.keepalive = e.properties.serverKeepAlive), e.properties.maximumPacketSize && (r.properties || (r.properties = {}), r.properties.maximumPacketSize = e.properties.maximumPacketSize);
        }
        if (i === 0) t.reconnecting = !1, t._onConnect(e);
        else if (i > 0) {
            let s = new W1.ErrorWithReasonCode(`Connection refused: ${j1.ReasonCodes[i]}`, i);
            t.emit("error", s), t.options.reconnectOnConnackError && t._cleanUp(!0);
        }
    };
    Qn.default = $1;
});
var $4c2dd1b68d143d96$var$zy = $4c2dd1b68d143d96$var$D((Su)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Su, "__esModule", {
        value: !0
    });
    var H1 = (t, e, r)=>{
        t.log("handling pubrel packet");
        let n = typeof r < "u" ? r : t.noop, { messageId: i } = e, s = {
            cmd: "pubcomp",
            messageId: i
        };
        t.incomingStore.get(e, (o, a)=>{
            o ? t._sendPacket(s, n) : (t.emit("message", a.topic, a.payload, a), t.handleMessage(a, (c)=>{
                if (c) return n(c);
                t.incomingStore.del(a, t.noop), t._sendPacket(s, n);
            }));
        });
    };
    Su.default = H1;
});
var $4c2dd1b68d143d96$var$Ky = $4c2dd1b68d143d96$var$D((Yn)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var Jn = Yn && Yn.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(Yn, "__esModule", {
        value: !0
    });
    var V1 = Jn($4c2dd1b68d143d96$var$dy()), G1 = Jn($4c2dd1b68d143d96$var$by()), z1 = Jn($4c2dd1b68d143d96$var$Gy()), K1 = Jn($4c2dd1b68d143d96$var$zn()), Q1 = Jn($4c2dd1b68d143d96$var$zy()), Y1 = (t, e, r)=>{
        let { options: n } = t;
        if (n.protocolVersion === 5 && n.properties && n.properties.maximumPacketSize && n.properties.maximumPacketSize < e.length) return t.emit("error", new Error(`exceeding packets size ${e.cmd}`)), t.end({
            reasonCode: 149,
            properties: {
                reasonString: "Maximum packet size was exceeded"
            }
        }), t;
        switch(t.log("_handlePacket :: emitting packetreceive"), t.emit("packetreceive", e), e.cmd){
            case "publish":
                (0, V1.default)(t, e, r);
                break;
            case "puback":
            case "pubrec":
            case "pubcomp":
            case "suback":
            case "unsuback":
                t.reschedulePing(), (0, K1.default)(t, e), r();
                break;
            case "pubrel":
                t.reschedulePing(), (0, Q1.default)(t, e, r);
                break;
            case "connack":
                (0, z1.default)(t, e), r();
                break;
            case "auth":
                t.reschedulePing(), (0, G1.default)(t, e), r();
                break;
            case "pingresp":
                t.log("_handlePacket :: received pingresp"), t.reschedulePing(!0), r();
                break;
            case "disconnect":
                t.emit("disconnect", e), r();
                break;
            default:
                t.log("_handlePacket :: unknown command"), r();
                break;
        }
    };
    Yn.default = Y1;
});
var $4c2dd1b68d143d96$var$Iu = $4c2dd1b68d143d96$var$D((Au)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Au, "__esModule", {
        value: !0
    });
    var Eu = class {
        nextId;
        constructor(){
            this.nextId = Math.max(1, Math.floor(Math.random() * 65535));
        }
        allocate() {
            let e = this.nextId++;
            return this.nextId === 65536 && (this.nextId = 1), e;
        }
        getLastAllocated() {
            return this.nextId === 1 ? 65535 : this.nextId - 1;
        }
        register(e) {
            return !0;
        }
        deallocate(e) {}
        clear() {}
    };
    Au.default = Eu;
});
var $4c2dd1b68d143d96$var$Qy = $4c2dd1b68d143d96$var$D((Tu)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Tu, "__esModule", {
        value: !0
    });
    var xu = class {
        aliasToTopic;
        max;
        length;
        constructor(e){
            this.aliasToTopic = {}, this.max = e;
        }
        put(e, r) {
            return r === 0 || r > this.max ? !1 : (this.aliasToTopic[r] = e, this.length = Object.keys(this.aliasToTopic).length, !0);
        }
        getTopicByAlias(e) {
            return this.aliasToTopic[e];
        }
        clear() {
            this.aliasToTopic = {};
        }
    };
    Tu.default = xu;
});
var $4c2dd1b68d143d96$var$Yy = $4c2dd1b68d143d96$var$D((_n)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var J1 = _n && _n.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(_n, "__esModule", {
        value: !0
    });
    _n.TypedEventEmitter = void 0;
    var X1 = J1(($4c2dd1b68d143d96$var$er(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$Zt))), Z1 = $4c2dd1b68d143d96$var$Mr(), jo = class {
    };
    _n.TypedEventEmitter = jo;
    (0, Z1.applyMixin)(jo, X1.default);
});
var $4c2dd1b68d143d96$var$Xn = $4c2dd1b68d143d96$var$D((GF, Wt)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    function Pu(t) {
        "@babel/helpers - typeof";
        return Wt.exports = Pu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
            return typeof e;
        } : function(e) {
            return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, Wt.exports.__esModule = !0, Wt.exports.default = Wt.exports, Pu(t);
    }
    Wt.exports = Pu, Wt.exports.__esModule = !0, Wt.exports.default = Wt.exports;
});
var $4c2dd1b68d143d96$var$Xy = $4c2dd1b68d143d96$var$D((r8, Zn)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var Jy = $4c2dd1b68d143d96$var$Xn().default;
    function eA(t, e) {
        if (Jy(t) != "object" || !t) return t;
        var r = t[Symbol.toPrimitive];
        if (r !== void 0) {
            var n = r.call(t, e || "default");
            if (Jy(n) != "object") return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (e === "string" ? String : Number)(t);
    }
    Zn.exports = eA, Zn.exports.__esModule = !0, Zn.exports.default = Zn.exports;
});
var $4c2dd1b68d143d96$var$Zy = $4c2dd1b68d143d96$var$D((h8, ei)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var tA = $4c2dd1b68d143d96$var$Xn().default, rA = $4c2dd1b68d143d96$var$Xy();
    function nA(t) {
        var e = rA(t, "string");
        return tA(e) == "symbol" ? e : e + "";
    }
    ei.exports = nA, ei.exports.__esModule = !0, ei.exports.default = ei.exports;
});
var $4c2dd1b68d143d96$var$eg = $4c2dd1b68d143d96$var$D((S8, ti)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var iA = $4c2dd1b68d143d96$var$Zy();
    function oA(t, e, r) {
        return (e = iA(e)) in t ? Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = r, t;
    }
    ti.exports = oA, ti.exports.__esModule = !0, ti.exports.default = ti.exports;
});
var $4c2dd1b68d143d96$var$tg = $4c2dd1b68d143d96$var$D((C8, ri)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    function sA(t) {
        if (Array.isArray(t)) return t;
    }
    ri.exports = sA, ri.exports.__esModule = !0, ri.exports.default = ri.exports;
});
var $4c2dd1b68d143d96$var$rg = $4c2dd1b68d143d96$var$D((W8, ni)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    function aA(t, e) {
        var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
        if (r != null) {
            var n, i, s, o, a = [], c = !0, f = !1;
            try {
                if (s = (r = r.call(t)).next, e === 0) {
                    if (Object(r) !== r) return;
                    c = !1;
                } else for(; !(c = (n = s.call(r)).done) && (a.push(n.value), a.length !== e); c = !0);
            } catch (h) {
                f = !0, i = h;
            } finally{
                try {
                    if (!c && r.return != null && (o = r.return(), Object(o) !== o)) return;
                } finally{
                    if (f) throw i;
                }
            }
            return a;
        }
    }
    ni.exports = aA, ni.exports.__esModule = !0, ni.exports.default = ni.exports;
});
var $4c2dd1b68d143d96$var$ng = $4c2dd1b68d143d96$var$D((X8, ii)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    function uA(t, e) {
        (e == null || e > t.length) && (e = t.length);
        for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
        return n;
    }
    ii.exports = uA, ii.exports.__esModule = !0, ii.exports.default = ii.exports;
});
var $4c2dd1b68d143d96$var$og = $4c2dd1b68d143d96$var$D((u6, oi)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var ig = $4c2dd1b68d143d96$var$ng();
    function lA(t, e) {
        if (t) {
            if (typeof t == "string") return ig(t, e);
            var r = ({}).toString.call(t).slice(8, -1);
            return r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set" ? Array.from(t) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ig(t, e) : void 0;
        }
    }
    oi.exports = lA, oi.exports.__esModule = !0, oi.exports.default = oi.exports;
});
var $4c2dd1b68d143d96$var$sg = $4c2dd1b68d143d96$var$D((w6, si)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    function cA() {
        throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    si.exports = cA, si.exports.__esModule = !0, si.exports.default = si.exports;
});
var $4c2dd1b68d143d96$var$ag = $4c2dd1b68d143d96$var$D((P6, ai)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var fA = $4c2dd1b68d143d96$var$tg(), hA = $4c2dd1b68d143d96$var$rg(), dA = $4c2dd1b68d143d96$var$og(), pA = $4c2dd1b68d143d96$var$sg();
    function yA(t, e) {
        return fA(t) || hA(t, e) || dA(t, e) || pA();
    }
    ai.exports = yA, ai.exports.__esModule = !0, ai.exports.default = ai.exports;
});
var $4c2dd1b68d143d96$var$Ou = $4c2dd1b68d143d96$var$D((Fo, ug)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    (function(t, e) {
        typeof Fo == "object" && typeof ug < "u" ? e(Fo) : typeof define == "function" && define.amd ? define([
            "exports"
        ], e) : (t = typeof globalThis < "u" ? globalThis : t || self, e(t.fastUniqueNumbers = {}));
    })(Fo, function(t) {
        "use strict";
        var e = function(w) {
            return function(y) {
                var P = w(y);
                return y.add(P), P;
            };
        }, r = function(w) {
            return function(y, P) {
                return w.set(y, P), P;
            };
        }, n = Number.MAX_SAFE_INTEGER === void 0 ? 9007199254740991 : Number.MAX_SAFE_INTEGER, i = 536870912, s = i * 2, o = function(w, y) {
            return function(P) {
                var E = y.get(P), b = E === void 0 ? P.size : E < s ? E + 1 : 0;
                if (!P.has(b)) return w(P, b);
                if (P.size < i) {
                    for(; P.has(b);)b = Math.floor(Math.random() * s);
                    return w(P, b);
                }
                if (P.size > n) throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");
                for(; P.has(b);)b = Math.floor(Math.random() * n);
                return w(P, b);
            };
        }, a = new WeakMap, c = r(a), f = o(c, a), h = e(f);
        t.addUniqueNumber = h, t.generateUniqueNumber = f;
    });
});
var $4c2dd1b68d143d96$var$cg = $4c2dd1b68d143d96$var$D((z6, ui)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    function lg(t, e, r, n, i, s, o) {
        try {
            var a = t[s](o), c = a.value;
        } catch (f) {
            return void r(f);
        }
        a.done ? e(c) : Promise.resolve(c).then(n, i);
    }
    function gA(t) {
        return function() {
            var e = this, r = arguments;
            return new Promise(function(n, i) {
                var s = t.apply(e, r);
                function o(c) {
                    lg(s, n, i, o, a, "next", c);
                }
                function a(c) {
                    lg(s, n, i, o, a, "throw", c);
                }
                o(void 0);
            });
        };
    }
    ui.exports = gA, ui.exports.__esModule = !0, ui.exports.default = ui.exports;
});
var $4c2dd1b68d143d96$var$Ru = $4c2dd1b68d143d96$var$D((nW, li)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    function bA(t, e) {
        this.v = t, this.k = e;
    }
    li.exports = bA, li.exports.__esModule = !0, li.exports.default = li.exports;
});
var $4c2dd1b68d143d96$var$ku = $4c2dd1b68d143d96$var$D((dW, $t)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    function Wo(t, e, r, n) {
        var i = Object.defineProperty;
        try {
            i({}, "", {});
        } catch  {
            i = 0;
        }
        $t.exports = Wo = function(o, a, c, f) {
            function h(d, w) {
                Wo(o, d, function(y) {
                    return this._invoke(d, w, y);
                });
            }
            a ? i ? i(o, a, {
                value: c,
                enumerable: !f,
                configurable: !f,
                writable: !f
            }) : o[a] = c : (h("next", 0), h("throw", 1), h("return", 2));
        }, $t.exports.__esModule = !0, $t.exports.default = $t.exports, Wo(t, e, r, n);
    }
    $t.exports = Wo, $t.exports.__esModule = !0, $t.exports.default = $t.exports;
});
var $4c2dd1b68d143d96$var$Cu = $4c2dd1b68d143d96$var$D((EW, Ht)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var Rt = $4c2dd1b68d143d96$var$ku();
    function fg() {
        var t, e, r = typeof Symbol == "function" ? Symbol : {}, n = r.iterator || "@@iterator", i = r.toStringTag || "@@toStringTag";
        function s(y, P, E, b) {
            var m = P && P.prototype instanceof a ? P : a, v = Object.create(m.prototype);
            return Rt(v, "_invoke", function(R, T, g) {
                var O, _, q, $ = 0, j = g || [], J = !1, W = {
                    p: 0,
                    n: 0,
                    v: t,
                    a: H,
                    f: H.bind(t, 4),
                    d: function(K, X) {
                        return O = K, _ = 0, q = t, W.n = X, o;
                    }
                };
                function H(G, K) {
                    for(_ = G, q = K, e = 0; !J && $ && !X && e < j.length; e++){
                        var X, Q = j[e], V = W.p, te = Q[2];
                        G > 3 ? (X = te === K) && (q = Q[(_ = Q[4]) ? 5 : (_ = 3, 3)], Q[4] = Q[5] = t) : Q[0] <= V && ((X = G < 2 && V < Q[1]) ? (_ = 0, W.v = K, W.n = Q[1]) : V < te && (X = G < 3 || Q[0] > K || K > te) && (Q[4] = G, Q[5] = K, W.n = te, _ = 0));
                    }
                    if (X || G > 1) return o;
                    throw J = !0, K;
                }
                return function(G, K, X) {
                    if ($ > 1) throw TypeError("Generator is already running");
                    for(J && K === 1 && H(K, X), _ = K, q = X; (e = _ < 2 ? t : q) || !J;){
                        O || (_ ? _ < 3 ? (_ > 1 && (W.n = -1), H(_, q)) : W.n = q : W.v = q);
                        try {
                            if ($ = 2, O) {
                                if (_ || (G = "next"), e = O[G]) {
                                    if (!(e = e.call(O, q))) throw TypeError("iterator result is not an object");
                                    if (!e.done) return e;
                                    q = e.value, _ < 2 && (_ = 0);
                                } else _ === 1 && (e = O.return) && e.call(O), _ < 2 && (q = TypeError("The iterator does not provide a '" + G + "' method"), _ = 1);
                                O = t;
                            } else if ((e = (J = W.n < 0) ? q : R.call(T, W)) !== o) break;
                        } catch (Q) {
                            O = t, _ = 1, q = Q;
                        } finally{
                            $ = 1;
                        }
                    }
                    return {
                        value: e,
                        done: J
                    };
                };
            }(y, E, b), !0), v;
        }
        var o = {};
        function a() {}
        function c() {}
        function f() {}
        e = Object.getPrototypeOf;
        var h = [][n] ? e(e([][n]())) : (Rt(e = {}, n, function() {
            return this;
        }), e), d = f.prototype = a.prototype = Object.create(h);
        function w(y) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(y, f) : (y.__proto__ = f, Rt(y, i, "GeneratorFunction")), y.prototype = Object.create(d), y;
        }
        return c.prototype = f, Rt(d, "constructor", f), Rt(f, "constructor", c), c.displayName = "GeneratorFunction", Rt(f, i, "GeneratorFunction"), Rt(d), Rt(d, i, "Generator"), Rt(d, n, function() {
            return this;
        }), Rt(d, "toString", function() {
            return "[object Generator]";
        }), (Ht.exports = fg = function() {
            return {
                w: s,
                m: w
            };
        }, Ht.exports.__esModule = !0, Ht.exports.default = Ht.exports)();
    }
    Ht.exports = fg, Ht.exports.__esModule = !0, Ht.exports.default = Ht.exports;
});
var $4c2dd1b68d143d96$var$Nu = $4c2dd1b68d143d96$var$D((BW, ci)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var wA = $4c2dd1b68d143d96$var$Ru(), Bu = $4c2dd1b68d143d96$var$ku();
    function Mu(t, e) {
        function r(i, s, o, a) {
            try {
                var c = t[i](s), f = c.value;
                return f instanceof wA ? e.resolve(f.v).then(function(h) {
                    r("next", h, o, a);
                }, function(h) {
                    r("throw", h, o, a);
                }) : e.resolve(f).then(function(h) {
                    c.value = h, o(c);
                }, function(h) {
                    return r("throw", h, o, a);
                });
            } catch (h) {
                a(h);
            }
        }
        var n;
        this.next || (Bu(Mu.prototype), Bu(Mu.prototype, typeof Symbol == "function" && Symbol.asyncIterator || "@asyncIterator", function() {
            return this;
        })), Bu(this, "_invoke", function(i, s, o) {
            function a() {
                return new e(function(c, f) {
                    r(i, o, c, f);
                });
            }
            return n = n ? n.then(a, a) : a();
        }, !0);
    }
    ci.exports = Mu, ci.exports.__esModule = !0, ci.exports.default = ci.exports;
});
var $4c2dd1b68d143d96$var$qu = $4c2dd1b68d143d96$var$D(($W, fi)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var mA = $4c2dd1b68d143d96$var$Cu(), _A = $4c2dd1b68d143d96$var$Nu();
    function vA(t, e, r, n, i) {
        return new _A(mA().w(t, e, r, n), i || Promise);
    }
    fi.exports = vA, fi.exports.__esModule = !0, fi.exports.default = fi.exports;
});
var $4c2dd1b68d143d96$var$hg = $4c2dd1b68d143d96$var$D((ZW, hi)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var SA = $4c2dd1b68d143d96$var$qu();
    function EA(t, e, r, n, i) {
        var s = SA(t, e, r, n, i);
        return s.next().then(function(o) {
            return o.done ? o.value : s.next();
        });
    }
    hi.exports = EA, hi.exports.__esModule = !0, hi.exports.default = hi.exports;
});
var $4c2dd1b68d143d96$var$dg = $4c2dd1b68d143d96$var$D((l4, di)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    function AA(t) {
        var e = Object(t), r = [];
        for(var n in e)r.unshift(n);
        return function i() {
            for(; r.length;)if ((n = r.pop()) in e) return i.value = n, i.done = !1, i;
            return i.done = !0, i;
        };
    }
    di.exports = AA, di.exports.__esModule = !0, di.exports.default = di.exports;
});
var $4c2dd1b68d143d96$var$pg = $4c2dd1b68d143d96$var$D((m4, pi)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var IA = $4c2dd1b68d143d96$var$Xn().default;
    function xA(t) {
        if (t != null) {
            var e = t[typeof Symbol == "function" && Symbol.iterator || "@@iterator"], r = 0;
            if (e) return e.call(t);
            if (typeof t.next == "function") return t;
            if (!isNaN(t.length)) return {
                next: function() {
                    return t && r >= t.length && (t = void 0), {
                        value: t && t[r++],
                        done: !t
                    };
                }
            };
        }
        throw new TypeError(IA(t) + " is not iterable");
    }
    pi.exports = xA, pi.exports.__esModule = !0, pi.exports.default = pi.exports;
});
var $4c2dd1b68d143d96$var$gg = $4c2dd1b68d143d96$var$D((O4, Vt)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var TA = $4c2dd1b68d143d96$var$Ru(), PA = $4c2dd1b68d143d96$var$Cu(), OA = $4c2dd1b68d143d96$var$hg(), RA = $4c2dd1b68d143d96$var$qu(), kA = $4c2dd1b68d143d96$var$Nu(), CA = $4c2dd1b68d143d96$var$dg(), yg = $4c2dd1b68d143d96$var$pg();
    function Lu() {
        "use strict";
        var t = PA(), e = t.m(Lu), r = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
        function n(o) {
            var a = typeof o == "function" && o.constructor;
            return !!a && (a === r || (a.displayName || a.name) === "GeneratorFunction");
        }
        var i = {
            throw: 1,
            return: 2,
            break: 3,
            continue: 3
        };
        function s(o) {
            var a, c;
            return function(f) {
                a || (a = {
                    stop: function() {
                        return c(f.a, 2);
                    },
                    catch: function() {
                        return f.v;
                    },
                    abrupt: function(d, w) {
                        return c(f.a, i[d], w);
                    },
                    delegateYield: function(d, w, y) {
                        return a.resultName = w, c(f.d, yg(d), y);
                    },
                    finish: function(d) {
                        return c(f.f, d);
                    }
                }, c = function(d, w, y) {
                    f.p = a.prev, f.n = a.next;
                    try {
                        return d(w, y);
                    } finally{
                        a.next = f.n;
                    }
                }), a.resultName && (a[a.resultName] = f.v, a.resultName = void 0), a.sent = f.v, a.next = f.n;
                try {
                    return o.call(this, a);
                } finally{
                    f.p = a.prev, f.n = a.next;
                }
            };
        }
        return (Vt.exports = Lu = function() {
            return {
                wrap: function(c, f, h, d) {
                    return t.w(s(c), f, h, d && d.reverse());
                },
                isGeneratorFunction: n,
                mark: t.m,
                awrap: function(c, f) {
                    return new TA(c, f);
                },
                AsyncIterator: kA,
                async: function(c, f, h, d, w) {
                    return (n(f) ? RA : OA)(s(c), f, h, d, w);
                },
                keys: CA,
                values: yg
            };
        }, Vt.exports.__esModule = !0, Vt.exports.default = Vt.exports)();
    }
    Vt.exports = Lu, Vt.exports.__esModule = !0, Vt.exports.default = Vt.exports;
});
var $4c2dd1b68d143d96$var$wg = $4c2dd1b68d143d96$var$D((D4, bg)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var $o = $4c2dd1b68d143d96$var$gg()();
    bg.exports = $o;
    try {
        regeneratorRuntime = $o;
    } catch  {
        typeof globalThis == "object" ? globalThis.regeneratorRuntime = $o : Function("r", "regeneratorRuntime = r")($o);
    }
});
var $4c2dd1b68d143d96$var$_g = $4c2dd1b68d143d96$var$D((Ho, mg)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    (function(t, e) {
        typeof Ho == "object" && typeof mg < "u" ? e(Ho, $4c2dd1b68d143d96$var$eg(), $4c2dd1b68d143d96$var$ag(), $4c2dd1b68d143d96$var$Ou(), $4c2dd1b68d143d96$var$cg(), $4c2dd1b68d143d96$var$wg()) : typeof define == "function" && define.amd ? define([
            "exports",
            "@babel/runtime/helpers/defineProperty",
            "@babel/runtime/helpers/slicedToArray",
            "fast-unique-numbers",
            "@babel/runtime/helpers/asyncToGenerator",
            "@babel/runtime/regenerator"
        ], e) : (t = typeof globalThis < "u" ? globalThis : t || self, e(t.brokerFactory = {}, t._defineProperty, t._slicedToArray, t.fastUniqueNumbers, t._asyncToGenerator, t._regeneratorRuntime));
    })(Ho, function(t, e, r, n, i, s) {
        "use strict";
        var o = function(m) {
            return typeof m.start == "function";
        }, a = new WeakMap;
        function c(b, m) {
            var v = Object.keys(b);
            if (Object.getOwnPropertySymbols) {
                var R = Object.getOwnPropertySymbols(b);
                m && (R = R.filter(function(T) {
                    return Object.getOwnPropertyDescriptor(b, T).enumerable;
                })), v.push.apply(v, R);
            }
            return v;
        }
        function f(b) {
            for(var m = 1; m < arguments.length; m++){
                var v = arguments[m] != null ? arguments[m] : {};
                m % 2 ? c(Object(v), !0).forEach(function(R) {
                    e(b, R, v[R]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(b, Object.getOwnPropertyDescriptors(v)) : c(Object(v)).forEach(function(R) {
                    Object.defineProperty(b, R, Object.getOwnPropertyDescriptor(v, R));
                });
            }
            return b;
        }
        var h = function(m) {
            return f(f({}, m), {}, {
                connect: function(R) {
                    var T = R.call;
                    return i(s.mark(function g() {
                        var O, _, q, $;
                        return s.wrap(function(j) {
                            for(;;)switch(j.prev = j.next){
                                case 0:
                                    return O = new MessageChannel, _ = O.port1, q = O.port2, j.next = 1, T("connect", {
                                        port: _
                                    }, [
                                        _
                                    ]);
                                case 1:
                                    return $ = j.sent, a.set(q, $), j.abrupt("return", q);
                                case 2:
                                case "end":
                                    return j.stop();
                            }
                        }, g);
                    }));
                },
                disconnect: function(R) {
                    var T = R.call;
                    return function() {
                        var g = i(s.mark(function O(_) {
                            var q;
                            return s.wrap(function($) {
                                for(;;)switch($.prev = $.next){
                                    case 0:
                                        if (q = a.get(_), q !== void 0) {
                                            $.next = 1;
                                            break;
                                        }
                                        throw new Error("The given port is not connected.");
                                    case 1:
                                        return $.next = 2, T("disconnect", {
                                            portId: q
                                        });
                                    case 2:
                                    case "end":
                                        return $.stop();
                                }
                            }, O);
                        }));
                        return function(O) {
                            return g.apply(this, arguments);
                        };
                    }();
                },
                isSupported: function(R) {
                    var T = R.call;
                    return function() {
                        return T("isSupported");
                    };
                }
            });
        };
        function d(b, m) {
            var v = Object.keys(b);
            if (Object.getOwnPropertySymbols) {
                var R = Object.getOwnPropertySymbols(b);
                m && (R = R.filter(function(T) {
                    return Object.getOwnPropertyDescriptor(b, T).enumerable;
                })), v.push.apply(v, R);
            }
            return v;
        }
        function w(b) {
            for(var m = 1; m < arguments.length; m++){
                var v = arguments[m] != null ? arguments[m] : {};
                m % 2 ? d(Object(v), !0).forEach(function(R) {
                    e(b, R, v[R]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(b, Object.getOwnPropertyDescriptors(v)) : d(Object(v)).forEach(function(R) {
                    Object.defineProperty(b, R, Object.getOwnPropertyDescriptor(v, R));
                });
            }
            return b;
        }
        var y = new WeakMap, P = function(m) {
            if (y.has(m)) return y.get(m);
            var v = new Map;
            return y.set(m, v), v;
        }, E = function(m) {
            var v = h(m);
            return function(R) {
                var T = P(R);
                R.addEventListener("message", function(H) {
                    var G = H.data, K = G.id;
                    if (K !== null && T.has(K)) {
                        var X = T.get(K), Q = X.reject, V = X.resolve;
                        T.delete(K), G.error === void 0 ? V(G.result) : Q(new Error(G.error.message));
                    }
                }), o(R) && R.start();
                for(var g = function(G) {
                    var K = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, X = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                    return new Promise(function(Q, V) {
                        var te = n.generateUniqueNumber(T);
                        T.set(te, {
                            reject: V,
                            resolve: Q
                        }), K === null ? R.postMessage({
                            id: te,
                            method: G
                        }, X) : R.postMessage({
                            id: te,
                            method: G,
                            params: K
                        }, X);
                    });
                }, O = function(G, K) {
                    var X = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                    R.postMessage({
                        id: null,
                        method: G,
                        params: K
                    }, X);
                }, _ = {}, q = 0, $ = Object.entries(v); q < $.length; q++){
                    var j = r($[q], 2), J = j[0], W = j[1];
                    _ = w(w({}, _), {}, e({}, J, W({
                        call: g,
                        notify: O
                    })));
                }
                return w({}, _);
            };
        };
        t.createBroker = E;
    });
});
var $4c2dd1b68d143d96$var$Sg = $4c2dd1b68d143d96$var$D((Vo, vg)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    (function(t, e) {
        typeof Vo == "object" && typeof vg < "u" ? e(Vo, $4c2dd1b68d143d96$var$Xn(), $4c2dd1b68d143d96$var$_g(), $4c2dd1b68d143d96$var$Ou()) : typeof define == "function" && define.amd ? define([
            "exports",
            "@babel/runtime/helpers/typeof",
            "broker-factory",
            "fast-unique-numbers"
        ], e) : (t = typeof globalThis < "u" ? globalThis : t || self, e(t.workerTimersBroker = {}, t._typeof, t.brokerFactory, t.fastUniqueNumbers));
    })(Vo, function(t, e, r, n) {
        "use strict";
        var i = new Map([
            [
                0,
                null
            ]
        ]), s = new Map([
            [
                0,
                null
            ]
        ]), o = r.createBroker({
            clearInterval: function(f) {
                var h = f.call;
                return function(d) {
                    e(i.get(d)) === "symbol" && (i.set(d, null), h("clear", {
                        timerId: d,
                        timerType: "interval"
                    }).then(function() {
                        i.delete(d);
                    }));
                };
            },
            clearTimeout: function(f) {
                var h = f.call;
                return function(d) {
                    e(s.get(d)) === "symbol" && (s.set(d, null), h("clear", {
                        timerId: d,
                        timerType: "timeout"
                    }).then(function() {
                        s.delete(d);
                    }));
                };
            },
            setInterval: function(f) {
                var h = f.call;
                return function(d) {
                    for(var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, y = arguments.length, P = new Array(y > 2 ? y - 2 : 0), E = 2; E < y; E++)P[E - 2] = arguments[E];
                    var b = Symbol(), m = n.generateUniqueNumber(i);
                    i.set(m, b);
                    var v = function() {
                        return h("set", {
                            delay: w,
                            now: performance.timeOrigin + performance.now(),
                            timerId: m,
                            timerType: "interval"
                        }).then(function() {
                            var T = i.get(m);
                            if (T === void 0) throw new Error("The timer is in an undefined state.");
                            T === b && (d.apply(void 0, P), i.get(m) === b && v());
                        });
                    };
                    return v(), m;
                };
            },
            setTimeout: function(f) {
                var h = f.call;
                return function(d) {
                    for(var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, y = arguments.length, P = new Array(y > 2 ? y - 2 : 0), E = 2; E < y; E++)P[E - 2] = arguments[E];
                    var b = Symbol(), m = n.generateUniqueNumber(s);
                    return s.set(m, b), h("set", {
                        delay: w,
                        now: performance.timeOrigin + performance.now(),
                        timerId: m,
                        timerType: "timeout"
                    }).then(function() {
                        var v = s.get(m);
                        if (v === void 0) throw new Error("The timer is in an undefined state.");
                        v === b && (s.delete(m), d.apply(void 0, P));
                    }), m;
                };
            }
        }), a = function(f) {
            var h = new Worker(f);
            return o(h);
        };
        t.load = a, t.wrap = o;
    });
});
var $4c2dd1b68d143d96$var$Ag = $4c2dd1b68d143d96$var$D((Go, Eg)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    (function(t, e) {
        typeof Go == "object" && typeof Eg < "u" ? e(Go, $4c2dd1b68d143d96$var$Sg()) : typeof define == "function" && define.amd ? define([
            "exports",
            "worker-timers-broker"
        ], e) : (t = typeof globalThis < "u" ? globalThis : t || self, e(t.workerTimers = {}, t.workerTimersBroker));
    })(Go, function(t, e) {
        "use strict";
        var r = function(h, d) {
            var w = null;
            return function() {
                if (w !== null) return w;
                var y = new Blob([
                    d
                ], {
                    type: "application/javascript; charset=utf-8"
                }), P = URL.createObjectURL(y);
                return w = h(P), setTimeout(function() {
                    return URL.revokeObjectURL(P);
                }), w;
            };
        }, n = `(()=>{var e={45:(e,t,r)=>{var n=r(738).default;e.exports=function(e,t){if("object"!=n(e)||!e)return e;var r=e[Symbol.toPrimitive];if(void 0!==r){var o=r.call(e,t||"default");if("object"!=n(o))return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)},e.exports.__esModule=!0,e.exports.default=e.exports},79:e=>{e.exports=function(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=Array(t);r<t;r++)n[r]=e[r];return n},e.exports.__esModule=!0,e.exports.default=e.exports},122:(e,t,r)=>{var n=r(79);e.exports=function(e,t){if(e){if("string"==typeof e)return n(e,t);var r={}.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?n(e,t):void 0}},e.exports.__esModule=!0,e.exports.default=e.exports},156:e=>{e.exports=function(e,t){var r=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null!=r){var n,o,u,a,i=[],s=!0,c=!1;try{if(u=(r=r.call(e)).next,0===t){if(Object(r)!==r)return;s=!1}else for(;!(s=(n=u.call(r)).done)&&(i.push(n.value),i.length!==t);s=!0);}catch(e){c=!0,o=e}finally{try{if(!s&&null!=r.return&&(a=r.return(),Object(a)!==a))return}finally{if(c)throw o}}return i}},e.exports.__esModule=!0,e.exports.default=e.exports},172:e=>{e.exports=function(e,t){this.v=e,this.k=t},e.exports.__esModule=!0,e.exports.default=e.exports},293:e=>{function t(e,t,r,n,o,u,a){try{var i=e[u](a),s=i.value}catch(e){return void r(e)}i.done?t(s):Promise.resolve(s).then(n,o)}e.exports=function(e){return function(){var r=this,n=arguments;return new Promise((function(o,u){var a=e.apply(r,n);function i(e){t(a,o,u,i,s,"next",e)}function s(e){t(a,o,u,i,s,"throw",e)}i(void 0)}))}},e.exports.__esModule=!0,e.exports.default=e.exports},373:e=>{e.exports=function(e){var t=Object(e),r=[];for(var n in t)r.unshift(n);return function e(){for(;r.length;)if((n=r.pop())in t)return e.value=n,e.done=!1,e;return e.done=!0,e}},e.exports.__esModule=!0,e.exports.default=e.exports},389:function(e,t){!function(e){"use strict";var t=function(e){return function(t){var r=e(t);return t.add(r),r}},r=function(e){return function(t,r){return e.set(t,r),r}},n=void 0===Number.MAX_SAFE_INTEGER?9007199254740991:Number.MAX_SAFE_INTEGER,o=536870912,u=2*o,a=function(e,t){return function(r){var a=t.get(r),i=void 0===a?r.size:a<u?a+1:0;if(!r.has(i))return e(r,i);if(r.size<o){for(;r.has(i);)i=Math.floor(Math.random()*u);return e(r,i)}if(r.size>n)throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");for(;r.has(i);)i=Math.floor(Math.random()*n);return e(r,i)}},i=new WeakMap,s=r(i),c=a(s,i),f=t(c);e.addUniqueNumber=f,e.generateUniqueNumber=c}(t)},472:function(e,t,r){!function(e,t,r,n){"use strict";var o=function(e,t){return function(r){var o=t.get(r);if(void 0===o)return Promise.resolve(!1);var u=n(o,2),a=u[0],i=u[1];return e(a),t.delete(r),i(!1),Promise.resolve(!0)}},u=function(e,t){var r=function(n,o,u,a){var i=n-e.now();i>0?o.set(a,[t(r,i,n,o,u,a),u]):(o.delete(a),u(!0))};return r},a=function(e,t,r,n){return function(o,u,a){var i=o+u-t.timeOrigin,s=i-t.now();return new Promise((function(t){e.set(a,[r(n,s,i,e,t,a),t])}))}},i=new Map,s=o(globalThis.clearTimeout,i),c=new Map,f=o(globalThis.clearTimeout,c),l=u(performance,globalThis.setTimeout),p=a(i,performance,globalThis.setTimeout,l),d=a(c,performance,globalThis.setTimeout,l);r.createWorker(self,{clear:function(){var r=e(t.mark((function e(r){var n,o,u;return t.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=r.timerId,o=r.timerType,e.next=1,"interval"===o?s(n):f(n);case 1:return u=e.sent,e.abrupt("return",{result:u});case 2:case"end":return e.stop()}}),e)})));function n(e){return r.apply(this,arguments)}return n}(),set:function(){var r=e(t.mark((function e(r){var n,o,u,a,i;return t.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=r.delay,o=r.now,u=r.timerId,a=r.timerType,e.next=1,("interval"===a?p:d)(n,o,u);case 1:return i=e.sent,e.abrupt("return",{result:i});case 2:case"end":return e.stop()}}),e)})));function n(e){return r.apply(this,arguments)}return n}()})}(r(293),r(756),r(623),r(715))},546:e=>{function t(r,n,o,u){var a=Object.defineProperty;try{a({},"",{})}catch(r){a=0}e.exports=t=function(e,r,n,o){if(r)a?a(e,r,{value:n,enumerable:!o,configurable:!o,writable:!o}):e[r]=n;else{var u=function(r,n){t(e,r,(function(e){return this._invoke(r,n,e)}))};u("next",0),u("throw",1),u("return",2)}},e.exports.__esModule=!0,e.exports.default=e.exports,t(r,n,o,u)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},579:(e,t,r)=>{var n=r(738).default;e.exports=function(e){if(null!=e){var t=e["function"==typeof Symbol&&Symbol.iterator||"@@iterator"],r=0;if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length))return{next:function(){return e&&r>=e.length&&(e=void 0),{value:e&&e[r++],done:!e}}}}throw new TypeError(n(e)+" is not iterable")},e.exports.__esModule=!0,e.exports.default=e.exports},623:function(e,t,r){!function(e,t,r,n,o){"use strict";var u={INTERNAL_ERROR:-32603,INVALID_PARAMS:-32602,METHOD_NOT_FOUND:-32601},a=function(e,t){return Object.assign(new Error(e),{status:t})},i=function(e){return a('The requested method called "'.concat(e,'" is not supported.'),u.METHOD_NOT_FOUND)},s=function(e){return a('The handler of the method called "'.concat(e,'" returned no required result.'),u.INTERNAL_ERROR)},c=function(e){return a('The handler of the method called "'.concat(e,'" returned an unexpected result.'),u.INTERNAL_ERROR)},f=function(e){return a('The specified parameter called "portId" with the given value "'.concat(e,'" does not identify a port connected to this worker.'),u.INVALID_PARAMS)},l=function(e,n){return function(){var o=t(r.mark((function t(o){var u,a,f,l,p,d,v,x,y,b,h,m,_,g,w;return r.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(u=o.data,a=u.id,f=u.method,l=u.params,p=n[f],t.prev=1,void 0!==p){t.next=2;break}throw i(f);case 2:if(void 0!==(d=void 0===l?p():p(l))){t.next=3;break}throw s(f);case 3:if(!(d instanceof Promise)){t.next=5;break}return t.next=4,d;case 4:g=t.sent,t.next=6;break;case 5:g=d;case 6:if(v=g,null!==a){t.next=8;break}if(void 0===v.result){t.next=7;break}throw c(f);case 7:t.next=10;break;case 8:if(void 0!==v.result){t.next=9;break}throw c(f);case 9:x=v.result,y=v.transferables,b=void 0===y?[]:y,e.postMessage({id:a,result:x},b);case 10:t.next=12;break;case 11:t.prev=11,w=t.catch(1),h=w.message,m=w.status,_=void 0===m?-32603:m,e.postMessage({error:{code:_,message:h},id:a});case 12:case"end":return t.stop()}}),t,null,[[1,11]])})));return function(e){return o.apply(this,arguments)}}()},p=function(){return new Promise((function(e){var t=new ArrayBuffer(0),r=new MessageChannel,n=r.port1,o=r.port2;n.onmessage=function(t){var r=t.data;return e(null!==r)},o.postMessage(t,[t])}))};function d(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function v(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?d(Object(r),!0).forEach((function(t){n(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):d(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var x=new Map,y=function(e,n,u){return v(v({},n),{},{connect:function(t){var r=t.port;r.start();var u=e(r,n),a=o.generateUniqueNumber(x);return x.set(a,(function(){u(),r.close(),x.delete(a)})),{result:a}},disconnect:function(e){var t=e.portId,r=x.get(t);if(void 0===r)throw f(t);return r(),{result:null}},isSupported:function(){var e=t(r.mark((function e(){var t,n,o;return r.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=1,p();case 1:if(!e.sent){e.next=5;break}if(!((t=u())instanceof Promise)){e.next=3;break}return e.next=2,t;case 2:o=e.sent,e.next=4;break;case 3:o=t;case 4:return n=o,e.abrupt("return",{result:n});case 5:return e.abrupt("return",{result:!1});case 6:case"end":return e.stop()}}),e)})));function n(){return e.apply(this,arguments)}return n}()})},b=function(e,t){var r=y(b,t,arguments.length>2&&void 0!==arguments[2]?arguments[2]:function(){return!0}),n=l(e,r);return e.addEventListener("message",n),function(){return e.removeEventListener("message",n)}};e.createWorker=b,e.isSupported=p}(t,r(293),r(756),r(693),r(389))},633:(e,t,r)=>{var n=r(172),o=r(993),u=r(869),a=r(887),i=r(791),s=r(373),c=r(579);function f(){"use strict";var t=o(),r=t.m(f),l=(Object.getPrototypeOf?Object.getPrototypeOf(r):r.__proto__).constructor;function p(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===l||"GeneratorFunction"===(t.displayName||t.name))}var d={throw:1,return:2,break:3,continue:3};function v(e){var t,r;return function(n){t||(t={stop:function(){return r(n.a,2)},catch:function(){return n.v},abrupt:function(e,t){return r(n.a,d[e],t)},delegateYield:function(e,o,u){return t.resultName=o,r(n.d,c(e),u)},finish:function(e){return r(n.f,e)}},r=function(e,r,o){n.p=t.prev,n.n=t.next;try{return e(r,o)}finally{t.next=n.n}}),t.resultName&&(t[t.resultName]=n.v,t.resultName=void 0),t.sent=n.v,t.next=n.n;try{return e.call(this,t)}finally{n.p=t.prev,n.n=t.next}}}return(e.exports=f=function(){return{wrap:function(e,r,n,o){return t.w(v(e),r,n,o&&o.reverse())},isGeneratorFunction:p,mark:t.m,awrap:function(e,t){return new n(e,t)},AsyncIterator:i,async:function(e,t,r,n,o){return(p(t)?a:u)(v(e),t,r,n,o)},keys:s,values:c}},e.exports.__esModule=!0,e.exports.default=e.exports)()}e.exports=f,e.exports.__esModule=!0,e.exports.default=e.exports},693:(e,t,r)=>{var n=r(736);e.exports=function(e,t,r){return(t=n(t))in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e},e.exports.__esModule=!0,e.exports.default=e.exports},715:(e,t,r)=>{var n=r(987),o=r(156),u=r(122),a=r(752);e.exports=function(e,t){return n(e)||o(e,t)||u(e,t)||a()},e.exports.__esModule=!0,e.exports.default=e.exports},736:(e,t,r)=>{var n=r(738).default,o=r(45);e.exports=function(e){var t=o(e,"string");return"symbol"==n(t)?t:t+""},e.exports.__esModule=!0,e.exports.default=e.exports},738:e=>{function t(r){return e.exports=t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports.__esModule=!0,e.exports.default=e.exports,t(r)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},752:e=>{e.exports=function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")},e.exports.__esModule=!0,e.exports.default=e.exports},756:(e,t,r)=>{var n=r(633)();e.exports=n;try{regeneratorRuntime=n}catch(e){"object"==typeof globalThis?globalThis.regeneratorRuntime=n:Function("r","regeneratorRuntime = r")(n)}},791:(e,t,r)=>{var n=r(172),o=r(546);e.exports=function e(t,r){function u(e,o,a,i){try{var s=t[e](o),c=s.value;return c instanceof n?r.resolve(c.v).then((function(e){u("next",e,a,i)}),(function(e){u("throw",e,a,i)})):r.resolve(c).then((function(e){s.value=e,a(s)}),(function(e){return u("throw",e,a,i)}))}catch(e){i(e)}}var a;this.next||(o(e.prototype),o(e.prototype,"function"==typeof Symbol&&Symbol.asyncIterator||"@asyncIterator",(function(){return this}))),o(this,"_invoke",(function(e,t,n){function o(){return new r((function(t,r){u(e,n,t,r)}))}return a=a?a.then(o,o):o()}),!0)},e.exports.__esModule=!0,e.exports.default=e.exports},869:(e,t,r)=>{var n=r(887);e.exports=function(e,t,r,o,u){var a=n(e,t,r,o,u);return a.next().then((function(e){return e.done?e.value:a.next()}))},e.exports.__esModule=!0,e.exports.default=e.exports},887:(e,t,r)=>{var n=r(993),o=r(791);e.exports=function(e,t,r,u,a){return new o(n().w(e,t,r,u),a||Promise)},e.exports.__esModule=!0,e.exports.default=e.exports},987:e=>{e.exports=function(e){if(Array.isArray(e))return e},e.exports.__esModule=!0,e.exports.default=e.exports},993:(e,t,r)=>{var n=r(546);function o(){var t,r,u="function"==typeof Symbol?Symbol:{},a=u.iterator||"@@iterator",i=u.toStringTag||"@@toStringTag";function s(e,o,u,a){var i=o&&o.prototype instanceof f?o:f,s=Object.create(i.prototype);return n(s,"_invoke",function(e,n,o){var u,a,i,s=0,f=o||[],l=!1,p={p:0,n:0,v:t,a:d,f:d.bind(t,4),d:function(e,r){return u=e,a=0,i=t,p.n=r,c}};function d(e,n){for(a=e,i=n,r=0;!l&&s&&!o&&r<f.length;r++){var o,u=f[r],d=p.p,v=u[2];e>3?(o=v===n)&&(i=u[(a=u[4])?5:(a=3,3)],u[4]=u[5]=t):u[0]<=d&&((o=e<2&&d<u[1])?(a=0,p.v=n,p.n=u[1]):d<v&&(o=e<3||u[0]>n||n>v)&&(u[4]=e,u[5]=n,p.n=v,a=0))}if(o||e>1)return c;throw l=!0,n}return function(o,f,v){if(s>1)throw TypeError("Generator is already running");for(l&&1===f&&d(f,v),a=f,i=v;(r=a<2?t:i)||!l;){u||(a?a<3?(a>1&&(p.n=-1),d(a,i)):p.n=i:p.v=i);try{if(s=2,u){if(a||(o="next"),r=u[o]){if(!(r=r.call(u,i)))throw TypeError("iterator result is not an object");if(!r.done)return r;i=r.value,a<2&&(a=0)}else 1===a&&(r=u.return)&&r.call(u),a<2&&(i=TypeError("The iterator does not provide a '"+o+"' method"),a=1);u=t}else if((r=(l=p.n<0)?i:e.call(n,p))!==c)break}catch(e){u=t,a=1,i=e}finally{s=1}}return{value:r,done:l}}}(e,u,a),!0),s}var c={};function f(){}function l(){}function p(){}r=Object.getPrototypeOf;var d=[][a]?r(r([][a]())):(n(r={},a,(function(){return this})),r),v=p.prototype=f.prototype=Object.create(d);function x(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,p):(e.__proto__=p,n(e,i,"GeneratorFunction")),e.prototype=Object.create(v),e}return l.prototype=p,n(v,"constructor",p),n(p,"constructor",l),l.displayName="GeneratorFunction",n(p,i,"GeneratorFunction"),n(v),n(v,i,"Generator"),n(v,a,(function(){return this})),n(v,"toString",(function(){return"[object Generator]"})),(e.exports=o=function(){return{w:s,m:x}},e.exports.__esModule=!0,e.exports.default=e.exports)()}e.exports=o,e.exports.__esModule=!0,e.exports.default=e.exports}},t={};function r(n){var o=t[n];if(void 0!==o)return o.exports;var u=t[n]={exports:{}};return e[n].call(u.exports,u,u.exports,r),u.exports}r.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return r.d(t,{a:t}),t},r.d=(e,t)=>{for(var n in t)r.o(t,n)&&!r.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},r.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),(()=>{"use strict";r(472)})()})();`, i = r(e.load, n), s = function(h) {
            return i().clearInterval(h);
        }, o = function(h) {
            return i().clearTimeout(h);
        }, a = function() {
            var h;
            return (h = i()).setInterval.apply(h, arguments);
        }, c = function() {
            var h;
            return (h = i()).setTimeout.apply(h, arguments);
        };
        t.clearInterval = s, t.clearTimeout = o, t.setInterval = a, t.setTimeout = c;
    });
});
var $4c2dd1b68d143d96$var$yi = $4c2dd1b68d143d96$var$D((Fr)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Fr, "__esModule", {
        value: !0
    });
    Fr.isReactNativeBrowser = Fr.isWebWorker = void 0;
    var BA = ()=>typeof window < "u" ? typeof navigator < "u" && navigator.userAgent?.toLowerCase().indexOf(" electron/") > -1 && $4c2dd1b68d143d96$var$M?.versions ? !Object.prototype.hasOwnProperty.call($4c2dd1b68d143d96$var$M.versions, "electron") : typeof window.document < "u" : !1, Ig = ()=>!!(typeof self == "object" && self?.constructor?.name?.includes("WorkerGlobalScope") && typeof Deno > "u"), xg = ()=>typeof navigator < "u" && navigator.product === "ReactNative", MA = BA() || Ig() || xg();
    Fr.isWebWorker = Ig();
    Fr.isReactNativeBrowser = xg();
    Fr.default = MA;
});
var $4c2dd1b68d143d96$var$Rg = $4c2dd1b68d143d96$var$D((Gt)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var NA = Gt && Gt.__createBinding || (Object.create ? function(t, e, r, n) {
        n === void 0 && (n = r);
        var i = Object.getOwnPropertyDescriptor(e, r);
        (!i || ("get" in i ? !e.__esModule : i.writable || i.configurable)) && (i = {
            enumerable: !0,
            get: function() {
                return e[r];
            }
        }), Object.defineProperty(t, n, i);
    } : function(t, e, r, n) {
        n === void 0 && (n = r), t[n] = e[r];
    }), qA = Gt && Gt.__setModuleDefault || (Object.create ? function(t, e) {
        Object.defineProperty(t, "default", {
            enumerable: !0,
            value: e
        });
    } : function(t, e) {
        t.default = e;
    }), LA = Gt && Gt.__importStar || function() {
        var t = function(e) {
            return t = Object.getOwnPropertyNames || function(r) {
                var n = [];
                for(var i in r)Object.prototype.hasOwnProperty.call(r, i) && (n[n.length] = i);
                return n;
            }, t(e);
        };
        return function(e) {
            if (e && e.__esModule) return e;
            var r = {};
            if (e != null) for(var n = t(e), i = 0; i < n.length; i++)n[i] !== "default" && NA(r, e, n[i]);
            return qA(r, e), r;
        };
    }();
    Object.defineProperty(Gt, "__esModule", {
        value: !0
    });
    var Tg = $4c2dd1b68d143d96$var$Ag(), Uu = LA($4c2dd1b68d143d96$var$yi()), Pg = {
        set: Tg.setInterval,
        clear: Tg.clearInterval
    }, Og = {
        set: (t, e)=>setInterval(t, e),
        clear: (t)=>clearInterval(t)
    }, UA = (t)=>{
        switch(t){
            case "native":
                return Og;
            case "worker":
                return Pg;
            case "auto":
            default:
                return Uu.default && !Uu.isWebWorker && !Uu.isReactNativeBrowser ? Pg : Og;
        }
    };
    Gt.default = UA;
});
var $4c2dd1b68d143d96$var$ju = $4c2dd1b68d143d96$var$D((gi)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var DA = gi && gi.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(gi, "__esModule", {
        value: !0
    });
    var jA = DA($4c2dd1b68d143d96$var$Rg()), Du = class {
        _keepalive;
        timerId;
        timer;
        destroyed = !1;
        counter;
        client;
        _keepaliveTimeoutTimestamp;
        _intervalEvery;
        get keepaliveTimeoutTimestamp() {
            return this._keepaliveTimeoutTimestamp;
        }
        get intervalEvery() {
            return this._intervalEvery;
        }
        get keepalive() {
            return this._keepalive;
        }
        constructor(e, r){
            this.client = e, this.timer = typeof r == "object" && "set" in r && "clear" in r ? r : (0, jA.default)(r), this.setKeepalive(e.options.keepalive);
        }
        clear() {
            this.timerId && (this.timer.clear(this.timerId), this.timerId = null);
        }
        setKeepalive(e) {
            if (e *= 1e3, isNaN(e) || e <= 0 || e > 2147483647) throw new Error(`Keepalive value must be an integer between 0 and 2147483647. Provided value is ${e}`);
            this._keepalive = e, this.reschedule(), this.client.log(`KeepaliveManager: set keepalive to ${e}ms`);
        }
        destroy() {
            this.clear(), this.destroyed = !0;
        }
        reschedule() {
            if (this.destroyed) return;
            this.clear(), this.counter = 0;
            let e = Math.ceil(this._keepalive * 1.5);
            this._keepaliveTimeoutTimestamp = Date.now() + e, this._intervalEvery = Math.ceil(this._keepalive / 2), this.timerId = this.timer.set(()=>{
                this.destroyed || (this.counter += 1, this.counter === 2 ? this.client.sendPing() : this.counter > 2 && this.client.onKeepaliveTimeout());
            }, this._intervalEvery);
        }
    };
    gi.default = Du;
});
var $4c2dd1b68d143d96$var$zo = $4c2dd1b68d143d96$var$D((yt)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var FA = yt && yt.__createBinding || (Object.create ? function(t, e, r, n) {
        n === void 0 && (n = r);
        var i = Object.getOwnPropertyDescriptor(e, r);
        (!i || ("get" in i ? !e.__esModule : i.writable || i.configurable)) && (i = {
            enumerable: !0,
            get: function() {
                return e[r];
            }
        }), Object.defineProperty(t, n, i);
    } : function(t, e, r, n) {
        n === void 0 && (n = r), t[n] = e[r];
    }), WA = yt && yt.__setModuleDefault || (Object.create ? function(t, e) {
        Object.defineProperty(t, "default", {
            enumerable: !0,
            value: e
        });
    } : function(t, e) {
        t.default = e;
    }), Ng = yt && yt.__importStar || function() {
        var t = function(e) {
            return t = Object.getOwnPropertyNames || function(r) {
                var n = [];
                for(var i in r)Object.prototype.hasOwnProperty.call(r, i) && (n[n.length] = i);
                return n;
            }, t(e);
        };
        return function(e) {
            if (e && e.__esModule) return e;
            var r = {};
            if (e != null) for(var n = t(e), i = 0; i < n.length; i++)n[i] !== "default" && FA(r, e, n[i]);
            return WA(r, e), r;
        };
    }(), fr = yt && yt.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(yt, "__esModule", {
        value: !0
    });
    var Fu = fr($4c2dd1b68d143d96$var$sy()), $A = $4c2dd1b68d143d96$var$or(), kg = fr($4c2dd1b68d143d96$var$cy()), HA = fr($4c2dd1b68d143d96$var$At()), Cg = Ng($4c2dd1b68d143d96$var$Na()), vn = fr($4c2dd1b68d143d96$var$Ua()), VA = fr($4c2dd1b68d143d96$var$Ky()), GA = fr($4c2dd1b68d143d96$var$Iu()), zA = fr($4c2dd1b68d143d96$var$Qy()), bi = $4c2dd1b68d143d96$var$Mr(), KA = $4c2dd1b68d143d96$var$Yy(), QA = fr($4c2dd1b68d143d96$var$ju()), Bg = Ng($4c2dd1b68d143d96$var$yi()), Wu = globalThis.setImmediate || ((...t)=>{
        let e = t.shift();
        (0, bi.nextTick)(()=>{
            e(...t);
        });
    }), Mg = {
        keepalive: 60,
        reschedulePings: !0,
        protocolId: "MQTT",
        protocolVersion: 4,
        reconnectPeriod: 1e3,
        connectTimeout: 30000,
        clean: !0,
        resubscribe: !0,
        subscribeBatchSize: null,
        writeCache: !0,
        timerVariant: "auto"
    }, $u = class t extends KA.TypedEventEmitter {
        static VERSION = bi.MQTTJS_VERSION;
        connected;
        disconnecting;
        disconnected;
        reconnecting;
        incomingStore;
        outgoingStore;
        options;
        queueQoSZero;
        _reconnectCount;
        log;
        messageIdProvider;
        outgoing;
        messageIdToTopic;
        noop;
        keepaliveManager;
        stream;
        queue;
        streamBuilder;
        _resubscribeTopics;
        connackTimer;
        reconnectTimer;
        _storeProcessing;
        _packetIdsDuringStoreProcessing;
        _storeProcessingQueue;
        _firstConnection;
        topicAliasRecv;
        topicAliasSend;
        _deferredReconnect;
        connackPacket;
        static defaultId() {
            return `mqttjs_${Math.random().toString(16).substr(2, 8)}`;
        }
        constructor(e, r){
            super(), this.options = r || {};
            for(let n in Mg)typeof this.options[n] > "u" ? this.options[n] = Mg[n] : this.options[n] = r[n];
            this.log = this.options.log || (0, HA.default)("mqttjs:client"), this.noop = this._noop.bind(this), this.log("MqttClient :: version:", t.VERSION), Bg.isWebWorker ? this.log("MqttClient :: environment", "webworker") : this.log("MqttClient :: environment", Bg.default ? "browser" : "node"), this.log("MqttClient :: options.protocol", r.protocol), this.log("MqttClient :: options.protocolVersion", r.protocolVersion), this.log("MqttClient :: options.username", r.username), this.log("MqttClient :: options.keepalive", r.keepalive), this.log("MqttClient :: options.reconnectPeriod", r.reconnectPeriod), this.log("MqttClient :: options.rejectUnauthorized", r.rejectUnauthorized), this.log("MqttClient :: options.properties.topicAliasMaximum", r.properties ? r.properties.topicAliasMaximum : void 0), this.options.clientId = typeof r.clientId == "string" ? r.clientId : t.defaultId(), this.log("MqttClient :: clientId", this.options.clientId), this.options.customHandleAcks = r.protocolVersion === 5 && r.customHandleAcks ? r.customHandleAcks : (...n)=>{
                n[3](null, 0);
            }, this.options.writeCache || (Fu.default.writeToStream.cacheNumbers = !1), this.streamBuilder = e, this.messageIdProvider = typeof this.options.messageIdProvider > "u" ? new GA.default : this.options.messageIdProvider, this.outgoingStore = r.outgoingStore || new vn.default, this.incomingStore = r.incomingStore || new vn.default, this.queueQoSZero = r.queueQoSZero === void 0 ? !0 : r.queueQoSZero, this._resubscribeTopics = {}, this.messageIdToTopic = {}, this.keepaliveManager = null, this.connected = !1, this.disconnecting = !1, this.reconnecting = !1, this.queue = [], this.connackTimer = null, this.reconnectTimer = null, this._storeProcessing = !1, this._packetIdsDuringStoreProcessing = {}, this._storeProcessingQueue = [], this.outgoing = {}, this._firstConnection = !0, r.properties && r.properties.topicAliasMaximum > 0 && (r.properties.topicAliasMaximum > 65535 ? this.log("MqttClient :: options.properties.topicAliasMaximum is out of range") : this.topicAliasRecv = new zA.default(r.properties.topicAliasMaximum)), this.on("connect", ()=>{
                let { queue: n } = this, i = ()=>{
                    let s = n.shift();
                    this.log("deliver :: entry %o", s);
                    let o = null;
                    if (!s) {
                        this._resubscribe();
                        return;
                    }
                    o = s.packet, this.log("deliver :: call _sendPacket for %o", o);
                    let a = !0;
                    o.messageId && o.messageId !== 0 && (this.messageIdProvider.register(o.messageId) || (a = !1)), a ? this._sendPacket(o, (c)=>{
                        s.cb && s.cb(c), i();
                    }) : (this.log("messageId: %d has already used. The message is skipped and removed.", o.messageId), i());
                };
                this.log("connect :: sending queued packets"), i();
            }), this.on("close", ()=>{
                this.log("close :: connected set to `false`"), this.connected = !1, this.log("close :: clearing connackTimer"), clearTimeout(this.connackTimer), this._destroyKeepaliveManager(), this.topicAliasRecv && this.topicAliasRecv.clear(), this.log("close :: calling _setupReconnect"), this._setupReconnect();
            }), this.options.manualConnect || (this.log("MqttClient :: setting up stream"), this.connect());
        }
        handleAuth(e, r) {
            r();
        }
        handleMessage(e, r) {
            r();
        }
        _nextId() {
            return this.messageIdProvider.allocate();
        }
        getLastMessageId() {
            return this.messageIdProvider.getLastAllocated();
        }
        connect() {
            let e = new $A.Writable, r = Fu.default.parser(this.options), n = null, i = [];
            this.log("connect :: calling method to clear reconnect"), this._clearReconnect(), this.disconnected && !this.reconnecting && (this.incomingStore = this.options.incomingStore || new vn.default, this.outgoingStore = this.options.outgoingStore || new vn.default, this.disconnecting = !1, this.disconnected = !1), this.log("connect :: using streamBuilder provided to client to create stream"), this.stream = this.streamBuilder(this), r.on("packet", (f)=>{
                this.log("parser :: on packet push to packets array."), i.push(f);
            });
            let s = ()=>{
                this.log("work :: getting next packet in queue");
                let f = i.shift();
                if (f) this.log("work :: packet pulled from queue"), (0, VA.default)(this, f, o);
                else {
                    this.log("work :: no packets in queue");
                    let h = n;
                    n = null, this.log("work :: done flag is %s", !!h), h && h();
                }
            }, o = ()=>{
                if (i.length) (0, bi.nextTick)(s);
                else {
                    let f = n;
                    n = null, f();
                }
            };
            e._write = (f, h, d)=>{
                n = d, this.log("writable stream :: parsing buffer"), r.parse(f), s();
            };
            let a = (f)=>{
                this.log("streamErrorHandler :: error", f.message), f.code ? (this.log("streamErrorHandler :: emitting error"), this.emit("error", f)) : this.noop(f);
            };
            this.log("connect :: pipe stream to writable stream"), this.stream.pipe(e), this.stream.on("error", a), this.stream.on("close", ()=>{
                this.log("(%s)stream :: on close", this.options.clientId), this._flushVolatile(), this.log("stream: emit close to MqttClient"), this.emit("close");
            }), this.log("connect: sending packet `connect`");
            let c = {
                cmd: "connect",
                protocolId: this.options.protocolId,
                protocolVersion: this.options.protocolVersion,
                clean: this.options.clean,
                clientId: this.options.clientId,
                keepalive: this.options.keepalive,
                username: this.options.username,
                password: this.options.password,
                properties: this.options.properties
            };
            if (this.options.will && (c.will = {
                ...this.options.will,
                payload: this.options.will?.payload
            }), this.topicAliasRecv && (c.properties || (c.properties = {}), this.topicAliasRecv && (c.properties.topicAliasMaximum = this.topicAliasRecv.max)), this._writePacket(c), r.on("error", this.emit.bind(this, "error")), this.options.properties) {
                if (!this.options.properties.authenticationMethod && this.options.properties.authenticationData) return this.end(()=>this.emit("error", new Error("Packet has no Authentication Method"))), this;
                if (this.options.properties.authenticationMethod && this.options.authPacket && typeof this.options.authPacket == "object") {
                    let f = {
                        cmd: "auth",
                        reasonCode: 0,
                        ...this.options.authPacket
                    };
                    this._writePacket(f);
                }
            }
            return this.stream.setMaxListeners(1e3), clearTimeout(this.connackTimer), this.connackTimer = setTimeout(()=>{
                this.log("!!connectTimeout hit!! Calling _cleanUp with force `true`"), this.emit("error", new Error("connack timeout")), this._cleanUp(!0);
            }, this.options.connectTimeout), this;
        }
        publish(e, r, n, i) {
            this.log("publish :: message `%s` to topic `%s`", r, e);
            let { options: s } = this;
            typeof n == "function" && (i = n, n = null), n = n || {}, n = {
                qos: 0,
                retain: !1,
                dup: !1,
                ...n
            };
            let { qos: a, retain: c, dup: f, properties: h, cbStorePut: d } = n;
            if (this._checkDisconnecting(i)) return this;
            let w = ()=>{
                let y = 0;
                if ((a === 1 || a === 2) && (y = this._nextId(), y === null)) return this.log("No messageId left"), !1;
                let P = {
                    cmd: "publish",
                    topic: e,
                    payload: r,
                    qos: a,
                    retain: c,
                    messageId: y,
                    dup: f
                };
                switch(s.protocolVersion === 5 && (P.properties = h), this.log("publish :: qos", a), a){
                    case 1:
                    case 2:
                        this.outgoing[P.messageId] = {
                            volatile: !1,
                            cb: i || this.noop
                        }, this.log("MqttClient:publish: packet cmd: %s", P.cmd), this._sendPacket(P, void 0, d);
                        break;
                    default:
                        this.log("MqttClient:publish: packet cmd: %s", P.cmd), this._sendPacket(P, i, d);
                        break;
                }
                return !0;
            };
            return (this._storeProcessing || this._storeProcessingQueue.length > 0 || !w()) && this._storeProcessingQueue.push({
                invoke: w,
                cbStorePut: n.cbStorePut,
                callback: i
            }), this;
        }
        publishAsync(e, r, n) {
            return new Promise((i, s)=>{
                this.publish(e, r, n, (o, a)=>{
                    o ? s(o) : i(a);
                });
            });
        }
        subscribe(e, r, n) {
            let i = this.options.protocolVersion;
            typeof r == "function" && (n = r), n = n || this.noop;
            let s = !1, o = [];
            typeof e == "string" ? (e = [
                e
            ], o = e) : Array.isArray(e) ? o = e : typeof e == "object" && (s = e.resubscribe, delete e.resubscribe, o = Object.keys(e));
            let a = Cg.validateTopics(o);
            if (a !== null) return Wu(n, new Error(`Invalid topic ${a}`)), this;
            if (this._checkDisconnecting(n)) return this.log("subscribe: discconecting true"), this;
            let c = {
                qos: 0
            };
            i === 5 && (c.nl = !1, c.rap = !1, c.rh = 0), r = {
                ...c,
                ...r
            };
            let { properties: f } = r, h = [], d = (P, E)=>{
                if (E = E || r, !Object.prototype.hasOwnProperty.call(this._resubscribeTopics, P) || this._resubscribeTopics[P].qos < E.qos || s) {
                    let b = {
                        topic: P,
                        qos: E.qos
                    };
                    i === 5 && (b.nl = E.nl, b.rap = E.rap, b.rh = E.rh, b.properties = f), this.log("subscribe: pushing topic `%s` and qos `%s` to subs list", b.topic, b.qos), h.push(b);
                }
            };
            if (Array.isArray(e) ? e.forEach((P)=>{
                this.log("subscribe: array topic %s", P), d(P);
            }) : Object.keys(e).forEach((P)=>{
                this.log("subscribe: object topic %s, %o", P, e[P]), d(P, e[P]);
            }), !h.length) return n(null, []), this;
            let w = (P, E)=>{
                let b = {
                    cmd: "subscribe",
                    subscriptions: P,
                    messageId: E
                };
                if (f && (b.properties = f), this.options.resubscribe) {
                    this.log("subscribe :: resubscribe true");
                    let v = [];
                    P.forEach((R)=>{
                        if (this.options.reconnectPeriod > 0) {
                            let T = {
                                qos: R.qos
                            };
                            i === 5 && (T.nl = R.nl || !1, T.rap = R.rap || !1, T.rh = R.rh || 0, T.properties = R.properties), this._resubscribeTopics[R.topic] = T, v.push(R.topic);
                        }
                    }), this.messageIdToTopic[b.messageId] = v;
                }
                let m = new Promise((v, R)=>{
                    this.outgoing[b.messageId] = {
                        volatile: !0,
                        cb (T, g) {
                            if (!T) {
                                let { granted: O } = g;
                                for(let _ = 0; _ < O.length; _ += 1)P[_].qos = O[_];
                            }
                            T ? R(new bi.ErrorWithSubackPacket(T.message, g)) : v(g);
                        }
                    };
                });
                return this.log("subscribe :: call _sendPacket"), this._sendPacket(b), m;
            }, y = ()=>{
                let P = this.options.subscribeBatchSize ?? h.length, E = [];
                for(let b = 0; b < h.length; b += P){
                    let m = h.slice(b, b + P), v = this._nextId();
                    if (v === null) return this.log("No messageId left"), !1;
                    E.push(w(m, v));
                }
                return Promise.all(E).then((b)=>{
                    n(null, h, b.at(-1));
                }).catch((b)=>{
                    n(b, h, b.packet);
                }), !0;
            };
            return (this._storeProcessing || this._storeProcessingQueue.length > 0 || !y()) && this._storeProcessingQueue.push({
                invoke: y,
                callback: n
            }), this;
        }
        subscribeAsync(e, r) {
            return new Promise((n, i)=>{
                this.subscribe(e, r, (s, o)=>{
                    s ? i(s) : n(o);
                });
            });
        }
        unsubscribe(e, r, n) {
            typeof e == "string" && (e = [
                e
            ]), typeof r == "function" && (n = r), n = n || this.noop;
            let i = Cg.validateTopics(e);
            if (i !== null) return Wu(n, new Error(`Invalid topic ${i}`)), this;
            if (this._checkDisconnecting(n)) return this;
            let s = ()=>{
                let o = this._nextId();
                if (o === null) return this.log("No messageId left"), !1;
                let a = {
                    cmd: "unsubscribe",
                    messageId: o,
                    unsubscriptions: []
                };
                return typeof e == "string" ? a.unsubscriptions = [
                    e
                ] : Array.isArray(e) && (a.unsubscriptions = e), this.options.resubscribe && a.unsubscriptions.forEach((c)=>{
                    delete this._resubscribeTopics[c];
                }), typeof r == "object" && r.properties && (a.properties = r.properties), this.outgoing[a.messageId] = {
                    volatile: !0,
                    cb: n
                }, this.log("unsubscribe: call _sendPacket"), this._sendPacket(a), !0;
            };
            return (this._storeProcessing || this._storeProcessingQueue.length > 0 || !s()) && this._storeProcessingQueue.push({
                invoke: s,
                callback: n
            }), this;
        }
        unsubscribeAsync(e, r) {
            return new Promise((n, i)=>{
                this.unsubscribe(e, r, (s, o)=>{
                    s ? i(s) : n(o);
                });
            });
        }
        end(e, r, n) {
            this.log("end :: (%s)", this.options.clientId), (e == null || typeof e != "boolean") && (n = n || r, r = e, e = !1), typeof r != "object" && (n = n || r, r = null), this.log("end :: cb? %s", !!n), (!n || typeof n != "function") && (n = this.noop);
            let i = ()=>{
                this.log("end :: closeStores: closing incoming and outgoing stores"), this.disconnected = !0, this.incomingStore.close((o)=>{
                    this.outgoingStore.close((a)=>{
                        if (this.log("end :: closeStores: emitting end"), this.emit("end"), n) {
                            let c = o || a;
                            this.log("end :: closeStores: invoking callback with args"), n(c);
                        }
                    });
                }), this._deferredReconnect ? this._deferredReconnect() : (this.options.reconnectPeriod === 0 || this.options.manualConnect) && (this.disconnecting = !1);
            }, s = ()=>{
                this.log("end :: (%s) :: finish :: calling _cleanUp with force %s", this.options.clientId, e), this._cleanUp(e, ()=>{
                    this.log("end :: finish :: calling process.nextTick on closeStores"), (0, bi.nextTick)(i);
                }, r);
            };
            return this.disconnecting ? (n(), this) : (this._clearReconnect(), this.disconnecting = !0, !e && Object.keys(this.outgoing).length > 0 ? (this.log("end :: (%s) :: calling finish in 10ms once outgoing is empty", this.options.clientId), this.once("outgoingEmpty", setTimeout.bind(null, s, 10))) : (this.log("end :: (%s) :: immediately calling finish", this.options.clientId), s()), this);
        }
        endAsync(e, r) {
            return new Promise((n, i)=>{
                this.end(e, r, (s)=>{
                    s ? i(s) : n();
                });
            });
        }
        removeOutgoingMessage(e) {
            if (this.outgoing[e]) {
                let { cb: r } = this.outgoing[e];
                this._removeOutgoingAndStoreMessage(e, ()=>{
                    r(new Error("Message removed"));
                });
            }
            return this;
        }
        reconnect(e) {
            this.log("client reconnect");
            let r = ()=>{
                e ? (this.options.incomingStore = e.incomingStore, this.options.outgoingStore = e.outgoingStore) : (this.options.incomingStore = null, this.options.outgoingStore = null), this.incomingStore = this.options.incomingStore || new vn.default, this.outgoingStore = this.options.outgoingStore || new vn.default, this.disconnecting = !1, this.disconnected = !1, this._deferredReconnect = null, this._reconnect();
            };
            return this.disconnecting && !this.disconnected ? this._deferredReconnect = r : r(), this;
        }
        _flushVolatile() {
            this.outgoing && (this.log("_flushVolatile :: deleting volatile messages from the queue and setting their callbacks as error function"), Object.keys(this.outgoing).forEach((e)=>{
                this.outgoing[e].volatile && typeof this.outgoing[e].cb == "function" && (this.outgoing[e].cb(new Error("Connection closed")), delete this.outgoing[e]);
            }));
        }
        _flush() {
            this.outgoing && (this.log("_flush: queue exists? %b", !!this.outgoing), Object.keys(this.outgoing).forEach((e)=>{
                typeof this.outgoing[e].cb == "function" && (this.outgoing[e].cb(new Error("Connection closed")), delete this.outgoing[e]);
            }));
        }
        _removeTopicAliasAndRecoverTopicName(e) {
            let r;
            e.properties && (r = e.properties.topicAlias);
            let n = e.topic.toString();
            if (this.log("_removeTopicAliasAndRecoverTopicName :: alias %d, topic %o", r, n), n.length === 0) {
                if (typeof r > "u") return new Error("Unregistered Topic Alias");
                if (n = this.topicAliasSend.getTopicByAlias(r), typeof n > "u") return new Error("Unregistered Topic Alias");
                e.topic = n;
            }
            r && delete e.properties.topicAlias;
        }
        _checkDisconnecting(e) {
            return this.disconnecting && (e && e !== this.noop ? e(new Error("client disconnecting")) : this.emit("error", new Error("client disconnecting"))), this.disconnecting;
        }
        _reconnect() {
            this.log("_reconnect: emitting reconnect to client"), this.emit("reconnect"), this.connected ? (this.end(()=>{
                this.connect();
            }), this.log("client already connected. disconnecting first.")) : (this.log("_reconnect: calling connect"), this.connect());
        }
        _setupReconnect() {
            !this.disconnecting && !this.reconnectTimer && this.options.reconnectPeriod > 0 ? (this.reconnecting || (this.log("_setupReconnect :: emit `offline` state"), this.emit("offline"), this.log("_setupReconnect :: set `reconnecting` to `true`"), this.reconnecting = !0), this.log("_setupReconnect :: setting reconnectTimer for %d ms", this.options.reconnectPeriod), this.reconnectTimer = setInterval(()=>{
                this.log("reconnectTimer :: reconnect triggered!"), this._reconnect();
            }, this.options.reconnectPeriod)) : this.log("_setupReconnect :: doing nothing...");
        }
        _clearReconnect() {
            this.log("_clearReconnect : clearing reconnect timer"), this.reconnectTimer && (clearInterval(this.reconnectTimer), this.reconnectTimer = null);
        }
        _cleanUp(e, r, n = {}) {
            if (r && (this.log("_cleanUp :: done callback provided for on stream close"), this.stream.on("close", r)), this.log("_cleanUp :: forced? %s", e), e) this.options.reconnectPeriod === 0 && this.options.clean && this._flush(), this.log("_cleanUp :: (%s) :: destroying stream", this.options.clientId), this.stream.destroy();
            else {
                let i = {
                    cmd: "disconnect",
                    ...n
                };
                this.log("_cleanUp :: (%s) :: call _sendPacket with disconnect packet", this.options.clientId), this._sendPacket(i, ()=>{
                    this.log("_cleanUp :: (%s) :: destroying stream", this.options.clientId), Wu(()=>{
                        this.stream.end(()=>{
                            this.log("_cleanUp :: (%s) :: stream destroyed", this.options.clientId);
                        });
                    });
                });
            }
            !this.disconnecting && !this.reconnecting && (this.log("_cleanUp :: client not disconnecting/reconnecting. Clearing and resetting reconnect."), this._clearReconnect(), this._setupReconnect()), this._destroyKeepaliveManager(), r && !this.connected && (this.log("_cleanUp :: (%s) :: removing stream `done` callback `close` listener", this.options.clientId), this.stream.removeListener("close", r), r());
        }
        _storeAndSend(e, r, n) {
            this.log("storeAndSend :: store packet with cmd %s to outgoingStore", e.cmd);
            let i = e, s;
            if (i.cmd === "publish" && (i = (0, kg.default)(e), s = this._removeTopicAliasAndRecoverTopicName(i), s)) return r && r(s);
            this.outgoingStore.put(i, (o)=>{
                if (o) return r && r(o);
                n(), this._writePacket(e, r);
            });
        }
        _applyTopicAlias(e) {
            if (this.options.protocolVersion === 5 && e.cmd === "publish") {
                let r;
                e.properties && (r = e.properties.topicAlias);
                let n = e.topic.toString();
                if (this.topicAliasSend) {
                    if (r) {
                        if (n.length !== 0 && (this.log("applyTopicAlias :: register topic: %s - alias: %d", n, r), !this.topicAliasSend.put(n, r))) return this.log("applyTopicAlias :: error out of range. topic: %s - alias: %d", n, r), new Error("Sending Topic Alias out of range");
                    } else n.length !== 0 && (this.options.autoAssignTopicAlias ? (r = this.topicAliasSend.getAliasByTopic(n), r ? (e.topic = "", e.properties = {
                        ...e.properties,
                        topicAlias: r
                    }, this.log("applyTopicAlias :: auto assign(use) topic: %s - alias: %d", n, r)) : (r = this.topicAliasSend.getLruAlias(), this.topicAliasSend.put(n, r), e.properties = {
                        ...e.properties,
                        topicAlias: r
                    }, this.log("applyTopicAlias :: auto assign topic: %s - alias: %d", n, r))) : this.options.autoUseTopicAlias && (r = this.topicAliasSend.getAliasByTopic(n), r && (e.topic = "", e.properties = {
                        ...e.properties,
                        topicAlias: r
                    }, this.log("applyTopicAlias :: auto use topic: %s - alias: %d", n, r))));
                } else if (r) return this.log("applyTopicAlias :: error out of range. topic: %s - alias: %d", n, r), new Error("Sending Topic Alias out of range");
            }
        }
        _noop(e) {
            this.log("noop ::", e);
        }
        _writePacket(e, r) {
            this.log("_writePacket :: packet: %O", e), this.log("_writePacket :: emitting `packetsend`"), this.emit("packetsend", e), this.log("_writePacket :: writing to stream");
            let n = Fu.default.writeToStream(e, this.stream, this.options);
            this.log("_writePacket :: writeToStream result %s", n), !n && r && r !== this.noop ? (this.log("_writePacket :: handle events on `drain` once through callback."), this.stream.once("drain", r)) : r && (this.log("_writePacket :: invoking cb"), r());
        }
        _sendPacket(e, r, n, i) {
            this.log("_sendPacket :: (%s) ::  start", this.options.clientId), n = n || this.noop, r = r || this.noop;
            let s = this._applyTopicAlias(e);
            if (s) {
                r(s);
                return;
            }
            if (!this.connected) {
                if (e.cmd === "auth") {
                    this._writePacket(e, r);
                    return;
                }
                this.log("_sendPacket :: client not connected. Storing packet offline."), this._storePacket(e, r, n);
                return;
            }
            if (i) {
                this._writePacket(e, r);
                return;
            }
            switch(e.cmd){
                case "publish":
                    break;
                case "pubrel":
                    this._storeAndSend(e, r, n);
                    return;
                default:
                    this._writePacket(e, r);
                    return;
            }
            switch(e.qos){
                case 2:
                case 1:
                    this._storeAndSend(e, r, n);
                    break;
                case 0:
                default:
                    this._writePacket(e, r);
                    break;
            }
            this.log("_sendPacket :: (%s) ::  end", this.options.clientId);
        }
        _storePacket(e, r, n) {
            this.log("_storePacket :: packet: %o", e), this.log("_storePacket :: cb? %s", !!r), n = n || this.noop;
            let i = e;
            if (i.cmd === "publish") {
                i = (0, kg.default)(e);
                let o = this._removeTopicAliasAndRecoverTopicName(i);
                if (o) return r && r(o);
            }
            let s = i.qos || 0;
            s === 0 && this.queueQoSZero || i.cmd !== "publish" ? this.queue.push({
                packet: i,
                cb: r
            }) : s > 0 ? (r = this.outgoing[i.messageId] ? this.outgoing[i.messageId].cb : null, this.outgoingStore.put(i, (o)=>{
                if (o) return r && r(o);
                n();
            })) : r && r(new Error("No connection to broker"));
        }
        _setupKeepaliveManager() {
            this.log("_setupKeepaliveManager :: keepalive %d (seconds)", this.options.keepalive), !this.keepaliveManager && this.options.keepalive && (this.keepaliveManager = new QA.default(this, this.options.timerVariant));
        }
        _destroyKeepaliveManager() {
            this.keepaliveManager && (this.log("_destroyKeepaliveManager :: destroying keepalive manager"), this.keepaliveManager.destroy(), this.keepaliveManager = null);
        }
        reschedulePing(e = !1) {
            this.keepaliveManager && this.options.keepalive && (e || this.options.reschedulePings) && this._reschedulePing();
        }
        _reschedulePing() {
            this.log("_reschedulePing :: rescheduling ping"), this.keepaliveManager.reschedule();
        }
        sendPing() {
            this.log("_sendPing :: sending pingreq"), this._sendPacket({
                cmd: "pingreq"
            });
        }
        onKeepaliveTimeout() {
            this.emit("error", new Error("Keepalive timeout")), this.log("onKeepaliveTimeout :: calling _cleanUp with force true"), this._cleanUp(!0);
        }
        _resubscribe() {
            this.log("_resubscribe");
            let e = Object.keys(this._resubscribeTopics);
            if (!this._firstConnection && (this.options.clean || this.options.protocolVersion >= 4 && !this.connackPacket.sessionPresent) && e.length > 0) {
                if (this.options.resubscribe) {
                    if (this.options.protocolVersion === 5) {
                        this.log("_resubscribe: protocolVersion 5");
                        for(let r = 0; r < e.length; r++){
                            let n = {};
                            n[e[r]] = this._resubscribeTopics[e[r]], n.resubscribe = !0, this.subscribe(n, {
                                properties: n[e[r]].properties
                            });
                        }
                    } else this._resubscribeTopics.resubscribe = !0, this.subscribe(this._resubscribeTopics);
                } else this._resubscribeTopics = {};
            }
            this._firstConnection = !1;
        }
        _onConnect(e) {
            if (this.disconnected) {
                this.emit("connect", e);
                return;
            }
            this.connackPacket = e, this.messageIdProvider.clear(), this._setupKeepaliveManager(), this.connected = !0;
            let r = ()=>{
                let n = this.outgoingStore.createStream(), i = ()=>{
                    n.destroy(), n = null, this._flushStoreProcessingQueue(), s();
                }, s = ()=>{
                    this._storeProcessing = !1, this._packetIdsDuringStoreProcessing = {};
                };
                this.once("close", i), n.on("error", (a)=>{
                    s(), this._flushStoreProcessingQueue(), this.removeListener("close", i), this.emit("error", a);
                });
                let o = ()=>{
                    if (!n) return;
                    let a = n.read(1), c;
                    if (!a) {
                        n.once("readable", o);
                        return;
                    }
                    if (this._storeProcessing = !0, this._packetIdsDuringStoreProcessing[a.messageId]) {
                        o();
                        return;
                    }
                    !this.disconnecting && !this.reconnectTimer ? (c = this.outgoing[a.messageId] ? this.outgoing[a.messageId].cb : null, this.outgoing[a.messageId] = {
                        volatile: !1,
                        cb (f, h) {
                            c && c(f, h), o();
                        }
                    }, this._packetIdsDuringStoreProcessing[a.messageId] = !0, this.messageIdProvider.register(a.messageId) ? this._sendPacket(a, void 0, void 0, !0) : this.log("messageId: %d has already used.", a.messageId)) : n.destroy && n.destroy();
                };
                n.on("end", ()=>{
                    let a = !0;
                    for(let c in this._packetIdsDuringStoreProcessing)if (!this._packetIdsDuringStoreProcessing[c]) {
                        a = !1;
                        break;
                    }
                    this.removeListener("close", i), a ? (s(), this._invokeAllStoreProcessingQueue(), this.emit("connect", e)) : r();
                }), o();
            };
            r();
        }
        _invokeStoreProcessingQueue() {
            if (!this._storeProcessing && this._storeProcessingQueue.length > 0) {
                let e = this._storeProcessingQueue[0];
                if (e && e.invoke()) return this._storeProcessingQueue.shift(), !0;
            }
            return !1;
        }
        _invokeAllStoreProcessingQueue() {
            for(; this._invokeStoreProcessingQueue(););
        }
        _flushStoreProcessingQueue() {
            for (let e of this._storeProcessingQueue)e.cbStorePut && e.cbStorePut(new Error("Connection closed")), e.callback && e.callback(new Error("Connection closed"));
            this._storeProcessingQueue.splice(0);
        }
        _removeOutgoingAndStoreMessage(e, r) {
            delete this.outgoing[e], this.outgoingStore.del({
                messageId: e
            }, (n, i)=>{
                r(n, i), this.messageIdProvider.deallocate(e), this._invokeStoreProcessingQueue();
            });
        }
    };
    yt.default = $u;
});
var $4c2dd1b68d143d96$var$qg = $4c2dd1b68d143d96$var$D((Vu)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Vu, "__esModule", {
        value: !0
    });
    var YA = $4c2dd1b68d143d96$var$mu(), Hu = class {
        numberAllocator;
        lastId;
        constructor(){
            this.numberAllocator = new YA.NumberAllocator(1, 65535);
        }
        allocate() {
            return this.lastId = this.numberAllocator.alloc(), this.lastId;
        }
        getLastAllocated() {
            return this.lastId;
        }
        register(e) {
            return this.numberAllocator.use(e);
        }
        deallocate(e) {
            this.numberAllocator.free(e);
        }
        clear() {
            this.numberAllocator.clear();
        }
    };
    Vu.default = Hu;
});
function $4c2dd1b68d143d96$var$JA() {
    if ($4c2dd1b68d143d96$var$Lg) return $4c2dd1b68d143d96$var$Gu;
    $4c2dd1b68d143d96$var$Lg = !0;
    let t = 2147483647, e = 36, r = 1, n = 26, i = 38, s = 700, o = 72, a = 128, c = "-", f = /^xn--/, h = /[^\0-\x7F]/, d = /[\x2E\u3002\uFF0E\uFF61]/g, w = {
        overflow: "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, y = e - r, P = Math.floor, E = String.fromCharCode;
    function b(H) {
        throw new RangeError(w[H]);
    }
    function m(H, G) {
        let K = [], X = H.length;
        for(; X--;)K[X] = G(H[X]);
        return K;
    }
    function v(H, G) {
        let K = H.split("@"), X = "";
        K.length > 1 && (X = K[0] + "@", H = K[1]), H = H.replace(d, ".");
        let Q = H.split("."), V = m(Q, G).join(".");
        return X + V;
    }
    function R(H) {
        let G = [], K = 0, X = H.length;
        for(; K < X;){
            let Q = H.charCodeAt(K++);
            if (Q >= 55296 && Q <= 56319 && K < X) {
                let V = H.charCodeAt(K++);
                (V & 64512) == 56320 ? G.push(((Q & 1023) << 10) + (V & 1023) + 65536) : (G.push(Q), K--);
            } else G.push(Q);
        }
        return G;
    }
    let T = (H)=>String.fromCodePoint(...H), g = function(H) {
        return H >= 48 && H < 58 ? 26 + (H - 48) : H >= 65 && H < 91 ? H - 65 : H >= 97 && H < 123 ? H - 97 : e;
    }, O = function(H, G) {
        return H + 22 + 75 * (H < 26) - ((G != 0) << 5);
    }, _ = function(H, G, K) {
        let X = 0;
        for(H = K ? P(H / s) : H >> 1, H += P(H / G); H > y * n >> 1; X += e)H = P(H / y);
        return P(X + (y + 1) * H / (H + i));
    }, q = function(H) {
        let G = [], K = H.length, X = 0, Q = a, V = o, te = H.lastIndexOf(c);
        te < 0 && (te = 0);
        for(let Y = 0; Y < te; ++Y)H.charCodeAt(Y) >= 128 && b("not-basic"), G.push(H.charCodeAt(Y));
        for(let Y = te > 0 ? te + 1 : 0; Y < K;){
            let ee = X;
            for(let Z = 1, ne = e;; ne += e){
                Y >= K && b("invalid-input");
                let fe = g(H.charCodeAt(Y++));
                fe >= e && b("invalid-input"), fe > P((t - X) / Z) && b("overflow"), X += fe * Z;
                let be = ne <= V ? r : ne >= V + n ? n : ne - V;
                if (fe < be) break;
                let ye = e - be;
                Z > P(t / ye) && b("overflow"), Z *= ye;
            }
            let pe = G.length + 1;
            V = _(X - ee, pe, ee == 0), P(X / pe) > t - Q && b("overflow"), Q += P(X / pe), X %= pe, G.splice(X++, 0, Q);
        }
        return String.fromCodePoint(...G);
    }, $ = function(H) {
        let G = [];
        H = R(H);
        let K = H.length, X = a, Q = 0, V = o;
        for (let ee of H)ee < 128 && G.push(E(ee));
        let te = G.length, Y = te;
        for(te && G.push(c); Y < K;){
            let ee = t;
            for (let Z of H)Z >= X && Z < ee && (ee = Z);
            let pe = Y + 1;
            ee - X > P((t - Q) / pe) && b("overflow"), Q += (ee - X) * pe, X = ee;
            for (let Z of H)if (Z < X && ++Q > t && b("overflow"), Z === X) {
                let ne = Q;
                for(let fe = e;; fe += e){
                    let be = fe <= V ? r : fe >= V + n ? n : fe - V;
                    if (ne < be) break;
                    let ye = ne - be, Ae = e - be;
                    G.push(E(O(be + ye % Ae, 0))), ne = P(ye / Ae);
                }
                G.push(E(O(ne, 0))), V = _(Q, pe, Y === te), Q = 0, ++Y;
            }
            ++Q, ++X;
        }
        return G.join("");
    };
    return $4c2dd1b68d143d96$var$Gu = {
        version: "2.3.1",
        ucs2: {
            decode: R,
            encode: T
        },
        decode: q,
        encode: $,
        toASCII: function(H) {
            return v(H, function(G) {
                return h.test(G) ? "xn--" + $(G) : G;
            });
        },
        toUnicode: function(H) {
            return v(H, function(G) {
                return f.test(G) ? q(G.slice(4).toLowerCase()) : G;
            });
        }
    }, $4c2dd1b68d143d96$var$Gu;
}
var $4c2dd1b68d143d96$var$Gu, $4c2dd1b68d143d96$var$Lg, $4c2dd1b68d143d96$var$hr, $4c2dd1b68d143d96$var$w5, $4c2dd1b68d143d96$var$m5, $4c2dd1b68d143d96$var$_5, $4c2dd1b68d143d96$var$v5, $4c2dd1b68d143d96$var$S5, $4c2dd1b68d143d96$var$E5, $4c2dd1b68d143d96$var$Ug = $4c2dd1b68d143d96$var$ze(()=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    $4c2dd1b68d143d96$var$Gu = {}, $4c2dd1b68d143d96$var$Lg = !1;
    $4c2dd1b68d143d96$var$hr = $4c2dd1b68d143d96$var$JA(), $4c2dd1b68d143d96$var$w5 = $4c2dd1b68d143d96$var$hr.decode, $4c2dd1b68d143d96$var$m5 = $4c2dd1b68d143d96$var$hr.encode, $4c2dd1b68d143d96$var$_5 = $4c2dd1b68d143d96$var$hr.toASCII, $4c2dd1b68d143d96$var$v5 = $4c2dd1b68d143d96$var$hr.toUnicode, $4c2dd1b68d143d96$var$S5 = $4c2dd1b68d143d96$var$hr.ucs2, $4c2dd1b68d143d96$var$E5 = $4c2dd1b68d143d96$var$hr.version;
});
function $4c2dd1b68d143d96$var$XA() {
    return $4c2dd1b68d143d96$var$Dg || ($4c2dd1b68d143d96$var$Dg = !0, $4c2dd1b68d143d96$var$zu = function() {
        if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function") return !1;
        if (typeof Symbol.iterator == "symbol") return !0;
        var e = {}, r = Symbol("test"), n = Object(r);
        if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]") return !1;
        var i = 42;
        e[r] = i;
        for(r in e)return !1;
        if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0) return !1;
        var s = Object.getOwnPropertySymbols(e);
        if (s.length !== 1 || s[0] !== r || !Object.prototype.propertyIsEnumerable.call(e, r)) return !1;
        if (typeof Object.getOwnPropertyDescriptor == "function") {
            var o = Object.getOwnPropertyDescriptor(e, r);
            if (o.value !== i || o.enumerable !== !0) return !1;
        }
        return !0;
    }), $4c2dd1b68d143d96$var$zu;
}
function $4c2dd1b68d143d96$var$ZA() {
    return $4c2dd1b68d143d96$var$jg || ($4c2dd1b68d143d96$var$jg = !0, $4c2dd1b68d143d96$var$Ku = Error), $4c2dd1b68d143d96$var$Ku;
}
function $4c2dd1b68d143d96$var$eI() {
    return $4c2dd1b68d143d96$var$Fg || ($4c2dd1b68d143d96$var$Fg = !0, $4c2dd1b68d143d96$var$Qu = EvalError), $4c2dd1b68d143d96$var$Qu;
}
function $4c2dd1b68d143d96$var$tI() {
    return $4c2dd1b68d143d96$var$Wg || ($4c2dd1b68d143d96$var$Wg = !0, $4c2dd1b68d143d96$var$Yu = RangeError), $4c2dd1b68d143d96$var$Yu;
}
function $4c2dd1b68d143d96$var$rI() {
    return $4c2dd1b68d143d96$var$$g || ($4c2dd1b68d143d96$var$$g = !0, $4c2dd1b68d143d96$var$Ju = ReferenceError), $4c2dd1b68d143d96$var$Ju;
}
function $4c2dd1b68d143d96$var$sb() {
    return $4c2dd1b68d143d96$var$Hg || ($4c2dd1b68d143d96$var$Hg = !0, $4c2dd1b68d143d96$var$Xu = SyntaxError), $4c2dd1b68d143d96$var$Xu;
}
function $4c2dd1b68d143d96$var$Sn() {
    return $4c2dd1b68d143d96$var$Vg || ($4c2dd1b68d143d96$var$Vg = !0, $4c2dd1b68d143d96$var$Zu = TypeError), $4c2dd1b68d143d96$var$Zu;
}
function $4c2dd1b68d143d96$var$nI() {
    return $4c2dd1b68d143d96$var$Gg || ($4c2dd1b68d143d96$var$Gg = !0, $4c2dd1b68d143d96$var$el = URIError), $4c2dd1b68d143d96$var$el;
}
function $4c2dd1b68d143d96$var$iI() {
    if ($4c2dd1b68d143d96$var$zg) return $4c2dd1b68d143d96$var$tl;
    $4c2dd1b68d143d96$var$zg = !0;
    var t = typeof Symbol < "u" && Symbol, e = $4c2dd1b68d143d96$var$XA();
    return $4c2dd1b68d143d96$var$tl = function() {
        return typeof t != "function" || typeof Symbol != "function" || typeof t("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : e();
    }, $4c2dd1b68d143d96$var$tl;
}
function $4c2dd1b68d143d96$var$oI() {
    if ($4c2dd1b68d143d96$var$Kg) return $4c2dd1b68d143d96$var$rl;
    $4c2dd1b68d143d96$var$Kg = !0;
    var t = {
        __proto__: null,
        foo: {}
    }, e = Object;
    return $4c2dd1b68d143d96$var$rl = function() {
        return ({
            __proto__: t
        }).foo === t.foo && !(t instanceof e);
    }, $4c2dd1b68d143d96$var$rl;
}
function $4c2dd1b68d143d96$var$sI() {
    if ($4c2dd1b68d143d96$var$Qg) return $4c2dd1b68d143d96$var$nl;
    $4c2dd1b68d143d96$var$Qg = !0;
    var t = "Function.prototype.bind called on incompatible ", e = Object.prototype.toString, r = Math.max, n = "[object Function]", i = function(c, f) {
        for(var h = [], d = 0; d < c.length; d += 1)h[d] = c[d];
        for(var w = 0; w < f.length; w += 1)h[w + c.length] = f[w];
        return h;
    }, s = function(c, f) {
        for(var h = [], d = f, w = 0; d < c.length; d += 1, w += 1)h[w] = c[d];
        return h;
    }, o = function(a, c) {
        for(var f = "", h = 0; h < a.length; h += 1)f += a[h], h + 1 < a.length && (f += c);
        return f;
    };
    return $4c2dd1b68d143d96$var$nl = function(c) {
        var f = this;
        if (typeof f != "function" || e.apply(f) !== n) throw new TypeError(t + f);
        for(var h = s(arguments, 1), d, w = function() {
            if (this instanceof d) {
                var m = f.apply(this, i(h, arguments));
                return Object(m) === m ? m : this;
            }
            return f.apply(c, i(h, arguments));
        }, y = r(0, f.length - h.length), P = [], E = 0; E < y; E++)P[E] = "$" + E;
        if (d = Function("binder", "return function (" + o(P, ",") + "){ return binder.apply(this,arguments); }")(w), f.prototype) {
            var b = function() {};
            b.prototype = f.prototype, d.prototype = new b, b.prototype = null;
        }
        return d;
    }, $4c2dd1b68d143d96$var$nl;
}
function $4c2dd1b68d143d96$var$dl() {
    if ($4c2dd1b68d143d96$var$Yg) return $4c2dd1b68d143d96$var$il;
    $4c2dd1b68d143d96$var$Yg = !0;
    var t = $4c2dd1b68d143d96$var$sI();
    return $4c2dd1b68d143d96$var$il = Function.prototype.bind || t, $4c2dd1b68d143d96$var$il;
}
function $4c2dd1b68d143d96$var$aI() {
    if ($4c2dd1b68d143d96$var$Jg) return $4c2dd1b68d143d96$var$ol;
    $4c2dd1b68d143d96$var$Jg = !0;
    var t = Function.prototype.call, e = Object.prototype.hasOwnProperty, r = $4c2dd1b68d143d96$var$dl();
    return $4c2dd1b68d143d96$var$ol = r.call(t, e), $4c2dd1b68d143d96$var$ol;
}
function $4c2dd1b68d143d96$var$Wr() {
    if ($4c2dd1b68d143d96$var$Xg) return $4c2dd1b68d143d96$var$sl;
    $4c2dd1b68d143d96$var$Xg = !0;
    var t, e = $4c2dd1b68d143d96$var$ZA(), r = $4c2dd1b68d143d96$var$eI(), n = $4c2dd1b68d143d96$var$tI(), i = $4c2dd1b68d143d96$var$rI(), s = $4c2dd1b68d143d96$var$sb(), o = $4c2dd1b68d143d96$var$Sn(), a = $4c2dd1b68d143d96$var$nI(), c = Function, f = function(Q) {
        try {
            return c('"use strict"; return (' + Q + ").constructor;")();
        } catch  {}
    }, h = Object.getOwnPropertyDescriptor;
    if (h) try {
        h({}, "");
    } catch  {
        h = null;
    }
    var d = function() {
        throw new o;
    }, w = h ? function() {
        try {
            return arguments.callee, d;
        } catch  {
            try {
                return h(arguments, "callee").get;
            } catch  {
                return d;
            }
        }
    }() : d, y = $4c2dd1b68d143d96$var$iI()(), P = $4c2dd1b68d143d96$var$oI()(), E = Object.getPrototypeOf || (P ? function(Q) {
        return Q.__proto__;
    } : null), b = {}, m = typeof Uint8Array > "u" || !E ? t : E(Uint8Array), v = {
        __proto__: null,
        "%AggregateError%": typeof AggregateError > "u" ? t : AggregateError,
        "%Array%": Array,
        "%ArrayBuffer%": typeof ArrayBuffer > "u" ? t : ArrayBuffer,
        "%ArrayIteratorPrototype%": y && E ? E([][Symbol.iterator]()) : t,
        "%AsyncFromSyncIteratorPrototype%": t,
        "%AsyncFunction%": b,
        "%AsyncGenerator%": b,
        "%AsyncGeneratorFunction%": b,
        "%AsyncIteratorPrototype%": b,
        "%Atomics%": typeof Atomics > "u" ? t : Atomics,
        "%BigInt%": typeof BigInt > "u" ? t : BigInt,
        "%BigInt64Array%": typeof BigInt64Array > "u" ? t : BigInt64Array,
        "%BigUint64Array%": typeof BigUint64Array > "u" ? t : BigUint64Array,
        "%Boolean%": Boolean,
        "%DataView%": typeof DataView > "u" ? t : DataView,
        "%Date%": Date,
        "%decodeURI%": decodeURI,
        "%decodeURIComponent%": decodeURIComponent,
        "%encodeURI%": encodeURI,
        "%encodeURIComponent%": encodeURIComponent,
        "%Error%": e,
        "%eval%": eval,
        "%EvalError%": r,
        "%Float32Array%": typeof Float32Array > "u" ? t : Float32Array,
        "%Float64Array%": typeof Float64Array > "u" ? t : Float64Array,
        "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? t : FinalizationRegistry,
        "%Function%": c,
        "%GeneratorFunction%": b,
        "%Int8Array%": typeof Int8Array > "u" ? t : Int8Array,
        "%Int16Array%": typeof Int16Array > "u" ? t : Int16Array,
        "%Int32Array%": typeof Int32Array > "u" ? t : Int32Array,
        "%isFinite%": isFinite,
        "%isNaN%": isNaN,
        "%IteratorPrototype%": y && E ? E(E([][Symbol.iterator]())) : t,
        "%JSON%": typeof JSON == "object" ? JSON : t,
        "%Map%": typeof Map > "u" ? t : Map,
        "%MapIteratorPrototype%": typeof Map > "u" || !y || !E ? t : E(new Map()[Symbol.iterator]()),
        "%Math%": Math,
        "%Number%": Number,
        "%Object%": Object,
        "%parseFloat%": parseFloat,
        "%parseInt%": parseInt,
        "%Promise%": typeof Promise > "u" ? t : Promise,
        "%Proxy%": typeof Proxy > "u" ? t : Proxy,
        "%RangeError%": n,
        "%ReferenceError%": i,
        "%Reflect%": typeof Reflect > "u" ? t : Reflect,
        "%RegExp%": RegExp,
        "%Set%": typeof Set > "u" ? t : Set,
        "%SetIteratorPrototype%": typeof Set > "u" || !y || !E ? t : E(new Set()[Symbol.iterator]()),
        "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? t : SharedArrayBuffer,
        "%String%": String,
        "%StringIteratorPrototype%": y && E ? E(""[Symbol.iterator]()) : t,
        "%Symbol%": y ? Symbol : t,
        "%SyntaxError%": s,
        "%ThrowTypeError%": w,
        "%TypedArray%": m,
        "%TypeError%": o,
        "%Uint8Array%": typeof Uint8Array > "u" ? t : Uint8Array,
        "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? t : Uint8ClampedArray,
        "%Uint16Array%": typeof Uint16Array > "u" ? t : Uint16Array,
        "%Uint32Array%": typeof Uint32Array > "u" ? t : Uint32Array,
        "%URIError%": a,
        "%WeakMap%": typeof WeakMap > "u" ? t : WeakMap,
        "%WeakRef%": typeof WeakRef > "u" ? t : WeakRef,
        "%WeakSet%": typeof WeakSet > "u" ? t : WeakSet
    };
    if (E) try {
        null.error;
    } catch (Q) {
        var R = E(E(Q));
        v["%Error.prototype%"] = R;
    }
    var T = function Q(V) {
        var te;
        if (V === "%AsyncFunction%") te = f("async function () {}");
        else if (V === "%GeneratorFunction%") te = f("function* () {}");
        else if (V === "%AsyncGeneratorFunction%") te = f("async function* () {}");
        else if (V === "%AsyncGenerator%") {
            var Y = Q("%AsyncGeneratorFunction%");
            Y && (te = Y.prototype);
        } else if (V === "%AsyncIteratorPrototype%") {
            var ee = Q("%AsyncGenerator%");
            ee && E && (te = E(ee.prototype));
        }
        return v[V] = te, te;
    }, g = {
        __proto__: null,
        "%ArrayBufferPrototype%": [
            "ArrayBuffer",
            "prototype"
        ],
        "%ArrayPrototype%": [
            "Array",
            "prototype"
        ],
        "%ArrayProto_entries%": [
            "Array",
            "prototype",
            "entries"
        ],
        "%ArrayProto_forEach%": [
            "Array",
            "prototype",
            "forEach"
        ],
        "%ArrayProto_keys%": [
            "Array",
            "prototype",
            "keys"
        ],
        "%ArrayProto_values%": [
            "Array",
            "prototype",
            "values"
        ],
        "%AsyncFunctionPrototype%": [
            "AsyncFunction",
            "prototype"
        ],
        "%AsyncGenerator%": [
            "AsyncGeneratorFunction",
            "prototype"
        ],
        "%AsyncGeneratorPrototype%": [
            "AsyncGeneratorFunction",
            "prototype",
            "prototype"
        ],
        "%BooleanPrototype%": [
            "Boolean",
            "prototype"
        ],
        "%DataViewPrototype%": [
            "DataView",
            "prototype"
        ],
        "%DatePrototype%": [
            "Date",
            "prototype"
        ],
        "%ErrorPrototype%": [
            "Error",
            "prototype"
        ],
        "%EvalErrorPrototype%": [
            "EvalError",
            "prototype"
        ],
        "%Float32ArrayPrototype%": [
            "Float32Array",
            "prototype"
        ],
        "%Float64ArrayPrototype%": [
            "Float64Array",
            "prototype"
        ],
        "%FunctionPrototype%": [
            "Function",
            "prototype"
        ],
        "%Generator%": [
            "GeneratorFunction",
            "prototype"
        ],
        "%GeneratorPrototype%": [
            "GeneratorFunction",
            "prototype",
            "prototype"
        ],
        "%Int8ArrayPrototype%": [
            "Int8Array",
            "prototype"
        ],
        "%Int16ArrayPrototype%": [
            "Int16Array",
            "prototype"
        ],
        "%Int32ArrayPrototype%": [
            "Int32Array",
            "prototype"
        ],
        "%JSONParse%": [
            "JSON",
            "parse"
        ],
        "%JSONStringify%": [
            "JSON",
            "stringify"
        ],
        "%MapPrototype%": [
            "Map",
            "prototype"
        ],
        "%NumberPrototype%": [
            "Number",
            "prototype"
        ],
        "%ObjectPrototype%": [
            "Object",
            "prototype"
        ],
        "%ObjProto_toString%": [
            "Object",
            "prototype",
            "toString"
        ],
        "%ObjProto_valueOf%": [
            "Object",
            "prototype",
            "valueOf"
        ],
        "%PromisePrototype%": [
            "Promise",
            "prototype"
        ],
        "%PromiseProto_then%": [
            "Promise",
            "prototype",
            "then"
        ],
        "%Promise_all%": [
            "Promise",
            "all"
        ],
        "%Promise_reject%": [
            "Promise",
            "reject"
        ],
        "%Promise_resolve%": [
            "Promise",
            "resolve"
        ],
        "%RangeErrorPrototype%": [
            "RangeError",
            "prototype"
        ],
        "%ReferenceErrorPrototype%": [
            "ReferenceError",
            "prototype"
        ],
        "%RegExpPrototype%": [
            "RegExp",
            "prototype"
        ],
        "%SetPrototype%": [
            "Set",
            "prototype"
        ],
        "%SharedArrayBufferPrototype%": [
            "SharedArrayBuffer",
            "prototype"
        ],
        "%StringPrototype%": [
            "String",
            "prototype"
        ],
        "%SymbolPrototype%": [
            "Symbol",
            "prototype"
        ],
        "%SyntaxErrorPrototype%": [
            "SyntaxError",
            "prototype"
        ],
        "%TypedArrayPrototype%": [
            "TypedArray",
            "prototype"
        ],
        "%TypeErrorPrototype%": [
            "TypeError",
            "prototype"
        ],
        "%Uint8ArrayPrototype%": [
            "Uint8Array",
            "prototype"
        ],
        "%Uint8ClampedArrayPrototype%": [
            "Uint8ClampedArray",
            "prototype"
        ],
        "%Uint16ArrayPrototype%": [
            "Uint16Array",
            "prototype"
        ],
        "%Uint32ArrayPrototype%": [
            "Uint32Array",
            "prototype"
        ],
        "%URIErrorPrototype%": [
            "URIError",
            "prototype"
        ],
        "%WeakMapPrototype%": [
            "WeakMap",
            "prototype"
        ],
        "%WeakSetPrototype%": [
            "WeakSet",
            "prototype"
        ]
    }, O = $4c2dd1b68d143d96$var$dl(), _ = $4c2dd1b68d143d96$var$aI(), q = O.call(Function.call, Array.prototype.concat), $ = O.call(Function.apply, Array.prototype.splice), j = O.call(Function.call, String.prototype.replace), J = O.call(Function.call, String.prototype.slice), W = O.call(Function.call, RegExp.prototype.exec), H = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, G = /\\(\\)?/g, K = function(V) {
        var te = J(V, 0, 1), Y = J(V, -1);
        if (te === "%" && Y !== "%") throw new s("invalid intrinsic syntax, expected closing `%`");
        if (Y === "%" && te !== "%") throw new s("invalid intrinsic syntax, expected opening `%`");
        var ee = [];
        return j(V, H, function(pe, Z, ne, fe) {
            ee[ee.length] = ne ? j(fe, G, "$1") : Z || pe;
        }), ee;
    }, X = function(V, te) {
        var Y = V, ee;
        if (_(g, Y) && (ee = g[Y], Y = "%" + ee[0] + "%"), _(v, Y)) {
            var pe = v[Y];
            if (pe === b && (pe = T(Y)), typeof pe > "u" && !te) throw new o("intrinsic " + V + " exists, but is not available. Please file an issue!");
            return {
                alias: ee,
                name: Y,
                value: pe
            };
        }
        throw new s("intrinsic " + V + " does not exist!");
    };
    return $4c2dd1b68d143d96$var$sl = function(V, te) {
        if (typeof V != "string" || V.length === 0) throw new o("intrinsic name must be a non-empty string");
        if (arguments.length > 1 && typeof te != "boolean") throw new o('"allowMissing" argument must be a boolean');
        if (W(/^%?[^%]*%?$/, V) === null) throw new s("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
        var Y = K(V), ee = Y.length > 0 ? Y[0] : "", pe = X("%" + ee + "%", te), Z = pe.name, ne = pe.value, fe = !1, be = pe.alias;
        be && (ee = be[0], $(Y, q([
            0,
            1
        ], be)));
        for(var ye = 1, Ae = !0; ye < Y.length; ye += 1){
            var _e = Y[ye], ve = J(_e, 0, 1), Oe = J(_e, -1);
            if ((ve === '"' || ve === "'" || ve === "`" || Oe === '"' || Oe === "'" || Oe === "`") && ve !== Oe) throw new s("property names with quotes must have matching quotes");
            if ((_e === "constructor" || !Ae) && (fe = !0), ee += "." + _e, Z = "%" + ee + "%", _(v, Z)) ne = v[Z];
            else if (ne != null) {
                if (!(_e in ne)) {
                    if (!te) throw new o("base intrinsic for " + V + " exists, but the property is not available.");
                    return;
                }
                if (h && ye + 1 >= Y.length) {
                    var xe = h(ne, _e);
                    Ae = !!xe, Ae && "get" in xe && !("originalValue" in xe.get) ? ne = xe.get : ne = ne[_e];
                } else Ae = _(ne, _e), ne = ne[_e];
                Ae && !fe && (v[Z] = ne);
            }
        }
        return ne;
    }, $4c2dd1b68d143d96$var$sl;
}
function $4c2dd1b68d143d96$var$pl() {
    if ($4c2dd1b68d143d96$var$Zg) return $4c2dd1b68d143d96$var$al;
    $4c2dd1b68d143d96$var$Zg = !0;
    var t = $4c2dd1b68d143d96$var$Wr(), e = t("%Object.defineProperty%", !0) || !1;
    if (e) try {
        e({}, "a", {
            value: 1
        });
    } catch  {
        e = !1;
    }
    return $4c2dd1b68d143d96$var$al = e, $4c2dd1b68d143d96$var$al;
}
function $4c2dd1b68d143d96$var$ab() {
    if ($4c2dd1b68d143d96$var$eb) return $4c2dd1b68d143d96$var$ul;
    $4c2dd1b68d143d96$var$eb = !0;
    var t = $4c2dd1b68d143d96$var$Wr(), e = t("%Object.getOwnPropertyDescriptor%", !0);
    if (e) try {
        e([], "length");
    } catch  {
        e = null;
    }
    return $4c2dd1b68d143d96$var$ul = e, $4c2dd1b68d143d96$var$ul;
}
function $4c2dd1b68d143d96$var$uI() {
    if ($4c2dd1b68d143d96$var$tb) return $4c2dd1b68d143d96$var$ll;
    $4c2dd1b68d143d96$var$tb = !0;
    var t = $4c2dd1b68d143d96$var$pl(), e = $4c2dd1b68d143d96$var$sb(), r = $4c2dd1b68d143d96$var$Sn(), n = $4c2dd1b68d143d96$var$ab();
    return $4c2dd1b68d143d96$var$ll = function(s, o, a) {
        if (!s || typeof s != "object" && typeof s != "function") throw new r("`obj` must be an object or a function`");
        if (typeof o != "string" && typeof o != "symbol") throw new r("`property` must be a string or a symbol`");
        if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null) throw new r("`nonEnumerable`, if provided, must be a boolean or null");
        if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null) throw new r("`nonWritable`, if provided, must be a boolean or null");
        if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null) throw new r("`nonConfigurable`, if provided, must be a boolean or null");
        if (arguments.length > 6 && typeof arguments[6] != "boolean") throw new r("`loose`, if provided, must be a boolean");
        var c = arguments.length > 3 ? arguments[3] : null, f = arguments.length > 4 ? arguments[4] : null, h = arguments.length > 5 ? arguments[5] : null, d = arguments.length > 6 ? arguments[6] : !1, w = !!n && n(s, o);
        if (t) t(s, o, {
            configurable: h === null && w ? w.configurable : !h,
            enumerable: c === null && w ? w.enumerable : !c,
            value: a,
            writable: f === null && w ? w.writable : !f
        });
        else if (d || !c && !f && !h) s[o] = a;
        else throw new e("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
    }, $4c2dd1b68d143d96$var$ll;
}
function $4c2dd1b68d143d96$var$lI() {
    if ($4c2dd1b68d143d96$var$rb) return $4c2dd1b68d143d96$var$cl;
    $4c2dd1b68d143d96$var$rb = !0;
    var t = $4c2dd1b68d143d96$var$pl(), e = function() {
        return !!t;
    };
    return e.hasArrayLengthDefineBug = function() {
        if (!t) return null;
        try {
            return t([], "length", {
                value: 1
            }).length !== 1;
        } catch  {
            return !0;
        }
    }, $4c2dd1b68d143d96$var$cl = e, $4c2dd1b68d143d96$var$cl;
}
function $4c2dd1b68d143d96$var$cI() {
    if ($4c2dd1b68d143d96$var$nb) return $4c2dd1b68d143d96$var$fl;
    $4c2dd1b68d143d96$var$nb = !0;
    var t = $4c2dd1b68d143d96$var$Wr(), e = $4c2dd1b68d143d96$var$uI(), r = $4c2dd1b68d143d96$var$lI()(), n = $4c2dd1b68d143d96$var$ab(), i = $4c2dd1b68d143d96$var$Sn(), s = t("%Math.floor%");
    return $4c2dd1b68d143d96$var$fl = function(a, c) {
        if (typeof a != "function") throw new i("`fn` is not a function");
        if (typeof c != "number" || c < 0 || c > 4294967295 || s(c) !== c) throw new i("`length` must be a positive 32-bit integer");
        var f = arguments.length > 2 && !!arguments[2], h = !0, d = !0;
        if ("length" in a && n) {
            var w = n(a, "length");
            w && !w.configurable && (h = !1), w && !w.writable && (d = !1);
        }
        return (h || d || !f) && (r ? e(a, "length", c, !0, !0) : e(a, "length", c)), a;
    }, $4c2dd1b68d143d96$var$fl;
}
function $4c2dd1b68d143d96$var$fI() {
    if ($4c2dd1b68d143d96$var$ib) return $4c2dd1b68d143d96$var$wi;
    $4c2dd1b68d143d96$var$ib = !0;
    var t = $4c2dd1b68d143d96$var$dl(), e = $4c2dd1b68d143d96$var$Wr(), r = $4c2dd1b68d143d96$var$cI(), n = $4c2dd1b68d143d96$var$Sn(), i = e("%Function.prototype.apply%"), s = e("%Function.prototype.call%"), o = e("%Reflect.apply%", !0) || t.call(s, i), a = $4c2dd1b68d143d96$var$pl(), c = e("%Math.max%");
    $4c2dd1b68d143d96$var$wi = function(d) {
        if (typeof d != "function") throw new n("a function is required");
        var w = o(t, s, arguments);
        return r(w, 1 + c(0, d.length - (arguments.length - 1)), !0);
    };
    var f = function() {
        return o(t, i, arguments);
    };
    return a ? a($4c2dd1b68d143d96$var$wi, "apply", {
        value: f
    }) : $4c2dd1b68d143d96$var$wi.apply = f, $4c2dd1b68d143d96$var$wi;
}
function $4c2dd1b68d143d96$var$ub() {
    if ($4c2dd1b68d143d96$var$ob) return $4c2dd1b68d143d96$var$hl;
    $4c2dd1b68d143d96$var$ob = !0;
    var t = $4c2dd1b68d143d96$var$Wr(), e = $4c2dd1b68d143d96$var$fI(), r = e(t("String.prototype.indexOf"));
    return $4c2dd1b68d143d96$var$hl = function(i, s) {
        var o = t(i, !!s);
        return typeof o == "function" && r(i, ".prototype.") > -1 ? e(o) : o;
    }, $4c2dd1b68d143d96$var$hl;
}
var $4c2dd1b68d143d96$var$zu, $4c2dd1b68d143d96$var$Dg, $4c2dd1b68d143d96$var$Ku, $4c2dd1b68d143d96$var$jg, $4c2dd1b68d143d96$var$Qu, $4c2dd1b68d143d96$var$Fg, $4c2dd1b68d143d96$var$Yu, $4c2dd1b68d143d96$var$Wg, $4c2dd1b68d143d96$var$Ju, $4c2dd1b68d143d96$var$$g, $4c2dd1b68d143d96$var$Xu, $4c2dd1b68d143d96$var$Hg, $4c2dd1b68d143d96$var$Zu, $4c2dd1b68d143d96$var$Vg, $4c2dd1b68d143d96$var$el, $4c2dd1b68d143d96$var$Gg, $4c2dd1b68d143d96$var$tl, $4c2dd1b68d143d96$var$zg, $4c2dd1b68d143d96$var$rl, $4c2dd1b68d143d96$var$Kg, $4c2dd1b68d143d96$var$nl, $4c2dd1b68d143d96$var$Qg, $4c2dd1b68d143d96$var$il, $4c2dd1b68d143d96$var$Yg, $4c2dd1b68d143d96$var$ol, $4c2dd1b68d143d96$var$Jg, $4c2dd1b68d143d96$var$sl, $4c2dd1b68d143d96$var$Xg, $4c2dd1b68d143d96$var$al, $4c2dd1b68d143d96$var$Zg, $4c2dd1b68d143d96$var$ul, $4c2dd1b68d143d96$var$eb, $4c2dd1b68d143d96$var$ll, $4c2dd1b68d143d96$var$tb, $4c2dd1b68d143d96$var$cl, $4c2dd1b68d143d96$var$rb, $4c2dd1b68d143d96$var$fl, $4c2dd1b68d143d96$var$nb, $4c2dd1b68d143d96$var$wi, $4c2dd1b68d143d96$var$ib, $4c2dd1b68d143d96$var$hl, $4c2dd1b68d143d96$var$ob, $4c2dd1b68d143d96$var$lb = $4c2dd1b68d143d96$var$ze(()=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    $4c2dd1b68d143d96$var$zu = {}, $4c2dd1b68d143d96$var$Dg = !1;
    $4c2dd1b68d143d96$var$Ku = {}, $4c2dd1b68d143d96$var$jg = !1;
    $4c2dd1b68d143d96$var$Qu = {}, $4c2dd1b68d143d96$var$Fg = !1;
    $4c2dd1b68d143d96$var$Yu = {}, $4c2dd1b68d143d96$var$Wg = !1;
    $4c2dd1b68d143d96$var$Ju = {}, $4c2dd1b68d143d96$var$$g = !1;
    $4c2dd1b68d143d96$var$Xu = {}, $4c2dd1b68d143d96$var$Hg = !1;
    $4c2dd1b68d143d96$var$Zu = {}, $4c2dd1b68d143d96$var$Vg = !1;
    $4c2dd1b68d143d96$var$el = {}, $4c2dd1b68d143d96$var$Gg = !1;
    $4c2dd1b68d143d96$var$tl = {}, $4c2dd1b68d143d96$var$zg = !1;
    $4c2dd1b68d143d96$var$rl = {}, $4c2dd1b68d143d96$var$Kg = !1;
    $4c2dd1b68d143d96$var$nl = {}, $4c2dd1b68d143d96$var$Qg = !1;
    $4c2dd1b68d143d96$var$il = {}, $4c2dd1b68d143d96$var$Yg = !1;
    $4c2dd1b68d143d96$var$ol = {}, $4c2dd1b68d143d96$var$Jg = !1;
    $4c2dd1b68d143d96$var$sl = {}, $4c2dd1b68d143d96$var$Xg = !1;
    $4c2dd1b68d143d96$var$al = {}, $4c2dd1b68d143d96$var$Zg = !1;
    $4c2dd1b68d143d96$var$ul = {}, $4c2dd1b68d143d96$var$eb = !1;
    $4c2dd1b68d143d96$var$ll = {}, $4c2dd1b68d143d96$var$tb = !1;
    $4c2dd1b68d143d96$var$cl = {}, $4c2dd1b68d143d96$var$rb = !1;
    $4c2dd1b68d143d96$var$fl = {}, $4c2dd1b68d143d96$var$nb = !1;
    $4c2dd1b68d143d96$var$wi = {}, $4c2dd1b68d143d96$var$ib = !1;
    $4c2dd1b68d143d96$var$hl = {}, $4c2dd1b68d143d96$var$ob = !1;
});
function $4c2dd1b68d143d96$var$wl(t) {
    throw new Error("Node.js process " + t + " is not supported by JSPM core outside of Node.js");
}
function $4c2dd1b68d143d96$var$hI() {
    !$4c2dd1b68d143d96$var$En || !$4c2dd1b68d143d96$var$$r || ($4c2dd1b68d143d96$var$En = !1, $4c2dd1b68d143d96$var$$r.length ? $4c2dd1b68d143d96$var$zt = $4c2dd1b68d143d96$var$$r.concat($4c2dd1b68d143d96$var$zt) : $4c2dd1b68d143d96$var$Ko = -1, $4c2dd1b68d143d96$var$zt.length && $4c2dd1b68d143d96$var$cb());
}
function $4c2dd1b68d143d96$var$cb() {
    if (!$4c2dd1b68d143d96$var$En) {
        var t = setTimeout($4c2dd1b68d143d96$var$hI, 0);
        $4c2dd1b68d143d96$var$En = !0;
        for(var e = $4c2dd1b68d143d96$var$zt.length; e;){
            for($4c2dd1b68d143d96$var$$r = $4c2dd1b68d143d96$var$zt, $4c2dd1b68d143d96$var$zt = []; ++$4c2dd1b68d143d96$var$Ko < e;)$4c2dd1b68d143d96$var$$r && $4c2dd1b68d143d96$var$$r[$4c2dd1b68d143d96$var$Ko].run();
            $4c2dd1b68d143d96$var$Ko = -1, e = $4c2dd1b68d143d96$var$zt.length;
        }
        $4c2dd1b68d143d96$var$$r = null, $4c2dd1b68d143d96$var$En = !1, clearTimeout(t);
    }
}
function $4c2dd1b68d143d96$var$dI(t) {
    var e = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
    $4c2dd1b68d143d96$var$zt.push(new $4c2dd1b68d143d96$var$fb(t, e)), $4c2dd1b68d143d96$var$zt.length === 1 && !$4c2dd1b68d143d96$var$En && setTimeout($4c2dd1b68d143d96$var$cb, 0);
}
function $4c2dd1b68d143d96$var$fb(t, e) {
    this.fun = t, this.array = e;
}
function $4c2dd1b68d143d96$var$We() {}
function $4c2dd1b68d143d96$var$RI(t) {
    $4c2dd1b68d143d96$var$wl("_linkedBinding");
}
function $4c2dd1b68d143d96$var$MI(t) {
    $4c2dd1b68d143d96$var$wl("dlopen");
}
function $4c2dd1b68d143d96$var$NI() {
    return [];
}
function $4c2dd1b68d143d96$var$qI() {
    return [];
}
function $4c2dd1b68d143d96$var$VI(t, e) {
    if (!t) throw new Error(e || "assertion error");
}
function $4c2dd1b68d143d96$var$QI() {
    return !1;
}
function $4c2dd1b68d143d96$var$hx() {
    return $4c2dd1b68d143d96$var$dr.now() / 1e3;
}
function $4c2dd1b68d143d96$var$bl(t) {
    var e = Math.floor((Date.now() - $4c2dd1b68d143d96$var$dr.now()) * .001), r = $4c2dd1b68d143d96$var$dr.now() * .001, n = Math.floor(r) + e, i = Math.floor(r % 1 * 1e9);
    return t && (n = n - t[0], i = i - t[1], i < 0 && (n--, i += $4c2dd1b68d143d96$var$gl)), [
        n,
        i
    ];
}
function $4c2dd1b68d143d96$var$pr() {
    return $4c2dd1b68d143d96$var$_l;
}
function $4c2dd1b68d143d96$var$Ix(t) {
    return [];
}
var $4c2dd1b68d143d96$var$zt, $4c2dd1b68d143d96$var$En, $4c2dd1b68d143d96$var$$r, $4c2dd1b68d143d96$var$Ko, $4c2dd1b68d143d96$var$pI, $4c2dd1b68d143d96$var$yI, $4c2dd1b68d143d96$var$gI, $4c2dd1b68d143d96$var$bI, $4c2dd1b68d143d96$var$wI, $4c2dd1b68d143d96$var$mI, $4c2dd1b68d143d96$var$_I, $4c2dd1b68d143d96$var$vI, $4c2dd1b68d143d96$var$SI, $4c2dd1b68d143d96$var$EI, $4c2dd1b68d143d96$var$AI, $4c2dd1b68d143d96$var$II, $4c2dd1b68d143d96$var$xI, $4c2dd1b68d143d96$var$TI, $4c2dd1b68d143d96$var$PI, $4c2dd1b68d143d96$var$OI, $4c2dd1b68d143d96$var$kI, $4c2dd1b68d143d96$var$CI, $4c2dd1b68d143d96$var$BI, $4c2dd1b68d143d96$var$LI, $4c2dd1b68d143d96$var$UI, $4c2dd1b68d143d96$var$ml, $4c2dd1b68d143d96$var$DI, $4c2dd1b68d143d96$var$jI, $4c2dd1b68d143d96$var$FI, $4c2dd1b68d143d96$var$WI, $4c2dd1b68d143d96$var$$I, $4c2dd1b68d143d96$var$HI, $4c2dd1b68d143d96$var$GI, $4c2dd1b68d143d96$var$zI, $4c2dd1b68d143d96$var$KI, $4c2dd1b68d143d96$var$YI, $4c2dd1b68d143d96$var$JI, $4c2dd1b68d143d96$var$XI, $4c2dd1b68d143d96$var$ZI, $4c2dd1b68d143d96$var$ex, $4c2dd1b68d143d96$var$tx, $4c2dd1b68d143d96$var$rx, $4c2dd1b68d143d96$var$nx, $4c2dd1b68d143d96$var$ix, $4c2dd1b68d143d96$var$ox, $4c2dd1b68d143d96$var$sx, $4c2dd1b68d143d96$var$ax, $4c2dd1b68d143d96$var$ux, $4c2dd1b68d143d96$var$lx, $4c2dd1b68d143d96$var$cx, $4c2dd1b68d143d96$var$fx, $4c2dd1b68d143d96$var$dr, $4c2dd1b68d143d96$var$yl, $4c2dd1b68d143d96$var$gl, $4c2dd1b68d143d96$var$dx, $4c2dd1b68d143d96$var$px, $4c2dd1b68d143d96$var$yx, $4c2dd1b68d143d96$var$gx, $4c2dd1b68d143d96$var$bx, $4c2dd1b68d143d96$var$mx, $4c2dd1b68d143d96$var$_x, $4c2dd1b68d143d96$var$vx, $4c2dd1b68d143d96$var$Sx, $4c2dd1b68d143d96$var$Ex, $4c2dd1b68d143d96$var$Ax, $4c2dd1b68d143d96$var$_l, $4c2dd1b68d143d96$var$vl = $4c2dd1b68d143d96$var$ze(()=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    $4c2dd1b68d143d96$var$zt = [], $4c2dd1b68d143d96$var$En = !1, $4c2dd1b68d143d96$var$Ko = -1;
    $4c2dd1b68d143d96$var$fb.prototype.run = function() {
        this.fun.apply(null, this.array);
    };
    $4c2dd1b68d143d96$var$pI = "browser", $4c2dd1b68d143d96$var$yI = "x64", $4c2dd1b68d143d96$var$gI = "browser", $4c2dd1b68d143d96$var$bI = {
        PATH: "/usr/bin",
        LANG: navigator.language + ".UTF-8",
        PWD: "/",
        HOME: "/home",
        TMP: "/tmp"
    }, $4c2dd1b68d143d96$var$wI = [
        "/usr/bin/node"
    ], $4c2dd1b68d143d96$var$mI = [], $4c2dd1b68d143d96$var$_I = "v16.8.0", $4c2dd1b68d143d96$var$vI = {}, $4c2dd1b68d143d96$var$SI = function(t, e) {
        console.warn((e ? e + ": " : "") + t);
    }, $4c2dd1b68d143d96$var$EI = function(t) {
        $4c2dd1b68d143d96$var$wl("binding");
    }, $4c2dd1b68d143d96$var$AI = function(t) {
        return 0;
    }, $4c2dd1b68d143d96$var$II = function() {
        return "/";
    }, $4c2dd1b68d143d96$var$xI = function(t) {}, $4c2dd1b68d143d96$var$TI = {
        name: "node",
        sourceUrl: "",
        headersUrl: "",
        libUrl: ""
    };
    $4c2dd1b68d143d96$var$PI = $4c2dd1b68d143d96$var$We, $4c2dd1b68d143d96$var$OI = [];
    $4c2dd1b68d143d96$var$kI = {}, $4c2dd1b68d143d96$var$CI = !1, $4c2dd1b68d143d96$var$BI = {};
    $4c2dd1b68d143d96$var$LI = $4c2dd1b68d143d96$var$We, $4c2dd1b68d143d96$var$UI = $4c2dd1b68d143d96$var$We, $4c2dd1b68d143d96$var$ml = function() {
        return {};
    }, $4c2dd1b68d143d96$var$DI = $4c2dd1b68d143d96$var$ml, $4c2dd1b68d143d96$var$jI = $4c2dd1b68d143d96$var$ml, $4c2dd1b68d143d96$var$FI = $4c2dd1b68d143d96$var$We, $4c2dd1b68d143d96$var$WI = $4c2dd1b68d143d96$var$We, $4c2dd1b68d143d96$var$$I = $4c2dd1b68d143d96$var$We, $4c2dd1b68d143d96$var$HI = {};
    $4c2dd1b68d143d96$var$GI = {
        inspector: !1,
        debug: !1,
        uv: !1,
        ipv6: !1,
        tls_alpn: !1,
        tls_sni: !1,
        tls_ocsp: !1,
        tls: !1,
        cached_builtins: !0
    }, $4c2dd1b68d143d96$var$zI = $4c2dd1b68d143d96$var$We, $4c2dd1b68d143d96$var$KI = $4c2dd1b68d143d96$var$We;
    $4c2dd1b68d143d96$var$YI = $4c2dd1b68d143d96$var$We, $4c2dd1b68d143d96$var$JI = $4c2dd1b68d143d96$var$We, $4c2dd1b68d143d96$var$XI = $4c2dd1b68d143d96$var$We, $4c2dd1b68d143d96$var$ZI = $4c2dd1b68d143d96$var$We, $4c2dd1b68d143d96$var$ex = $4c2dd1b68d143d96$var$We, $4c2dd1b68d143d96$var$tx = void 0, $4c2dd1b68d143d96$var$rx = void 0, $4c2dd1b68d143d96$var$nx = void 0, $4c2dd1b68d143d96$var$ix = $4c2dd1b68d143d96$var$We, $4c2dd1b68d143d96$var$ox = 2, $4c2dd1b68d143d96$var$sx = 1, $4c2dd1b68d143d96$var$ax = "/bin/usr/node", $4c2dd1b68d143d96$var$ux = 9229, $4c2dd1b68d143d96$var$lx = "node", $4c2dd1b68d143d96$var$cx = [], $4c2dd1b68d143d96$var$fx = $4c2dd1b68d143d96$var$We, $4c2dd1b68d143d96$var$dr = {
        now: typeof performance < "u" ? performance.now.bind(performance) : void 0,
        timing: typeof performance < "u" ? performance.timing : void 0
    };
    $4c2dd1b68d143d96$var$dr.now === void 0 && ($4c2dd1b68d143d96$var$yl = Date.now(), $4c2dd1b68d143d96$var$dr.timing && $4c2dd1b68d143d96$var$dr.timing.navigationStart && ($4c2dd1b68d143d96$var$yl = $4c2dd1b68d143d96$var$dr.timing.navigationStart), $4c2dd1b68d143d96$var$dr.now = ()=>Date.now() - $4c2dd1b68d143d96$var$yl);
    $4c2dd1b68d143d96$var$gl = 1e9;
    $4c2dd1b68d143d96$var$bl.bigint = function(t) {
        var e = $4c2dd1b68d143d96$var$bl(t);
        return typeof BigInt > "u" ? e[0] * $4c2dd1b68d143d96$var$gl + e[1] : BigInt(e[0] * $4c2dd1b68d143d96$var$gl) + BigInt(e[1]);
    };
    $4c2dd1b68d143d96$var$dx = 10, $4c2dd1b68d143d96$var$px = {}, $4c2dd1b68d143d96$var$yx = 0;
    $4c2dd1b68d143d96$var$gx = $4c2dd1b68d143d96$var$pr, $4c2dd1b68d143d96$var$bx = $4c2dd1b68d143d96$var$pr, $4c2dd1b68d143d96$var$mx = $4c2dd1b68d143d96$var$pr, $4c2dd1b68d143d96$var$_x = $4c2dd1b68d143d96$var$pr, $4c2dd1b68d143d96$var$vx = $4c2dd1b68d143d96$var$pr, $4c2dd1b68d143d96$var$Sx = $4c2dd1b68d143d96$var$We, $4c2dd1b68d143d96$var$Ex = $4c2dd1b68d143d96$var$pr, $4c2dd1b68d143d96$var$Ax = $4c2dd1b68d143d96$var$pr;
    $4c2dd1b68d143d96$var$_l = {
        version: $4c2dd1b68d143d96$var$_I,
        versions: $4c2dd1b68d143d96$var$vI,
        arch: $4c2dd1b68d143d96$var$yI,
        platform: $4c2dd1b68d143d96$var$gI,
        release: $4c2dd1b68d143d96$var$TI,
        _rawDebug: $4c2dd1b68d143d96$var$PI,
        moduleLoadList: $4c2dd1b68d143d96$var$OI,
        binding: $4c2dd1b68d143d96$var$EI,
        _linkedBinding: $4c2dd1b68d143d96$var$RI,
        _events: $4c2dd1b68d143d96$var$px,
        _eventsCount: $4c2dd1b68d143d96$var$yx,
        _maxListeners: $4c2dd1b68d143d96$var$dx,
        on: $4c2dd1b68d143d96$var$pr,
        addListener: $4c2dd1b68d143d96$var$gx,
        once: $4c2dd1b68d143d96$var$bx,
        off: $4c2dd1b68d143d96$var$mx,
        removeListener: $4c2dd1b68d143d96$var$_x,
        removeAllListeners: $4c2dd1b68d143d96$var$vx,
        emit: $4c2dd1b68d143d96$var$Sx,
        prependListener: $4c2dd1b68d143d96$var$Ex,
        prependOnceListener: $4c2dd1b68d143d96$var$Ax,
        listeners: $4c2dd1b68d143d96$var$Ix,
        domain: $4c2dd1b68d143d96$var$kI,
        _exiting: $4c2dd1b68d143d96$var$CI,
        config: $4c2dd1b68d143d96$var$BI,
        dlopen: $4c2dd1b68d143d96$var$MI,
        uptime: $4c2dd1b68d143d96$var$hx,
        _getActiveRequests: $4c2dd1b68d143d96$var$NI,
        _getActiveHandles: $4c2dd1b68d143d96$var$qI,
        reallyExit: $4c2dd1b68d143d96$var$LI,
        _kill: $4c2dd1b68d143d96$var$UI,
        cpuUsage: $4c2dd1b68d143d96$var$ml,
        resourceUsage: $4c2dd1b68d143d96$var$DI,
        memoryUsage: $4c2dd1b68d143d96$var$jI,
        kill: $4c2dd1b68d143d96$var$FI,
        exit: $4c2dd1b68d143d96$var$WI,
        openStdin: $4c2dd1b68d143d96$var$$I,
        allowedNodeEnvironmentFlags: $4c2dd1b68d143d96$var$HI,
        assert: $4c2dd1b68d143d96$var$VI,
        features: $4c2dd1b68d143d96$var$GI,
        _fatalExceptions: $4c2dd1b68d143d96$var$zI,
        setUncaughtExceptionCaptureCallback: $4c2dd1b68d143d96$var$KI,
        hasUncaughtExceptionCaptureCallback: $4c2dd1b68d143d96$var$QI,
        emitWarning: $4c2dd1b68d143d96$var$SI,
        nextTick: $4c2dd1b68d143d96$var$dI,
        _tickCallback: $4c2dd1b68d143d96$var$YI,
        _debugProcess: $4c2dd1b68d143d96$var$JI,
        _debugEnd: $4c2dd1b68d143d96$var$XI,
        _startProfilerIdleNotifier: $4c2dd1b68d143d96$var$ZI,
        _stopProfilerIdleNotifier: $4c2dd1b68d143d96$var$ex,
        stdout: $4c2dd1b68d143d96$var$tx,
        stdin: $4c2dd1b68d143d96$var$nx,
        stderr: $4c2dd1b68d143d96$var$rx,
        abort: $4c2dd1b68d143d96$var$ix,
        umask: $4c2dd1b68d143d96$var$AI,
        chdir: $4c2dd1b68d143d96$var$xI,
        cwd: $4c2dd1b68d143d96$var$II,
        env: $4c2dd1b68d143d96$var$bI,
        title: $4c2dd1b68d143d96$var$pI,
        argv: $4c2dd1b68d143d96$var$wI,
        execArgv: $4c2dd1b68d143d96$var$mI,
        pid: $4c2dd1b68d143d96$var$ox,
        ppid: $4c2dd1b68d143d96$var$sx,
        execPath: $4c2dd1b68d143d96$var$ax,
        debugPort: $4c2dd1b68d143d96$var$ux,
        hrtime: $4c2dd1b68d143d96$var$bl,
        argv0: $4c2dd1b68d143d96$var$lx,
        _preload_modules: $4c2dd1b68d143d96$var$cx,
        setSourceMapsEnabled: $4c2dd1b68d143d96$var$fx
    };
});
function $4c2dd1b68d143d96$var$xx() {
    if ($4c2dd1b68d143d96$var$hb) return $4c2dd1b68d143d96$var$Sl;
    $4c2dd1b68d143d96$var$hb = !0;
    var t = $4c2dd1b68d143d96$var$_l;
    function e(s) {
        if (typeof s != "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(s));
    }
    function r(s, o) {
        for(var a = "", c = 0, f = -1, h = 0, d, w = 0; w <= s.length; ++w){
            if (w < s.length) d = s.charCodeAt(w);
            else {
                if (d === 47) break;
                d = 47;
            }
            if (d === 47) {
                if (!(f === w - 1 || h === 1)) {
                    if (f !== w - 1 && h === 2) {
                        if (a.length < 2 || c !== 2 || a.charCodeAt(a.length - 1) !== 46 || a.charCodeAt(a.length - 2) !== 46) {
                            if (a.length > 2) {
                                var y = a.lastIndexOf("/");
                                if (y !== a.length - 1) {
                                    y === -1 ? (a = "", c = 0) : (a = a.slice(0, y), c = a.length - 1 - a.lastIndexOf("/")), f = w, h = 0;
                                    continue;
                                }
                            } else if (a.length === 2 || a.length === 1) {
                                a = "", c = 0, f = w, h = 0;
                                continue;
                            }
                        }
                        o && (a.length > 0 ? a += "/.." : a = "..", c = 2);
                    } else a.length > 0 ? a += "/" + s.slice(f + 1, w) : a = s.slice(f + 1, w), c = w - f - 1;
                }
                f = w, h = 0;
            } else d === 46 && h !== -1 ? ++h : h = -1;
        }
        return a;
    }
    function n(s, o) {
        var a = o.dir || o.root, c = o.base || (o.name || "") + (o.ext || "");
        return a ? a === o.root ? a + c : a + s + c : c;
    }
    var i = {
        resolve: function() {
            for(var o = "", a = !1, c, f = arguments.length - 1; f >= -1 && !a; f--){
                var h;
                f >= 0 ? h = arguments[f] : (c === void 0 && (c = t.cwd()), h = c), e(h), h.length !== 0 && (o = h + "/" + o, a = h.charCodeAt(0) === 47);
            }
            return o = r(o, !a), a ? o.length > 0 ? "/" + o : "/" : o.length > 0 ? o : ".";
        },
        normalize: function(o) {
            if (e(o), o.length === 0) return ".";
            var a = o.charCodeAt(0) === 47, c = o.charCodeAt(o.length - 1) === 47;
            return o = r(o, !a), o.length === 0 && !a && (o = "."), o.length > 0 && c && (o += "/"), a ? "/" + o : o;
        },
        isAbsolute: function(o) {
            return e(o), o.length > 0 && o.charCodeAt(0) === 47;
        },
        join: function() {
            if (arguments.length === 0) return ".";
            for(var o, a = 0; a < arguments.length; ++a){
                var c = arguments[a];
                e(c), c.length > 0 && (o === void 0 ? o = c : o += "/" + c);
            }
            return o === void 0 ? "." : i.normalize(o);
        },
        relative: function(o, a) {
            if (e(o), e(a), o === a || (o = i.resolve(o), a = i.resolve(a), o === a)) return "";
            for(var c = 1; c < o.length && o.charCodeAt(c) === 47; ++c);
            for(var f = o.length, h = f - c, d = 1; d < a.length && a.charCodeAt(d) === 47; ++d);
            for(var w = a.length, y = w - d, P = h < y ? h : y, E = -1, b = 0; b <= P; ++b){
                if (b === P) {
                    if (y > P) {
                        if (a.charCodeAt(d + b) === 47) return a.slice(d + b + 1);
                        if (b === 0) return a.slice(d + b);
                    } else h > P && (o.charCodeAt(c + b) === 47 ? E = b : b === 0 && (E = 0));
                    break;
                }
                var m = o.charCodeAt(c + b), v = a.charCodeAt(d + b);
                if (m !== v) break;
                m === 47 && (E = b);
            }
            var R = "";
            for(b = c + E + 1; b <= f; ++b)(b === f || o.charCodeAt(b) === 47) && (R.length === 0 ? R += ".." : R += "/..");
            return R.length > 0 ? R + a.slice(d + E) : (d += E, a.charCodeAt(d) === 47 && ++d, a.slice(d));
        },
        _makeLong: function(o) {
            return o;
        },
        dirname: function(o) {
            if (e(o), o.length === 0) return ".";
            for(var a = o.charCodeAt(0), c = a === 47, f = -1, h = !0, d = o.length - 1; d >= 1; --d)if (a = o.charCodeAt(d), a === 47) {
                if (!h) {
                    f = d;
                    break;
                }
            } else h = !1;
            return f === -1 ? c ? "/" : "." : c && f === 1 ? "//" : o.slice(0, f);
        },
        basename: function(o, a) {
            if (a !== void 0 && typeof a != "string") throw new TypeError('"ext" argument must be a string');
            e(o);
            var c = 0, f = -1, h = !0, d;
            if (a !== void 0 && a.length > 0 && a.length <= o.length) {
                if (a.length === o.length && a === o) return "";
                var w = a.length - 1, y = -1;
                for(d = o.length - 1; d >= 0; --d){
                    var P = o.charCodeAt(d);
                    if (P === 47) {
                        if (!h) {
                            c = d + 1;
                            break;
                        }
                    } else y === -1 && (h = !1, y = d + 1), w >= 0 && (P === a.charCodeAt(w) ? --w === -1 && (f = d) : (w = -1, f = y));
                }
                return c === f ? f = y : f === -1 && (f = o.length), o.slice(c, f);
            } else {
                for(d = o.length - 1; d >= 0; --d)if (o.charCodeAt(d) === 47) {
                    if (!h) {
                        c = d + 1;
                        break;
                    }
                } else f === -1 && (h = !1, f = d + 1);
                return f === -1 ? "" : o.slice(c, f);
            }
        },
        extname: function(o) {
            e(o);
            for(var a = -1, c = 0, f = -1, h = !0, d = 0, w = o.length - 1; w >= 0; --w){
                var y = o.charCodeAt(w);
                if (y === 47) {
                    if (!h) {
                        c = w + 1;
                        break;
                    }
                    continue;
                }
                f === -1 && (h = !1, f = w + 1), y === 46 ? a === -1 ? a = w : d !== 1 && (d = 1) : a !== -1 && (d = -1);
            }
            return a === -1 || f === -1 || d === 0 || d === 1 && a === f - 1 && a === c + 1 ? "" : o.slice(a, f);
        },
        format: function(o) {
            if (o === null || typeof o != "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof o);
            return n("/", o);
        },
        parse: function(o) {
            e(o);
            var a = {
                root: "",
                dir: "",
                base: "",
                ext: "",
                name: ""
            };
            if (o.length === 0) return a;
            var c = o.charCodeAt(0), f = c === 47, h;
            f ? (a.root = "/", h = 1) : h = 0;
            for(var d = -1, w = 0, y = -1, P = !0, E = o.length - 1, b = 0; E >= h; --E){
                if (c = o.charCodeAt(E), c === 47) {
                    if (!P) {
                        w = E + 1;
                        break;
                    }
                    continue;
                }
                y === -1 && (P = !1, y = E + 1), c === 46 ? d === -1 ? d = E : b !== 1 && (b = 1) : d !== -1 && (b = -1);
            }
            return d === -1 || y === -1 || b === 0 || b === 1 && d === y - 1 && d === w + 1 ? y !== -1 && (w === 0 && f ? a.base = a.name = o.slice(1, y) : a.base = a.name = o.slice(w, y)) : (w === 0 && f ? (a.name = o.slice(1, d), a.base = o.slice(1, y)) : (a.name = o.slice(w, d), a.base = o.slice(w, y)), a.ext = o.slice(d, y)), w > 0 ? a.dir = o.slice(0, w - 1) : f && (a.dir = "/"), a;
        },
        sep: "/",
        delimiter: ":",
        win32: null,
        posix: null
    };
    return i.posix = i, $4c2dd1b68d143d96$var$Sl = i, $4c2dd1b68d143d96$var$Sl;
}
var $4c2dd1b68d143d96$var$Sl, $4c2dd1b68d143d96$var$hb, $4c2dd1b68d143d96$var$El, $4c2dd1b68d143d96$var$db = $4c2dd1b68d143d96$var$ze(()=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    $4c2dd1b68d143d96$var$vl();
    $4c2dd1b68d143d96$var$Sl = {}, $4c2dd1b68d143d96$var$hb = !1;
    $4c2dd1b68d143d96$var$El = $4c2dd1b68d143d96$var$xx();
});
var $4c2dd1b68d143d96$var$Ib = {};
$4c2dd1b68d143d96$var$Kr($4c2dd1b68d143d96$var$Ib, {
    URL: ()=>$4c2dd1b68d143d96$var$jx,
    Url: ()=>$4c2dd1b68d143d96$var$Nx,
    default: ()=>$4c2dd1b68d143d96$var$Ge,
    fileURLToPath: ()=>$4c2dd1b68d143d96$var$Eb,
    format: ()=>$4c2dd1b68d143d96$var$qx,
    parse: ()=>$4c2dd1b68d143d96$var$Dx,
    pathToFileURL: ()=>$4c2dd1b68d143d96$var$Ab,
    resolve: ()=>$4c2dd1b68d143d96$var$Lx,
    resolveObject: ()=>$4c2dd1b68d143d96$var$Ux
});
function $4c2dd1b68d143d96$var$Px() {
    if ($4c2dd1b68d143d96$var$pb) return $4c2dd1b68d143d96$var$Al;
    $4c2dd1b68d143d96$var$pb = !0;
    var t = typeof Map == "function" && Map.prototype, e = Object.getOwnPropertyDescriptor && t ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, r = t && e && typeof e.get == "function" ? e.get : null, n = t && Map.prototype.forEach, i = typeof Set == "function" && Set.prototype, s = Object.getOwnPropertyDescriptor && i ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, o = i && s && typeof s.get == "function" ? s.get : null, a = i && Set.prototype.forEach, c = typeof WeakMap == "function" && WeakMap.prototype, f = c ? WeakMap.prototype.has : null, h = typeof WeakSet == "function" && WeakSet.prototype, d = h ? WeakSet.prototype.has : null, w = typeof WeakRef == "function" && WeakRef.prototype, y = w ? WeakRef.prototype.deref : null, P = Boolean.prototype.valueOf, E = Object.prototype.toString, b = Function.prototype.toString, m = String.prototype.match, v = String.prototype.slice, R = String.prototype.replace, T = String.prototype.toUpperCase, g = String.prototype.toLowerCase, O = RegExp.prototype.test, _ = Array.prototype.concat, q = Array.prototype.join, $ = Array.prototype.slice, j = Math.floor, J = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, W = Object.getOwnPropertySymbols, H = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, G = typeof Symbol == "function" && typeof Symbol.iterator == "object", K = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === G || !0) ? Symbol.toStringTag : null, X = Object.prototype.propertyIsEnumerable, Q = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(k) {
        return k.__proto__;
    } : null);
    function V(k, B) {
        if (k === 1 / 0 || k === -1 / 0 || k !== k || k && k > -1000 && k < 1e3 || O.call(/e/, B)) return B;
        var re = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
        if (typeof k == "number") {
            var ie = k < 0 ? -j(-k) : j(k);
            if (ie !== k) {
                var oe = String(ie), ce = v.call(B, oe.length + 1);
                return R.call(oe, re, "$&_") + "." + R.call(R.call(ce, /([0-9]{3})/g, "$&_"), /_$/, "");
            }
        }
        return R.call(B, re, "$&_");
    }
    var te = $4c2dd1b68d143d96$var$Tx, Y = te.custom, ee = Oe(Y) ? Y : null;
    $4c2dd1b68d143d96$var$Al = function k(B, re, ie, oe) {
        var ce = re || {};
        if (Re(ce, "quoteStyle") && ce.quoteStyle !== "single" && ce.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
        if (Re(ce, "maxStringLength") && (typeof ce.maxStringLength == "number" ? ce.maxStringLength < 0 && ce.maxStringLength !== 1 / 0 : ce.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
        var Qt = Re(ce, "customInspect") ? ce.customInspect : !0;
        if (typeof Qt != "boolean" && Qt !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
        if (Re(ce, "indent") && ce.indent !== null && ce.indent !== "	" && !(parseInt(ce.indent, 10) === ce.indent && ce.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
        if (Re(ce, "numericSeparator") && typeof ce.numericSeparator != "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
        var br = ce.numericSeparator;
        if (typeof B > "u") return "undefined";
        if (B === null) return "null";
        if (typeof B == "boolean") return B ? "true" : "false";
        if (typeof B == "string") return at(B, ce);
        if (typeof B == "number") {
            if (B === 0) return 1 / 0 / B > 0 ? "0" : "-0";
            var Ye = String(B);
            return br ? V(B, Ye) : Ye;
        }
        if (typeof B == "bigint") {
            var Yt = String(B) + "n";
            return br ? V(B, Yt) : Yt;
        }
        var es = typeof ce.depth > "u" ? 5 : ce.depth;
        if (typeof ie > "u" && (ie = 0), ie >= es && es > 0 && typeof B == "object") return ne(B) ? "[Array]" : "[Object]";
        var Gr = C(ce, ie);
        if (typeof oe > "u") oe = [];
        else if (Bt(oe, B) >= 0) return "[Circular]";
        function ut(zr, Ti, Qb) {
            if (Ti && (oe = $.call(oe), oe.push(Ti)), Qb) {
                var oc = {
                    depth: ce.depth
                };
                return Re(ce, "quoteStyle") && (oc.quoteStyle = ce.quoteStyle), k(zr, oc, ie + 1, oe);
            }
            return k(zr, ce, ie + 1, oe);
        }
        if (typeof B == "function" && !be(B)) {
            var Xl = Ct(B), Zl = F(B, ut);
            return "[Function" + (Xl ? ": " + Xl : " (anonymous)") + "]" + (Zl.length > 0 ? " { " + q.call(Zl, ", ") + " }" : "");
        }
        if (Oe(B)) {
            var ec = G ? R.call(String(B), /^(Symbol\(.*\))_[^)]*$/, "$1") : H.call(B);
            return typeof B == "object" && !G ? p(ec) : ec;
        }
        if (Xo(B)) {
            for(var Pn = "<" + g.call(String(B.nodeName)), ts = B.attributes || [], xi = 0; xi < ts.length; xi++)Pn += " " + ts[xi].name + "=" + pe(Z(ts[xi].value), "double", ce);
            return Pn += ">", B.childNodes && B.childNodes.length && (Pn += "..."), Pn += "</" + g.call(String(B.nodeName)) + ">", Pn;
        }
        if (ne(B)) {
            if (B.length === 0) return "[]";
            var rs = F(B, ut);
            return Gr && !S(rs) ? "[" + N(rs, Gr) + "]" : "[ " + q.call(rs, ", ") + " ]";
        }
        if (ye(B)) {
            var ns = F(B, ut);
            return !("cause" in Error.prototype) && "cause" in B && !X.call(B, "cause") ? "{ [" + String(B) + "] " + q.call(_.call("[cause]: " + ut(B.cause), ns), ", ") + " }" : ns.length === 0 ? "[" + String(B) + "]" : "{ [" + String(B) + "] " + q.call(ns, ", ") + " }";
        }
        if (typeof B == "object" && Qt) {
            if (ee && typeof B[ee] == "function" && te) return te(B, {
                depth: es - ie
            });
            if (Qt !== "symbol" && typeof B.inspect == "function") return B.inspect();
        }
        if (xn(B)) {
            var tc = [];
            return n && n.call(B, function(zr, Ti) {
                tc.push(ut(Ti, B, !0) + " => " + ut(zr, B));
            }), l("Map", r.call(B), tc, Gr);
        }
        if (Ze(B)) {
            var rc = [];
            return a && a.call(B, function(zr) {
                rc.push(ut(zr, B));
            }), l("Set", o.call(B), rc, Gr);
        }
        if (Ii(B)) return u("WeakMap");
        if (Tn(B)) return u("WeakSet");
        if (Vr(B)) return u("WeakRef");
        if (_e(B)) return p(ut(Number(B)));
        if (xe(B)) return p(ut(J.call(B)));
        if (ve(B)) return p(P.call(B));
        if (Ae(B)) return p(ut(String(B)));
        if (typeof window < "u" && B === window) return "{ [object Window] }";
        if (typeof globalThis < "u" && B === globalThis || typeof $4c2dd1b68d143d96$var$Il < "u" && B === $4c2dd1b68d143d96$var$Il) return "{ [object globalThis] }";
        if (!fe(B) && !be(B)) {
            var is = F(B, ut), nc = Q ? Q(B) === Object.prototype : B instanceof Object || B.constructor === Object, os = B instanceof Object ? "" : "null prototype", ic = !nc && K && Object(B) === B && K in B ? v.call(Ne(B), 8, -1) : os ? "Object" : "", Kb = nc || typeof B.constructor != "function" ? "" : B.constructor.name ? B.constructor.name + " " : "", ss = Kb + (ic || os ? "[" + q.call(_.call([], ic || [], os || []), ": ") + "] " : "");
            return is.length === 0 ? ss + "{}" : Gr ? ss + "{" + N(is, Gr) + "}" : ss + "{ " + q.call(is, ", ") + " }";
        }
        return String(B);
    };
    function pe(k, B, re) {
        var ie = (re.quoteStyle || B) === "double" ? '"' : "'";
        return ie + k + ie;
    }
    function Z(k) {
        return R.call(String(k), /"/g, "&quot;");
    }
    function ne(k) {
        return Ne(k) === "[object Array]" && (!K || !(typeof k == "object" && K in k));
    }
    function fe(k) {
        return Ne(k) === "[object Date]" && (!K || !(typeof k == "object" && K in k));
    }
    function be(k) {
        return Ne(k) === "[object RegExp]" && (!K || !(typeof k == "object" && K in k));
    }
    function ye(k) {
        return Ne(k) === "[object Error]" && (!K || !(typeof k == "object" && K in k));
    }
    function Ae(k) {
        return Ne(k) === "[object String]" && (!K || !(typeof k == "object" && K in k));
    }
    function _e(k) {
        return Ne(k) === "[object Number]" && (!K || !(typeof k == "object" && K in k));
    }
    function ve(k) {
        return Ne(k) === "[object Boolean]" && (!K || !(typeof k == "object" && K in k));
    }
    function Oe(k) {
        if (G) return k && typeof k == "object" && k instanceof Symbol;
        if (typeof k == "symbol") return !0;
        if (!k || typeof k != "object" || !H) return !1;
        try {
            return H.call(k), !0;
        } catch  {}
        return !1;
    }
    function xe(k) {
        if (!k || typeof k != "object" || !J) return !1;
        try {
            return J.call(k), !0;
        } catch  {}
        return !1;
    }
    var st = Object.prototype.hasOwnProperty || function(k) {
        return k in (this || $4c2dd1b68d143d96$var$Il);
    };
    function Re(k, B) {
        return st.call(k, B);
    }
    function Ne(k) {
        return E.call(k);
    }
    function Ct(k) {
        if (k.name) return k.name;
        var B = m.call(b.call(k), /^function\s*([\w$]+)/);
        return B ? B[1] : null;
    }
    function Bt(k, B) {
        if (k.indexOf) return k.indexOf(B);
        for(var re = 0, ie = k.length; re < ie; re++)if (k[re] === B) return re;
        return -1;
    }
    function xn(k) {
        if (!r || !k || typeof k != "object") return !1;
        try {
            r.call(k);
            try {
                o.call(k);
            } catch  {
                return !0;
            }
            return k instanceof Map;
        } catch  {}
        return !1;
    }
    function Ii(k) {
        if (!f || !k || typeof k != "object") return !1;
        try {
            f.call(k, f);
            try {
                d.call(k, d);
            } catch  {
                return !0;
            }
            return k instanceof WeakMap;
        } catch  {}
        return !1;
    }
    function Vr(k) {
        if (!y || !k || typeof k != "object") return !1;
        try {
            return y.call(k), !0;
        } catch  {}
        return !1;
    }
    function Ze(k) {
        if (!o || !k || typeof k != "object") return !1;
        try {
            o.call(k);
            try {
                r.call(k);
            } catch  {
                return !0;
            }
            return k instanceof Set;
        } catch  {}
        return !1;
    }
    function Tn(k) {
        if (!d || !k || typeof k != "object") return !1;
        try {
            d.call(k, d);
            try {
                f.call(k, f);
            } catch  {
                return !0;
            }
            return k instanceof WeakSet;
        } catch  {}
        return !1;
    }
    function Xo(k) {
        return !k || typeof k != "object" ? !1 : typeof HTMLElement < "u" && k instanceof HTMLElement ? !0 : typeof k.nodeName == "string" && typeof k.getAttribute == "function";
    }
    function at(k, B) {
        if (k.length > B.maxStringLength) {
            var re = k.length - B.maxStringLength, ie = "... " + re + " more character" + (re > 1 ? "s" : "");
            return at(v.call(k, 0, B.maxStringLength), B) + ie;
        }
        var oe = R.call(R.call(k, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, Zo);
        return pe(oe, "single", B);
    }
    function Zo(k) {
        var B = k.charCodeAt(0), re = {
            8: "b",
            9: "t",
            10: "n",
            12: "f",
            13: "r"
        }[B];
        return re ? "\\" + re : "\\x" + (B < 16 ? "0" : "") + T.call(B.toString(16));
    }
    function p(k) {
        return "Object(" + k + ")";
    }
    function u(k) {
        return k + " { ? }";
    }
    function l(k, B, re, ie) {
        var oe = ie ? N(re, ie) : q.call(re, ", ");
        return k + " (" + B + ") {" + oe + "}";
    }
    function S(k) {
        for(var B = 0; B < k.length; B++)if (Bt(k[B], `
`) >= 0) return !1;
        return !0;
    }
    function C(k, B) {
        var re;
        if (k.indent === "	") re = "	";
        else if (typeof k.indent == "number" && k.indent > 0) re = q.call(Array(k.indent + 1), " ");
        else return null;
        return {
            base: re,
            prev: q.call(Array(B + 1), re)
        };
    }
    function N(k, B) {
        if (k.length === 0) return "";
        var re = `
` + B.prev + B.base;
        return re + q.call(k, "," + re) + `
` + B.prev;
    }
    function F(k, B) {
        var re = ne(k), ie = [];
        if (re) {
            ie.length = k.length;
            for(var oe = 0; oe < k.length; oe++)ie[oe] = Re(k, oe) ? B(k[oe], k) : "";
        }
        var ce = typeof W == "function" ? W(k) : [], Qt;
        if (G) {
            Qt = {};
            for(var br = 0; br < ce.length; br++)Qt["$" + ce[br]] = ce[br];
        }
        for(var Ye in k)Re(k, Ye) && (re && String(Number(Ye)) === Ye && Ye < k.length || G && Qt["$" + Ye] instanceof Symbol || (O.call(/[^\w$]/, Ye) ? ie.push(B(Ye, k) + ": " + B(k[Ye], k)) : ie.push(Ye + ": " + B(k[Ye], k))));
        if (typeof W == "function") for(var Yt = 0; Yt < ce.length; Yt++)X.call(k, ce[Yt]) && ie.push("[" + B(ce[Yt]) + "]: " + B(k[ce[Yt]], k));
        return ie;
    }
    return $4c2dd1b68d143d96$var$Al;
}
function $4c2dd1b68d143d96$var$Ox() {
    if ($4c2dd1b68d143d96$var$yb) return $4c2dd1b68d143d96$var$xl;
    $4c2dd1b68d143d96$var$yb = !0;
    var t = $4c2dd1b68d143d96$var$Wr(), e = $4c2dd1b68d143d96$var$ub(), r = $4c2dd1b68d143d96$var$Px(), n = $4c2dd1b68d143d96$var$Sn(), i = t("%WeakMap%", !0), s = t("%Map%", !0), o = e("WeakMap.prototype.get", !0), a = e("WeakMap.prototype.set", !0), c = e("WeakMap.prototype.has", !0), f = e("Map.prototype.get", !0), h = e("Map.prototype.set", !0), d = e("Map.prototype.has", !0), w = function(b, m) {
        for(var v = b, R; (R = v.next) !== null; v = R)if (R.key === m) return v.next = R.next, R.next = b.next, b.next = R, R;
    }, y = function(b, m) {
        var v = w(b, m);
        return v && v.value;
    }, P = function(b, m, v) {
        var R = w(b, m);
        R ? R.value = v : b.next = {
            key: m,
            next: b.next,
            value: v
        };
    }, E = function(b, m) {
        return !!w(b, m);
    };
    return $4c2dd1b68d143d96$var$xl = function() {
        var m, v, R, T = {
            assert: function(g) {
                if (!T.has(g)) throw new n("Side channel does not contain " + r(g));
            },
            get: function(g) {
                if (i && g && (typeof g == "object" || typeof g == "function")) {
                    if (m) return o(m, g);
                } else if (s) {
                    if (v) return f(v, g);
                } else if (R) return y(R, g);
            },
            has: function(g) {
                if (i && g && (typeof g == "object" || typeof g == "function")) {
                    if (m) return c(m, g);
                } else if (s) {
                    if (v) return d(v, g);
                } else if (R) return E(R, g);
                return !1;
            },
            set: function(g, O) {
                i && g && (typeof g == "object" || typeof g == "function") ? (m || (m = new i), a(m, g, O)) : s ? (v || (v = new s), h(v, g, O)) : (R || (R = {
                    key: {},
                    next: null
                }), P(R, g, O));
            }
        };
        return T;
    }, $4c2dd1b68d143d96$var$xl;
}
function $4c2dd1b68d143d96$var$Bl() {
    if ($4c2dd1b68d143d96$var$gb) return $4c2dd1b68d143d96$var$Tl;
    $4c2dd1b68d143d96$var$gb = !0;
    var t = String.prototype.replace, e = /%20/g, r = {
        RFC1738: "RFC1738",
        RFC3986: "RFC3986"
    };
    return $4c2dd1b68d143d96$var$Tl = {
        default: r.RFC3986,
        formatters: {
            RFC1738: function(n) {
                return t.call(n, e, "+");
            },
            RFC3986: function(n) {
                return String(n);
            }
        },
        RFC1738: r.RFC1738,
        RFC3986: r.RFC3986
    }, $4c2dd1b68d143d96$var$Tl;
}
function $4c2dd1b68d143d96$var$Sb() {
    if ($4c2dd1b68d143d96$var$bb) return $4c2dd1b68d143d96$var$Pl;
    $4c2dd1b68d143d96$var$bb = !0;
    var t = $4c2dd1b68d143d96$var$Bl(), e = Object.prototype.hasOwnProperty, r = Array.isArray, n = function() {
        for(var b = [], m = 0; m < 256; ++m)b.push("%" + ((m < 16 ? "0" : "") + m.toString(16)).toUpperCase());
        return b;
    }(), i = function(m) {
        for(; m.length > 1;){
            var v = m.pop(), R = v.obj[v.prop];
            if (r(R)) {
                for(var T = [], g = 0; g < R.length; ++g)typeof R[g] < "u" && T.push(R[g]);
                v.obj[v.prop] = T;
            }
        }
    }, s = function(m, v) {
        for(var R = v && v.plainObjects ? Object.create(null) : {}, T = 0; T < m.length; ++T)typeof m[T] < "u" && (R[T] = m[T]);
        return R;
    }, o = function b(m, v, R) {
        if (!v) return m;
        if (typeof v != "object") {
            if (r(m)) m.push(v);
            else if (m && typeof m == "object") (R && (R.plainObjects || R.allowPrototypes) || !e.call(Object.prototype, v)) && (m[v] = !0);
            else return [
                m,
                v
            ];
            return m;
        }
        if (!m || typeof m != "object") return [
            m
        ].concat(v);
        var T = m;
        return r(m) && !r(v) && (T = s(m, R)), r(m) && r(v) ? (v.forEach(function(g, O) {
            if (e.call(m, O)) {
                var _ = m[O];
                _ && typeof _ == "object" && g && typeof g == "object" ? m[O] = b(_, g, R) : m.push(g);
            } else m[O] = g;
        }), m) : Object.keys(v).reduce(function(g, O) {
            var _ = v[O];
            return e.call(g, O) ? g[O] = b(g[O], _, R) : g[O] = _, g;
        }, T);
    }, a = function(m, v) {
        return Object.keys(v).reduce(function(R, T) {
            return R[T] = v[T], R;
        }, m);
    }, c = function(b, m, v) {
        var R = b.replace(/\+/g, " ");
        if (v === "iso-8859-1") return R.replace(/%[0-9a-f]{2}/gi, unescape);
        try {
            return decodeURIComponent(R);
        } catch  {
            return R;
        }
    }, f = 1024, h = function(m, v, R, T, g) {
        if (m.length === 0) return m;
        var O = m;
        if (typeof m == "symbol" ? O = Symbol.prototype.toString.call(m) : typeof m != "string" && (O = String(m)), R === "iso-8859-1") return escape(O).replace(/%u[0-9a-f]{4}/gi, function(H) {
            return "%26%23" + parseInt(H.slice(2), 16) + "%3B";
        });
        for(var _ = "", q = 0; q < O.length; q += f){
            for(var $ = O.length >= f ? O.slice(q, q + f) : O, j = [], J = 0; J < $.length; ++J){
                var W = $.charCodeAt(J);
                if (W === 45 || W === 46 || W === 95 || W === 126 || W >= 48 && W <= 57 || W >= 65 && W <= 90 || W >= 97 && W <= 122 || g === t.RFC1738 && (W === 40 || W === 41)) {
                    j[j.length] = $.charAt(J);
                    continue;
                }
                if (W < 128) {
                    j[j.length] = n[W];
                    continue;
                }
                if (W < 2048) {
                    j[j.length] = n[192 | W >> 6] + n[128 | W & 63];
                    continue;
                }
                if (W < 55296 || W >= 57344) {
                    j[j.length] = n[224 | W >> 12] + n[128 | W >> 6 & 63] + n[128 | W & 63];
                    continue;
                }
                J += 1, W = 65536 + ((W & 1023) << 10 | $.charCodeAt(J) & 1023), j[j.length] = n[240 | W >> 18] + n[128 | W >> 12 & 63] + n[128 | W >> 6 & 63] + n[128 | W & 63];
            }
            _ += j.join("");
        }
        return _;
    }, d = function(m) {
        for(var v = [
            {
                obj: {
                    o: m
                },
                prop: "o"
            }
        ], R = [], T = 0; T < v.length; ++T)for(var g = v[T], O = g.obj[g.prop], _ = Object.keys(O), q = 0; q < _.length; ++q){
            var $ = _[q], j = O[$];
            typeof j == "object" && j !== null && R.indexOf(j) === -1 && (v.push({
                obj: O,
                prop: $
            }), R.push(j));
        }
        return i(v), m;
    }, w = function(m) {
        return Object.prototype.toString.call(m) === "[object RegExp]";
    }, y = function(m) {
        return !m || typeof m != "object" ? !1 : !!(m.constructor && m.constructor.isBuffer && m.constructor.isBuffer(m));
    }, P = function(m, v) {
        return [].concat(m, v);
    }, E = function(m, v) {
        if (r(m)) {
            for(var R = [], T = 0; T < m.length; T += 1)R.push(v(m[T]));
            return R;
        }
        return v(m);
    };
    return $4c2dd1b68d143d96$var$Pl = {
        arrayToObject: s,
        assign: a,
        combine: P,
        compact: d,
        decode: c,
        encode: h,
        isBuffer: y,
        isRegExp: w,
        maybeMap: E,
        merge: o
    }, $4c2dd1b68d143d96$var$Pl;
}
function $4c2dd1b68d143d96$var$Rx() {
    if ($4c2dd1b68d143d96$var$wb) return $4c2dd1b68d143d96$var$Ol;
    $4c2dd1b68d143d96$var$wb = !0;
    var t = $4c2dd1b68d143d96$var$Ox(), e = $4c2dd1b68d143d96$var$Sb(), r = $4c2dd1b68d143d96$var$Bl(), n = Object.prototype.hasOwnProperty, i = {
        brackets: function(b) {
            return b + "[]";
        },
        comma: "comma",
        indices: function(b, m) {
            return b + "[" + m + "]";
        },
        repeat: function(b) {
            return b;
        }
    }, s = Array.isArray, o = Array.prototype.push, a = function(E, b) {
        o.apply(E, s(b) ? b : [
            b
        ]);
    }, c = Date.prototype.toISOString, f = r.default, h = {
        addQueryPrefix: !1,
        allowDots: !1,
        allowEmptyArrays: !1,
        arrayFormat: "indices",
        charset: "utf-8",
        charsetSentinel: !1,
        delimiter: "&",
        encode: !0,
        encodeDotInKeys: !1,
        encoder: e.encode,
        encodeValuesOnly: !1,
        format: f,
        formatter: r.formatters[f],
        indices: !1,
        serializeDate: function(b) {
            return c.call(b);
        },
        skipNulls: !1,
        strictNullHandling: !1
    }, d = function(b) {
        return typeof b == "string" || typeof b == "number" || typeof b == "boolean" || typeof b == "symbol" || typeof b == "bigint";
    }, w = {}, y = function E(b, m, v, R, T, g, O, _, q, $, j, J, W, H, G, K, X, Q) {
        for(var V = b, te = Q, Y = 0, ee = !1; (te = te.get(w)) !== void 0 && !ee;){
            var pe = te.get(b);
            if (Y += 1, typeof pe < "u") {
                if (pe === Y) throw new RangeError("Cyclic object value");
                ee = !0;
            }
            typeof te.get(w) > "u" && (Y = 0);
        }
        if (typeof $ == "function" ? V = $(m, V) : V instanceof Date ? V = W(V) : v === "comma" && s(V) && (V = e.maybeMap(V, function(Ne) {
            return Ne instanceof Date ? W(Ne) : Ne;
        })), V === null) {
            if (g) return q && !K ? q(m, h.encoder, X, "key", H) : m;
            V = "";
        }
        if (d(V) || e.isBuffer(V)) {
            if (q) {
                var Z = K ? m : q(m, h.encoder, X, "key", H);
                return [
                    G(Z) + "=" + G(q(V, h.encoder, X, "value", H))
                ];
            }
            return [
                G(m) + "=" + G(String(V))
            ];
        }
        var ne = [];
        if (typeof V > "u") return ne;
        var fe;
        if (v === "comma" && s(V)) K && q && (V = e.maybeMap(V, q)), fe = [
            {
                value: V.length > 0 ? V.join(",") || null : void 0
            }
        ];
        else if (s($)) fe = $;
        else {
            var be = Object.keys(V);
            fe = j ? be.sort(j) : be;
        }
        var ye = _ ? m.replace(/\./g, "%2E") : m, Ae = R && s(V) && V.length === 1 ? ye + "[]" : ye;
        if (T && s(V) && V.length === 0) return Ae + "[]";
        for(var _e = 0; _e < fe.length; ++_e){
            var ve = fe[_e], Oe = typeof ve == "object" && typeof ve.value < "u" ? ve.value : V[ve];
            if (!(O && Oe === null)) {
                var xe = J && _ ? ve.replace(/\./g, "%2E") : ve, st = s(V) ? typeof v == "function" ? v(Ae, xe) : Ae : Ae + (J ? "." + xe : "[" + xe + "]");
                Q.set(b, Y);
                var Re = t();
                Re.set(w, Q), a(ne, E(Oe, st, v, R, T, g, O, _, v === "comma" && K && s(V) ? null : q, $, j, J, W, H, G, K, X, Re));
            }
        }
        return ne;
    }, P = function(b) {
        if (!b) return h;
        if (typeof b.allowEmptyArrays < "u" && typeof b.allowEmptyArrays != "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
        if (typeof b.encodeDotInKeys < "u" && typeof b.encodeDotInKeys != "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
        if (b.encoder !== null && typeof b.encoder < "u" && typeof b.encoder != "function") throw new TypeError("Encoder has to be a function.");
        var m = b.charset || h.charset;
        if (typeof b.charset < "u" && b.charset !== "utf-8" && b.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
        var v = r.default;
        if (typeof b.format < "u") {
            if (!n.call(r.formatters, b.format)) throw new TypeError("Unknown format option provided.");
            v = b.format;
        }
        var R = r.formatters[v], T = h.filter;
        (typeof b.filter == "function" || s(b.filter)) && (T = b.filter);
        var g;
        if (b.arrayFormat in i ? g = b.arrayFormat : "indices" in b ? g = b.indices ? "indices" : "repeat" : g = h.arrayFormat, "commaRoundTrip" in b && typeof b.commaRoundTrip != "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
        var O = typeof b.allowDots > "u" ? b.encodeDotInKeys === !0 ? !0 : h.allowDots : !!b.allowDots;
        return {
            addQueryPrefix: typeof b.addQueryPrefix == "boolean" ? b.addQueryPrefix : h.addQueryPrefix,
            allowDots: O,
            allowEmptyArrays: typeof b.allowEmptyArrays == "boolean" ? !!b.allowEmptyArrays : h.allowEmptyArrays,
            arrayFormat: g,
            charset: m,
            charsetSentinel: typeof b.charsetSentinel == "boolean" ? b.charsetSentinel : h.charsetSentinel,
            commaRoundTrip: b.commaRoundTrip,
            delimiter: typeof b.delimiter > "u" ? h.delimiter : b.delimiter,
            encode: typeof b.encode == "boolean" ? b.encode : h.encode,
            encodeDotInKeys: typeof b.encodeDotInKeys == "boolean" ? b.encodeDotInKeys : h.encodeDotInKeys,
            encoder: typeof b.encoder == "function" ? b.encoder : h.encoder,
            encodeValuesOnly: typeof b.encodeValuesOnly == "boolean" ? b.encodeValuesOnly : h.encodeValuesOnly,
            filter: T,
            format: v,
            formatter: R,
            serializeDate: typeof b.serializeDate == "function" ? b.serializeDate : h.serializeDate,
            skipNulls: typeof b.skipNulls == "boolean" ? b.skipNulls : h.skipNulls,
            sort: typeof b.sort == "function" ? b.sort : null,
            strictNullHandling: typeof b.strictNullHandling == "boolean" ? b.strictNullHandling : h.strictNullHandling
        };
    };
    return $4c2dd1b68d143d96$var$Ol = function(E, b) {
        var m = E, v = P(b), R, T;
        typeof v.filter == "function" ? (T = v.filter, m = T("", m)) : s(v.filter) && (T = v.filter, R = T);
        var g = [];
        if (typeof m != "object" || m === null) return "";
        var O = i[v.arrayFormat], _ = O === "comma" && v.commaRoundTrip;
        R || (R = Object.keys(m)), v.sort && R.sort(v.sort);
        for(var q = t(), $ = 0; $ < R.length; ++$){
            var j = R[$];
            v.skipNulls && m[j] === null || a(g, y(m[j], j, O, _, v.allowEmptyArrays, v.strictNullHandling, v.skipNulls, v.encodeDotInKeys, v.encode ? v.encoder : null, v.filter, v.sort, v.allowDots, v.serializeDate, v.format, v.formatter, v.encodeValuesOnly, v.charset, q));
        }
        var J = g.join(v.delimiter), W = v.addQueryPrefix === !0 ? "?" : "";
        return v.charsetSentinel && (v.charset === "iso-8859-1" ? W += "utf8=%26%2310003%3B&" : W += "utf8=%E2%9C%93&"), J.length > 0 ? W + J : "";
    }, $4c2dd1b68d143d96$var$Ol;
}
function $4c2dd1b68d143d96$var$kx() {
    if ($4c2dd1b68d143d96$var$mb) return $4c2dd1b68d143d96$var$Rl;
    $4c2dd1b68d143d96$var$mb = !0;
    var t = $4c2dd1b68d143d96$var$Sb(), e = Object.prototype.hasOwnProperty, r = Array.isArray, n = {
        allowDots: !1,
        allowEmptyArrays: !1,
        allowPrototypes: !1,
        allowSparse: !1,
        arrayLimit: 20,
        charset: "utf-8",
        charsetSentinel: !1,
        comma: !1,
        decodeDotInKeys: !1,
        decoder: t.decode,
        delimiter: "&",
        depth: 5,
        duplicates: "combine",
        ignoreQueryPrefix: !1,
        interpretNumericEntities: !1,
        parameterLimit: 1e3,
        parseArrays: !0,
        plainObjects: !1,
        strictDepth: !1,
        strictNullHandling: !1
    }, i = function(w) {
        return w.replace(/&#(\d+);/g, function(y, P) {
            return String.fromCharCode(parseInt(P, 10));
        });
    }, s = function(w, y) {
        return w && typeof w == "string" && y.comma && w.indexOf(",") > -1 ? w.split(",") : w;
    }, o = "utf8=%26%2310003%3B", a = "utf8=%E2%9C%93", c = function(y, P) {
        var E = {
            __proto__: null
        }, b = P.ignoreQueryPrefix ? y.replace(/^\?/, "") : y;
        b = b.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
        var m = P.parameterLimit === 1 / 0 ? void 0 : P.parameterLimit, v = b.split(P.delimiter, m), R = -1, T, g = P.charset;
        if (P.charsetSentinel) for(T = 0; T < v.length; ++T)v[T].indexOf("utf8=") === 0 && (v[T] === a ? g = "utf-8" : v[T] === o && (g = "iso-8859-1"), R = T, T = v.length);
        for(T = 0; T < v.length; ++T)if (T !== R) {
            var O = v[T], _ = O.indexOf("]="), q = _ === -1 ? O.indexOf("=") : _ + 1, $, j;
            q === -1 ? ($ = P.decoder(O, n.decoder, g, "key"), j = P.strictNullHandling ? null : "") : ($ = P.decoder(O.slice(0, q), n.decoder, g, "key"), j = t.maybeMap(s(O.slice(q + 1), P), function(W) {
                return P.decoder(W, n.decoder, g, "value");
            })), j && P.interpretNumericEntities && g === "iso-8859-1" && (j = i(j)), O.indexOf("[]=") > -1 && (j = r(j) ? [
                j
            ] : j);
            var J = e.call(E, $);
            J && P.duplicates === "combine" ? E[$] = t.combine(E[$], j) : (!J || P.duplicates === "last") && (E[$] = j);
        }
        return E;
    }, f = function(w, y, P, E) {
        for(var b = E ? y : s(y, P), m = w.length - 1; m >= 0; --m){
            var v, R = w[m];
            if (R === "[]" && P.parseArrays) v = P.allowEmptyArrays && (b === "" || P.strictNullHandling && b === null) ? [] : [].concat(b);
            else {
                v = P.plainObjects ? Object.create(null) : {};
                var T = R.charAt(0) === "[" && R.charAt(R.length - 1) === "]" ? R.slice(1, -1) : R, g = P.decodeDotInKeys ? T.replace(/%2E/g, ".") : T, O = parseInt(g, 10);
                !P.parseArrays && g === "" ? v = {
                    0: b
                } : !isNaN(O) && R !== g && String(O) === g && O >= 0 && P.parseArrays && O <= P.arrayLimit ? (v = [], v[O] = b) : g !== "__proto__" && (v[g] = b);
            }
            b = v;
        }
        return b;
    }, h = function(y, P, E, b) {
        if (y) {
            var m = E.allowDots ? y.replace(/\.([^.[]+)/g, "[$1]") : y, v = /(\[[^[\]]*])/, R = /(\[[^[\]]*])/g, T = E.depth > 0 && v.exec(m), g = T ? m.slice(0, T.index) : m, O = [];
            if (g) {
                if (!E.plainObjects && e.call(Object.prototype, g) && !E.allowPrototypes) return;
                O.push(g);
            }
            for(var _ = 0; E.depth > 0 && (T = R.exec(m)) !== null && _ < E.depth;){
                if (_ += 1, !E.plainObjects && e.call(Object.prototype, T[1].slice(1, -1)) && !E.allowPrototypes) return;
                O.push(T[1]);
            }
            if (T) {
                if (E.strictDepth === !0) throw new RangeError("Input depth exceeded depth option of " + E.depth + " and strictDepth is true");
                O.push("[" + m.slice(T.index) + "]");
            }
            return f(O, P, E, b);
        }
    }, d = function(y) {
        if (!y) return n;
        if (typeof y.allowEmptyArrays < "u" && typeof y.allowEmptyArrays != "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
        if (typeof y.decodeDotInKeys < "u" && typeof y.decodeDotInKeys != "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
        if (y.decoder !== null && typeof y.decoder < "u" && typeof y.decoder != "function") throw new TypeError("Decoder has to be a function.");
        if (typeof y.charset < "u" && y.charset !== "utf-8" && y.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
        var P = typeof y.charset > "u" ? n.charset : y.charset, E = typeof y.duplicates > "u" ? n.duplicates : y.duplicates;
        if (E !== "combine" && E !== "first" && E !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
        var b = typeof y.allowDots > "u" ? y.decodeDotInKeys === !0 ? !0 : n.allowDots : !!y.allowDots;
        return {
            allowDots: b,
            allowEmptyArrays: typeof y.allowEmptyArrays == "boolean" ? !!y.allowEmptyArrays : n.allowEmptyArrays,
            allowPrototypes: typeof y.allowPrototypes == "boolean" ? y.allowPrototypes : n.allowPrototypes,
            allowSparse: typeof y.allowSparse == "boolean" ? y.allowSparse : n.allowSparse,
            arrayLimit: typeof y.arrayLimit == "number" ? y.arrayLimit : n.arrayLimit,
            charset: P,
            charsetSentinel: typeof y.charsetSentinel == "boolean" ? y.charsetSentinel : n.charsetSentinel,
            comma: typeof y.comma == "boolean" ? y.comma : n.comma,
            decodeDotInKeys: typeof y.decodeDotInKeys == "boolean" ? y.decodeDotInKeys : n.decodeDotInKeys,
            decoder: typeof y.decoder == "function" ? y.decoder : n.decoder,
            delimiter: typeof y.delimiter == "string" || t.isRegExp(y.delimiter) ? y.delimiter : n.delimiter,
            depth: typeof y.depth == "number" || y.depth === !1 ? +y.depth : n.depth,
            duplicates: E,
            ignoreQueryPrefix: y.ignoreQueryPrefix === !0,
            interpretNumericEntities: typeof y.interpretNumericEntities == "boolean" ? y.interpretNumericEntities : n.interpretNumericEntities,
            parameterLimit: typeof y.parameterLimit == "number" ? y.parameterLimit : n.parameterLimit,
            parseArrays: y.parseArrays !== !1,
            plainObjects: typeof y.plainObjects == "boolean" ? y.plainObjects : n.plainObjects,
            strictDepth: typeof y.strictDepth == "boolean" ? !!y.strictDepth : n.strictDepth,
            strictNullHandling: typeof y.strictNullHandling == "boolean" ? y.strictNullHandling : n.strictNullHandling
        };
    };
    return $4c2dd1b68d143d96$var$Rl = function(w, y) {
        var P = d(y);
        if (w === "" || w === null || typeof w > "u") return P.plainObjects ? Object.create(null) : {};
        for(var E = typeof w == "string" ? c(w, P) : w, b = P.plainObjects ? Object.create(null) : {}, m = Object.keys(E), v = 0; v < m.length; ++v){
            var R = m[v], T = h(R, E[R], P, typeof w == "string");
            b = t.merge(b, T, P);
        }
        return P.allowSparse === !0 ? b : t.compact(b);
    }, $4c2dd1b68d143d96$var$Rl;
}
function $4c2dd1b68d143d96$var$Cx() {
    if ($4c2dd1b68d143d96$var$_b) return $4c2dd1b68d143d96$var$kl;
    $4c2dd1b68d143d96$var$_b = !0;
    var t = $4c2dd1b68d143d96$var$Rx(), e = $4c2dd1b68d143d96$var$kx(), r = $4c2dd1b68d143d96$var$Bl();
    return $4c2dd1b68d143d96$var$kl = {
        formats: r,
        parse: e,
        stringify: t
    }, $4c2dd1b68d143d96$var$kl;
}
function $4c2dd1b68d143d96$var$Bx() {
    if ($4c2dd1b68d143d96$var$vb) return $4c2dd1b68d143d96$var$Hr;
    $4c2dd1b68d143d96$var$vb = !0;
    var t = $4c2dd1b68d143d96$var$hr;
    function e() {
        this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
    }
    var r = /^([a-z0-9.+-]+:)/i, n = /:[0-9]*$/, i = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, s = [
        "<",
        ">",
        '"',
        "`",
        " ",
        "\r",
        `
`,
        "	"
    ], o = [
        "{",
        "}",
        "|",
        "\\",
        "^",
        "`"
    ].concat(s), a = [
        "'"
    ].concat(o), c = [
        "%",
        "/",
        "?",
        ";",
        "#"
    ].concat(a), f = [
        "/",
        "?",
        "#"
    ], h = 255, d = /^[+a-z0-9A-Z_-]{0,63}$/, w = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, y = {
        javascript: !0,
        "javascript:": !0
    }, P = {
        javascript: !0,
        "javascript:": !0
    }, E = {
        http: !0,
        https: !0,
        ftp: !0,
        gopher: !0,
        file: !0,
        "http:": !0,
        "https:": !0,
        "ftp:": !0,
        "gopher:": !0,
        "file:": !0
    }, b = $4c2dd1b68d143d96$var$Cx();
    function m(g, O, _) {
        if (g && typeof g == "object" && g instanceof e) return g;
        var q = new e;
        return q.parse(g, O, _), q;
    }
    e.prototype.parse = function(g, O, _) {
        if (typeof g != "string") throw new TypeError("Parameter 'url' must be a string, not " + typeof g);
        var q = g.indexOf("?"), $ = q !== -1 && q < g.indexOf("#") ? "?" : "#", j = g.split($), J = /\\/g;
        j[0] = j[0].replace(J, "/"), g = j.join($);
        var W = g;
        if (W = W.trim(), !_ && g.split("#").length === 1) {
            var H = i.exec(W);
            if (H) return this.path = W, this.href = W, this.pathname = H[1], H[2] ? (this.search = H[2], O ? this.query = b.parse(this.search.substr(1)) : this.query = this.search.substr(1)) : O && (this.search = "", this.query = {}), this;
        }
        var G = r.exec(W);
        if (G) {
            G = G[0];
            var K = G.toLowerCase();
            this.protocol = K, W = W.substr(G.length);
        }
        if (_ || G || W.match(/^\/\/[^@/]+@[^@/]+/)) {
            var X = W.substr(0, 2) === "//";
            X && !(G && P[G]) && (W = W.substr(2), this.slashes = !0);
        }
        if (!P[G] && (X || G && !E[G])) {
            for(var Q = -1, V = 0; V < f.length; V++){
                var te = W.indexOf(f[V]);
                te !== -1 && (Q === -1 || te < Q) && (Q = te);
            }
            var Y, ee;
            Q === -1 ? ee = W.lastIndexOf("@") : ee = W.lastIndexOf("@", Q), ee !== -1 && (Y = W.slice(0, ee), W = W.slice(ee + 1), this.auth = decodeURIComponent(Y)), Q = -1;
            for(var V = 0; V < c.length; V++){
                var te = W.indexOf(c[V]);
                te !== -1 && (Q === -1 || te < Q) && (Q = te);
            }
            Q === -1 && (Q = W.length), this.host = W.slice(0, Q), W = W.slice(Q), this.parseHost(), this.hostname = this.hostname || "";
            var pe = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
            if (!pe) for(var Z = this.hostname.split(/\./), V = 0, ne = Z.length; V < ne; V++){
                var fe = Z[V];
                if (fe && !fe.match(d)) {
                    for(var be = "", ye = 0, Ae = fe.length; ye < Ae; ye++)fe.charCodeAt(ye) > 127 ? be += "x" : be += fe[ye];
                    if (!be.match(d)) {
                        var _e = Z.slice(0, V), ve = Z.slice(V + 1), Oe = fe.match(w);
                        Oe && (_e.push(Oe[1]), ve.unshift(Oe[2])), ve.length && (W = "/" + ve.join(".") + W), this.hostname = _e.join(".");
                        break;
                    }
                }
            }
            this.hostname.length > h ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), pe || (this.hostname = t.toASCII(this.hostname));
            var xe = this.port ? ":" + this.port : "", st = this.hostname || "";
            this.host = st + xe, this.href += this.host, pe && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), W[0] !== "/" && (W = "/" + W));
        }
        if (!y[K]) for(var V = 0, ne = a.length; V < ne; V++){
            var Re = a[V];
            if (W.indexOf(Re) !== -1) {
                var Ne = encodeURIComponent(Re);
                Ne === Re && (Ne = escape(Re)), W = W.split(Re).join(Ne);
            }
        }
        var Ct = W.indexOf("#");
        Ct !== -1 && (this.hash = W.substr(Ct), W = W.slice(0, Ct));
        var Bt = W.indexOf("?");
        if (Bt !== -1 ? (this.search = W.substr(Bt), this.query = W.substr(Bt + 1), O && (this.query = b.parse(this.query)), W = W.slice(0, Bt)) : O && (this.search = "", this.query = {}), W && (this.pathname = W), E[K] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
            var xe = this.pathname || "", xn = this.search || "";
            this.path = xe + xn;
        }
        return this.href = this.format(), this;
    };
    function v(g) {
        return typeof g == "string" && (g = m(g)), g instanceof e ? g.format() : e.prototype.format.call(g);
    }
    e.prototype.format = function() {
        var g = this.auth || "";
        g && (g = encodeURIComponent(g), g = g.replace(/%3A/i, ":"), g += "@");
        var O = this.protocol || "", _ = this.pathname || "", q = this.hash || "", $ = !1, j = "";
        this.host ? $ = g + this.host : this.hostname && ($ = g + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && ($ += ":" + this.port)), this.query && typeof this.query == "object" && Object.keys(this.query).length && (j = b.stringify(this.query, {
            arrayFormat: "repeat",
            addQueryPrefix: !1
        }));
        var J = this.search || j && "?" + j || "";
        return O && O.substr(-1) !== ":" && (O += ":"), this.slashes || (!O || E[O]) && $ !== !1 ? ($ = "//" + ($ || ""), _ && _.charAt(0) !== "/" && (_ = "/" + _)) : $ || ($ = ""), q && q.charAt(0) !== "#" && (q = "#" + q), J && J.charAt(0) !== "?" && (J = "?" + J), _ = _.replace(/[?#]/g, function(W) {
            return encodeURIComponent(W);
        }), J = J.replace("#", "%23"), O + $ + _ + J + q;
    };
    function R(g, O) {
        return m(g, !1, !0).resolve(O);
    }
    e.prototype.resolve = function(g) {
        return this.resolveObject(m(g, !1, !0)).format();
    };
    function T(g, O) {
        return g ? m(g, !1, !0).resolveObject(O) : O;
    }
    return e.prototype.resolveObject = function(g) {
        if (typeof g == "string") {
            var O = new e;
            O.parse(g, !1, !0), g = O;
        }
        for(var _ = new e, q = Object.keys(this), $ = 0; $ < q.length; $++){
            var j = q[$];
            _[j] = this[j];
        }
        if (_.hash = g.hash, g.href === "") return _.href = _.format(), _;
        if (g.slashes && !g.protocol) {
            for(var J = Object.keys(g), W = 0; W < J.length; W++){
                var H = J[W];
                H !== "protocol" && (_[H] = g[H]);
            }
            return E[_.protocol] && _.hostname && !_.pathname && (_.pathname = "/", _.path = _.pathname), _.href = _.format(), _;
        }
        if (g.protocol && g.protocol !== _.protocol) {
            if (!E[g.protocol]) {
                for(var G = Object.keys(g), K = 0; K < G.length; K++){
                    var X = G[K];
                    _[X] = g[X];
                }
                return _.href = _.format(), _;
            }
            if (_.protocol = g.protocol, !g.host && !P[g.protocol]) {
                for(var ne = (g.pathname || "").split("/"); ne.length && !(g.host = ne.shift()););
                g.host || (g.host = ""), g.hostname || (g.hostname = ""), ne[0] !== "" && ne.unshift(""), ne.length < 2 && ne.unshift(""), _.pathname = ne.join("/");
            } else _.pathname = g.pathname;
            if (_.search = g.search, _.query = g.query, _.host = g.host || "", _.auth = g.auth, _.hostname = g.hostname || g.host, _.port = g.port, _.pathname || _.search) {
                var Q = _.pathname || "", V = _.search || "";
                _.path = Q + V;
            }
            return _.slashes = _.slashes || g.slashes, _.href = _.format(), _;
        }
        var te = _.pathname && _.pathname.charAt(0) === "/", Y = g.host || g.pathname && g.pathname.charAt(0) === "/", ee = Y || te || _.host && g.pathname, pe = ee, Z = _.pathname && _.pathname.split("/") || [], ne = g.pathname && g.pathname.split("/") || [], fe = _.protocol && !E[_.protocol];
        if (fe && (_.hostname = "", _.port = null, _.host && (Z[0] === "" ? Z[0] = _.host : Z.unshift(_.host)), _.host = "", g.protocol && (g.hostname = null, g.port = null, g.host && (ne[0] === "" ? ne[0] = g.host : ne.unshift(g.host)), g.host = null), ee = ee && (ne[0] === "" || Z[0] === "")), Y) _.host = g.host || g.host === "" ? g.host : _.host, _.hostname = g.hostname || g.hostname === "" ? g.hostname : _.hostname, _.search = g.search, _.query = g.query, Z = ne;
        else if (ne.length) Z || (Z = []), Z.pop(), Z = Z.concat(ne), _.search = g.search, _.query = g.query;
        else if (g.search != null) {
            if (fe) {
                _.host = Z.shift(), _.hostname = _.host;
                var be = _.host && _.host.indexOf("@") > 0 ? _.host.split("@") : !1;
                be && (_.auth = be.shift(), _.hostname = be.shift(), _.host = _.hostname);
            }
            return _.search = g.search, _.query = g.query, (_.pathname !== null || _.search !== null) && (_.path = (_.pathname ? _.pathname : "") + (_.search ? _.search : "")), _.href = _.format(), _;
        }
        if (!Z.length) return _.pathname = null, _.search ? _.path = "/" + _.search : _.path = null, _.href = _.format(), _;
        for(var ye = Z.slice(-1)[0], Ae = (_.host || g.host || Z.length > 1) && (ye === "." || ye === "..") || ye === "", _e = 0, ve = Z.length; ve >= 0; ve--)ye = Z[ve], ye === "." ? Z.splice(ve, 1) : ye === ".." ? (Z.splice(ve, 1), _e++) : _e && (Z.splice(ve, 1), _e--);
        if (!ee && !pe) for(; _e--; _e)Z.unshift("..");
        ee && Z[0] !== "" && (!Z[0] || Z[0].charAt(0) !== "/") && Z.unshift(""), Ae && Z.join("/").substr(-1) !== "/" && Z.push("");
        var Oe = Z[0] === "" || Z[0] && Z[0].charAt(0) === "/";
        if (fe) {
            _.hostname = Oe ? "" : Z.length ? Z.shift() : "", _.host = _.hostname;
            var be = _.host && _.host.indexOf("@") > 0 ? _.host.split("@") : !1;
            be && (_.auth = be.shift(), _.hostname = be.shift(), _.host = _.hostname);
        }
        return ee = ee || _.host && Z.length, ee && !Oe && Z.unshift(""), Z.length > 0 ? _.pathname = Z.join("/") : (_.pathname = null, _.path = null), (_.pathname !== null || _.search !== null) && (_.path = (_.pathname ? _.pathname : "") + (_.search ? _.search : "")), _.auth = g.auth || _.auth, _.slashes = _.slashes || g.slashes, _.href = _.format(), _;
    }, e.prototype.parseHost = function() {
        var g = this.host, O = n.exec(g);
        O && (O = O[0], O !== ":" && (this.port = O.substr(1)), g = g.substr(0, g.length - O.length)), g && (this.hostname = g);
    }, $4c2dd1b68d143d96$var$Hr.parse = m, $4c2dd1b68d143d96$var$Hr.resolve = R, $4c2dd1b68d143d96$var$Hr.resolveObject = T, $4c2dd1b68d143d96$var$Hr.format = v, $4c2dd1b68d143d96$var$Hr.Url = e, $4c2dd1b68d143d96$var$Hr;
}
function $4c2dd1b68d143d96$var$Eb(t) {
    if (typeof t == "string") t = new URL(t);
    else if (!(t instanceof URL)) throw new Deno.errors.InvalidData("invalid argument path , must be a string or URL");
    if (t.protocol !== "file:") throw new Deno.errors.InvalidData("invalid url scheme");
    return $4c2dd1b68d143d96$var$Cl ? $4c2dd1b68d143d96$var$Jx(t) : $4c2dd1b68d143d96$var$Xx(t);
}
function $4c2dd1b68d143d96$var$Jx(t) {
    let e = t.hostname, r = t.pathname;
    for(let n = 0; n < r.length; n++)if (r[n] === "%") {
        let i = r.codePointAt(n + 2) || 32;
        if (r[n + 1] === "2" && i === 102 || r[n + 1] === "5" && i === 99) throw new Deno.errors.InvalidData("must not include encoded \\ or / characters");
    }
    if (r = r.replace($4c2dd1b68d143d96$var$Vx, "\\"), r = decodeURIComponent(r), e !== "") return `\\\\${e}${r}`;
    {
        let n = r.codePointAt(1) | 32, i = r[2];
        if (n < $4c2dd1b68d143d96$var$$x || n > $4c2dd1b68d143d96$var$Hx || i !== ":") throw new Deno.errors.InvalidData("file url path must be absolute");
        return r.slice(1);
    }
}
function $4c2dd1b68d143d96$var$Xx(t) {
    if (t.hostname !== "") throw new Deno.errors.InvalidData("invalid file url hostname");
    let e = t.pathname;
    for(let r = 0; r < e.length; r++)if (e[r] === "%") {
        let n = e.codePointAt(r + 2) || 32;
        if (e[r + 1] === "2" && n === 102) throw new Deno.errors.InvalidData("must not include encoded / characters");
    }
    return decodeURIComponent(e);
}
function $4c2dd1b68d143d96$var$Ab(t) {
    let e = $4c2dd1b68d143d96$var$El.resolve(t), r = t.charCodeAt(t.length - 1);
    (r === $4c2dd1b68d143d96$var$Wx || $4c2dd1b68d143d96$var$Cl && r === $4c2dd1b68d143d96$var$Fx) && e[e.length - 1] !== $4c2dd1b68d143d96$var$El.sep && (e += "/");
    let n = new URL("file://");
    return e.includes("%") && (e = e.replace($4c2dd1b68d143d96$var$Gx, "%25")), !$4c2dd1b68d143d96$var$Cl && e.includes("\\") && (e = e.replace($4c2dd1b68d143d96$var$zx, "%5C")), e.includes(`
`) && (e = e.replace($4c2dd1b68d143d96$var$Kx, "%0A")), e.includes("\r") && (e = e.replace($4c2dd1b68d143d96$var$Qx, "%0D")), e.includes("	") && (e = e.replace($4c2dd1b68d143d96$var$Yx, "%09")), n.pathname = e, n;
}
var $4c2dd1b68d143d96$var$Tx, $4c2dd1b68d143d96$var$Al, $4c2dd1b68d143d96$var$pb, $4c2dd1b68d143d96$var$Il, $4c2dd1b68d143d96$var$xl, $4c2dd1b68d143d96$var$yb, $4c2dd1b68d143d96$var$Tl, $4c2dd1b68d143d96$var$gb, $4c2dd1b68d143d96$var$Pl, $4c2dd1b68d143d96$var$bb, $4c2dd1b68d143d96$var$Ol, $4c2dd1b68d143d96$var$wb, $4c2dd1b68d143d96$var$Rl, $4c2dd1b68d143d96$var$mb, $4c2dd1b68d143d96$var$kl, $4c2dd1b68d143d96$var$_b, $4c2dd1b68d143d96$var$Hr, $4c2dd1b68d143d96$var$vb, $4c2dd1b68d143d96$var$Ge, $4c2dd1b68d143d96$var$Mx, $4c2dd1b68d143d96$var$Nx, $4c2dd1b68d143d96$var$qx, $4c2dd1b68d143d96$var$Lx, $4c2dd1b68d143d96$var$Ux, $4c2dd1b68d143d96$var$Dx, $4c2dd1b68d143d96$var$jx, $4c2dd1b68d143d96$var$Fx, $4c2dd1b68d143d96$var$Wx, $4c2dd1b68d143d96$var$$x, $4c2dd1b68d143d96$var$Hx, $4c2dd1b68d143d96$var$Cl, $4c2dd1b68d143d96$var$Vx, $4c2dd1b68d143d96$var$Gx, $4c2dd1b68d143d96$var$zx, $4c2dd1b68d143d96$var$Kx, $4c2dd1b68d143d96$var$Qx, $4c2dd1b68d143d96$var$Yx, $4c2dd1b68d143d96$var$xb = $4c2dd1b68d143d96$var$ze(()=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    $4c2dd1b68d143d96$var$Ug();
    $4c2dd1b68d143d96$var$lb();
    $4c2dd1b68d143d96$var$db();
    $4c2dd1b68d143d96$var$vl();
    $4c2dd1b68d143d96$var$Tx = Object.freeze(Object.create(null)), $4c2dd1b68d143d96$var$Al = {}, $4c2dd1b68d143d96$var$pb = !1, $4c2dd1b68d143d96$var$Il = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : $parcel$global;
    $4c2dd1b68d143d96$var$xl = {}, $4c2dd1b68d143d96$var$yb = !1;
    $4c2dd1b68d143d96$var$Tl = {}, $4c2dd1b68d143d96$var$gb = !1;
    $4c2dd1b68d143d96$var$Pl = {}, $4c2dd1b68d143d96$var$bb = !1;
    $4c2dd1b68d143d96$var$Ol = {}, $4c2dd1b68d143d96$var$wb = !1;
    $4c2dd1b68d143d96$var$Rl = {}, $4c2dd1b68d143d96$var$mb = !1;
    $4c2dd1b68d143d96$var$kl = {}, $4c2dd1b68d143d96$var$_b = !1;
    $4c2dd1b68d143d96$var$Hr = {}, $4c2dd1b68d143d96$var$vb = !1;
    $4c2dd1b68d143d96$var$Ge = $4c2dd1b68d143d96$var$Bx();
    $4c2dd1b68d143d96$var$Ge.parse;
    $4c2dd1b68d143d96$var$Ge.resolve;
    $4c2dd1b68d143d96$var$Ge.resolveObject;
    $4c2dd1b68d143d96$var$Ge.format;
    $4c2dd1b68d143d96$var$Ge.Url;
    $4c2dd1b68d143d96$var$Mx = typeof Deno < "u" ? Deno.build.os === "windows" ? "win32" : Deno.build.os : void 0;
    $4c2dd1b68d143d96$var$Ge.URL = typeof URL < "u" ? URL : null;
    $4c2dd1b68d143d96$var$Ge.pathToFileURL = $4c2dd1b68d143d96$var$Ab;
    $4c2dd1b68d143d96$var$Ge.fileURLToPath = $4c2dd1b68d143d96$var$Eb;
    $4c2dd1b68d143d96$var$Nx = $4c2dd1b68d143d96$var$Ge.Url, $4c2dd1b68d143d96$var$qx = $4c2dd1b68d143d96$var$Ge.format, $4c2dd1b68d143d96$var$Lx = $4c2dd1b68d143d96$var$Ge.resolve, $4c2dd1b68d143d96$var$Ux = $4c2dd1b68d143d96$var$Ge.resolveObject, $4c2dd1b68d143d96$var$Dx = $4c2dd1b68d143d96$var$Ge.parse, $4c2dd1b68d143d96$var$jx = $4c2dd1b68d143d96$var$Ge.URL, $4c2dd1b68d143d96$var$Fx = 92, $4c2dd1b68d143d96$var$Wx = 47, $4c2dd1b68d143d96$var$$x = 97, $4c2dd1b68d143d96$var$Hx = 122, $4c2dd1b68d143d96$var$Cl = $4c2dd1b68d143d96$var$Mx === "win32", $4c2dd1b68d143d96$var$Vx = /\//g, $4c2dd1b68d143d96$var$Gx = /%/g, $4c2dd1b68d143d96$var$zx = /\\/g, $4c2dd1b68d143d96$var$Kx = /\n/g, $4c2dd1b68d143d96$var$Qx = /\r/g, $4c2dd1b68d143d96$var$Yx = /\t/g;
});
var $4c2dd1b68d143d96$var$Pb = $4c2dd1b68d143d96$var$D((A9, Tb)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Tb.exports = function() {
        throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
    };
});
var $4c2dd1b68d143d96$var$Qo = $4c2dd1b68d143d96$var$D((mi)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(mi, "__esModule", {
        value: !0
    });
    mi.BufferedDuplex = void 0;
    mi.writev = Rb;
    var Zx = $4c2dd1b68d143d96$var$or(), Ob = ($4c2dd1b68d143d96$var$ke(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$qe));
    function Rb(t, e) {
        let r = new Array(t.length);
        for(let n = 0; n < t.length; n++)typeof t[n].chunk == "string" ? r[n] = Ob.Buffer.from(t[n].chunk, "utf8") : r[n] = t[n].chunk;
        this._write(Ob.Buffer.concat(r), "binary", e);
    }
    var Ml = class extends Zx.Duplex {
        socket;
        proxy;
        isSocketOpen;
        writeQueue;
        constructor(e, r, n){
            super({
                objectMode: !0
            }), this.proxy = r, this.socket = n, this.writeQueue = [], e.objectMode || (this._writev = Rb.bind(this)), this.isSocketOpen = !1, this.proxy.on("data", (i)=>{
                !this.destroyed && this.readable && this.push(i);
            });
        }
        _read(e) {
            this.proxy.read(e);
        }
        _write(e, r, n) {
            this.isSocketOpen ? this.writeToProxy(e, r, n) : this.writeQueue.push({
                chunk: e,
                encoding: r,
                cb: n
            });
        }
        _final(e) {
            this.writeQueue = [], this.proxy.end(e);
        }
        _destroy(e, r) {
            this.writeQueue = [], this.proxy.destroy(), r(e);
        }
        socketReady() {
            this.emit("connect"), this.isSocketOpen = !0, this.processWriteQueue();
        }
        writeToProxy(e, r, n) {
            this.proxy.write(e, r) === !1 ? this.proxy.once("drain", n) : n();
        }
        processWriteQueue() {
            for(; this.writeQueue.length > 0;){
                let { chunk: e, encoding: r, cb: n } = this.writeQueue.shift();
                this.writeToProxy(e, r, n);
            }
        }
    };
    mi.BufferedDuplex = Ml;
});
var $4c2dd1b68d143d96$var$_i = $4c2dd1b68d143d96$var$D((gr)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var ql = gr && gr.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(gr, "__esModule", {
        value: !0
    });
    gr.streamBuilder = gr.browserStreamBuilder = void 0;
    var Yo = ($4c2dd1b68d143d96$var$ke(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$qe)), kb = ql($4c2dd1b68d143d96$var$Pb()), eT = ql($4c2dd1b68d143d96$var$At()), tT = $4c2dd1b68d143d96$var$or(), rT = ql($4c2dd1b68d143d96$var$yi()), Nl = $4c2dd1b68d143d96$var$Qo(), yr = (0, eT.default)("mqttjs:ws"), nT = [
        "rejectUnauthorized",
        "ca",
        "cert",
        "key",
        "pfx",
        "passphrase"
    ];
    function Cb(t, e) {
        let r = `${t.protocol}://${t.hostname}:${t.port}${t.path}`;
        return typeof t.transformWsUrl == "function" && (r = t.transformWsUrl(r, t, e)), r;
    }
    function Bb(t) {
        let e = t;
        return t.port || (t.protocol === "wss" ? e.port = 443 : e.port = 80), t.path || (e.path = "/"), t.wsOptions || (e.wsOptions = {}), !rT.default && !t.forceNativeWebSocket && t.protocol === "wss" && nT.forEach((r)=>{
            Object.prototype.hasOwnProperty.call(t, r) && !Object.prototype.hasOwnProperty.call(t.wsOptions, r) && (e.wsOptions[r] = t[r]);
        }), e;
    }
    function iT(t) {
        let e = Bb(t);
        if (e.hostname || (e.hostname = e.host), !e.hostname) {
            if (typeof document > "u") throw new Error("Could not determine host. Specify host manually.");
            let r = new URL(document.URL);
            e.hostname = r.hostname, e.port || (e.port = Number(r.port));
        }
        return e.objectMode === void 0 && (e.objectMode = !(e.binary === !0 || e.binary === void 0)), e;
    }
    function oT(t, e, r) {
        yr("createWebSocket"), yr(`protocol: ${r.protocolId} ${r.protocolVersion}`);
        let n = r.protocolId === "MQIsdp" && r.protocolVersion === 3 ? "mqttv3.1" : "mqtt";
        yr(`creating new Websocket for url: ${e} and protocol: ${n}`);
        let i;
        return r.createWebsocket ? i = r.createWebsocket(e, [
            n
        ], r) : i = new kb.default(e, [
            n
        ], r.wsOptions), i;
    }
    function sT(t, e) {
        let r = e.protocolId === "MQIsdp" && e.protocolVersion === 3 ? "mqttv3.1" : "mqtt", n = Cb(e, t), i;
        return e.createWebsocket ? i = e.createWebsocket(n, [
            r
        ], e) : i = new WebSocket(n, [
            r
        ]), i.binaryType = "arraybuffer", i;
    }
    var aT = (t, e)=>{
        yr("streamBuilder");
        let r = Bb(e);
        r.hostname = r.hostname || r.host || "localhost";
        let n = Cb(r, t), i = oT(t, n, r), s = kb.default.createWebSocketStream(i, r.wsOptions);
        return s.url = n, i.on("close", ()=>{
            s.destroy();
        }), s;
    };
    gr.streamBuilder = aT;
    var uT = (t, e)=>{
        yr("browserStreamBuilder");
        let r, i = iT(e).browserBufferSize || 524288, s = e.browserBufferTimeout || 1e3, o = !e.objectMode, a = sT(t, e), c = h(e, E, b);
        e.objectMode || (c._writev = Nl.writev.bind(c)), c.on("close", ()=>{
            a.close();
        });
        let f = typeof a.addEventListener < "u";
        a.readyState === a.OPEN ? (r = c, r.socket = a) : (r = new Nl.BufferedDuplex(e, c, a), f ? a.addEventListener("open", d) : a.onopen = d), f ? (a.addEventListener("close", w), a.addEventListener("error", y), a.addEventListener("message", P)) : (a.onclose = w, a.onerror = y, a.onmessage = P);
        function h(m, v, R) {
            let T = new tT.Transform({
                objectMode: m.objectMode
            });
            return T._write = v, T._flush = R, T;
        }
        function d() {
            yr("WebSocket onOpen"), r instanceof Nl.BufferedDuplex && r.socketReady();
        }
        function w(m) {
            yr("WebSocket onClose", m), r.end(), r.destroy();
        }
        function y(m) {
            yr("WebSocket onError", m);
            let v = new Error("WebSocket error");
            v.event = m, r.destroy(v);
        }
        async function P(m) {
            if (!c || !c.readable || !c.writable) return;
            let { data: v } = m;
            v instanceof ArrayBuffer ? v = Yo.Buffer.from(v) : v instanceof Blob ? v = Yo.Buffer.from(await new Response(v).arrayBuffer()) : v = Yo.Buffer.from(v, "utf8"), c.push(v);
        }
        function E(m, v, R) {
            if (a.bufferedAmount > i) {
                setTimeout(E, s, m, v, R);
                return;
            }
            o && typeof m == "string" && (m = Yo.Buffer.from(m, "utf8"));
            try {
                a.send(m);
            } catch (T) {
                return R(T);
            }
            R();
        }
        function b(m) {
            a.close(), m();
        }
        return r;
    };
    gr.browserStreamBuilder = uT;
});
var $4c2dd1b68d143d96$var$Ll = {};
$4c2dd1b68d143d96$var$Kr($4c2dd1b68d143d96$var$Ll, {
    Server: ()=>$4c2dd1b68d143d96$var$Je,
    Socket: ()=>$4c2dd1b68d143d96$var$Je,
    Stream: ()=>$4c2dd1b68d143d96$var$Je,
    _createServerHandle: ()=>$4c2dd1b68d143d96$var$Je,
    _normalizeArgs: ()=>$4c2dd1b68d143d96$var$Je,
    _setSimultaneousAccepts: ()=>$4c2dd1b68d143d96$var$Je,
    connect: ()=>$4c2dd1b68d143d96$var$Je,
    createConnection: ()=>$4c2dd1b68d143d96$var$Je,
    createServer: ()=>$4c2dd1b68d143d96$var$Je,
    default: ()=>$4c2dd1b68d143d96$var$lT,
    isIP: ()=>$4c2dd1b68d143d96$var$Je,
    isIPv4: ()=>$4c2dd1b68d143d96$var$Je,
    isIPv6: ()=>$4c2dd1b68d143d96$var$Je
});
function $4c2dd1b68d143d96$var$Je() {
    throw new Error("Node.js net module is not supported by JSPM core outside of Node.js");
}
var $4c2dd1b68d143d96$var$lT, $4c2dd1b68d143d96$var$Ul = $4c2dd1b68d143d96$var$ze(()=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    $4c2dd1b68d143d96$var$lT = {
        _createServerHandle: $4c2dd1b68d143d96$var$Je,
        _normalizeArgs: $4c2dd1b68d143d96$var$Je,
        _setSimultaneousAccepts: $4c2dd1b68d143d96$var$Je,
        connect: $4c2dd1b68d143d96$var$Je,
        createConnection: $4c2dd1b68d143d96$var$Je,
        createServer: $4c2dd1b68d143d96$var$Je,
        isIP: $4c2dd1b68d143d96$var$Je,
        isIPv4: $4c2dd1b68d143d96$var$Je,
        isIPv6: $4c2dd1b68d143d96$var$Je,
        Server: $4c2dd1b68d143d96$var$Je,
        Socket: $4c2dd1b68d143d96$var$Je,
        Stream: $4c2dd1b68d143d96$var$Je
    };
});
var $4c2dd1b68d143d96$var$Dl = $4c2dd1b68d143d96$var$D((lH, Mb)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Mb.exports = {};
});
var $4c2dd1b68d143d96$var$Fl = $4c2dd1b68d143d96$var$D((vi)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var jl = vi && vi.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(vi, "__esModule", {
        value: !0
    });
    var cT = jl(($4c2dd1b68d143d96$var$Ul(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$Ll))), fT = jl($4c2dd1b68d143d96$var$At()), hT = jl($4c2dd1b68d143d96$var$Dl()), dT = (0, fT.default)("mqttjs:tcp"), pT = (t, e)=>{
        if (e.port = e.port || 1883, e.hostname = e.hostname || e.host || "localhost", e.socksProxy) return (0, hT.default)(e.hostname, e.port, e.socksProxy, {
            timeout: e.socksTimeout
        });
        let { port: r, path: n } = e, i = e.hostname;
        return dT("port %d and host %s", r, i), cT.default.createConnection({
            port: r,
            host: i,
            path: n
        });
    };
    vi.default = pT;
});
var $4c2dd1b68d143d96$var$Nb = {};
$4c2dd1b68d143d96$var$Kr($4c2dd1b68d143d96$var$Nb, {
    default: ()=>$4c2dd1b68d143d96$var$yT
});
var $4c2dd1b68d143d96$var$yT, $4c2dd1b68d143d96$var$qb = $4c2dd1b68d143d96$var$ze(()=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    $4c2dd1b68d143d96$var$yT = {};
});
var $4c2dd1b68d143d96$var$$l = $4c2dd1b68d143d96$var$D((Si)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var Wl = Si && Si.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(Si, "__esModule", {
        value: !0
    });
    var Lb = ($4c2dd1b68d143d96$var$qb(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$Nb)), gT = Wl(($4c2dd1b68d143d96$var$Ul(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$Ll))), bT = Wl($4c2dd1b68d143d96$var$At()), wT = Wl($4c2dd1b68d143d96$var$Dl()), mT = (0, bT.default)("mqttjs:tls");
    function _T(t) {
        let { host: e, port: r, socksProxy: n, ...i } = t;
        if (n !== void 0) {
            let s = (0, wT.default)(e, r, n, {
                timeout: t.socksTimeout
            });
            return (0, Lb.connect)({
                ...i,
                socket: s
            });
        }
        return (0, Lb.connect)(t);
    }
    var vT = (t, e)=>{
        e.port = e.port || 8883, e.host = e.hostname || e.host || "localhost", gT.default.isIP(e.host) === 0 && (e.servername = e.host), e.rejectUnauthorized = e.rejectUnauthorized !== !1, delete e.path, mT("port %d host %s rejectUnauthorized %b", e.port, e.host, e.rejectUnauthorized);
        let r = _T(e);
        r.on("secureConnect", ()=>{
            e.rejectUnauthorized && !r.authorized ? r.emit("error", new Error("TLS not authorized")) : r.removeListener("error", n);
        });
        function n(i) {
            e.rejectUnauthorized && t.emit("error", i), r.end();
        }
        return r.on("error", n), r;
    };
    Si.default = vT;
});
var $4c2dd1b68d143d96$var$Gl = $4c2dd1b68d143d96$var$D((Vl)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Vl, "__esModule", {
        value: !0
    });
    var Ub = ($4c2dd1b68d143d96$var$ke(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$qe)), ST = $4c2dd1b68d143d96$var$or(), ET = $4c2dd1b68d143d96$var$Qo(), kt, Hl, Xe;
    function AT() {
        let t = new ST.Transform;
        return t._write = (e, r, n)=>{
            kt.send({
                data: e.buffer,
                success () {
                    n();
                },
                fail (i) {
                    n(new Error(i));
                }
            });
        }, t._flush = (e)=>{
            kt.close({
                success () {
                    e();
                }
            });
        }, t;
    }
    function IT(t) {
        t.hostname || (t.hostname = "localhost"), t.path || (t.path = "/"), t.wsOptions || (t.wsOptions = {});
    }
    function xT(t, e) {
        let r = t.protocol === "wxs" ? "wss" : "ws", n = `${r}://${t.hostname}${t.path}`;
        return t.port && t.port !== 80 && t.port !== 443 && (n = `${r}://${t.hostname}:${t.port}${t.path}`), typeof t.transformWsUrl == "function" && (n = t.transformWsUrl(n, t, e)), n;
    }
    function TT() {
        kt.onOpen(()=>{
            Xe.socketReady();
        }), kt.onMessage((t)=>{
            let { data: e } = t;
            e instanceof ArrayBuffer ? e = Ub.Buffer.from(e) : e = Ub.Buffer.from(e, "utf8"), Hl.push(e);
        }), kt.onClose(()=>{
            Xe.emit("close"), Xe.end(), Xe.destroy();
        }), kt.onError((t)=>{
            let e = new Error(t.errMsg);
            Xe.destroy(e);
        });
    }
    var PT = (t, e)=>{
        if (e.hostname = e.hostname || e.host, !e.hostname) throw new Error("Could not determine host. Specify host manually.");
        let r = e.protocolId === "MQIsdp" && e.protocolVersion === 3 ? "mqttv3.1" : "mqtt";
        IT(e);
        let n = xT(e, t);
        kt = wx.connectSocket({
            url: n,
            protocols: [
                r
            ]
        }), Hl = AT(), Xe = new ET.BufferedDuplex(e, Hl, kt), Xe._destroy = (s, o)=>{
            kt.close({
                success () {
                    o && o(s);
                }
            });
        };
        let i = Xe.destroy;
        return Xe.destroy = (s, o)=>(Xe.destroy = i, setTimeout(()=>{
                kt.close({
                    fail () {
                        Xe._destroy(s, o);
                    }
                });
            }, 0), Xe), TT(), Xe;
    };
    Vl.default = PT;
});
var $4c2dd1b68d143d96$var$Ql = $4c2dd1b68d143d96$var$D((Kl)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    Object.defineProperty(Kl, "__esModule", {
        value: !0
    });
    var zl = ($4c2dd1b68d143d96$var$ke(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$qe)), OT = $4c2dd1b68d143d96$var$or(), RT = $4c2dd1b68d143d96$var$Qo(), Kt, Ei, An, Db = !1;
    function kT() {
        let t = new OT.Transform;
        return t._write = (e, r, n)=>{
            Kt.sendSocketMessage({
                data: e.buffer,
                success () {
                    n();
                },
                fail () {
                    n(new Error);
                }
            });
        }, t._flush = (e)=>{
            Kt.closeSocket({
                success () {
                    e();
                }
            });
        }, t;
    }
    function CT(t) {
        t.hostname || (t.hostname = "localhost"), t.path || (t.path = "/"), t.wsOptions || (t.wsOptions = {});
    }
    function BT(t, e) {
        let r = t.protocol === "alis" ? "wss" : "ws", n = `${r}://${t.hostname}${t.path}`;
        return t.port && t.port !== 80 && t.port !== 443 && (n = `${r}://${t.hostname}:${t.port}${t.path}`), typeof t.transformWsUrl == "function" && (n = t.transformWsUrl(n, t, e)), n;
    }
    function MT() {
        Db || (Db = !0, Kt.onSocketOpen(()=>{
            An.socketReady();
        }), Kt.onSocketMessage((t)=>{
            if (typeof t.data == "string") {
                let e = zl.Buffer.from(t.data, "base64");
                Ei.push(e);
            } else {
                let e = new FileReader;
                e.addEventListener("load", ()=>{
                    if (e.result instanceof ArrayBuffer) {
                        Ei.push(zl.Buffer.from(e.result));
                        return;
                    }
                    Ei.push(zl.Buffer.from(e.result, "utf-8"));
                }), e.readAsArrayBuffer(t.data);
            }
        }), Kt.onSocketClose(()=>{
            An.end(), An.destroy();
        }), Kt.onSocketError((t)=>{
            An.destroy(t);
        }));
    }
    var NT = (t, e)=>{
        if (e.hostname = e.hostname || e.host, !e.hostname) throw new Error("Could not determine host. Specify host manually.");
        let r = e.protocolId === "MQIsdp" && e.protocolVersion === 3 ? "mqttv3.1" : "mqtt";
        CT(e);
        let n = BT(e, t);
        return Kt = e.my, Kt.connectSocket({
            url: n,
            protocols: r
        }), Ei = kT(), An = new RT.BufferedDuplex(e, Ei, Kt), MT(), An;
    };
    Kl.default = NT;
});
var $4c2dd1b68d143d96$var$$b = $4c2dd1b68d143d96$var$D((In)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var Jo = In && In.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(In, "__esModule", {
        value: !0
    });
    In.connectAsync = jT;
    var qT = Jo($4c2dd1b68d143d96$var$At()), LT = Jo(($4c2dd1b68d143d96$var$xb(), $4c2dd1b68d143d96$var$me($4c2dd1b68d143d96$var$Ib))), UT = Jo($4c2dd1b68d143d96$var$zo()), jb = Jo($4c2dd1b68d143d96$var$yi());
    typeof $4c2dd1b68d143d96$var$M?.nextTick != "function" && ($4c2dd1b68d143d96$var$M.nextTick = setImmediate);
    var Fb = (0, qT.default)("mqttjs"), Me = null;
    function DT(t) {
        let e;
        if (t.auth) {
            if (e = t.auth.match(/^(.+):(.+)$/), e) {
                let [, r, n] = e;
                t.username = r, t.password = n;
            } else t.username = t.auth;
        }
    }
    function Wb(t, e) {
        if (Fb("connecting to an MQTT broker..."), typeof t == "object" && !e && (e = t, t = ""), e = e || {}, t && typeof t == "string") {
            let i = LT.default.parse(t, !0), s = {};
            if (i.port != null && (s.port = Number(i.port)), s.host = i.hostname, s.query = i.query, s.auth = i.auth, s.protocol = i.protocol, s.path = i.path, e = {
                ...s,
                ...e
            }, !e.protocol) throw new Error("Missing protocol");
            e.protocol = e.protocol.replace(/:$/, "");
        }
        if (e.unixSocket = e.unixSocket || e.protocol?.includes("+unix"), e.unixSocket ? e.protocol = e.protocol.replace("+unix", "") : !e.protocol?.startsWith("ws") && !e.protocol?.startsWith("wx") && delete e.path, DT(e), e.query && typeof e.query.clientId == "string" && (e.clientId = e.query.clientId), jb.default || e.unixSocket ? e.socksProxy = void 0 : e.socksProxy === void 0 && typeof $4c2dd1b68d143d96$var$M < "u" && (e.socksProxy = $4c2dd1b68d143d96$var$M.env.MQTTJS_SOCKS_PROXY), e.cert && e.key) {
            if (e.protocol) {
                if ([
                    "mqtts",
                    "wss",
                    "wxs",
                    "alis"
                ].indexOf(e.protocol) === -1) switch(e.protocol){
                    case "mqtt":
                        e.protocol = "mqtts";
                        break;
                    case "ws":
                        e.protocol = "wss";
                        break;
                    case "wx":
                        e.protocol = "wxs";
                        break;
                    case "ali":
                        e.protocol = "alis";
                        break;
                    default:
                        throw new Error(`Unknown protocol for secure connection: "${e.protocol}"!`);
                }
            } else throw new Error("Missing secure protocol key");
        }
        if (Me || (Me = {}, !jb.default && !e.forceNativeWebSocket ? (Me.ws = $4c2dd1b68d143d96$var$_i().streamBuilder, Me.wss = $4c2dd1b68d143d96$var$_i().streamBuilder, Me.mqtt = $4c2dd1b68d143d96$var$Fl().default, Me.tcp = $4c2dd1b68d143d96$var$Fl().default, Me.ssl = $4c2dd1b68d143d96$var$$l().default, Me.tls = Me.ssl, Me.mqtts = $4c2dd1b68d143d96$var$$l().default) : (Me.ws = $4c2dd1b68d143d96$var$_i().browserStreamBuilder, Me.wss = $4c2dd1b68d143d96$var$_i().browserStreamBuilder, Me.wx = $4c2dd1b68d143d96$var$Gl().default, Me.wxs = $4c2dd1b68d143d96$var$Gl().default, Me.ali = $4c2dd1b68d143d96$var$Ql().default, Me.alis = $4c2dd1b68d143d96$var$Ql().default)), !Me[e.protocol]) {
            let i = [
                "mqtts",
                "wss"
            ].indexOf(e.protocol) !== -1;
            e.protocol = [
                "mqtt",
                "mqtts",
                "ws",
                "wss",
                "wx",
                "wxs",
                "ali",
                "alis"
            ].filter((s, o)=>i && o % 2 === 0 ? !1 : typeof Me[s] == "function")[0];
        }
        if (e.clean === !1 && !e.clientId) throw new Error("Missing clientId for unclean clients");
        e.protocol && (e.defaultProtocol = e.protocol);
        function r(i) {
            return e.servers && ((!i._reconnectCount || i._reconnectCount === e.servers.length) && (i._reconnectCount = 0), e.host = e.servers[i._reconnectCount].host, e.port = e.servers[i._reconnectCount].port, e.protocol = e.servers[i._reconnectCount].protocol ? e.servers[i._reconnectCount].protocol : e.defaultProtocol, e.hostname = e.host, i._reconnectCount++), Fb("calling streambuilder for", e.protocol), Me[e.protocol](i, e);
        }
        let n = new UT.default(r, e);
        return n.on("error", ()=>{}), n;
    }
    function jT(t, e, r = !0) {
        return new Promise((n, i)=>{
            let s = Wb(t, e), o = {
                connect: (c)=>{
                    a(), n(s);
                },
                end: ()=>{
                    a(), n(s);
                },
                error: (c)=>{
                    a(), s.end(), i(c);
                }
            };
            r === !1 && (o.close = ()=>{
                o.error(new Error("Couldn't connect to server"));
            });
            function a() {
                Object.keys(o).forEach((c)=>{
                    s.off(c, o[c]);
                });
            }
            Object.keys(o).forEach((c)=>{
                s.on(c, o[c]);
            });
        });
    }
    In.default = Wb;
});
var $4c2dd1b68d143d96$var$Jl = $4c2dd1b68d143d96$var$D((ge)=>{
    "use strict";
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var Hb = ge && ge.__createBinding || (Object.create ? function(t, e, r, n) {
        n === void 0 && (n = r);
        var i = Object.getOwnPropertyDescriptor(e, r);
        (!i || ("get" in i ? !e.__esModule : i.writable || i.configurable)) && (i = {
            enumerable: !0,
            get: function() {
                return e[r];
            }
        }), Object.defineProperty(t, n, i);
    } : function(t, e, r, n) {
        n === void 0 && (n = r), t[n] = e[r];
    }), FT = ge && ge.__setModuleDefault || (Object.create ? function(t, e) {
        Object.defineProperty(t, "default", {
            enumerable: !0,
            value: e
        });
    } : function(t, e) {
        t.default = e;
    }), WT = ge && ge.__importStar || function() {
        var t = function(e) {
            return t = Object.getOwnPropertyNames || function(r) {
                var n = [];
                for(var i in r)Object.prototype.hasOwnProperty.call(r, i) && (n[n.length] = i);
                return n;
            }, t(e);
        };
        return function(e) {
            if (e && e.__esModule) return e;
            var r = {};
            if (e != null) for(var n = t(e), i = 0; i < n.length; i++)n[i] !== "default" && Hb(r, e, n[i]);
            return FT(r, e), r;
        };
    }(), Yl = ge && ge.__exportStar || function(t, e) {
        for(var r in t)r !== "default" && !Object.prototype.hasOwnProperty.call(e, r) && Hb(e, t, r);
    }, Ai = ge && ge.__importDefault || function(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    };
    Object.defineProperty(ge, "__esModule", {
        value: !0
    });
    ge.ReasonCodes = ge.KeepaliveManager = ge.UniqueMessageIdProvider = ge.DefaultMessageIdProvider = ge.Store = ge.MqttClient = ge.connectAsync = ge.connect = ge.Client = void 0;
    var Vb = Ai($4c2dd1b68d143d96$var$zo());
    ge.MqttClient = Vb.default;
    var $T = Ai($4c2dd1b68d143d96$var$Iu());
    ge.DefaultMessageIdProvider = $T.default;
    var HT = Ai($4c2dd1b68d143d96$var$qg());
    ge.UniqueMessageIdProvider = HT.default;
    var VT = Ai($4c2dd1b68d143d96$var$Ua());
    ge.Store = VT.default;
    var Gb = WT($4c2dd1b68d143d96$var$$b());
    ge.connect = Gb.default;
    Object.defineProperty(ge, "connectAsync", {
        enumerable: !0,
        get: function() {
            return Gb.connectAsync;
        }
    });
    var GT = Ai($4c2dd1b68d143d96$var$ju());
    ge.KeepaliveManager = GT.default;
    ge.Client = Vb.default;
    Yl($4c2dd1b68d143d96$var$zo(), ge);
    Yl($4c2dd1b68d143d96$var$Mr(), ge);
    Yl($4c2dd1b68d143d96$var$Na(), ge);
    var zT = $4c2dd1b68d143d96$var$zn();
    Object.defineProperty(ge, "ReasonCodes", {
        enumerable: !0,
        get: function() {
            return zT.ReasonCodes;
        }
    });
});
var $4c2dd1b68d143d96$var$XT = $4c2dd1b68d143d96$var$D((ot)=>{
    $4c2dd1b68d143d96$var$A();
    $4c2dd1b68d143d96$var$x();
    $4c2dd1b68d143d96$var$I();
    var zb = ot && ot.__createBinding || (Object.create ? function(t, e, r, n) {
        n === void 0 && (n = r);
        var i = Object.getOwnPropertyDescriptor(e, r);
        (!i || ("get" in i ? !e.__esModule : i.writable || i.configurable)) && (i = {
            enumerable: !0,
            get: function() {
                return e[r];
            }
        }), Object.defineProperty(t, n, i);
    } : function(t, e, r, n) {
        n === void 0 && (n = r), t[n] = e[r];
    }), KT = ot && ot.__setModuleDefault || (Object.create ? function(t, e) {
        Object.defineProperty(t, "default", {
            enumerable: !0,
            value: e
        });
    } : function(t, e) {
        t.default = e;
    }), QT = ot && ot.__importStar || function() {
        var t = function(e) {
            return t = Object.getOwnPropertyNames || function(r) {
                var n = [];
                for(var i in r)Object.prototype.hasOwnProperty.call(r, i) && (n[n.length] = i);
                return n;
            }, t(e);
        };
        return function(e) {
            if (e && e.__esModule) return e;
            var r = {};
            if (e != null) for(var n = t(e), i = 0; i < n.length; i++)n[i] !== "default" && zb(r, e, n[i]);
            return KT(r, e), r;
        };
    }(), YT = ot && ot.__exportStar || function(t, e) {
        for(var r in t)r !== "default" && !Object.prototype.hasOwnProperty.call(e, r) && zb(e, t, r);
    };
    Object.defineProperty(ot, "__esModule", {
        value: !0
    });
    var JT = QT($4c2dd1b68d143d96$var$Jl());
    ot.default = JT;
    YT($4c2dd1b68d143d96$var$Jl(), ot);
});
var $4c2dd1b68d143d96$export$2e2bcd8739ae039 /*! Bundled license information:

@jspm/core/nodelibs/browser/chunk-DtuTasat.js:
  (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)

safe-buffer/index.js:
  (*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> *)

@babel/runtime/helpers/regenerator.js:
  (*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE *)
*/  = $4c2dd1b68d143d96$var$XT();




class $07053aed662f811a$export$320e4b58b7eeecaf {
    static #_ = this.levelsCache = new (0, $39a8095e56de6b13$export$94affb487e701bf2)(([path])=>`${String(path === null)}_${String(path)}`);
    static #_2 = this.isExactCache = new (0, $39a8095e56de6b13$export$94affb487e701bf2)(([path])=>path);
    static #_3 = this.isValidCache = new (0, $39a8095e56de6b13$export$94affb487e701bf2)(([path, depth])=>`${path}_${depth}`);
    static #_4 = this.isSourceCache = new (0, $39a8095e56de6b13$export$94affb487e701bf2)((/**
             * The key here is generated using the invalid markup,
             * as those can't be used in real topics,
             * making our serialization much easier
             */ [path, source])=>`${path}_${this.invalidSymbolMarkup}_${source}`);
    static #_5 = this.isPrefixedCache = new (0, $39a8095e56de6b13$export$94affb487e701bf2)((/**
             * The key here is generated using the invalid markup,
             * as those can't be used in real topics,
             * making our serialization much easier
             */ [prefix, source])=>`${prefix}_${this.invalidSymbolMarkup}_${source}`);
    static #_6 = this.levelDelimiter = '/';
    static #_7 = this.multipleLineMatchMarkup = '#';
    static #_8 = this.singleLineMatchMarkup = '+';
    static #_9 = /**
     * Topic Names and Topic Filters MUST NOT include the null character (Unicode U+0000)
     * @see https://docs.oasis-open.org/mqtt/mqtt/v3.1.1/os/mqtt-v3.1.1-os.html#_Toc384800482
     */ this.invalidSymbolMarkup = '\u0000';
    /**
     * Splits the given topic & source into their parts
     * If it detect that there is multi-level wildcard at the source,
     * Then, it removes everything after that index & returns only the parts before that multi-level wildcard index
     */ static getNonMultiLevelWildcardTopicParts(topic, base) {
        /**
         * Split everything by levels
         */ let topicParts = this.fromPath(topic);
        let sourceParts = this.fromPath(base);
        /**
         * There can be only one # (@see https://upload.wikimedia.org/wikipedia/en/b/bc/Highlander_1986%2Cposter.jpg)
         * It has to be the last char in order for the sub to be valid
         * So if we find it, we remove everything after it
         */ const wildcardPosition = sourceParts.indexOf(this.multipleLineMatchMarkup);
        if (wildcardPosition >= 0) {
            sourceParts = sourceParts.slice(0, wildcardPosition);
            topicParts = topicParts.slice(0, wildcardPosition);
        }
        return [
            topicParts,
            sourceParts
        ];
    }
    /**
     * Match every source & topic parts by level
     * Returns true, if it detect single-level wildcard at the source part, or topic & source part are same
     */ static doNonMultiLevelPartsMatch(a, b) {
        return a.every((topicPart, index)=>{
            const sourcePart = b[index];
            /**
             * Now we handle one level deep wildcards (+)
             * There can be any amount
             */ return sourcePart === this.singleLineMatchMarkup || sourcePart === topicPart;
        });
    }
    static isExact(topic) {
        return this.isExactCache.get(()=>[
                this.singleLineMatchMarkup,
                this.multipleLineMatchMarkup
            ].every((symbol)=>!this.fromPath(topic).includes(symbol)), topic);
    }
    static isValid(topic, maxDepth) {
        return this.isValidCache.get(()=>{
            /**
                 * All Topic Names and Topic Filters MUST be at least one character long
                 * Topic Names and Topic Filters are UTF-8 encoded strings, they MUST NOT encode to more than 65535 bytes
                 * @see https://docs.oasis-open.org/mqtt/mqtt/v3.1.1/os/mqtt-v3.1.1-os.html#_Toc384800482
                 */ if (topic.length <= 0 || topic.length > 65535) return false;
            /**
                 * Topic Names and Topic Filters MUST NOT include the null character (Unicode U+0000)
                 * @see https://docs.oasis-open.org/mqtt/mqtt/v3.1.1/os/mqtt-v3.1.1-os.html#_Toc384800482
                 */ if (topic.includes(this.invalidSymbolMarkup)) return false;
            const levels = this.fromPath(topic);
            if (levels.length > maxDepth) /**
                     * This topic is too deep
                     */ return false;
            return (0, $4c2dd1b68d143d96$export$2e2bcd8739ae039).validateTopic(topic);
        }, topic, maxDepth);
    }
    static isSource(topic, source) {
        return this.isSourceCache.get(()=>{
            if (topic === source) return true;
            const [topicParts, sourceParts] = this.getNonMultiLevelWildcardTopicParts(topic, source);
            if (topicParts.length !== sourceParts.length) /**
                     * A mismatch in sizes is not expected from this point on
                     * As any-levels wildcards have been done away with
                     */ return false;
            return this.doNonMultiLevelPartsMatch(topicParts, sourceParts);
        }, topic, source);
    }
    static isPrefixedBy(prefixTopic, topic) {
        return this.isPrefixedCache.get(()=>{
            if (prefixTopic === topic) return true;
            const [prefixParts, topicParts] = this.getNonMultiLevelWildcardTopicParts(prefixTopic, topic);
            const endsWithSlash = !prefixParts[prefixParts.length - 1];
            return this.doNonMultiLevelPartsMatch(/**
                     * Cuts off the prefix's last part if it ends with a slash
                     * unless the prefix is shorter than the source and thus
                     * needs another level becomes relevant again
                     */ prefixParts.slice(0, prefixParts.length - Number(endsWithSlash && prefixParts.length <= topicParts.length)), /**
                     * Cut of to the level of the source without the trailing slash
                     */ topicParts.slice(0, prefixParts.length - Number(endsWithSlash)));
        }, prefixTopic, topic);
    }
    static fromPath(topic) {
        return this.levelsCache.get(/**
             * An Mqtt topic can **not** be an empty string, but levels beyond the first one can
             * So when calculating the levels, and there is nothing above the given path (IE isForChild === false)
             * Then yield no levels, otherwise, yield an empty set of levels
             *
             * @see https://docs.oasis-open.org/mqtt/mqtt/v3.1.1/os/mqtt-v3.1.1-os.html#_Toc384800482
             */ ()=>topic !== null ? topic.split($07053aed662f811a$export$320e4b58b7eeecaf.levelDelimiter) : [], topic);
    }
    static toPath(...levels) {
        return levels.join(this.levelDelimiter);
    }
    constructor(/**
         * Null value is used to denominate a root node that doesn't have value on its own
         */ fullPath, maxDepth){
        this.fullPath = fullPath;
        this.maxDepth = maxDepth;
    }
    get levels() {
        return this.withFullPath((fullPath)=>$07053aed662f811a$export$320e4b58b7eeecaf.fromPath(fullPath), null);
    }
    get lastLevel() {
        return this.levels && (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(this.levels) ? (0, $9f70c141ac08ef9a$export$109d9d261d61ca16)(this.levels) : null;
    }
    get valid() {
        const { maxDepth: maxDepth } = this;
        (0, $14eddac5f20c576c$export$a7a9523472993e97)(maxDepth !== null, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Invalid max topic depth provided'));
        return this.withFullPath((fullPath)=>$07053aed662f811a$export$320e4b58b7eeecaf.isValid(fullPath, maxDepth), false);
    }
    get exact() {
        return this.withFullPath((fullPath)=>$07053aed662f811a$export$320e4b58b7eeecaf.isExact(fullPath), null);
    }
    withFullPath(transformer, withNoPath) {
        return this.fullPath === null ? withNoPath : transformer(this.fullPath);
    }
    createChild(childTopic) {
        const levels = $07053aed662f811a$export$320e4b58b7eeecaf.fromPath(this.fullPath);
        /**
         * The function fromPath should yield at least a single sized array
         * Even if it contains only an empty string
         */ const [firstLevel, ...restLevels] = $07053aed662f811a$export$320e4b58b7eeecaf.fromPath(childTopic);
        return [
            new $07053aed662f811a$export$320e4b58b7eeecaf($07053aed662f811a$export$320e4b58b7eeecaf.toPath(...levels, firstLevel), this.maxDepth),
            restLevels.length ? $07053aed662f811a$export$320e4b58b7eeecaf.toPath(...restLevels) : null
        ];
    }
    isPrefixedBy(topics) {
        return this.withFullPath((fullPath)=>topics.some((topic)=>$07053aed662f811a$export$320e4b58b7eeecaf.isPrefixedBy(fullPath, topic)), false);
    }
    isSourcedFrom(topics) {
        return this.withFullPath((fullPath)=>topics.some((source)=>$07053aed662f811a$export$320e4b58b7eeecaf.isSource(fullPath, source)), false);
    }
    filterSources(topics) {
        return this.withFullPath((fullPath)=>topics.filter((source)=>$07053aed662f811a$export$320e4b58b7eeecaf.isSource(fullPath, source)), []);
    }
}



var $8fJ0j = parcelRequire("8fJ0j");
var $e83e10387b18cd27$require$Buffer = $8fJ0j.Buffer;
const $e83e10387b18cd27$var$errorMap = {
    genericError: (0, $c3e1b746ad236797$export$13cd8ea82c82bf53).SERVER_ERROR,
    couldNotReconnect: (0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED,
    couldNotConnect: (0, $c3e1b746ad236797$export$13cd8ea82c82bf53).CONFIGURATION_ERROR,
    state: (0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED
};
const $e83e10387b18cd27$var$errorMessageMap = {
    genericError: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MQTT_GENERIC_ERROR,
    couldNotReconnect: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MQTT_GENERIC_ERROR,
    couldNotConnect: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MQTT_COULD_NOT_CONNECT_ERROR,
    state: (0, $40a99dac858c1d75$export$b63289fbda65eed1).MQTT_GENERIC_ERROR
};
const $e83e10387b18cd27$var$deserializeTopicMessageEvent = ({ payload: payload, ...line })=>({
        ...line,
        payload: $e83e10387b18cd27$require$Buffer.from(payload)
    });
class $e83e10387b18cd27$var$MqttTopicsSubscription {
    constructor(dynamicArgsGetter, { timeout: timeout, cycle: cycle, maxTopicDepth: maxTopicDepth, translationService: translationService }){
        this.droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        this.messages = new (0, $9fc21cc786388d5a$export$3291343375ee8b92)();
        this.errors = new (0, $9fc21cc786388d5a$export$3291343375ee8b92)();
        this.topics = new (0, $9fc21cc786388d5a$export$668230531b0abb74)({
            id: NaN,
            topics: []
        });
        this.subscriptions = new (0, $9fc21cc786388d5a$export$3291343375ee8b92)();
        this.subscriptionId = 0;
        const { url: url, username: username, password: password, worker: worker } = dynamicArgsGetter();
        /** Connect the created worker */ worker.send({
            action: 'connect',
            url: url.toString(),
            username: username,
            password: password,
            timeout: timeout,
            cycle: cycle,
            maxTopicDepth: maxTopicDepth
        });
        /** Setup drop listener, once droped, disconnect mqtt and terminate worker */ this.droppable.onDrop(()=>{
            worker.send({
                action: 'disconnect'
            });
            worker.terminate();
        });
        /** If there is a change in topics being subscribed, update them */ this.droppable.onDrop(this.topics.onChange(([, { id: id, topics: topics }])=>worker.send({
                action: 'subscribe',
                topics: topics,
                id: id
            })));
        /** Handles mqtt errors and new incoming message batches */ this.droppable.onDrop(worker.listen((data)=>{
            switch(data.action){
                case 'messages':
                    // The worker can take some time to load batches...
                    if ((0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(data.batch) && (0, $0b21958d2ab6642d$export$cf8d5bedcfe04f6)(data.topics, this.topics.value.topics)) // ...If you are here, it means the batch has relevant topics to the currently subscribed topics
                    this.messages.trigger(data.batch.map($e83e10387b18cd27$var$deserializeTopicMessageEvent));
                    break;
                case 'error':
                    this.errors.trigger(new (0, $c3e1b746ad236797$export$8d524fb6540252df)($e83e10387b18cd27$var$errorMap[data.type], translationService.translate($e83e10387b18cd27$var$errorMessageMap[data.type]), data.type === 'couldNotConnect' ? {
                        url: url,
                        username: username,
                        timeout: timeout
                    } : {
                        originalMessage: data.message
                    }));
                    /** Stop the presses */ this.end();
                    break;
                case 'subscription':
                    this.subscriptions.trigger([
                        data.id,
                        data.response
                    ]);
                    break;
            }
        }));
    }
    onBatch(listener) {
        return this.messages.on(listener);
    }
    onLastMessage(listener) {
        return this.onBatch((batch)=>listener((0, $9f70c141ac08ef9a$export$109d9d261d61ca16)(batch)));
    }
    onError(listener) {
        return this.errors.on(listener);
    }
    subscribe(topics) {
        return new Promise((resolve)=>{
            /** Define id that will be used to identify returning messages */ const id = ++this.subscriptionId;
            /** Setup drop listener flow */ const droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
            this.droppable.onDrop(()=>droppable.drop());
            /** Setup a new listener that will wait for a subscription response */ droppable.onDrop(this.subscriptions.on(([returnId, response])=>{
                if (id !== returnId) return;
                /** Matched, drop this listener */ droppable.drop();
                /** Finalize promise */ resolve(response);
            }));
            /** Finally trigger the topics to change */ this.topics.change({
                id: id,
                topics: topics
            });
        });
    }
    end() {
        return this.droppable.drop();
    }
}
class $e83e10387b18cd27$export$d832ee6c181d9601 {
    constructor(dynamicArgsGetter, staticArgs){
        this.dynamicArgsGetter = dynamicArgsGetter;
        this.staticArgs = staticArgs;
    }
    createTopic(path) {
        return new (0, $07053aed662f811a$export$320e4b58b7eeecaf)(path, this.staticArgs.maxTopicDepth);
    }
    createSubscription() {
        return new $e83e10387b18cd27$var$MqttTopicsSubscription(this.dynamicArgsGetter, this.staticArgs);
    }
}


/**
 * Here so mqtt lib works on the browser
 * @see {https://github.com/mqttjs/MQTT.js/issues/1474}
 * @see {https://github.com/mqttjs/MQTT.js/pull/1497}
 */ // TODO: Remove this module from `core-js@4` since it's split to modules listed below
var $9d2aa0c06cf9981d$exports = {};
var $0a054db221c0f15e$exports = {};
var $0a054db221c0f15e$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$0a054db221c0f15e$exports = // eslint-disable-next-line es/no-global-this -- safe
$0a054db221c0f15e$var$check(typeof globalThis == 'object' && globalThis) || $0a054db221c0f15e$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$0a054db221c0f15e$var$check(typeof self == 'object' && self) || $0a054db221c0f15e$var$check(typeof $parcel$global == 'object' && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || $0a054db221c0f15e$exports || Function('return this')();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $1bf1c27592d288d8$export$2d1720544b23b823;
var $811d8a9f70056560$exports = {};
var $0a54724770c9d119$exports = {};
$0a54724770c9d119$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$811d8a9f70056560$exports = !$0a54724770c9d119$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});


var $7f13d6c61e686faa$exports = {};
var $6eaa9cebbcd3667e$exports = {};

$6eaa9cebbcd3667e$exports = !$0a54724770c9d119$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});


var $7f13d6c61e686faa$var$call = Function.prototype.call;
$7f13d6c61e686faa$exports = $6eaa9cebbcd3667e$exports ? $7f13d6c61e686faa$var$call.bind($7f13d6c61e686faa$var$call) : function() {
    return $7f13d6c61e686faa$var$call.apply($7f13d6c61e686faa$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $667703b6f4538b30$export$2d1720544b23b823;
'use strict';
var $667703b6f4538b30$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $667703b6f4538b30$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $667703b6f4538b30$var$NASHORN_BUG = $667703b6f4538b30$var$getOwnPropertyDescriptor && !$667703b6f4538b30$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$667703b6f4538b30$export$2d1720544b23b823 = $667703b6f4538b30$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $667703b6f4538b30$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $667703b6f4538b30$var$$propertyIsEnumerable;


var $c741da8096e15ef9$exports = {};
$c741da8096e15ef9$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $2a9ab4e9ecf3374f$exports = {};
// toObject with fallback for non-array-like ES3 strings
var $f1f66d2938a5b411$exports = {};
var $b0d9d61806655616$exports = {};

var $b0d9d61806655616$var$FunctionPrototype = Function.prototype;
var $b0d9d61806655616$var$call = $b0d9d61806655616$var$FunctionPrototype.call;
var $b0d9d61806655616$var$uncurryThisWithBind = $6eaa9cebbcd3667e$exports && $b0d9d61806655616$var$FunctionPrototype.bind.bind($b0d9d61806655616$var$call, $b0d9d61806655616$var$call);
$b0d9d61806655616$exports = $6eaa9cebbcd3667e$exports ? $b0d9d61806655616$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $b0d9d61806655616$var$call.apply(fn, arguments);
    };
};



var $d39aaece64624764$exports = {};

var $d39aaece64624764$var$toString = $b0d9d61806655616$exports({}.toString);
var $d39aaece64624764$var$stringSlice = $b0d9d61806655616$exports(''.slice);
$d39aaece64624764$exports = function(it) {
    return $d39aaece64624764$var$stringSlice($d39aaece64624764$var$toString(it), 8, -1);
};


var $f1f66d2938a5b411$var$$Object = Object;
var $f1f66d2938a5b411$var$split = $b0d9d61806655616$exports(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$f1f66d2938a5b411$exports = $0a54724770c9d119$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$f1f66d2938a5b411$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $d39aaece64624764$exports(it) == 'String' ? $f1f66d2938a5b411$var$split(it, '') : $f1f66d2938a5b411$var$$Object(it);
} : $f1f66d2938a5b411$var$$Object;


var $d44f851bb76c5f79$exports = {};
var $c59c4b1975fe27ef$exports = {};
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$c59c4b1975fe27ef$exports = function(it) {
    return it === null || it === undefined;
};


var $d44f851bb76c5f79$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$d44f851bb76c5f79$exports = function(it) {
    if ($c59c4b1975fe27ef$exports(it)) throw $d44f851bb76c5f79$var$$TypeError("Can't call method on " + it);
    return it;
};


$2a9ab4e9ecf3374f$exports = function(it) {
    return $f1f66d2938a5b411$exports($d44f851bb76c5f79$exports(it));
};


var $ee66af91b67186b9$exports = {};
var $a33f2c3b4645211d$exports = {};

var $5189f72eb185181d$exports = {};
var $d01e71850d02c39e$exports = {};
var $cc998adc97313712$exports = {};
var $cc998adc97313712$var$documentAll = typeof document == 'object' && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $cc998adc97313712$var$IS_HTMLDDA = typeof $cc998adc97313712$var$documentAll == 'undefined' && $cc998adc97313712$var$documentAll !== undefined;
$cc998adc97313712$exports = {
    all: $cc998adc97313712$var$documentAll,
    IS_HTMLDDA: $cc998adc97313712$var$IS_HTMLDDA
};


var $d01e71850d02c39e$var$documentAll = $cc998adc97313712$exports.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
$d01e71850d02c39e$exports = $cc998adc97313712$exports.IS_HTMLDDA ? function(argument) {
    return typeof argument == 'function' || argument === $d01e71850d02c39e$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};



var $5189f72eb185181d$var$documentAll = $cc998adc97313712$exports.all;
$5189f72eb185181d$exports = $cc998adc97313712$exports.IS_HTMLDDA ? function(it) {
    return typeof it == 'object' ? it !== null : $d01e71850d02c39e$exports(it) || it === $5189f72eb185181d$var$documentAll;
} : function(it) {
    return typeof it == 'object' ? it !== null : $d01e71850d02c39e$exports(it);
};


var $f9ab9ed12d08f4b3$exports = {};
var $6559aa8e66ece2fa$exports = {};


var $6559aa8e66ece2fa$var$aFunction = function(argument) {
    return $d01e71850d02c39e$exports(argument) ? argument : undefined;
};
$6559aa8e66ece2fa$exports = function(namespace, method) {
    return arguments.length < 2 ? $6559aa8e66ece2fa$var$aFunction($0a054db221c0f15e$exports[namespace]) : $0a054db221c0f15e$exports[namespace] && $0a054db221c0f15e$exports[namespace][method];
};



var $2bb710ba06b7da5d$exports = {};

$2bb710ba06b7da5d$exports = $b0d9d61806655616$exports({}.isPrototypeOf);


var $7bec59d531746206$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ var $2d64b28ecf9d0a20$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ var $6748ad10943803ff$exports = {};

var $b897f5ee5c2f82f9$exports = {};
$b897f5ee5c2f82f9$exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


var $6748ad10943803ff$var$process = $0a054db221c0f15e$exports.process;
var $6748ad10943803ff$var$Deno = $0a054db221c0f15e$exports.Deno;
var $6748ad10943803ff$var$versions = $6748ad10943803ff$var$process && $6748ad10943803ff$var$process.versions || $6748ad10943803ff$var$Deno && $6748ad10943803ff$var$Deno.version;
var $6748ad10943803ff$var$v8 = $6748ad10943803ff$var$versions && $6748ad10943803ff$var$versions.v8;
var $6748ad10943803ff$var$match, $6748ad10943803ff$var$version;
if ($6748ad10943803ff$var$v8) {
    $6748ad10943803ff$var$match = $6748ad10943803ff$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $6748ad10943803ff$var$version = $6748ad10943803ff$var$match[0] > 0 && $6748ad10943803ff$var$match[0] < 4 ? 1 : +($6748ad10943803ff$var$match[0] + $6748ad10943803ff$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$6748ad10943803ff$var$version && $b897f5ee5c2f82f9$exports) {
    $6748ad10943803ff$var$match = $b897f5ee5c2f82f9$exports.match(/Edge\/(\d+)/);
    if (!$6748ad10943803ff$var$match || $6748ad10943803ff$var$match[1] >= 74) {
        $6748ad10943803ff$var$match = $b897f5ee5c2f82f9$exports.match(/Chrome\/(\d+)/);
        if ($6748ad10943803ff$var$match) $6748ad10943803ff$var$version = +$6748ad10943803ff$var$match[1];
    }
}
$6748ad10943803ff$exports = $6748ad10943803ff$var$version;




var $2d64b28ecf9d0a20$var$$String = $0a054db221c0f15e$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$2d64b28ecf9d0a20$exports = !!Object.getOwnPropertySymbols && !$0a54724770c9d119$exports(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$2d64b28ecf9d0a20$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $6748ad10943803ff$exports && $6748ad10943803ff$exports < 41;
});


$7bec59d531746206$exports = $2d64b28ecf9d0a20$exports && !Symbol.sham && typeof Symbol.iterator == 'symbol';


var $f9ab9ed12d08f4b3$var$$Object = Object;
$f9ab9ed12d08f4b3$exports = $7bec59d531746206$exports ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $6559aa8e66ece2fa$exports('Symbol');
    return $d01e71850d02c39e$exports($Symbol) && $2bb710ba06b7da5d$exports($Symbol.prototype, $f9ab9ed12d08f4b3$var$$Object(it));
};


var $00e12a624f18a8c7$exports = {};
var $2a03b58aeff71e08$exports = {};

var $696bf8b560d228b5$exports = {};
var $696bf8b560d228b5$var$$String = String;
$696bf8b560d228b5$exports = function(argument) {
    try {
        return $696bf8b560d228b5$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};


var $2a03b58aeff71e08$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$2a03b58aeff71e08$exports = function(argument) {
    if ($d01e71850d02c39e$exports(argument)) return argument;
    throw $2a03b58aeff71e08$var$$TypeError($696bf8b560d228b5$exports(argument) + ' is not a function');
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$00e12a624f18a8c7$exports = function(V, P) {
    var func = V[P];
    return $c59c4b1975fe27ef$exports(func) ? undefined : $2a03b58aeff71e08$exports(func);
};


var $313a45b42f7d9ba9$exports = {};



var $313a45b42f7d9ba9$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$313a45b42f7d9ba9$exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $d01e71850d02c39e$exports(fn = input.toString) && !$5189f72eb185181d$exports(val = $7f13d6c61e686faa$exports(fn, input))) return val;
    if ($d01e71850d02c39e$exports(fn = input.valueOf) && !$5189f72eb185181d$exports(val = $7f13d6c61e686faa$exports(fn, input))) return val;
    if (pref !== 'string' && $d01e71850d02c39e$exports(fn = input.toString) && !$5189f72eb185181d$exports(val = $7f13d6c61e686faa$exports(fn, input))) return val;
    throw $313a45b42f7d9ba9$var$$TypeError("Can't convert object to primitive value");
};


var $8cabe6be4a5e0c0c$exports = {};

var $892ce4a36c053529$exports = {};
var $fa004ad599b1ee23$exports = {};
$fa004ad599b1ee23$exports = false;


var $ec2a9bdd44264973$exports = {};

var $1886608243484f3b$exports = {};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $1886608243484f3b$var$defineProperty = Object.defineProperty;
$1886608243484f3b$exports = function(key, value) {
    try {
        $1886608243484f3b$var$defineProperty($0a054db221c0f15e$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $0a054db221c0f15e$exports[key] = value;
    }
    return value;
};


var $ec2a9bdd44264973$var$SHARED = '__core-js_shared__';
var $ec2a9bdd44264973$var$store = $0a054db221c0f15e$exports[$ec2a9bdd44264973$var$SHARED] || $1886608243484f3b$exports($ec2a9bdd44264973$var$SHARED, {});
$ec2a9bdd44264973$exports = $ec2a9bdd44264973$var$store;


($892ce4a36c053529$exports = function(key, value) {
    return $ec2a9bdd44264973$exports[key] || ($ec2a9bdd44264973$exports[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: '3.30.2',
    mode: $fa004ad599b1ee23$exports ? 'pure' : 'global',
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: 'https://github.com/zloirock/core-js/blob/v3.30.2/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});


var $1e350ae3e9a02430$exports = {};

var $32d7af80aea36a96$exports = {};

var $32d7af80aea36a96$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$32d7af80aea36a96$exports = function(argument) {
    return $32d7af80aea36a96$var$$Object($d44f851bb76c5f79$exports(argument));
};


var $1e350ae3e9a02430$var$hasOwnProperty = $b0d9d61806655616$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$1e350ae3e9a02430$exports = Object.hasOwn || function hasOwn(it, key) {
    return $1e350ae3e9a02430$var$hasOwnProperty($32d7af80aea36a96$exports(it), key);
};


var $81f30dc071ad395c$exports = {};

var $81f30dc071ad395c$var$id = 0;
var $81f30dc071ad395c$var$postfix = Math.random();
var $81f30dc071ad395c$var$toString = $b0d9d61806655616$exports(1.0.toString);
$81f30dc071ad395c$exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $81f30dc071ad395c$var$toString(++$81f30dc071ad395c$var$id + $81f30dc071ad395c$var$postfix, 36);
};




var $8cabe6be4a5e0c0c$var$Symbol = $0a054db221c0f15e$exports.Symbol;
var $8cabe6be4a5e0c0c$var$WellKnownSymbolsStore = $892ce4a36c053529$exports('wks');
var $8cabe6be4a5e0c0c$var$createWellKnownSymbol = $7bec59d531746206$exports ? $8cabe6be4a5e0c0c$var$Symbol['for'] || $8cabe6be4a5e0c0c$var$Symbol : $8cabe6be4a5e0c0c$var$Symbol && $8cabe6be4a5e0c0c$var$Symbol.withoutSetter || $81f30dc071ad395c$exports;
$8cabe6be4a5e0c0c$exports = function(name) {
    if (!$1e350ae3e9a02430$exports($8cabe6be4a5e0c0c$var$WellKnownSymbolsStore, name)) $8cabe6be4a5e0c0c$var$WellKnownSymbolsStore[name] = $2d64b28ecf9d0a20$exports && $1e350ae3e9a02430$exports($8cabe6be4a5e0c0c$var$Symbol, name) ? $8cabe6be4a5e0c0c$var$Symbol[name] : $8cabe6be4a5e0c0c$var$createWellKnownSymbol('Symbol.' + name);
    return $8cabe6be4a5e0c0c$var$WellKnownSymbolsStore[name];
};


var $a33f2c3b4645211d$var$$TypeError = TypeError;
var $a33f2c3b4645211d$var$TO_PRIMITIVE = $8cabe6be4a5e0c0c$exports('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$a33f2c3b4645211d$exports = function(input, pref) {
    if (!$5189f72eb185181d$exports(input) || $f9ab9ed12d08f4b3$exports(input)) return input;
    var exoticToPrim = $00e12a624f18a8c7$exports(input, $a33f2c3b4645211d$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $7f13d6c61e686faa$exports(exoticToPrim, input, pref);
        if (!$5189f72eb185181d$exports(result) || $f9ab9ed12d08f4b3$exports(result)) return result;
        throw $a33f2c3b4645211d$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $313a45b42f7d9ba9$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$ee66af91b67186b9$exports = function(argument) {
    var key = $a33f2c3b4645211d$exports(argument, 'string');
    return $f9ab9ed12d08f4b3$exports(key) ? key : key + '';
};



var $33abe47938651948$exports = {};


var $4b1f87f61316b1b2$exports = {};


var $4b1f87f61316b1b2$var$document = $0a054db221c0f15e$exports.document;
// typeof document.createElement is 'object' in old IE
var $4b1f87f61316b1b2$var$EXISTS = $5189f72eb185181d$exports($4b1f87f61316b1b2$var$document) && $5189f72eb185181d$exports($4b1f87f61316b1b2$var$document.createElement);
$4b1f87f61316b1b2$exports = function(it) {
    return $4b1f87f61316b1b2$var$EXISTS ? $4b1f87f61316b1b2$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$33abe47938651948$exports = !$811d8a9f70056560$exports && !$0a54724770c9d119$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($4b1f87f61316b1b2$exports('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1bf1c27592d288d8$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$1bf1c27592d288d8$export$2d1720544b23b823 = $811d8a9f70056560$exports ? $1bf1c27592d288d8$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $2a9ab4e9ecf3374f$exports(O);
    P = $ee66af91b67186b9$exports(P);
    if ($33abe47938651948$exports) try {
        return $1bf1c27592d288d8$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($1e350ae3e9a02430$exports(O, P)) return $c741da8096e15ef9$exports(!$7f13d6c61e686faa$exports($667703b6f4538b30$export$2d1720544b23b823, O, P), O[P]);
};


var $9d2aa0c06cf9981d$require$getOwnPropertyDescriptor = $1bf1c27592d288d8$export$2d1720544b23b823;
var $6eb85d8841785741$exports = {};

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $7f34f771f864b1ae$export$2d1720544b23b823;


var $3d313964c5a0e252$exports = {};


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$3d313964c5a0e252$exports = $811d8a9f70056560$exports && $0a54724770c9d119$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype != 42;
});


var $651a30bf2719885c$exports = {};

var $651a30bf2719885c$var$$String = String;
var $651a30bf2719885c$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$651a30bf2719885c$exports = function(argument) {
    if ($5189f72eb185181d$exports(argument)) return argument;
    throw $651a30bf2719885c$var$$TypeError($651a30bf2719885c$var$$String(argument) + ' is not an object');
};



var $7f34f771f864b1ae$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $7f34f771f864b1ae$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $7f34f771f864b1ae$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $7f34f771f864b1ae$var$ENUMERABLE = 'enumerable';
var $7f34f771f864b1ae$var$CONFIGURABLE = 'configurable';
var $7f34f771f864b1ae$var$WRITABLE = 'writable';
$7f34f771f864b1ae$export$2d1720544b23b823 = $811d8a9f70056560$exports ? $3d313964c5a0e252$exports ? function defineProperty(O, P, Attributes) {
    $651a30bf2719885c$exports(O);
    P = $ee66af91b67186b9$exports(P);
    $651a30bf2719885c$exports(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $7f34f771f864b1ae$var$WRITABLE in Attributes && !Attributes[$7f34f771f864b1ae$var$WRITABLE]) {
        var current = $7f34f771f864b1ae$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$7f34f771f864b1ae$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $7f34f771f864b1ae$var$CONFIGURABLE in Attributes ? Attributes[$7f34f771f864b1ae$var$CONFIGURABLE] : current[$7f34f771f864b1ae$var$CONFIGURABLE],
                enumerable: $7f34f771f864b1ae$var$ENUMERABLE in Attributes ? Attributes[$7f34f771f864b1ae$var$ENUMERABLE] : current[$7f34f771f864b1ae$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $7f34f771f864b1ae$var$$defineProperty(O, P, Attributes);
} : $7f34f771f864b1ae$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $651a30bf2719885c$exports(O);
    P = $ee66af91b67186b9$exports(P);
    $651a30bf2719885c$exports(Attributes);
    if ($33abe47938651948$exports) try {
        return $7f34f771f864b1ae$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw $7f34f771f864b1ae$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};



$6eb85d8841785741$exports = $811d8a9f70056560$exports ? function(object, key, value) {
    return $7f34f771f864b1ae$export$2d1720544b23b823(object, key, $c741da8096e15ef9$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $fe56497c904d3e57$exports = {};


var $d27d13aad71fd9b5$exports = {};





var $1e37f642d67d769e$exports = {};


var $1e37f642d67d769e$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1e37f642d67d769e$var$getDescriptor = $811d8a9f70056560$exports && Object.getOwnPropertyDescriptor;
var $1e37f642d67d769e$var$EXISTS = $1e350ae3e9a02430$exports($1e37f642d67d769e$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $1e37f642d67d769e$var$PROPER = $1e37f642d67d769e$var$EXISTS && (function something() {}).name === 'something';
var $1e37f642d67d769e$var$CONFIGURABLE = $1e37f642d67d769e$var$EXISTS && (!$811d8a9f70056560$exports || $811d8a9f70056560$exports && $1e37f642d67d769e$var$getDescriptor($1e37f642d67d769e$var$FunctionPrototype, 'name').configurable);
$1e37f642d67d769e$exports = {
    EXISTS: $1e37f642d67d769e$var$EXISTS,
    PROPER: $1e37f642d67d769e$var$PROPER,
    CONFIGURABLE: $1e37f642d67d769e$var$CONFIGURABLE
};


var $d27d13aad71fd9b5$require$CONFIGURABLE_FUNCTION_NAME = $1e37f642d67d769e$exports.CONFIGURABLE;
var $00983fb40650d15c$exports = {};



var $00983fb40650d15c$var$functionToString = $b0d9d61806655616$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$d01e71850d02c39e$exports($ec2a9bdd44264973$exports.inspectSource)) $ec2a9bdd44264973$exports.inspectSource = function(it) {
    return $00983fb40650d15c$var$functionToString(it);
};
$00983fb40650d15c$exports = $ec2a9bdd44264973$exports.inspectSource;


var $7490afbcbffccb41$exports = {};
var $a8a2111a681cd42a$exports = {};


var $a8a2111a681cd42a$var$WeakMap = $0a054db221c0f15e$exports.WeakMap;
$a8a2111a681cd42a$exports = $d01e71850d02c39e$exports($a8a2111a681cd42a$var$WeakMap) && /native code/.test(String($a8a2111a681cd42a$var$WeakMap));







var $1e6f7989711a9479$exports = {};


var $1e6f7989711a9479$var$keys = $892ce4a36c053529$exports('keys');
$1e6f7989711a9479$exports = function(key) {
    return $1e6f7989711a9479$var$keys[key] || ($1e6f7989711a9479$var$keys[key] = $81f30dc071ad395c$exports(key));
};


var $2348fff052e216db$exports = {};
$2348fff052e216db$exports = {};


var $7490afbcbffccb41$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $7490afbcbffccb41$var$TypeError = $0a054db221c0f15e$exports.TypeError;
var $7490afbcbffccb41$var$WeakMap = $0a054db221c0f15e$exports.WeakMap;
var $7490afbcbffccb41$var$set, $7490afbcbffccb41$var$get, $7490afbcbffccb41$var$has;
var $7490afbcbffccb41$var$enforce = function(it) {
    return $7490afbcbffccb41$var$has(it) ? $7490afbcbffccb41$var$get(it) : $7490afbcbffccb41$var$set(it, {});
};
var $7490afbcbffccb41$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$5189f72eb185181d$exports(it) || (state = $7490afbcbffccb41$var$get(it)).type !== TYPE) throw $7490afbcbffccb41$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($a8a2111a681cd42a$exports || $ec2a9bdd44264973$exports.state) {
    var $7490afbcbffccb41$var$store = $ec2a9bdd44264973$exports.state || ($ec2a9bdd44264973$exports.state = new $7490afbcbffccb41$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $7490afbcbffccb41$var$store.get = $7490afbcbffccb41$var$store.get;
    $7490afbcbffccb41$var$store.has = $7490afbcbffccb41$var$store.has;
    $7490afbcbffccb41$var$store.set = $7490afbcbffccb41$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $7490afbcbffccb41$var$set = function(it, metadata) {
        if ($7490afbcbffccb41$var$store.has(it)) throw $7490afbcbffccb41$var$TypeError($7490afbcbffccb41$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $7490afbcbffccb41$var$store.set(it, metadata);
        return metadata;
    };
    $7490afbcbffccb41$var$get = function(it) {
        return $7490afbcbffccb41$var$store.get(it) || {};
    };
    $7490afbcbffccb41$var$has = function(it) {
        return $7490afbcbffccb41$var$store.has(it);
    };
} else {
    var $7490afbcbffccb41$var$STATE = $1e6f7989711a9479$exports('state');
    $2348fff052e216db$exports[$7490afbcbffccb41$var$STATE] = true;
    $7490afbcbffccb41$var$set = function(it, metadata) {
        if ($1e350ae3e9a02430$exports(it, $7490afbcbffccb41$var$STATE)) throw $7490afbcbffccb41$var$TypeError($7490afbcbffccb41$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $6eb85d8841785741$exports(it, $7490afbcbffccb41$var$STATE, metadata);
        return metadata;
    };
    $7490afbcbffccb41$var$get = function(it) {
        return $1e350ae3e9a02430$exports(it, $7490afbcbffccb41$var$STATE) ? it[$7490afbcbffccb41$var$STATE] : {};
    };
    $7490afbcbffccb41$var$has = function(it) {
        return $1e350ae3e9a02430$exports(it, $7490afbcbffccb41$var$STATE);
    };
}
$7490afbcbffccb41$exports = {
    set: $7490afbcbffccb41$var$set,
    get: $7490afbcbffccb41$var$get,
    has: $7490afbcbffccb41$var$has,
    enforce: $7490afbcbffccb41$var$enforce,
    getterFor: $7490afbcbffccb41$var$getterFor
};


var $d27d13aad71fd9b5$var$enforceInternalState = $7490afbcbffccb41$exports.enforce;
var $d27d13aad71fd9b5$var$getInternalState = $7490afbcbffccb41$exports.get;
var $d27d13aad71fd9b5$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $d27d13aad71fd9b5$var$defineProperty = Object.defineProperty;
var $d27d13aad71fd9b5$var$stringSlice = $b0d9d61806655616$exports(''.slice);
var $d27d13aad71fd9b5$var$replace = $b0d9d61806655616$exports(''.replace);
var $d27d13aad71fd9b5$var$join = $b0d9d61806655616$exports([].join);
var $d27d13aad71fd9b5$var$CONFIGURABLE_LENGTH = $811d8a9f70056560$exports && !$0a54724770c9d119$exports(function() {
    return $d27d13aad71fd9b5$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $d27d13aad71fd9b5$var$TEMPLATE = String(String).split('String');
var $d27d13aad71fd9b5$var$makeBuiltIn = $d27d13aad71fd9b5$exports = function(value, name, options) {
    if ($d27d13aad71fd9b5$var$stringSlice($d27d13aad71fd9b5$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $d27d13aad71fd9b5$var$replace($d27d13aad71fd9b5$var$$String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$1e350ae3e9a02430$exports(value, 'name') || $d27d13aad71fd9b5$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($811d8a9f70056560$exports) $d27d13aad71fd9b5$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($d27d13aad71fd9b5$var$CONFIGURABLE_LENGTH && options && $1e350ae3e9a02430$exports(options, 'arity') && value.length !== options.arity) $d27d13aad71fd9b5$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $1e350ae3e9a02430$exports(options, 'constructor') && options.constructor) {
            if ($811d8a9f70056560$exports) $d27d13aad71fd9b5$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $d27d13aad71fd9b5$var$enforceInternalState(value);
    if (!$1e350ae3e9a02430$exports(state, 'source')) state.source = $d27d13aad71fd9b5$var$join($d27d13aad71fd9b5$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $d27d13aad71fd9b5$var$makeBuiltIn(function toString() {
    return $d01e71850d02c39e$exports(this) && $d27d13aad71fd9b5$var$getInternalState(this).source || $00983fb40650d15c$exports(this);
}, 'toString');



$fe56497c904d3e57$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($d01e71850d02c39e$exports(value)) $d27d13aad71fd9b5$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $1886608243484f3b$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $7f34f771f864b1ae$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $95c0a68542f6d778$exports = {};

var $a0dc60342cf08fa8$exports = {};


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $e548ae6dc7cebebb$export$2d1720544b23b823;
var $311a7b48fe43a2f5$exports = {};



var $4ec158fcbff7ce05$exports = {};

var $4a3ae9c334b8a84c$exports = {};
var $970aefff68e52b21$exports = {};
var $dd8aec77e89a7c25$exports = {};
var $dd8aec77e89a7c25$var$ceil = Math.ceil;
var $dd8aec77e89a7c25$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$dd8aec77e89a7c25$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $dd8aec77e89a7c25$var$floor : $dd8aec77e89a7c25$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$970aefff68e52b21$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $dd8aec77e89a7c25$exports(number);
};


var $4a3ae9c334b8a84c$var$max = Math.max;
var $4a3ae9c334b8a84c$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$4a3ae9c334b8a84c$exports = function(index, length) {
    var integer = $970aefff68e52b21$exports(index);
    return integer < 0 ? $4a3ae9c334b8a84c$var$max(integer + length, 0) : $4a3ae9c334b8a84c$var$min(integer, length);
};


var $db5813a0328f7fe3$exports = {};
var $5f04989a51bb195c$exports = {};

var $5f04989a51bb195c$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$5f04989a51bb195c$exports = function(argument) {
    return argument > 0 ? $5f04989a51bb195c$var$min($970aefff68e52b21$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$db5813a0328f7fe3$exports = function(obj) {
    return $5f04989a51bb195c$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $4ec158fcbff7ce05$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $2a9ab4e9ecf3374f$exports($this);
        var length = $db5813a0328f7fe3$exports(O);
        var index = $4a3ae9c334b8a84c$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$4ec158fcbff7ce05$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $4ec158fcbff7ce05$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $4ec158fcbff7ce05$var$createMethod(false)
};


var $311a7b48fe43a2f5$require$indexOf = $4ec158fcbff7ce05$exports.indexOf;

var $311a7b48fe43a2f5$var$push = $b0d9d61806655616$exports([].push);
$311a7b48fe43a2f5$exports = function(object, names) {
    var O = $2a9ab4e9ecf3374f$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$1e350ae3e9a02430$exports($2348fff052e216db$exports, key) && $1e350ae3e9a02430$exports(O, key) && $311a7b48fe43a2f5$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($1e350ae3e9a02430$exports(O, key = names[i++])) ~$311a7b48fe43a2f5$require$indexOf(result, key) || $311a7b48fe43a2f5$var$push(result, key);
    return result;
};


var $dfa284be77c8907c$exports = {};
// IE8- don't enum bug keys
$dfa284be77c8907c$exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];


var $e548ae6dc7cebebb$var$hiddenKeys = $dfa284be77c8907c$exports.concat('length', 'prototype');
$e548ae6dc7cebebb$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $311a7b48fe43a2f5$exports(O, $e548ae6dc7cebebb$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $bcf5b530f2cfa9ec$export$2d1720544b23b823;
$bcf5b530f2cfa9ec$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $a0dc60342cf08fa8$var$concat = $b0d9d61806655616$exports([].concat);
// all object keys, includes non-enumerable and symbols
$a0dc60342cf08fa8$exports = $6559aa8e66ece2fa$exports('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $e548ae6dc7cebebb$export$2d1720544b23b823($651a30bf2719885c$exports(it));
    var getOwnPropertySymbols = $bcf5b530f2cfa9ec$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $a0dc60342cf08fa8$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$95c0a68542f6d778$exports = function(target, source, exceptions) {
    var keys = $a0dc60342cf08fa8$exports(source);
    var defineProperty = $7f34f771f864b1ae$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $1bf1c27592d288d8$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$1e350ae3e9a02430$exports(target, key) && !(exceptions && $1e350ae3e9a02430$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $dd0595a1733014fe$exports = {};


var $dd0595a1733014fe$var$replacement = /#|\.prototype\./;
var $dd0595a1733014fe$var$isForced = function(feature, detection) {
    var value = $dd0595a1733014fe$var$data[$dd0595a1733014fe$var$normalize(feature)];
    return value == $dd0595a1733014fe$var$POLYFILL ? true : value == $dd0595a1733014fe$var$NATIVE ? false : $d01e71850d02c39e$exports(detection) ? $0a54724770c9d119$exports(detection) : !!detection;
};
var $dd0595a1733014fe$var$normalize = $dd0595a1733014fe$var$isForced.normalize = function(string) {
    return String(string).replace($dd0595a1733014fe$var$replacement, '.').toLowerCase();
};
var $dd0595a1733014fe$var$data = $dd0595a1733014fe$var$isForced.data = {};
var $dd0595a1733014fe$var$NATIVE = $dd0595a1733014fe$var$isForced.NATIVE = 'N';
var $dd0595a1733014fe$var$POLYFILL = $dd0595a1733014fe$var$isForced.POLYFILL = 'P';
$dd0595a1733014fe$exports = $dd0595a1733014fe$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $9d2aa0c06cf9981d$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $0a054db221c0f15e$exports;
    else if (STATIC) target = $0a054db221c0f15e$exports[TARGET] || $1886608243484f3b$exports(TARGET, {});
    else target = ($0a054db221c0f15e$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $9d2aa0c06cf9981d$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $dd0595a1733014fe$exports(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $95c0a68542f6d778$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $6eb85d8841785741$exports(sourceProperty, 'sham', true);
        $fe56497c904d3e57$exports(target, key, sourceProperty, options);
    }
};



var $f64ddc8b7ab8d31d$exports = {};

var $40ec2a83e5c3f251$exports = {};

var $40ec2a83e5c3f251$var$FunctionPrototype = Function.prototype;
var $40ec2a83e5c3f251$var$apply = $40ec2a83e5c3f251$var$FunctionPrototype.apply;
var $40ec2a83e5c3f251$var$call = $40ec2a83e5c3f251$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$40ec2a83e5c3f251$exports = typeof Reflect == 'object' && Reflect.apply || ($6eaa9cebbcd3667e$exports ? $40ec2a83e5c3f251$var$call.bind($40ec2a83e5c3f251$var$apply) : function() {
    return $40ec2a83e5c3f251$var$call.apply($40ec2a83e5c3f251$var$apply, arguments);
});


var $3730c6cb93a9573a$exports = {};
var $044d58886be44672$exports = {};


$044d58886be44672$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($d39aaece64624764$exports(fn) === 'Function') return $b0d9d61806655616$exports(fn);
};




var $3730c6cb93a9573a$var$bind = $044d58886be44672$exports($044d58886be44672$exports.bind);
// optional / simple context binding
$3730c6cb93a9573a$exports = function(fn, that) {
    $2a03b58aeff71e08$exports(fn);
    return that === undefined ? fn : $6eaa9cebbcd3667e$exports ? $3730c6cb93a9573a$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $230e2f8315bf73f8$exports = {};

$230e2f8315bf73f8$exports = $6559aa8e66ece2fa$exports('document', 'documentElement');


var $8b6ebb16ba6b649e$exports = {};

$8b6ebb16ba6b649e$exports = $b0d9d61806655616$exports([].slice);



var $fa0359152e567bf0$exports = {};
var $fa0359152e567bf0$var$$TypeError = TypeError;
$fa0359152e567bf0$exports = function(passed, required) {
    if (passed < required) throw $fa0359152e567bf0$var$$TypeError('Not enough arguments');
    return passed;
};


var $3bffc32c4c128ac9$exports = {};

// eslint-disable-next-line redos/no-vulnerable -- safe
$3bffc32c4c128ac9$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($b897f5ee5c2f82f9$exports);


var $060c42cd9b1cf126$exports = {};

$060c42cd9b1cf126$exports = false;


var $f64ddc8b7ab8d31d$var$set = $0a054db221c0f15e$exports.setImmediate;
var $f64ddc8b7ab8d31d$var$clear = $0a054db221c0f15e$exports.clearImmediate;
var $f64ddc8b7ab8d31d$var$process = $0a054db221c0f15e$exports.process;
var $f64ddc8b7ab8d31d$var$Dispatch = $0a054db221c0f15e$exports.Dispatch;
var $f64ddc8b7ab8d31d$var$Function = $0a054db221c0f15e$exports.Function;
var $f64ddc8b7ab8d31d$var$MessageChannel = $0a054db221c0f15e$exports.MessageChannel;
var $f64ddc8b7ab8d31d$var$String = $0a054db221c0f15e$exports.String;
var $f64ddc8b7ab8d31d$var$counter = 0;
var $f64ddc8b7ab8d31d$var$queue = {};
var $f64ddc8b7ab8d31d$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $f64ddc8b7ab8d31d$var$$location, $f64ddc8b7ab8d31d$var$defer, $f64ddc8b7ab8d31d$var$channel, $f64ddc8b7ab8d31d$var$port;
$0a54724770c9d119$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $f64ddc8b7ab8d31d$var$$location = $0a054db221c0f15e$exports.location;
});
var $f64ddc8b7ab8d31d$var$run = function(id) {
    if ($1e350ae3e9a02430$exports($f64ddc8b7ab8d31d$var$queue, id)) {
        var fn = $f64ddc8b7ab8d31d$var$queue[id];
        delete $f64ddc8b7ab8d31d$var$queue[id];
        fn();
    }
};
var $f64ddc8b7ab8d31d$var$runner = function(id) {
    return function() {
        $f64ddc8b7ab8d31d$var$run(id);
    };
};
var $f64ddc8b7ab8d31d$var$eventListener = function(event) {
    $f64ddc8b7ab8d31d$var$run(event.data);
};
var $f64ddc8b7ab8d31d$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $0a054db221c0f15e$exports.postMessage($f64ddc8b7ab8d31d$var$String(id), $f64ddc8b7ab8d31d$var$$location.protocol + '//' + $f64ddc8b7ab8d31d$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$f64ddc8b7ab8d31d$var$set || !$f64ddc8b7ab8d31d$var$clear) {
    $f64ddc8b7ab8d31d$var$set = function setImmediate(handler) {
        $fa0359152e567bf0$exports(arguments.length, 1);
        var fn = $d01e71850d02c39e$exports(handler) ? handler : $f64ddc8b7ab8d31d$var$Function(handler);
        var args = $8b6ebb16ba6b649e$exports(arguments, 1);
        $f64ddc8b7ab8d31d$var$queue[++$f64ddc8b7ab8d31d$var$counter] = function() {
            $40ec2a83e5c3f251$exports(fn, undefined, args);
        };
        $f64ddc8b7ab8d31d$var$defer($f64ddc8b7ab8d31d$var$counter);
        return $f64ddc8b7ab8d31d$var$counter;
    };
    $f64ddc8b7ab8d31d$var$clear = function clearImmediate(id) {
        delete $f64ddc8b7ab8d31d$var$queue[id];
    };
    // Node.js 0.8-
    if ($060c42cd9b1cf126$exports) $f64ddc8b7ab8d31d$var$defer = function(id) {
        $f64ddc8b7ab8d31d$var$process.nextTick($f64ddc8b7ab8d31d$var$runner(id));
    };
    else if ($f64ddc8b7ab8d31d$var$Dispatch && $f64ddc8b7ab8d31d$var$Dispatch.now) $f64ddc8b7ab8d31d$var$defer = function(id) {
        $f64ddc8b7ab8d31d$var$Dispatch.now($f64ddc8b7ab8d31d$var$runner(id));
    };
    else if ($f64ddc8b7ab8d31d$var$MessageChannel && !$3bffc32c4c128ac9$exports) {
        $f64ddc8b7ab8d31d$var$channel = new $f64ddc8b7ab8d31d$var$MessageChannel();
        $f64ddc8b7ab8d31d$var$port = $f64ddc8b7ab8d31d$var$channel.port2;
        $f64ddc8b7ab8d31d$var$channel.port1.onmessage = $f64ddc8b7ab8d31d$var$eventListener;
        $f64ddc8b7ab8d31d$var$defer = $3730c6cb93a9573a$exports($f64ddc8b7ab8d31d$var$port.postMessage, $f64ddc8b7ab8d31d$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($0a054db221c0f15e$exports.addEventListener && $d01e71850d02c39e$exports($0a054db221c0f15e$exports.postMessage) && !$0a054db221c0f15e$exports.importScripts && $f64ddc8b7ab8d31d$var$$location && $f64ddc8b7ab8d31d$var$$location.protocol !== 'file:' && !$0a54724770c9d119$exports($f64ddc8b7ab8d31d$var$globalPostMessageDefer)) {
        $f64ddc8b7ab8d31d$var$defer = $f64ddc8b7ab8d31d$var$globalPostMessageDefer;
        $0a054db221c0f15e$exports.addEventListener('message', $f64ddc8b7ab8d31d$var$eventListener, false);
    // IE8-
    } else if ($f64ddc8b7ab8d31d$var$ONREADYSTATECHANGE in $4b1f87f61316b1b2$exports('script')) $f64ddc8b7ab8d31d$var$defer = function(id) {
        $230e2f8315bf73f8$exports.appendChild($4b1f87f61316b1b2$exports('script'))[$f64ddc8b7ab8d31d$var$ONREADYSTATECHANGE] = function() {
            $230e2f8315bf73f8$exports.removeChild(this);
            $f64ddc8b7ab8d31d$var$run(id);
        };
    };
    else $f64ddc8b7ab8d31d$var$defer = function(id) {
        setTimeout($f64ddc8b7ab8d31d$var$runner(id), 0);
    };
}
$f64ddc8b7ab8d31d$exports = {
    set: $f64ddc8b7ab8d31d$var$set,
    clear: $f64ddc8b7ab8d31d$var$clear
};


var $4ccf9fd709c24310$require$clearImmediate = $f64ddc8b7ab8d31d$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$9d2aa0c06cf9981d$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $0a054db221c0f15e$exports.clearImmediate !== $4ccf9fd709c24310$require$clearImmediate
}, {
    clearImmediate: $4ccf9fd709c24310$require$clearImmediate
});





var $7534c3f6e54c9eeb$require$setTask = $f64ddc8b7ab8d31d$exports.set;
var $ab9ad7b4709b05bc$exports = {};
'use strict';



var $931042dadc538415$exports = {};
/* global Bun -- Deno case */ $931042dadc538415$exports = typeof Bun == 'function' && Bun && typeof Bun.version == 'string';





var $ab9ad7b4709b05bc$var$Function = $0a054db221c0f15e$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $ab9ad7b4709b05bc$var$WRAP = /MSIE .\./.test($b897f5ee5c2f82f9$exports) || $931042dadc538415$exports && function() {
    var version = $0a054db221c0f15e$exports.Bun.version.split('.');
    return version.length < 3 || version[0] == 0 && (version[1] < 3 || version[1] == 3 && version[2] == 0);
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$ab9ad7b4709b05bc$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $ab9ad7b4709b05bc$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $fa0359152e567bf0$exports(arguments.length, 1) > firstParamIndex;
        var fn = $d01e71850d02c39e$exports(handler) ? handler : $ab9ad7b4709b05bc$var$Function(handler);
        var params = boundArgs ? $8b6ebb16ba6b649e$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $40ec2a83e5c3f251$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $7534c3f6e54c9eeb$var$setImmediate = $0a054db221c0f15e$exports.setImmediate ? $ab9ad7b4709b05bc$exports($7534c3f6e54c9eeb$require$setTask, false) : $7534c3f6e54c9eeb$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$9d2aa0c06cf9981d$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $0a054db221c0f15e$exports.setImmediate !== $7534c3f6e54c9eeb$var$setImmediate
}, {
    setImmediate: $7534c3f6e54c9eeb$var$setImmediate
});









const $2f51e41da859bac7$export$c2c583a967e8e371 = 102400;
const $2f51e41da859bac7$export$42966f329c86fa8b = (buffer)=>{
    if (buffer.length > $2f51e41da859bac7$export$c2c583a967e8e371) /** Limit by size and propagate limitation signal through LARGE_BUFFER */ return [
        buffer.toString(undefined, 0, $2f51e41da859bac7$export$c2c583a967e8e371),
        [
            (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).LARGE_BUFFER
        ]
    ];
    const asString = buffer.toString();
    if (!asString) return [
        asString,
        [
            (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).STRING,
            (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).HEX
        ]
    ];
    if (!isNaN(Number(asString))) return [
        asString,
        [
            (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).NUMBER,
            (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).STRING,
            (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).HEX
        ]
    ];
    try {
        switch(typeof JSON.parse(asString)){
            case 'object':
                return [
                    asString,
                    [
                        (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).OBJECT
                    ]
                ];
            default:
                return [
                    asString,
                    [
                        (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).STRING,
                        (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).HEX
                    ]
                ];
        }
    } catch (_) {
        return [
            asString,
            [
                (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).STRING,
                (0, $0b8fac93f85dcb05$export$a9b603917c4d9863).HEX
            ]
        ];
    }
};


/**
 * @see https://docs.oasis-open.org/mqtt/mqtt/v5.0/os/mqtt-v5.0-os.html#_Shared_Subscriptions
 */ const $c960284468e1cb68$var$sharedTopicPattern = /^\$share\/[^/]+\/.+$/;
class $c960284468e1cb68$var$ConnectedClient {
    constructor(args){
        this.args = args;
        this.droppable = new (0, $092680ba287ef87d$export$423ec2075359570a)();
        this.subscriptionQueue = new (0, $85a96cf722827591$export$3dc07afe418952bc)();
        this.previousTopics = [];
        this.client = (0, $4c2dd1b68d143d96$export$2e2bcd8739ae039).connect(args.url, {
            username: args.username,
            password: args.password,
            connectTimeout: args.timeout
        });
    }
    onError(handler) {
        this.client.on('error', (e)=>{
            /**
             * The code below ignores errors that happen during reconnection
             * And only pass it along if the client is still disconnected
             */ this.onLoad((connected)=>{
                if (!connected) handler(e);
            });
        });
    }
    onLoad(handler) {
        Promise.race([
            /** Connection promise */ new Promise((resolve)=>this.client.once('connect', ()=>resolve(this.client.connected))),
            /** Time-out promise */ (0, $48cf5ef53a480c1f$export$1391212d75b2ee65)(this.args.timeout).then(()=>false)
        ]).then(handler);
    }
    /**
     * This function should only call the handler after the reconnection is succesful
     * not at every reconnection attempt
     */ onReconnect(handler) {
        let lastRecon = null;
        this.client.on('reconnect', ()=>lastRecon = Date.now());
        this.client.on('connect', ()=>{
            const lastCon = Date.now();
            if (/** No reconnection was started */ lastRecon === null || /** Reconnection was too long ago so something else is up */ lastRecon + this.args.timeout < lastCon || /** Client is not connected */ !this.client.connected) return;
            handler();
        });
    }
    onBulk(handler) {
        const bulkEvent = new (0, $9fc21cc786388d5a$export$37ef2bcb880cd30)(this.args.cycle, true);
        /** Listen to messages once connected */ this.client.on('message', (topic, payload)=>bulkEvent.append([
                topic,
                payload
            ]));
        /** Every cycle, send this up the chain */ this.droppable.onDrop(bulkEvent.onCycled((batch)=>handler(batch)));
    }
    disconnect() {
        this.client.removeAllListeners();
        this.client.end();
        this.droppable.drop();
    }
    subscribe(topics) {
        /** Wait for the last subscription flow to be done and then start the next one */ return this.subscriptionQueue.push(async ()=>{
            const { previousTopics: previousTopics } = this;
            /** Unsubscribe from previous topics if there are any */ if ((0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(previousTopics)) this.client.unsubscribe([
                ...previousTopics
            ]);
            const validTopics = [];
            let nonSubscribed = {
                invalid: [],
                shared: []
            };
            let subscriptionResult = {
                subscribed: [],
                noPermissions: [],
                unknown: []
            };
            /** Strip out topics that are either malformed or too deep */ topics.forEach((topic)=>{
                if (!new (0, $07053aed662f811a$export$320e4b58b7eeecaf)(topic, this.args.maxTopicDepth).valid) nonSubscribed = {
                    ...nonSubscribed,
                    invalid: [
                        ...nonSubscribed.invalid,
                        topic
                    ]
                };
                else if ($c960284468e1cb68$var$sharedTopicPattern.test(topic)) nonSubscribed = {
                    ...nonSubscribed,
                    shared: [
                        ...nonSubscribed.shared,
                        topic
                    ]
                };
                else validTopics.push(topic);
            });
            /** Subscribe to new topics if there are any and validate subscription was successful */ subscriptionResult = (0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(validTopics) ? await new Promise((resolve)=>this.client.subscribe([
                    ...validTopics
                ], (error, granted, packet)=>{
                    (0, $14eddac5f20c576c$export$a7a9523472993e97)(granted, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Granted array is always sent if the topics are valid'));
                    resolve(granted.reduce((r, { topic: topic }, k)=>{
                        const qos = packet?.granted[k];
                        if (qos === 128) /** QOS with this value, means missing permissions */ return {
                            ...r,
                            noPermissions: [
                                ...r.noPermissions,
                                topic
                            ]
                        };
                        if (!error && qos === 0) /** There are no issues, so just subscribe */ return {
                            ...r,
                            subscribed: [
                                ...r.subscribed,
                                topic
                            ]
                        };
                        /** There were issues with the subscription, so mark everyone */ return {
                            ...r,
                            unknown: [
                                ...r.unknown,
                                topic
                            ]
                        };
                    }, subscriptionResult));
                })) : subscriptionResult;
            this.previousTopics = subscriptionResult.subscribed;
            return {
                ...nonSubscribed,
                ...subscriptionResult
            };
        });
    }
}
class $c960284468e1cb68$export$4edce18b9bd81028 {
    constructor(worker){
        this.worker = worker;
        this.client = null;
        this.topics = [];
        this.sendStateError = ()=>{
            this.worker.send({
                action: 'error',
                type: 'state',
                message: "Worker's state is not properly setup"
            });
        };
    }
    withClient(withClient, withoutClient = this.sendStateError) {
        if (this.client) withClient(this.client);
        else withoutClient();
    }
    send(message) {
        this.withClient(()=>this.worker.send(message));
    }
    connect(args) {
        this.withClient(this.sendStateError, ()=>{
            const client = this.client = new $c960284468e1cb68$var$ConnectedClient(args);
            /** Handle errors */ client.onError((e)=>{
                this.send({
                    action: 'error',
                    type: 'genericError',
                    message: e.message
                });
                this.disconnect();
            });
            /** Wait for load */ client.onLoad((connected)=>{
                /** Make sure connection is made with-in the accepted timeframe */ if (!connected) {
                    this.send({
                        action: 'error',
                        type: 'couldNotConnect',
                        message: 'Could not connect to the mqtt client'
                    });
                    return;
                }
                client.onBulk((batch)=>{
                    const topicalBatch = batch.reduce((r, [topic, payload])=>{
                        if (!(0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(this.topics)) return r;
                        const sources = new (0, $07053aed662f811a$export$320e4b58b7eeecaf)(topic, null).filterSources(this.topics);
                        const [serializedPayload, possibleTypes] = (0, $2f51e41da859bac7$export$42966f329c86fa8b)(payload);
                        if ((0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(sources)) r.push({
                            topic: topic,
                            possibleTypes: possibleTypes,
                            payload: serializedPayload,
                            timestamp: this.getCurrentTime(),
                            sources: sources
                        });
                        return r;
                    }, []);
                    if ((0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(topicalBatch)) this.send({
                        action: 'messages',
                        batch: topicalBatch,
                        topics: this.topics
                    });
                });
            });
            /** Detect reconnections and re-subscribe to all topics */ client.onReconnect(()=>{
                this.applySubscription(this.topics, (response)=>{
                    if (!(0, $238a83731a48faba$export$8f7496a65239c6d8)(response)) /** Had issues resubscribing, should never occur in real life scenarios, but this covers all basis */ this.send({
                        action: 'error',
                        type: 'couldNotReconnect',
                        message: 'There was an issue completing reconnection'
                    });
                });
            });
        });
    }
    disconnect() {
        this.withClient((client)=>client.disconnect());
        this.client = null;
    }
    /**
     * Actually performs the subscription, handles exceptions and updates internal controls
     */ applySubscription(topics, handler) {
        this.withClient(async (client)=>{
            const response = await client.subscribe(topics);
            this.topics = response.subscribed;
            handler(response);
        });
    }
    /**
     * Subscribes and signals top frame what subscription was actually made
     */ subscribe({ id: id, topics: topics }) {
        this.applySubscription(topics, (response)=>this.send({
                id: id,
                action: 'subscription',
                response: response
            }));
    }
    /** This is exposed to enable tests mocks */ getCurrentTime() {
        return new Date();
    }
    start() {
        this.worker.listen((data)=>{
            switch(data.action){
                case 'connect':
                    this.connect(data);
                    break;
                case 'disconnect':
                    this.disconnect();
                    break;
                case 'subscribe':
                    this.subscribe(data);
                    break;
            }
        });
    }
}











class $9cca181571b4e123$export$434efc531990293d {
    static #_ = this.INTERNAL_CLOSURE_REASON = `${this.name}_INTERNAL_CLOSURE_REASON`;
    constructor(options){
        this.options = options;
        this.listener = new (0, $9fc21cc786388d5a$export$3291343375ee8b92)();
        this.socket = null;
        this.InternalWebSocketConstructor = WebSocket;
    }
    hasSocket() {
        return this.socket !== null;
    }
    needsSocket() {
        return this.listener.size > 0;
    }
    createURL() {
        const { origin: origin, path: path, params: params } = this.options;
        const url = new URL(origin);
        url.pathname = path;
        for (const [key, valueOrArray] of (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(params))for (const value of (0, $36fb5ff0bd6498d5$export$2dabafa86f11ed64)(valueOrArray, (v)=>typeof v === 'string') ? valueOrArray : [
            valueOrArray
        ])url.searchParams.append(String(key), String(value));
        return url;
    }
    /**
     * Discards current socket without care for what it was supposed to be doing
     */ discardSocket() {
        /**
         * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/close
         * @see https://developer.mozilla.org/pt-BR/docs/Web/API/CloseEvent
         */ this.socket?.close(1000, $9cca181571b4e123$export$434efc531990293d.INTERNAL_CLOSURE_REASON);
        this.socket = null;
    }
    /**
     * Replaces current socket without care for what it was supposed to be doing
     */ async replaceSocket() {
        this.discardSocket();
        /**
         * So a cool down period before trying again
         */ await (0, $48cf5ef53a480c1f$export$1391212d75b2ee65)(this.options.reconnectTimeout);
        if (this.hasSocket() || !this.needsSocket()) /**
             * There is already a socket there, or there is no need for one
             */ return;
        return this.initializeSocket();
    }
    /**
     * Creates a socket if there was none there
     * And setups listeners to recreate another socket
     */ initializeSocket() {
        if (this.hasSocket()) /**
             * Socket is already there, so don't bother setting everything up again
             */ return Promise.resolve();
        const promise = new (0, $4b4d116d11b9cad5$export$63804c02d20d1c30)();
        const socket = new this.InternalWebSocketConstructor(this.createURL());
        this.socket = socket;
        socket.addEventListener('open', ()=>{
            socket.addEventListener('close', (e)=>{
                if (e.reason !== $9cca181571b4e123$export$434efc531990293d.INTERNAL_CLOSURE_REASON) /** Close is not internal, so create another socket to reconnect */ this.replaceSocket();
            }, {
                once: true
            });
            /**
                 * Deals with the messages that come back from RST
                 */ socket.addEventListener('message', (e)=>{
                let data;
                try {
                    data = JSON.parse(String(e.data));
                } catch (err) {
                    data = new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).MAPPING_ERROR, 'Given data is not parseable', {
                        url: socket.url,
                        data: e.data,
                        message: err.message
                    });
                }
                this.listener.trigger(data);
            });
            promise.resolve();
        }, {
            once: true
        });
        /**
         * There was a error with the connection, so retry again
         */ socket.addEventListener('error', ()=>promise.resolve(this.replaceSocket()), {
            once: true
        });
        return promise.promise;
    }
    disuseSocket() {
        if (this.needsSocket()) /** Socket in use, keep it around */ return;
        this.discardSocket();
    }
    on(listener) {
        const off = this.listener.on(listener);
        return this.initializeSocket().then(()=>{
            return ()=>{
                off();
                this.disuseSocket();
            };
        });
    }
}


const $2a20d6395286d7d0$var$extractArgsParts = ([type, ...extra])=>({
        type: type,
        extra: extra
    });
class $2a20d6395286d7d0$var$RequestsManager {
    constructor(pageSize){
        this.pageSize = pageSize;
        this.requests = [];
    }
    add(...args) {
        const request = {
            args: args,
            listener: new (0, $9fc21cc786388d5a$export$3291343375ee8b92)(),
            promise: new (0, $4b4d116d11b9cad5$export$63804c02d20d1c30)()
        };
        this.requests.push(request);
        return [
            request.listener,
            request.promise.promise
        ];
    }
    extractNextBatch() {
        const [first, ...next] = this.requests.splice(0, this.requests.length);
        if (!first) /** There is nothing here, just give up */ return [];
        const { type: type } = $2a20d6395286d7d0$var$extractArgsParts(first.args);
        const nextBatch = [
            first
        ];
        next.forEach((request)=>{
            /**
             * Sockets with multiple types may one day have different paths again
             * So all the requests need to be of the same type in order to ensure internal consistency when creating sockets
             * This could be improved upon, but it is such a marginal case that improving may not be worth-while
             */ if (nextBatch.length < this.pageSize && $2a20d6395286d7d0$var$extractArgsParts(request.args).type === type) nextBatch.push(request);
            else this.requests.push(request);
        });
        return nextBatch;
    }
}
class $2a20d6395286d7d0$var$SocketsManager {
    constructor(mapId, mapQueryParameters, sockerWrapperOptions, SocketWrapper, pathsConfiguration){
        this.mapId = mapId;
        this.mapQueryParameters = mapQueryParameters;
        this.sockerWrapperOptions = sockerWrapperOptions;
        this.SocketWrapper = SocketWrapper;
        this.pathsConfiguration = pathsConfiguration;
        this.sockets = new Map();
    }
    createSocket(type, params) {
        const { origin: origin, reconnectTimeout: reconnectTimeout } = this.sockerWrapperOptions;
        const { path: path } = this.pathsConfiguration[type];
        return new this.SocketWrapper({
            origin: origin,
            path: path,
            params: params,
            reconnectTimeout: reconnectTimeout
        });
    }
    get(args) {
        return this.sockets.get(this.mapId(...$2a20d6395286d7d0$var$extractArgsParts(args).extra)) ?? null;
    }
    create(requests) {
        const ids = Array.from(requests.reduce((s, r)=>s.add(this.mapId(...$2a20d6395286d7d0$var$extractArgsParts(r).extra)), new Set()));
        const { type: type } = $2a20d6395286d7d0$var$extractArgsParts(requests[0]);
        const socket = this.createSocket(type, this.mapQueryParameters(ids));
        for (const id of ids)this.sockets.set(id, socket);
        return socket;
    }
}
class $2a20d6395286d7d0$var$Cache {
    constructor(cacheLifespan, extractIdFromArgs, extractIdFromData, mapCacheResult){
        this.cacheLifespan = cacheLifespan;
        this.extractIdFromArgs = extractIdFromArgs;
        this.extractIdFromData = extractIdFromData;
        this.mapCacheResult = mapCacheResult;
        this.results = new Map();
    }
    set(type, args, data) {
        const key = `${type}_${(0, $c3e1b746ad236797$export$8d524fb6540252df).is(data) ? this.extractIdFromArgs(...args) : this.extractIdFromData(data)}`;
        /**
         * Cache value is wrapped so the timeout validation only drops it by reference
         */ const cache = {
            value: (0, $c3e1b746ad236797$export$8d524fb6540252df).is(data) ? data : this.mapCacheResult(data)
        };
        this.results.set(key, cache);
        (0, $d4622374f48a4eef$export$6eae7cf7a129a986)(()=>{
            if (this.results.get(key) === cache) this.results.delete(key);
        }, this.cacheLifespan);
    }
    get(type, ...args) {
        return this.results.get(`${type}_${this.extractIdFromArgs(...args)}`)?.value ?? null;
    }
}
class $2a20d6395286d7d0$var$RSTBaseSubscription {
    constructor(options){
        this.options = options;
        this.queue = new (0, $85a96cf722827591$export$3dc07afe418952bc)();
        this.SocketWrapper = (0, $9cca181571b4e123$export$434efc531990293d);
    }
    /**
     * This function creates a subscription
     * Calls the passed handler as messages arrive
     * And sets cache accordingly as needed
     */ subscribe({ args: args, strategy: { requests: requests, sockets: sockets, cache: cache, isEventRelevant: isEventRelevant }, handler: handler }) {
        const [listener, socketConnectionPromise] = requests.add(...args);
        const stopListening = listener.on(handler);
        /**
         * Use the queue to bunch up requests whenever possible
         */ this.queue.push(async ()=>{
            const batch = requests.extractNextBatch();
            const requestsGroupedBySockets = new (0, $f0cbf013be9038ef$export$c3f30dbb97e8bc91)();
            const socketless = {
                requests: [],
                args: []
            };
            /**
             * Go over each request
             * If there is no socket associated with each request, then ensure there will be one
             * But try to re-use previous sockets (that may still be active thus not needing reconnection)
             */ for (const request of batch){
                const socket = sockets.get(request.args);
                if (socket) requestsGroupedBySockets.set(socket, [
                    ...requestsGroupedBySockets.getDefault(socket, []),
                    request
                ]);
                else {
                    socketless.requests.push(request);
                    socketless.args.push(request.args);
                }
            }
            if ((0, $9f70c141ac08ef9a$export$a079a83b07f794bf)(socketless.args)) /**
                 * Create a single socket for all missing elements
                 */ requestsGroupedBySockets.set(sockets.create(socketless.args), socketless.requests);
            /**
             * Process each group of requests associated with a WebSocket
             * And resolve each request by spinning up the socket
             */ for (const [socket, socketRequests] of requestsGroupedBySockets)for (const request of socketRequests)request.promise.resolve(socket.on((event)=>{
                const { type: type, extra: extra } = $2a20d6395286d7d0$var$extractArgsParts(request.args);
                cache.set(type, extra, event);
                if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(event) || isEventRelevant(event, ...extra)) /**
                                 * If its an error, just send it to everyone possibly with-in the given socket
                                 * If its an event, then check if that event is relevant to the given handler
                                 *
                                 * If either are true, then trigger the listener
                                 */ request.listener.trigger();
            }));
        });
        return socketConnectionPromise.then((notifySocketDisuse)=>{
            return ()=>{
                stopListening();
                notifySocketDisuse();
            };
        });
    }
}
class $2a20d6395286d7d0$export$c8a394d91a850e65 extends $2a20d6395286d7d0$var$RSTBaseSubscription {
    subscribeToStatusType(...[type, id, handler]) {
        return this.subscribe({
            args: [
                type,
                id
            ],
            strategy: this.createStatusTypeStrategy(),
            handler: handler
        });
    }
    useCachedStatusType(...args) {
        return this.createStatusTypeStrategy().cache.get(...args);
    }
    constructor(...args){
        super(...args), /**
     * The executeOnce is here to delay the intake of baseclass properties
     * This allows tests to inject their own values
     */ this.createStatusTypeStrategy = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>({
                requests: new $2a20d6395286d7d0$var$RequestsManager(this.options.pageSize),
                sockets: new $2a20d6395286d7d0$var$SocketsManager((id)=>id, (resourceIds)=>({
                        resourceIds: resourceIds
                    }), this.options, this.SocketWrapper, {
                    connection: {
                        path: '/api/v2/resources/states',
                        capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTION_READ
                    },
                    connections: {
                        path: '/api/v2/resources/states',
                        capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_READ
                    },
                    endpoint: {
                        path: '/api/v2/resources/states',
                        capability: (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINT_READ
                    },
                    endpoints: {
                        path: '/api/v2/resources/states',
                        capability: (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_READ
                    },
                    mapping: {
                        path: '/api/v2/resources/states',
                        capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPING_READ
                    },
                    mappings: {
                        path: '/api/v2/resources/states',
                        capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_READ
                    },
                    nodes: {
                        path: '/api/v2/resources/states',
                        capability: (0, $78670ebe9381a713$export$790a66df9dc00390).NODES_READ
                    },
                    server: {
                        path: '/api/v2/resources/states',
                        capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVER_READ
                    },
                    servers: {
                        path: '/api/v2/resources/states',
                        capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_READ
                    }
                }),
                cache: new $2a20d6395286d7d0$var$Cache(this.options.cacheLifespan, (id)=>id, (data)=>(0, $1ce286d293747584$export$9c5ea5a6c0d1312b)(data.resource), (data)=>(0, $1ce286d293747584$export$3442ac9bfe667688)(data.state)),
                isEventRelevant: (content, id)=>content.resource.id === id
            }));
    }
}
class $2a20d6395286d7d0$export$898c8c6251bb3334 extends $2a20d6395286d7d0$var$RSTBaseSubscription {
    static #_ = this.mapServiceId = (0, $1ce286d293747584$export$7e41c8195d072605)(({ serviceId: serviceId })=>serviceId);
    createSocketWrapperGetter(paths) {
        const wrapperCreators = (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(paths).reduce((r, [type, configuration])=>({
                ...r,
                /**
                 * The executeOnce is here to only create the wrappers when they are first setup
                 */ [type]: (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>{
                    const { origin: origin, reconnectTimeout: reconnectTimeout } = this.options;
                    return new this.SocketWrapper({
                        origin: origin,
                        path: configuration.path,
                        params: {},
                        reconnectTimeout: reconnectTimeout
                    });
                })
            }), {});
        return (type)=>wrapperCreators[type]();
    }
    useCachedServiceDeviationsCount(...args) {
        return this.createServiceDeviationStrategy().cache.get(...args);
    }
    subscribeToServiceDeviationsCount(...[type, serviceId, handler]) {
        return this.subscribe({
            args: [
                type,
                serviceId
            ],
            strategy: this.createServiceDeviationStrategy(),
            handler: handler
        });
    }
    subscribeToServicesDeviationsCount(...[type, handler]) {
        return this.getServicesDeviationsWrapper(type).on(()=>handler());
    }
    subscribeToResolvedDeviations(...[type, handler]) {
        return this.getDeviationsResolutionWrapper(type).on((event)=>{
            if ((0, $c3e1b746ad236797$export$8d524fb6540252df).is(event)) /** Error happened, so just pass it over */ handler(event);
            else if (event.service?.deviated === false) /** Deviated service was resolved  */ handler({
                id: event.service.serviceId
            });
        });
    }
    constructor(...args){
        super(...args), /**
     * The executeOnce is here to delay the intake of baseclass properties
     * This allows tests to inject their own values
     */ this.createServiceDeviationStrategy = (0, $3b4a6a32782da93b$export$b1fe116b2fdda743)(()=>({
                requests: new $2a20d6395286d7d0$var$RequestsManager(this.options.pageSize),
                sockets: new $2a20d6395286d7d0$var$SocketsManager((id)=>id, (ids)=>({
                        ids: ids
                    }), this.options, this.SocketWrapper, {
                    connections: {
                        path: '/api/v2/resources/states/deviations/count',
                        capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_READ
                    },
                    endpoints: {
                        path: '/api/v2/resources/states/deviations/count',
                        capability: (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_READ
                    },
                    mappings: {
                        path: '/api/v2/resources/states/deviations/count',
                        capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_READ
                    },
                    nodes: {
                        path: '/api/v2/resources/states/deviations/count',
                        capability: (0, $78670ebe9381a713$export$790a66df9dc00390).NODES_READ
                    },
                    resourceDeviation: {
                        path: '/api/v2/resources/states/deviations/count',
                        capability: (0, $78670ebe9381a713$export$790a66df9dc00390).DEVIATIONS_READ
                    },
                    servers: {
                        path: '/api/v2/resources/states/deviations/count',
                        capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_READ
                    },
                    service: {
                        path: '/api/v2/resources/states/deviations/count',
                        capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICE_READ
                    },
                    services: {
                        path: '/api/v2/resources/states/deviations/count',
                        capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_READ
                    }
                }),
                cache: new $2a20d6395286d7d0$var$Cache(this.options.cacheLifespan, (id)=>id, $2a20d6395286d7d0$export$898c8c6251bb3334.mapServiceId, (0, $1ce286d293747584$export$7e41c8195d072605)(({ count: count })=>count)),
                isEventRelevant: (content, id)=>$2a20d6395286d7d0$export$898c8c6251bb3334.mapServiceId(content) === id
            })), this.getServicesDeviationsWrapper = this.createSocketWrapperGetter({
            connections: {
                path: '/api/v2/resources/states/deviations/count',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).CONNECTIONS_READ
            },
            deviatedServices: {
                path: '/api/v2/resources/states/deviations/count',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).DEVIATIONS_READ
            },
            endpoints: {
                path: '/api/v2/resources/states/deviations/count',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).ENDPOINTS_READ
            },
            mappings: {
                path: '/api/v2/resources/states/deviations/count',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).MAPPINGS_READ
            },
            nodes: {
                path: '/api/v2/resources/states/deviations/count',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).NODES_READ
            },
            resourceDeviation: {
                path: '/api/v2/resources/states/deviations/count',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).DEVIATIONS_READ
            },
            servers: {
                path: '/api/v2/resources/states/deviations/count',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVERS_READ
            },
            serviceDeviations: {
                path: '/api/v2/resources/states/deviations/count',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).DEVIATIONS_READ
            },
            services: {
                path: '/api/v2/resources/states/deviations/count',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).SERVICES_READ
            }
        }), this.getDeviationsResolutionWrapper = this.createSocketWrapperGetter({
            resolvedServiceDeviations: {
                path: '/api/v2/resources/states/deviations/services',
                capability: (0, $78670ebe9381a713$export$790a66df9dc00390).DEVIATIONS_READ
            }
        });
    }
}




var $6ddf5ab010591f87$exports = {};

$6ddf5ab010591f87$exports = (parcelRequire("GCbjB"));




/**
 * The rule engine sometimes yields metadata in its outbound objects
 * This is not useful to the user, so they will be stripped
 */ const $97a66398d023fe2e$var$stripMetadata = (input)=>{
    /**
     * In order to not break the `parse` or `stringify` methods
     * first we wrap the possibly undefined value into an object
     * and then strip it once done reserializing
     */ const wrapped = {
        value: input
    };
    const { value: output } = JSON.parse(JSON.stringify(wrapped));
    return output;
};
class $97a66398d023fe2e$export$11c6975ca0631c48 {
    transform(input, transformation) {
        return this.cache.get(()=>new Promise((resolve, reject)=>{
                new (0, (/*@__PURE__*/$parcel$interopDefault($6ddf5ab010591f87$exports)))({
                    configuration: [
                        {
                            transform: {
                                expression: transformation
                            }
                        }
                    ],
                    /** The log is sadly required :') */ log: {
                        warn: (...args)=>this.warningsListener.trigger(args)
                    },
                    /** Log id is also required :') */ id: $97a66398d023fe2e$export$11c6975ca0631c48.name,
                    /** As soon as an error occurs, just reject everything */ onExecutionError: ({ error: [prefix, details], ruleName: ruleName, rule: rule, message: message })=>reject(new (0, $5491cfd462130f7a$export$79c7d16c94855997)({
                            messagePrefix: prefix,
                            messageDetails: details,
                            rule: rule,
                            ruleName: ruleName,
                            payload: message
                        }))
                }).run(input)/**
                         * The rule engine will always yield something,
                         * so just wait until everything is done and any errors fire events before resolving
                         */ .then((output)=>resolve($97a66398d023fe2e$var$stripMetadata(output)));
            }), input, transformation);
    }
    constructor(){
        /** Setup cache for successful results */ this.cache = new (0, $39a8095e56de6b13$export$94affb487e701bf2)();
        /**
     * Only used in tests
     */ this.warningsListener = new (0, $9fc21cc786388d5a$export$3291343375ee8b92)();
    }
}





/** This script was auto generated by 'TypeValidatorCreator' at 'src/infrastructure/scripts/Typescript/TypeValidator.ts' **/ 
const $767593b8e1232b98$var$CompressedPersistedTopicsSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/CompressedPersistedTopics',
    definitions: {
        CompressedPersistedTopics: {
            type: 'object',
            properties: {
                allTopics: {
                    type: 'array',
                    items: {
                        type: 'string'
                    }
                },
                custom: {
                    type: 'array',
                    items: {
                        type: 'number'
                    }
                },
                selected: {
                    type: 'array',
                    items: {
                        type: 'number'
                    }
                }
            },
            required: [
                'allTopics',
                'custom',
                'selected'
            ],
            additionalProperties: false
        }
    }
};
const $767593b8e1232b98$export$5bfb7be2f4295bce = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($767593b8e1232b98$var$CompressedPersistedTopicsSchema, 'isCompressedPersistedTopics');
const $767593b8e1232b98$var$AllSerializedCustomTablesSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/AllSerializedCustomTables',
    definitions: {
        AllSerializedCustomTables: {
            $ref: '#/definitions/ReadonlyRecord%3Cstring%2Calias-2057045733-350-650-2057045733-0-3093%3E'
        },
        'ReadonlyRecord<string,alias-2057045733-350-650-2057045733-0-3093>': {
            type: 'object',
            additionalProperties: {
                type: 'array',
                minItems: 4,
                items: [
                    {
                        type: 'number',
                        title: 'page'
                    },
                    {
                        type: 'number',
                        title: 'pageSize'
                    },
                    {
                        anyOf: [
                            {
                                type: 'array',
                                minItems: 2,
                                items: [
                                    {
                                        type: 'string'
                                    },
                                    {
                                        type: 'number'
                                    }
                                ],
                                maxItems: 2
                            },
                            {
                                type: 'number',
                                const: 0
                            }
                        ],
                        title: 'sort'
                    },
                    {
                        type: 'string',
                        title: 'search'
                    }
                ],
                maxItems: 4
            }
        }
    }
};
const $767593b8e1232b98$export$9f2aef3f03726bd7 = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($767593b8e1232b98$var$AllSerializedCustomTablesSchema, 'isAllSerializedCustomTables');
const $767593b8e1232b98$var$AllSerializedColumnViewsSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/AllSerializedColumnViews',
    definitions: {
        AllSerializedColumnViews: {
            $ref: '#/definitions/ReadonlyRecord%3Cstring%2Calias-1298395520-810-995-1298395520-0-3316143846508%3E'
        },
        'ReadonlyRecord<string,alias-1298395520-810-995-1298395520-0-3316143846508>': {
            type: 'object',
            additionalProperties: {
                anyOf: [
                    {
                        type: 'array',
                        minItems: 3,
                        items: [
                            {
                                type: 'array',
                                items: {
                                    type: 'string'
                                },
                                title: 'order'
                            },
                            {
                                type: 'array',
                                items: {
                                    type: 'string'
                                },
                                title: 'hidden'
                            },
                            {
                                type: 'array',
                                items: {
                                    type: 'string'
                                },
                                title: 'pinned'
                            }
                        ],
                        maxItems: 3
                    },
                    {
                        type: 'array',
                        minItems: 4,
                        items: [
                            {
                                type: 'array',
                                items: {
                                    type: 'string'
                                },
                                title: 'order'
                            },
                            {
                                type: 'array',
                                items: {
                                    type: 'string'
                                },
                                title: 'hidden'
                            },
                            {
                                type: 'array',
                                items: {
                                    type: 'string'
                                },
                                title: 'pinned'
                            },
                            {
                                type: 'object',
                                additionalProperties: {
                                    type: 'number'
                                },
                                title: 'widths'
                            }
                        ],
                        maxItems: 4
                    }
                ],
                description: 'The widths are left out when no column was sized, as in views stored before columns could be sized'
            }
        }
    }
};
const $767593b8e1232b98$export$41ee8bcf7375f29f = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($767593b8e1232b98$var$AllSerializedColumnViewsSchema, 'isAllSerializedColumnViews');
const $767593b8e1232b98$var$SerializedRecordPanelWidthSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/SerializedRecordPanelWidth',
    definitions: {
        SerializedRecordPanelWidth: {
            type: [
                'number',
                'null'
            ],
            description: 'In px, `null` for the default width'
        }
    }
};
const $767593b8e1232b98$export$af1af8e2e4a6f43c = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($767593b8e1232b98$var$SerializedRecordPanelWidthSchema, 'isSerializedRecordPanelWidth');
const $767593b8e1232b98$var$SerializedAuthenticationInformationSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/SerializedAuthenticationInformation',
    definitions: {
        SerializedAuthenticationInformation: {
            type: 'array',
            minItems: 4,
            items: [
                {
                    type: 'string',
                    description: 'The auth token'
                },
                {
                    type: 'string',
                    description: 'The source of the token'
                },
                {
                    type: 'number'
                },
                {
                    type: 'array',
                    items: {
                        $ref: '#/definitions/Capability'
                    },
                    description: 'The capabilities the user has on the application'
                }
            ],
            maxItems: 4
        },
        Capability: {
            type: 'string',
            enum: [
                'AGENTS_MANAGE',
                'AGENTS_READ',
                'CONNECTION_READ',
                'CONNECTIONS_MANAGE',
                'CONNECTIONS_READ',
                'CORE_CONTAINER_READ',
                'CORE_CONTAINERS_MANAGE',
                'CORE_CONTAINERS_READ',
                'SERVICE_CONTAINER_READ',
                'SERVICE_CONTAINERS_MANAGE',
                'SERVICE_CONTAINERS_READ',
                'ENDPOINT_READ',
                'ENDPOINTS_MANAGE',
                'ENDPOINTS_READ',
                'MAPPING_READ',
                'MAPPINGS_MANAGE',
                'MAPPINGS_READ',
                'NODES_READ',
                'SERVER_READ',
                'SERVERS_MANAGE',
                'SERVERS_READ',
                'SERVICE_READ',
                'SERVICE_COMMISSIONING_FILE_READ',
                'SERVICES_MANAGE',
                'SERVICES_PARAMETERS_READ',
                'SERVICES_CREATE_OR_UPDATE',
                'SERVICES_READ',
                'SERVICE_SUBSCRIPTION_METADATA',
                'DEVIATIONS_READ',
                'VOLUME_READ',
                'VOLUMES_MANAGE',
                'VOLUMES_READ',
                'MANAGE_USERS',
                'MANAGE_ROLES',
                'MANAGE_PERMISSIONS',
                'CLIENT_REGISTRY_MANAGE',
                'CERTIFICATES_MANAGE',
                'USER_MANAGEMENT_CONFIGURATION',
                'TOPIC_CHUNKS_READ',
                'RULE_ENGINE_RESOURCES',
                'TOPICS_SUBSCRIPTION',
                'WORKBENCH',
                'LOGS_READ',
                'MINIMUM',
                'USE_MFA',
                'SYSTEM_LICENSE_MANAGE',
                'SYSTEM_METRICS_MANAGE',
                'SYSTEM_METRICS_READ',
                'MANAGE_OWN_PASSWORD',
                'RETRIEVE_USERNAME_POLICY',
                'RETRIEVE_PASSWORD_POLICY'
            ]
        }
    }
};
const $767593b8e1232b98$export$41ecd63cae8e572c = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($767593b8e1232b98$var$SerializedAuthenticationInformationSchema, 'isSerializedAuthenticationInformation');
const $767593b8e1232b98$var$UnknownWebStorageSerializedWrappedValueSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/UnknownWebStorageSerializedWrappedValue',
    definitions: {
        UnknownWebStorageSerializedWrappedValue: {
            type: 'array',
            minItems: 2,
            items: [
                {
                    type: 'string',
                    title: 'version'
                },
                {
                    title: 'containedValue'
                }
            ],
            maxItems: 2
        }
    }
};
const $767593b8e1232b98$export$e6f69a5143a20552 = (0, $1ec5a5c3b3288d0c$export$9a4b8a3ca30b6002)($767593b8e1232b98$var$UnknownWebStorageSerializedWrappedValueSchema, 'isUnknownWebStorageSerializedWrappedValue');


class $d6bb771cea33b351$export$155059cab93ae9d8 {
    constructor(storage, version){
        this.storage = storage;
        this.version = version;
        this.ignoreVersionMismatch = false;
    }
    wrapValue(value) {
        return [
            this.version,
            this.toSerializable(value)
        ];
    }
    doesVersionMatch([version]) {
        return this.ignoreVersionMismatch || version === this.version;
    }
    getValue() {
        return this.storage.getItem(this.key);
    }
    setValue(value) {
        this.storage.setItem(this.key, value);
    }
    remove() {
        this.storage.removeItem(this.key);
    }
    persistSerialize(value) {
        const stringfied = JSON.stringify(this.wrapValue(value));
        const content = (0, $eaf49e34dc778a74$export$373f4c3083978ffd)(stringfied);
        this.setValue(content);
    }
    retrieveDeserialize() {
        let value = this.fallbackValue;
        const raw = this.getValue();
        if (raw === null) return value;
        try {
            const content = (0, $eaf49e34dc778a74$export$83edfd8fcc66ec17)(raw);
            const wrappedJson = JSON.parse(content);
            if ((0, $767593b8e1232b98$export$e6f69a5143a20552)(wrappedJson) && this.doesVersionMatch(wrappedJson) && this.isValidSerializable(wrappedJson[1])) value = this.fromSerializable(wrappedJson[1]);
        } catch  {}
        return value;
    }
}



/**
 * This localStorage field is shared across the application
 * Do **not** change its value
 */ const $f3a6dafb36d8bcd4$var$SHARED_TOKEN_FIELD = 'token';
class $f3a6dafb36d8bcd4$export$4f5c407b79fcdfc7 extends (0, $d6bb771cea33b351$export$155059cab93ae9d8) {
    constructor(...[storage, version]){
        super(storage, version), this.fallbackValue = null, this.key = 'authKey';
        this.rawStorage = storage;
    }
    toSerializable({ token: token, username: username, expiresAt: expiresAt, capabilities: capabilities }) {
        return [
            token,
            username,
            expiresAt.getTime(),
            capabilities
        ];
    }
    isValidSerializable(unknownValue) {
        return (0, $767593b8e1232b98$export$41ecd63cae8e572c)(unknownValue);
    }
    fromSerializable([token, username, expiresAt, capabilities]) {
        return {
            token: token,
            username: username,
            expiresAt: new Date(expiresAt),
            capabilities: capabilities,
            obsolete: null,
            expiresSoon: false
        };
    }
    retrieve() {
        return this.retrieveDeserialize();
    }
    flush() {
        this.remove();
        this.rawStorage.removeItem($f3a6dafb36d8bcd4$var$SHARED_TOKEN_FIELD);
    }
    persist(info) {
        this.persistSerialize(info);
        this.rawStorage.setItem($f3a6dafb36d8bcd4$var$SHARED_TOKEN_FIELD, info.token);
    }
}




class $bd296ea1dbcc6b4b$export$92dc9c38b543dc44 extends (0, $d6bb771cea33b351$export$155059cab93ae9d8) {
    toSerializable({ custom: custom, selected: selected }) {
        const allTopics = Array.from(new Set([
            ...custom,
            ...selected
        ]));
        const compressed = {
            allTopics: allTopics,
            custom: custom.map((t)=>allTopics.indexOf(t)),
            selected: selected.map((t)=>allTopics.indexOf(t))
        };
        return compressed;
    }
    isValidSerializable(unknownValue) {
        return (0, $767593b8e1232b98$export$5bfb7be2f4295bce)(unknownValue) && ![
            unknownValue.custom,
            unknownValue.selected
        ].some((arr)=>arr.some((i)=>unknownValue.allTopics[i] === undefined));
    }
    fromSerializable(compressed) {
        const { allTopics: allTopics, custom: custom, selected: selected } = compressed;
        return {
            custom: custom.map((c)=>allTopics[c]),
            selected: selected.map((s)=>allTopics[s])
        };
    }
    retrieveTopics() {
        return this.retrieveDeserialize();
    }
    persistTopics(topics) {
        this.persistSerialize(topics);
    }
    constructor(...args){
        super(...args), this.fallbackValue = {
            custom: [],
            selected: []
        }, this.key = 'explorerTopics', this.ignoreVersionMismatch = true;
    }
}





class $599797cb3b26e804$export$2e881f835ceabb53 extends (0, $d6bb771cea33b351$export$155059cab93ae9d8) {
    toSerializable(allTables) {
        return (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(allTables).reduce((r, [id, { page: page, pageSize: pageSize, sort: sort, search: search }])=>({
                ...r,
                [id]: [
                    page !== undefined ? page : 0,
                    pageSize !== undefined ? pageSize : 0,
                    sort ? [
                        sort.column,
                        Number(sort.asc)
                    ] : 0,
                    search || ''
                ]
            }), {});
    }
    isValidSerializable(unknownValue) {
        return (0, $767593b8e1232b98$export$9f2aef3f03726bd7)(unknownValue);
    }
    fromSerializable(serialized) {
        return (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(serialized).reduce((r, [id, unknownValue])=>{
            const [page, pageSize, sort, search] = unknownValue;
            const table = {};
            if (page > 0) table.page = page;
            if (pageSize > 0) table.pageSize = pageSize;
            if ((0, $36fb5ff0bd6498d5$export$226b3eccf92c9ed9)(sort) && sort.length === 2 && typeof sort[0] === 'string' && typeof sort[1] === 'number') table.sort = {
                column: sort[0],
                asc: Boolean(sort[1])
            };
            if (search) table.search = search;
            return {
                ...r,
                [id]: table
            };
        }, {});
    }
    retrieveTable(id) {
        return this.retrieveDeserialize()[id] ?? {};
    }
    persistTable(id, table) {
        const deserialized = this.retrieveDeserialize();
        this.persistSerialize({
            ...deserialized,
            [id]: table
        });
    }
    flush() {
        this.remove();
    }
    constructor(...args){
        super(...args), this.fallbackValue = {}, this.key = 'cwTables';
    }
}






class $5055175439c77b1c$export$fb74cd16b5dd677d extends (0, $d6bb771cea33b351$export$155059cab93ae9d8) {
    toSerializable(views) {
        return (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(views).reduce((r, [id, { order: order, hidden: hidden, pinned: pinned, widths: widths }])=>{
            /** JSON writes NaN and Infinity as null, which the validator rejects, and that would lose every table's view on the next read */ const finiteWidths = Object.fromEntries(Object.entries(widths).filter(([, width])=>Number.isFinite(width)));
            const serialized = Object.keys(finiteWidths).length === 0 ? [
                [
                    ...order
                ],
                [
                    ...hidden
                ],
                [
                    ...pinned
                ]
            ] : [
                [
                    ...order
                ],
                [
                    ...hidden
                ],
                [
                    ...pinned
                ],
                finiteWidths
            ];
            return {
                ...r,
                [id]: serialized
            };
        }, {});
    }
    isValidSerializable(unknownValue) {
        return (0, $767593b8e1232b98$export$41ee8bcf7375f29f)(unknownValue);
    }
    fromSerializable(serialized) {
        return (0, $e407acf04d9c2f7e$export$6a29ade99f81ec8a)(serialized).reduce((r, [id, view])=>{
            const [order, hidden, pinned] = view;
            return {
                ...r,
                [id]: {
                    order: order,
                    hidden: hidden,
                    pinned: pinned,
                    widths: view.length === 4 ? view[3] : {}
                }
            };
        }, {});
    }
    retrieve(id) {
        return this.retrieveDeserialize()[id] ?? (0, $2ac73d5fe610e8da$export$638aea850a86a555);
    }
    persist(id, view) {
        this.persistSerialize({
            ...this.retrieveDeserialize(),
            [id]: view
        });
    }
    drop(id) {
        const { [id]: _removed, ...views } = this.retrieveDeserialize();
        this.persistSerialize(views);
    }
    flush() {
        this.remove();
    }
    constructor(...args){
        super(...args), this.fallbackValue = {}, this.key = 'cwTableColumns', /** A view that outlived a column is still valid, as names that aren't columns any more are ignored */ this.ignoreVersionMismatch = true;
    }
}




class $c24caaae4a9703fb$export$e646456eb2ef4e3e extends (0, $d6bb771cea33b351$export$155059cab93ae9d8) {
    toSerializable(width) {
        return width;
    }
    isValidSerializable(unknownValue) {
        return (0, $767593b8e1232b98$export$af1af8e2e4a6f43c)(unknownValue);
    }
    fromSerializable(width) {
        return width;
    }
    retrieve() {
        return this.retrieveDeserialize();
    }
    /** `null` and widths JSON can't write (NaN and Infinity) drop the saved width */ persist(width) {
        if (width !== null && Number.isFinite(width)) this.persistSerialize(Math.round(width));
        else this.remove();
    }
    constructor(...args){
        super(...args), this.fallbackValue = null, this.key = 'cwRecordPanelWidth', /** A width is a width in any version */ this.ignoreVersionMismatch = true;
    }
}




class $2cb67e5225c64ded$var$BaseMessenger {
    constructor(worker){
        this.worker = worker;
    }
    addEventListener(handler) {
        const listener = (e)=>handler(e.data);
        this.worker.addEventListener('message', listener);
        return ()=>this.worker.removeEventListener('message', listener);
    }
    send(message) {
        this.worker.postMessage(message);
    }
}
class $2cb67e5225c64ded$export$76a693f49e8fd66a extends $2cb67e5225c64ded$var$BaseMessenger {
    listen(handler) {
        this.addEventListener(handler);
    }
}
class $2cb67e5225c64ded$export$16f3a0ac69cb0d61 extends $2cb67e5225c64ded$var$BaseMessenger {
    listen(handler) {
        return this.addEventListener(handler);
    }
    terminate() {
        this.worker.terminate();
    }
}




/** Yields the MQTT worker to be used by the MQTT services */ var $d755bb40a61b89fd$exports = {};
var $420821d28b29884e$exports = {};
"use strict";
$420821d28b29884e$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $d755bb40a61b89fd$var$url = new URL($parcel$resolve("lLlqL"));
$d755bb40a61b89fd$exports = $420821d28b29884e$exports($d755bb40a61b89fd$var$url.toString(), $d755bb40a61b89fd$var$url.origin, true);


const $b285423858a77e01$export$b3c5c321d083fb92 = ()=>{
    /**
     * The way parcel works when setting up workers is to
     * identify a valid URL to a file, and a worker type
     *
     * All of them need to be in the same place in order
     * for this worker to be properly created
     */ // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    return new Worker($d755bb40a61b89fd$exports);
};



/**
 * This class is here to enable the PermissionSplitter to do its job
 * But it also collects the many technologies used in the Admin UI
 * to be injected into the application's usecases
 */ class $e135757ccd029d0b$var$InjectedServices {
    constructor(applicationState, logger, intl, config, httpResponseListener){
        this.applicationState = applicationState;
        this.logger = logger;
        const { displayVersion: displayVersion, backendHost: backendHost, workbenchPath: workbenchPath, services: services, userManagement: userManagement, rst: rst, mqtt: mqtt, enableStorybook: enableStorybook } = config;
        /**
         * Either use the custom backend host, or fall back to the current url
         */ const host = backendHost ?? location.host;
        const httpsBackendURL = new URL(`https://${host}`);
        const wssBackendURL = new URL(`wss://${host}`);
        const createStateSelector = (selector)=>(...args)=>selector(this.applicationState.getState(), ...args);
        const selectCapabilities = createStateSelector((0, $1c05f13022cf1480$export$13066c71c1ef331a));
        const getToken = createStateSelector((0, $1c05f13022cf1480$export$f145af4743957df7));
        const tokenOrMfaTokenSelector = createStateSelector((s)=>(0, $37c2a8e29603f683$export$24620db712c9d7b2)(s) ?? (0, $1c05f13022cf1480$export$f145af4743957df7)(s));
        const baseMqttAuthenticationSelector = createStateSelector((state, path)=>{
            const username = (0, $1c05f13022cf1480$export$f45ac34dd9e56631)(state);
            const password = (0, $1c05f13022cf1480$export$f145af4743957df7)(state);
            (0, $14eddac5f20c576c$export$a7a9523472993e97)(password !== null && username !== null, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).AUTHENTICATION, 'Authentication is missing'));
            return {
                url: new URL(path, wssBackendURL),
                username: username,
                password: password
            };
        });
        this.translationService = new (0, $3595aa224dad6f35$export$50f8b6f81dec1abd)(intl);
        const ruleEngineServiceTransform = new (0, $97a66398d023fe2e$export$11c6975ca0631c48)();
        /**
         * Web services
         */ this.browserService = new (0, $897ee296cd9b4196$export$95af61d43eab0f10)(logger, httpsBackendURL.origin, new Set([
            httpsBackendURL.host,
            location.host
        ]), new Set([
            services.externalUrlBasePath,
            workbenchPath,
            ...(0, $42451c28db270589$export$a343d875f0ac2ee6)['resource-status-tracking']
        ]));
        this.fileService = new (0, $2b079fbc1cb22ff5$export$7f7c7a3367841dd1)();
        this.authenticationPersistenceService = new (0, $f3a6dafb36d8bcd4$export$4f5c407b79fcdfc7)(window.localStorage, displayVersion);
        this.topicsPersistenceService = new (0, $bd296ea1dbcc6b4b$export$92dc9c38b543dc44)(window.localStorage, displayVersion);
        this.tablePersistenceService = new (0, $599797cb3b26e804$export$2e881f835ceabb53)(window.localStorage, displayVersion);
        this.columnViewPersistenceService = new (0, $5055175439c77b1c$export$fb74cd16b5dd677d)(window.localStorage, displayVersion);
        this.recordPanelWidthPersistenceService = new (0, $c24caaae4a9703fb$export$e646456eb2ef4e3e)(window.localStorage, displayVersion);
        /**
         * Due to how changes are expected on the domain and business layers, propagating resource changes SHOULD ONLY
         * be done under the hood and without extra work from the rendering layer
         *
         * This listener hooks "the http resource service" to "the http subscription service" and
         * ensures that whenever a service changes, there will be an immediate change on the UI
         */ const resourceChangeListeners = new (0, $9fc21cc786388d5a$export$3291343375ee8b92)();
        /**
         * Http services
         */ const httpOptions = {
            baseURL: httpsBackendURL.toString(),
            getToken: getToken,
            responseHandler: httpResponseListener
        };
        this.userService = new (0, $5ffa9b3caa9d9b5d$export$9b345d37b35caaf5)(httpOptions, {
            usersConfig: {
                protectedRoles: new Set(userManagement.protectedRoles),
                protectedUsers: new Set(userManagement.protectedUsers)
            },
            pagination: {
                pageSize: userManagement.pageSize,
                searchSize: userManagement.searchSize
            },
            cacheInterval: userManagement.indexesCache
        }, this.translationService);
        this.clientRegistryService = new (0, $05095b563b5e5262$export$3456ba167f053528)(httpOptions, this.translationService);
        this.authenticationService = new (0, $864836966eac5047$export$57eaa77631f4ce6e)(httpOptions);
        this.configurationService = new (0, $75bfa09ac5354192$export$9183fa87787f525f)({
            httpsURL: httpsBackendURL,
            wssURL: wssBackendURL,
            salesEmail: config.contact.salesEmail,
            supportEmail: config.contact.supportEmail,
            mqttPaths: [
                mqtt.path
            ],
            workbenchPath: workbenchPath,
            version: displayVersion,
            pageSizes: [
                config.pageSizes.short,
                config.pageSizes.default,
                config.pageSizes.large,
                config.pageSizes.max
            ],
            clientRegistryRefreshRate: userManagement.clientRegistryRefreshRate,
            certificateFileExtension: userManagement.certificateFileExtension,
            infoPageRefreshRate: config.infoPageRefreshRate,
            licenseFileExtension: config.licenseFileExtension,
            commissioningFile: {
                uploadExtensions: services.commissioningFile.extensions,
                downloadMimeType: services.commissioningFile.downloadMimeType
            },
            interactionThrottle: config.interactionThrottle,
            documentation: new URL(config.documentation),
            searchMinimum: config.searchMinimum,
            logoutWarningPeriod: config.logoutWarningPeriod,
            enableStorybook: enableStorybook
        });
        this.systemService = new (0, $e0d11f8dfe649973$export$c299242ad2e6dfd5)(httpOptions, displayVersion);
        this.certificatesService = new (0, $3965c8d2141fedcb$export$a8f8641209eb2f6)(httpOptions);
        const websocketOptions = {
            origin: wssBackendURL.origin,
            cacheLifespan: rst.cacheLifespan,
            reconnectTimeout: rst.reconnectTimeout,
            pageSize: rst.maxPageSize
        };
        const rstAdapter = (0, $aec3232385138720$export$ef727a9a1ed6cd67)(new (0, $9cbed1cedac192a6$export$6404d3f3f4d7534b)(httpOptions, rst.maxPageSize), new (0, $774df96d885f273e$export$e039aea709dd4ff5)(httpOptions, rst.maxPageSize), new (0, $2a20d6395286d7d0$export$c8a394d91a850e65)(websocketOptions), new (0, $2a20d6395286d7d0$export$898c8c6251bb3334)(websocketOptions));
        this.subscriptionsService = new (0, $bab5d7f1d0ba91e5$export$d07c633948128403)({
            ...httpOptions,
            getCapabilities: selectCapabilities,
            translationService: this.translationService,
            resourceChangeListeners: resourceChangeListeners,
            rstAdapter: rstAdapter,
            updateThrottle: config.resourcesRefreshThrottle,
            pollingInterval: config.resourcesRefreshRate
        });
        this.connectwareResourcesManagementService = new (0, $02fb8a8821e3573f$export$f6ec0e511e9f3aeb)(httpOptions, this.translationService, resourceChangeListeners);
        this.connectwareLogsService = new (0, $660ed0109cd6c8c5$export$105230d55709e392)(httpOptions, this.translationService);
        this.connectwareServicesService = new (0, $bbb341a67553f14f$export$a641772aca945bae)(httpOptions, resourceChangeListeners);
        this.mfaService = new (0, $53b9a477a5bda966$export$93b1926a5eec64ea)({
            ...httpOptions,
            getToken: tokenOrMfaTokenSelector
        }, this.translationService);
        const httpRuleEngineService = new (0, $b8daf9334d524508$export$9be0b709dd3f09be)(httpOptions, this.translationService, {
            searchMinimum: config.searchMinimum,
            maxPageSize: config.pageSizes.max
        });
        const httpTopicsService = new (0, $165c25270f704fd4$export$e9b5b258b34f61ee)(httpOptions, this.translationService);
        /**
         * Mqtt services
         */ const mqttTopicsService = new (0, $e83e10387b18cd27$export$d832ee6c181d9601)(()=>({
                ...baseMqttAuthenticationSelector(mqtt.path),
                worker: new (0, $2cb67e5225c64ded$export$16f3a0ac69cb0d61)((0, $b285423858a77e01$export$b3c5c321d083fb92)())
            }), {
            cycle: mqtt.cycle,
            maxTopicDepth: mqtt.maxTopicDepth,
            timeout: mqtt.timeout,
            translationService: this.translationService
        });
        this.topicsService = (0, $c9e988a9208a6bbc$export$755b96d9572a8e9e)({
            createSubscription: mqttTopicsService,
            createTopic: mqttTopicsService,
            fetchTopicsChunk: httpTopicsService
        });
        this.ruleEngineService = (0, $c9e988a9208a6bbc$export$755b96d9572a8e9e)({
            transform: ruleEngineServiceTransform,
            fetchEndpoints: httpRuleEngineService
        });
    }
}
const $e135757ccd029d0b$export$57e663737dc94926 = (appState, config)=>{
    const state = new (0, $08b3e6ee09ecfd12$export$b20e70bc564b1116)(appState);
    const logger = console;
    const internationalization = (0, $3595aa224dad6f35$export$a208c2a8af89b1d9)(config.translations, logger);
    const missingPermissionsListener = new (0, $9fc21cc786388d5a$export$3291343375ee8b92)((0, $133af03133e6eca3$export$e05d433ecc078c7e));
    return {
        services: new $e135757ccd029d0b$var$InjectedServices(state, logger, internationalization, config, missingPermissionsListener),
        state: state,
        internationalization: internationalization,
        missingPermissionsListener: missingPermissionsListener
    };
};


(0, $f30b7b49cc16b3fd$export$2e2bcd8739ae039).then(({ customizedConfig: customizedConfig, errors: errors })=>{
    const { services: services, state: state, internationalization: internationalization, missingPermissionsListener: missingPermissionsListener } = (0, $e135757ccd029d0b$export$57e663737dc94926)((0, $95a9c43d1c8832e3$export$d4c72bab9d6cc13a), customizedConfig);
    const usecases = (0, $08f633a474e8a160$export$32fa1abc5072a856)(services);
    usecases.debugApplicationUsecase.handleConfigurationErrors(errors);
    /** If there are authentication issues, handle the problem */ missingPermissionsListener.on(()=>void usecases.missingPermissionsUsecase.updateObsolescence());
    const root = document.getElementById('root');
    (0, $14eddac5f20c576c$export$a7a9523472993e97)(root, new (0, $c3e1b746ad236797$export$8d524fb6540252df)((0, $c3e1b746ad236797$export$13cd8ea82c82bf53).UNEXPECTED, 'Failed to mount React app - root element was not found.'));
    (0, (/*@__PURE__*/$parcel$interopDefault($3966d42803f0ec68$exports))).createRoot(root).render(/*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $f2541c61ee606526$export$6cd5d5c1dae69a36), {
        usecases: usecases,
        manager: state,
        internationalization: internationalization,
        theme: (0, $1a6512ae4318d72b$export$f951e619290d8fb2),
        children: /*#__PURE__*/ (0, $2e41620b030ed79e$exports.jsx)((0, $5a1cbe913fab6236$export$86fbec116b87613f), {})
    }));
});


//# sourceMappingURL=parcel.4106a3d9.js.map
